export const word_to_lemme = {
    "a": [
        "avoir",
        "a"
    ],
    "aa": [
        "aa"
    ],
    "abaca": [
        "abaca"
    ],
    "abaissa": [
        "abaisser"
    ],
    "abaissai": [
        "abaisser"
    ],
    "abaissaient": [
        "abaisser"
    ],
    "abaissait": [
        "abaisser"
    ],
    "abaissant": [
        "abaissant",
        "abaisser"
    ],
    "abaissante": [
        "abaissant"
    ],
    "abaisse": [
        "abaisser",
        "abaisse"
    ],
    "abaissement": [
        "abaissement"
    ],
    "abaissent": [
        "abaisser"
    ],
    "abaisser": [
        "abaisser"
    ],
    "abaissera": [
        "abaisser"
    ],
    "abaisserai": [
        "abaisser"
    ],
    "abaisseraient": [
        "abaisser"
    ],
    "abaisserais": [
        "abaisser"
    ],
    "abaisserait": [
        "abaisser"
    ],
    "abaisses": [
        "abaisser",
        "abaisse"
    ],
    "abaissez": [
        "abaisser"
    ],
    "abaissons": [
        "abaisser"
    ],
    "abaisserent": [
        "abaisser"
    ],
    "abaissee": [
        "abaisser",
        "abaisse"
    ],
    "abaissees": [
        "abaisser",
        "abaisse"
    ],
    "abalone": [
        "abalone"
    ],
    "abalones": [
        "abalone"
    ],
    "abandon": [
        "abandon"
    ],
    "abandonna": [
        "abandonner"
    ],
    "abandonnai": [
        "abandonner"
    ],
    "abandonnaient": [
        "abandonner"
    ],
    "abandonnais": [
        "abandonner"
    ],
    "abandonnait": [
        "abandonner"
    ],
    "abandonnant": [
        "abandonner"
    ],
    "abandonnas": [
        "abandonner"
    ],
    "abandonne": [
        "abandonne",
        "abandonner"
    ],
    "abandonnent": [
        "abandonner"
    ],
    "abandonner": [
        "abandonner"
    ],
    "abandonnera": [
        "abandonner"
    ],
    "abandonnerai": [
        "abandonner"
    ],
    "abandonneraient": [
        "abandonner"
    ],
    "abandonnerais": [
        "abandonner"
    ],
    "abandonnerait": [
        "abandonner"
    ],
    "abandonneras": [
        "abandonner"
    ],
    "abandonnerez": [
        "abandonner"
    ],
    "abandonneriez": [
        "abandonner"
    ],
    "abandonnerions": [
        "abandonner"
    ],
    "abandonnerons": [
        "abandonner"
    ],
    "abandonneront": [
        "abandonner"
    ],
    "abandonnes": [
        "abandonne",
        "abandonner"
    ],
    "abandonneurs": [
        "abandonneur"
    ],
    "abandonnez": [
        "abandonner"
    ],
    "abandonniez": [
        "abandonner"
    ],
    "abandonnions": [
        "abandonner"
    ],
    "abandonnique": [
        "abandonnique"
    ],
    "abandonnons": [
        "abandonner"
    ],
    "abandonnames": [
        "abandonner"
    ],
    "abandonnat": [
        "abandonner"
    ],
    "abandonnerent": [
        "abandonner"
    ],
    "abandonnee": [
        "abandonne",
        "abandonner"
    ],
    "abandonnees": [
        "abandonne",
        "abandonner"
    ],
    "abandons": [
        "abandon"
    ],
    "abaque": [
        "abaque"
    ],
    "abasourdi": [
        "abasourdir",
        "abasourdi"
    ],
    "abasourdie": [
        "abasourdir",
        "abasourdi"
    ],
    "abasourdir": [
        "abasourdir"
    ],
    "abasourdis": [
        "abasourdir",
        "abasourdi"
    ],
    "abasourdissant": [
        "abasourdissant"
    ],
    "abasourdissants": [
        "abasourdissant"
    ],
    "abat": [
        "abat",
        "abattre"
    ],
    "abatage": [
        "abatage"
    ],
    "abatis": [
        "abatis"
    ],
    "abats": [
        "abat",
        "abattre"
    ],
    "abattage": [
        "abattage"
    ],
    "abattages": [
        "abattage"
    ],
    "abattaient": [
        "abattre"
    ],
    "abattais": [
        "abattre"
    ],
    "abattait": [
        "abattre"
    ],
    "abattant": [
        "abattre",
        "abattant"
    ],
    "abattants": [
        "abattant"
    ],
    "abatte": [
        "abattre"
    ],
    "abattement": [
        "abattement"
    ],
    "abattements": [
        "abattement"
    ],
    "abattent": [
        "abattre"
    ],
    "abattes": [
        "abattre"
    ],
    "abatteur": [
        "abatteur"
    ],
    "abatteurs": [
        "abatteur"
    ],
    "abattez": [
        "abattre"
    ],
    "abattiez": [
        "abattre"
    ],
    "abattions": [
        "abattre"
    ],
    "abattirent": [
        "abattre"
    ],
    "abattis": [
        "abattis",
        "abattre"
    ],
    "abattit": [
        "abattre"
    ],
    "abattoir": [
        "abattoir"
    ],
    "abattoirs": [
        "abattoir"
    ],
    "abattons": [
        "abattre"
    ],
    "abattra": [
        "abattre"
    ],
    "abattrai": [
        "abattre"
    ],
    "abattraient": [
        "abattre"
    ],
    "abattrais": [
        "abattre"
    ],
    "abattrait": [
        "abattre"
    ],
    "abattras": [
        "abattre"
    ],
    "abattre": [
        "abattre"
    ],
    "abattrez": [
        "abattre"
    ],
    "abattriez": [
        "abattre"
    ],
    "abattrons": [
        "abattre"
    ],
    "abattront": [
        "abattre"
    ],
    "abattu": [
        "abattre",
        "abattu"
    ],
    "abattue": [
        "abattre",
        "abattu"
    ],
    "abattues": [
        "abattre",
        "abattu"
    ],
    "abattures": [
        "abatture"
    ],
    "abattus": [
        "abattre",
        "abattu"
    ],
    "abbatial": [
        "abbatial"
    ],
    "abbatiale": [
        "abbatiale",
        "abbatial"
    ],
    "abbatiales": [
        "abbatial"
    ],
    "abbaye": [
        "abbaye"
    ],
    "abbayes": [
        "abbaye"
    ],
    "abbesse": [
        "abbe"
    ],
    "abbesses": [
        "abbe"
    ],
    "abbe": [
        "abbe"
    ],
    "abbes": [
        "abbe"
    ],
    "abc": [
        "abc"
    ],
    "abces": [
        "abces"
    ],
    "abdication": [
        "abdication"
    ],
    "abdications": [
        "abdication"
    ],
    "abdiqua": [
        "abdiquer"
    ],
    "abdiquai": [
        "abdiquer"
    ],
    "abdiquaient": [
        "abdiquer"
    ],
    "abdiquais": [
        "abdiquer"
    ],
    "abdiquait": [
        "abdiquer"
    ],
    "abdiquant": [
        "abdiquer"
    ],
    "abdique": [
        "abdiquer"
    ],
    "abdiquer": [
        "abdiquer"
    ],
    "abdiquera": [
        "abdiquer"
    ],
    "abdiquerais": [
        "abdiquer"
    ],
    "abdiquerait": [
        "abdiquer"
    ],
    "abdiquez": [
        "abdiquer"
    ],
    "abdiquee": [
        "abdiquer"
    ],
    "abdomen": [
        "abdomen"
    ],
    "abdominal": [
        "abdominal"
    ],
    "abdominale": [
        "abdominal"
    ],
    "abdominales": [
        "abdominal"
    ],
    "abdominaux": [
        "abdominal"
    ],
    "abdos": [
        "abdos"
    ],
    "abducteur": [
        "abducteur"
    ],
    "abduction": [
        "abduction"
    ],
    "abeille": [
        "abeille"
    ],
    "abeilles": [
        "abeille"
    ],
    "aber": [
        "aber"
    ],
    "aberrant": [
        "aberrer",
        "aberrant"
    ],
    "aberrante": [
        "aberrant"
    ],
    "aberrantes": [
        "aberrant"
    ],
    "aberrants": [
        "aberrant"
    ],
    "aberration": [
        "aberration"
    ],
    "aberrations": [
        "aberration"
    ],
    "abhorrais": [
        "abhorrer"
    ],
    "abhorrait": [
        "abhorrer"
    ],
    "abhorrant": [
        "abhorrer"
    ],
    "abhorre": [
        "abhorre",
        "abhorrer"
    ],
    "abhorrer": [
        "abhorrer"
    ],
    "abhorrez": [
        "abhorrer"
    ],
    "abhorree": [
        "abhorre",
        "abhorrer"
    ],
    "abhorres": [
        "abhorrer"
    ],
    "abject": [
        "abject"
    ],
    "abjecte": [
        "abject"
    ],
    "abjectement": [
        "abjectement"
    ],
    "abjectes": [
        "abject"
    ],
    "abjection": [
        "abjection"
    ],
    "abjections": [
        "abjection"
    ],
    "abjects": [
        "abject"
    ],
    "abjurant": [
        "abjurer"
    ],
    "abjuration": [
        "abjuration"
    ],
    "abjurations": [
        "abjuration"
    ],
    "abjure": [
        "abjurer"
    ],
    "abjurer": [
        "abjurer"
    ],
    "abjurez": [
        "abjurer"
    ],
    "abjurons": [
        "abjurer"
    ],
    "abkhaze": [
        "abkhaze"
    ],
    "ablatif": [
        "ablatif"
    ],
    "ablation": [
        "ablation"
    ],
    "ablations": [
        "ablation"
    ],
    "able": [
        "able"
    ],
    "ablette": [
        "ablette"
    ],
    "ablettes": [
        "ablette"
    ],
    "ablution": [
        "ablution"
    ],
    "ablutions": [
        "ablution"
    ],
    "abnegation": [
        "abnegation"
    ],
    "aboi": [
        "aboi"
    ],
    "aboie": [
        "aboyer"
    ],
    "aboiement": [
        "aboiement"
    ],
    "aboiements": [
        "aboiement"
    ],
    "aboient": [
        "aboyer"
    ],
    "aboiera": [
        "aboyer"
    ],
    "aboierait": [
        "aboyer"
    ],
    "aboieront": [
        "aboyer"
    ],
    "aboies": [
        "aboyer"
    ],
    "abois": [
        "aboi"
    ],
    "aboli": [
        "aboli",
        "abolir"
    ],
    "abolie": [
        "aboli",
        "abolir"
    ],
    "abolies": [
        "aboli",
        "abolir"
    ],
    "abolir": [
        "abolir"
    ],
    "abolira": [
        "abolir"
    ],
    "abolirait": [
        "abolir"
    ],
    "aboliras": [
        "abolir"
    ],
    "abolis": [
        "aboli",
        "abolir"
    ],
    "abolissaient": [
        "abolir"
    ],
    "abolissais": [
        "abolir"
    ],
    "abolissait": [
        "abolir"
    ],
    "abolissant": [
        "abolir"
    ],
    "abolissent": [
        "abolir"
    ],
    "abolissions": [
        "abolir"
    ],
    "abolissons": [
        "abolir"
    ],
    "abolit": [
        "abolir"
    ],
    "abolition": [
        "abolition"
    ],
    "abolitionniste": [
        "abolitionniste"
    ],
    "abolitionnistes": [
        "abolitionniste"
    ],
    "abominable": [
        "abominable"
    ],
    "abominablement": [
        "abominablement"
    ],
    "abominables": [
        "abominable"
    ],
    "abominaient": [
        "abominer"
    ],
    "abomination": [
        "abomination"
    ],
    "abominations": [
        "abomination"
    ],
    "abomine": [
        "abominer"
    ],
    "abominer": [
        "abominer"
    ],
    "abonda": [
        "abonder"
    ],
    "abondai": [
        "abonder"
    ],
    "abondaient": [
        "abonder"
    ],
    "abondais": [
        "abonder"
    ],
    "abondait": [
        "abonder"
    ],
    "abondamment": [
        "abondamment"
    ],
    "abondance": [
        "abondance"
    ],
    "abondant": [
        "abondant",
        "abonder"
    ],
    "abondante": [
        "abondant"
    ],
    "abondantes": [
        "abondant"
    ],
    "abondants": [
        "abondant"
    ],
    "abondassent": [
        "abonder"
    ],
    "abonde": [
        "abonder"
    ],
    "abondent": [
        "abonder"
    ],
    "abonder": [
        "abonder"
    ],
    "abonnai": [
        "abonner"
    ],
    "abonnant": [
        "abonner"
    ],
    "abonne": [
        "abonne",
        "abonner"
    ],
    "abonnement": [
        "abonnement"
    ],
    "abonnements": [
        "abonnement"
    ],
    "abonner": [
        "abonner"
    ],
    "abonnez": [
        "abonner"
    ],
    "abonnat": [
        "abonner"
    ],
    "abonnee": [
        "abonne",
        "abonner"
    ],
    "abonnees": [
        "abonne",
        "abonner"
    ],
    "abonnes": [
        "abonne",
        "abonner"
    ],
    "abord": [
        "abord"
    ],
    "aborda": [
        "aborder"
    ],
    "abordable": [
        "abordable"
    ],
    "abordables": [
        "abordable"
    ],
    "abordage": [
        "abordage"
    ],
    "abordages": [
        "abordage"
    ],
    "abordai": [
        "aborder"
    ],
    "abordaient": [
        "aborder"
    ],
    "abordais": [
        "aborder"
    ],
    "abordait": [
        "aborder"
    ],
    "abordant": [
        "aborder"
    ],
    "aborde": [
        "aborde",
        "aborder"
    ],
    "abordent": [
        "aborder"
    ],
    "aborder": [
        "aborder"
    ],
    "abordera": [
        "aborder"
    ],
    "aborderai": [
        "aborder"
    ],
    "aborderaient": [
        "aborder"
    ],
    "aborderais": [
        "aborder"
    ],
    "aborderait": [
        "aborder"
    ],
    "aborderiez": [
        "aborder"
    ],
    "aborderions": [
        "aborder"
    ],
    "aborderons": [
        "aborder"
    ],
    "aborderont": [
        "aborder"
    ],
    "abordes": [
        "aborde",
        "aborder"
    ],
    "abordez": [
        "aborder"
    ],
    "abordiez": [
        "aborder"
    ],
    "abordions": [
        "aborder"
    ],
    "abordons": [
        "aborder"
    ],
    "abords": [
        "abord"
    ],
    "abordames": [
        "aborder"
    ],
    "aborderent": [
        "aborder"
    ],
    "abordee": [
        "aborder"
    ],
    "abordees": [
        "aborde",
        "aborder"
    ],
    "aborigene": [
        "aborigene"
    ],
    "aborigenes": [
        "aborigene"
    ],
    "abornement": [
        "abornement"
    ],
    "abortif": [
        "abortif"
    ],
    "abortive": [
        "abortif"
    ],
    "abortives": [
        "abortif"
    ],
    "abouchaient": [
        "aboucher"
    ],
    "abouchais": [
        "aboucher"
    ],
    "abouchait": [
        "aboucher"
    ],
    "abouchant": [
        "aboucher"
    ],
    "abouchements": [
        "abouchement"
    ],
    "aboucher": [
        "aboucher"
    ],
    "abouche": [
        "aboucher"
    ],
    "abouchee": [
        "aboucher"
    ],
    "abouches": [
        "aboucher"
    ],
    "aboule": [
        "abouler"
    ],
    "abouler": [
        "abouler"
    ],
    "aboules": [
        "abouler"
    ],
    "aboulez": [
        "abouler"
    ],
    "aboulie": [
        "aboulie"
    ],
    "aboulique": [
        "aboulique"
    ],
    "abouliques": [
        "aboulique"
    ],
    "abounas": [
        "abouna"
    ],
    "about": [
        "about"
    ],
    "aboutait": [
        "abouter"
    ],
    "abouti": [
        "aboutir",
        "abouti"
    ],
    "aboutie": [
        "aboutir",
        "abouti"
    ],
    "aboutir": [
        "aboutir"
    ],
    "aboutira": [
        "aboutir"
    ],
    "aboutirai": [
        "aboutir"
    ],
    "aboutiraient": [
        "aboutir"
    ],
    "aboutirais": [
        "aboutir"
    ],
    "aboutirait": [
        "aboutir"
    ],
    "aboutiras": [
        "aboutir"
    ],
    "aboutirent": [
        "aboutir"
    ],
    "aboutirons": [
        "aboutir"
    ],
    "aboutiront": [
        "aboutir"
    ],
    "aboutis": [
        "aboutir",
        "abouti"
    ],
    "aboutissaient": [
        "aboutir"
    ],
    "aboutissait": [
        "aboutir"
    ],
    "aboutissant": [
        "aboutir",
        "aboutissant"
    ],
    "aboutissants": [
        "aboutissant"
    ],
    "aboutisse": [
        "aboutir"
    ],
    "aboutissement": [
        "aboutissement"
    ],
    "aboutissent": [
        "aboutir"
    ],
    "aboutissez": [
        "aboutir"
    ],
    "aboutissiez": [
        "aboutir"
    ],
    "aboutissions": [
        "aboutir"
    ],
    "aboutit": [
        "aboutir"
    ],
    "aboutonnai": [
        "aboutonner"
    ],
    "aboutons": [
        "abouter"
    ],
    "aboutimes": [
        "aboutir"
    ],
    "aboya": [
        "aboyer"
    ],
    "aboyaient": [
        "aboyer"
    ],
    "aboyait": [
        "aboyer"
    ],
    "aboyant": [
        "aboyant",
        "aboyer"
    ],
    "aboyante": [
        "aboyant"
    ],
    "aboyer": [
        "aboyer"
    ],
    "aboyeur": [
        "aboyeur"
    ],
    "aboyeurs": [
        "aboyeur"
    ],
    "aboyons": [
        "aboyer"
    ],
    "aboyerent": [
        "aboyer"
    ],
    "aboye": [
        "aboyer"
    ],
    "abracadabra": [
        "abracadabra"
    ],
    "abracadabrant": [
        "abracadabrant"
    ],
    "abracadabrante": [
        "abracadabrant"
    ],
    "abracadabrantes": [
        "abracadabrant"
    ],
    "abracadabrants": [
        "abracadabrant"
    ],
    "abracadabre": [
        "abracadabrer"
    ],
    "abrasif": [
        "abrasif"
    ],
    "abrasifs": [
        "abrasif"
    ],
    "abrasion": [
        "abrasion"
    ],
    "abrasive": [
        "abrasif"
    ],
    "abrase": [
        "abraser"
    ],
    "abraxas": [
        "abraxas"
    ],
    "abreuva": [
        "abreuver"
    ],
    "abreuvage": [
        "abreuvage"
    ],
    "abreuvaient": [
        "abreuver"
    ],
    "abreuvait": [
        "abreuver"
    ],
    "abreuvant": [
        "abreuver"
    ],
    "abreuve": [
        "abreuver",
        "abreuve"
    ],
    "abreuvent": [
        "abreuver"
    ],
    "abreuver": [
        "abreuver"
    ],
    "abreuvera": [
        "abreuver"
    ],
    "abreuveraient": [
        "abreuver"
    ],
    "abreuvez": [
        "abreuver"
    ],
    "abreuvoir": [
        "abreuvoir"
    ],
    "abreuvoirs": [
        "abreuvoir"
    ],
    "abreuvons": [
        "abreuver"
    ],
    "abreuvee": [
        "abreuver"
    ],
    "abreuves": [
        "abreuver",
        "abreuve"
    ],
    "abri": [
        "abri"
    ],
    "abribus": [
        "abribus"
    ],
    "abricot": [
        "abricot"
    ],
    "abricotez": [
        "abricoter"
    ],
    "abricotier": [
        "abricotier"
    ],
    "abricotiers": [
        "abricotier"
    ],
    "abricotine": [
        "abricotine"
    ],
    "abricots": [
        "abricot"
    ],
    "abris": [
        "abri"
    ],
    "abrita": [
        "abriter"
    ],
    "abritai": [
        "abriter"
    ],
    "abritaient": [
        "abriter"
    ],
    "abritais": [
        "abriter"
    ],
    "abritait": [
        "abriter"
    ],
    "abritant": [
        "abritant",
        "abriter"
    ],
    "abrite": [
        "abrite",
        "abriter"
    ],
    "abritent": [
        "abriter"
    ],
    "abriter": [
        "abriter"
    ],
    "abritera": [
        "abriter"
    ],
    "abriterait": [
        "abriter"
    ],
    "abriterons": [
        "abriter"
    ],
    "abriteront": [
        "abriter"
    ],
    "abrites": [
        "abrite",
        "abriter"
    ],
    "abritez": [
        "abriter"
    ],
    "abritiez": [
        "abriter"
    ],
    "abritions": [
        "abriter"
    ],
    "abritons": [
        "abriter"
    ],
    "abritames": [
        "abriter"
    ],
    "abriterent": [
        "abriter"
    ],
    "abritee": [
        "abrite",
        "abriter"
    ],
    "abritees": [
        "abriter"
    ],
    "abrogation": [
        "abrogation"
    ],
    "abrogent": [
        "abroger"
    ],
    "abroger": [
        "abroger"
    ],
    "abroge": [
        "abroge",
        "abroger"
    ],
    "abrogee": [
        "abroger"
    ],
    "abrogees": [
        "abroger"
    ],
    "abroges": [
        "abroger"
    ],
    "abrupt": [
        "abrupt"
    ],
    "abrupte": [
        "abrupt"
    ],
    "abruptement": [
        "abruptement"
    ],
    "abruptes": [
        "abrupt"
    ],
    "abrupts": [
        "abrupt"
    ],
    "abruti": [
        "abruti",
        "abrutir"
    ],
    "abrutie": [
        "abruti",
        "abrutir"
    ],
    "abruties": [
        "abruti",
        "abrutir"
    ],
    "abrutir": [
        "abrutir"
    ],
    "abrutira": [
        "abrutir"
    ],
    "abrutis": [
        "abruti",
        "abrutir"
    ],
    "abrutissaient": [
        "abrutir"
    ],
    "abrutissais": [
        "abrutir"
    ],
    "abrutissait": [
        "abrutir"
    ],
    "abrutissant": [
        "abrutissant",
        "abrutir"
    ],
    "abrutissante": [
        "abrutissant"
    ],
    "abrutissantes": [
        "abrutissant"
    ],
    "abrutissants": [
        "abrutissant"
    ],
    "abrutissement": [
        "abrutissement"
    ],
    "abrutissent": [
        "abrutir"
    ],
    "abrutisseur": [
        "abrutisseur"
    ],
    "abrutissions": [
        "abrutir"
    ],
    "abrutit": [
        "abrutir"
    ],
    "abrege": [
        "abreger",
        "abrege"
    ],
    "abregent": [
        "abreger"
    ],
    "abregea": [
        "abreger"
    ],
    "abregeai": [
        "abreger"
    ],
    "abregeaient": [
        "abreger"
    ],
    "abregeait": [
        "abreger"
    ],
    "abregeant": [
        "abreger"
    ],
    "abregeons": [
        "abreger"
    ],
    "abreger": [
        "abreger"
    ],
    "abregera": [
        "abreger"
    ],
    "abregerai": [
        "abreger"
    ],
    "abregerait": [
        "abreger"
    ],
    "abregez": [
        "abreger"
    ],
    "abregeat": [
        "abreger"
    ],
    "abregee": [
        "abreger",
        "abrege"
    ],
    "abreges": [
        "abrege"
    ],
    "abreviatif": [
        "abreviatif"
    ],
    "abreviation": [
        "abreviation"
    ],
    "abreviations": [
        "abreviation"
    ],
    "abscisse": [
        "abscisse"
    ],
    "abscission": [
        "abscission"
    ],
    "abscons": [
        "abscons"
    ],
    "absconse": [
        "abscons"
    ],
    "absconses": [
        "abscons"
    ],
    "absence": [
        "absence"
    ],
    "absences": [
        "absence"
    ],
    "absent": [
        "absent"
    ],
    "absenta": [
        "absenter"
    ],
    "absentai": [
        "absenter"
    ],
    "absentaient": [
        "absenter"
    ],
    "absentais": [
        "absenter"
    ],
    "absentait": [
        "absenter"
    ],
    "absentant": [
        "absenter"
    ],
    "absente": [
        "absenter",
        "absent"
    ],
    "absenter": [
        "absenter"
    ],
    "absentera": [
        "absenter"
    ],
    "absenterai": [
        "absenter"
    ],
    "absenterait": [
        "absenter"
    ],
    "absentes": [
        "absenter",
        "absent"
    ],
    "absents": [
        "absent"
    ],
    "absenterent": [
        "absenter"
    ],
    "absentee": [
        "absenter"
    ],
    "absenteisme": [
        "absenteisme"
    ],
    "absenteiste": [
        "absenteiste"
    ],
    "abside": [
        "abside"
    ],
    "absides": [
        "abside"
    ],
    "absidiales": [
        "absidial"
    ],
    "absidiole": [
        "absidiole"
    ],
    "absinthant": [
        "absinther"
    ],
    "absinthe": [
        "absinthe"
    ],
    "absolu": [
        "absolu"
    ],
    "absolue": [
        "absolu"
    ],
    "absolues": [
        "absolu"
    ],
    "absolument": [
        "absolument"
    ],
    "absolus": [
        "absolu"
    ],
    "absolution": [
        "absolution"
    ],
    "absolutisme": [
        "absolutisme"
    ],
    "absolvaient": [
        "absoudre"
    ],
    "absolvait": [
        "absoudre"
    ],
    "absolvant": [
        "absolvant"
    ],
    "absolve": [
        "absoudre"
    ],
    "absolvent": [
        "absoudre"
    ],
    "absolves": [
        "absolve",
        "absoudre"
    ],
    "absorba": [
        "absorber"
    ],
    "absorbables": [
        "absorbable"
    ],
    "absorbai": [
        "absorber"
    ],
    "absorbaient": [
        "absorber"
    ],
    "absorbais": [
        "absorber"
    ],
    "absorbait": [
        "absorber"
    ],
    "absorbant": [
        "absorber",
        "absorbant"
    ],
    "absorbante": [
        "absorbant"
    ],
    "absorbantes": [
        "absorbant"
    ],
    "absorbants": [
        "absorbant"
    ],
    "absorbe": [
        "absorber",
        "absorbe"
    ],
    "absorbent": [
        "absorber"
    ],
    "absorber": [
        "absorber"
    ],
    "absorbera": [
        "absorber"
    ],
    "absorberai": [
        "absorber"
    ],
    "absorberaient": [
        "absorber"
    ],
    "absorberait": [
        "absorber"
    ],
    "absorbeur": [
        "absorbeur"
    ],
    "absorbez": [
        "absorber"
    ],
    "absorbions": [
        "absorber"
    ],
    "absorbons": [
        "absorber"
    ],
    "absorberent": [
        "absorber"
    ],
    "absorbee": [
        "absorber",
        "absorbe"
    ],
    "absorbees": [
        "absorber",
        "absorbe"
    ],
    "absorbes": [
        "absorber",
        "absorbe"
    ],
    "absorption": [
        "absorption"
    ],
    "absorptions": [
        "absorption"
    ],
    "absoudrai": [
        "absoudre"
    ],
    "absoudrait": [
        "absoudre"
    ],
    "absoudre": [
        "absoudre"
    ],
    "absoudriez": [
        "absoudre"
    ],
    "absous": [
        "absous",
        "absoudre"
    ],
    "absout": [
        "absoudre"
    ],
    "absoute": [
        "absoute",
        "absoudre"
    ],
    "absoutes": [
        "absoudre"
    ],
    "abstenaient": [
        "abstenir"
    ],
    "abstenais": [
        "abstenir"
    ],
    "abstenait": [
        "abstenir"
    ],
    "abstenant": [
        "abstenir"
    ],
    "abstenez": [
        "abstenir"
    ],
    "absteniez": [
        "abstenir"
    ],
    "abstenions": [
        "abstenir"
    ],
    "abstenir": [
        "abstenir"
    ],
    "abstenons": [
        "abstenir"
    ],
    "abstention": [
        "abstention"
    ],
    "abstentionniste": [
        "abstentionniste"
    ],
    "abstentionnistes": [
        "abstentionniste"
    ],
    "abstenu": [
        "abstenir"
    ],
    "abstenue": [
        "abstenir",
        "abstenu"
    ],
    "abstenues": [
        "abstenir"
    ],
    "abstenus": [
        "abstenir"
    ],
    "abstiendrai": [
        "abstenir"
    ],
    "abstiendraient": [
        "abstenir"
    ],
    "abstiendrais": [
        "abstenir"
    ],
    "abstiendrait": [
        "abstenir"
    ],
    "abstiendras": [
        "abstenir"
    ],
    "abstiendrions": [
        "abstenir"
    ],
    "abstiendrons": [
        "abstenir"
    ],
    "abstiendront": [
        "abstenir"
    ],
    "abstienne": [
        "abstenir"
    ],
    "abstiennent": [
        "abstenir"
    ],
    "abstiennes": [
        "abstenir"
    ],
    "abstiens": [
        "abstenir"
    ],
    "abstient": [
        "abstenir"
    ],
    "abstinence": [
        "abstinence"
    ],
    "abstinences": [
        "abstinence"
    ],
    "abstinent": [
        "abstinent"
    ],
    "abstinente": [
        "abstinent"
    ],
    "abstinrent": [
        "abstenir"
    ],
    "abstins": [
        "abstenir"
    ],
    "abstint": [
        "abstenir"
    ],
    "abstraction": [
        "abstraction"
    ],
    "abstractions": [
        "abstraction"
    ],
    "abstraire": [
        "abstraire"
    ],
    "abstrais": [
        "abstraire"
    ],
    "abstrait": [
        "abstraire",
        "abstrait"
    ],
    "abstraite": [
        "abstraire",
        "abstrait"
    ],
    "abstraitement": [
        "abstraitement"
    ],
    "abstraites": [
        "abstraire",
        "abstrait"
    ],
    "abstraits": [
        "abstraire",
        "abstrait"
    ],
    "abstrus": [
        "abstrus"
    ],
    "abstruse": [
        "abstrus"
    ],
    "abstruses": [
        "abstrus"
    ],
    "absurde": [
        "absurde"
    ],
    "absurdement": [
        "absurdement"
    ],
    "absurdes": [
        "absurde"
    ],
    "absurdistes": [
        "absurdiste"
    ],
    "absurdite": [
        "absurdite"
    ],
    "absurdites": [
        "absurdite"
    ],
    "abus": [
        "abus"
    ],
    "abusa": [
        "abuser"
    ],
    "abusai": [
        "abuser"
    ],
    "abusaient": [
        "abuser"
    ],
    "abusais": [
        "abuser"
    ],
    "abusait": [
        "abuser"
    ],
    "abusant": [
        "abuser"
    ],
    "abuse": [
        "abuse",
        "abuser"
    ],
    "abusent": [
        "abuser"
    ],
    "abuser": [
        "abuser"
    ],
    "abusera": [
        "abuser"
    ],
    "abuserai": [
        "abuser"
    ],
    "abuserais": [
        "abuser"
    ],
    "abuserait": [
        "abuser"
    ],
    "abuserez": [
        "abuser"
    ],
    "abuseriez": [
        "abuser"
    ],
    "abuses": [
        "abuse",
        "abuser"
    ],
    "abuseur": [
        "abuseur"
    ],
    "abusez": [
        "abuser"
    ],
    "abusiez": [
        "abuser"
    ],
    "abusif": [
        "abusif"
    ],
    "abusifs": [
        "abusif"
    ],
    "abusive": [
        "abusif"
    ],
    "abusivement": [
        "abusivement"
    ],
    "abusives": [
        "abusif"
    ],
    "abusons": [
        "abuser"
    ],
    "abuserent": [
        "abuser"
    ],
    "abusee": [
        "abuse",
        "abuser"
    ],
    "abusees": [
        "abuse",
        "abuser"
    ],
    "abyme": [
        "abyme"
    ],
    "abyssal": [
        "abyssal"
    ],
    "abyssale": [
        "abyssal"
    ],
    "abyssales": [
        "abyssal"
    ],
    "abysse": [
        "abysse"
    ],
    "abysses": [
        "abysse",
        "abyss"
    ],
    "abyssin": [
        "abyssin"
    ],
    "abyssinien": [
        "abyssinien"
    ],
    "abyssinienne": [
        "abyssinien"
    ],
    "abyssins": [
        "abyssin"
    ],
    "abatardi": [
        "abatardir"
    ],
    "abatardie": [
        "abatardi"
    ],
    "abatardies": [
        "abatardir"
    ],
    "abatardir": [
        "abatardir"
    ],
    "abatardirai": [
        "abatardir"
    ],
    "abatardissant": [
        "abatardir"
    ],
    "abecedaire": [
        "abecedaire"
    ],
    "abeti": [
        "abeti",
        "abetir"
    ],
    "abeties": [
        "abeti"
    ],
    "abetir": [
        "abetir"
    ],
    "abetis": [
        "abeti",
        "abetir"
    ],
    "abetissait": [
        "abetir"
    ],
    "abetissement": [
        "abetissement"
    ],
    "abetit": [
        "abetir"
    ],
    "abima": [
        "abimer"
    ],
    "abimai": [
        "abimer"
    ],
    "abimaient": [
        "abimer"
    ],
    "abimait": [
        "abimer"
    ],
    "abimant": [
        "abimer"
    ],
    "abime": [
        "abimer",
        "abime"
    ],
    "abiment": [
        "abimer"
    ],
    "abimer": [
        "abimer"
    ],
    "abimera": [
        "abimer"
    ],
    "abimerai": [
        "abimer"
    ],
    "abimerais": [
        "abimer"
    ],
    "abimerait": [
        "abimer"
    ],
    "abimeras": [
        "abimer"
    ],
    "abimerez": [
        "abimer"
    ],
    "abimeront": [
        "abimer"
    ],
    "abimes": [
        "abimer",
        "abime"
    ],
    "abimez": [
        "abimer"
    ],
    "abimions": [
        "abimer"
    ],
    "abimons": [
        "abimer"
    ],
    "abimee": [
        "abimer"
    ],
    "abimees": [
        "abimer"
    ],
    "acabit": [
        "acabit"
    ],
    "acabits": [
        "acabit"
    ],
    "acacia": [
        "acacia"
    ],
    "acacias": [
        "acacia"
    ],
    "acadien": [
        "acadien"
    ],
    "acadienne": [
        "acadienne"
    ],
    "acadiens": [
        "acadien"
    ],
    "academicien": [
        "academicien"
    ],
    "academiciens": [
        "academicien"
    ],
    "academie": [
        "academie"
    ],
    "academies": [
        "academy",
        "academie"
    ],
    "academique": [
        "academique"
    ],
    "academiquement": [
        "academiquement"
    ],
    "academiques": [
        "academique"
    ],
    "academisme": [
        "academisme"
    ],
    "academise": [
        "academiser"
    ],
    "acagnardai": [
        "acagnarder"
    ],
    "acagnardait": [
        "acagnarder"
    ],
    "acagnarder": [
        "acagnarder"
    ],
    "acagnarde": [
        "acagnarder"
    ],
    "acagnardee": [
        "acagnarder"
    ],
    "acajou": [
        "acajou"
    ],
    "acajous": [
        "acajou"
    ],
    "acanthe": [
        "acanthe"
    ],
    "acanthes": [
        "acanthe"
    ],
    "acariens": [
        "acarien"
    ],
    "acariatre": [
        "acariatre"
    ],
    "acariatres": [
        "acariatre"
    ],
    "accabla": [
        "accabler"
    ],
    "accablai": [
        "accabler"
    ],
    "accablaient": [
        "accabler"
    ],
    "accablais": [
        "accabler"
    ],
    "accablait": [
        "accabler"
    ],
    "accablant": [
        "accabler",
        "accablant"
    ],
    "accablante": [
        "accablant"
    ],
    "accablantes": [
        "accablant"
    ],
    "accablants": [
        "accablant"
    ],
    "accable": [
        "accable",
        "accabler"
    ],
    "accablement": [
        "accablement"
    ],
    "accablements": [
        "accablement"
    ],
    "accablent": [
        "accabler"
    ],
    "accabler": [
        "accabler"
    ],
    "accableraient": [
        "accabler"
    ],
    "accablez": [
        "accabler"
    ],
    "accablions": [
        "accabler"
    ],
    "accablat": [
        "accabler"
    ],
    "accablerent": [
        "accabler"
    ],
    "accablee": [
        "accable",
        "accabler"
    ],
    "accablees": [
        "accable",
        "accabler"
    ],
    "accables": [
        "accable",
        "accabler"
    ],
    "accalmie": [
        "accalmie"
    ],
    "accalmies": [
        "accalmie"
    ],
    "accalmit": [
        "accalmir"
    ],
    "accapara": [
        "accaparer"
    ],
    "accaparaient": [
        "accaparer"
    ],
    "accaparait": [
        "accaparer"
    ],
    "accaparant": [
        "accaparant",
        "accaparer"
    ],
    "accaparante": [
        "accaparant"
    ],
    "accapare": [
        "accaparer"
    ],
    "accaparer": [
        "accaparer"
    ],
    "accaparerait": [
        "accaparer"
    ],
    "accapareur": [
        "accapareur"
    ],
    "accaparez": [
        "accaparer"
    ],
    "accaparee": [
        "accaparer"
    ],
    "accaparees": [
        "accaparer"
    ],
    "accapares": [
        "accaparer"
    ],
    "accastillage": [
        "accastillage"
    ],
    "accastillages": [
        "accastillage"
    ],
    "accelerando": [
        "accelerando"
    ],
    "accent": [
        "accent"
    ],
    "accenteur": [
        "accenteur"
    ],
    "accents": [
        "accent"
    ],
    "accentua": [
        "accentuer"
    ],
    "accentuai": [
        "accentuer"
    ],
    "accentuaient": [
        "accentuer"
    ],
    "accentuais": [
        "accentuer"
    ],
    "accentuait": [
        "accentuer"
    ],
    "accentuant": [
        "accentuer"
    ],
    "accentuation": [
        "accentuation"
    ],
    "accentue": [
        "accentuer",
        "accentue"
    ],
    "accentuent": [
        "accentuer"
    ],
    "accentuer": [
        "accentuer"
    ],
    "accentuerait": [
        "accentuer"
    ],
    "accentuez": [
        "accentuer"
    ],
    "accentuat": [
        "accentuer"
    ],
    "accentuerent": [
        "accentuer"
    ],
    "accentuee": [
        "accentuer",
        "accentue"
    ],
    "accentuees": [
        "accentuer",
        "accentue"
    ],
    "accentues": [
        "accentuer",
        "accentue"
    ],
    "accepta": [
        "accepter"
    ],
    "acceptable": [
        "acceptable"
    ],
    "acceptables": [
        "acceptable"
    ],
    "acceptai": [
        "accepter"
    ],
    "acceptaient": [
        "accepter"
    ],
    "acceptais": [
        "accepter"
    ],
    "acceptait": [
        "accepter"
    ],
    "acceptant": [
        "acceptant",
        "accepter"
    ],
    "acceptassent": [
        "accepter"
    ],
    "acceptasses": [
        "accepter"
    ],
    "acceptation": [
        "acceptation"
    ],
    "acceptations": [
        "acceptation"
    ],
    "accepte": [
        "accepter"
    ],
    "acceptent": [
        "accepter"
    ],
    "accepter": [
        "accepter"
    ],
    "acceptera": [
        "accepter"
    ],
    "accepterai": [
        "accepter"
    ],
    "accepteraient": [
        "accepter"
    ],
    "accepterais": [
        "accepter"
    ],
    "accepterait": [
        "accepter"
    ],
    "accepteras": [
        "accepter"
    ],
    "accepterez": [
        "accepter"
    ],
    "accepteriez": [
        "accepter"
    ],
    "accepterions": [
        "accepter"
    ],
    "accepterons": [
        "accepter"
    ],
    "accepteront": [
        "accepter"
    ],
    "acceptes": [
        "accepter"
    ],
    "acceptez": [
        "accepter"
    ],
    "acceptiez": [
        "accepter"
    ],
    "acception": [
        "acception"
    ],
    "acceptions": [
        "accepter",
        "acception"
    ],
    "acceptons": [
        "accepter"
    ],
    "acceptames": [
        "accepter"
    ],
    "acceptat": [
        "accepter"
    ],
    "accepterent": [
        "accepter"
    ],
    "acceptee": [
        "accepter"
    ],
    "acceptees": [
        "accepter"
    ],
    "accesseurs": [
        "accesseur"
    ],
    "accessibilite": [
        "accessibilite"
    ],
    "accessible": [
        "accessible"
    ],
    "accessibles": [
        "accessible"
    ],
    "accession": [
        "accession"
    ],
    "accessit": [
        "accessit"
    ],
    "accessoire": [
        "accessoire"
    ],
    "accessoirement": [
        "accessoirement"
    ],
    "accessoires": [
        "accessoire"
    ],
    "accessoirise": [
        "accessoiriser"
    ],
    "accessoiriser": [
        "accessoiriser"
    ],
    "accessoiriste": [
        "accessoiriste"
    ],
    "accessoiristes": [
        "accessoiriste"
    ],
    "accident": [
        "accident"
    ],
    "accidente": [
        "accidente",
        "accidenter"
    ],
    "accidentel": [
        "accidentel"
    ],
    "accidentelle": [
        "accidentel"
    ],
    "accidentellement": [
        "accidentellement"
    ],
    "accidentelles": [
        "accidentel"
    ],
    "accidentels": [
        "accidentel"
    ],
    "accidenter": [
        "accidenter"
    ],
    "accidents": [
        "accident"
    ],
    "accidentee": [
        "accidente",
        "accidenter"
    ],
    "accidentees": [
        "accidente"
    ],
    "accidentes": [
        "accidente"
    ],
    "acclama": [
        "acclamer"
    ],
    "acclamaient": [
        "acclamer"
    ],
    "acclamait": [
        "acclamer"
    ],
    "acclamant": [
        "acclamer"
    ],
    "acclamation": [
        "acclamation"
    ],
    "acclamations": [
        "acclamation"
    ],
    "acclame": [
        "acclamer"
    ],
    "acclament": [
        "acclamer"
    ],
    "acclamer": [
        "acclamer"
    ],
    "acclamera": [
        "acclamer"
    ],
    "acclamerait": [
        "acclamer"
    ],
    "acclameront": [
        "acclamer"
    ],
    "acclamez": [
        "acclamer"
    ],
    "acclamiez": [
        "acclamer"
    ],
    "acclamons": [
        "acclamer"
    ],
    "acclamee": [
        "acclamer"
    ],
    "acclamees": [
        "acclamer"
    ],
    "acclames": [
        "acclamer"
    ],
    "acclimata": [
        "acclimater"
    ],
    "acclimatai": [
        "acclimater"
    ],
    "acclimatation": [
        "acclimatation"
    ],
    "acclimate": [
        "acclimater"
    ],
    "acclimatement": [
        "acclimatement"
    ],
    "acclimatent": [
        "acclimater"
    ],
    "acclimater": [
        "acclimater"
    ],
    "acclimaterait": [
        "acclimater"
    ],
    "acclimates": [
        "acclimater"
    ],
    "acclimatez": [
        "acclimater"
    ],
    "accointance": [
        "accointance"
    ],
    "accointances": [
        "accointance"
    ],
    "accointe": [
        "accointer"
    ],
    "accointes": [
        "accointer"
    ],
    "accola": [
        "accoler"
    ],
    "accolade": [
        "accolade"
    ],
    "accolades": [
        "accolade"
    ],
    "accolait": [
        "accoler"
    ],
    "accolant": [
        "accoler"
    ],
    "accole": [
        "accoler"
    ],
    "accolement": [
        "accolement"
    ],
    "accolent": [
        "accoler"
    ],
    "accoler": [
        "accoler"
    ],
    "accolerais": [
        "accoler"
    ],
    "accolee": [
        "accoler",
        "accole"
    ],
    "accolees": [
        "accoler",
        "accole"
    ],
    "accoles": [
        "accoler",
        "accole"
    ],
    "accommoda": [
        "accommoder"
    ],
    "accommodai": [
        "accommoder"
    ],
    "accommodaient": [
        "accommoder"
    ],
    "accommodais": [
        "accommoder"
    ],
    "accommodait": [
        "accommoder"
    ],
    "accommodant": [
        "accommodant",
        "accommoder"
    ],
    "accommodante": [
        "accommodant"
    ],
    "accommodantes": [
        "accommodant"
    ],
    "accommodants": [
        "accommodant"
    ],
    "accommodation": [
        "accommodation"
    ],
    "accommodatrices": [
        "accommodateur"
    ],
    "accommode": [
        "accommoder"
    ],
    "accommodement": [
        "accommodement"
    ],
    "accommodements": [
        "accommodement"
    ],
    "accommodent": [
        "accommoder"
    ],
    "accommoder": [
        "accommoder"
    ],
    "accommodera": [
        "accommoder"
    ],
    "accommoderai": [
        "accommoder"
    ],
    "accommoderaient": [
        "accommoder"
    ],
    "accommoderais": [
        "accommoder"
    ],
    "accommoderait": [
        "accommoder"
    ],
    "accommoderez": [
        "accommoder"
    ],
    "accommoderions": [
        "accommoder"
    ],
    "accommoderont": [
        "accommoder"
    ],
    "accommodions": [
        "accommoder"
    ],
    "accommodons": [
        "accommoder"
    ],
    "accommodat": [
        "accommoder"
    ],
    "accommoderent": [
        "accommoder"
    ],
    "accommodee": [
        "accommoder"
    ],
    "accommodes": [
        "accommoder"
    ],
    "accompagna": [
        "accompagner"
    ],
    "accompagnai": [
        "accompagner"
    ],
    "accompagnaient": [
        "accompagner"
    ],
    "accompagnais": [
        "accompagner"
    ],
    "accompagnait": [
        "accompagner"
    ],
    "accompagnant": [
        "accompagner",
        "accompagnant"
    ],
    "accompagnateur": [
        "accompagnateur"
    ],
    "accompagnateurs": [
        "accompagnateur"
    ],
    "accompagnatrice": [
        "accompagnateur"
    ],
    "accompagnatrices": [
        "accompagnateur"
    ],
    "accompagne": [
        "accompagne",
        "accompagner"
    ],
    "accompagnement": [
        "accompagnement"
    ],
    "accompagnements": [
        "accompagnement"
    ],
    "accompagnent": [
        "accompagner"
    ],
    "accompagner": [
        "accompagner"
    ],
    "accompagnera": [
        "accompagner"
    ],
    "accompagnerai": [
        "accompagner"
    ],
    "accompagneraient": [
        "accompagner"
    ],
    "accompagnerais": [
        "accompagner"
    ],
    "accompagnerait": [
        "accompagner"
    ],
    "accompagneras": [
        "accompagner"
    ],
    "accompagnerez": [
        "accompagner"
    ],
    "accompagneriez": [
        "accompagner"
    ],
    "accompagnerons": [
        "accompagner"
    ],
    "accompagneront": [
        "accompagner"
    ],
    "accompagnes": [
        "accompagne",
        "accompagner"
    ],
    "accompagnez": [
        "accompagner"
    ],
    "accompagniez": [
        "accompagner"
    ],
    "accompagnions": [
        "accompagner"
    ],
    "accompagnons": [
        "accompagner"
    ],
    "accompagnames": [
        "accompagner"
    ],
    "accompagnat": [
        "accompagner"
    ],
    "accompagnerent": [
        "accompagner"
    ],
    "accompagnee": [
        "accompagne",
        "accompagner"
    ],
    "accompagnees": [
        "accompagne",
        "accompagner"
    ],
    "accompli": [
        "accompli",
        "accomplir"
    ],
    "accomplie": [
        "accompli",
        "accomplir"
    ],
    "accomplies": [
        "accompli",
        "accomplir"
    ],
    "accomplir": [
        "accomplir"
    ],
    "accomplira": [
        "accomplir"
    ],
    "accomplirai": [
        "accomplir"
    ],
    "accompliraient": [
        "accomplir"
    ],
    "accomplirais": [
        "accomplir"
    ],
    "accomplirait": [
        "accomplir"
    ],
    "accompliras": [
        "accomplir"
    ],
    "accomplirent": [
        "accomplir"
    ],
    "accomplirez": [
        "accomplir"
    ],
    "accomplirons": [
        "accomplir"
    ],
    "accompliront": [
        "accomplir"
    ],
    "accomplis": [
        "accompli",
        "accomplir"
    ],
    "accomplissaient": [
        "accomplir"
    ],
    "accomplissais": [
        "accomplir"
    ],
    "accomplissait": [
        "accomplir"
    ],
    "accomplissant": [
        "accomplir"
    ],
    "accomplisse": [
        "accomplir"
    ],
    "accomplissement": [
        "accomplissement"
    ],
    "accomplissements": [
        "accomplissement"
    ],
    "accomplissent": [
        "accomplir"
    ],
    "accomplissez": [
        "accomplir"
    ],
    "accomplissiez": [
        "accomplir"
    ],
    "accomplissions": [
        "accomplir"
    ],
    "accomplissons": [
        "accomplir"
    ],
    "accomplit": [
        "accomplir"
    ],
    "accord": [
        "accord"
    ],
    "accorda": [
        "accorder"
    ],
    "accordai": [
        "accorder"
    ],
    "accordaient": [
        "accorder"
    ],
    "accordailles": [
        "accordailles"
    ],
    "accordais": [
        "accorder"
    ],
    "accordait": [
        "accorder"
    ],
    "accordant": [
        "accorder"
    ],
    "accordas": [
        "accorder"
    ],
    "accordassent": [
        "accorder"
    ],
    "accorde": [
        "accorder",
        "accorde"
    ],
    "accordement": [
        "accordement"
    ],
    "accordent": [
        "accorder"
    ],
    "accorder": [
        "accorder"
    ],
    "accordera": [
        "accorder"
    ],
    "accorderai": [
        "accorder"
    ],
    "accorderaient": [
        "accorder"
    ],
    "accorderais": [
        "accorder"
    ],
    "accorderait": [
        "accorder"
    ],
    "accorderas": [
        "accorder"
    ],
    "accorderez": [
        "accorder"
    ],
    "accorderiez": [
        "accorder"
    ],
    "accorderons": [
        "accorder"
    ],
    "accorderont": [
        "accorder"
    ],
    "accordes": [
        "accorder",
        "accorde"
    ],
    "accordeur": [
        "accordeur"
    ],
    "accordez": [
        "accorder"
    ],
    "accordiez": [
        "accorder"
    ],
    "accordions": [
        "accorder"
    ],
    "accordo": [
        "accordo"
    ],
    "accordons": [
        "accorder"
    ],
    "accords": [
        "accord"
    ],
    "accordat": [
        "accorder"
    ],
    "accorderent": [
        "accorder"
    ],
    "accordee": [
        "accorder",
        "accorde"
    ],
    "accordees": [
        "accorder",
        "accorde"
    ],
    "accordeon": [
        "accordeon"
    ],
    "accordeoniste": [
        "accordeoniste"
    ],
    "accordeonistes": [
        "accordeoniste"
    ],
    "accordeons": [
        "accordeon"
    ],
    "accore": [
        "accore"
    ],
    "accores": [
        "accore"
    ],
    "accort": [
        "accort"
    ],
    "accorte": [
        "accort"
    ],
    "accortes": [
        "accort"
    ],
    "accorts": [
        "accort"
    ],
    "accosta": [
        "accoster"
    ],
    "accostage": [
        "accostage"
    ],
    "accostaient": [
        "accoster"
    ],
    "accostais": [
        "accoster"
    ],
    "accostait": [
        "accoster"
    ],
    "accostant": [
        "accostant",
        "accoster"
    ],
    "accoste": [
        "accoster"
    ],
    "accostent": [
        "accoster"
    ],
    "accoster": [
        "accoster"
    ],
    "accosterez": [
        "accoster"
    ],
    "accosterons": [
        "accoster"
    ],
    "accostez": [
        "accoster"
    ],
    "accostiez": [
        "accoster"
    ],
    "accostons": [
        "accoster"
    ],
    "accostee": [
        "accoster"
    ],
    "accostees": [
        "accoster"
    ],
    "accota": [
        "accoter"
    ],
    "accotaient": [
        "accoter"
    ],
    "accotait": [
        "accoter"
    ],
    "accotant": [
        "accoter"
    ],
    "accote": [
        "accoter"
    ],
    "accotement": [
        "accotement"
    ],
    "accotements": [
        "accotement"
    ],
    "accotent": [
        "accoter"
    ],
    "accoter": [
        "accoter"
    ],
    "accotoirs": [
        "accotoir"
    ],
    "accotons": [
        "accoter"
    ],
    "accoterent": [
        "accoter"
    ],
    "accotee": [
        "accoter"
    ],
    "accotees": [
        "accoter"
    ],
    "accotes": [
        "accoter",
        "accote"
    ],
    "accoucha": [
        "accoucher"
    ],
    "accouchaient": [
        "accoucher"
    ],
    "accouchais": [
        "accoucher"
    ],
    "accouchait": [
        "accoucher"
    ],
    "accouchant": [
        "accouchant",
        "accoucher"
    ],
    "accouche": [
        "accoucher"
    ],
    "accouchement": [
        "accouchement"
    ],
    "accouchements": [
        "accouchement"
    ],
    "accouchent": [
        "accoucher"
    ],
    "accoucher": [
        "accoucher"
    ],
    "accouchera": [
        "accoucher"
    ],
    "accoucherait": [
        "accoucher"
    ],
    "accoucheras": [
        "accoucher"
    ],
    "accouches": [
        "accoucher"
    ],
    "accoucheur": [
        "accoucheur"
    ],
    "accoucheurs": [
        "accoucheur"
    ],
    "accoucheuse": [
        "accoucheur"
    ],
    "accouchez": [
        "accoucher"
    ],
    "accouchee": [
        "accouchee",
        "accoucher"
    ],
    "accouchees": [
        "accouchee"
    ],
    "accouda": [
        "accouder"
    ],
    "accoudai": [
        "accouder"
    ],
    "accoudaient": [
        "accouder"
    ],
    "accoudais": [
        "accouder"
    ],
    "accoudait": [
        "accouder"
    ],
    "accoudant": [
        "accouder"
    ],
    "accoude": [
        "accoude",
        "accouder"
    ],
    "accouder": [
        "accouder"
    ],
    "accoudions": [
        "accouder"
    ],
    "accoudoir": [
        "accoudoir"
    ],
    "accoudoirs": [
        "accoudoir"
    ],
    "accoudons": [
        "accouder"
    ],
    "accouderent": [
        "accouder"
    ],
    "accoudee": [
        "accoude",
        "accouder"
    ],
    "accoudees": [
        "accouder"
    ],
    "accoudes": [
        "accoude",
        "accouder"
    ],
    "accoupla": [
        "accoupler"
    ],
    "accouplaient": [
        "accoupler"
    ],
    "accouplais": [
        "accoupler"
    ],
    "accouplait": [
        "accoupler"
    ],
    "accouplant": [
        "accoupler"
    ],
    "accouple": [
        "accoupler"
    ],
    "accouplement": [
        "accouplement"
    ],
    "accouplements": [
        "accouplement"
    ],
    "accouplent": [
        "accoupler"
    ],
    "accoupler": [
        "accoupler"
    ],
    "accouplera": [
        "accoupler"
    ],
    "accouplerait": [
        "accoupler"
    ],
    "accoupleront": [
        "accoupler"
    ],
    "accouplerent": [
        "accoupler"
    ],
    "accouplee": [
        "accoupler"
    ],
    "accouplees": [
        "accoupler"
    ],
    "accouples": [
        "accoupler"
    ],
    "accouraient": [
        "accourir"
    ],
    "accourais": [
        "accourir"
    ],
    "accourait": [
        "accourir"
    ],
    "accourant": [
        "accourir"
    ],
    "accourcissant": [
        "accourcir"
    ],
    "accoure": [
        "accourir"
    ],
    "accourent": [
        "accourir"
    ],
    "accoures": [
        "accourir"
    ],
    "accourez": [
        "accourir"
    ],
    "accouriez": [
        "accourir"
    ],
    "accourir": [
        "accourir"
    ],
    "accourons": [
        "accourir"
    ],
    "accourra": [
        "accourir"
    ],
    "accourrai": [
        "accourir"
    ],
    "accourraient": [
        "accourir"
    ],
    "accourrais": [
        "accourir"
    ],
    "accourrait": [
        "accourir"
    ],
    "accourront": [
        "accourir"
    ],
    "accours": [
        "accourir"
    ],
    "accourt": [
        "accourir"
    ],
    "accouru": [
        "accourir"
    ],
    "accourue": [
        "accourir"
    ],
    "accourues": [
        "accourir"
    ],
    "accoururent": [
        "accourir"
    ],
    "accourus": [
        "accourir"
    ],
    "accourussent": [
        "accourir"
    ],
    "accourut": [
        "accourir"
    ],
    "accoutre": [
        "accoutrer",
        "accoutre"
    ],
    "accoutrement": [
        "accoutrement"
    ],
    "accoutrements": [
        "accoutrement"
    ],
    "accoutree": [
        "accoutrer",
        "accoutre"
    ],
    "accoutres": [
        "accoutrer",
        "accoutre"
    ],
    "accoutuma": [
        "accoutumer"
    ],
    "accoutumai": [
        "accoutumer"
    ],
    "accoutumaient": [
        "accoutumer"
    ],
    "accoutumais": [
        "accoutumer"
    ],
    "accoutumait": [
        "accoutumer"
    ],
    "accoutumance": [
        "accoutumance"
    ],
    "accoutumances": [
        "accoutumance"
    ],
    "accoutumant": [
        "accoutumer"
    ],
    "accoutume": [
        "accoutumer",
        "accoutume"
    ],
    "accoutument": [
        "accoutumer"
    ],
    "accoutumer": [
        "accoutumer"
    ],
    "accoutumerait": [
        "accoutumer"
    ],
    "accoutumee": [
        "accoutumer",
        "accoutume"
    ],
    "accoutumees": [
        "accoutumer",
        "accoutume"
    ],
    "accoutumes": [
        "accoutumer",
        "accoutume"
    ],
    "accouvee": [
        "accouver"
    ],
    "accras": [
        "accra"
    ],
    "accro": [
        "accro"
    ],
    "accroc": [
        "accroc"
    ],
    "accrocha": [
        "accrocher"
    ],
    "accrochage": [
        "accrochage"
    ],
    "accrochages": [
        "accrochage"
    ],
    "accrochai": [
        "accrocher"
    ],
    "accrochaient": [
        "accrocher"
    ],
    "accrochais": [
        "accrocher"
    ],
    "accrochait": [
        "accrocher"
    ],
    "accrochant": [
        "accrochant",
        "accrocher"
    ],
    "accroche": [
        "accroche",
        "accrocher"
    ],
    "accrochent": [
        "accrocher"
    ],
    "accrocher": [
        "accrocher"
    ],
    "accrochera": [
        "accrocher"
    ],
    "accrocherai": [
        "accrocher"
    ],
    "accrocheraient": [
        "accrocher"
    ],
    "accrocherais": [
        "accrocher"
    ],
    "accrocherait": [
        "accrocher"
    ],
    "accrocherez": [
        "accrocher"
    ],
    "accrocheriez": [
        "accrocher"
    ],
    "accrocheront": [
        "accrocher"
    ],
    "accroches": [
        "accroche",
        "accrocher"
    ],
    "accrocheur": [
        "accrocheur"
    ],
    "accrocheurs": [
        "accrocheur"
    ],
    "accrocheuse": [
        "accrocheur"
    ],
    "accrocheuses": [
        "accrocheur"
    ],
    "accrochez": [
        "accrocher"
    ],
    "accrochiez": [
        "accrocher"
    ],
    "accrochions": [
        "accrocher"
    ],
    "accrochons": [
        "accrocher"
    ],
    "accrochat": [
        "accrocher"
    ],
    "accrocherent": [
        "accrocher"
    ],
    "accrochee": [
        "accroche",
        "accrocher"
    ],
    "accrochees": [
        "accroche",
        "accrocher"
    ],
    "accrocs": [
        "accroc"
    ],
    "accroire": [
        "accroire"
    ],
    "accrois": [
        "accroitre"
    ],
    "accroissaient": [
        "accroitre"
    ],
    "accroissait": [
        "accroitre"
    ],
    "accroissant": [
        "accroitre"
    ],
    "accroisse": [
        "accroitre"
    ],
    "accroissement": [
        "accroissement"
    ],
    "accroissent": [
        "accroitre"
    ],
    "accroissez": [
        "accroitre"
    ],
    "accros": [
        "accro"
    ],
    "accroupi": [
        "accroupi",
        "accroupir"
    ],
    "accroupie": [
        "accroupi",
        "accroupir"
    ],
    "accroupies": [
        "accroupi",
        "accroupir"
    ],
    "accroupir": [
        "accroupir"
    ],
    "accroupirent": [
        "accroupir"
    ],
    "accroupis": [
        "accroupi",
        "accroupir"
    ],
    "accroupissaient": [
        "accroupir"
    ],
    "accroupissais": [
        "accroupir"
    ],
    "accroupissait": [
        "accroupir"
    ],
    "accroupissant": [
        "accroupir"
    ],
    "accroupisse": [
        "accroupir"
    ],
    "accroupissement": [
        "accroupissement"
    ],
    "accroupissent": [
        "accroupir"
    ],
    "accroupissons": [
        "accroupir"
    ],
    "accroupit": [
        "accroupir"
    ],
    "accroit": [
        "accroitre"
    ],
    "accroitra": [
        "accroitre"
    ],
    "accroitrait": [
        "accroitre"
    ],
    "accroitre": [
        "accroitre"
    ],
    "accroitront": [
        "accroitre"
    ],
    "accru": [
        "accroitre",
        "accru"
    ],
    "accrue": [
        "accrue",
        "accroitre",
        "accru"
    ],
    "accrues": [
        "accrue",
        "accroitre",
        "accru"
    ],
    "accrurent": [
        "accroitre"
    ],
    "accrus": [
        "accroitre",
        "accru"
    ],
    "accrut": [
        "accroitre"
    ],
    "accredita": [
        "accrediter"
    ],
    "accreditaient": [
        "accrediter"
    ],
    "accreditait": [
        "accrediter"
    ],
    "accreditant": [
        "accrediter"
    ],
    "accreditation": [
        "accreditation"
    ],
    "accreditations": [
        "accreditation"
    ],
    "accrediter": [
        "accrediter"
    ],
    "accreditif": [
        "accreditif"
    ],
    "accredite": [
        "accredite",
        "accrediter"
    ],
    "accreditee": [
        "accredite",
        "accrediter"
    ],
    "accredites": [
        "accredite",
        "accrediter"
    ],
    "accretion": [
        "accretion"
    ],
    "accu": [
        "accu"
    ],
    "accueil": [
        "accueil"
    ],
    "accueillaient": [
        "accueillir"
    ],
    "accueillais": [
        "accueillir"
    ],
    "accueillait": [
        "accueillir"
    ],
    "accueillant": [
        "accueillir",
        "accueillant"
    ],
    "accueillante": [
        "accueillant"
    ],
    "accueillantes": [
        "accueillant"
    ],
    "accueillants": [
        "accueillant"
    ],
    "accueille": [
        "accueillir"
    ],
    "accueillent": [
        "accueillir"
    ],
    "accueillera": [
        "accueillir"
    ],
    "accueillerai": [
        "accueillir"
    ],
    "accueilleraient": [
        "accueillir"
    ],
    "accueillerait": [
        "accueillir"
    ],
    "accueilleras": [
        "accueillir"
    ],
    "accueillerez": [
        "accueillir"
    ],
    "accueilleriez": [
        "accueillir"
    ],
    "accueillerons": [
        "accueillir"
    ],
    "accueilleront": [
        "accueillir"
    ],
    "accueilles": [
        "accueillir"
    ],
    "accueillez": [
        "accueillir"
    ],
    "accueilli": [
        "accueillir"
    ],
    "accueillie": [
        "accueillir"
    ],
    "accueillies": [
        "accueillir"
    ],
    "accueillir": [
        "accueillir"
    ],
    "accueillirent": [
        "accueillir"
    ],
    "accueillis": [
        "accueillir"
    ],
    "accueillit": [
        "accueillir"
    ],
    "accueillons": [
        "accueillir"
    ],
    "accueils": [
        "accueil"
    ],
    "accula": [
        "acculer"
    ],
    "acculaient": [
        "acculer"
    ],
    "acculais": [
        "acculer"
    ],
    "acculait": [
        "acculer"
    ],
    "acculant": [
        "acculer"
    ],
    "accule": [
        "acculer",
        "accule"
    ],
    "acculent": [
        "acculer"
    ],
    "acculer": [
        "acculer"
    ],
    "acculera": [
        "acculer"
    ],
    "acculeraient": [
        "acculer"
    ],
    "acculez": [
        "acculer"
    ],
    "acculturation": [
        "acculturation"
    ],
    "acculat": [
        "acculer"
    ],
    "acculerent": [
        "acculer"
    ],
    "acculee": [
        "acculer"
    ],
    "acculees": [
        "acculer"
    ],
    "accules": [
        "acculer",
        "accule"
    ],
    "accumula": [
        "accumuler"
    ],
    "accumulai": [
        "accumuler"
    ],
    "accumulaient": [
        "accumuler"
    ],
    "accumulais": [
        "accumuler"
    ],
    "accumulait": [
        "accumuler"
    ],
    "accumulant": [
        "accumuler"
    ],
    "accumulateur": [
        "accumulateur"
    ],
    "accumulateurs": [
        "accumulateur"
    ],
    "accumulation": [
        "accumulation"
    ],
    "accumulations": [
        "accumulation"
    ],
    "accumule": [
        "accumuler"
    ],
    "accumulent": [
        "accumuler"
    ],
    "accumuler": [
        "accumuler"
    ],
    "accumulerez": [
        "accumuler"
    ],
    "accumulez": [
        "accumuler"
    ],
    "accumulerent": [
        "accumuler"
    ],
    "accumulee": [
        "accumuler"
    ],
    "accumulees": [
        "accumuler"
    ],
    "accumules": [
        "accumuler"
    ],
    "accus": [
        "accu"
    ],
    "accusa": [
        "accuser"
    ],
    "accusai": [
        "accuser"
    ],
    "accusaient": [
        "accuser"
    ],
    "accusais": [
        "accuser"
    ],
    "accusait": [
        "accuser"
    ],
    "accusant": [
        "accuser"
    ],
    "accusateur": [
        "accusateur"
    ],
    "accusateurs": [
        "accusateur"
    ],
    "accusatif": [
        "accusatif"
    ],
    "accusation": [
        "accusation"
    ],
    "accusations": [
        "accusation"
    ],
    "accusatoire": [
        "accusatoire"
    ],
    "accusatrice": [
        "accusateur"
    ],
    "accusatrices": [
        "accusateur"
    ],
    "accuse": [
        "accuser",
        "accuse"
    ],
    "accusent": [
        "accuser"
    ],
    "accuser": [
        "accuser"
    ],
    "accusera": [
        "accuser"
    ],
    "accuseraient": [
        "accuser"
    ],
    "accuserais": [
        "accuser"
    ],
    "accuserait": [
        "accuser"
    ],
    "accuserez": [
        "accuser"
    ],
    "accuseriez": [
        "accuser"
    ],
    "accuserions": [
        "accuser"
    ],
    "accuserons": [
        "accuser"
    ],
    "accuseront": [
        "accuser"
    ],
    "accuses": [
        "accuser",
        "accuse"
    ],
    "accusez": [
        "accuser"
    ],
    "accusiez": [
        "accuser"
    ],
    "accusions": [
        "accuser"
    ],
    "accusons": [
        "accuser"
    ],
    "accusat": [
        "accuser"
    ],
    "accuserent": [
        "accuser"
    ],
    "accusee": [
        "accuser",
        "accuse"
    ],
    "accusees": [
        "accuser",
        "accuse"
    ],
    "accede": [
        "acceder"
    ],
    "accedent": [
        "acceder"
    ],
    "accedes": [
        "acceder",
        "accede"
    ],
    "acces": [
        "acces"
    ],
    "acceda": [
        "acceder"
    ],
    "accedai": [
        "acceder"
    ],
    "accedaient": [
        "acceder"
    ],
    "accedais": [
        "acceder"
    ],
    "accedait": [
        "acceder"
    ],
    "accedant": [
        "acceder"
    ],
    "acceder": [
        "acceder"
    ],
    "accedera": [
        "acceder"
    ],
    "accederai": [
        "acceder"
    ],
    "accederaient": [
        "acceder"
    ],
    "accederais": [
        "acceder"
    ],
    "accederait": [
        "acceder"
    ],
    "accederas": [
        "acceder"
    ],
    "accedez": [
        "acceder"
    ],
    "accedons": [
        "acceder"
    ],
    "accedames": [
        "acceder"
    ],
    "accelere": [
        "accelerer",
        "accelere"
    ],
    "accelerent": [
        "accelerer"
    ],
    "acceleres": [
        "accelerer",
        "accelere"
    ],
    "accelera": [
        "accelerer"
    ],
    "accelerai": [
        "accelerer"
    ],
    "acceleraient": [
        "accelerer"
    ],
    "accelerais": [
        "accelerer"
    ],
    "accelerait": [
        "accelerer"
    ],
    "accelerant": [
        "accelerer",
        "accelerant"
    ],
    "accelerants": [
        "accelerant"
    ],
    "accelerateur": [
        "accelerateur"
    ],
    "accelerateurs": [
        "accelerateur"
    ],
    "acceleration": [
        "acceleration"
    ],
    "accelerations": [
        "acceleration"
    ],
    "acceleratrice": [
        "accelerateur"
    ],
    "accelerer": [
        "accelerer"
    ],
    "accelerera": [
        "accelerer"
    ],
    "accelererait": [
        "accelerer"
    ],
    "accelereras": [
        "accelerer"
    ],
    "accelerez": [
        "accelerer"
    ],
    "acceleriez": [
        "accelerer"
    ],
    "accelerons": [
        "accelerer"
    ],
    "accelererent": [
        "accelerer"
    ],
    "acceleree": [
        "accelerer"
    ],
    "accelerees": [
        "accelerer"
    ],
    "ace": [
        "ace"
    ],
    "acellulaire": [
        "acellulaire"
    ],
    "acerbe": [
        "acerbe"
    ],
    "acerbes": [
        "acerbe"
    ],
    "acerbite": [
        "acerbite"
    ],
    "acetabulum": [
        "acetabulum"
    ],
    "achalandage": [
        "achalandage"
    ],
    "achalandaient": [
        "achalander"
    ],
    "achalande": [
        "achalande"
    ],
    "achalandee": [
        "achalande"
    ],
    "achalandees": [
        "achalande"
    ],
    "achalandes": [
        "achalander",
        "achalande"
    ],
    "achaler": [
        "achaler"
    ],
    "achards": [
        "achards"
    ],
    "acharna": [
        "acharner"
    ],
    "acharnai": [
        "acharner"
    ],
    "acharnaient": [
        "acharner"
    ],
    "acharnais": [
        "acharner"
    ],
    "acharnait": [
        "acharner"
    ],
    "acharnant": [
        "acharner"
    ],
    "acharne": [
        "acharne",
        "acharner"
    ],
    "acharnement": [
        "acharnement"
    ],
    "acharnements": [
        "acharnement"
    ],
    "acharnent": [
        "acharner"
    ],
    "acharner": [
        "acharner"
    ],
    "acharnera": [
        "acharner"
    ],
    "acharnerai": [
        "acharner"
    ],
    "acharnerait": [
        "acharner"
    ],
    "acharnes": [
        "acharne",
        "acharner"
    ],
    "acharnez": [
        "acharner"
    ],
    "acharnerent": [
        "acharner"
    ],
    "acharnee": [
        "acharne",
        "acharner"
    ],
    "acharnees": [
        "acharne",
        "acharner"
    ],
    "achat": [
        "achat"
    ],
    "achats": [
        "achat"
    ],
    "ache": [
        "ache"
    ],
    "achemina": [
        "acheminer"
    ],
    "acheminai": [
        "acheminer"
    ],
    "acheminaient": [
        "acheminer"
    ],
    "acheminait": [
        "acheminer"
    ],
    "acheminant": [
        "acheminer"
    ],
    "achemine": [
        "acheminer"
    ],
    "acheminement": [
        "acheminement"
    ],
    "acheminent": [
        "acheminer"
    ],
    "acheminer": [
        "acheminer"
    ],
    "achemineront": [
        "acheminer"
    ],
    "acheminons": [
        "acheminer"
    ],
    "acheminames": [
        "acheminer"
    ],
    "acheminerent": [
        "acheminer"
    ],
    "acheminee": [
        "acheminer"
    ],
    "acheminees": [
        "acheminer"
    ],
    "achemines": [
        "acheminer"
    ],
    "aches": [
        "ach",
        "ache"
    ],
    "acheta": [
        "acheter"
    ],
    "achetable": [
        "achetable"
    ],
    "achetai": [
        "acheter"
    ],
    "achetaient": [
        "acheter"
    ],
    "achetais": [
        "acheter"
    ],
    "achetait": [
        "acheter"
    ],
    "achetant": [
        "acheter"
    ],
    "achetassent": [
        "acheter"
    ],
    "acheter": [
        "acheter"
    ],
    "acheteur": [
        "acheteur"
    ],
    "acheteurs": [
        "acheteur"
    ],
    "acheteuse": [
        "acheteur"
    ],
    "acheteuses": [
        "acheteur"
    ],
    "achetez": [
        "acheter"
    ],
    "achetiez": [
        "acheter"
    ],
    "achetions": [
        "acheter"
    ],
    "achetons": [
        "acheter"
    ],
    "achetames": [
        "acheter"
    ],
    "achetat": [
        "acheter"
    ],
    "acheterent": [
        "acheter"
    ],
    "achete": [
        "acheter"
    ],
    "achetee": [
        "acheter"
    ],
    "achetees": [
        "acheter"
    ],
    "achetes": [
        "acheter"
    ],
    "acheva": [
        "achever"
    ],
    "achevai": [
        "achever"
    ],
    "achevaient": [
        "achever"
    ],
    "achevais": [
        "achever"
    ],
    "achevait": [
        "achever"
    ],
    "achevant": [
        "achever"
    ],
    "achever": [
        "achever"
    ],
    "achevez": [
        "achever"
    ],
    "acheviez": [
        "achever"
    ],
    "achevions": [
        "achever"
    ],
    "achevons": [
        "achever"
    ],
    "achevames": [
        "achever"
    ],
    "achevat": [
        "achever"
    ],
    "acheverent": [
        "achever"
    ],
    "acheve": [
        "achever",
        "acheve"
    ],
    "achevee": [
        "achever",
        "acheve"
    ],
    "achevees": [
        "achever",
        "acheve"
    ],
    "acheves": [
        "achever",
        "acheve"
    ],
    "achillee": [
        "achillee"
    ],
    "achondroplasie": [
        "achondroplasie"
    ],
    "achondroplasies": [
        "achondroplasie"
    ],
    "achoppa": [
        "achopper"
    ],
    "achoppai": [
        "achopper"
    ],
    "achoppaient": [
        "achopper"
    ],
    "achoppais": [
        "achopper"
    ],
    "achoppait": [
        "achopper"
    ],
    "achoppe": [
        "achopper"
    ],
    "achoppement": [
        "achoppement"
    ],
    "achopper": [
        "achopper"
    ],
    "achoppee": [
        "achopper"
    ],
    "achetent": [
        "acheter"
    ],
    "achetera": [
        "acheter"
    ],
    "acheterai": [
        "acheter"
    ],
    "acheteraient": [
        "acheter"
    ],
    "acheterais": [
        "acheter"
    ],
    "acheterait": [
        "acheter"
    ],
    "acheteras": [
        "acheter"
    ],
    "acheterez": [
        "acheter"
    ],
    "acheteriez": [
        "acheter"
    ],
    "acheterions": [
        "acheter"
    ],
    "acheterons": [
        "acheter"
    ],
    "acheteront": [
        "acheter"
    ],
    "achevement": [
        "achevement"
    ],
    "achevements": [
        "achevement"
    ],
    "achevent": [
        "achever"
    ],
    "achevera": [
        "achever"
    ],
    "acheverai": [
        "achever"
    ],
    "acheveraient": [
        "achever"
    ],
    "acheverait": [
        "achever"
    ],
    "acheverez": [
        "achever"
    ],
    "acheverons": [
        "achever"
    ],
    "acheveront": [
        "achever"
    ],
    "acheleme": [
        "acheleme"
    ],
    "achelemes": [
        "acheleme"
    ],
    "acide": [
        "acide"
    ],
    "acides": [
        "acide"
    ],
    "acidite": [
        "acidite"
    ],
    "acidites": [
        "acidite"
    ],
    "acidocetose": [
        "acidocetose"
    ],
    "acidose": [
        "acidose"
    ],
    "acidule": [
        "acidule",
        "aciduler"
    ],
    "acidulee": [
        "acidule",
        "aciduler"
    ],
    "acidulees": [
        "acidule",
        "aciduler"
    ],
    "acidules": [
        "acidule",
        "aciduler"
    ],
    "acier": [
        "acier"
    ],
    "aciers": [
        "acier"
    ],
    "acierie": [
        "acierie"
    ],
    "acieries": [
        "acierie"
    ],
    "acme": [
        "acme"
    ],
    "acne": [
        "acne"
    ],
    "acneiques": [
        "acneique"
    ],
    "acnes": [
        "acne"
    ],
    "acolyte": [
        "acolyte"
    ],
    "acolytes": [
        "acolyte"
    ],
    "acompte": [
        "acompte"
    ],
    "acomptes": [
        "acompte"
    ],
    "aconiers": [
        "aconier"
    ],
    "aconit": [
        "aconit"
    ],
    "acoquina": [
        "acoquiner"
    ],
    "acoquine": [
        "acoquiner"
    ],
    "acoquiner": [
        "acoquiner"
    ],
    "acoquinee": [
        "acoquiner"
    ],
    "acoquines": [
        "acoquiner"
    ],
    "acouphene": [
        "acouphene"
    ],
    "acoustique": [
        "acoustique"
    ],
    "acoustiques": [
        "acoustique"
    ],
    "acquerra": [
        "acquerir"
    ],
    "acquerrai": [
        "acquerir"
    ],
    "acquerraient": [
        "acquerir"
    ],
    "acquerront": [
        "acquerir"
    ],
    "acquiers": [
        "acquerir"
    ],
    "acquiert": [
        "acquerir"
    ],
    "acquiesce": [
        "acquiescer"
    ],
    "acquiescement": [
        "acquiescement"
    ],
    "acquiescements": [
        "acquiescement"
    ],
    "acquiescent": [
        "acquiescer"
    ],
    "acquiescer": [
        "acquiescer"
    ],
    "acquiesceront": [
        "acquiescer"
    ],
    "acquiesces": [
        "acquiesce",
        "acquiescer"
    ],
    "acquiescerent": [
        "acquiescer"
    ],
    "acquiesca": [
        "acquiescer"
    ],
    "acquiescai": [
        "acquiescer"
    ],
    "acquiescaient": [
        "acquiescer"
    ],
    "acquiescais": [
        "acquiescer"
    ],
    "acquiescait": [
        "acquiescer"
    ],
    "acquiescant": [
        "acquiescer"
    ],
    "acquiescons": [
        "acquiescer"
    ],
    "acquirent": [
        "acquerir"
    ],
    "acquis": [
        "acquis",
        "acquerir"
    ],
    "acquise": [
        "acquis",
        "acquerir"
    ],
    "acquises": [
        "acquis",
        "acquerir"
    ],
    "acquisition": [
        "acquisition"
    ],
    "acquisitions": [
        "acquisition"
    ],
    "acquit": [
        "acquit",
        "acquerir"
    ],
    "acquits": [
        "acquit"
    ],
    "acquitta": [
        "acquitter"
    ],
    "acquittai": [
        "acquitter"
    ],
    "acquittaient": [
        "acquitter"
    ],
    "acquittais": [
        "acquitter"
    ],
    "acquittait": [
        "acquitter"
    ],
    "acquittant": [
        "acquitter"
    ],
    "acquitte": [
        "acquitte",
        "acquitter"
    ],
    "acquittement": [
        "acquittement"
    ],
    "acquittent": [
        "acquitter"
    ],
    "acquitter": [
        "acquitter"
    ],
    "acquittera": [
        "acquitter"
    ],
    "acquitterai": [
        "acquitter"
    ],
    "acquitterais": [
        "acquitter"
    ],
    "acquitterait": [
        "acquitter"
    ],
    "acquitterez": [
        "acquitter"
    ],
    "acquittes": [
        "acquitte",
        "acquitter"
    ],
    "acquittez": [
        "acquitter"
    ],
    "acquittions": [
        "acquitter"
    ],
    "acquittat": [
        "acquitter"
    ],
    "acquittee": [
        "acquitte",
        "acquitter"
    ],
    "acquiere": [
        "acquerir"
    ],
    "acquierent": [
        "acquerir"
    ],
    "acqueraient": [
        "acquerir"
    ],
    "acquerais": [
        "acquerir"
    ],
    "acquerait": [
        "acquerir"
    ],
    "acquerant": [
        "acquerir"
    ],
    "acquereur": [
        "acquereur"
    ],
    "acquereurs": [
        "acquereur"
    ],
    "acquerions": [
        "acquerir"
    ],
    "acquerir": [
        "acquerir"
    ],
    "acquerons": [
        "acquerir"
    ],
    "acquet": [
        "acquet"
    ],
    "acquets": [
        "acquet"
    ],
    "acra": [
        "acra"
    ],
    "acre": [
        "acre"
    ],
    "acres": [
        "acre"
    ],
    "acrimonie": [
        "acrimonie"
    ],
    "acrimonieuse": [
        "acrimonieux"
    ],
    "acrimonieusement": [
        "acrimonieusement"
    ],
    "acrimonieuses": [
        "acrimonieux"
    ],
    "acrimonieux": [
        "acrimonieux"
    ],
    "acrobate": [
        "acrobate"
    ],
    "acrobates": [
        "acrobate"
    ],
    "acrobatie": [
        "acrobatie"
    ],
    "acrobaties": [
        "acrobatie"
    ],
    "acrobatique": [
        "acrobatique"
    ],
    "acrobatiquement": [
        "acrobatiquement"
    ],
    "acrobatiques": [
        "acrobatique"
    ],
    "acrocephale": [
        "acrocephale"
    ],
    "acromion": [
        "acromion"
    ],
    "acronyme": [
        "acronyme"
    ],
    "acrophobie": [
        "acrophobie"
    ],
    "acropole": [
        "acropole"
    ],
    "acrostiche": [
        "acrostiche"
    ],
    "acrotere": [
        "acrotere"
    ],
    "acrylique": [
        "acrylique"
    ],
    "acryliques": [
        "acrylique"
    ],
    "acrylonitrile": [
        "acrylonitrile"
    ],
    "acta": [
        "acter"
    ],
    "acte": [
        "acte"
    ],
    "actes": [
        "acte"
    ],
    "acteur": [
        "acteur"
    ],
    "acteurs": [
        "acteur"
    ],
    "actif": [
        "actif"
    ],
    "actifs": [
        "actif"
    ],
    "actine": [
        "actine"
    ],
    "actinies": [
        "actinie"
    ],
    "action": [
        "action"
    ],
    "actionna": [
        "actionner"
    ],
    "actionnai": [
        "actionner"
    ],
    "actionnaient": [
        "actionner"
    ],
    "actionnaire": [
        "actionnaire"
    ],
    "actionnaires": [
        "actionnaire"
    ],
    "actionnais": [
        "actionner"
    ],
    "actionnait": [
        "actionner"
    ],
    "actionnant": [
        "actionner"
    ],
    "actionnariat": [
        "actionnariat"
    ],
    "actionne": [
        "actionner"
    ],
    "actionnement": [
        "actionnement"
    ],
    "actionnent": [
        "actionner"
    ],
    "actionner": [
        "actionner"
    ],
    "actionneront": [
        "actionner"
    ],
    "actionneur": [
        "actionneur"
    ],
    "actionnez": [
        "actionner"
    ],
    "actionnat": [
        "actionner"
    ],
    "actionnee": [
        "actionner"
    ],
    "actionnees": [
        "actionner"
    ],
    "actionnes": [
        "actionner"
    ],
    "actions": [
        "action",
        "acter"
    ],
    "activa": [
        "activer"
    ],
    "activai": [
        "activer"
    ],
    "activaient": [
        "activer"
    ],
    "activait": [
        "activer"
    ],
    "activant": [
        "activer",
        "activant"
    ],
    "activateur": [
        "activateur"
    ],
    "activation": [
        "activation"
    ],
    "activations": [
        "activation"
    ],
    "active": [
        "activer",
        "active",
        "actif"
    ],
    "activement": [
        "activement"
    ],
    "activent": [
        "activer"
    ],
    "activer": [
        "activer"
    ],
    "activera": [
        "activer"
    ],
    "activerai": [
        "activer"
    ],
    "activerait": [
        "activer"
    ],
    "activeras": [
        "activer"
    ],
    "actives": [
        "activer",
        "active",
        "actif"
    ],
    "activez": [
        "activer"
    ],
    "activisme": [
        "activisme"
    ],
    "activiste": [
        "activiste"
    ],
    "activistes": [
        "activiste"
    ],
    "activite": [
        "activite"
    ],
    "activites": [
        "activite"
    ],
    "activons": [
        "activer"
    ],
    "activerent": [
        "activer"
    ],
    "activee": [
        "activer",
        "active"
    ],
    "activees": [
        "activer",
        "active"
    ],
    "actrice": [
        "acteur"
    ],
    "actrices": [
        "acteur"
    ],
    "actuaire": [
        "actuaire"
    ],
    "actualisation": [
        "actualisation"
    ],
    "actualise": [
        "actualiser"
    ],
    "actualiser": [
        "actualiser"
    ],
    "actualisez": [
        "actualiser"
    ],
    "actualisee": [
        "actualiser"
    ],
    "actualisees": [
        "actualiser"
    ],
    "actualite": [
        "actualite"
    ],
    "actualites": [
        "actualite"
    ],
    "actuariel": [
        "actuariel"
    ],
    "actuation": [
        "actuation"
    ],
    "actuel": [
        "actuel"
    ],
    "actuelle": [
        "actuel"
    ],
    "actuellement": [
        "actuellement"
    ],
    "actuelles": [
        "actuel"
    ],
    "actuels": [
        "actuel"
    ],
    "acuite": [
        "acuite"
    ],
    "acumen": [
        "acumen"
    ],
    "acuponcteur": [
        "acuponcteur"
    ],
    "acuponcture": [
        "acuponcture"
    ],
    "acupuncteur": [
        "acupuncteur"
    ],
    "acupuncture": [
        "acupuncture"
    ],
    "acephale": [
        "acephale"
    ],
    "acephales": [
        "acephale"
    ],
    "acere": [
        "acere",
        "acerer"
    ],
    "aceree": [
        "acere"
    ],
    "acerees": [
        "acere",
        "acerer"
    ],
    "aceres": [
        "acere",
        "acerer"
    ],
    "acetate": [
        "acetate"
    ],
    "acetique": [
        "acetique"
    ],
    "acetone": [
        "acetone"
    ],
    "acetylcholine": [
        "acetylcholine"
    ],
    "acetylsalicylique": [
        "acetylsalicylique"
    ],
    "acetylene": [
        "acetylene"
    ],
    "ada": [
        "ada"
    ],
    "adage": [
        "adage"
    ],
    "adages": [
        "adage"
    ],
    "adagio": [
        "adagio"
    ],
    "adamantin": [
        "adamantin"
    ],
    "adamantine": [
        "adamantin"
    ],
    "adamique": [
        "adamique"
    ],
    "adapta": [
        "adapter"
    ],
    "adaptabilite": [
        "adaptabilite"
    ],
    "adaptable": [
        "adaptable"
    ],
    "adaptables": [
        "adaptable"
    ],
    "adaptai": [
        "adapter"
    ],
    "adaptaient": [
        "adapter"
    ],
    "adaptais": [
        "adapter"
    ],
    "adaptait": [
        "adapter"
    ],
    "adaptant": [
        "adapter"
    ],
    "adaptateur": [
        "adaptateur"
    ],
    "adaptateurs": [
        "adaptateur"
    ],
    "adaptatif": [
        "adaptatif"
    ],
    "adaptatifs": [
        "adaptatif"
    ],
    "adaptation": [
        "adaptation"
    ],
    "adaptations": [
        "adaptation"
    ],
    "adapte": [
        "adapter"
    ],
    "adaptent": [
        "adapter"
    ],
    "adapter": [
        "adapter"
    ],
    "adaptera": [
        "adapter"
    ],
    "adapterai": [
        "adapter"
    ],
    "adapterais": [
        "adapter"
    ],
    "adapterait": [
        "adapter"
    ],
    "adapteras": [
        "adapter"
    ],
    "adapterez": [
        "adapter"
    ],
    "adapterons": [
        "adapter"
    ],
    "adapteront": [
        "adapter"
    ],
    "adaptes": [
        "adapter"
    ],
    "adaptez": [
        "adapter"
    ],
    "adaptat": [
        "adapter"
    ],
    "adapterent": [
        "adapter"
    ],
    "adaptee": [
        "adapter"
    ],
    "adaptees": [
        "adapter"
    ],
    "addenda": [
        "addenda"
    ],
    "addendum": [
        "addendum"
    ],
    "addiction": [
        "addiction"
    ],
    "additif": [
        "additif"
    ],
    "additifs": [
        "additif"
    ],
    "addition": [
        "addition"
    ],
    "additionnaient": [
        "additionner"
    ],
    "additionnais": [
        "additionner"
    ],
    "additionnait": [
        "additionner"
    ],
    "additionnant": [
        "additionner"
    ],
    "additionne": [
        "additionner"
    ],
    "additionnel": [
        "additionnel"
    ],
    "additionnelle": [
        "additionnel"
    ],
    "additionnelles": [
        "additionnel"
    ],
    "additionnels": [
        "additionnel"
    ],
    "additionnent": [
        "additionner"
    ],
    "additionner": [
        "additionner"
    ],
    "additionneraient": [
        "additionner"
    ],
    "additionnerait": [
        "additionner"
    ],
    "additionnez": [
        "additionner"
    ],
    "additionnee": [
        "additionner"
    ],
    "additionnees": [
        "additionner"
    ],
    "additionnes": [
        "additionner"
    ],
    "additions": [
        "addition"
    ],
    "adducteur": [
        "adducteur"
    ],
    "adducteurs": [
        "adducteur"
    ],
    "adduction": [
        "adduction"
    ],
    "adent": [
        "adent"
    ],
    "adepte": [
        "adepte"
    ],
    "adeptes": [
        "adepte"
    ],
    "adhere": [
        "adherer"
    ],
    "adherent": [
        "adherer",
        "adherent"
    ],
    "adhera": [
        "adherer"
    ],
    "adheraient": [
        "adherer"
    ],
    "adherais": [
        "adherer"
    ],
    "adherait": [
        "adherer"
    ],
    "adherant": [
        "adherer"
    ],
    "adherence": [
        "adherence"
    ],
    "adherences": [
        "adherence"
    ],
    "adherente": [
        "adherent"
    ],
    "adherentes": [
        "adherent"
    ],
    "adherents": [
        "adherent"
    ],
    "adherer": [
        "adherer"
    ],
    "adherez": [
        "adherer"
    ],
    "adhesif": [
        "adhesif"
    ],
    "adhesifs": [
        "adhesif"
    ],
    "adhesion": [
        "adhesion"
    ],
    "adhesions": [
        "adhesion"
    ],
    "adhesive": [
        "adhesif"
    ],
    "adhesives": [
        "adhesive",
        "adhesif"
    ],
    "adieu": [
        "adieu"
    ],
    "adieux": [
        "adieu"
    ],
    "adipeuse": [
        "adipeux"
    ],
    "adipeuses": [
        "adipeux"
    ],
    "adipeux": [
        "adipeux"
    ],
    "adipique": [
        "adipique"
    ],
    "adiposite": [
        "adiposite"
    ],
    "adira": [
        "adire"
    ],
    "adja": [
        "adja"
    ],
    "adjacent": [
        "adjacent"
    ],
    "adjacente": [
        "adjacent"
    ],
    "adjacentes": [
        "adjacent"
    ],
    "adjacents": [
        "adjacent"
    ],
    "adjas": [
        "adja"
    ],
    "adjectif": [
        "adjectif"
    ],
    "adjectifs": [
        "adjectif"
    ],
    "adjective": [
        "adjectif"
    ],
    "adjoignait": [
        "adjoindre"
    ],
    "adjoignant": [
        "adjoindre"
    ],
    "adjoigne": [
        "adjoindre"
    ],
    "adjoignit": [
        "adjoindre"
    ],
    "adjoindra": [
        "adjoindre"
    ],
    "adjoindre": [
        "adjoindre"
    ],
    "adjoindront": [
        "adjoindre"
    ],
    "adjoins": [
        "adjoin",
        "adjoindre"
    ],
    "adjoint": [
        "adjoindre",
        "adjoint"
    ],
    "adjointe": [
        "adjoindre",
        "adjoint"
    ],
    "adjointes": [
        "adjoint"
    ],
    "adjoints": [
        "adjoindre",
        "adjoint"
    ],
    "adjonction": [
        "adjonction"
    ],
    "adjudant": [
        "adjudant"
    ],
    "adjudants": [
        "adjudant"
    ],
    "adjudication": [
        "adjudication"
    ],
    "adjudications": [
        "adjudication"
    ],
    "adjuge": [
        "adjuger"
    ],
    "adjugeait": [
        "adjuger"
    ],
    "adjugeant": [
        "adjuger"
    ],
    "adjuger": [
        "adjuger"
    ],
    "adjugez": [
        "adjuger"
    ],
    "adjugee": [
        "adjuger"
    ],
    "adjuges": [
        "adjuger"
    ],
    "adjupete": [
        "adjupete"
    ],
    "adjupetes": [
        "adjupete"
    ],
    "adjura": [
        "adjurer"
    ],
    "adjurai": [
        "adjurer"
    ],
    "adjuraient": [
        "adjurer"
    ],
    "adjurais": [
        "adjurer"
    ],
    "adjurait": [
        "adjurer"
    ],
    "adjurant": [
        "adjurer"
    ],
    "adjuration": [
        "adjuration"
    ],
    "adjurations": [
        "adjuration"
    ],
    "adjure": [
        "adjurer"
    ],
    "adjurer": [
        "adjurer"
    ],
    "adjurerai": [
        "adjurer"
    ],
    "adjurerait": [
        "adjurer"
    ],
    "adjutrice": [
        "adjutrice"
    ],
    "adjuvants": [
        "adjuvant"
    ],
    "admet": [
        "admettre"
    ],
    "admets": [
        "admettre"
    ],
    "admettaient": [
        "admettre"
    ],
    "admettais": [
        "admettre"
    ],
    "admettait": [
        "admettre"
    ],
    "admettant": [
        "admettre"
    ],
    "admette": [
        "admettre"
    ],
    "admettent": [
        "admettre"
    ],
    "admettes": [
        "admettre"
    ],
    "admettez": [
        "admettre"
    ],
    "admettiez": [
        "admettre"
    ],
    "admettions": [
        "admettre"
    ],
    "admettons": [
        "admettre"
    ],
    "admettra": [
        "admettre"
    ],
    "admettrai": [
        "admettre"
    ],
    "admettraient": [
        "admettre"
    ],
    "admettrais": [
        "admettre"
    ],
    "admettrait": [
        "admettre"
    ],
    "admettras": [
        "admettre"
    ],
    "admettre": [
        "admettre"
    ],
    "admettrez": [
        "admettre"
    ],
    "admettriez": [
        "admettre"
    ],
    "admettrons": [
        "admettre"
    ],
    "admettront": [
        "admettre"
    ],
    "administra": [
        "administrer"
    ],
    "administrai": [
        "administrer"
    ],
    "administraient": [
        "administrer"
    ],
    "administrais": [
        "administrer"
    ],
    "administrait": [
        "administrer"
    ],
    "administrant": [
        "administrant",
        "administrer"
    ],
    "administrateur": [
        "administrateur"
    ],
    "administrateurs": [
        "administrateur"
    ],
    "administratif": [
        "administratif"
    ],
    "administratifs": [
        "administratif"
    ],
    "administration": [
        "administration"
    ],
    "administrations": [
        "administration"
    ],
    "administrative": [
        "administratif"
    ],
    "administrativement": [
        "administrativement"
    ],
    "administratives": [
        "administratif"
    ],
    "administratrice": [
        "administrateur"
    ],
    "administre": [
        "administre",
        "administrer"
    ],
    "administrent": [
        "administrer"
    ],
    "administrer": [
        "administrer"
    ],
    "administrera": [
        "administrer"
    ],
    "administrerai": [
        "administrer"
    ],
    "administrerons": [
        "administrer"
    ],
    "administres": [
        "administre",
        "administrer"
    ],
    "administrez": [
        "administrer"
    ],
    "administrat": [
        "administrer"
    ],
    "administree": [
        "administre",
        "administrer"
    ],
    "administrees": [
        "administre",
        "administrer"
    ],
    "admira": [
        "admirer"
    ],
    "admirable": [
        "admirable"
    ],
    "admirablement": [
        "admirablement"
    ],
    "admirables": [
        "admirable"
    ],
    "admirai": [
        "admirer"
    ],
    "admiraient": [
        "admirer"
    ],
    "admirais": [
        "admirer"
    ],
    "admirait": [
        "admirer"
    ],
    "admirant": [
        "admirer"
    ],
    "admirateur": [
        "admirateur"
    ],
    "admirateurs": [
        "admirateur"
    ],
    "admiratif": [
        "admiratif"
    ],
    "admiratifs": [
        "admiratif"
    ],
    "admiration": [
        "admiration"
    ],
    "admirations": [
        "admiration"
    ],
    "admirative": [
        "admiratif"
    ],
    "admirativement": [
        "admirativement"
    ],
    "admiratives": [
        "admiratif"
    ],
    "admiratrice": [
        "admirateur"
    ],
    "admiratrices": [
        "admirateur"
    ],
    "admire": [
        "admirer"
    ],
    "admirent": [
        "admettre",
        "admirer"
    ],
    "admirer": [
        "admirer"
    ],
    "admirera": [
        "admirer"
    ],
    "admirerai": [
        "admirer"
    ],
    "admirerais": [
        "admirer"
    ],
    "admirerait": [
        "admirer"
    ],
    "admirerez": [
        "admirer"
    ],
    "admireront": [
        "admirer"
    ],
    "admires": [
        "admirer",
        "admire"
    ],
    "admirez": [
        "admirer"
    ],
    "admiriez": [
        "admirer"
    ],
    "admirions": [
        "admirer"
    ],
    "admirons": [
        "admirer"
    ],
    "admirames": [
        "admirer"
    ],
    "admirerent": [
        "admirer"
    ],
    "admiree": [
        "admirer"
    ],
    "admirees": [
        "admirer"
    ],
    "admis": [
        "admettre",
        "admis"
    ],
    "admise": [
        "admettre",
        "admis"
    ],
    "admises": [
        "admettre",
        "admis"
    ],
    "admissibilite": [
        "admissibilite"
    ],
    "admissible": [
        "admissible"
    ],
    "admissibles": [
        "admissible"
    ],
    "admission": [
        "admission"
    ],
    "admissions": [
        "admission"
    ],
    "admit": [
        "admettre"
    ],
    "admixtion": [
        "admixtion"
    ],
    "admonesta": [
        "admonester"
    ],
    "admonestait": [
        "admonester"
    ],
    "admonestation": [
        "admonestation"
    ],
    "admonestations": [
        "admonestation"
    ],
    "admoneste": [
        "admonester"
    ],
    "admonester": [
        "admonester"
    ],
    "admonestat": [
        "admonester"
    ],
    "admonestes": [
        "admonester"
    ],
    "admonition": [
        "admonition"
    ],
    "admonitions": [
        "admonition"
    ],
    "ado": [
        "ado"
    ],
    "adobe": [
        "adobe"
    ],
    "adolescence": [
        "adolescence"
    ],
    "adolescences": [
        "adolescence"
    ],
    "adolescent": [
        "adolescent"
    ],
    "adolescente": [
        "adolescent"
    ],
    "adolescentes": [
        "adolescent"
    ],
    "adolescents": [
        "adolescent"
    ],
    "adon": [
        "adon"
    ],
    "adonc": [
        "adonc"
    ],
    "adoncques": [
        "adoncques"
    ],
    "adonies": [
        "adonies"
    ],
    "adonis": [
        "adonis"
    ],
    "adonisant": [
        "adoniser"
    ],
    "adonna": [
        "adonner"
    ],
    "adonnai": [
        "adonner"
    ],
    "adonnaient": [
        "adonner"
    ],
    "adonnais": [
        "adonner"
    ],
    "adonnait": [
        "adonner"
    ],
    "adonnant": [
        "adonner"
    ],
    "adonne": [
        "adonner"
    ],
    "adonnent": [
        "adonner"
    ],
    "adonner": [
        "adonner"
    ],
    "adonnerait": [
        "adonner"
    ],
    "adonnez": [
        "adonner"
    ],
    "adonnions": [
        "adonner"
    ],
    "adonnee": [
        "adonner"
    ],
    "adonnees": [
        "adonner"
    ],
    "adonnes": [
        "adonner"
    ],
    "adopta": [
        "adopter"
    ],
    "adoptable": [
        "adoptable"
    ],
    "adoptai": [
        "adopter"
    ],
    "adoptaient": [
        "adopter"
    ],
    "adoptais": [
        "adopter"
    ],
    "adoptait": [
        "adopter"
    ],
    "adoptant": [
        "adopter",
        "adoptant"
    ],
    "adopte": [
        "adopte",
        "adopter"
    ],
    "adoptent": [
        "adopter"
    ],
    "adopter": [
        "adopter"
    ],
    "adoptera": [
        "adopter"
    ],
    "adopterai": [
        "adopter"
    ],
    "adopteraient": [
        "adopter"
    ],
    "adopterait": [
        "adopter"
    ],
    "adopterez": [
        "adopter"
    ],
    "adopterons": [
        "adopter"
    ],
    "adopteront": [
        "adopter"
    ],
    "adoptez": [
        "adopter"
    ],
    "adoptif": [
        "adoptif"
    ],
    "adoptifs": [
        "adoptif"
    ],
    "adoption": [
        "adoption"
    ],
    "adoptions": [
        "adopter",
        "adoption"
    ],
    "adoptive": [
        "adoptif"
    ],
    "adoptives": [
        "adoptif"
    ],
    "adoptons": [
        "adopter"
    ],
    "adoptat": [
        "adopter"
    ],
    "adopterent": [
        "adopter"
    ],
    "adoptee": [
        "adopte",
        "adopter"
    ],
    "adoptees": [
        "adopte",
        "adopter"
    ],
    "adoptes": [
        "adopte",
        "adopter"
    ],
    "adora": [
        "adorer"
    ],
    "adorable": [
        "adorable"
    ],
    "adorablement": [
        "adorablement"
    ],
    "adorables": [
        "adorable"
    ],
    "adorai": [
        "adorer"
    ],
    "adoraient": [
        "adorer"
    ],
    "adorais": [
        "adorer"
    ],
    "adorait": [
        "adorer"
    ],
    "adorant": [
        "adorer",
        "adorant"
    ],
    "adorante": [
        "adorant"
    ],
    "adorants": [
        "adorant"
    ],
    "adorateur": [
        "adorateur"
    ],
    "adorateurs": [
        "adorateur"
    ],
    "adoration": [
        "adoration"
    ],
    "adorations": [
        "adoration"
    ],
    "adoratrice": [
        "adorateur"
    ],
    "adoratrices": [
        "adorateur"
    ],
    "adore": [
        "adorer"
    ],
    "adorent": [
        "adorer"
    ],
    "adorer": [
        "adorer"
    ],
    "adorera": [
        "adorer"
    ],
    "adorerai": [
        "adorer"
    ],
    "adoreraient": [
        "adorer"
    ],
    "adorerais": [
        "adorer"
    ],
    "adorerait": [
        "adorer"
    ],
    "adoreras": [
        "adorer"
    ],
    "adorerez": [
        "adorer"
    ],
    "adoreriez": [
        "adorer"
    ],
    "adorerions": [
        "adorer"
    ],
    "adorerons": [
        "adorer"
    ],
    "adoreront": [
        "adorer"
    ],
    "adores": [
        "adorer",
        "adore"
    ],
    "adorez": [
        "adorer"
    ],
    "adoriez": [
        "adorer"
    ],
    "adorions": [
        "adorer"
    ],
    "adornaient": [
        "adorner"
    ],
    "adornait": [
        "adorner"
    ],
    "adorne": [
        "adorner"
    ],
    "adorons": [
        "adorer"
    ],
    "adorerent": [
        "adorer"
    ],
    "adoree": [
        "adorer"
    ],
    "adorees": [
        "adorer"
    ],
    "ados": [
        "ados"
    ],
    "adossa": [
        "adosser"
    ],
    "adossai": [
        "adosser"
    ],
    "adossaient": [
        "adosser"
    ],
    "adossais": [
        "adosser"
    ],
    "adossait": [
        "adosser"
    ],
    "adossant": [
        "adosser"
    ],
    "adosse": [
        "adosse",
        "adosser"
    ],
    "adossent": [
        "adosser"
    ],
    "adosser": [
        "adosser"
    ],
    "adossez": [
        "adosser"
    ],
    "adosserent": [
        "adosser"
    ],
    "adossee": [
        "adosse",
        "adosser"
    ],
    "adossees": [
        "adosser"
    ],
    "adosses": [
        "adosse",
        "adosser"
    ],
    "adouba": [
        "adouber"
    ],
    "adoubement": [
        "adoubement"
    ],
    "adouber": [
        "adouber"
    ],
    "adoube": [
        "adouber"
    ],
    "adouci": [
        "adoucir",
        "adouci"
    ],
    "adoucie": [
        "adoucir"
    ],
    "adoucies": [
        "adoucir"
    ],
    "adoucir": [
        "adoucir"
    ],
    "adoucira": [
        "adoucir"
    ],
    "adoucirait": [
        "adoucir"
    ],
    "adoucirent": [
        "adoucir"
    ],
    "adoucis": [
        "adoucir",
        "adouci"
    ],
    "adoucissaient": [
        "adoucir"
    ],
    "adoucissait": [
        "adoucir"
    ],
    "adoucissant": [
        "adoucir",
        "adoucissant"
    ],
    "adoucissantes": [
        "adoucissant"
    ],
    "adoucisse": [
        "adoucir"
    ],
    "adoucissement": [
        "adoucissement"
    ],
    "adoucissements": [
        "adoucissement"
    ],
    "adoucissent": [
        "adoucir"
    ],
    "adoucisseur": [
        "adoucisseur"
    ],
    "adoucisseurs": [
        "adoucisseur"
    ],
    "adoucissez": [
        "adoucir"
    ],
    "adoucit": [
        "adoucir"
    ],
    "adp": [
        "adp"
    ],
    "adragante": [
        "adragant"
    ],
    "adressa": [
        "adresser"
    ],
    "adressage": [
        "adressage"
    ],
    "adressai": [
        "adresser"
    ],
    "adressaient": [
        "adresser"
    ],
    "adressais": [
        "adresser"
    ],
    "adressait": [
        "adresser"
    ],
    "adressant": [
        "adresser"
    ],
    "adressassent": [
        "adresser"
    ],
    "adresse": [
        "adresser",
        "adresse"
    ],
    "adressent": [
        "adresser"
    ],
    "adresser": [
        "adresser"
    ],
    "adressera": [
        "adresser"
    ],
    "adresserai": [
        "adresser"
    ],
    "adresseraient": [
        "adresser"
    ],
    "adresserais": [
        "adresser"
    ],
    "adresserait": [
        "adresser"
    ],
    "adresseras": [
        "adresser"
    ],
    "adresserez": [
        "adresser"
    ],
    "adresserons": [
        "adresser"
    ],
    "adresseront": [
        "adresser"
    ],
    "adresses": [
        "adresser",
        "adresse"
    ],
    "adressez": [
        "adresser"
    ],
    "adressiez": [
        "adresser"
    ],
    "adressions": [
        "adresser"
    ],
    "adressons": [
        "adresser"
    ],
    "adressames": [
        "adresser"
    ],
    "adressat": [
        "adresser"
    ],
    "adresserent": [
        "adresser"
    ],
    "adressee": [
        "adresser"
    ],
    "adressees": [
        "adresser"
    ],
    "adret": [
        "adret"
    ],
    "adriatique": [
        "adriatique"
    ],
    "adriatiques": [
        "adriatique"
    ],
    "adroit": [
        "adroit"
    ],
    "adroite": [
        "adroit"
    ],
    "adroitement": [
        "adroitement"
    ],
    "adroites": [
        "adroit"
    ],
    "adroits": [
        "adroit"
    ],
    "adrenaline": [
        "adrenaline"
    ],
    "adrenalines": [
        "adrenaline"
    ],
    "adulaient": [
        "aduler"
    ],
    "adulais": [
        "aduler"
    ],
    "adulait": [
        "aduler"
    ],
    "adulateur": [
        "adulateur"
    ],
    "adulation": [
        "adulation"
    ],
    "adulations": [
        "adulation"
    ],
    "adulent": [
        "aduler"
    ],
    "aduler": [
        "aduler"
    ],
    "adultat": [
        "adultat"
    ],
    "adulte": [
        "adulte"
    ],
    "adultes": [
        "adulte"
    ],
    "adultere": [
        "adulterer",
        "adultere"
    ],
    "adulteres": [
        "adultere"
    ],
    "adulteraient": [
        "adulterer"
    ],
    "adulteration": [
        "adulteration"
    ],
    "adulterin": [
        "adulterin"
    ],
    "adulterine": [
        "adulterin"
    ],
    "adulterins": [
        "adulterin"
    ],
    "adulterees": [
        "adulterer"
    ],
    "adule": [
        "aduler"
    ],
    "adulee": [
        "aduler"
    ],
    "adules": [
        "aduler"
    ],
    "advenait": [
        "advenir"
    ],
    "advenir": [
        "advenir"
    ],
    "adventices": [
        "adventice"
    ],
    "adventiste": [
        "adventiste"
    ],
    "advenu": [
        "advenir"
    ],
    "advenue": [
        "advenu",
        "advenir"
    ],
    "advenues": [
        "advenir"
    ],
    "adverbe": [
        "adverbe"
    ],
    "adverbes": [
        "adverbe"
    ],
    "adversaire": [
        "adversaire"
    ],
    "adversaires": [
        "adversaire"
    ],
    "adverse": [
        "adverse"
    ],
    "adverses": [
        "adverse"
    ],
    "adversite": [
        "adversite"
    ],
    "adversites": [
        "adversite"
    ],
    "adviendra": [
        "advenir"
    ],
    "adviendrait": [
        "advenir"
    ],
    "advienne": [
        "advenir"
    ],
    "adviennent": [
        "advenir"
    ],
    "advient": [
        "advenir"
    ],
    "advint": [
        "advenir"
    ],
    "adenine": [
        "adenine"
    ],
    "adenocarcinome": [
        "adenocarcinome"
    ],
    "adenome": [
        "adenome"
    ],
    "adenopathie": [
        "adenopathie"
    ],
    "adenosine": [
        "adenosine"
    ],
    "adenovirus": [
        "adenovirus"
    ],
    "adequat": [
        "adequat"
    ],
    "adequate": [
        "adequat"
    ],
    "adequatement": [
        "adequatement"
    ],
    "adequates": [
        "adequat"
    ],
    "adequation": [
        "adequation"
    ],
    "adequats": [
        "adequat"
    ],
    "aegipans": [
        "aegipan"
    ],
    "affabilite": [
        "affabilite"
    ],
    "affabilites": [
        "affabilite"
    ],
    "affable": [
        "affable"
    ],
    "affablement": [
        "affablement"
    ],
    "affables": [
        "affable"
    ],
    "affabulation": [
        "affabulation"
    ],
    "affabulations": [
        "affabulation"
    ],
    "affabulatrice": [
        "affabulateur"
    ],
    "affabule": [
        "affabuler"
    ],
    "affabuler": [
        "affabuler"
    ],
    "affabules": [
        "affabuler"
    ],
    "affacturage": [
        "affacturage"
    ],
    "affadi": [
        "affadir"
    ],
    "affadie": [
        "affadir"
    ],
    "affadies": [
        "affadir"
    ],
    "affadir": [
        "affadir"
    ],
    "affadis": [
        "affadir"
    ],
    "affadissaient": [
        "affadir"
    ],
    "affadissait": [
        "affadir"
    ],
    "affadissant": [
        "affadir"
    ],
    "affadisse": [
        "affadir"
    ],
    "affadissement": [
        "affadissement"
    ],
    "affadit": [
        "affadir"
    ],
    "affaibli": [
        "affaiblir",
        "affaibli"
    ],
    "affaiblie": [
        "affaiblir",
        "affaibli"
    ],
    "affaiblies": [
        "affaiblir",
        "affaibli"
    ],
    "affaiblir": [
        "affaiblir"
    ],
    "affaiblira": [
        "affaiblir"
    ],
    "affaiblis": [
        "affaiblir",
        "affaibli"
    ],
    "affaiblissaient": [
        "affaiblir"
    ],
    "affaiblissais": [
        "affaiblir"
    ],
    "affaiblissait": [
        "affaiblir"
    ],
    "affaiblissant": [
        "affaiblissant",
        "affaiblir"
    ],
    "affaiblisse": [
        "affaiblir"
    ],
    "affaiblissement": [
        "affaiblissement"
    ],
    "affaiblissent": [
        "affaiblir"
    ],
    "affaiblissez": [
        "affaiblir"
    ],
    "affaiblissons": [
        "affaiblir"
    ],
    "affaiblit": [
        "affaiblir"
    ],
    "affaira": [
        "affairer"
    ],
    "affairai": [
        "affairer"
    ],
    "affairaient": [
        "affairer"
    ],
    "affairais": [
        "affairer"
    ],
    "affairait": [
        "affairer"
    ],
    "affairant": [
        "affairer"
    ],
    "affaire": [
        "affairer",
        "affaire"
    ],
    "affairement": [
        "affairement"
    ],
    "affairements": [
        "affairement"
    ],
    "affairent": [
        "affairer"
    ],
    "affairer": [
        "affairer"
    ],
    "affaireraient": [
        "affairer"
    ],
    "affaires": [
        "affairer",
        "affaire"
    ],
    "affairions": [
        "affairer"
    ],
    "affairisme": [
        "affairisme"
    ],
    "affairiste": [
        "affairiste"
    ],
    "affairistes": [
        "affairiste"
    ],
    "affairons": [
        "affairer"
    ],
    "affairerent": [
        "affairer"
    ],
    "affairee": [
        "affairer",
        "affaire"
    ],
    "affairees": [
        "affairer",
        "affaire"
    ],
    "affaissa": [
        "affaisser"
    ],
    "affaissaient": [
        "affaisser"
    ],
    "affaissait": [
        "affaisser"
    ],
    "affaissant": [
        "affaisser"
    ],
    "affaisse": [
        "affaisser"
    ],
    "affaissement": [
        "affaissement"
    ],
    "affaissements": [
        "affaissement"
    ],
    "affaissent": [
        "affaisser"
    ],
    "affaisser": [
        "affaisser"
    ],
    "affaisseraient": [
        "affaisser"
    ],
    "affaisserait": [
        "affaisser"
    ],
    "affaissions": [
        "affaisser"
    ],
    "affaisserent": [
        "affaisser"
    ],
    "affaissee": [
        "affaisser"
    ],
    "affaissees": [
        "affaisser"
    ],
    "affaisses": [
        "affaisser"
    ],
    "affala": [
        "affaler"
    ],
    "affalai": [
        "affaler"
    ],
    "affalaient": [
        "affaler"
    ],
    "affalais": [
        "affaler"
    ],
    "affalait": [
        "affaler"
    ],
    "affalant": [
        "affaler"
    ],
    "affale": [
        "affaler"
    ],
    "affalement": [
        "affalement"
    ],
    "affalent": [
        "affaler"
    ],
    "affaler": [
        "affaler"
    ],
    "affalez": [
        "affaler"
    ],
    "affalons": [
        "affaler"
    ],
    "affalerent": [
        "affaler"
    ],
    "affalee": [
        "affaler"
    ],
    "affalees": [
        "affaler"
    ],
    "affales": [
        "affaler"
    ],
    "affamaient": [
        "affamer"
    ],
    "affamait": [
        "affamer"
    ],
    "affamant": [
        "affamer"
    ],
    "affamantes": [
        "affamant"
    ],
    "affame": [
        "affame",
        "affamer"
    ],
    "affament": [
        "affamer"
    ],
    "affamer": [
        "affamer"
    ],
    "affamera": [
        "affamer"
    ],
    "affamez": [
        "affamer"
    ],
    "affamee": [
        "affame",
        "affamer"
    ],
    "affamees": [
        "affame",
        "affamer"
    ],
    "affames": [
        "affame",
        "affamer"
    ],
    "affect": [
        "affect"
    ],
    "affecta": [
        "affecter"
    ],
    "affectai": [
        "affecter"
    ],
    "affectaient": [
        "affecter"
    ],
    "affectais": [
        "affecter"
    ],
    "affectait": [
        "affecter"
    ],
    "affectant": [
        "affecter"
    ],
    "affectassent": [
        "affecter"
    ],
    "affectation": [
        "affectation"
    ],
    "affectations": [
        "affectation"
    ],
    "affecte": [
        "affecte",
        "affecter"
    ],
    "affectent": [
        "affecter"
    ],
    "affecter": [
        "affecter"
    ],
    "affectera": [
        "affecter"
    ],
    "affecterai": [
        "affecter"
    ],
    "affecteraient": [
        "affecter"
    ],
    "affecterait": [
        "affecter"
    ],
    "affecteriez": [
        "affecter"
    ],
    "affecteront": [
        "affecter"
    ],
    "affectez": [
        "affecter"
    ],
    "affectiez": [
        "affecter"
    ],
    "affectif": [
        "affectif"
    ],
    "affectifs": [
        "affectif"
    ],
    "affection": [
        "affection"
    ],
    "affectionnaient": [
        "affectionner"
    ],
    "affectionnais": [
        "affectionner"
    ],
    "affectionnait": [
        "affectionner"
    ],
    "affectionnant": [
        "affectionner"
    ],
    "affectionne": [
        "affectionne",
        "affectionner"
    ],
    "affectionnent": [
        "affectionner"
    ],
    "affectionner": [
        "affectionner"
    ],
    "affectionnez": [
        "affectionner"
    ],
    "affectionnee": [
        "affectionne",
        "affectionner"
    ],
    "affectionnes": [
        "affectionne"
    ],
    "affections": [
        "affection",
        "affecter"
    ],
    "affective": [
        "affectif"
    ],
    "affectivement": [
        "affectivement"
    ],
    "affectives": [
        "affectif"
    ],
    "affectivite": [
        "affectivite"
    ],
    "affectons": [
        "affecter"
    ],
    "affectueuse": [
        "affectueux"
    ],
    "affectueusement": [
        "affectueusement"
    ],
    "affectueuses": [
        "affectueux"
    ],
    "affectueux": [
        "affectueux"
    ],
    "affectames": [
        "affecter"
    ],
    "affectat": [
        "affecter"
    ],
    "affecterent": [
        "affecter"
    ],
    "affectee": [
        "affecte",
        "affecter"
    ],
    "affectees": [
        "affecte",
        "affecter"
    ],
    "affectes": [
        "affecte",
        "affecter"
    ],
    "affermi": [
        "affermir"
    ],
    "affermie": [
        "affermir"
    ],
    "affermir": [
        "affermir"
    ],
    "affermira": [
        "affermir"
    ],
    "affermis": [
        "affermir"
    ],
    "affermissaient": [
        "affermir"
    ],
    "affermissait": [
        "affermir"
    ],
    "affermissant": [
        "affermir"
    ],
    "affermisse": [
        "affermir"
    ],
    "affermissement": [
        "affermissement"
    ],
    "affermissent": [
        "affermir"
    ],
    "affermit": [
        "affermir"
    ],
    "afficha": [
        "afficher"
    ],
    "affichage": [
        "affichage"
    ],
    "affichages": [
        "affichage"
    ],
    "affichaient": [
        "afficher"
    ],
    "affichais": [
        "afficher"
    ],
    "affichait": [
        "afficher"
    ],
    "affichant": [
        "affichant",
        "afficher"
    ],
    "affiche": [
        "afficher",
        "affiche"
    ],
    "affichent": [
        "afficher"
    ],
    "afficher": [
        "afficher"
    ],
    "affichera": [
        "afficher"
    ],
    "afficherai": [
        "afficher"
    ],
    "afficherait": [
        "afficher"
    ],
    "affiches": [
        "afficher",
        "affiche"
    ],
    "affichette": [
        "affichette"
    ],
    "affichettes": [
        "affichette"
    ],
    "afficheur": [
        "afficheur"
    ],
    "afficheurs": [
        "afficheur"
    ],
    "affichez": [
        "afficher"
    ],
    "affichions": [
        "afficher"
    ],
    "affichiste": [
        "affichiste"
    ],
    "affichistes": [
        "affichiste"
    ],
    "affichons": [
        "afficher"
    ],
    "affichat": [
        "afficher"
    ],
    "afficherent": [
        "afficher"
    ],
    "affichee": [
        "afficher"
    ],
    "affichees": [
        "afficher"
    ],
    "affidavit": [
        "affidavit"
    ],
    "affide": [
        "affide"
    ],
    "affidee": [
        "affide"
    ],
    "affides": [
        "affide"
    ],
    "affile": [
        "affile",
        "affiler"
    ],
    "affiler": [
        "affiler"
    ],
    "affilia": [
        "affilier"
    ],
    "affiliaient": [
        "affilier"
    ],
    "affiliant": [
        "affilier"
    ],
    "affiliation": [
        "affiliation"
    ],
    "affiliations": [
        "affiliation"
    ],
    "affilier": [
        "affilier"
    ],
    "affilie": [
        "affilie",
        "affilier"
    ],
    "affiliee": [
        "affilie",
        "affilier"
    ],
    "affiliees": [
        "affilie"
    ],
    "affilies": [
        "affilie",
        "affilier"
    ],
    "affilee": [
        "affile",
        "affiler"
    ],
    "affilees": [
        "affile"
    ],
    "affiles": [
        "affile"
    ],
    "affin": [
        "affin"
    ],
    "affina": [
        "affiner"
    ],
    "affinage": [
        "affinage"
    ],
    "affinaient": [
        "affiner"
    ],
    "affinait": [
        "affiner"
    ],
    "affinant": [
        "affiner"
    ],
    "affine": [
        "affiner",
        "affine"
    ],
    "affinement": [
        "affinement"
    ],
    "affinent": [
        "affiner"
    ],
    "affiner": [
        "affiner"
    ],
    "affinera": [
        "affiner"
    ],
    "affinerait": [
        "affiner"
    ],
    "affinite": [
        "affinite"
    ],
    "affinites": [
        "affinite"
    ],
    "affinons": [
        "affiner"
    ],
    "affinee": [
        "affiner",
        "affine"
    ],
    "affinees": [
        "affiner"
    ],
    "affiquets": [
        "affiquet"
    ],
    "affirma": [
        "affirmer"
    ],
    "affirmai": [
        "affirmer"
    ],
    "affirmaient": [
        "affirmer"
    ],
    "affirmais": [
        "affirmer"
    ],
    "affirmait": [
        "affirmer"
    ],
    "affirmant": [
        "affirmer"
    ],
    "affirmatif": [
        "affirmatif"
    ],
    "affirmatifs": [
        "affirmatif"
    ],
    "affirmation": [
        "affirmation"
    ],
    "affirmations": [
        "affirmation"
    ],
    "affirmative": [
        "affirmative",
        "affirmatif"
    ],
    "affirmativement": [
        "affirmativement"
    ],
    "affirme": [
        "affirmer"
    ],
    "affirment": [
        "affirmer"
    ],
    "affirmer": [
        "affirmer"
    ],
    "affirmerai": [
        "affirmer"
    ],
    "affirmerait": [
        "affirmer"
    ],
    "affirmeras": [
        "affirmer"
    ],
    "affirmerez": [
        "affirmer"
    ],
    "affirmeriez": [
        "affirmer"
    ],
    "affirmeront": [
        "affirmer"
    ],
    "affirmes": [
        "affirmer"
    ],
    "affirmez": [
        "affirmer"
    ],
    "affirmiez": [
        "affirmer"
    ],
    "affirmions": [
        "affirmer"
    ],
    "affirmons": [
        "affirmer"
    ],
    "affirmat": [
        "affirmer"
    ],
    "affirmerent": [
        "affirmer"
    ],
    "affirmee": [
        "affirmer"
    ],
    "affirmees": [
        "affirmer"
    ],
    "affixe": [
        "affixe"
    ],
    "afflanque": [
        "afflanquer"
    ],
    "affleura": [
        "affleurer"
    ],
    "affleuraient": [
        "affleurer"
    ],
    "affleurait": [
        "affleurer"
    ],
    "affleurant": [
        "affleurer",
        "affleurant"
    ],
    "affleure": [
        "affleurer"
    ],
    "affleurement": [
        "affleurement"
    ],
    "affleurements": [
        "affleurement"
    ],
    "affleurent": [
        "affleurer"
    ],
    "affleurer": [
        "affleurer"
    ],
    "affleurat": [
        "affleurer"
    ],
    "affleurerent": [
        "affleurer"
    ],
    "affliction": [
        "affliction"
    ],
    "afflictions": [
        "affliction"
    ],
    "afflige": [
        "afflige",
        "affliger"
    ],
    "affligea": [
        "affliger"
    ],
    "affligeaient": [
        "affliger"
    ],
    "affligeait": [
        "affliger"
    ],
    "affligeant": [
        "affligeant",
        "affliger"
    ],
    "affligeante": [
        "affligeant"
    ],
    "affligeantes": [
        "affligeant"
    ],
    "affligeants": [
        "affligeant"
    ],
    "affligent": [
        "affliger"
    ],
    "affliger": [
        "affliger"
    ],
    "affligez": [
        "affliger"
    ],
    "affligerent": [
        "affliger"
    ],
    "affligee": [
        "afflige",
        "affliger"
    ],
    "affliges": [
        "afflige",
        "affliger"
    ],
    "afflua": [
        "affluer"
    ],
    "affluaient": [
        "affluer"
    ],
    "affluait": [
        "affluer"
    ],
    "affluant": [
        "affluer"
    ],
    "afflue": [
        "affluer"
    ],
    "affluence": [
        "affluence"
    ],
    "affluent": [
        "affluent",
        "affluer"
    ],
    "affluentes": [
        "affluent"
    ],
    "affluents": [
        "affluent"
    ],
    "affluer": [
        "affluer"
    ],
    "afflueraient": [
        "affluer"
    ],
    "afflux": [
        "afflux"
    ],
    "affluerent": [
        "affluer"
    ],
    "affola": [
        "affoler"
    ],
    "affolai": [
        "affoler"
    ],
    "affolaient": [
        "affoler"
    ],
    "affolais": [
        "affoler"
    ],
    "affolait": [
        "affoler"
    ],
    "affolant": [
        "affolant",
        "affoler"
    ],
    "affolante": [
        "affolant"
    ],
    "affolantes": [
        "affolant"
    ],
    "affolants": [
        "affolant"
    ],
    "affole": [
        "affole",
        "affoler"
    ],
    "affolement": [
        "affolement"
    ],
    "affolent": [
        "affoler"
    ],
    "affoler": [
        "affoler"
    ],
    "affolera": [
        "affoler"
    ],
    "affolerais": [
        "affoler"
    ],
    "affolerait": [
        "affoler"
    ],
    "affoleront": [
        "affoler"
    ],
    "affoles": [
        "affole",
        "affoler"
    ],
    "affolez": [
        "affoler"
    ],
    "affoliez": [
        "affoler"
    ],
    "affolons": [
        "affoler"
    ],
    "affolat": [
        "affoler"
    ],
    "affolerent": [
        "affoler"
    ],
    "affolee": [
        "affole",
        "affoler"
    ],
    "affolees": [
        "affole",
        "affoler"
    ],
    "affouage": [
        "affouage"
    ],
    "affouages": [
        "affouage"
    ],
    "affouillait": [
        "affouiller"
    ],
    "affouillement": [
        "affouillement"
    ],
    "affouillements": [
        "affouillement"
    ],
    "affouille": [
        "affouiller"
    ],
    "affranchi": [
        "affranchir",
        "affranchi"
    ],
    "affranchie": [
        "affranchir",
        "affranchi"
    ],
    "affranchies": [
        "affranchir",
        "affranchi"
    ],
    "affranchir": [
        "affranchir"
    ],
    "affranchirait": [
        "affranchir"
    ],
    "affranchis": [
        "affranchir",
        "affranchi"
    ],
    "affranchissais": [
        "affranchir"
    ],
    "affranchissait": [
        "affranchir"
    ],
    "affranchissant": [
        "affranchir"
    ],
    "affranchisse": [
        "affranchir"
    ],
    "affranchissement": [
        "affranchissement"
    ],
    "affranchit": [
        "affranchir"
    ],
    "affres": [
        "affre"
    ],
    "affreuse": [
        "affreux"
    ],
    "affreusement": [
        "affreusement"
    ],
    "affreuses": [
        "affreux"
    ],
    "affreux": [
        "affreux"
    ],
    "affriandai": [
        "affriander"
    ],
    "affriander": [
        "affriander"
    ],
    "affriande": [
        "affriander"
    ],
    "affriandes": [
        "affriander"
    ],
    "affriolait": [
        "affrioler"
    ],
    "affriolant": [
        "affriolant",
        "affrioler"
    ],
    "affriolante": [
        "affriolant"
    ],
    "affriolantes": [
        "affriolant"
    ],
    "affriolants": [
        "affriolant"
    ],
    "affriole": [
        "affrioler"
    ],
    "affrioler": [
        "affrioler"
    ],
    "affriolerait": [
        "affrioler"
    ],
    "affrioles": [
        "affrioler"
    ],
    "affront": [
        "affront"
    ],
    "affronta": [
        "affronter"
    ],
    "affrontai": [
        "affronter"
    ],
    "affrontaient": [
        "affronter"
    ],
    "affrontais": [
        "affronter"
    ],
    "affrontait": [
        "affronter"
    ],
    "affrontant": [
        "affronter"
    ],
    "affronte": [
        "affronter"
    ],
    "affrontement": [
        "affrontement"
    ],
    "affrontements": [
        "affrontement"
    ],
    "affrontent": [
        "affronter"
    ],
    "affronter": [
        "affronter"
    ],
    "affrontera": [
        "affronter"
    ],
    "affronterai": [
        "affronter"
    ],
    "affronteraient": [
        "affronter"
    ],
    "affronterais": [
        "affronter"
    ],
    "affronterait": [
        "affronter"
    ],
    "affronteras": [
        "affronter"
    ],
    "affronterez": [
        "affronter"
    ],
    "affronterons": [
        "affronter"
    ],
    "affronteront": [
        "affronter"
    ],
    "affrontes": [
        "affronte",
        "affronter"
    ],
    "affrontez": [
        "affronter"
    ],
    "affrontiez": [
        "affronter"
    ],
    "affrontions": [
        "affronter"
    ],
    "affrontons": [
        "affronter"
    ],
    "affronts": [
        "affront"
    ],
    "affronterent": [
        "affronter"
    ],
    "affrontee": [
        "affronter"
    ],
    "affrontees": [
        "affronte",
        "affronter"
    ],
    "affrete": [
        "affreter"
    ],
    "affretement": [
        "affretement"
    ],
    "affreter": [
        "affreter"
    ],
    "affreterons": [
        "affreter"
    ],
    "affreteur": [
        "affreteur"
    ],
    "affretez": [
        "affreter"
    ],
    "affubla": [
        "affubler"
    ],
    "affublait": [
        "affubler"
    ],
    "affublant": [
        "affubler"
    ],
    "affuble": [
        "affubler",
        "affuble"
    ],
    "affublement": [
        "affublement"
    ],
    "affublent": [
        "affubler"
    ],
    "affubler": [
        "affubler"
    ],
    "affublerais": [
        "affubler"
    ],
    "affublerait": [
        "affubler"
    ],
    "affublons": [
        "affubler"
    ],
    "affublee": [
        "affubler",
        "affuble"
    ],
    "affublees": [
        "affubler"
    ],
    "affubles": [
        "affubler",
        "affuble"
    ],
    "affurait": [
        "affurer"
    ],
    "affure": [
        "affurer"
    ],
    "affurer": [
        "affurer"
    ],
    "affures": [
        "affurer"
    ],
    "affuree": [
        "affurer"
    ],
    "affusions": [
        "affusion"
    ],
    "afferent": [
        "afferent"
    ],
    "afferente": [
        "afferent"
    ],
    "afferentes": [
        "afferent"
    ],
    "afferents": [
        "afferent"
    ],
    "affeterie": [
        "affeterie"
    ],
    "affeteries": [
        "affeterie"
    ],
    "affetees": [
        "affete"
    ],
    "affut": [
        "affut"
    ],
    "affuta": [
        "affuter"
    ],
    "affutage": [
        "affutage"
    ],
    "affutait": [
        "affuter"
    ],
    "affutant": [
        "affuter"
    ],
    "affute": [
        "affuter"
    ],
    "affuter": [
        "affuter"
    ],
    "affuterai": [
        "affuter"
    ],
    "affuteur": [
        "affuteur"
    ],
    "affutez": [
        "affuter"
    ],
    "affuts": [
        "affut"
    ],
    "affutat": [
        "affuter"
    ],
    "affutee": [
        "affuter"
    ],
    "affutees": [
        "affuter"
    ],
    "affutes": [
        "affuter"
    ],
    "afghan": [
        "afghan"
    ],
    "afghane": [
        "afghan"
    ],
    "afghanes": [
        "afghan"
    ],
    "afghans": [
        "afghan"
    ],
    "aficionado": [
        "aficionado"
    ],
    "aficionados": [
        "aficionado"
    ],
    "afin": [
        "afin"
    ],
    "africain": [
        "africain"
    ],
    "africaine": [
        "africain"
    ],
    "africaines": [
        "africain"
    ],
    "africains": [
        "africain"
    ],
    "africanisme": [
        "africanisme"
    ],
    "afrikaans": [
        "afrikaans"
    ],
    "afrikaner": [
        "afrikaner"
    ],
    "afrikaners": [
        "afrikaner"
    ],
    "afro": [
        "afro"
    ],
    "aga": [
        "aga"
    ],
    "agace": [
        "agace",
        "agacer"
    ],
    "agacement": [
        "agacement"
    ],
    "agacements": [
        "agacement"
    ],
    "agacent": [
        "agacer"
    ],
    "agacer": [
        "agacer"
    ],
    "agacera": [
        "agacer"
    ],
    "agacerait": [
        "agacer"
    ],
    "agaceras": [
        "agacer"
    ],
    "agacerie": [
        "agacerie"
    ],
    "agaceries": [
        "agacerie"
    ],
    "agaceront": [
        "agacer"
    ],
    "agaces": [
        "agacer"
    ],
    "agaceur": [
        "agaceur"
    ],
    "agacez": [
        "agacer"
    ],
    "agacerent": [
        "agacer"
    ],
    "agacee": [
        "agacer"
    ],
    "agacees": [
        "agacer"
    ],
    "agames": [
        "agame"
    ],
    "agami": [
        "agami"
    ],
    "agapanthe": [
        "agapanthe"
    ],
    "agapanthes": [
        "agapanthe"
    ],
    "agape": [
        "agape"
    ],
    "agapes": [
        "agape"
    ],
    "agas": [
        "aga"
    ],
    "agasses": [
        "agasse"
    ],
    "agate": [
        "agate"
    ],
    "agates": [
        "agate"
    ],
    "agathe": [
        "agathe"
    ],
    "agave": [
        "agave"
    ],
    "agaves": [
        "agave"
    ],
    "agaca": [
        "agacer"
    ],
    "agacaient": [
        "agacer"
    ],
    "agacais": [
        "agacer"
    ],
    "agacait": [
        "agacer"
    ],
    "agacant": [
        "agacant",
        "agacer"
    ],
    "agacante": [
        "agacant"
    ],
    "agacantes": [
        "agacant"
    ],
    "agacants": [
        "agacant"
    ],
    "age": [
        "age"
    ],
    "agence": [
        "agencer",
        "agence"
    ],
    "agencement": [
        "agencement"
    ],
    "agencements": [
        "agencement"
    ],
    "agencer": [
        "agencer"
    ],
    "agences": [
        "agencer",
        "agence"
    ],
    "agencee": [
        "agencer"
    ],
    "agencees": [
        "agencer"
    ],
    "agenda": [
        "agenda"
    ],
    "agendas": [
        "agenda"
    ],
    "agenouilla": [
        "agenouiller"
    ],
    "agenouillai": [
        "agenouiller"
    ],
    "agenouillaient": [
        "agenouiller"
    ],
    "agenouillais": [
        "agenouiller"
    ],
    "agenouillait": [
        "agenouiller"
    ],
    "agenouillant": [
        "agenouiller"
    ],
    "agenouille": [
        "agenouille",
        "agenouiller"
    ],
    "agenouillement": [
        "agenouillement"
    ],
    "agenouillent": [
        "agenouiller"
    ],
    "agenouiller": [
        "agenouiller"
    ],
    "agenouillera": [
        "agenouiller"
    ],
    "agenouilleront": [
        "agenouiller"
    ],
    "agenouilles": [
        "agenouille",
        "agenouiller"
    ],
    "agenouillez": [
        "agenouiller"
    ],
    "agenouillons": [
        "agenouiller"
    ],
    "agenouillat": [
        "agenouiller"
    ],
    "agenouillerent": [
        "agenouiller"
    ],
    "agenouillee": [
        "agenouille",
        "agenouiller"
    ],
    "agenouillees": [
        "agenouille",
        "agenouiller"
    ],
    "agent": [
        "agent"
    ],
    "agente": [
        "agent"
    ],
    "agents": [
        "agent"
    ],
    "agenca": [
        "agencer"
    ],
    "agencaient": [
        "agencer"
    ],
    "agencait": [
        "agencer"
    ],
    "agencant": [
        "agencer"
    ],
    "ages": [
        "age"
    ],
    "aggiornamento": [
        "aggiornamento"
    ],
    "agglo": [
        "agglo"
    ],
    "agglomere": [
        "agglomere",
        "agglomerer"
    ],
    "agglomerent": [
        "agglomerer"
    ],
    "agglomeraient": [
        "agglomerer"
    ],
    "agglomerant": [
        "agglomerer"
    ],
    "agglomerat": [
        "agglomerat"
    ],
    "agglomeration": [
        "agglomeration"
    ],
    "agglomerations": [
        "agglomeration"
    ],
    "agglomerer": [
        "agglomerer"
    ],
    "agglomerera": [
        "agglomerer"
    ],
    "agglomereront": [
        "agglomerer"
    ],
    "agglomeree": [
        "agglomerer"
    ],
    "agglomerees": [
        "agglomerer"
    ],
    "agglomeres": [
        "agglomere",
        "agglomerer"
    ],
    "agglutina": [
        "agglutiner"
    ],
    "agglutinaient": [
        "agglutiner"
    ],
    "agglutinait": [
        "agglutiner"
    ],
    "agglutinant": [
        "agglutiner"
    ],
    "agglutinatif": [
        "agglutinatif"
    ],
    "agglutination": [
        "agglutination"
    ],
    "agglutine": [
        "agglutiner"
    ],
    "agglutinement": [
        "agglutinement"
    ],
    "agglutinent": [
        "agglutiner"
    ],
    "agglutiner": [
        "agglutiner"
    ],
    "agglutinez": [
        "agglutiner"
    ],
    "agglutinogene": [
        "agglutinogene"
    ],
    "agglutinerent": [
        "agglutiner"
    ],
    "agglutinee": [
        "agglutiner"
    ],
    "agglutinees": [
        "agglutiner"
    ],
    "agglutines": [
        "agglutiner"
    ],
    "aggrava": [
        "aggraver"
    ],
    "aggravai": [
        "aggraver"
    ],
    "aggravaient": [
        "aggraver"
    ],
    "aggravait": [
        "aggraver"
    ],
    "aggravant": [
        "aggraver"
    ],
    "aggravante": [
        "aggravant"
    ],
    "aggravantes": [
        "aggravant"
    ],
    "aggravation": [
        "aggravation"
    ],
    "aggrave": [
        "aggraver",
        "aggrave"
    ],
    "aggravent": [
        "aggraver"
    ],
    "aggraver": [
        "aggraver"
    ],
    "aggravera": [
        "aggraver"
    ],
    "aggraverait": [
        "aggraver"
    ],
    "aggraveriez": [
        "aggraver"
    ],
    "aggravez": [
        "aggraver"
    ],
    "aggraviez": [
        "aggraver"
    ],
    "aggravons": [
        "aggraver"
    ],
    "aggraverent": [
        "aggraver"
    ],
    "aggravee": [
        "aggraver",
        "aggravee"
    ],
    "aggravees": [
        "aggraver"
    ],
    "aggraves": [
        "aggraver"
    ],
    "aghas": [
        "agha"
    ],
    "agi": [
        "agir"
    ],
    "agie": [
        "agir"
    ],
    "agile": [
        "agile"
    ],
    "agiles": [
        "agile"
    ],
    "agilite": [
        "agilite"
    ],
    "agilites": [
        "agilite"
    ],
    "agios": [
        "agio"
    ],
    "agioteur": [
        "agioteur"
    ],
    "agir": [
        "agir"
    ],
    "agira": [
        "agir"
    ],
    "agirai": [
        "agir"
    ],
    "agiraient": [
        "agir"
    ],
    "agirais": [
        "agir"
    ],
    "agirait": [
        "agir"
    ],
    "agiras": [
        "agir"
    ],
    "agirent": [
        "agir"
    ],
    "agirez": [
        "agir"
    ],
    "agiriez": [
        "agir"
    ],
    "agirons": [
        "agir"
    ],
    "agiront": [
        "agir"
    ],
    "agis": [
        "agir"
    ],
    "agissaient": [
        "agir"
    ],
    "agissais": [
        "agir"
    ],
    "agissait": [
        "agir"
    ],
    "agissant": [
        "agissant",
        "agir"
    ],
    "agissante": [
        "agissant"
    ],
    "agissantes": [
        "agissant"
    ],
    "agisse": [
        "agir"
    ],
    "agissement": [
        "agissement"
    ],
    "agissements": [
        "agissement"
    ],
    "agissent": [
        "agir"
    ],
    "agisses": [
        "agir"
    ],
    "agissez": [
        "agir"
    ],
    "agissiez": [
        "agir"
    ],
    "agissions": [
        "agir"
    ],
    "agissons": [
        "agir"
    ],
    "agit": [
        "agir"
    ],
    "agita": [
        "agiter"
    ],
    "agitai": [
        "agiter"
    ],
    "agitaient": [
        "agiter"
    ],
    "agitais": [
        "agiter"
    ],
    "agitait": [
        "agiter"
    ],
    "agitant": [
        "agitant",
        "agiter"
    ],
    "agitassent": [
        "agiter"
    ],
    "agitateur": [
        "agitateur"
    ],
    "agitateurs": [
        "agitateur"
    ],
    "agitation": [
        "agitation"
    ],
    "agitations": [
        "agitation"
    ],
    "agitato": [
        "agitato"
    ],
    "agitatrice": [
        "agitateur"
    ],
    "agite": [
        "agite",
        "agiter"
    ],
    "agitent": [
        "agiter"
    ],
    "agiter": [
        "agiter"
    ],
    "agitera": [
        "agiter"
    ],
    "agiterai": [
        "agiter"
    ],
    "agiterait": [
        "agiter"
    ],
    "agiteront": [
        "agiter"
    ],
    "agites": [
        "agite",
        "agiter"
    ],
    "agitez": [
        "agiter"
    ],
    "agitiez": [
        "agiter"
    ],
    "agitions": [
        "agiter"
    ],
    "agitons": [
        "agiter"
    ],
    "agitat": [
        "agiter"
    ],
    "agiterent": [
        "agiter"
    ],
    "agitee": [
        "agite",
        "agiter"
    ],
    "agitees": [
        "agite",
        "agiter"
    ],
    "aglagla": [
        "aglagla"
    ],
    "agnat": [
        "agnat"
    ],
    "agnathes": [
        "agnathe"
    ],
    "agneau": [
        "agneau"
    ],
    "agneaux": [
        "agneau"
    ],
    "agnela": [
        "agneler"
    ],
    "agnelage": [
        "agnelage"
    ],
    "agnelet": [
        "agnelet"
    ],
    "agneline": [
        "agneline"
    ],
    "agnelle": [
        "agnel"
    ],
    "agnelles": [
        "agnel"
    ],
    "agnosie": [
        "agnosie"
    ],
    "agnostique": [
        "agnostique"
    ],
    "agnostiques": [
        "agnostique"
    ],
    "agonie": [
        "agonie",
        "agonir"
    ],
    "agonies": [
        "agonie",
        "agony"
    ],
    "agonique": [
        "agonique"
    ],
    "agoniques": [
        "agonique"
    ],
    "agonir": [
        "agonir"
    ],
    "agonirent": [
        "agonir"
    ],
    "agonisa": [
        "agoniser"
    ],
    "agonisai": [
        "agoniser"
    ],
    "agonisaient": [
        "agoniser"
    ],
    "agonisais": [
        "agoniser"
    ],
    "agonisait": [
        "agoniser"
    ],
    "agonisant": [
        "agonisant",
        "agoniser"
    ],
    "agonisante": [
        "agonisant"
    ],
    "agonisantes": [
        "agonisant"
    ],
    "agonisants": [
        "agonisant"
    ],
    "agonise": [
        "agoniser"
    ],
    "agonisent": [
        "agoniser"
    ],
    "agoniser": [
        "agoniser"
    ],
    "agonisez": [
        "agoniser"
    ],
    "agonisiez": [
        "agoniser"
    ],
    "agonissait": [
        "agonir"
    ],
    "agoniste": [
        "agoniste"
    ],
    "agonit": [
        "agonir"
    ],
    "agora": [
        "agora"
    ],
    "agoraphobe": [
        "agoraphobe"
    ],
    "agoraphobes": [
        "agoraphobe"
    ],
    "agoraphobie": [
        "agoraphobie"
    ],
    "agouti": [
        "agouti"
    ],
    "agoutis": [
        "agouti"
    ],
    "agoyate": [
        "agoyate"
    ],
    "agoyates": [
        "agoyate"
    ],
    "agrafa": [
        "agrafer"
    ],
    "agrafage": [
        "agrafage"
    ],
    "agrafait": [
        "agrafer"
    ],
    "agrafant": [
        "agrafer"
    ],
    "agrafe": [
        "agrafer",
        "agrafe"
    ],
    "agrafent": [
        "agrafer"
    ],
    "agrafer": [
        "agrafer"
    ],
    "agraferai": [
        "agrafer"
    ],
    "agrafes": [
        "agrafer",
        "agrafe"
    ],
    "agrafeur": [
        "agrafeur"
    ],
    "agrafeuse": [
        "agrafeuse"
    ],
    "agrafeuses": [
        "agrafeuse"
    ],
    "agrafez": [
        "agrafer"
    ],
    "agrafons": [
        "agrafer"
    ],
    "agrafee": [
        "agrafer"
    ],
    "agrafees": [
        "agrafer"
    ],
    "agrainage": [
        "agrainage"
    ],
    "agraire": [
        "agraire"
    ],
    "agraires": [
        "agraire"
    ],
    "agrandi": [
        "agrandir"
    ],
    "agrandie": [
        "agrandir"
    ],
    "agrandies": [
        "agrandir"
    ],
    "agrandir": [
        "agrandir"
    ],
    "agrandira": [
        "agrandir"
    ],
    "agrandirai": [
        "agrandir"
    ],
    "agrandirait": [
        "agrandir"
    ],
    "agrandirent": [
        "agrandir"
    ],
    "agrandiront": [
        "agrandir"
    ],
    "agrandis": [
        "agrandir"
    ],
    "agrandissaient": [
        "agrandir"
    ],
    "agrandissait": [
        "agrandir"
    ],
    "agrandissant": [
        "agrandir"
    ],
    "agrandissement": [
        "agrandissement"
    ],
    "agrandissements": [
        "agrandissement"
    ],
    "agrandissent": [
        "agrandir"
    ],
    "agrandisseur": [
        "agrandisseur"
    ],
    "agrandisseurs": [
        "agrandisseur"
    ],
    "agrandissez": [
        "agrandir"
    ],
    "agrandissons": [
        "agrandir"
    ],
    "agrandit": [
        "agrandir"
    ],
    "agranulocytose": [
        "agranulocytose"
    ],
    "agrarien": [
        "agrarien"
    ],
    "agressa": [
        "agresser"
    ],
    "agressaient": [
        "agresser"
    ],
    "agressais": [
        "agresser"
    ],
    "agressait": [
        "agresser"
    ],
    "agressant": [
        "agresser"
    ],
    "agresse": [
        "agresser"
    ],
    "agressent": [
        "agresser"
    ],
    "agresser": [
        "agresser"
    ],
    "agresseraient": [
        "agresser"
    ],
    "agresserait": [
        "agresser"
    ],
    "agresseur": [
        "agresseur"
    ],
    "agresseurs": [
        "agresseur"
    ],
    "agressez": [
        "agresser"
    ],
    "agressif": [
        "agressif"
    ],
    "agressifs": [
        "agressif"
    ],
    "agression": [
        "agression"
    ],
    "agressions": [
        "agresser",
        "agression"
    ],
    "agressive": [
        "agressif"
    ],
    "agressivement": [
        "agressivement"
    ],
    "agressives": [
        "agressif"
    ],
    "agressivite": [
        "agressivite"
    ],
    "agressivites": [
        "agressivite"
    ],
    "agressee": [
        "agresser"
    ],
    "agressees": [
        "agresser"
    ],
    "agresses": [
        "agresser"
    ],
    "agreste": [
        "agreste"
    ],
    "agrestes": [
        "agreste"
    ],
    "agriche": [
        "agricher"
    ],
    "agriches": [
        "agricher"
    ],
    "agricole": [
        "agricole"
    ],
    "agricoles": [
        "agricole"
    ],
    "agriculteur": [
        "agriculteur"
    ],
    "agriculteurs": [
        "agriculteur"
    ],
    "agricultrice": [
        "agriculteur"
    ],
    "agricultrices": [
        "agriculteur"
    ],
    "agriculture": [
        "agriculture"
    ],
    "agrippa": [
        "agripper"
    ],
    "agrippai": [
        "agripper"
    ],
    "agrippaient": [
        "agripper"
    ],
    "agrippais": [
        "agripper"
    ],
    "agrippait": [
        "agripper"
    ],
    "agrippant": [
        "agrippant",
        "agripper"
    ],
    "agrippants": [
        "agrippant"
    ],
    "agrippe": [
        "agripper"
    ],
    "agrippement": [
        "agrippement"
    ],
    "agrippent": [
        "agripper"
    ],
    "agripper": [
        "agripper"
    ],
    "agrippes": [
        "agripper"
    ],
    "agrippez": [
        "agripper"
    ],
    "agrippions": [
        "agripper"
    ],
    "agripperent": [
        "agripper"
    ],
    "agrippee": [
        "agripper"
    ],
    "agrippees": [
        "agripper"
    ],
    "agro": [
        "agro"
    ],
    "agroalimentaire": [
        "agroalimentaire"
    ],
    "agronome": [
        "agronome"
    ],
    "agronomes": [
        "agronome"
    ],
    "agronomie": [
        "agronomie"
    ],
    "agronomique": [
        "agronomique"
    ],
    "agrovilles": [
        "agroville"
    ],
    "agrume": [
        "agrume"
    ],
    "agrumes": [
        "agrume"
    ],
    "agrege": [
        "agreger",
        "agrege"
    ],
    "agregent": [
        "agreger"
    ],
    "agres": [
        "agres"
    ],
    "agrea": [
        "agreer"
    ],
    "agreable": [
        "agreable"
    ],
    "agreablement": [
        "agreablement"
    ],
    "agreables": [
        "agreable"
    ],
    "agreaient": [
        "agreer"
    ],
    "agreais": [
        "agreer"
    ],
    "agreait": [
        "agreer"
    ],
    "agree": [
        "agree",
        "agreer"
    ],
    "agreent": [
        "agreer"
    ],
    "agreer": [
        "agreer"
    ],
    "agreera": [
        "agreer"
    ],
    "agreerait": [
        "agreer"
    ],
    "agrees": [
        "agree",
        "agreer"
    ],
    "agreez": [
        "agreer"
    ],
    "agreg": [
        "agreg"
    ],
    "agregat": [
        "agregat"
    ],
    "agregatif": [
        "agregatif"
    ],
    "agregatifs": [
        "agregatif"
    ],
    "agregation": [
        "agregation"
    ],
    "agregative": [
        "agregative"
    ],
    "agregats": [
        "agregat"
    ],
    "agregeaient": [
        "agreger"
    ],
    "agregeait": [
        "agreger"
    ],
    "agreger": [
        "agreger"
    ],
    "agregee": [
        "agreger",
        "agrege"
    ],
    "agregees": [
        "agreger",
        "agrege"
    ],
    "agreges": [
        "agreger",
        "agrege"
    ],
    "agreions": [
        "agreer"
    ],
    "agrement": [
        "agrement"
    ],
    "agrementa": [
        "agrementer"
    ],
    "agrementaient": [
        "agrementer"
    ],
    "agrementait": [
        "agrementer"
    ],
    "agrementant": [
        "agrementer"
    ],
    "agremente": [
        "agremente",
        "agrementer"
    ],
    "agrementent": [
        "agrementer"
    ],
    "agrementer": [
        "agrementer"
    ],
    "agrements": [
        "agrement"
    ],
    "agrementee": [
        "agremente",
        "agrementer"
    ],
    "agrementees": [
        "agrementer"
    ],
    "agrementes": [
        "agrementer"
    ],
    "agreee": [
        "agree",
        "agreer"
    ],
    "agreees": [
        "agreer"
    ],
    "aguardiente": [
        "aguardiente"
    ],
    "aguerri": [
        "aguerri",
        "aguerrir"
    ],
    "aguerrie": [
        "aguerri",
        "aguerrir"
    ],
    "aguerries": [
        "aguerri",
        "aguerrir"
    ],
    "aguerrir": [
        "aguerrir"
    ],
    "aguerrira": [
        "aguerrir"
    ],
    "aguerris": [
        "aguerri",
        "aguerrir"
    ],
    "aguerrissait": [
        "aguerrir"
    ],
    "aguerrit": [
        "aguerrir"
    ],
    "aguichage": [
        "aguichage"
    ],
    "aguichait": [
        "aguicher"
    ],
    "aguichant": [
        "aguichant"
    ],
    "aguichante": [
        "aguichant"
    ],
    "aguichantes": [
        "aguichant"
    ],
    "aguiche": [
        "aguiche",
        "aguicher"
    ],
    "aguichent": [
        "aguicher"
    ],
    "aguicher": [
        "aguicher"
    ],
    "aguicheur": [
        "aguicheur"
    ],
    "aguicheurs": [
        "aguicheur"
    ],
    "aguicheuse": [
        "aguicheur"
    ],
    "aguicheuses": [
        "aguicheur"
    ],
    "aguillera": [
        "aguiller"
    ],
    "ah": [
        "ah"
    ],
    "ahan": [
        "ahan"
    ],
    "ahana": [
        "ahaner"
    ],
    "ahanaient": [
        "ahaner"
    ],
    "ahanait": [
        "ahaner"
    ],
    "ahanant": [
        "ahaner",
        "ahanant"
    ],
    "ahanante": [
        "ahanant"
    ],
    "ahane": [
        "ahaner"
    ],
    "ahanement": [
        "ahanement"
    ],
    "ahanements": [
        "ahanement"
    ],
    "ahanent": [
        "ahaner"
    ],
    "ahaner": [
        "ahaner"
    ],
    "ahans": [
        "ahan"
    ],
    "ahi": [
        "ahi"
    ],
    "ahou": [
        "ahou"
    ],
    "ahuri": [
        "ahuri",
        "ahurir"
    ],
    "ahurie": [
        "ahuri"
    ],
    "ahuries": [
        "ahuri",
        "ahurir"
    ],
    "ahurir": [
        "ahurir"
    ],
    "ahuris": [
        "ahuri",
        "ahurir"
    ],
    "ahurissait": [
        "ahurir"
    ],
    "ahurissant": [
        "ahurissant",
        "ahurir"
    ],
    "ahurissante": [
        "ahurissant"
    ],
    "ahurissantes": [
        "ahurissant"
    ],
    "ahurissants": [
        "ahurissant"
    ],
    "ahurissement": [
        "ahurissement"
    ],
    "ahurissements": [
        "ahurissement"
    ],
    "ahurit": [
        "ahurir"
    ],
    "ai": [
        "avoir",
        "ai"
    ],
    "aicher": [
        "aicher"
    ],
    "aida": [
        "aider"
    ],
    "aidai": [
        "aider"
    ],
    "aidaient": [
        "aider"
    ],
    "aidais": [
        "aider"
    ],
    "aidait": [
        "aider"
    ],
    "aidant": [
        "aider"
    ],
    "aidassent": [
        "aider"
    ],
    "aide": [
        "aide",
        "aider"
    ],
    "aident": [
        "aider"
    ],
    "aider": [
        "aider"
    ],
    "aidera": [
        "aider"
    ],
    "aiderai": [
        "aider"
    ],
    "aideraient": [
        "aider"
    ],
    "aiderais": [
        "aider"
    ],
    "aiderait": [
        "aider"
    ],
    "aideras": [
        "aider"
    ],
    "aiderez": [
        "aider"
    ],
    "aideriez": [
        "aider"
    ],
    "aiderions": [
        "aider"
    ],
    "aiderons": [
        "aider"
    ],
    "aideront": [
        "aider"
    ],
    "aides": [
        "aide",
        "aider"
    ],
    "aidez": [
        "aider"
    ],
    "aidiez": [
        "aider"
    ],
    "aidions": [
        "aider"
    ],
    "aidons": [
        "aider"
    ],
    "aidat": [
        "aider"
    ],
    "aiderent": [
        "aider"
    ],
    "aidee": [
        "aider"
    ],
    "aidees": [
        "aider"
    ],
    "aie": [
        "avoir",
        "aie"
    ],
    "aient": [
        "avoir"
    ],
    "aies": [
        "avoir"
    ],
    "aigle": [
        "aigle"
    ],
    "aiglefin": [
        "aiglefin"
    ],
    "aigles": [
        "aigle"
    ],
    "aiglon": [
        "aiglon"
    ],
    "aiglons": [
        "aiglon"
    ],
    "aigre": [
        "aigre"
    ],
    "aigrelet": [
        "aigrelet"
    ],
    "aigrelets": [
        "aigrelet"
    ],
    "aigrelette": [
        "aigrelet"
    ],
    "aigrelettes": [
        "aigrelet"
    ],
    "aigrement": [
        "aigrement"
    ],
    "aigres": [
        "aigre"
    ],
    "aigrette": [
        "aigret",
        "aigrette"
    ],
    "aigrettes": [
        "aigret",
        "aigrette"
    ],
    "aigreur": [
        "aigreur"
    ],
    "aigreurs": [
        "aigreur"
    ],
    "aigri": [
        "aigrir",
        "aigri"
    ],
    "aigrie": [
        "aigrir",
        "aigri"
    ],
    "aigries": [
        "aigri"
    ],
    "aigrir": [
        "aigrir"
    ],
    "aigrirent": [
        "aigrir"
    ],
    "aigris": [
        "aigrir",
        "aigri"
    ],
    "aigrissaient": [
        "aigrir"
    ],
    "aigrissait": [
        "aigrir"
    ],
    "aigrissent": [
        "aigrir"
    ],
    "aigrit": [
        "aigrir"
    ],
    "aigu": [
        "aigu"
    ],
    "aiguade": [
        "aiguade"
    ],
    "aiguail": [
        "aiguail"
    ],
    "aigue": [
        "aigu",
        "aiguer"
    ],
    "aiguilla": [
        "aiguiller"
    ],
    "aiguillage": [
        "aiguillage"
    ],
    "aiguillages": [
        "aiguillage"
    ],
    "aiguillant": [
        "aiguiller"
    ],
    "aiguillat": [
        "aiguillat"
    ],
    "aiguille": [
        "aiguiller",
        "aiguille"
    ],
    "aiguiller": [
        "aiguiller"
    ],
    "aiguilles": [
        "aiguiller",
        "aiguille"
    ],
    "aiguillettes": [
        "aiguillette"
    ],
    "aiguilleur": [
        "aiguilleur"
    ],
    "aiguilleurs": [
        "aiguilleur"
    ],
    "aiguillon": [
        "aiguillon"
    ],
    "aiguillonnaient": [
        "aiguillonner"
    ],
    "aiguillonnait": [
        "aiguillonner"
    ],
    "aiguillonnant": [
        "aiguillonner"
    ],
    "aiguillonnante": [
        "aiguillonnant"
    ],
    "aiguillonne": [
        "aiguillonner"
    ],
    "aiguillonnent": [
        "aiguillonner"
    ],
    "aiguillonner": [
        "aiguillonner"
    ],
    "aiguillonnee": [
        "aiguillonner"
    ],
    "aiguillonnees": [
        "aiguillonner"
    ],
    "aiguillonnes": [
        "aiguillonner"
    ],
    "aiguillons": [
        "aiguillon",
        "aiguiller"
    ],
    "aiguillee": [
        "aiguillee",
        "aiguiller"
    ],
    "aiguillees": [
        "aiguillee",
        "aiguiller"
    ],
    "aiguisa": [
        "aiguiser"
    ],
    "aiguisai": [
        "aiguiser"
    ],
    "aiguisaient": [
        "aiguiser"
    ],
    "aiguisait": [
        "aiguiser"
    ],
    "aiguisant": [
        "aiguiser"
    ],
    "aiguisas": [
        "aiguiser"
    ],
    "aiguise": [
        "aiguise",
        "aiguiser"
    ],
    "aiguisent": [
        "aiguiser"
    ],
    "aiguiser": [
        "aiguiser"
    ],
    "aiguisera": [
        "aiguiser"
    ],
    "aiguiserai": [
        "aiguiser"
    ],
    "aiguiseur": [
        "aiguiseur"
    ],
    "aiguisez": [
        "aiguiser"
    ],
    "aiguisoir": [
        "aiguisoir"
    ],
    "aiguisons": [
        "aiguiser"
    ],
    "aiguiserent": [
        "aiguiser"
    ],
    "aiguisee": [
        "aiguise",
        "aiguiser"
    ],
    "aiguisees": [
        "aiguise",
        "aiguiser"
    ],
    "aiguises": [
        "aiguise",
        "aiguiser"
    ],
    "aiguiere": [
        "aiguiere"
    ],
    "aigus": [
        "aigu"
    ],
    "aigues": [
        "aigu"
    ],
    "ail": [
        "ail"
    ],
    "aile": [
        "ailer",
        "aile"
    ],
    "aileron": [
        "aileron"
    ],
    "ailerons": [
        "aileron"
    ],
    "ailes": [
        "ailer",
        "aile"
    ],
    "ailette": [
        "ailette"
    ],
    "ailettes": [
        "ailette"
    ],
    "ailier": [
        "ailier"
    ],
    "ailiers": [
        "ailier"
    ],
    "aillais": [
        "ailler"
    ],
    "aille": [
        "aller",
        "ailler"
    ],
    "aillent": [
        "aller"
    ],
    "ailler": [
        "ailler"
    ],
    "ailles": [
        "aller",
        "ailler"
    ],
    "ailleurs": [
        "ailleurs"
    ],
    "aillions": [
        "ailler"
    ],
    "aillons": [
        "ailler"
    ],
    "aillee": [
        "ailler"
    ],
    "ailee": [
        "aile",
        "ailer"
    ],
    "ailees": [
        "aile",
        "ailer"
    ],
    "aima": [
        "aimer"
    ],
    "aimable": [
        "aimable"
    ],
    "aimablement": [
        "aimablement"
    ],
    "aimables": [
        "aimable"
    ],
    "aimai": [
        "aimer"
    ],
    "aimaient": [
        "aimer"
    ],
    "aimais": [
        "aimer"
    ],
    "aimait": [
        "aimer"
    ],
    "aimant": [
        "aimant",
        "aimer"
    ],
    "aimantaient": [
        "aimanter"
    ],
    "aimantait": [
        "aimanter"
    ],
    "aimantation": [
        "aimantation"
    ],
    "aimante": [
        "aimant",
        "aimanter"
    ],
    "aimanter": [
        "aimanter"
    ],
    "aimantes": [
        "aimant",
        "aimanter"
    ],
    "aimants": [
        "aimant"
    ],
    "aimantee": [
        "aimanter"
    ],
    "aimantees": [
        "aimanter"
    ],
    "aimasse": [
        "aimer"
    ],
    "aimassent": [
        "aimer"
    ],
    "aimassions": [
        "aimer"
    ],
    "aime": [
        "aime",
        "aimer"
    ],
    "aiment": [
        "aimer"
    ],
    "aimer": [
        "aimer"
    ],
    "aimera": [
        "aimer"
    ],
    "aimerai": [
        "aimer"
    ],
    "aimeraient": [
        "aimer"
    ],
    "aimerais": [
        "aimer"
    ],
    "aimerait": [
        "aimer"
    ],
    "aimeras": [
        "aimer"
    ],
    "aimerez": [
        "aimer"
    ],
    "aimeriez": [
        "aimer"
    ],
    "aimerions": [
        "aimer"
    ],
    "aimerons": [
        "aimer"
    ],
    "aimeront": [
        "aimer"
    ],
    "aimes": [
        "aime",
        "aimer"
    ],
    "aimeuse": [
        "aimeur"
    ],
    "aimez": [
        "aimer"
    ],
    "aimiez": [
        "aimer"
    ],
    "aimions": [
        "aimer"
    ],
    "aimons": [
        "aimer"
    ],
    "aimames": [
        "aimer"
    ],
    "aimat": [
        "aimer"
    ],
    "aimates": [
        "aimer"
    ],
    "aimerent": [
        "aimer"
    ],
    "aimee": [
        "aime",
        "aimer"
    ],
    "aimees": [
        "aime",
        "aimer"
    ],
    "aine": [
        "ain",
        "aine"
    ],
    "aines": [
        "aine"
    ],
    "ains": [
        "ains"
    ],
    "ainsi": [
        "ainsi"
    ],
    "air": [
        "air"
    ],
    "airain": [
        "airain"
    ],
    "airbag": [
        "airbag"
    ],
    "airbags": [
        "airbag"
    ],
    "airbus": [
        "airbus"
    ],
    "aire": [
        "aire"
    ],
    "airedale": [
        "airedale"
    ],
    "airelle": [
        "airelle"
    ],
    "airelles": [
        "airelle"
    ],
    "aires": [
        "aire"
    ],
    "airs": [
        "air"
    ],
    "ais": [
        "ai",
        "ais"
    ],
    "aisance": [
        "aisance"
    ],
    "aisances": [
        "aisance"
    ],
    "aise": [
        "aise"
    ],
    "aises": [
        "aise"
    ],
    "aisseau": [
        "aisseau"
    ],
    "aisselle": [
        "aisselle"
    ],
    "aisselles": [
        "aisselle"
    ],
    "aisee": [
        "aise"
    ],
    "aisees": [
        "aise"
    ],
    "aisement": [
        "aisement"
    ],
    "ait": [
        "avoir"
    ],
    "aixois": [
        "aixois"
    ],
    "ajaccienne": [
        "ajaccienne"
    ],
    "ajax": [
        "ajax"
    ],
    "ajistes": [
        "ajiste"
    ],
    "ajointer": [
        "ajointer"
    ],
    "ajointee": [
        "ajointer"
    ],
    "ajonc": [
        "ajonc"
    ],
    "ajoncs": [
        "ajonc"
    ],
    "ajouraient": [
        "ajourer"
    ],
    "ajourait": [
        "ajourer"
    ],
    "ajourant": [
        "ajourer"
    ],
    "ajourna": [
        "ajourner"
    ],
    "ajournait": [
        "ajourner"
    ],
    "ajourne": [
        "ajourne",
        "ajourner"
    ],
    "ajournement": [
        "ajournement"
    ],
    "ajournements": [
        "ajournement"
    ],
    "ajourner": [
        "ajourner"
    ],
    "ajournez": [
        "ajourner"
    ],
    "ajournee": [
        "ajourne",
        "ajourner"
    ],
    "ajournes": [
        "ajourne",
        "ajourner"
    ],
    "ajours": [
        "ajour"
    ],
    "ajoure": [
        "ajourer",
        "ajoure"
    ],
    "ajouree": [
        "ajourer",
        "ajoure"
    ],
    "ajourees": [
        "ajourer",
        "ajoure"
    ],
    "ajoures": [
        "ajourer",
        "ajoure"
    ],
    "ajout": [
        "ajout"
    ],
    "ajouta": [
        "ajouter"
    ],
    "ajoutai": [
        "ajouter"
    ],
    "ajoutaient": [
        "ajouter"
    ],
    "ajoutais": [
        "ajouter"
    ],
    "ajoutait": [
        "ajouter"
    ],
    "ajoutant": [
        "ajouter"
    ],
    "ajoutassent": [
        "ajouter"
    ],
    "ajoute": [
        "ajoute",
        "ajouter"
    ],
    "ajoutent": [
        "ajouter"
    ],
    "ajouter": [
        "ajouter"
    ],
    "ajoutera": [
        "ajouter"
    ],
    "ajouterai": [
        "ajouter"
    ],
    "ajouteraient": [
        "ajouter"
    ],
    "ajouterais": [
        "ajouter"
    ],
    "ajouterait": [
        "ajouter"
    ],
    "ajouteras": [
        "ajouter"
    ],
    "ajouterez": [
        "ajouter"
    ],
    "ajouterons": [
        "ajouter"
    ],
    "ajouteront": [
        "ajouter"
    ],
    "ajoutes": [
        "ajoute",
        "ajouter"
    ],
    "ajoutez": [
        "ajouter"
    ],
    "ajoutiez": [
        "ajouter"
    ],
    "ajoutions": [
        "ajouter"
    ],
    "ajoutons": [
        "ajouter"
    ],
    "ajouts": [
        "ajout"
    ],
    "ajoutat": [
        "ajouter"
    ],
    "ajouterent": [
        "ajouter"
    ],
    "ajoutee": [
        "ajoute",
        "ajouter"
    ],
    "ajoutees": [
        "ajoute",
        "ajouter"
    ],
    "ajusta": [
        "ajuster"
    ],
    "ajustable": [
        "ajustable"
    ],
    "ajustables": [
        "ajustable"
    ],
    "ajustage": [
        "ajustage"
    ],
    "ajustaient": [
        "ajuster"
    ],
    "ajustais": [
        "ajuster"
    ],
    "ajustait": [
        "ajuster"
    ],
    "ajustant": [
        "ajuster"
    ],
    "ajuste": [
        "ajuste",
        "ajuster"
    ],
    "ajustement": [
        "ajustement"
    ],
    "ajustements": [
        "ajustement"
    ],
    "ajustent": [
        "ajuster"
    ],
    "ajuster": [
        "ajuster"
    ],
    "ajusterai": [
        "ajuster"
    ],
    "ajusteur": [
        "ajusteur"
    ],
    "ajusteurs": [
        "ajusteur"
    ],
    "ajustez": [
        "ajuster"
    ],
    "ajustons": [
        "ajuster"
    ],
    "ajusture": [
        "ajusture"
    ],
    "ajusterent": [
        "ajuster"
    ],
    "ajustee": [
        "ajuste",
        "ajuster"
    ],
    "ajustees": [
        "ajuste",
        "ajuster"
    ],
    "ajustes": [
        "ajuste",
        "ajuster"
    ],
    "ajutage": [
        "ajutage"
    ],
    "akkadien": [
        "akkadien"
    ],
    "akkadienne": [
        "akkadienne"
    ],
    "ako": [
        "ako"
    ],
    "akvavit": [
        "akvavit"
    ],
    "alabandines": [
        "alabandine"
    ],
    "alacrite": [
        "alacrite"
    ],
    "alain": [
        "alain"
    ],
    "alaire": [
        "alaire"
    ],
    "alaise": [
        "alaise"
    ],
    "alambic": [
        "alambic"
    ],
    "alambics": [
        "alambic"
    ],
    "alambique": [
        "alambiquer"
    ],
    "alambiquee": [
        "alambiquer",
        "alambique"
    ],
    "alambiquees": [
        "alambique"
    ],
    "alambiques": [
        "alambique"
    ],
    "alangui": [
        "alanguir",
        "alangui"
    ],
    "alanguie": [
        "alanguir",
        "alangui"
    ],
    "alanguies": [
        "alanguir",
        "alangui"
    ],
    "alanguir": [
        "alanguir"
    ],
    "alanguis": [
        "alanguir",
        "alangui"
    ],
    "alanguissaient": [
        "alanguir"
    ],
    "alanguissait": [
        "alanguir"
    ],
    "alanguissant": [
        "alanguir"
    ],
    "alanguissante": [
        "alanguissant"
    ],
    "alanguissement": [
        "alanguissement"
    ],
    "alanguissements": [
        "alanguissement"
    ],
    "alanguissent": [
        "alanguir"
    ],
    "alanguit": [
        "alanguir"
    ],
    "alarma": [
        "alarmer"
    ],
    "alarmai": [
        "alarmer"
    ],
    "alarmaient": [
        "alarmer"
    ],
    "alarmait": [
        "alarmer"
    ],
    "alarmant": [
        "alarmant",
        "alarmer"
    ],
    "alarmante": [
        "alarmant"
    ],
    "alarmantes": [
        "alarmant"
    ],
    "alarmants": [
        "alarmant"
    ],
    "alarme": [
        "alarme",
        "alarmer"
    ],
    "alarmer": [
        "alarmer"
    ],
    "alarmeraient": [
        "alarmer"
    ],
    "alarmerait": [
        "alarmer"
    ],
    "alarmes": [
        "alarme",
        "alarmer"
    ],
    "alarmez": [
        "alarmer"
    ],
    "alarmisme": [
        "alarmisme"
    ],
    "alarmiste": [
        "alarmiste"
    ],
    "alarmistes": [
        "alarmiste"
    ],
    "alarmee": [
        "alarmer"
    ],
    "alarmees": [
        "alarmer"
    ],
    "alba": [
        "alba"
    ],
    "albacore": [
        "albacore"
    ],
    "albanais": [
        "albanais"
    ],
    "albanaise": [
        "albanais"
    ],
    "albanaises": [
        "albanais"
    ],
    "albanophone": [
        "albanophone"
    ],
    "albatros": [
        "albatros"
    ],
    "albe": [
        "albe"
    ],
    "albertine": [
        "albertine"
    ],
    "albigeois": [
        "albigeois"
    ],
    "albinisme": [
        "albinisme"
    ],
    "albinos": [
        "albinos"
    ],
    "alboche": [
        "alboche"
    ],
    "albugo": [
        "albugo"
    ],
    "album": [
        "album"
    ],
    "albumine": [
        "albumine"
    ],
    "albumines": [
        "albumine"
    ],
    "albumineuse": [
        "albumineux"
    ],
    "albums": [
        "album"
    ],
    "albatre": [
        "albatre"
    ],
    "albatres": [
        "albatre"
    ],
    "albene": [
        "albene"
    ],
    "alcade": [
        "alcade"
    ],
    "alcalde": [
        "alcalde"
    ],
    "alcali": [
        "alcali"
    ],
    "alcalin": [
        "alcalin"
    ],
    "alcaline": [
        "alcalin"
    ],
    "alcalines": [
        "alcalin"
    ],
    "alcaliniser": [
        "alcaliniser"
    ],
    "alcalinite": [
        "alcalinite"
    ],
    "alcalins": [
        "alcalin"
    ],
    "alcalis": [
        "alcali"
    ],
    "alcalose": [
        "alcalose"
    ],
    "alcaloide": [
        "alcaloide"
    ],
    "alcatraz": [
        "alcatraz"
    ],
    "alcazar": [
        "alcazar"
    ],
    "alchimie": [
        "alchimie"
    ],
    "alchimies": [
        "alchimie"
    ],
    "alchimique": [
        "alchimique"
    ],
    "alchimiques": [
        "alchimique"
    ],
    "alchimiste": [
        "alchimiste"
    ],
    "alchimistes": [
        "alchimiste"
    ],
    "alcibiade": [
        "alcibiade"
    ],
    "alcool": [
        "alcool"
    ],
    "alcoolique": [
        "alcoolique"
    ],
    "alcooliques": [
        "alcoolique"
    ],
    "alcoolise": [
        "alcooliser",
        "alcoolise"
    ],
    "alcoolisme": [
        "alcoolisme"
    ],
    "alcoolisee": [
        "alcooliser",
        "alcoolise"
    ],
    "alcoolisees": [
        "alcooliser",
        "alcoolise"
    ],
    "alcoolises": [
        "alcooliser",
        "alcoolise"
    ],
    "alcoolo": [
        "alcoolo"
    ],
    "alcoolos": [
        "alcoolo"
    ],
    "alcools": [
        "alcool"
    ],
    "alcoolemie": [
        "alcoolemie"
    ],
    "alcoometre": [
        "alcoometre"
    ],
    "alcootest": [
        "alcootest"
    ],
    "alcoran": [
        "alcoran"
    ],
    "alcyon": [
        "alcyon"
    ],
    "alcyons": [
        "alcyon"
    ],
    "alcees": [
        "alcee"
    ],
    "alcove": [
        "alcove"
    ],
    "alcoves": [
        "alcove"
    ],
    "alde": [
        "alde"
    ],
    "alderman": [
        "alderman"
    ],
    "aldol": [
        "aldol"
    ],
    "aldehyde": [
        "aldehyde"
    ],
    "ale": [
        "ale"
    ],
    "alenti": [
        "alentir"
    ],
    "alentie": [
        "alentir"
    ],
    "alenties": [
        "alentir"
    ],
    "alentis": [
        "alentir"
    ],
    "alentour": [
        "alentour"
    ],
    "alentours": [
        "alentour"
    ],
    "alenconnais": [
        "alenconnais"
    ],
    "alenconnaise": [
        "alenconnais"
    ],
    "aleph": [
        "aleph"
    ],
    "alerta": [
        "alerter"
    ],
    "alertait": [
        "alerter"
    ],
    "alertant": [
        "alerter"
    ],
    "alerte": [
        "alerte",
        "alerter"
    ],
    "alertement": [
        "alertement"
    ],
    "alertent": [
        "alerter"
    ],
    "alerter": [
        "alerter"
    ],
    "alertera": [
        "alerter"
    ],
    "alerterai": [
        "alerter"
    ],
    "alerterais": [
        "alerter"
    ],
    "alerterait": [
        "alerter"
    ],
    "alerterez": [
        "alerter"
    ],
    "alerteront": [
        "alerter"
    ],
    "alertes": [
        "alerte",
        "alerter"
    ],
    "alertez": [
        "alerter"
    ],
    "alertions": [
        "alerter"
    ],
    "alertons": [
        "alerter"
    ],
    "alertat": [
        "alerter"
    ],
    "alerterent": [
        "alerter"
    ],
    "alertee": [
        "alerte",
        "alerter"
    ],
    "alertees": [
        "alerte",
        "alerter"
    ],
    "alevin": [
        "alevin"
    ],
    "alevins": [
        "alevin"
    ],
    "alexandra": [
        "alexandra"
    ],
    "alexandrin": [
        "alexandrin"
    ],
    "alexandrine": [
        "alexandrin"
    ],
    "alexandrines": [
        "alexandrin"
    ],
    "alexandrins": [
        "alexandrin"
    ],
    "alexie": [
        "alexie"
    ],
    "alexithymie": [
        "alexithymie"
    ],
    "alezan": [
        "alezan"
    ],
    "alezane": [
        "alezan"
    ],
    "alezanes": [
        "alezan"
    ],
    "alezans": [
        "alezan"
    ],
    "alfa": [
        "alfa"
    ],
    "alfas": [
        "alfa"
    ],
    "alfenides": [
        "alfenide"
    ],
    "algarade": [
        "algarade"
    ],
    "algarades": [
        "algarade"
    ],
    "algie": [
        "algie"
    ],
    "algonquin": [
        "algonquin"
    ],
    "algonquines": [
        "algonquin"
    ],
    "algorithme": [
        "algorithme"
    ],
    "algorithmes": [
        "algorithme"
    ],
    "algorithmique": [
        "algorithmique"
    ],
    "algue": [
        "algue"
    ],
    "algues": [
        "algue"
    ],
    "algebre": [
        "algebre"
    ],
    "algebrique": [
        "algebrique"
    ],
    "algebriquement": [
        "algebriquement"
    ],
    "algebriques": [
        "algebrique"
    ],
    "algebriste": [
        "algebriste"
    ],
    "algebristes": [
        "algebriste"
    ],
    "algerien": [
        "algerien"
    ],
    "algerienne": [
        "algerien"
    ],
    "algeriennes": [
        "algerien"
    ],
    "algeriens": [
        "algerien"
    ],
    "algerois": [
        "algerois"
    ],
    "algeroise": [
        "algerois"
    ],
    "alhambra": [
        "alhambra"
    ],
    "alias": [
        "alias"
    ],
    "alibi": [
        "alibi"
    ],
    "alibis": [
        "alibi"
    ],
    "alidade": [
        "alidade"
    ],
    "aligna": [
        "aligner"
    ],
    "alignaient": [
        "aligner"
    ],
    "alignais": [
        "aligner"
    ],
    "alignait": [
        "aligner"
    ],
    "alignant": [
        "aligner"
    ],
    "aligne": [
        "aligner",
        "aligne"
    ],
    "alignement": [
        "alignement"
    ],
    "alignements": [
        "alignement"
    ],
    "alignent": [
        "aligner"
    ],
    "aligner": [
        "aligner"
    ],
    "alignera": [
        "aligner"
    ],
    "aligneraient": [
        "aligner"
    ],
    "alignerez": [
        "aligner"
    ],
    "alignerons": [
        "aligner"
    ],
    "aligneront": [
        "aligner"
    ],
    "alignes": [
        "aligner",
        "aligne"
    ],
    "alignez": [
        "aligner"
    ],
    "alignons": [
        "aligner"
    ],
    "alignerent": [
        "aligner"
    ],
    "alignee": [
        "aligner",
        "aligne"
    ],
    "alignees": [
        "aligner",
        "aligne"
    ],
    "aligot": [
        "aligot"
    ],
    "aligote": [
        "aligote"
    ],
    "alim": [
        "alim"
    ],
    "aliment": [
        "aliment"
    ],
    "alimenta": [
        "alimenter"
    ],
    "alimentaient": [
        "alimenter"
    ],
    "alimentaire": [
        "alimentaire"
    ],
    "alimentaires": [
        "alimentaire"
    ],
    "alimentais": [
        "alimenter"
    ],
    "alimentait": [
        "alimenter"
    ],
    "alimentant": [
        "alimenter"
    ],
    "alimentation": [
        "alimentation"
    ],
    "alimentations": [
        "alimentation"
    ],
    "alimente": [
        "alimenter"
    ],
    "alimentent": [
        "alimenter"
    ],
    "alimenter": [
        "alimenter"
    ],
    "alimentera": [
        "alimenter"
    ],
    "alimentez": [
        "alimenter"
    ],
    "alimentons": [
        "alimenter"
    ],
    "aliments": [
        "aliment"
    ],
    "alimenterent": [
        "alimenter"
    ],
    "alimentee": [
        "alimenter"
    ],
    "alimentees": [
        "alimenter"
    ],
    "alimentes": [
        "alimenter"
    ],
    "alinea": [
        "alinea"
    ],
    "alineas": [
        "alinea"
    ],
    "alise": [
        "alise"
    ],
    "alises": [
        "alise"
    ],
    "alisier": [
        "alisier"
    ],
    "alita": [
        "aliter"
    ],
    "alitai": [
        "aliter"
    ],
    "alitait": [
        "aliter"
    ],
    "alitement": [
        "alitement"
    ],
    "aliter": [
        "aliter"
    ],
    "alite": [
        "aliter"
    ],
    "alitee": [
        "aliter"
    ],
    "alitees": [
        "aliter"
    ],
    "alize": [
        "alize"
    ],
    "alizes": [
        "alize"
    ],
    "aliene": [
        "aliener",
        "aliene"
    ],
    "aliena": [
        "aliener"
    ],
    "alienant": [
        "aliener",
        "alienant"
    ],
    "alienante": [
        "alienant"
    ],
    "alienation": [
        "alienation"
    ],
    "aliener": [
        "aliener"
    ],
    "alienerait": [
        "aliener"
    ],
    "alienerez": [
        "aliener"
    ],
    "alieniez": [
        "aliener"
    ],
    "alieniste": [
        "alieniste"
    ],
    "alienat": [
        "aliener"
    ],
    "alienee": [
        "aliener",
        "aliene"
    ],
    "alienees": [
        "aliener"
    ],
    "alienes": [
        "aliener",
        "aliene"
    ],
    "alkali": [
        "alkali"
    ],
    "alla": [
        "aller"
    ],
    "allai": [
        "aller"
    ],
    "allaient": [
        "aller"
    ],
    "allais": [
        "aller"
    ],
    "allait": [
        "aller"
    ],
    "allaitais": [
        "allaiter"
    ],
    "allaitait": [
        "allaiter"
    ],
    "allaitant": [
        "allaitant",
        "allaiter"
    ],
    "allaitante": [
        "allaitant"
    ],
    "allaitantes": [
        "allaitant"
    ],
    "allaite": [
        "allaiter"
    ],
    "allaitement": [
        "allaitement"
    ],
    "allaitent": [
        "allaiter"
    ],
    "allaiter": [
        "allaiter"
    ],
    "allaiterait": [
        "allaiter"
    ],
    "allaitee": [
        "allaiter"
    ],
    "allaites": [
        "allaiter"
    ],
    "allant": [
        "aller",
        "allant"
    ],
    "allante": [
        "allant"
    ],
    "allas": [
        "aller"
    ],
    "allassent": [
        "aller"
    ],
    "allegretto": [
        "allegretto"
    ],
    "allegro": [
        "allegro"
    ],
    "allemagne": [
        "allemagne"
    ],
    "allemand": [
        "allemand"
    ],
    "allemande": [
        "allemand"
    ],
    "allemandes": [
        "allemand"
    ],
    "allemands": [
        "allemand"
    ],
    "aller": [
        "aller"
    ],
    "allergie": [
        "allergie"
    ],
    "allergies": [
        "allergie",
        "allergy"
    ],
    "allergique": [
        "allergique"
    ],
    "allergiques": [
        "allergique"
    ],
    "allergologie": [
        "allergologie"
    ],
    "allergologue": [
        "allergologue"
    ],
    "allergene": [
        "allergene"
    ],
    "allergenes": [
        "allergene"
    ],
    "allers": [
        "aller"
    ],
    "allez": [
        "aller"
    ],
    "allia": [
        "allier"
    ],
    "alliace": [
        "alliace"
    ],
    "alliage": [
        "alliage"
    ],
    "alliages": [
        "alliage"
    ],
    "alliait": [
        "allier"
    ],
    "alliance": [
        "alliance"
    ],
    "alliances": [
        "alliance"
    ],
    "alliant": [
        "allier"
    ],
    "allie": [
        "allie",
        "allier"
    ],
    "allient": [
        "allier"
    ],
    "allier": [
        "aller",
        "allier"
    ],
    "alliera": [
        "allier"
    ],
    "allierait": [
        "allier"
    ],
    "alliez": [
        "aller"
    ],
    "alligator": [
        "alligator"
    ],
    "alligators": [
        "alligator"
    ],
    "allions": [
        "aller"
    ],
    "alliteratif": [
        "alliteratif"
    ],
    "alliteration": [
        "alliteration"
    ],
    "alliterations": [
        "alliteration"
    ],
    "allium": [
        "allium"
    ],
    "alliat": [
        "allier"
    ],
    "alliee": [
        "allie",
        "allier"
    ],
    "alliees": [
        "allie",
        "allier"
    ],
    "allies": [
        "allie",
        "allier",
        "ally"
    ],
    "allo": [
        "allo"
    ],
    "allobarbital": [
        "allobarbital"
    ],
    "allobroges": [
        "allobroge"
    ],
    "alloc": [
        "alloc"
    ],
    "allocataires": [
        "allocataire"
    ],
    "allocation": [
        "allocation"
    ],
    "allocations": [
        "allocations",
        "allocation"
    ],
    "allochtone": [
        "allochtone"
    ],
    "allocs": [
        "alloc"
    ],
    "allocution": [
        "allocution"
    ],
    "allocutions": [
        "allocution"
    ],
    "allogreffe": [
        "allogreffe"
    ],
    "allogenes": [
        "allogene"
    ],
    "allonge": [
        "allonge",
        "allonger"
    ],
    "allongea": [
        "allonger"
    ],
    "allongeai": [
        "allonger"
    ],
    "allongeaient": [
        "allonger"
    ],
    "allongeais": [
        "allonger"
    ],
    "allongeait": [
        "allonger"
    ],
    "allongeant": [
        "allonger"
    ],
    "allongement": [
        "allongement"
    ],
    "allongent": [
        "allonger"
    ],
    "allongeons": [
        "allonger"
    ],
    "allonger": [
        "allonger"
    ],
    "allongera": [
        "allonger"
    ],
    "allongerai": [
        "allonger"
    ],
    "allongeraient": [
        "allonger"
    ],
    "allongerais": [
        "allonger"
    ],
    "allongerait": [
        "allonger"
    ],
    "allongeras": [
        "allonger"
    ],
    "allonges": [
        "allonge",
        "allonger"
    ],
    "allongez": [
        "allonger"
    ],
    "allongeames": [
        "allonger"
    ],
    "allongeat": [
        "allonger"
    ],
    "allongiez": [
        "allonger"
    ],
    "allongions": [
        "allonger"
    ],
    "allongerent": [
        "allonger"
    ],
    "allongee": [
        "allonge",
        "allonger"
    ],
    "allongees": [
        "allonge",
        "allonger"
    ],
    "allons": [
        "aller"
    ],
    "allopathie": [
        "allopathie"
    ],
    "allosterique": [
        "allosterique"
    ],
    "alloua": [
        "allouer"
    ],
    "allouait": [
        "allouer"
    ],
    "allouant": [
        "allouer"
    ],
    "alloue": [
        "allouer"
    ],
    "allouer": [
        "allouer"
    ],
    "allouerait": [
        "allouer"
    ],
    "allouee": [
        "allouer"
    ],
    "alloues": [
        "allouer"
    ],
    "alluma": [
        "allumer"
    ],
    "allumage": [
        "allumage"
    ],
    "allumai": [
        "allumer"
    ],
    "allumaient": [
        "allumer"
    ],
    "allumais": [
        "allumer"
    ],
    "allumait": [
        "allumer"
    ],
    "allumant": [
        "allumer"
    ],
    "allume": [
        "allume",
        "allumer"
    ],
    "allument": [
        "allumer"
    ],
    "allumer": [
        "allumer"
    ],
    "allumera": [
        "allumer"
    ],
    "allumerai": [
        "allumer"
    ],
    "allumeraient": [
        "allumer"
    ],
    "allumerais": [
        "allumer"
    ],
    "allumerait": [
        "allumer"
    ],
    "allumeras": [
        "allumer"
    ],
    "allumerons": [
        "allumer"
    ],
    "allumeront": [
        "allumer"
    ],
    "allumes": [
        "allume",
        "allumer"
    ],
    "allumette": [
        "allumette"
    ],
    "allumettes": [
        "allumette"
    ],
    "allumeur": [
        "allumeur"
    ],
    "allumeurs": [
        "allumeur"
    ],
    "allumeuse": [
        "allumeur"
    ],
    "allumeuses": [
        "allumeur"
    ],
    "allumez": [
        "allumer"
    ],
    "allumiez": [
        "allumer"
    ],
    "allumions": [
        "allumer"
    ],
    "allumoir": [
        "allumoir"
    ],
    "allumons": [
        "allumer"
    ],
    "allumames": [
        "allumer"
    ],
    "allumat": [
        "allumer"
    ],
    "allumerent": [
        "allumer"
    ],
    "allumee": [
        "allume",
        "allumer"
    ],
    "allumees": [
        "allume",
        "allumer"
    ],
    "allure": [
        "allure"
    ],
    "allures": [
        "allure"
    ],
    "allusif": [
        "allusif"
    ],
    "allusifs": [
        "allusif"
    ],
    "allusion": [
        "allusion"
    ],
    "allusionne": [
        "allusionner"
    ],
    "allusions": [
        "allusion"
    ],
    "allusive": [
        "allusif"
    ],
    "allusivement": [
        "allusivement"
    ],
    "allusives": [
        "allusif"
    ],
    "alluvion": [
        "alluvion"
    ],
    "alluvions": [
        "alluvion"
    ],
    "allames": [
        "aller"
    ],
    "allat": [
        "aller"
    ],
    "alleche": [
        "allecher"
    ],
    "allege": [
        "alleger"
    ],
    "allegement": [
        "allegement"
    ],
    "allegent": [
        "alleger"
    ],
    "allegre": [
        "allegre"
    ],
    "allegrement": [
        "allegrement"
    ],
    "allegres": [
        "allegre"
    ],
    "allegue": [
        "alleguer"
    ],
    "allele": [
        "allele"
    ],
    "allerent": [
        "aller"
    ],
    "alle": [
        "aller"
    ],
    "allecha": [
        "allecher"
    ],
    "allechait": [
        "allecher"
    ],
    "allechant": [
        "allechant",
        "allecher"
    ],
    "allechante": [
        "allechant"
    ],
    "allechantes": [
        "allechant"
    ],
    "allechants": [
        "allechant"
    ],
    "allecher": [
        "allecher"
    ],
    "allecherait": [
        "allecher"
    ],
    "allechee": [
        "allecher"
    ],
    "alleches": [
        "allecher"
    ],
    "allee": [
        "aller",
        "allee"
    ],
    "allees": [
        "aller",
        "allee"
    ],
    "allegation": [
        "allegation"
    ],
    "allegations": [
        "allegation"
    ],
    "allegea": [
        "alleger"
    ],
    "allegeaient": [
        "alleger"
    ],
    "allegeais": [
        "alleger"
    ],
    "allegeait": [
        "alleger"
    ],
    "allegeance": [
        "allegeance"
    ],
    "allegeances": [
        "allegeance"
    ],
    "allegeant": [
        "alleger"
    ],
    "allegements": [
        "allegement"
    ],
    "alleger": [
        "alleger"
    ],
    "allegera": [
        "alleger"
    ],
    "allegerait": [
        "alleger"
    ],
    "allegez": [
        "alleger"
    ],
    "allegorie": [
        "allegorie"
    ],
    "allegories": [
        "allegorie",
        "allegory"
    ],
    "allegorique": [
        "allegorique"
    ],
    "allegoriquement": [
        "allegoriquement"
    ],
    "allegoriques": [
        "allegorique"
    ],
    "allegorise": [
        "allegoriser"
    ],
    "allegresse": [
        "allegresse"
    ],
    "allegresses": [
        "allegresse"
    ],
    "allegua": [
        "alleguer"
    ],
    "alleguaient": [
        "alleguer"
    ],
    "alleguais": [
        "alleguer"
    ],
    "alleguait": [
        "alleguer"
    ],
    "alleguant": [
        "alleguer"
    ],
    "alleguer": [
        "alleguer"
    ],
    "alleguera": [
        "alleguer"
    ],
    "alleguee": [
        "alleguer"
    ],
    "allegee": [
        "alleger"
    ],
    "allegees": [
        "alleger"
    ],
    "alleges": [
        "alleger",
        "allege"
    ],
    "alleluia": [
        "alleluia"
    ],
    "alleluias": [
        "alleluia"
    ],
    "alles": [
        "aller"
    ],
    "alma": [
        "alma"
    ],
    "almanach": [
        "almanach"
    ],
    "almanachs": [
        "almanach"
    ],
    "almohade": [
        "almohade"
    ],
    "almohades": [
        "almohade"
    ],
    "almee": [
        "almee"
    ],
    "almees": [
        "almee"
    ],
    "aloi": [
        "aloi"
    ],
    "alopecie": [
        "alopecie"
    ],
    "alors": [
        "alors"
    ],
    "alose": [
        "alose"
    ],
    "aloses": [
        "alose"
    ],
    "alouette": [
        "alouette"
    ],
    "alouettes": [
        "alouette"
    ],
    "alourdi": [
        "alourdir"
    ],
    "alourdie": [
        "alourdir"
    ],
    "alourdies": [
        "alourdir"
    ],
    "alourdir": [
        "alourdir"
    ],
    "alourdirai": [
        "alourdir"
    ],
    "alourdiraient": [
        "alourdir"
    ],
    "alourdirent": [
        "alourdir"
    ],
    "alourdis": [
        "alourdir"
    ],
    "alourdissaient": [
        "alourdir"
    ],
    "alourdissait": [
        "alourdir"
    ],
    "alourdissant": [
        "alourdir"
    ],
    "alourdissement": [
        "alourdissement"
    ],
    "alourdissent": [
        "alourdir"
    ],
    "alourdit": [
        "alourdir"
    ],
    "aloyau": [
        "aloyau"
    ],
    "aloes": [
        "aloes"
    ],
    "alpa": [
        "alper"
    ],
    "alpaga": [
        "alpaga"
    ],
    "alpage": [
        "alpage"
    ],
    "alpages": [
        "alpage"
    ],
    "alpaguait": [
        "alpaguer"
    ],
    "alpague": [
        "alpaguer"
    ],
    "alpaguent": [
        "alpaguer"
    ],
    "alpaguer": [
        "alpaguer"
    ],
    "alpaguerait": [
        "alpaguer"
    ],
    "alpaguee": [
        "alpaguer"
    ],
    "alpagues": [
        "alpaguer"
    ],
    "alpe": [
        "alpe"
    ],
    "alpenstock": [
        "alpenstock"
    ],
    "alpes": [
        "alpe"
    ],
    "alpestre": [
        "alpestre"
    ],
    "alpestres": [
        "alpestre"
    ],
    "alpha": [
        "alpha"
    ],
    "alphabet": [
        "alphabet"
    ],
    "alphabets": [
        "alphabet"
    ],
    "alphabetique": [
        "alphabetique"
    ],
    "alphabetiquement": [
        "alphabetiquement"
    ],
    "alphabetisation": [
        "alphabetisation"
    ],
    "alphabetiser": [
        "alphabetiser"
    ],
    "alphabetise": [
        "alphabetise"
    ],
    "alphanumerique": [
        "alphanumerique"
    ],
    "alpin": [
        "alpin"
    ],
    "alpine": [
        "alpin"
    ],
    "alpines": [
        "alpin",
        "alpine"
    ],
    "alpinisme": [
        "alpinisme"
    ],
    "alpiniste": [
        "alpiniste"
    ],
    "alpinistes": [
        "alpiniste"
    ],
    "alpins": [
        "alpin"
    ],
    "alsacien": [
        "alsacien"
    ],
    "alsacienne": [
        "alsacien"
    ],
    "alsaciennes": [
        "alsacien"
    ],
    "alsaciens": [
        "alsacien"
    ],
    "alstonia": [
        "alstonia"
    ],
    "alter": [
        "alter"
    ],
    "altercation": [
        "altercation"
    ],
    "altercations": [
        "altercation"
    ],
    "alterna": [
        "alterner"
    ],
    "alternaient": [
        "alterner"
    ],
    "alternait": [
        "alterner"
    ],
    "alternance": [
        "alternance"
    ],
    "alternances": [
        "alternance"
    ],
    "alternant": [
        "alterner",
        "alternant"
    ],
    "alternateur": [
        "alternateur"
    ],
    "alternatif": [
        "alternatif"
    ],
    "alternatifs": [
        "alternatif"
    ],
    "alternative": [
        "alternative",
        "alternatif"
    ],
    "alternativement": [
        "alternativement"
    ],
    "alternatives": [
        "alternative",
        "alternatif"
    ],
    "alterne": [
        "alterne",
        "alterner"
    ],
    "alternent": [
        "alterner"
    ],
    "alterner": [
        "alterner"
    ],
    "alternera": [
        "alterner"
    ],
    "alternez": [
        "alterner"
    ],
    "alternions": [
        "alterner"
    ],
    "alternerent": [
        "alterner"
    ],
    "alternee": [
        "alterne",
        "alterner"
    ],
    "alternees": [
        "alterne",
        "alterner"
    ],
    "alternes": [
        "alterne",
        "alterner"
    ],
    "altesse": [
        "altesse"
    ],
    "altesses": [
        "altesse"
    ],
    "althaea": [
        "althaea"
    ],
    "altier": [
        "altier"
    ],
    "altiers": [
        "altier"
    ],
    "altimetre": [
        "altimetre"
    ],
    "altimetres": [
        "altimetre"
    ],
    "altitude": [
        "altitude"
    ],
    "altitudes": [
        "altitude"
    ],
    "altiere": [
        "altier"
    ],
    "altierement": [
        "altierement"
    ],
    "altieres": [
        "altier"
    ],
    "alto": [
        "alto"
    ],
    "altos": [
        "alto"
    ],
    "altruisme": [
        "altruisme"
    ],
    "altruiste": [
        "altruiste"
    ],
    "altruistes": [
        "altruiste"
    ],
    "altuglas": [
        "altuglas"
    ],
    "altere": [
        "altere",
        "alterer"
    ],
    "alterent": [
        "alterer"
    ],
    "altera": [
        "alterer"
    ],
    "alterable": [
        "alterable"
    ],
    "alteraient": [
        "alterer"
    ],
    "alterait": [
        "alterer"
    ],
    "alterant": [
        "alterer"
    ],
    "alteration": [
        "alteration"
    ],
    "alterations": [
        "alteration"
    ],
    "alterer": [
        "alterer"
    ],
    "alterera": [
        "alterer"
    ],
    "altereront": [
        "alterer"
    ],
    "alterez": [
        "alterer"
    ],
    "alteriez": [
        "alterer"
    ],
    "alterite": [
        "alterite"
    ],
    "alterat": [
        "alterer"
    ],
    "altererent": [
        "alterer"
    ],
    "alteree": [
        "altere",
        "alterer"
    ],
    "alterees": [
        "altere",
        "alterer"
    ],
    "alteres": [
        "altere",
        "alterer"
    ],
    "alu": [
        "alu"
    ],
    "aludes": [
        "alude"
    ],
    "aluette": [
        "aluette"
    ],
    "aluminium": [
        "aluminium"
    ],
    "alun": [
        "alun"
    ],
    "aluni": [
        "alunir"
    ],
    "alunir": [
        "alunir"
    ],
    "alunira": [
        "alunir"
    ],
    "alunissage": [
        "alunissage"
    ],
    "alunissages": [
        "alunissage"
    ],
    "alvar": [
        "alvar"
    ],
    "alvin": [
        "alvin"
    ],
    "alveolaire": [
        "alveolaire"
    ],
    "alveole": [
        "alveole"
    ],
    "alveoles": [
        "alveole"
    ],
    "alveolee": [
        "alveole"
    ],
    "alveolees": [
        "alveole"
    ],
    "alysse": [
        "alysse"
    ],
    "alene": [
        "alene"
    ],
    "alese": [
        "alese"
    ],
    "aleze": [
        "aleze"
    ],
    "alea": [
        "alea"
    ],
    "aleas": [
        "alea"
    ],
    "aleatoire": [
        "aleatoire"
    ],
    "aleatoirement": [
        "aleatoirement"
    ],
    "aleatoires": [
        "aleatoire"
    ],
    "alemaniques": [
        "alemanique"
    ],
    "aleoutien": [
        "aleoutien"
    ],
    "alesait": [
        "aleser"
    ],
    "aleser": [
        "aleser"
    ],
    "amabilite": [
        "amabilite"
    ],
    "amabilites": [
        "amabilite"
    ],
    "amadou": [
        "amadou"
    ],
    "amadoua": [
        "amadouer"
    ],
    "amadouaient": [
        "amadouer"
    ],
    "amadouait": [
        "amadouer"
    ],
    "amadouant": [
        "amadouer"
    ],
    "amadoue": [
        "amadouer"
    ],
    "amadouer": [
        "amadouer"
    ],
    "amadoueras": [
        "amadouer"
    ],
    "amadouez": [
        "amadouer"
    ],
    "amaigri": [
        "amaigri",
        "amaigrir"
    ],
    "amaigrie": [
        "amaigri",
        "amaigrir"
    ],
    "amaigries": [
        "amaigri",
        "amaigrir"
    ],
    "amaigris": [
        "amaigri"
    ],
    "amaigrissait": [
        "amaigrir"
    ],
    "amaigrissant": [
        "amaigrissant"
    ],
    "amaigrissante": [
        "amaigrissant"
    ],
    "amaigrissantes": [
        "amaigrissant"
    ],
    "amaigrissants": [
        "amaigrissant"
    ],
    "amaigrissement": [
        "amaigrissement"
    ],
    "amaigrit": [
        "amaigrir"
    ],
    "amalfitaine": [
        "amalfitain"
    ],
    "amalgamaient": [
        "amalgamer"
    ],
    "amalgamais": [
        "amalgamer"
    ],
    "amalgamait": [
        "amalgamer"
    ],
    "amalgamant": [
        "amalgamer"
    ],
    "amalgame": [
        "amalgame",
        "amalgamer"
    ],
    "amalgamer": [
        "amalgamer"
    ],
    "amalgames": [
        "amalgame",
        "amalgamer"
    ],
    "amalgamez": [
        "amalgamer"
    ],
    "amalgamee": [
        "amalgamer"
    ],
    "amalgamees": [
        "amalgamer"
    ],
    "aman": [
        "aman"
    ],
    "amande": [
        "amande"
    ],
    "amandes": [
        "amande"
    ],
    "amandier": [
        "amandier"
    ],
    "amandiers": [
        "amandier"
    ],
    "amandine": [
        "amandine"
    ],
    "amandines": [
        "amandine"
    ],
    "amanite": [
        "amanite"
    ],
    "amanites": [
        "amanite"
    ],
    "amant": [
        "amant"
    ],
    "amante": [
        "amante"
    ],
    "amantes": [
        "amante"
    ],
    "amants": [
        "amant"
    ],
    "amarante": [
        "amarante"
    ],
    "amarantes": [
        "amarante"
    ],
    "amaro": [
        "amaro"
    ],
    "amarra": [
        "amarrer"
    ],
    "amarrage": [
        "amarrage"
    ],
    "amarrages": [
        "amarrage"
    ],
    "amarrai": [
        "amarrer"
    ],
    "amarraient": [
        "amarrer"
    ],
    "amarrais": [
        "amarrer"
    ],
    "amarrait": [
        "amarrer"
    ],
    "amarrant": [
        "amarrer"
    ],
    "amarre": [
        "amarre",
        "amarrer"
    ],
    "amarrent": [
        "amarrer"
    ],
    "amarrer": [
        "amarrer"
    ],
    "amarres": [
        "amarre",
        "amarrer"
    ],
    "amarrez": [
        "amarrer"
    ],
    "amarree": [
        "amarrer"
    ],
    "amarrees": [
        "amarrer"
    ],
    "amaryllis": [
        "amaryllis"
    ],
    "amas": [
        "amas"
    ],
    "amassa": [
        "amasser"
    ],
    "amassai": [
        "amasser"
    ],
    "amassaient": [
        "amasser"
    ],
    "amassait": [
        "amasser"
    ],
    "amassant": [
        "amasser"
    ],
    "amasse": [
        "amasser"
    ],
    "amassent": [
        "amasser"
    ],
    "amasser": [
        "amasser"
    ],
    "amassera": [
        "amasser"
    ],
    "amassez": [
        "amasser"
    ],
    "amassons": [
        "amasser"
    ],
    "amasserent": [
        "amasser"
    ],
    "amassee": [
        "amasser"
    ],
    "amassees": [
        "amasser"
    ],
    "amasses": [
        "amass",
        "amasser"
    ],
    "amateur": [
        "amateur"
    ],
    "amateurisme": [
        "amateurisme"
    ],
    "amateurs": [
        "amateur"
    ],
    "amati": [
        "amatir"
    ],
    "amatrice": [
        "amateur"
    ],
    "amaurose": [
        "amaurose"
    ],
    "amazone": [
        "amazone"
    ],
    "amazones": [
        "amazone"
    ],
    "amazonien": [
        "amazonien"
    ],
    "amazonienne": [
        "amazonien"
    ],
    "amazoniennes": [
        "amazonien"
    ],
    "ambages": [
        "ambages"
    ],
    "ambassade": [
        "ambassade"
    ],
    "ambassades": [
        "ambassade"
    ],
    "ambassadeur": [
        "ambassadeur"
    ],
    "ambassadeurs": [
        "ambassadeur"
    ],
    "ambassadrice": [
        "ambassadeur"
    ],
    "ambassadrices": [
        "ambassadeur"
    ],
    "ambiance": [
        "ambiance"
    ],
    "ambiances": [
        "ambiance"
    ],
    "ambiant": [
        "ambiant"
    ],
    "ambiante": [
        "ambiant"
    ],
    "ambiantes": [
        "ambiant"
    ],
    "ambiants": [
        "ambiant"
    ],
    "ambidextre": [
        "ambidextre"
    ],
    "ambigu": [
        "ambigu"
    ],
    "ambigus": [
        "ambigu"
    ],
    "ambigue": [
        "ambigu"
    ],
    "ambigues": [
        "ambigu"
    ],
    "ambiguite": [
        "ambiguite"
    ],
    "ambiguites": [
        "ambiguite"
    ],
    "ambitieuse": [
        "ambitieux"
    ],
    "ambitieuses": [
        "ambitieuse",
        "ambitieux"
    ],
    "ambitieux": [
        "ambitieux"
    ],
    "ambition": [
        "ambition"
    ],
    "ambitionnais": [
        "ambitionner"
    ],
    "ambitionnait": [
        "ambitionner"
    ],
    "ambitionnant": [
        "ambitionner"
    ],
    "ambitionne": [
        "ambitionner"
    ],
    "ambitionnent": [
        "ambitionner"
    ],
    "ambitionner": [
        "ambitionner"
    ],
    "ambitionnez": [
        "ambitionner"
    ],
    "ambitions": [
        "ambition"
    ],
    "ambivalence": [
        "ambivalence"
    ],
    "ambivalences": [
        "ambivalence"
    ],
    "ambivalent": [
        "ambivalent"
    ],
    "ambivalente": [
        "ambivalent"
    ],
    "amble": [
        "amble"
    ],
    "ambler": [
        "ambler"
    ],
    "amboine": [
        "amboine"
    ],
    "ambon": [
        "ambon"
    ],
    "ambras": [
        "ambrer"
    ],
    "ambre": [
        "ambrer",
        "ambre"
    ],
    "ambrer": [
        "ambrer"
    ],
    "ambroisie": [
        "ambroisie"
    ],
    "ambree": [
        "ambre",
        "ambrer"
    ],
    "ambrees": [
        "ambre",
        "ambrer"
    ],
    "ambres": [
        "ambre",
        "ambrer"
    ],
    "ambulance": [
        "ambulance"
    ],
    "ambulances": [
        "ambulance"
    ],
    "ambulancier": [
        "ambulancier"
    ],
    "ambulanciers": [
        "ambulancier"
    ],
    "ambulanciere": [
        "ambulancier"
    ],
    "ambulancieres": [
        "ambulancier"
    ],
    "ambulant": [
        "ambulant"
    ],
    "ambulante": [
        "ambulant"
    ],
    "ambulantes": [
        "ambulant"
    ],
    "ambulants": [
        "ambulant"
    ],
    "ambulatoire": [
        "ambulatoire"
    ],
    "amen": [
        "amen"
    ],
    "amena": [
        "amener"
    ],
    "amenai": [
        "amener"
    ],
    "amenaient": [
        "amener"
    ],
    "amenais": [
        "amener"
    ],
    "amenait": [
        "amener"
    ],
    "amenant": [
        "amener"
    ],
    "amendai": [
        "amender"
    ],
    "amendait": [
        "amender"
    ],
    "amende": [
        "amende",
        "amender"
    ],
    "amendement": [
        "amendement"
    ],
    "amendements": [
        "amendement"
    ],
    "amendent": [
        "amender"
    ],
    "amender": [
        "amender"
    ],
    "amenderez": [
        "amender"
    ],
    "amendes": [
        "amende",
        "amender"
    ],
    "amendez": [
        "amender"
    ],
    "amendat": [
        "amender"
    ],
    "amendee": [
        "amender"
    ],
    "amener": [
        "amener"
    ],
    "amenez": [
        "amener"
    ],
    "ameniez": [
        "amener"
    ],
    "amenions": [
        "amener"
    ],
    "amenons": [
        "amener"
    ],
    "amenuisaient": [
        "amenuiser"
    ],
    "amenuisait": [
        "amenuiser"
    ],
    "amenuisant": [
        "amenuiser"
    ],
    "amenuise": [
        "amenuiser"
    ],
    "amenuisement": [
        "amenuisement"
    ],
    "amenuisent": [
        "amenuiser"
    ],
    "amenuiser": [
        "amenuiser"
    ],
    "amenuiserait": [
        "amenuiser"
    ],
    "amenuiserent": [
        "amenuiser"
    ],
    "amenuisee": [
        "amenuiser"
    ],
    "amenuises": [
        "amenuiser"
    ],
    "amenat": [
        "amener"
    ],
    "amenerent": [
        "amener"
    ],
    "amene": [
        "amener",
        "amene"
    ],
    "amenee": [
        "amenee",
        "amener"
    ],
    "amenees": [
        "amener"
    ],
    "amenes": [
        "amener",
        "amene"
    ],
    "amer": [
        "am",
        "amer"
    ],
    "amerlo": [
        "amerlo"
    ],
    "amerloque": [
        "amerloque"
    ],
    "amerloques": [
        "amerloque"
    ],
    "amerlos": [
        "amerlo"
    ],
    "amerri": [
        "amerrir"
    ],
    "amerrir": [
        "amerrir"
    ],
    "amerrissage": [
        "amerrissage"
    ],
    "amerrit": [
        "amerrir"
    ],
    "amers": [
        "amer"
    ],
    "amertume": [
        "amertume"
    ],
    "amertumes": [
        "amertume"
    ],
    "ameublement": [
        "ameublement"
    ],
    "ameublements": [
        "ameublement"
    ],
    "ameuta": [
        "ameuter"
    ],
    "ameutaient": [
        "ameuter"
    ],
    "ameutait": [
        "ameuter"
    ],
    "ameutant": [
        "ameuter"
    ],
    "ameute": [
        "ameuter"
    ],
    "ameutent": [
        "ameuter"
    ],
    "ameuter": [
        "ameuter"
    ],
    "ameutera": [
        "ameuter"
    ],
    "ameuterait": [
        "ameuter"
    ],
    "ameutat": [
        "ameuter"
    ],
    "ameutee": [
        "ameuter"
    ],
    "ameutees": [
        "ameuter"
    ],
    "ameutes": [
        "ameuter"
    ],
    "amharique": [
        "amharique"
    ],
    "ami": [
        "ami"
    ],
    "amiable": [
        "amiable"
    ],
    "amiante": [
        "amiante"
    ],
    "amibe": [
        "amibe"
    ],
    "amibes": [
        "amibe"
    ],
    "amibienne": [
        "amibien"
    ],
    "amical": [
        "amical"
    ],
    "amicale": [
        "amicale",
        "amical"
    ],
    "amicalement": [
        "amicalement"
    ],
    "amicales": [
        "amicale",
        "amical"
    ],
    "amicalites": [
        "amicalite"
    ],
    "amicaux": [
        "amical"
    ],
    "amidon": [
        "amidon"
    ],
    "amidonnaient": [
        "amidonner"
    ],
    "amidonnent": [
        "amidonner"
    ],
    "amidonner": [
        "amidonner"
    ],
    "amidonnez": [
        "amidonner"
    ],
    "amidonne": [
        "amidonner"
    ],
    "amidonnee": [
        "amidonner"
    ],
    "amidonnees": [
        "amidonner"
    ],
    "amidonnes": [
        "amidonner"
    ],
    "amie": [
        "ami"
    ],
    "amies": [
        "ami"
    ],
    "amignoter": [
        "amignoter"
    ],
    "amigo": [
        "amigo"
    ],
    "amigos": [
        "amigo"
    ],
    "aminci": [
        "aminci",
        "amincir"
    ],
    "amincie": [
        "aminci",
        "amincir"
    ],
    "amincies": [
        "aminci",
        "amincir"
    ],
    "amincir": [
        "amincir"
    ],
    "amincis": [
        "aminci"
    ],
    "amincissaient": [
        "amincir"
    ],
    "amincissait": [
        "amincir"
    ],
    "amincissant": [
        "amincissant",
        "amincir"
    ],
    "amincissante": [
        "amincissant"
    ],
    "amincissantes": [
        "amincissant"
    ],
    "amincissants": [
        "amincissant"
    ],
    "amincissement": [
        "amincissement"
    ],
    "amincissent": [
        "amincir"
    ],
    "amincit": [
        "amincir"
    ],
    "amine": [
        "amine"
    ],
    "aminoacides": [
        "aminoacide"
    ],
    "aminophylline": [
        "aminophylline"
    ],
    "amines": [
        "amine"
    ],
    "amiral": [
        "amiral"
    ],
    "amirale": [
        "amiral"
    ],
    "amiraute": [
        "amiraute"
    ],
    "amirautes": [
        "amiraute"
    ],
    "amiraux": [
        "amiral"
    ],
    "amis": [
        "ami"
    ],
    "amish": [
        "amish"
    ],
    "amitieuse": [
        "amitieux"
    ],
    "amitie": [
        "amitie"
    ],
    "amities": [
        "amitie"
    ],
    "ammoniac": [
        "ammoniac"
    ],
    "ammoniacale": [
        "ammoniacal"
    ],
    "ammoniacales": [
        "ammoniacal"
    ],
    "ammoniacaux": [
        "ammoniacal"
    ],
    "ammoniaque": [
        "ammoniaque"
    ],
    "ammoniaquee": [
        "ammoniaque"
    ],
    "ammoniaquees": [
        "ammoniaque"
    ],
    "ammonite": [
        "ammonite"
    ],
    "ammonitrate": [
        "ammonitrate"
    ],
    "ammonium": [
        "ammonium"
    ],
    "amniocentese": [
        "amniocentese"
    ],
    "amnios": [
        "amnios"
    ],
    "amniotique": [
        "amniotique"
    ],
    "amnistiable": [
        "amnistiable"
    ],
    "amnistiante": [
        "amnistiant"
    ],
    "amnistie": [
        "amnistie",
        "amnistier"
    ],
    "amnistier": [
        "amnistier"
    ],
    "amnistierons": [
        "amnistier"
    ],
    "amnisties": [
        "amnistie",
        "amnistier"
    ],
    "amnistiee": [
        "amnistie",
        "amnistier"
    ],
    "amnesie": [
        "amnesie"
    ],
    "amnesies": [
        "amnesie"
    ],
    "amnesique": [
        "amnesique"
    ],
    "amnesiques": [
        "amnesique"
    ],
    "amochait": [
        "amocher"
    ],
    "amoche": [
        "amocher"
    ],
    "amocher": [
        "amocher"
    ],
    "amochez": [
        "amocher"
    ],
    "amochie": [
        "amochir"
    ],
    "amochee": [
        "amocher"
    ],
    "amoches": [
        "amocher"
    ],
    "amoindri": [
        "amoindrir"
    ],
    "amoindrie": [
        "amoindrir"
    ],
    "amoindries": [
        "amoindrir"
    ],
    "amoindrir": [
        "amoindrir"
    ],
    "amoindrira": [
        "amoindrir"
    ],
    "amoindris": [
        "amoindrir"
    ],
    "amoindrissait": [
        "amoindrir"
    ],
    "amoindrissement": [
        "amoindrissement"
    ],
    "amoindrit": [
        "amoindrir"
    ],
    "amok": [
        "amok"
    ],
    "amolli": [
        "amollir"
    ],
    "amollie": [
        "amollir"
    ],
    "amollies": [
        "amollir"
    ],
    "amollir": [
        "amollir"
    ],
    "amollirent": [
        "amollir"
    ],
    "amollis": [
        "amollir"
    ],
    "amollissaient": [
        "amollir"
    ],
    "amollissait": [
        "amollir"
    ],
    "amollissant": [
        "amollissant",
        "amollir"
    ],
    "amollissement": [
        "amollissement"
    ],
    "amollissent": [
        "amollir"
    ],
    "amollit": [
        "amollir"
    ],
    "amoncelaient": [
        "amonceler"
    ],
    "amoncelait": [
        "amonceler"
    ],
    "amoncelant": [
        "amonceler"
    ],
    "amonceler": [
        "amonceler"
    ],
    "amoncelle": [
        "amonceler"
    ],
    "amoncellement": [
        "amoncellement"
    ],
    "amoncellements": [
        "amoncellement"
    ],
    "amoncellent": [
        "amonceler"
    ],
    "amoncelleraient": [
        "amonceler"
    ],
    "amoncelerent": [
        "amonceler"
    ],
    "amoncele": [
        "amonceler"
    ],
    "amoncelee": [
        "amonceler"
    ],
    "amoncelees": [
        "amonceler"
    ],
    "amonceles": [
        "amonceler"
    ],
    "amont": [
        "amont"
    ],
    "amontillado": [
        "amontillado"
    ],
    "amoral": [
        "amoral"
    ],
    "amorale": [
        "amoral"
    ],
    "amoraliste": [
        "amoraliste"
    ],
    "amoralite": [
        "amoralite"
    ],
    "amoraux": [
        "amoral"
    ],
    "amorce": [
        "amorcer",
        "amorce"
    ],
    "amorcent": [
        "amorcer"
    ],
    "amorcer": [
        "amorcer"
    ],
    "amorcerait": [
        "amorcer"
    ],
    "amorces": [
        "amorcer",
        "amorce"
    ],
    "amorcez": [
        "amorcer"
    ],
    "amorcerent": [
        "amorcer"
    ],
    "amorcee": [
        "amorcer"
    ],
    "amorcees": [
        "amorcer"
    ],
    "amoroso": [
        "amoroso"
    ],
    "amorphe": [
        "amorphe"
    ],
    "amorphes": [
        "amorphe"
    ],
    "amorti": [
        "amorti",
        "amortir"
    ],
    "amortie": [
        "amorti",
        "amortir"
    ],
    "amorties": [
        "amorti",
        "amortir"
    ],
    "amortir": [
        "amortir"
    ],
    "amortirent": [
        "amortir"
    ],
    "amortiront": [
        "amortir"
    ],
    "amortis": [
        "amorti",
        "amortir"
    ],
    "amortissaient": [
        "amortir"
    ],
    "amortissait": [
        "amortir"
    ],
    "amortissant": [
        "amortir"
    ],
    "amortisse": [
        "amortir"
    ],
    "amortissement": [
        "amortissement"
    ],
    "amortissent": [
        "amortir"
    ],
    "amortisseur": [
        "amortisseur"
    ],
    "amortisseurs": [
        "amortisseur"
    ],
    "amortit": [
        "amortir"
    ],
    "amorca": [
        "amorcer"
    ],
    "amorcage": [
        "amorcage"
    ],
    "amorcai": [
        "amorcer"
    ],
    "amorcaient": [
        "amorcer"
    ],
    "amorcais": [
        "amorcer"
    ],
    "amorcait": [
        "amorcer"
    ],
    "amorcant": [
        "amorcer"
    ],
    "amorcoir": [
        "amorcoir"
    ],
    "amorcons": [
        "amorcer"
    ],
    "amour": [
        "amour"
    ],
    "amouracha": [
        "amouracher"
    ],
    "amourache": [
        "amouracher"
    ],
    "amourachent": [
        "amouracher"
    ],
    "amouracher": [
        "amouracher"
    ],
    "amourachera": [
        "amouracher"
    ],
    "amouraches": [
        "amouracher"
    ],
    "amourachee": [
        "amouracher"
    ],
    "amourer": [
        "amourer"
    ],
    "amourette": [
        "amourette"
    ],
    "amourettes": [
        "amourette"
    ],
    "amoureuse": [
        "amoureux"
    ],
    "amoureusement": [
        "amoureusement"
    ],
    "amoureuses": [
        "amoureux"
    ],
    "amoureux": [
        "amoureux"
    ],
    "amours": [
        "amour"
    ],
    "amovible": [
        "amovible"
    ],
    "amovibles": [
        "amovible"
    ],
    "amphi": [
        "amphi"
    ],
    "amphibie": [
        "amphibie"
    ],
    "amphibien": [
        "amphibien"
    ],
    "amphibiens": [
        "amphibien"
    ],
    "amphibies": [
        "amphibie"
    ],
    "amphigouri": [
        "amphigouri"
    ],
    "amphigourique": [
        "amphigourique"
    ],
    "amphigouriques": [
        "amphigourique"
    ],
    "amphigouris": [
        "amphigouri"
    ],
    "amphis": [
        "amphi"
    ],
    "amphitheatre": [
        "amphitheatre"
    ],
    "amphitheatres": [
        "amphitheatre"
    ],
    "amphitrite": [
        "amphitrite"
    ],
    "amphitryon": [
        "amphitryon"
    ],
    "amphore": [
        "amphore"
    ],
    "amphores": [
        "amphore"
    ],
    "amphes": [
        "amphe"
    ],
    "amphetamine": [
        "amphetamine"
    ],
    "amphetamines": [
        "amphetamine"
    ],
    "ample": [
        "ample"
    ],
    "amplement": [
        "amplement"
    ],
    "amples": [
        "ample"
    ],
    "ampleur": [
        "ampleur"
    ],
    "ampleurs": [
        "ampleur"
    ],
    "ampli": [
        "ampli"
    ],
    "amplifia": [
        "amplifier"
    ],
    "amplifiaient": [
        "amplifier"
    ],
    "amplifiait": [
        "amplifier"
    ],
    "amplifiant": [
        "amplifier"
    ],
    "amplificateur": [
        "amplificateur"
    ],
    "amplificateurs": [
        "amplificateur"
    ],
    "amplification": [
        "amplification"
    ],
    "amplifications": [
        "amplification"
    ],
    "amplifie": [
        "amplifier"
    ],
    "amplifient": [
        "amplifier"
    ],
    "amplifier": [
        "amplifier"
    ],
    "amplifiera": [
        "amplifier"
    ],
    "amplifierais": [
        "amplifier"
    ],
    "amplifiez": [
        "amplifier"
    ],
    "amplifions": [
        "amplifier"
    ],
    "amplifierent": [
        "amplifier"
    ],
    "amplifiee": [
        "amplifier"
    ],
    "amplifiees": [
        "amplifier"
    ],
    "amplifies": [
        "amplifier",
        "amplify"
    ],
    "amplis": [
        "ampli"
    ],
    "amplitude": [
        "amplitude"
    ],
    "ampoule": [
        "ampoule"
    ],
    "ampoules": [
        "ampoule"
    ],
    "ampoulee": [
        "ampoule"
    ],
    "ampoulees": [
        "ampoule"
    ],
    "amputa": [
        "amputer"
    ],
    "amputait": [
        "amputer"
    ],
    "amputant": [
        "amputer"
    ],
    "amputation": [
        "amputation"
    ],
    "amputations": [
        "amputation"
    ],
    "ampute": [
        "amputer",
        "ampute"
    ],
    "amputent": [
        "amputer"
    ],
    "amputer": [
        "amputer"
    ],
    "amputerai": [
        "amputer"
    ],
    "amputerait": [
        "amputer"
    ],
    "amputez": [
        "amputer"
    ],
    "amputee": [
        "amputer",
        "ampute"
    ],
    "amputees": [
        "amputer",
        "ampute"
    ],
    "amputes": [
        "amputer",
        "ampute"
    ],
    "ampere": [
        "ampere"
    ],
    "amperemetre": [
        "amperemetre"
    ],
    "amperes": [
        "ampere"
    ],
    "ampelopsis": [
        "ampelopsis"
    ],
    "amperage": [
        "amperage"
    ],
    "amulette": [
        "amulette"
    ],
    "amulettes": [
        "amulette"
    ],
    "amura": [
        "amurer"
    ],
    "amure": [
        "amure"
    ],
    "amures": [
        "amure"
    ],
    "amusa": [
        "amuser"
    ],
    "amusai": [
        "amuser"
    ],
    "amusaient": [
        "amuser"
    ],
    "amusais": [
        "amuser"
    ],
    "amusait": [
        "amuser"
    ],
    "amusant": [
        "amusant",
        "amuser"
    ],
    "amusante": [
        "amusant"
    ],
    "amusantes": [
        "amusant"
    ],
    "amusants": [
        "amusant"
    ],
    "amuse": [
        "amuser"
    ],
    "amusement": [
        "amusement"
    ],
    "amusements": [
        "amusement"
    ],
    "amusent": [
        "amuser"
    ],
    "amuser": [
        "amuser"
    ],
    "amusera": [
        "amuser"
    ],
    "amuserai": [
        "amuser"
    ],
    "amuseraient": [
        "amuser"
    ],
    "amuserais": [
        "amuser"
    ],
    "amuserait": [
        "amuser"
    ],
    "amuseras": [
        "amuser"
    ],
    "amuserez": [
        "amuser"
    ],
    "amuseriez": [
        "amuser"
    ],
    "amuserons": [
        "amuser"
    ],
    "amuseront": [
        "amuser"
    ],
    "amuses": [
        "amuse",
        "amuser"
    ],
    "amusette": [
        "amusette"
    ],
    "amusettes": [
        "amusette"
    ],
    "amuseur": [
        "amuseur"
    ],
    "amuseurs": [
        "amuseur"
    ],
    "amusez": [
        "amuser"
    ],
    "amusiez": [
        "amuser"
    ],
    "amusions": [
        "amuser"
    ],
    "amusons": [
        "amuser"
    ],
    "amusames": [
        "amuser"
    ],
    "amusat": [
        "amuser"
    ],
    "amuserent": [
        "amuser"
    ],
    "amusee": [
        "amuser"
    ],
    "amusees": [
        "amuser"
    ],
    "amygdale": [
        "amygdale"
    ],
    "amygdalectomie": [
        "amygdalectomie"
    ],
    "amygdalectomies": [
        "amygdalectomie"
    ],
    "amygdales": [
        "amygdale"
    ],
    "amygdalien": [
        "amygdalien"
    ],
    "amygdalite": [
        "amygdalite"
    ],
    "amylase": [
        "amylase"
    ],
    "amyle": [
        "amyle"
    ],
    "amylique": [
        "amylique"
    ],
    "amyotrophique": [
        "amyotrophique"
    ],
    "amenent": [
        "amener"
    ],
    "amenera": [
        "amener"
    ],
    "amenerai": [
        "amener"
    ],
    "ameneraient": [
        "amener"
    ],
    "amenerais": [
        "amener"
    ],
    "amenerait": [
        "amener"
    ],
    "ameneras": [
        "amener"
    ],
    "amenerez": [
        "amener"
    ],
    "ameneriez": [
        "amener"
    ],
    "amenerions": [
        "amener"
    ],
    "amenerons": [
        "amener"
    ],
    "ameneront": [
        "amener"
    ],
    "amere": [
        "amer"
    ],
    "amerement": [
        "amerement"
    ],
    "ameres": [
        "amer"
    ],
    "ame": [
        "ame"
    ],
    "ameliora": [
        "ameliorer"
    ],
    "ameliorable": [
        "ameliorable"
    ],
    "amelioraient": [
        "ameliorer"
    ],
    "ameliorait": [
        "ameliorer"
    ],
    "ameliorant": [
        "ameliorer"
    ],
    "ameliorateur": [
        "ameliorateur"
    ],
    "amelioration": [
        "amelioration"
    ],
    "ameliorations": [
        "amelioration"
    ],
    "ameliore": [
        "ameliore",
        "ameliorer"
    ],
    "ameliorent": [
        "ameliorer"
    ],
    "ameliorer": [
        "ameliorer"
    ],
    "ameliorera": [
        "ameliorer"
    ],
    "ameliorerait": [
        "ameliorer"
    ],
    "amelioreront": [
        "ameliorer"
    ],
    "ameliores": [
        "ameliore",
        "ameliorer"
    ],
    "ameliorez": [
        "ameliorer"
    ],
    "ameliorons": [
        "ameliorer"
    ],
    "ameliorerent": [
        "ameliorer"
    ],
    "amelioree": [
        "ameliore",
        "ameliorer"
    ],
    "ameliorees": [
        "ameliore",
        "ameliorer"
    ],
    "amenage": [
        "amenager"
    ],
    "amenagea": [
        "amenager"
    ],
    "amenageai": [
        "amenager"
    ],
    "amenageaient": [
        "amenager"
    ],
    "amenageait": [
        "amenager"
    ],
    "amenageant": [
        "amenager"
    ],
    "amenagement": [
        "amenagement"
    ],
    "amenagements": [
        "amenagement"
    ],
    "amenagent": [
        "amenager"
    ],
    "amenager": [
        "amenager"
    ],
    "amenagerai": [
        "amenager"
    ],
    "amenagerait": [
        "amenager"
    ],
    "amenagez": [
        "amenager"
    ],
    "amenagerent": [
        "amenager"
    ],
    "amenagee": [
        "amenager"
    ],
    "amenagees": [
        "amenager"
    ],
    "amenages": [
        "amenager"
    ],
    "amenite": [
        "amenite"
    ],
    "amenites": [
        "amenite"
    ],
    "amenorrhee": [
        "amenorrhee"
    ],
    "americain": [
        "americain"
    ],
    "americaine": [
        "americain"
    ],
    "americaines": [
        "americain"
    ],
    "americains": [
        "americain"
    ],
    "americanisais": [
        "americaniser"
    ],
    "americanisation": [
        "americanisation"
    ],
    "americaniser": [
        "americaniser"
    ],
    "americanisme": [
        "americanisme"
    ],
    "americanismes": [
        "americanisme"
    ],
    "americanise": [
        "americaniser"
    ],
    "americanises": [
        "americaniser"
    ],
    "americanite": [
        "americanite"
    ],
    "americano": [
        "americano"
    ],
    "americanophile": [
        "americanophile"
    ],
    "americanophiles": [
        "americanophile"
    ],
    "americanos": [
        "americano"
    ],
    "americium": [
        "americium"
    ],
    "amerindien": [
        "amerindien"
    ],
    "amerindienne": [
        "amerindien"
    ],
    "amerindiennes": [
        "amerindien"
    ],
    "amerindiens": [
        "amerindien"
    ],
    "amerique": [
        "amerique"
    ],
    "amethyste": [
        "amethyste"
    ],
    "amethystes": [
        "amethyste"
    ],
    "an": [
        "an"
    ],
    "ana": [
        "ana"
    ],
    "anabaptiste": [
        "anabaptiste"
    ],
    "anabaptistes": [
        "anabaptiste"
    ],
    "anabase": [
        "anabase"
    ],
    "anabolisant": [
        "anabolisant"
    ],
    "anabolisants": [
        "anabolisant"
    ],
    "anachorete": [
        "anachorete"
    ],
    "anachoretes": [
        "anachorete"
    ],
    "anachronique": [
        "anachronique"
    ],
    "anachroniquement": [
        "anachroniquement"
    ],
    "anachroniques": [
        "anachronique"
    ],
    "anachronisme": [
        "anachronisme"
    ],
    "anachronismes": [
        "anachronisme"
    ],
    "anacoluthe": [
        "anacoluthe"
    ],
    "anaconda": [
        "anaconda"
    ],
    "anacondas": [
        "anaconda"
    ],
    "anadyomene": [
        "anadyomene"
    ],
    "anaglyphe": [
        "anaglyphe"
    ],
    "anagramme": [
        "anagramme"
    ],
    "anagrammes": [
        "anagramme"
    ],
    "anal": [
        "anal"
    ],
    "anale": [
        "anal"
    ],
    "analeptiques": [
        "analeptique"
    ],
    "anales": [
        "anal"
    ],
    "analgesie": [
        "analgesie"
    ],
    "analgesique": [
        "analgesique"
    ],
    "analgesiques": [
        "analgesique"
    ],
    "analogie": [
        "analogie"
    ],
    "analogies": [
        "analogie",
        "analogy"
    ],
    "analogique": [
        "analogique"
    ],
    "analogiques": [
        "analogique"
    ],
    "analogue": [
        "analogue"
    ],
    "analogues": [
        "analogue"
    ],
    "analphabete": [
        "analphabete"
    ],
    "analphabetes": [
        "analphabete"
    ],
    "analphabetisme": [
        "analphabetisme"
    ],
    "analysa": [
        "analyser"
    ],
    "analysaient": [
        "analyser"
    ],
    "analysais": [
        "analyser"
    ],
    "analysait": [
        "analyser"
    ],
    "analysant": [
        "analysant",
        "analyser"
    ],
    "analysants": [
        "analysant"
    ],
    "analyse": [
        "analyser",
        "analyse"
    ],
    "analysent": [
        "analyser"
    ],
    "analyser": [
        "analyser"
    ],
    "analysera": [
        "analyser"
    ],
    "analyserai": [
        "analyser"
    ],
    "analyserait": [
        "analyser"
    ],
    "analyserons": [
        "analyser"
    ],
    "analyseront": [
        "analyser"
    ],
    "analyses": [
        "analyser",
        "analyse",
        "analysis"
    ],
    "analyseur": [
        "analyseur"
    ],
    "analyseurs": [
        "analyseur"
    ],
    "analysez": [
        "analyser"
    ],
    "analysions": [
        "analyser"
    ],
    "analysons": [
        "analyser"
    ],
    "analyste": [
        "analyste"
    ],
    "analystes": [
        "analyste"
    ],
    "analyserent": [
        "analyser"
    ],
    "analysee": [
        "analyser",
        "analyse"
    ],
    "analysees": [
        "analyser",
        "analyse"
    ],
    "analytique": [
        "analytique"
    ],
    "analytiquement": [
        "analytiquement"
    ],
    "anamnese": [
        "anamnese"
    ],
    "anamorphose": [
        "anamorphose"
    ],
    "ananas": [
        "ananas"
    ],
    "anaphase": [
        "anaphase"
    ],
    "anaphoriquement": [
        "anaphoriquement"
    ],
    "anaphylactique": [
        "anaphylactique"
    ],
    "anaphylaxie": [
        "anaphylaxie"
    ],
    "anar": [
        "anar"
    ],
    "anarchie": [
        "anarchie"
    ],
    "anarchique": [
        "anarchique"
    ],
    "anarchiquement": [
        "anarchiquement"
    ],
    "anarchiques": [
        "anarchique"
    ],
    "anarchisant": [
        "anarchisant"
    ],
    "anarchisme": [
        "anarchisme"
    ],
    "anarchiste": [
        "anarchiste"
    ],
    "anarchistes": [
        "anarchiste"
    ],
    "anars": [
        "anar"
    ],
    "anas": [
        "anas",
        "ana"
    ],
    "anastomose": [
        "anastomose"
    ],
    "anastomoses": [
        "anastomose"
    ],
    "anatheme": [
        "anatheme"
    ],
    "anathemes": [
        "anatheme"
    ],
    "anathematisait": [
        "anathematiser"
    ],
    "anathematise": [
        "anathematiser"
    ],
    "anatides": [
        "anatide"
    ],
    "anatifes": [
        "anatife"
    ],
    "anatomie": [
        "anatomie"
    ],
    "anatomies": [
        "anatomie",
        "anatomy"
    ],
    "anatomique": [
        "anatomique"
    ],
    "anatomiquement": [
        "anatomiquement"
    ],
    "anatomiques": [
        "anatomique"
    ],
    "anatomiser": [
        "anatomiser"
    ],
    "anatomiste": [
        "anatomiste"
    ],
    "anatomistes": [
        "anatomiste"
    ],
    "anatomophysiologique": [
        "anatomophysiologique"
    ],
    "anaux": [
        "anal"
    ],
    "anaerobie": [
        "anaerobie"
    ],
    "ancestral": [
        "ancestral"
    ],
    "ancestrale": [
        "ancestral"
    ],
    "ancestralement": [
        "ancestralement"
    ],
    "ancestrales": [
        "ancestral"
    ],
    "ancestralite": [
        "ancestralite"
    ],
    "ancestraux": [
        "ancestral"
    ],
    "anche": [
        "anche"
    ],
    "anchilops": [
        "anchilops"
    ],
    "anchois": [
        "anchois"
    ],
    "anchoiade": [
        "anchoiade"
    ],
    "ancien": [
        "ancien"
    ],
    "ancienne": [
        "ancien"
    ],
    "anciennement": [
        "anciennement"
    ],
    "anciennes": [
        "ancien"
    ],
    "anciennete": [
        "anciennete"
    ],
    "anciens": [
        "ancien"
    ],
    "ancillaire": [
        "ancillaire"
    ],
    "ancillaires": [
        "ancillaire"
    ],
    "ancolie": [
        "ancolie"
    ],
    "ancra": [
        "ancrer"
    ],
    "ancrage": [
        "ancrage"
    ],
    "ancraient": [
        "ancrer"
    ],
    "ancrais": [
        "ancrer"
    ],
    "ancrait": [
        "ancrer"
    ],
    "ancrant": [
        "ancrer"
    ],
    "ancre": [
        "ancre",
        "ancrer"
    ],
    "ancrer": [
        "ancrer"
    ],
    "ancrera": [
        "ancrer"
    ],
    "ancres": [
        "ancre",
        "ancrer"
    ],
    "ancrez": [
        "ancrer"
    ],
    "ancree": [
        "ancre",
        "ancrer"
    ],
    "ancrees": [
        "ancre",
        "ancrer"
    ],
    "ancetre": [
        "ancetre"
    ],
    "ancetres": [
        "ancetre"
    ],
    "anda": [
        "anda"
    ],
    "andain": [
        "andain"
    ],
    "andains": [
        "andain"
    ],
    "andalou": [
        "andalou"
    ],
    "andalous": [
        "andalou"
    ],
    "andalouse": [
        "andalou"
    ],
    "andalouses": [
        "andalou"
    ],
    "andante": [
        "andante"
    ],
    "andine": [
        "andin"
    ],
    "andines": [
        "andin"
    ],
    "andorranes": [
        "andorran"
    ],
    "andouille": [
        "andouille"
    ],
    "andouiller": [
        "andouiller"
    ],
    "andouillers": [
        "andouiller"
    ],
    "andouilles": [
        "andouille"
    ],
    "andouillette": [
        "andouillette"
    ],
    "andouillettes": [
        "andouillette"
    ],
    "andrinople": [
        "andrinople"
    ],
    "androgyne": [
        "androgyne"
    ],
    "androgynes": [
        "androgyne"
    ],
    "androgynie": [
        "androgynie"
    ],
    "androgynique": [
        "androgynique"
    ],
    "androgenes": [
        "androgene"
    ],
    "andropause": [
        "andropause"
    ],
    "androide": [
        "androide"
    ],
    "androides": [
        "androide"
    ],
    "anecdote": [
        "anecdote"
    ],
    "anecdotes": [
        "anecdote"
    ],
    "anecdotier": [
        "anecdotier"
    ],
    "anecdotique": [
        "anecdotique"
    ],
    "anecdotiquement": [
        "anecdotiquement"
    ],
    "anecdotiques": [
        "anecdotique"
    ],
    "anesthesia": [
        "anesthesier"
    ],
    "anesthesiaient": [
        "anesthesier"
    ],
    "anesthesiait": [
        "anesthesier"
    ],
    "anesthesiant": [
        "anesthesier",
        "anesthesiant"
    ],
    "anesthesiante": [
        "anesthesiant"
    ],
    "anesthesiantes": [
        "anesthesiant"
    ],
    "anesthesiants": [
        "anesthesiant"
    ],
    "anesthesie": [
        "anesthesier",
        "anesthesie"
    ],
    "anesthesient": [
        "anesthesier"
    ],
    "anesthesier": [
        "anesthesier"
    ],
    "anesthesierai": [
        "anesthesier"
    ],
    "anesthesies": [
        "anesthesier",
        "anesthesie"
    ],
    "anesthesiez": [
        "anesthesier"
    ],
    "anesthesions": [
        "anesthesier"
    ],
    "anesthesique": [
        "anesthesique"
    ],
    "anesthesiques": [
        "anesthesique"
    ],
    "anesthesiste": [
        "anesthesiste"
    ],
    "anesthesistes": [
        "anesthesiste"
    ],
    "anesthesiee": [
        "anesthesier"
    ],
    "anesthesiees": [
        "anesthesier"
    ],
    "aneth": [
        "aneth"
    ],
    "anfractuosite": [
        "anfractuosite"
    ],
    "anfractuosites": [
        "anfractuosite"
    ],
    "ange": [
        "ange"
    ],
    "angelot": [
        "angelot"
    ],
    "angelots": [
        "angelot"
    ],
    "anges": [
        "ange"
    ],
    "angevin": [
        "angevin"
    ],
    "angevine": [
        "angevin"
    ],
    "angevins": [
        "angevin"
    ],
    "angine": [
        "angine"
    ],
    "angines": [
        "angine"
    ],
    "angiocholite": [
        "angiocholite"
    ],
    "angiographie": [
        "angiographie"
    ],
    "angiome": [
        "angiome"
    ],
    "angioplastie": [
        "angioplastie"
    ],
    "anglais": [
        "anglais",
        "angler"
    ],
    "anglaise": [
        "anglais"
    ],
    "anglaises": [
        "anglais"
    ],
    "angle": [
        "angle"
    ],
    "angler": [
        "angler"
    ],
    "angles": [
        "angle"
    ],
    "angleterre": [
        "angleterre"
    ],
    "anglican": [
        "anglican"
    ],
    "anglicane": [
        "anglican"
    ],
    "anglicans": [
        "anglican"
    ],
    "angliche": [
        "angliche"
    ],
    "angliches": [
        "angliche"
    ],
    "anglicisation": [
        "anglicisation"
    ],
    "angliciser": [
        "angliciser"
    ],
    "anglicismes": [
        "anglicisme"
    ],
    "anglicise": [
        "angliciser"
    ],
    "anglomane": [
        "anglomane"
    ],
    "anglomanes": [
        "anglomane"
    ],
    "anglomanie": [
        "anglomanie"
    ],
    "anglophile": [
        "anglophile"
    ],
    "anglophobe": [
        "anglophobe"
    ],
    "anglophobes": [
        "anglophobe"
    ],
    "anglophobie": [
        "anglophobie"
    ],
    "anglophone": [
        "anglophone"
    ],
    "anglophones": [
        "anglophone"
    ],
    "angoissa": [
        "angoisser"
    ],
    "angoissaient": [
        "angoisser"
    ],
    "angoissais": [
        "angoisser"
    ],
    "angoissait": [
        "angoisser"
    ],
    "angoissant": [
        "angoissant",
        "angoisser"
    ],
    "angoissante": [
        "angoissant"
    ],
    "angoissantes": [
        "angoissant"
    ],
    "angoissants": [
        "angoissant"
    ],
    "angoisse": [
        "angoisse",
        "angoisser"
    ],
    "angoissent": [
        "angoisser"
    ],
    "angoisser": [
        "angoisser"
    ],
    "angoisserait": [
        "angoisser"
    ],
    "angoisses": [
        "angoisse",
        "angoisser"
    ],
    "angoissez": [
        "angoisser"
    ],
    "angoissiez": [
        "angoisser"
    ],
    "angoissee": [
        "angoisse",
        "angoisser"
    ],
    "angoissees": [
        "angoisse",
        "angoisser"
    ],
    "angolais": [
        "angolais"
    ],
    "angon": [
        "angon"
    ],
    "angor": [
        "angor"
    ],
    "angora": [
        "angora"
    ],
    "angoras": [
        "angora"
    ],
    "angstrom": [
        "angstrom"
    ],
    "anguille": [
        "anguille"
    ],
    "anguilles": [
        "anguille"
    ],
    "anguillules": [
        "anguillule"
    ],
    "anguis": [
        "anguis"
    ],
    "angulaire": [
        "angulaire"
    ],
    "angulaires": [
        "angulaire"
    ],
    "anguleuse": [
        "anguleux"
    ],
    "anguleuses": [
        "anguleux"
    ],
    "anguleux": [
        "anguleux"
    ],
    "angulosite": [
        "angulosite"
    ],
    "angustura": [
        "angustura"
    ],
    "angeite": [
        "angeite"
    ],
    "angelique": [
        "angelique"
    ],
    "angeliquement": [
        "angeliquement"
    ],
    "angeliques": [
        "angelique"
    ],
    "angelisme": [
        "angelisme"
    ],
    "angelus": [
        "angelus"
    ],
    "anhydre": [
        "anhydre"
    ],
    "anhydride": [
        "anhydride"
    ],
    "anhele": [
        "anheler"
    ],
    "anhelations": [
        "anhelation"
    ],
    "anicroche": [
        "anicroche"
    ],
    "anicroches": [
        "anicroche"
    ],
    "aniline": [
        "aniline"
    ],
    "anima": [
        "animer"
    ],
    "animai": [
        "animer"
    ],
    "animaient": [
        "animer"
    ],
    "animais": [
        "animer"
    ],
    "animait": [
        "animer"
    ],
    "animal": [
        "animal"
    ],
    "animalcule": [
        "animalcule"
    ],
    "animale": [
        "animal"
    ],
    "animalement": [
        "animalement"
    ],
    "animalerie": [
        "animalerie"
    ],
    "animales": [
        "animal"
    ],
    "animalier": [
        "animalier"
    ],
    "animaliers": [
        "animalier"
    ],
    "animalisait": [
        "animaliser"
    ],
    "animalise": [
        "animaliser"
    ],
    "animalite": [
        "animalite"
    ],
    "animaliere": [
        "animalier"
    ],
    "animalieres": [
        "animalier"
    ],
    "animant": [
        "animer"
    ],
    "animas": [
        "animer"
    ],
    "animateur": [
        "animateur"
    ],
    "animateurs": [
        "animateur"
    ],
    "animation": [
        "animation"
    ],
    "animations": [
        "animation"
    ],
    "animatrice": [
        "animateur"
    ],
    "animatrices": [
        "animateur"
    ],
    "animaux": [
        "animaux",
        "animal"
    ],
    "anime": [
        "anime",
        "animer"
    ],
    "animent": [
        "animer"
    ],
    "animer": [
        "animer"
    ],
    "animeraient": [
        "animer"
    ],
    "animerait": [
        "animer"
    ],
    "animes": [
        "anime",
        "animer"
    ],
    "animique": [
        "animique"
    ],
    "animisme": [
        "animisme"
    ],
    "animiste": [
        "animiste"
    ],
    "animosite": [
        "animosite"
    ],
    "animosites": [
        "animosite"
    ],
    "animus": [
        "animus"
    ],
    "animat": [
        "animer"
    ],
    "animerent": [
        "animer"
    ],
    "animee": [
        "anime",
        "animer"
    ],
    "animees": [
        "anime",
        "animer"
    ],
    "anionique": [
        "anionique"
    ],
    "anis": [
        "anis"
    ],
    "anise": [
        "anise",
        "aniser"
    ],
    "anisette": [
        "anisette"
    ],
    "anisettes": [
        "anisette"
    ],
    "anisee": [
        "aniser"
    ],
    "anisees": [
        "aniser"
    ],
    "ankh": [
        "ankh"
    ],
    "ankylosait": [
        "ankyloser"
    ],
    "ankylose": [
        "ankylose",
        "ankyloser"
    ],
    "ankyloser": [
        "ankyloser"
    ],
    "ankyloses": [
        "ankylose",
        "ankyloser"
    ],
    "ankylosee": [
        "ankyloser",
        "ankylose"
    ],
    "ankylosees": [
        "ankyloser",
        "ankylose"
    ],
    "annales": [
        "annales"
    ],
    "annamite": [
        "annamite"
    ],
    "annamites": [
        "annamite"
    ],
    "anneau": [
        "anneau"
    ],
    "anneaux": [
        "anneau"
    ],
    "annelets": [
        "annelet"
    ],
    "annelures": [
        "annelure"
    ],
    "annele": [
        "annele",
        "anneler"
    ],
    "annelee": [
        "annele"
    ],
    "annelees": [
        "annele",
        "anneler"
    ],
    "anneles": [
        "annele",
        "anneler"
    ],
    "annexa": [
        "annexer"
    ],
    "annexaient": [
        "annexer"
    ],
    "annexait": [
        "annexer"
    ],
    "annexant": [
        "annexer"
    ],
    "annexe": [
        "annexe",
        "annexer"
    ],
    "annexer": [
        "annexer"
    ],
    "annexes": [
        "annexe",
        "annexer",
        "annex"
    ],
    "annexion": [
        "annexion"
    ],
    "annexions": [
        "annexion"
    ],
    "annexerent": [
        "annexer"
    ],
    "annexee": [
        "annexe",
        "annexer"
    ],
    "annexees": [
        "annexe",
        "annexer"
    ],
    "annihila": [
        "annihiler"
    ],
    "annihilait": [
        "annihiler"
    ],
    "annihilant": [
        "annihiler",
        "annihilant"
    ],
    "annihilante": [
        "annihilant"
    ],
    "annihilateur": [
        "annihilateur"
    ],
    "annihilation": [
        "annihilation"
    ],
    "annihile": [
        "annihiler"
    ],
    "annihilent": [
        "annihiler"
    ],
    "annihiler": [
        "annihiler"
    ],
    "annihilez": [
        "annihiler"
    ],
    "annihilons": [
        "annihiler"
    ],
    "annihilee": [
        "annihiler"
    ],
    "anniv": [
        "anniv"
    ],
    "anniversaire": [
        "anniversaire"
    ],
    "anniversaires": [
        "anniversaire"
    ],
    "annonce": [
        "annonce",
        "annoncer"
    ],
    "annoncent": [
        "annoncer"
    ],
    "annoncer": [
        "annoncer"
    ],
    "annoncera": [
        "annoncer"
    ],
    "annoncerai": [
        "annoncer"
    ],
    "annonceraient": [
        "annoncer"
    ],
    "annoncerais": [
        "annoncer"
    ],
    "annoncerait": [
        "annoncer"
    ],
    "annonceras": [
        "annoncer"
    ],
    "annoncerez": [
        "annoncer"
    ],
    "annoncerons": [
        "annoncer"
    ],
    "annonceront": [
        "annoncer"
    ],
    "annonces": [
        "annonce",
        "annoncer"
    ],
    "annonceur": [
        "annonceur"
    ],
    "annonceurs": [
        "annonceur"
    ],
    "annonceuse": [
        "annonceur"
    ],
    "annoncez": [
        "annoncer"
    ],
    "annonciateur": [
        "annonciateur"
    ],
    "annonciateurs": [
        "annonciateur"
    ],
    "annonciation": [
        "annonciation"
    ],
    "annonciations": [
        "annonciation"
    ],
    "annonciatrice": [
        "annonciateur"
    ],
    "annonciatrices": [
        "annonciateur"
    ],
    "annonciez": [
        "annoncer"
    ],
    "annoncions": [
        "annoncer"
    ],
    "annoncerent": [
        "annoncer"
    ],
    "annoncee": [
        "annoncer"
    ],
    "annoncees": [
        "annoncer"
    ],
    "annonca": [
        "annoncer"
    ],
    "annoncai": [
        "annoncer"
    ],
    "annoncaient": [
        "annoncer"
    ],
    "annoncais": [
        "annoncer"
    ],
    "annoncait": [
        "annoncer"
    ],
    "annoncant": [
        "annoncer"
    ],
    "annoncons": [
        "annoncer"
    ],
    "annoncat": [
        "annoncer"
    ],
    "annotais": [
        "annoter"
    ],
    "annotait": [
        "annoter"
    ],
    "annotant": [
        "annoter"
    ],
    "annotation": [
        "annotation"
    ],
    "annotations": [
        "annotation"
    ],
    "annote": [
        "annoter"
    ],
    "annoter": [
        "annoter"
    ],
    "annotee": [
        "annoter"
    ],
    "annotes": [
        "annoter"
    ],
    "annuaire": [
        "annuaire"
    ],
    "annuaires": [
        "annuaire"
    ],
    "annuel": [
        "annuel"
    ],
    "annuelle": [
        "annuel"
    ],
    "annuellement": [
        "annuellement"
    ],
    "annuelles": [
        "annuel"
    ],
    "annuels": [
        "annuel"
    ],
    "annula": [
        "annuler"
    ],
    "annulai": [
        "annuler"
    ],
    "annulaient": [
        "annuler"
    ],
    "annulaire": [
        "annulaire"
    ],
    "annulais": [
        "annuler"
    ],
    "annulait": [
        "annuler"
    ],
    "annulant": [
        "annuler"
    ],
    "annulation": [
        "annulation"
    ],
    "annulations": [
        "annulation"
    ],
    "annule": [
        "annule",
        "annuler"
    ],
    "annulent": [
        "annuler"
    ],
    "annuler": [
        "annuler"
    ],
    "annulera": [
        "annuler"
    ],
    "annulerai": [
        "annuler"
    ],
    "annuleraient": [
        "annuler"
    ],
    "annulerais": [
        "annuler"
    ],
    "annulerait": [
        "annuler"
    ],
    "annulerez": [
        "annuler"
    ],
    "annulerons": [
        "annuler"
    ],
    "annuleront": [
        "annuler"
    ],
    "annules": [
        "annule",
        "annuler"
    ],
    "annulez": [
        "annuler"
    ],
    "annuliez": [
        "annuler"
    ],
    "annulons": [
        "annuler"
    ],
    "annulerent": [
        "annuler"
    ],
    "annulee": [
        "annule",
        "annuler"
    ],
    "annulees": [
        "annule",
        "annuler"
    ],
    "annee": [
        "annee"
    ],
    "annees": [
        "annee"
    ],
    "anobli": [
        "anobli",
        "anoblir"
    ],
    "anoblie": [
        "anobli",
        "anoblir"
    ],
    "anoblies": [
        "anobli"
    ],
    "anoblir": [
        "anoblir"
    ],
    "anoblissait": [
        "anoblir"
    ],
    "anoblissant": [
        "anoblir"
    ],
    "anoblissante": [
        "anoblissant"
    ],
    "anoblissement": [
        "anoblissement"
    ],
    "anoblit": [
        "anoblir"
    ],
    "anode": [
        "anode"
    ],
    "anodin": [
        "anodin"
    ],
    "anodine": [
        "anodin"
    ],
    "anodines": [
        "anodin"
    ],
    "anodins": [
        "anodin"
    ],
    "anodique": [
        "anodique"
    ],
    "anodise": [
        "anodiser"
    ],
    "anomalie": [
        "anomalie"
    ],
    "anomalies": [
        "anomaly",
        "anomalie"
    ],
    "anomoure": [
        "anomoure"
    ],
    "anonymat": [
        "anonymat"
    ],
    "anonyme": [
        "anonyme"
    ],
    "anonymement": [
        "anonymement"
    ],
    "anonymes": [
        "anonyme"
    ],
    "anonymographe": [
        "anonymographe"
    ],
    "anophele": [
        "anophele"
    ],
    "anorak": [
        "anorak"
    ],
    "anoraks": [
        "anorak"
    ],
    "anorexie": [
        "anorexie"
    ],
    "anorexies": [
        "anorexie"
    ],
    "anorexique": [
        "anorexique"
    ],
    "anorexiques": [
        "anorexique"
    ],
    "anormal": [
        "anormal"
    ],
    "anormale": [
        "anormal"
    ],
    "anormalement": [
        "anormalement"
    ],
    "anormales": [
        "anormal"
    ],
    "anormalite": [
        "anormalite"
    ],
    "anormaux": [
        "anormal"
    ],
    "anosmie": [
        "anosmie"
    ],
    "anosmique": [
        "anosmique"
    ],
    "anoxie": [
        "anoxie"
    ],
    "ans": [
        "an"
    ],
    "anse": [
        "anse"
    ],
    "anses": [
        "anse"
    ],
    "ansee": [
        "anse"
    ],
    "ansees": [
        "anse"
    ],
    "antagonique": [
        "antagonique"
    ],
    "antagonisme": [
        "antagonisme"
    ],
    "antagonismes": [
        "antagonisme"
    ],
    "antagoniste": [
        "antagoniste"
    ],
    "antagonistes": [
        "antagoniste"
    ],
    "antalgique": [
        "antalgique"
    ],
    "antalgiques": [
        "antalgique"
    ],
    "antan": [
        "antan"
    ],
    "antarctique": [
        "antarctique"
    ],
    "antarctiques": [
        "antarctique"
    ],
    "ante": [
        "anter",
        "ante"
    ],
    "antenne": [
        "antenne"
    ],
    "antennes": [
        "antenne"
    ],
    "anthologie": [
        "anthologie"
    ],
    "anthologies": [
        "anthology",
        "anthologie"
    ],
    "anthonome": [
        "anthonome"
    ],
    "anthracine": [
        "anthracine"
    ],
    "anthracite": [
        "anthracite"
    ],
    "anthracites": [
        "anthracite"
    ],
    "anthracose": [
        "anthracose"
    ],
    "anthracene": [
        "anthracene"
    ],
    "anthraquinone": [
        "anthraquinone"
    ],
    "anthrax": [
        "anthrax"
    ],
    "anthropiques": [
        "anthropique"
    ],
    "anthropologie": [
        "anthropologie"
    ],
    "anthropologique": [
        "anthropologique"
    ],
    "anthropologiquement": [
        "anthropologiquement"
    ],
    "anthropologiques": [
        "anthropologique"
    ],
    "anthropologiste": [
        "anthropologiste"
    ],
    "anthropologue": [
        "anthropologue"
    ],
    "anthropologues": [
        "anthropologue"
    ],
    "anthropomorphe": [
        "anthropomorphe"
    ],
    "anthropomorphique": [
        "anthropomorphique"
    ],
    "anthropomorphiser": [
        "anthropomorphiser"
    ],
    "anthropomorphisme": [
        "anthropomorphisme"
    ],
    "anthropometrie": [
        "anthropometrie"
    ],
    "anthropometrique": [
        "anthropometrique"
    ],
    "anthropometriques": [
        "anthropometrique"
    ],
    "anthropophage": [
        "anthropophage"
    ],
    "anthropophages": [
        "anthropophage"
    ],
    "anthropophagie": [
        "anthropophagie"
    ],
    "anthropophagiques": [
        "anthropophagique"
    ],
    "anthropopitheque": [
        "anthropopitheque"
    ],
    "anthropopitheques": [
        "anthropopitheque"
    ],
    "anthropoide": [
        "anthropoide"
    ],
    "anthropoides": [
        "anthropoide"
    ],
    "anthume": [
        "anthume"
    ],
    "anti": [
        "anti"
    ],
    "antiacide": [
        "antiacide"
    ],
    "antiacides": [
        "antiacide"
    ],
    "antialcoolique": [
        "antialcoolique"
    ],
    "antiallemands": [
        "antiallemand"
    ],
    "antiamericain": [
        "antiamericain"
    ],
    "antiamericaine": [
        "antiamericain"
    ],
    "antiamericaines": [
        "antiamericain"
    ],
    "antiamericanisme": [
        "antiamericanisme"
    ],
    "antiatomique": [
        "antiatomique"
    ],
    "antiaerien": [
        "antiaerien"
    ],
    "antiaerienne": [
        "antiaerien"
    ],
    "antiaeriennes": [
        "antiaerien"
    ],
    "antiaeriens": [
        "antiaerien"
    ],
    "antibacterien": [
        "antibacterien"
    ],
    "antibiotique": [
        "antibiotique"
    ],
    "antibiotiques": [
        "antibiotique"
    ],
    "antiblocage": [
        "antiblocage"
    ],
    "antibois": [
        "antibois"
    ],
    "antibolcheviques": [
        "antibolchevique"
    ],
    "antibolchevisme": [
        "antibolchevisme"
    ],
    "antibourgeois": [
        "antibourgeois"
    ],
    "antibrouillard": [
        "antibrouillard"
    ],
    "antibruit": [
        "antibruit"
    ],
    "anticalcaire": [
        "anticalcaire"
    ],
    "anticapitaliste": [
        "anticapitaliste"
    ],
    "anticastriste": [
        "anticastriste"
    ],
    "anticastristes": [
        "anticastriste"
    ],
    "anticatalyseurs": [
        "anticatalyseur"
    ],
    "anticatholique": [
        "anticatholique"
    ],
    "antichambre": [
        "antichambre"
    ],
    "antichambres": [
        "antichambre"
    ],
    "antichar": [
        "antichar"
    ],
    "antichars": [
        "antichar"
    ],
    "antichoc": [
        "antichoc"
    ],
    "anticholinergique": [
        "anticholinergique"
    ],
    "antichristianisme": [
        "antichristianisme"
    ],
    "antichretien": [
        "antichretien"
    ],
    "antichretienne": [
        "antichretien"
    ],
    "anticipa": [
        "anticiper"
    ],
    "anticipais": [
        "anticiper"
    ],
    "anticipait": [
        "anticiper"
    ],
    "anticipant": [
        "anticiper"
    ],
    "anticipateur": [
        "anticipateur"
    ],
    "anticipation": [
        "anticipation"
    ],
    "anticipations": [
        "anticipation"
    ],
    "anticipatoire": [
        "anticipatoire"
    ],
    "anticipatrice": [
        "anticipateur"
    ],
    "anticipe": [
        "anticipe",
        "anticiper"
    ],
    "anticipent": [
        "anticiper"
    ],
    "anticiper": [
        "anticiper"
    ],
    "anticipera": [
        "anticiper"
    ],
    "anticiperait": [
        "anticiper"
    ],
    "anticipez": [
        "anticiper"
    ],
    "anticipons": [
        "anticiper"
    ],
    "anticipee": [
        "anticipe",
        "anticiper"
    ],
    "anticipees": [
        "anticipe",
        "anticiper"
    ],
    "anticipes": [
        "anticipe",
        "anticiper"
    ],
    "anticlerical": [
        "anticlerical"
    ],
    "anticlericale": [
        "anticlerical"
    ],
    "anticlericales": [
        "anticlerical"
    ],
    "anticlericalisme": [
        "anticlericalisme"
    ],
    "anticlericaux": [
        "anticlerical"
    ],
    "anticoagulant": [
        "anticoagulant"
    ],
    "anticoagulants": [
        "anticoagulant"
    ],
    "anticolonialisme": [
        "anticolonialisme"
    ],
    "anticommunisme": [
        "anticommunisme"
    ],
    "anticommuniste": [
        "anticommuniste"
    ],
    "anticommunistes": [
        "anticommuniste"
    ],
    "anticonceptionnelle": [
        "anticonceptionnel"
    ],
    "anticonceptionnelles": [
        "anticonceptionnel"
    ],
    "anticonceptionnels": [
        "anticonceptionnel"
    ],
    "anticonformisme": [
        "anticonformisme"
    ],
    "anticonformiste": [
        "anticonformiste"
    ],
    "anticonstitutionnel": [
        "anticonstitutionnel"
    ],
    "anticonstitutionnelle": [
        "anticonstitutionnel"
    ],
    "anticonstitutionnellement": [
        "anticonstitutionnellement"
    ],
    "anticorps": [
        "anticorps"
    ],
    "anticyclique": [
        "anticyclique"
    ],
    "anticyclone": [
        "anticyclone"
    ],
    "anticycloniques": [
        "anticyclonique"
    ],
    "antidatait": [
        "antidater"
    ],
    "antidater": [
        "antidater"
    ],
    "antidate": [
        "antidater"
    ],
    "antidatee": [
        "antidater"
    ],
    "antidictatoriaux": [
        "antidictatorial"
    ],
    "antidopage": [
        "antidopage"
    ],
    "antidote": [
        "antidote"
    ],
    "antidotes": [
        "antidote"
    ],
    "antidouleur": [
        "antidouleur"
    ],
    "antidreyfusard": [
        "antidreyfusard"
    ],
    "antidreyfusarde": [
        "antidreyfusard"
    ],
    "antidreyfusards": [
        "antidreyfusard"
    ],
    "antidreyfusisme": [
        "antidreyfusisme"
    ],
    "antidrogue": [
        "antidrogue"
    ],
    "antidemarrage": [
        "antidemarrage"
    ],
    "antidemocratique": [
        "antidemocratique"
    ],
    "antidepresseur": [
        "antidepresseur"
    ],
    "antidepresseurs": [
        "antidepresseur"
    ],
    "antiderapant": [
        "antiderapant"
    ],
    "antiderapante": [
        "antiderapant"
    ],
    "antiderapantes": [
        "antiderapant"
    ],
    "antiderapants": [
        "antiderapant"
    ],
    "antienne": [
        "antienne"
    ],
    "antiennes": [
        "antienne"
    ],
    "antiesclavagiste": [
        "antiesclavagiste"
    ],
    "antifading": [
        "antifading"
    ],
    "antifascisme": [
        "antifascisme"
    ],
    "antifasciste": [
        "antifasciste"
    ],
    "antifascistes": [
        "antifasciste"
    ],
    "antifongique": [
        "antifongique"
    ],
    "antifrancaise": [
        "antifrancais"
    ],
    "antifrancaises": [
        "antifrancais"
    ],
    "antifumee": [
        "antifumee"
    ],
    "antifeminisme": [
        "antifeminisme"
    ],
    "antigang": [
        "antigang"
    ],
    "antigangs": [
        "antigang"
    ],
    "antigaullistes": [
        "antigaulliste"
    ],
    "antigel": [
        "antigel"
    ],
    "antigermanisme": [
        "antigermanisme"
    ],
    "antigravitation": [
        "antigravitation"
    ],
    "antigravitationnel": [
        "antigravitationnel"
    ],
    "antigravite": [
        "antigravite"
    ],
    "antigrippe": [
        "antigrippe"
    ],
    "antigene": [
        "antigene"
    ],
    "antigenes": [
        "antigene"
    ],
    "antihistaminique": [
        "antihistaminique"
    ],
    "antihistaminiques": [
        "antihistaminique"
    ],
    "antihygienique": [
        "antihygienique"
    ],
    "antihemorragiques": [
        "antihemorragique"
    ],
    "antiheros": [
        "antiheros"
    ],
    "antillais": [
        "antillais"
    ],
    "antillaise": [
        "antillais"
    ],
    "antillaises": [
        "antillais"
    ],
    "antilogique": [
        "antilogique"
    ],
    "antilope": [
        "antilope"
    ],
    "antilopes": [
        "antilope"
    ],
    "antimarxiste": [
        "antimarxiste"
    ],
    "antimatiere": [
        "antimatiere"
    ],
    "antimaconniques": [
        "antimaconnique"
    ],
    "antimicrobien": [
        "antimicrobien"
    ],
    "antimigraineux": [
        "antimigraineux"
    ],
    "antimilitarisme": [
        "antimilitarisme"
    ],
    "antimilitariste": [
        "antimilitariste"
    ],
    "antimilitaristes": [
        "antimilitariste"
    ],
    "antimissile": [
        "antimissile"
    ],
    "antimissiles": [
        "antimissile"
    ],
    "antimite": [
        "antimite"
    ],
    "antimites": [
        "antimite"
    ],
    "antimitotiques": [
        "antimitotique"
    ],
    "antimoine": [
        "antimoine"
    ],
    "antimonde": [
        "antimonde"
    ],
    "antinationale": [
        "antinational"
    ],
    "antinationales": [
        "antinational"
    ],
    "antinationaliste": [
        "antinationaliste"
    ],
    "antinaturel": [
        "antinaturel"
    ],
    "antinaturelle": [
        "antinaturel"
    ],
    "antinazie": [
        "antinazi"
    ],
    "antinazis": [
        "antinazi"
    ],
    "antinomie": [
        "antinomie"
    ],
    "antinomies": [
        "antinomie"
    ],
    "antinomique": [
        "antinomique"
    ],
    "antinomiques": [
        "antinomique"
    ],
    "antinucleaire": [
        "antinucleaire"
    ],
    "antinucleaires": [
        "antinucleaire"
    ],
    "antioxydant": [
        "antioxydant"
    ],
    "antioxydants": [
        "antioxydant"
    ],
    "antipape": [
        "antipape"
    ],
    "antipapes": [
        "antipape"
    ],
    "antiparasitage": [
        "antiparasitage"
    ],
    "antiparasite": [
        "antiparasite"
    ],
    "antiparasites": [
        "antiparasite"
    ],
    "antipathie": [
        "antipathie"
    ],
    "antipathies": [
        "antipathie",
        "antipathy"
    ],
    "antipathique": [
        "antipathique"
    ],
    "antipathiques": [
        "antipathique"
    ],
    "antipatriote": [
        "antipatriote"
    ],
    "antipatriotiques": [
        "antipatriotique"
    ],
    "antipelliculaire": [
        "antipelliculaire"
    ],
    "antipersonnel": [
        "antipersonnel"
    ],
    "antipersonnelle": [
        "antipersonnel"
    ],
    "antipersonnelles": [
        "antipersonnel"
    ],
    "antiphonaires": [
        "antiphonaire"
    ],
    "antiphrase": [
        "antiphrase"
    ],
    "antiphysiques": [
        "antiphysique"
    ],
    "antipodaire": [
        "antipodaire"
    ],
    "antipode": [
        "antipode"
    ],
    "antipodes": [
        "antipode"
    ],
    "antipodiste": [
        "antipodiste"
    ],
    "antipodistes": [
        "antipodiste"
    ],
    "antipoison": [
        "antipoison"
    ],
    "antipoisons": [
        "antipoison"
    ],
    "antipoliomyelitique": [
        "antipoliomyelitique"
    ],
    "antipollution": [
        "antipollution"
    ],
    "antipopulaire": [
        "antipopulaire"
    ],
    "antiproton": [
        "antiproton"
    ],
    "antiprotons": [
        "antiproton"
    ],
    "antiprotease": [
        "antiprotease"
    ],
    "antipsychiatrie": [
        "antipsychiatrie"
    ],
    "antipsychotique": [
        "antipsychotique"
    ],
    "antipsychotiques": [
        "antipsychotique"
    ],
    "antiquaille": [
        "antiquaille"
    ],
    "antiquailleries": [
        "antiquaillerie"
    ],
    "antiquailles": [
        "antiquaille"
    ],
    "antiquaire": [
        "antiquaire"
    ],
    "antiquaires": [
        "antiquaire"
    ],
    "antiquark": [
        "antiquark"
    ],
    "antique": [
        "antique"
    ],
    "antiques": [
        "antique"
    ],
    "antiquite": [
        "antiquite"
    ],
    "antiquites": [
        "antiquite"
    ],
    "antirabique": [
        "antirabique"
    ],
    "antiracisme": [
        "antiracisme"
    ],
    "antiracistes": [
        "antiraciste"
    ],
    "antiradiation": [
        "antiradiation"
    ],
    "antireligieuse": [
        "antireligieux"
    ],
    "antireligieux": [
        "antireligieux"
    ],
    "antirides": [
        "antirides"
    ],
    "antirouille": [
        "antirouille"
    ],
    "antirusse": [
        "antirusse"
    ],
    "antirepublicain": [
        "antirepublicain"
    ],
    "antisatellite": [
        "antisatellite"
    ],
    "antiscientifique": [
        "antiscientifique"
    ],
    "antisepsie": [
        "antisepsie"
    ],
    "antiseptique": [
        "antiseptique"
    ],
    "antiseptiques": [
        "antiseptique"
    ],
    "antisexistes": [
        "antisexiste"
    ],
    "antisexuel": [
        "antisexuel"
    ],
    "antisionistes": [
        "antisioniste"
    ],
    "antiskating": [
        "antiskating"
    ],
    "antisocial": [
        "antisocial"
    ],
    "antisociale": [
        "antisocial"
    ],
    "antisociales": [
        "antisocial"
    ],
    "antisociaux": [
        "antisocial"
    ],
    "antisolaire": [
        "antisolaire"
    ],
    "antisolaires": [
        "antisolaire"
    ],
    "antisovietique": [
        "antisovietique"
    ],
    "antisovietiques": [
        "antisovietique"
    ],
    "antisovietisme": [
        "antisovietisme"
    ],
    "antispasmodique": [
        "antispasmodique"
    ],
    "antisportif": [
        "antisportif"
    ],
    "antistalinien": [
        "antistalinien"
    ],
    "antistaliniens": [
        "antistalinien"
    ],
    "antistatique": [
        "antistatique"
    ],
    "antistatiques": [
        "antistatique"
    ],
    "antistress": [
        "antistress"
    ],
    "antiseche": [
        "antiseche"
    ],
    "antiseches": [
        "antiseche"
    ],
    "antisemite": [
        "antisemite"
    ],
    "antisemites": [
        "antisemite"
    ],
    "antisemitisme": [
        "antisemitisme"
    ],
    "antiserum": [
        "antiserum"
    ],
    "antitabac": [
        "antitabac"
    ],
    "antiterrorisme": [
        "antiterrorisme"
    ],
    "antiterroriste": [
        "antiterroriste"
    ],
    "antithese": [
        "antithese"
    ],
    "antitheses": [
        "antithesis",
        "antithese"
    ],
    "antithetiques": [
        "antithetique"
    ],
    "antitout": [
        "antitout"
    ],
    "antitoxine": [
        "antitoxine"
    ],
    "antitoxique": [
        "antitoxique"
    ],
    "antitrust": [
        "antitrust"
    ],
    "antituberculeux": [
        "antituberculeux"
    ],
    "antitussif": [
        "antitussif"
    ],
    "antitussives": [
        "antitussif"
    ],
    "antityphoidique": [
        "antityphoidique"
    ],
    "antitetanique": [
        "antitetanique"
    ],
    "antivariolique": [
        "antivariolique"
    ],
    "antivenimeux": [
        "antivenimeux"
    ],
    "antiviolence": [
        "antiviolence"
    ],
    "antiviral": [
        "antiviral"
    ],
    "antiviraux": [
        "antiviral"
    ],
    "antivirus": [
        "antivirus"
    ],
    "antivol": [
        "antivol"
    ],
    "antiemeute": [
        "antiemeute"
    ],
    "antiemetique": [
        "antiemetique"
    ],
    "antonin": [
        "antonin"
    ],
    "antonomase": [
        "antonomase"
    ],
    "antonyme": [
        "antonyme"
    ],
    "antonymes": [
        "antonyme"
    ],
    "antre": [
        "antre"
    ],
    "antres": [
        "antre"
    ],
    "antechrist": [
        "antechrist"
    ],
    "antechrists": [
        "antechrist"
    ],
    "antecedent": [
        "antecedent"
    ],
    "antecedents": [
        "antecedent"
    ],
    "antediluvien": [
        "antediluvien"
    ],
    "antediluvienne": [
        "antediluvien"
    ],
    "antediluviennes": [
        "antediluvien"
    ],
    "antediluviens": [
        "antediluvien"
    ],
    "antepenultieme": [
        "antepenultieme"
    ],
    "antepenultiemes": [
        "antepenultieme"
    ],
    "anterieur": [
        "anterieur"
    ],
    "anterieure": [
        "anterieur"
    ],
    "anterieurement": [
        "anterieurement"
    ],
    "anterieures": [
        "anterieur"
    ],
    "anterieurs": [
        "anterieur"
    ],
    "anterograde": [
        "anterograde"
    ],
    "anuite": [
        "anuiter"
    ],
    "anuitees": [
        "anuiter"
    ],
    "anus": [
        "anus"
    ],
    "anuscopie": [
        "anuscopie"
    ],
    "anxieuse": [
        "anxieux"
    ],
    "anxieusement": [
        "anxieusement"
    ],
    "anxieuses": [
        "anxieux"
    ],
    "anxieux": [
        "anxieux"
    ],
    "anxiolytique": [
        "anxiolytique"
    ],
    "anxiolytiques": [
        "anxiolytique"
    ],
    "anxiete": [
        "anxiete"
    ],
    "anxietes": [
        "anxiete"
    ],
    "anya": [
        "anya"
    ],
    "aneanti": [
        "aneantir"
    ],
    "aneantie": [
        "aneantir"
    ],
    "aneanties": [
        "aneantir"
    ],
    "aneantir": [
        "aneantir"
    ],
    "aneantira": [
        "aneantir"
    ],
    "aneantirai": [
        "aneantir"
    ],
    "aneantiraient": [
        "aneantir"
    ],
    "aneantirait": [
        "aneantir"
    ],
    "aneantirent": [
        "aneantir"
    ],
    "aneantiriez": [
        "aneantir"
    ],
    "aneantirons": [
        "aneantir"
    ],
    "aneantiront": [
        "aneantir"
    ],
    "aneantis": [
        "aneantir"
    ],
    "aneantissaient": [
        "aneantir"
    ],
    "aneantissait": [
        "aneantir"
    ],
    "aneantissant": [
        "aneantir"
    ],
    "aneantissante": [
        "aneantissant"
    ],
    "aneantissantes": [
        "aneantissant"
    ],
    "aneantisse": [
        "aneantir"
    ],
    "aneantissement": [
        "aneantissement"
    ],
    "aneantissements": [
        "aneantissement"
    ],
    "aneantissent": [
        "aneantir"
    ],
    "aneantissez": [
        "aneantir"
    ],
    "aneantissons": [
        "aneantir"
    ],
    "aneantit": [
        "aneantir"
    ],
    "anemiais": [
        "anemier"
    ],
    "anemiante": [
        "anemiant"
    ],
    "anemie": [
        "anemier",
        "anemie"
    ],
    "anemique": [
        "anemique"
    ],
    "anemiques": [
        "anemique"
    ],
    "anemiee": [
        "anemier",
        "anemie"
    ],
    "anemies": [
        "anemie"
    ],
    "anemometre": [
        "anemometre"
    ],
    "anemometrique": [
        "anemometrique"
    ],
    "anemone": [
        "anemone"
    ],
    "anemones": [
        "anemone"
    ],
    "anevrisme": [
        "anevrisme"
    ],
    "anevrismes": [
        "anevrisme"
    ],
    "aoriste": [
        "aoriste"
    ],
    "aorte": [
        "aorte"
    ],
    "aortique": [
        "aortique"
    ],
    "aortiques": [
        "aortique"
    ],
    "aouls": [
        "aoul"
    ],
    "aout": [
        "aout"
    ],
    "aoutat": [
        "aoutat"
    ],
    "aoutien": [
        "aoutien"
    ],
    "apache": [
        "apache"
    ],
    "apaches": [
        "apache"
    ],
    "apaisa": [
        "apaiser"
    ],
    "apaisai": [
        "apaiser"
    ],
    "apaisaient": [
        "apaiser"
    ],
    "apaisais": [
        "apaiser"
    ],
    "apaisait": [
        "apaiser"
    ],
    "apaisant": [
        "apaiser",
        "apaisant"
    ],
    "apaisante": [
        "apaisant"
    ],
    "apaisantes": [
        "apaisant"
    ],
    "apaisants": [
        "apaisant"
    ],
    "apaise": [
        "apaiser"
    ],
    "apaisement": [
        "apaisement"
    ],
    "apaisements": [
        "apaisement"
    ],
    "apaisent": [
        "apaiser"
    ],
    "apaiser": [
        "apaiser"
    ],
    "apaisera": [
        "apaiser"
    ],
    "apaiseraient": [
        "apaiser"
    ],
    "apaiserais": [
        "apaiser"
    ],
    "apaiserait": [
        "apaiser"
    ],
    "apaisez": [
        "apaiser"
    ],
    "apaisiez": [
        "apaiser"
    ],
    "apaisons": [
        "apaiser"
    ],
    "apaisat": [
        "apaiser"
    ],
    "apaiserent": [
        "apaiser"
    ],
    "apaisee": [
        "apaiser"
    ],
    "apaisees": [
        "apaiser"
    ],
    "apaises": [
        "apaiser"
    ],
    "apanage": [
        "apanage"
    ],
    "apanages": [
        "apanage"
    ],
    "apartheid": [
        "apartheid"
    ],
    "aparte": [
        "aparte"
    ],
    "apartes": [
        "aparte"
    ],
    "apathie": [
        "apathie"
    ],
    "apathique": [
        "apathique"
    ],
    "apathiques": [
        "apathique"
    ],
    "apatride": [
        "apatride"
    ],
    "apatrides": [
        "apatride"
    ],
    "apax": [
        "apax"
    ],
    "ape": [
        "ape"
    ],
    "aperceptions": [
        "aperception"
    ],
    "apercevaient": [
        "apercevoir"
    ],
    "apercevais": [
        "apercevoir"
    ],
    "apercevait": [
        "apercevoir"
    ],
    "apercevant": [
        "apercevoir"
    ],
    "apercevez": [
        "apercevoir"
    ],
    "aperceviez": [
        "apercevoir"
    ],
    "apercevions": [
        "apercevoir"
    ],
    "apercevoir": [
        "apercevoir"
    ],
    "apercevons": [
        "apercevoir"
    ],
    "apercevra": [
        "apercevoir"
    ],
    "apercevrai": [
        "apercevoir"
    ],
    "apercevraient": [
        "apercevoir"
    ],
    "apercevrais": [
        "apercevoir"
    ],
    "apercevrait": [
        "apercevoir"
    ],
    "apercevras": [
        "apercevoir"
    ],
    "apercevrez": [
        "apercevoir"
    ],
    "apercevrons": [
        "apercevoir"
    ],
    "apercevront": [
        "apercevoir"
    ],
    "apercois": [
        "apercevoir"
    ],
    "apercoit": [
        "apercevoir"
    ],
    "apercoive": [
        "apercevoir"
    ],
    "apercoivent": [
        "apercevoir"
    ],
    "apercoives": [
        "apercevoir"
    ],
    "apercu": [
        "apercevoir",
        "apercu"
    ],
    "apercue": [
        "apercevoir"
    ],
    "apercues": [
        "apercevoir"
    ],
    "apercurent": [
        "apercevoir"
    ],
    "apercus": [
        "apercevoir",
        "apercu"
    ],
    "apercussent": [
        "apercevoir"
    ],
    "apercut": [
        "apercevoir"
    ],
    "apercumes": [
        "apercevoir"
    ],
    "apes": [
        "ape"
    ],
    "apesanteur": [
        "apesanteur"
    ],
    "apeura": [
        "apeurer"
    ],
    "apeuraient": [
        "apeurer"
    ],
    "apeurait": [
        "apeurer"
    ],
    "apeure": [
        "apeurer",
        "apeure"
    ],
    "apeurer": [
        "apeurer"
    ],
    "apeuree": [
        "apeurer",
        "apeure"
    ],
    "apeurees": [
        "apeurer",
        "apeure"
    ],
    "apeures": [
        "apeurer",
        "apeure"
    ],
    "apex": [
        "apex"
    ],
    "aphanipteres": [
        "aphaniptere"
    ],
    "aphasie": [
        "aphasie"
    ],
    "aphasique": [
        "aphasique"
    ],
    "aphasiques": [
        "aphasique"
    ],
    "aphone": [
        "aphone"
    ],
    "aphones": [
        "aphone"
    ],
    "aphonie": [
        "aphonie"
    ],
    "aphorisme": [
        "aphorisme"
    ],
    "aphorismes": [
        "aphorisme"
    ],
    "aphrodisiaque": [
        "aphrodisiaque"
    ],
    "aphrodisiaques": [
        "aphrodisiaque"
    ],
    "aphrodisie": [
        "aphrodisie"
    ],
    "aphrodite": [
        "aphrodite"
    ],
    "aphtes": [
        "aphte"
    ],
    "aphteuse": [
        "aphteux"
    ],
    "aphteux": [
        "aphteux"
    ],
    "apherese": [
        "apherese"
    ],
    "api": [
        "api"
    ],
    "apiculteur": [
        "apiculteur"
    ],
    "apiculteurs": [
        "apiculteur"
    ],
    "apicultrice": [
        "apiculteur"
    ],
    "apiculture": [
        "apiculture"
    ],
    "apion": [
        "apion"
    ],
    "apis": [
        "apis"
    ],
    "apitoie": [
        "apitoyer"
    ],
    "apitoiement": [
        "apitoiement"
    ],
    "apitoient": [
        "apitoyer"
    ],
    "apitoierai": [
        "apitoyer"
    ],
    "apitoierait": [
        "apitoyer"
    ],
    "apitoies": [
        "apitoyer"
    ],
    "apitoya": [
        "apitoyer"
    ],
    "apitoyaient": [
        "apitoyer"
    ],
    "apitoyait": [
        "apitoyer"
    ],
    "apitoyant": [
        "apitoyer"
    ],
    "apitoyer": [
        "apitoyer"
    ],
    "apitoyez": [
        "apitoyer"
    ],
    "apitoyons": [
        "apitoyer"
    ],
    "apitoyerent": [
        "apitoyer"
    ],
    "apitoye": [
        "apitoyer"
    ],
    "apitoyee": [
        "apitoyer"
    ],
    "apitoyees": [
        "apitoyer"
    ],
    "apitoyes": [
        "apitoyer"
    ],
    "apivore": [
        "apivore"
    ],
    "aplani": [
        "aplanir"
    ],
    "aplanie": [
        "aplanir"
    ],
    "aplanies": [
        "aplanir"
    ],
    "aplanir": [
        "aplanir"
    ],
    "aplanira": [
        "aplanir"
    ],
    "aplaniront": [
        "aplanir"
    ],
    "aplanis": [
        "aplanir"
    ],
    "aplanissaient": [
        "aplanir"
    ],
    "aplanissait": [
        "aplanir"
    ],
    "aplanissant": [
        "aplanir"
    ],
    "aplanissement": [
        "aplanissement"
    ],
    "aplanissez": [
        "aplanir"
    ],
    "aplanissons": [
        "aplanir"
    ],
    "aplanit": [
        "aplanir"
    ],
    "aplasie": [
        "aplasie"
    ],
    "aplat": [
        "aplat"
    ],
    "aplati": [
        "aplatir",
        "aplati"
    ],
    "aplatie": [
        "aplatir",
        "aplati"
    ],
    "aplaties": [
        "aplatir",
        "aplati"
    ],
    "aplatir": [
        "aplatir"
    ],
    "aplatirais": [
        "aplatir"
    ],
    "aplatirait": [
        "aplatir"
    ],
    "aplatirent": [
        "aplatir"
    ],
    "aplatirez": [
        "aplatir"
    ],
    "aplatis": [
        "aplatir",
        "aplati"
    ],
    "aplatissaient": [
        "aplatir"
    ],
    "aplatissais": [
        "aplatir"
    ],
    "aplatissait": [
        "aplatir"
    ],
    "aplatissant": [
        "aplatir"
    ],
    "aplatisse": [
        "aplatir"
    ],
    "aplatissement": [
        "aplatissement"
    ],
    "aplatissements": [
        "aplatissement"
    ],
    "aplatissent": [
        "aplatir"
    ],
    "aplatissez": [
        "aplatir"
    ],
    "aplatit": [
        "aplatir"
    ],
    "aplats": [
        "aplat"
    ],
    "aplomb": [
        "aplomb"
    ],
    "aplombs": [
        "aplomb"
    ],
    "apnee": [
        "apnee"
    ],
    "apocalypse": [
        "apocalypse"
    ],
    "apocalypses": [
        "apocalypse"
    ],
    "apocalyptique": [
        "apocalyptique"
    ],
    "apocalyptiques": [
        "apocalyptique"
    ],
    "apocope": [
        "apocope"
    ],
    "apocryphe": [
        "apocryphe"
    ],
    "apocryphes": [
        "apocryphe"
    ],
    "apodictique": [
        "apodictique"
    ],
    "apogee": [
        "apogee"
    ],
    "apolitique": [
        "apolitique"
    ],
    "apolitiques": [
        "apolitique"
    ],
    "apolitisme": [
        "apolitisme"
    ],
    "apollon": [
        "apollon"
    ],
    "apollons": [
        "apollon"
    ],
    "apologie": [
        "apologie"
    ],
    "apologiste": [
        "apologiste"
    ],
    "apologistes": [
        "apologiste"
    ],
    "apologue": [
        "apologue"
    ],
    "apologetique": [
        "apologetique"
    ],
    "apologetiques": [
        "apologetique"
    ],
    "aponevroses": [
        "aponevrose"
    ],
    "aponevrotique": [
        "aponevrotique"
    ],
    "apophtegmes": [
        "apophtegme"
    ],
    "apoplectique": [
        "apoplectique"
    ],
    "apoplectiques": [
        "apoplectique"
    ],
    "apoplexie": [
        "apoplexie"
    ],
    "apoplexies": [
        "apoplexie"
    ],
    "apoptose": [
        "apoptose"
    ],
    "apostasie": [
        "apostasie",
        "apostasier"
    ],
    "apostat": [
        "apostat"
    ],
    "apostate": [
        "apostat"
    ],
    "apostats": [
        "apostat"
    ],
    "apostillee": [
        "apostiller"
    ],
    "apostolat": [
        "apostolat"
    ],
    "apostolique": [
        "apostolique"
    ],
    "apostoliques": [
        "apostolique"
    ],
    "apostropha": [
        "apostropher"
    ],
    "apostrophaient": [
        "apostropher"
    ],
    "apostrophait": [
        "apostropher"
    ],
    "apostrophant": [
        "apostropher"
    ],
    "apostrophe": [
        "apostrophe",
        "apostropher"
    ],
    "apostrophent": [
        "apostropher"
    ],
    "apostropher": [
        "apostropher"
    ],
    "apostrophes": [
        "apostrophe",
        "apostropher"
    ],
    "apostropherent": [
        "apostropher"
    ],
    "apostrophee": [
        "apostropher"
    ],
    "apostume": [
        "apostume"
    ],
    "apostees": [
        "aposter"
    ],
    "apothicaire": [
        "apothicaire"
    ],
    "apothicairerie": [
        "apothicairerie"
    ],
    "apothicaires": [
        "apothicaire"
    ],
    "apotheose": [
        "apotheose"
    ],
    "apotheoses": [
        "apotheose"
    ],
    "apparais": [
        "apparaitre"
    ],
    "apparaissaient": [
        "apparaitre"
    ],
    "apparaissais": [
        "apparaitre"
    ],
    "apparaissait": [
        "apparaitre"
    ],
    "apparaissant": [
        "apparaissant",
        "apparaitre"
    ],
    "apparaisse": [
        "apparaitre"
    ],
    "apparaissent": [
        "apparaitre"
    ],
    "apparaissez": [
        "apparaitre"
    ],
    "apparaissiez": [
        "apparaitre"
    ],
    "apparaissions": [
        "apparaitre"
    ],
    "apparaissons": [
        "apparaitre"
    ],
    "apparat": [
        "apparat"
    ],
    "apparatchik": [
        "apparatchik"
    ],
    "apparatchiks": [
        "apparatchik"
    ],
    "apparats": [
        "apparat"
    ],
    "apparaux": [
        "apparaux"
    ],
    "apparait": [
        "apparaitre"
    ],
    "apparaitra": [
        "apparaitre"
    ],
    "apparaitrai": [
        "apparaitre"
    ],
    "apparaitraient": [
        "apparaitre"
    ],
    "apparaitrais": [
        "apparaitre"
    ],
    "apparaitrait": [
        "apparaitre"
    ],
    "apparaitras": [
        "apparaitre"
    ],
    "apparaitre": [
        "apparaitre"
    ],
    "apparaitrez": [
        "apparaitre"
    ],
    "apparaitrions": [
        "apparaitre"
    ],
    "apparaitrons": [
        "apparaitre"
    ],
    "apparaitront": [
        "apparaitre"
    ],
    "appareil": [
        "appareil"
    ],
    "appareilla": [
        "appareiller"
    ],
    "appareillage": [
        "appareillage"
    ],
    "appareillages": [
        "appareillage"
    ],
    "appareillaient": [
        "appareiller"
    ],
    "appareillait": [
        "appareiller"
    ],
    "appareillant": [
        "appareiller"
    ],
    "appareille": [
        "appareiller"
    ],
    "appareillent": [
        "appareiller"
    ],
    "appareiller": [
        "appareiller"
    ],
    "appareilleraient": [
        "appareiller"
    ],
    "appareillez": [
        "appareiller"
    ],
    "appareillions": [
        "appareiller"
    ],
    "appareillons": [
        "appareiller"
    ],
    "appareilles": [
        "appareiller"
    ],
    "appareils": [
        "appareil"
    ],
    "apparemment": [
        "apparemment"
    ],
    "apparence": [
        "apparence"
    ],
    "apparences": [
        "apparence"
    ],
    "apparent": [
        "apparent"
    ],
    "apparentaient": [
        "apparenter"
    ],
    "apparentait": [
        "apparenter"
    ],
    "apparentant": [
        "apparenter"
    ],
    "apparente": [
        "apparenter",
        "apparent",
        "apparente"
    ],
    "apparentement": [
        "apparentement"
    ],
    "apparentent": [
        "apparenter"
    ],
    "apparenter": [
        "apparenter"
    ],
    "apparentes": [
        "apparenter",
        "apparent",
        "apparente"
    ],
    "apparents": [
        "apparent"
    ],
    "apparentee": [
        "apparenter",
        "apparente"
    ],
    "appariait": [
        "apparier"
    ],
    "appariant": [
        "apparier"
    ],
    "apparie": [
        "apparier"
    ],
    "apparier": [
        "apparier"
    ],
    "appariteur": [
        "appariteur"
    ],
    "appariteurs": [
        "appariteur"
    ],
    "apparition": [
        "apparition"
    ],
    "apparitions": [
        "apparition"
    ],
    "appariee": [
        "apparier"
    ],
    "appariees": [
        "apparier"
    ],
    "apparies": [
        "apparier"
    ],
    "appart": [
        "appart"
    ],
    "appartement": [
        "appartement"
    ],
    "appartements": [
        "appartement"
    ],
    "appartenaient": [
        "appartenir"
    ],
    "appartenais": [
        "appartenir"
    ],
    "appartenait": [
        "appartenir"
    ],
    "appartenance": [
        "appartenance"
    ],
    "appartenances": [
        "appartenance"
    ],
    "appartenant": [
        "appartenant",
        "appartenir"
    ],
    "appartenez": [
        "appartenir"
    ],
    "apparteniez": [
        "appartenir"
    ],
    "appartenions": [
        "appartenir"
    ],
    "appartenir": [
        "appartenir"
    ],
    "appartenons": [
        "appartenir"
    ],
    "appartenu": [
        "appartenir"
    ],
    "appartenues": [
        "appartenir"
    ],
    "appartiendra": [
        "appartenir"
    ],
    "appartiendrai": [
        "appartenir"
    ],
    "appartiendraient": [
        "appartenir"
    ],
    "appartiendrais": [
        "appartenir"
    ],
    "appartiendrait": [
        "appartenir"
    ],
    "appartiendras": [
        "appartenir"
    ],
    "appartiendrons": [
        "appartenir"
    ],
    "appartiendront": [
        "appartenir"
    ],
    "appartienne": [
        "appartenir"
    ],
    "appartiennent": [
        "appartenir"
    ],
    "appartiens": [
        "appartenir"
    ],
    "appartient": [
        "appartenir"
    ],
    "appartins": [
        "appartenir"
    ],
    "appartinssent": [
        "appartenir"
    ],
    "appartint": [
        "appartenir"
    ],
    "apparts": [
        "appart"
    ],
    "apparu": [
        "apparaitre"
    ],
    "apparue": [
        "apparaitre"
    ],
    "apparues": [
        "apparaitre"
    ],
    "apparurent": [
        "apparaitre"
    ],
    "apparus": [
        "apparaitre"
    ],
    "apparussent": [
        "apparaitre"
    ],
    "apparut": [
        "apparaitre"
    ],
    "appas": [
        "appas"
    ],
    "appauvri": [
        "appauvrir"
    ],
    "appauvrie": [
        "appauvrir"
    ],
    "appauvries": [
        "appauvrir"
    ],
    "appauvrir": [
        "appauvrir"
    ],
    "appauvris": [
        "appauvrir"
    ],
    "appauvrissaient": [
        "appauvrir"
    ],
    "appauvrissait": [
        "appauvrir"
    ],
    "appauvrissant": [
        "appauvrissant"
    ],
    "appauvrissante": [
        "appauvrissant"
    ],
    "appauvrissement": [
        "appauvrissement"
    ],
    "appauvrissez": [
        "appauvrir"
    ],
    "appauvrissions": [
        "appauvrir"
    ],
    "appauvrissons": [
        "appauvrir"
    ],
    "appauvrit": [
        "appauvrir"
    ],
    "appeau": [
        "appeau"
    ],
    "appeaux": [
        "appeau"
    ],
    "appel": [
        "appel"
    ],
    "appela": [
        "appeler"
    ],
    "appelai": [
        "appeler"
    ],
    "appelaient": [
        "appeler"
    ],
    "appelais": [
        "appeler"
    ],
    "appelait": [
        "appeler"
    ],
    "appelant": [
        "appeler",
        "appelant"
    ],
    "appelants": [
        "appelant"
    ],
    "appeler": [
        "appeler"
    ],
    "appeleur": [
        "appeleur"
    ],
    "appelez": [
        "appeler"
    ],
    "appeliez": [
        "appeler"
    ],
    "appelions": [
        "appeler"
    ],
    "appellation": [
        "appellation"
    ],
    "appellations": [
        "appellation"
    ],
    "appelle": [
        "appeler"
    ],
    "appellent": [
        "appeler"
    ],
    "appellera": [
        "appeler"
    ],
    "appellerai": [
        "appeler"
    ],
    "appelleraient": [
        "appeler"
    ],
    "appellerais": [
        "appeler"
    ],
    "appellerait": [
        "appeler"
    ],
    "appelleras": [
        "appeler"
    ],
    "appellerez": [
        "appeler"
    ],
    "appelleriez": [
        "appeler"
    ],
    "appellerions": [
        "appeler"
    ],
    "appellerons": [
        "appeler"
    ],
    "appelleront": [
        "appeler"
    ],
    "appelles": [
        "appeler"
    ],
    "appelons": [
        "appeler"
    ],
    "appels": [
        "appel"
    ],
    "appelat": [
        "appeler"
    ],
    "appelerent": [
        "appeler"
    ],
    "appele": [
        "appele",
        "appeler"
    ],
    "appelee": [
        "appeler"
    ],
    "appelees": [
        "appeler"
    ],
    "appeles": [
        "appele",
        "appeler"
    ],
    "appendait": [
        "appendre"
    ],
    "appendice": [
        "appendice"
    ],
    "appendicectomie": [
        "appendicectomie"
    ],
    "appendices": [
        "appendix",
        "appendice"
    ],
    "appendicite": [
        "appendicite"
    ],
    "appendrait": [
        "appendre"
    ],
    "appendre": [
        "appendre"
    ],
    "appends": [
        "append",
        "appendre"
    ],
    "appendu": [
        "appendre"
    ],
    "appendues": [
        "appendre"
    ],
    "appendus": [
        "appendre"
    ],
    "appentis": [
        "appentis"
    ],
    "appert": [
        "appert"
    ],
    "appesanti": [
        "appesantir"
    ],
    "appesantie": [
        "appesantir"
    ],
    "appesanties": [
        "appesantir"
    ],
    "appesantir": [
        "appesantir"
    ],
    "appesantis": [
        "appesantir"
    ],
    "appesantissais": [
        "appesantir"
    ],
    "appesantissait": [
        "appesantir"
    ],
    "appesantissant": [
        "appesantir"
    ],
    "appesantissement": [
        "appesantissement"
    ],
    "appesantit": [
        "appesantir"
    ],
    "applaudi": [
        "applaudir"
    ],
    "applaudie": [
        "applaudir"
    ],
    "applaudies": [
        "applaudir"
    ],
    "applaudimetre": [
        "applaudimetre"
    ],
    "applaudir": [
        "applaudir"
    ],
    "applaudira": [
        "applaudir"
    ],
    "applaudirai": [
        "applaudir"
    ],
    "applaudiraient": [
        "applaudir"
    ],
    "applaudirais": [
        "applaudir"
    ],
    "applaudirait": [
        "applaudir"
    ],
    "applaudirent": [
        "applaudir"
    ],
    "applaudirez": [
        "applaudir"
    ],
    "applaudirons": [
        "applaudir"
    ],
    "applaudis": [
        "applaudir"
    ],
    "applaudissaient": [
        "applaudir"
    ],
    "applaudissais": [
        "applaudir"
    ],
    "applaudissait": [
        "applaudir"
    ],
    "applaudissant": [
        "applaudir"
    ],
    "applaudisse": [
        "applaudir"
    ],
    "applaudissement": [
        "applaudissement"
    ],
    "applaudissements": [
        "applaudissement"
    ],
    "applaudissent": [
        "applaudir"
    ],
    "applaudisseur": [
        "applaudisseur"
    ],
    "applaudissez": [
        "applaudir"
    ],
    "applaudissiez": [
        "applaudir"
    ],
    "applaudissions": [
        "applaudir"
    ],
    "applaudissons": [
        "applaudir"
    ],
    "applaudit": [
        "applaudir"
    ],
    "applaudimes": [
        "applaudir"
    ],
    "applicabilite": [
        "applicabilite"
    ],
    "applicable": [
        "applicable"
    ],
    "applicables": [
        "applicable"
    ],
    "applicateur": [
        "applicateur"
    ],
    "application": [
        "application"
    ],
    "applications": [
        "application"
    ],
    "appliqua": [
        "appliquer"
    ],
    "appliquai": [
        "appliquer"
    ],
    "appliquaient": [
        "appliquer"
    ],
    "appliquais": [
        "appliquer"
    ],
    "appliquait": [
        "appliquer"
    ],
    "appliquant": [
        "appliquer"
    ],
    "appliquasse": [
        "appliquer"
    ],
    "appliquassions": [
        "appliquer"
    ],
    "applique": [
        "applique",
        "appliquer"
    ],
    "appliquent": [
        "appliquer"
    ],
    "appliquer": [
        "appliquer"
    ],
    "appliquera": [
        "appliquer"
    ],
    "appliquerai": [
        "appliquer"
    ],
    "appliquerais": [
        "appliquer"
    ],
    "appliquerait": [
        "appliquer"
    ],
    "appliqueras": [
        "appliquer"
    ],
    "appliquerez": [
        "appliquer"
    ],
    "appliquerons": [
        "appliquer"
    ],
    "appliques": [
        "applique",
        "appliquer"
    ],
    "appliquez": [
        "appliquer"
    ],
    "appliquions": [
        "appliquer"
    ],
    "appliquons": [
        "appliquer"
    ],
    "appliquat": [
        "appliquer"
    ],
    "appliquerent": [
        "appliquer"
    ],
    "appliquee": [
        "applique",
        "appliquer"
    ],
    "appliquees": [
        "applique",
        "appliquer"
    ],
    "appoggiature": [
        "appoggiature"
    ],
    "appoggiatures": [
        "appoggiature"
    ],
    "appoint": [
        "appoint"
    ],
    "appointaient": [
        "appointer"
    ],
    "appointait": [
        "appointer"
    ],
    "appointe": [
        "appointer",
        "appointe"
    ],
    "appointements": [
        "appointement"
    ],
    "appointer": [
        "appointer"
    ],
    "appointee": [
        "appointer",
        "appointe"
    ],
    "appointes": [
        "appointer",
        "appointe"
    ],
    "appontage": [
        "appontage"
    ],
    "appontement": [
        "appontement"
    ],
    "apponter": [
        "apponter"
    ],
    "apport": [
        "apport"
    ],
    "apporta": [
        "apporter"
    ],
    "apportai": [
        "apporter"
    ],
    "apportaient": [
        "apporter"
    ],
    "apportais": [
        "apporter"
    ],
    "apportait": [
        "apporter"
    ],
    "apportant": [
        "apporter"
    ],
    "apportas": [
        "apporter"
    ],
    "apporte": [
        "apporter"
    ],
    "apportent": [
        "apporter"
    ],
    "apporter": [
        "apporter"
    ],
    "apportera": [
        "apporter"
    ],
    "apporterai": [
        "apporter"
    ],
    "apporteraient": [
        "apporter"
    ],
    "apporterais": [
        "apporter"
    ],
    "apporterait": [
        "apporter"
    ],
    "apporteras": [
        "apporter"
    ],
    "apporterez": [
        "apporter"
    ],
    "apporteriez": [
        "apporter"
    ],
    "apporterons": [
        "apporter"
    ],
    "apporteront": [
        "apporter"
    ],
    "apportes": [
        "apporter"
    ],
    "apportez": [
        "apporter"
    ],
    "apportiez": [
        "apporter"
    ],
    "apportions": [
        "apportion",
        "apporter"
    ],
    "apportons": [
        "apporter"
    ],
    "apports": [
        "apport"
    ],
    "apportat": [
        "apporter"
    ],
    "apporterent": [
        "apporter"
    ],
    "apportee": [
        "apporter"
    ],
    "apportees": [
        "apporter"
    ],
    "apposa": [
        "apposer"
    ],
    "apposai": [
        "apposer"
    ],
    "apposait": [
        "apposer"
    ],
    "apposant": [
        "apposer"
    ],
    "appose": [
        "apposer"
    ],
    "apposent": [
        "apposer"
    ],
    "apposer": [
        "apposer"
    ],
    "apposerait": [
        "apposer"
    ],
    "apposeras": [
        "apposer"
    ],
    "apposez": [
        "apposer"
    ],
    "apposition": [
        "apposition"
    ],
    "apposee": [
        "apposer"
    ],
    "apposees": [
        "apposer"
    ],
    "apposes": [
        "apposer"
    ],
    "apprenaient": [
        "apprendre"
    ],
    "apprenais": [
        "apprendre"
    ],
    "apprenait": [
        "apprendre"
    ],
    "apprenant": [
        "apprenant",
        "apprendre"
    ],
    "apprend": [
        "apprendre"
    ],
    "apprendra": [
        "apprendre"
    ],
    "apprendrai": [
        "apprendre"
    ],
    "apprendraient": [
        "apprendre"
    ],
    "apprendrais": [
        "apprendre"
    ],
    "apprendrait": [
        "apprendre"
    ],
    "apprendras": [
        "apprendre"
    ],
    "apprendre": [
        "apprendre"
    ],
    "apprendrez": [
        "apprendre"
    ],
    "apprendriez": [
        "apprendre"
    ],
    "apprendrions": [
        "apprendre"
    ],
    "apprendrons": [
        "apprendre"
    ],
    "apprendront": [
        "apprendre"
    ],
    "apprends": [
        "apprendre"
    ],
    "apprenez": [
        "apprendre"
    ],
    "appreniez": [
        "apprendre"
    ],
    "apprenions": [
        "apprendre"
    ],
    "apprenne": [
        "apprendre"
    ],
    "apprennent": [
        "apprendre"
    ],
    "apprennes": [
        "apprendre"
    ],
    "apprenons": [
        "apprendre"
    ],
    "apprenti": [
        "apprenti"
    ],
    "apprentie": [
        "apprenti"
    ],
    "apprenties": [
        "apprenti"
    ],
    "apprentis": [
        "apprenti"
    ],
    "apprentissage": [
        "apprentissage"
    ],
    "apprentissages": [
        "apprentissage"
    ],
    "apprirent": [
        "apprendre"
    ],
    "appris": [
        "apprendre",
        "appris"
    ],
    "apprise": [
        "apprendre",
        "appris"
    ],
    "apprises": [
        "apprendre",
        "appris"
    ],
    "apprissent": [
        "apprendre"
    ],
    "apprit": [
        "apprendre"
    ],
    "apprivoisa": [
        "apprivoiser"
    ],
    "apprivoisaient": [
        "apprivoiser"
    ],
    "apprivoisais": [
        "apprivoiser"
    ],
    "apprivoisait": [
        "apprivoiser"
    ],
    "apprivoisant": [
        "apprivoiser"
    ],
    "apprivoise": [
        "apprivoiser"
    ],
    "apprivoisent": [
        "apprivoiser"
    ],
    "apprivoiser": [
        "apprivoiser"
    ],
    "apprivoiserai": [
        "apprivoiser"
    ],
    "apprivoiseur": [
        "apprivoiseur"
    ],
    "apprivoisez": [
        "apprivoiser"
    ],
    "apprivoisons": [
        "apprivoiser"
    ],
    "apprivoiserent": [
        "apprivoiser"
    ],
    "apprivoisee": [
        "apprivoiser"
    ],
    "apprivoisees": [
        "apprivoiser"
    ],
    "apprivoises": [
        "apprivoiser"
    ],
    "approbateur": [
        "approbateur"
    ],
    "approbateurs": [
        "approbateur"
    ],
    "approbatif": [
        "approbatif"
    ],
    "approbation": [
        "approbation"
    ],
    "approbations": [
        "approbation"
    ],
    "approbativement": [
        "approbativement"
    ],
    "approbatrice": [
        "approbateur"
    ],
    "approcha": [
        "approcher"
    ],
    "approchai": [
        "approcher"
    ],
    "approchaient": [
        "approcher"
    ],
    "approchais": [
        "approcher"
    ],
    "approchait": [
        "approcher"
    ],
    "approchant": [
        "approchant",
        "approcher"
    ],
    "approchants": [
        "approchant"
    ],
    "approchassent": [
        "approcher"
    ],
    "approche": [
        "approche",
        "approcher"
    ],
    "approchent": [
        "approcher"
    ],
    "approcher": [
        "approcher"
    ],
    "approchera": [
        "approcher"
    ],
    "approcherai": [
        "approcher"
    ],
    "approcherais": [
        "approcher"
    ],
    "approcherait": [
        "approcher"
    ],
    "approcheras": [
        "approcher"
    ],
    "approcherez": [
        "approcher"
    ],
    "approcherions": [
        "approcher"
    ],
    "approcherons": [
        "approcher"
    ],
    "approcheront": [
        "approcher"
    ],
    "approches": [
        "approche",
        "approcher"
    ],
    "approchez": [
        "approcher"
    ],
    "approchiez": [
        "approcher"
    ],
    "approchions": [
        "approcher"
    ],
    "approchons": [
        "approcher"
    ],
    "approchames": [
        "approcher"
    ],
    "approchat": [
        "approcher"
    ],
    "approcherent": [
        "approcher"
    ],
    "approchee": [
        "approche",
        "approcher"
    ],
    "approchees": [
        "approcher"
    ],
    "approfondi": [
        "approfondi",
        "approfondir"
    ],
    "approfondie": [
        "approfondi",
        "approfondir"
    ],
    "approfondies": [
        "approfondi",
        "approfondir"
    ],
    "approfondir": [
        "approfondir"
    ],
    "approfondirai": [
        "approfondir"
    ],
    "approfondirent": [
        "approfondir"
    ],
    "approfondirions": [
        "approfondir"
    ],
    "approfondirons": [
        "approfondir"
    ],
    "approfondis": [
        "approfondi",
        "approfondir"
    ],
    "approfondissaient": [
        "approfondir"
    ],
    "approfondissais": [
        "approfondir"
    ],
    "approfondissait": [
        "approfondir"
    ],
    "approfondissant": [
        "approfondir"
    ],
    "approfondisse": [
        "approfondir"
    ],
    "approfondissement": [
        "approfondissement"
    ],
    "approfondissent": [
        "approfondir"
    ],
    "approfondissons": [
        "approfondir"
    ],
    "approfondit": [
        "approfondir"
    ],
    "appropriaient": [
        "approprier"
    ],
    "appropriait": [
        "approprier"
    ],
    "appropriant": [
        "approprier"
    ],
    "appropriation": [
        "appropriation"
    ],
    "appropriations": [
        "appropriation"
    ],
    "approprie": [
        "approprier",
        "approprie"
    ],
    "approprient": [
        "approprier"
    ],
    "approprier": [
        "approprier"
    ],
    "approprieraient": [
        "approprier"
    ],
    "approprierais": [
        "approprier"
    ],
    "approprierait": [
        "approprier"
    ],
    "approprieront": [
        "approprier"
    ],
    "appropriez": [
        "approprier"
    ],
    "appropriee": [
        "approprier",
        "approprie"
    ],
    "appropriees": [
        "approprier",
        "approprie"
    ],
    "appropries": [
        "approprier",
        "approprie"
    ],
    "approuva": [
        "approuver"
    ],
    "approuvai": [
        "approuver"
    ],
    "approuvaient": [
        "approuver"
    ],
    "approuvais": [
        "approuver"
    ],
    "approuvait": [
        "approuver"
    ],
    "approuvant": [
        "approuver"
    ],
    "approuve": [
        "approuver",
        "approuve"
    ],
    "approuvent": [
        "approuver"
    ],
    "approuver": [
        "approuver"
    ],
    "approuvera": [
        "approuver"
    ],
    "approuverai": [
        "approuver"
    ],
    "approuverais": [
        "approuver"
    ],
    "approuverait": [
        "approuver"
    ],
    "approuveras": [
        "approuver"
    ],
    "approuverons": [
        "approuver"
    ],
    "approuveront": [
        "approuver"
    ],
    "approuves": [
        "approuver",
        "approuve"
    ],
    "approuvez": [
        "approuver"
    ],
    "approuviez": [
        "approuver"
    ],
    "approuvions": [
        "approuver"
    ],
    "approuvons": [
        "approuver"
    ],
    "approuvames": [
        "approuver"
    ],
    "approuvat": [
        "approuver"
    ],
    "approuverent": [
        "approuver"
    ],
    "approuvee": [
        "approuver",
        "approuve"
    ],
    "approuvees": [
        "approuver",
        "approuve"
    ],
    "approvisionnait": [
        "approvisionner"
    ],
    "approvisionnant": [
        "approvisionner"
    ],
    "approvisionne": [
        "approvisionner"
    ],
    "approvisionnement": [
        "approvisionnement"
    ],
    "approvisionnements": [
        "approvisionnement"
    ],
    "approvisionnent": [
        "approvisionner"
    ],
    "approvisionner": [
        "approvisionner"
    ],
    "approvisionnera": [
        "approvisionner"
    ],
    "approvisionniez": [
        "approvisionner"
    ],
    "approvisionnons": [
        "approvisionner"
    ],
    "approvisionnee": [
        "approvisionner"
    ],
    "approvisionnees": [
        "approvisionner"
    ],
    "approvisionnes": [
        "approvisionner"
    ],
    "approximatif": [
        "approximatif"
    ],
    "approximatifs": [
        "approximatif"
    ],
    "approximation": [
        "approximation"
    ],
    "approximations": [
        "approximation"
    ],
    "approximative": [
        "approximatif"
    ],
    "approximativement": [
        "approximativement"
    ],
    "approximatives": [
        "approximatif"
    ],
    "apprecia": [
        "apprecier"
    ],
    "appreciable": [
        "appreciable"
    ],
    "appreciables": [
        "appreciable"
    ],
    "appreciai": [
        "apprecier"
    ],
    "appreciaient": [
        "apprecier"
    ],
    "appreciais": [
        "apprecier"
    ],
    "appreciait": [
        "apprecier"
    ],
    "appreciant": [
        "apprecier"
    ],
    "appreciateur": [
        "appreciateur"
    ],
    "appreciation": [
        "appreciation"
    ],
    "appreciations": [
        "appreciation"
    ],
    "appreciatrice": [
        "appreciateur"
    ],
    "apprecie": [
        "apprecier"
    ],
    "apprecient": [
        "apprecier"
    ],
    "apprecier": [
        "apprecier"
    ],
    "appreciera": [
        "apprecier"
    ],
    "apprecierai": [
        "apprecier"
    ],
    "apprecieraient": [
        "apprecier"
    ],
    "apprecierais": [
        "apprecier"
    ],
    "apprecierait": [
        "apprecier"
    ],
    "apprecieras": [
        "apprecier"
    ],
    "apprecierez": [
        "apprecier"
    ],
    "apprecieriez": [
        "apprecier"
    ],
    "apprecierions": [
        "apprecier"
    ],
    "apprecierons": [
        "apprecier"
    ],
    "apprecieront": [
        "apprecier"
    ],
    "apprecies": [
        "apprecier"
    ],
    "appreciez": [
        "apprecier"
    ],
    "appreciions": [
        "apprecier"
    ],
    "apprecions": [
        "apprecier"
    ],
    "appreciat": [
        "apprecier"
    ],
    "apprecierent": [
        "apprecier"
    ],
    "appreciee": [
        "apprecier"
    ],
    "appreciees": [
        "apprecier"
    ],
    "apprehendai": [
        "apprehender"
    ],
    "apprehendaient": [
        "apprehender"
    ],
    "apprehendais": [
        "apprehender"
    ],
    "apprehendait": [
        "apprehender"
    ],
    "apprehendant": [
        "apprehender"
    ],
    "apprehende": [
        "apprehender"
    ],
    "apprehendent": [
        "apprehender"
    ],
    "apprehender": [
        "apprehender"
    ],
    "apprehendera": [
        "apprehender"
    ],
    "apprehenderons": [
        "apprehender"
    ],
    "apprehendez": [
        "apprehender"
    ],
    "apprehendions": [
        "apprehender"
    ],
    "apprehendons": [
        "apprehender"
    ],
    "apprehendee": [
        "apprehender"
    ],
    "apprehendees": [
        "apprehender"
    ],
    "apprehendes": [
        "apprehender"
    ],
    "apprehensif": [
        "apprehensif"
    ],
    "apprehension": [
        "apprehension"
    ],
    "apprehensions": [
        "apprehension"
    ],
    "appret": [
        "appret"
    ],
    "appreta": [
        "appreter"
    ],
    "appretai": [
        "appreter"
    ],
    "appretaient": [
        "appreter"
    ],
    "appretais": [
        "appreter"
    ],
    "appretait": [
        "appreter"
    ],
    "appretant": [
        "appreter"
    ],
    "apprete": [
        "apprete",
        "appreter"
    ],
    "appretent": [
        "appreter"
    ],
    "appreter": [
        "appreter"
    ],
    "appreterait": [
        "appreter"
    ],
    "appretes": [
        "apprete",
        "appreter"
    ],
    "appretez": [
        "appreter"
    ],
    "appretiez": [
        "appreter"
    ],
    "appretions": [
        "appreter"
    ],
    "apprets": [
        "appret"
    ],
    "appreterent": [
        "appreter"
    ],
    "appretee": [
        "apprete",
        "appreter"
    ],
    "appretees": [
        "apprete",
        "appreter"
    ],
    "apprimes": [
        "apprendre"
    ],
    "appui": [
        "appui"
    ],
    "appuie": [
        "appuyer"
    ],
    "appuient": [
        "appuyer"
    ],
    "appuiera": [
        "appuyer"
    ],
    "appuierai": [
        "appuyer"
    ],
    "appuieraient": [
        "appuyer"
    ],
    "appuierais": [
        "appuyer"
    ],
    "appuierait": [
        "appuyer"
    ],
    "appuieras": [
        "appuyer"
    ],
    "appuierez": [
        "appuyer"
    ],
    "appuierons": [
        "appuyer"
    ],
    "appuieront": [
        "appuyer"
    ],
    "appuies": [
        "appuyer"
    ],
    "appuis": [
        "appui"
    ],
    "appuya": [
        "appuyer"
    ],
    "appuyai": [
        "appuyer"
    ],
    "appuyaient": [
        "appuyer"
    ],
    "appuyais": [
        "appuyer"
    ],
    "appuyait": [
        "appuyer"
    ],
    "appuyant": [
        "appuyer"
    ],
    "appuyer": [
        "appuyer"
    ],
    "appuyez": [
        "appuyer"
    ],
    "appuyiez": [
        "appuyer"
    ],
    "appuyons": [
        "appuyer"
    ],
    "appuyames": [
        "appuyer"
    ],
    "appuyat": [
        "appuyer"
    ],
    "appuyerent": [
        "appuyer"
    ],
    "appuye": [
        "appuye",
        "appuyer"
    ],
    "appuyee": [
        "appuye",
        "appuyer"
    ],
    "appuyees": [
        "appuye",
        "appuyer"
    ],
    "appuyes": [
        "appuye",
        "appuyer"
    ],
    "appat": [
        "appat"
    ],
    "appatais": [
        "appater"
    ],
    "appatant": [
        "appater"
    ],
    "appate": [
        "appater"
    ],
    "appatent": [
        "appater"
    ],
    "appater": [
        "appater"
    ],
    "appatera": [
        "appater"
    ],
    "appaterait": [
        "appater"
    ],
    "appates": [
        "appater"
    ],
    "appatez": [
        "appater"
    ],
    "appatons": [
        "appater"
    ],
    "appats": [
        "appat"
    ],
    "appatee": [
        "appater"
    ],
    "appatees": [
        "appater"
    ],
    "appetence": [
        "appetence"
    ],
    "appetences": [
        "appetence"
    ],
    "appetissant": [
        "appetissant"
    ],
    "appetissante": [
        "appetissant"
    ],
    "appetissantes": [
        "appetissant"
    ],
    "appetissants": [
        "appetissant"
    ],
    "appetit": [
        "appetit"
    ],
    "appetits": [
        "appetit"
    ],
    "aprem": [
        "aprem"
    ],
    "apreme": [
        "aprem"
    ],
    "apres": [
        "apres",
        "apre"
    ],
    "apte": [
        "apte"
    ],
    "aptes": [
        "apte"
    ],
    "aptitude": [
        "aptitude"
    ],
    "aptitudes": [
        "aptitude"
    ],
    "aptere": [
        "aptere"
    ],
    "apteres": [
        "aptere"
    ],
    "apurait": [
        "apurer"
    ],
    "apurer": [
        "apurer"
    ],
    "apure": [
        "apurer"
    ],
    "apures": [
        "apurer"
    ],
    "apali": [
        "apalir"
    ],
    "apalis": [
        "apalir"
    ],
    "aperitif": [
        "aperitif"
    ],
    "aperitifs": [
        "aperitif"
    ],
    "aperitive": [
        "aperitif"
    ],
    "aperitives": [
        "aperitif"
    ],
    "apero": [
        "apero"
    ],
    "aperos": [
        "apero"
    ],
    "apotre": [
        "apotre"
    ],
    "apotres": [
        "apotre"
    ],
    "aquaculture": [
        "aquaculture"
    ],
    "aquagym": [
        "aquagym"
    ],
    "aquaplane": [
        "aquaplane"
    ],
    "aquarellait": [
        "aquareller"
    ],
    "aquarelle": [
        "aquarelle"
    ],
    "aquarelles": [
        "aquarelle"
    ],
    "aquarelliste": [
        "aquarelliste"
    ],
    "aquarellistes": [
        "aquarelliste"
    ],
    "aquariophilie": [
        "aquariophilie"
    ],
    "aquarium": [
        "aquarium"
    ],
    "aquariums": [
        "aquarium"
    ],
    "aquatinte": [
        "aquatinte"
    ],
    "aquatique": [
        "aquatique"
    ],
    "aquatiques": [
        "aquatique"
    ],
    "aquavit": [
        "aquavit"
    ],
    "aqueduc": [
        "aqueduc"
    ],
    "aqueducs": [
        "aqueduc"
    ],
    "aqueuse": [
        "aqueux"
    ],
    "aqueuses": [
        "aqueux"
    ],
    "aqueux": [
        "aqueux"
    ],
    "aquifere": [
        "aquifere"
    ],
    "aquilin": [
        "aquilin"
    ],
    "aquilon": [
        "aquilon"
    ],
    "aquilons": [
        "aquilon"
    ],
    "aquitain": [
        "aquitain"
    ],
    "ara": [
        "ara"
    ],
    "arabe": [
        "arabe"
    ],
    "arabes": [
        "arabe"
    ],
    "arabesque": [
        "arabesque"
    ],
    "arabesques": [
        "arabesque"
    ],
    "arabica": [
        "arabica"
    ],
    "arabicas": [
        "arabica"
    ],
    "arabique": [
        "arabique"
    ],
    "arabisant": [
        "arabisant",
        "arabiser"
    ],
    "arabisants": [
        "arabisant"
    ],
    "arabise": [
        "arabiser"
    ],
    "arable": [
        "arable"
    ],
    "arables": [
        "arable"
    ],
    "arac": [
        "arac"
    ],
    "arachide": [
        "arachide"
    ],
    "arachides": [
        "arachide"
    ],
    "arachnide": [
        "arachnide"
    ],
    "arachnides": [
        "arachnide"
    ],
    "arachnoide": [
        "arachnoide"
    ],
    "arachnoides": [
        "arachnoide"
    ],
    "arachneen": [
        "arachneen"
    ],
    "arachneenne": [
        "arachneen"
    ],
    "arachneennes": [
        "arachneen"
    ],
    "aragonais": [
        "aragonais"
    ],
    "aragonaise": [
        "aragonais"
    ],
    "aragonite": [
        "aragonite"
    ],
    "araigne": [
        "araigne"
    ],
    "araignee": [
        "araignee"
    ],
    "araignees": [
        "araignee"
    ],
    "araire": [
        "araire"
    ],
    "arak": [
        "arak"
    ],
    "araldite": [
        "araldite"
    ],
    "aralia": [
        "aralia"
    ],
    "aramide": [
        "aramide"
    ],
    "aramon": [
        "aramon"
    ],
    "arameen": [
        "arameen"
    ],
    "arameenne": [
        "arameen"
    ],
    "araneeuse": [
        "araneeux"
    ],
    "arapedes": [
        "arapede"
    ],
    "aras": [
        "ara"
    ],
    "arasant": [
        "araser"
    ],
    "araser": [
        "araser"
    ],
    "arasee": [
        "araser"
    ],
    "aratoire": [
        "aratoire"
    ],
    "aratoires": [
        "aratoire"
    ],
    "araucan": [
        "araucan"
    ],
    "araucanien": [
        "araucanien"
    ],
    "araucaniennes": [
        "araucanien"
    ],
    "araucaniens": [
        "araucanien"
    ],
    "araucaria": [
        "araucaria"
    ],
    "araucarias": [
        "araucaria"
    ],
    "arbalete": [
        "arbalete"
    ],
    "arbaletes": [
        "arbalete"
    ],
    "arbaletrier": [
        "arbaletrier"
    ],
    "arbaletriers": [
        "arbaletrier"
    ],
    "arbi": [
        "arbi"
    ],
    "arbis": [
        "arbi"
    ],
    "arbitrage": [
        "arbitrage"
    ],
    "arbitrages": [
        "arbitrage"
    ],
    "arbitraire": [
        "arbitraire"
    ],
    "arbitrairement": [
        "arbitrairement"
    ],
    "arbitraires": [
        "arbitraire"
    ],
    "arbitrait": [
        "arbitrer"
    ],
    "arbitrale": [
        "arbitral"
    ],
    "arbitre": [
        "arbitrer",
        "arbitre"
    ],
    "arbitrer": [
        "arbitrer"
    ],
    "arbitrera": [
        "arbitrer"
    ],
    "arbitres": [
        "arbitrer",
        "arbitre"
    ],
    "arbitree": [
        "arbitrer"
    ],
    "arbitrees": [
        "arbitrer"
    ],
    "arbois": [
        "arbois"
    ],
    "arbora": [
        "arborer"
    ],
    "arboraient": [
        "arborer"
    ],
    "arborais": [
        "arborer"
    ],
    "arborait": [
        "arborer"
    ],
    "arborant": [
        "arborer"
    ],
    "arbore": [
        "arborer"
    ],
    "arborent": [
        "arborer"
    ],
    "arborer": [
        "arborer"
    ],
    "arborerait": [
        "arborer"
    ],
    "arbores": [
        "arborer"
    ],
    "arborescence": [
        "arborescence"
    ],
    "arborescences": [
        "arborescence"
    ],
    "arborescent": [
        "arborescent"
    ],
    "arborescentes": [
        "arborescent"
    ],
    "arborescents": [
        "arborescent"
    ],
    "arboretum": [
        "arboretum"
    ],
    "arborez": [
        "arborer"
    ],
    "arboricole": [
        "arboricole"
    ],
    "arboriculteur": [
        "arboriculteur"
    ],
    "arboriculture": [
        "arboriculture"
    ],
    "arborions": [
        "arborer"
    ],
    "arborisations": [
        "arborisation"
    ],
    "arborat": [
        "arborer"
    ],
    "arborerent": [
        "arborer"
    ],
    "arboree": [
        "arborer"
    ],
    "arbouse": [
        "arbouse"
    ],
    "arbouses": [
        "arbouse"
    ],
    "arbousiers": [
        "arbousier"
    ],
    "arbre": [
        "arbre"
    ],
    "arbres": [
        "arbre"
    ],
    "arbrisseau": [
        "arbrisseau"
    ],
    "arbrisseaux": [
        "arbrisseau"
    ],
    "arbuste": [
        "arbuste"
    ],
    "arbustes": [
        "arbuste"
    ],
    "arc": [
        "arc"
    ],
    "arcade": [
        "arcade"
    ],
    "arcades": [
        "arcade"
    ],
    "arcadien": [
        "arcadien"
    ],
    "arcadienne": [
        "arcadien"
    ],
    "arcadiens": [
        "arcadien"
    ],
    "arcan": [
        "arcan"
    ],
    "arcane": [
        "arcane"
    ],
    "arcanes": [
        "arcane"
    ],
    "arcans": [
        "arcan"
    ],
    "arcatures": [
        "arcature"
    ],
    "arceau": [
        "arceau"
    ],
    "arceaux": [
        "arceau"
    ],
    "archange": [
        "archange"
    ],
    "archanges": [
        "archange"
    ],
    "archangelique": [
        "archangelique"
    ],
    "archaique": [
        "archaique"
    ],
    "archaiques": [
        "archaique"
    ],
    "archaisant": [
        "archaisant"
    ],
    "archaisme": [
        "archaisme"
    ],
    "arche": [
        "arche"
    ],
    "archer": [
        "archer"
    ],
    "archers": [
        "archer"
    ],
    "arches": [
        "arche",
        "arch"
    ],
    "archet": [
        "archet"
    ],
    "archets": [
        "archet"
    ],
    "archeveche": [
        "archeveche"
    ],
    "archeveches": [
        "archeveche"
    ],
    "archeveque": [
        "archeveque"
    ],
    "archeveques": [
        "archeveque"
    ],
    "archi": [
        "archi"
    ],
    "archiatre": [
        "archiatre"
    ],
    "archicomble": [
        "archicomble"
    ],
    "archicombles": [
        "archicomble"
    ],
    "archiconnu": [
        "archiconnu"
    ],
    "archidiacre": [
        "archidiacre"
    ],
    "archidiocese": [
        "archidiocese"
    ],
    "archiduc": [
        "archiduc"
    ],
    "archiduchesse": [
        "archiduc"
    ],
    "archiducs": [
        "archiduc"
    ],
    "archie": [
        "archi-e"
    ],
    "archifaux": [
        "archifaux"
    ],
    "archimandrite": [
        "archimandrite"
    ],
    "archinulles": [
        "archinul"
    ],
    "archipel": [
        "archipel"
    ],
    "archipels": [
        "archipel"
    ],
    "archipretre": [
        "archipretre"
    ],
    "architecte": [
        "architecte"
    ],
    "architectes": [
        "architecte"
    ],
    "architectonie": [
        "architectonie"
    ],
    "architectonique": [
        "architectonique"
    ],
    "architectural": [
        "architectural"
    ],
    "architecturale": [
        "architectural"
    ],
    "architecturalement": [
        "architecturalement"
    ],
    "architecturales": [
        "architectural"
    ],
    "architecturant": [
        "architecturer"
    ],
    "architecturaux": [
        "architectural"
    ],
    "architecture": [
        "architecture",
        "architecturer"
    ],
    "architecturent": [
        "architecturer"
    ],
    "architectures": [
        "architecture"
    ],
    "architecturees": [
        "architecturer"
    ],
    "architrave": [
        "architrave"
    ],
    "archivage": [
        "archivage"
    ],
    "archive": [
        "archive",
        "archiver"
    ],
    "archiver": [
        "archiver"
    ],
    "archives": [
        "archive",
        "archiver"
    ],
    "archivez": [
        "archiver"
    ],
    "archivions": [
        "archiver"
    ],
    "archiviste": [
        "archiviste"
    ],
    "archivistes": [
        "archiviste"
    ],
    "archivolte": [
        "archivolte"
    ],
    "archivoltes": [
        "archivolte"
    ],
    "archivons": [
        "archiver"
    ],
    "archivees": [
        "archiver"
    ],
    "archiepiscopal": [
        "archiepiscopal"
    ],
    "archonte": [
        "archonte"
    ],
    "archeres": [
        "archer"
    ],
    "archeologie": [
        "archeologie"
    ],
    "archeologique": [
        "archeologique"
    ],
    "archeologiques": [
        "archeologique"
    ],
    "archeologue": [
        "archeologue"
    ],
    "archeologues": [
        "archeologue"
    ],
    "archeopteryx": [
        "archeopteryx"
    ],
    "archetypale": [
        "archetypal"
    ],
    "archetypaux": [
        "archetypal"
    ],
    "archetype": [
        "archetype"
    ],
    "archetypes": [
        "archetype"
    ],
    "arcs": [
        "arc"
    ],
    "arctique": [
        "arctique"
    ],
    "arctiques": [
        "arctique"
    ],
    "ardais": [
        "arder"
    ],
    "ardait": [
        "arder"
    ],
    "ardant": [
        "arder"
    ],
    "arde": [
        "arder"
    ],
    "ardemment": [
        "ardemment"
    ],
    "ardennais": [
        "ardennais"
    ],
    "ardennaise": [
        "ardennais"
    ],
    "ardent": [
        "ardent"
    ],
    "ardente": [
        "ardent"
    ],
    "ardentes": [
        "ardent"
    ],
    "ardents": [
        "ardent"
    ],
    "arder": [
        "arder"
    ],
    "ardeur": [
        "ardeur"
    ],
    "ardeurs": [
        "ardeur"
    ],
    "ardillon": [
        "ardillon"
    ],
    "ardillons": [
        "ardillon"
    ],
    "ardin": [
        "ardin"
    ],
    "ardito": [
        "ardito"
    ],
    "ardoise": [
        "ardoise"
    ],
    "ardoises": [
        "ardoise"
    ],
    "ardoisiere": [
        "ardoisier"
    ],
    "ardoisee": [
        "ardoise"
    ],
    "ardoisees": [
        "ardoiser"
    ],
    "ardre": [
        "ardre"
    ],
    "ardu": [
        "ardu"
    ],
    "ardue": [
        "ardu"
    ],
    "ardues": [
        "ardu"
    ],
    "ardus": [
        "ardu"
    ],
    "ardechois": [
        "ardechois"
    ],
    "ardechoise": [
        "ardechois"
    ],
    "ardument": [
        "ardument"
    ],
    "are": [
        "be",
        "are"
    ],
    "area": [
        "area"
    ],
    "arec": [
        "arec"
    ],
    "ares": [
        "are"
    ],
    "arganier": [
        "arganier"
    ],
    "arganiers": [
        "arganier"
    ],
    "argans": [
        "argan"
    ],
    "argent": [
        "argent"
    ],
    "argentait": [
        "argenter"
    ],
    "argente": [
        "argenter",
        "argente"
    ],
    "argenterie": [
        "argenterie"
    ],
    "argenteries": [
        "argenterie"
    ],
    "argentier": [
        "argentier"
    ],
    "argentiferes": [
        "argentifere"
    ],
    "argentin": [
        "argentin"
    ],
    "argentine": [
        "argentin"
    ],
    "argentines": [
        "argentine",
        "argentin"
    ],
    "argentins": [
        "argentin"
    ],
    "argenton": [
        "argenton"
    ],
    "argents": [
        "argent"
    ],
    "argentee": [
        "argenter",
        "argente"
    ],
    "argentees": [
        "argenter",
        "argente"
    ],
    "argentes": [
        "argenter",
        "argente"
    ],
    "argile": [
        "argile"
    ],
    "argiles": [
        "argile"
    ],
    "argileuse": [
        "argileux"
    ],
    "argileux": [
        "argileux"
    ],
    "argiliere": [
        "argiliere"
    ],
    "argol": [
        "argol"
    ],
    "argon": [
        "argon"
    ],
    "argonaute": [
        "argonaute"
    ],
    "argot": [
        "argot"
    ],
    "argotique": [
        "argotique"
    ],
    "argotiques": [
        "argotique"
    ],
    "argots": [
        "argot"
    ],
    "argougnasses": [
        "argougner"
    ],
    "argougne": [
        "argougner"
    ],
    "argousin": [
        "argousin"
    ],
    "argousins": [
        "argousin"
    ],
    "argua": [
        "arguer"
    ],
    "arguais": [
        "arguer"
    ],
    "arguait": [
        "arguer"
    ],
    "arguant": [
        "arguer"
    ],
    "argue": [
        "arguer"
    ],
    "arguer": [
        "arguer"
    ],
    "argument": [
        "argument"
    ],
    "argumenta": [
        "argumenter"
    ],
    "argumentaire": [
        "argumentaire"
    ],
    "argumentait": [
        "argumenter"
    ],
    "argumentant": [
        "argumenter"
    ],
    "argumentateur": [
        "argumentateur"
    ],
    "argumentatif": [
        "argumentatif"
    ],
    "argumentation": [
        "argumentation"
    ],
    "argumentations": [
        "argumentation"
    ],
    "argumente": [
        "argumenter"
    ],
    "argumentent": [
        "argumenter"
    ],
    "argumenter": [
        "argumenter"
    ],
    "argumenterai": [
        "argumenter"
    ],
    "argumentes": [
        "argumenter"
    ],
    "argumentez": [
        "argumenter"
    ],
    "arguments": [
        "argument"
    ],
    "argus": [
        "argus"
    ],
    "argutie": [
        "argutie"
    ],
    "arguties": [
        "argutie"
    ],
    "aria": [
        "aria"
    ],
    "arianisme": [
        "arianisme"
    ],
    "arias": [
        "aria"
    ],
    "aride": [
        "aride"
    ],
    "arides": [
        "aride"
    ],
    "aridite": [
        "aridite"
    ],
    "arien": [
        "arien"
    ],
    "arienne": [
        "arien"
    ],
    "ariens": [
        "arien"
    ],
    "ariettes": [
        "ariette"
    ],
    "arioso": [
        "arioso"
    ],
    "aristarque": [
        "aristarque"
    ],
    "aristarques": [
        "aristarque"
    ],
    "aristo": [
        "aristo"
    ],
    "aristocrate": [
        "aristocrate"
    ],
    "aristocrates": [
        "aristocrate"
    ],
    "aristocratie": [
        "aristocratie"
    ],
    "aristocratique": [
        "aristocratique"
    ],
    "aristocratiquement": [
        "aristocratiquement"
    ],
    "aristocratiques": [
        "aristocratique"
    ],
    "aristocratisme": [
        "aristocratisme"
    ],
    "aristoloche": [
        "aristoloche"
    ],
    "aristoloches": [
        "aristoloche"
    ],
    "aristos": [
        "aristo"
    ],
    "aristotelicien": [
        "aristotelicien"
    ],
    "aristotelicienne": [
        "aristotelicien"
    ],
    "arithmometre": [
        "arithmometre"
    ],
    "arithmetique": [
        "arithmetique"
    ],
    "arithmetiquement": [
        "arithmetiquement"
    ],
    "arithmetiques": [
        "arithmetique"
    ],
    "ariegeois": [
        "ariegeois"
    ],
    "ariegeoise": [
        "ariegeois"
    ],
    "arkose": [
        "arkose"
    ],
    "arlequin": [
        "arlequin"
    ],
    "arlequins": [
        "arlequin"
    ],
    "arlesien": [
        "arlesien"
    ],
    "arlesienne": [
        "arlesienne"
    ],
    "arlesiennes": [
        "arlesien"
    ],
    "arma": [
        "armer"
    ],
    "armada": [
        "armada"
    ],
    "armadas": [
        "armada"
    ],
    "armadille": [
        "armadille"
    ],
    "armagnac": [
        "armagnac"
    ],
    "armagnacs": [
        "armagnac"
    ],
    "armai": [
        "armer"
    ],
    "armaient": [
        "armer"
    ],
    "armait": [
        "armer"
    ],
    "armant": [
        "armer"
    ],
    "armateur": [
        "armateur"
    ],
    "armateurs": [
        "armateur"
    ],
    "armature": [
        "armature"
    ],
    "armaturent": [
        "armaturer"
    ],
    "armatures": [
        "armature"
    ],
    "arme": [
        "armer",
        "arme"
    ],
    "armement": [
        "armement"
    ],
    "armements": [
        "armement"
    ],
    "arment": [
        "armer"
    ],
    "armer": [
        "armer"
    ],
    "armeraient": [
        "armer"
    ],
    "armerais": [
        "armer"
    ],
    "armeront": [
        "armer"
    ],
    "armes": [
        "armer",
        "arme"
    ],
    "armez": [
        "armer"
    ],
    "armistice": [
        "armistice"
    ],
    "armistices": [
        "armistice"
    ],
    "armoire": [
        "armoire"
    ],
    "armoires": [
        "armoire"
    ],
    "armoirie": [
        "armoirie"
    ],
    "armoiries": [
        "armoirie"
    ],
    "armoise": [
        "armoise"
    ],
    "armoises": [
        "armoise"
    ],
    "armon": [
        "armon"
    ],
    "armons": [
        "armer"
    ],
    "armorial": [
        "armorial"
    ],
    "armoricaine": [
        "armoricain"
    ],
    "armorie": [
        "armorier"
    ],
    "armoriee": [
        "armorier"
    ],
    "armoriees": [
        "armorier"
    ],
    "armories": [
        "armorier"
    ],
    "armure": [
        "armure"
    ],
    "armurerie": [
        "armurerie"
    ],
    "armureries": [
        "armurerie"
    ],
    "armures": [
        "armure"
    ],
    "armurier": [
        "armurier"
    ],
    "armuriers": [
        "armurier"
    ],
    "armat": [
        "armer"
    ],
    "armee": [
        "armer",
        "arme",
        "armee"
    ],
    "armees": [
        "armer",
        "arme",
        "armee"
    ],
    "armenien": [
        "armenien"
    ],
    "armenienne": [
        "armenien"
    ],
    "armeniennes": [
        "armenien"
    ],
    "armeniens": [
        "armenien"
    ],
    "armenoide": [
        "armenoide"
    ],
    "armeria": [
        "armeria"
    ],
    "armerias": [
        "armeria"
    ],
    "arnaquait": [
        "arnaquer"
    ],
    "arnaquant": [
        "arnaquer"
    ],
    "arnaque": [
        "arnaque",
        "arnaquer"
    ],
    "arnaquent": [
        "arnaquer"
    ],
    "arnaquer": [
        "arnaquer"
    ],
    "arnaquera": [
        "arnaquer"
    ],
    "arnaques": [
        "arnaque",
        "arnaquer"
    ],
    "arnaqueur": [
        "arnaqueur"
    ],
    "arnaqueurs": [
        "arnaqueur"
    ],
    "arnaqueuse": [
        "arnaqueur"
    ],
    "arnaquez": [
        "arnaquer"
    ],
    "arnaquee": [
        "arnaquer"
    ],
    "arnica": [
        "arnica"
    ],
    "arobase": [
        "arobase"
    ],
    "aromate": [
        "aromate"
    ],
    "aromates": [
        "aromate"
    ],
    "aromatherapie": [
        "aromatherapie"
    ],
    "aromatique": [
        "aromatique"
    ],
    "aromatiques": [
        "aromatique"
    ],
    "aromatiser": [
        "aromatiser"
    ],
    "aromatise": [
        "aromatiser"
    ],
    "aromatisee": [
        "aromatiser"
    ],
    "aromatisees": [
        "aromatiser"
    ],
    "aromatises": [
        "aromatiser"
    ],
    "aronde": [
        "aronde"
    ],
    "arousal": [
        "arousal"
    ],
    "arpent": [
        "arpent"
    ],
    "arpenta": [
        "arpenter"
    ],
    "arpentage": [
        "arpentage"
    ],
    "arpentages": [
        "arpentage"
    ],
    "arpentai": [
        "arpenter"
    ],
    "arpentaient": [
        "arpenter"
    ],
    "arpentais": [
        "arpenter"
    ],
    "arpentait": [
        "arpenter"
    ],
    "arpentant": [
        "arpenter"
    ],
    "arpente": [
        "arpenter"
    ],
    "arpentent": [
        "arpenter"
    ],
    "arpenter": [
        "arpenter"
    ],
    "arpenterai": [
        "arpenter"
    ],
    "arpenteront": [
        "arpenter"
    ],
    "arpenteur": [
        "arpenteur"
    ],
    "arpenteurs": [
        "arpenteur"
    ],
    "arpentez": [
        "arpenter"
    ],
    "arpentions": [
        "arpenter"
    ],
    "arpentons": [
        "arpenter"
    ],
    "arpents": [
        "arpent"
    ],
    "arpenterent": [
        "arpenter"
    ],
    "arpentee": [
        "arpenter"
    ],
    "arpentes": [
        "arpenter"
    ],
    "arpette": [
        "arpette"
    ],
    "arpion": [
        "arpion"
    ],
    "arpions": [
        "arpion"
    ],
    "arpege": [
        "arpeger",
        "arpege"
    ],
    "arpeges": [
        "arpege"
    ],
    "arpete": [
        "arpete"
    ],
    "arpetes": [
        "arpete"
    ],
    "arqua": [
        "arquer"
    ],
    "arquaient": [
        "arquer"
    ],
    "arquait": [
        "arquer"
    ],
    "arquant": [
        "arquer"
    ],
    "arque": [
        "arque",
        "arquer"
    ],
    "arquebusade": [
        "arquebusade"
    ],
    "arquebuse": [
        "arquebuse"
    ],
    "arquebuses": [
        "arquebuse"
    ],
    "arquebusiers": [
        "arquebusier"
    ],
    "arquebusat": [
        "arquebuser"
    ],
    "arquent": [
        "arquer"
    ],
    "arquepince": [
        "arquepincer"
    ],
    "arquer": [
        "arquer"
    ],
    "arquee": [
        "arque",
        "arquer"
    ],
    "arquees": [
        "arque",
        "arquer"
    ],
    "arques": [
        "arque",
        "arquer"
    ],
    "arracha": [
        "arracher"
    ],
    "arrachage": [
        "arrachage"
    ],
    "arrachai": [
        "arracher"
    ],
    "arrachaient": [
        "arracher"
    ],
    "arrachais": [
        "arracher"
    ],
    "arrachait": [
        "arracher"
    ],
    "arrachant": [
        "arracher"
    ],
    "arrache": [
        "arracher",
        "arrache"
    ],
    "arrachement": [
        "arrachement"
    ],
    "arrachements": [
        "arrachement"
    ],
    "arrachent": [
        "arracher"
    ],
    "arracher": [
        "arracher"
    ],
    "arrachera": [
        "arracher"
    ],
    "arracherai": [
        "arracher"
    ],
    "arracheraient": [
        "arracher"
    ],
    "arracherais": [
        "arracher"
    ],
    "arracherait": [
        "arracher"
    ],
    "arracheras": [
        "arracher"
    ],
    "arracherons": [
        "arracher"
    ],
    "arracheront": [
        "arracher"
    ],
    "arraches": [
        "arracher",
        "arrache"
    ],
    "arracheur": [
        "arracheur"
    ],
    "arracheurs": [
        "arracheur"
    ],
    "arracheuse": [
        "arracheur"
    ],
    "arracheuses": [
        "arracheur"
    ],
    "arrachez": [
        "arracher"
    ],
    "arrachiez": [
        "arracher"
    ],
    "arrachions": [
        "arracher"
    ],
    "arrachons": [
        "arracher"
    ],
    "arrachures": [
        "arrachure"
    ],
    "arrachat": [
        "arracher"
    ],
    "arracherent": [
        "arracher"
    ],
    "arrachee": [
        "arracher",
        "arrache"
    ],
    "arrachees": [
        "arracher",
        "arrache"
    ],
    "arraisonner": [
        "arraisonner"
    ],
    "arraisonnerons": [
        "arraisonner"
    ],
    "arraisonne": [
        "arraisonner"
    ],
    "arraisonnees": [
        "arraisonner"
    ],
    "arraisonnes": [
        "arraisonner"
    ],
    "arrange": [
        "arranger"
    ],
    "arrangea": [
        "arranger"
    ],
    "arrangeai": [
        "arranger"
    ],
    "arrangeaient": [
        "arranger"
    ],
    "arrangeais": [
        "arranger"
    ],
    "arrangeait": [
        "arranger"
    ],
    "arrangeant": [
        "arrangeant",
        "arranger"
    ],
    "arrangeante": [
        "arrangeant"
    ],
    "arrangeantes": [
        "arrangeant"
    ],
    "arrangeants": [
        "arrangeant"
    ],
    "arrangement": [
        "arrangement"
    ],
    "arrangements": [
        "arrangement"
    ],
    "arrangent": [
        "arranger"
    ],
    "arrangeons": [
        "arranger"
    ],
    "arranger": [
        "arranger"
    ],
    "arrangera": [
        "arranger"
    ],
    "arrangerai": [
        "arranger"
    ],
    "arrangeraient": [
        "arranger"
    ],
    "arrangerais": [
        "arranger"
    ],
    "arrangerait": [
        "arranger"
    ],
    "arrangeras": [
        "arranger"
    ],
    "arrangerez": [
        "arranger"
    ],
    "arrangerions": [
        "arranger"
    ],
    "arrangerons": [
        "arranger"
    ],
    "arrangeront": [
        "arranger"
    ],
    "arranges": [
        "arrange",
        "arranger"
    ],
    "arrangeur": [
        "arrangeur"
    ],
    "arrangeurs": [
        "arrangeur"
    ],
    "arrangez": [
        "arranger"
    ],
    "arrangeat": [
        "arranger"
    ],
    "arrangiez": [
        "arranger"
    ],
    "arrangions": [
        "arranger"
    ],
    "arrangerent": [
        "arranger"
    ],
    "arrangee": [
        "arranger"
    ],
    "arrangees": [
        "arranger"
    ],
    "arrestation": [
        "arrestation"
    ],
    "arrestations": [
        "arrestation"
    ],
    "arrhes": [
        "arrhe"
    ],
    "arrima": [
        "arrimer"
    ],
    "arrimage": [
        "arrimage"
    ],
    "arrimais": [
        "arrimer"
    ],
    "arrimait": [
        "arrimer"
    ],
    "arrimant": [
        "arrimer"
    ],
    "arrime": [
        "arrimer"
    ],
    "arriment": [
        "arrimer"
    ],
    "arrimer": [
        "arrimer"
    ],
    "arrimez": [
        "arrimer"
    ],
    "arrimee": [
        "arrimer"
    ],
    "arrimees": [
        "arrimer"
    ],
    "arrimes": [
        "arrimer"
    ],
    "arriva": [
        "arriver"
    ],
    "arrivage": [
        "arrivage"
    ],
    "arrivages": [
        "arrivage"
    ],
    "arrivai": [
        "arriver"
    ],
    "arrivaient": [
        "arriver"
    ],
    "arrivais": [
        "arriver"
    ],
    "arrivait": [
        "arriver"
    ],
    "arrivant": [
        "arriver",
        "arrivant"
    ],
    "arrivante": [
        "arrivant"
    ],
    "arrivants": [
        "arrivant"
    ],
    "arrivas": [
        "arriver"
    ],
    "arrivassent": [
        "arriver"
    ],
    "arrive": [
        "arriver",
        "arrive"
    ],
    "arrivent": [
        "arriver"
    ],
    "arriver": [
        "arriver"
    ],
    "arrivera": [
        "arriver"
    ],
    "arriverai": [
        "arriver"
    ],
    "arriveraient": [
        "arriver"
    ],
    "arriverais": [
        "arriver"
    ],
    "arriverait": [
        "arriver"
    ],
    "arriveras": [
        "arriver"
    ],
    "arriverez": [
        "arriver"
    ],
    "arriveriez": [
        "arriver"
    ],
    "arriverions": [
        "arriver"
    ],
    "arriverons": [
        "arriver"
    ],
    "arriveront": [
        "arriver"
    ],
    "arrives": [
        "arriver",
        "arrive"
    ],
    "arrivez": [
        "arriver"
    ],
    "arriviez": [
        "arriver"
    ],
    "arrivions": [
        "arriver"
    ],
    "arrivisme": [
        "arrivisme"
    ],
    "arriviste": [
        "arriviste"
    ],
    "arrivistes": [
        "arriviste"
    ],
    "arrivons": [
        "arriver"
    ],
    "arrivames": [
        "arriver"
    ],
    "arrivat": [
        "arriver"
    ],
    "arrivates": [
        "arriver"
    ],
    "arriverent": [
        "arriver"
    ],
    "arrivee": [
        "arriver",
        "arrivee",
        "arrive"
    ],
    "arrivees": [
        "arriver",
        "arrivee",
        "arrive"
    ],
    "arriere": [
        "arrierer",
        "arriere"
    ],
    "arrieres": [
        "arrierer",
        "arriere"
    ],
    "arrieration": [
        "arrieration"
    ],
    "arrieree": [
        "arrierer",
        "arriere"
    ],
    "arrierees": [
        "arrierer",
        "arriere"
    ],
    "arrogamment": [
        "arrogamment"
    ],
    "arrogance": [
        "arrogance"
    ],
    "arrogant": [
        "arrogant"
    ],
    "arrogante": [
        "arrogant"
    ],
    "arrogantes": [
        "arrogant"
    ],
    "arrogants": [
        "arrogant"
    ],
    "arroge": [
        "arroger"
    ],
    "arrogeaient": [
        "arroger"
    ],
    "arrogeait": [
        "arroger"
    ],
    "arrogeant": [
        "arroger"
    ],
    "arrogent": [
        "arroger"
    ],
    "arroger": [
        "arroger"
    ],
    "arrogerent": [
        "arroger"
    ],
    "arrogee": [
        "arroger"
    ],
    "arroi": [
        "arroi"
    ],
    "arrondi": [
        "arrondir",
        "arrondi"
    ],
    "arrondie": [
        "arrondir",
        "arrondi"
    ],
    "arrondies": [
        "arrondir",
        "arrondi"
    ],
    "arrondir": [
        "arrondir"
    ],
    "arrondira": [
        "arrondir"
    ],
    "arrondirait": [
        "arrondir"
    ],
    "arrondirent": [
        "arrondir"
    ],
    "arrondis": [
        "arrondir",
        "arrondi"
    ],
    "arrondissaient": [
        "arrondir"
    ],
    "arrondissait": [
        "arrondir"
    ],
    "arrondissant": [
        "arrondir"
    ],
    "arrondissement": [
        "arrondissement"
    ],
    "arrondissements": [
        "arrondissement"
    ],
    "arrondissent": [
        "arrondir"
    ],
    "arrondissons": [
        "arrondir"
    ],
    "arrondit": [
        "arrondir"
    ],
    "arrosa": [
        "arroser"
    ],
    "arrosage": [
        "arrosage"
    ],
    "arrosaient": [
        "arroser"
    ],
    "arrosais": [
        "arroser"
    ],
    "arrosait": [
        "arroser"
    ],
    "arrosant": [
        "arroser"
    ],
    "arrose": [
        "arroser",
        "arrose"
    ],
    "arrosent": [
        "arroser"
    ],
    "arroser": [
        "arroser"
    ],
    "arrosera": [
        "arroser"
    ],
    "arroserais": [
        "arroser"
    ],
    "arroserait": [
        "arroser"
    ],
    "arroseras": [
        "arroser"
    ],
    "arroserez": [
        "arroser"
    ],
    "arroseront": [
        "arroser"
    ],
    "arroses": [
        "arroser",
        "arrose"
    ],
    "arroseur": [
        "arroseur"
    ],
    "arroseurs": [
        "arroseur"
    ],
    "arroseuse": [
        "arroseur"
    ],
    "arroseuses": [
        "arroseur"
    ],
    "arrosez": [
        "arroser"
    ],
    "arrosiez": [
        "arroser"
    ],
    "arrosions": [
        "arroser"
    ],
    "arrosoir": [
        "arrosoir"
    ],
    "arrosoirs": [
        "arrosoir"
    ],
    "arrosons": [
        "arroser"
    ],
    "arroserent": [
        "arroser"
    ],
    "arrosee": [
        "arroser",
        "arrose"
    ],
    "arrosees": [
        "arroser",
        "arrose"
    ],
    "arrerages": [
        "arrerage"
    ],
    "arret": [
        "arret"
    ],
    "arreta": [
        "arreter"
    ],
    "arretai": [
        "arreter"
    ],
    "arretaient": [
        "arreter"
    ],
    "arretais": [
        "arreter"
    ],
    "arretait": [
        "arreter"
    ],
    "arretant": [
        "arreter"
    ],
    "arretassent": [
        "arreter"
    ],
    "arrete": [
        "arrete",
        "arreter"
    ],
    "arretent": [
        "arreter"
    ],
    "arreter": [
        "arreter"
    ],
    "arretera": [
        "arreter"
    ],
    "arreterai": [
        "arreter"
    ],
    "arreteraient": [
        "arreter"
    ],
    "arreterais": [
        "arreter"
    ],
    "arreterait": [
        "arreter"
    ],
    "arreteras": [
        "arreter"
    ],
    "arreterez": [
        "arreter"
    ],
    "arreteriez": [
        "arreter"
    ],
    "arreterions": [
        "arreter"
    ],
    "arreterons": [
        "arreter"
    ],
    "arreteront": [
        "arreter"
    ],
    "arretes": [
        "arrete",
        "arreter"
    ],
    "arretez": [
        "arreter"
    ],
    "arretiez": [
        "arreter"
    ],
    "arretions": [
        "arreter"
    ],
    "arretons": [
        "arreter"
    ],
    "arrets": [
        "arret"
    ],
    "arretames": [
        "arreter"
    ],
    "arretat": [
        "arreter"
    ],
    "arreterent": [
        "arreter"
    ],
    "arretee": [
        "arrete",
        "arreter"
    ],
    "arretees": [
        "arrete",
        "arreter"
    ],
    "ars": [
        "ars",
        "ar"
    ],
    "arsacide": [
        "arsacide"
    ],
    "arsenal": [
        "arsenal"
    ],
    "arsenaux": [
        "arsenal"
    ],
    "arsenic": [
        "arsenic"
    ],
    "arsenicales": [
        "arsenical"
    ],
    "arsouille": [
        "arsouille"
    ],
    "arsouiller": [
        "arsouiller"
    ],
    "arsouilles": [
        "arsouille"
    ],
    "arsenieux": [
        "arsenieux"
    ],
    "art": [
        "art"
    ],
    "artefact": [
        "artefact"
    ],
    "artefacts": [
        "artefact"
    ],
    "arthrite": [
        "arthrite"
    ],
    "arthrites": [
        "arthrite"
    ],
    "arthritique": [
        "arthritique"
    ],
    "arthritiques": [
        "arthritique"
    ],
    "arthrodese": [
        "arthrodese"
    ],
    "arthropathie": [
        "arthropathie"
    ],
    "arthroplastie": [
        "arthroplastie"
    ],
    "arthropodes": [
        "arthropode"
    ],
    "arthroscopie": [
        "arthroscopie"
    ],
    "arthrose": [
        "arthrose"
    ],
    "arthroses": [
        "arthrose"
    ],
    "arthurien": [
        "arthurien"
    ],
    "arthurienne": [
        "arthurien"
    ],
    "arthuriens": [
        "arthurien"
    ],
    "artichaut": [
        "artichaut"
    ],
    "artichauts": [
        "artichaut"
    ],
    "artiche": [
        "artiche"
    ],
    "article": [
        "article"
    ],
    "articles": [
        "article"
    ],
    "articula": [
        "articuler"
    ],
    "articulai": [
        "articuler"
    ],
    "articulaient": [
        "articuler"
    ],
    "articulaire": [
        "articulaire"
    ],
    "articulaires": [
        "articulaire"
    ],
    "articulait": [
        "articuler"
    ],
    "articulant": [
        "articuler"
    ],
    "articulation": [
        "articulation"
    ],
    "articulations": [
        "articulation"
    ],
    "articule": [
        "articuler",
        "articule"
    ],
    "articulent": [
        "articuler"
    ],
    "articuler": [
        "articuler"
    ],
    "articulet": [
        "articulet"
    ],
    "articulez": [
        "articuler"
    ],
    "articulee": [
        "articuler",
        "articule"
    ],
    "articulees": [
        "articuler",
        "articule"
    ],
    "articules": [
        "articuler",
        "articule"
    ],
    "artifice": [
        "artifice"
    ],
    "artifices": [
        "artifice"
    ],
    "artificialite": [
        "artificialite"
    ],
    "artificiel": [
        "artificiel"
    ],
    "artificielle": [
        "artificiel"
    ],
    "artificiellement": [
        "artificiellement"
    ],
    "artificielles": [
        "artificiel"
    ],
    "artificiels": [
        "artificiel"
    ],
    "artificier": [
        "artificier"
    ],
    "artificiers": [
        "artificier"
    ],
    "artificieuse": [
        "artificieux"
    ],
    "artificieuses": [
        "artificieux"
    ],
    "artiflot": [
        "artiflot"
    ],
    "artiflots": [
        "artiflot"
    ],
    "artillerie": [
        "artillerie"
    ],
    "artilleur": [
        "artilleur"
    ],
    "artilleurs": [
        "artilleur"
    ],
    "artimon": [
        "artimon"
    ],
    "artisan": [
        "artisan"
    ],
    "artisanal": [
        "artisanal"
    ],
    "artisanale": [
        "artisanal"
    ],
    "artisanalement": [
        "artisanalement"
    ],
    "artisanales": [
        "artisanal"
    ],
    "artisanat": [
        "artisanat"
    ],
    "artisanaux": [
        "artisanal"
    ],
    "artisane": [
        "artisan"
    ],
    "artisans": [
        "artisan"
    ],
    "artison": [
        "artison"
    ],
    "artiste": [
        "artiste"
    ],
    "artistement": [
        "artistement"
    ],
    "artistes": [
        "artiste"
    ],
    "artistique": [
        "artistique"
    ],
    "artistiquement": [
        "artistiquement"
    ],
    "artistiques": [
        "artistique"
    ],
    "arts": [
        "art"
    ],
    "artere": [
        "artere"
    ],
    "arteres": [
        "artere"
    ],
    "arteriectomie": [
        "arteriectomie"
    ],
    "arteriel": [
        "arteriel"
    ],
    "arterielle": [
        "arteriel"
    ],
    "arterielles": [
        "arteriel"
    ],
    "arteriographie": [
        "arteriographie"
    ],
    "arteriole": [
        "arteriole"
    ],
    "arterioles": [
        "arteriole"
    ],
    "arteriopathie": [
        "arteriopathie"
    ],
    "arteriosclerose": [
        "arteriosclerose"
    ],
    "arterite": [
        "arterite"
    ],
    "artesien": [
        "artesien"
    ],
    "arum": [
        "arum"
    ],
    "arums": [
        "arum"
    ],
    "aruspice": [
        "aruspice"
    ],
    "aruspices": [
        "aruspice"
    ],
    "arverne": [
        "arverne"
    ],
    "arvernes": [
        "arverne"
    ],
    "aryen": [
        "aryen"
    ],
    "aryenne": [
        "aryen",
        "aryenne"
    ],
    "aryennes": [
        "aryen",
        "aryenne"
    ],
    "aryens": [
        "aryen"
    ],
    "arythmie": [
        "arythmie"
    ],
    "arythmique": [
        "arythmique"
    ],
    "arzels": [
        "arzel"
    ],
    "arcon": [
        "arcon"
    ],
    "arcons": [
        "arcon"
    ],
    "arene": [
        "arene"
    ],
    "arenes": [
        "arene"
    ],
    "areflexie": [
        "areflexie"
    ],
    "arena": [
        "arena"
    ],
    "areole": [
        "areole"
    ],
    "areoles": [
        "areole"
    ],
    "areopage": [
        "areopage"
    ],
    "areopages": [
        "areopage"
    ],
    "areopagite": [
        "areopagite"
    ],
    "arequier": [
        "arequier"
    ],
    "aretin": [
        "aretin"
    ],
    "arete": [
        "arete"
    ],
    "aretes": [
        "arete"
    ],
    "arome": [
        "arome"
    ],
    "aromes": [
        "arome"
    ],
    "as": [
        "avoir",
        "as"
    ],
    "asa": [
        "asa"
    ],
    "asana": [
        "asana"
    ],
    "asbeste": [
        "asbeste"
    ],
    "asbestose": [
        "asbestose"
    ],
    "ascaris": [
        "ascaris"
    ],
    "ascendance": [
        "ascendance"
    ],
    "ascendances": [
        "ascendance"
    ],
    "ascendant": [
        "ascendant"
    ],
    "ascendante": [
        "ascendant"
    ],
    "ascendantes": [
        "ascendant"
    ],
    "ascendants": [
        "ascendant"
    ],
    "ascendre": [
        "ascendre"
    ],
    "ascendu": [
        "ascendre"
    ],
    "ascenseur": [
        "ascenseur"
    ],
    "ascenseurs": [
        "ascenseur"
    ],
    "ascension": [
        "ascension"
    ],
    "ascensionne": [
        "ascensionner"
    ],
    "ascensionnel": [
        "ascensionnel"
    ],
    "ascensionnelle": [
        "ascensionnel"
    ],
    "ascensionnelles": [
        "ascensionnel"
    ],
    "ascensionner": [
        "ascensionner"
    ],
    "ascensions": [
        "ascension"
    ],
    "ascite": [
        "ascite"
    ],
    "asclepias": [
        "asclepias"
    ],
    "ascorbique": [
        "ascorbique"
    ],
    "ascot": [
        "ascot"
    ],
    "ascese": [
        "ascese"
    ],
    "asceses": [
        "ascese"
    ],
    "ascete": [
        "ascete"
    ],
    "ascetes": [
        "ascete"
    ],
    "ascetique": [
        "ascetique"
    ],
    "ascetiques": [
        "ascetique"
    ],
    "ascetisme": [
        "ascetisme"
    ],
    "asdic": [
        "asdic"
    ],
    "ase": [
        "as"
    ],
    "asepsie": [
        "asepsie"
    ],
    "aseptique": [
        "aseptique"
    ],
    "aseptiques": [
        "aseptique"
    ],
    "aseptisant": [
        "aseptiser"
    ],
    "aseptisation": [
        "aseptisation"
    ],
    "aseptise": [
        "aseptise",
        "aseptiser"
    ],
    "aseptisee": [
        "aseptise",
        "aseptiser"
    ],
    "aseptisees": [
        "aseptise"
    ],
    "aseptises": [
        "aseptise"
    ],
    "asexualite": [
        "asexualite"
    ],
    "asexuelle": [
        "asexuel"
    ],
    "asexue": [
        "asexue"
    ],
    "asexuee": [
        "asexue"
    ],
    "asexuees": [
        "asexue"
    ],
    "asexues": [
        "asexue"
    ],
    "ashanti": [
        "ashanti"
    ],
    "ashkenaze": [
        "ashkenaze"
    ],
    "ashkenazes": [
        "ashkenaze"
    ],
    "ashram": [
        "ashram"
    ],
    "asiate": [
        "asiate"
    ],
    "asiatique": [
        "asiatique"
    ],
    "asiatiques": [
        "asiatique"
    ],
    "asiatise": [
        "asiatiser"
    ],
    "asilaire": [
        "asilaire"
    ],
    "asile": [
        "asile"
    ],
    "asiles": [
        "asile"
    ],
    "asociabilite": [
        "asociabilite"
    ],
    "asocial": [
        "asocial"
    ],
    "asociale": [
        "asocial"
    ],
    "asociales": [
        "asocial"
    ],
    "asociaux": [
        "asocial"
    ],
    "asparagus": [
        "asparagus"
    ],
    "aspartam": [
        "aspartam"
    ],
    "aspartame": [
        "aspartame"
    ],
    "aspartique": [
        "aspartique"
    ],
    "aspect": [
        "aspect"
    ],
    "aspects": [
        "aspect"
    ],
    "asperge": [
        "asperger",
        "asperge"
    ],
    "aspergea": [
        "asperger"
    ],
    "aspergeaient": [
        "asperger"
    ],
    "aspergeait": [
        "asperger"
    ],
    "aspergeant": [
        "asperger"
    ],
    "aspergent": [
        "asperger"
    ],
    "asperger": [
        "asperger"
    ],
    "aspergerait": [
        "asperger"
    ],
    "asperges": [
        "asperger",
        "asperge"
    ],
    "aspergez": [
        "asperger"
    ],
    "aspergillose": [
        "aspergillose"
    ],
    "aspergillus": [
        "aspergillus"
    ],
    "aspergerent": [
        "asperger"
    ],
    "aspergee": [
        "asperger"
    ],
    "aspergees": [
        "asperger"
    ],
    "aspersion": [
        "aspersion"
    ],
    "aspersions": [
        "aspersion"
    ],
    "asphalte": [
        "asphalter",
        "asphalte"
    ],
    "asphalter": [
        "asphalter"
    ],
    "asphaltee": [
        "asphalter"
    ],
    "asphaltees": [
        "asphalter"
    ],
    "asphaltes": [
        "asphalter"
    ],
    "asphodele": [
        "asphodele"
    ],
    "asphodeles": [
        "asphodele"
    ],
    "asphyxia": [
        "asphyxier"
    ],
    "asphyxiaient": [
        "asphyxier"
    ],
    "asphyxiait": [
        "asphyxier"
    ],
    "asphyxiant": [
        "asphyxier",
        "asphyxiant"
    ],
    "asphyxiante": [
        "asphyxiant"
    ],
    "asphyxiants": [
        "asphyxiant"
    ],
    "asphyxie": [
        "asphyxie",
        "asphyxier"
    ],
    "asphyxient": [
        "asphyxier"
    ],
    "asphyxier": [
        "asphyxier"
    ],
    "asphyxiera": [
        "asphyxier"
    ],
    "asphyxiee": [
        "asphyxie",
        "asphyxier"
    ],
    "asphyxiees": [
        "asphyxie",
        "asphyxier"
    ],
    "asphyxies": [
        "asphyxie",
        "asphyxier"
    ],
    "aspi": [
        "aspi"
    ],
    "aspic": [
        "aspic"
    ],
    "aspics": [
        "aspic"
    ],
    "aspidistra": [
        "aspidistra"
    ],
    "aspidistras": [
        "aspidistra"
    ],
    "aspira": [
        "aspirer"
    ],
    "aspirai": [
        "aspirer"
    ],
    "aspiraient": [
        "aspirer"
    ],
    "aspirais": [
        "aspirer"
    ],
    "aspirait": [
        "aspirer"
    ],
    "aspirant": [
        "aspirer",
        "aspirant"
    ],
    "aspirante": [
        "aspirant"
    ],
    "aspirantes": [
        "aspirant"
    ],
    "aspirants": [
        "aspirant"
    ],
    "aspirateur": [
        "aspirateur"
    ],
    "aspirateurs": [
        "aspirateur"
    ],
    "aspiration": [
        "aspiration"
    ],
    "aspirations": [
        "aspiration"
    ],
    "aspire": [
        "aspire",
        "aspirer"
    ],
    "aspirent": [
        "aspirer"
    ],
    "aspirer": [
        "aspirer"
    ],
    "aspirera": [
        "aspirer"
    ],
    "aspireraient": [
        "aspirer"
    ],
    "aspirerait": [
        "aspirer"
    ],
    "aspires": [
        "aspire",
        "aspirer"
    ],
    "aspirez": [
        "aspirer"
    ],
    "aspiriez": [
        "aspirer"
    ],
    "aspirine": [
        "aspirine"
    ],
    "aspirines": [
        "aspirine"
    ],
    "aspirions": [
        "aspirer"
    ],
    "aspirons": [
        "aspirer"
    ],
    "aspirat": [
        "aspirer"
    ],
    "aspiree": [
        "aspire",
        "aspirer"
    ],
    "aspirees": [
        "aspire",
        "aspirer"
    ],
    "aspis": [
        "aspi"
    ],
    "aspre": [
        "aspre"
    ],
    "aspecifique": [
        "aspecifique"
    ],
    "asperite": [
        "asperite"
    ],
    "asperites": [
        "asperite"
    ],
    "assagi": [
        "assagir",
        "assagi"
    ],
    "assagie": [
        "assagir",
        "assagi"
    ],
    "assagir": [
        "assagir"
    ],
    "assagirai": [
        "assagir"
    ],
    "assagis": [
        "assagir",
        "assagi"
    ],
    "assagissant": [
        "assagir"
    ],
    "assagisse": [
        "assagir"
    ],
    "assagit": [
        "assagir"
    ],
    "assaillaient": [
        "assaillir"
    ],
    "assaillait": [
        "assaillir"
    ],
    "assaillant": [
        "assaillant",
        "assaillir"
    ],
    "assaillante": [
        "assaillant"
    ],
    "assaillants": [
        "assaillant"
    ],
    "assaille": [
        "assaillir"
    ],
    "assaillent": [
        "assaillir"
    ],
    "assailles": [
        "assaillir"
    ],
    "assailli": [
        "assaillir"
    ],
    "assaillie": [
        "assaillir"
    ],
    "assaillies": [
        "assaillir"
    ],
    "assaillir": [
        "assaillir"
    ],
    "assaillira": [
        "assaillir"
    ],
    "assaillirent": [
        "assaillir"
    ],
    "assaillis": [
        "assaillir"
    ],
    "assaillit": [
        "assaillir"
    ],
    "assaillons": [
        "assaillir"
    ],
    "assaini": [
        "assainir"
    ],
    "assainie": [
        "assainir"
    ],
    "assainir": [
        "assainir"
    ],
    "assainirait": [
        "assainir"
    ],
    "assainis": [
        "assainir"
    ],
    "assainissement": [
        "assainissement"
    ],
    "assaisonna": [
        "assaisonner"
    ],
    "assaisonnait": [
        "assaisonner"
    ],
    "assaisonne": [
        "assaisonner"
    ],
    "assaisonnement": [
        "assaisonnement"
    ],
    "assaisonnements": [
        "assaisonnement"
    ],
    "assaisonner": [
        "assaisonner"
    ],
    "assaisonnerait": [
        "assaisonner"
    ],
    "assaisonnerent": [
        "assaisonner"
    ],
    "assaisonnee": [
        "assaisonner"
    ],
    "assaisonnees": [
        "assaisonner"
    ],
    "assaisonnes": [
        "assaisonner"
    ],
    "assassin": [
        "assassin"
    ],
    "assassina": [
        "assassiner"
    ],
    "assassinai": [
        "assassiner"
    ],
    "assassinaient": [
        "assassiner"
    ],
    "assassinais": [
        "assassiner"
    ],
    "assassinait": [
        "assassiner"
    ],
    "assassinant": [
        "assassiner"
    ],
    "assassinat": [
        "assassinat"
    ],
    "assassinats": [
        "assassinat"
    ],
    "assassine": [
        "assassiner",
        "assassine",
        "assassin"
    ],
    "assassinent": [
        "assassiner"
    ],
    "assassiner": [
        "assassiner"
    ],
    "assassinera": [
        "assassiner"
    ],
    "assassinerai": [
        "assassiner"
    ],
    "assassinerais": [
        "assassiner"
    ],
    "assassinerez": [
        "assassiner"
    ],
    "assassines": [
        "assassiner",
        "assassine",
        "assassin"
    ],
    "assassinez": [
        "assassiner"
    ],
    "assassinons": [
        "assassiner"
    ],
    "assassins": [
        "assassin"
    ],
    "assassinee": [
        "assassiner",
        "assassine"
    ],
    "assassinees": [
        "assassiner",
        "assassine"
    ],
    "assaut": [
        "assaut"
    ],
    "assauts": [
        "assaut"
    ],
    "assavoir": [
        "assavoir"
    ],
    "asse": [
        "asse"
    ],
    "asseau": [
        "asseau"
    ],
    "assembla": [
        "assembler"
    ],
    "assemblage": [
        "assemblage"
    ],
    "assemblages": [
        "assemblage"
    ],
    "assemblaient": [
        "assembler"
    ],
    "assemblait": [
        "assembler"
    ],
    "assemblant": [
        "assembler"
    ],
    "assemble": [
        "assembler",
        "assemble"
    ],
    "assemblent": [
        "assembler"
    ],
    "assembler": [
        "assembler"
    ],
    "assemblera": [
        "assembler"
    ],
    "assemblerez": [
        "assembler"
    ],
    "assembleur": [
        "assembleur"
    ],
    "assembleurs": [
        "assembleur"
    ],
    "assemblez": [
        "assembler"
    ],
    "assemblons": [
        "assembler"
    ],
    "assemblee": [
        "assembler",
        "assemblee"
    ],
    "assemblees": [
        "assembler",
        "assemblee"
    ],
    "assembles": [
        "assembler",
        "assemble"
    ],
    "assena": [
        "assener"
    ],
    "assenai": [
        "assener"
    ],
    "assenaient": [
        "assener"
    ],
    "assenais": [
        "assener"
    ],
    "assenait": [
        "assener"
    ],
    "assenant": [
        "assener"
    ],
    "assener": [
        "assener"
    ],
    "assentiment": [
        "assentiment"
    ],
    "assentiments": [
        "assentiment"
    ],
    "assene": [
        "assener"
    ],
    "assenee": [
        "assener"
    ],
    "assenees": [
        "assener"
    ],
    "assenes": [
        "assener"
    ],
    "asseoir": [
        "asseoir"
    ],
    "assermenter": [
        "assermenter"
    ],
    "assermentez": [
        "assermenter"
    ],
    "assermente": [
        "assermente",
        "assermenter"
    ],
    "assermentee": [
        "assermenter"
    ],
    "assermentes": [
        "assermente",
        "assermenter"
    ],
    "assertion": [
        "assertion"
    ],
    "assertions": [
        "assertion"
    ],
    "asservi": [
        "asservi",
        "asservir"
    ],
    "asservie": [
        "asservi",
        "asservir"
    ],
    "asservies": [
        "asservi",
        "asservir"
    ],
    "asservir": [
        "asservir"
    ],
    "asservirai": [
        "asservir"
    ],
    "asservirait": [
        "asservir"
    ],
    "asserviront": [
        "asservir"
    ],
    "asservis": [
        "asservi",
        "asservir"
    ],
    "asservissaient": [
        "asservir"
    ],
    "asservissait": [
        "asservir"
    ],
    "asservissant": [
        "asservissant",
        "asservir"
    ],
    "asservissement": [
        "asservissement"
    ],
    "asservissements": [
        "asservissement"
    ],
    "asservissent": [
        "asservir"
    ],
    "asservit": [
        "asservir"
    ],
    "assesseur": [
        "assesseur"
    ],
    "assesseurs": [
        "assesseur"
    ],
    "asseyaient": [
        "asseoir"
    ],
    "asseyais": [
        "asseoir"
    ],
    "asseyait": [
        "asseoir"
    ],
    "asseyant": [
        "asseoir"
    ],
    "asseye": [
        "asseoir"
    ],
    "asseyent": [
        "asseoir"
    ],
    "asseyes": [
        "asseoir"
    ],
    "asseyez": [
        "asseoir"
    ],
    "asseyiez": [
        "asseoir"
    ],
    "asseyions": [
        "asseoir"
    ],
    "asseyons": [
        "asseoir"
    ],
    "assez": [
        "assez"
    ],
    "assidu": [
        "assidu"
    ],
    "assidue": [
        "assidu"
    ],
    "assidues": [
        "assidu"
    ],
    "assiduite": [
        "assiduite"
    ],
    "assiduites": [
        "assiduite"
    ],
    "assidus": [
        "assidu"
    ],
    "assidument": [
        "assidument"
    ],
    "assied": [
        "asseoir"
    ],
    "assieds": [
        "asseoir"
    ],
    "assiette": [
        "assiette"
    ],
    "assiettes": [
        "assiette"
    ],
    "assiettee": [
        "assiettee"
    ],
    "assiettees": [
        "assiettee"
    ],
    "assigna": [
        "assigner"
    ],
    "assignai": [
        "assigner"
    ],
    "assignais": [
        "assigner"
    ],
    "assignait": [
        "assigner"
    ],
    "assignant": [
        "assigner"
    ],
    "assignation": [
        "assignation"
    ],
    "assignations": [
        "assignation"
    ],
    "assignats": [
        "assignat"
    ],
    "assigne": [
        "assigner"
    ],
    "assignement": [
        "assignement"
    ],
    "assignent": [
        "assigner"
    ],
    "assigner": [
        "assigner"
    ],
    "assignera": [
        "assigner"
    ],
    "assignerai": [
        "assigner"
    ],
    "assignerait": [
        "assigner"
    ],
    "assignerons": [
        "assigner"
    ],
    "assigneront": [
        "assigner"
    ],
    "assignes": [
        "assigner"
    ],
    "assignee": [
        "assigner"
    ],
    "assignees": [
        "assigner",
        "assignee"
    ],
    "assimila": [
        "assimiler"
    ],
    "assimilable": [
        "assimilable"
    ],
    "assimilables": [
        "assimilable"
    ],
    "assimilaient": [
        "assimiler"
    ],
    "assimilais": [
        "assimiler"
    ],
    "assimilait": [
        "assimiler"
    ],
    "assimilant": [
        "assimiler",
        "assimilant"
    ],
    "assimilateurs": [
        "assimilateur"
    ],
    "assimilation": [
        "assimilation"
    ],
    "assimilations": [
        "assimilation"
    ],
    "assimile": [
        "assimiler",
        "assimile"
    ],
    "assimilent": [
        "assimiler"
    ],
    "assimiler": [
        "assimiler"
    ],
    "assimilerait": [
        "assimiler"
    ],
    "assimilez": [
        "assimiler"
    ],
    "assimilerent": [
        "assimiler"
    ],
    "assimilee": [
        "assimiler",
        "assimile"
    ],
    "assimilees": [
        "assimiler",
        "assimile"
    ],
    "assimiles": [
        "assimiler",
        "assimile"
    ],
    "assirent": [
        "asseoir"
    ],
    "assis": [
        "assis",
        "asseoir"
    ],
    "assise": [
        "assise",
        "assis",
        "asseoir"
    ],
    "assises": [
        "assise",
        "assis",
        "asseoir"
    ],
    "assista": [
        "assister"
    ],
    "assistai": [
        "assister"
    ],
    "assistaient": [
        "assister"
    ],
    "assistais": [
        "assister"
    ],
    "assistait": [
        "assister"
    ],
    "assistanat": [
        "assistanat"
    ],
    "assistance": [
        "assistance"
    ],
    "assistances": [
        "assistance"
    ],
    "assistant": [
        "assistant",
        "assister"
    ],
    "assistante": [
        "assistant"
    ],
    "assistantes": [
        "assistant"
    ],
    "assistants": [
        "assistant"
    ],
    "assistas": [
        "assister"
    ],
    "assiste": [
        "assister",
        "assiste"
    ],
    "assistent": [
        "assister"
    ],
    "assister": [
        "assister"
    ],
    "assistera": [
        "assister"
    ],
    "assisterai": [
        "assister"
    ],
    "assisteraient": [
        "assister"
    ],
    "assisterais": [
        "assister"
    ],
    "assisterait": [
        "assister"
    ],
    "assisteras": [
        "assister"
    ],
    "assisterez": [
        "assister"
    ],
    "assisteriez": [
        "assister"
    ],
    "assisterons": [
        "assister"
    ],
    "assisteront": [
        "assister"
    ],
    "assistez": [
        "assister"
    ],
    "assistiez": [
        "assister"
    ],
    "assistions": [
        "assister"
    ],
    "assistons": [
        "assister"
    ],
    "assistames": [
        "assister"
    ],
    "assistat": [
        "assister"
    ],
    "assisterent": [
        "assister"
    ],
    "assistee": [
        "assister",
        "assiste"
    ],
    "assistees": [
        "assister",
        "assiste"
    ],
    "assistes": [
        "assister",
        "assiste"
    ],
    "assit": [
        "asseoir"
    ],
    "assiege": [
        "assiege",
        "assieger"
    ],
    "assiegent": [
        "assieger"
    ],
    "assiegea": [
        "assieger"
    ],
    "assiegeaient": [
        "assieger"
    ],
    "assiegeait": [
        "assieger"
    ],
    "assiegeant": [
        "assiegeant",
        "assieger"
    ],
    "assiegeantes": [
        "assiegeant"
    ],
    "assiegeants": [
        "assiegeant"
    ],
    "assieger": [
        "assieger"
    ],
    "assiegera": [
        "assieger"
    ],
    "assiegeraient": [
        "assieger"
    ],
    "assiegee": [
        "assiege",
        "assieger"
    ],
    "assiegees": [
        "assiege",
        "assieger"
    ],
    "assieges": [
        "assiege",
        "assieger"
    ],
    "assiera": [
        "asseoir"
    ],
    "assierai": [
        "asseoir"
    ],
    "assierais": [
        "asseoir"
    ],
    "assierait": [
        "asseoir"
    ],
    "assieras": [
        "asseoir"
    ],
    "assierions": [
        "asseoir"
    ],
    "assieront": [
        "asseoir"
    ],
    "associa": [
        "associer"
    ],
    "associai": [
        "associer"
    ],
    "associaient": [
        "associer"
    ],
    "associais": [
        "associer"
    ],
    "associait": [
        "associer"
    ],
    "associant": [
        "associer"
    ],
    "associassent": [
        "associer"
    ],
    "associatifs": [
        "associatif"
    ],
    "association": [
        "association"
    ],
    "associations": [
        "association"
    ],
    "associative": [
        "associatif"
    ],
    "associe": [
        "associer",
        "associe"
    ],
    "associent": [
        "associer"
    ],
    "associer": [
        "associer"
    ],
    "associera": [
        "associer"
    ],
    "associerai": [
        "associer"
    ],
    "associeraient": [
        "associer"
    ],
    "associerais": [
        "associer"
    ],
    "associerait": [
        "associer"
    ],
    "associeront": [
        "associer"
    ],
    "associez": [
        "associer"
    ],
    "associions": [
        "associer"
    ],
    "associons": [
        "associer"
    ],
    "associat": [
        "associer"
    ],
    "associerent": [
        "associer"
    ],
    "associee": [
        "associer",
        "associe"
    ],
    "associees": [
        "associer",
        "associe"
    ],
    "associes": [
        "associer",
        "associe"
    ],
    "assoie": [
        "asseoir"
    ],
    "assoient": [
        "asseoir"
    ],
    "assoies": [
        "asseoir"
    ],
    "assoiffent": [
        "assoiffer"
    ],
    "assoiffer": [
        "assoiffer"
    ],
    "assoiffez": [
        "assoiffer"
    ],
    "assoiffe": [
        "assoiffe",
        "assoiffer"
    ],
    "assoiffee": [
        "assoiffe",
        "assoiffer"
    ],
    "assoiffees": [
        "assoiffe",
        "assoiffer"
    ],
    "assoiffes": [
        "assoiffe",
        "assoiffer"
    ],
    "assoira": [
        "asseoir"
    ],
    "assoirai": [
        "asseoir"
    ],
    "assoiraient": [
        "asseoir"
    ],
    "assoirais": [
        "asseoir"
    ],
    "assoirait": [
        "asseoir"
    ],
    "assoiras": [
        "asseoir"
    ],
    "assoiront": [
        "asseoir"
    ],
    "assois": [
        "asseoir"
    ],
    "assoit": [
        "asseoir"
    ],
    "assombri": [
        "assombrir"
    ],
    "assombrie": [
        "assombrir"
    ],
    "assombries": [
        "assombrir"
    ],
    "assombrir": [
        "assombrir"
    ],
    "assombrira": [
        "assombrir"
    ],
    "assombrirent": [
        "assombrir"
    ],
    "assombris": [
        "assombrir"
    ],
    "assombrissaient": [
        "assombrir"
    ],
    "assombrissait": [
        "assombrir"
    ],
    "assombrissant": [
        "assombrir"
    ],
    "assombrissement": [
        "assombrissement"
    ],
    "assombrissent": [
        "assombrir"
    ],
    "assombrit": [
        "assombrir"
    ],
    "assomma": [
        "assommer"
    ],
    "assommaient": [
        "assommer"
    ],
    "assommait": [
        "assommer"
    ],
    "assommant": [
        "assommer",
        "assommant"
    ],
    "assommante": [
        "assommant"
    ],
    "assommantes": [
        "assommant"
    ],
    "assommants": [
        "assommant"
    ],
    "assomme": [
        "assommer"
    ],
    "assomment": [
        "assommer"
    ],
    "assommer": [
        "assommer"
    ],
    "assommera": [
        "assommer"
    ],
    "assommerai": [
        "assommer"
    ],
    "assommeraient": [
        "assommer"
    ],
    "assommerais": [
        "assommer"
    ],
    "assommerait": [
        "assommer"
    ],
    "assommeras": [
        "assommer"
    ],
    "assommes": [
        "assommer"
    ],
    "assommeur": [
        "assommeur"
    ],
    "assommez": [
        "assommer"
    ],
    "assommiez": [
        "assommer"
    ],
    "assommoir": [
        "assommoir"
    ],
    "assommoirs": [
        "assommoir"
    ],
    "assommons": [
        "assommer"
    ],
    "assommat": [
        "assommer"
    ],
    "assommee": [
        "assommer"
    ],
    "assommees": [
        "assommer"
    ],
    "assomption": [
        "assomption"
    ],
    "assomptions": [
        "assomption"
    ],
    "assonance": [
        "assonance"
    ],
    "assonances": [
        "assonance"
    ],
    "assonants": [
        "assonant"
    ],
    "assorti": [
        "assortir",
        "assorti"
    ],
    "assortie": [
        "assortir",
        "assorti"
    ],
    "assorties": [
        "assortir",
        "assorti"
    ],
    "assortiment": [
        "assortiment"
    ],
    "assortiments": [
        "assortiment"
    ],
    "assortir": [
        "assortir"
    ],
    "assortirai": [
        "assortir"
    ],
    "assortirais": [
        "assortir"
    ],
    "assortis": [
        "assortir",
        "assorti"
    ],
    "assortissaient": [
        "assortir"
    ],
    "assortissais": [
        "assortir"
    ],
    "assortissait": [
        "assortir"
    ],
    "assortissant": [
        "assortir"
    ],
    "assortissent": [
        "assortir"
    ],
    "assortit": [
        "assortir"
    ],
    "assote": [
        "assoter"
    ],
    "assotes": [
        "assoter"
    ],
    "assoupi": [
        "assoupi",
        "assoupir"
    ],
    "assoupie": [
        "assoupi",
        "assoupir"
    ],
    "assoupies": [
        "assoupi",
        "assoupir"
    ],
    "assoupir": [
        "assoupir"
    ],
    "assoupira": [
        "assoupir"
    ],
    "assoupirais": [
        "assoupir"
    ],
    "assoupis": [
        "assoupi",
        "assoupir"
    ],
    "assoupissaient": [
        "assoupir"
    ],
    "assoupissais": [
        "assoupir"
    ],
    "assoupissait": [
        "assoupir"
    ],
    "assoupissant": [
        "assoupissant",
        "assoupir"
    ],
    "assoupisse": [
        "assoupir"
    ],
    "assoupissement": [
        "assoupissement"
    ],
    "assoupissent": [
        "assoupir"
    ],
    "assoupit": [
        "assoupir"
    ],
    "assoupli": [
        "assouplir"
    ],
    "assouplie": [
        "assouplir"
    ],
    "assouplies": [
        "assouplir"
    ],
    "assouplir": [
        "assouplir"
    ],
    "assouplira": [
        "assouplir"
    ],
    "assouplis": [
        "assouplir"
    ],
    "assouplissaient": [
        "assouplir"
    ],
    "assouplissait": [
        "assouplir"
    ],
    "assouplissant": [
        "assouplissant"
    ],
    "assouplissement": [
        "assouplissement"
    ],
    "assouplissements": [
        "assouplissement"
    ],
    "assouplissent": [
        "assouplir"
    ],
    "assouplit": [
        "assouplir"
    ],
    "assourdi": [
        "assourdir",
        "assourdi"
    ],
    "assourdie": [
        "assourdir",
        "assourdi"
    ],
    "assourdies": [
        "assourdir",
        "assourdi"
    ],
    "assourdir": [
        "assourdir"
    ],
    "assourdiraient": [
        "assourdir"
    ],
    "assourdiras": [
        "assourdir"
    ],
    "assourdirent": [
        "assourdir"
    ],
    "assourdis": [
        "assourdir",
        "assourdi"
    ],
    "assourdissaient": [
        "assourdir"
    ],
    "assourdissait": [
        "assourdir"
    ],
    "assourdissant": [
        "assourdir",
        "assourdissant"
    ],
    "assourdissante": [
        "assourdissant"
    ],
    "assourdissantes": [
        "assourdissant"
    ],
    "assourdissants": [
        "assourdissant"
    ],
    "assourdissement": [
        "assourdissement"
    ],
    "assourdissent": [
        "assourdir"
    ],
    "assourdit": [
        "assourdir"
    ],
    "assouvi": [
        "assouvir"
    ],
    "assouvie": [
        "assouvir"
    ],
    "assouvies": [
        "assouvir"
    ],
    "assouvir": [
        "assouvir"
    ],
    "assouvira": [
        "assouvir"
    ],
    "assouvirai": [
        "assouvir"
    ],
    "assouvirait": [
        "assouvir"
    ],
    "assouviras": [
        "assouvir"
    ],
    "assouvirent": [
        "assouvir"
    ],
    "assouvis": [
        "assouvir"
    ],
    "assouvissaient": [
        "assouvir"
    ],
    "assouvissait": [
        "assouvir"
    ],
    "assouvissant": [
        "assouvir"
    ],
    "assouvisse": [
        "assouvir"
    ],
    "assouvissement": [
        "assouvissement"
    ],
    "assouvissent": [
        "assouvir"
    ],
    "assouvit": [
        "assouvir"
    ],
    "assoyait": [
        "asseoir"
    ],
    "assoyez": [
        "asseoir"
    ],
    "assoyons": [
        "asseoir"
    ],
    "assujetti": [
        "assujetti",
        "assujettir"
    ],
    "assujettie": [
        "assujettir"
    ],
    "assujetties": [
        "assujetti",
        "assujettir"
    ],
    "assujettir": [
        "assujettir"
    ],
    "assujettiraient": [
        "assujettir"
    ],
    "assujettis": [
        "assujetti",
        "assujettir"
    ],
    "assujettissaient": [
        "assujettir"
    ],
    "assujettissait": [
        "assujettir"
    ],
    "assujettissant": [
        "assujettir",
        "assujettissant"
    ],
    "assujettisse": [
        "assujettir"
    ],
    "assujettissement": [
        "assujettissement"
    ],
    "assujettissent": [
        "assujettir"
    ],
    "assujettit": [
        "assujettir"
    ],
    "assuma": [
        "assumer"
    ],
    "assumai": [
        "assumer"
    ],
    "assumaient": [
        "assumer"
    ],
    "assumais": [
        "assumer"
    ],
    "assumait": [
        "assumer"
    ],
    "assumant": [
        "assumer"
    ],
    "assume": [
        "assumer"
    ],
    "assument": [
        "assumer"
    ],
    "assumer": [
        "assumer"
    ],
    "assumera": [
        "assumer"
    ],
    "assumerai": [
        "assumer"
    ],
    "assumeraient": [
        "assumer"
    ],
    "assumerais": [
        "assumer"
    ],
    "assumerait": [
        "assumer"
    ],
    "assumeras": [
        "assumer"
    ],
    "assumerez": [
        "assumer"
    ],
    "assumerions": [
        "assumer"
    ],
    "assumerons": [
        "assumer"
    ],
    "assumez": [
        "assumer"
    ],
    "assumions": [
        "assumer"
    ],
    "assumons": [
        "assumer"
    ],
    "assumat": [
        "assumer"
    ],
    "assumerent": [
        "assumer"
    ],
    "assumee": [
        "assumer"
    ],
    "assumees": [
        "assumer"
    ],
    "assumes": [
        "assumer",
        "assume"
    ],
    "assura": [
        "assurer"
    ],
    "assurable": [
        "assurable"
    ],
    "assurage": [
        "assurage"
    ],
    "assurai": [
        "assurer"
    ],
    "assuraient": [
        "assurer"
    ],
    "assurais": [
        "assurer"
    ],
    "assurait": [
        "assurer"
    ],
    "assurance": [
        "assurance"
    ],
    "assurances": [
        "assurance"
    ],
    "assurant": [
        "assurer"
    ],
    "assurassent": [
        "assurer"
    ],
    "assure": [
        "assurer",
        "assure"
    ],
    "assurent": [
        "assurer"
    ],
    "assurer": [
        "assurer"
    ],
    "assurera": [
        "assurer"
    ],
    "assurerai": [
        "assurer"
    ],
    "assureraient": [
        "assurer"
    ],
    "assurerais": [
        "assurer"
    ],
    "assurerait": [
        "assurer"
    ],
    "assureras": [
        "assurer"
    ],
    "assurerez": [
        "assurer"
    ],
    "assurerons": [
        "assurer"
    ],
    "assureront": [
        "assurer"
    ],
    "assures": [
        "assurer",
        "assure"
    ],
    "assureur": [
        "assureur"
    ],
    "assureurs": [
        "assureur"
    ],
    "assurez": [
        "assurer"
    ],
    "assuriez": [
        "assurer"
    ],
    "assurions": [
        "assurer"
    ],
    "assurons": [
        "assurer"
    ],
    "assurat": [
        "assurer"
    ],
    "assurerent": [
        "assurer"
    ],
    "assuree": [
        "assurer",
        "assure"
    ],
    "assurees": [
        "assurer",
        "assure"
    ],
    "assurement": [
        "assurement"
    ],
    "assuetude": [
        "assuetude"
    ],
    "assyrien": [
        "assyrien"
    ],
    "assyrienne": [
        "assyrien"
    ],
    "assyriennes": [
        "assyrien"
    ],
    "assyriens": [
        "assyrien"
    ],
    "assyro": [
        "assyro"
    ],
    "asseche": [
        "assecher"
    ],
    "assechement": [
        "assechement"
    ],
    "assechent": [
        "assecher"
    ],
    "assenent": [
        "assener"
    ],
    "assenerai": [
        "assener"
    ],
    "assecha": [
        "assecher"
    ],
    "assechaient": [
        "assecher"
    ],
    "assechais": [
        "assecher"
    ],
    "assechait": [
        "assecher"
    ],
    "assechant": [
        "assecher"
    ],
    "assecher": [
        "assecher"
    ],
    "assecherait": [
        "assecher"
    ],
    "assechez": [
        "assecher"
    ],
    "assechons": [
        "assecher"
    ],
    "assechee": [
        "assecher"
    ],
    "assechees": [
        "assecher"
    ],
    "asseches": [
        "assecher"
    ],
    "assimes": [
        "asseoir"
    ],
    "astarte": [
        "astarte"
    ],
    "aste": [
        "aste"
    ],
    "aster": [
        "aster"
    ],
    "asters": [
        "aster"
    ],
    "asthmatique": [
        "asthmatique"
    ],
    "asthmatiques": [
        "asthmatique"
    ],
    "asthme": [
        "asthme"
    ],
    "asthmes": [
        "asthme"
    ],
    "asthenie": [
        "asthenie"
    ],
    "asthenies": [
        "asthenie"
    ],
    "asti": [
        "asti"
    ],
    "astic": [
        "astic"
    ],
    "asticot": [
        "asticot"
    ],
    "asticota": [
        "asticoter"
    ],
    "asticotages": [
        "asticotage"
    ],
    "asticotaient": [
        "asticoter"
    ],
    "asticotais": [
        "asticoter"
    ],
    "asticotait": [
        "asticoter"
    ],
    "asticotant": [
        "asticoter"
    ],
    "asticote": [
        "asticoter"
    ],
    "asticotent": [
        "asticoter"
    ],
    "asticoter": [
        "asticoter"
    ],
    "asticotez": [
        "asticoter"
    ],
    "asticots": [
        "asticot"
    ],
    "asticotes": [
        "asticoter"
    ],
    "astigmate": [
        "astigmate"
    ],
    "astigmatisme": [
        "astigmatisme"
    ],
    "astiqua": [
        "astiquer"
    ],
    "astiquage": [
        "astiquage"
    ],
    "astiquaient": [
        "astiquer"
    ],
    "astiquais": [
        "astiquer"
    ],
    "astiquait": [
        "astiquer"
    ],
    "astiquant": [
        "astiquer"
    ],
    "astique": [
        "astiquer"
    ],
    "astiquent": [
        "astiquer"
    ],
    "astiquer": [
        "astiquer"
    ],
    "astiquera": [
        "astiquer"
    ],
    "astiquerai": [
        "astiquer"
    ],
    "astiquerons": [
        "astiquer"
    ],
    "astiqueur": [
        "astiqueur"
    ],
    "astiquez": [
        "astiquer"
    ],
    "astiquee": [
        "astiquer"
    ],
    "astiquees": [
        "astiquer"
    ],
    "astiques": [
        "astiquer"
    ],
    "astragale": [
        "astragale"
    ],
    "astragales": [
        "astragale"
    ],
    "astrakan": [
        "astrakan"
    ],
    "astral": [
        "astral"
    ],
    "astrale": [
        "astral"
    ],
    "astrales": [
        "astral"
    ],
    "astraux": [
        "astral"
    ],
    "astre": [
        "astre"
    ],
    "astreignais": [
        "astreindre"
    ],
    "astreignait": [
        "astreindre"
    ],
    "astreignant": [
        "astreignant",
        "astreindre"
    ],
    "astreignante": [
        "astreignant"
    ],
    "astreignantes": [
        "astreignant"
    ],
    "astreigne": [
        "astreindre"
    ],
    "astreignions": [
        "astreindre"
    ],
    "astreignis": [
        "astreindre"
    ],
    "astreignit": [
        "astreindre"
    ],
    "astreindre": [
        "astreindre"
    ],
    "astreins": [
        "astreindre"
    ],
    "astreint": [
        "astreint",
        "astreindre"
    ],
    "astreinte": [
        "astreinte",
        "astreint",
        "astreindre"
    ],
    "astreintes": [
        "astreinte",
        "astreint"
    ],
    "astreints": [
        "astreint",
        "astreindre"
    ],
    "astres": [
        "astre"
    ],
    "astringent": [
        "astringent"
    ],
    "astringente": [
        "astringent"
    ],
    "astringentes": [
        "astringent"
    ],
    "astro": [
        "astro"
    ],
    "astrochimie": [
        "astrochimie"
    ],
    "astrolabe": [
        "astrolabe"
    ],
    "astrolabes": [
        "astrolabe"
    ],
    "astrologie": [
        "astrologie"
    ],
    "astrologique": [
        "astrologique"
    ],
    "astrologiquement": [
        "astrologiquement"
    ],
    "astrologiques": [
        "astrologique"
    ],
    "astrologue": [
        "astrologue"
    ],
    "astrologues": [
        "astrologue"
    ],
    "astrolatres": [
        "astrolatre"
    ],
    "astrometrie": [
        "astrometrie"
    ],
    "astronaute": [
        "astronaute"
    ],
    "astronautes": [
        "astronaute"
    ],
    "astronautique": [
        "astronautique"
    ],
    "astronef": [
        "astronef"
    ],
    "astronome": [
        "astronome"
    ],
    "astronomes": [
        "astronome"
    ],
    "astronomie": [
        "astronomie"
    ],
    "astronomique": [
        "astronomique"
    ],
    "astronomiquement": [
        "astronomiquement"
    ],
    "astronomiques": [
        "astronomique"
    ],
    "astrophore": [
        "astrophore"
    ],
    "astrophysicien": [
        "astrophysicien"
    ],
    "astrophysicienne": [
        "astrophysicien"
    ],
    "astrophysiciens": [
        "astrophysicien"
    ],
    "astrophysique": [
        "astrophysique"
    ],
    "astroport": [
        "astroport"
    ],
    "astroscope": [
        "astroscope"
    ],
    "astuce": [
        "astuce"
    ],
    "astuces": [
        "astuce"
    ],
    "astucieuse": [
        "astucieux"
    ],
    "astucieusement": [
        "astucieusement"
    ],
    "astucieuses": [
        "astucieux"
    ],
    "astucieux": [
        "astucieux"
    ],
    "asturienne": [
        "asturienne"
    ],
    "asterisme": [
        "asterisme"
    ],
    "asterisque": [
        "asterisque"
    ],
    "asterisques": [
        "asterisque"
    ],
    "asteroide": [
        "asteroide"
    ],
    "asteroides": [
        "asteroide"
    ],
    "asymptomatique": [
        "asymptomatique"
    ],
    "asymptomatiques": [
        "asymptomatique"
    ],
    "asymetrie": [
        "asymetrie"
    ],
    "asymetrique": [
        "asymetrique"
    ],
    "asymetriquement": [
        "asymetriquement"
    ],
    "asymetriques": [
        "asymetrique"
    ],
    "asynchrone": [
        "asynchrone"
    ],
    "asystolie": [
        "asystolie"
    ],
    "atabeg": [
        "atabeg"
    ],
    "atabegs": [
        "atabeg"
    ],
    "ataman": [
        "ataman"
    ],
    "atamans": [
        "ataman"
    ],
    "ataraxie": [
        "ataraxie"
    ],
    "atavique": [
        "atavique"
    ],
    "ataviques": [
        "atavique"
    ],
    "atavisme": [
        "atavisme"
    ],
    "atavismes": [
        "atavisme"
    ],
    "ataxie": [
        "ataxie"
    ],
    "atchoum": [
        "atchoum"
    ],
    "atelier": [
        "atelier"
    ],
    "ateliers": [
        "atelier"
    ],
    "atellanes": [
        "atellane"
    ],
    "atermoiement": [
        "atermoiement"
    ],
    "atermoiements": [
        "atermoiement"
    ],
    "atermoye": [
        "atermoyer"
    ],
    "athanor": [
        "athanor"
    ],
    "athlete": [
        "athlete"
    ],
    "athletes": [
        "athlete"
    ],
    "athletique": [
        "athletique"
    ],
    "athletiques": [
        "athletique"
    ],
    "athletisme": [
        "athletisme"
    ],
    "athee": [
        "athee"
    ],
    "athees": [
        "athee"
    ],
    "atheisme": [
        "atheisme"
    ],
    "atheiste": [
        "atheiste"
    ],
    "athenien": [
        "athenien"
    ],
    "athenienne": [
        "athenienne",
        "athenien"
    ],
    "atheniennes": [
        "athenienne",
        "athenien"
    ],
    "atheniens": [
        "athenien"
    ],
    "athenee": [
        "athenee"
    ],
    "atlante": [
        "atlante"
    ],
    "atlantes": [
        "atlante"
    ],
    "atlantique": [
        "atlantique"
    ],
    "atlantiques": [
        "atlantique"
    ],
    "atlas": [
        "atlas"
    ],
    "atmosphere": [
        "atmosphere"
    ],
    "atmospheres": [
        "atmosphere"
    ],
    "atmospherique": [
        "atmospherique"
    ],
    "atmospheriques": [
        "atmospherique"
    ],
    "atoll": [
        "atoll"
    ],
    "atolls": [
        "atoll"
    ],
    "atome": [
        "atome"
    ],
    "atomes": [
        "atome"
    ],
    "atomique": [
        "atomique"
    ],
    "atomiques": [
        "atomique"
    ],
    "atomisait": [
        "atomiser"
    ],
    "atomise": [
        "atomise",
        "atomiser"
    ],
    "atomisent": [
        "atomiser"
    ],
    "atomiser": [
        "atomiser"
    ],
    "atomiseur": [
        "atomiseur"
    ],
    "atomisez": [
        "atomiser"
    ],
    "atomiste": [
        "atomiste"
    ],
    "atomistes": [
        "atomiste"
    ],
    "atomisee": [
        "atomise",
        "atomiser"
    ],
    "atomises": [
        "atomiser"
    ],
    "atonal": [
        "atonal"
    ],
    "atonale": [
        "atonal"
    ],
    "atonales": [
        "atonal"
    ],
    "atone": [
        "atone"
    ],
    "atones": [
        "atone"
    ],
    "atonie": [
        "atonie"
    ],
    "atour": [
        "atour"
    ],
    "atourne": [
        "atourner"
    ],
    "atours": [
        "atour"
    ],
    "atout": [
        "atout"
    ],
    "atouts": [
        "atout"
    ],
    "atrabilaire": [
        "atrabilaire"
    ],
    "atrium": [
        "atrium"
    ],
    "atroce": [
        "atroce"
    ],
    "atrocement": [
        "atrocement"
    ],
    "atroces": [
        "atroce"
    ],
    "atrocite": [
        "atrocite"
    ],
    "atrocites": [
        "atrocite"
    ],
    "atrophiait": [
        "atrophier"
    ],
    "atrophie": [
        "atrophier",
        "atrophie"
    ],
    "atrophient": [
        "atrophier"
    ],
    "atrophier": [
        "atrophier"
    ],
    "atrophieraient": [
        "atrophier"
    ],
    "atrophies": [
        "atrophier",
        "atrophie",
        "atrophy"
    ],
    "atrophiee": [
        "atrophier",
        "atrophie"
    ],
    "atrophiees": [
        "atrophie"
    ],
    "atropine": [
        "atropine"
    ],
    "atresie": [
        "atresie"
    ],
    "attabla": [
        "attabler"
    ],
    "attablai": [
        "attabler"
    ],
    "attablaient": [
        "attabler"
    ],
    "attablais": [
        "attabler"
    ],
    "attablait": [
        "attabler"
    ],
    "attablant": [
        "attabler"
    ],
    "attable": [
        "attabler",
        "attable"
    ],
    "attablent": [
        "attabler"
    ],
    "attabler": [
        "attabler"
    ],
    "attablions": [
        "attabler"
    ],
    "attablons": [
        "attabler"
    ],
    "attablerent": [
        "attabler"
    ],
    "attablee": [
        "attabler",
        "attable"
    ],
    "attablees": [
        "attabler",
        "attable"
    ],
    "attables": [
        "attabler",
        "attable"
    ],
    "attacha": [
        "attacher"
    ],
    "attachai": [
        "attacher"
    ],
    "attachaient": [
        "attacher"
    ],
    "attachais": [
        "attacher"
    ],
    "attachait": [
        "attacher"
    ],
    "attachant": [
        "attacher",
        "attachant"
    ],
    "attachante": [
        "attachant"
    ],
    "attachants": [
        "attachant"
    ],
    "attache": [
        "attacher",
        "attache"
    ],
    "attachement": [
        "attachement"
    ],
    "attachements": [
        "attachement"
    ],
    "attachent": [
        "attacher"
    ],
    "attacher": [
        "attacher"
    ],
    "attachera": [
        "attacher"
    ],
    "attacherai": [
        "attacher"
    ],
    "attacherais": [
        "attacher"
    ],
    "attacherait": [
        "attacher"
    ],
    "attacheras": [
        "attacher"
    ],
    "attacherez": [
        "attacher"
    ],
    "attacherions": [
        "attacher"
    ],
    "attacheront": [
        "attacher"
    ],
    "attaches": [
        "attacher",
        "attache",
        "attach"
    ],
    "attachez": [
        "attacher"
    ],
    "attachiez": [
        "attacher"
    ],
    "attachions": [
        "attacher"
    ],
    "attachons": [
        "attacher"
    ],
    "attachat": [
        "attacher"
    ],
    "attacherent": [
        "attacher"
    ],
    "attachee": [
        "attacher",
        "attache"
    ],
    "attachees": [
        "attacher",
        "attache"
    ],
    "attaqua": [
        "attaquer"
    ],
    "attaquable": [
        "attaquable"
    ],
    "attaquai": [
        "attaquer"
    ],
    "attaquaient": [
        "attaquer"
    ],
    "attaquais": [
        "attaquer"
    ],
    "attaquait": [
        "attaquer"
    ],
    "attaquant": [
        "attaquer",
        "attaquant"
    ],
    "attaquante": [
        "attaquant"
    ],
    "attaquants": [
        "attaquant"
    ],
    "attaque": [
        "attaquer",
        "attaque"
    ],
    "attaquent": [
        "attaquer"
    ],
    "attaquer": [
        "attaquer"
    ],
    "attaquera": [
        "attaquer"
    ],
    "attaquerai": [
        "attaquer"
    ],
    "attaqueraient": [
        "attaquer"
    ],
    "attaquerais": [
        "attaquer"
    ],
    "attaquerait": [
        "attaquer"
    ],
    "attaqueras": [
        "attaquer"
    ],
    "attaquerez": [
        "attaquer"
    ],
    "attaqueriez": [
        "attaquer"
    ],
    "attaquerions": [
        "attaquer"
    ],
    "attaquerons": [
        "attaquer"
    ],
    "attaqueront": [
        "attaquer"
    ],
    "attaques": [
        "attaquer",
        "attaque"
    ],
    "attaqueur": [
        "attaqueur"
    ],
    "attaquez": [
        "attaquer"
    ],
    "attaquiez": [
        "attaquer"
    ],
    "attaquons": [
        "attaquer"
    ],
    "attaquames": [
        "attaquer"
    ],
    "attaquat": [
        "attaquer"
    ],
    "attaquerent": [
        "attaquer"
    ],
    "attaquee": [
        "attaquer"
    ],
    "attaquees": [
        "attaquer"
    ],
    "attarda": [
        "attarder"
    ],
    "attardai": [
        "attarder"
    ],
    "attardaient": [
        "attarder"
    ],
    "attardais": [
        "attarder"
    ],
    "attardait": [
        "attarder"
    ],
    "attardant": [
        "attarder"
    ],
    "attarde": [
        "attarde",
        "attarder"
    ],
    "attardement": [
        "attardement"
    ],
    "attardent": [
        "attarder"
    ],
    "attarder": [
        "attarder"
    ],
    "attardera": [
        "attarder"
    ],
    "attarderai": [
        "attarder"
    ],
    "attarderaient": [
        "attarder"
    ],
    "attarderait": [
        "attarder"
    ],
    "attarderont": [
        "attarder"
    ],
    "attardez": [
        "attarder"
    ],
    "attardions": [
        "attarder"
    ],
    "attardons": [
        "attarder"
    ],
    "attardames": [
        "attarder"
    ],
    "attardat": [
        "attarder"
    ],
    "attarderent": [
        "attarder"
    ],
    "attardee": [
        "attarde",
        "attarder"
    ],
    "attardees": [
        "attarde",
        "attarder"
    ],
    "attardes": [
        "attarde",
        "attarder"
    ],
    "atteignable": [
        "atteignable"
    ],
    "atteignaient": [
        "atteindre"
    ],
    "atteignais": [
        "atteindre"
    ],
    "atteignait": [
        "atteindre"
    ],
    "atteignant": [
        "atteindre"
    ],
    "atteigne": [
        "atteindre"
    ],
    "atteignent": [
        "atteindre"
    ],
    "atteignes": [
        "atteindre"
    ],
    "atteignez": [
        "atteindre"
    ],
    "atteignions": [
        "atteindre"
    ],
    "atteignirent": [
        "atteindre"
    ],
    "atteignis": [
        "atteindre"
    ],
    "atteignissent": [
        "atteindre"
    ],
    "atteignit": [
        "atteindre"
    ],
    "atteignons": [
        "atteindre"
    ],
    "atteignimes": [
        "atteindre"
    ],
    "atteindra": [
        "atteindre"
    ],
    "atteindrai": [
        "atteindre"
    ],
    "atteindraient": [
        "atteindre"
    ],
    "atteindrais": [
        "atteindre"
    ],
    "atteindrait": [
        "atteindre"
    ],
    "atteindras": [
        "atteindre"
    ],
    "atteindre": [
        "atteindre"
    ],
    "atteindrez": [
        "atteindre"
    ],
    "atteindrons": [
        "atteindre"
    ],
    "atteindront": [
        "atteindre"
    ],
    "atteins": [
        "atteindre"
    ],
    "atteint": [
        "atteint",
        "atteindre"
    ],
    "atteinte": [
        "atteint",
        "atteindre",
        "atteinte"
    ],
    "atteintes": [
        "atteint",
        "atteindre",
        "atteinte"
    ],
    "atteints": [
        "atteint",
        "atteindre"
    ],
    "attela": [
        "atteler"
    ],
    "attelage": [
        "attelage"
    ],
    "attelages": [
        "attelage"
    ],
    "attelai": [
        "atteler"
    ],
    "attelaient": [
        "atteler"
    ],
    "attelais": [
        "atteler"
    ],
    "attelait": [
        "atteler"
    ],
    "attelant": [
        "atteler"
    ],
    "atteler": [
        "atteler"
    ],
    "attelez": [
        "atteler"
    ],
    "attelions": [
        "atteler"
    ],
    "attelle": [
        "attelle",
        "atteler"
    ],
    "attellent": [
        "atteler"
    ],
    "attellera": [
        "atteler"
    ],
    "attellerais": [
        "atteler"
    ],
    "attelles": [
        "attelle",
        "atteler"
    ],
    "attelons": [
        "atteler"
    ],
    "attelames": [
        "atteler"
    ],
    "attelerent": [
        "atteler"
    ],
    "attele": [
        "atteler"
    ],
    "attelee": [
        "atteler"
    ],
    "attelees": [
        "atteler"
    ],
    "atteles": [
        "atteler"
    ],
    "attenant": [
        "attenant"
    ],
    "attenante": [
        "attenant"
    ],
    "attenantes": [
        "attenant"
    ],
    "attend": [
        "attendre"
    ],
    "attendaient": [
        "attendre"
    ],
    "attendais": [
        "attendre"
    ],
    "attendait": [
        "attendre"
    ],
    "attendant": [
        "attendant",
        "attendre"
    ],
    "attende": [
        "attendre"
    ],
    "attendent": [
        "attendre"
    ],
    "attendes": [
        "attendre"
    ],
    "attendez": [
        "attendre"
    ],
    "attendiez": [
        "attendre"
    ],
    "attendions": [
        "attendre"
    ],
    "attendirent": [
        "attendre"
    ],
    "attendis": [
        "attendre"
    ],
    "attendisse": [
        "attendre"
    ],
    "attendissent": [
        "attendre"
    ],
    "attendit": [
        "attendre"
    ],
    "attendons": [
        "attendre"
    ],
    "attendra": [
        "attendre"
    ],
    "attendrai": [
        "attendre"
    ],
    "attendraient": [
        "attendre"
    ],
    "attendrais": [
        "attendre"
    ],
    "attendrait": [
        "attendre"
    ],
    "attendras": [
        "attendre"
    ],
    "attendre": [
        "attendre"
    ],
    "attendrez": [
        "attendre"
    ],
    "attendri": [
        "attendrir"
    ],
    "attendrie": [
        "attendrir"
    ],
    "attendries": [
        "attendrir"
    ],
    "attendriez": [
        "attendre"
    ],
    "attendrions": [
        "attendre"
    ],
    "attendrir": [
        "attendrir"
    ],
    "attendrirait": [
        "attendrir"
    ],
    "attendriras": [
        "attendrir"
    ],
    "attendrirent": [
        "attendrir"
    ],
    "attendris": [
        "attendrir"
    ],
    "attendrissaient": [
        "attendrir"
    ],
    "attendrissais": [
        "attendrir"
    ],
    "attendrissait": [
        "attendrir"
    ],
    "attendrissant": [
        "attendrir",
        "attendrissant"
    ],
    "attendrissante": [
        "attendrissant"
    ],
    "attendrissantes": [
        "attendrissant"
    ],
    "attendrissants": [
        "attendrissant"
    ],
    "attendrisse": [
        "attendrir"
    ],
    "attendrissement": [
        "attendrissement"
    ],
    "attendrissements": [
        "attendrissement"
    ],
    "attendrissent": [
        "attendrir"
    ],
    "attendrisseur": [
        "attendrisseur"
    ],
    "attendrissons": [
        "attendrir"
    ],
    "attendrit": [
        "attendrir"
    ],
    "attendrons": [
        "attendre"
    ],
    "attendront": [
        "attendre"
    ],
    "attends": [
        "attend",
        "attendre"
    ],
    "attendu": [
        "attendu",
        "attendre"
    ],
    "attendue": [
        "attendu",
        "attendre"
    ],
    "attendues": [
        "attendu",
        "attendre"
    ],
    "attendus": [
        "attendu",
        "attendre"
    ],
    "attendimes": [
        "attendre"
    ],
    "attenta": [
        "attenter"
    ],
    "attentais": [
        "attenter"
    ],
    "attentait": [
        "attenter"
    ],
    "attentant": [
        "attenter"
    ],
    "attentat": [
        "attentat"
    ],
    "attentatoire": [
        "attentatoire"
    ],
    "attentatoires": [
        "attentatoire"
    ],
    "attentats": [
        "attentat"
    ],
    "attente": [
        "attenter",
        "attente"
    ],
    "attenter": [
        "attenter"
    ],
    "attenterai": [
        "attenter"
    ],
    "attenterait": [
        "attenter"
    ],
    "attentes": [
        "attente"
    ],
    "attentez": [
        "attenter"
    ],
    "attentiez": [
        "attenter"
    ],
    "attentif": [
        "attentif"
    ],
    "attentifs": [
        "attentif"
    ],
    "attention": [
        "attention"
    ],
    "attentionne": [
        "attentionner",
        "attentionne"
    ],
    "attentionnee": [
        "attentionner",
        "attentionne"
    ],
    "attentionnees": [
        "attentionne"
    ],
    "attentionnes": [
        "attentionner",
        "attentionne"
    ],
    "attentions": [
        "attention"
    ],
    "attentisme": [
        "attentisme"
    ],
    "attentiste": [
        "attentiste"
    ],
    "attentistes": [
        "attentiste"
    ],
    "attentive": [
        "attentif"
    ],
    "attentivement": [
        "attentivement"
    ],
    "attentives": [
        "attentif"
    ],
    "atterrages": [
        "atterrage"
    ],
    "atterraient": [
        "atterrer"
    ],
    "atterrait": [
        "atterrer"
    ],
    "atterrant": [
        "atterrant"
    ],
    "atterrante": [
        "atterrant"
    ],
    "atterre": [
        "atterrer",
        "atterre"
    ],
    "atterri": [
        "atterrir"
    ],
    "atterrir": [
        "atterrir"
    ],
    "atterrira": [
        "atterrir"
    ],
    "atterrirai": [
        "atterrir"
    ],
    "atterrirais": [
        "atterrir"
    ],
    "atterriras": [
        "atterrir"
    ],
    "atterrirent": [
        "atterrir"
    ],
    "atterrirez": [
        "atterrir"
    ],
    "atterrirons": [
        "atterrir"
    ],
    "atterris": [
        "atterrir"
    ],
    "atterrissage": [
        "atterrissage"
    ],
    "atterrissages": [
        "atterrissage"
    ],
    "atterrissaient": [
        "atterrir"
    ],
    "atterrissais": [
        "atterrir"
    ],
    "atterrissait": [
        "atterrir"
    ],
    "atterrissant": [
        "atterrir"
    ],
    "atterrisse": [
        "atterrir"
    ],
    "atterrissent": [
        "atterrir"
    ],
    "atterrisses": [
        "atterrir"
    ],
    "atterrissez": [
        "atterrir"
    ],
    "atterrissons": [
        "atterrir"
    ],
    "atterrit": [
        "atterrir"
    ],
    "atterrerent": [
        "atterrer"
    ],
    "atterree": [
        "atterrer",
        "atterre"
    ],
    "atterrees": [
        "atterrer"
    ],
    "atterres": [
        "atterrer",
        "atterre"
    ],
    "atterrimes": [
        "atterrir"
    ],
    "attesta": [
        "attester"
    ],
    "attestaient": [
        "attester"
    ],
    "attestait": [
        "attester"
    ],
    "attestant": [
        "attester"
    ],
    "attestation": [
        "attestation"
    ],
    "attestations": [
        "attestation"
    ],
    "atteste": [
        "atteste",
        "attester"
    ],
    "attestent": [
        "attester"
    ],
    "attester": [
        "attester"
    ],
    "attestera": [
        "attester"
    ],
    "attestons": [
        "attester"
    ],
    "attesterent": [
        "attester"
    ],
    "attestee": [
        "atteste",
        "attester"
    ],
    "attestees": [
        "attester"
    ],
    "attifa": [
        "attifer"
    ],
    "attifait": [
        "attifer"
    ],
    "attifant": [
        "attifer"
    ],
    "attife": [
        "attifer"
    ],
    "attifer": [
        "attifer"
    ],
    "attifiaux": [
        "attifiaux"
    ],
    "attifee": [
        "attifer"
    ],
    "attifees": [
        "attifer"
    ],
    "attifes": [
        "attifer"
    ],
    "attige": [
        "attiger"
    ],
    "attigeait": [
        "attiger"
    ],
    "attigent": [
        "attiger"
    ],
    "attiges": [
        "attiger"
    ],
    "attique": [
        "attique"
    ],
    "attiques": [
        "attique"
    ],
    "attira": [
        "attirer"
    ],
    "attirai": [
        "attirer"
    ],
    "attiraient": [
        "attirer"
    ],
    "attirail": [
        "attirail"
    ],
    "attirais": [
        "attirer"
    ],
    "attirait": [
        "attirer"
    ],
    "attirance": [
        "attirance"
    ],
    "attirances": [
        "attirance"
    ],
    "attirant": [
        "attirant",
        "attirer"
    ],
    "attirante": [
        "attirant"
    ],
    "attirantes": [
        "attirant"
    ],
    "attirants": [
        "attirant"
    ],
    "attire": [
        "attirer"
    ],
    "attirent": [
        "attirer"
    ],
    "attirer": [
        "attirer"
    ],
    "attirera": [
        "attirer"
    ],
    "attirerai": [
        "attirer"
    ],
    "attireraient": [
        "attirer"
    ],
    "attirerais": [
        "attirer"
    ],
    "attirerait": [
        "attirer"
    ],
    "attirerez": [
        "attirer"
    ],
    "attireriez": [
        "attirer"
    ],
    "attirerons": [
        "attirer"
    ],
    "attireront": [
        "attirer"
    ],
    "attires": [
        "attirer",
        "attire"
    ],
    "attirez": [
        "attirer"
    ],
    "attiriez": [
        "attirer"
    ],
    "attirions": [
        "attirer"
    ],
    "attirons": [
        "attirer"
    ],
    "attirat": [
        "attirer"
    ],
    "attirerent": [
        "attirer"
    ],
    "attiree": [
        "attirer"
    ],
    "attirees": [
        "attirer"
    ],
    "attisa": [
        "attiser"
    ],
    "attisaient": [
        "attiser"
    ],
    "attisait": [
        "attiser"
    ],
    "attisant": [
        "attiser"
    ],
    "attise": [
        "attiser"
    ],
    "attisement": [
        "attisement"
    ],
    "attisent": [
        "attiser"
    ],
    "attiser": [
        "attiser"
    ],
    "attisera": [
        "attiser"
    ],
    "attises": [
        "attiser"
    ],
    "attisez": [
        "attiser"
    ],
    "attisoir": [
        "attisoir"
    ],
    "attisons": [
        "attiser"
    ],
    "attisee": [
        "attiser"
    ],
    "attisees": [
        "attiser"
    ],
    "attitre": [
        "attitrer",
        "attitre"
    ],
    "attitree": [
        "attitrer",
        "attitre"
    ],
    "attitrees": [
        "attitre"
    ],
    "attitres": [
        "attitrer",
        "attitre"
    ],
    "attitude": [
        "attitude"
    ],
    "attitudes": [
        "attitude"
    ],
    "attiedi": [
        "attiedir"
    ],
    "attiedie": [
        "attiedir"
    ],
    "attiedis": [
        "attiedir"
    ],
    "attiedissait": [
        "attiedir"
    ],
    "attorney": [
        "attorney"
    ],
    "attouchant": [
        "attoucher"
    ],
    "attouchement": [
        "attouchement"
    ],
    "attouchements": [
        "attouchement"
    ],
    "attracteur": [
        "attracteur"
    ],
    "attracteurs": [
        "attracteur"
    ],
    "attractif": [
        "attractif"
    ],
    "attractifs": [
        "attractif"
    ],
    "attraction": [
        "attraction"
    ],
    "attractions": [
        "attraction"
    ],
    "attractive": [
        "attractif"
    ],
    "attrait": [
        "attraire",
        "attrait"
    ],
    "attraits": [
        "attrait"
    ],
    "attrapa": [
        "attraper"
    ],
    "attrapage": [
        "attrapage"
    ],
    "attrapai": [
        "attraper"
    ],
    "attrapaient": [
        "attraper"
    ],
    "attrapais": [
        "attraper"
    ],
    "attrapait": [
        "attraper"
    ],
    "attrapant": [
        "attraper"
    ],
    "attrape": [
        "attraper",
        "attrape"
    ],
    "attrapent": [
        "attraper"
    ],
    "attraper": [
        "attraper"
    ],
    "attrapera": [
        "attraper"
    ],
    "attraperai": [
        "attraper"
    ],
    "attraperaient": [
        "attraper"
    ],
    "attraperais": [
        "attraper"
    ],
    "attraperait": [
        "attraper"
    ],
    "attraperas": [
        "attraper"
    ],
    "attraperez": [
        "attraper"
    ],
    "attraperiez": [
        "attraper"
    ],
    "attraperons": [
        "attraper"
    ],
    "attraperont": [
        "attraper"
    ],
    "attrapes": [
        "attraper",
        "attrape"
    ],
    "attrapeur": [
        "attrapeur"
    ],
    "attrapez": [
        "attraper"
    ],
    "attrapiez": [
        "attraper"
    ],
    "attrapions": [
        "attraper"
    ],
    "attrapons": [
        "attraper"
    ],
    "attraperent": [
        "attraper"
    ],
    "attrapee": [
        "attraper"
    ],
    "attrapees": [
        "attraper"
    ],
    "attrayant": [
        "attrayant"
    ],
    "attrayante": [
        "attrayant"
    ],
    "attrayantes": [
        "attrayant"
    ],
    "attrayants": [
        "attrayant"
    ],
    "attribua": [
        "attribuer"
    ],
    "attribuable": [
        "attribuable"
    ],
    "attribuai": [
        "attribuer"
    ],
    "attribuaient": [
        "attribuer"
    ],
    "attribuais": [
        "attribuer"
    ],
    "attribuait": [
        "attribuer"
    ],
    "attribuant": [
        "attribuer"
    ],
    "attribue": [
        "attribue",
        "attribuer"
    ],
    "attribuent": [
        "attribuer"
    ],
    "attribuer": [
        "attribuer"
    ],
    "attribuera": [
        "attribuer"
    ],
    "attribueraient": [
        "attribuer"
    ],
    "attribuerais": [
        "attribuer"
    ],
    "attribuerait": [
        "attribuer"
    ],
    "attribueront": [
        "attribuer"
    ],
    "attribues": [
        "attribue",
        "attribuer"
    ],
    "attribuez": [
        "attribuer"
    ],
    "attribuions": [
        "attribuer"
    ],
    "attribuons": [
        "attribuer"
    ],
    "attribut": [
        "attribut"
    ],
    "attribution": [
        "attribution"
    ],
    "attributions": [
        "attribution"
    ],
    "attributs": [
        "attribut"
    ],
    "attribuames": [
        "attribuer"
    ],
    "attribuat": [
        "attribuer"
    ],
    "attribuerent": [
        "attribuer"
    ],
    "attribuee": [
        "attribue",
        "attribuer"
    ],
    "attribuees": [
        "attribue",
        "attribuer"
    ],
    "attriquait": [
        "attriquer"
    ],
    "attriquant": [
        "attriquer"
    ],
    "attrique": [
        "attriquer"
    ],
    "attriquent": [
        "attriquer"
    ],
    "attriquer": [
        "attriquer"
    ],
    "attriquerait": [
        "attriquer"
    ],
    "attriquee": [
        "attriquer"
    ],
    "attrista": [
        "attrister"
    ],
    "attristai": [
        "attrister"
    ],
    "attristaient": [
        "attrister"
    ],
    "attristais": [
        "attrister"
    ],
    "attristait": [
        "attrister"
    ],
    "attristant": [
        "attrister",
        "attristant"
    ],
    "attristante": [
        "attristant"
    ],
    "attristantes": [
        "attristant"
    ],
    "attriste": [
        "attriste",
        "attrister"
    ],
    "attristent": [
        "attrister"
    ],
    "attrister": [
        "attrister"
    ],
    "attristerait": [
        "attrister"
    ],
    "attristez": [
        "attrister"
    ],
    "attristat": [
        "attrister"
    ],
    "attristerent": [
        "attrister"
    ],
    "attristee": [
        "attriste",
        "attrister"
    ],
    "attristes": [
        "attriste",
        "attrister"
    ],
    "attrition": [
        "attrition"
    ],
    "attritions": [
        "attrition"
    ],
    "attroupa": [
        "attrouper"
    ],
    "attroupaient": [
        "attrouper"
    ],
    "attroupait": [
        "attrouper"
    ],
    "attroupement": [
        "attroupement"
    ],
    "attroupements": [
        "attroupement"
    ],
    "attroupent": [
        "attrouper"
    ],
    "attrouper": [
        "attrouper"
    ],
    "attrouperaient": [
        "attrouper"
    ],
    "attrouperent": [
        "attrouper"
    ],
    "attroupe": [
        "attrouper"
    ],
    "attroupee": [
        "attrouper"
    ],
    "attroupees": [
        "attrouper"
    ],
    "attroupes": [
        "attrouper"
    ],
    "attenua": [
        "attenuer"
    ],
    "attenuaient": [
        "attenuer"
    ],
    "attenuait": [
        "attenuer"
    ],
    "attenuant": [
        "attenuer"
    ],
    "attenuante": [
        "attenuant"
    ],
    "attenuantes": [
        "attenuant"
    ],
    "attenuateur": [
        "attenuateur"
    ],
    "attenuation": [
        "attenuation"
    ],
    "attenuations": [
        "attenuation"
    ],
    "attenue": [
        "attenue",
        "attenuer"
    ],
    "attenuent": [
        "attenuer"
    ],
    "attenuer": [
        "attenuer"
    ],
    "attenuera": [
        "attenuer"
    ],
    "attenueraient": [
        "attenuer"
    ],
    "attenuez": [
        "attenuer"
    ],
    "attenuons": [
        "attenuer"
    ],
    "attenuat": [
        "attenuer"
    ],
    "attenuerent": [
        "attenuer"
    ],
    "attenuee": [
        "attenue",
        "attenuer"
    ],
    "attenuees": [
        "attenue",
        "attenuer"
    ],
    "attenues": [
        "attenue",
        "attenuer"
    ],
    "atypique": [
        "atypique"
    ],
    "atypiques": [
        "atypique"
    ],
    "atele": [
        "atele"
    ],
    "atelectasie": [
        "atelectasie"
    ],
    "atemi": [
        "atemi"
    ],
    "au": [
        "au"
    ],
    "aubade": [
        "aubade"
    ],
    "aubadent": [
        "aubader"
    ],
    "aubain": [
        "aubain"
    ],
    "aubaine": [
        "aubaine"
    ],
    "aubaines": [
        "aubaine"
    ],
    "aube": [
        "aube"
    ],
    "auberge": [
        "auberge"
    ],
    "auberges": [
        "auberge"
    ],
    "aubergine": [
        "aubergine"
    ],
    "aubergines": [
        "aubergine"
    ],
    "aubergiste": [
        "aubergiste"
    ],
    "aubergistes": [
        "aubergiste"
    ],
    "aubes": [
        "aube"
    ],
    "aubette": [
        "aubette"
    ],
    "aubier": [
        "aubier"
    ],
    "aubour": [
        "aubour"
    ],
    "auburn": [
        "auburn"
    ],
    "aubusson": [
        "aubusson"
    ],
    "aubere": [
        "aubere"
    ],
    "auberes": [
        "aubere"
    ],
    "aubepine": [
        "aubepine"
    ],
    "aubepines": [
        "aubepine"
    ],
    "aucubas": [
        "aucuba"
    ],
    "aucun": [
        "aucun"
    ],
    "aucune": [
        "aucune"
    ],
    "aucunement": [
        "aucunement"
    ],
    "aucunes": [
        "aucunes"
    ],
    "aucuns": [
        "aucuns"
    ],
    "audace": [
        "audace"
    ],
    "audaces": [
        "audace"
    ],
    "audacieuse": [
        "audacieux"
    ],
    "audacieusement": [
        "audacieusement"
    ],
    "audacieuses": [
        "audacieux"
    ],
    "audacieux": [
        "audacieux"
    ],
    "audible": [
        "audible"
    ],
    "audibles": [
        "audible"
    ],
    "audience": [
        "audience"
    ],
    "audiences": [
        "audience"
    ],
    "audiencia": [
        "audiencia"
    ],
    "audienciers": [
        "audiencier"
    ],
    "audimat": [
        "audimat"
    ],
    "audimats": [
        "audimat"
    ],
    "audio": [
        "audio"
    ],
    "audioconference": [
        "audioconference"
    ],
    "audiogramme": [
        "audiogramme"
    ],
    "audiometrie": [
        "audiometrie"
    ],
    "audiophile": [
        "audiophile"
    ],
    "audiophone": [
        "audiophone"
    ],
    "audiovisuel": [
        "audiovisuel"
    ],
    "audiovisuelle": [
        "audiovisuel"
    ],
    "audiovisuelles": [
        "audiovisuel"
    ],
    "audit": [
        "audit"
    ],
    "auditer": [
        "auditer"
    ],
    "auditeur": [
        "auditeur"
    ],
    "auditeurs": [
        "auditeur"
    ],
    "auditif": [
        "auditif"
    ],
    "auditifs": [
        "auditif"
    ],
    "audition": [
        "audition"
    ],
    "auditionnais": [
        "auditionner"
    ],
    "auditionne": [
        "auditionner"
    ],
    "auditionnent": [
        "auditionner"
    ],
    "auditionner": [
        "auditionner"
    ],
    "auditionnera": [
        "auditionner"
    ],
    "auditionnerais": [
        "auditionner"
    ],
    "auditionnes": [
        "auditionner"
    ],
    "auditionnez": [
        "auditionner"
    ],
    "auditionnee": [
        "auditionner"
    ],
    "auditions": [
        "audition"
    ],
    "auditive": [
        "auditif"
    ],
    "auditives": [
        "auditif"
    ],
    "auditoire": [
        "auditoire"
    ],
    "auditoires": [
        "auditoire"
    ],
    "auditorium": [
        "auditorium"
    ],
    "auditoriums": [
        "auditorium"
    ],
    "auditrice": [
        "auditeur"
    ],
    "auditrices": [
        "auditeur"
    ],
    "audits": [
        "audit"
    ],
    "auge": [
        "auge"
    ],
    "auges": [
        "auge"
    ],
    "augment": [
        "augment"
    ],
    "augmenta": [
        "augmenter"
    ],
    "augmentaient": [
        "augmenter"
    ],
    "augmentais": [
        "augmenter"
    ],
    "augmentait": [
        "augmenter"
    ],
    "augmentant": [
        "augmenter"
    ],
    "augmentation": [
        "augmentation"
    ],
    "augmentations": [
        "augmentation"
    ],
    "augmente": [
        "augmenter"
    ],
    "augmentent": [
        "augmenter"
    ],
    "augmenter": [
        "augmenter"
    ],
    "augmentera": [
        "augmenter"
    ],
    "augmenterai": [
        "augmenter"
    ],
    "augmenteraient": [
        "augmenter"
    ],
    "augmenterais": [
        "augmenter"
    ],
    "augmenterait": [
        "augmenter"
    ],
    "augmenteras": [
        "augmenter"
    ],
    "augmenterez": [
        "augmenter"
    ],
    "augmenteront": [
        "augmenter"
    ],
    "augmentez": [
        "augmenter"
    ],
    "augmentions": [
        "augmenter"
    ],
    "augmentons": [
        "augmenter"
    ],
    "augmentat": [
        "augmenter"
    ],
    "augmenterent": [
        "augmenter"
    ],
    "augmentee": [
        "augmenter"
    ],
    "augmentees": [
        "augmenter"
    ],
    "augmentes": [
        "augmenter"
    ],
    "augurai": [
        "augurer"
    ],
    "augurais": [
        "augurer"
    ],
    "augurait": [
        "augurer"
    ],
    "augural": [
        "augural"
    ],
    "augurale": [
        "augural"
    ],
    "augurant": [
        "augurer"
    ],
    "augure": [
        "augure",
        "augurer"
    ],
    "augurent": [
        "augurer"
    ],
    "augurer": [
        "augurer"
    ],
    "augurerais": [
        "augurer"
    ],
    "augures": [
        "augure"
    ],
    "auguste": [
        "auguste"
    ],
    "augustes": [
        "auguste"
    ],
    "augustin": [
        "augustin"
    ],
    "augustinien": [
        "augustinien"
    ],
    "augustins": [
        "augustin"
    ],
    "aujourd'hui": [
        "aujourd'huie",
        "aujourd'hui"
    ],
    "aula": [
        "aula"
    ],
    "aulique": [
        "aulique"
    ],
    "aulnaie": [
        "aulnaie"
    ],
    "aulne": [
        "aulne"
    ],
    "aulnes": [
        "aulne"
    ],
    "auloffee": [
        "auloffee"
    ],
    "aulos": [
        "aulos"
    ],
    "aulx": [
        "aulx"
    ],
    "aumone": [
        "aumone"
    ],
    "aumonerie": [
        "aumonerie"
    ],
    "aumones": [
        "aumone"
    ],
    "aumonier": [
        "aumonier"
    ],
    "aumoniers": [
        "aumonier"
    ],
    "aumoniere": [
        "aumonier"
    ],
    "aumonieres": [
        "aumonier"
    ],
    "aune": [
        "aune"
    ],
    "auner": [
        "auner"
    ],
    "aunes": [
        "aune"
    ],
    "auparavant": [
        "auparavant"
    ],
    "aupres": [
        "aupres"
    ],
    "auquel": [
        "auquel"
    ],
    "aura": [
        "avoir",
        "aura"
    ],
    "aurai": [
        "avoir",
        "aurai"
    ],
    "auraient": [
        "avoir"
    ],
    "aurais": [
        "avoir"
    ],
    "aurait": [
        "avoir"
    ],
    "auras": [
        "avoir",
        "aura"
    ],
    "aureus": [
        "aureus"
    ],
    "aurez": [
        "avoir"
    ],
    "auriculaire": [
        "auriculaire"
    ],
    "auriculaires": [
        "auriculaire"
    ],
    "auricule": [
        "auricule"
    ],
    "auriez": [
        "avoir"
    ],
    "aurifiees": [
        "aurifier"
    ],
    "aurifere": [
        "aurifere"
    ],
    "auriferes": [
        "aurifere"
    ],
    "aurige": [
        "aurige"
    ],
    "aurions": [
        "avoir"
    ],
    "aurochs": [
        "aurochs"
    ],
    "aurone": [
        "aurone"
    ],
    "aurons": [
        "avoir"
    ],
    "auront": [
        "avoir"
    ],
    "auroral": [
        "auroral"
    ],
    "aurore": [
        "aurore"
    ],
    "aurores": [
        "aurore"
    ],
    "aureola": [
        "aureoler"
    ],
    "aureolaient": [
        "aureoler"
    ],
    "aureolaire": [
        "aureolaire"
    ],
    "aureolait": [
        "aureoler"
    ],
    "aureolant": [
        "aureoler"
    ],
    "aureole": [
        "aureoler",
        "aureole"
    ],
    "aureoler": [
        "aureoler"
    ],
    "aureoles": [
        "aureoler",
        "aureole"
    ],
    "aureolee": [
        "aureoler",
        "aureole"
    ],
    "aureolees": [
        "aureoler",
        "aureole"
    ],
    "aureomycine": [
        "aureomycine"
    ],
    "ausculta": [
        "ausculter"
    ],
    "auscultais": [
        "ausculter"
    ],
    "auscultait": [
        "ausculter"
    ],
    "auscultant": [
        "ausculter"
    ],
    "auscultation": [
        "auscultation"
    ],
    "auscultations": [
        "auscultation"
    ],
    "ausculte": [
        "ausculter"
    ],
    "auscultent": [
        "ausculter"
    ],
    "ausculter": [
        "ausculter"
    ],
    "auscultez": [
        "ausculter"
    ],
    "auscultees": [
        "ausculter"
    ],
    "auscultes": [
        "ausculter"
    ],
    "auspices": [
        "auspice"
    ],
    "aussi": [
        "aussi"
    ],
    "aussitot": [
        "aussitot"
    ],
    "aussiere": [
        "aussiere"
    ],
    "aussieres": [
        "aussiere"
    ],
    "austral": [
        "austral"
    ],
    "australe": [
        "austral"
    ],
    "australes": [
        "austral"
    ],
    "australien": [
        "australien"
    ],
    "australienne": [
        "australien",
        "australienne"
    ],
    "australiennes": [
        "australien",
        "australienne"
    ],
    "australiens": [
        "australien"
    ],
    "australopitheque": [
        "australopitheque"
    ],
    "australopitheques": [
        "australopitheque"
    ],
    "austro": [
        "austro"
    ],
    "austere": [
        "austere"
    ],
    "austerement": [
        "austerement"
    ],
    "austeres": [
        "austere"
    ],
    "austerite": [
        "austerite"
    ],
    "austerites": [
        "austerite"
    ],
    "ausweis": [
        "ausweis"
    ],
    "autan": [
        "autan"
    ],
    "autant": [
        "autant"
    ],
    "autarcie": [
        "autarcie"
    ],
    "autarcique": [
        "autarcique"
    ],
    "autarciques": [
        "autarcique"
    ],
    "autel": [
        "autel"
    ],
    "autels": [
        "autel"
    ],
    "auteur": [
        "auteur"
    ],
    "auteure": [
        "auteur"
    ],
    "auteurs": [
        "auteur"
    ],
    "authenticite": [
        "authenticite"
    ],
    "authentifiait": [
        "authentifier"
    ],
    "authentification": [
        "authentification"
    ],
    "authentifie": [
        "authentifier"
    ],
    "authentifient": [
        "authentifier"
    ],
    "authentifier": [
        "authentifier"
    ],
    "authentifierait": [
        "authentifier"
    ],
    "authentifiez": [
        "authentifier"
    ],
    "authentifiee": [
        "authentifier"
    ],
    "authentifiees": [
        "authentifier"
    ],
    "authentifies": [
        "authentifier"
    ],
    "authentiquant": [
        "authentiquer"
    ],
    "authentique": [
        "authentique",
        "authentiquer"
    ],
    "authentiquement": [
        "authentiquement"
    ],
    "authentiques": [
        "authentique"
    ],
    "autisme": [
        "autisme"
    ],
    "autiste": [
        "autiste"
    ],
    "autistes": [
        "autiste"
    ],
    "autistique": [
        "autistique"
    ],
    "auto": [
        "auto"
    ],
    "autobiographe": [
        "autobiographe"
    ],
    "autobiographie": [
        "autobiographie"
    ],
    "autobiographies": [
        "autobiographie",
        "autobiography"
    ],
    "autobiographique": [
        "autobiographique"
    ],
    "autobiographiques": [
        "autobiographique"
    ],
    "autobronzant": [
        "autobronzant"
    ],
    "autobus": [
        "autobus"
    ],
    "autocar": [
        "autocar"
    ],
    "autocars": [
        "autocar"
    ],
    "autocensure": [
        "autocensurer",
        "autocensure"
    ],
    "autocensurent": [
        "autocensurer"
    ],
    "autocensurer": [
        "autocensurer"
    ],
    "autochenille": [
        "autochenille"
    ],
    "autochtone": [
        "autochtone"
    ],
    "autochtones": [
        "autochtone"
    ],
    "autoclave": [
        "autoclave"
    ],
    "autocollant": [
        "autocollant"
    ],
    "autocollante": [
        "autocollant"
    ],
    "autocollantes": [
        "autocollant"
    ],
    "autocollants": [
        "autocollant"
    ],
    "autoconservation": [
        "autoconservation"
    ],
    "autocrate": [
        "autocrate"
    ],
    "autocrates": [
        "autocrate"
    ],
    "autocratie": [
        "autocratie"
    ],
    "autocratique": [
        "autocratique"
    ],
    "autocratiques": [
        "autocratique"
    ],
    "autocritique": [
        "autocritique"
    ],
    "autocritiquer": [
        "autocritiquer"
    ],
    "autocritiques": [
        "autocritique"
    ],
    "autocreation": [
        "autocreation"
    ],
    "autocuiseur": [
        "autocuiseur"
    ],
    "autodafe": [
        "autodafe"
    ],
    "autodafes": [
        "autodafe"
    ],
    "autodestructeur": [
        "autodestructeur"
    ],
    "autodestructeurs": [
        "autodestructeur"
    ],
    "autodestructible": [
        "autodestructible"
    ],
    "autodestruction": [
        "autodestruction"
    ],
    "autodestructrice": [
        "autodestructeur"
    ],
    "autodidacte": [
        "autodidacte"
    ],
    "autodidactes": [
        "autodidacte"
    ],
    "autodidactique": [
        "autodidactique"
    ],
    "autodirecteur": [
        "autodirecteur"
    ],
    "autodiscipline": [
        "autodiscipline"
    ],
    "autodrome": [
        "autodrome"
    ],
    "autodefense": [
        "autodefense"
    ],
    "autodenigrement": [
        "autodenigrement"
    ],
    "autoderision": [
        "autoderision"
    ],
    "autodetermination": [
        "autodetermination"
    ],
    "autodetruira": [
        "autodetruire"
    ],
    "autodetruire": [
        "autodetruire"
    ],
    "autodetruiront": [
        "autodetruire"
    ],
    "autodetruisant": [
        "autodetruire"
    ],
    "autodetruisent": [
        "autodetruire"
    ],
    "autodetruit": [
        "autodetruire"
    ],
    "autodetruite": [
        "autodetruire"
    ],
    "autofinancement": [
        "autofinancement"
    ],
    "autofocus": [
        "autofocus"
    ],
    "autogenese": [
        "autogenese"
    ],
    "autogestion": [
        "autogestion"
    ],
    "autogire": [
        "autogire"
    ],
    "autogires": [
        "autogire"
    ],
    "autographe": [
        "autographe"
    ],
    "autographes": [
        "autographe"
    ],
    "autographier": [
        "autographier"
    ],
    "autographie": [
        "autographier"
    ],
    "autoguidage": [
        "autoguidage"
    ],
    "autoguide": [
        "autoguide"
    ],
    "autogene": [
        "autogene"
    ],
    "autogerer": [
        "autogerer"
    ],
    "autogeree": [
        "autogere"
    ],
    "autolimite": [
        "autolimiter"
    ],
    "autologues": [
        "autologue"
    ],
    "autolysat": [
        "autolysat"
    ],
    "autolyse": [
        "autolyse"
    ],
    "automate": [
        "automate"
    ],
    "automates": [
        "automate"
    ],
    "automatico": [
        "automatico"
    ],
    "automation": [
        "automation"
    ],
    "automatique": [
        "automatique"
    ],
    "automatiquement": [
        "automatiquement"
    ],
    "automatiques": [
        "automatique"
    ],
    "automatisation": [
        "automatisation"
    ],
    "automatisme": [
        "automatisme"
    ],
    "automatismes": [
        "automatisme"
    ],
    "automatise": [
        "automatise",
        "automatiser"
    ],
    "automatisee": [
        "automatise",
        "automatiser"
    ],
    "automatisees": [
        "automatise"
    ],
    "automatises": [
        "automatise",
        "automatiser"
    ],
    "automitrailleuse": [
        "automitrailleur"
    ],
    "automitrailleuses": [
        "automitrailleur"
    ],
    "automnal": [
        "automnal"
    ],
    "automnale": [
        "automnal"
    ],
    "automnales": [
        "automnal"
    ],
    "automne": [
        "automne"
    ],
    "automnes": [
        "automne"
    ],
    "automobile": [
        "automobile"
    ],
    "automobiles": [
        "automobile"
    ],
    "automobiliste": [
        "automobiliste"
    ],
    "automobilistes": [
        "automobiliste"
    ],
    "automoteur": [
        "automoteur"
    ],
    "automoteurs": [
        "automoteur"
    ],
    "automotrice": [
        "automoteur"
    ],
    "automutilation": [
        "automutilation"
    ],
    "automutiler": [
        "automutiler"
    ],
    "automedication": [
        "automedication"
    ],
    "autoneige": [
        "autoneige"
    ],
    "autoneiges": [
        "autoneige"
    ],
    "autonettoyant": [
        "autonettoyant"
    ],
    "autonettoyante": [
        "autonettoyant"
    ],
    "autonome": [
        "autonome"
    ],
    "autonomes": [
        "autonome"
    ],
    "autonomie": [
        "autonomie"
    ],
    "autonomique": [
        "autonomique"
    ],
    "autonomistes": [
        "autonomiste"
    ],
    "autopilote": [
        "autopilote"
    ],
    "autoplastie": [
        "autoplastie"
    ],
    "autoportrait": [
        "autoportrait"
    ],
    "autoportraits": [
        "autoportrait"
    ],
    "autoportee": [
        "autoporte"
    ],
    "autoproclame": [
        "autoproclamer"
    ],
    "autoproclamee": [
        "autoproclamer"
    ],
    "autoproduit": [
        "autoproduit"
    ],
    "autopropulseur": [
        "autopropulseur"
    ],
    "autopropulse": [
        "autopropulse"
    ],
    "autopropulsee": [
        "autopropulse"
    ],
    "autopropulses": [
        "autopropulse"
    ],
    "autopsia": [
        "autopsier"
    ],
    "autopsiais": [
        "autopsier"
    ],
    "autopsie": [
        "autopsier",
        "autopsie"
    ],
    "autopsier": [
        "autopsier"
    ],
    "autopsies": [
        "autopsie",
        "autopsy"
    ],
    "autopunition": [
        "autopunition"
    ],
    "autoradio": [
        "autoradio"
    ],
    "autoradios": [
        "autoradio"
    ],
    "autorail": [
        "autorail"
    ],
    "autoreproduction": [
        "autoreproduction"
    ],
    "autorisa": [
        "autoriser"
    ],
    "autorisai": [
        "autoriser"
    ],
    "autorisaient": [
        "autoriser"
    ],
    "autorisais": [
        "autoriser"
    ],
    "autorisait": [
        "autoriser"
    ],
    "autorisant": [
        "autoriser"
    ],
    "autorisassent": [
        "autoriser"
    ],
    "autorisation": [
        "autorisation"
    ],
    "autorisations": [
        "autorisation"
    ],
    "autorise": [
        "autorise",
        "autoriser"
    ],
    "autorisent": [
        "autoriser"
    ],
    "autoriser": [
        "autoriser"
    ],
    "autorisera": [
        "autoriser"
    ],
    "autoriserai": [
        "autoriser"
    ],
    "autoriserais": [
        "autoriser"
    ],
    "autoriserait": [
        "autoriser"
    ],
    "autoriserez": [
        "autoriser"
    ],
    "autoriserons": [
        "autoriser"
    ],
    "autoriseront": [
        "autoriser"
    ],
    "autorises": [
        "autorise",
        "autoriser"
    ],
    "autorisez": [
        "autoriser"
    ],
    "autorisiez": [
        "autoriser"
    ],
    "autorisions": [
        "autoriser"
    ],
    "autorisons": [
        "autoriser"
    ],
    "autorisat": [
        "autoriser"
    ],
    "autoriserent": [
        "autoriser"
    ],
    "autorisee": [
        "autorise",
        "autoriser"
    ],
    "autorisees": [
        "autorise",
        "autoriser"
    ],
    "autoritaire": [
        "autoritaire"
    ],
    "autoritairement": [
        "autoritairement"
    ],
    "autoritaires": [
        "autoritaire"
    ],
    "autoritarisme": [
        "autoritarisme"
    ],
    "autorite": [
        "autorite"
    ],
    "autorites": [
        "autorite"
    ],
    "autoroute": [
        "autoroute"
    ],
    "autoroutes": [
        "autoroute"
    ],
    "autoroutiers": [
        "autoroutier"
    ],
    "autoroutiere": [
        "autoroutiere",
        "autoroutier"
    ],
    "autoregulateur": [
        "autoregulateur"
    ],
    "autoregulation": [
        "autoregulation"
    ],
    "autoregule": [
        "autoreguler"
    ],
    "autos": [
        "auto"
    ],
    "autosatisfaction": [
        "autosatisfaction"
    ],
    "autostop": [
        "autostop"
    ],
    "autostrade": [
        "autostrade"
    ],
    "autostrades": [
        "autostrade"
    ],
    "autosubsistance": [
        "autosubsistance"
    ],
    "autosuffisance": [
        "autosuffisance"
    ],
    "autosuffisant": [
        "autosuffisant"
    ],
    "autosuffisants": [
        "autosuffisant"
    ],
    "autosuggestion": [
        "autosuggestion"
    ],
    "autosuggestionna": [
        "autosuggestionner"
    ],
    "autosurveillance": [
        "autosurveillance"
    ],
    "autour": [
        "autour"
    ],
    "autours": [
        "autour"
    ],
    "autoerotique": [
        "autoerotique"
    ],
    "autre": [
        "autre"
    ],
    "autrefois": [
        "autrefois"
    ],
    "autrement": [
        "autrement"
    ],
    "autres": [
        "autres",
        "autre"
    ],
    "autrichien": [
        "autrichien"
    ],
    "autrichienne": [
        "autrichien"
    ],
    "autrichiennes": [
        "autrichien"
    ],
    "autrichiens": [
        "autrichien",
        "autrichiens"
    ],
    "autruche": [
        "autruche"
    ],
    "autruches": [
        "autruche"
    ],
    "autrui": [
        "autrui"
    ],
    "auvent": [
        "auvent"
    ],
    "auvents": [
        "auvent"
    ],
    "auvergnat": [
        "auvergnat"
    ],
    "auvergnate": [
        "auvergnat"
    ],
    "auvergnates": [
        "auvergnat"
    ],
    "auvergnats": [
        "auvergnat"
    ],
    "auvergne": [
        "auvergne"
    ],
    "auverpin": [
        "auverpin"
    ],
    "auverpins": [
        "auverpin"
    ],
    "aux": [
        "aux",
        "au"
    ],
    "auxdits": [
        "auxdits"
    ],
    "auxerrois": [
        "auxerrois"
    ],
    "auxiliaire": [
        "auxiliaire"
    ],
    "auxiliaires": [
        "auxiliaire"
    ],
    "auxquelles": [
        "auxquelles"
    ],
    "auxquels": [
        "auxquels"
    ],
    "avachi": [
        "avachi",
        "avachir"
    ],
    "avachie": [
        "avachi",
        "avachir"
    ],
    "avachies": [
        "avachi"
    ],
    "avachir": [
        "avachir"
    ],
    "avachirait": [
        "avachir"
    ],
    "avachirons": [
        "avachir"
    ],
    "avachis": [
        "avachi",
        "avachir"
    ],
    "avachissait": [
        "avachir"
    ],
    "avachissement": [
        "avachissement"
    ],
    "avachissent": [
        "avachir"
    ],
    "avachit": [
        "avachir"
    ],
    "avaient": [
        "avoir"
    ],
    "avais": [
        "avoir"
    ],
    "avait": [
        "avoir"
    ],
    "aval": [
        "aval"
    ],
    "avala": [
        "avaler"
    ],
    "avalage": [
        "avalage"
    ],
    "avalai": [
        "avaler"
    ],
    "avalaient": [
        "avaler"
    ],
    "avalais": [
        "avaler"
    ],
    "avalait": [
        "avaler"
    ],
    "avalanche": [
        "avalanche"
    ],
    "avalanches": [
        "avalanche"
    ],
    "avalant": [
        "avaler",
        "avalant"
    ],
    "avale": [
        "avaler"
    ],
    "avalement": [
        "avalement"
    ],
    "avalent": [
        "avaler"
    ],
    "avaler": [
        "avaler"
    ],
    "avalera": [
        "avaler"
    ],
    "avalerai": [
        "avaler"
    ],
    "avaleraient": [
        "avaler"
    ],
    "avalerais": [
        "avaler"
    ],
    "avalerait": [
        "avaler"
    ],
    "avaleras": [
        "avaler"
    ],
    "avaleriez": [
        "avaler"
    ],
    "avaleront": [
        "avaler"
    ],
    "avales": [
        "avaler"
    ],
    "avaleur": [
        "avaleur"
    ],
    "avaleurs": [
        "avaleur"
    ],
    "avaleuse": [
        "avaleur"
    ],
    "avalez": [
        "avaler"
    ],
    "avaliez": [
        "avaler"
    ],
    "avaliser": [
        "avaliser"
    ],
    "avaliseur": [
        "avaliseur"
    ],
    "avalises": [
        "avaliser"
    ],
    "avaloires": [
        "avaloire"
    ],
    "avalons": [
        "avaler"
    ],
    "avalames": [
        "avaler"
    ],
    "avalat": [
        "avaler"
    ],
    "avalerent": [
        "avaler"
    ],
    "avalee": [
        "avaler"
    ],
    "avalees": [
        "avaler"
    ],
    "avance": [
        "avancer",
        "avance"
    ],
    "avancement": [
        "avancement"
    ],
    "avancements": [
        "avancement"
    ],
    "avancent": [
        "avancer"
    ],
    "avancer": [
        "avancer"
    ],
    "avancera": [
        "avancer"
    ],
    "avancerai": [
        "avancer"
    ],
    "avancerais": [
        "avancer"
    ],
    "avancerait": [
        "avancer"
    ],
    "avancerez": [
        "avancer"
    ],
    "avancerons": [
        "avancer"
    ],
    "avanceront": [
        "avancer"
    ],
    "avances": [
        "avancer",
        "avance"
    ],
    "avancez": [
        "avancer"
    ],
    "avanciez": [
        "avancer"
    ],
    "avancions": [
        "avancer"
    ],
    "avancerent": [
        "avancer"
    ],
    "avancee": [
        "avancer",
        "avance",
        "avancee"
    ],
    "avancees": [
        "avancer",
        "avance",
        "avancee"
    ],
    "avanie": [
        "avanie"
    ],
    "avanies": [
        "avanie"
    ],
    "avant": [
        "avant"
    ],
    "avantage": [
        "avantager",
        "avantage"
    ],
    "avantageaient": [
        "avantager"
    ],
    "avantageais": [
        "avantager"
    ],
    "avantageait": [
        "avantager"
    ],
    "avantageant": [
        "avantager"
    ],
    "avantagent": [
        "avantager"
    ],
    "avantager": [
        "avantager"
    ],
    "avantagera": [
        "avantager"
    ],
    "avantages": [
        "avantager",
        "avantage"
    ],
    "avantageuse": [
        "avantageux"
    ],
    "avantageusement": [
        "avantageusement"
    ],
    "avantageuses": [
        "avantageux"
    ],
    "avantageux": [
        "avantageux"
    ],
    "avantagee": [
        "avantager"
    ],
    "avants": [
        "avant"
    ],
    "avanca": [
        "avancer"
    ],
    "avancai": [
        "avancer"
    ],
    "avancaient": [
        "avancer"
    ],
    "avancais": [
        "avancer"
    ],
    "avancait": [
        "avancer"
    ],
    "avancant": [
        "avancer"
    ],
    "avancons": [
        "avancer",
        "avancon"
    ],
    "avancames": [
        "avancer"
    ],
    "avancat": [
        "avancer"
    ],
    "avare": [
        "avare"
    ],
    "avarement": [
        "avarement"
    ],
    "avares": [
        "avare"
    ],
    "avarice": [
        "avarice"
    ],
    "avarices": [
        "avarice"
    ],
    "avaricieuse": [
        "avaricieux"
    ],
    "avaricieusement": [
        "avaricieusement"
    ],
    "avaricieux": [
        "avaricieux"
    ],
    "avarie": [
        "avarie",
        "avarier"
    ],
    "avarient": [
        "avarier"
    ],
    "avaries": [
        "avarie",
        "avarier"
    ],
    "avariee": [
        "avarie",
        "avarier"
    ],
    "avariees": [
        "avarie",
        "avarier"
    ],
    "avaro": [
        "avaro"
    ],
    "avaros": [
        "avaro"
    ],
    "avatar": [
        "avatar"
    ],
    "avatars": [
        "avatar"
    ],
    "ave": [
        "ave"
    ],
    "avec": [
        "avec"
    ],
    "avelines": [
        "aveline"
    ],
    "avenant": [
        "avenant"
    ],
    "avenante": [
        "avenant"
    ],
    "avenantes": [
        "avenant"
    ],
    "avenants": [
        "avenant"
    ],
    "avenir": [
        "avenir"
    ],
    "avenirs": [
        "avenir"
    ],
    "avent": [
        "avent"
    ],
    "aventura": [
        "aventurer"
    ],
    "aventurai": [
        "aventurer"
    ],
    "aventuraient": [
        "aventurer"
    ],
    "aventurais": [
        "aventurer"
    ],
    "aventurait": [
        "aventurer"
    ],
    "aventurant": [
        "aventurer"
    ],
    "aventure": [
        "aventure",
        "aventurer"
    ],
    "aventurent": [
        "aventurer"
    ],
    "aventurer": [
        "aventurer"
    ],
    "aventurerai": [
        "aventurer"
    ],
    "aventurerais": [
        "aventurer"
    ],
    "aventurerait": [
        "aventurer"
    ],
    "aventures": [
        "aventure",
        "aventurer"
    ],
    "aventureuse": [
        "aventureux"
    ],
    "aventureuses": [
        "aventureux"
    ],
    "aventureux": [
        "aventureux"
    ],
    "aventurez": [
        "aventurer"
    ],
    "aventurier": [
        "aventurier"
    ],
    "aventuriers": [
        "aventurier"
    ],
    "aventurines": [
        "aventurine"
    ],
    "aventurions": [
        "aventurer"
    ],
    "aventuriere": [
        "aventurier"
    ],
    "aventurieres": [
        "aventurier"
    ],
    "aventurons": [
        "aventurer"
    ],
    "aventurat": [
        "aventurer"
    ],
    "aventurerent": [
        "aventurer"
    ],
    "aventuree": [
        "aventure",
        "aventurer"
    ],
    "aventurees": [
        "aventure",
        "aventurer"
    ],
    "avenu": [
        "avenu"
    ],
    "avenue": [
        "avenue"
    ],
    "avenues": [
        "avenue",
        "avenu"
    ],
    "avenus": [
        "avenu"
    ],
    "avers": [
        "avers"
    ],
    "averse": [
        "averse"
    ],
    "averses": [
        "averse"
    ],
    "aversion": [
        "aversion"
    ],
    "aversions": [
        "aversion"
    ],
    "averti": [
        "averti",
        "avertir"
    ],
    "avertie": [
        "averti",
        "avertir"
    ],
    "averties": [
        "averti",
        "avertir"
    ],
    "avertir": [
        "avertir"
    ],
    "avertira": [
        "avertir"
    ],
    "avertirai": [
        "avertir"
    ],
    "avertirait": [
        "avertir"
    ],
    "avertiras": [
        "avertir"
    ],
    "avertirent": [
        "avertir"
    ],
    "avertirez": [
        "avertir"
    ],
    "avertis": [
        "averti",
        "avertir"
    ],
    "avertissaient": [
        "avertir"
    ],
    "avertissais": [
        "avertir"
    ],
    "avertissait": [
        "avertir"
    ],
    "avertissant": [
        "avertir"
    ],
    "avertisse": [
        "avertir"
    ],
    "avertissement": [
        "avertissement"
    ],
    "avertissements": [
        "avertissement"
    ],
    "avertissent": [
        "avertir"
    ],
    "avertisseur": [
        "avertisseur"
    ],
    "avertisseurs": [
        "avertisseur"
    ],
    "avertisseuses": [
        "avertisseur"
    ],
    "avertissez": [
        "avertir"
    ],
    "avertissiez": [
        "avertir"
    ],
    "avertissons": [
        "avertir"
    ],
    "avertit": [
        "avertir"
    ],
    "aveu": [
        "aveu"
    ],
    "aveugla": [
        "aveugler"
    ],
    "aveuglaient": [
        "aveugler"
    ],
    "aveuglais": [
        "aveugler"
    ],
    "aveuglait": [
        "aveugler"
    ],
    "aveuglant": [
        "aveugler",
        "aveuglant"
    ],
    "aveuglante": [
        "aveuglant"
    ],
    "aveuglantes": [
        "aveuglant"
    ],
    "aveuglants": [
        "aveuglant"
    ],
    "aveugle": [
        "aveugler",
        "aveugle"
    ],
    "aveuglement": [
        "aveuglement"
    ],
    "aveuglements": [
        "aveuglement"
    ],
    "aveuglent": [
        "aveugler"
    ],
    "aveugler": [
        "aveugler"
    ],
    "aveuglera": [
        "aveugler"
    ],
    "aveuglerait": [
        "aveugler"
    ],
    "aveugles": [
        "aveugler",
        "aveugle"
    ],
    "aveuglez": [
        "aveugler"
    ],
    "aveuglons": [
        "aveugler"
    ],
    "aveuglat": [
        "aveugler"
    ],
    "aveuglerent": [
        "aveugler"
    ],
    "aveuglee": [
        "aveugler"
    ],
    "aveuglees": [
        "aveugler"
    ],
    "aveuli": [
        "aveulir"
    ],
    "aveulissante": [
        "aveulissant"
    ],
    "aveux": [
        "aveu"
    ],
    "avez": [
        "avoir"
    ],
    "aviaire": [
        "aviaire"
    ],
    "aviateur": [
        "aviateur"
    ],
    "aviateurs": [
        "aviateur"
    ],
    "aviation": [
        "aviation"
    ],
    "aviations": [
        "aviation"
    ],
    "aviatrice": [
        "aviateur"
    ],
    "aviatrices": [
        "aviateur"
    ],
    "avicole": [
        "avicole"
    ],
    "aviculture": [
        "aviculture"
    ],
    "avide": [
        "avide"
    ],
    "avidement": [
        "avidement"
    ],
    "avides": [
        "avide"
    ],
    "avidite": [
        "avidite"
    ],
    "avidites": [
        "avidite"
    ],
    "aviez": [
        "avoir"
    ],
    "avignonnais": [
        "avignonnais"
    ],
    "avignonnaise": [
        "avignonnais"
    ],
    "avili": [
        "avilir"
    ],
    "avilie": [
        "avilir"
    ],
    "avilies": [
        "avilir"
    ],
    "avilir": [
        "avilir"
    ],
    "avilis": [
        "avilir"
    ],
    "avilissait": [
        "avilir"
    ],
    "avilissant": [
        "avilir",
        "avilissant"
    ],
    "avilissante": [
        "avilissant"
    ],
    "avilissantes": [
        "avilissant"
    ],
    "avilissants": [
        "avilissant"
    ],
    "avilissement": [
        "avilissement"
    ],
    "avilissent": [
        "avilir"
    ],
    "avilit": [
        "avilir"
    ],
    "avine": [
        "avine"
    ],
    "avinee": [
        "avine"
    ],
    "avinees": [
        "avine",
        "aviner"
    ],
    "avines": [
        "avine",
        "aviner"
    ],
    "avion": [
        "avion"
    ],
    "avionique": [
        "avionique"
    ],
    "avionnettes": [
        "avionnette"
    ],
    "avionneurs": [
        "avionneur"
    ],
    "avions": [
        "avoir",
        "avion"
    ],
    "aviron": [
        "aviron"
    ],
    "avirons": [
        "aviron"
    ],
    "avis": [
        "avis"
    ],
    "avisa": [
        "aviser"
    ],
    "avisai": [
        "aviser"
    ],
    "avisaient": [
        "aviser"
    ],
    "avisais": [
        "aviser"
    ],
    "avisait": [
        "aviser"
    ],
    "avisant": [
        "aviser"
    ],
    "avise": [
        "avise",
        "aviser"
    ],
    "avisent": [
        "aviser"
    ],
    "aviser": [
        "aviser"
    ],
    "avisera": [
        "aviser"
    ],
    "aviserai": [
        "aviser"
    ],
    "aviseraient": [
        "aviser"
    ],
    "aviserais": [
        "aviser"
    ],
    "aviserait": [
        "aviser"
    ],
    "aviseras": [
        "aviser"
    ],
    "aviserons": [
        "aviser"
    ],
    "aviseront": [
        "aviser"
    ],
    "avises": [
        "avise",
        "aviser"
    ],
    "avisez": [
        "aviser"
    ],
    "avisions": [
        "aviser"
    ],
    "aviso": [
        "aviso"
    ],
    "avisos": [
        "aviso"
    ],
    "avisat": [
        "aviser"
    ],
    "aviserent": [
        "aviser"
    ],
    "avisee": [
        "avise",
        "aviser"
    ],
    "avisees": [
        "avise"
    ],
    "avitailler": [
        "avitailler"
    ],
    "avitaminose": [
        "avitaminose"
    ],
    "aviva": [
        "aviver"
    ],
    "avivaient": [
        "aviver"
    ],
    "avivait": [
        "aviver"
    ],
    "avivant": [
        "aviver"
    ],
    "avive": [
        "avive",
        "aviver"
    ],
    "avivent": [
        "aviver"
    ],
    "aviver": [
        "aviver"
    ],
    "avivons": [
        "aviver"
    ],
    "avivat": [
        "aviver"
    ],
    "aviverent": [
        "aviver"
    ],
    "avivee": [
        "aviver"
    ],
    "avivees": [
        "aviver"
    ],
    "avives": [
        "aviver"
    ],
    "avocaillon": [
        "avocaillon"
    ],
    "avocasseries": [
        "avocasserie"
    ],
    "avocat": [
        "avocat"
    ],
    "avocate": [
        "avocat"
    ],
    "avocates": [
        "avocat"
    ],
    "avocatier": [
        "avocatier"
    ],
    "avocats": [
        "avocat"
    ],
    "avocette": [
        "avocette"
    ],
    "avoient": [
        "avoyer"
    ],
    "avoinaient": [
        "avoiner"
    ],
    "avoine": [
        "avoine"
    ],
    "avoiner": [
        "avoiner"
    ],
    "avoines": [
        "avoine"
    ],
    "avoir": [
        "avoir"
    ],
    "avoirs": [
        "avoir"
    ],
    "avoisinaient": [
        "avoisiner"
    ],
    "avoisinait": [
        "avoisiner"
    ],
    "avoisinant": [
        "avoisinant",
        "avoisiner"
    ],
    "avoisinante": [
        "avoisinant"
    ],
    "avoisinantes": [
        "avoisinant"
    ],
    "avoisinants": [
        "avoisinant"
    ],
    "avoisine": [
        "avoisiner"
    ],
    "avoisinent": [
        "avoisiner"
    ],
    "avoisiner": [
        "avoisiner"
    ],
    "avoisinerait": [
        "avoisiner"
    ],
    "avons": [
        "avoir",
        "avon"
    ],
    "avorta": [
        "avorter"
    ],
    "avortait": [
        "avorter"
    ],
    "avortant": [
        "avorter"
    ],
    "avorte": [
        "avorter",
        "avorte"
    ],
    "avortement": [
        "avortement"
    ],
    "avortements": [
        "avortement"
    ],
    "avortent": [
        "avorter"
    ],
    "avorter": [
        "avorter"
    ],
    "avorterai": [
        "avorter"
    ],
    "avorterait": [
        "avorter"
    ],
    "avorteriez": [
        "avorter"
    ],
    "avorteur": [
        "avorteur"
    ],
    "avorteurs": [
        "avorteur"
    ],
    "avorteuse": [
        "avorteur"
    ],
    "avorteuses": [
        "avorteur"
    ],
    "avortez": [
        "avorter"
    ],
    "avorton": [
        "avorton"
    ],
    "avortons": [
        "avorter",
        "avorton"
    ],
    "avortee": [
        "avorter",
        "avorte"
    ],
    "avortees": [
        "avorter",
        "avorte"
    ],
    "avortes": [
        "avorter",
        "avorte"
    ],
    "avoua": [
        "avouer"
    ],
    "avouable": [
        "avouable"
    ],
    "avouables": [
        "avouable"
    ],
    "avouai": [
        "avouer"
    ],
    "avouaient": [
        "avouer"
    ],
    "avouais": [
        "avouer"
    ],
    "avouait": [
        "avouer"
    ],
    "avouant": [
        "avouer"
    ],
    "avouas": [
        "avouer"
    ],
    "avoue": [
        "avoue",
        "avouer"
    ],
    "avouent": [
        "avouer"
    ],
    "avouer": [
        "avouer"
    ],
    "avouera": [
        "avouer"
    ],
    "avouerai": [
        "avouer"
    ],
    "avoueraient": [
        "avouer"
    ],
    "avouerais": [
        "avouer"
    ],
    "avouerait": [
        "avouer"
    ],
    "avoueras": [
        "avouer"
    ],
    "avouerez": [
        "avouer"
    ],
    "avoueriez": [
        "avouer"
    ],
    "avouerions": [
        "avouer"
    ],
    "avoueront": [
        "avouer"
    ],
    "avoues": [
        "avoue",
        "avouer"
    ],
    "avouez": [
        "avouer"
    ],
    "avouiez": [
        "avouer"
    ],
    "avouions": [
        "avouer"
    ],
    "avouons": [
        "avouer"
    ],
    "avouames": [
        "avouer"
    ],
    "avouat": [
        "avouer"
    ],
    "avouerent": [
        "avouer"
    ],
    "avouee": [
        "avoue",
        "avouer"
    ],
    "avouees": [
        "avoue",
        "avouer"
    ],
    "avoyer": [
        "avoyer"
    ],
    "avril": [
        "avril"
    ],
    "avrillee": [
        "avrillee"
    ],
    "avulsion": [
        "avulsion"
    ],
    "avunculaire": [
        "avunculaire"
    ],
    "avunculat": [
        "avunculat"
    ],
    "avenement": [
        "avenement"
    ],
    "avere": [
        "averer",
        "avere"
    ],
    "averent": [
        "averer"
    ],
    "avera": [
        "averer"
    ],
    "averai": [
        "averer"
    ],
    "averaient": [
        "averer"
    ],
    "averait": [
        "averer"
    ],
    "averant": [
        "averer"
    ],
    "averer": [
        "averer"
    ],
    "averera": [
        "averer"
    ],
    "avereraient": [
        "averer"
    ],
    "avererait": [
        "averer"
    ],
    "averat": [
        "averer"
    ],
    "avererent": [
        "averer"
    ],
    "averee": [
        "averer",
        "avere"
    ],
    "averees": [
        "averer",
        "avere"
    ],
    "averes": [
        "averer",
        "avere"
    ],
    "awacs": [
        "awacs"
    ],
    "axa": [
        "axer"
    ],
    "axe": [
        "axer",
        "axe"
    ],
    "axel": [
        "axel"
    ],
    "axels": [
        "axel"
    ],
    "axent": [
        "axer"
    ],
    "axer": [
        "axer"
    ],
    "axes": [
        "ax",
        "axer",
        "axe"
    ],
    "axial": [
        "axial"
    ],
    "axiale": [
        "axial"
    ],
    "axillaire": [
        "axillaire"
    ],
    "axiomatisation": [
        "axiomatisation"
    ],
    "axiome": [
        "axiome"
    ],
    "axiomes": [
        "axiome"
    ],
    "axis": [
        "axis"
    ],
    "axolotl": [
        "axolotl"
    ],
    "axolotls": [
        "axolotl"
    ],
    "axonge": [
        "axonge"
    ],
    "axee": [
        "axer"
    ],
    "axees": [
        "axer"
    ],
    "aya": [
        "aya"
    ],
    "ayans": [
        "ayan"
    ],
    "ayant": [
        "avoir"
    ],
    "ayatollah": [
        "ayatollah"
    ],
    "ayatollahs": [
        "ayatollah"
    ],
    "ayez": [
        "avoir"
    ],
    "ayons": [
        "avoir"
    ],
    "ayuntamiento": [
        "ayuntamiento"
    ],
    "azalee": [
        "azalee"
    ],
    "azalees": [
        "azalee"
    ],
    "azerbaidjanais": [
        "azerbaidjanais"
    ],
    "azimut": [
        "azimut"
    ],
    "azimutal": [
        "azimutal"
    ],
    "azimuts": [
        "azimut"
    ],
    "azimute": [
        "azimute",
        "azimuter"
    ],
    "azimutee": [
        "azimuter"
    ],
    "azoospermie": [
        "azoospermie"
    ],
    "azote": [
        "azote"
    ],
    "azoture": [
        "azoture"
    ],
    "azoique": [
        "azoique"
    ],
    "azteque": [
        "azteque"
    ],
    "azteques": [
        "azteque"
    ],
    "azulejo": [
        "azulejo"
    ],
    "azulejos": [
        "azulejo"
    ],
    "azur": [
        "azur"
    ],
    "azurs": [
        "azur"
    ],
    "azure": [
        "azure",
        "azurer"
    ],
    "azuree": [
        "azure",
        "azurer"
    ],
    "azurees": [
        "azure"
    ],
    "azures": [
        "azure"
    ],
    "azygos": [
        "azygos"
    ],
    "azyme": [
        "azyme"
    ],
    "azeri": [
        "azeri"
    ],
    "azeris": [
        "azeri"
    ],
    "aede": [
        "aede"
    ],
    "aedes": [
        "aede"
    ],
    "aere": [
        "aerer",
        "aere"
    ],
    "aerage": [
        "aerage"
    ],
    "aeraient": [
        "aerer"
    ],
    "aerait": [
        "aerer"
    ],
    "aerateur": [
        "aerateur"
    ],
    "aerateurs": [
        "aerateur"
    ],
    "aeration": [
        "aeration"
    ],
    "aerations": [
        "aeration"
    ],
    "aerer": [
        "aerer"
    ],
    "aerez": [
        "aerer"
    ],
    "aerien": [
        "aerien"
    ],
    "aerienne": [
        "aerien"
    ],
    "aeriennes": [
        "aerien"
    ],
    "aeriens": [
        "aerien"
    ],
    "aero": [
        "aero"
    ],
    "aerobic": [
        "aerobic"
    ],
    "aerobics": [
        "aerobic"
    ],
    "aerodrome": [
        "aerodrome"
    ],
    "aerodromes": [
        "aerodrome"
    ],
    "aerodynamique": [
        "aerodynamique"
    ],
    "aerodynamiques": [
        "aerodynamique"
    ],
    "aerodynamisme": [
        "aerodynamisme"
    ],
    "aerofrein": [
        "aerofrein"
    ],
    "aerofreins": [
        "aerofrein"
    ],
    "aerogare": [
        "aerogare"
    ],
    "aerogares": [
        "aerogare"
    ],
    "aeroglisseur": [
        "aeroglisseur"
    ],
    "aeroglisseurs": [
        "aeroglisseur"
    ],
    "aerographe": [
        "aerographe"
    ],
    "aerolithe": [
        "aerolithe"
    ],
    "aerolithes": [
        "aerolithe"
    ],
    "aerologie": [
        "aerologie"
    ],
    "aeromobile": [
        "aeromobile"
    ],
    "aeromodelisme": [
        "aeromodelisme"
    ],
    "aeronaute": [
        "aeronaute"
    ],
    "aeronautes": [
        "aeronaute"
    ],
    "aeronautique": [
        "aeronautique"
    ],
    "aeronautiques": [
        "aeronautique"
    ],
    "aeronaval": [
        "aeronaval"
    ],
    "aeronavale": [
        "aeronavale",
        "aeronaval"
    ],
    "aeronavales": [
        "aeronaval"
    ],
    "aeronavals": [
        "aeronaval"
    ],
    "aeronef": [
        "aeronef"
    ],
    "aeronefs": [
        "aeronef"
    ],
    "aerons": [
        "aerer"
    ],
    "aeropathie": [
        "aeropathie"
    ],
    "aerophagie": [
        "aerophagie"
    ],
    "aeroplane": [
        "aeroplane"
    ],
    "aeroplanes": [
        "aeroplane"
    ],
    "aeroport": [
        "aeroport"
    ],
    "aeroports": [
        "aeroport"
    ],
    "aeroporte": [
        "aeroporte"
    ],
    "aeroportee": [
        "aeroporte"
    ],
    "aeroportees": [
        "aeroporte"
    ],
    "aeroportes": [
        "aeroporte"
    ],
    "aeropostale": [
        "aeropostale"
    ],
    "aerosol": [
        "aerosol"
    ],
    "aerosols": [
        "aerosol"
    ],
    "aerospatial": [
        "aerospatial"
    ],
    "aerospatiale": [
        "aerospatial",
        "aerospatiale"
    ],
    "aerostat": [
        "aerostat"
    ],
    "aerostier": [
        "aerostier"
    ],
    "aerostiers": [
        "aerostier"
    ],
    "aerotrains": [
        "aerotrain"
    ],
    "aererent": [
        "aerer"
    ],
    "aeree": [
        "aerer",
        "aere"
    ],
    "aerees": [
        "aere"
    ],
    "aeres": [
        "aerer",
        "aere"
    ],
    "ainesse": [
        "ainesse"
    ],
    "ainee": [
        "aine"
    ],
    "ainees": [
        "aine"
    ],
    "aitre": [
        "aitre"
    ],
    "aitres": [
        "aitre"
    ],
    "aid": [
        "aid"
    ],
    "aieul": [
        "aieul"
    ],
    "aieule": [
        "aieul"
    ],
    "aieules": [
        "aieul"
    ],
    "aieuls": [
        "aieul"
    ],
    "aieux": [
        "aieul"
    ],
    "aikido": [
        "aikido"
    ],
    "aioli": [
        "aioli"
    ],
    "b": [
        "b"
    ],
    "baba": [
        "baba"
    ],
    "baballe": [
        "baballe"
    ],
    "babas": [
        "baba"
    ],
    "babasse": [
        "babasse"
    ],
    "babel": [
        "babel"
    ],
    "babeurre": [
        "babeurre"
    ],
    "babi": [
        "babi"
    ],
    "babil": [
        "babil"
    ],
    "babillage": [
        "babillage"
    ],
    "babillages": [
        "babillage"
    ],
    "babillaient": [
        "babiller"
    ],
    "babillait": [
        "babiller"
    ],
    "babillant": [
        "babiller"
    ],
    "babillard": [
        "babillard"
    ],
    "babillarde": [
        "babillard"
    ],
    "babille": [
        "babiller"
    ],
    "babillent": [
        "babiller"
    ],
    "babiller": [
        "babiller"
    ],
    "babilles": [
        "babiller"
    ],
    "babils": [
        "babil"
    ],
    "babine": [
        "babine"
    ],
    "babines": [
        "babine"
    ],
    "babiole": [
        "babiole"
    ],
    "babioles": [
        "babiole"
    ],
    "babiroussa": [
        "babiroussa"
    ],
    "babouche": [
        "babouche"
    ],
    "babouches": [
        "babouche"
    ],
    "babouchka": [
        "babouchka"
    ],
    "babouchkas": [
        "babouchka"
    ],
    "babouin": [
        "babouin"
    ],
    "babouine": [
        "babouin"
    ],
    "babouines": [
        "babouin"
    ],
    "babouins": [
        "babouin"
    ],
    "babouvistes": [
        "babouviste"
    ],
    "baby": [
        "baby"
    ],
    "babylonien": [
        "babylonien"
    ],
    "babylonienne": [
        "babylonien"
    ],
    "babyloniens": [
        "babylonien"
    ],
    "babys": [
        "baby"
    ],
    "babelienne": [
        "babelien"
    ],
    "bac": [
        "bac"
    ],
    "baccalaureat": [
        "baccalaureat"
    ],
    "baccara": [
        "baccara"
    ],
    "baccarat": [
        "baccarat"
    ],
    "bacchanal": [
        "bacchanal"
    ],
    "bacchanale": [
        "bacchanale"
    ],
    "bacchanales": [
        "bacchanale"
    ],
    "bacchante": [
        "bacchante"
    ],
    "bacchantes": [
        "bacchante"
    ],
    "bachaghas": [
        "bachagha"
    ],
    "bachelier": [
        "bachelier"
    ],
    "bacheliers": [
        "bachelier"
    ],
    "bacheliere": [
        "bachelier"
    ],
    "bachique": [
        "bachique"
    ],
    "bachiques": [
        "bachique"
    ],
    "bachot": [
        "bachot"
    ],
    "bachotage": [
        "bachotage"
    ],
    "bachotaient": [
        "bachoter"
    ],
    "bachotait": [
        "bachoter"
    ],
    "bachotant": [
        "bachoter"
    ],
    "bachoter": [
        "bachoter"
    ],
    "bachots": [
        "bachot"
    ],
    "bacillaires": [
        "bacillaire"
    ],
    "bacille": [
        "bacille"
    ],
    "bacilles": [
        "bacille"
    ],
    "back": [
        "back"
    ],
    "backgammon": [
        "backgammon"
    ],
    "background": [
        "background"
    ],
    "bacon": [
        "bacon"
    ],
    "bacs": [
        "bac"
    ],
    "bactericide": [
        "bactericide"
    ],
    "bactericides": [
        "bactericide"
    ],
    "bacterie": [
        "bacterie"
    ],
    "bacterien": [
        "bacterien"
    ],
    "bacterienne": [
        "bacterien"
    ],
    "bacteriennes": [
        "bacterien"
    ],
    "bacteries": [
        "bacterie"
    ],
    "bacteriologie": [
        "bacteriologie"
    ],
    "bacteriologique": [
        "bacteriologique"
    ],
    "bacteriologiques": [
        "bacteriologique"
    ],
    "bacteriologiste": [
        "bacteriologiste"
    ],
    "bacteriophage": [
        "bacteriophage"
    ],
    "bacteriemie": [
        "bacteriemie"
    ],
    "bada": [
        "bader"
    ],
    "badabam": [
        "badabam"
    ],
    "badaboum": [
        "badaboum"
    ],
    "badamier": [
        "badamier"
    ],
    "badamiers": [
        "badamier"
    ],
    "badant": [
        "bader"
    ],
    "badaud": [
        "badaud"
    ],
    "badauda": [
        "badauder"
    ],
    "badaudaient": [
        "badauder"
    ],
    "badaudant": [
        "badauder"
    ],
    "badaude": [
        "badauder"
    ],
    "badauder": [
        "badauder"
    ],
    "badauderie": [
        "badauderie"
    ],
    "badauderies": [
        "badauderie"
    ],
    "badauds": [
        "badaud"
    ],
    "bader": [
        "bader"
    ],
    "baderne": [
        "baderne"
    ],
    "badernes": [
        "baderne"
    ],
    "bades": [
        "bader"
    ],
    "badge": [
        "badge"
    ],
    "badges": [
        "badge"
    ],
    "badigeon": [
        "badigeon"
    ],
    "badigeonna": [
        "badigeonner"
    ],
    "badigeonnage": [
        "badigeonnage"
    ],
    "badigeonnages": [
        "badigeonnage"
    ],
    "badigeonnaient": [
        "badigeonner"
    ],
    "badigeonnait": [
        "badigeonner"
    ],
    "badigeonnant": [
        "badigeonner"
    ],
    "badigeonne": [
        "badigeonner"
    ],
    "badigeonner": [
        "badigeonner"
    ],
    "badigeonnerai": [
        "badigeonner"
    ],
    "badigeonnerez": [
        "badigeonner"
    ],
    "badigeonneur": [
        "badigeonneur"
    ],
    "badigeonnions": [
        "badigeonner"
    ],
    "badigeonnerent": [
        "badigeonner"
    ],
    "badigeonnee": [
        "badigeonner"
    ],
    "badigeonnees": [
        "badigeonner"
    ],
    "badigeonnes": [
        "badigeonner"
    ],
    "badigeons": [
        "badigeon"
    ],
    "badigoinces": [
        "badigoinces"
    ],
    "badin": [
        "badin"
    ],
    "badina": [
        "badiner"
    ],
    "badinage": [
        "badinage"
    ],
    "badinages": [
        "badinage"
    ],
    "badinaient": [
        "badiner"
    ],
    "badinais": [
        "badiner"
    ],
    "badinait": [
        "badiner"
    ],
    "badine": [
        "badiner",
        "badin",
        "badine"
    ],
    "badiner": [
        "badiner"
    ],
    "badines": [
        "badiner",
        "badine"
    ],
    "badinez": [
        "badiner"
    ],
    "badins": [
        "badin"
    ],
    "badminton": [
        "badminton"
    ],
    "badois": [
        "badois"
    ],
    "badoise": [
        "badois"
    ],
    "baffe": [
        "baffe",
        "baffer"
    ],
    "baffer": [
        "baffer"
    ],
    "baffes": [
        "baffe",
        "baffer"
    ],
    "baffle": [
        "baffle"
    ],
    "baffles": [
        "baffle"
    ],
    "bafouais": [
        "bafouer"
    ],
    "bafouait": [
        "bafouer"
    ],
    "bafouant": [
        "bafouer"
    ],
    "bafoue": [
        "bafoue",
        "bafouer"
    ],
    "bafouent": [
        "bafouer"
    ],
    "bafouer": [
        "bafouer"
    ],
    "bafoues": [
        "bafoue",
        "bafouer"
    ],
    "bafouez": [
        "bafouer"
    ],
    "bafouilla": [
        "bafouiller"
    ],
    "bafouillage": [
        "bafouillage"
    ],
    "bafouillages": [
        "bafouillage"
    ],
    "bafouillai": [
        "bafouiller"
    ],
    "bafouillaient": [
        "bafouiller"
    ],
    "bafouillais": [
        "bafouiller"
    ],
    "bafouillait": [
        "bafouiller"
    ],
    "bafouillant": [
        "bafouiller",
        "bafouillant"
    ],
    "bafouillante": [
        "bafouillant"
    ],
    "bafouillantes": [
        "bafouillant"
    ],
    "bafouille": [
        "bafouiller",
        "bafouille"
    ],
    "bafouillent": [
        "bafouiller"
    ],
    "bafouiller": [
        "bafouiller"
    ],
    "bafouilles": [
        "bafouiller",
        "bafouille"
    ],
    "bafouilleur": [
        "bafouilleur"
    ],
    "bafouillez": [
        "bafouiller"
    ],
    "bafouillis": [
        "bafouillis"
    ],
    "bafouillerent": [
        "bafouiller"
    ],
    "bafouee": [
        "bafoue",
        "bafouer"
    ],
    "bafouees": [
        "bafoue",
        "bafouer"
    ],
    "bagage": [
        "bagage"
    ],
    "bagagerie": [
        "bagagerie"
    ],
    "bagages": [
        "bagage"
    ],
    "bagagiste": [
        "bagagiste"
    ],
    "bagagistes": [
        "bagagiste"
    ],
    "bagarraient": [
        "bagarrer"
    ],
    "bagarrais": [
        "bagarrer"
    ],
    "bagarrait": [
        "bagarrer"
    ],
    "bagarrant": [
        "bagarrer"
    ],
    "bagarre": [
        "bagarrer",
        "bagarre"
    ],
    "bagarrent": [
        "bagarrer"
    ],
    "bagarrer": [
        "bagarrer"
    ],
    "bagarrerais": [
        "bagarrer"
    ],
    "bagarrerait": [
        "bagarrer"
    ],
    "bagarres": [
        "bagarrer",
        "bagarre"
    ],
    "bagarreur": [
        "bagarreur"
    ],
    "bagarreurs": [
        "bagarreur"
    ],
    "bagarreuse": [
        "bagarreur"
    ],
    "bagarreuses": [
        "bagarreur"
    ],
    "bagarrez": [
        "bagarrer"
    ],
    "bagarrons": [
        "bagarrer"
    ],
    "bagarree": [
        "bagarrer"
    ],
    "bagasse": [
        "bagasse"
    ],
    "bagatelle": [
        "bagatelle"
    ],
    "bagatelles": [
        "bagatelle"
    ],
    "bagnard": [
        "bagnard"
    ],
    "bagnards": [
        "bagnard"
    ],
    "bagne": [
        "bagne"
    ],
    "bagnes": [
        "bagne"
    ],
    "bagnole": [
        "bagnole"
    ],
    "bagnoles": [
        "bagnole"
    ],
    "bagote": [
        "bagoter"
    ],
    "bagoter": [
        "bagoter"
    ],
    "bagottaient": [
        "bagotter"
    ],
    "bagottais": [
        "bagotter"
    ],
    "bagotte": [
        "bagotter"
    ],
    "bagotter": [
        "bagotter"
    ],
    "bagou": [
        "bagou"
    ],
    "bagoulait": [
        "bagouler"
    ],
    "bagoule": [
        "bagouler"
    ],
    "bagouse": [
        "bagouse"
    ],
    "bagousees": [
        "bagouse"
    ],
    "bagout": [
        "bagout"
    ],
    "bagouts": [
        "bagout"
    ],
    "bagouze": [
        "bagouze"
    ],
    "bagouzes": [
        "bagouze"
    ],
    "baguage": [
        "baguage"
    ],
    "bague": [
        "bague",
        "baguer"
    ],
    "baguenaudaient": [
        "baguenauder"
    ],
    "baguenaudais": [
        "baguenauder"
    ],
    "baguenaudait": [
        "baguenauder"
    ],
    "baguenaudant": [
        "baguenauder"
    ],
    "baguenaude": [
        "baguenauder",
        "baguenaude"
    ],
    "baguenaudent": [
        "baguenauder"
    ],
    "baguenauder": [
        "baguenauder"
    ],
    "baguenauderait": [
        "baguenauder"
    ],
    "baguer": [
        "baguer"
    ],
    "bagues": [
        "bague",
        "baguer"
    ],
    "baguette": [
        "baguette"
    ],
    "baguettes": [
        "baguette"
    ],
    "baguee": [
        "bague",
        "baguer"
    ],
    "baguees": [
        "bague",
        "baguer"
    ],
    "bah": [
        "bah"
    ],
    "baht": [
        "baht"
    ],
    "bahts": [
        "baht"
    ],
    "bahut": [
        "bahut"
    ],
    "bahute": [
        "bahuter"
    ],
    "bahutent": [
        "bahuter"
    ],
    "bahuts": [
        "bahut"
    ],
    "bai": [
        "bai"
    ],
    "baie": [
        "bayer",
        "baie"
    ],
    "baies": [
        "baie"
    ],
    "baigna": [
        "baigner"
    ],
    "baignade": [
        "baignade"
    ],
    "baignades": [
        "baignade"
    ],
    "baignai": [
        "baigner"
    ],
    "baignaient": [
        "baigner"
    ],
    "baignais": [
        "baigner"
    ],
    "baignait": [
        "baigner"
    ],
    "baignant": [
        "baigner"
    ],
    "baigne": [
        "baigner"
    ],
    "baignent": [
        "baigner"
    ],
    "baigner": [
        "baigner"
    ],
    "baignera": [
        "baigner"
    ],
    "baigneraient": [
        "baigner"
    ],
    "baignerait": [
        "baigner"
    ],
    "baignerons": [
        "baigner"
    ],
    "baigneront": [
        "baigner"
    ],
    "baignes": [
        "baigner"
    ],
    "baigneur": [
        "baigneur"
    ],
    "baigneurs": [
        "baigneur"
    ],
    "baigneuse": [
        "baigneur"
    ],
    "baigneuses": [
        "baigneur"
    ],
    "baignez": [
        "baigner"
    ],
    "baignions": [
        "baigner"
    ],
    "baignoire": [
        "baignoire"
    ],
    "baignoires": [
        "baignoire"
    ],
    "baignons": [
        "baigner"
    ],
    "baignerent": [
        "baigner"
    ],
    "baignee": [
        "baigner"
    ],
    "baignees": [
        "baigner"
    ],
    "bail": [
        "bail"
    ],
    "baile": [
        "baile"
    ],
    "bailes": [
        "baile"
    ],
    "baillait": [
        "bailler"
    ],
    "baillant": [
        "baillant",
        "bailler"
    ],
    "baille": [
        "baille",
        "bailler"
    ],
    "bailler": [
        "bailler"
    ],
    "bailles": [
        "baille",
        "bailler"
    ],
    "bailleur": [
        "bailleur"
    ],
    "bailleurs": [
        "bailleur"
    ],
    "baillez": [
        "bailler"
    ],
    "bailli": [
        "bailli"
    ],
    "bailliage": [
        "bailliage"
    ],
    "baillis": [
        "bailli"
    ],
    "baillive": [
        "baillive"
    ],
    "bain": [
        "bain"
    ],
    "bains": [
        "bain"
    ],
    "bais": [
        "bai"
    ],
    "baisa": [
        "baiser"
    ],
    "baisable": [
        "baisable"
    ],
    "baisables": [
        "baisable"
    ],
    "baisade": [
        "baisade"
    ],
    "baisai": [
        "baiser"
    ],
    "baisaient": [
        "baiser"
    ],
    "baisais": [
        "baiser"
    ],
    "baisait": [
        "baiser"
    ],
    "baisant": [
        "baiser"
    ],
    "baise": [
        "baiser",
        "baise"
    ],
    "baisemain": [
        "baisemain"
    ],
    "baisemains": [
        "baisemain"
    ],
    "baisement": [
        "baisement"
    ],
    "baisent": [
        "baiser"
    ],
    "baiser": [
        "baiser"
    ],
    "baisera": [
        "baiser"
    ],
    "baiserai": [
        "baiser"
    ],
    "baiseraient": [
        "baiser"
    ],
    "baiserais": [
        "baiser"
    ],
    "baiserait": [
        "baiser"
    ],
    "baiseras": [
        "baiser"
    ],
    "baiserez": [
        "baiser"
    ],
    "baiseriez": [
        "baiser"
    ],
    "baiserons": [
        "baiser"
    ],
    "baiseront": [
        "baiser"
    ],
    "baisers": [
        "baiser"
    ],
    "baises": [
        "baiser",
        "baise"
    ],
    "baiseur": [
        "baiseur"
    ],
    "baiseurs": [
        "baiseur"
    ],
    "baiseuse": [
        "baiseur"
    ],
    "baisez": [
        "baiser"
    ],
    "baisiez": [
        "baiser"
    ],
    "baisions": [
        "baiser"
    ],
    "baisodrome": [
        "baisodrome"
    ],
    "baisons": [
        "baiser"
    ],
    "baisotant": [
        "baisoter"
    ],
    "baisouiller": [
        "baisouiller"
    ],
    "baisouille": [
        "baisouiller"
    ],
    "baissa": [
        "baisser"
    ],
    "baissai": [
        "baisser"
    ],
    "baissaient": [
        "baisser"
    ],
    "baissais": [
        "baisser"
    ],
    "baissait": [
        "baisser"
    ],
    "baissant": [
        "baisser"
    ],
    "baisse": [
        "baisse",
        "baisser"
    ],
    "baissement": [
        "baissement"
    ],
    "baissent": [
        "baisser"
    ],
    "baisser": [
        "baisser"
    ],
    "baissera": [
        "baisser"
    ],
    "baisserai": [
        "baisser"
    ],
    "baisseraient": [
        "baisser"
    ],
    "baisserais": [
        "baisser"
    ],
    "baisserait": [
        "baisser"
    ],
    "baisseras": [
        "baisser"
    ],
    "baisserez": [
        "baisser"
    ],
    "baisserons": [
        "baisser"
    ],
    "baisseront": [
        "baisser"
    ],
    "baisses": [
        "baisse",
        "baisser"
    ],
    "baissez": [
        "baisser"
    ],
    "baissier": [
        "baissier"
    ],
    "baissiez": [
        "baisser"
    ],
    "baissions": [
        "baisser"
    ],
    "baissons": [
        "baisser"
    ],
    "baissames": [
        "baisser"
    ],
    "baissat": [
        "baisser"
    ],
    "baisserent": [
        "baisser"
    ],
    "baissee": [
        "baisser"
    ],
    "baissees": [
        "baisser"
    ],
    "baiserent": [
        "baiser"
    ],
    "baisee": [
        "baiser"
    ],
    "baisees": [
        "baiser"
    ],
    "bajoue": [
        "bajoue"
    ],
    "bajoues": [
        "bajoue"
    ],
    "bajoyers": [
        "bajoyer"
    ],
    "bakchich": [
        "bakchich"
    ],
    "bakchichs": [
        "bakchich"
    ],
    "baklava": [
        "baklava"
    ],
    "baklavas": [
        "baklava"
    ],
    "bakelite": [
        "bakelite"
    ],
    "bal": [
        "bal"
    ],
    "balada": [
        "balader"
    ],
    "baladai": [
        "balader"
    ],
    "baladaient": [
        "balader"
    ],
    "baladais": [
        "balader"
    ],
    "baladait": [
        "balader"
    ],
    "baladant": [
        "balader"
    ],
    "balade": [
        "balade",
        "balader"
    ],
    "baladent": [
        "balader"
    ],
    "balader": [
        "balader"
    ],
    "baladera": [
        "balader"
    ],
    "baladerai": [
        "balader"
    ],
    "baladerais": [
        "balader"
    ],
    "baladerait": [
        "balader"
    ],
    "baladerez": [
        "balader"
    ],
    "balades": [
        "balade",
        "balader"
    ],
    "baladeur": [
        "baladeur"
    ],
    "baladeurs": [
        "baladeur"
    ],
    "baladeuse": [
        "baladeur"
    ],
    "baladeuses": [
        "baladeur"
    ],
    "baladez": [
        "balader"
    ],
    "baladiez": [
        "balader"
    ],
    "baladin": [
        "baladin"
    ],
    "baladins": [
        "baladin"
    ],
    "baladerent": [
        "balader"
    ],
    "baladee": [
        "balader"
    ],
    "baladees": [
        "balader"
    ],
    "balafon": [
        "balafon"
    ],
    "balafons": [
        "balafon"
    ],
    "balafra": [
        "balafrer"
    ],
    "balafraient": [
        "balafrer"
    ],
    "balafrait": [
        "balafrer"
    ],
    "balafre": [
        "balafre",
        "balafrer"
    ],
    "balafrent": [
        "balafrer"
    ],
    "balafrer": [
        "balafrer"
    ],
    "balafres": [
        "balafre",
        "balafrer"
    ],
    "balafrons": [
        "balafrer"
    ],
    "balafrat": [
        "balafrer"
    ],
    "balafree": [
        "balafre",
        "balafrer"
    ],
    "balafrees": [
        "balafrer"
    ],
    "balai": [
        "balai"
    ],
    "balaie": [
        "balayer"
    ],
    "balaient": [
        "balayer"
    ],
    "balaiera": [
        "balayer"
    ],
    "balaierai": [
        "balayer"
    ],
    "balaieraient": [
        "balayer"
    ],
    "balaierait": [
        "balayer"
    ],
    "balaieras": [
        "balayer"
    ],
    "balaierez": [
        "balayer"
    ],
    "balaies": [
        "balayer"
    ],
    "balais": [
        "balais",
        "balai"
    ],
    "balaise": [
        "balaise"
    ],
    "balaises": [
        "balaise"
    ],
    "balalaika": [
        "balalaika"
    ],
    "balalaikas": [
        "balalaika"
    ],
    "balan": [
        "balan"
    ],
    "balance": [
        "balance",
        "balancer"
    ],
    "balancelle": [
        "balancelle"
    ],
    "balancelles": [
        "balancelle"
    ],
    "balancement": [
        "balancement"
    ],
    "balancements": [
        "balancement"
    ],
    "balancent": [
        "balancer"
    ],
    "balancer": [
        "balancer"
    ],
    "balancera": [
        "balancer"
    ],
    "balancerai": [
        "balancer"
    ],
    "balanceraient": [
        "balancer"
    ],
    "balancerais": [
        "balancer"
    ],
    "balancerait": [
        "balancer"
    ],
    "balanceras": [
        "balancer"
    ],
    "balancerez": [
        "balancer"
    ],
    "balanceriez": [
        "balancer"
    ],
    "balanceront": [
        "balancer"
    ],
    "balances": [
        "balance",
        "balancer"
    ],
    "balancez": [
        "balancer"
    ],
    "balancier": [
        "balancier"
    ],
    "balanciers": [
        "balancier"
    ],
    "balanciez": [
        "balancer"
    ],
    "balancines": [
        "balancine"
    ],
    "balancions": [
        "balancer"
    ],
    "balancerent": [
        "balancer"
    ],
    "balancee": [
        "balance",
        "balancer"
    ],
    "balancees": [
        "balance",
        "balancer"
    ],
    "balandras": [
        "balandras"
    ],
    "balanes": [
        "balane"
    ],
    "balanstiquant": [
        "balanstiquer"
    ],
    "balanstique": [
        "balanstiquer"
    ],
    "balanstiquer": [
        "balanstiquer"
    ],
    "balanca": [
        "balancer"
    ],
    "balancage": [
        "balancage"
    ],
    "balancages": [
        "balancage"
    ],
    "balancai": [
        "balancer"
    ],
    "balancaient": [
        "balancer"
    ],
    "balancais": [
        "balancer"
    ],
    "balancait": [
        "balancer"
    ],
    "balancant": [
        "balancer"
    ],
    "balancoire": [
        "balancoire"
    ],
    "balancoires": [
        "balancoire"
    ],
    "balancons": [
        "balancer"
    ],
    "balatum": [
        "balatum"
    ],
    "balaya": [
        "balayer"
    ],
    "balayage": [
        "balayage"
    ],
    "balayages": [
        "balayage"
    ],
    "balayai": [
        "balayer"
    ],
    "balayaient": [
        "balayer"
    ],
    "balayais": [
        "balayer"
    ],
    "balayait": [
        "balayer"
    ],
    "balayant": [
        "balayant",
        "balayer"
    ],
    "balaye": [
        "balayer"
    ],
    "balayent": [
        "balayer"
    ],
    "balayer": [
        "balayer"
    ],
    "balayera": [
        "balayer"
    ],
    "balayerai": [
        "balayer"
    ],
    "balayeraient": [
        "balayer"
    ],
    "balayerait": [
        "balayer"
    ],
    "balayerez": [
        "balayer"
    ],
    "balayerons": [
        "balayer"
    ],
    "balayeront": [
        "balayer"
    ],
    "balayette": [
        "balayette"
    ],
    "balayettes": [
        "balayette"
    ],
    "balayeur": [
        "balayeur"
    ],
    "balayeurs": [
        "balayeur"
    ],
    "balayeuse": [
        "balayeur"
    ],
    "balayeuses": [
        "balayeur"
    ],
    "balayez": [
        "balayer"
    ],
    "balayons": [
        "balayer"
    ],
    "balayure": [
        "balayure"
    ],
    "balayures": [
        "balayure"
    ],
    "balayat": [
        "balayer"
    ],
    "balayerent": [
        "balayer"
    ],
    "balayee": [
        "balayer"
    ],
    "balayees": [
        "balayer"
    ],
    "balayes": [
        "balayer"
    ],
    "balboa": [
        "balboa"
    ],
    "balbutia": [
        "balbutier"
    ],
    "balbutiai": [
        "balbutier"
    ],
    "balbutiaient": [
        "balbutier"
    ],
    "balbutiais": [
        "balbutier"
    ],
    "balbutiait": [
        "balbutier"
    ],
    "balbutiant": [
        "balbutier",
        "balbutiant"
    ],
    "balbutiante": [
        "balbutiant"
    ],
    "balbutiantes": [
        "balbutiant"
    ],
    "balbutie": [
        "balbutier"
    ],
    "balbutiement": [
        "balbutiement"
    ],
    "balbutiements": [
        "balbutiement"
    ],
    "balbutier": [
        "balbutier"
    ],
    "balbutions": [
        "balbutier"
    ],
    "balbutierent": [
        "balbutier"
    ],
    "balbutiees": [
        "balbutier"
    ],
    "balbuties": [
        "balbutier"
    ],
    "balbuzard": [
        "balbuzard"
    ],
    "balcon": [
        "balcon"
    ],
    "balconnet": [
        "balconnet"
    ],
    "balconnets": [
        "balconnet"
    ],
    "balcons": [
        "balcon"
    ],
    "baldaquin": [
        "baldaquin"
    ],
    "baldaquins": [
        "baldaquin"
    ],
    "bale": [
        "bale"
    ],
    "baleine": [
        "baleine"
    ],
    "baleineau": [
        "baleineau"
    ],
    "baleines": [
        "baleine"
    ],
    "baleinier": [
        "baleinier"
    ],
    "baleiniers": [
        "baleinier"
    ],
    "baleiniere": [
        "baleinier"
    ],
    "baleinieres": [
        "baleinier"
    ],
    "baleinee": [
        "baleine"
    ],
    "baleinees": [
        "baleine"
    ],
    "bales": [
        "bale"
    ],
    "balinais": [
        "balinais"
    ],
    "balinaise": [
        "balinais"
    ],
    "balisage": [
        "balisage"
    ],
    "balisaient": [
        "baliser"
    ],
    "balisait": [
        "baliser"
    ],
    "balisant": [
        "baliser"
    ],
    "balise": [
        "balise",
        "baliser"
    ],
    "balisent": [
        "baliser"
    ],
    "baliser": [
        "baliser"
    ],
    "baliseraient": [
        "baliser"
    ],
    "balises": [
        "balise",
        "baliser"
    ],
    "baliste": [
        "baliste"
    ],
    "balistes": [
        "baliste"
    ],
    "balistique": [
        "balistique"
    ],
    "balistiquement": [
        "balistiquement"
    ],
    "balistiques": [
        "balistique"
    ],
    "balisee": [
        "baliser"
    ],
    "balisees": [
        "baliser"
    ],
    "baliveau": [
        "baliveau"
    ],
    "baliveaux": [
        "baliveau"
    ],
    "baliverne": [
        "baliverne"
    ],
    "balivernes": [
        "baliverne"
    ],
    "balkanique": [
        "balkanique"
    ],
    "balkaniques": [
        "balkanique"
    ],
    "balkanises": [
        "balkaniser"
    ],
    "ballade": [
        "ballade"
    ],
    "ballades": [
        "ballade"
    ],
    "ballaient": [
        "baller"
    ],
    "ballant": [
        "ballant",
        "baller"
    ],
    "ballante": [
        "ballant"
    ],
    "ballantes": [
        "ballant"
    ],
    "ballants": [
        "ballant"
    ],
    "ballast": [
        "ballast"
    ],
    "ballasts": [
        "ballast"
    ],
    "balle": [
        "balle"
    ],
    "baller": [
        "baller"
    ],
    "ballerine": [
        "ballerine"
    ],
    "ballerines": [
        "ballerine"
    ],
    "balles": [
        "balle"
    ],
    "ballet": [
        "ballet"
    ],
    "ballets": [
        "ballet"
    ],
    "balloches": [
        "balloche"
    ],
    "ballon": [
        "ballon"
    ],
    "ballonnaient": [
        "ballonner"
    ],
    "ballonnant": [
        "ballonnant"
    ],
    "ballonnante": [
        "ballonnant"
    ],
    "ballonnants": [
        "ballonnant"
    ],
    "ballonne": [
        "ballonner",
        "ballonne"
    ],
    "ballonnement": [
        "ballonnement"
    ],
    "ballonnements": [
        "ballonnement"
    ],
    "ballonnent": [
        "ballonner"
    ],
    "ballonner": [
        "ballonner"
    ],
    "ballonnets": [
        "ballonnet"
    ],
    "ballonnee": [
        "ballonner",
        "ballonne"
    ],
    "ballonnees": [
        "ballonner",
        "ballonne"
    ],
    "ballonnes": [
        "ballonner",
        "ballonne"
    ],
    "ballons": [
        "baller",
        "ballon"
    ],
    "ballot": [
        "ballot"
    ],
    "ballote": [
        "ballote"
    ],
    "ballots": [
        "ballot"
    ],
    "ballottage": [
        "ballottage"
    ],
    "ballottages": [
        "ballottage"
    ],
    "ballottaient": [
        "ballotter"
    ],
    "ballottait": [
        "ballotter"
    ],
    "ballottant": [
        "ballotter"
    ],
    "ballotte": [
        "ballotter",
        "ballotte"
    ],
    "ballottement": [
        "ballottement"
    ],
    "ballottent": [
        "ballotter"
    ],
    "ballotter": [
        "ballotter"
    ],
    "ballottine": [
        "ballottine"
    ],
    "ballottines": [
        "ballottine"
    ],
    "ballotterent": [
        "ballotter"
    ],
    "ballottee": [
        "ballotter",
        "ballotte"
    ],
    "ballottees": [
        "ballotter"
    ],
    "ballottes": [
        "ballotter"
    ],
    "balluche": [
        "balluche"
    ],
    "balluches": [
        "balluche"
    ],
    "balluchon": [
        "balluchon"
    ],
    "balluchonnage": [
        "balluchonnage"
    ],
    "balluchonne": [
        "balluchonner"
    ],
    "balluchons": [
        "balluchon"
    ],
    "balneaire": [
        "balneaire"
    ],
    "balneaires": [
        "balneaire"
    ],
    "balneotherapie": [
        "balneotherapie"
    ],
    "balourd": [
        "balourd"
    ],
    "balourde": [
        "balourd"
    ],
    "balourdise": [
        "balourdise"
    ],
    "balourdises": [
        "balourdise"
    ],
    "balourds": [
        "balourd"
    ],
    "balpeau": [
        "balpeau"
    ],
    "bals": [
        "bal"
    ],
    "balsa": [
        "balsa"
    ],
    "balsamier": [
        "balsamier"
    ],
    "balsamiers": [
        "balsamier"
    ],
    "balsamine": [
        "balsamine"
    ],
    "balsamines": [
        "balsamine"
    ],
    "balsamique": [
        "balsamique"
    ],
    "balsamiques": [
        "balsamique"
    ],
    "balte": [
        "balte"
    ],
    "baltes": [
        "balte"
    ],
    "balthazar": [
        "balthazar"
    ],
    "balthazars": [
        "balthazar"
    ],
    "baltique": [
        "baltique"
    ],
    "baltiques": [
        "baltique"
    ],
    "balto": [
        "balto"
    ],
    "baluba": [
        "baluba"
    ],
    "baluchon": [
        "baluchon"
    ],
    "baluchonnage": [
        "baluchonnage"
    ],
    "baluchonne": [
        "baluchonner"
    ],
    "baluchonnent": [
        "baluchonner"
    ],
    "baluchonner": [
        "baluchonner"
    ],
    "baluchonneur": [
        "baluchonneur"
    ],
    "baluchonneurs": [
        "baluchonneur"
    ],
    "baluchons": [
        "baluchon"
    ],
    "balustrade": [
        "balustrade"
    ],
    "balustrades": [
        "balustrade"
    ],
    "balustre": [
        "balustre"
    ],
    "balustres": [
        "balustre"
    ],
    "balzacien": [
        "balzacien"
    ],
    "balzacienne": [
        "balzacien"
    ],
    "balzaciennes": [
        "balzacien"
    ],
    "balzaciens": [
        "balzacien"
    ],
    "balzanes": [
        "balzane"
    ],
    "baleze": [
        "baleze"
    ],
    "balezes": [
        "baleze"
    ],
    "bambara": [
        "bambara"
    ],
    "bambin": [
        "bambin"
    ],
    "bambine": [
        "bambin"
    ],
    "bambines": [
        "bambin"
    ],
    "bambinette": [
        "bambinette"
    ],
    "bambino": [
        "bambino"
    ],
    "bambinos": [
        "bambino"
    ],
    "bambins": [
        "bambin"
    ],
    "bambochait": [
        "bambocher"
    ],
    "bamboche": [
        "bamboche",
        "bambocher"
    ],
    "bambocher": [
        "bambocher"
    ],
    "bambocheurs": [
        "bambocheur"
    ],
    "bambou": [
        "bambou"
    ],
    "bamboula": [
        "bamboula"
    ],
    "bambous": [
        "bambou"
    ],
    "ban": [
        "ban"
    ],
    "banal": [
        "banal"
    ],
    "banale": [
        "banal"
    ],
    "banalement": [
        "banalement"
    ],
    "banales": [
        "banal"
    ],
    "banalisait": [
        "banaliser"
    ],
    "banalisation": [
        "banalisation"
    ],
    "banalise": [
        "banaliser"
    ],
    "banalisent": [
        "banaliser"
    ],
    "banaliser": [
        "banaliser"
    ],
    "banalisee": [
        "banaliser"
    ],
    "banalisees": [
        "banaliser"
    ],
    "banalises": [
        "banaliser"
    ],
    "banalite": [
        "banalite"
    ],
    "banalites": [
        "banalite"
    ],
    "banals": [
        "banal"
    ],
    "banana": [
        "bananer"
    ],
    "bananas": [
        "bananer",
        "banana"
    ],
    "banane": [
        "banane"
    ],
    "bananer": [
        "bananer"
    ],
    "bananeraie": [
        "bananeraie"
    ],
    "bananes": [
        "banane"
    ],
    "bananier": [
        "bananier"
    ],
    "bananiers": [
        "bananier"
    ],
    "bananiere": [
        "bananier"
    ],
    "banaux": [
        "banal"
    ],
    "banc": [
        "banc"
    ],
    "bancaire": [
        "bancaire"
    ],
    "bancaires": [
        "bancaire"
    ],
    "bancal": [
        "bancal"
    ],
    "bancale": [
        "bancal"
    ],
    "bancales": [
        "bancal"
    ],
    "bancals": [
        "bancal"
    ],
    "banche": [
        "bancher"
    ],
    "banco": [
        "banco"
    ],
    "bancos": [
        "banco"
    ],
    "bancroche": [
        "bancroche"
    ],
    "bancroches": [
        "bancroche"
    ],
    "bancs": [
        "banc"
    ],
    "banda": [
        "bander"
    ],
    "bandage": [
        "bandage"
    ],
    "bandages": [
        "bandage"
    ],
    "bandagiste": [
        "bandagiste"
    ],
    "bandai": [
        "bander"
    ],
    "bandaient": [
        "bander"
    ],
    "bandais": [
        "bander"
    ],
    "bandaison": [
        "bandaison"
    ],
    "bandaisons": [
        "bandaison"
    ],
    "bandait": [
        "bander"
    ],
    "bandana": [
        "bandana"
    ],
    "bandanas": [
        "bandana"
    ],
    "bandant": [
        "bandant",
        "bander"
    ],
    "bandante": [
        "bandant"
    ],
    "bandantes": [
        "bandant"
    ],
    "bandants": [
        "bandant"
    ],
    "bandasse": [
        "bander"
    ],
    "bande": [
        "bande",
        "bander"
    ],
    "bandeau": [
        "bandeau"
    ],
    "bandeaux": [
        "bandeau"
    ],
    "bandelette": [
        "bandelette"
    ],
    "bandelettes": [
        "bandelette"
    ],
    "bandent": [
        "bander"
    ],
    "bander": [
        "bander"
    ],
    "bandera": [
        "bander",
        "bandera"
    ],
    "banderai": [
        "bander"
    ],
    "banderaient": [
        "bander"
    ],
    "banderait": [
        "bander"
    ],
    "banderas": [
        "bander",
        "bandera"
    ],
    "banderille": [
        "banderille"
    ],
    "banderillero": [
        "banderillero"
    ],
    "banderilleros": [
        "banderillero"
    ],
    "banderilles": [
        "banderille"
    ],
    "banderole": [
        "banderole"
    ],
    "banderoles": [
        "banderole"
    ],
    "bandes": [
        "bande",
        "bander"
    ],
    "bandeur": [
        "bandeur"
    ],
    "bandeurs": [
        "bandeur"
    ],
    "bandez": [
        "bander"
    ],
    "bandiez": [
        "bander"
    ],
    "bandit": [
        "bandit"
    ],
    "banditisme": [
        "banditisme"
    ],
    "bandits": [
        "bandit"
    ],
    "bandoline": [
        "bandoline"
    ],
    "bandoneon": [
        "bandoneon"
    ],
    "bandotheque": [
        "bandotheque"
    ],
    "bandouliere": [
        "bandouliere"
    ],
    "bandee": [
        "bander",
        "bande"
    ],
    "bandees": [
        "bander",
        "bande"
    ],
    "bang": [
        "bang"
    ],
    "bangladais": [
        "bangladais"
    ],
    "bangs": [
        "bang"
    ],
    "banian": [
        "banian"
    ],
    "banians": [
        "banian"
    ],
    "banjo": [
        "banjo"
    ],
    "banjos": [
        "banjo"
    ],
    "banlieue": [
        "banlieue"
    ],
    "banlieues": [
        "banlieue"
    ],
    "banlieusard": [
        "banlieusard"
    ],
    "banlieusarde": [
        "banlieusard"
    ],
    "banlieusardes": [
        "banlieusard"
    ],
    "banlieusards": [
        "banlieusard"
    ],
    "banne": [
        "banner"
    ],
    "banner": [
        "banner"
    ],
    "bannes": [
        "banne"
    ],
    "banni": [
        "banni",
        "bannir"
    ],
    "bannie": [
        "banni",
        "bannir"
    ],
    "bannies": [
        "banni",
        "bannir"
    ],
    "bannir": [
        "bannir"
    ],
    "bannirait": [
        "bannir"
    ],
    "bannirent": [
        "bannir"
    ],
    "bannis": [
        "banni",
        "bannir"
    ],
    "bannissaient": [
        "bannir"
    ],
    "bannissait": [
        "bannir"
    ],
    "bannissant": [
        "bannir"
    ],
    "bannisse": [
        "bannir"
    ],
    "bannissement": [
        "bannissement"
    ],
    "bannissements": [
        "bannissement"
    ],
    "bannissez": [
        "bannir"
    ],
    "bannissons": [
        "bannir"
    ],
    "bannit": [
        "bannir"
    ],
    "banniere": [
        "banniere"
    ],
    "bannieres": [
        "banniere"
    ],
    "banqua": [
        "banquer"
    ],
    "banque": [
        "banquer",
        "banque"
    ],
    "banquer": [
        "banquer"
    ],
    "banquerai": [
        "banquer"
    ],
    "banqueroute": [
        "banqueroute"
    ],
    "banqueroutes": [
        "banqueroute"
    ],
    "banqueroutier": [
        "banqueroutier"
    ],
    "banqueroutiers": [
        "banqueroutier"
    ],
    "banques": [
        "banque"
    ],
    "banquet": [
        "banquet"
    ],
    "banquets": [
        "banquet"
    ],
    "banquette": [
        "banquette"
    ],
    "banquettes": [
        "banquette"
    ],
    "banquete": [
        "banqueter"
    ],
    "banquier": [
        "banquier"
    ],
    "banquiers": [
        "banquier"
    ],
    "banquise": [
        "banquise"
    ],
    "banquises": [
        "banquise"
    ],
    "banquistes": [
        "banquiste"
    ],
    "banquiere": [
        "banquier"
    ],
    "banquieres": [
        "banquier"
    ],
    "bans": [
        "ban"
    ],
    "bantou": [
        "bantou"
    ],
    "bantoue": [
        "bantou"
    ],
    "bantu": [
        "bantu"
    ],
    "banyan": [
        "banyan"
    ],
    "banyuls": [
        "banyuls"
    ],
    "baobab": [
        "baobab"
    ],
    "baobabs": [
        "baobab"
    ],
    "baou": [
        "baou"
    ],
    "baptisa": [
        "baptiser"
    ],
    "baptisai": [
        "baptiser"
    ],
    "baptisaient": [
        "baptiser"
    ],
    "baptisais": [
        "baptiser"
    ],
    "baptisait": [
        "baptiser"
    ],
    "baptisant": [
        "baptiser"
    ],
    "baptise": [
        "baptiser"
    ],
    "baptisent": [
        "baptiser"
    ],
    "baptiser": [
        "baptiser"
    ],
    "baptisera": [
        "baptiser"
    ],
    "baptiserai": [
        "baptiser"
    ],
    "baptiseraient": [
        "baptiser"
    ],
    "baptiserait": [
        "baptiser"
    ],
    "baptiseront": [
        "baptiser"
    ],
    "baptises": [
        "baptise",
        "baptiser"
    ],
    "baptiseur": [
        "baptiseur"
    ],
    "baptisez": [
        "baptiser"
    ],
    "baptisions": [
        "baptiser"
    ],
    "baptismal": [
        "baptismal"
    ],
    "baptismale": [
        "baptismal"
    ],
    "baptismales": [
        "baptismal"
    ],
    "baptismaux": [
        "baptismal"
    ],
    "baptisons": [
        "baptiser"
    ],
    "baptiste": [
        "baptiste"
    ],
    "baptistes": [
        "baptiste"
    ],
    "baptistere": [
        "baptistere"
    ],
    "baptiserent": [
        "baptiser"
    ],
    "baptisee": [
        "baptiser"
    ],
    "baptisees": [
        "baptiser"
    ],
    "bapteme": [
        "bapteme"
    ],
    "baptemes": [
        "bapteme"
    ],
    "baquet": [
        "baquet"
    ],
    "baquets": [
        "baquet"
    ],
    "bar": [
        "bar"
    ],
    "baragouin": [
        "baragouin"
    ],
    "baragouinage": [
        "baragouinage"
    ],
    "baragouinaient": [
        "baragouiner"
    ],
    "baragouinait": [
        "baragouiner"
    ],
    "baragouinant": [
        "baragouiner"
    ],
    "baragouine": [
        "baragouiner"
    ],
    "baragouinent": [
        "baragouiner"
    ],
    "baragouiner": [
        "baragouiner"
    ],
    "baragouines": [
        "baragouiner"
    ],
    "baragouineur": [
        "baragouineur"
    ],
    "baragouinez": [
        "baragouiner"
    ],
    "baragouins": [
        "baragouin"
    ],
    "baraka": [
        "baraka"
    ],
    "baralipton": [
        "baralipton"
    ],
    "baraque": [
        "baraque",
        "baraquer"
    ],
    "baraquement": [
        "baraquement"
    ],
    "baraquements": [
        "baraquement"
    ],
    "baraques": [
        "baraque",
        "baraquer"
    ],
    "baraquee": [
        "baraque",
        "baraquer"
    ],
    "baraterie": [
        "baraterie"
    ],
    "baratin": [
        "baratin"
    ],
    "baratinais": [
        "baratiner"
    ],
    "baratinait": [
        "baratiner"
    ],
    "baratine": [
        "baratiner"
    ],
    "baratinent": [
        "baratiner"
    ],
    "baratiner": [
        "baratiner"
    ],
    "baratines": [
        "baratiner"
    ],
    "baratineur": [
        "baratineur"
    ],
    "baratineurs": [
        "baratineur"
    ],
    "baratineuse": [
        "baratineur"
    ],
    "baratinez": [
        "baratiner"
    ],
    "baratins": [
        "baratin"
    ],
    "baratinee": [
        "baratiner"
    ],
    "barattage": [
        "barattage"
    ],
    "barattait": [
        "baratter"
    ],
    "barattant": [
        "baratter"
    ],
    "baratte": [
        "baratte",
        "baratter"
    ],
    "barattent": [
        "baratter"
    ],
    "baratter": [
        "baratter"
    ],
    "barattes": [
        "baratte",
        "baratter"
    ],
    "barba": [
        "barber"
    ],
    "barbacane": [
        "barbacane"
    ],
    "barbacanes": [
        "barbacane"
    ],
    "barbaient": [
        "barber"
    ],
    "barbait": [
        "barber"
    ],
    "barbant": [
        "barbant",
        "barber"
    ],
    "barbante": [
        "barbant"
    ],
    "barbantes": [
        "barbant"
    ],
    "barbants": [
        "barbant"
    ],
    "barbaque": [
        "barbaque"
    ],
    "barbara": [
        "barbara"
    ],
    "barbare": [
        "barbare"
    ],
    "barbarement": [
        "barbarement"
    ],
    "barbares": [
        "barbare"
    ],
    "barbaresque": [
        "barbaresque"
    ],
    "barbaresques": [
        "barbaresque"
    ],
    "barbarie": [
        "barbarie"
    ],
    "barbaries": [
        "barbarie"
    ],
    "barbarisme": [
        "barbarisme"
    ],
    "barbarismes": [
        "barbarisme"
    ],
    "barbe": [
        "barbe",
        "barber"
    ],
    "barbeau": [
        "barbeau"
    ],
    "barbeaux": [
        "barbeau"
    ],
    "barbecue": [
        "barbecue"
    ],
    "barbecues": [
        "barbecue"
    ],
    "barbele": [
        "barbele"
    ],
    "barbelee": [
        "barbele"
    ],
    "barbelees": [
        "barbele"
    ],
    "barbeles": [
        "barbele"
    ],
    "barbent": [
        "barber"
    ],
    "barber": [
        "barber"
    ],
    "barbera": [
        "barber"
    ],
    "barberait": [
        "barber"
    ],
    "barbes": [
        "barbe",
        "barber"
    ],
    "barbet": [
        "barbet"
    ],
    "barbets": [
        "barbet"
    ],
    "barbette": [
        "barbette"
    ],
    "barbiche": [
        "barbiche"
    ],
    "barbiches": [
        "barbiche"
    ],
    "barbichette": [
        "barbichette"
    ],
    "barbichu": [
        "barbichu"
    ],
    "barbichus": [
        "barbichu"
    ],
    "barbier": [
        "barbier"
    ],
    "barbiers": [
        "barbier"
    ],
    "barbillon": [
        "barbillon"
    ],
    "barbillons": [
        "barbillon"
    ],
    "barbiquet": [
        "barbiquet"
    ],
    "barbiquets": [
        "barbiquet"
    ],
    "barbiturique": [
        "barbiturique"
    ],
    "barbituriques": [
        "barbiturique"
    ],
    "barbon": [
        "barbon"
    ],
    "barbons": [
        "barbon"
    ],
    "barbot": [
        "barbot"
    ],
    "barbota": [
        "barboter"
    ],
    "barbotages": [
        "barbotage"
    ],
    "barbotaient": [
        "barboter"
    ],
    "barbotait": [
        "barboter"
    ],
    "barbotant": [
        "barboter"
    ],
    "barbote": [
        "barbote",
        "barboter"
    ],
    "barbotent": [
        "barboter"
    ],
    "barboter": [
        "barboter"
    ],
    "barboterais": [
        "barboter"
    ],
    "barboterait": [
        "barboter"
    ],
    "barboteuse": [
        "barboteur"
    ],
    "barboteuses": [
        "barboteur"
    ],
    "barbotiere": [
        "barbotiere"
    ],
    "barbotons": [
        "barboter"
    ],
    "barbotte": [
        "barbotte"
    ],
    "barbottes": [
        "barbotte"
    ],
    "barbouilla": [
        "barbouiller"
    ],
    "barbouillage": [
        "barbouillage"
    ],
    "barbouillages": [
        "barbouillage"
    ],
    "barbouillai": [
        "barbouiller"
    ],
    "barbouillaient": [
        "barbouiller"
    ],
    "barbouillais": [
        "barbouiller"
    ],
    "barbouillait": [
        "barbouiller"
    ],
    "barbouillant": [
        "barbouiller"
    ],
    "barbouille": [
        "barbouiller",
        "barbouille"
    ],
    "barbouillent": [
        "barbouiller"
    ],
    "barbouiller": [
        "barbouiller"
    ],
    "barbouilles": [
        "barbouiller",
        "barbouille"
    ],
    "barbouilleur": [
        "barbouilleur"
    ],
    "barbouilleurs": [
        "barbouilleur"
    ],
    "barbouillis": [
        "barbouillis"
    ],
    "barbouillerent": [
        "barbouiller"
    ],
    "barbouillee": [
        "barbouiller",
        "barbouille"
    ],
    "barbouillees": [
        "barbouiller",
        "barbouille"
    ],
    "barbouze": [
        "barbouze"
    ],
    "barbouzes": [
        "barbouze"
    ],
    "barbu": [
        "barbu"
    ],
    "barbue": [
        "barbue",
        "barbu"
    ],
    "barbues": [
        "barbue",
        "barbu"
    ],
    "barbules": [
        "barbule"
    ],
    "barbus": [
        "barbu"
    ],
    "barca": [
        "barca"
    ],
    "barcarolle": [
        "barcarolle"
    ],
    "barcasse": [
        "barcasse"
    ],
    "barcasses": [
        "barcasse"
    ],
    "barda": [
        "barda"
    ],
    "bardage": [
        "bardage"
    ],
    "bardaient": [
        "barder"
    ],
    "bardait": [
        "barder"
    ],
    "bardane": [
        "bardane"
    ],
    "bardanes": [
        "bardane"
    ],
    "bardas": [
        "barda"
    ],
    "barde": [
        "barder",
        "barde"
    ],
    "bardeau": [
        "bardeau"
    ],
    "bardeaux": [
        "bardeau"
    ],
    "barder": [
        "barder"
    ],
    "bardera": [
        "barder"
    ],
    "barderait": [
        "barder"
    ],
    "bardes": [
        "barder",
        "barde"
    ],
    "bardeurs": [
        "bardeur"
    ],
    "bardiques": [
        "bardique"
    ],
    "bardo": [
        "bardo"
    ],
    "bardolino": [
        "bardolino"
    ],
    "bardot": [
        "bardot"
    ],
    "bardots": [
        "bardot"
    ],
    "bardee": [
        "barder"
    ],
    "bardees": [
        "barder"
    ],
    "baret": [
        "baret"
    ],
    "barge": [
        "barge"
    ],
    "barges": [
        "barge"
    ],
    "barguigna": [
        "barguigner"
    ],
    "barguigner": [
        "barguigner"
    ],
    "barguigne": [
        "barguigner"
    ],
    "baril": [
        "baril"
    ],
    "barillet": [
        "barillet"
    ],
    "barillets": [
        "barillet"
    ],
    "barils": [
        "baril"
    ],
    "barine": [
        "barine"
    ],
    "bariolage": [
        "bariolage"
    ],
    "bariolages": [
        "bariolage"
    ],
    "bariolaient": [
        "barioler"
    ],
    "bariolant": [
        "barioler"
    ],
    "bariole": [
        "barioler",
        "bariole"
    ],
    "bariolures": [
        "bariolure"
    ],
    "bariolee": [
        "barioler",
        "bariole"
    ],
    "bariolees": [
        "barioler",
        "bariole"
    ],
    "barioles": [
        "barioler",
        "bariole"
    ],
    "barje": [
        "barje"
    ],
    "barjes": [
        "barje"
    ],
    "barjo": [
        "barjo"
    ],
    "barjos": [
        "barjo"
    ],
    "barjot": [
        "barjot"
    ],
    "barjots": [
        "barjot"
    ],
    "barmaid": [
        "barmaid"
    ],
    "barmaids": [
        "barmaid"
    ],
    "barman": [
        "barman"
    ],
    "barmans": [
        "barman"
    ],
    "barmen": [
        "barman"
    ],
    "barnum": [
        "barnum"
    ],
    "barolo": [
        "barolo"
    ],
    "barometre": [
        "barometre"
    ],
    "barometres": [
        "barometre"
    ],
    "barometrique": [
        "barometrique"
    ],
    "baron": [
        "baron"
    ],
    "baronet": [
        "baronet"
    ],
    "baronnait": [
        "baronner"
    ],
    "baronne": [
        "baron"
    ],
    "baronner": [
        "baronner"
    ],
    "baronnes": [
        "baron"
    ],
    "baronnet": [
        "baronnet"
    ],
    "baronnets": [
        "baronnet"
    ],
    "baronnez": [
        "baronner"
    ],
    "baronnie": [
        "baronnie"
    ],
    "baronnies": [
        "baronnie"
    ],
    "barons": [
        "baron"
    ],
    "baroque": [
        "baroque"
    ],
    "baroques": [
        "baroque"
    ],
    "barotraumatisme": [
        "barotraumatisme"
    ],
    "baroud": [
        "baroud"
    ],
    "baroudeur": [
        "baroudeur"
    ],
    "baroudeurs": [
        "baroudeur"
    ],
    "baroudeuse": [
        "baroudeur"
    ],
    "baroude": [
        "barouder"
    ],
    "barouf": [
        "barouf"
    ],
    "barque": [
        "barque"
    ],
    "barques": [
        "barque"
    ],
    "barquette": [
        "barquette"
    ],
    "barquettes": [
        "barquette"
    ],
    "barra": [
        "barrer"
    ],
    "barracuda": [
        "barracuda"
    ],
    "barracudas": [
        "barracuda"
    ],
    "barrage": [
        "barrage"
    ],
    "barrages": [
        "barrage"
    ],
    "barrai": [
        "barrer"
    ],
    "barraient": [
        "barrer"
    ],
    "barrais": [
        "barrer"
    ],
    "barrait": [
        "barrer"
    ],
    "barrant": [
        "barrer"
    ],
    "barre": [
        "barrer",
        "barre"
    ],
    "barreau": [
        "barreau"
    ],
    "barreaudees": [
        "barreaude"
    ],
    "barreaux": [
        "barreau"
    ],
    "barrent": [
        "barrer"
    ],
    "barrer": [
        "barrer"
    ],
    "barrera": [
        "barrer"
    ],
    "barrerai": [
        "barrer"
    ],
    "barrerais": [
        "barrer"
    ],
    "barreront": [
        "barrer"
    ],
    "barres": [
        "barrer",
        "barre"
    ],
    "barrette": [
        "barrette"
    ],
    "barrettes": [
        "barrette"
    ],
    "barreur": [
        "barreur"
    ],
    "barreurs": [
        "barreur"
    ],
    "barreuse": [
        "barreur"
    ],
    "barrez": [
        "barrer"
    ],
    "barri": [
        "barrir"
    ],
    "barricada": [
        "barricader"
    ],
    "barricadai": [
        "barricader"
    ],
    "barricadaient": [
        "barricader"
    ],
    "barricadait": [
        "barricader"
    ],
    "barricade": [
        "barricade",
        "barricader"
    ],
    "barricadent": [
        "barricader"
    ],
    "barricader": [
        "barricader"
    ],
    "barricaderait": [
        "barricader"
    ],
    "barricades": [
        "barricade",
        "barricader"
    ],
    "barricadez": [
        "barricader"
    ],
    "barricadier": [
        "barricadier"
    ],
    "barricadieres": [
        "barricadier"
    ],
    "barricadons": [
        "barricader"
    ],
    "barricaderent": [
        "barricader"
    ],
    "barricadee": [
        "barricader"
    ],
    "barricadees": [
        "barricader"
    ],
    "barrique": [
        "barrique"
    ],
    "barriques": [
        "barrique"
    ],
    "barris": [
        "barrir"
    ],
    "barrissait": [
        "barrir"
    ],
    "barrissant": [
        "barrir"
    ],
    "barrissement": [
        "barrissement"
    ],
    "barrissements": [
        "barrissement"
    ],
    "barrissent": [
        "barrir"
    ],
    "barriste": [
        "barriste"
    ],
    "barrit": [
        "barrir"
    ],
    "barriere": [
        "barriere"
    ],
    "barrieres": [
        "barriere"
    ],
    "barrons": [
        "barrer"
    ],
    "barrerent": [
        "barrer"
    ],
    "barree": [
        "barrer",
        "barre"
    ],
    "barrees": [
        "barrer",
        "barre"
    ],
    "barresien": [
        "barresien"
    ],
    "bars": [
        "bar"
    ],
    "bartavelle": [
        "bartavelle"
    ],
    "bartavelles": [
        "bartavelle"
    ],
    "barye": [
        "barye"
    ],
    "baryon": [
        "baryon"
    ],
    "baryte": [
        "baryte"
    ],
    "baryton": [
        "baryton"
    ],
    "barytonnant": [
        "barytonner"
    ],
    "barytonner": [
        "barytonner"
    ],
    "barytons": [
        "baryton"
    ],
    "baryum": [
        "baryum"
    ],
    "barzoi": [
        "barzoi"
    ],
    "bareme": [
        "bareme"
    ],
    "baremes": [
        "bareme"
    ],
    "bas": [
        "bas",
        "ba"
    ],
    "basa": [
        "baser"
    ],
    "basaient": [
        "baser"
    ],
    "basait": [
        "baser"
    ],
    "basal": [
        "basal"
    ],
    "basalte": [
        "basalte"
    ],
    "basaltes": [
        "basalte"
    ],
    "basaltique": [
        "basaltique"
    ],
    "basane": [
        "basane",
        "basaner"
    ],
    "basanes": [
        "basane",
        "basaner"
    ],
    "basant": [
        "baser"
    ],
    "basanee": [
        "basane"
    ],
    "basanees": [
        "basane",
        "basaner"
    ],
    "bascula": [
        "basculer"
    ],
    "basculai": [
        "basculer"
    ],
    "basculaient": [
        "basculer"
    ],
    "basculais": [
        "basculer"
    ],
    "basculait": [
        "basculer"
    ],
    "basculant": [
        "basculant",
        "basculer"
    ],
    "basculante": [
        "basculant"
    ],
    "basculants": [
        "basculant"
    ],
    "bascule": [
        "basculer",
        "bascule"
    ],
    "basculement": [
        "basculement"
    ],
    "basculent": [
        "basculer"
    ],
    "basculer": [
        "basculer"
    ],
    "basculera": [
        "basculer"
    ],
    "basculerai": [
        "basculer"
    ],
    "basculerais": [
        "basculer"
    ],
    "basculerait": [
        "basculer"
    ],
    "basculeront": [
        "basculer"
    ],
    "bascules": [
        "basculer",
        "bascule"
    ],
    "basculez": [
        "basculer"
    ],
    "basculions": [
        "basculer"
    ],
    "basculames": [
        "basculer"
    ],
    "basculat": [
        "basculer"
    ],
    "basculerent": [
        "basculer"
    ],
    "basculee": [
        "basculer"
    ],
    "basculees": [
        "basculer"
    ],
    "base": [
        "baser",
        "base"
    ],
    "baseball": [
        "baseball"
    ],
    "basent": [
        "baser"
    ],
    "baser": [
        "base",
        "baser"
    ],
    "basera": [
        "baser"
    ],
    "baseront": [
        "baser"
    ],
    "bases": [
        "baser",
        "base"
    ],
    "basez": [
        "baser"
    ],
    "basic": [
        "basic"
    ],
    "basilaire": [
        "basilaire"
    ],
    "basileus": [
        "basileus"
    ],
    "basilic": [
        "basilic"
    ],
    "basilicum": [
        "basilicum"
    ],
    "basilique": [
        "basilique"
    ],
    "basiliques": [
        "basilique"
    ],
    "basin": [
        "basin"
    ],
    "basique": [
        "basique"
    ],
    "basiques": [
        "basique"
    ],
    "basket": [
        "basket"
    ],
    "baskets": [
        "basket"
    ],
    "basketteur": [
        "basketteur"
    ],
    "basketteurs": [
        "basketteur"
    ],
    "basketteuse": [
        "basketteur"
    ],
    "basketteuses": [
        "basketteur"
    ],
    "basmati": [
        "basmati"
    ],
    "basoche": [
        "basoche"
    ],
    "basons": [
        "baser"
    ],
    "basquaise": [
        "basquais"
    ],
    "basque": [
        "basque"
    ],
    "basques": [
        "basque"
    ],
    "bassa": [
        "bassa"
    ],
    "bassas": [
        "bassa"
    ],
    "basse": [
        "bas",
        "basse"
    ],
    "bassement": [
        "bassement"
    ],
    "basses": [
        "bas",
        "basse",
        "bass"
    ],
    "bassesse": [
        "bassesse"
    ],
    "bassesses": [
        "bassesse"
    ],
    "basset": [
        "basset"
    ],
    "bassets": [
        "basset"
    ],
    "bassette": [
        "bassette"
    ],
    "bassin": [
        "bassin"
    ],
    "bassinaient": [
        "bassiner"
    ],
    "bassinais": [
        "bassiner"
    ],
    "bassinait": [
        "bassiner"
    ],
    "bassinant": [
        "bassiner"
    ],
    "bassine": [
        "bassiner",
        "bassine"
    ],
    "bassiner": [
        "bassiner"
    ],
    "bassines": [
        "bassiner",
        "bassine"
    ],
    "bassinet": [
        "bassinet"
    ],
    "bassinez": [
        "bassiner"
    ],
    "bassinoire": [
        "bassinoire"
    ],
    "bassinoires": [
        "bassinoire"
    ],
    "bassins": [
        "bassin"
    ],
    "bassiste": [
        "bassiste"
    ],
    "bassistes": [
        "bassiste"
    ],
    "basson": [
        "basson"
    ],
    "basta": [
        "baster",
        "basta"
    ],
    "baste": [
        "baste"
    ],
    "baster": [
        "baster"
    ],
    "bastide": [
        "bastide"
    ],
    "bastides": [
        "bastide"
    ],
    "bastille": [
        "bastille"
    ],
    "bastilles": [
        "bastille"
    ],
    "bastingage": [
        "bastingage"
    ],
    "bastingages": [
        "bastingage"
    ],
    "bastion": [
        "bastion"
    ],
    "bastionnee": [
        "bastionner"
    ],
    "bastions": [
        "bastion"
    ],
    "baston": [
        "baston"
    ],
    "bastonnade": [
        "bastonnade"
    ],
    "bastonnades": [
        "bastonnade"
    ],
    "bastonne": [
        "bastonner"
    ],
    "bastonnent": [
        "bastonner"
    ],
    "bastonner": [
        "bastonner"
    ],
    "bastonneurs": [
        "bastonneur"
    ],
    "bastonnee": [
        "bastonner"
    ],
    "bastonnes": [
        "bastonner"
    ],
    "bastons": [
        "baster",
        "baston"
    ],
    "bastos": [
        "bastos"
    ],
    "bastringue": [
        "bastringue"
    ],
    "bastringues": [
        "bastringue"
    ],
    "basee": [
        "base",
        "baser"
    ],
    "basees": [
        "base",
        "baser"
    ],
    "bat": [
        "bat",
        "battre"
    ],
    "bataclan": [
        "bataclan"
    ],
    "batailla": [
        "batailler"
    ],
    "bataillait": [
        "batailler"
    ],
    "bataillant": [
        "batailler"
    ],
    "bataille": [
        "bataille",
        "batailler"
    ],
    "bataillent": [
        "batailler"
    ],
    "batailler": [
        "batailler"
    ],
    "batailles": [
        "bataille",
        "batailler"
    ],
    "batailleur": [
        "batailleur"
    ],
    "batailleurs": [
        "batailleur"
    ],
    "batailleuse": [
        "batailleur"
    ],
    "batailleuses": [
        "batailleur"
    ],
    "bataillon": [
        "bataillon"
    ],
    "bataillonnaire": [
        "bataillonnaire"
    ],
    "bataillonnaires": [
        "bataillonnaire"
    ],
    "bataillons": [
        "batailler",
        "bataillon"
    ],
    "bataillerent": [
        "batailler"
    ],
    "batak": [
        "batak"
    ],
    "batardeau": [
        "batardeau"
    ],
    "batave": [
        "batave"
    ],
    "bataves": [
        "batave"
    ],
    "bateau": [
        "bateau"
    ],
    "bateaux": [
        "bateau"
    ],
    "batelets": [
        "batelet"
    ],
    "bateleur": [
        "bateleur"
    ],
    "bateleurs": [
        "bateleur"
    ],
    "batelier": [
        "batelier"
    ],
    "bateliers": [
        "batelier"
    ],
    "batellerie": [
        "batellerie"
    ],
    "bath": [
        "bath"
    ],
    "bathyale": [
        "bathyal"
    ],
    "bathymetre": [
        "bathymetre"
    ],
    "bathymetrique": [
        "bathymetrique"
    ],
    "bathyscaphe": [
        "bathyscaphe"
    ],
    "bathysphere": [
        "bathysphere"
    ],
    "batifola": [
        "batifoler"
    ],
    "batifolage": [
        "batifolage"
    ],
    "batifolages": [
        "batifolage"
    ],
    "batifolaient": [
        "batifoler"
    ],
    "batifolais": [
        "batifoler"
    ],
    "batifolait": [
        "batifoler"
    ],
    "batifolant": [
        "batifoler"
    ],
    "batifole": [
        "batifoler"
    ],
    "batifolent": [
        "batifoler"
    ],
    "batifoler": [
        "batifoler"
    ],
    "batifoles": [
        "batifoler"
    ],
    "batifoleurs": [
        "batifoleur"
    ],
    "batifolez": [
        "batifoler"
    ],
    "batik": [
        "batik"
    ],
    "batiste": [
        "batiste"
    ],
    "batracien": [
        "batracien"
    ],
    "batracienne": [
        "batracien"
    ],
    "batraciens": [
        "batracien"
    ],
    "bats": [
        "bat",
        "battre"
    ],
    "battage": [
        "battage"
    ],
    "battages": [
        "battage"
    ],
    "battaient": [
        "battre"
    ],
    "battais": [
        "battre"
    ],
    "battait": [
        "battre"
    ],
    "battant": [
        "battant",
        "battre"
    ],
    "battante": [
        "battant"
    ],
    "battantes": [
        "battant"
    ],
    "battants": [
        "battant"
    ],
    "batte": [
        "batte",
        "battre"
    ],
    "battement": [
        "battement"
    ],
    "battements": [
        "battement"
    ],
    "battent": [
        "battre"
    ],
    "batterie": [
        "batterie"
    ],
    "batteries": [
        "batterie",
        "battery"
    ],
    "battes": [
        "batte",
        "battre"
    ],
    "batteur": [
        "batteur"
    ],
    "batteurs": [
        "batteur"
    ],
    "batteuse": [
        "batteur"
    ],
    "batteuses": [
        "batteur"
    ],
    "battez": [
        "battre"
    ],
    "battiez": [
        "battre"
    ],
    "battions": [
        "battre"
    ],
    "battirent": [
        "battre"
    ],
    "battis": [
        "battre"
    ],
    "battit": [
        "battre"
    ],
    "battoir": [
        "battoir"
    ],
    "battoires": [
        "battoire"
    ],
    "battoirs": [
        "battoir"
    ],
    "battons": [
        "battre"
    ],
    "battra": [
        "battre"
    ],
    "battrai": [
        "battre"
    ],
    "battraient": [
        "battre"
    ],
    "battrais": [
        "battre"
    ],
    "battrait": [
        "battre"
    ],
    "battras": [
        "battre"
    ],
    "battre": [
        "battre"
    ],
    "battrez": [
        "battre"
    ],
    "battriez": [
        "battre"
    ],
    "battrions": [
        "battre"
    ],
    "battrons": [
        "battre"
    ],
    "battront": [
        "battre"
    ],
    "battu": [
        "battu",
        "battre"
    ],
    "battue": [
        "battue",
        "battu",
        "battre"
    ],
    "battues": [
        "battue",
        "battu",
        "battre"
    ],
    "battus": [
        "battu",
        "battre"
    ],
    "battimes": [
        "battre"
    ],
    "batee": [
        "batee"
    ],
    "bau": [
        "bau"
    ],
    "baud": [
        "baud"
    ],
    "baudelairien": [
        "baudelairien"
    ],
    "baudelairiennes": [
        "baudelairien"
    ],
    "baudelairiens": [
        "baudelairien"
    ],
    "baudet": [
        "baudet"
    ],
    "baudets": [
        "baudet"
    ],
    "baudrier": [
        "baudrier"
    ],
    "baudriers": [
        "baudrier"
    ],
    "baudroie": [
        "baudroie"
    ],
    "baudroies": [
        "baudroie"
    ],
    "baudruche": [
        "baudruche"
    ],
    "baudruches": [
        "baudruche"
    ],
    "bauge": [
        "bauge",
        "bauger"
    ],
    "bauges": [
        "bauge"
    ],
    "baume": [
        "baume"
    ],
    "baumes": [
        "baume"
    ],
    "baumier": [
        "baumier"
    ],
    "baumiers": [
        "baumier"
    ],
    "baux": [
        "bail,bau"
    ],
    "bauxite": [
        "bauxite"
    ],
    "bava": [
        "baver"
    ],
    "bavaient": [
        "baver"
    ],
    "bavais": [
        "baver"
    ],
    "bavait": [
        "baver"
    ],
    "bavant": [
        "baver"
    ],
    "bavard": [
        "bavard"
    ],
    "bavarda": [
        "bavarder"
    ],
    "bavardage": [
        "bavardage"
    ],
    "bavardages": [
        "bavardage"
    ],
    "bavardai": [
        "bavarder"
    ],
    "bavardaient": [
        "bavarder"
    ],
    "bavardais": [
        "bavarder"
    ],
    "bavardait": [
        "bavarder"
    ],
    "bavardant": [
        "bavarder"
    ],
    "bavarde": [
        "bavard",
        "bavarder"
    ],
    "bavardent": [
        "bavarder"
    ],
    "bavarder": [
        "bavarder"
    ],
    "bavardera": [
        "bavarder"
    ],
    "bavarderai": [
        "bavarder"
    ],
    "bavarderait": [
        "bavarder"
    ],
    "bavarderas": [
        "bavarder"
    ],
    "bavarderons": [
        "bavarder"
    ],
    "bavardes": [
        "bavard",
        "bavarder"
    ],
    "bavardez": [
        "bavarder"
    ],
    "bavardiez": [
        "bavarder"
    ],
    "bavardions": [
        "bavarder"
    ],
    "bavardons": [
        "bavarder"
    ],
    "bavards": [
        "bavard"
    ],
    "bavarderent": [
        "bavarder"
    ],
    "bavarois": [
        "bavarois"
    ],
    "bavaroise": [
        "bavarois"
    ],
    "bavaroises": [
        "bavarois"
    ],
    "bavassaient": [
        "bavasser"
    ],
    "bavassait": [
        "bavasser"
    ],
    "bavassant": [
        "bavasser"
    ],
    "bavasse": [
        "bavasser"
    ],
    "bavassent": [
        "bavasser"
    ],
    "bavasser": [
        "bavasser"
    ],
    "bavasses": [
        "bavasser"
    ],
    "bavasseur": [
        "bavasseur"
    ],
    "bavassiez": [
        "bavasser"
    ],
    "bave": [
        "baver",
        "bave"
    ],
    "bavent": [
        "baver"
    ],
    "baver": [
        "baver"
    ],
    "baverais": [
        "baver"
    ],
    "baveras": [
        "baver"
    ],
    "baverez": [
        "baver"
    ],
    "baveront": [
        "baver"
    ],
    "baves": [
        "baver",
        "bave"
    ],
    "bavette": [
        "bavette"
    ],
    "bavettes": [
        "bavette"
    ],
    "baveur": [
        "baveur"
    ],
    "baveurs": [
        "baveur"
    ],
    "baveuse": [
        "baveur",
        "baveux"
    ],
    "baveuses": [
        "baveux"
    ],
    "baveux": [
        "baveux"
    ],
    "bavez": [
        "baver"
    ],
    "bavocher": [
        "bavocher"
    ],
    "bavoir": [
        "bavoir"
    ],
    "bavoirs": [
        "bavoir"
    ],
    "bavons": [
        "baver"
    ],
    "bavotait": [
        "bavoter"
    ],
    "bavotant": [
        "bavoter"
    ],
    "bavure": [
        "bavure"
    ],
    "bavures": [
        "bavure"
    ],
    "bayadere": [
        "bayadere"
    ],
    "bayaderes": [
        "bayadere"
    ],
    "bayaient": [
        "bayer"
    ],
    "bayant": [
        "bayer"
    ],
    "bayard": [
        "bayard"
    ],
    "baye": [
        "bayer"
    ],
    "bayer": [
        "bayer"
    ],
    "bayons": [
        "bayer"
    ],
    "bayou": [
        "bayou"
    ],
    "bayous": [
        "bayou"
    ],
    "bazar": [
        "bazar"
    ],
    "bazard": [
        "bazard"
    ],
    "bazardait": [
        "bazarder"
    ],
    "bazardant": [
        "bazarder"
    ],
    "bazarde": [
        "bazarder"
    ],
    "bazarder": [
        "bazarder"
    ],
    "bazarderez": [
        "bazarder"
    ],
    "bazardes": [
        "bazarder"
    ],
    "bazardeur": [
        "bazardeur"
    ],
    "bazardee": [
        "bazarder"
    ],
    "bazardees": [
        "bazarder"
    ],
    "bazars": [
        "bazar"
    ],
    "bazooka": [
        "bazooka"
    ],
    "bazookas": [
        "bazooka"
    ],
    "baionnette": [
        "baionnette"
    ],
    "baionnettes": [
        "baionnette"
    ],
    "bcbg": [
        "bcbg"
    ],
    "beagle": [
        "beagle"
    ],
    "beagles": [
        "beagle"
    ],
    "beat": [
        "beat"
    ],
    "beatnik": [
        "beatnik"
    ],
    "beatniks": [
        "beatnik"
    ],
    "beau": [
        "beau"
    ],
    "beauceron": [
        "beauceron"
    ],
    "beauceronne": [
        "beauceron"
    ],
    "beauceronnes": [
        "beauceron"
    ],
    "beaucerons": [
        "beauceron"
    ],
    "beaucoup": [
        "beaucoup"
    ],
    "beauf": [
        "beauf"
    ],
    "beaufs": [
        "beauf"
    ],
    "beaujolais": [
        "beaujolais"
    ],
    "beaujolpif": [
        "beaujolpif"
    ],
    "beaupre": [
        "beaupre"
    ],
    "beaute": [
        "beaute"
    ],
    "beautes": [
        "beaute"
    ],
    "beauvais": [
        "beauvais"
    ],
    "beaux": [
        "beau"
    ],
    "bec": [
        "bec"
    ],
    "because": [
        "because"
    ],
    "becfigue": [
        "becfigue"
    ],
    "becfigues": [
        "becfigue"
    ],
    "becquant": [
        "becquer"
    ],
    "becquer": [
        "becquer"
    ],
    "becquet": [
        "becquet"
    ],
    "becquetaient": [
        "becqueter"
    ],
    "becquetait": [
        "becqueter"
    ],
    "becquetance": [
        "becquetance"
    ],
    "becquetant": [
        "becqueter"
    ],
    "becqueter": [
        "becqueter"
    ],
    "becquets": [
        "becquet"
    ],
    "becquette": [
        "becqueter"
    ],
    "becquete": [
        "becqueter"
    ],
    "becquetes": [
        "becqueter"
    ],
    "becque": [
        "becquer"
    ],
    "becquee": [
        "becquee"
    ],
    "becs": [
        "bec"
    ],
    "becta": [
        "becter"
    ],
    "bectais": [
        "becter"
    ],
    "bectait": [
        "becter"
    ],
    "bectance": [
        "bectance"
    ],
    "bectant": [
        "becter"
    ],
    "becte": [
        "becter"
    ],
    "bectent": [
        "becter"
    ],
    "becter": [
        "becter"
    ],
    "becterais": [
        "becter"
    ],
    "becteras": [
        "becter"
    ],
    "bectees": [
        "becter"
    ],
    "bectes": [
        "becter"
    ],
    "bedaine": [
        "bedaine"
    ],
    "bedaines": [
        "bedaine"
    ],
    "bedeau": [
        "bedeau"
    ],
    "bedeaux": [
        "bedeau"
    ],
    "bedon": [
        "bedon"
    ],
    "bedonnant": [
        "bedonner",
        "bedonnant"
    ],
    "bedonnante": [
        "bedonnant"
    ],
    "bedonnantes": [
        "bedonnant"
    ],
    "bedonnants": [
        "bedonnant"
    ],
    "bedonne": [
        "bedonner"
    ],
    "bedons": [
        "bedon"
    ],
    "beefsteak": [
        "beefsteak"
    ],
    "beefsteaks": [
        "beefsteak"
    ],
    "beeper": [
        "beeper"
    ],
    "beethovenien": [
        "beethovenien"
    ],
    "beffroi": [
        "beffroi"
    ],
    "behavioriste": [
        "behavioriste"
    ],
    "beige": [
        "beige"
    ],
    "beigeasses": [
        "beigeasse"
    ],
    "beiges": [
        "beige"
    ],
    "beigne": [
        "beigne"
    ],
    "beignes": [
        "beigne"
    ],
    "beignet": [
        "beignet"
    ],
    "beignets": [
        "beignet"
    ],
    "bel": [
        "bel"
    ],
    "belette": [
        "belette"
    ],
    "belettes": [
        "belette"
    ],
    "belge": [
        "belge"
    ],
    "belges": [
        "belge"
    ],
    "belgicains": [
        "belgicain"
    ],
    "belgique": [
        "belgique"
    ],
    "belladone": [
        "belladone"
    ],
    "belladones": [
        "belladone"
    ],
    "belle": [
        "beau"
    ],
    "bellement": [
        "bellement"
    ],
    "belles": [
        "belle",
        "beau"
    ],
    "bellevillois": [
        "bellevillois"
    ],
    "bellevilloise": [
        "bellevillois"
    ],
    "belliciste": [
        "belliciste"
    ],
    "bellicistes": [
        "belliciste"
    ],
    "belligerance": [
        "belligerance"
    ],
    "belligerant": [
        "belligerant"
    ],
    "belligerante": [
        "belligerant"
    ],
    "belligerantes": [
        "belligerant"
    ],
    "belligerants": [
        "belligerant"
    ],
    "belliqueuse": [
        "belliqueux"
    ],
    "belliqueusement": [
        "belliqueusement"
    ],
    "belliqueuses": [
        "belliqueux"
    ],
    "belliqueux": [
        "belliqueux"
    ],
    "bellissime": [
        "bellissime"
    ],
    "bellot": [
        "bellot"
    ],
    "belluaire": [
        "belluaire"
    ],
    "bellatre": [
        "bellatre"
    ],
    "belon": [
        "belon"
    ],
    "belons": [
        "belon"
    ],
    "belote": [
        "belote"
    ],
    "beloter": [
        "beloter"
    ],
    "belotes": [
        "belote"
    ],
    "beloteurs": [
        "beloteur"
    ],
    "belotte": [
        "belotter"
    ],
    "beluga": [
        "beluga"
    ],
    "belvedere": [
        "belvedere"
    ],
    "belvederes": [
        "belvedere"
    ],
    "ben": [
        "ben"
    ],
    "benedictus": [
        "benedictus"
    ],
    "bengalais": [
        "bengalais"
    ],
    "bengali": [
        "bengali"
    ],
    "bengalis": [
        "bengali"
    ],
    "benjamin": [
        "benjamin"
    ],
    "benjamine": [
        "benjamin"
    ],
    "benjamins": [
        "benjamin"
    ],
    "benjoin": [
        "benjoin"
    ],
    "benne": [
        "benne"
    ],
    "bennes": [
        "benne"
    ],
    "benoit": [
        "benoit"
    ],
    "benoite": [
        "benoit",
        "benoite"
    ],
    "benoitement": [
        "benoitement"
    ],
    "benthique": [
        "benthique"
    ],
    "benzidine": [
        "benzidine"
    ],
    "benzine": [
        "benzine"
    ],
    "benzoate": [
        "benzoate"
    ],
    "benzodiazepine": [
        "benzodiazepine"
    ],
    "benzonaphtol": [
        "benzonaphtol"
    ],
    "benzylique": [
        "benzylique"
    ],
    "benzene": [
        "benzene"
    ],
    "benzedrine": [
        "benzedrine"
    ],
    "benet": [
        "benet"
    ],
    "benets": [
        "benet"
    ],
    "ber": [
        "ber"
    ],
    "berbere": [
        "berbere"
    ],
    "berberes": [
        "berbere"
    ],
    "bercail": [
        "bercail"
    ],
    "berce": [
        "bercer",
        "berce"
    ],
    "berceau": [
        "berceau"
    ],
    "berceaux": [
        "berceau"
    ],
    "bercelonnette": [
        "bercelonnette"
    ],
    "bercement": [
        "bercement"
    ],
    "bercements": [
        "bercement"
    ],
    "bercent": [
        "bercer"
    ],
    "bercer": [
        "bercer"
    ],
    "bercera": [
        "bercer"
    ],
    "bercerai": [
        "bercer"
    ],
    "bercerait": [
        "bercer"
    ],
    "bercerez": [
        "bercer"
    ],
    "berces": [
        "bercer",
        "berce"
    ],
    "berceur": [
        "berceur"
    ],
    "berceurs": [
        "berceur"
    ],
    "berceuse": [
        "berceur"
    ],
    "berceuses": [
        "berceur"
    ],
    "bercez": [
        "bercer"
    ],
    "bercerent": [
        "bercer"
    ],
    "bercee": [
        "bercer"
    ],
    "berdouillette": [
        "berdouillette"
    ],
    "berg": [
        "berg"
    ],
    "bergamasques": [
        "bergamasque"
    ],
    "bergamote": [
        "bergamote"
    ],
    "berge": [
        "berge"
    ],
    "berger": [
        "berger"
    ],
    "bergerie": [
        "bergerie"
    ],
    "bergeries": [
        "bergerie"
    ],
    "bergeronnette": [
        "bergeronnette"
    ],
    "bergeronnettes": [
        "bergeronnette"
    ],
    "bergers": [
        "berger"
    ],
    "berges": [
        "berge"
    ],
    "bergere": [
        "berger"
    ],
    "bergeres": [
        "berger"
    ],
    "berk": [
        "berk"
    ],
    "berle": [
        "berle"
    ],
    "berlin": [
        "berlin"
    ],
    "berline": [
        "berline"
    ],
    "berlines": [
        "berline"
    ],
    "berlingot": [
        "berlingot"
    ],
    "berlingots": [
        "berlingot"
    ],
    "berlingue": [
        "berlingue"
    ],
    "berlinois": [
        "berlinois"
    ],
    "berlinoise": [
        "berlinois"
    ],
    "berlinoises": [
        "berlinois"
    ],
    "berloque": [
        "berloque"
    ],
    "berlue": [
        "berlue"
    ],
    "berlues": [
        "berlue"
    ],
    "berlurais": [
        "berlurer"
    ],
    "berlurait": [
        "berlurer"
    ],
    "berlure": [
        "berlure",
        "berlurer"
    ],
    "berlurent": [
        "berlurer"
    ],
    "berlurer": [
        "berlurer"
    ],
    "berlures": [
        "berlure"
    ],
    "berluree": [
        "berlurer"
    ],
    "berme": [
        "berme"
    ],
    "bermes": [
        "berme"
    ],
    "bermuda": [
        "bermuda"
    ],
    "bermudas": [
        "bermuda"
    ],
    "bernache": [
        "bernache"
    ],
    "bernaches": [
        "bernache"
    ],
    "bernait": [
        "berner"
    ],
    "bernant": [
        "berner"
    ],
    "bernardines": [
        "bernardin"
    ],
    "berne": [
        "berner",
        "berne"
    ],
    "berner": [
        "berner"
    ],
    "berneras": [
        "berner"
    ],
    "bernez": [
        "berner"
    ],
    "bernicle": [
        "bernicle"
    ],
    "bernicles": [
        "bernicle"
    ],
    "bernique": [
        "bernique"
    ],
    "berniques": [
        "bernique"
    ],
    "bernois": [
        "bernois"
    ],
    "bernoise": [
        "bernois"
    ],
    "bernoises": [
        "bernois"
    ],
    "bernee": [
        "berner"
    ],
    "bernees": [
        "berner"
    ],
    "bernes": [
        "berner"
    ],
    "berrichon": [
        "berrichon"
    ],
    "berrichonne": [
        "berrichon"
    ],
    "bersaglier": [
        "bersaglier"
    ],
    "bersagliers": [
        "bersaglier"
    ],
    "bertha": [
        "bertha"
    ],
    "berthas": [
        "bertha"
    ],
    "berthe": [
        "berthe"
    ],
    "berzingue": [
        "berzingue"
    ],
    "berca": [
        "bercer"
    ],
    "bercaient": [
        "bercer"
    ],
    "bercais": [
        "bercer"
    ],
    "bercait": [
        "bercer"
    ],
    "bercant": [
        "bercer"
    ],
    "besace": [
        "besace"
    ],
    "besaces": [
        "besace"
    ],
    "besaigue": [
        "besaigue"
    ],
    "besant": [
        "besant"
    ],
    "besants": [
        "besant"
    ],
    "besef": [
        "besef"
    ],
    "besicles": [
        "besicles"
    ],
    "besogna": [
        "besogner"
    ],
    "besognaient": [
        "besogner"
    ],
    "besognais": [
        "besogner"
    ],
    "besognait": [
        "besogner"
    ],
    "besognant": [
        "besogner"
    ],
    "besogne": [
        "besogne",
        "besogner"
    ],
    "besognent": [
        "besogner"
    ],
    "besogner": [
        "besogner"
    ],
    "besogneras": [
        "besogner"
    ],
    "besognes": [
        "besogne"
    ],
    "besogneuse": [
        "besogneux"
    ],
    "besogneuses": [
        "besogneux"
    ],
    "besogneux": [
        "besogneux"
    ],
    "besognerent": [
        "besogner"
    ],
    "besoin": [
        "besoin"
    ],
    "besoins": [
        "besoin"
    ],
    "besson": [
        "besson"
    ],
    "bessons": [
        "besson"
    ],
    "best": [
        "best",
        "good"
    ],
    "bestiaire": [
        "bestiaire"
    ],
    "bestiaires": [
        "bestiaire"
    ],
    "bestial": [
        "bestial"
    ],
    "bestiale": [
        "bestial"
    ],
    "bestialement": [
        "bestialement"
    ],
    "bestiales": [
        "bestial"
    ],
    "bestialite": [
        "bestialite"
    ],
    "bestialites": [
        "bestialite"
    ],
    "bestiasse": [
        "bestiasse"
    ],
    "bestiau": [
        "bestiau"
    ],
    "bestiaux": [
        "bestial",
        "bestiau"
    ],
    "bestiole": [
        "bestiole"
    ],
    "bestioles": [
        "bestiole"
    ],
    "bette": [
        "bette"
    ],
    "betterave": [
        "betterave"
    ],
    "betteraves": [
        "betterave"
    ],
    "betteravier": [
        "betteravier"
    ],
    "bettes": [
        "bette"
    ],
    "betting": [
        "bet",
        "betting"
    ],
    "beu": [
        "beu"
    ],
    "beuark": [
        "beuark"
    ],
    "beugla": [
        "beugler"
    ],
    "beuglaient": [
        "beugler"
    ],
    "beuglais": [
        "beugler"
    ],
    "beuglait": [
        "beugler"
    ],
    "beuglant": [
        "beugler",
        "beuglant"
    ],
    "beuglante": [
        "beuglant"
    ],
    "beuglantes": [
        "beuglant"
    ],
    "beuglants": [
        "beuglant"
    ],
    "beugle": [
        "beugler"
    ],
    "beuglement": [
        "beuglement"
    ],
    "beuglements": [
        "beuglement"
    ],
    "beuglent": [
        "beugler"
    ],
    "beugler": [
        "beugler"
    ],
    "beuglions": [
        "beugler"
    ],
    "beuglee": [
        "beugler"
    ],
    "beuh": [
        "beuh"
    ],
    "beur": [
        "beur"
    ],
    "beurk": [
        "beurk"
    ],
    "beurra": [
        "beurrer"
    ],
    "beurrage": [
        "beurrage"
    ],
    "beurraient": [
        "beurrer"
    ],
    "beurrais": [
        "beurrer"
    ],
    "beurrait": [
        "beurrer"
    ],
    "beurrant": [
        "beurrer"
    ],
    "beurre": [
        "beurre",
        "beurrer"
    ],
    "beurrer": [
        "beurrer"
    ],
    "beurres": [
        "beurre",
        "beurrer"
    ],
    "beurrier": [
        "beurrier"
    ],
    "beurree": [
        "beurre",
        "beurrer"
    ],
    "beurrees": [
        "beurre",
        "beurrer"
    ],
    "beuverie": [
        "beuverie"
    ],
    "beuveries": [
        "beuverie"
    ],
    "bey": [
        "bey"
    ],
    "bezef": [
        "bezef"
    ],
    "bi": [
        "bi"
    ],
    "biafrais": [
        "biafrais"
    ],
    "biais": [
        "biais"
    ],
    "biaisai": [
        "biaiser"
    ],
    "biaise": [
        "biaise",
        "biaiser",
        "biais"
    ],
    "biaisements": [
        "biaisement"
    ],
    "biaiser": [
        "biaiser"
    ],
    "biaises": [
        "biais"
    ],
    "biaisee": [
        "biaise",
        "biaiser"
    ],
    "biathlon": [
        "biathlon"
    ],
    "bib": [
        "bib"
    ],
    "bibard": [
        "bibard"
    ],
    "bibelot": [
        "bibelot"
    ],
    "bibelots": [
        "bibelot"
    ],
    "bibendum": [
        "bibendum"
    ],
    "biberon": [
        "biberon"
    ],
    "biberonnait": [
        "biberonner"
    ],
    "biberonne": [
        "biberonner"
    ],
    "biberonner": [
        "biberonner"
    ],
    "biberonneurs": [
        "biberonneur"
    ],
    "biberons": [
        "biberon"
    ],
    "bibi": [
        "bibi"
    ],
    "bibiche": [
        "bibiche"
    ],
    "bibine": [
        "bibine"
    ],
    "bibines": [
        "bibine"
    ],
    "bibis": [
        "bibi"
    ],
    "bibite": [
        "bibite"
    ],
    "bible": [
        "bible"
    ],
    "bibles": [
        "bible"
    ],
    "bibliobus": [
        "bibliobus"
    ],
    "bibliographe": [
        "bibliographe"
    ],
    "bibliographie": [
        "bibliographie"
    ],
    "bibliographies": [
        "bibliography",
        "bibliographie"
    ],
    "bibliographique": [
        "bibliographique"
    ],
    "bibliographiques": [
        "bibliographique"
    ],
    "bibliophile": [
        "bibliophile"
    ],
    "bibliophiles": [
        "bibliophile"
    ],
    "bibliophilie": [
        "bibliophilie"
    ],
    "bibliophilique": [
        "bibliophilique"
    ],
    "bibliotheque": [
        "bibliotheque"
    ],
    "bibliotheques": [
        "bibliotheque"
    ],
    "bibliothecaire": [
        "bibliothecaire"
    ],
    "bibliothecaires": [
        "bibliothecaire"
    ],
    "biblique": [
        "biblique"
    ],
    "bibliquement": [
        "bibliquement"
    ],
    "bibliques": [
        "biblique"
    ],
    "bic": [
        "bic"
    ],
    "bicamerale": [
        "bicameral"
    ],
    "bicarbonate": [
        "bicarbonate"
    ],
    "bicarbonates": [
        "bicarbonate"
    ],
    "bicause": [
        "bicause"
    ],
    "bicentenaire": [
        "bicentenaire"
    ],
    "biceps": [
        "biceps"
    ],
    "bichais": [
        "bicher"
    ],
    "bichait": [
        "bicher"
    ],
    "bichant": [
        "bicher"
    ],
    "biche": [
        "bicher",
        "biche"
    ],
    "bicher": [
        "bicher"
    ],
    "biches": [
        "bicher",
        "biche"
    ],
    "bichette": [
        "bichette"
    ],
    "bichez": [
        "bicher"
    ],
    "bichon": [
        "bichon"
    ],
    "bichonnait": [
        "bichonner"
    ],
    "bichonnant": [
        "bichonner"
    ],
    "bichonne": [
        "bichonner"
    ],
    "bichonner": [
        "bichonner"
    ],
    "bichonnerai": [
        "bichonner"
    ],
    "bichonnez": [
        "bichonner"
    ],
    "bichonnee": [
        "bichonner"
    ],
    "biclou": [
        "biclou"
    ],
    "biclous": [
        "biclou"
    ],
    "bicolore": [
        "bicolore"
    ],
    "bicolores": [
        "bicolore"
    ],
    "biconvexes": [
        "biconvexe"
    ],
    "bicoque": [
        "bicoque"
    ],
    "bicoques": [
        "bicoque"
    ],
    "bicorne": [
        "bicorne"
    ],
    "bicornes": [
        "bicorne"
    ],
    "bicot": [
        "bicot"
    ],
    "bicots": [
        "bicot"
    ],
    "biculturelle": [
        "biculturel"
    ],
    "bicuspide": [
        "bicuspide"
    ],
    "bicycle": [
        "bicycle"
    ],
    "bicycles": [
        "bicycle"
    ],
    "bicyclette": [
        "bicyclette"
    ],
    "bicyclettes": [
        "bicyclette"
    ],
    "bicycliste": [
        "bicycliste"
    ],
    "bicephale": [
        "bicephale"
    ],
    "bicephales": [
        "bicephale"
    ],
    "bicephalie": [
        "bicephalie"
    ],
    "bidasse": [
        "bidasse"
    ],
    "bidasses": [
        "bidasse"
    ],
    "bide": [
        "bide"
    ],
    "bides": [
        "bide"
    ],
    "bidet": [
        "bidet"
    ],
    "bidets": [
        "bidet"
    ],
    "bidimensionnel": [
        "bidimensionnel"
    ],
    "bidoche": [
        "bidoche"
    ],
    "bidoches": [
        "bidoche"
    ],
    "bidon": [
        "bidon"
    ],
    "bidonnage": [
        "bidonnage"
    ],
    "bidonnaient": [
        "bidonner"
    ],
    "bidonnais": [
        "bidonner"
    ],
    "bidonnait": [
        "bidonner"
    ],
    "bidonnant": [
        "bidonnant",
        "bidonner"
    ],
    "bidonnante": [
        "bidonnant"
    ],
    "bidonne": [
        "bidonner"
    ],
    "bidonnent": [
        "bidonner"
    ],
    "bidonner": [
        "bidonner"
    ],
    "bidonnera": [
        "bidonner"
    ],
    "bidonnez": [
        "bidonner"
    ],
    "bidonnee": [
        "bidonner"
    ],
    "bidonnees": [
        "bidonner"
    ],
    "bidonnes": [
        "bidonner"
    ],
    "bidons": [
        "bidon"
    ],
    "bidonville": [
        "bidonville"
    ],
    "bidonvilles": [
        "bidonville"
    ],
    "bidouilla": [
        "bidouiller"
    ],
    "bidouillage": [
        "bidouillage"
    ],
    "bidouille": [
        "bidouiller",
        "bidouille"
    ],
    "bidouiller": [
        "bidouiller"
    ],
    "bidouillerai": [
        "bidouiller"
    ],
    "bidouillee": [
        "bidouiller"
    ],
    "bidouilles": [
        "bidouiller"
    ],
    "bidule": [
        "bidule"
    ],
    "bidules": [
        "bidule"
    ],
    "bief": [
        "bief"
    ],
    "biefs": [
        "bief"
    ],
    "bielle": [
        "bielle"
    ],
    "bielles": [
        "bielle"
    ],
    "bien": [
        "bien"
    ],
    "bienfaisance": [
        "bienfaisance"
    ],
    "bienfaisant": [
        "bienfaisant"
    ],
    "bienfaisante": [
        "bienfaisant"
    ],
    "bienfaisantes": [
        "bienfaisant"
    ],
    "bienfaisants": [
        "bienfaisant"
    ],
    "bienfait": [
        "bienfait"
    ],
    "bienfaiteur": [
        "bienfaiteur"
    ],
    "bienfaiteurs": [
        "bienfaiteur"
    ],
    "bienfaitrice": [
        "bienfaiteur"
    ],
    "bienfaitrices": [
        "bienfaiteur"
    ],
    "bienfaits": [
        "bienfait"
    ],
    "bienheureuse": [
        "bienheureux"
    ],
    "bienheureusement": [
        "bienheureusement"
    ],
    "bienheureuses": [
        "bienheureux"
    ],
    "bienheureux": [
        "bienheureux"
    ],
    "biennale": [
        "biennale"
    ],
    "biens": [
        "bien"
    ],
    "bienseance": [
        "bienseance"
    ],
    "bienseances": [
        "bienseance"
    ],
    "bienseant": [
        "bienseant"
    ],
    "bienseante": [
        "bienseant"
    ],
    "bienseantes": [
        "bienseant"
    ],
    "bienseants": [
        "bienseant"
    ],
    "bientot": [
        "bientot"
    ],
    "bienveillamment": [
        "bienveillamment"
    ],
    "bienveillance": [
        "bienveillance"
    ],
    "bienveillances": [
        "bienveillance"
    ],
    "bienveillant": [
        "bienveillant"
    ],
    "bienveillante": [
        "bienveillant"
    ],
    "bienveillantes": [
        "bienveillant"
    ],
    "bienveillants": [
        "bienveillant"
    ],
    "bienvenu": [
        "bienvenu"
    ],
    "bienvenue": [
        "bienvenue"
    ],
    "bienvenues": [
        "bienvenue"
    ],
    "bienvenus": [
        "bienvenu"
    ],
    "bif": [
        "bif"
    ],
    "biface": [
        "biface"
    ],
    "bifaces": [
        "biface"
    ],
    "biffa": [
        "biffer"
    ],
    "biffaient": [
        "biffer"
    ],
    "biffais": [
        "biffer"
    ],
    "biffant": [
        "biffer"
    ],
    "biffe": [
        "biffer",
        "biffe"
    ],
    "biffer": [
        "biffer"
    ],
    "biffeton": [
        "biffeton"
    ],
    "biffetons": [
        "biffeton"
    ],
    "biffin": [
        "biffin"
    ],
    "biffins": [
        "biffin"
    ],
    "bifide": [
        "bifide"
    ],
    "bifides": [
        "bifide"
    ],
    "bifrons": [
        "bifron"
    ],
    "bifteck": [
        "bifteck"
    ],
    "biftecks": [
        "bifteck"
    ],
    "bifton": [
        "bifton"
    ],
    "biftons": [
        "bifton"
    ],
    "bifteque": [
        "bifteque"
    ],
    "bifteques": [
        "bifteque"
    ],
    "bifurcation": [
        "bifurcation"
    ],
    "bifurcations": [
        "bifurcation"
    ],
    "bifurqua": [
        "bifurquer"
    ],
    "bifurquait": [
        "bifurquer"
    ],
    "bifurquant": [
        "bifurquer"
    ],
    "bifurque": [
        "bifurquer"
    ],
    "bifurquent": [
        "bifurquer"
    ],
    "bifurquer": [
        "bifurquer"
    ],
    "bifurqueront": [
        "bifurquer"
    ],
    "bifurquee": [
        "bifurquer"
    ],
    "bigaille": [
        "bigaille"
    ],
    "bigame": [
        "bigame"
    ],
    "bigamie": [
        "bigamie"
    ],
    "bigarreau": [
        "bigarreau"
    ],
    "bigarrer": [
        "bigarrer"
    ],
    "bigarrure": [
        "bigarrure"
    ],
    "bigarrures": [
        "bigarrure"
    ],
    "bigarre": [
        "bigarre",
        "bigarrer"
    ],
    "bigarree": [
        "bigarre",
        "bigarrer"
    ],
    "bigarrees": [
        "bigarre"
    ],
    "bigarres": [
        "bigarre",
        "bigarrer"
    ],
    "bighorn": [
        "bighorn"
    ],
    "bighorns": [
        "bighorn"
    ],
    "biglaient": [
        "bigler"
    ],
    "biglais": [
        "bigler"
    ],
    "biglait": [
        "bigler"
    ],
    "biglant": [
        "bigler"
    ],
    "bigle": [
        "bigler",
        "bigle"
    ],
    "biglent": [
        "bigler"
    ],
    "bigler": [
        "bigler"
    ],
    "bigles": [
        "bigler",
        "bigle"
    ],
    "bigleuse": [
        "bigleux"
    ],
    "bigleux": [
        "bigleux"
    ],
    "biglez": [
        "bigler"
    ],
    "biglee": [
        "bigler"
    ],
    "bigne": [
        "bigne"
    ],
    "bignolait": [
        "bignoler"
    ],
    "bignole": [
        "bignole"
    ],
    "bignoles": [
        "bignole"
    ],
    "bignolle": [
        "bignolle"
    ],
    "bignon": [
        "bignon"
    ],
    "bignones": [
        "bignone"
    ],
    "bignonias": [
        "bignonia"
    ],
    "bigo": [
        "bigo"
    ],
    "bigophone": [
        "bigophone",
        "bigophoner"
    ],
    "bigophoner": [
        "bigophoner"
    ],
    "bigophones": [
        "bigophoner"
    ],
    "bigorne": [
        "bigorne",
        "bigorner"
    ],
    "bigorneau": [
        "bigorneau"
    ],
    "bigorneaux": [
        "bigorneau"
    ],
    "bigorner": [
        "bigorner"
    ],
    "bigornes": [
        "bigorne",
        "bigorner"
    ],
    "bigot": [
        "bigot"
    ],
    "bigote": [
        "bigot"
    ],
    "bigoterie": [
        "bigoterie"
    ],
    "bigotes": [
        "bigot"
    ],
    "bigots": [
        "bigot"
    ],
    "bigouden": [
        "bigouden"
    ],
    "bigoudens": [
        "bigouden"
    ],
    "bigoudi": [
        "bigoudi"
    ],
    "bigoudis": [
        "bigoudi"
    ],
    "bigre": [
        "bigre"
    ],
    "bigrement": [
        "bigrement"
    ],
    "bigue": [
        "bigue"
    ],
    "biguine": [
        "biguine"
    ],
    "bihebdomadaire": [
        "bihebdomadaire"
    ],
    "bihebdomadaires": [
        "bihebdomadaire"
    ],
    "bihoreau": [
        "bihoreau"
    ],
    "bijou": [
        "bijou"
    ],
    "bijouterie": [
        "bijouterie"
    ],
    "bijouteries": [
        "bijouterie"
    ],
    "bijoutier": [
        "bijoutier"
    ],
    "bijoutiers": [
        "bijoutier"
    ],
    "bijoutiere": [
        "bijoutier"
    ],
    "bijoux": [
        "bijoux"
    ],
    "bikini": [
        "bikini"
    ],
    "bikinis": [
        "bikini"
    ],
    "bilais": [
        "biler"
    ],
    "bilait": [
        "biler"
    ],
    "bilan": [
        "bilan"
    ],
    "bilans": [
        "bilan"
    ],
    "bilateral": [
        "bilateral"
    ],
    "bilaterale": [
        "bilateral"
    ],
    "bilateralement": [
        "bilateralement"
    ],
    "bilateraux": [
        "bilateral"
    ],
    "bilbergia": [
        "bilbergia"
    ],
    "bilboquet": [
        "bilboquet"
    ],
    "bilboquets": [
        "bilboquet"
    ],
    "bile": [
        "biler",
        "bile"
    ],
    "biler": [
        "biler"
    ],
    "biles": [
        "biler",
        "bile"
    ],
    "bileux": [
        "bileux"
    ],
    "bilez": [
        "biler"
    ],
    "bilharziose": [
        "bilharziose"
    ],
    "biliaire": [
        "biliaire"
    ],
    "biliaires": [
        "biliaire"
    ],
    "bilieuse": [
        "bilieux"
    ],
    "bilieuses": [
        "bilieux"
    ],
    "bilieux": [
        "bilieux"
    ],
    "bilingue": [
        "bilingue"
    ],
    "bilingues": [
        "bilingue"
    ],
    "bilinguisme": [
        "bilinguisme"
    ],
    "bilirubine": [
        "bilirubine"
    ],
    "bill": [
        "bill"
    ],
    "billard": [
        "billard"
    ],
    "billards": [
        "billard"
    ],
    "bille": [
        "bille"
    ],
    "biller": [
        "biller"
    ],
    "billes": [
        "bille"
    ],
    "billet": [
        "billet"
    ],
    "billets": [
        "billet"
    ],
    "billetterie": [
        "billetterie"
    ],
    "billetteries": [
        "billetterie"
    ],
    "billettes": [
        "billette"
    ],
    "billevesee": [
        "billevesee"
    ],
    "billevesees": [
        "billevesee"
    ],
    "billion": [
        "billion"
    ],
    "billions": [
        "billion",
        "biller"
    ],
    "billon": [
        "billon"
    ],
    "billot": [
        "billot"
    ],
    "billots": [
        "billot"
    ],
    "bills": [
        "bill"
    ],
    "bilobee": [
        "bilobe"
    ],
    "bim": [
        "bim"
    ],
    "bimbeloterie": [
        "bimbeloterie"
    ],
    "bimbeloteries": [
        "bimbeloterie"
    ],
    "bimensuel": [
        "bimensuel"
    ],
    "bimensuelle": [
        "bimensuel"
    ],
    "bimensuelles": [
        "bimensuel"
    ],
    "bimestre": [
        "bimestre"
    ],
    "bimoteur": [
        "bimoteur"
    ],
    "bimoteurs": [
        "bimoteur"
    ],
    "bimetallisme": [
        "bimetallisme"
    ],
    "bin's": [
        "bin's"
    ],
    "binaire": [
        "binaire"
    ],
    "binaires": [
        "binaire"
    ],
    "binait": [
        "biner"
    ],
    "binant": [
        "biner"
    ],
    "biner": [
        "biner"
    ],
    "binette": [
        "binette"
    ],
    "binettes": [
        "binette"
    ],
    "bing": [
        "bing"
    ],
    "bingo": [
        "bingo"
    ],
    "biniou": [
        "biniou"
    ],
    "binious": [
        "biniou"
    ],
    "binoclard": [
        "binoclard"
    ],
    "binoclarde": [
        "binoclard"
    ],
    "binoclards": [
        "binoclard"
    ],
    "binocle": [
        "binocle"
    ],
    "binocles": [
        "binocle"
    ],
    "binoculaire": [
        "binoculaire"
    ],
    "bintje": [
        "bintje"
    ],
    "binz": [
        "binz"
    ],
    "bine": [
        "biner"
    ],
    "binome": [
        "binome"
    ],
    "binomes": [
        "binome"
    ],
    "bio": [
        "bio"
    ],
    "biochimie": [
        "biochimie"
    ],
    "biochimique": [
        "biochimique"
    ],
    "biochimiquement": [
        "biochimiquement"
    ],
    "biochimiques": [
        "biochimique"
    ],
    "biochimiste": [
        "biochimiste"
    ],
    "biochimistes": [
        "biochimiste"
    ],
    "biodiversite": [
        "biodiversite"
    ],
    "biodegradable": [
        "biodegradable"
    ],
    "biodegradables": [
        "biodegradable"
    ],
    "biographe": [
        "biographe"
    ],
    "biographes": [
        "biographe"
    ],
    "biographie": [
        "biographie"
    ],
    "biographies": [
        "biography",
        "biographie"
    ],
    "biographique": [
        "biographique"
    ],
    "biographiques": [
        "biographique"
    ],
    "biogenique": [
        "biogenique"
    ],
    "biogenetique": [
        "biogenetique"
    ],
    "biologie": [
        "biologie"
    ],
    "biologique": [
        "biologique"
    ],
    "biologiquement": [
        "biologiquement"
    ],
    "biologiques": [
        "biologique"
    ],
    "biologiste": [
        "biologiste"
    ],
    "biologistes": [
        "biologiste"
    ],
    "biologise": [
        "biologiser"
    ],
    "bioluminescence": [
        "bioluminescence"
    ],
    "bioluminescente": [
        "bioluminescent"
    ],
    "biomasse": [
        "biomasse"
    ],
    "biomecanique": [
        "biomecanique"
    ],
    "biomecanisme": [
        "biomecanisme"
    ],
    "biomedical": [
        "biomedical"
    ],
    "biomedicale": [
        "biomedical"
    ],
    "biomedicaux": [
        "biomedical"
    ],
    "biometrie": [
        "biometrie"
    ],
    "biometrique": [
        "biometrique"
    ],
    "biometriques": [
        "biometrique"
    ],
    "bionique": [
        "bionique"
    ],
    "bioniques": [
        "bionique"
    ],
    "biophysique": [
        "biophysique"
    ],
    "biopsie": [
        "biopsie"
    ],
    "biopsies": [
        "biopsy",
        "biopsie"
    ],
    "biorythme": [
        "biorythme"
    ],
    "biorythmes": [
        "biorythme"
    ],
    "biosphere": [
        "biosphere"
    ],
    "biosynthetiques": [
        "biosynthetique"
    ],
    "biotechnique": [
        "biotechnique"
    ],
    "biotechnologie": [
        "biotechnologie"
    ],
    "biotique": [
        "biotique"
    ],
    "biotite": [
        "biotite"
    ],
    "biotope": [
        "biotope"
    ],
    "bioxyde": [
        "bioxyde"
    ],
    "bioelectrique": [
        "bioelectrique"
    ],
    "bip": [
        "bip"
    ],
    "bipais": [
        "biper"
    ],
    "bipartisan": [
        "bipartisan"
    ],
    "bipartisme": [
        "bipartisme"
    ],
    "bipartite": [
        "bipartite"
    ],
    "bipe": [
        "biper"
    ],
    "biper": [
        "biper"
    ],
    "biperai": [
        "biper"
    ],
    "biperait": [
        "biper"
    ],
    "bipes": [
        "biper"
    ],
    "bipez": [
        "biper"
    ],
    "biphenyle": [
        "biphenyle"
    ],
    "biplace": [
        "biplace"
    ],
    "biplaces": [
        "biplace"
    ],
    "biplan": [
        "biplan"
    ],
    "biplans": [
        "biplan"
    ],
    "bipolaire": [
        "bipolaire"
    ],
    "bipolaires": [
        "bipolaire"
    ],
    "bipolarite": [
        "bipolarite"
    ],
    "bips": [
        "bip"
    ],
    "bipede": [
        "bipede"
    ],
    "bipedes": [
        "bipede"
    ],
    "bipee": [
        "biper"
    ],
    "bique": [
        "bique"
    ],
    "biques": [
        "bique"
    ],
    "biquet": [
        "biquet"
    ],
    "biquets": [
        "biquet"
    ],
    "biquette": [
        "biquette"
    ],
    "biquettes": [
        "biquette"
    ],
    "biquotidienne": [
        "biquotidien"
    ],
    "biquotidiens": [
        "biquotidien"
    ],
    "birbe": [
        "birbe"
    ],
    "birbes": [
        "birbe"
    ],
    "birchers": [
        "bircher"
    ],
    "bire": [
        "bire"
    ],
    "biribi": [
        "biribi"
    ],
    "birman": [
        "birman"
    ],
    "birmane": [
        "birman"
    ],
    "birmanes": [
        "birman"
    ],
    "birmans": [
        "birman"
    ],
    "biroute": [
        "biroute"
    ],
    "biroutes": [
        "biroute"
    ],
    "birefringence": [
        "birefringence"
    ],
    "bis": [
        "bis"
    ],
    "bisannuel": [
        "bisannuel"
    ],
    "bisannuelles": [
        "bisannuel"
    ],
    "bisaieul": [
        "bisaieul"
    ],
    "bisaieule": [
        "bisaieul"
    ],
    "bisbille": [
        "bisbille"
    ],
    "bisbilles": [
        "bisbille"
    ],
    "biscaien": [
        "biscaien"
    ],
    "bischof": [
        "bischof"
    ],
    "biscornu": [
        "biscornu"
    ],
    "biscornue": [
        "biscornu"
    ],
    "biscornues": [
        "biscornu"
    ],
    "biscornus": [
        "biscornu"
    ],
    "biscoteaux": [
        "biscoteau"
    ],
    "biscotos": [
        "biscoto"
    ],
    "biscotte": [
        "biscotte"
    ],
    "biscottes": [
        "biscotte"
    ],
    "biscuit": [
        "biscuit"
    ],
    "biscuiterie": [
        "biscuiterie"
    ],
    "biscuits": [
        "biscuit"
    ],
    "bise": [
        "biser",
        "bise"
    ],
    "biseau": [
        "biseau"
    ],
    "biseaute": [
        "biseauter"
    ],
    "biseautee": [
        "biseauter"
    ],
    "biseautees": [
        "biseauter"
    ],
    "biseautes": [
        "biseauter"
    ],
    "biseaux": [
        "biseau"
    ],
    "biseness": [
        "biseness"
    ],
    "biser": [
        "biser"
    ],
    "bises": [
        "bis",
        "bise",
        "biser"
    ],
    "bisets": [
        "biset"
    ],
    "bisette": [
        "bisette"
    ],
    "bisexualite": [
        "bisexualite"
    ],
    "bisexuel": [
        "bisexuel"
    ],
    "bisexuelle": [
        "bisexuel"
    ],
    "bisexuelles": [
        "bisexuel"
    ],
    "bisexuels": [
        "bisexuel"
    ],
    "bisexue": [
        "bisexue"
    ],
    "bisexues": [
        "bisexue"
    ],
    "bishop": [
        "bishop"
    ],
    "bismarckien": [
        "bismarckien"
    ],
    "bismuth": [
        "bismuth"
    ],
    "bisness": [
        "bisness"
    ],
    "bison": [
        "bison"
    ],
    "bisons": [
        "bison"
    ],
    "bisou": [
        "bisou"
    ],
    "bisous": [
        "bisou"
    ],
    "bisque": [
        "bisquer",
        "bisque"
    ],
    "bisquent": [
        "bisquer"
    ],
    "bisquer": [
        "bisquer"
    ],
    "bisques": [
        "bisque"
    ],
    "bissac": [
        "bissac"
    ],
    "bissacs": [
        "bissac"
    ],
    "bissant": [
        "bisser"
    ],
    "bisse": [
        "bisser"
    ],
    "bissel": [
        "bissel"
    ],
    "bisser": [
        "bisser"
    ],
    "bissextile": [
        "bissextile"
    ],
    "bissextiles": [
        "bissextile"
    ],
    "bistorte": [
        "bistorte"
    ],
    "bistouille": [
        "bistouille"
    ],
    "bistouquette": [
        "bistouquette"
    ],
    "bistouri": [
        "bistouri"
    ],
    "bistouris": [
        "bistouri"
    ],
    "bistouriser": [
        "bistouriser"
    ],
    "bistre": [
        "bistre",
        "bistrer"
    ],
    "bistres": [
        "bistre",
        "bistrer"
    ],
    "bistro": [
        "bistro"
    ],
    "bistroquet": [
        "bistroquet"
    ],
    "bistros": [
        "bistro"
    ],
    "bistrot": [
        "bistrot"
    ],
    "bistrote": [
        "bistrot"
    ],
    "bistrotier": [
        "bistrotier"
    ],
    "bistrotiers": [
        "bistrotier"
    ],
    "bistrotiere": [
        "bistrotier"
    ],
    "bistrotieres": [
        "bistrotier"
    ],
    "bistrots": [
        "bistrot"
    ],
    "bistrouille": [
        "bistrouille"
    ],
    "bistree": [
        "bistre",
        "bistrer"
    ],
    "bistrees": [
        "bistrer"
    ],
    "bisulfite": [
        "bisulfite"
    ],
    "bit": [
        "bite",
        "bit"
    ],
    "bite": [
        "biter",
        "bite"
    ],
    "bitent": [
        "biter"
    ],
    "bites": [
        "bite"
    ],
    "bithynien": [
        "bithynien"
    ],
    "bithyniens": [
        "bithynien"
    ],
    "bitoniau": [
        "bitoniau"
    ],
    "bitos": [
        "bitos"
    ],
    "bits": [
        "bit"
    ],
    "bitte": [
        "bitte"
    ],
    "bitter": [
        "bitter"
    ],
    "bitters": [
        "bitter"
    ],
    "bittes": [
        "bitte"
    ],
    "bitume": [
        "bitumer",
        "bitume"
    ],
    "bitumes": [
        "bitume"
    ],
    "bitumeuse": [
        "bitumeux"
    ],
    "bitumeux": [
        "bitumeux"
    ],
    "bitumineuse": [
        "bitumineux"
    ],
    "bitumineux": [
        "bitumineux"
    ],
    "bitumee": [
        "bitumer"
    ],
    "bitumees": [
        "bitumer"
    ],
    "biture": [
        "biturer",
        "biture"
    ],
    "biturer": [
        "biturer"
    ],
    "bitures": [
        "biturer",
        "biture"
    ],
    "biturin": [
        "biturin"
    ],
    "biturins": [
        "biturin"
    ],
    "bivalente": [
        "bivalent"
    ],
    "bivalve": [
        "bivalve"
    ],
    "bivalves": [
        "bivalve"
    ],
    "bivouac": [
        "bivouac"
    ],
    "bivouacs": [
        "bivouac"
    ],
    "bivouaquaient": [
        "bivouaquer"
    ],
    "bivouaquait": [
        "bivouaquer"
    ],
    "bivouaque": [
        "bivouaquer"
    ],
    "bivouaquent": [
        "bivouaquer"
    ],
    "bivouaquer": [
        "bivouaquer"
    ],
    "bivouaquerons": [
        "bivouaquer"
    ],
    "bivouaquons": [
        "bivouaquer"
    ],
    "bivouaquee": [
        "bivouaquer"
    ],
    "bizarde": [
        "bizarde"
    ],
    "bizarre": [
        "bizarre"
    ],
    "bizarrement": [
        "bizarrement"
    ],
    "bizarrerie": [
        "bizarrerie"
    ],
    "bizarreries": [
        "bizarrerie"
    ],
    "bizarres": [
        "bizarre"
    ],
    "bizarroide": [
        "bizarroide"
    ],
    "bizarroides": [
        "bizarroide"
    ],
    "bizness": [
        "bizness"
    ],
    "bizou": [
        "bizou"
    ],
    "bizut": [
        "bizut"
    ],
    "bizutage": [
        "bizutage"
    ],
    "bizutages": [
        "bizutage"
    ],
    "bizuter": [
        "bizuter"
    ],
    "bizuteurs": [
        "bizuteur"
    ],
    "bizuth": [
        "bizuth"
    ],
    "bizuts": [
        "bizut"
    ],
    "bizute": [
        "bizuter"
    ],
    "biere": [
        "biere"
    ],
    "bieres": [
        "biere"
    ],
    "blabla": [
        "blabla"
    ],
    "blablabla": [
        "blablabla"
    ],
    "blablatait": [
        "blablater"
    ],
    "blablater": [
        "blablater"
    ],
    "blablateurs": [
        "blablateur"
    ],
    "blablatez": [
        "blablater"
    ],
    "blablate": [
        "blablater"
    ],
    "black": [
        "black"
    ],
    "blackboule": [
        "blackbouler"
    ],
    "blackbouler": [
        "blackbouler"
    ],
    "blacks": [
        "black"
    ],
    "blafard": [
        "blafard"
    ],
    "blafarde": [
        "blafard"
    ],
    "blafardes": [
        "blafard"
    ],
    "blafards": [
        "blafard"
    ],
    "blagua": [
        "blaguer"
    ],
    "blaguaient": [
        "blaguer"
    ],
    "blaguais": [
        "blaguer"
    ],
    "blaguait": [
        "blaguer"
    ],
    "blaguant": [
        "blaguer"
    ],
    "blague": [
        "blague",
        "blaguer"
    ],
    "blaguent": [
        "blaguer"
    ],
    "blaguer": [
        "blaguer"
    ],
    "blaguerais": [
        "blaguer"
    ],
    "blagues": [
        "blague",
        "blaguer"
    ],
    "blagueur": [
        "blagueur"
    ],
    "blagueurs": [
        "blagueur"
    ],
    "blagueuse": [
        "blagueur"
    ],
    "blagueuses": [
        "blagueur"
    ],
    "blaguez": [
        "blaguer"
    ],
    "blaguons": [
        "blaguer"
    ],
    "blair": [
        "blair"
    ],
    "blairaient": [
        "blairer"
    ],
    "blairait": [
        "blairer"
    ],
    "blaire": [
        "blairer"
    ],
    "blaireau": [
        "blaireau"
    ],
    "blaireaux": [
        "blaireau"
    ],
    "blairer": [
        "blairer"
    ],
    "blairs": [
        "blair"
    ],
    "blaise": [
        "blaiser"
    ],
    "blaisois": [
        "blaisois"
    ],
    "blanc": [
        "blanc"
    ],
    "blanche": [
        "blanc",
        "blanche"
    ],
    "blanchecaille": [
        "blanchecaille"
    ],
    "blanchecailles": [
        "blanchecaille"
    ],
    "blanchement": [
        "blanchement"
    ],
    "blanches": [
        "blanc",
        "blanche"
    ],
    "blanchet": [
        "blanchet"
    ],
    "blancheur": [
        "blancheur"
    ],
    "blancheurs": [
        "blancheur"
    ],
    "blanchi": [
        "blanchir",
        "blanchi"
    ],
    "blanchie": [
        "blanchir",
        "blanchi"
    ],
    "blanchies": [
        "blanchir",
        "blanchi"
    ],
    "blanchiment": [
        "blanchiment"
    ],
    "blanchiments": [
        "blanchiment"
    ],
    "blanchir": [
        "blanchir"
    ],
    "blanchira": [
        "blanchir"
    ],
    "blanchiraient": [
        "blanchir"
    ],
    "blanchirait": [
        "blanchir"
    ],
    "blanchirent": [
        "blanchir"
    ],
    "blanchirez": [
        "blanchir"
    ],
    "blanchiront": [
        "blanchir"
    ],
    "blanchis": [
        "blanchir",
        "blanchi"
    ],
    "blanchissage": [
        "blanchissage"
    ],
    "blanchissaient": [
        "blanchir"
    ],
    "blanchissait": [
        "blanchir"
    ],
    "blanchissant": [
        "blanchir",
        "blanchissant"
    ],
    "blanchissante": [
        "blanchissant"
    ],
    "blanchissantes": [
        "blanchissant"
    ],
    "blanchissants": [
        "blanchissant"
    ],
    "blanchisse": [
        "blanchir"
    ],
    "blanchissement": [
        "blanchissement"
    ],
    "blanchissent": [
        "blanchir"
    ],
    "blanchisserie": [
        "blanchisserie"
    ],
    "blanchisses": [
        "blanchir"
    ],
    "blanchisseur": [
        "blanchisseur"
    ],
    "blanchisseurs": [
        "blanchisseur"
    ],
    "blanchisseuse": [
        "blanchisseur"
    ],
    "blanchisseuses": [
        "blanchisseur"
    ],
    "blanchissez": [
        "blanchir"
    ],
    "blanchit": [
        "blanchir"
    ],
    "blanchoie": [
        "blanchoyer"
    ],
    "blanchoiement": [
        "blanchoiement"
    ],
    "blanchon": [
        "blanchon"
    ],
    "blanchoyait": [
        "blanchoyer"
    ],
    "blanchoyant": [
        "blanchoyer"
    ],
    "blanchatre": [
        "blanchatre"
    ],
    "blanchatres": [
        "blanchatre"
    ],
    "blancs": [
        "blanc"
    ],
    "blandices": [
        "blandice"
    ],
    "blanque": [
        "blanque"
    ],
    "blanquette": [
        "blanquette"
    ],
    "blanquettes": [
        "blanquette"
    ],
    "blasait": [
        "blaser"
    ],
    "blase": [
        "blase",
        "blaser"
    ],
    "blaser": [
        "blaser"
    ],
    "blases": [
        "blase",
        "blaser"
    ],
    "blason": [
        "blason"
    ],
    "blasonnait": [
        "blasonner"
    ],
    "blasonne": [
        "blasonner"
    ],
    "blasonnee": [
        "blasonner"
    ],
    "blasonnees": [
        "blasonner"
    ],
    "blasonnes": [
        "blasonner"
    ],
    "blasons": [
        "blason"
    ],
    "blaspheme": [
        "blasphemer",
        "blaspheme"
    ],
    "blasphement": [
        "blasphemer"
    ],
    "blasphemes": [
        "blasphemer",
        "blaspheme"
    ],
    "blasphema": [
        "blasphemer"
    ],
    "blasphemaient": [
        "blasphemer"
    ],
    "blasphemais": [
        "blasphemer"
    ],
    "blasphemait": [
        "blasphemer"
    ],
    "blasphemant": [
        "blasphemer"
    ],
    "blasphemateur": [
        "blasphemateur"
    ],
    "blasphemateurs": [
        "blasphemateur"
    ],
    "blasphematoire": [
        "blasphematoire"
    ],
    "blasphematoires": [
        "blasphematoire"
    ],
    "blasphematrice": [
        "blasphemateur"
    ],
    "blasphemer": [
        "blasphemer"
    ],
    "blasphemez": [
        "blasphemer"
    ],
    "blastula": [
        "blastula"
    ],
    "blasee": [
        "blase",
        "blaser"
    ],
    "blasees": [
        "blase",
        "blaser"
    ],
    "blatte": [
        "blatte"
    ],
    "blattes": [
        "blatte"
    ],
    "blaterant": [
        "blaterer"
    ],
    "blaze": [
        "blaze"
    ],
    "blazer": [
        "blazer"
    ],
    "blazers": [
        "blazer"
    ],
    "blazes": [
        "blaze"
    ],
    "bled": [
        "bleed",
        "bled"
    ],
    "bleds": [
        "bled"
    ],
    "blennies": [
        "blennie"
    ],
    "blennorragie": [
        "blennorragie"
    ],
    "blessa": [
        "blesser"
    ],
    "blessaient": [
        "blesser"
    ],
    "blessais": [
        "blesser"
    ],
    "blessait": [
        "blesser"
    ],
    "blessant": [
        "blesser",
        "blessant"
    ],
    "blessante": [
        "blessant"
    ],
    "blessantes": [
        "blessant"
    ],
    "blessants": [
        "blessant"
    ],
    "blesse": [
        "blesser",
        "blesse"
    ],
    "blessent": [
        "blesser"
    ],
    "blesser": [
        "blesser"
    ],
    "blessera": [
        "blesser"
    ],
    "blesserai": [
        "blesser"
    ],
    "blesseraient": [
        "blesser"
    ],
    "blesserais": [
        "blesser"
    ],
    "blesserait": [
        "blesser"
    ],
    "blesseras": [
        "blesser"
    ],
    "blesserez": [
        "blesser"
    ],
    "blesseriez": [
        "blesser"
    ],
    "blesserons": [
        "blesser"
    ],
    "blesseront": [
        "blesser"
    ],
    "blesses": [
        "bless",
        "blesser",
        "blesse"
    ],
    "blessez": [
        "blesser"
    ],
    "blessiez": [
        "blesser"
    ],
    "blessing": [
        "blessing",
        "bless"
    ],
    "blessure": [
        "blessure"
    ],
    "blessures": [
        "blessure"
    ],
    "blessat": [
        "blesser"
    ],
    "blesserent": [
        "blesser"
    ],
    "blessee": [
        "blesser",
        "blesse"
    ],
    "blessees": [
        "blesser",
        "blesse"
    ],
    "blet": [
        "blet"
    ],
    "blets": [
        "blet"
    ],
    "blette": [
        "blet"
    ],
    "blettes": [
        "blette",
        "blet"
    ],
    "blettir": [
        "blettir"
    ],
    "blettissait": [
        "blettir"
    ],
    "blettissement": [
        "blettissement"
    ],
    "bleu": [
        "bleu"
    ],
    "bleubite": [
        "bleubite"
    ],
    "bleubites": [
        "bleubite"
    ],
    "bleue": [
        "bleu"
    ],
    "bleues": [
        "bleu"
    ],
    "bleuet": [
        "bleuet"
    ],
    "bleuets": [
        "bleuet"
    ],
    "bleuette": [
        "bleuette"
    ],
    "bleui": [
        "bleuir",
        "bleui"
    ],
    "bleuie": [
        "bleuir",
        "bleui"
    ],
    "bleuies": [
        "bleuir",
        "bleui"
    ],
    "bleuir": [
        "bleuir"
    ],
    "bleuira": [
        "bleuir"
    ],
    "bleuis": [
        "bleuir",
        "bleui"
    ],
    "bleuissaient": [
        "bleuir"
    ],
    "bleuissait": [
        "bleuir"
    ],
    "bleuissante": [
        "bleuissant"
    ],
    "bleuissantes": [
        "bleuissant"
    ],
    "bleuissent": [
        "bleuir"
    ],
    "bleuit": [
        "bleuir"
    ],
    "bleus": [
        "bleu"
    ],
    "bleusaille": [
        "bleusaille"
    ],
    "bleusailles": [
        "bleusaille"
    ],
    "bleute": [
        "bleuter",
        "bleute"
    ],
    "bleutee": [
        "bleuter",
        "bleute"
    ],
    "bleutees": [
        "bleuter",
        "bleute"
    ],
    "bleutes": [
        "bleuter",
        "bleute"
    ],
    "bleuatre": [
        "bleuatre"
    ],
    "bleuatres": [
        "bleuatre"
    ],
    "bliaut": [
        "bliaut"
    ],
    "blindage": [
        "blindage"
    ],
    "blindages": [
        "blindage"
    ],
    "blindant": [
        "blinder"
    ],
    "blinde": [
        "blinde",
        "blinder"
    ],
    "blindent": [
        "blinder"
    ],
    "blinder": [
        "blind",
        "blinder"
    ],
    "blindera": [
        "blinder"
    ],
    "blindes": [
        "blinde",
        "blinder"
    ],
    "blindez": [
        "blinder"
    ],
    "blindee": [
        "blinde",
        "blinder"
    ],
    "blindees": [
        "blinde",
        "blinder"
    ],
    "blini": [
        "blini"
    ],
    "blinis": [
        "blini"
    ],
    "blitzkrieg": [
        "blitzkrieg"
    ],
    "blizzard": [
        "blizzard"
    ],
    "blizzards": [
        "blizzard"
    ],
    "blob": [
        "blob"
    ],
    "bloc": [
        "bloc"
    ],
    "blocage": [
        "blocage"
    ],
    "blocages": [
        "blocage"
    ],
    "blocaille": [
        "blocaille"
    ],
    "block": [
        "block"
    ],
    "blockhaus": [
        "blockhaus"
    ],
    "blocks": [
        "block"
    ],
    "blocs": [
        "bloc"
    ],
    "blocus": [
        "blocus"
    ],
    "blond": [
        "blond"
    ],
    "blondasse": [
        "blondasse"
    ],
    "blondasses": [
        "blondasse"
    ],
    "blonde": [
        "blond"
    ],
    "blondes": [
        "blond",
        "blonde"
    ],
    "blondeur": [
        "blondeur"
    ],
    "blondeurs": [
        "blondeur"
    ],
    "blondi": [
        "blondir"
    ],
    "blondie": [
        "blondir"
    ],
    "blondin": [
        "blondin"
    ],
    "blondine": [
        "blondin"
    ],
    "blondines": [
        "blondin"
    ],
    "blondinet": [
        "blondinet"
    ],
    "blondinets": [
        "blondinet"
    ],
    "blondinette": [
        "blondinet"
    ],
    "blondir": [
        "blondir"
    ],
    "blondis": [
        "blondir"
    ],
    "blondissait": [
        "blondir"
    ],
    "blondit": [
        "blondir"
    ],
    "blonds": [
        "blond"
    ],
    "bloom": [
        "bloom"
    ],
    "bloomer": [
        "bloomer"
    ],
    "bloqua": [
        "bloquer"
    ],
    "bloquai": [
        "bloquer"
    ],
    "bloquaient": [
        "bloquer"
    ],
    "bloquais": [
        "bloquer"
    ],
    "bloquait": [
        "bloquer"
    ],
    "bloquant": [
        "bloquer",
        "bloquant"
    ],
    "bloque": [
        "bloque",
        "bloquer"
    ],
    "bloquent": [
        "bloquer"
    ],
    "bloquer": [
        "bloquer"
    ],
    "bloquera": [
        "bloquer"
    ],
    "bloquerai": [
        "bloquer"
    ],
    "bloquerais": [
        "bloquer"
    ],
    "bloquerait": [
        "bloquer"
    ],
    "bloqueront": [
        "bloquer"
    ],
    "bloques": [
        "bloque",
        "bloquer"
    ],
    "bloqueur": [
        "bloqueur"
    ],
    "bloqueurs": [
        "bloqueur"
    ],
    "bloquez": [
        "bloquer"
    ],
    "bloquiez": [
        "bloquer"
    ],
    "bloquons": [
        "bloquer"
    ],
    "bloquat": [
        "bloquer"
    ],
    "bloquerent": [
        "bloquer"
    ],
    "bloquee": [
        "bloque",
        "bloquer"
    ],
    "bloquees": [
        "bloque",
        "bloquer"
    ],
    "blot": [
        "blot"
    ],
    "blots": [
        "blot"
    ],
    "blotti": [
        "blottir",
        "blotti"
    ],
    "blottie": [
        "blottir",
        "blotti"
    ],
    "blotties": [
        "blottir",
        "blotti"
    ],
    "blottir": [
        "blottir"
    ],
    "blottirai": [
        "blottir"
    ],
    "blottirait": [
        "blottir"
    ],
    "blottirent": [
        "blottir"
    ],
    "blottis": [
        "blottir",
        "blotti"
    ],
    "blottissaient": [
        "blottir"
    ],
    "blottissais": [
        "blottir"
    ],
    "blottissait": [
        "blottir"
    ],
    "blottissant": [
        "blottir"
    ],
    "blottisse": [
        "blottir"
    ],
    "blottissement": [
        "blottissement"
    ],
    "blottissent": [
        "blottir"
    ],
    "blottissions": [
        "blottir"
    ],
    "blottit": [
        "blottir"
    ],
    "bloum": [
        "bloum"
    ],
    "blousantes": [
        "blousant"
    ],
    "blouse": [
        "blouse",
        "blouser"
    ],
    "blousent": [
        "blouser"
    ],
    "blouser": [
        "blouser"
    ],
    "blouses": [
        "blouse",
        "blouser"
    ],
    "blouson": [
        "blouson"
    ],
    "blousons": [
        "blouson"
    ],
    "blousee": [
        "blouser"
    ],
    "blues": [
        "blues",
        "blue"
    ],
    "bluets": [
        "bluet"
    ],
    "bluette": [
        "bluette"
    ],
    "bluettes": [
        "bluette"
    ],
    "bluff": [
        "bluff"
    ],
    "bluffa": [
        "bluffer"
    ],
    "bluffaient": [
        "bluffer"
    ],
    "bluffais": [
        "bluffer"
    ],
    "bluffait": [
        "bluffer"
    ],
    "bluffant": [
        "bluffer"
    ],
    "bluffe": [
        "bluffer"
    ],
    "bluffent": [
        "bluffer"
    ],
    "bluffer": [
        "bluff",
        "bluffer"
    ],
    "blufferais": [
        "bluffer"
    ],
    "blufferez": [
        "bluffer"
    ],
    "bluffes": [
        "bluffer"
    ],
    "bluffeur": [
        "bluffeur"
    ],
    "bluffeurs": [
        "bluffeur"
    ],
    "bluffeuses": [
        "bluffeur"
    ],
    "bluffez": [
        "bluffer"
    ],
    "bluffiez": [
        "bluffer"
    ],
    "bluffons": [
        "bluffer"
    ],
    "bluffs": [
        "bluff"
    ],
    "bluffee": [
        "bluffer"
    ],
    "bluffees": [
        "bluffer"
    ],
    "blush": [
        "blush"
    ],
    "bluter": [
        "bluter"
    ],
    "blutoir": [
        "blutoir"
    ],
    "blama": [
        "blamer"
    ],
    "blamable": [
        "blamable"
    ],
    "blamaient": [
        "blamer"
    ],
    "blamais": [
        "blamer"
    ],
    "blamait": [
        "blamer"
    ],
    "blamant": [
        "blamer"
    ],
    "blame": [
        "blame",
        "blamer"
    ],
    "blament": [
        "blamer"
    ],
    "blamer": [
        "blamer"
    ],
    "blamera": [
        "blamer"
    ],
    "blamerais": [
        "blamer"
    ],
    "blamerait": [
        "blamer"
    ],
    "blameras": [
        "blamer"
    ],
    "blamerions": [
        "blamer"
    ],
    "blameront": [
        "blamer"
    ],
    "blames": [
        "blame",
        "blamer"
    ],
    "blamez": [
        "blamer"
    ],
    "blamons": [
        "blamer"
    ],
    "blamee": [
        "blamer"
    ],
    "blamees": [
        "blamer"
    ],
    "bleche": [
        "bleche"
    ],
    "bleches": [
        "bleche"
    ],
    "blesement": [
        "blesement"
    ],
    "ble": [
        "ble"
    ],
    "bledard": [
        "bledard"
    ],
    "bledards": [
        "bledard"
    ],
    "blepharite": [
        "blepharite"
    ],
    "bles": [
        "ble"
    ],
    "bleme": [
        "bleme"
    ],
    "blemes": [
        "bleme"
    ],
    "blemi": [
        "blemir"
    ],
    "blemies": [
        "blemir"
    ],
    "blemir": [
        "blemir"
    ],
    "blemis": [
        "blemir"
    ],
    "blemissais": [
        "blemir"
    ],
    "blemissait": [
        "blemir"
    ],
    "blemissant": [
        "blemir"
    ],
    "blemissante": [
        "blemissant"
    ],
    "blemit": [
        "blemir"
    ],
    "boa": [
        "boa"
    ],
    "boas": [
        "boa"
    ],
    "bob": [
        "bob"
    ],
    "bobard": [
        "bobard"
    ],
    "bobards": [
        "bobard"
    ],
    "bobbies": [
        "bobby",
        "bobbies"
    ],
    "bobby": [
        "bobby"
    ],
    "bobinage": [
        "bobinage"
    ],
    "bobinait": [
        "bobiner"
    ],
    "bobinard": [
        "bobinard"
    ],
    "bobinards": [
        "bobinard"
    ],
    "bobine": [
        "bobiner",
        "bobine"
    ],
    "bobineau": [
        "bobineau"
    ],
    "bobines": [
        "bobiner",
        "bobine"
    ],
    "bobinette": [
        "bobinette"
    ],
    "bobinettes": [
        "bobinette"
    ],
    "bobineuse": [
        "bobineur"
    ],
    "bobineuses": [
        "bobineur"
    ],
    "bobino": [
        "bobino"
    ],
    "bobo": [
        "bobo"
    ],
    "bobonne": [
        "bobonne"
    ],
    "bobonnes": [
        "bobonne"
    ],
    "bobos": [
        "bobo"
    ],
    "bobosse": [
        "bobosse"
    ],
    "bobs": [
        "bob"
    ],
    "bobsleigh": [
        "bobsleigh"
    ],
    "bobeche": [
        "bobeche"
    ],
    "bobeches": [
        "bobeche"
    ],
    "boc": [
        "boc"
    ],
    "bocage": [
        "bocage"
    ],
    "bocages": [
        "bocage"
    ],
    "bocageres": [
        "bocager"
    ],
    "bocal": [
        "bocal"
    ],
    "bocard": [
        "bocard"
    ],
    "bocaux": [
        "bocal"
    ],
    "boche": [
        "boche"
    ],
    "boches": [
        "boche"
    ],
    "bochiman": [
        "bochiman"
    ],
    "bock": [
        "bock"
    ],
    "bocks": [
        "bock"
    ],
    "bocson": [
        "bocson"
    ],
    "bodega": [
        "bodega"
    ],
    "bodegas": [
        "bodega"
    ],
    "bodhi": [
        "bodhi"
    ],
    "bodhisattva": [
        "bodhisattva"
    ],
    "bodo": [
        "bodo"
    ],
    "body": [
        "body"
    ],
    "bodybuilding": [
        "bodybuilding"
    ],
    "boer": [
        "boer"
    ],
    "boers": [
        "boer"
    ],
    "boeuf": [
        "boeuf"
    ],
    "boeufs": [
        "boeuf"
    ],
    "bof": [
        "bof"
    ],
    "boggie": [
        "boggie"
    ],
    "boggies": [
        "boggie"
    ],
    "boghei": [
        "boghei"
    ],
    "bogie": [
        "bogie"
    ],
    "bogomiles": [
        "bogomile"
    ],
    "bogue": [
        "boguer",
        "bogue"
    ],
    "boguer": [
        "boguer"
    ],
    "bogues": [
        "bogue"
    ],
    "boguet": [
        "boguet"
    ],
    "boheme": [
        "boheme"
    ],
    "bohemes": [
        "boheme"
    ],
    "bohemien": [
        "bohemien"
    ],
    "bohemienne": [
        "bohemien"
    ],
    "bohemiennes": [
        "bohemien"
    ],
    "bohemiens": [
        "bohemien"
    ],
    "boira": [
        "boire"
    ],
    "boirai": [
        "boire"
    ],
    "boiraient": [
        "boire"
    ],
    "boirais": [
        "boire"
    ],
    "boirait": [
        "boire"
    ],
    "boiras": [
        "boire"
    ],
    "boire": [
        "boire"
    ],
    "boirez": [
        "boire"
    ],
    "boiriez": [
        "boire"
    ],
    "boirions": [
        "boire"
    ],
    "boirons": [
        "boire"
    ],
    "boiront": [
        "boire"
    ],
    "bois": [
        "boire",
        "bois"
    ],
    "boisaient": [
        "boiser"
    ],
    "boisait": [
        "boiser"
    ],
    "boisant": [
        "boiser"
    ],
    "boise": [
        "boise",
        "boiser"
    ],
    "boiserie": [
        "boiserie"
    ],
    "boiseries": [
        "boiserie"
    ],
    "boiseur": [
        "boiseur"
    ],
    "boisseau": [
        "boisseau"
    ],
    "boisseaux": [
        "boisseau"
    ],
    "boisselier": [
        "boisselier"
    ],
    "boisson": [
        "boisson"
    ],
    "boissonnee": [
        "boissonner"
    ],
    "boissons": [
        "boisson"
    ],
    "boisee": [
        "boise",
        "boiser"
    ],
    "boisees": [
        "boise",
        "boiser"
    ],
    "boises": [
        "boise",
        "boiser"
    ],
    "boit": [
        "boire"
    ],
    "boitaient": [
        "boiter"
    ],
    "boitais": [
        "boiter"
    ],
    "boitait": [
        "boiter"
    ],
    "boitant": [
        "boiter"
    ],
    "boite": [
        "boiter",
        "boite"
    ],
    "boitement": [
        "boitement"
    ],
    "boitent": [
        "boiter"
    ],
    "boiter": [
        "boiter"
    ],
    "boitera": [
        "boiter"
    ],
    "boiterai": [
        "boiter"
    ],
    "boiteraient": [
        "boiter"
    ],
    "boiterait": [
        "boiter"
    ],
    "boiteras": [
        "boiter"
    ],
    "boiterie": [
        "boiterie"
    ],
    "boites": [
        "boiter",
        "boite"
    ],
    "boiteuse": [
        "boiteux"
    ],
    "boiteuses": [
        "boiteux"
    ],
    "boiteux": [
        "boiteux"
    ],
    "boitez": [
        "boiter"
    ],
    "boitiez": [
        "boiter"
    ],
    "boitillait": [
        "boitiller"
    ],
    "boitillant": [
        "boitillant",
        "boitiller"
    ],
    "boitille": [
        "boitiller"
    ],
    "boitillement": [
        "boitillement"
    ],
    "boitillements": [
        "boitillement"
    ],
    "boitiller": [
        "boitiller"
    ],
    "boive": [
        "boire"
    ],
    "boivent": [
        "boire"
    ],
    "boives": [
        "boire"
    ],
    "bol": [
        "bol"
    ],
    "bola": [
        "bola"
    ],
    "bolas": [
        "bola"
    ],
    "bolchevik": [
        "bolchevik"
    ],
    "bolcheviks": [
        "bolchevik"
    ],
    "bolchevique": [
        "bolchevique"
    ],
    "bolcheviques": [
        "bolchevique"
    ],
    "bolchevisme": [
        "bolchevisme"
    ],
    "bolcheviste": [
        "bolcheviste"
    ],
    "bolchevistes": [
        "bolcheviste"
    ],
    "bolcho": [
        "bolcho"
    ],
    "bold": [
        "bold"
    ],
    "boldo": [
        "boldo"
    ],
    "bolduc": [
        "bolduc"
    ],
    "bolet": [
        "bolet"
    ],
    "bolets": [
        "bolet"
    ],
    "bolge": [
        "bolge"
    ],
    "bolide": [
        "bolide"
    ],
    "bolides": [
        "bolide"
    ],
    "bolivar": [
        "bolivar"
    ],
    "bolivien": [
        "bolivien"
    ],
    "bolivienne": [
        "bolivien"
    ],
    "boliviens": [
        "bolivien"
    ],
    "bolognais": [
        "bolognais"
    ],
    "bolognaise": [
        "bolognais"
    ],
    "bolognaises": [
        "bolognais"
    ],
    "bolonaise": [
        "bolonais"
    ],
    "bols": [
        "bol"
    ],
    "bolee": [
        "bolee"
    ],
    "bolees": [
        "bolee"
    ],
    "bolero": [
        "bolero"
    ],
    "boleros": [
        "bolero"
    ],
    "bomba": [
        "bomber"
    ],
    "bombage": [
        "bombage"
    ],
    "bombaient": [
        "bomber"
    ],
    "bombais": [
        "bomber"
    ],
    "bombait": [
        "bomber"
    ],
    "bombance": [
        "bombance"
    ],
    "bombances": [
        "bombance"
    ],
    "bombant": [
        "bomber"
    ],
    "bombarda": [
        "bombarder"
    ],
    "bombardaient": [
        "bombarder"
    ],
    "bombardais": [
        "bombarder"
    ],
    "bombardait": [
        "bombarder"
    ],
    "bombardant": [
        "bombarder"
    ],
    "bombarde": [
        "bombarder",
        "bombarde"
    ],
    "bombardement": [
        "bombardement"
    ],
    "bombardements": [
        "bombardement"
    ],
    "bombardent": [
        "bombarder"
    ],
    "bombarder": [
        "bombarder"
    ],
    "bombardera": [
        "bombarder"
    ],
    "bombarderai": [
        "bombarder"
    ],
    "bombarderaient": [
        "bombarder"
    ],
    "bombarderais": [
        "bombarder"
    ],
    "bombarderait": [
        "bombarder"
    ],
    "bombarderons": [
        "bombarder"
    ],
    "bombarderont": [
        "bombarder"
    ],
    "bombardes": [
        "bombarder",
        "bombarde"
    ],
    "bombardez": [
        "bombarder"
    ],
    "bombardier": [
        "bombardier"
    ],
    "bombardiers": [
        "bombardier"
    ],
    "bombardions": [
        "bombarder"
    ],
    "bombardon": [
        "bombardon"
    ],
    "bombardons": [
        "bombarder",
        "bombardon"
    ],
    "bombardames": [
        "bombarder"
    ],
    "bombarderent": [
        "bombarder"
    ],
    "bombardee": [
        "bombarder",
        "bombarde"
    ],
    "bombardees": [
        "bombarder",
        "bombarde"
    ],
    "bombas": [
        "bomber"
    ],
    "bombasses": [
        "bomber"
    ],
    "bombe": [
        "bomber",
        "bombe"
    ],
    "bombements": [
        "bombement"
    ],
    "bombent": [
        "bomber"
    ],
    "bomber": [
        "bomber"
    ],
    "bombes": [
        "bomber",
        "bombe"
    ],
    "bombeur": [
        "bombeur"
    ],
    "bombez": [
        "bomber"
    ],
    "bombillement": [
        "bombillement"
    ],
    "bombinette": [
        "bombinette"
    ],
    "bombinettes": [
        "bombinette"
    ],
    "bombonne": [
        "bombonne"
    ],
    "bombonnes": [
        "bombonne"
    ],
    "bombyx": [
        "bombyx"
    ],
    "bomberent": [
        "bomber"
    ],
    "bombee": [
        "bomber",
        "bombe"
    ],
    "bombees": [
        "bomber",
        "bombe"
    ],
    "bon": [
        "bon"
    ],
    "bonace": [
        "bonace"
    ],
    "bonaces": [
        "bonace"
    ],
    "bonapartiste": [
        "bonapartiste"
    ],
    "bonapartistes": [
        "bonapartiste"
    ],
    "bonard": [
        "bonard"
    ],
    "bonardes": [
        "bonard"
    ],
    "bonasse": [
        "bonasse"
    ],
    "bonassement": [
        "bonassement"
    ],
    "bonasserie": [
        "bonasserie"
    ],
    "bonasses": [
        "bonasse"
    ],
    "bonbon": [
        "bonbon"
    ],
    "bonbonne": [
        "bonbonne"
    ],
    "bonbonnes": [
        "bonbonne"
    ],
    "bonbonniere": [
        "bonbonniere"
    ],
    "bonbonnieres": [
        "bonbonniere"
    ],
    "bonbons": [
        "bonbon"
    ],
    "bond": [
        "bond"
    ],
    "bondage": [
        "bondage"
    ],
    "bondages": [
        "bondage"
    ],
    "bondait": [
        "bonder"
    ],
    "bonde": [
        "bonder",
        "bonde"
    ],
    "bonder": [
        "bonder"
    ],
    "bondes": [
        "bonder",
        "bonde"
    ],
    "bondi": [
        "bondir"
    ],
    "bondieusard": [
        "bondieusard"
    ],
    "bondieuserie": [
        "bondieuserie"
    ],
    "bondieuseries": [
        "bondieuserie"
    ],
    "bondieuses": [
        "bondieuser"
    ],
    "bondir": [
        "bondir"
    ],
    "bondira": [
        "bondir"
    ],
    "bondirais": [
        "bondir"
    ],
    "bondirait": [
        "bondir"
    ],
    "bondirent": [
        "bondir"
    ],
    "bondis": [
        "bondir"
    ],
    "bondissaient": [
        "bondir"
    ],
    "bondissais": [
        "bondir"
    ],
    "bondissait": [
        "bondir"
    ],
    "bondissant": [
        "bondir",
        "bondissant"
    ],
    "bondissante": [
        "bondissant"
    ],
    "bondissantes": [
        "bondissant"
    ],
    "bondissants": [
        "bondissant"
    ],
    "bondisse": [
        "bondir"
    ],
    "bondissement": [
        "bondissement"
    ],
    "bondissements": [
        "bondissement"
    ],
    "bondissent": [
        "bondir"
    ],
    "bondissez": [
        "bondir"
    ],
    "bondissons": [
        "bondir"
    ],
    "bondit": [
        "bondir"
    ],
    "bondree": [
        "bondree"
    ],
    "bonds": [
        "bond"
    ],
    "bondee": [
        "bonder",
        "bonde"
    ],
    "bondees": [
        "bonder",
        "bonde"
    ],
    "bongo": [
        "bongo"
    ],
    "bongos": [
        "bongo"
    ],
    "bonheur": [
        "bonheur"
    ],
    "bonheurs": [
        "bonheur"
    ],
    "bonhomie": [
        "bonhomie"
    ],
    "bonhomme": [
        "bonhomme"
    ],
    "bonhommes": [
        "bonhomme"
    ],
    "boni": [
        "boni"
    ],
    "boniche": [
        "boniche"
    ],
    "boniches": [
        "boniche"
    ],
    "bonifiaient": [
        "bonifier"
    ],
    "bonification": [
        "bonification"
    ],
    "bonifier": [
        "bonifier"
    ],
    "bonifierait": [
        "bonifier"
    ],
    "bonifiez": [
        "bonifier"
    ],
    "bonifie": [
        "bonifier"
    ],
    "bonifiee": [
        "bonifier"
    ],
    "boniment": [
        "boniment"
    ],
    "bonimentait": [
        "bonimenter"
    ],
    "bonimente": [
        "bonimenter"
    ],
    "bonimenter": [
        "bonimenter"
    ],
    "bonimenteur": [
        "bonimenteur"
    ],
    "bonimenteurs": [
        "bonimenteur"
    ],
    "boniments": [
        "boniment"
    ],
    "bonir": [
        "bonir"
    ],
    "bonis": [
        "boni"
    ],
    "bonissait": [
        "bonir"
    ],
    "bonisse": [
        "bonir"
    ],
    "bonit": [
        "bonir"
    ],
    "bonjour": [
        "bonjour"
    ],
    "bonjours": [
        "bonjour"
    ],
    "bonnard": [
        "bonnard"
    ],
    "bonnarde": [
        "bonnard"
    ],
    "bonnardes": [
        "bonnard"
    ],
    "bonnards": [
        "bonnard"
    ],
    "bonne": [
        "bonne",
        "bon"
    ],
    "bonnement": [
        "bonnement"
    ],
    "bonnes": [
        "bonne",
        "bon"
    ],
    "bonnet": [
        "bonnet"
    ],
    "bonneteau": [
        "bonneteau"
    ],
    "bonneter": [
        "bonneter"
    ],
    "bonneterie": [
        "bonneterie"
    ],
    "bonneteries": [
        "bonneterie"
    ],
    "bonneteur": [
        "bonneteur"
    ],
    "bonneteurs": [
        "bonneteur"
    ],
    "bonnets": [
        "bonnet"
    ],
    "bonnette": [
        "bonnette"
    ],
    "bonnettes": [
        "bonnette"
    ],
    "bonni": [
        "bonnir"
    ],
    "bonniche": [
        "bonniche"
    ],
    "bonniches": [
        "bonniche"
    ],
    "bonnie": [
        "bonnir"
    ],
    "bonnir": [
        "bonnir"
    ],
    "bonnis": [
        "bonnir"
    ],
    "bonnisse": [
        "bonnir"
    ],
    "bonnissent": [
        "bonnir"
    ],
    "bonnit": [
        "bonnir"
    ],
    "bons": [
        "bon"
    ],
    "bonsai": [
        "bonsai"
    ],
    "bonsais": [
        "bonsai"
    ],
    "bonshommes": [
        "bonhomme"
    ],
    "bonsoir": [
        "bonsoir"
    ],
    "bonsoirs": [
        "bonsoir"
    ],
    "bonte": [
        "bonte"
    ],
    "bontes": [
        "bonte"
    ],
    "bonus": [
        "bonus"
    ],
    "bonzai": [
        "bonzai"
    ],
    "bonze": [
        "bonze"
    ],
    "bonzes": [
        "bonze"
    ],
    "book": [
        "book"
    ],
    "bookmaker": [
        "bookmaker"
    ],
    "bookmakers": [
        "bookmaker"
    ],
    "books": [
        "book"
    ],
    "boom": [
        "boom"
    ],
    "boomer": [
        "boomer"
    ],
    "boomerang": [
        "boomerang"
    ],
    "booms": [
        "boom"
    ],
    "booster": [
        "booster"
    ],
    "boosters": [
        "booster"
    ],
    "bootlegger": [
        "bootlegger"
    ],
    "bootleggers": [
        "bootlegger"
    ],
    "boots": [
        "boots",
        "boot"
    ],
    "bop": [
        "bop"
    ],
    "boqueteau": [
        "boqueteau"
    ],
    "boqueteaux": [
        "boqueteau"
    ],
    "boquillons": [
        "boquillon"
    ],
    "bora": [
        "bora"
    ],
    "borax": [
        "borax"
    ],
    "borborygme": [
        "borborygme"
    ],
    "borborygmes": [
        "borborygme"
    ],
    "borchtch": [
        "borchtch"
    ],
    "bord": [
        "bord"
    ],
    "borda": [
        "border"
    ],
    "bordage": [
        "bordage"
    ],
    "bordages": [
        "bordage"
    ],
    "bordai": [
        "border"
    ],
    "bordaient": [
        "border"
    ],
    "bordait": [
        "border"
    ],
    "bordant": [
        "border"
    ],
    "borde": [
        "border",
        "borde"
    ],
    "bordeau": [
        "bordeau"
    ],
    "bordeaux": [
        "bordeaux"
    ],
    "bordel": [
        "bordel"
    ],
    "bordelais": [
        "bordelais"
    ],
    "bordelaise": [
        "bordelais"
    ],
    "bordelaises": [
        "bordelais"
    ],
    "bordelieres": [
        "bordelier"
    ],
    "bordels": [
        "bordel"
    ],
    "bordent": [
        "border"
    ],
    "border": [
        "border"
    ],
    "bordera": [
        "border"
    ],
    "borderait": [
        "border"
    ],
    "bordereau": [
        "bordereau"
    ],
    "bordereaux": [
        "bordereau"
    ],
    "borderie": [
        "borderie"
    ],
    "borderiez": [
        "border"
    ],
    "borderline": [
        "borderline"
    ],
    "bordes": [
        "border",
        "borde"
    ],
    "bordez": [
        "border"
    ],
    "bordier": [
        "bordier"
    ],
    "bordille": [
        "bordille"
    ],
    "bordj": [
        "bordj"
    ],
    "bords": [
        "bord"
    ],
    "bordurant": [
        "bordurer"
    ],
    "bordure": [
        "bordure",
        "bordurer"
    ],
    "bordurer": [
        "bordurer"
    ],
    "bordures": [
        "bordure"
    ],
    "borduree": [
        "bordurer"
    ],
    "borderent": [
        "border"
    ],
    "bordee": [
        "border",
        "bordee"
    ],
    "bordees": [
        "border",
        "bordee"
    ],
    "bordelique": [
        "bordelique"
    ],
    "bordeliques": [
        "bordelique"
    ],
    "bordeliser": [
        "bordeliser"
    ],
    "bore": [
        "bear",
        "bore"
    ],
    "borgne": [
        "borgne"
    ],
    "borgnes": [
        "borgne"
    ],
    "borgnotaient": [
        "borgnoter"
    ],
    "borgnotant": [
        "borgnoter"
    ],
    "borgnote": [
        "borgnoter"
    ],
    "borie": [
        "borie"
    ],
    "borique": [
        "borique"
    ],
    "borna": [
        "borner"
    ],
    "bornage": [
        "bornage"
    ],
    "bornages": [
        "bornage"
    ],
    "bornai": [
        "borner"
    ],
    "bornaient": [
        "borner"
    ],
    "bornais": [
        "borner"
    ],
    "bornait": [
        "borner"
    ],
    "bornant": [
        "borner"
    ],
    "borne": [
        "bear",
        "borne",
        "borner"
    ],
    "bornent": [
        "borner"
    ],
    "borner": [
        "borner"
    ],
    "bornera": [
        "borner"
    ],
    "bornerai": [
        "borner"
    ],
    "borneraient": [
        "borner"
    ],
    "bornerait": [
        "borner"
    ],
    "bornerons": [
        "borner"
    ],
    "bornes": [
        "borne",
        "borner"
    ],
    "bornez": [
        "borner"
    ],
    "bornions": [
        "borner"
    ],
    "bornat": [
        "borner"
    ],
    "bornerent": [
        "borner"
    ],
    "bornee": [
        "borne",
        "borner"
    ],
    "bornees": [
        "borne",
        "borner"
    ],
    "borough": [
        "borough"
    ],
    "borsalino": [
        "borsalino"
    ],
    "bortch": [
        "bortch"
    ],
    "bortsch": [
        "bortsch"
    ],
    "boreal": [
        "boreal"
    ],
    "boreale": [
        "boreal"
    ],
    "boreales": [
        "boreal"
    ],
    "boree": [
        "boree"
    ],
    "bosco": [
        "bosco"
    ],
    "boscotte": [
        "boscot"
    ],
    "boskoop": [
        "boskoop"
    ],
    "bosniaque": [
        "bosniaque"
    ],
    "bosniaques": [
        "bosniaque"
    ],
    "bosnien": [
        "bosnien"
    ],
    "bosquet": [
        "bosquet"
    ],
    "bosquets": [
        "bosquet"
    ],
    "boss": [
        "boss"
    ],
    "bossa": [
        "bosser"
    ],
    "bossage": [
        "bossage"
    ],
    "bossaient": [
        "bosser"
    ],
    "bossais": [
        "bosser"
    ],
    "bossait": [
        "bosser"
    ],
    "bossant": [
        "bosser"
    ],
    "bosse": [
        "bosser",
        "bosse"
    ],
    "bossela": [
        "bosseler"
    ],
    "bosselaient": [
        "bosseler"
    ],
    "bosselait": [
        "bosseler"
    ],
    "bosseler": [
        "bosseler"
    ],
    "bossellement": [
        "bossellement"
    ],
    "bossellements": [
        "bossellement"
    ],
    "bosselure": [
        "bosselure"
    ],
    "bossele": [
        "bosseler",
        "bossele"
    ],
    "bosselee": [
        "bosseler",
        "bossele"
    ],
    "bosselees": [
        "bosseler",
        "bossele"
    ],
    "bosseles": [
        "bosseler",
        "bossele"
    ],
    "bossent": [
        "bosser"
    ],
    "bosser": [
        "bosser"
    ],
    "bossera": [
        "bosser"
    ],
    "bosserai": [
        "bosser"
    ],
    "bosserais": [
        "bosser"
    ],
    "bosserait": [
        "bosser"
    ],
    "bosseras": [
        "bosser"
    ],
    "bosserez": [
        "bosser"
    ],
    "bosses": [
        "boss",
        "bosser",
        "bosse"
    ],
    "bosseur": [
        "bosseur"
    ],
    "bosseurs": [
        "bosseur"
    ],
    "bosseuse": [
        "bosseur"
    ],
    "bossez": [
        "bosser"
    ],
    "bossiez": [
        "bosser"
    ],
    "bossions": [
        "bosser"
    ],
    "bossoir": [
        "bossoir"
    ],
    "bossoirs": [
        "bossoir"
    ],
    "bosson": [
        "bosson"
    ],
    "bossons": [
        "bosser",
        "bosson"
    ],
    "bossu": [
        "bossu"
    ],
    "bossuaient": [
        "bossuer"
    ],
    "bossue": [
        "bossue",
        "bossu",
        "bossuer"
    ],
    "bossues": [
        "bossu",
        "bossue"
    ],
    "bossus": [
        "bossu"
    ],
    "bossuee": [
        "bossue"
    ],
    "bossuees": [
        "bossuer"
    ],
    "boston": [
        "boston"
    ],
    "bostonien": [
        "bostonien"
    ],
    "bostonienne": [
        "bostonien"
    ],
    "bostoniens": [
        "bostonien"
    ],
    "bostonner": [
        "bostonner"
    ],
    "bot": [
        "bot"
    ],
    "botanique": [
        "botanique"
    ],
    "botaniquement": [
        "botaniquement"
    ],
    "botaniques": [
        "botanique"
    ],
    "botaniste": [
        "botaniste"
    ],
    "botanistes": [
        "botaniste"
    ],
    "bote": [
        "bot"
    ],
    "botta": [
        "botter"
    ],
    "bottai": [
        "botter"
    ],
    "bottaient": [
        "botter"
    ],
    "bottait": [
        "botter"
    ],
    "bottant": [
        "botter"
    ],
    "botte": [
        "botte",
        "botter"
    ],
    "botteler": [
        "botteler"
    ],
    "bottellent": [
        "botteler"
    ],
    "bottele": [
        "botteler",
        "bottele"
    ],
    "bottelees": [
        "botteler"
    ],
    "bottent": [
        "botter"
    ],
    "botter": [
        "botter"
    ],
    "bottera": [
        "botter"
    ],
    "botterai": [
        "botter"
    ],
    "botterais": [
        "botter"
    ],
    "botterait": [
        "botter"
    ],
    "botteras": [
        "botter"
    ],
    "botterons": [
        "botter"
    ],
    "botteront": [
        "botter"
    ],
    "bottes": [
        "botte",
        "botter"
    ],
    "botteur": [
        "botteur"
    ],
    "botteurs": [
        "botteur"
    ],
    "bottez": [
        "botter"
    ],
    "botticellienne": [
        "botticellien"
    ],
    "bottier": [
        "bottier"
    ],
    "bottiers": [
        "bottier"
    ],
    "bottiez": [
        "botter"
    ],
    "bottillon": [
        "bottillon"
    ],
    "bottillons": [
        "bottillon"
    ],
    "bottin": [
        "bottin"
    ],
    "bottine": [
        "bottine",
        "bottiner"
    ],
    "bottines": [
        "bottine"
    ],
    "bottins": [
        "bottin"
    ],
    "bottons": [
        "botter"
    ],
    "bottee": [
        "botte",
        "botter"
    ],
    "bottees": [
        "botte",
        "botter"
    ],
    "botulique": [
        "botulique"
    ],
    "botulisme": [
        "botulisme"
    ],
    "boubou": [
        "boubou"
    ],
    "bouboule": [
        "boubouler"
    ],
    "bouboules": [
        "boubouler"
    ],
    "boubous": [
        "boubou"
    ],
    "bouc": [
        "bouc"
    ],
    "boucan": [
        "boucan"
    ],
    "boucanait": [
        "boucaner"
    ],
    "boucaner": [
        "boucaner"
    ],
    "boucanerie": [
        "boucanerie"
    ],
    "boucanier": [
        "boucanier"
    ],
    "boucaniers": [
        "boucanier"
    ],
    "boucane": [
        "boucaner"
    ],
    "boucanee": [
        "boucaner"
    ],
    "boucanees": [
        "boucaner"
    ],
    "boucanes": [
        "boucaner"
    ],
    "boucha": [
        "boucher"
    ],
    "bouchage": [
        "bouchage"
    ],
    "bouchai": [
        "boucher"
    ],
    "bouchaient": [
        "boucher"
    ],
    "bouchais": [
        "boucher"
    ],
    "bouchait": [
        "boucher"
    ],
    "bouchant": [
        "boucher"
    ],
    "bouchardant": [
        "boucharder"
    ],
    "boucharde": [
        "boucharde"
    ],
    "boucharder": [
        "boucharder"
    ],
    "bouche": [
        "bouche",
        "boucher"
    ],
    "bouchent": [
        "boucher"
    ],
    "boucher": [
        "boucher"
    ],
    "bouchera": [
        "boucher"
    ],
    "boucheraient": [
        "boucher"
    ],
    "boucherais": [
        "boucher"
    ],
    "boucherait": [
        "boucher"
    ],
    "boucheras": [
        "boucher"
    ],
    "boucherie": [
        "boucherie"
    ],
    "boucheries": [
        "boucherie"
    ],
    "boucherons": [
        "boucher"
    ],
    "bouchers": [
        "boucher"
    ],
    "bouches": [
        "bouche",
        "boucher"
    ],
    "bouchez": [
        "boucher"
    ],
    "bouchions": [
        "boucher"
    ],
    "bouchon": [
        "bouchon"
    ],
    "bouchonna": [
        "bouchonner"
    ],
    "bouchonnaient": [
        "bouchonner"
    ],
    "bouchonnait": [
        "bouchonner"
    ],
    "bouchonnant": [
        "bouchonner"
    ],
    "bouchonne": [
        "bouchonner",
        "bouchonne"
    ],
    "bouchonner": [
        "bouchonner"
    ],
    "bouchonneras": [
        "bouchonner"
    ],
    "bouchonnee": [
        "bouchonner"
    ],
    "bouchons": [
        "boucher",
        "bouchon"
    ],
    "bouchot": [
        "bouchot"
    ],
    "bouchoteurs": [
        "bouchoteur"
    ],
    "bouchots": [
        "bouchot"
    ],
    "bouchure": [
        "bouchure"
    ],
    "bouchere": [
        "boucher"
    ],
    "boucherent": [
        "boucher"
    ],
    "boucheres": [
        "boucher"
    ],
    "bouchee": [
        "bouche",
        "bouchee",
        "boucher"
    ],
    "bouchees": [
        "bouche",
        "bouchee",
        "boucher"
    ],
    "boucla": [
        "boucler"
    ],
    "bouclage": [
        "bouclage"
    ],
    "bouclaient": [
        "boucler"
    ],
    "bouclais": [
        "boucler"
    ],
    "bouclait": [
        "boucler"
    ],
    "bouclant": [
        "boucler"
    ],
    "boucle": [
        "boucle",
        "boucler"
    ],
    "bouclent": [
        "boucler"
    ],
    "boucler": [
        "boucler"
    ],
    "bouclera": [
        "boucler"
    ],
    "bouclerai": [
        "boucler"
    ],
    "boucleraient": [
        "boucler"
    ],
    "bouclerais": [
        "boucler"
    ],
    "bouclerait": [
        "boucler"
    ],
    "boucleras": [
        "boucler"
    ],
    "bouclerons": [
        "boucler"
    ],
    "boucleront": [
        "boucler"
    ],
    "boucles": [
        "boucle",
        "boucler"
    ],
    "bouclette": [
        "bouclette"
    ],
    "bouclettes": [
        "bouclette"
    ],
    "bouclez": [
        "boucler"
    ],
    "bouclier": [
        "bouclier"
    ],
    "boucliers": [
        "bouclier"
    ],
    "bouclons": [
        "boucler"
    ],
    "bouclames": [
        "boucler"
    ],
    "bouclat": [
        "boucler"
    ],
    "bouclerent": [
        "boucler"
    ],
    "bouclee": [
        "boucle",
        "boucler"
    ],
    "bouclees": [
        "boucle",
        "boucler"
    ],
    "boucs": [
        "bouc"
    ],
    "bouda": [
        "bouder"
    ],
    "boudaient": [
        "bouder"
    ],
    "boudais": [
        "bouder"
    ],
    "boudait": [
        "bouder"
    ],
    "boudant": [
        "bouder"
    ],
    "bouddha": [
        "bouddha"
    ],
    "bouddhas": [
        "bouddha"
    ],
    "bouddhique": [
        "bouddhique"
    ],
    "bouddhiques": [
        "bouddhique"
    ],
    "bouddhisme": [
        "bouddhisme"
    ],
    "bouddhiste": [
        "bouddhiste"
    ],
    "bouddhistes": [
        "bouddhiste"
    ],
    "boude": [
        "bouder"
    ],
    "boudent": [
        "bouder"
    ],
    "bouder": [
        "bouder"
    ],
    "bouderai": [
        "bouder"
    ],
    "bouderait": [
        "bouder"
    ],
    "bouderie": [
        "bouderie"
    ],
    "bouderies": [
        "bouderie"
    ],
    "boudes": [
        "bouder"
    ],
    "boudeur": [
        "boudeur"
    ],
    "boudeurs": [
        "boudeur"
    ],
    "boudeuse": [
        "boudeur"
    ],
    "boudeuses": [
        "boudeur"
    ],
    "boudez": [
        "bouder"
    ],
    "boudi": [
        "boudi"
    ],
    "boudiez": [
        "bouder"
    ],
    "boudin": [
        "boudin"
    ],
    "boudinaient": [
        "boudiner"
    ],
    "boudinait": [
        "boudiner"
    ],
    "boudinant": [
        "boudiner"
    ],
    "boudine": [
        "boudiner",
        "boudine"
    ],
    "boudinent": [
        "boudiner"
    ],
    "boudins": [
        "boudin"
    ],
    "boudinee": [
        "boudiner",
        "boudine"
    ],
    "boudinees": [
        "boudiner",
        "boudine"
    ],
    "boudines": [
        "boudiner",
        "boudine"
    ],
    "boudiou": [
        "boudiou"
    ],
    "boudoir": [
        "boudoir"
    ],
    "boudoirs": [
        "boudoir"
    ],
    "boudons": [
        "bouder"
    ],
    "boudu": [
        "boudu"
    ],
    "bouderent": [
        "bouder"
    ],
    "boudee": [
        "bouder"
    ],
    "boue": [
        "boue"
    ],
    "boues": [
        "boue"
    ],
    "boueur": [
        "boueur"
    ],
    "boueuse": [
        "boueux"
    ],
    "boueuses": [
        "boueux"
    ],
    "boueux": [
        "boueux"
    ],
    "bouf": [
        "bouf"
    ],
    "bouffable": [
        "bouffable"
    ],
    "bouffaient": [
        "bouffer"
    ],
    "bouffais": [
        "bouffer"
    ],
    "bouffait": [
        "bouffer"
    ],
    "bouffant": [
        "bouffant",
        "bouffer"
    ],
    "bouffante": [
        "bouffant"
    ],
    "bouffantes": [
        "bouffant"
    ],
    "bouffants": [
        "bouffant"
    ],
    "bouffarde": [
        "bouffarde"
    ],
    "bouffardes": [
        "bouffarde"
    ],
    "bouffe": [
        "bouffer",
        "bouffe"
    ],
    "bouffent": [
        "bouffer"
    ],
    "bouffer": [
        "bouffer"
    ],
    "bouffera": [
        "bouffer"
    ],
    "boufferai": [
        "bouffer"
    ],
    "boufferaient": [
        "bouffer"
    ],
    "boufferais": [
        "bouffer"
    ],
    "boufferait": [
        "bouffer"
    ],
    "boufferas": [
        "bouffer"
    ],
    "boufferez": [
        "bouffer"
    ],
    "boufferont": [
        "bouffer"
    ],
    "bouffes": [
        "bouffer",
        "bouffe"
    ],
    "bouffetance": [
        "bouffetance"
    ],
    "bouffettes": [
        "bouffette"
    ],
    "bouffeur": [
        "bouffeur"
    ],
    "bouffeurs": [
        "bouffeur"
    ],
    "bouffeuse": [
        "bouffeur"
    ],
    "bouffeuses": [
        "bouffeur"
    ],
    "bouffez": [
        "bouffer"
    ],
    "bouffi": [
        "bouffir",
        "bouffi"
    ],
    "bouffie": [
        "bouffir",
        "bouffi"
    ],
    "bouffies": [
        "bouffir",
        "bouffi"
    ],
    "bouffiez": [
        "bouffer"
    ],
    "bouffis": [
        "bouffir",
        "bouffi"
    ],
    "bouffissure": [
        "bouffissure"
    ],
    "bouffissures": [
        "bouffissure"
    ],
    "bouffon": [
        "bouffon"
    ],
    "bouffonna": [
        "bouffonner"
    ],
    "bouffonnait": [
        "bouffonner"
    ],
    "bouffonnant": [
        "bouffonnant",
        "bouffonner"
    ],
    "bouffonnante": [
        "bouffonnant"
    ],
    "bouffonne": [
        "bouffon"
    ],
    "bouffonnement": [
        "bouffonnement"
    ],
    "bouffonner": [
        "bouffonner"
    ],
    "bouffonnerie": [
        "bouffonnerie"
    ],
    "bouffonneries": [
        "bouffonnerie"
    ],
    "bouffonnes": [
        "bouffon",
        "bouffonner"
    ],
    "bouffons": [
        "bouffer",
        "bouffon"
    ],
    "bouffee": [
        "bouffer",
        "bouffee"
    ],
    "bouffees": [
        "bouffer",
        "bouffee"
    ],
    "bouftance": [
        "bouftance"
    ],
    "bougainvillier": [
        "bougainvillier"
    ],
    "bougainvilliers": [
        "bougainvillier"
    ],
    "bougainvillee": [
        "bougainvillee"
    ],
    "bougainvillees": [
        "bougainvillee"
    ],
    "bouge": [
        "bouger",
        "bouge"
    ],
    "bougea": [
        "bouger"
    ],
    "bougeai": [
        "bouger"
    ],
    "bougeaient": [
        "bouger"
    ],
    "bougeais": [
        "bouger"
    ],
    "bougeait": [
        "bouger"
    ],
    "bougeant": [
        "bouger"
    ],
    "bougeassent": [
        "bouger"
    ],
    "bougent": [
        "bouger"
    ],
    "bougeoir": [
        "bougeoir"
    ],
    "bougeoirs": [
        "bougeoir"
    ],
    "bougeons": [
        "bouger"
    ],
    "bougeotte": [
        "bougeotte"
    ],
    "bouger": [
        "bouger"
    ],
    "bougera": [
        "bouger"
    ],
    "bougerai": [
        "bouger"
    ],
    "bougeraient": [
        "bouger"
    ],
    "bougerais": [
        "bouger"
    ],
    "bougerait": [
        "bouger"
    ],
    "bougeras": [
        "bouger"
    ],
    "bougerez": [
        "bouger"
    ],
    "bougeriez": [
        "bouger"
    ],
    "bougerons": [
        "bouger"
    ],
    "bougeront": [
        "bouger"
    ],
    "bouges": [
        "bouger",
        "bouge"
    ],
    "bougez": [
        "bouger"
    ],
    "bougeat": [
        "bouger"
    ],
    "bougie": [
        "bougie"
    ],
    "bougies": [
        "bougie"
    ],
    "bougiez": [
        "bougier"
    ],
    "bougions": [
        "bouger"
    ],
    "bougnat": [
        "bougnat"
    ],
    "bougnats": [
        "bougnat"
    ],
    "bougne": [
        "bougner"
    ],
    "bougnes": [
        "bougner"
    ],
    "bougnoul": [
        "bougnoul"
    ],
    "bougnoule": [
        "bougnoule"
    ],
    "bougnoules": [
        "bougnoule"
    ],
    "bougon": [
        "bougon"
    ],
    "bougonna": [
        "bougonner"
    ],
    "bougonnaient": [
        "bougonner"
    ],
    "bougonnais": [
        "bougonner"
    ],
    "bougonnait": [
        "bougonner"
    ],
    "bougonnant": [
        "bougonner"
    ],
    "bougonne": [
        "bougon",
        "bougonner"
    ],
    "bougonnement": [
        "bougonnement"
    ],
    "bougonnent": [
        "bougonner"
    ],
    "bougonner": [
        "bougonner"
    ],
    "bougons": [
        "bougon"
    ],
    "bougran": [
        "bougran"
    ],
    "bougre": [
        "bougre"
    ],
    "bougrement": [
        "bougrement"
    ],
    "bougrerie": [
        "bougrerie"
    ],
    "bougreries": [
        "bougrerie"
    ],
    "bougres": [
        "bougre"
    ],
    "bougresse": [
        "bougresse"
    ],
    "bougerent": [
        "bouger"
    ],
    "bougee": [
        "bouger"
    ],
    "bougees": [
        "bouger"
    ],
    "bouiboui": [
        "bouiboui"
    ],
    "bouibouis": [
        "bouiboui"
    ],
    "bouif": [
        "bouif"
    ],
    "bouillabaisse": [
        "bouillabaisse"
    ],
    "bouillaient": [
        "bouillir"
    ],
    "bouillais": [
        "bouillir"
    ],
    "bouillait": [
        "bouillir"
    ],
    "bouillant": [
        "bouillant",
        "bouiller"
    ],
    "bouillante": [
        "bouillant"
    ],
    "bouillantes": [
        "bouillant"
    ],
    "bouillants": [
        "bouillant"
    ],
    "bouillasse": [
        "bouillasse"
    ],
    "bouille": [
        "bouille",
        "bouillir"
    ],
    "bouillent": [
        "bouillir"
    ],
    "bouilles": [
        "bouille"
    ],
    "bouilleur": [
        "bouilleur"
    ],
    "bouilleurs": [
        "bouilleur"
    ],
    "bouilli": [
        "bouilli",
        "bouillir"
    ],
    "bouillie": [
        "bouilli",
        "bouillie",
        "bouillir"
    ],
    "bouillies": [
        "bouilli",
        "bouillie"
    ],
    "bouillir": [
        "bouillir"
    ],
    "bouillira": [
        "bouillir"
    ],
    "bouillirons": [
        "bouillir"
    ],
    "bouillis": [
        "bouilli",
        "bouillir"
    ],
    "bouilloire": [
        "bouilloire"
    ],
    "bouilloires": [
        "bouilloire"
    ],
    "bouillon": [
        "bouillon"
    ],
    "bouillonnaient": [
        "bouillonner"
    ],
    "bouillonnais": [
        "bouillonner"
    ],
    "bouillonnait": [
        "bouillonner"
    ],
    "bouillonnant": [
        "bouillonner",
        "bouillonnant"
    ],
    "bouillonnante": [
        "bouillonnant"
    ],
    "bouillonnantes": [
        "bouillonnant"
    ],
    "bouillonnants": [
        "bouillonnant"
    ],
    "bouillonne": [
        "bouillonner",
        "bouillonne"
    ],
    "bouillonnement": [
        "bouillonnement"
    ],
    "bouillonnements": [
        "bouillonnement"
    ],
    "bouillonnent": [
        "bouillonner"
    ],
    "bouillonner": [
        "bouillonner"
    ],
    "bouillonneux": [
        "bouillonneux"
    ],
    "bouillonnerent": [
        "bouillonner"
    ],
    "bouillonnee": [
        "bouillonner"
    ],
    "bouillonnees": [
        "bouillonner"
    ],
    "bouillonnes": [
        "bouillonner",
        "bouillonne"
    ],
    "bouillons": [
        "bouillon",
        "bouillir"
    ],
    "bouillottait": [
        "bouillotter"
    ],
    "bouillotte": [
        "bouillotte"
    ],
    "bouillottes": [
        "bouillotte"
    ],
    "bouillu": [
        "bouillu"
    ],
    "boukha": [
        "boukha"
    ],
    "boula": [
        "bouler"
    ],
    "boulait": [
        "bouler"
    ],
    "boulange": [
        "boulange"
    ],
    "boulanger": [
        "boulanger"
    ],
    "boulangerie": [
        "boulangerie"
    ],
    "boulangeries": [
        "boulangerie"
    ],
    "boulangers": [
        "boulanger"
    ],
    "boulangisme": [
        "boulangisme"
    ],
    "boulangere": [
        "boulanger"
    ],
    "boulangeres": [
        "boulanger"
    ],
    "boulants": [
        "boulant"
    ],
    "boulder": [
        "boulder"
    ],
    "boule": [
        "bouler",
        "boule"
    ],
    "bouleau": [
        "bouleau"
    ],
    "bouleaux": [
        "bouleau"
    ],
    "bouledogue": [
        "bouledogue"
    ],
    "bouledogues": [
        "bouledogue"
    ],
    "boulent": [
        "bouler"
    ],
    "bouler": [
        "bouler"
    ],
    "boules": [
        "bouler",
        "boule"
    ],
    "boulet": [
        "boulet"
    ],
    "boulets": [
        "boulet"
    ],
    "boulette": [
        "boulette"
    ],
    "boulettes": [
        "boulette"
    ],
    "boulevard": [
        "boulevard"
    ],
    "boulevardier": [
        "boulevardier"
    ],
    "boulevardiers": [
        "boulevardier"
    ],
    "boulevardiere": [
        "boulevardier"
    ],
    "boulevards": [
        "boulevard"
    ],
    "bouleversa": [
        "bouleverser"
    ],
    "bouleversaient": [
        "bouleverser"
    ],
    "bouleversait": [
        "bouleverser"
    ],
    "bouleversant": [
        "bouleversant",
        "bouleverser"
    ],
    "bouleversante": [
        "bouleversant"
    ],
    "bouleversantes": [
        "bouleversant"
    ],
    "bouleversants": [
        "bouleversant"
    ],
    "bouleverse": [
        "bouleverse",
        "bouleverser"
    ],
    "bouleversement": [
        "bouleversement"
    ],
    "bouleversements": [
        "bouleversement"
    ],
    "bouleversent": [
        "bouleverser"
    ],
    "bouleverser": [
        "bouleverser"
    ],
    "bouleversera": [
        "bouleverser"
    ],
    "bouleverseraient": [
        "bouleverser"
    ],
    "bouleverserais": [
        "bouleverser"
    ],
    "bouleverserait": [
        "bouleverser"
    ],
    "bouleverseras": [
        "bouleverser"
    ],
    "bouleverserons": [
        "bouleverser"
    ],
    "bouleverseront": [
        "bouleverser"
    ],
    "bouleversions": [
        "bouleverser"
    ],
    "bouleversons": [
        "bouleverser"
    ],
    "bouleverserent": [
        "bouleverser"
    ],
    "bouleversee": [
        "bouleverse",
        "bouleverser"
    ],
    "bouleversees": [
        "bouleverse",
        "bouleverser"
    ],
    "bouleverses": [
        "bouleverse",
        "bouleverser"
    ],
    "boulgour": [
        "boulgour"
    ],
    "boulier": [
        "boulier"
    ],
    "bouliers": [
        "boulier"
    ],
    "boulimie": [
        "boulimie"
    ],
    "boulimies": [
        "boulimie"
    ],
    "boulimique": [
        "boulimique"
    ],
    "boulimiques": [
        "boulimique"
    ],
    "bouline": [
        "bouline"
    ],
    "boulines": [
        "bouline"
    ],
    "boulingrins": [
        "boulingrin"
    ],
    "boulins": [
        "boulin"
    ],
    "bouliste": [
        "bouliste"
    ],
    "boulistes": [
        "bouliste"
    ],
    "boulle": [
        "boulle"
    ],
    "boulochait": [
        "boulocher"
    ],
    "boulodrome": [
        "boulodrome"
    ],
    "bouloir": [
        "bouloir"
    ],
    "boulon": [
        "boulon"
    ],
    "boulonnage": [
        "boulonnage"
    ],
    "boulonnais": [
        "boulonnais"
    ],
    "boulonnait": [
        "boulonner"
    ],
    "boulonnant": [
        "boulonner"
    ],
    "boulonne": [
        "boulonner"
    ],
    "boulonner": [
        "boulonner"
    ],
    "boulonnerie": [
        "boulonnerie"
    ],
    "boulonnee": [
        "boulonner"
    ],
    "boulonnes": [
        "boulonner"
    ],
    "boulons": [
        "boulon"
    ],
    "boulot": [
        "boulot"
    ],
    "boulots": [
        "boulot"
    ],
    "boulottait": [
        "boulotter"
    ],
    "boulotte": [
        "boulot",
        "boulotte",
        "boulotter"
    ],
    "boulotter": [
        "boulotter"
    ],
    "boulottes": [
        "boulot",
        "boulotte",
        "boulotter"
    ],
    "boulottees": [
        "boulotter"
    ],
    "boulu": [
        "boulu"
    ],
    "boulus": [
        "boulu"
    ],
    "boum": [
        "boum"
    ],
    "boumaient": [
        "boumer"
    ],
    "boumait": [
        "boumer"
    ],
    "boume": [
        "boumer"
    ],
    "boums": [
        "boum"
    ],
    "bouniouls": [
        "bounioul"
    ],
    "bouquet": [
        "bouquet"
    ],
    "bouquetier": [
        "bouquetier"
    ],
    "bouquetin": [
        "bouquetin"
    ],
    "bouquetins": [
        "bouquetin"
    ],
    "bouquetiere": [
        "bouquetier"
    ],
    "bouquets": [
        "bouquet"
    ],
    "bouquete": [
        "bouquete"
    ],
    "bouquin": [
        "bouquin"
    ],
    "bouquinage": [
        "bouquinage"
    ],
    "bouquinais": [
        "bouquiner"
    ],
    "bouquinait": [
        "bouquiner"
    ],
    "bouquinant": [
        "bouquiner"
    ],
    "bouquine": [
        "bouquiner"
    ],
    "bouquiner": [
        "bouquiner"
    ],
    "bouquinerait": [
        "bouquiner"
    ],
    "bouquineur": [
        "bouquineur"
    ],
    "bouquiniste": [
        "bouquiniste"
    ],
    "bouquinistes": [
        "bouquiniste"
    ],
    "bouquins": [
        "bouquin"
    ],
    "bour": [
        "bour"
    ],
    "bourbe": [
        "bourbe"
    ],
    "bourbeuse": [
        "bourbeux"
    ],
    "bourbeuses": [
        "bourbeux"
    ],
    "bourbeux": [
        "bourbeux"
    ],
    "bourbier": [
        "bourbier"
    ],
    "bourbiers": [
        "bourbier"
    ],
    "bourbon": [
        "bourbon"
    ],
    "bourbonien": [
        "bourbonien"
    ],
    "bourbonienne": [
        "bourbonien"
    ],
    "bourbons": [
        "bourbon"
    ],
    "bourdaine": [
        "bourdaine"
    ],
    "bourdaines": [
        "bourdaine"
    ],
    "bourdalous": [
        "bourdalou"
    ],
    "bourde": [
        "bourde"
    ],
    "bourdes": [
        "bourde"
    ],
    "bourdillon": [
        "bourdillon"
    ],
    "bourdon": [
        "bourdon"
    ],
    "bourdonna": [
        "bourdonner"
    ],
    "bourdonnaient": [
        "bourdonner"
    ],
    "bourdonnais": [
        "bourdonner"
    ],
    "bourdonnait": [
        "bourdonner"
    ],
    "bourdonnant": [
        "bourdonner",
        "bourdonnant"
    ],
    "bourdonnante": [
        "bourdonnant"
    ],
    "bourdonnantes": [
        "bourdonnant"
    ],
    "bourdonnants": [
        "bourdonnant"
    ],
    "bourdonne": [
        "bourdonner"
    ],
    "bourdonnement": [
        "bourdonnement"
    ],
    "bourdonnements": [
        "bourdonnement"
    ],
    "bourdonnent": [
        "bourdonner"
    ],
    "bourdonner": [
        "bourdonner"
    ],
    "bourdons": [
        "bourdon"
    ],
    "bourg": [
        "bourg"
    ],
    "bourgade": [
        "bourgade"
    ],
    "bourgades": [
        "bourgade"
    ],
    "bourge": [
        "bourge"
    ],
    "bourgeois": [
        "bourgeois"
    ],
    "bourgeoise": [
        "bourgeois"
    ],
    "bourgeoisement": [
        "bourgeoisement"
    ],
    "bourgeoises": [
        "bourgeois"
    ],
    "bourgeoisie": [
        "bourgeoisie"
    ],
    "bourgeoisies": [
        "bourgeoisie"
    ],
    "bourgeoisisme": [
        "bourgeoisisme"
    ],
    "bourgeon": [
        "bourgeon"
    ],
    "bourgeonnaient": [
        "bourgeonner"
    ],
    "bourgeonnait": [
        "bourgeonner"
    ],
    "bourgeonnant": [
        "bourgeonnant",
        "bourgeonner"
    ],
    "bourgeonnante": [
        "bourgeonnant"
    ],
    "bourgeonnants": [
        "bourgeonnant"
    ],
    "bourgeonne": [
        "bourgeonner"
    ],
    "bourgeonnement": [
        "bourgeonnement"
    ],
    "bourgeonnements": [
        "bourgeonnement"
    ],
    "bourgeonnent": [
        "bourgeonner"
    ],
    "bourgeonner": [
        "bourgeonner"
    ],
    "bourgeonneraient": [
        "bourgeonner"
    ],
    "bourgeonneuse": [
        "bourgeonneux"
    ],
    "bourgeons": [
        "bourgeon"
    ],
    "bourgeron": [
        "bourgeron"
    ],
    "bourgerons": [
        "bourgeron"
    ],
    "bourges": [
        "bourge"
    ],
    "bourgmestre": [
        "bourgmestre"
    ],
    "bourgmestres": [
        "bourgmestre"
    ],
    "bourgogne": [
        "bourgogne"
    ],
    "bourgognes": [
        "bourgogne"
    ],
    "bourgs": [
        "bourg"
    ],
    "bourgueil": [
        "bourgueil"
    ],
    "bourgues": [
        "bourgue"
    ],
    "bourguignon": [
        "bourguignon"
    ],
    "bourguignonne": [
        "bourguignon"
    ],
    "bourguignonnes": [
        "bourguignon"
    ],
    "bourguignons": [
        "bourguignon"
    ],
    "bouriates": [
        "bouriate"
    ],
    "bourlinguant": [
        "bourlinguer"
    ],
    "bourlingue": [
        "bourlingue",
        "bourlinguer"
    ],
    "bourlinguer": [
        "bourlinguer"
    ],
    "bourlinguera": [
        "bourlinguer"
    ],
    "bourlingueur": [
        "bourlingueur"
    ],
    "bourlingueuses": [
        "bourlingueur"
    ],
    "bourlinguons": [
        "bourlinguer"
    ],
    "bourra": [
        "bourrer"
    ],
    "bourrache": [
        "bourrache"
    ],
    "bourrade": [
        "bourrade"
    ],
    "bourrades": [
        "bourrade"
    ],
    "bourrage": [
        "bourrage"
    ],
    "bourrages": [
        "bourrage"
    ],
    "bourrai": [
        "bourrer"
    ],
    "bourraient": [
        "bourrer"
    ],
    "bourrais": [
        "bourrer"
    ],
    "bourrait": [
        "bourrer"
    ],
    "bourrant": [
        "bourrer"
    ],
    "bourrasque": [
        "bourrasque"
    ],
    "bourrasques": [
        "bourrasque"
    ],
    "bourratif": [
        "bourratif"
    ],
    "bourrative": [
        "bourratif"
    ],
    "bourratives": [
        "bourratif"
    ],
    "bourre": [
        "bourre",
        "bourrer"
    ],
    "bourreau": [
        "bourreau"
    ],
    "bourreaux": [
        "bourreau"
    ],
    "bourrelet": [
        "bourrelet"
    ],
    "bourrelets": [
        "bourrelet"
    ],
    "bourrelier": [
        "bourrelier"
    ],
    "bourreliers": [
        "bourrelier"
    ],
    "bourrellerie": [
        "bourrellerie"
    ],
    "bourrele": [
        "bourreler"
    ],
    "bourrelee": [
        "bourreler"
    ],
    "bourreles": [
        "bourreler"
    ],
    "bourrent": [
        "bourrer"
    ],
    "bourrer": [
        "bourrer"
    ],
    "bourrera": [
        "bourrer"
    ],
    "bourrerai": [
        "bourrer"
    ],
    "bourres": [
        "bourre",
        "bourrer"
    ],
    "bourreur": [
        "bourreur"
    ],
    "bourrez": [
        "bourrer"
    ],
    "bourriche": [
        "bourriche"
    ],
    "bourriches": [
        "bourriche"
    ],
    "bourrichon": [
        "bourrichon"
    ],
    "bourricot": [
        "bourricot"
    ],
    "bourricots": [
        "bourricot"
    ],
    "bourrier": [
        "bourrier"
    ],
    "bourrin": [
        "bourrin"
    ],
    "bourrine": [
        "bourrine"
    ],
    "bourrins": [
        "bourrin"
    ],
    "bourriquait": [
        "bourriquer"
    ],
    "bourrique": [
        "bourrique"
    ],
    "bourriques": [
        "bourrique"
    ],
    "bourriquet": [
        "bourriquet"
    ],
    "bourriquets": [
        "bourriquet"
    ],
    "bourrons": [
        "bourrer"
    ],
    "bourru": [
        "bourru"
    ],
    "bourrue": [
        "bourru"
    ],
    "bourrues": [
        "bourru"
    ],
    "bourrus": [
        "bourru"
    ],
    "bourrerent": [
        "bourrer"
    ],
    "bourree": [
        "bourre",
        "bourrer"
    ],
    "bourrees": [
        "bourre",
        "bourree"
    ],
    "bourse": [
        "bourse"
    ],
    "bourses": [
        "bourse"
    ],
    "boursicot": [
        "boursicot"
    ],
    "boursicotage": [
        "boursicotage"
    ],
    "boursicoteur": [
        "boursicoteur"
    ],
    "boursicoteurs": [
        "boursicoteur"
    ],
    "boursier": [
        "boursier"
    ],
    "boursiers": [
        "boursier"
    ],
    "boursiere": [
        "boursier"
    ],
    "boursieres": [
        "boursier"
    ],
    "boursouflaient": [
        "boursoufler"
    ],
    "boursouflait": [
        "boursoufler"
    ],
    "boursoufle": [
        "boursoufler",
        "boursoufle"
    ],
    "boursouflement": [
        "boursouflement"
    ],
    "boursoufler": [
        "boursoufler"
    ],
    "boursouflure": [
        "boursouflure"
    ],
    "boursouflures": [
        "boursouflure"
    ],
    "boursouflee": [
        "boursoufler",
        "boursoufle"
    ],
    "boursouflees": [
        "boursoufler",
        "boursoufle"
    ],
    "boursoufles": [
        "boursoufler",
        "boursoufle"
    ],
    "bous": [
        "bouillir"
    ],
    "bousards": [
        "bousard"
    ],
    "bousbir": [
        "bousbir"
    ],
    "bousbirs": [
        "bousbir"
    ],
    "bouscula": [
        "bousculer"
    ],
    "bousculade": [
        "bousculade"
    ],
    "bousculades": [
        "bousculade"
    ],
    "bousculai": [
        "bousculer"
    ],
    "bousculaient": [
        "bousculer"
    ],
    "bousculait": [
        "bousculer"
    ],
    "bousculant": [
        "bousculer"
    ],
    "bouscule": [
        "bousculer"
    ],
    "bousculent": [
        "bousculer"
    ],
    "bousculer": [
        "bousculer"
    ],
    "bousculera": [
        "bousculer"
    ],
    "bousculerait": [
        "bousculer"
    ],
    "bousculerons": [
        "bousculer"
    ],
    "bousculeront": [
        "bousculer"
    ],
    "bousculez": [
        "bousculer"
    ],
    "bousculons": [
        "bousculer"
    ],
    "bousculat": [
        "bousculer"
    ],
    "bousculerent": [
        "bousculer"
    ],
    "bousculee": [
        "bousculer"
    ],
    "bousculees": [
        "bousculer"
    ],
    "bouscules": [
        "bousculer"
    ],
    "bouse": [
        "bouse"
    ],
    "bouses": [
        "bouse"
    ],
    "bouseuse": [
        "bouseux"
    ],
    "bouseux": [
        "bouseux"
    ],
    "bousier": [
        "bousier"
    ],
    "bousiers": [
        "bousier"
    ],
    "bousillage": [
        "bousillage"
    ],
    "bousillages": [
        "bousillage"
    ],
    "bousillaient": [
        "bousiller"
    ],
    "bousillais": [
        "bousiller"
    ],
    "bousillait": [
        "bousiller"
    ],
    "bousillant": [
        "bousiller"
    ],
    "bousille": [
        "bousille",
        "bousiller"
    ],
    "bousillent": [
        "bousiller"
    ],
    "bousiller": [
        "bousiller"
    ],
    "bousillera": [
        "bousiller"
    ],
    "bousillerai": [
        "bousiller"
    ],
    "bousillerait": [
        "bousiller"
    ],
    "bousilleras": [
        "bousiller"
    ],
    "bousilleront": [
        "bousiller"
    ],
    "bousilles": [
        "bousille",
        "bousiller"
    ],
    "bousilleur": [
        "bousilleur"
    ],
    "bousillez": [
        "bousiller"
    ],
    "bousilliez": [
        "bousiller"
    ],
    "bousillons": [
        "bousiller"
    ],
    "bousillee": [
        "bousille",
        "bousiller"
    ],
    "bousillees": [
        "bousille",
        "bousiller"
    ],
    "bousin": [
        "bousin"
    ],
    "bousine": [
        "bousine"
    ],
    "bousins": [
        "bousin"
    ],
    "boussole": [
        "boussole"
    ],
    "boussoles": [
        "boussole"
    ],
    "boustifaille": [
        "boustifaille"
    ],
    "boustifailles": [
        "boustifaille"
    ],
    "boustifailleuse": [
        "boustifailleur"
    ],
    "boustrophedon": [
        "boustrophedon"
    ],
    "bout": [
        "bouillir",
        "bout"
    ],
    "bouta": [
        "bouter"
    ],
    "boutade": [
        "boutade"
    ],
    "boutades": [
        "boutade"
    ],
    "boutanche": [
        "boutanche"
    ],
    "boutanches": [
        "boutanche"
    ],
    "boutargue": [
        "boutargue"
    ],
    "boutasse": [
        "bouter"
    ],
    "boute": [
        "bouter"
    ],
    "boutefeu": [
        "boutefeu"
    ],
    "boutefeux": [
        "boutefeux"
    ],
    "bouteille": [
        "bouteille"
    ],
    "bouteilles": [
        "bouteille"
    ],
    "bouteillon": [
        "bouteillon"
    ],
    "bouteillons": [
        "bouteillon"
    ],
    "bouter": [
        "bouter"
    ],
    "bouterais": [
        "bouter"
    ],
    "bouteur": [
        "bouteur"
    ],
    "bouteurs": [
        "bouteur"
    ],
    "boutheon": [
        "boutheon"
    ],
    "boutheons": [
        "boutheon"
    ],
    "boutillier": [
        "boutillier"
    ],
    "boutique": [
        "boutiquer",
        "boutique"
    ],
    "boutiquer": [
        "boutiquer"
    ],
    "boutiques": [
        "boutique"
    ],
    "boutiquier": [
        "boutiquier"
    ],
    "boutiquiers": [
        "boutiquier"
    ],
    "boutiquiere": [
        "boutiquier"
    ],
    "boutiquieres": [
        "boutiquier"
    ],
    "boutisses": [
        "boutisse"
    ],
    "boutoir": [
        "boutoir"
    ],
    "bouton": [
        "bouton"
    ],
    "boutonna": [
        "boutonner"
    ],
    "boutonnage": [
        "boutonnage"
    ],
    "boutonnaient": [
        "boutonner"
    ],
    "boutonnais": [
        "boutonner"
    ],
    "boutonnait": [
        "boutonner"
    ],
    "boutonnant": [
        "boutonner",
        "boutonnant"
    ],
    "boutonne": [
        "boutonne",
        "boutonner"
    ],
    "boutonnent": [
        "boutonner"
    ],
    "boutonner": [
        "boutonner"
    ],
    "boutonnerait": [
        "boutonner"
    ],
    "boutonnes": [
        "boutonne",
        "boutonner"
    ],
    "boutonneuse": [
        "boutonneux"
    ],
    "boutonneuses": [
        "boutonneux"
    ],
    "boutonneux": [
        "boutonneux"
    ],
    "boutonnez": [
        "boutonner"
    ],
    "boutonniere": [
        "boutonniere"
    ],
    "boutonnieres": [
        "boutonniere"
    ],
    "boutonnee": [
        "boutonne",
        "boutonner"
    ],
    "boutonnees": [
        "boutonne",
        "boutonner"
    ],
    "boutons": [
        "bouton",
        "bouter"
    ],
    "boutre": [
        "boutre"
    ],
    "boutres": [
        "boutre"
    ],
    "bouts": [
        "bout"
    ],
    "bouture": [
        "bouture"
    ],
    "boutures": [
        "bouture"
    ],
    "boutee": [
        "bouter"
    ],
    "boutees": [
        "bouter"
    ],
    "boutes": [
        "bouter"
    ],
    "bouvet": [
        "bouvet"
    ],
    "bouvier": [
        "bouvier"
    ],
    "bouviers": [
        "bouvier"
    ],
    "bouvillon": [
        "bouvillon"
    ],
    "bouvreuil": [
        "bouvreuil"
    ],
    "bouvreuils": [
        "bouvreuil"
    ],
    "bouzine": [
        "bouzine"
    ],
    "bouzouki": [
        "bouzouki"
    ],
    "bouzy": [
        "bouzy"
    ],
    "bouee": [
        "bouee"
    ],
    "bouees": [
        "bouee"
    ],
    "bovide": [
        "bovide"
    ],
    "bovides": [
        "bovide"
    ],
    "bovin": [
        "bovin"
    ],
    "bovine": [
        "bovin"
    ],
    "bovines": [
        "bovin",
        "bovine"
    ],
    "bovins": [
        "bovin"
    ],
    "bowling": [
        "bowl",
        "bowling"
    ],
    "box": [
        "box"
    ],
    "boxa": [
        "boxer"
    ],
    "boxaient": [
        "boxer"
    ],
    "boxais": [
        "boxer"
    ],
    "boxait": [
        "boxer"
    ],
    "boxant": [
        "boxer"
    ],
    "boxe": [
        "boxer",
        "boxe"
    ],
    "boxent": [
        "boxer"
    ],
    "boxer": [
        "boxer"
    ],
    "boxerai": [
        "boxer"
    ],
    "boxerais": [
        "boxer"
    ],
    "boxerez": [
        "boxer"
    ],
    "boxers": [
        "boxer"
    ],
    "boxes": [
        "boxer",
        "boxe",
        "box"
    ],
    "boxeur": [
        "boxeur"
    ],
    "boxeurs": [
        "boxeur"
    ],
    "boxeuse": [
        "boxeur"
    ],
    "boxez": [
        "boxer"
    ],
    "boxon": [
        "boxon"
    ],
    "boxons": [
        "boxer",
        "boxon"
    ],
    "boy": [
        "boy"
    ],
    "boyard": [
        "boyard"
    ],
    "boyards": [
        "boyard"
    ],
    "boyau": [
        "boyau"
    ],
    "boyauter": [
        "boyauter"
    ],
    "boyaux": [
        "boyau"
    ],
    "boycott": [
        "boycott"
    ],
    "boycotte": [
        "boycotter"
    ],
    "boycottent": [
        "boycotter"
    ],
    "boycotter": [
        "boycotter"
    ],
    "boycotterai": [
        "boycotter"
    ],
    "boycotteront": [
        "boycotter"
    ],
    "boycottes": [
        "boycotter"
    ],
    "boycottez": [
        "boycotter"
    ],
    "boys": [
        "boy"
    ],
    "bozo": [
        "bozo"
    ],
    "boettes": [
        "boette"
    ],
    "boitier": [
        "boitier"
    ],
    "boitiers": [
        "boitier"
    ],
    "brabant": [
        "brabant"
    ],
    "brabancon": [
        "brabancon"
    ],
    "brabanconne": [
        "brabancon"
    ],
    "brabancons": [
        "brabancon"
    ],
    "bracelet": [
        "bracelet"
    ],
    "bracelets": [
        "bracelet"
    ],
    "brachial": [
        "brachial"
    ],
    "brachiale": [
        "brachial"
    ],
    "brachiocephalique": [
        "brachiocephalique"
    ],
    "brachiosaure": [
        "brachiosaure"
    ],
    "brachycephale": [
        "brachycephale"
    ],
    "brachycephales": [
        "brachycephale"
    ],
    "braco": [
        "braco"
    ],
    "braconnage": [
        "braconnage"
    ],
    "braconnages": [
        "braconnage"
    ],
    "braconnais": [
        "braconner"
    ],
    "braconnait": [
        "braconner"
    ],
    "braconnant": [
        "braconner"
    ],
    "braconne": [
        "braconner"
    ],
    "braconner": [
        "braconner"
    ],
    "braconnez": [
        "braconner"
    ],
    "braconnier": [
        "braconnier"
    ],
    "braconniers": [
        "braconnier"
    ],
    "braconniere": [
        "braconnier"
    ],
    "braconnieres": [
        "braconnier"
    ],
    "bractees": [
        "bractee"
    ],
    "bradaient": [
        "brader"
    ],
    "bradait": [
        "brader"
    ],
    "brade": [
        "brader"
    ],
    "bradent": [
        "brader"
    ],
    "brader": [
        "brader"
    ],
    "braderai": [
        "brader"
    ],
    "braderais": [
        "brader"
    ],
    "braderait": [
        "brader"
    ],
    "braderie": [
        "braderie"
    ],
    "braderies": [
        "braderie"
    ],
    "bradillon": [
        "bradillon"
    ],
    "bradillons": [
        "bradillon"
    ],
    "bradons": [
        "brader"
    ],
    "bradycardie": [
        "bradycardie"
    ],
    "bradee": [
        "brader"
    ],
    "bragard": [
        "bragard"
    ],
    "braguette": [
        "braguette"
    ],
    "braguettes": [
        "braguette"
    ],
    "brahmane": [
        "brahmane"
    ],
    "brahmanes": [
        "brahmane"
    ],
    "brahmanique": [
        "brahmanique"
    ],
    "brahmanisme": [
        "brahmanisme"
    ],
    "brahmanistes": [
        "brahmaniste"
    ],
    "brai": [
        "brai"
    ],
    "braie": [
        "brayer"
    ],
    "braiement": [
        "braiement"
    ],
    "braiements": [
        "braiement"
    ],
    "braies": [
        "braie"
    ],
    "brailla": [
        "brailler"
    ],
    "braillaient": [
        "brailler"
    ],
    "braillait": [
        "brailler"
    ],
    "braillant": [
        "brailler"
    ],
    "braillard": [
        "braillard"
    ],
    "braillarde": [
        "braillard"
    ],
    "braillardes": [
        "braillard"
    ],
    "braillards": [
        "braillard"
    ],
    "braille": [
        "brailler",
        "braille"
    ],
    "braillement": [
        "braillement"
    ],
    "braillements": [
        "braillement"
    ],
    "braillent": [
        "brailler"
    ],
    "brailler": [
        "brailler"
    ],
    "braillera": [
        "brailler"
    ],
    "braillerai": [
        "brailler"
    ],
    "brailles": [
        "brailler",
        "braille"
    ],
    "brailleur": [
        "brailleur"
    ],
    "brailleurs": [
        "brailleur"
    ],
    "brailleuse": [
        "brailleur"
    ],
    "braillez": [
        "brailler"
    ],
    "braillerent": [
        "brailler"
    ],
    "braillee": [
        "brailler"
    ],
    "braiment": [
        "braiment"
    ],
    "braiments": [
        "braiment"
    ],
    "brainstorming": [
        "brainstorming"
    ],
    "braire": [
        "braire"
    ],
    "brais": [
        "brai"
    ],
    "braise": [
        "braiser",
        "braise"
    ],
    "braiser": [
        "braiser"
    ],
    "braises": [
        "braiser",
        "braise"
    ],
    "braisillant": [
        "braisillant"
    ],
    "braisillante": [
        "braisillant"
    ],
    "braisee": [
        "braiser",
        "braise"
    ],
    "brait": [
        "braire"
    ],
    "brama": [
        "bramer"
    ],
    "bramaient": [
        "bramer"
    ],
    "bramait": [
        "bramer"
    ],
    "bramant": [
        "bramer"
    ],
    "brame": [
        "brame",
        "bramer"
    ],
    "bramement": [
        "bramement"
    ],
    "bramements": [
        "bramement"
    ],
    "brament": [
        "bramer"
    ],
    "bramer": [
        "bramer"
    ],
    "brames": [
        "brame",
        "bramer"
    ],
    "bramees": [
        "bramer"
    ],
    "bran": [
        "bran"
    ],
    "brancard": [
        "brancard"
    ],
    "brancarder": [
        "brancarder"
    ],
    "brancardier": [
        "brancardier"
    ],
    "brancardiers": [
        "brancardier"
    ],
    "brancards": [
        "brancard"
    ],
    "brancha": [
        "brancher"
    ],
    "branchage": [
        "branchage"
    ],
    "branchages": [
        "branchage"
    ],
    "branchai": [
        "brancher"
    ],
    "branchaient": [
        "brancher"
    ],
    "branchais": [
        "brancher"
    ],
    "branchait": [
        "brancher"
    ],
    "branchant": [
        "brancher"
    ],
    "branche": [
        "brancher",
        "branche"
    ],
    "branchement": [
        "branchement"
    ],
    "branchements": [
        "branchement"
    ],
    "branchent": [
        "brancher"
    ],
    "brancher": [
        "brancher"
    ],
    "branchera": [
        "brancher"
    ],
    "brancheraient": [
        "brancher"
    ],
    "brancherait": [
        "brancher"
    ],
    "brancheras": [
        "brancher"
    ],
    "brancherez": [
        "brancher"
    ],
    "branches": [
        "brancher",
        "branche",
        "branch"
    ],
    "branchette": [
        "branchette"
    ],
    "branchettes": [
        "branchette"
    ],
    "branchez": [
        "brancher"
    ],
    "branchiale": [
        "branchial"
    ],
    "branchie": [
        "branchie"
    ],
    "branchies": [
        "branchie"
    ],
    "branchons": [
        "brancher"
    ],
    "branchu": [
        "branchu"
    ],
    "branchue": [
        "branchu"
    ],
    "branchus": [
        "branchu"
    ],
    "branchee": [
        "brancher",
        "branche"
    ],
    "branchees": [
        "brancher",
        "branche"
    ],
    "brand": [
        "brand"
    ],
    "brandade": [
        "brandade"
    ],
    "brande": [
        "brand"
    ],
    "brandebourgeois": [
        "brandebourgeois"
    ],
    "brandebourgs": [
        "brandebourg"
    ],
    "brandevin": [
        "brandevin"
    ],
    "brandevinier": [
        "brandevinier"
    ],
    "brandi": [
        "brandir"
    ],
    "brandie": [
        "brandir"
    ],
    "brandies": [
        "brandy",
        "brandir"
    ],
    "brandillon": [
        "brandillon"
    ],
    "brandillons": [
        "brandillon"
    ],
    "brandir": [
        "brandir"
    ],
    "brandira": [
        "brandir"
    ],
    "brandirait": [
        "brandir"
    ],
    "brandirent": [
        "brandir"
    ],
    "brandiront": [
        "brandir"
    ],
    "brandis": [
        "brandir"
    ],
    "brandissaient": [
        "brandir"
    ],
    "brandissais": [
        "brandir"
    ],
    "brandissait": [
        "brandir"
    ],
    "brandissant": [
        "brandir"
    ],
    "brandisse": [
        "brandir"
    ],
    "brandissent": [
        "brandir"
    ],
    "brandissez": [
        "brandir"
    ],
    "brandissiez": [
        "brandir"
    ],
    "brandissions": [
        "brandir"
    ],
    "brandissons": [
        "brandir"
    ],
    "brandit": [
        "brandir"
    ],
    "brandon": [
        "brandon"
    ],
    "brandons": [
        "brandon"
    ],
    "brandouille": [
        "brandouiller"
    ],
    "brandy": [
        "brandy"
    ],
    "branla": [
        "branler"
    ],
    "branlage": [
        "branlage"
    ],
    "branlaient": [
        "branler"
    ],
    "branlais": [
        "branler"
    ],
    "branlait": [
        "branler"
    ],
    "branlant": [
        "branlant",
        "branler"
    ],
    "branlante": [
        "branlant"
    ],
    "branlantes": [
        "branlant"
    ],
    "branlants": [
        "branlant"
    ],
    "branle": [
        "branle",
        "branler"
    ],
    "branlement": [
        "branlement"
    ],
    "branlent": [
        "branler"
    ],
    "branler": [
        "branler"
    ],
    "branlera": [
        "branler"
    ],
    "branlerais": [
        "branler"
    ],
    "branlerait": [
        "branler"
    ],
    "branles": [
        "branle",
        "branler"
    ],
    "branlette": [
        "branlette"
    ],
    "branlettes": [
        "branlette"
    ],
    "branleur": [
        "branleur"
    ],
    "branleurs": [
        "branleur"
    ],
    "branleuse": [
        "branleur"
    ],
    "branleuses": [
        "branleur"
    ],
    "branlez": [
        "branler"
    ],
    "branlochais": [
        "branlocher"
    ],
    "branlochant": [
        "branlocher"
    ],
    "branlochent": [
        "branlocher"
    ],
    "branlee": [
        "branlee",
        "branler"
    ],
    "branque": [
        "branque"
    ],
    "branques": [
        "branque"
    ],
    "branquignol": [
        "branquignol"
    ],
    "branquignols": [
        "branquignol"
    ],
    "braqua": [
        "braquer"
    ],
    "braquage": [
        "braquage"
    ],
    "braquages": [
        "braquage"
    ],
    "braquai": [
        "braquer"
    ],
    "braquaient": [
        "braquer"
    ],
    "braquais": [
        "braquer"
    ],
    "braquait": [
        "braquer"
    ],
    "braquant": [
        "braquer"
    ],
    "braque": [
        "braque",
        "braquer"
    ],
    "braquemart": [
        "braquemart"
    ],
    "braquemarts": [
        "braquemart"
    ],
    "braquent": [
        "braquer"
    ],
    "braquer": [
        "braquer"
    ],
    "braquera": [
        "braquer"
    ],
    "braquerais": [
        "braquer"
    ],
    "braquerait": [
        "braquer"
    ],
    "braques": [
        "braque",
        "braquer"
    ],
    "braquet": [
        "braquet"
    ],
    "braquets": [
        "braquet"
    ],
    "braqueur": [
        "braqueur"
    ],
    "braqueurs": [
        "braqueur"
    ],
    "braqueuse": [
        "braqueur"
    ],
    "braqueuses": [
        "braqueur"
    ],
    "braquez": [
        "braquer"
    ],
    "braquerent": [
        "braquer"
    ],
    "braquee": [
        "braquer"
    ],
    "braquees": [
        "braquer"
    ],
    "bras": [
        "bras",
        "bra"
    ],
    "brasage": [
        "brasage"
    ],
    "braser": [
        "braser"
    ],
    "brasero": [
        "brasero"
    ],
    "braseros": [
        "brasero"
    ],
    "brasier": [
        "brasier"
    ],
    "brasiers": [
        "brasier"
    ],
    "brasillaient": [
        "brasiller"
    ],
    "brasillait": [
        "brasiller"
    ],
    "brasillant": [
        "brasiller"
    ],
    "brasille": [
        "brasiller"
    ],
    "brasillement": [
        "brasillement"
    ],
    "brasiller": [
        "brasiller"
    ],
    "brassage": [
        "brassage"
    ],
    "brassages": [
        "brassage"
    ],
    "brassai": [
        "brasser"
    ],
    "brassaient": [
        "brasser"
    ],
    "brassait": [
        "brasser"
    ],
    "brassant": [
        "brasser"
    ],
    "brassard": [
        "brassard"
    ],
    "brassards": [
        "brassard"
    ],
    "brasse": [
        "brasse",
        "brasser"
    ],
    "brassent": [
        "brasser"
    ],
    "brasser": [
        "brasser"
    ],
    "brasserie": [
        "brasserie"
    ],
    "brasseries": [
        "brasserie"
    ],
    "brasseront": [
        "brasser"
    ],
    "brasses": [
        "brasse",
        "brass",
        "brasser"
    ],
    "brasseur": [
        "brasseur"
    ],
    "brasseurs": [
        "brasseur"
    ],
    "brassez": [
        "brasser"
    ],
    "brassicourt": [
        "brassicourt"
    ],
    "brassions": [
        "brasser"
    ],
    "brassiere": [
        "brassiere"
    ],
    "brassieres": [
        "brassiere"
    ],
    "brassee": [
        "brassee",
        "brasser"
    ],
    "brassees": [
        "brassee",
        "brasser"
    ],
    "brasure": [
        "brasure"
    ],
    "brava": [
        "braver"
    ],
    "bravache": [
        "bravache"
    ],
    "bravaches": [
        "bravache"
    ],
    "bravade": [
        "bravade"
    ],
    "bravades": [
        "bravade"
    ],
    "bravaient": [
        "braver"
    ],
    "bravais": [
        "braver"
    ],
    "bravait": [
        "braver"
    ],
    "bravant": [
        "braver"
    ],
    "brave": [
        "braver",
        "brave"
    ],
    "bravement": [
        "bravement"
    ],
    "bravent": [
        "braver"
    ],
    "braver": [
        "braver",
        "brave"
    ],
    "braverai": [
        "braver"
    ],
    "braveraient": [
        "braver"
    ],
    "braverait": [
        "braver"
    ],
    "braveries": [
        "braverie",
        "bravery"
    ],
    "braveriez": [
        "braver"
    ],
    "braves": [
        "braver",
        "brave"
    ],
    "bravez": [
        "braver"
    ],
    "bravissimo": [
        "bravissimo"
    ],
    "bravo": [
        "bravo"
    ],
    "bravons": [
        "braver"
    ],
    "bravos": [
        "bravo"
    ],
    "bravoure": [
        "bravoure"
    ],
    "braverent": [
        "braver"
    ],
    "bravee": [
        "braver"
    ],
    "brayaient": [
        "brayer"
    ],
    "brayait": [
        "brayer"
    ],
    "braye": [
        "braye"
    ],
    "brayes": [
        "brayer"
    ],
    "brayons": [
        "brayon"
    ],
    "break": [
        "break"
    ],
    "breakdance": [
        "breakdance"
    ],
    "breakfast": [
        "breakfast"
    ],
    "breakfasts": [
        "breakfast"
    ],
    "breaks": [
        "break"
    ],
    "brebis": [
        "brebis"
    ],
    "brechtienne": [
        "brechtien"
    ],
    "bredin": [
        "bredin"
    ],
    "bredouilla": [
        "bredouiller"
    ],
    "bredouillage": [
        "bredouillage"
    ],
    "bredouillai": [
        "bredouiller"
    ],
    "bredouillaient": [
        "bredouiller"
    ],
    "bredouillais": [
        "bredouiller"
    ],
    "bredouillait": [
        "bredouiller"
    ],
    "bredouillant": [
        "bredouiller",
        "bredouillant"
    ],
    "bredouillante": [
        "bredouillant"
    ],
    "bredouille": [
        "bredouiller",
        "bredouille"
    ],
    "bredouillement": [
        "bredouillement"
    ],
    "bredouillements": [
        "bredouillement"
    ],
    "bredouillent": [
        "bredouiller"
    ],
    "bredouiller": [
        "bredouiller"
    ],
    "bredouilles": [
        "bredouiller",
        "bredouille"
    ],
    "bredouilleurs": [
        "bredouilleur"
    ],
    "bredouillez": [
        "bredouiller"
    ],
    "bredouillis": [
        "bredouillis"
    ],
    "bredouillees": [
        "bredouiller"
    ],
    "bref": [
        "bref"
    ],
    "brefs": [
        "bref"
    ],
    "bregma": [
        "bregma"
    ],
    "breitschwanz": [
        "breitschwanz"
    ],
    "brelan": [
        "brelan"
    ],
    "brelans": [
        "brelan"
    ],
    "breloque": [
        "breloque"
    ],
    "breloques": [
        "breloque"
    ],
    "breneuses": [
        "breneux"
    ],
    "breneux": [
        "breneux"
    ],
    "bressan": [
        "bressan"
    ],
    "bressane": [
        "bressan"
    ],
    "bressanes": [
        "bressan"
    ],
    "bressans": [
        "bressan"
    ],
    "brestois": [
        "brestois"
    ],
    "brestoise": [
        "brestois"
    ],
    "bretelle": [
        "bretelle"
    ],
    "bretelles": [
        "bretelle"
    ],
    "breton": [
        "breton"
    ],
    "bretonnant": [
        "bretonnant"
    ],
    "bretonnants": [
        "bretonnant"
    ],
    "bretonne": [
        "breton"
    ],
    "bretonnes": [
        "breton"
    ],
    "bretons": [
        "breton"
    ],
    "brette": [
        "brette"
    ],
    "bretteur": [
        "bretteur"
    ],
    "bretteurs": [
        "bretteur"
    ],
    "bretzel": [
        "bretzel"
    ],
    "bretzels": [
        "bretzel"
    ],
    "breuil": [
        "breuil"
    ],
    "breuils": [
        "breuil"
    ],
    "breuvage": [
        "breuvage"
    ],
    "breuvages": [
        "breuvage"
    ],
    "brevet": [
        "brevet"
    ],
    "breveter": [
        "breveter"
    ],
    "brevets": [
        "brevet"
    ],
    "brevete": [
        "breveter",
        "brevete"
    ],
    "brevetee": [
        "breveter",
        "brevete"
    ],
    "brevetees": [
        "brevete"
    ],
    "brevetes": [
        "breveter",
        "brevete"
    ],
    "bri": [
        "bri"
    ],
    "briard": [
        "briard"
    ],
    "briarde": [
        "briard"
    ],
    "briards": [
        "briard"
    ],
    "bribe": [
        "bribe"
    ],
    "bribes": [
        "bribe"
    ],
    "bricheton": [
        "bricheton"
    ],
    "brick": [
        "brick"
    ],
    "bricks": [
        "brick"
    ],
    "bricola": [
        "bricoler"
    ],
    "bricolage": [
        "bricolage"
    ],
    "bricolages": [
        "bricolage"
    ],
    "bricolaient": [
        "bricoler"
    ],
    "bricolais": [
        "bricoler"
    ],
    "bricolait": [
        "bricoler"
    ],
    "bricolant": [
        "bricoler"
    ],
    "bricole": [
        "bricoler",
        "bricole"
    ],
    "bricolent": [
        "bricoler"
    ],
    "bricoler": [
        "bricoler"
    ],
    "bricoles": [
        "bricoler",
        "bricole"
    ],
    "bricoleur": [
        "bricoleur"
    ],
    "bricoleurs": [
        "bricoleur"
    ],
    "bricoleuse": [
        "bricoleur"
    ],
    "bricolez": [
        "bricoler"
    ],
    "bricolo": [
        "bricolo"
    ],
    "bricolons": [
        "bricoler"
    ],
    "bricolos": [
        "bricolo"
    ],
    "bricolee": [
        "bricoler"
    ],
    "bricolees": [
        "bricoler"
    ],
    "bridais": [
        "brider"
    ],
    "bridait": [
        "brider"
    ],
    "bridant": [
        "brider"
    ],
    "bride": [
        "brider",
        "bride"
    ],
    "brident": [
        "brider"
    ],
    "brider": [
        "brider"
    ],
    "brides": [
        "brider",
        "bride"
    ],
    "bridez": [
        "brider"
    ],
    "bridge": [
        "bridge"
    ],
    "bridgeait": [
        "bridger"
    ],
    "bridgeant": [
        "bridger"
    ],
    "bridgent": [
        "bridger"
    ],
    "bridgeons": [
        "bridger"
    ],
    "bridger": [
        "bridger"
    ],
    "bridges": [
        "bridge"
    ],
    "bridgeurs": [
        "bridgeur"
    ],
    "bridgeuse": [
        "bridgeur"
    ],
    "bridgez": [
        "bridger"
    ],
    "bridgees": [
        "bridger"
    ],
    "bridon": [
        "bridon"
    ],
    "bridons": [
        "bridon"
    ],
    "bridee": [
        "bride",
        "brider"
    ],
    "bridees": [
        "bride",
        "brider"
    ],
    "brie": [
        "brie"
    ],
    "briefe": [
        "briefer"
    ],
    "briefer": [
        "briefer",
        "brief"
    ],
    "briefera": [
        "briefer"
    ],
    "brieferai": [
        "briefer"
    ],
    "brieferas": [
        "briefer"
    ],
    "briefes": [
        "briefer"
    ],
    "briefez": [
        "briefer"
    ],
    "briefing": [
        "briefing",
        "brief"
    ],
    "briefings": [
        "briefing"
    ],
    "briefee": [
        "briefer"
    ],
    "bries": [
        "brie"
    ],
    "brifez": [
        "brifer"
    ],
    "briffe": [
        "briffer"
    ],
    "briffer": [
        "briffer"
    ],
    "brigade": [
        "brigade"
    ],
    "brigades": [
        "brigade"
    ],
    "brigadier": [
        "brigadier"
    ],
    "brigadiers": [
        "brigadier"
    ],
    "brigadiste": [
        "brigadiste"
    ],
    "brigadistes": [
        "brigadiste"
    ],
    "brigand": [
        "brigand"
    ],
    "brigandage": [
        "brigandage"
    ],
    "brigandages": [
        "brigandage"
    ],
    "brigandaient": [
        "brigander"
    ],
    "brigandasse": [
        "brigander"
    ],
    "brigande": [
        "brigander"
    ],
    "brigandeaux": [
        "brigandeau"
    ],
    "brigands": [
        "brigand"
    ],
    "brigantin": [
        "brigantin"
    ],
    "brigantine": [
        "brigantine"
    ],
    "brignolet": [
        "brignolet"
    ],
    "briguaient": [
        "briguer"
    ],
    "briguait": [
        "briguer"
    ],
    "briguant": [
        "briguer"
    ],
    "brigue": [
        "briguer"
    ],
    "briguer": [
        "briguer"
    ],
    "briguerait": [
        "briguer"
    ],
    "brigues": [
        "brigue"
    ],
    "briguerent": [
        "briguer"
    ],
    "brilla": [
        "briller"
    ],
    "brillaient": [
        "briller"
    ],
    "brillais": [
        "briller"
    ],
    "brillait": [
        "briller"
    ],
    "brillamment": [
        "brillamment"
    ],
    "brillance": [
        "brillance"
    ],
    "brillances": [
        "brillance"
    ],
    "brillant": [
        "brillant",
        "briller"
    ],
    "brillantage": [
        "brillantage"
    ],
    "brillante": [
        "brillant",
        "brillanter"
    ],
    "brillantes": [
        "brillant",
        "brillanter"
    ],
    "brillantine": [
        "brillantine",
        "brillantiner"
    ],
    "brillantiner": [
        "brillantiner"
    ],
    "brillantinee": [
        "brillantiner"
    ],
    "brillantinees": [
        "brillantiner"
    ],
    "brillantines": [
        "brillantiner"
    ],
    "brillants": [
        "brillant"
    ],
    "brille": [
        "briller"
    ],
    "brillent": [
        "briller"
    ],
    "briller": [
        "briller"
    ],
    "brillera": [
        "briller"
    ],
    "brilleraient": [
        "briller"
    ],
    "brillerais": [
        "briller"
    ],
    "brillerait": [
        "briller"
    ],
    "brillerons": [
        "briller"
    ],
    "brilleront": [
        "briller"
    ],
    "brilles": [
        "briller"
    ],
    "brillez": [
        "briller"
    ],
    "brillions": [
        "briller"
    ],
    "brillons": [
        "briller"
    ],
    "brillat": [
        "briller"
    ],
    "brillerent": [
        "briller"
    ],
    "brima": [
        "brimer"
    ],
    "brimade": [
        "brimade"
    ],
    "brimades": [
        "brimade"
    ],
    "brimaient": [
        "brimer"
    ],
    "brimais": [
        "brimer"
    ],
    "brimait": [
        "brimer"
    ],
    "brimbala": [
        "brimbaler"
    ],
    "brimbalant": [
        "brimbaler"
    ],
    "brimbalement": [
        "brimbalement"
    ],
    "brimbalements": [
        "brimbalement"
    ],
    "brimbaler": [
        "brimbaler"
    ],
    "brimbales": [
        "brimbaler"
    ],
    "brimborion": [
        "brimborion"
    ],
    "brimborions": [
        "brimborion"
    ],
    "brime": [
        "brimer"
    ],
    "briment": [
        "brimer"
    ],
    "brimer": [
        "brimer"
    ],
    "brimee": [
        "brimer"
    ],
    "brimees": [
        "brimer"
    ],
    "brimes": [
        "brimer"
    ],
    "brin": [
        "brin"
    ],
    "brindes": [
        "brinde"
    ],
    "brindezingue": [
        "brindezingue"
    ],
    "brindille": [
        "brindille"
    ],
    "brindilles": [
        "brindille"
    ],
    "bringue": [
        "bringue"
    ],
    "bringuebalaient": [
        "bringuebaler"
    ],
    "bringuebalait": [
        "bringuebaler"
    ],
    "bringuebalant": [
        "bringuebalant",
        "bringuebaler"
    ],
    "bringuebalante": [
        "bringuebalant"
    ],
    "bringuebalantes": [
        "bringuebalant"
    ],
    "bringuebalants": [
        "bringuebalant"
    ],
    "bringuebale": [
        "bringuebaler"
    ],
    "bringuebalent": [
        "bringuebaler"
    ],
    "bringuebaler": [
        "bringuebaler"
    ],
    "brinquebalait": [
        "brinquebaler"
    ],
    "brinquebalants": [
        "brinquebalant"
    ],
    "brinquebale": [
        "brinquebaler"
    ],
    "brinquebaler": [
        "brinquebaler"
    ],
    "brinqueballant": [
        "brinqueballer"
    ],
    "brinqueballe": [
        "brinqueballer"
    ],
    "brinqueballes": [
        "brinqueballer"
    ],
    "brins": [
        "brin"
    ],
    "brio": [
        "brio"
    ],
    "brioche": [
        "brioche"
    ],
    "brioches": [
        "brioche"
    ],
    "briochee": [
        "brioche"
    ],
    "brions": [
        "brion"
    ],
    "briquage": [
        "briquage"
    ],
    "briquaient": [
        "briquer"
    ],
    "briquais": [
        "briquer"
    ],
    "briquait": [
        "briquer"
    ],
    "briquant": [
        "briquer"
    ],
    "brique": [
        "brique",
        "briquer"
    ],
    "briquent": [
        "briquer"
    ],
    "briquer": [
        "briquer"
    ],
    "briquerait": [
        "briquer"
    ],
    "briques": [
        "brique",
        "briquer"
    ],
    "briquet": [
        "briquet"
    ],
    "briquetage": [
        "briquetage"
    ],
    "briqueterie": [
        "briqueterie"
    ],
    "briqueteries": [
        "briqueterie"
    ],
    "briquetier": [
        "briquetier"
    ],
    "briquets": [
        "briquet"
    ],
    "briquette": [
        "briquette"
    ],
    "briquettes": [
        "briquette"
    ],
    "briquetees": [
        "briquete"
    ],
    "briquez": [
        "briquer"
    ],
    "briquee": [
        "briquer"
    ],
    "briquees": [
        "briquer"
    ],
    "bris": [
        "bris"
    ],
    "brisa": [
        "briser"
    ],
    "brisai": [
        "briser"
    ],
    "brisaient": [
        "briser"
    ],
    "brisais": [
        "briser"
    ],
    "brisait": [
        "briser"
    ],
    "brisant": [
        "briser",
        "brisant"
    ],
    "brisante": [
        "brisant"
    ],
    "brisantes": [
        "brisant"
    ],
    "brisants": [
        "brisant"
    ],
    "briscard": [
        "briscard"
    ],
    "briscards": [
        "briscard"
    ],
    "brise": [
        "briser",
        "brise"
    ],
    "brisent": [
        "briser"
    ],
    "briser": [
        "briser"
    ],
    "brisera": [
        "briser"
    ],
    "briserai": [
        "briser"
    ],
    "briseraient": [
        "briser"
    ],
    "briserais": [
        "briser"
    ],
    "briserait": [
        "briser"
    ],
    "briseras": [
        "briser"
    ],
    "briserez": [
        "briser"
    ],
    "briseriez": [
        "briser"
    ],
    "briserons": [
        "briser"
    ],
    "briseront": [
        "briser"
    ],
    "brises": [
        "briser",
        "brise"
    ],
    "briseur": [
        "briseur"
    ],
    "briseurs": [
        "briseur"
    ],
    "briseuse": [
        "briseur"
    ],
    "brisez": [
        "briser"
    ],
    "brisions": [
        "briser"
    ],
    "brisis": [
        "brisis"
    ],
    "brisons": [
        "briser"
    ],
    "brisque": [
        "brisque"
    ],
    "bristol": [
        "bristol"
    ],
    "bristols": [
        "bristol"
    ],
    "brisure": [
        "brisure"
    ],
    "brisures": [
        "brisure"
    ],
    "brisat": [
        "briser"
    ],
    "briserent": [
        "briser"
    ],
    "brisee": [
        "brisee",
        "briser",
        "brise"
    ],
    "brisees": [
        "brisee",
        "briser"
    ],
    "britannique": [
        "britannique"
    ],
    "britanniques": [
        "britannique"
    ],
    "british": [
        "british"
    ],
    "brivadois": [
        "brivadois"
    ],
    "brivadoise": [
        "brivadois"
    ],
    "brize": [
        "brize"
    ],
    "brievement": [
        "brievement"
    ],
    "brievete": [
        "brievete"
    ],
    "broc": [
        "broc"
    ],
    "brocante": [
        "brocante"
    ],
    "brocantes": [
        "brocante"
    ],
    "brocanteur": [
        "brocanteur"
    ],
    "brocanteurs": [
        "brocanteur"
    ],
    "brocanteuse": [
        "brocanteur"
    ],
    "brocantees": [
        "brocanter"
    ],
    "brocard": [
        "brocard"
    ],
    "brocardaient": [
        "brocarder"
    ],
    "brocardait": [
        "brocarder"
    ],
    "brocarde": [
        "brocarder"
    ],
    "brocarder": [
        "brocarder"
    ],
    "brocardions": [
        "brocarder"
    ],
    "brocards": [
        "brocard"
    ],
    "brocart": [
        "brocart"
    ],
    "brocarts": [
        "brocart"
    ],
    "brocatelle": [
        "brocatelle"
    ],
    "brochage": [
        "brochage"
    ],
    "brochages": [
        "brochage"
    ],
    "brochaient": [
        "brocher"
    ],
    "brochant": [
        "brochant",
        "brocher"
    ],
    "broche": [
        "broche",
        "brocher"
    ],
    "brocher": [
        "brocher"
    ],
    "broches": [
        "broche",
        "brocher"
    ],
    "brochet": [
        "brochet"
    ],
    "brochets": [
        "brochet"
    ],
    "brochette": [
        "brochette"
    ],
    "brochettes": [
        "brochette"
    ],
    "brocheur": [
        "brocheur"
    ],
    "brocheurs": [
        "brocheur"
    ],
    "brochoirs": [
        "brochoir"
    ],
    "brochure": [
        "brochure"
    ],
    "brochures": [
        "brochure"
    ],
    "brochee": [
        "brocher",
        "broche"
    ],
    "brochees": [
        "broche"
    ],
    "brocoli": [
        "brocoli"
    ],
    "brocolis": [
        "brocoli"
    ],
    "brocs": [
        "broc"
    ],
    "broda": [
        "broder"
    ],
    "brodaient": [
        "broder"
    ],
    "brodais": [
        "broder"
    ],
    "brodait": [
        "broder"
    ],
    "brodant": [
        "broder"
    ],
    "brode": [
        "broder",
        "brode"
    ],
    "brodent": [
        "broder"
    ],
    "brodequin": [
        "brodequin"
    ],
    "brodequins": [
        "brodequin"
    ],
    "broder": [
        "broder"
    ],
    "brodera": [
        "broder"
    ],
    "broderai": [
        "broder"
    ],
    "broderie": [
        "broderie"
    ],
    "broderies": [
        "broderie"
    ],
    "brodes": [
        "broder",
        "brode"
    ],
    "brodeuse": [
        "brodeur"
    ],
    "brodeuses": [
        "brodeur"
    ],
    "brodez": [
        "broder"
    ],
    "brodee": [
        "broder",
        "brode"
    ],
    "brodees": [
        "broder",
        "brode"
    ],
    "broie": [
        "broyer"
    ],
    "broiement": [
        "broiement"
    ],
    "broiements": [
        "broiement"
    ],
    "broient": [
        "broyer"
    ],
    "broiera": [
        "broyer"
    ],
    "broierai": [
        "broyer"
    ],
    "broieras": [
        "broyer"
    ],
    "broies": [
        "broyer"
    ],
    "broker": [
        "broker"
    ],
    "brol": [
        "brol"
    ],
    "brome": [
        "brome"
    ],
    "bromure": [
        "bromure"
    ],
    "bromures": [
        "bromure"
    ],
    "broncha": [
        "broncher"
    ],
    "bronchai": [
        "broncher"
    ],
    "bronchaient": [
        "broncher"
    ],
    "bronchais": [
        "broncher"
    ],
    "bronchait": [
        "broncher"
    ],
    "bronchant": [
        "broncher"
    ],
    "bronche": [
        "broncher",
        "bronche"
    ],
    "bronchent": [
        "broncher"
    ],
    "broncher": [
        "broncher"
    ],
    "bronchera": [
        "broncher"
    ],
    "broncherai": [
        "broncher"
    ],
    "broncherais": [
        "broncher"
    ],
    "broncherait": [
        "broncher"
    ],
    "broncherons": [
        "broncher"
    ],
    "broncheront": [
        "broncher"
    ],
    "bronches": [
        "broncher",
        "bronche"
    ],
    "bronchez": [
        "broncher"
    ],
    "bronchioles": [
        "bronchiole"
    ],
    "bronchique": [
        "bronchique"
    ],
    "bronchiques": [
        "bronchique"
    ],
    "bronchite": [
        "bronchite"
    ],
    "bronchites": [
        "bronchite"
    ],
    "bronchitique": [
        "bronchitique"
    ],
    "bronchitiques": [
        "bronchitique"
    ],
    "broncho": [
        "broncho"
    ],
    "bronchons": [
        "broncher"
    ],
    "bronchoscope": [
        "bronchoscope"
    ],
    "bronchoscopie": [
        "bronchoscopie"
    ],
    "bronchat": [
        "broncher"
    ],
    "broncherent": [
        "broncher"
    ],
    "brontosaure": [
        "brontosaure"
    ],
    "brontosaures": [
        "brontosaure"
    ],
    "bronzage": [
        "bronzage"
    ],
    "bronzages": [
        "bronzage"
    ],
    "bronzaient": [
        "bronzer"
    ],
    "bronzait": [
        "bronzer"
    ],
    "bronzant": [
        "bronzer",
        "bronzant"
    ],
    "bronzante": [
        "bronzant"
    ],
    "bronzants": [
        "bronzant"
    ],
    "bronze": [
        "bronze",
        "bronzer"
    ],
    "bronzent": [
        "bronzer"
    ],
    "bronzer": [
        "bronzer"
    ],
    "bronzes": [
        "bronze",
        "bronzer"
    ],
    "bronzette": [
        "bronzette"
    ],
    "bronzettes": [
        "bronzette"
    ],
    "bronzier": [
        "bronzier"
    ],
    "bronzions": [
        "bronzer"
    ],
    "bronzee": [
        "bronze",
        "bronzer"
    ],
    "bronzees": [
        "bronze",
        "bronzer"
    ],
    "brook": [
        "brook"
    ],
    "brooks": [
        "brook"
    ],
    "broquarts": [
        "broquart"
    ],
    "broque": [
        "broque"
    ],
    "broques": [
        "broque"
    ],
    "broquettes": [
        "broquette"
    ],
    "broquille": [
        "broquille"
    ],
    "broquilles": [
        "broquille"
    ],
    "brossa": [
        "brosser"
    ],
    "brossage": [
        "brossage"
    ],
    "brossaient": [
        "brosser"
    ],
    "brossais": [
        "brosser"
    ],
    "brossait": [
        "brosser"
    ],
    "brossant": [
        "brosser"
    ],
    "brosse": [
        "brosser",
        "brosse"
    ],
    "brossent": [
        "brosser"
    ],
    "brosser": [
        "brosser"
    ],
    "brossera": [
        "brosser"
    ],
    "brosserai": [
        "brosser"
    ],
    "brosseras": [
        "brosser"
    ],
    "brosserez": [
        "brosser"
    ],
    "brosses": [
        "brosser",
        "brosse"
    ],
    "brosseur": [
        "brosseur"
    ],
    "brosseurs": [
        "brosseur"
    ],
    "brossez": [
        "brosser"
    ],
    "brossier": [
        "brossier"
    ],
    "brossee": [
        "brosser"
    ],
    "brossees": [
        "brosser"
    ],
    "brou": [
        "brou"
    ],
    "brouet": [
        "brouet"
    ],
    "brouets": [
        "brouet"
    ],
    "brouetta": [
        "brouetter"
    ],
    "brouettait": [
        "brouetter"
    ],
    "brouette": [
        "brouette"
    ],
    "brouetter": [
        "brouetter"
    ],
    "brouettes": [
        "brouette"
    ],
    "brouettee": [
        "brouettee"
    ],
    "brouettees": [
        "brouettee"
    ],
    "brouhaha": [
        "brouhaha"
    ],
    "brouhahas": [
        "brouhaha"
    ],
    "brouilla": [
        "brouiller"
    ],
    "brouillade": [
        "brouillade"
    ],
    "brouillage": [
        "brouillage"
    ],
    "brouillages": [
        "brouillage"
    ],
    "brouillaient": [
        "brouiller"
    ],
    "brouillait": [
        "brouiller"
    ],
    "brouillamini": [
        "brouillamini"
    ],
    "brouillant": [
        "brouiller"
    ],
    "brouillard": [
        "brouillard"
    ],
    "brouillardeuse": [
        "brouillardeux"
    ],
    "brouillardeux": [
        "brouillardeux"
    ],
    "brouillards": [
        "brouillard"
    ],
    "brouillassait": [
        "brouillasser"
    ],
    "brouillasse": [
        "brouillasse"
    ],
    "brouille": [
        "brouiller",
        "brouille"
    ],
    "brouillent": [
        "brouiller"
    ],
    "brouiller": [
        "brouiller"
    ],
    "brouilleraient": [
        "brouiller"
    ],
    "brouillerait": [
        "brouiller"
    ],
    "brouillerons": [
        "brouiller"
    ],
    "brouilles": [
        "brouiller",
        "brouille"
    ],
    "brouilleur": [
        "brouilleur"
    ],
    "brouilleurs": [
        "brouilleur"
    ],
    "brouillez": [
        "brouiller"
    ],
    "brouillon": [
        "brouillon"
    ],
    "brouillonne": [
        "brouillon",
        "brouillonner"
    ],
    "brouillonnes": [
        "brouillon"
    ],
    "brouillons": [
        "brouiller",
        "brouillon"
    ],
    "brouillat": [
        "brouiller"
    ],
    "brouillerent": [
        "brouiller"
    ],
    "brouillee": [
        "brouiller",
        "brouille"
    ],
    "brouillees": [
        "brouiller",
        "brouille"
    ],
    "brouis": [
        "brouir"
    ],
    "brouit": [
        "brouir"
    ],
    "broum": [
        "broum"
    ],
    "broussaille": [
        "broussaille"
    ],
    "broussailles": [
        "broussaille"
    ],
    "broussailleuse": [
        "broussailleux"
    ],
    "broussailleuses": [
        "broussailleux"
    ],
    "broussailleux": [
        "broussailleux"
    ],
    "broussait": [
        "brousser"
    ],
    "broussard": [
        "broussard"
    ],
    "brousse": [
        "brousse"
    ],
    "brousses": [
        "brousse"
    ],
    "brout": [
        "brout"
    ],
    "brouta": [
        "brouter"
    ],
    "broutage": [
        "broutage"
    ],
    "broutaient": [
        "brouter"
    ],
    "broutait": [
        "brouter"
    ],
    "broutant": [
        "brouter"
    ],
    "broutantes": [
        "broutant"
    ],
    "broutard": [
        "broutard"
    ],
    "broute": [
        "brouter"
    ],
    "broutent": [
        "brouter"
    ],
    "brouter": [
        "brouter"
    ],
    "brouterai": [
        "brouter"
    ],
    "brouteraient": [
        "brouter"
    ],
    "broutes": [
        "brouter"
    ],
    "brouteur": [
        "brouteur"
    ],
    "brouteurs": [
        "brouteur"
    ],
    "brouteuse": [
        "brouteur"
    ],
    "brouteuses": [
        "brouteur"
    ],
    "broutez": [
        "brouter"
    ],
    "broutille": [
        "broutille"
    ],
    "broutilles": [
        "broutille"
    ],
    "brouterent": [
        "brouter"
    ],
    "broutee": [
        "brouter"
    ],
    "browning": [
        "brown",
        "browning"
    ],
    "brownings": [
        "browning"
    ],
    "broya": [
        "broyer"
    ],
    "broyage": [
        "broyage"
    ],
    "broyages": [
        "broyage"
    ],
    "broyaient": [
        "broyer"
    ],
    "broyais": [
        "broyer"
    ],
    "broyait": [
        "broyer"
    ],
    "broyant": [
        "broyer"
    ],
    "broyer": [
        "broyer"
    ],
    "broyeur": [
        "broyeur"
    ],
    "broyeurs": [
        "broyeur"
    ],
    "broyeuse": [
        "broyeur"
    ],
    "broyez": [
        "broyer"
    ],
    "broyerent": [
        "broyer"
    ],
    "broye": [
        "broye",
        "broyer"
    ],
    "broyee": [
        "broye",
        "broyer"
    ],
    "broyees": [
        "broye",
        "broyer"
    ],
    "broyes": [
        "broye",
        "broyer"
    ],
    "brrr": [
        "brrr"
    ],
    "bru": [
        "bru"
    ],
    "bruant": [
        "bruant"
    ],
    "bruants": [
        "bruant"
    ],
    "brucellose": [
        "brucellose"
    ],
    "brugeois": [
        "brugeois"
    ],
    "brugeoise": [
        "brugeois"
    ],
    "brugeoises": [
        "brugeois"
    ],
    "bruges": [
        "bruges"
    ],
    "brugnon": [
        "brugnon"
    ],
    "brugnons": [
        "brugnon"
    ],
    "bruinait": [
        "bruiner"
    ],
    "bruinasse": [
        "bruiner"
    ],
    "bruine": [
        "bruiner",
        "bruine"
    ],
    "bruiner": [
        "bruiner"
    ],
    "bruines": [
        "bruine"
    ],
    "bruire": [
        "bruire"
    ],
    "bruissa": [
        "bruisser"
    ],
    "bruissaient": [
        "bruisser"
    ],
    "bruissait": [
        "bruisser"
    ],
    "bruissant": [
        "bruisser",
        "bruissant"
    ],
    "bruissante": [
        "bruissant"
    ],
    "bruissantes": [
        "bruissant"
    ],
    "bruissants": [
        "bruissant"
    ],
    "bruisse": [
        "bruisser"
    ],
    "bruissement": [
        "bruissement"
    ],
    "bruissements": [
        "bruissement"
    ],
    "bruissent": [
        "bruisser"
    ],
    "bruit": [
        "bruire",
        "bruit"
    ],
    "bruita": [
        "bruiter"
    ],
    "bruitage": [
        "bruitage"
    ],
    "bruitages": [
        "bruitage"
    ],
    "bruiter": [
        "bruiter"
    ],
    "bruiteur": [
        "bruiteur"
    ],
    "bruiteuse": [
        "bruiteur"
    ],
    "bruits": [
        "bruit"
    ],
    "brumaille": [
        "brumaille"
    ],
    "brumaire": [
        "brumaire"
    ],
    "brumassait": [
        "brumasser"
    ],
    "brume": [
        "brume"
    ],
    "brument": [
        "brumer"
    ],
    "brumes": [
        "brume"
    ],
    "brumeuse": [
        "brumeux"
    ],
    "brumeuses": [
        "brumeux"
    ],
    "brumeux": [
        "brumeux"
    ],
    "brumisateur": [
        "brumisateur"
    ],
    "brun": [
        "brun"
    ],
    "brunch": [
        "brunch"
    ],
    "brunches": [
        "brunch"
    ],
    "brunchs": [
        "brunch"
    ],
    "brune": [
        "brun",
        "brune"
    ],
    "brunes": [
        "brun",
        "brune"
    ],
    "brunet": [
        "brunet"
    ],
    "brunette": [
        "brunet",
        "brunette"
    ],
    "brunettes": [
        "brunette"
    ],
    "bruni": [
        "bruni",
        "brunir"
    ],
    "brunie": [
        "bruni",
        "brunir"
    ],
    "brunies": [
        "bruni",
        "brunir"
    ],
    "brunir": [
        "brunir"
    ],
    "brunirent": [
        "brunir"
    ],
    "brunis": [
        "bruni",
        "brunir"
    ],
    "brunissage": [
        "brunissage"
    ],
    "brunissaient": [
        "brunir"
    ],
    "brunissent": [
        "brunir"
    ],
    "brunissoir": [
        "brunissoir"
    ],
    "brunissures": [
        "brunissure"
    ],
    "brunit": [
        "brunir"
    ],
    "bruns": [
        "brun"
    ],
    "brunatre": [
        "brunatre"
    ],
    "brunatres": [
        "brunatre"
    ],
    "brus": [
        "bru"
    ],
    "brushing": [
        "brushing",
        "brush"
    ],
    "brusqua": [
        "brusquer"
    ],
    "brusquai": [
        "brusquer"
    ],
    "brusquait": [
        "brusquer"
    ],
    "brusquant": [
        "brusquer"
    ],
    "brusque": [
        "brusque",
        "brusquer"
    ],
    "brusquement": [
        "brusquement"
    ],
    "brusquent": [
        "brusquer"
    ],
    "brusquer": [
        "brusquer"
    ],
    "brusquerai": [
        "brusquer"
    ],
    "brusqueraient": [
        "brusquer"
    ],
    "brusquerie": [
        "brusquerie"
    ],
    "brusqueries": [
        "brusquerie"
    ],
    "brusques": [
        "brusque"
    ],
    "brusquette": [
        "brusquet"
    ],
    "brusquez": [
        "brusquer"
    ],
    "brusquons": [
        "brusquer"
    ],
    "brusquat": [
        "brusquer"
    ],
    "brusquee": [
        "brusquer"
    ],
    "brut": [
        "brut"
    ],
    "brutal": [
        "brutal"
    ],
    "brutale": [
        "brutal"
    ],
    "brutalement": [
        "brutalement"
    ],
    "brutales": [
        "brutal"
    ],
    "brutalisaient": [
        "brutaliser"
    ],
    "brutalisait": [
        "brutaliser"
    ],
    "brutalisant": [
        "brutaliser"
    ],
    "brutalise": [
        "brutaliser"
    ],
    "brutaliser": [
        "brutaliser"
    ],
    "brutaliserai": [
        "brutaliser"
    ],
    "brutaliserait": [
        "brutaliser"
    ],
    "brutalisez": [
        "brutaliser"
    ],
    "brutalisee": [
        "brutaliser"
    ],
    "brutalisees": [
        "brutaliser"
    ],
    "brutalises": [
        "brutaliser"
    ],
    "brutalite": [
        "brutalite"
    ],
    "brutalites": [
        "brutalite"
    ],
    "brutaux": [
        "brutal"
    ],
    "brute": [
        "brute",
        "brut"
    ],
    "brutes": [
        "brute",
        "brut"
    ],
    "bruts": [
        "brut"
    ],
    "bruxellois": [
        "bruxellois"
    ],
    "bruxelloise": [
        "bruxellois"
    ],
    "bruyamment": [
        "bruyamment"
    ],
    "bruyant": [
        "bruyant"
    ],
    "bruyante": [
        "bruyant"
    ],
    "bruyantes": [
        "bruyant"
    ],
    "bruyants": [
        "bruyant"
    ],
    "bruyere": [
        "bruyere"
    ],
    "bruyeres": [
        "bruyere"
    ],
    "breche": [
        "breche"
    ],
    "breches": [
        "breche"
    ],
    "breme": [
        "breme"
    ],
    "bremes": [
        "breme"
    ],
    "breve": [
        "breve",
        "bref"
    ],
    "breves": [
        "breve",
        "bref"
    ],
    "brechet": [
        "brechet"
    ],
    "brehaigne": [
        "brehaigne"
    ],
    "brehaignes": [
        "brehaigne"
    ],
    "bresil": [
        "bresil"
    ],
    "bresilien": [
        "bresilien"
    ],
    "bresilienne": [
        "bresilien"
    ],
    "bresiliennes": [
        "bresilien"
    ],
    "bresiliens": [
        "bresilien"
    ],
    "bresils": [
        "bresil"
    ],
    "breviaire": [
        "breviaire"
    ],
    "breles": [
        "breler"
    ],
    "brula": [
        "bruler"
    ],
    "brulage": [
        "brulage"
    ],
    "brulai": [
        "bruler"
    ],
    "brulaient": [
        "bruler"
    ],
    "brulais": [
        "bruler"
    ],
    "brulait": [
        "bruler"
    ],
    "brulant": [
        "brulant",
        "bruler"
    ],
    "brulante": [
        "brulant"
    ],
    "brulantes": [
        "brulant"
    ],
    "brulants": [
        "brulant"
    ],
    "brulasse": [
        "bruler"
    ],
    "brulassent": [
        "bruler"
    ],
    "brule": [
        "bruler",
        "brule"
    ],
    "brulent": [
        "bruler"
    ],
    "bruler": [
        "bruler"
    ],
    "brulera": [
        "bruler"
    ],
    "brulerai": [
        "bruler"
    ],
    "bruleraient": [
        "bruler"
    ],
    "brulerais": [
        "bruler"
    ],
    "brulerait": [
        "bruler"
    ],
    "bruleras": [
        "bruler"
    ],
    "brulerez": [
        "bruler"
    ],
    "brulerons": [
        "bruler"
    ],
    "bruleront": [
        "bruler"
    ],
    "brules": [
        "bruler",
        "brule"
    ],
    "bruleur": [
        "bruleur"
    ],
    "bruleurs": [
        "bruleur"
    ],
    "bruleuse": [
        "bruleur"
    ],
    "brulez": [
        "bruler"
    ],
    "bruliez": [
        "bruler"
    ],
    "brulions": [
        "bruler"
    ],
    "brulis": [
        "brulis"
    ],
    "bruloirs": [
        "bruloir"
    ],
    "brulons": [
        "bruler"
    ],
    "brulot": [
        "brulot"
    ],
    "brulots": [
        "brulot"
    ],
    "brulure": [
        "brulure"
    ],
    "brulures": [
        "brulure"
    ],
    "brulat": [
        "bruler"
    ],
    "brulerent": [
        "bruler"
    ],
    "brulee": [
        "bruler",
        "brule"
    ],
    "brulees": [
        "bruler",
        "brule"
    ],
    "bu": [
        "bu",
        "boire"
    ],
    "bua": [
        "buer"
    ],
    "buanderie": [
        "buanderie"
    ],
    "buanderies": [
        "buanderie"
    ],
    "bubon": [
        "bubon"
    ],
    "bubonique": [
        "bubonique"
    ],
    "bubons": [
        "bubon"
    ],
    "buccal": [
        "buccal"
    ],
    "buccale": [
        "buccal"
    ],
    "buccales": [
        "buccal"
    ],
    "buccaux": [
        "buccal"
    ],
    "buccin": [
        "buccin"
    ],
    "buccinateur": [
        "buccinateur"
    ],
    "bucco": [
        "bucco"
    ],
    "buccogenitales": [
        "buccogenital"
    ],
    "bucoliastes": [
        "bucoliaste"
    ],
    "bucolique": [
        "bucolique"
    ],
    "bucoliques": [
        "bucolique"
    ],
    "bucranes": [
        "bucrane"
    ],
    "bucephales": [
        "bucephale"
    ],
    "buddha": [
        "buddha"
    ],
    "budget": [
        "budget"
    ],
    "budgets": [
        "budget"
    ],
    "budgetaire": [
        "budgetaire"
    ],
    "budgetairement": [
        "budgetairement"
    ],
    "budgetaires": [
        "budgetaire"
    ],
    "budgetisation": [
        "budgetisation"
    ],
    "budgetivores": [
        "budgetivore"
    ],
    "bue": [
        "bu"
    ],
    "bues": [
        "bu"
    ],
    "buffalo": [
        "buffalo"
    ],
    "buffet": [
        "buffet"
    ],
    "buffets": [
        "buffet"
    ],
    "buffle": [
        "buffle"
    ],
    "buffles": [
        "buffle"
    ],
    "buffleterie": [
        "buffleterie"
    ],
    "buffleteries": [
        "buffleterie"
    ],
    "bufflonne": [
        "bufflon"
    ],
    "bufo": [
        "bufo"
    ],
    "bug": [
        "bug"
    ],
    "buggy": [
        "buggy"
    ],
    "bugle": [
        "bugle"
    ],
    "bugler": [
        "bugler"
    ],
    "bugles": [
        "bugle"
    ],
    "bugne": [
        "bugner",
        "bugne"
    ],
    "bugnes": [
        "bugne"
    ],
    "bugs": [
        "bug"
    ],
    "building": [
        "build",
        "building"
    ],
    "buildings": [
        "building"
    ],
    "buires": [
        "buire"
    ],
    "buis": [
        "buis"
    ],
    "buisson": [
        "buisson"
    ],
    "buissonnant": [
        "buissonnant",
        "buissonner"
    ],
    "buissonnants": [
        "buissonnant"
    ],
    "buissonne": [
        "buissonner"
    ],
    "buissonner": [
        "buissonner"
    ],
    "buissonneuse": [
        "buissonneux"
    ],
    "buissonneuses": [
        "buissonneux"
    ],
    "buissonneux": [
        "buissonneux"
    ],
    "buissonniere": [
        "buissonnier"
    ],
    "buissonnieres": [
        "buissonnier"
    ],
    "buissons": [
        "buisson"
    ],
    "bulbe": [
        "bulbe"
    ],
    "bulbes": [
        "bulbe"
    ],
    "bulbeuse": [
        "bulbeux"
    ],
    "bulbeux": [
        "bulbeux"
    ],
    "bulbul": [
        "bulbul"
    ],
    "bulgare": [
        "bulgare"
    ],
    "bulgares": [
        "bulgare"
    ],
    "bulgaro": [
        "bulgaro"
    ],
    "bulge": [
        "bulge"
    ],
    "bull": [
        "bull"
    ],
    "bulla": [
        "buller"
    ],
    "bullaire": [
        "bullaire"
    ],
    "bulldog": [
        "bulldog"
    ],
    "bulldogs": [
        "bulldog"
    ],
    "bulldozer": [
        "bulldozer"
    ],
    "bulldozers": [
        "bulldozer"
    ],
    "bulle": [
        "buller",
        "bulle"
    ],
    "buller": [
        "buller"
    ],
    "bulles": [
        "buller",
        "bulle"
    ],
    "bulletin": [
        "bulletin"
    ],
    "bulletins": [
        "bulletin"
    ],
    "bulleux": [
        "bulleux"
    ],
    "bullez": [
        "buller"
    ],
    "bulls": [
        "bull"
    ],
    "bulot": [
        "bulot"
    ],
    "bulots": [
        "bulot"
    ],
    "bumper": [
        "bumper"
    ],
    "buna": [
        "buna"
    ],
    "bungalow": [
        "bungalow"
    ],
    "bungalows": [
        "bungalow"
    ],
    "bunker": [
        "bunker"
    ],
    "bunkers": [
        "bunker"
    ],
    "bunraku": [
        "bunraku"
    ],
    "bunsen": [
        "bunsen"
    ],
    "buprestes": [
        "bupreste"
    ],
    "buraliste": [
        "buraliste"
    ],
    "buralistes": [
        "buraliste"
    ],
    "bure": [
        "bure"
    ],
    "bureau": [
        "bureau"
    ],
    "bureaucrate": [
        "bureaucrate"
    ],
    "bureaucrates": [
        "bureaucrate"
    ],
    "bureaucratie": [
        "bureaucratie"
    ],
    "bureaucraties": [
        "bureaucratie"
    ],
    "bureaucratique": [
        "bureaucratique"
    ],
    "bureaucratiquement": [
        "bureaucratiquement"
    ],
    "bureaucratiques": [
        "bureaucratique"
    ],
    "bureaucratisees": [
        "bureaucratiser"
    ],
    "bureautique": [
        "bureautique"
    ],
    "bureaux": [
        "bureau"
    ],
    "burent": [
        "boire"
    ],
    "burette": [
        "burette"
    ],
    "burettes": [
        "burette"
    ],
    "burg": [
        "burg"
    ],
    "burger": [
        "burger"
    ],
    "burgers": [
        "burger"
    ],
    "burgondes": [
        "burgonde"
    ],
    "burgraviat": [
        "burgraviat"
    ],
    "burin": [
        "burin"
    ],
    "burina": [
        "buriner"
    ],
    "buriner": [
        "buriner"
    ],
    "burins": [
        "burin"
    ],
    "burine": [
        "buriner",
        "burine"
    ],
    "burinee": [
        "buriner",
        "burine"
    ],
    "burinees": [
        "burine"
    ],
    "burines": [
        "buriner",
        "burine"
    ],
    "burkinabe": [
        "burkinabe"
    ],
    "burlesque": [
        "burlesque"
    ],
    "burlesques": [
        "burlesque"
    ],
    "burlingue": [
        "burlingue"
    ],
    "burlingues": [
        "burlingue"
    ],
    "burne": [
        "burne"
    ],
    "burnes": [
        "burne"
    ],
    "burnous": [
        "burnous"
    ],
    "burons": [
        "buron"
    ],
    "bursite": [
        "bursite"
    ],
    "burundais": [
        "burundais"
    ],
    "bus": [
        "bus",
        "boire"
    ],
    "busard": [
        "busard"
    ],
    "busards": [
        "busard"
    ],
    "buse": [
        "buse"
    ],
    "buses": [
        "buse",
        "bus"
    ],
    "bush": [
        "bush"
    ],
    "bushi": [
        "bushi"
    ],
    "bushido": [
        "bushido"
    ],
    "bushman": [
        "bushman"
    ],
    "business": [
        "business"
    ],
    "businessman": [
        "businessman"
    ],
    "businessmen": [
        "businessman"
    ],
    "busque": [
        "busque",
        "busquer"
    ],
    "busse": [
        "boire"
    ],
    "buste": [
        "buste"
    ],
    "bustes": [
        "buste"
    ],
    "bustier": [
        "bustier"
    ],
    "but": [
        "but",
        "boire"
    ],
    "buta": [
        "buter"
    ],
    "butadiene": [
        "butadiene"
    ],
    "butagaz": [
        "butagaz"
    ],
    "butai": [
        "buter"
    ],
    "butaient": [
        "buter"
    ],
    "butais": [
        "buter"
    ],
    "butait": [
        "buter"
    ],
    "butane": [
        "butane"
    ],
    "butant": [
        "buter"
    ],
    "bute": [
        "buter",
        "bute"
    ],
    "butent": [
        "buter"
    ],
    "buter": [
        "buter"
    ],
    "butera": [
        "buter"
    ],
    "buterai": [
        "buter"
    ],
    "buterais": [
        "buter"
    ],
    "buterait": [
        "buter"
    ],
    "buteras": [
        "buter"
    ],
    "buterez": [
        "buter"
    ],
    "buterions": [
        "buter"
    ],
    "buteront": [
        "buter"
    ],
    "butes": [
        "buter",
        "bute"
    ],
    "buteur": [
        "buteur"
    ],
    "butez": [
        "buter"
    ],
    "butin": [
        "butin"
    ],
    "butinait": [
        "butiner"
    ],
    "butinant": [
        "butiner"
    ],
    "butine": [
        "butiner"
    ],
    "butinent": [
        "butiner"
    ],
    "butiner": [
        "butiner"
    ],
    "butines": [
        "butiner"
    ],
    "butineur": [
        "butineur"
    ],
    "butineuse": [
        "butineur"
    ],
    "butineuses": [
        "butineur"
    ],
    "butins": [
        "butin"
    ],
    "butinees": [
        "butiner"
    ],
    "butoir": [
        "butoir"
    ],
    "butoirs": [
        "butoir"
    ],
    "butons": [
        "buter"
    ],
    "butor": [
        "butor"
    ],
    "butors": [
        "butor"
    ],
    "buts": [
        "but"
    ],
    "butte": [
        "butte",
        "butter"
    ],
    "butter": [
        "butter"
    ],
    "buttes": [
        "butte",
        "butter"
    ],
    "butteur": [
        "butteur"
    ],
    "buttoir": [
        "buttoir"
    ],
    "butterent": [
        "butter"
    ],
    "buterent": [
        "buter"
    ],
    "butee": [
        "butee",
        "buter",
        "bute"
    ],
    "butees": [
        "buter",
        "bute"
    ],
    "buvable": [
        "buvable"
    ],
    "buvables": [
        "buvable"
    ],
    "buvaient": [
        "boire"
    ],
    "buvais": [
        "boire"
    ],
    "buvait": [
        "boire"
    ],
    "buvant": [
        "buvant",
        "boire"
    ],
    "buvard": [
        "buvard"
    ],
    "buvarde": [
        "buvarder"
    ],
    "buvards": [
        "buvard"
    ],
    "buvardes": [
        "buvarder"
    ],
    "buvette": [
        "buvette"
    ],
    "buvettes": [
        "buvette"
    ],
    "buveur": [
        "buveur"
    ],
    "buveurs": [
        "buveur"
    ],
    "buveuse": [
        "buveur"
    ],
    "buvez": [
        "boire"
    ],
    "buviez": [
        "boire"
    ],
    "buvions": [
        "boire"
    ],
    "buvons": [
        "boire"
    ],
    "buee": [
        "buee"
    ],
    "buees": [
        "buee"
    ],
    "by": [
        "by"
    ],
    "bye": [
        "bye"
    ],
    "byronien": [
        "byronien"
    ],
    "bytes": [
        "byte"
    ],
    "bytures": [
        "byture"
    ],
    "byzantin": [
        "byzantin"
    ],
    "byzantine": [
        "byzantin"
    ],
    "byzantines": [
        "byzantin",
        "byzantine"
    ],
    "byzantinisant": [
        "byzantinisant"
    ],
    "byzantinisme": [
        "byzantinisme"
    ],
    "byzantins": [
        "byzantin"
    ],
    "babord": [
        "babord"
    ],
    "bache": [
        "bacher",
        "bache"
    ],
    "bacher": [
        "bacher"
    ],
    "baches": [
        "bache",
        "bach"
    ],
    "bachee": [
        "bacher",
        "bache"
    ],
    "bachees": [
        "bacher",
        "bache"
    ],
    "bacla": [
        "bacler"
    ],
    "baclai": [
        "bacler"
    ],
    "baclaient": [
        "bacler"
    ],
    "baclais": [
        "bacler"
    ],
    "baclait": [
        "bacler"
    ],
    "baclant": [
        "bacler"
    ],
    "bacle": [
        "bacler"
    ],
    "bacler": [
        "bacler"
    ],
    "baclera": [
        "bacler"
    ],
    "baclerait": [
        "bacler"
    ],
    "bacles": [
        "bacler"
    ],
    "bacleurs": [
        "bacleur"
    ],
    "baclez": [
        "bacler"
    ],
    "baclons": [
        "bacler"
    ],
    "baclee": [
        "bacler"
    ],
    "baclees": [
        "bacler"
    ],
    "bafra": [
        "bafrer"
    ],
    "bafraient": [
        "bafrer"
    ],
    "bafrais": [
        "bafrer"
    ],
    "bafrait": [
        "bafrer"
    ],
    "bafrant": [
        "bafrer"
    ],
    "bafre": [
        "bafrer"
    ],
    "bafrements": [
        "bafrement"
    ],
    "bafrer": [
        "bafrer"
    ],
    "bafres": [
        "bafrer"
    ],
    "bafreur": [
        "bafreur"
    ],
    "bafreurs": [
        "bafreur"
    ],
    "bafrez": [
        "bafrer"
    ],
    "bafrerent": [
        "bafrer"
    ],
    "bailla": [
        "bailler"
    ],
    "baillai": [
        "bailler"
    ],
    "baillaient": [
        "bailler"
    ],
    "baillais": [
        "bailler"
    ],
    "baillante": [
        "baillant"
    ],
    "baillantes": [
        "baillant"
    ],
    "baillement": [
        "baillement"
    ],
    "baillements": [
        "baillement"
    ],
    "baillent": [
        "bailler"
    ],
    "baillera": [
        "bailler"
    ],
    "baillerez": [
        "bailler"
    ],
    "baillon": [
        "baillon"
    ],
    "baillonna": [
        "baillonner"
    ],
    "baillonnait": [
        "baillonner"
    ],
    "baillonnant": [
        "baillonner"
    ],
    "baillonne": [
        "baillonner"
    ],
    "baillonnent": [
        "baillonner"
    ],
    "baillonner": [
        "baillonner"
    ],
    "baillonnera": [
        "baillonner"
    ],
    "baillonnerait": [
        "baillonner"
    ],
    "baillonnez": [
        "baillonner"
    ],
    "baillonnons": [
        "baillonner"
    ],
    "baillonnee": [
        "baillonner"
    ],
    "baillonnes": [
        "baillonner"
    ],
    "baillons": [
        "baillon"
    ],
    "baillames": [
        "bailler"
    ],
    "baillerent": [
        "bailler"
    ],
    "batard": [
        "batard"
    ],
    "batarde": [
        "batard"
    ],
    "batardes": [
        "batard"
    ],
    "batardise": [
        "batardise"
    ],
    "batardises": [
        "batardise"
    ],
    "batards": [
        "batard"
    ],
    "bater": [
        "bater"
    ],
    "bati": [
        "batir",
        "bati"
    ],
    "batie": [
        "batir",
        "bati"
    ],
    "baties": [
        "batir",
        "bati"
    ],
    "batiment": [
        "batiment"
    ],
    "batiments": [
        "batiment"
    ],
    "batir": [
        "batir"
    ],
    "batira": [
        "batir"
    ],
    "batirai": [
        "batir"
    ],
    "batirais": [
        "batir"
    ],
    "batirait": [
        "batir"
    ],
    "batirent": [
        "batir"
    ],
    "batirions": [
        "batir"
    ],
    "batirons": [
        "batir"
    ],
    "batiront": [
        "batir"
    ],
    "batis": [
        "batir",
        "bati"
    ],
    "batissaient": [
        "batir"
    ],
    "batissais": [
        "batir"
    ],
    "batissait": [
        "batir"
    ],
    "batissant": [
        "batir"
    ],
    "batisse": [
        "batir",
        "batisse"
    ],
    "batissent": [
        "batir"
    ],
    "batisses": [
        "batisse"
    ],
    "batisseur": [
        "batisseur"
    ],
    "batisseurs": [
        "batisseur"
    ],
    "batisseuse": [
        "batisseur"
    ],
    "batissez": [
        "batir"
    ],
    "batissions": [
        "batir"
    ],
    "batissons": [
        "batir"
    ],
    "batit": [
        "batir"
    ],
    "batiere": [
        "batier"
    ],
    "baton": [
        "baton"
    ],
    "batonnant": [
        "batonner"
    ],
    "batonner": [
        "batonner"
    ],
    "batonnet": [
        "batonnet"
    ],
    "batonnets": [
        "batonnet"
    ],
    "batonnier": [
        "batonnier"
    ],
    "batonnee": [
        "batonner"
    ],
    "batons": [
        "bater",
        "baton"
    ],
    "bate": [
        "bater",
        "bate"
    ],
    "bates": [
        "bater",
        "bate"
    ],
    "begue": [
        "begue"
    ],
    "begues": [
        "begue"
    ],
    "be": [
        "be"
    ],
    "bea": [
        "beer"
    ],
    "beaient": [
        "beer"
    ],
    "beait": [
        "beer"
    ],
    "beance": [
        "beance"
    ],
    "beant": [
        "beant",
        "beer"
    ],
    "beante": [
        "beant"
    ],
    "beantes": [
        "beant"
    ],
    "beants": [
        "beant"
    ],
    "bearnais": [
        "bearnais"
    ],
    "bearnaise": [
        "bearnais"
    ],
    "beate": [
        "beat"
    ],
    "beatement": [
        "beatement"
    ],
    "beates": [
        "beat"
    ],
    "beatification": [
        "beatification"
    ],
    "beatifications": [
        "beatification"
    ],
    "beatifier": [
        "beatifier"
    ],
    "beatifique": [
        "beatifique"
    ],
    "beatifie": [
        "beatifier"
    ],
    "beatifiee": [
        "beatifier"
    ],
    "beatifies": [
        "beatifier"
    ],
    "beatitude": [
        "beatitude"
    ],
    "beatitudes": [
        "beatitude"
    ],
    "beats": [
        "beat"
    ],
    "bebe": [
        "bebe"
    ],
    "bebes": [
        "bebe"
    ],
    "bebete": [
        "bebete"
    ],
    "bebetes": [
        "bebete"
    ],
    "becabunga": [
        "becabunga"
    ],
    "becane": [
        "becane"
    ],
    "becanes": [
        "becane"
    ],
    "becard": [
        "becard"
    ],
    "becarre": [
        "becarre"
    ],
    "becasse": [
        "becasse"
    ],
    "becasses": [
        "becasse"
    ],
    "becassine": [
        "becassine"
    ],
    "becassines": [
        "becassine"
    ],
    "bechamel": [
        "bechamel"
    ],
    "becher": [
        "becher"
    ],
    "becot": [
        "becot"
    ],
    "becotait": [
        "becoter"
    ],
    "becotant": [
        "becoter"
    ],
    "becote": [
        "becoter"
    ],
    "becotent": [
        "becoter"
    ],
    "becoter": [
        "becoter"
    ],
    "becoteur": [
        "becoteur"
    ],
    "becots": [
        "becot"
    ],
    "becotee": [
        "becoter"
    ],
    "becotes": [
        "becoter"
    ],
    "bedane": [
        "bedane"
    ],
    "bedouin": [
        "bedouin"
    ],
    "bedouine": [
        "bedouin"
    ],
    "bedouines": [
        "bedouin"
    ],
    "bedouins": [
        "bedouin"
    ],
    "bede": [
        "bede"
    ],
    "bedephiles": [
        "bedephile"
    ],
    "bedes": [
        "bede"
    ],
    "bee": [
        "be",
        "beer",
        "bee"
    ],
    "beent": [
        "beer"
    ],
    "beer": [
        "beer"
    ],
    "bees": [
        "be",
        "bee"
    ],
    "begaie": [
        "begayer"
    ],
    "begaiement": [
        "begaiement"
    ],
    "begaiements": [
        "begaiement"
    ],
    "begaient": [
        "begayer"
    ],
    "begaiera": [
        "begayer"
    ],
    "begaies": [
        "begayer"
    ],
    "begaya": [
        "begayer"
    ],
    "begayai": [
        "begayer"
    ],
    "begayaient": [
        "begayer"
    ],
    "begayais": [
        "begayer"
    ],
    "begayait": [
        "begayer"
    ],
    "begayant": [
        "begayer",
        "begayant"
    ],
    "begayante": [
        "begayant"
    ],
    "begayantes": [
        "begayant"
    ],
    "begayants": [
        "begayant"
    ],
    "begaye": [
        "begayer"
    ],
    "begayer": [
        "begayer"
    ],
    "begayes": [
        "begayer"
    ],
    "begayeur": [
        "begayeur"
    ],
    "begayez": [
        "begayer"
    ],
    "begayees": [
        "begayer"
    ],
    "begonias": [
        "begonia"
    ],
    "begueule": [
        "begueule"
    ],
    "begueulerie": [
        "begueulerie"
    ],
    "begueules": [
        "begueule"
    ],
    "beguin": [
        "beguin"
    ],
    "beguinage": [
        "beguinage"
    ],
    "beguine": [
        "beguine"
    ],
    "beguineuse": [
        "beguineuse"
    ],
    "beguins": [
        "beguin"
    ],
    "begum": [
        "begum"
    ],
    "beheme": [
        "beheme"
    ],
    "behemoth": [
        "behemoth"
    ],
    "bejaune": [
        "bejaune"
    ],
    "belier": [
        "belier"
    ],
    "beliers": [
        "belier"
    ],
    "belinogramme": [
        "belinogramme"
    ],
    "belouga": [
        "belouga"
    ],
    "belitre": [
        "belitre"
    ],
    "bemol": [
        "bemol"
    ],
    "bemolise": [
        "bemoliser"
    ],
    "bemols": [
        "bemol"
    ],
    "benard": [
        "benard"
    ],
    "benarde": [
        "benard"
    ],
    "benards": [
        "benard"
    ],
    "benef": [
        "benef"
    ],
    "benefs": [
        "benef"
    ],
    "beni": [
        "benir"
    ],
    "benie": [
        "benir"
    ],
    "benies": [
        "benir"
    ],
    "benigne": [
        "benin"
    ],
    "benignement": [
        "benignement"
    ],
    "benignes": [
        "benin"
    ],
    "benignite": [
        "benignite"
    ],
    "benin": [
        "benin"
    ],
    "beninois": [
        "beninois"
    ],
    "benins": [
        "benin"
    ],
    "benir": [
        "benir"
    ],
    "benira": [
        "benir"
    ],
    "benirai": [
        "benir"
    ],
    "benirais": [
        "benir"
    ],
    "benirait": [
        "benir"
    ],
    "beniras": [
        "benir"
    ],
    "benirez": [
        "benir"
    ],
    "benirons": [
        "benir"
    ],
    "beniront": [
        "benir"
    ],
    "benis": [
        "benir"
    ],
    "benissaient": [
        "benir"
    ],
    "benissais": [
        "benir"
    ],
    "benissait": [
        "benir"
    ],
    "benissant": [
        "benir"
    ],
    "benisse": [
        "benir"
    ],
    "benissent": [
        "benir"
    ],
    "benisseur": [
        "benisseur"
    ],
    "benisseurs": [
        "benisseur"
    ],
    "benisseuse": [
        "benisseur"
    ],
    "benissez": [
        "benir"
    ],
    "benissions": [
        "benir"
    ],
    "benissons": [
        "benir"
    ],
    "benit": [
        "benir",
        "benit"
    ],
    "benite": [
        "benit"
    ],
    "benites": [
        "benit"
    ],
    "benitier": [
        "benitier"
    ],
    "benitiers": [
        "benitier"
    ],
    "benits": [
        "benit"
    ],
    "benouze": [
        "benouze"
    ],
    "benedicite": [
        "benedicite"
    ],
    "benedicites": [
        "benedicite"
    ],
    "benedictin": [
        "benedictin"
    ],
    "benedictine": [
        "benedictin"
    ],
    "benedictines": [
        "benedictine",
        "benedictin"
    ],
    "benedictins": [
        "benedictin"
    ],
    "benediction": [
        "benediction"
    ],
    "benedictions": [
        "benediction"
    ],
    "benefice": [
        "benefice"
    ],
    "benefices": [
        "benefice"
    ],
    "beneficia": [
        "beneficier"
    ],
    "beneficiaient": [
        "beneficier"
    ],
    "beneficiaire": [
        "beneficiaire"
    ],
    "beneficiaires": [
        "beneficiaire"
    ],
    "beneficiais": [
        "beneficier"
    ],
    "beneficiait": [
        "beneficier"
    ],
    "beneficiant": [
        "beneficier"
    ],
    "beneficie": [
        "beneficier"
    ],
    "beneficient": [
        "beneficier"
    ],
    "beneficier": [
        "beneficier"
    ],
    "beneficiera": [
        "beneficier"
    ],
    "beneficierai": [
        "beneficier"
    ],
    "beneficierais": [
        "beneficier"
    ],
    "beneficierait": [
        "beneficier"
    ],
    "beneficierez": [
        "beneficier"
    ],
    "beneficierons": [
        "beneficier"
    ],
    "beneficies": [
        "beneficier"
    ],
    "beneficiez": [
        "beneficier"
    ],
    "beneficions": [
        "beneficier"
    ],
    "beneficiat": [
        "beneficier"
    ],
    "beneficierent": [
        "beneficier"
    ],
    "benefique": [
        "benefique"
    ],
    "benefiques": [
        "benefique"
    ],
    "benevolat": [
        "benevolat"
    ],
    "benevole": [
        "benevole"
    ],
    "benevolement": [
        "benevolement"
    ],
    "benevolence": [
        "benevolence"
    ],
    "benevoles": [
        "benevole"
    ],
    "beotien": [
        "beotien"
    ],
    "beotienne": [
        "beotien"
    ],
    "beotiens": [
        "beotien"
    ],
    "bequant": [
        "bequer"
    ],
    "bequillant": [
        "bequiller"
    ],
    "bequillard": [
        "bequillard"
    ],
    "bequille": [
        "bequille"
    ],
    "bequillent": [
        "bequiller"
    ],
    "bequilles": [
        "bequille"
    ],
    "bequilleux": [
        "bequilleux"
    ],
    "beret": [
        "beret"
    ],
    "berets": [
        "beret"
    ],
    "beriberi": [
        "beriberi"
    ],
    "berullienne": [
        "berullien"
    ],
    "beryl": [
        "beryl"
    ],
    "beryllium": [
        "beryllium"
    ],
    "beryls": [
        "beryl"
    ],
    "berezina": [
        "berezina"
    ],
    "besiclard": [
        "besiclard"
    ],
    "besigue": [
        "besigue"
    ],
    "betail": [
        "betail"
    ],
    "betaillere": [
        "betaillere"
    ],
    "betailleres": [
        "betaillere"
    ],
    "betails": [
        "betail"
    ],
    "betel": [
        "betel"
    ],
    "betoine": [
        "betoine"
    ],
    "beton": [
        "beton"
    ],
    "betonnage": [
        "betonnage"
    ],
    "betonnaient": [
        "betonner"
    ],
    "betonner": [
        "betonner"
    ],
    "betonneurs": [
        "betonneur"
    ],
    "betonneuse": [
        "betonneur"
    ],
    "betonneuses": [
        "betonneur"
    ],
    "betonniere": [
        "betonniere"
    ],
    "betonnieres": [
        "betonniere"
    ],
    "betonne": [
        "betonne",
        "betonner"
    ],
    "betonnee": [
        "betonne",
        "betonner"
    ],
    "betonnees": [
        "betonne"
    ],
    "betonnes": [
        "betonne",
        "betonner"
    ],
    "betons": [
        "beton"
    ],
    "bevue": [
        "bevue"
    ],
    "bevues": [
        "bevue"
    ],
    "bezoard": [
        "bezoard"
    ],
    "beerent": [
        "beer"
    ],
    "beee": [
        "beer"
    ],
    "bechaient": [
        "becher"
    ],
    "bechait": [
        "becher"
    ],
    "bechant": [
        "becher"
    ],
    "beche": [
        "beche",
        "becher"
    ],
    "bechent": [
        "becher"
    ],
    "beches": [
        "beche"
    ],
    "becheur": [
        "becheur"
    ],
    "becheurs": [
        "becheur"
    ],
    "becheuse": [
        "becheur"
    ],
    "becheuses": [
        "becheur"
    ],
    "belaient": [
        "beler"
    ],
    "belait": [
        "beler"
    ],
    "belant": [
        "beler",
        "belant"
    ],
    "belantes": [
        "belant"
    ],
    "belants": [
        "belant"
    ],
    "bele": [
        "beler"
    ],
    "belement": [
        "belement"
    ],
    "belements": [
        "belement"
    ],
    "belent": [
        "beler"
    ],
    "beler": [
        "beler"
    ],
    "beta": [
        "beta"
    ],
    "betas": [
        "beta"
    ],
    "betasse": [
        "beta"
    ],
    "betasses": [
        "beta"
    ],
    "betatron": [
        "betatron"
    ],
    "bete": [
        "bete"
    ],
    "betement": [
        "betement"
    ],
    "betes": [
        "bete"
    ],
    "betifia": [
        "betifier"
    ],
    "betifiaient": [
        "betifier"
    ],
    "betifiais": [
        "betifier"
    ],
    "betifiait": [
        "betifier"
    ],
    "betifiant": [
        "betifiant"
    ],
    "betifie": [
        "betifier"
    ],
    "betifier": [
        "betifier"
    ],
    "betise": [
        "betise"
    ],
    "betises": [
        "betise"
    ],
    "betisier": [
        "betisier"
    ],
    "bome": [
        "bome"
    ],
    "buchais": [
        "bucher"
    ],
    "buchant": [
        "bucher"
    ],
    "buche": [
        "buche",
        "bucher"
    ],
    "buchent": [
        "bucher"
    ],
    "bucher": [
        "bucher"
    ],
    "bucheron": [
        "bucheron"
    ],
    "bucheronne": [
        "bucheronner"
    ],
    "bucheronner": [
        "bucheronner"
    ],
    "bucherons": [
        "bucher",
        "bucheron"
    ],
    "buchers": [
        "bucher"
    ],
    "buches": [
        "buche",
        "bucher"
    ],
    "buchette": [
        "buchette"
    ],
    "buchettes": [
        "buchette"
    ],
    "bucheur": [
        "bucheur"
    ],
    "bucheurs": [
        "bucheur"
    ],
    "bucheuse": [
        "bucheur"
    ],
    "bucheuses": [
        "bucheur"
    ],
    "buchez": [
        "bucher"
    ],
    "bumes": [
        "boire"
    ],
    "c": [
        "c"
    ],
    "c'": [
        "ce"
    ],
    "cab": [
        "cab"
    ],
    "cabale": [
        "cabale"
    ],
    "cabales": [
        "cabale"
    ],
    "cabaliste": [
        "cabaliste"
    ],
    "cabalistes": [
        "cabaliste"
    ],
    "cabalistique": [
        "cabalistique"
    ],
    "cabalistiques": [
        "cabalistique"
    ],
    "caballero": [
        "caballero"
    ],
    "caban": [
        "caban"
    ],
    "cabana": [
        "cabaner"
    ],
    "cabane": [
        "cabane"
    ],
    "cabanes": [
        "cabane"
    ],
    "cabanettes": [
        "cabanette"
    ],
    "cabanon": [
        "cabanon"
    ],
    "cabanons": [
        "cabanon"
    ],
    "cabans": [
        "caban"
    ],
    "cabaret": [
        "cabaret"
    ],
    "cabaretier": [
        "cabaretier"
    ],
    "cabaretiers": [
        "cabaretier"
    ],
    "cabaretiere": [
        "cabaretier"
    ],
    "cabarets": [
        "cabaret"
    ],
    "cabas": [
        "cabas"
    ],
    "caberlot": [
        "caberlot"
    ],
    "cabernet": [
        "cabernet"
    ],
    "cabestan": [
        "cabestan"
    ],
    "cabiais": [
        "cabiai"
    ],
    "cabillaud": [
        "cabillaud"
    ],
    "cabillots": [
        "cabillot"
    ],
    "cabine": [
        "cabine"
    ],
    "cabiner": [
        "cabiner"
    ],
    "cabines": [
        "cabine"
    ],
    "cabinet": [
        "cabinet"
    ],
    "cabinets": [
        "cabinet"
    ],
    "cabochard": [
        "cabochard"
    ],
    "cabocharde": [
        "cabochard"
    ],
    "cabochards": [
        "cabochard"
    ],
    "caboche": [
        "caboche"
    ],
    "caboches": [
        "caboche"
    ],
    "cabochon": [
        "cabochon"
    ],
    "cabochons": [
        "cabochon"
    ],
    "cabossa": [
        "cabosser"
    ],
    "cabossages": [
        "cabossage"
    ],
    "cabossait": [
        "cabosser"
    ],
    "cabosse": [
        "cabosse",
        "cabosser"
    ],
    "cabosser": [
        "cabosser"
    ],
    "cabosses": [
        "cabosse",
        "cabosser"
    ],
    "cabossee": [
        "cabosser"
    ],
    "cabossees": [
        "cabosser"
    ],
    "cabot": [
        "cabot"
    ],
    "cabotage": [
        "cabotage"
    ],
    "cabotaient": [
        "caboter"
    ],
    "cabotait": [
        "caboter"
    ],
    "cabote": [
        "caboter"
    ],
    "caboter": [
        "caboter"
    ],
    "caboteur": [
        "caboteur"
    ],
    "cabotin": [
        "cabotin"
    ],
    "cabotinage": [
        "cabotinage"
    ],
    "cabotine": [
        "cabotin"
    ],
    "cabotines": [
        "cabotin",
        "cabotiner"
    ],
    "cabotins": [
        "cabotin"
    ],
    "cabots": [
        "cabot"
    ],
    "caboulot": [
        "caboulot"
    ],
    "caboulots": [
        "caboulot"
    ],
    "cabra": [
        "cabrer"
    ],
    "cabrade": [
        "cabrade"
    ],
    "cabrage": [
        "cabrage"
    ],
    "cabraient": [
        "cabrer"
    ],
    "cabrais": [
        "cabrer"
    ],
    "cabrait": [
        "cabrer"
    ],
    "cabrant": [
        "cabrer"
    ],
    "cabre": [
        "cabrer"
    ],
    "cabrent": [
        "cabrer"
    ],
    "cabrer": [
        "cabrer"
    ],
    "cabrera": [
        "cabrer"
    ],
    "cabrerait": [
        "cabrer"
    ],
    "cabrette": [
        "cabrette"
    ],
    "cabri": [
        "cabri"
    ],
    "cabriolaient": [
        "cabrioler"
    ],
    "cabriolait": [
        "cabrioler"
    ],
    "cabriolant": [
        "cabrioler"
    ],
    "cabriole": [
        "cabrioler",
        "cabriole"
    ],
    "cabrioler": [
        "cabrioler"
    ],
    "cabrioles": [
        "cabriole"
    ],
    "cabriolet": [
        "cabriolet"
    ],
    "cabriolets": [
        "cabriolet"
    ],
    "cabris": [
        "cabri"
    ],
    "cabrerent": [
        "cabrer"
    ],
    "cabree": [
        "cabrer"
    ],
    "cabrees": [
        "cabrer"
    ],
    "cabres": [
        "cabrer"
    ],
    "cabs": [
        "cab"
    ],
    "cabus": [
        "cabus"
    ],
    "cabeche": [
        "cabeche"
    ],
    "cabeches": [
        "cabeche"
    ],
    "cabecous": [
        "cabecou"
    ],
    "caca": [
        "caca"
    ],
    "cacahouete": [
        "cacahouete"
    ],
    "cacahouetes": [
        "cacahouete"
    ],
    "cacahuete": [
        "cacahuete"
    ],
    "cacahuetes": [
        "cacahuete"
    ],
    "cacao": [
        "cacao"
    ],
    "cacaos": [
        "cacao"
    ],
    "cacaotier": [
        "cacaotier"
    ],
    "cacaotes": [
        "cacaote"
    ],
    "cacaoyer": [
        "cacaoyer"
    ],
    "cacarda": [
        "cacarder"
    ],
    "cacardait": [
        "cacarder"
    ],
    "cacarde": [
        "cacarder"
    ],
    "cacas": [
        "caca"
    ],
    "cacatois": [
        "cacatois"
    ],
    "cacatoes": [
        "cacatoes"
    ],
    "cacha": [
        "cacher"
    ],
    "cachai": [
        "cacher"
    ],
    "cachaient": [
        "cacher"
    ],
    "cachais": [
        "cacher"
    ],
    "cachait": [
        "cacher"
    ],
    "cachalot": [
        "cachalot"
    ],
    "cachalots": [
        "cachalot"
    ],
    "cachant": [
        "cacher"
    ],
    "cache": [
        "cacher",
        "cache"
    ],
    "cachectique": [
        "cachectique"
    ],
    "cachectiques": [
        "cachectique"
    ],
    "cachemire": [
        "cachemire"
    ],
    "cachemires": [
        "cachemire"
    ],
    "cachemiris": [
        "cachemiri"
    ],
    "cachent": [
        "cacher"
    ],
    "cacher": [
        "cacher"
    ],
    "cachera": [
        "cacher"
    ],
    "cacherai": [
        "cacher"
    ],
    "cacheraient": [
        "cacher"
    ],
    "cacherais": [
        "cacher"
    ],
    "cacherait": [
        "cacher"
    ],
    "cacheras": [
        "cacher"
    ],
    "cacherez": [
        "cacher"
    ],
    "cacheriez": [
        "cacher"
    ],
    "cacherons": [
        "cacher"
    ],
    "cacheront": [
        "cacher"
    ],
    "caches": [
        "cacher",
        "cache"
    ],
    "cachet": [
        "cachet"
    ],
    "cacheta": [
        "cacheter"
    ],
    "cachetais": [
        "cacheter"
    ],
    "cachetait": [
        "cacheter"
    ],
    "cacheter": [
        "cacheter"
    ],
    "cacheton": [
        "cacheton"
    ],
    "cachetonnais": [
        "cachetonner"
    ],
    "cachetonnait": [
        "cachetonner"
    ],
    "cachetonne": [
        "cachetonner"
    ],
    "cachetons": [
        "cacheton"
    ],
    "cachets": [
        "cachet"
    ],
    "cachette": [
        "cachette",
        "cacheter"
    ],
    "cachettes": [
        "cachette",
        "cacheter"
    ],
    "cachete": [
        "cacheter"
    ],
    "cachetee": [
        "cacheter"
    ],
    "cachetees": [
        "cacheter"
    ],
    "cachetes": [
        "cacheter"
    ],
    "cachexie": [
        "cachexie"
    ],
    "cachez": [
        "cacher"
    ],
    "cachiez": [
        "cacher"
    ],
    "cachions": [
        "cacher"
    ],
    "cachons": [
        "cacher"
    ],
    "cachot": [
        "cachot"
    ],
    "cachots": [
        "cachot"
    ],
    "cachotterie": [
        "cachotterie"
    ],
    "cachotteries": [
        "cachotterie"
    ],
    "cachottier": [
        "cachottier"
    ],
    "cachottiers": [
        "cachottier"
    ],
    "cachottiere": [
        "cachottier"
    ],
    "cachottieres": [
        "cachottier"
    ],
    "cachou": [
        "cachou"
    ],
    "cachous": [
        "cachou"
    ],
    "cachat": [
        "cacher"
    ],
    "cachere": [
        "cachere"
    ],
    "cacherent": [
        "cacher"
    ],
    "cachee": [
        "cacher",
        "cache"
    ],
    "cachees": [
        "cacher",
        "cache"
    ],
    "cacique": [
        "cacique"
    ],
    "caciques": [
        "cacique"
    ],
    "cacochyme": [
        "cacochyme"
    ],
    "cacochymes": [
        "cacochyme"
    ],
    "cacodylate": [
        "cacodylate"
    ],
    "cacographes": [
        "cacographe"
    ],
    "cacophonie": [
        "cacophonie"
    ],
    "cacophonies": [
        "cacophonie"
    ],
    "cacophonique": [
        "cacophonique"
    ],
    "cacophoniques": [
        "cacophonique"
    ],
    "cactus": [
        "cactus"
    ],
    "cactees": [
        "cactee"
    ],
    "cadastral": [
        "cadastral"
    ],
    "cadastrale": [
        "cadastral"
    ],
    "cadastraux": [
        "cadastral"
    ],
    "cadastre": [
        "cadastrer",
        "cadastre"
    ],
    "cadastres": [
        "cadastre"
    ],
    "cadastree": [
        "cadastrer"
    ],
    "cadavre": [
        "cadavre"
    ],
    "cadavres": [
        "cadavre"
    ],
    "cadavereuse": [
        "cadavereux"
    ],
    "cadavereux": [
        "cadavereux"
    ],
    "cadaverique": [
        "cadaverique"
    ],
    "cadaveriques": [
        "cadaverique"
    ],
    "cadaverise": [
        "cadaveriser"
    ],
    "cadaverises": [
        "cadaveriser"
    ],
    "caddie": [
        "caddie"
    ],
    "caddies": [
        "caddy",
        "caddie"
    ],
    "caddy": [
        "caddy"
    ],
    "cade": [
        "cade"
    ],
    "cadeau": [
        "cadeau"
    ],
    "cadeaux": [
        "cadeau"
    ],
    "cadenas": [
        "cadenas"
    ],
    "cadenassaient": [
        "cadenasser"
    ],
    "cadenassait": [
        "cadenasser"
    ],
    "cadenassant": [
        "cadenasser"
    ],
    "cadenasse": [
        "cadenasser"
    ],
    "cadenasser": [
        "cadenasser"
    ],
    "cadenassez": [
        "cadenasser"
    ],
    "cadenassee": [
        "cadenasser"
    ],
    "cadenassees": [
        "cadenasser"
    ],
    "cadence": [
        "cadencer",
        "cadence"
    ],
    "cadencer": [
        "cadencer"
    ],
    "cadences": [
        "cadencer",
        "cadence"
    ],
    "cadencee": [
        "cadencer",
        "cadence"
    ],
    "cadencees": [
        "cadence"
    ],
    "cadet": [
        "cadet"
    ],
    "cadets": [
        "cadet"
    ],
    "cadette": [
        "cadet"
    ],
    "cadettes": [
        "cadet"
    ],
    "cadi": [
        "cadi"
    ],
    "cadmium": [
        "cadmium"
    ],
    "cadmie": [
        "cadmier"
    ],
    "cadogan": [
        "cadogan"
    ],
    "cador": [
        "cador"
    ],
    "cadors": [
        "cador"
    ],
    "cadrage": [
        "cadrage"
    ],
    "cadrages": [
        "cadrage"
    ],
    "cadrais": [
        "cadrer"
    ],
    "cadrait": [
        "cadrer"
    ],
    "cadran": [
        "cadran"
    ],
    "cadrans": [
        "cadran"
    ],
    "cadrant": [
        "cadrer"
    ],
    "cadratin": [
        "cadratin"
    ],
    "cadratins": [
        "cadratin"
    ],
    "cadre": [
        "cadrer",
        "cadre"
    ],
    "cadrent": [
        "cadrer"
    ],
    "cadrer": [
        "cadrer"
    ],
    "cadres": [
        "cadrer",
        "cadre"
    ],
    "cadreur": [
        "cadreur"
    ],
    "cadreurs": [
        "cadreur"
    ],
    "cadrez": [
        "cadrer"
    ],
    "cadree": [
        "cadrer"
    ],
    "caduc": [
        "caduc"
    ],
    "caducite": [
        "caducite"
    ],
    "caducs": [
        "caduc"
    ],
    "caducee": [
        "caducee"
    ],
    "caducees": [
        "caducee"
    ],
    "caduque": [
        "caduque"
    ],
    "caduques": [
        "caduque"
    ],
    "cadenes": [
        "cadene"
    ],
    "caecum": [
        "caecum"
    ],
    "caesium": [
        "caesium"
    ],
    "caf": [
        "caf"
    ],
    "cafard": [
        "cafard"
    ],
    "cafardage": [
        "cafardage"
    ],
    "cafarde": [
        "cafarder",
        "cafard"
    ],
    "cafarder": [
        "cafarder"
    ],
    "cafarderait": [
        "cafarder"
    ],
    "cafardeur": [
        "cafardeur"
    ],
    "cafardeuse": [
        "cafardeur",
        "cafardeuse"
    ],
    "cafardeux": [
        "cafardeux"
    ],
    "cafards": [
        "cafard"
    ],
    "cafetais": [
        "cafeter"
    ],
    "cafetan": [
        "cafetan"
    ],
    "cafetans": [
        "cafetan"
    ],
    "cafeter": [
        "cafeter"
    ],
    "cafeteria": [
        "cafeteria"
    ],
    "cafeterias": [
        "cafeteria"
    ],
    "cafeteur": [
        "cafeteur"
    ],
    "cafetier": [
        "cafetier"
    ],
    "cafetiers": [
        "cafetier"
    ],
    "cafetiere": [
        "cafetiere"
    ],
    "cafetieres": [
        "cafetiere"
    ],
    "cafeton": [
        "cafeton"
    ],
    "cafete": [
        "cafeter"
    ],
    "cafouilla": [
        "cafouiller"
    ],
    "cafouillage": [
        "cafouillage"
    ],
    "cafouillages": [
        "cafouillage"
    ],
    "cafouillait": [
        "cafouiller"
    ],
    "cafouillant": [
        "cafouiller"
    ],
    "cafouille": [
        "cafouiller"
    ],
    "cafouillent": [
        "cafouiller"
    ],
    "cafouiller": [
        "cafouiller"
    ],
    "cafouilles": [
        "cafouiller"
    ],
    "cafouilleuse": [
        "cafouilleux"
    ],
    "cafouilleux": [
        "cafouilleux"
    ],
    "cafouillis": [
        "cafouillis"
    ],
    "cafre": [
        "cafre"
    ],
    "caftage": [
        "caftage"
    ],
    "caftaient": [
        "cafter"
    ],
    "caftait": [
        "cafter"
    ],
    "caftan": [
        "caftan"
    ],
    "caftans": [
        "caftan"
    ],
    "cafte": [
        "cafter"
    ],
    "cafter": [
        "cafter"
    ],
    "cafterai": [
        "cafter"
    ],
    "cafterait": [
        "cafter"
    ],
    "cafteras": [
        "cafter"
    ],
    "caftes": [
        "cafter"
    ],
    "cafteur": [
        "cafteur"
    ],
    "cafteurs": [
        "cafteur"
    ],
    "cafteuse": [
        "cafteur"
    ],
    "cafe": [
        "cafe"
    ],
    "cafeier": [
        "cafeier"
    ],
    "cafeiers": [
        "cafeier"
    ],
    "cafeine": [
        "cafeine"
    ],
    "cafes": [
        "cafe"
    ],
    "cagade": [
        "cagade"
    ],
    "cagades": [
        "cagade"
    ],
    "cage": [
        "cage"
    ],
    "cageot": [
        "cageot"
    ],
    "cageots": [
        "cageot"
    ],
    "cages": [
        "cage"
    ],
    "cagette": [
        "cagette"
    ],
    "cagettes": [
        "cagette"
    ],
    "cagibi": [
        "cagibi"
    ],
    "cagibis": [
        "cagibi"
    ],
    "cagna": [
        "cagna"
    ],
    "cagnard": [
        "cagnard"
    ],
    "cagnards": [
        "cagnard"
    ],
    "cagnas": [
        "cagna"
    ],
    "cagne": [
        "cagne"
    ],
    "cagneuse": [
        "cagneux"
    ],
    "cagneuses": [
        "cagneux"
    ],
    "cagneux": [
        "cagneux"
    ],
    "cagnotte": [
        "cagnotte"
    ],
    "cagot": [
        "cagot"
    ],
    "cagote": [
        "cagot"
    ],
    "cagotes": [
        "cagot"
    ],
    "cagots": [
        "cagot"
    ],
    "cagou": [
        "cagou"
    ],
    "cagoulard": [
        "cagoulard"
    ],
    "cagoulards": [
        "cagoulard"
    ],
    "cagoule": [
        "cagoule"
    ],
    "cagoules": [
        "cagoule"
    ],
    "caguait": [
        "caguer"
    ],
    "cague": [
        "caguer"
    ],
    "caguer": [
        "caguer"
    ],
    "cahier": [
        "cahier"
    ],
    "cahiers": [
        "cahier"
    ],
    "cahors": [
        "cahors"
    ],
    "cahot": [
        "cahot"
    ],
    "cahota": [
        "cahoter"
    ],
    "cahotait": [
        "cahoter"
    ],
    "cahotant": [
        "cahotant",
        "cahoter"
    ],
    "cahotante": [
        "cahotant"
    ],
    "cahote": [
        "cahoter"
    ],
    "cahotement": [
        "cahotement"
    ],
    "cahotent": [
        "cahoter"
    ],
    "cahoter": [
        "cahoter"
    ],
    "cahoteuse": [
        "cahoteux"
    ],
    "cahoteuses": [
        "cahoteux"
    ],
    "cahoteux": [
        "cahoteux"
    ],
    "cahotons": [
        "cahoter"
    ],
    "cahots": [
        "cahot"
    ],
    "cahoterent": [
        "cahoter"
    ],
    "cahotee": [
        "cahoter"
    ],
    "cahotees": [
        "cahoter"
    ],
    "cahotes": [
        "cahoter"
    ],
    "cahute": [
        "cahute"
    ],
    "cahutes": [
        "cahute"
    ],
    "cailla": [
        "cailler"
    ],
    "caillaient": [
        "cailler"
    ],
    "caillais": [
        "cailler"
    ],
    "caillait": [
        "cailler"
    ],
    "caillant": [
        "cailler"
    ],
    "caillasse": [
        "caillasse"
    ],
    "caillasser": [
        "caillasser"
    ],
    "caillasses": [
        "caillasse"
    ],
    "caille": [
        "caille",
        "cailler"
    ],
    "caillebotis": [
        "caillebotis"
    ],
    "caillent": [
        "cailler"
    ],
    "cailler": [
        "cailler"
    ],
    "caillera": [
        "caillera"
    ],
    "caillerait": [
        "cailler"
    ],
    "caillerez": [
        "cailler"
    ],
    "cailles": [
        "caille",
        "cailler"
    ],
    "caillette": [
        "caillette"
    ],
    "caillot": [
        "caillot"
    ],
    "caillots": [
        "caillot"
    ],
    "caillou": [
        "caillou"
    ],
    "cailloutage": [
        "cailloutage"
    ],
    "caillouteuse": [
        "caillouteux"
    ],
    "caillouteuses": [
        "caillouteux"
    ],
    "caillouteux": [
        "caillouteux"
    ],
    "cailloutis": [
        "cailloutis"
    ],
    "cailloute": [
        "caillouter"
    ],
    "cailloux": [
        "caillou"
    ],
    "caillee": [
        "cailler"
    ],
    "caillees": [
        "cailler"
    ],
    "cairn": [
        "cairn"
    ],
    "cairns": [
        "cairn"
    ],
    "cairote": [
        "cairote"
    ],
    "cairotes": [
        "cairote"
    ],
    "caisse": [
        "caisse"
    ],
    "caisses": [
        "caisse"
    ],
    "caissette": [
        "caissette"
    ],
    "caissettes": [
        "caissette"
    ],
    "caissier": [
        "caissier"
    ],
    "caissiers": [
        "caissier"
    ],
    "caissiere": [
        "caissier"
    ],
    "caissieres": [
        "caissier"
    ],
    "caisson": [
        "caisson"
    ],
    "caissons": [
        "caisson"
    ],
    "cajola": [
        "cajoler"
    ],
    "cajolaient": [
        "cajoler"
    ],
    "cajolait": [
        "cajoler"
    ],
    "cajolant": [
        "cajoler"
    ],
    "cajole": [
        "cajoler"
    ],
    "cajolent": [
        "cajoler"
    ],
    "cajoler": [
        "cajoler"
    ],
    "cajolera": [
        "cajoler"
    ],
    "cajolerai": [
        "cajoler"
    ],
    "cajolerait": [
        "cajoler"
    ],
    "cajolerie": [
        "cajolerie"
    ],
    "cajoleries": [
        "cajolerie"
    ],
    "cajoleur": [
        "cajoleur"
    ],
    "cajoleurs": [
        "cajoleur"
    ],
    "cajoleuse": [
        "cajoleur"
    ],
    "cajolerent": [
        "cajoler"
    ],
    "cajolee": [
        "cajoler"
    ],
    "cajoles": [
        "cajoler",
        "cajole"
    ],
    "cajou": [
        "cajou"
    ],
    "cajous": [
        "cajou"
    ],
    "cajun": [
        "cajun"
    ],
    "cajuns": [
        "cajun"
    ],
    "cake": [
        "cake"
    ],
    "cakes": [
        "cake"
    ],
    "cal": [
        "cal"
    ],
    "cala": [
        "caler"
    ],
    "calabrais": [
        "calabrais"
    ],
    "calabraises": [
        "calabrais"
    ],
    "calade": [
        "calade"
    ],
    "calai": [
        "caler"
    ],
    "calaient": [
        "caler"
    ],
    "calais": [
        "caler"
    ],
    "calaisiens": [
        "calaisien"
    ],
    "calaison": [
        "calaison"
    ],
    "calait": [
        "caler"
    ],
    "calamar": [
        "calamar"
    ],
    "calamars": [
        "calamar"
    ],
    "calame": [
        "calame"
    ],
    "calames": [
        "calame"
    ],
    "calamine": [
        "calamine"
    ],
    "calamines": [
        "calamine"
    ],
    "calamistre": [
        "calamistrer",
        "calamistre"
    ],
    "calamistree": [
        "calamistre"
    ],
    "calamistres": [
        "calamistre"
    ],
    "calamita": [
        "calamiter"
    ],
    "calamitait": [
        "calamiter"
    ],
    "calamiteuse": [
        "calamiteux"
    ],
    "calamiteuses": [
        "calamiteux"
    ],
    "calamiteux": [
        "calamiteux"
    ],
    "calamite": [
        "calamiter",
        "calamite"
    ],
    "calamites": [
        "calamite"
    ],
    "calanchaient": [
        "calancher"
    ],
    "calanchais": [
        "calancher"
    ],
    "calanche": [
        "calancher"
    ],
    "calancher": [
        "calancher"
    ],
    "calandre": [
        "calandre",
        "calandrer"
    ],
    "calanque": [
        "calanque"
    ],
    "calanques": [
        "calanque"
    ],
    "calant": [
        "caler"
    ],
    "calao": [
        "calao"
    ],
    "calbar": [
        "calbar"
    ],
    "calbars": [
        "calbar"
    ],
    "calbombe": [
        "calbombe"
    ],
    "calbombes": [
        "calbombe"
    ],
    "calcaire": [
        "calcaire"
    ],
    "calcaires": [
        "calcaire"
    ],
    "calce": [
        "calcer"
    ],
    "calcer": [
        "calcer"
    ],
    "calcerais": [
        "calcer"
    ],
    "calcif": [
        "calcif"
    ],
    "calcification": [
        "calcification"
    ],
    "calcifie": [
        "calcifier",
        "calcifie"
    ],
    "calcifiee": [
        "calcifier",
        "calcifie"
    ],
    "calcifs": [
        "calcif"
    ],
    "calcinaient": [
        "calciner"
    ],
    "calcinait": [
        "calciner"
    ],
    "calcinant": [
        "calciner"
    ],
    "calcination": [
        "calcination"
    ],
    "calcine": [
        "calcine",
        "calciner"
    ],
    "calciner": [
        "calciner"
    ],
    "calcinee": [
        "calcine",
        "calciner"
    ],
    "calcinees": [
        "calcine",
        "calciner"
    ],
    "calcines": [
        "calcine",
        "calciner"
    ],
    "calcite": [
        "calcite"
    ],
    "calcium": [
        "calcium"
    ],
    "calcul": [
        "calcul"
    ],
    "calcula": [
        "calculer"
    ],
    "calculables": [
        "calculable"
    ],
    "calculai": [
        "calculer"
    ],
    "calculaient": [
        "calculer"
    ],
    "calculais": [
        "calculer"
    ],
    "calculait": [
        "calculer"
    ],
    "calculant": [
        "calculer",
        "calculant"
    ],
    "calculateur": [
        "calculateur"
    ],
    "calculateurs": [
        "calculateur"
    ],
    "calculatrice": [
        "calculatrice"
    ],
    "calculatrices": [
        "calculatrice"
    ],
    "calcule": [
        "calculer"
    ],
    "calculent": [
        "calculer"
    ],
    "calculer": [
        "calculer"
    ],
    "calculera": [
        "calculer"
    ],
    "calculerai": [
        "calculer"
    ],
    "calculerait": [
        "calculer"
    ],
    "calcules": [
        "calculer"
    ],
    "calculette": [
        "calculette"
    ],
    "calculettes": [
        "calculette"
    ],
    "calculeuse": [
        "calculeux"
    ],
    "calculez": [
        "calculer"
    ],
    "calculiez": [
        "calculer"
    ],
    "calculons": [
        "calculer"
    ],
    "calculs": [
        "calcul"
    ],
    "calculerent": [
        "calculer"
    ],
    "calculee": [
        "calculer"
    ],
    "calculees": [
        "calculer"
    ],
    "calcemie": [
        "calcemie"
    ],
    "caldarium": [
        "caldarium"
    ],
    "caldeira": [
        "caldeira"
    ],
    "cale": [
        "caler",
        "cale"
    ],
    "calebar": [
        "calebar"
    ],
    "calebasse": [
        "calebasse"
    ],
    "calebasses": [
        "calebasse"
    ],
    "calebassier": [
        "calebassier"
    ],
    "calebombe": [
        "calebombe"
    ],
    "calecif": [
        "calecif"
    ],
    "calembour": [
        "calembour"
    ],
    "calembours": [
        "calembour"
    ],
    "calembredaine": [
        "calembredaine"
    ],
    "calembredaines": [
        "calembredaine"
    ],
    "calenche": [
        "calencher"
    ],
    "calendaire": [
        "calendaire"
    ],
    "calendes": [
        "calendes"
    ],
    "calendo": [
        "calendo"
    ],
    "calendos": [
        "calendos"
    ],
    "calendre": [
        "calendre"
    ],
    "calendrier": [
        "calendrier"
    ],
    "calendriers": [
        "calendrier"
    ],
    "calendula": [
        "calendula"
    ],
    "calent": [
        "caler"
    ],
    "calepin": [
        "calepin"
    ],
    "calepins": [
        "calepin"
    ],
    "caler": [
        "caler"
    ],
    "calerai": [
        "caler"
    ],
    "calerait": [
        "caler"
    ],
    "caleras": [
        "caler"
    ],
    "cales": [
        "caler",
        "cale"
    ],
    "calez": [
        "caler"
    ],
    "calecon": [
        "calecon"
    ],
    "caleconnade": [
        "caleconnade"
    ],
    "calecons": [
        "calecon"
    ],
    "calf": [
        "calf"
    ],
    "calfat": [
        "calfat"
    ],
    "calfatage": [
        "calfatage"
    ],
    "calfatait": [
        "calfater"
    ],
    "calfatant": [
        "calfater"
    ],
    "calfate": [
        "calfater"
    ],
    "calfater": [
        "calfater"
    ],
    "calfats": [
        "calfat"
    ],
    "calfatee": [
        "calfater"
    ],
    "calfates": [
        "calfater"
    ],
    "calfeutra": [
        "calfeutrer"
    ],
    "calfeutrage": [
        "calfeutrage"
    ],
    "calfeutrai": [
        "calfeutrer"
    ],
    "calfeutraient": [
        "calfeutrer"
    ],
    "calfeutrais": [
        "calfeutrer"
    ],
    "calfeutrait": [
        "calfeutrer"
    ],
    "calfeutrant": [
        "calfeutrer"
    ],
    "calfeutre": [
        "calfeutrer"
    ],
    "calfeutrer": [
        "calfeutrer"
    ],
    "calfeutres": [
        "calfeutrer"
    ],
    "calfeutree": [
        "calfeutrer"
    ],
    "calfeutrees": [
        "calfeutrer"
    ],
    "calibrage": [
        "calibrage"
    ],
    "calibrages": [
        "calibrage"
    ],
    "calibration": [
        "calibration"
    ],
    "calibre": [
        "calibre",
        "calibrer"
    ],
    "calibrer": [
        "calibrer"
    ],
    "calibres": [
        "calibre",
        "calibrer"
    ],
    "calibrez": [
        "calibrer"
    ],
    "calibree": [
        "calibrer"
    ],
    "calibrees": [
        "calibrer"
    ],
    "calice": [
        "calice"
    ],
    "calices": [
        "calice"
    ],
    "calicot": [
        "calicot"
    ],
    "calicots": [
        "calicot"
    ],
    "califat": [
        "califat"
    ],
    "calife": [
        "calife"
    ],
    "califes": [
        "calife"
    ],
    "californie": [
        "californie"
    ],
    "californien": [
        "californien"
    ],
    "californienne": [
        "californien"
    ],
    "californiennes": [
        "californien"
    ],
    "californiens": [
        "californien"
    ],
    "californium": [
        "californium"
    ],
    "califourchon": [
        "califourchon"
    ],
    "calisson": [
        "calisson"
    ],
    "calissons": [
        "calisson"
    ],
    "calla": [
        "caller",
        "calla"
    ],
    "calle": [
        "caller"
    ],
    "caller": [
        "caller"
    ],
    "calles": [
        "caller"
    ],
    "calleuse": [
        "calleux"
    ],
    "calleuses": [
        "calleux"
    ],
    "calleux": [
        "calleux"
    ],
    "calligrammes": [
        "calligramme"
    ],
    "calligraphe": [
        "calligraphe"
    ],
    "calligraphiais": [
        "calligraphier"
    ],
    "calligraphiait": [
        "calligraphier"
    ],
    "calligraphiant": [
        "calligraphier"
    ],
    "calligraphie": [
        "calligraphier",
        "calligraphie"
    ],
    "calligraphient": [
        "calligraphier"
    ],
    "calligraphier": [
        "calligraphier"
    ],
    "calligraphies": [
        "calligraphier",
        "calligraphie"
    ],
    "calligraphiez": [
        "calligraphier"
    ],
    "calligraphique": [
        "calligraphique"
    ],
    "calligraphiquement": [
        "calligraphiquement"
    ],
    "calligraphiques": [
        "calligraphique"
    ],
    "calligraphiee": [
        "calligraphier"
    ],
    "calligraphiees": [
        "calligraphier"
    ],
    "callipyge": [
        "callipyge"
    ],
    "callosite": [
        "callosite"
    ],
    "callosites": [
        "callosite"
    ],
    "calma": [
        "calmer"
    ],
    "calmai": [
        "calmer"
    ],
    "calmaient": [
        "calmer"
    ],
    "calmais": [
        "calmer"
    ],
    "calmait": [
        "calmer"
    ],
    "calmant": [
        "calmer",
        "calmant"
    ],
    "calmante": [
        "calmant"
    ],
    "calmants": [
        "calmant"
    ],
    "calmar": [
        "calmar"
    ],
    "calmars": [
        "calmar"
    ],
    "calmas": [
        "calmer"
    ],
    "calme": [
        "calmer",
        "calme"
    ],
    "calmement": [
        "calmement"
    ],
    "calment": [
        "calmer"
    ],
    "calmer": [
        "calmer",
        "calm"
    ],
    "calmera": [
        "calmer"
    ],
    "calmerai": [
        "calmer"
    ],
    "calmeraient": [
        "calmer"
    ],
    "calmerais": [
        "calmer"
    ],
    "calmerait": [
        "calmer"
    ],
    "calmeras": [
        "calmer"
    ],
    "calmerez": [
        "calmer"
    ],
    "calmerons": [
        "calmer"
    ],
    "calmeront": [
        "calmer"
    ],
    "calmes": [
        "calmer",
        "calme"
    ],
    "calmez": [
        "calmer"
    ],
    "calmi": [
        "calmir"
    ],
    "calmiez": [
        "calmer"
    ],
    "calmir": [
        "calmir"
    ],
    "calmons": [
        "calmer"
    ],
    "calmos": [
        "calmos"
    ],
    "calmat": [
        "calmer"
    ],
    "calmerent": [
        "calmer"
    ],
    "calmee": [
        "calmer"
    ],
    "calmees": [
        "calmer"
    ],
    "calo": [
        "calo"
    ],
    "calomel": [
        "calomel"
    ],
    "calomniant": [
        "calomnier"
    ],
    "calomniateur": [
        "calomniateur"
    ],
    "calomniateurs": [
        "calomniateur"
    ],
    "calomniatrice": [
        "calomniateur"
    ],
    "calomnie": [
        "calomnie",
        "calomnier"
    ],
    "calomnient": [
        "calomnier"
    ],
    "calomnier": [
        "calomnier"
    ],
    "calomnies": [
        "calomnie",
        "calomnier"
    ],
    "calomnieuse": [
        "calomnieux"
    ],
    "calomnieuses": [
        "calomnieux"
    ],
    "calomnieux": [
        "calomnieux"
    ],
    "calomniez": [
        "calomnier"
    ],
    "calomniee": [
        "calomnier"
    ],
    "caloporteur": [
        "caloporteur"
    ],
    "calorie": [
        "calorie"
    ],
    "calories": [
        "calory",
        "calorie"
    ],
    "calorifique": [
        "calorifique"
    ],
    "calorifuges": [
        "calorifuge"
    ],
    "calorifere": [
        "calorifere"
    ],
    "caloriferes": [
        "calorifere"
    ],
    "calorique": [
        "calorique"
    ],
    "calot": [
        "calot"
    ],
    "calotin": [
        "calotin"
    ],
    "calotins": [
        "calotin"
    ],
    "calots": [
        "calot"
    ],
    "calottais": [
        "calotter"
    ],
    "calotte": [
        "calotte",
        "calotter"
    ],
    "calottes": [
        "calotte",
        "calotter"
    ],
    "calottees": [
        "calotter"
    ],
    "calquaient": [
        "calquer"
    ],
    "calquait": [
        "calquer"
    ],
    "calquant": [
        "calquer"
    ],
    "calque": [
        "calquer",
        "calque"
    ],
    "calquer": [
        "calquer"
    ],
    "calquera": [
        "calquer"
    ],
    "calques": [
        "calque"
    ],
    "calquee": [
        "calquer"
    ],
    "calquees": [
        "calquer"
    ],
    "cals": [
        "cal"
    ],
    "calte": [
        "calter"
    ],
    "caltent": [
        "calter"
    ],
    "calter": [
        "calter"
    ],
    "caltez": [
        "calter"
    ],
    "caltons": [
        "calter"
    ],
    "caltes": [
        "calter"
    ],
    "calumet": [
        "calumet"
    ],
    "calumets": [
        "calumet"
    ],
    "calus": [
        "calus"
    ],
    "calva": [
        "calva"
    ],
    "calvados": [
        "calvados"
    ],
    "calvaire": [
        "calvaire"
    ],
    "calvaires": [
        "calvaire"
    ],
    "calvas": [
        "calva"
    ],
    "calville": [
        "calville"
    ],
    "calvilles": [
        "calville"
    ],
    "calvinisme": [
        "calvinisme"
    ],
    "calviniste": [
        "calviniste"
    ],
    "calvinistes": [
        "calviniste"
    ],
    "calvitie": [
        "calvitie"
    ],
    "calvities": [
        "calvitie"
    ],
    "calypso": [
        "calypso"
    ],
    "caleche": [
        "caleche"
    ],
    "caleches": [
        "caleche"
    ],
    "calerent": [
        "caler"
    ],
    "caledonien": [
        "caledonien"
    ],
    "caledonienne": [
        "caledonien"
    ],
    "caledoniens": [
        "caledonien"
    ],
    "calee": [
        "caler",
        "cale"
    ],
    "calees": [
        "caler",
        "cale"
    ],
    "caleidoscope": [
        "caleidoscope"
    ],
    "cama": [
        "camer"
    ],
    "camail": [
        "camail"
    ],
    "camails": [
        "camail"
    ],
    "camarade": [
        "camarade"
    ],
    "camaraderie": [
        "camaraderie"
    ],
    "camaraderies": [
        "camaraderie"
    ],
    "camarades": [
        "camarade"
    ],
    "camard": [
        "camard"
    ],
    "camarde": [
        "camard"
    ],
    "camards": [
        "camard"
    ],
    "camarero": [
        "camarero"
    ],
    "camareros": [
        "camarero"
    ],
    "camarguais": [
        "camarguais"
    ],
    "camarguaises": [
        "camarguais"
    ],
    "camarilla": [
        "camarilla"
    ],
    "camarin": [
        "camarin"
    ],
    "camarins": [
        "camarin"
    ],
    "camarluche": [
        "camarluche"
    ],
    "camaro": [
        "camaro"
    ],
    "camaieu": [
        "camaieu"
    ],
    "camaieux": [
        "camaieux"
    ],
    "camber": [
        "camber"
    ],
    "cambiste": [
        "cambiste"
    ],
    "cambodgien": [
        "cambodgien"
    ],
    "cambodgienne": [
        "cambodgien"
    ],
    "cambodgiennes": [
        "cambodgien"
    ],
    "cambodgiens": [
        "cambodgien"
    ],
    "cambouis": [
        "cambouis"
    ],
    "cambra": [
        "cambrer"
    ],
    "cambrait": [
        "cambrer"
    ],
    "cambrant": [
        "cambrer"
    ],
    "cambre": [
        "cambrer",
        "cambre"
    ],
    "cambrement": [
        "cambrement"
    ],
    "cambrent": [
        "cambrer"
    ],
    "cambrer": [
        "cambrer"
    ],
    "cambrera": [
        "cambrer"
    ],
    "cambres": [
        "cambrer",
        "cambre"
    ],
    "cambrez": [
        "cambrer"
    ],
    "cambrienne": [
        "cambrien"
    ],
    "cambriolage": [
        "cambriolage"
    ],
    "cambriolages": [
        "cambriolage"
    ],
    "cambriolaient": [
        "cambrioler"
    ],
    "cambriolais": [
        "cambrioler"
    ],
    "cambriolant": [
        "cambrioler"
    ],
    "cambriole": [
        "cambrioler"
    ],
    "cambriolent": [
        "cambrioler"
    ],
    "cambrioler": [
        "cambrioler"
    ],
    "cambrioles": [
        "cambrioler"
    ],
    "cambrioleur": [
        "cambrioleur"
    ],
    "cambrioleurs": [
        "cambrioleur"
    ],
    "cambrioleuse": [
        "cambrioleur"
    ],
    "cambriolez": [
        "cambrioler"
    ],
    "cambrioliez": [
        "cambrioler"
    ],
    "cambriolons": [
        "cambrioler"
    ],
    "cambriolee": [
        "cambrioler"
    ],
    "cambriolees": [
        "cambrioler"
    ],
    "cambrousse": [
        "cambrousse"
    ],
    "cambrousses": [
        "cambrousse"
    ],
    "cambrure": [
        "cambrure"
    ],
    "cambrures": [
        "cambrure"
    ],
    "cambree": [
        "cambrer",
        "cambre"
    ],
    "cambrees": [
        "cambrer",
        "cambre"
    ],
    "cambuse": [
        "cambuse"
    ],
    "cambuses": [
        "cambuse"
    ],
    "cambusier": [
        "cambusier"
    ],
    "cambute": [
        "cambuter"
    ],
    "came": [
        "came",
        "camer",
        "come"
    ],
    "camellia": [
        "camellia"
    ],
    "camelot": [
        "camelot"
    ],
    "camelote": [
        "camelote"
    ],
    "camelotes": [
        "camelote"
    ],
    "camelots": [
        "camelot"
    ],
    "camembert": [
        "camembert"
    ],
    "camemberts": [
        "camembert"
    ],
    "cament": [
        "camer"
    ],
    "camer": [
        "camer"
    ],
    "camera": [
        "camer",
        "camera"
    ],
    "cameraman": [
        "cameraman"
    ],
    "cameramen": [
        "cameraman"
    ],
    "cameras": [
        "camer",
        "camera"
    ],
    "camerounais": [
        "camerounais"
    ],
    "camerounaise": [
        "camerounais"
    ],
    "cames": [
        "came",
        "camer"
    ],
    "camez": [
        "camer"
    ],
    "camion": [
        "camion"
    ],
    "camionnage": [
        "camionnage"
    ],
    "camionnette": [
        "camionnette"
    ],
    "camionnettes": [
        "camionnette"
    ],
    "camionneur": [
        "camionneur"
    ],
    "camionneurs": [
        "camionneur"
    ],
    "camionnee": [
        "camionner"
    ],
    "camions": [
        "camion"
    ],
    "camisards": [
        "camisard"
    ],
    "camisole": [
        "camisole"
    ],
    "camisoles": [
        "camisole"
    ],
    "camomille": [
        "camomille"
    ],
    "camomilles": [
        "camomille"
    ],
    "camorra": [
        "camorra"
    ],
    "camoufla": [
        "camoufler"
    ],
    "camouflage": [
        "camouflage"
    ],
    "camouflages": [
        "camouflage"
    ],
    "camouflaient": [
        "camoufler"
    ],
    "camouflais": [
        "camoufler"
    ],
    "camouflait": [
        "camoufler"
    ],
    "camouflant": [
        "camoufler"
    ],
    "camoufle": [
        "camoufler"
    ],
    "camouflent": [
        "camoufler"
    ],
    "camoufler": [
        "camoufler"
    ],
    "camouflerait": [
        "camoufler"
    ],
    "camouflet": [
        "camouflet"
    ],
    "camouflets": [
        "camouflet"
    ],
    "camouflez": [
        "camoufler"
    ],
    "camouflee": [
        "camoufler"
    ],
    "camouflees": [
        "camoufler"
    ],
    "camoufles": [
        "camoufler"
    ],
    "camp": [
        "camp"
    ],
    "campa": [
        "camper"
    ],
    "campagnard": [
        "campagnard"
    ],
    "campagnarde": [
        "campagnard"
    ],
    "campagnardes": [
        "campagnard"
    ],
    "campagnards": [
        "campagnard"
    ],
    "campagne": [
        "campagne"
    ],
    "campagnes": [
        "campagne"
    ],
    "campagnol": [
        "campagnol"
    ],
    "campagnols": [
        "campagnol"
    ],
    "campaient": [
        "camper"
    ],
    "campais": [
        "camper"
    ],
    "campait": [
        "camper"
    ],
    "campanaire": [
        "campanaire"
    ],
    "campanelles": [
        "campanelle"
    ],
    "campanile": [
        "campanile"
    ],
    "campaniles": [
        "campanile"
    ],
    "campant": [
        "camper"
    ],
    "campanule": [
        "campanule"
    ],
    "campanules": [
        "campanule"
    ],
    "campe": [
        "campe",
        "camper"
    ],
    "campement": [
        "campement"
    ],
    "campements": [
        "campement"
    ],
    "campent": [
        "camper"
    ],
    "camper": [
        "camp",
        "camper"
    ],
    "campera": [
        "camper"
    ],
    "camperai": [
        "camper"
    ],
    "camperait": [
        "camper"
    ],
    "camperons": [
        "camper"
    ],
    "campes": [
        "camper"
    ],
    "campeur": [
        "campeur"
    ],
    "campeurs": [
        "campeur"
    ],
    "campeuse": [
        "campeur"
    ],
    "campeuses": [
        "campeur"
    ],
    "campez": [
        "camper"
    ],
    "camphre": [
        "camphre"
    ],
    "camphrier": [
        "camphrier"
    ],
    "camphree": [
        "camphrer",
        "camphre"
    ],
    "camphrees": [
        "camphre"
    ],
    "camping": [
        "camping",
        "camp"
    ],
    "campings": [
        "camping"
    ],
    "campions": [
        "camper"
    ],
    "campo": [
        "campo"
    ],
    "campons": [
        "camper"
    ],
    "campos": [
        "campo"
    ],
    "camps": [
        "camp"
    ],
    "campus": [
        "campus"
    ],
    "campames": [
        "camper"
    ],
    "camperent": [
        "camper"
    ],
    "campee": [
        "campe",
        "camper"
    ],
    "campees": [
        "camper"
    ],
    "campeche": [
        "campeche"
    ],
    "camus": [
        "camus"
    ],
    "camuse": [
        "camus"
    ],
    "camee": [
        "came",
        "camee",
        "camer"
    ],
    "camees": [
        "came",
        "camee"
    ],
    "camelia": [
        "camelia"
    ],
    "camelias": [
        "camelia"
    ],
    "camelide": [
        "camelide"
    ],
    "camelides": [
        "camelide"
    ],
    "cameleon": [
        "cameleon"
    ],
    "cameleons": [
        "cameleon"
    ],
    "cameramans": [
        "cameraman"
    ],
    "cameriste": [
        "cameriste"
    ],
    "cameristes": [
        "cameriste"
    ],
    "camescope": [
        "camescope"
    ],
    "camescopes": [
        "camescope"
    ],
    "cana": [
        "caner"
    ],
    "canada": [
        "canada"
    ],
    "canadair": [
        "canadair"
    ],
    "canadairs": [
        "canadair"
    ],
    "canadien": [
        "canadien"
    ],
    "canadienne": [
        "canadienne"
    ],
    "canadiennes": [
        "canadienne"
    ],
    "canadiens": [
        "canadien"
    ],
    "canado": [
        "canado"
    ],
    "canaille": [
        "canaille"
    ],
    "canaillement": [
        "canaillement"
    ],
    "canaillerie": [
        "canaillerie"
    ],
    "canailles": [
        "canaille"
    ],
    "canal": [
        "canal"
    ],
    "canalicules": [
        "canalicule"
    ],
    "canalisa": [
        "canaliser"
    ],
    "canalisaient": [
        "canaliser"
    ],
    "canalisait": [
        "canaliser"
    ],
    "canalisateur": [
        "canalisateur"
    ],
    "canalisation": [
        "canalisation"
    ],
    "canalisations": [
        "canalisation"
    ],
    "canalise": [
        "canaliser"
    ],
    "canalisent": [
        "canaliser"
    ],
    "canaliser": [
        "canaliser"
    ],
    "canalisez": [
        "canaliser"
    ],
    "canalisons": [
        "canaliser"
    ],
    "canalisee": [
        "canaliser"
    ],
    "canalisees": [
        "canaliser"
    ],
    "canalises": [
        "canaliser"
    ],
    "cananeen": [
        "cananeen"
    ],
    "canape": [
        "canape"
    ],
    "canapes": [
        "canape"
    ],
    "canaque": [
        "canaque"
    ],
    "canaques": [
        "canaque"
    ],
    "canard": [
        "canard"
    ],
    "canardaient": [
        "canarder"
    ],
    "canardait": [
        "canarder"
    ],
    "canarde": [
        "canarder"
    ],
    "canardeaux": [
        "canardeau"
    ],
    "canardent": [
        "canarder"
    ],
    "canarder": [
        "canarder"
    ],
    "canardera": [
        "canarder"
    ],
    "canarderais": [
        "canarder"
    ],
    "canarderont": [
        "canarder"
    ],
    "canardez": [
        "canarder"
    ],
    "canards": [
        "canard"
    ],
    "canardee": [
        "canarder"
    ],
    "canardes": [
        "canarder"
    ],
    "canari": [
        "canari"
    ],
    "canaris": [
        "canari"
    ],
    "canas": [
        "caner"
    ],
    "canasson": [
        "canasson"
    ],
    "canassons": [
        "canasson"
    ],
    "canasta": [
        "canasta"
    ],
    "canaux": [
        "canal"
    ],
    "cancan": [
        "cancan"
    ],
    "cancanaient": [
        "cancaner"
    ],
    "cancanait": [
        "cancaner"
    ],
    "cancanant": [
        "cancaner"
    ],
    "cancane": [
        "cancaner"
    ],
    "cancaner": [
        "cancaner"
    ],
    "cancaneries": [
        "cancanerie"
    ],
    "cancanes": [
        "cancaner"
    ],
    "cancanier": [
        "cancanier"
    ],
    "cancaniere": [
        "cancanier"
    ],
    "cancanieres": [
        "cancanier"
    ],
    "cancans": [
        "cancan"
    ],
    "cancel": [
        "cancel"
    ],
    "cancer": [
        "cancer"
    ],
    "cancers": [
        "cancer"
    ],
    "canche": [
        "canche"
    ],
    "cancoillotte": [
        "cancoillotte"
    ],
    "cancre": [
        "cancre"
    ],
    "cancrelat": [
        "cancrelat"
    ],
    "cancrelats": [
        "cancrelat"
    ],
    "cancres": [
        "cancre"
    ],
    "cancereuse": [
        "cancereux"
    ],
    "cancereuses": [
        "cancereux"
    ],
    "cancereux": [
        "cancereux"
    ],
    "cancerigene": [
        "cancerigene"
    ],
    "cancerigenes": [
        "cancerigene"
    ],
    "canceriser": [
        "canceriser"
    ],
    "cancerogene": [
        "cancerogene"
    ],
    "cancerologie": [
        "cancerologie"
    ],
    "cancerologue": [
        "cancerologue"
    ],
    "cancerologues": [
        "cancerologue"
    ],
    "candeur": [
        "candeur"
    ],
    "candeurs": [
        "candeur"
    ],
    "candi": [
        "candi",
        "candir"
    ],
    "candida": [
        "candida"
    ],
    "candidat": [
        "candidat"
    ],
    "candidate": [
        "candidat"
    ],
    "candidates": [
        "candidate",
        "candidat"
    ],
    "candidats": [
        "candidat"
    ],
    "candidature": [
        "candidature"
    ],
    "candidatures": [
        "candidature"
    ],
    "candide": [
        "candide"
    ],
    "candidement": [
        "candidement"
    ],
    "candides": [
        "candide"
    ],
    "candidose": [
        "candidose"
    ],
    "candie": [
        "candir"
    ],
    "candis": [
        "candi"
    ],
    "candelabre": [
        "candelabre"
    ],
    "candelabres": [
        "candelabre"
    ],
    "cane": [
        "canard",
        "caner"
    ],
    "canebiere": [
        "canebiere"
    ],
    "canepetiere": [
        "canepetiere"
    ],
    "caner": [
        "caner"
    ],
    "caneras": [
        "caner"
    ],
    "canes": [
        "canard",
        "cane",
        "caner"
    ],
    "canetille": [
        "canetille"
    ],
    "caneton": [
        "caneton"
    ],
    "canetons": [
        "caneton"
    ],
    "canette": [
        "canette"
    ],
    "canettes": [
        "canette"
    ],
    "canevas": [
        "canevas"
    ],
    "canfouine": [
        "canfouine"
    ],
    "cangue": [
        "cangue"
    ],
    "caniche": [
        "caniche"
    ],
    "caniches": [
        "caniche"
    ],
    "caniculaire": [
        "caniculaire"
    ],
    "caniculaires": [
        "caniculaire"
    ],
    "canicule": [
        "canicule"
    ],
    "canicules": [
        "canicule"
    ],
    "canides": [
        "canide"
    ],
    "canif": [
        "canif"
    ],
    "canifs": [
        "canif"
    ],
    "canin": [
        "canin"
    ],
    "canine": [
        "canine"
    ],
    "canines": [
        "canine"
    ],
    "caninette": [
        "caninette"
    ],
    "canins": [
        "canin"
    ],
    "canisses": [
        "canisse"
    ],
    "caniveau": [
        "caniveau"
    ],
    "caniveaux": [
        "caniveau"
    ],
    "canna": [
        "canna"
    ],
    "cannabis": [
        "cannabis"
    ],
    "cannage": [
        "cannage"
    ],
    "cannait": [
        "canner"
    ],
    "cannant": [
        "canner"
    ],
    "cannas": [
        "canna"
    ],
    "canne": [
        "canner",
        "canne"
    ],
    "canneberge": [
        "canneberge"
    ],
    "canneberges": [
        "canneberge"
    ],
    "canneliers": [
        "cannelier"
    ],
    "cannelle": [
        "cannelle"
    ],
    "cannelloni": [
        "cannelloni"
    ],
    "cannellonis": [
        "cannelloni"
    ],
    "cannelure": [
        "cannelure"
    ],
    "cannelures": [
        "cannelure"
    ],
    "cannele": [
        "cannele"
    ],
    "cannelee": [
        "canneler",
        "cannele"
    ],
    "cannelees": [
        "canneler",
        "cannele"
    ],
    "canneles": [
        "cannele"
    ],
    "canner": [
        "canner"
    ],
    "canneraient": [
        "canner"
    ],
    "cannes": [
        "canne"
    ],
    "cannette": [
        "cannette"
    ],
    "cannettes": [
        "cannette"
    ],
    "cannibale": [
        "cannibale"
    ],
    "cannibales": [
        "cannibale"
    ],
    "cannibalisme": [
        "cannibalisme"
    ],
    "cannee": [
        "canner",
        "canne"
    ],
    "cannees": [
        "canner",
        "canne"
    ],
    "canon": [
        "canon"
    ],
    "canoniale": [
        "canonial"
    ],
    "canoniales": [
        "canonial"
    ],
    "canonique": [
        "canonique"
    ],
    "canoniquement": [
        "canoniquement"
    ],
    "canoniques": [
        "canonique"
    ],
    "canonisation": [
        "canonisation"
    ],
    "canonisations": [
        "canonisation"
    ],
    "canoniser": [
        "canoniser"
    ],
    "canonisez": [
        "canoniser"
    ],
    "canonise": [
        "canoniser"
    ],
    "canonisee": [
        "canoniser"
    ],
    "canonises": [
        "canoniser"
    ],
    "canonnade": [
        "canonnade"
    ],
    "canonnades": [
        "canonnade"
    ],
    "canonnage": [
        "canonnage"
    ],
    "canonnait": [
        "canonner"
    ],
    "canonner": [
        "canonner"
    ],
    "canonnier": [
        "canonnier"
    ],
    "canonniers": [
        "canonnier"
    ],
    "canonniere": [
        "canonniere"
    ],
    "canonnieres": [
        "canonniere"
    ],
    "canonne": [
        "canonner"
    ],
    "canonnees": [
        "canonner"
    ],
    "canonnes": [
        "canonner"
    ],
    "canons": [
        "canon",
        "caner"
    ],
    "canope": [
        "canope"
    ],
    "canopes": [
        "canope"
    ],
    "canot": [
        "canot"
    ],
    "canotage": [
        "canotage"
    ],
    "canotaient": [
        "canoter"
    ],
    "canote": [
        "canoter"
    ],
    "canotent": [
        "canoter"
    ],
    "canoter": [
        "canoter"
    ],
    "canoteurs": [
        "canoteur"
    ],
    "canotier": [
        "canotier"
    ],
    "canotiers": [
        "canotier"
    ],
    "canots": [
        "canot"
    ],
    "canotames": [
        "canoter"
    ],
    "canoe": [
        "canoe"
    ],
    "canoes": [
        "canoe"
    ],
    "cantabile": [
        "cantabile"
    ],
    "cantabrique": [
        "cantabrique"
    ],
    "cantabriques": [
        "cantabrique"
    ],
    "cantal": [
        "cantal"
    ],
    "cantaloup": [
        "cantaloup"
    ],
    "cantaloups": [
        "cantaloup"
    ],
    "cantate": [
        "cantate"
    ],
    "cantates": [
        "cantate"
    ],
    "cantatrice": [
        "cantatrice"
    ],
    "cantatrices": [
        "cantatrice"
    ],
    "canter": [
        "canter",
        "cant"
    ],
    "canthare": [
        "canthare"
    ],
    "canthares": [
        "canthare"
    ],
    "cantharide": [
        "cantharide"
    ],
    "cantharides": [
        "cantharide"
    ],
    "cantilever": [
        "cantilever"
    ],
    "cantilene": [
        "cantilene"
    ],
    "cantina": [
        "cantiner"
    ],
    "cantinaient": [
        "cantiner"
    ],
    "cantine": [
        "cantine"
    ],
    "cantiner": [
        "cantiner"
    ],
    "cantines": [
        "cantine"
    ],
    "cantinier": [
        "cantinier"
    ],
    "cantiniers": [
        "cantinier"
    ],
    "cantiniere": [
        "cantinier"
    ],
    "cantinieres": [
        "cantinier"
    ],
    "cantique": [
        "cantique"
    ],
    "cantiques": [
        "cantique"
    ],
    "canton": [
        "canton"
    ],
    "cantonade": [
        "cantonade"
    ],
    "cantonais": [
        "cantonais"
    ],
    "cantonaise": [
        "cantonais"
    ],
    "cantonal": [
        "cantonal"
    ],
    "cantonale": [
        "cantonal"
    ],
    "cantonales": [
        "cantonal"
    ],
    "cantonna": [
        "cantonner"
    ],
    "cantonnai": [
        "cantonner"
    ],
    "cantonnaient": [
        "cantonner"
    ],
    "cantonnais": [
        "cantonner"
    ],
    "cantonnait": [
        "cantonner"
    ],
    "cantonnant": [
        "cantonner"
    ],
    "cantonne": [
        "cantonner"
    ],
    "cantonnement": [
        "cantonnement"
    ],
    "cantonnements": [
        "cantonnement"
    ],
    "cantonnent": [
        "cantonner"
    ],
    "cantonner": [
        "cantonner"
    ],
    "cantonneraient": [
        "cantonner"
    ],
    "cantonnez": [
        "cantonner"
    ],
    "cantonnier": [
        "cantonnier"
    ],
    "cantonniers": [
        "cantonnier"
    ],
    "cantonnieres": [
        "cantonnier"
    ],
    "cantonnons": [
        "cantonner"
    ],
    "cantonnerent": [
        "cantonner"
    ],
    "cantonnee": [
        "cantonner"
    ],
    "cantonnees": [
        "cantonner"
    ],
    "cantonnes": [
        "cantonner"
    ],
    "cantons": [
        "canton"
    ],
    "cantre": [
        "cantre"
    ],
    "canulant": [
        "canuler"
    ],
    "canular": [
        "canular"
    ],
    "canularesque": [
        "canularesque"
    ],
    "canulars": [
        "canular"
    ],
    "canule": [
        "canule"
    ],
    "canut": [
        "canut"
    ],
    "canuts": [
        "canut"
    ],
    "canyon": [
        "canyon"
    ],
    "canyons": [
        "canyon"
    ],
    "canzonettes": [
        "canzonette"
    ],
    "caoua": [
        "caoua"
    ],
    "caouas": [
        "caoua"
    ],
    "caoutchouc": [
        "caoutchouc"
    ],
    "caoutchoucs": [
        "caoutchouc"
    ],
    "caoutchouteuse": [
        "caoutchouteux"
    ],
    "caoutchouteuses": [
        "caoutchouteux"
    ],
    "caoutchouteux": [
        "caoutchouteux"
    ],
    "caoutchoute": [
        "caoutchouter",
        "caoutchoute"
    ],
    "caoutchoutee": [
        "caoutchouter",
        "caoutchoute"
    ],
    "caoutchoutees": [
        "caoutchoute"
    ],
    "caoutchoutes": [
        "caoutchouter",
        "caoutchoute"
    ],
    "cap": [
        "cap"
    ],
    "capable": [
        "capable"
    ],
    "capables": [
        "capable"
    ],
    "capacite": [
        "capacite"
    ],
    "capacites": [
        "capacites",
        "capacite"
    ],
    "capades": [
        "capade"
    ],
    "caparacon": [
        "caparacon"
    ],
    "caparaconnait": [
        "caparaconner"
    ],
    "caparaconne": [
        "caparaconner"
    ],
    "caparaconnee": [
        "caparaconner"
    ],
    "caparaconnees": [
        "caparaconner"
    ],
    "caparaconnes": [
        "caparaconner"
    ],
    "caparacons": [
        "caparacon"
    ],
    "cape": [
        "cape"
    ],
    "capelage": [
        "capelage"
    ],
    "capeline": [
        "capeline"
    ],
    "capelines": [
        "capeline"
    ],
    "capele": [
        "capeler"
    ],
    "caper": [
        "caper"
    ],
    "capes": [
        "cape"
    ],
    "capharnaum": [
        "capharnaum"
    ],
    "capillaire": [
        "capillaire"
    ],
    "capillaires": [
        "capillaire"
    ],
    "capillarite": [
        "capillarite"
    ],
    "capilliculteur": [
        "capilliculteur"
    ],
    "capilotade": [
        "capilotade"
    ],
    "capilotades": [
        "capilotade"
    ],
    "capisco": [
        "capisco"
    ],
    "capitaine": [
        "capitaine"
    ],
    "capitainerie": [
        "capitainerie"
    ],
    "capitaines": [
        "capitaine"
    ],
    "capital": [
        "capital"
    ],
    "capitale": [
        "capitale",
        "capital"
    ],
    "capitalement": [
        "capitalement"
    ],
    "capitales": [
        "capitale",
        "capital"
    ],
    "capitalisation": [
        "capitalisation"
    ],
    "capitalise": [
        "capitaliser"
    ],
    "capitaliser": [
        "capitaliser"
    ],
    "capitalisme": [
        "capitalisme"
    ],
    "capitalisons": [
        "capitaliser"
    ],
    "capitaliste": [
        "capitaliste"
    ],
    "capitalistes": [
        "capitaliste"
    ],
    "capitalistiques": [
        "capitalistique"
    ],
    "capitalises": [
        "capitalise",
        "capitaliser"
    ],
    "capitan": [
        "capitan"
    ],
    "capitanat": [
        "capitanat"
    ],
    "capitane": [
        "capitane"
    ],
    "capitans": [
        "capitan"
    ],
    "capitaux": [
        "capital"
    ],
    "capiteuse": [
        "capiteux"
    ],
    "capiteuses": [
        "capiteux"
    ],
    "capiteux": [
        "capiteux"
    ],
    "capitole": [
        "capitole"
    ],
    "capiton": [
        "capiton"
    ],
    "capitonnage": [
        "capitonnage"
    ],
    "capitonnaient": [
        "capitonner"
    ],
    "capitonnait": [
        "capitonner"
    ],
    "capitonner": [
        "capitonner"
    ],
    "capitonne": [
        "capitonne",
        "capitonner"
    ],
    "capitonnee": [
        "capitonne",
        "capitonner"
    ],
    "capitonnees": [
        "capitonne",
        "capitonner"
    ],
    "capitonnes": [
        "capitonne",
        "capitonner"
    ],
    "capitons": [
        "capiton"
    ],
    "capitouls": [
        "capitoul"
    ],
    "capitula": [
        "capituler"
    ],
    "capitulaient": [
        "capituler"
    ],
    "capitulaire": [
        "capitulaire"
    ],
    "capitulais": [
        "capituler"
    ],
    "capitulait": [
        "capituler"
    ],
    "capitulant": [
        "capituler"
    ],
    "capitulard": [
        "capitulard"
    ],
    "capitulation": [
        "capitulation"
    ],
    "capitulations": [
        "capitulation"
    ],
    "capitule": [
        "capitule",
        "capituler"
    ],
    "capitulent": [
        "capituler"
    ],
    "capituler": [
        "capituler"
    ],
    "capitulera": [
        "capituler"
    ],
    "capitulerait": [
        "capituler"
    ],
    "capitulerez": [
        "capituler"
    ],
    "capitulerons": [
        "capituler"
    ],
    "capituleront": [
        "capituler"
    ],
    "capitules": [
        "capitule",
        "capituler"
    ],
    "capituliez": [
        "capituler"
    ],
    "capitulions": [
        "capituler"
    ],
    "capitulons": [
        "capituler"
    ],
    "capitulerent": [
        "capituler"
    ],
    "capo": [
        "capo"
    ],
    "capoc": [
        "capoc"
    ],
    "capon": [
        "capon"
    ],
    "capons": [
        "capon"
    ],
    "caporal": [
        "caporal"
    ],
    "caporale": [
        "caporal"
    ],
    "caporaux": [
        "caporal"
    ],
    "capos": [
        "capo"
    ],
    "capot": [
        "capot"
    ],
    "capota": [
        "capoter"
    ],
    "capotaient": [
        "capoter"
    ],
    "capote": [
        "capote",
        "capoter"
    ],
    "capoter": [
        "capoter"
    ],
    "capotes": [
        "capote",
        "capoter"
    ],
    "capots": [
        "capot"
    ],
    "capotee": [
        "capoter"
    ],
    "cappa": [
        "cappa"
    ],
    "cappuccino": [
        "cappuccino"
    ],
    "cappuccinos": [
        "cappuccino"
    ],
    "capricant": [
        "capricant"
    ],
    "capricants": [
        "capricant"
    ],
    "caprice": [
        "caprice"
    ],
    "caprices": [
        "caprice"
    ],
    "capricieuse": [
        "capricieux"
    ],
    "capricieusement": [
        "capricieusement"
    ],
    "capricieuses": [
        "capricieux"
    ],
    "capricieux": [
        "capricieux"
    ],
    "capricorne": [
        "capricorne"
    ],
    "capricornes": [
        "capricorne"
    ],
    "caprine": [
        "caprin"
    ],
    "caps": [
        "cap"
    ],
    "capsulaire": [
        "capsulaire"
    ],
    "capsule": [
        "capsuler",
        "capsule"
    ],
    "capsules": [
        "capsule"
    ],
    "capta": [
        "capter"
    ],
    "captage": [
        "captage"
    ],
    "captaient": [
        "capter"
    ],
    "captais": [
        "capter"
    ],
    "captait": [
        "capter"
    ],
    "captant": [
        "capter"
    ],
    "captation": [
        "captation"
    ],
    "captations": [
        "captation"
    ],
    "capte": [
        "capter"
    ],
    "captent": [
        "capter"
    ],
    "capter": [
        "capter"
    ],
    "capterai": [
        "capter"
    ],
    "capterais": [
        "capter"
    ],
    "capterait": [
        "capter"
    ],
    "capteront": [
        "capter"
    ],
    "capteur": [
        "capteur"
    ],
    "capteurs": [
        "capteur"
    ],
    "captez": [
        "capter"
    ],
    "captieuse": [
        "captieux"
    ],
    "captieux": [
        "captieux"
    ],
    "captif": [
        "captif"
    ],
    "captifs": [
        "captif"
    ],
    "captions": [
        "caption",
        "capter"
    ],
    "captiva": [
        "captiver"
    ],
    "captivaient": [
        "captiver"
    ],
    "captivait": [
        "captiver"
    ],
    "captivant": [
        "captiver",
        "captivant"
    ],
    "captivante": [
        "captivant"
    ],
    "captivantes": [
        "captivant"
    ],
    "captive": [
        "captiver",
        "captif"
    ],
    "captivent": [
        "captiver"
    ],
    "captiver": [
        "captiver"
    ],
    "captives": [
        "captiver",
        "captive",
        "captif"
    ],
    "captivite": [
        "captivite"
    ],
    "captiverent": [
        "captiver"
    ],
    "captivee": [
        "captiver"
    ],
    "captons": [
        "capter"
    ],
    "captura": [
        "capturer"
    ],
    "capturait": [
        "capturer"
    ],
    "capturant": [
        "capturer"
    ],
    "capture": [
        "capture",
        "capturer"
    ],
    "capturent": [
        "capturer"
    ],
    "capturer": [
        "capturer"
    ],
    "capturera": [
        "capturer"
    ],
    "capturerait": [
        "capturer"
    ],
    "captureras": [
        "capturer"
    ],
    "capturerez": [
        "capturer"
    ],
    "capturerons": [
        "capturer"
    ],
    "captureront": [
        "capturer"
    ],
    "captures": [
        "capture",
        "capturer"
    ],
    "capturez": [
        "capturer"
    ],
    "capturons": [
        "capturer"
    ],
    "capturee": [
        "capturer"
    ],
    "capturees": [
        "capturer"
    ],
    "captee": [
        "capter"
    ],
    "captees": [
        "capter"
    ],
    "captes": [
        "capter"
    ],
    "capuccino": [
        "capuccino"
    ],
    "capuche": [
        "capuche"
    ],
    "capuches": [
        "capuche"
    ],
    "capuchon": [
        "capuchon"
    ],
    "capuchonnes": [
        "capuchonner"
    ],
    "capuchons": [
        "capuchon"
    ],
    "capucin": [
        "capucin"
    ],
    "capucinade": [
        "capucinade"
    ],
    "capucinades": [
        "capucinade"
    ],
    "capucine": [
        "capucine"
    ],
    "capucines": [
        "capucine"
    ],
    "capucino": [
        "capucino"
    ],
    "capucins": [
        "capucin"
    ],
    "capulet": [
        "capulet"
    ],
    "capetien": [
        "capetien"
    ],
    "capetienne": [
        "capetien"
    ],
    "capetiennes": [
        "capetien"
    ],
    "caque": [
        "caque"
    ],
    "caquelon": [
        "caquelon"
    ],
    "caques": [
        "caque"
    ],
    "caquet": [
        "caquet"
    ],
    "caquetage": [
        "caquetage"
    ],
    "caquetages": [
        "caquetage"
    ],
    "caquetaient": [
        "caqueter"
    ],
    "caquetait": [
        "caqueter"
    ],
    "caquetant": [
        "caqueter",
        "caquetant"
    ],
    "caquetante": [
        "caquetant"
    ],
    "caquetantes": [
        "caquetant"
    ],
    "caqueter": [
        "caqueter"
    ],
    "caqueteuse": [
        "caqueteur"
    ],
    "caquets": [
        "caquet"
    ],
    "caquette": [
        "caqueter"
    ],
    "caquettent": [
        "caqueter"
    ],
    "caquetement": [
        "caquetement"
    ],
    "caquetements": [
        "caquetement"
    ],
    "car": [
        "car"
    ],
    "carabas": [
        "carabas"
    ],
    "carabe": [
        "carabe"
    ],
    "carabes": [
        "carabe"
    ],
    "carabin": [
        "carabin"
    ],
    "carabine": [
        "carabine"
    ],
    "carabines": [
        "carabine"
    ],
    "carabinier": [
        "carabinier"
    ],
    "carabiniers": [
        "carabinier"
    ],
    "carabins": [
        "carabin"
    ],
    "carabinee": [
        "carabine"
    ],
    "carabosse": [
        "carabosse"
    ],
    "caracal": [
        "caracal"
    ],
    "caraco": [
        "caraco"
    ],
    "caracola": [
        "caracoler"
    ],
    "caracolade": [
        "caracolade"
    ],
    "caracolait": [
        "caracoler"
    ],
    "caracolant": [
        "caracoler",
        "caracolant"
    ],
    "caracole": [
        "caracole",
        "caracoler"
    ],
    "caracolent": [
        "caracoler"
    ],
    "caracoler": [
        "caracoler"
    ],
    "caracolerez": [
        "caracoler"
    ],
    "caracos": [
        "caraco"
    ],
    "caractere": [
        "caractere"
    ],
    "caracteres": [
        "caractere"
    ],
    "caracteriel": [
        "caracteriel"
    ],
    "caracterielle": [
        "caracteriel"
    ],
    "caracterielles": [
        "caracteriel"
    ],
    "caracteriels": [
        "caracteriel"
    ],
    "caracterisait": [
        "caracteriser"
    ],
    "caracterisant": [
        "caracterisant",
        "caracteriser"
    ],
    "caracterisation": [
        "caracterisation"
    ],
    "caracterise": [
        "caracterise",
        "caracteriser"
    ],
    "caracterisent": [
        "caracteriser"
    ],
    "caracteriser": [
        "caracteriser"
    ],
    "caracteriserais": [
        "caracteriser"
    ],
    "caracteriserait": [
        "caracteriser"
    ],
    "caracteristique": [
        "caracteristique"
    ],
    "caracteristiques": [
        "caracteristique"
    ],
    "caracterisee": [
        "caracterise",
        "caracteriser"
    ],
    "caracterisees": [
        "caracterise"
    ],
    "caracterises": [
        "caracterise",
        "caracteriser"
    ],
    "caracterologie": [
        "caracterologie"
    ],
    "caracul": [
        "caracul"
    ],
    "carafe": [
        "carafe"
    ],
    "carafes": [
        "carafe"
    ],
    "carafon": [
        "carafon"
    ],
    "carafons": [
        "carafon"
    ],
    "caramba": [
        "caramba"
    ],
    "carambar": [
        "carambar"
    ],
    "carambars": [
        "carambar"
    ],
    "carambolage": [
        "carambolage"
    ],
    "carambolages": [
        "carambolage"
    ],
    "carambolaient": [
        "caramboler"
    ],
    "carambolait": [
        "caramboler"
    ],
    "carambole": [
        "carambole",
        "caramboler"
    ],
    "carambolent": [
        "caramboler"
    ],
    "caramboler": [
        "caramboler"
    ],
    "caramboles": [
        "carambole"
    ],
    "carambouillage": [
        "carambouillage"
    ],
    "carambouille": [
        "carambouille",
        "carambouiller"
    ],
    "carambouilleurs": [
        "carambouilleur"
    ],
    "caramel": [
        "caramel"
    ],
    "caramels": [
        "caramel"
    ],
    "caramelisait": [
        "carameliser"
    ],
    "caramelise": [
        "caramelise",
        "carameliser"
    ],
    "carameliser": [
        "carameliser"
    ],
    "caramelisee": [
        "caramelise"
    ],
    "caramelisees": [
        "caramelise"
    ],
    "caramelises": [
        "caramelise"
    ],
    "carapace": [
        "carapace"
    ],
    "carapaces": [
        "carapace"
    ],
    "carapatait": [
        "carapater"
    ],
    "carapate": [
        "carapater"
    ],
    "carapatent": [
        "carapater"
    ],
    "carapater": [
        "carapater"
    ],
    "carapates": [
        "carapater"
    ],
    "caraque": [
        "caraque"
    ],
    "carat": [
        "carat"
    ],
    "carats": [
        "carat"
    ],
    "caravane": [
        "caravane"
    ],
    "caravanes": [
        "caravane"
    ],
    "caravanier": [
        "caravanier"
    ],
    "caravaniers": [
        "caravanier"
    ],
    "caravaning": [
        "caravaning"
    ],
    "caravanings": [
        "caravaning"
    ],
    "caravaniere": [
        "caravanier"
    ],
    "caravanieres": [
        "caravanier"
    ],
    "caravanserail": [
        "caravanserail"
    ],
    "caravanserails": [
        "caravanserail"
    ],
    "caravelle": [
        "caravelle"
    ],
    "caravelles": [
        "caravelle"
    ],
    "caraibe": [
        "caraibe"
    ],
    "caraibes": [
        "caraibe"
    ],
    "carbets": [
        "carbet"
    ],
    "carboglace": [
        "carboglace"
    ],
    "carbonade": [
        "carbonade"
    ],
    "carbonari": [
        "carbonari"
    ],
    "carbonate": [
        "carbonate"
    ],
    "carbone": [
        "carbone"
    ],
    "carbones": [
        "carbone"
    ],
    "carbonique": [
        "carbonique"
    ],
    "carboniques": [
        "carbonique"
    ],
    "carbonisa": [
        "carboniser"
    ],
    "carbonisant": [
        "carboniser"
    ],
    "carbonisation": [
        "carbonisation"
    ],
    "carboniser": [
        "carboniser"
    ],
    "carbonise": [
        "carboniser"
    ],
    "carbonisee": [
        "carboniser"
    ],
    "carbonisees": [
        "carboniser"
    ],
    "carbonises": [
        "carboniser"
    ],
    "carboxyhemoglobine": [
        "carboxyhemoglobine"
    ],
    "carburaient": [
        "carburer"
    ],
    "carburais": [
        "carburer"
    ],
    "carburait": [
        "carburer"
    ],
    "carburant": [
        "carburant",
        "carburer"
    ],
    "carburants": [
        "carburant"
    ],
    "carburateur": [
        "carburateur"
    ],
    "carburateurs": [
        "carburateur"
    ],
    "carburation": [
        "carburation"
    ],
    "carbure": [
        "carbure",
        "carburer"
    ],
    "carburent": [
        "carburer"
    ],
    "carburer": [
        "carburer"
    ],
    "carburez": [
        "carburer"
    ],
    "carcajou": [
        "carcajou"
    ],
    "carcan": [
        "carcan"
    ],
    "carcans": [
        "carcan"
    ],
    "carcasse": [
        "carcasse"
    ],
    "carcasses": [
        "carcasse",
        "carcass"
    ],
    "carcharodon": [
        "carcharodon"
    ],
    "carcinome": [
        "carcinome"
    ],
    "carcinoide": [
        "carcinoide"
    ],
    "carceral": [
        "carceral"
    ],
    "carcerale": [
        "carceral"
    ],
    "carcerales": [
        "carceral"
    ],
    "carceraux": [
        "carceral"
    ],
    "cardage": [
        "cardage"
    ],
    "cardait": [
        "carder"
    ],
    "cardamome": [
        "cardamome"
    ],
    "cardamomes": [
        "cardamome"
    ],
    "cardan": [
        "cardan"
    ],
    "cardans": [
        "cardan"
    ],
    "cardant": [
        "carder"
    ],
    "carde": [
        "carde",
        "carder"
    ],
    "carder": [
        "carder"
    ],
    "carderai": [
        "carder"
    ],
    "carderie": [
        "carderie"
    ],
    "cardes": [
        "carde",
        "carder"
    ],
    "cardeur": [
        "cardeur"
    ],
    "cardeuse": [
        "cardeur"
    ],
    "cardeuses": [
        "cardeur"
    ],
    "cardia": [
        "cardia"
    ],
    "cardiaque": [
        "cardiaque"
    ],
    "cardiaques": [
        "cardiaque"
    ],
    "cardigan": [
        "cardigan"
    ],
    "cardigans": [
        "cardigan"
    ],
    "cardinal": [
        "cardinal"
    ],
    "cardinale": [
        "cardinal"
    ],
    "cardinales": [
        "cardinal"
    ],
    "cardinalice": [
        "cardinalice"
    ],
    "cardinalices": [
        "cardinalice"
    ],
    "cardinaux": [
        "cardinal"
    ],
    "cardiogramme": [
        "cardiogramme"
    ],
    "cardiographe": [
        "cardiographe"
    ],
    "cardiographie": [
        "cardiographie"
    ],
    "cardiologie": [
        "cardiologie"
    ],
    "cardiologue": [
        "cardiologue"
    ],
    "cardiologues": [
        "cardiologue"
    ],
    "cardiomyopathie": [
        "cardiomyopathie"
    ],
    "cardiomegalie": [
        "cardiomegalie"
    ],
    "cardiotonique": [
        "cardiotonique"
    ],
    "cardiovasculaire": [
        "cardiovasculaire"
    ],
    "cardioide": [
        "cardioide"
    ],
    "cardite": [
        "cardite"
    ],
    "cardium": [
        "cardium"
    ],
    "cardon": [
        "cardon"
    ],
    "cardons": [
        "cardon"
    ],
    "carderes": [
        "carder"
    ],
    "cardee": [
        "carder"
    ],
    "care": [
        "care"
    ],
    "carence": [
        "carence"
    ],
    "carences": [
        "carence"
    ],
    "caressa": [
        "caresser"
    ],
    "caressai": [
        "caresser"
    ],
    "caressaient": [
        "caresser"
    ],
    "caressais": [
        "caresser"
    ],
    "caressait": [
        "caresser"
    ],
    "caressant": [
        "caresser",
        "caressant"
    ],
    "caressante": [
        "caressant"
    ],
    "caressantes": [
        "caressant"
    ],
    "caressants": [
        "caressant"
    ],
    "caresse": [
        "caresse",
        "caresser"
    ],
    "caressent": [
        "caresser"
    ],
    "caresser": [
        "caresser"
    ],
    "caressera": [
        "caresser"
    ],
    "caresserai": [
        "caresser"
    ],
    "caresseraient": [
        "caresser"
    ],
    "caresserait": [
        "caresser"
    ],
    "caresserez": [
        "caresser"
    ],
    "caresseront": [
        "caresser"
    ],
    "caresses": [
        "caresse",
        "caress",
        "caresser"
    ],
    "caresseurs": [
        "caresseur"
    ],
    "caresseuse": [
        "caresseur"
    ],
    "caresseuses": [
        "caresseur"
    ],
    "caressez": [
        "caresser"
    ],
    "caressions": [
        "caresser"
    ],
    "caressat": [
        "caresser"
    ],
    "caresserent": [
        "caresser"
    ],
    "caressee": [
        "caresser"
    ],
    "caressees": [
        "caresser"
    ],
    "caret": [
        "caret"
    ],
    "carex": [
        "carex"
    ],
    "cargaison": [
        "cargaison"
    ],
    "cargaisons": [
        "cargaison"
    ],
    "cargo": [
        "cargo"
    ],
    "cargos": [
        "cargo"
    ],
    "cargua": [
        "carguer"
    ],
    "carguent": [
        "carguer"
    ],
    "carguer": [
        "carguer"
    ],
    "carguez": [
        "carguer"
    ],
    "carguee": [
        "carguer"
    ],
    "carguees": [
        "carguer"
    ],
    "cari": [
        "cari"
    ],
    "cariatide": [
        "cariatide"
    ],
    "cariatides": [
        "cariatide"
    ],
    "caribou": [
        "caribou"
    ],
    "caribous": [
        "caribou"
    ],
    "caribeenne": [
        "caribeen"
    ],
    "caricatural": [
        "caricatural"
    ],
    "caricaturale": [
        "caricatural"
    ],
    "caricaturales": [
        "caricatural"
    ],
    "caricaturaux": [
        "caricatural"
    ],
    "caricature": [
        "caricaturer",
        "caricature"
    ],
    "caricaturer": [
        "caricaturer"
    ],
    "caricatures": [
        "caricaturer",
        "caricature"
    ],
    "caricaturiste": [
        "caricaturiste"
    ],
    "caricaturistes": [
        "caricaturiste"
    ],
    "caricaturees": [
        "caricaturer"
    ],
    "carie": [
        "carie"
    ],
    "carien": [
        "carien"
    ],
    "carier": [
        "carier"
    ],
    "caries": [
        "carie"
    ],
    "carillon": [
        "carillon"
    ],
    "carillonnaient": [
        "carillonner"
    ],
    "carillonnait": [
        "carillonner"
    ],
    "carillonnant": [
        "carillonner"
    ],
    "carillonne": [
        "carillonne",
        "carillonner"
    ],
    "carillonnent": [
        "carillonner"
    ],
    "carillonner": [
        "carillonner"
    ],
    "carillonnes": [
        "carillonne",
        "carillonner"
    ],
    "carillonneur": [
        "carillonneur"
    ],
    "carillonneuse": [
        "carillonneur"
    ],
    "carillonnees": [
        "carillonne"
    ],
    "carillons": [
        "carillon"
    ],
    "carioca": [
        "carioca"
    ],
    "caris": [
        "cari"
    ],
    "carissime": [
        "carissime"
    ],
    "cariste": [
        "cariste"
    ],
    "caritatif": [
        "caritatif"
    ],
    "caritatifs": [
        "caritatif"
    ],
    "caritative": [
        "caritatif"
    ],
    "caritatives": [
        "caritatif"
    ],
    "cariee": [
        "carie",
        "carier"
    ],
    "cariees": [
        "carie",
        "carier"
    ],
    "carlin": [
        "carlin"
    ],
    "carlines": [
        "carline"
    ],
    "carlingue": [
        "carlingue"
    ],
    "carlingues": [
        "carlingue"
    ],
    "carlins": [
        "carlin"
    ],
    "carlisme": [
        "carlisme"
    ],
    "carliste": [
        "carliste"
    ],
    "carlistes": [
        "carliste"
    ],
    "carma": [
        "carmer"
    ],
    "carmagnole": [
        "carmagnole"
    ],
    "carmagnoles": [
        "carmagnole"
    ],
    "carmant": [
        "carmer"
    ],
    "carme": [
        "carme",
        "carmer"
    ],
    "carmel": [
        "carmel"
    ],
    "carmer": [
        "carmer"
    ],
    "carmes": [
        "carme"
    ],
    "carmin": [
        "carmin"
    ],
    "carmina": [
        "carminer"
    ],
    "carmine": [
        "carminer",
        "carmine"
    ],
    "carmins": [
        "carmin"
    ],
    "carminee": [
        "carminer",
        "carmine"
    ],
    "carminees": [
        "carmine"
    ],
    "carmines": [
        "carmine"
    ],
    "carmee": [
        "carmer"
    ],
    "carmelite": [
        "carmelite"
    ],
    "carmelites": [
        "carmelite"
    ],
    "carnage": [
        "carnage"
    ],
    "carnages": [
        "carnage"
    ],
    "carnassier": [
        "carnassier"
    ],
    "carnassiers": [
        "carnassier"
    ],
    "carnassiere": [
        "carnassier"
    ],
    "carnassieres": [
        "carnassier"
    ],
    "carnation": [
        "carnation"
    ],
    "carnaval": [
        "carnaval"
    ],
    "carnavalesque": [
        "carnavalesque"
    ],
    "carnavals": [
        "carnaval"
    ],
    "carne": [
        "carne"
    ],
    "carnes": [
        "carne"
    ],
    "carnet": [
        "carnet"
    ],
    "carnets": [
        "carnet"
    ],
    "carnier": [
        "carnier"
    ],
    "carniers": [
        "carnier"
    ],
    "carnivore": [
        "carnivore"
    ],
    "carnivores": [
        "carnivore"
    ],
    "carnee": [
        "carne"
    ],
    "carnees": [
        "carne"
    ],
    "carogne": [
        "carogne"
    ],
    "carole": [
        "carole"
    ],
    "caroline": [
        "carolin"
    ],
    "carolines": [
        "carolin"
    ],
    "carolingien": [
        "carolingien"
    ],
    "carolingienne": [
        "carolingien"
    ],
    "carolingiens": [
        "carolingien"
    ],
    "carolins": [
        "carolin"
    ],
    "carolus": [
        "carolus"
    ],
    "caronades": [
        "caronade"
    ],
    "caroncule": [
        "caroncule"
    ],
    "carotide": [
        "carotide"
    ],
    "carotides": [
        "carotide"
    ],
    "carotidien": [
        "carotidien"
    ],
    "carotidienne": [
        "carotidien"
    ],
    "carottage": [
        "carottage"
    ],
    "carottait": [
        "carotter"
    ],
    "carotte": [
        "carotter",
        "carotte"
    ],
    "carottent": [
        "carotter"
    ],
    "carotter": [
        "carotter"
    ],
    "carotterait": [
        "carotter"
    ],
    "carottes": [
        "carotter",
        "carotte"
    ],
    "carotteur": [
        "carotteur"
    ],
    "carotteuse": [
        "carotteur"
    ],
    "carottier": [
        "carottier"
    ],
    "carotene": [
        "carotene"
    ],
    "caroube": [
        "caroube"
    ],
    "caroubier": [
        "caroubier"
    ],
    "caroubiers": [
        "caroubier"
    ],
    "caroublant": [
        "caroubler"
    ],
    "carouble": [
        "carouble"
    ],
    "caroubler": [
        "caroubler"
    ],
    "caroubles": [
        "carouble"
    ],
    "caroubleur": [
        "caroubleur"
    ],
    "carousse": [
        "carousse"
    ],
    "carpaccio": [
        "carpaccio"
    ],
    "carpe": [
        "carpe"
    ],
    "carpes": [
        "carpe"
    ],
    "carpette": [
        "carpette"
    ],
    "carpettes": [
        "carpette"
    ],
    "carpien": [
        "carpien"
    ],
    "carpienne": [
        "carpien"
    ],
    "carpillon": [
        "carpillon"
    ],
    "carquois": [
        "carquois"
    ],
    "carra": [
        "carrer"
    ],
    "carraient": [
        "carrer"
    ],
    "carrais": [
        "carrer"
    ],
    "carrait": [
        "carrer"
    ],
    "carrant": [
        "carrer"
    ],
    "carrare": [
        "carrare"
    ],
    "carre": [
        "carre",
        "carrer"
    ],
    "carreau": [
        "carreau"
    ],
    "carreaux": [
        "carreau"
    ],
    "carrefour": [
        "carrefour"
    ],
    "carrefours": [
        "carrefour"
    ],
    "carrelage": [
        "carrelage"
    ],
    "carrelages": [
        "carrelage"
    ],
    "carrelait": [
        "carreler"
    ],
    "carrelant": [
        "carreler"
    ],
    "carreler": [
        "carreler"
    ],
    "carrelet": [
        "carrelet"
    ],
    "carrelets": [
        "carrelet"
    ],
    "carreleur": [
        "carreleur"
    ],
    "carreleurs": [
        "carreleur"
    ],
    "carrele": [
        "carreler"
    ],
    "carrelee": [
        "carreler"
    ],
    "carrelees": [
        "carreler"
    ],
    "carreles": [
        "carreler"
    ],
    "carrent": [
        "carrer"
    ],
    "carrer": [
        "carrer"
    ],
    "carrerais": [
        "carrer"
    ],
    "carres": [
        "carre",
        "carrer"
    ],
    "carrick": [
        "carrick"
    ],
    "carrier": [
        "carrier"
    ],
    "carriers": [
        "carrier"
    ],
    "carriole": [
        "carriole"
    ],
    "carrioles": [
        "carriole"
    ],
    "carriere": [
        "carriere"
    ],
    "carrieres": [
        "carriere"
    ],
    "carrierisme": [
        "carrierisme"
    ],
    "carrieriste": [
        "carrieriste"
    ],
    "carrieristes": [
        "carrieriste"
    ],
    "carron": [
        "carron"
    ],
    "carrossable": [
        "carrossable"
    ],
    "carrossables": [
        "carrossable"
    ],
    "carrosse": [
        "carrosser",
        "carrosse"
    ],
    "carrosser": [
        "carrosser"
    ],
    "carrosserie": [
        "carrosserie"
    ],
    "carrosseries": [
        "carrosserie"
    ],
    "carrosses": [
        "carrosse"
    ],
    "carrossier": [
        "carrossier"
    ],
    "carrossiers": [
        "carrossier"
    ],
    "carrossee": [
        "carrosser"
    ],
    "carrossees": [
        "carrosser"
    ],
    "carrousel": [
        "carrousel"
    ],
    "carrousels": [
        "carrousel"
    ],
    "carrure": [
        "carrure"
    ],
    "carrures": [
        "carrure"
    ],
    "carry": [
        "carry"
    ],
    "carree": [
        "carre",
        "carrer",
        "carree"
    ],
    "carrees": [
        "carre",
        "carrer",
        "carree"
    ],
    "carrement": [
        "carrement"
    ],
    "cars": [
        "car"
    ],
    "carta": [
        "carter"
    ],
    "cartable": [
        "cartable"
    ],
    "cartables": [
        "cartable"
    ],
    "carte": [
        "carte",
        "carter"
    ],
    "cartel": [
        "cartel"
    ],
    "cartels": [
        "cartel"
    ],
    "carter": [
        "carter"
    ],
    "carterie": [
        "carterie"
    ],
    "carters": [
        "carter"
    ],
    "cartes": [
        "carte"
    ],
    "carthaginois": [
        "carthaginois"
    ],
    "carthaginoise": [
        "carthaginois"
    ],
    "carthame": [
        "carthame"
    ],
    "cartilage": [
        "cartilage"
    ],
    "cartilages": [
        "cartilage"
    ],
    "cartilagineuse": [
        "cartilagineux"
    ],
    "cartilagineuses": [
        "cartilagineux"
    ],
    "cartilagineux": [
        "cartilagineux"
    ],
    "cartographe": [
        "cartographe"
    ],
    "cartographes": [
        "cartographe"
    ],
    "cartographie": [
        "cartographie",
        "cartographier"
    ],
    "cartographient": [
        "cartographier"
    ],
    "cartographier": [
        "cartographier"
    ],
    "cartographique": [
        "cartographique"
    ],
    "cartographiques": [
        "cartographique"
    ],
    "cartographies": [
        "cartographier"
    ],
    "cartomancie": [
        "cartomancie"
    ],
    "cartomancien": [
        "cartomancien"
    ],
    "cartomancienne": [
        "cartomancien"
    ],
    "cartomanciennes": [
        "cartomancien"
    ],
    "carton": [
        "carton"
    ],
    "cartonnage": [
        "cartonnage"
    ],
    "cartonnages": [
        "cartonnage"
    ],
    "cartonnant": [
        "cartonner"
    ],
    "cartonne": [
        "cartonner"
    ],
    "cartonnent": [
        "cartonner"
    ],
    "cartonner": [
        "cartonner"
    ],
    "cartonneuse": [
        "cartonneux"
    ],
    "cartonneuses": [
        "cartonneur",
        "cartonneux"
    ],
    "cartonneux": [
        "cartonneux"
    ],
    "cartonnier": [
        "cartonnier"
    ],
    "cartonniers": [
        "cartonnier"
    ],
    "cartonnee": [
        "cartonner"
    ],
    "cartonnees": [
        "cartonner"
    ],
    "cartonnes": [
        "cartonner"
    ],
    "cartons": [
        "carton"
    ],
    "cartoon": [
        "cartoon"
    ],
    "cartoons": [
        "cartoon"
    ],
    "cartotheque": [
        "cartotheque"
    ],
    "cartouche": [
        "cartouche"
    ],
    "cartoucherie": [
        "cartoucherie"
    ],
    "cartouches": [
        "cartouche"
    ],
    "cartouchiere": [
        "cartouchiere"
    ],
    "cartouchieres": [
        "cartouchiere"
    ],
    "cartulaires": [
        "cartulaire"
    ],
    "cartesianisme": [
        "cartesianisme"
    ],
    "cartesien": [
        "cartesien"
    ],
    "cartesienne": [
        "cartesien"
    ],
    "cartesiennes": [
        "cartesien"
    ],
    "cartesiens": [
        "cartesien"
    ],
    "carvi": [
        "carvi"
    ],
    "cary": [
        "cary"
    ],
    "caryatides": [
        "caryatide"
    ],
    "caryotype": [
        "caryotype"
    ],
    "carene": [
        "carene",
        "carener"
    ],
    "carenes": [
        "carene"
    ],
    "carenage": [
        "carenage"
    ],
    "carenages": [
        "carenage"
    ],
    "carener": [
        "carener"
    ],
    "carenees": [
        "carener"
    ],
    "careme": [
        "careme"
    ],
    "caremes": [
        "careme"
    ],
    "cas": [
        "ca",
        "cas"
    ],
    "casa": [
        "casa",
        "caser"
    ],
    "casablancaises": [
        "casablancais"
    ],
    "casaient": [
        "caser"
    ],
    "casait": [
        "caser"
    ],
    "casanier": [
        "casanier"
    ],
    "casaniers": [
        "casanier"
    ],
    "casaniere": [
        "casanier"
    ],
    "casanieres": [
        "casanier"
    ],
    "casant": [
        "caser"
    ],
    "casaque": [
        "casaque"
    ],
    "casaques": [
        "casaque"
    ],
    "casaquin": [
        "casaquin"
    ],
    "casas": [
        "casa",
        "caser"
    ],
    "casbah": [
        "casbah"
    ],
    "cascadaient": [
        "cascader"
    ],
    "cascadait": [
        "cascader"
    ],
    "cascadant": [
        "cascader"
    ],
    "cascadas": [
        "cascader"
    ],
    "cascade": [
        "cascader",
        "cascade"
    ],
    "cascadent": [
        "cascader"
    ],
    "cascader": [
        "cascader"
    ],
    "cascades": [
        "cascader",
        "cascade"
    ],
    "cascadeur": [
        "cascadeur"
    ],
    "cascadeurs": [
        "cascadeur"
    ],
    "cascadeuse": [
        "cascadeur"
    ],
    "cascaderent": [
        "cascader"
    ],
    "cascara": [
        "cascara"
    ],
    "cascatelle": [
        "cascatelle"
    ],
    "cascatelles": [
        "cascatelle"
    ],
    "cascher": [
        "cascher"
    ],
    "case": [
        "caser",
        "case"
    ],
    "casemate": [
        "casemate"
    ],
    "casemates": [
        "casemate"
    ],
    "casent": [
        "caser"
    ],
    "caser": [
        "caser"
    ],
    "caserai": [
        "caser"
    ],
    "caserais": [
        "caser"
    ],
    "caserait": [
        "caser"
    ],
    "caserne": [
        "caserner",
        "caserne"
    ],
    "casernement": [
        "casernement"
    ],
    "casernements": [
        "casernement"
    ],
    "caserner": [
        "caserner"
    ],
    "casernes": [
        "caserner",
        "caserne"
    ],
    "cases": [
        "caser",
        "case"
    ],
    "casette": [
        "casette"
    ],
    "casettes": [
        "casette"
    ],
    "cash": [
        "cash"
    ],
    "casher": [
        "casher"
    ],
    "cashmere": [
        "cashmere"
    ],
    "casier": [
        "casier"
    ],
    "casiers": [
        "casier"
    ],
    "casimir": [
        "casimir"
    ],
    "casino": [
        "casino"
    ],
    "casinos": [
        "casino"
    ],
    "casoar": [
        "casoar"
    ],
    "casoars": [
        "casoar"
    ],
    "caspiennes": [
        "caspienne",
        "caspien"
    ],
    "casquaient": [
        "casquer"
    ],
    "casquais": [
        "casquer"
    ],
    "casquait": [
        "casquer"
    ],
    "casquant": [
        "casquer"
    ],
    "casque": [
        "casque",
        "casquer"
    ],
    "casquent": [
        "casquer"
    ],
    "casquer": [
        "casquer"
    ],
    "casquera": [
        "casquer"
    ],
    "casqueras": [
        "casquer"
    ],
    "casqueront": [
        "casquer"
    ],
    "casques": [
        "casque",
        "casquer"
    ],
    "casquette": [
        "casquette"
    ],
    "casquettes": [
        "casquette"
    ],
    "casquettiers": [
        "casquettier"
    ],
    "casquez": [
        "casquer"
    ],
    "casquee": [
        "casque",
        "casquer"
    ],
    "casquees": [
        "casque",
        "casquer"
    ],
    "cassa": [
        "casser"
    ],
    "cassable": [
        "cassable"
    ],
    "cassables": [
        "cassable"
    ],
    "cassage": [
        "cassage"
    ],
    "cassages": [
        "cassage"
    ],
    "cassai": [
        "casser"
    ],
    "cassaient": [
        "casser"
    ],
    "cassais": [
        "casser"
    ],
    "cassait": [
        "casser"
    ],
    "cassandre": [
        "cassandre"
    ],
    "cassant": [
        "casser",
        "cassant"
    ],
    "cassante": [
        "cassant"
    ],
    "cassantes": [
        "cassant"
    ],
    "cassants": [
        "cassant"
    ],
    "cassate": [
        "cassate"
    ],
    "cassation": [
        "cassation"
    ],
    "cassations": [
        "cassation"
    ],
    "casse": [
        "casser",
        "casse"
    ],
    "cassement": [
        "cassement"
    ],
    "cassements": [
        "cassement"
    ],
    "cassent": [
        "casser"
    ],
    "casser": [
        "casser"
    ],
    "cassera": [
        "casser"
    ],
    "casserai": [
        "casser"
    ],
    "casseraient": [
        "casser"
    ],
    "casserais": [
        "casser"
    ],
    "casserait": [
        "casser"
    ],
    "casseras": [
        "casser"
    ],
    "casserez": [
        "casser"
    ],
    "casseriez": [
        "casser"
    ],
    "casserole": [
        "casserole"
    ],
    "casseroles": [
        "casserole"
    ],
    "casserolee": [
        "casserolee"
    ],
    "casserolees": [
        "casserolee"
    ],
    "casserons": [
        "casser"
    ],
    "casseront": [
        "casser"
    ],
    "casses": [
        "casser",
        "casse"
    ],
    "cassetins": [
        "cassetin"
    ],
    "cassette": [
        "cassette"
    ],
    "cassettes": [
        "cassette"
    ],
    "casseur": [
        "casseur"
    ],
    "casseurs": [
        "casseur"
    ],
    "casseuse": [
        "casseur"
    ],
    "casseuses": [
        "casseur"
    ],
    "cassez": [
        "casser"
    ],
    "cassier": [
        "cassier"
    ],
    "cassiez": [
        "casser"
    ],
    "cassine": [
        "cassine"
    ],
    "cassis": [
        "cassis"
    ],
    "cassiterite": [
        "cassiterite"
    ],
    "cassolette": [
        "cassolette"
    ],
    "cassolettes": [
        "cassolette"
    ],
    "cassonade": [
        "cassonade"
    ],
    "cassons": [
        "casser",
        "casson"
    ],
    "cassoulet": [
        "cassoulet"
    ],
    "cassure": [
        "cassure"
    ],
    "cassures": [
        "cassure"
    ],
    "casserent": [
        "casser"
    ],
    "cassee": [
        "casser",
        "casse"
    ],
    "cassees": [
        "casser",
        "casse"
    ],
    "castagnait": [
        "castagner"
    ],
    "castagne": [
        "castagner",
        "castagne"
    ],
    "castagnent": [
        "castagner"
    ],
    "castagner": [
        "castagner"
    ],
    "castagnes": [
        "castagner"
    ],
    "castagnette": [
        "castagnette"
    ],
    "castagnettes": [
        "castagnette"
    ],
    "castard": [
        "castard"
    ],
    "caste": [
        "caste"
    ],
    "castel": [
        "castel"
    ],
    "castelet": [
        "castelet"
    ],
    "castes": [
        "caste"
    ],
    "castillan": [
        "castillan"
    ],
    "castillane": [
        "castillan"
    ],
    "castillanes": [
        "castillan"
    ],
    "castillans": [
        "castillan"
    ],
    "castille": [
        "castille"
    ],
    "castine": [
        "castine"
    ],
    "casting": [
        "casting",
        "cast"
    ],
    "castings": [
        "casting"
    ],
    "castor": [
        "castor"
    ],
    "castors": [
        "castor"
    ],
    "castrat": [
        "castrat"
    ],
    "castrateur": [
        "castrateur"
    ],
    "castration": [
        "castration"
    ],
    "castratrice": [
        "castrateur"
    ],
    "castratrices": [
        "castrateur"
    ],
    "castrats": [
        "castrat"
    ],
    "castrer": [
        "castrer"
    ],
    "castreur": [
        "castreur"
    ],
    "castreurs": [
        "castreur"
    ],
    "castrez": [
        "castrer"
    ],
    "castrisme": [
        "castrisme"
    ],
    "castriste": [
        "castriste"
    ],
    "castristes": [
        "castriste"
    ],
    "castrons": [
        "castrer"
    ],
    "castre": [
        "castrer"
    ],
    "castree": [
        "castrer"
    ],
    "castres": [
        "castrer"
    ],
    "casuel": [
        "casuel"
    ],
    "casuistes": [
        "casuiste"
    ],
    "casuistique": [
        "casuistique"
    ],
    "casuistiques": [
        "casuistique"
    ],
    "casee": [
        "caser"
    ],
    "casees": [
        "caser"
    ],
    "caseeuse": [
        "caseeux"
    ],
    "caseine": [
        "caseine"
    ],
    "cata": [
        "cata"
    ],
    "catabolique": [
        "catabolique"
    ],
    "catachrese": [
        "catachrese"
    ],
    "cataclysme": [
        "cataclysme"
    ],
    "cataclysmes": [
        "cataclysme"
    ],
    "cataclysmique": [
        "cataclysmique"
    ],
    "cataclysmiques": [
        "cataclysmique"
    ],
    "catacombe": [
        "catacombe"
    ],
    "catacombes": [
        "catacombe"
    ],
    "catadioptre": [
        "catadioptre"
    ],
    "catadioptres": [
        "catadioptre"
    ],
    "catafalque": [
        "catafalque"
    ],
    "catafalques": [
        "catafalque"
    ],
    "catalan": [
        "catalan"
    ],
    "catalane": [
        "catalan"
    ],
    "catalanes": [
        "catalan"
    ],
    "catalans": [
        "catalan"
    ],
    "catalauniques": [
        "catalaunique"
    ],
    "catalepsie": [
        "catalepsie"
    ],
    "catalepsies": [
        "catalepsie"
    ],
    "cataleptique": [
        "cataleptique"
    ],
    "cataleptiques": [
        "cataleptique"
    ],
    "catalogage": [
        "catalogage"
    ],
    "catalogne": [
        "catalogne"
    ],
    "cataloguais": [
        "cataloguer"
    ],
    "cataloguant": [
        "cataloguer"
    ],
    "catalogue": [
        "catalogue",
        "cataloguer"
    ],
    "cataloguent": [
        "cataloguer"
    ],
    "cataloguer": [
        "cataloguer"
    ],
    "cataloguerai": [
        "cataloguer"
    ],
    "catalogues": [
        "catalogue",
        "cataloguer"
    ],
    "cataloguiez": [
        "cataloguer"
    ],
    "cataloguee": [
        "cataloguer"
    ],
    "cataloguees": [
        "cataloguer"
    ],
    "catalpa": [
        "catalpa"
    ],
    "catalpas": [
        "catalpa"
    ],
    "catalyser": [
        "catalyser"
    ],
    "catalyses": [
        "catalyse"
    ],
    "catalyseur": [
        "catalyseur"
    ],
    "catalyseurs": [
        "catalyseur"
    ],
    "catalyse": [
        "catalyser"
    ],
    "catalytique": [
        "catalytique"
    ],
    "catalytiques": [
        "catalytique"
    ],
    "catamaran": [
        "catamaran"
    ],
    "cataphotes": [
        "cataphote"
    ],
    "cataplasme": [
        "cataplasme"
    ],
    "cataplasmes": [
        "cataplasme"
    ],
    "cataplexie": [
        "cataplexie"
    ],
    "catapulta": [
        "catapulter"
    ],
    "catapultait": [
        "catapulter"
    ],
    "catapulte": [
        "catapulter",
        "catapulte"
    ],
    "catapulter": [
        "catapulter"
    ],
    "catapultera": [
        "catapulter"
    ],
    "catapultes": [
        "catapulter",
        "catapulte"
    ],
    "catapultee": [
        "catapulter"
    ],
    "catapultees": [
        "catapulter"
    ],
    "cataracte": [
        "cataracte"
    ],
    "cataractes": [
        "cataracte"
    ],
    "catarrhal": [
        "catarrhal"
    ],
    "catarrhe": [
        "catarrhe"
    ],
    "catarrheuse": [
        "catarrheux"
    ],
    "catarrheux": [
        "catarrheux"
    ],
    "catastropha": [
        "catastropher"
    ],
    "catastrophait": [
        "catastropher"
    ],
    "catastrophas": [
        "catastropher"
    ],
    "catastrophe": [
        "catastropher",
        "catastrophe"
    ],
    "catastropher": [
        "catastropher"
    ],
    "catastrophes": [
        "catastrophe"
    ],
    "catastrophique": [
        "catastrophique"
    ],
    "catastrophiquement": [
        "catastrophiquement"
    ],
    "catastrophiques": [
        "catastrophique"
    ],
    "catastrophisme": [
        "catastrophisme"
    ],
    "catastrophiste": [
        "catastrophiste"
    ],
    "catastrophee": [
        "catastropher"
    ],
    "catatonie": [
        "catatonie"
    ],
    "catatonique": [
        "catatonique"
    ],
    "catatoniques": [
        "catatonique"
    ],
    "catch": [
        "catch"
    ],
    "catcher": [
        "catcher"
    ],
    "catcheur": [
        "catcheur"
    ],
    "catcheurs": [
        "catcheur"
    ],
    "catcheuse": [
        "catcheur"
    ],
    "catcheuses": [
        "catcheur"
    ],
    "catche": [
        "catcher"
    ],
    "caterpillar": [
        "caterpillar"
    ],
    "catgut": [
        "catgut"
    ],
    "catguts": [
        "catgut"
    ],
    "cathare": [
        "cathare"
    ],
    "cathares": [
        "cathare"
    ],
    "catharsis": [
        "catharsis"
    ],
    "cathartique": [
        "cathartique"
    ],
    "catherinette": [
        "catherinette"
    ],
    "cathexis": [
        "cathexis"
    ],
    "catho": [
        "catho"
    ],
    "cathode": [
        "cathode"
    ],
    "cathodique": [
        "cathodique"
    ],
    "cathodiques": [
        "cathodique"
    ],
    "catholicisme": [
        "catholicisme"
    ],
    "catholicite": [
        "catholicite"
    ],
    "catholique": [
        "catholique"
    ],
    "catholiquement": [
        "catholiquement"
    ],
    "catholiques": [
        "catholique"
    ],
    "cathos": [
        "catho"
    ],
    "cathedre": [
        "cathedre"
    ],
    "cathedres": [
        "cathedre"
    ],
    "cathedral": [
        "cathedral"
    ],
    "cathedrale": [
        "cathedrale"
    ],
    "cathedrales": [
        "cathedrale"
    ],
    "catheter": [
        "catheter"
    ],
    "catheterisme": [
        "catheterisme"
    ],
    "cati": [
        "cati"
    ],
    "catiche": [
        "catiche"
    ],
    "catin": [
        "catin"
    ],
    "catins": [
        "catin"
    ],
    "cation": [
        "cation"
    ],
    "cato": [
        "cato"
    ],
    "catoblepas": [
        "catoblepas"
    ],
    "catogan": [
        "catogan"
    ],
    "catogans": [
        "catogan"
    ],
    "cattleyas": [
        "cattleya"
    ],
    "cate": [
        "cate"
    ],
    "catechisme": [
        "catechisme"
    ],
    "catechismes": [
        "catechisme"
    ],
    "catechiste": [
        "catechiste"
    ],
    "catechisee": [
        "catechiser"
    ],
    "catecholamine": [
        "catecholamine"
    ],
    "catechumene": [
        "catechumene"
    ],
    "catechumenes": [
        "catechumene"
    ],
    "catechese": [
        "catechese"
    ],
    "categorie": [
        "categorie"
    ],
    "categories": [
        "category",
        "categorie"
    ],
    "categorique": [
        "categorique"
    ],
    "categoriquement": [
        "categoriquement"
    ],
    "categoriques": [
        "categorique"
    ],
    "categorisation": [
        "categorisation"
    ],
    "categorise": [
        "categoriser"
    ],
    "categoriser": [
        "categoriser"
    ],
    "catenaire": [
        "catenaire"
    ],
    "catenaires": [
        "catenaire"
    ],
    "caucasien": [
        "caucasien"
    ],
    "caucasienne": [
        "caucasien"
    ],
    "caucasiens": [
        "caucasien"
    ],
    "caucasique": [
        "caucasique"
    ],
    "cauchemar": [
        "cauchemar"
    ],
    "cauchemardais": [
        "cauchemarder"
    ],
    "cauchemarde": [
        "cauchemarder"
    ],
    "cauchemarder": [
        "cauchemarder"
    ],
    "cauchemardes": [
        "cauchemarder"
    ],
    "cauchemardesque": [
        "cauchemardesque"
    ],
    "cauchemardesques": [
        "cauchemardesque"
    ],
    "cauchemardeuse": [
        "cauchemardeux"
    ],
    "cauchemardeuses": [
        "cauchemardeux"
    ],
    "cauchemardeux": [
        "cauchemardeux"
    ],
    "cauchemars": [
        "cauchemar"
    ],
    "cauchois": [
        "cauchois"
    ],
    "cauchoise": [
        "cauchois"
    ],
    "cauchoises": [
        "cauchois"
    ],
    "caudal": [
        "caudal"
    ],
    "caudale": [
        "caudal"
    ],
    "caudales": [
        "caudal"
    ],
    "caudebec": [
        "caudebec"
    ],
    "caudillo": [
        "caudillo"
    ],
    "caudines": [
        "caudines"
    ],
    "cauri": [
        "cauri"
    ],
    "cauris": [
        "cauri"
    ],
    "causa": [
        "causa",
        "causer"
    ],
    "causai": [
        "causer"
    ],
    "causaient": [
        "causer"
    ],
    "causais": [
        "causer"
    ],
    "causait": [
        "causer"
    ],
    "causal": [
        "causal"
    ],
    "causaliste": [
        "causaliste"
    ],
    "causalite": [
        "causalite"
    ],
    "causalites": [
        "causalite"
    ],
    "causant": [
        "causer",
        "causant"
    ],
    "causante": [
        "causant"
    ],
    "causantes": [
        "causant"
    ],
    "causants": [
        "causant"
    ],
    "cause": [
        "cause",
        "causer"
    ],
    "causent": [
        "causer"
    ],
    "causer": [
        "causer"
    ],
    "causera": [
        "causer"
    ],
    "causerai": [
        "causer"
    ],
    "causeraient": [
        "causer"
    ],
    "causerais": [
        "causer"
    ],
    "causerait": [
        "causer"
    ],
    "causeras": [
        "causer"
    ],
    "causerez": [
        "causer"
    ],
    "causerie": [
        "causerie"
    ],
    "causeries": [
        "causerie"
    ],
    "causerions": [
        "causer"
    ],
    "causerons": [
        "causer"
    ],
    "causeront": [
        "causer"
    ],
    "causes": [
        "cause",
        "causer"
    ],
    "causette": [
        "causette"
    ],
    "causettes": [
        "causette"
    ],
    "causeur": [
        "causeur"
    ],
    "causeurs": [
        "causeur"
    ],
    "causeuse": [
        "causeur"
    ],
    "causeuses": [
        "causeur"
    ],
    "causez": [
        "causer"
    ],
    "causiez": [
        "causer"
    ],
    "causions": [
        "causer"
    ],
    "causons": [
        "causer"
    ],
    "causse": [
        "causse"
    ],
    "caussenard": [
        "caussenard"
    ],
    "causses": [
        "causse"
    ],
    "causticite": [
        "causticite"
    ],
    "caustique": [
        "caustique"
    ],
    "caustiques": [
        "caustique"
    ],
    "causames": [
        "causer"
    ],
    "causerent": [
        "causer"
    ],
    "causee": [
        "causer"
    ],
    "causees": [
        "causer"
    ],
    "cauteleuse": [
        "cauteleux"
    ],
    "cauteleusement": [
        "cauteleusement"
    ],
    "cauteleuses": [
        "cauteleux"
    ],
    "cauteleux": [
        "cauteleux"
    ],
    "caution": [
        "caution"
    ],
    "cautionnaire": [
        "cautionnaire"
    ],
    "cautionnait": [
        "cautionner"
    ],
    "cautionne": [
        "cautionner"
    ],
    "cautionnement": [
        "cautionnement"
    ],
    "cautionnent": [
        "cautionner"
    ],
    "cautionner": [
        "cautionner"
    ],
    "cautionnerait": [
        "cautionner"
    ],
    "cautionnes": [
        "cautionner"
    ],
    "cautionnez": [
        "cautionner"
    ],
    "cautionnee": [
        "cautionner"
    ],
    "cautions": [
        "caution"
    ],
    "cautele": [
        "cautele"
    ],
    "cauteles": [
        "cautele"
    ],
    "cautere": [
        "cautere"
    ],
    "cauteres": [
        "cautere"
    ],
    "cauterisant": [
        "cauteriser"
    ],
    "cauterisation": [
        "cauterisation"
    ],
    "cauterise": [
        "cauteriser"
    ],
    "cauteriser": [
        "cauteriser"
    ],
    "cauterisee": [
        "cauteriser"
    ],
    "cauterisees": [
        "cauteriser"
    ],
    "cava": [
        "caver"
    ],
    "cavaillon": [
        "cavaillon"
    ],
    "cavalaient": [
        "cavaler"
    ],
    "cavalais": [
        "cavaler"
    ],
    "cavalait": [
        "cavaler"
    ],
    "cavalant": [
        "cavaler"
    ],
    "cavalcadaient": [
        "cavalcader"
    ],
    "cavalcadait": [
        "cavalcader"
    ],
    "cavalcadant": [
        "cavalcader"
    ],
    "cavalcade": [
        "cavalcade"
    ],
    "cavalcadent": [
        "cavalcader"
    ],
    "cavalcader": [
        "cavalcader"
    ],
    "cavalcades": [
        "cavalcade"
    ],
    "cavale": [
        "cavale",
        "cavaler"
    ],
    "cavalent": [
        "cavaler"
    ],
    "cavaler": [
        "cavaler"
    ],
    "cavalerais": [
        "cavaler"
    ],
    "cavaleras": [
        "cavaler"
    ],
    "cavalerie": [
        "cavalerie"
    ],
    "cavaleries": [
        "cavalerie"
    ],
    "cavaleront": [
        "cavaler"
    ],
    "cavales": [
        "cavale",
        "cavaler"
    ],
    "cavaleur": [
        "cavaleur"
    ],
    "cavaleurs": [
        "cavaleur"
    ],
    "cavaleuse": [
        "cavaleur"
    ],
    "cavalez": [
        "cavaler"
    ],
    "cavalier": [
        "cavalier"
    ],
    "cavaliers": [
        "cavalier"
    ],
    "cavaliere": [
        "cavalier"
    ],
    "cavalierement": [
        "cavalierement"
    ],
    "cavalieres": [
        "cavalier"
    ],
    "cave": [
        "caver",
        "cave"
    ],
    "caveau": [
        "caveau"
    ],
    "caveaux": [
        "caveau"
    ],
    "caveces": [
        "cavece"
    ],
    "caver": [
        "caver"
    ],
    "caverne": [
        "caverne"
    ],
    "cavernes": [
        "caverne"
    ],
    "caverneuse": [
        "caverneux"
    ],
    "caverneuses": [
        "caverneux"
    ],
    "caverneux": [
        "caverneux"
    ],
    "cavernicoles": [
        "cavernicole"
    ],
    "caves": [
        "cave"
    ],
    "cavette": [
        "cavette"
    ],
    "cavettes": [
        "cavette"
    ],
    "caviar": [
        "caviar"
    ],
    "caviarde": [
        "caviarder"
    ],
    "cavillon": [
        "cavillon"
    ],
    "cavillonne": [
        "cavillon"
    ],
    "cavillons": [
        "cavillon"
    ],
    "caviste": [
        "caviste"
    ],
    "cavitation": [
        "cavitation"
    ],
    "cavite": [
        "cavite"
    ],
    "cavites": [
        "cavite"
    ],
    "cavum": [
        "cavum"
    ],
    "cavee": [
        "cavee"
    ],
    "cavees": [
        "cavee"
    ],
    "cayenne": [
        "cayenne"
    ],
    "caid": [
        "caid"
    ],
    "caids": [
        "caid"
    ],
    "caiman": [
        "caiman"
    ],
    "caimans": [
        "caiman"
    ],
    "caique": [
        "caique"
    ],
    "caiques": [
        "caique"
    ],
    "ce": [
        "ce"
    ],
    "ceci": [
        "ceci"
    ],
    "ceignait": [
        "ceindre"
    ],
    "ceignant": [
        "ceindre"
    ],
    "ceignent": [
        "ceindre"
    ],
    "ceignit": [
        "ceindre"
    ],
    "ceindra": [
        "ceindre"
    ],
    "ceindrait": [
        "ceindre"
    ],
    "ceindre": [
        "ceindre"
    ],
    "ceins": [
        "ceindre"
    ],
    "ceint": [
        "ceindre",
        "ceint"
    ],
    "ceinte": [
        "ceindre"
    ],
    "ceintes": [
        "ceindre"
    ],
    "ceints": [
        "ceindre"
    ],
    "ceintura": [
        "ceinturer"
    ],
    "ceinturaient": [
        "ceinturer"
    ],
    "ceinturait": [
        "ceinturer"
    ],
    "ceinturant": [
        "ceinturer"
    ],
    "ceinture": [
        "ceinturer",
        "ceinture"
    ],
    "ceinturent": [
        "ceinturer"
    ],
    "ceinturer": [
        "ceinturer"
    ],
    "ceintures": [
        "ceinturer",
        "ceinture"
    ],
    "ceinturez": [
        "ceinturer"
    ],
    "ceinturon": [
        "ceinturon"
    ],
    "ceinturons": [
        "ceinturon"
    ],
    "ceinturat": [
        "ceinturer"
    ],
    "ceinturerent": [
        "ceinturer"
    ],
    "ceinturee": [
        "ceinturer"
    ],
    "ceinturees": [
        "ceinturer"
    ],
    "cela": [
        "cela",
        "ceci"
    ],
    "celait": [
        "celer"
    ],
    "celer": [
        "celer"
    ],
    "cella": [
        "cella"
    ],
    "celle": [
        "celle"
    ],
    "celles": [
        "celles"
    ],
    "cellier": [
        "cellier"
    ],
    "celliers": [
        "cellier"
    ],
    "cellophane": [
        "cellophane"
    ],
    "cellulaire": [
        "cellulaire"
    ],
    "cellulairement": [
        "cellulairement"
    ],
    "cellulaires": [
        "cellulaire"
    ],
    "cellular": [
        "cellular"
    ],
    "cellule": [
        "cellule"
    ],
    "cellules": [
        "cellules",
        "cellule"
    ],
    "cellulite": [
        "cellulite"
    ],
    "cellulites": [
        "cellulite"
    ],
    "celluliteux": [
        "celluliteux"
    ],
    "cellulose": [
        "cellulose"
    ],
    "celluloid": [
        "celluloid"
    ],
    "cellerier": [
        "cellerier"
    ],
    "celte": [
        "celte"
    ],
    "celtes": [
        "celte"
    ],
    "celtique": [
        "celtique"
    ],
    "celtiques": [
        "celtique"
    ],
    "celtisants": [
        "celtisant"
    ],
    "celtisme": [
        "celtisme"
    ],
    "celui": [
        "celui"
    ],
    "celee": [
        "celer"
    ],
    "cendraient": [
        "cendrer"
    ],
    "cendrait": [
        "cendrer"
    ],
    "cendre": [
        "cendre",
        "cendrer"
    ],
    "cendres": [
        "cendre",
        "cendrer"
    ],
    "cendreuse": [
        "cendreux"
    ],
    "cendreuses": [
        "cendreux"
    ],
    "cendreux": [
        "cendreux"
    ],
    "cendrier": [
        "cendrier"
    ],
    "cendriers": [
        "cendrier"
    ],
    "cendrillon": [
        "cendrillon"
    ],
    "cendrillons": [
        "cendrillon"
    ],
    "cendree": [
        "cendre",
        "cendree"
    ],
    "cendrees": [
        "cendrer",
        "cendree",
        "cendre"
    ],
    "cens": [
        "cens"
    ],
    "censeur": [
        "censeur"
    ],
    "censeurs": [
        "censeur"
    ],
    "censier": [
        "censier"
    ],
    "censitaire": [
        "censitaire"
    ],
    "censuraient": [
        "censurer"
    ],
    "censurait": [
        "censurer"
    ],
    "censurant": [
        "censurer"
    ],
    "censure": [
        "censure",
        "censurer"
    ],
    "censurer": [
        "censurer"
    ],
    "censures": [
        "censure",
        "censurer"
    ],
    "censurez": [
        "censurer"
    ],
    "censuriez": [
        "censurer"
    ],
    "censuree": [
        "censurer"
    ],
    "censurees": [
        "censurer"
    ],
    "cense": [
        "cense"
    ],
    "censee": [
        "cense"
    ],
    "censees": [
        "cense"
    ],
    "censement": [
        "censement"
    ],
    "censes": [
        "cense"
    ],
    "cent": [
        "cent"
    ],
    "centaine": [
        "centaine"
    ],
    "centaines": [
        "centaine",
        "centaines"
    ],
    "centaure": [
        "centaure"
    ],
    "centaures": [
        "centaure"
    ],
    "centauree": [
        "centauree"
    ],
    "centavo": [
        "centavo"
    ],
    "centavos": [
        "centavo"
    ],
    "centenaire": [
        "centenaire"
    ],
    "centenaires": [
        "centenaire",
        "centenaires"
    ],
    "centigrade": [
        "centigrade"
    ],
    "centigrades": [
        "centigrade"
    ],
    "centigrammes": [
        "centigramme"
    ],
    "centile": [
        "centile"
    ],
    "centilitres": [
        "centilitre"
    ],
    "centime": [
        "centime"
    ],
    "centimes": [
        "centime"
    ],
    "centimetre": [
        "centimetre"
    ],
    "centimetres": [
        "centimetre"
    ],
    "centieme": [
        "centieme"
    ],
    "centiemes": [
        "centieme"
    ],
    "centon": [
        "centon"
    ],
    "centrafricain": [
        "centrafricain"
    ],
    "centrafricaine": [
        "centrafricain"
    ],
    "centrage": [
        "centrage"
    ],
    "centrait": [
        "centrer"
    ],
    "central": [
        "central"
    ],
    "centrale": [
        "centrale",
        "central"
    ],
    "centrales": [
        "centrale",
        "centrales",
        "central"
    ],
    "centralisait": [
        "centraliser"
    ],
    "centralisation": [
        "centralisation"
    ],
    "centralisatrice": [
        "centralisateur"
    ],
    "centralise": [
        "centraliser"
    ],
    "centraliser": [
        "centraliser"
    ],
    "centralisiez": [
        "centraliser"
    ],
    "centralisme": [
        "centralisme"
    ],
    "centralisons": [
        "centraliser"
    ],
    "centralisee": [
        "centraliser"
    ],
    "centralises": [
        "centralise",
        "centraliser"
    ],
    "centrant": [
        "centrer"
    ],
    "centraux": [
        "central"
    ],
    "centre": [
        "centre",
        "centrer"
    ],
    "centrer": [
        "centrer"
    ],
    "centres": [
        "centre",
        "centrer"
    ],
    "centrifugation": [
        "centrifugation"
    ],
    "centrifuge": [
        "centrifuge"
    ],
    "centrifuges": [
        "centrifuge"
    ],
    "centrifugeur": [
        "centrifugeur"
    ],
    "centrifugeuse": [
        "centrifugeur"
    ],
    "centrifugeuses": [
        "centrifugeur"
    ],
    "centriole": [
        "centriole"
    ],
    "centripete": [
        "centripete"
    ],
    "centripetes": [
        "centripete"
    ],
    "centriste": [
        "centriste"
    ],
    "centrouse": [
        "centrouse"
    ],
    "centrum": [
        "centrum"
    ],
    "centree": [
        "centre",
        "centrer"
    ],
    "centrees": [
        "centrer"
    ],
    "cents": [
        "cents",
        "cent"
    ],
    "centuple": [
        "centupler",
        "centuple"
    ],
    "centuplee": [
        "centupler"
    ],
    "centurie": [
        "centurie"
    ],
    "centuries": [
        "century",
        "centurie"
    ],
    "centurion": [
        "centurion"
    ],
    "centurions": [
        "centurion"
    ],
    "cep": [
        "cep"
    ],
    "cependant": [
        "cependant"
    ],
    "ceps": [
        "cep"
    ],
    "cerbere": [
        "cerbere"
    ],
    "cerberes": [
        "cerbere"
    ],
    "cerceau": [
        "cerceau"
    ],
    "cerceaux": [
        "cerceau"
    ],
    "cerclage": [
        "cerclage"
    ],
    "cerclait": [
        "cercler"
    ],
    "cerclant": [
        "cercler"
    ],
    "cercle": [
        "cercle",
        "cercler"
    ],
    "cercler": [
        "cercler"
    ],
    "cercles": [
        "cercle",
        "cercler"
    ],
    "cercleux": [
        "cercleux"
    ],
    "cerclee": [
        "cercler"
    ],
    "cerclees": [
        "cercler"
    ],
    "cercueil": [
        "cercueil"
    ],
    "cercueils": [
        "cercueil"
    ],
    "cerf": [
        "cerf"
    ],
    "cerfeuil": [
        "cerfeuil"
    ],
    "cerfs": [
        "cerf"
    ],
    "cerisaie": [
        "cerisaie"
    ],
    "cerise": [
        "cerise"
    ],
    "cerises": [
        "cerise"
    ],
    "cerisier": [
        "cerisier"
    ],
    "cerisiers": [
        "cerisier"
    ],
    "cerna": [
        "cerner"
    ],
    "cernable": [
        "cernable"
    ],
    "cernaient": [
        "cerner"
    ],
    "cernais": [
        "cerner"
    ],
    "cernait": [
        "cerner"
    ],
    "cernant": [
        "cerner"
    ],
    "cerne": [
        "cerne",
        "cerner"
    ],
    "cerneau": [
        "cerneau"
    ],
    "cerneaux": [
        "cerneau"
    ],
    "cernent": [
        "cerner"
    ],
    "cerner": [
        "cerner"
    ],
    "cernes": [
        "cerne",
        "cerner"
    ],
    "cernez": [
        "cerner"
    ],
    "cerniez": [
        "cerner"
    ],
    "cernons": [
        "cerner"
    ],
    "cernee": [
        "cerne",
        "cerner"
    ],
    "cernees": [
        "cerne",
        "cerner"
    ],
    "cerque": [
        "cerque"
    ],
    "certain": [
        "certain"
    ],
    "certaine": [
        "certaine",
        "certain"
    ],
    "certainement": [
        "certainement"
    ],
    "certaines": [
        "certaines",
        "certain"
    ],
    "certains": [
        "certains",
        "certain"
    ],
    "certes": [
        "certes"
    ],
    "certif": [
        "certif"
    ],
    "certifia": [
        "certifier"
    ],
    "certifiaient": [
        "certifier"
    ],
    "certifiait": [
        "certifier"
    ],
    "certifiant": [
        "certifier"
    ],
    "certificat": [
        "certificat"
    ],
    "certification": [
        "certification"
    ],
    "certificats": [
        "certificat"
    ],
    "certifie": [
        "certifie",
        "certifier"
    ],
    "certifier": [
        "certifier"
    ],
    "certifierait": [
        "certifier"
    ],
    "certifieront": [
        "certifier"
    ],
    "certifiez": [
        "certifier"
    ],
    "certifions": [
        "certifier"
    ],
    "certifiee": [
        "certifie",
        "certifier"
    ],
    "certifiees": [
        "certifie",
        "certifier"
    ],
    "certifies": [
        "certifie",
        "certify",
        "certifier"
    ],
    "certifs": [
        "certif"
    ],
    "certitude": [
        "certitude"
    ],
    "certitudes": [
        "certitude"
    ],
    "cerveau": [
        "cerveau"
    ],
    "cerveaux": [
        "cerveau"
    ],
    "cervelas": [
        "cervelas"
    ],
    "cervelet": [
        "cervelet"
    ],
    "cervelets": [
        "cervelet"
    ],
    "cervelle": [
        "cervelle"
    ],
    "cervelles": [
        "cervelle"
    ],
    "cervical": [
        "cervical"
    ],
    "cervicale": [
        "cervical"
    ],
    "cervicales": [
        "cervical"
    ],
    "cervicaux": [
        "cervical"
    ],
    "cervides": [
        "cervide"
    ],
    "cervoise": [
        "cervoise"
    ],
    "ces": [
        "ce",
        "ces"
    ],
    "cessa": [
        "cesser"
    ],
    "cessai": [
        "cesser"
    ],
    "cessaient": [
        "cesser"
    ],
    "cessais": [
        "cesser"
    ],
    "cessait": [
        "cesser"
    ],
    "cessant": [
        "cesser",
        "cessant"
    ],
    "cessante": [
        "cessant"
    ],
    "cessantes": [
        "cessant"
    ],
    "cessasse": [
        "cesser"
    ],
    "cessation": [
        "cessation"
    ],
    "cesse": [
        "cesser",
        "cesse"
    ],
    "cessent": [
        "cesser"
    ],
    "cesser": [
        "cesser"
    ],
    "cessera": [
        "cesser"
    ],
    "cesserai": [
        "cesser"
    ],
    "cesseraient": [
        "cesser"
    ],
    "cesserais": [
        "cesser"
    ],
    "cesserait": [
        "cesser"
    ],
    "cesseras": [
        "cesser"
    ],
    "cesserez": [
        "cesser"
    ],
    "cesseriez": [
        "cesser"
    ],
    "cesserons": [
        "cesser"
    ],
    "cesseront": [
        "cesser"
    ],
    "cesses": [
        "cesser",
        "cesse"
    ],
    "cessez": [
        "cesser"
    ],
    "cessiez": [
        "cesser"
    ],
    "cession": [
        "cession"
    ],
    "cessionnaire": [
        "cessionnaire"
    ],
    "cessions": [
        "cesser",
        "cession"
    ],
    "cessons": [
        "cesser"
    ],
    "cessames": [
        "cesser"
    ],
    "cessat": [
        "cesser"
    ],
    "cesserent": [
        "cesser"
    ],
    "cessee": [
        "cesser"
    ],
    "ceste": [
        "ceste"
    ],
    "cet": [
        "cet",
        "ce"
    ],
    "cette": [
        "cette",
        "ce"
    ],
    "ceux": [
        "ceux"
    ],
    "ch'timi": [
        "ch'timi"
    ],
    "ch'timis": [
        "ch'timi"
    ],
    "chabanais": [
        "chabanais"
    ],
    "chabichou": [
        "chabichou"
    ],
    "chabler": [
        "chabler"
    ],
    "chablis": [
        "chablis"
    ],
    "chaboisseaux": [
        "chaboisseau"
    ],
    "chabot": [
        "chabot"
    ],
    "chabots": [
        "chabot"
    ],
    "chabraque": [
        "chabraque"
    ],
    "chabrot": [
        "chabrot"
    ],
    "chacal": [
        "chacal"
    ],
    "chacals": [
        "chacal"
    ],
    "chachlik": [
        "chachlik"
    ],
    "chaconne": [
        "chaconne"
    ],
    "chacun": [
        "chacun"
    ],
    "chacune": [
        "chacune"
    ],
    "chafaud": [
        "chafaud"
    ],
    "chafauds": [
        "chafaud"
    ],
    "chafouin": [
        "chafouin"
    ],
    "chafouine": [
        "chafouin"
    ],
    "chafouins": [
        "chafouin"
    ],
    "chagatte": [
        "chagatte"
    ],
    "chagattes": [
        "chagatte"
    ],
    "chagrin": [
        "chagrin"
    ],
    "chagrina": [
        "chagriner"
    ],
    "chagrinaient": [
        "chagriner"
    ],
    "chagrinait": [
        "chagriner"
    ],
    "chagrine": [
        "chagrin",
        "chagrine",
        "chagriner"
    ],
    "chagrinent": [
        "chagriner"
    ],
    "chagriner": [
        "chagriner"
    ],
    "chagrinerait": [
        "chagriner"
    ],
    "chagrines": [
        "chagrin",
        "chagrine",
        "chagriner"
    ],
    "chagrins": [
        "chagrin"
    ],
    "chagrinee": [
        "chagrine",
        "chagriner"
    ],
    "chah": [
        "chah"
    ],
    "chahut": [
        "chahut"
    ],
    "chahutaient": [
        "chahuter"
    ],
    "chahutais": [
        "chahuter"
    ],
    "chahutait": [
        "chahuter"
    ],
    "chahutant": [
        "chahuter"
    ],
    "chahute": [
        "chahuter"
    ],
    "chahutent": [
        "chahuter"
    ],
    "chahuter": [
        "chahuter"
    ],
    "chahuteraient": [
        "chahuter"
    ],
    "chahuteur": [
        "chahuteur"
    ],
    "chahuteurs": [
        "chahuteur"
    ],
    "chahuteuse": [
        "chahuteur"
    ],
    "chahutez": [
        "chahuter"
    ],
    "chahuts": [
        "chahut"
    ],
    "chahuterent": [
        "chahuter"
    ],
    "chahutee": [
        "chahuter"
    ],
    "chahutees": [
        "chahuter"
    ],
    "chahutes": [
        "chahuter"
    ],
    "chai": [
        "chai"
    ],
    "chair": [
        "chair"
    ],
    "chaire": [
        "chaire"
    ],
    "chaires": [
        "chaire"
    ],
    "chairman": [
        "chairman"
    ],
    "chairs": [
        "chair"
    ],
    "chais": [
        "chai"
    ],
    "chaise": [
        "chaise"
    ],
    "chaises": [
        "chaise"
    ],
    "chaisiere": [
        "chaisier"
    ],
    "chaisieres": [
        "chaisier"
    ],
    "chaix": [
        "chaix"
    ],
    "chaland": [
        "chaland"
    ],
    "chalands": [
        "chaland"
    ],
    "chalazions": [
        "chalazion"
    ],
    "chaldaiques": [
        "chaldaique"
    ],
    "chaldeen": [
        "chaldeen"
    ],
    "chaldeens": [
        "chaldeen"
    ],
    "chalet": [
        "chalet"
    ],
    "chalets": [
        "chalet"
    ],
    "chaleur": [
        "chaleur"
    ],
    "chaleureuse": [
        "chaleureux"
    ],
    "chaleureusement": [
        "chaleureusement"
    ],
    "chaleureuses": [
        "chaleureux"
    ],
    "chaleureux": [
        "chaleureux"
    ],
    "chaleurs": [
        "chaleur"
    ],
    "challenge": [
        "challenge"
    ],
    "challenger": [
        "challenger"
    ],
    "challengers": [
        "challenger"
    ],
    "challenges": [
        "challenge"
    ],
    "challengeur": [
        "challengeur"
    ],
    "chalon": [
        "chalon"
    ],
    "chalonnaises": [
        "chalonnais"
    ],
    "chalons": [
        "chalon"
    ],
    "chaloupait": [
        "chalouper"
    ],
    "chaloupant": [
        "chalouper"
    ],
    "chaloupe": [
        "chaloupe",
        "chalouper"
    ],
    "chalouper": [
        "chalouper"
    ],
    "chaloupes": [
        "chaloupe",
        "chalouper"
    ],
    "chaloupee": [
        "chaloupe",
        "chalouper"
    ],
    "chaloupees": [
        "chalouper"
    ],
    "chalumeau": [
        "chalumeau"
    ],
    "chalumeaux": [
        "chalumeau"
    ],
    "chalut": [
        "chalut"
    ],
    "chalutier": [
        "chalutier"
    ],
    "chalutiers": [
        "chalutier"
    ],
    "chaluts": [
        "chalut"
    ],
    "chamade": [
        "chamade"
    ],
    "chamaillaient": [
        "chamailler"
    ],
    "chamaillait": [
        "chamailler"
    ],
    "chamaillant": [
        "chamailler"
    ],
    "chamaille": [
        "chamaille",
        "chamailler"
    ],
    "chamaillent": [
        "chamailler"
    ],
    "chamailler": [
        "chamailler"
    ],
    "chamaillerie": [
        "chamaillerie"
    ],
    "chamailleries": [
        "chamaillerie"
    ],
    "chamailleur": [
        "chamailleur"
    ],
    "chamailleurs": [
        "chamailleur"
    ],
    "chamailleuse": [
        "chamailleur"
    ],
    "chamaillez": [
        "chamailler"
    ],
    "chamaillions": [
        "chamailler"
    ],
    "chamaillis": [
        "chamaillis"
    ],
    "chamaillons": [
        "chamailler"
    ],
    "chamaillerent": [
        "chamailler"
    ],
    "chamailles": [
        "chamailler"
    ],
    "chaman": [
        "chaman"
    ],
    "chamane": [
        "chamane"
    ],
    "chamanes": [
        "chamane"
    ],
    "chamanisme": [
        "chamanisme"
    ],
    "chamans": [
        "chaman"
    ],
    "chamarrures": [
        "chamarrure"
    ],
    "chamarre": [
        "chamarrer",
        "chamarre"
    ],
    "chamarree": [
        "chamarrer",
        "chamarre"
    ],
    "chamarrees": [
        "chamarrer",
        "chamarre"
    ],
    "chamarres": [
        "chamarrer",
        "chamarre"
    ],
    "chambard": [
        "chambard"
    ],
    "chambarda": [
        "chambarder"
    ],
    "chambardait": [
        "chambarder"
    ],
    "chambardement": [
        "chambardement"
    ],
    "chambardements": [
        "chambardement"
    ],
    "chambarder": [
        "chambarder"
    ],
    "chambarde": [
        "chambarder"
    ],
    "chambardee": [
        "chambarder"
    ],
    "chambellan": [
        "chambellan"
    ],
    "chambellans": [
        "chambellan"
    ],
    "chambertin": [
        "chambertin"
    ],
    "chambertins": [
        "chambertin"
    ],
    "chamboulaient": [
        "chambouler"
    ],
    "chamboulait": [
        "chambouler"
    ],
    "chamboulant": [
        "chambouler"
    ],
    "chamboule": [
        "chambouler"
    ],
    "chamboulement": [
        "chamboulement"
    ],
    "chamboulements": [
        "chamboulement"
    ],
    "chamboulent": [
        "chambouler"
    ],
    "chambouler": [
        "chambouler"
    ],
    "chambouleras": [
        "chambouler"
    ],
    "chamboulez": [
        "chambouler"
    ],
    "chamboulat": [
        "chambouler"
    ],
    "chamboulee": [
        "chambouler"
    ],
    "chamboulees": [
        "chambouler"
    ],
    "chamboules": [
        "chambouler"
    ],
    "chambra": [
        "chambrer"
    ],
    "chambrais": [
        "chambrer"
    ],
    "chambrait": [
        "chambrer"
    ],
    "chambranle": [
        "chambranle"
    ],
    "chambranles": [
        "chambranle"
    ],
    "chambrant": [
        "chambrer"
    ],
    "chambre": [
        "chambre",
        "chambrer"
    ],
    "chambrent": [
        "chambrer"
    ],
    "chambrer": [
        "chambrer"
    ],
    "chambres": [
        "chambre",
        "chambrer"
    ],
    "chambrette": [
        "chambrette"
    ],
    "chambrez": [
        "chambrer"
    ],
    "chambriere": [
        "chambriere"
    ],
    "chambrieres": [
        "chambriere"
    ],
    "chambree": [
        "chambree",
        "chambrer"
    ],
    "chambrees": [
        "chambree"
    ],
    "chameau": [
        "chameau"
    ],
    "chameaux": [
        "chameau"
    ],
    "chamelier": [
        "chamelier"
    ],
    "chameliers": [
        "chamelier"
    ],
    "chamelle": [
        "chameau"
    ],
    "chamelles": [
        "chameau"
    ],
    "chamois": [
        "chamois"
    ],
    "chamoisine": [
        "chamoisine"
    ],
    "champ": [
        "champ"
    ],
    "champ'": [
        "champ"
    ],
    "champagne": [
        "champagne"
    ],
    "champagnes": [
        "champagne"
    ],
    "champagnises": [
        "champagniser"
    ],
    "champenois": [
        "champenois"
    ],
    "champenoise": [
        "champenois"
    ],
    "champenoises": [
        "champenois"
    ],
    "champi": [
        "champi"
    ],
    "champignon": [
        "champignon"
    ],
    "champignonnaient": [
        "champignonner"
    ],
    "champignonnait": [
        "champignonner"
    ],
    "champignonne": [
        "champignonner"
    ],
    "champignonnent": [
        "champignonner"
    ],
    "champignonniere": [
        "champignonniere"
    ],
    "champignonnieres": [
        "champignonniere"
    ],
    "champignons": [
        "champignon"
    ],
    "champion": [
        "champion"
    ],
    "championnat": [
        "championnat"
    ],
    "championnats": [
        "championnat"
    ],
    "championne": [
        "champion"
    ],
    "championnes": [
        "champion"
    ],
    "champions": [
        "champion"
    ],
    "champis": [
        "champi"
    ],
    "champs": [
        "champ"
    ],
    "champetre": [
        "champetre"
    ],
    "champetres": [
        "champetre"
    ],
    "chance": [
        "chance"
    ],
    "chancel": [
        "chancel"
    ],
    "chancela": [
        "chanceler"
    ],
    "chancelai": [
        "chanceler"
    ],
    "chancelaient": [
        "chanceler"
    ],
    "chancelais": [
        "chanceler"
    ],
    "chancelait": [
        "chanceler"
    ],
    "chancelant": [
        "chanceler",
        "chancelant"
    ],
    "chancelante": [
        "chancelant"
    ],
    "chancelantes": [
        "chancelant"
    ],
    "chancelants": [
        "chancelant"
    ],
    "chanceler": [
        "chanceler"
    ],
    "chancelier": [
        "chancelier"
    ],
    "chanceliers": [
        "chancelier"
    ],
    "chancelions": [
        "chanceler"
    ],
    "chanceliere": [
        "chanceliere"
    ],
    "chancelieres": [
        "chancelier"
    ],
    "chancelle": [
        "chanceler"
    ],
    "chancellent": [
        "chanceler"
    ],
    "chancellerie": [
        "chancellerie"
    ],
    "chancelleries": [
        "chancellerie"
    ],
    "chancelerent": [
        "chanceler"
    ],
    "chancele": [
        "chanceler"
    ],
    "chances": [
        "chance"
    ],
    "chanceuse": [
        "chanceux"
    ],
    "chanceuses": [
        "chanceux"
    ],
    "chanceux": [
        "chanceux"
    ],
    "chanci": [
        "chanci",
        "chancir"
    ],
    "chancre": [
        "chancre"
    ],
    "chancres": [
        "chancre"
    ],
    "chand": [
        "chand"
    ],
    "chandail": [
        "chandail"
    ],
    "chandails": [
        "chandail"
    ],
    "chandeleur": [
        "chandeleur"
    ],
    "chandelier": [
        "chandelier"
    ],
    "chandeliers": [
        "chandelier"
    ],
    "chandelle": [
        "chandelle"
    ],
    "chandelles": [
        "chandelle"
    ],
    "chanfrein": [
        "chanfrein"
    ],
    "chanfreinee": [
        "chanfreiner"
    ],
    "change": [
        "changer",
        "change"
    ],
    "changea": [
        "changer"
    ],
    "changeai": [
        "changer"
    ],
    "changeaient": [
        "changer"
    ],
    "changeais": [
        "changer"
    ],
    "changeait": [
        "changer"
    ],
    "changeant": [
        "changeant",
        "changer"
    ],
    "changeante": [
        "changeant"
    ],
    "changeantes": [
        "changeant"
    ],
    "changeants": [
        "changeant"
    ],
    "changeas": [
        "changer"
    ],
    "changement": [
        "changement"
    ],
    "changements": [
        "changement"
    ],
    "changent": [
        "changer"
    ],
    "changeons": [
        "changer"
    ],
    "changer": [
        "changer"
    ],
    "changera": [
        "changer"
    ],
    "changerai": [
        "changer"
    ],
    "changeraient": [
        "changer"
    ],
    "changerais": [
        "changer"
    ],
    "changerait": [
        "changer"
    ],
    "changeras": [
        "changer"
    ],
    "changerez": [
        "changer"
    ],
    "changeriez": [
        "changer"
    ],
    "changerons": [
        "changer"
    ],
    "changeront": [
        "changer"
    ],
    "changes": [
        "changer",
        "change"
    ],
    "changeur": [
        "changeur"
    ],
    "changeurs": [
        "changeur"
    ],
    "changeuse": [
        "changeur"
    ],
    "changez": [
        "changer"
    ],
    "changeames": [
        "changer"
    ],
    "changeat": [
        "changer"
    ],
    "changiez": [
        "changer"
    ],
    "changions": [
        "changer"
    ],
    "changerent": [
        "changer"
    ],
    "changee": [
        "changer",
        "change"
    ],
    "changees": [
        "changer",
        "change"
    ],
    "chanoine": [
        "chanoine"
    ],
    "chanoines": [
        "chanoine"
    ],
    "chanoinesse": [
        "chanoinesse"
    ],
    "chanoinesses": [
        "chanoinesse"
    ],
    "chanson": [
        "chanson"
    ],
    "chansonner": [
        "chansonner"
    ],
    "chansonnette": [
        "chansonnette"
    ],
    "chansonnettes": [
        "chansonnette"
    ],
    "chansonnier": [
        "chansonnier"
    ],
    "chansonniers": [
        "chansonnier"
    ],
    "chansons": [
        "chanson"
    ],
    "chanstiquait": [
        "chanstiquer"
    ],
    "chanstique": [
        "chanstiquer"
    ],
    "chanstiquent": [
        "chanstiquer"
    ],
    "chanstiquer": [
        "chanstiquer"
    ],
    "chanstiquerent": [
        "chanstiquer"
    ],
    "chanstiquee": [
        "chanstiquer"
    ],
    "chant": [
        "chant"
    ],
    "chanta": [
        "chanter"
    ],
    "chantage": [
        "chantage"
    ],
    "chantages": [
        "chantage"
    ],
    "chantai": [
        "chanter"
    ],
    "chantaient": [
        "chanter"
    ],
    "chantais": [
        "chanter"
    ],
    "chantait": [
        "chanter"
    ],
    "chantant": [
        "chanter",
        "chantant"
    ],
    "chantante": [
        "chantant"
    ],
    "chantantes": [
        "chantant"
    ],
    "chantants": [
        "chantant"
    ],
    "chante": [
        "chanter"
    ],
    "chanteau": [
        "chanteau"
    ],
    "chantent": [
        "chanter"
    ],
    "chanter": [
        "chanter"
    ],
    "chantera": [
        "chanter"
    ],
    "chanterai": [
        "chanter"
    ],
    "chanteraient": [
        "chanter"
    ],
    "chanterais": [
        "chanter"
    ],
    "chanterait": [
        "chanter"
    ],
    "chanteras": [
        "chanter"
    ],
    "chanterelle": [
        "chanterelle"
    ],
    "chanterelles": [
        "chanterelle"
    ],
    "chanterez": [
        "chanter"
    ],
    "chanteriez": [
        "chanter"
    ],
    "chanterons": [
        "chanter"
    ],
    "chanteront": [
        "chanter"
    ],
    "chantes": [
        "chanter"
    ],
    "chanteur": [
        "chanteur"
    ],
    "chanteurs": [
        "chanteur"
    ],
    "chanteuse": [
        "chanteur"
    ],
    "chanteuses": [
        "chanteur"
    ],
    "chantez": [
        "chanter"
    ],
    "chantier": [
        "chantier"
    ],
    "chantiers": [
        "chantier"
    ],
    "chantiez": [
        "chanter"
    ],
    "chantilly": [
        "chantilly"
    ],
    "chantions": [
        "chanter"
    ],
    "chantonna": [
        "chantonner"
    ],
    "chantonnai": [
        "chantonner"
    ],
    "chantonnaient": [
        "chantonner"
    ],
    "chantonnais": [
        "chantonner"
    ],
    "chantonnait": [
        "chantonner"
    ],
    "chantonnant": [
        "chantonnant",
        "chantonner"
    ],
    "chantonnante": [
        "chantonnant"
    ],
    "chantonne": [
        "chantonner"
    ],
    "chantonnement": [
        "chantonnement"
    ],
    "chantonnent": [
        "chantonner"
    ],
    "chantonner": [
        "chantonner"
    ],
    "chantonnerent": [
        "chantonner"
    ],
    "chantonnee": [
        "chantonner"
    ],
    "chantonnes": [
        "chantonner"
    ],
    "chantons": [
        "chanter"
    ],
    "chantoung": [
        "chantoung"
    ],
    "chantourner": [
        "chantourner"
    ],
    "chantourne": [
        "chantourner"
    ],
    "chantournees": [
        "chantourner"
    ],
    "chantournes": [
        "chantourner"
    ],
    "chantre": [
        "chantre"
    ],
    "chantrerie": [
        "chantrerie"
    ],
    "chantres": [
        "chantre"
    ],
    "chants": [
        "chant"
    ],
    "chantames": [
        "chanter"
    ],
    "chantat": [
        "chanter"
    ],
    "chanterent": [
        "chanter"
    ],
    "chantee": [
        "chanter"
    ],
    "chantees": [
        "chanter"
    ],
    "chanvre": [
        "chanvre"
    ],
    "chanvres": [
        "chanvre"
    ],
    "chancard": [
        "chancard"
    ],
    "chancarde": [
        "chancard"
    ],
    "chao": [
        "chao"
    ],
    "chaos": [
        "chaos"
    ],
    "chaotique": [
        "chaotique"
    ],
    "chaotiquement": [
        "chaotiquement"
    ],
    "chaotiques": [
        "chaotique"
    ],
    "chaouch": [
        "chaouch"
    ],
    "chaouchs": [
        "chaouch"
    ],
    "chaparda": [
        "chaparder"
    ],
    "chapardage": [
        "chapardage"
    ],
    "chapardages": [
        "chapardage"
    ],
    "chapardait": [
        "chaparder"
    ],
    "chapardant": [
        "chaparder"
    ],
    "chapardent": [
        "chaparder"
    ],
    "chaparder": [
        "chaparder"
    ],
    "chapardeur": [
        "chapardeur"
    ],
    "chapardeurs": [
        "chapardeur"
    ],
    "chapardeuse": [
        "chapardeur"
    ],
    "chaparde": [
        "chaparder"
    ],
    "chapardee": [
        "chaparder"
    ],
    "chapardees": [
        "chaparder"
    ],
    "chaparral": [
        "chaparral"
    ],
    "chaparrals": [
        "chaparral"
    ],
    "chape": [
        "chape"
    ],
    "chapeau": [
        "chapeau"
    ],
    "chapeautait": [
        "chapeauter"
    ],
    "chapeaute": [
        "chapeauter",
        "chapeaute"
    ],
    "chapeauter": [
        "chapeauter"
    ],
    "chapeautee": [
        "chapeauter",
        "chapeaute"
    ],
    "chapeautees": [
        "chapeauter",
        "chapeaute"
    ],
    "chapeautes": [
        "chapeauter",
        "chapeaute"
    ],
    "chapeaux": [
        "chapeau"
    ],
    "chapelain": [
        "chapelain"
    ],
    "chapelains": [
        "chapelain"
    ],
    "chapelet": [
        "chapelet"
    ],
    "chapelets": [
        "chapelet"
    ],
    "chapelier": [
        "chapelier"
    ],
    "chapeliers": [
        "chapelier"
    ],
    "chapelle": [
        "chapelle"
    ],
    "chapellerie": [
        "chapellerie"
    ],
    "chapelles": [
        "chapelle"
    ],
    "chapelure": [
        "chapelure"
    ],
    "chapelures": [
        "chapelure"
    ],
    "chaperon": [
        "chaperon"
    ],
    "chaperonnais": [
        "chaperonner"
    ],
    "chaperonnait": [
        "chaperonner"
    ],
    "chaperonner": [
        "chaperonner"
    ],
    "chaperonne": [
        "chaperonner"
    ],
    "chaperonnee": [
        "chaperonner"
    ],
    "chaperonnes": [
        "chaperonner"
    ],
    "chaperons": [
        "chaperon"
    ],
    "chapes": [
        "chape"
    ],
    "chapiteau": [
        "chapiteau"
    ],
    "chapiteaux": [
        "chapiteau"
    ],
    "chapitre": [
        "chapitre",
        "chapitrer"
    ],
    "chapitrer": [
        "chapitrer"
    ],
    "chapitres": [
        "chapitre",
        "chapitrer"
    ],
    "chapitree": [
        "chapitrer"
    ],
    "chapitrees": [
        "chapitrer"
    ],
    "chapka": [
        "chapka"
    ],
    "chaplinesque": [
        "chaplinesque"
    ],
    "chapon": [
        "chapon"
    ],
    "chapons": [
        "chapon"
    ],
    "chappe": [
        "chappe"
    ],
    "chapska": [
        "chapska"
    ],
    "chapskas": [
        "chapska"
    ],
    "chaque": [
        "chaque"
    ],
    "char": [
        "char"
    ],
    "charabia": [
        "charabia"
    ],
    "charabias": [
        "charabia"
    ],
    "charade": [
        "charade"
    ],
    "charades": [
        "charade"
    ],
    "charale": [
        "charale"
    ],
    "charancon": [
        "charancon"
    ],
    "charanconne": [
        "charanconne"
    ],
    "charanconnee": [
        "charanconne"
    ],
    "charanconnes": [
        "charanconne"
    ],
    "charancons": [
        "charancon"
    ],
    "charbon": [
        "charbon"
    ],
    "charbonnages": [
        "charbonnage"
    ],
    "charbonnaient": [
        "charbonner"
    ],
    "charbonnait": [
        "charbonner"
    ],
    "charbonne": [
        "charbonner"
    ],
    "charbonnent": [
        "charbonner"
    ],
    "charbonner": [
        "charbonner"
    ],
    "charbonnette": [
        "charbonnette"
    ],
    "charbonneuse": [
        "charbonneux"
    ],
    "charbonneuses": [
        "charbonneux"
    ],
    "charbonneux": [
        "charbonneux"
    ],
    "charbonnier": [
        "charbonnier"
    ],
    "charbonniers": [
        "charbonnier"
    ],
    "charbonniere": [
        "charbonniere",
        "charbonnier"
    ],
    "charbonnieres": [
        "charbonnier"
    ],
    "charbonnees": [
        "charbonner"
    ],
    "charbonnes": [
        "charbonner"
    ],
    "charbons": [
        "charbon"
    ],
    "charca": [
        "charca"
    ],
    "charcutage": [
        "charcutage"
    ],
    "charcutaient": [
        "charcuter"
    ],
    "charcutaille": [
        "charcutaille"
    ],
    "charcutait": [
        "charcuter"
    ],
    "charcute": [
        "charcuter"
    ],
    "charcuter": [
        "charcuter"
    ],
    "charcuterie": [
        "charcuterie"
    ],
    "charcuteries": [
        "charcuterie"
    ],
    "charcutez": [
        "charcuter"
    ],
    "charcutier": [
        "charcutier"
    ],
    "charcutiers": [
        "charcutier"
    ],
    "charcutiere": [
        "charcutier"
    ],
    "charcutieres": [
        "charcutier"
    ],
    "charcutee": [
        "charcuter"
    ],
    "charcutees": [
        "charcuter"
    ],
    "charcutes": [
        "charcuter"
    ],
    "chardon": [
        "chardon"
    ],
    "chardonay": [
        "chardonay"
    ],
    "chardonnay": [
        "chardonnay"
    ],
    "chardonneret": [
        "chardonneret"
    ],
    "chardonnerets": [
        "chardonneret"
    ],
    "chardons": [
        "chardon"
    ],
    "charentaise": [
        "charentais"
    ],
    "charentaises": [
        "charentais"
    ],
    "charge": [
        "charger",
        "charge"
    ],
    "chargea": [
        "charger"
    ],
    "chargeai": [
        "charger"
    ],
    "chargeaient": [
        "charger"
    ],
    "chargeais": [
        "charger"
    ],
    "chargeait": [
        "charger"
    ],
    "chargeant": [
        "charger"
    ],
    "chargement": [
        "chargement"
    ],
    "chargements": [
        "chargement"
    ],
    "chargent": [
        "charger"
    ],
    "chargeons": [
        "charger"
    ],
    "charger": [
        "charger"
    ],
    "chargera": [
        "charger"
    ],
    "chargerai": [
        "charger"
    ],
    "chargeraient": [
        "charger"
    ],
    "chargerais": [
        "charger"
    ],
    "chargerait": [
        "charger"
    ],
    "chargeras": [
        "charger"
    ],
    "chargerez": [
        "charger"
    ],
    "chargerons": [
        "charger"
    ],
    "chargeront": [
        "charger"
    ],
    "charges": [
        "charger",
        "charge"
    ],
    "chargeur": [
        "chargeur"
    ],
    "chargeurs": [
        "chargeur"
    ],
    "chargez": [
        "charger"
    ],
    "chargeat": [
        "charger"
    ],
    "chargiez": [
        "charger"
    ],
    "chargions": [
        "charger"
    ],
    "chargerent": [
        "charger"
    ],
    "chargee": [
        "charger",
        "charge"
    ],
    "chargees": [
        "charger",
        "charge"
    ],
    "charia": [
        "charia"
    ],
    "chariot": [
        "chariot"
    ],
    "chariots": [
        "chariot"
    ],
    "charismatique": [
        "charismatique"
    ],
    "charisme": [
        "charisme"
    ],
    "charitable": [
        "charitable"
    ],
    "charitablement": [
        "charitablement"
    ],
    "charitables": [
        "charitable"
    ],
    "charite": [
        "charite"
    ],
    "charites": [
        "charite"
    ],
    "charivari": [
        "charivari"
    ],
    "charivaris": [
        "charivari"
    ],
    "charlatan": [
        "charlatan"
    ],
    "charlataner": [
        "charlataner"
    ],
    "charlatanerie": [
        "charlatanerie"
    ],
    "charlatanisme": [
        "charlatanisme"
    ],
    "charlatanismes": [
        "charlatanisme"
    ],
    "charlatans": [
        "charlatan"
    ],
    "charleston": [
        "charleston"
    ],
    "charlot": [
        "charlot"
    ],
    "charlots": [
        "charlot"
    ],
    "charlotte": [
        "charlotte"
    ],
    "charlottes": [
        "charlotte"
    ],
    "charma": [
        "charmer"
    ],
    "charmaient": [
        "charmer"
    ],
    "charmait": [
        "charmer"
    ],
    "charmant": [
        "charmant",
        "charmer"
    ],
    "charmante": [
        "charmant"
    ],
    "charmantes": [
        "charmant"
    ],
    "charmants": [
        "charmant"
    ],
    "charme": [
        "charme",
        "charmer"
    ],
    "charment": [
        "charmer"
    ],
    "charmer": [
        "charmer"
    ],
    "charmera": [
        "charmer"
    ],
    "charmes": [
        "charme",
        "charmer"
    ],
    "charmeur": [
        "charmeur"
    ],
    "charmeurs": [
        "charmeur"
    ],
    "charmeuse": [
        "charmeur"
    ],
    "charmeuses": [
        "charmeur"
    ],
    "charmille": [
        "charmille"
    ],
    "charmilles": [
        "charmille"
    ],
    "charmee": [
        "charme",
        "charmer"
    ],
    "charnel": [
        "charnel"
    ],
    "charnelle": [
        "charnel"
    ],
    "charnellement": [
        "charnellement"
    ],
    "charnelles": [
        "charnel"
    ],
    "charnels": [
        "charnel"
    ],
    "charnier": [
        "charnier"
    ],
    "charniers": [
        "charnier"
    ],
    "charniere": [
        "charniere"
    ],
    "charnieres": [
        "charniere"
    ],
    "charnu": [
        "charnu"
    ],
    "charnue": [
        "charnu"
    ],
    "charnues": [
        "charnu"
    ],
    "charnus": [
        "charnu"
    ],
    "charognard": [
        "charognard"
    ],
    "charognards": [
        "charognard"
    ],
    "charogne": [
        "charogne"
    ],
    "charognerie": [
        "charognerie"
    ],
    "charognes": [
        "charogne"
    ],
    "charolaise": [
        "charolais"
    ],
    "charolaises": [
        "charolais"
    ],
    "charpente": [
        "charpente",
        "charpenter"
    ],
    "charpenter": [
        "charpenter"
    ],
    "charpenterie": [
        "charpenterie"
    ],
    "charpentes": [
        "charpente"
    ],
    "charpentier": [
        "charpentier"
    ],
    "charpentiers": [
        "charpentier"
    ],
    "charpentiere": [
        "charpentier"
    ],
    "charpentee": [
        "charpente",
        "charpenter"
    ],
    "charpie": [
        "charpie"
    ],
    "charpies": [
        "charpie"
    ],
    "charre": [
        "charre"
    ],
    "charres": [
        "charre"
    ],
    "charretier": [
        "charretier"
    ],
    "charretiers": [
        "charretier"
    ],
    "charretiere": [
        "charretier"
    ],
    "charreton": [
        "charreton"
    ],
    "charretons": [
        "charreton"
    ],
    "charrette": [
        "charrette"
    ],
    "charrettes": [
        "charrette"
    ],
    "charretee": [
        "charretee"
    ],
    "charretees": [
        "charretee"
    ],
    "charria": [
        "charrier"
    ],
    "charriage": [
        "charriage"
    ],
    "charriaient": [
        "charrier"
    ],
    "charriais": [
        "charrier"
    ],
    "charriait": [
        "charrier"
    ],
    "charriant": [
        "charrier",
        "charriant"
    ],
    "charrie": [
        "charrier",
        "charrie"
    ],
    "charrient": [
        "charrier"
    ],
    "charrier": [
        "charrier"
    ],
    "charrieras": [
        "charrier"
    ],
    "charrierons": [
        "charrier"
    ],
    "charrieront": [
        "charrier"
    ],
    "charries": [
        "charrier"
    ],
    "charrieurs": [
        "charrieur"
    ],
    "charriez": [
        "charrier"
    ],
    "charrions": [
        "charrier"
    ],
    "charriere": [
        "charrier"
    ],
    "charrierent": [
        "charrier"
    ],
    "charrieres": [
        "charrier"
    ],
    "charriee": [
        "charrier"
    ],
    "charriees": [
        "charrier"
    ],
    "charroi": [
        "charroi"
    ],
    "charrois": [
        "charroi"
    ],
    "charron": [
        "charron"
    ],
    "charronnees": [
        "charronner"
    ],
    "charrons": [
        "charron"
    ],
    "charrue": [
        "charrue"
    ],
    "charrues": [
        "charrue"
    ],
    "charruee": [
        "charruer"
    ],
    "chars": [
        "char"
    ],
    "charte": [
        "charte"
    ],
    "charter": [
        "charter"
    ],
    "charters": [
        "charter"
    ],
    "chartes": [
        "charte"
    ],
    "chartiste": [
        "chartiste"
    ],
    "chartistes": [
        "chartiste"
    ],
    "chartre": [
        "chartre"
    ],
    "chartreuse": [
        "chartreux"
    ],
    "chartreuses": [
        "chartreux"
    ],
    "chartreux": [
        "chartreux"
    ],
    "charybde": [
        "charybde"
    ],
    "chas": [
        "chas"
    ],
    "chassa": [
        "chasser"
    ],
    "chassai": [
        "chasser"
    ],
    "chassaient": [
        "chasser"
    ],
    "chassais": [
        "chasser"
    ],
    "chassait": [
        "chasser"
    ],
    "chassant": [
        "chassant",
        "chasser"
    ],
    "chasse": [
        "chasser",
        "chasse"
    ],
    "chasselas": [
        "chasselas"
    ],
    "chassent": [
        "chasser"
    ],
    "chasser": [
        "chasser"
    ],
    "chassera": [
        "chasser"
    ],
    "chasserai": [
        "chasser"
    ],
    "chasseraient": [
        "chasser"
    ],
    "chasserais": [
        "chasser"
    ],
    "chasserait": [
        "chasser"
    ],
    "chasseras": [
        "chasser"
    ],
    "chasseresse": [
        "chasseur"
    ],
    "chasseresses": [
        "chasseur"
    ],
    "chasserez": [
        "chasser"
    ],
    "chasserions": [
        "chasser"
    ],
    "chasserons": [
        "chasser"
    ],
    "chasseront": [
        "chasser"
    ],
    "chasses": [
        "chasser",
        "chasse"
    ],
    "chasseur": [
        "chasseur"
    ],
    "chasseurs": [
        "chasseur"
    ],
    "chasseuse": [
        "chasseur"
    ],
    "chassez": [
        "chasser"
    ],
    "chassie": [
        "chassie"
    ],
    "chassieuse": [
        "chassieux"
    ],
    "chassieux": [
        "chassieux"
    ],
    "chassiez": [
        "chasser"
    ],
    "chassions": [
        "chasser"
    ],
    "chassons": [
        "chasser"
    ],
    "chassat": [
        "chasser"
    ],
    "chasserent": [
        "chasser"
    ],
    "chassee": [
        "chasser",
        "chasse"
    ],
    "chassees": [
        "chasser",
        "chasse"
    ],
    "chaste": [
        "chaste"
    ],
    "chastement": [
        "chastement"
    ],
    "chastes": [
        "chaste"
    ],
    "chastete": [
        "chastete"
    ],
    "chasuble": [
        "chasuble"
    ],
    "chasubles": [
        "chasuble"
    ],
    "chat": [
        "chat"
    ],
    "chateaubriand": [
        "chateaubriand"
    ],
    "chateaubriands": [
        "chateaubriand"
    ],
    "chatiere": [
        "chatiere"
    ],
    "chatoiement": [
        "chatoiement"
    ],
    "chatoiements": [
        "chatoiement"
    ],
    "chatoient": [
        "chatoyer"
    ],
    "chaton": [
        "chaton"
    ],
    "chatonne": [
        "chatonner"
    ],
    "chatons": [
        "chaton"
    ],
    "chatouilla": [
        "chatouiller"
    ],
    "chatouillaient": [
        "chatouiller"
    ],
    "chatouillait": [
        "chatouiller"
    ],
    "chatouillant": [
        "chatouiller"
    ],
    "chatouille": [
        "chatouiller",
        "chatouille"
    ],
    "chatouillement": [
        "chatouillement"
    ],
    "chatouillements": [
        "chatouillement"
    ],
    "chatouillent": [
        "chatouiller"
    ],
    "chatouiller": [
        "chatouiller"
    ],
    "chatouillera": [
        "chatouiller"
    ],
    "chatouilles": [
        "chatouiller",
        "chatouille"
    ],
    "chatouilleuse": [
        "chatouilleux"
    ],
    "chatouilleuses": [
        "chatouilleux"
    ],
    "chatouilleux": [
        "chatouilleux"
    ],
    "chatouillez": [
        "chatouiller"
    ],
    "chatouillis": [
        "chatouillis"
    ],
    "chatouillons": [
        "chatouiller"
    ],
    "chatouillat": [
        "chatouiller"
    ],
    "chatouillerent": [
        "chatouiller"
    ],
    "chatouillee": [
        "chatouiller"
    ],
    "chatouillees": [
        "chatouiller"
    ],
    "chatoyaient": [
        "chatoyer"
    ],
    "chatoyait": [
        "chatoyer"
    ],
    "chatoyant": [
        "chatoyant",
        "chatoyer"
    ],
    "chatoyante": [
        "chatoyant"
    ],
    "chatoyantes": [
        "chatoyant"
    ],
    "chatoyants": [
        "chatoyant"
    ],
    "chatoyer": [
        "chatoyer"
    ],
    "chats": [
        "chat"
    ],
    "chattant": [
        "chatter"
    ],
    "chatte": [
        "chat"
    ],
    "chattemite": [
        "chattemite"
    ],
    "chatter": [
        "chatter"
    ],
    "chatterie": [
        "chatterie"
    ],
    "chatteries": [
        "chatterie"
    ],
    "chatterton": [
        "chatterton"
    ],
    "chattes": [
        "chat"
    ],
    "chattons": [
        "chatter"
    ],
    "chaud": [
        "chaud"
    ],
    "chaude": [
        "chaud"
    ],
    "chaudement": [
        "chaudement"
    ],
    "chaudes": [
        "chaud"
    ],
    "chaudiere": [
        "chaudiere"
    ],
    "chaudieres": [
        "chaudiere"
    ],
    "chaudron": [
        "chaudron"
    ],
    "chaudronnerie": [
        "chaudronnerie"
    ],
    "chaudronneries": [
        "chaudronnerie"
    ],
    "chaudronnier": [
        "chaudronnier"
    ],
    "chaudronniers": [
        "chaudronnier"
    ],
    "chaudronne": [
        "chaudronner"
    ],
    "chaudronnee": [
        "chaudronnee"
    ],
    "chaudrons": [
        "chaudron"
    ],
    "chauds": [
        "chaud"
    ],
    "chauffa": [
        "chauffer"
    ],
    "chauffage": [
        "chauffage"
    ],
    "chauffagiste": [
        "chauffagiste"
    ],
    "chauffaient": [
        "chauffer"
    ],
    "chauffais": [
        "chauffer"
    ],
    "chauffait": [
        "chauffer"
    ],
    "chauffant": [
        "chauffant",
        "chauffer"
    ],
    "chauffante": [
        "chauffant"
    ],
    "chauffantes": [
        "chauffant"
    ],
    "chauffants": [
        "chauffant"
    ],
    "chauffard": [
        "chauffard"
    ],
    "chauffards": [
        "chauffard"
    ],
    "chauffe": [
        "chauffer",
        "chauffe"
    ],
    "chauffent": [
        "chauffer"
    ],
    "chauffer": [
        "chauffer"
    ],
    "chauffera": [
        "chauffer"
    ],
    "chaufferai": [
        "chauffer"
    ],
    "chaufferette": [
        "chaufferette"
    ],
    "chaufferettes": [
        "chaufferette"
    ],
    "chaufferie": [
        "chaufferie"
    ],
    "chaufferies": [
        "chaufferie"
    ],
    "chauffes": [
        "chauffer"
    ],
    "chauffeur": [
        "chauffeur"
    ],
    "chauffeurs": [
        "chauffeur"
    ],
    "chauffeuse": [
        "chauffeur"
    ],
    "chauffez": [
        "chauffer"
    ],
    "chauffiez": [
        "chauffer"
    ],
    "chauffions": [
        "chauffer"
    ],
    "chauffons": [
        "chauffer"
    ],
    "chauffames": [
        "chauffer"
    ],
    "chaufferent": [
        "chauffer"
    ],
    "chauffee": [
        "chauffer"
    ],
    "chauffees": [
        "chauffer"
    ],
    "chaule": [
        "chauler"
    ],
    "chauler": [
        "chauler"
    ],
    "chaulee": [
        "chauler"
    ],
    "chaulees": [
        "chauler"
    ],
    "chaules": [
        "chauler"
    ],
    "chaume": [
        "chaume",
        "chaumer"
    ],
    "chaumes": [
        "chaume"
    ],
    "chaumine": [
        "chaumine"
    ],
    "chaumines": [
        "chaumine"
    ],
    "chaumiere": [
        "chaumiere"
    ],
    "chaumieres": [
        "chaumiere"
    ],
    "chaussa": [
        "chausser"
    ],
    "chaussai": [
        "chausser"
    ],
    "chaussaient": [
        "chausser"
    ],
    "chaussait": [
        "chausser"
    ],
    "chaussant": [
        "chausser",
        "chaussant"
    ],
    "chausse": [
        "chausser",
        "chausse"
    ],
    "chaussent": [
        "chausser"
    ],
    "chausser": [
        "chausser"
    ],
    "chausserai": [
        "chausser"
    ],
    "chausses": [
        "chausser",
        "chausse"
    ],
    "chaussette": [
        "chaussette"
    ],
    "chaussettes": [
        "chaussette"
    ],
    "chausseur": [
        "chausseur"
    ],
    "chausseurs": [
        "chausseur"
    ],
    "chaussez": [
        "chausser"
    ],
    "chausson": [
        "chausson"
    ],
    "chaussons": [
        "chausson"
    ],
    "chaussure": [
        "chaussure"
    ],
    "chaussures": [
        "chaussures",
        "chaussure"
    ],
    "chausserent": [
        "chausser"
    ],
    "chaussee": [
        "chausser",
        "chausse",
        "chaussee"
    ],
    "chaussees": [
        "chausser",
        "chausse",
        "chaussee"
    ],
    "chaut": [
        "chaut"
    ],
    "chauve": [
        "chauve"
    ],
    "chauves": [
        "chauve"
    ],
    "chauvin": [
        "chauvin"
    ],
    "chauvine": [
        "chauvin"
    ],
    "chauvines": [
        "chauvin"
    ],
    "chauvinisme": [
        "chauvinisme"
    ],
    "chauviniste": [
        "chauviniste"
    ],
    "chauvins": [
        "chauvin"
    ],
    "chauvit": [
        "chauvir"
    ],
    "chaux": [
        "chaux"
    ],
    "chavignol": [
        "chavignol"
    ],
    "chavira": [
        "chavirer"
    ],
    "chavirai": [
        "chavirer"
    ],
    "chaviraient": [
        "chavirer"
    ],
    "chavirait": [
        "chavirer"
    ],
    "chavirant": [
        "chavirant",
        "chavirer"
    ],
    "chavirante": [
        "chavirant"
    ],
    "chavire": [
        "chavirer"
    ],
    "chavirement": [
        "chavirement"
    ],
    "chavirements": [
        "chavirement"
    ],
    "chavirent": [
        "chavirer"
    ],
    "chavirer": [
        "chavirer"
    ],
    "chavireraient": [
        "chavirer"
    ],
    "chavirerait": [
        "chavirer"
    ],
    "chavireront": [
        "chavirer"
    ],
    "chavirions": [
        "chavirer"
    ],
    "chavirons": [
        "chavirer"
    ],
    "chavirerent": [
        "chavirer"
    ],
    "chaviree": [
        "chavirer"
    ],
    "chavires": [
        "chavirer"
    ],
    "chaine": [
        "chaine",
        "chainer"
    ],
    "chaines": [
        "chaine"
    ],
    "chainette": [
        "chainette"
    ],
    "chainettes": [
        "chainette"
    ],
    "chainon": [
        "chainon"
    ],
    "chainons": [
        "chainon"
    ],
    "cheap": [
        "cheap"
    ],
    "cheddar": [
        "cheddar"
    ],
    "cheddite": [
        "cheddite"
    ],
    "cheeseburger": [
        "cheeseburger"
    ],
    "cheeseburgers": [
        "cheeseburger"
    ],
    "chef": [
        "chef"
    ],
    "chefs": [
        "chef"
    ],
    "cheftaine": [
        "cheftaine"
    ],
    "cheftaines": [
        "cheftaine"
    ],
    "cheik": [
        "cheik"
    ],
    "cheikh": [
        "cheikh"
    ],
    "cheiks": [
        "cheik"
    ],
    "chelem": [
        "chelem"
    ],
    "chemin": [
        "chemin"
    ],
    "chemina": [
        "cheminer"
    ],
    "cheminaient": [
        "cheminer"
    ],
    "cheminait": [
        "cheminer"
    ],
    "cheminant": [
        "cheminer"
    ],
    "chemine": [
        "cheminer"
    ],
    "chemineau": [
        "chemineau"
    ],
    "chemineaux": [
        "chemineau"
    ],
    "cheminement": [
        "cheminement"
    ],
    "cheminements": [
        "cheminement"
    ],
    "cheminent": [
        "cheminer"
    ],
    "cheminer": [
        "cheminer"
    ],
    "chemineraient": [
        "cheminer"
    ],
    "cheminerait": [
        "cheminer"
    ],
    "cheminerons": [
        "cheminer"
    ],
    "chemineront": [
        "cheminer"
    ],
    "cheminions": [
        "cheminer"
    ],
    "cheminons": [
        "cheminer"
    ],
    "cheminot": [
        "cheminot"
    ],
    "cheminots": [
        "cheminot"
    ],
    "chemins": [
        "chemin"
    ],
    "cheminames": [
        "cheminer"
    ],
    "cheminerent": [
        "cheminer"
    ],
    "cheminee": [
        "cheminer",
        "cheminee"
    ],
    "cheminees": [
        "cheminer",
        "cheminee"
    ],
    "chemise": [
        "chemise"
    ],
    "chemiser": [
        "chemiser"
    ],
    "chemiserie": [
        "chemiserie"
    ],
    "chemises": [
        "chemise"
    ],
    "chemisette": [
        "chemisette"
    ],
    "chemisettes": [
        "chemisette"
    ],
    "chemisier": [
        "chemisier"
    ],
    "chemisiers": [
        "chemisier"
    ],
    "chemisee": [
        "chemiser"
    ],
    "chemisees": [
        "chemiser"
    ],
    "chenal": [
        "chenal"
    ],
    "chenapan": [
        "chenapan"
    ],
    "chenapans": [
        "chenapan"
    ],
    "chenaux": [
        "chenal"
    ],
    "chenet": [
        "chenet"
    ],
    "chenets": [
        "chenet"
    ],
    "chenil": [
        "chenil"
    ],
    "chenille": [
        "chenille"
    ],
    "chenilles": [
        "chenille"
    ],
    "chenillette": [
        "chenillette"
    ],
    "chenillettes": [
        "chenillette"
    ],
    "chenils": [
        "chenil"
    ],
    "chenu": [
        "chenu"
    ],
    "chenue": [
        "chenu"
    ],
    "chenues": [
        "chenu"
    ],
    "chenus": [
        "chenu"
    ],
    "cheptel": [
        "cheptel"
    ],
    "cher": [
        "cher"
    ],
    "chercha": [
        "chercher"
    ],
    "cherchai": [
        "chercher"
    ],
    "cherchaient": [
        "chercher"
    ],
    "cherchais": [
        "chercher"
    ],
    "cherchait": [
        "chercher"
    ],
    "cherchant": [
        "chercher"
    ],
    "cherchas": [
        "chercher"
    ],
    "cherche": [
        "chercher"
    ],
    "cherchent": [
        "chercher"
    ],
    "chercher": [
        "chercher"
    ],
    "cherchera": [
        "chercher"
    ],
    "chercherai": [
        "chercher"
    ],
    "chercheraient": [
        "chercher"
    ],
    "chercherais": [
        "chercher"
    ],
    "chercherait": [
        "chercher"
    ],
    "chercheras": [
        "chercher"
    ],
    "chercherez": [
        "chercher"
    ],
    "chercheriez": [
        "chercher"
    ],
    "chercherions": [
        "chercher"
    ],
    "chercherons": [
        "chercher"
    ],
    "chercheront": [
        "chercher"
    ],
    "cherches": [
        "chercher"
    ],
    "chercheur": [
        "chercheur"
    ],
    "chercheurs": [
        "chercheur"
    ],
    "chercheuse": [
        "chercheur"
    ],
    "chercheuses": [
        "chercheur"
    ],
    "cherchez": [
        "chercher"
    ],
    "cherchiez": [
        "chercher"
    ],
    "cherchions": [
        "chercher"
    ],
    "cherchons": [
        "chercher"
    ],
    "cherchames": [
        "chercher"
    ],
    "cherchat": [
        "chercher"
    ],
    "chercherent": [
        "chercher"
    ],
    "cherchee": [
        "chercher"
    ],
    "cherchees": [
        "chercher"
    ],
    "chergui": [
        "chergui"
    ],
    "cherokee": [
        "cherokee"
    ],
    "cherokees": [
        "cherokee"
    ],
    "cherres": [
        "cherrer"
    ],
    "cherry": [
        "cherry"
    ],
    "chers": [
        "cher"
    ],
    "cherte": [
        "cherte"
    ],
    "chester": [
        "chester"
    ],
    "chevai": [
        "chever"
    ],
    "cheval": [
        "cheval"
    ],
    "chevaler": [
        "chevaler"
    ],
    "chevaleresque": [
        "chevaleresque"
    ],
    "chevaleresquement": [
        "chevaleresquement"
    ],
    "chevaleresques": [
        "chevaleresque"
    ],
    "chevalerie": [
        "chevalerie"
    ],
    "chevaleries": [
        "chevalerie"
    ],
    "chevalet": [
        "chevalet"
    ],
    "chevalets": [
        "chevalet"
    ],
    "chevalier": [
        "chevalier"
    ],
    "chevaliers": [
        "chevalier"
    ],
    "chevalin": [
        "chevalin"
    ],
    "chevaline": [
        "chevalin"
    ],
    "chevalins": [
        "chevalin"
    ],
    "chevaliere": [
        "chevaliere"
    ],
    "chevalieres": [
        "chevaliere"
    ],
    "chevalee": [
        "chevaler"
    ],
    "chevance": [
        "chevance"
    ],
    "chevaucha": [
        "chevaucher"
    ],
    "chevauchaient": [
        "chevaucher"
    ],
    "chevauchais": [
        "chevaucher"
    ],
    "chevauchait": [
        "chevaucher"
    ],
    "chevauchant": [
        "chevauchant",
        "chevaucher"
    ],
    "chevauche": [
        "chevaucher"
    ],
    "chevauchement": [
        "chevauchement"
    ],
    "chevauchent": [
        "chevaucher"
    ],
    "chevaucher": [
        "chevaucher"
    ],
    "chevauchera": [
        "chevaucher"
    ],
    "chevaucherai": [
        "chevaucher"
    ],
    "chevaucheraient": [
        "chevaucher"
    ],
    "chevaucheur": [
        "chevaucheur"
    ],
    "chevauchez": [
        "chevaucher"
    ],
    "chevauchons": [
        "chevaucher"
    ],
    "chevaucherent": [
        "chevaucher"
    ],
    "chevauchee": [
        "chevaucher",
        "chevauchee"
    ],
    "chevauchees": [
        "chevauchee"
    ],
    "chevauches": [
        "chevaucher"
    ],
    "chevaux": [
        "cheval"
    ],
    "chevelu": [
        "chevelu"
    ],
    "chevelue": [
        "chevelu"
    ],
    "chevelues": [
        "chevelu"
    ],
    "chevelure": [
        "chevelure"
    ],
    "chevelures": [
        "chevelure"
    ],
    "chevelus": [
        "chevelu"
    ],
    "chevesne": [
        "chevesne"
    ],
    "chevesnes": [
        "chevesne"
    ],
    "chevet": [
        "chevet"
    ],
    "chevets": [
        "chevet"
    ],
    "cheveu": [
        "cheveu"
    ],
    "cheveux": [
        "cheveu"
    ],
    "chevillage": [
        "chevillage"
    ],
    "chevillard": [
        "chevillard"
    ],
    "chevillards": [
        "chevillard"
    ],
    "cheville": [
        "cheville",
        "cheviller"
    ],
    "chevilles": [
        "cheville"
    ],
    "chevillette": [
        "chevillette"
    ],
    "chevillee": [
        "cheviller"
    ],
    "chevillees": [
        "cheviller"
    ],
    "cheviotte": [
        "cheviotte"
    ],
    "chevir": [
        "chevir"
    ],
    "chevreau": [
        "chevreau"
    ],
    "chevreaux": [
        "chevreau"
    ],
    "chevrette": [
        "chevrette"
    ],
    "chevrettes": [
        "chevrette"
    ],
    "chevreuil": [
        "chevreuil"
    ],
    "chevreuils": [
        "chevreuil"
    ],
    "chevrier": [
        "chevrier"
    ],
    "chevriers": [
        "chevrier"
    ],
    "chevriere": [
        "chevrier"
    ],
    "chevron": [
        "chevron"
    ],
    "chevronne": [
        "chevronner",
        "chevronne"
    ],
    "chevronnee": [
        "chevronner"
    ],
    "chevronnes": [
        "chevronner",
        "chevronne"
    ],
    "chevrons": [
        "chevron"
    ],
    "chevrota": [
        "chevroter"
    ],
    "chevrotais": [
        "chevroter"
    ],
    "chevrotait": [
        "chevroter"
    ],
    "chevrotant": [
        "chevroter"
    ],
    "chevrotante": [
        "chevrotant"
    ],
    "chevrote": [
        "chevroter"
    ],
    "chevrotement": [
        "chevrotement"
    ],
    "chevrotements": [
        "chevrotement"
    ],
    "chevroter": [
        "chevroter"
    ],
    "chevrotine": [
        "chevrotine"
    ],
    "chevrotines": [
        "chevrotine"
    ],
    "chevrotee": [
        "chevroter"
    ],
    "cheveche": [
        "cheveche"
    ],
    "cheveches": [
        "cheveche"
    ],
    "chez": [
        "chez"
    ],
    "chi": [
        "chi"
    ],
    "chia": [
        "chier"
    ],
    "chiader": [
        "chiader"
    ],
    "chiade": [
        "chiader"
    ],
    "chiadee": [
        "chiader"
    ],
    "chiadees": [
        "chiader"
    ],
    "chiaient": [
        "chier"
    ],
    "chiais": [
        "chier"
    ],
    "chiait": [
        "chier"
    ],
    "chiala": [
        "chialer"
    ],
    "chialaient": [
        "chialer"
    ],
    "chialais": [
        "chialer"
    ],
    "chialait": [
        "chialer"
    ],
    "chialant": [
        "chialer"
    ],
    "chiale": [
        "chialer"
    ],
    "chialent": [
        "chialer"
    ],
    "chialer": [
        "chialer"
    ],
    "chialera": [
        "chialer"
    ],
    "chialeraient": [
        "chialer"
    ],
    "chialerais": [
        "chialer"
    ],
    "chialerait": [
        "chialer"
    ],
    "chialeras": [
        "chialer"
    ],
    "chialeries": [
        "chialerie"
    ],
    "chiales": [
        "chialer"
    ],
    "chialeur": [
        "chialeur"
    ],
    "chialeuse": [
        "chialeur"
    ],
    "chialez": [
        "chialer"
    ],
    "chialerent": [
        "chialer"
    ],
    "chiant": [
        "chiant",
        "chier"
    ],
    "chiante": [
        "chiant"
    ],
    "chiantes": [
        "chiant"
    ],
    "chianti": [
        "chianti"
    ],
    "chiants": [
        "chiant"
    ],
    "chiard": [
        "chiard"
    ],
    "chiards": [
        "chiard"
    ],
    "chiasma": [
        "chiasma"
    ],
    "chiasme": [
        "chiasme"
    ],
    "chiasse": [
        "chiasse"
    ],
    "chiasses": [
        "chiasse"
    ],
    "chiasseux": [
        "chiasseux"
    ],
    "chiatique": [
        "chiatique"
    ],
    "chiatiques": [
        "chiatique"
    ],
    "chibouk": [
        "chibouk"
    ],
    "chibre": [
        "chibre"
    ],
    "chic": [
        "chic"
    ],
    "chica": [
        "chica"
    ],
    "chicanait": [
        "chicaner"
    ],
    "chicanant": [
        "chicaner"
    ],
    "chicane": [
        "chicane",
        "chicaner"
    ],
    "chicanent": [
        "chicaner"
    ],
    "chicaner": [
        "chicaner"
    ],
    "chicaneries": [
        "chicanerie"
    ],
    "chicanerons": [
        "chicaner"
    ],
    "chicanes": [
        "chicane",
        "chicaner"
    ],
    "chicaneur": [
        "chicaneur"
    ],
    "chicanez": [
        "chicaner"
    ],
    "chicanier": [
        "chicanier"
    ],
    "chicaniers": [
        "chicanier"
    ],
    "chicaniere": [
        "chicanier"
    ],
    "chicano": [
        "chicano"
    ],
    "chicanons": [
        "chicaner"
    ],
    "chicanos": [
        "chicano"
    ],
    "chicanees": [
        "chicaner"
    ],
    "chicas": [
        "chica"
    ],
    "chiche": [
        "chiche"
    ],
    "chichement": [
        "chichement"
    ],
    "chiches": [
        "chiche"
    ],
    "chichi": [
        "chichi"
    ],
    "chichis": [
        "chichi"
    ],
    "chichiteuse": [
        "chichiteux"
    ],
    "chichiteuses": [
        "chichiteux"
    ],
    "chichiteux": [
        "chichiteux"
    ],
    "chicon": [
        "chicon"
    ],
    "chicore": [
        "chicorer"
    ],
    "chicorent": [
        "chicorer"
    ],
    "chicorer": [
        "chicorer"
    ],
    "chicores": [
        "chicorer"
    ],
    "chicoree": [
        "chicoree"
    ],
    "chicorees": [
        "chicoree"
    ],
    "chicot": [
        "chicot"
    ],
    "chicote": [
        "chicoter",
        "chicot"
    ],
    "chicoter": [
        "chicoter"
    ],
    "chicotin": [
        "chicotin"
    ],
    "chicots": [
        "chicot"
    ],
    "chicotte": [
        "chicotte"
    ],
    "chics": [
        "chic"
    ],
    "chie": [
        "chier"
    ],
    "chien": [
        "chien"
    ],
    "chienchien": [
        "chienchien"
    ],
    "chienchiens": [
        "chienchien"
    ],
    "chiendent": [
        "chiendent"
    ],
    "chienlit": [
        "chienlit"
    ],
    "chiennasse": [
        "chienner"
    ],
    "chienne": [
        "chien"
    ],
    "chiennerie": [
        "chiennerie"
    ],
    "chienneries": [
        "chiennerie"
    ],
    "chiennes": [
        "chien"
    ],
    "chiens": [
        "chien",
        "chiens"
    ],
    "chient": [
        "chier"
    ],
    "chier": [
        "chier"
    ],
    "chiera": [
        "chier"
    ],
    "chierai": [
        "chier"
    ],
    "chierais": [
        "chier"
    ],
    "chieras": [
        "chier"
    ],
    "chierez": [
        "chier"
    ],
    "chierie": [
        "chierie"
    ],
    "chieries": [
        "chierie"
    ],
    "chieront": [
        "chier"
    ],
    "chies": [
        "chier"
    ],
    "chieur": [
        "chieur"
    ],
    "chieurs": [
        "chieur"
    ],
    "chieuse": [
        "chieur"
    ],
    "chieuses": [
        "chieur"
    ],
    "chiez": [
        "chier"
    ],
    "chiffe": [
        "chiffe"
    ],
    "chiffes": [
        "chiffe"
    ],
    "chiffon": [
        "chiffon"
    ],
    "chiffonna": [
        "chiffonner"
    ],
    "chiffonnade": [
        "chiffonnade"
    ],
    "chiffonnades": [
        "chiffonnade"
    ],
    "chiffonnaient": [
        "chiffonner"
    ],
    "chiffonnait": [
        "chiffonner"
    ],
    "chiffonnant": [
        "chiffonner"
    ],
    "chiffonne": [
        "chiffonner",
        "chiffonne"
    ],
    "chiffonner": [
        "chiffonner"
    ],
    "chiffonnier": [
        "chiffonnier"
    ],
    "chiffonniers": [
        "chiffonnier"
    ],
    "chiffonniere": [
        "chiffonnier"
    ],
    "chiffonnieres": [
        "chiffonnier"
    ],
    "chiffonnee": [
        "chiffonner",
        "chiffonne"
    ],
    "chiffonnees": [
        "chiffonner",
        "chiffonne"
    ],
    "chiffonnes": [
        "chiffonner",
        "chiffonne"
    ],
    "chiffons": [
        "chiffon"
    ],
    "chiffrable": [
        "chiffrable"
    ],
    "chiffrage": [
        "chiffrage"
    ],
    "chiffrait": [
        "chiffrer"
    ],
    "chiffrant": [
        "chiffrer"
    ],
    "chiffre": [
        "chiffre",
        "chiffrer"
    ],
    "chiffrement": [
        "chiffrement"
    ],
    "chiffrent": [
        "chiffrer"
    ],
    "chiffrer": [
        "chiffrer"
    ],
    "chiffres": [
        "chiffre",
        "chiffrer"
    ],
    "chiffreur": [
        "chiffreur"
    ],
    "chiffreuse": [
        "chiffreur"
    ],
    "chiffree": [
        "chiffre",
        "chiffrer"
    ],
    "chiffrees": [
        "chiffre",
        "chiffrer"
    ],
    "chignole": [
        "chignole"
    ],
    "chignoles": [
        "chignole"
    ],
    "chignon": [
        "chignon"
    ],
    "chignons": [
        "chignon"
    ],
    "chihuahua": [
        "chihuahua"
    ],
    "chihuahuas": [
        "chihuahua"
    ],
    "chiites": [
        "chiite"
    ],
    "chiles": [
        "chile"
    ],
    "chili": [
        "chili"
    ],
    "chilien": [
        "chilien"
    ],
    "chilienne": [
        "chilien",
        "chilienne"
    ],
    "chiliennes": [
        "chilien",
        "chilienne"
    ],
    "chiliens": [
        "chilien"
    ],
    "chilis": [
        "chili"
    ],
    "chilom": [
        "chilom"
    ],
    "chimie": [
        "chimie"
    ],
    "chimies": [
        "chimie"
    ],
    "chimiotherapie": [
        "chimiotherapie"
    ],
    "chimique": [
        "chimique"
    ],
    "chimiquement": [
        "chimiquement"
    ],
    "chimiques": [
        "chimique"
    ],
    "chimiste": [
        "chimiste"
    ],
    "chimistes": [
        "chimiste"
    ],
    "chimpanze": [
        "chimpanze"
    ],
    "chimpanzes": [
        "chimpanze"
    ],
    "chimere": [
        "chimere"
    ],
    "chimeres": [
        "chimere"
    ],
    "chimerique": [
        "chimerique"
    ],
    "chimeriquement": [
        "chimeriquement"
    ],
    "chimeriques": [
        "chimerique"
    ],
    "china": [
        "chiner"
    ],
    "chinaient": [
        "chiner"
    ],
    "chinait": [
        "chiner"
    ],
    "chinant": [
        "chiner"
    ],
    "chinchard": [
        "chinchard"
    ],
    "chinchilla": [
        "chinchilla"
    ],
    "chinchillas": [
        "chinchilla"
    ],
    "chine": [
        "chiner",
        "chine"
    ],
    "chiner": [
        "chiner"
    ],
    "chinera": [
        "chiner"
    ],
    "chinetoque": [
        "chinetoque"
    ],
    "chinetoques": [
        "chinetoque"
    ],
    "chineur": [
        "chineur"
    ],
    "chineurs": [
        "chineur"
    ],
    "chinois": [
        "chinois"
    ],
    "chinoise": [
        "chinois"
    ],
    "chinoiser": [
        "chinoiser"
    ],
    "chinoiserie": [
        "chinoiserie"
    ],
    "chinoiseries": [
        "chinoiserie"
    ],
    "chinoises": [
        "chinois"
    ],
    "chinook": [
        "chinook"
    ],
    "chintz": [
        "chintz"
    ],
    "chinee": [
        "chiner",
        "chine"
    ],
    "chinees": [
        "chiner"
    ],
    "chines": [
        "chine"
    ],
    "chiot": [
        "chiot"
    ],
    "chiots": [
        "chiot"
    ],
    "chiotte": [
        "chiotte"
    ],
    "chiottes": [
        "chiotte"
    ],
    "chiourme": [
        "chiourme"
    ],
    "chip": [
        "chip"
    ],
    "chipa": [
        "chiper"
    ],
    "chipaient": [
        "chiper"
    ],
    "chipais": [
        "chiper"
    ],
    "chipait": [
        "chiper"
    ],
    "chipant": [
        "chiper"
    ],
    "chipe": [
        "chiper"
    ],
    "chiper": [
        "chiper"
    ],
    "chiperaient": [
        "chiper"
    ],
    "chiperiez": [
        "chiper"
    ],
    "chipeur": [
        "chipeur"
    ],
    "chipez": [
        "chiper"
    ],
    "chipie": [
        "chipie"
    ],
    "chipies": [
        "chipie"
    ],
    "chipolata": [
        "chipolata"
    ],
    "chipolatas": [
        "chipolata"
    ],
    "chipota": [
        "chipoter"
    ],
    "chipotage": [
        "chipotage"
    ],
    "chipotages": [
        "chipotage"
    ],
    "chipotais": [
        "chipoter"
    ],
    "chipotait": [
        "chipoter"
    ],
    "chipotant": [
        "chipoter"
    ],
    "chipote": [
        "chipoter"
    ],
    "chipotent": [
        "chipoter"
    ],
    "chipoter": [
        "chipoter"
    ],
    "chipotes": [
        "chipoter"
    ],
    "chipoteur": [
        "chipoteur"
    ],
    "chipoteuse": [
        "chipoteur"
    ],
    "chipotez": [
        "chipoter"
    ],
    "chipotons": [
        "chipoter"
    ],
    "chippendale": [
        "chippendale"
    ],
    "chippendales": [
        "chippendale"
    ],
    "chips": [
        "chip",
        "chips"
    ],
    "chiperent": [
        "chiper"
    ],
    "chipee": [
        "chiper"
    ],
    "chipees": [
        "chiper"
    ],
    "chipes": [
        "chiper"
    ],
    "chiquaient": [
        "chiquer"
    ],
    "chiquait": [
        "chiquer"
    ],
    "chiquant": [
        "chiquer"
    ],
    "chique": [
        "chiquer",
        "chique"
    ],
    "chiquement": [
        "chiquement"
    ],
    "chiquenaude": [
        "chiquenaude"
    ],
    "chiquenaudes": [
        "chiquenaude"
    ],
    "chiquent": [
        "chiquer"
    ],
    "chiquer": [
        "chiquer"
    ],
    "chiquerai": [
        "chiquer"
    ],
    "chiqueront": [
        "chiquer"
    ],
    "chiques": [
        "chiquer",
        "chique"
    ],
    "chiqueur": [
        "chiqueur"
    ],
    "chiqueurs": [
        "chiqueur"
    ],
    "chiqueuses": [
        "chiqueur"
    ],
    "chiraquien": [
        "chiraquien"
    ],
    "chiricahua": [
        "chiricahua"
    ],
    "chiricahuas": [
        "chiricahua"
    ],
    "chiromancie": [
        "chiromancie"
    ],
    "chiromancien": [
        "chiromancien"
    ],
    "chiromancienne": [
        "chiromancien"
    ],
    "chiromanciens": [
        "chiromancien"
    ],
    "chiropracteur": [
        "chiropracteur"
    ],
    "chiropraticien": [
        "chiropraticien"
    ],
    "chiropraticienne": [
        "chiropraticien"
    ],
    "chiropratique": [
        "chiropratique"
    ],
    "chiropraxie": [
        "chiropraxie"
    ],
    "chiroptere": [
        "chiroptere"
    ],
    "chiroubles": [
        "chiroubles"
    ],
    "chirurgical": [
        "chirurgical"
    ],
    "chirurgicale": [
        "chirurgical"
    ],
    "chirurgicalement": [
        "chirurgicalement"
    ],
    "chirurgicales": [
        "chirurgical"
    ],
    "chirurgicaux": [
        "chirurgical"
    ],
    "chirurgie": [
        "chirurgie"
    ],
    "chirurgien": [
        "chirurgien"
    ],
    "chirurgienne": [
        "chirurgien"
    ],
    "chirurgiens": [
        "chirurgien"
    ],
    "chirurgies": [
        "chirurgie"
    ],
    "chisel": [
        "chisel"
    ],
    "chistera": [
        "chistera"
    ],
    "chitine": [
        "chitine"
    ],
    "chitineux": [
        "chitineux"
    ],
    "chiton": [
        "chiton"
    ],
    "chiure": [
        "chiure"
    ],
    "chiures": [
        "chiure"
    ],
    "chiee": [
        "chiee",
        "chier"
    ],
    "chiees": [
        "chiee",
        "chier"
    ],
    "chlamyde": [
        "chlamyde"
    ],
    "chlamydia": [
        "chlamydia"
    ],
    "chlamydiae": [
        "chlamydia"
    ],
    "chlass": [
        "chlass"
    ],
    "chleuh": [
        "chleuh"
    ],
    "chleuhs": [
        "chleuh"
    ],
    "chlingue": [
        "chlinguer"
    ],
    "chlinguer": [
        "chlinguer"
    ],
    "chlingues": [
        "chlinguer"
    ],
    "chloral": [
        "chloral"
    ],
    "chloramphenicol": [
        "chloramphenicol"
    ],
    "chlorate": [
        "chlorate"
    ],
    "chlore": [
        "chlorer",
        "chlore"
    ],
    "chlorer": [
        "chlorer"
    ],
    "chlorhydrate": [
        "chlorhydrate"
    ],
    "chlorhydrique": [
        "chlorhydrique"
    ],
    "chlorique": [
        "chlorique"
    ],
    "chloroformant": [
        "chloroformer"
    ],
    "chloroforme": [
        "chloroforme",
        "chloroformer"
    ],
    "chloroformer": [
        "chloroformer"
    ],
    "chloroformes": [
        "chloroformer"
    ],
    "chloroformez": [
        "chloroformer"
    ],
    "chloroformisation": [
        "chloroformisation"
    ],
    "chlorophylle": [
        "chlorophylle"
    ],
    "chlorophyllien": [
        "chlorophyllien"
    ],
    "chlorophytums": [
        "chlorophytum"
    ],
    "chloroplaste": [
        "chloroplaste"
    ],
    "chloroquine": [
        "chloroquine"
    ],
    "chlorotique": [
        "chlorotique"
    ],
    "chlorotiques": [
        "chlorotique"
    ],
    "chlorpromazine": [
        "chlorpromazine"
    ],
    "chlorure": [
        "chlorure"
    ],
    "chlorures": [
        "chlorure"
    ],
    "chloree": [
        "chlore"
    ],
    "chnoque": [
        "chnoque"
    ],
    "chnoques": [
        "chnoque"
    ],
    "chnord": [
        "chnord"
    ],
    "chnouf": [
        "chnouf"
    ],
    "choanes": [
        "choane"
    ],
    "choc": [
        "choc"
    ],
    "chocard": [
        "chocard"
    ],
    "chochotte": [
        "chochotte"
    ],
    "chochottes": [
        "chochotte"
    ],
    "chocolat": [
        "chocolat"
    ],
    "chocolaterie": [
        "chocolaterie"
    ],
    "chocolateries": [
        "chocolaterie"
    ],
    "chocolatier": [
        "chocolatier"
    ],
    "chocolatiere": [
        "chocolatier"
    ],
    "chocolats": [
        "chocolat"
    ],
    "chocolate": [
        "chocolate"
    ],
    "chocolatee": [
        "chocolate"
    ],
    "chocolatees": [
        "chocolate"
    ],
    "chocolates": [
        "chocolate"
    ],
    "chocottes": [
        "chocotte"
    ],
    "chocs": [
        "choc"
    ],
    "choeur": [
        "choeur"
    ],
    "choeurs": [
        "choeur"
    ],
    "choie": [
        "choyer"
    ],
    "choient": [
        "choyer"
    ],
    "choieront": [
        "choyer"
    ],
    "choir": [
        "choir"
    ],
    "choiras": [
        "choir"
    ],
    "chois": [
        "choir"
    ],
    "choisi": [
        "choisir",
        "choisi"
    ],
    "choisie": [
        "choisir",
        "choisi"
    ],
    "choisies": [
        "choisir",
        "choisi"
    ],
    "choisir": [
        "choisir"
    ],
    "choisira": [
        "choisir"
    ],
    "choisirai": [
        "choisir"
    ],
    "choisiraient": [
        "choisir"
    ],
    "choisirais": [
        "choisir"
    ],
    "choisirait": [
        "choisir"
    ],
    "choisiras": [
        "choisir"
    ],
    "choisirent": [
        "choisir"
    ],
    "choisirez": [
        "choisir"
    ],
    "choisiriez": [
        "choisir"
    ],
    "choisirions": [
        "choisir"
    ],
    "choisirons": [
        "choisir"
    ],
    "choisiront": [
        "choisir"
    ],
    "choisis": [
        "choisir",
        "choisi"
    ],
    "choisissaient": [
        "choisir"
    ],
    "choisissais": [
        "choisir"
    ],
    "choisissait": [
        "choisir"
    ],
    "choisissant": [
        "choisir"
    ],
    "choisisse": [
        "choisir"
    ],
    "choisissent": [
        "choisir"
    ],
    "choisisses": [
        "choisir"
    ],
    "choisissez": [
        "choisir"
    ],
    "choisissiez": [
        "choisir"
    ],
    "choisissions": [
        "choisir"
    ],
    "choisissons": [
        "choisir"
    ],
    "choisit": [
        "choisir"
    ],
    "choisimes": [
        "choisir"
    ],
    "choit": [
        "choir"
    ],
    "choix": [
        "choix"
    ],
    "choke": [
        "choke"
    ],
    "cholera": [
        "choler",
        "cholera"
    ],
    "cholesterol": [
        "cholesterol"
    ],
    "choline": [
        "choline"
    ],
    "cholines": [
        "choline"
    ],
    "cholinesterase": [
        "cholinesterase"
    ],
    "cholique": [
        "cholique"
    ],
    "cholecystectomie": [
        "cholecystectomie"
    ],
    "cholecystite": [
        "cholecystite"
    ],
    "choledoque": [
        "choledoque"
    ],
    "choleras": [
        "cholera"
    ],
    "choleriques": [
        "cholerique"
    ],
    "chopaient": [
        "choper"
    ],
    "chopais": [
        "choper"
    ],
    "chopait": [
        "choper"
    ],
    "chopant": [
        "choper"
    ],
    "chope": [
        "chope",
        "choper"
    ],
    "chopent": [
        "choper"
    ],
    "choper": [
        "choper"
    ],
    "chopera": [
        "choper"
    ],
    "choperai": [
        "choper"
    ],
    "choperais": [
        "choper"
    ],
    "choperait": [
        "choper"
    ],
    "choperas": [
        "choper"
    ],
    "choperez": [
        "choper"
    ],
    "choperons": [
        "choper"
    ],
    "choperont": [
        "choper"
    ],
    "chopes": [
        "chope",
        "choper"
    ],
    "chopez": [
        "choper"
    ],
    "chopine": [
        "chopine"
    ],
    "chopines": [
        "chopine"
    ],
    "chopons": [
        "choper"
    ],
    "choppe": [
        "chopper"
    ],
    "choppent": [
        "chopper"
    ],
    "chopper": [
        "chopper"
    ],
    "choppers": [
        "chopper"
    ],
    "choppes": [
        "chopper"
    ],
    "choppez": [
        "chopper"
    ],
    "choppons": [
        "chopper"
    ],
    "choppee": [
        "chopper"
    ],
    "chopee": [
        "choper"
    ],
    "chopees": [
        "choper"
    ],
    "choqua": [
        "choquer"
    ],
    "choquaient": [
        "choquer"
    ],
    "choquait": [
        "choquer"
    ],
    "choquant": [
        "choquant",
        "choquer"
    ],
    "choquante": [
        "choquant"
    ],
    "choquantes": [
        "choquant"
    ],
    "choquants": [
        "choquant"
    ],
    "choque": [
        "choque",
        "choquer"
    ],
    "choquent": [
        "choquer"
    ],
    "choquer": [
        "choquer"
    ],
    "choquera": [
        "choquer"
    ],
    "choqueraient": [
        "choquer"
    ],
    "choquerais": [
        "choquer"
    ],
    "choquerait": [
        "choquer"
    ],
    "choqueras": [
        "choquer"
    ],
    "choquez": [
        "choquer"
    ],
    "choquons": [
        "choquer"
    ],
    "choquerent": [
        "choquer"
    ],
    "choquee": [
        "choque",
        "choquer"
    ],
    "choquees": [
        "choque",
        "choquer"
    ],
    "choques": [
        "choque",
        "choquer"
    ],
    "choral": [
        "choral"
    ],
    "chorale": [
        "choral",
        "chorale"
    ],
    "chorales": [
        "choral",
        "chorale"
    ],
    "chorals": [
        "choral"
    ],
    "choraux": [
        "choral"
    ],
    "chorba": [
        "chorba"
    ],
    "choreutes": [
        "choreute"
    ],
    "choriste": [
        "choriste"
    ],
    "choristes": [
        "choriste"
    ],
    "chorizo": [
        "chorizo"
    ],
    "chorizos": [
        "chorizo"
    ],
    "chortens": [
        "chorten"
    ],
    "chorus": [
        "chorus"
    ],
    "choree": [
        "choree"
    ],
    "choregraphe": [
        "choregraphe"
    ],
    "choregraphes": [
        "choregraphe"
    ],
    "choregraphie": [
        "choregraphie"
    ],
    "choregraphier": [
        "choregraphier"
    ],
    "choregraphies": [
        "choregraphie"
    ],
    "choregraphique": [
        "choregraphique"
    ],
    "choregraphiques": [
        "choregraphique"
    ],
    "choregraphiees": [
        "choregraphier"
    ],
    "chose": [
        "chose",
        "choose"
    ],
    "choser": [
        "choser"
    ],
    "choses": [
        "chose",
        "choses"
    ],
    "chosification": [
        "chosification"
    ],
    "chosifient": [
        "chosifier"
    ],
    "chosifier": [
        "chosifier"
    ],
    "chotts": [
        "chott"
    ],
    "chou": [
        "chou"
    ],
    "chouan": [
        "chouan"
    ],
    "chouannerie": [
        "chouannerie"
    ],
    "chouans": [
        "chouan"
    ],
    "choucard": [
        "choucard"
    ],
    "choucarde": [
        "choucard"
    ],
    "choucardes": [
        "choucard"
    ],
    "choucards": [
        "choucard"
    ],
    "choucas": [
        "choucas"
    ],
    "chouchou": [
        "chouchou"
    ],
    "chouchous": [
        "chouchou"
    ],
    "chouchoutage": [
        "chouchoutage"
    ],
    "chouchoutaient": [
        "chouchouter"
    ],
    "chouchoutait": [
        "chouchouter"
    ],
    "chouchoute": [
        "chouchouter",
        "chouchoute"
    ],
    "chouchouter": [
        "chouchouter"
    ],
    "chouchouteras": [
        "chouchouter"
    ],
    "chouchoutes": [
        "chouchoute"
    ],
    "chouchoutez": [
        "chouchouter"
    ],
    "chouchoutee": [
        "chouchouter"
    ],
    "choucroute": [
        "choucroute"
    ],
    "choucroutes": [
        "choucroute"
    ],
    "chouette": [
        "chouette"
    ],
    "chouettement": [
        "chouettement"
    ],
    "chouettes": [
        "chouette"
    ],
    "chougnait": [
        "chougner"
    ],
    "chougne": [
        "chougner"
    ],
    "chouia": [
        "chouia"
    ],
    "chouiner": [
        "chouiner"
    ],
    "choupette": [
        "choupette"
    ],
    "chouquet": [
        "chouquet"
    ],
    "chouquette": [
        "chouquette"
    ],
    "choura": [
        "chourer"
    ],
    "chouravait": [
        "chouraver"
    ],
    "chourave": [
        "chouraver"
    ],
    "chouravent": [
        "chouraver"
    ],
    "chouraver": [
        "chouraver"
    ],
    "chouraveur": [
        "chouraveur"
    ],
    "chouraveurs": [
        "chouraveur"
    ],
    "chouraveuse": [
        "chouraveur"
    ],
    "chouraveuses": [
        "chouraveur"
    ],
    "chouravee": [
        "chouraver"
    ],
    "chouraves": [
        "chouraver"
    ],
    "choure": [
        "chourer"
    ],
    "chourent": [
        "chourer"
    ],
    "chourer": [
        "chourer"
    ],
    "chouriez": [
        "chourer"
    ],
    "chourineurs": [
        "chourineur"
    ],
    "chouree": [
        "chourer"
    ],
    "chourees": [
        "chourer"
    ],
    "choute": [
        "chou"
    ],
    "choutes": [
        "chou"
    ],
    "choux": [
        "chou"
    ],
    "chouya": [
        "chouya"
    ],
    "choya": [
        "choyer"
    ],
    "choyais": [
        "choyer"
    ],
    "choyait": [
        "choyer"
    ],
    "choyant": [
        "choyer"
    ],
    "choyer": [
        "choyer"
    ],
    "choyez": [
        "choyer"
    ],
    "choye": [
        "choye",
        "choyer"
    ],
    "choyee": [
        "choye",
        "choyer"
    ],
    "choyees": [
        "choye",
        "choyer"
    ],
    "choyes": [
        "choye",
        "choyer"
    ],
    "christ": [
        "christ"
    ],
    "christiania": [
        "christiania"
    ],
    "christianisme": [
        "christianisme"
    ],
    "christianises": [
        "christianiser"
    ],
    "christique": [
        "christique"
    ],
    "christmas": [
        "christmas"
    ],
    "christocentrisme": [
        "christocentrisme"
    ],
    "christologique": [
        "christologique"
    ],
    "christs": [
        "christ"
    ],
    "chromage": [
        "chromage"
    ],
    "chromatique": [
        "chromatique"
    ],
    "chromatiques": [
        "chromatique"
    ],
    "chromatisme": [
        "chromatisme"
    ],
    "chromatismes": [
        "chromatisme"
    ],
    "chromatogramme": [
        "chromatogramme"
    ],
    "chromatographie": [
        "chromatographie"
    ],
    "chrome": [
        "chromer",
        "chrome"
    ],
    "chromes": [
        "chromer",
        "chrome"
    ],
    "chromo": [
        "chromo"
    ],
    "chromogenes": [
        "chromogene"
    ],
    "chromos": [
        "chromo"
    ],
    "chromosome": [
        "chromosome"
    ],
    "chromosomes": [
        "chromosome"
    ],
    "chromosomique": [
        "chromosomique"
    ],
    "chromosomiques": [
        "chromosomique"
    ],
    "chromosphere": [
        "chromosphere"
    ],
    "chromee": [
        "chromer"
    ],
    "chromees": [
        "chromer"
    ],
    "chroniquais": [
        "chroniquer"
    ],
    "chronique": [
        "chroniquer",
        "chronique"
    ],
    "chroniquement": [
        "chroniquement"
    ],
    "chroniquer": [
        "chroniquer"
    ],
    "chroniques": [
        "chronique"
    ],
    "chroniqueur": [
        "chroniqueur"
    ],
    "chroniqueurs": [
        "chroniqueur"
    ],
    "chroniqueuse": [
        "chroniqueur"
    ],
    "chroniqueuses": [
        "chroniqueur"
    ],
    "chrono": [
        "chrono"
    ],
    "chronographe": [
        "chronographe"
    ],
    "chronologie": [
        "chronologie"
    ],
    "chronologique": [
        "chronologique"
    ],
    "chronologiquement": [
        "chronologiquement"
    ],
    "chronologiques": [
        "chronologique"
    ],
    "chronometre": [
        "chronometre",
        "chronometrer"
    ],
    "chronometres": [
        "chronometre",
        "chronometrer"
    ],
    "chronometrage": [
        "chronometrage"
    ],
    "chronometrait": [
        "chronometrer"
    ],
    "chronometrant": [
        "chronometrer"
    ],
    "chronometrer": [
        "chronometrer"
    ],
    "chronometreur": [
        "chronometreur"
    ],
    "chronometrez": [
        "chronometrer"
    ],
    "chronometrions": [
        "chronometrer"
    ],
    "chronometree": [
        "chronometrer"
    ],
    "chronometrees": [
        "chronometrer"
    ],
    "chronophotographie": [
        "chronophotographie"
    ],
    "chronophotographique": [
        "chronophotographique"
    ],
    "chronos": [
        "chrono"
    ],
    "chrysalide": [
        "chrysalide"
    ],
    "chrysalides": [
        "chrysalide"
    ],
    "chrysantheme": [
        "chrysantheme"
    ],
    "chrysanthemes": [
        "chrysantheme"
    ],
    "chrysolite": [
        "chrysolite"
    ],
    "chrysolithe": [
        "chrysolithe"
    ],
    "chrysostome": [
        "chrysostome"
    ],
    "chretien": [
        "chretien"
    ],
    "chretienne": [
        "chretien"
    ],
    "chretiennement": [
        "chretiennement"
    ],
    "chretiennes": [
        "chretien"
    ],
    "chretiens": [
        "chretien"
    ],
    "chretiente": [
        "chretiente"
    ],
    "chreme": [
        "chreme"
    ],
    "chtar": [
        "chtar"
    ],
    "chtarbe": [
        "chtarbe"
    ],
    "chtarbee": [
        "chtarbe"
    ],
    "chtarbees": [
        "chtarbe"
    ],
    "chthoniennes": [
        "chthonien"
    ],
    "chtibe": [
        "chtibe"
    ],
    "chtimi": [
        "chtimi"
    ],
    "chtimis": [
        "chtimi"
    ],
    "chtouille": [
        "chtouille"
    ],
    "chtourbe": [
        "chtourbe"
    ],
    "chu": [
        "choir"
    ],
    "chuchota": [
        "chuchoter"
    ],
    "chuchotai": [
        "chuchoter"
    ],
    "chuchotaient": [
        "chuchoter"
    ],
    "chuchotais": [
        "chuchoter"
    ],
    "chuchotait": [
        "chuchoter"
    ],
    "chuchotant": [
        "chuchoter",
        "chuchotant"
    ],
    "chuchotante": [
        "chuchotant"
    ],
    "chuchotantes": [
        "chuchotant"
    ],
    "chuchotants": [
        "chuchotant"
    ],
    "chuchote": [
        "chuchoter"
    ],
    "chuchotement": [
        "chuchotement"
    ],
    "chuchotements": [
        "chuchotement"
    ],
    "chuchotent": [
        "chuchoter"
    ],
    "chuchoter": [
        "chuchoter"
    ],
    "chuchoteraient": [
        "chuchoter"
    ],
    "chuchoterais": [
        "chuchoter"
    ],
    "chuchoterait": [
        "chuchoter"
    ],
    "chuchoteras": [
        "chuchoter"
    ],
    "chuchoterez": [
        "chuchoter"
    ],
    "chuchoteries": [
        "chuchoterie"
    ],
    "chuchoteur": [
        "chuchoteur"
    ],
    "chuchoteuse": [
        "chuchoteur"
    ],
    "chuchotez": [
        "chuchoter"
    ],
    "chuchotions": [
        "chuchoter"
    ],
    "chuchotis": [
        "chuchotis"
    ],
    "chuchotat": [
        "chuchoter"
    ],
    "chuchoterent": [
        "chuchoter"
    ],
    "chuchotee": [
        "chuchoter"
    ],
    "chuchotees": [
        "chuchoter"
    ],
    "chuchotes": [
        "chuchoter"
    ],
    "chue": [
        "choir"
    ],
    "chues": [
        "choir"
    ],
    "chuinta": [
        "chuinter"
    ],
    "chuintaient": [
        "chuinter"
    ],
    "chuintait": [
        "chuinter"
    ],
    "chuintant": [
        "chuinter",
        "chuintant"
    ],
    "chuintante": [
        "chuintant",
        "chuintante"
    ],
    "chuintants": [
        "chuintant"
    ],
    "chuinte": [
        "chuinter"
    ],
    "chuintement": [
        "chuintement"
    ],
    "chuintements": [
        "chuintement"
    ],
    "chuinter": [
        "chuinter"
    ],
    "chuinterent": [
        "chuinter"
    ],
    "chulo": [
        "chulo"
    ],
    "chum": [
        "chum"
    ],
    "churrigueresque": [
        "churrigueresque"
    ],
    "churros": [
        "churro"
    ],
    "chus": [
        "choir"
    ],
    "chut": [
        "chut",
        "choir"
    ],
    "chuta": [
        "chuter"
    ],
    "chutait": [
        "chuter"
    ],
    "chutant": [
        "chuter"
    ],
    "chute": [
        "chuter",
        "chute"
    ],
    "chutent": [
        "chuter"
    ],
    "chuter": [
        "chuter"
    ],
    "chutera": [
        "chuter"
    ],
    "chuteraient": [
        "chuter"
    ],
    "chuterait": [
        "chuter"
    ],
    "chuterez": [
        "chuter"
    ],
    "chutes": [
        "chuter",
        "chute"
    ],
    "chutney": [
        "chutney"
    ],
    "chuterent": [
        "chuter"
    ],
    "chutee": [
        "chuter"
    ],
    "chyle": [
        "chyle"
    ],
    "chypre": [
        "chypre"
    ],
    "chypriote": [
        "chypriote"
    ],
    "chale": [
        "chale"
    ],
    "chales": [
        "chale"
    ],
    "chalit": [
        "chalit"
    ],
    "chalits": [
        "chalit"
    ],
    "chalonnais": [
        "chalonnais"
    ],
    "chassis": [
        "chassis"
    ],
    "chataigne": [
        "chataigne",
        "chataigner"
    ],
    "chataignent": [
        "chataigner"
    ],
    "chataigner": [
        "chataigner"
    ],
    "chataigneraie": [
        "chataigneraie"
    ],
    "chataigneraies": [
        "chataigneraie"
    ],
    "chataignes": [
        "chataigne"
    ],
    "chataignier": [
        "chataignier"
    ],
    "chataigniers": [
        "chataignier"
    ],
    "chatain": [
        "chatain"
    ],
    "chataine": [
        "chatain"
    ],
    "chataines": [
        "chatain"
    ],
    "chatains": [
        "chatain"
    ],
    "chateau": [
        "chateau"
    ],
    "chateaubriant": [
        "chateaubriant"
    ],
    "chateaux": [
        "chateau"
    ],
    "chatel": [
        "chatel"
    ],
    "chatelain": [
        "chatelain"
    ],
    "chatelaine": [
        "chatelain"
    ],
    "chatelaines": [
        "chatelain"
    ],
    "chatelains": [
        "chatelain"
    ],
    "chatelet": [
        "chatelet"
    ],
    "chatellenie": [
        "chatellenie"
    ],
    "chatiaient": [
        "chatier"
    ],
    "chatiait": [
        "chatier"
    ],
    "chatiant": [
        "chatier"
    ],
    "chatie": [
        "chatier"
    ],
    "chatier": [
        "chatier"
    ],
    "chatiera": [
        "chatier"
    ],
    "chatierai": [
        "chatier"
    ],
    "chatierait": [
        "chatier"
    ],
    "chatiez": [
        "chatier"
    ],
    "chatiment": [
        "chatiment"
    ],
    "chatiments": [
        "chatiment"
    ],
    "chatiee": [
        "chatier"
    ],
    "chaties": [
        "chatier"
    ],
    "chatrage": [
        "chatrage"
    ],
    "chatraient": [
        "chatrer"
    ],
    "chatre": [
        "chatre",
        "chatrer"
    ],
    "chatrent": [
        "chatrer"
    ],
    "chatrer": [
        "chatrer"
    ],
    "chatreront": [
        "chatrer"
    ],
    "chatron": [
        "chatron"
    ],
    "chatrons": [
        "chatron"
    ],
    "chatres": [
        "chatre",
        "chatrer"
    ],
    "cheche": [
        "cheche"
    ],
    "cheches": [
        "cheche"
    ],
    "chenevis": [
        "chenevis"
    ],
    "cheque": [
        "cheque"
    ],
    "cheques": [
        "cheque"
    ],
    "chere": [
        "cher"
    ],
    "cherement": [
        "cherement"
    ],
    "cheres": [
        "cher"
    ],
    "chevre": [
        "chevre"
    ],
    "chevrefeuille": [
        "chevrefeuille"
    ],
    "chevrefeuilles": [
        "chevrefeuille"
    ],
    "chevres": [
        "chevre"
    ],
    "chebran": [
        "chebran"
    ],
    "chechia": [
        "chechia"
    ],
    "chechias": [
        "chechia"
    ],
    "chefesse": [
        "chefesse"
    ],
    "chelate": [
        "chelate"
    ],
    "chelidoine": [
        "chelidoine"
    ],
    "chelidoines": [
        "chelidoine"
    ],
    "cheloide": [
        "cheloide"
    ],
    "cheneau": [
        "cheneau"
    ],
    "cheneaux": [
        "cheneau"
    ],
    "chequier": [
        "chequier"
    ],
    "chequiers": [
        "chequier"
    ],
    "cheri": [
        "cheri",
        "cherir"
    ],
    "cherie": [
        "cheri",
        "cherir"
    ],
    "cheries": [
        "cheri",
        "cherir"
    ],
    "cherif": [
        "cherif"
    ],
    "cherifienne": [
        "cherifien"
    ],
    "cherir": [
        "cherir"
    ],
    "cherirai": [
        "cherir"
    ],
    "cherirais": [
        "cherir"
    ],
    "cherirez": [
        "cherir"
    ],
    "cherirons": [
        "cherir"
    ],
    "cheris": [
        "cheri",
        "cherir"
    ],
    "cherissaient": [
        "cherir"
    ],
    "cherissais": [
        "cherir"
    ],
    "cherissait": [
        "cherir"
    ],
    "cherissant": [
        "cherir"
    ],
    "cherisse": [
        "cherir"
    ],
    "cherissent": [
        "cherir"
    ],
    "cherissez": [
        "cherir"
    ],
    "cherissons": [
        "cherir"
    ],
    "cherit": [
        "cherir"
    ],
    "cherot": [
        "cherot"
    ],
    "cherubin": [
        "cherubin"
    ],
    "cherubinique": [
        "cherubinique"
    ],
    "cherubins": [
        "cherubin"
    ],
    "chetif": [
        "chetif"
    ],
    "chetifs": [
        "chetif"
    ],
    "chetive": [
        "chetif"
    ],
    "chetivement": [
        "chetivement"
    ],
    "chetives": [
        "chetif"
    ],
    "chetivite": [
        "chetivite"
    ],
    "chenaie": [
        "chenaie"
    ],
    "chenaies": [
        "chenaie"
    ],
    "chene": [
        "chene"
    ],
    "chenes": [
        "chene"
    ],
    "cheneteau": [
        "cheneteau"
    ],
    "chomage": [
        "chomage"
    ],
    "chomaient": [
        "chomer"
    ],
    "chomait": [
        "chomer"
    ],
    "chome": [
        "chome",
        "chomer"
    ],
    "chomedu": [
        "chomedu"
    ],
    "choment": [
        "chomer"
    ],
    "chomer": [
        "chomer"
    ],
    "chomerez": [
        "chomer"
    ],
    "chomeur": [
        "chomeur"
    ],
    "chomeurs": [
        "chomeur"
    ],
    "chomeuse": [
        "chomeur"
    ],
    "chomeuses": [
        "chomeur"
    ],
    "chomez": [
        "chomer"
    ],
    "chomee": [
        "chome"
    ],
    "chomes": [
        "chome"
    ],
    "ci": [
        "ci"
    ],
    "ciao": [
        "ciao"
    ],
    "cibiche": [
        "cibiche"
    ],
    "cibiches": [
        "cibiche"
    ],
    "cibiste": [
        "cibiste"
    ],
    "cibistes": [
        "cibiste"
    ],
    "ciblage": [
        "ciblage"
    ],
    "ciblais": [
        "cibler"
    ],
    "ciblait": [
        "cibler"
    ],
    "cible": [
        "cibler",
        "cible"
    ],
    "cibler": [
        "cibler"
    ],
    "ciblera": [
        "cibler"
    ],
    "cibleront": [
        "cibler"
    ],
    "cibles": [
        "cibler",
        "cible"
    ],
    "ciblez": [
        "cibler"
    ],
    "ciblons": [
        "cibler"
    ],
    "ciblee": [
        "cibler"
    ],
    "ciblees": [
        "cibler"
    ],
    "ciboire": [
        "ciboire"
    ],
    "ciboires": [
        "ciboire"
    ],
    "ciboule": [
        "ciboule"
    ],
    "ciboulette": [
        "ciboulette"
    ],
    "ciboulot": [
        "ciboulot"
    ],
    "ciboulots": [
        "ciboulot"
    ],
    "cicatrice": [
        "cicatrice"
    ],
    "cicatrices": [
        "cicatrice"
    ],
    "cicatriciel": [
        "cicatriciel"
    ],
    "cicatriciels": [
        "cicatriciel"
    ],
    "cicatrisa": [
        "cicatriser"
    ],
    "cicatrisable": [
        "cicatrisable"
    ],
    "cicatrisait": [
        "cicatriser"
    ],
    "cicatrisante": [
        "cicatrisant"
    ],
    "cicatrisants": [
        "cicatrisant"
    ],
    "cicatrisation": [
        "cicatrisation"
    ],
    "cicatrise": [
        "cicatriser"
    ],
    "cicatrisent": [
        "cicatriser"
    ],
    "cicatriser": [
        "cicatriser"
    ],
    "cicatrisera": [
        "cicatriser"
    ],
    "cicatriserait": [
        "cicatriser"
    ],
    "cicatriseront": [
        "cicatriser"
    ],
    "cicatrisez": [
        "cicatriser"
    ],
    "cicatrisee": [
        "cicatriser"
    ],
    "cicatrisees": [
        "cicatriser"
    ],
    "cicatrises": [
        "cicatriser"
    ],
    "cicero": [
        "cicero"
    ],
    "cicindele": [
        "cicindele"
    ],
    "cicindeles": [
        "cicindele"
    ],
    "cicerone": [
        "cicerone"
    ],
    "cicerones": [
        "cicerone"
    ],
    "ciceronienne": [
        "ciceronien"
    ],
    "cidre": [
        "cidre"
    ],
    "cidrerie": [
        "cidrerie"
    ],
    "ciel": [
        "ciel"
    ],
    "ciels": [
        "ciel"
    ],
    "cierge": [
        "cierge"
    ],
    "cierges": [
        "cierge"
    ],
    "cieux": [
        "cieux"
    ],
    "cigale": [
        "cigale"
    ],
    "cigales": [
        "cigale"
    ],
    "cigalon": [
        "cigalon"
    ],
    "cigalou": [
        "cigalou"
    ],
    "cigare": [
        "cigare"
    ],
    "cigares": [
        "cigare"
    ],
    "cigarette": [
        "cigarette"
    ],
    "cigarettes": [
        "cigarette"
    ],
    "cigarettier": [
        "cigarettier"
    ],
    "cigarillo": [
        "cigarillo"
    ],
    "cigarillos": [
        "cigarillo"
    ],
    "cigariere": [
        "cigarier"
    ],
    "cigarieres": [
        "cigarier"
    ],
    "cigle": [
        "cigler"
    ],
    "ciglent": [
        "cigler"
    ],
    "cigler": [
        "cigler"
    ],
    "ciglees": [
        "cigler"
    ],
    "cigles": [
        "cigler"
    ],
    "cigogne": [
        "cigogne"
    ],
    "cigognes": [
        "cigogne"
    ],
    "cigue": [
        "cigue"
    ],
    "cigues": [
        "cigue"
    ],
    "cil": [
        "cil"
    ],
    "ciliaires": [
        "ciliaire"
    ],
    "cilice": [
        "cilice"
    ],
    "cilla": [
        "ciller"
    ],
    "cillaient": [
        "ciller"
    ],
    "cillait": [
        "ciller"
    ],
    "cillant": [
        "ciller"
    ],
    "cille": [
        "ciller"
    ],
    "cillement": [
        "cillement"
    ],
    "cillements": [
        "cillement"
    ],
    "cillent": [
        "ciller"
    ],
    "ciller": [
        "ciller"
    ],
    "cillerait": [
        "ciller"
    ],
    "cillerent": [
        "ciller"
    ],
    "cils": [
        "cil"
    ],
    "cimaise": [
        "cimaise"
    ],
    "cimaises": [
        "cimaise"
    ],
    "cimarron": [
        "cimarron"
    ],
    "cime": [
        "cime"
    ],
    "ciment": [
        "ciment"
    ],
    "cimentaient": [
        "cimenter"
    ],
    "cimentait": [
        "cimenter"
    ],
    "cimentant": [
        "cimenter"
    ],
    "cimente": [
        "cimenter"
    ],
    "cimentent": [
        "cimenter"
    ],
    "cimenter": [
        "cimenter"
    ],
    "cimentera": [
        "cimenter"
    ],
    "cimenterie": [
        "cimenterie"
    ],
    "cimenteries": [
        "cimenterie"
    ],
    "ciments": [
        "ciment"
    ],
    "cimentee": [
        "cimenter"
    ],
    "cimentees": [
        "cimenter"
    ],
    "cimentes": [
        "cimenter"
    ],
    "cimes": [
        "cime"
    ],
    "cimeterre": [
        "cimeterre"
    ],
    "cimeterres": [
        "cimeterre"
    ],
    "cimetiere": [
        "cimetiere"
    ],
    "cimetieres": [
        "cimetiere"
    ],
    "cimier": [
        "cimier"
    ],
    "cimiers": [
        "cimier"
    ],
    "cinabre": [
        "cinabre"
    ],
    "cinghalais": [
        "cinghalais"
    ],
    "cinghalaises": [
        "cinghalais"
    ],
    "cingla": [
        "cingler"
    ],
    "cinglage": [
        "cinglage"
    ],
    "cinglaient": [
        "cingler"
    ],
    "cinglait": [
        "cingler"
    ],
    "cinglant": [
        "cingler",
        "cinglant"
    ],
    "cinglante": [
        "cinglant"
    ],
    "cinglantes": [
        "cinglant"
    ],
    "cinglants": [
        "cinglant"
    ],
    "cingle": [
        "cingler",
        "cingle"
    ],
    "cinglement": [
        "cinglement"
    ],
    "cinglent": [
        "cingler"
    ],
    "cingler": [
        "cingler"
    ],
    "cinglions": [
        "cingler"
    ],
    "cinglons": [
        "cinglon",
        "cingler"
    ],
    "cinglerent": [
        "cingler"
    ],
    "cinglee": [
        "cingler",
        "cingle"
    ],
    "cinglees": [
        "cingler",
        "cingle"
    ],
    "cingles": [
        "cingler",
        "cingle"
    ],
    "cinname": [
        "cinname"
    ],
    "cinoche": [
        "cinoche"
    ],
    "cinoches": [
        "cinoche"
    ],
    "cinoque": [
        "cinoque"
    ],
    "cinoques": [
        "cinoque"
    ],
    "cinq": [
        "cinq"
    ],
    "cinquantaine": [
        "cinquantaine"
    ],
    "cinquantaines": [
        "cinquantaine"
    ],
    "cinquante": [
        "cinquante"
    ],
    "cinquantenaire": [
        "cinquantenaire"
    ],
    "cinquantenaires": [
        "cinquantenaire"
    ],
    "cinquantieme": [
        "cinquantieme"
    ],
    "cinquantiemes": [
        "cinquantieme"
    ],
    "cinquieme": [
        "cinquieme"
    ],
    "cinquiemement": [
        "cinquiemement"
    ],
    "cinquiemes": [
        "cinquieme"
    ],
    "cintra": [
        "cintrer"
    ],
    "cintrage": [
        "cintrage"
    ],
    "cintrait": [
        "cintrer"
    ],
    "cintrant": [
        "cintrer"
    ],
    "cintras": [
        "cintrer"
    ],
    "cintre": [
        "cintre",
        "cintrer"
    ],
    "cintrer": [
        "cintrer"
    ],
    "cintres": [
        "cintre",
        "cintrer"
    ],
    "cintree": [
        "cintre",
        "cintrer"
    ],
    "cintrees": [
        "cintre",
        "cintrer"
    ],
    "cinzano": [
        "cinzano"
    ],
    "cine": [
        "cine"
    ],
    "cineaste": [
        "cineaste"
    ],
    "cineastes": [
        "cineaste"
    ],
    "cinema": [
        "cinema"
    ],
    "cinemas": [
        "cinema"
    ],
    "cinemascope": [
        "cinemascope"
    ],
    "cinematheque": [
        "cinematheque"
    ],
    "cinematheques": [
        "cinematheque"
    ],
    "cinematique": [
        "cinematique"
    ],
    "cinematographe": [
        "cinematographe"
    ],
    "cinematographes": [
        "cinematographe"
    ],
    "cinematographie": [
        "cinematographie"
    ],
    "cinematographique": [
        "cinematographique"
    ],
    "cinematographiquement": [
        "cinematographiquement"
    ],
    "cinematographiques": [
        "cinematographique"
    ],
    "cinemometres": [
        "cinemometre"
    ],
    "cinephile": [
        "cinephile"
    ],
    "cinephiles": [
        "cinephile"
    ],
    "cineraire": [
        "cineraire"
    ],
    "cinerama": [
        "cinerama"
    ],
    "cines": [
        "cine"
    ],
    "cinetique": [
        "cinetique"
    ],
    "cipal": [
        "cipal"
    ],
    "cipaye": [
        "cipaye"
    ],
    "cipayes": [
        "cipaye"
    ],
    "cipolin": [
        "cipolin"
    ],
    "cippes": [
        "cippe"
    ],
    "cira": [
        "cirer"
    ],
    "cirage": [
        "cirage"
    ],
    "ciraient": [
        "cirer"
    ],
    "cirais": [
        "cirer"
    ],
    "cirait": [
        "cirer"
    ],
    "cirant": [
        "cirer"
    ],
    "circadien": [
        "circadien"
    ],
    "circassien": [
        "circassien"
    ],
    "circassienne": [
        "circassien",
        "circassienne"
    ],
    "circassiennes": [
        "circassienne"
    ],
    "circaete": [
        "circaete"
    ],
    "circoncire": [
        "circoncire"
    ],
    "circoncis": [
        "circoncis",
        "circoncire"
    ],
    "circoncise": [
        "circoncire"
    ],
    "circoncisent": [
        "circoncire"
    ],
    "circoncision": [
        "circoncision"
    ],
    "circoncisions": [
        "circoncision"
    ],
    "circoncit": [
        "circoncire"
    ],
    "circonflexe": [
        "circonflexe"
    ],
    "circonflexes": [
        "circonflexe"
    ],
    "circonference": [
        "circonference"
    ],
    "circonlocutions": [
        "circonlocution"
    ],
    "circonscription": [
        "circonscription"
    ],
    "circonscriptions": [
        "circonscription"
    ],
    "circonscrire": [
        "circonscrire"
    ],
    "circonscris": [
        "circonscrire"
    ],
    "circonscrit": [
        "circonscrire"
    ],
    "circonscrite": [
        "circonscrire"
    ],
    "circonscrites": [
        "circonscrire"
    ],
    "circonscrits": [
        "circonscrire"
    ],
    "circonscrivait": [
        "circonscrire"
    ],
    "circonscrivent": [
        "circonscrire"
    ],
    "circonscrivit": [
        "circonscrire"
    ],
    "circonspect": [
        "circonspect"
    ],
    "circonspecte": [
        "circonspect"
    ],
    "circonspectes": [
        "circonspect"
    ],
    "circonspection": [
        "circonspection"
    ],
    "circonspections": [
        "circonspection"
    ],
    "circonspects": [
        "circonspect"
    ],
    "circonstance": [
        "circonstance"
    ],
    "circonstances": [
        "circonstance"
    ],
    "circonstancia": [
        "circonstancier"
    ],
    "circonstanciel": [
        "circonstanciel"
    ],
    "circonstancielle": [
        "circonstanciel"
    ],
    "circonstanciels": [
        "circonstanciel"
    ],
    "circonstancie": [
        "circonstancie",
        "circonstancier"
    ],
    "circonstanciee": [
        "circonstancier"
    ],
    "circonstanciees": [
        "circonstancie"
    ],
    "circonstancies": [
        "circonstancie"
    ],
    "circonvallation": [
        "circonvallation"
    ],
    "circonvallations": [
        "circonvallation"
    ],
    "circonvenant": [
        "circonvenir"
    ],
    "circonvenir": [
        "circonvenir"
    ],
    "circonvenu": [
        "circonvenir"
    ],
    "circonvenue": [
        "circonvenir"
    ],
    "circonvient": [
        "circonvenir"
    ],
    "circonvolution": [
        "circonvolution"
    ],
    "circonvolutions": [
        "circonvolution"
    ],
    "circuit": [
        "circuit"
    ],
    "circuits": [
        "circuit"
    ],
    "circula": [
        "circuler"
    ],
    "circulaient": [
        "circuler"
    ],
    "circulaire": [
        "circulaire"
    ],
    "circulairement": [
        "circulairement"
    ],
    "circulaires": [
        "circulaire"
    ],
    "circulais": [
        "circuler"
    ],
    "circulait": [
        "circuler"
    ],
    "circulant": [
        "circuler",
        "circulant"
    ],
    "circularite": [
        "circularite"
    ],
    "circulation": [
        "circulation"
    ],
    "circulations": [
        "circulation"
    ],
    "circulatoire": [
        "circulatoire"
    ],
    "circulatoires": [
        "circulatoire"
    ],
    "circule": [
        "circuler"
    ],
    "circulent": [
        "circuler"
    ],
    "circuler": [
        "circuler"
    ],
    "circulera": [
        "circuler"
    ],
    "circuleraient": [
        "circuler"
    ],
    "circulerait": [
        "circuler"
    ],
    "circuleront": [
        "circuler"
    ],
    "circules": [
        "circuler"
    ],
    "circulez": [
        "circuler"
    ],
    "circulions": [
        "circuler"
    ],
    "circulons": [
        "circuler"
    ],
    "circulerent": [
        "circuler"
    ],
    "circumnavigation": [
        "circumnavigation"
    ],
    "cire": [
        "cirer",
        "cire"
    ],
    "cirent": [
        "cirer"
    ],
    "cirer": [
        "cirer"
    ],
    "cirerais": [
        "cirer"
    ],
    "cirerait": [
        "cirer"
    ],
    "cires": [
        "cirer",
        "cire"
    ],
    "cireur": [
        "cireur"
    ],
    "cireurs": [
        "cireur"
    ],
    "cireuse": [
        "cireur",
        "cireux"
    ],
    "cireuses": [
        "cireux"
    ],
    "cireux": [
        "cireux"
    ],
    "cirez": [
        "cirer"
    ],
    "cirions": [
        "cirer"
    ],
    "ciron": [
        "ciron"
    ],
    "cirons": [
        "cirer",
        "ciron"
    ],
    "cirque": [
        "cirque"
    ],
    "cirques": [
        "cirque"
    ],
    "cirrhose": [
        "cirrhose"
    ],
    "cirrhotique": [
        "cirrhotique"
    ],
    "cirrus": [
        "cirrus"
    ],
    "cirses": [
        "cirse"
    ],
    "ciree": [
        "cirer"
    ],
    "cirees": [
        "cirer"
    ],
    "cis": [
        "ci",
        "cis"
    ],
    "cisailla": [
        "cisailler"
    ],
    "cisaillage": [
        "cisaillage"
    ],
    "cisaillaient": [
        "cisailler"
    ],
    "cisaillait": [
        "cisailler"
    ],
    "cisaillant": [
        "cisailler",
        "cisaillant"
    ],
    "cisaille": [
        "cisailler",
        "cisaille"
    ],
    "cisaillement": [
        "cisaillement"
    ],
    "cisaillent": [
        "cisailler"
    ],
    "cisailler": [
        "cisailler"
    ],
    "cisailles": [
        "cisailler",
        "cisaille"
    ],
    "cisaillerent": [
        "cisailler"
    ],
    "cisaillee": [
        "cisailler"
    ],
    "cisaillees": [
        "cisailler"
    ],
    "ciseau": [
        "ciseau"
    ],
    "ciseaux": [
        "ciseau"
    ],
    "ciselaient": [
        "ciseler"
    ],
    "ciselait": [
        "ciseler"
    ],
    "ciseler": [
        "ciseler"
    ],
    "ciselet": [
        "ciselet"
    ],
    "ciseleurs": [
        "ciseleur"
    ],
    "ciselions": [
        "ciseler"
    ],
    "ciselure": [
        "ciselure"
    ],
    "ciselures": [
        "ciselure"
    ],
    "cisele": [
        "cisele",
        "ciseler"
    ],
    "ciselee": [
        "cisele",
        "ciseler"
    ],
    "ciselees": [
        "cisele",
        "ciseler"
    ],
    "ciseles": [
        "cisele",
        "ciseler"
    ],
    "ciste": [
        "ciste"
    ],
    "cistercien": [
        "cistercien"
    ],
    "cistercienne": [
        "cistercien"
    ],
    "cisterciennes": [
        "cistercien"
    ],
    "cisterciens": [
        "cistercien"
    ],
    "cistes": [
        "ciste"
    ],
    "cita": [
        "citer"
    ],
    "citadelle": [
        "citadelle"
    ],
    "citadelles": [
        "citadelle"
    ],
    "citadin": [
        "citadin"
    ],
    "citadine": [
        "citadin"
    ],
    "citadines": [
        "citadin"
    ],
    "citadins": [
        "citadin"
    ],
    "citai": [
        "citer"
    ],
    "citaient": [
        "citer"
    ],
    "citais": [
        "citer"
    ],
    "citait": [
        "citer"
    ],
    "citant": [
        "citer"
    ],
    "citation": [
        "citation"
    ],
    "citations": [
        "citation"
    ],
    "cite": [
        "cite",
        "citer"
    ],
    "citent": [
        "citer"
    ],
    "citer": [
        "citer"
    ],
    "citera": [
        "citer"
    ],
    "citerai": [
        "citer"
    ],
    "citerais": [
        "citer"
    ],
    "citerait": [
        "citer"
    ],
    "citeras": [
        "citer"
    ],
    "citerne": [
        "citerne"
    ],
    "citernes": [
        "citerne"
    ],
    "cites": [
        "cite",
        "citer"
    ],
    "citez": [
        "citer"
    ],
    "cithare": [
        "cithare"
    ],
    "cithares": [
        "cithare"
    ],
    "citiez": [
        "citer"
    ],
    "citions": [
        "citer"
    ],
    "citons": [
        "citer"
    ],
    "citoyen": [
        "citoyen"
    ],
    "citoyenne": [
        "citoyen"
    ],
    "citoyennes": [
        "citoyen"
    ],
    "citoyennete": [
        "citoyennete"
    ],
    "citoyens": [
        "citoyen"
    ],
    "citrate": [
        "citrate"
    ],
    "citrine": [
        "citrine"
    ],
    "citrique": [
        "citrique"
    ],
    "citron": [
        "citron"
    ],
    "citronnade": [
        "citronnade"
    ],
    "citronnades": [
        "citronnade"
    ],
    "citronnelle": [
        "citronnelle"
    ],
    "citronnelles": [
        "citronnelle"
    ],
    "citronnez": [
        "citronner"
    ],
    "citronnier": [
        "citronnier"
    ],
    "citronniers": [
        "citronnier"
    ],
    "citronne": [
        "citronne"
    ],
    "citronnee": [
        "citronne",
        "citronner"
    ],
    "citrons": [
        "citron"
    ],
    "citrouille": [
        "citrouille"
    ],
    "citrouilles": [
        "citrouille"
    ],
    "citrus": [
        "citrus"
    ],
    "city": [
        "city"
    ],
    "citat": [
        "citer"
    ],
    "citerent": [
        "citer"
    ],
    "citee": [
        "cite",
        "citer"
    ],
    "citees": [
        "cite",
        "citer"
    ],
    "citerieure": [
        "citerieur"
    ],
    "civadiere": [
        "civadiere"
    ],
    "civelles": [
        "civelle"
    ],
    "civelots": [
        "civelot"
    ],
    "civet": [
        "civet"
    ],
    "civets": [
        "civet"
    ],
    "civette": [
        "civette"
    ],
    "civil": [
        "civil"
    ],
    "civile": [
        "civil"
    ],
    "civilement": [
        "civilement"
    ],
    "civiles": [
        "civil"
    ],
    "civilisateur": [
        "civilisateur"
    ],
    "civilisation": [
        "civilisation"
    ],
    "civilisations": [
        "civilisation"
    ],
    "civilisatrice": [
        "civilisateur"
    ],
    "civilise": [
        "civilise",
        "civiliser"
    ],
    "civiliser": [
        "civiliser"
    ],
    "civilises": [
        "civilise",
        "civiliser"
    ],
    "civilisee": [
        "civilise",
        "civiliser"
    ],
    "civilisees": [
        "civilise",
        "civiliser"
    ],
    "civilite": [
        "civilite"
    ],
    "civilites": [
        "civilite"
    ],
    "civils": [
        "civil"
    ],
    "civique": [
        "civique"
    ],
    "civiques": [
        "civique"
    ],
    "civisme": [
        "civisme"
    ],
    "civiere": [
        "civiere"
    ],
    "civieres": [
        "civiere"
    ],
    "clabaudage": [
        "clabaudage"
    ],
    "clabaudages": [
        "clabaudage"
    ],
    "clabaudaient": [
        "clabauder"
    ],
    "clabaudent": [
        "clabauder"
    ],
    "clabauder": [
        "clabauder"
    ],
    "clabauderies": [
        "clabauderie"
    ],
    "clabaude": [
        "clabauder"
    ],
    "clabote": [
        "claboter"
    ],
    "clabotent": [
        "claboter"
    ],
    "claboter": [
        "claboter"
    ],
    "clac": [
        "clac"
    ],
    "clafouti": [
        "clafouti"
    ],
    "clafoutis": [
        "clafoutis"
    ],
    "claie": [
        "claie"
    ],
    "claies": [
        "claie"
    ],
    "claim": [
        "claim"
    ],
    "clair": [
        "clair"
    ],
    "claire": [
        "claire",
        "clair"
    ],
    "clairement": [
        "clairement"
    ],
    "claires": [
        "claire",
        "clair"
    ],
    "clairet": [
        "clairet"
    ],
    "clairette": [
        "clairet",
        "clairette"
    ],
    "clairiere": [
        "clairiere"
    ],
    "clairieres": [
        "clairiere"
    ],
    "clairon": [
        "clairon"
    ],
    "claironna": [
        "claironner"
    ],
    "claironnait": [
        "claironner"
    ],
    "claironnant": [
        "claironnant",
        "claironner"
    ],
    "claironnante": [
        "claironnant"
    ],
    "claironnantes": [
        "claironnant"
    ],
    "claironnants": [
        "claironnant"
    ],
    "claironne": [
        "claironner"
    ],
    "claironnent": [
        "claironner"
    ],
    "claironner": [
        "claironner"
    ],
    "claironnions": [
        "claironner"
    ],
    "clairons": [
        "clairon"
    ],
    "clairs": [
        "clair"
    ],
    "clairsemaient": [
        "clairsemer"
    ],
    "clairsemait": [
        "clairsemer"
    ],
    "clairsemant": [
        "clairsemer"
    ],
    "clairseme": [
        "clairseme",
        "clairsemer"
    ],
    "clairsemee": [
        "clairseme",
        "clairsemer"
    ],
    "clairsemees": [
        "clairseme",
        "clairsemer"
    ],
    "clairsemes": [
        "clairseme",
        "clairsemer"
    ],
    "clairvoyance": [
        "clairvoyance"
    ],
    "clairvoyances": [
        "clairvoyance"
    ],
    "clairvoyant": [
        "clairvoyant"
    ],
    "clairvoyante": [
        "clairvoyant"
    ],
    "clairvoyants": [
        "clairvoyant"
    ],
    "clam": [
        "clam"
    ],
    "clama": [
        "clamer"
    ],
    "clamai": [
        "clamer"
    ],
    "clamaient": [
        "clamer"
    ],
    "clamait": [
        "clamer"
    ],
    "clamant": [
        "clamer"
    ],
    "clame": [
        "clamer"
    ],
    "clamecer": [
        "clamecer"
    ],
    "clamece": [
        "clamecer"
    ],
    "clamecee": [
        "clamecer"
    ],
    "clament": [
        "clamer"
    ],
    "clamer": [
        "clamer"
    ],
    "clameraient": [
        "clamer"
    ],
    "clameur": [
        "clameur"
    ],
    "clameurs": [
        "clameur"
    ],
    "clamez": [
        "clamer"
    ],
    "clamions": [
        "clamer"
    ],
    "clamp": [
        "clamp"
    ],
    "clampe": [
        "clamper"
    ],
    "clamper": [
        "clamper"
    ],
    "clampin": [
        "clampin"
    ],
    "clampins": [
        "clampin"
    ],
    "clamps": [
        "clamp"
    ],
    "clams": [
        "clam"
    ],
    "clamse": [
        "clamser"
    ],
    "clamser": [
        "clamser"
    ],
    "clamserai": [
        "clamser"
    ],
    "clamserait": [
        "clamser"
    ],
    "clamsee": [
        "clamser"
    ],
    "clamses": [
        "clamser"
    ],
    "clamerent": [
        "clamer"
    ],
    "clamee": [
        "clamer"
    ],
    "clames": [
        "clamer"
    ],
    "clan": [
        "clan"
    ],
    "clandestin": [
        "clandestin"
    ],
    "clandestine": [
        "clandestin"
    ],
    "clandestinement": [
        "clandestinement"
    ],
    "clandestines": [
        "clandestin"
    ],
    "clandestinite": [
        "clandestinite"
    ],
    "clandestinites": [
        "clandestinite"
    ],
    "clandestins": [
        "clandestin"
    ],
    "clande": [
        "clande"
    ],
    "clandes": [
        "clande"
    ],
    "clans": [
        "clan"
    ],
    "clap": [
        "clap"
    ],
    "clapant": [
        "claper"
    ],
    "clape": [
        "claper"
    ],
    "clapent": [
        "claper"
    ],
    "claper": [
        "claper"
    ],
    "claperai": [
        "claper"
    ],
    "clapes": [
        "claper"
    ],
    "clapet": [
        "clapet"
    ],
    "clapets": [
        "clapet"
    ],
    "clapette": [
        "clapette"
    ],
    "clapier": [
        "clapier"
    ],
    "clapiers": [
        "clapier"
    ],
    "clapir": [
        "clapir"
    ],
    "clapit": [
        "clapir"
    ],
    "clapot": [
        "clapot"
    ],
    "clapota": [
        "clapoter"
    ],
    "clapotaient": [
        "clapoter"
    ],
    "clapotait": [
        "clapoter"
    ],
    "clapotant": [
        "clapoter",
        "clapotant"
    ],
    "clapotante": [
        "clapotant"
    ],
    "clapotantes": [
        "clapotant"
    ],
    "clapote": [
        "clapoter"
    ],
    "clapotement": [
        "clapotement"
    ],
    "clapotements": [
        "clapotement"
    ],
    "clapotent": [
        "clapoter"
    ],
    "clapoter": [
        "clapoter"
    ],
    "clapoterait": [
        "clapoter"
    ],
    "clapotis": [
        "clapotis"
    ],
    "clappait": [
        "clapper"
    ],
    "clappant": [
        "clapper"
    ],
    "clappe": [
        "clapper"
    ],
    "clappement": [
        "clappement"
    ],
    "clappements": [
        "clappement"
    ],
    "clapper": [
        "clapper"
    ],
    "claqua": [
        "claquer"
    ],
    "claquage": [
        "claquage"
    ],
    "claquai": [
        "claquer"
    ],
    "claquaient": [
        "claquer"
    ],
    "claquais": [
        "claquer"
    ],
    "claquait": [
        "claquer"
    ],
    "claquant": [
        "claquant",
        "claquer"
    ],
    "claquante": [
        "claquant"
    ],
    "claquantes": [
        "claquant"
    ],
    "claquants": [
        "claquant"
    ],
    "claque": [
        "claquer",
        "claque"
    ],
    "claquedents": [
        "claquedent"
    ],
    "claquement": [
        "claquement"
    ],
    "claquements": [
        "claquement"
    ],
    "claquemurait": [
        "claquemurer"
    ],
    "claquemurant": [
        "claquemurer"
    ],
    "claquemurer": [
        "claquemurer"
    ],
    "claquemures": [
        "claquemurer"
    ],
    "claquemure": [
        "claquemurer"
    ],
    "claquemuree": [
        "claquemure",
        "claquemurer"
    ],
    "claquemurees": [
        "claquemure",
        "claquemurer"
    ],
    "claquent": [
        "claquer"
    ],
    "claquer": [
        "claquer"
    ],
    "claquera": [
        "claquer"
    ],
    "claquerai": [
        "claquer"
    ],
    "claqueraient": [
        "claquer"
    ],
    "claquerais": [
        "claquer"
    ],
    "claquerait": [
        "claquer"
    ],
    "claqueriez": [
        "claquer"
    ],
    "claqueront": [
        "claquer"
    ],
    "claques": [
        "claquer",
        "claque"
    ],
    "claquet": [
        "claquet"
    ],
    "claquette": [
        "claquette"
    ],
    "claquettes": [
        "claquette"
    ],
    "claqueterent": [
        "claqueter"
    ],
    "claqueurs": [
        "claqueur"
    ],
    "claquez": [
        "claquer"
    ],
    "claquions": [
        "claquer"
    ],
    "claquoirs": [
        "claquoir"
    ],
    "claquons": [
        "claquer"
    ],
    "claquat": [
        "claquer"
    ],
    "claquerent": [
        "claquer"
    ],
    "claquee": [
        "claquer"
    ],
    "claquees": [
        "claquer"
    ],
    "clarifia": [
        "clarifier"
    ],
    "clarifiant": [
        "clarifier"
    ],
    "clarification": [
        "clarification"
    ],
    "clarifie": [
        "clarifier"
    ],
    "clarifier": [
        "clarifier"
    ],
    "clarifions": [
        "clarifier"
    ],
    "clarifiee": [
        "clarifier"
    ],
    "clarine": [
        "clarine"
    ],
    "clarines": [
        "clarine"
    ],
    "clarinette": [
        "clarinette"
    ],
    "clarinettes": [
        "clarinette"
    ],
    "clarinettiste": [
        "clarinettiste"
    ],
    "clarisse": [
        "clarisse"
    ],
    "clarisses": [
        "clarisse"
    ],
    "clarissimes": [
        "clarissime"
    ],
    "clarte": [
        "clarte"
    ],
    "clartes": [
        "clarte"
    ],
    "clash": [
        "clash"
    ],
    "class": [
        "class"
    ],
    "classa": [
        "classer"
    ],
    "classable": [
        "classable"
    ],
    "classaient": [
        "classer"
    ],
    "classais": [
        "classer"
    ],
    "classait": [
        "classer"
    ],
    "classant": [
        "classer"
    ],
    "classe": [
        "classe",
        "classer"
    ],
    "classement": [
        "classement"
    ],
    "classements": [
        "classement"
    ],
    "classent": [
        "classer"
    ],
    "classer": [
        "classer"
    ],
    "classera": [
        "classer"
    ],
    "classerai": [
        "classer"
    ],
    "classeraient": [
        "classer"
    ],
    "classerais": [
        "classer"
    ],
    "classerait": [
        "classer"
    ],
    "classeras": [
        "classer"
    ],
    "classes": [
        "class",
        "classe",
        "classer"
    ],
    "classeur": [
        "classeur"
    ],
    "classeurs": [
        "classeur"
    ],
    "classez": [
        "classer"
    ],
    "classicisme": [
        "classicisme"
    ],
    "classico": [
        "classico"
    ],
    "classieuse": [
        "classieux"
    ],
    "classieux": [
        "classieux"
    ],
    "classiez": [
        "classer"
    ],
    "classifiables": [
        "classifiable"
    ],
    "classificateur": [
        "classificateur"
    ],
    "classification": [
        "classification"
    ],
    "classifications": [
        "classification"
    ],
    "classificatrice": [
        "classificateur"
    ],
    "classifient": [
        "classifier"
    ],
    "classifier": [
        "classifier"
    ],
    "classifierais": [
        "classifier"
    ],
    "classifie": [
        "classifier"
    ],
    "classifiees": [
        "classifier"
    ],
    "classique": [
        "classique"
    ],
    "classiquement": [
        "classiquement"
    ],
    "classiques": [
        "classique"
    ],
    "classons": [
        "classer"
    ],
    "classerent": [
        "classer"
    ],
    "classee": [
        "classe",
        "classer"
    ],
    "classees": [
        "classe",
        "classer"
    ],
    "clathres": [
        "clathre"
    ],
    "claude": [
        "claude"
    ],
    "claudicant": [
        "claudicant"
    ],
    "claudicante": [
        "claudicant"
    ],
    "claudicants": [
        "claudicant"
    ],
    "claudication": [
        "claudication"
    ],
    "claudiquait": [
        "claudiquer"
    ],
    "claudiquant": [
        "claudiquer"
    ],
    "claudique": [
        "claudiquer"
    ],
    "claudiquer": [
        "claudiquer"
    ],
    "claudiquerait": [
        "claudiquer"
    ],
    "claudiquerez": [
        "claudiquer"
    ],
    "claudelienne": [
        "claudelien"
    ],
    "clause": [
        "clause"
    ],
    "clauses": [
        "clause"
    ],
    "clausewitziens": [
        "clausewitzien"
    ],
    "claustrait": [
        "claustrer"
    ],
    "claustrale": [
        "claustral"
    ],
    "claustration": [
        "claustration"
    ],
    "claustrophobe": [
        "claustrophobe"
    ],
    "claustrophobie": [
        "claustrophobie"
    ],
    "claustree": [
        "claustrer"
    ],
    "clavaire": [
        "clavaire"
    ],
    "clavaires": [
        "clavaire"
    ],
    "claveaux": [
        "claveau"
    ],
    "clavecin": [
        "clavecin"
    ],
    "claveciniste": [
        "claveciniste"
    ],
    "clavecins": [
        "clavecin"
    ],
    "clavette": [
        "clavette"
    ],
    "clavicule": [
        "clavicule"
    ],
    "clavicules": [
        "clavicule"
    ],
    "clavier": [
        "clavier"
    ],
    "claviers": [
        "clavier"
    ],
    "clayettes": [
        "clayette"
    ],
    "claymore": [
        "claymore"
    ],
    "clayon": [
        "clayon"
    ],
    "clayonnage": [
        "clayonnage"
    ],
    "clayonnages": [
        "clayonnage"
    ],
    "clayonnee": [
        "clayonner"
    ],
    "clayons": [
        "clayon"
    ],
    "clean": [
        "clean"
    ],
    "clearing": [
        "clear",
        "clearing"
    ],
    "clebs": [
        "clebs"
    ],
    "clef": [
        "clef"
    ],
    "clefs": [
        "clef"
    ],
    "clenche": [
        "clenche"
    ],
    "clenches": [
        "clench",
        "clenche"
    ],
    "clepsydre": [
        "clepsydre"
    ],
    "cleptomane": [
        "cleptomane"
    ],
    "cleptomanie": [
        "cleptomanie"
    ],
    "clerc": [
        "clerc"
    ],
    "clercs": [
        "clerc"
    ],
    "clergeon": [
        "clergeon"
    ],
    "clergyman": [
        "clergyman"
    ],
    "clergymen": [
        "clergyman"
    ],
    "clerge": [
        "clerge"
    ],
    "clerges": [
        "clerge"
    ],
    "clermontois": [
        "clermontois"
    ],
    "clermontoise": [
        "clermontois"
    ],
    "clic": [
        "clic"
    ],
    "clichage": [
        "clichage"
    ],
    "clicher": [
        "clicher"
    ],
    "clicherie": [
        "clicherie"
    ],
    "clicheur": [
        "clicheur"
    ],
    "cliche": [
        "cliche",
        "clicher"
    ],
    "clichee": [
        "cliche"
    ],
    "cliches": [
        "cliche",
        "clicher"
    ],
    "click": [
        "click"
    ],
    "clics": [
        "clic"
    ],
    "client": [
        "client"
    ],
    "cliente": [
        "client"
    ],
    "clientes": [
        "client"
    ],
    "clients": [
        "client"
    ],
    "clientele": [
        "clientele"
    ],
    "clienteles": [
        "clientele"
    ],
    "cligna": [
        "cligner"
    ],
    "clignaient": [
        "cligner"
    ],
    "clignais": [
        "cligner"
    ],
    "clignait": [
        "cligner"
    ],
    "clignant": [
        "cligner"
    ],
    "cligne": [
        "cligner"
    ],
    "clignement": [
        "clignement"
    ],
    "clignements": [
        "clignement"
    ],
    "clignent": [
        "cligner"
    ],
    "cligner": [
        "cligner"
    ],
    "clignez": [
        "cligner"
    ],
    "clignons": [
        "cligner"
    ],
    "clignota": [
        "clignoter"
    ],
    "clignotaient": [
        "clignoter"
    ],
    "clignotait": [
        "clignoter"
    ],
    "clignotant": [
        "clignotant",
        "clignoter"
    ],
    "clignotante": [
        "clignotant"
    ],
    "clignotantes": [
        "clignotant"
    ],
    "clignotants": [
        "clignotant"
    ],
    "clignote": [
        "clignoter"
    ],
    "clignotement": [
        "clignotement"
    ],
    "clignotements": [
        "clignotement"
    ],
    "clignotent": [
        "clignoter"
    ],
    "clignoter": [
        "clignoter"
    ],
    "clignotera": [
        "clignoter"
    ],
    "clignoterait": [
        "clignoter"
    ],
    "clignoteur": [
        "clignoteur"
    ],
    "clignoterent": [
        "clignoter"
    ],
    "clignerent": [
        "cligner"
    ],
    "clignees": [
        "cligner"
    ],
    "clignes": [
        "cligner"
    ],
    "clilles": [
        "clille"
    ],
    "climat": [
        "climat"
    ],
    "climatique": [
        "climatique"
    ],
    "climatiques": [
        "climatique"
    ],
    "climatisant": [
        "climatiser"
    ],
    "climatisation": [
        "climatisation"
    ],
    "climatiser": [
        "climatiser"
    ],
    "climatiseur": [
        "climatiseur"
    ],
    "climatiseurs": [
        "climatiseur"
    ],
    "climatise": [
        "climatise",
        "climatiser"
    ],
    "climatisee": [
        "climatise",
        "climatiser"
    ],
    "climatisees": [
        "climatise",
        "climatiser"
    ],
    "climatises": [
        "climatise"
    ],
    "climatologue": [
        "climatologue"
    ],
    "climats": [
        "climat"
    ],
    "climateriques": [
        "climaterique"
    ],
    "climax": [
        "climax"
    ],
    "clin": [
        "clin"
    ],
    "clinche": [
        "clinche"
    ],
    "clinicat": [
        "clinicat"
    ],
    "clinicien": [
        "clinicien"
    ],
    "clinicienne": [
        "clinicien"
    ],
    "cliniciens": [
        "clinicien"
    ],
    "clinique": [
        "clinique"
    ],
    "cliniquement": [
        "cliniquement"
    ],
    "cliniques": [
        "clinique"
    ],
    "clinker": [
        "clinker"
    ],
    "clinquant": [
        "clinquant"
    ],
    "clinquante": [
        "clinquant"
    ],
    "clinquantes": [
        "clinquant"
    ],
    "clinquants": [
        "clinquant"
    ],
    "clins": [
        "clin"
    ],
    "clip": [
        "clip"
    ],
    "clipper": [
        "clipper"
    ],
    "clippers": [
        "clipper"
    ],
    "clips": [
        "clip"
    ],
    "cliquant": [
        "cliquer"
    ],
    "clique": [
        "clique",
        "cliquer"
    ],
    "cliquer": [
        "cliquer"
    ],
    "cliques": [
        "clique"
    ],
    "cliquet": [
        "cliquet"
    ],
    "cliqueta": [
        "cliqueter"
    ],
    "cliquetaient": [
        "cliqueter"
    ],
    "cliquetait": [
        "cliqueter"
    ],
    "cliquetant": [
        "cliqueter",
        "cliquetant"
    ],
    "cliquetante": [
        "cliquetant"
    ],
    "cliquetantes": [
        "cliquetant"
    ],
    "cliquetants": [
        "cliquetant"
    ],
    "cliqueter": [
        "cliqueter"
    ],
    "cliquetis": [
        "cliquetis"
    ],
    "cliquets": [
        "cliquet"
    ],
    "cliquette": [
        "cliqueter"
    ],
    "cliquettement": [
        "cliquettement"
    ],
    "cliquettent": [
        "cliqueter"
    ],
    "cliquettes": [
        "cliquette"
    ],
    "cliquez": [
        "cliquer"
    ],
    "cliquetement": [
        "cliquetement"
    ],
    "cliquetements": [
        "cliquetement"
    ],
    "clissees": [
        "clisser"
    ],
    "clito": [
        "clito"
    ],
    "clitoridectomie": [
        "clitoridectomie"
    ],
    "clitoridien": [
        "clitoridien"
    ],
    "clitoridienne": [
        "clitoridien"
    ],
    "clitoris": [
        "clitoris"
    ],
    "clivage": [
        "clivage"
    ],
    "clivages": [
        "clivage"
    ],
    "cliver": [
        "cliver"
    ],
    "clives": [
        "clive"
    ],
    "cloacal": [
        "cloacal"
    ],
    "cloaque": [
        "cloaque"
    ],
    "cloaques": [
        "cloaque"
    ],
    "cloc": [
        "cloc"
    ],
    "clochaient": [
        "clocher"
    ],
    "clochait": [
        "clocher"
    ],
    "clochant": [
        "clocher"
    ],
    "clochard": [
        "clochard"
    ],
    "clocharde": [
        "clochard"
    ],
    "clochardes": [
        "clochard"
    ],
    "clochardisait": [
        "clochardiser"
    ],
    "clochardisation": [
        "clochardisation"
    ],
    "clochardiser": [
        "clochardiser"
    ],
    "clochardise": [
        "clochardiser"
    ],
    "clochards": [
        "clochard"
    ],
    "cloche": [
        "cloche",
        "clocher"
    ],
    "clochent": [
        "clocher"
    ],
    "clocher": [
        "clocher"
    ],
    "clochers": [
        "clocher"
    ],
    "cloches": [
        "cloche",
        "clocher"
    ],
    "clocheton": [
        "clocheton"
    ],
    "clochetons": [
        "clocheton",
        "clocheter"
    ],
    "clochette": [
        "clochette"
    ],
    "clochettes": [
        "clochette"
    ],
    "clochat": [
        "clocher"
    ],
    "clodo": [
        "clodo"
    ],
    "clodos": [
        "clodo"
    ],
    "cloison": [
        "cloison"
    ],
    "cloisonnaient": [
        "cloisonner"
    ],
    "cloisonnais": [
        "cloisonner"
    ],
    "cloisonnant": [
        "cloisonner"
    ],
    "cloisonne": [
        "cloisonne",
        "cloisonner"
    ],
    "cloisonnement": [
        "cloisonnement"
    ],
    "cloisonnements": [
        "cloisonnement"
    ],
    "cloisonner": [
        "cloisonner"
    ],
    "cloisonnee": [
        "cloisonne",
        "cloisonner"
    ],
    "cloisonnees": [
        "cloisonne"
    ],
    "cloisonnes": [
        "cloisonne",
        "cloisonner"
    ],
    "cloisons": [
        "cloison"
    ],
    "clonage": [
        "clonage"
    ],
    "clonant": [
        "cloner"
    ],
    "clone": [
        "cloner",
        "clone"
    ],
    "clonent": [
        "cloner"
    ],
    "cloner": [
        "cloner"
    ],
    "clones": [
        "cloner",
        "clone"
    ],
    "clonique": [
        "clonique"
    ],
    "clopais": [
        "cloper"
    ],
    "clopant": [
        "cloper"
    ],
    "clope": [
        "clope",
        "cloper"
    ],
    "cloper": [
        "cloper"
    ],
    "clopes": [
        "clope",
        "cloper"
    ],
    "clopeur": [
        "clopeur"
    ],
    "clopina": [
        "clopiner"
    ],
    "clopinait": [
        "clopiner"
    ],
    "clopinant": [
        "clopiner"
    ],
    "clopine": [
        "clopiner"
    ],
    "clopinements": [
        "clopinement"
    ],
    "clopiner": [
        "clopiner"
    ],
    "clopinettes": [
        "clopinettes"
    ],
    "clopinez": [
        "clopiner"
    ],
    "clopinames": [
        "clopiner"
    ],
    "cloporte": [
        "cloporte"
    ],
    "cloportes": [
        "cloporte"
    ],
    "cloquait": [
        "cloquer"
    ],
    "cloquant": [
        "cloquer"
    ],
    "cloque": [
        "cloque",
        "cloquer"
    ],
    "cloquent": [
        "cloquer"
    ],
    "cloquer": [
        "cloquer"
    ],
    "cloques": [
        "cloque",
        "cloquer"
    ],
    "cloquee": [
        "cloque",
        "cloquer"
    ],
    "cloquees": [
        "cloquer"
    ],
    "clora": [
        "clore"
    ],
    "clore": [
        "clore"
    ],
    "clos": [
        "clo",
        "clore",
        "clos"
    ],
    "close": [
        "clore",
        "clos"
    ],
    "closent": [
        "clore"
    ],
    "closerie": [
        "closerie"
    ],
    "closes": [
        "close",
        "clore",
        "clos"
    ],
    "clou": [
        "clou"
    ],
    "cloua": [
        "clouer"
    ],
    "clouage": [
        "clouage"
    ],
    "clouai": [
        "clouer"
    ],
    "clouaient": [
        "clouer"
    ],
    "clouait": [
        "clouer"
    ],
    "clouant": [
        "clouer"
    ],
    "cloue": [
        "clouer",
        "cloue"
    ],
    "clouent": [
        "clouer"
    ],
    "clouer": [
        "clouer"
    ],
    "clouera": [
        "clouer"
    ],
    "clouerai": [
        "clouer"
    ],
    "cloueraient": [
        "clouer"
    ],
    "clouerait": [
        "clouer"
    ],
    "cloueras": [
        "clouer"
    ],
    "clouerez": [
        "clouer"
    ],
    "cloueur": [
        "cloueur"
    ],
    "cloueuse": [
        "cloueur"
    ],
    "clouez": [
        "clouer"
    ],
    "clouions": [
        "clouer"
    ],
    "clouons": [
        "clouer"
    ],
    "clous": [
        "clou"
    ],
    "cloutage": [
        "cloutage"
    ],
    "cloutier": [
        "cloutier"
    ],
    "cloute": [
        "cloute",
        "clouter"
    ],
    "cloutee": [
        "cloute",
        "clouter"
    ],
    "cloutees": [
        "cloute",
        "clouter"
    ],
    "cloutes": [
        "cloute",
        "clouter"
    ],
    "clouerent": [
        "clouer"
    ],
    "clouee": [
        "clouer",
        "cloue"
    ],
    "clouees": [
        "clouer",
        "cloue"
    ],
    "cloues": [
        "clouer",
        "cloue"
    ],
    "clown": [
        "clown"
    ],
    "clownerie": [
        "clownerie"
    ],
    "clowneries": [
        "clownerie"
    ],
    "clownesque": [
        "clownesque"
    ],
    "clownesques": [
        "clownesque"
    ],
    "clowns": [
        "clown"
    ],
    "cloitra": [
        "cloitrer"
    ],
    "cloitrai": [
        "cloitrer"
    ],
    "cloitraient": [
        "cloitrer"
    ],
    "cloitrait": [
        "cloitrer"
    ],
    "cloitrant": [
        "cloitrer"
    ],
    "cloitre": [
        "cloitre",
        "cloitrer"
    ],
    "cloitrer": [
        "cloitrer"
    ],
    "cloitres": [
        "cloitre",
        "cloitrer"
    ],
    "cloitrames": [
        "cloitrer"
    ],
    "cloitree": [
        "cloitre",
        "cloitrer"
    ],
    "cloitrees": [
        "cloitre",
        "cloitrer"
    ],
    "club": [
        "club"
    ],
    "clubhouse": [
        "clubhouse"
    ],
    "clubiste": [
        "clubiste"
    ],
    "clubman": [
        "clubman"
    ],
    "clubs": [
        "club"
    ],
    "clunisien": [
        "clunisien"
    ],
    "cluse": [
        "cluse"
    ],
    "cluses": [
        "cluse"
    ],
    "cluster": [
        "cluster"
    ],
    "clystere": [
        "clystere"
    ],
    "clysteres": [
        "clystere"
    ],
    "cle": [
        "cle"
    ],
    "clebard": [
        "clebard"
    ],
    "clebards": [
        "clebard"
    ],
    "clematite": [
        "clematite"
    ],
    "clematites": [
        "clematite"
    ],
    "clemence": [
        "clemence"
    ],
    "clement": [
        "clement"
    ],
    "clemente": [
        "clement"
    ],
    "clementes": [
        "clement"
    ],
    "clementine": [
        "clementine"
    ],
    "clements": [
        "clement"
    ],
    "clerical": [
        "clerical"
    ],
    "clericale": [
        "clerical"
    ],
    "clericales": [
        "clerical"
    ],
    "clericalisme": [
        "clericalisme"
    ],
    "clericature": [
        "clericature"
    ],
    "clericaux": [
        "clerical"
    ],
    "cles": [
        "cle"
    ],
    "clot": [
        "clore"
    ],
    "clotura": [
        "cloturer"
    ],
    "cloturai": [
        "cloturer"
    ],
    "cloturaient": [
        "cloturer"
    ],
    "cloturait": [
        "cloturer"
    ],
    "cloture": [
        "cloturer",
        "cloture"
    ],
    "cloturent": [
        "cloturer"
    ],
    "cloturer": [
        "cloturer"
    ],
    "cloturera": [
        "cloturer"
    ],
    "clotures": [
        "cloture"
    ],
    "cloturee": [
        "cloturer"
    ],
    "cm": [
        "cm"
    ],
    "co": [
        "co"
    ],
    "coaccuse": [
        "coaccuse"
    ],
    "coaccuses": [
        "coaccuse"
    ],
    "coach": [
        "coach"
    ],
    "coache": [
        "coacher"
    ],
    "coacher": [
        "coacher"
    ],
    "coaches": [
        "coach",
        "coache"
    ],
    "coachs": [
        "coach"
    ],
    "coactionnaires": [
        "coactionnaire"
    ],
    "coadjuteur": [
        "coadjuteur"
    ],
    "coagula": [
        "coaguler"
    ],
    "coagulaient": [
        "coaguler"
    ],
    "coagulait": [
        "coaguler"
    ],
    "coagulant": [
        "coaguler",
        "coagulant"
    ],
    "coagulantes": [
        "coagulant"
    ],
    "coagulants": [
        "coagulant"
    ],
    "coagulation": [
        "coagulation"
    ],
    "coagule": [
        "coaguler"
    ],
    "coagulent": [
        "coaguler"
    ],
    "coaguler": [
        "coaguler"
    ],
    "coagulera": [
        "coaguler"
    ],
    "coagulat": [
        "coaguler"
    ],
    "coagulee": [
        "coaguler"
    ],
    "coagulees": [
        "coaguler"
    ],
    "coagules": [
        "coaguler"
    ],
    "coalisaient": [
        "coaliser"
    ],
    "coalisent": [
        "coaliser"
    ],
    "coaliser": [
        "coaliser"
    ],
    "coalisee": [
        "coalise",
        "coaliser"
    ],
    "coalises": [
        "coalise",
        "coaliser"
    ],
    "coalition": [
        "coalition"
    ],
    "coalitions": [
        "coalition"
    ],
    "coaltar": [
        "coaltar"
    ],
    "coassaient": [
        "coasser"
    ],
    "coassant": [
        "coasser"
    ],
    "coasse": [
        "coasser"
    ],
    "coassement": [
        "coassement"
    ],
    "coassements": [
        "coassement"
    ],
    "coassent": [
        "coasser"
    ],
    "coasser": [
        "coasser"
    ],
    "coati": [
        "coati"
    ],
    "coauteur": [
        "coauteur"
    ],
    "coauteurs": [
        "coauteur"
    ],
    "coaxial": [
        "coaxial"
    ],
    "coaxiales": [
        "coaxial"
    ],
    "cob": [
        "cob"
    ],
    "cobalt": [
        "cobalt"
    ],
    "cobaye": [
        "cobaye"
    ],
    "cobayes": [
        "cobaye"
    ],
    "cobelligerants": [
        "cobelligerant"
    ],
    "cobol": [
        "cobol"
    ],
    "cobra": [
        "cobra"
    ],
    "cobras": [
        "cobra"
    ],
    "coca": [
        "coca"
    ],
    "cocagne": [
        "cocagne"
    ],
    "cocagnes": [
        "cocagne"
    ],
    "cocard": [
        "cocard"
    ],
    "cocardasse": [
        "cocarder"
    ],
    "cocarde": [
        "cocarde"
    ],
    "cocarder": [
        "cocarder"
    ],
    "cocardes": [
        "cocarder",
        "cocarde"
    ],
    "cocardier": [
        "cocardier"
    ],
    "cocardiers": [
        "cocardier"
    ],
    "cocardiere": [
        "cocardier"
    ],
    "cocardieres": [
        "cocardier"
    ],
    "cocards": [
        "cocard"
    ],
    "cocas": [
        "coca"
    ],
    "cocasse": [
        "cocasse"
    ],
    "cocassement": [
        "cocassement"
    ],
    "cocasserie": [
        "cocasserie"
    ],
    "cocasses": [
        "cocasse"
    ],
    "cocaine": [
        "cocaine"
    ],
    "cocainomane": [
        "cocainomane"
    ],
    "coccinelle": [
        "coccinelle"
    ],
    "coccinelles": [
        "coccinelle"
    ],
    "coccyx": [
        "coccyx"
    ],
    "cocha": [
        "cocher"
    ],
    "cochait": [
        "cocher"
    ],
    "cochant": [
        "cocher"
    ],
    "coche": [
        "cocher",
        "coche"
    ],
    "cochelet": [
        "cochelet"
    ],
    "cochenille": [
        "cochenille"
    ],
    "cochenilles": [
        "cochenille"
    ],
    "cocher": [
        "cocher"
    ],
    "cocheras": [
        "cocher"
    ],
    "cochers": [
        "cocher"
    ],
    "coches": [
        "cocher",
        "coche"
    ],
    "cochez": [
        "cocher"
    ],
    "cochleaire": [
        "cochleaire"
    ],
    "cochleaires": [
        "cochleaire"
    ],
    "cochlee": [
        "cochlee"
    ],
    "cochon": [
        "cochon"
    ],
    "cochoncete": [
        "cochoncete"
    ],
    "cochoncetes": [
        "cochoncete"
    ],
    "cochonnaille": [
        "cochonnaille"
    ],
    "cochonnailles": [
        "cochonnaille"
    ],
    "cochonne": [
        "cochon",
        "cochonner"
    ],
    "cochonner": [
        "cochonner"
    ],
    "cochonnerie": [
        "cochonnerie"
    ],
    "cochonneries": [
        "cochonnerie"
    ],
    "cochonnes": [
        "cochon"
    ],
    "cochonnet": [
        "cochonnet"
    ],
    "cochonnets": [
        "cochonnet"
    ],
    "cochonnez": [
        "cochonner"
    ],
    "cochonnee": [
        "cochonnee"
    ],
    "cochonnees": [
        "cochonnee",
        "cochonner"
    ],
    "cochons": [
        "cochon"
    ],
    "cochylis": [
        "cochylis"
    ],
    "cochat": [
        "cocher"
    ],
    "cochere": [
        "cocher"
    ],
    "cocheres": [
        "cocher"
    ],
    "cochee": [
        "cocher"
    ],
    "cochees": [
        "cocher"
    ],
    "cocker": [
        "cocker"
    ],
    "cockney": [
        "cockney"
    ],
    "cockneys": [
        "cockney"
    ],
    "cockpit": [
        "cockpit"
    ],
    "cocktail": [
        "cocktail"
    ],
    "cocktails": [
        "cocktail"
    ],
    "coco": [
        "coco"
    ],
    "cocolait": [
        "cocoler"
    ],
    "cocole": [
        "cocoler"
    ],
    "cocon": [
        "cocon"
    ],
    "cocons": [
        "cocon"
    ],
    "cocoon": [
        "cocoon"
    ],
    "cocorico": [
        "cocorico"
    ],
    "cocoricos": [
        "cocorico"
    ],
    "cocos": [
        "coco"
    ],
    "cocotent": [
        "cocoter"
    ],
    "cocoter": [
        "cocoter"
    ],
    "cocoteraies": [
        "cocoteraie"
    ],
    "cocoterait": [
        "cocoter"
    ],
    "cocotier": [
        "cocotier"
    ],
    "cocotiers": [
        "cocotier"
    ],
    "cocotte": [
        "cocotter",
        "cocotte"
    ],
    "cocottes": [
        "cocotte"
    ],
    "coction": [
        "coction"
    ],
    "cocu": [
        "cocu"
    ],
    "cocuage": [
        "cocuage"
    ],
    "cocuages": [
        "cocuage"
    ],
    "cocue": [
        "cocu"
    ],
    "cocues": [
        "cocu"
    ],
    "cocufiant": [
        "cocufier"
    ],
    "cocufie": [
        "cocufie",
        "cocufier"
    ],
    "cocufier": [
        "cocufier"
    ],
    "cocufiera": [
        "cocufier"
    ],
    "cocus": [
        "cocu"
    ],
    "coda": [
        "coda"
    ],
    "codage": [
        "codage"
    ],
    "codages": [
        "codage"
    ],
    "codait": [
        "coder"
    ],
    "codante": [
        "codant"
    ],
    "code": [
        "coder",
        "code"
    ],
    "coder": [
        "coder"
    ],
    "codes": [
        "coder",
        "code"
    ],
    "codeur": [
        "codeur"
    ],
    "codex": [
        "codex"
    ],
    "codicille": [
        "codicille"
    ],
    "codicilles": [
        "codicille"
    ],
    "codifia": [
        "codifier"
    ],
    "codifiait": [
        "codifier"
    ],
    "codifiant": [
        "codifier"
    ],
    "codification": [
        "codification"
    ],
    "codifier": [
        "codifier"
    ],
    "codifierent": [
        "codifier"
    ],
    "codifie": [
        "codifier"
    ],
    "codifiee": [
        "codifier"
    ],
    "codifiees": [
        "codifier"
    ],
    "codon": [
        "codon"
    ],
    "codee": [
        "coder",
        "code"
    ],
    "codees": [
        "coder",
        "code"
    ],
    "codeine": [
        "codeine"
    ],
    "codetenu": [
        "codetenu"
    ],
    "codetenus": [
        "codetenu"
    ],
    "coefficient": [
        "coefficient"
    ],
    "coefficients": [
        "coefficient"
    ],
    "coelacanthe": [
        "coelacanthe"
    ],
    "coeliaque": [
        "coeliaque"
    ],
    "coentreprise": [
        "coentreprise"
    ],
    "coenzyme": [
        "coenzyme"
    ],
    "coercitif": [
        "coercitif"
    ],
    "coercition": [
        "coercition"
    ],
    "coercitive": [
        "coercitif"
    ],
    "coeur": [
        "coeur"
    ],
    "coeurs": [
        "coeur"
    ],
    "coexistaient": [
        "coexister"
    ],
    "coexistait": [
        "coexister"
    ],
    "coexistant": [
        "coexister"
    ],
    "coexistants": [
        "coexistant"
    ],
    "coexiste": [
        "coexister"
    ],
    "coexistence": [
        "coexistence"
    ],
    "coexistent": [
        "coexister"
    ],
    "coexister": [
        "coexister"
    ],
    "coexisteront": [
        "coexister"
    ],
    "coexistez": [
        "coexister"
    ],
    "coexistons": [
        "coexister"
    ],
    "coffin": [
        "coffin"
    ],
    "coffio": [
        "coffio"
    ],
    "coffios": [
        "coffio"
    ],
    "coffiot": [
        "coffiot"
    ],
    "coffiots": [
        "coffiot"
    ],
    "coffrage": [
        "coffrage"
    ],
    "coffrages": [
        "coffrage"
    ],
    "coffraient": [
        "coffrer"
    ],
    "coffrait": [
        "coffrer"
    ],
    "coffre": [
        "coffrer",
        "coffre"
    ],
    "coffrent": [
        "coffrer"
    ],
    "coffrer": [
        "coffrer"
    ],
    "coffrera": [
        "coffrer"
    ],
    "coffrerai": [
        "coffrer"
    ],
    "coffrerais": [
        "coffrer"
    ],
    "coffrerons": [
        "coffrer"
    ],
    "coffreront": [
        "coffrer"
    ],
    "coffres": [
        "coffrer",
        "coffre"
    ],
    "coffret": [
        "coffret"
    ],
    "coffrets": [
        "coffret"
    ],
    "coffrez": [
        "coffrer"
    ],
    "coffrons": [
        "coffrer"
    ],
    "coffree": [
        "coffrer"
    ],
    "coffrees": [
        "coffrer"
    ],
    "cofinancement": [
        "cofinancement"
    ],
    "cofondateur": [
        "cofondateur"
    ],
    "cofondateurs": [
        "cofondateur"
    ],
    "cofondatrice": [
        "cofondateur"
    ],
    "cofonde": [
        "cofonde"
    ],
    "cogitais": [
        "cogiter"
    ],
    "cogitait": [
        "cogiter"
    ],
    "cogitant": [
        "cogiter"
    ],
    "cogitation": [
        "cogitation"
    ],
    "cogitations": [
        "cogitation"
    ],
    "cogite": [
        "cogiter"
    ],
    "cogitent": [
        "cogiter"
    ],
    "cogiter": [
        "cogiter"
    ],
    "cogito": [
        "cogito"
    ],
    "cogna": [
        "cogner"
    ],
    "cognac": [
        "cognac"
    ],
    "cognacs": [
        "cognac"
    ],
    "cognai": [
        "cogner"
    ],
    "cognaient": [
        "cogner"
    ],
    "cognais": [
        "cogner"
    ],
    "cognait": [
        "cogner"
    ],
    "cognant": [
        "cogner"
    ],
    "cognassier": [
        "cognassier"
    ],
    "cognassiers": [
        "cognassier"
    ],
    "cogne": [
        "cogne",
        "cogner"
    ],
    "cognement": [
        "cognement"
    ],
    "cognements": [
        "cognement"
    ],
    "cognent": [
        "cogner"
    ],
    "cogner": [
        "cogner"
    ],
    "cognera": [
        "cogner"
    ],
    "cognerai": [
        "cogner"
    ],
    "cogneraient": [
        "cogner"
    ],
    "cognerais": [
        "cogner"
    ],
    "cognerait": [
        "cogner"
    ],
    "cognerez": [
        "cogner"
    ],
    "cogneront": [
        "cogner"
    ],
    "cognes": [
        "cogne",
        "cogner"
    ],
    "cogneur": [
        "cogneur"
    ],
    "cogneurs": [
        "cogneur"
    ],
    "cogneuse": [
        "cogneur"
    ],
    "cognez": [
        "cogner"
    ],
    "cognitif": [
        "cognitif"
    ],
    "cognitifs": [
        "cognitif"
    ],
    "cognition": [
        "cognition"
    ],
    "cognitive": [
        "cognitif"
    ],
    "cognitives": [
        "cognitif"
    ],
    "cognons": [
        "cogner"
    ],
    "cognerent": [
        "cogner"
    ],
    "cognee": [
        "cognee",
        "cogner"
    ],
    "cognees": [
        "cognee",
        "cogner"
    ],
    "cogerant": [
        "cogerant"
    ],
    "cohabita": [
        "cohabiter"
    ],
    "cohabitaient": [
        "cohabiter"
    ],
    "cohabitait": [
        "cohabiter"
    ],
    "cohabitant": [
        "cohabitant"
    ],
    "cohabitation": [
        "cohabitation"
    ],
    "cohabitations": [
        "cohabitation"
    ],
    "cohabite": [
        "cohabiter"
    ],
    "cohabitent": [
        "cohabiter"
    ],
    "cohabiter": [
        "cohabiter"
    ],
    "cohabiteraient": [
        "cohabiter"
    ],
    "cohabitiez": [
        "cohabiter"
    ],
    "cohorte": [
        "cohorte"
    ],
    "cohortes": [
        "cohorte"
    ],
    "cohue": [
        "cohue"
    ],
    "cohues": [
        "cohue"
    ],
    "coherence": [
        "coherence"
    ],
    "coherences": [
        "coherence"
    ],
    "coherent": [
        "coherent"
    ],
    "coherente": [
        "coherent"
    ],
    "coherentes": [
        "coherent"
    ],
    "coherents": [
        "coherent"
    ],
    "coheritier": [
        "coheritier"
    ],
    "coheritiers": [
        "coheritier"
    ],
    "cohesion": [
        "cohesion"
    ],
    "cohesive": [
        "cohesif"
    ],
    "coi": [
        "coi"
    ],
    "coiffa": [
        "coiffer"
    ],
    "coiffai": [
        "coiffer"
    ],
    "coiffaient": [
        "coiffer"
    ],
    "coiffais": [
        "coiffer"
    ],
    "coiffait": [
        "coiffer"
    ],
    "coiffant": [
        "coiffant",
        "coiffer"
    ],
    "coiffante": [
        "coiffant"
    ],
    "coiffe": [
        "coiffe",
        "coiffer"
    ],
    "coiffent": [
        "coiffer"
    ],
    "coiffer": [
        "coiffer"
    ],
    "coiffera": [
        "coiffer"
    ],
    "coifferais": [
        "coiffer"
    ],
    "coifferait": [
        "coiffer"
    ],
    "coifferas": [
        "coiffer"
    ],
    "coifferont": [
        "coiffer"
    ],
    "coiffes": [
        "coiffe",
        "coiffer"
    ],
    "coiffeur": [
        "coiffeur"
    ],
    "coiffeurs": [
        "coiffeur"
    ],
    "coiffeuse": [
        "coiffeur"
    ],
    "coiffeuses": [
        "coiffeur"
    ],
    "coiffez": [
        "coiffer"
    ],
    "coiffiez": [
        "coiffer"
    ],
    "coiffure": [
        "coiffure"
    ],
    "coiffures": [
        "coiffure"
    ],
    "coiffat": [
        "coiffer"
    ],
    "coifferent": [
        "coiffer"
    ],
    "coiffee": [
        "coiffe",
        "coiffer"
    ],
    "coiffees": [
        "coiffe",
        "coiffer"
    ],
    "coin": [
        "coin"
    ],
    "coince": [
        "coince",
        "coincer"
    ],
    "coincent": [
        "coincer"
    ],
    "coincer": [
        "coincer"
    ],
    "coincera": [
        "coincer"
    ],
    "coincerai": [
        "coincer"
    ],
    "coincerais": [
        "coincer"
    ],
    "coincerait": [
        "coincer"
    ],
    "coinceriez": [
        "coincer"
    ],
    "coincerons": [
        "coincer"
    ],
    "coinceront": [
        "coincer"
    ],
    "coinces": [
        "coince",
        "coincer"
    ],
    "coinceur": [
        "coinceur"
    ],
    "coincez": [
        "coincer"
    ],
    "coincher": [
        "coincher"
    ],
    "coinciez": [
        "coincer"
    ],
    "coincerent": [
        "coincer"
    ],
    "coincee": [
        "coince",
        "coincer"
    ],
    "coincees": [
        "coince",
        "coincer"
    ],
    "coing": [
        "coing"
    ],
    "coings": [
        "coing"
    ],
    "coins": [
        "coin"
    ],
    "coinstot": [
        "coinstot"
    ],
    "coinstots": [
        "coinstot"
    ],
    "coinca": [
        "coincer"
    ],
    "coincage": [
        "coincage"
    ],
    "coincages": [
        "coincage"
    ],
    "coincaient": [
        "coincer"
    ],
    "coincais": [
        "coincer"
    ],
    "coincait": [
        "coincer"
    ],
    "coincant": [
        "coincer"
    ],
    "coincons": [
        "coincer"
    ],
    "coir": [
        "coir"
    ],
    "cois": [
        "coi"
    ],
    "coite": [
        "coi",
        "coiter"
    ],
    "coites": [
        "coi"
    ],
    "coke": [
        "coke"
    ],
    "cokes": [
        "coke"
    ],
    "col": [
        "col"
    ],
    "cola": [
        "cola"
    ],
    "colas": [
        "cola"
    ],
    "colback": [
        "colback"
    ],
    "colbacks": [
        "colback"
    ],
    "colchicine": [
        "colchicine"
    ],
    "colchique": [
        "colchique"
    ],
    "colchiques": [
        "colchique"
    ],
    "colcotar": [
        "colcotar"
    ],
    "cold": [
        "cold"
    ],
    "colectomie": [
        "colectomie"
    ],
    "colibacilles": [
        "colibacille"
    ],
    "colibri": [
        "colibri"
    ],
    "colibris": [
        "colibri"
    ],
    "colifichet": [
        "colifichet"
    ],
    "colifichets": [
        "colifichet"
    ],
    "colimacon": [
        "colimacon"
    ],
    "colimacons": [
        "colimacon"
    ],
    "colin": [
        "colin"
    ],
    "colique": [
        "colique"
    ],
    "coliques": [
        "colique"
    ],
    "colis": [
        "colis"
    ],
    "colistier": [
        "colistier"
    ],
    "colite": [
        "colite"
    ],
    "colites": [
        "colite"
    ],
    "colla": [
        "coller"
    ],
    "collabo": [
        "collabo"
    ],
    "collabora": [
        "collaborer"
    ],
    "collaborai": [
        "collaborer"
    ],
    "collaboraient": [
        "collaborer"
    ],
    "collaborais": [
        "collaborer"
    ],
    "collaborait": [
        "collaborer"
    ],
    "collaborant": [
        "collaborer"
    ],
    "collaborateur": [
        "collaborateur"
    ],
    "collaborateurs": [
        "collaborateur"
    ],
    "collaboration": [
        "collaboration"
    ],
    "collaborationniste": [
        "collaborationniste"
    ],
    "collaborationnistes": [
        "collaborationniste"
    ],
    "collaborations": [
        "collaboration"
    ],
    "collaboratrice": [
        "collaborateur"
    ],
    "collaboratrices": [
        "collaborateur"
    ],
    "collabore": [
        "collaborer"
    ],
    "collaborent": [
        "collaborer"
    ],
    "collaborer": [
        "collaborer"
    ],
    "collaborera": [
        "collaborer"
    ],
    "collaborerai": [
        "collaborer"
    ],
    "collaboreraient": [
        "collaborer"
    ],
    "collaborerez": [
        "collaborer"
    ],
    "collaborerons": [
        "collaborer"
    ],
    "collabores": [
        "collaborer"
    ],
    "collaborez": [
        "collaborer"
    ],
    "collaborions": [
        "collaborer"
    ],
    "collaborons": [
        "collaborer"
    ],
    "collabos": [
        "collabo"
    ],
    "collage": [
        "collage"
    ],
    "collages": [
        "collage"
    ],
    "collagene": [
        "collagene"
    ],
    "collai": [
        "coller"
    ],
    "collaient": [
        "coller"
    ],
    "collais": [
        "coller"
    ],
    "collait": [
        "coller"
    ],
    "collant": [
        "collant",
        "coller"
    ],
    "collante": [
        "collant"
    ],
    "collantes": [
        "collant"
    ],
    "collants": [
        "collant"
    ],
    "collapse": [
        "collapser"
    ],
    "collapserait": [
        "collapser"
    ],
    "collapsus": [
        "collapsus"
    ],
    "collas": [
        "coller"
    ],
    "collation": [
        "collation"
    ],
    "collationne": [
        "collationner"
    ],
    "collationnement": [
        "collationnement"
    ],
    "collationner": [
        "collationner"
    ],
    "collationnes": [
        "collationner"
    ],
    "collations": [
        "collation"
    ],
    "collateral": [
        "collateral"
    ],
    "collaterale": [
        "collateral"
    ],
    "collaterales": [
        "collateral"
    ],
    "collateraux": [
        "collateral"
    ],
    "colle": [
        "colle",
        "coller"
    ],
    "collectait": [
        "collecter"
    ],
    "collectant": [
        "collecter"
    ],
    "collecte": [
        "collecte",
        "collecter"
    ],
    "collecter": [
        "collecter"
    ],
    "collectes": [
        "collecte",
        "collecter"
    ],
    "collecteur": [
        "collecteur"
    ],
    "collecteurs": [
        "collecteur"
    ],
    "collectez": [
        "collecter"
    ],
    "collectif": [
        "collectif"
    ],
    "collectifs": [
        "collectif"
    ],
    "collection": [
        "collection"
    ],
    "collectionna": [
        "collectionner"
    ],
    "collectionnaient": [
        "collectionner"
    ],
    "collectionnais": [
        "collectionner"
    ],
    "collectionnait": [
        "collectionner"
    ],
    "collectionnant": [
        "collectionner"
    ],
    "collectionne": [
        "collectionner"
    ],
    "collectionnent": [
        "collectionner"
    ],
    "collectionner": [
        "collectionner"
    ],
    "collectionnes": [
        "collectionner"
    ],
    "collectionneur": [
        "collectionneur"
    ],
    "collectionneurs": [
        "collectionneur"
    ],
    "collectionneuse": [
        "collectionneur"
    ],
    "collectionnez": [
        "collectionner"
    ],
    "collectionnions": [
        "collectionner"
    ],
    "collectionnons": [
        "collectionner"
    ],
    "collectionnees": [
        "collectionner"
    ],
    "collections": [
        "collection"
    ],
    "collective": [
        "collectif"
    ],
    "collectivement": [
        "collectivement"
    ],
    "collectives": [
        "collectif",
        "collective"
    ],
    "collectivisation": [
        "collectivisation"
    ],
    "collectiviser": [
        "collectiviser"
    ],
    "collectivisme": [
        "collectivisme"
    ],
    "collectiviste": [
        "collectiviste"
    ],
    "collectivise": [
        "collectiviser"
    ],
    "collectivisee": [
        "collectiviser"
    ],
    "collectivises": [
        "collectiviser"
    ],
    "collectivite": [
        "collectivite"
    ],
    "collectivites": [
        "collectivite"
    ],
    "collectons": [
        "collecter"
    ],
    "collector": [
        "collector"
    ],
    "collectrice": [
        "collecteur"
    ],
    "collectee": [
        "collecter"
    ],
    "collectees": [
        "collecter"
    ],
    "collent": [
        "coller"
    ],
    "coller": [
        "coller"
    ],
    "collera": [
        "coller"
    ],
    "collerai": [
        "coller"
    ],
    "collerais": [
        "coller"
    ],
    "collerait": [
        "coller"
    ],
    "colleras": [
        "coller"
    ],
    "collerette": [
        "collerette"
    ],
    "collerettes": [
        "collerette"
    ],
    "collerez": [
        "coller"
    ],
    "colleront": [
        "coller"
    ],
    "colles": [
        "colle",
        "coller"
    ],
    "collet": [
        "collet"
    ],
    "colletage": [
        "colletage"
    ],
    "colleter": [
        "colleter"
    ],
    "colletin": [
        "colletin"
    ],
    "collets": [
        "collet"
    ],
    "collette": [
        "colleter"
    ],
    "collete": [
        "colleter"
    ],
    "colletes": [
        "colleter"
    ],
    "colleur": [
        "colleur"
    ],
    "colleurs": [
        "colleur"
    ],
    "colleuse": [
        "colleuse"
    ],
    "colley": [
        "colley"
    ],
    "colleys": [
        "colley"
    ],
    "collez": [
        "coller"
    ],
    "collier": [
        "collier"
    ],
    "colliers": [
        "collier"
    ],
    "colliez": [
        "coller"
    ],
    "collignon": [
        "collignon"
    ],
    "collimateur": [
        "collimateur"
    ],
    "collimation": [
        "collimation"
    ],
    "colline": [
        "colline"
    ],
    "collines": [
        "colline"
    ],
    "collions": [
        "coller"
    ],
    "collision": [
        "collision"
    ],
    "collisions": [
        "collision"
    ],
    "collodion": [
        "collodion"
    ],
    "collons": [
        "coller"
    ],
    "colloquant": [
        "colloquer"
    ],
    "colloque": [
        "colloquer",
        "colloque"
    ],
    "colloquer": [
        "colloquer"
    ],
    "colloques": [
        "colloque"
    ],
    "colloquee": [
        "colloquer"
    ],
    "colloidale": [
        "colloidal"
    ],
    "colloide": [
        "colloide"
    ],
    "collure": [
        "collure"
    ],
    "collusion": [
        "collusion"
    ],
    "collusions": [
        "collusion"
    ],
    "collutoire": [
        "collutoire"
    ],
    "collyre": [
        "collyre"
    ],
    "collyres": [
        "collyre"
    ],
    "college": [
        "college"
    ],
    "colleges": [
        "college"
    ],
    "collegue": [
        "collegue"
    ],
    "collegues": [
        "collegue"
    ],
    "collerent": [
        "coller"
    ],
    "collee": [
        "coller"
    ],
    "collees": [
        "coller"
    ],
    "collegial": [
        "collegial"
    ],
    "collegiale": [
        "collegiale",
        "collegial"
    ],
    "collegiales": [
        "collegial"
    ],
    "collegialite": [
        "collegialite"
    ],
    "collegiaux": [
        "collegial"
    ],
    "collegien": [
        "collegien"
    ],
    "collegienne": [
        "collegien"
    ],
    "collegiennes": [
        "collegien"
    ],
    "collegiens": [
        "collegien"
    ],
    "colmatage": [
        "colmatage"
    ],
    "colmataient": [
        "colmater"
    ],
    "colmatais": [
        "colmater"
    ],
    "colmatait": [
        "colmater"
    ],
    "colmatant": [
        "colmater"
    ],
    "colmate": [
        "colmater"
    ],
    "colmater": [
        "colmater"
    ],
    "colmatez": [
        "colmater"
    ],
    "colmatons": [
        "colmater"
    ],
    "colmatee": [
        "colmater"
    ],
    "colmatees": [
        "colmater"
    ],
    "colmates": [
        "colmater"
    ],
    "colo": [
        "colo"
    ],
    "colocataire": [
        "colocataire"
    ],
    "colocataires": [
        "colocataire"
    ],
    "colocation": [
        "colocation"
    ],
    "colombages": [
        "colombage"
    ],
    "colombe": [
        "colombe"
    ],
    "colombelle": [
        "colombelle"
    ],
    "colombes": [
        "colombe"
    ],
    "colombien": [
        "colombien"
    ],
    "colombienne": [
        "colombien"
    ],
    "colombiens": [
        "colombien"
    ],
    "colombier": [
        "colombier"
    ],
    "colombiers": [
        "colombier"
    ],
    "colombin": [
        "colombin"
    ],
    "colombine": [
        "colombin"
    ],
    "colombines": [
        "colombin"
    ],
    "colombins": [
        "colombin"
    ],
    "colombo": [
        "colombo"
    ],
    "colombophile": [
        "colombophile"
    ],
    "colombophilie": [
        "colombophilie"
    ],
    "colon": [
        "colon"
    ],
    "colonel": [
        "colonel"
    ],
    "colonelle": [
        "colonel"
    ],
    "colonels": [
        "colonel"
    ],
    "colonial": [
        "colonial"
    ],
    "coloniale": [
        "colonial"
    ],
    "coloniales": [
        "colonial"
    ],
    "colonialisme": [
        "colonialisme"
    ],
    "colonialismes": [
        "colonialisme"
    ],
    "colonialiste": [
        "colonialiste"
    ],
    "colonialistes": [
        "colonialiste"
    ],
    "coloniaux": [
        "colonial"
    ],
    "colonie": [
        "colonie"
    ],
    "colonies": [
        "colonie",
        "colony"
    ],
    "colonisait": [
        "coloniser"
    ],
    "colonisateur": [
        "colonisateur"
    ],
    "colonisateurs": [
        "colonisateur"
    ],
    "colonisation": [
        "colonisation"
    ],
    "colonisations": [
        "colonisation"
    ],
    "colonisatrice": [
        "colonisateur"
    ],
    "colonise": [
        "coloniser",
        "colonise"
    ],
    "colonisent": [
        "coloniser"
    ],
    "coloniser": [
        "coloniser"
    ],
    "coloniserait": [
        "coloniser"
    ],
    "colonisez": [
        "coloniser"
    ],
    "colonisons": [
        "coloniser"
    ],
    "coloniserent": [
        "coloniser"
    ],
    "colonisee": [
        "coloniser",
        "colonise"
    ],
    "colonisees": [
        "coloniser"
    ],
    "colonises": [
        "coloniser",
        "colonise"
    ],
    "colonnade": [
        "colonnade"
    ],
    "colonnades": [
        "colonnade"
    ],
    "colonne": [
        "colonne"
    ],
    "colonnes": [
        "colonne"
    ],
    "colonnette": [
        "colonnette"
    ],
    "colonnettes": [
        "colonnette"
    ],
    "colonoscopie": [
        "colonoscopie"
    ],
    "colons": [
        "colon"
    ],
    "colopathie": [
        "colopathie"
    ],
    "colophane": [
        "colophaner",
        "colophane"
    ],
    "coloquinte": [
        "coloquinte"
    ],
    "coloquintes": [
        "coloquinte"
    ],
    "colora": [
        "colorer"
    ],
    "colorai": [
        "colorer"
    ],
    "coloraient": [
        "colorer"
    ],
    "colorait": [
        "colorer"
    ],
    "colorant": [
        "colorer",
        "colorant"
    ],
    "colorantes": [
        "colorant"
    ],
    "colorants": [
        "colorant"
    ],
    "coloration": [
        "coloration"
    ],
    "colorations": [
        "coloration"
    ],
    "colorature": [
        "colorature"
    ],
    "colore": [
        "colorer",
        "colore"
    ],
    "colorectal": [
        "colorectal"
    ],
    "colorent": [
        "colorer"
    ],
    "colorer": [
        "colorer"
    ],
    "colorez": [
        "colorer"
    ],
    "coloriage": [
        "coloriage"
    ],
    "coloriages": [
        "coloriage"
    ],
    "coloriaient": [
        "colorier"
    ],
    "coloriait": [
        "colorier"
    ],
    "colorie": [
        "colorier"
    ],
    "colorient": [
        "colorier"
    ],
    "colorier": [
        "colorier"
    ],
    "coloriez": [
        "colorier"
    ],
    "coloris": [
        "coloris"
    ],
    "colorisation": [
        "colorisation"
    ],
    "coloriste": [
        "coloriste"
    ],
    "colorise": [
        "coloriser"
    ],
    "coloriee": [
        "colorier"
    ],
    "coloriees": [
        "colorier"
    ],
    "colories": [
        "colorier"
    ],
    "colorerent": [
        "colorer"
    ],
    "coloree": [
        "colorer",
        "colore"
    ],
    "colorees": [
        "colorer",
        "colore"
    ],
    "colores": [
        "colorer",
        "colore"
    ],
    "colos": [
        "colo"
    ],
    "coloscopie": [
        "coloscopie"
    ],
    "colossal": [
        "colossal"
    ],
    "colossale": [
        "colossal"
    ],
    "colossales": [
        "colossal"
    ],
    "colossaux": [
        "colossal"
    ],
    "colosse": [
        "colosse"
    ],
    "colosses": [
        "colosse"
    ],
    "colostomie": [
        "colostomie"
    ],
    "colostrum": [
        "colostrum"
    ],
    "colporta": [
        "colporter"
    ],
    "colportage": [
        "colportage"
    ],
    "colportaient": [
        "colporter"
    ],
    "colportait": [
        "colporter"
    ],
    "colportant": [
        "colporter"
    ],
    "colporte": [
        "colporter"
    ],
    "colportent": [
        "colporter"
    ],
    "colporter": [
        "colporter"
    ],
    "colportera": [
        "colporter"
    ],
    "colportes": [
        "colporter"
    ],
    "colporteur": [
        "colporteur"
    ],
    "colporteurs": [
        "colporteur"
    ],
    "colporteuse": [
        "colporteur"
    ],
    "colportons": [
        "colporter"
    ],
    "colportee": [
        "colporter"
    ],
    "colportees": [
        "colporter"
    ],
    "colposcopie": [
        "colposcopie"
    ],
    "cols": [
        "col"
    ],
    "colt": [
        "colt"
    ],
    "coltin": [
        "coltin"
    ],
    "coltina": [
        "coltiner"
    ],
    "coltinage": [
        "coltinage"
    ],
    "coltinages": [
        "coltinage"
    ],
    "coltinais": [
        "coltiner"
    ],
    "coltinait": [
        "coltiner"
    ],
    "coltinant": [
        "coltiner"
    ],
    "coltine": [
        "coltiner"
    ],
    "coltinent": [
        "coltiner"
    ],
    "coltiner": [
        "coltiner"
    ],
    "coltines": [
        "coltiner"
    ],
    "coltineur": [
        "coltineur"
    ],
    "coltinez": [
        "coltiner"
    ],
    "coltinee": [
        "coltiner"
    ],
    "colts": [
        "colt"
    ],
    "columbarium": [
        "columbarium"
    ],
    "colvert": [
        "colvert"
    ],
    "colverts": [
        "colvert"
    ],
    "colza": [
        "colza"
    ],
    "colzas": [
        "colza"
    ],
    "colere": [
        "colere"
    ],
    "coleres": [
        "colere"
    ],
    "colee": [
        "colee"
    ],
    "coleoptere": [
        "coleoptere"
    ],
    "coleopteres": [
        "coleoptere"
    ],
    "colerer": [
        "colerer"
    ],
    "colereuse": [
        "colereux"
    ],
    "colereusement": [
        "colereusement"
    ],
    "colereux": [
        "colereux"
    ],
    "colerique": [
        "colerique"
    ],
    "coleriques": [
        "colerique"
    ],
    "com": [
        "com"
    ],
    "coma": [
        "coma"
    ],
    "comac": [
        "comac"
    ],
    "comacs": [
        "comac"
    ],
    "comanche": [
        "comanche"
    ],
    "comandant": [
        "comandant"
    ],
    "comas": [
        "coma"
    ],
    "comateuse": [
        "comateux"
    ],
    "comateux": [
        "comateux"
    ],
    "combat": [
        "combat",
        "combattre"
    ],
    "combatif": [
        "combatif"
    ],
    "combatifs": [
        "combatif"
    ],
    "combative": [
        "combatif"
    ],
    "combativite": [
        "combativite"
    ],
    "combats": [
        "combat",
        "combattre"
    ],
    "combattaient": [
        "combattre"
    ],
    "combattais": [
        "combattre"
    ],
    "combattait": [
        "combattre"
    ],
    "combattant": [
        "combattre",
        "combattant"
    ],
    "combattante": [
        "combattant"
    ],
    "combattantes": [
        "combattant"
    ],
    "combattants": [
        "combattant"
    ],
    "combatte": [
        "combattre"
    ],
    "combattent": [
        "combattre"
    ],
    "combattes": [
        "combattre"
    ],
    "combattez": [
        "combattre"
    ],
    "combattiez": [
        "combattre"
    ],
    "combattions": [
        "combattre"
    ],
    "combattirent": [
        "combattre"
    ],
    "combattit": [
        "combattre"
    ],
    "combattons": [
        "combattre"
    ],
    "combattra": [
        "combattre"
    ],
    "combattrai": [
        "combattre"
    ],
    "combattraient": [
        "combattre"
    ],
    "combattrais": [
        "combattre"
    ],
    "combattrait": [
        "combattre"
    ],
    "combattras": [
        "combattre"
    ],
    "combattre": [
        "combattre"
    ],
    "combattrez": [
        "combattre"
    ],
    "combattriez": [
        "combattre"
    ],
    "combattrons": [
        "combattre"
    ],
    "combattront": [
        "combattre"
    ],
    "combattu": [
        "combattre"
    ],
    "combattue": [
        "combattre"
    ],
    "combattues": [
        "combattre"
    ],
    "combattus": [
        "combattre"
    ],
    "combe": [
        "combe"
    ],
    "combes": [
        "combe"
    ],
    "combette": [
        "combette"
    ],
    "combi": [
        "combi"
    ],
    "combien": [
        "combien"
    ],
    "combientieme": [
        "combientieme"
    ],
    "combina": [
        "combiner"
    ],
    "combinaient": [
        "combiner"
    ],
    "combinaison": [
        "combinaison"
    ],
    "combinaisons": [
        "combinaison"
    ],
    "combinait": [
        "combiner"
    ],
    "combinant": [
        "combiner"
    ],
    "combinard": [
        "combinard"
    ],
    "combinards": [
        "combinard"
    ],
    "combinat": [
        "combinat"
    ],
    "combinatoire": [
        "combinatoire"
    ],
    "combinatoires": [
        "combinatoire"
    ],
    "combine": [
        "combine",
        "combiner"
    ],
    "combinent": [
        "combiner"
    ],
    "combiner": [
        "combiner"
    ],
    "combineraient": [
        "combiner"
    ],
    "combinerait": [
        "combiner"
    ],
    "combinerons": [
        "combiner"
    ],
    "combines": [
        "combine",
        "combiner"
    ],
    "combinez": [
        "combiner"
    ],
    "combinons": [
        "combiner"
    ],
    "combinee": [
        "combine",
        "combiner"
    ],
    "combinees": [
        "combine",
        "combiner"
    ],
    "combis": [
        "combi"
    ],
    "combisme": [
        "combisme"
    ],
    "combla": [
        "combler"
    ],
    "comblaient": [
        "combler"
    ],
    "comblais": [
        "combler"
    ],
    "comblait": [
        "combler"
    ],
    "comblant": [
        "combler",
        "comblant"
    ],
    "comblants": [
        "comblant"
    ],
    "comble": [
        "combler",
        "comble"
    ],
    "comblent": [
        "combler"
    ],
    "combler": [
        "combler"
    ],
    "comblera": [
        "combler"
    ],
    "comblerai": [
        "combler"
    ],
    "combleraient": [
        "combler"
    ],
    "comblerais": [
        "combler"
    ],
    "comblerait": [
        "combler"
    ],
    "comblerez": [
        "combler"
    ],
    "combleront": [
        "combler"
    ],
    "combles": [
        "combler",
        "comble"
    ],
    "comblez": [
        "combler"
    ],
    "comblons": [
        "combler"
    ],
    "comblat": [
        "combler"
    ],
    "comblerent": [
        "combler"
    ],
    "comblee": [
        "combler",
        "comble"
    ],
    "comblees": [
        "combler",
        "comble"
    ],
    "combo": [
        "combo"
    ],
    "combourgeois": [
        "combourgeois"
    ],
    "comburant": [
        "comburant"
    ],
    "combustible": [
        "combustible"
    ],
    "combustibles": [
        "combustible"
    ],
    "combustion": [
        "combustion"
    ],
    "combustions": [
        "combustion"
    ],
    "comestibilite": [
        "comestibilite"
    ],
    "comestible": [
        "comestible"
    ],
    "comestibles": [
        "comestible"
    ],
    "comice": [
        "comice"
    ],
    "comices": [
        "comice"
    ],
    "comics": [
        "comic",
        "comics"
    ],
    "comique": [
        "comique"
    ],
    "comiquement": [
        "comiquement"
    ],
    "comiques": [
        "comique"
    ],
    "comitadji": [
        "comitadji"
    ],
    "comite": [
        "comite"
    ],
    "comites": [
        "comite"
    ],
    "comma": [
        "comma"
    ],
    "command": [
        "command"
    ],
    "commanda": [
        "commander"
    ],
    "commandai": [
        "commander"
    ],
    "commandaient": [
        "commander"
    ],
    "commandais": [
        "commander"
    ],
    "commandait": [
        "commander"
    ],
    "commandant": [
        "commandant",
        "commander"
    ],
    "commandante": [
        "commandant"
    ],
    "commandants": [
        "commandant"
    ],
    "commande": [
        "commander",
        "commande"
    ],
    "commandement": [
        "commandement"
    ],
    "commandements": [
        "commandement"
    ],
    "commandent": [
        "commander"
    ],
    "commander": [
        "commander"
    ],
    "commandera": [
        "commander"
    ],
    "commanderai": [
        "commander"
    ],
    "commanderait": [
        "commander"
    ],
    "commanderas": [
        "commander"
    ],
    "commanderez": [
        "commander"
    ],
    "commanderie": [
        "commanderie"
    ],
    "commanderies": [
        "commanderie"
    ],
    "commanderons": [
        "commander"
    ],
    "commanderont": [
        "commander"
    ],
    "commandes": [
        "commander",
        "commande"
    ],
    "commandeur": [
        "commandeur"
    ],
    "commandeurs": [
        "commandeur"
    ],
    "commandez": [
        "commander"
    ],
    "commandiez": [
        "commander"
    ],
    "commandions": [
        "commander"
    ],
    "commanditaire": [
        "commanditaire"
    ],
    "commanditaires": [
        "commanditaire"
    ],
    "commandite": [
        "commanditer",
        "commandite"
    ],
    "commanditer": [
        "commanditer"
    ],
    "commandites": [
        "commanditer",
        "commandite"
    ],
    "commanditee": [
        "commanditer"
    ],
    "commanditees": [
        "commanditer"
    ],
    "commando": [
        "commando"
    ],
    "commandons": [
        "commander"
    ],
    "commandos": [
        "commando"
    ],
    "commandat": [
        "commander"
    ],
    "commanderent": [
        "commander"
    ],
    "commandee": [
        "commander",
        "commande"
    ],
    "commandees": [
        "commander",
        "commande"
    ],
    "comme": [
        "comme"
    ],
    "commence": [
        "commencer"
    ],
    "commencement": [
        "commencement"
    ],
    "commencements": [
        "commencement"
    ],
    "commencent": [
        "commencer"
    ],
    "commencer": [
        "commencer"
    ],
    "commencera": [
        "commencer"
    ],
    "commencerai": [
        "commencer"
    ],
    "commenceraient": [
        "commencer"
    ],
    "commencerais": [
        "commencer"
    ],
    "commencerait": [
        "commencer"
    ],
    "commenceras": [
        "commencer"
    ],
    "commencerez": [
        "commencer"
    ],
    "commenceriez": [
        "commencer"
    ],
    "commencerions": [
        "commencer"
    ],
    "commencerons": [
        "commencer"
    ],
    "commenceront": [
        "commencer"
    ],
    "commences": [
        "commencer",
        "commence"
    ],
    "commencez": [
        "commencer"
    ],
    "commenciez": [
        "commencer"
    ],
    "commencions": [
        "commencer"
    ],
    "commencerent": [
        "commencer"
    ],
    "commencee": [
        "commencer"
    ],
    "commencees": [
        "commencer"
    ],
    "commensal": [
        "commensal"
    ],
    "commensalisme": [
        "commensalisme"
    ],
    "commensaux": [
        "commensal"
    ],
    "commensurable": [
        "commensurable"
    ],
    "commensurables": [
        "commensurable"
    ],
    "comment": [
        "comment"
    ],
    "commenta": [
        "commenter"
    ],
    "commentai": [
        "commenter"
    ],
    "commentaient": [
        "commenter"
    ],
    "commentaire": [
        "commentaire"
    ],
    "commentaires": [
        "commentaire"
    ],
    "commentais": [
        "commenter"
    ],
    "commentait": [
        "commenter"
    ],
    "commentant": [
        "commenter"
    ],
    "commentateur": [
        "commentateur"
    ],
    "commentateurs": [
        "commentateur"
    ],
    "commentatrice": [
        "commentateur"
    ],
    "commente": [
        "commenter"
    ],
    "commentent": [
        "commenter"
    ],
    "commenter": [
        "commenter"
    ],
    "commentera": [
        "commenter"
    ],
    "commenterai": [
        "commenter"
    ],
    "commenterait": [
        "commenter"
    ],
    "commentez": [
        "commenter"
    ],
    "commentions": [
        "commenter"
    ],
    "commentee": [
        "commenter"
    ],
    "commentees": [
        "commenter"
    ],
    "commentes": [
        "commenter"
    ],
    "commenca": [
        "commencer"
    ],
    "commencai": [
        "commencer"
    ],
    "commencaient": [
        "commencer"
    ],
    "commencais": [
        "commencer"
    ],
    "commencait": [
        "commencer"
    ],
    "commencant": [
        "commencer",
        "commencant"
    ],
    "commencante": [
        "commencant"
    ],
    "commencantes": [
        "commencant"
    ],
    "commencants": [
        "commencant"
    ],
    "commencas": [
        "commencer"
    ],
    "commencons": [
        "commencer"
    ],
    "commencames": [
        "commencer"
    ],
    "commencat": [
        "commencer"
    ],
    "commerce": [
        "commerce",
        "commercer"
    ],
    "commercent": [
        "commercer"
    ],
    "commercer": [
        "commercer"
    ],
    "commerces": [
        "commerce"
    ],
    "commercial": [
        "commercial"
    ],
    "commerciale": [
        "commercial"
    ],
    "commercialement": [
        "commercialement"
    ],
    "commerciales": [
        "commercial"
    ],
    "commercialisable": [
        "commercialisable"
    ],
    "commercialisation": [
        "commercialisation"
    ],
    "commercialiser": [
        "commercialiser"
    ],
    "commercialisera": [
        "commercialiser"
    ],
    "commercialise": [
        "commercialiser"
    ],
    "commerciaux": [
        "commercial"
    ],
    "commerciez": [
        "commercer"
    ],
    "commercait": [
        "commercer"
    ],
    "commercant": [
        "commercer",
        "commercant"
    ],
    "commercante": [
        "commercant"
    ],
    "commercantes": [
        "commercant"
    ],
    "commercants": [
        "commercant"
    ],
    "commercons": [
        "commercer"
    ],
    "commet": [
        "commettre"
    ],
    "commets": [
        "commettre"
    ],
    "commettaient": [
        "commettre"
    ],
    "commettais": [
        "commettre"
    ],
    "commettait": [
        "commettre"
    ],
    "commettant": [
        "commettant",
        "commettre"
    ],
    "commettants": [
        "commettant"
    ],
    "commette": [
        "commettre"
    ],
    "commettent": [
        "commettre"
    ],
    "commettes": [
        "commettre"
    ],
    "commettez": [
        "commettre"
    ],
    "commettiez": [
        "commettre"
    ],
    "commettions": [
        "commettre"
    ],
    "commettons": [
        "commettre"
    ],
    "commettra": [
        "commettre"
    ],
    "commettrai": [
        "commettre"
    ],
    "commettraient": [
        "commettre"
    ],
    "commettrais": [
        "commettre"
    ],
    "commettrait": [
        "commettre"
    ],
    "commettras": [
        "commettre"
    ],
    "commettre": [
        "commettre"
    ],
    "commettrez": [
        "commettre"
    ],
    "comminatoire": [
        "comminatoire"
    ],
    "comminatoires": [
        "comminatoire"
    ],
    "comminutive": [
        "comminutif"
    ],
    "commirent": [
        "commettre"
    ],
    "commis": [
        "commis",
        "commettre"
    ],
    "commise": [
        "commettre"
    ],
    "commises": [
        "commettre"
    ],
    "commissaire": [
        "commissaire"
    ],
    "commissaires": [
        "commissaire"
    ],
    "commissariat": [
        "commissariat"
    ],
    "commissariats": [
        "commissariat"
    ],
    "commission": [
        "commission"
    ],
    "commissionnaire": [
        "commissionnaire"
    ],
    "commissionnaires": [
        "commissionnaire"
    ],
    "commissionne": [
        "commissionner"
    ],
    "commissions": [
        "commission"
    ],
    "commissurale": [
        "commissural"
    ],
    "commissure": [
        "commissure"
    ],
    "commissures": [
        "commissure"
    ],
    "commiseration": [
        "commiseration"
    ],
    "commit": [
        "commettre"
    ],
    "commode": [
        "commode"
    ],
    "commodes": [
        "commode"
    ],
    "commodite": [
        "commodite"
    ],
    "commodites": [
        "commodite"
    ],
    "commodore": [
        "commodore"
    ],
    "commodores": [
        "commodore"
    ],
    "commodement": [
        "commodement"
    ],
    "commotion": [
        "commotion"
    ],
    "commotionnerait": [
        "commotionner"
    ],
    "commotionne": [
        "commotionner"
    ],
    "commotionnee": [
        "commotionner"
    ],
    "commotionnes": [
        "commotionner"
    ],
    "commotions": [
        "commotion"
    ],
    "commuais": [
        "commuer"
    ],
    "commuant": [
        "commuer"
    ],
    "commuent": [
        "commuer"
    ],
    "commuer": [
        "commuer"
    ],
    "commun": [
        "commun"
    ],
    "communal": [
        "communal"
    ],
    "communale": [
        "communal"
    ],
    "communales": [
        "communal"
    ],
    "communard": [
        "communard"
    ],
    "communards": [
        "communard"
    ],
    "communautaire": [
        "communautaire"
    ],
    "communautaires": [
        "communautaire"
    ],
    "communaute": [
        "communaute"
    ],
    "communautes": [
        "communaute"
    ],
    "communaux": [
        "communal"
    ],
    "commune": [
        "commun",
        "commune"
    ],
    "communes": [
        "commun",
        "commune"
    ],
    "communia": [
        "communier"
    ],
    "communiaient": [
        "communier"
    ],
    "communiais": [
        "communier"
    ],
    "communiait": [
        "communier"
    ],
    "communiant": [
        "communiant",
        "communier"
    ],
    "communiante": [
        "communiant"
    ],
    "communiantes": [
        "communiant"
    ],
    "communiants": [
        "communiant"
    ],
    "communiasse": [
        "communier"
    ],
    "communicabilite": [
        "communicabilite"
    ],
    "communicable": [
        "communicable"
    ],
    "communicables": [
        "communicable"
    ],
    "communicant": [
        "communicant"
    ],
    "communicante": [
        "communicant"
    ],
    "communicantes": [
        "communicant"
    ],
    "communicants": [
        "communicant"
    ],
    "communicateur": [
        "communicateur"
    ],
    "communicateurs": [
        "communicateur"
    ],
    "communicatif": [
        "communicatif"
    ],
    "communicatifs": [
        "communicatif"
    ],
    "communication": [
        "communication"
    ],
    "communications": [
        "communication"
    ],
    "communicative": [
        "communicatif"
    ],
    "communie": [
        "communier"
    ],
    "communient": [
        "communier"
    ],
    "communier": [
        "communier"
    ],
    "communierons": [
        "communier"
    ],
    "communieront": [
        "communier"
    ],
    "communiez": [
        "communier"
    ],
    "communion": [
        "communion"
    ],
    "communions": [
        "communion",
        "communier"
    ],
    "communiqua": [
        "communiquer"
    ],
    "communiquai": [
        "communiquer"
    ],
    "communiquaient": [
        "communiquer"
    ],
    "communiquais": [
        "communiquer"
    ],
    "communiquait": [
        "communiquer"
    ],
    "communiquant": [
        "communiquer"
    ],
    "communiquassent": [
        "communiquer"
    ],
    "communique": [
        "communiquer",
        "communique"
    ],
    "communiquent": [
        "communiquer"
    ],
    "communiquer": [
        "communiquer"
    ],
    "communiquera": [
        "communiquer"
    ],
    "communiquerai": [
        "communiquer"
    ],
    "communiqueraient": [
        "communiquer"
    ],
    "communiquerait": [
        "communiquer"
    ],
    "communiquerez": [
        "communiquer"
    ],
    "communiquerons": [
        "communiquer"
    ],
    "communiqueront": [
        "communiquer"
    ],
    "communiques": [
        "communiquer",
        "communique"
    ],
    "communiquez": [
        "communiquer"
    ],
    "communiquiez": [
        "communiquer"
    ],
    "communiquions": [
        "communiquer"
    ],
    "communiquons": [
        "communiquer"
    ],
    "communiquat": [
        "communiquer"
    ],
    "communiquerent": [
        "communiquer"
    ],
    "communiquee": [
        "communiquer"
    ],
    "communiquees": [
        "communiquer"
    ],
    "communisant": [
        "communisant"
    ],
    "communisants": [
        "communisant"
    ],
    "communisme": [
        "communisme"
    ],
    "communiste": [
        "communiste"
    ],
    "communistes": [
        "communiste"
    ],
    "communisee": [
        "communiser"
    ],
    "communierent": [
        "communier"
    ],
    "communs": [
        "commun"
    ],
    "communement": [
        "communement"
    ],
    "commutateur": [
        "commutateur"
    ],
    "commutateurs": [
        "commutateur"
    ],
    "commutation": [
        "commutation"
    ],
    "commute": [
        "commuter"
    ],
    "commuter": [
        "commuter"
    ],
    "commue": [
        "commuer"
    ],
    "commuee": [
        "commuer"
    ],
    "commere": [
        "commere"
    ],
    "commeres": [
        "commere"
    ],
    "commemorait": [
        "commemorer"
    ],
    "commemorant": [
        "commemorer"
    ],
    "commemoratif": [
        "commemoratif"
    ],
    "commemoratifs": [
        "commemoratif"
    ],
    "commemoration": [
        "commemoration"
    ],
    "commemorations": [
        "commemoration"
    ],
    "commemorative": [
        "commemoratif"
    ],
    "commemoratives": [
        "commemorative",
        "commemoratif"
    ],
    "commemore": [
        "commemorer"
    ],
    "commemorent": [
        "commemorer"
    ],
    "commemorer": [
        "commemorer"
    ],
    "commemorions": [
        "commemorer"
    ],
    "commemorons": [
        "commemorer"
    ],
    "commerage": [
        "commerage"
    ],
    "commerages": [
        "commerage"
    ],
    "commerait": [
        "commerer"
    ],
    "commerer": [
        "commerer"
    ],
    "comnene": [
        "comnene"
    ],
    "compacite": [
        "compacite"
    ],
    "compact": [
        "compact"
    ],
    "compactage": [
        "compactage"
    ],
    "compacte": [
        "compacter",
        "compact"
    ],
    "compactes": [
        "compact"
    ],
    "compacteur": [
        "compacteur"
    ],
    "compacteurs": [
        "compacteur"
    ],
    "compacts": [
        "compact"
    ],
    "compadre": [
        "compadre"
    ],
    "compadres": [
        "compadre"
    ],
    "compagne": [
        "compagnon"
    ],
    "compagnes": [
        "compagnon"
    ],
    "compagnie": [
        "compagnie"
    ],
    "compagnies": [
        "compagnie"
    ],
    "compagnon": [
        "compagnon"
    ],
    "compagnonnage": [
        "compagnonnage"
    ],
    "compagnonnages": [
        "compagnonnage"
    ],
    "compagnonnes": [
        "compagnon"
    ],
    "compagnons": [
        "compagnon"
    ],
    "compara": [
        "comparer"
    ],
    "comparabilite": [
        "comparabilite"
    ],
    "comparable": [
        "comparable"
    ],
    "comparables": [
        "comparable"
    ],
    "comparai": [
        "comparer"
    ],
    "comparaient": [
        "comparer"
    ],
    "comparais": [
        "comparer",
        "comparaitre"
    ],
    "comparaison": [
        "comparaison"
    ],
    "comparaisons": [
        "comparaison"
    ],
    "comparaissaient": [
        "comparaitre"
    ],
    "comparaissait": [
        "comparaitre"
    ],
    "comparaissant": [
        "comparaitre"
    ],
    "comparaissent": [
        "comparaitre"
    ],
    "comparaisses": [
        "comparaitre"
    ],
    "comparaissons": [
        "comparaitre"
    ],
    "comparait": [
        "comparaitre",
        "comparer"
    ],
    "comparant": [
        "comparer",
        "comparant"
    ],
    "comparateur": [
        "comparateur"
    ],
    "comparatif": [
        "comparatif"
    ],
    "comparatifs": [
        "comparatif"
    ],
    "comparative": [
        "comparatif"
    ],
    "comparativement": [
        "comparativement"
    ],
    "comparatives": [
        "comparative",
        "comparatif"
    ],
    "comparaitra": [
        "comparaitre"
    ],
    "comparaitrait": [
        "comparaitre"
    ],
    "comparaitre": [
        "comparaitre"
    ],
    "comparaitrez": [
        "comparaitre"
    ],
    "comparaitrons": [
        "comparaitre"
    ],
    "compare": [
        "compare",
        "comparer"
    ],
    "comparent": [
        "comparer"
    ],
    "comparer": [
        "comparer"
    ],
    "comparera": [
        "comparer"
    ],
    "comparerai": [
        "comparer"
    ],
    "comparerais": [
        "comparer"
    ],
    "comparerons": [
        "comparer"
    ],
    "compareront": [
        "comparer"
    ],
    "compares": [
        "compare",
        "comparer"
    ],
    "comparez": [
        "comparer"
    ],
    "compariez": [
        "comparer"
    ],
    "comparions": [
        "comparer"
    ],
    "comparoir": [
        "comparoir"
    ],
    "comparons": [
        "comparer"
    ],
    "comparse": [
        "comparse"
    ],
    "comparses": [
        "comparse"
    ],
    "compartiment": [
        "compartiment"
    ],
    "compartimentage": [
        "compartimentage"
    ],
    "compartimentaient": [
        "compartimenter"
    ],
    "compartimentant": [
        "compartimenter"
    ],
    "compartimente": [
        "compartimenter",
        "compartimente"
    ],
    "compartimenter": [
        "compartimenter"
    ],
    "compartiments": [
        "compartiment"
    ],
    "compartimentee": [
        "compartimenter",
        "compartimente"
    ],
    "comparu": [
        "comparaitre"
    ],
    "comparut": [
        "comparaitre"
    ],
    "comparution": [
        "comparution"
    ],
    "comparee": [
        "compare",
        "comparer"
    ],
    "comparees": [
        "compare",
        "comparer"
    ],
    "compas": [
        "compas"
    ],
    "compassion": [
        "compassion"
    ],
    "compasse": [
        "compasser",
        "compasse"
    ],
    "compassee": [
        "compasser",
        "compasse"
    ],
    "compassees": [
        "compasse"
    ],
    "compasses": [
        "compasser",
        "compass",
        "compasse"
    ],
    "compati": [
        "compatir"
    ],
    "compatibilite": [
        "compatibilite"
    ],
    "compatible": [
        "compatible"
    ],
    "compatibles": [
        "compatible"
    ],
    "compatie": [
        "compatir"
    ],
    "compatir": [
        "compatir"
    ],
    "compatira": [
        "compatir"
    ],
    "compatirait": [
        "compatir"
    ],
    "compatirent": [
        "compatir"
    ],
    "compatis": [
        "compatir"
    ],
    "compatissaient": [
        "compatir"
    ],
    "compatissais": [
        "compatir"
    ],
    "compatissait": [
        "compatir"
    ],
    "compatissant": [
        "compatir",
        "compatissant"
    ],
    "compatissante": [
        "compatissant"
    ],
    "compatissantes": [
        "compatissant"
    ],
    "compatissants": [
        "compatissant"
    ],
    "compatisse": [
        "compatir"
    ],
    "compatissent": [
        "compatir"
    ],
    "compatissez": [
        "compatir"
    ],
    "compatissons": [
        "compatir"
    ],
    "compatit": [
        "compatir"
    ],
    "compatriote": [
        "compatriote"
    ],
    "compatriotes": [
        "compatriote"
    ],
    "compendium": [
        "compendium"
    ],
    "compendiums": [
        "compendium"
    ],
    "compensa": [
        "compenser"
    ],
    "compensaient": [
        "compenser"
    ],
    "compensais": [
        "compenser"
    ],
    "compensait": [
        "compenser"
    ],
    "compensant": [
        "compenser"
    ],
    "compensateur": [
        "compensateur"
    ],
    "compensateurs": [
        "compensateur"
    ],
    "compensation": [
        "compensation"
    ],
    "compensations": [
        "compensation"
    ],
    "compensatoire": [
        "compensatoire"
    ],
    "compense": [
        "compenser",
        "compense"
    ],
    "compensent": [
        "compenser"
    ],
    "compenser": [
        "compenser"
    ],
    "compensera": [
        "compenser"
    ],
    "compenserais": [
        "compenser"
    ],
    "compenserait": [
        "compenser"
    ],
    "compensez": [
        "compenser"
    ],
    "compensat": [
        "compenser"
    ],
    "compenserent": [
        "compenser"
    ],
    "compensee": [
        "compenser",
        "compense"
    ],
    "compensees": [
        "compenser",
        "compense"
    ],
    "compenses": [
        "compenser",
        "compense"
    ],
    "compil": [
        "compil"
    ],
    "compilant": [
        "compiler"
    ],
    "compilateur": [
        "compilateur"
    ],
    "compilation": [
        "compilation"
    ],
    "compilations": [
        "compilation"
    ],
    "compile": [
        "compiler"
    ],
    "compiler": [
        "compiler"
    ],
    "compilons": [
        "compiler"
    ],
    "compilees": [
        "compiler"
    ],
    "compissait": [
        "compisser"
    ],
    "compisse": [
        "compisser"
    ],
    "compisser": [
        "compisser"
    ],
    "complainte": [
        "complainte"
    ],
    "complaintes": [
        "complainte"
    ],
    "complairait": [
        "complaire"
    ],
    "complaire": [
        "complaire"
    ],
    "complais": [
        "complaire"
    ],
    "complaisaient": [
        "complaire"
    ],
    "complaisais": [
        "complaire"
    ],
    "complaisait": [
        "complaire"
    ],
    "complaisamment": [
        "complaisamment"
    ],
    "complaisance": [
        "complaisance"
    ],
    "complaisances": [
        "complaisance"
    ],
    "complaisant": [
        "complaisant",
        "complaire"
    ],
    "complaisante": [
        "complaisant"
    ],
    "complaisantes": [
        "complaisant"
    ],
    "complaisants": [
        "complaisant"
    ],
    "complaise": [
        "complaire"
    ],
    "complaisent": [
        "complaire"
    ],
    "complaisez": [
        "complaire"
    ],
    "complaisiez": [
        "complaire"
    ],
    "complait": [
        "complaire"
    ],
    "complet": [
        "complet"
    ],
    "complets": [
        "complet"
    ],
    "complexait": [
        "complexer"
    ],
    "complexe": [
        "complexe",
        "complexer"
    ],
    "complexer": [
        "complexer"
    ],
    "complexes": [
        "complexe",
        "complexer",
        "complex"
    ],
    "complexion": [
        "complexion"
    ],
    "complexite": [
        "complexite"
    ],
    "complexites": [
        "complexite"
    ],
    "complexee": [
        "complexe",
        "complexer"
    ],
    "complication": [
        "complication"
    ],
    "complications": [
        "complication"
    ],
    "complice": [
        "complice"
    ],
    "complices": [
        "complice"
    ],
    "complicite": [
        "complicite"
    ],
    "complicites": [
        "complicite"
    ],
    "complies": [
        "complies",
        "comply"
    ],
    "compliment": [
        "compliment"
    ],
    "complimenta": [
        "complimenter"
    ],
    "complimentaient": [
        "complimenter"
    ],
    "complimentais": [
        "complimenter"
    ],
    "complimentait": [
        "complimenter"
    ],
    "complimentant": [
        "complimenter"
    ],
    "complimente": [
        "complimenter"
    ],
    "complimentent": [
        "complimenter"
    ],
    "complimenter": [
        "complimenter"
    ],
    "complimenteraient": [
        "complimenter"
    ],
    "complimentez": [
        "complimenter"
    ],
    "compliments": [
        "compliment"
    ],
    "complimentat": [
        "complimenter"
    ],
    "complimentee": [
        "complimenter"
    ],
    "compliqua": [
        "compliquer"
    ],
    "compliquaient": [
        "compliquer"
    ],
    "compliquais": [
        "compliquer"
    ],
    "compliquait": [
        "compliquer"
    ],
    "compliquant": [
        "compliquer"
    ],
    "complique": [
        "compliquer",
        "complique"
    ],
    "compliquent": [
        "compliquer"
    ],
    "compliquer": [
        "compliquer"
    ],
    "compliquera": [
        "compliquer"
    ],
    "compliquerai": [
        "compliquer"
    ],
    "compliquerait": [
        "compliquer"
    ],
    "compliques": [
        "compliquer",
        "complique"
    ],
    "compliquez": [
        "compliquer"
    ],
    "compliquions": [
        "compliquer"
    ],
    "compliquons": [
        "compliquer"
    ],
    "compliquerent": [
        "compliquer"
    ],
    "compliquee": [
        "compliquer",
        "complique"
    ],
    "compliquees": [
        "compliquer",
        "complique"
    ],
    "complot": [
        "complot"
    ],
    "complotai": [
        "comploter"
    ],
    "complotaient": [
        "comploter"
    ],
    "complotais": [
        "comploter"
    ],
    "complotait": [
        "comploter"
    ],
    "complotant": [
        "comploter"
    ],
    "complote": [
        "comploter"
    ],
    "complotent": [
        "comploter"
    ],
    "comploter": [
        "comploter"
    ],
    "comploteraient": [
        "comploter"
    ],
    "comploterait": [
        "comploter"
    ],
    "complotes": [
        "comploter"
    ],
    "comploteur": [
        "comploteur"
    ],
    "comploteurs": [
        "comploteur"
    ],
    "comploteuse": [
        "comploteur"
    ],
    "complotez": [
        "comploter"
    ],
    "complotiez": [
        "comploter"
    ],
    "complotons": [
        "comploter"
    ],
    "complots": [
        "complot"
    ],
    "comploterent": [
        "comploter"
    ],
    "complu": [
        "complu"
    ],
    "complus": [
        "complaire"
    ],
    "complut": [
        "complaire"
    ],
    "complete": [
        "completer",
        "complet"
    ],
    "completement": [
        "completement"
    ],
    "completements": [
        "completement"
    ],
    "completent": [
        "completer"
    ],
    "completes": [
        "completer",
        "complet",
        "complete"
    ],
    "complement": [
        "complement"
    ],
    "complementaire": [
        "complementaire"
    ],
    "complementairement": [
        "complementairement"
    ],
    "complementaires": [
        "complementaire"
    ],
    "complementarite": [
        "complementarite"
    ],
    "complements": [
        "complement"
    ],
    "completa": [
        "completer"
    ],
    "completai": [
        "completer"
    ],
    "completaient": [
        "completer"
    ],
    "completais": [
        "completer"
    ],
    "completait": [
        "completer"
    ],
    "completant": [
        "completer"
    ],
    "completer": [
        "completer"
    ],
    "completera": [
        "completer"
    ],
    "completerai": [
        "completer"
    ],
    "completeraient": [
        "completer"
    ],
    "completerait": [
        "completer"
    ],
    "completeras": [
        "completer"
    ],
    "completerez": [
        "completer"
    ],
    "completeront": [
        "completer"
    ],
    "completez": [
        "completer"
    ],
    "completiez": [
        "completer"
    ],
    "completons": [
        "completer"
    ],
    "completude": [
        "completude"
    ],
    "completerent": [
        "completer"
    ],
    "completee": [
        "completer"
    ],
    "completees": [
        "completer"
    ],
    "compo": [
        "compo"
    ],
    "componction": [
        "componction"
    ],
    "components": [
        "component"
    ],
    "comporta": [
        "comporter"
    ],
    "comportai": [
        "comporter"
    ],
    "comportaient": [
        "comporter"
    ],
    "comportais": [
        "comporter"
    ],
    "comportait": [
        "comporter"
    ],
    "comportant": [
        "comporter"
    ],
    "comportassent": [
        "comporter"
    ],
    "comporte": [
        "comporte",
        "comporter"
    ],
    "comportement": [
        "comportement"
    ],
    "comportemental": [
        "comportemental"
    ],
    "comportementale": [
        "comportemental"
    ],
    "comportementales": [
        "comportemental"
    ],
    "comportementalisme": [
        "comportementalisme"
    ],
    "comportementaliste": [
        "comportementaliste"
    ],
    "comportementaux": [
        "comportemental"
    ],
    "comportements": [
        "comportement"
    ],
    "comportent": [
        "comporter"
    ],
    "comporter": [
        "comporter"
    ],
    "comportera": [
        "comporter"
    ],
    "comporterai": [
        "comporter"
    ],
    "comporteraient": [
        "comporter"
    ],
    "comporterais": [
        "comporter"
    ],
    "comporterait": [
        "comporter"
    ],
    "comporterez": [
        "comporter"
    ],
    "comporteriez": [
        "comporter"
    ],
    "comporterions": [
        "comporter"
    ],
    "comporteront": [
        "comporter"
    ],
    "comportes": [
        "comporte",
        "comporter"
    ],
    "comportez": [
        "comporter"
    ],
    "comportiez": [
        "comporter"
    ],
    "comportions": [
        "comporter"
    ],
    "comportons": [
        "comporter"
    ],
    "comportat": [
        "comporter"
    ],
    "comportee": [
        "comporter"
    ],
    "composa": [
        "composer"
    ],
    "composai": [
        "composer"
    ],
    "composaient": [
        "composer"
    ],
    "composais": [
        "composer"
    ],
    "composait": [
        "composer"
    ],
    "composant": [
        "composer",
        "composant"
    ],
    "composante": [
        "composant"
    ],
    "composantes": [
        "composant"
    ],
    "composants": [
        "composant"
    ],
    "compose": [
        "composer",
        "compose"
    ],
    "composent": [
        "composer"
    ],
    "composer": [
        "composer"
    ],
    "composera": [
        "composer"
    ],
    "composerai": [
        "composer"
    ],
    "composerait": [
        "composer"
    ],
    "composeront": [
        "composer"
    ],
    "composes": [
        "composer",
        "compose"
    ],
    "composeur": [
        "composeur"
    ],
    "composez": [
        "composer"
    ],
    "composiez": [
        "composer"
    ],
    "composions": [
        "composer"
    ],
    "composite": [
        "composite"
    ],
    "composites": [
        "composite"
    ],
    "compositeur": [
        "compositeur"
    ],
    "compositeurs": [
        "compositeur"
    ],
    "composition": [
        "composition"
    ],
    "compositions": [
        "composition"
    ],
    "compositrice": [
        "compositeur"
    ],
    "composons": [
        "composer"
    ],
    "compost": [
        "compost"
    ],
    "composter": [
        "composter"
    ],
    "composteur": [
        "composteur"
    ],
    "composteurs": [
        "composteur"
    ],
    "compostez": [
        "composter"
    ],
    "composte": [
        "composter"
    ],
    "composerent": [
        "composer"
    ],
    "composee": [
        "composer",
        "compose"
    ],
    "composees": [
        "composer",
        "compose"
    ],
    "compote": [
        "compote"
    ],
    "compotes": [
        "compote"
    ],
    "compotier": [
        "compotier"
    ],
    "compotiers": [
        "compotier"
    ],
    "compound": [
        "compound"
    ],
    "comprador": [
        "comprador"
    ],
    "comprenaient": [
        "comprendre"
    ],
    "comprenais": [
        "comprendre"
    ],
    "comprenait": [
        "comprendre"
    ],
    "comprenant": [
        "comprendre"
    ],
    "comprend": [
        "comprendre"
    ],
    "comprendra": [
        "comprendre"
    ],
    "comprendrai": [
        "comprendre"
    ],
    "comprendraient": [
        "comprendre"
    ],
    "comprendrais": [
        "comprendre"
    ],
    "comprendrait": [
        "comprendre"
    ],
    "comprendras": [
        "comprendre"
    ],
    "comprendre": [
        "comprendre"
    ],
    "comprendrez": [
        "comprendre"
    ],
    "comprendriez": [
        "comprendre"
    ],
    "comprendrions": [
        "comprendre"
    ],
    "comprendrons": [
        "comprendre"
    ],
    "comprendront": [
        "comprendre"
    ],
    "comprends": [
        "comprendre"
    ],
    "comprenette": [
        "comprenette"
    ],
    "comprenez": [
        "comprendre"
    ],
    "compreniez": [
        "comprendre"
    ],
    "comprenions": [
        "comprendre"
    ],
    "comprenne": [
        "comprendre"
    ],
    "comprennent": [
        "comprendre"
    ],
    "comprennes": [
        "comprendre"
    ],
    "comprenons": [
        "comprendre"
    ],
    "compresse": [
        "compresser",
        "compresse"
    ],
    "compresser": [
        "compresser"
    ],
    "compresses": [
        "compresser",
        "compress",
        "compresse"
    ],
    "compresseur": [
        "compresseur"
    ],
    "compresseurs": [
        "compresseur"
    ],
    "compressible": [
        "compressible"
    ],
    "compressibles": [
        "compressible"
    ],
    "compressif": [
        "compressif"
    ],
    "compression": [
        "compression"
    ],
    "compressions": [
        "compression",
        "compresser"
    ],
    "compressee": [
        "compresser",
        "compresse"
    ],
    "compressees": [
        "compresse"
    ],
    "comprima": [
        "comprimer"
    ],
    "comprimait": [
        "comprimer"
    ],
    "comprimant": [
        "comprimant",
        "comprimer"
    ],
    "comprime": [
        "comprimer",
        "comprime"
    ],
    "compriment": [
        "comprimer"
    ],
    "comprimer": [
        "comprimer"
    ],
    "comprimez": [
        "comprimer"
    ],
    "comprimerent": [
        "comprimer"
    ],
    "comprimee": [
        "comprimer",
        "comprime"
    ],
    "comprimees": [
        "comprimer",
        "comprime"
    ],
    "comprimes": [
        "comprendre",
        "comprimer",
        "comprime"
    ],
    "comprirent": [
        "comprendre"
    ],
    "compris": [
        "comprendre",
        "compris"
    ],
    "comprise": [
        "comprendre",
        "compris"
    ],
    "comprises": [
        "comprendre",
        "compris",
        "comprise"
    ],
    "comprisse": [
        "comprendre"
    ],
    "comprit": [
        "comprendre"
    ],
    "compromet": [
        "compromettre"
    ],
    "compromets": [
        "compromettre"
    ],
    "compromettaient": [
        "compromettre"
    ],
    "compromettait": [
        "compromettre"
    ],
    "compromettant": [
        "compromettant",
        "compromettre"
    ],
    "compromettante": [
        "compromettant"
    ],
    "compromettantes": [
        "compromettant"
    ],
    "compromettants": [
        "compromettant"
    ],
    "compromette": [
        "compromettre"
    ],
    "compromettent": [
        "compromettre"
    ],
    "compromettes": [
        "compromettre"
    ],
    "compromettez": [
        "compromettre"
    ],
    "compromettiez": [
        "compromettre"
    ],
    "compromettrai": [
        "compromettre"
    ],
    "compromettrait": [
        "compromettre"
    ],
    "compromettre": [
        "compromettre"
    ],
    "compromettrons": [
        "compromettre"
    ],
    "compromirent": [
        "compromettre"
    ],
    "compromis": [
        "compromis",
        "compromettre"
    ],
    "compromise": [
        "compromettre"
    ],
    "compromises": [
        "compromettre",
        "compromise"
    ],
    "compromission": [
        "compromission"
    ],
    "compromissions": [
        "compromission"
    ],
    "compromissoire": [
        "compromissoire"
    ],
    "compromit": [
        "compromettre"
    ],
    "comprehensible": [
        "comprehensible"
    ],
    "comprehensibles": [
        "comprehensible"
    ],
    "comprehensif": [
        "comprehensif"
    ],
    "comprehensifs": [
        "comprehensif"
    ],
    "comprehension": [
        "comprehension"
    ],
    "comprehensions": [
        "comprehension"
    ],
    "comprehensive": [
        "comprehensif"
    ],
    "comprehensives": [
        "comprehensif",
        "comprehensive"
    ],
    "compta": [
        "compter"
    ],
    "comptabilisait": [
        "comptabiliser"
    ],
    "comptabilisant": [
        "comptabiliser"
    ],
    "comptabilisation": [
        "comptabilisation"
    ],
    "comptabilise": [
        "comptabiliser"
    ],
    "comptabiliser": [
        "comptabiliser"
    ],
    "comptabilisees": [
        "comptabiliser"
    ],
    "comptabilises": [
        "comptabiliser"
    ],
    "comptabilite": [
        "comptabilite"
    ],
    "comptabilites": [
        "comptabilite"
    ],
    "comptable": [
        "comptable"
    ],
    "comptables": [
        "comptable"
    ],
    "comptage": [
        "comptage"
    ],
    "comptai": [
        "compter"
    ],
    "comptaient": [
        "compter"
    ],
    "comptais": [
        "compter"
    ],
    "comptait": [
        "compter"
    ],
    "comptant": [
        "compter",
        "comptant"
    ],
    "compte": [
        "compte",
        "compter"
    ],
    "comptent": [
        "compter"
    ],
    "compter": [
        "compter"
    ],
    "comptera": [
        "compter"
    ],
    "compterai": [
        "compter"
    ],
    "compteraient": [
        "compter"
    ],
    "compterais": [
        "compter"
    ],
    "compterait": [
        "compter"
    ],
    "compteras": [
        "compter"
    ],
    "compterez": [
        "compter"
    ],
    "compterons": [
        "compter"
    ],
    "compteront": [
        "compter"
    ],
    "comptes": [
        "compte",
        "compter"
    ],
    "compteur": [
        "compteur"
    ],
    "compteurs": [
        "compteur"
    ],
    "comptez": [
        "compter"
    ],
    "comptiez": [
        "compter"
    ],
    "comptine": [
        "comptine"
    ],
    "comptines": [
        "comptine"
    ],
    "comptions": [
        "compter"
    ],
    "comptoir": [
        "comptoir"
    ],
    "comptoirs": [
        "comptoir"
    ],
    "comptons": [
        "compton",
        "compter"
    ],
    "comptat": [
        "compter"
    ],
    "compterent": [
        "compter"
    ],
    "comptee": [
        "compter"
    ],
    "comptees": [
        "compter"
    ],
    "compulsait": [
        "compulser"
    ],
    "compulsant": [
        "compulser"
    ],
    "compulse": [
        "compulser"
    ],
    "compulser": [
        "compulser"
    ],
    "compulsez": [
        "compulser"
    ],
    "compulsif": [
        "compulsif"
    ],
    "compulsifs": [
        "compulsif"
    ],
    "compulsion": [
        "compulsion"
    ],
    "compulsive": [
        "compulsif"
    ],
    "compulsivement": [
        "compulsivement"
    ],
    "compulsives": [
        "compulsive",
        "compulsif"
    ],
    "compulsoire": [
        "compulsoire"
    ],
    "compulsons": [
        "compulser"
    ],
    "compulses": [
        "compulser"
    ],
    "comput": [
        "comput"
    ],
    "computations": [
        "computation"
    ],
    "computer": [
        "computer"
    ],
    "computers": [
        "computer"
    ],
    "computeur": [
        "computeur"
    ],
    "computeurs": [
        "computeur"
    ],
    "compere": [
        "compere"
    ],
    "comperes": [
        "compere"
    ],
    "compete": [
        "competer"
    ],
    "competes": [
        "competer",
        "compete"
    ],
    "competant": [
        "competer"
    ],
    "competence": [
        "competence"
    ],
    "competences": [
        "competence"
    ],
    "competent": [
        "competent"
    ],
    "competente": [
        "competent"
    ],
    "competentes": [
        "competent"
    ],
    "competents": [
        "competent"
    ],
    "competiteur": [
        "competiteur"
    ],
    "competiteurs": [
        "competiteur"
    ],
    "competitif": [
        "competitif"
    ],
    "competitifs": [
        "competitif"
    ],
    "competition": [
        "competition"
    ],
    "competitions": [
        "competition"
    ],
    "competitive": [
        "competitif"
    ],
    "competitivite": [
        "competitivite"
    ],
    "competitrice": [
        "competiteur"
    ],
    "comtal": [
        "comtal"
    ],
    "comtale": [
        "comtal"
    ],
    "comte": [
        "comte"
    ],
    "comtes": [
        "comte"
    ],
    "comtesse": [
        "comte"
    ],
    "comtesses": [
        "comte"
    ],
    "comtois": [
        "comtois"
    ],
    "comtoise": [
        "comtois"
    ],
    "comete": [
        "comete"
    ],
    "cometes": [
        "comete"
    ],
    "comedie": [
        "comedie"
    ],
    "comedien": [
        "comedien"
    ],
    "comedienne": [
        "comedien"
    ],
    "comediennes": [
        "comedien"
    ],
    "comediens": [
        "comedien"
    ],
    "comedies": [
        "comedie",
        "comedy"
    ],
    "comedons": [
        "comedon"
    ],
    "con": [
        "con"
    ],
    "conard": [
        "conard"
    ],
    "conarde": [
        "conard"
    ],
    "conards": [
        "conard"
    ],
    "conasse": [
        "conasse"
    ],
    "conasses": [
        "conasse"
    ],
    "concassage": [
        "concassage"
    ],
    "concassait": [
        "concasser"
    ],
    "concassant": [
        "concasser"
    ],
    "concasse": [
        "concasser"
    ],
    "concassent": [
        "concasser"
    ],
    "concasser": [
        "concasser"
    ],
    "concasseur": [
        "concasseur"
    ],
    "concasseurs": [
        "concasseur"
    ],
    "concassee": [
        "concasser"
    ],
    "concassees": [
        "concasser"
    ],
    "concasses": [
        "concasser"
    ],
    "concatenation": [
        "concatenation"
    ],
    "concave": [
        "concave"
    ],
    "concaves": [
        "concave"
    ],
    "concavite": [
        "concavite"
    ],
    "concentra": [
        "concentrer"
    ],
    "concentrai": [
        "concentrer"
    ],
    "concentraient": [
        "concentrer"
    ],
    "concentrais": [
        "concentrer"
    ],
    "concentrait": [
        "concentrer"
    ],
    "concentrant": [
        "concentrer"
    ],
    "concentrateur": [
        "concentrateur"
    ],
    "concentration": [
        "concentration"
    ],
    "concentrationnaire": [
        "concentrationnaire"
    ],
    "concentrationnaires": [
        "concentrationnaire"
    ],
    "concentrations": [
        "concentration"
    ],
    "concentre": [
        "concentrer",
        "concentre"
    ],
    "concentrent": [
        "concentrer"
    ],
    "concentrer": [
        "concentrer"
    ],
    "concentrera": [
        "concentrer"
    ],
    "concentrerai": [
        "concentrer"
    ],
    "concentrerais": [
        "concentrer"
    ],
    "concentrerait": [
        "concentrer"
    ],
    "concentrerons": [
        "concentrer"
    ],
    "concentreront": [
        "concentrer"
    ],
    "concentres": [
        "concentrer",
        "concentre"
    ],
    "concentrez": [
        "concentrer"
    ],
    "concentriez": [
        "concentrer"
    ],
    "concentrions": [
        "concentrer"
    ],
    "concentrique": [
        "concentrique"
    ],
    "concentriques": [
        "concentrique"
    ],
    "concentrons": [
        "concentrer"
    ],
    "concentree": [
        "concentrer",
        "concentre"
    ],
    "concentrees": [
        "concentrer",
        "concentre"
    ],
    "concept": [
        "concept"
    ],
    "concepteur": [
        "concepteur"
    ],
    "concepteurs": [
        "concepteur"
    ],
    "conception": [
        "conception"
    ],
    "conceptions": [
        "conception"
    ],
    "conceptrice": [
        "concepteur"
    ],
    "concepts": [
        "concept"
    ],
    "conceptualise": [
        "conceptualiser"
    ],
    "conceptualiser": [
        "conceptualiser"
    ],
    "conceptuel": [
        "conceptuel"
    ],
    "conceptuelle": [
        "conceptuel"
    ],
    "conceptuellement": [
        "conceptuellement"
    ],
    "conceptuelles": [
        "conceptuel"
    ],
    "conceptuels": [
        "conceptuel"
    ],
    "concernaient": [
        "concerner"
    ],
    "concernait": [
        "concerner"
    ],
    "concernant": [
        "concerner",
        "concernant"
    ],
    "concerne": [
        "concerner"
    ],
    "concernent": [
        "concerner"
    ],
    "concerner": [
        "concerner"
    ],
    "concernera": [
        "concerner"
    ],
    "concerneraient": [
        "concerner"
    ],
    "concernerait": [
        "concerner"
    ],
    "concernat": [
        "concerner"
    ],
    "concernerent": [
        "concerner"
    ],
    "concernee": [
        "concerner"
    ],
    "concernees": [
        "concerner"
    ],
    "concernes": [
        "concerner"
    ],
    "concert": [
        "concert"
    ],
    "concertaient": [
        "concerter"
    ],
    "concertait": [
        "concerter"
    ],
    "concertant": [
        "concerter"
    ],
    "concertation": [
        "concertation"
    ],
    "concertations": [
        "concertation"
    ],
    "concerte": [
        "concerter",
        "concerte"
    ],
    "concertent": [
        "concerter"
    ],
    "concerter": [
        "concerter"
    ],
    "concertez": [
        "concerter"
    ],
    "concertina": [
        "concertina"
    ],
    "concertiste": [
        "concertiste"
    ],
    "concerto": [
        "concerto"
    ],
    "concertons": [
        "concerter"
    ],
    "concertos": [
        "concerto"
    ],
    "concerts": [
        "concert"
    ],
    "concerterent": [
        "concerter"
    ],
    "concertee": [
        "concerter",
        "concerte"
    ],
    "concertees": [
        "concerter",
        "concerte"
    ],
    "concertes": [
        "concerter",
        "concerte"
    ],
    "concession": [
        "concession"
    ],
    "concessionnaire": [
        "concessionnaire"
    ],
    "concessionnaires": [
        "concessionnaire"
    ],
    "concessions": [
        "concession"
    ],
    "concetto": [
        "concetto"
    ],
    "concevable": [
        "concevable"
    ],
    "concevables": [
        "concevable"
    ],
    "concevaient": [
        "concevoir"
    ],
    "concevais": [
        "concevoir"
    ],
    "concevait": [
        "concevoir"
    ],
    "concevant": [
        "concevoir"
    ],
    "concevez": [
        "concevoir"
    ],
    "conceviez": [
        "concevoir"
    ],
    "concevions": [
        "concevoir"
    ],
    "concevoir": [
        "concevoir"
    ],
    "concevons": [
        "concevoir"
    ],
    "concevrais": [
        "concevoir"
    ],
    "concevrait": [
        "concevoir"
    ],
    "conchiaient": [
        "conchier"
    ],
    "conchie": [
        "conchier"
    ],
    "conchier": [
        "conchier"
    ],
    "conchoidaux": [
        "conchoidal"
    ],
    "concierge": [
        "concierge"
    ],
    "conciergerie": [
        "conciergerie"
    ],
    "conciergeries": [
        "conciergerie"
    ],
    "concierges": [
        "concierge"
    ],
    "concile": [
        "concile"
    ],
    "conciles": [
        "concile"
    ],
    "conciliable": [
        "conciliable"
    ],
    "conciliables": [
        "conciliable"
    ],
    "conciliabule": [
        "conciliabule"
    ],
    "conciliabules": [
        "conciliabule"
    ],
    "conciliaient": [
        "concilier"
    ],
    "conciliaires": [
        "conciliaire"
    ],
    "conciliait": [
        "concilier"
    ],
    "conciliant": [
        "conciliant",
        "concilier"
    ],
    "conciliante": [
        "conciliant"
    ],
    "conciliantes": [
        "conciliant"
    ],
    "conciliants": [
        "conciliant"
    ],
    "conciliateur": [
        "conciliateur"
    ],
    "conciliateurs": [
        "conciliateur"
    ],
    "conciliation": [
        "conciliation"
    ],
    "conciliations": [
        "conciliation"
    ],
    "conciliatrice": [
        "conciliateur"
    ],
    "concilie": [
        "concilier"
    ],
    "concilier": [
        "concilier"
    ],
    "concilierait": [
        "concilier"
    ],
    "concilies": [
        "concilier"
    ],
    "conciliees": [
        "concilier"
    ],
    "concis": [
        "concis"
    ],
    "concise": [
        "concis"
    ],
    "concision": [
        "concision"
    ],
    "concitoyen": [
        "concitoyen"
    ],
    "concitoyenne": [
        "concitoyen"
    ],
    "concitoyennes": [
        "concitoyen"
    ],
    "concitoyens": [
        "concitoyen"
    ],
    "conclave": [
        "conclave"
    ],
    "conclaviste": [
        "conclaviste"
    ],
    "conclu": [
        "conclure"
    ],
    "concluaient": [
        "conclure"
    ],
    "concluais": [
        "conclure"
    ],
    "concluait": [
        "conclure"
    ],
    "concluant": [
        "concluant",
        "conclure"
    ],
    "concluante": [
        "concluant"
    ],
    "concluantes": [
        "concluant"
    ],
    "concluants": [
        "concluant"
    ],
    "conclue": [
        "conclure"
    ],
    "concluent": [
        "conclure"
    ],
    "conclues": [
        "conclure"
    ],
    "concluez": [
        "conclure"
    ],
    "concluions": [
        "conclure"
    ],
    "concluons": [
        "conclure"
    ],
    "conclura": [
        "conclure"
    ],
    "conclurai": [
        "conclure"
    ],
    "conclurais": [
        "conclure"
    ],
    "conclurait": [
        "conclure"
    ],
    "conclure": [
        "conclure"
    ],
    "conclurent": [
        "conclure"
    ],
    "conclurez": [
        "conclure"
    ],
    "conclurions": [
        "conclure"
    ],
    "conclurons": [
        "conclure"
    ],
    "concluront": [
        "conclure"
    ],
    "conclus": [
        "conclure"
    ],
    "conclusion": [
        "conclusion"
    ],
    "conclusions": [
        "conclusion"
    ],
    "conclusive": [
        "conclusif"
    ],
    "conclut": [
        "conclure"
    ],
    "conclumes": [
        "conclure"
    ],
    "concocta": [
        "concocter"
    ],
    "concoctait": [
        "concocter"
    ],
    "concoctent": [
        "concocter"
    ],
    "concocter": [
        "concocter"
    ],
    "concocteras": [
        "concocter"
    ],
    "concoction": [
        "concoction"
    ],
    "concocte": [
        "concocter"
    ],
    "concoctee": [
        "concocter"
    ],
    "concoctes": [
        "concocter"
    ],
    "concombre": [
        "concombre"
    ],
    "concombres": [
        "concombre"
    ],
    "concomitance": [
        "concomitance"
    ],
    "concomitant": [
        "concomitant"
    ],
    "concomitante": [
        "concomitant"
    ],
    "concomitantes": [
        "concomitant"
    ],
    "concordaient": [
        "concorder"
    ],
    "concordait": [
        "concorder"
    ],
    "concordance": [
        "concordance"
    ],
    "concordant": [
        "concorder",
        "concordant"
    ],
    "concordante": [
        "concordant"
    ],
    "concordantes": [
        "concordant"
    ],
    "concordants": [
        "concordant"
    ],
    "concordat": [
        "concordat"
    ],
    "concorde": [
        "concorder",
        "concorde"
    ],
    "concordent": [
        "concorder"
    ],
    "concorder": [
        "concorder"
    ],
    "concordez": [
        "concorder"
    ],
    "concordistes": [
        "concordiste"
    ],
    "concouraient": [
        "concourir"
    ],
    "concourait": [
        "concourir"
    ],
    "concourant": [
        "concourir",
        "concourant"
    ],
    "concoure": [
        "concourir"
    ],
    "concourent": [
        "concourir"
    ],
    "concourez": [
        "concourir"
    ],
    "concourir": [
        "concourir"
    ],
    "concourrai": [
        "concourir"
    ],
    "concourrait": [
        "concourir"
    ],
    "concourront": [
        "concourir"
    ],
    "concours": [
        "concours",
        "concourir"
    ],
    "concourt": [
        "concourir"
    ],
    "concouru": [
        "concourir"
    ],
    "concourut": [
        "concourir"
    ],
    "concret": [
        "concret"
    ],
    "concrets": [
        "concret"
    ],
    "concrete": [
        "concreter",
        "concret"
    ],
    "concretement": [
        "concretement"
    ],
    "concretes": [
        "concret",
        "concrete"
    ],
    "concretion": [
        "concretion"
    ],
    "concretions": [
        "concretion"
    ],
    "concretisant": [
        "concretiser"
    ],
    "concretisation": [
        "concretisation"
    ],
    "concretise": [
        "concretiser"
    ],
    "concretisent": [
        "concretiser"
    ],
    "concretiser": [
        "concretiser"
    ],
    "concretiserent": [
        "concretiser"
    ],
    "concretisee": [
        "concretiser"
    ],
    "concretisees": [
        "concretiser"
    ],
    "concretises": [
        "concretiser"
    ],
    "concubin": [
        "concubin"
    ],
    "concubinage": [
        "concubinage"
    ],
    "concubinages": [
        "concubinage"
    ],
    "concubinait": [
        "concubiner"
    ],
    "concubine": [
        "concubin"
    ],
    "concubines": [
        "concubin"
    ],
    "concubins": [
        "concubin"
    ],
    "concupiscence": [
        "concupiscence"
    ],
    "concupiscences": [
        "concupiscence"
    ],
    "concupiscent": [
        "concupiscent"
    ],
    "concupiscente": [
        "concupiscent"
    ],
    "concupiscentes": [
        "concupiscent"
    ],
    "concupiscents": [
        "concupiscent"
    ],
    "concurremment": [
        "concurremment"
    ],
    "concurrence": [
        "concurrence",
        "concurrencer"
    ],
    "concurrencer": [
        "concurrencer"
    ],
    "concurrences": [
        "concurrence"
    ],
    "concurrencee": [
        "concurrencer"
    ],
    "concurrent": [
        "concurrent"
    ],
    "concurrente": [
        "concurrent"
    ],
    "concurrentes": [
        "concurrent"
    ],
    "concurrentiel": [
        "concurrentiel"
    ],
    "concurrentielle": [
        "concurrentiel"
    ],
    "concurrentiels": [
        "concurrentiel"
    ],
    "concurrents": [
        "concurrent"
    ],
    "concurrencait": [
        "concurrencer"
    ],
    "concussion": [
        "concussion"
    ],
    "concussionnaire": [
        "concussionnaire"
    ],
    "concede": [
        "conceder"
    ],
    "concedes": [
        "conceder",
        "concede"
    ],
    "conceda": [
        "conceder"
    ],
    "concedai": [
        "conceder"
    ],
    "concedaient": [
        "conceder"
    ],
    "concedais": [
        "conceder"
    ],
    "concedait": [
        "conceder"
    ],
    "concedant": [
        "concedant"
    ],
    "conceder": [
        "conceder"
    ],
    "concederait": [
        "conceder"
    ],
    "concedez": [
        "conceder"
    ],
    "concedons": [
        "conceder"
    ],
    "concedat": [
        "conceder"
    ],
    "concedee": [
        "conceder"
    ],
    "concelebrent": [
        "concelebrer"
    ],
    "condamna": [
        "condamner"
    ],
    "condamnable": [
        "condamnable"
    ],
    "condamnables": [
        "condamnable"
    ],
    "condamnai": [
        "condamner"
    ],
    "condamnaient": [
        "condamner"
    ],
    "condamnais": [
        "condamner"
    ],
    "condamnait": [
        "condamner"
    ],
    "condamnant": [
        "condamner"
    ],
    "condamnation": [
        "condamnation"
    ],
    "condamnations": [
        "condamnation"
    ],
    "condamne": [
        "condamne",
        "condamner"
    ],
    "condamnent": [
        "condamner"
    ],
    "condamner": [
        "condamner"
    ],
    "condamnera": [
        "condamner"
    ],
    "condamnerai": [
        "condamner"
    ],
    "condamneraient": [
        "condamner"
    ],
    "condamnerais": [
        "condamner"
    ],
    "condamnerait": [
        "condamner"
    ],
    "condamneras": [
        "condamner"
    ],
    "condamnerons": [
        "condamner"
    ],
    "condamneront": [
        "condamner"
    ],
    "condamnes": [
        "condamne",
        "condamner"
    ],
    "condamnez": [
        "condamner"
    ],
    "condamniez": [
        "condamner"
    ],
    "condamnions": [
        "condamner"
    ],
    "condamnons": [
        "condamner"
    ],
    "condamnat": [
        "condamner"
    ],
    "condamnerent": [
        "condamner"
    ],
    "condamnee": [
        "condamne",
        "condamner"
    ],
    "condamnees": [
        "condamne",
        "condamner"
    ],
    "condensa": [
        "condenser"
    ],
    "condensaient": [
        "condenser"
    ],
    "condensait": [
        "condenser"
    ],
    "condensant": [
        "condenser"
    ],
    "condensateur": [
        "condensateur"
    ],
    "condensateurs": [
        "condensateur"
    ],
    "condensation": [
        "condensation"
    ],
    "condense": [
        "condense",
        "condenser"
    ],
    "condensent": [
        "condenser"
    ],
    "condenser": [
        "condenser"
    ],
    "condensera": [
        "condenser"
    ],
    "condenseur": [
        "condenseur"
    ],
    "condenserent": [
        "condenser"
    ],
    "condensee": [
        "condense"
    ],
    "condensees": [
        "condenser"
    ],
    "condenses": [
        "condense",
        "condenser"
    ],
    "condescend": [
        "condescendre"
    ],
    "condescendait": [
        "condescendre"
    ],
    "condescendance": [
        "condescendance"
    ],
    "condescendant": [
        "condescendre",
        "condescendant"
    ],
    "condescendante": [
        "condescendant"
    ],
    "condescendants": [
        "condescendant"
    ],
    "condescendit": [
        "condescendre"
    ],
    "condescendrais": [
        "condescendre"
    ],
    "condescendre": [
        "condescendre"
    ],
    "condescendu": [
        "condescendre"
    ],
    "condiment": [
        "condiment"
    ],
    "condiments": [
        "condiment"
    ],
    "condisciple": [
        "condisciple"
    ],
    "condisciples": [
        "condisciple"
    ],
    "condition": [
        "condition"
    ],
    "conditionnait": [
        "conditionner"
    ],
    "conditionnant": [
        "conditionner"
    ],
    "conditionne": [
        "conditionne",
        "conditionner"
    ],
    "conditionnel": [
        "conditionnel"
    ],
    "conditionnelle": [
        "conditionnel"
    ],
    "conditionnellement": [
        "conditionnellement"
    ],
    "conditionnelles": [
        "conditionnel"
    ],
    "conditionnels": [
        "conditionnel"
    ],
    "conditionnement": [
        "conditionnement"
    ],
    "conditionnements": [
        "conditionnement"
    ],
    "conditionnent": [
        "conditionner"
    ],
    "conditionner": [
        "conditionner"
    ],
    "conditionnerons": [
        "conditionner"
    ],
    "conditionneur": [
        "conditionneur"
    ],
    "conditionneurs": [
        "conditionneur"
    ],
    "conditionnons": [
        "conditionner"
    ],
    "conditionnee": [
        "conditionne",
        "conditionner"
    ],
    "conditionnees": [
        "conditionne",
        "conditionner"
    ],
    "conditionnes": [
        "conditionne",
        "conditionner"
    ],
    "conditions": [
        "condition"
    ],
    "condo": [
        "condo"
    ],
    "condoleance": [
        "condoleance"
    ],
    "condoleances": [
        "condoleance"
    ],
    "condoleants": [
        "condoleant"
    ],
    "condom": [
        "condom"
    ],
    "condominium": [
        "condominium"
    ],
    "condor": [
        "condor"
    ],
    "condors": [
        "condor"
    ],
    "condos": [
        "condo"
    ],
    "condottiere": [
        "condottiere"
    ],
    "condottieres": [
        "condottiere"
    ],
    "condottieri": [
        "condottieri"
    ],
    "conductance": [
        "conductance"
    ],
    "conducteur": [
        "conducteur"
    ],
    "conducteurs": [
        "conducteur"
    ],
    "conductibilite": [
        "conductibilite"
    ],
    "conduction": [
        "conduction"
    ],
    "conductivite": [
        "conductivite"
    ],
    "conductrice": [
        "conducteur"
    ],
    "conductrices": [
        "conducteur"
    ],
    "conduira": [
        "conduire"
    ],
    "conduirai": [
        "conduire"
    ],
    "conduiraient": [
        "conduire"
    ],
    "conduirais": [
        "conduire"
    ],
    "conduirait": [
        "conduire"
    ],
    "conduiras": [
        "conduire"
    ],
    "conduire": [
        "conduire"
    ],
    "conduirez": [
        "conduire"
    ],
    "conduiriez": [
        "conduire"
    ],
    "conduirons": [
        "conduire"
    ],
    "conduiront": [
        "conduire"
    ],
    "conduis": [
        "conduire"
    ],
    "conduisaient": [
        "conduire"
    ],
    "conduisais": [
        "conduire"
    ],
    "conduisait": [
        "conduire"
    ],
    "conduisant": [
        "conduire"
    ],
    "conduise": [
        "conduire"
    ],
    "conduisent": [
        "conduire"
    ],
    "conduises": [
        "conduire"
    ],
    "conduisez": [
        "conduire"
    ],
    "conduisiez": [
        "conduire"
    ],
    "conduisions": [
        "conduire"
    ],
    "conduisirent": [
        "conduire"
    ],
    "conduisis": [
        "conduire"
    ],
    "conduisit": [
        "conduire"
    ],
    "conduisons": [
        "conduire"
    ],
    "conduit": [
        "conduit",
        "conduire"
    ],
    "conduite": [
        "conduit",
        "conduite",
        "conduire"
    ],
    "conduites": [
        "conduit",
        "conduite",
        "conduire"
    ],
    "conduits": [
        "conduit",
        "conduire"
    ],
    "condyle": [
        "condyle"
    ],
    "condyles": [
        "condyle"
    ],
    "conde": [
        "conde"
    ],
    "condes": [
        "conde"
    ],
    "confabulaient": [
        "confabuler"
    ],
    "confection": [
        "confection"
    ],
    "confectionna": [
        "confectionner"
    ],
    "confectionnai": [
        "confectionner"
    ],
    "confectionnaient": [
        "confectionner"
    ],
    "confectionnais": [
        "confectionner"
    ],
    "confectionnait": [
        "confectionner"
    ],
    "confectionne": [
        "confectionner"
    ],
    "confectionner": [
        "confectionner"
    ],
    "confectionnerai": [
        "confectionner"
    ],
    "confectionnerais": [
        "confectionner"
    ],
    "confectionnerait": [
        "confectionner"
    ],
    "confectionneur": [
        "confectionneur"
    ],
    "confectionneurs": [
        "confectionneur"
    ],
    "confectionneuse": [
        "confectionneur"
    ],
    "confectionneuses": [
        "confectionneur"
    ],
    "confectionnez": [
        "confectionner"
    ],
    "confectionnions": [
        "confectionner"
    ],
    "confectionnames": [
        "confectionner"
    ],
    "confectionnat": [
        "confectionner"
    ],
    "confectionnerent": [
        "confectionner"
    ],
    "confectionnee": [
        "confectionner"
    ],
    "confectionnees": [
        "confectionner"
    ],
    "confectionnes": [
        "confectionner"
    ],
    "confessa": [
        "confesser"
    ],
    "confessai": [
        "confesser"
    ],
    "confessaient": [
        "confesser"
    ],
    "confessais": [
        "confesser"
    ],
    "confessait": [
        "confesser"
    ],
    "confessant": [
        "confesser"
    ],
    "confesse": [
        "confesse",
        "confesser"
    ],
    "confessent": [
        "confesser"
    ],
    "confesser": [
        "confesser"
    ],
    "confesserai": [
        "confesser"
    ],
    "confesserait": [
        "confesser"
    ],
    "confesseras": [
        "confesser"
    ],
    "confesserez": [
        "confesser"
    ],
    "confesseur": [
        "confesseur"
    ],
    "confesseurs": [
        "confesseur"
    ],
    "confessez": [
        "confesser"
    ],
    "confessiez": [
        "confesser"
    ],
    "confession": [
        "confession"
    ],
    "confessionnal": [
        "confessionnal"
    ],
    "confessionnaux": [
        "confessionnal"
    ],
    "confessionnel": [
        "confessionnel"
    ],
    "confessionnelle": [
        "confessionnel"
    ],
    "confessionnels": [
        "confessionnel"
    ],
    "confessions": [
        "confession"
    ],
    "confessons": [
        "confesser"
    ],
    "confessee": [
        "confesser"
    ],
    "confesses": [
        "confess",
        "confesser"
    ],
    "confetti": [
        "confetti"
    ],
    "confettis": [
        "confetti"
    ],
    "confia": [
        "confier"
    ],
    "confiai": [
        "confier"
    ],
    "confiaient": [
        "confier"
    ],
    "confiais": [
        "confier"
    ],
    "confiait": [
        "confier"
    ],
    "confiance": [
        "confiance"
    ],
    "confiances": [
        "confiance"
    ],
    "confiant": [
        "confiant",
        "confier"
    ],
    "confiante": [
        "confiant"
    ],
    "confiantes": [
        "confiant"
    ],
    "confiants": [
        "confiant"
    ],
    "confidence": [
        "confidence"
    ],
    "confidences": [
        "confidence"
    ],
    "confident": [
        "confident"
    ],
    "confidente": [
        "confident"
    ],
    "confidentes": [
        "confident"
    ],
    "confidentialite": [
        "confidentialite"
    ],
    "confidentiel": [
        "confidentiel"
    ],
    "confidentielle": [
        "confidentiel"
    ],
    "confidentiellement": [
        "confidentiellement"
    ],
    "confidentielles": [
        "confidentiel"
    ],
    "confidentiels": [
        "confidentiel"
    ],
    "confidents": [
        "confident"
    ],
    "confie": [
        "confier"
    ],
    "confient": [
        "confier"
    ],
    "confier": [
        "confier"
    ],
    "confiera": [
        "confier"
    ],
    "confierai": [
        "confier"
    ],
    "confieraient": [
        "confier"
    ],
    "confierais": [
        "confier"
    ],
    "confierait": [
        "confier"
    ],
    "confieras": [
        "confier"
    ],
    "confierez": [
        "confier"
    ],
    "confieriez": [
        "confier"
    ],
    "confiez": [
        "confier"
    ],
    "configuration": [
        "configuration"
    ],
    "configurations": [
        "configuration"
    ],
    "configure": [
        "configurer"
    ],
    "configurer": [
        "configurer"
    ],
    "confiions": [
        "confier"
    ],
    "confina": [
        "confiner"
    ],
    "confinaient": [
        "confiner"
    ],
    "confinait": [
        "confiner"
    ],
    "confinant": [
        "confiner"
    ],
    "confine": [
        "confine",
        "confiner"
    ],
    "confinement": [
        "confinement"
    ],
    "confinent": [
        "confiner"
    ],
    "confiner": [
        "confiner"
    ],
    "confinerez": [
        "confiner"
    ],
    "confins": [
        "confins"
    ],
    "confinee": [
        "confine",
        "confiner"
    ],
    "confinees": [
        "confine",
        "confiner"
    ],
    "confines": [
        "confine",
        "confiner"
    ],
    "confions": [
        "confier"
    ],
    "confiote": [
        "confiote"
    ],
    "confiotes": [
        "confiote"
    ],
    "confire": [
        "confire"
    ],
    "confirma": [
        "confirmer"
    ],
    "confirmai": [
        "confirmer"
    ],
    "confirmaient": [
        "confirmer"
    ],
    "confirmais": [
        "confirmer"
    ],
    "confirmait": [
        "confirmer"
    ],
    "confirmant": [
        "confirmer"
    ],
    "confirmation": [
        "confirmation"
    ],
    "confirmations": [
        "confirmation"
    ],
    "confirme": [
        "confirme",
        "confirmer"
    ],
    "confirment": [
        "confirmer"
    ],
    "confirmer": [
        "confirmer"
    ],
    "confirmera": [
        "confirmer"
    ],
    "confirmerai": [
        "confirmer"
    ],
    "confirmeraient": [
        "confirmer"
    ],
    "confirmerait": [
        "confirmer"
    ],
    "confirmerez": [
        "confirmer"
    ],
    "confirmeront": [
        "confirmer"
    ],
    "confirmes": [
        "confirme",
        "confirmer"
    ],
    "confirmez": [
        "confirmer"
    ],
    "confirmions": [
        "confirmer"
    ],
    "confirmons": [
        "confirmer"
    ],
    "confirmames": [
        "confirmer"
    ],
    "confirmat": [
        "confirmer"
    ],
    "confirmerent": [
        "confirmer"
    ],
    "confirmee": [
        "confirme",
        "confirmer"
    ],
    "confirmees": [
        "confirme",
        "confirmer"
    ],
    "confiscation": [
        "confiscation"
    ],
    "confiscations": [
        "confiscation"
    ],
    "confiserie": [
        "confiserie"
    ],
    "confiseries": [
        "confiserie"
    ],
    "confiseur": [
        "confiseur"
    ],
    "confiseurs": [
        "confiseur"
    ],
    "confiseuse": [
        "confiseur"
    ],
    "confisqua": [
        "confisquer"
    ],
    "confisquaient": [
        "confisquer"
    ],
    "confisquait": [
        "confisquer"
    ],
    "confisquant": [
        "confisquer"
    ],
    "confisque": [
        "confisquer",
        "confisque"
    ],
    "confisquent": [
        "confisquer"
    ],
    "confisquer": [
        "confisquer"
    ],
    "confisquera": [
        "confisquer"
    ],
    "confisquerai": [
        "confisquer"
    ],
    "confisqueraient": [
        "confisquer"
    ],
    "confisquerait": [
        "confisquer"
    ],
    "confisquerons": [
        "confisquer"
    ],
    "confisqueront": [
        "confisquer"
    ],
    "confisquez": [
        "confisquer"
    ],
    "confisquons": [
        "confisquer"
    ],
    "confisquat": [
        "confisquer"
    ],
    "confisquerent": [
        "confisquer"
    ],
    "confisquee": [
        "confisquer",
        "confisque"
    ],
    "confisquees": [
        "confisquer",
        "confisque"
    ],
    "confisques": [
        "confisquer",
        "confisque"
    ],
    "confit": [
        "confire",
        "confit"
    ],
    "confite": [
        "confire",
        "confit"
    ],
    "confiteor": [
        "confiteor"
    ],
    "confites": [
        "confire",
        "confit"
    ],
    "confits": [
        "confire",
        "confit"
    ],
    "confiture": [
        "confiture"
    ],
    "confitures": [
        "confiture"
    ],
    "confituriers": [
        "confiturier"
    ],
    "confituriere": [
        "confiturier"
    ],
    "confiames": [
        "confier"
    ],
    "confiat": [
        "confier"
    ],
    "confierent": [
        "confier"
    ],
    "confiee": [
        "confier"
    ],
    "confiees": [
        "confier"
    ],
    "confies": [
        "confier"
    ],
    "conflagration": [
        "conflagration"
    ],
    "conflictuel": [
        "conflictuel"
    ],
    "conflictuelle": [
        "conflictuel"
    ],
    "conflictuelles": [
        "conflictuel"
    ],
    "conflictuels": [
        "conflictuel"
    ],
    "conflit": [
        "conflit"
    ],
    "conflits": [
        "conflit"
    ],
    "confluaient": [
        "confluer"
    ],
    "confluait": [
        "confluer"
    ],
    "confluant": [
        "confluer"
    ],
    "conflue": [
        "confluer"
    ],
    "confluence": [
        "confluence"
    ],
    "confluent": [
        "confluent",
        "confluer"
    ],
    "confluents": [
        "confluent"
    ],
    "confluer": [
        "confluer"
    ],
    "confond": [
        "confondre"
    ],
    "confondaient": [
        "confondre"
    ],
    "confondais": [
        "confondre"
    ],
    "confondait": [
        "confondre"
    ],
    "confondant": [
        "confondant",
        "confondre"
    ],
    "confondante": [
        "confondant"
    ],
    "confondantes": [
        "confondant"
    ],
    "confondants": [
        "confondant"
    ],
    "confonde": [
        "confondre"
    ],
    "confondent": [
        "confondre"
    ],
    "confondez": [
        "confondre"
    ],
    "confondions": [
        "confondre"
    ],
    "confondirent": [
        "confondre"
    ],
    "confondis": [
        "confondre"
    ],
    "confondit": [
        "confondre"
    ],
    "confondons": [
        "confondre"
    ],
    "confondra": [
        "confondre"
    ],
    "confondrai": [
        "confondre"
    ],
    "confondrais": [
        "confondre"
    ],
    "confondrait": [
        "confondre"
    ],
    "confondre": [
        "confondre"
    ],
    "confondrez": [
        "confondre"
    ],
    "confondront": [
        "confondre"
    ],
    "confonds": [
        "confondre"
    ],
    "confondu": [
        "confondu",
        "confondre"
    ],
    "confondue": [
        "confondu",
        "confondre"
    ],
    "confondues": [
        "confondu",
        "confondre"
    ],
    "confondus": [
        "confondu",
        "confondre"
    ],
    "conformai": [
        "conformer"
    ],
    "conformaient": [
        "conformer"
    ],
    "conformais": [
        "conformer"
    ],
    "conformait": [
        "conformer"
    ],
    "conformant": [
        "conformer"
    ],
    "conformation": [
        "conformation"
    ],
    "conforme": [
        "conforme",
        "conformer"
    ],
    "conforment": [
        "conformer"
    ],
    "conformer": [
        "conformer"
    ],
    "conformera": [
        "conformer"
    ],
    "conformerai": [
        "conformer"
    ],
    "conformeraient": [
        "conformer"
    ],
    "conformerez": [
        "conformer"
    ],
    "conformes": [
        "conforme"
    ],
    "conformisme": [
        "conformisme"
    ],
    "conformismes": [
        "conformisme"
    ],
    "conformiste": [
        "conformiste"
    ],
    "conformistes": [
        "conformiste"
    ],
    "conformite": [
        "conformite"
    ],
    "conformat": [
        "conformer"
    ],
    "conformee": [
        "conformer"
    ],
    "conformement": [
        "conformement"
    ],
    "confort": [
        "confort"
    ],
    "conforta": [
        "conforter"
    ],
    "confortable": [
        "confortable"
    ],
    "confortablement": [
        "confortablement"
    ],
    "confortables": [
        "confortable"
    ],
    "confortaient": [
        "conforter"
    ],
    "confortait": [
        "conforter"
    ],
    "confortant": [
        "conforter"
    ],
    "conforte": [
        "conforter"
    ],
    "conforter": [
        "conforter"
    ],
    "conforterait": [
        "conforter"
    ],
    "conforts": [
        "confort"
    ],
    "confortee": [
        "conforter"
    ],
    "confraternel": [
        "confraternel"
    ],
    "confraternelle": [
        "confraternel"
    ],
    "confraternellement": [
        "confraternellement"
    ],
    "confraternelles": [
        "confraternel"
    ],
    "confraternels": [
        "confraternel"
    ],
    "confraternite": [
        "confraternite"
    ],
    "confrontai": [
        "confronter"
    ],
    "confrontaient": [
        "confronter"
    ],
    "confrontais": [
        "confronter"
    ],
    "confrontait": [
        "confronter"
    ],
    "confrontant": [
        "confronter"
    ],
    "confrontation": [
        "confrontation"
    ],
    "confrontations": [
        "confrontation"
    ],
    "confronte": [
        "confronte",
        "confronter"
    ],
    "confrontent": [
        "confronter"
    ],
    "confronter": [
        "confronter"
    ],
    "confrontez": [
        "confronter"
    ],
    "confrontons": [
        "confronter"
    ],
    "confronterent": [
        "confronter"
    ],
    "confrontee": [
        "confronte",
        "confronter"
    ],
    "confrontees": [
        "confronte",
        "confronter"
    ],
    "confrontes": [
        "confronte",
        "confronter"
    ],
    "confrere": [
        "confrere"
    ],
    "confreres": [
        "confrere"
    ],
    "confrerie": [
        "confrerie"
    ],
    "confreries": [
        "confrerie"
    ],
    "confucianisme": [
        "confucianisme"
    ],
    "confuceenne": [
        "confuceen"
    ],
    "confus": [
        "confus"
    ],
    "confuse": [
        "confus"
    ],
    "confuses": [
        "confuse",
        "confus"
    ],
    "confusion": [
        "confusion"
    ],
    "confusionnisme": [
        "confusionnisme"
    ],
    "confusions": [
        "confusion"
    ],
    "confusement": [
        "confusement"
    ],
    "confere": [
        "confere",
        "conferer"
    ],
    "conferent": [
        "conferer"
    ],
    "confederal": [
        "confederal"
    ],
    "confederation": [
        "confederation"
    ],
    "confederaux": [
        "confederal"
    ],
    "confederer": [
        "confederer"
    ],
    "confedere": [
        "confedere",
        "confederer"
    ],
    "confederee": [
        "confedere"
    ],
    "confederes": [
        "confedere",
        "confederer"
    ],
    "confera": [
        "conferer"
    ],
    "conferaient": [
        "conferer"
    ],
    "conferais": [
        "conferer"
    ],
    "conferait": [
        "conferer"
    ],
    "conferant": [
        "conferer"
    ],
    "conference": [
        "conference"
    ],
    "conferences": [
        "conference"
    ],
    "conferencier": [
        "conferencier"
    ],
    "conferenciers": [
        "conferencier"
    ],
    "conferenciere": [
        "conferencier"
    ],
    "conferents": [
        "conferent"
    ],
    "conferer": [
        "conferer"
    ],
    "conferera": [
        "conferer"
    ],
    "confereraient": [
        "conferer"
    ],
    "confererait": [
        "conferer"
    ],
    "confererez": [
        "conferer"
    ],
    "confereront": [
        "conferer"
    ],
    "conferez": [
        "conferer"
    ],
    "conferat": [
        "conferer"
    ],
    "confererent": [
        "conferer"
    ],
    "conferee": [
        "conferer"
    ],
    "conferees": [
        "confere",
        "conferer"
    ],
    "conferes": [
        "confere",
        "conferer"
    ],
    "conga": [
        "conga"
    ],
    "congas": [
        "conga"
    ],
    "congayes": [
        "congaye"
    ],
    "congais": [
        "congai"
    ],
    "congela": [
        "congeler"
    ],
    "congelait": [
        "congeler"
    ],
    "congelant": [
        "congeler"
    ],
    "congeler": [
        "congeler"
    ],
    "congelez": [
        "congeler"
    ],
    "congelons": [
        "congeler"
    ],
    "congele": [
        "congele",
        "congeler"
    ],
    "congelee": [
        "congele",
        "congeler"
    ],
    "congelees": [
        "congele",
        "congeler"
    ],
    "congeles": [
        "congele",
        "congeler"
    ],
    "congestif": [
        "congestif"
    ],
    "congestion": [
        "congestion"
    ],
    "congestionnaient": [
        "congestionner"
    ],
    "congestionnait": [
        "congestionner"
    ],
    "congestionne": [
        "congestionner",
        "congestionne"
    ],
    "congestionnent": [
        "congestionner"
    ],
    "congestionnee": [
        "congestionner",
        "congestionne"
    ],
    "congestionnees": [
        "congestionne"
    ],
    "congestionnes": [
        "congestionner",
        "congestionne"
    ],
    "congestions": [
        "congestion"
    ],
    "congestive": [
        "congestif"
    ],
    "conglobation": [
        "conglobation"
    ],
    "conglomerat": [
        "conglomerat"
    ],
    "conglomerats": [
        "conglomerat"
    ],
    "conglomeree": [
        "conglomerer"
    ],
    "congolais": [
        "congolais"
    ],
    "congolaise": [
        "congolais"
    ],
    "congratula": [
        "congratuler"
    ],
    "congratulaient": [
        "congratuler"
    ],
    "congratulait": [
        "congratuler"
    ],
    "congratulant": [
        "congratuler"
    ],
    "congratulations": [
        "congratulation"
    ],
    "congratule": [
        "congratuler"
    ],
    "congratulent": [
        "congratuler"
    ],
    "congratuler": [
        "congratuler"
    ],
    "congratulions": [
        "congratuler"
    ],
    "congratulames": [
        "congratuler"
    ],
    "congratulerent": [
        "congratuler"
    ],
    "congratules": [
        "congratuler"
    ],
    "congre": [
        "congre"
    ],
    "congres": [
        "congre",
        "congres"
    ],
    "congressistes": [
        "congressiste"
    ],
    "congrue": [
        "congru"
    ],
    "congreganiste": [
        "congreganiste"
    ],
    "congregation": [
        "congregation"
    ],
    "congregationaliste": [
        "congregationaliste"
    ],
    "congregations": [
        "congregation"
    ],
    "congrument": [
        "congrument"
    ],
    "congelera": [
        "congeler"
    ],
    "congelerais": [
        "congeler"
    ],
    "congere": [
        "congere"
    ],
    "congeres": [
        "congere"
    ],
    "conge": [
        "conge"
    ],
    "congedia": [
        "congedier"
    ],
    "congediai": [
        "congedier"
    ],
    "congediait": [
        "congedier"
    ],
    "congediant": [
        "congedier"
    ],
    "congedie": [
        "congedie",
        "congedier"
    ],
    "congediement": [
        "congediement"
    ],
    "congedient": [
        "congedier"
    ],
    "congedier": [
        "congedier"
    ],
    "congediez": [
        "congedier"
    ],
    "congediee": [
        "congedie",
        "congedier"
    ],
    "congediees": [
        "congedier"
    ],
    "congedies": [
        "congedier"
    ],
    "congelateur": [
        "congelateur"
    ],
    "congelateurs": [
        "congelateur"
    ],
    "congelation": [
        "congelation"
    ],
    "congenital": [
        "congenital"
    ],
    "congenitale": [
        "congenital"
    ],
    "congenitalement": [
        "congenitalement"
    ],
    "congenitales": [
        "congenital"
    ],
    "congenitaux": [
        "congenital"
    ],
    "congenere": [
        "congenere"
    ],
    "congeneres": [
        "congenere"
    ],
    "conges": [
        "conge"
    ],
    "conifere": [
        "conifere"
    ],
    "coniferes": [
        "conifere"
    ],
    "conique": [
        "conique"
    ],
    "coniques": [
        "conique"
    ],
    "conjecturai": [
        "conjecturer"
    ],
    "conjectural": [
        "conjectural"
    ],
    "conjecturale": [
        "conjectural"
    ],
    "conjecture": [
        "conjecturer",
        "conjecture"
    ],
    "conjecturent": [
        "conjecturer"
    ],
    "conjecturer": [
        "conjecturer"
    ],
    "conjectures": [
        "conjecturer",
        "conjecture"
    ],
    "conjoindre": [
        "conjoindre"
    ],
    "conjoint": [
        "conjoindre",
        "conjoint"
    ],
    "conjointe": [
        "conjoint"
    ],
    "conjointement": [
        "conjointement"
    ],
    "conjointes": [
        "conjoint"
    ],
    "conjoints": [
        "conjoindre",
        "conjoint"
    ],
    "conjoncteur": [
        "conjoncteur"
    ],
    "conjonctif": [
        "conjonctif"
    ],
    "conjonction": [
        "conjonction"
    ],
    "conjonctions": [
        "conjonction"
    ],
    "conjonctive": [
        "conjonctive",
        "conjonctif"
    ],
    "conjonctives": [
        "conjonctive",
        "conjonctif"
    ],
    "conjonctivite": [
        "conjonctivite"
    ],
    "conjonctivites": [
        "conjonctivite"
    ],
    "conjoncture": [
        "conjoncture"
    ],
    "conjonctures": [
        "conjoncture"
    ],
    "conjugaison": [
        "conjugaison"
    ],
    "conjugaisons": [
        "conjugaison"
    ],
    "conjugal": [
        "conjugal"
    ],
    "conjugale": [
        "conjugal"
    ],
    "conjugalement": [
        "conjugalement"
    ],
    "conjugales": [
        "conjugal"
    ],
    "conjugalite": [
        "conjugalite"
    ],
    "conjugaux": [
        "conjugal"
    ],
    "conjuguaient": [
        "conjuguer"
    ],
    "conjuguait": [
        "conjuguer"
    ],
    "conjuguant": [
        "conjuguer"
    ],
    "conjugue": [
        "conjuguer",
        "conjugue"
    ],
    "conjuguent": [
        "conjuguer"
    ],
    "conjuguer": [
        "conjuguer"
    ],
    "conjuguerions": [
        "conjuguer"
    ],
    "conjugues": [
        "conjuguer"
    ],
    "conjuguee": [
        "conjuguer",
        "conjugue"
    ],
    "conjuguees": [
        "conjuguer"
    ],
    "conjungo": [
        "conjungo"
    ],
    "conjungos": [
        "conjungo"
    ],
    "conjura": [
        "conjurer"
    ],
    "conjurait": [
        "conjurer"
    ],
    "conjurant": [
        "conjurer"
    ],
    "conjurateur": [
        "conjurateur"
    ],
    "conjuration": [
        "conjuration"
    ],
    "conjurations": [
        "conjuration"
    ],
    "conjuratoire": [
        "conjuratoire"
    ],
    "conjure": [
        "conjure",
        "conjurer"
    ],
    "conjurer": [
        "conjurer"
    ],
    "conjurera": [
        "conjurer"
    ],
    "conjuree": [
        "conjure",
        "conjurer"
    ],
    "conjurees": [
        "conjurer"
    ],
    "conjures": [
        "conjure",
        "conjurer"
    ],
    "connais": [
        "connaitre",
        "connais"
    ],
    "connaissable": [
        "connaissable"
    ],
    "connaissables": [
        "connaissable"
    ],
    "connaissaient": [
        "connaitre"
    ],
    "connaissais": [
        "connaitre"
    ],
    "connaissait": [
        "connaitre"
    ],
    "connaissance": [
        "connaissance"
    ],
    "connaissances": [
        "connaissance"
    ],
    "connaissant": [
        "connaitre",
        "connaissant"
    ],
    "connaisse": [
        "connaitre"
    ],
    "connaissement": [
        "connaissement"
    ],
    "connaissements": [
        "connaissement"
    ],
    "connaissent": [
        "connaitre"
    ],
    "connaisses": [
        "connaitre"
    ],
    "connaisseur": [
        "connaisseur"
    ],
    "connaisseurs": [
        "connaisseur"
    ],
    "connaisseuse": [
        "connaisseur"
    ],
    "connaisseuses": [
        "connaisseur"
    ],
    "connaissez": [
        "connaitre"
    ],
    "connaissiez": [
        "connaitre"
    ],
    "connaissions": [
        "connaitre"
    ],
    "connaissons": [
        "connaitre"
    ],
    "connard": [
        "connard"
    ],
    "connards": [
        "connard"
    ],
    "connasse": [
        "connasse"
    ],
    "connasses": [
        "connasse"
    ],
    "connait": [
        "connaitre"
    ],
    "connaitra": [
        "connaitre"
    ],
    "connaitrai": [
        "connaitre"
    ],
    "connaitraient": [
        "connaitre"
    ],
    "connaitrais": [
        "connaitre"
    ],
    "connaitrait": [
        "connaitre"
    ],
    "connaitras": [
        "connaitre"
    ],
    "connaitre": [
        "connaitre"
    ],
    "connaitrez": [
        "connaitre"
    ],
    "connaitriez": [
        "connaitre"
    ],
    "connaitrions": [
        "connaitre"
    ],
    "connaitrons": [
        "connaitre"
    ],
    "connaitront": [
        "connaitre"
    ],
    "conne": [
        "con"
    ],
    "conneau": [
        "conneau"
    ],
    "conneaux": [
        "conneau"
    ],
    "connectant": [
        "connecter"
    ],
    "connecte": [
        "connecter"
    ],
    "connectent": [
        "connecter"
    ],
    "connecter": [
        "connecter"
    ],
    "connectera": [
        "connecter"
    ],
    "connecteur": [
        "connecteur"
    ],
    "connectez": [
        "connecter"
    ],
    "connectiez": [
        "connecter"
    ],
    "connections": [
        "connection",
        "connecter"
    ],
    "connectivite": [
        "connectivite"
    ],
    "connectons": [
        "connecter"
    ],
    "connectee": [
        "connecter"
    ],
    "connectees": [
        "connecter"
    ],
    "connectes": [
        "connecter"
    ],
    "connement": [
        "connement"
    ],
    "connerie": [
        "connerie"
    ],
    "conneries": [
        "connerie"
    ],
    "connes": [
        "con"
    ],
    "connexe": [
        "connexe"
    ],
    "connexes": [
        "connexe"
    ],
    "connexion": [
        "connexion"
    ],
    "connexions": [
        "connexion"
    ],
    "connils": [
        "connil"
    ],
    "connivence": [
        "connivence"
    ],
    "connivences": [
        "connivence"
    ],
    "connotation": [
        "connotation"
    ],
    "connotations": [
        "connotation"
    ],
    "connu": [
        "connaitre",
        "connu"
    ],
    "connue": [
        "connaitre",
        "connu"
    ],
    "connues": [
        "connaitre",
        "connu"
    ],
    "connurent": [
        "connaitre"
    ],
    "connus": [
        "connaitre",
        "connu"
    ],
    "connusse": [
        "connaitre"
    ],
    "connussent": [
        "connaitre"
    ],
    "connusses": [
        "connaitre"
    ],
    "connut": [
        "connaitre"
    ],
    "connetable": [
        "connetable"
    ],
    "connetables": [
        "connetable"
    ],
    "connumes": [
        "connaitre"
    ],
    "conoidaux": [
        "conoidal"
    ],
    "conoide": [
        "conoide"
    ],
    "conque": [
        "conque"
    ],
    "conquerra": [
        "conquerir"
    ],
    "conquerraient": [
        "conquerir"
    ],
    "conquerrons": [
        "conquerir"
    ],
    "conquerront": [
        "conquerir"
    ],
    "conques": [
        "conque"
    ],
    "conquiers": [
        "conquerir"
    ],
    "conquiert": [
        "conquerir"
    ],
    "conquirent": [
        "conquerir"
    ],
    "conquis": [
        "conquis",
        "conquerir"
    ],
    "conquise": [
        "conquis",
        "conquerir"
    ],
    "conquises": [
        "conquis",
        "conquerir"
    ],
    "conquistador": [
        "conquistador"
    ],
    "conquistadores": [
        "conquistador"
    ],
    "conquistadors": [
        "conquistador"
    ],
    "conquit": [
        "conquerir"
    ],
    "conquiere": [
        "conquerir"
    ],
    "conquierent": [
        "conquerir"
    ],
    "conquerait": [
        "conquerir"
    ],
    "conquerant": [
        "conquerant",
        "conquerir"
    ],
    "conquerante": [
        "conquerant"
    ],
    "conquerantes": [
        "conquerant"
    ],
    "conquerants": [
        "conquerant"
    ],
    "conquerez": [
        "conquerir"
    ],
    "conquerir": [
        "conquerir"
    ],
    "conquerons": [
        "conquerir"
    ],
    "conquete": [
        "conquete"
    ],
    "conquetes": [
        "conquete"
    ],
    "cons": [
        "con"
    ],
    "consacra": [
        "consacrer"
    ],
    "consacrai": [
        "consacrer"
    ],
    "consacraient": [
        "consacrer"
    ],
    "consacrais": [
        "consacrer"
    ],
    "consacrait": [
        "consacrer"
    ],
    "consacrant": [
        "consacrant",
        "consacrer"
    ],
    "consacre": [
        "consacrer",
        "consacre"
    ],
    "consacrent": [
        "consacrer"
    ],
    "consacrer": [
        "consacrer"
    ],
    "consacrera": [
        "consacrer"
    ],
    "consacrerai": [
        "consacrer"
    ],
    "consacreraient": [
        "consacrer"
    ],
    "consacrerais": [
        "consacrer"
    ],
    "consacrerait": [
        "consacrer"
    ],
    "consacreras": [
        "consacrer"
    ],
    "consacrerez": [
        "consacrer"
    ],
    "consacreriez": [
        "consacrer"
    ],
    "consacrerions": [
        "consacrer"
    ],
    "consacreront": [
        "consacrer"
    ],
    "consacres": [
        "consacrer",
        "consacre"
    ],
    "consacrez": [
        "consacrer"
    ],
    "consacriez": [
        "consacrer"
    ],
    "consacrons": [
        "consacrer"
    ],
    "consacrerent": [
        "consacrer"
    ],
    "consacree": [
        "consacrer",
        "consacre"
    ],
    "consacrees": [
        "consacrer",
        "consacre"
    ],
    "consanguin": [
        "consanguin"
    ],
    "consanguine": [
        "consanguin"
    ],
    "consanguinite": [
        "consanguinite"
    ],
    "consanguinites": [
        "consanguinite"
    ],
    "consanguins": [
        "consanguin"
    ],
    "consciemment": [
        "consciemment"
    ],
    "conscience": [
        "conscience"
    ],
    "consciences": [
        "conscience"
    ],
    "consciencieuse": [
        "consciencieux"
    ],
    "consciencieusement": [
        "consciencieusement"
    ],
    "consciencieuses": [
        "consciencieux"
    ],
    "consciencieux": [
        "consciencieux"
    ],
    "conscient": [
        "conscient"
    ],
    "consciente": [
        "conscient"
    ],
    "conscientes": [
        "conscient"
    ],
    "conscients": [
        "conscient"
    ],
    "conscription": [
        "conscription"
    ],
    "conscrit": [
        "conscrit"
    ],
    "conscrits": [
        "conscrit"
    ],
    "conseil": [
        "conseil"
    ],
    "conseilla": [
        "conseiller"
    ],
    "conseillai": [
        "conseiller"
    ],
    "conseillaient": [
        "conseiller"
    ],
    "conseillais": [
        "conseiller"
    ],
    "conseillait": [
        "conseiller"
    ],
    "conseillant": [
        "conseiller"
    ],
    "conseille": [
        "conseiller"
    ],
    "conseillent": [
        "conseiller"
    ],
    "conseiller": [
        "conseiller"
    ],
    "conseillera": [
        "conseiller"
    ],
    "conseillerai": [
        "conseiller"
    ],
    "conseillerais": [
        "conseiller"
    ],
    "conseillerait": [
        "conseiller"
    ],
    "conseillerez": [
        "conseiller"
    ],
    "conseilleriez": [
        "conseiller"
    ],
    "conseillers": [
        "conseiller"
    ],
    "conseilles": [
        "conseiller"
    ],
    "conseilleurs": [
        "conseilleur"
    ],
    "conseillez": [
        "conseiller"
    ],
    "conseillons": [
        "conseiller"
    ],
    "conseillere": [
        "conseiller"
    ],
    "conseillerent": [
        "conseiller"
    ],
    "conseilleres": [
        "conseiller"
    ],
    "conseillee": [
        "conseiller"
    ],
    "conseillees": [
        "conseiller"
    ],
    "conseils": [
        "conseil"
    ],
    "consens": [
        "consentir"
    ],
    "consensuel": [
        "consensuel"
    ],
    "consensuelle": [
        "consensuel"
    ],
    "consensus": [
        "consensus"
    ],
    "consent": [
        "consentir"
    ],
    "consentaient": [
        "consentir"
    ],
    "consentais": [
        "consentir"
    ],
    "consentait": [
        "consentir"
    ],
    "consentant": [
        "consentir",
        "consentant"
    ],
    "consentante": [
        "consentant"
    ],
    "consentantes": [
        "consentant"
    ],
    "consentants": [
        "consentant"
    ],
    "consente": [
        "consentir"
    ],
    "consentement": [
        "consentement"
    ],
    "consentements": [
        "consentement"
    ],
    "consentent": [
        "consentir"
    ],
    "consentes": [
        "consentir"
    ],
    "consentez": [
        "consentir"
    ],
    "consenti": [
        "consentir"
    ],
    "consentie": [
        "consentir"
    ],
    "consenties": [
        "consentir"
    ],
    "consentiez": [
        "consentir"
    ],
    "consentions": [
        "consentir"
    ],
    "consentir": [
        "consentir"
    ],
    "consentira": [
        "consentir"
    ],
    "consentirai": [
        "consentir"
    ],
    "consentiraient": [
        "consentir"
    ],
    "consentirais": [
        "consentir"
    ],
    "consentirait": [
        "consentir"
    ],
    "consentiras": [
        "consentir"
    ],
    "consentirent": [
        "consentir"
    ],
    "consentirez": [
        "consentir"
    ],
    "consentiriez": [
        "consentir"
    ],
    "consentirions": [
        "consentir"
    ],
    "consentiront": [
        "consentir"
    ],
    "consentis": [
        "consentir"
    ],
    "consentisse": [
        "consentir"
    ],
    "consentissent": [
        "consentir"
    ],
    "consentit": [
        "consentir"
    ],
    "consentons": [
        "consentir"
    ],
    "conserva": [
        "conserver"
    ],
    "conservai": [
        "conserver"
    ],
    "conservaient": [
        "conserver"
    ],
    "conservais": [
        "conserver"
    ],
    "conservait": [
        "conserver"
    ],
    "conservant": [
        "conserver"
    ],
    "conservateur": [
        "conservateur"
    ],
    "conservateurs": [
        "conservateur"
    ],
    "conservation": [
        "conservation"
    ],
    "conservatisme": [
        "conservatisme"
    ],
    "conservatoire": [
        "conservatoire"
    ],
    "conservatoires": [
        "conservatoire"
    ],
    "conservatrice": [
        "conservateur",
        "conservatrice"
    ],
    "conservatrices": [
        "conservateur",
        "conservatrice"
    ],
    "conserve": [
        "conserve",
        "conserver"
    ],
    "conservent": [
        "conserver"
    ],
    "conserver": [
        "conserver"
    ],
    "conservera": [
        "conserver"
    ],
    "conserverai": [
        "conserver"
    ],
    "conserveraient": [
        "conserver"
    ],
    "conserverais": [
        "conserver"
    ],
    "conserverait": [
        "conserver"
    ],
    "conserveras": [
        "conserver"
    ],
    "conserverez": [
        "conserver"
    ],
    "conserverie": [
        "conserverie"
    ],
    "conserveries": [
        "conserverie"
    ],
    "conserverons": [
        "conserver"
    ],
    "conserveront": [
        "conserver"
    ],
    "conserves": [
        "conserve",
        "conserver"
    ],
    "conservez": [
        "conserver"
    ],
    "conserviez": [
        "conserver"
    ],
    "conservions": [
        "conserver"
    ],
    "conservons": [
        "conserver"
    ],
    "conservat": [
        "conserver"
    ],
    "conserverent": [
        "conserver"
    ],
    "conservee": [
        "conserve",
        "conserver"
    ],
    "conservees": [
        "conserve",
        "conserver"
    ],
    "considere": [
        "considerer"
    ],
    "considerent": [
        "considerer"
    ],
    "consideres": [
        "considerer"
    ],
    "considera": [
        "considerer"
    ],
    "considerable": [
        "considerable"
    ],
    "considerablement": [
        "considerablement"
    ],
    "considerables": [
        "considerable"
    ],
    "considerai": [
        "considerer"
    ],
    "consideraient": [
        "considerer"
    ],
    "considerais": [
        "considerer"
    ],
    "considerait": [
        "considerer"
    ],
    "considerant": [
        "considerant",
        "considerer"
    ],
    "considerants": [
        "considerant"
    ],
    "considerassent": [
        "considerer"
    ],
    "consideration": [
        "consideration"
    ],
    "considerations": [
        "consideration"
    ],
    "considerer": [
        "considerer"
    ],
    "considerera": [
        "considerer"
    ],
    "considererai": [
        "considerer"
    ],
    "considereraient": [
        "considerer"
    ],
    "considererais": [
        "considerer"
    ],
    "considererait": [
        "considerer"
    ],
    "considereras": [
        "considerer"
    ],
    "considereriez": [
        "considerer"
    ],
    "considererions": [
        "considerer"
    ],
    "considererons": [
        "considerer"
    ],
    "considerez": [
        "considerer"
    ],
    "consideriez": [
        "considerer"
    ],
    "considerions": [
        "considerer"
    ],
    "considerons": [
        "considerer"
    ],
    "considerat": [
        "considerer"
    ],
    "considererent": [
        "considerer"
    ],
    "consideree": [
        "considerer"
    ],
    "considerees": [
        "considerer"
    ],
    "consigna": [
        "consigner"
    ],
    "consignais": [
        "consigner"
    ],
    "consignait": [
        "consigner"
    ],
    "consignant": [
        "consigner"
    ],
    "consignataire": [
        "consignataire"
    ],
    "consignation": [
        "consignation"
    ],
    "consignations": [
        "consignation"
    ],
    "consigne": [
        "consigner",
        "consigne"
    ],
    "consignent": [
        "consigner"
    ],
    "consigner": [
        "consigner"
    ],
    "consignera": [
        "consigner"
    ],
    "consignerais": [
        "consigner"
    ],
    "consignes": [
        "consigner",
        "consigne"
    ],
    "consignez": [
        "consigner"
    ],
    "consignee": [
        "consigner",
        "consigne"
    ],
    "consignees": [
        "consigner",
        "consigne"
    ],
    "consista": [
        "consister"
    ],
    "consistaient": [
        "consister"
    ],
    "consistait": [
        "consister"
    ],
    "consistance": [
        "consistance"
    ],
    "consistances": [
        "consistance"
    ],
    "consistant": [
        "consistant",
        "consister"
    ],
    "consistante": [
        "consistant"
    ],
    "consistantes": [
        "consistant"
    ],
    "consistants": [
        "consistant"
    ],
    "consiste": [
        "consister"
    ],
    "consistent": [
        "consister"
    ],
    "consister": [
        "consister"
    ],
    "consistera": [
        "consister"
    ],
    "consisteraient": [
        "consister"
    ],
    "consisterait": [
        "consister"
    ],
    "consistoire": [
        "consistoire"
    ],
    "consistorial": [
        "consistorial"
    ],
    "consistoriales": [
        "consistorial"
    ],
    "consisterent": [
        "consister"
    ],
    "conso": [
        "conso"
    ],
    "consoeur": [
        "consoeur"
    ],
    "consoeurs": [
        "consoeur"
    ],
    "consola": [
        "consoler"
    ],
    "consolai": [
        "consoler"
    ],
    "consolaient": [
        "consoler"
    ],
    "consolais": [
        "consoler"
    ],
    "consolait": [
        "consoler"
    ],
    "consolant": [
        "consoler",
        "consolant"
    ],
    "consolante": [
        "consolant"
    ],
    "consolantes": [
        "consolant"
    ],
    "consolants": [
        "consolant"
    ],
    "consolasse": [
        "consoler"
    ],
    "consolateur": [
        "consolateur"
    ],
    "consolateurs": [
        "consolateur"
    ],
    "consolation": [
        "consolation"
    ],
    "consolations": [
        "consolation"
    ],
    "consolatrice": [
        "consolateur"
    ],
    "consolatrices": [
        "consolateur"
    ],
    "console": [
        "consoler",
        "console"
    ],
    "consolent": [
        "consoler"
    ],
    "consoler": [
        "consoler"
    ],
    "consolera": [
        "consoler"
    ],
    "consolerai": [
        "consoler"
    ],
    "consoleraient": [
        "consoler"
    ],
    "consolerais": [
        "consoler"
    ],
    "consolerait": [
        "consoler"
    ],
    "consoleras": [
        "consoler"
    ],
    "consolerez": [
        "consoler"
    ],
    "consolerons": [
        "consoler"
    ],
    "consoleront": [
        "consoler"
    ],
    "consoles": [
        "consoler",
        "console"
    ],
    "consolez": [
        "consoler"
    ],
    "consolidaient": [
        "consolider"
    ],
    "consolidais": [
        "consolider"
    ],
    "consolidait": [
        "consolider"
    ],
    "consolidant": [
        "consolider"
    ],
    "consolidation": [
        "consolidation"
    ],
    "consolide": [
        "consolide",
        "consolider"
    ],
    "consolident": [
        "consolider"
    ],
    "consolider": [
        "consolider"
    ],
    "consolideraient": [
        "consolider"
    ],
    "consolidons": [
        "consolider"
    ],
    "consolidee": [
        "consolide",
        "consolider"
    ],
    "consolidees": [
        "consolide",
        "consolider"
    ],
    "consolides": [
        "consolide",
        "consolider"
    ],
    "consoliez": [
        "consoler"
    ],
    "consolions": [
        "consoler"
    ],
    "consolat": [
        "consoler"
    ],
    "consolerent": [
        "consoler"
    ],
    "consolee": [
        "consoler"
    ],
    "consolees": [
        "consoler"
    ],
    "consomma": [
        "consommer"
    ],
    "consommable": [
        "consommable"
    ],
    "consommables": [
        "consommable"
    ],
    "consommai": [
        "consommer"
    ],
    "consommaient": [
        "consommer"
    ],
    "consommait": [
        "consommer"
    ],
    "consommant": [
        "consommer"
    ],
    "consommateur": [
        "consommateur"
    ],
    "consommateurs": [
        "consommateur"
    ],
    "consommation": [
        "consommation"
    ],
    "consommations": [
        "consommation"
    ],
    "consommatrice": [
        "consommateur"
    ],
    "consommatrices": [
        "consommateur"
    ],
    "consomme": [
        "consommer",
        "consomme"
    ],
    "consomment": [
        "consommer"
    ],
    "consommer": [
        "consommer"
    ],
    "consommerait": [
        "consommer"
    ],
    "consommeront": [
        "consommer"
    ],
    "consommez": [
        "consommer"
    ],
    "consommions": [
        "consommer"
    ],
    "consommons": [
        "consommer"
    ],
    "consommee": [
        "consommer",
        "consomme"
    ],
    "consommees": [
        "consommer"
    ],
    "consommes": [
        "consommer",
        "consomme"
    ],
    "consomption": [
        "consomption"
    ],
    "consomptive": [
        "consomptif"
    ],
    "consonance": [
        "consonance"
    ],
    "consonances": [
        "consonance"
    ],
    "consonne": [
        "consonne"
    ],
    "consonnes": [
        "consonne"
    ],
    "consort": [
        "consort"
    ],
    "consortium": [
        "consortium"
    ],
    "consortiums": [
        "consortium"
    ],
    "consorts": [
        "consort"
    ],
    "consos": [
        "conso"
    ],
    "consoude": [
        "consoude"
    ],
    "conspiraient": [
        "conspirer"
    ],
    "conspirait": [
        "conspirer"
    ],
    "conspirant": [
        "conspirer"
    ],
    "conspirateur": [
        "conspirateur"
    ],
    "conspirateurs": [
        "conspirateur"
    ],
    "conspiratif": [
        "conspiratif"
    ],
    "conspiration": [
        "conspiration"
    ],
    "conspirations": [
        "conspiration"
    ],
    "conspiratrice": [
        "conspirateur"
    ],
    "conspiratrices": [
        "conspirateur"
    ],
    "conspire": [
        "conspirer"
    ],
    "conspirent": [
        "conspirer"
    ],
    "conspirer": [
        "conspirer"
    ],
    "conspirez": [
        "conspirer"
    ],
    "conspuaient": [
        "conspuer"
    ],
    "conspuant": [
        "conspuer"
    ],
    "conspue": [
        "conspuer"
    ],
    "conspuer": [
        "conspuer"
    ],
    "conspuerent": [
        "conspuer"
    ],
    "conspues": [
        "conspuer"
    ],
    "constable": [
        "constable"
    ],
    "constamment": [
        "constamment"
    ],
    "constance": [
        "constance"
    ],
    "constances": [
        "constance"
    ],
    "constant": [
        "constant"
    ],
    "constante": [
        "constant",
        "constante"
    ],
    "constantes": [
        "constant",
        "constante"
    ],
    "constants": [
        "constant"
    ],
    "constat": [
        "constat"
    ],
    "constata": [
        "constater"
    ],
    "constatai": [
        "constater"
    ],
    "constataient": [
        "constater"
    ],
    "constatais": [
        "constater"
    ],
    "constatait": [
        "constater"
    ],
    "constatant": [
        "constater"
    ],
    "constatation": [
        "constatation"
    ],
    "constatations": [
        "constatation"
    ],
    "constate": [
        "constater"
    ],
    "constatent": [
        "constater"
    ],
    "constater": [
        "constater"
    ],
    "constatera": [
        "constater"
    ],
    "constaterai": [
        "constater"
    ],
    "constateraient": [
        "constater"
    ],
    "constaterais": [
        "constater"
    ],
    "constaterait": [
        "constater"
    ],
    "constateras": [
        "constater"
    ],
    "constaterez": [
        "constater"
    ],
    "constateriez": [
        "constater"
    ],
    "constatez": [
        "constater"
    ],
    "constatiez": [
        "constater"
    ],
    "constations": [
        "constater"
    ],
    "constatons": [
        "constater"
    ],
    "constats": [
        "constat"
    ],
    "constatames": [
        "constater"
    ],
    "constaterent": [
        "constater"
    ],
    "constatee": [
        "constater"
    ],
    "constatees": [
        "constater"
    ],
    "constates": [
        "constater"
    ],
    "constellaient": [
        "consteller"
    ],
    "constellait": [
        "consteller"
    ],
    "constellant": [
        "consteller"
    ],
    "constellation": [
        "constellation"
    ],
    "constellations": [
        "constellation"
    ],
    "constelle": [
        "constelle",
        "consteller"
    ],
    "constellent": [
        "consteller"
    ],
    "constellee": [
        "constelle",
        "consteller"
    ],
    "constellees": [
        "constelle",
        "consteller"
    ],
    "constelles": [
        "consteller"
    ],
    "consterna": [
        "consterner"
    ],
    "consternait": [
        "consterner"
    ],
    "consternant": [
        "consterner",
        "consternant"
    ],
    "consternante": [
        "consternant"
    ],
    "consternantes": [
        "consternant"
    ],
    "consternants": [
        "consternant"
    ],
    "consternation": [
        "consternation"
    ],
    "consterne": [
        "consterner",
        "consterne"
    ],
    "consternent": [
        "consterner"
    ],
    "consternee": [
        "consterner",
        "consterne"
    ],
    "consternees": [
        "consterner",
        "consterne"
    ],
    "consternes": [
        "consterner",
        "consterne"
    ],
    "constipant": [
        "constipant"
    ],
    "constipation": [
        "constipation"
    ],
    "constipations": [
        "constipation"
    ],
    "constipe": [
        "constiper",
        "constipe"
    ],
    "constipee": [
        "constiper",
        "constipe"
    ],
    "constipees": [
        "constipe"
    ],
    "constipes": [
        "constiper",
        "constipe"
    ],
    "constitua": [
        "constituer"
    ],
    "constituaient": [
        "constituer"
    ],
    "constituais": [
        "constituer"
    ],
    "constituait": [
        "constituer"
    ],
    "constituant": [
        "constituer",
        "constituant"
    ],
    "constituante": [
        "constituant"
    ],
    "constituantes": [
        "constituant"
    ],
    "constituants": [
        "constituant"
    ],
    "constitue": [
        "constituer",
        "constitue"
    ],
    "constituent": [
        "constituer"
    ],
    "constituer": [
        "constituer"
    ],
    "constituera": [
        "constituer"
    ],
    "constituerai": [
        "constituer"
    ],
    "constitueraient": [
        "constituer"
    ],
    "constituerais": [
        "constituer"
    ],
    "constituerait": [
        "constituer"
    ],
    "constitueras": [
        "constituer"
    ],
    "constitueront": [
        "constituer"
    ],
    "constituez": [
        "constituer"
    ],
    "constituions": [
        "constituer"
    ],
    "constituons": [
        "constituer"
    ],
    "constitutif": [
        "constitutif"
    ],
    "constitutifs": [
        "constitutif"
    ],
    "constitution": [
        "constitution"
    ],
    "constitutionnaliste": [
        "constitutionnaliste"
    ],
    "constitutionnalite": [
        "constitutionnalite"
    ],
    "constitutionnel": [
        "constitutionnel"
    ],
    "constitutionnelle": [
        "constitutionnel"
    ],
    "constitutionnellement": [
        "constitutionnellement"
    ],
    "constitutionnelles": [
        "constitutionnel"
    ],
    "constitutionnels": [
        "constitutionnel"
    ],
    "constitutions": [
        "constitution"
    ],
    "constituat": [
        "constituer"
    ],
    "constituerent": [
        "constituer"
    ],
    "constituee": [
        "constituer",
        "constitue"
    ],
    "constituees": [
        "constituer",
        "constitue"
    ],
    "constitues": [
        "constituer",
        "constitue"
    ],
    "constricteur": [
        "constricteur"
    ],
    "constricteurs": [
        "constricteur"
    ],
    "constriction": [
        "constriction"
    ],
    "constrictive": [
        "constrictif"
    ],
    "constrictor": [
        "constrictor"
    ],
    "constrictors": [
        "constrictor"
    ],
    "constructeur": [
        "constructeur"
    ],
    "constructeurs": [
        "constructeur"
    ],
    "constructif": [
        "constructif"
    ],
    "constructifs": [
        "constructif"
    ],
    "construction": [
        "construction"
    ],
    "constructions": [
        "construction"
    ],
    "constructive": [
        "constructif"
    ],
    "constructives": [
        "constructif"
    ],
    "constructivisme": [
        "constructivisme"
    ],
    "construira": [
        "construire"
    ],
    "construirai": [
        "construire"
    ],
    "construiraient": [
        "construire"
    ],
    "construirais": [
        "construire"
    ],
    "construirait": [
        "construire"
    ],
    "construiras": [
        "construire"
    ],
    "construire": [
        "construire"
    ],
    "construirez": [
        "construire"
    ],
    "construiriez": [
        "construire"
    ],
    "construirons": [
        "construire"
    ],
    "construiront": [
        "construire"
    ],
    "construis": [
        "construire"
    ],
    "construisaient": [
        "construire"
    ],
    "construisais": [
        "construire"
    ],
    "construisait": [
        "construire"
    ],
    "construisant": [
        "construire"
    ],
    "construise": [
        "construire"
    ],
    "construisent": [
        "construire"
    ],
    "construisez": [
        "construire"
    ],
    "construisiez": [
        "construire"
    ],
    "construisions": [
        "construire"
    ],
    "construisirent": [
        "construire"
    ],
    "construisis": [
        "construire"
    ],
    "construisit": [
        "construire"
    ],
    "construisons": [
        "construire"
    ],
    "construit": [
        "construire"
    ],
    "construite": [
        "construire"
    ],
    "construites": [
        "construire"
    ],
    "construits": [
        "construire"
    ],
    "consubstantiel": [
        "consubstantiel"
    ],
    "consubstantielle": [
        "consubstantiel"
    ],
    "consubstantiels": [
        "consubstantiel"
    ],
    "consul": [
        "consul"
    ],
    "consulaire": [
        "consulaire"
    ],
    "consulaires": [
        "consulaire"
    ],
    "consulat": [
        "consulat"
    ],
    "consulats": [
        "consulat"
    ],
    "consuls": [
        "consul"
    ],
    "consulta": [
        "consulter"
    ],
    "consultable": [
        "consultable"
    ],
    "consultai": [
        "consulter"
    ],
    "consultaient": [
        "consulter"
    ],
    "consultais": [
        "consulter"
    ],
    "consultait": [
        "consulter"
    ],
    "consultant": [
        "consulter",
        "consultant"
    ],
    "consultante": [
        "consultant"
    ],
    "consultants": [
        "consultant"
    ],
    "consultatif": [
        "consultatif"
    ],
    "consultatifs": [
        "consultatif"
    ],
    "consultation": [
        "consultation"
    ],
    "consultations": [
        "consultation"
    ],
    "consultative": [
        "consultatif"
    ],
    "consulte": [
        "consulter",
        "consulte"
    ],
    "consultent": [
        "consulter"
    ],
    "consulter": [
        "consulter"
    ],
    "consultera": [
        "consulter"
    ],
    "consulterai": [
        "consulter"
    ],
    "consulteraient": [
        "consulter"
    ],
    "consulterais": [
        "consulter"
    ],
    "consulteras": [
        "consulter"
    ],
    "consulterons": [
        "consulter"
    ],
    "consulteront": [
        "consulter"
    ],
    "consultes": [
        "consulter"
    ],
    "consultez": [
        "consulter"
    ],
    "consultions": [
        "consulter"
    ],
    "consultons": [
        "consulter"
    ],
    "consultames": [
        "consulter"
    ],
    "consulterent": [
        "consulter"
    ],
    "consultee": [
        "consulter"
    ],
    "consultees": [
        "consulter"
    ],
    "consuma": [
        "consumer"
    ],
    "consumable": [
        "consumable"
    ],
    "consumai": [
        "consumer"
    ],
    "consumaient": [
        "consumer"
    ],
    "consumais": [
        "consumer"
    ],
    "consumait": [
        "consumer"
    ],
    "consumant": [
        "consumer"
    ],
    "consumation": [
        "consumation"
    ],
    "consume": [
        "consumer"
    ],
    "consument": [
        "consumer"
    ],
    "consumer": [
        "consumer"
    ],
    "consumera": [
        "consumer"
    ],
    "consumerait": [
        "consumer"
    ],
    "consumeront": [
        "consumer"
    ],
    "consumes": [
        "consume",
        "consumer"
    ],
    "consumez": [
        "consumer"
    ],
    "consumat": [
        "consumer"
    ],
    "consumerent": [
        "consumer"
    ],
    "consumee": [
        "consumer"
    ],
    "consumees": [
        "consumer"
    ],
    "consumerisme": [
        "consumerisme"
    ],
    "consumeriste": [
        "consumeriste"
    ],
    "consecration": [
        "consecration"
    ],
    "consecutif": [
        "consecutif"
    ],
    "consecutifs": [
        "consecutif"
    ],
    "consecution": [
        "consecution"
    ],
    "consecutive": [
        "consecutif"
    ],
    "consecutivement": [
        "consecutivement"
    ],
    "consecutives": [
        "consecutif"
    ],
    "consequemment": [
        "consequemment"
    ],
    "consequence": [
        "consequence"
    ],
    "consequences": [
        "consequence"
    ],
    "consequent": [
        "consequent"
    ],
    "consequente": [
        "consequent"
    ],
    "consequentes": [
        "consequent"
    ],
    "consequents": [
        "consequent"
    ],
    "conta": [
        "conter"
    ],
    "contact": [
        "contact"
    ],
    "contacta": [
        "contacter"
    ],
    "contactais": [
        "contacter"
    ],
    "contactait": [
        "contacter"
    ],
    "contactant": [
        "contacter"
    ],
    "contacte": [
        "contacter"
    ],
    "contactent": [
        "contacter"
    ],
    "contacter": [
        "contacter"
    ],
    "contactera": [
        "contacter"
    ],
    "contacterai": [
        "contacter"
    ],
    "contacteraient": [
        "contacter"
    ],
    "contacterais": [
        "contacter"
    ],
    "contacterait": [
        "contacter"
    ],
    "contacteras": [
        "contacter"
    ],
    "contacterez": [
        "contacter"
    ],
    "contacterons": [
        "contacter"
    ],
    "contacteront": [
        "contacter"
    ],
    "contacteur": [
        "contacteur"
    ],
    "contactez": [
        "contacter"
    ],
    "contactiez": [
        "contacter"
    ],
    "contactions": [
        "contacter"
    ],
    "contactons": [
        "contacter"
    ],
    "contacts": [
        "contact"
    ],
    "contactee": [
        "contacter"
    ],
    "contactees": [
        "contacter"
    ],
    "contactes": [
        "contacter"
    ],
    "contagieuse": [
        "contagieux"
    ],
    "contagieuses": [
        "contagieux"
    ],
    "contagieux": [
        "contagieux"
    ],
    "contagion": [
        "contagion"
    ],
    "contai": [
        "conter"
    ],
    "contaient": [
        "conter"
    ],
    "container": [
        "container"
    ],
    "containers": [
        "container"
    ],
    "containeur": [
        "containeur"
    ],
    "contais": [
        "conter"
    ],
    "contait": [
        "conter"
    ],
    "contaminaient": [
        "contaminer"
    ],
    "contaminait": [
        "contaminer"
    ],
    "contaminant": [
        "contaminant",
        "contaminer"
    ],
    "contaminants": [
        "contaminant"
    ],
    "contaminateur": [
        "contaminateur"
    ],
    "contamination": [
        "contamination"
    ],
    "contaminations": [
        "contamination"
    ],
    "contamine": [
        "contaminer"
    ],
    "contaminer": [
        "contaminer"
    ],
    "contaminera": [
        "contaminer"
    ],
    "contamineras": [
        "contaminer"
    ],
    "contamines": [
        "contaminer"
    ],
    "contaminons": [
        "contaminer"
    ],
    "contaminat": [
        "contaminer"
    ],
    "contaminee": [
        "contaminer"
    ],
    "contaminees": [
        "contaminer"
    ],
    "contant": [
        "conter"
    ],
    "conte": [
        "conter",
        "conte"
    ],
    "contempla": [
        "contempler"
    ],
    "contemplai": [
        "contempler"
    ],
    "contemplaient": [
        "contempler"
    ],
    "contemplais": [
        "contempler"
    ],
    "contemplait": [
        "contempler"
    ],
    "contemplant": [
        "contempler"
    ],
    "contemplateur": [
        "contemplateur"
    ],
    "contemplatif": [
        "contemplatif"
    ],
    "contemplatifs": [
        "contemplatif"
    ],
    "contemplation": [
        "contemplation"
    ],
    "contemplations": [
        "contemplation"
    ],
    "contemplative": [
        "contemplatif"
    ],
    "contemplativement": [
        "contemplativement"
    ],
    "contemplatives": [
        "contemplatif",
        "contemplative"
    ],
    "contemplatrice": [
        "contemplateur"
    ],
    "contemple": [
        "contempler"
    ],
    "contemplent": [
        "contempler"
    ],
    "contempler": [
        "contempler"
    ],
    "contemplera": [
        "contempler"
    ],
    "contemplerai": [
        "contempler"
    ],
    "contempleraient": [
        "contempler"
    ],
    "contemplerait": [
        "contempler"
    ],
    "contempleront": [
        "contempler"
    ],
    "contemples": [
        "contempler"
    ],
    "contemplez": [
        "contempler"
    ],
    "contempliez": [
        "contempler"
    ],
    "contemplions": [
        "contempler"
    ],
    "contemplons": [
        "contempler"
    ],
    "contemplames": [
        "contempler"
    ],
    "contemplerent": [
        "contempler"
    ],
    "contemplee": [
        "contempler"
    ],
    "contemplees": [
        "contempler"
    ],
    "contemporain": [
        "contemporain"
    ],
    "contemporaine": [
        "contemporain"
    ],
    "contemporaines": [
        "contemporain"
    ],
    "contemporains": [
        "contemporain"
    ],
    "contempteur": [
        "contempteur"
    ],
    "contempteurs": [
        "contempteur"
    ],
    "contenaient": [
        "contenir"
    ],
    "contenais": [
        "contenir"
    ],
    "contenait": [
        "contenir"
    ],
    "contenance": [
        "contenance"
    ],
    "contenances": [
        "contenance"
    ],
    "contenant": [
        "contenant",
        "contenir"
    ],
    "contenants": [
        "contenant"
    ],
    "conteneur": [
        "conteneur"
    ],
    "conteneurs": [
        "conteneur"
    ],
    "contenez": [
        "contenir"
    ],
    "contenir": [
        "contenir"
    ],
    "content": [
        "content",
        "conter"
    ],
    "contenta": [
        "contenter"
    ],
    "contentai": [
        "contenter"
    ],
    "contentaient": [
        "contenter"
    ],
    "contentais": [
        "contenter"
    ],
    "contentait": [
        "contenter"
    ],
    "contentant": [
        "contenter"
    ],
    "contentassent": [
        "contenter"
    ],
    "contente": [
        "content",
        "contenter"
    ],
    "contentement": [
        "contentement"
    ],
    "contentements": [
        "contentement"
    ],
    "contentent": [
        "contenter"
    ],
    "contenter": [
        "contenter"
    ],
    "contentera": [
        "contenter"
    ],
    "contenterai": [
        "contenter"
    ],
    "contenteraient": [
        "contenter"
    ],
    "contenterais": [
        "contenter"
    ],
    "contenterait": [
        "contenter"
    ],
    "contenteras": [
        "contenter"
    ],
    "contenterez": [
        "contenter"
    ],
    "contenteriez": [
        "contenter"
    ],
    "contenterions": [
        "contenter"
    ],
    "contenterons": [
        "contenter"
    ],
    "contenteront": [
        "contenter"
    ],
    "contentes": [
        "content",
        "contenter"
    ],
    "contentez": [
        "contenter"
    ],
    "contentieux": [
        "contentieux"
    ],
    "contentiez": [
        "contenter"
    ],
    "contention": [
        "contention"
    ],
    "contentions": [
        "contention",
        "contenter"
    ],
    "contentons": [
        "contenter"
    ],
    "contents": [
        "content"
    ],
    "contenterent": [
        "contenter"
    ],
    "contentee": [
        "contenter"
    ],
    "contentees": [
        "contenter"
    ],
    "contenu": [
        "contenir",
        "contenu"
    ],
    "contenue": [
        "contenir",
        "contenu"
    ],
    "contenues": [
        "contenir",
        "contenu"
    ],
    "contenus": [
        "contenir",
        "contenu"
    ],
    "conter": [
        "conter"
    ],
    "contera": [
        "conter"
    ],
    "conterai": [
        "conter"
    ],
    "conterait": [
        "conter"
    ],
    "conteras": [
        "conter"
    ],
    "conterez": [
        "conter"
    ],
    "conterons": [
        "conter"
    ],
    "contes": [
        "conter",
        "conte"
    ],
    "contesta": [
        "contester"
    ],
    "contestable": [
        "contestable"
    ],
    "contestables": [
        "contestable"
    ],
    "contestaient": [
        "contester"
    ],
    "contestais": [
        "contester"
    ],
    "contestait": [
        "contester"
    ],
    "contestant": [
        "contester"
    ],
    "contestataire": [
        "contestataire"
    ],
    "contestataires": [
        "contestataire"
    ],
    "contestation": [
        "contestation"
    ],
    "contestations": [
        "contestation"
    ],
    "conteste": [
        "contester",
        "conteste"
    ],
    "contestent": [
        "contester"
    ],
    "contester": [
        "contester"
    ],
    "contestera": [
        "contester"
    ],
    "contesterai": [
        "contester"
    ],
    "contesterait": [
        "contester"
    ],
    "contesteriez": [
        "contester"
    ],
    "contesterons": [
        "contester"
    ],
    "contestes": [
        "contester"
    ],
    "contestez": [
        "contester"
    ],
    "contestiez": [
        "contester"
    ],
    "contestons": [
        "contester"
    ],
    "contestee": [
        "contester"
    ],
    "contestees": [
        "contester"
    ],
    "conteur": [
        "conteur"
    ],
    "conteurs": [
        "conteur"
    ],
    "conteuse": [
        "conteur"
    ],
    "contexte": [
        "contexte"
    ],
    "contextes": [
        "contexte"
    ],
    "contextualiser": [
        "contextualiser"
    ],
    "contextuel": [
        "contextuel"
    ],
    "contez": [
        "conter"
    ],
    "contiendra": [
        "contenir"
    ],
    "contiendrai": [
        "contenir"
    ],
    "contiendraient": [
        "contenir"
    ],
    "contiendrait": [
        "contenir"
    ],
    "contienne": [
        "contenir"
    ],
    "contiennent": [
        "contenir"
    ],
    "contiens": [
        "contenir"
    ],
    "contient": [
        "contenir"
    ],
    "contigu": [
        "contigu"
    ],
    "contigus": [
        "contigu"
    ],
    "contigue": [
        "contigu"
    ],
    "contigues": [
        "contigu"
    ],
    "contiguite": [
        "contiguite"
    ],
    "continence": [
        "continence"
    ],
    "continent": [
        "continent"
    ],
    "continental": [
        "continental"
    ],
    "continentale": [
        "continental"
    ],
    "continentales": [
        "continental"
    ],
    "continentaux": [
        "continental"
    ],
    "continents": [
        "continent"
    ],
    "contingence": [
        "contingence"
    ],
    "contingences": [
        "contingence"
    ],
    "contingent": [
        "contingent"
    ],
    "contingente": [
        "contingent",
        "contingenter"
    ],
    "contingentement": [
        "contingentement"
    ],
    "contingentes": [
        "contingent"
    ],
    "contingents": [
        "contingent"
    ],
    "continrent": [
        "contenir"
    ],
    "contins": [
        "contenir"
    ],
    "contint": [
        "contenir"
    ],
    "continu": [
        "continu"
    ],
    "continua": [
        "continuer"
    ],
    "continuai": [
        "continuer"
    ],
    "continuaient": [
        "continuer"
    ],
    "continuais": [
        "continuer"
    ],
    "continuait": [
        "continuer"
    ],
    "continuant": [
        "continuer"
    ],
    "continuassent": [
        "continuer"
    ],
    "continuateur": [
        "continuateur"
    ],
    "continuateurs": [
        "continuateur"
    ],
    "continuation": [
        "continuation"
    ],
    "continue": [
        "continue",
        "continuer"
    ],
    "continuel": [
        "continuel"
    ],
    "continuelle": [
        "continuel"
    ],
    "continuellement": [
        "continuellement"
    ],
    "continuelles": [
        "continuel"
    ],
    "continuels": [
        "continuel"
    ],
    "continuent": [
        "continuer"
    ],
    "continuer": [
        "continuer"
    ],
    "continuera": [
        "continuer"
    ],
    "continuerai": [
        "continuer"
    ],
    "continueraient": [
        "continuer"
    ],
    "continuerais": [
        "continuer"
    ],
    "continuerait": [
        "continuer"
    ],
    "continueras": [
        "continuer"
    ],
    "continuerez": [
        "continuer"
    ],
    "continueriez": [
        "continuer"
    ],
    "continuerons": [
        "continuer"
    ],
    "continueront": [
        "continuer"
    ],
    "continues": [
        "continuer",
        "continue",
        "continu"
    ],
    "continuez": [
        "continuer"
    ],
    "continuiez": [
        "continuer"
    ],
    "continuions": [
        "continuer"
    ],
    "continuite": [
        "continuite"
    ],
    "continuons": [
        "continuer"
    ],
    "continus": [
        "continu"
    ],
    "continuum": [
        "continuum"
    ],
    "continuames": [
        "continuer"
    ],
    "continuat": [
        "continuer"
    ],
    "continuerent": [
        "continuer"
    ],
    "continuee": [
        "continuer"
    ],
    "continuees": [
        "continuer"
    ],
    "continument": [
        "continument"
    ],
    "contions": [
        "conter"
    ],
    "contondant": [
        "contondant"
    ],
    "contondante": [
        "contondant"
    ],
    "contondants": [
        "contondant"
    ],
    "contorsion": [
        "contorsion"
    ],
    "contorsionna": [
        "contorsionner"
    ],
    "contorsionnaient": [
        "contorsionner"
    ],
    "contorsionnait": [
        "contorsionner"
    ],
    "contorsionnant": [
        "contorsionner"
    ],
    "contorsionne": [
        "contorsionner"
    ],
    "contorsionnent": [
        "contorsionner"
    ],
    "contorsionner": [
        "contorsionner"
    ],
    "contorsionniste": [
        "contorsionniste"
    ],
    "contorsionnistes": [
        "contorsionniste"
    ],
    "contorsionnee": [
        "contorsionner"
    ],
    "contorsionnees": [
        "contorsionner"
    ],
    "contorsionnes": [
        "contorsionner"
    ],
    "contorsions": [
        "contorsion"
    ],
    "contour": [
        "contour"
    ],
    "contourna": [
        "contourner"
    ],
    "contournai": [
        "contourner"
    ],
    "contournaient": [
        "contourner"
    ],
    "contournais": [
        "contourner"
    ],
    "contournait": [
        "contourner"
    ],
    "contournant": [
        "contourner"
    ],
    "contourne": [
        "contourner",
        "contourne"
    ],
    "contournement": [
        "contournement"
    ],
    "contournements": [
        "contournement"
    ],
    "contournent": [
        "contourner"
    ],
    "contourner": [
        "contourner"
    ],
    "contournera": [
        "contourner"
    ],
    "contournerai": [
        "contourner"
    ],
    "contournerais": [
        "contourner"
    ],
    "contournerez": [
        "contourner"
    ],
    "contournerons": [
        "contourner"
    ],
    "contournes": [
        "contourner",
        "contourne"
    ],
    "contournez": [
        "contourner"
    ],
    "contournions": [
        "contourner"
    ],
    "contournons": [
        "contourner"
    ],
    "contournerent": [
        "contourner"
    ],
    "contournee": [
        "contourner",
        "contourne"
    ],
    "contournees": [
        "contourner",
        "contourne"
    ],
    "contours": [
        "contour"
    ],
    "contra": [
        "contrer",
        "contra"
    ],
    "contraceptif": [
        "contraceptif"
    ],
    "contraceptifs": [
        "contraceptif"
    ],
    "contraception": [
        "contraception"
    ],
    "contraceptive": [
        "contraceptif"
    ],
    "contraceptives": [
        "contraceptive",
        "contraceptif"
    ],
    "contracta": [
        "contracter"
    ],
    "contractai": [
        "contracter"
    ],
    "contractaient": [
        "contracter"
    ],
    "contractais": [
        "contracter"
    ],
    "contractait": [
        "contracter"
    ],
    "contractant": [
        "contractant",
        "contracter"
    ],
    "contractantes": [
        "contractant"
    ],
    "contractants": [
        "contractant"
    ],
    "contracte": [
        "contracter",
        "contracte"
    ],
    "contractent": [
        "contracter"
    ],
    "contracter": [
        "contracter"
    ],
    "contracterait": [
        "contracter"
    ],
    "contractez": [
        "contracter"
    ],
    "contractile": [
        "contractile"
    ],
    "contraction": [
        "contraction"
    ],
    "contractions": [
        "contraction",
        "contracter"
    ],
    "contractons": [
        "contracter"
    ],
    "contractuel": [
        "contractuel"
    ],
    "contractuelle": [
        "contractuel"
    ],
    "contractuellement": [
        "contractuellement"
    ],
    "contractuelles": [
        "contractuel"
    ],
    "contractuels": [
        "contractuel"
    ],
    "contracture": [
        "contracture"
    ],
    "contractures": [
        "contracture"
    ],
    "contracterent": [
        "contracter"
    ],
    "contractee": [
        "contracte",
        "contracter"
    ],
    "contractees": [
        "contracte",
        "contracter"
    ],
    "contractes": [
        "contracte",
        "contracter"
    ],
    "contradicteur": [
        "contradicteur"
    ],
    "contradicteurs": [
        "contradicteur"
    ],
    "contradiction": [
        "contradiction"
    ],
    "contradictions": [
        "contradiction"
    ],
    "contradictoire": [
        "contradictoire"
    ],
    "contradictoirement": [
        "contradictoirement"
    ],
    "contradictoires": [
        "contradictoire"
    ],
    "contraignaient": [
        "contraindre"
    ],
    "contraignais": [
        "contraindre"
    ],
    "contraignait": [
        "contraindre"
    ],
    "contraignant": [
        "contraindre",
        "contraignant"
    ],
    "contraignante": [
        "contraignant"
    ],
    "contraignantes": [
        "contraignant"
    ],
    "contraigne": [
        "contraindre"
    ],
    "contraignent": [
        "contraindre"
    ],
    "contraignit": [
        "contraindre"
    ],
    "contraindra": [
        "contraindre"
    ],
    "contraindrai": [
        "contraindre"
    ],
    "contraindraient": [
        "contraindre"
    ],
    "contraindrais": [
        "contraindre"
    ],
    "contraindrait": [
        "contraindre"
    ],
    "contraindre": [
        "contraindre"
    ],
    "contrains": [
        "contraindre"
    ],
    "contraint": [
        "contraindre",
        "contraint"
    ],
    "contrainte": [
        "contraindre",
        "contraint",
        "contrainte"
    ],
    "contraintes": [
        "contraindre",
        "contraint"
    ],
    "contraints": [
        "contraindre",
        "contraint"
    ],
    "contraire": [
        "contraire"
    ],
    "contrairement": [
        "contrairement"
    ],
    "contraires": [
        "contraire"
    ],
    "contrait": [
        "contrer"
    ],
    "contralto": [
        "contralto"
    ],
    "contraltos": [
        "contralto"
    ],
    "contrant": [
        "contrer"
    ],
    "contrapunctique": [
        "contrapunctique"
    ],
    "contrapuntique": [
        "contrapuntique"
    ],
    "contraria": [
        "contrarier"
    ],
    "contrariaient": [
        "contrarier"
    ],
    "contrariais": [
        "contrarier"
    ],
    "contrariait": [
        "contrarier"
    ],
    "contrariant": [
        "contrarier",
        "contrariant"
    ],
    "contrariante": [
        "contrariant"
    ],
    "contrariantes": [
        "contrariant"
    ],
    "contrariants": [
        "contrariant"
    ],
    "contrarie": [
        "contrarier",
        "contrarie"
    ],
    "contrarient": [
        "contrarier"
    ],
    "contrarier": [
        "contrarier"
    ],
    "contrarierai": [
        "contrarier"
    ],
    "contrarierait": [
        "contrarier"
    ],
    "contrariez": [
        "contrarier"
    ],
    "contrarions": [
        "contrarier"
    ],
    "contrariat": [
        "contrarier"
    ],
    "contrariee": [
        "contrarier",
        "contrarie"
    ],
    "contrariees": [
        "contrarier",
        "contrarie"
    ],
    "contraries": [
        "contrary",
        "contrarier",
        "contrarie"
    ],
    "contrariete": [
        "contrariete"
    ],
    "contrarietes": [
        "contrariete"
    ],
    "contras": [
        "contra"
    ],
    "contrasta": [
        "contraster"
    ],
    "contrastaient": [
        "contraster"
    ],
    "contrastait": [
        "contraster"
    ],
    "contrastant": [
        "contrastant",
        "contraster"
    ],
    "contraste": [
        "contraste",
        "contraster"
    ],
    "contrastent": [
        "contraster"
    ],
    "contraster": [
        "contraster"
    ],
    "contrasteraient": [
        "contraster"
    ],
    "contrasterait": [
        "contraster"
    ],
    "contrastes": [
        "contraste",
        "contraster"
    ],
    "contrastez": [
        "contraster"
    ],
    "contrastat": [
        "contraster"
    ],
    "contrastee": [
        "contraste",
        "contraster"
    ],
    "contrastees": [
        "contraste",
        "contraster"
    ],
    "contrat": [
        "contrat"
    ],
    "contrats": [
        "contrat"
    ],
    "contravention": [
        "contravention"
    ],
    "contraventions": [
        "contravention"
    ],
    "contre": [
        "contre",
        "contrer"
    ],
    "contrebalance": [
        "contrebalancer"
    ],
    "contrebalancer": [
        "contrebalancer"
    ],
    "contrebalancee": [
        "contrebalancer"
    ],
    "contrebalances": [
        "contrebalancer"
    ],
    "contrebalancais": [
        "contrebalancer"
    ],
    "contrebalancait": [
        "contrebalancer"
    ],
    "contrebande": [
        "contrebande"
    ],
    "contrebandier": [
        "contrebandier"
    ],
    "contrebandiers": [
        "contrebandier"
    ],
    "contrebandiere": [
        "contrebandier"
    ],
    "contrebas": [
        "contrebas"
    ],
    "contrebasse": [
        "contrebasse"
    ],
    "contrebasses": [
        "contrebasse"
    ],
    "contrebassiste": [
        "contrebassiste"
    ],
    "contrebassistes": [
        "contrebassiste"
    ],
    "contrebraque": [
        "contrebraquer"
    ],
    "contrecarraient": [
        "contrecarrer"
    ],
    "contrecarrais": [
        "contrecarrer"
    ],
    "contrecarre": [
        "contrecarrer"
    ],
    "contrecarrer": [
        "contrecarrer"
    ],
    "contrecarres": [
        "contrecarrer"
    ],
    "contrecarree": [
        "contrecarrer"
    ],
    "contrechamp": [
        "contrechamp"
    ],
    "contrechamps": [
        "contrechamp"
    ],
    "contrecoeur": [
        "contrecoeur"
    ],
    "contrecolle": [
        "contrecolle"
    ],
    "contrecoup": [
        "contrecoup"
    ],
    "contrecoups": [
        "contrecoup"
    ],
    "contredanse": [
        "contredanse"
    ],
    "contredanses": [
        "contredanse"
    ],
    "contredira": [
        "contredire"
    ],
    "contredirai": [
        "contredire"
    ],
    "contrediraient": [
        "contredire"
    ],
    "contredirait": [
        "contredire"
    ],
    "contredire": [
        "contredire"
    ],
    "contredirez": [
        "contredire"
    ],
    "contredis": [
        "contredire"
    ],
    "contredisaient": [
        "contredire"
    ],
    "contredisait": [
        "contredire"
    ],
    "contredisant": [
        "contredire"
    ],
    "contredise": [
        "contredire"
    ],
    "contredisent": [
        "contredire"
    ],
    "contredises": [
        "contredire"
    ],
    "contredisez": [
        "contredire"
    ],
    "contredit": [
        "contredire",
        "contredit"
    ],
    "contredite": [
        "contredire"
    ],
    "contredites": [
        "contredire"
    ],
    "contredits": [
        "contredire",
        "contredit"
    ],
    "contrefacteurs": [
        "contrefacteur"
    ],
    "contrefaire": [
        "contrefaire"
    ],
    "contrefaisait": [
        "contrefaire"
    ],
    "contrefaisant": [
        "contrefaire"
    ],
    "contrefait": [
        "contrefaire",
        "contrefait"
    ],
    "contrefaite": [
        "contrefaire",
        "contrefait"
    ],
    "contrefaits": [
        "contrefaire",
        "contrefait"
    ],
    "contrefacon": [
        "contrefacon"
    ],
    "contrefacons": [
        "contrefacon"
    ],
    "contreferait": [
        "contrefaire"
    ],
    "contrefichais": [
        "contreficher"
    ],
    "contrefichait": [
        "contreficher"
    ],
    "contrefiche": [
        "contrefiche",
        "contreficher"
    ],
    "contrefort": [
        "contrefort"
    ],
    "contreforts": [
        "contrefort"
    ],
    "contrefous": [
        "contrefoutre"
    ],
    "contrefout": [
        "contrefoutre"
    ],
    "contrefoutait": [
        "contrefoutre"
    ],
    "contrefoutre": [
        "contrefoutre"
    ],
    "contremander": [
        "contremander"
    ],
    "contremarches": [
        "contremarche"
    ],
    "contremarques": [
        "contremarque"
    ],
    "contremaitre": [
        "contremaitre"
    ],
    "contremaitres": [
        "contremaitre"
    ],
    "contremaitresse": [
        "contremaitresse"
    ],
    "contrent": [
        "contrer"
    ],
    "contrepartie": [
        "contrepartie"
    ],
    "contreplaque": [
        "contreplaque"
    ],
    "contrepoids": [
        "contrepoids"
    ],
    "contrepoint": [
        "contrepoint"
    ],
    "contrepoison": [
        "contrepoison"
    ],
    "contrepoisons": [
        "contrepoison"
    ],
    "contreproposition": [
        "contreproposition"
    ],
    "contrepeterie": [
        "contrepeterie"
    ],
    "contrepeteries": [
        "contrepeterie"
    ],
    "contrer": [
        "contrer"
    ],
    "contrerai": [
        "contrer"
    ],
    "contrerait": [
        "contrer"
    ],
    "contreras": [
        "contrer"
    ],
    "contreront": [
        "contrer"
    ],
    "contres": [
        "contre",
        "contrer"
    ],
    "contrescarpe": [
        "contrescarpe"
    ],
    "contreseing": [
        "contreseing"
    ],
    "contresens": [
        "contresens"
    ],
    "contresignait": [
        "contresigner"
    ],
    "contresigne": [
        "contresigner"
    ],
    "contresigner": [
        "contresigner"
    ],
    "contresignee": [
        "contresigner"
    ],
    "contresignees": [
        "contresigner"
    ],
    "contresignes": [
        "contresigner"
    ],
    "contretemps": [
        "contretemps"
    ],
    "contretypes": [
        "contretyper"
    ],
    "contrevallation": [
        "contrevallation"
    ],
    "contrevenaient": [
        "contrevenir"
    ],
    "contrevenait": [
        "contrevenir"
    ],
    "contrevenant": [
        "contrevenir",
        "contrevenant"
    ],
    "contrevenants": [
        "contrevenant"
    ],
    "contrevenez": [
        "contrevenir"
    ],
    "contrevenir": [
        "contrevenir"
    ],
    "contrevent": [
        "contrevent"
    ],
    "contrevents": [
        "contrevent"
    ],
    "contrevenu": [
        "contrevenir"
    ],
    "contreviendrait": [
        "contrevenir"
    ],
    "contreviens": [
        "contrevenir"
    ],
    "contrevient": [
        "contrevenir"
    ],
    "contreverite": [
        "contreverite"
    ],
    "contreverites": [
        "contreverite"
    ],
    "contribua": [
        "contribuer"
    ],
    "contribuable": [
        "contribuable"
    ],
    "contribuables": [
        "contribuable"
    ],
    "contribuaient": [
        "contribuer"
    ],
    "contribuait": [
        "contribuer"
    ],
    "contribuant": [
        "contribuer"
    ],
    "contribue": [
        "contribuer"
    ],
    "contribuent": [
        "contribuer"
    ],
    "contribuer": [
        "contribuer"
    ],
    "contribuera": [
        "contribuer"
    ],
    "contribueraient": [
        "contribuer"
    ],
    "contribuerais": [
        "contribuer"
    ],
    "contribuerait": [
        "contribuer"
    ],
    "contribueras": [
        "contribuer"
    ],
    "contribuerez": [
        "contribuer"
    ],
    "contribueront": [
        "contribuer"
    ],
    "contribuez": [
        "contribuer"
    ],
    "contribuons": [
        "contribuer"
    ],
    "contributeur": [
        "contributeur"
    ],
    "contribution": [
        "contribution"
    ],
    "contributions": [
        "contribution"
    ],
    "contribuat": [
        "contribuer"
    ],
    "contribuerent": [
        "contribuer"
    ],
    "contrista": [
        "contrister"
    ],
    "contristant": [
        "contrister"
    ],
    "contristees": [
        "contrister"
    ],
    "contrit": [
        "contrit"
    ],
    "contrite": [
        "contrit"
    ],
    "contrites": [
        "contrit"
    ],
    "contrition": [
        "contrition"
    ],
    "contritions": [
        "contrition"
    ],
    "contrits": [
        "contrit"
    ],
    "control": [
        "control"
    ],
    "contrordre": [
        "contrordre"
    ],
    "contrordres": [
        "contrordre"
    ],
    "controverse": [
        "controverser",
        "controverse"
    ],
    "controverses": [
        "controverser",
        "controverse"
    ],
    "controversee": [
        "controverser",
        "controverse"
    ],
    "controversees": [
        "controverser",
        "controverse"
    ],
    "contree": [
        "contrer",
        "contree"
    ],
    "contrees": [
        "contrer",
        "contree"
    ],
    "controla": [
        "controler"
    ],
    "controlable": [
        "controlable"
    ],
    "controlables": [
        "controlable"
    ],
    "controlai": [
        "controler"
    ],
    "controlaient": [
        "controler"
    ],
    "controlais": [
        "controler"
    ],
    "controlait": [
        "controler"
    ],
    "controlant": [
        "controler"
    ],
    "controle": [
        "controle",
        "controler"
    ],
    "controlent": [
        "controler"
    ],
    "controler": [
        "controler",
        "chuter"
    ],
    "controlera": [
        "controler"
    ],
    "controlerai": [
        "controler"
    ],
    "controlerais": [
        "controler"
    ],
    "controlerait": [
        "controler"
    ],
    "controleras": [
        "controler"
    ],
    "controlerez": [
        "controler"
    ],
    "controleriez": [
        "controler"
    ],
    "controlerons": [
        "controler"
    ],
    "controleront": [
        "controler"
    ],
    "controles": [
        "controle",
        "controler"
    ],
    "controleur": [
        "controleur"
    ],
    "controleurs": [
        "controleur"
    ],
    "controleuse": [
        "controleur"
    ],
    "controlez": [
        "controler"
    ],
    "controliez": [
        "controler"
    ],
    "controlions": [
        "controler"
    ],
    "controlons": [
        "controler"
    ],
    "controlames": [
        "controler"
    ],
    "controlerent": [
        "controler"
    ],
    "controlee": [
        "controler"
    ],
    "controlees": [
        "controler"
    ],
    "contumace": [
        "contumace"
    ],
    "contumaces": [
        "contumace"
    ],
    "contumax": [
        "contumax"
    ],
    "contuse": [
        "contus"
    ],
    "contusion": [
        "contusion"
    ],
    "contusionne": [
        "contusionner",
        "contusionne"
    ],
    "contusionnee": [
        "contusionner",
        "contusionne"
    ],
    "contusionnes": [
        "contusionner",
        "contusionne"
    ],
    "contusions": [
        "contusion"
    ],
    "contat": [
        "conter"
    ],
    "contee": [
        "conter"
    ],
    "contees": [
        "conter"
    ],
    "convainc": [
        "convaincre"
    ],
    "convaincant": [
        "convaincant"
    ],
    "convaincante": [
        "convaincant"
    ],
    "convaincantes": [
        "convaincant"
    ],
    "convaincants": [
        "convaincant"
    ],
    "convaincra": [
        "convaincre"
    ],
    "convaincrai": [
        "convaincre"
    ],
    "convaincrait": [
        "convaincre"
    ],
    "convaincras": [
        "convaincre"
    ],
    "convaincre": [
        "convaincre"
    ],
    "convaincrez": [
        "convaincre"
    ],
    "convaincrons": [
        "convaincre"
    ],
    "convaincront": [
        "convaincre"
    ],
    "convaincs": [
        "convaincre"
    ],
    "convaincu": [
        "convaincre",
        "convaincu"
    ],
    "convaincue": [
        "convaincre",
        "convaincu"
    ],
    "convaincues": [
        "convaincre",
        "convaincu"
    ],
    "convaincus": [
        "convaincre",
        "convaincu"
    ],
    "convainquaient": [
        "convaincre"
    ],
    "convainquait": [
        "convaincre"
    ],
    "convainquant": [
        "convaincre"
    ],
    "convainque": [
        "convaincre"
    ],
    "convainquent": [
        "convaincre"
    ],
    "convainques": [
        "convaincre"
    ],
    "convainquez": [
        "convaincre"
    ],
    "convainquiez": [
        "convaincre"
    ],
    "convainquirent": [
        "convaincre"
    ],
    "convainquis": [
        "convaincre"
    ],
    "convainquit": [
        "convaincre"
    ],
    "convainquons": [
        "convaincre"
    ],
    "convalescence": [
        "convalescence"
    ],
    "convalescences": [
        "convalescence"
    ],
    "convalescent": [
        "convalescent"
    ],
    "convalescente": [
        "convalescent"
    ],
    "convalescentes": [
        "convalescent"
    ],
    "convalescents": [
        "convalescent"
    ],
    "convalo": [
        "convalo"
    ],
    "convalos": [
        "convalo"
    ],
    "convecteur": [
        "convecteur"
    ],
    "convection": [
        "convection"
    ],
    "convenable": [
        "convenable"
    ],
    "convenablement": [
        "convenablement"
    ],
    "convenables": [
        "convenable"
    ],
    "convenaient": [
        "convenir"
    ],
    "convenais": [
        "convenir"
    ],
    "convenait": [
        "convenir"
    ],
    "convenance": [
        "convenance"
    ],
    "convenances": [
        "convenance"
    ],
    "convenant": [
        "convenir",
        "convenant"
    ],
    "convenez": [
        "convenir"
    ],
    "conveniez": [
        "convenir"
    ],
    "convenir": [
        "convenir"
    ],
    "convenons": [
        "convenir"
    ],
    "convent": [
        "convent"
    ],
    "conventicule": [
        "conventicule"
    ],
    "convention": [
        "convention"
    ],
    "conventionnel": [
        "conventionnel"
    ],
    "conventionnelle": [
        "conventionnel"
    ],
    "conventionnellement": [
        "conventionnellement"
    ],
    "conventionnelles": [
        "conventionnel"
    ],
    "conventionnels": [
        "conventionnel"
    ],
    "conventionnee": [
        "conventionne"
    ],
    "conventions": [
        "convention"
    ],
    "conventuel": [
        "conventuel"
    ],
    "conventuelle": [
        "conventuel"
    ],
    "conventuellement": [
        "conventuellement"
    ],
    "conventuelles": [
        "conventuel"
    ],
    "conventuels": [
        "conventuel"
    ],
    "convenu": [
        "convenir",
        "convenu"
    ],
    "convenue": [
        "convenir",
        "convenu"
    ],
    "convenues": [
        "convenir",
        "convenu"
    ],
    "convenus": [
        "convenir",
        "convenu"
    ],
    "converge": [
        "converger"
    ],
    "convergeaient": [
        "converger"
    ],
    "convergeait": [
        "converger"
    ],
    "convergeant": [
        "converger"
    ],
    "convergence": [
        "convergence"
    ],
    "convergent": [
        "convergent",
        "converger"
    ],
    "convergente": [
        "convergent"
    ],
    "convergentes": [
        "convergent"
    ],
    "convergents": [
        "convergent"
    ],
    "convergeons": [
        "converger"
    ],
    "converger": [
        "converger"
    ],
    "convergeraient": [
        "converger"
    ],
    "convergez": [
        "converger"
    ],
    "convergerent": [
        "converger"
    ],
    "convers": [
        "convers"
    ],
    "conversaient": [
        "converser"
    ],
    "conversais": [
        "converser"
    ],
    "conversait": [
        "converser"
    ],
    "conversant": [
        "converser"
    ],
    "conversation": [
        "conversation"
    ],
    "conversations": [
        "conversation"
    ],
    "converse": [
        "converser",
        "converse"
    ],
    "conversent": [
        "converser"
    ],
    "converser": [
        "converser"
    ],
    "converses": [
        "converse"
    ],
    "conversez": [
        "converser"
    ],
    "conversiez": [
        "converser"
    ],
    "conversion": [
        "conversion"
    ],
    "conversions": [
        "conversion",
        "converser"
    ],
    "conversons": [
        "converser"
    ],
    "conversames": [
        "converser"
    ],
    "converserent": [
        "converser"
    ],
    "converti": [
        "converti",
        "convertir"
    ],
    "convertible": [
        "convertible"
    ],
    "convertibles": [
        "convertible"
    ],
    "convertie": [
        "converti",
        "convertir"
    ],
    "converties": [
        "converti",
        "convertir"
    ],
    "convertir": [
        "convertir"
    ],
    "convertira": [
        "convertir"
    ],
    "convertirai": [
        "convertir"
    ],
    "convertirais": [
        "convertir"
    ],
    "convertirait": [
        "convertir"
    ],
    "convertirons": [
        "convertir"
    ],
    "convertis": [
        "converti",
        "convertir"
    ],
    "convertissaient": [
        "convertir"
    ],
    "convertissais": [
        "convertir"
    ],
    "convertissait": [
        "convertir"
    ],
    "convertissant": [
        "convertir"
    ],
    "convertisse": [
        "convertir"
    ],
    "convertissent": [
        "convertir"
    ],
    "convertisseur": [
        "convertisseur"
    ],
    "convertisseurs": [
        "convertisseur"
    ],
    "convertissez": [
        "convertir"
    ],
    "convertissions": [
        "convertir"
    ],
    "convertit": [
        "convertir"
    ],
    "convexe": [
        "convexe"
    ],
    "convexes": [
        "convexe"
    ],
    "convexite": [
        "convexite"
    ],
    "convia": [
        "convier"
    ],
    "conviaient": [
        "convier"
    ],
    "conviais": [
        "convier"
    ],
    "conviait": [
        "convier"
    ],
    "conviant": [
        "convier"
    ],
    "convict": [
        "convict"
    ],
    "conviction": [
        "conviction"
    ],
    "convictions": [
        "conviction"
    ],
    "convicts": [
        "convict"
    ],
    "convie": [
        "convier",
        "convie"
    ],
    "conviendra": [
        "convenir"
    ],
    "conviendrai": [
        "convenir"
    ],
    "conviendraient": [
        "convenir"
    ],
    "conviendrais": [
        "convenir"
    ],
    "conviendrait": [
        "convenir"
    ],
    "conviendras": [
        "convenir"
    ],
    "conviendrez": [
        "convenir"
    ],
    "conviendrions": [
        "convenir"
    ],
    "conviendrons": [
        "convenir"
    ],
    "conviendront": [
        "convenir"
    ],
    "convienne": [
        "convenir"
    ],
    "conviennent": [
        "convenir"
    ],
    "conviens": [
        "convenir"
    ],
    "convient": [
        "convenir",
        "convier"
    ],
    "convier": [
        "convier"
    ],
    "conviera": [
        "convier"
    ],
    "convierai": [
        "convier"
    ],
    "convierait": [
        "convier"
    ],
    "conviez": [
        "convier"
    ],
    "convinrent": [
        "convenir"
    ],
    "convins": [
        "convenir"
    ],
    "convint": [
        "convenir"
    ],
    "convions": [
        "convier"
    ],
    "convive": [
        "convive"
    ],
    "convives": [
        "convive"
    ],
    "convivial": [
        "convivial"
    ],
    "conviviale": [
        "convivial"
    ],
    "conviviales": [
        "convivial"
    ],
    "convivialisez": [
        "convivialiser"
    ],
    "convivialite": [
        "convivialite"
    ],
    "conviviaux": [
        "convivial"
    ],
    "convierent": [
        "convier"
    ],
    "conviee": [
        "convier",
        "convie"
    ],
    "conviees": [
        "convier"
    ],
    "convies": [
        "convier",
        "convie"
    ],
    "convocable": [
        "convocable"
    ],
    "convocation": [
        "convocation"
    ],
    "convocations": [
        "convocation"
    ],
    "convoi": [
        "convoi"
    ],
    "convoie": [
        "convoyer"
    ],
    "convois": [
        "convoi"
    ],
    "convoita": [
        "convoiter"
    ],
    "convoitaient": [
        "convoiter"
    ],
    "convoitais": [
        "convoiter"
    ],
    "convoitait": [
        "convoiter"
    ],
    "convoitant": [
        "convoiter"
    ],
    "convoite": [
        "convoiter"
    ],
    "convoitent": [
        "convoiter"
    ],
    "convoiter": [
        "convoiter"
    ],
    "convoiteras": [
        "convoiter"
    ],
    "convoiteront": [
        "convoiter"
    ],
    "convoiteur": [
        "convoiteur"
    ],
    "convoiteux": [
        "convoiteux"
    ],
    "convoitez": [
        "convoiter"
    ],
    "convoitise": [
        "convoitise"
    ],
    "convoitises": [
        "convoitise"
    ],
    "convoitee": [
        "convoiter"
    ],
    "convoitees": [
        "convoiter"
    ],
    "convoites": [
        "convoiter"
    ],
    "convola": [
        "convoler"
    ],
    "convolait": [
        "convoler"
    ],
    "convolant": [
        "convoler"
    ],
    "convolent": [
        "convoler"
    ],
    "convoler": [
        "convoler"
    ],
    "convolerent": [
        "convoler"
    ],
    "convole": [
        "convoler"
    ],
    "convoqua": [
        "convoquer"
    ],
    "convoquai": [
        "convoquer"
    ],
    "convoquaient": [
        "convoquer"
    ],
    "convoquait": [
        "convoquer"
    ],
    "convoquant": [
        "convoquer"
    ],
    "convoque": [
        "convoquer"
    ],
    "convoquent": [
        "convoquer"
    ],
    "convoquer": [
        "convoquer"
    ],
    "convoquera": [
        "convoquer"
    ],
    "convoquerai": [
        "convoquer"
    ],
    "convoqueraient": [
        "convoquer"
    ],
    "convoquerait": [
        "convoquer"
    ],
    "convoquerez": [
        "convoquer"
    ],
    "convoqueront": [
        "convoquer"
    ],
    "convoquez": [
        "convoquer"
    ],
    "convoquions": [
        "convoquer"
    ],
    "convoquons": [
        "convoquer"
    ],
    "convoquat": [
        "convoquer"
    ],
    "convoquerent": [
        "convoquer"
    ],
    "convoquee": [
        "convoquer"
    ],
    "convoquees": [
        "convoquer"
    ],
    "convoques": [
        "convoquer"
    ],
    "convoya": [
        "convoyer"
    ],
    "convoyage": [
        "convoyage"
    ],
    "convoyages": [
        "convoyage"
    ],
    "convoyaient": [
        "convoyer"
    ],
    "convoyait": [
        "convoyer"
    ],
    "convoyant": [
        "convoyer"
    ],
    "convoyer": [
        "convoyer"
    ],
    "convoyeur": [
        "convoyeur"
    ],
    "convoyeurs": [
        "convoyeur"
    ],
    "convoyeuse": [
        "convoyeur"
    ],
    "convoye": [
        "convoyer"
    ],
    "convoyee": [
        "convoyer"
    ],
    "convoyes": [
        "convoyer"
    ],
    "convulsa": [
        "convulser"
    ],
    "convulsai": [
        "convulser"
    ],
    "convulsais": [
        "convulser"
    ],
    "convulsait": [
        "convulser"
    ],
    "convulsant": [
        "convulser"
    ],
    "convulse": [
        "convulse",
        "convulser"
    ],
    "convulser": [
        "convulser"
    ],
    "convulsif": [
        "convulsif"
    ],
    "convulsifs": [
        "convulsif"
    ],
    "convulsion": [
        "convulsion"
    ],
    "convulsionnaire": [
        "convulsionnaire"
    ],
    "convulsionne": [
        "convulsionner"
    ],
    "convulsionnee": [
        "convulsionner"
    ],
    "convulsions": [
        "convulser",
        "convulsion"
    ],
    "convulsive": [
        "convulsif"
    ],
    "convulsivement": [
        "convulsivement"
    ],
    "convulsives": [
        "convulsif"
    ],
    "convulsee": [
        "convulse",
        "convulser"
    ],
    "convulsees": [
        "convulse"
    ],
    "convulses": [
        "convulse",
        "convulser"
    ],
    "convinmes": [
        "convenir"
    ],
    "concois": [
        "concevoir"
    ],
    "concoit": [
        "concevoir"
    ],
    "concoivent": [
        "concevoir"
    ],
    "concu": [
        "concevoir",
        "concu"
    ],
    "concue": [
        "concevoir",
        "concu"
    ],
    "concues": [
        "concevoir",
        "concu"
    ],
    "concurent": [
        "concevoir"
    ],
    "concus": [
        "concevoir",
        "concu"
    ],
    "concut": [
        "concevoir"
    ],
    "cooccupant": [
        "cooccupant"
    ],
    "cookie": [
        "cookie"
    ],
    "cookies": [
        "cookie"
    ],
    "cool": [
        "cool"
    ],
    "coolie": [
        "coolie"
    ],
    "coolies": [
        "coolie"
    ],
    "coolos": [
        "coolos"
    ],
    "cooptant": [
        "coopter"
    ],
    "cooptation": [
        "cooptation"
    ],
    "coopter": [
        "coopter"
    ],
    "coopte": [
        "coopter"
    ],
    "coopere": [
        "cooperer"
    ],
    "cooperent": [
        "cooperer"
    ],
    "cooperes": [
        "cooperer"
    ],
    "coope": [
        "coope"
    ],
    "cooperais": [
        "cooperer"
    ],
    "cooperait": [
        "cooperer"
    ],
    "cooperant": [
        "cooperer",
        "cooperant"
    ],
    "cooperante": [
        "cooperant"
    ],
    "cooperants": [
        "cooperant"
    ],
    "cooperateur": [
        "cooperateur"
    ],
    "cooperatif": [
        "cooperatif"
    ],
    "cooperatifs": [
        "cooperatif"
    ],
    "cooperation": [
        "cooperation"
    ],
    "cooperatisme": [
        "cooperatisme"
    ],
    "cooperative": [
        "cooperatif",
        "cooperative"
    ],
    "cooperatives": [
        "cooperatif",
        "cooperative"
    ],
    "cooperer": [
        "cooperer"
    ],
    "cooperera": [
        "cooperer"
    ],
    "coopererai": [
        "cooperer"
    ],
    "coopereraient": [
        "cooperer"
    ],
    "coopererais": [
        "cooperer"
    ],
    "coopererez": [
        "cooperer"
    ],
    "coopereriez": [
        "cooperer"
    ],
    "coopererons": [
        "cooperer"
    ],
    "coopereront": [
        "cooperer"
    ],
    "cooperez": [
        "cooperer"
    ],
    "cooperiez": [
        "cooperer"
    ],
    "cooperions": [
        "cooperer"
    ],
    "cooperons": [
        "cooperer"
    ],
    "coordinateur": [
        "coordinateur"
    ],
    "coordinateurs": [
        "coordinateur"
    ],
    "coordination": [
        "coordination"
    ],
    "coordinatrice": [
        "coordinateur"
    ],
    "coordonna": [
        "coordonner"
    ],
    "coordonnaient": [
        "coordonner"
    ],
    "coordonnait": [
        "coordonner"
    ],
    "coordonnant": [
        "coordonner"
    ],
    "coordonnateur": [
        "coordonnateur"
    ],
    "coordonne": [
        "coordonne",
        "coordonner"
    ],
    "coordonner": [
        "coordonner"
    ],
    "coordonnera": [
        "coordonner"
    ],
    "coordonnerait": [
        "coordonner"
    ],
    "coordonnez": [
        "coordonner"
    ],
    "coordonnons": [
        "coordonner"
    ],
    "coordonnee": [
        "coordonner",
        "coordonnee"
    ],
    "coordonnees": [
        "coordonner",
        "coordonnee"
    ],
    "coordonnes": [
        "coordonne"
    ],
    "cop": [
        "cop"
    ],
    "copain": [
        "copain"
    ],
    "copains": [
        "copain"
    ],
    "copal": [
        "copal"
    ],
    "copaiba": [
        "copaiba"
    ],
    "copeau": [
        "copeau"
    ],
    "copeaux": [
        "copeau"
    ],
    "copernicienne": [
        "copernicien"
    ],
    "copia": [
        "copier"
    ],
    "copiable": [
        "copiable"
    ],
    "copiage": [
        "copiage"
    ],
    "copiai": [
        "copier"
    ],
    "copiaient": [
        "copier"
    ],
    "copiais": [
        "copier"
    ],
    "copiait": [
        "copier"
    ],
    "copiant": [
        "copier"
    ],
    "copie": [
        "copier",
        "copie"
    ],
    "copient": [
        "copier"
    ],
    "copier": [
        "copier"
    ],
    "copiera": [
        "copier"
    ],
    "copierai": [
        "copier"
    ],
    "copierait": [
        "copier"
    ],
    "copieras": [
        "copier"
    ],
    "copierez": [
        "copier"
    ],
    "copieront": [
        "copier"
    ],
    "copies": [
        "copier",
        "copy",
        "copie"
    ],
    "copieur": [
        "copieur"
    ],
    "copieurs": [
        "copieur"
    ],
    "copieuse": [
        "copieur"
    ],
    "copieusement": [
        "copieusement"
    ],
    "copieuses": [
        "copieur"
    ],
    "copieux": [
        "copieux"
    ],
    "copiez": [
        "copier"
    ],
    "copilote": [
        "copilote"
    ],
    "copinage": [
        "copinage"
    ],
    "copinait": [
        "copiner"
    ],
    "copine": [
        "copain",
        "copiner"
    ],
    "copiner": [
        "copiner"
    ],
    "copines": [
        "copain"
    ],
    "copineur": [
        "copineur"
    ],
    "copineurs": [
        "copineur"
    ],
    "copineuse": [
        "copineur"
    ],
    "copiniez": [
        "copiner"
    ],
    "copiste": [
        "copiste"
    ],
    "copistes": [
        "copiste"
    ],
    "copiee": [
        "copier"
    ],
    "copiees": [
        "copier"
    ],
    "copla": [
        "copla"
    ],
    "coppa": [
        "coppa"
    ],
    "copra": [
        "copra"
    ],
    "coprins": [
        "coprin"
    ],
    "coproculture": [
        "coproculture"
    ],
    "coproducteur": [
        "coproducteur"
    ],
    "coproducteurs": [
        "coproducteur"
    ],
    "coproduction": [
        "coproduction"
    ],
    "coproduire": [
        "coproduire"
    ],
    "coproduit": [
        "coproduire"
    ],
    "coprologie": [
        "coprologie"
    ],
    "coprologique": [
        "coprologique"
    ],
    "coprophage": [
        "coprophage"
    ],
    "coprophagie": [
        "coprophagie"
    ],
    "coprophile": [
        "coprophile"
    ],
    "coprophilie": [
        "coprophilie"
    ],
    "coproprietaire": [
        "coproprietaire"
    ],
    "coproprietaires": [
        "coproprietaire"
    ],
    "copropriete": [
        "copropriete"
    ],
    "copresidence": [
        "copresidence"
    ],
    "copresident": [
        "copresider"
    ],
    "cops": [
        "cops",
        "cop"
    ],
    "copte": [
        "copte"
    ],
    "coptes": [
        "copte"
    ],
    "copula": [
        "copuler"
    ],
    "copulait": [
        "copuler"
    ],
    "copulant": [
        "copulant",
        "copuler"
    ],
    "copulation": [
        "copulation"
    ],
    "copulations": [
        "copulation"
    ],
    "copule": [
        "copuler",
        "copule"
    ],
    "copulent": [
        "copuler"
    ],
    "copuler": [
        "copuler"
    ],
    "copulez": [
        "copuler"
    ],
    "copyright": [
        "copyright"
    ],
    "coq": [
        "coq"
    ],
    "coqs": [
        "coq"
    ],
    "coquard": [
        "coquard"
    ],
    "coquards": [
        "coquard"
    ],
    "coquart": [
        "coquart"
    ],
    "coquarts": [
        "coquart"
    ],
    "coque": [
        "coque"
    ],
    "coquebin": [
        "coquebin"
    ],
    "coquelet": [
        "coquelet"
    ],
    "coquelicot": [
        "coquelicot"
    ],
    "coquelicots": [
        "coquelicot"
    ],
    "coquelle": [
        "coquelle"
    ],
    "coqueluche": [
        "coqueluche"
    ],
    "coqueluches": [
        "coqueluche"
    ],
    "coquemar": [
        "coquemar"
    ],
    "coquerelle": [
        "coquerelle"
    ],
    "coquerie": [
        "coquerie"
    ],
    "coqueron": [
        "coqueron"
    ],
    "coques": [
        "coque"
    ],
    "coquet": [
        "coquet"
    ],
    "coquetel": [
        "coquetel"
    ],
    "coqueter": [
        "coqueter"
    ],
    "coquetier": [
        "coquetier"
    ],
    "coquetiers": [
        "coquetier"
    ],
    "coquets": [
        "coquet"
    ],
    "coquette": [
        "coquette",
        "coquet"
    ],
    "coquettement": [
        "coquettement"
    ],
    "coquetterie": [
        "coquetterie"
    ],
    "coquetteries": [
        "coquetterie"
    ],
    "coquettes": [
        "coquette",
        "coquet"
    ],
    "coquillage": [
        "coquillage"
    ],
    "coquillages": [
        "coquillage"
    ],
    "coquillard": [
        "coquillard"
    ],
    "coquillards": [
        "coquillard"
    ],
    "coquillart": [
        "coquillart"
    ],
    "coquille": [
        "coquille"
    ],
    "coquilles": [
        "coquille"
    ],
    "coquillettes": [
        "coquillette"
    ],
    "coquilleux": [
        "coquilleux"
    ],
    "coquin": [
        "coquin"
    ],
    "coquine": [
        "coquin"
    ],
    "coquinement": [
        "coquinement"
    ],
    "coquinerie": [
        "coquinerie"
    ],
    "coquineries": [
        "coquinerie"
    ],
    "coquines": [
        "coquin"
    ],
    "coquinet": [
        "coquinet"
    ],
    "coquins": [
        "coquin"
    ],
    "cor": [
        "cor"
    ],
    "cora": [
        "cora"
    ],
    "corail": [
        "corail"
    ],
    "coralliaires": [
        "coralliaire"
    ],
    "corallien": [
        "corallien"
    ],
    "coralliens": [
        "corallien"
    ],
    "coramine": [
        "coramine"
    ],
    "coran": [
        "coran"
    ],
    "coranique": [
        "coranique"
    ],
    "coraniques": [
        "coranique"
    ],
    "coras": [
        "cora"
    ],
    "coraux": [
        "corail"
    ],
    "corbeau": [
        "corbeau"
    ],
    "corbeaux": [
        "corbeau"
    ],
    "corbeille": [
        "corbeille"
    ],
    "corbeilles": [
        "corbeille"
    ],
    "corbillard": [
        "corbillard"
    ],
    "corbillards": [
        "corbillard"
    ],
    "corbin": [
        "corbin"
    ],
    "corbieres": [
        "corbieres"
    ],
    "cordage": [
        "cordage"
    ],
    "cordages": [
        "cordage"
    ],
    "corde": [
        "corde",
        "corder"
    ],
    "cordeau": [
        "cordeau"
    ],
    "cordeaux": [
        "cordeau"
    ],
    "cordelette": [
        "cordelette"
    ],
    "cordelettes": [
        "cordelette"
    ],
    "cordelier": [
        "cordelier"
    ],
    "cordeliers": [
        "cordelier"
    ],
    "cordeliere": [
        "cordelier"
    ],
    "cordelieres": [
        "cordelier"
    ],
    "cordelle": [
        "cordeau"
    ],
    "corder": [
        "corder"
    ],
    "corderie": [
        "corderie"
    ],
    "cordes": [
        "corde",
        "corder"
    ],
    "cordial": [
        "cordial"
    ],
    "cordiale": [
        "cordial"
    ],
    "cordialement": [
        "cordialement"
    ],
    "cordiales": [
        "cordial"
    ],
    "cordialite": [
        "cordialite"
    ],
    "cordialites": [
        "cordialite"
    ],
    "cordiaux": [
        "cordial"
    ],
    "cordiers": [
        "cordier"
    ],
    "cordiforme": [
        "cordiforme"
    ],
    "cordiformes": [
        "cordiforme"
    ],
    "cordillere": [
        "cordillere"
    ],
    "cordite": [
        "cordite"
    ],
    "cordobas": [
        "cordoba"
    ],
    "cordon": [
        "cordon"
    ],
    "cordonner": [
        "cordonner"
    ],
    "cordonnerie": [
        "cordonnerie"
    ],
    "cordonnet": [
        "cordonnet"
    ],
    "cordonnets": [
        "cordonnet"
    ],
    "cordonnier": [
        "cordonnier"
    ],
    "cordonniers": [
        "cordonnier"
    ],
    "cordonniere": [
        "cordonnier"
    ],
    "cordonnees": [
        "cordonner"
    ],
    "cordons": [
        "cordon",
        "corder"
    ],
    "cordouan": [
        "cordouan"
    ],
    "cordee": [
        "cordee"
    ],
    "cordees": [
        "cordee",
        "corder"
    ],
    "coreligionnaires": [
        "coreligionnaire"
    ],
    "corelliens": [
        "corellien"
    ],
    "coriace": [
        "coriace"
    ],
    "coriaces": [
        "coriace"
    ],
    "coriacite": [
        "coriacite"
    ],
    "coriandre": [
        "coriandre"
    ],
    "corindon": [
        "corindon"
    ],
    "corinthe": [
        "corinthe"
    ],
    "corinthien": [
        "corinthien"
    ],
    "corinthiennes": [
        "corinthien"
    ],
    "corinthiens": [
        "corinthien"
    ],
    "cormier": [
        "cormier"
    ],
    "cormoran": [
        "cormoran"
    ],
    "cormorans": [
        "cormoran"
    ],
    "corna": [
        "corner"
    ],
    "cornac": [
        "cornac"
    ],
    "cornaient": [
        "corner"
    ],
    "cornais": [
        "corner"
    ],
    "cornait": [
        "corner"
    ],
    "cornaline": [
        "cornaline"
    ],
    "cornalines": [
        "cornaline"
    ],
    "cornant": [
        "corner"
    ],
    "cornaquaient": [
        "cornaquer"
    ],
    "cornaquee": [
        "cornaquer"
    ],
    "cornard": [
        "cornard"
    ],
    "cornards": [
        "cornard"
    ],
    "cornas": [
        "corner"
    ],
    "corne": [
        "corne",
        "corner"
    ],
    "cornecul": [
        "cornecul"
    ],
    "corneille": [
        "corneille"
    ],
    "corneilles": [
        "corneille"
    ],
    "cornemuse": [
        "cornemuse"
    ],
    "cornemuses": [
        "cornemuse"
    ],
    "cornemuseur": [
        "cornemuseur"
    ],
    "cornent": [
        "corner"
    ],
    "corner": [
        "corner"
    ],
    "corners": [
        "corner"
    ],
    "cornes": [
        "corne",
        "corner"
    ],
    "cornet": [
        "cornet"
    ],
    "cornets": [
        "cornet"
    ],
    "cornette": [
        "cornette"
    ],
    "cornettes": [
        "cornette"
    ],
    "corniaud": [
        "corniaud"
    ],
    "corniauds": [
        "corniaud"
    ],
    "corniche": [
        "corniche"
    ],
    "corniches": [
        "corniche"
    ],
    "cornichon": [
        "cornichon"
    ],
    "cornichons": [
        "cornichon"
    ],
    "cornillon": [
        "cornillon"
    ],
    "cornistes": [
        "corniste"
    ],
    "cornieres": [
        "corniere"
    ],
    "cornouaillais": [
        "cornouaillais"
    ],
    "cornouille": [
        "cornouille"
    ],
    "cornouiller": [
        "cornouiller"
    ],
    "cornouillers": [
        "cornouiller"
    ],
    "cornouilles": [
        "cornouille"
    ],
    "cornu": [
        "cornu"
    ],
    "cornue": [
        "cornu",
        "cornue"
    ],
    "cornues": [
        "cornu",
        "cornue"
    ],
    "cornus": [
        "cornu"
    ],
    "cornerent": [
        "corner"
    ],
    "cornee": [
        "corne",
        "cornee",
        "corner"
    ],
    "corneen": [
        "corneen"
    ],
    "corneenne": [
        "corneen"
    ],
    "cornees": [
        "corne",
        "cornee"
    ],
    "cornelien": [
        "cornelien"
    ],
    "cornelienne": [
        "cornelien"
    ],
    "corneliennes": [
        "cornelien"
    ],
    "corollaire": [
        "corollaire"
    ],
    "corollaires": [
        "corollaire"
    ],
    "corolle": [
        "corolle"
    ],
    "corolles": [
        "corolle"
    ],
    "coron": [
        "coron"
    ],
    "corona": [
        "corona"
    ],
    "coronaire": [
        "coronaire"
    ],
    "coronaires": [
        "coronaire"
    ],
    "coronal": [
        "coronal"
    ],
    "coronale": [
        "coronal"
    ],
    "coronales": [
        "coronal"
    ],
    "coronarien": [
        "coronarien"
    ],
    "coronarienne": [
        "coronarien"
    ],
    "coroner": [
        "coroner"
    ],
    "coroners": [
        "coroner"
    ],
    "coronilles": [
        "coronille"
    ],
    "corons": [
        "coron"
    ],
    "corozo": [
        "corozo"
    ],
    "corporal": [
        "corporal"
    ],
    "corporalises": [
        "corporaliser"
    ],
    "corporalite": [
        "corporalite"
    ],
    "corporatif": [
        "corporatif"
    ],
    "corporatifs": [
        "corporatif"
    ],
    "corporation": [
        "corporation"
    ],
    "corporations": [
        "corporation"
    ],
    "corporatisme": [
        "corporatisme"
    ],
    "corporatiste": [
        "corporatiste"
    ],
    "corporative": [
        "corporatif"
    ],
    "corporatives": [
        "corporatif"
    ],
    "corporel": [
        "corporel"
    ],
    "corporelle": [
        "corporel"
    ],
    "corporelles": [
        "corporel"
    ],
    "corporels": [
        "corporel"
    ],
    "corps": [
        "corps"
    ],
    "corpsard": [
        "corpsard"
    ],
    "corpulence": [
        "corpulence"
    ],
    "corpulent": [
        "corpulent"
    ],
    "corpulente": [
        "corpulent"
    ],
    "corpulentes": [
        "corpulent"
    ],
    "corpulents": [
        "corpulent"
    ],
    "corpus": [
        "corpus"
    ],
    "corpuscule": [
        "corpuscule"
    ],
    "corpuscules": [
        "corpuscule"
    ],
    "corral": [
        "corral"
    ],
    "corrals": [
        "corral"
    ],
    "correct": [
        "correct"
    ],
    "correcte": [
        "correct"
    ],
    "correctement": [
        "correctement"
    ],
    "correctes": [
        "correct"
    ],
    "correcteur": [
        "correcteur"
    ],
    "correcteurs": [
        "correcteur"
    ],
    "correctif": [
        "correctif"
    ],
    "correction": [
        "correction"
    ],
    "correctionnaliser": [
        "correctionnaliser"
    ],
    "correctionnel": [
        "correctionnel"
    ],
    "correctionnelle": [
        "correctionnel"
    ],
    "correctionnelles": [
        "correctionnel"
    ],
    "correctionnels": [
        "correctionnel"
    ],
    "corrections": [
        "correction"
    ],
    "corrective": [
        "correctif"
    ],
    "corrector": [
        "corrector"
    ],
    "correctrice": [
        "correcteur"
    ],
    "correctrices": [
        "correcteur"
    ],
    "corrects": [
        "correct"
    ],
    "corregidor": [
        "corregidor"
    ],
    "correspond": [
        "correspondre"
    ],
    "correspondaient": [
        "correspondre"
    ],
    "correspondais": [
        "correspondre"
    ],
    "correspondait": [
        "correspondre"
    ],
    "correspondance": [
        "correspondance"
    ],
    "correspondances": [
        "correspondance"
    ],
    "correspondancier": [
        "correspondancier"
    ],
    "correspondant": [
        "correspondant",
        "correspondre"
    ],
    "correspondante": [
        "correspondant"
    ],
    "correspondantes": [
        "correspondant"
    ],
    "correspondants": [
        "correspondant"
    ],
    "corresponde": [
        "correspondre"
    ],
    "correspondent": [
        "correspondre"
    ],
    "correspondez": [
        "correspondre"
    ],
    "correspondiez": [
        "correspondre"
    ],
    "correspondions": [
        "correspondre"
    ],
    "correspondra": [
        "correspondre"
    ],
    "correspondrai": [
        "correspondre"
    ],
    "correspondraient": [
        "correspondre"
    ],
    "correspondrait": [
        "correspondre"
    ],
    "correspondre": [
        "correspondre"
    ],
    "correspondrons": [
        "correspondre"
    ],
    "corresponds": [
        "correspond",
        "correspondre"
    ],
    "correspondu": [
        "correspondre"
    ],
    "correspondit": [
        "correspondre"
    ],
    "corrida": [
        "corrida"
    ],
    "corridas": [
        "corrida"
    ],
    "corridor": [
        "corridor"
    ],
    "corridors": [
        "corridor"
    ],
    "corrige": [
        "corriger",
        "corrige"
    ],
    "corrigea": [
        "corriger"
    ],
    "corrigeai": [
        "corriger"
    ],
    "corrigeaient": [
        "corriger"
    ],
    "corrigeais": [
        "corriger"
    ],
    "corrigeait": [
        "corriger"
    ],
    "corrigeant": [
        "corriger"
    ],
    "corrigent": [
        "corriger"
    ],
    "corrigeons": [
        "corriger"
    ],
    "corriger": [
        "corriger"
    ],
    "corrigera": [
        "corriger"
    ],
    "corrigerai": [
        "corriger"
    ],
    "corrigerais": [
        "corriger"
    ],
    "corrigerait": [
        "corriger"
    ],
    "corrigeras": [
        "corriger"
    ],
    "corrigerez": [
        "corriger"
    ],
    "corrigerons": [
        "corriger"
    ],
    "corriges": [
        "corriger",
        "corrige"
    ],
    "corrigez": [
        "corriger"
    ],
    "corrigiez": [
        "corriger"
    ],
    "corrigions": [
        "corriger"
    ],
    "corrigee": [
        "corriger",
        "corrige"
    ],
    "corrigees": [
        "corriger",
        "corrige"
    ],
    "corrobora": [
        "corroborer"
    ],
    "corroboraient": [
        "corroborer"
    ],
    "corroborait": [
        "corroborer"
    ],
    "corroborant": [
        "corroborer"
    ],
    "corroboration": [
        "corroboration"
    ],
    "corrobore": [
        "corroborer"
    ],
    "corroborent": [
        "corroborer"
    ],
    "corroborer": [
        "corroborer"
    ],
    "corroborera": [
        "corroborer"
    ],
    "corroborerent": [
        "corroborer"
    ],
    "corroborees": [
        "corroborer"
    ],
    "corrodait": [
        "corroder"
    ],
    "corrodant": [
        "corrodant"
    ],
    "corrodante": [
        "corrodant"
    ],
    "corrode": [
        "corroder"
    ],
    "corrodent": [
        "corroder"
    ],
    "corroder": [
        "corroder"
    ],
    "corrodee": [
        "corroder"
    ],
    "corrodees": [
        "corroder"
    ],
    "corrodes": [
        "corroder"
    ],
    "corroierie": [
        "corroierie"
    ],
    "corrompais": [
        "corrompre"
    ],
    "corrompant": [
        "corrompre"
    ],
    "corrompe": [
        "corrompre"
    ],
    "corrompent": [
        "corrompre"
    ],
    "corrompez": [
        "corrompre"
    ],
    "corrompis": [
        "corrompre"
    ],
    "corrompra": [
        "corrompre"
    ],
    "corrompraient": [
        "corrompre"
    ],
    "corrompre": [
        "corrompre"
    ],
    "corromps": [
        "corrompre"
    ],
    "corrompt": [
        "corrompre"
    ],
    "corrompu": [
        "corrompre",
        "corrompu"
    ],
    "corrompue": [
        "corrompre"
    ],
    "corrompues": [
        "corrompre"
    ],
    "corrompus": [
        "corrompre",
        "corrompu"
    ],
    "corrosif": [
        "corrosif"
    ],
    "corrosifs": [
        "corrosif"
    ],
    "corrosion": [
        "corrosion"
    ],
    "corrosive": [
        "corrosif"
    ],
    "corrosives": [
        "corrosif",
        "corrosive"
    ],
    "corrupteur": [
        "corrupteur"
    ],
    "corrupteurs": [
        "corrupteur"
    ],
    "corruptible": [
        "corruptible"
    ],
    "corruptibles": [
        "corruptible"
    ],
    "corruption": [
        "corruption"
    ],
    "corruptions": [
        "corruption"
    ],
    "corruptrice": [
        "corrupteur"
    ],
    "corruptrices": [
        "corrupteur"
    ],
    "correlatif": [
        "correlatif"
    ],
    "correlation": [
        "correlation"
    ],
    "correlative": [
        "correlatif"
    ],
    "correlativement": [
        "correlativement"
    ],
    "correler": [
        "correler"
    ],
    "correziennes": [
        "correzien"
    ],
    "cors": [
        "cor"
    ],
    "corsa": [
        "corser"
    ],
    "corsage": [
        "corsage"
    ],
    "corsages": [
        "corsage"
    ],
    "corsaire": [
        "corsaire"
    ],
    "corsaires": [
        "corsaire"
    ],
    "corsait": [
        "corser"
    ],
    "corsant": [
        "corser"
    ],
    "corse": [
        "corser",
        "corse"
    ],
    "corselet": [
        "corselet"
    ],
    "corselets": [
        "corselet"
    ],
    "corsent": [
        "corser"
    ],
    "corser": [
        "corser"
    ],
    "corserait": [
        "corser"
    ],
    "corses": [
        "corser",
        "corse"
    ],
    "corset": [
        "corset"
    ],
    "corseter": [
        "corseter"
    ],
    "corsetiere": [
        "corsetier"
    ],
    "corsets": [
        "corset"
    ],
    "corsete": [
        "corseter"
    ],
    "corsetee": [
        "corseter"
    ],
    "corsetees": [
        "corseter"
    ],
    "corsetes": [
        "corseter"
    ],
    "corso": [
        "corso"
    ],
    "corsos": [
        "corso"
    ],
    "corsee": [
        "corser",
        "corse"
    ],
    "corsees": [
        "corse"
    ],
    "cortes": [
        "cortes",
        "corte"
    ],
    "cortex": [
        "cortex"
    ],
    "cortical": [
        "cortical"
    ],
    "corticale": [
        "cortical"
    ],
    "corticales": [
        "cortical"
    ],
    "corticaux": [
        "cortical"
    ],
    "cortine": [
        "cortine"
    ],
    "cortisol": [
        "cortisol"
    ],
    "cortisone": [
        "cortisone"
    ],
    "corton": [
        "corton"
    ],
    "cortege": [
        "cortege"
    ],
    "corteges": [
        "cortege"
    ],
    "cortegeant": [
        "corteger"
    ],
    "coruscant": [
        "coruscant"
    ],
    "coruscante": [
        "coruscant"
    ],
    "coruscants": [
        "coruscant"
    ],
    "coruscation": [
        "coruscation"
    ],
    "corvette": [
        "corvette"
    ],
    "corvettes": [
        "corvette"
    ],
    "corveable": [
        "corveable"
    ],
    "corvee": [
        "corvee"
    ],
    "corvees": [
        "corvee"
    ],
    "corybantes": [
        "corybante"
    ],
    "coryphene": [
        "coryphene"
    ],
    "coryphee": [
        "coryphee"
    ],
    "coryste": [
        "coryste"
    ],
    "coryza": [
        "coryza"
    ],
    "core": [
        "core"
    ],
    "coreen": [
        "coreen"
    ],
    "coreenne": [
        "coreen"
    ],
    "coreennes": [
        "coreen"
    ],
    "coreens": [
        "coreen"
    ],
    "cosaque": [
        "cosaque"
    ],
    "cosaques": [
        "cosaque"
    ],
    "coseigneurs": [
        "coseigneur"
    ],
    "cosigner": [
        "cosigner"
    ],
    "cosigne": [
        "cosigner"
    ],
    "cosinus": [
        "cosinus"
    ],
    "cosmique": [
        "cosmique"
    ],
    "cosmiquement": [
        "cosmiquement"
    ],
    "cosmiques": [
        "cosmique"
    ],
    "cosmo": [
        "cosmo"
    ],
    "cosmodromes": [
        "cosmodrome"
    ],
    "cosmogonie": [
        "cosmogonie"
    ],
    "cosmogonies": [
        "cosmogonie"
    ],
    "cosmogonique": [
        "cosmogonique"
    ],
    "cosmographie": [
        "cosmographie"
    ],
    "cosmologie": [
        "cosmologie"
    ],
    "cosmologique": [
        "cosmologique"
    ],
    "cosmologiques": [
        "cosmologique"
    ],
    "cosmologue": [
        "cosmologue"
    ],
    "cosmonaute": [
        "cosmonaute"
    ],
    "cosmonautes": [
        "cosmonaute"
    ],
    "cosmopolite": [
        "cosmopolite"
    ],
    "cosmopolites": [
        "cosmopolite"
    ],
    "cosmopolitisme": [
        "cosmopolitisme"
    ],
    "cosmos": [
        "cosmos"
    ],
    "cosmeticienne": [
        "cosmeticien"
    ],
    "cosmetique": [
        "cosmetique",
        "cosmetiquer"
    ],
    "cosmetiques": [
        "cosmetique",
        "cosmetiquer"
    ],
    "cosmetiquee": [
        "cosmetiquer"
    ],
    "cosmetiquees": [
        "cosmetiquer"
    ],
    "cosmetologie": [
        "cosmetologie"
    ],
    "cosmetologue": [
        "cosmetologue"
    ],
    "cossard": [
        "cossard"
    ],
    "cossarde": [
        "cossard"
    ],
    "cossards": [
        "cossard"
    ],
    "cosse": [
        "cosse"
    ],
    "cossent": [
        "cosser"
    ],
    "cosses": [
        "cosse"
    ],
    "cossu": [
        "cossu"
    ],
    "cossue": [
        "cossu"
    ],
    "cossues": [
        "cossu"
    ],
    "cossus": [
        "cossu",
        "cossus"
    ],
    "costal": [
        "costal"
    ],
    "costale": [
        "costal"
    ],
    "costar": [
        "costar"
    ],
    "costard": [
        "costard"
    ],
    "costards": [
        "costard"
    ],
    "costaricain": [
        "costaricain"
    ],
    "costaud": [
        "costaud"
    ],
    "costaude": [
        "costaud"
    ],
    "costaudes": [
        "costaud"
    ],
    "costauds": [
        "costaud"
    ],
    "costaux": [
        "costal"
    ],
    "costume": [
        "costumer",
        "costume"
    ],
    "costumer": [
        "costumer"
    ],
    "costumes": [
        "costumer",
        "costume"
    ],
    "costumier": [
        "costumier"
    ],
    "costumiers": [
        "costumier"
    ],
    "costumiere": [
        "costumier"
    ],
    "costumee": [
        "costumer",
        "costume"
    ],
    "costumees": [
        "costumer"
    ],
    "cosy": [
        "cosy"
    ],
    "cosys": [
        "cosy"
    ],
    "cota": [
        "coter"
    ],
    "cotait": [
        "coter"
    ],
    "cotation": [
        "cotation"
    ],
    "cotations": [
        "cotation"
    ],
    "cote": [
        "cote",
        "coter"
    ],
    "coteau": [
        "coteau"
    ],
    "coteaux": [
        "coteau"
    ],
    "cotent": [
        "coter"
    ],
    "coter": [
        "coter"
    ],
    "coterie": [
        "coterie"
    ],
    "coteries": [
        "coterie"
    ],
    "cotes": [
        "cote",
        "coter"
    ],
    "cothurne": [
        "cothurne"
    ],
    "cothurnes": [
        "cothurne"
    ],
    "coties": [
        "cotir"
    ],
    "cotillon": [
        "cotillon"
    ],
    "cotillons": [
        "cotillon"
    ],
    "cotisa": [
        "cotiser"
    ],
    "cotisaient": [
        "cotiser"
    ],
    "cotisais": [
        "cotiser"
    ],
    "cotisant": [
        "cotiser",
        "cotisant"
    ],
    "cotisants": [
        "cotisant"
    ],
    "cotisation": [
        "cotisation"
    ],
    "cotisations": [
        "cotisation"
    ],
    "cotise": [
        "cotiser"
    ],
    "cotisent": [
        "cotiser"
    ],
    "cotiser": [
        "cotiser"
    ],
    "cotises": [
        "cotiser"
    ],
    "cotiserent": [
        "cotiser"
    ],
    "cotisees": [
        "cotiser"
    ],
    "coton": [
        "coton"
    ],
    "cotonnade": [
        "cotonnade"
    ],
    "cotonnades": [
        "cotonnade"
    ],
    "cotonnait": [
        "cotonner"
    ],
    "cotonnant": [
        "cotonner"
    ],
    "cotonnerie": [
        "cotonnerie"
    ],
    "cotonneuse": [
        "cotonneux"
    ],
    "cotonneuses": [
        "cotonneux"
    ],
    "cotonneux": [
        "cotonneux"
    ],
    "cotonnier": [
        "cotonnier"
    ],
    "cotonniere": [
        "cotonniere"
    ],
    "cotons": [
        "coton"
    ],
    "cotoneasters": [
        "cotoneaster"
    ],
    "cotre": [
        "cotre"
    ],
    "cotres": [
        "cotre"
    ],
    "cotrets": [
        "cotret"
    ],
    "cotriade": [
        "cotriade"
    ],
    "cottage": [
        "cottage"
    ],
    "cottages": [
        "cottage"
    ],
    "cotte": [
        "cotte"
    ],
    "cottes": [
        "cotte"
    ],
    "coturne": [
        "coturne"
    ],
    "cotyledons": [
        "cotyledon"
    ],
    "cotat": [
        "coter"
    ],
    "cotee": [
        "cote",
        "coter"
    ],
    "cotees": [
        "cote",
        "coter"
    ],
    "cou": [
        "cou"
    ],
    "couac": [
        "couac"
    ],
    "couacs": [
        "couac"
    ],
    "couaille": [
        "couaille"
    ],
    "couaquait": [
        "couaquer"
    ],
    "couaquer": [
        "couaquer"
    ],
    "couard": [
        "couard"
    ],
    "couarde": [
        "couard"
    ],
    "couardise": [
        "couardise"
    ],
    "couards": [
        "couard"
    ],
    "coucha": [
        "coucher"
    ],
    "couchage": [
        "couchage"
    ],
    "couchai": [
        "coucher"
    ],
    "couchaient": [
        "coucher"
    ],
    "couchailler": [
        "couchailler"
    ],
    "couchais": [
        "coucher"
    ],
    "couchait": [
        "coucher"
    ],
    "couchant": [
        "couchant",
        "coucher"
    ],
    "couchants": [
        "couchant"
    ],
    "couche": [
        "couche",
        "coucher"
    ],
    "couchent": [
        "coucher"
    ],
    "coucher": [
        "coucher"
    ],
    "couchera": [
        "coucher"
    ],
    "coucherai": [
        "coucher"
    ],
    "coucheraient": [
        "coucher"
    ],
    "coucherais": [
        "coucher"
    ],
    "coucherait": [
        "coucher"
    ],
    "coucheras": [
        "coucher"
    ],
    "coucherez": [
        "coucher"
    ],
    "coucherie": [
        "coucherie"
    ],
    "coucheries": [
        "coucherie"
    ],
    "coucheriez": [
        "coucher"
    ],
    "coucherions": [
        "coucher"
    ],
    "coucherons": [
        "coucher"
    ],
    "coucheront": [
        "coucher"
    ],
    "couchers": [
        "coucher"
    ],
    "couches": [
        "couche",
        "couch",
        "coucher"
    ],
    "couchette": [
        "couchette"
    ],
    "couchettes": [
        "couchette"
    ],
    "coucheur": [
        "coucheur"
    ],
    "coucheurs": [
        "coucheur"
    ],
    "coucheuse": [
        "coucheur"
    ],
    "couchez": [
        "coucher"
    ],
    "couchiez": [
        "coucher"
    ],
    "couchions": [
        "coucher"
    ],
    "couchoir": [
        "couchoir"
    ],
    "couchons": [
        "coucher"
    ],
    "couchames": [
        "coucher"
    ],
    "couchat": [
        "coucher"
    ],
    "coucherent": [
        "coucher"
    ],
    "couchee": [
        "couche",
        "coucher"
    ],
    "couchees": [
        "couche",
        "coucher"
    ],
    "coucou": [
        "coucou"
    ],
    "coucous": [
        "coucou"
    ],
    "coud": [
        "coudre"
    ],
    "coude": [
        "coude",
        "couder"
    ],
    "coudent": [
        "couder"
    ],
    "coudes": [
        "coude"
    ],
    "coudoie": [
        "coudoyer"
    ],
    "coudoient": [
        "coudoyer"
    ],
    "coudoyai": [
        "coudoyer"
    ],
    "coudoyaient": [
        "coudoyer"
    ],
    "coudoyais": [
        "coudoyer"
    ],
    "coudoyant": [
        "coudoyer"
    ],
    "coudoyer": [
        "coudoyer"
    ],
    "coudoyons": [
        "coudoyer"
    ],
    "coudoye": [
        "coudoyer"
    ],
    "coudra": [
        "coudre"
    ],
    "coudrai": [
        "coudre"
    ],
    "coudrais": [
        "coudre"
    ],
    "coudrait": [
        "coudre"
    ],
    "coudras": [
        "coudre"
    ],
    "coudre": [
        "coudre"
    ],
    "coudreuse": [
        "coudreuse"
    ],
    "coudrier": [
        "coudrier"
    ],
    "coudriers": [
        "coudrier"
    ],
    "couds": [
        "coudre"
    ],
    "coudee": [
        "coudee",
        "coude",
        "couder"
    ],
    "coudees": [
        "coudee",
        "coude",
        "couder"
    ],
    "couenne": [
        "couenne"
    ],
    "couennes": [
        "couenne"
    ],
    "couette": [
        "couette"
    ],
    "couettes": [
        "couette"
    ],
    "couffin": [
        "couffin"
    ],
    "couffins": [
        "couffin"
    ],
    "couguar": [
        "couguar"
    ],
    "couguars": [
        "couguar"
    ],
    "couic": [
        "couic"
    ],
    "couillard": [
        "couillard"
    ],
    "couille": [
        "couille"
    ],
    "couilles": [
        "couille"
    ],
    "couillettes": [
        "couillette"
    ],
    "couillon": [
        "couillon"
    ],
    "couillonnade": [
        "couillonnade"
    ],
    "couillonnades": [
        "couillonnade"
    ],
    "couillonne": [
        "couillonner"
    ],
    "couillonnent": [
        "couillonner"
    ],
    "couillonner": [
        "couillonner"
    ],
    "couillonnee": [
        "couillonner"
    ],
    "couillonnes": [
        "couillonner"
    ],
    "couillons": [
        "couillon"
    ],
    "couillu": [
        "couillu"
    ],
    "couillus": [
        "couillu"
    ],
    "couina": [
        "couiner"
    ],
    "couinaient": [
        "couiner"
    ],
    "couinais": [
        "couiner"
    ],
    "couinait": [
        "couiner"
    ],
    "couinant": [
        "couinant",
        "couiner"
    ],
    "couine": [
        "couiner"
    ],
    "couinement": [
        "couinement"
    ],
    "couinements": [
        "couinement"
    ],
    "couinent": [
        "couiner"
    ],
    "couiner": [
        "couiner"
    ],
    "couinerais": [
        "couiner"
    ],
    "couineras": [
        "couiner"
    ],
    "couineront": [
        "couiner"
    ],
    "couines": [
        "couiner"
    ],
    "couinez": [
        "couiner"
    ],
    "coula": [
        "couler"
    ],
    "coulage": [
        "coulage"
    ],
    "coulai": [
        "couler"
    ],
    "coulaient": [
        "couler"
    ],
    "coulais": [
        "couler"
    ],
    "coulait": [
        "couler"
    ],
    "coulant": [
        "couler",
        "coulant"
    ],
    "coulante": [
        "coulant"
    ],
    "coulants": [
        "coulant"
    ],
    "coule": [
        "coule",
        "couler"
    ],
    "coulemelle": [
        "coulemelle"
    ],
    "coulent": [
        "couler"
    ],
    "couler": [
        "couler"
    ],
    "coulera": [
        "couler"
    ],
    "coulerai": [
        "couler"
    ],
    "couleraient": [
        "couler"
    ],
    "coulerais": [
        "couler"
    ],
    "coulerait": [
        "couler"
    ],
    "couleras": [
        "couler"
    ],
    "coulerez": [
        "couler"
    ],
    "couleront": [
        "couler"
    ],
    "coules": [
        "couler",
        "coule"
    ],
    "couleur": [
        "couleur"
    ],
    "couleurs": [
        "couleur"
    ],
    "couleuvre": [
        "couleuvre"
    ],
    "couleuvres": [
        "couleuvre"
    ],
    "couleuvrine": [
        "couleuvrine"
    ],
    "couleuvrines": [
        "couleuvrine"
    ],
    "coulez": [
        "couler"
    ],
    "couliez": [
        "couler"
    ],
    "coulions": [
        "couler"
    ],
    "coulis": [
        "coulis"
    ],
    "coulissa": [
        "coulisser"
    ],
    "coulissaient": [
        "coulisser"
    ],
    "coulissait": [
        "coulisser"
    ],
    "coulissant": [
        "coulisser",
        "coulissant"
    ],
    "coulissante": [
        "coulissant"
    ],
    "coulissantes": [
        "coulissant"
    ],
    "coulissants": [
        "coulissant"
    ],
    "coulisse": [
        "coulisse",
        "coulisser"
    ],
    "coulissements": [
        "coulissement"
    ],
    "coulissent": [
        "coulisser"
    ],
    "coulisser": [
        "coulisser"
    ],
    "coulisses": [
        "coulisse",
        "coulisser"
    ],
    "coulissier": [
        "coulissier"
    ],
    "coulisserent": [
        "coulisser"
    ],
    "coulissee": [
        "coulisser"
    ],
    "couloir": [
        "couloir"
    ],
    "couloirs": [
        "couloir"
    ],
    "coulombs": [
        "coulomb"
    ],
    "coulons": [
        "couler"
    ],
    "coulpe": [
        "coulpe"
    ],
    "coulure": [
        "coulure"
    ],
    "coulures": [
        "coulure"
    ],
    "coulat": [
        "couler"
    ],
    "coulerent": [
        "couler"
    ],
    "coulee": [
        "couler",
        "coulee",
        "coule"
    ],
    "coulees": [
        "couler",
        "coulee",
        "coule"
    ],
    "coumarine": [
        "coumarine"
    ],
    "countries": [
        "country",
        "countries"
    ],
    "country": [
        "country"
    ],
    "coup": [
        "coup"
    ],
    "coupa": [
        "couper"
    ],
    "coupable": [
        "coupable"
    ],
    "coupablement": [
        "coupablement"
    ],
    "coupables": [
        "coupable"
    ],
    "coupage": [
        "coupage"
    ],
    "coupages": [
        "coupage"
    ],
    "coupai": [
        "couper"
    ],
    "coupaient": [
        "couper"
    ],
    "coupailler": [
        "coupailler"
    ],
    "coupais": [
        "couper"
    ],
    "coupait": [
        "couper"
    ],
    "coupant": [
        "coupant",
        "couper"
    ],
    "coupante": [
        "coupant"
    ],
    "coupantes": [
        "coupant"
    ],
    "coupants": [
        "coupant"
    ],
    "coupe": [
        "coupe",
        "couper"
    ],
    "coupelle": [
        "coupelle"
    ],
    "coupelles": [
        "coupelle"
    ],
    "coupent": [
        "couper"
    ],
    "couper": [
        "couper"
    ],
    "coupera": [
        "couper"
    ],
    "couperai": [
        "couper"
    ],
    "couperaient": [
        "couper"
    ],
    "couperais": [
        "couper"
    ],
    "couperait": [
        "couper"
    ],
    "couperas": [
        "couper"
    ],
    "couperet": [
        "couperet"
    ],
    "couperets": [
        "couperet"
    ],
    "couperez": [
        "couper"
    ],
    "couperons": [
        "couper"
    ],
    "couperont": [
        "couper"
    ],
    "couperose": [
        "couperoser",
        "couperose"
    ],
    "couperosee": [
        "couperose"
    ],
    "couperosees": [
        "couperose"
    ],
    "coupes": [
        "coupe",
        "couper"
    ],
    "coupeur": [
        "coupeur"
    ],
    "coupeurs": [
        "coupeur"
    ],
    "coupeuse": [
        "coupeur"
    ],
    "coupez": [
        "couper"
    ],
    "coupiez": [
        "couper"
    ],
    "coupions": [
        "couper"
    ],
    "couplage": [
        "couplage"
    ],
    "couplages": [
        "couplage"
    ],
    "couplant": [
        "coupler"
    ],
    "couple": [
        "coupler",
        "couple"
    ],
    "coupler": [
        "coupler"
    ],
    "couples": [
        "coupler",
        "couple"
    ],
    "couplet": [
        "couplet"
    ],
    "couplets": [
        "couplet"
    ],
    "coupleur": [
        "coupleur"
    ],
    "coupleurs": [
        "coupleur"
    ],
    "couplee": [
        "coupler"
    ],
    "couplees": [
        "coupler"
    ],
    "coupole": [
        "coupole"
    ],
    "coupoles": [
        "coupole"
    ],
    "coupon": [
        "coupon"
    ],
    "coupons": [
        "coupon",
        "couper"
    ],
    "coups": [
        "coup"
    ],
    "coupure": [
        "coupure"
    ],
    "coupures": [
        "coupure"
    ],
    "couperent": [
        "couper"
    ],
    "coupee": [
        "coupee",
        "coupe",
        "couper"
    ],
    "coupees": [
        "coupee",
        "coupe",
        "couper"
    ],
    "couques": [
        "couque"
    ],
    "cour": [
        "cour"
    ],
    "courage": [
        "courage"
    ],
    "courages": [
        "courage"
    ],
    "courageuse": [
        "courageux"
    ],
    "courageusement": [
        "courageusement"
    ],
    "courageuses": [
        "courageux"
    ],
    "courageux": [
        "courageux"
    ],
    "couraient": [
        "courir"
    ],
    "courailler": [
        "courailler"
    ],
    "courais": [
        "courir"
    ],
    "courait": [
        "courir"
    ],
    "couramment": [
        "couramment"
    ],
    "courant": [
        "courant",
        "courir"
    ],
    "courante": [
        "courante",
        "courant"
    ],
    "courantes": [
        "courante",
        "courant"
    ],
    "courants": [
        "courant"
    ],
    "courba": [
        "courber"
    ],
    "courbaient": [
        "courber"
    ],
    "courbait": [
        "courber"
    ],
    "courbant": [
        "courber"
    ],
    "courbatu": [
        "courbatu"
    ],
    "courbatue": [
        "courbatu"
    ],
    "courbature": [
        "courbature"
    ],
    "courbatures": [
        "courbature"
    ],
    "courbaturee": [
        "courbature"
    ],
    "courbatus": [
        "courbatu"
    ],
    "courbe": [
        "courbe",
        "courber"
    ],
    "courbent": [
        "courber"
    ],
    "courber": [
        "courber"
    ],
    "courberait": [
        "courber"
    ],
    "courbes": [
        "courbe",
        "courber"
    ],
    "courbette": [
        "courbette"
    ],
    "courbettes": [
        "courbette"
    ],
    "courbez": [
        "courber"
    ],
    "courbons": [
        "courber"
    ],
    "courbure": [
        "courbure"
    ],
    "courbures": [
        "courbure"
    ],
    "courbee": [
        "courbe",
        "courber"
    ],
    "courbees": [
        "courbe",
        "courber"
    ],
    "coure": [
        "courir"
    ],
    "courent": [
        "courir"
    ],
    "coures": [
        "courir"
    ],
    "courette": [
        "courette"
    ],
    "courettes": [
        "courette"
    ],
    "coureur": [
        "coureur"
    ],
    "coureurs": [
        "coureur"
    ],
    "coureuse": [
        "coureur"
    ],
    "coureuses": [
        "coureur"
    ],
    "courez": [
        "courir"
    ],
    "courge": [
        "courge"
    ],
    "courges": [
        "courge"
    ],
    "courgette": [
        "courgette"
    ],
    "courgettes": [
        "courgette"
    ],
    "couriez": [
        "courir"
    ],
    "courions": [
        "courir"
    ],
    "courir": [
        "courir"
    ],
    "courlis": [
        "courlis"
    ],
    "couronna": [
        "couronner"
    ],
    "couronnaient": [
        "couronner"
    ],
    "couronnait": [
        "couronner"
    ],
    "couronnant": [
        "couronner"
    ],
    "couronne": [
        "couronner",
        "couronne"
    ],
    "couronnement": [
        "couronnement"
    ],
    "couronnements": [
        "couronnement"
    ],
    "couronnent": [
        "couronner"
    ],
    "couronner": [
        "couronner"
    ],
    "couronnera": [
        "couronner"
    ],
    "couronnerai": [
        "couronner"
    ],
    "couronnerons": [
        "couronner"
    ],
    "couronnes": [
        "couronner",
        "couronne"
    ],
    "couronnee": [
        "couronner",
        "couronne"
    ],
    "couronnees": [
        "couronner",
        "couronne"
    ],
    "courons": [
        "courir"
    ],
    "courra": [
        "courir"
    ],
    "courrai": [
        "courir"
    ],
    "courraient": [
        "courir"
    ],
    "courrais": [
        "courir"
    ],
    "courrait": [
        "courir"
    ],
    "courras": [
        "courir"
    ],
    "courre": [
        "courre"
    ],
    "courrez": [
        "courir"
    ],
    "courriel": [
        "courriel"
    ],
    "courrier": [
        "courrier"
    ],
    "courriers": [
        "courrier"
    ],
    "courriez": [
        "courir"
    ],
    "courrions": [
        "courir"
    ],
    "courrieriste": [
        "courrieriste"
    ],
    "courroie": [
        "courroie"
    ],
    "courroies": [
        "courroie"
    ],
    "courrons": [
        "courir"
    ],
    "courront": [
        "courir"
    ],
    "courrouce": [
        "courroucer"
    ],
    "courroucer": [
        "courroucer"
    ],
    "courroucee": [
        "courroucer"
    ],
    "courroucees": [
        "courroucer"
    ],
    "courrouces": [
        "courroucer"
    ],
    "courroux": [
        "courroux"
    ],
    "courroucaient": [
        "courroucer"
    ],
    "courroucait": [
        "courroucer"
    ],
    "cours": [
        "cours",
        "courir"
    ],
    "coursaient": [
        "courser"
    ],
    "coursais": [
        "courser"
    ],
    "coursait": [
        "courser"
    ],
    "coursant": [
        "courser"
    ],
    "course": [
        "courser",
        "course"
    ],
    "coursent": [
        "courser"
    ],
    "courser": [
        "courser"
    ],
    "courserais": [
        "courser"
    ],
    "courses": [
        "courser",
        "course"
    ],
    "coursier": [
        "coursier"
    ],
    "coursiers": [
        "coursier"
    ],
    "coursive": [
        "coursive"
    ],
    "coursives": [
        "coursive"
    ],
    "coursiere": [
        "coursier"
    ],
    "coursee": [
        "courser"
    ],
    "court": [
        "courir",
        "court"
    ],
    "courtage": [
        "courtage"
    ],
    "courtages": [
        "courtage"
    ],
    "courtaud": [
        "courtaud"
    ],
    "courtaude": [
        "courtaud"
    ],
    "courtaudes": [
        "courtaud"
    ],
    "courtauds": [
        "courtaud"
    ],
    "courte": [
        "courter",
        "court"
    ],
    "courtelinesque": [
        "courtelinesque"
    ],
    "courtelinesques": [
        "courtelinesque"
    ],
    "courtement": [
        "courtement"
    ],
    "courtepointe": [
        "courtepointe"
    ],
    "courtepointes": [
        "courtepointe"
    ],
    "courtes": [
        "court"
    ],
    "courtier": [
        "courtier"
    ],
    "courtiers": [
        "courtier"
    ],
    "courtiliere": [
        "courtiliere"
    ],
    "courtilieres": [
        "courtiliere"
    ],
    "courtils": [
        "courtil"
    ],
    "courtine": [
        "courtine"
    ],
    "courtines": [
        "courtine"
    ],
    "courtisa": [
        "courtiser"
    ],
    "courtisaient": [
        "courtiser"
    ],
    "courtisais": [
        "courtiser"
    ],
    "courtisait": [
        "courtiser"
    ],
    "courtisan": [
        "courtisan"
    ],
    "courtisane": [
        "courtisan"
    ],
    "courtisanerie": [
        "courtisanerie"
    ],
    "courtisanes": [
        "courtisan"
    ],
    "courtisans": [
        "courtisan"
    ],
    "courtisant": [
        "courtiser"
    ],
    "courtise": [
        "courtiser"
    ],
    "courtisent": [
        "courtiser"
    ],
    "courtiser": [
        "courtiser"
    ],
    "courtiserai": [
        "courtiser"
    ],
    "courtiseras": [
        "courtiser"
    ],
    "courtisez": [
        "courtiser"
    ],
    "courtisiez": [
        "courtiser"
    ],
    "courtisee": [
        "courtiser"
    ],
    "courtisees": [
        "courtiser"
    ],
    "courtiere": [
        "courtier"
    ],
    "courtieres": [
        "courtier"
    ],
    "courtois": [
        "courtois"
    ],
    "courtoise": [
        "courtois"
    ],
    "courtoisement": [
        "courtoisement"
    ],
    "courtoises": [
        "courtois"
    ],
    "courtoisie": [
        "courtoisie"
    ],
    "courtoisies": [
        "courtoisie"
    ],
    "courts": [
        "court"
    ],
    "couru": [
        "couru",
        "courir"
    ],
    "courue": [
        "couru",
        "courir"
    ],
    "courues": [
        "couru",
        "courir"
    ],
    "coururent": [
        "courir"
    ],
    "courus": [
        "couru",
        "courir"
    ],
    "courussent": [
        "courir"
    ],
    "courut": [
        "courir"
    ],
    "courumes": [
        "courir"
    ],
    "courutes": [
        "courir"
    ],
    "cous": [
        "cou"
    ],
    "cousaient": [
        "coudre"
    ],
    "cousait": [
        "coudre"
    ],
    "cousant": [
        "coudre"
    ],
    "couscous": [
        "couscous"
    ],
    "couscoussier": [
        "couscoussier"
    ],
    "couscoussiers": [
        "couscoussier"
    ],
    "couse": [
        "coudre"
    ],
    "cousent": [
        "coudre"
    ],
    "cousette": [
        "cousette"
    ],
    "cousettes": [
        "cousette"
    ],
    "couseuse": [
        "couseur"
    ],
    "cousez": [
        "coudre"
    ],
    "cousiez": [
        "coudre"
    ],
    "cousin": [
        "cousin"
    ],
    "cousinage": [
        "cousinage"
    ],
    "cousinages": [
        "cousinage"
    ],
    "cousinant": [
        "cousiner"
    ],
    "cousine": [
        "cousin"
    ],
    "cousines": [
        "cousin"
    ],
    "cousins": [
        "cousin"
    ],
    "cousirent": [
        "coudre"
    ],
    "cousissent": [
        "coudre"
    ],
    "cousit": [
        "coudre"
    ],
    "coussin": [
        "coussin"
    ],
    "coussinet": [
        "coussinet"
    ],
    "coussinets": [
        "coussinet"
    ],
    "coussins": [
        "coussin"
    ],
    "cousu": [
        "coudre",
        "cousu"
    ],
    "cousue": [
        "coudre",
        "cousu"
    ],
    "cousues": [
        "coudre",
        "cousu"
    ],
    "cousus": [
        "coudre",
        "cousu"
    ],
    "couteau": [
        "couteau"
    ],
    "couteaux": [
        "couteau"
    ],
    "coutelas": [
        "coutelas"
    ],
    "coutelier": [
        "coutelier"
    ],
    "coutellerie": [
        "coutellerie"
    ],
    "coutelleries": [
        "coutellerie"
    ],
    "coutil": [
        "coutil"
    ],
    "coutume": [
        "coutume"
    ],
    "coutumes": [
        "coutume"
    ],
    "coutumier": [
        "coutumier"
    ],
    "coutumiers": [
        "coutumier"
    ],
    "coutumiere": [
        "coutumier"
    ],
    "coutumierement": [
        "coutumierement"
    ],
    "coutumieres": [
        "coutumier"
    ],
    "couturaient": [
        "couturer"
    ],
    "couture": [
        "couturer",
        "couture"
    ],
    "coutures": [
        "couturer",
        "couture"
    ],
    "couturier": [
        "couturier"
    ],
    "couturiers": [
        "couturier"
    ],
    "couturiere": [
        "couturier"
    ],
    "couturieres": [
        "couturier"
    ],
    "couturee": [
        "couturer",
        "couture"
    ],
    "couturees": [
        "couturer",
        "couture"
    ],
    "couvade": [
        "couvade"
    ],
    "couvaient": [
        "couver"
    ],
    "couvais": [
        "couver"
    ],
    "couvaison": [
        "couvaison"
    ],
    "couvaisons": [
        "couvaison"
    ],
    "couvait": [
        "couver"
    ],
    "couvant": [
        "couver"
    ],
    "couve": [
        "couver"
    ],
    "couvent": [
        "couvent",
        "couver"
    ],
    "couventine": [
        "couventine"
    ],
    "couventines": [
        "couventine"
    ],
    "couvents": [
        "couvent"
    ],
    "couver": [
        "couver"
    ],
    "couvercle": [
        "couvercle"
    ],
    "couvercles": [
        "couvercle"
    ],
    "couveront": [
        "couver"
    ],
    "couvert": [
        "couvert",
        "couvrir"
    ],
    "couverte": [
        "couvert",
        "couvrir"
    ],
    "couvertes": [
        "couvert",
        "couvrir"
    ],
    "couverts": [
        "couvert",
        "couvrir"
    ],
    "couverture": [
        "couverture"
    ],
    "couvertures": [
        "couverture"
    ],
    "couves": [
        "couver"
    ],
    "couvet": [
        "couvet"
    ],
    "couveuse": [
        "couveuse"
    ],
    "couveuses": [
        "couveuse"
    ],
    "couvez": [
        "couver"
    ],
    "couvis": [
        "couvi"
    ],
    "couvraient": [
        "couvrir"
    ],
    "couvrais": [
        "couvrir"
    ],
    "couvrait": [
        "couvrir"
    ],
    "couvrant": [
        "couvrant",
        "couvrir"
    ],
    "couvrante": [
        "couvrant"
    ],
    "couvrantes": [
        "couvrant"
    ],
    "couvre": [
        "couvrir"
    ],
    "couvrent": [
        "couvrir"
    ],
    "couvres": [
        "couvrir"
    ],
    "couvreur": [
        "couvreur"
    ],
    "couvreurs": [
        "couvreur"
    ],
    "couvrez": [
        "couvrir"
    ],
    "couvriez": [
        "couvrir"
    ],
    "couvrir": [
        "couvrir"
    ],
    "couvrira": [
        "couvrir"
    ],
    "couvrirai": [
        "couvrir"
    ],
    "couvriraient": [
        "couvrir"
    ],
    "couvrirais": [
        "couvrir"
    ],
    "couvrirait": [
        "couvrir"
    ],
    "couvriras": [
        "couvrir"
    ],
    "couvrirent": [
        "couvrir"
    ],
    "couvrirez": [
        "couvrir"
    ],
    "couvrirons": [
        "couvrir"
    ],
    "couvriront": [
        "couvrir"
    ],
    "couvris": [
        "couvrir"
    ],
    "couvrit": [
        "couvrir"
    ],
    "couvrons": [
        "couvrir"
    ],
    "couvee": [
        "couvee",
        "couver"
    ],
    "couvees": [
        "couvee",
        "couver"
    ],
    "covalent": [
        "covalent"
    ],
    "covalente": [
        "covalent"
    ],
    "covenant": [
        "covenant"
    ],
    "covoiturage": [
        "covoiturage"
    ],
    "coxalgie": [
        "coxalgie"
    ],
    "coxalgique": [
        "coxalgique"
    ],
    "coyote": [
        "coyote"
    ],
    "coyotes": [
        "coyote"
    ],
    "coequipier": [
        "coequipier"
    ],
    "coequipiers": [
        "coequipier"
    ],
    "coequipiere": [
        "coequipier"
    ],
    "coequipieres": [
        "coequipier"
    ],
    "coincida": [
        "coincider"
    ],
    "coincidaient": [
        "coincider"
    ],
    "coincidais": [
        "coincider"
    ],
    "coincidait": [
        "coincider"
    ],
    "coincidant": [
        "coincider"
    ],
    "coincidassent": [
        "coincider"
    ],
    "coincide": [
        "coincider"
    ],
    "coincidence": [
        "coincidence"
    ],
    "coincidences": [
        "coincidence"
    ],
    "coincident": [
        "coincider",
        "coincident"
    ],
    "coincider": [
        "coincider"
    ],
    "coinciderait": [
        "coincider"
    ],
    "coincidions": [
        "coincider"
    ],
    "coincidat": [
        "coincider"
    ],
    "coinciderent": [
        "coincider"
    ],
    "coit": [
        "coit"
    ],
    "coits": [
        "coit"
    ],
    "cout": [
        "cout"
    ],
    "couta": [
        "couter"
    ],
    "coutaient": [
        "couter"
    ],
    "coutais": [
        "couter"
    ],
    "coutait": [
        "couter"
    ],
    "coutant": [
        "couter",
        "coutant"
    ],
    "coute": [
        "couter"
    ],
    "coutent": [
        "couter"
    ],
    "couter": [
        "couter"
    ],
    "coutera": [
        "couter"
    ],
    "couterai": [
        "couter"
    ],
    "couteraient": [
        "couter"
    ],
    "couterait": [
        "couter"
    ],
    "couteras": [
        "couter"
    ],
    "couteront": [
        "couter"
    ],
    "coutes": [
        "couter"
    ],
    "couteuse": [
        "couteux"
    ],
    "couteusement": [
        "couteusement"
    ],
    "couteuses": [
        "couteux"
    ],
    "couteux": [
        "couteux"
    ],
    "coutez": [
        "couter"
    ],
    "coutions": [
        "couter"
    ],
    "couts": [
        "cout"
    ],
    "coutat": [
        "couter"
    ],
    "coutee": [
        "couter"
    ],
    "coutees": [
        "couter"
    ],
    "crabe": [
        "crabe"
    ],
    "crabes": [
        "crabe"
    ],
    "crabillon": [
        "crabillon"
    ],
    "crabillons": [
        "crabillon"
    ],
    "crabs": [
        "crabs",
        "crab"
    ],
    "crac": [
        "crac"
    ],
    "cracha": [
        "cracher"
    ],
    "crachai": [
        "cracher"
    ],
    "crachaient": [
        "cracher"
    ],
    "crachais": [
        "cracher"
    ],
    "crachait": [
        "cracher"
    ],
    "crachant": [
        "cracher"
    ],
    "crachat": [
        "crachat"
    ],
    "crachats": [
        "crachat"
    ],
    "crache": [
        "cracher",
        "crache"
    ],
    "crachement": [
        "crachement"
    ],
    "crachements": [
        "crachement"
    ],
    "crachent": [
        "cracher"
    ],
    "cracher": [
        "cracher"
    ],
    "crachera": [
        "cracher"
    ],
    "cracherai": [
        "cracher"
    ],
    "cracherais": [
        "cracher"
    ],
    "cracherait": [
        "cracher"
    ],
    "cracheriez": [
        "cracher"
    ],
    "cracheront": [
        "cracher"
    ],
    "craches": [
        "cracher",
        "crache"
    ],
    "cracheur": [
        "cracheur"
    ],
    "cracheurs": [
        "cracheur"
    ],
    "cracheuse": [
        "cracheur"
    ],
    "cracheuses": [
        "cracheur"
    ],
    "crachez": [
        "cracher"
    ],
    "crachin": [
        "crachin"
    ],
    "crachine": [
        "crachiner"
    ],
    "crachiner": [
        "crachiner"
    ],
    "crachins": [
        "crachin"
    ],
    "crachoir": [
        "crachoir"
    ],
    "crachoirs": [
        "crachoir"
    ],
    "crachons": [
        "cracher"
    ],
    "crachota": [
        "crachoter"
    ],
    "crachotaient": [
        "crachoter"
    ],
    "crachotait": [
        "crachoter"
    ],
    "crachotant": [
        "crachoter",
        "crachotant"
    ],
    "crachotantes": [
        "crachotant"
    ],
    "crachotants": [
        "crachotant"
    ],
    "crachote": [
        "crachoter"
    ],
    "crachotement": [
        "crachotement"
    ],
    "crachotements": [
        "crachotement"
    ],
    "crachotent": [
        "crachoter"
    ],
    "crachoter": [
        "crachoter"
    ],
    "crachoteuse": [
        "crachoteux"
    ],
    "crachoteux": [
        "crachoteux"
    ],
    "crachouilla": [
        "crachouiller"
    ],
    "crachouille": [
        "crachouiller"
    ],
    "crachouillis": [
        "crachouillis"
    ],
    "cracherent": [
        "cracher"
    ],
    "crachee": [
        "cracher",
        "crache"
    ],
    "crachees": [
        "cracher"
    ],
    "crack": [
        "crack"
    ],
    "cracker": [
        "cracker"
    ],
    "crackers": [
        "cracker"
    ],
    "cracking": [
        "cracking",
        "crack"
    ],
    "cracks": [
        "crack"
    ],
    "cracra": [
        "cracra"
    ],
    "crade": [
        "crade"
    ],
    "crades": [
        "crade"
    ],
    "cradingue": [
        "cradingue"
    ],
    "cradingues": [
        "cradingue"
    ],
    "crado": [
        "crado"
    ],
    "cradoque": [
        "cradoque"
    ],
    "crados": [
        "crado"
    ],
    "craie": [
        "craie"
    ],
    "craies": [
        "craie"
    ],
    "craignaient": [
        "craindre"
    ],
    "craignais": [
        "craindre"
    ],
    "craignait": [
        "craindre"
    ],
    "craignant": [
        "craindre"
    ],
    "craigne": [
        "craindre"
    ],
    "craignent": [
        "craindre"
    ],
    "craignes": [
        "craindre"
    ],
    "craignez": [
        "craindre"
    ],
    "craigniez": [
        "craindre"
    ],
    "craignions": [
        "craindre"
    ],
    "craignirent": [
        "craindre"
    ],
    "craignis": [
        "craindre"
    ],
    "craignissent": [
        "craindre"
    ],
    "craignit": [
        "craindre"
    ],
    "craignons": [
        "craindre"
    ],
    "craignos": [
        "craignos"
    ],
    "craillaient": [
        "crailler"
    ],
    "craillent": [
        "crailler"
    ],
    "craindra": [
        "craindre"
    ],
    "craindrai": [
        "craindre"
    ],
    "craindraient": [
        "craindre"
    ],
    "craindrais": [
        "craindre"
    ],
    "craindrait": [
        "craindre"
    ],
    "craindras": [
        "craindre"
    ],
    "craindre": [
        "craindre"
    ],
    "craindriez": [
        "craindre"
    ],
    "craindrons": [
        "craindre"
    ],
    "craindront": [
        "craindre"
    ],
    "crains": [
        "craindre"
    ],
    "craint": [
        "craindre"
    ],
    "crainte": [
        "craindre",
        "crainte"
    ],
    "craintes": [
        "craindre",
        "crainte"
    ],
    "craintif": [
        "craintif"
    ],
    "craintifs": [
        "craintif"
    ],
    "craintive": [
        "craintif"
    ],
    "craintivement": [
        "craintivement"
    ],
    "craintives": [
        "craintif"
    ],
    "craints": [
        "craindre"
    ],
    "crama": [
        "cramer"
    ],
    "cramaient": [
        "cramer"
    ],
    "cramait": [
        "cramer"
    ],
    "cramant": [
        "cramer"
    ],
    "crame": [
        "cramer"
    ],
    "crament": [
        "cramer"
    ],
    "cramer": [
        "cramer"
    ],
    "crameraient": [
        "cramer"
    ],
    "cramerais": [
        "cramer"
    ],
    "crameras": [
        "cramer"
    ],
    "cramez": [
        "cramer"
    ],
    "cramoisi": [
        "cramoisi",
        "cramoisir"
    ],
    "cramoisie": [
        "cramoisi",
        "cramoisir"
    ],
    "cramoisies": [
        "cramoisi"
    ],
    "cramoisis": [
        "cramoisi",
        "cramoisir"
    ],
    "cramouille": [
        "cramouille"
    ],
    "cramouilles": [
        "cramouille"
    ],
    "crampe": [
        "crampe"
    ],
    "crampes": [
        "crampe"
    ],
    "crampette": [
        "crampette"
    ],
    "crampettes": [
        "crampette"
    ],
    "crampon": [
        "crampon"
    ],
    "cramponna": [
        "cramponner"
    ],
    "cramponnaient": [
        "cramponner"
    ],
    "cramponnais": [
        "cramponner"
    ],
    "cramponnait": [
        "cramponner"
    ],
    "cramponnant": [
        "cramponner"
    ],
    "cramponne": [
        "cramponner"
    ],
    "cramponnent": [
        "cramponner"
    ],
    "cramponner": [
        "cramponner"
    ],
    "cramponneront": [
        "cramponner"
    ],
    "cramponnez": [
        "cramponner"
    ],
    "cramponniez": [
        "cramponner"
    ],
    "cramponnons": [
        "cramponner"
    ],
    "cramponnee": [
        "cramponner"
    ],
    "cramponnees": [
        "cramponner"
    ],
    "cramponnes": [
        "cramponner"
    ],
    "crampons": [
        "crampon"
    ],
    "cramee": [
        "cramer"
    ],
    "cramees": [
        "cramer"
    ],
    "crames": [
        "cramer"
    ],
    "cran": [
        "cran"
    ],
    "crane": [
        "crane",
        "craner"
    ],
    "craniometrie": [
        "craniometrie"
    ],
    "craniotomie": [
        "craniotomie"
    ],
    "crans": [
        "cran"
    ],
    "cranter": [
        "cranter"
    ],
    "crante": [
        "cranter"
    ],
    "crantees": [
        "cranter"
    ],
    "crantes": [
        "cranter"
    ],
    "craonnais": [
        "craonnais"
    ],
    "craonnaise": [
        "craonnais"
    ],
    "craonnaises": [
        "craonnais"
    ],
    "crapahutait": [
        "crapahuter"
    ],
    "crapahutant": [
        "crapahuter"
    ],
    "crapahute": [
        "crapahuter"
    ],
    "crapahuter": [
        "crapahuter"
    ],
    "crapahutons": [
        "crapahuter"
    ],
    "crapaud": [
        "crapaud"
    ],
    "crapauds": [
        "crapaud"
    ],
    "crapoter": [
        "crapoter"
    ],
    "crapoteuse": [
        "crapoteux"
    ],
    "crapoteuses": [
        "crapoteux"
    ],
    "crapoteux": [
        "crapoteux"
    ],
    "crapouillot": [
        "crapouillot"
    ],
    "crapouillots": [
        "crapouillot"
    ],
    "craps": [
        "craps",
        "crap"
    ],
    "crapule": [
        "crapule"
    ],
    "crapulerie": [
        "crapulerie"
    ],
    "crapules": [
        "crapule"
    ],
    "crapuleuse": [
        "crapuleux"
    ],
    "crapuleusement": [
        "crapuleusement"
    ],
    "crapuleuses": [
        "crapuleux"
    ],
    "crapuleux": [
        "crapuleux"
    ],
    "craqua": [
        "craquer"
    ],
    "craquage": [
        "craquage"
    ],
    "craquaient": [
        "craquer"
    ],
    "craquais": [
        "craquer"
    ],
    "craquait": [
        "craquer"
    ],
    "craquant": [
        "craquer",
        "craquant"
    ],
    "craquante": [
        "craquant"
    ],
    "craquantes": [
        "craquant"
    ],
    "craquants": [
        "craquant"
    ],
    "craque": [
        "craque",
        "craquer"
    ],
    "craquela": [
        "craqueler"
    ],
    "craquelaient": [
        "craqueler"
    ],
    "craquelait": [
        "craqueler"
    ],
    "craquelant": [
        "craqueler"
    ],
    "craqueler": [
        "craqueler"
    ],
    "craquelin": [
        "craquelin"
    ],
    "craquelins": [
        "craquelin"
    ],
    "craquelle": [
        "craqueler"
    ],
    "craquellent": [
        "craqueler"
    ],
    "craquelure": [
        "craquelure"
    ],
    "craquelures": [
        "craquelure"
    ],
    "craquelerent": [
        "craqueler"
    ],
    "craquele": [
        "craqueler",
        "craquele"
    ],
    "craquelee": [
        "craqueler",
        "craquele"
    ],
    "craquelees": [
        "craqueler",
        "craquele"
    ],
    "craqueles": [
        "craquele"
    ],
    "craquement": [
        "craquement"
    ],
    "craquements": [
        "craquement"
    ],
    "craquent": [
        "craquer"
    ],
    "craquer": [
        "craquer"
    ],
    "craquera": [
        "craquer"
    ],
    "craqueraient": [
        "craquer"
    ],
    "craquerait": [
        "craquer"
    ],
    "craqueras": [
        "craquer"
    ],
    "craqueront": [
        "craquer"
    ],
    "craques": [
        "craque",
        "craquer"
    ],
    "craquette": [
        "craqueter"
    ],
    "craquez": [
        "craquer"
    ],
    "craquiez": [
        "craquer"
    ],
    "craquelement": [
        "craquelement"
    ],
    "craquerent": [
        "craquer"
    ],
    "craquee": [
        "craquee",
        "craquer"
    ],
    "craquees": [
        "craquer"
    ],
    "crase": [
        "crase"
    ],
    "crash": [
        "crash"
    ],
    "crashe": [
        "crasher"
    ],
    "crasher": [
        "crasher"
    ],
    "crashes": [
        "crash",
        "crashe"
    ],
    "crashee": [
        "crasher"
    ],
    "craspec": [
        "craspec"
    ],
    "crasse": [
        "crasse"
    ],
    "crasses": [
        "crasse"
    ],
    "crasseuse": [
        "crasseux"
    ],
    "crasseuses": [
        "crasseux"
    ],
    "crasseux": [
        "crasseux"
    ],
    "crassier": [
        "crassier"
    ],
    "crassiers": [
        "crassier"
    ],
    "crassula": [
        "crassula"
    ],
    "crataegus": [
        "crataegus"
    ],
    "cratere": [
        "cratere"
    ],
    "crateres": [
        "cratere"
    ],
    "cravachais": [
        "cravacher"
    ],
    "cravachait": [
        "cravacher"
    ],
    "cravachant": [
        "cravacher"
    ],
    "cravache": [
        "cravacher",
        "cravache"
    ],
    "cravacher": [
        "cravacher"
    ],
    "cravaches": [
        "cravache"
    ],
    "cravachees": [
        "cravacher"
    ],
    "cravant": [
        "cravant"
    ],
    "cravants": [
        "cravant"
    ],
    "cravatage": [
        "cravatage"
    ],
    "cravatait": [
        "cravater"
    ],
    "cravate": [
        "cravate",
        "cravater"
    ],
    "cravater": [
        "cravater"
    ],
    "cravates": [
        "cravate",
        "cravater"
    ],
    "cravateur": [
        "cravateur"
    ],
    "cravatiere": [
        "cravatier"
    ],
    "cravatee": [
        "cravater"
    ],
    "cravatees": [
        "cravater"
    ],
    "crawl": [
        "crawl"
    ],
    "crawlait": [
        "crawler"
    ],
    "crawlant": [
        "crawler"
    ],
    "crawle": [
        "crawle"
    ],
    "crayeuse": [
        "crayeux"
    ],
    "crayeuses": [
        "crayeux"
    ],
    "crayeux": [
        "crayeux"
    ],
    "crayon": [
        "crayon"
    ],
    "crayonna": [
        "crayonner"
    ],
    "crayonnage": [
        "crayonnage"
    ],
    "crayonnages": [
        "crayonnage"
    ],
    "crayonnait": [
        "crayonner"
    ],
    "crayonnant": [
        "crayonner"
    ],
    "crayonne": [
        "crayonner"
    ],
    "crayonner": [
        "crayonner"
    ],
    "crayonneur": [
        "crayonneur"
    ],
    "crayonneurs": [
        "crayonneur"
    ],
    "crayonnez": [
        "crayonner"
    ],
    "crayonnees": [
        "crayonner"
    ],
    "crayonnes": [
        "crayonner",
        "crayonne"
    ],
    "crayons": [
        "crayon"
    ],
    "credo": [
        "credo"
    ],
    "creek": [
        "creek"
    ],
    "creeks": [
        "creek"
    ],
    "crematorium": [
        "crematorium"
    ],
    "crescendo": [
        "crescendo"
    ],
    "cresson": [
        "cresson"
    ],
    "cressonnette": [
        "cressonnette"
    ],
    "cressonniere": [
        "cressonniere"
    ],
    "cressonnieres": [
        "cressonniere"
    ],
    "cressons": [
        "cresson"
    ],
    "creton": [
        "creton"
    ],
    "cretonne": [
        "creton"
    ],
    "cretonnes": [
        "creton"
    ],
    "cretons": [
        "creton"
    ],
    "creusa": [
        "creuser"
    ],
    "creusai": [
        "creuser"
    ],
    "creusaient": [
        "creuser"
    ],
    "creusais": [
        "creuser"
    ],
    "creusait": [
        "creuser"
    ],
    "creusant": [
        "creuser"
    ],
    "creusas": [
        "creuser"
    ],
    "creusassent": [
        "creuser"
    ],
    "creuse": [
        "creux",
        "creuser"
    ],
    "creusement": [
        "creusement"
    ],
    "creusements": [
        "creusement"
    ],
    "creusent": [
        "creuser"
    ],
    "creuser": [
        "creuser"
    ],
    "creusera": [
        "creuser"
    ],
    "creuserai": [
        "creuser"
    ],
    "creuseraient": [
        "creuser"
    ],
    "creuserais": [
        "creuser"
    ],
    "creuserait": [
        "creuser"
    ],
    "creuseras": [
        "creuser"
    ],
    "creuserez": [
        "creuser"
    ],
    "creuserons": [
        "creuser"
    ],
    "creuseront": [
        "creuser"
    ],
    "creuses": [
        "creux",
        "creuser"
    ],
    "creuset": [
        "creuset"
    ],
    "creusets": [
        "creuset"
    ],
    "creuseur": [
        "creuseur"
    ],
    "creusez": [
        "creuser"
    ],
    "creusiez": [
        "creuser"
    ],
    "creusions": [
        "creuser"
    ],
    "creusons": [
        "creuser"
    ],
    "creuserent": [
        "creuser"
    ],
    "creusee": [
        "creuser"
    ],
    "creusees": [
        "creuser"
    ],
    "creux": [
        "creux"
    ],
    "creva": [
        "crever"
    ],
    "crevage": [
        "crevage"
    ],
    "crevaient": [
        "crever"
    ],
    "crevais": [
        "crever"
    ],
    "crevaison": [
        "crevaison"
    ],
    "crevaisons": [
        "crevaison"
    ],
    "crevait": [
        "crever"
    ],
    "crevant": [
        "crevant",
        "crever"
    ],
    "crevante": [
        "crevant"
    ],
    "crevants": [
        "crevant"
    ],
    "crevard": [
        "crevard"
    ],
    "crevarde": [
        "crevard"
    ],
    "crevards": [
        "crevard"
    ],
    "crevasse": [
        "crevasse",
        "crevasser"
    ],
    "crevassent": [
        "crevasser"
    ],
    "crevasser": [
        "crevasser"
    ],
    "crevasses": [
        "crevasse",
        "crevasser"
    ],
    "crevassee": [
        "crevasser"
    ],
    "crevassees": [
        "crevasser"
    ],
    "crever": [
        "crever"
    ],
    "crevette": [
        "crevette"
    ],
    "crevettes": [
        "crevette"
    ],
    "crevettier": [
        "crevettier"
    ],
    "crevettiers": [
        "crevettier"
    ],
    "crevez": [
        "crever"
    ],
    "creviez": [
        "crever"
    ],
    "crevions": [
        "crever"
    ],
    "crevons": [
        "crever"
    ],
    "crevotant": [
        "crevoter"
    ],
    "crevure": [
        "crevure"
    ],
    "crevures": [
        "crevure"
    ],
    "crevat": [
        "crever"
    ],
    "creverent": [
        "crever"
    ],
    "creve": [
        "creve",
        "crever"
    ],
    "crevee": [
        "crever"
    ],
    "crevees": [
        "crever"
    ],
    "creves": [
        "creve",
        "crever"
    ],
    "cri": [
        "cri"
    ],
    "cria": [
        "crier"
    ],
    "criai": [
        "crier"
    ],
    "criaient": [
        "crier"
    ],
    "criaillaient": [
        "criailler"
    ],
    "criaillait": [
        "criailler"
    ],
    "criaillant": [
        "criailler"
    ],
    "criaillement": [
        "criaillement"
    ],
    "criaillent": [
        "criailler"
    ],
    "criailler": [
        "criailler"
    ],
    "criaillerie": [
        "criaillerie"
    ],
    "criailleries": [
        "criaillerie"
    ],
    "criais": [
        "crier"
    ],
    "criait": [
        "crier"
    ],
    "criant": [
        "crier",
        "criant"
    ],
    "criante": [
        "criant"
    ],
    "criantes": [
        "criant"
    ],
    "criard": [
        "criard"
    ],
    "criarde": [
        "criard"
    ],
    "criardes": [
        "criard"
    ],
    "criards": [
        "criard"
    ],
    "crib": [
        "crib"
    ],
    "cribla": [
        "cribler"
    ],
    "criblage": [
        "criblage"
    ],
    "criblaient": [
        "cribler"
    ],
    "criblait": [
        "cribler"
    ],
    "criblant": [
        "cribler"
    ],
    "crible": [
        "cribler",
        "crible"
    ],
    "criblent": [
        "cribler"
    ],
    "cribler": [
        "cribler"
    ],
    "cribles": [
        "cribler",
        "crible"
    ],
    "criblee": [
        "cribler"
    ],
    "criblees": [
        "cribler"
    ],
    "cric": [
        "cric"
    ],
    "cricket": [
        "cricket"
    ],
    "crickets": [
        "cricket"
    ],
    "cricoide": [
        "cricoide"
    ],
    "cricri": [
        "cricri"
    ],
    "cricris": [
        "cricri"
    ],
    "crics": [
        "cric"
    ],
    "crie": [
        "crier"
    ],
    "crient": [
        "crier"
    ],
    "crier": [
        "crier"
    ],
    "criera": [
        "crier"
    ],
    "crierai": [
        "crier"
    ],
    "crieraient": [
        "crier"
    ],
    "crierais": [
        "crier"
    ],
    "crierait": [
        "crier"
    ],
    "crieras": [
        "crier"
    ],
    "crieront": [
        "crier"
    ],
    "cries": [
        "crier",
        "cry"
    ],
    "crieur": [
        "crieur"
    ],
    "crieurs": [
        "crieur"
    ],
    "crieuse": [
        "crieur"
    ],
    "criez": [
        "crier"
    ],
    "criions": [
        "crier"
    ],
    "crime": [
        "crime"
    ],
    "crimes": [
        "crime"
    ],
    "criminaliser": [
        "criminaliser"
    ],
    "criminaliste": [
        "criminaliste"
    ],
    "criminalistique": [
        "criminalistique"
    ],
    "criminalite": [
        "criminalite"
    ],
    "criminel": [
        "criminel"
    ],
    "criminelle": [
        "criminel"
    ],
    "criminellement": [
        "criminellement"
    ],
    "criminelles": [
        "criminel"
    ],
    "criminels": [
        "criminel"
    ],
    "criminologie": [
        "criminologie"
    ],
    "criminologiste": [
        "criminologiste"
    ],
    "criminologue": [
        "criminologue"
    ],
    "criminologues": [
        "criminologue"
    ],
    "crin": [
        "crin"
    ],
    "crincrin": [
        "crincrin"
    ],
    "crincrins": [
        "crincrin"
    ],
    "criniere": [
        "criniere"
    ],
    "crinieres": [
        "criniere"
    ],
    "crinoline": [
        "crinoline"
    ],
    "crinolines": [
        "crinoline"
    ],
    "crins": [
        "crin"
    ],
    "crions": [
        "crier"
    ],
    "crique": [
        "crique"
    ],
    "criques": [
        "crique"
    ],
    "criquet": [
        "criquet"
    ],
    "criquets": [
        "criquet"
    ],
    "cris": [
        "cri"
    ],
    "crise": [
        "crise"
    ],
    "crises": [
        "crisis",
        "crise"
    ],
    "crispa": [
        "crisper"
    ],
    "crispai": [
        "crisper"
    ],
    "crispaient": [
        "crisper"
    ],
    "crispait": [
        "crisper"
    ],
    "crispant": [
        "crisper",
        "crispant"
    ],
    "crispante": [
        "crispant"
    ],
    "crispantes": [
        "crispant"
    ],
    "crispation": [
        "crispation"
    ],
    "crispations": [
        "crispation"
    ],
    "crispe": [
        "crisper"
    ],
    "crispent": [
        "crisper"
    ],
    "crisper": [
        "crisper",
        "crisp"
    ],
    "crispes": [
        "crisper"
    ],
    "crispin": [
        "crispin"
    ],
    "crisperent": [
        "crisper"
    ],
    "crispee": [
        "crisper"
    ],
    "crispees": [
        "crisper"
    ],
    "crissa": [
        "crisser"
    ],
    "crissaient": [
        "crisser"
    ],
    "crissait": [
        "crisser"
    ],
    "crissant": [
        "crisser"
    ],
    "crisse": [
        "crisser"
    ],
    "crissement": [
        "crissement"
    ],
    "crissements": [
        "crissement"
    ],
    "crissent": [
        "crisser"
    ],
    "crisser": [
        "crisser"
    ],
    "crisserent": [
        "crisser"
    ],
    "cristal": [
        "cristal"
    ],
    "cristallerie": [
        "cristallerie"
    ],
    "cristalleries": [
        "cristallerie"
    ],
    "cristallin": [
        "cristallin"
    ],
    "cristalline": [
        "cristallin"
    ],
    "cristallines": [
        "cristallin"
    ],
    "cristallins": [
        "cristallin"
    ],
    "cristallisaient": [
        "cristalliser"
    ],
    "cristallisait": [
        "cristalliser"
    ],
    "cristallisation": [
        "cristallisation"
    ],
    "cristallise": [
        "cristalliser",
        "cristallise"
    ],
    "cristallisent": [
        "cristalliser"
    ],
    "cristalliser": [
        "cristalliser"
    ],
    "cristallisera": [
        "cristalliser"
    ],
    "cristalliserent": [
        "cristalliser"
    ],
    "cristallisee": [
        "cristalliser",
        "cristallise"
    ],
    "cristallisees": [
        "cristallise"
    ],
    "cristallises": [
        "cristalliser"
    ],
    "cristallographie": [
        "cristallographie"
    ],
    "cristallomancie": [
        "cristallomancie"
    ],
    "cristalloide": [
        "cristalloide"
    ],
    "cristaux": [
        "cristal"
    ],
    "cristi": [
        "cristi"
    ],
    "criticaillent": [
        "criticailler"
    ],
    "critiqua": [
        "critiquer"
    ],
    "critiquable": [
        "critiquable"
    ],
    "critiquables": [
        "critiquable"
    ],
    "critiquaient": [
        "critiquer"
    ],
    "critiquais": [
        "critiquer"
    ],
    "critiquait": [
        "critiquer"
    ],
    "critiquant": [
        "critiquer"
    ],
    "critique": [
        "critiquer",
        "critique"
    ],
    "critiquent": [
        "critiquer"
    ],
    "critiquer": [
        "critiquer"
    ],
    "critiquera": [
        "critiquer"
    ],
    "critiquerais": [
        "critiquer"
    ],
    "critiquerait": [
        "critiquer"
    ],
    "critiqueras": [
        "critiquer"
    ],
    "critiques": [
        "critiquer",
        "critique"
    ],
    "critiquez": [
        "critiquer"
    ],
    "critiquiez": [
        "critiquer"
    ],
    "critiquons": [
        "critiquer"
    ],
    "critiquat": [
        "critiquer"
    ],
    "critiquee": [
        "critiquer"
    ],
    "critiquees": [
        "critiquer"
    ],
    "critere": [
        "critere"
    ],
    "criteres": [
        "critere"
    ],
    "criterium": [
        "criterium"
    ],
    "criteriums": [
        "criterium"
    ],
    "criat": [
        "crier"
    ],
    "crierent": [
        "crier"
    ],
    "criee": [
        "crier",
        "criee"
    ],
    "criees": [
        "crier",
        "criee"
    ],
    "croassa": [
        "croasser"
    ],
    "croassaient": [
        "croasser"
    ],
    "croassait": [
        "croasser"
    ],
    "croassant": [
        "croassant"
    ],
    "croasse": [
        "croasser"
    ],
    "croassement": [
        "croassement"
    ],
    "croassements": [
        "croassement"
    ],
    "croassent": [
        "croasser"
    ],
    "croasser": [
        "croasser"
    ],
    "croate": [
        "croate"
    ],
    "croates": [
        "croate"
    ],
    "crobard": [
        "crobard"
    ],
    "croc": [
        "croc"
    ],
    "crocha": [
        "crocher"
    ],
    "crochaient": [
        "crocher"
    ],
    "crochait": [
        "crocher"
    ],
    "croche": [
        "croche",
        "crocher"
    ],
    "crochent": [
        "crocher"
    ],
    "crocher": [
        "crocher"
    ],
    "croches": [
        "croche"
    ],
    "crochet": [
        "crochet"
    ],
    "crocheta": [
        "crocheter"
    ],
    "crochetage": [
        "crochetage"
    ],
    "crochetaient": [
        "crocheter"
    ],
    "crochetait": [
        "crocheter"
    ],
    "crochetant": [
        "crocheter"
    ],
    "crocheter": [
        "crocheter"
    ],
    "crocheteur": [
        "crocheteur"
    ],
    "crocheteurs": [
        "crocheteur"
    ],
    "crochets": [
        "crochet"
    ],
    "crochete": [
        "crocheter"
    ],
    "crochetees": [
        "crocheter"
    ],
    "crochetes": [
        "crocheter"
    ],
    "crochu": [
        "crochu"
    ],
    "crochue": [
        "crochu"
    ],
    "crochues": [
        "crochu"
    ],
    "crochus": [
        "crochu"
    ],
    "crochetent": [
        "crocheter"
    ],
    "crochees": [
        "crocher"
    ],
    "croco": [
        "croco"
    ],
    "crocodile": [
        "crocodile"
    ],
    "crocodiles": [
        "crocodile"
    ],
    "crocos": [
        "croco"
    ],
    "crocs": [
        "croc"
    ],
    "crocus": [
        "crocus"
    ],
    "croie": [
        "croire"
    ],
    "croient": [
        "croire"
    ],
    "croies": [
        "croire"
    ],
    "croira": [
        "croire"
    ],
    "croirai": [
        "croire"
    ],
    "croiraient": [
        "croire"
    ],
    "croirais": [
        "croire"
    ],
    "croirait": [
        "croire"
    ],
    "croiras": [
        "croire"
    ],
    "croire": [
        "croire"
    ],
    "croirez": [
        "croire"
    ],
    "croiriez": [
        "croire"
    ],
    "croirions": [
        "croire"
    ],
    "croirons": [
        "croire"
    ],
    "croiront": [
        "croire"
    ],
    "crois": [
        "croire",
        "croitre"
    ],
    "croisa": [
        "croiser"
    ],
    "croisade": [
        "croisade"
    ],
    "croisades": [
        "croisade"
    ],
    "croisai": [
        "croiser"
    ],
    "croisaient": [
        "croiser"
    ],
    "croisais": [
        "croiser"
    ],
    "croisait": [
        "croiser"
    ],
    "croisant": [
        "croiser"
    ],
    "croise": [
        "croiser",
        "croise"
    ],
    "croisement": [
        "croisement"
    ],
    "croisements": [
        "croisement"
    ],
    "croisent": [
        "croiser"
    ],
    "croiser": [
        "croiser"
    ],
    "croisera": [
        "croiser"
    ],
    "croiserai": [
        "croiser"
    ],
    "croiseraient": [
        "croiser"
    ],
    "croiserais": [
        "croiser"
    ],
    "croiserait": [
        "croiser"
    ],
    "croiserez": [
        "croiser"
    ],
    "croiserons": [
        "croiser"
    ],
    "croiseront": [
        "croiser"
    ],
    "croises": [
        "croiser",
        "croise"
    ],
    "croisette": [
        "croisette"
    ],
    "croiseur": [
        "croiseur"
    ],
    "croiseurs": [
        "croiseur"
    ],
    "croisez": [
        "croiser"
    ],
    "croisillon": [
        "croisillon"
    ],
    "croisillons": [
        "croisillon"
    ],
    "croisions": [
        "croiser"
    ],
    "croisiere": [
        "croisiere"
    ],
    "croisieres": [
        "croisiere"
    ],
    "croisons": [
        "croiser"
    ],
    "croissaient": [
        "croitre"
    ],
    "croissais": [
        "croitre"
    ],
    "croissait": [
        "croitre"
    ],
    "croissance": [
        "croissance"
    ],
    "croissances": [
        "croissance"
    ],
    "croissant": [
        "croissant",
        "croitre"
    ],
    "croissante": [
        "croissant"
    ],
    "croissantes": [
        "croissant"
    ],
    "croissants": [
        "croissant"
    ],
    "croisse": [
        "croitre"
    ],
    "croissent": [
        "croitre"
    ],
    "croissez": [
        "croitre"
    ],
    "croisames": [
        "croiser"
    ],
    "croisat": [
        "croiser"
    ],
    "croiserent": [
        "croiser"
    ],
    "croisee": [
        "croisee",
        "croiser",
        "croise"
    ],
    "croisees": [
        "croisee",
        "croiser",
        "croise"
    ],
    "croit": [
        "croit",
        "croire",
        "croitre"
    ],
    "croix": [
        "croix"
    ],
    "cromlech": [
        "cromlech"
    ],
    "cromlechs": [
        "cromlech"
    ],
    "cromorne": [
        "cromorne"
    ],
    "cronstadt": [
        "cronstadt"
    ],
    "crooner": [
        "crooner"
    ],
    "crooners": [
        "crooner"
    ],
    "croqua": [
        "croquer"
    ],
    "croquai": [
        "croquer"
    ],
    "croquaient": [
        "croquer"
    ],
    "croquais": [
        "croquer"
    ],
    "croquait": [
        "croquer"
    ],
    "croquant": [
        "croquant",
        "croquer"
    ],
    "croquante": [
        "croquant"
    ],
    "croquantes": [
        "croquant"
    ],
    "croquants": [
        "croquant"
    ],
    "croque": [
        "croquer"
    ],
    "croquemitaine": [
        "croquemitaine"
    ],
    "croquemitaines": [
        "croquemitaine"
    ],
    "croquemort": [
        "croquemort"
    ],
    "croquemorts": [
        "croquemort"
    ],
    "croquenots": [
        "croquenot"
    ],
    "croquent": [
        "croquer"
    ],
    "croquer": [
        "croquer"
    ],
    "croquera": [
        "croquer"
    ],
    "croquerai": [
        "croquer"
    ],
    "croqueraient": [
        "croquer"
    ],
    "croquerais": [
        "croquer"
    ],
    "croquerait": [
        "croquer"
    ],
    "croquerons": [
        "croquer"
    ],
    "croques": [
        "croquer"
    ],
    "croquet": [
        "croquet"
    ],
    "croqueton": [
        "croqueton"
    ],
    "croquetons": [
        "croqueton"
    ],
    "croquette": [
        "croquette"
    ],
    "croquettes": [
        "croquette"
    ],
    "croqueur": [
        "croqueur"
    ],
    "croqueuse": [
        "croqueur"
    ],
    "croquez": [
        "croquer"
    ],
    "croquignol": [
        "croquignol"
    ],
    "croquignolet": [
        "croquignolet"
    ],
    "croquignolets": [
        "croquignolet"
    ],
    "croquis": [
        "croquis"
    ],
    "croquons": [
        "croquer"
    ],
    "croquerent": [
        "croquer"
    ],
    "croquee": [
        "croquer"
    ],
    "croquees": [
        "croquer"
    ],
    "crosne": [
        "crosne"
    ],
    "crosnes": [
        "crosne"
    ],
    "cross": [
        "cross"
    ],
    "crosse": [
        "crosse"
    ],
    "crosser": [
        "crosser",
        "cross"
    ],
    "crosses": [
        "crosse",
        "cross"
    ],
    "crossman": [
        "crossman"
    ],
    "crotale": [
        "crotale"
    ],
    "crotales": [
        "crotale"
    ],
    "croton": [
        "croton"
    ],
    "crottait": [
        "crotter"
    ],
    "crotte": [
        "crotte",
        "crotter"
    ],
    "crotter": [
        "crotter"
    ],
    "crottes": [
        "crotte",
        "crotter"
    ],
    "crottin": [
        "crottin"
    ],
    "crottins": [
        "crottin"
    ],
    "crottee": [
        "crotte",
        "crotter"
    ],
    "crottees": [
        "crotte",
        "crotter"
    ],
    "crouillat": [
        "crouillat"
    ],
    "crouillats": [
        "crouillat"
    ],
    "crouille": [
        "crouille"
    ],
    "croula": [
        "crouler"
    ],
    "croulaient": [
        "crouler"
    ],
    "croulait": [
        "crouler"
    ],
    "croulant": [
        "croulant",
        "crouler"
    ],
    "croulante": [
        "croulant"
    ],
    "croulantes": [
        "croulant"
    ],
    "croulants": [
        "croulant"
    ],
    "croule": [
        "crouler",
        "croule"
    ],
    "croulement": [
        "croulement"
    ],
    "croulent": [
        "crouler"
    ],
    "crouler": [
        "crouler"
    ],
    "croulera": [
        "crouler"
    ],
    "croulerai": [
        "crouler"
    ],
    "crouleraient": [
        "crouler"
    ],
    "croulerait": [
        "crouler"
    ],
    "crouleras": [
        "crouler"
    ],
    "croulerons": [
        "crouler"
    ],
    "crouleront": [
        "crouler"
    ],
    "croulons": [
        "crouler"
    ],
    "croulat": [
        "crouler"
    ],
    "croulerent": [
        "crouler"
    ],
    "croulee": [
        "crouler"
    ],
    "croules": [
        "crouler"
    ],
    "croup": [
        "croup"
    ],
    "croupade": [
        "croupade"
    ],
    "croupe": [
        "croupe"
    ],
    "croupes": [
        "croupe"
    ],
    "croupi": [
        "croupi",
        "croupir"
    ],
    "croupie": [
        "croupi",
        "croupir"
    ],
    "croupier": [
        "croupier"
    ],
    "croupiers": [
        "croupier"
    ],
    "croupies": [
        "croupi",
        "croupir"
    ],
    "croupion": [
        "croupion"
    ],
    "croupionne": [
        "croupionner"
    ],
    "croupions": [
        "croupion"
    ],
    "croupir": [
        "croupir"
    ],
    "croupira": [
        "croupir"
    ],
    "croupis": [
        "croupir"
    ],
    "croupissaient": [
        "croupir"
    ],
    "croupissais": [
        "croupir"
    ],
    "croupissait": [
        "croupir"
    ],
    "croupissant": [
        "croupissant",
        "croupir"
    ],
    "croupissante": [
        "croupissant"
    ],
    "croupissantes": [
        "croupissant"
    ],
    "croupissent": [
        "croupir"
    ],
    "croupissez": [
        "croupir"
    ],
    "croupissoir": [
        "croupissoir"
    ],
    "croupissure": [
        "croupissure"
    ],
    "croupit": [
        "croupir"
    ],
    "croupiere": [
        "croupiere"
    ],
    "croupieres": [
        "croupiere"
    ],
    "croupon": [
        "croupon"
    ],
    "croustade": [
        "croustade"
    ],
    "croustades": [
        "croustade"
    ],
    "croustillaient": [
        "croustiller"
    ],
    "croustillait": [
        "croustiller"
    ],
    "croustillance": [
        "croustillance"
    ],
    "croustillant": [
        "croustillant",
        "croustiller"
    ],
    "croustillante": [
        "croustillant"
    ],
    "croustillantes": [
        "croustillant"
    ],
    "croustillants": [
        "croustillant"
    ],
    "croustille": [
        "croustille",
        "croustiller"
    ],
    "croustillent": [
        "croustiller"
    ],
    "croustilles": [
        "croustille"
    ],
    "croustillon": [
        "croustillon"
    ],
    "croustillons": [
        "croustillon"
    ],
    "crown": [
        "crown"
    ],
    "croyable": [
        "croyable"
    ],
    "croyables": [
        "croyable"
    ],
    "croyaient": [
        "croire"
    ],
    "croyais": [
        "croire"
    ],
    "croyait": [
        "croire"
    ],
    "croyance": [
        "croyance"
    ],
    "croyances": [
        "croyance"
    ],
    "croyant": [
        "croire",
        "croyant"
    ],
    "croyante": [
        "croyant"
    ],
    "croyantes": [
        "croyant"
    ],
    "croyants": [
        "croyant"
    ],
    "croyez": [
        "croire"
    ],
    "croyiez": [
        "croire"
    ],
    "croyions": [
        "croire"
    ],
    "croyons": [
        "croire"
    ],
    "croitraient": [
        "croitre"
    ],
    "croitrait": [
        "croitre"
    ],
    "croitre": [
        "croitre"
    ],
    "croute": [
        "crouter",
        "croute"
    ],
    "crouter": [
        "crouter"
    ],
    "croutes": [
        "crouter",
        "croute"
    ],
    "crouteuse": [
        "crouteux"
    ],
    "crouteuses": [
        "crouteux"
    ],
    "crouteux": [
        "crouteux"
    ],
    "crouton": [
        "crouton"
    ],
    "croutonnais": [
        "croutonner"
    ],
    "croutons": [
        "crouton"
    ],
    "croutee": [
        "crouter"
    ],
    "croutees": [
        "crouter"
    ],
    "cru": [
        "cru",
        "croire",
        "croitre"
    ],
    "cruaute": [
        "cruaute"
    ],
    "cruautes": [
        "cruaute"
    ],
    "cruche": [
        "cruche"
    ],
    "cruches": [
        "cruche"
    ],
    "cruchon": [
        "cruchon"
    ],
    "cruchons": [
        "cruchon"
    ],
    "crucial": [
        "crucial"
    ],
    "cruciale": [
        "crucial"
    ],
    "crucialement": [
        "crucialement"
    ],
    "cruciales": [
        "crucial"
    ],
    "cruciaux": [
        "crucial"
    ],
    "crucifia": [
        "crucifier"
    ],
    "crucifiaient": [
        "crucifier"
    ],
    "crucifiait": [
        "crucifier"
    ],
    "crucifiant": [
        "crucifiant"
    ],
    "crucifiante": [
        "crucifiant"
    ],
    "crucifie": [
        "crucifie",
        "crucifier"
    ],
    "crucifiement": [
        "crucifiement"
    ],
    "crucifient": [
        "crucifier"
    ],
    "crucifier": [
        "crucifier"
    ],
    "crucifierez": [
        "crucifier"
    ],
    "crucifieront": [
        "crucifier"
    ],
    "crucifiez": [
        "crucifier"
    ],
    "crucifix": [
        "crucifix"
    ],
    "crucifixion": [
        "crucifixion"
    ],
    "crucifixions": [
        "crucifixion"
    ],
    "crucifiee": [
        "crucifie",
        "crucifier"
    ],
    "crucifiees": [
        "crucifie",
        "crucifier"
    ],
    "crucifies": [
        "crucifie",
        "crucifier",
        "crucify"
    ],
    "cruciforme": [
        "cruciforme"
    ],
    "cruciformes": [
        "cruciforme"
    ],
    "crucifere": [
        "crucifere"
    ],
    "cruciferes": [
        "crucifere"
    ],
    "cruciverbiste": [
        "cruciverbiste"
    ],
    "cruciverbistes": [
        "cruciverbiste"
    ],
    "crudite": [
        "crudite"
    ],
    "crudites": [
        "crudite"
    ],
    "crue": [
        "cru",
        "crue",
        "croire",
        "croitre"
    ],
    "cruel": [
        "cruel"
    ],
    "cruelle": [
        "cruel"
    ],
    "cruellement": [
        "cruellement"
    ],
    "cruelles": [
        "cruel"
    ],
    "cruels": [
        "cruel"
    ],
    "crues": [
        "cru",
        "crue",
        "croire",
        "croitre"
    ],
    "cruiser": [
        "cruiser"
    ],
    "crumble": [
        "crumble"
    ],
    "crurent": [
        "croire"
    ],
    "crus": [
        "cru",
        "croire"
    ],
    "crusse": [
        "croire"
    ],
    "crussent": [
        "croire"
    ],
    "crusses": [
        "croire"
    ],
    "crustace": [
        "crustace"
    ],
    "crustaces": [
        "crustace"
    ],
    "crut": [
        "croire",
        "croitre"
    ],
    "cruzeiro": [
        "cruzeiro"
    ],
    "cruzeiros": [
        "cruzeiro"
    ],
    "cryofracture": [
        "cryofracture"
    ],
    "cryogene": [
        "cryogene"
    ],
    "cryogenie": [
        "cryogenie"
    ],
    "cryogenique": [
        "cryogenique"
    ],
    "cryogeniques": [
        "cryogenique"
    ],
    "cryogenisation": [
        "cryogenisation"
    ],
    "cryonique": [
        "cryonique"
    ],
    "cryotechnique": [
        "cryotechnique"
    ],
    "cryptage": [
        "cryptage"
    ],
    "crypte": [
        "crypte",
        "crypter"
    ],
    "crypter": [
        "crypter"
    ],
    "cryptes": [
        "crypte",
        "crypter"
    ],
    "cryptique": [
        "cryptique"
    ],
    "cryptiques": [
        "cryptique"
    ],
    "crypto": [
        "crypto"
    ],
    "cryptocommunistes": [
        "cryptocommuniste"
    ],
    "cryptogame": [
        "cryptogame"
    ],
    "cryptogames": [
        "cryptogame"
    ],
    "cryptogamique": [
        "cryptogamique"
    ],
    "cryptogramme": [
        "cryptogramme"
    ],
    "cryptogrammes": [
        "cryptogramme"
    ],
    "cryptographe": [
        "cryptographe"
    ],
    "cryptographie": [
        "cryptographie"
    ],
    "cryptographique": [
        "cryptographique"
    ],
    "cryptologie": [
        "cryptologie"
    ],
    "cryptomere": [
        "cryptomere"
    ],
    "cryptee": [
        "crypter"
    ],
    "cryptees": [
        "crypter"
    ],
    "crana": [
        "craner"
    ],
    "cranais": [
        "craner"
    ],
    "cranait": [
        "craner"
    ],
    "cranant": [
        "craner"
    ],
    "cranement": [
        "cranement"
    ],
    "cranent": [
        "craner"
    ],
    "craner": [
        "craner"
    ],
    "cranerie": [
        "cranerie"
    ],
    "cranes": [
        "crane",
        "craner"
    ],
    "craneur": [
        "craneur"
    ],
    "craneurs": [
        "craneur"
    ],
    "craneuse": [
        "craneur"
    ],
    "craneuses": [
        "craneur"
    ],
    "cranez": [
        "craner"
    ],
    "cranien": [
        "cranien"
    ],
    "cranienne": [
        "cranien"
    ],
    "craniens": [
        "cranien"
    ],
    "creche": [
        "crecher",
        "creche"
    ],
    "crechent": [
        "crecher"
    ],
    "creches": [
        "crecher",
        "creche"
    ],
    "creme": [
        "creme"
    ],
    "cremes": [
        "cremer",
        "creme"
    ],
    "crevent": [
        "crever"
    ],
    "crevera": [
        "crever"
    ],
    "creverai": [
        "crever"
    ],
    "creveraient": [
        "crever"
    ],
    "creverais": [
        "crever"
    ],
    "creverait": [
        "crever"
    ],
    "creveras": [
        "crever"
    ],
    "creverez": [
        "crever"
    ],
    "creveriez": [
        "crever"
    ],
    "creverons": [
        "crever"
    ],
    "creveront": [
        "crever"
    ],
    "cre": [
        "cre"
    ],
    "crea": [
        "creer"
    ],
    "creai": [
        "creer"
    ],
    "creaient": [
        "creer"
    ],
    "creais": [
        "creer"
    ],
    "creait": [
        "creer"
    ],
    "creance": [
        "creance"
    ],
    "creances": [
        "creance"
    ],
    "creancier": [
        "creancier"
    ],
    "creanciers": [
        "creancier"
    ],
    "creant": [
        "creer"
    ],
    "createur": [
        "createur"
    ],
    "createurs": [
        "createur"
    ],
    "creatif": [
        "creatif"
    ],
    "creatifs": [
        "creatif"
    ],
    "creatine": [
        "creatine"
    ],
    "creatinine": [
        "creatinine"
    ],
    "creation": [
        "creation"
    ],
    "creationnisme": [
        "creationnisme"
    ],
    "creations": [
        "creation"
    ],
    "creative": [
        "creatif",
        "creative"
    ],
    "creatives": [
        "creatif",
        "creative"
    ],
    "creativite": [
        "creativite"
    ],
    "creatrice": [
        "createur"
    ],
    "creatrices": [
        "createur"
    ],
    "creature": [
        "creature"
    ],
    "creatures": [
        "creature"
    ],
    "crecelle": [
        "crecelle"
    ],
    "crecelles": [
        "crecelle"
    ],
    "crecerelle": [
        "crecerelle"
    ],
    "crecerelles": [
        "crecerelle"
    ],
    "crechaient": [
        "crecher"
    ],
    "crechait": [
        "crecher"
    ],
    "crechant": [
        "crecher"
    ],
    "crecher": [
        "crecher"
    ],
    "crecy": [
        "crecy"
    ],
    "credence": [
        "credence"
    ],
    "credences": [
        "credence"
    ],
    "credibilite": [
        "credibilite"
    ],
    "credible": [
        "credible"
    ],
    "credibles": [
        "credible"
    ],
    "credit": [
        "credit"
    ],
    "creditait": [
        "crediter"
    ],
    "credite": [
        "crediter"
    ],
    "creditent": [
        "crediter"
    ],
    "crediter": [
        "crediter"
    ],
    "crediteraient": [
        "crediter"
    ],
    "crediteur": [
        "crediteur"
    ],
    "crediteurs": [
        "crediteur"
    ],
    "creditez": [
        "crediter"
    ],
    "creditrice": [
        "crediteur"
    ],
    "credits": [
        "credit"
    ],
    "creditee": [
        "crediter"
    ],
    "credites": [
        "crediter"
    ],
    "credie": [
        "credie"
    ],
    "credule": [
        "credule"
    ],
    "credules": [
        "credule"
    ],
    "credulite": [
        "credulite"
    ],
    "credulites": [
        "credulite"
    ],
    "cree": [
        "creer"
    ],
    "creent": [
        "creer"
    ],
    "creer": [
        "creer"
    ],
    "creera": [
        "creer"
    ],
    "creerai": [
        "creer"
    ],
    "creeraient": [
        "creer"
    ],
    "creerais": [
        "creer"
    ],
    "creerait": [
        "creer"
    ],
    "creerez": [
        "creer"
    ],
    "creerons": [
        "creer"
    ],
    "creeront": [
        "creer"
    ],
    "creez": [
        "creer"
    ],
    "creiez": [
        "creer"
    ],
    "creions": [
        "creer"
    ],
    "cremaillere": [
        "cremaillere"
    ],
    "cremailleres": [
        "cremaillere"
    ],
    "cremant": [
        "cremant"
    ],
    "cremateurs": [
        "cremateur"
    ],
    "cremation": [
        "cremation"
    ],
    "cremations": [
        "cremation"
    ],
    "crematoire": [
        "crematoire"
    ],
    "crematoires": [
        "crematoire"
    ],
    "cremer": [
        "cremer"
    ],
    "cremerie": [
        "cremerie"
    ],
    "cremeries": [
        "cremerie"
    ],
    "cremeuse": [
        "cremeux"
    ],
    "cremeuses": [
        "cremeux"
    ],
    "cremeux": [
        "cremeux"
    ],
    "cremier": [
        "cremier"
    ],
    "cremiers": [
        "cremier"
    ],
    "cremiere": [
        "cremier"
    ],
    "cremieres": [
        "cremier"
    ],
    "cremone": [
        "cremone"
    ],
    "creneau": [
        "creneau"
    ],
    "creneaux": [
        "creneau"
    ],
    "crenelait": [
        "creneler"
    ],
    "crenele": [
        "crenele",
        "creneler"
    ],
    "crenelee": [
        "crenele",
        "creneler"
    ],
    "crenelees": [
        "crenele",
        "creneler"
    ],
    "creneles": [
        "crenele"
    ],
    "crenom": [
        "crenom"
    ],
    "creole": [
        "creole"
    ],
    "creoles": [
        "creole"
    ],
    "creolophone": [
        "creolophone"
    ],
    "creons": [
        "creer"
    ],
    "creosote": [
        "creosote"
    ],
    "creosotee": [
        "creosoter"
    ],
    "crepi": [
        "crepir",
        "crepi"
    ],
    "crepie": [
        "crepir"
    ],
    "crepies": [
        "crepir"
    ],
    "crepine": [
        "crepine"
    ],
    "crepinette": [
        "crepinette"
    ],
    "crepinettes": [
        "crepinette"
    ],
    "crepins": [
        "crepin"
    ],
    "crepir": [
        "crepir"
    ],
    "crepis": [
        "crepir",
        "crepi"
    ],
    "crepissage": [
        "crepissage"
    ],
    "crepissez": [
        "crepir"
    ],
    "crepita": [
        "crepiter"
    ],
    "crepitaient": [
        "crepiter"
    ],
    "crepitait": [
        "crepiter"
    ],
    "crepitant": [
        "crepiter",
        "crepitant"
    ],
    "crepitante": [
        "crepitant"
    ],
    "crepitantes": [
        "crepitant"
    ],
    "crepitants": [
        "crepitant"
    ],
    "crepitation": [
        "crepitation"
    ],
    "crepite": [
        "crepiter"
    ],
    "crepitement": [
        "crepitement"
    ],
    "crepitements": [
        "crepitement"
    ],
    "crepitent": [
        "crepiter"
    ],
    "crepiter": [
        "crepiter"
    ],
    "crepiteront": [
        "crepiter"
    ],
    "crepiterent": [
        "crepiter"
    ],
    "crepon": [
        "crepon"
    ],
    "crepons": [
        "crepon"
    ],
    "crepu": [
        "crepu"
    ],
    "crepue": [
        "crepu"
    ],
    "crepues": [
        "crepu"
    ],
    "crepus": [
        "crepu"
    ],
    "crepusculaire": [
        "crepusculaire"
    ],
    "crepusculaires": [
        "crepusculaire"
    ],
    "crepuscule": [
        "crepuscule"
    ],
    "crepuscules": [
        "crepuscule"
    ],
    "crequier": [
        "crequier"
    ],
    "cresol": [
        "cresol"
    ],
    "cresus": [
        "cresus"
    ],
    "cresyl": [
        "cresyl"
    ],
    "cresylee": [
        "cresyle"
    ],
    "cretace": [
        "cretace"
    ],
    "cretacee": [
        "cretace"
    ],
    "cretelle": [
        "cretelle"
    ],
    "cretin": [
        "cretin"
    ],
    "cretine": [
        "cretin"
    ],
    "cretinerie": [
        "cretinerie"
    ],
    "cretineries": [
        "cretinerie"
    ],
    "cretineux": [
        "cretineux"
    ],
    "cretinisant": [
        "cretinisant"
    ],
    "cretinisation": [
        "cretinisation"
    ],
    "cretiniser": [
        "cretiniser"
    ],
    "cretinisme": [
        "cretinisme"
    ],
    "cretinise": [
        "cretiniser"
    ],
    "cretins": [
        "cretin"
    ],
    "cretois": [
        "cretois"
    ],
    "cretoise": [
        "cretois"
    ],
    "cretoises": [
        "cretois"
    ],
    "creat": [
        "creer"
    ],
    "creerent": [
        "creer"
    ],
    "creee": [
        "creer"
    ],
    "creees": [
        "creer"
    ],
    "crees": [
        "creer"
    ],
    "crepage": [
        "crepage"
    ],
    "crepages": [
        "crepage"
    ],
    "crepaient": [
        "creper"
    ],
    "crepait": [
        "creper"
    ],
    "crepe": [
        "creper",
        "crepe"
    ],
    "crepelait": [
        "crepeler"
    ],
    "crepelure": [
        "crepelure"
    ],
    "crepelees": [
        "crepele"
    ],
    "crepeles": [
        "crepele"
    ],
    "creper": [
        "creper"
    ],
    "crepes": [
        "creper",
        "crepe"
    ],
    "crepee": [
        "creper",
        "crepe"
    ],
    "cret": [
        "cret"
    ],
    "cretaient": [
        "creter"
    ],
    "crete": [
        "creter",
        "crete"
    ],
    "cretes": [
        "creter",
        "crete"
    ],
    "cretions": [
        "creter"
    ],
    "cretee": [
        "creter",
        "crete"
    ],
    "cretees": [
        "creter"
    ],
    "crument": [
        "crument"
    ],
    "crumes": [
        "croire"
    ],
    "csardas": [
        "csardas"
    ],
    "cuadrilla": [
        "cuadrilla"
    ],
    "cuadrillas": [
        "cuadrilla"
    ],
    "cubage": [
        "cubage"
    ],
    "cubages": [
        "cubage"
    ],
    "cubain": [
        "cubain"
    ],
    "cubaine": [
        "cubain"
    ],
    "cubaines": [
        "cubain"
    ],
    "cubains": [
        "cubain"
    ],
    "cubait": [
        "cuber"
    ],
    "cubasse": [
        "cuber"
    ],
    "cube": [
        "cuber",
        "cube"
    ],
    "cubes": [
        "cuber",
        "cube"
    ],
    "cubique": [
        "cubique"
    ],
    "cubiques": [
        "cubique"
    ],
    "cubisme": [
        "cubisme"
    ],
    "cubiste": [
        "cubiste"
    ],
    "cubistes": [
        "cubiste"
    ],
    "cubitainer": [
        "cubitainer"
    ],
    "cubital": [
        "cubital"
    ],
    "cubitale": [
        "cubital"
    ],
    "cubitieres": [
        "cubitiere"
    ],
    "cubitus": [
        "cubitus"
    ],
    "cucaracha": [
        "cucaracha"
    ],
    "cucu": [
        "cucu"
    ],
    "cucul": [
        "cucul"
    ],
    "cucurbitacee": [
        "cucurbitacee"
    ],
    "cucurbite": [
        "cucurbite"
    ],
    "cucurbites": [
        "cucurbite"
    ],
    "cucuterie": [
        "cucuterie"
    ],
    "cueillaient": [
        "cueillir"
    ],
    "cueillais": [
        "cueillir"
    ],
    "cueillaison": [
        "cueillaison"
    ],
    "cueillait": [
        "cueillir"
    ],
    "cueillant": [
        "cueillir"
    ],
    "cueille": [
        "cueillir"
    ],
    "cueillent": [
        "cueillir"
    ],
    "cueillera": [
        "cueillir"
    ],
    "cueillerai": [
        "cueillir"
    ],
    "cueillerais": [
        "cueillir"
    ],
    "cueillerait": [
        "cueillir"
    ],
    "cueilleras": [
        "cueillir"
    ],
    "cueilleront": [
        "cueillir"
    ],
    "cueilles": [
        "cueillir"
    ],
    "cueillette": [
        "cueillette"
    ],
    "cueillettes": [
        "cueillette"
    ],
    "cueilleur": [
        "cueilleur"
    ],
    "cueilleurs": [
        "cueilleur"
    ],
    "cueilleuse": [
        "cueilleur"
    ],
    "cueilleuses": [
        "cueilleur"
    ],
    "cueillez": [
        "cueillir"
    ],
    "cueilli": [
        "cueillir"
    ],
    "cueillie": [
        "cueillir"
    ],
    "cueillies": [
        "cueillir"
    ],
    "cueillir": [
        "cueillir"
    ],
    "cueillirent": [
        "cueillir"
    ],
    "cueillis": [
        "cueillir"
    ],
    "cueillissent": [
        "cueillir"
    ],
    "cueillit": [
        "cueillir"
    ],
    "cueillons": [
        "cueillir"
    ],
    "cueillimes": [
        "cueillir"
    ],
    "cuesta": [
        "cuesta"
    ],
    "cueva": [
        "cueva"
    ],
    "cuevas": [
        "cueva"
    ],
    "cuiller": [
        "cuiller"
    ],
    "cuilleron": [
        "cuilleron"
    ],
    "cuillers": [
        "cuiller"
    ],
    "cuilleree": [
        "cuilleree"
    ],
    "cuillerees": [
        "cuilleree"
    ],
    "cuillere": [
        "cuillere"
    ],
    "cuilleres": [
        "cuillere"
    ],
    "cuir": [
        "cuir"
    ],
    "cuira": [
        "cuire"
    ],
    "cuirai": [
        "cuire"
    ],
    "cuirait": [
        "cuire"
    ],
    "cuiras": [
        "cuire"
    ],
    "cuirassaient": [
        "cuirasser"
    ],
    "cuirassait": [
        "cuirasser"
    ],
    "cuirasse": [
        "cuirasse",
        "cuirasser"
    ],
    "cuirassements": [
        "cuirassement"
    ],
    "cuirassent": [
        "cuirasser"
    ],
    "cuirasser": [
        "cuirasser"
    ],
    "cuirasses": [
        "cuirasse",
        "cuirasser"
    ],
    "cuirassier": [
        "cuirassier"
    ],
    "cuirassiers": [
        "cuirassier"
    ],
    "cuirassee": [
        "cuirasse",
        "cuirasser"
    ],
    "cuirassees": [
        "cuirasse",
        "cuirasser"
    ],
    "cuire": [
        "cuire"
    ],
    "cuirez": [
        "cuire"
    ],
    "cuiront": [
        "cuire"
    ],
    "cuirs": [
        "cuir"
    ],
    "cuis": [
        "cuire"
    ],
    "cuisaient": [
        "cuire"
    ],
    "cuisait": [
        "cuire"
    ],
    "cuisant": [
        "cuisant",
        "cuire"
    ],
    "cuisante": [
        "cuisant"
    ],
    "cuisantes": [
        "cuisant"
    ],
    "cuisants": [
        "cuisant"
    ],
    "cuise": [
        "cuire"
    ],
    "cuisent": [
        "cuire"
    ],
    "cuises": [
        "cuire"
    ],
    "cuiseurs": [
        "cuiseur"
    ],
    "cuisez": [
        "cuire"
    ],
    "cuisiez": [
        "cuire"
    ],
    "cuisina": [
        "cuisiner"
    ],
    "cuisinaient": [
        "cuisiner"
    ],
    "cuisinais": [
        "cuisiner"
    ],
    "cuisinait": [
        "cuisiner"
    ],
    "cuisinant": [
        "cuisiner"
    ],
    "cuisine": [
        "cuisiner",
        "cuisine"
    ],
    "cuisinent": [
        "cuisiner"
    ],
    "cuisiner": [
        "cuisiner"
    ],
    "cuisinera": [
        "cuisiner"
    ],
    "cuisinerai": [
        "cuisiner"
    ],
    "cuisinerais": [
        "cuisiner"
    ],
    "cuisinerait": [
        "cuisiner"
    ],
    "cuisineras": [
        "cuisiner"
    ],
    "cuisinerons": [
        "cuisiner"
    ],
    "cuisines": [
        "cuisiner",
        "cuisine"
    ],
    "cuisinette": [
        "cuisinette"
    ],
    "cuisinez": [
        "cuisiner"
    ],
    "cuisinier": [
        "cuisinier"
    ],
    "cuisiniers": [
        "cuisinier"
    ],
    "cuisiniez": [
        "cuisiner"
    ],
    "cuisiniere": [
        "cuisinier"
    ],
    "cuisinieres": [
        "cuisinier"
    ],
    "cuisinons": [
        "cuisiner"
    ],
    "cuisinee": [
        "cuisiner",
        "cuisine"
    ],
    "cuisinees": [
        "cuisiner",
        "cuisine"
    ],
    "cuisit": [
        "cuire"
    ],
    "cuisons": [
        "cuire"
    ],
    "cuissage": [
        "cuissage"
    ],
    "cuissard": [
        "cuissard"
    ],
    "cuissardes": [
        "cuissard",
        "cuissarde"
    ],
    "cuissards": [
        "cuissard"
    ],
    "cuisse": [
        "cuisse"
    ],
    "cuisseau": [
        "cuisseau"
    ],
    "cuisses": [
        "cuisse"
    ],
    "cuissette": [
        "cuissette"
    ],
    "cuissettes": [
        "cuissette"
    ],
    "cuisson": [
        "cuisson"
    ],
    "cuissons": [
        "cuisson"
    ],
    "cuissot": [
        "cuissot"
    ],
    "cuissots": [
        "cuissot"
    ],
    "cuistance": [
        "cuistance"
    ],
    "cuistances": [
        "cuistance"
    ],
    "cuistot": [
        "cuistot"
    ],
    "cuistots": [
        "cuistot"
    ],
    "cuistre": [
        "cuistre"
    ],
    "cuistrerie": [
        "cuistrerie"
    ],
    "cuistreries": [
        "cuistrerie"
    ],
    "cuistres": [
        "cuistre"
    ],
    "cuit": [
        "cuire",
        "cuit"
    ],
    "cuitant": [
        "cuiter"
    ],
    "cuite": [
        "cuiter",
        "cuite",
        "cuit"
    ],
    "cuiter": [
        "cuiter"
    ],
    "cuites": [
        "cuite",
        "cuit"
    ],
    "cuits": [
        "cuire",
        "cuit"
    ],
    "cuivra": [
        "cuivrer"
    ],
    "cuivrait": [
        "cuivrer"
    ],
    "cuivre": [
        "cuivrer",
        "cuivre"
    ],
    "cuivres": [
        "cuivrer",
        "cuivre"
    ],
    "cuivreux": [
        "cuivreux"
    ],
    "cuivree": [
        "cuivrer",
        "cuivre"
    ],
    "cuivrees": [
        "cuivrer",
        "cuivre"
    ],
    "cul": [
        "cul"
    ],
    "culasse": [
        "culasse"
    ],
    "culasses": [
        "culasse"
    ],
    "culbuta": [
        "culbuter"
    ],
    "culbutages": [
        "culbutage"
    ],
    "culbutaient": [
        "culbuter"
    ],
    "culbutait": [
        "culbuter"
    ],
    "culbutant": [
        "culbuter"
    ],
    "culbute": [
        "culbuter",
        "culbute"
    ],
    "culbutent": [
        "culbuter"
    ],
    "culbuter": [
        "culbuter"
    ],
    "culbuterais": [
        "culbuter"
    ],
    "culbutes": [
        "culbuter",
        "culbute"
    ],
    "culbuteur": [
        "culbuteur"
    ],
    "culbuteurs": [
        "culbuteur"
    ],
    "culbuto": [
        "culbuto"
    ],
    "culbuterent": [
        "culbuter"
    ],
    "culbutee": [
        "culbuter"
    ],
    "culbutees": [
        "culbuter"
    ],
    "cule": [
        "culer"
    ],
    "culer": [
        "culer"
    ],
    "culex": [
        "culex"
    ],
    "culinaire": [
        "culinaire"
    ],
    "culinaires": [
        "culinaire"
    ],
    "culmina": [
        "culminer"
    ],
    "culminait": [
        "culminer"
    ],
    "culminance": [
        "culminance"
    ],
    "culminant": [
        "culminer",
        "culminant"
    ],
    "culminants": [
        "culminant"
    ],
    "culmination": [
        "culmination"
    ],
    "culmine": [
        "culminer"
    ],
    "culminent": [
        "culminer"
    ],
    "culminer": [
        "culminer"
    ],
    "culons": [
        "culer"
    ],
    "culot": [
        "culot"
    ],
    "culots": [
        "culot"
    ],
    "culotte": [
        "culotte",
        "culotter"
    ],
    "culotter": [
        "culotter"
    ],
    "culottes": [
        "culotte",
        "culotter"
    ],
    "culottier": [
        "culottier"
    ],
    "culottiers": [
        "culottier"
    ],
    "culottiere": [
        "culottier"
    ],
    "culottieres": [
        "culottier"
    ],
    "culottee": [
        "culotter",
        "culotte"
    ],
    "culottees": [
        "culotter"
    ],
    "culpabilisais": [
        "culpabiliser"
    ],
    "culpabilisait": [
        "culpabiliser"
    ],
    "culpabilisant": [
        "culpabiliser",
        "culpabilisant"
    ],
    "culpabilisation": [
        "culpabilisation"
    ],
    "culpabilise": [
        "culpabiliser"
    ],
    "culpabilisent": [
        "culpabiliser"
    ],
    "culpabiliser": [
        "culpabiliser"
    ],
    "culpabiliserai": [
        "culpabiliser"
    ],
    "culpabilises": [
        "culpabiliser"
    ],
    "culpabilisez": [
        "culpabiliser"
    ],
    "culpabilisiez": [
        "culpabiliser"
    ],
    "culpabilisons": [
        "culpabiliser"
    ],
    "culpabilisee": [
        "culpabiliser"
    ],
    "culpabilite": [
        "culpabilite"
    ],
    "culs": [
        "cul"
    ],
    "culte": [
        "culte"
    ],
    "cultes": [
        "culte"
    ],
    "cultiva": [
        "cultiver"
    ],
    "cultivable": [
        "cultivable"
    ],
    "cultivables": [
        "cultivable"
    ],
    "cultivai": [
        "cultiver"
    ],
    "cultivaient": [
        "cultiver"
    ],
    "cultivais": [
        "cultiver"
    ],
    "cultivait": [
        "cultiver"
    ],
    "cultivant": [
        "cultiver"
    ],
    "cultivateur": [
        "cultivateur"
    ],
    "cultivateurs": [
        "cultivateur"
    ],
    "cultivatrice": [
        "cultivateur"
    ],
    "cultivatrices": [
        "cultivateur"
    ],
    "cultive": [
        "cultive",
        "cultiver"
    ],
    "cultivent": [
        "cultiver"
    ],
    "cultiver": [
        "cultiver"
    ],
    "cultivera": [
        "cultiver"
    ],
    "cultiverai": [
        "cultiver"
    ],
    "cultiveraient": [
        "cultiver"
    ],
    "cultiverait": [
        "cultiver"
    ],
    "cultiveras": [
        "cultiver"
    ],
    "cultives": [
        "cultive",
        "cultiver"
    ],
    "cultivez": [
        "cultiver"
    ],
    "cultivions": [
        "cultiver"
    ],
    "cultivons": [
        "cultiver"
    ],
    "cultiverent": [
        "cultiver"
    ],
    "cultivee": [
        "cultive",
        "cultiver"
    ],
    "cultivees": [
        "cultive",
        "cultiver"
    ],
    "cultural": [
        "cultural"
    ],
    "culturalismes": [
        "culturalisme"
    ],
    "culture": [
        "culture"
    ],
    "culturel": [
        "culturel"
    ],
    "culturelle": [
        "culturel"
    ],
    "culturellement": [
        "culturellement"
    ],
    "culturelles": [
        "culturel"
    ],
    "culturels": [
        "culturel"
    ],
    "cultures": [
        "culture"
    ],
    "culturisme": [
        "culturisme"
    ],
    "culturiste": [
        "culturiste"
    ],
    "culturistes": [
        "culturiste"
    ],
    "culee": [
        "culee"
    ],
    "cumin": [
        "cumin"
    ],
    "cumul": [
        "cumul"
    ],
    "cumulaient": [
        "cumuler"
    ],
    "cumulait": [
        "cumuler"
    ],
    "cumulant": [
        "cumuler"
    ],
    "cumulard": [
        "cumulard"
    ],
    "cumulatif": [
        "cumulatif"
    ],
    "cumulatifs": [
        "cumulatif"
    ],
    "cumulation": [
        "cumulation"
    ],
    "cumulative": [
        "cumulatif"
    ],
    "cumule": [
        "cumuler"
    ],
    "cumuler": [
        "cumuler"
    ],
    "cumulera": [
        "cumuler"
    ],
    "cumulez": [
        "cumuler"
    ],
    "cumuliez": [
        "cumuler"
    ],
    "cumulus": [
        "cumulus"
    ],
    "cumules": [
        "cumuler"
    ],
    "cunnilinctus": [
        "cunnilinctus"
    ],
    "cunnilingus": [
        "cunnilingus"
    ],
    "cuneiforme": [
        "cuneiforme"
    ],
    "cuneiformes": [
        "cuneiforme"
    ],
    "cupide": [
        "cupide"
    ],
    "cupidement": [
        "cupidement"
    ],
    "cupides": [
        "cupide"
    ],
    "cupidite": [
        "cupidite"
    ],
    "cupidon": [
        "cupidon"
    ],
    "cupidons": [
        "cupidon"
    ],
    "cupressus": [
        "cupressus"
    ],
    "cupriferes": [
        "cuprifere"
    ],
    "cupriques": [
        "cuprique"
    ],
    "cupronickel": [
        "cupronickel"
    ],
    "cupule": [
        "cupule"
    ],
    "cupules": [
        "cupule"
    ],
    "cura": [
        "curer"
    ],
    "curable": [
        "curable"
    ],
    "curables": [
        "curable"
    ],
    "curage": [
        "curage"
    ],
    "curaille": [
        "curaille"
    ],
    "curaillon": [
        "curaillon"
    ],
    "curait": [
        "curer"
    ],
    "curant": [
        "curer"
    ],
    "curare": [
        "curare"
    ],
    "curarisant": [
        "curarisant"
    ],
    "curariser": [
        "curariser"
    ],
    "curateur": [
        "curateur"
    ],
    "curatif": [
        "curatif"
    ],
    "curatifs": [
        "curatif"
    ],
    "curative": [
        "curatif"
    ],
    "curatives": [
        "curatif"
    ],
    "curatrice": [
        "curateur"
    ],
    "curacao": [
        "curacao"
    ],
    "curacaos": [
        "curacao"
    ],
    "curcuma": [
        "curcuma"
    ],
    "cure": [
        "cure",
        "curer"
    ],
    "curer": [
        "curer"
    ],
    "cureras": [
        "curer"
    ],
    "cures": [
        "cure",
        "curer"
    ],
    "curetage": [
        "curetage"
    ],
    "cureter": [
        "cureter"
    ],
    "cureton": [
        "cureton"
    ],
    "curetons": [
        "cureton"
    ],
    "curette": [
        "curette"
    ],
    "curettes": [
        "curette"
    ],
    "curial": [
        "curial"
    ],
    "curiales": [
        "curial"
    ],
    "curie": [
        "curie"
    ],
    "curieuse": [
        "curieux"
    ],
    "curieusement": [
        "curieusement"
    ],
    "curieuses": [
        "curieux"
    ],
    "curieux": [
        "curieux"
    ],
    "curiosite": [
        "curiosite"
    ],
    "curiosites": [
        "curiosite"
    ],
    "curiste": [
        "curiste"
    ],
    "curistes": [
        "curiste"
    ],
    "curling": [
        "curl",
        "curling"
    ],
    "curricula": [
        "curriculum"
    ],
    "curriculum": [
        "curriculum"
    ],
    "curry": [
        "curry"
    ],
    "curseur": [
        "curseur"
    ],
    "cursif": [
        "cursif"
    ],
    "cursive": [
        "cursive",
        "cursif"
    ],
    "cursus": [
        "cursus"
    ],
    "curve": [
        "curve"
    ],
    "curviligne": [
        "curviligne"
    ],
    "curvilignes": [
        "curviligne"
    ],
    "curvimetres": [
        "curvimetre"
    ],
    "curee": [
        "curee",
        "curer"
    ],
    "curees": [
        "curee"
    ],
    "custode": [
        "custode"
    ],
    "custom": [
        "custom"
    ],
    "customise": [
        "customiser"
    ],
    "cutane": [
        "cutane"
    ],
    "cutanee": [
        "cutane"
    ],
    "cutanees": [
        "cutane"
    ],
    "cutanes": [
        "cutane"
    ],
    "cuti": [
        "cuti"
    ],
    "cuticule": [
        "cuticule"
    ],
    "cuticules": [
        "cuticule"
    ],
    "cutis": [
        "cuti"
    ],
    "cutter": [
        "cutter"
    ],
    "cutters": [
        "cutter"
    ],
    "cuvaient": [
        "cuver"
    ],
    "cuvait": [
        "cuver"
    ],
    "cuvant": [
        "cuver"
    ],
    "cuve": [
        "cuver",
        "cuve"
    ],
    "cuveau": [
        "cuveau"
    ],
    "cuveaux": [
        "cuveau"
    ],
    "cuvent": [
        "cuver"
    ],
    "cuver": [
        "cuver"
    ],
    "cuvera": [
        "cuver"
    ],
    "cuverez": [
        "cuver"
    ],
    "cuves": [
        "cuve"
    ],
    "cuvette": [
        "cuvette"
    ],
    "cuvettes": [
        "cuvette"
    ],
    "cuvier": [
        "cuvier"
    ],
    "cuviers": [
        "cuvier"
    ],
    "cuvee": [
        "cuver",
        "cuvee"
    ],
    "cuvees": [
        "cuvee"
    ],
    "cyan": [
        "cyan"
    ],
    "cyanhydrique": [
        "cyanhydrique"
    ],
    "cyanoacrylate": [
        "cyanoacrylate"
    ],
    "cyanobacterie": [
        "cyanobacterie"
    ],
    "cyanogene": [
        "cyanogene"
    ],
    "cyanose": [
        "cyanoser",
        "cyanose"
    ],
    "cyanosee": [
        "cyanoser"
    ],
    "cyanure": [
        "cyanure"
    ],
    "cybercafe": [
        "cybercafe"
    ],
    "cyberespace": [
        "cyberespace"
    ],
    "cybermonde": [
        "cybermonde"
    ],
    "cybernautes": [
        "cybernaute"
    ],
    "cyberneticien": [
        "cyberneticien"
    ],
    "cybernetique": [
        "cybernetique"
    ],
    "cybernetiques": [
        "cybernetique"
    ],
    "cybernetiser": [
        "cybernetiser"
    ],
    "cyberspace": [
        "cyberspace"
    ],
    "cycas": [
        "cycas"
    ],
    "cyclable": [
        "cyclable"
    ],
    "cyclables": [
        "cyclable"
    ],
    "cyclamen": [
        "cyclamen"
    ],
    "cyclamens": [
        "cyclamen"
    ],
    "cycle": [
        "cycle"
    ],
    "cycles": [
        "cycle"
    ],
    "cyclique": [
        "cyclique"
    ],
    "cycliquement": [
        "cycliquement"
    ],
    "cycliques": [
        "cyclique"
    ],
    "cyclisme": [
        "cyclisme"
    ],
    "cycliste": [
        "cycliste"
    ],
    "cyclistes": [
        "cycliste"
    ],
    "cyclo": [
        "cyclo"
    ],
    "cyclomoteur": [
        "cyclomoteur"
    ],
    "cyclomoteurs": [
        "cyclomoteur"
    ],
    "cyclone": [
        "cyclone"
    ],
    "cyclones": [
        "cyclone"
    ],
    "cyclonique": [
        "cyclonique"
    ],
    "cyclope": [
        "cyclope"
    ],
    "cyclopes": [
        "cyclope"
    ],
    "cyclopousses": [
        "cyclopousse"
    ],
    "cyclopeen": [
        "cyclopeen"
    ],
    "cyclopeenne": [
        "cyclopeen"
    ],
    "cyclopeennes": [
        "cyclopeen"
    ],
    "cyclopeens": [
        "cyclopeen"
    ],
    "cyclorama": [
        "cyclorama"
    ],
    "cyclosporine": [
        "cyclosporine"
    ],
    "cyclostomes": [
        "cyclostome"
    ],
    "cyclothymie": [
        "cyclothymie"
    ],
    "cyclothymique": [
        "cyclothymique"
    ],
    "cyclotron": [
        "cyclotron"
    ],
    "cycloidal": [
        "cycloidal"
    ],
    "cyclees": [
        "cycler"
    ],
    "cygne": [
        "cygne"
    ],
    "cygnes": [
        "cygne"
    ],
    "cylindre": [
        "cylindrer",
        "cylindre"
    ],
    "cylindres": [
        "cylindrer",
        "cylindre"
    ],
    "cylindrique": [
        "cylindrique"
    ],
    "cylindriques": [
        "cylindrique"
    ],
    "cylindree": [
        "cylindree"
    ],
    "cylindrees": [
        "cylindree"
    ],
    "cymbale": [
        "cymbale"
    ],
    "cymbales": [
        "cymbale"
    ],
    "cymbaliste": [
        "cymbaliste"
    ],
    "cymbalistes": [
        "cymbaliste"
    ],
    "cymbalum": [
        "cymbalum"
    ],
    "cymes": [
        "cyme"
    ],
    "cynips": [
        "cynips"
    ],
    "cynique": [
        "cynique"
    ],
    "cyniquement": [
        "cyniquement"
    ],
    "cyniques": [
        "cynique"
    ],
    "cynisme": [
        "cynisme"
    ],
    "cynismes": [
        "cynisme"
    ],
    "cynocephale": [
        "cynocephale"
    ],
    "cynocephales": [
        "cynocephale"
    ],
    "cynodrome": [
        "cynodrome"
    ],
    "cynophile": [
        "cynophile"
    ],
    "cynos": [
        "cyno"
    ],
    "cynegetique": [
        "cynegetique"
    ],
    "cynegetiques": [
        "cynegetique"
    ],
    "cyphoscoliose": [
        "cyphoscoliose"
    ],
    "cyphose": [
        "cyphose"
    ],
    "cyprin": [
        "cyprin"
    ],
    "cyprinide": [
        "cyprinide"
    ],
    "cyprinides": [
        "cyprinide"
    ],
    "cyprins": [
        "cyprin"
    ],
    "cypriote": [
        "cypriote"
    ],
    "cypriotes": [
        "cypriote"
    ],
    "cypres": [
        "cypres"
    ],
    "cyrard": [
        "cyrard"
    ],
    "cyrards": [
        "cyrard"
    ],
    "cyrillique": [
        "cyrillique"
    ],
    "cyrilliques": [
        "cyrillique"
    ],
    "cystique": [
        "cystique"
    ],
    "cystite": [
        "cystite"
    ],
    "cystotomie": [
        "cystotomie"
    ],
    "cytises": [
        "cytise"
    ],
    "cytologie": [
        "cytologie"
    ],
    "cytologiques": [
        "cytologique"
    ],
    "cytomegalovirus": [
        "cytomegalovirus"
    ],
    "cytoplasme": [
        "cytoplasme"
    ],
    "cytoplasmique": [
        "cytoplasmique"
    ],
    "cytosine": [
        "cytosine"
    ],
    "cytotoxique": [
        "cytotoxique"
    ],
    "czar": [
        "czar"
    ],
    "czardas": [
        "czardas"
    ],
    "czars": [
        "czar"
    ],
    "cabla": [
        "cabler"
    ],
    "cablage": [
        "cablage"
    ],
    "cablages": [
        "cablage"
    ],
    "cablait": [
        "cabler"
    ],
    "cable": [
        "cable",
        "cabler"
    ],
    "cabler": [
        "cabler"
    ],
    "cablerais": [
        "cabler"
    ],
    "cablerie": [
        "cablerie"
    ],
    "cableront": [
        "cabler"
    ],
    "cables": [
        "cable",
        "cabler"
    ],
    "cableur": [
        "cableur"
    ],
    "cableurs": [
        "cableur"
    ],
    "cablez": [
        "cabler"
    ],
    "cablier": [
        "cablier"
    ],
    "cablogramme": [
        "cablogramme"
    ],
    "cablee": [
        "cable",
        "cabler"
    ],
    "cablees": [
        "cable",
        "cabler"
    ],
    "calin": [
        "calin"
    ],
    "calina": [
        "caliner"
    ],
    "calinait": [
        "caliner"
    ],
    "calinant": [
        "caliner"
    ],
    "caline": [
        "caliner",
        "calin"
    ],
    "calinement": [
        "calinement"
    ],
    "calinent": [
        "caliner"
    ],
    "caliner": [
        "caliner"
    ],
    "calinerai": [
        "caliner"
    ],
    "calinerie": [
        "calinerie"
    ],
    "calineries": [
        "calinerie"
    ],
    "calines": [
        "calin"
    ],
    "calins": [
        "calin"
    ],
    "calinee": [
        "caliner"
    ],
    "capre": [
        "capre"
    ],
    "capres": [
        "capre"
    ],
    "capriers": [
        "caprier"
    ],
    "cede": [
        "ceder"
    ],
    "cedent": [
        "ceder"
    ],
    "cedre": [
        "cedre"
    ],
    "cedres": [
        "cedre"
    ],
    "cele": [
        "celer"
    ],
    "cene": [
        "cene"
    ],
    "cepe": [
        "cepe"
    ],
    "cepes": [
        "cepe"
    ],
    "ceans": [
        "ceans"
    ],
    "ceara": [
        "ceara"
    ],
    "cecidomyies": [
        "cecidomyie"
    ],
    "cecite": [
        "cecite"
    ],
    "ceda": [
        "ceder"
    ],
    "cedai": [
        "ceder"
    ],
    "cedaient": [
        "ceder"
    ],
    "cedais": [
        "ceder"
    ],
    "cedait": [
        "ceder"
    ],
    "cedant": [
        "cedant",
        "ceder"
    ],
    "ceder": [
        "ceder"
    ],
    "cedera": [
        "ceder"
    ],
    "cederai": [
        "ceder"
    ],
    "cederaient": [
        "ceder"
    ],
    "cederais": [
        "ceder"
    ],
    "cederait": [
        "ceder"
    ],
    "cederas": [
        "ceder"
    ],
    "cederez": [
        "ceder"
    ],
    "cederiez": [
        "ceder"
    ],
    "cederons": [
        "ceder"
    ],
    "cederont": [
        "ceder"
    ],
    "cedez": [
        "ceder"
    ],
    "cediez": [
        "ceder"
    ],
    "cedions": [
        "ceder"
    ],
    "cedons": [
        "ceder"
    ],
    "cedrat": [
        "cedrat"
    ],
    "cedratier": [
        "cedratier"
    ],
    "cedrats": [
        "cedrat"
    ],
    "cedulaire": [
        "cedulaire"
    ],
    "cedule": [
        "cedule"
    ],
    "cedat": [
        "ceder"
    ],
    "cederent": [
        "ceder"
    ],
    "cedee": [
        "ceder"
    ],
    "cedees": [
        "ceder"
    ],
    "cedes": [
        "cede",
        "ceder"
    ],
    "cegep": [
        "cegep"
    ],
    "cegetiste": [
        "cegetiste"
    ],
    "cegetistes": [
        "cegetiste"
    ],
    "celadon": [
        "celadon"
    ],
    "celeri": [
        "celeri"
    ],
    "celeris": [
        "celeri"
    ],
    "celeste": [
        "celeste"
    ],
    "celestes": [
        "celeste"
    ],
    "celestin": [
        "celestin"
    ],
    "celestins": [
        "celestin"
    ],
    "celibat": [
        "celibat"
    ],
    "celibataire": [
        "celibataire"
    ],
    "celibataires": [
        "celibataire"
    ],
    "celimene": [
        "celimene"
    ],
    "celinien": [
        "celinien"
    ],
    "celinienne": [
        "celinien"
    ],
    "celebre": [
        "celebrer",
        "celebre"
    ],
    "celebrent": [
        "celebrer"
    ],
    "celebres": [
        "celebrer",
        "celebre"
    ],
    "celebra": [
        "celebrer"
    ],
    "celebraient": [
        "celebrer"
    ],
    "celebrais": [
        "celebrer"
    ],
    "celebrait": [
        "celebrer"
    ],
    "celebrant": [
        "celebrer",
        "celebrant"
    ],
    "celebrants": [
        "celebrant"
    ],
    "celebration": [
        "celebration"
    ],
    "celebrations": [
        "celebration"
    ],
    "celebrer": [
        "celebrer"
    ],
    "celebrera": [
        "celebrer"
    ],
    "celebrerais": [
        "celebrer"
    ],
    "celebrerait": [
        "celebrer"
    ],
    "celebrerons": [
        "celebrer"
    ],
    "celebreront": [
        "celebrer"
    ],
    "celebriez": [
        "celebrer"
    ],
    "celebrions": [
        "celebrer"
    ],
    "celebrissime": [
        "celebrissime"
    ],
    "celebrite": [
        "celebrite"
    ],
    "celebrites": [
        "celebrite"
    ],
    "celebrons": [
        "celebrer"
    ],
    "celebrames": [
        "celebrer"
    ],
    "celebrat": [
        "celebrer"
    ],
    "celebrerent": [
        "celebrer"
    ],
    "celebree": [
        "celebrer"
    ],
    "celebrees": [
        "celebrer"
    ],
    "celerifere": [
        "celerifere"
    ],
    "celerite": [
        "celerite"
    ],
    "cenacle": [
        "cenacle"
    ],
    "cenacles": [
        "cenacle"
    ],
    "cenobite": [
        "cenobite"
    ],
    "cenobites": [
        "cenobite"
    ],
    "cenotaphe": [
        "cenotaphe"
    ],
    "cepage": [
        "cepage"
    ],
    "cephaline": [
        "cephaline"
    ],
    "cephalique": [
        "cephalique"
    ],
    "cephalopode": [
        "cephalopode"
    ],
    "cephalopodes": [
        "cephalopode"
    ],
    "cephalorachidien": [
        "cephalorachidien"
    ],
    "cephalosporine": [
        "cephalosporine"
    ],
    "cephalee": [
        "cephale"
    ],
    "cephalees": [
        "cephale",
        "cephalee"
    ],
    "cepee": [
        "cepee"
    ],
    "cepees": [
        "cepee"
    ],
    "ceramique": [
        "ceramique"
    ],
    "ceramiques": [
        "ceramique"
    ],
    "ceramiste": [
        "ceramiste"
    ],
    "ceruleen": [
        "ceruleen"
    ],
    "ceruleens": [
        "ceruleen"
    ],
    "cerumen": [
        "cerumen"
    ],
    "ceruse": [
        "ceruse"
    ],
    "cereale": [
        "cereale"
    ],
    "cereales": [
        "cereale"
    ],
    "cerealier": [
        "cerealier"
    ],
    "cerealiers": [
        "cerealier"
    ],
    "cerealiere": [
        "cerealier"
    ],
    "cerealieres": [
        "cerealier"
    ],
    "cerebelleuse": [
        "cerebelleux"
    ],
    "cerebelleuses": [
        "cerebelleux"
    ],
    "cerebral": [
        "cerebral"
    ],
    "cerebrale": [
        "cerebral"
    ],
    "cerebralement": [
        "cerebralement"
    ],
    "cerebrales": [
        "cerebral"
    ],
    "cerebralite": [
        "cerebralite"
    ],
    "cerebraux": [
        "cerebral"
    ],
    "ceremoniaires": [
        "ceremoniaire"
    ],
    "ceremonial": [
        "ceremonial"
    ],
    "ceremoniale": [
        "ceremonial"
    ],
    "ceremonials": [
        "ceremonial"
    ],
    "ceremonie": [
        "ceremonie"
    ],
    "ceremoniel": [
        "ceremoniel"
    ],
    "ceremonielle": [
        "ceremoniel"
    ],
    "ceremoniels": [
        "ceremoniel"
    ],
    "ceremonies": [
        "ceremony",
        "ceremonie"
    ],
    "ceremonieuse": [
        "ceremonieux"
    ],
    "ceremonieusement": [
        "ceremonieusement"
    ],
    "ceremonieuses": [
        "ceremonieux"
    ],
    "ceremonieux": [
        "ceremonieux"
    ],
    "cesar": [
        "cesar"
    ],
    "cesarien": [
        "cesarien"
    ],
    "cesarienne": [
        "cesarienne"
    ],
    "cesariennes": [
        "cesarienne"
    ],
    "cesariens": [
        "cesarien"
    ],
    "cesars": [
        "cesar"
    ],
    "cesium": [
        "cesium"
    ],
    "cesure": [
        "cesure"
    ],
    "cesures": [
        "cesure"
    ],
    "cetace": [
        "cetace"
    ],
    "cetaces": [
        "cetace"
    ],
    "cetoine": [
        "cetoine"
    ],
    "cetoines": [
        "cetoine"
    ],
    "cetone": [
        "cetone"
    ],
    "cevadille": [
        "cevadille"
    ],
    "cevenol": [
        "cevenol"
    ],
    "cezigue": [
        "cezigue"
    ],
    "cone": [
        "cone"
    ],
    "cones": [
        "cone"
    ],
    "cotelette": [
        "cotelette"
    ],
    "cotelettes": [
        "cotelette"
    ],
    "cotele": [
        "cotele"
    ],
    "cotelee": [
        "cotele"
    ],
    "cotier": [
        "cotier"
    ],
    "cotiers": [
        "cotier"
    ],
    "cotiere": [
        "cotier"
    ],
    "cotieres": [
        "cotier"
    ],
    "cotoie": [
        "cotoyer"
    ],
    "cotoiements": [
        "cotoiement"
    ],
    "cotoient": [
        "cotoyer"
    ],
    "cotoies": [
        "cotoyer"
    ],
    "cotoya": [
        "cotoyer"
    ],
    "cotoyaient": [
        "cotoyer"
    ],
    "cotoyais": [
        "cotoyer"
    ],
    "cotoyait": [
        "cotoyer"
    ],
    "cotoyant": [
        "cotoyer"
    ],
    "cotoyer": [
        "cotoyer"
    ],
    "cotoyons": [
        "cotoyer"
    ],
    "cotoye": [
        "cotoyer"
    ],
    "cotoyee": [
        "cotoyer"
    ],
    "cotoyees": [
        "cotoyer"
    ],
    "cotoyes": [
        "cotoyer"
    ],
    "d": [
        "d",
        "have"
    ],
    "d'": [
        "d",
        "do",
        "d'",
        "de"
    ],
    "d'abord": [
        "d'abord"
    ],
    "d'autres": [
        "d'autres"
    ],
    "d'emblee": [
        "d'emblee",
        "d'embleee"
    ],
    "da": [
        "da"
    ],
    "dab": [
        "dab"
    ],
    "daba": [
        "daba"
    ],
    "dabe": [
        "dabe"
    ],
    "dabs": [
        "dab"
    ],
    "dabuche": [
        "dabuche"
    ],
    "dabuches": [
        "dabuche"
    ],
    "dace": [
        "dace"
    ],
    "daces": [
        "dace"
    ],
    "dache": [
        "dache"
    ],
    "dacique": [
        "dacique"
    ],
    "dacron": [
        "dacron"
    ],
    "dactyle": [
        "dactyle"
    ],
    "dactyles": [
        "dactyle"
    ],
    "dactylo": [
        "dactylo"
    ],
    "dactylographe": [
        "dactylographe"
    ],
    "dactylographes": [
        "dactylographe"
    ],
    "dactylographie": [
        "dactylographie",
        "dactylographier"
    ],
    "dactylographier": [
        "dactylographier"
    ],
    "dactylographiee": [
        "dactylographie",
        "dactylographier"
    ],
    "dactylographiees": [
        "dactylographie",
        "dactylographier"
    ],
    "dactylographies": [
        "dactylographie"
    ],
    "dactylopteres": [
        "dactyloptere"
    ],
    "dactylos": [
        "dactylo"
    ],
    "dactyloscopie": [
        "dactyloscopie"
    ],
    "dada": [
        "dada"
    ],
    "dadais": [
        "dadais"
    ],
    "dadas": [
        "dada"
    ],
    "dadaisme": [
        "dadaisme"
    ],
    "dadaiste": [
        "dadaiste"
    ],
    "dadaistes": [
        "dadaiste"
    ],
    "dague": [
        "dague",
        "daguer"
    ],
    "daguerreotype": [
        "daguerreotype"
    ],
    "daguerreotypes": [
        "daguerreotype"
    ],
    "dagues": [
        "dague"
    ],
    "daguet": [
        "daguet"
    ],
    "daguets": [
        "daguet"
    ],
    "dahlia": [
        "dahlia"
    ],
    "dahlias": [
        "dahlia"
    ],
    "dahomeenne": [
        "dahomeen"
    ],
    "dahu": [
        "dahu"
    ],
    "dahus": [
        "dahu"
    ],
    "daigna": [
        "daigner"
    ],
    "daignaient": [
        "daigner"
    ],
    "daignait": [
        "daigner"
    ],
    "daignant": [
        "daigner"
    ],
    "daigne": [
        "daigner"
    ],
    "daignent": [
        "daigner"
    ],
    "daigner": [
        "daigner"
    ],
    "daignera": [
        "daigner"
    ],
    "daigneraient": [
        "daigner"
    ],
    "daignerais": [
        "daigner"
    ],
    "daignerait": [
        "daigner"
    ],
    "daigneras": [
        "daigner"
    ],
    "daignes": [
        "daigner"
    ],
    "daignez": [
        "daigner"
    ],
    "daignons": [
        "daigner"
    ],
    "daignat": [
        "daigner"
    ],
    "daignerent": [
        "daigner"
    ],
    "daim": [
        "daim"
    ],
    "daims": [
        "daim"
    ],
    "daine": [
        "daine"
    ],
    "daiquiri": [
        "daiquiri"
    ],
    "daiquiris": [
        "daiquiri"
    ],
    "dais": [
        "dais"
    ],
    "dakarois": [
        "dakarois"
    ],
    "dakaroise": [
        "dakarois"
    ],
    "dakin": [
        "dakin"
    ],
    "dakotas": [
        "dakota"
    ],
    "dal": [
        "dal"
    ],
    "dale": [
        "dale"
    ],
    "dalinienne": [
        "dalinien"
    ],
    "dallage": [
        "dallage"
    ],
    "dallages": [
        "dallage"
    ],
    "dalle": [
        "dalle",
        "daller"
    ],
    "daller": [
        "daller"
    ],
    "dalles": [
        "dalle",
        "daller"
    ],
    "dallee": [
        "daller"
    ],
    "dallees": [
        "daller"
    ],
    "dalmate": [
        "dalmate"
    ],
    "dalmates": [
        "dalmate"
    ],
    "dalmatien": [
        "dalmatien"
    ],
    "dalmatienne": [
        "dalmatien"
    ],
    "dalmatiens": [
        "dalmatien"
    ],
    "dalmatique": [
        "dalmatique"
    ],
    "dalmatiques": [
        "dalmatique"
    ],
    "daltonien": [
        "daltonien"
    ],
    "daltonienne": [
        "daltonien"
    ],
    "daltoniennes": [
        "daltonien"
    ],
    "daltoniens": [
        "daltonien"
    ],
    "daltonisme": [
        "daltonisme"
    ],
    "daltons": [
        "dalton"
    ],
    "dam": [
        "dam"
    ],
    "damage": [
        "damage"
    ],
    "damas": [
        "damas"
    ],
    "damasquin": [
        "damasquin"
    ],
    "damasquinage": [
        "damasquinage"
    ],
    "damasquinerie": [
        "damasquinerie"
    ],
    "damasquins": [
        "damasquin"
    ],
    "damasquinure": [
        "damasquinure"
    ],
    "damasquine": [
        "damasquine"
    ],
    "damasquinee": [
        "damasquine"
    ],
    "damasquines": [
        "damasquine"
    ],
    "damasse": [
        "damasse"
    ],
    "damassee": [
        "damasser",
        "damasse"
    ],
    "damassees": [
        "damasser",
        "damasse"
    ],
    "damasses": [
        "damasser",
        "damasse"
    ],
    "dame": [
        "damer",
        "dame"
    ],
    "dament": [
        "damer"
    ],
    "damer": [
        "damer"
    ],
    "dameret": [
        "dameret"
    ],
    "dameriez": [
        "damer"
    ],
    "dames": [
        "damer",
        "dames",
        "dame"
    ],
    "damez": [
        "damer"
    ],
    "damier": [
        "damier"
    ],
    "damiers": [
        "damier"
    ],
    "damnable": [
        "damnable"
    ],
    "damnables": [
        "damnable"
    ],
    "damnait": [
        "damner"
    ],
    "damnant": [
        "damner"
    ],
    "damnation": [
        "damnation"
    ],
    "damnations": [
        "damnation"
    ],
    "damne": [
        "damner",
        "damne"
    ],
    "damned": [
        "damned",
        "damn"
    ],
    "damnent": [
        "damner"
    ],
    "damner": [
        "damner"
    ],
    "damnera": [
        "damner"
    ],
    "damneraient": [
        "damner"
    ],
    "damnerais": [
        "damner"
    ],
    "damnez": [
        "damner"
    ],
    "damnee": [
        "damner",
        "damne"
    ],
    "damnees": [
        "damner",
        "damne"
    ],
    "damnes": [
        "damner",
        "damne"
    ],
    "damoiseau": [
        "damoiseau"
    ],
    "damoiselle": [
        "damoiselle"
    ],
    "damoiselles": [
        "damoiselle"
    ],
    "dams": [
        "dam"
    ],
    "damee": [
        "damer"
    ],
    "damees": [
        "damer"
    ],
    "dan": [
        "dan"
    ],
    "danaide": [
        "danaide"
    ],
    "dancing": [
        "dance",
        "dancing"
    ],
    "dancings": [
        "dancing"
    ],
    "dandina": [
        "dandiner"
    ],
    "dandinaient": [
        "dandiner"
    ],
    "dandinais": [
        "dandiner"
    ],
    "dandinait": [
        "dandiner"
    ],
    "dandinant": [
        "dandiner"
    ],
    "dandine": [
        "dandiner"
    ],
    "dandinement": [
        "dandinement"
    ],
    "dandinements": [
        "dandinement"
    ],
    "dandinent": [
        "dandiner"
    ],
    "dandiner": [
        "dandiner"
    ],
    "dandinez": [
        "dandiner"
    ],
    "dandinee": [
        "dandiner"
    ],
    "dandines": [
        "dandiner"
    ],
    "dandy": [
        "dandy"
    ],
    "dandys": [
        "dandy"
    ],
    "dandysme": [
        "dandysme"
    ],
    "danger": [
        "danger"
    ],
    "dangereuse": [
        "dangereux"
    ],
    "dangereusement": [
        "dangereusement"
    ],
    "dangereuses": [
        "dangereux"
    ],
    "dangereux": [
        "dangereux"
    ],
    "dangerosite": [
        "dangerosite"
    ],
    "dangers": [
        "danger"
    ],
    "dano": [
        "dano"
    ],
    "danois": [
        "danois"
    ],
    "danoise": [
        "danois"
    ],
    "danoises": [
        "danois"
    ],
    "dans": [
        "dans"
    ],
    "dansa": [
        "danser"
    ],
    "dansai": [
        "danser"
    ],
    "dansaient": [
        "danser"
    ],
    "dansais": [
        "danser"
    ],
    "dansait": [
        "danser"
    ],
    "dansant": [
        "dansant",
        "danser"
    ],
    "dansante": [
        "dansant"
    ],
    "dansantes": [
        "dansant"
    ],
    "dansants": [
        "dansant"
    ],
    "danse": [
        "danse",
        "danser"
    ],
    "dansent": [
        "danser"
    ],
    "danser": [
        "danser"
    ],
    "dansera": [
        "danser"
    ],
    "danserai": [
        "danser"
    ],
    "danseraient": [
        "danser"
    ],
    "danserais": [
        "danser"
    ],
    "danserait": [
        "danser"
    ],
    "danseras": [
        "danser"
    ],
    "danserez": [
        "danser"
    ],
    "danseriez": [
        "danser"
    ],
    "danserions": [
        "danser"
    ],
    "danserons": [
        "danser"
    ],
    "danseront": [
        "danser"
    ],
    "danses": [
        "danse",
        "danser"
    ],
    "danseur": [
        "danseur"
    ],
    "danseurs": [
        "danseur"
    ],
    "danseuse": [
        "danseur"
    ],
    "danseuses": [
        "danseur"
    ],
    "dansez": [
        "danser"
    ],
    "dansiez": [
        "danser"
    ],
    "dansions": [
        "danser"
    ],
    "dansons": [
        "danser"
    ],
    "dansota": [
        "dansoter"
    ],
    "dansotait": [
        "dansoter"
    ],
    "dansotter": [
        "dansotter"
    ],
    "dansames": [
        "danser"
    ],
    "danserent": [
        "danser"
    ],
    "dansee": [
        "danser"
    ],
    "dantesque": [
        "dantesque"
    ],
    "dantesques": [
        "dantesque"
    ],
    "danubien": [
        "danubien"
    ],
    "danubienne": [
        "danubien"
    ],
    "danubiennes": [
        "danubien"
    ],
    "dao": [
        "dao"
    ],
    "daphne": [
        "daphne"
    ],
    "darce": [
        "darce"
    ],
    "dard": [
        "dard"
    ],
    "darda": [
        "darder"
    ],
    "dardaient": [
        "darder"
    ],
    "dardait": [
        "darder"
    ],
    "dardant": [
        "darder"
    ],
    "darde": [
        "darder"
    ],
    "dardent": [
        "darder"
    ],
    "darder": [
        "darder"
    ],
    "dardillonnaient": [
        "dardillonner"
    ],
    "dardillonne": [
        "dardillonner"
    ],
    "dards": [
        "dard"
    ],
    "dardee": [
        "darder"
    ],
    "dardees": [
        "darder"
    ],
    "dardes": [
        "darder"
    ],
    "darioles": [
        "dariole"
    ],
    "darne": [
        "darne"
    ],
    "daron": [
        "daron"
    ],
    "daronne": [
        "daron"
    ],
    "daronnes": [
        "daron"
    ],
    "darons": [
        "daron"
    ],
    "darse": [
        "darse"
    ],
    "darses": [
        "darse"
    ],
    "dartres": [
        "dartre"
    ],
    "dartreuses": [
        "dartreux"
    ],
    "dasein": [
        "dasein"
    ],
    "data": [
        "dater"
    ],
    "datable": [
        "datable"
    ],
    "datage": [
        "datage"
    ],
    "dataient": [
        "dater"
    ],
    "datait": [
        "dater"
    ],
    "datant": [
        "dater"
    ],
    "datation": [
        "datation"
    ],
    "datcha": [
        "datcha"
    ],
    "datchas": [
        "datcha"
    ],
    "date": [
        "dater",
        "date"
    ],
    "datent": [
        "dater"
    ],
    "dater": [
        "dater"
    ],
    "daterai": [
        "dater"
    ],
    "daterais": [
        "dater"
    ],
    "daterait": [
        "dater"
    ],
    "dates": [
        "dater",
        "date"
    ],
    "dateur": [
        "dateur"
    ],
    "datez": [
        "dater"
    ],
    "datif": [
        "datif"
    ],
    "datte": [
        "datte"
    ],
    "dattes": [
        "datte"
    ],
    "dattier": [
        "dattier"
    ],
    "dattiers": [
        "dattier"
    ],
    "datura": [
        "datura"
    ],
    "daturas": [
        "datura"
    ],
    "datee": [
        "dater"
    ],
    "datees": [
        "dater"
    ],
    "daubait": [
        "dauber"
    ],
    "daube": [
        "dauber",
        "daube"
    ],
    "dauber": [
        "dauber"
    ],
    "daubes": [
        "daube"
    ],
    "daubiere": [
        "daubiere"
    ],
    "dauphin": [
        "dauphin"
    ],
    "dauphinat": [
        "dauphinat"
    ],
    "dauphine": [
        "dauphin"
    ],
    "dauphines": [
        "dauphin"
    ],
    "dauphinois": [
        "dauphinois"
    ],
    "dauphins": [
        "dauphin"
    ],
    "daurade": [
        "daurade"
    ],
    "daurades": [
        "daurade"
    ],
    "davantage": [
        "davantage"
    ],
    "davier": [
        "davier"
    ],
    "daya": [
        "daya"
    ],
    "daimios": [
        "daimio"
    ],
    "dc": [
        "dc"
    ],
    "de": [
        "de"
    ],
    "deadline": [
        "deadline"
    ],
    "deal": [
        "deal"
    ],
    "dealaient": [
        "dealer"
    ],
    "dealais": [
        "dealer"
    ],
    "dealait": [
        "dealer"
    ],
    "dealant": [
        "dealer"
    ],
    "deale": [
        "dealer"
    ],
    "dealent": [
        "dealer"
    ],
    "dealer": [
        "dealer"
    ],
    "dealera": [
        "dealer"
    ],
    "dealeront": [
        "dealer"
    ],
    "dealers": [
        "dealer"
    ],
    "deales": [
        "dealer"
    ],
    "dealez": [
        "dealer"
    ],
    "deals": [
        "deal"
    ],
    "debater": [
        "debater"
    ],
    "debout": [
        "debout"
    ],
    "decca": [
        "decca"
    ],
    "deck": [
        "deck"
    ],
    "decrescendo": [
        "decrescendo"
    ],
    "dedans": [
        "dedans"
    ],
    "degre": [
        "degre"
    ],
    "degres": [
        "degre"
    ],
    "dehors": [
        "dehors"
    ],
    "delco": [
        "delco"
    ],
    "delirium": [
        "delirium"
    ],
    "delphinides": [
        "delphinide"
    ],
    "delphinium": [
        "delphinium"
    ],
    "delphiniums": [
        "delphinium"
    ],
    "delta": [
        "delta"
    ],
    "deltaplane": [
        "deltaplane"
    ],
    "deltas": [
        "delta"
    ],
    "deltoide": [
        "deltoide"
    ],
    "deltoides": [
        "deltoide"
    ],
    "dela": [
        "dela"
    ],
    "demain": [
        "demain"
    ],
    "demains": [
        "demain"
    ],
    "demanda": [
        "demander"
    ],
    "demandai": [
        "demander"
    ],
    "demandaient": [
        "demander"
    ],
    "demandais": [
        "demander"
    ],
    "demandait": [
        "demander"
    ],
    "demandant": [
        "demander"
    ],
    "demande": [
        "demander",
        "demande"
    ],
    "demandent": [
        "demander"
    ],
    "demander": [
        "demander"
    ],
    "demandera": [
        "demander"
    ],
    "demanderai": [
        "demander"
    ],
    "demanderaient": [
        "demander"
    ],
    "demanderais": [
        "demander"
    ],
    "demanderait": [
        "demander"
    ],
    "demanderas": [
        "demander"
    ],
    "demanderesse": [
        "demandeur"
    ],
    "demanderez": [
        "demander"
    ],
    "demanderiez": [
        "demander"
    ],
    "demanderons": [
        "demander"
    ],
    "demanderont": [
        "demander"
    ],
    "demandes": [
        "demander",
        "demande"
    ],
    "demandeur": [
        "demandeur"
    ],
    "demandeurs": [
        "demandeur"
    ],
    "demandeuse": [
        "demandeur"
    ],
    "demandez": [
        "demander"
    ],
    "demandiez": [
        "demander"
    ],
    "demandions": [
        "demander"
    ],
    "demandons": [
        "demander"
    ],
    "demandames": [
        "demander"
    ],
    "demandat": [
        "demander"
    ],
    "demanderent": [
        "demander"
    ],
    "demandee": [
        "demander"
    ],
    "demandees": [
        "demander"
    ],
    "demeura": [
        "demeurer"
    ],
    "demeurai": [
        "demeurer"
    ],
    "demeuraient": [
        "demeurer"
    ],
    "demeurais": [
        "demeurer"
    ],
    "demeurait": [
        "demeurer"
    ],
    "demeurant": [
        "demeurer"
    ],
    "demeurassent": [
        "demeurer"
    ],
    "demeure": [
        "demeurer",
        "demeure"
    ],
    "demeurent": [
        "demeurer"
    ],
    "demeurer": [
        "demeurer"
    ],
    "demeurera": [
        "demeurer"
    ],
    "demeurerai": [
        "demeurer"
    ],
    "demeureraient": [
        "demeurer"
    ],
    "demeurerais": [
        "demeurer"
    ],
    "demeurerait": [
        "demeurer"
    ],
    "demeureras": [
        "demeurer"
    ],
    "demeurerez": [
        "demeurer"
    ],
    "demeurerions": [
        "demeurer"
    ],
    "demeurerons": [
        "demeurer"
    ],
    "demeureront": [
        "demeurer"
    ],
    "demeures": [
        "demeurer",
        "demeure"
    ],
    "demeurez": [
        "demeurer"
    ],
    "demeuriez": [
        "demeurer"
    ],
    "demeurions": [
        "demeurer"
    ],
    "demeurons": [
        "demeurer"
    ],
    "demeurames": [
        "demeurer"
    ],
    "demeurat": [
        "demeurer"
    ],
    "demeurerent": [
        "demeurer"
    ],
    "demeuree": [
        "demeurer",
        "demeure"
    ],
    "demeurees": [
        "demeurer",
        "demeure"
    ],
    "demi": [
        "demi"
    ],
    "demie": [
        "demi"
    ],
    "demies": [
        "demi"
    ],
    "demis": [
        "demis",
        "demettre",
        "demi"
    ],
    "demoiselle": [
        "damoiseau"
    ],
    "demoiselles": [
        "damoiseau"
    ],
    "dendrite": [
        "dendrite"
    ],
    "dengue": [
        "dengue"
    ],
    "denier": [
        "denier"
    ],
    "deniers": [
        "denier"
    ],
    "denim": [
        "denim"
    ],
    "denims": [
        "denim"
    ],
    "denree": [
        "denree"
    ],
    "denrees": [
        "denree"
    ],
    "dense": [
        "dense"
    ],
    "denses": [
        "dense"
    ],
    "densifia": [
        "densifier"
    ],
    "densifie": [
        "densifier"
    ],
    "densimetre": [
        "densimetre"
    ],
    "densite": [
        "densite"
    ],
    "densites": [
        "densite"
    ],
    "dent": [
        "dent"
    ],
    "dentaire": [
        "dentaire"
    ],
    "dentaires": [
        "dentaire"
    ],
    "dental": [
        "dental"
    ],
    "dentale": [
        "dental"
    ],
    "dentales": [
        "dental"
    ],
    "dentelle": [
        "dentelle"
    ],
    "dentelles": [
        "dentelle"
    ],
    "dentelliere": [
        "dentellier",
        "dentelliere"
    ],
    "dentelure": [
        "dentelure"
    ],
    "dentelures": [
        "dentelure"
    ],
    "dentele": [
        "denteler",
        "dentele"
    ],
    "dentelee": [
        "denteler",
        "dentele"
    ],
    "dentelees": [
        "denteler",
        "dentele"
    ],
    "denteles": [
        "denteler",
        "dentele"
    ],
    "dentier": [
        "dentier"
    ],
    "dentiers": [
        "dentier"
    ],
    "dentifrice": [
        "dentifrice"
    ],
    "dentifrices": [
        "dentifrice"
    ],
    "dentiste": [
        "dentiste"
    ],
    "dentisterie": [
        "dentisterie"
    ],
    "dentistes": [
        "dentiste"
    ],
    "dentition": [
        "dentition"
    ],
    "dentitions": [
        "dentition"
    ],
    "dents": [
        "dent"
    ],
    "denture": [
        "denture"
    ],
    "dentures": [
        "denture"
    ],
    "dente": [
        "dente"
    ],
    "dentee": [
        "denter",
        "dente"
    ],
    "dentees": [
        "denter",
        "dente"
    ],
    "dentes": [
        "dente"
    ],
    "depuis": [
        "depuis"
    ],
    "der": [
        "der"
    ],
    "derby": [
        "derby"
    ],
    "derbys": [
        "derby"
    ],
    "derche": [
        "derche"
    ],
    "derches": [
        "derche"
    ],
    "derechef": [
        "derechef"
    ],
    "dermatite": [
        "dermatite"
    ],
    "dermatoglyphes": [
        "dermatoglyphe"
    ],
    "dermatologie": [
        "dermatologie"
    ],
    "dermatologique": [
        "dermatologique"
    ],
    "dermatologiques": [
        "dermatologique"
    ],
    "dermatologiste": [
        "dermatologiste"
    ],
    "dermatologue": [
        "dermatologue"
    ],
    "dermatose": [
        "dermatose"
    ],
    "dermatoses": [
        "dermatose"
    ],
    "derme": [
        "derme"
    ],
    "dermeste": [
        "dermeste"
    ],
    "dermique": [
        "dermique"
    ],
    "dermiques": [
        "dermique"
    ],
    "dermite": [
        "dermite"
    ],
    "dermites": [
        "dermite"
    ],
    "dermographie": [
        "dermographie"
    ],
    "dernier": [
        "dernier"
    ],
    "derniers": [
        "dernier"
    ],
    "derniere": [
        "dernier"
    ],
    "dernierement": [
        "dernierement"
    ],
    "dernieres": [
        "dernier"
    ],
    "derrick": [
        "derrick"
    ],
    "derricks": [
        "derrick"
    ],
    "derriere": [
        "derriere"
    ],
    "derrieres": [
        "derriere"
    ],
    "ders": [
        "der"
    ],
    "derviche": [
        "derviche"
    ],
    "derviches": [
        "derviche"
    ],
    "des": [
        "des",
        "un"
    ],
    "descamisados": [
        "descamisado"
    ],
    "descella": [
        "desceller"
    ],
    "descellant": [
        "desceller"
    ],
    "desceller": [
        "desceller"
    ],
    "descellera": [
        "desceller"
    ],
    "descellez": [
        "desceller"
    ],
    "descelle": [
        "desceller"
    ],
    "descellee": [
        "desceller"
    ],
    "descellees": [
        "desceller"
    ],
    "descelles": [
        "desceller"
    ],
    "descend": [
        "descendre"
    ],
    "descendaient": [
        "descendre"
    ],
    "descendais": [
        "descendre"
    ],
    "descendait": [
        "descendre"
    ],
    "descendance": [
        "descendance"
    ],
    "descendances": [
        "descendance"
    ],
    "descendant": [
        "descendant",
        "descendre"
    ],
    "descendante": [
        "descendant"
    ],
    "descendantes": [
        "descendant"
    ],
    "descendants": [
        "descendant"
    ],
    "descende": [
        "descendre"
    ],
    "descendent": [
        "descendre"
    ],
    "descendes": [
        "descendre"
    ],
    "descendeur": [
        "descendeur"
    ],
    "descendeurs": [
        "descendeur"
    ],
    "descendez": [
        "descendre"
    ],
    "descendiez": [
        "descendre"
    ],
    "descendions": [
        "descendre"
    ],
    "descendirent": [
        "descendre"
    ],
    "descendis": [
        "descendre"
    ],
    "descendit": [
        "descendre"
    ],
    "descendons": [
        "descendre"
    ],
    "descendra": [
        "descendre"
    ],
    "descendrai": [
        "descendre"
    ],
    "descendraient": [
        "descendre"
    ],
    "descendrais": [
        "descendre"
    ],
    "descendrait": [
        "descendre"
    ],
    "descendras": [
        "descendre"
    ],
    "descendre": [
        "descendre"
    ],
    "descendrez": [
        "descendre"
    ],
    "descendriez": [
        "descendre"
    ],
    "descendrions": [
        "descendre"
    ],
    "descendrons": [
        "descendre"
    ],
    "descendront": [
        "descendre"
    ],
    "descends": [
        "descendre",
        "descend"
    ],
    "descendu": [
        "descendre"
    ],
    "descendue": [
        "descendre"
    ],
    "descendues": [
        "descendre"
    ],
    "descendus": [
        "descendre"
    ],
    "descendimes": [
        "descendre"
    ],
    "descenseur": [
        "descenseur"
    ],
    "descente": [
        "descente"
    ],
    "descentes": [
        "descente"
    ],
    "descriptible": [
        "descriptible"
    ],
    "descriptibles": [
        "descriptible"
    ],
    "descriptif": [
        "descriptif"
    ],
    "descriptifs": [
        "descriptif"
    ],
    "description": [
        "description"
    ],
    "descriptions": [
        "description"
    ],
    "descriptive": [
        "descriptif"
    ],
    "descriptives": [
        "descriptif"
    ],
    "desdites": [
        "desdites"
    ],
    "desdits": [
        "desdits"
    ],
    "desiderata": [
        "desiderata"
    ],
    "design": [
        "design"
    ],
    "designer": [
        "designer"
    ],
    "designers": [
        "designer"
    ],
    "designs": [
        "design"
    ],
    "desk": [
        "desk"
    ],
    "desperado": [
        "desperado"
    ],
    "desperados": [
        "desperado"
    ],
    "despote": [
        "despote"
    ],
    "despotes": [
        "despote"
    ],
    "despotique": [
        "despotique"
    ],
    "despotiques": [
        "despotique"
    ],
    "despotisme": [
        "despotisme"
    ],
    "desquamante": [
        "desquamant"
    ],
    "desquamation": [
        "desquamation"
    ],
    "desquame": [
        "desquamer"
    ],
    "desquelles": [
        "desquelles"
    ],
    "desquels": [
        "desquels"
    ],
    "dessaisi": [
        "dessaisir"
    ],
    "dessaisir": [
        "dessaisir"
    ],
    "dessaisis": [
        "dessaisir"
    ],
    "dessaisissais": [
        "dessaisir"
    ],
    "dessaisissement": [
        "dessaisissement"
    ],
    "dessaisissent": [
        "dessaisir"
    ],
    "dessaisit": [
        "dessaisir"
    ],
    "dessalaient": [
        "dessaler"
    ],
    "dessalait": [
        "dessaler"
    ],
    "dessalant": [
        "dessaler"
    ],
    "dessale": [
        "dessaler",
        "dessale"
    ],
    "dessaler": [
        "dessaler"
    ],
    "dessalee": [
        "dessale"
    ],
    "dessalees": [
        "dessale"
    ],
    "dessales": [
        "dessale"
    ],
    "dessaoulais": [
        "dessaouler"
    ],
    "dessaoule": [
        "dessaouler"
    ],
    "dessaoulent": [
        "dessaouler"
    ],
    "dessaouler": [
        "dessaouler"
    ],
    "dessaoulee": [
        "dessaouler"
    ],
    "dessaoules": [
        "dessaouler"
    ],
    "dessape": [
        "dessaper"
    ],
    "dessaper": [
        "dessaper"
    ],
    "dessein": [
        "dessein"
    ],
    "desseins": [
        "dessein"
    ],
    "desselle": [
        "desseller"
    ],
    "desseller": [
        "desseller"
    ],
    "dessellez": [
        "desseller"
    ],
    "dessellees": [
        "desseller"
    ],
    "desselles": [
        "desseller"
    ],
    "desserra": [
        "desserrer"
    ],
    "desserrage": [
        "desserrage"
    ],
    "desserrai": [
        "desserrer"
    ],
    "desserraient": [
        "desserrer"
    ],
    "desserrais": [
        "desserrer"
    ],
    "desserrait": [
        "desserrer"
    ],
    "desserrant": [
        "desserrer"
    ],
    "desserre": [
        "desserre",
        "desserrer"
    ],
    "desserrent": [
        "desserrer"
    ],
    "desserrer": [
        "desserrer"
    ],
    "desserrera": [
        "desserrer"
    ],
    "desserreraient": [
        "desserrer"
    ],
    "desserrerait": [
        "desserrer"
    ],
    "desserrez": [
        "desserrer"
    ],
    "desserrons": [
        "desserrer"
    ],
    "desserrat": [
        "desserrer"
    ],
    "desserrerent": [
        "desserrer"
    ],
    "desserree": [
        "desserrer"
    ],
    "desserrees": [
        "desserrer"
    ],
    "desserres": [
        "desserrer"
    ],
    "dessers": [
        "desservir"
    ],
    "dessert": [
        "desservir",
        "dessert"
    ],
    "desserte": [
        "desserte"
    ],
    "dessertes": [
        "desserte"
    ],
    "dessertie": [
        "dessertir"
    ],
    "dessertir": [
        "dessertir"
    ],
    "desserts": [
        "dessert"
    ],
    "desservaient": [
        "desservir"
    ],
    "desservait": [
        "desservir"
    ],
    "desservant": [
        "desservant",
        "desservir"
    ],
    "desserve": [
        "desservir"
    ],
    "desservent": [
        "desservir"
    ],
    "desservi": [
        "desservir"
    ],
    "desservie": [
        "desservir"
    ],
    "desservies": [
        "desservir"
    ],
    "desservir": [
        "desservir"
    ],
    "desservira": [
        "desservir"
    ],
    "desservirait": [
        "desservir"
    ],
    "desserviront": [
        "desservir"
    ],
    "desservis": [
        "desservir"
    ],
    "desservit": [
        "desservir"
    ],
    "dessiccation": [
        "dessiccation"
    ],
    "dessille": [
        "dessiller"
    ],
    "dessiller": [
        "dessiller"
    ],
    "dessilleront": [
        "dessiller"
    ],
    "dessilles": [
        "dessiller"
    ],
    "dessin": [
        "dessin"
    ],
    "dessina": [
        "dessiner"
    ],
    "dessinai": [
        "dessiner"
    ],
    "dessinaient": [
        "dessiner"
    ],
    "dessinais": [
        "dessiner"
    ],
    "dessinait": [
        "dessiner"
    ],
    "dessinant": [
        "dessiner"
    ],
    "dessinateur": [
        "dessinateur"
    ],
    "dessinateurs": [
        "dessinateur"
    ],
    "dessinatrice": [
        "dessinateur"
    ],
    "dessine": [
        "dessiner",
        "dessine"
    ],
    "dessinent": [
        "dessiner"
    ],
    "dessiner": [
        "dessiner"
    ],
    "dessinera": [
        "dessiner"
    ],
    "dessinerai": [
        "dessiner"
    ],
    "dessineraient": [
        "dessiner"
    ],
    "dessinerais": [
        "dessiner"
    ],
    "dessinerait": [
        "dessiner"
    ],
    "dessinerez": [
        "dessiner"
    ],
    "dessineront": [
        "dessiner"
    ],
    "dessines": [
        "dessiner",
        "dessine"
    ],
    "dessinez": [
        "dessiner"
    ],
    "dessiniez": [
        "dessiner"
    ],
    "dessinions": [
        "dessiner"
    ],
    "dessins": [
        "dessin"
    ],
    "dessinat": [
        "dessiner"
    ],
    "dessinerent": [
        "dessiner"
    ],
    "dessinee": [
        "dessiner"
    ],
    "dessinees": [
        "dessiner"
    ],
    "dessoucha": [
        "dessoucher"
    ],
    "dessouchee": [
        "dessoucher"
    ],
    "dessouda": [
        "dessouder"
    ],
    "dessouder": [
        "dessouder"
    ],
    "dessoude": [
        "dessouder"
    ],
    "dessoudee": [
        "dessouder"
    ],
    "dessoudees": [
        "dessouder"
    ],
    "dessoulait": [
        "dessouler"
    ],
    "dessouler": [
        "dessouler"
    ],
    "dessoule": [
        "dessouler"
    ],
    "dessous": [
        "dessous"
    ],
    "dessoula": [
        "dessouler"
    ],
    "dessoulent": [
        "dessouler"
    ],
    "dessoules": [
        "dessouler"
    ],
    "dessoulez": [
        "dessouler"
    ],
    "dessoulee": [
        "dessouler"
    ],
    "dessuintee": [
        "dessuinter"
    ],
    "dessus": [
        "dessus"
    ],
    "desseche": [
        "dessecher"
    ],
    "dessechement": [
        "dessechement"
    ],
    "dessechent": [
        "dessecher"
    ],
    "dessecha": [
        "dessecher"
    ],
    "dessechaient": [
        "dessecher"
    ],
    "dessechais": [
        "dessecher"
    ],
    "dessechait": [
        "dessecher"
    ],
    "dessechant": [
        "dessecher",
        "dessechant"
    ],
    "dessechante": [
        "dessechant"
    ],
    "dessecher": [
        "dessecher"
    ],
    "dessecherait": [
        "dessecher"
    ],
    "dessecheront": [
        "dessecher"
    ],
    "dessechez": [
        "dessecher"
    ],
    "dessecherent": [
        "dessecher"
    ],
    "dessechee": [
        "dessecher"
    ],
    "dessechees": [
        "dessecher"
    ],
    "desseches": [
        "dessecher"
    ],
    "destin": [
        "destin"
    ],
    "destina": [
        "destiner"
    ],
    "destinaient": [
        "destiner"
    ],
    "destinais": [
        "destiner"
    ],
    "destinait": [
        "destiner"
    ],
    "destinant": [
        "destiner"
    ],
    "destinataire": [
        "destinataire"
    ],
    "destinataires": [
        "destinataire"
    ],
    "destination": [
        "destination"
    ],
    "destinations": [
        "destination"
    ],
    "destinatrice": [
        "destinateur"
    ],
    "destine": [
        "destine",
        "destiner"
    ],
    "destinent": [
        "destiner"
    ],
    "destiner": [
        "destiner"
    ],
    "destines": [
        "destine",
        "destiner"
    ],
    "destinez": [
        "destiner"
    ],
    "destiniez": [
        "destiner"
    ],
    "destins": [
        "destin"
    ],
    "destinee": [
        "destinee",
        "destine",
        "destiner"
    ],
    "destinees": [
        "destinee",
        "destine",
        "destiner"
    ],
    "destitue": [
        "destituer"
    ],
    "destituer": [
        "destituer"
    ],
    "destitueront": [
        "destituer"
    ],
    "destituez": [
        "destituer"
    ],
    "destitution": [
        "destitution"
    ],
    "destituee": [
        "destituer"
    ],
    "destrier": [
        "destrier"
    ],
    "destriers": [
        "destrier"
    ],
    "destroy": [
        "destroy"
    ],
    "destroyer": [
        "destroyer"
    ],
    "destroyers": [
        "destroyer"
    ],
    "destructeur": [
        "destructeur"
    ],
    "destructeurs": [
        "destructeur"
    ],
    "destructible": [
        "destructible"
    ],
    "destructif": [
        "destructif"
    ],
    "destructifs": [
        "destructif"
    ],
    "destruction": [
        "destruction"
    ],
    "destructions": [
        "destruction"
    ],
    "destructive": [
        "destructif"
    ],
    "destructrice": [
        "destructeur"
    ],
    "destructrices": [
        "destructeur"
    ],
    "dette": [
        "dette"
    ],
    "dettes": [
        "dette"
    ],
    "deuche": [
        "deuche"
    ],
    "deuil": [
        "deuil"
    ],
    "deuils": [
        "deuil"
    ],
    "deusio": [
        "deusio"
    ],
    "deuterium": [
        "deuterium"
    ],
    "deuteronome": [
        "deuteronome"
    ],
    "deux": [
        "deux"
    ],
    "deuxieme": [
        "deuxieme"
    ],
    "deuxiemement": [
        "deuxiemement"
    ],
    "deuxiemes": [
        "deuxieme"
    ],
    "deuzio": [
        "deuzio"
    ],
    "devaient": [
        "devoir"
    ],
    "devais": [
        "devoir"
    ],
    "devait": [
        "devoir"
    ],
    "devance": [
        "devancer"
    ],
    "devancent": [
        "devancer"
    ],
    "devancer": [
        "devancer"
    ],
    "devancerait": [
        "devancer"
    ],
    "devancerez": [
        "devancer"
    ],
    "devancez": [
        "devancer"
    ],
    "devanciers": [
        "devancier"
    ],
    "devancerent": [
        "devancer"
    ],
    "devancee": [
        "devancer"
    ],
    "devances": [
        "devancer"
    ],
    "devant": [
        "devoir",
        "devant"
    ],
    "devants": [
        "devant"
    ],
    "devanture": [
        "devanture"
    ],
    "devantures": [
        "devanture"
    ],
    "devanca": [
        "devancer"
    ],
    "devancaient": [
        "devancer"
    ],
    "devancais": [
        "devancer"
    ],
    "devancait": [
        "devancer"
    ],
    "devancant": [
        "devancer"
    ],
    "devancons": [
        "devancer"
    ],
    "devenaient": [
        "devenir"
    ],
    "devenais": [
        "devenir"
    ],
    "devenait": [
        "devenir"
    ],
    "devenant": [
        "devenir"
    ],
    "devenez": [
        "devenir"
    ],
    "deveniez": [
        "devenir"
    ],
    "devenions": [
        "devenir"
    ],
    "devenir": [
        "devenir"
    ],
    "devenons": [
        "devenir"
    ],
    "devenu": [
        "devenir"
    ],
    "devenue": [
        "devenir"
    ],
    "devenues": [
        "devenir"
    ],
    "devenus": [
        "devenir"
    ],
    "devers": [
        "devers"
    ],
    "devez": [
        "devoir"
    ],
    "deviendra": [
        "devenir"
    ],
    "deviendrai": [
        "devenir"
    ],
    "deviendraient": [
        "devenir"
    ],
    "deviendrais": [
        "devenir"
    ],
    "deviendrait": [
        "devenir"
    ],
    "deviendras": [
        "devenir"
    ],
    "deviendrez": [
        "devenir"
    ],
    "deviendriez": [
        "devenir"
    ],
    "deviendrions": [
        "devenir"
    ],
    "deviendrons": [
        "devenir"
    ],
    "deviendront": [
        "devenir"
    ],
    "devienne": [
        "devenir"
    ],
    "deviennent": [
        "devenir"
    ],
    "deviennes": [
        "devenir"
    ],
    "deviens": [
        "devenir"
    ],
    "devient": [
        "devier",
        "devenir"
    ],
    "deviez": [
        "devoir",
        "devier"
    ],
    "devin": [
        "devin"
    ],
    "devina": [
        "deviner"
    ],
    "devinai": [
        "deviner"
    ],
    "devinaient": [
        "deviner"
    ],
    "devinais": [
        "deviner"
    ],
    "devinait": [
        "deviner"
    ],
    "devinant": [
        "deviner"
    ],
    "devine": [
        "deviner"
    ],
    "devinent": [
        "deviner"
    ],
    "deviner": [
        "deviner"
    ],
    "devinera": [
        "deviner"
    ],
    "devinerai": [
        "deviner"
    ],
    "devineraient": [
        "deviner"
    ],
    "devinerais": [
        "deviner"
    ],
    "devinerait": [
        "deviner"
    ],
    "devineras": [
        "deviner"
    ],
    "devineresse": [
        "devineur"
    ],
    "devineresses": [
        "devineur"
    ],
    "devinerez": [
        "deviner"
    ],
    "devineriez": [
        "deviner"
    ],
    "devineront": [
        "deviner"
    ],
    "devines": [
        "deviner"
    ],
    "devinette": [
        "devinette"
    ],
    "devinettes": [
        "devinette"
    ],
    "devineur": [
        "devineur"
    ],
    "devinez": [
        "deviner"
    ],
    "devinions": [
        "deviner"
    ],
    "devinons": [
        "deviner"
    ],
    "devinrent": [
        "devenir"
    ],
    "devins": [
        "devin",
        "devenir"
    ],
    "devinsse": [
        "devenir"
    ],
    "devinssent": [
        "devenir"
    ],
    "devinssiez": [
        "devenir"
    ],
    "devint": [
        "devenir"
    ],
    "devinames": [
        "deviner"
    ],
    "devinat": [
        "deviner"
    ],
    "devinerent": [
        "deviner"
    ],
    "devinee": [
        "deviner"
    ],
    "devinees": [
        "deviner"
    ],
    "devions": [
        "devoir",
        "devier"
    ],
    "devis": [
        "devis"
    ],
    "devisaient": [
        "deviser"
    ],
    "devisais": [
        "deviser"
    ],
    "devisait": [
        "deviser"
    ],
    "devisant": [
        "deviser"
    ],
    "devise": [
        "deviser",
        "devise"
    ],
    "devisent": [
        "deviser"
    ],
    "deviser": [
        "deviser"
    ],
    "devises": [
        "devise"
    ],
    "devisions": [
        "deviser"
    ],
    "deviserent": [
        "deviser"
    ],
    "devoir": [
        "devoir"
    ],
    "devoirs": [
        "devoir"
    ],
    "devon": [
        "devon"
    ],
    "devons": [
        "devoir",
        "devon"
    ],
    "devra": [
        "devoir"
    ],
    "devrai": [
        "devoir"
    ],
    "devraient": [
        "devoir"
    ],
    "devrais": [
        "devoir"
    ],
    "devrait": [
        "devoir"
    ],
    "devras": [
        "devoir"
    ],
    "devrez": [
        "devoir"
    ],
    "devriez": [
        "devoir"
    ],
    "devrions": [
        "devoir"
    ],
    "devrons": [
        "devoir"
    ],
    "devront": [
        "devoir"
    ],
    "devinmes": [
        "devenir"
    ],
    "dexamethasone": [
        "dexamethasone"
    ],
    "dextre": [
        "dextre"
    ],
    "dextrement": [
        "dextrement"
    ],
    "dextrose": [
        "dextrose"
    ],
    "dexterite": [
        "dexterite"
    ],
    "dey": [
        "dey"
    ],
    "deca": [
        "deca"
    ],
    "dharma": [
        "dharma"
    ],
    "dhole": [
        "dhole"
    ],
    "dia": [
        "dia"
    ],
    "diable": [
        "diable"
    ],
    "diablement": [
        "diablement"
    ],
    "diablerie": [
        "diablerie"
    ],
    "diableries": [
        "diablerie"
    ],
    "diables": [
        "diable"
    ],
    "diablesse": [
        "diablesse"
    ],
    "diablesses": [
        "diablesse"
    ],
    "diablotin": [
        "diablotin"
    ],
    "diablotins": [
        "diablotin"
    ],
    "diabolique": [
        "diabolique"
    ],
    "diaboliquement": [
        "diaboliquement"
    ],
    "diaboliques": [
        "diabolique"
    ],
    "diabolisent": [
        "diaboliser"
    ],
    "diaboliser": [
        "diaboliser"
    ],
    "diabolisme": [
        "diabolisme"
    ],
    "diabolise": [
        "diaboliser"
    ],
    "diabolisee": [
        "diaboliser"
    ],
    "diabolo": [
        "diabolo"
    ],
    "diabolos": [
        "diabolo"
    ],
    "diabete": [
        "diabete"
    ],
    "diabetes": [
        "diabete"
    ],
    "diabetique": [
        "diabetique"
    ],
    "diabetiques": [
        "diabetique"
    ],
    "diachronique": [
        "diachronique"
    ],
    "diaclase": [
        "diaclase"
    ],
    "diaconesse": [
        "diaconesse"
    ],
    "diaconesses": [
        "diaconesse"
    ],
    "diaconie": [
        "diaconie"
    ],
    "diacre": [
        "diacre"
    ],
    "diacres": [
        "diacre"
    ],
    "diacritique": [
        "diacritique"
    ],
    "diacetylmorphine": [
        "diacetylmorphine"
    ],
    "diademe": [
        "diademe"
    ],
    "diademes": [
        "diademe"
    ],
    "diagnose": [
        "diagnose"
    ],
    "diagnostic": [
        "diagnostic"
    ],
    "diagnostics": [
        "diagnostic"
    ],
    "diagnostiqua": [
        "diagnostiquer"
    ],
    "diagnostiquait": [
        "diagnostiquer"
    ],
    "diagnostiquant": [
        "diagnostiquer"
    ],
    "diagnostique": [
        "diagnostiquer",
        "diagnostique"
    ],
    "diagnostiquer": [
        "diagnostiquer"
    ],
    "diagnostiques": [
        "diagnostiquer",
        "diagnostique"
    ],
    "diagnostiqueur": [
        "diagnostiqueur"
    ],
    "diagnostiquez": [
        "diagnostiquer"
    ],
    "diagnostiquerent": [
        "diagnostiquer"
    ],
    "diagonal": [
        "diagonal"
    ],
    "diagonale": [
        "diagonale",
        "diagonal"
    ],
    "diagonalement": [
        "diagonalement"
    ],
    "diagonales": [
        "diagonale",
        "diagonal"
    ],
    "diagonaux": [
        "diagonal"
    ],
    "diagramme": [
        "diagramme"
    ],
    "diagrammes": [
        "diagramme"
    ],
    "dialectal": [
        "dialectal"
    ],
    "dialectale": [
        "dialectal"
    ],
    "dialecte": [
        "dialecte"
    ],
    "dialectes": [
        "dialecte"
    ],
    "dialecticien": [
        "dialecticien"
    ],
    "dialecticienne": [
        "dialecticien"
    ],
    "dialecticiens": [
        "dialecticien"
    ],
    "dialectique": [
        "dialectique"
    ],
    "dialectiques": [
        "dialectique"
    ],
    "dialogique": [
        "dialogique"
    ],
    "dialoguai": [
        "dialoguer"
    ],
    "dialoguaient": [
        "dialoguer"
    ],
    "dialoguait": [
        "dialoguer"
    ],
    "dialoguant": [
        "dialoguer"
    ],
    "dialogue": [
        "dialoguer",
        "dialogue"
    ],
    "dialoguent": [
        "dialoguer"
    ],
    "dialoguer": [
        "dialoguer"
    ],
    "dialoguera": [
        "dialoguer"
    ],
    "dialogues": [
        "dialogue"
    ],
    "dialoguez": [
        "dialoguer"
    ],
    "dialoguiste": [
        "dialoguiste"
    ],
    "dialoguistes": [
        "dialoguiste"
    ],
    "dialoguons": [
        "dialoguer"
    ],
    "dialoguat": [
        "dialoguer"
    ],
    "dialoguee": [
        "dialoguer"
    ],
    "dialoguees": [
        "dialoguer"
    ],
    "dialyse": [
        "dialyser",
        "dialyse"
    ],
    "dialyser": [
        "dialyser"
    ],
    "dialyses": [
        "dialysis",
        "dialyse"
    ],
    "dialysee": [
        "dialyser"
    ],
    "diam": [
        "diam"
    ],
    "diamant": [
        "diamant"
    ],
    "diamantaire": [
        "diamantaire"
    ],
    "diamantaires": [
        "diamantaire"
    ],
    "diamante": [
        "diamanter",
        "diamante"
    ],
    "diamantifere": [
        "diamantifere"
    ],
    "diamantin": [
        "diamantin"
    ],
    "diamantine": [
        "diamantin"
    ],
    "diamantines": [
        "diamantin"
    ],
    "diamantins": [
        "diamantin"
    ],
    "diamants": [
        "diamant"
    ],
    "diamantee": [
        "diamanter"
    ],
    "diamantes": [
        "diamante"
    ],
    "diamine": [
        "diamine"
    ],
    "diamorphine": [
        "diamorphine"
    ],
    "diams": [
        "diam"
    ],
    "diametre": [
        "diametre"
    ],
    "diametralement": [
        "diametralement"
    ],
    "diane": [
        "diane"
    ],
    "dianes": [
        "diane"
    ],
    "diantre": [
        "diantre"
    ],
    "diapason": [
        "diapason"
    ],
    "diapasons": [
        "diapason"
    ],
    "diaphane": [
        "diaphane"
    ],
    "diaphanes": [
        "diaphane"
    ],
    "diaphoretique": [
        "diaphoretique"
    ],
    "diaphragma": [
        "diaphragmer"
    ],
    "diaphragmatique": [
        "diaphragmatique"
    ],
    "diaphragme": [
        "diaphragme"
    ],
    "diaphragmes": [
        "diaphragme"
    ],
    "diapo": [
        "diapo"
    ],
    "diaporama": [
        "diaporama"
    ],
    "diaporamas": [
        "diaporama"
    ],
    "diapos": [
        "diapo"
    ],
    "diapositifs": [
        "diapositif"
    ],
    "diapositive": [
        "diapositif",
        "diapositive"
    ],
    "diapositives": [
        "diapositif",
        "diapositive"
    ],
    "diaprures": [
        "diaprure"
    ],
    "diapre": [
        "diapre"
    ],
    "diapree": [
        "diaprer",
        "diapre"
    ],
    "diaprees": [
        "diaprer"
    ],
    "diapres": [
        "diaprer",
        "diapre"
    ],
    "diarrhee": [
        "diarrhee"
    ],
    "diarrhees": [
        "diarrhee"
    ],
    "diarrheique": [
        "diarrheique"
    ],
    "diaspora": [
        "diaspora"
    ],
    "diasporas": [
        "diaspora"
    ],
    "diastole": [
        "diastole"
    ],
    "diastoles": [
        "diastole"
    ],
    "diastolique": [
        "diastolique"
    ],
    "diastoliques": [
        "diastolique"
    ],
    "diatomee": [
        "diatomee"
    ],
    "diatomees": [
        "diatomee"
    ],
    "diatonique": [
        "diatonique"
    ],
    "diatribe": [
        "diatribe"
    ],
    "diatribes": [
        "diatribe"
    ],
    "dicasteres": [
        "dicastere"
    ],
    "dichotomie": [
        "dichotomie"
    ],
    "dichroique": [
        "dichroique"
    ],
    "dichroisme": [
        "dichroisme"
    ],
    "dicible": [
        "dicible"
    ],
    "dico": [
        "dico"
    ],
    "dicos": [
        "dico"
    ],
    "dicta": [
        "dicter",
        "dictum"
    ],
    "dictai": [
        "dicter"
    ],
    "dictaient": [
        "dicter"
    ],
    "dictais": [
        "dicter"
    ],
    "dictait": [
        "dicter"
    ],
    "dictames": [
        "dictame"
    ],
    "dictant": [
        "dicter"
    ],
    "dictaphone": [
        "dictaphone"
    ],
    "dictaphones": [
        "dictaphone"
    ],
    "dictateur": [
        "dictateur"
    ],
    "dictateurs": [
        "dictateur"
    ],
    "dictatorial": [
        "dictatorial"
    ],
    "dictatoriale": [
        "dictatorial"
    ],
    "dictatoriales": [
        "dictatorial"
    ],
    "dictatoriaux": [
        "dictatorial"
    ],
    "dictatrice": [
        "dictateur"
    ],
    "dictats": [
        "dictat"
    ],
    "dictature": [
        "dictature"
    ],
    "dictatures": [
        "dictature"
    ],
    "dicte": [
        "dicter"
    ],
    "dictent": [
        "dicter"
    ],
    "dicter": [
        "dicter"
    ],
    "dictera": [
        "dicter"
    ],
    "dicterai": [
        "dicter"
    ],
    "dicterez": [
        "dicter"
    ],
    "dictes": [
        "dicter"
    ],
    "dictez": [
        "dicter"
    ],
    "dictiez": [
        "dicter"
    ],
    "diction": [
        "diction"
    ],
    "dictionnaire": [
        "dictionnaire"
    ],
    "dictionnaires": [
        "dictionnaire"
    ],
    "dicton": [
        "dicton"
    ],
    "dictons": [
        "dicter",
        "dicton"
    ],
    "dictat": [
        "dicter"
    ],
    "dicterent": [
        "dicter"
    ],
    "dictee": [
        "dictee",
        "dicter"
    ],
    "dictees": [
        "dictee",
        "dicter"
    ],
    "didactique": [
        "didactique"
    ],
    "didactiquement": [
        "didactiquement"
    ],
    "didactiques": [
        "didactique"
    ],
    "die": [
        "die"
    ],
    "dieffenbachia": [
        "dieffenbachia"
    ],
    "diem": [
        "diem"
    ],
    "dieppoise": [
        "dieppois"
    ],
    "dieppoises": [
        "dieppois"
    ],
    "diesel": [
        "diesel"
    ],
    "diesels": [
        "diesel"
    ],
    "dieu": [
        "dieu"
    ],
    "dieux": [
        "dieu"
    ],
    "diffamait": [
        "diffamer"
    ],
    "diffamant": [
        "diffamer"
    ],
    "diffamateur": [
        "diffamateur"
    ],
    "diffamateurs": [
        "diffamateur"
    ],
    "diffamation": [
        "diffamation"
    ],
    "diffamations": [
        "diffamation"
    ],
    "diffamatoire": [
        "diffamatoire"
    ],
    "diffamatoires": [
        "diffamatoire"
    ],
    "diffamatrice": [
        "diffamateur"
    ],
    "diffame": [
        "diffamer",
        "diffame"
    ],
    "diffament": [
        "diffamer"
    ],
    "diffamer": [
        "diffamer"
    ],
    "diffamee": [
        "diffamer",
        "diffame"
    ],
    "diffamees": [
        "diffamer"
    ],
    "diffames": [
        "diffamer",
        "diffame"
    ],
    "difficile": [
        "difficile"
    ],
    "difficilement": [
        "difficilement"
    ],
    "difficiles": [
        "difficile"
    ],
    "difficultueux": [
        "difficultueux"
    ],
    "difficulte": [
        "difficulte"
    ],
    "difficultes": [
        "difficulte"
    ],
    "difforme": [
        "difforme",
        "difformer"
    ],
    "difformes": [
        "difforme"
    ],
    "difformite": [
        "difformite"
    ],
    "difformites": [
        "difformite"
    ],
    "diffractent": [
        "diffracter"
    ],
    "diffraction": [
        "diffraction"
    ],
    "diffractee": [
        "diffracter"
    ],
    "diffus": [
        "diffus"
    ],
    "diffusa": [
        "diffuser"
    ],
    "diffusaient": [
        "diffuser"
    ],
    "diffusais": [
        "diffuser"
    ],
    "diffusait": [
        "diffuser"
    ],
    "diffusant": [
        "diffusant",
        "diffuser"
    ],
    "diffuse": [
        "diffus",
        "diffuser"
    ],
    "diffusent": [
        "diffuser"
    ],
    "diffuser": [
        "diffuser"
    ],
    "diffusera": [
        "diffuser"
    ],
    "diffuserai": [
        "diffuser"
    ],
    "diffuseraient": [
        "diffuser"
    ],
    "diffuserais": [
        "diffuser"
    ],
    "diffuserait": [
        "diffuser"
    ],
    "diffuserions": [
        "diffuser"
    ],
    "diffuserons": [
        "diffuser"
    ],
    "diffuseront": [
        "diffuser"
    ],
    "diffuses": [
        "diffus",
        "diffuse",
        "diffuser"
    ],
    "diffuseur": [
        "diffuseur"
    ],
    "diffuseurs": [
        "diffuseur"
    ],
    "diffusez": [
        "diffuser"
    ],
    "diffusion": [
        "diffusion"
    ],
    "diffusions": [
        "diffusion",
        "diffuser"
    ],
    "diffusons": [
        "diffuser"
    ],
    "diffuserent": [
        "diffuser"
    ],
    "diffusee": [
        "diffuser"
    ],
    "diffusees": [
        "diffuser"
    ],
    "differe": [
        "differe",
        "differer"
    ],
    "different": [
        "different",
        "differer"
    ],
    "differa": [
        "differer"
    ],
    "differaient": [
        "differer"
    ],
    "differais": [
        "differer"
    ],
    "differait": [
        "differer"
    ],
    "differant": [
        "differer"
    ],
    "differemment": [
        "differemment"
    ],
    "difference": [
        "difference"
    ],
    "differences": [
        "difference"
    ],
    "differenciables": [
        "differenciable"
    ],
    "differenciaient": [
        "differencier"
    ],
    "differenciais": [
        "differencier"
    ],
    "differenciait": [
        "differencier"
    ],
    "differenciant": [
        "differencier"
    ],
    "differenciation": [
        "differenciation"
    ],
    "differenciations": [
        "differenciation"
    ],
    "differencie": [
        "differencie",
        "differencier"
    ],
    "differencient": [
        "differencier"
    ],
    "differencier": [
        "differencier"
    ],
    "differenciera": [
        "differencier"
    ],
    "differencierez": [
        "differencier"
    ],
    "differencieront": [
        "differencier"
    ],
    "differenciez": [
        "differencier"
    ],
    "differenciee": [
        "differencie"
    ],
    "differenciees": [
        "differencie",
        "differencier"
    ],
    "differencies": [
        "differencier"
    ],
    "differend": [
        "differend"
    ],
    "differends": [
        "differend"
    ],
    "differente": [
        "different"
    ],
    "differentes": [
        "different"
    ],
    "differentie": [
        "differentier"
    ],
    "differentiel": [
        "differentiel"
    ],
    "differentielle": [
        "differentiel"
    ],
    "differentielles": [
        "differentiel"
    ],
    "differents": [
        "different",
        "differents"
    ],
    "differer": [
        "differer"
    ],
    "differera": [
        "differer"
    ],
    "differerais": [
        "differer"
    ],
    "differerait": [
        "differer"
    ],
    "differeront": [
        "differer"
    ],
    "differez": [
        "differer"
    ],
    "differions": [
        "differer"
    ],
    "differons": [
        "differer"
    ],
    "differat": [
        "differer"
    ],
    "differerent": [
        "differer"
    ],
    "differee": [
        "differe",
        "differer"
    ],
    "differees": [
        "differe",
        "differer"
    ],
    "differes": [
        "differe"
    ],
    "difracter": [
        "difracter"
    ],
    "dig": [
        "dig"
    ],
    "digest": [
        "digest"
    ],
    "digeste": [
        "digeste"
    ],
    "digestibles": [
        "digestible"
    ],
    "digestif": [
        "digestif"
    ],
    "digestifs": [
        "digestif"
    ],
    "digestion": [
        "digestion"
    ],
    "digestions": [
        "digestion"
    ],
    "digestive": [
        "digestif"
    ],
    "digestives": [
        "digestif",
        "digestive"
    ],
    "digests": [
        "digest"
    ],
    "digicode": [
        "digicode"
    ],
    "digit": [
        "digit"
    ],
    "digital": [
        "digital"
    ],
    "digitale": [
        "digitale",
        "digital"
    ],
    "digitales": [
        "digitale",
        "digital"
    ],
    "digitaline": [
        "digitaline"
    ],
    "digitaliseur": [
        "digitaliseur"
    ],
    "digitalisee": [
        "digitaliser"
    ],
    "digitalisees": [
        "digitaliser"
    ],
    "digitaux": [
        "digital"
    ],
    "digitee": [
        "digite"
    ],
    "digne": [
        "digne"
    ],
    "dignement": [
        "dignement"
    ],
    "dignes": [
        "digne"
    ],
    "dignitaire": [
        "dignitaire"
    ],
    "dignitaires": [
        "dignitaire"
    ],
    "dignite": [
        "dignite"
    ],
    "dignites": [
        "dignite"
    ],
    "digresse": [
        "digresser"
    ],
    "digression": [
        "digression"
    ],
    "digressions": [
        "digression"
    ],
    "digue": [
        "digue"
    ],
    "digues": [
        "digue"
    ],
    "digere": [
        "digerer"
    ],
    "digerent": [
        "digerer"
    ],
    "digera": [
        "digerer"
    ],
    "digerai": [
        "digerer"
    ],
    "digeraient": [
        "digerer"
    ],
    "digerait": [
        "digerer"
    ],
    "digerant": [
        "digerer"
    ],
    "digerer": [
        "digerer"
    ],
    "digerera": [
        "digerer"
    ],
    "digererait": [
        "digerer"
    ],
    "digerons": [
        "digerer"
    ],
    "digerat": [
        "digerer"
    ],
    "digeree": [
        "digerer"
    ],
    "digerees": [
        "digerer"
    ],
    "digeres": [
        "digerer"
    ],
    "dijonnais": [
        "dijonnais"
    ],
    "diktat": [
        "diktat"
    ],
    "diktats": [
        "diktat"
    ],
    "dilapida": [
        "dilapider"
    ],
    "dilapidait": [
        "dilapider"
    ],
    "dilapidant": [
        "dilapider"
    ],
    "dilapidation": [
        "dilapidation"
    ],
    "dilapide": [
        "dilapider"
    ],
    "dilapider": [
        "dilapider"
    ],
    "dilapides": [
        "dilapider"
    ],
    "dilapidez": [
        "dilapider"
    ],
    "dilapidee": [
        "dilapider"
    ],
    "dilapidees": [
        "dilapider"
    ],
    "dilata": [
        "dilater"
    ],
    "dilatable": [
        "dilatable"
    ],
    "dilataient": [
        "dilater"
    ],
    "dilatait": [
        "dilater"
    ],
    "dilatant": [
        "dilater"
    ],
    "dilatateur": [
        "dilatateur"
    ],
    "dilatateurs": [
        "dilatateur"
    ],
    "dilatation": [
        "dilatation"
    ],
    "dilatations": [
        "dilatation"
    ],
    "dilate": [
        "dilater",
        "dilate"
    ],
    "dilatent": [
        "dilater"
    ],
    "dilater": [
        "dilater"
    ],
    "dilation": [
        "dilation"
    ],
    "dilatoire": [
        "dilatoire"
    ],
    "dilatoires": [
        "dilatoire"
    ],
    "dilatat": [
        "dilater"
    ],
    "dilaterent": [
        "dilater"
    ],
    "dilatee": [
        "dilater",
        "dilate"
    ],
    "dilatees": [
        "dilater",
        "dilate"
    ],
    "dilates": [
        "dilater",
        "dilate"
    ],
    "dilection": [
        "dilection"
    ],
    "dilemme": [
        "dilemme"
    ],
    "dilemmes": [
        "dilemme"
    ],
    "dilettante": [
        "dilettante"
    ],
    "dilettantes": [
        "dilettante"
    ],
    "dilettantisme": [
        "dilettantisme"
    ],
    "dilettantismes": [
        "dilettantisme"
    ],
    "diligemment": [
        "diligemment"
    ],
    "diligence": [
        "diligence"
    ],
    "diligences": [
        "diligence"
    ],
    "diligent": [
        "diligent"
    ],
    "diligente": [
        "diligent"
    ],
    "diligenter": [
        "diligenter"
    ],
    "diligentes": [
        "diligent"
    ],
    "diligents": [
        "diligent"
    ],
    "dilua": [
        "diluer"
    ],
    "diluaient": [
        "diluer"
    ],
    "diluait": [
        "diluer"
    ],
    "diluant": [
        "diluer",
        "diluant"
    ],
    "dilue": [
        "diluer"
    ],
    "diluent": [
        "diluer"
    ],
    "diluer": [
        "diluer"
    ],
    "diluerait": [
        "diluer"
    ],
    "diluons": [
        "diluer"
    ],
    "dilution": [
        "dilution"
    ],
    "diluvien": [
        "diluvien"
    ],
    "diluvienne": [
        "diluvien"
    ],
    "diluviennes": [
        "diluvien"
    ],
    "diluee": [
        "diluer"
    ],
    "diluees": [
        "diluer"
    ],
    "dilues": [
        "diluer"
    ],
    "dimanche": [
        "dimanche"
    ],
    "dimanches": [
        "dimanche"
    ],
    "dimension": [
        "dimension"
    ],
    "dimensionnel": [
        "dimensionnel"
    ],
    "dimensionnelle": [
        "dimensionnel"
    ],
    "dimensionnelles": [
        "dimensionnel"
    ],
    "dimensionnels": [
        "dimensionnel"
    ],
    "dimensionnement": [
        "dimensionnement"
    ],
    "dimensions": [
        "dimension"
    ],
    "diminua": [
        "diminuer"
    ],
    "diminuaient": [
        "diminuer"
    ],
    "diminuais": [
        "diminuer"
    ],
    "diminuait": [
        "diminuer"
    ],
    "diminuant": [
        "diminuant",
        "diminuer"
    ],
    "diminue": [
        "diminue",
        "diminuer"
    ],
    "diminuendo": [
        "diminuendo"
    ],
    "diminuent": [
        "diminuer"
    ],
    "diminuer": [
        "diminuer"
    ],
    "diminuera": [
        "diminuer"
    ],
    "diminuerai": [
        "diminuer"
    ],
    "diminuerais": [
        "diminuer"
    ],
    "diminuerait": [
        "diminuer"
    ],
    "diminueront": [
        "diminuer"
    ],
    "diminuez": [
        "diminuer"
    ],
    "diminuiez": [
        "diminuer"
    ],
    "diminutif": [
        "diminutif"
    ],
    "diminutifs": [
        "diminutif"
    ],
    "diminution": [
        "diminution"
    ],
    "diminutions": [
        "diminution"
    ],
    "diminuat": [
        "diminuer"
    ],
    "diminuerent": [
        "diminuer"
    ],
    "diminuee": [
        "diminue",
        "diminuer"
    ],
    "diminuees": [
        "diminue",
        "diminuer"
    ],
    "diminues": [
        "diminue",
        "diminuer"
    ],
    "dinamiteros": [
        "dinamitero"
    ],
    "dinanderie": [
        "dinanderie"
    ],
    "dinar": [
        "dinar"
    ],
    "dinars": [
        "dinar"
    ],
    "dinde": [
        "dinde"
    ],
    "dindes": [
        "dinde"
    ],
    "dindon": [
        "dindon"
    ],
    "dindonne": [
        "dindonner"
    ],
    "dindonneau": [
        "dindonneau"
    ],
    "dindonneaux": [
        "dindonneau"
    ],
    "dindons": [
        "dindon"
    ],
    "dine": [
        "dine",
        "diner"
    ],
    "ding": [
        "ding"
    ],
    "dingo": [
        "dingo"
    ],
    "dingos": [
        "dingo"
    ],
    "dingue": [
        "dinguer",
        "dingue"
    ],
    "dinguent": [
        "dinguer"
    ],
    "dinguer": [
        "dinguer"
    ],
    "dinguerie": [
        "dinguerie"
    ],
    "dingueries": [
        "dinguerie"
    ],
    "dingues": [
        "dingue"
    ],
    "dinosaure": [
        "dinosaure"
    ],
    "dinosaures": [
        "dinosaure"
    ],
    "diocletienne": [
        "diocletien"
    ],
    "diocletiennes": [
        "diocletien"
    ],
    "diocese": [
        "diocese"
    ],
    "dioceses": [
        "diocese"
    ],
    "diocesain": [
        "diocesain"
    ],
    "diocesaines": [
        "diocesain"
    ],
    "diode": [
        "diode"
    ],
    "diodon": [
        "diodon"
    ],
    "dionysiaque": [
        "dionysiaque"
    ],
    "dionysiaques": [
        "dionysiaque"
    ],
    "dionysien": [
        "dionysien"
    ],
    "dionee": [
        "dionee"
    ],
    "dioptre": [
        "dioptre"
    ],
    "dioptries": [
        "dioptrie"
    ],
    "diorama": [
        "diorama"
    ],
    "dioramas": [
        "diorama"
    ],
    "diorite": [
        "diorite"
    ],
    "dioxine": [
        "dioxine"
    ],
    "dioxines": [
        "dioxine"
    ],
    "dioxyde": [
        "dioxyde"
    ],
    "diphtongue": [
        "diphtongue"
    ],
    "diphtongues": [
        "diphtongue"
    ],
    "diphterie": [
        "diphterie"
    ],
    "diphenyle": [
        "diphenyle"
    ],
    "diplodocus": [
        "diplodocus"
    ],
    "diplomate": [
        "diplomate"
    ],
    "diplomates": [
        "diplomate"
    ],
    "diplomatie": [
        "diplomatie"
    ],
    "diplomatique": [
        "diplomatique"
    ],
    "diplomatiquement": [
        "diplomatiquement"
    ],
    "diplomatiques": [
        "diplomatique"
    ],
    "diplopie": [
        "diplopie"
    ],
    "diplome": [
        "diplomer",
        "diplome"
    ],
    "diplomer": [
        "diplomer"
    ],
    "diplomes": [
        "diplomer",
        "diplome"
    ],
    "diplomee": [
        "diplomer",
        "diplome"
    ],
    "diplomees": [
        "diplomer",
        "diplome"
    ],
    "dipneuste": [
        "dipneuste"
    ],
    "dipneustes": [
        "dipneuste"
    ],
    "dipsomane": [
        "dipsomane"
    ],
    "dipsomanes": [
        "dipsomane"
    ],
    "dipsomanie": [
        "dipsomanie"
    ],
    "diptyque": [
        "diptyque"
    ],
    "dipteres": [
        "diptere"
    ],
    "dipole": [
        "dipole"
    ],
    "dira": [
        "dire"
    ],
    "dirai": [
        "dire"
    ],
    "diraient": [
        "dire"
    ],
    "dirais": [
        "dire"
    ],
    "dirait": [
        "dire"
    ],
    "diras": [
        "dire"
    ],
    "dire": [
        "dire"
    ],
    "direct": [
        "direct"
    ],
    "directe": [
        "direct"
    ],
    "directement": [
        "directement"
    ],
    "directes": [
        "direct"
    ],
    "directeur": [
        "directeur"
    ],
    "directeurs": [
        "directeur"
    ],
    "directif": [
        "directif"
    ],
    "direction": [
        "direction"
    ],
    "directionnel": [
        "directionnel"
    ],
    "directionnelle": [
        "directionnel"
    ],
    "directionnelles": [
        "directionnel"
    ],
    "directionnels": [
        "directionnel"
    ],
    "directions": [
        "direction"
    ],
    "directive": [
        "directive",
        "directif"
    ],
    "directives": [
        "directive",
        "directif"
    ],
    "directo": [
        "directo"
    ],
    "directoire": [
        "directoire"
    ],
    "directorat": [
        "directorat"
    ],
    "directorial": [
        "directorial"
    ],
    "directoriale": [
        "directorial"
    ],
    "directoriaux": [
        "directorial"
    ],
    "directos": [
        "directos"
    ],
    "directrice": [
        "directeur"
    ],
    "directrices": [
        "directeur"
    ],
    "directs": [
        "direct"
    ],
    "dirent": [
        "dire"
    ],
    "dires": [
        "dire"
    ],
    "direz": [
        "dire"
    ],
    "dirham": [
        "dirham"
    ],
    "dirhams": [
        "dirham"
    ],
    "diriez": [
        "dire"
    ],
    "dirige": [
        "diriger",
        "dirige"
    ],
    "dirigea": [
        "diriger"
    ],
    "dirigeable": [
        "dirigeable"
    ],
    "dirigeables": [
        "dirigeable"
    ],
    "dirigeai": [
        "diriger"
    ],
    "dirigeaient": [
        "diriger"
    ],
    "dirigeais": [
        "diriger"
    ],
    "dirigeait": [
        "diriger"
    ],
    "dirigeant": [
        "dirigeant",
        "diriger"
    ],
    "dirigeante": [
        "dirigeant"
    ],
    "dirigeantes": [
        "dirigeant"
    ],
    "dirigeants": [
        "dirigeant"
    ],
    "dirigent": [
        "diriger"
    ],
    "dirigeons": [
        "diriger"
    ],
    "diriger": [
        "diriger"
    ],
    "dirigera": [
        "diriger"
    ],
    "dirigerai": [
        "diriger"
    ],
    "dirigeraient": [
        "diriger"
    ],
    "dirigerais": [
        "diriger"
    ],
    "dirigerait": [
        "diriger"
    ],
    "dirigeras": [
        "diriger"
    ],
    "dirigerez": [
        "diriger"
    ],
    "dirigerons": [
        "diriger"
    ],
    "dirigeront": [
        "diriger"
    ],
    "diriges": [
        "diriger",
        "dirige"
    ],
    "dirigez": [
        "diriger"
    ],
    "dirigeames": [
        "diriger"
    ],
    "dirigeat": [
        "diriger"
    ],
    "dirigiez": [
        "diriger"
    ],
    "dirigions": [
        "diriger"
    ],
    "dirigerent": [
        "diriger"
    ],
    "dirigee": [
        "diriger",
        "dirige"
    ],
    "dirigees": [
        "diriger",
        "dirige"
    ],
    "dirimant": [
        "dirimant"
    ],
    "dirimants": [
        "dirimant"
    ],
    "dirions": [
        "dire"
    ],
    "dirlo": [
        "dirlo"
    ],
    "dirlos": [
        "dirlo"
    ],
    "dirons": [
        "dire"
    ],
    "diront": [
        "dire"
    ],
    "dis": [
        "di",
        "dire"
    ],
    "disaient": [
        "dire"
    ],
    "disais": [
        "dire"
    ],
    "disait": [
        "dire"
    ],
    "disant": [
        "disant",
        "dire"
    ],
    "disants": [
        "disant"
    ],
    "discal": [
        "discal"
    ],
    "discale": [
        "discal"
    ],
    "discerna": [
        "discerner"
    ],
    "discernable": [
        "discernable"
    ],
    "discernables": [
        "discernable"
    ],
    "discernai": [
        "discerner"
    ],
    "discernaient": [
        "discerner"
    ],
    "discernais": [
        "discerner"
    ],
    "discernait": [
        "discerner"
    ],
    "discernant": [
        "discerner"
    ],
    "discerne": [
        "discerner"
    ],
    "discernement": [
        "discernement"
    ],
    "discernent": [
        "discerner"
    ],
    "discerner": [
        "discerner"
    ],
    "discernerait": [
        "discerner"
    ],
    "discernes": [
        "discerner"
    ],
    "discernions": [
        "discerner"
    ],
    "discernames": [
        "discerner"
    ],
    "discernat": [
        "discerner"
    ],
    "discernees": [
        "discerner"
    ],
    "disciple": [
        "disciple"
    ],
    "disciples": [
        "disciple"
    ],
    "disciplina": [
        "discipliner"
    ],
    "disciplinaient": [
        "discipliner"
    ],
    "disciplinaire": [
        "disciplinaire"
    ],
    "disciplinaires": [
        "disciplinaire"
    ],
    "disciplinais": [
        "discipliner"
    ],
    "disciplinait": [
        "discipliner"
    ],
    "discipline": [
        "discipliner",
        "discipline"
    ],
    "discipliner": [
        "discipliner"
    ],
    "disciplinera": [
        "discipliner"
    ],
    "disciplinerait": [
        "discipliner"
    ],
    "disciplines": [
        "discipliner",
        "discipline"
    ],
    "disciplinee": [
        "discipliner",
        "discipline"
    ],
    "disciplinees": [
        "discipline"
    ],
    "disco": [
        "disco"
    ],
    "discobole": [
        "discobole"
    ],
    "discoboles": [
        "discobole"
    ],
    "discographie": [
        "discographie"
    ],
    "discographiques": [
        "discographique"
    ],
    "discontinu": [
        "discontinu"
    ],
    "discontinuaient": [
        "discontinuer"
    ],
    "discontinue": [
        "discontinu"
    ],
    "discontinuer": [
        "discontinuer"
    ],
    "discontinues": [
        "discontinu",
        "discontinue"
    ],
    "discontinuite": [
        "discontinuite"
    ],
    "discontinus": [
        "discontinu"
    ],
    "disconviens": [
        "disconvenir"
    ],
    "disconvint": [
        "disconvenir"
    ],
    "discordance": [
        "discordance"
    ],
    "discordances": [
        "discordance"
    ],
    "discordant": [
        "discordant",
        "discorder"
    ],
    "discordante": [
        "discordant"
    ],
    "discordantes": [
        "discordant"
    ],
    "discordants": [
        "discordant"
    ],
    "discorde": [
        "discorde"
    ],
    "discordes": [
        "discorde",
        "discord"
    ],
    "discos": [
        "disco"
    ],
    "discotheque": [
        "discotheque"
    ],
    "discotheques": [
        "discotheque"
    ],
    "discount": [
        "discount"
    ],
    "discouraient": [
        "discourir"
    ],
    "discourait": [
        "discourir"
    ],
    "discourant": [
        "discourir"
    ],
    "discoure": [
        "discourir"
    ],
    "discourent": [
        "discourir"
    ],
    "discoureur": [
        "discoureur"
    ],
    "discoureurs": [
        "discoureur"
    ],
    "discourir": [
        "discourir"
    ],
    "discours": [
        "discours",
        "discourir"
    ],
    "discourt": [
        "discourir"
    ],
    "discourtois": [
        "discourtois"
    ],
    "discourtoise": [
        "discourtois"
    ],
    "discourtoises": [
        "discourtois"
    ],
    "discouru": [
        "discourir"
    ],
    "discourut": [
        "discourir"
    ],
    "discret": [
        "discret"
    ],
    "discrets": [
        "discret"
    ],
    "discriminant": [
        "discriminant"
    ],
    "discriminants": [
        "discriminant"
    ],
    "discrimination": [
        "discrimination"
    ],
    "discriminations": [
        "discrimination"
    ],
    "discriminatoire": [
        "discriminatoire"
    ],
    "discriminer": [
        "discriminer"
    ],
    "discrimine": [
        "discriminer"
    ],
    "discrete": [
        "discret"
    ],
    "discretement": [
        "discretement"
    ],
    "discretes": [
        "discrete",
        "discret"
    ],
    "discredit": [
        "discredit"
    ],
    "discreditait": [
        "discrediter"
    ],
    "discreditant": [
        "discrediter"
    ],
    "discredite": [
        "discrediter"
    ],
    "discrediter": [
        "discrediter"
    ],
    "discrediterait": [
        "discrediter"
    ],
    "discreditez": [
        "discrediter"
    ],
    "discreditee": [
        "discrediter"
    ],
    "discreditees": [
        "discrediter"
    ],
    "discredites": [
        "discrediter"
    ],
    "discretion": [
        "discretion"
    ],
    "discretionnaire": [
        "discretionnaire"
    ],
    "discretionnaires": [
        "discretionnaire"
    ],
    "disculpait": [
        "disculper"
    ],
    "disculpant": [
        "disculper"
    ],
    "disculpation": [
        "disculpation"
    ],
    "disculpe": [
        "disculper"
    ],
    "disculpent": [
        "disculper"
    ],
    "disculper": [
        "disculper"
    ],
    "disculperait": [
        "disculper"
    ],
    "disculpez": [
        "disculper"
    ],
    "disculpes": [
        "disculper"
    ],
    "discursives": [
        "discursif"
    ],
    "discussion": [
        "discussion"
    ],
    "discussions": [
        "discussion"
    ],
    "discuta": [
        "discuter"
    ],
    "discutable": [
        "discutable"
    ],
    "discutables": [
        "discutable"
    ],
    "discutai": [
        "discuter"
    ],
    "discutaient": [
        "discuter"
    ],
    "discutaillaient": [
        "discutailler"
    ],
    "discutaillait": [
        "discutailler"
    ],
    "discutaille": [
        "discutailler"
    ],
    "discutaillent": [
        "discutailler"
    ],
    "discutailler": [
        "discutailler"
    ],
    "discutailleries": [
        "discutaillerie"
    ],
    "discutailleur": [
        "discutailleur"
    ],
    "discutailleuse": [
        "discutailleur"
    ],
    "discutais": [
        "discuter"
    ],
    "discutait": [
        "discuter"
    ],
    "discutant": [
        "discuter"
    ],
    "discute": [
        "discute",
        "discuter"
    ],
    "discutent": [
        "discuter"
    ],
    "discuter": [
        "discuter"
    ],
    "discutera": [
        "discuter"
    ],
    "discuterai": [
        "discuter"
    ],
    "discuteraient": [
        "discuter"
    ],
    "discuterais": [
        "discuter"
    ],
    "discuterait": [
        "discuter"
    ],
    "discuterez": [
        "discuter"
    ],
    "discuteriez": [
        "discuter"
    ],
    "discuterions": [
        "discuter"
    ],
    "discuterons": [
        "discuter"
    ],
    "discuteront": [
        "discuter"
    ],
    "discutes": [
        "discuter"
    ],
    "discutez": [
        "discuter"
    ],
    "discutiez": [
        "discuter"
    ],
    "discutions": [
        "discuter"
    ],
    "discutons": [
        "discuter"
    ],
    "discutames": [
        "discuter"
    ],
    "discutat": [
        "discuter"
    ],
    "discuterent": [
        "discuter"
    ],
    "discutee": [
        "discute",
        "discuter"
    ],
    "discutees": [
        "discute",
        "discuter"
    ],
    "dise": [
        "dire"
    ],
    "disent": [
        "dire"
    ],
    "disert": [
        "disert"
    ],
    "diserte": [
        "disert"
    ],
    "dises": [
        "dire"
    ],
    "disette": [
        "disette"
    ],
    "disettes": [
        "disette"
    ],
    "diseur": [
        "diseur"
    ],
    "diseurs": [
        "diseur"
    ],
    "diseuse": [
        "diseur"
    ],
    "diseuses": [
        "diseur"
    ],
    "disfonctionnement": [
        "disfonctionnement"
    ],
    "disgracia": [
        "disgracier"
    ],
    "disgraciaient": [
        "disgracier"
    ],
    "disgraciait": [
        "disgracier"
    ],
    "disgracier": [
        "disgracier"
    ],
    "disgraciera": [
        "disgracier"
    ],
    "disgracieuse": [
        "disgracieux"
    ],
    "disgracieusement": [
        "disgracieusement"
    ],
    "disgracieuses": [
        "disgracieux"
    ],
    "disgracieux": [
        "disgracieux"
    ],
    "disgracie": [
        "disgracier",
        "disgracie"
    ],
    "disgraciee": [
        "disgracier",
        "disgracie"
    ],
    "disgraciees": [
        "disgracie"
    ],
    "disgracies": [
        "disgracier",
        "disgracie"
    ],
    "disgrace": [
        "disgrace"
    ],
    "disgraces": [
        "disgrace"
    ],
    "disharmonie": [
        "disharmonie"
    ],
    "disiez": [
        "dire"
    ],
    "disions": [
        "dire"
    ],
    "disjoignait": [
        "disjoindre"
    ],
    "disjoignant": [
        "disjoindre"
    ],
    "disjoignent": [
        "disjoindre"
    ],
    "disjoindre": [
        "disjoindre"
    ],
    "disjoint": [
        "disjoindre",
        "disjoint"
    ],
    "disjointe": [
        "disjoindre",
        "disjoint"
    ],
    "disjointes": [
        "disjoindre",
        "disjoint"
    ],
    "disjoints": [
        "disjoindre",
        "disjoint"
    ],
    "disjoncta": [
        "disjoncter"
    ],
    "disjonctais": [
        "disjoncter"
    ],
    "disjonctait": [
        "disjoncter"
    ],
    "disjoncte": [
        "disjoncter"
    ],
    "disjonctent": [
        "disjoncter"
    ],
    "disjoncter": [
        "disjoncter"
    ],
    "disjoncterais": [
        "disjoncter"
    ],
    "disjoncterait": [
        "disjoncter"
    ],
    "disjonctes": [
        "disjoncter"
    ],
    "disjoncteur": [
        "disjoncteur"
    ],
    "disjoncteurs": [
        "disjoncteur"
    ],
    "disjonctez": [
        "disjoncter"
    ],
    "disjonction": [
        "disjonction"
    ],
    "disjonctions": [
        "disjonction"
    ],
    "disjonctee": [
        "disjoncter"
    ],
    "diskette": [
        "diskette"
    ],
    "dislocation": [
        "dislocation"
    ],
    "dislocations": [
        "dislocation"
    ],
    "disloqua": [
        "disloquer"
    ],
    "disloquai": [
        "disloquer"
    ],
    "disloquaient": [
        "disloquer"
    ],
    "disloquait": [
        "disloquer"
    ],
    "disloquant": [
        "disloquer"
    ],
    "disloque": [
        "disloque",
        "disloquer"
    ],
    "disloquent": [
        "disloquer"
    ],
    "disloquer": [
        "disloquer"
    ],
    "disloquerai": [
        "disloquer"
    ],
    "disloqueront": [
        "disloquer"
    ],
    "disloquat": [
        "disloquer"
    ],
    "disloquerent": [
        "disloquer"
    ],
    "disloquee": [
        "disloque",
        "disloquer"
    ],
    "disloquees": [
        "disloque",
        "disloquer"
    ],
    "disloques": [
        "disloque",
        "disloquer"
    ],
    "disons": [
        "dire"
    ],
    "disparais": [
        "disparaitre"
    ],
    "disparaissaient": [
        "disparaitre"
    ],
    "disparaissais": [
        "disparaitre"
    ],
    "disparaissait": [
        "disparaitre"
    ],
    "disparaissant": [
        "disparaissant",
        "disparaitre"
    ],
    "disparaissante": [
        "disparaissant"
    ],
    "disparaisse": [
        "disparaitre"
    ],
    "disparaissent": [
        "disparaitre"
    ],
    "disparaisses": [
        "disparaitre"
    ],
    "disparaissez": [
        "disparaitre"
    ],
    "disparaissiez": [
        "disparaitre"
    ],
    "disparaissions": [
        "disparaitre"
    ],
    "disparaissons": [
        "disparaitre"
    ],
    "disparate": [
        "disparate"
    ],
    "disparates": [
        "disparate"
    ],
    "disparait": [
        "disparaitre"
    ],
    "disparaitra": [
        "disparaitre"
    ],
    "disparaitrai": [
        "disparaitre"
    ],
    "disparaitraient": [
        "disparaitre"
    ],
    "disparaitrais": [
        "disparaitre"
    ],
    "disparaitrait": [
        "disparaitre"
    ],
    "disparaitras": [
        "disparaitre"
    ],
    "disparaitre": [
        "disparaitre"
    ],
    "disparaitrez": [
        "disparaitre"
    ],
    "disparaitrions": [
        "disparaitre"
    ],
    "disparaitrons": [
        "disparaitre"
    ],
    "disparaitront": [
        "disparaitre"
    ],
    "disparition": [
        "disparition"
    ],
    "disparitions": [
        "disparition"
    ],
    "disparite": [
        "disparite"
    ],
    "disparu": [
        "disparaitre",
        "disparu"
    ],
    "disparue": [
        "disparaitre",
        "disparu"
    ],
    "disparues": [
        "disparaitre",
        "disparu"
    ],
    "disparurent": [
        "disparaitre"
    ],
    "disparus": [
        "disparaitre",
        "disparu"
    ],
    "disparut": [
        "disparaitre"
    ],
    "disparumes": [
        "disparaitre"
    ],
    "dispatchais": [
        "dispatcher"
    ],
    "dispatchait": [
        "dispatcher"
    ],
    "dispatche": [
        "dispatcher"
    ],
    "dispatcher": [
        "dispatcher"
    ],
    "dispatching": [
        "dispatch",
        "dispatching"
    ],
    "dispendieuse": [
        "dispendieux"
    ],
    "dispendieusement": [
        "dispendieusement"
    ],
    "dispendieux": [
        "dispendieux"
    ],
    "dispensa": [
        "dispenser"
    ],
    "dispensable": [
        "dispensable"
    ],
    "dispensaient": [
        "dispenser"
    ],
    "dispensaire": [
        "dispensaire"
    ],
    "dispensaires": [
        "dispensaire"
    ],
    "dispensais": [
        "dispenser"
    ],
    "dispensait": [
        "dispenser"
    ],
    "dispensant": [
        "dispenser"
    ],
    "dispensateur": [
        "dispensateur"
    ],
    "dispensateurs": [
        "dispensateur"
    ],
    "dispensation": [
        "dispensation"
    ],
    "dispensatrice": [
        "dispensateur"
    ],
    "dispensatrices": [
        "dispensateur"
    ],
    "dispense": [
        "dispense",
        "dispenser"
    ],
    "dispensent": [
        "dispenser"
    ],
    "dispenser": [
        "dispenser"
    ],
    "dispenserait": [
        "dispenser"
    ],
    "dispenseras": [
        "dispenser"
    ],
    "dispenses": [
        "dispense",
        "dispenser"
    ],
    "dispensez": [
        "dispenser"
    ],
    "dispensat": [
        "dispenser"
    ],
    "dispenserent": [
        "dispenser"
    ],
    "dispensee": [
        "dispenser"
    ],
    "dispensees": [
        "dispenser",
        "dispense"
    ],
    "dispersa": [
        "disperser"
    ],
    "dispersaient": [
        "disperser"
    ],
    "dispersait": [
        "disperser"
    ],
    "dispersant": [
        "disperser",
        "dispersant"
    ],
    "disperse": [
        "disperser",
        "disperse"
    ],
    "dispersement": [
        "dispersement"
    ],
    "dispersent": [
        "disperser"
    ],
    "disperser": [
        "disperser"
    ],
    "dispersera": [
        "disperser"
    ],
    "disperserai": [
        "disperser"
    ],
    "disperseraient": [
        "disperser"
    ],
    "disperserait": [
        "disperser"
    ],
    "disperserons": [
        "disperser"
    ],
    "disperseront": [
        "disperser"
    ],
    "disperses": [
        "disperser",
        "disperse"
    ],
    "dispersez": [
        "disperser"
    ],
    "dispersif": [
        "dispersif"
    ],
    "dispersion": [
        "dispersion"
    ],
    "dispersions": [
        "disperser",
        "dispersion"
    ],
    "dispersons": [
        "disperser"
    ],
    "dispersat": [
        "disperser"
    ],
    "disperserent": [
        "disperser"
    ],
    "dispersee": [
        "disperser",
        "disperse"
    ],
    "dispersees": [
        "disperser",
        "disperse"
    ],
    "dispo": [
        "dispo"
    ],
    "disponibilite": [
        "disponibilite"
    ],
    "disponibilites": [
        "disponibilite"
    ],
    "disponible": [
        "disponible"
    ],
    "disponibles": [
        "disponible"
    ],
    "dispos": [
        "dispos"
    ],
    "disposa": [
        "disposer"
    ],
    "disposai": [
        "disposer"
    ],
    "disposaient": [
        "disposer"
    ],
    "disposais": [
        "disposer"
    ],
    "disposait": [
        "disposer"
    ],
    "disposant": [
        "disposer",
        "disposant"
    ],
    "disposas": [
        "disposer"
    ],
    "dispose": [
        "dispose",
        "disposer",
        "dispos"
    ],
    "disposent": [
        "disposer"
    ],
    "disposer": [
        "disposer"
    ],
    "disposera": [
        "disposer"
    ],
    "disposerai": [
        "disposer"
    ],
    "disposeraient": [
        "disposer"
    ],
    "disposerais": [
        "disposer"
    ],
    "disposerait": [
        "disposer"
    ],
    "disposeras": [
        "disposer"
    ],
    "disposerez": [
        "disposer"
    ],
    "disposerons": [
        "disposer"
    ],
    "disposeront": [
        "disposer"
    ],
    "disposes": [
        "dispose",
        "disposer"
    ],
    "disposez": [
        "disposer"
    ],
    "disposiez": [
        "disposer"
    ],
    "disposions": [
        "disposer"
    ],
    "dispositif": [
        "dispositif"
    ],
    "dispositifs": [
        "dispositif"
    ],
    "disposition": [
        "disposition"
    ],
    "dispositions": [
        "disposition"
    ],
    "disposons": [
        "disposer"
    ],
    "disposames": [
        "disposer"
    ],
    "disposat": [
        "disposer"
    ],
    "disposerent": [
        "disposer"
    ],
    "disposee": [
        "dispose",
        "disposer"
    ],
    "disposees": [
        "dispose",
        "disposer"
    ],
    "disproportion": [
        "disproportion"
    ],
    "disproportionnelle": [
        "disproportionnel"
    ],
    "disproportionne": [
        "disproportionne",
        "disproportionner"
    ],
    "disproportionnee": [
        "disproportionne",
        "disproportionner"
    ],
    "disproportionnees": [
        "disproportionne",
        "disproportionner"
    ],
    "disproportionnes": [
        "disproportionne"
    ],
    "disproportions": [
        "disproportion"
    ],
    "disputa": [
        "disputer"
    ],
    "disputaient": [
        "disputer"
    ],
    "disputais": [
        "disputer"
    ],
    "disputait": [
        "disputer"
    ],
    "disputant": [
        "disputer"
    ],
    "dispute": [
        "dispute",
        "disputer"
    ],
    "disputent": [
        "disputer"
    ],
    "disputer": [
        "disputer"
    ],
    "disputera": [
        "disputer"
    ],
    "disputerai": [
        "disputer"
    ],
    "disputeraient": [
        "disputer"
    ],
    "disputerait": [
        "disputer"
    ],
    "disputerez": [
        "disputer"
    ],
    "disputerons": [
        "disputer"
    ],
    "disputeront": [
        "disputer"
    ],
    "disputes": [
        "dispute",
        "disputer"
    ],
    "disputeur": [
        "disputeur"
    ],
    "disputez": [
        "disputer"
    ],
    "disputiez": [
        "disputer"
    ],
    "disputions": [
        "disputer"
    ],
    "disputons": [
        "disputer"
    ],
    "disputames": [
        "disputer"
    ],
    "disputat": [
        "disputer"
    ],
    "disputerent": [
        "disputer"
    ],
    "disputee": [
        "dispute",
        "disputer"
    ],
    "disputees": [
        "dispute",
        "disputer"
    ],
    "disquaire": [
        "disquaire"
    ],
    "disquaires": [
        "disquaire"
    ],
    "disqualifiait": [
        "disqualifier"
    ],
    "disqualifiant": [
        "disqualifier"
    ],
    "disqualification": [
        "disqualification"
    ],
    "disqualifications": [
        "disqualification"
    ],
    "disqualifie": [
        "disqualifie",
        "disqualifier"
    ],
    "disqualifient": [
        "disqualifier"
    ],
    "disqualifier": [
        "disqualifier"
    ],
    "disqualifiee": [
        "disqualifie",
        "disqualifier"
    ],
    "disqualifiees": [
        "disqualifie",
        "disqualifier"
    ],
    "disqualifies": [
        "disqualify",
        "disqualifie",
        "disqualifier"
    ],
    "disque": [
        "disque"
    ],
    "disques": [
        "disque"
    ],
    "disquette": [
        "disquette"
    ],
    "disquettes": [
        "disquette"
    ],
    "disruptif": [
        "disruptif"
    ],
    "disruption": [
        "disruption"
    ],
    "dissection": [
        "dissection"
    ],
    "dissections": [
        "dissection"
    ],
    "dissemblable": [
        "dissemblable"
    ],
    "dissemblables": [
        "dissemblable"
    ],
    "dissemblance": [
        "dissemblance"
    ],
    "dissension": [
        "dissension"
    ],
    "dissensions": [
        "dissension"
    ],
    "dissent": [
        "dire"
    ],
    "dissentiment": [
        "dissentiment"
    ],
    "dissentiments": [
        "dissentiment"
    ],
    "dissertait": [
        "disserter"
    ],
    "dissertant": [
        "disserter"
    ],
    "dissertation": [
        "dissertation"
    ],
    "dissertations": [
        "dissertation"
    ],
    "disserte": [
        "disserter"
    ],
    "dissertent": [
        "disserter"
    ],
    "disserter": [
        "disserter"
    ],
    "disserterait": [
        "disserter"
    ],
    "dissertes": [
        "disserter"
    ],
    "dissidence": [
        "dissidence"
    ],
    "dissidences": [
        "dissidence"
    ],
    "dissident": [
        "dissident"
    ],
    "dissidente": [
        "dissident"
    ],
    "dissidentes": [
        "dissident"
    ],
    "dissidents": [
        "dissident"
    ],
    "dissimilaires": [
        "dissimilaire"
    ],
    "dissimiler": [
        "dissimiler"
    ],
    "dissimula": [
        "dissimuler"
    ],
    "dissimulables": [
        "dissimulable"
    ],
    "dissimulai": [
        "dissimuler"
    ],
    "dissimulaient": [
        "dissimuler"
    ],
    "dissimulais": [
        "dissimuler"
    ],
    "dissimulait": [
        "dissimuler"
    ],
    "dissimulant": [
        "dissimuler"
    ],
    "dissimulateur": [
        "dissimulateur"
    ],
    "dissimulateurs": [
        "dissimulateur"
    ],
    "dissimulation": [
        "dissimulation"
    ],
    "dissimulations": [
        "dissimulation"
    ],
    "dissimulatrice": [
        "dissimulateur"
    ],
    "dissimulatrices": [
        "dissimulateur"
    ],
    "dissimule": [
        "dissimule",
        "dissimuler"
    ],
    "dissimulent": [
        "dissimuler"
    ],
    "dissimuler": [
        "dissimuler"
    ],
    "dissimulera": [
        "dissimuler"
    ],
    "dissimuleraient": [
        "dissimuler"
    ],
    "dissimulerais": [
        "dissimuler"
    ],
    "dissimulerait": [
        "dissimuler"
    ],
    "dissimulerons": [
        "dissimuler"
    ],
    "dissimules": [
        "dissimule",
        "dissimuler"
    ],
    "dissimulez": [
        "dissimuler"
    ],
    "dissimuliez": [
        "dissimuler"
    ],
    "dissimulions": [
        "dissimuler"
    ],
    "dissimulons": [
        "dissimuler"
    ],
    "dissimulat": [
        "dissimuler"
    ],
    "dissimulerent": [
        "dissimuler"
    ],
    "dissimulee": [
        "dissimule",
        "dissimuler"
    ],
    "dissimulees": [
        "dissimule",
        "dissimuler"
    ],
    "dissipa": [
        "dissiper"
    ],
    "dissipaient": [
        "dissiper"
    ],
    "dissipait": [
        "dissiper"
    ],
    "dissipant": [
        "dissiper"
    ],
    "dissipateur": [
        "dissipateur"
    ],
    "dissipateurs": [
        "dissipateur"
    ],
    "dissipation": [
        "dissipation"
    ],
    "dissipations": [
        "dissipation"
    ],
    "dissipe": [
        "dissiper",
        "dissipe"
    ],
    "dissipent": [
        "dissiper"
    ],
    "dissiper": [
        "dissiper"
    ],
    "dissipera": [
        "dissiper"
    ],
    "dissiperais": [
        "dissiper"
    ],
    "dissiperait": [
        "dissiper"
    ],
    "dissiperont": [
        "dissiper"
    ],
    "dissipez": [
        "dissiper"
    ],
    "dissiperent": [
        "dissiper"
    ],
    "dissipee": [
        "dissiper",
        "dissipe"
    ],
    "dissipees": [
        "dissiper",
        "dissipe"
    ],
    "dissipes": [
        "dissiper",
        "dissipe"
    ],
    "dissocia": [
        "dissocier"
    ],
    "dissociaient": [
        "dissocier"
    ],
    "dissociait": [
        "dissocier"
    ],
    "dissociant": [
        "dissocier"
    ],
    "dissociatif": [
        "dissociatif"
    ],
    "dissociatifs": [
        "dissociatif"
    ],
    "dissociation": [
        "dissociation"
    ],
    "dissociations": [
        "dissociation"
    ],
    "dissociative": [
        "dissociatif"
    ],
    "dissocie": [
        "dissocier"
    ],
    "dissocient": [
        "dissocier"
    ],
    "dissocier": [
        "dissocier"
    ],
    "dissocierons": [
        "dissocier"
    ],
    "dissociee": [
        "dissocier"
    ],
    "dissociees": [
        "dissocier"
    ],
    "dissocies": [
        "dissocier"
    ],
    "dissolu": [
        "dissolu"
    ],
    "dissolue": [
        "dissolu"
    ],
    "dissolues": [
        "dissolu"
    ],
    "dissolus": [
        "dissolu"
    ],
    "dissolution": [
        "dissolution"
    ],
    "dissolvaient": [
        "dissoudre"
    ],
    "dissolvait": [
        "dissoudre"
    ],
    "dissolvant": [
        "dissoudre",
        "dissolvant"
    ],
    "dissolvante": [
        "dissolvant"
    ],
    "dissolvantes": [
        "dissolvant"
    ],
    "dissolvants": [
        "dissolvant"
    ],
    "dissolve": [
        "dissoudre"
    ],
    "dissolvent": [
        "dissoudre"
    ],
    "dissolves": [
        "dissoudre",
        "dissolve"
    ],
    "dissonance": [
        "dissonance"
    ],
    "dissonances": [
        "dissonance"
    ],
    "dissonant": [
        "dissonant",
        "dissoner"
    ],
    "dissonants": [
        "dissonant"
    ],
    "dissoudra": [
        "dissoudre"
    ],
    "dissoudrai": [
        "dissoudre"
    ],
    "dissoudrait": [
        "dissoudre"
    ],
    "dissoudre": [
        "dissoudre"
    ],
    "dissoudront": [
        "dissoudre"
    ],
    "dissous": [
        "dissoudre",
        "dissous"
    ],
    "dissout": [
        "dissoudre"
    ],
    "dissoute": [
        "dissoute"
    ],
    "dissoutes": [
        "dissoute"
    ],
    "dissuada": [
        "dissuader"
    ],
    "dissuadai": [
        "dissuader"
    ],
    "dissuadait": [
        "dissuader"
    ],
    "dissuadant": [
        "dissuader"
    ],
    "dissuade": [
        "dissuader"
    ],
    "dissuadent": [
        "dissuader"
    ],
    "dissuader": [
        "dissuader"
    ],
    "dissuadera": [
        "dissuader"
    ],
    "dissuaderas": [
        "dissuader"
    ],
    "dissuaderez": [
        "dissuader"
    ],
    "dissuaderont": [
        "dissuader"
    ],
    "dissuadez": [
        "dissuader"
    ],
    "dissuadiez": [
        "dissuader"
    ],
    "dissuaderent": [
        "dissuader"
    ],
    "dissuadee": [
        "dissuader"
    ],
    "dissuades": [
        "dissuader",
        "dissuade"
    ],
    "dissuasif": [
        "dissuasif"
    ],
    "dissuasion": [
        "dissuasion"
    ],
    "dissuasive": [
        "dissuasif"
    ],
    "dissymetrie": [
        "dissymetrie"
    ],
    "dissymetrique": [
        "dissymetrique"
    ],
    "dissymetriques": [
        "dissymetrique"
    ],
    "disseque": [
        "dissequer"
    ],
    "dissequent": [
        "dissequer"
    ],
    "dissemina": [
        "disseminer"
    ],
    "disseminait": [
        "disseminer"
    ],
    "disseminant": [
        "disseminer"
    ],
    "dissemination": [
        "dissemination"
    ],
    "disseminent": [
        "disseminer"
    ],
    "disseminer": [
        "disseminer"
    ],
    "disseminerent": [
        "disseminer"
    ],
    "dissemine": [
        "disseminer",
        "dissemine"
    ],
    "disseminee": [
        "disseminer",
        "dissemine"
    ],
    "disseminees": [
        "disseminer",
        "dissemine"
    ],
    "dissemines": [
        "disseminer",
        "dissemine"
    ],
    "dissequai": [
        "dissequer"
    ],
    "dissequait": [
        "dissequer"
    ],
    "dissequant": [
        "dissequer"
    ],
    "dissequer": [
        "dissequer"
    ],
    "dissequeraient": [
        "dissequer"
    ],
    "dissequerais": [
        "dissequer"
    ],
    "dissequeur": [
        "dissequeur"
    ],
    "dissequez": [
        "dissequer"
    ],
    "dissequiez": [
        "dissequer"
    ],
    "dissequions": [
        "dissequer"
    ],
    "dissequons": [
        "dissequer"
    ],
    "dissequee": [
        "dissequer"
    ],
    "disseques": [
        "dissequer"
    ],
    "distal": [
        "distal"
    ],
    "distale": [
        "distal"
    ],
    "distance": [
        "distance",
        "distancer"
    ],
    "distancent": [
        "distancer"
    ],
    "distancer": [
        "distancer"
    ],
    "distancerez": [
        "distancer"
    ],
    "distances": [
        "distance",
        "distancer"
    ],
    "distanciation": [
        "distanciation"
    ],
    "distancier": [
        "distancier"
    ],
    "distancie": [
        "distancier"
    ],
    "distancee": [
        "distancer"
    ],
    "distant": [
        "distant"
    ],
    "distante": [
        "distant"
    ],
    "distantes": [
        "distant"
    ],
    "distants": [
        "distant"
    ],
    "distanca": [
        "distancer"
    ],
    "distancait": [
        "distancer"
    ],
    "distancant": [
        "distancer"
    ],
    "distancons": [
        "distancer"
    ],
    "distaux": [
        "distal"
    ],
    "distend": [
        "distendre"
    ],
    "distendaient": [
        "distendre"
    ],
    "distendait": [
        "distendre"
    ],
    "distendant": [
        "distendre"
    ],
    "distende": [
        "distendre"
    ],
    "distendent": [
        "distendre"
    ],
    "distendit": [
        "distendre"
    ],
    "distendrait": [
        "distendre"
    ],
    "distendre": [
        "distendre"
    ],
    "distendu": [
        "distendu",
        "distendre"
    ],
    "distendue": [
        "distendu",
        "distendre"
    ],
    "distendues": [
        "distendu",
        "distendre"
    ],
    "distendus": [
        "distendu",
        "distendre"
    ],
    "distension": [
        "distension"
    ],
    "distillaient": [
        "distiller"
    ],
    "distillait": [
        "distiller"
    ],
    "distillant": [
        "distiller"
    ],
    "distillat": [
        "distillat"
    ],
    "distillateur": [
        "distillateur"
    ],
    "distillateurs": [
        "distillateur"
    ],
    "distillation": [
        "distillation"
    ],
    "distillations": [
        "distillation"
    ],
    "distille": [
        "distiller"
    ],
    "distillent": [
        "distiller"
    ],
    "distiller": [
        "distiller"
    ],
    "distillera": [
        "distiller"
    ],
    "distillerie": [
        "distillerie"
    ],
    "distilleries": [
        "distillerie",
        "distillery"
    ],
    "distilleront": [
        "distiller"
    ],
    "distillez": [
        "distiller"
    ],
    "distillee": [
        "distiller"
    ],
    "distillees": [
        "distiller"
    ],
    "distilles": [
        "distiller"
    ],
    "distinct": [
        "distinct"
    ],
    "distincte": [
        "distinct"
    ],
    "distinctement": [
        "distinctement"
    ],
    "distinctes": [
        "distinct"
    ],
    "distinctif": [
        "distinctif"
    ],
    "distinctifs": [
        "distinctif"
    ],
    "distinction": [
        "distinction"
    ],
    "distinctions": [
        "distinction"
    ],
    "distinctive": [
        "distinctif"
    ],
    "distinctives": [
        "distinctif"
    ],
    "distincts": [
        "distinct"
    ],
    "distingua": [
        "distinguer"
    ],
    "distinguai": [
        "distinguer"
    ],
    "distinguaient": [
        "distinguer"
    ],
    "distinguais": [
        "distinguer"
    ],
    "distinguait": [
        "distinguer"
    ],
    "distinguant": [
        "distinguer"
    ],
    "distingue": [
        "distinguer",
        "distingue"
    ],
    "distinguent": [
        "distinguer"
    ],
    "distinguer": [
        "distinguer"
    ],
    "distinguera": [
        "distinguer"
    ],
    "distingueraient": [
        "distinguer"
    ],
    "distinguerait": [
        "distinguer"
    ],
    "distinguerez": [
        "distinguer"
    ],
    "distingues": [
        "distinguer",
        "distingue"
    ],
    "distinguez": [
        "distinguer"
    ],
    "distinguions": [
        "distinguer"
    ],
    "distinguo": [
        "distinguo"
    ],
    "distinguons": [
        "distinguer"
    ],
    "distinguos": [
        "distinguo"
    ],
    "distinguat": [
        "distinguer"
    ],
    "distinguerent": [
        "distinguer"
    ],
    "distinguee": [
        "distinguer",
        "distingue"
    ],
    "distinguees": [
        "distinguer",
        "distingue"
    ],
    "distord": [
        "distordre"
    ],
    "distordant": [
        "distordre"
    ],
    "distordre": [
        "distordre"
    ],
    "distordu": [
        "distordre"
    ],
    "distordue": [
        "distordre"
    ],
    "distordues": [
        "distordre"
    ],
    "distorsion": [
        "distorsion"
    ],
    "distorsions": [
        "distorsion"
    ],
    "distraction": [
        "distraction"
    ],
    "distractions": [
        "distraction"
    ],
    "distractives": [
        "distractif"
    ],
    "distraie": [
        "distraire"
    ],
    "distraient": [
        "distraire"
    ],
    "distraies": [
        "distraire"
    ],
    "distraira": [
        "distraire"
    ],
    "distrairaient": [
        "distraire"
    ],
    "distrairait": [
        "distraire"
    ],
    "distraire": [
        "distraire"
    ],
    "distrairont": [
        "distraire"
    ],
    "distrais": [
        "distraire"
    ],
    "distrait": [
        "distrait",
        "distraire"
    ],
    "distraite": [
        "distrait",
        "distraire"
    ],
    "distraitement": [
        "distraitement"
    ],
    "distraites": [
        "distrait",
        "distraire"
    ],
    "distraits": [
        "distrait",
        "distraire"
    ],
    "distrayaient": [
        "distraire"
    ],
    "distrayais": [
        "distraire"
    ],
    "distrayait": [
        "distraire"
    ],
    "distrayant": [
        "distrayant",
        "distraire"
    ],
    "distrayante": [
        "distrayant"
    ],
    "distrayantes": [
        "distrayant"
    ],
    "distrayants": [
        "distrayant"
    ],
    "distrayez": [
        "distraire"
    ],
    "distrayons": [
        "distraire"
    ],
    "distribua": [
        "distribuer"
    ],
    "distribuai": [
        "distribuer"
    ],
    "distribuaient": [
        "distribuer"
    ],
    "distribuais": [
        "distribuer"
    ],
    "distribuait": [
        "distribuer"
    ],
    "distribuant": [
        "distribuer"
    ],
    "distribue": [
        "distribuer",
        "distribue"
    ],
    "distribuent": [
        "distribuer"
    ],
    "distribuer": [
        "distribuer"
    ],
    "distribuera": [
        "distribuer"
    ],
    "distribuerai": [
        "distribuer"
    ],
    "distribuerais": [
        "distribuer"
    ],
    "distribuerait": [
        "distribuer"
    ],
    "distribuerez": [
        "distribuer"
    ],
    "distribuerions": [
        "distribuer"
    ],
    "distribuerons": [
        "distribuer"
    ],
    "distribueront": [
        "distribuer"
    ],
    "distribues": [
        "distribuer",
        "distribue"
    ],
    "distribuez": [
        "distribuer"
    ],
    "distribuiez": [
        "distribuer"
    ],
    "distribuions": [
        "distribuer"
    ],
    "distribuons": [
        "distribuer"
    ],
    "distributeur": [
        "distributeur"
    ],
    "distributeurs": [
        "distributeur"
    ],
    "distribution": [
        "distribution"
    ],
    "distributions": [
        "distribution"
    ],
    "distributive": [
        "distributif"
    ],
    "distributrice": [
        "distributeur"
    ],
    "distribuat": [
        "distribuer"
    ],
    "distribuerent": [
        "distribuer"
    ],
    "distribuee": [
        "distribuer",
        "distribue"
    ],
    "distribuees": [
        "distribuer",
        "distribue"
    ],
    "district": [
        "district"
    ],
    "districts": [
        "district"
    ],
    "dit": [
        "dit",
        "dire"
    ],
    "dite": [
        "dit",
        "dire"
    ],
    "dites": [
        "dit",
        "dire"
    ],
    "dithyrambe": [
        "dithyrambe"
    ],
    "dithyrambes": [
        "dithyrambe"
    ],
    "dithyrambique": [
        "dithyrambique"
    ],
    "dithyrambiques": [
        "dithyrambique"
    ],
    "dito": [
        "dito"
    ],
    "dits": [
        "dit",
        "dire"
    ],
    "diurnal": [
        "diurnal"
    ],
    "diurne": [
        "diurne"
    ],
    "diurnes": [
        "diurne"
    ],
    "diurese": [
        "diurese"
    ],
    "diuretique": [
        "diuretique"
    ],
    "diuretiques": [
        "diuretique"
    ],
    "diva": [
        "diva"
    ],
    "divagant": [
        "divagant"
    ],
    "divagants": [
        "divagant"
    ],
    "divagation": [
        "divagation"
    ],
    "divagations": [
        "divagation"
    ],
    "divaguaient": [
        "divaguer"
    ],
    "divaguait": [
        "divaguer"
    ],
    "divaguant": [
        "divaguer"
    ],
    "divague": [
        "divaguer"
    ],
    "divaguent": [
        "divaguer"
    ],
    "divaguer": [
        "divaguer"
    ],
    "divagues": [
        "divaguer"
    ],
    "divaguez": [
        "divaguer"
    ],
    "divan": [
        "divan"
    ],
    "divans": [
        "divan"
    ],
    "divas": [
        "diva"
    ],
    "dive": [
        "dive"
    ],
    "diverge": [
        "diverger"
    ],
    "divergeaient": [
        "diverger"
    ],
    "divergeait": [
        "diverger"
    ],
    "divergeant": [
        "diverger"
    ],
    "divergence": [
        "divergence"
    ],
    "divergences": [
        "divergence"
    ],
    "divergent": [
        "divergent",
        "diverger"
    ],
    "divergente": [
        "divergent"
    ],
    "divergentes": [
        "divergent"
    ],
    "divergents": [
        "divergent"
    ],
    "divergeons": [
        "diverger"
    ],
    "diverger": [
        "diverger"
    ],
    "divergez": [
        "diverger"
    ],
    "divergions": [
        "diverger"
    ],
    "divers": [
        "diver",
        "divers"
    ],
    "diverse": [
        "divers"
    ],
    "diversement": [
        "diversement"
    ],
    "diverses": [
        "diverses",
        "divers"
    ],
    "diversifiant": [
        "diversifier"
    ],
    "diversification": [
        "diversification"
    ],
    "diversifie": [
        "diversifier"
    ],
    "diversifient": [
        "diversifier"
    ],
    "diversifier": [
        "diversifier"
    ],
    "diversifiee": [
        "diversifier"
    ],
    "diversifiees": [
        "diversifier"
    ],
    "diversifies": [
        "diversify",
        "diversifier"
    ],
    "diversion": [
        "diversion"
    ],
    "diversions": [
        "diversion"
    ],
    "diversite": [
        "diversite"
    ],
    "diversites": [
        "diversite"
    ],
    "diverti": [
        "divertir"
    ],
    "diverticule": [
        "diverticule"
    ],
    "diverticulose": [
        "diverticulose"
    ],
    "divertie": [
        "divertir"
    ],
    "divertimento": [
        "divertimento"
    ],
    "divertir": [
        "divertir"
    ],
    "divertira": [
        "divertir"
    ],
    "divertirait": [
        "divertir"
    ],
    "divertirent": [
        "divertir"
    ],
    "divertirons": [
        "divertir"
    ],
    "divertiront": [
        "divertir"
    ],
    "divertis": [
        "divertir"
    ],
    "divertissaient": [
        "divertir"
    ],
    "divertissais": [
        "divertir"
    ],
    "divertissait": [
        "divertir"
    ],
    "divertissant": [
        "divertissant",
        "divertir"
    ],
    "divertissante": [
        "divertissant"
    ],
    "divertissantes": [
        "divertissant"
    ],
    "divertissants": [
        "divertissant"
    ],
    "divertissement": [
        "divertissement"
    ],
    "divertissements": [
        "divertissement"
    ],
    "divertissent": [
        "divertir"
    ],
    "divertissez": [
        "divertir"
    ],
    "divertissons": [
        "divertir"
    ],
    "divertit": [
        "divertir"
    ],
    "dividende": [
        "dividende"
    ],
    "dividendes": [
        "dividende"
    ],
    "divin": [
        "divin"
    ],
    "divination": [
        "divination"
    ],
    "divinations": [
        "divination"
    ],
    "divinatoire": [
        "divinatoire"
    ],
    "divinatoires": [
        "divinatoire"
    ],
    "divinatrice": [
        "divinateur"
    ],
    "divinatrices": [
        "divinateur"
    ],
    "divine": [
        "divin"
    ],
    "divinement": [
        "divinement"
    ],
    "divines": [
        "divine",
        "divin"
    ],
    "divinisaient": [
        "diviniser"
    ],
    "divinisant": [
        "divinisant"
    ],
    "divinise": [
        "diviniser"
    ],
    "divinisez": [
        "diviniser"
    ],
    "divinisee": [
        "diviniser"
    ],
    "divinite": [
        "divinite"
    ],
    "divinites": [
        "divinite"
    ],
    "divins": [
        "divin"
    ],
    "divisa": [
        "diviser"
    ],
    "divisaient": [
        "diviser"
    ],
    "divisais": [
        "diviser"
    ],
    "divisait": [
        "diviser"
    ],
    "divisant": [
        "diviser"
    ],
    "divise": [
        "diviser",
        "divis",
        "divise"
    ],
    "divisent": [
        "diviser"
    ],
    "diviser": [
        "diviser"
    ],
    "divisera": [
        "diviser"
    ],
    "diviserais": [
        "diviser"
    ],
    "diviserait": [
        "diviser"
    ],
    "divises": [
        "diviser",
        "divis",
        "divise"
    ],
    "diviseur": [
        "diviseur"
    ],
    "diviseuse": [
        "diviseur"
    ],
    "divisez": [
        "diviser"
    ],
    "divisible": [
        "divisible"
    ],
    "divisibles": [
        "divisible"
    ],
    "division": [
        "division"
    ],
    "divisionnaire": [
        "divisionnaire"
    ],
    "divisionnaires": [
        "divisionnaire"
    ],
    "divisionnisme": [
        "divisionnisme"
    ],
    "divisions": [
        "division",
        "diviser"
    ],
    "divisons": [
        "diviser"
    ],
    "diviserent": [
        "diviser"
    ],
    "divisee": [
        "diviser",
        "divise"
    ],
    "divisees": [
        "diviser",
        "divise"
    ],
    "divorce": [
        "divorce",
        "divorcer"
    ],
    "divorcent": [
        "divorcer"
    ],
    "divorcer": [
        "divorcer"
    ],
    "divorcera": [
        "divorcer"
    ],
    "divorcerai": [
        "divorcer"
    ],
    "divorcerais": [
        "divorcer"
    ],
    "divorcerait": [
        "divorcer"
    ],
    "divorceras": [
        "divorcer"
    ],
    "divorcerez": [
        "divorcer"
    ],
    "divorceriez": [
        "divorcer"
    ],
    "divorcerons": [
        "divorcer"
    ],
    "divorceront": [
        "divorcer"
    ],
    "divorces": [
        "divorce",
        "divorcer"
    ],
    "divorcez": [
        "divorcer"
    ],
    "divorciez": [
        "divorcer"
    ],
    "divorcions": [
        "divorcer"
    ],
    "divorcerent": [
        "divorcer"
    ],
    "divorcee": [
        "divorcer",
        "divorce"
    ],
    "divorcees": [
        "divorcer",
        "divorce"
    ],
    "divorca": [
        "divorcer"
    ],
    "divorcaient": [
        "divorcer"
    ],
    "divorcait": [
        "divorcer"
    ],
    "divorcant": [
        "divorcer"
    ],
    "divorcons": [
        "divorcer"
    ],
    "divulgation": [
        "divulgation"
    ],
    "divulguait": [
        "divulguer"
    ],
    "divulguant": [
        "divulguer"
    ],
    "divulgue": [
        "divulguer"
    ],
    "divulguer": [
        "divulguer"
    ],
    "divulguera": [
        "divulguer"
    ],
    "divulguez": [
        "divulguer"
    ],
    "divulguons": [
        "divulguer"
    ],
    "divulguee": [
        "divulguer"
    ],
    "divulguees": [
        "divulguer"
    ],
    "divulgues": [
        "divulguer"
    ],
    "dix": [
        "dix"
    ],
    "dixie": [
        "dixie"
    ],
    "dixieland": [
        "dixieland"
    ],
    "dixit": [
        "dixit"
    ],
    "dixieme": [
        "dixieme"
    ],
    "dixiemement": [
        "dixiemement"
    ],
    "dixiemes": [
        "dixieme"
    ],
    "dizain": [
        "dizain"
    ],
    "dizaine": [
        "dizaine"
    ],
    "dizaines": [
        "dizaine"
    ],
    "diedre": [
        "diedre"
    ],
    "diedres": [
        "diedre"
    ],
    "diese": [
        "dieser",
        "diese"
    ],
    "dieses": [
        "dieser",
        "diese"
    ],
    "diete": [
        "diete"
    ],
    "diereses": [
        "dierese"
    ],
    "diethylenique": [
        "diethylenique"
    ],
    "dieteticien": [
        "dieteticien"
    ],
    "dieteticienne": [
        "dieteticien"
    ],
    "dieteticiens": [
        "dieteticien"
    ],
    "dietetique": [
        "dietetique"
    ],
    "dietetiques": [
        "dietetique"
    ],
    "dietetiste": [
        "dietetiste"
    ],
    "djebel": [
        "djebel"
    ],
    "djebels": [
        "djebel"
    ],
    "djellaba": [
        "djellaba"
    ],
    "djellabas": [
        "djellaba"
    ],
    "djemaa": [
        "djemaa"
    ],
    "djihad": [
        "djihad"
    ],
    "djihads": [
        "djihad"
    ],
    "djinn": [
        "djinn"
    ],
    "djinns": [
        "djinn"
    ],
    "dm": [
        "dm"
    ],
    "dna": [
        "dna"
    ],
    "do": [
        "do"
    ],
    "doberman": [
        "doberman"
    ],
    "dobermans": [
        "doberman"
    ],
    "doc": [
        "doc"
    ],
    "doche": [
        "doche"
    ],
    "docile": [
        "docile"
    ],
    "docilement": [
        "docilement"
    ],
    "dociles": [
        "docile"
    ],
    "docilite": [
        "docilite"
    ],
    "dock": [
        "dock"
    ],
    "docker": [
        "docker"
    ],
    "dockers": [
        "docker"
    ],
    "docks": [
        "dock"
    ],
    "docte": [
        "docte"
    ],
    "doctement": [
        "doctement"
    ],
    "doctes": [
        "docte"
    ],
    "docteur": [
        "docteur"
    ],
    "docteurs": [
        "docteur"
    ],
    "doctissime": [
        "doctissime"
    ],
    "doctoral": [
        "doctoral"
    ],
    "doctorale": [
        "doctoral"
    ],
    "doctorat": [
        "doctorat"
    ],
    "doctorats": [
        "doctorat"
    ],
    "doctoresse": [
        "docteur"
    ],
    "doctrina": [
        "doctriner"
    ],
    "doctrinaire": [
        "doctrinaire"
    ],
    "doctrinaires": [
        "doctrinaire"
    ],
    "doctrinal": [
        "doctrinal"
    ],
    "doctrinale": [
        "doctrinal"
    ],
    "doctrinales": [
        "doctrinal"
    ],
    "doctrine": [
        "doctrine"
    ],
    "doctrines": [
        "doctrine"
    ],
    "docudrame": [
        "docudrame"
    ],
    "document": [
        "document"
    ],
    "documenta": [
        "documenter"
    ],
    "documentaire": [
        "documentaire"
    ],
    "documentaires": [
        "documentaire"
    ],
    "documentais": [
        "documenter"
    ],
    "documentait": [
        "documenter"
    ],
    "documentaliste": [
        "documentaliste"
    ],
    "documentalistes": [
        "documentaliste"
    ],
    "documentant": [
        "documenter"
    ],
    "documentariste": [
        "documentariste"
    ],
    "documentaristes": [
        "documentariste"
    ],
    "documentation": [
        "documentation"
    ],
    "documentations": [
        "documentation"
    ],
    "documente": [
        "documente",
        "documenter"
    ],
    "documentent": [
        "documenter"
    ],
    "documenter": [
        "documenter"
    ],
    "documenterai": [
        "documenter"
    ],
    "documentes": [
        "documente",
        "documenter"
    ],
    "documents": [
        "document"
    ],
    "documentee": [
        "documente",
        "documenter"
    ],
    "dodelinaient": [
        "dodeliner"
    ],
    "dodelinais": [
        "dodeliner"
    ],
    "dodelinait": [
        "dodeliner"
    ],
    "dodelinant": [
        "dodelinant",
        "dodeliner"
    ],
    "dodelinante": [
        "dodelinant"
    ],
    "dodelinantes": [
        "dodelinant"
    ],
    "dodeline": [
        "dodeliner"
    ],
    "dodelinent": [
        "dodeliner"
    ],
    "dodeliner": [
        "dodeliner"
    ],
    "dodelinerent": [
        "dodeliner"
    ],
    "dodine": [
        "dodiner"
    ],
    "dodo": [
        "dodo"
    ],
    "dodos": [
        "dodo"
    ],
    "dodu": [
        "dodu"
    ],
    "dodue": [
        "dodu"
    ],
    "dodues": [
        "dodu"
    ],
    "dodus": [
        "dodu"
    ],
    "dodecagone": [
        "dodecagone"
    ],
    "dodecaphoniste": [
        "dodecaphoniste"
    ],
    "dodecaedre": [
        "dodecaedre"
    ],
    "dogaresse": [
        "dogaresse"
    ],
    "dogaresses": [
        "dogaresse"
    ],
    "doge": [
        "doge"
    ],
    "doges": [
        "doge"
    ],
    "dogger": [
        "dogger"
    ],
    "dogmatique": [
        "dogmatique"
    ],
    "dogmatiques": [
        "dogmatique"
    ],
    "dogmatisme": [
        "dogmatisme"
    ],
    "dogme": [
        "dogme"
    ],
    "dogmes": [
        "dogme"
    ],
    "dogue": [
        "dogue"
    ],
    "dogues": [
        "dogue"
    ],
    "doguin": [
        "doguin"
    ],
    "doigt": [
        "doigt"
    ],
    "doigta": [
        "doigter"
    ],
    "doigtait": [
        "doigter"
    ],
    "doigter": [
        "doigter"
    ],
    "doigtier": [
        "doigtier"
    ],
    "doigts": [
        "doigt"
    ],
    "doigte": [
        "doigter",
        "doigte"
    ],
    "dois": [
        "devoir"
    ],
    "doit": [
        "devoir",
        "doit"
    ],
    "doive": [
        "devoir"
    ],
    "doivent": [
        "devoir"
    ],
    "doives": [
        "devoir"
    ],
    "dojo": [
        "dojo"
    ],
    "dol": [
        "dol"
    ],
    "dolby": [
        "dolby"
    ],
    "dolce": [
        "dolce"
    ],
    "dolent": [
        "dolent"
    ],
    "dolente": [
        "dolent"
    ],
    "dolentes": [
        "dolent"
    ],
    "dolents": [
        "dolent"
    ],
    "dolichocephale": [
        "dolichocephale"
    ],
    "dolichocephales": [
        "dolichocephale"
    ],
    "dolichocephalie": [
        "dolichocephalie"
    ],
    "doline": [
        "doline"
    ],
    "dolique": [
        "dolique"
    ],
    "dollar": [
        "dollar"
    ],
    "dollars": [
        "dollar"
    ],
    "dolman": [
        "dolman"
    ],
    "dolmans": [
        "dolman"
    ],
    "dolmen": [
        "dolmen"
    ],
    "dolmens": [
        "dolmen"
    ],
    "dolomies": [
        "dolomie"
    ],
    "dolomite": [
        "dolomite"
    ],
    "dolorisme": [
        "dolorisme"
    ],
    "doloriste": [
        "doloriste"
    ],
    "doleance": [
        "doleance"
    ],
    "doleances": [
        "doleance"
    ],
    "dom": [
        "dom"
    ],
    "domaine": [
        "domaine"
    ],
    "domaines": [
        "domaine"
    ],
    "domanial": [
        "domanial"
    ],
    "domaniale": [
        "domanial"
    ],
    "domaniaux": [
        "domanial"
    ],
    "domestication": [
        "domestication"
    ],
    "domesticite": [
        "domesticite"
    ],
    "domestiqua": [
        "domestiquer"
    ],
    "domestiquait": [
        "domestiquer"
    ],
    "domestique": [
        "domestique",
        "domestiquer"
    ],
    "domestiquement": [
        "domestiquement"
    ],
    "domestiquer": [
        "domestiquer"
    ],
    "domestiques": [
        "domestique",
        "domestiquer"
    ],
    "domestiquez": [
        "domestiquer"
    ],
    "domestiquee": [
        "domestiquer"
    ],
    "domestiquees": [
        "domestiquer"
    ],
    "domicile": [
        "domicile"
    ],
    "domiciles": [
        "domicile"
    ],
    "domiciliaires": [
        "domiciliaire"
    ],
    "domiciliation": [
        "domiciliation"
    ],
    "domicilier": [
        "domicilier"
    ],
    "domicilie": [
        "domicilie",
        "domicilier"
    ],
    "domiciliee": [
        "domicilie",
        "domicilier"
    ],
    "domicilies": [
        "domicilie",
        "domicilier"
    ],
    "domina": [
        "dominer"
    ],
    "dominaient": [
        "dominer"
    ],
    "dominais": [
        "dominer"
    ],
    "dominait": [
        "dominer"
    ],
    "dominance": [
        "dominance"
    ],
    "dominant": [
        "dominant",
        "dominer"
    ],
    "dominante": [
        "dominant",
        "dominante"
    ],
    "dominantes": [
        "dominant",
        "dominante"
    ],
    "dominants": [
        "dominant"
    ],
    "dominateur": [
        "dominateur"
    ],
    "dominateurs": [
        "dominateur"
    ],
    "domination": [
        "domination"
    ],
    "dominations": [
        "domination"
    ],
    "dominatrice": [
        "dominateur"
    ],
    "dominatrices": [
        "dominateur"
    ],
    "domine": [
        "dominer"
    ],
    "dominent": [
        "dominer"
    ],
    "dominer": [
        "dominer"
    ],
    "dominera": [
        "dominer"
    ],
    "dominerai": [
        "dominer"
    ],
    "domineraient": [
        "dominer"
    ],
    "dominerais": [
        "dominer"
    ],
    "dominerait": [
        "dominer"
    ],
    "domineras": [
        "dominer"
    ],
    "domineriez": [
        "dominer"
    ],
    "dominerions": [
        "dominer"
    ],
    "dominerons": [
        "dominer"
    ],
    "domineront": [
        "dominer"
    ],
    "domines": [
        "dominer"
    ],
    "dominez": [
        "dominer"
    ],
    "dominicain": [
        "dominicain"
    ],
    "dominicaine": [
        "dominicain"
    ],
    "dominicaines": [
        "dominicain"
    ],
    "dominicains": [
        "dominicain"
    ],
    "dominical": [
        "dominical"
    ],
    "dominicale": [
        "dominical"
    ],
    "dominicales": [
        "dominical"
    ],
    "dominicaux": [
        "dominical"
    ],
    "dominiez": [
        "dominer"
    ],
    "dominion": [
        "dominion"
    ],
    "dominions": [
        "dominion",
        "dominer"
    ],
    "domino": [
        "domino"
    ],
    "dominons": [
        "dominer"
    ],
    "dominos": [
        "domino"
    ],
    "dominat": [
        "dominer"
    ],
    "dominerent": [
        "dominer"
    ],
    "dominee": [
        "dominer"
    ],
    "dominees": [
        "dominer"
    ],
    "dommage": [
        "dommage"
    ],
    "dommageable": [
        "dommageable"
    ],
    "dommageables": [
        "dommageable"
    ],
    "dommages": [
        "dommage"
    ],
    "domotique": [
        "domotique"
    ],
    "dompta": [
        "dompter"
    ],
    "domptage": [
        "domptage"
    ],
    "domptai": [
        "dompter"
    ],
    "domptait": [
        "dompter"
    ],
    "dompte": [
        "dompter",
        "dompte"
    ],
    "domptent": [
        "dompter"
    ],
    "dompter": [
        "dompter"
    ],
    "dompterai": [
        "dompter"
    ],
    "dompterait": [
        "dompter"
    ],
    "dompteur": [
        "dompteur"
    ],
    "dompteurs": [
        "dompteur"
    ],
    "dompteuse": [
        "dompteur"
    ],
    "dompteuses": [
        "dompteur"
    ],
    "domptez": [
        "dompter"
    ],
    "domptee": [
        "dompter",
        "dompte"
    ],
    "domptees": [
        "dompte"
    ],
    "domptes": [
        "dompter",
        "dompte"
    ],
    "don": [
        "don"
    ],
    "dona": [
        "dona"
    ],
    "donateur": [
        "donateur"
    ],
    "donateurs": [
        "donateur"
    ],
    "donation": [
        "donation"
    ],
    "donations": [
        "donation"
    ],
    "donatrice": [
        "donateur"
    ],
    "donc": [
        "donc"
    ],
    "dondaine": [
        "dondaine"
    ],
    "dondaines": [
        "dondaine"
    ],
    "dondon": [
        "dondon"
    ],
    "dondons": [
        "dondon"
    ],
    "dong": [
        "dong"
    ],
    "donjon": [
        "donjon"
    ],
    "donjons": [
        "donjon"
    ],
    "donjuanesque": [
        "donjuanesque"
    ],
    "donjuanisme": [
        "donjuanisme"
    ],
    "donna": [
        "donner"
    ],
    "donnai": [
        "donner"
    ],
    "donnaient": [
        "donner"
    ],
    "donnais": [
        "donner"
    ],
    "donnait": [
        "donner"
    ],
    "donnant": [
        "donner",
        "donnant"
    ],
    "donnas": [
        "donna",
        "donner"
    ],
    "donnassent": [
        "donner"
    ],
    "donne": [
        "donner",
        "donne"
    ],
    "donnent": [
        "donner"
    ],
    "donner": [
        "donner"
    ],
    "donnera": [
        "donner"
    ],
    "donnerai": [
        "donner"
    ],
    "donneraient": [
        "donner"
    ],
    "donnerais": [
        "donner"
    ],
    "donnerait": [
        "donner"
    ],
    "donneras": [
        "donner"
    ],
    "donnerez": [
        "donner"
    ],
    "donneriez": [
        "donner"
    ],
    "donnerions": [
        "donner"
    ],
    "donnerons": [
        "donner"
    ],
    "donneront": [
        "donner"
    ],
    "donnes": [
        "donner",
        "donne"
    ],
    "donneur": [
        "donneur"
    ],
    "donneurs": [
        "donneur"
    ],
    "donneuse": [
        "donneur"
    ],
    "donneuses": [
        "donneur"
    ],
    "donnez": [
        "donner"
    ],
    "donniez": [
        "donner"
    ],
    "donnions": [
        "donner"
    ],
    "donnons": [
        "donner"
    ],
    "donnames": [
        "donner"
    ],
    "donnat": [
        "donner"
    ],
    "donnerent": [
        "donner"
    ],
    "donnee": [
        "donner",
        "donnee",
        "donne"
    ],
    "donnees": [
        "donner",
        "donnee",
        "donne"
    ],
    "donquichottesque": [
        "donquichottesque"
    ],
    "donquichottesques": [
        "donquichottesque"
    ],
    "donquichottisme": [
        "donquichottisme"
    ],
    "dons": [
        "don"
    ],
    "dont": [
        "dont"
    ],
    "donzelle": [
        "donzelle"
    ],
    "donzelles": [
        "donzelle"
    ],
    "dopage": [
        "dopage"
    ],
    "dopais": [
        "doper"
    ],
    "dopait": [
        "doper"
    ],
    "dopamine": [
        "dopamine"
    ],
    "dopant": [
        "dopant",
        "doper"
    ],
    "dopants": [
        "dopant"
    ],
    "dope": [
        "dope",
        "doper"
    ],
    "doper": [
        "doper"
    ],
    "dopes": [
        "dope",
        "doper"
    ],
    "dopez": [
        "doper"
    ],
    "doping": [
        "dope",
        "doping"
    ],
    "doppler": [
        "doppler"
    ],
    "dopee": [
        "doper"
    ],
    "dora": [
        "dorer"
    ],
    "dorade": [
        "dorade"
    ],
    "dorades": [
        "dorade"
    ],
    "dorage": [
        "dorage"
    ],
    "doraient": [
        "dorer"
    ],
    "dorais": [
        "dorer"
    ],
    "dorait": [
        "dorer"
    ],
    "dorant": [
        "dorer"
    ],
    "dorcades": [
        "dorcade"
    ],
    "dore": [
        "dore",
        "dorer"
    ],
    "dorent": [
        "dorer"
    ],
    "dorer": [
        "dorer"
    ],
    "dorera": [
        "dorer"
    ],
    "doreront": [
        "dorer"
    ],
    "doreurs": [
        "doreur"
    ],
    "doriennes": [
        "dorien"
    ],
    "doriens": [
        "dorien"
    ],
    "dorique": [
        "dorique"
    ],
    "doriques": [
        "dorique"
    ],
    "dorlotait": [
        "dorloter"
    ],
    "dorlotant": [
        "dorloter"
    ],
    "dorlote": [
        "dorloter"
    ],
    "dorlotent": [
        "dorloter"
    ],
    "dorloter": [
        "dorloter"
    ],
    "dorloterai": [
        "dorloter"
    ],
    "dorloterons": [
        "dorloter"
    ],
    "dorlotez": [
        "dorloter"
    ],
    "dorlotee": [
        "dorloter"
    ],
    "dorlotees": [
        "dorloter"
    ],
    "dorlotes": [
        "dorloter"
    ],
    "dormaient": [
        "dormir"
    ],
    "dormais": [
        "dormir"
    ],
    "dormait": [
        "dormir"
    ],
    "dormance": [
        "dormance"
    ],
    "dormant": [
        "dormant",
        "dormir"
    ],
    "dormante": [
        "dormant"
    ],
    "dormantes": [
        "dormant"
    ],
    "dormants": [
        "dormant"
    ],
    "dorme": [
        "dormir"
    ],
    "dorment": [
        "dormir"
    ],
    "dormes": [
        "dormir"
    ],
    "dormeur": [
        "dormeur"
    ],
    "dormeurs": [
        "dormeur"
    ],
    "dormeuse": [
        "dormeur"
    ],
    "dormeuses": [
        "dormeur"
    ],
    "dormez": [
        "dormir"
    ],
    "dormi": [
        "dormir"
    ],
    "dormiez": [
        "dormir"
    ],
    "dormions": [
        "dormir"
    ],
    "dormir": [
        "dormir"
    ],
    "dormira": [
        "dormir"
    ],
    "dormirai": [
        "dormir"
    ],
    "dormiraient": [
        "dormir"
    ],
    "dormirais": [
        "dormir"
    ],
    "dormirait": [
        "dormir"
    ],
    "dormiras": [
        "dormir"
    ],
    "dormirent": [
        "dormir"
    ],
    "dormirez": [
        "dormir"
    ],
    "dormiriez": [
        "dormir"
    ],
    "dormirions": [
        "dormir"
    ],
    "dormirons": [
        "dormir"
    ],
    "dormiront": [
        "dormir"
    ],
    "dormis": [
        "dormir"
    ],
    "dormit": [
        "dormir"
    ],
    "dormitif": [
        "dormitif"
    ],
    "dormition": [
        "dormition"
    ],
    "dormons": [
        "dormir"
    ],
    "dormimes": [
        "dormir"
    ],
    "dors": [
        "dormir"
    ],
    "dorsal": [
        "dorsal"
    ],
    "dorsale": [
        "dorsale",
        "dorsal"
    ],
    "dorsales": [
        "dorsal"
    ],
    "dorsaux": [
        "dorsal"
    ],
    "dort": [
        "dormir"
    ],
    "dortoir": [
        "dortoir"
    ],
    "dortoirs": [
        "dortoir"
    ],
    "dorure": [
        "dorure"
    ],
    "dorures": [
        "dorure"
    ],
    "doryphore": [
        "doryphore"
    ],
    "doryphores": [
        "doryphore"
    ],
    "doree": [
        "dore",
        "dorer",
        "doree"
    ],
    "dorees": [
        "dore",
        "dorer",
        "doree"
    ],
    "dorenavant": [
        "dorenavant"
    ],
    "dores": [
        "dore",
        "dorer"
    ],
    "dos": [
        "dos"
    ],
    "dosage": [
        "dosage"
    ],
    "dosages": [
        "dosage"
    ],
    "dosaient": [
        "doser"
    ],
    "dosais": [
        "doser"
    ],
    "dosait": [
        "doser"
    ],
    "dosant": [
        "doser"
    ],
    "dose": [
        "dose",
        "doser"
    ],
    "dosent": [
        "doser"
    ],
    "doser": [
        "doser"
    ],
    "doses": [
        "dose",
        "doser"
    ],
    "doseur": [
        "doseur"
    ],
    "doseurs": [
        "doseur"
    ],
    "dosimetre": [
        "dosimetre"
    ],
    "dossard": [
        "dossard"
    ],
    "dossards": [
        "dossard"
    ],
    "dosseret": [
        "dosseret"
    ],
    "dossier": [
        "dossier"
    ],
    "dossiers": [
        "dossier"
    ],
    "dossiere": [
        "dossiere"
    ],
    "dossieres": [
        "dossiere"
    ],
    "dostoievskiens": [
        "dostoievskien"
    ],
    "dosee": [
        "doser"
    ],
    "dosees": [
        "doser"
    ],
    "dot": [
        "dot"
    ],
    "dota": [
        "doter"
    ],
    "dotaient": [
        "doter"
    ],
    "dotait": [
        "doter"
    ],
    "dotant": [
        "doter"
    ],
    "dotation": [
        "dotation"
    ],
    "dote": [
        "doter",
        "dote"
    ],
    "doter": [
        "doter"
    ],
    "dots": [
        "dot"
    ],
    "dotee": [
        "doter",
        "dote"
    ],
    "dotees": [
        "doter",
        "dote"
    ],
    "dotes": [
        "doter",
        "dote"
    ],
    "douaire": [
        "douaire"
    ],
    "douairiere": [
        "douairier"
    ],
    "douairieres": [
        "douairier"
    ],
    "douait": [
        "douer"
    ],
    "douane": [
        "douane"
    ],
    "douanes": [
        "douane"
    ],
    "douanier": [
        "douanier"
    ],
    "douaniers": [
        "douanier"
    ],
    "douaniere": [
        "douanier"
    ],
    "douanieres": [
        "douanier"
    ],
    "douar": [
        "douar"
    ],
    "douars": [
        "douar"
    ],
    "doubla": [
        "doubler"
    ],
    "doublage": [
        "doublage"
    ],
    "doublages": [
        "doublage"
    ],
    "doublai": [
        "doubler"
    ],
    "doublaient": [
        "doubler"
    ],
    "doublais": [
        "doubler"
    ],
    "doublait": [
        "doubler"
    ],
    "doublant": [
        "doubler"
    ],
    "doublard": [
        "doublard"
    ],
    "doublards": [
        "doublard"
    ],
    "double": [
        "doubler",
        "double"
    ],
    "doubleau": [
        "doubleau"
    ],
    "doubleaux": [
        "doubleau"
    ],
    "doublement": [
        "doublement"
    ],
    "doublent": [
        "doubler"
    ],
    "doubler": [
        "doubler"
    ],
    "doublera": [
        "doubler"
    ],
    "doublerai": [
        "doubler"
    ],
    "doubleraient": [
        "doubler"
    ],
    "doublerait": [
        "doubler"
    ],
    "doublerez": [
        "doubler"
    ],
    "doublerons": [
        "doubler"
    ],
    "doubles": [
        "doubler",
        "double"
    ],
    "doublet": [
        "doublet"
    ],
    "doublets": [
        "doublet"
    ],
    "doublette": [
        "doublette"
    ],
    "doubleur": [
        "doubleur"
    ],
    "doubleuse": [
        "doubleur"
    ],
    "doubleuses": [
        "doubleur"
    ],
    "doublez": [
        "doubler"
    ],
    "doubliez": [
        "doubler"
    ],
    "doublions": [
        "doubler"
    ],
    "doublon": [
        "doublon"
    ],
    "doublonner": [
        "doublonner"
    ],
    "doublons": [
        "doubler",
        "doublon"
    ],
    "doublure": [
        "doublure"
    ],
    "doublures": [
        "doublure"
    ],
    "doublat": [
        "doubler"
    ],
    "doublerent": [
        "doubler"
    ],
    "doublee": [
        "doubler",
        "double"
    ],
    "doublees": [
        "doubler",
        "double"
    ],
    "douce": [
        "doux",
        "douce"
    ],
    "doucement": [
        "doucement"
    ],
    "doucereuse": [
        "doucereux"
    ],
    "doucereusement": [
        "doucereusement"
    ],
    "doucereuses": [
        "doucereux"
    ],
    "doucereux": [
        "doucereux"
    ],
    "douces": [
        "doux"
    ],
    "doucet": [
        "doucet"
    ],
    "doucette": [
        "doucet",
        "doucette"
    ],
    "doucettement": [
        "doucettement"
    ],
    "douceur": [
        "douceur"
    ],
    "douceurs": [
        "douceur"
    ],
    "douceatre": [
        "douceatre"
    ],
    "douceatres": [
        "douceatre"
    ],
    "doucha": [
        "doucher"
    ],
    "douchais": [
        "doucher"
    ],
    "douchait": [
        "doucher"
    ],
    "douchant": [
        "doucher"
    ],
    "douche": [
        "doucher",
        "douche"
    ],
    "douchent": [
        "doucher"
    ],
    "doucher": [
        "doucher"
    ],
    "douchera": [
        "doucher"
    ],
    "doucherai": [
        "doucher"
    ],
    "doucheras": [
        "doucher"
    ],
    "douches": [
        "doucher",
        "douche"
    ],
    "doucheur": [
        "doucheur"
    ],
    "douchez": [
        "doucher"
    ],
    "douchiez": [
        "doucher"
    ],
    "douchons": [
        "doucher"
    ],
    "douchee": [
        "doucher"
    ],
    "doucie": [
        "doucir"
    ],
    "doucin": [
        "doucin"
    ],
    "doucine": [
        "doucine"
    ],
    "doucins": [
        "doucin"
    ],
    "doudou": [
        "doudou"
    ],
    "doudoune": [
        "doudoune"
    ],
    "doudounes": [
        "doudoune"
    ],
    "douelle": [
        "douelle"
    ],
    "douelles": [
        "douelle"
    ],
    "douer": [
        "douer"
    ],
    "douglas": [
        "douglas"
    ],
    "douillait": [
        "douiller"
    ],
    "douille": [
        "douille",
        "douiller"
    ],
    "douillent": [
        "douiller"
    ],
    "douiller": [
        "douiller"
    ],
    "douillera": [
        "douiller"
    ],
    "douilles": [
        "douille",
        "douiller"
    ],
    "douillet": [
        "douillet"
    ],
    "douillets": [
        "douillet"
    ],
    "douillette": [
        "douillette",
        "douillet"
    ],
    "douillettement": [
        "douillettement"
    ],
    "douillettes": [
        "douillette",
        "douillet"
    ],
    "douillons": [
        "douillon"
    ],
    "douillee": [
        "douiller"
    ],
    "douleur": [
        "douleur"
    ],
    "douleurs": [
        "douleur"
    ],
    "douloureuse": [
        "douloureux"
    ],
    "douloureusement": [
        "douloureusement"
    ],
    "douloureuses": [
        "douloureux"
    ],
    "douloureux": [
        "douloureux"
    ],
    "douma": [
        "douma"
    ],
    "doura": [
        "doura"
    ],
    "douro": [
        "douro"
    ],
    "douros": [
        "douro"
    ],
    "douta": [
        "douter"
    ],
    "doutai": [
        "douter"
    ],
    "doutaient": [
        "douter"
    ],
    "doutais": [
        "douter"
    ],
    "doutait": [
        "douter"
    ],
    "doutance": [
        "doutance"
    ],
    "doutances": [
        "doutance"
    ],
    "doutant": [
        "douter"
    ],
    "doute": [
        "doute",
        "douter"
    ],
    "doutent": [
        "douter"
    ],
    "douter": [
        "douter"
    ],
    "doutera": [
        "douter"
    ],
    "douterai": [
        "douter"
    ],
    "douterais": [
        "douter"
    ],
    "douterait": [
        "douter"
    ],
    "douteras": [
        "douter"
    ],
    "douterez": [
        "douter"
    ],
    "douteriez": [
        "douter"
    ],
    "douteront": [
        "douter"
    ],
    "doutes": [
        "doute",
        "douter"
    ],
    "douteurs": [
        "douteur"
    ],
    "douteuse": [
        "douteux"
    ],
    "douteusement": [
        "douteusement"
    ],
    "douteuses": [
        "douteux"
    ],
    "douteux": [
        "douteux"
    ],
    "doutez": [
        "douter"
    ],
    "doutiez": [
        "douter"
    ],
    "doutions": [
        "douter"
    ],
    "doutons": [
        "douter"
    ],
    "doutat": [
        "douter"
    ],
    "douterent": [
        "douter"
    ],
    "doutee": [
        "douter"
    ],
    "douve": [
        "douve"
    ],
    "douves": [
        "douve"
    ],
    "doux": [
        "doux"
    ],
    "douzaine": [
        "douzaine"
    ],
    "douzaines": [
        "douzaine"
    ],
    "douze": [
        "douze"
    ],
    "douzieme": [
        "douzieme"
    ],
    "douziemes": [
        "douzieme"
    ],
    "doucatre": [
        "doucatre"
    ],
    "doue": [
        "doue",
        "douer"
    ],
    "douee": [
        "doue",
        "douer"
    ],
    "douees": [
        "doue",
        "douer"
    ],
    "doues": [
        "doue",
        "douer"
    ],
    "down": [
        "down"
    ],
    "doyen": [
        "doyen"
    ],
    "doyenne": [
        "doyenne",
        "doyen"
    ],
    "doyens": [
        "doyen"
    ],
    "drache": [
        "dracher"
    ],
    "drachme": [
        "drachme"
    ],
    "drachmes": [
        "drachme"
    ],
    "draconien": [
        "draconien"
    ],
    "draconienne": [
        "draconien"
    ],
    "draconiennes": [
        "draconien"
    ],
    "draconiens": [
        "draconien"
    ],
    "drag": [
        "drag"
    ],
    "dragage": [
        "dragage"
    ],
    "drageoir": [
        "drageoir"
    ],
    "drageoirs": [
        "drageoir"
    ],
    "dragon": [
        "dragon"
    ],
    "dragonnades": [
        "dragonnade"
    ],
    "dragonne": [
        "dragon"
    ],
    "dragonnier": [
        "dragonnier"
    ],
    "dragons": [
        "dragon"
    ],
    "drags": [
        "drag"
    ],
    "dragster": [
        "dragster"
    ],
    "dragua": [
        "draguer"
    ],
    "draguaient": [
        "draguer"
    ],
    "draguais": [
        "draguer"
    ],
    "draguait": [
        "draguer"
    ],
    "draguant": [
        "draguer"
    ],
    "drague": [
        "draguer",
        "drague"
    ],
    "draguent": [
        "draguer"
    ],
    "draguer": [
        "draguer"
    ],
    "draguera": [
        "draguer"
    ],
    "draguerai": [
        "draguer"
    ],
    "draguerais": [
        "draguer"
    ],
    "draguerait": [
        "draguer"
    ],
    "dragues": [
        "draguer",
        "drague"
    ],
    "dragueur": [
        "dragueur"
    ],
    "dragueurs": [
        "dragueur"
    ],
    "dragueuse": [
        "dragueur"
    ],
    "draguez": [
        "draguer"
    ],
    "draguiez": [
        "draguer"
    ],
    "draguons": [
        "draguer"
    ],
    "draguee": [
        "draguer"
    ],
    "draguees": [
        "draguer"
    ],
    "dragee": [
        "dragee"
    ],
    "dragees": [
        "dragee"
    ],
    "drailles": [
        "draille"
    ],
    "drain": [
        "drain"
    ],
    "draina": [
        "drainer"
    ],
    "drainage": [
        "drainage"
    ],
    "drainages": [
        "drainage"
    ],
    "drainaient": [
        "drainer"
    ],
    "drainait": [
        "drainer"
    ],
    "drainant": [
        "drainer"
    ],
    "draine": [
        "drainer"
    ],
    "drainent": [
        "drainer"
    ],
    "drainer": [
        "drainer"
    ],
    "drainera": [
        "drainer"
    ],
    "drainons": [
        "drainer"
    ],
    "drains": [
        "drain"
    ],
    "drainees": [
        "drainer"
    ],
    "draines": [
        "drainer"
    ],
    "draisienne": [
        "draisienne"
    ],
    "draisine": [
        "draisine"
    ],
    "drakkar": [
        "drakkar"
    ],
    "drakkars": [
        "drakkar"
    ],
    "dramatique": [
        "dramatique"
    ],
    "dramatiquement": [
        "dramatiquement"
    ],
    "dramatiques": [
        "dramatique"
    ],
    "dramatisait": [
        "dramatiser"
    ],
    "dramatisant": [
        "dramatiser"
    ],
    "dramatisation": [
        "dramatisation"
    ],
    "dramatise": [
        "dramatiser"
    ],
    "dramatisent": [
        "dramatiser"
    ],
    "dramatiser": [
        "dramatiser"
    ],
    "dramatises": [
        "dramatiser"
    ],
    "dramatisez": [
        "dramatiser"
    ],
    "dramatisons": [
        "dramatiser"
    ],
    "dramatisee": [
        "dramatiser"
    ],
    "dramaturge": [
        "dramaturge"
    ],
    "dramaturges": [
        "dramaturge"
    ],
    "dramaturgie": [
        "dramaturgie"
    ],
    "drame": [
        "drame"
    ],
    "drames": [
        "drame"
    ],
    "drap": [
        "drap"
    ],
    "drapa": [
        "draper"
    ],
    "drapai": [
        "draper"
    ],
    "drapaient": [
        "draper"
    ],
    "drapait": [
        "draper"
    ],
    "drapant": [
        "draper"
    ],
    "drape": [
        "drape",
        "draper"
    ],
    "drapeau": [
        "drapeau"
    ],
    "drapeaux": [
        "drapeau"
    ],
    "drapelets": [
        "drapelet"
    ],
    "drapent": [
        "draper"
    ],
    "draper": [
        "draper"
    ],
    "draperaient": [
        "draper"
    ],
    "draperez": [
        "draper"
    ],
    "draperie": [
        "draperie"
    ],
    "draperies": [
        "draperie"
    ],
    "drapier": [
        "drapier"
    ],
    "drapiers": [
        "drapier"
    ],
    "draps": [
        "drap"
    ],
    "draperent": [
        "draper"
    ],
    "drapee": [
        "draper"
    ],
    "drapees": [
        "draper"
    ],
    "drapes": [
        "drape",
        "draper"
    ],
    "drastique": [
        "drastique"
    ],
    "drastiquement": [
        "drastiquement"
    ],
    "drastiques": [
        "drastique"
    ],
    "drave": [
        "drave"
    ],
    "draveurs": [
        "draveur"
    ],
    "dreadlocks": [
        "dreadlocks"
    ],
    "drelin": [
        "drelin"
    ],
    "drepou": [
        "drepou"
    ],
    "dressa": [
        "dresser"
    ],
    "dressage": [
        "dressage"
    ],
    "dressages": [
        "dressage"
    ],
    "dressai": [
        "dresser"
    ],
    "dressaient": [
        "dresser"
    ],
    "dressais": [
        "dresser"
    ],
    "dressait": [
        "dresser"
    ],
    "dressant": [
        "dresser",
        "dressant"
    ],
    "dresse": [
        "dresse",
        "dresser"
    ],
    "dressement": [
        "dressement"
    ],
    "dressent": [
        "dresser"
    ],
    "dresser": [
        "dresser"
    ],
    "dressera": [
        "dresser"
    ],
    "dresserai": [
        "dresser"
    ],
    "dresseraient": [
        "dresser"
    ],
    "dresserait": [
        "dresser"
    ],
    "dresseras": [
        "dresser"
    ],
    "dresserons": [
        "dresser"
    ],
    "dresseront": [
        "dresser"
    ],
    "dresses": [
        "dresse",
        "dress",
        "dresser"
    ],
    "dresseur": [
        "dresseur"
    ],
    "dresseurs": [
        "dresseur"
    ],
    "dresseuse": [
        "dresseur"
    ],
    "dressez": [
        "dresser"
    ],
    "dressing": [
        "dress",
        "dressing"
    ],
    "dressions": [
        "dresser"
    ],
    "dressoir": [
        "dressoir"
    ],
    "dressoirs": [
        "dressoir"
    ],
    "dressons": [
        "dresser"
    ],
    "dressat": [
        "dresser"
    ],
    "dresserent": [
        "dresser"
    ],
    "dressee": [
        "dresse",
        "dresser"
    ],
    "dressees": [
        "dresse",
        "dresser"
    ],
    "dreyfusard": [
        "dreyfusard"
    ],
    "dreyfusards": [
        "dreyfusard"
    ],
    "dreyfusisme": [
        "dreyfusisme"
    ],
    "dribbla": [
        "dribbler"
    ],
    "dribblais": [
        "dribbler"
    ],
    "dribblait": [
        "dribbler"
    ],
    "dribble": [
        "dribbler",
        "dribble"
    ],
    "dribbler": [
        "dribbler"
    ],
    "dribbles": [
        "dribbler",
        "dribble"
    ],
    "dribbleur": [
        "dribbleur"
    ],
    "dribblez": [
        "dribbler"
    ],
    "drible": [
        "dribler"
    ],
    "dribler": [
        "dribler"
    ],
    "drift": [
        "drift"
    ],
    "drifter": [
        "drifter"
    ],
    "drifters": [
        "drifter"
    ],
    "drill": [
        "drill"
    ],
    "drille": [
        "drille"
    ],
    "drilles": [
        "drille"
    ],
    "dring": [
        "dring"
    ],
    "drink": [
        "drink"
    ],
    "drinks": [
        "drink"
    ],
    "drisse": [
        "drisse"
    ],
    "drisses": [
        "drisse"
    ],
    "drivait": [
        "driver"
    ],
    "drivant": [
        "driver"
    ],
    "drive": [
        "driver",
        "drive"
    ],
    "driver": [
        "driver"
    ],
    "drivers": [
        "driver"
    ],
    "drives": [
        "drive"
    ],
    "drivee": [
        "driver"
    ],
    "drogman": [
        "drogman"
    ],
    "drogmans": [
        "drogman"
    ],
    "droguaient": [
        "droguer"
    ],
    "droguais": [
        "droguer"
    ],
    "droguait": [
        "droguer"
    ],
    "droguant": [
        "droguer"
    ],
    "drogue": [
        "drogue",
        "droguer"
    ],
    "droguent": [
        "droguer"
    ],
    "droguer": [
        "droguer"
    ],
    "droguerie": [
        "droguerie"
    ],
    "drogueries": [
        "droguerie"
    ],
    "drogues": [
        "drogue",
        "droguer"
    ],
    "droguet": [
        "droguet"
    ],
    "droguets": [
        "droguet"
    ],
    "droguez": [
        "droguer"
    ],
    "droguiez": [
        "droguer"
    ],
    "droguiste": [
        "droguiste"
    ],
    "droguistes": [
        "droguiste"
    ],
    "droguee": [
        "drogue",
        "droguer"
    ],
    "droguees": [
        "drogue",
        "droguer"
    ],
    "droicos": [
        "droico"
    ],
    "droit": [
        "droit"
    ],
    "droite": [
        "droit",
        "droite"
    ],
    "droitement": [
        "droitement"
    ],
    "droites": [
        "droit",
        "droite"
    ],
    "droitier": [
        "droitier"
    ],
    "droitiers": [
        "droitier"
    ],
    "droitiere": [
        "droitier"
    ],
    "droits": [
        "droit"
    ],
    "droiture": [
        "droiture"
    ],
    "drolatique": [
        "drolatique"
    ],
    "drolatiques": [
        "drolatique"
    ],
    "dromadaire": [
        "dromadaire"
    ],
    "dromadaires": [
        "dromadaire"
    ],
    "drome": [
        "drome"
    ],
    "dromes": [
        "drome"
    ],
    "drone": [
        "drone"
    ],
    "drones": [
        "drone"
    ],
    "dronte": [
        "dronte"
    ],
    "drop": [
        "drop"
    ],
    "drope": [
        "droper"
    ],
    "dropent": [
        "droper"
    ],
    "droppage": [
        "droppage"
    ],
    "droppant": [
        "dropper"
    ],
    "droppe": [
        "dropper"
    ],
    "drosophile": [
        "drosophile"
    ],
    "drosophiles": [
        "drosophile"
    ],
    "dross": [
        "dross"
    ],
    "drossait": [
        "drosser"
    ],
    "drossant": [
        "drosser"
    ],
    "drossart": [
        "drossart"
    ],
    "drosser": [
        "drosser"
    ],
    "drosse": [
        "drosser"
    ],
    "drossee": [
        "drosser"
    ],
    "drosses": [
        "drosser"
    ],
    "drosera": [
        "drosera"
    ],
    "dru": [
        "dru"
    ],
    "drue": [
        "dru"
    ],
    "drues": [
        "dru"
    ],
    "drugstore": [
        "drugstore"
    ],
    "drugstores": [
        "drugstore"
    ],
    "druide": [
        "druide"
    ],
    "druides": [
        "druide"
    ],
    "druidesse": [
        "druidesse"
    ],
    "druidesses": [
        "druidesse"
    ],
    "druidique": [
        "druidique"
    ],
    "druidiques": [
        "druidique"
    ],
    "druidisme": [
        "druidisme"
    ],
    "drumlin": [
        "drumlin"
    ],
    "drummer": [
        "drummer"
    ],
    "drums": [
        "drum",
        "drums"
    ],
    "drus": [
        "dru"
    ],
    "druze": [
        "druze"
    ],
    "druzes": [
        "druze"
    ],
    "dry": [
        "dry"
    ],
    "dryade": [
        "dryade"
    ],
    "dryades": [
        "dryade"
    ],
    "drege": [
        "drege"
    ],
    "drepanocytose": [
        "drepanocytose"
    ],
    "drole": [
        "drole"
    ],
    "drolement": [
        "drolement"
    ],
    "drolerie": [
        "drolerie"
    ],
    "droleries": [
        "drolerie"
    ],
    "droles": [
        "drole"
    ],
    "drolesse": [
        "drolesse"
    ],
    "drolesses": [
        "drolesse"
    ],
    "drolet": [
        "drolet"
    ],
    "drolette": [
        "drolet"
    ],
    "du": [
        "devoir",
        "du",
        "do"
    ],
    "dual": [
        "dual"
    ],
    "dualisme": [
        "dualisme"
    ],
    "dualiste": [
        "dualiste"
    ],
    "dualite": [
        "dualite"
    ],
    "dubitatif": [
        "dubitatif"
    ],
    "dubitatifs": [
        "dubitatif"
    ],
    "dubitation": [
        "dubitation"
    ],
    "dubitations": [
        "dubitation"
    ],
    "dubitative": [
        "dubitatif"
    ],
    "dubitativement": [
        "dubitativement"
    ],
    "dubitatives": [
        "dubitatif"
    ],
    "duc": [
        "duc"
    ],
    "ducal": [
        "ducal"
    ],
    "ducale": [
        "ducal"
    ],
    "ducales": [
        "ducal"
    ],
    "ducasse": [
        "ducasse"
    ],
    "ducasses": [
        "ducasse"
    ],
    "ducat": [
        "ducat"
    ],
    "ducaton": [
        "ducaton"
    ],
    "ducats": [
        "ducat"
    ],
    "ducaux": [
        "ducal"
    ],
    "duce": [
        "duce"
    ],
    "duces": [
        "duce"
    ],
    "duchesse": [
        "duc"
    ],
    "duchesses": [
        "duchess",
        "duc"
    ],
    "duchnoque": [
        "duchnoque"
    ],
    "duche": [
        "duche"
    ],
    "ducon": [
        "ducon"
    ],
    "ducs": [
        "duc"
    ],
    "ductile": [
        "ductile"
    ],
    "dudit": [
        "dudit"
    ],
    "due": [
        "devoir",
        "du"
    ],
    "duel": [
        "duel"
    ],
    "duelliste": [
        "duelliste"
    ],
    "duellistes": [
        "duelliste"
    ],
    "duels": [
        "duel"
    ],
    "dues": [
        "devoir",
        "du"
    ],
    "duettistes": [
        "duettiste"
    ],
    "dugong": [
        "dugong"
    ],
    "dugongs": [
        "dugong"
    ],
    "duit": [
        "duit"
    ],
    "dulcifiant": [
        "dulcifier"
    ],
    "dulcinee": [
        "dulcinee"
    ],
    "dumper": [
        "dumper"
    ],
    "dumping": [
        "dump",
        "dumping"
    ],
    "dundee": [
        "dundee"
    ],
    "dune": [
        "dune"
    ],
    "dunes": [
        "dune"
    ],
    "dunette": [
        "dunette"
    ],
    "dunettes": [
        "dunette"
    ],
    "dunkerque": [
        "dunkerque"
    ],
    "duo": [
        "duo"
    ],
    "duodi": [
        "duodi"
    ],
    "duodecimale": [
        "duodecimal"
    ],
    "duodenal": [
        "duodenal"
    ],
    "duodenale": [
        "duodenal"
    ],
    "duodenum": [
        "duodenum"
    ],
    "duopole": [
        "duopole"
    ],
    "duos": [
        "duo"
    ],
    "dupait": [
        "duper"
    ],
    "dupant": [
        "duper"
    ],
    "dupe": [
        "dupe",
        "duper"
    ],
    "dupent": [
        "duper"
    ],
    "duper": [
        "duper"
    ],
    "dupera": [
        "duper"
    ],
    "duperas": [
        "duper"
    ],
    "duperie": [
        "duperie"
    ],
    "duperies": [
        "duperie"
    ],
    "dupes": [
        "dupe",
        "duper"
    ],
    "dupeur": [
        "dupeur"
    ],
    "dupez": [
        "duper"
    ],
    "duplex": [
        "duplex"
    ],
    "duplicata": [
        "duplicata"
    ],
    "duplicate": [
        "duplicate"
    ],
    "duplicateur": [
        "duplicateur"
    ],
    "duplicateurs": [
        "duplicateur"
    ],
    "duplication": [
        "duplication"
    ],
    "duplice": [
        "duplice"
    ],
    "duplicite": [
        "duplicite"
    ],
    "dupliquer": [
        "dupliquer"
    ],
    "duplique": [
        "dupliquer"
    ],
    "dupliques": [
        "dupliquer"
    ],
    "dupons": [
        "duper"
    ],
    "dupee": [
        "duper"
    ],
    "duquel": [
        "duquel"
    ],
    "dur": [
        "dur"
    ],
    "dura": [
        "durer"
    ],
    "durabilite": [
        "durabilite"
    ],
    "durable": [
        "durable"
    ],
    "durablement": [
        "durablement"
    ],
    "durables": [
        "durable"
    ],
    "duraient": [
        "durer"
    ],
    "duraille": [
        "duraille"
    ],
    "durailles": [
        "duraille"
    ],
    "durait": [
        "durer"
    ],
    "durale": [
        "dural"
    ],
    "duralumin": [
        "duralumin"
    ],
    "durant": [
        "durer",
        "durant"
    ],
    "durassent": [
        "durer"
    ],
    "durci": [
        "durci",
        "durcir"
    ],
    "durcie": [
        "durci",
        "durcir"
    ],
    "durcies": [
        "durci",
        "durcir"
    ],
    "durcir": [
        "durcir"
    ],
    "durciraient": [
        "durcir"
    ],
    "durcirent": [
        "durcir"
    ],
    "durcis": [
        "durci",
        "durcir"
    ],
    "durcissaient": [
        "durcir"
    ],
    "durcissais": [
        "durcir"
    ],
    "durcissait": [
        "durcir"
    ],
    "durcissant": [
        "durcir"
    ],
    "durcisse": [
        "durcir"
    ],
    "durcissement": [
        "durcissement"
    ],
    "durcissent": [
        "durcir"
    ],
    "durcisseur": [
        "durcisseur"
    ],
    "durcit": [
        "durcir"
    ],
    "dure": [
        "durer",
        "dur",
        "dure"
    ],
    "durement": [
        "durement"
    ],
    "durent": [
        "devoir",
        "durer"
    ],
    "durer": [
        "durer"
    ],
    "durera": [
        "durer"
    ],
    "durerai": [
        "durer"
    ],
    "dureraient": [
        "durer"
    ],
    "durerais": [
        "durer"
    ],
    "durerait": [
        "durer"
    ],
    "dureras": [
        "durer"
    ],
    "durerez": [
        "durer"
    ],
    "dureront": [
        "durer"
    ],
    "dures": [
        "durer",
        "dur",
        "dure"
    ],
    "durete": [
        "durete"
    ],
    "duretes": [
        "durete"
    ],
    "durham": [
        "durham"
    ],
    "durian": [
        "durian"
    ],
    "durillon": [
        "durillon"
    ],
    "durillons": [
        "durillon"
    ],
    "durit": [
        "durit"
    ],
    "durite": [
        "durite"
    ],
    "durites": [
        "durite"
    ],
    "durs": [
        "dur"
    ],
    "durat": [
        "durer"
    ],
    "durerent": [
        "durer"
    ],
    "duree": [
        "durer",
        "duree"
    ],
    "durees": [
        "durer",
        "duree"
    ],
    "dus": [
        "devoir",
        "du"
    ],
    "dusse": [
        "devoir"
    ],
    "dussent": [
        "devoir"
    ],
    "dusses": [
        "devoir"
    ],
    "dussiez": [
        "devoir"
    ],
    "dussions": [
        "devoir"
    ],
    "dut": [
        "devoir"
    ],
    "duvet": [
        "duvet"
    ],
    "duveteuse": [
        "duveteux"
    ],
    "duveteuses": [
        "duveteux"
    ],
    "duveteux": [
        "duveteux"
    ],
    "duvets": [
        "duvet"
    ],
    "duvete": [
        "duveter",
        "duvete"
    ],
    "duvetee": [
        "duvete"
    ],
    "duvetees": [
        "duveter",
        "duvete"
    ],
    "duvetes": [
        "duveter",
        "duvete"
    ],
    "duegne": [
        "duegne"
    ],
    "dyke": [
        "dyke"
    ],
    "dykes": [
        "dyke"
    ],
    "dynamique": [
        "dynamique"
    ],
    "dynamiques": [
        "dynamique"
    ],
    "dynamiser": [
        "dynamiser"
    ],
    "dynamisera": [
        "dynamiser"
    ],
    "dynamiserait": [
        "dynamiser"
    ],
    "dynamisez": [
        "dynamiser"
    ],
    "dynamisme": [
        "dynamisme"
    ],
    "dynamise": [
        "dynamiser"
    ],
    "dynamisee": [
        "dynamiser"
    ],
    "dynamisees": [
        "dynamiser"
    ],
    "dynamitage": [
        "dynamitage"
    ],
    "dynamitait": [
        "dynamiter"
    ],
    "dynamitant": [
        "dynamiter"
    ],
    "dynamite": [
        "dynamiter",
        "dynamite"
    ],
    "dynamiter": [
        "dynamiter"
    ],
    "dynamiteur": [
        "dynamiteur"
    ],
    "dynamiteurs": [
        "dynamiteur"
    ],
    "dynamitez": [
        "dynamiter"
    ],
    "dynamitons": [
        "dynamiter"
    ],
    "dynamitee": [
        "dynamiter"
    ],
    "dynamo": [
        "dynamo"
    ],
    "dynamometre": [
        "dynamometre"
    ],
    "dynamometrique": [
        "dynamometrique"
    ],
    "dynamos": [
        "dynamo"
    ],
    "dynastie": [
        "dynastie"
    ],
    "dynasties": [
        "dynasty",
        "dynastie"
    ],
    "dynastique": [
        "dynastique"
    ],
    "dynes": [
        "dyne"
    ],
    "dyscinesie": [
        "dyscinesie"
    ],
    "dyscrasie": [
        "dyscrasie"
    ],
    "dysenterie": [
        "dysenterie"
    ],
    "dysenteries": [
        "dysenterie"
    ],
    "dysenterique": [
        "dysenterique"
    ],
    "dysenteriques": [
        "dysenterique"
    ],
    "dysfonction": [
        "dysfonction"
    ],
    "dysfonctionnement": [
        "dysfonctionnement"
    ],
    "dysfonctionnements": [
        "dysfonctionnement"
    ],
    "dyslexie": [
        "dyslexie"
    ],
    "dyslexique": [
        "dyslexique"
    ],
    "dysmenorrhee": [
        "dysmenorrhee"
    ],
    "dyspepsie": [
        "dyspepsie"
    ],
    "dyspepsique": [
        "dyspepsique"
    ],
    "dyspeptique": [
        "dyspeptique"
    ],
    "dysphonie": [
        "dysphonie"
    ],
    "dysphorie": [
        "dysphorie"
    ],
    "dysplasie": [
        "dysplasie"
    ],
    "dyspnee": [
        "dyspnee"
    ],
    "dyspneique": [
        "dyspneique"
    ],
    "dyspneiques": [
        "dyspneique"
    ],
    "dysthymie": [
        "dysthymie"
    ],
    "dystocie": [
        "dystocie"
    ],
    "dystrophie": [
        "dystrophie"
    ],
    "dysurie": [
        "dysurie"
    ],
    "dytique": [
        "dytique"
    ],
    "deche": [
        "decher",
        "deche"
    ],
    "deches": [
        "deche"
    ],
    "demes": [
        "deme"
    ],
    "deambula": [
        "deambuler"
    ],
    "deambulai": [
        "deambuler"
    ],
    "deambulaient": [
        "deambuler"
    ],
    "deambulais": [
        "deambuler"
    ],
    "deambulait": [
        "deambuler"
    ],
    "deambulant": [
        "deambulant",
        "deambuler"
    ],
    "deambulante": [
        "deambulant"
    ],
    "deambulateur": [
        "deambulateur"
    ],
    "deambulation": [
        "deambulation"
    ],
    "deambulations": [
        "deambulation"
    ],
    "deambulatoire": [
        "deambulatoire"
    ],
    "deambulatoires": [
        "deambulatoire"
    ],
    "deambule": [
        "deambuler"
    ],
    "deambulent": [
        "deambuler"
    ],
    "deambuler": [
        "deambuler"
    ],
    "deambulerai": [
        "deambuler"
    ],
    "deambulez": [
        "deambuler"
    ],
    "deambulions": [
        "deambuler"
    ],
    "deambulons": [
        "deambuler"
    ],
    "deambulerent": [
        "deambuler"
    ],
    "debagoulage": [
        "debagoulage"
    ],
    "debagoule": [
        "debagouler"
    ],
    "debagouler": [
        "debagouler"
    ],
    "debagoulerait": [
        "debagouler"
    ],
    "debagoules": [
        "debagouler"
    ],
    "deballa": [
        "deballer"
    ],
    "deballage": [
        "deballage"
    ],
    "deballages": [
        "deballage"
    ],
    "deballai": [
        "deballer"
    ],
    "deballaient": [
        "deballer"
    ],
    "deballais": [
        "deballer"
    ],
    "deballait": [
        "deballer"
    ],
    "deballant": [
        "deballer"
    ],
    "deballe": [
        "deballer"
    ],
    "deballent": [
        "deballer"
    ],
    "deballer": [
        "deballer"
    ],
    "deballera": [
        "deballer"
    ],
    "deballez": [
        "deballer"
    ],
    "deballonnage": [
        "deballonnage"
    ],
    "deballonner": [
        "deballonner"
    ],
    "deballonnerais": [
        "deballonner"
    ],
    "deballonneront": [
        "deballonner"
    ],
    "deballonne": [
        "deballonner"
    ],
    "deballons": [
        "deballer"
    ],
    "deballerent": [
        "deballer"
    ],
    "deballee": [
        "deballer"
    ],
    "deballees": [
        "deballer"
    ],
    "deballes": [
        "deballer"
    ],
    "debanda": [
        "debander"
    ],
    "debandade": [
        "debandade"
    ],
    "debandaient": [
        "debander"
    ],
    "debandais": [
        "debander"
    ],
    "debandait": [
        "debander"
    ],
    "debande": [
        "debander"
    ],
    "debandent": [
        "debander"
    ],
    "debander": [
        "debander"
    ],
    "debandera": [
        "debander"
    ],
    "debanderaient": [
        "debander"
    ],
    "debandez": [
        "debander"
    ],
    "debanderent": [
        "debander"
    ],
    "debandees": [
        "debander"
    ],
    "debandes": [
        "debander"
    ],
    "debaptiser": [
        "debaptiser"
    ],
    "debaptiserais": [
        "debaptiser"
    ],
    "debaptise": [
        "debaptiser"
    ],
    "debaptisee": [
        "debaptiser"
    ],
    "debarbot": [
        "debarbot"
    ],
    "debarbots": [
        "debarbot"
    ],
    "debarbouilla": [
        "debarbouiller"
    ],
    "debarbouillait": [
        "debarbouiller"
    ],
    "debarbouillant": [
        "debarbouiller"
    ],
    "debarbouille": [
        "debarbouiller"
    ],
    "debarbouiller": [
        "debarbouiller"
    ],
    "debarbouillette": [
        "debarbouillette"
    ],
    "debarbouillee": [
        "debarbouiller"
    ],
    "debarbouilles": [
        "debarbouiller"
    ],
    "debarcadere": [
        "debarcadere"
    ],
    "debarcaderes": [
        "debarcadere"
    ],
    "debardage": [
        "debardage"
    ],
    "debardages": [
        "debardage"
    ],
    "debardaient": [
        "debarder"
    ],
    "debarder": [
        "debarder"
    ],
    "debardeur": [
        "debardeur"
    ],
    "debardeurs": [
        "debardeur"
    ],
    "debardee": [
        "debarder"
    ],
    "debaroule": [
        "debarouler"
    ],
    "debaroulent": [
        "debarouler"
    ],
    "debarqua": [
        "debarquer"
    ],
    "debarquai": [
        "debarquer"
    ],
    "debarquaient": [
        "debarquer"
    ],
    "debarquais": [
        "debarquer"
    ],
    "debarquait": [
        "debarquer"
    ],
    "debarquant": [
        "debarquer"
    ],
    "debarque": [
        "debarque",
        "debarquer"
    ],
    "debarquement": [
        "debarquement"
    ],
    "debarquements": [
        "debarquement"
    ],
    "debarquent": [
        "debarquer"
    ],
    "debarquer": [
        "debarquer"
    ],
    "debarquera": [
        "debarquer"
    ],
    "debarquerai": [
        "debarquer"
    ],
    "debarqueraient": [
        "debarquer"
    ],
    "debarquerait": [
        "debarquer"
    ],
    "debarqueras": [
        "debarquer"
    ],
    "debarquerez": [
        "debarquer"
    ],
    "debarquerons": [
        "debarquer"
    ],
    "debarqueront": [
        "debarquer"
    ],
    "debarques": [
        "debarque",
        "debarquer"
    ],
    "debarquez": [
        "debarquer"
    ],
    "debarquiez": [
        "debarquer"
    ],
    "debarquions": [
        "debarquer"
    ],
    "debarquons": [
        "debarquer"
    ],
    "debarquames": [
        "debarquer"
    ],
    "debarquerent": [
        "debarquer"
    ],
    "debarquee": [
        "debarque",
        "debarquer"
    ],
    "debarquees": [
        "debarque",
        "debarquer"
    ],
    "debarra": [
        "debarrer"
    ],
    "debarras": [
        "debarras",
        "debarrer"
    ],
    "debarrassa": [
        "debarrasser"
    ],
    "debarrassai": [
        "debarrasser"
    ],
    "debarrassaient": [
        "debarrasser"
    ],
    "debarrassais": [
        "debarrasser"
    ],
    "debarrassait": [
        "debarrasser"
    ],
    "debarrassant": [
        "debarrasser"
    ],
    "debarrasse": [
        "debarrasser"
    ],
    "debarrassent": [
        "debarrasser"
    ],
    "debarrasser": [
        "debarrasser"
    ],
    "debarrassera": [
        "debarrasser"
    ],
    "debarrasserai": [
        "debarrasser"
    ],
    "debarrasserais": [
        "debarrasser"
    ],
    "debarrasserait": [
        "debarrasser"
    ],
    "debarrasseras": [
        "debarrasser"
    ],
    "debarrasserez": [
        "debarrasser"
    ],
    "debarrasserons": [
        "debarrasser"
    ],
    "debarrasseront": [
        "debarrasser"
    ],
    "debarrasses": [
        "debarrasser"
    ],
    "debarrassez": [
        "debarrasser"
    ],
    "debarrassiez": [
        "debarrasser"
    ],
    "debarrassons": [
        "debarrasser"
    ],
    "debarrassat": [
        "debarrasser"
    ],
    "debarrasserent": [
        "debarrasser"
    ],
    "debarrassee": [
        "debarrasser"
    ],
    "debarrassees": [
        "debarrasser"
    ],
    "debarrer": [
        "debarrer"
    ],
    "debarrons": [
        "debarrer"
    ],
    "debat": [
        "debattre",
        "debat"
    ],
    "debats": [
        "debattre",
        "debat"
    ],
    "debattaient": [
        "debattre"
    ],
    "debattais": [
        "debattre"
    ],
    "debattait": [
        "debattre"
    ],
    "debattant": [
        "debattre"
    ],
    "debatte": [
        "debattre"
    ],
    "debattent": [
        "debattre"
    ],
    "debatteur": [
        "debatteur"
    ],
    "debattez": [
        "debattre"
    ],
    "debattiez": [
        "debattre"
    ],
    "debattions": [
        "debattre"
    ],
    "debattirent": [
        "debattre"
    ],
    "debattis": [
        "debattre"
    ],
    "debattit": [
        "debattre"
    ],
    "debattons": [
        "debattre"
    ],
    "debattra": [
        "debattre"
    ],
    "debattraient": [
        "debattre"
    ],
    "debattrais": [
        "debattre"
    ],
    "debattrait": [
        "debattre"
    ],
    "debattre": [
        "debattre"
    ],
    "debattrons": [
        "debattre"
    ],
    "debattu": [
        "debattre"
    ],
    "debattue": [
        "debattre",
        "debattue"
    ],
    "debattues": [
        "debattre"
    ],
    "debattus": [
        "debattre"
    ],
    "debauchais": [
        "debaucher"
    ],
    "debauchait": [
        "debaucher"
    ],
    "debauchant": [
        "debaucher"
    ],
    "debauche": [
        "debauche",
        "debaucher"
    ],
    "debaucher": [
        "debaucher"
    ],
    "debauches": [
        "debauche",
        "debaucher"
    ],
    "debaucheur": [
        "debaucheur"
    ],
    "debaucheurs": [
        "debaucheur"
    ],
    "debauchee": [
        "debaucher",
        "debauche"
    ],
    "debauchees": [
        "debauche"
    ],
    "debecquetait": [
        "debecqueter"
    ],
    "debectage": [
        "debectage"
    ],
    "debectait": [
        "debecter"
    ],
    "debectance": [
        "debectance"
    ],
    "debectant": [
        "debecter"
    ],
    "debecte": [
        "debecter"
    ],
    "debectent": [
        "debecter"
    ],
    "debecter": [
        "debecter"
    ],
    "debecterais": [
        "debecter"
    ],
    "debectez": [
        "debecter"
    ],
    "debectee": [
        "debecter"
    ],
    "debectes": [
        "debecter"
    ],
    "debiffe": [
        "debiffer"
    ],
    "debile": [
        "debile"
    ],
    "debilement": [
        "debilement"
    ],
    "debiles": [
        "debile"
    ],
    "debilitaient": [
        "debiliter"
    ],
    "debilitant": [
        "debilitant",
        "debiliter"
    ],
    "debilitante": [
        "debilitant"
    ],
    "debilitantes": [
        "debilitant"
    ],
    "debilitation": [
        "debilitation"
    ],
    "debilite": [
        "debiliter",
        "debilite"
    ],
    "debilitee": [
        "debiliter"
    ],
    "debilites": [
        "debiliter",
        "debilite"
    ],
    "debiller": [
        "debiller"
    ],
    "debinait": [
        "debiner"
    ],
    "debine": [
        "debine",
        "debiner"
    ],
    "debinent": [
        "debiner"
    ],
    "debiner": [
        "debiner"
    ],
    "debinera": [
        "debiner"
    ],
    "debinerai": [
        "debiner"
    ],
    "debinerait": [
        "debiner"
    ],
    "debineras": [
        "debiner"
    ],
    "debines": [
        "debiner"
    ],
    "debineurs": [
        "debineur"
    ],
    "debineuses": [
        "debineur"
    ],
    "debinez": [
        "debiner"
    ],
    "debinees": [
        "debiner"
    ],
    "debit": [
        "debit"
    ],
    "debita": [
        "debiter"
    ],
    "debitage": [
        "debitage"
    ],
    "debitai": [
        "debiter"
    ],
    "debitaient": [
        "debiter"
    ],
    "debitais": [
        "debiter"
    ],
    "debitait": [
        "debiter"
    ],
    "debitant": [
        "debitant",
        "debiter"
    ],
    "debitants": [
        "debitant"
    ],
    "debite": [
        "debite",
        "debiter"
    ],
    "debitent": [
        "debiter"
    ],
    "debiter": [
        "debiter"
    ],
    "debitera": [
        "debiter"
    ],
    "debiterai": [
        "debiter"
    ],
    "debiterait": [
        "debiter"
    ],
    "debites": [
        "debiter"
    ],
    "debiteur": [
        "debiteur"
    ],
    "debiteurs": [
        "debiteur"
    ],
    "debitez": [
        "debiter"
    ],
    "debitrice": [
        "debiteur"
    ],
    "debits": [
        "debit"
    ],
    "debitee": [
        "debiter"
    ],
    "debitees": [
        "debiter"
    ],
    "deblai": [
        "deblai"
    ],
    "deblaie": [
        "deblayer"
    ],
    "deblaiement": [
        "deblaiement"
    ],
    "deblaient": [
        "deblayer"
    ],
    "deblaierez": [
        "deblayer"
    ],
    "deblais": [
        "deblai"
    ],
    "deblatere": [
        "deblaterer"
    ],
    "deblaterait": [
        "deblaterer"
    ],
    "deblaterant": [
        "deblaterer"
    ],
    "deblaterations": [
        "deblateration"
    ],
    "deblaterer": [
        "deblaterer"
    ],
    "deblaya": [
        "deblayer"
    ],
    "deblayage": [
        "deblayage"
    ],
    "deblayaient": [
        "deblayer"
    ],
    "deblayait": [
        "deblayer"
    ],
    "deblayant": [
        "deblayer"
    ],
    "deblayer": [
        "deblayer"
    ],
    "deblayera": [
        "deblayer"
    ],
    "deblayeur": [
        "deblayeur"
    ],
    "deblayeurs": [
        "deblayeur"
    ],
    "deblayez": [
        "deblayer"
    ],
    "deblaye": [
        "deblayer"
    ],
    "deblayee": [
        "deblayer"
    ],
    "deblayees": [
        "deblayer"
    ],
    "deblayes": [
        "deblayer"
    ],
    "deblocage": [
        "deblocage"
    ],
    "deblocages": [
        "deblocage"
    ],
    "debloqua": [
        "debloquer"
    ],
    "debloquait": [
        "debloquer"
    ],
    "debloquant": [
        "debloquer"
    ],
    "debloque": [
        "debloquer"
    ],
    "debloquent": [
        "debloquer"
    ],
    "debloquer": [
        "debloquer"
    ],
    "debloques": [
        "debloquer"
    ],
    "debloquez": [
        "debloquer"
    ],
    "debloquat": [
        "debloquer"
    ],
    "debloquee": [
        "debloquer"
    ],
    "debobinage": [
        "debobinage"
    ],
    "debobiner": [
        "debobiner"
    ],
    "debogage": [
        "debogage"
    ],
    "deboguer": [
        "deboguer"
    ],
    "deboire": [
        "deboire"
    ],
    "deboires": [
        "deboire"
    ],
    "deboisement": [
        "deboisement"
    ],
    "deboiser": [
        "deboiser"
    ],
    "deboise": [
        "deboiser"
    ],
    "deboisee": [
        "deboiser"
    ],
    "deboisees": [
        "deboiser"
    ],
    "debonda": [
        "debonder"
    ],
    "debondait": [
        "debonder"
    ],
    "debondant": [
        "debonder"
    ],
    "debonder": [
        "debonder"
    ],
    "debonde": [
        "debonder"
    ],
    "debonnaire": [
        "debonnaire"
    ],
    "debonnaires": [
        "debonnaire"
    ],
    "debord": [
        "debord"
    ],
    "deborda": [
        "deborder"
    ],
    "debordaient": [
        "deborder"
    ],
    "debordais": [
        "deborder"
    ],
    "debordait": [
        "deborder"
    ],
    "debordant": [
        "deborder",
        "debordant"
    ],
    "debordante": [
        "debordant"
    ],
    "debordantes": [
        "debordant"
    ],
    "debordants": [
        "debordant"
    ],
    "deborde": [
        "deborder"
    ],
    "debordement": [
        "debordement"
    ],
    "debordements": [
        "debordement"
    ],
    "debordent": [
        "deborder"
    ],
    "deborder": [
        "deborder"
    ],
    "debordera": [
        "deborder"
    ],
    "deborderaient": [
        "deborder"
    ],
    "deborderait": [
        "deborder"
    ],
    "debordez": [
        "deborder"
    ],
    "debordat": [
        "deborder"
    ],
    "deborderent": [
        "deborder"
    ],
    "debordee": [
        "deborder"
    ],
    "debordees": [
        "deborder"
    ],
    "debordes": [
        "deborder"
    ],
    "debottelons": [
        "debotteler"
    ],
    "debotte": [
        "debotte"
    ],
    "deboucha": [
        "deboucher"
    ],
    "debouchage": [
        "debouchage"
    ],
    "debouchai": [
        "deboucher"
    ],
    "debouchaient": [
        "deboucher"
    ],
    "debouchais": [
        "deboucher"
    ],
    "debouchait": [
        "deboucher"
    ],
    "debouchant": [
        "deboucher"
    ],
    "debouche": [
        "debouche",
        "deboucher"
    ],
    "debouchent": [
        "deboucher"
    ],
    "deboucher": [
        "deboucher"
    ],
    "debouchera": [
        "deboucher"
    ],
    "deboucherai": [
        "deboucher"
    ],
    "deboucheraient": [
        "deboucher"
    ],
    "deboucherait": [
        "deboucher"
    ],
    "deboucherez": [
        "deboucher"
    ],
    "deboucheur": [
        "deboucheur"
    ],
    "deboucheurs": [
        "deboucheur"
    ],
    "debouchez": [
        "deboucher"
    ],
    "debouchions": [
        "deboucher"
    ],
    "debouchoir": [
        "debouchoir"
    ],
    "debouchoirs": [
        "debouchoir"
    ],
    "debouchons": [
        "deboucher"
    ],
    "debouchames": [
        "deboucher"
    ],
    "deboucherent": [
        "deboucher"
    ],
    "debouchee": [
        "deboucher"
    ],
    "debouchees": [
        "deboucher"
    ],
    "debouches": [
        "debouche",
        "deboucher"
    ],
    "deboucla": [
        "deboucler"
    ],
    "debouclaient": [
        "deboucler"
    ],
    "debouclait": [
        "deboucler"
    ],
    "debouclant": [
        "deboucler"
    ],
    "deboucle": [
        "deboucler"
    ],
    "debouclent": [
        "deboucler"
    ],
    "deboucler": [
        "deboucler"
    ],
    "debouclez": [
        "deboucler"
    ],
    "debouclions": [
        "deboucler"
    ],
    "debouclerent": [
        "deboucler"
    ],
    "debouclees": [
        "deboucler"
    ],
    "deboucles": [
        "deboucler"
    ],
    "deboula": [
        "debouler"
    ],
    "deboulai": [
        "debouler"
    ],
    "deboulaient": [
        "debouler"
    ],
    "deboulais": [
        "debouler"
    ],
    "deboulait": [
        "debouler"
    ],
    "deboulant": [
        "debouler"
    ],
    "deboule": [
        "debouler",
        "deboule"
    ],
    "deboulent": [
        "debouler"
    ],
    "debouler": [
        "debouler"
    ],
    "deboulerais": [
        "debouler"
    ],
    "deboulerait": [
        "debouler"
    ],
    "debouleront": [
        "debouler"
    ],
    "deboulez": [
        "debouler"
    ],
    "debouliez": [
        "debouler"
    ],
    "deboulions": [
        "debouler"
    ],
    "deboulonnant": [
        "deboulonner"
    ],
    "deboulonner": [
        "deboulonner"
    ],
    "deboulonnez": [
        "deboulonner"
    ],
    "deboulonne": [
        "deboulonner"
    ],
    "deboulonnee": [
        "deboulonner"
    ],
    "deboulonnees": [
        "deboulonner"
    ],
    "deboulerent": [
        "debouler"
    ],
    "deboules": [
        "debouler",
        "deboule"
    ],
    "debouquaient": [
        "debouquer"
    ],
    "debouque": [
        "debouquer"
    ],
    "debourrage": [
        "debourrage"
    ],
    "debourre": [
        "debourrer"
    ],
    "debourrent": [
        "debourrer"
    ],
    "debourrer": [
        "debourrer"
    ],
    "debourree": [
        "debourrer"
    ],
    "debours": [
        "debours"
    ],
    "debourse": [
        "debourser"
    ],
    "deboursement": [
        "deboursement"
    ],
    "debourser": [
        "debourser"
    ],
    "deboursera": [
        "debourser"
    ],
    "debourseront": [
        "debourser"
    ],
    "deboursees": [
        "debourser"
    ],
    "deboussolait": [
        "deboussoler"
    ],
    "deboussolantes": [
        "deboussolant"
    ],
    "deboussoler": [
        "deboussoler"
    ],
    "deboussole": [
        "deboussoler"
    ],
    "deboussolee": [
        "deboussoler"
    ],
    "deboussolees": [
        "deboussoler"
    ],
    "deboussoles": [
        "deboussoler"
    ],
    "deboutait": [
        "debouter"
    ],
    "debouter": [
        "debouter"
    ],
    "deboutonna": [
        "deboutonner"
    ],
    "deboutonnage": [
        "deboutonnage"
    ],
    "deboutonnait": [
        "deboutonner"
    ],
    "deboutonnant": [
        "deboutonner"
    ],
    "deboutonne": [
        "deboutonner"
    ],
    "deboutonnent": [
        "deboutonner"
    ],
    "deboutonner": [
        "deboutonner"
    ],
    "deboutonnez": [
        "deboutonner"
    ],
    "deboutonnat": [
        "deboutonner"
    ],
    "deboutonnee": [
        "deboutonner"
    ],
    "deboutonnees": [
        "deboutonner"
    ],
    "deboutonnes": [
        "deboutonner"
    ],
    "deboute": [
        "debouter"
    ],
    "deboutee": [
        "debouter"
    ],
    "deboita": [
        "deboiter"
    ],
    "deboitaient": [
        "deboiter"
    ],
    "deboitais": [
        "deboiter"
    ],
    "deboitait": [
        "deboiter"
    ],
    "deboitant": [
        "deboiter"
    ],
    "deboite": [
        "deboiter"
    ],
    "deboitement": [
        "deboitement"
    ],
    "deboiter": [
        "deboiter"
    ],
    "deboitez": [
        "deboiter"
    ],
    "deboitee": [
        "deboiter"
    ],
    "deboitees": [
        "deboiter"
    ],
    "debraguette": [
        "debraguetter"
    ],
    "debraguettent": [
        "debraguetter"
    ],
    "debraguetter": [
        "debraguetter"
    ],
    "debraguettes": [
        "debraguetter"
    ],
    "debraille": [
        "debraille",
        "debrailler"
    ],
    "debraillee": [
        "debraille",
        "debrailler"
    ],
    "debraillees": [
        "debraille",
        "debrailler"
    ],
    "debrailles": [
        "debraille",
        "debrailler"
    ],
    "debrancha": [
        "debrancher"
    ],
    "debranchant": [
        "debrancher"
    ],
    "debranche": [
        "debrancher"
    ],
    "debranchement": [
        "debranchement"
    ],
    "debranchent": [
        "debrancher"
    ],
    "debrancher": [
        "debrancher"
    ],
    "debrancherai": [
        "debrancher"
    ],
    "debrancherais": [
        "debrancher"
    ],
    "debrancherait": [
        "debrancher"
    ],
    "debranchez": [
        "debrancher"
    ],
    "debranchons": [
        "debrancher"
    ],
    "debranchee": [
        "debrancher"
    ],
    "debranchees": [
        "debrancher"
    ],
    "debranches": [
        "debrancher"
    ],
    "debraya": [
        "debrayer"
    ],
    "debrayage": [
        "debrayage"
    ],
    "debrayages": [
        "debrayage"
    ],
    "debrayait": [
        "debrayer"
    ],
    "debraye": [
        "debrayer"
    ],
    "debrayent": [
        "debrayer"
    ],
    "debrayer": [
        "debrayer"
    ],
    "debrayes": [
        "debrayer"
    ],
    "debrayez": [
        "debrayer"
    ],
    "debrayee": [
        "debrayer"
    ],
    "debridait": [
        "debrider"
    ],
    "debridant": [
        "debrider"
    ],
    "debride": [
        "debride",
        "debrider"
    ],
    "debridement": [
        "debridement"
    ],
    "debrider": [
        "debrider"
    ],
    "debridera": [
        "debrider"
    ],
    "debriderai": [
        "debrider"
    ],
    "debriderait": [
        "debrider"
    ],
    "debridez": [
        "debrider"
    ],
    "debridee": [
        "debride",
        "debrider"
    ],
    "debridees": [
        "debride",
        "debrider"
    ],
    "debrides": [
        "debride",
        "debrider"
    ],
    "debriefer": [
        "debriefer"
    ],
    "debriefing": [
        "debriefing"
    ],
    "debriefe": [
        "debriefer"
    ],
    "debriefee": [
        "debriefer"
    ],
    "debris": [
        "debris"
    ],
    "debronzer": [
        "debronzer"
    ],
    "debrouilla": [
        "debrouiller"
    ],
    "debrouillage": [
        "debrouillage"
    ],
    "debrouillai": [
        "debrouiller"
    ],
    "debrouillaient": [
        "debrouiller"
    ],
    "debrouillais": [
        "debrouiller"
    ],
    "debrouillait": [
        "debrouiller"
    ],
    "debrouillant": [
        "debrouiller"
    ],
    "debrouillard": [
        "debrouillard"
    ],
    "debrouillarde": [
        "debrouillard"
    ],
    "debrouillardise": [
        "debrouillardise"
    ],
    "debrouillards": [
        "debrouillard"
    ],
    "debrouille": [
        "debrouille",
        "debrouiller"
    ],
    "debrouillent": [
        "debrouiller"
    ],
    "debrouiller": [
        "debrouiller"
    ],
    "debrouillera": [
        "debrouiller"
    ],
    "debrouillerai": [
        "debrouiller"
    ],
    "debrouilleraient": [
        "debrouiller"
    ],
    "debrouillerais": [
        "debrouiller"
    ],
    "debrouillerait": [
        "debrouiller"
    ],
    "debrouilleras": [
        "debrouiller"
    ],
    "debrouillerez": [
        "debrouiller"
    ],
    "debrouillerions": [
        "debrouiller"
    ],
    "debrouillerons": [
        "debrouiller"
    ],
    "debrouilleront": [
        "debrouiller"
    ],
    "debrouilles": [
        "debrouille",
        "debrouiller"
    ],
    "debrouilleurs": [
        "debrouilleur"
    ],
    "debrouillez": [
        "debrouiller"
    ],
    "debrouilliez": [
        "debrouiller"
    ],
    "debrouillions": [
        "debrouiller"
    ],
    "debrouillons": [
        "debrouiller"
    ],
    "debrouillat": [
        "debrouiller"
    ],
    "debrouillee": [
        "debrouiller"
    ],
    "debrouillees": [
        "debrouiller"
    ],
    "debroussaillage": [
        "debroussaillage"
    ],
    "debroussaille": [
        "debroussailler"
    ],
    "debroussailler": [
        "debroussailler"
    ],
    "debroussailleuse": [
        "debroussailleur"
    ],
    "debucher": [
        "debucher"
    ],
    "debusquaient": [
        "debusquer"
    ],
    "debusquait": [
        "debusquer"
    ],
    "debusquant": [
        "debusquer"
    ],
    "debusque": [
        "debusquer"
    ],
    "debusquer": [
        "debusquer"
    ],
    "debusquerait": [
        "debusquer"
    ],
    "debusquerons": [
        "debusquer"
    ],
    "debusquez": [
        "debusquer"
    ],
    "debusquerent": [
        "debusquer"
    ],
    "debusquee": [
        "debusquer"
    ],
    "debusques": [
        "debusquer"
    ],
    "debut": [
        "debut"
    ],
    "debuta": [
        "debuter"
    ],
    "debutai": [
        "debuter"
    ],
    "debutaient": [
        "debuter"
    ],
    "debutais": [
        "debuter"
    ],
    "debutait": [
        "debuter"
    ],
    "debutant": [
        "debutant",
        "debuter"
    ],
    "debutante": [
        "debutant"
    ],
    "debutantes": [
        "debutant"
    ],
    "debutants": [
        "debutant"
    ],
    "debute": [
        "debuter"
    ],
    "debutent": [
        "debuter"
    ],
    "debuter": [
        "debuter"
    ],
    "debutera": [
        "debuter"
    ],
    "debuteraient": [
        "debuter"
    ],
    "debutes": [
        "debuter"
    ],
    "debutez": [
        "debuter"
    ],
    "debutiez": [
        "debuter"
    ],
    "debutons": [
        "debuter"
    ],
    "debuts": [
        "debut"
    ],
    "debuterent": [
        "debuter"
    ],
    "debutee": [
        "debuter"
    ],
    "debacle": [
        "debacle"
    ],
    "debacles": [
        "debacle"
    ],
    "debaillonne": [
        "debaillonner"
    ],
    "debate": [
        "debater"
    ],
    "debatees": [
        "debater"
    ],
    "dec": [
        "dec"
    ],
    "decabosser": [
        "decabosser"
    ],
    "decacheta": [
        "decacheter"
    ],
    "decachetage": [
        "decachetage"
    ],
    "decachetai": [
        "decacheter"
    ],
    "decachetaient": [
        "decacheter"
    ],
    "decachetais": [
        "decacheter"
    ],
    "decachetant": [
        "decacheter"
    ],
    "decacheter": [
        "decacheter"
    ],
    "decachetons": [
        "decacheter"
    ],
    "decachette": [
        "decacheter"
    ],
    "decachetteraient": [
        "decacheter"
    ],
    "decachete": [
        "decacheter"
    ],
    "decachetee": [
        "decacheter"
    ],
    "decachetees": [
        "decacheter"
    ],
    "decade": [
        "decade"
    ],
    "decadence": [
        "decadence"
    ],
    "decadent": [
        "decadent"
    ],
    "decadente": [
        "decadent"
    ],
    "decadentes": [
        "decadent"
    ],
    "decadentisme": [
        "decadentisme"
    ],
    "decadents": [
        "decadent"
    ],
    "decades": [
        "decade"
    ],
    "decadi": [
        "decadi"
    ],
    "decadis": [
        "decadi"
    ],
    "decafeine": [
        "decafeine",
        "decafeiner"
    ],
    "decafeinee": [
        "decafeiner"
    ],
    "decaissement": [
        "decaissement"
    ],
    "decaisser": [
        "decaisser"
    ],
    "decalage": [
        "decalage"
    ],
    "decalages": [
        "decalage"
    ],
    "decalamine": [
        "decalaminer"
    ],
    "decalant": [
        "decaler"
    ],
    "decalcification": [
        "decalcification"
    ],
    "decalcifie": [
        "decalcifier"
    ],
    "decalcifiee": [
        "decalcifier"
    ],
    "decalcomanie": [
        "decalcomanie"
    ],
    "decalcomanies": [
        "decalcomanies",
        "decalcomanie"
    ],
    "decale": [
        "decaler",
        "decale"
    ],
    "decalent": [
        "decaler"
    ],
    "decaler": [
        "decaler"
    ],
    "decalez": [
        "decaler"
    ],
    "decalitre": [
        "decalitre"
    ],
    "decalitres": [
        "decalitre"
    ],
    "decalogue": [
        "decalogue"
    ],
    "decalotta": [
        "decalotter"
    ],
    "decalotter": [
        "decalotter"
    ],
    "decalotte": [
        "decalotter"
    ],
    "decalottee": [
        "decalotter"
    ],
    "decalottes": [
        "decalotter"
    ],
    "decalquai": [
        "decalquer"
    ],
    "decalquait": [
        "decalquer"
    ],
    "decalque": [
        "decalque",
        "decalquer"
    ],
    "decalquer": [
        "decalquer"
    ],
    "decalques": [
        "decalque",
        "decalquer"
    ],
    "decalquee": [
        "decalquer"
    ],
    "decalquees": [
        "decalquer"
    ],
    "decalee": [
        "decaler",
        "decale"
    ],
    "decalees": [
        "decaler",
        "decale"
    ],
    "decales": [
        "decaler",
        "decale"
    ],
    "decambuter": [
        "decambuter"
    ],
    "decampa": [
        "decamper"
    ],
    "decampait": [
        "decamper"
    ],
    "decampe": [
        "decamper"
    ],
    "decampent": [
        "decamper"
    ],
    "decamper": [
        "decamper"
    ],
    "decampera": [
        "decamper"
    ],
    "decamperais": [
        "decamper"
    ],
    "decamperont": [
        "decamper"
    ],
    "decampes": [
        "decamper"
    ],
    "decampez": [
        "decamper"
    ],
    "decampons": [
        "decamper"
    ],
    "decametre": [
        "decametre"
    ],
    "decametres": [
        "decametre"
    ],
    "decan": [
        "decan"
    ],
    "decanillant": [
        "decaniller"
    ],
    "decanille": [
        "decaniller"
    ],
    "decaniller": [
        "decaniller"
    ],
    "decanillerait": [
        "decaniller"
    ],
    "decanillez": [
        "decaniller"
    ],
    "decantai": [
        "decanter"
    ],
    "decantaient": [
        "decanter"
    ],
    "decantait": [
        "decanter"
    ],
    "decantant": [
        "decanter"
    ],
    "decantation": [
        "decantation"
    ],
    "decante": [
        "decanter"
    ],
    "decantent": [
        "decanter"
    ],
    "decanter": [
        "decanter"
    ],
    "decanteur": [
        "decanteur"
    ],
    "decantee": [
        "decanter"
    ],
    "decantees": [
        "decanter"
    ],
    "decapage": [
        "decapage"
    ],
    "decapais": [
        "decaper"
    ],
    "decapait": [
        "decaper"
    ],
    "decapant": [
        "decaper",
        "decapant"
    ],
    "decapante": [
        "decapant"
    ],
    "decapants": [
        "decapant"
    ],
    "decape": [
        "decaper"
    ],
    "decaper": [
        "decaper"
    ],
    "decapera": [
        "decaper"
    ],
    "decapeur": [
        "decapeur"
    ],
    "decapita": [
        "decapiter"
    ],
    "decapitaient": [
        "decapiter"
    ],
    "decapitais": [
        "decapiter"
    ],
    "decapitait": [
        "decapiter"
    ],
    "decapitant": [
        "decapiter"
    ],
    "decapitation": [
        "decapitation"
    ],
    "decapitations": [
        "decapitation"
    ],
    "decapite": [
        "decapiter"
    ],
    "decapitent": [
        "decapiter"
    ],
    "decapiter": [
        "decapiter"
    ],
    "decapitera": [
        "decapiter"
    ],
    "decapiterai": [
        "decapiter"
    ],
    "decapiterait": [
        "decapiter"
    ],
    "decapiteront": [
        "decapiter"
    ],
    "decapitez": [
        "decapiter"
    ],
    "decapitons": [
        "decapiter"
    ],
    "decapitat": [
        "decapiter"
    ],
    "decapiterent": [
        "decapiter"
    ],
    "decapitee": [
        "decapiter"
    ],
    "decapitees": [
        "decapiter"
    ],
    "decapites": [
        "decapiter"
    ],
    "decapode": [
        "decapode"
    ],
    "decapotable": [
        "decapotable"
    ],
    "decapotables": [
        "decapotable"
    ],
    "decapotage": [
        "decapotage"
    ],
    "decapotait": [
        "decapoter"
    ],
    "decapote": [
        "decapote",
        "decapoter"
    ],
    "decapoter": [
        "decapoter"
    ],
    "decapotee": [
        "decapote",
        "decapoter"
    ],
    "decapotes": [
        "decapoter"
    ],
    "decapsula": [
        "decapsuler"
    ],
    "decapsulant": [
        "decapsuler"
    ],
    "decapsule": [
        "decapsuler"
    ],
    "decapsuler": [
        "decapsuler"
    ],
    "decapsulerait": [
        "decapsuler"
    ],
    "decapsuleur": [
        "decapsuleur"
    ],
    "decapsulez": [
        "decapsuler"
    ],
    "decapsulee": [
        "decapsuler"
    ],
    "decapuchonna": [
        "decapuchonner"
    ],
    "decapuchonne": [
        "decapuchonner"
    ],
    "decapuchonner": [
        "decapuchonner"
    ],
    "decapuchonnerent": [
        "decapuchonner"
    ],
    "decapee": [
        "decaper"
    ],
    "decapees": [
        "decaper"
    ],
    "decapes": [
        "decaper"
    ],
    "decarcassais": [
        "decarcasser"
    ],
    "decarcassait": [
        "decarcasser"
    ],
    "decarcassent": [
        "decarcasser"
    ],
    "decarcasser": [
        "decarcasser"
    ],
    "decarcasse": [
        "decarcasser"
    ],
    "decarcassee": [
        "decarcasser"
    ],
    "decarcassees": [
        "decarcasser"
    ],
    "decarpillage": [
        "decarpillage"
    ],
    "decarpiller": [
        "decarpiller"
    ],
    "decarpille": [
        "decarpiller"
    ],
    "decarrade": [
        "decarrade"
    ],
    "decarrades": [
        "decarrade"
    ],
    "decarraient": [
        "decarrer"
    ],
    "decarrais": [
        "decarrer"
    ],
    "decarrait": [
        "decarrer"
    ],
    "decarrant": [
        "decarrer"
    ],
    "decarre": [
        "decarrer"
    ],
    "decarrent": [
        "decarrer"
    ],
    "decarrer": [
        "decarrer"
    ],
    "decarrerait": [
        "decarrer"
    ],
    "decarres": [
        "decarrer"
    ],
    "decathlon": [
        "decathlon"
    ],
    "decathlons": [
        "decathlon"
    ],
    "decati": [
        "decatir",
        "decati"
    ],
    "decatie": [
        "decatir",
        "decati"
    ],
    "decatir": [
        "decatir"
    ],
    "decatis": [
        "decati"
    ],
    "decave": [
        "decave"
    ],
    "deceint": [
        "deceindre"
    ],
    "decela": [
        "deceler"
    ],
    "decelable": [
        "decelable"
    ],
    "decelai": [
        "deceler"
    ],
    "decelaient": [
        "deceler"
    ],
    "decelais": [
        "deceler"
    ],
    "decelait": [
        "deceler"
    ],
    "decelant": [
        "deceler"
    ],
    "deceler": [
        "deceler"
    ],
    "decelerent": [
        "deceler"
    ],
    "decele": [
        "deceler"
    ],
    "decelee": [
        "deceler"
    ],
    "decelees": [
        "deceler"
    ],
    "deceles": [
        "deceler"
    ],
    "decembre": [
        "decembre"
    ],
    "decembres": [
        "decembre"
    ],
    "decembriste": [
        "decembriste"
    ],
    "decembristes": [
        "decembriste"
    ],
    "decemment": [
        "decemment"
    ],
    "decence": [
        "decence"
    ],
    "decences": [
        "decence"
    ],
    "decennal": [
        "decennal"
    ],
    "decennale": [
        "decennal"
    ],
    "decennie": [
        "decennie"
    ],
    "decennies": [
        "decennie"
    ],
    "decent": [
        "decent"
    ],
    "decente": [
        "decent"
    ],
    "decentes": [
        "decent"
    ],
    "decentralisation": [
        "decentralisation"
    ],
    "decentralise": [
        "decentraliser"
    ],
    "decentralisee": [
        "decentraliser"
    ],
    "decentralisees": [
        "decentraliser"
    ],
    "decentrant": [
        "decentrer"
    ],
    "decentre": [
        "decentrer"
    ],
    "decentrement": [
        "decentrement"
    ],
    "decentree": [
        "decentrer"
    ],
    "decentrees": [
        "decentrer"
    ],
    "decents": [
        "decent"
    ],
    "deception": [
        "deception"
    ],
    "deceptions": [
        "deception"
    ],
    "decerna": [
        "decerner"
    ],
    "decernai": [
        "decerner"
    ],
    "decernais": [
        "decerner"
    ],
    "decernait": [
        "decerner"
    ],
    "decernant": [
        "decerner"
    ],
    "decerne": [
        "decerner"
    ],
    "decernent": [
        "decerner"
    ],
    "decerner": [
        "decerner"
    ],
    "decernera": [
        "decerner"
    ],
    "decerniez": [
        "decerner"
    ],
    "decernons": [
        "decerner"
    ],
    "decernee": [
        "decerner"
    ],
    "decernees": [
        "decerner"
    ],
    "decernes": [
        "decerner"
    ],
    "decervelage": [
        "decervelage"
    ],
    "decerveler": [
        "decerveler"
    ],
    "decervelle": [
        "decerveler"
    ],
    "decervele": [
        "decerveler"
    ],
    "decesse": [
        "decesser"
    ],
    "decevaient": [
        "decevoir"
    ],
    "decevais": [
        "decevoir"
    ],
    "decevait": [
        "decevoir"
    ],
    "decevant": [
        "decevant",
        "decevoir"
    ],
    "decevante": [
        "decevant"
    ],
    "decevantes": [
        "decevant"
    ],
    "decevants": [
        "decevant"
    ],
    "decevez": [
        "decevoir"
    ],
    "deceviez": [
        "decevoir"
    ],
    "decevoir": [
        "decevoir"
    ],
    "decevons": [
        "decevoir"
    ],
    "decevra": [
        "decevoir"
    ],
    "decevrai": [
        "decevoir"
    ],
    "decevraient": [
        "decevoir"
    ],
    "decevrais": [
        "decevoir"
    ],
    "decevrait": [
        "decevoir"
    ],
    "decevras": [
        "decevoir"
    ],
    "decevrez": [
        "decevoir"
    ],
    "dechait": [
        "decher"
    ],
    "dechanta": [
        "dechanter"
    ],
    "dechantai": [
        "dechanter"
    ],
    "dechantait": [
        "dechanter"
    ],
    "dechantant": [
        "dechanter"
    ],
    "dechante": [
        "dechanter"
    ],
    "dechantent": [
        "dechanter"
    ],
    "dechanter": [
        "dechanter"
    ],
    "dechanterais": [
        "dechanter"
    ],
    "dechanterent": [
        "dechanter"
    ],
    "dechard": [
        "dechard"
    ],
    "dechards": [
        "dechard"
    ],
    "decharge": [
        "decharge",
        "decharger"
    ],
    "dechargea": [
        "decharger"
    ],
    "dechargeaient": [
        "decharger"
    ],
    "dechargeait": [
        "decharger"
    ],
    "dechargeant": [
        "decharger"
    ],
    "dechargement": [
        "dechargement"
    ],
    "dechargent": [
        "decharger"
    ],
    "dechargeons": [
        "decharger"
    ],
    "decharger": [
        "decharger"
    ],
    "dechargera": [
        "decharger"
    ],
    "dechargerais": [
        "decharger"
    ],
    "dechargerait": [
        "decharger"
    ],
    "dechargerez": [
        "decharger"
    ],
    "decharges": [
        "decharge",
        "decharger"
    ],
    "dechargeur": [
        "dechargeur"
    ],
    "dechargez": [
        "decharger"
    ],
    "dechargeat": [
        "decharger"
    ],
    "dechargions": [
        "decharger"
    ],
    "dechargerent": [
        "decharger"
    ],
    "dechargee": [
        "decharger"
    ],
    "dechargees": [
        "decharger"
    ],
    "decharne": [
        "decharner",
        "decharne"
    ],
    "decharnement": [
        "decharnement"
    ],
    "decharnent": [
        "decharner"
    ],
    "decharner": [
        "decharner"
    ],
    "decharnerait": [
        "decharner"
    ],
    "decharnee": [
        "decharner",
        "decharne"
    ],
    "decharnees": [
        "decharner",
        "decharne"
    ],
    "decharnes": [
        "decharner",
        "decharne"
    ],
    "dechasse": [
        "dechasser"
    ],
    "dechaumaient": [
        "dechaumer"
    ],
    "dechaumee": [
        "dechaumer"
    ],
    "dechaussa": [
        "dechausser"
    ],
    "dechaussaient": [
        "dechausser"
    ],
    "dechaussait": [
        "dechausser"
    ],
    "dechaussant": [
        "dechausser"
    ],
    "dechausse": [
        "dechausse",
        "dechausser"
    ],
    "dechaussent": [
        "dechausser"
    ],
    "dechausser": [
        "dechausser"
    ],
    "dechausserais": [
        "dechausser"
    ],
    "dechaussez": [
        "dechausser"
    ],
    "dechaussee": [
        "dechausse",
        "dechausser"
    ],
    "dechaussees": [
        "dechausse",
        "dechausser"
    ],
    "dechausses": [
        "dechausse",
        "dechausser"
    ],
    "dechaina": [
        "dechainer"
    ],
    "dechainaient": [
        "dechainer"
    ],
    "dechainais": [
        "dechainer"
    ],
    "dechainait": [
        "dechainer"
    ],
    "dechainant": [
        "dechainer"
    ],
    "dechaine": [
        "dechainer",
        "dechaine"
    ],
    "dechainement": [
        "dechainement"
    ],
    "dechainements": [
        "dechainement"
    ],
    "dechainent": [
        "dechainer"
    ],
    "dechainer": [
        "dechainer"
    ],
    "dechainera": [
        "dechainer"
    ],
    "dechainerait": [
        "dechainer"
    ],
    "dechaineras": [
        "dechainer"
    ],
    "dechainez": [
        "dechainer"
    ],
    "dechainat": [
        "dechainer"
    ],
    "dechainerent": [
        "dechainer"
    ],
    "dechainee": [
        "dechainer",
        "dechaine"
    ],
    "dechainees": [
        "dechainer",
        "dechaine"
    ],
    "dechaines": [
        "dechainer",
        "dechaine"
    ],
    "decher": [
        "decher"
    ],
    "dechet": [
        "dechet"
    ],
    "dechets": [
        "dechet"
    ],
    "dechetterie": [
        "dechetterie"
    ],
    "dechiffra": [
        "dechiffrer"
    ],
    "dechiffrable": [
        "dechiffrable"
    ],
    "dechiffrables": [
        "dechiffrable"
    ],
    "dechiffrage": [
        "dechiffrage"
    ],
    "dechiffrai": [
        "dechiffrer"
    ],
    "dechiffraient": [
        "dechiffrer"
    ],
    "dechiffrais": [
        "dechiffrer"
    ],
    "dechiffrait": [
        "dechiffrer"
    ],
    "dechiffrant": [
        "dechiffrer"
    ],
    "dechiffre": [
        "dechiffrer"
    ],
    "dechiffrement": [
        "dechiffrement"
    ],
    "dechiffrent": [
        "dechiffrer"
    ],
    "dechiffrer": [
        "dechiffrer"
    ],
    "dechiffrera": [
        "dechiffrer"
    ],
    "dechiffreur": [
        "dechiffreur"
    ],
    "dechiffrez": [
        "dechiffrer"
    ],
    "dechiffrions": [
        "dechiffrer"
    ],
    "dechifframes": [
        "dechiffrer"
    ],
    "dechiffrat": [
        "dechiffrer"
    ],
    "dechiffrerent": [
        "dechiffrer"
    ],
    "dechiffree": [
        "dechiffrer"
    ],
    "dechiffrees": [
        "dechiffrer"
    ],
    "dechiffres": [
        "dechiffrer"
    ],
    "dechiqueta": [
        "dechiqueter"
    ],
    "dechiquetage": [
        "dechiquetage"
    ],
    "dechiquetaient": [
        "dechiqueter"
    ],
    "dechiquetait": [
        "dechiqueter"
    ],
    "dechiquetant": [
        "dechiqueter"
    ],
    "dechiqueter": [
        "dechiqueter"
    ],
    "dechiqueteur": [
        "dechiqueteur"
    ],
    "dechiqueteurs": [
        "dechiqueteur"
    ],
    "dechiqueteuse": [
        "dechiqueteur"
    ],
    "dechiqueteuses": [
        "dechiqueteur"
    ],
    "dechiquetons": [
        "dechiqueter"
    ],
    "dechiquette": [
        "dechiqueter"
    ],
    "dechiquettent": [
        "dechiqueter"
    ],
    "dechiquettes": [
        "dechiqueter"
    ],
    "dechiquete": [
        "dechiqueter",
        "dechiquete"
    ],
    "dechiquetee": [
        "dechiqueter",
        "dechiquete"
    ],
    "dechiquetees": [
        "dechiqueter",
        "dechiquete"
    ],
    "dechiquetes": [
        "dechiqueter",
        "dechiquete"
    ],
    "dechira": [
        "dechirer"
    ],
    "dechirage": [
        "dechirage"
    ],
    "dechirages": [
        "dechirage"
    ],
    "dechirai": [
        "dechirer"
    ],
    "dechiraient": [
        "dechirer"
    ],
    "dechirais": [
        "dechirer"
    ],
    "dechirait": [
        "dechirer"
    ],
    "dechirant": [
        "dechirant",
        "dechirer"
    ],
    "dechirante": [
        "dechirant"
    ],
    "dechirantes": [
        "dechirant"
    ],
    "dechirants": [
        "dechirant"
    ],
    "dechire": [
        "dechire",
        "dechirer"
    ],
    "dechirement": [
        "dechirement"
    ],
    "dechirements": [
        "dechirement"
    ],
    "dechirent": [
        "dechirer"
    ],
    "dechirer": [
        "dechirer"
    ],
    "dechirera": [
        "dechirer"
    ],
    "dechirerai": [
        "dechirer"
    ],
    "dechireraient": [
        "dechirer"
    ],
    "dechirerais": [
        "dechirer"
    ],
    "dechirerait": [
        "dechirer"
    ],
    "dechireras": [
        "dechirer"
    ],
    "dechirerons": [
        "dechirer"
    ],
    "dechireront": [
        "dechirer"
    ],
    "dechires": [
        "dechire",
        "dechirer"
    ],
    "dechireur": [
        "dechireur"
    ],
    "dechirez": [
        "dechirer"
    ],
    "dechiriez": [
        "dechirer"
    ],
    "dechirions": [
        "dechirer"
    ],
    "dechirons": [
        "dechirer"
    ],
    "dechirure": [
        "dechirure"
    ],
    "dechirures": [
        "dechirure"
    ],
    "dechirat": [
        "dechirer"
    ],
    "dechirerent": [
        "dechirer"
    ],
    "dechiree": [
        "dechire",
        "dechirer"
    ],
    "dechirees": [
        "dechire",
        "dechirer"
    ],
    "dechoient": [
        "dechoir"
    ],
    "dechoir": [
        "dechoir"
    ],
    "dechoirons": [
        "dechoir"
    ],
    "dechouer": [
        "dechouer"
    ],
    "dechristianise": [
        "dechristianiser"
    ],
    "dechu": [
        "dechoir",
        "dechu"
    ],
    "dechue": [
        "dechoir",
        "dechu"
    ],
    "dechues": [
        "dechoir",
        "dechu"
    ],
    "dechus": [
        "dechoir",
        "dechu"
    ],
    "decheance": [
        "decheance"
    ],
    "decheances": [
        "decheance"
    ],
    "deci": [
        "deci"
    ],
    "decibel": [
        "decibel"
    ],
    "decibels": [
        "decibel"
    ],
    "decida": [
        "decider"
    ],
    "decidai": [
        "decider"
    ],
    "decidaient": [
        "decider"
    ],
    "decidais": [
        "decider"
    ],
    "decidait": [
        "decider"
    ],
    "decidant": [
        "decider"
    ],
    "decide": [
        "decider",
        "decide"
    ],
    "decident": [
        "decider"
    ],
    "decider": [
        "decider"
    ],
    "decidera": [
        "decider"
    ],
    "deciderai": [
        "decider"
    ],
    "decideraient": [
        "decider"
    ],
    "deciderais": [
        "decider"
    ],
    "deciderait": [
        "decider"
    ],
    "decideras": [
        "decider"
    ],
    "deciderez": [
        "decider"
    ],
    "decideriez": [
        "decider"
    ],
    "deciderions": [
        "decider"
    ],
    "deciderons": [
        "decider"
    ],
    "decideront": [
        "decider"
    ],
    "decides": [
        "decider",
        "decide"
    ],
    "decideur": [
        "decideur"
    ],
    "decideurs": [
        "decideur"
    ],
    "decidez": [
        "decider"
    ],
    "decidiez": [
        "decider"
    ],
    "decidions": [
        "decider"
    ],
    "decidons": [
        "decider"
    ],
    "decidames": [
        "decider"
    ],
    "decidat": [
        "decider"
    ],
    "deciderent": [
        "decider"
    ],
    "decidee": [
        "decider",
        "decide"
    ],
    "decidees": [
        "decider",
        "decide"
    ],
    "decidement": [
        "decidement"
    ],
    "decigramme": [
        "decigramme"
    ],
    "decigrammes": [
        "decigramme"
    ],
    "decile": [
        "decile"
    ],
    "decilitre": [
        "decilitre"
    ],
    "decima": [
        "decimer"
    ],
    "decimaient": [
        "decimer"
    ],
    "decimait": [
        "decimer"
    ],
    "decimal": [
        "decimal"
    ],
    "decimale": [
        "decimal"
    ],
    "decimales": [
        "decimal"
    ],
    "decimalisation": [
        "decimalisation"
    ],
    "decimalite": [
        "decimalite"
    ],
    "decimant": [
        "decimer"
    ],
    "decimateur": [
        "decimateur"
    ],
    "decimation": [
        "decimation"
    ],
    "decime": [
        "decimer"
    ],
    "deciment": [
        "decimer"
    ],
    "decimer": [
        "decimer"
    ],
    "decimera": [
        "decimer"
    ],
    "decimerai": [
        "decimer"
    ],
    "decimerait": [
        "decimer"
    ],
    "decimeront": [
        "decimer"
    ],
    "decimes": [
        "decimer",
        "decime"
    ],
    "decimerent": [
        "decimer"
    ],
    "decimetre": [
        "decimetre"
    ],
    "decimetres": [
        "decimetre"
    ],
    "decimee": [
        "decimer"
    ],
    "decimees": [
        "decimer"
    ],
    "decisif": [
        "decisif"
    ],
    "decisifs": [
        "decisif"
    ],
    "decision": [
        "decision"
    ],
    "decisionnaire": [
        "decisionnaire"
    ],
    "decisionnel": [
        "decisionnel"
    ],
    "decisionnelles": [
        "decisionnel"
    ],
    "decisions": [
        "decision"
    ],
    "decisive": [
        "decisif"
    ],
    "decisives": [
        "decisif"
    ],
    "decivilises": [
        "deciviliser"
    ],
    "declama": [
        "declamer"
    ],
    "declamai": [
        "declamer"
    ],
    "declamaient": [
        "declamer"
    ],
    "declamais": [
        "declamer"
    ],
    "declamait": [
        "declamer"
    ],
    "declamant": [
        "declamer"
    ],
    "declamation": [
        "declamation"
    ],
    "declamations": [
        "declamation"
    ],
    "declamatoire": [
        "declamatoire"
    ],
    "declamatoires": [
        "declamatoire"
    ],
    "declamatrice": [
        "declamateur"
    ],
    "declame": [
        "declamer"
    ],
    "declamer": [
        "declamer"
    ],
    "declamera": [
        "declamer"
    ],
    "declamerait": [
        "declamer"
    ],
    "declamat": [
        "declamer"
    ],
    "declamee": [
        "declamer"
    ],
    "declanche": [
        "declancher"
    ],
    "declancher": [
        "declancher"
    ],
    "declanchera": [
        "declancher"
    ],
    "declara": [
        "declarer"
    ],
    "declarai": [
        "declarer"
    ],
    "declaraient": [
        "declarer"
    ],
    "declarais": [
        "declarer"
    ],
    "declarait": [
        "declarer"
    ],
    "declarant": [
        "declarant",
        "declarer"
    ],
    "declaration": [
        "declaration"
    ],
    "declarations": [
        "declaration"
    ],
    "declarative": [
        "declaratif"
    ],
    "declaratoire": [
        "declaratoire"
    ],
    "declare": [
        "declare",
        "declarer"
    ],
    "declarent": [
        "declarer"
    ],
    "declarer": [
        "declarer"
    ],
    "declarera": [
        "declarer"
    ],
    "declarerai": [
        "declarer"
    ],
    "declarerais": [
        "declarer"
    ],
    "declarerait": [
        "declarer"
    ],
    "declareriez": [
        "declarer"
    ],
    "declarerions": [
        "declarer"
    ],
    "declarerons": [
        "declarer"
    ],
    "declareront": [
        "declarer"
    ],
    "declares": [
        "declare",
        "declarer"
    ],
    "declarez": [
        "declarer"
    ],
    "declariez": [
        "declarer"
    ],
    "declarions": [
        "declarer"
    ],
    "declarons": [
        "declarer"
    ],
    "declarat": [
        "declarer"
    ],
    "declarerent": [
        "declarer"
    ],
    "declaree": [
        "declare",
        "declarer"
    ],
    "declarees": [
        "declare",
        "declarer"
    ],
    "declasse": [
        "declasser",
        "declasse"
    ],
    "declassement": [
        "declassement"
    ],
    "declasser": [
        "declasser"
    ],
    "declassee": [
        "declasser",
        "declasse"
    ],
    "declassees": [
        "declasser",
        "declasse"
    ],
    "declasses": [
        "declasse"
    ],
    "declavetees": [
        "declaveter"
    ],
    "declencha": [
        "declencher"
    ],
    "declenchai": [
        "declencher"
    ],
    "declenchaient": [
        "declencher"
    ],
    "declenchait": [
        "declencher"
    ],
    "declenchant": [
        "declencher",
        "declenchant"
    ],
    "declenche": [
        "declencher",
        "declenche"
    ],
    "declenchement": [
        "declenchement"
    ],
    "declenchent": [
        "declencher"
    ],
    "declencher": [
        "declencher"
    ],
    "declenchera": [
        "declencher"
    ],
    "declencherai": [
        "declencher"
    ],
    "declencheraient": [
        "declencher"
    ],
    "declencherais": [
        "declencher"
    ],
    "declencherait": [
        "declencher"
    ],
    "declencherez": [
        "declencher"
    ],
    "declencherons": [
        "declencher"
    ],
    "declencheront": [
        "declencher"
    ],
    "declencheur": [
        "declencheur"
    ],
    "declencheurs": [
        "declencheur"
    ],
    "declenchez": [
        "declencher"
    ],
    "declenchions": [
        "declencher"
    ],
    "declenchons": [
        "declencher"
    ],
    "declenchat": [
        "declencher"
    ],
    "declencherent": [
        "declencher"
    ],
    "declenchee": [
        "declencher"
    ],
    "declenchees": [
        "declencher"
    ],
    "declenches": [
        "declencher"
    ],
    "declic": [
        "declic"
    ],
    "declics": [
        "declic"
    ],
    "declin": [
        "declin"
    ],
    "declina": [
        "decliner"
    ],
    "declinai": [
        "decliner"
    ],
    "declinaient": [
        "decliner"
    ],
    "declinais": [
        "decliner"
    ],
    "declinaison": [
        "declinaison"
    ],
    "declinaisons": [
        "declinaison"
    ],
    "declinait": [
        "decliner"
    ],
    "declinant": [
        "declinant",
        "decliner"
    ],
    "declinante": [
        "declinant"
    ],
    "declinants": [
        "declinant"
    ],
    "decline": [
        "decliner"
    ],
    "declinent": [
        "decliner"
    ],
    "decliner": [
        "decliner"
    ],
    "declinera": [
        "decliner"
    ],
    "declines": [
        "decline",
        "decliner"
    ],
    "declinez": [
        "decliner"
    ],
    "declinions": [
        "decliner"
    ],
    "declins": [
        "declin"
    ],
    "declinerent": [
        "decliner"
    ],
    "declinee": [
        "decliner"
    ],
    "declique": [
        "decliquer"
    ],
    "decliquete": [
        "decliqueter"
    ],
    "declive": [
        "declive"
    ],
    "declives": [
        "declive"
    ],
    "declivite": [
        "declivite"
    ],
    "declivites": [
        "declivite"
    ],
    "decloisonnee": [
        "decloisonner"
    ],
    "declose": [
        "declore",
        "declos"
    ],
    "decloses": [
        "declos"
    ],
    "declouer": [
        "declouer"
    ],
    "declouerent": [
        "declouer"
    ],
    "decloue": [
        "declouer"
    ],
    "declouee": [
        "declouer"
    ],
    "declouees": [
        "declouer"
    ],
    "deco": [
        "deco"
    ],
    "decocha": [
        "decocher"
    ],
    "decochai": [
        "decocher"
    ],
    "decochaient": [
        "decocher"
    ],
    "decochais": [
        "decocher"
    ],
    "decochait": [
        "decocher"
    ],
    "decochant": [
        "decocher"
    ],
    "decoche": [
        "decocher"
    ],
    "decochent": [
        "decocher"
    ],
    "decocher": [
        "decocher"
    ],
    "decochera": [
        "decocher"
    ],
    "decocheuses": [
        "decocheur"
    ],
    "decochez": [
        "decocher"
    ],
    "decochee": [
        "decocher"
    ],
    "decochees": [
        "decocher"
    ],
    "decoconne": [
        "decoconner"
    ],
    "decoconnerai": [
        "decoconner"
    ],
    "decoction": [
        "decoction"
    ],
    "decoctions": [
        "decoction"
    ],
    "decodage": [
        "decodage"
    ],
    "decodages": [
        "decodage"
    ],
    "decodait": [
        "decoder"
    ],
    "decodant": [
        "decoder"
    ],
    "decode": [
        "decoder"
    ],
    "decodent": [
        "decoder"
    ],
    "decoder": [
        "decoder"
    ],
    "decoderai": [
        "decoder"
    ],
    "decodeur": [
        "decodeur"
    ],
    "decodeurs": [
        "decodeur"
    ],
    "decodeuse": [
        "decodeur"
    ],
    "decodez": [
        "decoder"
    ],
    "decodons": [
        "decoder"
    ],
    "decodee": [
        "decoder"
    ],
    "decodees": [
        "decoder"
    ],
    "decodes": [
        "decoder",
        "decode"
    ],
    "decoffrage": [
        "decoffrage"
    ],
    "decoffres": [
        "decoffrer"
    ],
    "decoiffa": [
        "decoiffer"
    ],
    "decoiffait": [
        "decoiffer"
    ],
    "decoiffe": [
        "decoiffer"
    ],
    "decoiffer": [
        "decoiffer"
    ],
    "decoiffera": [
        "decoiffer"
    ],
    "decoifferais": [
        "decoiffer"
    ],
    "decoifferait": [
        "decoiffer"
    ],
    "decoiffes": [
        "decoiffer"
    ],
    "decoiffez": [
        "decoiffer"
    ],
    "decoiffee": [
        "decoiffer"
    ],
    "decoiffees": [
        "decoiffer"
    ],
    "decoince": [
        "decoincer"
    ],
    "decoincer": [
        "decoincer"
    ],
    "decoincera": [
        "decoincer"
    ],
    "decoincerait": [
        "decoincer"
    ],
    "decoinces": [
        "decoincer"
    ],
    "decoincez": [
        "decoincer"
    ],
    "decoinca": [
        "decoincer"
    ],
    "decoincage": [
        "decoincage"
    ],
    "decoincant": [
        "decoincer"
    ],
    "decolla": [
        "decoller"
    ],
    "decollage": [
        "decollage"
    ],
    "decollages": [
        "decollage"
    ],
    "decollai": [
        "decoller"
    ],
    "decollaient": [
        "decoller"
    ],
    "decollais": [
        "decoller"
    ],
    "decollait": [
        "decoller"
    ],
    "decollant": [
        "decoller"
    ],
    "decollassions": [
        "decoller"
    ],
    "decollation": [
        "decollation"
    ],
    "decolle": [
        "decoller"
    ],
    "decollement": [
        "decollement"
    ],
    "decollements": [
        "decollement"
    ],
    "decollent": [
        "decoller"
    ],
    "decoller": [
        "decoller"
    ],
    "decollera": [
        "decoller"
    ],
    "decollerai": [
        "decoller"
    ],
    "decollerait": [
        "decoller"
    ],
    "decolleras": [
        "decoller"
    ],
    "decollerons": [
        "decoller"
    ],
    "decolleront": [
        "decoller"
    ],
    "decolles": [
        "decoller"
    ],
    "decolleter": [
        "decolleter"
    ],
    "decollete": [
        "decolleter",
        "decollete"
    ],
    "decolletee": [
        "decolleter",
        "decollete"
    ],
    "decolletees": [
        "decolleter",
        "decollete"
    ],
    "decolletes": [
        "decollete"
    ],
    "decollez": [
        "decoller"
    ],
    "decollons": [
        "decoller"
    ],
    "decollerent": [
        "decoller"
    ],
    "decollee": [
        "decoller"
    ],
    "decollees": [
        "decoller"
    ],
    "decolonisation": [
        "decolonisation"
    ],
    "decolonise": [
        "decoloniser"
    ],
    "decolora": [
        "decolorer"
    ],
    "decoloraient": [
        "decolorer"
    ],
    "decolorait": [
        "decolorer"
    ],
    "decolorant": [
        "decolorant",
        "decolorer"
    ],
    "decoloration": [
        "decoloration"
    ],
    "decolorations": [
        "decoloration"
    ],
    "decolore": [
        "decolorer",
        "decolore"
    ],
    "decolorent": [
        "decolorer"
    ],
    "decolorer": [
        "decolorer"
    ],
    "decoloree": [
        "decolorer",
        "decolore"
    ],
    "decolorees": [
        "decolorer",
        "decolore"
    ],
    "decolores": [
        "decolorer",
        "decolore"
    ],
    "decolere": [
        "decolerer"
    ],
    "decoleraient": [
        "decolerer"
    ],
    "decolerais": [
        "decolerer"
    ],
    "decolerait": [
        "decolerer"
    ],
    "decolerer": [
        "decolerer"
    ],
    "decombre": [
        "decombrer"
    ],
    "decombres": [
        "decombre"
    ],
    "decommanda": [
        "decommander"
    ],
    "decommandai": [
        "decommander"
    ],
    "decommandais": [
        "decommander"
    ],
    "decommandait": [
        "decommander"
    ],
    "decommande": [
        "decommander"
    ],
    "decommander": [
        "decommander"
    ],
    "decommanderait": [
        "decommander"
    ],
    "decommandes": [
        "decommander"
    ],
    "decommandez": [
        "decommander"
    ],
    "decommandee": [
        "decommander"
    ],
    "decommandees": [
        "decommander"
    ],
    "decompensation": [
        "decompensation"
    ],
    "decompenser": [
        "decompenser"
    ],
    "decompense": [
        "decompenser"
    ],
    "decompliquer": [
        "decompliquer"
    ],
    "decomposa": [
        "decomposer"
    ],
    "decomposable": [
        "decomposable"
    ],
    "decomposaient": [
        "decomposer"
    ],
    "decomposais": [
        "decomposer"
    ],
    "decomposait": [
        "decomposer"
    ],
    "decomposant": [
        "decomposer"
    ],
    "decompose": [
        "decomposer",
        "decompose"
    ],
    "decomposent": [
        "decomposer"
    ],
    "decomposer": [
        "decomposer"
    ],
    "decomposera": [
        "decomposer"
    ],
    "decomposeraient": [
        "decomposer"
    ],
    "decomposerait": [
        "decomposer"
    ],
    "decomposeur": [
        "decomposeur"
    ],
    "decomposition": [
        "decomposition"
    ],
    "decompositions": [
        "decomposition"
    ],
    "decomposee": [
        "decomposer",
        "decompose"
    ],
    "decomposees": [
        "decomposer",
        "decompose"
    ],
    "decomposes": [
        "decomposer",
        "decompose"
    ],
    "decompressa": [
        "decompresser"
    ],
    "decompresse": [
        "decompresser"
    ],
    "decompresser": [
        "decompresser"
    ],
    "decompressez": [
        "decompresser"
    ],
    "decompression": [
        "decompression"
    ],
    "decompressions": [
        "decompression"
    ],
    "decomprimer": [
        "decomprimer"
    ],
    "decompte": [
        "decompte",
        "decompter"
    ],
    "decompter": [
        "decompter"
    ],
    "decomptes": [
        "decompte",
        "decompter"
    ],
    "deconcentrant": [
        "deconcentrer"
    ],
    "deconcentration": [
        "deconcentration"
    ],
    "deconcentrent": [
        "deconcentrer"
    ],
    "deconcentrer": [
        "deconcentrer"
    ],
    "deconcentrez": [
        "deconcentrer"
    ],
    "deconcentre": [
        "deconcentrer"
    ],
    "deconcentree": [
        "deconcentrer"
    ],
    "deconcerta": [
        "deconcerter"
    ],
    "deconcertait": [
        "deconcerter"
    ],
    "deconcertant": [
        "deconcerter",
        "deconcertant"
    ],
    "deconcertante": [
        "deconcertant"
    ],
    "deconcertantes": [
        "deconcertant"
    ],
    "deconcertants": [
        "deconcertant"
    ],
    "deconcerte": [
        "deconcerter",
        "deconcerte"
    ],
    "deconcertent": [
        "deconcerter"
    ],
    "deconcerter": [
        "deconcerter"
    ],
    "deconcertera": [
        "deconcerter"
    ],
    "deconcertez": [
        "deconcerter"
    ],
    "deconcerterent": [
        "deconcerter"
    ],
    "deconcertee": [
        "deconcerter",
        "deconcerte"
    ],
    "deconcertes": [
        "deconcerter",
        "deconcerte"
    ],
    "deconditionnement": [
        "deconditionnement"
    ],
    "deconditionner": [
        "deconditionner"
    ],
    "deconfire": [
        "deconfire"
    ],
    "deconfit": [
        "deconfire",
        "deconfit"
    ],
    "deconfite": [
        "deconfire",
        "deconfit"
    ],
    "deconfits": [
        "deconfire",
        "deconfit"
    ],
    "deconfiture": [
        "deconfiture"
    ],
    "deconfitures": [
        "deconfiture"
    ],
    "decongela": [
        "decongeler"
    ],
    "decongeler": [
        "decongeler"
    ],
    "decongele": [
        "decongeler"
    ],
    "decongelee": [
        "decongeler"
    ],
    "decongestif": [
        "decongestif"
    ],
    "decongestion": [
        "decongestion"
    ],
    "decongestionnant": [
        "decongestionner"
    ],
    "decongestionne": [
        "decongestionner"
    ],
    "decongestionner": [
        "decongestionner"
    ],
    "decongelera": [
        "decongeler"
    ],
    "decongelation": [
        "decongelation"
    ],
    "deconnage": [
        "deconnage"
    ],
    "deconnages": [
        "deconnage"
    ],
    "deconnaient": [
        "deconner"
    ],
    "deconnais": [
        "deconner"
    ],
    "deconnait": [
        "deconner"
    ],
    "deconnant": [
        "deconner"
    ],
    "deconne": [
        "deconner"
    ],
    "deconnectaient": [
        "deconnecter"
    ],
    "deconnectant": [
        "deconnecter"
    ],
    "deconnecte": [
        "deconnecter"
    ],
    "deconnectent": [
        "deconnecter"
    ],
    "deconnecter": [
        "deconnecter"
    ],
    "deconnectez": [
        "deconnecter"
    ],
    "deconnectiez": [
        "deconnecter"
    ],
    "deconnection": [
        "deconnection"
    ],
    "deconnectons": [
        "deconnecter"
    ],
    "deconnectee": [
        "deconnecter"
    ],
    "deconnectes": [
        "deconnecter"
    ],
    "deconnent": [
        "deconner"
    ],
    "deconner": [
        "deconner"
    ],
    "deconnerai": [
        "deconner"
    ],
    "deconnerais": [
        "deconner"
    ],
    "deconnes": [
        "deconner"
    ],
    "deconneur": [
        "deconneur"
    ],
    "deconneurs": [
        "deconneur"
    ],
    "deconneuse": [
        "deconneur"
    ],
    "deconnexion": [
        "deconnexion"
    ],
    "deconnez": [
        "deconner"
    ],
    "deconometre": [
        "deconometre"
    ],
    "deconophone": [
        "deconophone"
    ],
    "deconophones": [
        "deconophone"
    ],
    "deconseilla": [
        "deconseiller"
    ],
    "deconseillai": [
        "deconseiller"
    ],
    "deconseillait": [
        "deconseiller"
    ],
    "deconseillant": [
        "deconseiller"
    ],
    "deconseille": [
        "deconseiller"
    ],
    "deconseiller": [
        "deconseiller"
    ],
    "deconseillerais": [
        "deconseiller"
    ],
    "deconseilles": [
        "deconseiller"
    ],
    "deconseillerent": [
        "deconseiller"
    ],
    "deconseillee": [
        "deconseiller"
    ],
    "deconseillees": [
        "deconseiller"
    ],
    "deconsiderent": [
        "deconsiderer"
    ],
    "deconsideraient": [
        "deconsiderer"
    ],
    "deconsiderait": [
        "deconsiderer"
    ],
    "deconsiderant": [
        "deconsiderer"
    ],
    "deconsideration": [
        "deconsideration"
    ],
    "deconsiderer": [
        "deconsiderer"
    ],
    "deconsidere": [
        "deconsiderer"
    ],
    "deconsideree": [
        "deconsiderer"
    ],
    "deconsideres": [
        "deconsiderer"
    ],
    "deconsigner": [
        "deconsigner"
    ],
    "deconstipe": [
        "deconstiper"
    ],
    "deconstiper": [
        "deconstiper"
    ],
    "deconstruction": [
        "deconstruction"
    ],
    "deconstruit": [
        "deconstruire"
    ],
    "decontaminant": [
        "decontaminer"
    ],
    "decontamination": [
        "decontamination"
    ],
    "decontaminer": [
        "decontaminer"
    ],
    "decontamine": [
        "decontaminer"
    ],
    "decontenancer": [
        "decontenancer"
    ],
    "decontenance": [
        "decontenance",
        "decontenancer"
    ],
    "decontenancee": [
        "decontenance",
        "decontenancer"
    ],
    "decontenances": [
        "decontenance",
        "decontenancer"
    ],
    "decontenanca": [
        "decontenancer"
    ],
    "decontenancaient": [
        "decontenancer"
    ],
    "decontenancait": [
        "decontenancer"
    ],
    "decontract": [
        "decontract"
    ],
    "decontracta": [
        "decontracter"
    ],
    "decontractaient": [
        "decontracter"
    ],
    "decontractait": [
        "decontracter"
    ],
    "decontractant": [
        "decontracter"
    ],
    "decontracte": [
        "decontracter",
        "decontracte"
    ],
    "decontracter": [
        "decontracter"
    ],
    "decontractez": [
        "decontracter"
    ],
    "decontraction": [
        "decontraction"
    ],
    "decontractee": [
        "decontracter",
        "decontracte"
    ],
    "decontractees": [
        "decontracte"
    ],
    "decontractes": [
        "decontracter",
        "decontracte"
    ],
    "deconvenue": [
        "deconvenue"
    ],
    "deconvenues": [
        "deconvenue"
    ],
    "decor": [
        "decor"
    ],
    "decora": [
        "decorer"
    ],
    "decorai": [
        "decorer"
    ],
    "decoraient": [
        "decorer"
    ],
    "decorais": [
        "decorer"
    ],
    "decorait": [
        "decorer"
    ],
    "decorant": [
        "decorer"
    ],
    "decorateur": [
        "decorateur"
    ],
    "decorateurs": [
        "decorateur"
    ],
    "decoratif": [
        "decoratif"
    ],
    "decoratifs": [
        "decoratif"
    ],
    "decoration": [
        "decoration"
    ],
    "decorations": [
        "decoration"
    ],
    "decorative": [
        "decoratif"
    ],
    "decoratives": [
        "decoratif"
    ],
    "decoratrice": [
        "decorateur"
    ],
    "decoratrices": [
        "decorateur"
    ],
    "decore": [
        "decore",
        "decorer"
    ],
    "decorent": [
        "decorer"
    ],
    "decorer": [
        "decorer"
    ],
    "decorera": [
        "decorer"
    ],
    "decorerait": [
        "decorer"
    ],
    "decoreront": [
        "decorer"
    ],
    "decorez": [
        "decorer"
    ],
    "decorne": [
        "decorner"
    ],
    "decorner": [
        "decorner"
    ],
    "decors": [
        "decor"
    ],
    "decorticage": [
        "decorticage"
    ],
    "decortication": [
        "decortication"
    ],
    "decortiqua": [
        "decortiquer"
    ],
    "decortiquaient": [
        "decortiquer"
    ],
    "decortiquait": [
        "decortiquer"
    ],
    "decortiquant": [
        "decortiquer"
    ],
    "decortique": [
        "decortique",
        "decortiquer"
    ],
    "decortiquent": [
        "decortiquer"
    ],
    "decortiquer": [
        "decortiquer"
    ],
    "decortiquez": [
        "decortiquer"
    ],
    "decortiquee": [
        "decortique",
        "decortiquer"
    ],
    "decortiquees": [
        "decortiquer"
    ],
    "decortiques": [
        "decortiquer"
    ],
    "decorum": [
        "decorum"
    ],
    "decorat": [
        "decorer"
    ],
    "decorerent": [
        "decorer"
    ],
    "decoree": [
        "decore",
        "decorer"
    ],
    "decorees": [
        "decore",
        "decorer"
    ],
    "decores": [
        "decore",
        "decorer"
    ],
    "decoucha": [
        "decoucher"
    ],
    "decouchaient": [
        "decoucher"
    ],
    "decouche": [
        "decoucher"
    ],
    "decoucher": [
        "decoucher"
    ],
    "decouches": [
        "decoucher"
    ],
    "decoud": [
        "decoudre"
    ],
    "decoudre": [
        "decoudre"
    ],
    "decoulaient": [
        "decouler"
    ],
    "decoulait": [
        "decouler"
    ],
    "decoulant": [
        "decouler"
    ],
    "decoule": [
        "decouler"
    ],
    "decoulent": [
        "decouler"
    ],
    "decouler": [
        "decouler"
    ],
    "decoulera": [
        "decouler"
    ],
    "decoulerait": [
        "decouler"
    ],
    "decoulerent": [
        "decouler"
    ],
    "decoupa": [
        "decouper"
    ],
    "decoupage": [
        "decoupage"
    ],
    "decoupages": [
        "decoupage"
    ],
    "decoupai": [
        "decouper"
    ],
    "decoupaient": [
        "decouper"
    ],
    "decoupais": [
        "decouper"
    ],
    "decoupait": [
        "decouper"
    ],
    "decoupant": [
        "decouper"
    ],
    "decoupe": [
        "decoupe",
        "decouper"
    ],
    "decoupent": [
        "decouper"
    ],
    "decouper": [
        "decouper"
    ],
    "decoupera": [
        "decouper"
    ],
    "decouperai": [
        "decouper"
    ],
    "decouperaient": [
        "decouper"
    ],
    "decouperais": [
        "decouper"
    ],
    "decouperait": [
        "decouper"
    ],
    "decouperont": [
        "decouper"
    ],
    "decoupes": [
        "decoupe",
        "decouper"
    ],
    "decoupeur": [
        "decoupeur"
    ],
    "decoupeurs": [
        "decoupeur"
    ],
    "decoupeuse": [
        "decoupeur"
    ],
    "decoupez": [
        "decouper"
    ],
    "decoupions": [
        "decouper"
    ],
    "decouplage": [
        "decouplage"
    ],
    "decoupler": [
        "decoupler"
    ],
    "decouplons": [
        "decoupler"
    ],
    "decouple": [
        "decoupler",
        "decouple"
    ],
    "decouplee": [
        "decoupler",
        "decouple"
    ],
    "decoupons": [
        "decouper"
    ],
    "decoupure": [
        "decoupure"
    ],
    "decoupures": [
        "decoupure"
    ],
    "decouperent": [
        "decouper"
    ],
    "decoupee": [
        "decoupe",
        "decouper"
    ],
    "decoupees": [
        "decoupe",
        "decouper"
    ],
    "decourage": [
        "decourage",
        "decourager"
    ],
    "decouragea": [
        "decourager"
    ],
    "decourageai": [
        "decourager"
    ],
    "decourageaient": [
        "decourager"
    ],
    "decourageais": [
        "decourager"
    ],
    "decourageait": [
        "decourager"
    ],
    "decourageant": [
        "decourager",
        "decourageant"
    ],
    "decourageante": [
        "decourageant"
    ],
    "decourageantes": [
        "decourageant"
    ],
    "decourageants": [
        "decourageant"
    ],
    "decouragement": [
        "decouragement"
    ],
    "decouragements": [
        "decouragement"
    ],
    "decouragent": [
        "decourager"
    ],
    "decourageons": [
        "decourager"
    ],
    "decourager": [
        "decourager"
    ],
    "decouragera": [
        "decourager"
    ],
    "decouragerais": [
        "decourager"
    ],
    "decouragerait": [
        "decourager"
    ],
    "decourages": [
        "decourage",
        "decourager"
    ],
    "decouragez": [
        "decourager"
    ],
    "decourageat": [
        "decourager"
    ],
    "decouragerent": [
        "decourager"
    ],
    "decouragee": [
        "decourage",
        "decourager"
    ],
    "decouragees": [
        "decourage",
        "decourager"
    ],
    "decouronne": [
        "decouronner"
    ],
    "decouronnes": [
        "decouronner"
    ],
    "decours": [
        "decours"
    ],
    "decousit": [
        "decoudre"
    ],
    "decousu": [
        "decousu",
        "decoudre"
    ],
    "decousue": [
        "decousu",
        "decoudre"
    ],
    "decousues": [
        "decousu",
        "decoudre"
    ],
    "decousus": [
        "decousu",
        "decoudre"
    ],
    "decouvert": [
        "decouvrir",
        "decouvert"
    ],
    "decouverte": [
        "decouverte",
        "decouvert"
    ],
    "decouvertes": [
        "decouverte",
        "decouvert"
    ],
    "decouverts": [
        "decouvrir",
        "decouvert"
    ],
    "decouvraient": [
        "decouvrir"
    ],
    "decouvrais": [
        "decouvrir"
    ],
    "decouvrait": [
        "decouvrir"
    ],
    "decouvrant": [
        "decouvrir"
    ],
    "decouvre": [
        "decouvrir"
    ],
    "decouvrent": [
        "decouvrir"
    ],
    "decouvres": [
        "decouvrir"
    ],
    "decouvreur": [
        "decouvreur"
    ],
    "decouvreurs": [
        "decouvreur"
    ],
    "decouvreuse": [
        "decouvreur"
    ],
    "decouvrez": [
        "decouvrir"
    ],
    "decouvriez": [
        "decouvrir"
    ],
    "decouvrions": [
        "decouvrir"
    ],
    "decouvrir": [
        "decouvrir"
    ],
    "decouvrira": [
        "decouvrir"
    ],
    "decouvrirai": [
        "decouvrir"
    ],
    "decouvriraient": [
        "decouvrir"
    ],
    "decouvrirais": [
        "decouvrir"
    ],
    "decouvrirait": [
        "decouvrir"
    ],
    "decouvriras": [
        "decouvrir"
    ],
    "decouvrirent": [
        "decouvrir"
    ],
    "decouvrirez": [
        "decouvrir"
    ],
    "decouvririez": [
        "decouvrir"
    ],
    "decouvrirons": [
        "decouvrir"
    ],
    "decouvriront": [
        "decouvrir"
    ],
    "decouvris": [
        "decouvrir"
    ],
    "decouvrisse": [
        "decouvrir"
    ],
    "decouvrissent": [
        "decouvrir"
    ],
    "decouvrit": [
        "decouvrir"
    ],
    "decouvrons": [
        "decouvrir"
    ],
    "decouvrimes": [
        "decouvrir"
    ],
    "decramponner": [
        "decramponner"
    ],
    "decrapouille": [
        "decrapouiller"
    ],
    "decrassage": [
        "decrassage"
    ],
    "decrassait": [
        "decrasser"
    ],
    "decrasse": [
        "decrasser"
    ],
    "decrasser": [
        "decrasser"
    ],
    "decrasses": [
        "decrasser"
    ],
    "decret": [
        "decret"
    ],
    "decrets": [
        "decret"
    ],
    "decrie": [
        "decrier",
        "decrie"
    ],
    "decrier": [
        "decrier"
    ],
    "decries": [
        "decrier",
        "decrie"
    ],
    "decriez": [
        "decrier"
    ],
    "decriminaliser": [
        "decriminaliser"
    ],
    "decrira": [
        "decrire"
    ],
    "decrirai": [
        "decrire"
    ],
    "decriraient": [
        "decrire"
    ],
    "decrirais": [
        "decrire"
    ],
    "decrirait": [
        "decrire"
    ],
    "decriras": [
        "decrire"
    ],
    "decrire": [
        "decrire"
    ],
    "decrirez": [
        "decrire"
    ],
    "decririez": [
        "decrire"
    ],
    "decriront": [
        "decrire"
    ],
    "decris": [
        "decri",
        "decrire"
    ],
    "decrispe": [
        "decrisper"
    ],
    "decrisper": [
        "decrisper"
    ],
    "decrispat": [
        "decrisper"
    ],
    "decrit": [
        "decrit",
        "decrire"
    ],
    "decrite": [
        "decrit",
        "decrire"
    ],
    "decrites": [
        "decrit",
        "decrire"
    ],
    "decrits": [
        "decrit",
        "decrire"
    ],
    "decrivaient": [
        "decrire"
    ],
    "decrivais": [
        "decrire"
    ],
    "decrivait": [
        "decrire"
    ],
    "decrivant": [
        "decrire"
    ],
    "decrive": [
        "decrire"
    ],
    "decrivent": [
        "decrire"
    ],
    "decrives": [
        "decrire"
    ],
    "decrivez": [
        "decrire"
    ],
    "decriviez": [
        "decrire"
    ],
    "decrivirent": [
        "decrire"
    ],
    "decrivis": [
        "decrire"
    ],
    "decrivit": [
        "decrire"
    ],
    "decriee": [
        "decrier",
        "decrie"
    ],
    "decriees": [
        "decrie"
    ],
    "decrocha": [
        "decrocher"
    ],
    "decrochage": [
        "decrochage"
    ],
    "decrochages": [
        "decrochage"
    ],
    "decrochai": [
        "decrocher"
    ],
    "decrochaient": [
        "decrocher"
    ],
    "decrochais": [
        "decrocher"
    ],
    "decrochait": [
        "decrocher"
    ],
    "decrochant": [
        "decrocher",
        "decrochant"
    ],
    "decroche": [
        "decrocher"
    ],
    "decrochement": [
        "decrochement"
    ],
    "decrochements": [
        "decrochement"
    ],
    "decrochent": [
        "decrocher"
    ],
    "decrocher": [
        "decrocher"
    ],
    "decrochera": [
        "decrocher"
    ],
    "decrocherai": [
        "decrocher"
    ],
    "decrocheraient": [
        "decrocher"
    ],
    "decrocherais": [
        "decrocher"
    ],
    "decrocherait": [
        "decrocher"
    ],
    "decrocheras": [
        "decrocher"
    ],
    "decrocheront": [
        "decrocher"
    ],
    "decrochez": [
        "decrocher"
    ],
    "decrochiez": [
        "decrocher"
    ],
    "decrochons": [
        "decrocher"
    ],
    "decrocherent": [
        "decrocher"
    ],
    "decrochee": [
        "decrocher"
    ],
    "decrochees": [
        "decrocher"
    ],
    "decroches": [
        "decrocher"
    ],
    "decroisa": [
        "decroiser"
    ],
    "decroisait": [
        "decroiser"
    ],
    "decroisant": [
        "decroiser"
    ],
    "decroise": [
        "decroiser"
    ],
    "decroiser": [
        "decroiser"
    ],
    "decroissaient": [
        "decroitre"
    ],
    "decroissait": [
        "decroitre"
    ],
    "decroissance": [
        "decroissance"
    ],
    "decroissant": [
        "decroitre",
        "decroissant"
    ],
    "decroissante": [
        "decroissant"
    ],
    "decroissantes": [
        "decroissant"
    ],
    "decroissants": [
        "decroissant"
    ],
    "decroisse": [
        "decroitre"
    ],
    "decroissent": [
        "decroitre"
    ],
    "decroisees": [
        "decroiser"
    ],
    "decrottages": [
        "decrottage"
    ],
    "decrottait": [
        "decrotter"
    ],
    "decrottant": [
        "decrotter"
    ],
    "decrotte": [
        "decrotter"
    ],
    "decrottent": [
        "decrotter"
    ],
    "decrotter": [
        "decrotter"
    ],
    "decrottions": [
        "decrotter"
    ],
    "decrottoir": [
        "decrottoir"
    ],
    "decrottee": [
        "decrotter"
    ],
    "decrottes": [
        "decrotter"
    ],
    "decroit": [
        "decroit",
        "decroitre"
    ],
    "decroitre": [
        "decroitre"
    ],
    "decru": [
        "decroitre"
    ],
    "decrue": [
        "decrue"
    ],
    "decrut": [
        "decroitre"
    ],
    "decryptage": [
        "decryptage"
    ],
    "decryptai": [
        "decrypter"
    ],
    "decrypte": [
        "decrypter"
    ],
    "decrypter": [
        "decrypter"
    ],
    "decrypteur": [
        "decrypteur"
    ],
    "decrypteurs": [
        "decrypteur"
    ],
    "decryptes": [
        "decrypter"
    ],
    "decrete": [
        "decreter"
    ],
    "decretent": [
        "decreter"
    ],
    "decretes": [
        "decreter"
    ],
    "decredibiliser": [
        "decredibiliser"
    ],
    "decredibilisez": [
        "decredibiliser"
    ],
    "decrepi": [
        "decrepir"
    ],
    "decrepie": [
        "decrepir"
    ],
    "decrepies": [
        "decrepir"
    ],
    "decrepis": [
        "decrepir"
    ],
    "decrepit": [
        "decrepir",
        "decrepit"
    ],
    "decrepite": [
        "decrepit"
    ],
    "decrepites": [
        "decrepit"
    ],
    "decrepits": [
        "decrepit"
    ],
    "decrepitude": [
        "decrepitude"
    ],
    "decreta": [
        "decreter"
    ],
    "decretai": [
        "decreter"
    ],
    "decretaient": [
        "decreter"
    ],
    "decretais": [
        "decreter"
    ],
    "decretait": [
        "decreter"
    ],
    "decretant": [
        "decreter"
    ],
    "decreter": [
        "decreter"
    ],
    "decretera": [
        "decreter"
    ],
    "decreterai": [
        "decreter"
    ],
    "decreterais": [
        "decreter"
    ],
    "decreterait": [
        "decreter"
    ],
    "decreteront": [
        "decreter"
    ],
    "decretez": [
        "decreter"
    ],
    "decretons": [
        "decreter"
    ],
    "decreterent": [
        "decreter"
    ],
    "decretee": [
        "decreter"
    ],
    "decrepage": [
        "decrepage"
    ],
    "decreper": [
        "decreper"
    ],
    "decuite": [
        "decuiter"
    ],
    "deculotta": [
        "deculotter"
    ],
    "deculottait": [
        "deculotter"
    ],
    "deculottant": [
        "deculotter"
    ],
    "deculotte": [
        "deculotter",
        "deculotte"
    ],
    "deculotter": [
        "deculotter"
    ],
    "deculottera": [
        "deculotter"
    ],
    "deculottee": [
        "deculotte",
        "deculottee"
    ],
    "deculottees": [
        "deculotte",
        "deculottee"
    ],
    "deculottes": [
        "deculotte"
    ],
    "deculpabilisait": [
        "deculpabiliser"
    ],
    "deculpabiliser": [
        "deculpabiliser"
    ],
    "deculpabilise": [
        "deculpabiliser"
    ],
    "decupla": [
        "decupler"
    ],
    "decuplaient": [
        "decupler"
    ],
    "decuplait": [
        "decupler"
    ],
    "decuplant": [
        "decupler"
    ],
    "decuple": [
        "decuple",
        "decupler"
    ],
    "decuplent": [
        "decupler"
    ],
    "decupler": [
        "decupler"
    ],
    "decuplera": [
        "decupler"
    ],
    "decuplerait": [
        "decupler"
    ],
    "decuplerent": [
        "decupler"
    ],
    "decuplee": [
        "decuple",
        "decupler"
    ],
    "decuplees": [
        "decupler"
    ],
    "decuples": [
        "decupler"
    ],
    "decuver": [
        "decuver"
    ],
    "decede": [
        "deceder",
        "decede"
    ],
    "decedent": [
        "deceder"
    ],
    "decelera": [
        "deceler"
    ],
    "decelerait": [
        "deceler"
    ],
    "deceleront": [
        "deceler"
    ],
    "deces": [
        "deces"
    ],
    "deceda": [
        "deceder"
    ],
    "decedait": [
        "deceder"
    ],
    "deceder": [
        "deceder"
    ],
    "decedee": [
        "deceder",
        "decede"
    ],
    "decedees": [
        "deceder",
        "decede"
    ],
    "decedes": [
        "deceder",
        "decede"
    ],
    "deceleration": [
        "deceleration"
    ],
    "decelerer": [
        "decelerer"
    ],
    "decelerez": [
        "decelerer"
    ],
    "decerebration": [
        "decerebration"
    ],
    "decerebrer": [
        "decerebrer"
    ],
    "decerebre": [
        "decerebrer"
    ],
    "decerebree": [
        "decerebrer"
    ],
    "decerebres": [
        "decerebrer"
    ],
    "dedaigna": [
        "dedaigner"
    ],
    "dedaignables": [
        "dedaignable"
    ],
    "dedaignaient": [
        "dedaigner"
    ],
    "dedaignais": [
        "dedaigner"
    ],
    "dedaignait": [
        "dedaigner"
    ],
    "dedaignant": [
        "dedaigner"
    ],
    "dedaigne": [
        "dedaigner"
    ],
    "dedaignent": [
        "dedaigner"
    ],
    "dedaigner": [
        "dedaigner"
    ],
    "dedaignes": [
        "dedaigner"
    ],
    "dedaigneuse": [
        "dedaigneux",
        "dedaigneuse"
    ],
    "dedaigneusement": [
        "dedaigneusement"
    ],
    "dedaigneuses": [
        "dedaigneux"
    ],
    "dedaigneux": [
        "dedaigneux"
    ],
    "dedaignez": [
        "dedaigner"
    ],
    "dedaignat": [
        "dedaigner"
    ],
    "dedaignee": [
        "dedaigner"
    ],
    "dedain": [
        "dedain"
    ],
    "dedains": [
        "dedain"
    ],
    "dedale": [
        "dedale"
    ],
    "dedales": [
        "dedale"
    ],
    "dedia": [
        "dedier"
    ],
    "dediaient": [
        "dedier"
    ],
    "dediait": [
        "dedier"
    ],
    "dediant": [
        "dedier"
    ],
    "dedicace": [
        "dedicacer",
        "dedicace"
    ],
    "dedicacer": [
        "dedicacer"
    ],
    "dedicacerai": [
        "dedicacer"
    ],
    "dedicaces": [
        "dedicacer",
        "dedicace"
    ],
    "dedicacez": [
        "dedicacer"
    ],
    "dedicaciez": [
        "dedicacer"
    ],
    "dedicacee": [
        "dedicacer",
        "dedicace"
    ],
    "dedicacees": [
        "dedicacer",
        "dedicace"
    ],
    "dedicatoire": [
        "dedicatoire"
    ],
    "dedicatoires": [
        "dedicatoire"
    ],
    "dedicaca": [
        "dedicacer"
    ],
    "dedicacait": [
        "dedicacer"
    ],
    "dedie": [
        "dedier",
        "dedie"
    ],
    "dedient": [
        "dedier"
    ],
    "dedier": [
        "dedier"
    ],
    "dediera": [
        "dedier"
    ],
    "dedierai": [
        "dedier"
    ],
    "dedierait": [
        "dedier"
    ],
    "dediez": [
        "dedier"
    ],
    "dedions": [
        "dedier"
    ],
    "dedire": [
        "dedire"
    ],
    "dedit": [
        "dedit",
        "dedire"
    ],
    "dedite": [
        "dedire"
    ],
    "dediee": [
        "dedier",
        "dedie"
    ],
    "dediees": [
        "dedier"
    ],
    "dedies": [
        "dedier",
        "dedie"
    ],
    "dedommage": [
        "dedommager"
    ],
    "dedommagea": [
        "dedommager"
    ],
    "dedommageait": [
        "dedommager"
    ],
    "dedommagement": [
        "dedommagement"
    ],
    "dedommagements": [
        "dedommagement"
    ],
    "dedommagent": [
        "dedommager"
    ],
    "dedommager": [
        "dedommager"
    ],
    "dedommagera": [
        "dedommager"
    ],
    "dedommagerai": [
        "dedommager"
    ],
    "dedommagerait": [
        "dedommager"
    ],
    "dedommagerez": [
        "dedommager"
    ],
    "dedommagerons": [
        "dedommager"
    ],
    "dedommagee": [
        "dedommager"
    ],
    "dedommages": [
        "dedommager"
    ],
    "dedorent": [
        "dedorer"
    ],
    "dedore": [
        "dedorer"
    ],
    "dedoree": [
        "dedorer"
    ],
    "dedorees": [
        "dedorer"
    ],
    "dedores": [
        "dedorer"
    ],
    "dedouanait": [
        "dedouaner"
    ],
    "dedouane": [
        "dedouaner"
    ],
    "dedouanement": [
        "dedouanement"
    ],
    "dedouaner": [
        "dedouaner"
    ],
    "dedouanez": [
        "dedouaner"
    ],
    "dedouanee": [
        "dedouaner"
    ],
    "dedouanes": [
        "dedouaner"
    ],
    "dedoubla": [
        "dedoubler"
    ],
    "dedoublaient": [
        "dedoubler"
    ],
    "dedoublais": [
        "dedoubler"
    ],
    "dedoublait": [
        "dedoubler"
    ],
    "dedouble": [
        "dedoubler"
    ],
    "dedoublement": [
        "dedoublement"
    ],
    "dedoubler": [
        "dedoubler"
    ],
    "dedoublerait": [
        "dedoubler"
    ],
    "dedoublez": [
        "dedoubler"
    ],
    "dedoublons": [
        "dedoubler"
    ],
    "dedoublee": [
        "dedoubler"
    ],
    "dedoublees": [
        "dedoubler"
    ],
    "dedoubles": [
        "dedoubler"
    ],
    "dedramatisant": [
        "dedramatiser"
    ],
    "dedramatise": [
        "dedramatiser"
    ],
    "dedramatiser": [
        "dedramatiser"
    ],
    "deducteur": [
        "deducteur"
    ],
    "deductibilite": [
        "deductibilite"
    ],
    "deductible": [
        "deductible"
    ],
    "deductibles": [
        "deductible"
    ],
    "deductif": [
        "deductif"
    ],
    "deduction": [
        "deduction"
    ],
    "deductions": [
        "deduction"
    ],
    "deductive": [
        "deductif"
    ],
    "deduira": [
        "deduire"
    ],
    "deduirai": [
        "deduire"
    ],
    "deduiraient": [
        "deduire"
    ],
    "deduirait": [
        "deduire"
    ],
    "deduire": [
        "deduire"
    ],
    "deduirez": [
        "deduire"
    ],
    "deduis": [
        "deduire"
    ],
    "deduisaient": [
        "deduire"
    ],
    "deduisait": [
        "deduire"
    ],
    "deduisant": [
        "deduire"
    ],
    "deduise": [
        "deduire"
    ],
    "deduisent": [
        "deduire"
    ],
    "deduisez": [
        "deduire"
    ],
    "deduisiez": [
        "deduire"
    ],
    "deduisit": [
        "deduire"
    ],
    "deduisons": [
        "deduire"
    ],
    "deduit": [
        "deduire",
        "deduit"
    ],
    "deduite": [
        "deduire"
    ],
    "deduites": [
        "deduire"
    ],
    "deduits": [
        "deduire"
    ],
    "deesse": [
        "deesse"
    ],
    "deesses": [
        "deesse"
    ],
    "defaillais": [
        "defaillir"
    ],
    "defaillait": [
        "defaillir"
    ],
    "defaillance": [
        "defaillance"
    ],
    "defaillances": [
        "defaillance"
    ],
    "defaillant": [
        "defaillir",
        "defaillant"
    ],
    "defaillante": [
        "defaillant"
    ],
    "defaillantes": [
        "defaillant"
    ],
    "defaillants": [
        "defaillant"
    ],
    "defaille": [
        "defaillir"
    ],
    "defaillent": [
        "defaillir"
    ],
    "defailli": [
        "defaillir"
    ],
    "defaillir": [
        "defaillir"
    ],
    "defaillirait": [
        "defaillir"
    ],
    "defaillis": [
        "defaillir"
    ],
    "defaillit": [
        "defaillir"
    ],
    "defaire": [
        "defaire"
    ],
    "defais": [
        "defaire"
    ],
    "defaisaient": [
        "defaire"
    ],
    "defaisais": [
        "defaire"
    ],
    "defaisait": [
        "defaire"
    ],
    "defaisant": [
        "defaire"
    ],
    "defaisons": [
        "defaire"
    ],
    "defait": [
        "defaire",
        "defait"
    ],
    "defaite": [
        "defaire",
        "defaite",
        "defait"
    ],
    "defaites": [
        "defaire",
        "defaite",
        "defait"
    ],
    "defaitisme": [
        "defaitisme"
    ],
    "defaitiste": [
        "defaitiste"
    ],
    "defaitistes": [
        "defaitiste"
    ],
    "defaits": [
        "defaire",
        "defait"
    ],
    "defalque": [
        "defalquer"
    ],
    "defalquer": [
        "defalquer"
    ],
    "defalquees": [
        "defalquer"
    ],
    "defarguaient": [
        "defarguer"
    ],
    "defargue": [
        "defarguer"
    ],
    "defarguer": [
        "defarguer"
    ],
    "defasse": [
        "defaire"
    ],
    "defausse": [
        "defausser"
    ],
    "defausser": [
        "defausser"
    ],
    "defaut": [
        "defaut"
    ],
    "defauts": [
        "defaut"
    ],
    "defaveur": [
        "defaveur"
    ],
    "defavorable": [
        "defavorable"
    ],
    "defavorablement": [
        "defavorablement"
    ],
    "defavorables": [
        "defavorable"
    ],
    "defavorisait": [
        "defavoriser"
    ],
    "defavorisent": [
        "defavoriser"
    ],
    "defavorise": [
        "defavoriser",
        "defavorise"
    ],
    "defavorisee": [
        "defavoriser",
        "defavorise"
    ],
    "defavorisees": [
        "defavoriser",
        "defavorise"
    ],
    "defavorises": [
        "defavoriser",
        "defavorise"
    ],
    "defectible": [
        "defectible"
    ],
    "defectif": [
        "defectif"
    ],
    "defection": [
        "defection"
    ],
    "defectionnaires": [
        "defectionnaire"
    ],
    "defections": [
        "defection"
    ],
    "defectueuse": [
        "defectueux"
    ],
    "defectueusement": [
        "defectueusement"
    ],
    "defectueuses": [
        "defectueux"
    ],
    "defectueux": [
        "defectueux"
    ],
    "defectuosite": [
        "defectuosite"
    ],
    "defend": [
        "defendre"
    ],
    "defendable": [
        "defendable"
    ],
    "defendaient": [
        "defendre"
    ],
    "defendais": [
        "defendre"
    ],
    "defendait": [
        "defendre"
    ],
    "defendant": [
        "defendre"
    ],
    "defende": [
        "defendre"
    ],
    "defendent": [
        "defendre"
    ],
    "defenderesse": [
        "defendeur"
    ],
    "defendes": [
        "defendre"
    ],
    "defendeur": [
        "defendeur"
    ],
    "defendeurs": [
        "defendeur"
    ],
    "defendez": [
        "defendre"
    ],
    "defendiez": [
        "defendre"
    ],
    "defendions": [
        "defendre"
    ],
    "defendirent": [
        "defendre"
    ],
    "defendis": [
        "defendre"
    ],
    "defendit": [
        "defendre"
    ],
    "defendons": [
        "defendre"
    ],
    "defendra": [
        "defendre"
    ],
    "defendrai": [
        "defendre"
    ],
    "defendraient": [
        "defendre"
    ],
    "defendrais": [
        "defendre"
    ],
    "defendrait": [
        "defendre"
    ],
    "defendras": [
        "defendre"
    ],
    "defendre": [
        "defendre"
    ],
    "defendrez": [
        "defendre"
    ],
    "defendriez": [
        "defendre"
    ],
    "defendrons": [
        "defendre"
    ],
    "defendront": [
        "defendre"
    ],
    "defends": [
        "defend",
        "defends",
        "defendre"
    ],
    "defendu": [
        "defendu",
        "defendre"
    ],
    "defendue": [
        "defendu",
        "defendre"
    ],
    "defendues": [
        "defendu",
        "defendre"
    ],
    "defendus": [
        "defendu",
        "defendre"
    ],
    "defenestraient": [
        "defenestrer"
    ],
    "defenestrant": [
        "defenestrer"
    ],
    "defenestration": [
        "defenestration"
    ],
    "defenestrer": [
        "defenestrer"
    ],
    "defenestrerai": [
        "defenestrer"
    ],
    "defenestre": [
        "defenestrer"
    ],
    "defenestree": [
        "defenestrer"
    ],
    "defens": [
        "defens"
    ],
    "defense": [
        "defense"
    ],
    "defenses": [
        "defense"
    ],
    "defenseur": [
        "defenseur"
    ],
    "defenseurs": [
        "defenseur"
    ],
    "defensif": [
        "defensif"
    ],
    "defensifs": [
        "defensif"
    ],
    "defensive": [
        "defensif",
        "defensive"
    ],
    "defensives": [
        "defensif",
        "defensive"
    ],
    "defera": [
        "defaire",
        "deferer"
    ],
    "deferai": [
        "defaire"
    ],
    "deferaient": [
        "defaire"
    ],
    "deferais": [
        "defaire"
    ],
    "deferait": [
        "defaire",
        "deferer"
    ],
    "deferas": [
        "defaire"
    ],
    "deferez": [
        "defaire"
    ],
    "deferla": [
        "deferler"
    ],
    "deferlaient": [
        "deferler"
    ],
    "deferlait": [
        "deferler"
    ],
    "deferlant": [
        "deferlant",
        "deferler"
    ],
    "deferlante": [
        "deferlante",
        "deferlant"
    ],
    "deferlantes": [
        "deferlante",
        "deferlant"
    ],
    "deferle": [
        "deferler"
    ],
    "deferlement": [
        "deferlement"
    ],
    "deferlements": [
        "deferlement"
    ],
    "deferlent": [
        "deferler"
    ],
    "deferler": [
        "deferler"
    ],
    "deferleraient": [
        "deferler"
    ],
    "deferlerait": [
        "deferler"
    ],
    "deferleront": [
        "deferler"
    ],
    "deferlez": [
        "deferler"
    ],
    "deferlat": [
        "deferler"
    ],
    "deferlerent": [
        "deferler"
    ],
    "deferlees": [
        "deferler"
    ],
    "deferons": [
        "defaire"
    ],
    "deferont": [
        "defaire"
    ],
    "deferrer": [
        "deferrer"
    ],
    "deferre": [
        "deferrer",
        "deferre"
    ],
    "defeuillees": [
        "defeuiller"
    ],
    "defi": [
        "defi"
    ],
    "defia": [
        "defier"
    ],
    "defiaient": [
        "defier"
    ],
    "defiais": [
        "defier"
    ],
    "defiait": [
        "defier"
    ],
    "defiance": [
        "defiance"
    ],
    "defiances": [
        "defiance"
    ],
    "defiant": [
        "defier",
        "defiant"
    ],
    "defiante": [
        "defiant"
    ],
    "defibreur": [
        "defibreur"
    ],
    "defibrillateur": [
        "defibrillateur"
    ],
    "defibrillateurs": [
        "defibrillateur"
    ],
    "defibrillation": [
        "defibrillation"
    ],
    "deficeler": [
        "deficeler"
    ],
    "deficelle": [
        "deficeler"
    ],
    "deficelerent": [
        "deficeler"
    ],
    "deficience": [
        "deficience"
    ],
    "deficiences": [
        "deficience"
    ],
    "deficient": [
        "deficient"
    ],
    "deficiente": [
        "deficient"
    ],
    "deficientes": [
        "deficient"
    ],
    "deficients": [
        "deficient"
    ],
    "deficit": [
        "deficit"
    ],
    "deficitaire": [
        "deficitaire"
    ],
    "deficitaires": [
        "deficitaire"
    ],
    "deficits": [
        "deficit"
    ],
    "defie": [
        "defier"
    ],
    "defient": [
        "defier"
    ],
    "defier": [
        "defier"
    ],
    "defiera": [
        "defier"
    ],
    "defierai": [
        "defier"
    ],
    "defierais": [
        "defier"
    ],
    "defierait": [
        "defier"
    ],
    "defieriez": [
        "defier"
    ],
    "defierons": [
        "defier"
    ],
    "defiez": [
        "defier"
    ],
    "defigeait": [
        "defiger"
    ],
    "defiger": [
        "defiger"
    ],
    "defigura": [
        "defigurer"
    ],
    "defiguraient": [
        "defigurer"
    ],
    "defigurais": [
        "defigurer"
    ],
    "defigurait": [
        "defigurer"
    ],
    "defigurant": [
        "defigurer"
    ],
    "defiguration": [
        "defiguration"
    ],
    "defigurations": [
        "defiguration"
    ],
    "defigure": [
        "defigurer",
        "defigure"
    ],
    "defigurement": [
        "defigurement"
    ],
    "defigurent": [
        "defigurer"
    ],
    "defigurer": [
        "defigurer"
    ],
    "defigurerait": [
        "defigurer"
    ],
    "defiguree": [
        "defigurer",
        "defigure"
    ],
    "defigurees": [
        "defigurer",
        "defigure"
    ],
    "defigures": [
        "defigurer",
        "defigure"
    ],
    "defila": [
        "defiler"
    ],
    "defilaient": [
        "defiler"
    ],
    "defilais": [
        "defiler"
    ],
    "defilait": [
        "defiler"
    ],
    "defilant": [
        "defiler"
    ],
    "defilantes": [
        "defilant"
    ],
    "defilants": [
        "defilant"
    ],
    "defile": [
        "defile",
        "defiler"
    ],
    "defilement": [
        "defilement"
    ],
    "defilements": [
        "defilement"
    ],
    "defilent": [
        "defiler"
    ],
    "defiler": [
        "defiler"
    ],
    "defilera": [
        "defiler"
    ],
    "defileraient": [
        "defiler"
    ],
    "defilerait": [
        "defiler"
    ],
    "defileras": [
        "defiler"
    ],
    "defilerez": [
        "defiler"
    ],
    "defilerons": [
        "defiler"
    ],
    "defileront": [
        "defiler"
    ],
    "defilez": [
        "defiler"
    ],
    "defiliez": [
        "defiler"
    ],
    "defilions": [
        "defiler"
    ],
    "defilons": [
        "defiler"
    ],
    "defilerent": [
        "defiler"
    ],
    "defilee": [
        "defiler"
    ],
    "defiles": [
        "defile",
        "defiler"
    ],
    "defini": [
        "defini",
        "definir"
    ],
    "definie": [
        "defini",
        "definir"
    ],
    "definies": [
        "defini",
        "definir"
    ],
    "definir": [
        "definir"
    ],
    "definira": [
        "definir"
    ],
    "definirais": [
        "definir"
    ],
    "definirait": [
        "definir"
    ],
    "definiriez": [
        "definir"
    ],
    "definis": [
        "defini",
        "definir"
    ],
    "definissable": [
        "definissable"
    ],
    "definissables": [
        "definissable"
    ],
    "definissaient": [
        "definir"
    ],
    "definissait": [
        "definir"
    ],
    "definissant": [
        "definir"
    ],
    "definisse": [
        "definir"
    ],
    "definissent": [
        "definir"
    ],
    "definissez": [
        "definir"
    ],
    "definissons": [
        "definir"
    ],
    "definit": [
        "definir"
    ],
    "definitif": [
        "definitif"
    ],
    "definitifs": [
        "definitif"
    ],
    "definition": [
        "definition"
    ],
    "definitions": [
        "definition"
    ],
    "definitive": [
        "definitif"
    ],
    "definitivement": [
        "definitivement"
    ],
    "definitives": [
        "definitif",
        "definitive"
    ],
    "defions": [
        "defier"
    ],
    "defirent": [
        "defaire"
    ],
    "defis": [
        "defaire",
        "defi"
    ],
    "defiscalisations": [
        "defiscalisation"
    ],
    "defiscalise": [
        "defiscaliser"
    ],
    "defit": [
        "defaire"
    ],
    "defierent": [
        "defier"
    ],
    "defiee": [
        "defier"
    ],
    "defies": [
        "defier",
        "defy"
    ],
    "deflagrante": [
        "deflagrant"
    ],
    "deflagration": [
        "deflagration"
    ],
    "deflagrations": [
        "deflagration"
    ],
    "deflationniste": [
        "deflationniste"
    ],
    "deflationnistes": [
        "deflationniste"
    ],
    "deflecteur": [
        "deflecteur"
    ],
    "deflecteurs": [
        "deflecteur"
    ],
    "defleuri": [
        "defleurir"
    ],
    "defleuries": [
        "defleurir"
    ],
    "defleuris": [
        "defleurir"
    ],
    "deflexion": [
        "deflexion"
    ],
    "defloraison": [
        "defloraison"
    ],
    "deflorait": [
        "deflorer"
    ],
    "defloration": [
        "defloration"
    ],
    "deflorer": [
        "deflorer"
    ],
    "deflorerons": [
        "deflorer"
    ],
    "deflore": [
        "deflorer"
    ],
    "defloree": [
        "deflorer"
    ],
    "deflores": [
        "deflorer"
    ],
    "defoliant": [
        "defoliant"
    ],
    "defonce": [
        "defoncer",
        "defonce"
    ],
    "defoncement": [
        "defoncement"
    ],
    "defoncements": [
        "defoncement"
    ],
    "defoncent": [
        "defoncer"
    ],
    "defoncer": [
        "defoncer"
    ],
    "defoncera": [
        "defoncer"
    ],
    "defoncerai": [
        "defoncer"
    ],
    "defonceraient": [
        "defoncer"
    ],
    "defoncerait": [
        "defoncer"
    ],
    "defonceront": [
        "defoncer"
    ],
    "defonceuse": [
        "defonceuse"
    ],
    "defoncez": [
        "defoncer"
    ],
    "defoncee": [
        "defoncer",
        "defonce"
    ],
    "defoncees": [
        "defoncer",
        "defonce"
    ],
    "defonces": [
        "defoncer",
        "defonce"
    ],
    "defont": [
        "defaire"
    ],
    "defonca": [
        "defoncer"
    ],
    "defoncai": [
        "defoncer"
    ],
    "defoncaient": [
        "defoncer"
    ],
    "defoncais": [
        "defoncer"
    ],
    "defoncait": [
        "defoncer"
    ],
    "defoncant": [
        "defoncer"
    ],
    "defoncons": [
        "defoncer"
    ],
    "deforestation": [
        "deforestation"
    ],
    "deforma": [
        "deformer"
    ],
    "deformaient": [
        "deformer"
    ],
    "deformait": [
        "deformer"
    ],
    "deformant": [
        "deformer",
        "deformant"
    ],
    "deformante": [
        "deformant"
    ],
    "deformantes": [
        "deformant"
    ],
    "deformants": [
        "deformant"
    ],
    "deformation": [
        "deformation"
    ],
    "deformations": [
        "deformation"
    ],
    "deforme": [
        "deforme",
        "deformer"
    ],
    "deforment": [
        "deformer"
    ],
    "deformer": [
        "deformer"
    ],
    "deformera": [
        "deformer"
    ],
    "deformerai": [
        "deformer"
    ],
    "deformerait": [
        "deformer"
    ],
    "deformeront": [
        "deformer"
    ],
    "deformes": [
        "deforme",
        "deformer"
    ],
    "deformez": [
        "deformer"
    ],
    "deformee": [
        "deforme",
        "deformer"
    ],
    "deformees": [
        "deforme",
        "deformer"
    ],
    "defoulaient": [
        "defouler"
    ],
    "defoulais": [
        "defouler"
    ],
    "defoulait": [
        "defouler"
    ],
    "defoule": [
        "defouler"
    ],
    "defoulement": [
        "defoulement"
    ],
    "defoulent": [
        "defouler"
    ],
    "defouler": [
        "defouler"
    ],
    "defoulera": [
        "defouler"
    ],
    "defoulerait": [
        "defouler"
    ],
    "defoules": [
        "defouler"
    ],
    "defouliez": [
        "defouler"
    ],
    "defouloir": [
        "defouloir"
    ],
    "defoulons": [
        "defouler"
    ],
    "defouraillaient": [
        "defourailler"
    ],
    "defouraille": [
        "defourailler"
    ],
    "defouraillent": [
        "defourailler"
    ],
    "defourailler": [
        "defourailler"
    ],
    "defouraillerait": [
        "defourailler"
    ],
    "defourna": [
        "defourner"
    ],
    "defournait": [
        "defourner"
    ],
    "defragmenteur": [
        "defragmenteur"
    ],
    "defraiement": [
        "defraiement"
    ],
    "defraiements": [
        "defraiement"
    ],
    "defraya": [
        "defrayer"
    ],
    "defrayaient": [
        "defrayer"
    ],
    "defrayait": [
        "defrayer"
    ],
    "defrayant": [
        "defrayer"
    ],
    "defrayent": [
        "defrayer"
    ],
    "defrayer": [
        "defrayer"
    ],
    "defrayerent": [
        "defrayer"
    ],
    "defraye": [
        "defrayer"
    ],
    "defraichi": [
        "defraichir",
        "defraichi"
    ],
    "defraichie": [
        "defraichir",
        "defraichi"
    ],
    "defraichies": [
        "defraichir",
        "defraichi"
    ],
    "defraichir": [
        "defraichir"
    ],
    "defraichis": [
        "defraichir",
        "defraichi"
    ],
    "defraichissait": [
        "defraichir"
    ],
    "defricha": [
        "defricher"
    ],
    "defrichage": [
        "defrichage"
    ],
    "defrichait": [
        "defricher"
    ],
    "defriche": [
        "defricher"
    ],
    "defrichement": [
        "defrichement"
    ],
    "defrichements": [
        "defrichement"
    ],
    "defricher": [
        "defricher"
    ],
    "defricheurs": [
        "defricheur"
    ],
    "defrichee": [
        "defricher"
    ],
    "defrichees": [
        "defricher"
    ],
    "defriches": [
        "defricher"
    ],
    "defringue": [
        "defringuer"
    ],
    "defringues": [
        "defringuer"
    ],
    "defripe": [
        "defriper"
    ],
    "defripera": [
        "defriper"
    ],
    "defripees": [
        "defriper"
    ],
    "defrisage": [
        "defrisage"
    ],
    "defrisaient": [
        "defriser"
    ],
    "defrisait": [
        "defriser"
    ],
    "defrise": [
        "defriser"
    ],
    "defriser": [
        "defriser"
    ],
    "defriserait": [
        "defriser"
    ],
    "defrises": [
        "defriser"
    ],
    "defroissa": [
        "defroisser"
    ],
    "defroissai": [
        "defroisser"
    ],
    "defroissaient": [
        "defroisser"
    ],
    "defroissait": [
        "defroisser"
    ],
    "defroissant": [
        "defroisser"
    ],
    "defroisse": [
        "defroisser"
    ],
    "defroissent": [
        "defroisser"
    ],
    "defroisser": [
        "defroisser"
    ],
    "defroissees": [
        "defroisser"
    ],
    "defroisses": [
        "defroisser"
    ],
    "defroqua": [
        "defroquer"
    ],
    "defroque": [
        "defroquer",
        "defroque"
    ],
    "defroquer": [
        "defroquer"
    ],
    "defroques": [
        "defroquer",
        "defroque"
    ],
    "defroquee": [
        "defroquer",
        "defroque"
    ],
    "defunt": [
        "defunt"
    ],
    "defunte": [
        "defunter",
        "defunt"
    ],
    "defunter": [
        "defunter"
    ],
    "defuntes": [
        "defunt"
    ],
    "defunts": [
        "defunt"
    ],
    "defeque": [
        "defequer"
    ],
    "defecation": [
        "defecation"
    ],
    "defecations": [
        "defecation"
    ],
    "defecatoire": [
        "defecatoire"
    ],
    "defeminiser": [
        "defeminiser"
    ],
    "defequaient": [
        "defequer"
    ],
    "defequant": [
        "defequer"
    ],
    "defequassent": [
        "defequer"
    ],
    "defequer": [
        "defequer"
    ],
    "deferant": [
        "deferer"
    ],
    "deference": [
        "deference"
    ],
    "deferent": [
        "deferent"
    ],
    "deferente": [
        "deferent"
    ],
    "deferentes": [
        "deferent"
    ],
    "deferents": [
        "deferent"
    ],
    "deferer": [
        "deferer"
    ],
    "defererait": [
        "deferer"
    ],
    "defere": [
        "deferer"
    ],
    "deferes": [
        "deferer"
    ],
    "degage": [
        "degager",
        "degage"
    ],
    "degagea": [
        "degager"
    ],
    "degageai": [
        "degager"
    ],
    "degageaient": [
        "degager"
    ],
    "degageait": [
        "degager"
    ],
    "degageant": [
        "degager"
    ],
    "degagement": [
        "degagement"
    ],
    "degagements": [
        "degagement"
    ],
    "degagent": [
        "degager"
    ],
    "degageons": [
        "degager"
    ],
    "degager": [
        "degager"
    ],
    "degagera": [
        "degager"
    ],
    "degageraient": [
        "degager"
    ],
    "degagerais": [
        "degager"
    ],
    "degagerait": [
        "degager"
    ],
    "degageront": [
        "degager"
    ],
    "degages": [
        "degager",
        "degage"
    ],
    "degagez": [
        "degager"
    ],
    "degageat": [
        "degager"
    ],
    "degagerent": [
        "degager"
    ],
    "degagee": [
        "degager",
        "degage"
    ],
    "degagees": [
        "degager",
        "degage"
    ],
    "degaina": [
        "degainer"
    ],
    "degainais": [
        "degainer"
    ],
    "degainait": [
        "degainer"
    ],
    "degainant": [
        "degainer"
    ],
    "degaine": [
        "degaine",
        "degainer"
    ],
    "degainent": [
        "degainer"
    ],
    "degainer": [
        "degainer"
    ],
    "degainerai": [
        "degainer"
    ],
    "degainerez": [
        "degainer"
    ],
    "degaines": [
        "degaine",
        "degainer"
    ],
    "degainez": [
        "degainer"
    ],
    "degainerent": [
        "degainer"
    ],
    "deganta": [
        "deganter"
    ],
    "degantant": [
        "deganter"
    ],
    "degante": [
        "deganter"
    ],
    "degantee": [
        "deganter"
    ],
    "degantees": [
        "deganter"
    ],
    "degarni": [
        "degarni",
        "degarnir"
    ],
    "degarnie": [
        "degarni",
        "degarnir"
    ],
    "degarnies": [
        "degarni",
        "degarnir"
    ],
    "degarnir": [
        "degarnir"
    ],
    "degarnis": [
        "degarnir"
    ],
    "degarnissait": [
        "degarnir"
    ],
    "degarnissant": [
        "degarnir"
    ],
    "degauchi": [
        "degauchir"
    ],
    "degauchie": [
        "degauchir"
    ],
    "degauchir": [
        "degauchir"
    ],
    "degauchira": [
        "degauchir"
    ],
    "degauchis": [
        "degauchir"
    ],
    "degauchisse": [
        "degauchir"
    ],
    "degauchisseuse": [
        "degauchisseuse"
    ],
    "degazage": [
        "degazage"
    ],
    "degazent": [
        "degazer"
    ],
    "degazer": [
        "degazer"
    ],
    "degel": [
        "degel"
    ],
    "degela": [
        "degeler"
    ],
    "degelai": [
        "degeler"
    ],
    "degelait": [
        "degeler"
    ],
    "degelant": [
        "degeler"
    ],
    "degeler": [
        "degeler"
    ],
    "degelez": [
        "degeler"
    ],
    "degelat": [
        "degeler"
    ],
    "degele": [
        "degeler"
    ],
    "degelee": [
        "degelee",
        "degeler"
    ],
    "degelees": [
        "degelee",
        "degeler"
    ],
    "degeles": [
        "degeler"
    ],
    "degermait": [
        "degermer"
    ],
    "degingande": [
        "degingander",
        "degingande"
    ],
    "degingandee": [
        "degingander",
        "degingande"
    ],
    "degingandees": [
        "degingande"
    ],
    "degingandes": [
        "degingande"
    ],
    "degivrage": [
        "degivrage"
    ],
    "degivrer": [
        "degivrer"
    ],
    "degivre": [
        "degivrer"
    ],
    "deglacer": [
        "deglacer"
    ],
    "deglacera": [
        "deglacer"
    ],
    "deglacez": [
        "deglacer"
    ],
    "deglace": [
        "deglacer"
    ],
    "deglingua": [
        "deglinguer"
    ],
    "deglinguaient": [
        "deglinguer"
    ],
    "deglinguait": [
        "deglinguer"
    ],
    "deglinguant": [
        "deglinguer"
    ],
    "deglingue": [
        "deglingue",
        "deglinguer"
    ],
    "deglinguent": [
        "deglinguer"
    ],
    "deglinguer": [
        "deglinguer"
    ],
    "deglinguions": [
        "deglinguer"
    ],
    "deglinguee": [
        "deglingue",
        "deglinguer"
    ],
    "deglinguees": [
        "deglingue",
        "deglinguer"
    ],
    "deglingues": [
        "deglingue",
        "deglinguer"
    ],
    "degluti": [
        "deglutir"
    ],
    "deglutie": [
        "deglutir"
    ],
    "degluties": [
        "deglutir"
    ],
    "deglutir": [
        "deglutir"
    ],
    "deglutis": [
        "deglutir"
    ],
    "deglutissait": [
        "deglutir"
    ],
    "deglutissant": [
        "deglutir"
    ],
    "deglutit": [
        "deglutir"
    ],
    "deglutition": [
        "deglutition"
    ],
    "deglutitions": [
        "deglutition"
    ],
    "degobilla": [
        "degobiller"
    ],
    "degobillage": [
        "degobillage"
    ],
    "degobillaient": [
        "degobiller"
    ],
    "degobillait": [
        "degobiller"
    ],
    "degobillant": [
        "degobiller"
    ],
    "degobille": [
        "degobiller"
    ],
    "degobiller": [
        "degobiller"
    ],
    "degoisais": [
        "degoiser"
    ],
    "degoisait": [
        "degoiser"
    ],
    "degoisant": [
        "degoiser"
    ],
    "degoise": [
        "degoiser"
    ],
    "degoisent": [
        "degoiser"
    ],
    "degoiser": [
        "degoiser"
    ],
    "degoiserai": [
        "degoiser"
    ],
    "degoises": [
        "degoiser"
    ],
    "degommage": [
        "degommage"
    ],
    "degommait": [
        "degommer"
    ],
    "degommant": [
        "degommer"
    ],
    "degomme": [
        "degommer"
    ],
    "degomment": [
        "degommer"
    ],
    "degommer": [
        "degommer"
    ],
    "degommera": [
        "degommer"
    ],
    "degommerai": [
        "degommer"
    ],
    "degommez": [
        "degommer"
    ],
    "degommons": [
        "degommer"
    ],
    "degommee": [
        "degommer"
    ],
    "degommees": [
        "degommer"
    ],
    "degommes": [
        "degommer"
    ],
    "degonfla": [
        "degonfler"
    ],
    "degonflage": [
        "degonflage"
    ],
    "degonflaient": [
        "degonfler"
    ],
    "degonflais": [
        "degonfler"
    ],
    "degonflait": [
        "degonfler"
    ],
    "degonflant": [
        "degonfler"
    ],
    "degonflard": [
        "degonflard"
    ],
    "degonfle": [
        "degonfler",
        "degonfle"
    ],
    "degonflement": [
        "degonflement"
    ],
    "degonflent": [
        "degonfler"
    ],
    "degonfler": [
        "degonfler"
    ],
    "degonflera": [
        "degonfler"
    ],
    "degonfleraient": [
        "degonfler"
    ],
    "degonflerais": [
        "degonfler"
    ],
    "degonflerait": [
        "degonfler"
    ],
    "degonfleriez": [
        "degonfler"
    ],
    "degonfles": [
        "degonfler",
        "degonfle"
    ],
    "degonflez": [
        "degonfler"
    ],
    "degonflee": [
        "degonfler",
        "degonfle"
    ],
    "degonflees": [
        "degonfler",
        "degonfle"
    ],
    "degorge": [
        "degorger"
    ],
    "degorgeaient": [
        "degorger"
    ],
    "degorgeais": [
        "degorger"
    ],
    "degorgeait": [
        "degorger"
    ],
    "degorgeant": [
        "degorger"
    ],
    "degorgement": [
        "degorgement"
    ],
    "degorgent": [
        "degorger"
    ],
    "degorger": [
        "degorger"
    ],
    "degorgeront": [
        "degorger"
    ],
    "degorgee": [
        "degorger"
    ],
    "degorgees": [
        "degorger"
    ],
    "degorges": [
        "degorger"
    ],
    "degota": [
        "degoter"
    ],
    "degotait": [
        "degoter"
    ],
    "degote": [
        "degoter"
    ],
    "degoter": [
        "degoter"
    ],
    "degoterais": [
        "degoter"
    ],
    "degoteras": [
        "degoter"
    ],
    "degotez": [
        "degoter"
    ],
    "degotte": [
        "degotter"
    ],
    "degotter": [
        "degotter"
    ],
    "degottera": [
        "degotter"
    ],
    "degotterai": [
        "degotter"
    ],
    "degotterait": [
        "degotter"
    ],
    "degottes": [
        "degotter"
    ],
    "degotee": [
        "degoter"
    ],
    "degotees": [
        "degoter"
    ],
    "degotes": [
        "degoter"
    ],
    "degoulina": [
        "degouliner"
    ],
    "degoulinade": [
        "degoulinade"
    ],
    "degoulinades": [
        "degoulinade"
    ],
    "degoulinaient": [
        "degouliner"
    ],
    "degoulinais": [
        "degouliner"
    ],
    "degoulinait": [
        "degouliner"
    ],
    "degoulinant": [
        "degouliner",
        "degoulinant"
    ],
    "degoulinante": [
        "degoulinant"
    ],
    "degoulinantes": [
        "degoulinant"
    ],
    "degoulinants": [
        "degoulinant"
    ],
    "degouline": [
        "degouliner"
    ],
    "degoulinement": [
        "degoulinement"
    ],
    "degoulinements": [
        "degoulinement"
    ],
    "degoulinent": [
        "degouliner"
    ],
    "degouliner": [
        "degouliner"
    ],
    "degoulines": [
        "degouliner"
    ],
    "degoulinez": [
        "degouliner"
    ],
    "degoulinures": [
        "degoulinure"
    ],
    "degoulinerent": [
        "degouliner"
    ],
    "degoupille": [
        "degoupiller"
    ],
    "degoupiller": [
        "degoupiller"
    ],
    "degoupillames": [
        "degoupiller"
    ],
    "degoupillee": [
        "degoupiller"
    ],
    "degoupillees": [
        "degoupiller"
    ],
    "degourdi": [
        "degourdi",
        "degourdir"
    ],
    "degourdie": [
        "degourdi",
        "degourdir"
    ],
    "degourdies": [
        "degourdi"
    ],
    "degourdir": [
        "degourdir"
    ],
    "degourdira": [
        "degourdir"
    ],
    "degourdiraient": [
        "degourdir"
    ],
    "degourdis": [
        "degourdi",
        "degourdir"
    ],
    "degourdissais": [
        "degourdir"
    ],
    "degourdissait": [
        "degourdir"
    ],
    "degourdissant": [
        "degourdir"
    ],
    "degourdisse": [
        "degourdir"
    ],
    "degourdissions": [
        "degourdir"
    ],
    "degourdit": [
        "degourdir"
    ],
    "degouttaient": [
        "degoutter"
    ],
    "degouttait": [
        "degoutter"
    ],
    "degouttant": [
        "degouttant",
        "degoutter"
    ],
    "degouttante": [
        "degouttant"
    ],
    "degouttantes": [
        "degouttant"
    ],
    "degouttants": [
        "degouttant"
    ],
    "degoutte": [
        "degoutter"
    ],
    "degoutter": [
        "degoutter"
    ],
    "degout": [
        "degout"
    ],
    "degouta": [
        "degouter"
    ],
    "degoutai": [
        "degouter"
    ],
    "degoutaient": [
        "degouter"
    ],
    "degoutais": [
        "degouter"
    ],
    "degoutait": [
        "degouter"
    ],
    "degoutant": [
        "degouter",
        "degoutant"
    ],
    "degoutante": [
        "degoutant"
    ],
    "degoutantes": [
        "degoutant"
    ],
    "degoutants": [
        "degoutant"
    ],
    "degoutation": [
        "degoutation"
    ],
    "degoutations": [
        "degoutation"
    ],
    "degoute": [
        "degouter",
        "degoute"
    ],
    "degoutent": [
        "degouter"
    ],
    "degouter": [
        "degouter"
    ],
    "degoutera": [
        "degouter"
    ],
    "degouteraient": [
        "degouter"
    ],
    "degouterais": [
        "degouter"
    ],
    "degouterait": [
        "degouter"
    ],
    "degoutes": [
        "degouter",
        "degoute"
    ],
    "degoutez": [
        "degouter"
    ],
    "degouts": [
        "degout"
    ],
    "degoutat": [
        "degouter"
    ],
    "degouterent": [
        "degouter"
    ],
    "degoutee": [
        "degouter",
        "degoute"
    ],
    "degoutees": [
        "degoute"
    ],
    "degrada": [
        "degrader"
    ],
    "degradable": [
        "degradable"
    ],
    "degradaient": [
        "degrader"
    ],
    "degradait": [
        "degrader"
    ],
    "degradant": [
        "degradant",
        "degrader"
    ],
    "degradante": [
        "degradant"
    ],
    "degradantes": [
        "degradant"
    ],
    "degradants": [
        "degradant"
    ],
    "degradation": [
        "degradation"
    ],
    "degradations": [
        "degradation"
    ],
    "degrade": [
        "degrade",
        "degrader"
    ],
    "degradent": [
        "degrader"
    ],
    "degrader": [
        "degrader"
    ],
    "degrades": [
        "degrade",
        "degrader"
    ],
    "degradez": [
        "degrader"
    ],
    "degradee": [
        "degrade",
        "degrader"
    ],
    "degradees": [
        "degrade",
        "degrader"
    ],
    "degrafa": [
        "degrafer"
    ],
    "degrafaient": [
        "degrafer"
    ],
    "degrafait": [
        "degrafer"
    ],
    "degrafant": [
        "degrafer"
    ],
    "degrafe": [
        "degrafer"
    ],
    "degrafer": [
        "degrafer"
    ],
    "degrafera": [
        "degrafer"
    ],
    "degraferait": [
        "degrafer"
    ],
    "degrafeur": [
        "degrafeur"
    ],
    "degrafez": [
        "degrafer"
    ],
    "degrafat": [
        "degrafer"
    ],
    "degrafee": [
        "degrafer"
    ],
    "degrafees": [
        "degrafer"
    ],
    "degrafes": [
        "degrafer"
    ],
    "degraissage": [
        "degraissage"
    ],
    "degraissant": [
        "degraisser",
        "degraissant"
    ],
    "degraissante": [
        "degraissant"
    ],
    "degraisse": [
        "degraisser"
    ],
    "degraissent": [
        "degraisser"
    ],
    "degraisser": [
        "degraisser"
    ],
    "degraissez": [
        "degraisser"
    ],
    "degraisses": [
        "degraisser"
    ],
    "degressifs": [
        "degressif"
    ],
    "degriffe": [
        "degriffe",
        "degriffer"
    ],
    "degriffer": [
        "degriffer"
    ],
    "degriffeur": [
        "degriffeur"
    ],
    "degriffes": [
        "degriffe"
    ],
    "degringola": [
        "degringoler"
    ],
    "degringolade": [
        "degringolade"
    ],
    "degringolades": [
        "degringolade"
    ],
    "degringolai": [
        "degringoler"
    ],
    "degringolaient": [
        "degringoler"
    ],
    "degringolait": [
        "degringoler"
    ],
    "degringolant": [
        "degringoler"
    ],
    "degringole": [
        "degringoler"
    ],
    "degringolent": [
        "degringoler"
    ],
    "degringoler": [
        "degringoler"
    ],
    "degringoleraient": [
        "degringoler"
    ],
    "degringolerais": [
        "degringoler"
    ],
    "degringoleront": [
        "degringoler"
    ],
    "degringolions": [
        "degringoler"
    ],
    "degringolames": [
        "degringoler"
    ],
    "degringolerent": [
        "degringoler"
    ],
    "degringolee": [
        "degringoler"
    ],
    "degringoles": [
        "degringoler"
    ],
    "degripper": [
        "degripper"
    ],
    "degrisa": [
        "degriser"
    ],
    "degrisait": [
        "degriser"
    ],
    "degrise": [
        "degriser"
    ],
    "degrisement": [
        "degrisement"
    ],
    "degriser": [
        "degriser"
    ],
    "degrisat": [
        "degriser"
    ],
    "degrisee": [
        "degriser"
    ],
    "degrises": [
        "degriser"
    ],
    "degrossi": [
        "degrossi"
    ],
    "degrossie": [
        "degrossi"
    ],
    "degrossies": [
        "degrossi"
    ],
    "degrossir": [
        "degrossir"
    ],
    "degrossis": [
        "degrossi"
    ],
    "degrossissage": [
        "degrossissage"
    ],
    "degrossissant": [
        "degrossir"
    ],
    "degrouille": [
        "degrouiller"
    ],
    "degrouiller": [
        "degrouiller"
    ],
    "degrene": [
        "degrener"
    ],
    "degrevement": [
        "degrevement"
    ],
    "degrevements": [
        "degrevement"
    ],
    "degree": [
        "degreer"
    ],
    "degrener": [
        "degrener"
    ],
    "deguenille": [
        "deguenille"
    ],
    "deguenillee": [
        "deguenille"
    ],
    "deguenillees": [
        "deguenille"
    ],
    "deguenilles": [
        "deguenille"
    ],
    "deguerpi": [
        "deguerpir"
    ],
    "deguerpir": [
        "deguerpir"
    ],
    "deguerpirent": [
        "deguerpir"
    ],
    "deguerpis": [
        "deguerpir"
    ],
    "deguerpisse": [
        "deguerpir"
    ],
    "deguerpissent": [
        "deguerpir"
    ],
    "deguerpissez": [
        "deguerpir"
    ],
    "deguerpissiez": [
        "deguerpir"
    ],
    "deguerpissons": [
        "deguerpir"
    ],
    "deguerpit": [
        "deguerpir"
    ],
    "degueu": [
        "degueu"
    ],
    "degueula": [
        "degueuler"
    ],
    "degueulais": [
        "degueuler"
    ],
    "degueulait": [
        "degueuler"
    ],
    "degueulando": [
        "degueulando"
    ],
    "degueulant": [
        "degueuler"
    ],
    "degueulasse": [
        "degueulasser",
        "degueulasse"
    ],
    "degueulassement": [
        "degueulassement"
    ],
    "degueulasser": [
        "degueulasser"
    ],
    "degueulasserie": [
        "degueulasserie"
    ],
    "degueulasseries": [
        "degueulasserie"
    ],
    "degueulasses": [
        "degueulasser",
        "degueulasse"
    ],
    "degueule": [
        "degueuler"
    ],
    "degueulent": [
        "degueuler"
    ],
    "degueuler": [
        "degueuler"
    ],
    "degueulera": [
        "degueuler"
    ],
    "degueules": [
        "degueuler"
    ],
    "degueulez": [
        "degueuler"
    ],
    "degueulis": [
        "degueulis"
    ],
    "degueulees": [
        "degueuler"
    ],
    "degueus": [
        "degueu"
    ],
    "deguisa": [
        "deguiser"
    ],
    "deguisaient": [
        "deguiser"
    ],
    "deguisais": [
        "deguiser"
    ],
    "deguisait": [
        "deguiser"
    ],
    "deguisant": [
        "deguiser"
    ],
    "deguise": [
        "deguise",
        "deguiser"
    ],
    "deguisement": [
        "deguisement"
    ],
    "deguisements": [
        "deguisement"
    ],
    "deguisent": [
        "deguiser"
    ],
    "deguiser": [
        "deguiser"
    ],
    "deguisera": [
        "deguiser"
    ],
    "deguiserai": [
        "deguiser"
    ],
    "deguiserais": [
        "deguiser"
    ],
    "deguiserait": [
        "deguiser"
    ],
    "deguises": [
        "deguise",
        "deguiser"
    ],
    "deguisez": [
        "deguiser"
    ],
    "deguisiez": [
        "deguiser"
    ],
    "deguisions": [
        "deguiser"
    ],
    "deguisee": [
        "deguise",
        "deguiser"
    ],
    "deguisees": [
        "deguise",
        "deguiser"
    ],
    "degurgitant": [
        "degurgiter"
    ],
    "degusta": [
        "deguster"
    ],
    "degustai": [
        "deguster"
    ],
    "degustaient": [
        "deguster"
    ],
    "degustais": [
        "deguster"
    ],
    "degustait": [
        "deguster"
    ],
    "degustant": [
        "deguster"
    ],
    "degustateur": [
        "degustateur"
    ],
    "degustateurs": [
        "degustateur"
    ],
    "degustation": [
        "degustation"
    ],
    "degustations": [
        "degustation"
    ],
    "degustatrice": [
        "degustateur"
    ],
    "deguste": [
        "deguster"
    ],
    "degustent": [
        "deguster"
    ],
    "deguster": [
        "deguster"
    ],
    "degustera": [
        "deguster"
    ],
    "degusteras": [
        "deguster"
    ],
    "degusterons": [
        "deguster"
    ],
    "degustez": [
        "deguster"
    ],
    "degustons": [
        "deguster"
    ],
    "degustames": [
        "deguster"
    ],
    "degusterent": [
        "deguster"
    ],
    "degustee": [
        "deguster"
    ],
    "degustees": [
        "deguster"
    ],
    "degustes": [
        "deguster"
    ],
    "degat": [
        "degat"
    ],
    "degats": [
        "degat"
    ],
    "degelent": [
        "degeler"
    ],
    "degelera": [
        "degeler"
    ],
    "degelerait": [
        "degeler"
    ],
    "degenere": [
        "degenere",
        "degenerer"
    ],
    "degenerent": [
        "degenerer"
    ],
    "degenera": [
        "degenerer"
    ],
    "degeneraient": [
        "degenerer"
    ],
    "degenerait": [
        "degenerer"
    ],
    "degenerant": [
        "degenerer"
    ],
    "degeneratif": [
        "degeneratif"
    ],
    "degeneration": [
        "degeneration"
    ],
    "degenerative": [
        "degeneratif"
    ],
    "degenerer": [
        "degenerer"
    ],
    "degenerescence": [
        "degenerescence"
    ],
    "degenerescences": [
        "degenerescence"
    ],
    "degenerat": [
        "degenerer"
    ],
    "degeneree": [
        "degenere",
        "degenerer"
    ],
    "degenerees": [
        "degenere",
        "degenerer"
    ],
    "degeneres": [
        "degenere",
        "degenerer"
    ],
    "dehale": [
        "dehaler"
    ],
    "dehaler": [
        "dehaler"
    ],
    "dehalees": [
        "dehaler"
    ],
    "dehancha": [
        "dehancher"
    ],
    "dehanchaient": [
        "dehancher"
    ],
    "dehanchait": [
        "dehancher"
    ],
    "dehanchant": [
        "dehancher"
    ],
    "dehanche": [
        "dehancher",
        "dehanche"
    ],
    "dehanchement": [
        "dehanchement"
    ],
    "dehanchements": [
        "dehanchement"
    ],
    "dehanchent": [
        "dehancher"
    ],
    "dehancher": [
        "dehancher"
    ],
    "dehanchez": [
        "dehancher"
    ],
    "dehanchee": [
        "dehancher",
        "dehanche"
    ],
    "dehanchees": [
        "dehancher",
        "dehanche"
    ],
    "dehanches": [
        "dehanche"
    ],
    "deharnacha": [
        "deharnacher"
    ],
    "deharnachees": [
        "deharnacher"
    ],
    "dehiscence": [
        "dehiscence"
    ],
    "dehotte": [
        "dehotter"
    ],
    "dehotter": [
        "dehotter"
    ],
    "dehottee": [
        "dehotter"
    ],
    "deicide": [
        "deicide"
    ],
    "deicides": [
        "deicide"
    ],
    "deifia": [
        "deifier"
    ],
    "deification": [
        "deification"
    ],
    "deifier": [
        "deifier"
    ],
    "deifie": [
        "deifier"
    ],
    "deifies": [
        "deifier"
    ],
    "deisme": [
        "deisme"
    ],
    "deite": [
        "deite"
    ],
    "deites": [
        "deite"
    ],
    "dejanta": [
        "dejanter"
    ],
    "dejantait": [
        "dejanter"
    ],
    "dejante": [
        "dejanter",
        "dejante"
    ],
    "dejantent": [
        "dejanter"
    ],
    "dejanter": [
        "dejanter"
    ],
    "dejanterais": [
        "dejanter"
    ],
    "dejantes": [
        "dejanter",
        "dejante"
    ],
    "dejantee": [
        "dejanter"
    ],
    "dejaugeant": [
        "dejauger"
    ],
    "dejection": [
        "dejection"
    ],
    "dejections": [
        "dejection"
    ],
    "dejetait": [
        "dejeter"
    ],
    "dejete": [
        "dejeter",
        "dejete"
    ],
    "dejetee": [
        "dejeter"
    ],
    "dejetes": [
        "dejete"
    ],
    "dejeuna": [
        "dejeuner"
    ],
    "dejeunai": [
        "dejeuner"
    ],
    "dejeunaient": [
        "dejeuner"
    ],
    "dejeunais": [
        "dejeuner"
    ],
    "dejeunait": [
        "dejeuner"
    ],
    "dejeunant": [
        "dejeuner"
    ],
    "dejeune": [
        "dejeuner"
    ],
    "dejeunent": [
        "dejeuner"
    ],
    "dejeuner": [
        "dejeuner"
    ],
    "dejeunera": [
        "dejeuner"
    ],
    "dejeunerai": [
        "dejeuner"
    ],
    "dejeuneraient": [
        "dejeuner"
    ],
    "dejeunerait": [
        "dejeuner"
    ],
    "dejeuneras": [
        "dejeuner"
    ],
    "dejeunerez": [
        "dejeuner"
    ],
    "dejeunerions": [
        "dejeuner"
    ],
    "dejeunerons": [
        "dejeuner"
    ],
    "dejeuners": [
        "dejeuner"
    ],
    "dejeunes": [
        "dejeuner"
    ],
    "dejeunez": [
        "dejeuner"
    ],
    "dejeuniez": [
        "dejeuner"
    ],
    "dejeunions": [
        "dejeuner"
    ],
    "dejeunons": [
        "dejeuner"
    ],
    "dejeunames": [
        "dejeuner"
    ],
    "dejeunat": [
        "dejeuner"
    ],
    "dejeunerent": [
        "dejeuner"
    ],
    "dejoua": [
        "dejouer"
    ],
    "dejouait": [
        "dejouer"
    ],
    "dejouant": [
        "dejouer"
    ],
    "dejoue": [
        "dejouer"
    ],
    "dejouent": [
        "dejouer"
    ],
    "dejouer": [
        "dejouer"
    ],
    "dejouerai": [
        "dejouer"
    ],
    "dejouerez": [
        "dejouer"
    ],
    "dejouerions": [
        "dejouer"
    ],
    "dejouez": [
        "dejouer"
    ],
    "dejouons": [
        "dejouer"
    ],
    "dejouee": [
        "dejouer"
    ],
    "dejouees": [
        "dejouer"
    ],
    "dejoues": [
        "dejouer"
    ],
    "dejuchaient": [
        "dejucher"
    ],
    "dejuger": [
        "dejuger"
    ],
    "dejuge": [
        "dejuger"
    ],
    "deja": [
        "deja"
    ],
    "dekoulakisation": [
        "dekoulakisation"
    ],
    "delabre": [
        "delabre",
        "delabrer"
    ],
    "delabrement": [
        "delabrement"
    ],
    "delabrer": [
        "delabrer"
    ],
    "delabree": [
        "delabre",
        "delabrer"
    ],
    "delabrees": [
        "delabre",
        "delabrer"
    ],
    "delabres": [
        "delabre",
        "delabrer"
    ],
    "delabyrinthez": [
        "delabyrinther"
    ],
    "delace": [
        "delacer"
    ],
    "delacer": [
        "delacer"
    ],
    "delacerent": [
        "delacer"
    ],
    "delacees": [
        "delacer"
    ],
    "delai": [
        "delai"
    ],
    "delaie": [
        "delayer"
    ],
    "delais": [
        "delai"
    ],
    "delaissa": [
        "delaisser"
    ],
    "delaissaient": [
        "delaisser"
    ],
    "delaissais": [
        "delaisser"
    ],
    "delaissait": [
        "delaisser"
    ],
    "delaissant": [
        "delaisser"
    ],
    "delaisse": [
        "delaisser",
        "delaisse"
    ],
    "delaissement": [
        "delaissement"
    ],
    "delaissements": [
        "delaissement"
    ],
    "delaissent": [
        "delaisser"
    ],
    "delaisser": [
        "delaisser"
    ],
    "delaisserait": [
        "delaisser"
    ],
    "delaisses": [
        "delaisser",
        "delaisse"
    ],
    "delaissions": [
        "delaisser"
    ],
    "delaisserent": [
        "delaisser"
    ],
    "delaissee": [
        "delaisser",
        "delaisse"
    ],
    "delaissees": [
        "delaisser",
        "delaisse"
    ],
    "delaita": [
        "delaiter"
    ],
    "delaite": [
        "delaiter"
    ],
    "delardant": [
        "delarder"
    ],
    "delassa": [
        "delasser"
    ],
    "delassait": [
        "delasser"
    ],
    "delassant": [
        "delassant"
    ],
    "delassante": [
        "delassant"
    ],
    "delasse": [
        "delasser"
    ],
    "delassement": [
        "delassement"
    ],
    "delasser": [
        "delasser"
    ],
    "delassera": [
        "delasser"
    ],
    "delasseront": [
        "delasser"
    ],
    "delasses": [
        "delasser"
    ],
    "delateur": [
        "delateur"
    ],
    "delateurs": [
        "delateur"
    ],
    "delation": [
        "delation"
    ],
    "delations": [
        "delation"
    ],
    "delatrice": [
        "delateur"
    ],
    "delavait": [
        "delaver"
    ],
    "delavant": [
        "delaver"
    ],
    "delave": [
        "delaver",
        "delave"
    ],
    "delavent": [
        "delaver"
    ],
    "delaver": [
        "delaver"
    ],
    "delavee": [
        "delaver",
        "delave"
    ],
    "delavees": [
        "delaver",
        "delave"
    ],
    "delaves": [
        "delaver",
        "delave"
    ],
    "delaya": [
        "delayer"
    ],
    "delayage": [
        "delayage"
    ],
    "delayait": [
        "delayer"
    ],
    "delayant": [
        "delayer"
    ],
    "delaye": [
        "delaye",
        "delayer"
    ],
    "delayent": [
        "delayer"
    ],
    "delayer": [
        "delayer"
    ],
    "delayee": [
        "delaye",
        "delayer"
    ],
    "delayes": [
        "delayer"
    ],
    "delaca": [
        "delacer"
    ],
    "delacais": [
        "delacer"
    ],
    "delacait": [
        "delacer"
    ],
    "delacant": [
        "delacer"
    ],
    "delectable": [
        "delectable"
    ],
    "delectables": [
        "delectable"
    ],
    "delectai": [
        "delecter"
    ],
    "delectaient": [
        "delecter"
    ],
    "delectais": [
        "delecter"
    ],
    "delectait": [
        "delecter"
    ],
    "delectant": [
        "delecter"
    ],
    "delectation": [
        "delectation"
    ],
    "delectations": [
        "delectation"
    ],
    "delecte": [
        "delecter"
    ],
    "delectent": [
        "delecter"
    ],
    "delecter": [
        "delecter"
    ],
    "delectes": [
        "delecter"
    ],
    "delectez": [
        "delecter"
    ],
    "delections": [
        "delecter"
    ],
    "delectat": [
        "delecter"
    ],
    "delestage": [
        "delestage"
    ],
    "delestant": [
        "delester"
    ],
    "deleste": [
        "delester"
    ],
    "delester": [
        "delester"
    ],
    "delestons": [
        "delester"
    ],
    "delesterent": [
        "delester"
    ],
    "delestee": [
        "delester"
    ],
    "delestees": [
        "delester"
    ],
    "delestes": [
        "delester"
    ],
    "delia": [
        "delier"
    ],
    "deliaient": [
        "delier"
    ],
    "deliait": [
        "delier"
    ],
    "deliant": [
        "delier"
    ],
    "delibere": [
        "delibere",
        "deliberer"
    ],
    "deliberent": [
        "deliberer"
    ],
    "delibera": [
        "deliberer"
    ],
    "deliberaient": [
        "deliberer"
    ],
    "deliberait": [
        "deliberer"
    ],
    "deliberant": [
        "deliberer"
    ],
    "deliberation": [
        "deliberation"
    ],
    "deliberations": [
        "deliberation"
    ],
    "deliberative": [
        "deliberatif"
    ],
    "deliberatoire": [
        "deliberatoire"
    ],
    "deliberer": [
        "deliberer"
    ],
    "deliberera": [
        "deliberer"
    ],
    "delibereraient": [
        "deliberer"
    ],
    "deliberions": [
        "deliberer"
    ],
    "delibererent": [
        "deliberer"
    ],
    "deliberee": [
        "delibere",
        "deliberer"
    ],
    "deliberees": [
        "delibere",
        "deliberer"
    ],
    "deliberement": [
        "deliberement"
    ],
    "deliberes": [
        "delibere",
        "deliberer"
    ],
    "delicat": [
        "delicat"
    ],
    "delicate": [
        "delicat"
    ],
    "delicatement": [
        "delicatement"
    ],
    "delicates": [
        "delicat"
    ],
    "delicatesse": [
        "delicatesse"
    ],
    "delicatesses": [
        "delicatesse"
    ],
    "delicats": [
        "delicat"
    ],
    "delice": [
        "delice"
    ],
    "delices": [
        "delice"
    ],
    "delicieuse": [
        "delicieux"
    ],
    "delicieusement": [
        "delicieusement"
    ],
    "delicieuses": [
        "delicieux"
    ],
    "delicieux": [
        "delicieux"
    ],
    "delictuelle": [
        "delictuel"
    ],
    "delictueuse": [
        "delictueux"
    ],
    "delictueuses": [
        "delictueux"
    ],
    "delictueux": [
        "delictueux"
    ],
    "delie": [
        "delie",
        "delier"
    ],
    "delient": [
        "delier"
    ],
    "delier": [
        "delier"
    ],
    "delieraient": [
        "delier"
    ],
    "delieras": [
        "delier"
    ],
    "deliez": [
        "delier"
    ],
    "delimitaient": [
        "delimiter"
    ],
    "delimitais": [
        "delimiter"
    ],
    "delimitait": [
        "delimiter"
    ],
    "delimitant": [
        "delimitant",
        "delimiter"
    ],
    "delimitation": [
        "delimitation"
    ],
    "delimitations": [
        "delimitation"
    ],
    "delimite": [
        "delimiter"
    ],
    "delimitent": [
        "delimiter"
    ],
    "delimiter": [
        "delimiter"
    ],
    "delimitez": [
        "delimiter"
    ],
    "delimitions": [
        "delimiter"
    ],
    "delimitons": [
        "delimiter"
    ],
    "delimitee": [
        "delimiter"
    ],
    "delimitees": [
        "delimiter"
    ],
    "delimites": [
        "delimiter"
    ],
    "delinquance": [
        "delinquance"
    ],
    "delinquances": [
        "delinquance"
    ],
    "delinquant": [
        "delinquant"
    ],
    "delinquante": [
        "delinquant"
    ],
    "delinquantes": [
        "delinquant"
    ],
    "delinquants": [
        "delinquant"
    ],
    "delineaments": [
        "delineament"
    ],
    "deliquescence": [
        "deliquescence"
    ],
    "deliquescent": [
        "deliquescent"
    ],
    "deliquescente": [
        "deliquescent"
    ],
    "deliquescents": [
        "deliquescent"
    ],
    "delira": [
        "delirer"
    ],
    "delirai": [
        "delirer"
    ],
    "deliraient": [
        "delirer"
    ],
    "delirais": [
        "delirer"
    ],
    "delirait": [
        "delirer"
    ],
    "delirant": [
        "delirant",
        "delirer"
    ],
    "delirante": [
        "delirant"
    ],
    "delirantes": [
        "delirant"
    ],
    "delirants": [
        "delirant"
    ],
    "delirassent": [
        "delirer"
    ],
    "delire": [
        "delirer",
        "delire"
    ],
    "delirent": [
        "delirer"
    ],
    "delirer": [
        "delirer"
    ],
    "delireras": [
        "delirer"
    ],
    "delires": [
        "delirer",
        "delire"
    ],
    "delirez": [
        "delirer"
    ],
    "deliriez": [
        "delirer"
    ],
    "delit": [
        "delit"
    ],
    "delitaient": [
        "deliter"
    ],
    "delite": [
        "deliter"
    ],
    "delitent": [
        "deliter"
    ],
    "deliteront": [
        "deliter"
    ],
    "delits": [
        "delit"
    ],
    "delitee": [
        "deliter"
    ],
    "delitees": [
        "deliter"
    ],
    "delivra": [
        "delivrer"
    ],
    "delivraient": [
        "delivrer"
    ],
    "delivrais": [
        "delivrer"
    ],
    "delivrait": [
        "delivrer"
    ],
    "delivrance": [
        "delivrance"
    ],
    "delivrances": [
        "delivrance"
    ],
    "delivrant": [
        "delivrer"
    ],
    "delivre": [
        "delivrer",
        "delivre"
    ],
    "delivrent": [
        "delivrer"
    ],
    "delivrer": [
        "delivrer"
    ],
    "delivrera": [
        "delivrer"
    ],
    "delivrerai": [
        "delivrer"
    ],
    "delivreraient": [
        "delivrer"
    ],
    "delivrerais": [
        "delivrer"
    ],
    "delivrerait": [
        "delivrer"
    ],
    "delivreras": [
        "delivrer"
    ],
    "delivrerez": [
        "delivrer"
    ],
    "delivrerons": [
        "delivrer"
    ],
    "delivreront": [
        "delivrer"
    ],
    "delivreurs": [
        "delivreur"
    ],
    "delivrez": [
        "delivrer"
    ],
    "delivriez": [
        "delivrer"
    ],
    "delivrions": [
        "delivrer"
    ],
    "delivrons": [
        "delivrer"
    ],
    "delivrat": [
        "delivrer"
    ],
    "delivrerent": [
        "delivrer"
    ],
    "delivree": [
        "delivrer"
    ],
    "delivrees": [
        "delivrer"
    ],
    "delivres": [
        "delivrer"
    ],
    "delierent": [
        "delier"
    ],
    "deliee": [
        "delie",
        "delier"
    ],
    "deliees": [
        "delie",
        "delier"
    ],
    "delies": [
        "delie",
        "delier"
    ],
    "delocalisation": [
        "delocalisation"
    ],
    "delocaliser": [
        "delocaliser"
    ],
    "delocalisez": [
        "delocaliser"
    ],
    "delocalise": [
        "delocaliser"
    ],
    "deloge": [
        "deloger"
    ],
    "delogea": [
        "deloger"
    ],
    "delogeait": [
        "deloger"
    ],
    "deloger": [
        "deloger"
    ],
    "delogera": [
        "deloger"
    ],
    "delogerait": [
        "deloger"
    ],
    "delogerons": [
        "deloger"
    ],
    "delogez": [
        "deloger"
    ],
    "delogeat": [
        "deloger"
    ],
    "delogee": [
        "deloger"
    ],
    "deloges": [
        "deloger"
    ],
    "deloquaient": [
        "deloquer"
    ],
    "deloque": [
        "deloquer"
    ],
    "deloquer": [
        "deloquer"
    ],
    "deloques": [
        "deloquer"
    ],
    "deloquees": [
        "deloquer"
    ],
    "delourdant": [
        "delourder"
    ],
    "delourder": [
        "delourder"
    ],
    "deloyal": [
        "deloyal"
    ],
    "deloyale": [
        "deloyal"
    ],
    "deloyalement": [
        "deloyalement"
    ],
    "deloyaute": [
        "deloyaute"
    ],
    "deloyautes": [
        "deloyaute"
    ],
    "deloyaux": [
        "deloyal"
    ],
    "deluge": [
        "deluge"
    ],
    "deluges": [
        "deluge"
    ],
    "delure": [
        "delurer",
        "delure"
    ],
    "deluree": [
        "delurer",
        "delure"
    ],
    "delurees": [
        "delurer",
        "delure"
    ],
    "delustrer": [
        "delustrer"
    ],
    "delegue": [
        "deleguer",
        "delegue"
    ],
    "delegation": [
        "delegation"
    ],
    "delegations": [
        "delegation"
    ],
    "delegua": [
        "deleguer"
    ],
    "deleguaient": [
        "deleguer"
    ],
    "deleguait": [
        "deleguer"
    ],
    "deleguant": [
        "deleguer"
    ],
    "deleguer": [
        "deleguer"
    ],
    "deleguerai": [
        "deleguer"
    ],
    "delegueraient": [
        "deleguer"
    ],
    "deleguez": [
        "deleguer"
    ],
    "deleguiez": [
        "deleguer"
    ],
    "deleguons": [
        "deleguer"
    ],
    "deleguat": [
        "deleguer"
    ],
    "deleguee": [
        "deleguer",
        "delegue"
    ],
    "delegues": [
        "deleguer",
        "delegue"
    ],
    "deletere": [
        "deletere"
    ],
    "deleteres": [
        "deletere"
    ],
    "demagnetiser": [
        "demagnetiser"
    ],
    "demagnetise": [
        "demagnetiser"
    ],
    "demagnetisee": [
        "demagnetiser"
    ],
    "demago": [
        "demago"
    ],
    "demagogie": [
        "demagogie"
    ],
    "demagogique": [
        "demagogique"
    ],
    "demagogiques": [
        "demagogique"
    ],
    "demagogue": [
        "demagogue"
    ],
    "demagogues": [
        "demagogue"
    ],
    "demaille": [
        "demailler"
    ],
    "demailler": [
        "demailler"
    ],
    "demailloter": [
        "demailloter"
    ],
    "demaillote": [
        "demailloter"
    ],
    "demaillee": [
        "demailler"
    ],
    "demanche": [
        "demancher"
    ],
    "demancher": [
        "demancher"
    ],
    "demange": [
        "demanger"
    ],
    "demangeaient": [
        "demanger"
    ],
    "demangeais": [
        "demanger"
    ],
    "demangeaison": [
        "demangeaison"
    ],
    "demangeaisons": [
        "demangeaison"
    ],
    "demangeait": [
        "demanger"
    ],
    "demangent": [
        "demanger"
    ],
    "demanger": [
        "demanger"
    ],
    "demanges": [
        "demanger"
    ],
    "demanteler": [
        "demanteler"
    ],
    "demantelez": [
        "demanteler"
    ],
    "demantelons": [
        "demanteler"
    ],
    "demantele": [
        "demanteler"
    ],
    "demantelee": [
        "demanteler"
    ],
    "demantelees": [
        "demanteler"
    ],
    "demanteles": [
        "demanteler"
    ],
    "demantibulant": [
        "demantibuler"
    ],
    "demantibule": [
        "demantibuler"
    ],
    "demantibulent": [
        "demantibuler"
    ],
    "demantibuler": [
        "demantibuler"
    ],
    "demantibulee": [
        "demantibuler"
    ],
    "demantibulees": [
        "demantibuler"
    ],
    "demantibules": [
        "demantibuler"
    ],
    "demantelement": [
        "demantelement"
    ],
    "demantelements": [
        "demantelement"
    ],
    "demantelent": [
        "demanteler"
    ],
    "demaquillage": [
        "demaquillage"
    ],
    "demaquillaient": [
        "demaquiller"
    ],
    "demaquillais": [
        "demaquiller"
    ],
    "demaquillait": [
        "demaquiller"
    ],
    "demaquillant": [
        "demaquiller",
        "demaquillant"
    ],
    "demaquillante": [
        "demaquillant"
    ],
    "demaquille": [
        "demaquiller"
    ],
    "demaquiller": [
        "demaquiller"
    ],
    "demaquillerai": [
        "demaquiller"
    ],
    "demaquillee": [
        "demaquiller"
    ],
    "demarcation": [
        "demarcation"
    ],
    "demarcha": [
        "demarcher"
    ],
    "demarchage": [
        "demarchage"
    ],
    "demarchait": [
        "demarcher"
    ],
    "demarche": [
        "demarche",
        "demarcher"
    ],
    "demarcher": [
        "demarcher"
    ],
    "demarches": [
        "demarche"
    ],
    "demarcheur": [
        "demarcheur"
    ],
    "demarcheurs": [
        "demarcheur"
    ],
    "demarcheuse": [
        "demarcheur"
    ],
    "demarient": [
        "demarier"
    ],
    "demarier": [
        "demarier"
    ],
    "demariee": [
        "demarier"
    ],
    "demarquai": [
        "demarquer"
    ],
    "demarquaient": [
        "demarquer"
    ],
    "demarquait": [
        "demarquer"
    ],
    "demarque": [
        "demarquer"
    ],
    "demarquer": [
        "demarquer"
    ],
    "demarquee": [
        "demarquer"
    ],
    "demarquees": [
        "demarquer"
    ],
    "demarques": [
        "demarquer"
    ],
    "demarra": [
        "demarrer"
    ],
    "demarrage": [
        "demarrage"
    ],
    "demarrages": [
        "demarrage"
    ],
    "demarrai": [
        "demarrer"
    ],
    "demarraient": [
        "demarrer"
    ],
    "demarrais": [
        "demarrer"
    ],
    "demarrait": [
        "demarrer"
    ],
    "demarrant": [
        "demarrer"
    ],
    "demarre": [
        "demarrer"
    ],
    "demarrent": [
        "demarrer"
    ],
    "demarrer": [
        "demarrer"
    ],
    "demarrera": [
        "demarrer"
    ],
    "demarrerai": [
        "demarrer"
    ],
    "demarreront": [
        "demarrer"
    ],
    "demarres": [
        "demarrer"
    ],
    "demarreur": [
        "demarreur"
    ],
    "demarreurs": [
        "demarreur"
    ],
    "demarrez": [
        "demarrer"
    ],
    "demarrions": [
        "demarrer"
    ],
    "demarrons": [
        "demarrer"
    ],
    "demarrat": [
        "demarrer"
    ],
    "demarrerent": [
        "demarrer"
    ],
    "demarree": [
        "demarrer"
    ],
    "demarrees": [
        "demarrer"
    ],
    "demasqua": [
        "demasquer"
    ],
    "demasquage": [
        "demasquage"
    ],
    "demasquaient": [
        "demasquer"
    ],
    "demasquais": [
        "demasquer"
    ],
    "demasquait": [
        "demasquer"
    ],
    "demasquant": [
        "demasquer"
    ],
    "demasque": [
        "demasquer"
    ],
    "demasquent": [
        "demasquer"
    ],
    "demasquer": [
        "demasquer"
    ],
    "demasquera": [
        "demasquer"
    ],
    "demasquerai": [
        "demasquer"
    ],
    "demasquerait": [
        "demasquer"
    ],
    "demasqueriez": [
        "demasquer"
    ],
    "demasquerons": [
        "demasquer"
    ],
    "demasqueront": [
        "demasquer"
    ],
    "demasquons": [
        "demasquer"
    ],
    "demasquee": [
        "demasquer"
    ],
    "demasquees": [
        "demasquer"
    ],
    "demasques": [
        "demasquer"
    ],
    "dematerialisation": [
        "dematerialisation"
    ],
    "dematerialise": [
        "dematerialiser"
    ],
    "dematerialisent": [
        "dematerialiser"
    ],
    "dematerialiser": [
        "dematerialiser"
    ],
    "demembrant": [
        "demembrer"
    ],
    "demembre": [
        "demembrer"
    ],
    "demembrement": [
        "demembrement"
    ],
    "demembrements": [
        "demembrement"
    ],
    "demembrer": [
        "demembrer"
    ],
    "demembrez": [
        "demembrer"
    ],
    "demembree": [
        "demembrer"
    ],
    "demembrees": [
        "demembrer"
    ],
    "demembres": [
        "demembrer"
    ],
    "demena": [
        "demener"
    ],
    "demenaient": [
        "demener"
    ],
    "demenais": [
        "demener"
    ],
    "demenait": [
        "demener"
    ],
    "demenant": [
        "demener"
    ],
    "demence": [
        "demence"
    ],
    "demener": [
        "demener"
    ],
    "demenons": [
        "demener"
    ],
    "demenotte": [
        "demenotter"
    ],
    "demens": [
        "dementir"
    ],
    "dement": [
        "dementir",
        "dement"
    ],
    "dementaient": [
        "dementir"
    ],
    "dementait": [
        "dementir"
    ],
    "dementant": [
        "dementir"
    ],
    "demente": [
        "dementir",
        "dement"
    ],
    "dementent": [
        "dementir"
    ],
    "dementes": [
        "dement"
    ],
    "dementez": [
        "dementir"
    ],
    "dementi": [
        "dementi",
        "dementir"
    ],
    "dementie": [
        "dementi",
        "dementir"
    ],
    "dementiel": [
        "dementiel"
    ],
    "dementielle": [
        "dementiel"
    ],
    "dementielles": [
        "dementiel"
    ],
    "dementiels": [
        "dementiel"
    ],
    "dementies": [
        "dementi",
        "dementir"
    ],
    "dementir": [
        "dementir"
    ],
    "dementirai": [
        "dementir"
    ],
    "dementirait": [
        "dementir"
    ],
    "dementiront": [
        "dementir"
    ],
    "dementis": [
        "dementi"
    ],
    "dementit": [
        "dementir"
    ],
    "dements": [
        "dement"
    ],
    "demene": [
        "demener"
    ],
    "demenee": [
        "demener"
    ],
    "demerdaient": [
        "demerder"
    ],
    "demerdais": [
        "demerder"
    ],
    "demerdait": [
        "demerder"
    ],
    "demerdard": [
        "demerdard"
    ],
    "demerdards": [
        "demerdard"
    ],
    "demerde": [
        "demerde",
        "demerder"
    ],
    "demerdent": [
        "demerder"
    ],
    "demerder": [
        "demerder"
    ],
    "demerdera": [
        "demerder"
    ],
    "demerderai": [
        "demerder"
    ],
    "demerderas": [
        "demerder"
    ],
    "demerdes": [
        "demerder"
    ],
    "demerdez": [
        "demerder"
    ],
    "demerdee": [
        "demerder"
    ],
    "demesure": [
        "demesurer",
        "demesure"
    ],
    "demesurent": [
        "demesurer"
    ],
    "demesuree": [
        "demesurer",
        "demesure"
    ],
    "demesurees": [
        "demesurer",
        "demesure"
    ],
    "demesurement": [
        "demesurement"
    ],
    "demesures": [
        "demesurer",
        "demesure"
    ],
    "demet": [
        "demettre"
    ],
    "demets": [
        "demettre"
    ],
    "demette": [
        "demettre"
    ],
    "demettez": [
        "demettre"
    ],
    "demettrait": [
        "demettre"
    ],
    "demettre": [
        "demettre"
    ],
    "demeuble": [
        "demeubler"
    ],
    "demeublee": [
        "demeubler"
    ],
    "demilitarisation": [
        "demilitarisation"
    ],
    "demilitarisee": [
        "demilitariser"
    ],
    "demilitarisees": [
        "demilitariser"
    ],
    "deminage": [
        "deminage"
    ],
    "deminant": [
        "deminer"
    ],
    "deminer": [
        "deminer"
    ],
    "demineur": [
        "demineur"
    ],
    "demineurs": [
        "demineur"
    ],
    "demine": [
        "deminer"
    ],
    "deminee": [
        "deminer"
    ],
    "demise": [
        "demis",
        "demettre"
    ],
    "demises": [
        "demis",
        "demise"
    ],
    "demission": [
        "demission"
    ],
    "demissionna": [
        "demissionner"
    ],
    "demissionnaient": [
        "demissionner"
    ],
    "demissionnaire": [
        "demissionnaire"
    ],
    "demissionnaires": [
        "demissionnaire"
    ],
    "demissionnais": [
        "demissionner"
    ],
    "demissionnait": [
        "demissionner"
    ],
    "demissionnant": [
        "demissionner"
    ],
    "demissionne": [
        "demissionner"
    ],
    "demissionnent": [
        "demissionner"
    ],
    "demissionner": [
        "demissionner"
    ],
    "demissionnera": [
        "demissionner"
    ],
    "demissionnerai": [
        "demissionner"
    ],
    "demissionneraient": [
        "demissionner"
    ],
    "demissionnerais": [
        "demissionner"
    ],
    "demissionnerait": [
        "demissionner"
    ],
    "demissionneras": [
        "demissionner"
    ],
    "demissionnerez": [
        "demissionner"
    ],
    "demissionneront": [
        "demissionner"
    ],
    "demissionnes": [
        "demissionner"
    ],
    "demissionnez": [
        "demissionner"
    ],
    "demissionniez": [
        "demissionner"
    ],
    "demissions": [
        "demission"
    ],
    "demit": [
        "demettre"
    ],
    "demiurge": [
        "demiurge"
    ],
    "demiurges": [
        "demiurge"
    ],
    "demobilisant": [
        "demobiliser"
    ],
    "demobilisateur": [
        "demobilisateur"
    ],
    "demobilisation": [
        "demobilisation"
    ],
    "demobilise": [
        "demobiliser",
        "demobilise"
    ],
    "demobiliser": [
        "demobiliser"
    ],
    "demobiliseriez": [
        "demobiliser"
    ],
    "demobilises": [
        "demobiliser",
        "demobilise"
    ],
    "democrate": [
        "democrate"
    ],
    "democrates": [
        "democrate"
    ],
    "democratie": [
        "democratie"
    ],
    "democraties": [
        "democratie"
    ],
    "democratique": [
        "democratique"
    ],
    "democratiquement": [
        "democratiquement"
    ],
    "democratiques": [
        "democratique"
    ],
    "democratisation": [
        "democratisation"
    ],
    "democratisations": [
        "democratisation"
    ],
    "democratise": [
        "democratiser"
    ],
    "democratiser": [
        "democratiser"
    ],
    "democratiseront": [
        "democratiser"
    ],
    "demodaient": [
        "demoder"
    ],
    "demodant": [
        "demoder"
    ],
    "demode": [
        "demode",
        "demoder"
    ],
    "demoder": [
        "demoder"
    ],
    "demodulateur": [
        "demodulateur"
    ],
    "demodulateurs": [
        "demodulateur"
    ],
    "demodee": [
        "demode",
        "demoder"
    ],
    "demodees": [
        "demode",
        "demoder"
    ],
    "demodes": [
        "demode",
        "demoder"
    ],
    "demographie": [
        "demographie"
    ],
    "demographique": [
        "demographique"
    ],
    "demographiquement": [
        "demographiquement"
    ],
    "demographiques": [
        "demographique"
    ],
    "demoli": [
        "demolir"
    ],
    "demolie": [
        "demolir"
    ],
    "demolies": [
        "demolir"
    ],
    "demolir": [
        "demolir"
    ],
    "demolira": [
        "demolir"
    ],
    "demolirai": [
        "demolir"
    ],
    "demoliraient": [
        "demolir"
    ],
    "demolirais": [
        "demolir"
    ],
    "demolirait": [
        "demolir"
    ],
    "demolirent": [
        "demolir"
    ],
    "demolirions": [
        "demolir"
    ],
    "demoliront": [
        "demolir"
    ],
    "demolis": [
        "demolir"
    ],
    "demolissaient": [
        "demolir"
    ],
    "demolissais": [
        "demolir"
    ],
    "demolissait": [
        "demolir"
    ],
    "demolissant": [
        "demolir"
    ],
    "demolisse": [
        "demolir"
    ],
    "demolissent": [
        "demolir"
    ],
    "demolisses": [
        "demolir"
    ],
    "demolisseur": [
        "demolisseur"
    ],
    "demolisseurs": [
        "demolisseur"
    ],
    "demolisseuse": [
        "demolisseur"
    ],
    "demolissez": [
        "demolir"
    ],
    "demolissions": [
        "demolir"
    ],
    "demolit": [
        "demolir"
    ],
    "demolition": [
        "demolition"
    ],
    "demolitions": [
        "demolition"
    ],
    "demon": [
        "demon"
    ],
    "demone": [
        "demon"
    ],
    "demones": [
        "demon"
    ],
    "demoniaque": [
        "demoniaque"
    ],
    "demoniaquement": [
        "demoniaquement"
    ],
    "demoniaques": [
        "demoniaque"
    ],
    "demonique": [
        "demonique"
    ],
    "demonologie": [
        "demonologie"
    ],
    "demonomanie": [
        "demonomanie"
    ],
    "demons": [
        "demon"
    ],
    "demonstrateur": [
        "demonstrateur"
    ],
    "demonstrateurs": [
        "demonstrateur"
    ],
    "demonstratif": [
        "demonstratif"
    ],
    "demonstratifs": [
        "demonstratif"
    ],
    "demonstration": [
        "demonstration"
    ],
    "demonstrations": [
        "demonstration"
    ],
    "demonstrative": [
        "demonstratif"
    ],
    "demonstrativement": [
        "demonstrativement"
    ],
    "demonstratrice": [
        "demonstrateur"
    ],
    "demonta": [
        "demonter"
    ],
    "demontable": [
        "demontable"
    ],
    "demontables": [
        "demontable"
    ],
    "demontage": [
        "demontage"
    ],
    "demontages": [
        "demontage"
    ],
    "demontaient": [
        "demonter"
    ],
    "demontait": [
        "demonter"
    ],
    "demontant": [
        "demonter"
    ],
    "demonte": [
        "demonter",
        "demonte"
    ],
    "demontent": [
        "demonter"
    ],
    "demonter": [
        "demonter"
    ],
    "demontez": [
        "demonter"
    ],
    "demontra": [
        "demontrer"
    ],
    "demontrable": [
        "demontrable"
    ],
    "demontrai": [
        "demontrer"
    ],
    "demontraient": [
        "demontrer"
    ],
    "demontrait": [
        "demontrer"
    ],
    "demontrant": [
        "demontrer"
    ],
    "demontre": [
        "demontrer"
    ],
    "demontrent": [
        "demontrer"
    ],
    "demontrer": [
        "demontrer"
    ],
    "demontrera": [
        "demontrer"
    ],
    "demontrerai": [
        "demontrer"
    ],
    "demontrerait": [
        "demontrer"
    ],
    "demontrerons": [
        "demontrer"
    ],
    "demontreront": [
        "demontrer"
    ],
    "demontrez": [
        "demontrer"
    ],
    "demontrions": [
        "demontrer"
    ],
    "demontrat": [
        "demontrer"
    ],
    "demontrerent": [
        "demontrer"
    ],
    "demontree": [
        "demontrer"
    ],
    "demontrees": [
        "demontrer"
    ],
    "demontres": [
        "demontrer"
    ],
    "demontee": [
        "demonter",
        "demonte"
    ],
    "demontees": [
        "demonter",
        "demonte"
    ],
    "demontes": [
        "demonter",
        "demonte"
    ],
    "demonetise": [
        "demonetiser"
    ],
    "demonetises": [
        "demonetiser"
    ],
    "demoralisa": [
        "demoraliser"
    ],
    "demoralisait": [
        "demoraliser"
    ],
    "demoralisant": [
        "demoralisant",
        "demoraliser"
    ],
    "demoralisante": [
        "demoralisant"
    ],
    "demoralisants": [
        "demoralisant"
    ],
    "demoralisateur": [
        "demoralisateur"
    ],
    "demoralisateurs": [
        "demoralisateur"
    ],
    "demoralisation": [
        "demoralisation"
    ],
    "demoralise": [
        "demoralise",
        "demoraliser"
    ],
    "demoralisent": [
        "demoraliser"
    ],
    "demoraliser": [
        "demoraliser"
    ],
    "demoraliseraient": [
        "demoraliser"
    ],
    "demoraliserais": [
        "demoraliser"
    ],
    "demoralisee": [
        "demoralise",
        "demoraliser"
    ],
    "demoralisees": [
        "demoralise"
    ],
    "demoralises": [
        "demoralise",
        "demoraliser"
    ],
    "demord": [
        "demordre"
    ],
    "demordaient": [
        "demordre"
    ],
    "demordais": [
        "demordre"
    ],
    "demordait": [
        "demordre"
    ],
    "demordent": [
        "demordre"
    ],
    "demordez": [
        "demordre"
    ],
    "demordit": [
        "demordre"
    ],
    "demordra": [
        "demordre"
    ],
    "demordrai": [
        "demordre"
    ],
    "demordrait": [
        "demordre"
    ],
    "demordre": [
        "demordre"
    ],
    "demordront": [
        "demordre"
    ],
    "demords": [
        "demordre"
    ],
    "demordu": [
        "demordre"
    ],
    "demotique": [
        "demotique"
    ],
    "demotivation": [
        "demotivation"
    ],
    "demotive": [
        "demotiver"
    ],
    "demotiver": [
        "demotiver"
    ],
    "demotivee": [
        "demotiver"
    ],
    "demouchete": [
        "demoucheter"
    ],
    "demoule": [
        "demouler"
    ],
    "demouler": [
        "demouler"
    ],
    "demoules": [
        "demouler"
    ],
    "demoulees": [
        "demouler"
    ],
    "demultipliaient": [
        "demultiplier"
    ],
    "demultipliait": [
        "demultiplier"
    ],
    "demultipliant": [
        "demultiplier"
    ],
    "demultiplicateur": [
        "demultiplicateur"
    ],
    "demultiplication": [
        "demultiplication"
    ],
    "demultiplie": [
        "demultiplier"
    ],
    "demultiplient": [
        "demultiplier"
    ],
    "demultiplier": [
        "demultiplier"
    ],
    "demultipliee": [
        "demultiplier"
    ],
    "demultipliees": [
        "demultiplier"
    ],
    "demultiplies": [
        "demultiplier"
    ],
    "demuni": [
        "demuni",
        "demunir"
    ],
    "demunie": [
        "demuni",
        "demunir"
    ],
    "demunies": [
        "demuni",
        "demunir"
    ],
    "demunir": [
        "demunir"
    ],
    "demunis": [
        "demuni",
        "demunir"
    ],
    "demunissant": [
        "demunir"
    ],
    "demurge": [
        "demurger"
    ],
    "demurger": [
        "demurger"
    ],
    "demuseler": [
        "demuseler"
    ],
    "demystificateur": [
        "demystificateur"
    ],
    "demystification": [
        "demystification"
    ],
    "demystifications": [
        "demystification"
    ],
    "demystificatrice": [
        "demystificateur"
    ],
    "demystifier": [
        "demystifier"
    ],
    "demystifie": [
        "demystifier"
    ],
    "demythifie": [
        "demythifier"
    ],
    "dematait": [
        "demater"
    ],
    "demater": [
        "demater"
    ],
    "demate": [
        "demater"
    ],
    "dematee": [
        "demater"
    ],
    "demates": [
        "demater"
    ],
    "demenent": [
        "demener"
    ],
    "demeneras": [
        "demener"
    ],
    "demenes": [
        "demener"
    ],
    "demenage": [
        "demenager"
    ],
    "demenagea": [
        "demenager"
    ],
    "demenageaient": [
        "demenager"
    ],
    "demenageais": [
        "demenager"
    ],
    "demenageait": [
        "demenager"
    ],
    "demenageant": [
        "demenager"
    ],
    "demenagement": [
        "demenagement"
    ],
    "demenagements": [
        "demenagement"
    ],
    "demenagent": [
        "demenager"
    ],
    "demenageons": [
        "demenager"
    ],
    "demenager": [
        "demenager"
    ],
    "demenagera": [
        "demenager"
    ],
    "demenagerai": [
        "demenager"
    ],
    "demenageraient": [
        "demenager"
    ],
    "demenagerais": [
        "demenager"
    ],
    "demenagerait": [
        "demenager"
    ],
    "demenageras": [
        "demenager"
    ],
    "demenagerez": [
        "demenager"
    ],
    "demenages": [
        "demenager"
    ],
    "demenageur": [
        "demenageur"
    ],
    "demenageurs": [
        "demenageur"
    ],
    "demenageuse": [
        "demenageur"
    ],
    "demenagez": [
        "demenager"
    ],
    "demenagiez": [
        "demenager"
    ],
    "demenagions": [
        "demenager"
    ],
    "demenagerent": [
        "demenager"
    ],
    "demenagee": [
        "demenager"
    ],
    "demeritait": [
        "demeriter"
    ],
    "demerite": [
        "demerite",
        "demeriter"
    ],
    "demeriter": [
        "demeriter"
    ],
    "demerites": [
        "demerite"
    ],
    "demela": [
        "demeler"
    ],
    "demelage": [
        "demelage"
    ],
    "demelai": [
        "demeler"
    ],
    "demelais": [
        "demeler"
    ],
    "demelait": [
        "demeler"
    ],
    "demelant": [
        "demeler",
        "demelant"
    ],
    "demele": [
        "demeler"
    ],
    "demelent": [
        "demeler"
    ],
    "demeler": [
        "demeler"
    ],
    "demelerait": [
        "demeler"
    ],
    "demelions": [
        "demeler"
    ],
    "demeloir": [
        "demeloir"
    ],
    "demelees": [
        "demeler"
    ],
    "demeles": [
        "demeler",
        "demele"
    ],
    "denanti": [
        "denantir"
    ],
    "denatalite": [
        "denatalite"
    ],
    "denaturaient": [
        "denaturer"
    ],
    "denaturait": [
        "denaturer"
    ],
    "denaturation": [
        "denaturation"
    ],
    "denature": [
        "denaturer",
        "denature"
    ],
    "denaturent": [
        "denaturer"
    ],
    "denaturer": [
        "denaturer"
    ],
    "denaturee": [
        "denaturer",
        "denature"
    ],
    "denaturees": [
        "denaturer",
        "denature"
    ],
    "denatures": [
        "denaturer",
        "denature"
    ],
    "denazification": [
        "denazification"
    ],
    "denazifier": [
        "denazifier"
    ],
    "deneigement": [
        "deneigement"
    ],
    "deneiger": [
        "deneiger"
    ],
    "deneige": [
        "deneiger"
    ],
    "denervation": [
        "denervation"
    ],
    "denerve": [
        "denerver"
    ],
    "deni": [
        "deni"
    ],
    "denia": [
        "denier"
    ],
    "deniaient": [
        "denier"
    ],
    "deniaisa": [
        "deniaiser"
    ],
    "deniaisas": [
        "deniaiser"
    ],
    "deniaisement": [
        "deniaisement"
    ],
    "deniaiser": [
        "deniaiser"
    ],
    "deniaises": [
        "deniaiser"
    ],
    "deniaise": [
        "deniaiser"
    ],
    "deniait": [
        "denier"
    ],
    "deniant": [
        "denier"
    ],
    "denicha": [
        "denicher"
    ],
    "denichai": [
        "denicher"
    ],
    "denichaient": [
        "denicher"
    ],
    "denichais": [
        "denicher"
    ],
    "denichait": [
        "denicher"
    ],
    "denichant": [
        "denicher"
    ],
    "deniche": [
        "denicher"
    ],
    "denichent": [
        "denicher"
    ],
    "denicher": [
        "denicher"
    ],
    "denichera": [
        "denicher"
    ],
    "denicherait": [
        "denicher"
    ],
    "denicheras": [
        "denicher"
    ],
    "denicheur": [
        "denicheur"
    ],
    "denicheurs": [
        "denicheur"
    ],
    "denicheuse": [
        "denicheur"
    ],
    "denichez": [
        "denicher"
    ],
    "denichions": [
        "denicher"
    ],
    "denichee": [
        "denicher"
    ],
    "denichees": [
        "denicher"
    ],
    "deniches": [
        "denicher"
    ],
    "denie": [
        "denier"
    ],
    "denierai": [
        "denier"
    ],
    "denies": [
        "denier",
        "deny"
    ],
    "denigrais": [
        "denigrer"
    ],
    "denigrait": [
        "denigrer"
    ],
    "denigrant": [
        "denigrer",
        "denigrant"
    ],
    "denigrante": [
        "denigrant"
    ],
    "denigre": [
        "denigrer"
    ],
    "denigrement": [
        "denigrement"
    ],
    "denigrements": [
        "denigrement"
    ],
    "denigrent": [
        "denigrer"
    ],
    "denigrer": [
        "denigrer"
    ],
    "denigres": [
        "denigrer"
    ],
    "denigreuses": [
        "denigreur"
    ],
    "denigrez": [
        "denigrer"
    ],
    "denigrees": [
        "denigrer"
    ],
    "denions": [
        "denier"
    ],
    "denis": [
        "deni"
    ],
    "denivellation": [
        "denivellation"
    ],
    "denivellations": [
        "denivellation"
    ],
    "denivele": [
        "denivele",
        "deniveler"
    ],
    "deniveles": [
        "denivele"
    ],
    "denombra": [
        "denombrer"
    ],
    "denombrables": [
        "denombrable"
    ],
    "denombrait": [
        "denombrer"
    ],
    "denombrant": [
        "denombrer"
    ],
    "denombre": [
        "denombrer"
    ],
    "denombrement": [
        "denombrement"
    ],
    "denombrements": [
        "denombrement"
    ],
    "denombrent": [
        "denombrer"
    ],
    "denombrer": [
        "denombrer"
    ],
    "denombrez": [
        "denombrer"
    ],
    "denombres": [
        "denombrer"
    ],
    "denominateur": [
        "denominateur"
    ],
    "denominatif": [
        "denominatif"
    ],
    "denomination": [
        "denomination"
    ],
    "denominations": [
        "denomination"
    ],
    "denominer": [
        "denominer"
    ],
    "denommaient": [
        "denommer"
    ],
    "denommait": [
        "denommer"
    ],
    "denomment": [
        "denommer"
    ],
    "denommer": [
        "denommer"
    ],
    "denommez": [
        "denommer"
    ],
    "denomme": [
        "denommer",
        "denomme"
    ],
    "denommee": [
        "denommer",
        "denomme"
    ],
    "denommes": [
        "denommer"
    ],
    "denonce": [
        "denoncer"
    ],
    "denoncent": [
        "denoncer"
    ],
    "denoncer": [
        "denoncer"
    ],
    "denoncera": [
        "denoncer"
    ],
    "denoncerai": [
        "denoncer"
    ],
    "denonceraient": [
        "denoncer"
    ],
    "denoncerais": [
        "denoncer"
    ],
    "denoncerait": [
        "denoncer"
    ],
    "denonceras": [
        "denoncer"
    ],
    "denoncerez": [
        "denoncer"
    ],
    "denonceriez": [
        "denoncer"
    ],
    "denonceront": [
        "denoncer"
    ],
    "denonces": [
        "denoncer"
    ],
    "denoncez": [
        "denoncer"
    ],
    "denonciateur": [
        "denonciateur"
    ],
    "denonciation": [
        "denonciation"
    ],
    "denonciations": [
        "denonciation"
    ],
    "denonciatrice": [
        "denonciateur"
    ],
    "denoncee": [
        "denoncer"
    ],
    "denoncees": [
        "denoncer"
    ],
    "denonca": [
        "denoncer"
    ],
    "denoncaient": [
        "denoncer"
    ],
    "denoncais": [
        "denoncer"
    ],
    "denoncait": [
        "denoncer"
    ],
    "denoncant": [
        "denoncer"
    ],
    "denoncons": [
        "denoncer"
    ],
    "denoncat": [
        "denoncer"
    ],
    "denotaient": [
        "denoter"
    ],
    "denotait": [
        "denoter"
    ],
    "denotant": [
        "denoter"
    ],
    "denote": [
        "denoter"
    ],
    "denotent": [
        "denoter"
    ],
    "denoter": [
        "denoter"
    ],
    "denoterait": [
        "denoter"
    ],
    "denoua": [
        "denouer"
    ],
    "denouaient": [
        "denouer"
    ],
    "denouait": [
        "denouer"
    ],
    "denouant": [
        "denouer"
    ],
    "denoue": [
        "denouer"
    ],
    "denouement": [
        "denouement"
    ],
    "denouements": [
        "denouement"
    ],
    "denouent": [
        "denouer"
    ],
    "denouer": [
        "denouer"
    ],
    "denouera": [
        "denouer"
    ],
    "denouerais": [
        "denouer"
    ],
    "denouions": [
        "denouer"
    ],
    "denouat": [
        "denouer"
    ],
    "denouerent": [
        "denouer"
    ],
    "denouee": [
        "denouer"
    ],
    "denouees": [
        "denouer"
    ],
    "denoues": [
        "denouer"
    ],
    "denoyautait": [
        "denoyauter"
    ],
    "denoyauter": [
        "denoyauter"
    ],
    "denoyauteur": [
        "denoyauteur"
    ],
    "denuda": [
        "denuder"
    ],
    "denudaient": [
        "denuder"
    ],
    "denudait": [
        "denuder"
    ],
    "denudant": [
        "denuder"
    ],
    "denudation": [
        "denudation"
    ],
    "denude": [
        "denude",
        "denuder"
    ],
    "denudent": [
        "denuder"
    ],
    "denuder": [
        "denuder"
    ],
    "denudera": [
        "denuder"
    ],
    "denuderait": [
        "denuder"
    ],
    "denuderent": [
        "denuder"
    ],
    "denudee": [
        "denude",
        "denuder"
    ],
    "denudees": [
        "denude",
        "denuder"
    ],
    "denudes": [
        "denude",
        "denuder"
    ],
    "denuement": [
        "denuement"
    ],
    "denue": [
        "denue",
        "denuer"
    ],
    "denuee": [
        "denue",
        "denuer"
    ],
    "denuees": [
        "denuer"
    ],
    "denues": [
        "denue",
        "denuer"
    ],
    "denegateurs": [
        "denegateur"
    ],
    "denegation": [
        "denegation"
    ],
    "denegations": [
        "denegation"
    ],
    "deodorant": [
        "deodorant"
    ],
    "deodorants": [
        "deodorant"
    ],
    "deontologie": [
        "deontologie"
    ],
    "deontologique": [
        "deontologique"
    ],
    "deontologiques": [
        "deontologique"
    ],
    "depaillee": [
        "depailler"
    ],
    "depaillees": [
        "depailler"
    ],
    "depannage": [
        "depannage"
    ],
    "depannages": [
        "depannage"
    ],
    "depannaient": [
        "depanner"
    ],
    "depannait": [
        "depanner"
    ],
    "depanne": [
        "depanner"
    ],
    "depannent": [
        "depanner"
    ],
    "depanner": [
        "depanner"
    ],
    "depannera": [
        "depanner"
    ],
    "depannerais": [
        "depanner"
    ],
    "depannerait": [
        "depanner"
    ],
    "depanneriez": [
        "depanner"
    ],
    "depanneront": [
        "depanner"
    ],
    "depanneur": [
        "depanneur"
    ],
    "depanneurs": [
        "depanneur"
    ],
    "depanneuse": [
        "depanneur"
    ],
    "depanneuses": [
        "depanneur"
    ],
    "depannons": [
        "depanner"
    ],
    "depannee": [
        "depanner"
    ],
    "depannes": [
        "depanner"
    ],
    "depaquetait": [
        "depaqueter"
    ],
    "deparaient": [
        "deparer"
    ],
    "deparait": [
        "deparer"
    ],
    "depare": [
        "deparer"
    ],
    "depareillaient": [
        "depareiller"
    ],
    "depareillait": [
        "depareiller"
    ],
    "depareiller": [
        "depareiller"
    ],
    "depareilleraient": [
        "depareiller"
    ],
    "depareille": [
        "depareiller",
        "depareille"
    ],
    "depareillee": [
        "depareiller",
        "depareille"
    ],
    "depareillees": [
        "depareiller",
        "depareille"
    ],
    "depareilles": [
        "depareiller",
        "depareille"
    ],
    "deparer": [
        "deparer"
    ],
    "deparerait": [
        "deparer"
    ],
    "deparie": [
        "deparier"
    ],
    "depariee": [
        "deparier"
    ],
    "depariees": [
        "deparier"
    ],
    "deparies": [
        "deparier"
    ],
    "deparlait": [
        "deparler"
    ],
    "deparler": [
        "deparler"
    ],
    "depart": [
        "departir",
        "depart"
    ],
    "departage": [
        "departager"
    ],
    "departageant": [
        "departager"
    ],
    "departager": [
        "departager"
    ],
    "departagera": [
        "departager"
    ],
    "departagions": [
        "departager"
    ],
    "departait": [
        "departir"
    ],
    "departement": [
        "departement"
    ],
    "departemental": [
        "departemental"
    ],
    "departementale": [
        "departemental",
        "departementale"
    ],
    "departementales": [
        "departemental",
        "departementale"
    ],
    "departementaux": [
        "departemental"
    ],
    "departements": [
        "departement"
    ],
    "departent": [
        "departir"
    ],
    "departi": [
        "departir"
    ],
    "departie": [
        "departir"
    ],
    "departir": [
        "departir"
    ],
    "departira": [
        "departir"
    ],
    "departirent": [
        "departir"
    ],
    "departis": [
        "departir"
    ],
    "departit": [
        "departir"
    ],
    "departs": [
        "depart"
    ],
    "deparat": [
        "deparer"
    ],
    "depassa": [
        "depasser"
    ],
    "depassai": [
        "depasser"
    ],
    "depassaient": [
        "depasser"
    ],
    "depassais": [
        "depasser"
    ],
    "depassait": [
        "depasser"
    ],
    "depassant": [
        "depassant",
        "depasser"
    ],
    "depasse": [
        "depasse",
        "depasser"
    ],
    "depassement": [
        "depassement"
    ],
    "depassements": [
        "depassement"
    ],
    "depassent": [
        "depasser"
    ],
    "depasser": [
        "depasser"
    ],
    "depassera": [
        "depasser"
    ],
    "depasserai": [
        "depasser"
    ],
    "depasseraient": [
        "depasser"
    ],
    "depasserais": [
        "depasser"
    ],
    "depasserait": [
        "depasser"
    ],
    "depasseras": [
        "depasser"
    ],
    "depasserions": [
        "depasser"
    ],
    "depasseront": [
        "depasser"
    ],
    "depasses": [
        "depasse",
        "depasser"
    ],
    "depassez": [
        "depasser"
    ],
    "depassiez": [
        "depasser"
    ],
    "depassionnons": [
        "depassionner"
    ],
    "depassions": [
        "depasser"
    ],
    "depassons": [
        "depasser"
    ],
    "depassames": [
        "depasser"
    ],
    "depassat": [
        "depasser"
    ],
    "depasserent": [
        "depasser"
    ],
    "depassee": [
        "depasse",
        "depasser"
    ],
    "depassees": [
        "depasse",
        "depasser"
    ],
    "depatouillait": [
        "depatouiller"
    ],
    "depatouille": [
        "depatouiller"
    ],
    "depatouiller": [
        "depatouiller"
    ],
    "depaver": [
        "depaver"
    ],
    "depaysaient": [
        "depayser"
    ],
    "depaysait": [
        "depayser"
    ],
    "depaysant": [
        "depaysant",
        "depayser"
    ],
    "depaysante": [
        "depaysant"
    ],
    "depaysantes": [
        "depaysant"
    ],
    "depayse": [
        "depayser"
    ],
    "depaysement": [
        "depaysement"
    ],
    "depaysements": [
        "depaysement"
    ],
    "depayser": [
        "depayser"
    ],
    "depaysera": [
        "depayser"
    ],
    "depaysee": [
        "depayser"
    ],
    "depayses": [
        "depayser"
    ],
    "depecer": [
        "depecer"
    ],
    "depeceur": [
        "depeceur"
    ],
    "depeceurs": [
        "depeceur"
    ],
    "depecez": [
        "depecer"
    ],
    "depecerent": [
        "depecer"
    ],
    "depece": [
        "depecer"
    ],
    "depecee": [
        "depecer"
    ],
    "depeces": [
        "depecer"
    ],
    "depeignaient": [
        "depeindre"
    ],
    "depeignais": [
        "depeindre"
    ],
    "depeignait": [
        "depeindre"
    ],
    "depeignant": [
        "depeigner",
        "depeindre"
    ],
    "depeigne": [
        "depeigner"
    ],
    "depeignent": [
        "depeindre"
    ],
    "depeignirent": [
        "depeindre"
    ],
    "depeignis": [
        "depeindre"
    ],
    "depeignit": [
        "depeindre"
    ],
    "depeignee": [
        "depeigner"
    ],
    "depeignes": [
        "depeigner"
    ],
    "depeindre": [
        "depeindre"
    ],
    "depeins": [
        "depeindre"
    ],
    "depeint": [
        "depeint",
        "depeindre"
    ],
    "depeinte": [
        "depeint",
        "depeindre"
    ],
    "depeintes": [
        "depeint"
    ],
    "depeints": [
        "depeint",
        "depeindre"
    ],
    "depenaillement": [
        "depenaillement"
    ],
    "depenaillements": [
        "depenaillement"
    ],
    "depenaille": [
        "depenaille"
    ],
    "depenaillee": [
        "depenaille"
    ],
    "depenaillees": [
        "depenaille"
    ],
    "depenailles": [
        "depenaille"
    ],
    "depend": [
        "dependre"
    ],
    "dependaient": [
        "dependre"
    ],
    "dependais": [
        "dependre"
    ],
    "dependait": [
        "dependre"
    ],
    "dependance": [
        "dependance"
    ],
    "dependances": [
        "dependance"
    ],
    "dependant": [
        "dependre",
        "dependant"
    ],
    "dependante": [
        "dependant"
    ],
    "dependantes": [
        "dependant"
    ],
    "dependants": [
        "dependant"
    ],
    "depende": [
        "dependre"
    ],
    "dependent": [
        "dependre"
    ],
    "dependeur": [
        "dependeur"
    ],
    "dependeurs": [
        "dependeur"
    ],
    "dependez": [
        "dependre"
    ],
    "dependions": [
        "dependre"
    ],
    "dependit": [
        "dependre"
    ],
    "dependons": [
        "dependre"
    ],
    "dependra": [
        "dependre"
    ],
    "dependraient": [
        "dependre"
    ],
    "dependrait": [
        "dependre"
    ],
    "dependre": [
        "dependre"
    ],
    "dependrez": [
        "dependre"
    ],
    "dependront": [
        "dependre"
    ],
    "depends": [
        "depend",
        "dependre"
    ],
    "dependu": [
        "dependre"
    ],
    "depens": [
        "depens"
    ],
    "depensa": [
        "depenser"
    ],
    "depensai": [
        "depenser"
    ],
    "depensaient": [
        "depenser"
    ],
    "depensais": [
        "depenser"
    ],
    "depensait": [
        "depenser"
    ],
    "depensant": [
        "depenser"
    ],
    "depense": [
        "depense",
        "depenser"
    ],
    "depensent": [
        "depenser"
    ],
    "depenser": [
        "depenser"
    ],
    "depensera": [
        "depenser"
    ],
    "depenserai": [
        "depenser"
    ],
    "depenseraient": [
        "depenser"
    ],
    "depenserais": [
        "depenser"
    ],
    "depenserait": [
        "depenser"
    ],
    "depenseras": [
        "depenser"
    ],
    "depenserez": [
        "depenser"
    ],
    "depenserions": [
        "depenser"
    ],
    "depenseront": [
        "depenser"
    ],
    "depenses": [
        "depense",
        "depenser"
    ],
    "depensez": [
        "depenser"
    ],
    "depensier": [
        "depensier"
    ],
    "depensiers": [
        "depensier"
    ],
    "depensiez": [
        "depenser"
    ],
    "depensiere": [
        "depensier"
    ],
    "depensons": [
        "depenser"
    ],
    "depensee": [
        "depenser"
    ],
    "depensees": [
        "depenser"
    ],
    "deperdition": [
        "deperdition"
    ],
    "deperditions": [
        "deperdition"
    ],
    "depersonnalisation": [
        "depersonnalisation"
    ],
    "depersonnaliser": [
        "depersonnaliser"
    ],
    "depersonnalise": [
        "depersonnaliser"
    ],
    "depersonnalisee": [
        "depersonnalise"
    ],
    "depeuplait": [
        "depeupler"
    ],
    "depeuple": [
        "depeupler",
        "depeuple"
    ],
    "depeuplent": [
        "depeupler"
    ],
    "depeupler": [
        "depeupler"
    ],
    "depeuplera": [
        "depeupler"
    ],
    "depeuplee": [
        "depeupler",
        "depeuple"
    ],
    "depeuplees": [
        "depeuple"
    ],
    "depeuples": [
        "depeupler",
        "depeuple"
    ],
    "depecage": [
        "depecage"
    ],
    "depecaient": [
        "depecer"
    ],
    "depecait": [
        "depecer"
    ],
    "depecant": [
        "depecer"
    ],
    "dephasage": [
        "dephasage"
    ],
    "dephase": [
        "dephase",
        "dephaser"
    ],
    "dephaseurs": [
        "dephaseur"
    ],
    "dephasee": [
        "dephase",
        "dephaser"
    ],
    "dephases": [
        "dephase",
        "dephaser"
    ],
    "depiautaient": [
        "depiauter"
    ],
    "depiautait": [
        "depiauter"
    ],
    "depiautant": [
        "depiauter"
    ],
    "depiaute": [
        "depiauter"
    ],
    "depiautent": [
        "depiauter"
    ],
    "depiauter": [
        "depiauter"
    ],
    "depiautera": [
        "depiauter"
    ],
    "depiauterent": [
        "depiauter"
    ],
    "depiautes": [
        "depiauter"
    ],
    "depieute": [
        "depieuter"
    ],
    "depigmentation": [
        "depigmentation"
    ],
    "depigmente": [
        "depigmenter"
    ],
    "depigmentes": [
        "depigmenter"
    ],
    "depilatoire": [
        "depilatoire"
    ],
    "depiler": [
        "depiler"
    ],
    "depiquage": [
        "depiquage"
    ],
    "depique": [
        "depiquer"
    ],
    "depiquer": [
        "depiquer"
    ],
    "depiques": [
        "depiquer"
    ],
    "depistage": [
        "depistage"
    ],
    "depistages": [
        "depistage"
    ],
    "depistait": [
        "depister"
    ],
    "depistant": [
        "depister"
    ],
    "depiste": [
        "depister"
    ],
    "depister": [
        "depister"
    ],
    "depit": [
        "depit"
    ],
    "depita": [
        "depiter"
    ],
    "depitait": [
        "depiter"
    ],
    "depiter": [
        "depiter"
    ],
    "depite": [
        "depite",
        "depiter"
    ],
    "depitee": [
        "depite",
        "depiter"
    ],
    "depites": [
        "depite",
        "depiter"
    ],
    "deplace": [
        "deplacer",
        "deplace"
    ],
    "deplacement": [
        "deplacement"
    ],
    "deplacements": [
        "deplacement"
    ],
    "deplacent": [
        "deplacer"
    ],
    "deplacer": [
        "deplacer"
    ],
    "deplacera": [
        "deplacer"
    ],
    "deplacerai": [
        "deplacer"
    ],
    "deplaceraient": [
        "deplacer"
    ],
    "deplacerait": [
        "deplacer"
    ],
    "deplaceras": [
        "deplacer"
    ],
    "deplacerez": [
        "deplacer"
    ],
    "deplacerons": [
        "deplacer"
    ],
    "deplaceront": [
        "deplacer"
    ],
    "deplaces": [
        "deplacer",
        "deplace"
    ],
    "deplacez": [
        "deplacer"
    ],
    "deplaciez": [
        "deplacer"
    ],
    "deplacions": [
        "deplacer"
    ],
    "deplacerent": [
        "deplacer"
    ],
    "deplacee": [
        "deplacer",
        "deplace"
    ],
    "deplacees": [
        "deplacer",
        "deplace"
    ],
    "deplaira": [
        "deplaire"
    ],
    "deplairaient": [
        "deplaire"
    ],
    "deplairait": [
        "deplaire"
    ],
    "deplaire": [
        "deplaire"
    ],
    "deplairont": [
        "deplaire"
    ],
    "deplais": [
        "deplaire"
    ],
    "deplaisaient": [
        "deplaire"
    ],
    "deplaisais": [
        "deplaire"
    ],
    "deplaisait": [
        "deplaire"
    ],
    "deplaisant": [
        "deplaire",
        "deplaisant"
    ],
    "deplaisante": [
        "deplaisant"
    ],
    "deplaisantes": [
        "deplaisant"
    ],
    "deplaisants": [
        "deplaisant"
    ],
    "deplaise": [
        "deplaire"
    ],
    "deplaisent": [
        "deplaire"
    ],
    "deplaisez": [
        "deplaire"
    ],
    "deplaisiez": [
        "deplaire"
    ],
    "deplaisir": [
        "deplaisir"
    ],
    "deplaisirs": [
        "deplaisir"
    ],
    "deplanque": [
        "deplanquer"
    ],
    "deplantoir": [
        "deplantoir"
    ],
    "deplanterent": [
        "deplanter"
    ],
    "deplaca": [
        "deplacer"
    ],
    "deplacai": [
        "deplacer"
    ],
    "deplacaient": [
        "deplacer"
    ],
    "deplacais": [
        "deplacer"
    ],
    "deplacait": [
        "deplacer"
    ],
    "deplacant": [
        "deplacer"
    ],
    "deplacons": [
        "deplacer"
    ],
    "deplacat": [
        "deplacer"
    ],
    "deplait": [
        "deplaire"
    ],
    "deplia": [
        "deplier"
    ],
    "depliable": [
        "depliable"
    ],
    "depliai": [
        "deplier"
    ],
    "depliaient": [
        "deplier"
    ],
    "depliais": [
        "deplier"
    ],
    "depliait": [
        "deplier"
    ],
    "depliant": [
        "depliant",
        "deplier"
    ],
    "depliante": [
        "depliant"
    ],
    "depliants": [
        "depliant"
    ],
    "deplie": [
        "deplier"
    ],
    "depliement": [
        "depliement"
    ],
    "deplient": [
        "deplier"
    ],
    "deplier": [
        "deplier"
    ],
    "deplies": [
        "deplier"
    ],
    "deplions": [
        "deplier"
    ],
    "deplissa": [
        "deplisser"
    ],
    "deplissaient": [
        "deplisser"
    ],
    "deplissait": [
        "deplisser"
    ],
    "deplisse": [
        "deplisser"
    ],
    "deplissent": [
        "deplisser"
    ],
    "deplisser": [
        "deplisser"
    ],
    "depliames": [
        "deplier"
    ],
    "deplierent": [
        "deplier"
    ],
    "depliee": [
        "deplier"
    ],
    "depliees": [
        "deplier"
    ],
    "deploie": [
        "deployer"
    ],
    "deploiement": [
        "deploiement"
    ],
    "deploiements": [
        "deploiement"
    ],
    "deploient": [
        "deployer"
    ],
    "deploiera": [
        "deployer"
    ],
    "deploierai": [
        "deployer"
    ],
    "deploieraient": [
        "deployer"
    ],
    "deploierait": [
        "deployer"
    ],
    "deploieras": [
        "deployer"
    ],
    "deploierez": [
        "deployer"
    ],
    "deploierons": [
        "deployer"
    ],
    "deploieront": [
        "deployer"
    ],
    "deploies": [
        "deployer"
    ],
    "deplombe": [
        "deplomber"
    ],
    "deplora": [
        "deplorer"
    ],
    "deplorable": [
        "deplorable"
    ],
    "deplorablement": [
        "deplorablement"
    ],
    "deplorables": [
        "deplorable"
    ],
    "deplorai": [
        "deplorer"
    ],
    "deploraient": [
        "deplorer"
    ],
    "deplorais": [
        "deplorer"
    ],
    "deplorait": [
        "deplorer"
    ],
    "deplorant": [
        "deplorer"
    ],
    "deploration": [
        "deploration"
    ],
    "deplore": [
        "deplorer"
    ],
    "deplorent": [
        "deplorer"
    ],
    "deplorer": [
        "deplorer"
    ],
    "deplorerais": [
        "deplorer"
    ],
    "deplorerait": [
        "deplorer"
    ],
    "deplorerons": [
        "deplorer"
    ],
    "deplorez": [
        "deplorer"
    ],
    "deplorions": [
        "deplorer"
    ],
    "deplorons": [
        "deplorer"
    ],
    "deplorerent": [
        "deplorer"
    ],
    "deploree": [
        "deplorer"
    ],
    "deplores": [
        "deplorer",
        "deplore"
    ],
    "deploya": [
        "deployer"
    ],
    "deployaient": [
        "deployer"
    ],
    "deployais": [
        "deployer"
    ],
    "deployait": [
        "deployer"
    ],
    "deployant": [
        "deployer"
    ],
    "deployasse": [
        "deployer"
    ],
    "deployer": [
        "deployer"
    ],
    "deployez": [
        "deployer"
    ],
    "deployions": [
        "deployer"
    ],
    "deployons": [
        "deployer"
    ],
    "deployat": [
        "deployer"
    ],
    "deployerent": [
        "deployer"
    ],
    "deploye": [
        "deploye",
        "deployer"
    ],
    "deployee": [
        "deploye",
        "deployer"
    ],
    "deployees": [
        "deploye",
        "deployer"
    ],
    "deployes": [
        "deploye",
        "deployer"
    ],
    "deplu": [
        "deplaire"
    ],
    "deplumait": [
        "deplumer"
    ],
    "deplume": [
        "deplume",
        "deplumer"
    ],
    "deplumer": [
        "deplumer"
    ],
    "deplumee": [
        "deplume",
        "deplumer"
    ],
    "deplumes": [
        "deplume",
        "deplumer"
    ],
    "deplurent": [
        "deplaire"
    ],
    "deplut": [
        "deplaire"
    ],
    "deplatre": [
        "deplatrer"
    ],
    "depoile": [
        "depoiler"
    ],
    "depoiler": [
        "depoiler"
    ],
    "depoilee": [
        "depoiler"
    ],
    "depoilees": [
        "depoiler"
    ],
    "depointees": [
        "depointer"
    ],
    "depoitraille": [
        "depoitraille",
        "depoitrailler"
    ],
    "depoitraillee": [
        "depoitraille"
    ],
    "depoitraillees": [
        "depoitraille"
    ],
    "depoitrailles": [
        "depoitraille"
    ],
    "depoli": [
        "depolir",
        "depoli"
    ],
    "depolie": [
        "depoli"
    ],
    "depolies": [
        "depolir",
        "depoli"
    ],
    "depolis": [
        "depolir",
        "depoli"
    ],
    "depolissait": [
        "depolir"
    ],
    "depolit": [
        "depolir"
    ],
    "depolitisant": [
        "depolitiser"
    ],
    "depolitise": [
        "depolitiser"
    ],
    "depolluer": [
        "depolluer"
    ],
    "depollution": [
        "depollution"
    ],
    "depopulation": [
        "depopulation"
    ],
    "deport": [
        "deport"
    ],
    "deporta": [
        "deporter"
    ],
    "deportaient": [
        "deporter"
    ],
    "deportais": [
        "deporter"
    ],
    "deportait": [
        "deporter"
    ],
    "deportant": [
        "deporter"
    ],
    "deportation": [
        "deportation"
    ],
    "deportations": [
        "deportation"
    ],
    "deporte": [
        "deporte",
        "deporter"
    ],
    "deportements": [
        "deportement"
    ],
    "deporter": [
        "deporter"
    ],
    "deporteront": [
        "deporter"
    ],
    "deportez": [
        "deporter"
    ],
    "deportee": [
        "deporte",
        "deporter"
    ],
    "deportees": [
        "deporte",
        "deporter"
    ],
    "deportes": [
        "deporte",
        "deporter"
    ],
    "deposa": [
        "deposer"
    ],
    "deposai": [
        "deposer"
    ],
    "deposaient": [
        "deposer"
    ],
    "deposais": [
        "deposer"
    ],
    "deposait": [
        "deposer"
    ],
    "deposant": [
        "deposer",
        "deposant"
    ],
    "depose": [
        "depose",
        "deposer"
    ],
    "deposent": [
        "deposer"
    ],
    "deposer": [
        "deposer"
    ],
    "deposera": [
        "deposer"
    ],
    "deposerai": [
        "deposer"
    ],
    "deposeraient": [
        "deposer"
    ],
    "deposerais": [
        "deposer"
    ],
    "deposerait": [
        "deposer"
    ],
    "deposeras": [
        "deposer"
    ],
    "deposerez": [
        "deposer"
    ],
    "deposerions": [
        "deposer"
    ],
    "deposerons": [
        "deposer"
    ],
    "deposeront": [
        "deposer"
    ],
    "deposes": [
        "depose",
        "deposer"
    ],
    "deposez": [
        "deposer"
    ],
    "deposiez": [
        "deposer"
    ],
    "deposions": [
        "deposer"
    ],
    "depositaire": [
        "depositaire"
    ],
    "depositaires": [
        "depositaire"
    ],
    "deposition": [
        "deposition"
    ],
    "depositions": [
        "deposition"
    ],
    "deposons": [
        "deposer"
    ],
    "depossession": [
        "depossession"
    ],
    "depossede": [
        "deposseder"
    ],
    "depossedais": [
        "deposseder"
    ],
    "depossedait": [
        "deposseder"
    ],
    "deposseder": [
        "deposseder"
    ],
    "depossedee": [
        "deposseder"
    ],
    "depossedees": [
        "deposseder"
    ],
    "depossedes": [
        "deposseder"
    ],
    "deposames": [
        "deposer"
    ],
    "deposat": [
        "deposer"
    ],
    "deposerent": [
        "deposer"
    ],
    "deposee": [
        "deposer"
    ],
    "deposees": [
        "deposer"
    ],
    "depote": [
        "depoter"
    ],
    "depotent": [
        "depoter"
    ],
    "depoter": [
        "depoter"
    ],
    "depotoir": [
        "depotoir"
    ],
    "depoudrer": [
        "depoudrer"
    ],
    "depouilla": [
        "depouiller"
    ],
    "depouillage": [
        "depouillage"
    ],
    "depouillaient": [
        "depouiller"
    ],
    "depouillais": [
        "depouiller"
    ],
    "depouillait": [
        "depouiller"
    ],
    "depouillant": [
        "depouiller"
    ],
    "depouille": [
        "depouille",
        "depouiller"
    ],
    "depouillement": [
        "depouillement"
    ],
    "depouillements": [
        "depouillement"
    ],
    "depouillent": [
        "depouiller"
    ],
    "depouiller": [
        "depouiller"
    ],
    "depouillera": [
        "depouiller"
    ],
    "depouillerais": [
        "depouiller"
    ],
    "depouillerait": [
        "depouiller"
    ],
    "depouillerez": [
        "depouiller"
    ],
    "depouilles": [
        "depouille",
        "depouiller"
    ],
    "depouillez": [
        "depouiller"
    ],
    "depouillons": [
        "depouiller"
    ],
    "depouillat": [
        "depouiller"
    ],
    "depouillerent": [
        "depouiller"
    ],
    "depouillee": [
        "depouille",
        "depouiller"
    ],
    "depouillees": [
        "depouille",
        "depouiller"
    ],
    "depourvu": [
        "depourvoir",
        "depourvu"
    ],
    "depourvue": [
        "depourvoir",
        "depourvu"
    ],
    "depourvues": [
        "depourvoir",
        "depourvu"
    ],
    "depourvus": [
        "depourvoir",
        "depourvu"
    ],
    "depoussiere": [
        "depoussierer"
    ],
    "depoussierage": [
        "depoussierage"
    ],
    "depoussieraient": [
        "depoussierer"
    ],
    "depoussierant": [
        "depoussierer"
    ],
    "depoussierer": [
        "depoussierer"
    ],
    "depoussierez": [
        "depoussierer"
    ],
    "depoetisent": [
        "depoetiser"
    ],
    "depravation": [
        "depravation"
    ],
    "depravations": [
        "depravation"
    ],
    "depraver": [
        "depraver"
    ],
    "depravons": [
        "depraver"
    ],
    "deprave": [
        "depraver",
        "deprave"
    ],
    "depravee": [
        "depraver",
        "deprave"
    ],
    "depravees": [
        "deprave"
    ],
    "depraves": [
        "depraver",
        "deprave"
    ],
    "deprenais": [
        "deprendre"
    ],
    "deprenait": [
        "deprendre"
    ],
    "deprend": [
        "deprendre"
    ],
    "deprendre": [
        "deprendre"
    ],
    "deprendront": [
        "deprendre"
    ],
    "depressif": [
        "depressif"
    ],
    "depressifs": [
        "depressif"
    ],
    "depression": [
        "depression"
    ],
    "depressionnaire": [
        "depressionnaire"
    ],
    "depressions": [
        "depression"
    ],
    "depressive": [
        "depressif"
    ],
    "depressives": [
        "depressive",
        "depressif"
    ],
    "depressurisait": [
        "depressuriser"
    ],
    "depressurisation": [
        "depressurisation"
    ],
    "depressurise": [
        "depressuriser"
    ],
    "depressuriser": [
        "depressuriser"
    ],
    "depressurises": [
        "depressuriser"
    ],
    "deprima": [
        "deprimer"
    ],
    "deprimais": [
        "deprimer"
    ],
    "deprimait": [
        "deprimer"
    ],
    "deprimant": [
        "deprimer",
        "deprimant"
    ],
    "deprimante": [
        "deprimant"
    ],
    "deprimantes": [
        "deprimant"
    ],
    "deprimants": [
        "deprimant"
    ],
    "deprime": [
        "deprime",
        "deprimer"
    ],
    "depriment": [
        "deprimer"
    ],
    "deprimer": [
        "deprimer"
    ],
    "deprimerais": [
        "deprimer"
    ],
    "deprimerait": [
        "deprimer"
    ],
    "deprimes": [
        "deprime",
        "deprimer"
    ],
    "deprimez": [
        "deprimer"
    ],
    "deprimee": [
        "deprimer",
        "deprime"
    ],
    "deprimees": [
        "deprimer",
        "deprime"
    ],
    "deprirent": [
        "deprendre"
    ],
    "depris": [
        "deprendre"
    ],
    "deprit": [
        "deprendre"
    ],
    "deprogrammation": [
        "deprogrammation"
    ],
    "deprogrammer": [
        "deprogrammer"
    ],
    "deprogrammez": [
        "deprogrammer"
    ],
    "deprogramme": [
        "deprogrammer"
    ],
    "deprogrammee": [
        "deprogrammer"
    ],
    "depreciait": [
        "deprecier"
    ],
    "depreciant": [
        "deprecier"
    ],
    "depreciation": [
        "depreciation"
    ],
    "deprecie": [
        "deprecier"
    ],
    "deprecier": [
        "deprecier"
    ],
    "deprecies": [
        "deprecier"
    ],
    "depreciez": [
        "deprecier"
    ],
    "depreciiez": [
        "deprecier"
    ],
    "depreciee": [
        "deprecier"
    ],
    "depredateur": [
        "depredateur"
    ],
    "depredateurs": [
        "depredateur"
    ],
    "depredation": [
        "depredation"
    ],
    "depredations": [
        "depredation"
    ],
    "depucela": [
        "depuceler"
    ],
    "depucelage": [
        "depucelage"
    ],
    "depucelages": [
        "depucelage"
    ],
    "depuceler": [
        "depuceler"
    ],
    "depuceleur": [
        "depuceleur"
    ],
    "depuceleurs": [
        "depuceleur"
    ],
    "depucelle": [
        "depuceler"
    ],
    "depucellera": [
        "depuceler"
    ],
    "depucelons": [
        "depuceler"
    ],
    "depucele": [
        "depuceler"
    ],
    "depucelee": [
        "depuceler"
    ],
    "depulpe": [
        "depulper"
    ],
    "depuratifs": [
        "depuratif"
    ],
    "depures": [
        "depurer"
    ],
    "deputation": [
        "deputation"
    ],
    "deputations": [
        "deputation"
    ],
    "deputer": [
        "deputer"
    ],
    "deputerent": [
        "deputer"
    ],
    "depute": [
        "depute"
    ],
    "deputee": [
        "depute",
        "deputer"
    ],
    "deputes": [
        "depute"
    ],
    "depecements": [
        "depecement"
    ],
    "depecent": [
        "depecer"
    ],
    "depecera": [
        "depecer"
    ],
    "depecerai": [
        "depecer"
    ],
    "depeceraient": [
        "depecer"
    ],
    "depenaliser": [
        "depenaliser"
    ],
    "deperi": [
        "deperir"
    ],
    "deperir": [
        "deperir"
    ],
    "deperira": [
        "deperir"
    ],
    "deperiraient": [
        "deperir"
    ],
    "deperirait": [
        "deperir"
    ],
    "deperiront": [
        "deperir"
    ],
    "deperis": [
        "deperir"
    ],
    "deperissaient": [
        "deperir"
    ],
    "deperissais": [
        "deperir"
    ],
    "deperissait": [
        "deperir"
    ],
    "deperisse": [
        "deperir"
    ],
    "deperissement": [
        "deperissement"
    ],
    "deperissent": [
        "deperir"
    ],
    "deperit": [
        "deperir"
    ],
    "depecha": [
        "depecher"
    ],
    "depechai": [
        "depecher"
    ],
    "depechaient": [
        "depecher"
    ],
    "depechais": [
        "depecher"
    ],
    "depechait": [
        "depecher"
    ],
    "depechant": [
        "depecher"
    ],
    "depeche": [
        "depeche",
        "depecher"
    ],
    "depechent": [
        "depecher"
    ],
    "depecher": [
        "depecher"
    ],
    "depecherais": [
        "depecher"
    ],
    "depecherons": [
        "depecher"
    ],
    "depeches": [
        "depeche",
        "depecher"
    ],
    "depechez": [
        "depecher"
    ],
    "depechions": [
        "depecher"
    ],
    "depechons": [
        "depecher"
    ],
    "depechat": [
        "depecher"
    ],
    "depecherent": [
        "depecher"
    ],
    "depechee": [
        "depecher"
    ],
    "depechees": [
        "depecher"
    ],
    "depetrer": [
        "depetrer"
    ],
    "depetre": [
        "depetrer"
    ],
    "depetree": [
        "depetrer"
    ],
    "depetres": [
        "depetrer"
    ],
    "depot": [
        "depot"
    ],
    "depots": [
        "depot"
    ],
    "dequalifier": [
        "dequalifier"
    ],
    "dequiller": [
        "dequiller"
    ],
    "dequille": [
        "dequiller"
    ],
    "dequilles": [
        "dequiller"
    ],
    "deracina": [
        "deraciner"
    ],
    "deracinaient": [
        "deraciner"
    ],
    "deracinais": [
        "deraciner"
    ],
    "deracinait": [
        "deraciner"
    ],
    "deracinant": [
        "deracinant"
    ],
    "deracine": [
        "deracine",
        "deraciner"
    ],
    "deracinement": [
        "deracinement"
    ],
    "deracinent": [
        "deraciner"
    ],
    "deraciner": [
        "deraciner"
    ],
    "deracinerait": [
        "deraciner"
    ],
    "deracinee": [
        "deracine",
        "deraciner"
    ],
    "deracinees": [
        "deracine",
        "deraciner"
    ],
    "deracines": [
        "deracine",
        "deraciner"
    ],
    "derailla": [
        "derailler"
    ],
    "deraillaient": [
        "derailler"
    ],
    "deraillais": [
        "derailler"
    ],
    "deraillait": [
        "derailler"
    ],
    "deraillant": [
        "derailler"
    ],
    "deraille": [
        "derailler"
    ],
    "deraillement": [
        "deraillement"
    ],
    "deraillements": [
        "deraillement"
    ],
    "deraillent": [
        "derailler"
    ],
    "derailler": [
        "derailler"
    ],
    "deraillera": [
        "derailler"
    ],
    "derailles": [
        "derailler"
    ],
    "derailleur": [
        "derailleur"
    ],
    "deraillez": [
        "derailler"
    ],
    "deraison": [
        "deraison"
    ],
    "deraisonnable": [
        "deraisonnable"
    ],
    "deraisonnablement": [
        "deraisonnablement"
    ],
    "deraisonnables": [
        "deraisonnable"
    ],
    "deraisonnait": [
        "deraisonner"
    ],
    "deraisonne": [
        "deraisonner"
    ],
    "deraisonner": [
        "deraisonner"
    ],
    "deraisonnes": [
        "deraisonner"
    ],
    "deraisonnez": [
        "deraisonner"
    ],
    "deraisons": [
        "deraison"
    ],
    "derange": [
        "deranger",
        "derange"
    ],
    "derangea": [
        "deranger"
    ],
    "derangeaient": [
        "deranger"
    ],
    "derangeais": [
        "deranger"
    ],
    "derangeait": [
        "deranger"
    ],
    "derangeant": [
        "deranger",
        "derangeant"
    ],
    "derangeante": [
        "derangeant"
    ],
    "derangeantes": [
        "derangeant"
    ],
    "derangeants": [
        "derangeant"
    ],
    "derangeassent": [
        "deranger"
    ],
    "derangement": [
        "derangement"
    ],
    "derangements": [
        "derangement"
    ],
    "derangent": [
        "deranger"
    ],
    "derangeons": [
        "deranger"
    ],
    "deranger": [
        "deranger"
    ],
    "derangera": [
        "deranger"
    ],
    "derangerai": [
        "deranger"
    ],
    "derangeraient": [
        "deranger"
    ],
    "derangerais": [
        "deranger"
    ],
    "derangerait": [
        "deranger"
    ],
    "derangeras": [
        "deranger"
    ],
    "derangerez": [
        "deranger"
    ],
    "derangerons": [
        "deranger"
    ],
    "deranges": [
        "deranger",
        "derange"
    ],
    "derangez": [
        "deranger"
    ],
    "derangeat": [
        "deranger"
    ],
    "derangiez": [
        "deranger"
    ],
    "derangions": [
        "deranger"
    ],
    "derangee": [
        "deranger",
        "derange"
    ],
    "derangees": [
        "deranger",
        "derange"
    ],
    "derapa": [
        "deraper"
    ],
    "derapage": [
        "derapage"
    ],
    "derapages": [
        "derapage"
    ],
    "derapai": [
        "deraper"
    ],
    "derapaient": [
        "deraper"
    ],
    "derapait": [
        "deraper"
    ],
    "derapant": [
        "deraper"
    ],
    "derape": [
        "deraper"
    ],
    "derapent": [
        "deraper"
    ],
    "deraper": [
        "deraper"
    ],
    "deraperont": [
        "deraper"
    ],
    "derapes": [
        "deraper"
    ],
    "derapez": [
        "deraper"
    ],
    "deratisation": [
        "deratisation"
    ],
    "deratisations": [
        "deratisation"
    ],
    "deratiser": [
        "deratiser"
    ],
    "deratise": [
        "deratiser"
    ],
    "deratisee": [
        "deratiser"
    ],
    "deratises": [
        "deratiser"
    ],
    "derate": [
        "derate"
    ],
    "deratees": [
        "derate"
    ],
    "derates": [
        "derate"
    ],
    "derayer": [
        "derayer"
    ],
    "deresponsabilisation": [
        "deresponsabilisation"
    ],
    "derida": [
        "derider"
    ],
    "deridait": [
        "derider"
    ],
    "deride": [
        "derider"
    ],
    "derider": [
        "derider"
    ],
    "deridera": [
        "derider"
    ],
    "deriderait": [
        "derider"
    ],
    "deridez": [
        "derider"
    ],
    "derision": [
        "derision"
    ],
    "derisoire": [
        "derisoire"
    ],
    "derisoirement": [
        "derisoirement"
    ],
    "derisoires": [
        "derisoire"
    ],
    "deriva": [
        "deriver"
    ],
    "derivaient": [
        "deriver"
    ],
    "derivais": [
        "deriver"
    ],
    "derivait": [
        "deriver"
    ],
    "derivant": [
        "deriver",
        "derivant"
    ],
    "derivante": [
        "derivant"
    ],
    "derivatif": [
        "derivatif"
    ],
    "derivatifs": [
        "derivatif"
    ],
    "derivation": [
        "derivation"
    ],
    "derivations": [
        "derivation"
    ],
    "derive": [
        "derive",
        "deriver"
    ],
    "derivent": [
        "deriver"
    ],
    "deriver": [
        "deriver"
    ],
    "deriverai": [
        "deriver"
    ],
    "deriveras": [
        "deriver"
    ],
    "derives": [
        "derive",
        "deriver"
    ],
    "deriveur": [
        "deriveur"
    ],
    "deriveurs": [
        "deriveur"
    ],
    "derivez": [
        "deriver"
    ],
    "derivions": [
        "deriver"
    ],
    "derivons": [
        "deriver"
    ],
    "derivee": [
        "derive",
        "deriver"
    ],
    "derivees": [
        "derive",
        "deriver"
    ],
    "deroba": [
        "derober"
    ],
    "derobade": [
        "derobade"
    ],
    "derobades": [
        "derobade"
    ],
    "derobai": [
        "derober"
    ],
    "derobaient": [
        "derober"
    ],
    "derobais": [
        "derober"
    ],
    "derobait": [
        "derober"
    ],
    "derobant": [
        "derober"
    ],
    "derobe": [
        "derober",
        "derobe"
    ],
    "derobent": [
        "derober"
    ],
    "derober": [
        "derober"
    ],
    "derobera": [
        "derober"
    ],
    "deroberaient": [
        "derober"
    ],
    "deroberait": [
        "derober"
    ],
    "deroberons": [
        "derober"
    ],
    "derobes": [
        "derober",
        "derobe"
    ],
    "derobeuse": [
        "derobeur"
    ],
    "derobez": [
        "derober"
    ],
    "derobiez": [
        "derober"
    ],
    "derobions": [
        "derober"
    ],
    "derobons": [
        "derober"
    ],
    "derobat": [
        "derober"
    ],
    "deroberent": [
        "derober"
    ],
    "derobee": [
        "derober",
        "derobe"
    ],
    "derobees": [
        "derober",
        "derobe"
    ],
    "derogation": [
        "derogation"
    ],
    "derogations": [
        "derogation"
    ],
    "derogatoire": [
        "derogatoire"
    ],
    "deroge": [
        "deroger"
    ],
    "derogea": [
        "deroger"
    ],
    "derogeait": [
        "deroger"
    ],
    "derogent": [
        "deroger"
    ],
    "deroger": [
        "deroger"
    ],
    "derogera": [
        "deroger"
    ],
    "derogerait": [
        "deroger"
    ],
    "derouillaient": [
        "derouiller"
    ],
    "derouillais": [
        "derouiller"
    ],
    "derouillait": [
        "derouiller"
    ],
    "derouillant": [
        "derouiller"
    ],
    "derouille": [
        "derouiller"
    ],
    "derouillement": [
        "derouillement"
    ],
    "derouillent": [
        "derouiller"
    ],
    "derouiller": [
        "derouiller"
    ],
    "derouillera": [
        "derouiller"
    ],
    "derouillerai": [
        "derouiller"
    ],
    "derouillerais": [
        "derouiller"
    ],
    "derouillerait": [
        "derouiller"
    ],
    "derouilles": [
        "derouiller"
    ],
    "derouillez": [
        "derouiller"
    ],
    "derouillee": [
        "derouiller",
        "derouillee"
    ],
    "derouillees": [
        "derouillee"
    ],
    "deroula": [
        "derouler"
    ],
    "deroulai": [
        "derouler"
    ],
    "deroulaient": [
        "derouler"
    ],
    "deroulais": [
        "derouler"
    ],
    "deroulait": [
        "derouler"
    ],
    "deroulant": [
        "derouler",
        "deroulant"
    ],
    "deroule": [
        "derouler"
    ],
    "deroulement": [
        "deroulement"
    ],
    "deroulements": [
        "deroulement"
    ],
    "deroulent": [
        "derouler"
    ],
    "derouler": [
        "derouler"
    ],
    "deroulera": [
        "derouler"
    ],
    "derouleraient": [
        "derouler"
    ],
    "deroulerait": [
        "derouler"
    ],
    "derouleront": [
        "derouler"
    ],
    "derouleur": [
        "derouleur"
    ],
    "derouleurs": [
        "derouleur"
    ],
    "derouleuse": [
        "derouleur"
    ],
    "deroulez": [
        "derouler"
    ],
    "deroulions": [
        "derouler"
    ],
    "deroulat": [
        "derouler"
    ],
    "deroulerent": [
        "derouler"
    ],
    "deroulee": [
        "derouler"
    ],
    "deroulees": [
        "derouler"
    ],
    "deroules": [
        "derouler"
    ],
    "derouta": [
        "derouter"
    ],
    "deroutage": [
        "deroutage"
    ],
    "deroutaient": [
        "derouter"
    ],
    "deroutait": [
        "derouter"
    ],
    "deroutant": [
        "derouter",
        "deroutant"
    ],
    "deroutante": [
        "deroutant"
    ],
    "deroutantes": [
        "deroutant"
    ],
    "deroutants": [
        "deroutant"
    ],
    "deroute": [
        "derouter",
        "deroute"
    ],
    "deroutement": [
        "deroutement"
    ],
    "deroutent": [
        "derouter"
    ],
    "derouter": [
        "derouter"
    ],
    "deroutera": [
        "derouter"
    ],
    "deroutes": [
        "derouter",
        "deroute"
    ],
    "deroutez": [
        "derouter"
    ],
    "derouterent": [
        "derouter"
    ],
    "deroutee": [
        "derouter"
    ],
    "deroutees": [
        "derouter"
    ],
    "deregle": [
        "deregle",
        "deregler"
    ],
    "dereglement": [
        "dereglement"
    ],
    "dereglements": [
        "dereglement"
    ],
    "dereglent": [
        "deregler"
    ],
    "derealisaient": [
        "derealiser"
    ],
    "dereglage": [
        "dereglage"
    ],
    "dereglait": [
        "deregler"
    ],
    "dereglant": [
        "deregler"
    ],
    "dereglementation": [
        "dereglementation"
    ],
    "deregler": [
        "deregler"
    ],
    "dereglee": [
        "deregle",
        "deregler"
    ],
    "dereglees": [
        "deregle",
        "deregler"
    ],
    "deregles": [
        "deregle",
        "deregler"
    ],
    "deregulation": [
        "deregulation"
    ],
    "dereguler": [
        "dereguler"
    ],
    "dereliction": [
        "dereliction"
    ],
    "desabonna": [
        "desabonner"
    ],
    "desabonnements": [
        "desabonnement"
    ],
    "desabusement": [
        "desabusement"
    ],
    "desabuser": [
        "desabuser"
    ],
    "desabuse": [
        "desabuser",
        "desabuse"
    ],
    "desabusee": [
        "desabuser",
        "desabuse"
    ],
    "desabusees": [
        "desabuser",
        "desabuse"
    ],
    "desabuses": [
        "desabuser",
        "desabuse"
    ],
    "desaccord": [
        "desaccord"
    ],
    "desaccorda": [
        "desaccorder"
    ],
    "desaccordaient": [
        "desaccorder"
    ],
    "desaccordent": [
        "desaccorder"
    ],
    "desaccorder": [
        "desaccorder"
    ],
    "desaccords": [
        "desaccord"
    ],
    "desaccorde": [
        "desaccorder"
    ],
    "desaccordee": [
        "desaccorder"
    ],
    "desaccordees": [
        "desaccorder"
    ],
    "desaccordes": [
        "desaccorder"
    ],
    "desaccoupler": [
        "desaccoupler"
    ],
    "desaccoutuma": [
        "desaccoutumer"
    ],
    "desaccoutumer": [
        "desaccoutumer"
    ],
    "desacralisation": [
        "desacralisation"
    ],
    "desacraliser": [
        "desacraliser"
    ],
    "desacralise": [
        "desacraliser"
    ],
    "desacralisee": [
        "desacraliser"
    ],
    "desactivation": [
        "desactivation"
    ],
    "desactive": [
        "desactiver"
    ],
    "desactiver": [
        "desactiver"
    ],
    "desactiverai": [
        "desactiver"
    ],
    "desactiveront": [
        "desactiver"
    ],
    "desactives": [
        "desactiver"
    ],
    "desactivez": [
        "desactiver"
    ],
    "desactivons": [
        "desactiver"
    ],
    "desactivee": [
        "desactiver"
    ],
    "desactivees": [
        "desactiver"
    ],
    "desadaptee": [
        "desadapter"
    ],
    "desadopter": [
        "desadopter"
    ],
    "desaffectation": [
        "desaffectation"
    ],
    "desaffecter": [
        "desaffecter"
    ],
    "desaffection": [
        "desaffection"
    ],
    "desaffecte": [
        "desaffecter",
        "desaffecte"
    ],
    "desaffectee": [
        "desaffecter",
        "desaffecte"
    ],
    "desaffectees": [
        "desaffecter",
        "desaffecte"
    ],
    "desaffectes": [
        "desaffecter",
        "desaffecte"
    ],
    "desagrege": [
        "desagreger"
    ],
    "desagregent": [
        "desagreger"
    ],
    "desagreable": [
        "desagreable"
    ],
    "desagreablement": [
        "desagreablement"
    ],
    "desagreables": [
        "desagreable"
    ],
    "desagregation": [
        "desagregation"
    ],
    "desagregeait": [
        "desagreger"
    ],
    "desagregeant": [
        "desagreger"
    ],
    "desagreger": [
        "desagreger"
    ],
    "desagregerent": [
        "desagreger"
    ],
    "desagregee": [
        "desagreger"
    ],
    "desagreges": [
        "desagreger"
    ],
    "desagrement": [
        "desagrement"
    ],
    "desagrements": [
        "desagrement"
    ],
    "desaimee": [
        "desaimer"
    ],
    "desajustes": [
        "desajuster"
    ],
    "desalinisation": [
        "desalinisation"
    ],
    "desalienation": [
        "desalienation"
    ],
    "desaltere": [
        "desalterer"
    ],
    "desaltera": [
        "desalterer"
    ],
    "desalteraient": [
        "desalterer"
    ],
    "desalterait": [
        "desalterer"
    ],
    "desalterant": [
        "desalterer"
    ],
    "desalterante": [
        "desalterant"
    ],
    "desalterer": [
        "desalterer"
    ],
    "desalterat": [
        "desalterer"
    ],
    "desalteres": [
        "desalterer"
    ],
    "desamiantage": [
        "desamiantage"
    ],
    "desaminase": [
        "desaminase"
    ],
    "desamorce": [
        "desamorcer"
    ],
    "desamorcent": [
        "desamorcer"
    ],
    "desamorcer": [
        "desamorcer"
    ],
    "desamorcera": [
        "desamorcer"
    ],
    "desamorcerez": [
        "desamorcer"
    ],
    "desamorcerons": [
        "desamorcer"
    ],
    "desamorcez": [
        "desamorcer"
    ],
    "desamorcee": [
        "desamorcer"
    ],
    "desamorcees": [
        "desamorcer"
    ],
    "desamorces": [
        "desamorcer"
    ],
    "desamorcage": [
        "desamorcage"
    ],
    "desamorcait": [
        "desamorcer"
    ],
    "desamorcant": [
        "desamorcer"
    ],
    "desamour": [
        "desamour"
    ],
    "desangler": [
        "desangler"
    ],
    "desape": [
        "desaper"
    ],
    "desapent": [
        "desaper"
    ],
    "desaper": [
        "desaper"
    ],
    "desapeurer": [
        "desapeurer"
    ],
    "desapez": [
        "desaper"
    ],
    "desappointait": [
        "desappointer"
    ],
    "desappointement": [
        "desappointement"
    ],
    "desappointements": [
        "desappointement"
    ],
    "desappointer": [
        "desappointer"
    ],
    "desappointe": [
        "desappointe",
        "desappointer"
    ],
    "desappointee": [
        "desappointe",
        "desappointer"
    ],
    "desappointes": [
        "desappointe",
        "desappointer"
    ],
    "desapprenais": [
        "desapprendre"
    ],
    "desapprenant": [
        "desapprendre"
    ],
    "desapprendre": [
        "desapprendre"
    ],
    "desapprenne": [
        "desapprendre"
    ],
    "desapprirent": [
        "desapprendre"
    ],
    "desappris": [
        "desapprendre"
    ],
    "desapprit": [
        "desapprendre"
    ],
    "desapprobateur": [
        "desapprobateur"
    ],
    "desapprobateurs": [
        "desapprobateur"
    ],
    "desapprobation": [
        "desapprobation"
    ],
    "desapprobatrice": [
        "desapprobateur"
    ],
    "desapprobatrices": [
        "desapprobateur"
    ],
    "desapprouva": [
        "desapprouver"
    ],
    "desapprouvaient": [
        "desapprouver"
    ],
    "desapprouvais": [
        "desapprouver"
    ],
    "desapprouvait": [
        "desapprouver"
    ],
    "desapprouvant": [
        "desapprouver"
    ],
    "desapprouve": [
        "desapprouver"
    ],
    "desapprouvent": [
        "desapprouver"
    ],
    "desapprouver": [
        "desapprouver"
    ],
    "desapprouvera": [
        "desapprouver"
    ],
    "desapprouverait": [
        "desapprouver"
    ],
    "desapprouverez": [
        "desapprouver"
    ],
    "desapprouves": [
        "desapprouver"
    ],
    "desapprouvez": [
        "desapprouver"
    ],
    "desapprouviez": [
        "desapprouver"
    ],
    "desapprouvat": [
        "desapprouver"
    ],
    "desapprouvee": [
        "desapprouver"
    ],
    "desargente": [
        "desargenter",
        "desargente"
    ],
    "desargentees": [
        "desargente"
    ],
    "desargentes": [
        "desargenter",
        "desargente"
    ],
    "desarma": [
        "desarmer"
    ],
    "desarmai": [
        "desarmer"
    ],
    "desarmaient": [
        "desarmer"
    ],
    "desarmait": [
        "desarmer"
    ],
    "desarmant": [
        "desarmant",
        "desarmer"
    ],
    "desarmante": [
        "desarmant"
    ],
    "desarmants": [
        "desarmant"
    ],
    "desarme": [
        "desarme",
        "desarmer"
    ],
    "desarmement": [
        "desarmement"
    ],
    "desarment": [
        "desarmer"
    ],
    "desarmer": [
        "desarmer"
    ],
    "desarmera": [
        "desarmer"
    ],
    "desarmez": [
        "desarmer"
    ],
    "desarmerent": [
        "desarmer"
    ],
    "desarmee": [
        "desarme",
        "desarmer"
    ],
    "desarmees": [
        "desarme",
        "desarmer"
    ],
    "desarmes": [
        "desarme",
        "desarmer"
    ],
    "desarrimage": [
        "desarrimage"
    ],
    "desarrimez": [
        "desarrimer"
    ],
    "desarrime": [
        "desarrimer"
    ],
    "desarroi": [
        "desarroi"
    ],
    "desarrois": [
        "desarroi"
    ],
    "desarticula": [
        "desarticuler"
    ],
    "desarticulait": [
        "desarticuler"
    ],
    "desarticulant": [
        "desarticuler"
    ],
    "desarticulation": [
        "desarticulation"
    ],
    "desarticulent": [
        "desarticuler"
    ],
    "desarticuler": [
        "desarticuler"
    ],
    "desarticulera": [
        "desarticuler"
    ],
    "desarticule": [
        "desarticuler"
    ],
    "desarticulee": [
        "desarticuler"
    ],
    "desarticulees": [
        "desarticuler"
    ],
    "desarticules": [
        "desarticuler"
    ],
    "desarconna": [
        "desarconner"
    ],
    "desarconnaient": [
        "desarconner"
    ],
    "desarconnait": [
        "desarconner"
    ],
    "desarconne": [
        "desarconner",
        "desarconne"
    ],
    "desarconner": [
        "desarconner"
    ],
    "desarconnee": [
        "desarconner",
        "desarconne"
    ],
    "desarconnes": [
        "desarconner",
        "desarconne"
    ],
    "desassemble": [
        "desassembler"
    ],
    "desassembler": [
        "desassembler"
    ],
    "desassortis": [
        "desassorti",
        "desassortir"
    ],
    "desastre": [
        "desastre"
    ],
    "desastres": [
        "desastre"
    ],
    "desastreuse": [
        "desastreux"
    ],
    "desastreusement": [
        "desastreusement"
    ],
    "desastreuses": [
        "desastreux"
    ],
    "desastreux": [
        "desastreux"
    ],
    "desavantage": [
        "desavantage",
        "desavantager"
    ],
    "desavantageaient": [
        "desavantager"
    ],
    "desavantageait": [
        "desavantager"
    ],
    "desavantager": [
        "desavantager"
    ],
    "desavantages": [
        "desavantage",
        "desavantager"
    ],
    "desavantageuse": [
        "desavantageux"
    ],
    "desaveu": [
        "desaveu"
    ],
    "desaveux": [
        "desaveux"
    ],
    "desavoua": [
        "desavouer"
    ],
    "desavouait": [
        "desavouer"
    ],
    "desavouant": [
        "desavouer"
    ],
    "desavoue": [
        "desavouer"
    ],
    "desavouent": [
        "desavouer"
    ],
    "desavouer": [
        "desavouer"
    ],
    "desavoueraient": [
        "desavouer"
    ],
    "desavouerons": [
        "desavouer"
    ],
    "desavouez": [
        "desavouer"
    ],
    "desavouat": [
        "desavouer"
    ],
    "desavouee": [
        "desavouer"
    ],
    "desavoues": [
        "desavouer"
    ],
    "desaxait": [
        "desaxer"
    ],
    "desaxant": [
        "desaxer"
    ],
    "desaxe": [
        "desaxe",
        "desaxer"
    ],
    "desaxement": [
        "desaxement"
    ],
    "desaxee": [
        "desaxe",
        "desaxer"
    ],
    "desaxees": [
        "desaxe"
    ],
    "desaxes": [
        "desaxe",
        "desaxer"
    ],
    "descolarise": [
        "descolariser"
    ],
    "desembourber": [
        "desembourber"
    ],
    "desembourbee": [
        "desembourber"
    ],
    "desembrouiller": [
        "desembrouiller"
    ],
    "desembuer": [
        "desembuer"
    ],
    "desemparait": [
        "desemparer"
    ],
    "desemparer": [
        "desemparer"
    ],
    "desempare": [
        "desempare",
        "desemparer"
    ],
    "desemparee": [
        "desempare",
        "desemparer"
    ],
    "desemparees": [
        "desempare"
    ],
    "desempares": [
        "desempare",
        "desemparer"
    ],
    "desempenne": [
        "desempenner"
    ],
    "desempierraient": [
        "desempierrer"
    ],
    "desemplissaient": [
        "desemplir"
    ],
    "desemplissait": [
        "desemplir"
    ],
    "desemplit": [
        "desemplir"
    ],
    "desenchanta": [
        "desenchanter"
    ],
    "desenchantant": [
        "desenchanter"
    ],
    "desenchante": [
        "desenchante",
        "desenchanter"
    ],
    "desenchantement": [
        "desenchantement"
    ],
    "desenchantements": [
        "desenchantement"
    ],
    "desenchantent": [
        "desenchanter"
    ],
    "desenchanter": [
        "desenchanter"
    ],
    "desenchantee": [
        "desenchante",
        "desenchanter"
    ],
    "desenchantees": [
        "desenchante",
        "desenchanter"
    ],
    "desenchantes": [
        "desenchante",
        "desenchanter"
    ],
    "desenchainement": [
        "desenchainement"
    ],
    "desenchainer": [
        "desenchainer"
    ],
    "desenchevetra": [
        "desenchevetrer"
    ],
    "desenclavement": [
        "desenclavement"
    ],
    "desencombre": [
        "desencombrer"
    ],
    "desencrasser": [
        "desencrasser"
    ],
    "desenflaient": [
        "desenfler"
    ],
    "desenfle": [
        "desenfler"
    ],
    "desenfler": [
        "desenfler"
    ],
    "desengagement": [
        "desengagement"
    ],
    "desengager": [
        "desengager"
    ],
    "desengagez": [
        "desengager"
    ],
    "desengage": [
        "desengager"
    ],
    "desengluer": [
        "desengluer"
    ],
    "desengourdir": [
        "desengourdir"
    ],
    "desennuie": [
        "desennuyer"
    ],
    "desennuiera": [
        "desennuyer"
    ],
    "desennuyant": [
        "desennuyer"
    ],
    "desennuyer": [
        "desennuyer"
    ],
    "desenrouler": [
        "desenrouler"
    ],
    "desensabler": [
        "desensabler"
    ],
    "desensibilisation": [
        "desensibilisation"
    ],
    "desensibilisent": [
        "desensibiliser"
    ],
    "desensibilisee": [
        "desensibiliser"
    ],
    "desensorceler": [
        "desensorceler"
    ],
    "desensorcele": [
        "desensorceler"
    ],
    "desentortille": [
        "desentortiller"
    ],
    "desentrave": [
        "desentraver"
    ],
    "desentravee": [
        "desentraver"
    ],
    "desenvouter": [
        "desenvouter"
    ],
    "desenvouteurs": [
        "desenvouteur"
    ],
    "desenvoute": [
        "desenvouter"
    ],
    "desert": [
        "desert"
    ],
    "deserta": [
        "deserter"
    ],
    "desertaient": [
        "deserter"
    ],
    "desertais": [
        "deserter"
    ],
    "desertait": [
        "deserter"
    ],
    "desertant": [
        "deserter"
    ],
    "deserte": [
        "desert",
        "deserte",
        "deserter"
    ],
    "desertent": [
        "deserter"
    ],
    "deserter": [
        "deserter"
    ],
    "deserterait": [
        "deserter"
    ],
    "desertes": [
        "desert",
        "deserte",
        "deserter"
    ],
    "deserteur": [
        "deserteur"
    ],
    "deserteurs": [
        "deserteur"
    ],
    "desertifie": [
        "desertifier"
    ],
    "desertion": [
        "desertion"
    ],
    "desertions": [
        "desertion"
    ],
    "desertique": [
        "desertique"
    ],
    "desertiques": [
        "desertique"
    ],
    "desertons": [
        "deserter"
    ],
    "deserts": [
        "desert"
    ],
    "desertames": [
        "deserter"
    ],
    "deserterent": [
        "deserter"
    ],
    "desertee": [
        "deserte",
        "deserter"
    ],
    "desertees": [
        "deserte",
        "deserter"
    ],
    "desespoir": [
        "desespoir"
    ],
    "desespoirs": [
        "desespoir"
    ],
    "desespere": [
        "desesperer",
        "desespere"
    ],
    "desesperent": [
        "desesperer"
    ],
    "desesperes": [
        "desesperer",
        "desespere"
    ],
    "desespera": [
        "desesperer"
    ],
    "desesperai": [
        "desesperer"
    ],
    "desesperaient": [
        "desesperer"
    ],
    "desesperais": [
        "desesperer"
    ],
    "desesperait": [
        "desesperer"
    ],
    "desesperance": [
        "desesperance"
    ],
    "desesperant": [
        "desesperer",
        "desesperant"
    ],
    "desesperante": [
        "desesperant"
    ],
    "desesperants": [
        "desesperant"
    ],
    "desesperer": [
        "desesperer"
    ],
    "desesperez": [
        "desesperer"
    ],
    "desesperions": [
        "desesperer"
    ],
    "desesperons": [
        "desesperer"
    ],
    "desesperat": [
        "desesperer"
    ],
    "desespererent": [
        "desesperer"
    ],
    "desesperee": [
        "desesperer",
        "desespere"
    ],
    "desesperees": [
        "desesperer",
        "desespere"
    ],
    "desesperement": [
        "desesperement"
    ],
    "deshabilla": [
        "deshabiller"
    ],
    "deshabillage": [
        "deshabillage"
    ],
    "deshabillages": [
        "deshabillage"
    ],
    "deshabillai": [
        "deshabiller"
    ],
    "deshabillaient": [
        "deshabiller"
    ],
    "deshabillais": [
        "deshabiller"
    ],
    "deshabillait": [
        "deshabiller"
    ],
    "deshabillant": [
        "deshabiller"
    ],
    "deshabille": [
        "deshabille",
        "deshabiller"
    ],
    "deshabillent": [
        "deshabiller"
    ],
    "deshabiller": [
        "deshabiller"
    ],
    "deshabillera": [
        "deshabiller"
    ],
    "deshabillerai": [
        "deshabiller"
    ],
    "deshabillerait": [
        "deshabiller"
    ],
    "deshabilleras": [
        "deshabiller"
    ],
    "deshabilleriez": [
        "deshabiller"
    ],
    "deshabillerons": [
        "deshabiller"
    ],
    "deshabilles": [
        "deshabille",
        "deshabiller"
    ],
    "deshabillez": [
        "deshabiller"
    ],
    "deshabillons": [
        "deshabiller"
    ],
    "deshabillerent": [
        "deshabiller"
    ],
    "deshabillee": [
        "deshabille",
        "deshabiller"
    ],
    "deshabillees": [
        "deshabille",
        "deshabiller"
    ],
    "deshabitue": [
        "deshabituer"
    ],
    "deshabituees": [
        "deshabituer"
    ],
    "deshabitues": [
        "deshabituer"
    ],
    "deshabite": [
        "deshabite",
        "deshabiter"
    ],
    "deshabitee": [
        "deshabite"
    ],
    "deshabites": [
        "deshabite",
        "deshabiter"
    ],
    "desharmonie": [
        "desharmonie"
    ],
    "desherbage": [
        "desherbage"
    ],
    "desherbait": [
        "desherber"
    ],
    "desherbant": [
        "desherbant"
    ],
    "desherbants": [
        "desherbant"
    ],
    "desherbe": [
        "desherber"
    ],
    "desherber": [
        "desherber"
    ],
    "desherbee": [
        "desherber"
    ],
    "desheuraient": [
        "desheurer"
    ],
    "deshonneur": [
        "deshonneur"
    ],
    "deshonnete": [
        "deshonnete"
    ],
    "deshonnetes": [
        "deshonnete"
    ],
    "deshonoraient": [
        "deshonorer"
    ],
    "deshonorait": [
        "deshonorer"
    ],
    "deshonorant": [
        "deshonorant",
        "deshonorer"
    ],
    "deshonorante": [
        "deshonorant"
    ],
    "deshonorantes": [
        "deshonorant"
    ],
    "deshonorants": [
        "deshonorant"
    ],
    "deshonore": [
        "deshonorer"
    ],
    "deshonorent": [
        "deshonorer"
    ],
    "deshonorer": [
        "deshonorer"
    ],
    "deshonorera": [
        "deshonorer"
    ],
    "deshonorerai": [
        "deshonorer"
    ],
    "deshonorerais": [
        "deshonorer"
    ],
    "deshonorerait": [
        "deshonorer"
    ],
    "deshonores": [
        "deshonorer"
    ],
    "deshonorez": [
        "deshonorer"
    ],
    "deshonoree": [
        "deshonorer"
    ],
    "deshonorees": [
        "deshonorer"
    ],
    "deshumanisant": [
        "deshumaniser"
    ],
    "deshumanisante": [
        "deshumanisant"
    ],
    "deshumanisation": [
        "deshumanisation"
    ],
    "deshumanise": [
        "deshumaniser"
    ],
    "deshumanisent": [
        "deshumaniser"
    ],
    "deshumaniser": [
        "deshumaniser"
    ],
    "deshumanisee": [
        "deshumaniser"
    ],
    "deshumanisees": [
        "deshumaniser"
    ],
    "deshumidification": [
        "deshumidification"
    ],
    "deshydratais": [
        "deshydrater"
    ],
    "deshydratant": [
        "deshydrater"
    ],
    "deshydratation": [
        "deshydratation"
    ],
    "deshydrate": [
        "deshydrater",
        "deshydrate"
    ],
    "deshydrater": [
        "deshydrater"
    ],
    "deshydratee": [
        "deshydrater",
        "deshydrate"
    ],
    "deshydratees": [
        "deshydrater",
        "deshydrate"
    ],
    "deshydrates": [
        "deshydrater",
        "deshydrate"
    ],
    "desherence": [
        "desherence"
    ],
    "desherita": [
        "desheriter"
    ],
    "desheritais": [
        "desheriter"
    ],
    "desherite": [
        "desheriter",
        "desherite"
    ],
    "desheriter": [
        "desheriter"
    ],
    "desheritera": [
        "desheriter"
    ],
    "desheriterai": [
        "desheriter"
    ],
    "desheriterais": [
        "desheriter"
    ],
    "desheriterait": [
        "desheriter"
    ],
    "desheritee": [
        "desheriter",
        "desherite"
    ],
    "desheritees": [
        "desherite"
    ],
    "desherites": [
        "desheriter",
        "desherite"
    ],
    "designa": [
        "designer"
    ],
    "designai": [
        "designer"
    ],
    "designaient": [
        "designer"
    ],
    "designais": [
        "designer"
    ],
    "designait": [
        "designer"
    ],
    "designant": [
        "designer"
    ],
    "designassent": [
        "designer"
    ],
    "designation": [
        "designation"
    ],
    "designations": [
        "designation"
    ],
    "designe": [
        "designer",
        "designe"
    ],
    "designent": [
        "designer"
    ],
    "designera": [
        "designer"
    ],
    "designerai": [
        "designer"
    ],
    "designerait": [
        "designer"
    ],
    "designeras": [
        "designer"
    ],
    "designerez": [
        "designer"
    ],
    "designeriez": [
        "designer"
    ],
    "designerons": [
        "designer"
    ],
    "designeront": [
        "designer"
    ],
    "designez": [
        "designer"
    ],
    "designions": [
        "designer"
    ],
    "designat": [
        "designer"
    ],
    "designerent": [
        "designer"
    ],
    "designee": [
        "designer",
        "designe"
    ],
    "designees": [
        "designer",
        "designe"
    ],
    "designes": [
        "designer",
        "designe"
    ],
    "desillusion": [
        "desillusion"
    ],
    "desillusionnement": [
        "desillusionnement"
    ],
    "desillusionner": [
        "desillusionner"
    ],
    "desillusionne": [
        "desillusionner"
    ],
    "desillusions": [
        "desillusion"
    ],
    "desincarceration": [
        "desincarceration"
    ],
    "desincarcere": [
        "desincarcerer"
    ],
    "desincarnant": [
        "desincarner"
    ],
    "desincarnation": [
        "desincarnation"
    ],
    "desincarne": [
        "desincarner",
        "desincarne"
    ],
    "desincarner": [
        "desincarner"
    ],
    "desincarnee": [
        "desincarne"
    ],
    "desincarnees": [
        "desincarne"
    ],
    "desincarnes": [
        "desincarner",
        "desincarne"
    ],
    "desincrustante": [
        "desincrustant"
    ],
    "desincruster": [
        "desincruster"
    ],
    "desindividualisation": [
        "desindividualisation"
    ],
    "desinence": [
        "desinence"
    ],
    "desinences": [
        "desinence"
    ],
    "desinfecta": [
        "desinfecter"
    ],
    "desinfectant": [
        "desinfectant",
        "desinfecter"
    ],
    "desinfectante": [
        "desinfectant"
    ],
    "desinfectantes": [
        "desinfectant"
    ],
    "desinfectants": [
        "desinfectant"
    ],
    "desinfecte": [
        "desinfecter"
    ],
    "desinfectent": [
        "desinfecter"
    ],
    "desinfecter": [
        "desinfecter"
    ],
    "desinfecterai": [
        "desinfecter"
    ],
    "desinfectez": [
        "desinfecter"
    ],
    "desinfection": [
        "desinfection"
    ],
    "desinfections": [
        "desinfection"
    ],
    "desinfectee": [
        "desinfecter"
    ],
    "desinfectees": [
        "desinfecter"
    ],
    "desinfectes": [
        "desinfecter"
    ],
    "desinformation": [
        "desinformation"
    ],
    "desinformations": [
        "desinformation"
    ],
    "desinformer": [
        "desinformer"
    ],
    "desinformee": [
        "desinformer"
    ],
    "desinhibe": [
        "desinhiber"
    ],
    "desinsectisation": [
        "desinsectisation"
    ],
    "desinsectiser": [
        "desinsectiser"
    ],
    "desinstaller": [
        "desinstaller"
    ],
    "desinstalle": [
        "desinstaller"
    ],
    "desintellectualiser": [
        "desintellectualiser"
    ],
    "desintoxication": [
        "desintoxication"
    ],
    "desintoxique": [
        "desintoxiquer"
    ],
    "desintoxiquer": [
        "desintoxiquer"
    ],
    "desintoxiquera": [
        "desintoxiquer"
    ],
    "desintoxiquez": [
        "desintoxiquer"
    ],
    "desintoxiquee": [
        "desintoxiquer"
    ],
    "desintoxiques": [
        "desintoxiquer"
    ],
    "desintegre": [
        "desintegrer"
    ],
    "desintegrent": [
        "desintegrer"
    ],
    "desintegra": [
        "desintegrer"
    ],
    "desintegraient": [
        "desintegrer"
    ],
    "desintegrait": [
        "desintegrer"
    ],
    "desintegrant": [
        "desintegrer"
    ],
    "desintegrateur": [
        "desintegrateur"
    ],
    "desintegration": [
        "desintegration"
    ],
    "desintegrations": [
        "desintegration"
    ],
    "desintegrer": [
        "desintegrer"
    ],
    "desintegrera": [
        "desintegrer"
    ],
    "desintegreront": [
        "desintegrer"
    ],
    "desintegree": [
        "desintegrer"
    ],
    "desintegres": [
        "desintegrer"
    ],
    "desinteressa": [
        "desinteresser"
    ],
    "desinteressaient": [
        "desinteresser"
    ],
    "desinteressait": [
        "desinteresser"
    ],
    "desinteressant": [
        "desinteresser"
    ],
    "desinteresse": [
        "desinteresse",
        "desinteresser"
    ],
    "desinteressement": [
        "desinteressement"
    ],
    "desinteressent": [
        "desinteresser"
    ],
    "desinteresser": [
        "desinteresser"
    ],
    "desinteresserait": [
        "desinteresser"
    ],
    "desinteresseront": [
        "desinteresser"
    ],
    "desinteressiez": [
        "desinteresser"
    ],
    "desinteressee": [
        "desinteresse",
        "desinteresser"
    ],
    "desinteressees": [
        "desinteresse",
        "desinteresser"
    ],
    "desinteresses": [
        "desinteresse",
        "desinteresser"
    ],
    "desinteret": [
        "desinteret"
    ],
    "desinvite": [
        "desinviter"
    ],
    "desinviter": [
        "desinviter"
    ],
    "desinvolte": [
        "desinvolte"
    ],
    "desinvoltes": [
        "desinvolte"
    ],
    "desinvolture": [
        "desinvolture"
    ],
    "desinvoltures": [
        "desinvolture"
    ],
    "desir": [
        "desir"
    ],
    "desira": [
        "desirer"
    ],
    "desirabilite": [
        "desirabilite"
    ],
    "desirable": [
        "desirable"
    ],
    "desirables": [
        "desirable"
    ],
    "desiraient": [
        "desirer"
    ],
    "desirais": [
        "desirer"
    ],
    "desirait": [
        "desirer"
    ],
    "desirant": [
        "desirant",
        "desirer"
    ],
    "desirante": [
        "desirant"
    ],
    "desire": [
        "desire",
        "desirer"
    ],
    "desirent": [
        "desirer"
    ],
    "desirer": [
        "desirer"
    ],
    "desirera": [
        "desirer"
    ],
    "desireraient": [
        "desirer"
    ],
    "desirerais": [
        "desirer"
    ],
    "desirerait": [
        "desirer"
    ],
    "desireras": [
        "desirer"
    ],
    "desireriez": [
        "desirer"
    ],
    "desirerions": [
        "desirer"
    ],
    "desireront": [
        "desirer"
    ],
    "desires": [
        "desire",
        "desirer"
    ],
    "desireuse": [
        "desireux"
    ],
    "desireuses": [
        "desireux"
    ],
    "desireux": [
        "desireux"
    ],
    "desirez": [
        "desirer"
    ],
    "desiriez": [
        "desirer"
    ],
    "desirions": [
        "desirer"
    ],
    "desirons": [
        "desirer"
    ],
    "desirs": [
        "desir"
    ],
    "desirat": [
        "desirer"
    ],
    "desiree": [
        "desire",
        "desirer"
    ],
    "desirees": [
        "desire",
        "desirer"
    ],
    "desiste": [
        "desister"
    ],
    "desistement": [
        "desistement"
    ],
    "desister": [
        "desister"
    ],
    "desistez": [
        "desister"
    ],
    "desisterent": [
        "desister"
    ],
    "desistee": [
        "desister"
    ],
    "desistes": [
        "desister"
    ],
    "deslipe": [
        "desliper"
    ],
    "desoblige": [
        "desobliger"
    ],
    "desobligea": [
        "desobliger"
    ],
    "desobligeait": [
        "desobliger"
    ],
    "desobligeance": [
        "desobligeance"
    ],
    "desobligeant": [
        "desobliger",
        "desobligeant"
    ],
    "desobligeante": [
        "desobligeant"
    ],
    "desobligeantes": [
        "desobligeant"
    ],
    "desobligeants": [
        "desobligeant"
    ],
    "desobligent": [
        "desobliger"
    ],
    "desobliger": [
        "desobliger"
    ],
    "desobligerait": [
        "desobliger"
    ],
    "desobliges": [
        "desobliger"
    ],
    "desobei": [
        "desobeir"
    ],
    "desobeir": [
        "desobeir"
    ],
    "desobeira": [
        "desobeir"
    ],
    "desobeirai": [
        "desobeir"
    ],
    "desobeirais": [
        "desobeir"
    ],
    "desobeiront": [
        "desobeir"
    ],
    "desobeis": [
        "desobeir"
    ],
    "desobeissais": [
        "desobeir"
    ],
    "desobeissait": [
        "desobeir"
    ],
    "desobeissance": [
        "desobeissance"
    ],
    "desobeissances": [
        "desobeissance"
    ],
    "desobeissant": [
        "desobeir",
        "desobeissant"
    ],
    "desobeissante": [
        "desobeissant"
    ],
    "desobeissants": [
        "desobeissant"
    ],
    "desobeisse": [
        "desobeir"
    ],
    "desobeissent": [
        "desobeir"
    ],
    "desobeissez": [
        "desobeir"
    ],
    "desobeissions": [
        "desobeir"
    ],
    "desobeit": [
        "desobeir"
    ],
    "desoccupes": [
        "desoccuper",
        "desoccupe"
    ],
    "desodorisant": [
        "desodorisant"
    ],
    "desodorisante": [
        "desodorisant"
    ],
    "desodorisants": [
        "desodorisant"
    ],
    "desodoriser": [
        "desodoriser"
    ],
    "desodorises": [
        "desodoriser"
    ],
    "desode": [
        "desode"
    ],
    "desoeuvre": [
        "desoeuvre",
        "desoeuvrer"
    ],
    "desoeuvrement": [
        "desoeuvrement"
    ],
    "desoeuvrements": [
        "desoeuvrement"
    ],
    "desoeuvree": [
        "desoeuvre",
        "desoeuvrer"
    ],
    "desoeuvrees": [
        "desoeuvre",
        "desoeuvrer"
    ],
    "desoeuvres": [
        "desoeuvre",
        "desoeuvrer"
    ],
    "desola": [
        "desoler"
    ],
    "desolai": [
        "desoler"
    ],
    "desolaient": [
        "desoler"
    ],
    "desolais": [
        "desoler"
    ],
    "desolait": [
        "desoler"
    ],
    "desolant": [
        "desoler",
        "desolant"
    ],
    "desolante": [
        "desolant"
    ],
    "desolantes": [
        "desolant"
    ],
    "desolants": [
        "desolant"
    ],
    "desolation": [
        "desolation"
    ],
    "desolations": [
        "desolation"
    ],
    "desole": [
        "desole",
        "desoler"
    ],
    "desolent": [
        "desoler"
    ],
    "desoler": [
        "desoler"
    ],
    "desolera": [
        "desoler"
    ],
    "desolerait": [
        "desoler"
    ],
    "desoleront": [
        "desoler"
    ],
    "desoles": [
        "desole",
        "desoler"
    ],
    "desolez": [
        "desoler"
    ],
    "desolidarisa": [
        "desolidariser"
    ],
    "desolidarisaient": [
        "desolidariser"
    ],
    "desolidarisait": [
        "desolidariser"
    ],
    "desolidariser": [
        "desolidariser"
    ],
    "desolidariserai": [
        "desolidariser"
    ],
    "desolidarise": [
        "desolidariser"
    ],
    "desolidarises": [
        "desolidariser"
    ],
    "desolat": [
        "desoler"
    ],
    "desolee": [
        "desole",
        "desoler"
    ],
    "desolees": [
        "desole",
        "desoler"
    ],
    "desopilant": [
        "desopiler",
        "desopilant"
    ],
    "desopilante": [
        "desopilant"
    ],
    "desopilantes": [
        "desopilant"
    ],
    "desopilants": [
        "desopilant"
    ],
    "desorbitation": [
        "desorbitation"
    ],
    "desorbitent": [
        "desorbiter"
    ],
    "desorbiter": [
        "desorbiter"
    ],
    "desordonne": [
        "desordonne",
        "desordonner"
    ],
    "desordonnee": [
        "desordonne",
        "desordonner"
    ],
    "desordonnees": [
        "desordonne"
    ],
    "desordonnement": [
        "desordonnement"
    ],
    "desordonnes": [
        "desordonne",
        "desordonner"
    ],
    "desordre": [
        "desordre"
    ],
    "desordres": [
        "desordre"
    ],
    "desorganisait": [
        "desorganiser"
    ],
    "desorganisateur": [
        "desorganisateur"
    ],
    "desorganisation": [
        "desorganisation"
    ],
    "desorganise": [
        "desorganiser"
    ],
    "desorganiser": [
        "desorganiser"
    ],
    "desorganisee": [
        "desorganiser"
    ],
    "desorganisees": [
        "desorganiser"
    ],
    "desorganises": [
        "desorganiser"
    ],
    "desorienta": [
        "desorienter"
    ],
    "desorientaient": [
        "desorienter"
    ],
    "desorientait": [
        "desorienter"
    ],
    "desorientant": [
        "desorienter"
    ],
    "desorientation": [
        "desorientation"
    ],
    "desoriente": [
        "desoriente",
        "desorienter"
    ],
    "desorientent": [
        "desorienter"
    ],
    "desorienter": [
        "desorienter"
    ],
    "desorienterait": [
        "desorienter"
    ],
    "desorientee": [
        "desoriente",
        "desorienter"
    ],
    "desorientees": [
        "desoriente",
        "desorienter"
    ],
    "desorientes": [
        "desoriente",
        "desorienter"
    ],
    "desormais": [
        "desormais"
    ],
    "desossage": [
        "desossage"
    ],
    "desossait": [
        "desosser"
    ],
    "desosse": [
        "desosser"
    ],
    "desossement": [
        "desossement"
    ],
    "desosser": [
        "desosser"
    ],
    "desosseur": [
        "desosseur"
    ],
    "desossee": [
        "desosser"
    ],
    "desossees": [
        "desosser"
    ],
    "desosses": [
        "desosser"
    ],
    "desoxygenation": [
        "desoxygenation"
    ],
    "desoxyribonucleique": [
        "desoxyribonucleique"
    ],
    "despiritualisation": [
        "despiritualisation"
    ],
    "despiritualiser": [
        "despiritualiser"
    ],
    "destabilisaient": [
        "destabiliser"
    ],
    "destabilisant": [
        "destabiliser",
        "destabilisant"
    ],
    "destabilisante": [
        "destabilisant"
    ],
    "destabilisantes": [
        "destabilisant"
    ],
    "destabilisation": [
        "destabilisation"
    ],
    "destabilisatrice": [
        "destabilisateur"
    ],
    "destabilise": [
        "destabiliser"
    ],
    "destabilisent": [
        "destabiliser"
    ],
    "destabiliser": [
        "destabiliser"
    ],
    "destabilisera": [
        "destabiliser"
    ],
    "destabiliserait": [
        "destabiliser"
    ],
    "destabilisez": [
        "destabiliser"
    ],
    "destabilisee": [
        "destabiliser"
    ],
    "destabilises": [
        "destabiliser"
    ],
    "destalinisation": [
        "destalinisation"
    ],
    "destockage": [
        "destockage"
    ],
    "destocke": [
        "destocker"
    ],
    "destructuration": [
        "destructuration"
    ],
    "destructurer": [
        "destructurer"
    ],
    "destructure": [
        "destructurer"
    ],
    "desubjectiviser": [
        "desubjectiviser"
    ],
    "desuet": [
        "desuet"
    ],
    "desuets": [
        "desuet"
    ],
    "desuni": [
        "desunir",
        "desuni"
    ],
    "desunie": [
        "desuni"
    ],
    "desunies": [
        "desuni"
    ],
    "desunion": [
        "desunion"
    ],
    "desunir": [
        "desunir"
    ],
    "desunirait": [
        "desunir"
    ],
    "desunirent": [
        "desunir"
    ],
    "desunis": [
        "desunir",
        "desuni"
    ],
    "desunissaient": [
        "desunir"
    ],
    "desunissait": [
        "desunir"
    ],
    "desunissant": [
        "desunir"
    ],
    "desunisse": [
        "desunir"
    ],
    "desunissent": [
        "desunir"
    ],
    "desunit": [
        "desunir"
    ],
    "desuete": [
        "desuet"
    ],
    "desuetes": [
        "desuet"
    ],
    "desuetude": [
        "desuetude"
    ],
    "desynchronisation": [
        "desynchronisation"
    ],
    "desynchronise": [
        "desynchroniser"
    ],
    "desechouee": [
        "desechouer"
    ],
    "desegregation": [
        "desegregation"
    ],
    "desepaissir": [
        "desepaissir"
    ],
    "desepaissis": [
        "desepaissir"
    ],
    "desequilibra": [
        "desequilibrer"
    ],
    "desequilibraient": [
        "desequilibrer"
    ],
    "desequilibrais": [
        "desequilibrer"
    ],
    "desequilibrait": [
        "desequilibrer"
    ],
    "desequilibrant": [
        "desequilibrer"
    ],
    "desequilibre": [
        "desequilibrer",
        "desequilibre"
    ],
    "desequilibrer": [
        "desequilibrer"
    ],
    "desequilibres": [
        "desequilibrer",
        "desequilibre"
    ],
    "desequilibrez": [
        "desequilibrer"
    ],
    "desequilibrat": [
        "desequilibrer"
    ],
    "desequilibree": [
        "desequilibrer",
        "desequilibre"
    ],
    "desequilibrees": [
        "desequilibre"
    ],
    "desequipent": [
        "desequiper"
    ],
    "desequiper": [
        "desequiper"
    ],
    "desequipe": [
        "desequiper"
    ],
    "desequipes": [
        "desequiper"
    ],
    "detacha": [
        "detacher"
    ],
    "detachable": [
        "detachable"
    ],
    "detachai": [
        "detacher"
    ],
    "detachaient": [
        "detacher"
    ],
    "detachais": [
        "detacher"
    ],
    "detachait": [
        "detacher"
    ],
    "detachant": [
        "detacher",
        "detachant"
    ],
    "detachants": [
        "detachant"
    ],
    "detache": [
        "detacher",
        "detache"
    ],
    "detachement": [
        "detachement"
    ],
    "detachements": [
        "detachement"
    ],
    "detachent": [
        "detacher"
    ],
    "detacher": [
        "detacher"
    ],
    "detacherai": [
        "detacher"
    ],
    "detacheraient": [
        "detacher"
    ],
    "detacherais": [
        "detacher"
    ],
    "detacherait": [
        "detacher"
    ],
    "detacherons": [
        "detacher"
    ],
    "detacheront": [
        "detacher"
    ],
    "detaches": [
        "detacher",
        "detache",
        "detach"
    ],
    "detacheur": [
        "detacheur"
    ],
    "detachez": [
        "detacher"
    ],
    "detachions": [
        "detacher"
    ],
    "detachons": [
        "detacher"
    ],
    "detachat": [
        "detacher"
    ],
    "detacherent": [
        "detacher"
    ],
    "detachee": [
        "detacher",
        "detache"
    ],
    "detachees": [
        "detacher",
        "detache"
    ],
    "detail": [
        "detail"
    ],
    "detailla": [
        "detailler"
    ],
    "detaillai": [
        "detailler"
    ],
    "detaillaient": [
        "detailler"
    ],
    "detaillais": [
        "detailler"
    ],
    "detaillait": [
        "detailler"
    ],
    "detaillant": [
        "detaillant",
        "detailler"
    ],
    "detaillante": [
        "detaillant"
    ],
    "detaillants": [
        "detaillant"
    ],
    "detaille": [
        "detailler",
        "detaille"
    ],
    "detailler": [
        "detailler"
    ],
    "detaillera": [
        "detailler"
    ],
    "detaillerai": [
        "detailler"
    ],
    "detaillez": [
        "detailler"
    ],
    "detaillions": [
        "detailler"
    ],
    "detaillons": [
        "detailler"
    ],
    "detaillat": [
        "detailler"
    ],
    "detaillerent": [
        "detailler"
    ],
    "detaillee": [
        "detailler",
        "detaille"
    ],
    "detaillees": [
        "detailler",
        "detaille"
    ],
    "detailles": [
        "detailler",
        "detaille"
    ],
    "details": [
        "detail"
    ],
    "detala": [
        "detaler"
    ],
    "detalai": [
        "detaler"
    ],
    "detalaient": [
        "detaler"
    ],
    "detalait": [
        "detaler"
    ],
    "detalant": [
        "detaler"
    ],
    "detale": [
        "detaler"
    ],
    "detalent": [
        "detaler"
    ],
    "detaler": [
        "detaler"
    ],
    "detaleraient": [
        "detaler"
    ],
    "detaleront": [
        "detaler"
    ],
    "detales": [
        "detaler"
    ],
    "detalions": [
        "detaler"
    ],
    "detalonner": [
        "detalonner"
    ],
    "detalat": [
        "detaler"
    ],
    "detalerent": [
        "detaler"
    ],
    "detartrage": [
        "detartrage"
    ],
    "detartrant": [
        "detartrant"
    ],
    "detartrants": [
        "detartrant"
    ],
    "detaxe": [
        "detaxe"
    ],
    "detaxes": [
        "detaxe"
    ],
    "detaxee": [
        "detaxer"
    ],
    "detaxees": [
        "detaxer"
    ],
    "detecta": [
        "detecter"
    ],
    "detectable": [
        "detectable"
    ],
    "detectables": [
        "detectable"
    ],
    "detectai": [
        "detecter"
    ],
    "detectaient": [
        "detecter"
    ],
    "detectait": [
        "detecter"
    ],
    "detecte": [
        "detecter"
    ],
    "detectent": [
        "detecter"
    ],
    "detecter": [
        "detecter"
    ],
    "detectera": [
        "detecter"
    ],
    "detecteront": [
        "detecter"
    ],
    "detecteur": [
        "detecteur"
    ],
    "detecteurs": [
        "detecteur"
    ],
    "detectez": [
        "detecter"
    ],
    "detection": [
        "detection"
    ],
    "detections": [
        "detection"
    ],
    "detective": [
        "detective"
    ],
    "detectives": [
        "detective"
    ],
    "detectons": [
        "detecter"
    ],
    "detectee": [
        "detecter"
    ],
    "detectees": [
        "detecter"
    ],
    "detectes": [
        "detecter"
    ],
    "deteignaient": [
        "deteindre"
    ],
    "deteignait": [
        "deteindre"
    ],
    "deteignant": [
        "deteindre"
    ],
    "deteigne": [
        "deteindre"
    ],
    "deteignent": [
        "deteindre"
    ],
    "deteignes": [
        "deteindre"
    ],
    "deteindra": [
        "deteindre"
    ],
    "deteindre": [
        "deteindre"
    ],
    "deteint": [
        "deteindre"
    ],
    "deteinte": [
        "deteindre"
    ],
    "deteintes": [
        "deteindre"
    ],
    "deteints": [
        "deteindre"
    ],
    "detela": [
        "deteler"
    ],
    "detelage": [
        "detelage"
    ],
    "detelaient": [
        "deteler"
    ],
    "detelait": [
        "deteler"
    ],
    "deteler": [
        "deteler"
    ],
    "detelez": [
        "deteler"
    ],
    "detelle": [
        "deteler"
    ],
    "detele": [
        "deteler"
    ],
    "detelee": [
        "deteler"
    ],
    "detelees": [
        "deteler"
    ],
    "deteles": [
        "deteler"
    ],
    "detenaient": [
        "detenir"
    ],
    "detenais": [
        "detenir"
    ],
    "detenait": [
        "detenir"
    ],
    "detenant": [
        "detenir"
    ],
    "detend": [
        "detendre"
    ],
    "detendaient": [
        "detendre"
    ],
    "detendais": [
        "detendre"
    ],
    "detendait": [
        "detendre"
    ],
    "detendant": [
        "detendre"
    ],
    "detende": [
        "detendre"
    ],
    "detendent": [
        "detendre"
    ],
    "detendes": [
        "detendre"
    ],
    "detendeur": [
        "detendeur"
    ],
    "detendez": [
        "detendre"
    ],
    "detendiez": [
        "detendre"
    ],
    "detendions": [
        "detendre"
    ],
    "detendirent": [
        "detendre"
    ],
    "detendis": [
        "detendre"
    ],
    "detendit": [
        "detendre"
    ],
    "detendons": [
        "detendre"
    ],
    "detendra": [
        "detendre"
    ],
    "detendrai": [
        "detendre"
    ],
    "detendraient": [
        "detendre"
    ],
    "detendrait": [
        "detendre"
    ],
    "detendre": [
        "detendre"
    ],
    "detendrez": [
        "detendre"
    ],
    "detendrons": [
        "detendre"
    ],
    "detends": [
        "detendre"
    ],
    "detendu": [
        "detendre",
        "detendu"
    ],
    "detendue": [
        "detendre",
        "detendu"
    ],
    "detendues": [
        "detendre",
        "detendu"
    ],
    "detendus": [
        "detendre",
        "detendu"
    ],
    "detenez": [
        "detenir"
    ],
    "deteniez": [
        "detenir"
    ],
    "detenions": [
        "detenir"
    ],
    "detenir": [
        "detenir"
    ],
    "detenons": [
        "detenir"
    ],
    "detente": [
        "detente"
    ],
    "detentes": [
        "detente"
    ],
    "detenteur": [
        "detenteur"
    ],
    "detenteurs": [
        "detenteur"
    ],
    "detention": [
        "detention"
    ],
    "detentions": [
        "detention"
    ],
    "detentrice": [
        "detenteur"
    ],
    "detentrices": [
        "detenteur"
    ],
    "detenu": [
        "detenir",
        "detenu"
    ],
    "detenue": [
        "detenir",
        "detenu"
    ],
    "detenues": [
        "detenir",
        "detenu"
    ],
    "detenus": [
        "detenir",
        "detenu"
    ],
    "detergeant": [
        "deterger"
    ],
    "detergent": [
        "detergent"
    ],
    "detergents": [
        "detergent"
    ],
    "determina": [
        "determiner"
    ],
    "determinai": [
        "determiner"
    ],
    "determinaient": [
        "determiner"
    ],
    "determinais": [
        "determiner"
    ],
    "determinait": [
        "determiner"
    ],
    "determinant": [
        "determiner",
        "determinant"
    ],
    "determinante": [
        "determinant"
    ],
    "determinantes": [
        "determinant"
    ],
    "determinants": [
        "determinant"
    ],
    "determination": [
        "determination"
    ],
    "determinations": [
        "determination"
    ],
    "determine": [
        "determiner",
        "determine"
    ],
    "determinent": [
        "determiner"
    ],
    "determiner": [
        "determiner"
    ],
    "determinera": [
        "determiner"
    ],
    "determineraient": [
        "determiner"
    ],
    "determinerait": [
        "determiner"
    ],
    "determinerons": [
        "determiner"
    ],
    "determineront": [
        "determiner"
    ],
    "determinez": [
        "determiner"
    ],
    "determiniez": [
        "determiner"
    ],
    "determinions": [
        "determiner"
    ],
    "determinisme": [
        "determinisme"
    ],
    "deterministe": [
        "deterministe"
    ],
    "deterministes": [
        "deterministe"
    ],
    "determinons": [
        "determiner"
    ],
    "determinerent": [
        "determiner"
    ],
    "determinee": [
        "determiner",
        "determine"
    ],
    "determinees": [
        "determiner",
        "determine"
    ],
    "determinement": [
        "determinement"
    ],
    "determines": [
        "determiner",
        "determine"
    ],
    "deterra": [
        "deterrer"
    ],
    "deterrage": [
        "deterrage"
    ],
    "deterraient": [
        "deterrer"
    ],
    "deterrais": [
        "deterrer"
    ],
    "deterrait": [
        "deterrer"
    ],
    "deterrant": [
        "deterrer"
    ],
    "deterre": [
        "deterrer",
        "deterre"
    ],
    "deterrent": [
        "deterrer"
    ],
    "deterrer": [
        "deterrer"
    ],
    "deterrera": [
        "deterrer"
    ],
    "deterrerai": [
        "deterrer"
    ],
    "deterrerait": [
        "deterrer"
    ],
    "deterrerez": [
        "deterrer"
    ],
    "deterreront": [
        "deterrer"
    ],
    "deterreur": [
        "deterreur"
    ],
    "deterreurs": [
        "deterreur"
    ],
    "deterreuse": [
        "deterreur"
    ],
    "deterrez": [
        "deterrer"
    ],
    "deterrions": [
        "deterrer"
    ],
    "deterrons": [
        "deterrer"
    ],
    "deterree": [
        "deterrer",
        "deterre"
    ],
    "deterrees": [
        "deterrer",
        "deterre"
    ],
    "deterres": [
        "deterrer",
        "deterre"
    ],
    "detersifs": [
        "detersif"
    ],
    "detersive": [
        "detersif"
    ],
    "detesta": [
        "detester"
    ],
    "detestable": [
        "detestable"
    ],
    "detestablement": [
        "detestablement"
    ],
    "detestables": [
        "detestable"
    ],
    "detestai": [
        "detester"
    ],
    "detestaient": [
        "detester"
    ],
    "detestais": [
        "detester"
    ],
    "detestait": [
        "detester"
    ],
    "detestant": [
        "detester"
    ],
    "detestation": [
        "detestation"
    ],
    "detestations": [
        "detestation"
    ],
    "deteste": [
        "detester",
        "deteste"
    ],
    "detestent": [
        "detester"
    ],
    "detester": [
        "detester"
    ],
    "detestera": [
        "detester"
    ],
    "detesterai": [
        "detester"
    ],
    "detesteraient": [
        "detester"
    ],
    "detesterais": [
        "detester"
    ],
    "detesterait": [
        "detester"
    ],
    "detesteras": [
        "detester"
    ],
    "detesteriez": [
        "detester"
    ],
    "detesteront": [
        "detester"
    ],
    "detestes": [
        "detester",
        "deteste"
    ],
    "detestez": [
        "detester"
    ],
    "detestiez": [
        "detester"
    ],
    "detestions": [
        "detester"
    ],
    "detestons": [
        "detester"
    ],
    "detestat": [
        "detester"
    ],
    "detestee": [
        "detester",
        "deteste"
    ],
    "detiendra": [
        "detenir"
    ],
    "detiendrai": [
        "detenir"
    ],
    "detiendraient": [
        "detenir"
    ],
    "detiendrait": [
        "detenir"
    ],
    "detiendras": [
        "detenir"
    ],
    "detiendrez": [
        "detenir"
    ],
    "detiendront": [
        "detenir"
    ],
    "detienne": [
        "detenir"
    ],
    "detiennent": [
        "detenir"
    ],
    "detiens": [
        "detenir"
    ],
    "detient": [
        "detenir"
    ],
    "detimbree": [
        "detimbre"
    ],
    "detint": [
        "detenir"
    ],
    "detisse": [
        "detisser"
    ],
    "detonait": [
        "detoner"
    ],
    "detonant": [
        "detonant"
    ],
    "detonante": [
        "detonant"
    ],
    "detonants": [
        "detonant"
    ],
    "detonateur": [
        "detonateur"
    ],
    "detonateurs": [
        "detonateur"
    ],
    "detonation": [
        "detonation"
    ],
    "detonations": [
        "detonation"
    ],
    "detoner": [
        "detoner"
    ],
    "detonera": [
        "detoner"
    ],
    "detonna": [
        "detonner"
    ],
    "detonnaient": [
        "detonner"
    ],
    "detonnait": [
        "detonner"
    ],
    "detonnant": [
        "detonner"
    ],
    "detonne": [
        "detonner"
    ],
    "detonnent": [
        "detonner"
    ],
    "detonner": [
        "detonner"
    ],
    "detonee": [
        "detoner"
    ],
    "detord": [
        "detordre"
    ],
    "detordit": [
        "detordre"
    ],
    "detortillai": [
        "detortiller"
    ],
    "detortille": [
        "detortiller"
    ],
    "detour": [
        "detour"
    ],
    "detourage": [
        "detourage"
    ],
    "detourna": [
        "detourner"
    ],
    "detournai": [
        "detourner"
    ],
    "detournaient": [
        "detourner"
    ],
    "detournais": [
        "detourner"
    ],
    "detournait": [
        "detourner"
    ],
    "detournant": [
        "detourner"
    ],
    "detourne": [
        "detourner",
        "detourne"
    ],
    "detournement": [
        "detournement"
    ],
    "detournements": [
        "detournement"
    ],
    "detournent": [
        "detourner"
    ],
    "detourner": [
        "detourner"
    ],
    "detournera": [
        "detourner"
    ],
    "detournerai": [
        "detourner"
    ],
    "detourneraient": [
        "detourner"
    ],
    "detournerais": [
        "detourner"
    ],
    "detournerait": [
        "detourner"
    ],
    "detourneront": [
        "detourner"
    ],
    "detournes": [
        "detourner",
        "detourne"
    ],
    "detourneur": [
        "detourneur"
    ],
    "detournez": [
        "detourner"
    ],
    "detourniez": [
        "detourner"
    ],
    "detournions": [
        "detourner"
    ],
    "detournons": [
        "detourner"
    ],
    "detournat": [
        "detourner"
    ],
    "detournerent": [
        "detourner"
    ],
    "detournee": [
        "detourner",
        "detourne"
    ],
    "detournees": [
        "detourner",
        "detourne"
    ],
    "detours": [
        "detour"
    ],
    "detracteur": [
        "detracteur"
    ],
    "detracteurs": [
        "detracteur"
    ],
    "detraquaient": [
        "detraquer"
    ],
    "detraquais": [
        "detraquer"
    ],
    "detraquant": [
        "detraquer"
    ],
    "detraque": [
        "detraquer",
        "detraque"
    ],
    "detraquement": [
        "detraquement"
    ],
    "detraquent": [
        "detraquer"
    ],
    "detraquer": [
        "detraquer"
    ],
    "detraquera": [
        "detraquer"
    ],
    "detraquerais": [
        "detraquer"
    ],
    "detraquee": [
        "detraquer",
        "detraque"
    ],
    "detraquees": [
        "detraquer",
        "detraque"
    ],
    "detraques": [
        "detraquer",
        "detraque"
    ],
    "detrempaient": [
        "detremper"
    ],
    "detrempait": [
        "detremper"
    ],
    "detrempant": [
        "detremper"
    ],
    "detrempe": [
        "detremper",
        "detrempe"
    ],
    "detremper": [
        "detremper"
    ],
    "detrempee": [
        "detremper"
    ],
    "detrempees": [
        "detremper"
    ],
    "detrempes": [
        "detremper"
    ],
    "detresse": [
        "detresse"
    ],
    "detresses": [
        "detresse"
    ],
    "detribalisee": [
        "detribaliser"
    ],
    "detricote": [
        "detricoter"
    ],
    "detricoter": [
        "detricoter"
    ],
    "detriment": [
        "detriment"
    ],
    "detriments": [
        "detriment"
    ],
    "detritiques": [
        "detritique"
    ],
    "detritus": [
        "detritus"
    ],
    "detroit": [
        "detroit"
    ],
    "detroits": [
        "detroit"
    ],
    "detrompa": [
        "detromper"
    ],
    "detrompai": [
        "detromper"
    ],
    "detrompais": [
        "detromper"
    ],
    "detrompait": [
        "detromper"
    ],
    "detrompe": [
        "detromper"
    ],
    "detromper": [
        "detromper"
    ],
    "detromperai": [
        "detromper"
    ],
    "detrompez": [
        "detromper"
    ],
    "detrompee": [
        "detromper"
    ],
    "detrompes": [
        "detromper"
    ],
    "detroncha": [
        "detroncher"
    ],
    "detronchant": [
        "detroncher"
    ],
    "detronche": [
        "detroncher"
    ],
    "detronchent": [
        "detroncher"
    ],
    "detroncher": [
        "detroncher"
    ],
    "detroncherais": [
        "detroncher"
    ],
    "detroncherent": [
        "detroncher"
    ],
    "detroussaient": [
        "detrousser"
    ],
    "detroussais": [
        "detrousser"
    ],
    "detroussant": [
        "detrousser"
    ],
    "detroussent": [
        "detrousser"
    ],
    "detrousser": [
        "detrousser"
    ],
    "detrousses": [
        "detrousser"
    ],
    "detrousseur": [
        "detrousseur"
    ],
    "detrousseurs": [
        "detrousseur"
    ],
    "detroussez": [
        "detrousser"
    ],
    "detrousse": [
        "detrousser"
    ],
    "detruira": [
        "detruire"
    ],
    "detruirai": [
        "detruire"
    ],
    "detruiraient": [
        "detruire"
    ],
    "detruirais": [
        "detruire"
    ],
    "detruirait": [
        "detruire"
    ],
    "detruiras": [
        "detruire"
    ],
    "detruire": [
        "detruire"
    ],
    "detruirez": [
        "detruire"
    ],
    "detruiriez": [
        "detruire"
    ],
    "detruirions": [
        "detruire"
    ],
    "detruirons": [
        "detruire"
    ],
    "detruiront": [
        "detruire"
    ],
    "detruis": [
        "detruire"
    ],
    "detruisaient": [
        "detruire"
    ],
    "detruisais": [
        "detruire"
    ],
    "detruisait": [
        "detruire"
    ],
    "detruisant": [
        "detruire"
    ],
    "detruise": [
        "detruire"
    ],
    "detruisent": [
        "detruire"
    ],
    "detruises": [
        "detruire"
    ],
    "detruisez": [
        "detruire"
    ],
    "detruisiez": [
        "detruire"
    ],
    "detruisions": [
        "detruire"
    ],
    "detruisirent": [
        "detruire"
    ],
    "detruisis": [
        "detruire"
    ],
    "detruisit": [
        "detruire"
    ],
    "detruisons": [
        "detruire"
    ],
    "detruit": [
        "detruire"
    ],
    "detruite": [
        "detruire"
    ],
    "detruites": [
        "detruire"
    ],
    "detruits": [
        "detruire"
    ],
    "detronaient": [
        "detroner"
    ],
    "detrone": [
        "detrone",
        "detroner"
    ],
    "detronement": [
        "detronement"
    ],
    "detroner": [
        "detroner"
    ],
    "detronat": [
        "detroner"
    ],
    "detronee": [
        "detrone",
        "detroner"
    ],
    "deterioraient": [
        "deteriorer"
    ],
    "deteriorait": [
        "deteriorer"
    ],
    "deteriorant": [
        "deteriorer"
    ],
    "deterioration": [
        "deterioration"
    ],
    "deteriorations": [
        "deterioration"
    ],
    "deteriore": [
        "deteriorer"
    ],
    "deteriorent": [
        "deteriorer"
    ],
    "deteriorer": [
        "deteriorer"
    ],
    "deteriorat": [
        "deteriorer"
    ],
    "deterioree": [
        "deteriorer"
    ],
    "deteriorees": [
        "deteriorer"
    ],
    "deteriores": [
        "deteriorer"
    ],
    "devala": [
        "devaler"
    ],
    "devalai": [
        "devaler"
    ],
    "devalaient": [
        "devaler"
    ],
    "devalais": [
        "devaler"
    ],
    "devalait": [
        "devaler"
    ],
    "devalant": [
        "devaler"
    ],
    "devale": [
        "devaler"
    ],
    "devalement": [
        "devalement"
    ],
    "devalent": [
        "devaler"
    ],
    "devaler": [
        "devaler"
    ],
    "devales": [
        "devaler"
    ],
    "devalions": [
        "devaler"
    ],
    "devalisai": [
        "devaliser"
    ],
    "devalisaient": [
        "devaliser"
    ],
    "devalisait": [
        "devaliser"
    ],
    "devalisant": [
        "devaliser"
    ],
    "devalise": [
        "devaliser"
    ],
    "devalisent": [
        "devaliser"
    ],
    "devaliser": [
        "devaliser"
    ],
    "devalisera": [
        "devaliser"
    ],
    "devaliserait": [
        "devaliser"
    ],
    "devalises": [
        "devaliser"
    ],
    "devalisez": [
        "devaliser"
    ],
    "devalisee": [
        "devaliser"
    ],
    "devalons": [
        "devaler"
    ],
    "devalorisaient": [
        "devaloriser"
    ],
    "devalorisait": [
        "devaloriser"
    ],
    "devalorisant": [
        "devalorisant"
    ],
    "devalorisation": [
        "devalorisation"
    ],
    "devalorise": [
        "devaloriser"
    ],
    "devalorisent": [
        "devaloriser"
    ],
    "devaloriser": [
        "devaloriser"
    ],
    "devalorisez": [
        "devaloriser"
    ],
    "devalorisee": [
        "devaloriser"
    ],
    "devaluait": [
        "devaluer"
    ],
    "devaluation": [
        "devaluation"
    ],
    "devaluations": [
        "devaluation"
    ],
    "devalue": [
        "devaluer"
    ],
    "devaluer": [
        "devaluer"
    ],
    "devaluera": [
        "devaluer"
    ],
    "devaluee": [
        "devaluer"
    ],
    "devalues": [
        "devaluer",
        "devalue"
    ],
    "devalerent": [
        "devaler"
    ],
    "devalee": [
        "devaler"
    ],
    "devasta": [
        "devaster"
    ],
    "devastaient": [
        "devaster"
    ],
    "devastait": [
        "devaster"
    ],
    "devastant": [
        "devaster"
    ],
    "devastateur": [
        "devastateur"
    ],
    "devastateurs": [
        "devastateur"
    ],
    "devastation": [
        "devastation"
    ],
    "devastations": [
        "devastation"
    ],
    "devastatrice": [
        "devastateur"
    ],
    "devastatrices": [
        "devastateur"
    ],
    "devaste": [
        "devaste",
        "devaster"
    ],
    "devastent": [
        "devaster"
    ],
    "devaster": [
        "devaster"
    ],
    "devastera": [
        "devaster"
    ],
    "devasterait": [
        "devaster"
    ],
    "devasteront": [
        "devaster"
    ],
    "devasterent": [
        "devaster"
    ],
    "devastee": [
        "devaste",
        "devaster"
    ],
    "devastees": [
        "devaste",
        "devaster"
    ],
    "devastes": [
        "devaste",
        "devaster"
    ],
    "deveinards": [
        "deveinard"
    ],
    "deveine": [
        "deveine"
    ],
    "deveines": [
        "deveine"
    ],
    "developpa": [
        "developper"
    ],
    "developpai": [
        "developper"
    ],
    "developpaient": [
        "developper"
    ],
    "developpais": [
        "developper"
    ],
    "developpait": [
        "developper"
    ],
    "developpant": [
        "developper"
    ],
    "developpe": [
        "developper",
        "developpe"
    ],
    "developpement": [
        "developpement"
    ],
    "developpements": [
        "developpement"
    ],
    "developpent": [
        "developper"
    ],
    "developper": [
        "developper"
    ],
    "developpera": [
        "developper"
    ],
    "developperai": [
        "developper"
    ],
    "developperaient": [
        "developper"
    ],
    "developperais": [
        "developper"
    ],
    "developperait": [
        "developper"
    ],
    "developperez": [
        "developper"
    ],
    "developperont": [
        "developper"
    ],
    "developpeur": [
        "developpeur"
    ],
    "developpez": [
        "developper"
    ],
    "developpons": [
        "developper"
    ],
    "developpat": [
        "developper"
    ],
    "developperent": [
        "developper"
    ],
    "developpee": [
        "developper",
        "developpee",
        "developpe"
    ],
    "developpees": [
        "developper",
        "developpee",
        "developpe"
    ],
    "developpes": [
        "developper",
        "developpe"
    ],
    "deventer": [
        "deventer"
    ],
    "devergondage": [
        "devergondage"
    ],
    "devergondages": [
        "devergondage"
    ],
    "devergonde": [
        "devergonder",
        "devergonde"
    ],
    "devergondent": [
        "devergonder"
    ],
    "devergonder": [
        "devergonder"
    ],
    "devergondee": [
        "devergonder",
        "devergonde"
    ],
    "devergondees": [
        "devergonder",
        "devergonde"
    ],
    "devergondes": [
        "devergonder",
        "devergonde"
    ],
    "devernie": [
        "devernir"
    ],
    "devernies": [
        "devernir"
    ],
    "devernir": [
        "devernir"
    ],
    "deverrouilla": [
        "deverrouiller"
    ],
    "deverrouillage": [
        "deverrouillage"
    ],
    "deverrouillait": [
        "deverrouiller"
    ],
    "deverrouille": [
        "deverrouiller"
    ],
    "deverrouillent": [
        "deverrouiller"
    ],
    "deverrouiller": [
        "deverrouiller"
    ],
    "deverrouillez": [
        "deverrouiller"
    ],
    "deverrouillee": [
        "deverrouiller"
    ],
    "deverrouillees": [
        "deverrouiller"
    ],
    "deversa": [
        "deverser"
    ],
    "deversaient": [
        "deverser"
    ],
    "deversais": [
        "deverser"
    ],
    "deversait": [
        "deverser"
    ],
    "deversant": [
        "deversant",
        "deverser"
    ],
    "deverse": [
        "deverser"
    ],
    "deversement": [
        "deversement"
    ],
    "deversements": [
        "deversement"
    ],
    "deversent": [
        "deverser"
    ],
    "deverser": [
        "deverser"
    ],
    "deversera": [
        "deverser"
    ],
    "deverserai": [
        "deverser"
    ],
    "deverseraient": [
        "deverser"
    ],
    "deverserait": [
        "deverser"
    ],
    "deversez": [
        "deverser"
    ],
    "deversoir": [
        "deversoir"
    ],
    "deverserent": [
        "deverser"
    ],
    "deversee": [
        "deverser"
    ],
    "deversees": [
        "deverser"
    ],
    "deverses": [
        "deverser"
    ],
    "devia": [
        "devier"
    ],
    "deviai": [
        "devier"
    ],
    "deviaient": [
        "devier"
    ],
    "deviait": [
        "devier"
    ],
    "deviance": [
        "deviance"
    ],
    "deviances": [
        "deviance"
    ],
    "deviant": [
        "devier",
        "deviant"
    ],
    "deviante": [
        "deviant"
    ],
    "deviants": [
        "deviant"
    ],
    "deviateur": [
        "deviateur"
    ],
    "deviation": [
        "deviation"
    ],
    "deviationnisme": [
        "deviationnisme"
    ],
    "deviationniste": [
        "deviationniste"
    ],
    "deviations": [
        "deviation"
    ],
    "devida": [
        "devider"
    ],
    "devidais": [
        "devider"
    ],
    "devidait": [
        "devider"
    ],
    "devidant": [
        "devider"
    ],
    "devide": [
        "devider"
    ],
    "devident": [
        "devider"
    ],
    "devider": [
        "devider"
    ],
    "deviderait": [
        "devider"
    ],
    "devideur": [
        "devideur"
    ],
    "devidions": [
        "devider"
    ],
    "devidoir": [
        "devidoir"
    ],
    "devidoirs": [
        "devidoir"
    ],
    "devidee": [
        "devider"
    ],
    "devie": [
        "devier"
    ],
    "devier": [
        "devier"
    ],
    "deviera": [
        "devier"
    ],
    "devierait": [
        "devier"
    ],
    "devirginiser": [
        "devirginiser"
    ],
    "devirginisee": [
        "devirginiser"
    ],
    "devirilisant": [
        "deviriliser"
    ],
    "devirilisation": [
        "devirilisation"
    ],
    "devirilise": [
        "deviriliser"
    ],
    "devisage": [
        "devisager"
    ],
    "devisagea": [
        "devisager"
    ],
    "devisageai": [
        "devisager"
    ],
    "devisageaient": [
        "devisager"
    ],
    "devisageais": [
        "devisager"
    ],
    "devisageait": [
        "devisager"
    ],
    "devisageant": [
        "devisager"
    ],
    "devisagent": [
        "devisager"
    ],
    "devisageons": [
        "devisager"
    ],
    "devisager": [
        "devisager"
    ],
    "devisageraient": [
        "devisager"
    ],
    "devisagez": [
        "devisager"
    ],
    "devisageames": [
        "devisager"
    ],
    "devisagions": [
        "devisager"
    ],
    "devisagerent": [
        "devisager"
    ],
    "devisagee": [
        "devisager"
    ],
    "devisages": [
        "devisager"
    ],
    "devissa": [
        "devisser"
    ],
    "devissable": [
        "devissable"
    ],
    "devissage": [
        "devissage"
    ],
    "devissaient": [
        "devisser"
    ],
    "devissait": [
        "devisser"
    ],
    "devissant": [
        "devisser"
    ],
    "devisse": [
        "devisse",
        "devisser"
    ],
    "devisser": [
        "devisser"
    ],
    "devissera": [
        "devisser"
    ],
    "devissez": [
        "devisser"
    ],
    "devissee": [
        "devisser"
    ],
    "devissees": [
        "devisser"
    ],
    "devisses": [
        "devisser"
    ],
    "devitalisation": [
        "devitalisation"
    ],
    "devitaliser": [
        "devitaliser"
    ],
    "devitalise": [
        "devitaliser"
    ],
    "deviee": [
        "devier"
    ],
    "devies": [
        "devier"
    ],
    "devoie": [
        "devoyer"
    ],
    "devoiement": [
        "devoiement"
    ],
    "devoila": [
        "devoiler"
    ],
    "devoilai": [
        "devoiler"
    ],
    "devoilaient": [
        "devoiler"
    ],
    "devoilais": [
        "devoiler"
    ],
    "devoilait": [
        "devoiler"
    ],
    "devoilant": [
        "devoiler",
        "devoilant"
    ],
    "devoile": [
        "devoiler"
    ],
    "devoilement": [
        "devoilement"
    ],
    "devoilements": [
        "devoilement"
    ],
    "devoilent": [
        "devoiler"
    ],
    "devoiler": [
        "devoiler"
    ],
    "devoilera": [
        "devoiler"
    ],
    "devoilerai": [
        "devoiler"
    ],
    "devoilerais": [
        "devoiler"
    ],
    "devoilerait": [
        "devoiler"
    ],
    "devoilerez": [
        "devoiler"
    ],
    "devoileront": [
        "devoiler"
    ],
    "devoiles": [
        "devoiler"
    ],
    "devoilez": [
        "devoiler"
    ],
    "devoilons": [
        "devoiler"
    ],
    "devoilee": [
        "devoiler"
    ],
    "devoilees": [
        "devoiler"
    ],
    "devolu": [
        "devolu"
    ],
    "devolue": [
        "devolu"
    ],
    "devolues": [
        "devolu"
    ],
    "devolus": [
        "devolu"
    ],
    "devolution": [
        "devolution"
    ],
    "devonien": [
        "devonien"
    ],
    "devonienne": [
        "devonien"
    ],
    "devora": [
        "devorer"
    ],
    "devorai": [
        "devorer"
    ],
    "devoraient": [
        "devorer"
    ],
    "devorais": [
        "devorer"
    ],
    "devorait": [
        "devorer"
    ],
    "devorant": [
        "devorant",
        "devorer"
    ],
    "devorante": [
        "devorant"
    ],
    "devorantes": [
        "devorant"
    ],
    "devorants": [
        "devorant"
    ],
    "devorateur": [
        "devorateur"
    ],
    "devorateurs": [
        "devorateur"
    ],
    "devoration": [
        "devoration"
    ],
    "devoratrice": [
        "devorateur"
    ],
    "devore": [
        "devorer"
    ],
    "devorent": [
        "devorer"
    ],
    "devorer": [
        "devorer"
    ],
    "devorera": [
        "devorer"
    ],
    "devorerai": [
        "devorer"
    ],
    "devoreraient": [
        "devorer"
    ],
    "devorerais": [
        "devorer"
    ],
    "devorerait": [
        "devorer"
    ],
    "devorerez": [
        "devorer"
    ],
    "devoreront": [
        "devorer"
    ],
    "devores": [
        "devorer"
    ],
    "devoreur": [
        "devoreur"
    ],
    "devoreurs": [
        "devoreur"
    ],
    "devoreuse": [
        "devoreur"
    ],
    "devoreuses": [
        "devoreur"
    ],
    "devorez": [
        "devorer"
    ],
    "devorions": [
        "devorer"
    ],
    "devorons": [
        "devorer"
    ],
    "devorerent": [
        "devorer"
    ],
    "devoree": [
        "devorer"
    ],
    "devorees": [
        "devorer"
    ],
    "devot": [
        "devot"
    ],
    "devote": [
        "devot"
    ],
    "devotement": [
        "devotement"
    ],
    "devotes": [
        "devot",
        "devote"
    ],
    "devotieusement": [
        "devotieusement"
    ],
    "devotion": [
        "devotion"
    ],
    "devotionnelle": [
        "devotionnel"
    ],
    "devotions": [
        "devotion"
    ],
    "devots": [
        "devot"
    ],
    "devoua": [
        "devouer"
    ],
    "devouaient": [
        "devouer"
    ],
    "devouait": [
        "devouer"
    ],
    "devouant": [
        "devouer"
    ],
    "devoue": [
        "devoue",
        "devouer"
    ],
    "devouement": [
        "devouement"
    ],
    "devouements": [
        "devouement"
    ],
    "devouent": [
        "devouer"
    ],
    "devouer": [
        "devouer"
    ],
    "devouera": [
        "devouer"
    ],
    "devouerais": [
        "devouer"
    ],
    "devoues": [
        "devoue",
        "devouer"
    ],
    "devouez": [
        "devouer"
    ],
    "devouat": [
        "devouer"
    ],
    "devouee": [
        "devoue",
        "devouer"
    ],
    "devouees": [
        "devoue",
        "devouer"
    ],
    "devoyait": [
        "devoyer"
    ],
    "devoyer": [
        "devoyer"
    ],
    "devoyez": [
        "devoyer"
    ],
    "devoye": [
        "devoye",
        "devoyer"
    ],
    "devoyee": [
        "devoye",
        "devoyer"
    ],
    "devoyees": [
        "devoye"
    ],
    "devoyes": [
        "devoye",
        "devoyer"
    ],
    "devet": [
        "devetir"
    ],
    "devetaient": [
        "devetir"
    ],
    "devetait": [
        "devetir"
    ],
    "devetant": [
        "devetir"
    ],
    "devetez": [
        "devetir"
    ],
    "devetir": [
        "devetir"
    ],
    "devetit": [
        "devetir"
    ],
    "devetu": [
        "devetir"
    ],
    "devetue": [
        "devetir"
    ],
    "devetues": [
        "devetir"
    ],
    "devetus": [
        "devetir"
    ],
    "dezingue": [
        "dezinguer"
    ],
    "dezinguer": [
        "dezinguer"
    ],
    "dezingues": [
        "dezinguer"
    ],
    "decois": [
        "decevoir"
    ],
    "decoit": [
        "decevoir"
    ],
    "decoive": [
        "decevoir"
    ],
    "decoivent": [
        "decevoir"
    ],
    "decoives": [
        "decevoir"
    ],
    "decu": [
        "decevoir",
        "decu"
    ],
    "decue": [
        "decevoir",
        "decu"
    ],
    "decues": [
        "decevoir",
        "decu"
    ],
    "decurent": [
        "decevoir"
    ],
    "decus": [
        "decevoir",
        "decu"
    ],
    "decut": [
        "decevoir"
    ],
    "decumes": [
        "decevoir"
    ],
    "dime": [
        "dime"
    ],
    "dimes": [
        "dime",
        "dire"
    ],
    "dina": [
        "diner"
    ],
    "dinai": [
        "diner"
    ],
    "dinaient": [
        "diner"
    ],
    "dinais": [
        "diner"
    ],
    "dinait": [
        "diner"
    ],
    "dinant": [
        "diner"
    ],
    "dinatoire": [
        "dinatoire"
    ],
    "dinatoires": [
        "dinatoire"
    ],
    "dinent": [
        "diner"
    ],
    "diner": [
        "diner"
    ],
    "dinera": [
        "diner"
    ],
    "dinerai": [
        "diner"
    ],
    "dineraient": [
        "diner"
    ],
    "dinerais": [
        "diner"
    ],
    "dinerait": [
        "diner"
    ],
    "dineras": [
        "diner"
    ],
    "dinerez": [
        "diner"
    ],
    "dineriez": [
        "diner"
    ],
    "dinerions": [
        "diner"
    ],
    "dinerons": [
        "diner"
    ],
    "dineront": [
        "diner"
    ],
    "diners": [
        "diner"
    ],
    "dines": [
        "dine",
        "diner"
    ],
    "dinette": [
        "dinette"
    ],
    "dinettes": [
        "dinette"
    ],
    "dineur": [
        "dineur"
    ],
    "dineurs": [
        "dineur"
    ],
    "dineuse": [
        "dineur"
    ],
    "dinez": [
        "diner"
    ],
    "diniez": [
        "diner"
    ],
    "dinions": [
        "diner"
    ],
    "dinons": [
        "diner"
    ],
    "dinames": [
        "diner"
    ],
    "dinat": [
        "diner"
    ],
    "dinerent": [
        "diner"
    ],
    "dole": [
        "dole"
    ],
    "dome": [
        "dome"
    ],
    "domes": [
        "dome"
    ],
    "dongs": [
        "dong"
    ],
    "dument": [
        "dument"
    ],
    "dumes": [
        "devoir"
    ],
    "e": [
        "2e",
        "58e",
        "7e",
        "e"
    ],
    "eau": [
        "eau"
    ],
    "eaux": [
        "eau"
    ],
    "ecchymose": [
        "ecchymose",
        "ecchymoser"
    ],
    "ecchymoses": [
        "ecchymose"
    ],
    "ecchymosee": [
        "ecchymose"
    ],
    "ecclesiale": [
        "ecclesial"
    ],
    "ecclesiastique": [
        "ecclesiastique"
    ],
    "ecclesiastiques": [
        "ecclesiastique"
    ],
    "ecsta": [
        "ecsta"
    ],
    "ecstasy": [
        "ecstasy"
    ],
    "ectasie": [
        "ectasie"
    ],
    "ecthyma": [
        "ecthyma"
    ],
    "ectodermique": [
        "ectodermique"
    ],
    "ectopie": [
        "ectopie"
    ],
    "ectopique": [
        "ectopique"
    ],
    "ectoplasme": [
        "ectoplasme"
    ],
    "ectoplasmes": [
        "ectoplasme"
    ],
    "ectoplasmique": [
        "ectoplasmique"
    ],
    "ectoplasmiques": [
        "ectoplasmique"
    ],
    "eczema": [
        "eczema"
    ],
    "eczemas": [
        "eczema"
    ],
    "eczemateuses": [
        "eczemateux"
    ],
    "eczemateux": [
        "eczemateux"
    ],
    "edelweiss": [
        "edelweiss"
    ],
    "edwardienne": [
        "edwardien"
    ],
    "efface": [
        "efface",
        "effacer"
    ],
    "effacement": [
        "effacement"
    ],
    "effacements": [
        "effacement"
    ],
    "effacent": [
        "effacer"
    ],
    "effacer": [
        "effacer"
    ],
    "effacera": [
        "effacer"
    ],
    "effacerai": [
        "effacer"
    ],
    "effaceraient": [
        "effacer"
    ],
    "effacerais": [
        "effacer"
    ],
    "effacerait": [
        "effacer"
    ],
    "effaceras": [
        "effacer"
    ],
    "effacerez": [
        "effacer"
    ],
    "effacerions": [
        "effacer"
    ],
    "effacerons": [
        "effacer"
    ],
    "effaceront": [
        "effacer"
    ],
    "effaces": [
        "efface",
        "effacer"
    ],
    "effaceur": [
        "effaceur"
    ],
    "effacez": [
        "effacer"
    ],
    "effaciez": [
        "effacer"
    ],
    "effacions": [
        "effacer"
    ],
    "effacerent": [
        "effacer"
    ],
    "effacee": [
        "efface",
        "effacer"
    ],
    "effacees": [
        "efface",
        "effacer"
    ],
    "effara": [
        "effarer"
    ],
    "effaraient": [
        "effarer"
    ],
    "effarait": [
        "effarer"
    ],
    "effarant": [
        "effarer",
        "effarant"
    ],
    "effarante": [
        "effarant"
    ],
    "effarantes": [
        "effarant"
    ],
    "effarants": [
        "effarant"
    ],
    "effare": [
        "effarer",
        "effare"
    ],
    "effarement": [
        "effarement"
    ],
    "effarer": [
        "effarer"
    ],
    "effaroucha": [
        "effaroucher"
    ],
    "effarouchaient": [
        "effaroucher"
    ],
    "effarouchait": [
        "effaroucher"
    ],
    "effarouchant": [
        "effaroucher"
    ],
    "effarouche": [
        "effaroucher",
        "effarouche"
    ],
    "effarouchement": [
        "effarouchement"
    ],
    "effarouchements": [
        "effarouchement"
    ],
    "effarouchent": [
        "effaroucher"
    ],
    "effaroucher": [
        "effaroucher"
    ],
    "effarouches": [
        "effaroucher",
        "effarouche"
    ],
    "effarouchames": [
        "effaroucher"
    ],
    "effarouchat": [
        "effaroucher"
    ],
    "effarouchee": [
        "effaroucher",
        "effarouche"
    ],
    "effarouchees": [
        "effarouche"
    ],
    "effarvatte": [
        "effarvatte"
    ],
    "effarvattes": [
        "effarvatte"
    ],
    "effarerent": [
        "effarer"
    ],
    "effaree": [
        "effarer",
        "effare"
    ],
    "effarees": [
        "effare"
    ],
    "effares": [
        "effarer",
        "effare"
    ],
    "effaca": [
        "effacer"
    ],
    "effacable": [
        "effacable"
    ],
    "effacables": [
        "effacable"
    ],
    "effacage": [
        "effacage"
    ],
    "effacai": [
        "effacer"
    ],
    "effacaient": [
        "effacer"
    ],
    "effacais": [
        "effacer"
    ],
    "effacait": [
        "effacer"
    ],
    "effacant": [
        "effacer"
    ],
    "effacassent": [
        "effacer"
    ],
    "effacons": [
        "effacer"
    ],
    "effacat": [
        "effacer"
    ],
    "effectif": [
        "effectif"
    ],
    "effectifs": [
        "effectif"
    ],
    "effective": [
        "effectif"
    ],
    "effectivement": [
        "effectivement"
    ],
    "effectives": [
        "effectif"
    ],
    "effectivite": [
        "effectivite"
    ],
    "effectua": [
        "effectuer"
    ],
    "effectuai": [
        "effectuer"
    ],
    "effectuaient": [
        "effectuer"
    ],
    "effectuais": [
        "effectuer"
    ],
    "effectuait": [
        "effectuer"
    ],
    "effectuant": [
        "effectuer"
    ],
    "effectue": [
        "effectuer"
    ],
    "effectuent": [
        "effectuer"
    ],
    "effectuer": [
        "effectuer"
    ],
    "effectuera": [
        "effectuer"
    ],
    "effectuerai": [
        "effectuer"
    ],
    "effectuerait": [
        "effectuer"
    ],
    "effectuerons": [
        "effectuer"
    ],
    "effectues": [
        "effectuer"
    ],
    "effectuez": [
        "effectuer"
    ],
    "effectuions": [
        "effectuer"
    ],
    "effectuons": [
        "effectuer"
    ],
    "effectuee": [
        "effectuer"
    ],
    "effectuees": [
        "effectuer"
    ],
    "effendi": [
        "effendi"
    ],
    "effervescence": [
        "effervescence"
    ],
    "effervescences": [
        "effervescence"
    ],
    "effervescent": [
        "effervescent"
    ],
    "effervescente": [
        "effervescent"
    ],
    "effervescentes": [
        "effervescent"
    ],
    "effervescents": [
        "effervescent"
    ],
    "effet": [
        "effet"
    ],
    "effets": [
        "effet"
    ],
    "effeuilla": [
        "effeuiller"
    ],
    "effeuillage": [
        "effeuillage"
    ],
    "effeuillaient": [
        "effeuiller"
    ],
    "effeuillait": [
        "effeuiller"
    ],
    "effeuillant": [
        "effeuiller"
    ],
    "effeuille": [
        "effeuiller"
    ],
    "effeuillent": [
        "effeuiller"
    ],
    "effeuiller": [
        "effeuiller"
    ],
    "effeuilleras": [
        "effeuiller"
    ],
    "effeuilleuse": [
        "effeuilleur"
    ],
    "effeuilleuses": [
        "effeuilleur"
    ],
    "effeuillez": [
        "effeuiller"
    ],
    "effeuillerent": [
        "effeuiller"
    ],
    "effeuillee": [
        "effeuiller"
    ],
    "effeuilles": [
        "effeuiller"
    ],
    "efficace": [
        "efficace"
    ],
    "efficacement": [
        "efficacement"
    ],
    "efficaces": [
        "efficace"
    ],
    "efficacite": [
        "efficacite"
    ],
    "efficience": [
        "efficience"
    ],
    "efficient": [
        "efficient"
    ],
    "efficiente": [
        "efficient"
    ],
    "efficientes": [
        "efficient"
    ],
    "efficients": [
        "efficient"
    ],
    "effigie": [
        "effigie"
    ],
    "effigies": [
        "effigie",
        "effigy"
    ],
    "effila": [
        "effiler"
    ],
    "effilaient": [
        "effiler"
    ],
    "effilait": [
        "effiler"
    ],
    "effilant": [
        "effiler"
    ],
    "effile": [
        "effiler",
        "effile"
    ],
    "effilement": [
        "effilement"
    ],
    "effilent": [
        "effiler"
    ],
    "effiler": [
        "effiler"
    ],
    "effilochage": [
        "effilochage"
    ],
    "effilochaient": [
        "effilocher"
    ],
    "effilochait": [
        "effilocher"
    ],
    "effilochant": [
        "effilocher"
    ],
    "effiloche": [
        "effilocher"
    ],
    "effilochent": [
        "effilocher"
    ],
    "effilocher": [
        "effilocher"
    ],
    "effilochera": [
        "effilocher"
    ],
    "effilochure": [
        "effilochure"
    ],
    "effilochures": [
        "effilochure"
    ],
    "effilocherent": [
        "effilocher"
    ],
    "effilochee": [
        "effilocher"
    ],
    "effilochees": [
        "effilocher"
    ],
    "effiloches": [
        "effilocher"
    ],
    "effilure": [
        "effilure"
    ],
    "effilures": [
        "effilure"
    ],
    "effilee": [
        "effiler",
        "effile"
    ],
    "effilees": [
        "effiler",
        "effile"
    ],
    "effiles": [
        "effiler",
        "effile"
    ],
    "efflanque": [
        "efflanque",
        "efflanquer"
    ],
    "efflanquee": [
        "efflanque",
        "efflanquer"
    ],
    "efflanquees": [
        "efflanque",
        "efflanquer"
    ],
    "efflanques": [
        "efflanque",
        "efflanquer"
    ],
    "effleura": [
        "effleurer"
    ],
    "effleurage": [
        "effleurage"
    ],
    "effleurai": [
        "effleurer"
    ],
    "effleuraient": [
        "effleurer"
    ],
    "effleurais": [
        "effleurer"
    ],
    "effleurait": [
        "effleurer"
    ],
    "effleurant": [
        "effleurer"
    ],
    "effleure": [
        "effleurer"
    ],
    "effleurement": [
        "effleurement"
    ],
    "effleurements": [
        "effleurement"
    ],
    "effleurent": [
        "effleurer"
    ],
    "effleurer": [
        "effleurer"
    ],
    "effleurera": [
        "effleurer"
    ],
    "effleurerait": [
        "effleurer"
    ],
    "effleureront": [
        "effleurer"
    ],
    "effleures": [
        "effleurer"
    ],
    "effleurez": [
        "effleurer"
    ],
    "effleurames": [
        "effleurer"
    ],
    "effleurat": [
        "effleurer"
    ],
    "effleurerent": [
        "effleurer"
    ],
    "effleuree": [
        "effleurer"
    ],
    "effleurees": [
        "effleurer"
    ],
    "efflorescence": [
        "efflorescence"
    ],
    "effluent": [
        "effluent"
    ],
    "effluve": [
        "effluve"
    ],
    "effluves": [
        "effluve"
    ],
    "effondra": [
        "effondrer"
    ],
    "effondrai": [
        "effondrer"
    ],
    "effondraient": [
        "effondrer"
    ],
    "effondrais": [
        "effondrer"
    ],
    "effondrait": [
        "effondrer"
    ],
    "effondrant": [
        "effondrer"
    ],
    "effondre": [
        "effondre",
        "effondrer"
    ],
    "effondrement": [
        "effondrement"
    ],
    "effondrements": [
        "effondrement"
    ],
    "effondrent": [
        "effondrer"
    ],
    "effondrer": [
        "effondrer"
    ],
    "effondrera": [
        "effondrer"
    ],
    "effondreraient": [
        "effondrer"
    ],
    "effondrerais": [
        "effondrer"
    ],
    "effondrerait": [
        "effondrer"
    ],
    "effondreront": [
        "effondrer"
    ],
    "effondrez": [
        "effondrer"
    ],
    "effondrat": [
        "effondrer"
    ],
    "effondrerent": [
        "effondrer"
    ],
    "effondree": [
        "effondre",
        "effondrer"
    ],
    "effondrees": [
        "effondre",
        "effondrer"
    ],
    "effondres": [
        "effondre",
        "effondrer"
    ],
    "efforce": [
        "efforcer"
    ],
    "efforcent": [
        "efforcer"
    ],
    "efforcer": [
        "efforcer"
    ],
    "efforcera": [
        "efforcer"
    ],
    "efforcerai": [
        "efforcer"
    ],
    "efforceraient": [
        "efforcer"
    ],
    "efforcerais": [
        "efforcer"
    ],
    "efforcerait": [
        "efforcer"
    ],
    "efforcerons": [
        "efforcer"
    ],
    "efforces": [
        "efforcer"
    ],
    "efforcez": [
        "efforcer"
    ],
    "efforcions": [
        "efforcer"
    ],
    "efforcerent": [
        "efforcer"
    ],
    "efforcee": [
        "efforcer"
    ],
    "effort": [
        "effort"
    ],
    "efforts": [
        "effort"
    ],
    "efforca": [
        "efforcer"
    ],
    "efforcai": [
        "efforcer"
    ],
    "efforcaient": [
        "efforcer"
    ],
    "efforcais": [
        "efforcer"
    ],
    "efforcait": [
        "efforcer"
    ],
    "efforcant": [
        "efforcer"
    ],
    "efforcons": [
        "efforcer"
    ],
    "efforcames": [
        "efforcer"
    ],
    "efforcat": [
        "efforcer"
    ],
    "effraction": [
        "effraction"
    ],
    "effractions": [
        "effraction"
    ],
    "effraie": [
        "effrayer",
        "effraie"
    ],
    "effraient": [
        "effrayer"
    ],
    "effraiera": [
        "effrayer"
    ],
    "effraieraient": [
        "effrayer"
    ],
    "effraierait": [
        "effrayer"
    ],
    "effraieras": [
        "effrayer"
    ],
    "effraierez": [
        "effrayer"
    ],
    "effraies": [
        "effrayer",
        "effraie"
    ],
    "effrange": [
        "effranger"
    ],
    "effrangeait": [
        "effranger"
    ],
    "effrangent": [
        "effranger"
    ],
    "effrangee": [
        "effranger"
    ],
    "effrangees": [
        "effranger"
    ],
    "effranges": [
        "effranger"
    ],
    "effraya": [
        "effrayer"
    ],
    "effrayaient": [
        "effrayer"
    ],
    "effrayais": [
        "effrayer"
    ],
    "effrayait": [
        "effrayer"
    ],
    "effrayamment": [
        "effrayamment"
    ],
    "effrayant": [
        "effrayer",
        "effrayant"
    ],
    "effrayante": [
        "effrayant"
    ],
    "effrayantes": [
        "effrayant"
    ],
    "effrayants": [
        "effrayant"
    ],
    "effraye": [
        "effrayer",
        "effraye"
    ],
    "effrayent": [
        "effrayer"
    ],
    "effrayer": [
        "effrayer"
    ],
    "effrayerais": [
        "effrayer"
    ],
    "effrayerait": [
        "effrayer"
    ],
    "effrayeras": [
        "effrayer"
    ],
    "effrayez": [
        "effrayer"
    ],
    "effrayons": [
        "effrayer"
    ],
    "effrayerent": [
        "effrayer"
    ],
    "effrayee": [
        "effrayer",
        "effraye"
    ],
    "effrayees": [
        "effrayer",
        "effraye"
    ],
    "effrayes": [
        "effrayer",
        "effraye"
    ],
    "effrita": [
        "effriter"
    ],
    "effritaient": [
        "effriter"
    ],
    "effritait": [
        "effriter"
    ],
    "effritant": [
        "effriter"
    ],
    "effrite": [
        "effriter"
    ],
    "effritement": [
        "effritement"
    ],
    "effritements": [
        "effritement"
    ],
    "effritent": [
        "effriter"
    ],
    "effriter": [
        "effriter"
    ],
    "effriterait": [
        "effriter"
    ],
    "effritee": [
        "effriter"
    ],
    "effritees": [
        "effriter"
    ],
    "effrites": [
        "effriter"
    ],
    "effroi": [
        "effroi"
    ],
    "effronterie": [
        "effronterie"
    ],
    "effronteries": [
        "effronterie"
    ],
    "effronte": [
        "effronte"
    ],
    "effrontee": [
        "effronte"
    ],
    "effrontees": [
        "effronte"
    ],
    "effrontement": [
        "effrontement"
    ],
    "effrontes": [
        "effronte"
    ],
    "effroyable": [
        "effroyable"
    ],
    "effroyablement": [
        "effroyablement"
    ],
    "effroyables": [
        "effroyable"
    ],
    "effrene": [
        "effrene"
    ],
    "effrenee": [
        "effrene"
    ],
    "effrenees": [
        "effrene"
    ],
    "effrenes": [
        "effrene"
    ],
    "effulgente": [
        "effulgent"
    ],
    "effusion": [
        "effusion"
    ],
    "effusionniste": [
        "effusionniste"
    ],
    "effusionnistes": [
        "effusionniste"
    ],
    "effusions": [
        "effusion"
    ],
    "effeminait": [
        "effeminer"
    ],
    "effemine": [
        "effemine",
        "effeminer"
    ],
    "effeminee": [
        "effemine",
        "effeminer"
    ],
    "effemines": [
        "effemine",
        "effeminer"
    ],
    "efrit": [
        "efrit"
    ],
    "ego": [
        "ego"
    ],
    "eh": [
        "eh"
    ],
    "eider": [
        "eider"
    ],
    "eiders": [
        "eider"
    ],
    "eidetique": [
        "eidetique"
    ],
    "einsteinienne": [
        "einsteinien"
    ],
    "ektachromes": [
        "ektachrome"
    ],
    "eldorado": [
        "eldorado"
    ],
    "elfe": [
        "elfe"
    ],
    "elfes": [
        "elfe"
    ],
    "elle": [
        "elle",
        "il"
    ],
    "elles": [
        "elles"
    ],
    "ellipse": [
        "ellipse"
    ],
    "ellipses": [
        "ellipse"
    ],
    "ellipsoide": [
        "ellipsoide"
    ],
    "elliptique": [
        "elliptique"
    ],
    "elliptiques": [
        "elliptique"
    ],
    "ellebore": [
        "ellebore"
    ],
    "elzevir": [
        "elzevir"
    ],
    "emails": [
        "email"
    ],
    "embabouiner": [
        "embabouiner"
    ],
    "emballa": [
        "emballer"
    ],
    "emballage": [
        "emballage"
    ],
    "emballages": [
        "emballage"
    ],
    "emballai": [
        "emballer"
    ],
    "emballaient": [
        "emballer"
    ],
    "emballais": [
        "emballer"
    ],
    "emballait": [
        "emballer"
    ],
    "emballant": [
        "emballer"
    ],
    "emballe": [
        "emballer",
        "emballe"
    ],
    "emballement": [
        "emballement"
    ],
    "emballements": [
        "emballement"
    ],
    "emballent": [
        "emballer"
    ],
    "emballer": [
        "emballer"
    ],
    "emballera": [
        "emballer"
    ],
    "emballeraient": [
        "emballer"
    ],
    "emballerait": [
        "emballer"
    ],
    "emballeras": [
        "emballer"
    ],
    "emballerons": [
        "emballer"
    ],
    "emballes": [
        "emballer",
        "emballe"
    ],
    "emballeur": [
        "emballeur"
    ],
    "emballeurs": [
        "emballeur"
    ],
    "emballeuse": [
        "emballeur"
    ],
    "emballeuses": [
        "emballeur"
    ],
    "emballez": [
        "emballer"
    ],
    "emballons": [
        "emballer"
    ],
    "emballat": [
        "emballer"
    ],
    "emballerent": [
        "emballer"
    ],
    "emballee": [
        "emballer",
        "emballe"
    ],
    "emballees": [
        "emballer",
        "emballe"
    ],
    "embaluchonnes": [
        "embaluchonner"
    ],
    "embarbouilla": [
        "embarbouiller"
    ],
    "embarbouille": [
        "embarbouiller"
    ],
    "embarcadere": [
        "embarcadere"
    ],
    "embarcaderes": [
        "embarcadere"
    ],
    "embarcation": [
        "embarcation"
    ],
    "embarcations": [
        "embarcation"
    ],
    "embardee": [
        "embardee"
    ],
    "embardees": [
        "embardee"
    ],
    "embargo": [
        "embargo"
    ],
    "embargos": [
        "embargo"
    ],
    "embarqua": [
        "embarquer"
    ],
    "embarquai": [
        "embarquer"
    ],
    "embarquaient": [
        "embarquer"
    ],
    "embarquais": [
        "embarquer"
    ],
    "embarquait": [
        "embarquer"
    ],
    "embarquant": [
        "embarquer"
    ],
    "embarque": [
        "embarquer"
    ],
    "embarquement": [
        "embarquement"
    ],
    "embarquements": [
        "embarquement"
    ],
    "embarquent": [
        "embarquer"
    ],
    "embarquer": [
        "embarquer"
    ],
    "embarquera": [
        "embarquer"
    ],
    "embarquerai": [
        "embarquer"
    ],
    "embarqueraient": [
        "embarquer"
    ],
    "embarquerais": [
        "embarquer"
    ],
    "embarquerait": [
        "embarquer"
    ],
    "embarqueras": [
        "embarquer"
    ],
    "embarquerez": [
        "embarquer"
    ],
    "embarquerions": [
        "embarquer"
    ],
    "embarqueront": [
        "embarquer"
    ],
    "embarquez": [
        "embarquer"
    ],
    "embarquiez": [
        "embarquer"
    ],
    "embarquions": [
        "embarquer"
    ],
    "embarquons": [
        "embarquer"
    ],
    "embarquames": [
        "embarquer"
    ],
    "embarquerent": [
        "embarquer"
    ],
    "embarquee": [
        "embarquer"
    ],
    "embarquees": [
        "embarquer"
    ],
    "embarques": [
        "embarquer"
    ],
    "embarras": [
        "embarras",
        "embarrer"
    ],
    "embarrassa": [
        "embarrasser"
    ],
    "embarrassai": [
        "embarrasser"
    ],
    "embarrassaient": [
        "embarrasser"
    ],
    "embarrassais": [
        "embarrasser"
    ],
    "embarrassait": [
        "embarrasser"
    ],
    "embarrassant": [
        "embarrasser",
        "embarrassant"
    ],
    "embarrassante": [
        "embarrassant"
    ],
    "embarrassantes": [
        "embarrassant"
    ],
    "embarrassants": [
        "embarrassant"
    ],
    "embarrasse": [
        "embarrasser",
        "embarrasse"
    ],
    "embarrassent": [
        "embarrasser"
    ],
    "embarrasser": [
        "embarrasser"
    ],
    "embarrasserai": [
        "embarrasser"
    ],
    "embarrasseraient": [
        "embarrasser"
    ],
    "embarrasses": [
        "embarrasser",
        "embarrasse",
        "embarrass"
    ],
    "embarrassez": [
        "embarrasser"
    ],
    "embarrassions": [
        "embarrasser"
    ],
    "embarrassons": [
        "embarrasser"
    ],
    "embarrasserent": [
        "embarrasser"
    ],
    "embarrassee": [
        "embarrasser",
        "embarrasse"
    ],
    "embarrassees": [
        "embarrasser",
        "embarrasse"
    ],
    "embarrure": [
        "embarrure"
    ],
    "embase": [
        "embase"
    ],
    "embases": [
        "embase"
    ],
    "embastiller": [
        "embastiller"
    ],
    "embastille": [
        "embastiller"
    ],
    "embastillee": [
        "embastiller"
    ],
    "embastilles": [
        "embastiller"
    ],
    "embats": [
        "embattre"
    ],
    "embaucha": [
        "embaucher"
    ],
    "embauchage": [
        "embauchage"
    ],
    "embauchaient": [
        "embaucher"
    ],
    "embauchais": [
        "embaucher"
    ],
    "embauchait": [
        "embaucher"
    ],
    "embauchant": [
        "embaucher"
    ],
    "embauche": [
        "embaucher",
        "embauche"
    ],
    "embauchent": [
        "embaucher"
    ],
    "embaucher": [
        "embaucher"
    ],
    "embauchera": [
        "embaucher"
    ],
    "embaucherai": [
        "embaucher"
    ],
    "embaucherais": [
        "embaucher"
    ],
    "embaucherait": [
        "embaucher"
    ],
    "embaucheront": [
        "embaucher"
    ],
    "embauches": [
        "embaucher",
        "embauche"
    ],
    "embauchez": [
        "embaucher"
    ],
    "embauchoir": [
        "embauchoir"
    ],
    "embauchoirs": [
        "embauchoir"
    ],
    "embauchons": [
        "embaucher"
    ],
    "embauchat": [
        "embaucher"
    ],
    "embauchee": [
        "embaucher"
    ],
    "embauchees": [
        "embaucher"
    ],
    "embauma": [
        "embaumer"
    ],
    "embaumaient": [
        "embaumer"
    ],
    "embaumait": [
        "embaumer"
    ],
    "embaumant": [
        "embaumant"
    ],
    "embaumants": [
        "embaumant"
    ],
    "embaume": [
        "embaumer"
    ],
    "embaumement": [
        "embaumement"
    ],
    "embaumements": [
        "embaumement"
    ],
    "embaument": [
        "embaumer"
    ],
    "embaumer": [
        "embaumer"
    ],
    "embaumerait": [
        "embaumer"
    ],
    "embaumeur": [
        "embaumeur"
    ],
    "embaumeurs": [
        "embaumeur"
    ],
    "embaumeuse": [
        "embaumeur"
    ],
    "embaumez": [
        "embaumer"
    ],
    "embaumions": [
        "embaumer"
    ],
    "embaumee": [
        "embaumer"
    ],
    "embaumees": [
        "embaumer"
    ],
    "embaumes": [
        "embaumer"
    ],
    "embelli": [
        "embellir"
    ],
    "embellie": [
        "embellie",
        "embellir"
    ],
    "embellies": [
        "embellie",
        "embellir"
    ],
    "embellir": [
        "embellir"
    ],
    "embellira": [
        "embellir"
    ],
    "embellirai": [
        "embellir"
    ],
    "embellirait": [
        "embellir"
    ],
    "embellis": [
        "embellir"
    ],
    "embellissaient": [
        "embellir"
    ],
    "embellissais": [
        "embellir"
    ],
    "embellissait": [
        "embellir"
    ],
    "embellissant": [
        "embellir"
    ],
    "embellissement": [
        "embellissement"
    ],
    "embellissements": [
        "embellissement"
    ],
    "embellissent": [
        "embellir"
    ],
    "embellissez": [
        "embellir"
    ],
    "embellissons": [
        "embellir"
    ],
    "embellit": [
        "embellir"
    ],
    "emberlificotaient": [
        "emberlificoter"
    ],
    "emberlificotais": [
        "emberlificoter"
    ],
    "emberlificote": [
        "emberlificote",
        "emberlificoter"
    ],
    "emberlificoter": [
        "emberlificoter"
    ],
    "emberlificotee": [
        "emberlificoter"
    ],
    "emberlificotees": [
        "emberlificoter"
    ],
    "emberlificotes": [
        "emberlificote"
    ],
    "emberlucoquer": [
        "emberlucoquer"
    ],
    "embijoutee": [
        "embijoute"
    ],
    "emblavages": [
        "emblavage"
    ],
    "emblaver": [
        "emblaver"
    ],
    "emblavure": [
        "emblavure"
    ],
    "emblavures": [
        "emblavure"
    ],
    "emblave": [
        "emblaver"
    ],
    "emblavee": [
        "emblaver"
    ],
    "embleme": [
        "embleme"
    ],
    "emblemes": [
        "embleme"
    ],
    "emblematique": [
        "emblematique"
    ],
    "emblematiques": [
        "emblematique"
    ],
    "embobeliner": [
        "embobeliner"
    ],
    "embobinant": [
        "embobiner"
    ],
    "embobine": [
        "embobiner"
    ],
    "embobiner": [
        "embobiner"
    ],
    "embobinez": [
        "embobiner"
    ],
    "embobinee": [
        "embobiner"
    ],
    "embobinees": [
        "embobiner"
    ],
    "embobines": [
        "embobiner"
    ],
    "embole": [
        "embole"
    ],
    "embolie": [
        "embolie"
    ],
    "embolies": [
        "embolie"
    ],
    "embolique": [
        "embolique"
    ],
    "embonpoint": [
        "embonpoint"
    ],
    "embosser": [
        "embosser"
    ],
    "embosse": [
        "embosser"
    ],
    "embossee": [
        "embosser"
    ],
    "embosses": [
        "embosser"
    ],
    "emboucanent": [
        "emboucaner"
    ],
    "emboucha": [
        "emboucher"
    ],
    "embouchant": [
        "emboucher"
    ],
    "embouche": [
        "embouche",
        "emboucher"
    ],
    "emboucher": [
        "emboucher"
    ],
    "emboucherait": [
        "emboucher"
    ],
    "embouchoir": [
        "embouchoir"
    ],
    "embouchoirs": [
        "embouchoir"
    ],
    "embouchure": [
        "embouchure"
    ],
    "embouchures": [
        "embouchure"
    ],
    "embouchee": [
        "embouche"
    ],
    "embouchees": [
        "embouche"
    ],
    "embouches": [
        "embouche"
    ],
    "embouquer": [
        "embouquer"
    ],
    "embouque": [
        "embouquer"
    ],
    "embourbaient": [
        "embourber"
    ],
    "embourbait": [
        "embourber"
    ],
    "embourbe": [
        "embourber",
        "embourbe"
    ],
    "embourbent": [
        "embourber"
    ],
    "embourber": [
        "embourber"
    ],
    "embourbee": [
        "embourber",
        "embourbe"
    ],
    "embourbees": [
        "embourber",
        "embourbe"
    ],
    "embourbes": [
        "embourber",
        "embourbe"
    ],
    "embourgeoise": [
        "embourgeoise",
        "embourgeoiser"
    ],
    "embourgeoisement": [
        "embourgeoisement"
    ],
    "embourgeoiser": [
        "embourgeoiser"
    ],
    "embourgeoises": [
        "embourgeoise",
        "embourgeoiser"
    ],
    "embout": [
        "embout"
    ],
    "embouteillage": [
        "embouteillage"
    ],
    "embouteillages": [
        "embouteillage"
    ],
    "embouteillait": [
        "embouteiller"
    ],
    "embouteille": [
        "embouteiller"
    ],
    "embouteiller": [
        "embouteiller"
    ],
    "embouteillee": [
        "embouteiller",
        "embouteille"
    ],
    "embouteillees": [
        "embouteiller",
        "embouteille"
    ],
    "embouti": [
        "embouti",
        "emboutir"
    ],
    "emboutie": [
        "embouti",
        "emboutir"
    ],
    "embouties": [
        "embouti",
        "emboutir"
    ],
    "emboutir": [
        "emboutir"
    ],
    "emboutis": [
        "emboutir"
    ],
    "emboutissant": [
        "emboutir"
    ],
    "emboutisseur": [
        "emboutisseur"
    ],
    "emboutisseuse": [
        "emboutisseur"
    ],
    "emboutit": [
        "emboutir"
    ],
    "embouts": [
        "embout"
    ],
    "emboita": [
        "emboiter"
    ],
    "emboitables": [
        "emboitable"
    ],
    "emboitage": [
        "emboitage"
    ],
    "emboitages": [
        "emboitage"
    ],
    "emboitai": [
        "emboiter"
    ],
    "emboitaient": [
        "emboiter"
    ],
    "emboitais": [
        "emboiter"
    ],
    "emboitait": [
        "emboiter"
    ],
    "emboitant": [
        "emboiter"
    ],
    "emboitas": [
        "emboiter"
    ],
    "emboite": [
        "emboiter"
    ],
    "emboitement": [
        "emboitement"
    ],
    "emboitent": [
        "emboiter"
    ],
    "emboiter": [
        "emboiter"
    ],
    "emboiterai": [
        "emboiter"
    ],
    "emboitions": [
        "emboiter"
    ],
    "emboitons": [
        "emboiter"
    ],
    "emboitures": [
        "emboiture"
    ],
    "emboitames": [
        "emboiter"
    ],
    "emboiterent": [
        "emboiter"
    ],
    "emboitee": [
        "emboiter"
    ],
    "emboitees": [
        "emboiter"
    ],
    "emboites": [
        "emboiter"
    ],
    "embranchant": [
        "embrancher"
    ],
    "embranchement": [
        "embranchement"
    ],
    "embranchements": [
        "embranchement"
    ],
    "embraquer": [
        "embraquer"
    ],
    "embrasa": [
        "embraser"
    ],
    "embrasaient": [
        "embraser"
    ],
    "embrasait": [
        "embraser"
    ],
    "embrasant": [
        "embraser"
    ],
    "embrase": [
        "embrase",
        "embraser"
    ],
    "embrasement": [
        "embrasement"
    ],
    "embrasements": [
        "embrasement"
    ],
    "embrasent": [
        "embraser"
    ],
    "embraser": [
        "embraser"
    ],
    "embrasera": [
        "embraser"
    ],
    "embraserait": [
        "embraser"
    ],
    "embrasez": [
        "embraser"
    ],
    "embrassa": [
        "embrasser"
    ],
    "embrassade": [
        "embrassade"
    ],
    "embrassades": [
        "embrassade"
    ],
    "embrassai": [
        "embrasser"
    ],
    "embrassaient": [
        "embrasser"
    ],
    "embrassais": [
        "embrasser"
    ],
    "embrassait": [
        "embrasser"
    ],
    "embrassant": [
        "embrasser",
        "embrassant"
    ],
    "embrasse": [
        "embrasser",
        "embrasse"
    ],
    "embrassement": [
        "embrassement"
    ],
    "embrassements": [
        "embrassement"
    ],
    "embrassent": [
        "embrasser"
    ],
    "embrasser": [
        "embrasser"
    ],
    "embrassera": [
        "embrasser"
    ],
    "embrasserai": [
        "embrasser"
    ],
    "embrasseraient": [
        "embrasser"
    ],
    "embrasserais": [
        "embrasser"
    ],
    "embrasserait": [
        "embrasser"
    ],
    "embrasseras": [
        "embrasser"
    ],
    "embrasserez": [
        "embrasser"
    ],
    "embrasseriez": [
        "embrasser"
    ],
    "embrasseront": [
        "embrasser"
    ],
    "embrasses": [
        "embrasser",
        "embrasse"
    ],
    "embrasseur": [
        "embrasseur"
    ],
    "embrasseurs": [
        "embrasseur"
    ],
    "embrasseuse": [
        "embrasseur"
    ],
    "embrasseuses": [
        "embrasseur"
    ],
    "embrassez": [
        "embrasser"
    ],
    "embrassiez": [
        "embrasser"
    ],
    "embrassions": [
        "embrasser"
    ],
    "embrassons": [
        "embrasser"
    ],
    "embrassames": [
        "embrasser"
    ],
    "embrassat": [
        "embrasser"
    ],
    "embrassates": [
        "embrasser"
    ],
    "embrasserent": [
        "embrasser"
    ],
    "embrassee": [
        "embrasser",
        "embrasse"
    ],
    "embrassees": [
        "embrasser",
        "embrasse"
    ],
    "embrasure": [
        "embrasure"
    ],
    "embrasures": [
        "embrasure"
    ],
    "embraserent": [
        "embraser"
    ],
    "embrasee": [
        "embrase",
        "embraser"
    ],
    "embrasees": [
        "embrase",
        "embraser"
    ],
    "embrases": [
        "embrase",
        "embraser"
    ],
    "embraya": [
        "embrayer"
    ],
    "embrayage": [
        "embrayage"
    ],
    "embrayages": [
        "embrayage"
    ],
    "embrayais": [
        "embrayer"
    ],
    "embrayait": [
        "embrayer"
    ],
    "embrayant": [
        "embrayer"
    ],
    "embraye": [
        "embrayer"
    ],
    "embrayer": [
        "embrayer"
    ],
    "embrayes": [
        "embrayer"
    ],
    "embrayee": [
        "embrayer"
    ],
    "embrigade": [
        "embrigade",
        "embrigader"
    ],
    "embrigadee": [
        "embrigader"
    ],
    "embringua": [
        "embringuer"
    ],
    "embringuaient": [
        "embringuer"
    ],
    "embringuait": [
        "embringuer"
    ],
    "embringuer": [
        "embringuer"
    ],
    "embringues": [
        "embringuer"
    ],
    "embringue": [
        "embringuer"
    ],
    "embringuee": [
        "embringuer"
    ],
    "embrocation": [
        "embrocation"
    ],
    "embrocations": [
        "embrocation"
    ],
    "embrocha": [
        "embrocher"
    ],
    "embrochais": [
        "embrocher"
    ],
    "embrochant": [
        "embrocher"
    ],
    "embroche": [
        "embrocher"
    ],
    "embrochent": [
        "embrocher"
    ],
    "embrocher": [
        "embrocher"
    ],
    "embrochera": [
        "embrocher"
    ],
    "embrochez": [
        "embrocher"
    ],
    "embrocherent": [
        "embrocher"
    ],
    "embrochee": [
        "embrocher"
    ],
    "embrochees": [
        "embrocher"
    ],
    "embroches": [
        "embrocher"
    ],
    "embrouilla": [
        "embrouiller"
    ],
    "embrouillage": [
        "embrouillage"
    ],
    "embrouillai": [
        "embrouiller"
    ],
    "embrouillaient": [
        "embrouiller"
    ],
    "embrouillais": [
        "embrouiller"
    ],
    "embrouillait": [
        "embrouiller"
    ],
    "embrouillamini": [
        "embrouillamini"
    ],
    "embrouillaminis": [
        "embrouillamini"
    ],
    "embrouillant": [
        "embrouiller"
    ],
    "embrouillasse": [
        "embrouiller"
    ],
    "embrouille": [
        "embrouille",
        "embrouiller"
    ],
    "embrouillement": [
        "embrouillement"
    ],
    "embrouillements": [
        "embrouillement"
    ],
    "embrouillent": [
        "embrouiller"
    ],
    "embrouiller": [
        "embrouiller"
    ],
    "embrouillerai": [
        "embrouiller"
    ],
    "embrouillerais": [
        "embrouiller"
    ],
    "embrouillerait": [
        "embrouiller"
    ],
    "embrouilles": [
        "embrouille",
        "embrouiller"
    ],
    "embrouilleur": [
        "embrouilleur"
    ],
    "embrouilleurs": [
        "embrouilleur"
    ],
    "embrouilleuses": [
        "embrouilleur"
    ],
    "embrouillez": [
        "embrouiller"
    ],
    "embrouillat": [
        "embrouiller"
    ],
    "embrouillerent": [
        "embrouiller"
    ],
    "embrouillee": [
        "embrouille",
        "embrouiller"
    ],
    "embrouillees": [
        "embrouille",
        "embrouiller"
    ],
    "embroussaille": [
        "embroussailler",
        "embroussaille"
    ],
    "embroussailler": [
        "embroussailler"
    ],
    "embroussaillee": [
        "embroussailler"
    ],
    "embroussaillees": [
        "embroussailler"
    ],
    "embroussailles": [
        "embroussailler",
        "embroussaille"
    ],
    "embruine": [
        "embruine"
    ],
    "embrumait": [
        "embrumer"
    ],
    "embrume": [
        "embrumer",
        "embrume"
    ],
    "embrument": [
        "embrumer"
    ],
    "embrumer": [
        "embrumer"
    ],
    "embrumee": [
        "embrumer",
        "embrume"
    ],
    "embrumees": [
        "embrumer",
        "embrume"
    ],
    "embrumes": [
        "embrumer",
        "embrume"
    ],
    "embrun": [
        "embrun"
    ],
    "embruns": [
        "embrun"
    ],
    "embryologie": [
        "embryologie"
    ],
    "embryologiste": [
        "embryologiste"
    ],
    "embryon": [
        "embryon"
    ],
    "embryonnaire": [
        "embryonnaire"
    ],
    "embryonnaires": [
        "embryonnaire"
    ],
    "embryons": [
        "embryon"
    ],
    "embu": [
        "embu"
    ],
    "embua": [
        "embuer"
    ],
    "embuaient": [
        "embuer"
    ],
    "embuait": [
        "embuer"
    ],
    "embuant": [
        "embuer"
    ],
    "embue": [
        "embuer",
        "embue"
    ],
    "embuent": [
        "embuer"
    ],
    "embuer": [
        "embuer"
    ],
    "embus": [
        "embu"
    ],
    "embuscade": [
        "embuscade"
    ],
    "embuscades": [
        "embuscade"
    ],
    "embusqua": [
        "embusquer"
    ],
    "embusquaient": [
        "embusquer"
    ],
    "embusquait": [
        "embusquer"
    ],
    "embusque": [
        "embusque",
        "embusquer"
    ],
    "embusquent": [
        "embusquer"
    ],
    "embusquer": [
        "embusquer"
    ],
    "embusquee": [
        "embusque",
        "embusquer"
    ],
    "embusquees": [
        "embusque",
        "embusquer"
    ],
    "embusques": [
        "embusque",
        "embusquer"
    ],
    "embuerent": [
        "embuer"
    ],
    "embuee": [
        "embuer",
        "embue"
    ],
    "embuees": [
        "embuer",
        "embue"
    ],
    "embues": [
        "embuer",
        "embue"
    ],
    "embacle": [
        "embacle"
    ],
    "embeguinees": [
        "embeguiner"
    ],
    "embetaient": [
        "embeter"
    ],
    "embetais": [
        "embeter"
    ],
    "embetait": [
        "embeter"
    ],
    "embetant": [
        "embetant"
    ],
    "embetante": [
        "embetant"
    ],
    "embetantes": [
        "embetant"
    ],
    "embetants": [
        "embetant"
    ],
    "embete": [
        "embeter",
        "embete"
    ],
    "embetement": [
        "embetement"
    ],
    "embetements": [
        "embetement"
    ],
    "embetent": [
        "embeter"
    ],
    "embeter": [
        "embeter"
    ],
    "embetera": [
        "embeter"
    ],
    "embeterai": [
        "embeter"
    ],
    "embeteraient": [
        "embeter"
    ],
    "embeterais": [
        "embeter"
    ],
    "embeterait": [
        "embeter"
    ],
    "embetes": [
        "embeter",
        "embete"
    ],
    "embetez": [
        "embeter"
    ],
    "embetee": [
        "embeter",
        "embete"
    ],
    "embetees": [
        "embeter"
    ],
    "embuche": [
        "embuche"
    ],
    "embuches": [
        "embuche"
    ],
    "emergency": [
        "emergency"
    ],
    "emmagasinaient": [
        "emmagasiner"
    ],
    "emmagasinais": [
        "emmagasiner"
    ],
    "emmagasinait": [
        "emmagasiner"
    ],
    "emmagasine": [
        "emmagasiner"
    ],
    "emmagasinent": [
        "emmagasiner"
    ],
    "emmagasiner": [
        "emmagasiner"
    ],
    "emmagasinee": [
        "emmagasine",
        "emmagasiner"
    ],
    "emmagasinees": [
        "emmagasine",
        "emmagasiner"
    ],
    "emmagasines": [
        "emmagasine",
        "emmagasiner"
    ],
    "emmaillota": [
        "emmailloter"
    ],
    "emmaillotaient": [
        "emmailloter"
    ],
    "emmaillotement": [
        "emmaillotement"
    ],
    "emmailloter": [
        "emmailloter"
    ],
    "emmaillote": [
        "emmailloter",
        "emmaillote"
    ],
    "emmaillotee": [
        "emmailloter",
        "emmaillote"
    ],
    "emmaillotees": [
        "emmailloter",
        "emmaillote"
    ],
    "emmaillotes": [
        "emmailloter"
    ],
    "emmanchage": [
        "emmanchage"
    ],
    "emmanchant": [
        "emmancher"
    ],
    "emmanche": [
        "emmancher"
    ],
    "emmanchent": [
        "emmancher"
    ],
    "emmancher": [
        "emmancher"
    ],
    "emmanchure": [
        "emmanchure"
    ],
    "emmanchures": [
        "emmanchure"
    ],
    "emmanchee": [
        "emmancher"
    ],
    "emmanchees": [
        "emmancher"
    ],
    "emmanches": [
        "emmancher"
    ],
    "emmena": [
        "emmener"
    ],
    "emmenai": [
        "emmener"
    ],
    "emmenaient": [
        "emmener"
    ],
    "emmenais": [
        "emmener"
    ],
    "emmenait": [
        "emmener"
    ],
    "emmenant": [
        "emmener"
    ],
    "emmener": [
        "emmener",
        "expliquer"
    ],
    "emmenez": [
        "emmener"
    ],
    "emmeniez": [
        "emmener"
    ],
    "emmenions": [
        "emmener"
    ],
    "emmenons": [
        "emmener"
    ],
    "emmenotte": [
        "emmenotter"
    ],
    "emmental": [
        "emmental"
    ],
    "emmenthal": [
        "emmenthal"
    ],
    "emmenat": [
        "emmener"
    ],
    "emmenerent": [
        "emmener"
    ],
    "emmene": [
        "emmener"
    ],
    "emmenee": [
        "emmener"
    ],
    "emmenees": [
        "emmener"
    ],
    "emmenes": [
        "emmener"
    ],
    "emmerda": [
        "emmerder"
    ],
    "emmerdaient": [
        "emmerder"
    ],
    "emmerdais": [
        "emmerder"
    ],
    "emmerdait": [
        "emmerder"
    ],
    "emmerdant": [
        "emmerder",
        "emmerdant"
    ],
    "emmerdante": [
        "emmerdant"
    ],
    "emmerdantes": [
        "emmerdant"
    ],
    "emmerdants": [
        "emmerdant"
    ],
    "emmerdatoires": [
        "emmerdatoire"
    ],
    "emmerde": [
        "emmerde",
        "emmerder"
    ],
    "emmerdement": [
        "emmerdement"
    ],
    "emmerdements": [
        "emmerdement"
    ],
    "emmerdent": [
        "emmerder"
    ],
    "emmerder": [
        "emmerder"
    ],
    "emmerdera": [
        "emmerder"
    ],
    "emmerderai": [
        "emmerder"
    ],
    "emmerderaient": [
        "emmerder"
    ],
    "emmerderais": [
        "emmerder"
    ],
    "emmerderait": [
        "emmerder"
    ],
    "emmerderez": [
        "emmerder"
    ],
    "emmerderont": [
        "emmerder"
    ],
    "emmerdes": [
        "emmerde",
        "emmerder"
    ],
    "emmerdeur": [
        "emmerdeur"
    ],
    "emmerdeurs": [
        "emmerdeur"
    ],
    "emmerdeuse": [
        "emmerdeur"
    ],
    "emmerdeuses": [
        "emmerdeur"
    ],
    "emmerdez": [
        "emmerder"
    ],
    "emmerdons": [
        "emmerder"
    ],
    "emmerdee": [
        "emmerder"
    ],
    "emmi": [
        "emmi"
    ],
    "emmitoufla": [
        "emmitoufler"
    ],
    "emmitouflai": [
        "emmitoufler"
    ],
    "emmitouflait": [
        "emmitoufler"
    ],
    "emmitouflant": [
        "emmitoufler"
    ],
    "emmitoufle": [
        "emmitoufler",
        "emmitoufle"
    ],
    "emmitoufler": [
        "emmitoufler"
    ],
    "emmitouflez": [
        "emmitoufler"
    ],
    "emmitouflee": [
        "emmitoufler",
        "emmitoufle"
    ],
    "emmitouflees": [
        "emmitoufler",
        "emmitoufle"
    ],
    "emmitoufles": [
        "emmitoufler",
        "emmitoufle"
    ],
    "emmoufle": [
        "emmoufler"
    ],
    "emmouscaillements": [
        "emmouscaillement"
    ],
    "emmura": [
        "emmurer"
    ],
    "emmurait": [
        "emmurer"
    ],
    "emmure": [
        "emmurer",
        "emmure"
    ],
    "emmurement": [
        "emmurement"
    ],
    "emmurer": [
        "emmurer"
    ],
    "emmuree": [
        "emmurer",
        "emmure"
    ],
    "emmurees": [
        "emmurer",
        "emmure"
    ],
    "emmures": [
        "emmurer",
        "emmure"
    ],
    "emmenent": [
        "emmener"
    ],
    "emmenera": [
        "emmener"
    ],
    "emmenerai": [
        "emmener"
    ],
    "emmeneraient": [
        "emmener"
    ],
    "emmenerais": [
        "emmener"
    ],
    "emmenerait": [
        "emmener"
    ],
    "emmeneras": [
        "emmener"
    ],
    "emmenerez": [
        "emmener"
    ],
    "emmeneriez": [
        "emmener"
    ],
    "emmenerions": [
        "emmener"
    ],
    "emmenerons": [
        "emmener"
    ],
    "emmeneront": [
        "emmener"
    ],
    "emmenage": [
        "emmenager"
    ],
    "emmenagea": [
        "emmenager"
    ],
    "emmenageaient": [
        "emmenager"
    ],
    "emmenageais": [
        "emmenager"
    ],
    "emmenageait": [
        "emmenager"
    ],
    "emmenageant": [
        "emmenager"
    ],
    "emmenagement": [
        "emmenagement"
    ],
    "emmenagent": [
        "emmenager"
    ],
    "emmenageons": [
        "emmenager"
    ],
    "emmenager": [
        "emmenager"
    ],
    "emmenagera": [
        "emmenager"
    ],
    "emmenagerai": [
        "emmenager"
    ],
    "emmenagerais": [
        "emmenager"
    ],
    "emmenagerait": [
        "emmenager"
    ],
    "emmenagerez": [
        "emmenager"
    ],
    "emmenagerons": [
        "emmenager"
    ],
    "emmenages": [
        "emmenager"
    ],
    "emmenagez": [
        "emmenager"
    ],
    "emmenagiez": [
        "emmenager"
    ],
    "emmenagions": [
        "emmenager"
    ],
    "emmenagerent": [
        "emmenager"
    ],
    "emmela": [
        "emmeler"
    ],
    "emmelai": [
        "emmeler"
    ],
    "emmelaient": [
        "emmeler"
    ],
    "emmelait": [
        "emmeler"
    ],
    "emmelant": [
        "emmeler"
    ],
    "emmele": [
        "emmeler",
        "emmele"
    ],
    "emmelement": [
        "emmelement"
    ],
    "emmelements": [
        "emmelement"
    ],
    "emmelent": [
        "emmeler"
    ],
    "emmeler": [
        "emmeler"
    ],
    "emmelera": [
        "emmeler"
    ],
    "emmeleront": [
        "emmeler"
    ],
    "emmeles": [
        "emmeler",
        "emmele"
    ],
    "emmelerent": [
        "emmeler"
    ],
    "emmelee": [
        "emmeler",
        "emmele"
    ],
    "emmelees": [
        "emmeler",
        "emmele"
    ],
    "empaffe": [
        "empaffer",
        "empaffe"
    ],
    "empaffer": [
        "empaffer"
    ],
    "empaffes": [
        "empaffe"
    ],
    "empaillant": [
        "empailler"
    ],
    "empailler": [
        "empailler"
    ],
    "empailleur": [
        "empailleur"
    ],
    "empailleurs": [
        "empailleur"
    ],
    "empaillez": [
        "empailler"
    ],
    "empaille": [
        "empailler",
        "empaille"
    ],
    "empaillee": [
        "empailler",
        "empaille"
    ],
    "empaillees": [
        "empailler",
        "empaille"
    ],
    "empailles": [
        "empailler",
        "empaille"
    ],
    "empalait": [
        "empaler"
    ],
    "empalant": [
        "empaler"
    ],
    "empale": [
        "empale",
        "empaler"
    ],
    "empalement": [
        "empalement"
    ],
    "empaler": [
        "empaler"
    ],
    "empalerais": [
        "empaler"
    ],
    "empaleront": [
        "empaler"
    ],
    "empalmait": [
        "empalmer"
    ],
    "empalme": [
        "empalmer"
    ],
    "empalee": [
        "empale",
        "empaler"
    ],
    "empalees": [
        "empaler"
    ],
    "empales": [
        "empale",
        "empaler"
    ],
    "empan": [
        "empan"
    ],
    "empanache": [
        "empanache",
        "empanacher"
    ],
    "empanachee": [
        "empanache",
        "empanacher"
    ],
    "empanachees": [
        "empanache",
        "empanacher"
    ],
    "empanaches": [
        "empanache",
        "empanacher"
    ],
    "empanner": [
        "empanner"
    ],
    "empapaoutent": [
        "empapaouter"
    ],
    "empapaouter": [
        "empapaouter"
    ],
    "empapaoute": [
        "empapaouter"
    ],
    "empapaoutes": [
        "empapaouter"
    ],
    "empaqueta": [
        "empaqueter"
    ],
    "empaquetage": [
        "empaquetage"
    ],
    "empaqueter": [
        "empaqueter"
    ],
    "empaqueteur": [
        "empaqueteur"
    ],
    "empaquette": [
        "empaqueter"
    ],
    "empaquettent": [
        "empaqueter"
    ],
    "empaquettes": [
        "empaqueter"
    ],
    "empaqueterent": [
        "empaqueter"
    ],
    "empaquete": [
        "empaqueter",
        "empaquete"
    ],
    "empaquetee": [
        "empaqueter",
        "empaquete"
    ],
    "empaquetees": [
        "empaqueter",
        "empaquete"
    ],
    "empaquetes": [
        "empaqueter",
        "empaquete"
    ],
    "empara": [
        "emparer"
    ],
    "emparadise": [
        "emparadiser"
    ],
    "emparai": [
        "emparer"
    ],
    "emparaient": [
        "emparer"
    ],
    "emparais": [
        "emparer"
    ],
    "emparait": [
        "emparer"
    ],
    "emparant": [
        "emparer"
    ],
    "emparassent": [
        "emparer"
    ],
    "empare": [
        "emparer"
    ],
    "emparent": [
        "emparer"
    ],
    "emparer": [
        "emparer"
    ],
    "emparera": [
        "emparer"
    ],
    "emparerai": [
        "emparer"
    ],
    "empareraient": [
        "emparer"
    ],
    "emparerais": [
        "emparer"
    ],
    "emparerait": [
        "emparer"
    ],
    "empareront": [
        "emparer"
    ],
    "emparez": [
        "emparer"
    ],
    "emparons": [
        "emparer"
    ],
    "emparat": [
        "emparer"
    ],
    "emparerent": [
        "emparer"
    ],
    "emparee": [
        "emparer"
    ],
    "emparees": [
        "emparer"
    ],
    "empares": [
        "emparer"
    ],
    "empathie": [
        "empathie"
    ],
    "empathique": [
        "empathique"
    ],
    "empathiques": [
        "empathique"
    ],
    "empattement": [
        "empattement"
    ],
    "empattements": [
        "empattement"
    ],
    "empaume": [
        "empaumer"
    ],
    "empaumer": [
        "empaumer"
    ],
    "empaumure": [
        "empaumure"
    ],
    "empaumures": [
        "empaumure"
    ],
    "empeigne": [
        "empeigne"
    ],
    "empeignes": [
        "empeigner"
    ],
    "empennage": [
        "empennage"
    ],
    "empennait": [
        "empenner"
    ],
    "empenne": [
        "empenne"
    ],
    "empennee": [
        "empenner"
    ],
    "empennees": [
        "empenner"
    ],
    "empennes": [
        "empenner"
    ],
    "empereur": [
        "empereur"
    ],
    "empereurs": [
        "empereur"
    ],
    "emperlait": [
        "emperler"
    ],
    "emperlant": [
        "emperler"
    ],
    "emperler": [
        "emperler"
    ],
    "emperlousees": [
        "emperlouse"
    ],
    "emperle": [
        "emperler",
        "emperle"
    ],
    "emperlees": [
        "emperle"
    ],
    "emperles": [
        "emperler",
        "emperle"
    ],
    "emperruques": [
        "emperruque"
    ],
    "empesage": [
        "empesage"
    ],
    "empesant": [
        "empeser"
    ],
    "empesta": [
        "empester"
    ],
    "empestaient": [
        "empester"
    ],
    "empestais": [
        "empester"
    ],
    "empestait": [
        "empester"
    ],
    "empestant": [
        "empester"
    ],
    "empeste": [
        "empester"
    ],
    "empestent": [
        "empester"
    ],
    "empester": [
        "empester"
    ],
    "empestes": [
        "empester"
    ],
    "empestez": [
        "empester"
    ],
    "empestee": [
        "empester"
    ],
    "empestees": [
        "empester"
    ],
    "empese": [
        "empeser",
        "empese"
    ],
    "empesee": [
        "empeser",
        "empese"
    ],
    "empesees": [
        "empeser",
        "empese"
    ],
    "empeses": [
        "empeser",
        "empese"
    ],
    "emphase": [
        "emphase"
    ],
    "emphases": [
        "emphase"
    ],
    "emphatique": [
        "emphatique"
    ],
    "emphatiquement": [
        "emphatiquement"
    ],
    "emphatiques": [
        "emphatique"
    ],
    "emphatise": [
        "emphatiser"
    ],
    "emphyseme": [
        "emphyseme"
    ],
    "emphysemes": [
        "emphyseme"
    ],
    "emphysemateuse": [
        "emphysemateux"
    ],
    "empierrage": [
        "empierrage"
    ],
    "empierrait": [
        "empierrer"
    ],
    "empierrement": [
        "empierrement"
    ],
    "empierrer": [
        "empierrer"
    ],
    "empierre": [
        "empierrer",
        "empierre"
    ],
    "empierree": [
        "empierrer",
        "empierre"
    ],
    "empierrees": [
        "empierre"
    ],
    "empierres": [
        "empierre"
    ],
    "empiffra": [
        "empiffrer"
    ],
    "empiffraient": [
        "empiffrer"
    ],
    "empiffrais": [
        "empiffrer"
    ],
    "empiffrait": [
        "empiffrer"
    ],
    "empiffrant": [
        "empiffrer"
    ],
    "empiffre": [
        "empiffrer"
    ],
    "empiffrent": [
        "empiffrer"
    ],
    "empiffrer": [
        "empiffrer"
    ],
    "empiffres": [
        "empiffrer"
    ],
    "empiffrez": [
        "empiffrer"
    ],
    "empiffree": [
        "empiffrer"
    ],
    "empiffrees": [
        "empiffrer"
    ],
    "empila": [
        "empiler"
    ],
    "empilage": [
        "empilage"
    ],
    "empilages": [
        "empilage"
    ],
    "empilaient": [
        "empiler"
    ],
    "empilais": [
        "empiler"
    ],
    "empilait": [
        "empiler"
    ],
    "empilant": [
        "empiler"
    ],
    "empile": [
        "empiler"
    ],
    "empilement": [
        "empilement"
    ],
    "empilements": [
        "empilement"
    ],
    "empilent": [
        "empiler"
    ],
    "empiler": [
        "empiler"
    ],
    "empilerai": [
        "empiler"
    ],
    "empilerions": [
        "empiler"
    ],
    "empilez": [
        "empiler"
    ],
    "empilons": [
        "empiler"
    ],
    "empilerent": [
        "empiler"
    ],
    "empilee": [
        "empiler"
    ],
    "empilees": [
        "empiler"
    ],
    "empiles": [
        "empiler"
    ],
    "empira": [
        "empirer"
    ],
    "empirait": [
        "empirer"
    ],
    "empirant": [
        "empirer"
    ],
    "empire": [
        "empirer",
        "empire"
    ],
    "empirent": [
        "empirer"
    ],
    "empirer": [
        "empirer"
    ],
    "empirera": [
        "empirer"
    ],
    "empirerait": [
        "empirer"
    ],
    "empireront": [
        "empirer"
    ],
    "empires": [
        "empirer",
        "empire"
    ],
    "empirez": [
        "empirer"
    ],
    "empirique": [
        "empirique"
    ],
    "empiriquement": [
        "empiriquement"
    ],
    "empiriques": [
        "empirique"
    ],
    "empirisme": [
        "empirisme"
    ],
    "empirismes": [
        "empirisme"
    ],
    "empirerent": [
        "empirer"
    ],
    "empiree": [
        "empirer"
    ],
    "empiecement": [
        "empiecement"
    ],
    "empiecements": [
        "empiecement"
    ],
    "empiete": [
        "empieter"
    ],
    "empietements": [
        "empietement"
    ],
    "empietent": [
        "empieter"
    ],
    "empietes": [
        "empieter"
    ],
    "empietaient": [
        "empieter"
    ],
    "empietais": [
        "empieter"
    ],
    "empietait": [
        "empieter"
    ],
    "empietant": [
        "empieter"
    ],
    "empietement": [
        "empietement"
    ],
    "empieter": [
        "empieter"
    ],
    "empietez": [
        "empieter"
    ],
    "emplacement": [
        "emplacement"
    ],
    "emplacements": [
        "emplacement"
    ],
    "emplafonne": [
        "emplafonner"
    ],
    "emplafonnent": [
        "emplafonner"
    ],
    "emplafonner": [
        "emplafonner"
    ],
    "emplafonnee": [
        "emplafonner"
    ],
    "emplanture": [
        "emplanture"
    ],
    "emplette": [
        "emplette"
    ],
    "emplettes": [
        "emplette"
    ],
    "empli": [
        "emplir",
        "empli"
    ],
    "emplie": [
        "emplir",
        "empli"
    ],
    "emplies": [
        "emplir"
    ],
    "emplir": [
        "emplir"
    ],
    "emplira": [
        "emplir"
    ],
    "empliraient": [
        "emplir"
    ],
    "emplirait": [
        "emplir"
    ],
    "emplirent": [
        "emplir"
    ],
    "emplis": [
        "emplir",
        "empli"
    ],
    "emplissaient": [
        "emplir"
    ],
    "emplissais": [
        "emplir"
    ],
    "emplissait": [
        "emplir"
    ],
    "emplissant": [
        "emplir"
    ],
    "emplissent": [
        "emplir"
    ],
    "emplissez": [
        "emplir"
    ],
    "emplissons": [
        "emplir"
    ],
    "emplit": [
        "emplir"
    ],
    "emploi": [
        "emploi"
    ],
    "emploie": [
        "employer"
    ],
    "emploient": [
        "employer"
    ],
    "emploiera": [
        "employer"
    ],
    "emploierai": [
        "employer"
    ],
    "emploieraient": [
        "employer"
    ],
    "emploierais": [
        "employer"
    ],
    "emploierait": [
        "employer"
    ],
    "emploierez": [
        "employer"
    ],
    "emploieriez": [
        "employer"
    ],
    "emploierons": [
        "employer"
    ],
    "emploieront": [
        "employer"
    ],
    "emploies": [
        "employer"
    ],
    "emplois": [
        "emploi"
    ],
    "employa": [
        "employer"
    ],
    "employai": [
        "employer"
    ],
    "employaient": [
        "employer"
    ],
    "employais": [
        "employer"
    ],
    "employait": [
        "employer"
    ],
    "employant": [
        "employer"
    ],
    "employer": [
        "employer"
    ],
    "employeur": [
        "employeur"
    ],
    "employeurs": [
        "employeur"
    ],
    "employez": [
        "employer"
    ],
    "employiez": [
        "employer"
    ],
    "employions": [
        "employer"
    ],
    "employons": [
        "employer"
    ],
    "employames": [
        "employer"
    ],
    "employat": [
        "employer"
    ],
    "employerent": [
        "employer"
    ],
    "employe": [
        "employer",
        "employe"
    ],
    "employee": [
        "employer",
        "employe"
    ],
    "employees": [
        "employee",
        "employer",
        "employe"
    ],
    "employes": [
        "employer",
        "employe"
    ],
    "empluma": [
        "emplumer"
    ],
    "emplume": [
        "emplume",
        "emplumer"
    ],
    "emplumee": [
        "emplume",
        "emplumer"
    ],
    "emplumees": [
        "emplumer"
    ],
    "emplumes": [
        "emplume"
    ],
    "emplatrage": [
        "emplatrage"
    ],
    "emplatrais": [
        "emplatrer"
    ],
    "emplatre": [
        "emplatrer",
        "emplatre"
    ],
    "emplatrer": [
        "emplatrer"
    ],
    "emplatres": [
        "emplatre"
    ],
    "empocha": [
        "empocher"
    ],
    "empochai": [
        "empocher"
    ],
    "empochaient": [
        "empocher"
    ],
    "empochais": [
        "empocher"
    ],
    "empochait": [
        "empocher"
    ],
    "empochant": [
        "empocher"
    ],
    "empoche": [
        "empocher"
    ],
    "empochent": [
        "empocher"
    ],
    "empocher": [
        "empocher"
    ],
    "empochera": [
        "empocher"
    ],
    "empocherais": [
        "empocher"
    ],
    "empocheras": [
        "empocher"
    ],
    "empoches": [
        "empocher"
    ],
    "empochez": [
        "empocher"
    ],
    "empochiez": [
        "empocher"
    ],
    "empochee": [
        "empocher"
    ],
    "empochees": [
        "empocher"
    ],
    "empoigna": [
        "empoigner"
    ],
    "empoignade": [
        "empoignade"
    ],
    "empoignades": [
        "empoignade"
    ],
    "empoignai": [
        "empoigner"
    ],
    "empoignaient": [
        "empoigner"
    ],
    "empoignais": [
        "empoigner"
    ],
    "empoignait": [
        "empoigner"
    ],
    "empoignant": [
        "empoigner",
        "empoignant"
    ],
    "empoigne": [
        "empoigner",
        "empoigne"
    ],
    "empoignent": [
        "empoigner"
    ],
    "empoigner": [
        "empoigner"
    ],
    "empoignera": [
        "empoigner"
    ],
    "empoigneront": [
        "empoigner"
    ],
    "empoignes": [
        "empoigner"
    ],
    "empoignez": [
        "empoigner"
    ],
    "empoignons": [
        "empoigner"
    ],
    "empoignerent": [
        "empoigner"
    ],
    "empoignee": [
        "empoigner"
    ],
    "empoignees": [
        "empoigner"
    ],
    "empoiler": [
        "empoiler"
    ],
    "empoiles": [
        "empoiler"
    ],
    "empois": [
        "empois"
    ],
    "empoisonna": [
        "empoisonner"
    ],
    "empoisonnaient": [
        "empoisonner"
    ],
    "empoisonnais": [
        "empoisonner"
    ],
    "empoisonnait": [
        "empoisonner"
    ],
    "empoisonnant": [
        "empoisonner",
        "empoisonnant"
    ],
    "empoisonnante": [
        "empoisonnant"
    ],
    "empoisonnantes": [
        "empoisonnant"
    ],
    "empoisonne": [
        "empoisonner"
    ],
    "empoisonnement": [
        "empoisonnement"
    ],
    "empoisonnements": [
        "empoisonnement"
    ],
    "empoisonnent": [
        "empoisonner"
    ],
    "empoisonner": [
        "empoisonner"
    ],
    "empoisonnera": [
        "empoisonner"
    ],
    "empoisonnerai": [
        "empoisonner"
    ],
    "empoisonneraient": [
        "empoisonner"
    ],
    "empoisonnerais": [
        "empoisonner"
    ],
    "empoisonnerez": [
        "empoisonner"
    ],
    "empoisonneront": [
        "empoisonner"
    ],
    "empoisonnes": [
        "empoisonner"
    ],
    "empoisonneur": [
        "empoisonneur"
    ],
    "empoisonneurs": [
        "empoisonneur"
    ],
    "empoisonneuse": [
        "empoisonneur"
    ],
    "empoisonneuses": [
        "empoisonneur"
    ],
    "empoisonnez": [
        "empoisonner"
    ],
    "empoisonnee": [
        "empoisonner"
    ],
    "empoisonnees": [
        "empoisonner"
    ],
    "empoissait": [
        "empoisser"
    ],
    "empoisse": [
        "empoisser"
    ],
    "empoisser": [
        "empoisser"
    ],
    "empoissonner": [
        "empoissonner"
    ],
    "empoissonne": [
        "empoissonner"
    ],
    "empoissonnees": [
        "empoissonner"
    ],
    "empoisses": [
        "empoisser"
    ],
    "emporium": [
        "emporium"
    ],
    "emport": [
        "emport"
    ],
    "emporta": [
        "emporter"
    ],
    "emportai": [
        "emporter"
    ],
    "emportaient": [
        "emporter"
    ],
    "emportais": [
        "emporter"
    ],
    "emportait": [
        "emporter"
    ],
    "emportant": [
        "emporter"
    ],
    "emporte": [
        "emporter",
        "emporte"
    ],
    "emportement": [
        "emportement"
    ],
    "emportements": [
        "emportement"
    ],
    "emportent": [
        "emporter"
    ],
    "emporter": [
        "emporter"
    ],
    "emportera": [
        "emporter"
    ],
    "emporterai": [
        "emporter"
    ],
    "emporteraient": [
        "emporter"
    ],
    "emporterais": [
        "emporter"
    ],
    "emporterait": [
        "emporter"
    ],
    "emporteras": [
        "emporter"
    ],
    "emporterez": [
        "emporter"
    ],
    "emporteriez": [
        "emporter"
    ],
    "emporterions": [
        "emporter"
    ],
    "emporterons": [
        "emporter"
    ],
    "emporteront": [
        "emporter"
    ],
    "emportes": [
        "emporter",
        "emporte"
    ],
    "emportez": [
        "emporter"
    ],
    "emportiez": [
        "emporter"
    ],
    "emportions": [
        "emporter"
    ],
    "emportons": [
        "emporter"
    ],
    "emportat": [
        "emporter"
    ],
    "emporterent": [
        "emporter"
    ],
    "emportee": [
        "emporter",
        "emporte"
    ],
    "emportees": [
        "emporter",
        "emporte"
    ],
    "empote": [
        "empote",
        "empoter"
    ],
    "empotee": [
        "empote",
        "empoter"
    ],
    "empotes": [
        "empote",
        "empoter"
    ],
    "empourpra": [
        "empourprer"
    ],
    "empourprait": [
        "empourprer"
    ],
    "empourprant": [
        "empourprer"
    ],
    "empourpre": [
        "empourprer"
    ],
    "empourprent": [
        "empourprer"
    ],
    "empourprer": [
        "empourprer"
    ],
    "empourpree": [
        "empourprer"
    ],
    "empourprees": [
        "empourprer"
    ],
    "empourpres": [
        "empourprer"
    ],
    "empoussiere": [
        "empoussiere",
        "empoussierer"
    ],
    "empoussierent": [
        "empoussierer"
    ],
    "empoussierait": [
        "empoussierer"
    ],
    "empoussieree": [
        "empoussiere",
        "empoussierer"
    ],
    "empoussierees": [
        "empoussiere"
    ],
    "empoussieres": [
        "empoussiere",
        "empoussierer"
    ],
    "empreignit": [
        "empreindre"
    ],
    "empreint": [
        "empreindre",
        "empreint"
    ],
    "empreinte": [
        "empreinte"
    ],
    "empreintes": [
        "empreinte"
    ],
    "empreints": [
        "empreindre",
        "empreint"
    ],
    "empressa": [
        "empresser"
    ],
    "empressai": [
        "empresser"
    ],
    "empressaient": [
        "empresser"
    ],
    "empressais": [
        "empresser"
    ],
    "empressait": [
        "empresser"
    ],
    "empressant": [
        "empresser"
    ],
    "empresse": [
        "empresser",
        "empresse"
    ],
    "empressement": [
        "empressement"
    ],
    "empressements": [
        "empressement"
    ],
    "empressent": [
        "empresser"
    ],
    "empresser": [
        "empresser"
    ],
    "empressera": [
        "empresser"
    ],
    "empresserait": [
        "empresser"
    ],
    "empresseras": [
        "empresser"
    ],
    "empresserez": [
        "empresser"
    ],
    "empresses": [
        "empress",
        "empresser",
        "empresse"
    ],
    "empressames": [
        "empresser"
    ],
    "empresserent": [
        "empresser"
    ],
    "empressee": [
        "empresser",
        "empresse"
    ],
    "empressees": [
        "empresser",
        "empresse"
    ],
    "emprise": [
        "emprise"
    ],
    "emprises": [
        "emprise"
    ],
    "emprisonna": [
        "emprisonner"
    ],
    "emprisonnaient": [
        "emprisonner"
    ],
    "emprisonnait": [
        "emprisonner"
    ],
    "emprisonnant": [
        "emprisonner"
    ],
    "emprisonne": [
        "emprisonne",
        "emprisonner"
    ],
    "emprisonnement": [
        "emprisonnement"
    ],
    "emprisonnements": [
        "emprisonnement"
    ],
    "emprisonnent": [
        "emprisonner"
    ],
    "emprisonner": [
        "emprisonner"
    ],
    "emprisonnera": [
        "emprisonner"
    ],
    "emprisonnez": [
        "emprisonner"
    ],
    "emprisonnerent": [
        "emprisonner"
    ],
    "emprisonnee": [
        "emprisonne",
        "emprisonner"
    ],
    "emprisonnees": [
        "emprisonne",
        "emprisonner"
    ],
    "emprisonnes": [
        "emprisonne",
        "emprisonner"
    ],
    "emprunt": [
        "emprunt"
    ],
    "emprunta": [
        "emprunter"
    ],
    "empruntai": [
        "emprunter"
    ],
    "empruntaient": [
        "emprunter"
    ],
    "empruntais": [
        "emprunter"
    ],
    "empruntait": [
        "emprunter"
    ],
    "empruntant": [
        "emprunter"
    ],
    "emprunte": [
        "emprunter",
        "emprunte"
    ],
    "empruntent": [
        "emprunter"
    ],
    "emprunter": [
        "emprunter"
    ],
    "empruntera": [
        "emprunter"
    ],
    "emprunterai": [
        "emprunter"
    ],
    "emprunteraient": [
        "emprunter"
    ],
    "emprunterais": [
        "emprunter"
    ],
    "emprunterait": [
        "emprunter"
    ],
    "emprunteras": [
        "emprunter"
    ],
    "emprunterons": [
        "emprunter"
    ],
    "emprunteront": [
        "emprunter"
    ],
    "empruntes": [
        "emprunter",
        "emprunte"
    ],
    "emprunteur": [
        "emprunteur"
    ],
    "empruntez": [
        "emprunter"
    ],
    "empruntions": [
        "emprunter"
    ],
    "empruntons": [
        "emprunter"
    ],
    "emprunts": [
        "emprunt"
    ],
    "empruntames": [
        "emprunter"
    ],
    "empruntat": [
        "emprunter"
    ],
    "emprunterent": [
        "emprunter"
    ],
    "empruntee": [
        "emprunter",
        "emprunte"
    ],
    "empruntees": [
        "emprunter",
        "emprunte"
    ],
    "empuanti": [
        "empuantir",
        "empuanti"
    ],
    "empuantie": [
        "empuantir",
        "empuanti"
    ],
    "empuanties": [
        "empuantir"
    ],
    "empuantir": [
        "empuantir"
    ],
    "empuantis": [
        "empuantir"
    ],
    "empuantissaient": [
        "empuantir"
    ],
    "empuantissait": [
        "empuantir"
    ],
    "empuantisse": [
        "empuantir"
    ],
    "empuantissent": [
        "empuantir"
    ],
    "empyree": [
        "empyree"
    ],
    "empyrees": [
        "empyree"
    ],
    "empata": [
        "empater"
    ],
    "empatait": [
        "empater"
    ],
    "empate": [
        "empater",
        "empate"
    ],
    "empatement": [
        "empatement"
    ],
    "empatements": [
        "empatement"
    ],
    "empatent": [
        "empater"
    ],
    "empater": [
        "empater"
    ],
    "empatee": [
        "empater",
        "empate"
    ],
    "empatees": [
        "empate"
    ],
    "empates": [
        "empater",
        "empate"
    ],
    "empecha": [
        "empecher"
    ],
    "empechai": [
        "empecher"
    ],
    "empechaient": [
        "empecher"
    ],
    "empechais": [
        "empecher"
    ],
    "empechait": [
        "empecher"
    ],
    "empechant": [
        "empecher"
    ],
    "empeche": [
        "empecher",
        "empeche"
    ],
    "empechement": [
        "empechement"
    ],
    "empechements": [
        "empechement"
    ],
    "empechent": [
        "empecher"
    ],
    "empecher": [
        "empecher"
    ],
    "empechera": [
        "empecher"
    ],
    "empecherai": [
        "empecher"
    ],
    "empecheraient": [
        "empecher"
    ],
    "empecherais": [
        "empecher"
    ],
    "empecherait": [
        "empecher"
    ],
    "empecheras": [
        "empecher"
    ],
    "empecherez": [
        "empecher"
    ],
    "empecherons": [
        "empecher"
    ],
    "empecheront": [
        "empecher"
    ],
    "empeches": [
        "empecher",
        "empeche"
    ],
    "empecheur": [
        "empecheur"
    ],
    "empecheurs": [
        "empecheur"
    ],
    "empecheuse": [
        "empecheur"
    ],
    "empechez": [
        "empecher"
    ],
    "empechions": [
        "empecher"
    ],
    "empechons": [
        "empecher"
    ],
    "empechat": [
        "empecher"
    ],
    "empecherent": [
        "empecher"
    ],
    "empechee": [
        "empecher",
        "empeche"
    ],
    "empechees": [
        "empecher"
    ],
    "empetra": [
        "empetrer"
    ],
    "empetraient": [
        "empetrer"
    ],
    "empetrais": [
        "empetrer"
    ],
    "empetrait": [
        "empetrer"
    ],
    "empetrant": [
        "empetrer"
    ],
    "empetre": [
        "empetrer",
        "empetre"
    ],
    "empetrent": [
        "empetrer"
    ],
    "empetrer": [
        "empetrer"
    ],
    "empetrons": [
        "empetrer"
    ],
    "empetree": [
        "empetrer",
        "empetre"
    ],
    "empetrees": [
        "empetrer",
        "empetre"
    ],
    "empetres": [
        "empetrer",
        "empetre"
    ],
    "en": [
        "en"
    ],
    "enamoure": [
        "enamourer",
        "enamoure"
    ],
    "enamouree": [
        "enamourer",
        "enamoure"
    ],
    "enamourees": [
        "enamourer",
        "enamoure"
    ],
    "enamoures": [
        "enamourer",
        "enamoure"
    ],
    "encabanee": [
        "encabaner"
    ],
    "encablure": [
        "encablure"
    ],
    "encablures": [
        "encablure"
    ],
    "encadra": [
        "encadrer"
    ],
    "encadraient": [
        "encadrer"
    ],
    "encadrait": [
        "encadrer"
    ],
    "encadrant": [
        "encadrant"
    ],
    "encadre": [
        "encadrer",
        "encadre"
    ],
    "encadrement": [
        "encadrement"
    ],
    "encadrements": [
        "encadrement"
    ],
    "encadrent": [
        "encadrer"
    ],
    "encadrer": [
        "encadrer"
    ],
    "encadrera": [
        "encadrer"
    ],
    "encadrerai": [
        "encadrer"
    ],
    "encadreraient": [
        "encadrer"
    ],
    "encadrerait": [
        "encadrer"
    ],
    "encadreront": [
        "encadrer"
    ],
    "encadreur": [
        "encadreur"
    ],
    "encadrez": [
        "encadrer"
    ],
    "encadrions": [
        "encadrer"
    ],
    "encadrerent": [
        "encadrer"
    ],
    "encadree": [
        "encadrer"
    ],
    "encadrees": [
        "encadrer"
    ],
    "encadres": [
        "encadrer",
        "encadre"
    ],
    "encagent": [
        "encager"
    ],
    "encager": [
        "encager"
    ],
    "encagez": [
        "encager"
    ],
    "encagoulees": [
        "encagoule"
    ],
    "encagoules": [
        "encagoule"
    ],
    "encage": [
        "encager",
        "encage"
    ],
    "encagee": [
        "encager",
        "encage"
    ],
    "encages": [
        "encager",
        "encage"
    ],
    "encaissa": [
        "encaisser"
    ],
    "encaissable": [
        "encaissable"
    ],
    "encaissai": [
        "encaisser"
    ],
    "encaissaient": [
        "encaisser"
    ],
    "encaissais": [
        "encaisser"
    ],
    "encaissait": [
        "encaisser"
    ],
    "encaissant": [
        "encaisser",
        "encaissant"
    ],
    "encaisse": [
        "encaisser",
        "encaisse"
    ],
    "encaissement": [
        "encaissement"
    ],
    "encaissements": [
        "encaissement"
    ],
    "encaissent": [
        "encaisser"
    ],
    "encaisser": [
        "encaisser"
    ],
    "encaissera": [
        "encaisser"
    ],
    "encaisserai": [
        "encaisser"
    ],
    "encaisserais": [
        "encaisser"
    ],
    "encaisserait": [
        "encaisser"
    ],
    "encaisserez": [
        "encaisser"
    ],
    "encaisseront": [
        "encaisser"
    ],
    "encaisses": [
        "encaisser",
        "encaisse"
    ],
    "encaisseur": [
        "encaisseur"
    ],
    "encaisseurs": [
        "encaisseur"
    ],
    "encaissez": [
        "encaisser"
    ],
    "encaissons": [
        "encaisser"
    ],
    "encaissat": [
        "encaisser"
    ],
    "encaissee": [
        "encaisser",
        "encaisse"
    ],
    "encaissees": [
        "encaisser",
        "encaisse"
    ],
    "encalmine": [
        "encalmine"
    ],
    "encalmines": [
        "encalmine"
    ],
    "encanaillais": [
        "encanailler"
    ],
    "encanaillait": [
        "encanailler"
    ],
    "encanaille": [
        "encanailler"
    ],
    "encanaillement": [
        "encanaillement"
    ],
    "encanaillent": [
        "encanailler"
    ],
    "encanailler": [
        "encanailler"
    ],
    "encapsuler": [
        "encapsuler"
    ],
    "encapsule": [
        "encapsuler"
    ],
    "encapuchonna": [
        "encapuchonner"
    ],
    "encapuchonnait": [
        "encapuchonner"
    ],
    "encapuchonnant": [
        "encapuchonner"
    ],
    "encapuchonne": [
        "encapuchonne",
        "encapuchonner"
    ],
    "encapuchonnee": [
        "encapuchonne",
        "encapuchonner"
    ],
    "encapuchonnees": [
        "encapuchonner"
    ],
    "encapuchonnes": [
        "encapuchonne",
        "encapuchonner"
    ],
    "encaques": [
        "encaquer"
    ],
    "encart": [
        "encart"
    ],
    "encartage": [
        "encartage"
    ],
    "encartait": [
        "encarter"
    ],
    "encarter": [
        "encarter"
    ],
    "encarts": [
        "encart"
    ],
    "encarte": [
        "encarter"
    ],
    "encartees": [
        "encarter"
    ],
    "encartes": [
        "encarter"
    ],
    "encas": [
        "encas"
    ],
    "encaserner": [
        "encaserner"
    ],
    "encastele": [
        "encasteler"
    ],
    "encastra": [
        "encastrer"
    ],
    "encastraient": [
        "encastrer"
    ],
    "encastrait": [
        "encastrer"
    ],
    "encastrant": [
        "encastrer"
    ],
    "encastre": [
        "encastre",
        "encastrer"
    ],
    "encastrement": [
        "encastrement"
    ],
    "encastrent": [
        "encastrer"
    ],
    "encastrer": [
        "encastrer"
    ],
    "encastree": [
        "encastre",
        "encastrer"
    ],
    "encastrees": [
        "encastre",
        "encastrer"
    ],
    "encastres": [
        "encastre",
        "encastrer"
    ],
    "encaustiquait": [
        "encaustiquer"
    ],
    "encaustique": [
        "encaustiquer",
        "encaustique"
    ],
    "encaustiquer": [
        "encaustiquer"
    ],
    "encaustiquee": [
        "encaustique"
    ],
    "encaver": [
        "encaver"
    ],
    "encavee": [
        "encaver"
    ],
    "enceint": [
        "enceindre"
    ],
    "enceinte": [
        "enceinte"
    ],
    "enceinter": [
        "enceinter"
    ],
    "enceintes": [
        "enceinte"
    ],
    "enceints": [
        "enceindre"
    ],
    "encellulement": [
        "encellulement"
    ],
    "encellulee": [
        "encelluler"
    ],
    "encellulees": [
        "encelluler"
    ],
    "encens": [
        "encens"
    ],
    "encensaient": [
        "encenser"
    ],
    "encensait": [
        "encenser"
    ],
    "encensant": [
        "encenser"
    ],
    "encense": [
        "encenser"
    ],
    "encensement": [
        "encensement"
    ],
    "encenser": [
        "encenser"
    ],
    "encensoir": [
        "encensoir"
    ],
    "encensoirs": [
        "encensoir"
    ],
    "encenses": [
        "encenser"
    ],
    "encercla": [
        "encercler"
    ],
    "encerclaient": [
        "encercler"
    ],
    "encerclais": [
        "encercler"
    ],
    "encerclait": [
        "encercler"
    ],
    "encerclant": [
        "encercler"
    ],
    "encercle": [
        "encercler"
    ],
    "encerclement": [
        "encerclement"
    ],
    "encerclent": [
        "encercler"
    ],
    "encercler": [
        "encercler"
    ],
    "encerclera": [
        "encercler"
    ],
    "encercleraient": [
        "encercler"
    ],
    "encerclez": [
        "encercler"
    ],
    "encerclons": [
        "encercler"
    ],
    "encerclerent": [
        "encercler"
    ],
    "encerclee": [
        "encercler"
    ],
    "encerclees": [
        "encercler"
    ],
    "encercles": [
        "encercler"
    ],
    "enchanta": [
        "enchanter"
    ],
    "enchantaient": [
        "enchanter"
    ],
    "enchantais": [
        "enchanter"
    ],
    "enchantait": [
        "enchanter"
    ],
    "enchantant": [
        "enchanter"
    ],
    "enchante": [
        "enchanter",
        "enchante"
    ],
    "enchantement": [
        "enchantement"
    ],
    "enchantements": [
        "enchantement"
    ],
    "enchantent": [
        "enchanter"
    ],
    "enchanter": [
        "enchanter"
    ],
    "enchantera": [
        "enchanter"
    ],
    "enchanteraient": [
        "enchanter"
    ],
    "enchanterait": [
        "enchanter"
    ],
    "enchanteresse": [
        "enchanteur"
    ],
    "enchanteresses": [
        "enchanteur"
    ],
    "enchanteront": [
        "enchanter"
    ],
    "enchantes": [
        "enchanter",
        "enchante"
    ],
    "enchanteur": [
        "enchanteur"
    ],
    "enchanteurs": [
        "enchanteur"
    ],
    "enchantez": [
        "enchanter"
    ],
    "enchantions": [
        "enchanter"
    ],
    "enchanterent": [
        "enchanter"
    ],
    "enchantee": [
        "enchanter",
        "enchante"
    ],
    "enchantees": [
        "enchanter",
        "enchante"
    ],
    "enchaina": [
        "enchainer"
    ],
    "enchainai": [
        "enchainer"
    ],
    "enchainaient": [
        "enchainer"
    ],
    "enchainais": [
        "enchainer"
    ],
    "enchainait": [
        "enchainer"
    ],
    "enchainant": [
        "enchainer"
    ],
    "enchaine": [
        "enchaine",
        "enchainer"
    ],
    "enchainement": [
        "enchainement"
    ],
    "enchainements": [
        "enchainement"
    ],
    "enchainent": [
        "enchainer"
    ],
    "enchainer": [
        "enchainer"
    ],
    "enchainera": [
        "enchainer"
    ],
    "enchaineraient": [
        "enchainer"
    ],
    "enchainerait": [
        "enchainer"
    ],
    "enchaineras": [
        "enchainer"
    ],
    "enchainerez": [
        "enchainer"
    ],
    "enchainerons": [
        "enchainer"
    ],
    "enchainez": [
        "enchainer"
    ],
    "enchainons": [
        "enchainer"
    ],
    "enchainerent": [
        "enchainer"
    ],
    "enchainee": [
        "enchaine",
        "enchainer"
    ],
    "enchainees": [
        "enchaine",
        "enchainer"
    ],
    "enchaines": [
        "enchaine",
        "enchainer"
    ],
    "enchemise": [
        "enchemiser"
    ],
    "enchevetraient": [
        "enchevetrer"
    ],
    "enchevetrais": [
        "enchevetrer"
    ],
    "enchevetrant": [
        "enchevetrer"
    ],
    "enchevetre": [
        "enchevetre",
        "enchevetrer"
    ],
    "enchevetrement": [
        "enchevetrement"
    ],
    "enchevetrements": [
        "enchevetrement"
    ],
    "enchevetrent": [
        "enchevetrer"
    ],
    "enchevetree": [
        "enchevetre",
        "enchevetrer"
    ],
    "enchevetrees": [
        "enchevetre",
        "enchevetrer"
    ],
    "enchevetres": [
        "enchevetre",
        "enchevetrer"
    ],
    "enchifrene": [
        "enchifrener"
    ],
    "enchriste": [
        "enchrister"
    ],
    "enchrister": [
        "enchrister"
    ],
    "enchristee": [
        "enchrister"
    ],
    "enchtiber": [
        "enchtiber"
    ],
    "enchtibe": [
        "enchtiber"
    ],
    "enchtibes": [
        "enchtiber"
    ],
    "enchassaient": [
        "enchasser"
    ],
    "enchassait": [
        "enchasser"
    ],
    "enchassant": [
        "enchasser"
    ],
    "enchasse": [
        "enchasser",
        "enchasse"
    ],
    "enchasser": [
        "enchasser"
    ],
    "enchassee": [
        "enchasser",
        "enchasse"
    ],
    "enchasses": [
        "enchasser",
        "enchasse"
    ],
    "enchere": [
        "enchere"
    ],
    "encheres": [
        "enchere"
    ],
    "encheri": [
        "encherir"
    ],
    "encherir": [
        "encherir"
    ],
    "encherissant": [
        "encherir"
    ],
    "encherisse": [
        "encherir"
    ],
    "encherisseur": [
        "encherisseur"
    ],
    "encherisseurs": [
        "encherisseur"
    ],
    "encherisseuse": [
        "encherisseur"
    ],
    "encherit": [
        "encherir"
    ],
    "enclave": [
        "enclave",
        "enclaver"
    ],
    "enclaves": [
        "enclave"
    ],
    "enclavee": [
        "enclave",
        "enclaver"
    ],
    "enclavees": [
        "enclave"
    ],
    "enclencha": [
        "enclencher"
    ],
    "enclenchai": [
        "enclencher"
    ],
    "enclenchait": [
        "enclencher"
    ],
    "enclenchant": [
        "enclencher"
    ],
    "enclenche": [
        "enclencher",
        "enclenche"
    ],
    "enclenchement": [
        "enclenchement"
    ],
    "enclenchent": [
        "enclencher"
    ],
    "enclencher": [
        "enclencher"
    ],
    "enclenchera": [
        "enclencher"
    ],
    "enclenches": [
        "enclencher",
        "enclenche"
    ],
    "enclenchez": [
        "enclencher"
    ],
    "enclenchee": [
        "enclencher",
        "enclenche"
    ],
    "enclenchees": [
        "enclencher",
        "enclenche"
    ],
    "enclin": [
        "enclin"
    ],
    "encline": [
        "enclin"
    ],
    "enclines": [
        "enclin"
    ],
    "enclins": [
        "enclin"
    ],
    "encliqueter": [
        "encliqueter"
    ],
    "encloque": [
        "encloquer"
    ],
    "enclore": [
        "enclore"
    ],
    "enclos": [
        "enclore",
        "enclos"
    ],
    "enclose": [
        "enclore"
    ],
    "encloses": [
        "enclore",
        "enclose"
    ],
    "enclosure": [
        "enclosure"
    ],
    "enclouer": [
        "enclouer"
    ],
    "encloitrer": [
        "encloitrer"
    ],
    "enclume": [
        "enclume"
    ],
    "enclumes": [
        "enclume"
    ],
    "encoche": [
        "encoche",
        "encocher"
    ],
    "encoches": [
        "encoche"
    ],
    "encoconner": [
        "encoconner"
    ],
    "encoconnee": [
        "encoconner"
    ],
    "encodage": [
        "encodage"
    ],
    "encode": [
        "encoder"
    ],
    "encoder": [
        "encoder"
    ],
    "encodeur": [
        "encodeur"
    ],
    "encodee": [
        "encoder"
    ],
    "encodes": [
        "encoder",
        "encode"
    ],
    "encoignure": [
        "encoignure"
    ],
    "encoignures": [
        "encoignure"
    ],
    "encollage": [
        "encollage"
    ],
    "encollait": [
        "encoller"
    ],
    "encoller": [
        "encoller"
    ],
    "encolleuses": [
        "encolleur"
    ],
    "encolle": [
        "encoller"
    ],
    "encollee": [
        "encoller"
    ],
    "encollees": [
        "encoller"
    ],
    "encolure": [
        "encolure"
    ],
    "encolures": [
        "encolure"
    ],
    "encoleree": [
        "encolere"
    ],
    "encoleres": [
        "encolere"
    ],
    "encombra": [
        "encombrer"
    ],
    "encombraient": [
        "encombrer"
    ],
    "encombrais": [
        "encombrer"
    ],
    "encombrait": [
        "encombrer"
    ],
    "encombrant": [
        "encombrant",
        "encombrer"
    ],
    "encombrante": [
        "encombrant"
    ],
    "encombrantes": [
        "encombrant"
    ],
    "encombrants": [
        "encombrant"
    ],
    "encombre": [
        "encombrer",
        "encombre"
    ],
    "encombrement": [
        "encombrement"
    ],
    "encombrements": [
        "encombrement"
    ],
    "encombrent": [
        "encombrer"
    ],
    "encombrer": [
        "encombrer"
    ],
    "encombrera": [
        "encombrer"
    ],
    "encombrerai": [
        "encombrer"
    ],
    "encombrerait": [
        "encombrer"
    ],
    "encombres": [
        "encombrer",
        "encombre"
    ],
    "encombrez": [
        "encombrer"
    ],
    "encombrerent": [
        "encombrer"
    ],
    "encombree": [
        "encombrer",
        "encombre"
    ],
    "encombrees": [
        "encombrer",
        "encombre"
    ],
    "encor": [
        "encor"
    ],
    "encorbellement": [
        "encorbellement"
    ],
    "encorbellements": [
        "encorbellement"
    ],
    "encorder": [
        "encorder"
    ],
    "encorde": [
        "encorder",
        "encorde"
    ],
    "encordee": [
        "encorder"
    ],
    "encordes": [
        "encorder",
        "encorde"
    ],
    "encore": [
        "encore"
    ],
    "encornaient": [
        "encorner"
    ],
    "encorner": [
        "encorner"
    ],
    "encornet": [
        "encornet"
    ],
    "encornets": [
        "encornet"
    ],
    "encorne": [
        "encorne"
    ],
    "encornee": [
        "encorne"
    ],
    "encornes": [
        "encorne"
    ],
    "encotonne": [
        "encotonner"
    ],
    "encotonner": [
        "encotonner"
    ],
    "encourage": [
        "encourager"
    ],
    "encouragea": [
        "encourager"
    ],
    "encourageai": [
        "encourager"
    ],
    "encourageaient": [
        "encourager"
    ],
    "encourageais": [
        "encourager"
    ],
    "encourageait": [
        "encourager"
    ],
    "encourageant": [
        "encourager",
        "encourageant"
    ],
    "encourageante": [
        "encourageant"
    ],
    "encourageantes": [
        "encourageant"
    ],
    "encourageants": [
        "encourageant"
    ],
    "encourageas": [
        "encourager"
    ],
    "encouragement": [
        "encouragement"
    ],
    "encouragements": [
        "encouragement"
    ],
    "encouragent": [
        "encourager"
    ],
    "encourageons": [
        "encourager"
    ],
    "encourager": [
        "encourager"
    ],
    "encouragera": [
        "encourager"
    ],
    "encouragerai": [
        "encourager"
    ],
    "encouragerais": [
        "encourager"
    ],
    "encouragerait": [
        "encourager"
    ],
    "encourageras": [
        "encourager"
    ],
    "encourages": [
        "encourage",
        "encourager"
    ],
    "encouragez": [
        "encourager"
    ],
    "encourageat": [
        "encourager"
    ],
    "encouragiez": [
        "encourager"
    ],
    "encouragerent": [
        "encourager"
    ],
    "encouragee": [
        "encourager"
    ],
    "encouragees": [
        "encourager"
    ],
    "encouraient": [
        "encourir"
    ],
    "encourais": [
        "encourir"
    ],
    "encourait": [
        "encourir"
    ],
    "encourant": [
        "encourir"
    ],
    "encourent": [
        "encourir"
    ],
    "encourir": [
        "encourir"
    ],
    "encourrait": [
        "encourir"
    ],
    "encours": [
        "encours",
        "encourir"
    ],
    "encourt": [
        "encourir"
    ],
    "encouru": [
        "encourir"
    ],
    "encourue": [
        "encourir"
    ],
    "encourues": [
        "encourir"
    ],
    "encourus": [
        "encourir"
    ],
    "encrage": [
        "encrage"
    ],
    "encrait": [
        "encrer"
    ],
    "encrassait": [
        "encrasser"
    ],
    "encrasse": [
        "encrasse",
        "encrasser"
    ],
    "encrassent": [
        "encrasser"
    ],
    "encrasser": [
        "encrasser"
    ],
    "encrassee": [
        "encrasse",
        "encrasser"
    ],
    "encrassees": [
        "encrasse",
        "encrasser"
    ],
    "encrasses": [
        "encrasse",
        "encrasser"
    ],
    "encre": [
        "encrer",
        "encre"
    ],
    "encrer": [
        "encrer"
    ],
    "encres": [
        "encrer",
        "encre"
    ],
    "encreur": [
        "encreur"
    ],
    "encreurs": [
        "encreur"
    ],
    "encrier": [
        "encrier"
    ],
    "encriers": [
        "encrier"
    ],
    "encrotte": [
        "encrotter"
    ],
    "encroutaient": [
        "encrouter"
    ],
    "encroute": [
        "encrouter",
        "encroute"
    ],
    "encroutement": [
        "encroutement"
    ],
    "encrouter": [
        "encrouter"
    ],
    "encrouterent": [
        "encrouter"
    ],
    "encroutee": [
        "encrouter"
    ],
    "encroutees": [
        "encrouter"
    ],
    "encroutes": [
        "encrouter",
        "encroute"
    ],
    "encryptage": [
        "encryptage"
    ],
    "encrypte": [
        "encrypter"
    ],
    "encree": [
        "encrer"
    ],
    "enculade": [
        "enculade"
    ],
    "enculades": [
        "enculade"
    ],
    "enculage": [
        "enculage"
    ],
    "enculant": [
        "enculer"
    ],
    "encule": [
        "enculer",
        "encule"
    ],
    "enculent": [
        "enculer"
    ],
    "enculer": [
        "enculer"
    ],
    "enculera": [
        "enculer"
    ],
    "enculerais": [
        "enculer"
    ],
    "enculerait": [
        "enculer"
    ],
    "enculerie": [
        "enculerie"
    ],
    "enculeries": [
        "enculerie"
    ],
    "encules": [
        "enculer",
        "encule"
    ],
    "enculeur": [
        "enculeur"
    ],
    "enculeurs": [
        "enculeur"
    ],
    "enculee": [
        "enculer",
        "encule"
    ],
    "enculees": [
        "encule"
    ],
    "encyclique": [
        "encyclique"
    ],
    "encycliques": [
        "encyclique"
    ],
    "encyclopedie": [
        "encyclopedie"
    ],
    "encyclopedies": [
        "encyclopedie"
    ],
    "encyclopedique": [
        "encyclopedique"
    ],
    "encyclopediques": [
        "encyclopedique"
    ],
    "encyclopedistes": [
        "encyclopediste"
    ],
    "encephale": [
        "encephale"
    ],
    "encephalique": [
        "encephalique"
    ],
    "encephaliques": [
        "encephalique"
    ],
    "encephalite": [
        "encephalite"
    ],
    "encephalogramme": [
        "encephalogramme"
    ],
    "encephalographie": [
        "encephalographie"
    ],
    "encephalopathie": [
        "encephalopathie"
    ],
    "endettait": [
        "endetter"
    ],
    "endettant": [
        "endetter"
    ],
    "endette": [
        "endetter",
        "endette"
    ],
    "endettement": [
        "endettement"
    ],
    "endetter": [
        "endetter"
    ],
    "endettez": [
        "endetter"
    ],
    "endettee": [
        "endetter",
        "endette"
    ],
    "endettees": [
        "endetter"
    ],
    "endettes": [
        "endetter",
        "endette"
    ],
    "endeuille": [
        "endeuille",
        "endeuiller"
    ],
    "endeuillent": [
        "endeuiller"
    ],
    "endeuiller": [
        "endeuiller"
    ],
    "endeuillerai": [
        "endeuiller"
    ],
    "endeuillee": [
        "endeuille",
        "endeuiller"
    ],
    "endeuillees": [
        "endeuille",
        "endeuiller"
    ],
    "endeuilles": [
        "endeuille",
        "endeuiller"
    ],
    "endiable": [
        "endiable",
        "endiabler"
    ],
    "endiablent": [
        "endiabler"
    ],
    "endiablerez": [
        "endiabler"
    ],
    "endiablee": [
        "endiable",
        "endiabler"
    ],
    "endiablees": [
        "endiable",
        "endiabler"
    ],
    "endiables": [
        "endiable"
    ],
    "endiamante": [
        "endiamante"
    ],
    "endiamantee": [
        "endiamante"
    ],
    "endiamantees": [
        "endiamante"
    ],
    "endiamantes": [
        "endiamante"
    ],
    "endigua": [
        "endiguer"
    ],
    "endiguait": [
        "endiguer"
    ],
    "endigue": [
        "endiguer"
    ],
    "endiguement": [
        "endiguement"
    ],
    "endiguer": [
        "endiguer"
    ],
    "endiguera": [
        "endiguer"
    ],
    "endiguee": [
        "endiguer"
    ],
    "endigues": [
        "endiguer"
    ],
    "endimanchait": [
        "endimancher"
    ],
    "endimanchement": [
        "endimanchement"
    ],
    "endimancher": [
        "endimancher"
    ],
    "endimanche": [
        "endimanche",
        "endimancher"
    ],
    "endimanchee": [
        "endimanche",
        "endimancher"
    ],
    "endimanchees": [
        "endimanche",
        "endimancher"
    ],
    "endimanches": [
        "endimanche",
        "endimancher"
    ],
    "endive": [
        "endive"
    ],
    "endives": [
        "endive"
    ],
    "endivisionnes": [
        "endivisionner"
    ],
    "endocarde": [
        "endocarde"
    ],
    "endocardite": [
        "endocardite"
    ],
    "endocrine": [
        "endocrine"
    ],
    "endocrines": [
        "endocrine"
    ],
    "endocrinien": [
        "endocrinien"
    ],
    "endocrinienne": [
        "endocrinien"
    ],
    "endocriniens": [
        "endocrinien"
    ],
    "endocrinologie": [
        "endocrinologie"
    ],
    "endocrinologiste": [
        "endocrinologiste"
    ],
    "endocrinologue": [
        "endocrinologue"
    ],
    "endoctrina": [
        "endoctriner"
    ],
    "endoctrinement": [
        "endoctrinement"
    ],
    "endoctriner": [
        "endoctriner"
    ],
    "endoctrine": [
        "endoctriner"
    ],
    "endoctrinee": [
        "endoctriner"
    ],
    "endoctrines": [
        "endoctriner"
    ],
    "endogamie": [
        "endogamie"
    ],
    "endogene": [
        "endogene"
    ],
    "endolori": [
        "endolori",
        "endolorir"
    ],
    "endolorie": [
        "endolori",
        "endolorir"
    ],
    "endolories": [
        "endolori",
        "endolorir"
    ],
    "endolorir": [
        "endolorir"
    ],
    "endoloris": [
        "endolori",
        "endolorir"
    ],
    "endolorissement": [
        "endolorissement"
    ],
    "endommagea": [
        "endommager"
    ],
    "endommageant": [
        "endommager"
    ],
    "endommagement": [
        "endommagement"
    ],
    "endommagements": [
        "endommagement"
    ],
    "endommager": [
        "endommager"
    ],
    "endommagera": [
        "endommager"
    ],
    "endommagerait": [
        "endommager"
    ],
    "endommagerez": [
        "endommager"
    ],
    "endommagez": [
        "endommager"
    ],
    "endommage": [
        "endommager",
        "endommage"
    ],
    "endommagee": [
        "endommager",
        "endommage"
    ],
    "endommagees": [
        "endommager",
        "endommage"
    ],
    "endommages": [
        "endommager",
        "endommage"
    ],
    "endomorphe": [
        "endomorphe"
    ],
    "endomorphine": [
        "endomorphine"
    ],
    "endometriose": [
        "endometriose"
    ],
    "endometrite": [
        "endometrite"
    ],
    "endoplasmique": [
        "endoplasmique"
    ],
    "endormaient": [
        "endormir"
    ],
    "endormais": [
        "endormir"
    ],
    "endormait": [
        "endormir"
    ],
    "endormant": [
        "endormant",
        "endormir"
    ],
    "endormante": [
        "endormant"
    ],
    "endorme": [
        "endormir"
    ],
    "endorment": [
        "endormir"
    ],
    "endormes": [
        "endormir"
    ],
    "endormeur": [
        "endormeur"
    ],
    "endormeurs": [
        "endormeur"
    ],
    "endormez": [
        "endormir"
    ],
    "endormi": [
        "endormi",
        "endormir"
    ],
    "endormie": [
        "endormi"
    ],
    "endormies": [
        "endormi"
    ],
    "endormions": [
        "endormir"
    ],
    "endormir": [
        "endormir"
    ],
    "endormira": [
        "endormir"
    ],
    "endormirai": [
        "endormir"
    ],
    "endormiraient": [
        "endormir"
    ],
    "endormirais": [
        "endormir"
    ],
    "endormirait": [
        "endormir"
    ],
    "endormirent": [
        "endormir"
    ],
    "endormirez": [
        "endormir"
    ],
    "endormirions": [
        "endormir"
    ],
    "endormiront": [
        "endormir"
    ],
    "endormis": [
        "endormi",
        "endormir"
    ],
    "endormisse": [
        "endormir"
    ],
    "endormissement": [
        "endormissement"
    ],
    "endormissements": [
        "endormissement"
    ],
    "endormit": [
        "endormir"
    ],
    "endormons": [
        "endormir"
    ],
    "endormimes": [
        "endormir"
    ],
    "endorphine": [
        "endorphine"
    ],
    "endorphines": [
        "endorphine"
    ],
    "endors": [
        "endormir"
    ],
    "endort": [
        "endormir"
    ],
    "endoscope": [
        "endoscope"
    ],
    "endoscopie": [
        "endoscopie"
    ],
    "endoscopique": [
        "endoscopique"
    ],
    "endosquelette": [
        "endosquelette"
    ],
    "endossa": [
        "endosser"
    ],
    "endossables": [
        "endossable"
    ],
    "endossai": [
        "endosser"
    ],
    "endossaient": [
        "endosser"
    ],
    "endossais": [
        "endosser"
    ],
    "endossait": [
        "endosser"
    ],
    "endossant": [
        "endosser"
    ],
    "endosse": [
        "endosse",
        "endosser"
    ],
    "endossement": [
        "endossement"
    ],
    "endossent": [
        "endosser"
    ],
    "endosser": [
        "endosser"
    ],
    "endosserai": [
        "endosser"
    ],
    "endosserais": [
        "endosser"
    ],
    "endosserait": [
        "endosser"
    ],
    "endosseras": [
        "endosser"
    ],
    "endosses": [
        "endosse",
        "endosser"
    ],
    "endosseur": [
        "endosseur"
    ],
    "endossez": [
        "endosser"
    ],
    "endossiez": [
        "endosser"
    ],
    "endossat": [
        "endosser"
    ],
    "endosserent": [
        "endosser"
    ],
    "endossee": [
        "endosser"
    ],
    "endossees": [
        "endosser"
    ],
    "endothermique": [
        "endothermique"
    ],
    "endroit": [
        "endroit"
    ],
    "endroits": [
        "endroit"
    ],
    "enduira": [
        "enduire"
    ],
    "enduirais": [
        "enduire"
    ],
    "enduirait": [
        "enduire"
    ],
    "enduire": [
        "enduire"
    ],
    "enduis": [
        "enduire"
    ],
    "enduisaient": [
        "enduire"
    ],
    "enduisait": [
        "enduire"
    ],
    "enduisant": [
        "enduire"
    ],
    "enduisent": [
        "enduire"
    ],
    "enduisit": [
        "enduire"
    ],
    "enduisons": [
        "enduire"
    ],
    "enduit": [
        "enduit",
        "enduire"
    ],
    "enduite": [
        "enduire"
    ],
    "enduites": [
        "enduire"
    ],
    "enduits": [
        "enduit",
        "enduire"
    ],
    "endura": [
        "endurer"
    ],
    "endurable": [
        "endurable"
    ],
    "enduraient": [
        "endurer"
    ],
    "endurais": [
        "endurer"
    ],
    "endurait": [
        "endurer"
    ],
    "endurance": [
        "endurance"
    ],
    "endurant": [
        "endurer",
        "endurant"
    ],
    "endurante": [
        "endurant"
    ],
    "endurants": [
        "endurant"
    ],
    "endurci": [
        "endurci",
        "endurcir"
    ],
    "endurcie": [
        "endurci",
        "endurcir"
    ],
    "endurcies": [
        "endurci",
        "endurcir"
    ],
    "endurcir": [
        "endurcir"
    ],
    "endurcirait": [
        "endurcir"
    ],
    "endurcis": [
        "endurci",
        "endurcir"
    ],
    "endurcissait": [
        "endurcir"
    ],
    "endurcissement": [
        "endurcissement"
    ],
    "endurcit": [
        "endurcir"
    ],
    "endure": [
        "endurer"
    ],
    "endurent": [
        "endurer"
    ],
    "endurer": [
        "endurer"
    ],
    "endurera": [
        "endurer"
    ],
    "endurerai": [
        "endurer"
    ],
    "endureras": [
        "endurer"
    ],
    "endurez": [
        "endurer"
    ],
    "enduriez": [
        "endurer"
    ],
    "endurons": [
        "endurer"
    ],
    "enduree": [
        "endurer"
    ],
    "endurees": [
        "endurer"
    ],
    "endures": [
        "endurer",
        "endure"
    ],
    "endemique": [
        "endemique"
    ],
    "endemiques": [
        "endemique"
    ],
    "endever": [
        "endever"
    ],
    "enfance": [
        "enfance"
    ],
    "enfances": [
        "enfance"
    ],
    "enfant": [
        "enfant"
    ],
    "enfanta": [
        "enfanter"
    ],
    "enfantaient": [
        "enfanter"
    ],
    "enfantait": [
        "enfanter"
    ],
    "enfante": [
        "enfanter"
    ],
    "enfantelets": [
        "enfantelet"
    ],
    "enfantement": [
        "enfantement"
    ],
    "enfantements": [
        "enfantement"
    ],
    "enfantent": [
        "enfanter"
    ],
    "enfanter": [
        "enfanter"
    ],
    "enfantera": [
        "enfanter"
    ],
    "enfanterai": [
        "enfanter"
    ],
    "enfantillage": [
        "enfantillage"
    ],
    "enfantillages": [
        "enfantillage"
    ],
    "enfantin": [
        "enfantin"
    ],
    "enfantine": [
        "enfantin"
    ],
    "enfantinement": [
        "enfantinement"
    ],
    "enfantines": [
        "enfantin"
    ],
    "enfantins": [
        "enfantin"
    ],
    "enfantons": [
        "enfanter"
    ],
    "enfants": [
        "enfant"
    ],
    "enfantee": [
        "enfanter"
    ],
    "enfantees": [
        "enfanter"
    ],
    "enfantes": [
        "enfanter"
    ],
    "enfancon": [
        "enfancon"
    ],
    "enfancons": [
        "enfancon"
    ],
    "enfarinait": [
        "enfariner"
    ],
    "enfarine": [
        "enfarine",
        "enfariner"
    ],
    "enfariner": [
        "enfariner"
    ],
    "enfarinee": [
        "enfarine",
        "enfariner"
    ],
    "enfarines": [
        "enfarine",
        "enfariner"
    ],
    "enfer": [
        "enfer"
    ],
    "enferma": [
        "enfermer"
    ],
    "enfermai": [
        "enfermer"
    ],
    "enfermaient": [
        "enfermer"
    ],
    "enfermais": [
        "enfermer"
    ],
    "enfermait": [
        "enfermer"
    ],
    "enfermant": [
        "enfermer"
    ],
    "enferme": [
        "enfermer",
        "enferme"
    ],
    "enfermement": [
        "enfermement"
    ],
    "enferment": [
        "enfermer"
    ],
    "enfermer": [
        "enfermer"
    ],
    "enfermera": [
        "enfermer"
    ],
    "enfermerai": [
        "enfermer"
    ],
    "enfermeraient": [
        "enfermer"
    ],
    "enfermerais": [
        "enfermer"
    ],
    "enfermerait": [
        "enfermer"
    ],
    "enfermerez": [
        "enfermer"
    ],
    "enfermerons": [
        "enfermer"
    ],
    "enfermeront": [
        "enfermer"
    ],
    "enfermes": [
        "enfermer",
        "enferme"
    ],
    "enfermez": [
        "enfermer"
    ],
    "enfermiez": [
        "enfermer"
    ],
    "enfermons": [
        "enfermer"
    ],
    "enfermerent": [
        "enfermer"
    ],
    "enfermee": [
        "enfermer",
        "enferme"
    ],
    "enfermees": [
        "enfermer",
        "enferme"
    ],
    "enferra": [
        "enferrer"
    ],
    "enferrait": [
        "enferrer"
    ],
    "enferrant": [
        "enferrer"
    ],
    "enferre": [
        "enferrer"
    ],
    "enferrent": [
        "enferrer"
    ],
    "enferrer": [
        "enferrer"
    ],
    "enferres": [
        "enferrer"
    ],
    "enferrez": [
        "enferrer"
    ],
    "enferrons": [
        "enferrer"
    ],
    "enferree": [
        "enferrer"
    ],
    "enfers": [
        "enfer"
    ],
    "enfiche": [
        "enficher"
    ],
    "enfila": [
        "enfiler"
    ],
    "enfilade": [
        "enfilade"
    ],
    "enfilades": [
        "enfilade"
    ],
    "enfilage": [
        "enfilage"
    ],
    "enfilai": [
        "enfiler"
    ],
    "enfilaient": [
        "enfiler"
    ],
    "enfilais": [
        "enfiler"
    ],
    "enfilait": [
        "enfiler"
    ],
    "enfilant": [
        "enfiler"
    ],
    "enfile": [
        "enfile",
        "enfiler"
    ],
    "enfilent": [
        "enfiler"
    ],
    "enfiler": [
        "enfiler"
    ],
    "enfilera": [
        "enfiler"
    ],
    "enfilerai": [
        "enfiler"
    ],
    "enfileraient": [
        "enfiler"
    ],
    "enfilerais": [
        "enfiler"
    ],
    "enfilerait": [
        "enfiler"
    ],
    "enfilerez": [
        "enfiler"
    ],
    "enfileront": [
        "enfiler"
    ],
    "enfiles": [
        "enfile",
        "enfiler"
    ],
    "enfileur": [
        "enfileur"
    ],
    "enfilez": [
        "enfiler"
    ],
    "enfilions": [
        "enfiler"
    ],
    "enfilons": [
        "enfiler"
    ],
    "enfilerent": [
        "enfiler"
    ],
    "enfilee": [
        "enfile",
        "enfiler"
    ],
    "enfilees": [
        "enfile",
        "enfiler"
    ],
    "enfin": [
        "enfin"
    ],
    "enfievre": [
        "enfievre",
        "enfievrer"
    ],
    "enfievrent": [
        "enfievrer"
    ],
    "enfievra": [
        "enfievrer"
    ],
    "enfievraient": [
        "enfievrer"
    ],
    "enfievrait": [
        "enfievrer"
    ],
    "enfievree": [
        "enfievre",
        "enfievrer"
    ],
    "enfievrees": [
        "enfievre",
        "enfievrer"
    ],
    "enfievres": [
        "enfievre",
        "enfievrer"
    ],
    "enfla": [
        "enfler"
    ],
    "enflaient": [
        "enfler"
    ],
    "enflait": [
        "enfler"
    ],
    "enflamma": [
        "enflammer"
    ],
    "enflammai": [
        "enflammer"
    ],
    "enflammaient": [
        "enflammer"
    ],
    "enflammait": [
        "enflammer"
    ],
    "enflammant": [
        "enflammer"
    ],
    "enflamme": [
        "enflammer",
        "enflamme"
    ],
    "enflamment": [
        "enflammer"
    ],
    "enflammer": [
        "enflammer"
    ],
    "enflammera": [
        "enflammer"
    ],
    "enflammerait": [
        "enflammer"
    ],
    "enflammez": [
        "enflammer"
    ],
    "enflammat": [
        "enflammer"
    ],
    "enflammerent": [
        "enflammer"
    ],
    "enflammee": [
        "enflammer",
        "enflamme"
    ],
    "enflammees": [
        "enflammer",
        "enflamme"
    ],
    "enflammes": [
        "enflammer",
        "enflamme"
    ],
    "enflant": [
        "enfler"
    ],
    "enfle": [
        "enfle",
        "enfler"
    ],
    "enflent": [
        "enfler"
    ],
    "enfler": [
        "enfler"
    ],
    "enflerait": [
        "enfler"
    ],
    "enfles": [
        "enfle",
        "enfler"
    ],
    "enflure": [
        "enflure"
    ],
    "enflures": [
        "enflure"
    ],
    "enflerent": [
        "enfler"
    ],
    "enflee": [
        "enfle",
        "enfler"
    ],
    "enflees": [
        "enfle",
        "enfler"
    ],
    "enfoire": [
        "enfoire"
    ],
    "enfoiree": [
        "enfoire"
    ],
    "enfoires": [
        "enfoire"
    ],
    "enfonce": [
        "enfoncer",
        "enfonce"
    ],
    "enfoncement": [
        "enfoncement"
    ],
    "enfoncements": [
        "enfoncement"
    ],
    "enfoncent": [
        "enfoncer"
    ],
    "enfoncer": [
        "enfoncer"
    ],
    "enfoncera": [
        "enfoncer"
    ],
    "enfoncerai": [
        "enfoncer"
    ],
    "enfonceraient": [
        "enfoncer"
    ],
    "enfoncerais": [
        "enfoncer"
    ],
    "enfoncerait": [
        "enfoncer"
    ],
    "enfonceras": [
        "enfoncer"
    ],
    "enfoncerez": [
        "enfoncer"
    ],
    "enfoncerions": [
        "enfoncer"
    ],
    "enfoncerons": [
        "enfoncer"
    ],
    "enfonceront": [
        "enfoncer"
    ],
    "enfonces": [
        "enfoncer",
        "enfonce"
    ],
    "enfonceur": [
        "enfonceur"
    ],
    "enfoncez": [
        "enfoncer"
    ],
    "enfonciez": [
        "enfoncer"
    ],
    "enfoncions": [
        "enfoncer"
    ],
    "enfoncerent": [
        "enfoncer"
    ],
    "enfoncee": [
        "enfoncer",
        "enfonce"
    ],
    "enfoncees": [
        "enfoncer",
        "enfonce"
    ],
    "enfonca": [
        "enfoncer"
    ],
    "enfoncage": [
        "enfoncage"
    ],
    "enfoncai": [
        "enfoncer"
    ],
    "enfoncaient": [
        "enfoncer"
    ],
    "enfoncais": [
        "enfoncer"
    ],
    "enfoncait": [
        "enfoncer"
    ],
    "enfoncant": [
        "enfoncer"
    ],
    "enfoncons": [
        "enfoncer"
    ],
    "enfoncames": [
        "enfoncer"
    ],
    "enfoui": [
        "enfoui",
        "enfouir"
    ],
    "enfouie": [
        "enfoui",
        "enfouir"
    ],
    "enfouies": [
        "enfoui",
        "enfouir"
    ],
    "enfouillais": [
        "enfouiller"
    ],
    "enfouillant": [
        "enfouiller"
    ],
    "enfouille": [
        "enfouiller"
    ],
    "enfouiller": [
        "enfouiller"
    ],
    "enfouillee": [
        "enfouiller"
    ],
    "enfouir": [
        "enfouir"
    ],
    "enfouiraient": [
        "enfouir"
    ],
    "enfouis": [
        "enfoui",
        "enfouir"
    ],
    "enfouissais": [
        "enfouir"
    ],
    "enfouissait": [
        "enfouir"
    ],
    "enfouissant": [
        "enfouir"
    ],
    "enfouissement": [
        "enfouissement"
    ],
    "enfouissements": [
        "enfouissement"
    ],
    "enfouissent": [
        "enfouir"
    ],
    "enfouissez": [
        "enfouir"
    ],
    "enfouissons": [
        "enfouir"
    ],
    "enfouit": [
        "enfouir"
    ],
    "enfouraille": [
        "enfourailler",
        "enfouraille"
    ],
    "enfouraillee": [
        "enfouraille"
    ],
    "enfourailles": [
        "enfouraille"
    ],
    "enfourcha": [
        "enfourcher"
    ],
    "enfourchai": [
        "enfourcher"
    ],
    "enfourchaient": [
        "enfourcher"
    ],
    "enfourchais": [
        "enfourcher"
    ],
    "enfourchait": [
        "enfourcher"
    ],
    "enfourchant": [
        "enfourcher"
    ],
    "enfourche": [
        "enfourcher"
    ],
    "enfourchement": [
        "enfourchement"
    ],
    "enfourcher": [
        "enfourcher"
    ],
    "enfourcherait": [
        "enfourcher"
    ],
    "enfourchez": [
        "enfourcher"
    ],
    "enfourchiez": [
        "enfourcher"
    ],
    "enfourchure": [
        "enfourchure"
    ],
    "enfourcherent": [
        "enfourcher"
    ],
    "enfourna": [
        "enfourner"
    ],
    "enfournage": [
        "enfournage"
    ],
    "enfournaient": [
        "enfourner"
    ],
    "enfournait": [
        "enfourner"
    ],
    "enfournant": [
        "enfourner"
    ],
    "enfourne": [
        "enfourner"
    ],
    "enfournent": [
        "enfourner"
    ],
    "enfourner": [
        "enfourner"
    ],
    "enfourniez": [
        "enfourner"
    ],
    "enfournerent": [
        "enfourner"
    ],
    "enfournee": [
        "enfourner"
    ],
    "enfournees": [
        "enfourner"
    ],
    "enfournes": [
        "enfourner"
    ],
    "enfreignaient": [
        "enfreindre"
    ],
    "enfreignais": [
        "enfreindre"
    ],
    "enfreignait": [
        "enfreindre"
    ],
    "enfreignant": [
        "enfreindre"
    ],
    "enfreignent": [
        "enfreindre"
    ],
    "enfreignez": [
        "enfreindre"
    ],
    "enfreindra": [
        "enfreindre"
    ],
    "enfreindrai": [
        "enfreindre"
    ],
    "enfreindrais": [
        "enfreindre"
    ],
    "enfreindre": [
        "enfreindre"
    ],
    "enfreins": [
        "enfreindre"
    ],
    "enfreint": [
        "enfreindre"
    ],
    "enfreinte": [
        "enfreindre"
    ],
    "enfreintes": [
        "enfreindre"
    ],
    "enfui": [
        "enfuir"
    ],
    "enfuie": [
        "enfuir"
    ],
    "enfuient": [
        "enfuir"
    ],
    "enfuies": [
        "enfuir"
    ],
    "enfuir": [
        "enfuir"
    ],
    "enfuira": [
        "enfuir"
    ],
    "enfuirai": [
        "enfuir"
    ],
    "enfuiraient": [
        "enfuir"
    ],
    "enfuirais": [
        "enfuir"
    ],
    "enfuirait": [
        "enfuir"
    ],
    "enfuiras": [
        "enfuir"
    ],
    "enfuirent": [
        "enfuir"
    ],
    "enfuiront": [
        "enfuir"
    ],
    "enfuis": [
        "enfuir"
    ],
    "enfuit": [
        "enfuir"
    ],
    "enfuma": [
        "enfumer"
    ],
    "enfumaient": [
        "enfumer"
    ],
    "enfumait": [
        "enfumer"
    ],
    "enfumer": [
        "enfumer"
    ],
    "enfumez": [
        "enfumer"
    ],
    "enfume": [
        "enfume",
        "enfumer"
    ],
    "enfumee": [
        "enfume",
        "enfumer"
    ],
    "enfumees": [
        "enfume",
        "enfumer"
    ],
    "enfumes": [
        "enfume",
        "enfumer"
    ],
    "enfuyaient": [
        "enfuir"
    ],
    "enfuyais": [
        "enfuir"
    ],
    "enfuyait": [
        "enfuir"
    ],
    "enfuyant": [
        "enfuir"
    ],
    "enfuyez": [
        "enfuir"
    ],
    "enfuyiez": [
        "enfuir"
    ],
    "enfuyons": [
        "enfuir"
    ],
    "engage": [
        "engager",
        "engage"
    ],
    "engagea": [
        "engager"
    ],
    "engageable": [
        "engageable"
    ],
    "engageai": [
        "engager"
    ],
    "engageaient": [
        "engager"
    ],
    "engageais": [
        "engager"
    ],
    "engageait": [
        "engager"
    ],
    "engageant": [
        "engager",
        "engageant"
    ],
    "engageante": [
        "engageant"
    ],
    "engageantes": [
        "engageant"
    ],
    "engageants": [
        "engageant"
    ],
    "engagement": [
        "engagement"
    ],
    "engagements": [
        "engagement"
    ],
    "engagent": [
        "engager"
    ],
    "engageons": [
        "engager"
    ],
    "engager": [
        "engager"
    ],
    "engagera": [
        "engager"
    ],
    "engagerai": [
        "engager"
    ],
    "engageraient": [
        "engager"
    ],
    "engagerais": [
        "engager"
    ],
    "engagerait": [
        "engager"
    ],
    "engageriez": [
        "engager"
    ],
    "engagerions": [
        "engager"
    ],
    "engagerons": [
        "engager"
    ],
    "engageront": [
        "engager"
    ],
    "engages": [
        "engager",
        "engage"
    ],
    "engagez": [
        "engager"
    ],
    "engageames": [
        "engager"
    ],
    "engageat": [
        "engager"
    ],
    "engagiez": [
        "engager"
    ],
    "engagions": [
        "engager"
    ],
    "engagerent": [
        "engager"
    ],
    "engagee": [
        "engager",
        "engage"
    ],
    "engagees": [
        "engager",
        "engage"
    ],
    "engazonnee": [
        "engazonner"
    ],
    "engeance": [
        "engeance"
    ],
    "engeances": [
        "engeance"
    ],
    "engelure": [
        "engelure"
    ],
    "engelures": [
        "engelure"
    ],
    "engendra": [
        "engendrer"
    ],
    "engendraient": [
        "engendrer"
    ],
    "engendrait": [
        "engendrer"
    ],
    "engendrant": [
        "engendrer"
    ],
    "engendrassent": [
        "engendrer"
    ],
    "engendre": [
        "engendrer"
    ],
    "engendrement": [
        "engendrement"
    ],
    "engendrent": [
        "engendrer"
    ],
    "engendrer": [
        "engendrer"
    ],
    "engendrera": [
        "engendrer"
    ],
    "engendreraient": [
        "engendrer"
    ],
    "engendrerait": [
        "engendrer"
    ],
    "engendreuse": [
        "engendreur"
    ],
    "engendrez": [
        "engendrer"
    ],
    "engendrons": [
        "engendrer"
    ],
    "engendrerent": [
        "engendrer"
    ],
    "engendree": [
        "engendrer"
    ],
    "engendrees": [
        "engendrer"
    ],
    "engendres": [
        "engendrer"
    ],
    "engin": [
        "engin"
    ],
    "engineering": [
        "engineer",
        "engineering"
    ],
    "engins": [
        "engin"
    ],
    "englace": [
        "englacer"
    ],
    "englande": [
        "englander"
    ],
    "englander": [
        "englander"
    ],
    "englandes": [
        "englander"
    ],
    "engliche": [
        "engliche"
    ],
    "engloba": [
        "englober"
    ],
    "englobaient": [
        "englober"
    ],
    "englobais": [
        "englober"
    ],
    "englobait": [
        "englober"
    ],
    "englobant": [
        "englober",
        "englobant"
    ],
    "englobe": [
        "englober"
    ],
    "englobent": [
        "englober"
    ],
    "englober": [
        "englober"
    ],
    "englobera": [
        "englober"
    ],
    "engloberaient": [
        "englober"
    ],
    "engloberait": [
        "englober"
    ],
    "englobee": [
        "englober"
    ],
    "englobees": [
        "englober"
    ],
    "englobes": [
        "englober"
    ],
    "englouti": [
        "engloutir"
    ],
    "engloutie": [
        "engloutir"
    ],
    "englouties": [
        "engloutir"
    ],
    "engloutir": [
        "engloutir"
    ],
    "engloutira": [
        "engloutir"
    ],
    "engloutiraient": [
        "engloutir"
    ],
    "engloutirait": [
        "engloutir"
    ],
    "engloutirent": [
        "engloutir"
    ],
    "engloutirons": [
        "engloutir"
    ],
    "engloutis": [
        "engloutir"
    ],
    "engloutissaient": [
        "engloutir"
    ],
    "engloutissais": [
        "engloutir"
    ],
    "engloutissait": [
        "engloutir"
    ],
    "engloutissant": [
        "engloutir"
    ],
    "engloutisse": [
        "engloutir"
    ],
    "engloutissement": [
        "engloutissement"
    ],
    "engloutissent": [
        "engloutir"
    ],
    "engloutissions": [
        "engloutir"
    ],
    "engloutit": [
        "engloutir"
    ],
    "engluaient": [
        "engluer"
    ],
    "engluait": [
        "engluer"
    ],
    "engluant": [
        "engluer"
    ],
    "englue": [
        "engluer",
        "englue"
    ],
    "engluent": [
        "engluer"
    ],
    "engluer": [
        "engluer"
    ],
    "engluee": [
        "engluer",
        "englue"
    ],
    "engluees": [
        "engluer",
        "englue"
    ],
    "englues": [
        "engluer",
        "englue"
    ],
    "engonce": [
        "engoncer",
        "engonce"
    ],
    "engoncement": [
        "engoncement"
    ],
    "engoncee": [
        "engoncer"
    ],
    "engoncees": [
        "engoncer"
    ],
    "engonces": [
        "engoncer",
        "engonce"
    ],
    "engoncaient": [
        "engoncer"
    ],
    "engoncait": [
        "engoncer"
    ],
    "engoncant": [
        "engoncer"
    ],
    "engorge": [
        "engorge",
        "engorger"
    ],
    "engorgeaient": [
        "engorger"
    ],
    "engorgeait": [
        "engorger"
    ],
    "engorgement": [
        "engorgement"
    ],
    "engorgements": [
        "engorgement"
    ],
    "engorgent": [
        "engorger"
    ],
    "engorger": [
        "engorger"
    ],
    "engorgeraient": [
        "engorger"
    ],
    "engorgerent": [
        "engorger"
    ],
    "engorgee": [
        "engorge",
        "engorger"
    ],
    "engorgees": [
        "engorge",
        "engorger"
    ],
    "engorges": [
        "engorge"
    ],
    "engouai": [
        "engouer"
    ],
    "engouait": [
        "engouer"
    ],
    "engouement": [
        "engouement"
    ],
    "engouements": [
        "engouement"
    ],
    "engouffra": [
        "engouffrer"
    ],
    "engouffrai": [
        "engouffrer"
    ],
    "engouffraient": [
        "engouffrer"
    ],
    "engouffrait": [
        "engouffrer"
    ],
    "engouffrant": [
        "engouffrer"
    ],
    "engouffre": [
        "engouffrer"
    ],
    "engouffrement": [
        "engouffrement"
    ],
    "engouffrent": [
        "engouffrer"
    ],
    "engouffrer": [
        "engouffrer"
    ],
    "engouffrera": [
        "engouffrer"
    ],
    "engouffreraient": [
        "engouffrer"
    ],
    "engouffrerait": [
        "engouffrer"
    ],
    "engouffrons": [
        "engouffrer"
    ],
    "engouffrat": [
        "engouffrer"
    ],
    "engouffrerent": [
        "engouffrer"
    ],
    "engouffree": [
        "engouffrer"
    ],
    "engouffrees": [
        "engouffrer"
    ],
    "engouffres": [
        "engouffrer"
    ],
    "engoulevent": [
        "engoulevent"
    ],
    "engourdi": [
        "engourdir",
        "engourdi"
    ],
    "engourdie": [
        "engourdir",
        "engourdi"
    ],
    "engourdies": [
        "engourdir",
        "engourdi"
    ],
    "engourdir": [
        "engourdir"
    ],
    "engourdira": [
        "engourdir"
    ],
    "engourdirai": [
        "engourdir"
    ],
    "engourdirais": [
        "engourdir"
    ],
    "engourdis": [
        "engourdir",
        "engourdi"
    ],
    "engourdissaient": [
        "engourdir"
    ],
    "engourdissait": [
        "engourdir"
    ],
    "engourdissant": [
        "engourdissant",
        "engourdir"
    ],
    "engourdissante": [
        "engourdissant"
    ],
    "engourdissantes": [
        "engourdissant"
    ],
    "engourdissement": [
        "engourdissement"
    ],
    "engourdissements": [
        "engourdissement"
    ],
    "engourdissent": [
        "engourdir"
    ],
    "engourdit": [
        "engourdir"
    ],
    "engoue": [
        "engouer"
    ],
    "engouee": [
        "engouer"
    ],
    "engoues": [
        "engouer"
    ],
    "engrainait": [
        "engrainer"
    ],
    "engrais": [
        "engrais"
    ],
    "engraissaient": [
        "engraisser"
    ],
    "engraissait": [
        "engraisser"
    ],
    "engraissant": [
        "engraisser"
    ],
    "engraisse": [
        "engraisser"
    ],
    "engraissement": [
        "engraissement"
    ],
    "engraissent": [
        "engraisser"
    ],
    "engraisser": [
        "entrer",
        "engraisser"
    ],
    "engraisseraient": [
        "engraisser"
    ],
    "engraisserait": [
        "engraisser"
    ],
    "engraisserons": [
        "engraisser"
    ],
    "engraisses": [
        "engraisser"
    ],
    "engraissez": [
        "engraisser"
    ],
    "engraisserent": [
        "engraisser"
    ],
    "engraissee": [
        "engraisser"
    ],
    "engraissees": [
        "engraisser"
    ],
    "engrange": [
        "engranger"
    ],
    "engrangea": [
        "engranger"
    ],
    "engrangeais": [
        "engranger"
    ],
    "engrangeait": [
        "engranger"
    ],
    "engrangeant": [
        "engranger"
    ],
    "engrangement": [
        "engrangement"
    ],
    "engrangent": [
        "engranger"
    ],
    "engrangeons": [
        "engranger"
    ],
    "engranger": [
        "engranger"
    ],
    "engrangee": [
        "engranger"
    ],
    "engrangees": [
        "engranger"
    ],
    "engranges": [
        "engranger"
    ],
    "engravement": [
        "engravement"
    ],
    "engraver": [
        "engraver"
    ],
    "engrenage": [
        "engrenage"
    ],
    "engrenages": [
        "engrenage"
    ],
    "engrenait": [
        "engrener"
    ],
    "engrenant": [
        "engrener"
    ],
    "engrener": [
        "engrener"
    ],
    "engrenez": [
        "engrener"
    ],
    "engrossait": [
        "engrosser"
    ],
    "engrossant": [
        "engrosser"
    ],
    "engrosse": [
        "engrosser"
    ],
    "engrossent": [
        "engrosser"
    ],
    "engrosser": [
        "engrosser"
    ],
    "engrossera": [
        "engrosser"
    ],
    "engrosses": [
        "engrosser",
        "engross"
    ],
    "engrossee": [
        "engrosser"
    ],
    "engrossees": [
        "engrosser"
    ],
    "engueula": [
        "engueuler"
    ],
    "engueulade": [
        "engueulade"
    ],
    "engueulades": [
        "engueulade"
    ],
    "engueulaient": [
        "engueuler"
    ],
    "engueulais": [
        "engueuler"
    ],
    "engueulait": [
        "engueuler"
    ],
    "engueulant": [
        "engueuler"
    ],
    "engueule": [
        "engueuler"
    ],
    "engueulent": [
        "engueuler"
    ],
    "engueuler": [
        "engueuler"
    ],
    "engueulera": [
        "engueuler"
    ],
    "engueuleraient": [
        "engueuler"
    ],
    "engueulerait": [
        "engueuler"
    ],
    "engueuleras": [
        "engueuler"
    ],
    "engueulerez": [
        "engueuler"
    ],
    "engueuleront": [
        "engueuler"
    ],
    "engueules": [
        "engueuler"
    ],
    "engueulez": [
        "engueuler"
    ],
    "engueuliez": [
        "engueuler"
    ],
    "engueulions": [
        "engueuler"
    ],
    "engueulons": [
        "engueuler"
    ],
    "engueulerent": [
        "engueuler"
    ],
    "engueulee": [
        "engueuler"
    ],
    "enguirlandaient": [
        "enguirlander"
    ],
    "enguirlandait": [
        "enguirlander"
    ],
    "enguirlande": [
        "enguirlander"
    ],
    "enguirlandent": [
        "enguirlander"
    ],
    "enguirlander": [
        "enguirlander"
    ],
    "enguirlandee": [
        "enguirlande",
        "enguirlander"
    ],
    "enguirlandees": [
        "enguirlande",
        "enguirlander"
    ],
    "enguirlandes": [
        "enguirlande",
        "enguirlander"
    ],
    "enhardi": [
        "enhardir"
    ],
    "enhardie": [
        "enhardir"
    ],
    "enhardies": [
        "enhardir"
    ],
    "enhardir": [
        "enhardir"
    ],
    "enhardirent": [
        "enhardir"
    ],
    "enhardis": [
        "enhardir"
    ],
    "enhardissaient": [
        "enhardir"
    ],
    "enhardissait": [
        "enhardir"
    ],
    "enhardissant": [
        "enhardir"
    ],
    "enhardissement": [
        "enhardissement"
    ],
    "enhardissent": [
        "enhardir"
    ],
    "enhardit": [
        "enhardir"
    ],
    "enivra": [
        "enivrer"
    ],
    "enivrai": [
        "enivrer"
    ],
    "enivraient": [
        "enivrer"
    ],
    "enivrais": [
        "enivrer"
    ],
    "enivrait": [
        "enivrer"
    ],
    "enivrant": [
        "enivrer",
        "enivrant"
    ],
    "enivrante": [
        "enivrant"
    ],
    "enivrantes": [
        "enivrant"
    ],
    "enivrants": [
        "enivrant"
    ],
    "enivre": [
        "enivrer"
    ],
    "enivrement": [
        "enivrement"
    ],
    "enivrent": [
        "enivrer"
    ],
    "enivrer": [
        "enivrer"
    ],
    "enivreras": [
        "enivrer"
    ],
    "enivrerez": [
        "enivrer"
    ],
    "enivres": [
        "enivrer"
    ],
    "enivrez": [
        "enivrer"
    ],
    "enivrons": [
        "enivrer"
    ],
    "enivrerent": [
        "enivrer"
    ],
    "enivree": [
        "enivrer"
    ],
    "enivrees": [
        "enivrer"
    ],
    "enjamba": [
        "enjamber"
    ],
    "enjambai": [
        "enjamber"
    ],
    "enjambaient": [
        "enjamber"
    ],
    "enjambais": [
        "enjamber"
    ],
    "enjambait": [
        "enjamber"
    ],
    "enjambant": [
        "enjamber"
    ],
    "enjambe": [
        "enjamber"
    ],
    "enjambements": [
        "enjambement"
    ],
    "enjambent": [
        "enjamber"
    ],
    "enjamber": [
        "enjamber"
    ],
    "enjamberais": [
        "enjamber"
    ],
    "enjamberait": [
        "enjamber"
    ],
    "enjambes": [
        "enjamber"
    ],
    "enjambeur": [
        "enjambeur"
    ],
    "enjambeurs": [
        "enjambeur"
    ],
    "enjambez": [
        "enjamber"
    ],
    "enjambions": [
        "enjamber"
    ],
    "enjambons": [
        "enjamber"
    ],
    "enjamberent": [
        "enjamber"
    ],
    "enjambee": [
        "enjamber",
        "enjambee"
    ],
    "enjambees": [
        "enjamber",
        "enjambee"
    ],
    "enjeu": [
        "enjeu"
    ],
    "enjeux": [
        "enjeu"
    ],
    "enjoignaient": [
        "enjoindre"
    ],
    "enjoignait": [
        "enjoindre"
    ],
    "enjoignant": [
        "enjoindre"
    ],
    "enjoignis": [
        "enjoindre"
    ],
    "enjoignit": [
        "enjoindre"
    ],
    "enjoignons": [
        "enjoindre"
    ],
    "enjoindre": [
        "enjoindre"
    ],
    "enjoint": [
        "enjoint",
        "enjoindre"
    ],
    "enjolivaient": [
        "enjoliver"
    ],
    "enjolivait": [
        "enjoliver"
    ],
    "enjolivant": [
        "enjoliver"
    ],
    "enjolive": [
        "enjoliver"
    ],
    "enjolivements": [
        "enjolivement"
    ],
    "enjoliver": [
        "enjoliver"
    ],
    "enjoliveur": [
        "enjoliveur"
    ],
    "enjoliveurs": [
        "enjoliveur"
    ],
    "enjolivee": [
        "enjoliver"
    ],
    "enjolives": [
        "enjoliver"
    ],
    "enjouement": [
        "enjouement"
    ],
    "enjoue": [
        "enjoue",
        "enjouer"
    ],
    "enjouee": [
        "enjoue",
        "enjouer"
    ],
    "enjouees": [
        "enjoue"
    ],
    "enjoues": [
        "enjoue",
        "enjouer"
    ],
    "enjuiver": [
        "enjuiver"
    ],
    "enjuives": [
        "enjuive"
    ],
    "enjuponne": [
        "enjuponner"
    ],
    "enjuponnee": [
        "enjuponner"
    ],
    "enjolait": [
        "enjoler"
    ],
    "enjolant": [
        "enjoler"
    ],
    "enjole": [
        "enjoler"
    ],
    "enjolement": [
        "enjolement"
    ],
    "enjoler": [
        "enjoler"
    ],
    "enjoleur": [
        "enjoleur"
    ],
    "enjoleurs": [
        "enjoleur"
    ],
    "enjoleuse": [
        "enjoleur"
    ],
    "enjoleuses": [
        "enjoleur"
    ],
    "enjolee": [
        "enjoler"
    ],
    "enkyster": [
        "enkyster"
    ],
    "enkystees": [
        "enkyste"
    ],
    "enlace": [
        "enlacer"
    ],
    "enlacement": [
        "enlacement"
    ],
    "enlacements": [
        "enlacement"
    ],
    "enlacent": [
        "enlacer"
    ],
    "enlacer": [
        "enlacer"
    ],
    "enlacerai": [
        "enlacer"
    ],
    "enlacerons": [
        "enlacer"
    ],
    "enlacez": [
        "enlacer"
    ],
    "enlacions": [
        "enlacer"
    ],
    "enlacerent": [
        "enlacer"
    ],
    "enlacee": [
        "enlacer"
    ],
    "enlacees": [
        "enlacer"
    ],
    "enlaces": [
        "enlacer"
    ],
    "enlaidi": [
        "enlaidir"
    ],
    "enlaidie": [
        "enlaidir",
        "enlaidi"
    ],
    "enlaidir": [
        "enlaidir"
    ],
    "enlaidis": [
        "enlaidir"
    ],
    "enlaidissait": [
        "enlaidir"
    ],
    "enlaidissant": [
        "enlaidir"
    ],
    "enlaidisse": [
        "enlaidir"
    ],
    "enlaidissement": [
        "enlaidissement"
    ],
    "enlaidissent": [
        "enlaidir"
    ],
    "enlaidisses": [
        "enlaidir"
    ],
    "enlaidit": [
        "enlaidir"
    ],
    "enlaca": [
        "enlacer"
    ],
    "enlacaient": [
        "enlacer"
    ],
    "enlacais": [
        "enlacer"
    ],
    "enlacait": [
        "enlacer"
    ],
    "enlacant": [
        "enlacer",
        "enlacant"
    ],
    "enlacons": [
        "enlacer"
    ],
    "enleva": [
        "enlever"
    ],
    "enlevai": [
        "enlever"
    ],
    "enlevaient": [
        "enlever"
    ],
    "enlevais": [
        "enlever"
    ],
    "enlevait": [
        "enlever"
    ],
    "enlevant": [
        "enlever"
    ],
    "enlever": [
        "enlever"
    ],
    "enlevez": [
        "enlever"
    ],
    "enleviez": [
        "enlever"
    ],
    "enlevions": [
        "enlever"
    ],
    "enlevons": [
        "enlever"
    ],
    "enlevat": [
        "enlever"
    ],
    "enleverent": [
        "enlever"
    ],
    "enleve": [
        "enlever",
        "enleve"
    ],
    "enlevee": [
        "enlever",
        "enleve"
    ],
    "enlevees": [
        "enlever",
        "enleve"
    ],
    "enleves": [
        "enlever",
        "enleve"
    ],
    "enliasser": [
        "enliasser"
    ],
    "enlisa": [
        "enliser"
    ],
    "enlisaient": [
        "enliser"
    ],
    "enlisais": [
        "enliser"
    ],
    "enlisait": [
        "enliser"
    ],
    "enlisant": [
        "enliser"
    ],
    "enlise": [
        "enliser"
    ],
    "enlisement": [
        "enlisement"
    ],
    "enlisent": [
        "enliser"
    ],
    "enliser": [
        "enliser"
    ],
    "enlisera": [
        "enliser"
    ],
    "enliserais": [
        "enliser"
    ],
    "enlisee": [
        "enliser"
    ],
    "enlisees": [
        "enliser"
    ],
    "enlises": [
        "enliser"
    ],
    "enlumine": [
        "enlumine",
        "enluminer"
    ],
    "enluminent": [
        "enluminer"
    ],
    "enluminer": [
        "enluminer"
    ],
    "enlumineur": [
        "enlumineur"
    ],
    "enlumineurs": [
        "enlumineur"
    ],
    "enluminure": [
        "enluminure"
    ],
    "enluminures": [
        "enluminure"
    ],
    "enluminee": [
        "enlumine",
        "enluminer"
    ],
    "enluminees": [
        "enlumine",
        "enluminer"
    ],
    "enlumines": [
        "enlumine",
        "enluminer"
    ],
    "enlevement": [
        "enlevement"
    ],
    "enlevements": [
        "enlevement"
    ],
    "enlevent": [
        "enlever"
    ],
    "enlevera": [
        "enlever"
    ],
    "enleverai": [
        "enlever"
    ],
    "enleveraient": [
        "enlever"
    ],
    "enleverais": [
        "enlever"
    ],
    "enleverait": [
        "enlever"
    ],
    "enleveras": [
        "enlever"
    ],
    "enleverez": [
        "enlever"
    ],
    "enleveriez": [
        "enlever"
    ],
    "enleverons": [
        "enlever"
    ],
    "enleveront": [
        "enlever"
    ],
    "enneige": [
        "enneiger",
        "enneige"
    ],
    "enneigeait": [
        "enneiger"
    ],
    "enneigement": [
        "enneigement"
    ],
    "enneiger": [
        "enneiger"
    ],
    "enneigee": [
        "enneiger",
        "enneige"
    ],
    "enneigees": [
        "enneiger",
        "enneige"
    ],
    "enneiges": [
        "enneiger",
        "enneige"
    ],
    "ennemi": [
        "ennemi"
    ],
    "ennemie": [
        "ennemi"
    ],
    "ennemies": [
        "ennemi"
    ],
    "ennemis": [
        "ennemi"
    ],
    "ennobli": [
        "ennoblir"
    ],
    "ennoblie": [
        "ennoblir"
    ],
    "ennoblir": [
        "ennoblir"
    ],
    "ennoblis": [
        "ennoblir"
    ],
    "ennoblissement": [
        "ennoblissement"
    ],
    "ennoblit": [
        "ennoblir"
    ],
    "ennuagent": [
        "ennuager"
    ],
    "ennuager": [
        "ennuager"
    ],
    "ennuage": [
        "ennuager"
    ],
    "ennui": [
        "ennui"
    ],
    "ennuie": [
        "ennuyer"
    ],
    "ennuient": [
        "ennuyer"
    ],
    "ennuiera": [
        "ennuyer"
    ],
    "ennuierai": [
        "ennuyer"
    ],
    "ennuieraient": [
        "ennuyer"
    ],
    "ennuierais": [
        "ennuyer"
    ],
    "ennuierait": [
        "ennuyer"
    ],
    "ennuieras": [
        "ennuyer"
    ],
    "ennuierez": [
        "ennuyer"
    ],
    "ennuieriez": [
        "ennuyer"
    ],
    "ennuierions": [
        "ennuyer"
    ],
    "ennuierons": [
        "ennuyer"
    ],
    "ennuieront": [
        "ennuyer"
    ],
    "ennuies": [
        "ennuyer"
    ],
    "ennuis": [
        "ennui"
    ],
    "ennuya": [
        "ennuyer"
    ],
    "ennuyai": [
        "ennuyer"
    ],
    "ennuyaient": [
        "ennuyer"
    ],
    "ennuyais": [
        "ennuyer"
    ],
    "ennuyait": [
        "ennuyer"
    ],
    "ennuyant": [
        "ennuyer",
        "ennuyant"
    ],
    "ennuyante": [
        "ennuyant"
    ],
    "ennuyer": [
        "ennuyer"
    ],
    "ennuyeuse": [
        "ennuyeux"
    ],
    "ennuyeuses": [
        "ennuyeux"
    ],
    "ennuyeux": [
        "ennuyeux"
    ],
    "ennuyez": [
        "ennuyer"
    ],
    "ennuyiez": [
        "ennuyer"
    ],
    "ennuyions": [
        "ennuyer"
    ],
    "ennuyons": [
        "ennuyer"
    ],
    "ennuyat": [
        "ennuyer"
    ],
    "ennuyerent": [
        "ennuyer"
    ],
    "ennuye": [
        "ennuye",
        "ennuyer"
    ],
    "ennuyee": [
        "ennuye",
        "ennuyer"
    ],
    "ennuyees": [
        "ennuye",
        "ennuyer"
    ],
    "ennuyes": [
        "ennuye",
        "ennuyer"
    ],
    "enorgueilli": [
        "enorgueillir"
    ],
    "enorgueillir": [
        "enorgueillir"
    ],
    "enorgueillirent": [
        "enorgueillir"
    ],
    "enorgueillis": [
        "enorgueillir"
    ],
    "enorgueillissais": [
        "enorgueillir"
    ],
    "enorgueillissait": [
        "enorgueillir"
    ],
    "enorgueillissant": [
        "enorgueillir"
    ],
    "enorgueillisse": [
        "enorgueillir"
    ],
    "enorgueillissent": [
        "enorgueillir"
    ],
    "enorgueillit": [
        "enorgueillir"
    ],
    "enquerraient": [
        "enquerir"
    ],
    "enquiers": [
        "enquerir"
    ],
    "enquiert": [
        "enquerir"
    ],
    "enquillais": [
        "enquiller"
    ],
    "enquillait": [
        "enquiller"
    ],
    "enquillant": [
        "enquiller"
    ],
    "enquille": [
        "enquiller"
    ],
    "enquillent": [
        "enquiller"
    ],
    "enquiller": [
        "enquiller"
    ],
    "enquillons": [
        "enquiller"
    ],
    "enquilles": [
        "enquiller"
    ],
    "enquiquinaient": [
        "enquiquiner"
    ],
    "enquiquinait": [
        "enquiquiner"
    ],
    "enquiquinant": [
        "enquiquinant",
        "enquiquiner"
    ],
    "enquiquinante": [
        "enquiquinant"
    ],
    "enquiquinants": [
        "enquiquinant"
    ],
    "enquiquine": [
        "enquiquiner"
    ],
    "enquiquinement": [
        "enquiquinement"
    ],
    "enquiquinent": [
        "enquiquiner"
    ],
    "enquiquiner": [
        "enquiquiner"
    ],
    "enquiquineraient": [
        "enquiquiner"
    ],
    "enquiquines": [
        "enquiquiner"
    ],
    "enquiquineur": [
        "enquiquineur"
    ],
    "enquiquineurs": [
        "enquiquineur"
    ],
    "enquiquineuse": [
        "enquiquineur"
    ],
    "enquis": [
        "enquerir"
    ],
    "enquise": [
        "enquerir"
    ],
    "enquit": [
        "enquerir"
    ],
    "enquiere": [
        "enquerir"
    ],
    "enquierent": [
        "enquerir"
    ],
    "enqueraient": [
        "enquerir"
    ],
    "enquerais": [
        "enquerir"
    ],
    "enquerait": [
        "enquerir"
    ],
    "enquerant": [
        "enquerir"
    ],
    "enquerez": [
        "enquerir"
    ],
    "enquerir": [
        "enquerir"
    ],
    "enqueta": [
        "enqueter"
    ],
    "enquetais": [
        "enqueter"
    ],
    "enquetait": [
        "enqueter"
    ],
    "enquetant": [
        "enqueter"
    ],
    "enquete": [
        "enquete",
        "enqueter"
    ],
    "enquetent": [
        "enqueter"
    ],
    "enqueter": [
        "enqueter"
    ],
    "enquetes": [
        "enquete",
        "enqueter"
    ],
    "enqueteur": [
        "enqueteur"
    ],
    "enqueteurs": [
        "enqueteur"
    ],
    "enqueteuse": [
        "enqueteur"
    ],
    "enquetez": [
        "enqueter"
    ],
    "enquetrices": [
        "enqueteur"
    ],
    "enracinais": [
        "enraciner"
    ],
    "enracinait": [
        "enraciner"
    ],
    "enracinant": [
        "enraciner"
    ],
    "enracine": [
        "enraciner",
        "enracine"
    ],
    "enracinement": [
        "enracinement"
    ],
    "enracinements": [
        "enracinement"
    ],
    "enracinent": [
        "enraciner"
    ],
    "enraciner": [
        "enraciner"
    ],
    "enracinerait": [
        "enraciner"
    ],
    "enracineras": [
        "enraciner"
    ],
    "enracinerez": [
        "enraciner"
    ],
    "enracinee": [
        "enraciner",
        "enracine"
    ],
    "enracinees": [
        "enraciner",
        "enracine"
    ],
    "enracines": [
        "enraciner",
        "enracine"
    ],
    "enrage": [
        "enrager",
        "enrage"
    ],
    "enragea": [
        "enrager"
    ],
    "enrageai": [
        "enrager"
    ],
    "enrageais": [
        "enrager"
    ],
    "enrageait": [
        "enrager"
    ],
    "enrageant": [
        "enrager"
    ],
    "enrageante": [
        "enrageant"
    ],
    "enragement": [
        "enragement"
    ],
    "enragent": [
        "enrager"
    ],
    "enrager": [
        "enrager"
    ],
    "enragerais": [
        "enrager"
    ],
    "enragee": [
        "enrager",
        "enrage"
    ],
    "enragees": [
        "enrager",
        "enrage"
    ],
    "enrages": [
        "enrager",
        "enrage"
    ],
    "enraie": [
        "enrayer"
    ],
    "enraillee": [
        "enrailler"
    ],
    "enraya": [
        "enrayer"
    ],
    "enrayage": [
        "enrayage"
    ],
    "enrayait": [
        "enrayer"
    ],
    "enrayant": [
        "enrayer"
    ],
    "enraye": [
        "enrayer"
    ],
    "enrayement": [
        "enrayement"
    ],
    "enrayent": [
        "enrayer"
    ],
    "enrayer": [
        "enrayer"
    ],
    "enrayera": [
        "enrayer"
    ],
    "enrayee": [
        "enrayer"
    ],
    "enregistra": [
        "enregistrer"
    ],
    "enregistrable": [
        "enregistrable"
    ],
    "enregistrai": [
        "enregistrer"
    ],
    "enregistraient": [
        "enregistrer"
    ],
    "enregistrais": [
        "enregistrer"
    ],
    "enregistrait": [
        "enregistrer"
    ],
    "enregistrant": [
        "enregistrer"
    ],
    "enregistre": [
        "enregistrer"
    ],
    "enregistrement": [
        "enregistrement"
    ],
    "enregistrements": [
        "enregistrement"
    ],
    "enregistrent": [
        "enregistrer"
    ],
    "enregistrer": [
        "enregistrer"
    ],
    "enregistrera": [
        "enregistrer"
    ],
    "enregistrerai": [
        "enregistrer"
    ],
    "enregistrerait": [
        "enregistrer"
    ],
    "enregistreras": [
        "enregistrer"
    ],
    "enregistrerez": [
        "enregistrer"
    ],
    "enregistrerons": [
        "enregistrer"
    ],
    "enregistreront": [
        "enregistrer"
    ],
    "enregistres": [
        "enregistrer"
    ],
    "enregistreur": [
        "enregistreur"
    ],
    "enregistreurs": [
        "enregistreur"
    ],
    "enregistreuse": [
        "enregistreur"
    ],
    "enregistreuses": [
        "enregistreur"
    ],
    "enregistrez": [
        "enregistrer"
    ],
    "enregistriez": [
        "enregistrer"
    ],
    "enregistrions": [
        "enregistrer"
    ],
    "enregistrons": [
        "enregistrer"
    ],
    "enregistree": [
        "enregistrer"
    ],
    "enregistrees": [
        "enregistrer"
    ],
    "enrhumait": [
        "enrhumer"
    ],
    "enrhume": [
        "enrhumer",
        "enrhume"
    ],
    "enrhument": [
        "enrhumer"
    ],
    "enrhumer": [
        "enrhumer"
    ],
    "enrhumes": [
        "enrhumer",
        "enrhume"
    ],
    "enrhumez": [
        "enrhumer"
    ],
    "enrhumee": [
        "enrhumer",
        "enrhume"
    ],
    "enrhumees": [
        "enrhume"
    ],
    "enrichi": [
        "enrichir",
        "enrichi"
    ],
    "enrichie": [
        "enrichir",
        "enrichi"
    ],
    "enrichies": [
        "enrichir",
        "enrichi"
    ],
    "enrichir": [
        "enrichir"
    ],
    "enrichira": [
        "enrichir"
    ],
    "enrichirais": [
        "enrichir"
    ],
    "enrichirait": [
        "enrichir"
    ],
    "enrichiront": [
        "enrichir"
    ],
    "enrichis": [
        "enrichir",
        "enrichi"
    ],
    "enrichissaient": [
        "enrichir"
    ],
    "enrichissais": [
        "enrichir"
    ],
    "enrichissait": [
        "enrichir"
    ],
    "enrichissant": [
        "enrichissant",
        "enrichir"
    ],
    "enrichissante": [
        "enrichissant"
    ],
    "enrichissantes": [
        "enrichissant"
    ],
    "enrichissants": [
        "enrichissant"
    ],
    "enrichisse": [
        "enrichir"
    ],
    "enrichissement": [
        "enrichissement"
    ],
    "enrichissements": [
        "enrichissement"
    ],
    "enrichissent": [
        "enrichir"
    ],
    "enrichissez": [
        "enrichir"
    ],
    "enrichit": [
        "enrichir"
    ],
    "enrobage": [
        "enrobage"
    ],
    "enrobaient": [
        "enrober"
    ],
    "enrobait": [
        "enrober"
    ],
    "enrobant": [
        "enrober"
    ],
    "enrobe": [
        "enrobe",
        "enrober"
    ],
    "enrober": [
        "enrober"
    ],
    "enroberent": [
        "enrober"
    ],
    "enrobee": [
        "enrobe",
        "enrober"
    ],
    "enrobees": [
        "enrobe",
        "enrober"
    ],
    "enrobes": [
        "enrobe",
        "enrober"
    ],
    "enrochements": [
        "enrochement"
    ],
    "enroua": [
        "enrouer"
    ],
    "enrouaient": [
        "enrouer"
    ],
    "enrouait": [
        "enrouer"
    ],
    "enroue": [
        "enrouer",
        "enroue"
    ],
    "enrouement": [
        "enrouement"
    ],
    "enrouements": [
        "enrouement"
    ],
    "enrouer": [
        "enrouer"
    ],
    "enroula": [
        "enrouler"
    ],
    "enroulage": [
        "enroulage"
    ],
    "enroulai": [
        "enrouler"
    ],
    "enroulaient": [
        "enrouler"
    ],
    "enroulais": [
        "enrouler"
    ],
    "enroulait": [
        "enrouler"
    ],
    "enroulant": [
        "enrouler"
    ],
    "enroule": [
        "enrouler"
    ],
    "enroulement": [
        "enroulement"
    ],
    "enroulements": [
        "enroulement"
    ],
    "enroulent": [
        "enrouler"
    ],
    "enrouler": [
        "enrouler"
    ],
    "enroulera": [
        "enrouler"
    ],
    "enroulerais": [
        "enrouler"
    ],
    "enroulez": [
        "enrouler"
    ],
    "enroulerent": [
        "enrouler"
    ],
    "enroulee": [
        "enrouler"
    ],
    "enroulees": [
        "enrouler"
    ],
    "enroules": [
        "enrouler"
    ],
    "enrouee": [
        "enrouer",
        "enroue"
    ],
    "enrouees": [
        "enrouer",
        "enroue"
    ],
    "enroues": [
        "enrouer",
        "enroue"
    ],
    "enrubannaient": [
        "enrubanner"
    ],
    "enrubannait": [
        "enrubanner"
    ],
    "enrubanner": [
        "enrubanner"
    ],
    "enrubanne": [
        "enrubanne",
        "enrubanner"
    ],
    "enrubannee": [
        "enrubanne",
        "enrubanner"
    ],
    "enrubannees": [
        "enrubanne",
        "enrubanner"
    ],
    "enrubannes": [
        "enrubanne",
        "enrubanner"
    ],
    "enregimentait": [
        "enregimenter"
    ],
    "enregimenter": [
        "enregimenter"
    ],
    "enregimenterait": [
        "enregimenter"
    ],
    "enrola": [
        "enroler"
    ],
    "enrolaient": [
        "enroler"
    ],
    "enrolais": [
        "enroler"
    ],
    "enrolait": [
        "enroler"
    ],
    "enrolant": [
        "enroler"
    ],
    "enrole": [
        "enroler",
        "enrole"
    ],
    "enrolement": [
        "enrolement"
    ],
    "enrolements": [
        "enrolement"
    ],
    "enroler": [
        "enroler"
    ],
    "enrolerait": [
        "enroler"
    ],
    "enroleriez": [
        "enroler"
    ],
    "enrolez": [
        "enroler"
    ],
    "enrolons": [
        "enroler"
    ],
    "enrolee": [
        "enroler"
    ],
    "enrolees": [
        "enroler"
    ],
    "enroles": [
        "enroler",
        "enrole"
    ],
    "ensablait": [
        "ensabler"
    ],
    "ensable": [
        "ensabler",
        "ensable"
    ],
    "ensablement": [
        "ensablement"
    ],
    "ensablent": [
        "ensabler"
    ],
    "ensabler": [
        "ensabler"
    ],
    "ensablerent": [
        "ensabler"
    ],
    "ensablee": [
        "ensabler",
        "ensable"
    ],
    "ensablees": [
        "ensabler",
        "ensable"
    ],
    "ensables": [
        "ensabler",
        "ensable"
    ],
    "ensacher": [
        "ensacher"
    ],
    "ensache": [
        "ensacher"
    ],
    "ensanglanta": [
        "ensanglanter"
    ],
    "ensanglantaient": [
        "ensanglanter"
    ],
    "ensanglantant": [
        "ensanglanter"
    ],
    "ensanglante": [
        "ensanglante",
        "ensanglanter"
    ],
    "ensanglantement": [
        "ensanglantement"
    ],
    "ensanglanter": [
        "ensanglanter"
    ],
    "ensanglanterent": [
        "ensanglanter"
    ],
    "ensanglantee": [
        "ensanglante",
        "ensanglanter"
    ],
    "ensanglantees": [
        "ensanglante",
        "ensanglanter"
    ],
    "ensanglantes": [
        "ensanglante",
        "ensanglanter"
    ],
    "ensauvageait": [
        "ensauvager"
    ],
    "ensauvagement": [
        "ensauvagement"
    ],
    "ensauvage": [
        "ensauvager"
    ],
    "ensauvagee": [
        "ensauvager"
    ],
    "ensauvagees": [
        "ensauvager"
    ],
    "ensauvages": [
        "ensauvager"
    ],
    "ensauve": [
        "ensauver"
    ],
    "ensauves": [
        "ensauver"
    ],
    "enseigna": [
        "enseigner"
    ],
    "enseignaient": [
        "enseigner"
    ],
    "enseignais": [
        "enseigner"
    ],
    "enseignait": [
        "enseigner"
    ],
    "enseignant": [
        "enseignant",
        "enseigner"
    ],
    "enseignante": [
        "enseignant"
    ],
    "enseignantes": [
        "enseignant"
    ],
    "enseignants": [
        "enseignant"
    ],
    "enseigne": [
        "enseigne",
        "enseigner"
    ],
    "enseignement": [
        "enseignement"
    ],
    "enseignements": [
        "enseignement"
    ],
    "enseignent": [
        "enseigner"
    ],
    "enseigner": [
        "enseigner"
    ],
    "enseignera": [
        "enseigner"
    ],
    "enseignerai": [
        "enseigner"
    ],
    "enseigneraient": [
        "enseigner"
    ],
    "enseignerais": [
        "enseigner"
    ],
    "enseignerait": [
        "enseigner"
    ],
    "enseigneras": [
        "enseigner"
    ],
    "enseignerez": [
        "enseigner"
    ],
    "enseignerons": [
        "enseigner"
    ],
    "enseigneront": [
        "enseigner"
    ],
    "enseignes": [
        "enseigne",
        "enseigner"
    ],
    "enseigneur": [
        "enseigneur"
    ],
    "enseignez": [
        "enseigner"
    ],
    "enseigniez": [
        "enseigner"
    ],
    "enseignons": [
        "enseigner"
    ],
    "enseignat": [
        "enseigner"
    ],
    "enseignerent": [
        "enseigner"
    ],
    "enseignee": [
        "enseigne",
        "enseigner"
    ],
    "enseignees": [
        "enseigner"
    ],
    "ensellement": [
        "ensellement"
    ],
    "ensellure": [
        "ensellure"
    ],
    "enselle": [
        "enselle"
    ],
    "enselles": [
        "enselle"
    ],
    "ensemble": [
        "ensemble"
    ],
    "ensembles": [
        "ensemble"
    ],
    "ensemencement": [
        "ensemencement"
    ],
    "ensemencements": [
        "ensemencement"
    ],
    "ensemencer": [
        "ensemencer"
    ],
    "ensemence": [
        "ensemencer"
    ],
    "ensemencee": [
        "ensemencer"
    ],
    "ensemences": [
        "ensemencer"
    ],
    "ensemenca": [
        "ensemencer"
    ],
    "ensemencaient": [
        "ensemencer"
    ],
    "ensemencait": [
        "ensemencer"
    ],
    "ensemencant": [
        "ensemencer"
    ],
    "enserra": [
        "enserrer"
    ],
    "enserrai": [
        "enserrer"
    ],
    "enserraient": [
        "enserrer"
    ],
    "enserrait": [
        "enserrer"
    ],
    "enserrant": [
        "enserrer"
    ],
    "enserre": [
        "enserrer"
    ],
    "enserrent": [
        "enserrer"
    ],
    "enserrer": [
        "enserrer"
    ],
    "enserrera": [
        "enserrer"
    ],
    "enserrerait": [
        "enserrer"
    ],
    "enserres": [
        "enserrer"
    ],
    "enserrerent": [
        "enserrer"
    ],
    "enserree": [
        "enserrer"
    ],
    "enserrees": [
        "enserrer"
    ],
    "enseveli": [
        "enseveli",
        "ensevelir"
    ],
    "ensevelie": [
        "enseveli",
        "ensevelir"
    ],
    "ensevelies": [
        "enseveli",
        "ensevelir"
    ],
    "ensevelir": [
        "ensevelir"
    ],
    "ensevelira": [
        "ensevelir"
    ],
    "ensevelirait": [
        "ensevelir"
    ],
    "ensevelis": [
        "enseveli",
        "ensevelir"
    ],
    "ensevelissaient": [
        "ensevelir"
    ],
    "ensevelissais": [
        "ensevelir"
    ],
    "ensevelissait": [
        "ensevelir"
    ],
    "ensevelissant": [
        "ensevelir"
    ],
    "ensevelisse": [
        "ensevelir"
    ],
    "ensevelissement": [
        "ensevelissement"
    ],
    "ensevelissent": [
        "ensevelir"
    ],
    "ensevelisseuse": [
        "ensevelisseur"
    ],
    "ensevelissez": [
        "ensevelir"
    ],
    "ensevelissons": [
        "ensevelir"
    ],
    "ensevelit": [
        "ensevelir"
    ],
    "ensoleilla": [
        "ensoleiller"
    ],
    "ensoleillement": [
        "ensoleillement"
    ],
    "ensoleiller": [
        "ensoleiller"
    ],
    "ensoleillerent": [
        "ensoleiller"
    ],
    "ensoleille": [
        "ensoleille",
        "ensoleiller"
    ],
    "ensoleillee": [
        "ensoleille",
        "ensoleiller"
    ],
    "ensoleillees": [
        "ensoleille",
        "ensoleiller"
    ],
    "ensoleilles": [
        "ensoleille",
        "ensoleiller"
    ],
    "ensommeilla": [
        "ensommeiller"
    ],
    "ensommeillaient": [
        "ensommeiller"
    ],
    "ensommeillait": [
        "ensommeiller"
    ],
    "ensommeiller": [
        "ensommeiller"
    ],
    "ensommeille": [
        "ensommeille",
        "ensommeiller"
    ],
    "ensommeillee": [
        "ensommeille",
        "ensommeiller"
    ],
    "ensommeillees": [
        "ensommeille",
        "ensommeiller"
    ],
    "ensommeilles": [
        "ensommeille"
    ],
    "ensorcelaient": [
        "ensorceler"
    ],
    "ensorcelant": [
        "ensorceler",
        "ensorcelant"
    ],
    "ensorcelante": [
        "ensorcelant"
    ],
    "ensorcelantes": [
        "ensorcelant"
    ],
    "ensorceler": [
        "ensorceler"
    ],
    "ensorceleur": [
        "ensorceleur"
    ],
    "ensorceleuse": [
        "ensorceleur"
    ],
    "ensorceleuses": [
        "ensorceleur"
    ],
    "ensorcelez": [
        "ensorceler"
    ],
    "ensorcelle": [
        "ensorceler"
    ],
    "ensorcellement": [
        "ensorcellement"
    ],
    "ensorcellent": [
        "ensorceler"
    ],
    "ensorcelles": [
        "ensorceler"
    ],
    "ensorcele": [
        "ensorceler",
        "ensorcele"
    ],
    "ensorcelee": [
        "ensorceler",
        "ensorcele"
    ],
    "ensorcelees": [
        "ensorceler",
        "ensorcele"
    ],
    "ensorceles": [
        "ensorceler",
        "ensorcele"
    ],
    "ensouple": [
        "ensouple"
    ],
    "ensoutanee": [
        "ensoutane"
    ],
    "ensoutanees": [
        "ensoutaner"
    ],
    "ensuit": [
        "ensuivre"
    ],
    "ensuite": [
        "ensuite"
    ],
    "ensuivaient": [
        "ensuivre"
    ],
    "ensuivait": [
        "ensuivre"
    ],
    "ensuive": [
        "ensuivre"
    ],
    "ensuivent": [
        "ensuivre"
    ],
    "ensuivi": [
        "ensuivre"
    ],
    "ensuivie": [
        "ensuivre"
    ],
    "ensuivies": [
        "ensuivre"
    ],
    "ensuivirent": [
        "ensuivre"
    ],
    "ensuivit": [
        "ensuivre"
    ],
    "ensuivra": [
        "ensuivre"
    ],
    "ensuivraient": [
        "ensuivre"
    ],
    "ensuivrait": [
        "ensuivre"
    ],
    "ensuivre": [
        "ensuivre"
    ],
    "ensuivront": [
        "ensuivre"
    ],
    "ensuquent": [
        "ensuquer"
    ],
    "ensuque": [
        "ensuquer"
    ],
    "ensuquee": [
        "ensuquer"
    ],
    "entablement": [
        "entablement"
    ],
    "entachait": [
        "entacher"
    ],
    "entache": [
        "entacher",
        "entache"
    ],
    "entachent": [
        "entacher"
    ],
    "entacher": [
        "entacher"
    ],
    "entacherait": [
        "entacher"
    ],
    "entachee": [
        "entacher",
        "entache"
    ],
    "entachees": [
        "entacher",
        "entache"
    ],
    "entaches": [
        "entacher"
    ],
    "entailla": [
        "entailler"
    ],
    "entaillait": [
        "entailler"
    ],
    "entaille": [
        "entaille",
        "entailler"
    ],
    "entaillent": [
        "entailler"
    ],
    "entailler": [
        "entailler"
    ],
    "entaillerai": [
        "entailler"
    ],
    "entailles": [
        "entaille",
        "entailler"
    ],
    "entaillee": [
        "entaille",
        "entailler"
    ],
    "entaillees": [
        "entaille",
        "entailler"
    ],
    "entama": [
        "entamer"
    ],
    "entamai": [
        "entamer"
    ],
    "entamaient": [
        "entamer"
    ],
    "entamais": [
        "entamer"
    ],
    "entamait": [
        "entamer"
    ],
    "entamant": [
        "entamer"
    ],
    "entame": [
        "entame",
        "entamer"
    ],
    "entament": [
        "entamer"
    ],
    "entamer": [
        "entamer"
    ],
    "entamera": [
        "entamer"
    ],
    "entamerai": [
        "entamer"
    ],
    "entameraient": [
        "entamer"
    ],
    "entamerais": [
        "entamer"
    ],
    "entamerait": [
        "entamer"
    ],
    "entamerez": [
        "entamer"
    ],
    "entamerons": [
        "entamer"
    ],
    "entames": [
        "entame",
        "entamer"
    ],
    "entamez": [
        "entamer"
    ],
    "entamons": [
        "entamer"
    ],
    "entamat": [
        "entamer"
    ],
    "entamerent": [
        "entamer"
    ],
    "entamee": [
        "entamer"
    ],
    "entamees": [
        "entamer"
    ],
    "entant": [
        "enter"
    ],
    "entassa": [
        "entasser"
    ],
    "entassaient": [
        "entasser"
    ],
    "entassait": [
        "entasser"
    ],
    "entassant": [
        "entasser"
    ],
    "entasse": [
        "entasser"
    ],
    "entassement": [
        "entassement"
    ],
    "entassements": [
        "entassement"
    ],
    "entassent": [
        "entasser"
    ],
    "entasser": [
        "entasser"
    ],
    "entassera": [
        "entasser"
    ],
    "entasseraient": [
        "entasser"
    ],
    "entasserait": [
        "entasser"
    ],
    "entasseront": [
        "entasser"
    ],
    "entassez": [
        "entasser"
    ],
    "entassions": [
        "entasser"
    ],
    "entassons": [
        "entasser"
    ],
    "entassames": [
        "entasser"
    ],
    "entasserent": [
        "entasser"
    ],
    "entassee": [
        "entasser"
    ],
    "entassees": [
        "entasser"
    ],
    "entasses": [
        "entasser"
    ],
    "ente": [
        "enter",
        "ente"
    ],
    "entement": [
        "entement"
    ],
    "entend": [
        "entendre"
    ],
    "entendaient": [
        "entendre"
    ],
    "entendais": [
        "entendre"
    ],
    "entendait": [
        "entendre"
    ],
    "entendant": [
        "entendre",
        "entendant"
    ],
    "entende": [
        "entendre"
    ],
    "entendement": [
        "entendement"
    ],
    "entendent": [
        "entendre"
    ],
    "entendes": [
        "entendre"
    ],
    "entendeur": [
        "entendeur"
    ],
    "entendeurs": [
        "entendeur"
    ],
    "entendez": [
        "entendre"
    ],
    "entendiez": [
        "entendre"
    ],
    "entendions": [
        "entendre"
    ],
    "entendirent": [
        "entendre"
    ],
    "entendis": [
        "entendre"
    ],
    "entendisse": [
        "entendre"
    ],
    "entendissent": [
        "entendre"
    ],
    "entendit": [
        "entendre"
    ],
    "entendons": [
        "entendre"
    ],
    "entendra": [
        "entendre"
    ],
    "entendrai": [
        "entendre"
    ],
    "entendraient": [
        "entendre"
    ],
    "entendrais": [
        "entendre"
    ],
    "entendrait": [
        "entendre"
    ],
    "entendras": [
        "entendre"
    ],
    "entendre": [
        "entendre"
    ],
    "entendrez": [
        "entendre"
    ],
    "entendriez": [
        "entendre"
    ],
    "entendrions": [
        "entendre"
    ],
    "entendrons": [
        "entendre"
    ],
    "entendront": [
        "entendre"
    ],
    "entends": [
        "entendre"
    ],
    "entendu": [
        "entendu",
        "entendre"
    ],
    "entendue": [
        "entendu",
        "entendre"
    ],
    "entendues": [
        "entendu",
        "entendre"
    ],
    "entendus": [
        "entendu",
        "entendre"
    ],
    "entendimes": [
        "entendre"
    ],
    "entente": [
        "entente"
    ],
    "ententes": [
        "entente"
    ],
    "enter": [
        "enter"
    ],
    "enterra": [
        "enterrer"
    ],
    "enterrai": [
        "enterrer"
    ],
    "enterraient": [
        "enterrer"
    ],
    "enterrais": [
        "enterrer"
    ],
    "enterrait": [
        "enterrer"
    ],
    "enterrant": [
        "enterrer"
    ],
    "enterre": [
        "enterrer",
        "enterre"
    ],
    "enterrement": [
        "enterrement"
    ],
    "enterrements": [
        "enterrement"
    ],
    "enterrent": [
        "enterrer"
    ],
    "enterrer": [
        "enterrer"
    ],
    "enterrera": [
        "enterrer"
    ],
    "enterrerai": [
        "enterrer"
    ],
    "enterrerais": [
        "enterrer"
    ],
    "enterrerait": [
        "enterrer"
    ],
    "enterreras": [
        "enterrer"
    ],
    "enterrerez": [
        "enterrer"
    ],
    "enterrerons": [
        "enterrer"
    ],
    "enterreront": [
        "enterrer"
    ],
    "enterres": [
        "enterrer",
        "enterre"
    ],
    "enterreur": [
        "enterreur"
    ],
    "enterrez": [
        "enterrer"
    ],
    "enterriez": [
        "enterrer"
    ],
    "enterrions": [
        "enterrer"
    ],
    "enterrons": [
        "enterrer"
    ],
    "enterrames": [
        "enterrer"
    ],
    "enterrerent": [
        "enterrer"
    ],
    "enterree": [
        "enterrer",
        "enterre"
    ],
    "enterrees": [
        "enterrer",
        "enterre"
    ],
    "enthalpie": [
        "enthalpie"
    ],
    "enthousiasma": [
        "enthousiasmer"
    ],
    "enthousiasmai": [
        "enthousiasmer"
    ],
    "enthousiasmaient": [
        "enthousiasmer"
    ],
    "enthousiasmais": [
        "enthousiasmer"
    ],
    "enthousiasmait": [
        "enthousiasmer"
    ],
    "enthousiasmant": [
        "enthousiasmant",
        "enthousiasmer"
    ],
    "enthousiasmante": [
        "enthousiasmant"
    ],
    "enthousiasme": [
        "enthousiasme",
        "enthousiasmer"
    ],
    "enthousiasmer": [
        "enthousiasmer"
    ],
    "enthousiasmes": [
        "enthousiasme",
        "enthousiasmer"
    ],
    "enthousiasmez": [
        "enthousiasmer"
    ],
    "enthousiasmerent": [
        "enthousiasmer"
    ],
    "enthousiasmee": [
        "enthousiasmer"
    ],
    "enthousiaste": [
        "enthousiaste"
    ],
    "enthousiastes": [
        "enthousiaste"
    ],
    "enticha": [
        "enticher"
    ],
    "entichait": [
        "enticher"
    ],
    "entiche": [
        "enticher"
    ],
    "entichement": [
        "entichement"
    ],
    "entichent": [
        "enticher"
    ],
    "enticher": [
        "enticher"
    ],
    "entichera": [
        "enticher"
    ],
    "enticherent": [
        "enticher"
    ],
    "entichee": [
        "entiche",
        "enticher"
    ],
    "entiches": [
        "enticher"
    ],
    "entier": [
        "entier"
    ],
    "entiers": [
        "entier"
    ],
    "entifler": [
        "entifler"
    ],
    "entifle": [
        "entifler"
    ],
    "entite": [
        "entite"
    ],
    "entites": [
        "entite"
    ],
    "entiere": [
        "entier"
    ],
    "entierement": [
        "entierement"
    ],
    "entieres": [
        "entier"
    ],
    "entierete": [
        "entierete"
    ],
    "entoilage": [
        "entoilage"
    ],
    "entoiler": [
        "entoiler"
    ],
    "entoilees": [
        "entoiler"
    ],
    "entoiles": [
        "entoiler"
    ],
    "entolome": [
        "entolome"
    ],
    "entolomes": [
        "entolome"
    ],
    "entomologie": [
        "entomologie"
    ],
    "entomologique": [
        "entomologique"
    ],
    "entomologiste": [
        "entomologiste"
    ],
    "entomologistes": [
        "entomologiste"
    ],
    "entonna": [
        "entonner"
    ],
    "entonnaient": [
        "entonner"
    ],
    "entonnais": [
        "entonner"
    ],
    "entonnait": [
        "entonner"
    ],
    "entonnant": [
        "entonner"
    ],
    "entonne": [
        "entonner"
    ],
    "entonnent": [
        "entonner"
    ],
    "entonner": [
        "entonner"
    ],
    "entonnera": [
        "entonner"
    ],
    "entonneraient": [
        "entonner"
    ],
    "entonnions": [
        "entonner"
    ],
    "entonnoir": [
        "entonnoir"
    ],
    "entonnoirs": [
        "entonnoir"
    ],
    "entonnons": [
        "entonner"
    ],
    "entonnames": [
        "entonner"
    ],
    "entonnerent": [
        "entonner"
    ],
    "entorse": [
        "entorse"
    ],
    "entorses": [
        "entorse"
    ],
    "entortilla": [
        "entortiller"
    ],
    "entortillage": [
        "entortillage"
    ],
    "entortillages": [
        "entortillage"
    ],
    "entortillai": [
        "entortiller"
    ],
    "entortillaient": [
        "entortiller"
    ],
    "entortillait": [
        "entortiller"
    ],
    "entortillant": [
        "entortiller"
    ],
    "entortille": [
        "entortille",
        "entortiller"
    ],
    "entortillement": [
        "entortillement"
    ],
    "entortillent": [
        "entortiller"
    ],
    "entortiller": [
        "entortiller"
    ],
    "entortilleraient": [
        "entortiller"
    ],
    "entortillee": [
        "entortille",
        "entortiller"
    ],
    "entortillees": [
        "entortiller"
    ],
    "entortilles": [
        "entortille",
        "entortiller"
    ],
    "entour": [
        "entour"
    ],
    "entoura": [
        "entourer"
    ],
    "entourage": [
        "entourage"
    ],
    "entourages": [
        "entourage"
    ],
    "entourai": [
        "entourer"
    ],
    "entouraient": [
        "entourer"
    ],
    "entourais": [
        "entourer"
    ],
    "entourait": [
        "entourer"
    ],
    "entourant": [
        "entourer"
    ],
    "entoure": [
        "entoure",
        "entourer"
    ],
    "entourent": [
        "entourer"
    ],
    "entourer": [
        "entourer"
    ],
    "entourera": [
        "entourer"
    ],
    "entoureraient": [
        "entourer"
    ],
    "entourerait": [
        "entourer"
    ],
    "entoureront": [
        "entourer"
    ],
    "entoures": [
        "entoure",
        "entourer"
    ],
    "entourez": [
        "entourer"
    ],
    "entourions": [
        "entourer"
    ],
    "entourloupe": [
        "entourloupe"
    ],
    "entourloupent": [
        "entourlouper"
    ],
    "entourlouper": [
        "entourlouper"
    ],
    "entourloupes": [
        "entourloupe"
    ],
    "entourloupette": [
        "entourloupette"
    ],
    "entourloupettes": [
        "entourloupette"
    ],
    "entournures": [
        "entournure"
    ],
    "entourons": [
        "entourer"
    ],
    "entours": [
        "entour"
    ],
    "entourat": [
        "entourer"
    ],
    "entourerent": [
        "entourer"
    ],
    "entouree": [
        "entoure",
        "entourer"
    ],
    "entourees": [
        "entoure",
        "entourer"
    ],
    "entr'acte": [
        "entr'acte"
    ],
    "entr'actes": [
        "entr'acte"
    ],
    "entr'aimer": [
        "entr'aimer"
    ],
    "entr'apercevoir": [
        "entr'apercevoir"
    ],
    "entr'apercu": [
        "entr'apercevoir"
    ],
    "entr'apercue": [
        "entr'apercevoir"
    ],
    "entr'apercues": [
        "entr'apercevoir"
    ],
    "entr'apercus": [
        "entr'apercevoir"
    ],
    "entr'appellent": [
        "entr'appeler"
    ],
    "entr'ouvert": [
        "entr'ouvert"
    ],
    "entr'ouverte": [
        "entr'ouvert"
    ],
    "entr'ouvertes": [
        "entr'ouvert"
    ],
    "entr'ouverts": [
        "entr'ouvert"
    ],
    "entr'egorgent": [
        "entr'egorger"
    ],
    "entr'egorger": [
        "entr'egorger"
    ],
    "entr'egorgerent": [
        "entr'egorger"
    ],
    "entra": [
        "entrer"
    ],
    "entracte": [
        "entracte"
    ],
    "entractes": [
        "entracte"
    ],
    "entrai": [
        "entrer"
    ],
    "entraidait": [
        "entraider"
    ],
    "entraidant": [
        "entraider"
    ],
    "entraide": [
        "entraider",
        "entraide"
    ],
    "entraident": [
        "entraider"
    ],
    "entraider": [
        "entraider"
    ],
    "entraidez": [
        "entraider"
    ],
    "entraidiez": [
        "entraider"
    ],
    "entraidons": [
        "entraider"
    ],
    "entraides": [
        "entraider"
    ],
    "entraient": [
        "entrer"
    ],
    "entrailles": [
        "entrailles"
    ],
    "entrain": [
        "entrain"
    ],
    "entrais": [
        "entrer"
    ],
    "entrait": [
        "entrer"
    ],
    "entrant": [
        "entrer",
        "entrant"
    ],
    "entrante": [
        "entrant"
    ],
    "entrantes": [
        "entrant"
    ],
    "entrants": [
        "entrant"
    ],
    "entrapercevoir": [
        "entrapercevoir"
    ],
    "entrapercu": [
        "entrapercevoir"
    ],
    "entrapercues": [
        "entrapercevoir"
    ],
    "entrapercus": [
        "entrapercevoir"
    ],
    "entrassent": [
        "entrer"
    ],
    "entrava": [
        "entraver"
    ],
    "entravai": [
        "entraver"
    ],
    "entravaient": [
        "entraver"
    ],
    "entravais": [
        "entraver"
    ],
    "entravait": [
        "entraver"
    ],
    "entravant": [
        "entraver"
    ],
    "entrave": [
        "entrave",
        "entraver"
    ],
    "entravent": [
        "entraver"
    ],
    "entraver": [
        "entraver"
    ],
    "entravera": [
        "entraver"
    ],
    "entraverais": [
        "entraver"
    ],
    "entraverait": [
        "entraver"
    ],
    "entraveront": [
        "entraver"
    ],
    "entraves": [
        "entrave",
        "entraver"
    ],
    "entravez": [
        "entraver"
    ],
    "entraverent": [
        "entraver"
    ],
    "entravee": [
        "entrave",
        "entraver"
    ],
    "entravees": [
        "entrave",
        "entraver"
    ],
    "entraina": [
        "entrainer"
    ],
    "entrainai": [
        "entrainer"
    ],
    "entrainaient": [
        "entrainer"
    ],
    "entrainais": [
        "entrainer"
    ],
    "entrainait": [
        "entrainer"
    ],
    "entrainant": [
        "entrainant",
        "entrainer"
    ],
    "entrainante": [
        "entrainant"
    ],
    "entrainants": [
        "entrainant"
    ],
    "entraine": [
        "entrainer",
        "entraine"
    ],
    "entrainement": [
        "entrainement"
    ],
    "entrainements": [
        "entrainement"
    ],
    "entrainent": [
        "entrainer"
    ],
    "entrainer": [
        "entrainer"
    ],
    "entrainera": [
        "entrainer"
    ],
    "entrainerai": [
        "entrainer"
    ],
    "entraineraient": [
        "entrainer"
    ],
    "entrainerais": [
        "entrainer"
    ],
    "entrainerait": [
        "entrainer"
    ],
    "entraineras": [
        "entrainer"
    ],
    "entrainerez": [
        "entrainer"
    ],
    "entraineriez": [
        "entrainer"
    ],
    "entraineront": [
        "entrainer"
    ],
    "entraines": [
        "entrainer",
        "entraine"
    ],
    "entraineur": [
        "entraineur"
    ],
    "entraineurs": [
        "entraineur"
    ],
    "entraineuse": [
        "entraineur"
    ],
    "entraineuses": [
        "entraineur"
    ],
    "entrainez": [
        "entrainer"
    ],
    "entrainiez": [
        "entrainer"
    ],
    "entrainons": [
        "entrainer"
    ],
    "entrainat": [
        "entrainer"
    ],
    "entrainerent": [
        "entrainer"
    ],
    "entrainee": [
        "entrainer",
        "entraine"
    ],
    "entrainees": [
        "entrainer",
        "entraine"
    ],
    "entre": [
        "entre",
        "entrer"
    ],
    "entrebattre": [
        "entrebattre"
    ],
    "entrebailla": [
        "entrebailler"
    ],
    "entrebaillaient": [
        "entrebailler"
    ],
    "entrebaillais": [
        "entrebailler"
    ],
    "entrebaillait": [
        "entrebailler"
    ],
    "entrebaillant": [
        "entrebailler"
    ],
    "entrebaille": [
        "entrebaille",
        "entrebailler"
    ],
    "entrebaillement": [
        "entrebaillement"
    ],
    "entrebaillent": [
        "entrebailler"
    ],
    "entrebailler": [
        "entrebailler"
    ],
    "entrebaillerait": [
        "entrebailler"
    ],
    "entrebailleur": [
        "entrebailleur"
    ],
    "entrebaillerent": [
        "entrebailler"
    ],
    "entrebaillee": [
        "entrebaille",
        "entrebailler"
    ],
    "entrebaillees": [
        "entrebaille",
        "entrebailler"
    ],
    "entrebailles": [
        "entrebaille",
        "entrebailler"
    ],
    "entrechat": [
        "entrechat"
    ],
    "entrechats": [
        "entrechat"
    ],
    "entrechoc": [
        "entrechoc"
    ],
    "entrechocs": [
        "entrechoc"
    ],
    "entrechoquaient": [
        "entrechoquer"
    ],
    "entrechoquait": [
        "entrechoquer"
    ],
    "entrechoquant": [
        "entrechoquer"
    ],
    "entrechoque": [
        "entrechoquer"
    ],
    "entrechoquement": [
        "entrechoquement"
    ],
    "entrechoquent": [
        "entrechoquer"
    ],
    "entrechoquer": [
        "entrechoquer"
    ],
    "entrechoqueront": [
        "entrechoquer"
    ],
    "entrechoquions": [
        "entrechoquer"
    ],
    "entrechoquerent": [
        "entrechoquer"
    ],
    "entrechoquees": [
        "entrechoquer"
    ],
    "entrechoques": [
        "entrechoquer"
    ],
    "entreclos": [
        "entreclore"
    ],
    "entrecloses": [
        "entreclos"
    ],
    "entrecoupaient": [
        "entrecouper"
    ],
    "entrecoupais": [
        "entrecouper"
    ],
    "entrecoupait": [
        "entrecouper"
    ],
    "entrecoupant": [
        "entrecouper"
    ],
    "entrecoupe": [
        "entrecoupe",
        "entrecouper"
    ],
    "entrecoupent": [
        "entrecouper"
    ],
    "entrecouper": [
        "entrecouper"
    ],
    "entrecoupee": [
        "entrecoupe",
        "entrecouper"
    ],
    "entrecoupees": [
        "entrecoupe",
        "entrecouper"
    ],
    "entrecoupes": [
        "entrecoupe",
        "entrecouper"
    ],
    "entrecroisaient": [
        "entrecroiser"
    ],
    "entrecroisait": [
        "entrecroiser"
    ],
    "entrecroisant": [
        "entrecroiser"
    ],
    "entrecroise": [
        "entrecroiser"
    ],
    "entrecroisement": [
        "entrecroisement"
    ],
    "entrecroisements": [
        "entrecroisement"
    ],
    "entrecroisent": [
        "entrecroiser"
    ],
    "entrecroiser": [
        "entrecroiser"
    ],
    "entrecroiserent": [
        "entrecroiser"
    ],
    "entrecroisees": [
        "entrecroiser"
    ],
    "entrecroises": [
        "entrecroiser"
    ],
    "entrecuisse": [
        "entrecuisse"
    ],
    "entrecote": [
        "entrecote"
    ],
    "entrecotes": [
        "entrecote"
    ],
    "entredechire": [
        "entredechirer"
    ],
    "entredevorait": [
        "entredevorer"
    ],
    "entredevorer": [
        "entredevorer"
    ],
    "entrefaites": [
        "entrefaite"
    ],
    "entreferma": [
        "entrefermer"
    ],
    "entrefermee": [
        "entrefermer"
    ],
    "entrefermees": [
        "entrefermer"
    ],
    "entrefilet": [
        "entrefilet"
    ],
    "entrefilets": [
        "entrefilet"
    ],
    "entregent": [
        "entregent"
    ],
    "entrejambe": [
        "entrejambe"
    ],
    "entrejambes": [
        "entrejambe"
    ],
    "entrelace": [
        "entrelace",
        "entrelacer"
    ],
    "entrelacement": [
        "entrelacement"
    ],
    "entrelacent": [
        "entrelacer"
    ],
    "entrelacer": [
        "entrelacer"
    ],
    "entrelacs": [
        "entrelacs"
    ],
    "entrelacerent": [
        "entrelacer"
    ],
    "entrelacee": [
        "entrelace",
        "entrelacer"
    ],
    "entrelacees": [
        "entrelace",
        "entrelacer"
    ],
    "entrelaces": [
        "entrelace",
        "entrelacer"
    ],
    "entrelarde": [
        "entrelarder",
        "entrelarde"
    ],
    "entrelarder": [
        "entrelarder"
    ],
    "entrelardee": [
        "entrelarder"
    ],
    "entrelardees": [
        "entrelarder"
    ],
    "entrelardes": [
        "entrelarder"
    ],
    "entrelacaient": [
        "entrelacer"
    ],
    "entrelacait": [
        "entrelacer"
    ],
    "entremet": [
        "entremettre"
    ],
    "entremets": [
        "entremets"
    ],
    "entremettait": [
        "entremettre"
    ],
    "entremetteur": [
        "entremetteur"
    ],
    "entremetteurs": [
        "entremetteur"
    ],
    "entremetteuse": [
        "entremetteur"
    ],
    "entremettre": [
        "entremettre"
    ],
    "entremis": [
        "entremettre"
    ],
    "entremise": [
        "entremettre",
        "entremise"
    ],
    "entremit": [
        "entremettre"
    ],
    "entremelaient": [
        "entremeler"
    ],
    "entremelait": [
        "entremeler"
    ],
    "entremelant": [
        "entremeler"
    ],
    "entremele": [
        "entremeler"
    ],
    "entremelement": [
        "entremelement"
    ],
    "entremelent": [
        "entremeler"
    ],
    "entremelees": [
        "entremeler"
    ],
    "entremeles": [
        "entremeler"
    ],
    "entrent": [
        "entrer"
    ],
    "entrepont": [
        "entrepont"
    ],
    "entreponts": [
        "entrepont"
    ],
    "entreposage": [
        "entreposage"
    ],
    "entreposais": [
        "entreposer"
    ],
    "entreposait": [
        "entreposer"
    ],
    "entrepose": [
        "entreposer",
        "entrepose"
    ],
    "entreposent": [
        "entreposer"
    ],
    "entreposer": [
        "entreposer"
    ],
    "entreposerait": [
        "entreposer"
    ],
    "entreposez": [
        "entreposer"
    ],
    "entreposions": [
        "entreposer"
    ],
    "entreposee": [
        "entreposer",
        "entrepose"
    ],
    "entreposees": [
        "entreposer",
        "entrepose"
    ],
    "entreposes": [
        "entreposer",
        "entrepose"
    ],
    "entreprenaient": [
        "entreprendre"
    ],
    "entreprenais": [
        "entreprendre"
    ],
    "entreprenait": [
        "entreprendre"
    ],
    "entreprenant": [
        "entreprendre",
        "entreprenant"
    ],
    "entreprenante": [
        "entreprenant"
    ],
    "entreprenantes": [
        "entreprenant"
    ],
    "entreprenants": [
        "entreprenant"
    ],
    "entreprend": [
        "entreprendre"
    ],
    "entreprendrai": [
        "entreprendre"
    ],
    "entreprendraient": [
        "entreprendre"
    ],
    "entreprendrais": [
        "entreprendre"
    ],
    "entreprendrait": [
        "entreprendre"
    ],
    "entreprendras": [
        "entreprendre"
    ],
    "entreprendre": [
        "entreprendre"
    ],
    "entreprendrez": [
        "entreprendre"
    ],
    "entreprendrons": [
        "entreprendre"
    ],
    "entreprends": [
        "entreprendre"
    ],
    "entrepreneur": [
        "entrepreneur"
    ],
    "entrepreneurs": [
        "entrepreneur"
    ],
    "entrepreneuse": [
        "entrepreneur"
    ],
    "entrepreneuses": [
        "entrepreneur"
    ],
    "entreprenez": [
        "entreprendre"
    ],
    "entrepreniez": [
        "entreprendre"
    ],
    "entreprenions": [
        "entreprendre"
    ],
    "entreprenne": [
        "entreprendre"
    ],
    "entreprennent": [
        "entreprendre"
    ],
    "entreprenons": [
        "entreprendre"
    ],
    "entreprirent": [
        "entreprendre"
    ],
    "entrepris": [
        "entreprendre"
    ],
    "entreprise": [
        "entreprendre",
        "entreprise"
    ],
    "entreprises": [
        "entreprendre",
        "entreprise"
    ],
    "entreprit": [
        "entreprendre"
    ],
    "entreprimes": [
        "entreprendre"
    ],
    "entrepot": [
        "entrepot"
    ],
    "entrepots": [
        "entrepot"
    ],
    "entrer": [
        "entrer"
    ],
    "entrera": [
        "entrer"
    ],
    "entrerai": [
        "entrer"
    ],
    "entreraient": [
        "entrer"
    ],
    "entrerais": [
        "entrer"
    ],
    "entrerait": [
        "entrer"
    ],
    "entreras": [
        "entrer"
    ],
    "entreregarderent": [
        "entreregarder"
    ],
    "entrerez": [
        "entrer"
    ],
    "entrerions": [
        "entrer"
    ],
    "entrerons": [
        "entrer"
    ],
    "entreront": [
        "entrer"
    ],
    "entres": [
        "entrer"
    ],
    "entresol": [
        "entresol"
    ],
    "entresols": [
        "entresol"
    ],
    "entretenaient": [
        "entretenir"
    ],
    "entretenais": [
        "entretenir"
    ],
    "entretenait": [
        "entretenir"
    ],
    "entretenant": [
        "entretenir"
    ],
    "entreteneur": [
        "entreteneur"
    ],
    "entreteneuse": [
        "entreteneur"
    ],
    "entretenez": [
        "entretenir"
    ],
    "entreteniez": [
        "entretenir"
    ],
    "entretenions": [
        "entretenir"
    ],
    "entretenir": [
        "entretenir"
    ],
    "entretenons": [
        "entretenir"
    ],
    "entretenu": [
        "entretenir",
        "entretenu"
    ],
    "entretenue": [
        "entretenir",
        "entretenu"
    ],
    "entretenues": [
        "entretenir",
        "entretenu"
    ],
    "entretenus": [
        "entretenir",
        "entretenu"
    ],
    "entretien": [
        "entretien"
    ],
    "entretiendra": [
        "entretenir"
    ],
    "entretiendrai": [
        "entretenir"
    ],
    "entretiendraient": [
        "entretenir"
    ],
    "entretiendrait": [
        "entretenir"
    ],
    "entretiendras": [
        "entretenir"
    ],
    "entretiendrez": [
        "entretenir"
    ],
    "entretiendrons": [
        "entretenir"
    ],
    "entretienne": [
        "entretenir"
    ],
    "entretiennent": [
        "entretenir"
    ],
    "entretiennes": [
        "entretenir"
    ],
    "entretiens": [
        "entretenir",
        "entretien"
    ],
    "entretient": [
        "entretenir"
    ],
    "entretinrent": [
        "entretenir"
    ],
    "entretins": [
        "entretenir"
    ],
    "entretint": [
        "entretenir"
    ],
    "entretissait": [
        "entretisser"
    ],
    "entretisse": [
        "entretisser"
    ],
    "entretissees": [
        "entretisser"
    ],
    "entretoisaient": [
        "entretoiser"
    ],
    "entretoise": [
        "entretoise"
    ],
    "entretoisement": [
        "entretoisement"
    ],
    "entretuaient": [
        "entretuer"
    ],
    "entretuant": [
        "entretuer"
    ],
    "entretue": [
        "entretuer"
    ],
    "entretuent": [
        "entretuer"
    ],
    "entretuer": [
        "entretuer"
    ],
    "entretueraient": [
        "entretuer"
    ],
    "entretuerait": [
        "entretuer"
    ],
    "entretueront": [
        "entretuer"
    ],
    "entretuez": [
        "entretuer"
    ],
    "entretuees": [
        "entretuer"
    ],
    "entretues": [
        "entretuer"
    ],
    "entretinmes": [
        "entretenir"
    ],
    "entreverrai": [
        "entrevoir"
    ],
    "entrevirent": [
        "entrevoir"
    ],
    "entrevis": [
        "entrevoir"
    ],
    "entrevit": [
        "entrevoir"
    ],
    "entrevoie": [
        "entrevoir"
    ],
    "entrevoient": [
        "entrevoir"
    ],
    "entrevoir": [
        "entrevoir"
    ],
    "entrevois": [
        "entrevoir"
    ],
    "entrevoit": [
        "entrevoir"
    ],
    "entrevous": [
        "entrevous"
    ],
    "entrevoyaient": [
        "entrevoir"
    ],
    "entrevoyais": [
        "entrevoir"
    ],
    "entrevoyait": [
        "entrevoir"
    ],
    "entrevoyant": [
        "entrevoir"
    ],
    "entrevoyons": [
        "entrevoir"
    ],
    "entrevu": [
        "entrevoir"
    ],
    "entrevue": [
        "entrevoir",
        "entrevue"
    ],
    "entrevues": [
        "entrevoir",
        "entrevue"
    ],
    "entrevus": [
        "entrevoir"
    ],
    "entrez": [
        "entrer"
    ],
    "entriez": [
        "entrer"
    ],
    "entrions": [
        "entrer"
    ],
    "entrisme": [
        "entrisme"
    ],
    "entrons": [
        "entrer"
    ],
    "entropie": [
        "entropie"
    ],
    "entropique": [
        "entropique"
    ],
    "entropiques": [
        "entropique"
    ],
    "entrouvert": [
        "entrouvrir",
        "entrouvert"
    ],
    "entrouverte": [
        "entrouvrir",
        "entrouvert"
    ],
    "entrouvertes": [
        "entrouvrir",
        "entrouvert"
    ],
    "entrouverts": [
        "entrouvrir",
        "entrouvert"
    ],
    "entrouverture": [
        "entrouverture"
    ],
    "entrouvraient": [
        "entrouvrir"
    ],
    "entrouvrait": [
        "entrouvrir"
    ],
    "entrouvrant": [
        "entrouvrir"
    ],
    "entrouvre": [
        "entrouvrir"
    ],
    "entrouvrent": [
        "entrouvrir"
    ],
    "entrouvrir": [
        "entrouvrir"
    ],
    "entrouvrirait": [
        "entrouvrir"
    ],
    "entrouvrirent": [
        "entrouvrir"
    ],
    "entrouvris": [
        "entrouvrir"
    ],
    "entrouvrit": [
        "entrouvrir"
    ],
    "entrames": [
        "entrer"
    ],
    "entrat": [
        "entrer"
    ],
    "entrerent": [
        "entrer"
    ],
    "entree": [
        "entree",
        "entrer"
    ],
    "entrees": [
        "entree",
        "entrer"
    ],
    "entubait": [
        "entuber"
    ],
    "entube": [
        "entuber"
    ],
    "entubent": [
        "entuber"
    ],
    "entuber": [
        "entuber"
    ],
    "entuberais": [
        "entuber"
    ],
    "entubes": [
        "entuber"
    ],
    "entubez": [
        "entuber"
    ],
    "entubee": [
        "entuber"
    ],
    "enturbanner": [
        "enturbanner"
    ],
    "enturbanne": [
        "enturbanner",
        "enturbanne"
    ],
    "enturbannee": [
        "enturbanner",
        "enturbanne"
    ],
    "enturbannees": [
        "enturbanne"
    ],
    "enturbannes": [
        "enturbanner",
        "enturbanne"
    ],
    "enture": [
        "enture"
    ],
    "entelechies": [
        "entelechie"
    ],
    "entenebre": [
        "entenebrer"
    ],
    "entenebrent": [
        "entenebrer"
    ],
    "entenebra": [
        "entenebrer"
    ],
    "entenebrait": [
        "entenebrer"
    ],
    "entenebrant": [
        "entenebrer"
    ],
    "entenebrer": [
        "entenebrer"
    ],
    "entenebree": [
        "entenebrer"
    ],
    "entenebrees": [
        "entenebrer"
    ],
    "entenebres": [
        "entenebrer"
    ],
    "enterinais": [
        "enteriner"
    ],
    "enterinait": [
        "enteriner"
    ],
    "enterinant": [
        "enteriner"
    ],
    "enterine": [
        "enteriner"
    ],
    "enterinement": [
        "enterinement"
    ],
    "enteriner": [
        "enteriner"
    ],
    "enterinee": [
        "enteriner"
    ],
    "enterinees": [
        "enteriner"
    ],
    "enterique": [
        "enterique"
    ],
    "enterite": [
        "enterite"
    ],
    "enterocolite": [
        "enterocolite"
    ],
    "enterovirus": [
        "enterovirus"
    ],
    "enteta": [
        "enteter"
    ],
    "entetai": [
        "enteter"
    ],
    "entetaient": [
        "enteter"
    ],
    "entetais": [
        "enteter"
    ],
    "entetait": [
        "enteter"
    ],
    "entetant": [
        "entetant",
        "enteter"
    ],
    "entetante": [
        "entetant"
    ],
    "entetantes": [
        "entetant"
    ],
    "entetants": [
        "entetant"
    ],
    "entete": [
        "enteter",
        "entete"
    ],
    "entetement": [
        "entetement"
    ],
    "entetements": [
        "entetement"
    ],
    "entetent": [
        "enteter"
    ],
    "enteter": [
        "enteter"
    ],
    "enteteraient": [
        "enteter"
    ],
    "enteterais": [
        "enteter"
    ],
    "entetes": [
        "enteter",
        "entete"
    ],
    "entetez": [
        "enteter"
    ],
    "entetiez": [
        "enteter"
    ],
    "entetons": [
        "enteter"
    ],
    "entetat": [
        "enteter"
    ],
    "entetee": [
        "enteter",
        "entete"
    ],
    "entetees": [
        "entete"
    ],
    "entolage": [
        "entolage"
    ],
    "entoler": [
        "entoler"
    ],
    "entoleur": [
        "entoleur"
    ],
    "entole": [
        "entoler"
    ],
    "entolee": [
        "entoler"
    ],
    "envahi": [
        "envahir",
        "envahi"
    ],
    "envahie": [
        "envahir",
        "envahi"
    ],
    "envahies": [
        "envahir",
        "envahi"
    ],
    "envahir": [
        "envahir"
    ],
    "envahira": [
        "envahir"
    ],
    "envahirai": [
        "envahir"
    ],
    "envahiraient": [
        "envahir"
    ],
    "envahirait": [
        "envahir"
    ],
    "envahirent": [
        "envahir"
    ],
    "envahirez": [
        "envahir"
    ],
    "envahirons": [
        "envahir"
    ],
    "envahiront": [
        "envahir"
    ],
    "envahis": [
        "envahir",
        "envahi"
    ],
    "envahissaient": [
        "envahir"
    ],
    "envahissait": [
        "envahir"
    ],
    "envahissant": [
        "envahir",
        "envahissant"
    ],
    "envahissante": [
        "envahissant"
    ],
    "envahissantes": [
        "envahissant"
    ],
    "envahissants": [
        "envahissant"
    ],
    "envahisse": [
        "envahir"
    ],
    "envahissement": [
        "envahissement"
    ],
    "envahissements": [
        "envahissement"
    ],
    "envahissent": [
        "envahir"
    ],
    "envahisseur": [
        "envahisseur"
    ],
    "envahisseurs": [
        "envahisseur"
    ],
    "envahissez": [
        "envahir"
    ],
    "envahissiez": [
        "envahir"
    ],
    "envahit": [
        "envahir"
    ],
    "envasait": [
        "envaser"
    ],
    "envasement": [
        "envasement"
    ],
    "envaser": [
        "envaser"
    ],
    "envase": [
        "envaser"
    ],
    "envasee": [
        "envaser"
    ],
    "envasees": [
        "envaser"
    ],
    "enveloppa": [
        "envelopper"
    ],
    "enveloppai": [
        "envelopper"
    ],
    "enveloppaient": [
        "envelopper"
    ],
    "enveloppais": [
        "envelopper"
    ],
    "enveloppait": [
        "envelopper"
    ],
    "enveloppant": [
        "envelopper",
        "enveloppant"
    ],
    "enveloppante": [
        "enveloppant"
    ],
    "enveloppantes": [
        "enveloppant"
    ],
    "enveloppants": [
        "enveloppant"
    ],
    "enveloppe": [
        "envelopper",
        "enveloppe"
    ],
    "enveloppement": [
        "enveloppement"
    ],
    "enveloppements": [
        "enveloppement"
    ],
    "enveloppent": [
        "envelopper"
    ],
    "envelopper": [
        "envelopper"
    ],
    "enveloppera": [
        "envelopper"
    ],
    "envelopperaient": [
        "envelopper"
    ],
    "envelopperait": [
        "envelopper"
    ],
    "envelopperez": [
        "envelopper"
    ],
    "enveloppes": [
        "envelopper",
        "enveloppe"
    ],
    "enveloppeur": [
        "enveloppeur"
    ],
    "enveloppez": [
        "envelopper"
    ],
    "enveloppons": [
        "envelopper"
    ],
    "enveloppat": [
        "envelopper"
    ],
    "envelopperent": [
        "envelopper"
    ],
    "enveloppee": [
        "envelopper",
        "enveloppe"
    ],
    "enveloppees": [
        "envelopper",
        "enveloppe"
    ],
    "envenima": [
        "envenimer"
    ],
    "envenimait": [
        "envenimer"
    ],
    "envenimant": [
        "envenimer"
    ],
    "envenime": [
        "envenime",
        "envenimer"
    ],
    "enveniment": [
        "envenimer"
    ],
    "envenimer": [
        "envenimer"
    ],
    "envenimons": [
        "envenimer"
    ],
    "envenimerent": [
        "envenimer"
    ],
    "envenimee": [
        "envenime",
        "envenimer"
    ],
    "envenimees": [
        "envenimer"
    ],
    "envenimes": [
        "envenimer"
    ],
    "envergure": [
        "envergure"
    ],
    "enverguee": [
        "enverguer"
    ],
    "enverra": [
        "envoyer"
    ],
    "enverrai": [
        "envoyer"
    ],
    "enverraient": [
        "envoyer"
    ],
    "enverrais": [
        "envoyer"
    ],
    "enverrait": [
        "envoyer"
    ],
    "enverras": [
        "envoyer"
    ],
    "enverrez": [
        "envoyer"
    ],
    "enverriez": [
        "envoyer"
    ],
    "enverrions": [
        "envoyer"
    ],
    "enverrons": [
        "envoyer"
    ],
    "enverront": [
        "envoyer"
    ],
    "envers": [
        "envers"
    ],
    "envia": [
        "envier"
    ],
    "enviable": [
        "enviable"
    ],
    "enviables": [
        "enviable"
    ],
    "enviai": [
        "envier"
    ],
    "enviaient": [
        "envier"
    ],
    "enviais": [
        "envier"
    ],
    "enviait": [
        "envier"
    ],
    "enviandait": [
        "enviander"
    ],
    "enviande": [
        "enviande"
    ],
    "enviandes": [
        "enviande"
    ],
    "enviant": [
        "envier"
    ],
    "envie": [
        "envier",
        "envie"
    ],
    "envient": [
        "envier"
    ],
    "envier": [
        "envier"
    ],
    "enviera": [
        "envier"
    ],
    "envieraient": [
        "envier"
    ],
    "envierais": [
        "envier"
    ],
    "envierait": [
        "envier"
    ],
    "envieront": [
        "envier"
    ],
    "envies": [
        "envier",
        "envy",
        "envie"
    ],
    "envieuse": [
        "envieux"
    ],
    "envieuses": [
        "envieux"
    ],
    "envieux": [
        "envieux"
    ],
    "enviez": [
        "envier"
    ],
    "enviions": [
        "envier"
    ],
    "envions": [
        "envier"
    ],
    "environ": [
        "environ"
    ],
    "environnaient": [
        "environner"
    ],
    "environnait": [
        "environner"
    ],
    "environnant": [
        "environner",
        "environnant"
    ],
    "environnante": [
        "environnant"
    ],
    "environnantes": [
        "environnant"
    ],
    "environnants": [
        "environnant"
    ],
    "environne": [
        "environner"
    ],
    "environnement": [
        "environnement"
    ],
    "environnemental": [
        "environnemental"
    ],
    "environnementale": [
        "environnemental"
    ],
    "environnementaux": [
        "environnemental"
    ],
    "environnements": [
        "environnement"
    ],
    "environnent": [
        "environner"
    ],
    "environner": [
        "environner"
    ],
    "environnee": [
        "environner"
    ],
    "environnees": [
        "environner"
    ],
    "environnes": [
        "environner"
    ],
    "environs": [
        "environ"
    ],
    "envisage": [
        "envisager",
        "envisage"
    ],
    "envisagea": [
        "envisager"
    ],
    "envisageable": [
        "envisageable"
    ],
    "envisageables": [
        "envisageable"
    ],
    "envisageai": [
        "envisager"
    ],
    "envisageaient": [
        "envisager"
    ],
    "envisageais": [
        "envisager"
    ],
    "envisageait": [
        "envisager"
    ],
    "envisageant": [
        "envisager"
    ],
    "envisagent": [
        "envisager"
    ],
    "envisageons": [
        "envisager"
    ],
    "envisager": [
        "envisager"
    ],
    "envisagera": [
        "envisager"
    ],
    "envisagerai": [
        "envisager"
    ],
    "envisagerais": [
        "envisager"
    ],
    "envisagerait": [
        "envisager"
    ],
    "envisageras": [
        "envisager"
    ],
    "envisagerez": [
        "envisager"
    ],
    "envisageriez": [
        "envisager"
    ],
    "envisagerions": [
        "envisager"
    ],
    "envisages": [
        "envisager",
        "envisage"
    ],
    "envisagez": [
        "envisager"
    ],
    "envisageat": [
        "envisager"
    ],
    "envisagiez": [
        "envisager"
    ],
    "envisagions": [
        "envisager"
    ],
    "envisagerent": [
        "envisager"
    ],
    "envisagee": [
        "envisager",
        "envisage"
    ],
    "envisagees": [
        "envisager",
        "envisage"
    ],
    "enviat": [
        "envier"
    ],
    "enviee": [
        "envier"
    ],
    "enviees": [
        "envier"
    ],
    "envoi": [
        "envoi"
    ],
    "envoie": [
        "envoyer"
    ],
    "envoient": [
        "envoyer"
    ],
    "envoies": [
        "envoyer"
    ],
    "envois": [
        "envoi"
    ],
    "envol": [
        "envol"
    ],
    "envola": [
        "envoler"
    ],
    "envolai": [
        "envoler"
    ],
    "envolaient": [
        "envoler"
    ],
    "envolais": [
        "envoler"
    ],
    "envolait": [
        "envoler"
    ],
    "envolant": [
        "envoler"
    ],
    "envole": [
        "envoler"
    ],
    "envolent": [
        "envoler"
    ],
    "envoler": [
        "envoler"
    ],
    "envolera": [
        "envoler"
    ],
    "envolerai": [
        "envoler"
    ],
    "envoleraient": [
        "envoler"
    ],
    "envolerais": [
        "envoler"
    ],
    "envolerait": [
        "envoler"
    ],
    "envolerez": [
        "envoler"
    ],
    "envolerions": [
        "envoler"
    ],
    "envolerons": [
        "envoler"
    ],
    "envoleront": [
        "envoler"
    ],
    "envoles": [
        "envoler"
    ],
    "envolez": [
        "envoler"
    ],
    "envolons": [
        "envoler"
    ],
    "envols": [
        "envol"
    ],
    "envolames": [
        "envoler"
    ],
    "envolat": [
        "envoler"
    ],
    "envolerent": [
        "envoler"
    ],
    "envolee": [
        "envoler",
        "envolee"
    ],
    "envolees": [
        "envoler",
        "envolee"
    ],
    "envoya": [
        "envoyer"
    ],
    "envoyai": [
        "envoyer"
    ],
    "envoyaient": [
        "envoyer"
    ],
    "envoyais": [
        "envoyer"
    ],
    "envoyait": [
        "envoyer"
    ],
    "envoyant": [
        "envoyer"
    ],
    "envoyer": [
        "envoyer"
    ],
    "envoyeur": [
        "envoyeur"
    ],
    "envoyeurs": [
        "envoyeur"
    ],
    "envoyez": [
        "envoyer"
    ],
    "envoyiez": [
        "envoyer"
    ],
    "envoyions": [
        "envoyer"
    ],
    "envoyons": [
        "envoyer"
    ],
    "envoyames": [
        "envoyer"
    ],
    "envoyat": [
        "envoyer"
    ],
    "envoyerent": [
        "envoyer"
    ],
    "envoye": [
        "envoye",
        "envoyer"
    ],
    "envoyee": [
        "envoye",
        "envoyer"
    ],
    "envoyees": [
        "envoye",
        "envoyer"
    ],
    "envoyes": [
        "envoye",
        "envoyer"
    ],
    "envoutaient": [
        "envouter"
    ],
    "envoutait": [
        "envouter"
    ],
    "envoutant": [
        "envouter",
        "envoutant"
    ],
    "envoutante": [
        "envoutant"
    ],
    "envoutantes": [
        "envoutant"
    ],
    "envoutants": [
        "envoutant"
    ],
    "envoute": [
        "envouter",
        "envoute"
    ],
    "envoutement": [
        "envoutement"
    ],
    "envoutements": [
        "envoutement"
    ],
    "envouter": [
        "envouter"
    ],
    "envouteras": [
        "envouter"
    ],
    "envouteur": [
        "envouteur"
    ],
    "envouteurs": [
        "envouteur"
    ],
    "envoutee": [
        "envouter",
        "envoute"
    ],
    "envoutees": [
        "envouter"
    ],
    "envoutes": [
        "envouter",
        "envoute"
    ],
    "enzymatique": [
        "enzymatique"
    ],
    "enzyme": [
        "enzyme"
    ],
    "enzymes": [
        "enzyme"
    ],
    "epsilon": [
        "epsilon"
    ],
    "erg": [
        "erg"
    ],
    "ergastule": [
        "ergastule"
    ],
    "ergastules": [
        "ergastule"
    ],
    "ergo": [
        "ergo"
    ],
    "ergol": [
        "ergol"
    ],
    "ergonomie": [
        "ergonomie"
    ],
    "ergonomique": [
        "ergonomique"
    ],
    "ergot": [
        "ergot"
    ],
    "ergotage": [
        "ergotage"
    ],
    "ergotait": [
        "ergoter"
    ],
    "ergotamine": [
        "ergotamine"
    ],
    "ergote": [
        "ergote",
        "ergoter"
    ],
    "ergotent": [
        "ergoter"
    ],
    "ergoter": [
        "ergoter"
    ],
    "ergoteur": [
        "ergoteur"
    ],
    "ergoteurs": [
        "ergoteur"
    ],
    "ergoteuse": [
        "ergoteur"
    ],
    "ergotherapeute": [
        "ergotherapeute"
    ],
    "ergotherapie": [
        "ergotherapie"
    ],
    "ergotons": [
        "ergoter"
    ],
    "ergots": [
        "ergot"
    ],
    "ergs": [
        "erg"
    ],
    "ermitage": [
        "ermitage"
    ],
    "ermitages": [
        "ermitage"
    ],
    "ermite": [
        "ermite"
    ],
    "ermites": [
        "ermite"
    ],
    "erpetologiste": [
        "erpetologiste"
    ],
    "erra": [
        "errer"
    ],
    "errai": [
        "errer"
    ],
    "erraient": [
        "errer"
    ],
    "errais": [
        "errer"
    ],
    "errait": [
        "errer"
    ],
    "errance": [
        "errance"
    ],
    "errances": [
        "errance"
    ],
    "errant": [
        "errant",
        "errer"
    ],
    "errante": [
        "errant"
    ],
    "errantes": [
        "errant"
    ],
    "errants": [
        "errant"
    ],
    "errata": [
        "erratum"
    ],
    "erratique": [
        "erratique"
    ],
    "erratiques": [
        "erratique"
    ],
    "erratum": [
        "erratum"
    ],
    "erre": [
        "errer",
        "erre"
    ],
    "errements": [
        "errements"
    ],
    "errent": [
        "errer"
    ],
    "errer": [
        "errer"
    ],
    "errera": [
        "errer"
    ],
    "errerai": [
        "errer"
    ],
    "erreraient": [
        "errer"
    ],
    "errerait": [
        "errer"
    ],
    "erreras": [
        "errer"
    ],
    "errerons": [
        "errer"
    ],
    "erreront": [
        "errer"
    ],
    "erres": [
        "errer"
    ],
    "erreur": [
        "erreur"
    ],
    "erreurs": [
        "erreur"
    ],
    "errez": [
        "errer"
    ],
    "erriez": [
        "errer"
    ],
    "errions": [
        "errer"
    ],
    "errons": [
        "errer"
    ],
    "errone": [
        "errone"
    ],
    "erronee": [
        "errone"
    ],
    "erronees": [
        "errone"
    ],
    "errones": [
        "errone"
    ],
    "errames": [
        "errer"
    ],
    "errerent": [
        "errer"
    ],
    "ers": [
        "ers"
    ],
    "ersatz": [
        "ersatz"
    ],
    "es": [
        "es",
        "etre"
    ],
    "esbaudir": [
        "esbaudir"
    ],
    "esbignais": [
        "esbigner"
    ],
    "esbignait": [
        "esbigner"
    ],
    "esbigne": [
        "esbigner"
    ],
    "esbignent": [
        "esbigner"
    ],
    "esbigner": [
        "esbigner"
    ],
    "esbroufe": [
        "esbroufe",
        "esbroufer"
    ],
    "esbroufer": [
        "esbroufer"
    ],
    "esbroufeur": [
        "esbroufeur"
    ],
    "esbroufeurs": [
        "esbroufeur"
    ],
    "esbroufee": [
        "esbroufer"
    ],
    "escabeau": [
        "escabeau"
    ],
    "escabeaux": [
        "escabeau"
    ],
    "escabeches": [
        "escabeche"
    ],
    "escadre": [
        "escadre"
    ],
    "escadres": [
        "escadre"
    ],
    "escadrille": [
        "escadrille"
    ],
    "escadrilles": [
        "escadrille"
    ],
    "escadrin": [
        "escadrin"
    ],
    "escadron": [
        "escadron"
    ],
    "escadrons": [
        "escadron"
    ],
    "escagasse": [
        "escagasser"
    ],
    "escagasser": [
        "escagasser"
    ],
    "escalada": [
        "escalader"
    ],
    "escaladaient": [
        "escalader"
    ],
    "escaladais": [
        "escalader"
    ],
    "escaladait": [
        "escalader"
    ],
    "escaladant": [
        "escalader"
    ],
    "escalade": [
        "escalader",
        "escalade"
    ],
    "escaladent": [
        "escalader"
    ],
    "escalader": [
        "escalader"
    ],
    "escaladera": [
        "escalader"
    ],
    "escaladerais": [
        "escalader"
    ],
    "escaladerait": [
        "escalader"
    ],
    "escalades": [
        "escalader",
        "escalade"
    ],
    "escaladeur": [
        "escaladeur"
    ],
    "escaladeuse": [
        "escaladeur"
    ],
    "escaladeuses": [
        "escaladeur"
    ],
    "escaladez": [
        "escalader"
    ],
    "escaladions": [
        "escalader"
    ],
    "escaladons": [
        "escalader"
    ],
    "escaladames": [
        "escalader"
    ],
    "escaladerent": [
        "escalader"
    ],
    "escaladee": [
        "escalader"
    ],
    "escaladees": [
        "escalader"
    ],
    "escalais": [
        "escaler"
    ],
    "escalator": [
        "escalator"
    ],
    "escalators": [
        "escalator"
    ],
    "escale": [
        "escale"
    ],
    "escalera": [
        "escaler"
    ],
    "escales": [
        "escale"
    ],
    "escalier": [
        "escalier"
    ],
    "escaliers": [
        "escalier"
    ],
    "escalope": [
        "escalope"
    ],
    "escalopes": [
        "escalope"
    ],
    "escamota": [
        "escamoter"
    ],
    "escamotable": [
        "escamotable"
    ],
    "escamotables": [
        "escamotable"
    ],
    "escamotage": [
        "escamotage"
    ],
    "escamotages": [
        "escamotage"
    ],
    "escamotaient": [
        "escamoter"
    ],
    "escamotait": [
        "escamoter"
    ],
    "escamotant": [
        "escamoter"
    ],
    "escamote": [
        "escamoter"
    ],
    "escamoter": [
        "escamoter"
    ],
    "escamoterai": [
        "escamoter"
    ],
    "escamoteur": [
        "escamoteur"
    ],
    "escamotee": [
        "escamoter"
    ],
    "escamotees": [
        "escamoter"
    ],
    "escamotes": [
        "escamoter"
    ],
    "escampette": [
        "escampette"
    ],
    "escapade": [
        "escapade"
    ],
    "escapades": [
        "escapade"
    ],
    "escape": [
        "escape"
    ],
    "escarbille": [
        "escarbille"
    ],
    "escarbilles": [
        "escarbille"
    ],
    "escarboucle": [
        "escarboucle"
    ],
    "escarboucles": [
        "escarboucle"
    ],
    "escarcelle": [
        "escarcelle"
    ],
    "escargot": [
        "escargot"
    ],
    "escargots": [
        "escargot"
    ],
    "escarmouchaient": [
        "escarmoucher"
    ],
    "escarmouche": [
        "escarmouche"
    ],
    "escarmouchent": [
        "escarmoucher"
    ],
    "escarmouches": [
        "escarmouche"
    ],
    "escarpement": [
        "escarpement"
    ],
    "escarpements": [
        "escarpement"
    ],
    "escarpes": [
        "escarpe"
    ],
    "escarpin": [
        "escarpin"
    ],
    "escarpins": [
        "escarpin"
    ],
    "escarpolette": [
        "escarpolette"
    ],
    "escarpolettes": [
        "escarpolette"
    ],
    "escarpe": [
        "escarper",
        "escarpe"
    ],
    "escarpee": [
        "escarper",
        "escarpe"
    ],
    "escarpees": [
        "escarper",
        "escarpe"
    ],
    "escarre": [
        "escarre"
    ],
    "escarres": [
        "escarre"
    ],
    "eschatologie": [
        "eschatologie"
    ],
    "esche": [
        "esche"
    ],
    "escher": [
        "escher"
    ],
    "escient": [
        "escient"
    ],
    "esclaffa": [
        "esclaffer"
    ],
    "esclaffai": [
        "esclaffer"
    ],
    "esclaffaient": [
        "esclaffer"
    ],
    "esclaffait": [
        "esclaffer"
    ],
    "esclaffant": [
        "esclaffer"
    ],
    "esclaffe": [
        "esclaffer"
    ],
    "esclaffement": [
        "esclaffement"
    ],
    "esclaffements": [
        "esclaffement"
    ],
    "esclaffent": [
        "esclaffer"
    ],
    "esclaffer": [
        "esclaffer"
    ],
    "esclafferaient": [
        "esclaffer"
    ],
    "esclafferent": [
        "esclaffer"
    ],
    "esclaffee": [
        "esclaffer"
    ],
    "esclaffes": [
        "esclaffer"
    ],
    "esclandre": [
        "esclandre"
    ],
    "esclandres": [
        "esclandre"
    ],
    "esclavage": [
        "esclavage",
        "esclavager"
    ],
    "esclavagea": [
        "esclavager"
    ],
    "esclavager": [
        "esclavager"
    ],
    "esclavagisme": [
        "esclavagisme"
    ],
    "esclavagiste": [
        "esclavagiste"
    ],
    "esclavagistes": [
        "esclavagiste"
    ],
    "esclave": [
        "esclave"
    ],
    "esclaves": [
        "esclave"
    ],
    "esclavons": [
        "esclavon"
    ],
    "escogriffe": [
        "escogriffe"
    ],
    "escogriffes": [
        "escogriffe"
    ],
    "escomptai": [
        "escompter"
    ],
    "escomptaient": [
        "escompter"
    ],
    "escomptais": [
        "escompter"
    ],
    "escomptait": [
        "escompter"
    ],
    "escomptant": [
        "escompter"
    ],
    "escompte": [
        "escompte",
        "escompter"
    ],
    "escomptent": [
        "escompter"
    ],
    "escompter": [
        "escompter"
    ],
    "escomptes": [
        "escompter"
    ],
    "escomptez": [
        "escompter"
    ],
    "escomptions": [
        "escompter"
    ],
    "escomptee": [
        "escompter"
    ],
    "escomptees": [
        "escompter"
    ],
    "escopette": [
        "escopette"
    ],
    "escorta": [
        "escorter"
    ],
    "escortaient": [
        "escorter"
    ],
    "escortais": [
        "escorter"
    ],
    "escortait": [
        "escorter"
    ],
    "escortant": [
        "escorter"
    ],
    "escorte": [
        "escorter",
        "escorte"
    ],
    "escortent": [
        "escorter"
    ],
    "escorter": [
        "escorter"
    ],
    "escortera": [
        "escorter"
    ],
    "escorterai": [
        "escorter"
    ],
    "escorteraient": [
        "escorter"
    ],
    "escorterez": [
        "escorter"
    ],
    "escorteriez": [
        "escorter"
    ],
    "escorterons": [
        "escorter"
    ],
    "escorteront": [
        "escorter"
    ],
    "escortes": [
        "escorter",
        "escorte"
    ],
    "escorteur": [
        "escorteur"
    ],
    "escorteurs": [
        "escorteur"
    ],
    "escortez": [
        "escorter"
    ],
    "escortiez": [
        "escorter"
    ],
    "escortons": [
        "escorter"
    ],
    "escorterent": [
        "escorter"
    ],
    "escortee": [
        "escorter"
    ],
    "escortees": [
        "escorter"
    ],
    "escot": [
        "escot"
    ],
    "escouade": [
        "escouade"
    ],
    "escouades": [
        "escouade"
    ],
    "escrimai": [
        "escrimer"
    ],
    "escrimaient": [
        "escrimer"
    ],
    "escrimais": [
        "escrimer"
    ],
    "escrimait": [
        "escrimer"
    ],
    "escrimant": [
        "escrimer"
    ],
    "escrime": [
        "escrime",
        "escrimer"
    ],
    "escriment": [
        "escrimer"
    ],
    "escrimer": [
        "escrimer"
    ],
    "escrimera": [
        "escrimer"
    ],
    "escrimeraient": [
        "escrimer"
    ],
    "escrimes": [
        "escrimer"
    ],
    "escrimeur": [
        "escrimeur"
    ],
    "escrimeurs": [
        "escrimeur"
    ],
    "escrimeuses": [
        "escrimeur"
    ],
    "escroc": [
        "escroc"
    ],
    "escrocs": [
        "escroc"
    ],
    "escroquant": [
        "escroquer"
    ],
    "escroque": [
        "escroquer"
    ],
    "escroquent": [
        "escroquer"
    ],
    "escroquer": [
        "escroquer"
    ],
    "escroquera": [
        "escroquer"
    ],
    "escroquerie": [
        "escroquerie"
    ],
    "escroqueries": [
        "escroquerie"
    ],
    "escroques": [
        "escroquer"
    ],
    "escroqueuse": [
        "escroqueur"
    ],
    "escroquez": [
        "escroquer"
    ],
    "escroquees": [
        "escroquer"
    ],
    "escudo": [
        "escudo"
    ],
    "escudos": [
        "escudo"
    ],
    "esgourdai": [
        "esgourder"
    ],
    "esgourdant": [
        "esgourder"
    ],
    "esgourde": [
        "esgourde",
        "esgourder"
    ],
    "esgourder": [
        "esgourder"
    ],
    "esgourdes": [
        "esgourde"
    ],
    "esgourdee": [
        "esgourder"
    ],
    "eskimo": [
        "eskimo"
    ],
    "eskimos": [
        "eskimo"
    ],
    "espace": [
        "espacer",
        "espace"
    ],
    "espacement": [
        "espacement"
    ],
    "espacements": [
        "espacement"
    ],
    "espacent": [
        "espacer"
    ],
    "espacer": [
        "espacer"
    ],
    "espacerait": [
        "espacer"
    ],
    "espaceront": [
        "espacer"
    ],
    "espaces": [
        "espacer",
        "espace"
    ],
    "espacez": [
        "espacer"
    ],
    "espacions": [
        "espacer"
    ],
    "espacerent": [
        "espacer"
    ],
    "espacee": [
        "espacer",
        "espace"
    ],
    "espacees": [
        "espacer",
        "espace"
    ],
    "espada": [
        "espada"
    ],
    "espadas": [
        "espada"
    ],
    "espadon": [
        "espadon"
    ],
    "espadons": [
        "espadon"
    ],
    "espadrille": [
        "espadrille"
    ],
    "espadrilles": [
        "espadrille"
    ],
    "espagnol": [
        "espagnol"
    ],
    "espagnole": [
        "espagnol"
    ],
    "espagnoles": [
        "espagnol"
    ],
    "espagnolette": [
        "espagnolette"
    ],
    "espagnols": [
        "espagnol"
    ],
    "espalier": [
        "espalier"
    ],
    "espaliers": [
        "espalier"
    ],
    "espar": [
        "espar"
    ],
    "espars": [
        "espars"
    ],
    "espaca": [
        "espacer"
    ],
    "espacaient": [
        "espacer"
    ],
    "espacait": [
        "espacer"
    ],
    "espacant": [
        "espacer"
    ],
    "esperanto": [
        "esperanto"
    ],
    "espingo": [
        "espingo"
    ],
    "espingole": [
        "espingole"
    ],
    "espingoles": [
        "espingole"
    ],
    "espingos": [
        "espingo"
    ],
    "espingouin": [
        "espingouin"
    ],
    "espingouins": [
        "espingouin"
    ],
    "espion": [
        "espion"
    ],
    "espionite": [
        "espionite"
    ],
    "espionnage": [
        "espionnage"
    ],
    "espionnaient": [
        "espionner"
    ],
    "espionnais": [
        "espionner"
    ],
    "espionnait": [
        "espionner"
    ],
    "espionnant": [
        "espionner"
    ],
    "espionne": [
        "espion",
        "espionner"
    ],
    "espionnent": [
        "espionner"
    ],
    "espionner": [
        "espionner"
    ],
    "espionnera": [
        "espionner"
    ],
    "espionnerai": [
        "espionner"
    ],
    "espionnerions": [
        "espionner"
    ],
    "espionnes": [
        "espion",
        "espionner"
    ],
    "espionnez": [
        "espionner"
    ],
    "espionniez": [
        "espionner"
    ],
    "espionnite": [
        "espionnite"
    ],
    "espionnons": [
        "espionner"
    ],
    "espionnat": [
        "espionner"
    ],
    "espionnee": [
        "espionner"
    ],
    "espions": [
        "espion"
    ],
    "espiegle": [
        "espiegle"
    ],
    "espieglement": [
        "espieglement"
    ],
    "espieglerie": [
        "espieglerie"
    ],
    "espiegleries": [
        "espieglerie"
    ],
    "espiegles": [
        "espiegle"
    ],
    "esplanade": [
        "esplanade"
    ],
    "esplanades": [
        "esplanade"
    ],
    "espoir": [
        "espoir"
    ],
    "espoirs": [
        "espoir"
    ],
    "esprit": [
        "esprit"
    ],
    "esprits": [
        "esprit"
    ],
    "espece": [
        "espece"
    ],
    "especes": [
        "espece"
    ],
    "espere": [
        "esperer"
    ],
    "esperent": [
        "esperer"
    ],
    "esperes": [
        "esperer"
    ],
    "espera": [
        "esperer"
    ],
    "esperai": [
        "esperer"
    ],
    "esperaient": [
        "esperer"
    ],
    "esperais": [
        "esperer"
    ],
    "esperait": [
        "esperer"
    ],
    "esperance": [
        "esperance"
    ],
    "esperances": [
        "esperance"
    ],
    "esperant": [
        "esperer"
    ],
    "esperantiste": [
        "esperantiste"
    ],
    "esperer": [
        "esperer"
    ],
    "espererai": [
        "esperer"
    ],
    "espererais": [
        "esperer"
    ],
    "espererait": [
        "esperer"
    ],
    "esperez": [
        "esperer"
    ],
    "esperiez": [
        "esperer"
    ],
    "esperions": [
        "esperer"
    ],
    "esperons": [
        "esperer"
    ],
    "esperames": [
        "esperer"
    ],
    "esperat": [
        "esperer"
    ],
    "espererent": [
        "esperer"
    ],
    "esperee": [
        "esperer"
    ],
    "esperees": [
        "esperer"
    ],
    "esquif": [
        "esquif"
    ],
    "esquifs": [
        "esquif"
    ],
    "esquille": [
        "esquille"
    ],
    "esquilles": [
        "esquille"
    ],
    "esquimau": [
        "esquimau"
    ],
    "esquimaude": [
        "esquimaud"
    ],
    "esquimaudes": [
        "esquimaud"
    ],
    "esquimaux": [
        "esquimau"
    ],
    "esquintait": [
        "esquinter"
    ],
    "esquinte": [
        "esquinter",
        "esquinte"
    ],
    "esquintement": [
        "esquintement"
    ],
    "esquintent": [
        "esquinter"
    ],
    "esquinter": [
        "esquinter"
    ],
    "esquinterais": [
        "esquinter"
    ],
    "esquintes": [
        "esquinter",
        "esquinte"
    ],
    "esquintez": [
        "esquinter"
    ],
    "esquintee": [
        "esquinter",
        "esquinte"
    ],
    "esquintees": [
        "esquinter"
    ],
    "esquire": [
        "esquire"
    ],
    "esquissa": [
        "esquisser"
    ],
    "esquissai": [
        "esquisser"
    ],
    "esquissaient": [
        "esquisser"
    ],
    "esquissais": [
        "esquisser"
    ],
    "esquissait": [
        "esquisser"
    ],
    "esquissant": [
        "esquisser"
    ],
    "esquisse": [
        "esquisser",
        "esquisse"
    ],
    "esquissent": [
        "esquisser"
    ],
    "esquisser": [
        "esquisser"
    ],
    "esquisses": [
        "esquisser",
        "esquisse"
    ],
    "esquisserent": [
        "esquisser"
    ],
    "esquissee": [
        "esquisser"
    ],
    "esquissees": [
        "esquisser"
    ],
    "esquiva": [
        "esquiver"
    ],
    "esquivai": [
        "esquiver"
    ],
    "esquivaient": [
        "esquiver"
    ],
    "esquivait": [
        "esquiver"
    ],
    "esquivant": [
        "esquiver"
    ],
    "esquive": [
        "esquive",
        "esquiver"
    ],
    "esquivent": [
        "esquiver"
    ],
    "esquiver": [
        "esquiver"
    ],
    "esquivera": [
        "esquiver"
    ],
    "esquiveront": [
        "esquiver"
    ],
    "esquives": [
        "esquive",
        "esquiver"
    ],
    "esquiverent": [
        "esquiver"
    ],
    "esquivee": [
        "esquiver"
    ],
    "essai": [
        "essai"
    ],
    "essaie": [
        "essayer"
    ],
    "essaient": [
        "essayer"
    ],
    "essaiera": [
        "essayer"
    ],
    "essaierai": [
        "essayer"
    ],
    "essaieraient": [
        "essayer"
    ],
    "essaierais": [
        "essayer"
    ],
    "essaierait": [
        "essayer"
    ],
    "essaieras": [
        "essayer"
    ],
    "essaierez": [
        "essayer"
    ],
    "essaieriez": [
        "essayer"
    ],
    "essaierions": [
        "essayer"
    ],
    "essaierons": [
        "essayer"
    ],
    "essaieront": [
        "essayer"
    ],
    "essaies": [
        "essayer"
    ],
    "essaim": [
        "essaim"
    ],
    "essaimaient": [
        "essaimer"
    ],
    "essaimait": [
        "essaimer"
    ],
    "essaiment": [
        "essaimer"
    ],
    "essaims": [
        "essaim"
    ],
    "essaime": [
        "essaimer"
    ],
    "essaimees": [
        "essaimer"
    ],
    "essaimes": [
        "essaimer"
    ],
    "essais": [
        "essai"
    ],
    "essangent": [
        "essanger"
    ],
    "essartage": [
        "essartage"
    ],
    "essarte": [
        "essarter"
    ],
    "essarts": [
        "essart"
    ],
    "essartee": [
        "essarter"
    ],
    "essaya": [
        "essayer"
    ],
    "essayage": [
        "essayage"
    ],
    "essayages": [
        "essayage"
    ],
    "essayai": [
        "essayer"
    ],
    "essayaient": [
        "essayer"
    ],
    "essayais": [
        "essayer"
    ],
    "essayait": [
        "essayer"
    ],
    "essayant": [
        "essayer"
    ],
    "essaye": [
        "essayer"
    ],
    "essayent": [
        "essayer"
    ],
    "essayer": [
        "essayer"
    ],
    "essayera": [
        "essayer"
    ],
    "essayerai": [
        "essayer"
    ],
    "essayeraient": [
        "essayer"
    ],
    "essayerais": [
        "essayer"
    ],
    "essayerait": [
        "essayer"
    ],
    "essayeras": [
        "essayer"
    ],
    "essayerez": [
        "essayer"
    ],
    "essayeriez": [
        "essayer"
    ],
    "essayerons": [
        "essayer"
    ],
    "essayeront": [
        "essayer"
    ],
    "essayes": [
        "essayer"
    ],
    "essayeur": [
        "essayeur"
    ],
    "essayeuses": [
        "essayeur"
    ],
    "essayez": [
        "essayer"
    ],
    "essayiez": [
        "essayer"
    ],
    "essayions": [
        "essayer"
    ],
    "essayiste": [
        "essayiste"
    ],
    "essayistes": [
        "essayiste"
    ],
    "essayons": [
        "essayer"
    ],
    "essayames": [
        "essayer"
    ],
    "essayat": [
        "essayer"
    ],
    "essayerent": [
        "essayer"
    ],
    "essayee": [
        "essayer"
    ],
    "essayees": [
        "essayer"
    ],
    "esse": [
        "esse"
    ],
    "essence": [
        "essence"
    ],
    "essences": [
        "essence"
    ],
    "essential": [
        "essential"
    ],
    "essentialisme": [
        "essentialisme"
    ],
    "essentiel": [
        "essentiel"
    ],
    "essentielle": [
        "essentiel"
    ],
    "essentiellement": [
        "essentiellement"
    ],
    "essentielles": [
        "essentiel"
    ],
    "essentiels": [
        "essentiel"
    ],
    "esseulement": [
        "esseulement"
    ],
    "esseule": [
        "esseuler",
        "esseule"
    ],
    "esseulee": [
        "esseuler",
        "esseule"
    ],
    "esseulees": [
        "esseuler",
        "esseule"
    ],
    "esseules": [
        "esseuler",
        "esseule"
    ],
    "essieu": [
        "essieu"
    ],
    "essieux": [
        "essieux"
    ],
    "essor": [
        "essor"
    ],
    "essora": [
        "essorer"
    ],
    "essorage": [
        "essorage"
    ],
    "essoraient": [
        "essorer"
    ],
    "essorait": [
        "essorer"
    ],
    "essorant": [
        "essorer"
    ],
    "essore": [
        "essore",
        "essorer"
    ],
    "essorent": [
        "essorer"
    ],
    "essorer": [
        "essorer"
    ],
    "essorerait": [
        "essorer"
    ],
    "essoreuse": [
        "essoreuse"
    ],
    "essorille": [
        "essoriller"
    ],
    "essoree": [
        "essore",
        "essorer"
    ],
    "essores": [
        "essore",
        "essorer"
    ],
    "essouffla": [
        "essouffler"
    ],
    "essoufflaient": [
        "essouffler"
    ],
    "essoufflais": [
        "essouffler"
    ],
    "essoufflait": [
        "essouffler"
    ],
    "essoufflant": [
        "essouffler"
    ],
    "essouffle": [
        "essouffler",
        "essouffle"
    ],
    "essoufflement": [
        "essoufflement"
    ],
    "essoufflements": [
        "essoufflement"
    ],
    "essoufflent": [
        "essouffler"
    ],
    "essouffler": [
        "essouffler"
    ],
    "essouffleront": [
        "essouffler"
    ],
    "essouffles": [
        "essouffler",
        "essouffle"
    ],
    "essoufflez": [
        "essouffler"
    ],
    "essoufflerent": [
        "essouffler"
    ],
    "essoufflee": [
        "essouffler",
        "essouffle"
    ],
    "essoufflees": [
        "essouffle"
    ],
    "essuie": [
        "essuyer",
        "essuie"
    ],
    "essuient": [
        "essuyer"
    ],
    "essuiera": [
        "essuyer"
    ],
    "essuierais": [
        "essuyer"
    ],
    "essuieras": [
        "essuyer"
    ],
    "essuierez": [
        "essuyer"
    ],
    "essuierions": [
        "essuyer"
    ],
    "essuies": [
        "essuyer",
        "essuie"
    ],
    "essuya": [
        "essuyer"
    ],
    "essuyage": [
        "essuyage"
    ],
    "essuyages": [
        "essuyage"
    ],
    "essuyai": [
        "essuyer"
    ],
    "essuyaient": [
        "essuyer"
    ],
    "essuyais": [
        "essuyer"
    ],
    "essuyait": [
        "essuyer"
    ],
    "essuyant": [
        "essuyer"
    ],
    "essuyer": [
        "essuyer"
    ],
    "essuyeur": [
        "essuyeur"
    ],
    "essuyez": [
        "essuyer"
    ],
    "essuyions": [
        "essuyer"
    ],
    "essuyons": [
        "essuyer"
    ],
    "essuyerent": [
        "essuyer"
    ],
    "essuye": [
        "essuyer"
    ],
    "essuyee": [
        "essuyer"
    ],
    "essuyees": [
        "essuyer"
    ],
    "essuyes": [
        "essuyer"
    ],
    "est": [
        "etre",
        "est"
    ],
    "establishment": [
        "establishment"
    ],
    "estacade": [
        "estacade"
    ],
    "estacades": [
        "estacade"
    ],
    "estafette": [
        "estafette"
    ],
    "estafettes": [
        "estafette"
    ],
    "estafier": [
        "estafier"
    ],
    "estafiers": [
        "estafier"
    ],
    "estafilade": [
        "estafilade"
    ],
    "estafilades": [
        "estafilade"
    ],
    "estagnon": [
        "estagnon"
    ],
    "estaminet": [
        "estaminet"
    ],
    "estaminets": [
        "estaminet"
    ],
    "estampage": [
        "estampage"
    ],
    "estampe": [
        "estamper",
        "estampe"
    ],
    "estamper": [
        "estamper"
    ],
    "estampes": [
        "estampe"
    ],
    "estampilla": [
        "estampiller"
    ],
    "estampillaient": [
        "estampiller"
    ],
    "estampille": [
        "estampiller",
        "estampille"
    ],
    "estampiller": [
        "estampiller"
    ],
    "estampillees": [
        "estampille"
    ],
    "estampilles": [
        "estampiller",
        "estampille"
    ],
    "estampee": [
        "estamper"
    ],
    "estancia": [
        "estancia"
    ],
    "estancias": [
        "estancia"
    ],
    "este": [
        "este"
    ],
    "ester": [
        "ester",
        "est"
    ],
    "estes": [
        "este"
    ],
    "esthete": [
        "esthete"
    ],
    "esthetes": [
        "esthete"
    ],
    "esthesiometre": [
        "esthesiometre"
    ],
    "estheticien": [
        "estheticien"
    ],
    "estheticienne": [
        "estheticien"
    ],
    "estheticiennes": [
        "estheticien"
    ],
    "esthetique": [
        "esthetique"
    ],
    "esthetiquement": [
        "esthetiquement"
    ],
    "esthetiques": [
        "esthetique"
    ],
    "esthetisait": [
        "esthetiser"
    ],
    "esthetisme": [
        "esthetisme"
    ],
    "estima": [
        "estimer"
    ],
    "estimable": [
        "estimable"
    ],
    "estimables": [
        "estimable"
    ],
    "estimai": [
        "estimer"
    ],
    "estimaient": [
        "estimer"
    ],
    "estimais": [
        "estimer"
    ],
    "estimait": [
        "estimer"
    ],
    "estimant": [
        "estimer"
    ],
    "estimation": [
        "estimation"
    ],
    "estimations": [
        "estimation"
    ],
    "estime": [
        "estime",
        "estimer"
    ],
    "estiment": [
        "estimer"
    ],
    "estimer": [
        "estimer"
    ],
    "estimera": [
        "estimer"
    ],
    "estimerai": [
        "estimer"
    ],
    "estimerais": [
        "estimer"
    ],
    "estimerait": [
        "estimer"
    ],
    "estimeras": [
        "estimer"
    ],
    "estimerez": [
        "estimer"
    ],
    "estimes": [
        "estime",
        "estimer"
    ],
    "estimez": [
        "estimer"
    ],
    "estimiez": [
        "estimer"
    ],
    "estimions": [
        "estimer"
    ],
    "estimons": [
        "estimer"
    ],
    "estimat": [
        "estimer"
    ],
    "estimerent": [
        "estimer"
    ],
    "estimee": [
        "estimer"
    ],
    "estimees": [
        "estimer"
    ],
    "estival": [
        "estival"
    ],
    "estivale": [
        "estival"
    ],
    "estivales": [
        "estival"
    ],
    "estivant": [
        "estivant"
    ],
    "estivante": [
        "estivant"
    ],
    "estivantes": [
        "estivant"
    ],
    "estivants": [
        "estivant"
    ],
    "estivaux": [
        "estival"
    ],
    "estoc": [
        "estoc"
    ],
    "estocade": [
        "estocade"
    ],
    "estocades": [
        "estocade"
    ],
    "estocs": [
        "estoc"
    ],
    "estom": [
        "estom"
    ],
    "estomac": [
        "estomac"
    ],
    "estomacs": [
        "estomac"
    ],
    "estomaquait": [
        "estomaquer"
    ],
    "estomaquant": [
        "estomaquer"
    ],
    "estomaque": [
        "estomaquer"
    ],
    "estomaquer": [
        "estomaquer"
    ],
    "estomaquee": [
        "estomaquer"
    ],
    "estomaques": [
        "estomaquer"
    ],
    "estompa": [
        "estomper"
    ],
    "estompaient": [
        "estomper"
    ],
    "estompait": [
        "estomper"
    ],
    "estompant": [
        "estomper"
    ],
    "estompe": [
        "estompe",
        "estomper"
    ],
    "estompent": [
        "estomper"
    ],
    "estomper": [
        "estomper"
    ],
    "estompera": [
        "estomper"
    ],
    "estomperont": [
        "estomper"
    ],
    "estompes": [
        "estompe",
        "estomper"
    ],
    "estompat": [
        "estomper"
    ],
    "estomperent": [
        "estomper"
    ],
    "estompee": [
        "estompe",
        "estomper"
    ],
    "estompees": [
        "estompe",
        "estomper"
    ],
    "estonien": [
        "estonien"
    ],
    "estonienne": [
        "estonienne"
    ],
    "estoniens": [
        "estonien"
    ],
    "estoqua": [
        "estoquer"
    ],
    "estoque": [
        "estoquer"
    ],
    "estoquer": [
        "estoquer"
    ],
    "estouffade": [
        "estouffade"
    ],
    "estourbi": [
        "estourbir"
    ],
    "estourbie": [
        "estourbir"
    ],
    "estourbies": [
        "estourbir"
    ],
    "estourbir": [
        "estourbir"
    ],
    "estourbirait": [
        "estourbir"
    ],
    "estourbis": [
        "estourbir"
    ],
    "estourbissais": [
        "estourbir"
    ],
    "estourbissant": [
        "estourbir"
    ],
    "estourbisse": [
        "estourbir"
    ],
    "estourbit": [
        "estourbir"
    ],
    "estrade": [
        "estrade"
    ],
    "estrades": [
        "estrade"
    ],
    "estragon": [
        "estragon"
    ],
    "estrangers": [
        "estranger"
    ],
    "estrapade": [
        "estrapade"
    ],
    "estrapades": [
        "estrapade"
    ],
    "estrapassee": [
        "estrapasser"
    ],
    "estrogene": [
        "estrogene"
    ],
    "estropiait": [
        "estropier"
    ],
    "estropie": [
        "estropie",
        "estropier"
    ],
    "estropier": [
        "estropier"
    ],
    "estropierai": [
        "estropier"
    ],
    "estropierait": [
        "estropier"
    ],
    "estropiez": [
        "estropier"
    ],
    "estropiee": [
        "estropie",
        "estropier"
    ],
    "estropies": [
        "estropie",
        "estropier"
    ],
    "estuaire": [
        "estuaire"
    ],
    "estuaires": [
        "estuaire"
    ],
    "estudiantin": [
        "estudiantin"
    ],
    "estudiantine": [
        "estudiantin"
    ],
    "estudiantines": [
        "estudiantin"
    ],
    "estudiantins": [
        "estudiantin"
    ],
    "esturgeon": [
        "esturgeon"
    ],
    "esturgeons": [
        "esturgeon"
    ],
    "et": [
        "et"
    ],
    "etc": [
        "etc"
    ],
    "etc.": [
        "etc."
    ],
    "etcetera": [
        "etcetera"
    ],
    "ethmoidal": [
        "ethmoidal"
    ],
    "ethmoidaux": [
        "ethmoidal"
    ],
    "ethnicite": [
        "ethnicite"
    ],
    "ethnie": [
        "ethnie"
    ],
    "ethnies": [
        "ethnie"
    ],
    "ethnique": [
        "ethnique"
    ],
    "ethniquement": [
        "ethniquement"
    ],
    "ethniques": [
        "ethnique"
    ],
    "ethnobotaniste": [
        "ethnobotaniste"
    ],
    "ethnographe": [
        "ethnographe"
    ],
    "ethnographie": [
        "ethnographie"
    ],
    "ethnographique": [
        "ethnographique"
    ],
    "ethnologie": [
        "ethnologie"
    ],
    "ethnologique": [
        "ethnologique"
    ],
    "ethnologiques": [
        "ethnologique"
    ],
    "ethnologue": [
        "ethnologue"
    ],
    "ethnologues": [
        "ethnologue"
    ],
    "eu": [
        "avoir"
    ],
    "eubage": [
        "eubage"
    ],
    "eubine": [
        "eubine"
    ],
    "eucalyptus": [
        "eucalyptus"
    ],
    "eucharistie": [
        "eucharistie"
    ],
    "eucharistique": [
        "eucharistique"
    ],
    "eucharistiques": [
        "eucharistique"
    ],
    "euclidien": [
        "euclidien"
    ],
    "euclidienne": [
        "euclidien"
    ],
    "euclidiens": [
        "euclidien"
    ],
    "eudistes": [
        "eudiste"
    ],
    "eue": [
        "avoir"
    ],
    "eues": [
        "avoir",
        "eue"
    ],
    "eugenique": [
        "eugenique"
    ],
    "eugenisme": [
        "eugenisme"
    ],
    "euh": [
        "euh"
    ],
    "eulogie": [
        "eulogie"
    ],
    "eunuque": [
        "eunuque"
    ],
    "eunuques": [
        "eunuque"
    ],
    "euphonie": [
        "euphonie"
    ],
    "euphonique": [
        "euphonique"
    ],
    "euphoniquement": [
        "euphoniquement"
    ],
    "euphoniques": [
        "euphonique"
    ],
    "euphorbe": [
        "euphorbe"
    ],
    "euphorbes": [
        "euphorbe"
    ],
    "euphorie": [
        "euphorie"
    ],
    "euphorique": [
        "euphorique"
    ],
    "euphorisant": [
        "euphorisant"
    ],
    "euphorisante": [
        "euphorisant"
    ],
    "euphorisants": [
        "euphorisant"
    ],
    "euphorisent": [
        "euphoriser"
    ],
    "euphorise": [
        "euphoriser"
    ],
    "euphorisee": [
        "euphoriser"
    ],
    "euphemisme": [
        "euphemisme"
    ],
    "euphemismes": [
        "euphemisme"
    ],
    "eurafricaine": [
        "eurafricain"
    ],
    "eurafricains": [
        "eurafricain"
    ],
    "eurasien": [
        "eurasien"
    ],
    "eurasienne": [
        "eurasienne",
        "eurasien"
    ],
    "eurent": [
        "avoir"
    ],
    "euro": [
        "euro"
    ],
    "eurodollar": [
        "eurodollar"
    ],
    "euromarche": [
        "euromarche"
    ],
    "europeen": [
        "europeen"
    ],
    "europeenne": [
        "europeen"
    ],
    "europeennes": [
        "europeen"
    ],
    "europeens": [
        "europeen"
    ],
    "euros": [
        "euro"
    ],
    "eurythmiques": [
        "eurythmique"
    ],
    "eureka": [
        "eureka"
    ],
    "eus": [
        "avoir"
    ],
    "euskera": [
        "euskera"
    ],
    "eusse": [
        "avoir"
    ],
    "eussent": [
        "avoir"
    ],
    "eusses": [
        "avoir"
    ],
    "eussiez": [
        "avoir"
    ],
    "eussions": [
        "avoir"
    ],
    "eustache": [
        "eustache"
    ],
    "eustaches": [
        "eustache"
    ],
    "eut": [
        "avoir"
    ],
    "euthanasie": [
        "euthanasie"
    ],
    "euthanasies": [
        "euthanasie"
    ],
    "eux": [
        "eux"
    ],
    "event": [
        "event"
    ],
    "evzones": [
        "evzone"
    ],
    "exacerba": [
        "exacerber"
    ],
    "exacerbant": [
        "exacerber"
    ],
    "exacerbation": [
        "exacerbation"
    ],
    "exacerbe": [
        "exacerbe",
        "exacerber"
    ],
    "exacerbent": [
        "exacerber"
    ],
    "exacerber": [
        "exacerber"
    ],
    "exacerbee": [
        "exacerbe",
        "exacerber"
    ],
    "exacerbees": [
        "exacerbe",
        "exacerber"
    ],
    "exacerbes": [
        "exacerbe",
        "exacerber"
    ],
    "exact": [
        "exact"
    ],
    "exacte": [
        "exact"
    ],
    "exactement": [
        "exactement"
    ],
    "exactes": [
        "exact"
    ],
    "exaction": [
        "exaction"
    ],
    "exactions": [
        "exaction"
    ],
    "exactitude": [
        "exactitude"
    ],
    "exactitudes": [
        "exactitude"
    ],
    "exacts": [
        "exact"
    ],
    "exagere": [
        "exagerer",
        "exagere"
    ],
    "exagerent": [
        "exagerer"
    ],
    "exageres": [
        "exagerer",
        "exagere"
    ],
    "exagera": [
        "exagerer"
    ],
    "exagerai": [
        "exagerer"
    ],
    "exageraient": [
        "exagerer"
    ],
    "exagerais": [
        "exagerer"
    ],
    "exagerait": [
        "exagerer"
    ],
    "exagerant": [
        "exagerer"
    ],
    "exageration": [
        "exageration"
    ],
    "exagerations": [
        "exageration"
    ],
    "exagerer": [
        "exagerer"
    ],
    "exagererais": [
        "exagerer"
    ],
    "exagererait": [
        "exagerer"
    ],
    "exagererons": [
        "exagerer"
    ],
    "exagerez": [
        "exagerer"
    ],
    "exagerions": [
        "exagerer"
    ],
    "exagerons": [
        "exagerer"
    ],
    "exagererent": [
        "exagerer"
    ],
    "exageree": [
        "exagerer",
        "exagere"
    ],
    "exagerees": [
        "exagerer",
        "exagere"
    ],
    "exagerement": [
        "exagerement"
    ],
    "exalta": [
        "exalter"
    ],
    "exaltai": [
        "exalter"
    ],
    "exaltaient": [
        "exalter"
    ],
    "exaltais": [
        "exalter"
    ],
    "exaltait": [
        "exalter"
    ],
    "exaltant": [
        "exalter",
        "exaltant"
    ],
    "exaltante": [
        "exaltant"
    ],
    "exaltantes": [
        "exaltant"
    ],
    "exaltants": [
        "exaltant"
    ],
    "exaltation": [
        "exaltation"
    ],
    "exaltations": [
        "exaltation"
    ],
    "exalte": [
        "exalte",
        "exalter"
    ],
    "exaltent": [
        "exalter"
    ],
    "exalter": [
        "exalter"
    ],
    "exalterait": [
        "exalter"
    ],
    "exaltes": [
        "exalte",
        "exalter"
    ],
    "exaltons": [
        "exalter"
    ],
    "exalterent": [
        "exalter"
    ],
    "exaltee": [
        "exalte",
        "exalter"
    ],
    "exaltees": [
        "exalte",
        "exalter"
    ],
    "exam": [
        "exam"
    ],
    "examen": [
        "examen"
    ],
    "examens": [
        "examen"
    ],
    "examina": [
        "examiner"
    ],
    "examinai": [
        "examiner"
    ],
    "examinaient": [
        "examiner"
    ],
    "examinais": [
        "examiner"
    ],
    "examinait": [
        "examiner"
    ],
    "examinant": [
        "examiner"
    ],
    "examinateur": [
        "examinateur"
    ],
    "examinateurs": [
        "examinateur"
    ],
    "examinatrice": [
        "examinateur"
    ],
    "examine": [
        "examiner"
    ],
    "examinent": [
        "examiner"
    ],
    "examiner": [
        "examiner"
    ],
    "examinera": [
        "examiner"
    ],
    "examinerai": [
        "examiner"
    ],
    "examineraient": [
        "examiner"
    ],
    "examinerais": [
        "examiner"
    ],
    "examinerait": [
        "examiner"
    ],
    "examinerez": [
        "examiner"
    ],
    "examineriez": [
        "examiner"
    ],
    "examinerons": [
        "examiner"
    ],
    "examineront": [
        "examiner"
    ],
    "examines": [
        "examine",
        "examiner"
    ],
    "examinez": [
        "examiner"
    ],
    "examiniez": [
        "examiner"
    ],
    "examinions": [
        "examiner"
    ],
    "examinons": [
        "examiner"
    ],
    "examinerent": [
        "examiner"
    ],
    "examinee": [
        "examiner"
    ],
    "examinees": [
        "examiner"
    ],
    "exams": [
        "exam"
    ],
    "exarque": [
        "exarque"
    ],
    "exaspere": [
        "exasperer"
    ],
    "exasperent": [
        "exasperer"
    ],
    "exaspera": [
        "exasperer"
    ],
    "exasperaient": [
        "exasperer"
    ],
    "exasperais": [
        "exasperer"
    ],
    "exasperait": [
        "exasperer"
    ],
    "exasperant": [
        "exasperant",
        "exasperer"
    ],
    "exasperante": [
        "exasperant"
    ],
    "exasperantes": [
        "exasperant"
    ],
    "exasperants": [
        "exasperant"
    ],
    "exasperation": [
        "exasperation"
    ],
    "exasperations": [
        "exasperation"
    ],
    "exasperer": [
        "exasperer"
    ],
    "exasperera": [
        "exasperer"
    ],
    "exaspereraient": [
        "exasperer"
    ],
    "exaspererait": [
        "exasperer"
    ],
    "exasperez": [
        "exasperer"
    ],
    "exasperat": [
        "exasperer"
    ],
    "exaspererent": [
        "exasperer"
    ],
    "exasperee": [
        "exasperer"
    ],
    "exasperees": [
        "exasperer"
    ],
    "exasperes": [
        "exasperer"
    ],
    "exauce": [
        "exaucer"
    ],
    "exaucement": [
        "exaucement"
    ],
    "exaucent": [
        "exaucer"
    ],
    "exaucer": [
        "exaucer"
    ],
    "exaucera": [
        "exaucer"
    ],
    "exaucerai": [
        "exaucer"
    ],
    "exaucez": [
        "exaucer"
    ],
    "exaucee": [
        "exaucer"
    ],
    "exaucees": [
        "exaucer"
    ],
    "exauces": [
        "exaucer"
    ],
    "exauca": [
        "exaucer"
    ],
    "exaucai": [
        "exaucer"
    ],
    "exaucaient": [
        "exaucer"
    ],
    "exaucant": [
        "exaucer"
    ],
    "exaucons": [
        "exaucer"
    ],
    "exaucat": [
        "exaucer"
    ],
    "excavateur": [
        "excavateur"
    ],
    "excavateurs": [
        "excavateur"
    ],
    "excavation": [
        "excavation"
    ],
    "excavations": [
        "excavation"
    ],
    "excavatrice": [
        "excavateur"
    ],
    "excaver": [
        "excaver"
    ],
    "excavee": [
        "excaver"
    ],
    "excavees": [
        "excaver"
    ],
    "excella": [
        "exceller"
    ],
    "excellaient": [
        "exceller"
    ],
    "excellais": [
        "exceller"
    ],
    "excellait": [
        "exceller"
    ],
    "excellant": [
        "exceller"
    ],
    "excelle": [
        "exceller"
    ],
    "excellemment": [
        "excellemment"
    ],
    "excellence": [
        "excellence"
    ],
    "excellences": [
        "excellence"
    ],
    "excellent": [
        "exceller",
        "excellent"
    ],
    "excellente": [
        "excellent"
    ],
    "excellentes": [
        "excellent"
    ],
    "excellentissime": [
        "excellentissime"
    ],
    "excellents": [
        "excellent"
    ],
    "exceller": [
        "exceller"
    ],
    "excelleraient": [
        "exceller"
    ],
    "excelles": [
        "exceller"
    ],
    "excellez": [
        "exceller"
    ],
    "excentrer": [
        "excentrer"
    ],
    "excentricite": [
        "excentricite"
    ],
    "excentricites": [
        "excentricite"
    ],
    "excentrique": [
        "excentrique"
    ],
    "excentriques": [
        "excentrique"
    ],
    "excentre": [
        "excentrer",
        "excentre"
    ],
    "excentree": [
        "excentre"
    ],
    "exceptais": [
        "excepter"
    ],
    "exceptait": [
        "excepter"
    ],
    "exceptant": [
        "excepter"
    ],
    "excepte": [
        "excepte",
        "excepter"
    ],
    "excepter": [
        "excepter"
    ],
    "exceptes": [
        "excepte",
        "excepter"
    ],
    "exception": [
        "exception"
    ],
    "exceptionnel": [
        "exceptionnel"
    ],
    "exceptionnelle": [
        "exceptionnel"
    ],
    "exceptionnellement": [
        "exceptionnellement"
    ],
    "exceptionnelles": [
        "exceptionnel"
    ],
    "exceptionnels": [
        "exceptionnel"
    ],
    "exceptions": [
        "exception",
        "excepter"
    ],
    "exceptee": [
        "excepte",
        "excepter"
    ],
    "exceptees": [
        "excepte",
        "excepter"
    ],
    "excessif": [
        "excessif"
    ],
    "excessifs": [
        "excessif"
    ],
    "excessive": [
        "excessif"
    ],
    "excessivement": [
        "excessivement"
    ],
    "excessives": [
        "excessif"
    ],
    "excipent": [
        "exciper"
    ],
    "exciper": [
        "exciper"
    ],
    "excisant": [
        "exciser"
    ],
    "excise": [
        "exciser"
    ],
    "exciser": [
        "exciser"
    ],
    "exciseuse": [
        "exciseur"
    ],
    "exciseuses": [
        "exciseur"
    ],
    "excision": [
        "excision"
    ],
    "excisee": [
        "exciser",
        "excise"
    ],
    "excisees": [
        "exciser",
        "excise"
    ],
    "excita": [
        "exciter"
    ],
    "excitable": [
        "excitable"
    ],
    "excitaient": [
        "exciter"
    ],
    "excitais": [
        "exciter"
    ],
    "excitait": [
        "exciter"
    ],
    "excitant": [
        "exciter",
        "excitant"
    ],
    "excitante": [
        "excitant"
    ],
    "excitantes": [
        "excitant"
    ],
    "excitants": [
        "excitant"
    ],
    "excitation": [
        "excitation"
    ],
    "excitations": [
        "excitation"
    ],
    "excite": [
        "excite",
        "exciter"
    ],
    "excitent": [
        "exciter"
    ],
    "exciter": [
        "exciter"
    ],
    "excitera": [
        "exciter"
    ],
    "exciterait": [
        "exciter"
    ],
    "exciterez": [
        "exciter"
    ],
    "exciteriez": [
        "exciter"
    ],
    "exciteront": [
        "exciter"
    ],
    "excites": [
        "excite",
        "exciter"
    ],
    "exciteur": [
        "exciteur"
    ],
    "excitez": [
        "exciter"
    ],
    "excitions": [
        "exciter"
    ],
    "excitons": [
        "exciter"
    ],
    "exciterent": [
        "exciter"
    ],
    "excitee": [
        "excite",
        "exciter"
    ],
    "excitees": [
        "excite",
        "exciter"
    ],
    "exclama": [
        "exclamer"
    ],
    "exclamai": [
        "exclamer"
    ],
    "exclamaient": [
        "exclamer"
    ],
    "exclamais": [
        "exclamer"
    ],
    "exclamait": [
        "exclamer"
    ],
    "exclamant": [
        "exclamer"
    ],
    "exclamatif": [
        "exclamatif"
    ],
    "exclamation": [
        "exclamation"
    ],
    "exclamations": [
        "exclamation"
    ],
    "exclamative": [
        "exclamatif"
    ],
    "exclame": [
        "exclamer"
    ],
    "exclament": [
        "exclamer"
    ],
    "exclamer": [
        "exclamer"
    ],
    "exclameraient": [
        "exclamer"
    ],
    "exclamerait": [
        "exclamer"
    ],
    "exclamames": [
        "exclamer"
    ],
    "exclamerent": [
        "exclamer"
    ],
    "exclamee": [
        "exclamer"
    ],
    "exclu": [
        "exclure",
        "exclu"
    ],
    "excluaient": [
        "exclure"
    ],
    "excluais": [
        "exclure"
    ],
    "excluait": [
        "exclure"
    ],
    "excluant": [
        "exclure"
    ],
    "exclue": [
        "exclure",
        "exclu"
    ],
    "excluent": [
        "exclure"
    ],
    "exclues": [
        "exclure",
        "exclu"
    ],
    "excluez": [
        "exclure"
    ],
    "excluions": [
        "exclure"
    ],
    "excluons": [
        "exclure"
    ],
    "exclura": [
        "exclure"
    ],
    "exclurais": [
        "exclure"
    ],
    "exclure": [
        "exclure"
    ],
    "exclus": [
        "exclure",
        "exclu"
    ],
    "exclusif": [
        "exclusif"
    ],
    "exclusifs": [
        "exclusif"
    ],
    "exclusion": [
        "exclusion"
    ],
    "exclusions": [
        "exclusion"
    ],
    "exclusive": [
        "exclusif"
    ],
    "exclusivement": [
        "exclusivement"
    ],
    "exclusives": [
        "exclusif",
        "exclusive"
    ],
    "exclusivite": [
        "exclusivite"
    ],
    "exclusivites": [
        "exclusivite"
    ],
    "exclut": [
        "exclure"
    ],
    "excommuniaient": [
        "excommunier"
    ],
    "excommuniait": [
        "excommunier"
    ],
    "excommuniant": [
        "excommunier"
    ],
    "excommunication": [
        "excommunication"
    ],
    "excommunications": [
        "excommunication"
    ],
    "excommunie": [
        "excommunie",
        "excommunier"
    ],
    "excommunient": [
        "excommunier"
    ],
    "excommunier": [
        "excommunier"
    ],
    "excommuniez": [
        "excommunier"
    ],
    "excommuniee": [
        "excommunier"
    ],
    "excommunies": [
        "excommunie",
        "excommunier"
    ],
    "excoriee": [
        "excorier"
    ],
    "excoriees": [
        "excorier"
    ],
    "excroissance": [
        "excroissance"
    ],
    "excroissances": [
        "excroissance"
    ],
    "excrement": [
        "excrement"
    ],
    "excrementiel": [
        "excrementiel"
    ],
    "excrementielle": [
        "excrementiel"
    ],
    "excrements": [
        "excrement"
    ],
    "excreter": [
        "excreter"
    ],
    "excretera": [
        "excreter"
    ],
    "excretion": [
        "excretion"
    ],
    "excretions": [
        "excretion"
    ],
    "excrete": [
        "excreter"
    ],
    "excursion": [
        "excursion"
    ],
    "excursionnaient": [
        "excursionner"
    ],
    "excursionnant": [
        "excursionner"
    ],
    "excursionner": [
        "excursionner"
    ],
    "excursionniste": [
        "excursionniste"
    ],
    "excursionnistes": [
        "excursionniste"
    ],
    "excursions": [
        "excursion"
    ],
    "excusa": [
        "excuser"
    ],
    "excusable": [
        "excusable"
    ],
    "excusables": [
        "excusable"
    ],
    "excusai": [
        "excuser"
    ],
    "excusaient": [
        "excuser"
    ],
    "excusais": [
        "excuser"
    ],
    "excusait": [
        "excuser"
    ],
    "excusant": [
        "excuser"
    ],
    "excuse": [
        "excuser",
        "excuse"
    ],
    "excusent": [
        "excuser"
    ],
    "excuser": [
        "excuser"
    ],
    "excusera": [
        "excuser"
    ],
    "excuserai": [
        "excuser"
    ],
    "excuserais": [
        "excuser"
    ],
    "excuserait": [
        "excuser"
    ],
    "excuseras": [
        "excuser"
    ],
    "excuserez": [
        "excuser"
    ],
    "excuseriez": [
        "excuser"
    ],
    "excuserons": [
        "excuser"
    ],
    "excuseront": [
        "excuser"
    ],
    "excuses": [
        "excuser",
        "excuse"
    ],
    "excusez": [
        "excuser"
    ],
    "excusiez": [
        "excuser"
    ],
    "excusions": [
        "excuser"
    ],
    "excusons": [
        "excuser"
    ],
    "excusames": [
        "excuser"
    ],
    "excusat": [
        "excuser"
    ],
    "excuserent": [
        "excuser"
    ],
    "excusee": [
        "excuser"
    ],
    "excusees": [
        "excuser"
    ],
    "excede": [
        "exceder"
    ],
    "excedent": [
        "excedent",
        "exceder"
    ],
    "exces": [
        "exces"
    ],
    "excedaient": [
        "exceder"
    ],
    "excedais": [
        "exceder"
    ],
    "excedait": [
        "exceder"
    ],
    "excedant": [
        "excedant",
        "exceder"
    ],
    "excedentaire": [
        "excedentaire"
    ],
    "excedentaires": [
        "excedentaire"
    ],
    "excedents": [
        "excedent"
    ],
    "exceder": [
        "exceder"
    ],
    "excedera": [
        "exceder"
    ],
    "excedat": [
        "exceder"
    ],
    "excedee": [
        "exceder"
    ],
    "excedees": [
        "exceder"
    ],
    "excedes": [
        "exceder"
    ],
    "exeat": [
        "exeat"
    ],
    "exemplaire": [
        "exemplaire"
    ],
    "exemplairement": [
        "exemplairement"
    ],
    "exemplaires": [
        "exemplaire"
    ],
    "exemplarite": [
        "exemplarite"
    ],
    "exemple": [
        "exemple"
    ],
    "exemples": [
        "exemple"
    ],
    "exemplifier": [
        "exemplifier"
    ],
    "exempt": [
        "exempt"
    ],
    "exempte": [
        "exempte",
        "exempter",
        "exempt"
    ],
    "exempter": [
        "exempter"
    ],
    "exemptes": [
        "exempte",
        "exempter",
        "exempt"
    ],
    "exemptiez": [
        "exempter"
    ],
    "exemption": [
        "exemption"
    ],
    "exemptions": [
        "exemption"
    ],
    "exempts": [
        "exempt"
    ],
    "exemptee": [
        "exempte",
        "exempter"
    ],
    "exequatur": [
        "exequatur"
    ],
    "exerce": [
        "exerce",
        "exercer"
    ],
    "exercent": [
        "exercer"
    ],
    "exercer": [
        "exercer"
    ],
    "exercera": [
        "exercer"
    ],
    "exercerai": [
        "exercer"
    ],
    "exerceraient": [
        "exercer"
    ],
    "exercerais": [
        "exercer"
    ],
    "exercerait": [
        "exercer"
    ],
    "exercerez": [
        "exercer"
    ],
    "exercerons": [
        "exercer"
    ],
    "exerceront": [
        "exercer"
    ],
    "exerces": [
        "exerce",
        "exercer"
    ],
    "exercez": [
        "exercer"
    ],
    "exercice": [
        "exercice"
    ],
    "exercices": [
        "exercice"
    ],
    "exerciez": [
        "exercer"
    ],
    "exercerent": [
        "exercer"
    ],
    "exercee": [
        "exerce",
        "exercer"
    ],
    "exercees": [
        "exerce",
        "exercer"
    ],
    "exergue": [
        "exergue"
    ],
    "exerca": [
        "exercer"
    ],
    "exercai": [
        "exercer"
    ],
    "exercaient": [
        "exercer"
    ],
    "exercais": [
        "exercer"
    ],
    "exercait": [
        "exercer"
    ],
    "exercant": [
        "exercant",
        "exercer"
    ],
    "exercassent": [
        "exercer"
    ],
    "exercons": [
        "exercer"
    ],
    "exercat": [
        "exercer"
    ],
    "exfiltration": [
        "exfiltration"
    ],
    "exfiltrer": [
        "exfiltrer"
    ],
    "exfiltre": [
        "exfiltrer"
    ],
    "exfoliant": [
        "exfoliant"
    ],
    "exfolier": [
        "exfolier"
    ],
    "exfolions": [
        "exfolier"
    ],
    "exfoliee": [
        "exfolier"
    ],
    "exhala": [
        "exhaler"
    ],
    "exhalaient": [
        "exhaler"
    ],
    "exhalaison": [
        "exhalaison"
    ],
    "exhalaisons": [
        "exhalaison"
    ],
    "exhalait": [
        "exhaler"
    ],
    "exhalant": [
        "exhaler",
        "exhalant"
    ],
    "exhalation": [
        "exhalation"
    ],
    "exhale": [
        "exhaler"
    ],
    "exhalent": [
        "exhaler"
    ],
    "exhaler": [
        "exhaler"
    ],
    "exhaleraient": [
        "exhaler"
    ],
    "exhalames": [
        "exhaler"
    ],
    "exhalat": [
        "exhaler"
    ],
    "exhalee": [
        "exhaler"
    ],
    "exhaussait": [
        "exhausser"
    ],
    "exhausse": [
        "exhausser"
    ],
    "exhaussement": [
        "exhaussement"
    ],
    "exhausser": [
        "exhausser"
    ],
    "exhaussee": [
        "exhausser"
    ],
    "exhaustif": [
        "exhaustif"
    ],
    "exhaustifs": [
        "exhaustif"
    ],
    "exhaustion": [
        "exhaustion"
    ],
    "exhaustive": [
        "exhaustif"
    ],
    "exhaustivement": [
        "exhaustivement"
    ],
    "exhaustivite": [
        "exhaustivite"
    ],
    "exhiba": [
        "exhiber"
    ],
    "exhibai": [
        "exhiber"
    ],
    "exhibaient": [
        "exhiber"
    ],
    "exhibais": [
        "exhiber"
    ],
    "exhibait": [
        "exhiber"
    ],
    "exhibant": [
        "exhiber"
    ],
    "exhibe": [
        "exhiber"
    ],
    "exhibent": [
        "exhiber"
    ],
    "exhiber": [
        "exhiber"
    ],
    "exhibera": [
        "exhiber"
    ],
    "exhiberait": [
        "exhiber"
    ],
    "exhiberas": [
        "exhiber"
    ],
    "exhibez": [
        "exhiber"
    ],
    "exhibions": [
        "exhiber"
    ],
    "exhibition": [
        "exhibition"
    ],
    "exhibitionnisme": [
        "exhibitionnisme"
    ],
    "exhibitionniste": [
        "exhibitionniste"
    ],
    "exhibitionnistes": [
        "exhibitionniste"
    ],
    "exhibitions": [
        "exhibition"
    ],
    "exhibee": [
        "exhiber"
    ],
    "exhibees": [
        "exhiber"
    ],
    "exhibes": [
        "exhiber"
    ],
    "exhorta": [
        "exhorter"
    ],
    "exhortai": [
        "exhorter"
    ],
    "exhortaient": [
        "exhorter"
    ],
    "exhortais": [
        "exhorter"
    ],
    "exhortait": [
        "exhorter"
    ],
    "exhortant": [
        "exhorter"
    ],
    "exhortation": [
        "exhortation"
    ],
    "exhortations": [
        "exhortation"
    ],
    "exhorte": [
        "exhorter"
    ],
    "exhortent": [
        "exhorter"
    ],
    "exhorter": [
        "exhorter"
    ],
    "exhortions": [
        "exhorter"
    ],
    "exhortons": [
        "exhorter"
    ],
    "exhortames": [
        "exhorter"
    ],
    "exhuma": [
        "exhumer"
    ],
    "exhumaient": [
        "exhumer"
    ],
    "exhumais": [
        "exhumer"
    ],
    "exhumait": [
        "exhumer"
    ],
    "exhumant": [
        "exhumer"
    ],
    "exhumation": [
        "exhumation"
    ],
    "exhume": [
        "exhumer"
    ],
    "exhumer": [
        "exhumer"
    ],
    "exhumera": [
        "exhumer"
    ],
    "exhumeront": [
        "exhumer"
    ],
    "exhumee": [
        "exhumer"
    ],
    "exhumees": [
        "exhumer"
    ],
    "exhumes": [
        "exhumer"
    ],
    "exige": [
        "exiger"
    ],
    "exigea": [
        "exiger"
    ],
    "exigeai": [
        "exiger"
    ],
    "exigeaient": [
        "exiger"
    ],
    "exigeais": [
        "exiger"
    ],
    "exigeait": [
        "exiger"
    ],
    "exigeant": [
        "exigeant",
        "exiger"
    ],
    "exigeante": [
        "exigeant"
    ],
    "exigeantes": [
        "exigeant"
    ],
    "exigeants": [
        "exigeant"
    ],
    "exigeassent": [
        "exiger"
    ],
    "exigence": [
        "exigence"
    ],
    "exigences": [
        "exigence"
    ],
    "exigent": [
        "exiger"
    ],
    "exigeons": [
        "exiger"
    ],
    "exiger": [
        "exiger"
    ],
    "exigera": [
        "exiger"
    ],
    "exigerai": [
        "exiger"
    ],
    "exigeraient": [
        "exiger"
    ],
    "exigerais": [
        "exiger"
    ],
    "exigerait": [
        "exiger"
    ],
    "exigerez": [
        "exiger"
    ],
    "exigeriez": [
        "exiger"
    ],
    "exigerions": [
        "exiger"
    ],
    "exigerons": [
        "exiger"
    ],
    "exigeront": [
        "exiger"
    ],
    "exiges": [
        "exiger"
    ],
    "exigez": [
        "exiger"
    ],
    "exigible": [
        "exigible"
    ],
    "exigiez": [
        "exiger"
    ],
    "exigu": [
        "exigu"
    ],
    "exigus": [
        "exigu"
    ],
    "exigue": [
        "exigu"
    ],
    "exigues": [
        "exigu"
    ],
    "exiguite": [
        "exiguite"
    ],
    "exigerent": [
        "exiger"
    ],
    "exigee": [
        "exiger"
    ],
    "exigees": [
        "exiger"
    ],
    "exil": [
        "exil"
    ],
    "exila": [
        "exiler"
    ],
    "exilaient": [
        "exiler"
    ],
    "exilait": [
        "exiler"
    ],
    "exilant": [
        "exiler"
    ],
    "exile": [
        "exile",
        "exiler"
    ],
    "exilent": [
        "exiler"
    ],
    "exiler": [
        "exiler"
    ],
    "exiles": [
        "exile",
        "exiler"
    ],
    "exilez": [
        "exiler"
    ],
    "exils": [
        "exil"
    ],
    "exilat": [
        "exiler"
    ],
    "exilee": [
        "exile",
        "exiler"
    ],
    "exilees": [
        "exile",
        "exiler"
    ],
    "exista": [
        "exister"
    ],
    "existai": [
        "exister"
    ],
    "existaient": [
        "exister"
    ],
    "existais": [
        "exister"
    ],
    "existait": [
        "exister"
    ],
    "existant": [
        "existant",
        "exister"
    ],
    "existante": [
        "existant"
    ],
    "existantes": [
        "existant"
    ],
    "existants": [
        "existant"
    ],
    "existe": [
        "exister"
    ],
    "existence": [
        "existence"
    ],
    "existences": [
        "existence"
    ],
    "existent": [
        "exister"
    ],
    "existentialisme": [
        "existentialisme"
    ],
    "existentialiste": [
        "existentialiste"
    ],
    "existentialistes": [
        "existentialiste"
    ],
    "existentiel": [
        "existentiel"
    ],
    "existentielle": [
        "existentiel"
    ],
    "existentielles": [
        "existentiel"
    ],
    "exister": [
        "exister"
    ],
    "existera": [
        "exister"
    ],
    "existerai": [
        "exister"
    ],
    "existeraient": [
        "exister"
    ],
    "existerais": [
        "exister"
    ],
    "existerait": [
        "exister"
    ],
    "existeras": [
        "exister"
    ],
    "existeriez": [
        "exister"
    ],
    "existerions": [
        "exister"
    ],
    "existerons": [
        "exister"
    ],
    "existeront": [
        "exister"
    ],
    "existes": [
        "exister"
    ],
    "existez": [
        "exister"
    ],
    "existiez": [
        "exister"
    ],
    "existions": [
        "exister"
    ],
    "existons": [
        "exister"
    ],
    "existat": [
        "exister"
    ],
    "existerent": [
        "exister"
    ],
    "existee": [
        "exister"
    ],
    "exit": [
        "exit"
    ],
    "exo": [
        "exo"
    ],
    "exobiologie": [
        "exobiologie"
    ],
    "exocet": [
        "exocet"
    ],
    "exode": [
        "exode"
    ],
    "exodes": [
        "exode"
    ],
    "exogamie": [
        "exogamie"
    ],
    "exogamique": [
        "exogamique"
    ],
    "exogene": [
        "exogene"
    ],
    "exonerait": [
        "exonerer"
    ],
    "exoneration": [
        "exoneration"
    ],
    "exonerer": [
        "exonerer"
    ],
    "exonerera": [
        "exonerer"
    ],
    "exonerees": [
        "exonerer"
    ],
    "exophtalmique": [
        "exophtalmique"
    ],
    "exorable": [
        "exorable"
    ],
    "exorbitaient": [
        "exorbiter"
    ],
    "exorbitait": [
        "exorbiter"
    ],
    "exorbitant": [
        "exorbitant"
    ],
    "exorbitante": [
        "exorbitant"
    ],
    "exorbitantes": [
        "exorbitant"
    ],
    "exorbitants": [
        "exorbitant"
    ],
    "exorbiter": [
        "exorbiter"
    ],
    "exorbite": [
        "exorbite"
    ],
    "exorbitees": [
        "exorbite",
        "exorbiter"
    ],
    "exorbites": [
        "exorbite",
        "exorbiter"
    ],
    "exorcisa": [
        "exorciser"
    ],
    "exorcisait": [
        "exorciser"
    ],
    "exorcisant": [
        "exorciser"
    ],
    "exorcise": [
        "exorciser"
    ],
    "exorcisent": [
        "exorciser"
    ],
    "exorciser": [
        "exorciser"
    ],
    "exorciserait": [
        "exorciser"
    ],
    "exorcisez": [
        "exorciser"
    ],
    "exorcisions": [
        "exorciser"
    ],
    "exorcisme": [
        "exorcisme"
    ],
    "exorcismes": [
        "exorcisme"
    ],
    "exorciste": [
        "exorciste"
    ],
    "exorcistes": [
        "exorciste"
    ],
    "exorcisee": [
        "exorciser"
    ],
    "exorcisees": [
        "exorciser"
    ],
    "exorcises": [
        "exorciser"
    ],
    "exorde": [
        "exorde"
    ],
    "exordes": [
        "exorde"
    ],
    "exos": [
        "exo"
    ],
    "exosphere": [
        "exosphere"
    ],
    "exosquelette": [
        "exosquelette"
    ],
    "exostose": [
        "exostose"
    ],
    "exostoses": [
        "exostose"
    ],
    "exothermique": [
        "exothermique"
    ],
    "exotique": [
        "exotique"
    ],
    "exotiquement": [
        "exotiquement"
    ],
    "exotiques": [
        "exotique"
    ],
    "exotisme": [
        "exotisme"
    ],
    "expansible": [
        "expansible"
    ],
    "expansif": [
        "expansif"
    ],
    "expansifs": [
        "expansif"
    ],
    "expansion": [
        "expansion"
    ],
    "expansionnisme": [
        "expansionnisme"
    ],
    "expansionniste": [
        "expansionniste"
    ],
    "expansionnistes": [
        "expansionniste"
    ],
    "expansive": [
        "expansif"
    ],
    "expansives": [
        "expansif"
    ],
    "expanse": [
        "expanse"
    ],
    "expatriait": [
        "expatrier"
    ],
    "expatriation": [
        "expatriation"
    ],
    "expatrier": [
        "expatrier"
    ],
    "expatrierent": [
        "expatrier"
    ],
    "expatrie": [
        "expatrie",
        "expatrier"
    ],
    "expatriee": [
        "expatrier"
    ],
    "expatries": [
        "expatrie"
    ],
    "expectatif": [
        "expectatif"
    ],
    "expectation": [
        "expectation"
    ],
    "expectative": [
        "expectative"
    ],
    "expectatives": [
        "expectative"
    ],
    "expectora": [
        "expectorer"
    ],
    "expectorant": [
        "expectorer",
        "expectorant"
    ],
    "expectoration": [
        "expectoration"
    ],
    "expectorer": [
        "expectorer"
    ],
    "expectore": [
        "expectorer"
    ],
    "expectorees": [
        "expectorer"
    ],
    "expert": [
        "expert"
    ],
    "experte": [
        "expert"
    ],
    "expertement": [
        "expertement"
    ],
    "expertes": [
        "expert"
    ],
    "expertisaient": [
        "expertiser"
    ],
    "expertisait": [
        "expertiser"
    ],
    "expertisant": [
        "expertiser"
    ],
    "expertise": [
        "expertise",
        "expertiser"
    ],
    "expertiser": [
        "expertiser"
    ],
    "expertises": [
        "expertise"
    ],
    "experts": [
        "expert"
    ],
    "expiaient": [
        "expier"
    ],
    "expiait": [
        "expier"
    ],
    "expiant": [
        "expier"
    ],
    "expiation": [
        "expiation"
    ],
    "expiatoire": [
        "expiatoire"
    ],
    "expiatoires": [
        "expiatoire"
    ],
    "expiatrice": [
        "expiateur"
    ],
    "expie": [
        "expier"
    ],
    "expier": [
        "expier"
    ],
    "expieras": [
        "expier"
    ],
    "expira": [
        "expirer"
    ],
    "expirais": [
        "expirer"
    ],
    "expirait": [
        "expirer"
    ],
    "expirant": [
        "expirer",
        "expirant"
    ],
    "expirante": [
        "expirant"
    ],
    "expirantes": [
        "expirant"
    ],
    "expiration": [
        "expiration"
    ],
    "expirations": [
        "expiration"
    ],
    "expire": [
        "expirer"
    ],
    "expirent": [
        "expirer"
    ],
    "expirer": [
        "expirer"
    ],
    "expirera": [
        "expirer"
    ],
    "expirerait": [
        "expirer"
    ],
    "expirez": [
        "expirer"
    ],
    "expirons": [
        "expirer"
    ],
    "expiree": [
        "expirer"
    ],
    "expires": [
        "expire",
        "expirer"
    ],
    "expiee": [
        "expier"
    ],
    "expies": [
        "expier"
    ],
    "explicable": [
        "explicable"
    ],
    "explicables": [
        "explicable"
    ],
    "explicatif": [
        "explicatif"
    ],
    "explicatifs": [
        "explicatif"
    ],
    "explication": [
        "explication"
    ],
    "explications": [
        "explication"
    ],
    "explicative": [
        "explicatif"
    ],
    "explicatives": [
        "explicatif"
    ],
    "explicitant": [
        "expliciter"
    ],
    "explicite": [
        "explicite",
        "expliciter"
    ],
    "explicitement": [
        "explicitement"
    ],
    "expliciter": [
        "expliciter"
    ],
    "explicites": [
        "explicite"
    ],
    "expliqua": [
        "expliquer"
    ],
    "expliquai": [
        "expliquer"
    ],
    "expliquaient": [
        "expliquer"
    ],
    "expliquais": [
        "expliquer"
    ],
    "expliquait": [
        "expliquer"
    ],
    "expliquant": [
        "expliquer"
    ],
    "explique": [
        "expliquer"
    ],
    "expliquent": [
        "expliquer"
    ],
    "expliquer": [
        "expliquer"
    ],
    "expliquera": [
        "expliquer"
    ],
    "expliquerai": [
        "expliquer"
    ],
    "expliqueraient": [
        "expliquer"
    ],
    "expliquerais": [
        "expliquer"
    ],
    "expliquerait": [
        "expliquer"
    ],
    "expliqueras": [
        "expliquer"
    ],
    "expliquerez": [
        "expliquer"
    ],
    "expliqueriez": [
        "expliquer"
    ],
    "expliquerons": [
        "expliquer"
    ],
    "expliqueront": [
        "expliquer"
    ],
    "expliques": [
        "expliquer"
    ],
    "expliquez": [
        "expliquer"
    ],
    "expliquiez": [
        "expliquer"
    ],
    "expliquions": [
        "expliquer"
    ],
    "expliquons": [
        "expliquer"
    ],
    "expliquames": [
        "expliquer"
    ],
    "expliquat": [
        "expliquer"
    ],
    "expliquerent": [
        "expliquer"
    ],
    "expliquee": [
        "expliquer"
    ],
    "expliquees": [
        "expliquer"
    ],
    "exploit": [
        "exploit"
    ],
    "exploita": [
        "exploiter"
    ],
    "exploitable": [
        "exploitable"
    ],
    "exploitables": [
        "exploitable"
    ],
    "exploitai": [
        "exploiter"
    ],
    "exploitaient": [
        "exploiter"
    ],
    "exploitais": [
        "exploiter"
    ],
    "exploitait": [
        "exploiter"
    ],
    "exploitant": [
        "exploitant",
        "exploiter"
    ],
    "exploitante": [
        "exploitant"
    ],
    "exploitants": [
        "exploitant"
    ],
    "exploitation": [
        "exploitation"
    ],
    "exploitations": [
        "exploitation"
    ],
    "exploite": [
        "exploite",
        "exploiter"
    ],
    "exploitent": [
        "exploiter"
    ],
    "exploiter": [
        "exploiter"
    ],
    "exploitera": [
        "exploiter"
    ],
    "exploiterais": [
        "exploiter"
    ],
    "exploiterait": [
        "exploiter"
    ],
    "exploiteront": [
        "exploiter"
    ],
    "exploites": [
        "exploite",
        "exploiter"
    ],
    "exploiteur": [
        "exploiteur"
    ],
    "exploiteurs": [
        "exploiteur"
    ],
    "exploiteuses": [
        "exploiteur"
    ],
    "exploitez": [
        "exploiter"
    ],
    "exploitions": [
        "exploiter"
    ],
    "exploitons": [
        "exploiter"
    ],
    "exploits": [
        "exploit"
    ],
    "exploitat": [
        "exploiter"
    ],
    "exploiterent": [
        "exploiter"
    ],
    "exploitee": [
        "exploite",
        "exploiter"
    ],
    "exploitees": [
        "exploite",
        "exploiter"
    ],
    "explora": [
        "explorer"
    ],
    "explorai": [
        "explorer"
    ],
    "exploraient": [
        "explorer"
    ],
    "explorais": [
        "explorer"
    ],
    "explorait": [
        "explorer"
    ],
    "explorant": [
        "explorer"
    ],
    "explorateur": [
        "explorateur"
    ],
    "explorateurs": [
        "explorateur"
    ],
    "exploration": [
        "exploration"
    ],
    "explorations": [
        "exploration"
    ],
    "exploratoire": [
        "exploratoire"
    ],
    "exploratoires": [
        "exploratoire"
    ],
    "exploratrice": [
        "explorateur"
    ],
    "exploratrices": [
        "explorateur"
    ],
    "explore": [
        "explorer"
    ],
    "explorent": [
        "explorer"
    ],
    "explorer": [
        "explorer"
    ],
    "explorera": [
        "explorer"
    ],
    "explorerai": [
        "explorer"
    ],
    "explorerez": [
        "explorer"
    ],
    "explorerons": [
        "explorer"
    ],
    "exploreur": [
        "exploreur"
    ],
    "explorez": [
        "explorer"
    ],
    "explorions": [
        "explorer"
    ],
    "explorons": [
        "explorer"
    ],
    "explorerent": [
        "explorer"
    ],
    "exploree": [
        "explorer"
    ],
    "explorees": [
        "explorer"
    ],
    "explores": [
        "explorer",
        "explore"
    ],
    "explosa": [
        "exploser"
    ],
    "explosai": [
        "exploser"
    ],
    "explosaient": [
        "exploser"
    ],
    "explosais": [
        "exploser"
    ],
    "explosait": [
        "exploser"
    ],
    "explosant": [
        "exploser"
    ],
    "explose": [
        "exploser"
    ],
    "explosent": [
        "exploser"
    ],
    "exploser": [
        "exploser"
    ],
    "explosera": [
        "exploser"
    ],
    "exploserai": [
        "exploser"
    ],
    "exploseraient": [
        "exploser"
    ],
    "exploserais": [
        "exploser"
    ],
    "exploserait": [
        "exploser"
    ],
    "exploseras": [
        "exploser"
    ],
    "exploserez": [
        "exploser"
    ],
    "exploseront": [
        "exploser"
    ],
    "exploses": [
        "exploser"
    ],
    "exploseur": [
        "exploseur"
    ],
    "explosez": [
        "exploser"
    ],
    "explosif": [
        "explosif"
    ],
    "explosifs": [
        "explosif"
    ],
    "explosion": [
        "explosion"
    ],
    "explosions": [
        "explosion",
        "exploser"
    ],
    "explosive": [
        "explosif"
    ],
    "explosives": [
        "explosif",
        "explosive"
    ],
    "explosons": [
        "exploser"
    ],
    "explosat": [
        "exploser"
    ],
    "exploserent": [
        "exploser"
    ],
    "explosee": [
        "exploser"
    ],
    "explosees": [
        "exploser"
    ],
    "expletif": [
        "expletif"
    ],
    "expletive": [
        "expletif"
    ],
    "expo": [
        "expo"
    ],
    "exponentiel": [
        "exponentiel"
    ],
    "exponentielle": [
        "exponentiel"
    ],
    "exponentiellement": [
        "exponentiellement"
    ],
    "exponentielles": [
        "exponentiel"
    ],
    "export": [
        "export"
    ],
    "exporta": [
        "exporter"
    ],
    "exportaient": [
        "exporter"
    ],
    "exportant": [
        "exporter"
    ],
    "exportateur": [
        "exportateur"
    ],
    "exportateurs": [
        "exportateur"
    ],
    "exportation": [
        "exportation"
    ],
    "exportations": [
        "exportation"
    ],
    "exporte": [
        "exporter"
    ],
    "exporter": [
        "exporter"
    ],
    "exportera": [
        "exporter"
    ],
    "exporterons": [
        "exporter"
    ],
    "exportez": [
        "exporter"
    ],
    "exports": [
        "export"
    ],
    "exportee": [
        "exporter"
    ],
    "exportees": [
        "exporter"
    ],
    "exportes": [
        "exporter"
    ],
    "expos": [
        "expo"
    ],
    "exposa": [
        "exposer"
    ],
    "exposai": [
        "exposer"
    ],
    "exposaient": [
        "exposer"
    ],
    "exposais": [
        "exposer"
    ],
    "exposait": [
        "exposer"
    ],
    "exposant": [
        "exposant",
        "exposer"
    ],
    "expose": [
        "exposer",
        "expose"
    ],
    "exposent": [
        "exposer"
    ],
    "exposer": [
        "exposer"
    ],
    "exposera": [
        "exposer"
    ],
    "exposerai": [
        "exposer"
    ],
    "exposerais": [
        "exposer"
    ],
    "exposerait": [
        "exposer"
    ],
    "exposerez": [
        "exposer"
    ],
    "exposerions": [
        "exposer"
    ],
    "exposeront": [
        "exposer"
    ],
    "exposes": [
        "exposer",
        "expose"
    ],
    "exposez": [
        "exposer"
    ],
    "exposiez": [
        "exposer"
    ],
    "exposition": [
        "exposition"
    ],
    "expositions": [
        "exposition"
    ],
    "exposons": [
        "exposer"
    ],
    "exposames": [
        "exposer"
    ],
    "exposerent": [
        "exposer"
    ],
    "exposee": [
        "exposer",
        "expose"
    ],
    "exposees": [
        "exposer",
        "expose"
    ],
    "express": [
        "express"
    ],
    "expresse": [
        "expres"
    ],
    "expresses": [
        "express",
        "expres"
    ],
    "expressif": [
        "expressif"
    ],
    "expressifs": [
        "expressif"
    ],
    "expression": [
        "expression"
    ],
    "expressionnisme": [
        "expressionnisme"
    ],
    "expressionniste": [
        "expressionniste"
    ],
    "expressionnistes": [
        "expressionniste"
    ],
    "expressions": [
        "expression"
    ],
    "expressive": [
        "expressif"
    ],
    "expressivement": [
        "expressivement"
    ],
    "expressives": [
        "expressif"
    ],
    "expressement": [
        "expressement"
    ],
    "exprima": [
        "exprimer"
    ],
    "exprimable": [
        "exprimable"
    ],
    "exprimai": [
        "exprimer"
    ],
    "exprimaient": [
        "exprimer"
    ],
    "exprimais": [
        "exprimer"
    ],
    "exprimait": [
        "exprimer"
    ],
    "exprimant": [
        "exprimer"
    ],
    "exprime": [
        "exprimer"
    ],
    "expriment": [
        "exprimer"
    ],
    "exprimer": [
        "exprimer"
    ],
    "exprimera": [
        "exprimer"
    ],
    "exprimerai": [
        "exprimer"
    ],
    "exprimerais": [
        "exprimer"
    ],
    "exprimerait": [
        "exprimer"
    ],
    "exprimeras": [
        "exprimer"
    ],
    "exprimerez": [
        "exprimer"
    ],
    "exprimeront": [
        "exprimer"
    ],
    "exprimes": [
        "exprimer"
    ],
    "exprimez": [
        "exprimer"
    ],
    "exprimiez": [
        "exprimer"
    ],
    "exprimions": [
        "exprimer"
    ],
    "exprimons": [
        "exprimer"
    ],
    "exprimat": [
        "exprimer"
    ],
    "exprimerent": [
        "exprimer"
    ],
    "exprimee": [
        "exprimer"
    ],
    "exprimees": [
        "exprimer"
    ],
    "expropria": [
        "exproprier"
    ],
    "expropriation": [
        "expropriation"
    ],
    "expropriations": [
        "expropriation"
    ],
    "exproprie": [
        "exproprier"
    ],
    "exproprier": [
        "exproprier"
    ],
    "exproprierait": [
        "exproprier"
    ],
    "expropriee": [
        "exproprier",
        "exproprie"
    ],
    "expropriees": [
        "exproprier"
    ],
    "expropries": [
        "exproprier"
    ],
    "expres": [
        "expres"
    ],
    "expulsa": [
        "expulser"
    ],
    "expulsai": [
        "expulser"
    ],
    "expulsaient": [
        "expulser"
    ],
    "expulsais": [
        "expulser"
    ],
    "expulsait": [
        "expulser"
    ],
    "expulsant": [
        "expulser"
    ],
    "expulse": [
        "expulse",
        "expulser"
    ],
    "expulsent": [
        "expulser"
    ],
    "expulser": [
        "expulser"
    ],
    "expulsera": [
        "expulser"
    ],
    "expulserai": [
        "expulser"
    ],
    "expulserait": [
        "expulser"
    ],
    "expulseront": [
        "expulser"
    ],
    "expulsez": [
        "expulser"
    ],
    "expulsion": [
        "expulsion"
    ],
    "expulsions": [
        "expulsion"
    ],
    "expulsive": [
        "expulsif"
    ],
    "expulsons": [
        "expulser"
    ],
    "expulsat": [
        "expulser"
    ],
    "expulsee": [
        "expulse",
        "expulser"
    ],
    "expulsees": [
        "expulse",
        "expulser"
    ],
    "expulses": [
        "expulse",
        "expulser"
    ],
    "expurgeait": [
        "expurger"
    ],
    "expurger": [
        "expurger"
    ],
    "expurgera": [
        "expurger"
    ],
    "expurge": [
        "expurger"
    ],
    "expurgee": [
        "expurger",
        "expurge"
    ],
    "expurges": [
        "expurger"
    ],
    "expedia": [
        "expedier"
    ],
    "expediai": [
        "expedier"
    ],
    "expediaient": [
        "expedier"
    ],
    "expediais": [
        "expedier"
    ],
    "expediait": [
        "expedier"
    ],
    "expediant": [
        "expedier"
    ],
    "expedie": [
        "expedier"
    ],
    "expedient": [
        "expedient",
        "expedier"
    ],
    "expedientes": [
        "expedient"
    ],
    "expedients": [
        "expedient"
    ],
    "expedier": [
        "expedier"
    ],
    "expediera": [
        "expedier"
    ],
    "expedierai": [
        "expedier"
    ],
    "expedierait": [
        "expedier"
    ],
    "expedieras": [
        "expedier"
    ],
    "expedieriez": [
        "expedier"
    ],
    "expedierons": [
        "expedier"
    ],
    "expedieront": [
        "expedier"
    ],
    "expedies": [
        "expedier"
    ],
    "expediez": [
        "expedier"
    ],
    "expedions": [
        "expedier"
    ],
    "expediteur": [
        "expediteur"
    ],
    "expediteurs": [
        "expediteur"
    ],
    "expeditif": [
        "expeditif"
    ],
    "expeditifs": [
        "expeditif"
    ],
    "expedition": [
        "expedition"
    ],
    "expeditionnaire": [
        "expeditionnaire"
    ],
    "expeditionnaires": [
        "expeditionnaire"
    ],
    "expeditions": [
        "expedition"
    ],
    "expeditive": [
        "expeditif"
    ],
    "expeditives": [
        "expeditif"
    ],
    "expeditrice": [
        "expediteur"
    ],
    "expediee": [
        "expediee",
        "expedier"
    ],
    "expediees": [
        "expediee",
        "expedier"
    ],
    "experience": [
        "experience"
    ],
    "experiences": [
        "experience"
    ],
    "experimenta": [
        "experimenter"
    ],
    "experimentai": [
        "experimenter"
    ],
    "experimentaient": [
        "experimenter"
    ],
    "experimentais": [
        "experimenter"
    ],
    "experimentait": [
        "experimenter"
    ],
    "experimental": [
        "experimental"
    ],
    "experimentale": [
        "experimental"
    ],
    "experimentalement": [
        "experimentalement"
    ],
    "experimentales": [
        "experimental"
    ],
    "experimentant": [
        "experimenter"
    ],
    "experimentateur": [
        "experimentateur"
    ],
    "experimentation": [
        "experimentation"
    ],
    "experimentations": [
        "experimentation"
    ],
    "experimentaux": [
        "experimental"
    ],
    "experimente": [
        "experimente",
        "experimenter"
    ],
    "experimentent": [
        "experimenter"
    ],
    "experimenter": [
        "experimenter"
    ],
    "experimenteras": [
        "experimenter"
    ],
    "experimentez": [
        "experimenter"
    ],
    "experimentiez": [
        "experimenter"
    ],
    "experimentons": [
        "experimenter"
    ],
    "experimentee": [
        "experimente",
        "experimenter"
    ],
    "experimentees": [
        "experimente",
        "experimenter"
    ],
    "experimentes": [
        "experimente",
        "experimenter"
    ],
    "exquis": [
        "exquis"
    ],
    "exquise": [
        "exquis"
    ],
    "exquises": [
        "exquis"
    ],
    "exsangue": [
        "exsangue"
    ],
    "exsangues": [
        "exsangue"
    ],
    "exsudaient": [
        "exsuder"
    ],
    "exsudait": [
        "exsuder"
    ],
    "exsudant": [
        "exsuder"
    ],
    "exsudat": [
        "exsudat"
    ],
    "exsudation": [
        "exsudation"
    ],
    "exsude": [
        "exsuder"
    ],
    "exsuder": [
        "exsuder"
    ],
    "extase": [
        "extase"
    ],
    "extases": [
        "extase"
    ],
    "extasia": [
        "extasier"
    ],
    "extasiaient": [
        "extasier"
    ],
    "extasiais": [
        "extasier"
    ],
    "extasiait": [
        "extasier"
    ],
    "extasiant": [
        "extasier",
        "extasiant"
    ],
    "extasiantes": [
        "extasiant"
    ],
    "extasie": [
        "extasie",
        "extasier"
    ],
    "extasient": [
        "extasier"
    ],
    "extasier": [
        "extasier"
    ],
    "extasieront": [
        "extasier"
    ],
    "extasiez": [
        "extasier"
    ],
    "extasions": [
        "extasier"
    ],
    "extasiat": [
        "extasier"
    ],
    "extasierent": [
        "extasier"
    ],
    "extasiee": [
        "extasie",
        "extasier"
    ],
    "extasiees": [
        "extasier"
    ],
    "extasies": [
        "extasie",
        "extasier"
    ],
    "extatique": [
        "extatique"
    ],
    "extatiquement": [
        "extatiquement"
    ],
    "extatiques": [
        "extatique"
    ],
    "extenseur": [
        "extenseur"
    ],
    "extenseurs": [
        "extenseur"
    ],
    "extensible": [
        "extensible"
    ],
    "extensibles": [
        "extensible"
    ],
    "extension": [
        "extension"
    ],
    "extensions": [
        "extension"
    ],
    "extensive": [
        "extensif"
    ],
    "extermina": [
        "exterminer"
    ],
    "exterminaient": [
        "exterminer"
    ],
    "exterminais": [
        "exterminer"
    ],
    "exterminait": [
        "exterminer"
    ],
    "exterminant": [
        "exterminer"
    ],
    "exterminateur": [
        "exterminateur"
    ],
    "exterminateurs": [
        "exterminateur"
    ],
    "extermination": [
        "extermination"
    ],
    "exterminations": [
        "extermination"
    ],
    "exterminatrice": [
        "exterminateur"
    ],
    "exterminatrices": [
        "exterminateur"
    ],
    "extermine": [
        "exterminer"
    ],
    "exterminent": [
        "exterminer"
    ],
    "exterminer": [
        "exterminer"
    ],
    "exterminera": [
        "exterminer"
    ],
    "exterminerait": [
        "exterminer"
    ],
    "exterminerons": [
        "exterminer"
    ],
    "extermineront": [
        "exterminer"
    ],
    "exterminez": [
        "exterminer"
    ],
    "exterminions": [
        "exterminer"
    ],
    "exterminons": [
        "exterminer"
    ],
    "exterminee": [
        "exterminer"
    ],
    "exterminees": [
        "exterminer"
    ],
    "extermines": [
        "exterminer"
    ],
    "externalite": [
        "externalite"
    ],
    "externat": [
        "externat"
    ],
    "externe": [
        "externe"
    ],
    "externes": [
        "externe"
    ],
    "exterritorialite": [
        "exterritorialite"
    ],
    "extincteur": [
        "extincteur"
    ],
    "extincteurs": [
        "extincteur"
    ],
    "extinction": [
        "extinction"
    ],
    "extinctrice": [
        "extinctrice"
    ],
    "extirpa": [
        "extirper"
    ],
    "extirpaient": [
        "extirper"
    ],
    "extirpais": [
        "extirper"
    ],
    "extirpait": [
        "extirper"
    ],
    "extirpant": [
        "extirper"
    ],
    "extirpation": [
        "extirpation"
    ],
    "extirpe": [
        "extirper"
    ],
    "extirpent": [
        "extirper"
    ],
    "extirper": [
        "extirper"
    ],
    "extirpera": [
        "extirper"
    ],
    "extirperai": [
        "extirper"
    ],
    "extirperais": [
        "extirper"
    ],
    "extirperait": [
        "extirper"
    ],
    "extirpee": [
        "extirper"
    ],
    "extirpees": [
        "extirper"
    ],
    "extirpes": [
        "extirper"
    ],
    "extorquai": [
        "extorquer"
    ],
    "extorquais": [
        "extorquer"
    ],
    "extorquait": [
        "extorquer"
    ],
    "extorque": [
        "extorquer"
    ],
    "extorquent": [
        "extorquer"
    ],
    "extorquer": [
        "extorquer"
    ],
    "extorqueur": [
        "extorqueur"
    ],
    "extorquez": [
        "extorquer"
    ],
    "extorquerent": [
        "extorquer"
    ],
    "extorquee": [
        "extorquer"
    ],
    "extorquees": [
        "extorquer"
    ],
    "extorques": [
        "extorquer"
    ],
    "extorsion": [
        "extorsion"
    ],
    "extorsions": [
        "extorsion"
    ],
    "extra": [
        "extra"
    ],
    "extraconjugal": [
        "extraconjugal"
    ],
    "extraconjugale": [
        "extraconjugal"
    ],
    "extraconjugales": [
        "extraconjugal"
    ],
    "extraconjugaux": [
        "extraconjugal"
    ],
    "extracorporelle": [
        "extracorporel"
    ],
    "extracteur": [
        "extracteur"
    ],
    "extracteurs": [
        "extracteur"
    ],
    "extraction": [
        "extraction"
    ],
    "extractions": [
        "extraction"
    ],
    "extractive": [
        "extractif"
    ],
    "extradaient": [
        "extrader"
    ],
    "extrade": [
        "extrade",
        "extrader"
    ],
    "extrader": [
        "extrader"
    ],
    "extradition": [
        "extradition"
    ],
    "extradee": [
        "extrade"
    ],
    "extraforte": [
        "extrafort"
    ],
    "extragalactique": [
        "extragalactique"
    ],
    "extraient": [
        "extraire"
    ],
    "extraira": [
        "extraire"
    ],
    "extrairai": [
        "extraire"
    ],
    "extraire": [
        "extraire"
    ],
    "extrairons": [
        "extraire"
    ],
    "extrairont": [
        "extraire"
    ],
    "extrais": [
        "extraire"
    ],
    "extrait": [
        "extraire",
        "extrait"
    ],
    "extraite": [
        "extraire"
    ],
    "extraites": [
        "extraire"
    ],
    "extraits": [
        "extraire",
        "extrait"
    ],
    "extralucide": [
        "extralucide"
    ],
    "extralucides": [
        "extralucide"
    ],
    "extraordinaire": [
        "extraordinaire"
    ],
    "extraordinairement": [
        "extraordinairement"
    ],
    "extraordinaires": [
        "extraordinaire"
    ],
    "extrapolant": [
        "extrapoler"
    ],
    "extrapolation": [
        "extrapolation"
    ],
    "extrapolations": [
        "extrapolation"
    ],
    "extrapole": [
        "extrapoler"
    ],
    "extrapolent": [
        "extrapoler"
    ],
    "extrapoler": [
        "extrapoler"
    ],
    "extrapolez": [
        "extrapoler"
    ],
    "extrapolons": [
        "extrapoler"
    ],
    "extrapolee": [
        "extrapoler"
    ],
    "extrapolees": [
        "extrapoler"
    ],
    "extras": [
        "extra"
    ],
    "extrascolaire": [
        "extrascolaire"
    ],
    "extrascolaires": [
        "extrascolaire"
    ],
    "extrasensoriel": [
        "extrasensoriel"
    ],
    "extrasensorielle": [
        "extrasensoriel"
    ],
    "extrasensoriels": [
        "extrasensoriel"
    ],
    "extrasystole": [
        "extrasystole"
    ],
    "extraterrestre": [
        "extraterrestre"
    ],
    "extraterrestres": [
        "extraterrestre"
    ],
    "extraterritoriale": [
        "extraterritorial"
    ],
    "extravagance": [
        "extravagance"
    ],
    "extravagances": [
        "extravagance"
    ],
    "extravagant": [
        "extravagant"
    ],
    "extravagante": [
        "extravagant"
    ],
    "extravagantes": [
        "extravagant"
    ],
    "extravagants": [
        "extravagant"
    ],
    "extravaguait": [
        "extravaguer"
    ],
    "extravague": [
        "extravaguer"
    ],
    "extravaguer": [
        "extravaguer"
    ],
    "extravasation": [
        "extravasation"
    ],
    "extraverti": [
        "extraverti"
    ],
    "extravertie": [
        "extraverti"
    ],
    "extravehiculaire": [
        "extravehiculaire"
    ],
    "extrayaient": [
        "extraire"
    ],
    "extrayait": [
        "extraire"
    ],
    "extrayant": [
        "extraire"
    ],
    "extrayez": [
        "extraire"
    ],
    "extrayions": [
        "extraire"
    ],
    "extroverti": [
        "extroverti"
    ],
    "extrovertie": [
        "extroverti"
    ],
    "extrusion": [
        "extrusion"
    ],
    "extremisme": [
        "extremisme"
    ],
    "extremiste": [
        "extremiste"
    ],
    "extremistes": [
        "extremiste"
    ],
    "extremite": [
        "extremite"
    ],
    "extremites": [
        "extremite"
    ],
    "extreme": [
        "extreme"
    ],
    "extremement": [
        "extremement"
    ],
    "extremes": [
        "extreme"
    ],
    "extenua": [
        "extenuer"
    ],
    "extenuait": [
        "extenuer"
    ],
    "extenuant": [
        "extenuer",
        "extenuant"
    ],
    "extenuante": [
        "extenuant"
    ],
    "extenuantes": [
        "extenuant"
    ],
    "extenuants": [
        "extenuant"
    ],
    "extenuation": [
        "extenuation"
    ],
    "extenue": [
        "extenuer",
        "extenue"
    ],
    "extenuement": [
        "extenuement"
    ],
    "extenuent": [
        "extenuer"
    ],
    "extenuer": [
        "extenuer"
    ],
    "extenuerait": [
        "extenuer"
    ],
    "extenuee": [
        "extenuer",
        "extenue"
    ],
    "extenuees": [
        "extenuer",
        "extenue"
    ],
    "extenues": [
        "extenuer",
        "extenue"
    ],
    "exterieur": [
        "exterieur"
    ],
    "exterieure": [
        "exterieur"
    ],
    "exterieurement": [
        "exterieurement"
    ],
    "exterieures": [
        "exterieur"
    ],
    "exterieurs": [
        "exterieur"
    ],
    "exteriorisa": [
        "exterioriser"
    ],
    "exteriorisaient": [
        "exterioriser"
    ],
    "exteriorisait": [
        "exterioriser"
    ],
    "exteriorisation": [
        "exteriorisation"
    ],
    "exteriorise": [
        "exterioriser"
    ],
    "exterioriser": [
        "exterioriser"
    ],
    "exteriorisez": [
        "exterioriser"
    ],
    "exteriorises": [
        "exterioriser"
    ],
    "exteriorite": [
        "exteriorite"
    ],
    "exuberance": [
        "exuberance"
    ],
    "exuberances": [
        "exuberance"
    ],
    "exuberant": [
        "exuberant"
    ],
    "exuberante": [
        "exuberant"
    ],
    "exuberantes": [
        "exuberant"
    ],
    "exuberants": [
        "exuberant"
    ],
    "exulta": [
        "exulter"
    ],
    "exultai": [
        "exulter"
    ],
    "exultaient": [
        "exulter"
    ],
    "exultais": [
        "exulter"
    ],
    "exultait": [
        "exulter"
    ],
    "exultant": [
        "exulter",
        "exultant"
    ],
    "exultante": [
        "exultant"
    ],
    "exultantes": [
        "exultant"
    ],
    "exultants": [
        "exultant"
    ],
    "exultation": [
        "exultation"
    ],
    "exulte": [
        "exulter"
    ],
    "exultent": [
        "exulter"
    ],
    "exulter": [
        "exulter"
    ],
    "exultons": [
        "exulter"
    ],
    "exulterent": [
        "exulter"
    ],
    "exutoire": [
        "exutoire"
    ],
    "exutoires": [
        "exutoire"
    ],
    "execre": [
        "execrer"
    ],
    "execrent": [
        "execrer"
    ],
    "execra": [
        "execrer"
    ],
    "execrable": [
        "execrable"
    ],
    "execrables": [
        "execrable"
    ],
    "execrais": [
        "execrer"
    ],
    "execrait": [
        "execrer"
    ],
    "execration": [
        "execration"
    ],
    "execrations": [
        "execration"
    ],
    "execrer": [
        "execrer"
    ],
    "execree": [
        "execrer"
    ],
    "execrees": [
        "execrer"
    ],
    "execres": [
        "execrer"
    ],
    "executa": [
        "executer"
    ],
    "executai": [
        "executer"
    ],
    "executaient": [
        "executer"
    ],
    "executais": [
        "executer"
    ],
    "executait": [
        "executer"
    ],
    "executant": [
        "executer",
        "executant"
    ],
    "executants": [
        "executant"
    ],
    "execute": [
        "executer"
    ],
    "executent": [
        "executer"
    ],
    "executer": [
        "executer"
    ],
    "executera": [
        "executer"
    ],
    "executerai": [
        "executer"
    ],
    "executeraient": [
        "executer"
    ],
    "executerais": [
        "executer"
    ],
    "executerait": [
        "executer"
    ],
    "executeras": [
        "executer"
    ],
    "executerez": [
        "executer"
    ],
    "executeriez": [
        "executer"
    ],
    "executerons": [
        "executer"
    ],
    "executeront": [
        "executer"
    ],
    "executes": [
        "executer",
        "execute"
    ],
    "executeur": [
        "executeur"
    ],
    "executeurs": [
        "executeur"
    ],
    "executez": [
        "executer"
    ],
    "executiez": [
        "executer"
    ],
    "executif": [
        "executif"
    ],
    "executifs": [
        "executif"
    ],
    "execution": [
        "execution"
    ],
    "executions": [
        "executer",
        "execution"
    ],
    "executive": [
        "executif"
    ],
    "executoire": [
        "executoire"
    ],
    "executoires": [
        "executoire"
    ],
    "executons": [
        "executer"
    ],
    "executrice": [
        "executeur"
    ],
    "executerent": [
        "executer"
    ],
    "executee": [
        "executer"
    ],
    "executees": [
        "executer"
    ],
    "exegese": [
        "exegese"
    ],
    "exegeses": [
        "exegese"
    ],
    "exegete": [
        "exegete"
    ],
    "exegetes": [
        "exegete"
    ],
    "eyeliner": [
        "eyeliner"
    ],
    "eumes": [
        "avoir"
    ],
    "eutes": [
        "avoir"
    ],
    "f": [
        "f"
    ],
    "fa": [
        "fa"
    ],
    "fabiens": [
        "fabien"
    ],
    "fable": [
        "fable"
    ],
    "fables": [
        "fable"
    ],
    "fabliau": [
        "fabliau"
    ],
    "fabliaux": [
        "fabliau"
    ],
    "fabricant": [
        "fabricant"
    ],
    "fabricante": [
        "fabricant"
    ],
    "fabricantes": [
        "fabricant"
    ],
    "fabricants": [
        "fabricant"
    ],
    "fabrication": [
        "fabrication"
    ],
    "fabrications": [
        "fabrication"
    ],
    "fabriqua": [
        "fabriquer"
    ],
    "fabriquai": [
        "fabriquer"
    ],
    "fabriquaient": [
        "fabriquer"
    ],
    "fabriquais": [
        "fabriquer"
    ],
    "fabriquait": [
        "fabriquer"
    ],
    "fabriquant": [
        "fabriquer"
    ],
    "fabrique": [
        "fabriquer",
        "fabrique"
    ],
    "fabriquent": [
        "fabriquer"
    ],
    "fabriquer": [
        "fabriquer"
    ],
    "fabriquera": [
        "fabriquer"
    ],
    "fabriquerai": [
        "fabriquer"
    ],
    "fabriquerais": [
        "fabriquer"
    ],
    "fabriquerait": [
        "fabriquer"
    ],
    "fabriquerez": [
        "fabriquer"
    ],
    "fabriquerons": [
        "fabriquer"
    ],
    "fabriqueront": [
        "fabriquer"
    ],
    "fabriques": [
        "fabriquer",
        "fabrique"
    ],
    "fabriquez": [
        "fabriquer"
    ],
    "fabriquiez": [
        "fabriquer"
    ],
    "fabriquions": [
        "fabriquer"
    ],
    "fabriquons": [
        "fabriquer"
    ],
    "fabriquerent": [
        "fabriquer"
    ],
    "fabriquee": [
        "fabriquer"
    ],
    "fabriquees": [
        "fabriquer"
    ],
    "fabulateur": [
        "fabulateur"
    ],
    "fabulation": [
        "fabulation"
    ],
    "fabulations": [
        "fabulation"
    ],
    "fabulatrice": [
        "fabulateur"
    ],
    "fabule": [
        "fabuler"
    ],
    "fabuler": [
        "fabuler"
    ],
    "fabuleuse": [
        "fabuleux"
    ],
    "fabuleusement": [
        "fabuleusement"
    ],
    "fabuleuses": [
        "fabuleux"
    ],
    "fabuleux": [
        "fabuleux"
    ],
    "fabulez": [
        "fabuler"
    ],
    "fabuliste": [
        "fabuliste"
    ],
    "fac": [
        "fac"
    ],
    "face": [
        "face"
    ],
    "faces": [
        "face"
    ],
    "facette": [
        "facette"
    ],
    "facettes": [
        "facetter",
        "facette"
    ],
    "facho": [
        "facho"
    ],
    "fachos": [
        "facho"
    ],
    "facial": [
        "facial"
    ],
    "faciale": [
        "facial"
    ],
    "faciales": [
        "facial"
    ],
    "faciaux": [
        "facial"
    ],
    "facile": [
        "facile"
    ],
    "facilement": [
        "facilement"
    ],
    "faciles": [
        "facile"
    ],
    "facilita": [
        "faciliter"
    ],
    "facilitaient": [
        "faciliter"
    ],
    "facilitait": [
        "faciliter"
    ],
    "facilitant": [
        "faciliter"
    ],
    "facilitateur": [
        "facilitateur"
    ],
    "facilitation": [
        "facilitation"
    ],
    "facilite": [
        "faciliter",
        "facilite"
    ],
    "facilitent": [
        "faciliter"
    ],
    "faciliter": [
        "faciliter"
    ],
    "facilitera": [
        "faciliter"
    ],
    "faciliterai": [
        "faciliter"
    ],
    "faciliteraient": [
        "faciliter"
    ],
    "faciliterais": [
        "faciliter"
    ],
    "faciliterait": [
        "faciliter"
    ],
    "faciliteront": [
        "faciliter"
    ],
    "facilitez": [
        "faciliter"
    ],
    "facilitons": [
        "faciliter"
    ],
    "facilitee": [
        "faciliter"
    ],
    "facilitees": [
        "faciliter"
    ],
    "facilites": [
        "faciliter",
        "facilite"
    ],
    "facies": [
        "facy",
        "facies"
    ],
    "faconde": [
        "faconde"
    ],
    "facs": [
        "fac"
    ],
    "facteur": [
        "facteur"
    ],
    "facteurs": [
        "facteur"
    ],
    "factice": [
        "factice"
    ],
    "factices": [
        "factice"
    ],
    "factieux": [
        "factieux"
    ],
    "faction": [
        "faction"
    ],
    "factionnaire": [
        "factionnaire"
    ],
    "factionnaires": [
        "factionnaire"
    ],
    "factions": [
        "faction"
    ],
    "factor": [
        "factor"
    ],
    "factorielle": [
        "factoriel"
    ],
    "factorielles": [
        "factoriel"
    ],
    "factorisation": [
        "factorisation"
    ],
    "factoriser": [
        "factoriser"
    ],
    "factotum": [
        "factotum"
    ],
    "factotums": [
        "factotum"
    ],
    "factrice": [
        "facteur"
    ],
    "factuel": [
        "factuel"
    ],
    "factuelles": [
        "factuel"
    ],
    "factuels": [
        "factuel"
    ],
    "factum": [
        "factum"
    ],
    "factums": [
        "factum"
    ],
    "facturation": [
        "facturation"
    ],
    "facture": [
        "facture",
        "facturer"
    ],
    "facturent": [
        "facturer"
    ],
    "facturer": [
        "facturer"
    ],
    "facturera": [
        "facturer"
    ],
    "facturerait": [
        "facturer"
    ],
    "factures": [
        "facture",
        "facturer"
    ],
    "facturette": [
        "facturette"
    ],
    "facturez": [
        "facturer"
    ],
    "facturier": [
        "facturier"
    ],
    "facturiere": [
        "facturier"
    ],
    "facturons": [
        "facturer"
    ],
    "facturee": [
        "facture",
        "facturer"
    ],
    "facturees": [
        "facturer"
    ],
    "facultatif": [
        "facultatif"
    ],
    "facultatifs": [
        "facultatif"
    ],
    "facultative": [
        "facultatif"
    ],
    "faculte": [
        "faculte"
    ],
    "facultes": [
        "faculte"
    ],
    "facetie": [
        "facetie"
    ],
    "faceties": [
        "facetie"
    ],
    "facetieuse": [
        "facetieux"
    ],
    "facetieusement": [
        "facetieusement"
    ],
    "facetieuses": [
        "facetieux"
    ],
    "facetieux": [
        "facetieux"
    ],
    "fada": [
        "fada"
    ],
    "fadaise": [
        "fadaise"
    ],
    "fadaises": [
        "fadaise"
    ],
    "fadas": [
        "fada"
    ],
    "fadasse": [
        "fadasse"
    ],
    "fadasses": [
        "fadasse"
    ],
    "fade": [
        "fade",
        "fader"
    ],
    "fadement": [
        "fadement"
    ],
    "fadent": [
        "fader"
    ],
    "fader": [
        "fader"
    ],
    "faderas": [
        "fader"
    ],
    "fades": [
        "fade",
        "fader"
    ],
    "fadette": [
        "fadette"
    ],
    "fadeur": [
        "fadeur"
    ],
    "fadeurs": [
        "fadeur"
    ],
    "fading": [
        "fading",
        "fade"
    ],
    "fado": [
        "fado"
    ],
    "fadee": [
        "fade"
    ],
    "faena": [
        "faena"
    ],
    "faf": [
        "faf"
    ],
    "fafiot": [
        "fafiot"
    ],
    "fafiots": [
        "fafiot"
    ],
    "fafs": [
        "faf"
    ],
    "fagne": [
        "fagne"
    ],
    "fagnes": [
        "fagne"
    ],
    "fagot": [
        "fagot"
    ],
    "fagotage": [
        "fagotage"
    ],
    "fagotait": [
        "fagoter"
    ],
    "fagotant": [
        "fagoter"
    ],
    "fagote": [
        "fagoter",
        "fagote"
    ],
    "fagoter": [
        "fagoter"
    ],
    "fagotiers": [
        "fagotier"
    ],
    "fagotin": [
        "fagotin"
    ],
    "fagotins": [
        "fagotin"
    ],
    "fagots": [
        "fagot"
    ],
    "fagotee": [
        "fagoter",
        "fagote"
    ],
    "fagotees": [
        "fagoter",
        "fagote"
    ],
    "fagotes": [
        "fagoter",
        "fagote"
    ],
    "fahrenheit": [
        "fahrenheit"
    ],
    "faiblard": [
        "faiblard"
    ],
    "faiblarde": [
        "faiblard"
    ],
    "faiblards": [
        "faiblard"
    ],
    "faible": [
        "faible"
    ],
    "faiblement": [
        "faiblement"
    ],
    "faibles": [
        "faible"
    ],
    "faiblesse": [
        "faiblesse"
    ],
    "faiblesses": [
        "faiblesse"
    ],
    "faibli": [
        "faibli",
        "faiblir"
    ],
    "faiblir": [
        "faiblir"
    ],
    "faiblira": [
        "faiblir"
    ],
    "faiblirent": [
        "faiblir"
    ],
    "faiblis": [
        "faiblir"
    ],
    "faiblissaient": [
        "faiblir"
    ],
    "faiblissais": [
        "faiblir"
    ],
    "faiblissait": [
        "faiblir"
    ],
    "faiblissant": [
        "faiblir"
    ],
    "faiblissante": [
        "faiblissant"
    ],
    "faiblissantes": [
        "faiblissant"
    ],
    "faiblisse": [
        "faiblir"
    ],
    "faiblissent": [
        "faiblir"
    ],
    "faiblissez": [
        "faiblir"
    ],
    "faiblissions": [
        "faiblir"
    ],
    "faiblit": [
        "faiblir"
    ],
    "faignant": [
        "faignant"
    ],
    "faignante": [
        "faignant",
        "faignanter"
    ],
    "faignants": [
        "faignant"
    ],
    "faillait": [
        "failler"
    ],
    "faille": [
        "failler",
        "faille"
    ],
    "failles": [
        "faille"
    ],
    "failli": [
        "failli",
        "faillir"
    ],
    "faillibilite": [
        "faillibilite"
    ],
    "faillibilites": [
        "faillibilite"
    ],
    "faillible": [
        "faillible"
    ],
    "faillibles": [
        "faillible"
    ],
    "faillie": [
        "faillie"
    ],
    "faillies": [
        "faillie"
    ],
    "faillir": [
        "faillir"
    ],
    "faillirai": [
        "faillir"
    ],
    "faillirent": [
        "faillir"
    ],
    "faillis": [
        "failli",
        "faillir"
    ],
    "faillit": [
        "faillir"
    ],
    "faillite": [
        "faillite"
    ],
    "faillites": [
        "faillite"
    ],
    "faillimes": [
        "faillir"
    ],
    "faim": [
        "faim"
    ],
    "faims": [
        "faim"
    ],
    "faine": [
        "faine"
    ],
    "faineant": [
        "faineant"
    ],
    "faineantais": [
        "faineanter"
    ],
    "faineantant": [
        "faineanter"
    ],
    "faineante": [
        "faineant",
        "faineanter"
    ],
    "faineanter": [
        "faineanter"
    ],
    "faineantes": [
        "faineant"
    ],
    "faineantise": [
        "faineantise"
    ],
    "faineants": [
        "faineant"
    ],
    "faire": [
        "faire"
    ],
    "fais": [
        "faire"
    ],
    "faisabilite": [
        "faisabilite"
    ],
    "faisable": [
        "faisable"
    ],
    "faisaient": [
        "faire"
    ],
    "faisais": [
        "faire"
    ],
    "faisait": [
        "faire"
    ],
    "faisan": [
        "faisan"
    ],
    "faisander": [
        "faisander"
    ],
    "faisanderie": [
        "faisanderie"
    ],
    "faisande": [
        "faisande",
        "faisander"
    ],
    "faisandee": [
        "faisande",
        "faisander"
    ],
    "faisandees": [
        "faisande",
        "faisander"
    ],
    "faisandes": [
        "faisande"
    ],
    "faisane": [
        "faisan"
    ],
    "faisans": [
        "faisan"
    ],
    "faisant": [
        "faire"
    ],
    "faisceau": [
        "faisceau"
    ],
    "faisceaux": [
        "faisceau"
    ],
    "faiseur": [
        "faiseur"
    ],
    "faiseurs": [
        "faiseur"
    ],
    "faiseuse": [
        "faiseur"
    ],
    "faiseuses": [
        "faiseur"
    ],
    "faisiez": [
        "faire"
    ],
    "faisions": [
        "faire"
    ],
    "faisons": [
        "faire"
    ],
    "fait": [
        "fait",
        "faire"
    ],
    "faite": [
        "fait",
        "faite",
        "faire"
    ],
    "faites": [
        "fait",
        "faire"
    ],
    "faitout": [
        "faitout"
    ],
    "faitouts": [
        "faitout"
    ],
    "faits": [
        "fait",
        "faire"
    ],
    "faix": [
        "faix"
    ],
    "fakir": [
        "fakir"
    ],
    "fakirs": [
        "fakir"
    ],
    "falaise": [
        "falaise"
    ],
    "falaises": [
        "falaise"
    ],
    "falbala": [
        "falbala"
    ],
    "falbalas": [
        "falbala"
    ],
    "falciforme": [
        "falciforme"
    ],
    "falerne": [
        "falerne"
    ],
    "fallacieuse": [
        "fallacieux"
    ],
    "fallacieusement": [
        "fallacieusement"
    ],
    "fallacieuses": [
        "fallacieux"
    ],
    "fallacieux": [
        "fallacieux"
    ],
    "fallait": [
        "falloir"
    ],
    "falloir": [
        "falloir"
    ],
    "fallu": [
        "falloir"
    ],
    "fallut": [
        "falloir"
    ],
    "falot": [
        "falot"
    ],
    "falote": [
        "falot"
    ],
    "falotes": [
        "falot"
    ],
    "falots": [
        "falot"
    ],
    "falsifiaient": [
        "falsifier"
    ],
    "falsifiais": [
        "falsifier"
    ],
    "falsifiait": [
        "falsifier"
    ],
    "falsifiant": [
        "falsifier"
    ],
    "falsification": [
        "falsification"
    ],
    "falsifient": [
        "falsifier"
    ],
    "falsifier": [
        "falsifier"
    ],
    "falsifiez": [
        "falsifier"
    ],
    "falsifie": [
        "falsifier"
    ],
    "falsifiee": [
        "falsifier"
    ],
    "falsifiees": [
        "falsifier"
    ],
    "falsifies": [
        "falsifier",
        "falsify"
    ],
    "faluche": [
        "faluche"
    ],
    "falzar": [
        "falzar"
    ],
    "falzars": [
        "falzar"
    ],
    "fameuse": [
        "fameux"
    ],
    "fameusement": [
        "fameusement"
    ],
    "fameuses": [
        "fameux"
    ],
    "fameux": [
        "fameux"
    ],
    "familial": [
        "familial"
    ],
    "familiale": [
        "familiale",
        "familial"
    ],
    "familiales": [
        "familiale",
        "familial"
    ],
    "familialiste": [
        "familialiste"
    ],
    "familiarisa": [
        "familiariser"
    ],
    "familiarisaient": [
        "familiariser"
    ],
    "familiarisais": [
        "familiariser"
    ],
    "familiarisait": [
        "familiariser"
    ],
    "familiarisant": [
        "familiariser"
    ],
    "familiarise": [
        "familiariser"
    ],
    "familiarisent": [
        "familiariser"
    ],
    "familiariser": [
        "familiariser"
    ],
    "familiariserez": [
        "familiariser"
    ],
    "familiarisez": [
        "familiariser"
    ],
    "familiarisee": [
        "familiariser"
    ],
    "familiarises": [
        "familiarise",
        "familiariser"
    ],
    "familiarite": [
        "familiarite"
    ],
    "familiarites": [
        "familiarite"
    ],
    "familiaux": [
        "familial"
    ],
    "familier": [
        "familier"
    ],
    "familiers": [
        "familier"
    ],
    "familistere": [
        "familistere"
    ],
    "familiere": [
        "familier"
    ],
    "familierement": [
        "familierement"
    ],
    "familieres": [
        "familier"
    ],
    "famille": [
        "famille"
    ],
    "familles": [
        "famille"
    ],
    "famine": [
        "famine"
    ],
    "famines": [
        "famine"
    ],
    "famulus": [
        "famulus"
    ],
    "fame": [
        "fame"
    ],
    "famee": [
        "fame"
    ],
    "famees": [
        "fame"
    ],
    "famelique": [
        "famelique"
    ],
    "fameliques": [
        "famelique"
    ],
    "fames": [
        "fame"
    ],
    "fan": [
        "fan"
    ],
    "fana": [
        "fana"
    ],
    "fanaient": [
        "faner"
    ],
    "fanait": [
        "faner"
    ],
    "fanal": [
        "fanal"
    ],
    "fanant": [
        "faner"
    ],
    "fanas": [
        "fana"
    ],
    "fanatique": [
        "fanatique"
    ],
    "fanatiquement": [
        "fanatiquement"
    ],
    "fanatiques": [
        "fanatique"
    ],
    "fanatisait": [
        "fanatiser"
    ],
    "fanatise": [
        "fanatiser"
    ],
    "fanatiser": [
        "fanatiser"
    ],
    "fanatisme": [
        "fanatisme"
    ],
    "fanatismes": [
        "fanatisme"
    ],
    "fanatises": [
        "fanatiser"
    ],
    "fanaux": [
        "fanal"
    ],
    "fanchon": [
        "fanchon"
    ],
    "fandango": [
        "fandango"
    ],
    "fane": [
        "fane",
        "faner"
    ],
    "fanent": [
        "faner"
    ],
    "faner": [
        "faner"
    ],
    "fanera": [
        "faner"
    ],
    "faneraient": [
        "faner"
    ],
    "fanerait": [
        "faner"
    ],
    "faneras": [
        "faner"
    ],
    "fanerions": [
        "faner"
    ],
    "faneront": [
        "faner"
    ],
    "fanes": [
        "fane",
        "faner"
    ],
    "faneuse": [
        "faneur"
    ],
    "faneuses": [
        "faneur"
    ],
    "fanez": [
        "faner"
    ],
    "fanfan": [
        "fanfan"
    ],
    "fanfare": [
        "fanfare"
    ],
    "fanfares": [
        "fanfare"
    ],
    "fanfaron": [
        "fanfaron"
    ],
    "fanfaronna": [
        "fanfaronner"
    ],
    "fanfaronnade": [
        "fanfaronnade"
    ],
    "fanfaronnades": [
        "fanfaronnade"
    ],
    "fanfaronnaient": [
        "fanfaronner"
    ],
    "fanfaronnait": [
        "fanfaronner"
    ],
    "fanfaronnant": [
        "fanfaronner"
    ],
    "fanfaronne": [
        "fanfaronner",
        "fanfaron"
    ],
    "fanfaronner": [
        "fanfaronner"
    ],
    "fanfaronnes": [
        "fanfaronner",
        "fanfaron"
    ],
    "fanfarons": [
        "fanfaron"
    ],
    "fanfreluche": [
        "fanfreluche"
    ],
    "fanfreluches": [
        "fanfreluche"
    ],
    "fang": [
        "fang"
    ],
    "fange": [
        "fange"
    ],
    "fanges": [
        "fange"
    ],
    "fangeuse": [
        "fangeux"
    ],
    "fangeuses": [
        "fangeux"
    ],
    "fangeux": [
        "fangeux"
    ],
    "fanion": [
        "fanion"
    ],
    "fanions": [
        "fanion"
    ],
    "fanny": [
        "fanny"
    ],
    "fanon": [
        "fanon"
    ],
    "fanons": [
        "fanon"
    ],
    "fans": [
        "fan"
    ],
    "fantaisie": [
        "fantaisie"
    ],
    "fantaisies": [
        "fantaisie"
    ],
    "fantaisiste": [
        "fantaisiste"
    ],
    "fantaisistes": [
        "fantaisiste"
    ],
    "fantasia": [
        "fantasia"
    ],
    "fantasmagorie": [
        "fantasmagorie"
    ],
    "fantasmagories": [
        "fantasmagorie"
    ],
    "fantasmagorique": [
        "fantasmagorique"
    ],
    "fantasmaient": [
        "fantasmer"
    ],
    "fantasmais": [
        "fantasmer"
    ],
    "fantasmait": [
        "fantasmer"
    ],
    "fantasmatique": [
        "fantasmatique"
    ],
    "fantasmatiquement": [
        "fantasmatiquement"
    ],
    "fantasme": [
        "fantasmer",
        "fantasme"
    ],
    "fantasment": [
        "fantasmer"
    ],
    "fantasmer": [
        "fantasmer"
    ],
    "fantasmes": [
        "fantasmer",
        "fantasme"
    ],
    "fantasmez": [
        "fantasmer"
    ],
    "fantasque": [
        "fantasque"
    ],
    "fantasquement": [
        "fantasquement"
    ],
    "fantasques": [
        "fantasque"
    ],
    "fantassin": [
        "fantassin"
    ],
    "fantassins": [
        "fantassin"
    ],
    "fantastique": [
        "fantastique"
    ],
    "fantastiquement": [
        "fantastiquement"
    ],
    "fantastiques": [
        "fantastique"
    ],
    "fanti": [
        "fanti"
    ],
    "fantoche": [
        "fantoche"
    ],
    "fantoches": [
        "fantoche"
    ],
    "fantomale": [
        "fantomal"
    ],
    "fantomales": [
        "fantomal"
    ],
    "fantomatique": [
        "fantomatique"
    ],
    "fantomatiquement": [
        "fantomatiquement"
    ],
    "fantomatiques": [
        "fantomatique"
    ],
    "fantome": [
        "fantome"
    ],
    "fantomes": [
        "fantome"
    ],
    "fanzine": [
        "fanzine"
    ],
    "fanzines": [
        "fanzine"
    ],
    "fanee": [
        "fane",
        "faner"
    ],
    "fanees": [
        "fane",
        "faner"
    ],
    "faon": [
        "faon"
    ],
    "faons": [
        "faon"
    ],
    "faquin": [
        "faquin"
    ],
    "faquins": [
        "faquin"
    ],
    "far": [
        "far"
    ],
    "farad": [
        "farad"
    ],
    "farads": [
        "farad"
    ],
    "faramineuse": [
        "faramineux"
    ],
    "faramineuses": [
        "faramineux"
    ],
    "faramineux": [
        "faramineux"
    ],
    "farandolaient": [
        "farandoler"
    ],
    "farandole": [
        "farandole"
    ],
    "farandoles": [
        "farandole"
    ],
    "faraud": [
        "faraud"
    ],
    "faraude": [
        "faraud"
    ],
    "farauder": [
        "farauder"
    ],
    "faraudes": [
        "faraud"
    ],
    "farauds": [
        "faraud"
    ],
    "farce": [
        "farcer",
        "farce"
    ],
    "farces": [
        "farcer",
        "farce"
    ],
    "farceur": [
        "farceur"
    ],
    "farceurs": [
        "farceur"
    ],
    "farceuse": [
        "farceur"
    ],
    "farceuses": [
        "farceur"
    ],
    "farci": [
        "farci",
        "farcir"
    ],
    "farcie": [
        "farci",
        "farcir"
    ],
    "farcies": [
        "farci",
        "farcir"
    ],
    "farcir": [
        "farcir"
    ],
    "farcirai": [
        "farcir"
    ],
    "farcirait": [
        "farcir"
    ],
    "farcis": [
        "farci",
        "farcir"
    ],
    "farcissaient": [
        "farcir"
    ],
    "farcissais": [
        "farcir"
    ],
    "farcissait": [
        "farcir"
    ],
    "farcissant": [
        "farcir"
    ],
    "farcisse": [
        "farcir"
    ],
    "farcissez": [
        "farcir"
    ],
    "farcit": [
        "farcir"
    ],
    "fard": [
        "fard"
    ],
    "fardaient": [
        "farder"
    ],
    "fardait": [
        "farder"
    ],
    "fardant": [
        "farder"
    ],
    "farde": [
        "farder"
    ],
    "fardeau": [
        "fardeau"
    ],
    "fardeaux": [
        "fardeau"
    ],
    "fardent": [
        "farder"
    ],
    "farder": [
        "farder"
    ],
    "fardier": [
        "fardier"
    ],
    "fardiers": [
        "fardier"
    ],
    "fards": [
        "fard"
    ],
    "fardee": [
        "farder"
    ],
    "fardees": [
        "farder"
    ],
    "fardes": [
        "farder"
    ],
    "fare": [
        "fare"
    ],
    "farfadet": [
        "farfadet"
    ],
    "farfadets": [
        "farfadet"
    ],
    "farfelu": [
        "farfelu"
    ],
    "farfelue": [
        "farfelu"
    ],
    "farfelues": [
        "farfelu"
    ],
    "farfelus": [
        "farfelu"
    ],
    "farfouilla": [
        "farfouiller"
    ],
    "farfouillais": [
        "farfouiller"
    ],
    "farfouillait": [
        "farfouiller"
    ],
    "farfouillant": [
        "farfouiller"
    ],
    "farfouille": [
        "farfouiller"
    ],
    "farfouillent": [
        "farfouiller"
    ],
    "farfouiller": [
        "farfouiller"
    ],
    "farfouillerait": [
        "farfouiller"
    ],
    "farfouilles": [
        "farfouiller"
    ],
    "farfouilleurs": [
        "farfouilleur"
    ],
    "farfouillez": [
        "farfouiller"
    ],
    "faribole": [
        "faribole"
    ],
    "fariboler": [
        "fariboler"
    ],
    "fariboles": [
        "faribole"
    ],
    "farigoule": [
        "farigoule"
    ],
    "farine": [
        "farine"
    ],
    "farines": [
        "farine",
        "fariner"
    ],
    "farineuse": [
        "farineux"
    ],
    "farineuses": [
        "farineux"
    ],
    "farineux": [
        "farineux"
    ],
    "farinee": [
        "fariner"
    ],
    "farniente": [
        "farniente"
    ],
    "faro": [
        "faro"
    ],
    "farouche": [
        "farouche"
    ],
    "farouchement": [
        "farouchement"
    ],
    "farouches": [
        "farouche"
    ],
    "farsi": [
        "farsi"
    ],
    "fart": [
        "fart"
    ],
    "farter": [
        "farter"
    ],
    "fascia": [
        "fascia"
    ],
    "fascicule": [
        "fascicule"
    ],
    "fascicules": [
        "fascicule"
    ],
    "fascina": [
        "fasciner"
    ],
    "fascinaient": [
        "fasciner"
    ],
    "fascinais": [
        "fasciner"
    ],
    "fascinait": [
        "fasciner"
    ],
    "fascinant": [
        "fascinant",
        "fasciner"
    ],
    "fascinante": [
        "fascinant"
    ],
    "fascinantes": [
        "fascinant"
    ],
    "fascinants": [
        "fascinant"
    ],
    "fascination": [
        "fascination"
    ],
    "fascinations": [
        "fascination"
    ],
    "fascine": [
        "fasciner",
        "fascine"
    ],
    "fascinent": [
        "fasciner"
    ],
    "fasciner": [
        "fasciner"
    ],
    "fascinerait": [
        "fasciner"
    ],
    "fascines": [
        "fasciner",
        "fascine"
    ],
    "fascinez": [
        "fasciner"
    ],
    "fascinerent": [
        "fasciner"
    ],
    "fascinee": [
        "fasciner"
    ],
    "fascinees": [
        "fasciner"
    ],
    "fascisme": [
        "fascisme"
    ],
    "fasciste": [
        "fasciste"
    ],
    "fascistes": [
        "fasciste"
    ],
    "fascisee": [
        "fasciser"
    ],
    "faseyaient": [
        "faseyer"
    ],
    "faseyait": [
        "faseyer"
    ],
    "fashion": [
        "fashion"
    ],
    "fashionable": [
        "fashionable"
    ],
    "fasse": [
        "faire"
    ],
    "fassent": [
        "faire"
    ],
    "fasses": [
        "faire"
    ],
    "fassiez": [
        "faire"
    ],
    "fassions": [
        "faire"
    ],
    "faste": [
        "faste"
    ],
    "fastes": [
        "faste"
    ],
    "fastidieuse": [
        "fastidieux"
    ],
    "fastidieusement": [
        "fastidieusement"
    ],
    "fastidieuses": [
        "fastidieux"
    ],
    "fastidieux": [
        "fastidieux"
    ],
    "fastoche": [
        "fastoche"
    ],
    "fastueuse": [
        "fastueux"
    ],
    "fastueusement": [
        "fastueusement"
    ],
    "fastueuses": [
        "fastueux"
    ],
    "fastueux": [
        "fastueux"
    ],
    "fat": [
        "fat"
    ],
    "fatal": [
        "fatal"
    ],
    "fatale": [
        "fatal"
    ],
    "fatalement": [
        "fatalement"
    ],
    "fatales": [
        "fatal"
    ],
    "fatalise": [
        "fataliser"
    ],
    "fataliser": [
        "fataliser"
    ],
    "fatalisme": [
        "fatalisme"
    ],
    "fataliste": [
        "fataliste"
    ],
    "fatalistes": [
        "fataliste"
    ],
    "fatalite": [
        "fatalite"
    ],
    "fatalites": [
        "fatalite"
    ],
    "fatals": [
        "fatal"
    ],
    "fate": [
        "fat"
    ],
    "fathma": [
        "fathma"
    ],
    "fathom": [
        "fathom"
    ],
    "fatidique": [
        "fatidique"
    ],
    "fatidiques": [
        "fatidique"
    ],
    "fatigant": [
        "fatigant"
    ],
    "fatigante": [
        "fatigant"
    ],
    "fatigantes": [
        "fatigant"
    ],
    "fatigants": [
        "fatigant"
    ],
    "fatigua": [
        "fatiguer"
    ],
    "fatiguai": [
        "fatiguer"
    ],
    "fatiguaient": [
        "fatiguer"
    ],
    "fatiguais": [
        "fatiguer"
    ],
    "fatiguait": [
        "fatiguer"
    ],
    "fatiguant": [
        "fatiguer"
    ],
    "fatigue": [
        "fatiguer",
        "fatigue"
    ],
    "fatiguent": [
        "fatiguer"
    ],
    "fatiguer": [
        "fatiguer"
    ],
    "fatiguera": [
        "fatiguer"
    ],
    "fatiguerai": [
        "fatiguer"
    ],
    "fatigueraient": [
        "fatiguer"
    ],
    "fatiguerais": [
        "fatiguer"
    ],
    "fatiguerait": [
        "fatiguer"
    ],
    "fatigueras": [
        "fatiguer"
    ],
    "fatigues": [
        "fatiguer",
        "fatigue"
    ],
    "fatiguez": [
        "fatiguer"
    ],
    "fatiguons": [
        "fatiguer"
    ],
    "fatiguat": [
        "fatiguer"
    ],
    "fatiguerent": [
        "fatiguer"
    ],
    "fatiguee": [
        "fatiguer",
        "fatigue"
    ],
    "fatiguees": [
        "fatiguer",
        "fatigue"
    ],
    "fatma": [
        "fatma"
    ],
    "fatmas": [
        "fatma"
    ],
    "fatras": [
        "fatras"
    ],
    "fats": [
        "fat"
    ],
    "fatuite": [
        "fatuite"
    ],
    "fatum": [
        "fatum"
    ],
    "fau": [
        "fau"
    ],
    "faubert": [
        "faubert"
    ],
    "faubourg": [
        "faubourg"
    ],
    "faubourgs": [
        "faubourg"
    ],
    "faubourien": [
        "faubourien"
    ],
    "faubourienne": [
        "faubourien"
    ],
    "faubouriennes": [
        "faubourien"
    ],
    "faubouriens": [
        "faubourien"
    ],
    "faucarde": [
        "faucarder"
    ],
    "faucardee": [
        "faucarder"
    ],
    "faucardees": [
        "faucarder"
    ],
    "faucardes": [
        "faucarder"
    ],
    "faucha": [
        "faucher"
    ],
    "fauchage": [
        "fauchage"
    ],
    "fauchaient": [
        "faucher"
    ],
    "fauchais": [
        "faucher"
    ],
    "fauchaison": [
        "fauchaison"
    ],
    "fauchait": [
        "faucher"
    ],
    "fauchant": [
        "faucher"
    ],
    "fauchard": [
        "fauchard"
    ],
    "fauche": [
        "faucher",
        "fauche"
    ],
    "fauchent": [
        "faucher"
    ],
    "faucher": [
        "faucher"
    ],
    "fauchera": [
        "faucher"
    ],
    "faucherait": [
        "faucher"
    ],
    "faucheras": [
        "faucher"
    ],
    "faucheront": [
        "faucher"
    ],
    "fauches": [
        "faucher",
        "fauche"
    ],
    "faucheur": [
        "faucheur"
    ],
    "faucheurs": [
        "faucheur"
    ],
    "faucheuse": [
        "faucheur"
    ],
    "faucheuses": [
        "faucheur"
    ],
    "faucheux": [
        "faucheux"
    ],
    "fauchez": [
        "faucher"
    ],
    "fauchon": [
        "fauchon"
    ],
    "fauchee": [
        "faucher",
        "fauche"
    ],
    "fauchees": [
        "faucher",
        "fauche"
    ],
    "faucille": [
        "faucille"
    ],
    "faucilles": [
        "faucille"
    ],
    "faucillon": [
        "faucillon"
    ],
    "faucon": [
        "faucon"
    ],
    "fauconneau": [
        "fauconneau"
    ],
    "fauconnerie": [
        "fauconnerie"
    ],
    "fauconnier": [
        "fauconnier"
    ],
    "fauconniers": [
        "fauconnier"
    ],
    "faucons": [
        "faucon"
    ],
    "faudra": [
        "falloir"
    ],
    "faudrait": [
        "falloir"
    ],
    "faufil": [
        "faufil"
    ],
    "faufila": [
        "faufiler"
    ],
    "faufilai": [
        "faufiler"
    ],
    "faufilaient": [
        "faufiler"
    ],
    "faufilais": [
        "faufiler"
    ],
    "faufilait": [
        "faufiler"
    ],
    "faufilant": [
        "faufiler"
    ],
    "faufile": [
        "faufiler"
    ],
    "faufilent": [
        "faufiler"
    ],
    "faufiler": [
        "faufiler"
    ],
    "faufilera": [
        "faufiler"
    ],
    "faufilerai": [
        "faufiler"
    ],
    "faufilerait": [
        "faufiler"
    ],
    "faufileras": [
        "faufiler"
    ],
    "faufileront": [
        "faufiler"
    ],
    "faufilez": [
        "faufiler"
    ],
    "faufilons": [
        "faufiler"
    ],
    "faufilames": [
        "faufiler"
    ],
    "faufilat": [
        "faufiler"
    ],
    "faufilerent": [
        "faufiler"
    ],
    "faufilee": [
        "faufiler"
    ],
    "faufilees": [
        "faufiler"
    ],
    "faufiles": [
        "faufiler"
    ],
    "faune": [
        "faune"
    ],
    "faunes": [
        "faune"
    ],
    "faunesque": [
        "faunesque"
    ],
    "faunesques": [
        "faunesque"
    ],
    "faunesse": [
        "faunesse"
    ],
    "faussa": [
        "fausser"
    ],
    "faussaient": [
        "fausser"
    ],
    "faussaire": [
        "faussaire"
    ],
    "faussaires": [
        "faussaire"
    ],
    "faussait": [
        "fausser"
    ],
    "faussant": [
        "fausser"
    ],
    "fausse": [
        "fausser"
    ],
    "faussement": [
        "faussement"
    ],
    "faussent": [
        "fausser"
    ],
    "fausser": [
        "fausser"
    ],
    "fausseront": [
        "fausser"
    ],
    "fausses": [
        "fausser",
        "fausses"
    ],
    "fausset": [
        "fausset"
    ],
    "faussets": [
        "fausset"
    ],
    "faussete": [
        "faussete"
    ],
    "faussez": [
        "fausser"
    ],
    "faussions": [
        "fausser"
    ],
    "faussat": [
        "fausser"
    ],
    "faussee": [
        "fausser"
    ],
    "faussees": [
        "fausser"
    ],
    "faustien": [
        "faustien"
    ],
    "faustienne": [
        "faustien"
    ],
    "faut": [
        "falloir"
    ],
    "faute": [
        "fauter",
        "faute"
    ],
    "fauter": [
        "fauter"
    ],
    "fautes": [
        "fauter",
        "faute"
    ],
    "fauteuil": [
        "fauteuil"
    ],
    "fauteuils": [
        "fauteuil"
    ],
    "fauteur": [
        "fauteur"
    ],
    "fauteurs": [
        "fauteur"
    ],
    "fauteuse": [
        "fauteur"
    ],
    "fautif": [
        "fautif"
    ],
    "fautifs": [
        "fautif"
    ],
    "fautive": [
        "fautif"
    ],
    "fautives": [
        "fautif"
    ],
    "fautrice": [
        "fauteur"
    ],
    "fauve": [
        "fauve"
    ],
    "fauverie": [
        "fauverie"
    ],
    "fauves": [
        "fauve"
    ],
    "fauvette": [
        "fauvette"
    ],
    "fauvettes": [
        "fauvette"
    ],
    "fauvisme": [
        "fauvisme"
    ],
    "favela": [
        "favela"
    ],
    "favelas": [
        "favela"
    ],
    "faveur": [
        "faveur"
    ],
    "faveurs": [
        "faveur"
    ],
    "favorable": [
        "favorable"
    ],
    "favorablement": [
        "favorablement"
    ],
    "favorables": [
        "favorable"
    ],
    "favori": [
        "favori"
    ],
    "favoris": [
        "favori"
    ],
    "favorisa": [
        "favoriser"
    ],
    "favorisaient": [
        "favoriser"
    ],
    "favorisait": [
        "favoriser"
    ],
    "favorisant": [
        "favoriser"
    ],
    "favorise": [
        "favoriser"
    ],
    "favorisent": [
        "favoriser"
    ],
    "favoriser": [
        "favoriser"
    ],
    "favorisera": [
        "favoriser"
    ],
    "favoriserai": [
        "favoriser"
    ],
    "favoriseraient": [
        "favoriser"
    ],
    "favoriserait": [
        "favoriser"
    ],
    "favorisez": [
        "favoriser"
    ],
    "favorisat": [
        "favoriser"
    ],
    "favoriserent": [
        "favoriser"
    ],
    "favorisee": [
        "favoriser"
    ],
    "favorisees": [
        "favoriser"
    ],
    "favorises": [
        "favoriser"
    ],
    "favorite": [
        "favori",
        "favorite"
    ],
    "favorites": [
        "favori",
        "favorite"
    ],
    "favoritisme": [
        "favoritisme"
    ],
    "fax": [
        "fax"
    ],
    "faxe": [
        "faxer"
    ],
    "faxer": [
        "faxer"
    ],
    "faxera": [
        "faxer"
    ],
    "faxerai": [
        "faxer"
    ],
    "faxes": [
        "fax",
        "faxer"
    ],
    "faxez": [
        "faxer"
    ],
    "faxons": [
        "faxer"
    ],
    "fayard": [
        "fayard"
    ],
    "fayards": [
        "fayard"
    ],
    "fayot": [
        "fayot"
    ],
    "fayotage": [
        "fayotage"
    ],
    "fayotaient": [
        "fayoter"
    ],
    "fayotais": [
        "fayoter"
    ],
    "fayotait": [
        "fayoter"
    ],
    "fayote": [
        "fayoter"
    ],
    "fayoter": [
        "fayoter"
    ],
    "fayots": [
        "fayot"
    ],
    "fayotte": [
        "fayotter"
    ],
    "fayotee": [
        "fayoter"
    ],
    "fazenda": [
        "fazenda"
    ],
    "facade": [
        "facade"
    ],
    "facades": [
        "facade"
    ],
    "facon": [
        "facon"
    ],
    "faconna": [
        "faconner"
    ],
    "faconnable": [
        "faconnable"
    ],
    "faconnaient": [
        "faconner"
    ],
    "faconnait": [
        "faconner"
    ],
    "faconnant": [
        "faconner"
    ],
    "faconne": [
        "faconne",
        "faconner"
    ],
    "faconnent": [
        "faconner"
    ],
    "faconner": [
        "faconner"
    ],
    "faconnera": [
        "faconner"
    ],
    "faconnerai": [
        "faconner"
    ],
    "faconnerais": [
        "faconner"
    ],
    "faconnerez": [
        "faconner"
    ],
    "faconneront": [
        "faconner"
    ],
    "faconniere": [
        "faconnier"
    ],
    "faconnee": [
        "faconner"
    ],
    "faconnees": [
        "faconner"
    ],
    "faconnes": [
        "faconne",
        "faconner"
    ],
    "facons": [
        "facon"
    ],
    "faines": [
        "faine"
    ],
    "faitage": [
        "faitage"
    ],
    "faitages": [
        "faitage"
    ],
    "faitiere": [
        "faitier",
        "faitiere"
    ],
    "faitieres": [
        "faitier"
    ],
    "faience": [
        "faience"
    ],
    "faiencerie": [
        "faiencerie"
    ],
    "faiences": [
        "faience"
    ],
    "faiencier": [
        "faiencier"
    ],
    "faienciers": [
        "faiencier"
    ],
    "fedayin": [
        "fedayin"
    ],
    "feedback": [
        "feedback"
    ],
    "feeder": [
        "feeder"
    ],
    "feeling": [
        "feel",
        "felt",
        "feeling"
    ],
    "feelings": [
        "feeling"
    ],
    "feignaient": [
        "feindre"
    ],
    "feignais": [
        "feindre"
    ],
    "feignait": [
        "feindre"
    ],
    "feignant": [
        "feignant",
        "feindre"
    ],
    "feignante": [
        "feignant"
    ],
    "feignantes": [
        "feignant"
    ],
    "feignants": [
        "feignant"
    ],
    "feignasse": [
        "feignasse"
    ],
    "feignasses": [
        "feignasse"
    ],
    "feigne": [
        "feindre"
    ],
    "feignent": [
        "feindre"
    ],
    "feignez": [
        "feindre"
    ],
    "feigniez": [
        "feindre"
    ],
    "feignirent": [
        "feindre"
    ],
    "feignis": [
        "feindre"
    ],
    "feignit": [
        "feindre"
    ],
    "feignons": [
        "feindre"
    ],
    "feignimes": [
        "feindre"
    ],
    "feindra": [
        "feindre"
    ],
    "feindrai": [
        "feindre"
    ],
    "feindrait": [
        "feindre"
    ],
    "feindre": [
        "feindre"
    ],
    "feins": [
        "feindre"
    ],
    "feint": [
        "feindre",
        "feint"
    ],
    "feintait": [
        "feinter"
    ],
    "feintant": [
        "feinter"
    ],
    "feinte": [
        "feinte",
        "feinter",
        "feint"
    ],
    "feinter": [
        "feinter"
    ],
    "feinterez": [
        "feinter"
    ],
    "feintes": [
        "feinte",
        "feinter",
        "feint"
    ],
    "feinteur": [
        "feinteur"
    ],
    "feintise": [
        "feintise"
    ],
    "feints": [
        "feindre",
        "feint"
    ],
    "feldgrau": [
        "feldgrau"
    ],
    "feldspath": [
        "feldspath"
    ],
    "feldwebel": [
        "feldwebel"
    ],
    "feldwebels": [
        "feldwebel"
    ],
    "fellaga": [
        "fellaga"
    ],
    "fellagas": [
        "fellaga"
    ],
    "fellagha": [
        "fellagha"
    ],
    "fellaghas": [
        "fellagha"
    ],
    "fellah": [
        "fellah"
    ],
    "fellahs": [
        "fellah"
    ],
    "fellation": [
        "fellation"
    ],
    "fellationne": [
        "fellationner"
    ],
    "fellations": [
        "fellation"
    ],
    "fellinien": [
        "fellinien"
    ],
    "fellinienne": [
        "fellinien"
    ],
    "felouque": [
        "felouque"
    ],
    "felouques": [
        "felouque"
    ],
    "femelle": [
        "femelle"
    ],
    "femelles": [
        "femelle"
    ],
    "femme": [
        "femme"
    ],
    "femmelette": [
        "femmelette"
    ],
    "femmelettes": [
        "femmelette"
    ],
    "femmes": [
        "femme"
    ],
    "fenaison": [
        "fenaison"
    ],
    "fenaisons": [
        "fenaison"
    ],
    "fend": [
        "fendre"
    ],
    "fendaient": [
        "fendre"
    ],
    "fendais": [
        "fendre"
    ],
    "fendait": [
        "fendre"
    ],
    "fendant": [
        "fendre",
        "fendant"
    ],
    "fendants": [
        "fendant"
    ],
    "fendard": [
        "fendard"
    ],
    "fende": [
        "fendre"
    ],
    "fendent": [
        "fendre"
    ],
    "fendeur": [
        "fendeur"
    ],
    "fendeurs": [
        "fendeur"
    ],
    "fendez": [
        "fendre"
    ],
    "fendillaient": [
        "fendiller"
    ],
    "fendillait": [
        "fendiller"
    ],
    "fendille": [
        "fendille",
        "fendiller"
    ],
    "fendillement": [
        "fendillement"
    ],
    "fendillements": [
        "fendillement"
    ],
    "fendiller": [
        "fendiller"
    ],
    "fendillerent": [
        "fendiller"
    ],
    "fendillee": [
        "fendille",
        "fendiller"
    ],
    "fendillees": [
        "fendille"
    ],
    "fendilles": [
        "fendiller"
    ],
    "fendis": [
        "fendre"
    ],
    "fendissent": [
        "fendre"
    ],
    "fendit": [
        "fendre"
    ],
    "fendoir": [
        "fendoir"
    ],
    "fendons": [
        "fendre"
    ],
    "fendra": [
        "fendre"
    ],
    "fendrai": [
        "fendre"
    ],
    "fendraient": [
        "fendre"
    ],
    "fendrait": [
        "fendre"
    ],
    "fendre": [
        "fendre"
    ],
    "fends": [
        "fendre",
        "fend"
    ],
    "fendu": [
        "fendu",
        "fendre"
    ],
    "fendue": [
        "fendu",
        "fendre"
    ],
    "fendues": [
        "fendu",
        "fendre"
    ],
    "fendus": [
        "fendu",
        "fendre"
    ],
    "fenestrages": [
        "fenestrage"
    ],
    "fenestrelle": [
        "fenestrelle"
    ],
    "fenians": [
        "fenian"
    ],
    "fenil": [
        "fenil"
    ],
    "fenils": [
        "fenil"
    ],
    "fennec": [
        "fennec"
    ],
    "fennecs": [
        "fennec"
    ],
    "fenouil": [
        "fenouil"
    ],
    "fente": [
        "fente"
    ],
    "fentes": [
        "fente"
    ],
    "fenton": [
        "fenton"
    ],
    "fenugrec": [
        "fenugrec"
    ],
    "fenetre": [
        "fenetre"
    ],
    "fenetres": [
        "fenetre"
    ],
    "fer": [
        "fer"
    ],
    "fera": [
        "fera",
        "faire"
    ],
    "ferai": [
        "faire"
    ],
    "feraient": [
        "faire"
    ],
    "ferais": [
        "faire"
    ],
    "ferait": [
        "faire"
    ],
    "feras": [
        "fera",
        "faire"
    ],
    "ferblanterie": [
        "ferblanterie"
    ],
    "ferblantier": [
        "ferblantier"
    ],
    "ferblantiers": [
        "ferblantier"
    ],
    "ferez": [
        "faire"
    ],
    "feria": [
        "feria"
    ],
    "ferias": [
        "feria"
    ],
    "feriez": [
        "faire"
    ],
    "ferions": [
        "faire"
    ],
    "ferlage": [
        "ferlage"
    ],
    "ferlez": [
        "ferler"
    ],
    "ferlee": [
        "ferler"
    ],
    "ferma": [
        "fermer"
    ],
    "fermage": [
        "fermage"
    ],
    "fermages": [
        "fermage"
    ],
    "fermai": [
        "fermer"
    ],
    "fermaient": [
        "fermer"
    ],
    "fermais": [
        "fermer"
    ],
    "fermait": [
        "fermer"
    ],
    "fermant": [
        "fermer",
        "fermant"
    ],
    "ferme": [
        "ferme",
        "fermer"
    ],
    "fermement": [
        "fermement"
    ],
    "ferment": [
        "fermer",
        "ferment"
    ],
    "fermentaient": [
        "fermenter"
    ],
    "fermentais": [
        "fermenter"
    ],
    "fermentait": [
        "fermenter"
    ],
    "fermentation": [
        "fermentation"
    ],
    "fermentations": [
        "fermentation"
    ],
    "fermente": [
        "fermente",
        "fermenter"
    ],
    "fermenter": [
        "fermenter"
    ],
    "ferments": [
        "ferment"
    ],
    "fermenterent": [
        "fermenter"
    ],
    "fermentee": [
        "fermente",
        "fermenter"
    ],
    "fermentees": [
        "fermente"
    ],
    "fermentes": [
        "fermente"
    ],
    "fermer": [
        "fermer"
    ],
    "fermera": [
        "fermer"
    ],
    "fermerai": [
        "fermer"
    ],
    "fermeraient": [
        "fermer"
    ],
    "fermerais": [
        "fermer"
    ],
    "fermerait": [
        "fermer"
    ],
    "fermeras": [
        "fermer"
    ],
    "fermerez": [
        "fermer"
    ],
    "fermeriez": [
        "fermer"
    ],
    "fermerons": [
        "fermer"
    ],
    "fermeront": [
        "fermer"
    ],
    "fermes": [
        "ferme",
        "fermer"
    ],
    "fermette": [
        "fermette"
    ],
    "fermeture": [
        "fermeture"
    ],
    "fermetures": [
        "fermeture"
    ],
    "fermete": [
        "fermete"
    ],
    "fermez": [
        "fermer"
    ],
    "fermi": [
        "fermi"
    ],
    "fermier": [
        "fermier"
    ],
    "fermiers": [
        "fermier"
    ],
    "fermiez": [
        "fermer"
    ],
    "fermions": [
        "fermion",
        "fermer"
    ],
    "fermium": [
        "fermium"
    ],
    "fermiere": [
        "fermier"
    ],
    "fermieres": [
        "fermier"
    ],
    "fermoir": [
        "fermoir"
    ],
    "fermoirs": [
        "fermoir"
    ],
    "fermons": [
        "fermer"
    ],
    "fermat": [
        "fermer"
    ],
    "fermerent": [
        "fermer"
    ],
    "fermee": [
        "ferme",
        "fermer"
    ],
    "fermees": [
        "ferme",
        "fermer"
    ],
    "ferons": [
        "faire"
    ],
    "feront": [
        "faire"
    ],
    "ferra": [
        "ferrer"
    ],
    "ferrage": [
        "ferrage"
    ],
    "ferrages": [
        "ferrage"
    ],
    "ferrai": [
        "ferrer"
    ],
    "ferrailla": [
        "ferrailler"
    ],
    "ferraillaient": [
        "ferrailler"
    ],
    "ferraillait": [
        "ferrailler"
    ],
    "ferraillant": [
        "ferraillant",
        "ferrailler"
    ],
    "ferraillante": [
        "ferraillant"
    ],
    "ferraille": [
        "ferraille",
        "ferrailler"
    ],
    "ferraillement": [
        "ferraillement"
    ],
    "ferrailler": [
        "ferrailler"
    ],
    "ferrailles": [
        "ferraille"
    ],
    "ferrailleur": [
        "ferrailleur"
    ],
    "ferrailleurs": [
        "ferrailleur"
    ],
    "ferrais": [
        "ferrer"
    ],
    "ferrait": [
        "ferrer"
    ],
    "ferrant": [
        "ferrer"
    ],
    "ferrasse": [
        "ferrer"
    ],
    "ferre": [
        "ferrer",
        "ferre"
    ],
    "ferrer": [
        "ferrer"
    ],
    "ferrera": [
        "ferrer"
    ],
    "ferrerait": [
        "ferrer"
    ],
    "ferrets": [
        "ferret"
    ],
    "ferreuse": [
        "ferreux"
    ],
    "ferreux": [
        "ferreux"
    ],
    "ferrez": [
        "ferrer"
    ],
    "ferries": [
        "ferry"
    ],
    "ferriques": [
        "ferrique"
    ],
    "ferrite": [
        "ferrite"
    ],
    "ferro": [
        "ferro"
    ],
    "ferrocyanure": [
        "ferrocyanure"
    ],
    "ferrocerium": [
        "ferrocerium"
    ],
    "ferronnerie": [
        "ferronnerie"
    ],
    "ferronneries": [
        "ferronnerie"
    ],
    "ferronnier": [
        "ferronnier"
    ],
    "ferronniers": [
        "ferronnier"
    ],
    "ferronniere": [
        "ferronnier"
    ],
    "ferrons": [
        "ferrer"
    ],
    "ferroviaire": [
        "ferroviaire"
    ],
    "ferroviaires": [
        "ferroviaire"
    ],
    "ferrugineuse": [
        "ferrugineux"
    ],
    "ferrugineuses": [
        "ferrugineux"
    ],
    "ferrugineux": [
        "ferrugineux"
    ],
    "ferrure": [
        "ferrure"
    ],
    "ferrures": [
        "ferrure"
    ],
    "ferry": [
        "ferry"
    ],
    "ferree": [
        "ferrer",
        "ferre"
    ],
    "ferrees": [
        "ferrer",
        "ferre"
    ],
    "ferres": [
        "ferrer",
        "ferre"
    ],
    "fers": [
        "fer"
    ],
    "fertile": [
        "fertile"
    ],
    "fertiles": [
        "fertile"
    ],
    "fertilisable": [
        "fertilisable"
    ],
    "fertilisait": [
        "fertiliser"
    ],
    "fertilisant": [
        "fertiliser",
        "fertilisant"
    ],
    "fertilisateur": [
        "fertilisateur"
    ],
    "fertilisation": [
        "fertilisation"
    ],
    "fertilise": [
        "fertiliser"
    ],
    "fertilisent": [
        "fertiliser"
    ],
    "fertiliser": [
        "fertiliser"
    ],
    "fertilisera": [
        "fertiliser"
    ],
    "fertiliserons": [
        "fertiliser"
    ],
    "fertilisez": [
        "fertiliser"
    ],
    "fertiliserent": [
        "fertiliser"
    ],
    "fertilisee": [
        "fertiliser"
    ],
    "fertilises": [
        "fertiliser"
    ],
    "fertilite": [
        "fertilite"
    ],
    "ferte": [
        "ferte"
    ],
    "fervent": [
        "fervent"
    ],
    "fervente": [
        "fervent"
    ],
    "ferventes": [
        "fervent"
    ],
    "fervents": [
        "fervent"
    ],
    "ferveur": [
        "ferveur"
    ],
    "ferveurs": [
        "ferveur"
    ],
    "fessait": [
        "fesser"
    ],
    "fesse": [
        "fesser",
        "fesse"
    ],
    "fesser": [
        "fesser"
    ],
    "fesserai": [
        "fesser"
    ],
    "fesserais": [
        "fesser"
    ],
    "fesses": [
        "fesser",
        "fesse"
    ],
    "fesseur": [
        "fesseur"
    ],
    "fesseuse": [
        "fesseur"
    ],
    "fessier": [
        "fessier"
    ],
    "fessiers": [
        "fessier"
    ],
    "fessiez": [
        "fesser"
    ],
    "fessiere": [
        "fessier"
    ],
    "fessieres": [
        "fessier"
    ],
    "fessu": [
        "fessu"
    ],
    "fessue": [
        "fessu"
    ],
    "fessues": [
        "fessu"
    ],
    "fessee": [
        "fessee",
        "fesser"
    ],
    "fessees": [
        "fessee",
        "fesser"
    ],
    "festif": [
        "festif"
    ],
    "festin": [
        "festin"
    ],
    "festins": [
        "festin"
    ],
    "festival": [
        "festival"
    ],
    "festivalier": [
        "festivalier"
    ],
    "festivals": [
        "festival"
    ],
    "festive": [
        "festif"
    ],
    "festives": [
        "festif"
    ],
    "festivite": [
        "festivite"
    ],
    "festivites": [
        "festivite"
    ],
    "festoie": [
        "festoyer"
    ],
    "festoient": [
        "festoyer"
    ],
    "festoiera": [
        "festoyer"
    ],
    "festoierons": [
        "festoyer"
    ],
    "feston": [
        "feston"
    ],
    "festonnaient": [
        "festonner"
    ],
    "festonnait": [
        "festonner"
    ],
    "festonne": [
        "festonner"
    ],
    "festonnements": [
        "festonnement"
    ],
    "festonner": [
        "festonner"
    ],
    "festonnee": [
        "festonner"
    ],
    "festonnees": [
        "festonner"
    ],
    "festonnes": [
        "festonner"
    ],
    "festons": [
        "feston"
    ],
    "festoya": [
        "festoyer"
    ],
    "festoyaient": [
        "festoyer"
    ],
    "festoyant": [
        "festoyer"
    ],
    "festoyer": [
        "festoyer"
    ],
    "festoyez": [
        "festoyer"
    ],
    "festoye": [
        "festoyer"
    ],
    "feta": [
        "feta",
        "feter"
    ],
    "fettucine": [
        "fettucine"
    ],
    "feu": [
        "feu"
    ],
    "feudataire": [
        "feudataire"
    ],
    "feue": [
        "feu"
    ],
    "feuillage": [
        "feuillage"
    ],
    "feuillages": [
        "feuillage"
    ],
    "feuillaison": [
        "feuillaison"
    ],
    "feuillantines": [
        "feuillantine"
    ],
    "feuille": [
        "feuille"
    ],
    "feuilles": [
        "feuille"
    ],
    "feuillet": [
        "feuillet"
    ],
    "feuilleta": [
        "feuilleter"
    ],
    "feuilletage": [
        "feuilletage"
    ],
    "feuilletai": [
        "feuilleter"
    ],
    "feuilletaient": [
        "feuilleter"
    ],
    "feuilletais": [
        "feuilleter"
    ],
    "feuilletait": [
        "feuilleter"
    ],
    "feuilletant": [
        "feuilleter"
    ],
    "feuilleter": [
        "feuilleter"
    ],
    "feuilletez": [
        "feuilleter"
    ],
    "feuilletiez": [
        "feuilleter"
    ],
    "feuilletions": [
        "feuilleter"
    ],
    "feuilleton": [
        "feuilleton"
    ],
    "feuilletoniste": [
        "feuilletoniste"
    ],
    "feuilletons": [
        "feuilleton"
    ],
    "feuillets": [
        "feuillet"
    ],
    "feuillette": [
        "feuilleter",
        "feuillette"
    ],
    "feuillettement": [
        "feuillettement"
    ],
    "feuillettent": [
        "feuilleter"
    ],
    "feuillettes": [
        "feuilleter",
        "feuillette"
    ],
    "feuilleterent": [
        "feuilleter"
    ],
    "feuillete": [
        "feuillete",
        "feuilleter"
    ],
    "feuilletee": [
        "feuillete",
        "feuilleter"
    ],
    "feuilletees": [
        "feuillete"
    ],
    "feuilletes": [
        "feuillete",
        "feuilleter"
    ],
    "feuillu": [
        "feuillu"
    ],
    "feuillue": [
        "feuillu"
    ],
    "feuillues": [
        "feuillu"
    ],
    "feuillure": [
        "feuillure"
    ],
    "feuillures": [
        "feuillure"
    ],
    "feuillus": [
        "feuillu"
    ],
    "feuillee": [
        "feuillee"
    ],
    "feuillees": [
        "feuillee"
    ],
    "feuj": [
        "feuj"
    ],
    "feula": [
        "feuler"
    ],
    "feulait": [
        "feuler"
    ],
    "feulant": [
        "feuler"
    ],
    "feule": [
        "feuler"
    ],
    "feulement": [
        "feulement"
    ],
    "feulements": [
        "feulement"
    ],
    "feulent": [
        "feuler"
    ],
    "feuler": [
        "feuler"
    ],
    "feulee": [
        "feuler"
    ],
    "feurre": [
        "feurre"
    ],
    "feutra": [
        "feutrer"
    ],
    "feutrage": [
        "feutrage"
    ],
    "feutrages": [
        "feutrage"
    ],
    "feutrait": [
        "feutrer"
    ],
    "feutrant": [
        "feutrer"
    ],
    "feutre": [
        "feutre",
        "feutrer"
    ],
    "feutrent": [
        "feutrer"
    ],
    "feutrer": [
        "feutrer"
    ],
    "feutres": [
        "feutre",
        "feutrer"
    ],
    "feutrine": [
        "feutrine"
    ],
    "feutree": [
        "feutre",
        "feutrer"
    ],
    "feutrees": [
        "feutre",
        "feutrer"
    ],
    "feux": [
        "feu"
    ],
    "fez": [
        "fez"
    ],
    "fi": [
        "fi"
    ],
    "fia": [
        "fier"
    ],
    "fiabilite": [
        "fiabilite"
    ],
    "fiable": [
        "fiable"
    ],
    "fiables": [
        "fiable"
    ],
    "fiacre": [
        "fiacre"
    ],
    "fiacres": [
        "fiacre"
    ],
    "fiaient": [
        "fier"
    ],
    "fiais": [
        "fier"
    ],
    "fiait": [
        "fier"
    ],
    "fiance": [
        "fiance",
        "fiancer"
    ],
    "fiancent": [
        "fiancer"
    ],
    "fiancer": [
        "fiancer"
    ],
    "fiancerais": [
        "fiancer"
    ],
    "fiancerons": [
        "fiancer"
    ],
    "fiancez": [
        "fiancer"
    ],
    "fiancerent": [
        "fiancer"
    ],
    "fiancee": [
        "fiance",
        "fiancer"
    ],
    "fiancees": [
        "fiance",
        "fiancer"
    ],
    "fiances": [
        "fiance",
        "fiancer"
    ],
    "fiant": [
        "fier"
    ],
    "fianca": [
        "fiancer"
    ],
    "fiancailles": [
        "fiancailles"
    ],
    "fiancais": [
        "fiancer"
    ],
    "fiancons": [
        "fiancer"
    ],
    "fias": [
        "fier"
    ],
    "fiasco": [
        "fiasco"
    ],
    "fiascos": [
        "fiasco"
    ],
    "fiasque": [
        "fiasque"
    ],
    "fiasques": [
        "fiasque"
    ],
    "fiassent": [
        "fier"
    ],
    "fiat": [
        "fiat"
    ],
    "fibre": [
        "fibre"
    ],
    "fibres": [
        "fibre"
    ],
    "fibreuse": [
        "fibreux"
    ],
    "fibreuses": [
        "fibreux"
    ],
    "fibreux": [
        "fibreux"
    ],
    "fibrillation": [
        "fibrillation"
    ],
    "fibrille": [
        "fibrille"
    ],
    "fibrilles": [
        "fibrille"
    ],
    "fibrilleux": [
        "fibrilleux"
    ],
    "fibrine": [
        "fibrine"
    ],
    "fibrinogene": [
        "fibrinogene"
    ],
    "fibrociment": [
        "fibrociment"
    ],
    "fibromateuse": [
        "fibromateux"
    ],
    "fibrome": [
        "fibrome"
    ],
    "fibromes": [
        "fibrome"
    ],
    "fibroscope": [
        "fibroscope"
    ],
    "fibroscopie": [
        "fibroscopie"
    ],
    "fibrose": [
        "fibrose"
    ],
    "fibrotoxine": [
        "fibrotoxine"
    ],
    "fibule": [
        "fibule"
    ],
    "fic": [
        "fic"
    ],
    "ficaires": [
        "ficaire"
    ],
    "ficela": [
        "ficeler"
    ],
    "ficelai": [
        "ficeler"
    ],
    "ficelaient": [
        "ficeler"
    ],
    "ficelait": [
        "ficeler"
    ],
    "ficelant": [
        "ficeler"
    ],
    "ficeler": [
        "ficeler"
    ],
    "ficelez": [
        "ficeler"
    ],
    "ficelle": [
        "ficeler",
        "ficelle"
    ],
    "ficellerait": [
        "ficeler"
    ],
    "ficelles": [
        "ficeler",
        "ficelle"
    ],
    "ficelerent": [
        "ficeler"
    ],
    "ficele": [
        "ficeler",
        "ficele"
    ],
    "ficelee": [
        "ficeler",
        "ficele"
    ],
    "ficelees": [
        "ficeler",
        "ficele"
    ],
    "ficeles": [
        "ficeler",
        "ficele"
    ],
    "ficha": [
        "ficher"
    ],
    "fichage": [
        "fichage"
    ],
    "fichaient": [
        "ficher"
    ],
    "fichais": [
        "ficher"
    ],
    "fichaise": [
        "fichaise"
    ],
    "fichaises": [
        "fichaise"
    ],
    "fichait": [
        "ficher"
    ],
    "fichant": [
        "ficher",
        "fichant"
    ],
    "fiche": [
        "ficher",
        "fiche"
    ],
    "fichent": [
        "ficher"
    ],
    "ficher": [
        "ficher"
    ],
    "fichera": [
        "ficher"
    ],
    "ficherai": [
        "ficher"
    ],
    "ficheraient": [
        "ficher"
    ],
    "ficherais": [
        "ficher"
    ],
    "ficherait": [
        "ficher"
    ],
    "ficheras": [
        "ficher"
    ],
    "ficherons": [
        "ficher"
    ],
    "ficheront": [
        "ficher"
    ],
    "fiches": [
        "ficher",
        "fiche"
    ],
    "fichez": [
        "ficher"
    ],
    "fichier": [
        "fichier"
    ],
    "fichiers": [
        "fichier"
    ],
    "fichiez": [
        "ficher"
    ],
    "fichions": [
        "ficher"
    ],
    "fichons": [
        "ficher"
    ],
    "fichtre": [
        "fichtre"
    ],
    "fichtrement": [
        "fichtrement"
    ],
    "fichu": [
        "fichu"
    ],
    "fichue": [
        "fichu"
    ],
    "fichues": [
        "fichu"
    ],
    "fichus": [
        "fichu"
    ],
    "fichat": [
        "ficher"
    ],
    "fichee": [
        "ficher"
    ],
    "fichees": [
        "ficher"
    ],
    "fictif": [
        "fictif"
    ],
    "fictifs": [
        "fictif"
    ],
    "fiction": [
        "fiction"
    ],
    "fictionnel": [
        "fictionnel"
    ],
    "fictions": [
        "fiction"
    ],
    "fictive": [
        "fictif"
    ],
    "fictivement": [
        "fictivement"
    ],
    "fictives": [
        "fictif"
    ],
    "ficus": [
        "ficus"
    ],
    "fiduciaire": [
        "fiduciaire"
    ],
    "fiduciaires": [
        "fiduciaire"
    ],
    "fiducie": [
        "fiducie"
    ],
    "fidele": [
        "fidele"
    ],
    "fidelement": [
        "fidelement"
    ],
    "fideles": [
        "fidele"
    ],
    "fideicommis": [
        "fideicommis"
    ],
    "fideliser": [
        "fideliser"
    ],
    "fideliseras": [
        "fideliser"
    ],
    "fidelite": [
        "fidelite"
    ],
    "fidelites": [
        "fidelite"
    ],
    "fie": [
        "fier"
    ],
    "fief": [
        "fief"
    ],
    "fieffe": [
        "fieffe",
        "fieffer"
    ],
    "fieffee": [
        "fieffe",
        "fieffer"
    ],
    "fieffes": [
        "fieffe"
    ],
    "fiefs": [
        "fief"
    ],
    "fiel": [
        "fiel"
    ],
    "field": [
        "field"
    ],
    "fielleuse": [
        "fielleux"
    ],
    "fielleusement": [
        "fielleusement"
    ],
    "fielleuses": [
        "fielleux"
    ],
    "fielleux": [
        "fielleux"
    ],
    "fient": [
        "fier"
    ],
    "fiente": [
        "fienter",
        "fiente"
    ],
    "fientes": [
        "fiente"
    ],
    "fienteuse": [
        "fienteux"
    ],
    "fienteux": [
        "fienteux"
    ],
    "fier": [
        "fier"
    ],
    "fiera": [
        "fier"
    ],
    "fierai": [
        "fier"
    ],
    "fierais": [
        "fier"
    ],
    "fieras": [
        "fier"
    ],
    "fiers": [
        "fier"
    ],
    "fierte": [
        "fierte"
    ],
    "fiertes": [
        "fierte"
    ],
    "fiesta": [
        "fiesta"
    ],
    "fiestas": [
        "fiesta"
    ],
    "fieu": [
        "fieu"
    ],
    "fieux": [
        "fieux"
    ],
    "fiez": [
        "fier"
    ],
    "fifi": [
        "fifi"
    ],
    "fifille": [
        "fifille"
    ],
    "fifis": [
        "fifi"
    ],
    "fifre": [
        "fifre"
    ],
    "fifrelin": [
        "fifrelin"
    ],
    "fifrelins": [
        "fifrelin"
    ],
    "fifres": [
        "fifre"
    ],
    "fifties": [
        "fifties"
    ],
    "fifty": [
        "fifty"
    ],
    "figaro": [
        "figaro"
    ],
    "figaros": [
        "figaro"
    ],
    "fige": [
        "figer",
        "fige"
    ],
    "figea": [
        "figer"
    ],
    "figeaient": [
        "figer"
    ],
    "figeais": [
        "figer"
    ],
    "figeait": [
        "figer"
    ],
    "figeant": [
        "figer"
    ],
    "figent": [
        "figer"
    ],
    "figer": [
        "figer"
    ],
    "figera": [
        "figer"
    ],
    "figerai": [
        "figer"
    ],
    "figeraient": [
        "figer"
    ],
    "figerait": [
        "figer"
    ],
    "figez": [
        "figer"
    ],
    "fignard": [
        "fignard"
    ],
    "fignola": [
        "fignoler"
    ],
    "fignolage": [
        "fignolage"
    ],
    "fignolages": [
        "fignolage"
    ],
    "fignolaient": [
        "fignoler"
    ],
    "fignolait": [
        "fignoler"
    ],
    "fignolant": [
        "fignoler"
    ],
    "fignole": [
        "fignoler"
    ],
    "fignolent": [
        "fignoler"
    ],
    "fignoler": [
        "fignoler"
    ],
    "fignolerai": [
        "fignoler"
    ],
    "fignolerais": [
        "fignoler"
    ],
    "fignolerait": [
        "fignoler"
    ],
    "fignoleur": [
        "fignoleur"
    ],
    "fignolons": [
        "fignoler"
    ],
    "fignolee": [
        "fignoler"
    ],
    "fignoles": [
        "fignoler"
    ],
    "figue": [
        "figue"
    ],
    "figues": [
        "figue"
    ],
    "figuier": [
        "figuier"
    ],
    "figuiers": [
        "figuier"
    ],
    "figura": [
        "figurer"
    ],
    "figurai": [
        "figurer"
    ],
    "figuraient": [
        "figurer"
    ],
    "figurais": [
        "figurer"
    ],
    "figurait": [
        "figurer"
    ],
    "figurant": [
        "figurant",
        "figurer"
    ],
    "figurante": [
        "figurant"
    ],
    "figurantes": [
        "figurant"
    ],
    "figurants": [
        "figurant"
    ],
    "figuratif": [
        "figuratif"
    ],
    "figuratifs": [
        "figuratif"
    ],
    "figuration": [
        "figuration"
    ],
    "figurations": [
        "figuration"
    ],
    "figurative": [
        "figuratif"
    ],
    "figurativement": [
        "figurativement"
    ],
    "figuratives": [
        "figuratif"
    ],
    "figure": [
        "figure",
        "figurer"
    ],
    "figurent": [
        "figurer"
    ],
    "figurer": [
        "figurer"
    ],
    "figurera": [
        "figurer"
    ],
    "figureraient": [
        "figurer"
    ],
    "figurerait": [
        "figurer"
    ],
    "figures": [
        "figure",
        "figurer"
    ],
    "figurez": [
        "figurer"
    ],
    "figuriez": [
        "figurer"
    ],
    "figurine": [
        "figurine"
    ],
    "figurines": [
        "figurine"
    ],
    "figurions": [
        "figurer"
    ],
    "figurat": [
        "figurer"
    ],
    "figurerent": [
        "figurer"
    ],
    "figuree": [
        "figure",
        "figurer"
    ],
    "figurees": [
        "figure",
        "figurer"
    ],
    "figerent": [
        "figer"
    ],
    "figee": [
        "figer",
        "fige"
    ],
    "figees": [
        "figer",
        "fige"
    ],
    "figes": [
        "figer",
        "fige"
    ],
    "fil": [
        "fil"
    ],
    "fila": [
        "filer"
    ],
    "filage": [
        "filage"
    ],
    "filai": [
        "filer"
    ],
    "filaient": [
        "filer"
    ],
    "filaire": [
        "filaire"
    ],
    "filais": [
        "filer"
    ],
    "filait": [
        "filer"
    ],
    "filament": [
        "filament"
    ],
    "filamenteux": [
        "filamenteux"
    ],
    "filaments": [
        "filament"
    ],
    "filandres": [
        "filandre"
    ],
    "filandreuse": [
        "filandreux"
    ],
    "filandreuses": [
        "filandreux"
    ],
    "filandreux": [
        "filandreux"
    ],
    "filant": [
        "filant",
        "filer"
    ],
    "filante": [
        "filant"
    ],
    "filantes": [
        "filant"
    ],
    "filaos": [
        "filao"
    ],
    "filariose": [
        "filariose"
    ],
    "filasse": [
        "filasse"
    ],
    "filasses": [
        "filasse"
    ],
    "filateur": [
        "filateur"
    ],
    "filateurs": [
        "filateur"
    ],
    "filature": [
        "filature"
    ],
    "filatures": [
        "filature"
    ],
    "file": [
        "file",
        "filer"
    ],
    "filent": [
        "filer"
    ],
    "filer": [
        "filer"
    ],
    "filera": [
        "filer"
    ],
    "filerai": [
        "filer"
    ],
    "fileraient": [
        "filer"
    ],
    "filerais": [
        "filer"
    ],
    "filerait": [
        "filer"
    ],
    "fileras": [
        "filer"
    ],
    "filerez": [
        "filer"
    ],
    "fileriez": [
        "filer"
    ],
    "filerons": [
        "filer"
    ],
    "fileront": [
        "filer"
    ],
    "files": [
        "file",
        "filer"
    ],
    "filet": [
        "filet"
    ],
    "filetage": [
        "filetage"
    ],
    "filets": [
        "filet"
    ],
    "filete": [
        "filete",
        "fileter"
    ],
    "filetee": [
        "filete",
        "fileter"
    ],
    "fileur": [
        "fileur"
    ],
    "fileuse": [
        "fileur"
    ],
    "filez": [
        "filer"
    ],
    "filial": [
        "filial"
    ],
    "filiale": [
        "filial",
        "filiale"
    ],
    "filialement": [
        "filialement"
    ],
    "filiales": [
        "filial",
        "filiale"
    ],
    "filiation": [
        "filiation"
    ],
    "filiations": [
        "filiation"
    ],
    "filiaux": [
        "filial"
    ],
    "filiez": [
        "filer"
    ],
    "filiforme": [
        "filiforme"
    ],
    "filiformes": [
        "filiforme"
    ],
    "filigrane": [
        "filigrane"
    ],
    "filigranes": [
        "filigrane",
        "filigraner"
    ],
    "filin": [
        "filin"
    ],
    "filins": [
        "filin"
    ],
    "filions": [
        "filer"
    ],
    "filioque": [
        "filioque"
    ],
    "filiere": [
        "filiere"
    ],
    "filieres": [
        "filiere"
    ],
    "fillasses": [
        "fillasse"
    ],
    "fille": [
        "fille"
    ],
    "filles": [
        "fille"
    ],
    "fillette": [
        "fillette"
    ],
    "fillettes": [
        "fillette"
    ],
    "filleul": [
        "filleul"
    ],
    "filleule": [
        "filleul"
    ],
    "filleuls": [
        "filleul"
    ],
    "filler": [
        "filler"
    ],
    "film": [
        "film"
    ],
    "filma": [
        "filmer"
    ],
    "filmage": [
        "filmage"
    ],
    "filmaient": [
        "filmer"
    ],
    "filmais": [
        "filmer"
    ],
    "filmait": [
        "filmer"
    ],
    "filmant": [
        "filmer"
    ],
    "filme": [
        "filmer"
    ],
    "filment": [
        "filmer"
    ],
    "filmer": [
        "filmer"
    ],
    "filmera": [
        "filmer"
    ],
    "filmerai": [
        "filmer"
    ],
    "filmerais": [
        "filmer"
    ],
    "filmerait": [
        "filmer"
    ],
    "filmerez": [
        "filmer"
    ],
    "filmeront": [
        "filmer"
    ],
    "filmes": [
        "filmer"
    ],
    "filmez": [
        "filmer"
    ],
    "filmiez": [
        "filmer"
    ],
    "filmions": [
        "filmer"
    ],
    "filmique": [
        "filmique"
    ],
    "filmographie": [
        "filmographie"
    ],
    "filmons": [
        "filmer"
    ],
    "filmotheque": [
        "filmotheque"
    ],
    "films": [
        "film"
    ],
    "filmee": [
        "filmer"
    ],
    "filmees": [
        "filmer"
    ],
    "filochard": [
        "filochard"
    ],
    "filoche": [
        "filocher",
        "filoche"
    ],
    "filocher": [
        "filocher"
    ],
    "filochez": [
        "filocher"
    ],
    "filoguide": [
        "filoguide"
    ],
    "filon": [
        "filon"
    ],
    "filons": [
        "filon",
        "filer"
    ],
    "filoselle": [
        "filoselle"
    ],
    "filou": [
        "filou"
    ],
    "filous": [
        "filou"
    ],
    "filouter": [
        "filouter"
    ],
    "filouterie": [
        "filouterie"
    ],
    "filouteries": [
        "filouterie"
    ],
    "filoutes": [
        "filouter"
    ],
    "filoute": [
        "filouter"
    ],
    "fils": [
        "fils",
        "fil"
    ],
    "filtra": [
        "filtrer"
    ],
    "filtrage": [
        "filtrage"
    ],
    "filtraient": [
        "filtrer"
    ],
    "filtrais": [
        "filtrer"
    ],
    "filtrait": [
        "filtrer"
    ],
    "filtrant": [
        "filtrant",
        "filtrer"
    ],
    "filtrantes": [
        "filtrant"
    ],
    "filtrants": [
        "filtrant"
    ],
    "filtration": [
        "filtration"
    ],
    "filtrations": [
        "filtration"
    ],
    "filtre": [
        "filtre",
        "filtrer"
    ],
    "filtrent": [
        "filtrer"
    ],
    "filtrer": [
        "filtrer"
    ],
    "filtrerait": [
        "filtrer"
    ],
    "filtres": [
        "filtre",
        "filtrer"
    ],
    "filtrez": [
        "filtrer"
    ],
    "filtrerent": [
        "filtrer"
    ],
    "filtree": [
        "filtrer"
    ],
    "filtrees": [
        "filtrer"
    ],
    "filames": [
        "filer"
    ],
    "filat": [
        "filer"
    ],
    "filerent": [
        "filer"
    ],
    "filee": [
        "file",
        "filer"
    ],
    "filees": [
        "filer"
    ],
    "fin": [
        "fin"
    ],
    "finage": [
        "finage"
    ],
    "final": [
        "final"
    ],
    "finale": [
        "finale",
        "final"
    ],
    "finalement": [
        "finalement"
    ],
    "finales": [
        "finale",
        "final"
    ],
    "finalisation": [
        "finalisation"
    ],
    "finaliser": [
        "finaliser"
    ],
    "finaliste": [
        "finaliste"
    ],
    "finalistes": [
        "finaliste"
    ],
    "finalise": [
        "finaliser"
    ],
    "finalisees": [
        "finaliser"
    ],
    "finalite": [
        "finalite"
    ],
    "finalites": [
        "finalite"
    ],
    "finals": [
        "final"
    ],
    "finance": [
        "finance",
        "financer"
    ],
    "financement": [
        "financement"
    ],
    "financements": [
        "financement"
    ],
    "financent": [
        "financer"
    ],
    "financer": [
        "financer"
    ],
    "financera": [
        "financer"
    ],
    "financerai": [
        "financer"
    ],
    "financeraient": [
        "financer"
    ],
    "financerait": [
        "financer"
    ],
    "financeras": [
        "financer"
    ],
    "financerons": [
        "financer"
    ],
    "financeront": [
        "financer"
    ],
    "finances": [
        "finance",
        "financer"
    ],
    "financez": [
        "financer"
    ],
    "financier": [
        "financier"
    ],
    "financiers": [
        "financier"
    ],
    "financiez": [
        "financer"
    ],
    "financiere": [
        "financier"
    ],
    "financierement": [
        "financierement"
    ],
    "financieres": [
        "financier"
    ],
    "financee": [
        "financer"
    ],
    "financai": [
        "financer"
    ],
    "financaient": [
        "financer"
    ],
    "financait": [
        "financer"
    ],
    "financant": [
        "financer"
    ],
    "financons": [
        "financer"
    ],
    "finassait": [
        "finasser"
    ],
    "finasse": [
        "finasser"
    ],
    "finasser": [
        "finasser"
    ],
    "finasserie": [
        "finasserie"
    ],
    "finasseries": [
        "finasserie"
    ],
    "finasses": [
        "finasser"
    ],
    "finassons": [
        "finasser"
    ],
    "finaud": [
        "finaud"
    ],
    "finaude": [
        "finaud"
    ],
    "finauds": [
        "finaud"
    ],
    "finaux": [
        "final"
    ],
    "fine": [
        "fin",
        "fine"
    ],
    "finement": [
        "finement"
    ],
    "fines": [
        "fin",
        "fine"
    ],
    "finesse": [
        "finesse"
    ],
    "finesses": [
        "finesse"
    ],
    "finet": [
        "finet"
    ],
    "finette": [
        "finette"
    ],
    "fini": [
        "fini",
        "finir"
    ],
    "finie": [
        "fini",
        "finir"
    ],
    "finies": [
        "fini",
        "finir"
    ],
    "finir": [
        "finir"
    ],
    "finira": [
        "finir"
    ],
    "finirai": [
        "finir"
    ],
    "finiraient": [
        "finir"
    ],
    "finirais": [
        "finir"
    ],
    "finirait": [
        "finir"
    ],
    "finiras": [
        "finir"
    ],
    "finirent": [
        "finir"
    ],
    "finirez": [
        "finir"
    ],
    "finiriez": [
        "finir"
    ],
    "finirions": [
        "finir"
    ],
    "finirons": [
        "finir"
    ],
    "finiront": [
        "finir"
    ],
    "finis": [
        "fini",
        "finir"
    ],
    "finish": [
        "finish"
    ],
    "finissaient": [
        "finir"
    ],
    "finissais": [
        "finir"
    ],
    "finissait": [
        "finir"
    ],
    "finissant": [
        "finissant",
        "finir"
    ],
    "finissante": [
        "finissant"
    ],
    "finissantes": [
        "finissant"
    ],
    "finissants": [
        "finissant"
    ],
    "finisse": [
        "finir"
    ],
    "finissent": [
        "finir"
    ],
    "finisses": [
        "finir"
    ],
    "finisseur": [
        "finisseur"
    ],
    "finisseuse": [
        "finisseur"
    ],
    "finissez": [
        "finir"
    ],
    "finissiez": [
        "finir"
    ],
    "finissions": [
        "finir"
    ],
    "finissons": [
        "finir"
    ],
    "finit": [
        "finir"
    ],
    "finition": [
        "finition"
    ],
    "finitions": [
        "finition"
    ],
    "finitude": [
        "finitude"
    ],
    "finlandais": [
        "finlandais"
    ],
    "finlandaise": [
        "finlandais"
    ],
    "finlandaises": [
        "finlandais"
    ],
    "finlandisation": [
        "finlandisation"
    ],
    "finnois": [
        "finnois"
    ],
    "fins": [
        "fin"
    ],
    "finimes": [
        "finir"
    ],
    "fiole": [
        "fiole"
    ],
    "fioles": [
        "fiole"
    ],
    "fion": [
        "fion"
    ],
    "fions": [
        "fion",
        "fier"
    ],
    "fiord": [
        "fiord"
    ],
    "fioriture": [
        "fioriture"
    ],
    "fioritures": [
        "fioriture"
    ],
    "fioul": [
        "fioul"
    ],
    "firent": [
        "faire"
    ],
    "firmament": [
        "firmament"
    ],
    "firmaments": [
        "firmament"
    ],
    "firman": [
        "firman"
    ],
    "firmans": [
        "firman"
    ],
    "firme": [
        "firme"
    ],
    "firmes": [
        "firme"
    ],
    "fis": [
        "faire"
    ],
    "fisc": [
        "fisc"
    ],
    "fiscal": [
        "fiscal"
    ],
    "fiscale": [
        "fiscal"
    ],
    "fiscalement": [
        "fiscalement"
    ],
    "fiscales": [
        "fiscal"
    ],
    "fiscaliste": [
        "fiscaliste"
    ],
    "fiscalite": [
        "fiscalite"
    ],
    "fiscaux": [
        "fiscal"
    ],
    "fissa": [
        "fissa"
    ],
    "fisse": [
        "faire"
    ],
    "fissent": [
        "faire"
    ],
    "fissible": [
        "fissible"
    ],
    "fissibles": [
        "fissible"
    ],
    "fissiez": [
        "faire"
    ],
    "fission": [
        "fission"
    ],
    "fissionner": [
        "fissionner"
    ],
    "fissionne": [
        "fissionner"
    ],
    "fissions": [
        "faire"
    ],
    "fissurait": [
        "fissurer"
    ],
    "fissurant": [
        "fissurer"
    ],
    "fissure": [
        "fissure",
        "fissurer"
    ],
    "fissurent": [
        "fissurer"
    ],
    "fissurer": [
        "fissurer"
    ],
    "fissures": [
        "fissure",
        "fissurer"
    ],
    "fissuree": [
        "fissurer"
    ],
    "fissurees": [
        "fissurer"
    ],
    "fiston": [
        "fiston"
    ],
    "fistons": [
        "fiston"
    ],
    "fistule": [
        "fistule"
    ],
    "fistules": [
        "fistule"
    ],
    "fit": [
        "faire"
    ],
    "fitness": [
        "fitness"
    ],
    "fitzgeraldiennes": [
        "fitzgeraldien"
    ],
    "fivete": [
        "fivete"
    ],
    "fixa": [
        "fixer"
    ],
    "fixage": [
        "fixage"
    ],
    "fixai": [
        "fixer"
    ],
    "fixaient": [
        "fixer"
    ],
    "fixais": [
        "fixer"
    ],
    "fixait": [
        "fixer"
    ],
    "fixant": [
        "fixer"
    ],
    "fixateur": [
        "fixateur"
    ],
    "fixatif": [
        "fixatif"
    ],
    "fixation": [
        "fixation"
    ],
    "fixations": [
        "fixation"
    ],
    "fixe": [
        "fixe",
        "fixer"
    ],
    "fixement": [
        "fixement"
    ],
    "fixent": [
        "fixer"
    ],
    "fixer": [
        "fixer"
    ],
    "fixera": [
        "fixer"
    ],
    "fixerai": [
        "fixer"
    ],
    "fixeraient": [
        "fixer"
    ],
    "fixerais": [
        "fixer"
    ],
    "fixerait": [
        "fixer"
    ],
    "fixeras": [
        "fixer"
    ],
    "fixerez": [
        "fixer"
    ],
    "fixeriez": [
        "fixer"
    ],
    "fixerons": [
        "fixer"
    ],
    "fixeront": [
        "fixer"
    ],
    "fixes": [
        "fix",
        "fixe",
        "fixer"
    ],
    "fixette": [
        "fixette"
    ],
    "fixez": [
        "fixer"
    ],
    "fixiez": [
        "fixer"
    ],
    "fixing": [
        "fix",
        "fixing"
    ],
    "fixions": [
        "fixer"
    ],
    "fixite": [
        "fixite"
    ],
    "fixons": [
        "fixer"
    ],
    "fixames": [
        "fixer"
    ],
    "fixat": [
        "fixer"
    ],
    "fixerent": [
        "fixer"
    ],
    "fixee": [
        "fixe",
        "fixer"
    ],
    "fixees": [
        "fixe",
        "fixer"
    ],
    "fiere": [
        "fier"
    ],
    "fierement": [
        "fierement"
    ],
    "fieres": [
        "fier"
    ],
    "fievre": [
        "fievre"
    ],
    "fievres": [
        "fievre"
    ],
    "fiee": [
        "fier"
    ],
    "fierot": [
        "fierot"
    ],
    "fierote": [
        "fierot"
    ],
    "fierots": [
        "fierot"
    ],
    "fies": [
        "fier"
    ],
    "fievreuse": [
        "fievreux"
    ],
    "fievreusement": [
        "fievreusement"
    ],
    "fievreuses": [
        "fievreux"
    ],
    "fievreux": [
        "fievreux"
    ],
    "fjord": [
        "fjord"
    ],
    "fjords": [
        "fjord"
    ],
    "fla": [
        "fla"
    ],
    "flac": [
        "flac"
    ],
    "flaccide": [
        "flaccide"
    ],
    "flaccidite": [
        "flaccidite"
    ],
    "flache": [
        "flache"
    ],
    "flaches": [
        "flache"
    ],
    "flacon": [
        "flacon"
    ],
    "flacons": [
        "flacon"
    ],
    "flafla": [
        "flafla"
    ],
    "flag": [
        "flag"
    ],
    "flagada": [
        "flagada"
    ],
    "flagella": [
        "flageller"
    ],
    "flagellaient": [
        "flageller"
    ],
    "flagellait": [
        "flageller"
    ],
    "flagellant": [
        "flagellant",
        "flageller"
    ],
    "flagellants": [
        "flagellant"
    ],
    "flagellateur": [
        "flagellateur"
    ],
    "flagellation": [
        "flagellation"
    ],
    "flagellations": [
        "flagellation"
    ],
    "flagelle": [
        "flagelle",
        "flageller"
    ],
    "flagellent": [
        "flageller"
    ],
    "flageller": [
        "flageller"
    ],
    "flagellerez": [
        "flageller"
    ],
    "flagelleront": [
        "flageller"
    ],
    "flagellee": [
        "flagelle",
        "flageller"
    ],
    "flagellees": [
        "flagelle",
        "flageller"
    ],
    "flagelles": [
        "flagelle",
        "flageller"
    ],
    "flageola": [
        "flageoler"
    ],
    "flageolai": [
        "flageoler"
    ],
    "flageolaient": [
        "flageoler"
    ],
    "flageolait": [
        "flageoler"
    ],
    "flageolant": [
        "flageoler",
        "flageolant"
    ],
    "flageolante": [
        "flageolant"
    ],
    "flageolantes": [
        "flageolant"
    ],
    "flageolants": [
        "flageolant"
    ],
    "flageole": [
        "flageoler"
    ],
    "flageolent": [
        "flageoler"
    ],
    "flageoler": [
        "flageoler"
    ],
    "flageoleront": [
        "flageoler"
    ],
    "flageolet": [
        "flageolet"
    ],
    "flageolets": [
        "flageolet"
    ],
    "flageolerent": [
        "flageoler"
    ],
    "flagornait": [
        "flagorner"
    ],
    "flagornent": [
        "flagorner"
    ],
    "flagorner": [
        "flagorner"
    ],
    "flagornerie": [
        "flagornerie"
    ],
    "flagorneries": [
        "flagornerie"
    ],
    "flagorneur": [
        "flagorneur"
    ],
    "flagorneurs": [
        "flagorneur"
    ],
    "flagorneuse": [
        "flagorneur"
    ],
    "flagrance": [
        "flagrance"
    ],
    "flagrant": [
        "flagrant"
    ],
    "flagrante": [
        "flagrant"
    ],
    "flagrantes": [
        "flagrant"
    ],
    "flagrants": [
        "flagrant"
    ],
    "flahutes": [
        "flahute"
    ],
    "flair": [
        "flair"
    ],
    "flaira": [
        "flairer"
    ],
    "flairaient": [
        "flairer"
    ],
    "flairais": [
        "flairer"
    ],
    "flairait": [
        "flairer"
    ],
    "flairant": [
        "flairer"
    ],
    "flaire": [
        "flairer"
    ],
    "flairent": [
        "flairer"
    ],
    "flairer": [
        "flairer"
    ],
    "flairera": [
        "flairer"
    ],
    "flairerait": [
        "flairer"
    ],
    "flaires": [
        "flairer"
    ],
    "flaireur": [
        "flaireur"
    ],
    "flaireurs": [
        "flaireur"
    ],
    "flaireuse": [
        "flaireur"
    ],
    "flairez": [
        "flairer"
    ],
    "flairee": [
        "flairer"
    ],
    "flamand": [
        "flamand"
    ],
    "flamande": [
        "flamand"
    ],
    "flamandes": [
        "flamand"
    ],
    "flamands": [
        "flamand"
    ],
    "flamant": [
        "flamant"
    ],
    "flamants": [
        "flamant"
    ],
    "flamba": [
        "flamber"
    ],
    "flambaient": [
        "flamber"
    ],
    "flambait": [
        "flamber"
    ],
    "flambant": [
        "flambant",
        "flamber"
    ],
    "flambante": [
        "flambant"
    ],
    "flambantes": [
        "flambant"
    ],
    "flambants": [
        "flambant"
    ],
    "flambard": [
        "flambard"
    ],
    "flambe": [
        "flamber",
        "flambe"
    ],
    "flambeau": [
        "flambeau"
    ],
    "flambeaux": [
        "flambeau"
    ],
    "flambent": [
        "flamber"
    ],
    "flamber": [
        "flamber"
    ],
    "flambera": [
        "flamber"
    ],
    "flamberaient": [
        "flamber"
    ],
    "flamberait": [
        "flamber"
    ],
    "flamberge": [
        "flamberge"
    ],
    "flamberont": [
        "flamber"
    ],
    "flambes": [
        "flamber",
        "flambe"
    ],
    "flambeur": [
        "flambeur"
    ],
    "flambeurs": [
        "flambeur"
    ],
    "flambeuse": [
        "flambeur"
    ],
    "flambez": [
        "flamber"
    ],
    "flamboie": [
        "flamboyer"
    ],
    "flamboiement": [
        "flamboiement"
    ],
    "flamboiements": [
        "flamboiement"
    ],
    "flamboient": [
        "flamboyer"
    ],
    "flamboierait": [
        "flamboyer"
    ],
    "flambons": [
        "flamber"
    ],
    "flamboya": [
        "flamboyer"
    ],
    "flamboyaient": [
        "flamboyer"
    ],
    "flamboyait": [
        "flamboyer"
    ],
    "flamboyance": [
        "flamboyance"
    ],
    "flamboyant": [
        "flamboyant",
        "flamboyer"
    ],
    "flamboyante": [
        "flamboyant"
    ],
    "flamboyantes": [
        "flamboyant"
    ],
    "flamboyants": [
        "flamboyant"
    ],
    "flamboyer": [
        "flamboyer"
    ],
    "flamboyerent": [
        "flamboyer"
    ],
    "flamberent": [
        "flamber"
    ],
    "flambee": [
        "flamber",
        "flambee"
    ],
    "flambees": [
        "flamber",
        "flambee"
    ],
    "flamenco": [
        "flamenco"
    ],
    "flamencos": [
        "flamenco"
    ],
    "flamine": [
        "flamine"
    ],
    "flamme": [
        "flamme"
    ],
    "flammes": [
        "flamme"
    ],
    "flammeche": [
        "flammeche"
    ],
    "flammeches": [
        "flammeche"
    ],
    "flammee": [
        "flamme"
    ],
    "flan": [
        "flan"
    ],
    "flanc": [
        "flanc"
    ],
    "flancha": [
        "flancher"
    ],
    "flanchais": [
        "flancher"
    ],
    "flanchait": [
        "flancher"
    ],
    "flanche": [
        "flancher"
    ],
    "flanchent": [
        "flancher"
    ],
    "flancher": [
        "flancher"
    ],
    "flanchera": [
        "flancher"
    ],
    "flancherai": [
        "flancher"
    ],
    "flancheraient": [
        "flancher"
    ],
    "flancherait": [
        "flancher"
    ],
    "flanchet": [
        "flanchet"
    ],
    "flancs": [
        "flanc"
    ],
    "flandrin": [
        "flandrin"
    ],
    "flanelle": [
        "flanelle"
    ],
    "flanelles": [
        "flanelle"
    ],
    "flanqua": [
        "flanquer"
    ],
    "flanquaient": [
        "flanquer"
    ],
    "flanquait": [
        "flanquer"
    ],
    "flanquant": [
        "flanquer"
    ],
    "flanque": [
        "flanquer"
    ],
    "flanquement": [
        "flanquement"
    ],
    "flanquent": [
        "flanquer"
    ],
    "flanquer": [
        "flanquer"
    ],
    "flanquera": [
        "flanquer"
    ],
    "flanquerai": [
        "flanquer"
    ],
    "flanqueraient": [
        "flanquer"
    ],
    "flanquerais": [
        "flanquer"
    ],
    "flanquerait": [
        "flanquer"
    ],
    "flanquerez": [
        "flanquer"
    ],
    "flanques": [
        "flanquer"
    ],
    "flanquez": [
        "flanquer"
    ],
    "flanquons": [
        "flanquer"
    ],
    "flanquee": [
        "flanquer"
    ],
    "flanquees": [
        "flanquer"
    ],
    "flans": [
        "flan"
    ],
    "flapi": [
        "flapi"
    ],
    "flapie": [
        "flapi"
    ],
    "flapies": [
        "flapi"
    ],
    "flapis": [
        "flapi"
    ],
    "flaque": [
        "flaque"
    ],
    "flaques": [
        "flaque"
    ],
    "flash": [
        "flash"
    ],
    "flashage": [
        "flashage"
    ],
    "flashaient": [
        "flasher"
    ],
    "flashant": [
        "flasher"
    ],
    "flashe": [
        "flasher"
    ],
    "flashent": [
        "flasher"
    ],
    "flasher": [
        "flash",
        "flasher"
    ],
    "flashes": [
        "flash",
        "flashe"
    ],
    "flasheur": [
        "flasheur"
    ],
    "flashs": [
        "flash"
    ],
    "flask": [
        "flask"
    ],
    "flasque": [
        "flasque"
    ],
    "flasques": [
        "flasque"
    ],
    "flat": [
        "flat"
    ],
    "flats": [
        "flat"
    ],
    "flatta": [
        "flatter"
    ],
    "flattai": [
        "flatter"
    ],
    "flattaient": [
        "flatter"
    ],
    "flattais": [
        "flatter"
    ],
    "flattait": [
        "flatter"
    ],
    "flattant": [
        "flatter"
    ],
    "flattasse": [
        "flatter"
    ],
    "flattassent": [
        "flatter"
    ],
    "flatte": [
        "flatter"
    ],
    "flattent": [
        "flatter"
    ],
    "flatter": [
        "flat",
        "flatter"
    ],
    "flatteras": [
        "flatter"
    ],
    "flatterie": [
        "flatterie"
    ],
    "flatteries": [
        "flattery",
        "flatterie"
    ],
    "flatteront": [
        "flatter"
    ],
    "flattes": [
        "flatter"
    ],
    "flatteur": [
        "flatteur"
    ],
    "flatteurs": [
        "flatteur"
    ],
    "flatteuse": [
        "flatteur"
    ],
    "flatteuses": [
        "flatteur"
    ],
    "flattez": [
        "flatter"
    ],
    "flattions": [
        "flatter"
    ],
    "flattons": [
        "flatter"
    ],
    "flatterent": [
        "flatter"
    ],
    "flattee": [
        "flatter"
    ],
    "flattees": [
        "flatter"
    ],
    "flatulence": [
        "flatulence"
    ],
    "flatulences": [
        "flatulence"
    ],
    "flatulent": [
        "flatulent"
    ],
    "flatulents": [
        "flatulent"
    ],
    "flatuosite": [
        "flatuosite"
    ],
    "flave": [
        "flave"
    ],
    "flaveur": [
        "flaveur"
    ],
    "flegmatique": [
        "flegmatique"
    ],
    "flegmatiquement": [
        "flegmatiquement"
    ],
    "flegmatiques": [
        "flegmatique"
    ],
    "flegmatisme": [
        "flegmatisme"
    ],
    "flegme": [
        "flegme"
    ],
    "flemmard": [
        "flemmard"
    ],
    "flemmardais": [
        "flemmarder"
    ],
    "flemmardant": [
        "flemmarder"
    ],
    "flemmarde": [
        "flemmard",
        "flemmarder"
    ],
    "flemmarder": [
        "flemmarder"
    ],
    "flemmardes": [
        "flemmard",
        "flemmarder"
    ],
    "flemmardise": [
        "flemmardise"
    ],
    "flemmards": [
        "flemmard"
    ],
    "flemme": [
        "flemme"
    ],
    "flemmer": [
        "flemmer"
    ],
    "fleur": [
        "fleur"
    ],
    "fleurage": [
        "fleurage"
    ],
    "fleuraient": [
        "fleurer"
    ],
    "fleurais": [
        "fleurer"
    ],
    "fleurait": [
        "fleurer"
    ],
    "fleurant": [
        "fleurer"
    ],
    "fleurdelise": [
        "fleurdelise"
    ],
    "fleurdelisee": [
        "fleurdeliser",
        "fleurdelise"
    ],
    "fleurdelises": [
        "fleurdelise"
    ],
    "fleure": [
        "fleurer"
    ],
    "fleurent": [
        "fleurer"
    ],
    "fleurer": [
        "fleurer"
    ],
    "fleuret": [
        "fleuret"
    ],
    "fleuretais": [
        "fleureter"
    ],
    "fleuretait": [
        "fleureter"
    ],
    "fleurets": [
        "fleuret"
    ],
    "fleurette": [
        "fleurette"
    ],
    "fleurettes": [
        "fleurette"
    ],
    "fleuri": [
        "fleurir",
        "fleuri"
    ],
    "fleurie": [
        "fleurir",
        "fleuri"
    ],
    "fleuries": [
        "fleurir",
        "fleuri"
    ],
    "fleurir": [
        "fleurir"
    ],
    "fleurira": [
        "fleurir"
    ],
    "fleuriraient": [
        "fleurir"
    ],
    "fleurirent": [
        "fleurir"
    ],
    "fleuriront": [
        "fleurir"
    ],
    "fleuris": [
        "fleurir",
        "fleuri"
    ],
    "fleurissaient": [
        "fleurir"
    ],
    "fleurissait": [
        "fleurir"
    ],
    "fleurissant": [
        "fleurir",
        "fleurissant"
    ],
    "fleurisse": [
        "fleurir"
    ],
    "fleurissement": [
        "fleurissement"
    ],
    "fleurissent": [
        "fleurir"
    ],
    "fleurissiez": [
        "fleurir"
    ],
    "fleurissons": [
        "fleurir"
    ],
    "fleuriste": [
        "fleuriste"
    ],
    "fleuristes": [
        "fleuriste"
    ],
    "fleurit": [
        "fleurir"
    ],
    "fleuron": [
        "fleuron"
    ],
    "fleuronner": [
        "fleuronner"
    ],
    "fleuronnee": [
        "fleuronne"
    ],
    "fleurons": [
        "fleuron"
    ],
    "fleurs": [
        "fleur"
    ],
    "fleuve": [
        "fleuve"
    ],
    "fleuves": [
        "fleuve"
    ],
    "flexibilite": [
        "flexibilite"
    ],
    "flexible": [
        "flexible"
    ],
    "flexibles": [
        "flexible"
    ],
    "flexion": [
        "flexion"
    ],
    "flexions": [
        "flexion"
    ],
    "flexuosite": [
        "flexuosite"
    ],
    "flibuste": [
        "flibuste"
    ],
    "flibustier": [
        "flibustier"
    ],
    "flibustiers": [
        "flibustier"
    ],
    "flic": [
        "flic"
    ],
    "flicage": [
        "flicage"
    ],
    "flicaille": [
        "flicaille"
    ],
    "flicailles": [
        "flicaille"
    ],
    "flicard": [
        "flicard"
    ],
    "flicarde": [
        "flicard"
    ],
    "flicardes": [
        "flicard"
    ],
    "flicards": [
        "flicard"
    ],
    "flics": [
        "flic"
    ],
    "flingage": [
        "flingage"
    ],
    "flingot": [
        "flingot"
    ],
    "flingots": [
        "flingot"
    ],
    "flingote": [
        "flingoter"
    ],
    "flinguait": [
        "flinguer"
    ],
    "flinguant": [
        "flinguer"
    ],
    "flingue": [
        "flinguer",
        "flingue"
    ],
    "flinguent": [
        "flinguer"
    ],
    "flinguer": [
        "flinguer"
    ],
    "flinguera": [
        "flinguer"
    ],
    "flinguerai": [
        "flinguer"
    ],
    "flingueraient": [
        "flinguer"
    ],
    "flinguerais": [
        "flinguer"
    ],
    "flingueront": [
        "flinguer"
    ],
    "flingues": [
        "flinguer",
        "flingue"
    ],
    "flingueur": [
        "flingueur"
    ],
    "flingueurs": [
        "flingueur"
    ],
    "flingueuse": [
        "flingueur"
    ],
    "flingueuses": [
        "flingueur"
    ],
    "flinguez": [
        "flinguer"
    ],
    "flinguons": [
        "flinguer"
    ],
    "flinguat": [
        "flinguer"
    ],
    "flinguee": [
        "flinguer"
    ],
    "flint": [
        "flint"
    ],
    "flip": [
        "flip"
    ],
    "flippais": [
        "flipper"
    ],
    "flippait": [
        "flipper"
    ],
    "flippant": [
        "flipper"
    ],
    "flippe": [
        "flippe",
        "flipper"
    ],
    "flippent": [
        "flipper"
    ],
    "flipper": [
        "flipper"
    ],
    "flipperais": [
        "flipper"
    ],
    "flipperait": [
        "flipper"
    ],
    "flipperont": [
        "flipper"
    ],
    "flippers": [
        "flipper"
    ],
    "flippes": [
        "flippe",
        "flipper"
    ],
    "flippee": [
        "flippe",
        "flipper"
    ],
    "flips": [
        "flip"
    ],
    "fliquer": [
        "fliquer"
    ],
    "fliquesse": [
        "fliquesse"
    ],
    "flique": [
        "flique"
    ],
    "fliques": [
        "flique"
    ],
    "flirt": [
        "flirt"
    ],
    "flirta": [
        "flirter"
    ],
    "flirtaient": [
        "flirter"
    ],
    "flirtais": [
        "flirter"
    ],
    "flirtait": [
        "flirter"
    ],
    "flirtant": [
        "flirter"
    ],
    "flirtation": [
        "flirtation"
    ],
    "flirte": [
        "flirter"
    ],
    "flirtent": [
        "flirter"
    ],
    "flirter": [
        "flirter"
    ],
    "flirteront": [
        "flirter"
    ],
    "flirtes": [
        "flirter"
    ],
    "flirteur": [
        "flirteur"
    ],
    "flirteuse": [
        "flirteur"
    ],
    "flirteuses": [
        "flirteur"
    ],
    "flirtez": [
        "flirter"
    ],
    "flirtiez": [
        "flirter"
    ],
    "flirtons": [
        "flirter"
    ],
    "flirts": [
        "flirt"
    ],
    "flirterent": [
        "flirter"
    ],
    "floc": [
        "floc"
    ],
    "floche": [
        "floche"
    ],
    "floches": [
        "floche"
    ],
    "flocon": [
        "flocon"
    ],
    "floconne": [
        "floconner"
    ],
    "floconnent": [
        "floconner"
    ],
    "floconneuse": [
        "floconneux"
    ],
    "floconneuses": [
        "floconneux"
    ],
    "floconneux": [
        "floconneux"
    ],
    "flocons": [
        "flocon"
    ],
    "floculation": [
        "floculation"
    ],
    "floculent": [
        "floculer"
    ],
    "flonflon": [
        "flonflon"
    ],
    "flonflons": [
        "flonflon"
    ],
    "flood": [
        "flood"
    ],
    "flop": [
        "flop"
    ],
    "flops": [
        "flop"
    ],
    "flopee": [
        "flopee"
    ],
    "flopees": [
        "flopee"
    ],
    "floraison": [
        "floraison"
    ],
    "floraisons": [
        "floraison"
    ],
    "floral": [
        "floral"
    ],
    "florale": [
        "floral"
    ],
    "florales": [
        "floral"
    ],
    "floralies": [
        "floralies"
    ],
    "floraux": [
        "floral"
    ],
    "flore": [
        "flore"
    ],
    "florence": [
        "florence"
    ],
    "florentin": [
        "florentin"
    ],
    "florentine": [
        "florentin"
    ],
    "florentines": [
        "florentine",
        "florentin"
    ],
    "florentins": [
        "florentin"
    ],
    "flores": [
        "flore",
        "flores"
    ],
    "florilege": [
        "florilege"
    ],
    "florin": [
        "florin"
    ],
    "florins": [
        "florin"
    ],
    "florissaient": [
        "florissaient"
    ],
    "florissait": [
        "florissait"
    ],
    "florissant": [
        "florissant",
        "florir"
    ],
    "florissante": [
        "florissant"
    ],
    "florissantes": [
        "florissant"
    ],
    "florissants": [
        "florissant"
    ],
    "floreal": [
        "floreal"
    ],
    "flot": [
        "flot"
    ],
    "flots": [
        "flot"
    ],
    "flotta": [
        "flotter"
    ],
    "flottabilite": [
        "flottabilite"
    ],
    "flottage": [
        "flottage"
    ],
    "flottaient": [
        "flotter"
    ],
    "flottais": [
        "flotter"
    ],
    "flottaison": [
        "flottaison"
    ],
    "flottaisons": [
        "flottaison"
    ],
    "flottait": [
        "flotter"
    ],
    "flottant": [
        "flotter",
        "flottant"
    ],
    "flottante": [
        "flottant"
    ],
    "flottantes": [
        "flottant"
    ],
    "flottants": [
        "flottant"
    ],
    "flottation": [
        "flottation"
    ],
    "flotte": [
        "flotter",
        "flotte"
    ],
    "flottement": [
        "flottement"
    ],
    "flottements": [
        "flottement"
    ],
    "flottent": [
        "flotter"
    ],
    "flotter": [
        "flotter"
    ],
    "flottera": [
        "flotter"
    ],
    "flotteraient": [
        "flotter"
    ],
    "flotterait": [
        "flotter"
    ],
    "flotteras": [
        "flotter"
    ],
    "flotterez": [
        "flotter"
    ],
    "flotteront": [
        "flotter"
    ],
    "flottes": [
        "flotter",
        "flotte"
    ],
    "flotteur": [
        "flotteur"
    ],
    "flotteurs": [
        "flotteur"
    ],
    "flottez": [
        "flotter"
    ],
    "flottiez": [
        "flotter"
    ],
    "flottille": [
        "flottille"
    ],
    "flottilles": [
        "flottille"
    ],
    "flottions": [
        "flotter"
    ],
    "flottat": [
        "flotter"
    ],
    "flotterent": [
        "flotter"
    ],
    "flottee": [
        "flotter"
    ],
    "flottees": [
        "flotter"
    ],
    "flou": [
        "flou"
    ],
    "flouant": [
        "flouer"
    ],
    "floue": [
        "flouer",
        "flou"
    ],
    "flouer": [
        "flouer"
    ],
    "flouerie": [
        "flouerie"
    ],
    "floues": [
        "flouer",
        "flou"
    ],
    "flous": [
        "flou"
    ],
    "flouse": [
        "flouse"
    ],
    "flouve": [
        "flouve"
    ],
    "flouzaille": [
        "flouzaille"
    ],
    "flouze": [
        "flouze"
    ],
    "flouee": [
        "flouer"
    ],
    "fluaient": [
        "fluer"
    ],
    "fluait": [
        "fluer"
    ],
    "flubes": [
        "fluber"
    ],
    "fluctuait": [
        "fluctuer"
    ],
    "fluctuant": [
        "fluctuant"
    ],
    "fluctuante": [
        "fluctuant"
    ],
    "fluctuation": [
        "fluctuation"
    ],
    "fluctuations": [
        "fluctuation"
    ],
    "fluctue": [
        "fluctuer"
    ],
    "fluctuent": [
        "fluctuer"
    ],
    "fluctuer": [
        "fluctuer"
    ],
    "fluctuerait": [
        "fluctuer"
    ],
    "fluence": [
        "fluence"
    ],
    "fluet": [
        "fluet"
    ],
    "fluets": [
        "fluet"
    ],
    "fluette": [
        "fluet"
    ],
    "fluettes": [
        "fluet"
    ],
    "fluide": [
        "fluide"
    ],
    "fluidement": [
        "fluidement"
    ],
    "fluides": [
        "fluide"
    ],
    "fluidifiant": [
        "fluidifiant"
    ],
    "fluidifier": [
        "fluidifier"
    ],
    "fluidifie": [
        "fluidifier"
    ],
    "fluidiques": [
        "fluidique"
    ],
    "fluidite": [
        "fluidite"
    ],
    "fluo": [
        "fluo"
    ],
    "fluor": [
        "fluor"
    ],
    "fluorescence": [
        "fluorescence"
    ],
    "fluorescent": [
        "fluorescent"
    ],
    "fluorescente": [
        "fluorescent"
    ],
    "fluorescentes": [
        "fluorescent"
    ],
    "fluorescents": [
        "fluorescent"
    ],
    "fluoresceine": [
        "fluoresceine"
    ],
    "fluorhydrique": [
        "fluorhydrique"
    ],
    "fluorite": [
        "fluorite"
    ],
    "fluorure": [
        "fluorure"
    ],
    "fluoree": [
        "fluore"
    ],
    "flush": [
        "flush"
    ],
    "fluvial": [
        "fluvial"
    ],
    "fluviale": [
        "fluvial"
    ],
    "fluviales": [
        "fluvial"
    ],
    "fluviatile": [
        "fluviatile"
    ],
    "fluviaux": [
        "fluvial"
    ],
    "flux": [
        "flux"
    ],
    "fluxe": [
        "fluxer"
    ],
    "fluxion": [
        "fluxion"
    ],
    "flana": [
        "flaner"
    ],
    "flanai": [
        "flaner"
    ],
    "flanaient": [
        "flaner"
    ],
    "flanais": [
        "flaner"
    ],
    "flanait": [
        "flaner"
    ],
    "flanant": [
        "flaner"
    ],
    "flane": [
        "flane",
        "flaner"
    ],
    "flanent": [
        "flaner"
    ],
    "flaner": [
        "flaner"
    ],
    "flanera": [
        "flaner"
    ],
    "flanerais": [
        "flaner"
    ],
    "flanerait": [
        "flaner"
    ],
    "flanerie": [
        "flanerie"
    ],
    "flaneries": [
        "flanerie"
    ],
    "flaneront": [
        "flaner"
    ],
    "flaneur": [
        "flaneur"
    ],
    "flaneurs": [
        "flaneur"
    ],
    "flaneuse": [
        "flaneuse",
        "flaneur"
    ],
    "flaneuses": [
        "flaneur"
    ],
    "flanions": [
        "flaner"
    ],
    "flanochent": [
        "flanocher"
    ],
    "flanocher": [
        "flanocher"
    ],
    "flanons": [
        "flaner"
    ],
    "fleche": [
        "fleche",
        "flecher"
    ],
    "fleches": [
        "fleche",
        "flecher"
    ],
    "fleau": [
        "fleau"
    ],
    "fleaux": [
        "fleau"
    ],
    "flecher": [
        "flecher"
    ],
    "flechette": [
        "flechette"
    ],
    "flechettes": [
        "flechette"
    ],
    "flechi": [
        "flechir"
    ],
    "flechie": [
        "flechir"
    ],
    "flechies": [
        "flechir"
    ],
    "flechir": [
        "flechir"
    ],
    "flechiraient": [
        "flechir"
    ],
    "flechirait": [
        "flechir"
    ],
    "flechirent": [
        "flechir"
    ],
    "flechis": [
        "flechir"
    ],
    "flechissaient": [
        "flechir"
    ],
    "flechissais": [
        "flechir"
    ],
    "flechissait": [
        "flechir"
    ],
    "flechissant": [
        "flechir"
    ],
    "flechisse": [
        "flechir"
    ],
    "flechissement": [
        "flechissement"
    ],
    "flechissements": [
        "flechissement"
    ],
    "flechissent": [
        "flechir"
    ],
    "flechisseur": [
        "flechisseur"
    ],
    "flechissez": [
        "flechir"
    ],
    "flechissions": [
        "flechir"
    ],
    "flechissons": [
        "flechir"
    ],
    "flechit": [
        "flechir"
    ],
    "flechee": [
        "fleche",
        "flecher"
    ],
    "flechees": [
        "fleche",
        "flecher"
    ],
    "fleole": [
        "fleole"
    ],
    "fletan": [
        "fletan"
    ],
    "fletans": [
        "fletan"
    ],
    "fletri": [
        "fletrir"
    ],
    "fletrie": [
        "fletrir"
    ],
    "fletries": [
        "fletrir"
    ],
    "fletrir": [
        "fletrir"
    ],
    "fletrira": [
        "fletrir"
    ],
    "fletrirai": [
        "fletrir"
    ],
    "fletrirent": [
        "fletrir"
    ],
    "fletriront": [
        "fletrir"
    ],
    "fletris": [
        "fletrir"
    ],
    "fletrissaient": [
        "fletrir"
    ],
    "fletrissait": [
        "fletrir"
    ],
    "fletrissant": [
        "fletrissant"
    ],
    "fletrissement": [
        "fletrissement"
    ],
    "fletrissent": [
        "fletrir"
    ],
    "fletrissure": [
        "fletrissure"
    ],
    "fletrissures": [
        "fletrissure"
    ],
    "fletrit": [
        "fletrir"
    ],
    "fluta": [
        "fluter"
    ],
    "flute": [
        "flute"
    ],
    "fluter": [
        "fluter"
    ],
    "flutes": [
        "flute"
    ],
    "flutiau": [
        "flutiau"
    ],
    "flutiste": [
        "flutiste"
    ],
    "flutistes": [
        "flutiste"
    ],
    "flutee": [
        "flute",
        "fluter"
    ],
    "foc": [
        "foc"
    ],
    "focal": [
        "focal"
    ],
    "focale": [
        "focale",
        "focal"
    ],
    "focales": [
        "focal"
    ],
    "focalisation": [
        "focalisation"
    ],
    "focalise": [
        "focaliser"
    ],
    "focaliser": [
        "focaliser"
    ],
    "focalisez": [
        "focaliser"
    ],
    "focalisons": [
        "focaliser"
    ],
    "focalises": [
        "focaliser"
    ],
    "focaux": [
        "focal"
    ],
    "focs": [
        "foc"
    ],
    "foehn": [
        "foehn"
    ],
    "foetal": [
        "foetal"
    ],
    "foetale": [
        "foetal"
    ],
    "foetales": [
        "foetal"
    ],
    "foetaux": [
        "foetal"
    ],
    "foetus": [
        "foetus"
    ],
    "fofolle": [
        "fofolle"
    ],
    "fofolles": [
        "fofolle"
    ],
    "foi": [
        "foi"
    ],
    "foie": [
        "foie"
    ],
    "foies": [
        "foie"
    ],
    "foil": [
        "foil"
    ],
    "foin": [
        "foin"
    ],
    "foins": [
        "foin"
    ],
    "foira": [
        "foirer"
    ],
    "foirade": [
        "foirade"
    ],
    "foirades": [
        "foirade"
    ],
    "foiraient": [
        "foirer"
    ],
    "foirail": [
        "foirail"
    ],
    "foirails": [
        "foirail"
    ],
    "foirais": [
        "foirer"
    ],
    "foirait": [
        "foirer"
    ],
    "foire": [
        "foirer",
        "foire"
    ],
    "foirent": [
        "foirer"
    ],
    "foirer": [
        "foirer"
    ],
    "foirera": [
        "foirer"
    ],
    "foires": [
        "foirer",
        "foire"
    ],
    "foireuse": [
        "foireux"
    ],
    "foireuses": [
        "foireux"
    ],
    "foireux": [
        "foireux"
    ],
    "foirez": [
        "foirer"
    ],
    "foiridon": [
        "foiridon"
    ],
    "foiree": [
        "foirer"
    ],
    "foirees": [
        "foirer"
    ],
    "fois": [
        "fois"
    ],
    "foison": [
        "foison"
    ],
    "foisonnaient": [
        "foisonner"
    ],
    "foisonnait": [
        "foisonner"
    ],
    "foisonnant": [
        "foisonner",
        "foisonnant"
    ],
    "foisonnante": [
        "foisonnant"
    ],
    "foisonnantes": [
        "foisonnant"
    ],
    "foisonne": [
        "foisonner"
    ],
    "foisonnement": [
        "foisonnement"
    ],
    "foisonnent": [
        "foisonner"
    ],
    "foisonner": [
        "foisonner"
    ],
    "foisonneraient": [
        "foisonner"
    ],
    "foisonneront": [
        "foisonner"
    ],
    "fol": [
        "fol"
    ],
    "folasse": [
        "folasse"
    ],
    "foldingue": [
        "foldingue"
    ],
    "foldingues": [
        "foldingue"
    ],
    "foliacee": [
        "foliace"
    ],
    "folichon": [
        "folichon"
    ],
    "folichonnait": [
        "folichonner"
    ],
    "folichonne": [
        "folichonner",
        "folichon"
    ],
    "folichonneries": [
        "folichonnerie"
    ],
    "folichonnes": [
        "folichon"
    ],
    "folie": [
        "folie"
    ],
    "folies": [
        "folie"
    ],
    "folingue": [
        "folingue"
    ],
    "folingues": [
        "folingue"
    ],
    "folio": [
        "folio"
    ],
    "folioles": [
        "foliole"
    ],
    "folios": [
        "folio"
    ],
    "folique": [
        "folique"
    ],
    "folk": [
        "folk"
    ],
    "folklo": [
        "folklo"
    ],
    "folklore": [
        "folklore"
    ],
    "folklores": [
        "folklore"
    ],
    "folklorique": [
        "folklorique"
    ],
    "folkloriques": [
        "folklorique"
    ],
    "folkloriste": [
        "folkloriste"
    ],
    "folkloristes": [
        "folkloriste"
    ],
    "folks": [
        "folk"
    ],
    "folle": [
        "fou"
    ],
    "folledingue": [
        "folledingue"
    ],
    "follement": [
        "follement"
    ],
    "folles": [
        "fou"
    ],
    "follet": [
        "follet"
    ],
    "follets": [
        "follet"
    ],
    "follette": [
        "follet"
    ],
    "follettes": [
        "follet"
    ],
    "folliculaire": [
        "folliculaire"
    ],
    "folliculaires": [
        "folliculaire"
    ],
    "follicule": [
        "follicule"
    ],
    "follicules": [
        "follicule"
    ],
    "folliculite": [
        "folliculite"
    ],
    "follingue": [
        "follingue"
    ],
    "fols": [
        "fol"
    ],
    "folatraient": [
        "folatrer"
    ],
    "folatrait": [
        "folatrer"
    ],
    "folatre": [
        "folatrer",
        "folatre"
    ],
    "folatrent": [
        "folatrer"
    ],
    "folatrer": [
        "folatrer"
    ],
    "folatreries": [
        "folatrerie"
    ],
    "folatres": [
        "folatre"
    ],
    "fomentaient": [
        "fomenter"
    ],
    "fomentait": [
        "fomenter"
    ],
    "fomentateurs": [
        "fomentateur"
    ],
    "fomente": [
        "fomenter"
    ],
    "fomentent": [
        "fomenter"
    ],
    "fomenter": [
        "fomenter"
    ],
    "fomentee": [
        "fomenter"
    ],
    "fonce": [
        "foncer",
        "fonce"
    ],
    "foncent": [
        "foncer"
    ],
    "foncer": [
        "foncer"
    ],
    "foncera": [
        "foncer"
    ],
    "foncerai": [
        "foncer"
    ],
    "fonceraient": [
        "foncer"
    ],
    "foncerais": [
        "foncer"
    ],
    "foncerait": [
        "foncer"
    ],
    "foncerons": [
        "foncer"
    ],
    "fonceront": [
        "foncer"
    ],
    "fonces": [
        "foncer",
        "fonce"
    ],
    "fonceur": [
        "fonceur"
    ],
    "fonceurs": [
        "fonceur"
    ],
    "fonceuse": [
        "fonceur"
    ],
    "foncez": [
        "foncer"
    ],
    "foncier": [
        "foncier"
    ],
    "fonciers": [
        "foncier"
    ],
    "fonciez": [
        "foncer"
    ],
    "foncions": [
        "foncer"
    ],
    "fonciere": [
        "foncier"
    ],
    "foncierement": [
        "foncierement"
    ],
    "foncieres": [
        "foncier"
    ],
    "foncteur": [
        "foncteur"
    ],
    "fonction": [
        "fonction"
    ],
    "fonctionna": [
        "fonctionner"
    ],
    "fonctionnaient": [
        "fonctionner"
    ],
    "fonctionnaire": [
        "fonctionnaire"
    ],
    "fonctionnaires": [
        "fonctionnaire"
    ],
    "fonctionnais": [
        "fonctionner"
    ],
    "fonctionnait": [
        "fonctionner"
    ],
    "fonctionnaliste": [
        "fonctionnaliste"
    ],
    "fonctionnalite": [
        "fonctionnalite"
    ],
    "fonctionnant": [
        "fonctionner"
    ],
    "fonctionnarise": [
        "fonctionnariser"
    ],
    "fonctionnarisee": [
        "fonctionnariser"
    ],
    "fonctionnassent": [
        "fonctionner"
    ],
    "fonctionne": [
        "fonctionner"
    ],
    "fonctionnel": [
        "fonctionnel"
    ],
    "fonctionnelle": [
        "fonctionnel"
    ],
    "fonctionnellement": [
        "fonctionnellement"
    ],
    "fonctionnelles": [
        "fonctionnel"
    ],
    "fonctionnels": [
        "fonctionnel"
    ],
    "fonctionnement": [
        "fonctionnement"
    ],
    "fonctionnent": [
        "fonctionner"
    ],
    "fonctionner": [
        "fonctionner"
    ],
    "fonctionnera": [
        "fonctionner"
    ],
    "fonctionneraient": [
        "fonctionner"
    ],
    "fonctionnerait": [
        "fonctionner"
    ],
    "fonctionneront": [
        "fonctionner"
    ],
    "fonctionnes": [
        "fonctionner"
    ],
    "fonctionnez": [
        "fonctionner"
    ],
    "fonctionnons": [
        "fonctionner"
    ],
    "fonctionnat": [
        "fonctionner"
    ],
    "fonctions": [
        "fonction"
    ],
    "foncerent": [
        "foncer"
    ],
    "foncee": [
        "foncer",
        "fonce"
    ],
    "foncees": [
        "foncer",
        "fonce"
    ],
    "fond": [
        "fond",
        "fondre"
    ],
    "fonda": [
        "fonder"
    ],
    "fondaient": [
        "fonder"
    ],
    "fondais": [
        "fonder"
    ],
    "fondait": [
        "fonder"
    ],
    "fondamental": [
        "fondamental"
    ],
    "fondamentale": [
        "fondamental"
    ],
    "fondamentalement": [
        "fondamentalement"
    ],
    "fondamentales": [
        "fondamental"
    ],
    "fondamentalisme": [
        "fondamentalisme"
    ],
    "fondamentaliste": [
        "fondamentaliste"
    ],
    "fondamentalistes": [
        "fondamentaliste"
    ],
    "fondamentaux": [
        "fondamental"
    ],
    "fondant": [
        "fonder",
        "fondant"
    ],
    "fondante": [
        "fondant"
    ],
    "fondantes": [
        "fondant"
    ],
    "fondants": [
        "fondant"
    ],
    "fondateur": [
        "fondateur"
    ],
    "fondateurs": [
        "fondateur"
    ],
    "fondation": [
        "fondation"
    ],
    "fondations": [
        "fondation"
    ],
    "fondatrice": [
        "fondateur"
    ],
    "fondatrices": [
        "fondateur"
    ],
    "fonde": [
        "fonder",
        "fonde"
    ],
    "fondement": [
        "fondement"
    ],
    "fondements": [
        "fondement"
    ],
    "fondent": [
        "fonder"
    ],
    "fonder": [
        "fond",
        "fonder"
    ],
    "fondera": [
        "fonder"
    ],
    "fonderais": [
        "fonder"
    ],
    "fonderait": [
        "fonder"
    ],
    "fonderez": [
        "fonder"
    ],
    "fonderie": [
        "fonderie"
    ],
    "fonderies": [
        "fonderie"
    ],
    "fonderons": [
        "fonder"
    ],
    "fonderont": [
        "fonder"
    ],
    "fondeur": [
        "fondeur"
    ],
    "fondez": [
        "fonder"
    ],
    "fondions": [
        "fonder"
    ],
    "fondirent": [
        "fondre"
    ],
    "fondis": [
        "fondre"
    ],
    "fondit": [
        "fondre"
    ],
    "fondons": [
        "fonder"
    ],
    "fondouk": [
        "fondouk"
    ],
    "fondra": [
        "fondre"
    ],
    "fondrai": [
        "fondre"
    ],
    "fondraient": [
        "fondre"
    ],
    "fondrait": [
        "fondre"
    ],
    "fondras": [
        "fondre"
    ],
    "fondre": [
        "fondre"
    ],
    "fondriez": [
        "fondre"
    ],
    "fondriere": [
        "fondriere"
    ],
    "fondrieres": [
        "fondriere"
    ],
    "fonds": [
        "fond",
        "fonds",
        "fondre"
    ],
    "fondu": [
        "fondu",
        "fondre"
    ],
    "fondue": [
        "fondre",
        "fondue"
    ],
    "fondues": [
        "fondre",
        "fondue"
    ],
    "fondus": [
        "fondu",
        "fondre"
    ],
    "fondat": [
        "fonder"
    ],
    "fonderent": [
        "fonder"
    ],
    "fondee": [
        "fonder",
        "fonde"
    ],
    "fondees": [
        "fonder",
        "fonde"
    ],
    "fondes": [
        "fonder",
        "fonde"
    ],
    "fongible": [
        "fongible"
    ],
    "fongicide": [
        "fongicide"
    ],
    "fongique": [
        "fongique"
    ],
    "fongueuse": [
        "fongueux"
    ],
    "fongueuses": [
        "fongueux"
    ],
    "fongus": [
        "fongus"
    ],
    "font": [
        "faire"
    ],
    "fontaine": [
        "fontaine"
    ],
    "fontaines": [
        "fontaine"
    ],
    "fontainette": [
        "fontainette"
    ],
    "fontainier": [
        "fontainier"
    ],
    "fontanelle": [
        "fontanelle",
        "fontanel"
    ],
    "fonte": [
        "fonte"
    ],
    "fontes": [
        "fonte"
    ],
    "fonts": [
        "fonts",
        "font"
    ],
    "fonca": [
        "foncer"
    ],
    "foncai": [
        "foncer"
    ],
    "foncaient": [
        "foncer"
    ],
    "foncais": [
        "foncer"
    ],
    "foncait": [
        "foncer"
    ],
    "foncant": [
        "foncer"
    ],
    "foncons": [
        "foncer"
    ],
    "foot": [
        "foot"
    ],
    "football": [
        "football"
    ],
    "footballeur": [
        "footballeur"
    ],
    "footballeurs": [
        "footballeur"
    ],
    "footballeuse": [
        "footballeur"
    ],
    "footballistique": [
        "footballistique"
    ],
    "footballistiques": [
        "footballistique"
    ],
    "footeuse": [
        "footeux"
    ],
    "footeux": [
        "footeux"
    ],
    "footing": [
        "foot",
        "footing"
    ],
    "for": [
        "for"
    ],
    "forage": [
        "forage"
    ],
    "forages": [
        "forage"
    ],
    "foraient": [
        "forer"
    ],
    "forain": [
        "forain"
    ],
    "foraine": [
        "forain"
    ],
    "foraines": [
        "forain"
    ],
    "forains": [
        "forain"
    ],
    "forait": [
        "forer"
    ],
    "foramen": [
        "foramen"
    ],
    "foraminiferes": [
        "foraminifere"
    ],
    "forant": [
        "forer"
    ],
    "forban": [
        "forban"
    ],
    "forbans": [
        "forban"
    ],
    "force": [
        "force",
        "forcer"
    ],
    "forcement": [
        "forcement"
    ],
    "forcent": [
        "forcer"
    ],
    "forcene": [
        "forcene"
    ],
    "forcenee": [
        "forcene"
    ],
    "forcenees": [
        "forcene"
    ],
    "forcenes": [
        "forcene"
    ],
    "forceps": [
        "forceps",
        "forcep"
    ],
    "forcer": [
        "forcer"
    ],
    "forcera": [
        "forcer"
    ],
    "forcerai": [
        "forcer"
    ],
    "forcerais": [
        "forcer"
    ],
    "forcerait": [
        "forcer"
    ],
    "forceras": [
        "forcer"
    ],
    "forcerez": [
        "forcer"
    ],
    "forceront": [
        "forcer"
    ],
    "forces": [
        "force",
        "forcer"
    ],
    "forceur": [
        "forceur"
    ],
    "forceurs": [
        "forceur"
    ],
    "forcez": [
        "forcer"
    ],
    "forci": [
        "forcir"
    ],
    "forciez": [
        "forcer"
    ],
    "forcing": [
        "force",
        "forcing"
    ],
    "forcions": [
        "forcer"
    ],
    "forcir": [
        "forcir"
    ],
    "forcis": [
        "forcir"
    ],
    "forcissait": [
        "forcir"
    ],
    "forcit": [
        "forcir"
    ],
    "forcerent": [
        "forcer"
    ],
    "forcee": [
        "force",
        "forcer"
    ],
    "forcees": [
        "force",
        "forcer"
    ],
    "fore": [
        "forer"
    ],
    "forent": [
        "forer"
    ],
    "forer": [
        "forer"
    ],
    "forestier": [
        "forestier"
    ],
    "forestiers": [
        "forestier"
    ],
    "forestiere": [
        "forestier"
    ],
    "forestieres": [
        "forestier"
    ],
    "foret": [
        "foret"
    ],
    "forets": [
        "foret"
    ],
    "foreur": [
        "foreur"
    ],
    "foreurs": [
        "foreur"
    ],
    "foreuse": [
        "foreur"
    ],
    "foreuses": [
        "foreur"
    ],
    "forez": [
        "forer"
    ],
    "forfait": [
        "forfait"
    ],
    "forfaitaire": [
        "forfaitaire"
    ],
    "forfaitaires": [
        "forfaitaire"
    ],
    "forfaits": [
        "forfait"
    ],
    "forfaiture": [
        "forfaiture"
    ],
    "forfanterie": [
        "forfanterie"
    ],
    "forfanteries": [
        "forfanterie"
    ],
    "forficules": [
        "forficule"
    ],
    "forge": [
        "forger",
        "forge"
    ],
    "forgea": [
        "forger"
    ],
    "forgeage": [
        "forgeage"
    ],
    "forgeaient": [
        "forger"
    ],
    "forgeais": [
        "forger"
    ],
    "forgeait": [
        "forger"
    ],
    "forgeant": [
        "forger"
    ],
    "forgent": [
        "forger"
    ],
    "forgeons": [
        "forger"
    ],
    "forger": [
        "forger"
    ],
    "forgera": [
        "forger"
    ],
    "forgerai": [
        "forger"
    ],
    "forgeries": [
        "forgery",
        "forgerie"
    ],
    "forgeron": [
        "forgeron"
    ],
    "forgeronne": [
        "forgeron"
    ],
    "forgerons": [
        "forgeron"
    ],
    "forges": [
        "forger",
        "forge"
    ],
    "forgeur": [
        "forgeur"
    ],
    "forgions": [
        "forger"
    ],
    "forgerent": [
        "forger"
    ],
    "forgee": [
        "forger"
    ],
    "forgees": [
        "forger"
    ],
    "forints": [
        "forint"
    ],
    "forlane": [
        "forlane"
    ],
    "forlonger": [
        "forlonger"
    ],
    "forlonges": [
        "forlonger"
    ],
    "forma": [
        "former"
    ],
    "formage": [
        "formage"
    ],
    "formai": [
        "former"
    ],
    "formaient": [
        "former"
    ],
    "formais": [
        "former"
    ],
    "formait": [
        "former"
    ],
    "formaldehyde": [
        "formaldehyde"
    ],
    "formalisa": [
        "formaliser"
    ],
    "formalisaient": [
        "formaliser"
    ],
    "formalisais": [
        "formaliser"
    ],
    "formalisait": [
        "formaliser"
    ],
    "formalise": [
        "formalise",
        "formaliser"
    ],
    "formaliser": [
        "formaliser"
    ],
    "formalisera": [
        "formaliser"
    ],
    "formaliserait": [
        "formaliser"
    ],
    "formalisez": [
        "formaliser"
    ],
    "formalisme": [
        "formalisme"
    ],
    "formaliste": [
        "formaliste"
    ],
    "formalistes": [
        "formaliste"
    ],
    "formalisat": [
        "formaliser"
    ],
    "formalisee": [
        "formaliser"
    ],
    "formalises": [
        "formalise",
        "formaliser"
    ],
    "formalite": [
        "formalite"
    ],
    "formalites": [
        "formalite"
    ],
    "formant": [
        "former",
        "formant"
    ],
    "format": [
        "format"
    ],
    "formatage": [
        "formatage"
    ],
    "formater": [
        "formater"
    ],
    "formateur": [
        "formateur"
    ],
    "formation": [
        "formation"
    ],
    "formations": [
        "formation"
    ],
    "formatrice": [
        "formateur"
    ],
    "formatrices": [
        "formateur"
    ],
    "formats": [
        "format"
    ],
    "formate": [
        "formater"
    ],
    "forme": [
        "former",
        "forme"
    ],
    "formel": [
        "formel"
    ],
    "formelle": [
        "formel"
    ],
    "formellement": [
        "formellement"
    ],
    "formelles": [
        "formel"
    ],
    "formels": [
        "formel"
    ],
    "forment": [
        "former"
    ],
    "former": [
        "former"
    ],
    "formera": [
        "former"
    ],
    "formerai": [
        "former"
    ],
    "formeraient": [
        "former"
    ],
    "formerais": [
        "former"
    ],
    "formerait": [
        "former"
    ],
    "formerez": [
        "former"
    ],
    "formeriez": [
        "former"
    ],
    "formerons": [
        "former"
    ],
    "formeront": [
        "former"
    ],
    "formes": [
        "former",
        "forme"
    ],
    "formez": [
        "former"
    ],
    "formica": [
        "formica"
    ],
    "formicas": [
        "formica"
    ],
    "formid": [
        "formid"
    ],
    "formidable": [
        "formidable"
    ],
    "formidablement": [
        "formidablement"
    ],
    "formidables": [
        "formidable"
    ],
    "formide": [
        "formide"
    ],
    "formides": [
        "formide"
    ],
    "formids": [
        "formid"
    ],
    "formiez": [
        "former"
    ],
    "formions": [
        "former"
    ],
    "formique": [
        "formique"
    ],
    "formol": [
        "formol"
    ],
    "formons": [
        "former"
    ],
    "formula": [
        "formuler"
    ],
    "formulai": [
        "formuler"
    ],
    "formulaient": [
        "formuler"
    ],
    "formulaire": [
        "formulaire"
    ],
    "formulaires": [
        "formulaire"
    ],
    "formulais": [
        "formuler"
    ],
    "formulait": [
        "formuler"
    ],
    "formulant": [
        "formuler"
    ],
    "formulation": [
        "formulation"
    ],
    "formulations": [
        "formulation"
    ],
    "formule": [
        "formuler",
        "formule"
    ],
    "formulent": [
        "formuler"
    ],
    "formuler": [
        "formuler"
    ],
    "formulera": [
        "formuler"
    ],
    "formules": [
        "formuler",
        "formule"
    ],
    "formulettes": [
        "formulette"
    ],
    "formulez": [
        "formuler"
    ],
    "formulons": [
        "formuler"
    ],
    "formulat": [
        "formuler"
    ],
    "formulee": [
        "formuler",
        "formule"
    ],
    "formulees": [
        "formuler",
        "formule"
    ],
    "formerent": [
        "former"
    ],
    "formee": [
        "former",
        "forme"
    ],
    "formees": [
        "former",
        "forme"
    ],
    "fornicateur": [
        "fornicateur"
    ],
    "fornicateurs": [
        "fornicateur"
    ],
    "fornication": [
        "fornication"
    ],
    "fornications": [
        "fornication"
    ],
    "fornicatrice": [
        "fornicateur"
    ],
    "forniquaient": [
        "forniquer"
    ],
    "forniquait": [
        "forniquer"
    ],
    "forniquant": [
        "forniquer"
    ],
    "fornique": [
        "forniquer"
    ],
    "forniquent": [
        "forniquer"
    ],
    "forniquer": [
        "forniquer"
    ],
    "fors": [
        "fors"
    ],
    "forsythias": [
        "forsythia"
    ],
    "fort": [
        "fort"
    ],
    "forte": [
        "fort",
        "forte"
    ],
    "fortement": [
        "fortement"
    ],
    "forteresse": [
        "forteresse"
    ],
    "forteresses": [
        "forteresse"
    ],
    "fortes": [
        "fort",
        "forte"
    ],
    "fortiche": [
        "fortiche"
    ],
    "fortiches": [
        "fortiche"
    ],
    "fortifia": [
        "fortifier"
    ],
    "fortifiaient": [
        "fortifier"
    ],
    "fortifiais": [
        "fortifier"
    ],
    "fortifiait": [
        "fortifier"
    ],
    "fortifiant": [
        "fortifier",
        "fortifiant"
    ],
    "fortifiants": [
        "fortifiant"
    ],
    "fortification": [
        "fortification"
    ],
    "fortifications": [
        "fortification"
    ],
    "fortifie": [
        "fortifier",
        "fortifie"
    ],
    "fortifient": [
        "fortifier"
    ],
    "fortifier": [
        "fortifier"
    ],
    "fortifiera": [
        "fortifier"
    ],
    "fortifierait": [
        "fortifier"
    ],
    "fortifiez": [
        "fortifier"
    ],
    "fortifions": [
        "fortifier"
    ],
    "fortifiat": [
        "fortifier"
    ],
    "fortifierent": [
        "fortifier"
    ],
    "fortifiee": [
        "fortifier",
        "fortifie"
    ],
    "fortifiees": [
        "fortifier",
        "fortifie"
    ],
    "fortifies": [
        "fortifier",
        "fortifie",
        "fortify"
    ],
    "fortifs": [
        "fortif"
    ],
    "fortin": [
        "fortin"
    ],
    "fortins": [
        "fortin"
    ],
    "fortissimo": [
        "fortissimo"
    ],
    "fortitude": [
        "fortitude"
    ],
    "fortraiture": [
        "fortraiture"
    ],
    "forts": [
        "fort"
    ],
    "fortuit": [
        "fortuit"
    ],
    "fortuite": [
        "fortuit"
    ],
    "fortuitement": [
        "fortuitement"
    ],
    "fortuites": [
        "fortuit"
    ],
    "fortuits": [
        "fortuit"
    ],
    "fortune": [
        "fortune"
    ],
    "fortunes": [
        "fortune"
    ],
    "fortunee": [
        "fortune"
    ],
    "fortunees": [
        "fortune"
    ],
    "forum": [
        "forum"
    ],
    "forums": [
        "forum"
    ],
    "forca": [
        "forcer"
    ],
    "forcage": [
        "forcage"
    ],
    "forcai": [
        "forcer"
    ],
    "forcaient": [
        "forcer"
    ],
    "forcais": [
        "forcer"
    ],
    "forcait": [
        "forcer"
    ],
    "forcant": [
        "forcer"
    ],
    "forcat": [
        "forcer",
        "forcat"
    ],
    "forcats": [
        "forcat"
    ],
    "forcons": [
        "forcer"
    ],
    "foree": [
        "forer"
    ],
    "fores": [
        "fore",
        "forer"
    ],
    "fosse": [
        "fosse"
    ],
    "fosses": [
        "fosse"
    ],
    "fossette": [
        "fossette"
    ],
    "fossettes": [
        "fossette"
    ],
    "fossile": [
        "fossile"
    ],
    "fossiles": [
        "fossile"
    ],
    "fossilisation": [
        "fossilisation"
    ],
    "fossilise": [
        "fossiliser"
    ],
    "fossilises": [
        "fossiliser"
    ],
    "fossoyeur": [
        "fossoyeur"
    ],
    "fossoyeurs": [
        "fossoyeur"
    ],
    "fossoyeuse": [
        "fossoyeuse"
    ],
    "fou": [
        "fou"
    ],
    "fouaces": [
        "fouace"
    ],
    "fouailla": [
        "fouailler"
    ],
    "fouaillai": [
        "fouailler"
    ],
    "fouaillaient": [
        "fouailler"
    ],
    "fouaillait": [
        "fouailler"
    ],
    "fouaillant": [
        "fouailler"
    ],
    "fouaille": [
        "fouailler",
        "fouaille"
    ],
    "fouailler": [
        "fouailler"
    ],
    "fouaillee": [
        "fouailler"
    ],
    "fouaillees": [
        "fouailler"
    ],
    "foucade": [
        "foucade"
    ],
    "foucades": [
        "foucade"
    ],
    "fouchtra": [
        "fouchtra"
    ],
    "foudre": [
        "foudre"
    ],
    "foudres": [
        "foudre"
    ],
    "foudroie": [
        "foudroyer"
    ],
    "foudroiement": [
        "foudroiement"
    ],
    "foudroient": [
        "foudroyer"
    ],
    "foudroiera": [
        "foudroyer"
    ],
    "foudroieraient": [
        "foudroyer"
    ],
    "foudroierait": [
        "foudroyer"
    ],
    "foudroya": [
        "foudroyer"
    ],
    "foudroyaient": [
        "foudroyer"
    ],
    "foudroyait": [
        "foudroyer"
    ],
    "foudroyant": [
        "foudroyer",
        "foudroyant"
    ],
    "foudroyante": [
        "foudroyant"
    ],
    "foudroyantes": [
        "foudroyant"
    ],
    "foudroyants": [
        "foudroyant"
    ],
    "foudroyer": [
        "foudroyer"
    ],
    "foudroyions": [
        "foudroyer"
    ],
    "foudroyerent": [
        "foudroyer"
    ],
    "foudroye": [
        "foudroyer"
    ],
    "foudroyee": [
        "foudroyer"
    ],
    "foudroyees": [
        "foudroyer"
    ],
    "foudroyes": [
        "foudroyer"
    ],
    "fouet": [
        "fouet"
    ],
    "fouets": [
        "fouet"
    ],
    "fouetta": [
        "fouetter"
    ],
    "fouettaient": [
        "fouetter"
    ],
    "fouettais": [
        "fouetter"
    ],
    "fouettait": [
        "fouetter"
    ],
    "fouettant": [
        "fouetter"
    ],
    "fouettard": [
        "fouettard"
    ],
    "fouettards": [
        "fouettard"
    ],
    "fouette": [
        "fouette",
        "fouetter"
    ],
    "fouettement": [
        "fouettement"
    ],
    "fouettements": [
        "fouettement"
    ],
    "fouettent": [
        "fouetter"
    ],
    "fouetter": [
        "fouetter"
    ],
    "fouettera": [
        "fouetter"
    ],
    "fouetterai": [
        "fouetter"
    ],
    "fouetterait": [
        "fouetter"
    ],
    "fouetteront": [
        "fouetter"
    ],
    "fouettes": [
        "fouette",
        "fouetter"
    ],
    "fouetteur": [
        "fouetteur"
    ],
    "fouetteurs": [
        "fouetteur"
    ],
    "fouetteuse": [
        "fouetteur"
    ],
    "fouettez": [
        "fouetter"
    ],
    "fouettons": [
        "fouetter"
    ],
    "fouetterent": [
        "fouetter"
    ],
    "fouettee": [
        "fouetter"
    ],
    "fouettees": [
        "fouetter"
    ],
    "foufou": [
        "foufou"
    ],
    "foufoune": [
        "foufoune"
    ],
    "foufounes": [
        "foufoune"
    ],
    "foufounette": [
        "foufounette"
    ],
    "foufous": [
        "foufou"
    ],
    "fougasse": [
        "fougasse"
    ],
    "fouge": [
        "fouger"
    ],
    "fougeraie": [
        "fougeraie"
    ],
    "fougeraies": [
        "fougeraie"
    ],
    "fougue": [
        "fougue"
    ],
    "fougues": [
        "fougue"
    ],
    "fougueuse": [
        "fougueux"
    ],
    "fougueusement": [
        "fougueusement"
    ],
    "fougueuses": [
        "fougueux"
    ],
    "fougueux": [
        "fougueux"
    ],
    "fougere": [
        "fougere"
    ],
    "fougeres": [
        "fougere"
    ],
    "foui": [
        "fouir"
    ],
    "fouie": [
        "fouir"
    ],
    "fouies": [
        "fouir"
    ],
    "fouilla": [
        "fouiller"
    ],
    "fouillai": [
        "fouiller"
    ],
    "fouillaient": [
        "fouiller"
    ],
    "fouillais": [
        "fouiller"
    ],
    "fouillait": [
        "fouiller"
    ],
    "fouillant": [
        "fouiller"
    ],
    "fouillasse": [
        "fouiller"
    ],
    "fouille": [
        "fouiller",
        "fouille"
    ],
    "fouillent": [
        "fouiller"
    ],
    "fouiller": [
        "fouiller"
    ],
    "fouillera": [
        "fouiller"
    ],
    "fouillerai": [
        "fouiller"
    ],
    "fouillerais": [
        "fouiller"
    ],
    "fouillerait": [
        "fouiller"
    ],
    "fouilleras": [
        "fouiller"
    ],
    "fouillerons": [
        "fouiller"
    ],
    "fouilleront": [
        "fouiller"
    ],
    "fouilles": [
        "fouiller",
        "fouille"
    ],
    "fouillette": [
        "fouillette"
    ],
    "fouilleur": [
        "fouilleur"
    ],
    "fouilleurs": [
        "fouilleur"
    ],
    "fouilleuse": [
        "fouilleur"
    ],
    "fouillez": [
        "fouiller"
    ],
    "fouilliez": [
        "fouiller"
    ],
    "fouillis": [
        "fouillis"
    ],
    "fouillons": [
        "fouiller"
    ],
    "fouillerent": [
        "fouiller"
    ],
    "fouillee": [
        "fouiller"
    ],
    "fouillees": [
        "fouiller"
    ],
    "fouinaient": [
        "fouiner"
    ],
    "fouinais": [
        "fouiner"
    ],
    "fouinait": [
        "fouiner"
    ],
    "fouinant": [
        "fouiner"
    ],
    "fouinard": [
        "fouinard"
    ],
    "fouinards": [
        "fouinard"
    ],
    "fouine": [
        "fouine",
        "fouiner"
    ],
    "fouinent": [
        "fouiner"
    ],
    "fouiner": [
        "fouiner"
    ],
    "fouinera": [
        "fouiner"
    ],
    "fouineriez": [
        "fouiner"
    ],
    "fouines": [
        "fouine",
        "fouiner"
    ],
    "fouineur": [
        "fouineur"
    ],
    "fouineurs": [
        "fouineur"
    ],
    "fouineuse": [
        "fouineur"
    ],
    "fouinez": [
        "fouiner"
    ],
    "fouiniez": [
        "fouiner"
    ],
    "fouir": [
        "fouir"
    ],
    "fouissait": [
        "fouir"
    ],
    "fouissant": [
        "fouir"
    ],
    "fouissent": [
        "fouir"
    ],
    "fouisseur": [
        "fouisseur"
    ],
    "fouisseurs": [
        "fouisseur"
    ],
    "fouisseuse": [
        "fouisseur"
    ],
    "fouisseuses": [
        "fouisseur"
    ],
    "fouit": [
        "fouir"
    ],
    "foula": [
        "fouler"
    ],
    "foulage": [
        "foulage"
    ],
    "foulaient": [
        "fouler"
    ],
    "foulais": [
        "fouler"
    ],
    "foulait": [
        "fouler"
    ],
    "foulant": [
        "fouler",
        "foulant"
    ],
    "foulard": [
        "foulard"
    ],
    "foulards": [
        "foulard"
    ],
    "foulbe": [
        "foulbe"
    ],
    "foule": [
        "foule",
        "fouler"
    ],
    "foulent": [
        "fouler"
    ],
    "fouler": [
        "foul",
        "fouler"
    ],
    "foulera": [
        "fouler"
    ],
    "fouleraient": [
        "fouler"
    ],
    "foulerait": [
        "fouler"
    ],
    "foulerez": [
        "fouler"
    ],
    "foules": [
        "foule",
        "fouler"
    ],
    "fouleur": [
        "fouleur"
    ],
    "foulions": [
        "fouler"
    ],
    "fouloir": [
        "fouloir"
    ],
    "foulon": [
        "foulon"
    ],
    "foulons": [
        "fouler"
    ],
    "foulque": [
        "foulque"
    ],
    "foulques": [
        "foulque"
    ],
    "foulure": [
        "foulure"
    ],
    "foulures": [
        "foulure"
    ],
    "foulerent": [
        "fouler"
    ],
    "foulee": [
        "fouler",
        "foulee"
    ],
    "foulees": [
        "fouler",
        "foulee"
    ],
    "four": [
        "four"
    ],
    "fourbais": [
        "fourber"
    ],
    "fourbe": [
        "fourbe"
    ],
    "fourber": [
        "fourber"
    ],
    "fourberie": [
        "fourberie"
    ],
    "fourberies": [
        "fourberie"
    ],
    "fourbes": [
        "fourbe"
    ],
    "fourbi": [
        "fourbi",
        "fourbir"
    ],
    "fourbie": [
        "fourbir"
    ],
    "fourbir": [
        "fourbir"
    ],
    "fourbis": [
        "fourbi",
        "fourbir"
    ],
    "fourbissaient": [
        "fourbir"
    ],
    "fourbissais": [
        "fourbir"
    ],
    "fourbissait": [
        "fourbir"
    ],
    "fourbissant": [
        "fourbir"
    ],
    "fourbit": [
        "fourbir"
    ],
    "fourbu": [
        "fourbu"
    ],
    "fourbue": [
        "fourbu"
    ],
    "fourbues": [
        "fourbu"
    ],
    "fourbus": [
        "fourbu"
    ],
    "fourcha": [
        "fourcher"
    ],
    "fourche": [
        "fourcher",
        "fourche"
    ],
    "fourchent": [
        "fourcher"
    ],
    "fourcher": [
        "fourcher"
    ],
    "fourches": [
        "fourche"
    ],
    "fourchet": [
        "fourchet"
    ],
    "fourchets": [
        "fourchet"
    ],
    "fourchette": [
        "fourchette"
    ],
    "fourchettes": [
        "fourchette"
    ],
    "fourchez": [
        "fourcher"
    ],
    "fourchu": [
        "fourchu"
    ],
    "fourchue": [
        "fourchu"
    ],
    "fourchues": [
        "fourchu"
    ],
    "fourchures": [
        "fourchure"
    ],
    "fourchus": [
        "fourchu"
    ],
    "fourchee": [
        "fourcher",
        "fourchee"
    ],
    "fourgon": [
        "fourgon"
    ],
    "fourgonnait": [
        "fourgonner"
    ],
    "fourgonnas": [
        "fourgonner"
    ],
    "fourgonne": [
        "fourgonner"
    ],
    "fourgonner": [
        "fourgonner"
    ],
    "fourgonnette": [
        "fourgonnette"
    ],
    "fourgonnettes": [
        "fourgonnette"
    ],
    "fourgons": [
        "fourgon"
    ],
    "fourguais": [
        "fourguer"
    ],
    "fourguait": [
        "fourguer"
    ],
    "fourguant": [
        "fourguer"
    ],
    "fourgue": [
        "fourguer",
        "fourgue"
    ],
    "fourguent": [
        "fourguer"
    ],
    "fourguer": [
        "fourguer"
    ],
    "fourgueraient": [
        "fourguer"
    ],
    "fourguerais": [
        "fourguer"
    ],
    "fourguerait": [
        "fourguer"
    ],
    "fourgues": [
        "fourguer",
        "fourgue"
    ],
    "fourguez": [
        "fourguer"
    ],
    "fourguee": [
        "fourguer"
    ],
    "fourguees": [
        "fourguer"
    ],
    "fourme": [
        "fourme"
    ],
    "fourmes": [
        "fourme"
    ],
    "fourmi": [
        "fourmi"
    ],
    "fourmilier": [
        "fourmilier"
    ],
    "fourmilion": [
        "fourmilion"
    ],
    "fourmiliere": [
        "fourmilier"
    ],
    "fourmilieres": [
        "fourmiliere"
    ],
    "fourmillaient": [
        "fourmiller"
    ],
    "fourmillait": [
        "fourmiller"
    ],
    "fourmillant": [
        "fourmillant",
        "fourmiller"
    ],
    "fourmillante": [
        "fourmillant"
    ],
    "fourmillants": [
        "fourmillant"
    ],
    "fourmille": [
        "fourmiller"
    ],
    "fourmillement": [
        "fourmillement"
    ],
    "fourmillements": [
        "fourmillement"
    ],
    "fourmillent": [
        "fourmiller"
    ],
    "fourmiller": [
        "fourmiller"
    ],
    "fourmis": [
        "fourmi"
    ],
    "fournaise": [
        "fournaise"
    ],
    "fournaises": [
        "fournaise"
    ],
    "fourneau": [
        "fourneau"
    ],
    "fourneaux": [
        "fourneau"
    ],
    "fourni": [
        "fourni",
        "fournir"
    ],
    "fournie": [
        "fourni",
        "fournir"
    ],
    "fournier": [
        "fournier"
    ],
    "fournies": [
        "fourni",
        "fournir"
    ],
    "fournil": [
        "fournil"
    ],
    "fourniment": [
        "fourniment"
    ],
    "fourniments": [
        "fourniment"
    ],
    "fournir": [
        "fournir"
    ],
    "fournira": [
        "fournir"
    ],
    "fournirai": [
        "fournir"
    ],
    "fourniraient": [
        "fournir"
    ],
    "fournirait": [
        "fournir"
    ],
    "fournirent": [
        "fournir"
    ],
    "fournirez": [
        "fournir"
    ],
    "fournirons": [
        "fournir"
    ],
    "fourniront": [
        "fournir"
    ],
    "fournis": [
        "fourni",
        "fournir"
    ],
    "fournissaient": [
        "fournir"
    ],
    "fournissais": [
        "fournir"
    ],
    "fournissait": [
        "fournir"
    ],
    "fournissant": [
        "fournir"
    ],
    "fournisse": [
        "fournir"
    ],
    "fournissent": [
        "fournir"
    ],
    "fournisseur": [
        "fournisseur"
    ],
    "fournisseurs": [
        "fournisseur"
    ],
    "fournisseuses": [
        "fournisseur"
    ],
    "fournissez": [
        "fournir"
    ],
    "fournissiez": [
        "fournir"
    ],
    "fournissions": [
        "fournir"
    ],
    "fournissons": [
        "fournir"
    ],
    "fournit": [
        "fournir"
    ],
    "fourniture": [
        "fourniture"
    ],
    "fournitures": [
        "fourniture"
    ],
    "fournee": [
        "fournee"
    ],
    "fournees": [
        "fournee"
    ],
    "fournimes": [
        "fournir"
    ],
    "fourra": [
        "fourrer"
    ],
    "fourrage": [
        "fourrager",
        "fourrage"
    ],
    "fourragea": [
        "fourrager"
    ],
    "fourrageaient": [
        "fourrager"
    ],
    "fourrageais": [
        "fourrager"
    ],
    "fourrageait": [
        "fourrager"
    ],
    "fourrageant": [
        "fourrager"
    ],
    "fourragement": [
        "fourragement"
    ],
    "fourrager": [
        "fourrager"
    ],
    "fourragerait": [
        "fourrager"
    ],
    "fourrages": [
        "fourrage"
    ],
    "fourrageurs": [
        "fourrageur"
    ],
    "fourragere": [
        "fourrager"
    ],
    "fourrageres": [
        "fourrager"
    ],
    "fourrai": [
        "fourrer"
    ],
    "fourraient": [
        "fourrer"
    ],
    "fourrais": [
        "fourrer"
    ],
    "fourrait": [
        "fourrer"
    ],
    "fourrant": [
        "fourrer"
    ],
    "fourre": [
        "fourre",
        "fourrer"
    ],
    "fourreau": [
        "fourreau"
    ],
    "fourreaux": [
        "fourreau"
    ],
    "fourrent": [
        "fourrer"
    ],
    "fourrer": [
        "fourrer"
    ],
    "fourrerai": [
        "fourrer"
    ],
    "fourreur": [
        "fourreur"
    ],
    "fourreurs": [
        "fourreur"
    ],
    "fourrez": [
        "fourrer"
    ],
    "fourrier": [
        "fourrier"
    ],
    "fourriers": [
        "fourrier"
    ],
    "fourriez": [
        "fourrer"
    ],
    "fourrions": [
        "fourrer"
    ],
    "fourriere": [
        "fourriere"
    ],
    "fourrons": [
        "fourrer"
    ],
    "fourrure": [
        "fourrure"
    ],
    "fourrures": [
        "fourrure"
    ],
    "fourrat": [
        "fourrer"
    ],
    "fourrerent": [
        "fourrer"
    ],
    "fourree": [
        "fourre",
        "fourrer"
    ],
    "fourrees": [
        "fourre",
        "fourrer"
    ],
    "fourres": [
        "fourre",
        "fourrer"
    ],
    "fours": [
        "four"
    ],
    "fourvoie": [
        "fourvoyer"
    ],
    "fourvoiement": [
        "fourvoiement"
    ],
    "fourvoiements": [
        "fourvoiement"
    ],
    "fourvoient": [
        "fourvoyer"
    ],
    "fourvoierais": [
        "fourvoyer"
    ],
    "fourvoierait": [
        "fourvoyer"
    ],
    "fourvoyaient": [
        "fourvoyer"
    ],
    "fourvoyait": [
        "fourvoyer"
    ],
    "fourvoyant": [
        "fourvoyer"
    ],
    "fourvoyer": [
        "fourvoyer"
    ],
    "fourvoyames": [
        "fourvoyer"
    ],
    "fourvoye": [
        "fourvoyer",
        "fourvoye"
    ],
    "fourvoyee": [
        "fourvoyer"
    ],
    "fourvoyees": [
        "fourvoyer",
        "fourvoye"
    ],
    "fourvoyes": [
        "fourvoyer",
        "fourvoye"
    ],
    "fous": [
        "fou",
        "foutre"
    ],
    "fout": [
        "foutre"
    ],
    "fouta": [
        "fouta"
    ],
    "foutaient": [
        "foutre"
    ],
    "foutais": [
        "foutre"
    ],
    "foutaise": [
        "foutaise"
    ],
    "foutaises": [
        "foutaise"
    ],
    "foutait": [
        "foutre"
    ],
    "foutant": [
        "foutre"
    ],
    "foute": [
        "foutre"
    ],
    "foutent": [
        "foutre"
    ],
    "fouterie": [
        "fouterie"
    ],
    "fouteries": [
        "fouterie"
    ],
    "foutes": [
        "foutre"
    ],
    "fouteur": [
        "fouteur"
    ],
    "fouteurs": [
        "fouteur"
    ],
    "foutez": [
        "foutre"
    ],
    "foutiez": [
        "foutre"
    ],
    "foutions": [
        "foutre"
    ],
    "foutit": [
        "foutre"
    ],
    "foutoir": [
        "foutoir"
    ],
    "foutoirs": [
        "foutoir"
    ],
    "foutons": [
        "foutre"
    ],
    "foutra": [
        "foutre"
    ],
    "foutrai": [
        "foutre"
    ],
    "foutraient": [
        "foutre"
    ],
    "foutrais": [
        "foutre"
    ],
    "foutrait": [
        "foutre"
    ],
    "foutral": [
        "foutral"
    ],
    "foutrale": [
        "foutral"
    ],
    "foutraque": [
        "foutraque"
    ],
    "foutras": [
        "foutre"
    ],
    "foutre": [
        "foutre"
    ],
    "foutrement": [
        "foutrement"
    ],
    "foutrerie": [
        "foutrerie"
    ],
    "foutrez": [
        "foutre"
    ],
    "foutriquet": [
        "foutriquet"
    ],
    "foutriquets": [
        "foutriquet"
    ],
    "foutrons": [
        "foutre"
    ],
    "foutront": [
        "foutre"
    ],
    "foutu": [
        "foutu",
        "foutre"
    ],
    "foutue": [
        "foutu",
        "foutre"
    ],
    "foutues": [
        "foutu",
        "foutre"
    ],
    "foutument": [
        "foutument"
    ],
    "foutus": [
        "foutu",
        "foutre"
    ],
    "fox": [
        "fox"
    ],
    "foyard": [
        "foyard"
    ],
    "foyards": [
        "foyard"
    ],
    "foyer": [
        "foyer"
    ],
    "foyers": [
        "foyer"
    ],
    "foene": [
        "foene"
    ],
    "fra": [
        "fra"
    ],
    "frac": [
        "frac"
    ],
    "fracas": [
        "fracas"
    ],
    "fracassa": [
        "fracasser"
    ],
    "fracassaient": [
        "fracasser"
    ],
    "fracassait": [
        "fracasser"
    ],
    "fracassant": [
        "fracassant",
        "fracasser"
    ],
    "fracassante": [
        "fracassant"
    ],
    "fracassantes": [
        "fracassant"
    ],
    "fracassants": [
        "fracassant"
    ],
    "fracasse": [
        "fracasse",
        "fracasser"
    ],
    "fracassent": [
        "fracasser"
    ],
    "fracasser": [
        "fracasser"
    ],
    "fracassera": [
        "fracasser"
    ],
    "fracasserait": [
        "fracasser"
    ],
    "fracassez": [
        "fracasser"
    ],
    "fracassat": [
        "fracasser"
    ],
    "fracassee": [
        "fracasse",
        "fracasser"
    ],
    "fracassees": [
        "fracasse",
        "fracasser"
    ],
    "fracasses": [
        "fracasse",
        "fracasser"
    ],
    "fracs": [
        "frac"
    ],
    "fractal": [
        "fractal"
    ],
    "fractale": [
        "fractal"
    ],
    "fractales": [
        "fractal"
    ],
    "fraction": [
        "fraction"
    ],
    "fractionnait": [
        "fractionner"
    ],
    "fractionnant": [
        "fractionner"
    ],
    "fractionne": [
        "fractionner"
    ],
    "fractionnel": [
        "fractionnel"
    ],
    "fractionnelles": [
        "fractionnel"
    ],
    "fractionnement": [
        "fractionnement"
    ],
    "fractionner": [
        "fractionner"
    ],
    "fractionnee": [
        "fractionner",
        "fractionne"
    ],
    "fractionnees": [
        "fractionner",
        "fractionne"
    ],
    "fractions": [
        "fraction"
    ],
    "fractura": [
        "fracturer"
    ],
    "fracturant": [
        "fracturer"
    ],
    "fracture": [
        "fracturer",
        "fracture"
    ],
    "fracturent": [
        "fracturer"
    ],
    "fracturer": [
        "fracturer"
    ],
    "fractures": [
        "fracturer",
        "fracture"
    ],
    "fracturee": [
        "fracturer",
        "fracture"
    ],
    "fracturees": [
        "fracturer",
        "fracture"
    ],
    "fractus": [
        "fractus"
    ],
    "fragile": [
        "fragile"
    ],
    "fragilement": [
        "fragilement"
    ],
    "fragiles": [
        "fragile"
    ],
    "fragilise": [
        "fragilise",
        "fragiliser"
    ],
    "fragiliser": [
        "fragiliser"
    ],
    "fragilisee": [
        "fragiliser"
    ],
    "fragilises": [
        "fragilise",
        "fragiliser"
    ],
    "fragilite": [
        "fragilite"
    ],
    "fragilites": [
        "fragilite"
    ],
    "fragment": [
        "fragment"
    ],
    "fragmentaient": [
        "fragmenter"
    ],
    "fragmentaire": [
        "fragmentaire"
    ],
    "fragmentaires": [
        "fragmentaire"
    ],
    "fragmentait": [
        "fragmenter"
    ],
    "fragmentant": [
        "fragmenter"
    ],
    "fragmentation": [
        "fragmentation"
    ],
    "fragmente": [
        "fragmente",
        "fragmenter"
    ],
    "fragmentent": [
        "fragmenter"
    ],
    "fragmenter": [
        "fragmenter"
    ],
    "fragments": [
        "fragment"
    ],
    "fragmenterent": [
        "fragmenter"
    ],
    "fragmentee": [
        "fragmente",
        "fragmenter"
    ],
    "fragmentees": [
        "fragmente",
        "fragmenter"
    ],
    "fragmentes": [
        "fragmente",
        "fragmenter"
    ],
    "fragrance": [
        "fragrance"
    ],
    "fragrances": [
        "fragrance"
    ],
    "fragrant": [
        "fragrant"
    ],
    "frai": [
        "frai"
    ],
    "fraie": [
        "frayer"
    ],
    "fraient": [
        "frayer"
    ],
    "fraies": [
        "frayer"
    ],
    "frairie": [
        "frairie"
    ],
    "frais": [
        "frais"
    ],
    "fraise": [
        "fraise",
        "fraiser"
    ],
    "fraiser": [
        "fraiser"
    ],
    "fraises": [
        "fraise"
    ],
    "fraiseur": [
        "fraiseur"
    ],
    "fraiseurs": [
        "fraiseur"
    ],
    "fraiseuse": [
        "fraiseur"
    ],
    "fraisier": [
        "fraisier"
    ],
    "fraisiers": [
        "fraisier"
    ],
    "fraisil": [
        "fraisil"
    ],
    "fraisees": [
        "fraiser"
    ],
    "framboise": [
        "framboise"
    ],
    "framboises": [
        "framboise"
    ],
    "framboisier": [
        "framboisier"
    ],
    "framboisiers": [
        "framboisier"
    ],
    "franc": [
        "franc"
    ],
    "francatu": [
        "francatu"
    ],
    "francfort": [
        "francfort"
    ],
    "francforts": [
        "francfort"
    ],
    "franche": [
        "franc"
    ],
    "franchement": [
        "franchement"
    ],
    "franches": [
        "franc"
    ],
    "franchi": [
        "franchir"
    ],
    "franchie": [
        "franchir"
    ],
    "franchies": [
        "franchir"
    ],
    "franchir": [
        "franchir"
    ],
    "franchira": [
        "franchir"
    ],
    "franchirai": [
        "franchir"
    ],
    "franchiraient": [
        "franchir"
    ],
    "franchirais": [
        "franchir"
    ],
    "franchirait": [
        "franchir"
    ],
    "franchiras": [
        "franchir"
    ],
    "franchirent": [
        "franchir"
    ],
    "franchirez": [
        "franchir"
    ],
    "franchirions": [
        "franchir"
    ],
    "franchirons": [
        "franchir"
    ],
    "franchiront": [
        "franchir"
    ],
    "franchis": [
        "franchir"
    ],
    "franchisage": [
        "franchisage"
    ],
    "franchisant": [
        "franchiser"
    ],
    "franchise": [
        "franchiser",
        "franchise"
    ],
    "franchiser": [
        "franchiser"
    ],
    "franchises": [
        "franchise"
    ],
    "franchissables": [
        "franchissable"
    ],
    "franchissaient": [
        "franchir"
    ],
    "franchissais": [
        "franchir"
    ],
    "franchissait": [
        "franchir"
    ],
    "franchissant": [
        "franchir"
    ],
    "franchisse": [
        "franchir"
    ],
    "franchissement": [
        "franchissement"
    ],
    "franchissements": [
        "franchissement"
    ],
    "franchissent": [
        "franchir"
    ],
    "franchissez": [
        "franchir"
    ],
    "franchissions": [
        "franchir"
    ],
    "franchissons": [
        "franchir"
    ],
    "franchisee": [
        "franchiser"
    ],
    "franchit": [
        "franchir"
    ],
    "franchouillard": [
        "franchouillard"
    ],
    "franchouillarde": [
        "franchouillard"
    ],
    "franchouillards": [
        "franchouillard"
    ],
    "franchimes": [
        "franchir"
    ],
    "francisant": [
        "franciser"
    ],
    "francisation": [
        "francisation"
    ],
    "franciscain": [
        "franciscain"
    ],
    "franciscaine": [
        "franciscain"
    ],
    "franciscains": [
        "franciscain"
    ],
    "franciser": [
        "franciser"
    ],
    "francisque": [
        "francisque"
    ],
    "francisques": [
        "francisque"
    ],
    "francise": [
        "franciser"
    ],
    "francises": [
        "franciser"
    ],
    "francite": [
        "francite"
    ],
    "franco": [
        "franco"
    ],
    "francomanie": [
        "francomanie"
    ],
    "francophile": [
        "francophile"
    ],
    "francophiles": [
        "francophile"
    ],
    "francophilie": [
        "francophilie"
    ],
    "francophobie": [
        "francophobie"
    ],
    "francophone": [
        "francophone"
    ],
    "francophones": [
        "francophone"
    ],
    "francophonie": [
        "francophonie"
    ],
    "francs": [
        "franc"
    ],
    "frange": [
        "frange",
        "franger"
    ],
    "frangeaient": [
        "franger"
    ],
    "frangeait": [
        "franger"
    ],
    "frangeant": [
        "franger"
    ],
    "frangent": [
        "franger"
    ],
    "franges": [
        "frange",
        "franger"
    ],
    "frangin": [
        "frangin"
    ],
    "frangine": [
        "frangin"
    ],
    "frangines": [
        "frangin"
    ],
    "frangins": [
        "frangin"
    ],
    "frangipane": [
        "frangipane"
    ],
    "frangipanes": [
        "frangipane"
    ],
    "frangipaniers": [
        "frangipanier"
    ],
    "franglais": [
        "franglais"
    ],
    "frangee": [
        "franger"
    ],
    "frangees": [
        "franger"
    ],
    "frankaoui": [
        "frankaoui"
    ],
    "franklin": [
        "franklin"
    ],
    "franque": [
        "franque"
    ],
    "franques": [
        "franque"
    ],
    "franquette": [
        "franquette"
    ],
    "franquisme": [
        "franquisme"
    ],
    "franquiste": [
        "franquiste"
    ],
    "franquistes": [
        "franquiste"
    ],
    "francais": [
        "francais"
    ],
    "francaise": [
        "francais"
    ],
    "francaises": [
        "francais"
    ],
    "frapadingue": [
        "frapadingue"
    ],
    "frapadingues": [
        "frapadingue"
    ],
    "frappa": [
        "frapper"
    ],
    "frappadingue": [
        "frappadingue"
    ],
    "frappadingues": [
        "frappadingue"
    ],
    "frappai": [
        "frapper"
    ],
    "frappaient": [
        "frapper"
    ],
    "frappais": [
        "frapper"
    ],
    "frappait": [
        "frapper"
    ],
    "frappant": [
        "frapper",
        "frappant"
    ],
    "frappante": [
        "frappant"
    ],
    "frappantes": [
        "frappant"
    ],
    "frappants": [
        "frappant"
    ],
    "frappe": [
        "frappe",
        "frapper"
    ],
    "frappement": [
        "frappement"
    ],
    "frappements": [
        "frappement"
    ],
    "frappent": [
        "frapper"
    ],
    "frapper": [
        "frapper"
    ],
    "frappera": [
        "frapper"
    ],
    "frapperai": [
        "frapper"
    ],
    "frapperaient": [
        "frapper"
    ],
    "frapperais": [
        "frapper"
    ],
    "frapperait": [
        "frapper"
    ],
    "frapperas": [
        "frapper"
    ],
    "frapperez": [
        "frapper"
    ],
    "frapperiez": [
        "frapper"
    ],
    "frapperons": [
        "frapper"
    ],
    "frapperont": [
        "frapper"
    ],
    "frappes": [
        "frappe",
        "frapper"
    ],
    "frappeur": [
        "frappeur"
    ],
    "frappeurs": [
        "frappeur"
    ],
    "frappez": [
        "frapper"
    ],
    "frappiez": [
        "frapper"
    ],
    "frappions": [
        "frapper"
    ],
    "frappons": [
        "frapper"
    ],
    "frappat": [
        "frapper"
    ],
    "frapperent": [
        "frapper"
    ],
    "frappee": [
        "frappe",
        "frapper"
    ],
    "frappees": [
        "frappe",
        "frapper"
    ],
    "fraser": [
        "fraser"
    ],
    "frasque": [
        "frasque"
    ],
    "frasques": [
        "frasque"
    ],
    "frater": [
        "frater"
    ],
    "fraternel": [
        "fraternel"
    ],
    "fraternelle": [
        "fraternel"
    ],
    "fraternellement": [
        "fraternellement"
    ],
    "fraternelles": [
        "fraternel"
    ],
    "fraternels": [
        "fraternel"
    ],
    "fraternisa": [
        "fraterniser"
    ],
    "fraternisaient": [
        "fraterniser"
    ],
    "fraternisant": [
        "fraterniser"
    ],
    "fraternisation": [
        "fraternisation"
    ],
    "fraternise": [
        "fraterniser"
    ],
    "fraternisent": [
        "fraterniser"
    ],
    "fraterniser": [
        "fraterniser"
    ],
    "fraterniserait": [
        "fraterniser"
    ],
    "fraternisiez": [
        "fraterniser"
    ],
    "fraternisons": [
        "fraterniser"
    ],
    "fraterniserent": [
        "fraterniser"
    ],
    "fraternite": [
        "fraternite"
    ],
    "fraternites": [
        "fraternite"
    ],
    "fratricide": [
        "fratricide"
    ],
    "fratricides": [
        "fratricide"
    ],
    "fratrie": [
        "fratrie"
    ],
    "fratries": [
        "fratrie"
    ],
    "frauda": [
        "frauder"
    ],
    "fraudais": [
        "frauder"
    ],
    "fraude": [
        "frauder",
        "fraude"
    ],
    "frauder": [
        "frauder"
    ],
    "fraudes": [
        "frauder",
        "fraude"
    ],
    "fraudeur": [
        "fraudeur"
    ],
    "fraudeurs": [
        "fraudeur"
    ],
    "fraudeuse": [
        "fraudeur"
    ],
    "frauduleuse": [
        "frauduleux"
    ],
    "frauduleusement": [
        "frauduleusement"
    ],
    "frauduleuses": [
        "frauduleux"
    ],
    "frauduleux": [
        "frauduleux"
    ],
    "fraya": [
        "frayer"
    ],
    "frayai": [
        "frayer"
    ],
    "frayaient": [
        "frayer"
    ],
    "frayais": [
        "frayer"
    ],
    "frayait": [
        "frayer"
    ],
    "frayant": [
        "frayer"
    ],
    "fraye": [
        "frayer"
    ],
    "frayent": [
        "frayer"
    ],
    "frayer": [
        "frayer"
    ],
    "frayes": [
        "frayer"
    ],
    "frayeur": [
        "frayeur"
    ],
    "frayeurs": [
        "frayeur"
    ],
    "frayez": [
        "frayer"
    ],
    "frayons": [
        "frayer"
    ],
    "frayerent": [
        "frayer"
    ],
    "frayee": [
        "frayer",
        "frayee"
    ],
    "fraiche": [
        "frais"
    ],
    "fraichement": [
        "fraichement"
    ],
    "fraiches": [
        "frais"
    ],
    "fraicheur": [
        "fraicheur"
    ],
    "fraicheurs": [
        "fraicheur"
    ],
    "fraichi": [
        "fraichir"
    ],
    "fraichir": [
        "fraichir"
    ],
    "fraichira": [
        "fraichir"
    ],
    "fraichissait": [
        "fraichir"
    ],
    "fraichissant": [
        "fraichir"
    ],
    "fraichissent": [
        "fraichir"
    ],
    "fraichit": [
        "fraichir"
    ],
    "freak": [
        "freak"
    ],
    "freaks": [
        "freak"
    ],
    "fredaines": [
        "fredaine"
    ],
    "fredonna": [
        "fredonner"
    ],
    "fredonnaient": [
        "fredonner"
    ],
    "fredonnais": [
        "fredonner"
    ],
    "fredonnait": [
        "fredonner"
    ],
    "fredonnant": [
        "fredonner"
    ],
    "fredonne": [
        "fredonner"
    ],
    "fredonnement": [
        "fredonnement"
    ],
    "fredonnent": [
        "fredonner"
    ],
    "fredonner": [
        "fredonner"
    ],
    "fredonnera": [
        "fredonner"
    ],
    "fredonnerai": [
        "fredonner"
    ],
    "fredonnerait": [
        "fredonner"
    ],
    "fredonneras": [
        "fredonner"
    ],
    "fredonnez": [
        "fredonner"
    ],
    "fredonnons": [
        "fredonner"
    ],
    "fredonnames": [
        "fredonner"
    ],
    "fredonnerent": [
        "fredonner"
    ],
    "fredonnee": [
        "fredonner"
    ],
    "fredonnees": [
        "fredonner"
    ],
    "fredonnes": [
        "fredonner"
    ],
    "freelance": [
        "freelance"
    ],
    "freesia": [
        "freesia"
    ],
    "freesias": [
        "freesia"
    ],
    "freezer": [
        "freezer"
    ],
    "frein": [
        "frein"
    ],
    "freina": [
        "freiner"
    ],
    "freinage": [
        "freinage"
    ],
    "freinages": [
        "freinage"
    ],
    "freinai": [
        "freiner"
    ],
    "freinaient": [
        "freiner"
    ],
    "freinais": [
        "freiner"
    ],
    "freinait": [
        "freiner"
    ],
    "freinant": [
        "freiner"
    ],
    "freine": [
        "freiner"
    ],
    "freinent": [
        "freiner"
    ],
    "freiner": [
        "freiner"
    ],
    "freinera": [
        "freiner"
    ],
    "freinerais": [
        "freiner"
    ],
    "freinerez": [
        "freiner"
    ],
    "freines": [
        "freiner"
    ],
    "freineurs": [
        "freineur"
    ],
    "freinez": [
        "freiner"
    ],
    "freinons": [
        "freiner"
    ],
    "freins": [
        "frein"
    ],
    "freinerent": [
        "freiner"
    ],
    "freinee": [
        "freiner"
    ],
    "freinees": [
        "freiner"
    ],
    "frelater": [
        "frelater"
    ],
    "frelate": [
        "frelate"
    ],
    "frelatee": [
        "frelate",
        "frelater"
    ],
    "frelatees": [
        "frelate"
    ],
    "frelates": [
        "frelate",
        "frelater"
    ],
    "frelon": [
        "frelon"
    ],
    "frelons": [
        "frelon"
    ],
    "freluquet": [
        "freluquet"
    ],
    "freluquets": [
        "freluquet"
    ],
    "french": [
        "french"
    ],
    "fresque": [
        "fresque"
    ],
    "fresques": [
        "fresque"
    ],
    "fresquiste": [
        "fresquiste"
    ],
    "fret": [
        "fret"
    ],
    "fretin": [
        "fretin"
    ],
    "fretins": [
        "fretin"
    ],
    "frets": [
        "fret"
    ],
    "fretta": [
        "fretter"
    ],
    "frette": [
        "frette"
    ],
    "freudien": [
        "freudien"
    ],
    "freudienne": [
        "freudien"
    ],
    "freudiennes": [
        "freudien"
    ],
    "freudiens": [
        "freudien"
    ],
    "freudisme": [
        "freudisme"
    ],
    "freux": [
        "freux"
    ],
    "friabilite": [
        "friabilite"
    ],
    "friable": [
        "friable"
    ],
    "friables": [
        "friable"
    ],
    "friand": [
        "friand"
    ],
    "friande": [
        "friand"
    ],
    "friandes": [
        "friand"
    ],
    "friandise": [
        "friandise"
    ],
    "friandises": [
        "friandise"
    ],
    "friands": [
        "friand"
    ],
    "fribourgeoise": [
        "fribourgeois"
    ],
    "fric": [
        "fric"
    ],
    "fricadelle": [
        "fricadelle"
    ],
    "fricadelles": [
        "fricadelle"
    ],
    "fricandeau": [
        "fricandeau"
    ],
    "fricandeaux": [
        "fricandeau"
    ],
    "fricasse": [
        "fricasser",
        "fricasse"
    ],
    "fricasserai": [
        "fricasser"
    ],
    "fricassee": [
        "fricassee"
    ],
    "fricassees": [
        "fricassee"
    ],
    "fricatif": [
        "fricatif"
    ],
    "fricatives": [
        "fricative"
    ],
    "friche": [
        "friche"
    ],
    "friches": [
        "friche"
    ],
    "frichti": [
        "frichti"
    ],
    "frichtis": [
        "frichti"
    ],
    "fricot": [
        "fricot"
    ],
    "fricotage": [
        "fricotage"
    ],
    "fricotages": [
        "fricotage"
    ],
    "fricotaient": [
        "fricoter"
    ],
    "fricotais": [
        "fricoter"
    ],
    "fricotait": [
        "fricoter"
    ],
    "fricotant": [
        "fricoter"
    ],
    "fricote": [
        "fricoter"
    ],
    "fricotent": [
        "fricoter"
    ],
    "fricoter": [
        "fricoter"
    ],
    "fricotes": [
        "fricoter"
    ],
    "fricoteur": [
        "fricoteur"
    ],
    "fricoteurs": [
        "fricoteur"
    ],
    "fricotez": [
        "fricoter"
    ],
    "fricotiez": [
        "fricoter"
    ],
    "fricots": [
        "fricot"
    ],
    "frics": [
        "fric"
    ],
    "friction": [
        "friction"
    ],
    "frictionna": [
        "frictionner"
    ],
    "frictionnais": [
        "frictionner"
    ],
    "frictionnait": [
        "frictionner"
    ],
    "frictionnant": [
        "frictionner"
    ],
    "frictionne": [
        "frictionner"
    ],
    "frictionnent": [
        "frictionner"
    ],
    "frictionner": [
        "frictionner"
    ],
    "frictionnerai": [
        "frictionner"
    ],
    "frictionnerait": [
        "frictionner"
    ],
    "frictionnez": [
        "frictionner"
    ],
    "frictionnerent": [
        "frictionner"
    ],
    "frictions": [
        "friction"
    ],
    "fridolin": [
        "fridolin"
    ],
    "fridolins": [
        "fridolin"
    ],
    "frigidaire": [
        "frigidaire"
    ],
    "frigidaires": [
        "frigidaire"
    ],
    "frigide": [
        "frigide"
    ],
    "frigides": [
        "frigide"
    ],
    "frigidite": [
        "frigidite"
    ],
    "frigo": [
        "frigo"
    ],
    "frigorifiant": [
        "frigorifier"
    ],
    "frigorifier": [
        "frigorifier"
    ],
    "frigorifique": [
        "frigorifique"
    ],
    "frigorifiques": [
        "frigorifique"
    ],
    "frigorifie": [
        "frigorifier",
        "frigorifie"
    ],
    "frigorifiee": [
        "frigorifier",
        "frigorifie"
    ],
    "frigorifiees": [
        "frigorifie"
    ],
    "frigorifies": [
        "frigorifier",
        "frigorifie"
    ],
    "frigorigene": [
        "frigorigene"
    ],
    "frigos": [
        "frigo"
    ],
    "frileuse": [
        "frileux"
    ],
    "frileusement": [
        "frileusement"
    ],
    "frileuses": [
        "frileux"
    ],
    "frileux": [
        "frileux"
    ],
    "frilosite": [
        "frilosite"
    ],
    "frima": [
        "frimer"
    ],
    "frimaient": [
        "frimer"
    ],
    "frimaire": [
        "frimaire"
    ],
    "frimais": [
        "frimer"
    ],
    "frimait": [
        "frimer"
    ],
    "frimant": [
        "frimer"
    ],
    "frimas": [
        "frimas"
    ],
    "frime": [
        "frimer",
        "frime"
    ],
    "friment": [
        "frimer"
    ],
    "frimer": [
        "frimer"
    ],
    "frimerais": [
        "frimer"
    ],
    "frimes": [
        "frimer",
        "frime"
    ],
    "frimeur": [
        "frimeur"
    ],
    "frimeurs": [
        "frimeur"
    ],
    "frimeuse": [
        "frimeur"
    ],
    "frimez": [
        "frimer"
    ],
    "frimiez": [
        "frimer"
    ],
    "frimousse": [
        "frimousse"
    ],
    "frimousses": [
        "frimousse"
    ],
    "frimee": [
        "frimer"
    ],
    "frimees": [
        "frimer"
    ],
    "fringale": [
        "fringale"
    ],
    "fringales": [
        "fringale"
    ],
    "fringant": [
        "fringant"
    ],
    "fringante": [
        "fringant"
    ],
    "fringantes": [
        "fringant"
    ],
    "fringants": [
        "fringant"
    ],
    "fringillide": [
        "fringillide"
    ],
    "fringuait": [
        "fringuer"
    ],
    "fringue": [
        "fringue",
        "fringuer"
    ],
    "fringuent": [
        "fringuer"
    ],
    "fringuer": [
        "fringuer"
    ],
    "fringues": [
        "fringue",
        "fringuer"
    ],
    "fringuez": [
        "fringuer"
    ],
    "fringuee": [
        "fringuer"
    ],
    "fringuees": [
        "fringuer"
    ],
    "frio": [
        "frio"
    ],
    "fripa": [
        "friper"
    ],
    "fripaient": [
        "friper"
    ],
    "fripant": [
        "friper"
    ],
    "fripe": [
        "fripe",
        "friper"
    ],
    "fripent": [
        "friper"
    ],
    "friper": [
        "friper"
    ],
    "friperie": [
        "friperie"
    ],
    "fripes": [
        "fripe",
        "friper"
    ],
    "fripier": [
        "fripier"
    ],
    "fripiers": [
        "fripier"
    ],
    "fripon": [
        "fripon"
    ],
    "friponne": [
        "fripon"
    ],
    "friponnerie": [
        "friponnerie"
    ],
    "friponnes": [
        "fripon"
    ],
    "fripons": [
        "fripon"
    ],
    "fripouille": [
        "fripouille"
    ],
    "fripouillerie": [
        "fripouillerie"
    ],
    "fripouilleries": [
        "fripouillerie"
    ],
    "fripouilles": [
        "fripouille"
    ],
    "frippe": [
        "frippe"
    ],
    "fripee": [
        "fripe",
        "friper"
    ],
    "fripees": [
        "fripe",
        "friper"
    ],
    "frique": [
        "frique"
    ],
    "friquee": [
        "frique"
    ],
    "friquees": [
        "frique"
    ],
    "friques": [
        "frique"
    ],
    "frire": [
        "frire"
    ],
    "fris": [
        "frire",
        "fri"
    ],
    "frisa": [
        "friser"
    ],
    "frisaient": [
        "friser"
    ],
    "frisais": [
        "friser"
    ],
    "frisait": [
        "friser"
    ],
    "frisant": [
        "friser",
        "frisant"
    ],
    "frisante": [
        "frisant"
    ],
    "frisants": [
        "frisant"
    ],
    "frisbee": [
        "frisbee"
    ],
    "frise": [
        "frise",
        "friser"
    ],
    "friseler": [
        "friseler"
    ],
    "friselis": [
        "friselis"
    ],
    "friselee": [
        "friselee"
    ],
    "frisent": [
        "friser"
    ],
    "friser": [
        "friser"
    ],
    "friserai": [
        "friser"
    ],
    "frises": [
        "frise",
        "friser"
    ],
    "frisette": [
        "frisette"
    ],
    "frisettes": [
        "frisette"
    ],
    "friseur": [
        "friseur"
    ],
    "frisez": [
        "friser"
    ],
    "frison": [
        "frison"
    ],
    "frisonne": [
        "frison"
    ],
    "frisonnes": [
        "frison"
    ],
    "frisons": [
        "frison",
        "friser"
    ],
    "frisottaient": [
        "frisotter"
    ],
    "frisottant": [
        "frisottant"
    ],
    "frisottants": [
        "frisottant"
    ],
    "frisottement": [
        "frisottement"
    ],
    "frisottent": [
        "frisotter"
    ],
    "frisotter": [
        "frisotter"
    ],
    "frisottis": [
        "frisottis"
    ],
    "frisotte": [
        "frisotte",
        "frisotter"
    ],
    "frisottee": [
        "frisotte",
        "frisotter"
    ],
    "frisottees": [
        "frisotter"
    ],
    "frisottes": [
        "frisotter"
    ],
    "frisous": [
        "frisou"
    ],
    "frisquet": [
        "frisquet"
    ],
    "frisquette": [
        "frisquet"
    ],
    "frisselis": [
        "frisselis"
    ],
    "frisson": [
        "frisson"
    ],
    "frissonna": [
        "frissonner"
    ],
    "frissonnai": [
        "frissonner"
    ],
    "frissonnaient": [
        "frissonner"
    ],
    "frissonnais": [
        "frissonner"
    ],
    "frissonnait": [
        "frissonner"
    ],
    "frissonnant": [
        "frissonner",
        "frissonnant"
    ],
    "frissonnante": [
        "frissonnant"
    ],
    "frissonnantes": [
        "frissonnant"
    ],
    "frissonnants": [
        "frissonnant"
    ],
    "frissonne": [
        "frissonner"
    ],
    "frissonnement": [
        "frissonnement"
    ],
    "frissonnements": [
        "frissonnement"
    ],
    "frissonnent": [
        "frissonner"
    ],
    "frissonner": [
        "frissonner"
    ],
    "frissonnes": [
        "frissonner"
    ],
    "frissonnez": [
        "frissonner"
    ],
    "frissonnerent": [
        "frissonner"
    ],
    "frissons": [
        "frisson"
    ],
    "frisure": [
        "frisure"
    ],
    "frisures": [
        "frisure"
    ],
    "frisames": [
        "friser"
    ],
    "frisee": [
        "frise",
        "friser"
    ],
    "frisees": [
        "frise",
        "friser"
    ],
    "frit": [
        "frire"
    ],
    "frite": [
        "frite"
    ],
    "friterie": [
        "friterie"
    ],
    "friteries": [
        "friterie"
    ],
    "frites": [
        "frite"
    ],
    "friteuse": [
        "friteur"
    ],
    "friteuses": [
        "friteur"
    ],
    "fritillaires": [
        "fritillaire"
    ],
    "fritons": [
        "friton"
    ],
    "frits": [
        "frire"
    ],
    "fritte": [
        "fritte"
    ],
    "fritter": [
        "fritter"
    ],
    "frittes": [
        "fritter"
    ],
    "friture": [
        "friture"
    ],
    "fritures": [
        "friture"
    ],
    "friturier": [
        "friturier"
    ],
    "fritz": [
        "fritz"
    ],
    "frivole": [
        "frivole"
    ],
    "frivoles": [
        "frivole"
    ],
    "frivolite": [
        "frivolite"
    ],
    "frivolites": [
        "frivolite"
    ],
    "froc": [
        "froc"
    ],
    "frocard": [
        "frocard"
    ],
    "frocards": [
        "frocard"
    ],
    "frocs": [
        "froc"
    ],
    "froid": [
        "froid"
    ],
    "froidasse": [
        "froidasse"
    ],
    "froide": [
        "froid"
    ],
    "froidement": [
        "froidement"
    ],
    "froides": [
        "froid"
    ],
    "froideur": [
        "froideur"
    ],
    "froideurs": [
        "froideur"
    ],
    "froidi": [
        "froidir"
    ],
    "froidir": [
        "froidir"
    ],
    "froidissait": [
        "froidir"
    ],
    "froids": [
        "froid"
    ],
    "froidure": [
        "froidure"
    ],
    "froidures": [
        "froidure"
    ],
    "froissa": [
        "froisser"
    ],
    "froissaient": [
        "froisser"
    ],
    "froissais": [
        "froisser"
    ],
    "froissait": [
        "froisser"
    ],
    "froissant": [
        "froisser"
    ],
    "froisse": [
        "froisser",
        "froisse"
    ],
    "froissement": [
        "froissement"
    ],
    "froissements": [
        "froissement"
    ],
    "froissent": [
        "froisser"
    ],
    "froisser": [
        "froisser"
    ],
    "froissera": [
        "froisser"
    ],
    "froisserais": [
        "froisser"
    ],
    "froisserait": [
        "froisser"
    ],
    "froisses": [
        "froisser",
        "froisse"
    ],
    "froissez": [
        "froisser"
    ],
    "froissions": [
        "froisser"
    ],
    "froisserent": [
        "froisser"
    ],
    "froissee": [
        "froisser",
        "froisse"
    ],
    "froissees": [
        "froisser",
        "froisse"
    ],
    "fromage": [
        "fromage"
    ],
    "fromager": [
        "fromager"
    ],
    "fromagerie": [
        "fromagerie"
    ],
    "fromagers": [
        "fromager"
    ],
    "fromages": [
        "fromage"
    ],
    "fromagere": [
        "fromager"
    ],
    "fromegi": [
        "fromegi"
    ],
    "froment": [
        "froment"
    ],
    "fromental": [
        "fromental"
    ],
    "frometon": [
        "frometon"
    ],
    "frometons": [
        "frometon"
    ],
    "fronce": [
        "froncer",
        "fronce"
    ],
    "froncement": [
        "froncement"
    ],
    "froncements": [
        "froncement"
    ],
    "froncer": [
        "froncer"
    ],
    "froncerait": [
        "froncer"
    ],
    "fronces": [
        "froncer",
        "fronce"
    ],
    "froncez": [
        "froncer"
    ],
    "froncerent": [
        "froncer"
    ],
    "froncee": [
        "froncer",
        "fronce"
    ],
    "froncees": [
        "fronce"
    ],
    "frondaient": [
        "fronder"
    ],
    "frondaison": [
        "frondaison"
    ],
    "frondaisons": [
        "frondaison"
    ],
    "fronde": [
        "fronder",
        "fronde"
    ],
    "frondent": [
        "fronder"
    ],
    "frondes": [
        "fronde"
    ],
    "frondeur": [
        "frondeur"
    ],
    "frondeurs": [
        "frondeur"
    ],
    "frondeuse": [
        "frondeur"
    ],
    "front": [
        "front"
    ],
    "frontal": [
        "frontal"
    ],
    "frontale": [
        "frontal"
    ],
    "frontalier": [
        "frontalier"
    ],
    "frontaliers": [
        "frontalier"
    ],
    "frontaliere": [
        "frontalier"
    ],
    "frontalieres": [
        "frontalier"
    ],
    "frontaux": [
        "frontal"
    ],
    "fronteau": [
        "fronteau"
    ],
    "frontispice": [
        "frontispice"
    ],
    "frontispices": [
        "frontispice"
    ],
    "frontiere": [
        "frontiere"
    ],
    "frontieres": [
        "frontiere"
    ],
    "fronton": [
        "fronton"
    ],
    "frontons": [
        "fronton"
    ],
    "fronts": [
        "front"
    ],
    "fronca": [
        "froncer"
    ],
    "froncai": [
        "froncer"
    ],
    "froncaient": [
        "froncer"
    ],
    "froncais": [
        "froncer"
    ],
    "froncait": [
        "froncer"
    ],
    "froncant": [
        "froncer"
    ],
    "frotta": [
        "frotter"
    ],
    "frottage": [
        "frottage"
    ],
    "frottages": [
        "frottage"
    ],
    "frottai": [
        "frotter"
    ],
    "frottaient": [
        "frotter"
    ],
    "frottais": [
        "frotter"
    ],
    "frottait": [
        "frotter"
    ],
    "frottant": [
        "frottant",
        "frotter"
    ],
    "frotte": [
        "frotte",
        "frotter"
    ],
    "frottement": [
        "frottement"
    ],
    "frottements": [
        "frottement"
    ],
    "frottent": [
        "frotter"
    ],
    "frotter": [
        "frotter"
    ],
    "frottera": [
        "frotter"
    ],
    "frotterai": [
        "frotter"
    ],
    "frotterais": [
        "frotter"
    ],
    "frotterait": [
        "frotter"
    ],
    "frotteras": [
        "frotter"
    ],
    "frotterons": [
        "frotter"
    ],
    "frottes": [
        "frotte",
        "frotter"
    ],
    "frotteur": [
        "frotteur"
    ],
    "frotteurs": [
        "frotteur"
    ],
    "frotteuse": [
        "frotteur"
    ],
    "frotteuses": [
        "frotteur"
    ],
    "frottez": [
        "frotter"
    ],
    "frottiez": [
        "frotter"
    ],
    "frottin": [
        "frottin"
    ],
    "frottions": [
        "frotter"
    ],
    "frottis": [
        "frottis"
    ],
    "frottoir": [
        "frottoir"
    ],
    "frottoirs": [
        "frottoir"
    ],
    "frottons": [
        "frotton",
        "frotter"
    ],
    "frotterent": [
        "frotter"
    ],
    "frottee": [
        "frotter"
    ],
    "frottees": [
        "frottee",
        "frotter"
    ],
    "frouement": [
        "frouement"
    ],
    "frouements": [
        "frouement"
    ],
    "froufrou": [
        "froufrou"
    ],
    "froufrous": [
        "froufrou"
    ],
    "froufroutait": [
        "froufrouter"
    ],
    "froufroutant": [
        "froufroutant",
        "froufrouter"
    ],
    "froufroutante": [
        "froufroutant"
    ],
    "froufroutantes": [
        "froufroutant"
    ],
    "froufroutants": [
        "froufroutant"
    ],
    "froufroutement": [
        "froufroutement"
    ],
    "froufrouter": [
        "froufrouter"
    ],
    "froussard": [
        "froussard"
    ],
    "froussarde": [
        "froussard"
    ],
    "froussards": [
        "froussard"
    ],
    "frousse": [
        "frousse"
    ],
    "frousses": [
        "frousse"
    ],
    "fructidor": [
        "fructidor"
    ],
    "fructifiaient": [
        "fructifier"
    ],
    "fructifiant": [
        "fructifier"
    ],
    "fructification": [
        "fructification"
    ],
    "fructifier": [
        "fructifier"
    ],
    "fructifie": [
        "fructifier"
    ],
    "fructose": [
        "fructose"
    ],
    "fructueuse": [
        "fructueux"
    ],
    "fructueuses": [
        "fructueux"
    ],
    "fructueux": [
        "fructueux"
    ],
    "frugal": [
        "frugal"
    ],
    "frugale": [
        "frugal"
    ],
    "frugalement": [
        "frugalement"
    ],
    "frugales": [
        "frugal"
    ],
    "frugalite": [
        "frugalite"
    ],
    "frugaux": [
        "frugal"
    ],
    "frugivore": [
        "frugivore"
    ],
    "fruit": [
        "fruit"
    ],
    "fruiter": [
        "fruiter"
    ],
    "fruiteries": [
        "fruiterie"
    ],
    "fruiteux": [
        "fruiteux"
    ],
    "fruitier": [
        "fruity",
        "fruitier"
    ],
    "fruitiers": [
        "fruitier"
    ],
    "fruitiere": [
        "fruitier"
    ],
    "fruitieres": [
        "fruitier"
    ],
    "fruits": [
        "fruit"
    ],
    "fruite": [
        "fruiter",
        "fruite"
    ],
    "fruitee": [
        "fruiter",
        "fruite"
    ],
    "fruitees": [
        "fruite"
    ],
    "fruites": [
        "fruiter",
        "fruite"
    ],
    "frusquer": [
        "frusquer"
    ],
    "frusques": [
        "frusque"
    ],
    "frusquee": [
        "frusquer"
    ],
    "fruste": [
        "fruste"
    ],
    "frustes": [
        "fruste"
    ],
    "frustra": [
        "frustrer"
    ],
    "frustrait": [
        "frustrer"
    ],
    "frustrant": [
        "frustrant",
        "frustrer"
    ],
    "frustrante": [
        "frustrant"
    ],
    "frustrantes": [
        "frustrant"
    ],
    "frustration": [
        "frustration"
    ],
    "frustrations": [
        "frustration"
    ],
    "frustre": [
        "frustrer",
        "frustre"
    ],
    "frustrer": [
        "frustrer"
    ],
    "frustrat": [
        "frustrer"
    ],
    "frustree": [
        "frustrer",
        "frustre"
    ],
    "frustrees": [
        "frustrer",
        "frustre"
    ],
    "frustres": [
        "frustrer",
        "frustre"
    ],
    "frere": [
        "frere"
    ],
    "freres": [
        "frere"
    ],
    "frete": [
        "freter"
    ],
    "fregate": [
        "fregate"
    ],
    "fregates": [
        "fregate"
    ],
    "fremi": [
        "fremir"
    ],
    "fremir": [
        "fremir"
    ],
    "fremirait": [
        "fremir"
    ],
    "fremirent": [
        "fremir"
    ],
    "fremiront": [
        "fremir"
    ],
    "fremis": [
        "fremir"
    ],
    "fremissaient": [
        "fremir"
    ],
    "fremissais": [
        "fremir"
    ],
    "fremissait": [
        "fremir"
    ],
    "fremissant": [
        "fremissant",
        "fremir"
    ],
    "fremissante": [
        "fremissant"
    ],
    "fremissantes": [
        "fremissant"
    ],
    "fremissants": [
        "fremissant"
    ],
    "fremisse": [
        "fremir"
    ],
    "fremissement": [
        "fremissement"
    ],
    "fremissements": [
        "fremissement"
    ],
    "fremissent": [
        "fremir"
    ],
    "fremissez": [
        "fremir"
    ],
    "fremit": [
        "fremir"
    ],
    "frenesie": [
        "frenesie"
    ],
    "frenesies": [
        "frenesie"
    ],
    "frenetique": [
        "frenetique"
    ],
    "frenetiquement": [
        "frenetiquement"
    ],
    "frenetiques": [
        "frenetique"
    ],
    "freon": [
        "freon"
    ],
    "frequemment": [
        "frequemment"
    ],
    "frequence": [
        "frequence"
    ],
    "frequences": [
        "frequence"
    ],
    "frequent": [
        "frequent"
    ],
    "frequenta": [
        "frequenter"
    ],
    "frequentable": [
        "frequentable"
    ],
    "frequentables": [
        "frequentable"
    ],
    "frequentai": [
        "frequenter"
    ],
    "frequentaient": [
        "frequenter"
    ],
    "frequentais": [
        "frequenter"
    ],
    "frequentait": [
        "frequenter"
    ],
    "frequentant": [
        "frequenter"
    ],
    "frequentation": [
        "frequentation"
    ],
    "frequentations": [
        "frequentation"
    ],
    "frequente": [
        "frequent",
        "frequente",
        "frequenter"
    ],
    "frequentent": [
        "frequenter"
    ],
    "frequenter": [
        "frequenter"
    ],
    "frequenterais": [
        "frequenter"
    ],
    "frequenterait": [
        "frequenter"
    ],
    "frequenteras": [
        "frequenter"
    ],
    "frequenterez": [
        "frequenter"
    ],
    "frequentes": [
        "frequent",
        "frequente",
        "frequenter"
    ],
    "frequentez": [
        "frequenter"
    ],
    "frequentiez": [
        "frequenter"
    ],
    "frequentions": [
        "frequenter"
    ],
    "frequentons": [
        "frequenter"
    ],
    "frequents": [
        "frequent"
    ],
    "frequentat": [
        "frequenter"
    ],
    "frequenterent": [
        "frequenter"
    ],
    "frequentee": [
        "frequente",
        "frequenter"
    ],
    "frequentees": [
        "frequente",
        "frequenter"
    ],
    "frerot": [
        "frerot"
    ],
    "frerots": [
        "frerot"
    ],
    "freta": [
        "freter"
    ],
    "fretait": [
        "freter"
    ],
    "fretant": [
        "freter"
    ],
    "freter": [
        "freter"
    ],
    "fretilla": [
        "fretiller"
    ],
    "fretillaient": [
        "fretiller"
    ],
    "fretillait": [
        "fretiller"
    ],
    "fretillant": [
        "fretiller",
        "fretillant"
    ],
    "fretillante": [
        "fretillant"
    ],
    "fretillantes": [
        "fretillant"
    ],
    "fretillants": [
        "fretillant"
    ],
    "fretillard": [
        "fretillard"
    ],
    "fretillarde": [
        "fretillard"
    ],
    "fretille": [
        "fretiller"
    ],
    "fretillement": [
        "fretillement"
    ],
    "fretillements": [
        "fretillement"
    ],
    "fretillent": [
        "fretiller"
    ],
    "fretiller": [
        "fretiller"
    ],
    "fretillon": [
        "fretillon"
    ],
    "freterent": [
        "freter"
    ],
    "fretee": [
        "freter"
    ],
    "frele": [
        "frele"
    ],
    "freles": [
        "frele"
    ],
    "frene": [
        "frene"
    ],
    "frenes": [
        "frene"
    ],
    "frola": [
        "froler"
    ],
    "frolai": [
        "froler"
    ],
    "frolaient": [
        "froler"
    ],
    "frolais": [
        "froler"
    ],
    "frolait": [
        "froler"
    ],
    "frolant": [
        "froler"
    ],
    "frole": [
        "froler"
    ],
    "frolement": [
        "frolement"
    ],
    "frolements": [
        "frolement"
    ],
    "frolent": [
        "froler"
    ],
    "froler": [
        "froler"
    ],
    "frolerais": [
        "froler"
    ],
    "frolerait": [
        "froler"
    ],
    "froles": [
        "froler"
    ],
    "froleur": [
        "froleur"
    ],
    "froleurs": [
        "froleur"
    ],
    "froleuse": [
        "froleur"
    ],
    "froleuses": [
        "froleur"
    ],
    "frolez": [
        "froler"
    ],
    "frolions": [
        "froler"
    ],
    "frolons": [
        "froler"
    ],
    "frolat": [
        "froler"
    ],
    "frolerent": [
        "froler"
    ],
    "frolee": [
        "froler"
    ],
    "frolees": [
        "froler"
    ],
    "fuchsia": [
        "fuchsia"
    ],
    "fuchsias": [
        "fuchsia"
    ],
    "fuel": [
        "fuel"
    ],
    "fugace": [
        "fugace"
    ],
    "fugacement": [
        "fugacement"
    ],
    "fugaces": [
        "fugace"
    ],
    "fugacite": [
        "fugacite"
    ],
    "fugitif": [
        "fugitif"
    ],
    "fugitifs": [
        "fugitif"
    ],
    "fugitive": [
        "fugitif"
    ],
    "fugitivement": [
        "fugitivement"
    ],
    "fugitives": [
        "fugitif",
        "fugitive"
    ],
    "fugu": [
        "fugu"
    ],
    "fuguaient": [
        "fuguer"
    ],
    "fuguait": [
        "fuguer"
    ],
    "fugue": [
        "fuguer",
        "fugue"
    ],
    "fuguent": [
        "fuguer"
    ],
    "fuguer": [
        "fuguer"
    ],
    "fuguerais": [
        "fuguer"
    ],
    "fugues": [
        "fuguer",
        "fugue"
    ],
    "fugueur": [
        "fugueur"
    ],
    "fugueurs": [
        "fugueur"
    ],
    "fugueuse": [
        "fugueur"
    ],
    "fugueuses": [
        "fugueur"
    ],
    "fuguerent": [
        "fuguer"
    ],
    "fuguees": [
        "fugue"
    ],
    "fui": [
        "fui",
        "fuir"
    ],
    "fuie": [
        "fuie",
        "fuir"
    ],
    "fuient": [
        "fuir"
    ],
    "fuies": [
        "fuir"
    ],
    "fuir": [
        "fuir"
    ],
    "fuira": [
        "fuir"
    ],
    "fuirai": [
        "fuir"
    ],
    "fuiraient": [
        "fuir"
    ],
    "fuirais": [
        "fuir"
    ],
    "fuirait": [
        "fuir"
    ],
    "fuiras": [
        "fuir"
    ],
    "fuirent": [
        "fuir"
    ],
    "fuirez": [
        "fuir"
    ],
    "fuiriez": [
        "fuir"
    ],
    "fuirions": [
        "fuir"
    ],
    "fuirons": [
        "fuir"
    ],
    "fuiront": [
        "fuir"
    ],
    "fuis": [
        "fui",
        "fuir"
    ],
    "fuisse": [
        "fuir"
    ],
    "fuit": [
        "fuir"
    ],
    "fuite": [
        "fuite"
    ],
    "fuiter": [
        "fuiter"
    ],
    "fuites": [
        "fuite"
    ],
    "fulgores": [
        "fulgore"
    ],
    "fulgura": [
        "fulgurer"
    ],
    "fulguraient": [
        "fulgurer"
    ],
    "fulgurait": [
        "fulgurer"
    ],
    "fulgurance": [
        "fulgurance"
    ],
    "fulgurances": [
        "fulgurance"
    ],
    "fulgurant": [
        "fulgurer",
        "fulgurant"
    ],
    "fulgurante": [
        "fulgurant"
    ],
    "fulgurantes": [
        "fulgurant"
    ],
    "fulgurants": [
        "fulgurant"
    ],
    "fulguration": [
        "fulguration"
    ],
    "fulgurations": [
        "fulguration"
    ],
    "fulgure": [
        "fulgurer"
    ],
    "fulgurent": [
        "fulgurer"
    ],
    "fulgurer": [
        "fulgurer"
    ],
    "fulgurerent": [
        "fulgurer"
    ],
    "fuligineuse": [
        "fuligineux"
    ],
    "fuligineuses": [
        "fuligineux"
    ],
    "fuligineux": [
        "fuligineux"
    ],
    "fuligule": [
        "fuligule"
    ],
    "full": [
        "full"
    ],
    "fullerene": [
        "fullerene"
    ],
    "fulls": [
        "full"
    ],
    "fulmicoton": [
        "fulmicoton"
    ],
    "fulmina": [
        "fulminer"
    ],
    "fulminaient": [
        "fulminer"
    ],
    "fulminais": [
        "fulminer"
    ],
    "fulminait": [
        "fulminer"
    ],
    "fulminant": [
        "fulminer",
        "fulminant"
    ],
    "fulminante": [
        "fulminant"
    ],
    "fulminantes": [
        "fulminant"
    ],
    "fulminants": [
        "fulminant"
    ],
    "fulminate": [
        "fulminate"
    ],
    "fulmination": [
        "fulmination"
    ],
    "fulminations": [
        "fulmination"
    ],
    "fulmine": [
        "fulminer"
    ],
    "fulminement": [
        "fulminement"
    ],
    "fulminent": [
        "fulminer"
    ],
    "fulminer": [
        "fulminer"
    ],
    "fulminera": [
        "fulminer"
    ],
    "fuma": [
        "fumer"
    ],
    "fumaga": [
        "fumaga"
    ],
    "fumage": [
        "fumage"
    ],
    "fumai": [
        "fumer"
    ],
    "fumaient": [
        "fumer"
    ],
    "fumailler": [
        "fumailler"
    ],
    "fumaille": [
        "fumailler"
    ],
    "fumais": [
        "fumer"
    ],
    "fumaison": [
        "fumaison"
    ],
    "fumait": [
        "fumer"
    ],
    "fumant": [
        "fumer",
        "fumant"
    ],
    "fumante": [
        "fumant"
    ],
    "fumantes": [
        "fumant"
    ],
    "fumants": [
        "fumant"
    ],
    "fumasse": [
        "fumasse"
    ],
    "fume": [
        "fumer",
        "fume"
    ],
    "fument": [
        "fumer"
    ],
    "fumer": [
        "fumer"
    ],
    "fumera": [
        "fumer"
    ],
    "fumerai": [
        "fumer"
    ],
    "fumeraient": [
        "fumer"
    ],
    "fumerais": [
        "fumer"
    ],
    "fumerait": [
        "fumer"
    ],
    "fumeras": [
        "fumer"
    ],
    "fumerez": [
        "fumer"
    ],
    "fumerie": [
        "fumerie"
    ],
    "fumeries": [
        "fumerie"
    ],
    "fumerolles": [
        "fumerolle"
    ],
    "fumeron": [
        "fumeron"
    ],
    "fumeronne": [
        "fumeronner"
    ],
    "fumerons": [
        "fumer",
        "fumeron"
    ],
    "fumes": [
        "fumer",
        "fume",
        "etre"
    ],
    "fumet": [
        "fumet"
    ],
    "fumets": [
        "fumet"
    ],
    "fumette": [
        "fumette"
    ],
    "fumeur": [
        "fumeur"
    ],
    "fumeurs": [
        "fumeur"
    ],
    "fumeuse": [
        "fumeur"
    ],
    "fumeuses": [
        "fumeur"
    ],
    "fumeux": [
        "fumeux"
    ],
    "fumez": [
        "fumer"
    ],
    "fumier": [
        "fumier"
    ],
    "fumiers": [
        "fumier"
    ],
    "fumiez": [
        "fumer"
    ],
    "fumigateur": [
        "fumigateur"
    ],
    "fumigation": [
        "fumigation"
    ],
    "fumigations": [
        "fumigation"
    ],
    "fumiger": [
        "fumiger"
    ],
    "fumigene": [
        "fumigene"
    ],
    "fumigenes": [
        "fumigene"
    ],
    "fumige": [
        "fumiger"
    ],
    "fumions": [
        "fumer"
    ],
    "fumiste": [
        "fumiste"
    ],
    "fumisterie": [
        "fumisterie"
    ],
    "fumisteries": [
        "fumisterie"
    ],
    "fumistes": [
        "fumiste"
    ],
    "fumiere": [
        "fumier"
    ],
    "fumoir": [
        "fumoir"
    ],
    "fumons": [
        "fumer"
    ],
    "fumure": [
        "fumure"
    ],
    "fumames": [
        "fumer"
    ],
    "fumat": [
        "fumer"
    ],
    "fumerent": [
        "fumer"
    ],
    "fumee": [
        "fumer",
        "fume",
        "fumee"
    ],
    "fumees": [
        "fumer",
        "fume",
        "fumee"
    ],
    "fun": [
        "fun"
    ],
    "funambule": [
        "funambule"
    ],
    "funambules": [
        "funambule"
    ],
    "funambulesque": [
        "funambulesque"
    ],
    "funeste": [
        "funeste"
    ],
    "funestement": [
        "funestement"
    ],
    "funestes": [
        "funeste"
    ],
    "fung": [
        "fung"
    ],
    "funiculaire": [
        "funiculaire"
    ],
    "funiculaires": [
        "funiculaire"
    ],
    "funk": [
        "funk"
    ],
    "funky": [
        "funky"
    ],
    "funebre": [
        "funebre"
    ],
    "funebres": [
        "funebre"
    ],
    "funerailles": [
        "funerailles"
    ],
    "funeraire": [
        "funeraire"
    ],
    "funeraires": [
        "funeraire"
    ],
    "funerarium": [
        "funerarium"
    ],
    "funerariums": [
        "funerarium"
    ],
    "furax": [
        "furax"
    ],
    "furent": [
        "etre"
    ],
    "furet": [
        "furet"
    ],
    "fureta": [
        "fureter"
    ],
    "furetage": [
        "furetage"
    ],
    "furetai": [
        "fureter"
    ],
    "furetaient": [
        "fureter"
    ],
    "furetait": [
        "fureter"
    ],
    "furetant": [
        "fureter"
    ],
    "fureter": [
        "fureter"
    ],
    "fureteur": [
        "fureteur"
    ],
    "fureteurs": [
        "fureteur"
    ],
    "fureteuse": [
        "fureteur"
    ],
    "fureteuses": [
        "fureteur"
    ],
    "furetez": [
        "fureter"
    ],
    "furets": [
        "furet"
    ],
    "furette": [
        "furette"
    ],
    "furete": [
        "fureter"
    ],
    "fureur": [
        "fureur"
    ],
    "fureurs": [
        "fureur"
    ],
    "furia": [
        "furia"
    ],
    "furibard": [
        "furibard"
    ],
    "furibarde": [
        "furibard"
    ],
    "furibardes": [
        "furibard"
    ],
    "furibond": [
        "furibond"
    ],
    "furibonde": [
        "furibond"
    ],
    "furibondes": [
        "furibond"
    ],
    "furibonds": [
        "furibond"
    ],
    "furie": [
        "furie"
    ],
    "furies": [
        "furie",
        "fury"
    ],
    "furieuse": [
        "furieux"
    ],
    "furieusement": [
        "furieusement"
    ],
    "furieuses": [
        "furieux"
    ],
    "furieux": [
        "furieux"
    ],
    "furioso": [
        "furioso"
    ],
    "furoncle": [
        "furoncle"
    ],
    "furoncles": [
        "furoncle"
    ],
    "furonculeux": [
        "furonculeux"
    ],
    "furonculose": [
        "furonculose"
    ],
    "furonculoses": [
        "furonculose"
    ],
    "furtif": [
        "furtif"
    ],
    "furtifs": [
        "furtif"
    ],
    "furtive": [
        "furtif"
    ],
    "furtivement": [
        "furtivement"
    ],
    "furtives": [
        "furtif"
    ],
    "furtivite": [
        "furtivite"
    ],
    "furetent": [
        "fureter"
    ],
    "fureterais": [
        "fureter"
    ],
    "fus": [
        "etre"
    ],
    "fusa": [
        "fuser"
    ],
    "fusaient": [
        "fuser"
    ],
    "fusain": [
        "fusain"
    ],
    "fusains": [
        "fusain"
    ],
    "fusait": [
        "fuser"
    ],
    "fusant": [
        "fuser",
        "fusant"
    ],
    "fusante": [
        "fusant"
    ],
    "fusants": [
        "fusant"
    ],
    "fuse": [
        "fuser"
    ],
    "fuseau": [
        "fuseau"
    ],
    "fuseaux": [
        "fuseau"
    ],
    "fuselage": [
        "fuselage"
    ],
    "fuselages": [
        "fuselage"
    ],
    "fusele": [
        "fuseler",
        "fusele"
    ],
    "fuselee": [
        "fuseler",
        "fusele"
    ],
    "fuselees": [
        "fuseler",
        "fusele"
    ],
    "fuseles": [
        "fusele"
    ],
    "fusent": [
        "fuser"
    ],
    "fuser": [
        "fuser"
    ],
    "fusible": [
        "fusible"
    ],
    "fusibles": [
        "fusible"
    ],
    "fusiforme": [
        "fusiforme"
    ],
    "fusil": [
        "fusil"
    ],
    "fusilier": [
        "fusilier"
    ],
    "fusiliers": [
        "fusilier"
    ],
    "fusilla": [
        "fusiller"
    ],
    "fusillade": [
        "fusillade"
    ],
    "fusillades": [
        "fusillade"
    ],
    "fusillaient": [
        "fusiller"
    ],
    "fusillait": [
        "fusiller"
    ],
    "fusillant": [
        "fusiller"
    ],
    "fusille": [
        "fusille",
        "fusiller"
    ],
    "fusillent": [
        "fusiller"
    ],
    "fusiller": [
        "fusiller"
    ],
    "fusillera": [
        "fusiller"
    ],
    "fusilleraient": [
        "fusiller"
    ],
    "fusillerait": [
        "fusiller"
    ],
    "fusillerons": [
        "fusiller"
    ],
    "fusilleront": [
        "fusiller"
    ],
    "fusilleurs": [
        "fusilleur"
    ],
    "fusillez": [
        "fusiller"
    ],
    "fusillions": [
        "fusiller"
    ],
    "fusillons": [
        "fusiller"
    ],
    "fusillee": [
        "fusille",
        "fusiller"
    ],
    "fusillees": [
        "fusille",
        "fusiller"
    ],
    "fusilles": [
        "fusille",
        "fusiller"
    ],
    "fusils": [
        "fusil"
    ],
    "fusion": [
        "fusion"
    ],
    "fusionnaient": [
        "fusionner"
    ],
    "fusionnant": [
        "fusionner"
    ],
    "fusionne": [
        "fusionner"
    ],
    "fusionnel": [
        "fusionnel"
    ],
    "fusionnelle": [
        "fusionnel"
    ],
    "fusionnement": [
        "fusionnement"
    ],
    "fusionnent": [
        "fusionner"
    ],
    "fusionner": [
        "fusionner"
    ],
    "fusionneraient": [
        "fusionner"
    ],
    "fusionnerait": [
        "fusionner"
    ],
    "fusionneront": [
        "fusionner"
    ],
    "fusionnons": [
        "fusionner"
    ],
    "fusionnes": [
        "fusionner"
    ],
    "fusions": [
        "fusion"
    ],
    "fusse": [
        "etre"
    ],
    "fussent": [
        "etre"
    ],
    "fusses": [
        "etre",
        "fuss"
    ],
    "fussiez": [
        "etre"
    ],
    "fussions": [
        "etre"
    ],
    "fustanelle": [
        "fustanelle"
    ],
    "fustigation": [
        "fustigation"
    ],
    "fustigations": [
        "fustigation"
    ],
    "fustige": [
        "fustiger"
    ],
    "fustigea": [
        "fustiger"
    ],
    "fustigeaient": [
        "fustiger"
    ],
    "fustigeais": [
        "fustiger"
    ],
    "fustigeait": [
        "fustiger"
    ],
    "fustigeant": [
        "fustiger"
    ],
    "fustiger": [
        "fustiger"
    ],
    "fustigez": [
        "fustiger"
    ],
    "fustigee": [
        "fustiger"
    ],
    "fustiges": [
        "fustiger"
    ],
    "fuserent": [
        "fuser"
    ],
    "fusee": [
        "fuser",
        "fusee"
    ],
    "fusees": [
        "fuser",
        "fusee"
    ],
    "fut": [
        "fut",
        "etre"
    ],
    "futaie": [
        "futaie"
    ],
    "futaies": [
        "futaie"
    ],
    "futaille": [
        "futaille"
    ],
    "futailles": [
        "futaille"
    ],
    "futaine": [
        "futaine"
    ],
    "futal": [
        "futal"
    ],
    "futals": [
        "futal"
    ],
    "futile": [
        "futile"
    ],
    "futilement": [
        "futilement"
    ],
    "futiles": [
        "futile"
    ],
    "futilite": [
        "futilite"
    ],
    "futilites": [
        "futilite"
    ],
    "futon": [
        "futon"
    ],
    "futons": [
        "futon"
    ],
    "futur": [
        "futur"
    ],
    "future": [
        "futur"
    ],
    "futures": [
        "futur",
        "future"
    ],
    "futurisme": [
        "futurisme"
    ],
    "futuriste": [
        "futuriste"
    ],
    "futuristes": [
        "futuriste"
    ],
    "futurologue": [
        "futurologue"
    ],
    "futurs": [
        "futur"
    ],
    "fute": [
        "fute"
    ],
    "futee": [
        "fute"
    ],
    "futees": [
        "fute"
    ],
    "futes": [
        "etre",
        "fute"
    ],
    "fuyaient": [
        "fuir"
    ],
    "fuyais": [
        "fuir"
    ],
    "fuyait": [
        "fuir"
    ],
    "fuyant": [
        "fuir",
        "fuyant"
    ],
    "fuyante": [
        "fuyant"
    ],
    "fuyantes": [
        "fuyant"
    ],
    "fuyants": [
        "fuyant"
    ],
    "fuyard": [
        "fuyard"
    ],
    "fuyarde": [
        "fuyard"
    ],
    "fuyards": [
        "fuyard"
    ],
    "fuyez": [
        "fuir"
    ],
    "fuyiez": [
        "fuir"
    ],
    "fuyions": [
        "fuir"
    ],
    "fuyons": [
        "fuir"
    ],
    "fuegien": [
        "fuegien"
    ],
    "fy": [
        "fy"
    ],
    "facha": [
        "facher"
    ],
    "fachai": [
        "facher"
    ],
    "fachaient": [
        "facher"
    ],
    "fachais": [
        "facher"
    ],
    "fachait": [
        "facher"
    ],
    "fache": [
        "facher",
        "fache"
    ],
    "fachent": [
        "facher"
    ],
    "facher": [
        "facher"
    ],
    "fachera": [
        "facher"
    ],
    "facherai": [
        "facher"
    ],
    "facherais": [
        "facher"
    ],
    "facherait": [
        "facher"
    ],
    "facheras": [
        "facher"
    ],
    "facherie": [
        "facherie"
    ],
    "facheries": [
        "facherie"
    ],
    "facheront": [
        "facher"
    ],
    "faches": [
        "facher",
        "fache"
    ],
    "facheuse": [
        "facheux"
    ],
    "facheusement": [
        "facheusement"
    ],
    "facheuses": [
        "facheux"
    ],
    "facheux": [
        "facheux"
    ],
    "fachez": [
        "facher"
    ],
    "fachiez": [
        "facher"
    ],
    "fachions": [
        "facher"
    ],
    "fachons": [
        "facher"
    ],
    "facherent": [
        "facher"
    ],
    "fachee": [
        "facher",
        "fache"
    ],
    "fachees": [
        "facher",
        "fache"
    ],
    "feces": [
        "feces"
    ],
    "fere": [
        "fer"
    ],
    "feve": [
        "feve"
    ],
    "feves": [
        "feve"
    ],
    "feal": [
        "feal"
    ],
    "feaux": [
        "feal"
    ],
    "febrile": [
        "febrile"
    ],
    "febrilement": [
        "febrilement"
    ],
    "febriles": [
        "febrile"
    ],
    "febrilite": [
        "febrilite"
    ],
    "fecal": [
        "fecal"
    ],
    "fecale": [
        "fecal"
    ],
    "fecales": [
        "fecal"
    ],
    "fecalome": [
        "fecalome"
    ],
    "fecaux": [
        "fecal"
    ],
    "fecond": [
        "fecond"
    ],
    "fecondais": [
        "feconder"
    ],
    "fecondait": [
        "feconder"
    ],
    "fecondant": [
        "feconder",
        "fecondant"
    ],
    "fecondante": [
        "fecondant"
    ],
    "fecondateur": [
        "fecondateur"
    ],
    "fecondation": [
        "fecondation"
    ],
    "fecondations": [
        "fecondation"
    ],
    "feconde": [
        "fecond",
        "feconder"
    ],
    "fecondent": [
        "feconder"
    ],
    "feconder": [
        "feconder"
    ],
    "feconderai": [
        "feconder"
    ],
    "feconderait": [
        "feconder"
    ],
    "fecondes": [
        "fecond",
        "feconder"
    ],
    "fecondez": [
        "feconder"
    ],
    "fecondite": [
        "fecondite"
    ],
    "feconds": [
        "fecond"
    ],
    "fecondee": [
        "feconder"
    ],
    "fecondees": [
        "feconder"
    ],
    "fecule": [
        "fecule"
    ],
    "feculent": [
        "feculent"
    ],
    "feculents": [
        "feculent"
    ],
    "federal": [
        "federal"
    ],
    "federale": [
        "federal"
    ],
    "federales": [
        "federal"
    ],
    "federalisme": [
        "federalisme"
    ],
    "federaliste": [
        "federaliste"
    ],
    "federateur": [
        "federateur"
    ],
    "federation": [
        "federation"
    ],
    "federations": [
        "federation"
    ],
    "federative": [
        "federatif"
    ],
    "federatrice": [
        "federateur"
    ],
    "federaux": [
        "federal"
    ],
    "federer": [
        "federer"
    ],
    "federe": [
        "federe",
        "federer"
    ],
    "federee": [
        "federe",
        "federer"
    ],
    "federees": [
        "federe"
    ],
    "federes": [
        "federe",
        "federer"
    ],
    "fee": [
        "fee"
    ],
    "feerie": [
        "feerie"
    ],
    "feeries": [
        "feerie"
    ],
    "feerique": [
        "feerique"
    ],
    "feeriquement": [
        "feeriquement"
    ],
    "feeriques": [
        "feerique"
    ],
    "fees": [
        "fee"
    ],
    "felibre": [
        "felibre"
    ],
    "felibres": [
        "felibre"
    ],
    "felibrige": [
        "felibrige"
    ],
    "felicita": [
        "feliciter"
    ],
    "felicitai": [
        "feliciter"
    ],
    "felicitaient": [
        "feliciter"
    ],
    "felicitais": [
        "feliciter"
    ],
    "felicitait": [
        "feliciter"
    ],
    "felicitant": [
        "feliciter"
    ],
    "felicitation": [
        "felicitation"
    ],
    "felicitations": [
        "felicitation"
    ],
    "felicite": [
        "feliciter",
        "felicite"
    ],
    "felicitent": [
        "feliciter"
    ],
    "feliciter": [
        "feliciter"
    ],
    "felicitera": [
        "feliciter"
    ],
    "feliciterai": [
        "feliciter"
    ],
    "feliciteraient": [
        "feliciter"
    ],
    "feliciterais": [
        "feliciter"
    ],
    "feliciterait": [
        "feliciter"
    ],
    "feliciteras": [
        "feliciter"
    ],
    "feliciteriez": [
        "feliciter"
    ],
    "felicitez": [
        "feliciter"
    ],
    "felicitiez": [
        "feliciter"
    ],
    "felicitions": [
        "feliciter"
    ],
    "felicitons": [
        "feliciter"
    ],
    "felicitames": [
        "feliciter"
    ],
    "feliciterent": [
        "feliciter"
    ],
    "felicitee": [
        "feliciter"
    ],
    "felicites": [
        "feliciter",
        "felicite"
    ],
    "felide": [
        "felide"
    ],
    "felin": [
        "felin"
    ],
    "feline": [
        "felin"
    ],
    "felinement": [
        "felinement"
    ],
    "felines": [
        "felin",
        "feline"
    ],
    "felinite": [
        "felinite"
    ],
    "felins": [
        "felin"
    ],
    "felon": [
        "felon"
    ],
    "felonie": [
        "felonie"
    ],
    "felonne": [
        "felon"
    ],
    "felons": [
        "felon"
    ],
    "feminin": [
        "feminin"
    ],
    "feminine": [
        "feminin"
    ],
    "feminines": [
        "feminine",
        "feminin"
    ],
    "feminins": [
        "feminin"
    ],
    "feminisaient": [
        "feminiser"
    ],
    "feminisation": [
        "feminisation"
    ],
    "feminiser": [
        "feminiser"
    ],
    "feminisme": [
        "feminisme"
    ],
    "feministe": [
        "feministe"
    ],
    "feministes": [
        "feministe"
    ],
    "feminise": [
        "feminiser"
    ],
    "feminitude": [
        "feminitude"
    ],
    "feminite": [
        "feminite"
    ],
    "feminites": [
        "feminite"
    ],
    "femoral": [
        "femoral"
    ],
    "femorale": [
        "femoral"
    ],
    "femorales": [
        "femoral"
    ],
    "femoraux": [
        "femoral"
    ],
    "femur": [
        "femur"
    ],
    "femurs": [
        "femur"
    ],
    "fenelonienne": [
        "fenelonien"
    ],
    "feodal": [
        "feodal"
    ],
    "feodale": [
        "feodal"
    ],
    "feodales": [
        "feodal"
    ],
    "feodalisme": [
        "feodalisme"
    ],
    "feodalite": [
        "feodalite"
    ],
    "feodaux": [
        "feodal"
    ],
    "ferir": [
        "ferir"
    ],
    "ferie": [
        "ferie"
    ],
    "feries": [
        "ferie"
    ],
    "feroce": [
        "feroce"
    ],
    "ferocement": [
        "ferocement"
    ],
    "feroces": [
        "feroce"
    ],
    "ferocite": [
        "ferocite"
    ],
    "ferocites": [
        "ferocite"
    ],
    "feru": [
        "feru"
    ],
    "ferue": [
        "feru"
    ],
    "ferues": [
        "feru"
    ],
    "ferule": [
        "ferule"
    ],
    "ferus": [
        "feru"
    ],
    "fetiche": [
        "fetiche"
    ],
    "fetiches": [
        "fetiche"
    ],
    "feticheur": [
        "feticheur"
    ],
    "feticheurs": [
        "feticheur"
    ],
    "fetichisations": [
        "fetichisation"
    ],
    "fetichisme": [
        "fetichisme"
    ],
    "fetichismes": [
        "fetichisme"
    ],
    "fetichiste": [
        "fetichiste"
    ],
    "fetichistes": [
        "fetichiste"
    ],
    "fetide": [
        "fetide"
    ],
    "fetides": [
        "fetide"
    ],
    "fetidite": [
        "fetidite"
    ],
    "fetu": [
        "fetu"
    ],
    "fetuque": [
        "fetuque"
    ],
    "fetus": [
        "fetu"
    ],
    "feveroles": [
        "feverole"
    ],
    "fevrier": [
        "fevrier"
    ],
    "fela": [
        "feler"
    ],
    "felant": [
        "feler"
    ],
    "fele": [
        "feler",
        "fele"
    ],
    "feler": [
        "feler"
    ],
    "feles": [
        "feler",
        "fele"
    ],
    "felure": [
        "felure"
    ],
    "felures": [
        "felure"
    ],
    "felee": [
        "feler",
        "fele"
    ],
    "felees": [
        "feler",
        "fele"
    ],
    "fetaient": [
        "feter"
    ],
    "fetait": [
        "feter"
    ],
    "fetant": [
        "feter"
    ],
    "fetard": [
        "fetard"
    ],
    "fetards": [
        "fetard"
    ],
    "fete": [
        "feter",
        "fete"
    ],
    "fetent": [
        "feter"
    ],
    "feter": [
        "feter"
    ],
    "fetera": [
        "feter"
    ],
    "feterait": [
        "feter"
    ],
    "feterons": [
        "feter"
    ],
    "fetes": [
        "feter",
        "fete"
    ],
    "fetez": [
        "feter"
    ],
    "fetions": [
        "feter"
    ],
    "fetons": [
        "feter"
    ],
    "fetames": [
        "feter"
    ],
    "feterent": [
        "feter"
    ],
    "fetee": [
        "feter"
    ],
    "fimes": [
        "faire"
    ],
    "fites": [
        "faire"
    ],
    "futs": [
        "fut"
    ],
    "fuhrer": [
        "fuhrer"
    ],
    "fuhrers": [
        "fuhrer"
    ],
    "g": [
        "g"
    ],
    "gaba": [
        "gaba"
    ],
    "gabardine": [
        "gabardine"
    ],
    "gabardines": [
        "gabardine"
    ],
    "gabare": [
        "gabare"
    ],
    "gabariers": [
        "gabarier"
    ],
    "gabarit": [
        "gabarit"
    ],
    "gabarits": [
        "gabarit"
    ],
    "gabarres": [
        "gabarre"
    ],
    "gabbro": [
        "gabbro"
    ],
    "gabe": [
        "gaber"
    ],
    "gabegie": [
        "gabegie"
    ],
    "gabelle": [
        "gabelle"
    ],
    "gabelou": [
        "gabelou"
    ],
    "gabier": [
        "gabier"
    ],
    "gabiers": [
        "gabier"
    ],
    "gabion": [
        "gabion"
    ],
    "gabions": [
        "gabion"
    ],
    "gable": [
        "gable"
    ],
    "gables": [
        "gable"
    ],
    "gabonais": [
        "gabonais"
    ],
    "gabonaise": [
        "gabonais"
    ],
    "gade": [
        "gade"
    ],
    "gadget": [
        "gadget"
    ],
    "gadgets": [
        "gadget"
    ],
    "gadin": [
        "gadin"
    ],
    "gadins": [
        "gadin"
    ],
    "gadjo": [
        "gadjo"
    ],
    "gadolinium": [
        "gadolinium"
    ],
    "gadoue": [
        "gadoue"
    ],
    "gadoues": [
        "gadoue"
    ],
    "gadouille": [
        "gadouille"
    ],
    "gaffa": [
        "gaffer"
    ],
    "gaffaient": [
        "gaffer"
    ],
    "gaffais": [
        "gaffer"
    ],
    "gaffait": [
        "gaffer"
    ],
    "gaffant": [
        "gaffer"
    ],
    "gaffe": [
        "gaffe",
        "gaffer"
    ],
    "gaffent": [
        "gaffer"
    ],
    "gaffer": [
        "gaffer"
    ],
    "gafferai": [
        "gaffer"
    ],
    "gaffes": [
        "gaffe",
        "gaffer"
    ],
    "gaffeur": [
        "gaffeur"
    ],
    "gaffeurs": [
        "gaffeur"
    ],
    "gaffeuse": [
        "gaffeur"
    ],
    "gaffeuses": [
        "gaffeur"
    ],
    "gaffez": [
        "gaffer"
    ],
    "gaffee": [
        "gaffer"
    ],
    "gag": [
        "gag"
    ],
    "gaga": [
        "gaga"
    ],
    "gagas": [
        "gaga"
    ],
    "gage": [
        "gage",
        "gager"
    ],
    "gageaient": [
        "gager"
    ],
    "gageons": [
        "gager"
    ],
    "gager": [
        "gager"
    ],
    "gagerai": [
        "gager"
    ],
    "gagerais": [
        "gager"
    ],
    "gages": [
        "gage",
        "gager"
    ],
    "gageure": [
        "gageure"
    ],
    "gageures": [
        "gageure"
    ],
    "gagez": [
        "gager"
    ],
    "gagna": [
        "gagner"
    ],
    "gagnage": [
        "gagnage"
    ],
    "gagnages": [
        "gagnage"
    ],
    "gagnai": [
        "gagner"
    ],
    "gagnaient": [
        "gagner"
    ],
    "gagnais": [
        "gagner"
    ],
    "gagnait": [
        "gagner"
    ],
    "gagnant": [
        "gagnant",
        "gagner"
    ],
    "gagnante": [
        "gagnant"
    ],
    "gagnantes": [
        "gagnant"
    ],
    "gagnants": [
        "gagnant"
    ],
    "gagne": [
        "gagner",
        "gagne"
    ],
    "gagnent": [
        "gagner"
    ],
    "gagner": [
        "gagner"
    ],
    "gagnera": [
        "gagner"
    ],
    "gagnerai": [
        "gagner"
    ],
    "gagneraient": [
        "gagner"
    ],
    "gagnerais": [
        "gagner"
    ],
    "gagnerait": [
        "gagner"
    ],
    "gagneras": [
        "gagner"
    ],
    "gagnerez": [
        "gagner"
    ],
    "gagneriez": [
        "gagner"
    ],
    "gagnerions": [
        "gagner"
    ],
    "gagnerons": [
        "gagner"
    ],
    "gagneront": [
        "gagner"
    ],
    "gagnes": [
        "gagner",
        "gagne"
    ],
    "gagneur": [
        "gagneur"
    ],
    "gagneurs": [
        "gagneur"
    ],
    "gagneuse": [
        "gagneur"
    ],
    "gagneuses": [
        "gagneur"
    ],
    "gagnez": [
        "gagner"
    ],
    "gagniez": [
        "gagner"
    ],
    "gagnions": [
        "gagner"
    ],
    "gagnons": [
        "gagner"
    ],
    "gagnames": [
        "gagner"
    ],
    "gagnat": [
        "gagner"
    ],
    "gagnerent": [
        "gagner"
    ],
    "gagnee": [
        "gagner",
        "gagne"
    ],
    "gagnees": [
        "gagner",
        "gagne"
    ],
    "gags": [
        "gag"
    ],
    "gagee": [
        "gager"
    ],
    "gai": [
        "gai"
    ],
    "gaie": [
        "gai"
    ],
    "gaiement": [
        "gaiement"
    ],
    "gaies": [
        "gai"
    ],
    "gaiete": [
        "gaiete"
    ],
    "gaietes": [
        "gaiete"
    ],
    "gail": [
        "gail"
    ],
    "gaillard": [
        "gaillard"
    ],
    "gaillarde": [
        "gaillard"
    ],
    "gaillardement": [
        "gaillardement"
    ],
    "gaillardes": [
        "gaillard"
    ],
    "gaillardise": [
        "gaillardise"
    ],
    "gaillards": [
        "gaillard"
    ],
    "gaillet": [
        "gaillet"
    ],
    "gaillette": [
        "gaillette"
    ],
    "gaillettes": [
        "gaillette"
    ],
    "gain": [
        "gain"
    ],
    "gainaient": [
        "gainer"
    ],
    "gainait": [
        "gainer"
    ],
    "gaine": [
        "gaine",
        "gainer"
    ],
    "gainent": [
        "gainer"
    ],
    "gainer": [
        "gainer"
    ],
    "gaines": [
        "gaine",
        "gainer"
    ],
    "gainiers": [
        "gainier"
    ],
    "gains": [
        "gain"
    ],
    "gainee": [
        "gainer"
    ],
    "gainees": [
        "gaine",
        "gainer"
    ],
    "gais": [
        "gai"
    ],
    "gal": [
        "gal"
    ],
    "gala": [
        "gala"
    ],
    "galactique": [
        "galactique"
    ],
    "galactiques": [
        "galactique"
    ],
    "galactophore": [
        "galactophore"
    ],
    "galago": [
        "galago"
    ],
    "galalithe": [
        "galalithe"
    ],
    "galamment": [
        "galamment"
    ],
    "galant": [
        "galant"
    ],
    "galante": [
        "galant"
    ],
    "galanterie": [
        "galanterie"
    ],
    "galanteries": [
        "galanterie"
    ],
    "galantes": [
        "galant"
    ],
    "galantine": [
        "galantine"
    ],
    "galantines": [
        "galantine"
    ],
    "galantins": [
        "galantin"
    ],
    "galantisait": [
        "galantiser"
    ],
    "galantise": [
        "galantiser"
    ],
    "galants": [
        "galant"
    ],
    "galapiat": [
        "galapiat"
    ],
    "galapiats": [
        "galapiat"
    ],
    "galas": [
        "gala"
    ],
    "galate": [
        "galate"
    ],
    "galates": [
        "galate"
    ],
    "galathee": [
        "galathee"
    ],
    "galaxie": [
        "galaxie"
    ],
    "galaxies": [
        "galaxie",
        "galaxy"
    ],
    "galbait": [
        "galber"
    ],
    "galbe": [
        "galber",
        "galbe"
    ],
    "galber": [
        "galber"
    ],
    "galbes": [
        "galber",
        "galbe"
    ],
    "galbee": [
        "galber",
        "galbe"
    ],
    "galbees": [
        "galber",
        "galbe"
    ],
    "gale": [
        "gale"
    ],
    "galerie": [
        "galerie"
    ],
    "galeries": [
        "galerie"
    ],
    "galeriste": [
        "galeriste"
    ],
    "galernes": [
        "galerne"
    ],
    "gales": [
        "gale"
    ],
    "galet": [
        "galet"
    ],
    "galetas": [
        "galetas"
    ],
    "galetouse": [
        "galetouse"
    ],
    "galets": [
        "galet"
    ],
    "galette": [
        "galette"
    ],
    "galettes": [
        "galette"
    ],
    "galetteux": [
        "galetteux"
    ],
    "galeuse": [
        "galeux"
    ],
    "galeuses": [
        "galeux"
    ],
    "galeux": [
        "galeux"
    ],
    "galibot": [
        "galibot"
    ],
    "galibots": [
        "galibot"
    ],
    "galicien": [
        "galicien"
    ],
    "galiciennes": [
        "galicien"
    ],
    "galiciens": [
        "galicien"
    ],
    "galileen": [
        "galileen"
    ],
    "galimatias": [
        "galimatias"
    ],
    "galion": [
        "galion"
    ],
    "galions": [
        "galion"
    ],
    "galiote": [
        "galiote"
    ],
    "galiotes": [
        "galiote"
    ],
    "galipette": [
        "galipette"
    ],
    "galipettes": [
        "galipette"
    ],
    "gallant": [
        "galler"
    ],
    "galle": [
        "galle"
    ],
    "galles": [
        "galle"
    ],
    "gallicanes": [
        "gallican"
    ],
    "gallicanisme": [
        "gallicanisme"
    ],
    "gallinace": [
        "gallinace"
    ],
    "galline": [
        "galline"
    ],
    "gallique": [
        "gallique"
    ],
    "gallium": [
        "gallium"
    ],
    "gallo": [
        "gallo"
    ],
    "gallois": [
        "gallois"
    ],
    "galloise": [
        "gallois",
        "galloise"
    ],
    "galloises": [
        "gallois"
    ],
    "gallon": [
        "gallon"
    ],
    "gallons": [
        "gallon"
    ],
    "gallos": [
        "gallo"
    ],
    "galoche": [
        "galoche",
        "galocher"
    ],
    "galoches": [
        "galoche",
        "galocher"
    ],
    "galon": [
        "galon"
    ],
    "galonnage": [
        "galonnage"
    ],
    "galonnait": [
        "galonner"
    ],
    "galonne": [
        "galonner",
        "galonne"
    ],
    "galonnee": [
        "galonner",
        "galonne"
    ],
    "galonnees": [
        "galonner",
        "galonne"
    ],
    "galonnes": [
        "galonner",
        "galonne"
    ],
    "galons": [
        "galon"
    ],
    "galop": [
        "galop"
    ],
    "galopa": [
        "galoper"
    ],
    "galopade": [
        "galopade"
    ],
    "galopades": [
        "galopade"
    ],
    "galopaient": [
        "galoper"
    ],
    "galopais": [
        "galoper"
    ],
    "galopait": [
        "galoper"
    ],
    "galopant": [
        "galopant",
        "galoper"
    ],
    "galopante": [
        "galopant"
    ],
    "galopantes": [
        "galopant"
    ],
    "galopants": [
        "galopant"
    ],
    "galope": [
        "galope",
        "galoper"
    ],
    "galopent": [
        "galoper"
    ],
    "galoper": [
        "galoper"
    ],
    "galopera": [
        "galoper"
    ],
    "galoperaient": [
        "galoper"
    ],
    "galoperez": [
        "galoper"
    ],
    "galopes": [
        "galoper"
    ],
    "galopez": [
        "galoper"
    ],
    "galopin": [
        "galopin"
    ],
    "galopine": [
        "galopin"
    ],
    "galopiner": [
        "galopiner"
    ],
    "galopines": [
        "galopin"
    ],
    "galopins": [
        "galopin"
    ],
    "galopons": [
        "galoper"
    ],
    "galops": [
        "galop"
    ],
    "galoperent": [
        "galoper"
    ],
    "galoubet": [
        "galoubet"
    ],
    "galoup": [
        "galoup"
    ],
    "galtouse": [
        "galtouse"
    ],
    "galtouses": [
        "galtouse"
    ],
    "galuchat": [
        "galuchat"
    ],
    "galure": [
        "galure"
    ],
    "galures": [
        "galure"
    ],
    "galurin": [
        "galurin"
    ],
    "galvanique": [
        "galvanique"
    ],
    "galvanisa": [
        "galvaniser"
    ],
    "galvanisait": [
        "galvaniser"
    ],
    "galvanisant": [
        "galvaniser"
    ],
    "galvanise": [
        "galvaniser"
    ],
    "galvaniser": [
        "galvaniser"
    ],
    "galvanisme": [
        "galvanisme"
    ],
    "galvanisee": [
        "galvaniser"
    ],
    "galvanisees": [
        "galvaniser"
    ],
    "galvanises": [
        "galvaniser"
    ],
    "galvaudait": [
        "galvauder"
    ],
    "galvaudant": [
        "galvauder"
    ],
    "galvaude": [
        "galvauder"
    ],
    "galvaudent": [
        "galvauder"
    ],
    "galvauder": [
        "galvauder"
    ],
    "galvaudeux": [
        "galvaudeux"
    ],
    "galvaudez": [
        "galvauder"
    ],
    "galvaudiez": [
        "galvauder"
    ],
    "galvaudee": [
        "galvauder"
    ],
    "galene": [
        "galene"
    ],
    "galere": [
        "galerer",
        "galer"
    ],
    "galerent": [
        "galerer"
    ],
    "galeres": [
        "galerer",
        "galere",
        "galer"
    ],
    "galeasses": [
        "galeasse"
    ],
    "galee": [
        "galee"
    ],
    "galees": [
        "galee"
    ],
    "galejade": [
        "galejade"
    ],
    "galejades": [
        "galejade"
    ],
    "galejeur": [
        "galejeur"
    ],
    "galeniste": [
        "galeniste"
    ],
    "galerais": [
        "galerer"
    ],
    "galerait": [
        "galerer"
    ],
    "galerer": [
        "galerer"
    ],
    "galerien": [
        "galerien"
    ],
    "galeriens": [
        "galerien"
    ],
    "gamahuche": [
        "gamahucher"
    ],
    "gamay": [
        "gamay"
    ],
    "gambada": [
        "gambader"
    ],
    "gambadaient": [
        "gambader"
    ],
    "gambadais": [
        "gambader"
    ],
    "gambadait": [
        "gambader"
    ],
    "gambadant": [
        "gambader",
        "gambadant"
    ],
    "gambadante": [
        "gambadant"
    ],
    "gambade": [
        "gambader",
        "gambade"
    ],
    "gambadent": [
        "gambader"
    ],
    "gambader": [
        "gambader"
    ],
    "gambades": [
        "gambader",
        "gambade"
    ],
    "gambadeurs": [
        "gambadeur"
    ],
    "gambadez": [
        "gambader"
    ],
    "gambaderent": [
        "gambader"
    ],
    "gambas": [
        "gamba"
    ],
    "gambe": [
        "gambe"
    ],
    "gamberge": [
        "gamberger",
        "gamberge"
    ],
    "gambergea": [
        "gamberger"
    ],
    "gambergeaient": [
        "gamberger"
    ],
    "gambergeailler": [
        "gambergeailler"
    ],
    "gambergeais": [
        "gamberger"
    ],
    "gambergeait": [
        "gamberger"
    ],
    "gambergeant": [
        "gamberger"
    ],
    "gambergent": [
        "gamberger"
    ],
    "gambergeons": [
        "gamberger"
    ],
    "gamberger": [
        "gamberger"
    ],
    "gamberges": [
        "gamberger",
        "gamberge"
    ],
    "gambergez": [
        "gamberger"
    ],
    "gambette": [
        "gambette"
    ],
    "gambettes": [
        "gambette"
    ],
    "gambillait": [
        "gambiller"
    ],
    "gambillant": [
        "gambiller"
    ],
    "gambille": [
        "gambiller"
    ],
    "gambiller": [
        "gambiller"
    ],
    "gambilles": [
        "gambiller"
    ],
    "gambilleurs": [
        "gambilleur"
    ],
    "gambilleuses": [
        "gambilleur"
    ],
    "gambit": [
        "gambit"
    ],
    "game": [
        "game"
    ],
    "gamelan": [
        "gamelan"
    ],
    "gamelle": [
        "gamelle"
    ],
    "gamelles": [
        "gamelle"
    ],
    "gamin": [
        "gamin"
    ],
    "gaminas": [
        "gaminer"
    ],
    "gamine": [
        "gamin"
    ],
    "gaminement": [
        "gaminement"
    ],
    "gaminerie": [
        "gaminerie"
    ],
    "gamineries": [
        "gaminerie"
    ],
    "gamines": [
        "gamin"
    ],
    "gamins": [
        "gamin"
    ],
    "gamma": [
        "gamma"
    ],
    "gammaglobuline": [
        "gammaglobuline"
    ],
    "gammaglobulines": [
        "gammaglobuline"
    ],
    "gammas": [
        "gamma",
        "gammas"
    ],
    "gamme": [
        "gamme"
    ],
    "gammes": [
        "gamme"
    ],
    "gammee": [
        "gammee"
    ],
    "gammees": [
        "gammee"
    ],
    "gamete": [
        "gamete"
    ],
    "gametes": [
        "gamete"
    ],
    "gan": [
        "gan"
    ],
    "ganache": [
        "ganache"
    ],
    "ganaderia": [
        "ganaderia"
    ],
    "ganaderias": [
        "ganaderia"
    ],
    "gandin": [
        "gandin"
    ],
    "gandins": [
        "gandin"
    ],
    "gandoura": [
        "gandoura"
    ],
    "gandourah": [
        "gandourah"
    ],
    "gandouras": [
        "gandoura"
    ],
    "gang": [
        "gang"
    ],
    "ganglion": [
        "ganglion"
    ],
    "ganglionnaires": [
        "ganglionnaire"
    ],
    "ganglions": [
        "ganglion"
    ],
    "gangrena": [
        "gangrener"
    ],
    "gangrener": [
        "gangrener"
    ],
    "gangreneux": [
        "gangreneux"
    ],
    "gangrene": [
        "gangrener",
        "gangrene"
    ],
    "gangrenee": [
        "gangrener"
    ],
    "gangrenees": [
        "gangrener",
        "gangrene"
    ],
    "gangrenes": [
        "gangrener",
        "gangrene"
    ],
    "gangs": [
        "gang"
    ],
    "gangster": [
        "gangster"
    ],
    "gangsters": [
        "gangster"
    ],
    "gangsterisme": [
        "gangsterisme"
    ],
    "gangue": [
        "gangue"
    ],
    "gangues": [
        "gangue"
    ],
    "ganja": [
        "ganja"
    ],
    "ganse": [
        "ganser",
        "ganse"
    ],
    "ganses": [
        "ganse"
    ],
    "gansee": [
        "ganser"
    ],
    "gant": [
        "gant"
    ],
    "gantait": [
        "ganter"
    ],
    "gantant": [
        "ganter"
    ],
    "gante": [
        "gante",
        "ganter"
    ],
    "gantelet": [
        "gantelet"
    ],
    "gantelets": [
        "gantelet"
    ],
    "ganterie": [
        "ganterie"
    ],
    "gantier": [
        "gantier"
    ],
    "gantieres": [
        "gantier"
    ],
    "gants": [
        "gant"
    ],
    "gantee": [
        "gante",
        "ganter"
    ],
    "gantees": [
        "gante",
        "ganter"
    ],
    "gantes": [
        "gante",
        "ganter"
    ],
    "ganymedes": [
        "ganymede"
    ],
    "gap": [
        "gap"
    ],
    "gaperon": [
        "gaperon"
    ],
    "gapette": [
        "gapette"
    ],
    "gapettes": [
        "gapette"
    ],
    "gara": [
        "garer"
    ],
    "garage": [
        "garage"
    ],
    "garages": [
        "garage"
    ],
    "garagiste": [
        "garagiste"
    ],
    "garagistes": [
        "garagiste"
    ],
    "garaient": [
        "garer"
    ],
    "garais": [
        "garer"
    ],
    "garait": [
        "garer"
    ],
    "garance": [
        "garance"
    ],
    "garanciere": [
        "garanciere"
    ],
    "garant": [
        "garer",
        "garant"
    ],
    "garante": [
        "garant"
    ],
    "garantes": [
        "garant"
    ],
    "garanti": [
        "garantir",
        "garanti"
    ],
    "garantie": [
        "garantir",
        "garantie",
        "garanti"
    ],
    "garanties": [
        "garantir",
        "garantie",
        "garanti"
    ],
    "garantir": [
        "garantir"
    ],
    "garantira": [
        "garantir"
    ],
    "garantirais": [
        "garantir"
    ],
    "garantirait": [
        "garantir"
    ],
    "garantiriez": [
        "garantir"
    ],
    "garantirons": [
        "garantir"
    ],
    "garantiront": [
        "garantir"
    ],
    "garantis": [
        "garantir",
        "garanti"
    ],
    "garantissaient": [
        "garantir"
    ],
    "garantissais": [
        "garantir"
    ],
    "garantissait": [
        "garantir"
    ],
    "garantissant": [
        "garantir"
    ],
    "garantisse": [
        "garantir"
    ],
    "garantissent": [
        "garantir"
    ],
    "garantissez": [
        "garantir"
    ],
    "garantissons": [
        "garantir"
    ],
    "garantit": [
        "garantir"
    ],
    "garants": [
        "garant"
    ],
    "garbure": [
        "garbure"
    ],
    "garce": [
        "garce"
    ],
    "garces": [
        "garce"
    ],
    "garcette": [
        "garcette"
    ],
    "garcettes": [
        "garcette"
    ],
    "garda": [
        "garder"
    ],
    "gardai": [
        "garder"
    ],
    "gardaient": [
        "garder"
    ],
    "gardais": [
        "garder"
    ],
    "gardait": [
        "garder"
    ],
    "gardant": [
        "garder"
    ],
    "garde": [
        "garder",
        "garde"
    ],
    "gardent": [
        "garder"
    ],
    "garder": [
        "garder"
    ],
    "gardera": [
        "garder"
    ],
    "garderai": [
        "garder"
    ],
    "garderaient": [
        "garder"
    ],
    "garderais": [
        "garder"
    ],
    "garderait": [
        "garder"
    ],
    "garderas": [
        "garder"
    ],
    "garderez": [
        "garder"
    ],
    "garderie": [
        "garderie"
    ],
    "garderies": [
        "garderie"
    ],
    "garderiez": [
        "garder"
    ],
    "garderions": [
        "garder"
    ],
    "garderons": [
        "garder"
    ],
    "garderont": [
        "garder"
    ],
    "gardes": [
        "garder",
        "garde"
    ],
    "gardeur": [
        "gardeur"
    ],
    "gardeurs": [
        "gardeur"
    ],
    "gardeuse": [
        "gardeur"
    ],
    "gardeuses": [
        "gardeur"
    ],
    "gardez": [
        "garder"
    ],
    "gardian": [
        "gardian"
    ],
    "gardians": [
        "gardian"
    ],
    "gardien": [
        "gardien"
    ],
    "gardiennage": [
        "gardiennage"
    ],
    "gardiennait": [
        "gardienner"
    ],
    "gardienne": [
        "gardien"
    ],
    "gardiennes": [
        "gardien"
    ],
    "gardiens": [
        "gardien"
    ],
    "gardiez": [
        "garder"
    ],
    "gardions": [
        "garder"
    ],
    "gardois": [
        "gardois"
    ],
    "gardon": [
        "gardon"
    ],
    "gardons": [
        "garder",
        "gardon"
    ],
    "gardames": [
        "garder"
    ],
    "gardat": [
        "garder"
    ],
    "garderent": [
        "garder"
    ],
    "gardee": [
        "garder",
        "garde"
    ],
    "gardees": [
        "garder",
        "garde"
    ],
    "gardenal": [
        "gardenal"
    ],
    "gardenia": [
        "gardenia"
    ],
    "gardenias": [
        "gardenia"
    ],
    "gare": [
        "garer",
        "gare"
    ],
    "garenne": [
        "garenne"
    ],
    "garennes": [
        "garenne"
    ],
    "garent": [
        "garer"
    ],
    "garer": [
        "garer"
    ],
    "garerai": [
        "garer"
    ],
    "garerais": [
        "garer"
    ],
    "garerait": [
        "garer"
    ],
    "gareront": [
        "garer"
    ],
    "gares": [
        "garer",
        "gare"
    ],
    "garez": [
        "garer"
    ],
    "gargamelle": [
        "gargamelle"
    ],
    "gargantua": [
        "gargantua"
    ],
    "gargantuesque": [
        "gargantuesque"
    ],
    "gargantuesques": [
        "gargantuesque"
    ],
    "gargarisa": [
        "gargariser"
    ],
    "gargarisaient": [
        "gargariser"
    ],
    "gargarisait": [
        "gargariser"
    ],
    "gargarisant": [
        "gargariser"
    ],
    "gargarise": [
        "gargariser"
    ],
    "gargarisent": [
        "gargariser"
    ],
    "gargariser": [
        "gargariser"
    ],
    "gargarisme": [
        "gargarisme"
    ],
    "gargarismes": [
        "gargarisme"
    ],
    "gargote": [
        "gargote"
    ],
    "gargotes": [
        "gargote"
    ],
    "gargotier": [
        "gargotier"
    ],
    "gargotiers": [
        "gargotier"
    ],
    "gargouilla": [
        "gargouiller"
    ],
    "gargouillaient": [
        "gargouiller"
    ],
    "gargouillait": [
        "gargouiller"
    ],
    "gargouillant": [
        "gargouiller",
        "gargouillant"
    ],
    "gargouillante": [
        "gargouillant"
    ],
    "gargouille": [
        "gargouille",
        "gargouiller"
    ],
    "gargouillement": [
        "gargouillement"
    ],
    "gargouillements": [
        "gargouillement"
    ],
    "gargouillent": [
        "gargouiller"
    ],
    "gargouiller": [
        "gargouiller"
    ],
    "gargouilles": [
        "gargouille"
    ],
    "gargouillette": [
        "gargouillette"
    ],
    "gargouillis": [
        "gargouillis"
    ],
    "gargoulette": [
        "gargoulette"
    ],
    "gargoulettes": [
        "gargoulette"
    ],
    "gargousses": [
        "gargousse"
    ],
    "gari": [
        "gari"
    ],
    "garibaldien": [
        "garibaldien"
    ],
    "garibaldiens": [
        "garibaldien"
    ],
    "garions": [
        "garer"
    ],
    "garnement": [
        "garnement"
    ],
    "garnements": [
        "garnement"
    ],
    "garni": [
        "garnir",
        "garni"
    ],
    "garnie": [
        "garnir",
        "garni"
    ],
    "garnies": [
        "garnir",
        "garni"
    ],
    "garnir": [
        "garnir"
    ],
    "garnirent": [
        "garnir"
    ],
    "garniront": [
        "garnir"
    ],
    "garnis": [
        "garnir",
        "garni"
    ],
    "garnison": [
        "garnison"
    ],
    "garnisons": [
        "garnison"
    ],
    "garnissage": [
        "garnissage"
    ],
    "garnissaient": [
        "garnir"
    ],
    "garnissais": [
        "garnir"
    ],
    "garnissait": [
        "garnir"
    ],
    "garnissant": [
        "garnir"
    ],
    "garnissent": [
        "garnir"
    ],
    "garnissez": [
        "garnir"
    ],
    "garnit": [
        "garnir"
    ],
    "garniture": [
        "garniture"
    ],
    "garnitures": [
        "garniture"
    ],
    "garno": [
        "garno"
    ],
    "garons": [
        "garer"
    ],
    "garou": [
        "garou"
    ],
    "garrick": [
        "garrick"
    ],
    "garrigue": [
        "garrigue"
    ],
    "garrigues": [
        "garrigue"
    ],
    "garrot": [
        "garrot"
    ],
    "garrots": [
        "garrot"
    ],
    "garrottaient": [
        "garrotter"
    ],
    "garrotte": [
        "garrotte",
        "garrotter"
    ],
    "garrottent": [
        "garrotter"
    ],
    "garrotter": [
        "garrotter"
    ],
    "garrottee": [
        "garrotter"
    ],
    "garrottes": [
        "garrotter"
    ],
    "gars": [
        "gars"
    ],
    "garcon": [
        "garcon"
    ],
    "garconne": [
        "garconne"
    ],
    "garconnet": [
        "garconnet"
    ],
    "garconnets": [
        "garconnet"
    ],
    "garconnier": [
        "garconnier"
    ],
    "garconniers": [
        "garconnier"
    ],
    "garconniere": [
        "garconnier",
        "garconniere"
    ],
    "garconnieres": [
        "garconniere"
    ],
    "garcons": [
        "garcon"
    ],
    "garerent": [
        "garer"
    ],
    "garee": [
        "garer"
    ],
    "garees": [
        "garer"
    ],
    "gascon": [
        "gascon"
    ],
    "gasconne": [
        "gascon"
    ],
    "gascons": [
        "gascon"
    ],
    "gasoil": [
        "gasoil"
    ],
    "gaspacho": [
        "gaspacho"
    ],
    "gaspard": [
        "gaspard"
    ],
    "gaspards": [
        "gaspard"
    ],
    "gaspilla": [
        "gaspiller"
    ],
    "gaspillage": [
        "gaspillage"
    ],
    "gaspillages": [
        "gaspillage"
    ],
    "gaspillaient": [
        "gaspiller"
    ],
    "gaspillait": [
        "gaspiller"
    ],
    "gaspillant": [
        "gaspiller"
    ],
    "gaspillasse": [
        "gaspiller"
    ],
    "gaspille": [
        "gaspiller"
    ],
    "gaspillent": [
        "gaspiller"
    ],
    "gaspiller": [
        "gaspiller"
    ],
    "gaspillerai": [
        "gaspiller"
    ],
    "gaspilleraient": [
        "gaspiller"
    ],
    "gaspillerais": [
        "gaspiller"
    ],
    "gaspillerez": [
        "gaspiller"
    ],
    "gaspilles": [
        "gaspiller"
    ],
    "gaspilleur": [
        "gaspilleur"
    ],
    "gaspilleurs": [
        "gaspilleur"
    ],
    "gaspilleuse": [
        "gaspilleur"
    ],
    "gaspilleuses": [
        "gaspilleur"
    ],
    "gaspillez": [
        "gaspiller"
    ],
    "gaspillons": [
        "gaspiller"
    ],
    "gaspillat": [
        "gaspiller"
    ],
    "gaspillee": [
        "gaspiller"
    ],
    "gaspillees": [
        "gaspiller"
    ],
    "gaster": [
        "gaster"
    ],
    "gastralgie": [
        "gastralgie"
    ],
    "gastralgies": [
        "gastralgie"
    ],
    "gastrectomie": [
        "gastrectomie"
    ],
    "gastrique": [
        "gastrique"
    ],
    "gastriques": [
        "gastrique"
    ],
    "gastrite": [
        "gastrite"
    ],
    "gastrites": [
        "gastrite"
    ],
    "gastro": [
        "gastro"
    ],
    "gastroenterologue": [
        "gastroenterologue"
    ],
    "gastrolatre": [
        "gastrolatre"
    ],
    "gastronome": [
        "gastronome"
    ],
    "gastronomes": [
        "gastronome"
    ],
    "gastronomie": [
        "gastronomie"
    ],
    "gastronomique": [
        "gastronomique"
    ],
    "gastronomiques": [
        "gastronomique"
    ],
    "gastrula": [
        "gastrula"
    ],
    "gasteropode": [
        "gasteropode"
    ],
    "gasteropodes": [
        "gasteropode"
    ],
    "gatte": [
        "gatte"
    ],
    "gauche": [
        "gauche"
    ],
    "gauchement": [
        "gauchement"
    ],
    "gaucher": [
        "gaucher"
    ],
    "gaucherie": [
        "gaucherie"
    ],
    "gaucheries": [
        "gaucherie"
    ],
    "gauchers": [
        "gaucher"
    ],
    "gauches": [
        "gauche"
    ],
    "gauchi": [
        "gauchir"
    ],
    "gauchie": [
        "gauchir"
    ],
    "gauchir": [
        "gauchir"
    ],
    "gauchis": [
        "gauchir"
    ],
    "gauchisante": [
        "gauchisant"
    ],
    "gauchisantes": [
        "gauchisant"
    ],
    "gauchisme": [
        "gauchisme"
    ],
    "gauchismes": [
        "gauchisme"
    ],
    "gauchissaient": [
        "gauchir"
    ],
    "gauchissait": [
        "gauchir"
    ],
    "gauchissement": [
        "gauchissement"
    ],
    "gauchiste": [
        "gauchiste"
    ],
    "gauchistes": [
        "gauchiste"
    ],
    "gaucho": [
        "gaucho"
    ],
    "gauchos": [
        "gaucho"
    ],
    "gauchere": [
        "gaucher"
    ],
    "gaudriole": [
        "gaudriole"
    ],
    "gaudrioles": [
        "gaudriole"
    ],
    "gaufre": [
        "gaufre",
        "gaufrer"
    ],
    "gaufres": [
        "gaufre",
        "gaufrer"
    ],
    "gaufrette": [
        "gaufrette"
    ],
    "gaufrettes": [
        "gaufrette"
    ],
    "gaufrier": [
        "gaufrier"
    ],
    "gaufree": [
        "gaufrer",
        "gaufre"
    ],
    "gaufrees": [
        "gaufrer",
        "gaufre"
    ],
    "gaulant": [
        "gauler"
    ],
    "gauldo": [
        "gauldo"
    ],
    "gauldos": [
        "gauldo"
    ],
    "gaule": [
        "gauler",
        "gaule"
    ],
    "gauleiter": [
        "gauleiter"
    ],
    "gauler": [
        "gauler"
    ],
    "gaulerais": [
        "gauler"
    ],
    "gaulerait": [
        "gauler"
    ],
    "gaules": [
        "gaul",
        "gaule"
    ],
    "gaulis": [
        "gaulis"
    ],
    "gaulle": [
        "gaulle"
    ],
    "gaullisme": [
        "gaullisme"
    ],
    "gaulliste": [
        "gaulliste"
    ],
    "gaullistes": [
        "gaulliste"
    ],
    "gaulois": [
        "gaulois"
    ],
    "gauloise": [
        "gaulois"
    ],
    "gauloisement": [
        "gauloisement"
    ],
    "gauloiseries": [
        "gauloiserie"
    ],
    "gauloises": [
        "gaulois"
    ],
    "gaultherie": [
        "gaultherie"
    ],
    "gaulerent": [
        "gauler"
    ],
    "gaulee": [
        "gauler",
        "gaulee"
    ],
    "gaupe": [
        "gaupe"
    ],
    "gauss": [
        "gauss"
    ],
    "gaussaient": [
        "gausser"
    ],
    "gaussait": [
        "gausser"
    ],
    "gaussant": [
        "gausser"
    ],
    "gausse": [
        "gausser"
    ],
    "gaussent": [
        "gausser"
    ],
    "gausser": [
        "gausser"
    ],
    "gausserai": [
        "gausser"
    ],
    "gausserait": [
        "gausser"
    ],
    "gaussez": [
        "gausser"
    ],
    "gausserent": [
        "gausser"
    ],
    "gaussee": [
        "gausser"
    ],
    "gava": [
        "gaver"
    ],
    "gavage": [
        "gavage"
    ],
    "gavai": [
        "gaver"
    ],
    "gavaient": [
        "gaver"
    ],
    "gavais": [
        "gaver"
    ],
    "gavait": [
        "gaver"
    ],
    "gavant": [
        "gaver"
    ],
    "gave": [
        "give",
        "gaver",
        "gave"
    ],
    "gavent": [
        "gaver"
    ],
    "gaver": [
        "gaver"
    ],
    "gavera": [
        "gaver"
    ],
    "gaveraient": [
        "gaver"
    ],
    "gaves": [
        "gaver",
        "gave"
    ],
    "gavez": [
        "gaver"
    ],
    "gavial": [
        "gavial"
    ],
    "gaviot": [
        "gaviot"
    ],
    "gavons": [
        "gaver"
    ],
    "gavroche": [
        "gavroche"
    ],
    "gavroches": [
        "gavroche"
    ],
    "gavee": [
        "gaver"
    ],
    "gavees": [
        "gaver"
    ],
    "gay": [
        "gay"
    ],
    "gayac": [
        "gayac"
    ],
    "gays": [
        "gay"
    ],
    "gaz": [
        "gaz"
    ],
    "gazage": [
        "gazage"
    ],
    "gazait": [
        "gazer"
    ],
    "gaze": [
        "gazer",
        "gaze"
    ],
    "gazelle": [
        "gazelle"
    ],
    "gazelles": [
        "gazelle"
    ],
    "gazer": [
        "gazer"
    ],
    "gazera": [
        "gazer"
    ],
    "gazerait": [
        "gazer"
    ],
    "gazes": [
        "gazer",
        "gaze"
    ],
    "gazette": [
        "gazette"
    ],
    "gazettes": [
        "gazette"
    ],
    "gazeuse": [
        "gazeux"
    ],
    "gazeuses": [
        "gazeux"
    ],
    "gazeux": [
        "gazeux"
    ],
    "gazez": [
        "gazer"
    ],
    "gazier": [
        "gazier"
    ],
    "gaziers": [
        "gazier"
    ],
    "gaziniere": [
        "gaziniere"
    ],
    "gazinieres": [
        "gaziniere"
    ],
    "gazoduc": [
        "gazoduc"
    ],
    "gazogene": [
        "gazogene"
    ],
    "gazogenes": [
        "gazogene"
    ],
    "gazole": [
        "gazole"
    ],
    "gazoline": [
        "gazoline"
    ],
    "gazometre": [
        "gazometre"
    ],
    "gazometrie": [
        "gazometrie"
    ],
    "gazon": [
        "gazon"
    ],
    "gazonne": [
        "gazonne"
    ],
    "gazonnee": [
        "gazonne"
    ],
    "gazons": [
        "gazer",
        "gazon"
    ],
    "gazouilla": [
        "gazouiller"
    ],
    "gazouillaient": [
        "gazouiller"
    ],
    "gazouillait": [
        "gazouiller"
    ],
    "gazouillant": [
        "gazouillant",
        "gazouiller"
    ],
    "gazouillante": [
        "gazouillant"
    ],
    "gazouillants": [
        "gazouillant"
    ],
    "gazouille": [
        "gazouiller"
    ],
    "gazouillement": [
        "gazouillement"
    ],
    "gazouillements": [
        "gazouillement"
    ],
    "gazouillent": [
        "gazouiller"
    ],
    "gazouiller": [
        "gazouiller"
    ],
    "gazouilles": [
        "gazouiller"
    ],
    "gazouilleurs": [
        "gazouilleur"
    ],
    "gazouillis": [
        "gazouillis"
    ],
    "gazpacho": [
        "gazpacho"
    ],
    "gazee": [
        "gazer",
        "gaze"
    ],
    "gazees": [
        "gazer"
    ],
    "gazeifier": [
        "gazeifier"
    ],
    "gazeifiee": [
        "gazeifier"
    ],
    "gaelique": [
        "gaelique"
    ],
    "gaiment": [
        "gaiment"
    ],
    "gaite": [
        "gaite"
    ],
    "gaites": [
        "gaite"
    ],
    "geai": [
        "geai"
    ],
    "geais": [
        "geai"
    ],
    "gecko": [
        "gecko"
    ],
    "geckos": [
        "gecko"
    ],
    "geez": [
        "geez"
    ],
    "geignaient": [
        "geindre"
    ],
    "geignais": [
        "geindre"
    ],
    "geignait": [
        "geindre"
    ],
    "geignant": [
        "geignant",
        "geindre"
    ],
    "geignante": [
        "geignant"
    ],
    "geignantes": [
        "geignant"
    ],
    "geignard": [
        "geignard"
    ],
    "geignarde": [
        "geignard"
    ],
    "geignardes": [
        "geignard"
    ],
    "geignardises": [
        "geignardise"
    ],
    "geignards": [
        "geignard"
    ],
    "geignement": [
        "geignement"
    ],
    "geignements": [
        "geignement"
    ],
    "geignent": [
        "geindre"
    ],
    "geignez": [
        "geindre"
    ],
    "geignit": [
        "geindre"
    ],
    "geindre": [
        "geindre"
    ],
    "geins": [
        "geindre"
    ],
    "geint": [
        "geindre"
    ],
    "geisha": [
        "geisha"
    ],
    "geishas": [
        "geisha"
    ],
    "gel": [
        "gel"
    ],
    "gela": [
        "geler"
    ],
    "gelaient": [
        "geler"
    ],
    "gelais": [
        "geler"
    ],
    "gelait": [
        "geler"
    ],
    "gelant": [
        "geler"
    ],
    "geler": [
        "geler"
    ],
    "gelez": [
        "geler"
    ],
    "geline": [
        "geline"
    ],
    "gelinotte": [
        "gelinotte"
    ],
    "gelons": [
        "geler"
    ],
    "gels": [
        "gel"
    ],
    "gelure": [
        "gelure"
    ],
    "gelures": [
        "gelure"
    ],
    "gelat": [
        "geler"
    ],
    "gele": [
        "gele",
        "geler"
    ],
    "gelee": [
        "geler",
        "gelee"
    ],
    "gelees": [
        "geler",
        "gelee"
    ],
    "geles": [
        "gele",
        "geler"
    ],
    "gemme": [
        "gemme"
    ],
    "gemmes": [
        "gemme"
    ],
    "gemmologie": [
        "gemmologie"
    ],
    "gencive": [
        "gencive"
    ],
    "gencives": [
        "gencive"
    ],
    "gendarme": [
        "gendarme"
    ],
    "gendarmer": [
        "gendarmer"
    ],
    "gendarmerie": [
        "gendarmerie"
    ],
    "gendarmeries": [
        "gendarmerie"
    ],
    "gendarmes": [
        "gendarme"
    ],
    "gendelettres": [
        "gendelettre"
    ],
    "gendre": [
        "gendre"
    ],
    "gendres": [
        "gendre"
    ],
    "genet": [
        "genet"
    ],
    "genevois": [
        "genevois"
    ],
    "genevoises": [
        "genevois"
    ],
    "gengiskhanide": [
        "gengiskhanide"
    ],
    "genievre": [
        "genievre"
    ],
    "genou": [
        "genou"
    ],
    "genouillere": [
        "genouillere"
    ],
    "genouilleres": [
        "genouillere"
    ],
    "genoux": [
        "genou"
    ],
    "genre": [
        "genre"
    ],
    "genres": [
        "genre"
    ],
    "genreux": [
        "genreux"
    ],
    "gens": [
        "gen",
        "gens"
    ],
    "gent": [
        "gent"
    ],
    "gentamicine": [
        "gentamicine"
    ],
    "gente": [
        "gent",
        "gente"
    ],
    "gentes": [
        "gent"
    ],
    "gentiane": [
        "gentiane"
    ],
    "gentianes": [
        "gentiane"
    ],
    "gentil": [
        "gentil"
    ],
    "gentilhomme": [
        "gentilhomme"
    ],
    "gentilhommiere": [
        "gentilhommier"
    ],
    "gentilhommieres": [
        "gentilhommier"
    ],
    "gentilice": [
        "gentilice"
    ],
    "gentille": [
        "gentil"
    ],
    "gentilles": [
        "gentil"
    ],
    "gentillesse": [
        "gentillesse"
    ],
    "gentillesses": [
        "gentillesse"
    ],
    "gentillet": [
        "gentillet"
    ],
    "gentillets": [
        "gentillet"
    ],
    "gentillette": [
        "gentillet"
    ],
    "gentils": [
        "gentil"
    ],
    "gentilshommes": [
        "gentilhomme"
    ],
    "gentiment": [
        "gentiment"
    ],
    "gentleman": [
        "gentleman"
    ],
    "gentlemen": [
        "gentleman"
    ],
    "gentry": [
        "gentry"
    ],
    "gents": [
        "gent"
    ],
    "genese": [
        "genese"
    ],
    "genevrier": [
        "genevrier"
    ],
    "genevriers": [
        "genevrier"
    ],
    "genetiere": [
        "genetiere"
    ],
    "genets": [
        "genet"
    ],
    "gerba": [
        "gerber"
    ],
    "gerbaient": [
        "gerber"
    ],
    "gerbais": [
        "gerber"
    ],
    "gerbait": [
        "gerber"
    ],
    "gerbant": [
        "gerber"
    ],
    "gerbe": [
        "gerbe",
        "gerber"
    ],
    "gerbent": [
        "gerber"
    ],
    "gerber": [
        "gerber"
    ],
    "gerberais": [
        "gerber"
    ],
    "gerberas": [
        "gerbera"
    ],
    "gerbes": [
        "gerbe",
        "gerber"
    ],
    "gerbeuse": [
        "gerbeur"
    ],
    "gerbeuses": [
        "gerbeur"
    ],
    "gerbier": [
        "gerbier"
    ],
    "gerbille": [
        "gerbille"
    ],
    "gerbiere": [
        "gerbier"
    ],
    "gerboise": [
        "gerboise"
    ],
    "gerboises": [
        "gerboise"
    ],
    "gerberent": [
        "gerber"
    ],
    "gerbee": [
        "gerber"
    ],
    "gerbees": [
        "gerber"
    ],
    "gerce": [
        "gercer"
    ],
    "gercent": [
        "gercer"
    ],
    "gercer": [
        "gercer"
    ],
    "gerces": [
        "gerce",
        "gercer"
    ],
    "gercerent": [
        "gercer"
    ],
    "gercee": [
        "gercer"
    ],
    "gercees": [
        "gercer"
    ],
    "gerfaut": [
        "gerfaut"
    ],
    "gerfauts": [
        "gerfaut"
    ],
    "germa": [
        "germer"
    ],
    "germaient": [
        "germer"
    ],
    "germain": [
        "germain"
    ],
    "germaine": [
        "germain"
    ],
    "germaines": [
        "germain"
    ],
    "germains": [
        "germain"
    ],
    "germait": [
        "germer"
    ],
    "germanique": [
        "germanique"
    ],
    "germaniques": [
        "germanique"
    ],
    "germanisation": [
        "germanisation"
    ],
    "germanisme": [
        "germanisme"
    ],
    "germaniste": [
        "germaniste"
    ],
    "germanite": [
        "germanite"
    ],
    "germanium": [
        "germanium"
    ],
    "germano": [
        "germano"
    ],
    "germanophile": [
        "germanophile"
    ],
    "germanophilie": [
        "germanophilie"
    ],
    "germanophone": [
        "germanophone"
    ],
    "germant": [
        "germant"
    ],
    "germe": [
        "germe",
        "germer"
    ],
    "germen": [
        "germen"
    ],
    "germent": [
        "germer"
    ],
    "germer": [
        "germer"
    ],
    "germera": [
        "germer"
    ],
    "germerait": [
        "germer"
    ],
    "germes": [
        "germe"
    ],
    "germinal": [
        "germinal"
    ],
    "germinale": [
        "germinal"
    ],
    "germination": [
        "germination"
    ],
    "germinations": [
        "germination"
    ],
    "germee": [
        "germe",
        "germer"
    ],
    "germees": [
        "germe",
        "germer"
    ],
    "gerris": [
        "gerris"
    ],
    "gercait": [
        "gercer"
    ],
    "gercures": [
        "gercure"
    ],
    "gestapiste": [
        "gestapiste"
    ],
    "gestapo": [
        "gestapo"
    ],
    "gestation": [
        "gestation"
    ],
    "gestations": [
        "gestation"
    ],
    "geste": [
        "geste"
    ],
    "gestes": [
        "geste"
    ],
    "gesticula": [
        "gesticuler"
    ],
    "gesticulai": [
        "gesticuler"
    ],
    "gesticulaient": [
        "gesticuler"
    ],
    "gesticulais": [
        "gesticuler"
    ],
    "gesticulait": [
        "gesticuler"
    ],
    "gesticulant": [
        "gesticuler",
        "gesticulant"
    ],
    "gesticulante": [
        "gesticulant"
    ],
    "gesticulantes": [
        "gesticulant"
    ],
    "gesticulants": [
        "gesticulant"
    ],
    "gesticulateurs": [
        "gesticulateur"
    ],
    "gesticulation": [
        "gesticulation"
    ],
    "gesticulations": [
        "gesticulation"
    ],
    "gesticulatoire": [
        "gesticulatoire"
    ],
    "gesticule": [
        "gesticuler"
    ],
    "gesticulent": [
        "gesticuler"
    ],
    "gesticuler": [
        "gesticuler"
    ],
    "gesticules": [
        "gesticuler"
    ],
    "gestion": [
        "gestion"
    ],
    "gestionnaire": [
        "gestionnaire"
    ],
    "gestionnaires": [
        "gestionnaire"
    ],
    "gestuel": [
        "gestuel"
    ],
    "gestuelle": [
        "gestuel"
    ],
    "geyser": [
        "geyser"
    ],
    "geysers": [
        "geyser"
    ],
    "geole": [
        "geole"
    ],
    "geoles": [
        "geole"
    ],
    "geolier": [
        "geolier"
    ],
    "geoliers": [
        "geolier"
    ],
    "geoliere": [
        "geolier"
    ],
    "geolieres": [
        "geolier"
    ],
    "ghaneens": [
        "ghaneen"
    ],
    "ghetto": [
        "ghetto"
    ],
    "ghettos": [
        "ghetto"
    ],
    "ghat": [
        "ghat"
    ],
    "gi": [
        "gi"
    ],
    "giaour": [
        "giaour"
    ],
    "giaours": [
        "giaour"
    ],
    "gibbeuse": [
        "gibbeux"
    ],
    "gibbeux": [
        "gibbeux"
    ],
    "gibbon": [
        "gibbon"
    ],
    "gibbons": [
        "gibbon"
    ],
    "gibbosite": [
        "gibbosite"
    ],
    "gibeciere": [
        "gibeciere"
    ],
    "gibecieres": [
        "gibeciere"
    ],
    "gibelet": [
        "gibelet"
    ],
    "gibelin": [
        "gibelin"
    ],
    "gibeline": [
        "gibelin"
    ],
    "gibelins": [
        "gibelin"
    ],
    "gibelotte": [
        "gibelotte"
    ],
    "gibelottes": [
        "gibelotte"
    ],
    "giberne": [
        "giberne"
    ],
    "gibernes": [
        "giberne"
    ],
    "gibet": [
        "gibet"
    ],
    "gibets": [
        "gibet"
    ],
    "gibier": [
        "gibier"
    ],
    "gibiers": [
        "gibier"
    ],
    "giboulee": [
        "giboulee"
    ],
    "giboulees": [
        "giboulee"
    ],
    "giboyeuse": [
        "giboyeux"
    ],
    "giboyeuses": [
        "giboyeux"
    ],
    "giboyeux": [
        "giboyeux"
    ],
    "gibus": [
        "gibus"
    ],
    "gicla": [
        "gicler"
    ],
    "giclaient": [
        "gicler"
    ],
    "giclais": [
        "gicler"
    ],
    "giclait": [
        "gicler"
    ],
    "giclant": [
        "gicler"
    ],
    "gicle": [
        "gicler"
    ],
    "giclement": [
        "giclement"
    ],
    "giclements": [
        "giclement"
    ],
    "giclent": [
        "gicler"
    ],
    "gicler": [
        "gicler"
    ],
    "giclera": [
        "gicler"
    ],
    "gicleront": [
        "gicler"
    ],
    "gicles": [
        "gicler"
    ],
    "gicleur": [
        "gicleur"
    ],
    "giclez": [
        "gicler"
    ],
    "giclerent": [
        "gicler"
    ],
    "giclee": [
        "giclee",
        "gicler"
    ],
    "giclees": [
        "giclee"
    ],
    "gidien": [
        "gidien"
    ],
    "gidienne": [
        "gidien"
    ],
    "gidiennes": [
        "gidien"
    ],
    "gidouille": [
        "gidouille"
    ],
    "gifla": [
        "gifler"
    ],
    "giflai": [
        "gifler"
    ],
    "giflaient": [
        "gifler"
    ],
    "giflais": [
        "gifler"
    ],
    "giflait": [
        "gifler"
    ],
    "giflant": [
        "gifler"
    ],
    "gifle": [
        "gifler",
        "gifle"
    ],
    "giflent": [
        "gifler"
    ],
    "gifler": [
        "gifler"
    ],
    "giflera": [
        "gifler"
    ],
    "giflerai": [
        "gifler"
    ],
    "giflerais": [
        "gifler"
    ],
    "giflerait": [
        "gifler"
    ],
    "gifles": [
        "gifler",
        "gifle"
    ],
    "gifleuse": [
        "gifleur"
    ],
    "giflez": [
        "gifler"
    ],
    "giflat": [
        "gifler"
    ],
    "giflee": [
        "gifler"
    ],
    "giflees": [
        "gifler"
    ],
    "gifts": [
        "gift"
    ],
    "gig": [
        "gig"
    ],
    "giga": [
        "giga"
    ],
    "gigabits": [
        "gigabit"
    ],
    "gigahertz": [
        "gigahertz"
    ],
    "gigantesque": [
        "gigantesque"
    ],
    "gigantesques": [
        "gigantesque"
    ],
    "gigantisme": [
        "gigantisme"
    ],
    "gigantismes": [
        "gigantisme"
    ],
    "gigantomachie": [
        "gigantomachie"
    ],
    "gigaoctets": [
        "gigaoctet"
    ],
    "gigas": [
        "giga"
    ],
    "gigogne": [
        "gigogne"
    ],
    "gigognes": [
        "gigogne"
    ],
    "gigolette": [
        "gigolette"
    ],
    "gigolo": [
        "gigolo"
    ],
    "gigolos": [
        "gigolo"
    ],
    "gigolpince": [
        "gigolpince"
    ],
    "gigolpinces": [
        "gigolpince"
    ],
    "gigot": [
        "gigot"
    ],
    "gigota": [
        "gigoter"
    ],
    "gigotaient": [
        "gigoter"
    ],
    "gigotait": [
        "gigoter"
    ],
    "gigotant": [
        "gigoter"
    ],
    "gigote": [
        "gigoter",
        "gigote"
    ],
    "gigotements": [
        "gigotement"
    ],
    "gigotent": [
        "gigoter"
    ],
    "gigoter": [
        "gigoter"
    ],
    "gigotes": [
        "gigoter"
    ],
    "gigotez": [
        "gigoter"
    ],
    "gigots": [
        "gigot"
    ],
    "gigue": [
        "gigue"
    ],
    "gilbert": [
        "gilbert"
    ],
    "gilet": [
        "gilet"
    ],
    "giletieres": [
        "giletier"
    ],
    "gilets": [
        "gilet"
    ],
    "gilles": [
        "gille"
    ],
    "gimmick": [
        "gimmick"
    ],
    "gimmicks": [
        "gimmick"
    ],
    "gin": [
        "gin"
    ],
    "gineste": [
        "gineste"
    ],
    "gingembre": [
        "gingembre"
    ],
    "gingin": [
        "gingin"
    ],
    "gingivite": [
        "gingivite"
    ],
    "ginkgo": [
        "ginkgo"
    ],
    "gins": [
        "gin"
    ],
    "ginseng": [
        "ginseng"
    ],
    "giocoso": [
        "giocoso"
    ],
    "gipsy": [
        "gipsy"
    ],
    "girafe": [
        "girafe"
    ],
    "girafeau": [
        "girafeau"
    ],
    "girafes": [
        "girafe"
    ],
    "girafon": [
        "girafon"
    ],
    "girandes": [
        "girande"
    ],
    "girandole": [
        "girandole"
    ],
    "girandoles": [
        "girandole"
    ],
    "giration": [
        "giration"
    ],
    "girations": [
        "giration"
    ],
    "giratoire": [
        "giratoire"
    ],
    "giraudistes": [
        "giraudiste"
    ],
    "gire": [
        "gire"
    ],
    "girelles": [
        "girel"
    ],
    "girer": [
        "girer"
    ],
    "gires": [
        "gire"
    ],
    "girie": [
        "girie"
    ],
    "giries": [
        "girie"
    ],
    "girl": [
        "girl"
    ],
    "girls": [
        "girl"
    ],
    "girofle": [
        "girofle"
    ],
    "girofles": [
        "girofle"
    ],
    "giroflier": [
        "giroflier"
    ],
    "giroflee": [
        "giroflee"
    ],
    "giroflees": [
        "giroflee"
    ],
    "girolle": [
        "girolle"
    ],
    "girolles": [
        "girolle"
    ],
    "giron": [
        "giron"
    ],
    "girond": [
        "girond"
    ],
    "gironde": [
        "girond"
    ],
    "girondes": [
        "girond"
    ],
    "girondin": [
        "girondin"
    ],
    "girondine": [
        "girondin"
    ],
    "girondines": [
        "girondin"
    ],
    "girondins": [
        "girondin"
    ],
    "gironds": [
        "girond"
    ],
    "girouettait": [
        "girouetter"
    ],
    "girouettant": [
        "girouetter"
    ],
    "girouette": [
        "girouette"
    ],
    "girouettes": [
        "girouette"
    ],
    "gis": [
        "gi",
        "gesir"
    ],
    "gisaient": [
        "gesir"
    ],
    "gisais": [
        "gesir"
    ],
    "gisait": [
        "gesir"
    ],
    "gisant": [
        "gesir",
        "gisant"
    ],
    "gisante": [
        "gisant"
    ],
    "gisantes": [
        "gisant"
    ],
    "gisants": [
        "gisant"
    ],
    "gisement": [
        "gisement"
    ],
    "gisements": [
        "gisement"
    ],
    "gisent": [
        "gesir"
    ],
    "gisions": [
        "gesir"
    ],
    "gisquette": [
        "gisquette"
    ],
    "gisquettes": [
        "gisquette"
    ],
    "gitan": [
        "gitan"
    ],
    "gitane": [
        "gitan"
    ],
    "gitanes": [
        "gitan"
    ],
    "gitans": [
        "gitan"
    ],
    "giton": [
        "giton"
    ],
    "gitons": [
        "giton"
    ],
    "givrage": [
        "givrage"
    ],
    "givrait": [
        "givrer"
    ],
    "givrante": [
        "givrant"
    ],
    "givre": [
        "givrer",
        "givre"
    ],
    "givrer": [
        "givrer"
    ],
    "givres": [
        "givrer",
        "givre"
    ],
    "givree": [
        "givrer",
        "givre"
    ],
    "givrees": [
        "givrer",
        "givre"
    ],
    "glabelle": [
        "glabelle"
    ],
    "glabre": [
        "glabre"
    ],
    "glabres": [
        "glabre"
    ],
    "glace": [
        "glacer",
        "glace"
    ],
    "glacent": [
        "glacer"
    ],
    "glacer": [
        "glacer"
    ],
    "glacera": [
        "glacer"
    ],
    "glaceront": [
        "glacer"
    ],
    "glaces": [
        "glacer",
        "glace"
    ],
    "glacez": [
        "glacer"
    ],
    "glaciaire": [
        "glaciaire"
    ],
    "glaciaires": [
        "glaciaire"
    ],
    "glacial": [
        "glacial"
    ],
    "glaciale": [
        "glacial"
    ],
    "glacialement": [
        "glacialement"
    ],
    "glaciales": [
        "glacial"
    ],
    "glacials": [
        "glacial"
    ],
    "glaciation": [
        "glaciation"
    ],
    "glaciations": [
        "glaciation"
    ],
    "glaciaux": [
        "glacial"
    ],
    "glacier": [
        "glacier"
    ],
    "glaciers": [
        "glacier"
    ],
    "glaciologue": [
        "glaciologue"
    ],
    "glacis": [
        "glacis"
    ],
    "glaciere": [
        "glaciere"
    ],
    "glacieres": [
        "glaciere"
    ],
    "glacerent": [
        "glacer"
    ],
    "glacee": [
        "glacer",
        "glace"
    ],
    "glacees": [
        "glacer",
        "glace"
    ],
    "gladiateur": [
        "gladiateur"
    ],
    "gladiateurs": [
        "gladiateur"
    ],
    "gladiatrices": [
        "gladiatrice"
    ],
    "glaglate": [
        "glaglater"
    ],
    "glaglater": [
        "glaglater"
    ],
    "glaire": [
        "glaire"
    ],
    "glaires": [
        "glaire"
    ],
    "glaireuse": [
        "glaireux"
    ],
    "glaireuses": [
        "glaireux"
    ],
    "glaireux": [
        "glaireux"
    ],
    "glaise": [
        "glaise"
    ],
    "glaises": [
        "glaise"
    ],
    "glaiseuse": [
        "glaiseux"
    ],
    "glaiseuses": [
        "glaiseux"
    ],
    "glaiseux": [
        "glaiseux"
    ],
    "glaive": [
        "glaive"
    ],
    "glaives": [
        "glaive"
    ],
    "glamour": [
        "glamour"
    ],
    "glana": [
        "glaner"
    ],
    "glanage": [
        "glanage"
    ],
    "glanaient": [
        "glaner"
    ],
    "glanais": [
        "glaner"
    ],
    "glanait": [
        "glaner"
    ],
    "glanant": [
        "glaner"
    ],
    "gland": [
        "gland"
    ],
    "glandage": [
        "glandage"
    ],
    "glandais": [
        "glander"
    ],
    "glandait": [
        "glander"
    ],
    "glande": [
        "glander",
        "glande"
    ],
    "glandent": [
        "glander"
    ],
    "glander": [
        "glander"
    ],
    "glandes": [
        "glander",
        "glande"
    ],
    "glandeur": [
        "glandeur"
    ],
    "glandeurs": [
        "glandeur"
    ],
    "glandez": [
        "glander"
    ],
    "glandiez": [
        "glander"
    ],
    "glandilleuse": [
        "glandilleuse"
    ],
    "glandilleuses": [
        "glandilleuse"
    ],
    "glandilleux": [
        "glandilleux"
    ],
    "glandons": [
        "glander"
    ],
    "glandouillant": [
        "glandouiller"
    ],
    "glandouille": [
        "glandouiller"
    ],
    "glandouiller": [
        "glandouiller"
    ],
    "glandouilleur": [
        "glandouilleur"
    ],
    "glandouillez": [
        "glandouiller"
    ],
    "glands": [
        "gland"
    ],
    "glandu": [
        "glandu"
    ],
    "glandulaire": [
        "glandulaire"
    ],
    "glandulaires": [
        "glandulaire"
    ],
    "glanduleuse": [
        "glanduleux"
    ],
    "glandus": [
        "glandu"
    ],
    "glane": [
        "glaner",
        "glane"
    ],
    "glanent": [
        "glaner"
    ],
    "glaner": [
        "glaner"
    ],
    "glanes": [
        "glaner",
        "glane"
    ],
    "glaneur": [
        "glaneur"
    ],
    "glaneuse": [
        "glaneur"
    ],
    "glanez": [
        "glaner"
    ],
    "glanure": [
        "glanure"
    ],
    "glanee": [
        "glaner"
    ],
    "glanees": [
        "glaner"
    ],
    "glapi": [
        "glapir"
    ],
    "glapie": [
        "glapir"
    ],
    "glapir": [
        "glapir"
    ],
    "glapirent": [
        "glapir"
    ],
    "glapissaient": [
        "glapir"
    ],
    "glapissait": [
        "glapir"
    ],
    "glapissant": [
        "glapir",
        "glapissant"
    ],
    "glapissante": [
        "glapissant"
    ],
    "glapissantes": [
        "glapissant"
    ],
    "glapissants": [
        "glapissant"
    ],
    "glapissement": [
        "glapissement"
    ],
    "glapissements": [
        "glapissement"
    ],
    "glapissent": [
        "glapir"
    ],
    "glapisseurs": [
        "glapisseur"
    ],
    "glapissions": [
        "glapir"
    ],
    "glapit": [
        "glapir"
    ],
    "glareole": [
        "glareole"
    ],
    "glas": [
        "glas"
    ],
    "glasnost": [
        "glasnost"
    ],
    "glass": [
        "glass"
    ],
    "glasses": [
        "glass"
    ],
    "glaucome": [
        "glaucome"
    ],
    "glauque": [
        "glauque"
    ],
    "glauquement": [
        "glauquement"
    ],
    "glauques": [
        "glauque"
    ],
    "glaviot": [
        "glaviot"
    ],
    "glaviotaient": [
        "glavioter"
    ],
    "glaviotait": [
        "glavioter"
    ],
    "glaviotant": [
        "glavioter"
    ],
    "glaviote": [
        "glavioter"
    ],
    "glavioter": [
        "glavioter"
    ],
    "glavioteurs": [
        "glavioteur"
    ],
    "glaviots": [
        "glaviot"
    ],
    "glaviotte": [
        "glaviotter"
    ],
    "glaca": [
        "glacer"
    ],
    "glacage": [
        "glacage"
    ],
    "glacages": [
        "glacage"
    ],
    "glacaient": [
        "glacer"
    ],
    "glacais": [
        "glacer"
    ],
    "glacait": [
        "glacer"
    ],
    "glacant": [
        "glacer",
        "glacant"
    ],
    "glacante": [
        "glacant"
    ],
    "glacon": [
        "glacon"
    ],
    "glacons": [
        "glacer",
        "glacon"
    ],
    "glacure": [
        "glacure"
    ],
    "glacures": [
        "glacure"
    ],
    "glaieul": [
        "glaieul"
    ],
    "glaieuls": [
        "glaieul"
    ],
    "glide": [
        "glide"
    ],
    "glioblastome": [
        "glioblastome"
    ],
    "gliome": [
        "gliome"
    ],
    "glissa": [
        "glisser"
    ],
    "glissade": [
        "glissade"
    ],
    "glissades": [
        "glissade"
    ],
    "glissai": [
        "glisser"
    ],
    "glissaient": [
        "glisser"
    ],
    "glissais": [
        "glisser"
    ],
    "glissait": [
        "glisser"
    ],
    "glissandi": [
        "glissando"
    ],
    "glissando": [
        "glissando"
    ],
    "glissandos": [
        "glissando"
    ],
    "glissant": [
        "glisser",
        "glissant"
    ],
    "glissante": [
        "glissant"
    ],
    "glissantes": [
        "glissant"
    ],
    "glissants": [
        "glissant"
    ],
    "glisse": [
        "glisser",
        "glisse"
    ],
    "glissement": [
        "glissement"
    ],
    "glissements": [
        "glissement"
    ],
    "glissent": [
        "glisser"
    ],
    "glisser": [
        "glisser"
    ],
    "glissera": [
        "glisser"
    ],
    "glisserai": [
        "glisser"
    ],
    "glisseraient": [
        "glisser"
    ],
    "glisserais": [
        "glisser"
    ],
    "glisserait": [
        "glisser"
    ],
    "glisserez": [
        "glisser"
    ],
    "glisseriez": [
        "glisser"
    ],
    "glisserons": [
        "glisser"
    ],
    "glisseront": [
        "glisser"
    ],
    "glisses": [
        "glisser",
        "glisse"
    ],
    "glissez": [
        "glisser"
    ],
    "glissions": [
        "glisser"
    ],
    "glissiere": [
        "glissiere"
    ],
    "glissieres": [
        "glissiere"
    ],
    "glissoire": [
        "glissoire"
    ],
    "glissons": [
        "glisser"
    ],
    "glissames": [
        "glisser"
    ],
    "glissat": [
        "glisser"
    ],
    "glisserent": [
        "glisser"
    ],
    "glissee": [
        "glisser"
    ],
    "glissees": [
        "glisser"
    ],
    "global": [
        "global"
    ],
    "globale": [
        "global"
    ],
    "globalement": [
        "globalement"
    ],
    "globalisation": [
        "globalisation"
    ],
    "globalise": [
        "globaliser"
    ],
    "globalite": [
        "globalite"
    ],
    "globaux": [
        "global"
    ],
    "globe": [
        "globe"
    ],
    "globes": [
        "globe"
    ],
    "globulaire": [
        "globulaire"
    ],
    "globulaires": [
        "globulaire"
    ],
    "globule": [
        "globule"
    ],
    "globules": [
        "globule"
    ],
    "globuleuse": [
        "globuleux"
    ],
    "globuleux": [
        "globuleux"
    ],
    "globuline": [
        "globuline"
    ],
    "glockenspiel": [
        "glockenspiel"
    ],
    "gloire": [
        "gloire"
    ],
    "gloires": [
        "gloire"
    ],
    "glomerule": [
        "glomerule"
    ],
    "glop": [
        "glop"
    ],
    "gloria": [
        "gloria"
    ],
    "gloriette": [
        "gloriette"
    ],
    "gloriettes": [
        "gloriette"
    ],
    "glorieuse": [
        "glorieux",
        "glorieuse"
    ],
    "glorieusement": [
        "glorieusement"
    ],
    "glorieuses": [
        "glorieux"
    ],
    "glorieux": [
        "glorieux"
    ],
    "glorifia": [
        "glorifier"
    ],
    "glorifiaient": [
        "glorifier"
    ],
    "glorifiait": [
        "glorifier"
    ],
    "glorifiant": [
        "glorifier"
    ],
    "glorification": [
        "glorification"
    ],
    "glorifie": [
        "glorifier"
    ],
    "glorifient": [
        "glorifier"
    ],
    "glorifier": [
        "glorifier"
    ],
    "glorifiez": [
        "glorifier"
    ],
    "glorifions": [
        "glorifier"
    ],
    "glorifiees": [
        "glorifier"
    ],
    "glorifies": [
        "glorifier",
        "glorify"
    ],
    "gloriole": [
        "gloriole"
    ],
    "glosaient": [
        "gloser"
    ],
    "glose": [
        "glose",
        "gloser"
    ],
    "gloser": [
        "gloser"
    ],
    "gloses": [
        "glose"
    ],
    "glossaire": [
        "glossaire"
    ],
    "glossateurs": [
        "glossateur"
    ],
    "glossematique": [
        "glossematique"
    ],
    "glosees": [
        "gloser"
    ],
    "glotte": [
        "glotte"
    ],
    "glottique": [
        "glottique"
    ],
    "glouglou": [
        "glouglou"
    ],
    "glouglous": [
        "glouglou"
    ],
    "glougloutait": [
        "glouglouter"
    ],
    "glougloutant": [
        "glouglouter"
    ],
    "glougloute": [
        "glouglouter"
    ],
    "glougloutement": [
        "glougloutement"
    ],
    "glouglouter": [
        "glouglouter"
    ],
    "gloussa": [
        "glousser"
    ],
    "gloussaient": [
        "glousser"
    ],
    "gloussait": [
        "glousser"
    ],
    "gloussant": [
        "gloussant",
        "glousser"
    ],
    "gloussante": [
        "gloussant"
    ],
    "gloussantes": [
        "gloussant"
    ],
    "gloussants": [
        "gloussant"
    ],
    "glousse": [
        "glousser"
    ],
    "gloussement": [
        "gloussement"
    ],
    "gloussements": [
        "gloussement"
    ],
    "gloussent": [
        "glousser"
    ],
    "glousser": [
        "glousser"
    ],
    "glousserait": [
        "glousser"
    ],
    "gloussez": [
        "glousser"
    ],
    "glousserent": [
        "glousser"
    ],
    "glouton": [
        "glouton"
    ],
    "gloutonnant": [
        "gloutonner"
    ],
    "gloutonne": [
        "glouton"
    ],
    "gloutonnement": [
        "gloutonnement"
    ],
    "gloutonnerie": [
        "gloutonnerie"
    ],
    "gloutons": [
        "glouton"
    ],
    "gloxinias": [
        "gloxinia"
    ],
    "glu": [
        "glu"
    ],
    "gluant": [
        "gluer",
        "gluant"
    ],
    "gluante": [
        "gluant"
    ],
    "gluantes": [
        "gluant"
    ],
    "gluants": [
        "gluant"
    ],
    "glucagon": [
        "glucagon"
    ],
    "glucide": [
        "glucide"
    ],
    "glucides": [
        "glucide"
    ],
    "gluconique": [
        "gluconique"
    ],
    "glucose": [
        "glucose"
    ],
    "glue": [
        "gluer"
    ],
    "gluent": [
        "gluer"
    ],
    "gluon": [
        "gluon"
    ],
    "glus": [
        "glu"
    ],
    "glutamate": [
        "glutamate"
    ],
    "gluten": [
        "gluten"
    ],
    "glycine": [
        "glycine"
    ],
    "glycines": [
        "glycine"
    ],
    "glycol": [
        "glycol"
    ],
    "glycoproteine": [
        "glycoproteine"
    ],
    "glycemie": [
        "glycemie"
    ],
    "glycerine": [
        "glycerine"
    ],
    "glycerol": [
        "glycerol"
    ],
    "glyphe": [
        "glyphe"
    ],
    "glyphes": [
        "glyphe"
    ],
    "glebe": [
        "glebe"
    ],
    "glebes": [
        "glebe"
    ],
    "glene": [
        "glene"
    ],
    "glenoide": [
        "glenoide"
    ],
    "gnafron": [
        "gnafron"
    ],
    "gnafrons": [
        "gnafron"
    ],
    "gnagnagna": [
        "gnagnagna"
    ],
    "gnangnan": [
        "gnangnan"
    ],
    "gnard": [
        "gnard"
    ],
    "gnards": [
        "gnard"
    ],
    "gnaule": [
        "gnaule"
    ],
    "gniard": [
        "gniard"
    ],
    "gniards": [
        "gniard"
    ],
    "gniouf": [
        "gniouf"
    ],
    "gnocchi": [
        "gnocchi"
    ],
    "gnocchis": [
        "gnocchi"
    ],
    "gnognote": [
        "gnognote"
    ],
    "gnognotte": [
        "gnognotte"
    ],
    "gnole": [
        "gnole"
    ],
    "gnome": [
        "gnome"
    ],
    "gnomes": [
        "gnome"
    ],
    "gnon": [
        "gnon"
    ],
    "gnons": [
        "gnon"
    ],
    "gnose": [
        "gnose"
    ],
    "gnosticisme": [
        "gnosticisme"
    ],
    "gnostique": [
        "gnostique"
    ],
    "gnostiques": [
        "gnostique"
    ],
    "gnou": [
        "gnou"
    ],
    "gnouf": [
        "gnouf"
    ],
    "gnous": [
        "gnou"
    ],
    "go": [
        "go"
    ],
    "goal": [
        "goal"
    ],
    "goals": [
        "goal"
    ],
    "goba": [
        "gober"
    ],
    "gobage": [
        "gobage"
    ],
    "gobages": [
        "gobage"
    ],
    "gobaient": [
        "gober"
    ],
    "gobais": [
        "gober"
    ],
    "gobait": [
        "gober"
    ],
    "gobant": [
        "gober"
    ],
    "gobe": [
        "gober"
    ],
    "gobelet": [
        "gobelet"
    ],
    "gobelets": [
        "gobelet"
    ],
    "gobelin": [
        "gobelin"
    ],
    "gobelins": [
        "gobelin"
    ],
    "gobelottes": [
        "gobelotter"
    ],
    "gobent": [
        "gober"
    ],
    "gober": [
        "gober"
    ],
    "gobera": [
        "gober"
    ],
    "goberaient": [
        "gober"
    ],
    "goberait": [
        "gober"
    ],
    "goberge": [
        "goberger"
    ],
    "gobergeait": [
        "goberger"
    ],
    "gobergent": [
        "goberger"
    ],
    "goberger": [
        "goberger"
    ],
    "gobergez": [
        "goberger"
    ],
    "goberont": [
        "gober"
    ],
    "gobes": [
        "gober"
    ],
    "gobet": [
        "gobet"
    ],
    "gobets": [
        "gobet"
    ],
    "gobette": [
        "gobeter"
    ],
    "gobeur": [
        "gobeur"
    ],
    "gobeurs": [
        "gobeur"
    ],
    "gobeuse": [
        "gobeur"
    ],
    "gobez": [
        "gober"
    ],
    "gobions": [
        "gober"
    ],
    "goberent": [
        "gober"
    ],
    "gobee": [
        "gober"
    ],
    "gobees": [
        "gober"
    ],
    "goda": [
        "goder"
    ],
    "godaille": [
        "godailler"
    ],
    "godaillera": [
        "godailler"
    ],
    "godailles": [
        "godailler"
    ],
    "godait": [
        "goder"
    ],
    "godant": [
        "goder"
    ],
    "godasse": [
        "godasse"
    ],
    "godasses": [
        "goder",
        "godasse"
    ],
    "goddam": [
        "goddam"
    ],
    "gode": [
        "goder"
    ],
    "godelureau": [
        "godelureau"
    ],
    "godelureaux": [
        "godelureau"
    ],
    "godemiche": [
        "godemiche"
    ],
    "godemiches": [
        "godemiche"
    ],
    "godent": [
        "goder"
    ],
    "goder": [
        "goder"
    ],
    "goderas": [
        "goder"
    ],
    "godes": [
        "goder"
    ],
    "godet": [
        "godet"
    ],
    "godets": [
        "godet"
    ],
    "godiche": [
        "godiche"
    ],
    "godiches": [
        "godiche"
    ],
    "godillais": [
        "godiller"
    ],
    "godillait": [
        "godiller"
    ],
    "godillant": [
        "godiller"
    ],
    "godille": [
        "godille",
        "godiller"
    ],
    "godiller": [
        "godiller"
    ],
    "godilles": [
        "godille"
    ],
    "godilleur": [
        "godilleur"
    ],
    "godillot": [
        "godillot"
    ],
    "godillots": [
        "godillot"
    ],
    "godronnes": [
        "godronner"
    ],
    "godrons": [
        "godron"
    ],
    "goglu": [
        "goglu"
    ],
    "gogo": [
        "gogo"
    ],
    "gogol": [
        "gogol"
    ],
    "gogols": [
        "gogol"
    ],
    "gogos": [
        "gogo"
    ],
    "gogs": [
        "gog"
    ],
    "goguenard": [
        "goguenard"
    ],
    "goguenarda": [
        "goguenarder"
    ],
    "goguenarde": [
        "goguenard",
        "goguenarder"
    ],
    "goguenardes": [
        "goguenard"
    ],
    "goguenards": [
        "goguenard"
    ],
    "goguenots": [
        "goguenot"
    ],
    "gogues": [
        "gogues"
    ],
    "goguette": [
        "goguette"
    ],
    "goguettes": [
        "goguette"
    ],
    "goinfraient": [
        "goinfrer"
    ],
    "goinfrait": [
        "goinfrer"
    ],
    "goinfre": [
        "goinfre",
        "goinfrer"
    ],
    "goinfrent": [
        "goinfrer"
    ],
    "goinfrer": [
        "goinfrer"
    ],
    "goinfreras": [
        "goinfrer"
    ],
    "goinfrerie": [
        "goinfrerie"
    ],
    "goinfres": [
        "goinfre",
        "goinfrer"
    ],
    "goinfrez": [
        "goinfrer"
    ],
    "goinfree": [
        "goinfrer"
    ],
    "goitre": [
        "goitre"
    ],
    "goitres": [
        "goitre"
    ],
    "goitreux": [
        "goitreux"
    ],
    "gold": [
        "gold"
    ],
    "golden": [
        "golden"
    ],
    "goldens": [
        "golden"
    ],
    "goldo": [
        "goldo"
    ],
    "goldos": [
        "goldo"
    ],
    "golem": [
        "golem"
    ],
    "golf": [
        "golf"
    ],
    "golfe": [
        "golfe"
    ],
    "golfes": [
        "golfe"
    ],
    "golfeur": [
        "golfeur"
    ],
    "golfeurs": [
        "golfeur"
    ],
    "golfeuse": [
        "golfeur"
    ],
    "golfeuses": [
        "golfeur"
    ],
    "golfs": [
        "golf"
    ],
    "golgotha": [
        "golgotha"
    ],
    "goliath": [
        "goliath"
    ],
    "gombo": [
        "gombo"
    ],
    "gombos": [
        "gombo"
    ],
    "gomina": [
        "gomina"
    ],
    "gominer": [
        "gominer"
    ],
    "gomine": [
        "gominer"
    ],
    "gominee": [
        "gominer"
    ],
    "gominees": [
        "gominer"
    ],
    "gomines": [
        "gominer"
    ],
    "gomma": [
        "gommer"
    ],
    "gommage": [
        "gommage"
    ],
    "gommait": [
        "gommer"
    ],
    "gommant": [
        "gommer"
    ],
    "gomme": [
        "gommer",
        "gomme"
    ],
    "gomment": [
        "gommer"
    ],
    "gommer": [
        "gommer"
    ],
    "gommerait": [
        "gommer"
    ],
    "gommes": [
        "gommer",
        "gomme"
    ],
    "gommette": [
        "gommette"
    ],
    "gommeuse": [
        "gommeux"
    ],
    "gommeux": [
        "gommeux"
    ],
    "gommier": [
        "gommier"
    ],
    "gommiers": [
        "gommier"
    ],
    "gommee": [
        "gommer",
        "gomme"
    ],
    "gommees": [
        "gommer",
        "gomme"
    ],
    "gomenol": [
        "gomenol"
    ],
    "gomenolee": [
        "gomenole"
    ],
    "gon": [
        "gon"
    ],
    "gonade": [
        "gonade"
    ],
    "gonades": [
        "gonade"
    ],
    "gonadotropes": [
        "gonadotrope"
    ],
    "gonadotrophine": [
        "gonadotrophine"
    ],
    "goncier": [
        "goncier"
    ],
    "gond": [
        "gond"
    ],
    "gonde": [
        "gonder"
    ],
    "gonder": [
        "gonder"
    ],
    "gondolaient": [
        "gondoler"
    ],
    "gondolais": [
        "gondoler"
    ],
    "gondolait": [
        "gondoler"
    ],
    "gondolant": [
        "gondoler",
        "gondolant"
    ],
    "gondole": [
        "gondole",
        "gondoler"
    ],
    "gondolement": [
        "gondolement"
    ],
    "gondolent": [
        "gondoler"
    ],
    "gondoler": [
        "gondoler"
    ],
    "gondolera": [
        "gondoler"
    ],
    "gondoles": [
        "gondole",
        "gondoler"
    ],
    "gondolier": [
        "gondolier"
    ],
    "gondoliers": [
        "gondolier"
    ],
    "gondoliere": [
        "gondolier"
    ],
    "gondolerent": [
        "gondoler"
    ],
    "gondolee": [
        "gondoler",
        "gondole"
    ],
    "gondolees": [
        "gondoler",
        "gondole"
    ],
    "gonds": [
        "gond"
    ],
    "gone": [
        "go",
        "gone"
    ],
    "gonelle": [
        "gonelle"
    ],
    "gonfalon": [
        "gonfalon"
    ],
    "gonfaloniers": [
        "gonfalonier"
    ],
    "gonfalons": [
        "gonfalon"
    ],
    "gonfanon": [
        "gonfanon"
    ],
    "gonfanons": [
        "gonfanon"
    ],
    "gonfla": [
        "gonfler"
    ],
    "gonflable": [
        "gonflable"
    ],
    "gonflables": [
        "gonflable"
    ],
    "gonflage": [
        "gonflage"
    ],
    "gonflaient": [
        "gonfler"
    ],
    "gonflais": [
        "gonfler"
    ],
    "gonflait": [
        "gonfler"
    ],
    "gonflant": [
        "gonfler",
        "gonflant"
    ],
    "gonflante": [
        "gonflant"
    ],
    "gonflantes": [
        "gonflant"
    ],
    "gonflants": [
        "gonflant"
    ],
    "gonfle": [
        "gonfler",
        "gonfle"
    ],
    "gonflement": [
        "gonflement"
    ],
    "gonflements": [
        "gonflement"
    ],
    "gonflent": [
        "gonfler"
    ],
    "gonfler": [
        "gonfler"
    ],
    "gonflera": [
        "gonfler"
    ],
    "gonflerait": [
        "gonfler"
    ],
    "gonfles": [
        "gonfler",
        "gonfle"
    ],
    "gonflette": [
        "gonflette"
    ],
    "gonfleur": [
        "gonfleur"
    ],
    "gonflez": [
        "gonfler"
    ],
    "gonflerent": [
        "gonfler"
    ],
    "gonflee": [
        "gonfler",
        "gonfle"
    ],
    "gonflees": [
        "gonfler",
        "gonfle"
    ],
    "gong": [
        "gong"
    ],
    "gongoriste": [
        "gongoriste"
    ],
    "gongs": [
        "gong"
    ],
    "goniometre": [
        "goniometre"
    ],
    "gonococcie": [
        "gonococcie"
    ],
    "gonococcique": [
        "gonococcique"
    ],
    "gonocoque": [
        "gonocoque"
    ],
    "gonocoques": [
        "gonocoque"
    ],
    "gonorrhee": [
        "gonorrhee"
    ],
    "gonze": [
        "gonze"
    ],
    "gonzes": [
        "gonze"
    ],
    "gonzesse": [
        "gonzesse"
    ],
    "gonzesses": [
        "gonzesse"
    ],
    "gopak": [
        "gopak"
    ],
    "gopher": [
        "gopher"
    ],
    "gord": [
        "gord"
    ],
    "gordien": [
        "gordien"
    ],
    "gordiens": [
        "gordien"
    ],
    "gore": [
        "gore"
    ],
    "goret": [
        "goret"
    ],
    "gorets": [
        "goret"
    ],
    "gorge": [
        "gorger",
        "gorge"
    ],
    "gorgea": [
        "gorger"
    ],
    "gorgeai": [
        "gorger"
    ],
    "gorgeaient": [
        "gorger"
    ],
    "gorgeais": [
        "gorger"
    ],
    "gorgeait": [
        "gorger"
    ],
    "gorgeant": [
        "gorger"
    ],
    "gorgent": [
        "gorger"
    ],
    "gorgeon": [
        "gorgeon"
    ],
    "gorgeons": [
        "gorger",
        "gorgeon"
    ],
    "gorger": [
        "gorger"
    ],
    "gorgerette": [
        "gorgerette"
    ],
    "gorgerin": [
        "gorgerin"
    ],
    "gorges": [
        "gorger",
        "gorge"
    ],
    "gorget": [
        "gorget"
    ],
    "gorgez": [
        "gorger"
    ],
    "gorgone": [
        "gorgone"
    ],
    "gorgonzola": [
        "gorgonzola"
    ],
    "gorgerent": [
        "gorger"
    ],
    "gorgee": [
        "gorgee",
        "gorger"
    ],
    "gorgees": [
        "gorgee",
        "gorger"
    ],
    "gorille": [
        "gorille"
    ],
    "gorilles": [
        "gorille"
    ],
    "gosier": [
        "gosier"
    ],
    "gosiers": [
        "gosier"
    ],
    "gospel": [
        "gospel"
    ],
    "gosplan": [
        "gosplan"
    ],
    "gosse": [
        "gosse"
    ],
    "gosseline": [
        "gosseline"
    ],
    "gosselines": [
        "gosseline"
    ],
    "gosses": [
        "gosse"
    ],
    "goth": [
        "goth"
    ],
    "gotha": [
        "gotha"
    ],
    "gothas": [
        "gotha"
    ],
    "gothique": [
        "gothique"
    ],
    "gothiques": [
        "gothique"
    ],
    "goths": [
        "goth"
    ],
    "goton": [
        "goton"
    ],
    "gouache": [
        "gouache"
    ],
    "gouaches": [
        "gouache"
    ],
    "gouachez": [
        "gouacher"
    ],
    "gouailla": [
        "gouailler"
    ],
    "gouaille": [
        "gouaille",
        "gouailler"
    ],
    "gouailleur": [
        "gouailleur"
    ],
    "gouailleurs": [
        "gouailleur"
    ],
    "gouailleuse": [
        "gouailleur"
    ],
    "gouailleuses": [
        "gouailleur"
    ],
    "goualante": [
        "goualante"
    ],
    "goualantes": [
        "goualante"
    ],
    "goualer": [
        "goualer"
    ],
    "gouape": [
        "gouape"
    ],
    "gouapes": [
        "gouape"
    ],
    "gouda": [
        "gouda"
    ],
    "goudou": [
        "goudou"
    ],
    "goudous": [
        "goudou"
    ],
    "goudron": [
        "goudron"
    ],
    "goudronnage": [
        "goudronnage"
    ],
    "goudronne": [
        "goudronner",
        "goudronne"
    ],
    "goudronner": [
        "goudronner"
    ],
    "goudronneux": [
        "goudronneux"
    ],
    "goudronnez": [
        "goudronner"
    ],
    "goudronnee": [
        "goudronner",
        "goudronne"
    ],
    "goudronnees": [
        "goudronne"
    ],
    "goudronnes": [
        "goudronne"
    ],
    "goudrons": [
        "goudron"
    ],
    "gouet": [
        "gouet"
    ],
    "gouffre": [
        "gouffre"
    ],
    "gouffres": [
        "gouffre"
    ],
    "gouge": [
        "gouge"
    ],
    "gouges": [
        "gouge"
    ],
    "gougnafier": [
        "gougnafier"
    ],
    "gougnafiers": [
        "gougnafier"
    ],
    "gougnottes": [
        "gougnotter"
    ],
    "gougoutte": [
        "gougoutte"
    ],
    "gougouttes": [
        "gougoutte"
    ],
    "gougere": [
        "gougere"
    ],
    "gougeres": [
        "gougere"
    ],
    "gouine": [
        "gouin",
        "gouine"
    ],
    "gouines": [
        "gouine"
    ],
    "goujat": [
        "goujat"
    ],
    "goujaterie": [
        "goujaterie"
    ],
    "goujats": [
        "goujat"
    ],
    "goujon": [
        "goujon"
    ],
    "goujons": [
        "goujon"
    ],
    "goulache": [
        "goulache"
    ],
    "goulafre": [
        "goulafre"
    ],
    "goulafres": [
        "goulafre"
    ],
    "goulag": [
        "goulag"
    ],
    "goulags": [
        "goulag"
    ],
    "goulasch": [
        "goulasch"
    ],
    "goule": [
        "goule"
    ],
    "goules": [
        "goule"
    ],
    "goulet": [
        "goulet"
    ],
    "goulette": [
        "goulette"
    ],
    "gouleyant": [
        "gouleyant"
    ],
    "goulot": [
        "goulot"
    ],
    "goulots": [
        "goulot"
    ],
    "goulotte": [
        "goulotte"
    ],
    "goulu": [
        "goulu"
    ],
    "goulue": [
        "goulu"
    ],
    "goulues": [
        "goulu"
    ],
    "goulus": [
        "goulu"
    ],
    "goulee": [
        "goulee"
    ],
    "goulees": [
        "goulee"
    ],
    "goulument": [
        "goulument"
    ],
    "goum": [
        "goum"
    ],
    "goumi": [
        "goumi"
    ],
    "goumier": [
        "goumier"
    ],
    "goumiers": [
        "goumier"
    ],
    "goums": [
        "goum"
    ],
    "goupil": [
        "goupil"
    ],
    "goupillait": [
        "goupiller"
    ],
    "goupille": [
        "goupille",
        "goupiller"
    ],
    "goupiller": [
        "goupiller"
    ],
    "goupilles": [
        "goupille",
        "goupiller"
    ],
    "goupillon": [
        "goupillon"
    ],
    "goupillons": [
        "goupillon"
    ],
    "goupillee": [
        "goupiller"
    ],
    "gour": [
        "gour"
    ],
    "goura": [
        "goura"
    ],
    "gouraient": [
        "gourer"
    ],
    "gourais": [
        "gourer"
    ],
    "gourait": [
        "gourer"
    ],
    "gourance": [
        "gourance"
    ],
    "gourances": [
        "gourance"
    ],
    "gourbi": [
        "gourbi"
    ],
    "gourbis": [
        "gourbi"
    ],
    "gourd": [
        "gourd"
    ],
    "gourde": [
        "gourde"
    ],
    "gourdes": [
        "gourde",
        "gourd"
    ],
    "gourdin": [
        "gourdin"
    ],
    "gourdins": [
        "gourdin"
    ],
    "gourds": [
        "gourd"
    ],
    "goure": [
        "gourer"
    ],
    "gourent": [
        "gourer"
    ],
    "gourer": [
        "gourer"
    ],
    "gourerait": [
        "gourer"
    ],
    "goures": [
        "gourer"
    ],
    "gourez": [
        "gourer"
    ],
    "gourgandine": [
        "gourgandine"
    ],
    "gourgandines": [
        "gourgandine"
    ],
    "gourmand": [
        "gourmand"
    ],
    "gourmandai": [
        "gourmander"
    ],
    "gourmandais": [
        "gourmander"
    ],
    "gourmandait": [
        "gourmander"
    ],
    "gourmandant": [
        "gourmander"
    ],
    "gourmande": [
        "gourmand",
        "gourmander"
    ],
    "gourmandement": [
        "gourmandement"
    ],
    "gourmandent": [
        "gourmander"
    ],
    "gourmander": [
        "gourmander"
    ],
    "gourmandes": [
        "gourmand"
    ],
    "gourmandise": [
        "gourmandise"
    ],
    "gourmandises": [
        "gourmandise"
    ],
    "gourmands": [
        "gourmand"
    ],
    "gourme": [
        "gourme",
        "gourmer"
    ],
    "gourmet": [
        "gourmet"
    ],
    "gourmets": [
        "gourmet"
    ],
    "gourmette": [
        "gourmette"
    ],
    "gourmettes": [
        "gourmette"
    ],
    "gourmee": [
        "gourme"
    ],
    "gourmes": [
        "gourme"
    ],
    "gourou": [
        "gourou"
    ],
    "gourous": [
        "gourou"
    ],
    "gours": [
        "gour"
    ],
    "gouree": [
        "gourer"
    ],
    "gourees": [
        "gourer"
    ],
    "gousse": [
        "gousse"
    ],
    "gousses": [
        "gousse"
    ],
    "gousset": [
        "gousset"
    ],
    "goussets": [
        "gousset"
    ],
    "gouttait": [
        "goutter"
    ],
    "gouttant": [
        "goutter"
    ],
    "goutte": [
        "goutter",
        "goutte"
    ],
    "gouttelaient": [
        "goutteler"
    ],
    "gouttelait": [
        "goutteler"
    ],
    "gouttelette": [
        "gouttelette"
    ],
    "gouttelettes": [
        "gouttelette"
    ],
    "goutter": [
        "goutter"
    ],
    "gouttera": [
        "goutter"
    ],
    "goutterais": [
        "goutter"
    ],
    "gouttereau": [
        "gouttereau"
    ],
    "gouttereaux": [
        "gouttereau"
    ],
    "gouttes": [
        "goutter",
        "goutte"
    ],
    "goutteuse": [
        "goutteur",
        "goutteux"
    ],
    "goutteuses": [
        "goutteux"
    ],
    "goutteux": [
        "goutteux"
    ],
    "gouttiere": [
        "gouttiere"
    ],
    "gouttieres": [
        "gouttiere"
    ],
    "gouvernable": [
        "gouvernable"
    ],
    "gouvernaient": [
        "gouverner"
    ],
    "gouvernail": [
        "gouvernail"
    ],
    "gouvernails": [
        "gouvernail"
    ],
    "gouvernait": [
        "gouverner"
    ],
    "gouvernance": [
        "gouvernance"
    ],
    "gouvernant": [
        "gouvernant",
        "gouverner"
    ],
    "gouvernante": [
        "gouvernante"
    ],
    "gouvernantes": [
        "gouvernante"
    ],
    "gouvernants": [
        "gouvernant"
    ],
    "gouverne": [
        "gouverner",
        "gouverne"
    ],
    "gouvernement": [
        "gouvernement"
    ],
    "gouvernemental": [
        "gouvernemental"
    ],
    "gouvernementale": [
        "gouvernemental"
    ],
    "gouvernementales": [
        "gouvernemental"
    ],
    "gouvernementaux": [
        "gouvernemental"
    ],
    "gouvernements": [
        "gouvernement"
    ],
    "gouvernent": [
        "gouverner"
    ],
    "gouverner": [
        "gouverner"
    ],
    "gouvernera": [
        "gouverner"
    ],
    "gouvernerai": [
        "gouverner"
    ],
    "gouvernerait": [
        "gouverner"
    ],
    "gouverneras": [
        "gouverner"
    ],
    "gouvernerez": [
        "gouverner"
    ],
    "gouvernerons": [
        "gouverner"
    ],
    "gouverneront": [
        "gouverner"
    ],
    "gouvernes": [
        "gouverner",
        "gouverne"
    ],
    "gouverneur": [
        "gouverneur"
    ],
    "gouverneurs": [
        "gouverneur"
    ],
    "gouvernez": [
        "gouverner"
    ],
    "gouverniez": [
        "gouverner"
    ],
    "gouvernorat": [
        "gouvernorat"
    ],
    "gouvernorats": [
        "gouvernorat"
    ],
    "gouvernat": [
        "gouverner"
    ],
    "gouvernee": [
        "gouverner"
    ],
    "goy": [
        "goy"
    ],
    "goyave": [
        "goyave"
    ],
    "goyesque": [
        "goyesque"
    ],
    "goyesques": [
        "goyesque"
    ],
    "goeland": [
        "goeland"
    ],
    "goelands": [
        "goeland"
    ],
    "goelette": [
        "goelette"
    ],
    "goelettes": [
        "goelette"
    ],
    "goemon": [
        "goemon"
    ],
    "goemons": [
        "goemon"
    ],
    "goetie": [
        "goetie"
    ],
    "gout": [
        "gout"
    ],
    "gouta": [
        "gouter"
    ],
    "goutables": [
        "goutable"
    ],
    "goutai": [
        "gouter"
    ],
    "goutaient": [
        "gouter"
    ],
    "goutais": [
        "gouter"
    ],
    "goutait": [
        "gouter"
    ],
    "goutant": [
        "gouter"
    ],
    "goute": [
        "gouter"
    ],
    "goutent": [
        "gouter"
    ],
    "gouter": [
        "gouter"
    ],
    "goutera": [
        "gouter"
    ],
    "gouterai": [
        "gouter"
    ],
    "gouterais": [
        "gouter"
    ],
    "gouterait": [
        "gouter"
    ],
    "gouteras": [
        "gouter"
    ],
    "gouterez": [
        "gouter"
    ],
    "gouterons": [
        "gouter"
    ],
    "gouteront": [
        "gouter"
    ],
    "gouters": [
        "gouter"
    ],
    "goutes": [
        "gouter"
    ],
    "gouteur": [
        "gouteur"
    ],
    "gouteuse": [
        "gouteux",
        "gouteur"
    ],
    "gouteuses": [
        "gouteux"
    ],
    "gouteux": [
        "gouteux"
    ],
    "goutez": [
        "gouter"
    ],
    "goutiez": [
        "gouter"
    ],
    "goutions": [
        "gouter"
    ],
    "goutons": [
        "gouter"
    ],
    "gouts": [
        "gout"
    ],
    "goutames": [
        "gouter"
    ],
    "gouterent": [
        "gouter"
    ],
    "goutee": [
        "gouter"
    ],
    "goutees": [
        "gouter"
    ],
    "graal": [
        "graal"
    ],
    "grabat": [
        "grabat"
    ],
    "grabataire": [
        "grabataire"
    ],
    "grabataires": [
        "grabataire"
    ],
    "grabats": [
        "grabat"
    ],
    "graben": [
        "graben"
    ],
    "grabuge": [
        "grabuge"
    ],
    "gracia": [
        "gracier"
    ],
    "graciai": [
        "gracier"
    ],
    "gracias": [
        "gracier"
    ],
    "gracie": [
        "gracie",
        "gracier"
    ],
    "gracier": [
        "gracier"
    ],
    "graciera": [
        "gracier"
    ],
    "gracierai": [
        "gracier"
    ],
    "gracieras": [
        "gracier"
    ],
    "gracieuse": [
        "gracieuse",
        "gracieux"
    ],
    "gracieusement": [
        "gracieusement"
    ],
    "gracieuses": [
        "gracieux"
    ],
    "gracieusete": [
        "gracieusete"
    ],
    "gracieusetes": [
        "gracieusete"
    ],
    "gracieux": [
        "gracieux"
    ],
    "graciez": [
        "gracier"
    ],
    "gracile": [
        "gracile"
    ],
    "graciles": [
        "gracile"
    ],
    "gracilite": [
        "gracilite"
    ],
    "graciat": [
        "gracier"
    ],
    "graciee": [
        "gracier"
    ],
    "gracies": [
        "gracie",
        "gracier"
    ],
    "gradaille": [
        "gradaille"
    ],
    "gradation": [
        "gradation"
    ],
    "gradations": [
        "gradation"
    ],
    "grade": [
        "grade"
    ],
    "grader": [
        "grader"
    ],
    "grades": [
        "grade"
    ],
    "gradient": [
        "gradient"
    ],
    "gradients": [
        "gradient"
    ],
    "gradin": [
        "gradin"
    ],
    "gradins": [
        "gradin"
    ],
    "graduation": [
        "graduation"
    ],
    "graduations": [
        "graduation"
    ],
    "graduel": [
        "graduel"
    ],
    "graduelle": [
        "graduel"
    ],
    "graduellement": [
        "graduellement"
    ],
    "graduer": [
        "graduer"
    ],
    "gradus": [
        "gradus"
    ],
    "gradue": [
        "graduer",
        "gradue"
    ],
    "graduee": [
        "graduer",
        "gradue"
    ],
    "graduees": [
        "graduer",
        "gradue"
    ],
    "gradues": [
        "graduer",
        "gradue"
    ],
    "gradee": [
        "grade"
    ],
    "graff": [
        "graff"
    ],
    "graffeur": [
        "graffeur"
    ],
    "graffita": [
        "graffiter"
    ],
    "graffiter": [
        "graffiter"
    ],
    "graffiteur": [
        "graffiteur"
    ],
    "graffiteurs": [
        "graffiteur"
    ],
    "graffiti": [
        "graffiti"
    ],
    "graffitis": [
        "graffiti"
    ],
    "graffito": [
        "graffito"
    ],
    "graffite": [
        "graffiter"
    ],
    "grafigner": [
        "grafigner"
    ],
    "graillant": [
        "grailler"
    ],
    "graille": [
        "grailler"
    ],
    "grailler": [
        "grailler"
    ],
    "graillon": [
        "graillon"
    ],
    "graillonna": [
        "graillonner"
    ],
    "graillonnait": [
        "graillonner"
    ],
    "graillonnant": [
        "graillonnant"
    ],
    "graillonne": [
        "graillonner"
    ],
    "graillonnements": [
        "graillonnement"
    ],
    "graillonneuse": [
        "graillonneur"
    ],
    "graillonneuses": [
        "graillonneur"
    ],
    "graillonneux": [
        "graillonneux"
    ],
    "graillons": [
        "graillon"
    ],
    "graillee": [
        "grailler"
    ],
    "grain": [
        "grain"
    ],
    "graine": [
        "grainer",
        "graine"
    ],
    "grainer": [
        "grainer"
    ],
    "graines": [
        "graine"
    ],
    "graineterie": [
        "graineterie"
    ],
    "grainetier": [
        "grainetier"
    ],
    "grainetiers": [
        "grainetier"
    ],
    "grains": [
        "grain"
    ],
    "graissa": [
        "graisser"
    ],
    "graissage": [
        "graissage"
    ],
    "graissages": [
        "graissage"
    ],
    "graissait": [
        "graisser"
    ],
    "graissant": [
        "graisser"
    ],
    "graisse": [
        "graisse",
        "graisser"
    ],
    "graissent": [
        "graisser"
    ],
    "graisser": [
        "graisser"
    ],
    "graissera": [
        "graisser"
    ],
    "graisserai": [
        "graisser"
    ],
    "graisses": [
        "graisse",
        "graisser"
    ],
    "graisseur": [
        "graisseur"
    ],
    "graisseuse": [
        "graisseux"
    ],
    "graisseuses": [
        "graisseux"
    ],
    "graisseux": [
        "graisseux"
    ],
    "graissez": [
        "graisser"
    ],
    "graissat": [
        "graisser"
    ],
    "graissee": [
        "graisse",
        "graisser"
    ],
    "graissees": [
        "graisse",
        "graisser"
    ],
    "gram": [
        "gram"
    ],
    "gramen": [
        "gramen"
    ],
    "gramens": [
        "gramen"
    ],
    "graminee": [
        "graminee"
    ],
    "graminees": [
        "graminee"
    ],
    "grammage": [
        "grammage"
    ],
    "grammages": [
        "grammage"
    ],
    "grammaire": [
        "grammaire"
    ],
    "grammaires": [
        "grammaire"
    ],
    "grammairien": [
        "grammairien"
    ],
    "grammairienne": [
        "grammairien"
    ],
    "grammairiennes": [
        "grammairien"
    ],
    "grammairiens": [
        "grammairien"
    ],
    "grammatical": [
        "grammatical"
    ],
    "grammaticale": [
        "grammatical"
    ],
    "grammaticalement": [
        "grammaticalement"
    ],
    "grammaticales": [
        "grammatical"
    ],
    "grammaticaux": [
        "grammatical"
    ],
    "gramme": [
        "gramme"
    ],
    "grammer": [
        "grammer"
    ],
    "grammes": [
        "gramme"
    ],
    "gramophone": [
        "gramophone"
    ],
    "gramophones": [
        "gramophone"
    ],
    "grana": [
        "grana"
    ],
    "granas": [
        "grana"
    ],
    "grand": [
        "grand"
    ],
    "grande": [
        "grand"
    ],
    "grandement": [
        "grandement"
    ],
    "grandes": [
        "grande",
        "grand"
    ],
    "grandesse": [
        "grandesse"
    ],
    "grandet": [
        "grandet"
    ],
    "grandeur": [
        "grandeur"
    ],
    "grandeurs": [
        "grandeur"
    ],
    "grandi": [
        "grandir"
    ],
    "grandie": [
        "grandir"
    ],
    "grandiloque": [
        "grandiloque"
    ],
    "grandiloquence": [
        "grandiloquence"
    ],
    "grandiloquent": [
        "grandiloquent"
    ],
    "grandiloquente": [
        "grandiloquent"
    ],
    "grandiloquentes": [
        "grandiloquent"
    ],
    "grandiloquents": [
        "grandiloquent"
    ],
    "grandiose": [
        "grandiose"
    ],
    "grandiosement": [
        "grandiosement"
    ],
    "grandioses": [
        "grandiose"
    ],
    "grandir": [
        "grandir"
    ],
    "grandira": [
        "grandir"
    ],
    "grandirai": [
        "grandir"
    ],
    "grandiraient": [
        "grandir"
    ],
    "grandirais": [
        "grandir"
    ],
    "grandirait": [
        "grandir"
    ],
    "grandiras": [
        "grandir"
    ],
    "grandirent": [
        "grandir"
    ],
    "grandirez": [
        "grandir"
    ],
    "grandiriez": [
        "grandir"
    ],
    "grandirons": [
        "grandir"
    ],
    "grandiront": [
        "grandir"
    ],
    "grandis": [
        "grandir"
    ],
    "grandissaient": [
        "grandir"
    ],
    "grandissais": [
        "grandir"
    ],
    "grandissait": [
        "grandir"
    ],
    "grandissant": [
        "grandissant",
        "grandir"
    ],
    "grandissante": [
        "grandissant"
    ],
    "grandissantes": [
        "grandissant"
    ],
    "grandissants": [
        "grandissant"
    ],
    "grandisse": [
        "grandir"
    ],
    "grandissement": [
        "grandissement"
    ],
    "grandissent": [
        "grandir"
    ],
    "grandisses": [
        "grandir"
    ],
    "grandissez": [
        "grandir"
    ],
    "grandissime": [
        "grandissime"
    ],
    "grandissions": [
        "grandir"
    ],
    "grandissons": [
        "grandir"
    ],
    "grandit": [
        "grandir"
    ],
    "grands": [
        "grand"
    ],
    "grange": [
        "grange"
    ],
    "granges": [
        "grange"
    ],
    "grangette": [
        "grangette"
    ],
    "granit": [
        "granit"
    ],
    "granita": [
        "graniter"
    ],
    "granite": [
        "granite"
    ],
    "granitique": [
        "granitique"
    ],
    "granitiques": [
        "granitique"
    ],
    "granito": [
        "granito"
    ],
    "granits": [
        "granit"
    ],
    "granitee": [
        "graniter"
    ],
    "granites": [
        "granite"
    ],
    "granulaire": [
        "granulaire"
    ],
    "granulait": [
        "granuler"
    ],
    "granulation": [
        "granulation"
    ],
    "granulations": [
        "granulation"
    ],
    "granule": [
        "granule",
        "granuler"
    ],
    "granules": [
        "granule"
    ],
    "granuleuse": [
        "granuleux"
    ],
    "granuleuses": [
        "granuleux"
    ],
    "granuleux": [
        "granuleux"
    ],
    "granulie": [
        "granulie"
    ],
    "granulome": [
        "granulome"
    ],
    "granulee": [
        "granuler"
    ],
    "graphe": [
        "graphe"
    ],
    "graphes": [
        "graphe"
    ],
    "graphie": [
        "graphie"
    ],
    "graphies": [
        "graphie"
    ],
    "graphique": [
        "graphique"
    ],
    "graphiques": [
        "graphique"
    ],
    "graphisme": [
        "graphisme"
    ],
    "graphismes": [
        "graphisme"
    ],
    "graphiste": [
        "graphiste"
    ],
    "graphite": [
        "graphite"
    ],
    "graphites": [
        "graphite"
    ],
    "graphologie": [
        "graphologie"
    ],
    "graphologique": [
        "graphologique"
    ],
    "graphologue": [
        "graphologue"
    ],
    "graphologues": [
        "graphologue"
    ],
    "graphomane": [
        "graphomane"
    ],
    "graphomanes": [
        "graphomane"
    ],
    "graphomanie": [
        "graphomanie"
    ],
    "graphometre": [
        "graphometre"
    ],
    "graphophone": [
        "graphophone"
    ],
    "grappa": [
        "grappa"
    ],
    "grappe": [
        "grappe"
    ],
    "grappes": [
        "grappe"
    ],
    "grappillage": [
        "grappillage"
    ],
    "grappillais": [
        "grappiller"
    ],
    "grappillait": [
        "grappiller"
    ],
    "grappillent": [
        "grappiller"
    ],
    "grappiller": [
        "grappiller"
    ],
    "grappilleur": [
        "grappilleur"
    ],
    "grappillon": [
        "grappillon"
    ],
    "grappillons": [
        "grappillon"
    ],
    "grappille": [
        "grappiller"
    ],
    "grappillees": [
        "grappiller"
    ],
    "grappin": [
        "grappin"
    ],
    "grappins": [
        "grappin"
    ],
    "gras": [
        "gras"
    ],
    "grasse": [
        "gras"
    ],
    "grassement": [
        "grassement"
    ],
    "grasses": [
        "gras",
        "grass"
    ],
    "grasseya": [
        "grasseyer"
    ],
    "grasseyait": [
        "grasseyer"
    ],
    "grasseyant": [
        "grasseyer",
        "grasseyant"
    ],
    "grasseyante": [
        "grasseyant"
    ],
    "grasseyement": [
        "grasseyement"
    ],
    "grasseyements": [
        "grasseyement"
    ],
    "grasseyer": [
        "grasseyer"
    ],
    "grasseye": [
        "grasseyer"
    ],
    "grassouillet": [
        "grassouillet"
    ],
    "grassouillets": [
        "grassouillet"
    ],
    "grassouillette": [
        "grassouillet"
    ],
    "grassouillettes": [
        "grassouillet"
    ],
    "gratifia": [
        "gratifier"
    ],
    "gratifiaient": [
        "gratifier"
    ],
    "gratifiait": [
        "gratifier"
    ],
    "gratifiant": [
        "gratifiant",
        "gratifier"
    ],
    "gratifiante": [
        "gratifiant"
    ],
    "gratification": [
        "gratification"
    ],
    "gratifications": [
        "gratification"
    ],
    "gratifie": [
        "gratifier"
    ],
    "gratifier": [
        "gratifier"
    ],
    "gratifierait": [
        "gratifier"
    ],
    "gratifies": [
        "gratify",
        "gratifier"
    ],
    "gratifiez": [
        "gratifier"
    ],
    "gratifierent": [
        "gratifier"
    ],
    "gratifiee": [
        "gratifier"
    ],
    "gratin": [
        "gratin"
    ],
    "gratiner": [
        "gratiner"
    ],
    "gratins": [
        "gratin"
    ],
    "gratine": [
        "gratine",
        "gratiner"
    ],
    "gratinee": [
        "gratinee",
        "gratiner"
    ],
    "gratinees": [
        "gratiner"
    ],
    "gratines": [
        "gratine",
        "gratiner"
    ],
    "gratis": [
        "gratis"
    ],
    "gratitude": [
        "gratitude"
    ],
    "gratitudes": [
        "gratitude"
    ],
    "gratos": [
        "gratos"
    ],
    "gratouillait": [
        "gratouiller"
    ],
    "gratouillant": [
        "gratouiller"
    ],
    "gratouille": [
        "gratouiller"
    ],
    "gratouillerait": [
        "gratouiller"
    ],
    "gratouillis": [
        "gratouillis"
    ],
    "gratta": [
        "gratter"
    ],
    "grattage": [
        "grattage"
    ],
    "grattages": [
        "grattage"
    ],
    "grattai": [
        "gratter"
    ],
    "grattaient": [
        "gratter"
    ],
    "grattais": [
        "gratter"
    ],
    "grattait": [
        "gratter"
    ],
    "grattant": [
        "grattant",
        "gratter"
    ],
    "gratte": [
        "gratte",
        "gratter"
    ],
    "grattement": [
        "grattement"
    ],
    "grattements": [
        "grattement"
    ],
    "grattent": [
        "gratter"
    ],
    "gratter": [
        "gratter"
    ],
    "grattera": [
        "gratter"
    ],
    "gratterai": [
        "gratter"
    ],
    "gratteraient": [
        "gratter"
    ],
    "gratterait": [
        "gratter"
    ],
    "gratterez": [
        "gratter"
    ],
    "gratterons": [
        "gratteron"
    ],
    "grattes": [
        "gratte",
        "gratter"
    ],
    "gratteur": [
        "gratteur"
    ],
    "gratteurs": [
        "gratteur"
    ],
    "grattez": [
        "gratter"
    ],
    "grattoir": [
        "grattoir"
    ],
    "grattoirs": [
        "grattoir"
    ],
    "grattons": [
        "gratton",
        "gratter"
    ],
    "grattouillant": [
        "grattouiller"
    ],
    "grattouillent": [
        "grattouiller"
    ],
    "grattouiller": [
        "grattouiller"
    ],
    "grattouilles": [
        "grattouiller"
    ],
    "grattouillis": [
        "grattouillis"
    ],
    "grattouille": [
        "grattouiller"
    ],
    "gratture": [
        "gratture"
    ],
    "grattat": [
        "gratter"
    ],
    "grattee": [
        "gratter"
    ],
    "grattees": [
        "gratter"
    ],
    "gratuit": [
        "gratuit"
    ],
    "gratuite": [
        "gratuit",
        "gratuite"
    ],
    "gratuitement": [
        "gratuitement"
    ],
    "gratuites": [
        "gratuit"
    ],
    "gratuits": [
        "gratuit"
    ],
    "grau": [
        "grau"
    ],
    "grava": [
        "graver"
    ],
    "gravai": [
        "graver"
    ],
    "gravaient": [
        "graver"
    ],
    "gravais": [
        "graver"
    ],
    "gravait": [
        "graver"
    ],
    "gravant": [
        "graver"
    ],
    "gravats": [
        "gravats"
    ],
    "grave": [
        "grave",
        "graver"
    ],
    "graveleuse": [
        "graveleux"
    ],
    "graveleuses": [
        "graveleux"
    ],
    "graveleux": [
        "graveleux"
    ],
    "gravelle": [
        "gravelle"
    ],
    "gravelles": [
        "gravelle"
    ],
    "gravele": [
        "graveler"
    ],
    "graveles": [
        "graveler"
    ],
    "gravement": [
        "gravement"
    ],
    "gravent": [
        "graver"
    ],
    "graver": [
        "grave",
        "graver"
    ],
    "graveraient": [
        "graver"
    ],
    "graverais": [
        "graver"
    ],
    "graverait": [
        "graver"
    ],
    "graves": [
        "grave",
        "graver"
    ],
    "graveur": [
        "graveur"
    ],
    "graveurs": [
        "graveur"
    ],
    "gravez": [
        "graver"
    ],
    "gravi": [
        "gravir"
    ],
    "gravide": [
        "gravide"
    ],
    "gravidite": [
        "gravidite"
    ],
    "gravie": [
        "gravir"
    ],
    "gravier": [
        "gravier"
    ],
    "graviers": [
        "gravier"
    ],
    "gravies": [
        "gravir",
        "gravy"
    ],
    "gravillon": [
        "gravillon"
    ],
    "gravillonnee": [
        "gravillonner"
    ],
    "gravillonnees": [
        "gravillonner"
    ],
    "gravillons": [
        "gravillon"
    ],
    "gravir": [
        "gravir"
    ],
    "gravirai": [
        "gravir"
    ],
    "gravirait": [
        "gravir"
    ],
    "gravirent": [
        "gravir"
    ],
    "gravirons": [
        "gravir"
    ],
    "gravis": [
        "gravir"
    ],
    "gravissaient": [
        "gravir"
    ],
    "gravissais": [
        "gravir"
    ],
    "gravissait": [
        "gravir"
    ],
    "gravissant": [
        "gravir"
    ],
    "gravisse": [
        "gravir"
    ],
    "gravissent": [
        "gravir"
    ],
    "gravissime": [
        "gravissime"
    ],
    "gravissimes": [
        "gravissime"
    ],
    "gravissions": [
        "gravir"
    ],
    "gravissons": [
        "gravir"
    ],
    "gravit": [
        "gravir"
    ],
    "gravitaient": [
        "graviter"
    ],
    "gravitait": [
        "graviter"
    ],
    "gravitant": [
        "graviter"
    ],
    "gravitation": [
        "gravitation"
    ],
    "gravitationnel": [
        "gravitationnel"
    ],
    "gravitationnelle": [
        "gravitationnel"
    ],
    "gravitationnelles": [
        "gravitationnel"
    ],
    "gravitationnels": [
        "gravitationnel"
    ],
    "gravite": [
        "graviter",
        "gravite"
    ],
    "graviter": [
        "graviter"
    ],
    "gravitons": [
        "graviter",
        "graviton"
    ],
    "gravieres": [
        "graviere"
    ],
    "gravons": [
        "graver"
    ],
    "gravos": [
        "gravos"
    ],
    "gravosse": [
        "gravosse"
    ],
    "gravosses": [
        "gravosse"
    ],
    "gravure": [
        "gravure"
    ],
    "gravures": [
        "gravure"
    ],
    "gravat": [
        "graver"
    ],
    "graverent": [
        "graver"
    ],
    "gravee": [
        "grave",
        "graver"
    ],
    "gravees": [
        "grave",
        "graver"
    ],
    "gray": [
        "gray"
    ],
    "grays": [
        "gray"
    ],
    "grec": [
        "grec"
    ],
    "grecque": [
        "grec"
    ],
    "grecques": [
        "grec"
    ],
    "grecs": [
        "grec"
    ],
    "gredin": [
        "gredin"
    ],
    "gredine": [
        "gredin"
    ],
    "gredins": [
        "gredin"
    ],
    "green": [
        "green"
    ],
    "greens": [
        "green"
    ],
    "greffage": [
        "greffage"
    ],
    "greffaient": [
        "greffer"
    ],
    "greffais": [
        "greffer"
    ],
    "greffait": [
        "greffer"
    ],
    "greffant": [
        "greffer"
    ],
    "greffe": [
        "greffe",
        "greffer"
    ],
    "greffent": [
        "greffer"
    ],
    "greffer": [
        "greffer"
    ],
    "greffera": [
        "greffer"
    ],
    "grefferais": [
        "greffer"
    ],
    "grefferons": [
        "greffer"
    ],
    "grefferont": [
        "greffer"
    ],
    "greffes": [
        "greffe",
        "greffer"
    ],
    "greffier": [
        "greffier"
    ],
    "greffiers": [
        "greffier"
    ],
    "greffiere": [
        "greffier"
    ],
    "greffon": [
        "greffon"
    ],
    "greffons": [
        "greffon"
    ],
    "greffee": [
        "greffe",
        "greffer"
    ],
    "greffees": [
        "greffe",
        "greffer"
    ],
    "grelot": [
        "grelot"
    ],
    "grelots": [
        "grelot"
    ],
    "grelotta": [
        "grelotter"
    ],
    "grelottaient": [
        "grelotter"
    ],
    "grelottais": [
        "grelotter"
    ],
    "grelottait": [
        "grelotter"
    ],
    "grelottant": [
        "grelotter",
        "grelottant"
    ],
    "grelottante": [
        "grelottant"
    ],
    "grelottantes": [
        "grelottant"
    ],
    "grelottants": [
        "grelottant"
    ],
    "grelotte": [
        "grelotter"
    ],
    "grelottement": [
        "grelottement"
    ],
    "grelottements": [
        "grelottement"
    ],
    "grelottent": [
        "grelotter"
    ],
    "grelotter": [
        "grelotter"
    ],
    "grelottes": [
        "grelotter"
    ],
    "grelotteux": [
        "grelotteux"
    ],
    "grelottions": [
        "grelotter"
    ],
    "grelottons": [
        "grelotter"
    ],
    "grelotterent": [
        "grelotter"
    ],
    "grelottee": [
        "grelotter"
    ],
    "greluche": [
        "greluche"
    ],
    "greluches": [
        "greluche"
    ],
    "greluchon": [
        "greluchon"
    ],
    "grenache": [
        "grenache"
    ],
    "grenadage": [
        "grenadage"
    ],
    "grenade": [
        "grenade",
        "grenader"
    ],
    "grenader": [
        "grenader"
    ],
    "grenades": [
        "grenade"
    ],
    "grenadeur": [
        "grenadeur"
    ],
    "grenadier": [
        "grenadier"
    ],
    "grenadiers": [
        "grenadier"
    ],
    "grenadine": [
        "grenadine",
        "grenadin"
    ],
    "grenadines": [
        "grenadine"
    ],
    "grenaille": [
        "grenaille"
    ],
    "grenailles": [
        "grenaille"
    ],
    "grenat": [
        "grenat"
    ],
    "grenats": [
        "grenat"
    ],
    "grenelle": [
        "greneler"
    ],
    "greneta": [
        "greneter"
    ],
    "greneuse": [
        "greneur"
    ],
    "grenier": [
        "grenier"
    ],
    "greniers": [
        "grenier"
    ],
    "grenoblois": [
        "grenoblois"
    ],
    "grenouillage": [
        "grenouillage"
    ],
    "grenouillait": [
        "grenouiller"
    ],
    "grenouillard": [
        "grenouillard"
    ],
    "grenouille": [
        "grenouille"
    ],
    "grenouilles": [
        "grenouille"
    ],
    "grenouillettes": [
        "grenouillette"
    ],
    "grenouillere": [
        "grenouillere"
    ],
    "grenouilleres": [
        "grenouillere"
    ],
    "grenu": [
        "grenu"
    ],
    "grenue": [
        "grenu"
    ],
    "grenues": [
        "grenu"
    ],
    "grenures": [
        "grenure"
    ],
    "grenus": [
        "grenu"
    ],
    "grene": [
        "grener"
    ],
    "grenee": [
        "grener"
    ],
    "grenees": [
        "grener"
    ],
    "gressin": [
        "gressin"
    ],
    "gressins": [
        "gressin"
    ],
    "gretchen": [
        "gretchen"
    ],
    "gretchens": [
        "gretchen"
    ],
    "grevaient": [
        "grever"
    ],
    "grever": [
        "grever"
    ],
    "greve": [
        "grever",
        "greve"
    ],
    "grevee": [
        "grever"
    ],
    "greves": [
        "grever",
        "greve"
    ],
    "gribiche": [
        "gribiche"
    ],
    "gribouilla": [
        "gribouiller"
    ],
    "gribouillage": [
        "gribouillage"
    ],
    "gribouillages": [
        "gribouillage"
    ],
    "gribouillais": [
        "gribouiller"
    ],
    "gribouillait": [
        "gribouiller"
    ],
    "gribouillant": [
        "gribouiller"
    ],
    "gribouille": [
        "gribouiller",
        "gribouille"
    ],
    "gribouillent": [
        "gribouiller"
    ],
    "gribouiller": [
        "gribouiller"
    ],
    "gribouilles": [
        "gribouiller"
    ],
    "gribouilleur": [
        "gribouilleur"
    ],
    "gribouillez": [
        "gribouiller"
    ],
    "gribouillis": [
        "gribouillis"
    ],
    "gribouillee": [
        "gribouiller"
    ],
    "gribouillees": [
        "gribouiller"
    ],
    "grief": [
        "grief"
    ],
    "griefs": [
        "grief"
    ],
    "griffa": [
        "griffer"
    ],
    "griffage": [
        "griffage"
    ],
    "griffai": [
        "griffer"
    ],
    "griffaient": [
        "griffer"
    ],
    "griffais": [
        "griffer"
    ],
    "griffait": [
        "griffer"
    ],
    "griffant": [
        "griffer"
    ],
    "griffe": [
        "griffe",
        "griffer"
    ],
    "griffent": [
        "griffer"
    ],
    "griffer": [
        "griffer"
    ],
    "griffera": [
        "griffer"
    ],
    "grifferait": [
        "griffer"
    ],
    "griffes": [
        "griffe",
        "griffer"
    ],
    "griffeur": [
        "griffeur"
    ],
    "griffon": [
        "griffon"
    ],
    "griffonna": [
        "griffonner"
    ],
    "griffonnage": [
        "griffonnage"
    ],
    "griffonnages": [
        "griffonnage"
    ],
    "griffonnai": [
        "griffonner"
    ],
    "griffonnaient": [
        "griffonner"
    ],
    "griffonnais": [
        "griffonner"
    ],
    "griffonnait": [
        "griffonner"
    ],
    "griffonnant": [
        "griffonner"
    ],
    "griffonne": [
        "griffonner"
    ],
    "griffonnent": [
        "griffonner"
    ],
    "griffonner": [
        "griffonner"
    ],
    "griffonnes": [
        "griffonner"
    ],
    "griffonneur": [
        "griffonneur"
    ],
    "griffonnez": [
        "griffonner"
    ],
    "griffonnee": [
        "griffonner"
    ],
    "griffonnees": [
        "griffonner"
    ],
    "griffons": [
        "griffer",
        "griffon"
    ],
    "grifftons": [
        "griffton"
    ],
    "griffu": [
        "griffu"
    ],
    "griffue": [
        "griffu"
    ],
    "griffues": [
        "griffu"
    ],
    "griffure": [
        "griffure"
    ],
    "griffures": [
        "griffure"
    ],
    "griffus": [
        "griffu"
    ],
    "griffee": [
        "griffe",
        "griffer"
    ],
    "griffees": [
        "griffe",
        "griffer"
    ],
    "grifton": [
        "grifton"
    ],
    "grignota": [
        "grignoter"
    ],
    "grignotage": [
        "grignotage"
    ],
    "grignotages": [
        "grignotage"
    ],
    "grignotaient": [
        "grignoter"
    ],
    "grignotais": [
        "grignoter"
    ],
    "grignotait": [
        "grignoter"
    ],
    "grignotant": [
        "grignoter"
    ],
    "grignote": [
        "grignoter"
    ],
    "grignotement": [
        "grignotement"
    ],
    "grignotent": [
        "grignoter"
    ],
    "grignoter": [
        "grignoter"
    ],
    "grignotera": [
        "grignoter"
    ],
    "grignoterai": [
        "grignoter"
    ],
    "grignoteraient": [
        "grignoter"
    ],
    "grignoterons": [
        "grignoter"
    ],
    "grignoteront": [
        "grignoter"
    ],
    "grignoteurs": [
        "grignoteur"
    ],
    "grignoteuses": [
        "grignoteur"
    ],
    "grignotions": [
        "grignoter"
    ],
    "grignotis": [
        "grignotis"
    ],
    "grignotons": [
        "grignoter"
    ],
    "grignoterent": [
        "grignoter"
    ],
    "grignotee": [
        "grignoter"
    ],
    "grignotees": [
        "grignoter"
    ],
    "grignotes": [
        "grignoter"
    ],
    "grigou": [
        "grigou"
    ],
    "grigri": [
        "grigri"
    ],
    "grigris": [
        "grigri"
    ],
    "gril": [
        "gril"
    ],
    "grill": [
        "grill"
    ],
    "grilla": [
        "griller"
    ],
    "grillade": [
        "grillade"
    ],
    "grilladerie": [
        "grilladerie"
    ],
    "grillades": [
        "grillade"
    ],
    "grillage": [
        "grillage",
        "grillager"
    ],
    "grillageront": [
        "grillager"
    ],
    "grillages": [
        "grillage",
        "grillager"
    ],
    "grillagez": [
        "grillager"
    ],
    "grillagee": [
        "grillage",
        "grillager"
    ],
    "grillagees": [
        "grillage",
        "grillager"
    ],
    "grillaient": [
        "griller"
    ],
    "grillais": [
        "griller"
    ],
    "grillait": [
        "griller"
    ],
    "grillant": [
        "griller"
    ],
    "grille": [
        "griller",
        "grille"
    ],
    "grillent": [
        "griller"
    ],
    "griller": [
        "griller"
    ],
    "grillera": [
        "griller"
    ],
    "grillerai": [
        "griller"
    ],
    "grilleraient": [
        "griller"
    ],
    "grillerais": [
        "griller"
    ],
    "grillerait": [
        "griller"
    ],
    "grilleras": [
        "griller"
    ],
    "grillerez": [
        "griller"
    ],
    "grillerions": [
        "griller"
    ],
    "grilleront": [
        "griller"
    ],
    "grilles": [
        "griller",
        "grille"
    ],
    "grillez": [
        "griller"
    ],
    "grilliez": [
        "griller"
    ],
    "grilloirs": [
        "grilloir"
    ],
    "grillon": [
        "grillon"
    ],
    "grillons": [
        "grillon",
        "griller"
    ],
    "grillots": [
        "grillot"
    ],
    "grillee": [
        "griller",
        "grille"
    ],
    "grillees": [
        "griller",
        "grille"
    ],
    "grils": [
        "gril"
    ],
    "grima": [
        "grimer"
    ],
    "grimace": [
        "grimace",
        "grimacer"
    ],
    "grimacement": [
        "grimacement"
    ],
    "grimacent": [
        "grimacer"
    ],
    "grimacer": [
        "grimacer"
    ],
    "grimaceries": [
        "grimacerie"
    ],
    "grimaces": [
        "grimace",
        "grimacer"
    ],
    "grimacez": [
        "grimacer"
    ],
    "grimacier": [
        "grimacier"
    ],
    "grimaciers": [
        "grimacier"
    ],
    "grimaciez": [
        "grimacer"
    ],
    "grimacions": [
        "grimacer"
    ],
    "grimacerent": [
        "grimacer"
    ],
    "grimage": [
        "grimage"
    ],
    "grimait": [
        "grimer"
    ],
    "grimant": [
        "grimer"
    ],
    "grimasse": [
        "grimer"
    ],
    "grimauds": [
        "grimaud"
    ],
    "grimaca": [
        "grimacer"
    ],
    "grimacai": [
        "grimacer"
    ],
    "grimacaient": [
        "grimacer"
    ],
    "grimacais": [
        "grimacer"
    ],
    "grimacait": [
        "grimacer"
    ],
    "grimacant": [
        "grimacer",
        "grimacant"
    ],
    "grimacante": [
        "grimacant"
    ],
    "grimacantes": [
        "grimacant"
    ],
    "grimacants": [
        "grimacant"
    ],
    "grimacons": [
        "grimacer"
    ],
    "griment": [
        "grimer"
    ],
    "grimer": [
        "grimer"
    ],
    "grimes": [
        "grime",
        "grimer"
    ],
    "grimoire": [
        "grimoire"
    ],
    "grimoires": [
        "grimoire"
    ],
    "grimpa": [
        "grimper"
    ],
    "grimpai": [
        "grimper"
    ],
    "grimpaient": [
        "grimper"
    ],
    "grimpais": [
        "grimper"
    ],
    "grimpait": [
        "grimper"
    ],
    "grimpant": [
        "grimper",
        "grimpant"
    ],
    "grimpante": [
        "grimpant"
    ],
    "grimpantes": [
        "grimpant"
    ],
    "grimpants": [
        "grimpant"
    ],
    "grimpe": [
        "grimpe",
        "grimper"
    ],
    "grimpent": [
        "grimper"
    ],
    "grimper": [
        "grimper"
    ],
    "grimpera": [
        "grimper"
    ],
    "grimperai": [
        "grimper"
    ],
    "grimperaient": [
        "grimper"
    ],
    "grimperais": [
        "grimper"
    ],
    "grimperait": [
        "grimper"
    ],
    "grimperez": [
        "grimper"
    ],
    "grimperons": [
        "grimper"
    ],
    "grimperont": [
        "grimper"
    ],
    "grimpette": [
        "grimpette"
    ],
    "grimpettes": [
        "grimpette"
    ],
    "grimpeur": [
        "grimpeur"
    ],
    "grimpeurs": [
        "grimpeur"
    ],
    "grimpeuse": [
        "grimpeur"
    ],
    "grimpez": [
        "grimper"
    ],
    "grimpiez": [
        "grimper"
    ],
    "grimpions": [
        "grimper"
    ],
    "grimpons": [
        "grimper"
    ],
    "grimpames": [
        "grimper"
    ],
    "grimpat": [
        "grimper"
    ],
    "grimperent": [
        "grimper"
    ],
    "grimpee": [
        "grimper",
        "grimpee"
    ],
    "grimpees": [
        "grimper"
    ],
    "grimpes": [
        "grimper"
    ],
    "grime": [
        "grimer"
    ],
    "grimee": [
        "grimer"
    ],
    "grimees": [
        "grimer"
    ],
    "grince": [
        "grincer"
    ],
    "grincement": [
        "grincement"
    ],
    "grincements": [
        "grincement"
    ],
    "grincent": [
        "grincer"
    ],
    "grincer": [
        "grincer"
    ],
    "grincerait": [
        "grincer"
    ],
    "grinces": [
        "grincer"
    ],
    "grincez": [
        "grincer"
    ],
    "grinche": [
        "grincher",
        "grinche"
    ],
    "grincheuse": [
        "grincheux"
    ],
    "grincheuses": [
        "grincheux"
    ],
    "grincheux": [
        "grincheux"
    ],
    "grinchir": [
        "grinchir"
    ],
    "grincerent": [
        "grincer"
    ],
    "gringalet": [
        "gringalet"
    ],
    "gringalets": [
        "gringalet"
    ],
    "gringo": [
        "gringo"
    ],
    "gringos": [
        "gringo"
    ],
    "gringue": [
        "gringue"
    ],
    "gringuer": [
        "gringuer"
    ],
    "grinca": [
        "grincer"
    ],
    "grincaient": [
        "grincer"
    ],
    "grincais": [
        "grincer"
    ],
    "grincait": [
        "grincer"
    ],
    "grincant": [
        "grincant",
        "grincer"
    ],
    "grincante": [
        "grincant"
    ],
    "grincantes": [
        "grincant"
    ],
    "grincants": [
        "grincant"
    ],
    "grincat": [
        "grincer"
    ],
    "griot": [
        "griot"
    ],
    "griots": [
        "griot"
    ],
    "griotte": [
        "griotte"
    ],
    "griottes": [
        "griotte"
    ],
    "grip": [
        "grip"
    ],
    "grippa": [
        "gripper"
    ],
    "grippaient": [
        "gripper"
    ],
    "grippal": [
        "grippal"
    ],
    "grippant": [
        "gripper"
    ],
    "grippaux": [
        "grippal"
    ],
    "grippe": [
        "gripper",
        "grippe"
    ],
    "grippements": [
        "grippement"
    ],
    "gripper": [
        "gripper"
    ],
    "gripperait": [
        "gripper"
    ],
    "grippes": [
        "gripper",
        "grippe"
    ],
    "grippee": [
        "gripper",
        "grippe"
    ],
    "gris": [
        "gris"
    ],
    "grisa": [
        "griser"
    ],
    "grisai": [
        "griser"
    ],
    "grisaient": [
        "griser"
    ],
    "grisaille": [
        "grisaille"
    ],
    "grisailles": [
        "grisaille"
    ],
    "grisaillerent": [
        "grisailler"
    ],
    "grisais": [
        "griser"
    ],
    "grisait": [
        "griser"
    ],
    "grisant": [
        "grisant",
        "griser"
    ],
    "grisante": [
        "grisant"
    ],
    "grisantes": [
        "grisant"
    ],
    "grisants": [
        "grisant"
    ],
    "grisassent": [
        "griser"
    ],
    "grisbi": [
        "grisbi"
    ],
    "grise": [
        "griser",
        "grise",
        "gris"
    ],
    "grisent": [
        "griser"
    ],
    "griser": [
        "griser"
    ],
    "grisera": [
        "griser"
    ],
    "griserie": [
        "griserie"
    ],
    "griseries": [
        "griserie"
    ],
    "grises": [
        "griser",
        "grise",
        "gris"
    ],
    "grisette": [
        "grisette"
    ],
    "grisettes": [
        "grisette"
    ],
    "grison": [
        "grison"
    ],
    "grisonnaient": [
        "grisonner"
    ],
    "grisonnait": [
        "grisonner"
    ],
    "grisonnant": [
        "grisonner",
        "grisonnant"
    ],
    "grisonnante": [
        "grisonnant"
    ],
    "grisonnantes": [
        "grisonnant"
    ],
    "grisonnants": [
        "grisonnant"
    ],
    "grisonne": [
        "grisonner",
        "grison"
    ],
    "grisonnent": [
        "grisonner"
    ],
    "grisonner": [
        "grisonner"
    ],
    "grisons": [
        "grison"
    ],
    "grisotte": [
        "grisotte"
    ],
    "grisou": [
        "grisou"
    ],
    "grisatre": [
        "grisatre"
    ],
    "grisatres": [
        "grisatre"
    ],
    "grisee": [
        "griser",
        "grise"
    ],
    "grisees": [
        "griser",
        "grise"
    ],
    "grive": [
        "grive"
    ],
    "grivelle": [
        "griveler"
    ],
    "grivelures": [
        "grivelure"
    ],
    "grivelee": [
        "grivele"
    ],
    "grives": [
        "grive"
    ],
    "grivet": [
        "grivet"
    ],
    "griveton": [
        "griveton"
    ],
    "grivetons": [
        "griveton"
    ],
    "grivois": [
        "grivois"
    ],
    "grivoise": [
        "grivois"
    ],
    "grivoiserie": [
        "grivoiserie"
    ],
    "grivoiseries": [
        "grivoiserie"
    ],
    "grivoises": [
        "grivois"
    ],
    "grivelerie": [
        "grivelerie"
    ],
    "grizzli": [
        "grizzli"
    ],
    "grizzlis": [
        "grizzli"
    ],
    "grizzly": [
        "grizzly"
    ],
    "grizzlys": [
        "grizzly"
    ],
    "grievement": [
        "grievement"
    ],
    "groenlandais": [
        "groenlandais"
    ],
    "grog": [
        "grog"
    ],
    "groggy": [
        "groggy"
    ],
    "grogna": [
        "grogner"
    ],
    "grognai": [
        "grogner"
    ],
    "grognaient": [
        "grogner"
    ],
    "grognais": [
        "grogner"
    ],
    "grognait": [
        "grogner"
    ],
    "grognant": [
        "grogner",
        "grognant"
    ],
    "grognard": [
        "grognard"
    ],
    "grognards": [
        "grognard"
    ],
    "grognassaient": [
        "grognasser"
    ],
    "grognasse": [
        "grognasse"
    ],
    "grognasser": [
        "grognasser"
    ],
    "grognasses": [
        "grognasse"
    ],
    "grogne": [
        "grogner",
        "grogne"
    ],
    "grognement": [
        "grognement"
    ],
    "grognements": [
        "grognement"
    ],
    "grognent": [
        "grogner"
    ],
    "grogner": [
        "grogner"
    ],
    "grognera": [
        "grogner"
    ],
    "grognes": [
        "grogner",
        "grogne"
    ],
    "grogneurs": [
        "grogneur"
    ],
    "grogneuse": [
        "grogneur"
    ],
    "grognions": [
        "grogner"
    ],
    "grognon": [
        "grognon"
    ],
    "grognonna": [
        "grognonner"
    ],
    "grognonne": [
        "grognon",
        "grognonner"
    ],
    "grognonner": [
        "grognonner"
    ],
    "grognons": [
        "grognon"
    ],
    "grognerent": [
        "grogner"
    ],
    "grognees": [
        "grogner"
    ],
    "grogs": [
        "grog"
    ],
    "groin": [
        "groin"
    ],
    "groins": [
        "groin"
    ],
    "grole": [
        "grole"
    ],
    "groles": [
        "grole"
    ],
    "grolle": [
        "grolle"
    ],
    "grolles": [
        "grolle"
    ],
    "grommela": [
        "grommeler"
    ],
    "grommelai": [
        "grommeler"
    ],
    "grommelaient": [
        "grommeler"
    ],
    "grommelait": [
        "grommeler"
    ],
    "grommelant": [
        "grommeler"
    ],
    "grommeler": [
        "grommeler"
    ],
    "grommelez": [
        "grommeler"
    ],
    "grommelle": [
        "grommeler"
    ],
    "grommellement": [
        "grommellement"
    ],
    "grommellements": [
        "grommellement"
    ],
    "grommellent": [
        "grommeler"
    ],
    "grommellerait": [
        "grommeler"
    ],
    "grommelerent": [
        "grommeler"
    ],
    "grommele": [
        "grommeler"
    ],
    "grommelee": [
        "grommeler"
    ],
    "gronda": [
        "gronder"
    ],
    "grondai": [
        "gronder"
    ],
    "grondaient": [
        "gronder"
    ],
    "grondais": [
        "gronder"
    ],
    "grondait": [
        "gronder"
    ],
    "grondant": [
        "gronder",
        "grondant"
    ],
    "grondante": [
        "grondant"
    ],
    "grondants": [
        "grondant"
    ],
    "gronde": [
        "gronder"
    ],
    "grondement": [
        "grondement"
    ],
    "grondements": [
        "grondement"
    ],
    "grondent": [
        "gronder"
    ],
    "gronder": [
        "gronder"
    ],
    "grondera": [
        "gronder"
    ],
    "gronderai": [
        "gronder"
    ],
    "gronderait": [
        "gronder"
    ],
    "gronderies": [
        "gronderie"
    ],
    "grondes": [
        "gronder"
    ],
    "grondeur": [
        "grondeur"
    ],
    "grondeurs": [
        "grondeur"
    ],
    "grondeuse": [
        "grondeur"
    ],
    "grondeuses": [
        "grondeur"
    ],
    "grondez": [
        "gronder"
    ],
    "grondin": [
        "grondin"
    ],
    "grondins": [
        "grondin"
    ],
    "gronderent": [
        "gronder"
    ],
    "grondee": [
        "gronder"
    ],
    "groom": [
        "groom"
    ],
    "grooms": [
        "groom"
    ],
    "gros": [
        "gros"
    ],
    "groschen": [
        "groschen"
    ],
    "groseille": [
        "groseille"
    ],
    "groseilles": [
        "groseille"
    ],
    "groseillier": [
        "groseillier"
    ],
    "groseilliers": [
        "groseillier"
    ],
    "grosse": [
        "gros"
    ],
    "grosses": [
        "gros",
        "gross"
    ],
    "grossesse": [
        "grossesse"
    ],
    "grossesses": [
        "grossesse"
    ],
    "grosseur": [
        "grosseur"
    ],
    "grosseurs": [
        "grosseur"
    ],
    "grossi": [
        "grossir",
        "grossi"
    ],
    "grossie": [
        "grossir",
        "grossi"
    ],
    "grossier": [
        "grossier"
    ],
    "grossiers": [
        "grossier"
    ],
    "grossies": [
        "grossir"
    ],
    "grossir": [
        "grossir"
    ],
    "grossira": [
        "grossir"
    ],
    "grossirent": [
        "grossir"
    ],
    "grossirez": [
        "grossir"
    ],
    "grossiront": [
        "grossir"
    ],
    "grossis": [
        "grossir",
        "grossi"
    ],
    "grossissaient": [
        "grossir"
    ],
    "grossissais": [
        "grossir"
    ],
    "grossissait": [
        "grossir"
    ],
    "grossissant": [
        "grossir",
        "grossissant"
    ],
    "grossissante": [
        "grossissant"
    ],
    "grossissantes": [
        "grossissant"
    ],
    "grossissants": [
        "grossissant"
    ],
    "grossisse": [
        "grossir"
    ],
    "grossissement": [
        "grossissement"
    ],
    "grossissent": [
        "grossir"
    ],
    "grossisses": [
        "grossir"
    ],
    "grossissez": [
        "grossir"
    ],
    "grossiste": [
        "grossiste"
    ],
    "grossistes": [
        "grossiste"
    ],
    "grossit": [
        "grossir"
    ],
    "grossium": [
        "grossium"
    ],
    "grossiums": [
        "grossium"
    ],
    "grossiere": [
        "grossier"
    ],
    "grossierement": [
        "grossierement"
    ],
    "grossieres": [
        "grossier"
    ],
    "grossierete": [
        "grossierete"
    ],
    "grossieretes": [
        "grossierete"
    ],
    "grotesque": [
        "grotesque"
    ],
    "grotesquement": [
        "grotesquement"
    ],
    "grotesques": [
        "grotesque"
    ],
    "grotte": [
        "grotte"
    ],
    "grottes": [
        "grotte"
    ],
    "grouillaient": [
        "grouiller"
    ],
    "grouillais": [
        "grouiller"
    ],
    "grouillait": [
        "grouiller"
    ],
    "grouillant": [
        "grouiller",
        "grouillant"
    ],
    "grouillante": [
        "grouillant"
    ],
    "grouillantes": [
        "grouillant"
    ],
    "grouillants": [
        "grouillant"
    ],
    "grouille": [
        "grouiller"
    ],
    "grouillement": [
        "grouillement"
    ],
    "grouillements": [
        "grouillement"
    ],
    "grouillent": [
        "grouiller"
    ],
    "grouiller": [
        "grouiller"
    ],
    "grouillera": [
        "grouiller"
    ],
    "grouillerait": [
        "grouiller"
    ],
    "grouilleront": [
        "grouiller"
    ],
    "grouilles": [
        "grouiller"
    ],
    "grouillez": [
        "grouiller"
    ],
    "grouillis": [
        "grouillis"
    ],
    "grouillons": [
        "grouiller"
    ],
    "grouillot": [
        "grouillot"
    ],
    "grouillots": [
        "grouillot"
    ],
    "grouillerent": [
        "grouiller"
    ],
    "grouillees": [
        "grouiller"
    ],
    "grouiner": [
        "grouiner"
    ],
    "groumais": [
        "groumer"
    ],
    "groumait": [
        "groumer"
    ],
    "groumant": [
        "groumer"
    ],
    "groume": [
        "groumer"
    ],
    "groumer": [
        "groumer"
    ],
    "ground": [
        "ground",
        "grind"
    ],
    "group": [
        "group"
    ],
    "groupa": [
        "grouper"
    ],
    "groupage": [
        "groupage"
    ],
    "groupaient": [
        "grouper"
    ],
    "groupais": [
        "grouper"
    ],
    "groupait": [
        "grouper"
    ],
    "groupant": [
        "grouper"
    ],
    "groupe": [
        "grouper",
        "groupe"
    ],
    "groupement": [
        "groupement"
    ],
    "groupements": [
        "groupement"
    ],
    "groupent": [
        "grouper"
    ],
    "grouper": [
        "grouper"
    ],
    "grouperaient": [
        "grouper"
    ],
    "grouperont": [
        "grouper"
    ],
    "groupes": [
        "grouper",
        "groupe"
    ],
    "groupez": [
        "grouper"
    ],
    "groupie": [
        "groupie"
    ],
    "groupies": [
        "groupie"
    ],
    "groupons": [
        "grouper"
    ],
    "groups": [
        "group"
    ],
    "groupuscule": [
        "groupuscule"
    ],
    "groupuscules": [
        "groupuscule"
    ],
    "groupat": [
        "grouper"
    ],
    "grouperent": [
        "grouper"
    ],
    "groupee": [
        "grouper",
        "groupe"
    ],
    "groupees": [
        "grouper",
        "groupe"
    ],
    "grouse": [
        "grouse"
    ],
    "grouses": [
        "grouse"
    ],
    "gruau": [
        "gruau"
    ],
    "gruaux": [
        "gruau"
    ],
    "grue": [
        "grue"
    ],
    "grues": [
        "grue"
    ],
    "gruge": [
        "gruger"
    ],
    "grugeaient": [
        "gruger"
    ],
    "grugeait": [
        "gruger"
    ],
    "grugeant": [
        "gruger"
    ],
    "gruger": [
        "gruger"
    ],
    "grugee": [
        "gruger"
    ],
    "grume": [
        "grume"
    ],
    "grumeau": [
        "grumeau"
    ],
    "grumeaux": [
        "grumeau"
    ],
    "grumeleuse": [
        "grumeleux"
    ],
    "grumeleuses": [
        "grumeleux"
    ],
    "grumeleux": [
        "grumeleux"
    ],
    "grumes": [
        "grume"
    ],
    "grumier": [
        "grumier"
    ],
    "grunge": [
        "grunge"
    ],
    "gruppetto": [
        "gruppetto"
    ],
    "gruta": [
        "gruter"
    ],
    "grute": [
        "gruter"
    ],
    "grutier": [
        "grutier"
    ],
    "grutiers": [
        "grutier"
    ],
    "grutiere": [
        "grutier"
    ],
    "gruyere": [
        "gruyere"
    ],
    "grace": [
        "grace"
    ],
    "graces": [
        "grace"
    ],
    "grebe": [
        "grebe"
    ],
    "grebes": [
        "grebe"
    ],
    "grege": [
        "grege"
    ],
    "greges": [
        "grege"
    ],
    "gregues": [
        "gregues"
    ],
    "grenera": [
        "grener"
    ],
    "gres": [
        "gres"
    ],
    "grevent": [
        "grever"
    ],
    "greverait": [
        "grever"
    ],
    "gre": [
        "gre"
    ],
    "greage": [
        "greage"
    ],
    "grebiche": [
        "grebiche"
    ],
    "greco": [
        "greco"
    ],
    "greement": [
        "greement"
    ],
    "greements": [
        "greement"
    ],
    "greer": [
        "greer"
    ],
    "greez": [
        "greer"
    ],
    "gregaire": [
        "gregaire"
    ],
    "gregeois": [
        "gregeois"
    ],
    "gregorien": [
        "gregorien"
    ],
    "gregorienne": [
        "gregorien"
    ],
    "gregoriens": [
        "gregorien"
    ],
    "gresil": [
        "gresil"
    ],
    "gresilla": [
        "gresiller"
    ],
    "gresillaient": [
        "gresiller"
    ],
    "gresillait": [
        "gresiller"
    ],
    "gresillant": [
        "gresillant",
        "gresiller"
    ],
    "gresillante": [
        "gresillant"
    ],
    "gresillantes": [
        "gresillant"
    ],
    "gresille": [
        "gresiller"
    ],
    "gresillement": [
        "gresillement"
    ],
    "gresillements": [
        "gresillement"
    ],
    "gresillent": [
        "gresiller"
    ],
    "gresiller": [
        "gresiller"
    ],
    "gresillerait": [
        "gresiller"
    ],
    "greviste": [
        "greviste"
    ],
    "grevistes": [
        "greviste"
    ],
    "gree": [
        "greer"
    ],
    "greee": [
        "greer"
    ],
    "greees": [
        "greer"
    ],
    "grelaient": [
        "greler"
    ],
    "grelait": [
        "greler"
    ],
    "grele": [
        "greler",
        "grele"
    ],
    "grelent": [
        "greler"
    ],
    "greler": [
        "greler"
    ],
    "greleraient": [
        "greler"
    ],
    "greles": [
        "greler",
        "grele"
    ],
    "grelon": [
        "grelon"
    ],
    "grelons": [
        "grelon"
    ],
    "grelee": [
        "greler",
        "grele"
    ],
    "grelees": [
        "greler"
    ],
    "guacamole": [
        "guacamole"
    ],
    "guadeloupeenne": [
        "guadeloupeenne"
    ],
    "guanaco": [
        "guanaco"
    ],
    "guanine": [
        "guanine"
    ],
    "guano": [
        "guano"
    ],
    "guaracha": [
        "guaracha"
    ],
    "guarani": [
        "guarani"
    ],
    "guatemalteque": [
        "guatemalteque"
    ],
    "guelfe": [
        "guelfe"
    ],
    "guelfes": [
        "guelfe"
    ],
    "guenille": [
        "guenille"
    ],
    "guenilles": [
        "guenille"
    ],
    "guenilleux": [
        "guenilleux"
    ],
    "guenillons": [
        "guenillon"
    ],
    "guenipe": [
        "guenipe"
    ],
    "guenon": [
        "guenon"
    ],
    "guenons": [
        "guenon"
    ],
    "guerre": [
        "guerre"
    ],
    "guerres": [
        "guerre"
    ],
    "guerrier": [
        "guerrier"
    ],
    "guerriers": [
        "guerrier"
    ],
    "guerriere": [
        "guerrier"
    ],
    "guerrieres": [
        "guerrier"
    ],
    "guerroient": [
        "guerroyer"
    ],
    "guerroyai": [
        "guerroyer"
    ],
    "guerroyaient": [
        "guerroyer"
    ],
    "guerroyait": [
        "guerroyer"
    ],
    "guerroyant": [
        "guerroyer"
    ],
    "guerroyer": [
        "guerroyer"
    ],
    "guerroyeur": [
        "guerroyeur"
    ],
    "guerroye": [
        "guerroyer"
    ],
    "guet": [
        "guet"
    ],
    "guets": [
        "guet"
    ],
    "guetta": [
        "guetter"
    ],
    "guettai": [
        "guetter"
    ],
    "guettaient": [
        "guetter"
    ],
    "guettais": [
        "guetter"
    ],
    "guettait": [
        "guetter"
    ],
    "guettant": [
        "guetter"
    ],
    "guette": [
        "guetter",
        "guette"
    ],
    "guettent": [
        "guetter"
    ],
    "guetter": [
        "guetter"
    ],
    "guettera": [
        "guetter"
    ],
    "guetterai": [
        "guetter"
    ],
    "guetterais": [
        "guetter"
    ],
    "guetterait": [
        "guetter"
    ],
    "guetterez": [
        "guetter"
    ],
    "guetterons": [
        "guetter"
    ],
    "guetteront": [
        "guetter"
    ],
    "guettes": [
        "guetter",
        "guette"
    ],
    "guetteur": [
        "guetteur"
    ],
    "guetteurs": [
        "guetteur"
    ],
    "guetteuse": [
        "guetteur"
    ],
    "guetteuses": [
        "guetteur"
    ],
    "guettez": [
        "guetter"
    ],
    "guettiez": [
        "guetter"
    ],
    "guettions": [
        "guetter"
    ],
    "guettons": [
        "guetter"
    ],
    "guettat": [
        "guetter"
    ],
    "guetterent": [
        "guetter"
    ],
    "guettee": [
        "guetter"
    ],
    "guettees": [
        "guetter"
    ],
    "gueugueule": [
        "gueugueule"
    ],
    "gueula": [
        "gueuler"
    ],
    "gueulai": [
        "gueuler"
    ],
    "gueulaient": [
        "gueuler"
    ],
    "gueulais": [
        "gueuler"
    ],
    "gueulait": [
        "gueuler"
    ],
    "gueulant": [
        "gueuler"
    ],
    "gueulante": [
        "gueulante"
    ],
    "gueulantes": [
        "gueulante"
    ],
    "gueulard": [
        "gueulard"
    ],
    "gueularde": [
        "gueulard"
    ],
    "gueulards": [
        "gueulard"
    ],
    "gueule": [
        "gueuler",
        "gueule"
    ],
    "gueulement": [
        "gueulement"
    ],
    "gueulements": [
        "gueulement"
    ],
    "gueulent": [
        "gueuler"
    ],
    "gueuler": [
        "gueuler"
    ],
    "gueulera": [
        "gueuler"
    ],
    "gueulerai": [
        "gueuler"
    ],
    "gueulerais": [
        "gueuler"
    ],
    "gueulerait": [
        "gueuler"
    ],
    "gueules": [
        "gueuler",
        "gueule"
    ],
    "gueuleton": [
        "gueuleton"
    ],
    "gueuletonnait": [
        "gueuletonner"
    ],
    "gueuletonner": [
        "gueuletonner"
    ],
    "gueuletons": [
        "gueuleton"
    ],
    "gueulette": [
        "gueulette"
    ],
    "gueulettes": [
        "gueulette"
    ],
    "gueulez": [
        "gueuler"
    ],
    "gueuloir": [
        "gueuloir"
    ],
    "gueulee": [
        "gueuler"
    ],
    "gueusant": [
        "gueuser"
    ],
    "gueusards": [
        "gueusard"
    ],
    "gueuse": [
        "gueux"
    ],
    "gueuserie": [
        "gueuserie"
    ],
    "gueuses": [
        "gueuse",
        "gueux"
    ],
    "gueux": [
        "gueux"
    ],
    "gueuze": [
        "gueuze"
    ],
    "gugusse": [
        "gugusse"
    ],
    "gugusses": [
        "gugusse"
    ],
    "gui": [
        "gui"
    ],
    "guibole": [
        "guibole"
    ],
    "guiboles": [
        "guibole"
    ],
    "guibolle": [
        "guibolle"
    ],
    "guibolles": [
        "guibolle"
    ],
    "guiche": [
        "guiche"
    ],
    "guiches": [
        "guiche"
    ],
    "guichet": [
        "guichet"
    ],
    "guichetier": [
        "guichetier"
    ],
    "guichetiers": [
        "guichetier"
    ],
    "guichetiere": [
        "guichetier"
    ],
    "guichets": [
        "guichet"
    ],
    "guida": [
        "guider"
    ],
    "guidage": [
        "guidage"
    ],
    "guidai": [
        "guider"
    ],
    "guidaient": [
        "guider"
    ],
    "guidais": [
        "guider"
    ],
    "guidait": [
        "guider"
    ],
    "guidance": [
        "guidance"
    ],
    "guidant": [
        "guider"
    ],
    "guide": [
        "guide",
        "guider"
    ],
    "guident": [
        "guider"
    ],
    "guider": [
        "guider"
    ],
    "guidera": [
        "guider"
    ],
    "guiderai": [
        "guider"
    ],
    "guiderait": [
        "guider"
    ],
    "guideras": [
        "guider"
    ],
    "guiderez": [
        "guider"
    ],
    "guideront": [
        "guider"
    ],
    "guides": [
        "guide",
        "guider"
    ],
    "guidez": [
        "guider"
    ],
    "guidiez": [
        "guider"
    ],
    "guidon": [
        "guidon"
    ],
    "guidons": [
        "guider",
        "guidon"
    ],
    "guiderent": [
        "guider"
    ],
    "guidee": [
        "guider"
    ],
    "guidees": [
        "guider"
    ],
    "guigna": [
        "guigner"
    ],
    "guignaient": [
        "guigner"
    ],
    "guignais": [
        "guigner"
    ],
    "guignait": [
        "guigner"
    ],
    "guignant": [
        "guigner"
    ],
    "guigne": [
        "guigne",
        "guigner"
    ],
    "guigner": [
        "guigner"
    ],
    "guignes": [
        "guigne"
    ],
    "guignol": [
        "guignol"
    ],
    "guignolades": [
        "guignolade"
    ],
    "guignolesque": [
        "guignolesque"
    ],
    "guignolet": [
        "guignolet"
    ],
    "guignols": [
        "guignol"
    ],
    "guignon": [
        "guignon"
    ],
    "guilde": [
        "guilde"
    ],
    "guildes": [
        "guilde"
    ],
    "guillaume": [
        "guillaume"
    ],
    "guillaumes": [
        "guillaume"
    ],
    "guilledou": [
        "guilledou"
    ],
    "guillemet": [
        "guillemet"
    ],
    "guillemets": [
        "guillemet"
    ],
    "guillemot": [
        "guillemot"
    ],
    "guilleret": [
        "guilleret"
    ],
    "guillerets": [
        "guilleret"
    ],
    "guillerette": [
        "guilleret"
    ],
    "guillerettes": [
        "guilleret"
    ],
    "guilloche": [
        "guillocher"
    ],
    "guillochures": [
        "guillochure"
    ],
    "guillochee": [
        "guillocher"
    ],
    "guillochees": [
        "guillocher"
    ],
    "guilloches": [
        "guillocher"
    ],
    "guillotina": [
        "guillotiner"
    ],
    "guillotinaient": [
        "guillotiner"
    ],
    "guillotinait": [
        "guillotiner"
    ],
    "guillotine": [
        "guillotine",
        "guillotiner"
    ],
    "guillotinent": [
        "guillotiner"
    ],
    "guillotiner": [
        "guillotiner"
    ],
    "guillotines": [
        "guillotin",
        "guillotine",
        "guillotiner"
    ],
    "guillotineur": [
        "guillotineur"
    ],
    "guillotineurs": [
        "guillotineur"
    ],
    "guillotinee": [
        "guillotine",
        "guillotiner"
    ],
    "guillotinees": [
        "guillotine"
    ],
    "guimauve": [
        "guimauve"
    ],
    "guimauves": [
        "guimauve"
    ],
    "guimbarde": [
        "guimbarde"
    ],
    "guimbardes": [
        "guimbarde"
    ],
    "guimpe": [
        "guimpe"
    ],
    "guimpes": [
        "guimpe"
    ],
    "guinchait": [
        "guincher"
    ],
    "guinche": [
        "guinche"
    ],
    "guincher": [
        "guincher"
    ],
    "guinches": [
        "guincher",
        "guinche"
    ],
    "guindaient": [
        "guinder"
    ],
    "guindait": [
        "guinder"
    ],
    "guindal": [
        "guindal"
    ],
    "guindals": [
        "guindal"
    ],
    "guindant": [
        "guinder",
        "guindant"
    ],
    "guinde": [
        "guinder",
        "guinde"
    ],
    "guindeau": [
        "guindeau"
    ],
    "guinder": [
        "guinder"
    ],
    "guindee": [
        "guinder",
        "guinde"
    ],
    "guindees": [
        "guinde"
    ],
    "guindes": [
        "guinder",
        "guinde"
    ],
    "guinguette": [
        "guinguette"
    ],
    "guinguettes": [
        "guinguette"
    ],
    "guinee": [
        "guinee"
    ],
    "guineen": [
        "guineen"
    ],
    "guineenne": [
        "guineen"
    ],
    "guineennes": [
        "guineen"
    ],
    "guineens": [
        "guineen"
    ],
    "guinees": [
        "guinee"
    ],
    "guipure": [
        "guipure"
    ],
    "guipures": [
        "guipure"
    ],
    "guirlande": [
        "guirlande"
    ],
    "guirlandes": [
        "guirlande"
    ],
    "guise": [
        "guise"
    ],
    "guises": [
        "guis",
        "guise"
    ],
    "guitare": [
        "guitare"
    ],
    "guitares": [
        "guitare"
    ],
    "guitariste": [
        "guitariste"
    ],
    "guitaristes": [
        "guitariste"
    ],
    "guitoune": [
        "guitoune"
    ],
    "guitounes": [
        "guitoune"
    ],
    "gulden": [
        "gulden"
    ],
    "gun": [
        "gun"
    ],
    "guna": [
        "guna"
    ],
    "guns": [
        "gun"
    ],
    "guppy": [
        "guppy"
    ],
    "guru": [
        "guru"
    ],
    "gus": [
        "gus"
    ],
    "gusse": [
        "gusse"
    ],
    "gustatif": [
        "gustatif"
    ],
    "gustation": [
        "gustation"
    ],
    "gustative": [
        "gustatif"
    ],
    "gustatives": [
        "gustatif"
    ],
    "gusto": [
        "gusto"
    ],
    "gut": [
        "gut"
    ],
    "guttural": [
        "guttural"
    ],
    "gutturale": [
        "guttural"
    ],
    "gutturales": [
        "guttural"
    ],
    "gutturaux": [
        "guttural"
    ],
    "guyanais": [
        "guyanais"
    ],
    "guzla": [
        "guzla"
    ],
    "guede": [
        "guede"
    ],
    "guere": [
        "guere"
    ],
    "gue": [
        "gue"
    ],
    "gueable": [
        "gueable"
    ],
    "gueguerre": [
        "gueguerre"
    ],
    "gueguerres": [
        "gueguerre"
    ],
    "guepard": [
        "guepard"
    ],
    "guepards": [
        "guepard"
    ],
    "gueret": [
        "gueret"
    ],
    "guerets": [
        "gueret"
    ],
    "gueri": [
        "guerir",
        "gueri"
    ],
    "gueridon": [
        "gueridon"
    ],
    "gueridons": [
        "gueridon"
    ],
    "guerie": [
        "guerir",
        "gueri"
    ],
    "gueries": [
        "guerir",
        "gueri"
    ],
    "guerilla": [
        "guerilla"
    ],
    "guerillas": [
        "guerilla"
    ],
    "guerillero": [
        "guerillero"
    ],
    "guerilleros": [
        "guerillero"
    ],
    "guerir": [
        "guerir"
    ],
    "guerira": [
        "guerir"
    ],
    "guerirai": [
        "guerir"
    ],
    "guerirais": [
        "guerir"
    ],
    "guerirait": [
        "guerir"
    ],
    "gueriras": [
        "guerir"
    ],
    "guerirez": [
        "guerir"
    ],
    "guerirons": [
        "guerir"
    ],
    "gueriront": [
        "guerir"
    ],
    "gueris": [
        "guerir",
        "gueri"
    ],
    "guerison": [
        "guerison"
    ],
    "guerisons": [
        "guerison"
    ],
    "guerissable": [
        "guerissable"
    ],
    "guerissables": [
        "guerissable"
    ],
    "guerissaient": [
        "guerir"
    ],
    "guerissais": [
        "guerir"
    ],
    "guerissait": [
        "guerir"
    ],
    "guerissant": [
        "guerir"
    ],
    "guerisse": [
        "guerir"
    ],
    "guerissent": [
        "guerir"
    ],
    "guerisses": [
        "guerir"
    ],
    "guerisseur": [
        "guerisseur"
    ],
    "guerisseurs": [
        "guerisseur"
    ],
    "guerisseuse": [
        "guerisseur"
    ],
    "guerisseuses": [
        "guerisseur"
    ],
    "guerissez": [
        "guerir"
    ],
    "guerissiez": [
        "guerir"
    ],
    "guerissons": [
        "guerir"
    ],
    "guerit": [
        "guerir"
    ],
    "guerite": [
        "guerite"
    ],
    "guerites": [
        "guerite"
    ],
    "guevariste": [
        "guevariste"
    ],
    "guepe": [
        "guepe"
    ],
    "guepes": [
        "guepe"
    ],
    "guepier": [
        "guepier"
    ],
    "guepiere": [
        "guepiere"
    ],
    "guepieres": [
        "guepiere"
    ],
    "guetre": [
        "guetrer",
        "guetre"
    ],
    "guetres": [
        "guetrer",
        "guetre"
    ],
    "gy": [
        "gy"
    ],
    "gym": [
        "gym"
    ],
    "gymkhana": [
        "gymkhana"
    ],
    "gymnase": [
        "gymnase"
    ],
    "gymnases": [
        "gymnase"
    ],
    "gymnasium": [
        "gymnasium"
    ],
    "gymnaste": [
        "gymnaste"
    ],
    "gymnastes": [
        "gymnaste"
    ],
    "gymnastique": [
        "gymnastique"
    ],
    "gymnastiques": [
        "gymnastique"
    ],
    "gymnique": [
        "gymnique"
    ],
    "gymniques": [
        "gymnique"
    ],
    "gymnopedie": [
        "gymnopedie"
    ],
    "gymnosophiste": [
        "gymnosophiste"
    ],
    "gymnosophistes": [
        "gymnosophiste"
    ],
    "gyneco": [
        "gyneco"
    ],
    "gynecologie": [
        "gynecologie"
    ],
    "gynecologique": [
        "gynecologique"
    ],
    "gynecologiques": [
        "gynecologique"
    ],
    "gynecologue": [
        "gynecologue"
    ],
    "gynecologues": [
        "gynecologue"
    ],
    "gynecomastie": [
        "gynecomastie"
    ],
    "gynecee": [
        "gynecee"
    ],
    "gynecees": [
        "gynecee"
    ],
    "gypaete": [
        "gypaete"
    ],
    "gypse": [
        "gypse"
    ],
    "gypses": [
        "gypse"
    ],
    "gypseuse": [
        "gypseux"
    ],
    "gypseux": [
        "gypseux"
    ],
    "gypsophile": [
        "gypsophile"
    ],
    "gypsophiles": [
        "gypsophile"
    ],
    "gyrins": [
        "gyrin"
    ],
    "gyrocompas": [
        "gyrocompas"
    ],
    "gyrophare": [
        "gyrophare"
    ],
    "gyrophares": [
        "gyrophare"
    ],
    "gyroscope": [
        "gyroscope"
    ],
    "gyroscopes": [
        "gyroscope"
    ],
    "gyroscopique": [
        "gyroscopique"
    ],
    "gyrus": [
        "gyrus"
    ],
    "gacha": [
        "gacher"
    ],
    "gachage": [
        "gachage"
    ],
    "gachaient": [
        "gacher"
    ],
    "gachais": [
        "gacher"
    ],
    "gachait": [
        "gacher"
    ],
    "gachant": [
        "gacher"
    ],
    "gache": [
        "gacher",
        "gache"
    ],
    "gachent": [
        "gacher"
    ],
    "gacher": [
        "gacher"
    ],
    "gachera": [
        "gacher"
    ],
    "gacherai": [
        "gacher"
    ],
    "gacheraient": [
        "gacher"
    ],
    "gacherais": [
        "gacher"
    ],
    "gacherait": [
        "gacher"
    ],
    "gacheras": [
        "gacher"
    ],
    "gacherez": [
        "gacher"
    ],
    "gacheriez": [
        "gacher"
    ],
    "gaches": [
        "gacher",
        "gache"
    ],
    "gachette": [
        "gachette"
    ],
    "gachettes": [
        "gachette"
    ],
    "gacheur": [
        "gacheur"
    ],
    "gacheurs": [
        "gacheur"
    ],
    "gacheuse": [
        "gacheur"
    ],
    "gachez": [
        "gacher"
    ],
    "gachiez": [
        "gacher"
    ],
    "gachis": [
        "gachis"
    ],
    "gachons": [
        "gacher"
    ],
    "gachat": [
        "gacher"
    ],
    "gachee": [
        "gacher"
    ],
    "gachees": [
        "gacher"
    ],
    "gata": [
        "gater"
    ],
    "gataient": [
        "gater"
    ],
    "gatais": [
        "gater"
    ],
    "gatait": [
        "gater"
    ],
    "gatant": [
        "gater"
    ],
    "gate": [
        "gater",
        "gate"
    ],
    "gateau": [
        "gateau"
    ],
    "gateaux": [
        "gateau"
    ],
    "gatent": [
        "gater"
    ],
    "gater": [
        "gater"
    ],
    "gatera": [
        "gater"
    ],
    "gaterais": [
        "gater"
    ],
    "gaterait": [
        "gater"
    ],
    "gaterie": [
        "gaterie"
    ],
    "gateries": [
        "gaterie"
    ],
    "gateront": [
        "gater"
    ],
    "gates": [
        "gater",
        "gate"
    ],
    "gateuse": [
        "gateur",
        "gateux"
    ],
    "gateuses": [
        "gateux"
    ],
    "gateux": [
        "gateux"
    ],
    "gatez": [
        "gater"
    ],
    "gatifie": [
        "gatifier"
    ],
    "gatine": [
        "gatine"
    ],
    "gatisme": [
        "gatisme"
    ],
    "gatat": [
        "gater"
    ],
    "gaterent": [
        "gater"
    ],
    "gatee": [
        "gater",
        "gate"
    ],
    "gatees": [
        "gater",
        "gate"
    ],
    "gelent": [
        "geler"
    ],
    "gelera": [
        "geler"
    ],
    "gelerai": [
        "geler"
    ],
    "gelerait": [
        "geler"
    ],
    "gene": [
        "gener",
        "gene"
    ],
    "genes": [
        "gener",
        "gene"
    ],
    "gere": [
        "gere",
        "gerer"
    ],
    "gerent": [
        "gerer"
    ],
    "geant": [
        "geant"
    ],
    "geante": [
        "geant"
    ],
    "geantes": [
        "geant"
    ],
    "geants": [
        "geant"
    ],
    "gegene": [
        "gegene"
    ],
    "gehenne": [
        "gehenne"
    ],
    "gehennes": [
        "gehenne"
    ],
    "gelatine": [
        "gelatine"
    ],
    "gelatines": [
        "gelatine"
    ],
    "gelatineuse": [
        "gelatineux"
    ],
    "gelatineuses": [
        "gelatineux"
    ],
    "gelatineux": [
        "gelatineux"
    ],
    "gelifiant": [
        "gelifiant"
    ],
    "gelification": [
        "gelification"
    ],
    "gelifie": [
        "gelifier"
    ],
    "gelines": [
        "geline"
    ],
    "gelolevure": [
        "gelolevure"
    ],
    "gelose": [
        "gelose"
    ],
    "gelule": [
        "gelule"
    ],
    "gelules": [
        "gelule"
    ],
    "gemeau": [
        "gemeau"
    ],
    "gemeaux": [
        "gemeau"
    ],
    "gemellaire": [
        "gemellaire"
    ],
    "gemellaires": [
        "gemellaire"
    ],
    "gemellite": [
        "gemellite"
    ],
    "gemi": [
        "gemir"
    ],
    "gemie": [
        "gemir"
    ],
    "gemir": [
        "gemir"
    ],
    "gemira": [
        "gemir"
    ],
    "gemirai": [
        "gemir"
    ],
    "gemiraient": [
        "gemir"
    ],
    "gemirais": [
        "gemir"
    ],
    "gemirait": [
        "gemir"
    ],
    "gemirent": [
        "gemir"
    ],
    "gemis": [
        "gemir"
    ],
    "gemissaient": [
        "gemir"
    ],
    "gemissais": [
        "gemir"
    ],
    "gemissait": [
        "gemir"
    ],
    "gemissant": [
        "gemir",
        "gemissant"
    ],
    "gemissante": [
        "gemissant"
    ],
    "gemissantes": [
        "gemissant"
    ],
    "gemissants": [
        "gemissant"
    ],
    "gemisse": [
        "gemir"
    ],
    "gemissement": [
        "gemissement"
    ],
    "gemissements": [
        "gemissement"
    ],
    "gemissent": [
        "gemir"
    ],
    "gemisseur": [
        "gemisseur"
    ],
    "gemisseurs": [
        "gemisseur"
    ],
    "gemissez": [
        "gemir"
    ],
    "gemissiez": [
        "gemir"
    ],
    "gemit": [
        "gemir"
    ],
    "gemonies": [
        "gemonies"
    ],
    "genial": [
        "genial"
    ],
    "geniale": [
        "genial"
    ],
    "genialement": [
        "genialement"
    ],
    "geniales": [
        "genial"
    ],
    "genialite": [
        "genialite"
    ],
    "geniaux": [
        "genial"
    ],
    "genie": [
        "genie"
    ],
    "genies": [
        "genie"
    ],
    "genique": [
        "genique"
    ],
    "genisse": [
        "genisse"
    ],
    "genisses": [
        "genisse"
    ],
    "genital": [
        "genital"
    ],
    "genitale": [
        "genital"
    ],
    "genitales": [
        "genital"
    ],
    "genitalite": [
        "genitalite"
    ],
    "genitaux": [
        "genital"
    ],
    "geniteur": [
        "geniteur"
    ],
    "geniteurs": [
        "geniteur"
    ],
    "genitoires": [
        "genitoire"
    ],
    "genitrice": [
        "geniteur"
    ],
    "genitrices": [
        "geniteur"
    ],
    "genocidaire": [
        "genocidaire"
    ],
    "genocide": [
        "genocide"
    ],
    "genocides": [
        "genocide"
    ],
    "genois": [
        "genois"
    ],
    "genoise": [
        "genois"
    ],
    "genoises": [
        "genois"
    ],
    "genome": [
        "genome"
    ],
    "genomique": [
        "genomique"
    ],
    "genomiques": [
        "genomique"
    ],
    "genotype": [
        "genotype"
    ],
    "genotypes": [
        "genotype"
    ],
    "genovefains": [
        "genovefain"
    ],
    "genuflexion": [
        "genuflexion"
    ],
    "genuflexions": [
        "genuflexion"
    ],
    "genuine": [
        "genuine"
    ],
    "genere": [
        "generer",
        "genere"
    ],
    "generes": [
        "generer",
        "genere"
    ],
    "genealogie": [
        "genealogie"
    ],
    "genealogies": [
        "genealogie",
        "genealogy"
    ],
    "genealogique": [
        "genealogique"
    ],
    "genealogiques": [
        "genealogique"
    ],
    "genealogiste": [
        "genealogiste"
    ],
    "genealogistes": [
        "genealogiste"
    ],
    "general": [
        "general"
    ],
    "generale": [
        "general"
    ],
    "generalement": [
        "generalement"
    ],
    "generales": [
        "general"
    ],
    "generalife": [
        "generalife"
    ],
    "generalisable": [
        "generalisable"
    ],
    "generalisait": [
        "generaliser"
    ],
    "generalisant": [
        "generaliser"
    ],
    "generalisation": [
        "generalisation"
    ],
    "generalisations": [
        "generalisation"
    ],
    "generalise": [
        "generalise",
        "generaliser"
    ],
    "generaliser": [
        "generaliser"
    ],
    "generalisez": [
        "generaliser"
    ],
    "generalisions": [
        "generaliser"
    ],
    "generalissime": [
        "generalissime"
    ],
    "generaliste": [
        "generaliste"
    ],
    "generalistes": [
        "generaliste"
    ],
    "generalisee": [
        "generalise",
        "generaliser"
    ],
    "generalisees": [
        "generalise"
    ],
    "generalite": [
        "generalite"
    ],
    "generalites": [
        "generalite"
    ],
    "generant": [
        "generer"
    ],
    "generateur": [
        "generateur"
    ],
    "generateurs": [
        "generateur"
    ],
    "generatif": [
        "generatif"
    ],
    "generation": [
        "generation"
    ],
    "generationnel": [
        "generationnel"
    ],
    "generations": [
        "generation"
    ],
    "generative": [
        "generatif"
    ],
    "generatrice": [
        "generateur"
    ],
    "generatrices": [
        "generateur"
    ],
    "generaux": [
        "general"
    ],
    "generer": [
        "generer"
    ],
    "genereuse": [
        "genereux"
    ],
    "genereusement": [
        "genereusement"
    ],
    "genereuses": [
        "genereux"
    ],
    "genereux": [
        "genereux"
    ],
    "generez": [
        "generer"
    ],
    "generique": [
        "generique"
    ],
    "generiques": [
        "generique"
    ],
    "generosite": [
        "generosite"
    ],
    "generosites": [
        "generosite"
    ],
    "generee": [
        "generer",
        "genere"
    ],
    "genesique": [
        "genesique"
    ],
    "geneticien": [
        "geneticien"
    ],
    "geneticienne": [
        "geneticien"
    ],
    "geneticiens": [
        "geneticien"
    ],
    "genetique": [
        "genetique"
    ],
    "genetiquement": [
        "genetiquement"
    ],
    "genetiques": [
        "genetique"
    ],
    "geo": [
        "geo"
    ],
    "geocorises": [
        "geocorise"
    ],
    "geode": [
        "geode"
    ],
    "geodesiens": [
        "geodesien"
    ],
    "geodesigraphe": [
        "geodesigraphe"
    ],
    "geodesique": [
        "geodesique"
    ],
    "geodesiques": [
        "geodesique"
    ],
    "geographe": [
        "geographe"
    ],
    "geographes": [
        "geographe"
    ],
    "geographie": [
        "geographie"
    ],
    "geographies": [
        "geographie",
        "geography"
    ],
    "geographique": [
        "geographique"
    ],
    "geographiquement": [
        "geographiquement"
    ],
    "geographiques": [
        "geographique"
    ],
    "geologie": [
        "geologie"
    ],
    "geologique": [
        "geologique"
    ],
    "geologiquement": [
        "geologiquement"
    ],
    "geologiques": [
        "geologique"
    ],
    "geologue": [
        "geologue"
    ],
    "geologues": [
        "geologue"
    ],
    "geomagnetique": [
        "geomagnetique"
    ],
    "geomagnetiques": [
        "geomagnetique"
    ],
    "geomancie": [
        "geomancie"
    ],
    "geometre": [
        "geometre"
    ],
    "geometres": [
        "geometre"
    ],
    "geometrie": [
        "geometrie"
    ],
    "geometries": [
        "geometry",
        "geometrie"
    ],
    "geometrique": [
        "geometrique"
    ],
    "geometriquement": [
        "geometriquement"
    ],
    "geometriques": [
        "geometrique"
    ],
    "geophysiciens": [
        "geophysicien"
    ],
    "geophysique": [
        "geophysique"
    ],
    "geopolitique": [
        "geopolitique"
    ],
    "georgien": [
        "georgien"
    ],
    "georgienne": [
        "georgien"
    ],
    "georgiennes": [
        "georgien"
    ],
    "georgiens": [
        "georgien"
    ],
    "geosciences": [
        "geoscience"
    ],
    "geostationnaire": [
        "geostationnaire"
    ],
    "geostrategie": [
        "geostrategie"
    ],
    "geosynchrone": [
        "geosynchrone"
    ],
    "geothermale": [
        "geothermal"
    ],
    "geothermie": [
        "geothermie"
    ],
    "geothermique": [
        "geothermique"
    ],
    "geotropique": [
        "geotropique"
    ],
    "geotropiques": [
        "geotropique"
    ],
    "gera": [
        "gerer"
    ],
    "gerable": [
        "gerable"
    ],
    "gerables": [
        "gerable"
    ],
    "gerais": [
        "gerer"
    ],
    "gerait": [
        "gerer"
    ],
    "gerance": [
        "gerance"
    ],
    "geranium": [
        "geranium"
    ],
    "geraniums": [
        "geranium"
    ],
    "gerant": [
        "gerer",
        "gerant"
    ],
    "gerante": [
        "gerant"
    ],
    "gerants": [
        "gerant"
    ],
    "gerer": [
        "gerer"
    ],
    "gerera": [
        "gerer"
    ],
    "gererai": [
        "gerer"
    ],
    "gererais": [
        "gerer"
    ],
    "gererez": [
        "gerer"
    ],
    "gereriez": [
        "gerer"
    ],
    "gerez": [
        "gerer"
    ],
    "geriatrie": [
        "geriatrie"
    ],
    "geriatrique": [
        "geriatrique"
    ],
    "geriatriques": [
        "geriatrique"
    ],
    "gerons": [
        "gerer"
    ],
    "geronte": [
        "geronte"
    ],
    "gerontes": [
        "geronte"
    ],
    "gerontisme": [
        "gerontisme"
    ],
    "gerontologie": [
        "gerontologie"
    ],
    "gerontologue": [
        "gerontologue"
    ],
    "gerontophiles": [
        "gerontophile"
    ],
    "geree": [
        "gerer"
    ],
    "gerees": [
        "gerer"
    ],
    "geres": [
        "gerer"
    ],
    "gesier": [
        "gesier"
    ],
    "gesiers": [
        "gesier"
    ],
    "gesine": [
        "gesine"
    ],
    "gesir": [
        "gesir"
    ],
    "gena": [
        "gener"
    ],
    "genaient": [
        "gener"
    ],
    "genais": [
        "gener"
    ],
    "genait": [
        "gener"
    ],
    "genant": [
        "gener",
        "genant"
    ],
    "genante": [
        "genant"
    ],
    "genantes": [
        "genant"
    ],
    "genants": [
        "genant"
    ],
    "genent": [
        "gener"
    ],
    "gener": [
        "gener"
    ],
    "genera": [
        "gener",
        "genus"
    ],
    "generai": [
        "gener"
    ],
    "generaient": [
        "gener"
    ],
    "generais": [
        "gener"
    ],
    "generait": [
        "gener"
    ],
    "generons": [
        "gener"
    ],
    "generont": [
        "gener"
    ],
    "geneur": [
        "geneur"
    ],
    "geneurs": [
        "geneur"
    ],
    "geneuse": [
        "geneur"
    ],
    "geneuses": [
        "geneur"
    ],
    "genez": [
        "gener"
    ],
    "geniez": [
        "gener"
    ],
    "genons": [
        "gener"
    ],
    "genat": [
        "gener"
    ],
    "genee": [
        "gener",
        "gene"
    ],
    "genees": [
        "gener",
        "gene"
    ],
    "git": [
        "gesir"
    ],
    "gita": [
        "giter"
    ],
    "gitait": [
        "giter"
    ],
    "gite": [
        "gite",
        "giter"
    ],
    "gitent": [
        "giter"
    ],
    "giter": [
        "giter"
    ],
    "gitera": [
        "giter"
    ],
    "gites": [
        "gite"
    ],
    "ha": [
        "ha"
    ],
    "habanera": [
        "habanera"
    ],
    "habile": [
        "habile"
    ],
    "habilement": [
        "habilement"
    ],
    "habiles": [
        "habile"
    ],
    "habilete": [
        "habilete"
    ],
    "habiletes": [
        "habilete"
    ],
    "habilitation": [
        "habilitation"
    ],
    "habilitations": [
        "habilitation"
    ],
    "habilite": [
        "habiliter",
        "habilite"
    ],
    "habilitee": [
        "habiliter",
        "habilite"
    ],
    "habilitees": [
        "habiliter",
        "habilite"
    ],
    "habilites": [
        "habiliter",
        "habilite"
    ],
    "habilla": [
        "habiller"
    ],
    "habillage": [
        "habillage"
    ],
    "habillai": [
        "habiller"
    ],
    "habillaient": [
        "habiller"
    ],
    "habillais": [
        "habiller"
    ],
    "habillait": [
        "habiller"
    ],
    "habillant": [
        "habiller"
    ],
    "habillas": [
        "habiller"
    ],
    "habille": [
        "habiller",
        "habille"
    ],
    "habillement": [
        "habillement"
    ],
    "habillent": [
        "habiller"
    ],
    "habiller": [
        "habiller"
    ],
    "habillera": [
        "habiller"
    ],
    "habillerai": [
        "habiller"
    ],
    "habilleraient": [
        "habiller"
    ],
    "habillerais": [
        "habiller"
    ],
    "habillerait": [
        "habiller"
    ],
    "habilleras": [
        "habiller"
    ],
    "habillerez": [
        "habiller"
    ],
    "habillerons": [
        "habiller"
    ],
    "habilles": [
        "habiller",
        "habille"
    ],
    "habilleur": [
        "habilleur"
    ],
    "habilleurs": [
        "habilleur"
    ],
    "habilleuse": [
        "habilleur"
    ],
    "habilleuses": [
        "habilleur"
    ],
    "habillez": [
        "habiller"
    ],
    "habilliez": [
        "habiller"
    ],
    "habillions": [
        "habiller"
    ],
    "habillons": [
        "habiller"
    ],
    "habillames": [
        "habiller"
    ],
    "habillat": [
        "habiller"
    ],
    "habillerent": [
        "habiller"
    ],
    "habillee": [
        "habiller",
        "habille"
    ],
    "habillees": [
        "habiller",
        "habille"
    ],
    "habit": [
        "habit"
    ],
    "habita": [
        "habiter"
    ],
    "habitabilite": [
        "habitabilite"
    ],
    "habitable": [
        "habitable"
    ],
    "habitables": [
        "habitable"
    ],
    "habitacle": [
        "habitacle"
    ],
    "habitacles": [
        "habitacle"
    ],
    "habitai": [
        "habiter"
    ],
    "habitaient": [
        "habiter"
    ],
    "habitais": [
        "habiter"
    ],
    "habitait": [
        "habiter"
    ],
    "habitant": [
        "habitant",
        "habiter"
    ],
    "habitante": [
        "habitant"
    ],
    "habitants": [
        "habitant"
    ],
    "habitassent": [
        "habiter"
    ],
    "habitat": [
        "habiter",
        "habitat"
    ],
    "habitation": [
        "habitation"
    ],
    "habitations": [
        "habitation"
    ],
    "habitats": [
        "habitat"
    ],
    "habite": [
        "habite",
        "habiter"
    ],
    "habitent": [
        "habiter"
    ],
    "habiter": [
        "habiter"
    ],
    "habitera": [
        "habiter"
    ],
    "habiterai": [
        "habiter"
    ],
    "habiteraient": [
        "habiter"
    ],
    "habiterais": [
        "habiter"
    ],
    "habiterait": [
        "habiter"
    ],
    "habiteras": [
        "habiter"
    ],
    "habiterez": [
        "habiter"
    ],
    "habiterions": [
        "habiter"
    ],
    "habiterons": [
        "habiter"
    ],
    "habiteront": [
        "habiter"
    ],
    "habites": [
        "habite",
        "habiter"
    ],
    "habitez": [
        "habiter"
    ],
    "habitiez": [
        "habiter"
    ],
    "habitions": [
        "habiter"
    ],
    "habitons": [
        "habiter"
    ],
    "habits": [
        "habit"
    ],
    "habitua": [
        "habituer"
    ],
    "habituai": [
        "habituer"
    ],
    "habituaient": [
        "habituer"
    ],
    "habituais": [
        "habituer"
    ],
    "habituait": [
        "habituer"
    ],
    "habituant": [
        "habituer"
    ],
    "habitude": [
        "habitude"
    ],
    "habitudes": [
        "habitude"
    ],
    "habitue": [
        "habitue",
        "habituer"
    ],
    "habituel": [
        "habituel"
    ],
    "habituelle": [
        "habituel"
    ],
    "habituellement": [
        "habituellement"
    ],
    "habituelles": [
        "habituel"
    ],
    "habituels": [
        "habituel"
    ],
    "habituent": [
        "habituer"
    ],
    "habituer": [
        "habituer"
    ],
    "habituera": [
        "habituer"
    ],
    "habituerai": [
        "habituer"
    ],
    "habitueraient": [
        "habituer"
    ],
    "habituerais": [
        "habituer"
    ],
    "habituerait": [
        "habituer"
    ],
    "habitueras": [
        "habituer"
    ],
    "habituerez": [
        "habituer"
    ],
    "habituerons": [
        "habituer"
    ],
    "habitueront": [
        "habituer"
    ],
    "habitues": [
        "habitue",
        "habituer"
    ],
    "habituez": [
        "habituer"
    ],
    "habituons": [
        "habituer"
    ],
    "habitus": [
        "habitus"
    ],
    "habituat": [
        "habituer"
    ],
    "habituerent": [
        "habituer"
    ],
    "habituee": [
        "habitue",
        "habituer"
    ],
    "habituees": [
        "habitue",
        "habituer"
    ],
    "habiterent": [
        "habiter"
    ],
    "habitee": [
        "habite",
        "habiter"
    ],
    "habitees": [
        "habite",
        "habiter"
    ],
    "hacha": [
        "hacher"
    ],
    "hachage": [
        "hachage"
    ],
    "hachaient": [
        "hacher"
    ],
    "hachait": [
        "hacher"
    ],
    "hachant": [
        "hacher"
    ],
    "hachard": [
        "hachard"
    ],
    "hache": [
        "hacher",
        "hache"
    ],
    "hachent": [
        "hacher"
    ],
    "hacher": [
        "hacher"
    ],
    "hacherai": [
        "hacher"
    ],
    "hacherait": [
        "hacher"
    ],
    "haches": [
        "hacher",
        "hache"
    ],
    "hachette": [
        "hachette"
    ],
    "hachettes": [
        "hachette"
    ],
    "hacheur": [
        "hacheur"
    ],
    "hacheurs": [
        "hacheur"
    ],
    "hachez": [
        "hacher"
    ],
    "hachis": [
        "hachis"
    ],
    "hachisch": [
        "hachisch"
    ],
    "hachoir": [
        "hachoir"
    ],
    "hachoirs": [
        "hachoir"
    ],
    "hachuraient": [
        "hachurer"
    ],
    "hachurait": [
        "hachurer"
    ],
    "hachurant": [
        "hachurer"
    ],
    "hachure": [
        "hachure",
        "hachurer"
    ],
    "hachures": [
        "hachure",
        "hachurer"
    ],
    "hachuree": [
        "hachurer"
    ],
    "hachurees": [
        "hachurer"
    ],
    "hacherent": [
        "hacher"
    ],
    "hachee": [
        "hacher",
        "hache"
    ],
    "hachees": [
        "hacher",
        "hache"
    ],
    "hacienda": [
        "hacienda"
    ],
    "haciendas": [
        "hacienda"
    ],
    "hack": [
        "hack"
    ],
    "hacker": [
        "hacker"
    ],
    "hackers": [
        "hacker"
    ],
    "haddock": [
        "haddock"
    ],
    "hadith": [
        "hadith"
    ],
    "hadj": [
        "hadj"
    ],
    "hadji": [
        "hadji"
    ],
    "hagard": [
        "hagard"
    ],
    "hagarde": [
        "hagard"
    ],
    "hagardes": [
        "hagard"
    ],
    "hagards": [
        "hagard"
    ],
    "haggadah": [
        "haggadah"
    ],
    "haggis": [
        "haggis"
    ],
    "hagiographe": [
        "hagiographe"
    ],
    "hagiographie": [
        "hagiographie"
    ],
    "haha": [
        "haha"
    ],
    "hai": [
        "hai",
        "hair"
    ],
    "haie": [
        "hai",
        "hair",
        "haie"
    ],
    "haies": [
        "hair",
        "haie"
    ],
    "haillon": [
        "haillon"
    ],
    "haillonneuse": [
        "haillonneux"
    ],
    "haillonneux": [
        "haillonneux"
    ],
    "haillons": [
        "haillon"
    ],
    "haine": [
        "haine"
    ],
    "haines": [
        "haine"
    ],
    "haineuse": [
        "haineux"
    ],
    "haineusement": [
        "haineusement"
    ],
    "haineuses": [
        "haineux"
    ],
    "haineux": [
        "haineux"
    ],
    "haire": [
        "haire"
    ],
    "haires": [
        "haire"
    ],
    "hais": [
        "hai",
        "hair"
    ],
    "hait": [
        "hair"
    ],
    "haka": [
        "haka"
    ],
    "hakka": [
        "hakka"
    ],
    "hala": [
        "haler"
    ],
    "halage": [
        "halage"
    ],
    "halages": [
        "halage"
    ],
    "halaient": [
        "haler"
    ],
    "halait": [
        "haler"
    ],
    "halal": [
        "halal"
    ],
    "halant": [
        "haler"
    ],
    "halcyon": [
        "halcyon"
    ],
    "hale": [
        "hale",
        "haler"
    ],
    "haleine": [
        "haleine"
    ],
    "haleines": [
        "haleine"
    ],
    "halent": [
        "haler"
    ],
    "haler": [
        "haler"
    ],
    "haleta": [
        "haleter"
    ],
    "haletaient": [
        "haleter"
    ],
    "haletais": [
        "haleter"
    ],
    "haletait": [
        "haleter"
    ],
    "haletant": [
        "haleter",
        "haletant"
    ],
    "haletante": [
        "haletant"
    ],
    "haletantes": [
        "haletant"
    ],
    "haletants": [
        "haletant"
    ],
    "haleter": [
        "haleter"
    ],
    "halete": [
        "haleter"
    ],
    "haleur": [
        "haleur"
    ],
    "haleurs": [
        "haleur"
    ],
    "halez": [
        "haler"
    ],
    "halieutiques": [
        "halieutique"
    ],
    "hall": [
        "hall"
    ],
    "hallali": [
        "hallali"
    ],
    "halle": [
        "halle"
    ],
    "hallebarde": [
        "hallebarde"
    ],
    "hallebardes": [
        "hallebarde"
    ],
    "hallebardier": [
        "hallebardier"
    ],
    "hallebardiers": [
        "hallebardier"
    ],
    "halles": [
        "halle"
    ],
    "hallier": [
        "hallier"
    ],
    "halliers": [
        "hallier"
    ],
    "halloween": [
        "halloween"
    ],
    "halls": [
        "hall"
    ],
    "hallucinais": [
        "halluciner"
    ],
    "hallucinant": [
        "hallucinant",
        "halluciner"
    ],
    "hallucinante": [
        "hallucinant"
    ],
    "hallucinantes": [
        "hallucinant"
    ],
    "hallucinants": [
        "hallucinant"
    ],
    "hallucination": [
        "hallucination"
    ],
    "hallucinations": [
        "hallucination"
    ],
    "hallucinatoire": [
        "hallucinatoire"
    ],
    "hallucinatoires": [
        "hallucinatoire"
    ],
    "hallucine": [
        "hallucine",
        "halluciner"
    ],
    "halluciner": [
        "halluciner"
    ],
    "hallucinez": [
        "halluciner"
    ],
    "hallucinogene": [
        "hallucinogene"
    ],
    "hallucinogenes": [
        "hallucinogene"
    ],
    "hallucinons": [
        "halluciner"
    ],
    "hallucinee": [
        "hallucine"
    ],
    "hallucinees": [
        "hallucine"
    ],
    "hallucines": [
        "hallucine",
        "halluciner"
    ],
    "halo": [
        "halo"
    ],
    "halogene": [
        "halogene"
    ],
    "halogenes": [
        "halogene"
    ],
    "halogenure": [
        "halogenure"
    ],
    "halon": [
        "halon"
    ],
    "halons": [
        "halon"
    ],
    "haloperidol": [
        "haloperidol"
    ],
    "halos": [
        "halo"
    ],
    "halothane": [
        "halothane"
    ],
    "halte": [
        "halter",
        "halte"
    ],
    "halter": [
        "halter"
    ],
    "haltes": [
        "halte"
    ],
    "haltere": [
        "haltere"
    ],
    "halteres": [
        "haltere"
    ],
    "halterophile": [
        "halterophile"
    ],
    "halterophiles": [
        "halterophile"
    ],
    "halterophilie": [
        "halterophilie"
    ],
    "halva": [
        "halva"
    ],
    "halerent": [
        "haler"
    ],
    "haletement": [
        "haletement"
    ],
    "haletements": [
        "haletement"
    ],
    "haletent": [
        "haleter"
    ],
    "haletes": [
        "haleter"
    ],
    "halee": [
        "hale",
        "haler"
    ],
    "hales": [
        "hale",
        "haler"
    ],
    "hamac": [
        "hamac"
    ],
    "hamacs": [
        "hamac"
    ],
    "hamada": [
        "hamada"
    ],
    "hamadryade": [
        "hamadryade"
    ],
    "hamadryas": [
        "hamadryas"
    ],
    "hamamelis": [
        "hamamelis"
    ],
    "hambourgeois": [
        "hambourgeois"
    ],
    "hambourgeoises": [
        "hambourgeois"
    ],
    "hamburger": [
        "hamburger"
    ],
    "hamburgers": [
        "hamburger"
    ],
    "hameau": [
        "hameau"
    ],
    "hameaux": [
        "hameau"
    ],
    "hamecon": [
        "hamecon"
    ],
    "hameconne": [
        "hameconner"
    ],
    "hamecons": [
        "hamecon"
    ],
    "hammam": [
        "hammam"
    ],
    "hammams": [
        "hammam"
    ],
    "hammerless": [
        "hammerless"
    ],
    "hampe": [
        "hampe"
    ],
    "hampes": [
        "hampe"
    ],
    "hamster": [
        "hamster"
    ],
    "hamsters": [
        "hamster"
    ],
    "han": [
        "han"
    ],
    "hanap": [
        "hanap"
    ],
    "hanaps": [
        "hanap"
    ],
    "hanche": [
        "hanche"
    ],
    "hanches": [
        "hanche"
    ],
    "hanchee": [
        "hancher"
    ],
    "handball": [
        "handball"
    ],
    "handicap": [
        "handicap"
    ],
    "handicapait": [
        "handicaper"
    ],
    "handicapant": [
        "handicapant"
    ],
    "handicape": [
        "handicape",
        "handicaper"
    ],
    "handicaper": [
        "handicaper"
    ],
    "handicapera": [
        "handicaper"
    ],
    "handicapeur": [
        "handicapeur"
    ],
    "handicaps": [
        "handicap"
    ],
    "handicapee": [
        "handicape",
        "handicaper"
    ],
    "handicapees": [
        "handicape",
        "handicaper"
    ],
    "handicapes": [
        "handicape",
        "handicaper"
    ],
    "hangar": [
        "hangar"
    ],
    "hangars": [
        "hangar"
    ],
    "hanneton": [
        "hanneton"
    ],
    "hannetons": [
        "hanneton"
    ],
    "hanoukka": [
        "hanoukka"
    ],
    "hanovrien": [
        "hanovrien"
    ],
    "hanovriens": [
        "hanovrien"
    ],
    "hanseatique": [
        "hanseatique"
    ],
    "hanta": [
        "hanter"
    ],
    "hantaient": [
        "hanter"
    ],
    "hantais": [
        "hanter"
    ],
    "hantait": [
        "hanter"
    ],
    "hantant": [
        "hanter"
    ],
    "hantavirus": [
        "hantavirus"
    ],
    "hante": [
        "hante",
        "hanter"
    ],
    "hantent": [
        "hanter"
    ],
    "hanter": [
        "hanter"
    ],
    "hantera": [
        "hanter"
    ],
    "hanterai": [
        "hanter"
    ],
    "hanterait": [
        "hanter"
    ],
    "hanteront": [
        "hanter"
    ],
    "hantes": [
        "hante",
        "hanter"
    ],
    "hanteur": [
        "hanteur"
    ],
    "hantez": [
        "hanter"
    ],
    "hantise": [
        "hantise"
    ],
    "hantises": [
        "hantise"
    ],
    "hantee": [
        "hante",
        "hanter"
    ],
    "hantees": [
        "hante",
        "hanter"
    ],
    "happa": [
        "happer"
    ],
    "happai": [
        "happer"
    ],
    "happaient": [
        "happer"
    ],
    "happait": [
        "happer"
    ],
    "happant": [
        "happer"
    ],
    "happe": [
        "happe",
        "happer"
    ],
    "happement": [
        "happement"
    ],
    "happening": [
        "happen",
        "happening"
    ],
    "happenings": [
        "happening"
    ],
    "happent": [
        "happer"
    ],
    "happer": [
        "happer"
    ],
    "happerait": [
        "happer"
    ],
    "happeurs": [
        "happeur"
    ],
    "happee": [
        "happer"
    ],
    "happees": [
        "happer"
    ],
    "happes": [
        "happer"
    ],
    "haptoglobine": [
        "haptoglobine"
    ],
    "haque": [
        "haque"
    ],
    "haquenee": [
        "haquenee"
    ],
    "haquet": [
        "haquet"
    ],
    "haquets": [
        "haquet"
    ],
    "harangua": [
        "haranguer"
    ],
    "haranguaient": [
        "haranguer"
    ],
    "haranguait": [
        "haranguer"
    ],
    "haranguant": [
        "haranguer"
    ],
    "harangue": [
        "harangue",
        "haranguer"
    ],
    "haranguer": [
        "haranguer"
    ],
    "haranguerais": [
        "haranguer"
    ],
    "harangues": [
        "harangue",
        "haranguer"
    ],
    "haranguez": [
        "haranguer"
    ],
    "haranguee": [
        "haranguer"
    ],
    "harari": [
        "harari"
    ],
    "haras": [
        "haras"
    ],
    "harassaient": [
        "harasser"
    ],
    "harassant": [
        "harassant",
        "harasser"
    ],
    "harassante": [
        "harassant"
    ],
    "harassantes": [
        "harassant"
    ],
    "harassants": [
        "harassant"
    ],
    "harasse": [
        "harasse",
        "harasser"
    ],
    "harassement": [
        "harassement"
    ],
    "harassent": [
        "harasser"
    ],
    "harasser": [
        "harasser"
    ],
    "harassee": [
        "harasse",
        "harasser"
    ],
    "harassees": [
        "harasse",
        "harasser"
    ],
    "harasses": [
        "harasse",
        "harasser",
        "harass"
    ],
    "harcela": [
        "harceler"
    ],
    "harcelai": [
        "harceler"
    ],
    "harcelaient": [
        "harceler"
    ],
    "harcelais": [
        "harceler"
    ],
    "harcelait": [
        "harceler"
    ],
    "harcelant": [
        "harcelant",
        "harceler"
    ],
    "harcelante": [
        "harcelant"
    ],
    "harcelantes": [
        "harcelant"
    ],
    "harcelants": [
        "harcelant"
    ],
    "harceler": [
        "harceler"
    ],
    "harceleur": [
        "harceleur"
    ],
    "harceleuse": [
        "harceleur"
    ],
    "harcelez": [
        "harceler"
    ],
    "harceliez": [
        "harceler"
    ],
    "harcelerent": [
        "harceler"
    ],
    "harcele": [
        "harceler"
    ],
    "harcelee": [
        "harceler"
    ],
    "harcelees": [
        "harceler"
    ],
    "harceles": [
        "harceler"
    ],
    "harcelement": [
        "harcelement"
    ],
    "harcelements": [
        "harcelement"
    ],
    "harcelent": [
        "harceler"
    ],
    "harcelera": [
        "harceler"
    ],
    "harcelerai": [
        "harceler"
    ],
    "harceleraient": [
        "harceler"
    ],
    "harcelerez": [
        "harceler"
    ],
    "harcelerons": [
        "harceler"
    ],
    "harceleront": [
        "harceler"
    ],
    "hard": [
        "hard"
    ],
    "harde": [
        "harde"
    ],
    "hardent": [
        "harder"
    ],
    "harder": [
        "harder",
        "hard"
    ],
    "hardes": [
        "harde"
    ],
    "hardi": [
        "hardi"
    ],
    "hardie": [
        "hardi"
    ],
    "hardies": [
        "hardi"
    ],
    "hardiesse": [
        "hardiesse"
    ],
    "hardiesses": [
        "hardiesse"
    ],
    "hardiment": [
        "hardiment"
    ],
    "hardis": [
        "hardi"
    ],
    "hare": [
        "hare"
    ],
    "harem": [
        "harem"
    ],
    "harems": [
        "harem"
    ],
    "hareng": [
        "hareng"
    ],
    "harengs": [
        "hareng"
    ],
    "harenguet": [
        "harenguet"
    ],
    "harenguier": [
        "harenguier"
    ],
    "harengere": [
        "harengere"
    ],
    "haret": [
        "haret"
    ],
    "harfang": [
        "harfang"
    ],
    "hargne": [
        "hargne"
    ],
    "hargnes": [
        "hargne"
    ],
    "hargneuse": [
        "hargneux"
    ],
    "hargneusement": [
        "hargneusement"
    ],
    "hargneuses": [
        "hargneux"
    ],
    "hargneux": [
        "hargneux"
    ],
    "haricot": [
        "haricot"
    ],
    "haricots": [
        "haricot"
    ],
    "haridelle": [
        "haridelle"
    ],
    "haridelles": [
        "haridelle"
    ],
    "harissa": [
        "harissa"
    ],
    "harki": [
        "harki"
    ],
    "harkis": [
        "harki"
    ],
    "harmattan": [
        "harmattan"
    ],
    "harmonica": [
        "harmonica"
    ],
    "harmonicas": [
        "harmonica"
    ],
    "harmoniciste": [
        "harmoniciste"
    ],
    "harmonie": [
        "harmonie"
    ],
    "harmonies": [
        "harmonie",
        "harmony"
    ],
    "harmonieuse": [
        "harmonieux"
    ],
    "harmonieusement": [
        "harmonieusement"
    ],
    "harmonieuses": [
        "harmonieux"
    ],
    "harmonieux": [
        "harmonieux"
    ],
    "harmonique": [
        "harmonique"
    ],
    "harmoniquement": [
        "harmoniquement"
    ],
    "harmoniques": [
        "harmonique"
    ],
    "harmonisaient": [
        "harmoniser"
    ],
    "harmonisait": [
        "harmoniser"
    ],
    "harmonisant": [
        "harmoniser"
    ],
    "harmonisateurs": [
        "harmonisateur"
    ],
    "harmonisation": [
        "harmonisation"
    ],
    "harmonisatrices": [
        "harmonisateur"
    ],
    "harmonise": [
        "harmoniser"
    ],
    "harmonisent": [
        "harmoniser"
    ],
    "harmoniser": [
        "harmoniser"
    ],
    "harmonisera": [
        "harmoniser"
    ],
    "harmonisez": [
        "harmoniser"
    ],
    "harmoniserent": [
        "harmoniser"
    ],
    "harmonises": [
        "harmoniser",
        "harmonise"
    ],
    "harmonium": [
        "harmonium"
    ],
    "harmoniums": [
        "harmonium"
    ],
    "harnacha": [
        "harnacher"
    ],
    "harnachaient": [
        "harnacher"
    ],
    "harnachais": [
        "harnacher"
    ],
    "harnachait": [
        "harnacher"
    ],
    "harnachement": [
        "harnachement"
    ],
    "harnachements": [
        "harnachement"
    ],
    "harnacher": [
        "harnacher"
    ],
    "harnachiez": [
        "harnacher"
    ],
    "harnacherent": [
        "harnacher"
    ],
    "harnache": [
        "harnache",
        "harnacher"
    ],
    "harnachee": [
        "harnache",
        "harnacher"
    ],
    "harnachees": [
        "harnache",
        "harnacher"
    ],
    "harnaches": [
        "harnache",
        "harnacher"
    ],
    "harnais": [
        "harnais"
    ],
    "harnois": [
        "harnois"
    ],
    "haro": [
        "haro"
    ],
    "harpagon": [
        "harpagon"
    ],
    "harpe": [
        "harpe"
    ],
    "harper": [
        "harper"
    ],
    "harpes": [
        "harpe"
    ],
    "harpie": [
        "harpie"
    ],
    "harpies": [
        "harpie",
        "harpy"
    ],
    "harpin": [
        "harpin"
    ],
    "harpions": [
        "harper"
    ],
    "harpiste": [
        "harpiste"
    ],
    "harpon": [
        "harpon"
    ],
    "harponna": [
        "harponner"
    ],
    "harponnage": [
        "harponnage"
    ],
    "harponne": [
        "harponner"
    ],
    "harponnent": [
        "harponner"
    ],
    "harponner": [
        "harponner"
    ],
    "harponnera": [
        "harponner"
    ],
    "harponneur": [
        "harponneur"
    ],
    "harponneurs": [
        "harponneur"
    ],
    "harponnee": [
        "harponner"
    ],
    "harponnes": [
        "harponner"
    ],
    "harpons": [
        "harpon"
    ],
    "harpyes": [
        "harpye"
    ],
    "hart": [
        "hart"
    ],
    "harts": [
        "hart"
    ],
    "haruspices": [
        "haruspice"
    ],
    "hasard": [
        "hasard"
    ],
    "hasarda": [
        "hasarder"
    ],
    "hasardai": [
        "hasarder"
    ],
    "hasardaient": [
        "hasarder"
    ],
    "hasardais": [
        "hasarder"
    ],
    "hasardait": [
        "hasarder"
    ],
    "hasardant": [
        "hasarder"
    ],
    "hasarde": [
        "hasarder"
    ],
    "hasardent": [
        "hasarder"
    ],
    "hasarder": [
        "hasarder"
    ],
    "hasardera": [
        "hasarder"
    ],
    "hasarderais": [
        "hasarder"
    ],
    "hasardeuse": [
        "hasardeux"
    ],
    "hasardeusement": [
        "hasardeusement"
    ],
    "hasardeuses": [
        "hasardeux"
    ],
    "hasardeux": [
        "hasardeux"
    ],
    "hasards": [
        "hasard"
    ],
    "hasardee": [
        "hasarder",
        "hasarde"
    ],
    "hasch": [
        "hasch"
    ],
    "haschich": [
        "haschich"
    ],
    "haschisch": [
        "haschisch"
    ],
    "hase": [
        "hase"
    ],
    "haseki": [
        "haseki"
    ],
    "hasekis": [
        "haseki"
    ],
    "hases": [
        "hase"
    ],
    "hassidim": [
        "hassidim"
    ],
    "hassidique": [
        "hassidique"
    ],
    "hassidisme": [
        "hassidisme"
    ],
    "hauban": [
        "hauban"
    ],
    "haubans": [
        "hauban"
    ],
    "haubanee": [
        "haubaner"
    ],
    "haubanes": [
        "haubaner"
    ],
    "haubert": [
        "haubert"
    ],
    "haussa": [
        "hausser"
    ],
    "haussai": [
        "hausser"
    ],
    "haussaient": [
        "hausser"
    ],
    "haussais": [
        "hausser"
    ],
    "haussait": [
        "hausser"
    ],
    "haussant": [
        "hausser"
    ],
    "hausse": [
        "hausse",
        "hausser"
    ],
    "haussement": [
        "haussement"
    ],
    "haussements": [
        "haussement"
    ],
    "haussent": [
        "hausser"
    ],
    "hausser": [
        "hausser"
    ],
    "hausserait": [
        "hausser"
    ],
    "hausses": [
        "hausse",
        "hausser"
    ],
    "haussez": [
        "hausser"
    ],
    "haussier": [
        "haussier"
    ],
    "haussiere": [
        "haussiere",
        "haussier"
    ],
    "haussieres": [
        "haussiere"
    ],
    "haussons": [
        "hausser"
    ],
    "haussat": [
        "hausser"
    ],
    "hausserent": [
        "hausser"
    ],
    "haussee": [
        "hausser"
    ],
    "haussees": [
        "hausser"
    ],
    "haut": [
        "haut"
    ],
    "hautain": [
        "hautain"
    ],
    "hautaine": [
        "hautain"
    ],
    "hautainement": [
        "hautainement"
    ],
    "hautaines": [
        "hautain"
    ],
    "hautains": [
        "hautain"
    ],
    "hautbois": [
        "hautbois"
    ],
    "haute": [
        "haut",
        "haute"
    ],
    "hautement": [
        "hautement"
    ],
    "hautes": [
        "haut"
    ],
    "hautesse": [
        "hautesse"
    ],
    "hauteur": [
        "hauteur"
    ],
    "hauteurs": [
        "hauteur"
    ],
    "hautin": [
        "hautin"
    ],
    "hautins": [
        "hautin"
    ],
    "hauts": [
        "haut"
    ],
    "hauturiere": [
        "hauturier"
    ],
    "havanais": [
        "havanais"
    ],
    "havanaise": [
        "havanaise"
    ],
    "havane": [
        "havane"
    ],
    "havanes": [
        "havane"
    ],
    "have": [
        "haver",
        "have"
    ],
    "haveneau": [
        "haveneau"
    ],
    "haveneaux": [
        "haveneau"
    ],
    "haver": [
        "haver"
    ],
    "haves": [
        "haver",
        "have"
    ],
    "havrais": [
        "havrais"
    ],
    "havre": [
        "havre"
    ],
    "havres": [
        "havre"
    ],
    "havresac": [
        "havresac"
    ],
    "havresacs": [
        "havresac"
    ],
    "hawaiienne": [
        "hawaiien"
    ],
    "hawaiiennes": [
        "hawaiien"
    ],
    "hawaien": [
        "hawaien"
    ],
    "hawaienne": [
        "hawaien"
    ],
    "hayon": [
        "hayon"
    ],
    "hayons": [
        "hayon"
    ],
    "haik": [
        "haik"
    ],
    "haikai": [
        "haikai"
    ],
    "haiks": [
        "haik"
    ],
    "haiku": [
        "haiku"
    ],
    "haikus": [
        "haiku"
    ],
    "hair": [
        "hair"
    ],
    "haira": [
        "hair"
    ],
    "hairai": [
        "hair"
    ],
    "hairaient": [
        "hair"
    ],
    "hairais": [
        "hair"
    ],
    "hairait": [
        "hair"
    ],
    "hairas": [
        "hair"
    ],
    "hairez": [
        "hair"
    ],
    "hairiez": [
        "hair"
    ],
    "hairons": [
        "hair"
    ],
    "hairont": [
        "hair"
    ],
    "haissable": [
        "haissable"
    ],
    "haissables": [
        "haissable"
    ],
    "haissaient": [
        "hair"
    ],
    "haissais": [
        "hair"
    ],
    "haissait": [
        "hair"
    ],
    "haissant": [
        "hair"
    ],
    "haisse": [
        "hair"
    ],
    "haissent": [
        "hair"
    ],
    "haisses": [
        "hair"
    ],
    "haissez": [
        "hair"
    ],
    "haissiez": [
        "hair"
    ],
    "haissions": [
        "hair"
    ],
    "haissons": [
        "hair"
    ],
    "haitien": [
        "haitien"
    ],
    "haitienne": [
        "haitien"
    ],
    "haitiens": [
        "haitien"
    ],
    "heaume": [
        "heaume"
    ],
    "heaumes": [
        "heaume"
    ],
    "hebdo": [
        "hebdo"
    ],
    "hebdomadaire": [
        "hebdomadaire"
    ],
    "hebdomadairement": [
        "hebdomadairement"
    ],
    "hebdomadaires": [
        "hebdomadaire"
    ],
    "hebdos": [
        "hebdo"
    ],
    "hectare": [
        "hectare"
    ],
    "hectares": [
        "hectare"
    ],
    "hecto": [
        "hecto"
    ],
    "hectolitres": [
        "hectolitre"
    ],
    "hectometres": [
        "hectometre"
    ],
    "hein": [
        "hein"
    ],
    "hello": [
        "hello"
    ],
    "hellene": [
        "hellene"
    ],
    "hellenes": [
        "hellene"
    ],
    "hellenique": [
        "hellenique"
    ],
    "helleniques": [
        "hellenique"
    ],
    "helleniser": [
        "helleniser"
    ],
    "hellenisme": [
        "hellenisme"
    ],
    "helleniste": [
        "helleniste"
    ],
    "hellenistes": [
        "helleniste"
    ],
    "hellenistique": [
        "hellenistique"
    ],
    "hellenistiques": [
        "hellenistique"
    ],
    "hellenise": [
        "helleniser"
    ],
    "helminthe": [
        "helminthe"
    ],
    "helvelles": [
        "helvelle"
    ],
    "helvete": [
        "helvete"
    ],
    "helvetes": [
        "helvete"
    ],
    "helvetien": [
        "helvetien"
    ],
    "helvetique": [
        "helvetique"
    ],
    "helvetiques": [
        "helvetique"
    ],
    "hem": [
        "hem"
    ],
    "hemlock": [
        "hemlock"
    ],
    "hennin": [
        "hennin"
    ],
    "hennir": [
        "hennir"
    ],
    "hennirent": [
        "hennir"
    ],
    "hennissaient": [
        "hennir"
    ],
    "hennissait": [
        "hennir"
    ],
    "hennissant": [
        "hennir",
        "hennissant"
    ],
    "hennissantes": [
        "hennissant"
    ],
    "hennissement": [
        "hennissement"
    ],
    "hennissements": [
        "hennissement"
    ],
    "hennissent": [
        "hennir"
    ],
    "hennit": [
        "hennir"
    ],
    "henne": [
        "henne"
    ],
    "henry": [
        "henry"
    ],
    "hep": [
        "hep"
    ],
    "heptagone": [
        "heptagone"
    ],
    "heptameron": [
        "heptameron"
    ],
    "heptane": [
        "heptane"
    ],
    "herba": [
        "herber"
    ],
    "herbage": [
        "herbage"
    ],
    "herbagers": [
        "herbager"
    ],
    "herbages": [
        "herbage"
    ],
    "herbe": [
        "herbe"
    ],
    "herber": [
        "herber"
    ],
    "herbes": [
        "herbe"
    ],
    "herbette": [
        "herbette"
    ],
    "herbettes": [
        "herbette"
    ],
    "herbeuse": [
        "herbeux"
    ],
    "herbeuses": [
        "herbeux"
    ],
    "herbeux": [
        "herbeux"
    ],
    "herbicide": [
        "herbicide"
    ],
    "herbier": [
        "herbier"
    ],
    "herbiers": [
        "herbier"
    ],
    "herbivore": [
        "herbivore"
    ],
    "herbivores": [
        "herbivore"
    ],
    "herborisais": [
        "herboriser"
    ],
    "herborisait": [
        "herboriser"
    ],
    "herboriser": [
        "herboriser"
    ],
    "herboriste": [
        "herboriste"
    ],
    "herboristerie": [
        "herboristerie"
    ],
    "herboristeries": [
        "herboristerie"
    ],
    "herboristes": [
        "herboriste"
    ],
    "herbu": [
        "herbu"
    ],
    "herbue": [
        "herbu"
    ],
    "herbues": [
        "herbu"
    ],
    "herbus": [
        "herbu"
    ],
    "hercher": [
        "hercher"
    ],
    "hercule": [
        "hercule"
    ],
    "hercules": [
        "hercule"
    ],
    "herculeen": [
        "herculeen"
    ],
    "herculeenne": [
        "herculeen"
    ],
    "herculeennes": [
        "herculeen"
    ],
    "herculeens": [
        "herculeen"
    ],
    "hercynien": [
        "hercynien"
    ],
    "hercyniennes": [
        "hercynien"
    ],
    "hermaphrodisme": [
        "hermaphrodisme"
    ],
    "hermaphrodite": [
        "hermaphrodite"
    ],
    "hermaphrodites": [
        "hermaphrodite"
    ],
    "hermaphroditisme": [
        "hermaphroditisme"
    ],
    "hermine": [
        "hermine"
    ],
    "hermines": [
        "hermine"
    ],
    "herminette": [
        "herminette"
    ],
    "herminettes": [
        "herminette"
    ],
    "hermes": [
        "hermes"
    ],
    "hermeneutique": [
        "hermeneutique"
    ],
    "hermetique": [
        "hermetique"
    ],
    "hermetiquement": [
        "hermetiquement"
    ],
    "hermetiques": [
        "hermetique"
    ],
    "hermetisme": [
        "hermetisme"
    ],
    "hermetistes": [
        "hermetiste"
    ],
    "herniaire": [
        "herniaire"
    ],
    "herniaires": [
        "herniaire"
    ],
    "hernie": [
        "hernie"
    ],
    "hernies": [
        "hernie"
    ],
    "hernieux": [
        "hernieux"
    ],
    "herpes": [
        "herpes",
        "herpe"
    ],
    "herpetique": [
        "herpetique"
    ],
    "herpetologie": [
        "herpetologie"
    ],
    "herpetologiste": [
        "herpetologiste"
    ],
    "hersait": [
        "herser"
    ],
    "herse": [
        "herser",
        "herse"
    ],
    "herser": [
        "herser"
    ],
    "herses": [
        "herser",
        "herse"
    ],
    "hertz": [
        "hertz"
    ],
    "hertzienne": [
        "hertzien"
    ],
    "hertziennes": [
        "hertzien"
    ],
    "hertziens": [
        "hertzien"
    ],
    "hessois": [
        "hessois"
    ],
    "hessoise": [
        "hessois"
    ],
    "hetman": [
        "hetman"
    ],
    "heu": [
        "heu"
    ],
    "heur": [
        "heur"
    ],
    "heure": [
        "heure"
    ],
    "heures": [
        "heure"
    ],
    "heureuse": [
        "heureux"
    ],
    "heureusement": [
        "heureusement"
    ],
    "heureuses": [
        "heureux"
    ],
    "heureux": [
        "heureux"
    ],
    "heuristique": [
        "heuristique"
    ],
    "heurs": [
        "heur"
    ],
    "heurt": [
        "heurt"
    ],
    "heurta": [
        "heurter"
    ],
    "heurtai": [
        "heurter"
    ],
    "heurtaient": [
        "heurter"
    ],
    "heurtais": [
        "heurter"
    ],
    "heurtait": [
        "heurter"
    ],
    "heurtant": [
        "heurter"
    ],
    "heurte": [
        "heurter",
        "heurte"
    ],
    "heurtent": [
        "heurter"
    ],
    "heurter": [
        "heurter"
    ],
    "heurtera": [
        "heurter"
    ],
    "heurterai": [
        "heurter"
    ],
    "heurteraient": [
        "heurter"
    ],
    "heurterait": [
        "heurter"
    ],
    "heurterions": [
        "heurter"
    ],
    "heurtez": [
        "heurter"
    ],
    "heurtions": [
        "heurter"
    ],
    "heurtoir": [
        "heurtoir"
    ],
    "heurtoirs": [
        "heurtoir"
    ],
    "heurtons": [
        "heurter"
    ],
    "heurts": [
        "heurt"
    ],
    "heurtat": [
        "heurter"
    ],
    "heurterent": [
        "heurter"
    ],
    "heurtee": [
        "heurter",
        "heurte"
    ],
    "heurtees": [
        "heurter",
        "heurte"
    ],
    "heurtes": [
        "heurter",
        "heurte"
    ],
    "hexagonal": [
        "hexagonal"
    ],
    "hexagonale": [
        "hexagonal"
    ],
    "hexagonales": [
        "hexagonal"
    ],
    "hexagonaux": [
        "hexagonal"
    ],
    "hexagone": [
        "hexagone"
    ],
    "hexagones": [
        "hexagone"
    ],
    "hexametres": [
        "hexametre"
    ],
    "hi": [
        "hi"
    ],
    "hiatale": [
        "hiatal"
    ],
    "hiatus": [
        "hiatus"
    ],
    "hibernaient": [
        "hiberner"
    ],
    "hibernait": [
        "hiberner"
    ],
    "hibernation": [
        "hibernation"
    ],
    "hiberne": [
        "hiberner"
    ],
    "hibernent": [
        "hiberner"
    ],
    "hiberner": [
        "hiberner"
    ],
    "hibiscus": [
        "hibiscus"
    ],
    "hibou": [
        "hibou"
    ],
    "hiboux": [
        "hibou"
    ],
    "hic": [
        "hic"
    ],
    "hickory": [
        "hickory"
    ],
    "hidalgo": [
        "hidalgo"
    ],
    "hidalgos": [
        "hidalgo"
    ],
    "hideur": [
        "hideur"
    ],
    "hideurs": [
        "hideur"
    ],
    "hideuse": [
        "hideux"
    ],
    "hideusement": [
        "hideusement"
    ],
    "hideuses": [
        "hideux"
    ],
    "hideux": [
        "hideux"
    ],
    "hier": [
        "hier"
    ],
    "highlander": [
        "highlander"
    ],
    "highlanders": [
        "highlander"
    ],
    "higoumene": [
        "higoumene"
    ],
    "hilaire": [
        "hilaire"
    ],
    "hilarant": [
        "hilarant"
    ],
    "hilarante": [
        "hilarant"
    ],
    "hilarantes": [
        "hilarant"
    ],
    "hilarants": [
        "hilarant"
    ],
    "hilare": [
        "hilare"
    ],
    "hilares": [
        "hilare"
    ],
    "hilarite": [
        "hilarite"
    ],
    "hilarites": [
        "hilarite"
    ],
    "hile": [
        "hile"
    ],
    "hiloire": [
        "hiloire"
    ],
    "hilotes": [
        "hilote"
    ],
    "himalaya": [
        "himalaya"
    ],
    "himalayenne": [
        "himalayenne",
        "himalayen"
    ],
    "himalayens": [
        "himalayen"
    ],
    "hindi": [
        "hindi"
    ],
    "hindou": [
        "hindou"
    ],
    "hindoue": [
        "hindou"
    ],
    "hindoues": [
        "hindou"
    ],
    "hindouisme": [
        "hindouisme"
    ],
    "hindous": [
        "hindou"
    ],
    "hindoustani": [
        "hindoustani"
    ],
    "hip": [
        "hip"
    ],
    "hippie": [
        "hippie"
    ],
    "hippies": [
        "hippy",
        "hippie"
    ],
    "hippique": [
        "hippique"
    ],
    "hippiques": [
        "hippique"
    ],
    "hippisme": [
        "hippisme"
    ],
    "hippo": [
        "hippo"
    ],
    "hippocampe": [
        "hippocampe"
    ],
    "hippocampes": [
        "hippocampe"
    ],
    "hippocratique": [
        "hippocratique"
    ],
    "hippodrome": [
        "hippodrome"
    ],
    "hippodromes": [
        "hippodrome"
    ],
    "hippogriffe": [
        "hippogriffe"
    ],
    "hippomobile": [
        "hippomobile"
    ],
    "hippophagique": [
        "hippophagique"
    ],
    "hippophagiques": [
        "hippophagique"
    ],
    "hippopotame": [
        "hippopotame"
    ],
    "hippopotames": [
        "hippopotame"
    ],
    "hippopotamesque": [
        "hippopotamesque"
    ],
    "hippy": [
        "hippy"
    ],
    "hirondelle": [
        "hirondeau"
    ],
    "hirondelles": [
        "hirondelle"
    ],
    "hirsute": [
        "hirsute"
    ],
    "hirsutes": [
        "hirsute"
    ],
    "hirsutisme": [
        "hirsutisme"
    ],
    "hirudine": [
        "hirudine"
    ],
    "hispanique": [
        "hispanique"
    ],
    "hispaniques": [
        "hispanique"
    ],
    "hispanisante": [
        "hispanisant"
    ],
    "hispanisants": [
        "hispanisant"
    ],
    "hispano": [
        "hispano"
    ],
    "hispanophone": [
        "hispanophone"
    ],
    "hissa": [
        "hisser"
    ],
    "hissai": [
        "hisser"
    ],
    "hissaient": [
        "hisser"
    ],
    "hissais": [
        "hisser"
    ],
    "hissait": [
        "hisser"
    ],
    "hissant": [
        "hisser"
    ],
    "hisse": [
        "hisser",
        "hisse"
    ],
    "hissent": [
        "hisser"
    ],
    "hisser": [
        "hisser"
    ],
    "hissera": [
        "hisser"
    ],
    "hisserai": [
        "hisser"
    ],
    "hissez": [
        "hisser"
    ],
    "hissons": [
        "hisser"
    ],
    "hissames": [
        "hisser"
    ],
    "hisserent": [
        "hisser"
    ],
    "hissee": [
        "hisser"
    ],
    "hissees": [
        "hisser"
    ],
    "hisses": [
        "hiss",
        "hisser"
    ],
    "histamine": [
        "histamine"
    ],
    "histaminique": [
        "histaminique"
    ],
    "hister": [
        "hister"
    ],
    "histocompatibilite": [
        "histocompatibilite"
    ],
    "histocompatibles": [
        "histocompatible"
    ],
    "histoire": [
        "histoire"
    ],
    "histoires": [
        "histoire"
    ],
    "histologie": [
        "histologie"
    ],
    "histologique": [
        "histologique"
    ],
    "histopathologie": [
        "histopathologie"
    ],
    "histoplasmose": [
        "histoplasmose"
    ],
    "historia": [
        "historier"
    ],
    "historicite": [
        "historicite"
    ],
    "historien": [
        "historien"
    ],
    "historienne": [
        "historien"
    ],
    "historiens": [
        "historien"
    ],
    "historiette": [
        "historiette"
    ],
    "historiettes": [
        "historiette"
    ],
    "historiographe": [
        "historiographe"
    ],
    "historiographie": [
        "historiographie"
    ],
    "historique": [
        "historique"
    ],
    "historiquement": [
        "historiquement"
    ],
    "historiques": [
        "historique"
    ],
    "historiee": [
        "historier",
        "historie"
    ],
    "histories": [
        "historier",
        "historie",
        "history"
    ],
    "histrion": [
        "histrion"
    ],
    "histrions": [
        "histrion"
    ],
    "hit": [
        "hit"
    ],
    "hitchcockien": [
        "hitchcockien"
    ],
    "hitlerien": [
        "hitlerien"
    ],
    "hitlerienne": [
        "hitlerien"
    ],
    "hitleriennes": [
        "hitlerien"
    ],
    "hitleriens": [
        "hitlerien"
    ],
    "hitlerisme": [
        "hitlerisme"
    ],
    "hits": [
        "hit"
    ],
    "hittite": [
        "hittite"
    ],
    "hittites": [
        "hittite"
    ],
    "hiv": [
        "hiv"
    ],
    "hiver": [
        "hiver"
    ],
    "hivernage": [
        "hivernage"
    ],
    "hivernaient": [
        "hiverner"
    ],
    "hivernait": [
        "hiverner"
    ],
    "hivernal": [
        "hivernal"
    ],
    "hivernale": [
        "hivernal"
    ],
    "hivernales": [
        "hivernal"
    ],
    "hivernant": [
        "hivernant"
    ],
    "hivernante": [
        "hivernant"
    ],
    "hivernantes": [
        "hivernant"
    ],
    "hivernants": [
        "hivernant"
    ],
    "hivernaux": [
        "hivernal"
    ],
    "hiverne": [
        "hiverner"
    ],
    "hiverner": [
        "hiverner"
    ],
    "hivernons": [
        "hiverner"
    ],
    "hivers": [
        "hiver"
    ],
    "hierarchie": [
        "hierarchie"
    ],
    "hierarchies": [
        "hierarchie",
        "hierarchy"
    ],
    "hierarchique": [
        "hierarchique"
    ],
    "hierarchiquement": [
        "hierarchiquement"
    ],
    "hierarchiques": [
        "hierarchique"
    ],
    "hierarchisait": [
        "hierarchiser"
    ],
    "hierarchisation": [
        "hierarchisation"
    ],
    "hierarchise": [
        "hierarchiser",
        "hierarchise"
    ],
    "hierarchisee": [
        "hierarchise"
    ],
    "hierarchises": [
        "hierarchiser",
        "hierarchise"
    ],
    "hieratique": [
        "hieratique"
    ],
    "hieratiquement": [
        "hieratiquement"
    ],
    "hieratiques": [
        "hieratique"
    ],
    "hieratisme": [
        "hieratisme"
    ],
    "hieroglyphe": [
        "hieroglyphe"
    ],
    "hieroglyphes": [
        "hieroglyphe"
    ],
    "hieroglyphique": [
        "hieroglyphique"
    ],
    "hieroglyphiques": [
        "hieroglyphique"
    ],
    "hieronymites": [
        "hieronymite"
    ],
    "hierophante": [
        "hierophante"
    ],
    "ho": [
        "ho"
    ],
    "hobbies": [
        "hobby"
    ],
    "hobby": [
        "hobby"
    ],
    "hobereau": [
        "hobereau"
    ],
    "hobereaux": [
        "hobereau"
    ],
    "hocha": [
        "hocher"
    ],
    "hochai": [
        "hocher"
    ],
    "hochaient": [
        "hocher"
    ],
    "hochais": [
        "hocher"
    ],
    "hochait": [
        "hocher"
    ],
    "hochant": [
        "hocher"
    ],
    "hoche": [
        "hocher"
    ],
    "hochement": [
        "hochement"
    ],
    "hochements": [
        "hochement"
    ],
    "hochent": [
        "hocher"
    ],
    "hochepot": [
        "hochepot"
    ],
    "hocher": [
        "hocher"
    ],
    "hocheraient": [
        "hocher"
    ],
    "hocheront": [
        "hocher"
    ],
    "hoches": [
        "hocher"
    ],
    "hochet": [
        "hochet"
    ],
    "hochets": [
        "hochet"
    ],
    "hocheurs": [
        "hocheur"
    ],
    "hochez": [
        "hocher"
    ],
    "hochions": [
        "hocher"
    ],
    "hocherent": [
        "hocher"
    ],
    "hockey": [
        "hockey"
    ],
    "hockeyeur": [
        "hockeyeur"
    ],
    "hockeyeurs": [
        "hockeyeur"
    ],
    "hodgkinien": [
        "hodgkinien"
    ],
    "hodja": [
        "hodja"
    ],
    "hoirie": [
        "hoirie"
    ],
    "hoiries": [
        "hoirie"
    ],
    "holding": [
        "holding",
        "hold"
    ],
    "holdings": [
        "holding"
    ],
    "holistique": [
        "holistique"
    ],
    "holistiques": [
        "holistique"
    ],
    "hollandais": [
        "hollandais"
    ],
    "hollandaise": [
        "hollandais",
        "hollandaise"
    ],
    "hollandaises": [
        "hollandais"
    ],
    "hollande": [
        "hollande"
    ],
    "hollywoodien": [
        "hollywoodien"
    ],
    "hollywoodienne": [
        "hollywoodien"
    ],
    "hollywoodiennes": [
        "hollywoodien"
    ],
    "hollywoodiens": [
        "hollywoodien"
    ],
    "holocauste": [
        "holocauste"
    ],
    "holocaustes": [
        "holocauste"
    ],
    "hologramme": [
        "hologramme"
    ],
    "hologrammes": [
        "hologramme"
    ],
    "holographe": [
        "holographe"
    ],
    "holographes": [
        "holographe"
    ],
    "holographie": [
        "holographie"
    ],
    "holographique": [
        "holographique"
    ],
    "holographiques": [
        "holographique"
    ],
    "holothuries": [
        "holothurie"
    ],
    "holoedres": [
        "holoedre"
    ],
    "holster": [
        "holster"
    ],
    "hola": [
        "hola"
    ],
    "hom": [
        "hom"
    ],
    "homard": [
        "homard"
    ],
    "homardiers": [
        "homardier"
    ],
    "homards": [
        "homard"
    ],
    "hombre": [
        "hombre"
    ],
    "home": [
        "home"
    ],
    "homeland": [
        "homeland"
    ],
    "homes": [
        "home"
    ],
    "homicide": [
        "homicide"
    ],
    "homicides": [
        "homicide"
    ],
    "hominien": [
        "hominien"
    ],
    "hominiens": [
        "hominien"
    ],
    "hominisation": [
        "hominisation"
    ],
    "hommage": [
        "hommage"
    ],
    "hommages": [
        "hommage"
    ],
    "hommasse": [
        "hommasse"
    ],
    "hommasses": [
        "hommasse"
    ],
    "homme": [
        "homme"
    ],
    "hommes": [
        "homme"
    ],
    "homo": [
        "homo"
    ],
    "homogene": [
        "homogene"
    ],
    "homogenes": [
        "homogene"
    ],
    "homogeneisateur": [
        "homogeneisateur"
    ],
    "homogeneisation": [
        "homogeneisation"
    ],
    "homogeneise": [
        "homogeneiser",
        "homogeneise"
    ],
    "homogeneisee": [
        "homogeneise"
    ],
    "homogeneite": [
        "homogeneite"
    ],
    "homologable": [
        "homologable"
    ],
    "homologation": [
        "homologation"
    ],
    "homologue": [
        "homologue",
        "homologuer"
    ],
    "homologuer": [
        "homologuer"
    ],
    "homologues": [
        "homologue",
        "homologuer"
    ],
    "homologuee": [
        "homologuer",
        "homologue"
    ],
    "homoncule": [
        "homoncule"
    ],
    "homonyme": [
        "homonyme"
    ],
    "homonymes": [
        "homonyme"
    ],
    "homonymie": [
        "homonymie"
    ],
    "homonymique": [
        "homonymique"
    ],
    "homophile": [
        "homophile"
    ],
    "homophilie": [
        "homophilie"
    ],
    "homophobe": [
        "homophobe"
    ],
    "homophobes": [
        "homophobe"
    ],
    "homophone": [
        "homophone"
    ],
    "homophonie": [
        "homophonie"
    ],
    "homos": [
        "homo"
    ],
    "homosexualite": [
        "homosexualite"
    ],
    "homosexuel": [
        "homosexuel"
    ],
    "homosexuelle": [
        "homosexuel",
        "homosexuelle"
    ],
    "homosexuelles": [
        "homosexuel",
        "homosexuelle"
    ],
    "homosexuels": [
        "homosexuel"
    ],
    "homozygote": [
        "homozygote"
    ],
    "homuncule": [
        "homuncule"
    ],
    "homelie": [
        "homelie"
    ],
    "homelies": [
        "homelie"
    ],
    "homeopathe": [
        "homeopathe"
    ],
    "homeopathie": [
        "homeopathie"
    ],
    "homeopathique": [
        "homeopathique"
    ],
    "homeopathiques": [
        "homeopathique"
    ],
    "homeostatique": [
        "homeostatique"
    ],
    "homeothermie": [
        "homeothermie"
    ],
    "homerique": [
        "homerique"
    ],
    "homeriques": [
        "homerique"
    ],
    "hon": [
        "hon"
    ],
    "hondurien": [
        "hondurien"
    ],
    "hongkongais": [
        "hongkongais"
    ],
    "hongre": [
        "hongre"
    ],
    "hongres": [
        "hongre"
    ],
    "hongrois": [
        "hongrois"
    ],
    "hongroise": [
        "hongrois",
        "hongroise"
    ],
    "hongroises": [
        "hongrois",
        "hongroise"
    ],
    "honneur": [
        "honneur"
    ],
    "honneurs": [
        "honneur"
    ],
    "honni": [
        "honni",
        "honnir"
    ],
    "honnie": [
        "honni",
        "honnir"
    ],
    "honnir": [
        "honnir"
    ],
    "honnis": [
        "honni",
        "honnir"
    ],
    "honnissait": [
        "honnir"
    ],
    "honnissant": [
        "honnir"
    ],
    "honnissent": [
        "honnir"
    ],
    "honnit": [
        "honnir"
    ],
    "honnete": [
        "honnete"
    ],
    "honnetement": [
        "honnetement"
    ],
    "honnetes": [
        "honnete"
    ],
    "honnetete": [
        "honnetete"
    ],
    "honora": [
        "honorer"
    ],
    "honorabilite": [
        "honorabilite"
    ],
    "honorable": [
        "honorable"
    ],
    "honorablement": [
        "honorablement"
    ],
    "honorables": [
        "honorable"
    ],
    "honorai": [
        "honorer"
    ],
    "honoraient": [
        "honorer"
    ],
    "honoraire": [
        "honoraire"
    ],
    "honoraires": [
        "honoraire"
    ],
    "honorais": [
        "honorer"
    ],
    "honorait": [
        "honorer"
    ],
    "honorant": [
        "honorer"
    ],
    "honore": [
        "honore",
        "honorer"
    ],
    "honorent": [
        "honorer"
    ],
    "honorer": [
        "honorer"
    ],
    "honorera": [
        "honorer"
    ],
    "honorerai": [
        "honorer"
    ],
    "honorerait": [
        "honorer"
    ],
    "honoreras": [
        "honorer"
    ],
    "honorerez": [
        "honorer"
    ],
    "honorerons": [
        "honorer"
    ],
    "honoreront": [
        "honorer"
    ],
    "honores": [
        "honore",
        "honorer"
    ],
    "honorez": [
        "honorer"
    ],
    "honoriez": [
        "honorer"
    ],
    "honorifique": [
        "honorifique"
    ],
    "honorifiques": [
        "honorifique"
    ],
    "honorons": [
        "honorer"
    ],
    "honorat": [
        "honorer"
    ],
    "honorerent": [
        "honorer"
    ],
    "honoree": [
        "honore",
        "honorer"
    ],
    "honorees": [
        "honorer"
    ],
    "honte": [
        "honte"
    ],
    "hontes": [
        "honte"
    ],
    "honteuse": [
        "honteux"
    ],
    "honteusement": [
        "honteusement"
    ],
    "honteuses": [
        "honteux"
    ],
    "honteux": [
        "honteux"
    ],
    "hooligan": [
        "hooligan"
    ],
    "hooligans": [
        "hooligan"
    ],
    "hop": [
        "hop"
    ],
    "hopak": [
        "hopak"
    ],
    "hopi": [
        "hopi"
    ],
    "hopis": [
        "hopi"
    ],
    "hoplite": [
        "hoplite"
    ],
    "hoquet": [
        "hoquet"
    ],
    "hoqueta": [
        "hoqueter"
    ],
    "hoquetai": [
        "hoqueter"
    ],
    "hoquetais": [
        "hoqueter"
    ],
    "hoquetait": [
        "hoqueter"
    ],
    "hoquetant": [
        "hoqueter"
    ],
    "hoqueter": [
        "hoqueter"
    ],
    "hoquetons": [
        "hoqueter"
    ],
    "hoquets": [
        "hoquet"
    ],
    "hoquette": [
        "hoqueter"
    ],
    "hoquete": [
        "hoqueter"
    ],
    "horaire": [
        "horaire"
    ],
    "horaires": [
        "horaire"
    ],
    "horde": [
        "horde"
    ],
    "hordes": [
        "horde"
    ],
    "horion": [
        "horion"
    ],
    "horions": [
        "horion"
    ],
    "horizon": [
        "horizon"
    ],
    "horizons": [
        "horizon"
    ],
    "horizontal": [
        "horizontal"
    ],
    "horizontale": [
        "horizontale",
        "horizontal"
    ],
    "horizontalement": [
        "horizontalement"
    ],
    "horizontales": [
        "horizontale",
        "horizontal"
    ],
    "horizontalite": [
        "horizontalite"
    ],
    "horizontaux": [
        "horizontal"
    ],
    "horloge": [
        "horloge"
    ],
    "horloger": [
        "horloger"
    ],
    "horlogerie": [
        "horlogerie"
    ],
    "horlogers": [
        "horloger"
    ],
    "horloges": [
        "horloge"
    ],
    "horlogere": [
        "horloger"
    ],
    "hormis": [
        "hormis"
    ],
    "hormonal": [
        "hormonal"
    ],
    "hormonale": [
        "hormonal"
    ],
    "hormonales": [
        "hormonal"
    ],
    "hormonaux": [
        "hormonal"
    ],
    "hormone": [
        "hormone"
    ],
    "hormones": [
        "hormoner",
        "hormone"
    ],
    "hornblende": [
        "hornblende"
    ],
    "horoscope": [
        "horoscope"
    ],
    "horoscopes": [
        "horoscope"
    ],
    "horreur": [
        "horreur"
    ],
    "horreurs": [
        "horreur"
    ],
    "horrible": [
        "horrible"
    ],
    "horriblement": [
        "horriblement"
    ],
    "horribles": [
        "horrible"
    ],
    "horrifia": [
        "horrifier"
    ],
    "horrifiaient": [
        "horrifier"
    ],
    "horrifiait": [
        "horrifier"
    ],
    "horrifiant": [
        "horrifier",
        "horrifiant"
    ],
    "horrifiante": [
        "horrifiant"
    ],
    "horrifiants": [
        "horrifiant"
    ],
    "horrifie": [
        "horrifie",
        "horrifier"
    ],
    "horrifier": [
        "horrifier"
    ],
    "horrifique": [
        "horrifique"
    ],
    "horrifierent": [
        "horrifier"
    ],
    "horrifiee": [
        "horrifie",
        "horrifier"
    ],
    "horrifiees": [
        "horrifie",
        "horrifier"
    ],
    "horrifies": [
        "horrifie",
        "horrifier",
        "horrify"
    ],
    "horripilaient": [
        "horripiler"
    ],
    "horripilais": [
        "horripiler"
    ],
    "horripilait": [
        "horripiler"
    ],
    "horripilant": [
        "horripilant",
        "horripiler"
    ],
    "horripilante": [
        "horripilant"
    ],
    "horripilantes": [
        "horripilant"
    ],
    "horripilants": [
        "horripilant"
    ],
    "horripilation": [
        "horripilation"
    ],
    "horripilations": [
        "horripilation"
    ],
    "horripile": [
        "horripiler"
    ],
    "horripilent": [
        "horripiler"
    ],
    "horripiler": [
        "horripiler"
    ],
    "horripilee": [
        "horripiler"
    ],
    "horripiles": [
        "horripiler"
    ],
    "hors": [
        "hors"
    ],
    "hortensia": [
        "hortensia"
    ],
    "hortensias": [
        "hortensia"
    ],
    "horticoles": [
        "horticole"
    ],
    "horticulteur": [
        "horticulteur"
    ],
    "horticulteurs": [
        "horticulteur"
    ],
    "horticultrice": [
        "horticultrice"
    ],
    "horticulture": [
        "horticulture"
    ],
    "hortillonnage": [
        "hortillonnage"
    ],
    "hosanna": [
        "hosanna"
    ],
    "hosannah": [
        "hosannah"
    ],
    "hosannas": [
        "hosanna"
    ],
    "hospice": [
        "hospice"
    ],
    "hospices": [
        "hospice"
    ],
    "hospitalier": [
        "hospitalier"
    ],
    "hospitaliers": [
        "hospitalier"
    ],
    "hospitalisation": [
        "hospitalisation"
    ],
    "hospitalisations": [
        "hospitalisation"
    ],
    "hospitaliser": [
        "hospitaliser"
    ],
    "hospitaliserons": [
        "hospitaliser"
    ],
    "hospitalise": [
        "hospitaliser"
    ],
    "hospitalisee": [
        "hospitaliser"
    ],
    "hospitalisees": [
        "hospitaliser"
    ],
    "hospitalises": [
        "hospitaliser"
    ],
    "hospitalite": [
        "hospitalite"
    ],
    "hospitaliere": [
        "hospitalier"
    ],
    "hospitalieres": [
        "hospitalier"
    ],
    "hospodar": [
        "hospodar"
    ],
    "hospodars": [
        "hospodar"
    ],
    "hostau": [
        "hostau"
    ],
    "hostellerie": [
        "hostellerie"
    ],
    "hostelleries": [
        "hostellerie"
    ],
    "hostie": [
        "hostie"
    ],
    "hosties": [
        "hostie"
    ],
    "hostile": [
        "hostile"
    ],
    "hostilement": [
        "hostilement"
    ],
    "hostiles": [
        "hostile"
    ],
    "hostilite": [
        "hostilite"
    ],
    "hostilites": [
        "hostilite"
    ],
    "hosto": [
        "hosto"
    ],
    "hostos": [
        "hosto"
    ],
    "hot": [
        "hot"
    ],
    "hotline": [
        "hotline"
    ],
    "hotte": [
        "hotte"
    ],
    "hotter": [
        "hot",
        "hotter"
    ],
    "hottes": [
        "hotte"
    ],
    "hottee": [
        "hottee"
    ],
    "hotu": [
        "hotu"
    ],
    "hotus": [
        "hotu"
    ],
    "hou": [
        "hou"
    ],
    "houa": [
        "houer"
    ],
    "houari": [
        "houari"
    ],
    "houblon": [
        "houblon"
    ],
    "houblonnes": [
        "houblonner"
    ],
    "houblons": [
        "houblon"
    ],
    "houe": [
        "houe"
    ],
    "houhou": [
        "houhou"
    ],
    "houille": [
        "houille"
    ],
    "houiller": [
        "houiller"
    ],
    "houilles": [
        "houille"
    ],
    "houillere": [
        "houillere"
    ],
    "houilleres": [
        "houillere"
    ],
    "houle": [
        "houle"
    ],
    "houler": [
        "houler"
    ],
    "houles": [
        "houle"
    ],
    "houlette": [
        "houlette"
    ],
    "houleuse": [
        "houleux"
    ],
    "houleuses": [
        "houleux"
    ],
    "houleux": [
        "houleux"
    ],
    "houligan": [
        "houligan"
    ],
    "houliganisme": [
        "houliganisme"
    ],
    "houlque": [
        "houlque"
    ],
    "houla": [
        "houla"
    ],
    "houp": [
        "houp"
    ],
    "houppe": [
        "houppe"
    ],
    "houppelande": [
        "houppelande"
    ],
    "houppelandes": [
        "houppelande"
    ],
    "houppes": [
        "houppe"
    ],
    "houppette": [
        "houppette"
    ],
    "houppettes": [
        "houppette"
    ],
    "hourdis": [
        "hourdis"
    ],
    "hourds": [
        "hourd"
    ],
    "houri": [
        "houri"
    ],
    "houris": [
        "houri"
    ],
    "hourra": [
        "hourra"
    ],
    "hourrah": [
        "hourrah"
    ],
    "hourrahs": [
        "hourrah"
    ],
    "hourras": [
        "hourra"
    ],
    "hourvari": [
        "hourvari"
    ],
    "hourvaris": [
        "hourvari"
    ],
    "housards": [
        "housard"
    ],
    "house": [
        "house"
    ],
    "houseau": [
        "houseau"
    ],
    "houseaux": [
        "houseau"
    ],
    "houspilla": [
        "houspiller"
    ],
    "houspillaient": [
        "houspiller"
    ],
    "houspillait": [
        "houspiller"
    ],
    "houspillant": [
        "houspiller"
    ],
    "houspille": [
        "houspiller"
    ],
    "houspillent": [
        "houspiller"
    ],
    "houspiller": [
        "houspiller"
    ],
    "houspillames": [
        "houspiller"
    ],
    "houspillerent": [
        "houspiller"
    ],
    "houspillee": [
        "houspiller"
    ],
    "houspillees": [
        "houspiller"
    ],
    "houspilles": [
        "houspiller"
    ],
    "housse": [
        "housse"
    ],
    "housses": [
        "housser",
        "housse"
    ],
    "houx": [
        "houx"
    ],
    "hovercraft": [
        "hovercraft"
    ],
    "hoyau": [
        "hoyau"
    ],
    "hua": [
        "huer"
    ],
    "huaient": [
        "huer"
    ],
    "huait": [
        "huer"
    ],
    "huant": [
        "huer"
    ],
    "huard": [
        "huard"
    ],
    "huards": [
        "huard"
    ],
    "huart": [
        "huart"
    ],
    "hublot": [
        "hublot"
    ],
    "hublots": [
        "hublot"
    ],
    "huche": [
        "huche"
    ],
    "huches": [
        "huche"
    ],
    "huchet": [
        "huchet"
    ],
    "hue": [
        "hue",
        "huer"
    ],
    "huer": [
        "huer"
    ],
    "huerta": [
        "huerta"
    ],
    "huez": [
        "huer"
    ],
    "hugh": [
        "hugh"
    ],
    "hugolien": [
        "hugolien"
    ],
    "hugoliens": [
        "hugolien"
    ],
    "huguenot": [
        "huguenot"
    ],
    "huguenote": [
        "huguenot"
    ],
    "huguenots": [
        "huguenot"
    ],
    "hui": [
        "hui"
    ],
    "huilai": [
        "huiler"
    ],
    "huilait": [
        "huiler"
    ],
    "huile": [
        "huiler",
        "huile"
    ],
    "huilent": [
        "huiler"
    ],
    "huiler": [
        "huiler"
    ],
    "huilerai": [
        "huiler"
    ],
    "huiles": [
        "huiler",
        "huile"
    ],
    "huileuse": [
        "huileux"
    ],
    "huileuses": [
        "huileux"
    ],
    "huileux": [
        "huileux"
    ],
    "huilez": [
        "huiler"
    ],
    "huilier": [
        "huilier"
    ],
    "huiliers": [
        "huilier"
    ],
    "huilee": [
        "huiler",
        "huile"
    ],
    "huilees": [
        "huiler",
        "huile"
    ],
    "huipil": [
        "huipil"
    ],
    "huipils": [
        "huipil"
    ],
    "huis": [
        "huis"
    ],
    "huisserie": [
        "huisserie"
    ],
    "huisseries": [
        "huisserie"
    ],
    "huissier": [
        "huissier"
    ],
    "huissiers": [
        "huissier"
    ],
    "huit": [
        "huit"
    ],
    "huitaine": [
        "huitaine"
    ],
    "huitieme": [
        "huitieme"
    ],
    "huitiemes": [
        "huitieme"
    ],
    "hulotte": [
        "hulotte"
    ],
    "hulottes": [
        "hulotte"
    ],
    "hulula": [
        "hululer"
    ],
    "hululaient": [
        "hululer"
    ],
    "hululait": [
        "hululer"
    ],
    "hululant": [
        "hululer"
    ],
    "hulule": [
        "hululer"
    ],
    "hululement": [
        "hululement"
    ],
    "hululements": [
        "hululement"
    ],
    "hululent": [
        "hululer"
    ],
    "hululer": [
        "hululer"
    ],
    "hululee": [
        "hululer"
    ],
    "hum": [
        "hum"
    ],
    "huma": [
        "humer"
    ],
    "humai": [
        "humer"
    ],
    "humaient": [
        "humer"
    ],
    "humain": [
        "humain"
    ],
    "humaine": [
        "humain"
    ],
    "humainement": [
        "humainement"
    ],
    "humaines": [
        "humain"
    ],
    "humains": [
        "humain"
    ],
    "humais": [
        "humer"
    ],
    "humait": [
        "humer"
    ],
    "humanisait": [
        "humaniser"
    ],
    "humanisant": [
        "humaniser"
    ],
    "humanisation": [
        "humanisation"
    ],
    "humanise": [
        "humaniser"
    ],
    "humanisent": [
        "humaniser"
    ],
    "humaniser": [
        "humaniser"
    ],
    "humanisme": [
        "humanisme"
    ],
    "humaniste": [
        "humaniste"
    ],
    "humanistes": [
        "humaniste"
    ],
    "humanisee": [
        "humaniser"
    ],
    "humanisees": [
        "humaniser"
    ],
    "humanises": [
        "humaniser"
    ],
    "humanitaire": [
        "humanitaire"
    ],
    "humanitaires": [
        "humanitaire"
    ],
    "humanitarisme": [
        "humanitarisme"
    ],
    "humanite": [
        "humanite"
    ],
    "humanites": [
        "humanite"
    ],
    "humano": [
        "humano"
    ],
    "humanoide": [
        "humanoide"
    ],
    "humanoides": [
        "humanoide"
    ],
    "humant": [
        "humer"
    ],
    "humble": [
        "humble"
    ],
    "humblement": [
        "humblement"
    ],
    "humbles": [
        "humble"
    ],
    "humbug": [
        "humbug"
    ],
    "hume": [
        "humer"
    ],
    "humecta": [
        "humecter"
    ],
    "humectage": [
        "humectage"
    ],
    "humectai": [
        "humecter"
    ],
    "humectaient": [
        "humecter"
    ],
    "humectais": [
        "humecter"
    ],
    "humectait": [
        "humecter"
    ],
    "humectant": [
        "humectant",
        "humecter"
    ],
    "humecte": [
        "humecter"
    ],
    "humectent": [
        "humecter"
    ],
    "humecter": [
        "humecter"
    ],
    "humectee": [
        "humecter"
    ],
    "humectees": [
        "humecter"
    ],
    "humectes": [
        "humecter"
    ],
    "hument": [
        "humer"
    ],
    "humer": [
        "humer"
    ],
    "humeras": [
        "humer"
    ],
    "humeur": [
        "humeur"
    ],
    "humeurs": [
        "humeur"
    ],
    "humez": [
        "humer"
    ],
    "humide": [
        "humide"
    ],
    "humidement": [
        "humidement"
    ],
    "humides": [
        "humide"
    ],
    "humidifia": [
        "humidifier"
    ],
    "humidifiant": [
        "humidifier"
    ],
    "humidificateur": [
        "humidificateur"
    ],
    "humidification": [
        "humidification"
    ],
    "humidifient": [
        "humidifier"
    ],
    "humidifier": [
        "humidifier"
    ],
    "humidifie": [
        "humidifier"
    ],
    "humidifies": [
        "humidifier"
    ],
    "humidite": [
        "humidite"
    ],
    "humilia": [
        "humilier"
    ],
    "humiliaient": [
        "humilier"
    ],
    "humiliais": [
        "humilier"
    ],
    "humiliait": [
        "humilier"
    ],
    "humiliant": [
        "humiliant",
        "humilier"
    ],
    "humiliante": [
        "humiliant"
    ],
    "humiliantes": [
        "humiliant"
    ],
    "humiliants": [
        "humiliant"
    ],
    "humiliassent": [
        "humilier"
    ],
    "humiliation": [
        "humiliation"
    ],
    "humiliations": [
        "humiliation"
    ],
    "humilie": [
        "humilie",
        "humilier"
    ],
    "humilient": [
        "humilier"
    ],
    "humilier": [
        "humilier"
    ],
    "humiliera": [
        "humilier"
    ],
    "humilierai": [
        "humilier"
    ],
    "humilieraient": [
        "humilier"
    ],
    "humilierais": [
        "humilier"
    ],
    "humilierait": [
        "humilier"
    ],
    "humilies": [
        "humilie",
        "humilier"
    ],
    "humiliez": [
        "humilier"
    ],
    "humilite": [
        "humilite"
    ],
    "humilites": [
        "humilite"
    ],
    "humiliee": [
        "humilie",
        "humilier"
    ],
    "humiliees": [
        "humilie",
        "humilier"
    ],
    "humions": [
        "humer"
    ],
    "humons": [
        "humer"
    ],
    "humoral": [
        "humoral"
    ],
    "humoriste": [
        "humoriste"
    ],
    "humoristes": [
        "humoriste"
    ],
    "humoristique": [
        "humoristique"
    ],
    "humoristiques": [
        "humoristique"
    ],
    "humour": [
        "humour"
    ],
    "humus": [
        "humus"
    ],
    "humerent": [
        "humer"
    ],
    "humee": [
        "humer"
    ],
    "humerale": [
        "humeral"
    ],
    "humerus": [
        "humerus"
    ],
    "humes": [
        "hume",
        "humer"
    ],
    "hun": [
        "hun"
    ],
    "hune": [
        "hune"
    ],
    "hunes": [
        "hune"
    ],
    "hunier": [
        "hunier"
    ],
    "huniers": [
        "hunier"
    ],
    "huns": [
        "hun"
    ],
    "hunter": [
        "hunter"
    ],
    "huppe": [
        "huppe"
    ],
    "huppee": [
        "huppe"
    ],
    "huppees": [
        "huppe"
    ],
    "huppes": [
        "huppe"
    ],
    "hure": [
        "hure"
    ],
    "hures": [
        "hure"
    ],
    "hurla": [
        "hurler"
    ],
    "hurlai": [
        "hurler"
    ],
    "hurlaient": [
        "hurler"
    ],
    "hurlais": [
        "hurler"
    ],
    "hurlait": [
        "hurler"
    ],
    "hurlant": [
        "hurler",
        "hurlant"
    ],
    "hurlante": [
        "hurlant"
    ],
    "hurlantes": [
        "hurlant"
    ],
    "hurlants": [
        "hurlant"
    ],
    "hurle": [
        "hurler"
    ],
    "hurlement": [
        "hurlement"
    ],
    "hurlements": [
        "hurlement"
    ],
    "hurlent": [
        "hurler"
    ],
    "hurler": [
        "hurler"
    ],
    "hurlera": [
        "hurler"
    ],
    "hurlerai": [
        "hurler"
    ],
    "hurleraient": [
        "hurler"
    ],
    "hurlerais": [
        "hurler"
    ],
    "hurlerait": [
        "hurler"
    ],
    "hurlerez": [
        "hurler"
    ],
    "hurleront": [
        "hurler"
    ],
    "hurles": [
        "hurler"
    ],
    "hurleur": [
        "hurleur"
    ],
    "hurleurs": [
        "hurleur"
    ],
    "hurlez": [
        "hurler"
    ],
    "hurlions": [
        "hurler"
    ],
    "hurluberlu": [
        "hurluberlu"
    ],
    "hurluberlus": [
        "hurluberlu"
    ],
    "hurlat": [
        "hurler"
    ],
    "hurlerent": [
        "hurler"
    ],
    "hurlee": [
        "hurler"
    ],
    "hurlees": [
        "hurler"
    ],
    "huron": [
        "huron"
    ],
    "huronne": [
        "huron"
    ],
    "hurrah": [
        "hurrah"
    ],
    "hurrahs": [
        "hurrah"
    ],
    "hurricane": [
        "hurricane"
    ],
    "hurricanes": [
        "hurricane"
    ],
    "huskies": [
        "huskies",
        "husky"
    ],
    "husky": [
        "husky"
    ],
    "hussard": [
        "hussard"
    ],
    "hussarde": [
        "hussard"
    ],
    "hussards": [
        "hussard"
    ],
    "husseinites": [
        "husseinite"
    ],
    "hussite": [
        "hussite"
    ],
    "hussites": [
        "hussite"
    ],
    "hutte": [
        "hutte"
    ],
    "hutter": [
        "hutter"
    ],
    "huttes": [
        "hutte"
    ],
    "huerent": [
        "huer"
    ],
    "huee": [
        "huee",
        "huer"
    ],
    "huees": [
        "huee",
        "huer"
    ],
    "hues": [
        "hue",
        "huer"
    ],
    "huitre": [
        "huitre"
    ],
    "huitres": [
        "huitre"
    ],
    "huitrier": [
        "huitrier"
    ],
    "huitriers": [
        "huitrier"
    ],
    "huitriere": [
        "huitriere"
    ],
    "hyacinthe": [
        "hyacinthe"
    ],
    "hyades": [
        "hyade"
    ],
    "hybridation": [
        "hybridation"
    ],
    "hybride": [
        "hybride",
        "hybrider"
    ],
    "hybrides": [
        "hybride"
    ],
    "hydatique": [
        "hydatique"
    ],
    "hydne": [
        "hydne"
    ],
    "hydratant": [
        "hydratant",
        "hydrater"
    ],
    "hydratante": [
        "hydratant"
    ],
    "hydratantes": [
        "hydratant"
    ],
    "hydratants": [
        "hydratant"
    ],
    "hydratation": [
        "hydratation"
    ],
    "hydrate": [
        "hydrate",
        "hydrater"
    ],
    "hydrater": [
        "hydrater"
    ],
    "hydrates": [
        "hydrate"
    ],
    "hydratez": [
        "hydrater"
    ],
    "hydratee": [
        "hydrater"
    ],
    "hydraulicien": [
        "hydraulicien"
    ],
    "hydraulique": [
        "hydraulique"
    ],
    "hydrauliques": [
        "hydraulique"
    ],
    "hydravion": [
        "hydravion"
    ],
    "hydravions": [
        "hydravion"
    ],
    "hydre": [
        "hydre"
    ],
    "hydrique": [
        "hydrique"
    ],
    "hydro": [
        "hydro"
    ],
    "hydrocarbure": [
        "hydrocarbure"
    ],
    "hydrocarbures": [
        "hydrocarbure"
    ],
    "hydrochlorique": [
        "hydrochlorique"
    ],
    "hydrocortisone": [
        "hydrocortisone"
    ],
    "hydrocution": [
        "hydrocution"
    ],
    "hydrocele": [
        "hydrocele"
    ],
    "hydrocephale": [
        "hydrocephale"
    ],
    "hydrocephales": [
        "hydrocephale"
    ],
    "hydrocephalie": [
        "hydrocephalie"
    ],
    "hydrodynamique": [
        "hydrodynamique"
    ],
    "hydrofoil": [
        "hydrofoil"
    ],
    "hydroglisseur": [
        "hydroglisseur"
    ],
    "hydrographe": [
        "hydrographe"
    ],
    "hydrographie": [
        "hydrographie"
    ],
    "hydrographique": [
        "hydrographique"
    ],
    "hydrographiques": [
        "hydrographique"
    ],
    "hydrogene": [
        "hydrogene"
    ],
    "hydrogenes": [
        "hydrogene"
    ],
    "hydrogenisation": [
        "hydrogenisation"
    ],
    "hydrogenee": [
        "hydrogene"
    ],
    "hydrolase": [
        "hydrolase"
    ],
    "hydrologie": [
        "hydrologie"
    ],
    "hydrolyse": [
        "hydrolyse"
    ],
    "hydromel": [
        "hydromel"
    ],
    "hydrometres": [
        "hydrometre"
    ],
    "hydrophile": [
        "hydrophile"
    ],
    "hydrophiles": [
        "hydrophile"
    ],
    "hydrophobe": [
        "hydrophobe"
    ],
    "hydrophobie": [
        "hydrophobie"
    ],
    "hydrophone": [
        "hydrophone"
    ],
    "hydrophyte": [
        "hydrophyte"
    ],
    "hydropique": [
        "hydropique"
    ],
    "hydropisie": [
        "hydropisie"
    ],
    "hydropneumatique": [
        "hydropneumatique"
    ],
    "hydroponique": [
        "hydroponique"
    ],
    "hydroponiques": [
        "hydroponique"
    ],
    "hydroptere": [
        "hydroptere"
    ],
    "hydroquinone": [
        "hydroquinone"
    ],
    "hydrostatique": [
        "hydrostatique"
    ],
    "hydrotherapie": [
        "hydrotherapie"
    ],
    "hydrox": [
        "hydrox"
    ],
    "hydroxyde": [
        "hydroxyde"
    ],
    "hydroelectrique": [
        "hydroelectrique"
    ],
    "hygiaphone": [
        "hygiaphone"
    ],
    "hygiene": [
        "hygiene"
    ],
    "hygienes": [
        "hygiene"
    ],
    "hygienique": [
        "hygienique"
    ],
    "hygieniquement": [
        "hygieniquement"
    ],
    "hygieniques": [
        "hygienique"
    ],
    "hygieniste": [
        "hygieniste"
    ],
    "hygienistes": [
        "hygieniste"
    ],
    "hygroma": [
        "hygroma"
    ],
    "hygrometre": [
        "hygrometre"
    ],
    "hygrometres": [
        "hygrometre"
    ],
    "hygrometrie": [
        "hygrometrie"
    ],
    "hygrometrique": [
        "hygrometrique"
    ],
    "hygrometriques": [
        "hygrometrique"
    ],
    "hylemorphique": [
        "hylemorphique"
    ],
    "hymen": [
        "hymen"
    ],
    "hymne": [
        "hymne"
    ],
    "hymnes": [
        "hymne"
    ],
    "hymenoptere": [
        "hymenoptere"
    ],
    "hymenopteres": [
        "hymenoptere"
    ],
    "hymenee": [
        "hymenee"
    ],
    "hymenees": [
        "hymenee"
    ],
    "hyoide": [
        "hyoide"
    ],
    "hypallage": [
        "hypallage"
    ],
    "hyper": [
        "hyper"
    ],
    "hyperacidite": [
        "hyperacidite"
    ],
    "hyperactif": [
        "hyperactif"
    ],
    "hyperactive": [
        "hyperactif"
    ],
    "hyperactivite": [
        "hyperactivite"
    ],
    "hyperbare": [
        "hyperbare"
    ],
    "hyperbole": [
        "hyperbole"
    ],
    "hyperboles": [
        "hyperbole"
    ],
    "hyperbolique": [
        "hyperbolique"
    ],
    "hyperboliquement": [
        "hyperboliquement"
    ],
    "hyperboree": [
        "hyperboree"
    ],
    "hyperboreen": [
        "hyperboreen"
    ],
    "hyperboreenne": [
        "hyperboreen"
    ],
    "hyperboreens": [
        "hyperboreen"
    ],
    "hypercalcemie": [
        "hypercalcemie"
    ],
    "hypercholesterolemie": [
        "hypercholesterolemie"
    ],
    "hypercoagulabilite": [
        "hypercoagulabilite"
    ],
    "hyperespace": [
        "hyperespace"
    ],
    "hyperesthesie": [
        "hyperesthesie"
    ],
    "hyperglycemies": [
        "hyperglycemie"
    ],
    "hyperkaliemie": [
        "hyperkaliemie"
    ],
    "hyperlipidemie": [
        "hyperlipidemie"
    ],
    "hyperlipemie": [
        "hyperlipemie"
    ],
    "hypermarche": [
        "hypermarche"
    ],
    "hypermarches": [
        "hypermarche"
    ],
    "hypermnesie": [
        "hypermnesie"
    ],
    "hypernerveuse": [
        "hypernerveux"
    ],
    "hypernerveux": [
        "hypernerveux"
    ],
    "hyperplan": [
        "hyperplan"
    ],
    "hyperplasie": [
        "hyperplasie"
    ],
    "hyperreactivite": [
        "hyperreactivite"
    ],
    "hyperrealisme": [
        "hyperrealisme"
    ],
    "hyperrealiste": [
        "hyperrealiste"
    ],
    "hyperrealistes": [
        "hyperrealiste"
    ],
    "hypersensibilite": [
        "hypersensibilite"
    ],
    "hypersensible": [
        "hypersensible"
    ],
    "hypersensibles": [
        "hypersensible"
    ],
    "hypersomnie": [
        "hypersomnie"
    ],
    "hypersonique": [
        "hypersonique"
    ],
    "hypersustentateur": [
        "hypersustentateur"
    ],
    "hypertendu": [
        "hypertendu"
    ],
    "hypertendue": [
        "hypertendu"
    ],
    "hypertendus": [
        "hypertendu"
    ],
    "hypertension": [
        "hypertension"
    ],
    "hypertensions": [
        "hypertension"
    ],
    "hyperthermie": [
        "hyperthermie"
    ],
    "hyperthyroidien": [
        "hyperthyroidien"
    ],
    "hypertonique": [
        "hypertonique"
    ],
    "hypertrichose": [
        "hypertrichose"
    ],
    "hypertrophie": [
        "hypertrophier",
        "hypertrophie"
    ],
    "hypertrophique": [
        "hypertrophique"
    ],
    "hypertrophiee": [
        "hypertrophier",
        "hypertrophie"
    ],
    "hypertrophies": [
        "hypertrophier",
        "hypertrophie"
    ],
    "hyperventilation": [
        "hyperventilation"
    ],
    "hyperemotive": [
        "hyperemotif"
    ],
    "hyperemotivite": [
        "hyperemotivite"
    ],
    "hypholomes": [
        "hypholome"
    ],
    "hypnagogique": [
        "hypnagogique"
    ],
    "hypnagogiques": [
        "hypnagogique"
    ],
    "hypnogene": [
        "hypnogene"
    ],
    "hypnogenes": [
        "hypnogene"
    ],
    "hypnose": [
        "hypnose"
    ],
    "hypnoses": [
        "hypnose",
        "hypnosis"
    ],
    "hypnotique": [
        "hypnotique"
    ],
    "hypnotiquement": [
        "hypnotiquement"
    ],
    "hypnotiques": [
        "hypnotique"
    ],
    "hypnotisa": [
        "hypnotiser"
    ],
    "hypnotisaient": [
        "hypnotiser"
    ],
    "hypnotisais": [
        "hypnotiser"
    ],
    "hypnotisait": [
        "hypnotiser"
    ],
    "hypnotisant": [
        "hypnotiser"
    ],
    "hypnotise": [
        "hypnotiser"
    ],
    "hypnotisent": [
        "hypnotiser"
    ],
    "hypnotiser": [
        "hypnotiser"
    ],
    "hypnotiseur": [
        "hypnotiseur"
    ],
    "hypnotiseurs": [
        "hypnotiseur"
    ],
    "hypnotiseuse": [
        "hypnotiseur"
    ],
    "hypnotisme": [
        "hypnotisme"
    ],
    "hypnotisee": [
        "hypnotiser"
    ],
    "hypnotisees": [
        "hypnotiser"
    ],
    "hypnotises": [
        "hypnotiser"
    ],
    "hypo": [
        "hypo"
    ],
    "hypoallergenique": [
        "hypoallergenique"
    ],
    "hypoallergeniques": [
        "hypoallergenique"
    ],
    "hypocalcemie": [
        "hypocalcemie"
    ],
    "hypocapnie": [
        "hypocapnie"
    ],
    "hypocauste": [
        "hypocauste"
    ],
    "hypocaustes": [
        "hypocauste"
    ],
    "hypocentre": [
        "hypocentre"
    ],
    "hypochlorite": [
        "hypochlorite"
    ],
    "hypochondriaque": [
        "hypochondriaque"
    ],
    "hypochondriaques": [
        "hypochondriaque"
    ],
    "hypocondre": [
        "hypocondre"
    ],
    "hypocondriaque": [
        "hypocondriaque"
    ],
    "hypocondriaques": [
        "hypocondriaque"
    ],
    "hypocondrie": [
        "hypocondrie"
    ],
    "hypocras": [
        "hypocras"
    ],
    "hypocrisie": [
        "hypocrisie"
    ],
    "hypocrisies": [
        "hypocrisy",
        "hypocrisie"
    ],
    "hypocrite": [
        "hypocrite"
    ],
    "hypocritement": [
        "hypocritement"
    ],
    "hypocrites": [
        "hypocrite"
    ],
    "hypoderme": [
        "hypoderme"
    ],
    "hypodermique": [
        "hypodermique"
    ],
    "hypodermiques": [
        "hypodermique"
    ],
    "hypoglycemie": [
        "hypoglycemie"
    ],
    "hypoglycemique": [
        "hypoglycemique"
    ],
    "hypoglycemiques": [
        "hypoglycemique"
    ],
    "hypogonadisme": [
        "hypogonadisme"
    ],
    "hypogee": [
        "hypogee"
    ],
    "hypogees": [
        "hypogee"
    ],
    "hypokhagne": [
        "hypokhagne"
    ],
    "hypokhagnes": [
        "hypokhagne"
    ],
    "hypomaniaques": [
        "hypomaniaque"
    ],
    "hyponatremie": [
        "hyponatremie"
    ],
    "hyponomeutes": [
        "hyponomeute"
    ],
    "hypophysaire": [
        "hypophysaire"
    ],
    "hypophyse": [
        "hypophyse"
    ],
    "hypophyses": [
        "hypophyse"
    ],
    "hypoplasie": [
        "hypoplasie"
    ],
    "hypospadias": [
        "hypospadias"
    ],
    "hypostase": [
        "hypostase"
    ],
    "hypostases": [
        "hypostase"
    ],
    "hyposulfite": [
        "hyposulfite"
    ],
    "hypotaupe": [
        "hypotaupe"
    ],
    "hypotendu": [
        "hypotendu"
    ],
    "hypotendue": [
        "hypotendu"
    ],
    "hypotensif": [
        "hypotensif"
    ],
    "hypotension": [
        "hypotension"
    ],
    "hypotensive": [
        "hypotensif"
    ],
    "hypothalamus": [
        "hypothalamus"
    ],
    "hypothermie": [
        "hypothermie"
    ],
    "hypothermique": [
        "hypothermique"
    ],
    "hypothyroidie": [
        "hypothyroidie"
    ],
    "hypotheque": [
        "hypothequer",
        "hypotheque"
    ],
    "hypothequent": [
        "hypothequer"
    ],
    "hypotheques": [
        "hypothequer",
        "hypotheque"
    ],
    "hypothese": [
        "hypothese"
    ],
    "hypotheses": [
        "hypothesis",
        "hypothese"
    ],
    "hypothecaire": [
        "hypothecaire"
    ],
    "hypothecaires": [
        "hypothecaire"
    ],
    "hypothequait": [
        "hypothequer"
    ],
    "hypothequant": [
        "hypothequer"
    ],
    "hypothequer": [
        "hypothequer"
    ],
    "hypothequeraient": [
        "hypothequer"
    ],
    "hypothequez": [
        "hypothequer"
    ],
    "hypothequions": [
        "hypothequer"
    ],
    "hypothequee": [
        "hypothequer"
    ],
    "hypothetique": [
        "hypothetique"
    ],
    "hypothetiquement": [
        "hypothetiquement"
    ],
    "hypothetiques": [
        "hypothetique"
    ],
    "hypotonie": [
        "hypotonie"
    ],
    "hypotenuse": [
        "hypotenuse"
    ],
    "hypoxie": [
        "hypoxie"
    ],
    "hypoxique": [
        "hypoxique"
    ],
    "hysope": [
        "hysope"
    ],
    "hysopes": [
        "hysope"
    ],
    "hysterectomie": [
        "hysterectomie"
    ],
    "hysterie": [
        "hysterie"
    ],
    "hysteries": [
        "hysterie"
    ],
    "hysterique": [
        "hysterique"
    ],
    "hysteriquement": [
        "hysteriquement"
    ],
    "hysteriques": [
        "hysterique"
    ],
    "hystero": [
        "hystero"
    ],
    "hyene": [
        "hyene"
    ],
    "hyenes": [
        "hyene"
    ],
    "hablerie": [
        "hablerie"
    ],
    "hableries": [
        "hablerie"
    ],
    "hableur": [
        "hableur"
    ],
    "hableurs": [
        "hableur"
    ],
    "halees": [
        "hale",
        "haler"
    ],
    "hata": [
        "hater"
    ],
    "hatai": [
        "hater"
    ],
    "hataient": [
        "hater"
    ],
    "hatais": [
        "hater"
    ],
    "hatait": [
        "hater"
    ],
    "hatant": [
        "hater"
    ],
    "hate": [
        "hate",
        "hater"
    ],
    "hatent": [
        "hater"
    ],
    "hater": [
        "hater"
    ],
    "hatera": [
        "hater"
    ],
    "hateraient": [
        "hater"
    ],
    "haterait": [
        "hater"
    ],
    "hates": [
        "hate",
        "hater"
    ],
    "hatez": [
        "hater"
    ],
    "hatif": [
        "hatif"
    ],
    "hatifs": [
        "hatif"
    ],
    "hations": [
        "hater"
    ],
    "hative": [
        "hatif"
    ],
    "hativement": [
        "hativement"
    ],
    "hatives": [
        "hatif"
    ],
    "hatons": [
        "hater"
    ],
    "hatames": [
        "hater"
    ],
    "hatat": [
        "hater"
    ],
    "haterent": [
        "hater"
    ],
    "hatee": [
        "hater"
    ],
    "hele": [
        "heler"
    ],
    "here": [
        "here"
    ],
    "heres": [
        "here"
    ],
    "he": [
        "he"
    ],
    "heberge": [
        "heberge",
        "heberger"
    ],
    "hebergea": [
        "heberger"
    ],
    "hebergeai": [
        "heberger"
    ],
    "hebergeaient": [
        "heberger"
    ],
    "hebergeais": [
        "heberger"
    ],
    "hebergeait": [
        "heberger"
    ],
    "hebergeant": [
        "heberger"
    ],
    "hebergement": [
        "hebergement"
    ],
    "hebergent": [
        "heberger"
    ],
    "hebergeons": [
        "heberger"
    ],
    "heberger": [
        "heberger"
    ],
    "hebergera": [
        "heberger"
    ],
    "hebergerait": [
        "heberger"
    ],
    "hebergeras": [
        "heberger"
    ],
    "hebergez": [
        "heberger"
    ],
    "hebergiez": [
        "heberger"
    ],
    "hebergions": [
        "heberger"
    ],
    "hebergee": [
        "heberger"
    ],
    "hebergees": [
        "heberger"
    ],
    "heberges": [
        "heberger"
    ],
    "hebertisme": [
        "hebertisme"
    ],
    "hebraique": [
        "hebraique"
    ],
    "hebraiquement": [
        "hebraiquement"
    ],
    "hebraiques": [
        "hebraique"
    ],
    "hebraisant": [
        "hebraisant"
    ],
    "hebreu": [
        "hebreu"
    ],
    "hebreux": [
        "hebreux",
        "hebreu"
    ],
    "hebetent": [
        "hebeter"
    ],
    "hebephrenique": [
        "hebephrenique"
    ],
    "hebeta": [
        "hebeter"
    ],
    "hebetait": [
        "hebeter"
    ],
    "hebetement": [
        "hebetement"
    ],
    "hebetude": [
        "hebetude"
    ],
    "hebete": [
        "hebete",
        "hebeter"
    ],
    "hebetee": [
        "hebete",
        "hebeter"
    ],
    "hebetees": [
        "hebete",
        "hebeter"
    ],
    "hebetes": [
        "hebete",
        "hebeter"
    ],
    "hecatombe": [
        "hecatombe"
    ],
    "hecatombes": [
        "hecatombe"
    ],
    "hedonisme": [
        "hedonisme"
    ],
    "hedoniste": [
        "hedoniste"
    ],
    "hedonistes": [
        "hedoniste"
    ],
    "hegire": [
        "hegire"
    ],
    "hegelianisme": [
        "hegelianisme"
    ],
    "hegelien": [
        "hegelien"
    ],
    "hegelienne": [
        "hegelien"
    ],
    "hegeliens": [
        "hegelien"
    ],
    "hegemonie": [
        "hegemonie"
    ],
    "hela": [
        "heler"
    ],
    "helai": [
        "heler"
    ],
    "helaient": [
        "heler"
    ],
    "helait": [
        "heler"
    ],
    "helant": [
        "heler"
    ],
    "helas": [
        "helas",
        "hela",
        "heler"
    ],
    "heler": [
        "heler"
    ],
    "helez": [
        "heler"
    ],
    "helianthes": [
        "helianthe"
    ],
    "helice": [
        "helice"
    ],
    "helices": [
        "helice"
    ],
    "helico": [
        "helico"
    ],
    "helicoptere": [
        "helicoptere"
    ],
    "helicopteres": [
        "helicoptere"
    ],
    "helicoidal": [
        "helicoidal"
    ],
    "helicoidale": [
        "helicoidal"
    ],
    "helio": [
        "helio"
    ],
    "heliographe": [
        "heliographe"
    ],
    "heliogravure": [
        "heliogravure"
    ],
    "heliophanie": [
        "heliophanie"
    ],
    "heliotrope": [
        "heliotrope"
    ],
    "heliotropes": [
        "heliotrope"
    ],
    "heliport": [
        "heliport"
    ],
    "heliporter": [
        "heliporter"
    ],
    "heliporte": [
        "heliporter",
        "heliporte"
    ],
    "heliportee": [
        "heliporter",
        "heliporte"
    ],
    "heliportes": [
        "heliporter",
        "heliporte"
    ],
    "helitreuiller": [
        "helitreuiller"
    ],
    "helium": [
        "helium"
    ],
    "helix": [
        "helix"
    ],
    "helerent": [
        "heler"
    ],
    "heles": [
        "heler"
    ],
    "hematie": [
        "hematie"
    ],
    "hematies": [
        "hematie"
    ],
    "hematine": [
        "hematine"
    ],
    "hematite": [
        "hematite"
    ],
    "hematocrite": [
        "hematocrite"
    ],
    "hematocele": [
        "hematocele"
    ],
    "hematologie": [
        "hematologie"
    ],
    "hematologique": [
        "hematologique"
    ],
    "hematologue": [
        "hematologue"
    ],
    "hematome": [
        "hematome"
    ],
    "hematomes": [
        "hematome"
    ],
    "hematopoiese": [
        "hematopoiese"
    ],
    "hematose": [
        "hematose"
    ],
    "hematurie": [
        "hematurie"
    ],
    "hemi": [
        "hemi"
    ],
    "hemicycle": [
        "hemicycle"
    ],
    "hemiplegie": [
        "hemiplegie"
    ],
    "hemiplegique": [
        "hemiplegique"
    ],
    "hemiptere": [
        "hemiptere"
    ],
    "hemisphere": [
        "hemisphere"
    ],
    "hemispheres": [
        "hemisphere"
    ],
    "hemispherique": [
        "hemispherique"
    ],
    "hemispheriques": [
        "hemispherique"
    ],
    "hemistiche": [
        "hemistiche"
    ],
    "hemistiches": [
        "hemistiche"
    ],
    "hemiedres": [
        "hemiedre"
    ],
    "hemoculture": [
        "hemoculture"
    ],
    "hemocultures": [
        "hemoculture"
    ],
    "hemodialyse": [
        "hemodialyse"
    ],
    "hemodynamique": [
        "hemodynamique"
    ],
    "hemoglobine": [
        "hemoglobine"
    ],
    "hemoglobines": [
        "hemoglobine"
    ],
    "hemogramme": [
        "hemogramme"
    ],
    "hemolyse": [
        "hemolyse"
    ],
    "hemolytique": [
        "hemolytique"
    ],
    "hemophile": [
        "hemophile"
    ],
    "hemophiles": [
        "hemophile"
    ],
    "hemophilie": [
        "hemophilie"
    ],
    "hemoptysie": [
        "hemoptysie"
    ],
    "hemoptysies": [
        "hemoptysie"
    ],
    "hemorragie": [
        "hemorragie"
    ],
    "hemorragies": [
        "hemorragie"
    ],
    "hemorragique": [
        "hemorragique"
    ],
    "hemorroidaire": [
        "hemorroidaire"
    ],
    "hemorroidale": [
        "hemorroidal"
    ],
    "hemorroide": [
        "hemorroide"
    ],
    "hemorroides": [
        "hemorroide"
    ],
    "hemostase": [
        "hemostase"
    ],
    "hemostatique": [
        "hemostatique"
    ],
    "heparine": [
        "heparine"
    ],
    "hepatique": [
        "hepatique"
    ],
    "hepatiques": [
        "hepatique"
    ],
    "hepatite": [
        "hepatite"
    ],
    "hepatites": [
        "hepatite"
    ],
    "hepatomegalie": [
        "hepatomegalie"
    ],
    "heraclitienne": [
        "heraclitien"
    ],
    "heracliteen": [
        "heracliteen"
    ],
    "heracliteenne": [
        "heracliteen"
    ],
    "heraldique": [
        "heraldique"
    ],
    "heraldiques": [
        "heraldique"
    ],
    "heraut": [
        "heraut"
    ],
    "herauts": [
        "heraut"
    ],
    "herissa": [
        "herisser"
    ],
    "herissaient": [
        "herisser"
    ],
    "herissait": [
        "herisser"
    ],
    "herissant": [
        "herisser"
    ],
    "herisse": [
        "herisser",
        "herisse"
    ],
    "herissement": [
        "herissement"
    ],
    "herissements": [
        "herissement"
    ],
    "herissent": [
        "herisser"
    ],
    "herisser": [
        "herisser"
    ],
    "herisseraient": [
        "herisser"
    ],
    "herisses": [
        "herisser",
        "herisse"
    ],
    "herisson": [
        "herisson"
    ],
    "herissons": [
        "herisser",
        "herisson"
    ],
    "herissat": [
        "herisser"
    ],
    "herisserent": [
        "herisser"
    ],
    "herissee": [
        "herisser",
        "herisse"
    ],
    "herissees": [
        "herisser",
        "herisse"
    ],
    "herita": [
        "heriter"
    ],
    "heritage": [
        "heritage"
    ],
    "heritages": [
        "heritage"
    ],
    "heritai": [
        "heriter"
    ],
    "heritaient": [
        "heriter"
    ],
    "heritais": [
        "heriter"
    ],
    "heritait": [
        "heriter"
    ],
    "herite": [
        "heriter"
    ],
    "heritent": [
        "heriter"
    ],
    "heriter": [
        "heriter"
    ],
    "heritera": [
        "heriter"
    ],
    "heriterai": [
        "heriter"
    ],
    "heriteraient": [
        "heriter"
    ],
    "heriterait": [
        "heriter"
    ],
    "heriteras": [
        "heriter"
    ],
    "heriterez": [
        "heriter"
    ],
    "heriteront": [
        "heriter"
    ],
    "herites": [
        "heriter"
    ],
    "heritez": [
        "heriter"
    ],
    "heritier": [
        "heritier"
    ],
    "heritiers": [
        "heritier"
    ],
    "heritiere": [
        "heritier"
    ],
    "heritieres": [
        "heritier"
    ],
    "heritons": [
        "heriter"
    ],
    "heritee": [
        "heriter"
    ],
    "heritees": [
        "heriter"
    ],
    "hero": [
        "hero"
    ],
    "heron": [
        "heron"
    ],
    "herons": [
        "heron"
    ],
    "heros": [
        "heros",
        "hero"
    ],
    "heroide": [
        "heroide"
    ],
    "heroine": [
        "heros"
    ],
    "heroines": [
        "heros",
        "heroine"
    ],
    "heroinomane": [
        "heroinomane"
    ],
    "heroique": [
        "heroique"
    ],
    "heroiquement": [
        "heroiquement"
    ],
    "heroiques": [
        "heroique"
    ],
    "heroisme": [
        "heroisme"
    ],
    "hereditaire": [
        "hereditaire"
    ],
    "hereditairement": [
        "hereditairement"
    ],
    "hereditaires": [
        "hereditaire"
    ],
    "heredite": [
        "heredite"
    ],
    "heredo": [
        "heredo"
    ],
    "heresiarque": [
        "heresiarque"
    ],
    "heresiarques": [
        "heresiarque"
    ],
    "heresie": [
        "heresie"
    ],
    "heresies": [
        "heresy",
        "heresie"
    ],
    "heretique": [
        "heretique"
    ],
    "heretiques": [
        "heretique"
    ],
    "hesita": [
        "hesiter"
    ],
    "hesitai": [
        "hesiter"
    ],
    "hesitaient": [
        "hesiter"
    ],
    "hesitais": [
        "hesiter"
    ],
    "hesitait": [
        "hesiter"
    ],
    "hesitant": [
        "hesitant",
        "hesiter"
    ],
    "hesitante": [
        "hesitant"
    ],
    "hesitantes": [
        "hesitant"
    ],
    "hesitants": [
        "hesitant"
    ],
    "hesitation": [
        "hesitation"
    ],
    "hesitations": [
        "hesitation"
    ],
    "hesite": [
        "hesiter"
    ],
    "hesitent": [
        "hesiter"
    ],
    "hesiter": [
        "hesiter"
    ],
    "hesitera": [
        "hesiter"
    ],
    "hesiterai": [
        "hesiter"
    ],
    "hesiteraient": [
        "hesiter"
    ],
    "hesiterais": [
        "hesiter"
    ],
    "hesiterait": [
        "hesiter"
    ],
    "hesiteras": [
        "hesiter"
    ],
    "hesiterez": [
        "hesiter"
    ],
    "hesiteriez": [
        "hesiter"
    ],
    "hesiterions": [
        "hesiter"
    ],
    "hesiterons": [
        "hesiter"
    ],
    "hesiteront": [
        "hesiter"
    ],
    "hesites": [
        "hesiter"
    ],
    "hesitez": [
        "hesiter"
    ],
    "hesitiez": [
        "hesiter"
    ],
    "hesitions": [
        "hesiter"
    ],
    "hesitons": [
        "hesiter"
    ],
    "hesitat": [
        "hesiter"
    ],
    "hesiterent": [
        "hesiter"
    ],
    "hetaire": [
        "hetaire"
    ],
    "hetaires": [
        "hetaire"
    ],
    "hetero": [
        "hetero"
    ],
    "heterochromie": [
        "heterochromie"
    ],
    "heteroclite": [
        "heteroclite"
    ],
    "heteroclites": [
        "heteroclite"
    ],
    "heterodoxes": [
        "heterodoxe"
    ],
    "heterodoxie": [
        "heterodoxie"
    ],
    "heterogene": [
        "heterogene"
    ],
    "heterogenes": [
        "heterogene"
    ],
    "heterogeneite": [
        "heterogeneite"
    ],
    "heteroptere": [
        "heteroptere"
    ],
    "heteros": [
        "hetero"
    ],
    "heterosexualite": [
        "heterosexualite"
    ],
    "heterosexuel": [
        "heterosexuel"
    ],
    "heterosexuelle": [
        "heterosexuel"
    ],
    "heterosexuelles": [
        "heterosexuel"
    ],
    "heterosexuels": [
        "heterosexuel"
    ],
    "heterozygote": [
        "heterozygote"
    ],
    "heterozygotes": [
        "heterozygote"
    ],
    "hevea": [
        "hevea"
    ],
    "heveas": [
        "hevea"
    ],
    "hetraie": [
        "hetraie"
    ],
    "hetraies": [
        "hetraie"
    ],
    "hetre": [
        "hetre"
    ],
    "hetres": [
        "hetre"
    ],
    "hopital": [
        "hopital"
    ],
    "hopitaux": [
        "hopital"
    ],
    "hote": [
        "hote"
    ],
    "hotel": [
        "hotel"
    ],
    "hotelier": [
        "hotelier"
    ],
    "hoteliers": [
        "hotelier"
    ],
    "hoteliere": [
        "hotelier"
    ],
    "hotelieres": [
        "hotelier"
    ],
    "hotellerie": [
        "hotellerie"
    ],
    "hotelleries": [
        "hotellerie"
    ],
    "hotels": [
        "hotel"
    ],
    "hotes": [
        "hote"
    ],
    "hotesse": [
        "hotesse"
    ],
    "hotesses": [
        "hotesse"
    ],
    "i": [
        "ie",
        "i"
    ],
    "i.e.": [
        "i.e."
    ],
    "iambe": [
        "iambe"
    ],
    "iambique": [
        "iambique"
    ],
    "iambiques": [
        "iambique"
    ],
    "ibex": [
        "ibex"
    ],
    "ibis": [
        "ibis"
    ],
    "ibm": [
        "ibm"
    ],
    "ibo": [
        "ibo"
    ],
    "iboga": [
        "iboga"
    ],
    "ibere": [
        "ibere"
    ],
    "iberes": [
        "ibere"
    ],
    "iberique": [
        "iberique"
    ],
    "iberiques": [
        "iberique"
    ],
    "icarienne": [
        "icarienne"
    ],
    "iceberg": [
        "iceberg"
    ],
    "icebergs": [
        "iceberg"
    ],
    "icelle": [
        "icelle"
    ],
    "icelles": [
        "icelles"
    ],
    "icelui": [
        "icelui"
    ],
    "ichtyologie": [
        "ichtyologie"
    ],
    "ichtyologiste": [
        "ichtyologiste"
    ],
    "ici": [
        "ici"
    ],
    "icoglan": [
        "icoglan"
    ],
    "icoglans": [
        "icoglan"
    ],
    "iconoclaste": [
        "iconoclaste"
    ],
    "iconoclastes": [
        "iconoclaste"
    ],
    "iconographe": [
        "iconographe"
    ],
    "iconographie": [
        "iconographie"
    ],
    "iconographies": [
        "iconographie"
    ],
    "iconographique": [
        "iconographique"
    ],
    "iconostase": [
        "iconostase"
    ],
    "icosaedre": [
        "icosaedre"
    ],
    "ictus": [
        "ictus"
    ],
    "ictere": [
        "ictere"
    ],
    "icterique": [
        "icterique"
    ],
    "icone": [
        "icone"
    ],
    "icones": [
        "icone"
    ],
    "ide": [
        "ide"
    ],
    "idem": [
        "idem"
    ],
    "identifia": [
        "identifier"
    ],
    "identifiable": [
        "identifiable"
    ],
    "identifiables": [
        "identifiable"
    ],
    "identifiai": [
        "identifier"
    ],
    "identifiaient": [
        "identifier"
    ],
    "identifiais": [
        "identifier"
    ],
    "identifiait": [
        "identifier"
    ],
    "identifiant": [
        "identifier",
        "identifiant"
    ],
    "identifiassent": [
        "identifier"
    ],
    "identificateur": [
        "identificateur"
    ],
    "identification": [
        "identification"
    ],
    "identifications": [
        "identification"
    ],
    "identifie": [
        "identifier"
    ],
    "identifient": [
        "identifier"
    ],
    "identifier": [
        "identifier"
    ],
    "identifiera": [
        "identifier"
    ],
    "identifierai": [
        "identifier"
    ],
    "identifierais": [
        "identifier"
    ],
    "identifierait": [
        "identifier"
    ],
    "identifierez": [
        "identifier"
    ],
    "identifieront": [
        "identifier"
    ],
    "identifiez": [
        "identifier"
    ],
    "identifions": [
        "identifier"
    ],
    "identifiat": [
        "identifier"
    ],
    "identifierent": [
        "identifier"
    ],
    "identifiee": [
        "identifier"
    ],
    "identifiees": [
        "identifier"
    ],
    "identifies": [
        "identifier",
        "identify"
    ],
    "identique": [
        "identique"
    ],
    "identiquement": [
        "identiquement"
    ],
    "identiques": [
        "identique"
    ],
    "identitaire": [
        "identitaire"
    ],
    "identitaires": [
        "identitaire"
    ],
    "identitarisme": [
        "identitarisme"
    ],
    "identite": [
        "identite"
    ],
    "identites": [
        "identite"
    ],
    "ides": [
        "ides",
        "ide"
    ],
    "idiolectes": [
        "idiolecte"
    ],
    "idiomatique": [
        "idiomatique"
    ],
    "idiomatiques": [
        "idiomatique"
    ],
    "idiome": [
        "idiome"
    ],
    "idiomes": [
        "idiome"
    ],
    "idiopathique": [
        "idiopathique"
    ],
    "idiosyncrasie": [
        "idiosyncrasie"
    ],
    "idiosyncrasies": [
        "idiosyncrasy",
        "idiosyncrasie"
    ],
    "idiosyncrasique": [
        "idiosyncrasique"
    ],
    "idiot": [
        "idiot"
    ],
    "idiote": [
        "idiot"
    ],
    "idiotement": [
        "idiotement"
    ],
    "idiotes": [
        "idiot"
    ],
    "idiotie": [
        "idiotie"
    ],
    "idioties": [
        "idiotie"
    ],
    "idiotisme": [
        "idiotisme"
    ],
    "idiotismes": [
        "idiotisme"
    ],
    "idiots": [
        "idiot"
    ],
    "idoine": [
        "idoine"
    ],
    "idoines": [
        "idoine"
    ],
    "idole": [
        "idole"
    ],
    "idoles": [
        "idole"
    ],
    "idolatraient": [
        "idolatrer"
    ],
    "idolatrait": [
        "idolatrer"
    ],
    "idolatrant": [
        "idolatrer"
    ],
    "idolatre": [
        "idolatrer",
        "idolatre"
    ],
    "idolatrent": [
        "idolatrer"
    ],
    "idolatrer": [
        "idolatrer"
    ],
    "idolatres": [
        "idolatrer",
        "idolatre"
    ],
    "idolatrie": [
        "idolatrie"
    ],
    "idolatries": [
        "idolatrie"
    ],
    "idolatree": [
        "idolatrer"
    ],
    "idylle": [
        "idylle"
    ],
    "idylles": [
        "idylle"
    ],
    "idyllique": [
        "idyllique"
    ],
    "idylliques": [
        "idyllique"
    ],
    "ideal": [
        "ideal"
    ],
    "ideale": [
        "ideal"
    ],
    "idealement": [
        "idealement"
    ],
    "ideales": [
        "ideal"
    ],
    "idealisait": [
        "idealiser"
    ],
    "idealisant": [
        "idealiser"
    ],
    "idealisation": [
        "idealisation"
    ],
    "idealise": [
        "idealiser"
    ],
    "idealisent": [
        "idealiser"
    ],
    "idealiser": [
        "idealiser"
    ],
    "idealisme": [
        "idealisme"
    ],
    "idealismes": [
        "idealisme"
    ],
    "idealiste": [
        "idealiste"
    ],
    "idealistes": [
        "idealiste"
    ],
    "idealisee": [
        "idealiser"
    ],
    "idealisees": [
        "idealiser"
    ],
    "idealises": [
        "idealiser"
    ],
    "ideals": [
        "ideal"
    ],
    "ideation": [
        "ideation"
    ],
    "ideaux": [
        "ideal"
    ],
    "idee": [
        "idee"
    ],
    "ideel": [
        "ideel"
    ],
    "idees": [
        "idee"
    ],
    "ideogramme": [
        "ideogramme"
    ],
    "ideogrammes": [
        "ideogramme"
    ],
    "ideographie": [
        "ideographie"
    ],
    "ideographique": [
        "ideographique"
    ],
    "ideologie": [
        "ideologie"
    ],
    "ideologies": [
        "ideologie",
        "ideology"
    ],
    "ideologique": [
        "ideologique"
    ],
    "ideologiquement": [
        "ideologiquement"
    ],
    "ideologiques": [
        "ideologique"
    ],
    "ideologue": [
        "ideologue"
    ],
    "ideologues": [
        "ideologue"
    ],
    "if": [
        "if"
    ],
    "ifs": [
        "if"
    ],
    "iftar": [
        "iftar"
    ],
    "igloo": [
        "igloo"
    ],
    "igloos": [
        "igloo"
    ],
    "igname": [
        "igname"
    ],
    "ignames": [
        "igname"
    ],
    "ignare": [
        "ignare"
    ],
    "ignares": [
        "ignare"
    ],
    "ignifuge": [
        "ignifuge",
        "ignifuger"
    ],
    "ignifugeant": [
        "ignifuger",
        "ignifugeant"
    ],
    "ignifuger": [
        "ignifuger"
    ],
    "ignifugee": [
        "ignifuge"
    ],
    "ignifugees": [
        "ignifuger"
    ],
    "ignifuges": [
        "ignifuge"
    ],
    "ignition": [
        "ignition"
    ],
    "ignoble": [
        "ignoble"
    ],
    "ignoblement": [
        "ignoblement"
    ],
    "ignobles": [
        "ignoble"
    ],
    "ignominie": [
        "ignominie"
    ],
    "ignominies": [
        "ignominie"
    ],
    "ignominieuse": [
        "ignominieux"
    ],
    "ignominieusement": [
        "ignominieusement"
    ],
    "ignominieuses": [
        "ignominieux"
    ],
    "ignominieux": [
        "ignominieux"
    ],
    "ignora": [
        "ignorer"
    ],
    "ignorai": [
        "ignorer"
    ],
    "ignoraient": [
        "ignorer"
    ],
    "ignorais": [
        "ignorer"
    ],
    "ignorait": [
        "ignorer"
    ],
    "ignorance": [
        "ignorance"
    ],
    "ignorances": [
        "ignorance"
    ],
    "ignorant": [
        "ignorer",
        "ignorant"
    ],
    "ignorante": [
        "ignorant"
    ],
    "ignorantes": [
        "ignorant"
    ],
    "ignorantins": [
        "ignorantin"
    ],
    "ignorants": [
        "ignorant"
    ],
    "ignorassent": [
        "ignorer"
    ],
    "ignore": [
        "ignorer",
        "ignore"
    ],
    "ignorent": [
        "ignorer"
    ],
    "ignorer": [
        "ignorer"
    ],
    "ignorera": [
        "ignorer"
    ],
    "ignorerai": [
        "ignorer"
    ],
    "ignoreraient": [
        "ignorer"
    ],
    "ignorerais": [
        "ignorer"
    ],
    "ignorerait": [
        "ignorer"
    ],
    "ignoreras": [
        "ignorer"
    ],
    "ignoreriez": [
        "ignorer"
    ],
    "ignorerons": [
        "ignorer"
    ],
    "ignoreront": [
        "ignorer"
    ],
    "ignores": [
        "ignorer",
        "ignore"
    ],
    "ignorez": [
        "ignorer"
    ],
    "ignoriez": [
        "ignorer"
    ],
    "ignorions": [
        "ignorer"
    ],
    "ignorons": [
        "ignorer"
    ],
    "ignorat": [
        "ignorer"
    ],
    "ignorerent": [
        "ignorer"
    ],
    "ignoree": [
        "ignorer",
        "ignore"
    ],
    "ignorees": [
        "ignorer",
        "ignore"
    ],
    "igne": [
        "igne"
    ],
    "ignee": [
        "igne"
    ],
    "iguane": [
        "iguane"
    ],
    "iguanes": [
        "iguane"
    ],
    "iguanodon": [
        "iguanodon"
    ],
    "iguanodons": [
        "iguanodon"
    ],
    "igue": [
        "igue"
    ],
    "igues": [
        "igue"
    ],
    "ikebana": [
        "ikebana"
    ],
    "il": [
        "il"
    ],
    "iles": [
        "ile"
    ],
    "iliaque": [
        "iliaque"
    ],
    "iliaques": [
        "iliaque"
    ],
    "ilium": [
        "ilium"
    ],
    "illettrisme": [
        "illettrisme"
    ],
    "illettre": [
        "illettre"
    ],
    "illettree": [
        "illettre"
    ],
    "illettres": [
        "illettre"
    ],
    "illicite": [
        "illicite"
    ],
    "illicitement": [
        "illicitement"
    ],
    "illicites": [
        "illicite"
    ],
    "illico": [
        "illico"
    ],
    "illimite": [
        "illimite"
    ],
    "illimitee": [
        "illimite"
    ],
    "illimitees": [
        "illimite"
    ],
    "illimites": [
        "illimite"
    ],
    "illisible": [
        "illisible"
    ],
    "illisibles": [
        "illisible"
    ],
    "illogique": [
        "illogique"
    ],
    "illogiquement": [
        "illogiquement"
    ],
    "illogiques": [
        "illogique"
    ],
    "illogisme": [
        "illogisme"
    ],
    "illogismes": [
        "illogisme"
    ],
    "illumina": [
        "illuminer"
    ],
    "illuminaient": [
        "illuminer"
    ],
    "illuminait": [
        "illuminer"
    ],
    "illuminant": [
        "illuminer",
        "illuminant"
    ],
    "illuminateurs": [
        "illuminateur"
    ],
    "illumination": [
        "illumination"
    ],
    "illuminations": [
        "illumination"
    ],
    "illumine": [
        "illuminer",
        "illumine"
    ],
    "illuminent": [
        "illuminer"
    ],
    "illuminer": [
        "illuminer"
    ],
    "illuminera": [
        "illuminer"
    ],
    "illuminerai": [
        "illuminer"
    ],
    "illuminerait": [
        "illuminer"
    ],
    "illumineront": [
        "illuminer"
    ],
    "illuminez": [
        "illuminer"
    ],
    "illuministes": [
        "illuministe"
    ],
    "illuminerent": [
        "illuminer"
    ],
    "illuminee": [
        "illuminer",
        "illumine"
    ],
    "illuminees": [
        "illuminer",
        "illumine"
    ],
    "illumines": [
        "illuminer",
        "illumine"
    ],
    "illusion": [
        "illusion"
    ],
    "illusionnait": [
        "illusionner"
    ],
    "illusionne": [
        "illusionner"
    ],
    "illusionnent": [
        "illusionner"
    ],
    "illusionner": [
        "illusionner"
    ],
    "illusionnez": [
        "illusionner"
    ],
    "illusionnisme": [
        "illusionnisme"
    ],
    "illusionniste": [
        "illusionniste"
    ],
    "illusionnistes": [
        "illusionniste"
    ],
    "illusions": [
        "illusion"
    ],
    "illusoire": [
        "illusoire"
    ],
    "illusoirement": [
        "illusoirement"
    ],
    "illusoires": [
        "illusoire"
    ],
    "illustra": [
        "illustrer"
    ],
    "illustraient": [
        "illustrer"
    ],
    "illustrait": [
        "illustrer"
    ],
    "illustrant": [
        "illustrer"
    ],
    "illustrateur": [
        "illustrateur"
    ],
    "illustration": [
        "illustration"
    ],
    "illustrations": [
        "illustration"
    ],
    "illustratrice": [
        "illustrateur"
    ],
    "illustre": [
        "illustrer",
        "illustre"
    ],
    "illustrement": [
        "illustrement"
    ],
    "illustrent": [
        "illustrer"
    ],
    "illustrer": [
        "illustrer"
    ],
    "illustrera": [
        "illustrer"
    ],
    "illustrerai": [
        "illustrer"
    ],
    "illustrerait": [
        "illustrer"
    ],
    "illustres": [
        "illustrer",
        "illustre"
    ],
    "illustrions": [
        "illustrer"
    ],
    "illustrissime": [
        "illustrissime"
    ],
    "illustrissimes": [
        "illustrissime"
    ],
    "illustree": [
        "illustrer",
        "illustre"
    ],
    "illustrees": [
        "illustrer",
        "illustre"
    ],
    "illegal": [
        "illegal"
    ],
    "illegale": [
        "illegal"
    ],
    "illegalement": [
        "illegalement"
    ],
    "illegales": [
        "illegal"
    ],
    "illegalistes": [
        "illegaliste"
    ],
    "illegalite": [
        "illegalite"
    ],
    "illegaux": [
        "illegal"
    ],
    "illegitime": [
        "illegitime"
    ],
    "illegitimement": [
        "illegitimement"
    ],
    "illegitimes": [
        "illegitime"
    ],
    "illegitimite": [
        "illegitimite"
    ],
    "ilote": [
        "ilote"
    ],
    "ilotes": [
        "ilote"
    ],
    "ilotisme": [
        "ilotisme"
    ],
    "ils": [
        "ils"
    ],
    "ileaux": [
        "ileal"
    ],
    "ileus": [
        "ileus"
    ],
    "image": [
        "imager",
        "image"
    ],
    "imageant": [
        "imager"
    ],
    "imager": [
        "imager"
    ],
    "imagerie": [
        "imagerie"
    ],
    "imageries": [
        "imagery",
        "imagerie"
    ],
    "images": [
        "imager",
        "image"
    ],
    "imageur": [
        "imageur"
    ],
    "imageurs": [
        "imageur"
    ],
    "imagier": [
        "imagier"
    ],
    "imagiers": [
        "imagier"
    ],
    "imagina": [
        "imaginer"
    ],
    "imaginable": [
        "imaginable"
    ],
    "imaginables": [
        "imaginable"
    ],
    "imaginai": [
        "imaginer"
    ],
    "imaginaient": [
        "imaginer"
    ],
    "imaginaire": [
        "imaginaire"
    ],
    "imaginairement": [
        "imaginairement"
    ],
    "imaginaires": [
        "imaginaire"
    ],
    "imaginais": [
        "imaginer"
    ],
    "imaginait": [
        "imaginer"
    ],
    "imaginant": [
        "imaginer",
        "imaginant"
    ],
    "imaginatif": [
        "imaginatif"
    ],
    "imaginatifs": [
        "imaginatif"
    ],
    "imagination": [
        "imagination"
    ],
    "imaginations": [
        "imagination"
    ],
    "imaginative": [
        "imaginative",
        "imaginatif"
    ],
    "imaginatives": [
        "imaginatif"
    ],
    "imagine": [
        "imaginer"
    ],
    "imaginent": [
        "imaginer"
    ],
    "imaginer": [
        "imaginer"
    ],
    "imaginerai": [
        "imaginer"
    ],
    "imagineraient": [
        "imaginer"
    ],
    "imaginerais": [
        "imaginer"
    ],
    "imaginerait": [
        "imaginer"
    ],
    "imagineras": [
        "imaginer"
    ],
    "imaginerez": [
        "imaginer"
    ],
    "imagineriez": [
        "imaginer"
    ],
    "imaginerons": [
        "imaginer"
    ],
    "imagineront": [
        "imaginer"
    ],
    "imagines": [
        "imaginer",
        "imagine"
    ],
    "imaginez": [
        "imaginer"
    ],
    "imaginiez": [
        "imaginer"
    ],
    "imaginions": [
        "imaginer"
    ],
    "imaginons": [
        "imaginer"
    ],
    "imaginames": [
        "imaginer"
    ],
    "imaginat": [
        "imaginer"
    ],
    "imaginerent": [
        "imaginer"
    ],
    "imaginee": [
        "imaginer"
    ],
    "imaginees": [
        "imaginer"
    ],
    "imago": [
        "imago"
    ],
    "imagee": [
        "imager",
        "image"
    ],
    "imagees": [
        "imager",
        "image"
    ],
    "imam": [
        "imam"
    ],
    "imams": [
        "imam"
    ],
    "iman": [
        "iman"
    ],
    "imbaisable": [
        "imbaisable"
    ],
    "imbattable": [
        "imbattable"
    ],
    "imbattables": [
        "imbattable"
    ],
    "imberbe": [
        "imberbe"
    ],
    "imberbes": [
        "imberbe"
    ],
    "imbiba": [
        "imbiber"
    ],
    "imbibaient": [
        "imbiber"
    ],
    "imbibais": [
        "imbiber"
    ],
    "imbibait": [
        "imbiber"
    ],
    "imbibant": [
        "imbiber"
    ],
    "imbibe": [
        "imbiber",
        "imbibe"
    ],
    "imbiber": [
        "imbiber"
    ],
    "imbiberai": [
        "imbiber"
    ],
    "imbiberais": [
        "imbiber"
    ],
    "imbiberait": [
        "imbiber"
    ],
    "imbibition": [
        "imbibition"
    ],
    "imbibee": [
        "imbiber",
        "imbibe"
    ],
    "imbibees": [
        "imbiber",
        "imbibe"
    ],
    "imbibes": [
        "imbiber",
        "imbibe"
    ],
    "imbitable": [
        "imbitable"
    ],
    "imbitables": [
        "imbitable"
    ],
    "imbittable": [
        "imbittable"
    ],
    "imbrication": [
        "imbrication"
    ],
    "imbrications": [
        "imbrication"
    ],
    "imbriquaient": [
        "imbriquer"
    ],
    "imbriquait": [
        "imbriquer"
    ],
    "imbriquant": [
        "imbriquer"
    ],
    "imbrique": [
        "imbriquer",
        "imbrique"
    ],
    "imbriquent": [
        "imbriquer"
    ],
    "imbriquer": [
        "imbriquer"
    ],
    "imbriquee": [
        "imbriquer"
    ],
    "imbriquees": [
        "imbriquer",
        "imbrique"
    ],
    "imbriques": [
        "imbriquer",
        "imbrique"
    ],
    "imbrisable": [
        "imbrisable"
    ],
    "imbroglio": [
        "imbroglio"
    ],
    "imbroglios": [
        "imbroglio"
    ],
    "imbu": [
        "imbu"
    ],
    "imbue": [
        "imbu"
    ],
    "imbues": [
        "imbue",
        "imbu"
    ],
    "imbus": [
        "imbu"
    ],
    "imbuvable": [
        "imbuvable"
    ],
    "imbecile": [
        "imbecile"
    ],
    "imbecilement": [
        "imbecilement"
    ],
    "imbeciles": [
        "imbecile"
    ],
    "imbecillite": [
        "imbecillite"
    ],
    "imbecillites": [
        "imbecillite"
    ],
    "imidazole": [
        "imidazole"
    ],
    "imita": [
        "imiter"
    ],
    "imitable": [
        "imitable"
    ],
    "imitables": [
        "imitable"
    ],
    "imitai": [
        "imiter"
    ],
    "imitaient": [
        "imiter"
    ],
    "imitais": [
        "imiter"
    ],
    "imitait": [
        "imiter"
    ],
    "imitant": [
        "imiter"
    ],
    "imitateur": [
        "imitateur"
    ],
    "imitateurs": [
        "imitateur"
    ],
    "imitation": [
        "imitation"
    ],
    "imitations": [
        "imitation"
    ],
    "imitative": [
        "imitatif"
    ],
    "imitatives": [
        "imitatif"
    ],
    "imitatrice": [
        "imitateur"
    ],
    "imite": [
        "imiter",
        "imite"
    ],
    "imitent": [
        "imiter"
    ],
    "imiter": [
        "imiter"
    ],
    "imitera": [
        "imiter"
    ],
    "imiterai": [
        "imiter"
    ],
    "imiteraient": [
        "imiter"
    ],
    "imiterais": [
        "imiter"
    ],
    "imiterait": [
        "imiter"
    ],
    "imiteront": [
        "imiter"
    ],
    "imites": [
        "imiter",
        "imite"
    ],
    "imitez": [
        "imiter"
    ],
    "imitiez": [
        "imiter"
    ],
    "imitions": [
        "imiter"
    ],
    "imitons": [
        "imiter"
    ],
    "imitames": [
        "imiter"
    ],
    "imitat": [
        "imiter"
    ],
    "imiterent": [
        "imiter"
    ],
    "imitee": [
        "imiter",
        "imite"
    ],
    "imitees": [
        "imiter",
        "imite"
    ],
    "immaculation": [
        "immaculation"
    ],
    "immacule": [
        "immacule"
    ],
    "immaculee": [
        "immacule"
    ],
    "immaculees": [
        "immacule"
    ],
    "immacules": [
        "immacule"
    ],
    "immanence": [
        "immanence"
    ],
    "immanent": [
        "immanent"
    ],
    "immanente": [
        "immanent"
    ],
    "immanentisme": [
        "immanentisme"
    ],
    "immangeable": [
        "immangeable"
    ],
    "immangeables": [
        "immangeable"
    ],
    "immanquable": [
        "immanquable"
    ],
    "immanquablement": [
        "immanquablement"
    ],
    "immanquables": [
        "immanquable"
    ],
    "immarcescible": [
        "immarcescible"
    ],
    "immatriculation": [
        "immatriculation"
    ],
    "immatriculations": [
        "immatriculation"
    ],
    "immatriculer": [
        "immatriculer"
    ],
    "immatricule": [
        "immatriculer",
        "immatricule"
    ],
    "immatriculee": [
        "immatriculer",
        "immatricule"
    ],
    "immatriculees": [
        "immatriculer"
    ],
    "immature": [
        "immature"
    ],
    "immatures": [
        "immature"
    ],
    "immaturite": [
        "immaturite"
    ],
    "immaterialite": [
        "immaterialite"
    ],
    "immateriel": [
        "immateriel"
    ],
    "immaterielle": [
        "immateriel"
    ],
    "immaterielles": [
        "immateriel"
    ],
    "immateriels": [
        "immateriel"
    ],
    "immense": [
        "immense"
    ],
    "immenses": [
        "immense"
    ],
    "immensite": [
        "immensite"
    ],
    "immensites": [
        "immensite"
    ],
    "immensurable": [
        "immensurable"
    ],
    "immensement": [
        "immensement"
    ],
    "immerge": [
        "immerger",
        "immerge"
    ],
    "immergea": [
        "immerger"
    ],
    "immergeait": [
        "immerger"
    ],
    "immergeant": [
        "immerger"
    ],
    "immergent": [
        "immerger"
    ],
    "immergeons": [
        "immerger"
    ],
    "immerger": [
        "immerger"
    ],
    "immergerons": [
        "immerger"
    ],
    "immergez": [
        "immerger"
    ],
    "immergiez": [
        "immerger"
    ],
    "immergerent": [
        "immerger"
    ],
    "immergee": [
        "immerger",
        "immerge"
    ],
    "immergees": [
        "immerger",
        "immerge"
    ],
    "immerges": [
        "immerger",
        "immerge"
    ],
    "immersion": [
        "immersion"
    ],
    "immettable": [
        "immettable"
    ],
    "immeuble": [
        "immeuble"
    ],
    "immeubles": [
        "immeuble"
    ],
    "immigrai": [
        "immigrer"
    ],
    "immigrant": [
        "immigrant"
    ],
    "immigrante": [
        "immigrant"
    ],
    "immigrants": [
        "immigrant"
    ],
    "immigration": [
        "immigration"
    ],
    "immigrer": [
        "immigrer"
    ],
    "immigre": [
        "immigrer",
        "immigre"
    ],
    "immigree": [
        "immigre"
    ],
    "immigrees": [
        "immigrer",
        "immigre"
    ],
    "immigres": [
        "immigre"
    ],
    "imminence": [
        "imminence"
    ],
    "imminent": [
        "imminent"
    ],
    "imminente": [
        "imminent"
    ],
    "imminentes": [
        "imminent"
    ],
    "imminents": [
        "imminent"
    ],
    "immisce": [
        "immiscer"
    ],
    "immiscent": [
        "immiscer"
    ],
    "immiscer": [
        "immiscer"
    ],
    "immiscerait": [
        "immiscer"
    ],
    "immisces": [
        "immiscer"
    ],
    "immiscibles": [
        "immiscible"
    ],
    "immiscee": [
        "immiscer"
    ],
    "immiscaient": [
        "immiscer"
    ],
    "immiscait": [
        "immiscer"
    ],
    "immiscant": [
        "immiscer"
    ],
    "immixtion": [
        "immixtion"
    ],
    "immixtions": [
        "immixtion"
    ],
    "immobile": [
        "immobile"
    ],
    "immobiles": [
        "immobile"
    ],
    "immobilier": [
        "immobilier"
    ],
    "immobiliers": [
        "immobilier"
    ],
    "immobilisa": [
        "immobiliser"
    ],
    "immobilisai": [
        "immobiliser"
    ],
    "immobilisaient": [
        "immobiliser"
    ],
    "immobilisais": [
        "immobiliser"
    ],
    "immobilisait": [
        "immobiliser"
    ],
    "immobilisant": [
        "immobilisant",
        "immobiliser"
    ],
    "immobilisation": [
        "immobilisation"
    ],
    "immobilisations": [
        "immobilisation"
    ],
    "immobilise": [
        "immobiliser"
    ],
    "immobilisent": [
        "immobiliser"
    ],
    "immobiliser": [
        "immobiliser"
    ],
    "immobilisera": [
        "immobiliser"
    ],
    "immobiliserait": [
        "immobiliser"
    ],
    "immobiliseront": [
        "immobiliser"
    ],
    "immobilises": [
        "immobiliser"
    ],
    "immobilisez": [
        "immobiliser"
    ],
    "immobilisme": [
        "immobilisme"
    ],
    "immobilisons": [
        "immobiliser"
    ],
    "immobiliserent": [
        "immobiliser"
    ],
    "immobilisee": [
        "immobiliser"
    ],
    "immobilisees": [
        "immobiliser"
    ],
    "immobilite": [
        "immobilite"
    ],
    "immobilites": [
        "immobilite"
    ],
    "immobiliere": [
        "immobilier"
    ],
    "immobilieres": [
        "immobilier"
    ],
    "immodeste": [
        "immodeste"
    ],
    "immodestes": [
        "immodeste"
    ],
    "immodestie": [
        "immodestie"
    ],
    "immodere": [
        "immodere"
    ],
    "immoderee": [
        "immodere"
    ],
    "immoderees": [
        "immodere"
    ],
    "immoderement": [
        "immoderement"
    ],
    "immoderes": [
        "immodere"
    ],
    "immola": [
        "immoler"
    ],
    "immolation": [
        "immolation"
    ],
    "immolations": [
        "immolation"
    ],
    "immole": [
        "immoler"
    ],
    "immolent": [
        "immoler"
    ],
    "immoler": [
        "immoler"
    ],
    "immolee": [
        "immoler"
    ],
    "immoles": [
        "immoler"
    ],
    "immonde": [
        "immonde"
    ],
    "immondes": [
        "immonde"
    ],
    "immondice": [
        "immondice"
    ],
    "immondices": [
        "immondice"
    ],
    "immoral": [
        "immoral"
    ],
    "immorale": [
        "immoral"
    ],
    "immoralement": [
        "immoralement"
    ],
    "immorales": [
        "immoral"
    ],
    "immoralisme": [
        "immoralisme"
    ],
    "immoraliste": [
        "immoraliste"
    ],
    "immoralite": [
        "immoralite"
    ],
    "immoraux": [
        "immoral"
    ],
    "immortalisa": [
        "immortaliser"
    ],
    "immortalisait": [
        "immortaliser"
    ],
    "immortalisant": [
        "immortaliser"
    ],
    "immortalisation": [
        "immortalisation"
    ],
    "immortalise": [
        "immortaliser"
    ],
    "immortaliser": [
        "immortaliser"
    ],
    "immortaliseraient": [
        "immortaliser"
    ],
    "immortaliseront": [
        "immortaliser"
    ],
    "immortalisez": [
        "immortaliser"
    ],
    "immortalisee": [
        "immortaliser"
    ],
    "immortalisees": [
        "immortaliser"
    ],
    "immortalises": [
        "immortaliser"
    ],
    "immortalite": [
        "immortalite"
    ],
    "immortalites": [
        "immortalite"
    ],
    "immortel": [
        "immortel"
    ],
    "immortelle": [
        "immortel"
    ],
    "immortelles": [
        "immortel"
    ],
    "immortels": [
        "immortel"
    ],
    "immortifiees": [
        "immortifie"
    ],
    "immotivee": [
        "immotive"
    ],
    "immotives": [
        "immotive"
    ],
    "immuabilite": [
        "immuabilite"
    ],
    "immuable": [
        "immuable"
    ],
    "immuablement": [
        "immuablement"
    ],
    "immuables": [
        "immuable"
    ],
    "immune": [
        "immun"
    ],
    "immunisait": [
        "immuniser"
    ],
    "immunisation": [
        "immunisation"
    ],
    "immunise": [
        "immuniser"
    ],
    "immunisent": [
        "immuniser"
    ],
    "immuniser": [
        "immuniser"
    ],
    "immunisee": [
        "immuniser"
    ],
    "immunises": [
        "immuniser"
    ],
    "immunitaire": [
        "immunitaire"
    ],
    "immunitaires": [
        "immunitaire"
    ],
    "immunite": [
        "immunite"
    ],
    "immunites": [
        "immunite"
    ],
    "immunodeficience": [
        "immunodeficience"
    ],
    "immunodeficitaire": [
        "immunodeficitaire"
    ],
    "immunodeprime": [
        "immunodeprime"
    ],
    "immunogene": [
        "immunogene"
    ],
    "immunologie": [
        "immunologie"
    ],
    "immunologique": [
        "immunologique"
    ],
    "immunologiste": [
        "immunologiste"
    ],
    "immunostimulant": [
        "immunostimulant"
    ],
    "immunotherapie": [
        "immunotherapie"
    ],
    "immutabilite": [
        "immutabilite"
    ],
    "immediat": [
        "immediat"
    ],
    "immediate": [
        "immediat"
    ],
    "immediatement": [
        "immediatement"
    ],
    "immediates": [
        "immediat"
    ],
    "immediatete": [
        "immediatete"
    ],
    "immediats": [
        "immediat"
    ],
    "immemorial": [
        "immemorial"
    ],
    "immemoriale": [
        "immemorial"
    ],
    "immemoriales": [
        "immemorial"
    ],
    "immemoriaux": [
        "immemorial"
    ],
    "immerite": [
        "immerite"
    ],
    "immeritee": [
        "immerite"
    ],
    "immeritees": [
        "immerite"
    ],
    "immerites": [
        "immerite"
    ],
    "impact": [
        "impact"
    ],
    "impacts": [
        "impact"
    ],
    "impair": [
        "impair"
    ],
    "impaire": [
        "impair"
    ],
    "impaires": [
        "impair"
    ],
    "impairs": [
        "impair"
    ],
    "impala": [
        "impala"
    ],
    "impalas": [
        "impala"
    ],
    "impalpabilite": [
        "impalpabilite"
    ],
    "impalpable": [
        "impalpable"
    ],
    "impalpablement": [
        "impalpablement"
    ],
    "impalpables": [
        "impalpable"
    ],
    "imparable": [
        "imparable"
    ],
    "imparablement": [
        "imparablement"
    ],
    "imparables": [
        "imparable"
    ],
    "impardonnable": [
        "impardonnable"
    ],
    "impardonnablement": [
        "impardonnablement"
    ],
    "impardonnables": [
        "impardonnable"
    ],
    "imparfait": [
        "imparfait"
    ],
    "imparfaite": [
        "imparfait"
    ],
    "imparfaitement": [
        "imparfaitement"
    ],
    "imparfaites": [
        "imparfait"
    ],
    "imparfaits": [
        "imparfait"
    ],
    "impartageable": [
        "impartageable"
    ],
    "imparti": [
        "imparti",
        "impartir"
    ],
    "impartial": [
        "impartial"
    ],
    "impartiale": [
        "impartial"
    ],
    "impartialement": [
        "impartialement"
    ],
    "impartiales": [
        "impartial"
    ],
    "impartialite": [
        "impartialite"
    ],
    "impartiaux": [
        "impartial"
    ],
    "impartie": [
        "impartir"
    ],
    "impartir": [
        "impartir"
    ],
    "impartis": [
        "impartir"
    ],
    "impassable": [
        "impassable"
    ],
    "impasse": [
        "impasse"
    ],
    "impasses": [
        "impasse"
    ],
    "impassibilite": [
        "impassibilite"
    ],
    "impassible": [
        "impassible"
    ],
    "impassiblement": [
        "impassiblement"
    ],
    "impassibles": [
        "impassible"
    ],
    "impatiemment": [
        "impatiemment"
    ],
    "impatience": [
        "impatience"
    ],
    "impatiences": [
        "impatience"
    ],
    "impatiens": [
        "impatiens"
    ],
    "impatient": [
        "impatient"
    ],
    "impatienta": [
        "impatienter"
    ],
    "impatientai": [
        "impatienter"
    ],
    "impatientaient": [
        "impatienter"
    ],
    "impatientais": [
        "impatienter"
    ],
    "impatientait": [
        "impatienter"
    ],
    "impatientant": [
        "impatienter"
    ],
    "impatiente": [
        "impatienter",
        "impatient"
    ],
    "impatientent": [
        "impatienter"
    ],
    "impatienter": [
        "impatienter"
    ],
    "impatienterait": [
        "impatienter"
    ],
    "impatientes": [
        "impatienter",
        "impatient"
    ],
    "impatientez": [
        "impatienter"
    ],
    "impatients": [
        "impatient"
    ],
    "impatienterent": [
        "impatienter"
    ],
    "impatientee": [
        "impatienter"
    ],
    "impatronisait": [
        "impatroniser"
    ],
    "impatroniser": [
        "impatroniser"
    ],
    "impatronise": [
        "impatroniser"
    ],
    "impavide": [
        "impavide"
    ],
    "impavides": [
        "impavide"
    ],
    "impayable": [
        "impayable"
    ],
    "impayables": [
        "impayable"
    ],
    "impaye": [
        "impaye"
    ],
    "impayee": [
        "impaye"
    ],
    "impayees": [
        "impaye"
    ],
    "impayes": [
        "impaye"
    ],
    "impeachment": [
        "impeachment"
    ],
    "impec": [
        "impec"
    ],
    "impeccabilite": [
        "impeccabilite"
    ],
    "impeccable": [
        "impeccable"
    ],
    "impeccablement": [
        "impeccablement"
    ],
    "impeccables": [
        "impeccable"
    ],
    "impedimenta": [
        "impedimenta"
    ],
    "impensable": [
        "impensable"
    ],
    "impensables": [
        "impensable"
    ],
    "impense": [
        "impense"
    ],
    "imper": [
        "imper"
    ],
    "imperator": [
        "imperator"
    ],
    "imperceptible": [
        "imperceptible"
    ],
    "imperceptiblement": [
        "imperceptiblement"
    ],
    "imperceptibles": [
        "imperceptible"
    ],
    "imperfectible": [
        "imperfectible"
    ],
    "imperfection": [
        "imperfection"
    ],
    "imperfections": [
        "imperfection"
    ],
    "imperium": [
        "imperium"
    ],
    "impermeabilisant": [
        "impermeabilisant"
    ],
    "impermeabiliser": [
        "impermeabiliser"
    ],
    "impermeabilise": [
        "impermeabiliser"
    ],
    "impermeabilite": [
        "impermeabilite"
    ],
    "impermeable": [
        "impermeable"
    ],
    "impermeables": [
        "impermeable"
    ],
    "impers": [
        "imper"
    ],
    "impersonnaliser": [
        "impersonnaliser"
    ],
    "impersonnalite": [
        "impersonnalite"
    ],
    "impersonnel": [
        "impersonnel"
    ],
    "impersonnelle": [
        "impersonnel"
    ],
    "impersonnelles": [
        "impersonnel"
    ],
    "impersonnels": [
        "impersonnel"
    ],
    "impertinemment": [
        "impertinemment"
    ],
    "impertinence": [
        "impertinence"
    ],
    "impertinences": [
        "impertinence"
    ],
    "impertinent": [
        "impertinent"
    ],
    "impertinente": [
        "impertinent"
    ],
    "impertinentes": [
        "impertinent"
    ],
    "impertinents": [
        "impertinent"
    ],
    "imperturbable": [
        "imperturbable"
    ],
    "imperturbablement": [
        "imperturbablement"
    ],
    "imperturbables": [
        "imperturbable"
    ],
    "impie": [
        "impie"
    ],
    "impies": [
        "impie"
    ],
    "impitoyable": [
        "impitoyable"
    ],
    "impitoyablement": [
        "impitoyablement"
    ],
    "impitoyables": [
        "impitoyable"
    ],
    "impiete": [
        "impiete"
    ],
    "impietes": [
        "impiete"
    ],
    "implacabilite": [
        "implacabilite"
    ],
    "implacable": [
        "implacable"
    ],
    "implacablement": [
        "implacablement"
    ],
    "implacables": [
        "implacable"
    ],
    "implant": [
        "implant"
    ],
    "implanta": [
        "implanter"
    ],
    "implantable": [
        "implantable"
    ],
    "implantaient": [
        "implanter"
    ],
    "implantais": [
        "implanter"
    ],
    "implantait": [
        "implanter"
    ],
    "implantant": [
        "implanter"
    ],
    "implantation": [
        "implantation"
    ],
    "implantations": [
        "implantation"
    ],
    "implante": [
        "implanter",
        "implante"
    ],
    "implantent": [
        "implanter"
    ],
    "implanter": [
        "implanter"
    ],
    "implantez": [
        "implanter"
    ],
    "implantiez": [
        "implanter"
    ],
    "implantons": [
        "implanter"
    ],
    "implants": [
        "implant"
    ],
    "implantee": [
        "implanter",
        "implante"
    ],
    "implantees": [
        "implanter",
        "implante"
    ],
    "implantes": [
        "implanter",
        "implante"
    ],
    "implication": [
        "implication"
    ],
    "implications": [
        "implication"
    ],
    "implicite": [
        "implicite"
    ],
    "implicitement": [
        "implicitement"
    ],
    "implicites": [
        "implicite"
    ],
    "impliqua": [
        "impliquer"
    ],
    "impliquaient": [
        "impliquer"
    ],
    "impliquait": [
        "impliquer"
    ],
    "impliquant": [
        "impliquer"
    ],
    "implique": [
        "impliquer"
    ],
    "impliquent": [
        "impliquer"
    ],
    "impliquer": [
        "impliquer"
    ],
    "impliquera": [
        "impliquer"
    ],
    "impliquerai": [
        "impliquer"
    ],
    "impliquerais": [
        "impliquer"
    ],
    "impliquerait": [
        "impliquer"
    ],
    "impliquerons": [
        "impliquer"
    ],
    "impliqueront": [
        "impliquer"
    ],
    "impliquez": [
        "impliquer"
    ],
    "impliquions": [
        "impliquer"
    ],
    "impliquons": [
        "impliquer"
    ],
    "impliquat": [
        "impliquer"
    ],
    "impliquee": [
        "impliquer"
    ],
    "impliquees": [
        "impliquer"
    ],
    "impliques": [
        "impliquer"
    ],
    "implora": [
        "implorer"
    ],
    "implorai": [
        "implorer"
    ],
    "imploraient": [
        "implorer"
    ],
    "implorais": [
        "implorer"
    ],
    "implorait": [
        "implorer"
    ],
    "implorant": [
        "implorant",
        "implorer"
    ],
    "implorante": [
        "implorant"
    ],
    "implorantes": [
        "implorant"
    ],
    "implorants": [
        "implorant"
    ],
    "imploration": [
        "imploration"
    ],
    "implorations": [
        "imploration"
    ],
    "implore": [
        "implorer"
    ],
    "implorent": [
        "implorer"
    ],
    "implorer": [
        "implorer"
    ],
    "implorera": [
        "implorer"
    ],
    "implorerai": [
        "implorer"
    ],
    "implorerais": [
        "implorer"
    ],
    "implorerez": [
        "implorer"
    ],
    "imploreront": [
        "implorer"
    ],
    "implorez": [
        "implorer"
    ],
    "imploriez": [
        "implorer"
    ],
    "implorons": [
        "implorer"
    ],
    "implorerent": [
        "implorer"
    ],
    "imploree": [
        "implorer"
    ],
    "implose": [
        "imploser"
    ],
    "implosent": [
        "imploser"
    ],
    "imploser": [
        "imploser"
    ],
    "implosera": [
        "imploser"
    ],
    "implosez": [
        "imploser"
    ],
    "implosif": [
        "implosif"
    ],
    "implosifs": [
        "implosif"
    ],
    "implosion": [
        "implosion"
    ],
    "implosive": [
        "implosive"
    ],
    "implosives": [
        "implosif"
    ],
    "implementation": [
        "implementation"
    ],
    "implementer": [
        "implementer"
    ],
    "impoli": [
        "impoli"
    ],
    "impolie": [
        "impoli"
    ],
    "impoliment": [
        "impoliment"
    ],
    "impolis": [
        "impoli"
    ],
    "impolitesse": [
        "impolitesse"
    ],
    "impolitesses": [
        "impolitesse"
    ],
    "impollu": [
        "impollu"
    ],
    "impolluable": [
        "impolluable"
    ],
    "impollue": [
        "impollue"
    ],
    "impolluee": [
        "impollue"
    ],
    "impolluees": [
        "impollue"
    ],
    "impollues": [
        "impollue"
    ],
    "imponderable": [
        "imponderable"
    ],
    "imponderables": [
        "imponderable"
    ],
    "impopulaire": [
        "impopulaire"
    ],
    "impopulaires": [
        "impopulaire"
    ],
    "impopularite": [
        "impopularite"
    ],
    "import": [
        "import"
    ],
    "importa": [
        "importer"
    ],
    "importable": [
        "importable"
    ],
    "importables": [
        "importable"
    ],
    "importaient": [
        "importer"
    ],
    "importait": [
        "importer"
    ],
    "importance": [
        "importance"
    ],
    "importances": [
        "importance"
    ],
    "important": [
        "important",
        "importer"
    ],
    "importante": [
        "important"
    ],
    "importantes": [
        "important"
    ],
    "importants": [
        "important"
    ],
    "importateur": [
        "importateur"
    ],
    "importateurs": [
        "importateur"
    ],
    "importation": [
        "importation"
    ],
    "importations": [
        "importation"
    ],
    "importe": [
        "importe",
        "importer"
    ],
    "importent": [
        "importer"
    ],
    "importer": [
        "importer"
    ],
    "importera": [
        "importer"
    ],
    "importeraient": [
        "importer"
    ],
    "importerait": [
        "importer"
    ],
    "importes": [
        "importe",
        "importer"
    ],
    "imports": [
        "import"
    ],
    "importun": [
        "importun"
    ],
    "importuna": [
        "importuner"
    ],
    "importunaient": [
        "importuner"
    ],
    "importunais": [
        "importuner"
    ],
    "importunait": [
        "importuner"
    ],
    "importune": [
        "importun",
        "importuner"
    ],
    "importunent": [
        "importuner"
    ],
    "importuner": [
        "importuner"
    ],
    "importunerai": [
        "importuner"
    ],
    "importunerait": [
        "importuner"
    ],
    "importunerez": [
        "importuner"
    ],
    "importunerons": [
        "importuner"
    ],
    "importunes": [
        "importun",
        "importuner"
    ],
    "importunez": [
        "importuner"
    ],
    "importunites": [
        "importunite"
    ],
    "importuns": [
        "importun"
    ],
    "importunat": [
        "importuner"
    ],
    "importunee": [
        "importuner"
    ],
    "importat": [
        "importer"
    ],
    "importee": [
        "importe",
        "importer"
    ],
    "importees": [
        "importe",
        "importer"
    ],
    "imposa": [
        "imposer"
    ],
    "imposable": [
        "imposable"
    ],
    "imposables": [
        "imposable"
    ],
    "imposai": [
        "imposer"
    ],
    "imposaient": [
        "imposer"
    ],
    "imposais": [
        "imposer"
    ],
    "imposait": [
        "imposer"
    ],
    "imposant": [
        "imposer",
        "imposant"
    ],
    "imposante": [
        "imposant"
    ],
    "imposantes": [
        "imposant"
    ],
    "imposants": [
        "imposant"
    ],
    "imposassent": [
        "imposer"
    ],
    "impose": [
        "imposer",
        "impose"
    ],
    "imposent": [
        "imposer"
    ],
    "imposer": [
        "imposer"
    ],
    "imposera": [
        "imposer"
    ],
    "imposerai": [
        "imposer"
    ],
    "imposeraient": [
        "imposer"
    ],
    "imposerais": [
        "imposer"
    ],
    "imposerait": [
        "imposer"
    ],
    "imposerez": [
        "imposer"
    ],
    "imposerions": [
        "imposer"
    ],
    "imposerons": [
        "imposer"
    ],
    "imposeront": [
        "imposer"
    ],
    "imposes": [
        "imposer",
        "impose"
    ],
    "imposez": [
        "imposer"
    ],
    "imposiez": [
        "imposer"
    ],
    "imposition": [
        "imposition"
    ],
    "impositions": [
        "imposition"
    ],
    "imposons": [
        "imposer"
    ],
    "impossibilite": [
        "impossibilite"
    ],
    "impossibilites": [
        "impossibilite"
    ],
    "impossible": [
        "impossible"
    ],
    "impossibles": [
        "impossible"
    ],
    "imposte": [
        "imposte"
    ],
    "imposteur": [
        "imposteur"
    ],
    "imposteurs": [
        "imposteur"
    ],
    "imposture": [
        "imposture"
    ],
    "impostures": [
        "imposture"
    ],
    "imposat": [
        "imposer"
    ],
    "imposerent": [
        "imposer"
    ],
    "imposee": [
        "imposer",
        "impose"
    ],
    "imposees": [
        "imposer",
        "impose"
    ],
    "impotence": [
        "impotence"
    ],
    "impotent": [
        "impotent"
    ],
    "impotente": [
        "impotent"
    ],
    "impotentes": [
        "impotent"
    ],
    "impotents": [
        "impotent"
    ],
    "impraticabilite": [
        "impraticabilite"
    ],
    "impraticable": [
        "impraticable"
    ],
    "impraticables": [
        "impraticable"
    ],
    "impratique": [
        "impratique"
    ],
    "imprenable": [
        "imprenable"
    ],
    "imprenables": [
        "imprenable"
    ],
    "impresarii": [
        "impresario"
    ],
    "impresario": [
        "impresario"
    ],
    "impresarios": [
        "impresario"
    ],
    "imprescriptible": [
        "imprescriptible"
    ],
    "imprescriptibles": [
        "imprescriptible"
    ],
    "impression": [
        "impression"
    ],
    "impressionna": [
        "impressionner"
    ],
    "impressionnable": [
        "impressionnable"
    ],
    "impressionnables": [
        "impressionnable"
    ],
    "impressionnaient": [
        "impressionner"
    ],
    "impressionnais": [
        "impressionner"
    ],
    "impressionnait": [
        "impressionner"
    ],
    "impressionnant": [
        "impressionnant",
        "impressionner"
    ],
    "impressionnante": [
        "impressionnant"
    ],
    "impressionnantes": [
        "impressionnant"
    ],
    "impressionnants": [
        "impressionnant"
    ],
    "impressionne": [
        "impressionner"
    ],
    "impressionnent": [
        "impressionner"
    ],
    "impressionner": [
        "impressionner"
    ],
    "impressionnera": [
        "impressionner"
    ],
    "impressionnerait": [
        "impressionner"
    ],
    "impressionneras": [
        "impressionner"
    ],
    "impressionneront": [
        "impressionner"
    ],
    "impressionnes": [
        "impressionner"
    ],
    "impressionnez": [
        "impressionner"
    ],
    "impressionnisme": [
        "impressionnisme"
    ],
    "impressionniste": [
        "impressionniste"
    ],
    "impressionnistes": [
        "impressionniste"
    ],
    "impressionnat": [
        "impressionner"
    ],
    "impressionnerent": [
        "impressionner"
    ],
    "impressionnee": [
        "impressionner"
    ],
    "impressionnees": [
        "impressionner"
    ],
    "impressions": [
        "impression"
    ],
    "impressive": [
        "impressif"
    ],
    "imprima": [
        "imprimer"
    ],
    "imprimable": [
        "imprimable"
    ],
    "imprimaient": [
        "imprimer"
    ],
    "imprimais": [
        "imprimer"
    ],
    "imprimait": [
        "imprimer"
    ],
    "imprimant": [
        "imprimer"
    ],
    "imprimante": [
        "imprimante"
    ],
    "imprimatur": [
        "imprimatur"
    ],
    "imprime": [
        "imprimer",
        "imprime"
    ],
    "impriment": [
        "imprimer"
    ],
    "imprimer": [
        "imprimer"
    ],
    "imprimera": [
        "imprimer"
    ],
    "imprimerai": [
        "imprimer"
    ],
    "imprimerait": [
        "imprimer"
    ],
    "imprimeras": [
        "imprimer"
    ],
    "imprimerie": [
        "imprimerie"
    ],
    "imprimeries": [
        "imprimerie"
    ],
    "imprimerons": [
        "imprimer"
    ],
    "imprimeur": [
        "imprimeur"
    ],
    "imprimeurs": [
        "imprimeur"
    ],
    "imprimez": [
        "imprimer"
    ],
    "imprimerent": [
        "imprimer"
    ],
    "imprimee": [
        "imprimer"
    ],
    "imprimees": [
        "imprimer"
    ],
    "imprimes": [
        "imprimer",
        "imprime"
    ],
    "impro": [
        "impro"
    ],
    "improbabilite": [
        "improbabilite"
    ],
    "improbable": [
        "improbable"
    ],
    "improbables": [
        "improbable"
    ],
    "improductif": [
        "improductif"
    ],
    "improductifs": [
        "improductif"
    ],
    "improductive": [
        "improductif"
    ],
    "improductives": [
        "improductif"
    ],
    "impromptu": [
        "impromptu"
    ],
    "impromptue": [
        "impromptu"
    ],
    "impromptues": [
        "impromptu"
    ],
    "impromptus": [
        "impromptu"
    ],
    "imprononce": [
        "imprononce"
    ],
    "imprononcable": [
        "imprononcable"
    ],
    "imprononcables": [
        "imprononcable"
    ],
    "impropre": [
        "impropre"
    ],
    "improprement": [
        "improprement"
    ],
    "impropres": [
        "impropre"
    ],
    "improprietes": [
        "impropriete"
    ],
    "improuva": [
        "improuver"
    ],
    "improuvable": [
        "improuvable"
    ],
    "improvisa": [
        "improviser"
    ],
    "improvisade": [
        "improvisade"
    ],
    "improvisai": [
        "improviser"
    ],
    "improvisaient": [
        "improviser"
    ],
    "improvisais": [
        "improviser"
    ],
    "improvisait": [
        "improviser"
    ],
    "improvisant": [
        "improviser"
    ],
    "improvisateur": [
        "improvisateur"
    ],
    "improvisateurs": [
        "improvisateur"
    ],
    "improvisation": [
        "improvisation"
    ],
    "improvisations": [
        "improvisation"
    ],
    "improvise": [
        "improvise",
        "improviser"
    ],
    "improvisent": [
        "improviser"
    ],
    "improviser": [
        "improviser"
    ],
    "improvisera": [
        "improviser"
    ],
    "improviserai": [
        "improviser"
    ],
    "improviserons": [
        "improviser"
    ],
    "improvisez": [
        "improviser"
    ],
    "improvisions": [
        "improviser"
    ],
    "improvisons": [
        "improviser"
    ],
    "improviserent": [
        "improviser"
    ],
    "improvisee": [
        "improvise",
        "improviser"
    ],
    "improvisees": [
        "improvise",
        "improviser"
    ],
    "improvises": [
        "improvise",
        "improviser"
    ],
    "imprudemment": [
        "imprudemment"
    ],
    "imprudence": [
        "imprudence"
    ],
    "imprudences": [
        "imprudence"
    ],
    "imprudent": [
        "imprudent"
    ],
    "imprudente": [
        "imprudent"
    ],
    "imprudentes": [
        "imprudent"
    ],
    "imprudents": [
        "imprudent"
    ],
    "impregne": [
        "impregner",
        "impregne"
    ],
    "impregnent": [
        "impregner"
    ],
    "imprecateur": [
        "imprecateur"
    ],
    "imprecation": [
        "imprecation"
    ],
    "imprecations": [
        "imprecation"
    ],
    "imprecis": [
        "imprecis"
    ],
    "imprecisable": [
        "imprecisable"
    ],
    "imprecise": [
        "imprecis"
    ],
    "imprecises": [
        "imprecis"
    ],
    "imprecision": [
        "imprecision"
    ],
    "imprecisions": [
        "imprecision"
    ],
    "impregna": [
        "impregner"
    ],
    "impregnaient": [
        "impregner"
    ],
    "impregnais": [
        "impregner"
    ],
    "impregnait": [
        "impregner"
    ],
    "impregnant": [
        "impregner",
        "impregnant"
    ],
    "impregnation": [
        "impregnation"
    ],
    "impregnations": [
        "impregnation"
    ],
    "impregner": [
        "impregner"
    ],
    "impregnez": [
        "impregner"
    ],
    "impregnerent": [
        "impregner"
    ],
    "impregnee": [
        "impregner",
        "impregne"
    ],
    "impregnees": [
        "impregner",
        "impregne"
    ],
    "impregnes": [
        "impregner",
        "impregne"
    ],
    "impreparation": [
        "impreparation"
    ],
    "impresentable": [
        "impresentable"
    ],
    "impresentables": [
        "impresentable"
    ],
    "imprevisibilite": [
        "imprevisibilite"
    ],
    "imprevisible": [
        "imprevisible"
    ],
    "imprevisiblement": [
        "imprevisiblement"
    ],
    "imprevisibles": [
        "imprevisible"
    ],
    "imprevision": [
        "imprevision"
    ],
    "imprevoyance": [
        "imprevoyance"
    ],
    "imprevoyant": [
        "imprevoyant"
    ],
    "imprevoyante": [
        "imprevoyant"
    ],
    "imprevoyants": [
        "imprevoyant"
    ],
    "imprevu": [
        "imprevu"
    ],
    "imprevue": [
        "imprevu"
    ],
    "imprevues": [
        "imprevu"
    ],
    "imprevus": [
        "imprevu"
    ],
    "impubliable": [
        "impubliable"
    ],
    "impubliables": [
        "impubliable"
    ],
    "impubere": [
        "impubere"
    ],
    "impuberes": [
        "impubere"
    ],
    "impudemment": [
        "impudemment"
    ],
    "impudence": [
        "impudence"
    ],
    "impudences": [
        "impudence"
    ],
    "impudent": [
        "impudent"
    ],
    "impudente": [
        "impudent"
    ],
    "impudentes": [
        "impudent"
    ],
    "impudents": [
        "impudent"
    ],
    "impudeur": [
        "impudeur"
    ],
    "impudeurs": [
        "impudeur"
    ],
    "impudicite": [
        "impudicite"
    ],
    "impudique": [
        "impudique"
    ],
    "impudiquement": [
        "impudiquement"
    ],
    "impudiques": [
        "impudique"
    ],
    "impuissance": [
        "impuissance"
    ],
    "impuissances": [
        "impuissance"
    ],
    "impuissant": [
        "impuissant"
    ],
    "impuissante": [
        "impuissant"
    ],
    "impuissantes": [
        "impuissant"
    ],
    "impuissants": [
        "impuissant"
    ],
    "impulsif": [
        "impulsif"
    ],
    "impulsifs": [
        "impulsif"
    ],
    "impulsion": [
        "impulsion"
    ],
    "impulsions": [
        "impulsion",
        "impulser"
    ],
    "impulsive": [
        "impulsive",
        "impulsif"
    ],
    "impulsivement": [
        "impulsivement"
    ],
    "impulsives": [
        "impulsif"
    ],
    "impulsivite": [
        "impulsivite"
    ],
    "impuni": [
        "impuni"
    ],
    "impunie": [
        "impuni"
    ],
    "impunis": [
        "impuni"
    ],
    "impunite": [
        "impunite"
    ],
    "impunement": [
        "impunement"
    ],
    "impur": [
        "impur"
    ],
    "impure": [
        "impur"
    ],
    "impures": [
        "impur"
    ],
    "impurete": [
        "impurete"
    ],
    "impuretes": [
        "impurete"
    ],
    "impurs": [
        "impur"
    ],
    "imputable": [
        "imputable"
    ],
    "imputables": [
        "imputable"
    ],
    "imputai": [
        "imputer"
    ],
    "imputaient": [
        "imputer"
    ],
    "imputais": [
        "imputer"
    ],
    "imputait": [
        "imputer"
    ],
    "imputant": [
        "imputer"
    ],
    "imputasse": [
        "imputer"
    ],
    "imputation": [
        "imputation"
    ],
    "imputations": [
        "imputation"
    ],
    "impute": [
        "imputer"
    ],
    "imputer": [
        "imputer"
    ],
    "imputera": [
        "imputer"
    ],
    "imputerai": [
        "imputer"
    ],
    "imputeront": [
        "imputer"
    ],
    "imputrescible": [
        "imputrescible"
    ],
    "imputrescibles": [
        "imputrescible"
    ],
    "imputat": [
        "imputer"
    ],
    "imputerent": [
        "imputer"
    ],
    "imputee": [
        "imputer"
    ],
    "imputees": [
        "imputer"
    ],
    "imputes": [
        "imputer"
    ],
    "impecunieuse": [
        "impecunieux"
    ],
    "impecunieux": [
        "impecunieux"
    ],
    "impecuniosite": [
        "impecuniosite"
    ],
    "impedance": [
        "impedance"
    ],
    "impenitent": [
        "impenitent"
    ],
    "impenitente": [
        "impenitent"
    ],
    "impenitents": [
        "impenitent"
    ],
    "impenetrabilite": [
        "impenetrabilite"
    ],
    "impenetrable": [
        "impenetrable"
    ],
    "impenetrables": [
        "impenetrable"
    ],
    "imperatif": [
        "imperatif"
    ],
    "imperatifs": [
        "imperatif"
    ],
    "imperative": [
        "imperatif"
    ],
    "imperativement": [
        "imperativement"
    ],
    "imperatives": [
        "imperative",
        "imperatif"
    ],
    "imperatrice": [
        "imperatrice"
    ],
    "imperatrices": [
        "imperatrice"
    ],
    "imperial": [
        "imperial"
    ],
    "imperiale": [
        "imperial",
        "imperiale"
    ],
    "imperiales": [
        "imperial",
        "imperiale"
    ],
    "imperialisation": [
        "imperialisation"
    ],
    "imperialisme": [
        "imperialisme"
    ],
    "imperialiste": [
        "imperialiste"
    ],
    "imperialistes": [
        "imperialiste"
    ],
    "imperiaux": [
        "imperial"
    ],
    "imperieuse": [
        "imperieux"
    ],
    "imperieusement": [
        "imperieusement"
    ],
    "imperieuses": [
        "imperieux"
    ],
    "imperieux": [
        "imperieux"
    ],
    "imperissable": [
        "imperissable"
    ],
    "imperissables": [
        "imperissable"
    ],
    "imperitie": [
        "imperitie"
    ],
    "impetigo": [
        "impetigo"
    ],
    "impetrant": [
        "impetrant"
    ],
    "impetrante": [
        "impetrant"
    ],
    "impetrants": [
        "impetrant"
    ],
    "impetueuse": [
        "impetueux"
    ],
    "impetueusement": [
        "impetueusement"
    ],
    "impetueuses": [
        "impetueux"
    ],
    "impetueux": [
        "impetueux"
    ],
    "impetuosite": [
        "impetuosite"
    ],
    "impot": [
        "impot"
    ],
    "impots": [
        "impot"
    ],
    "in": [
        "in"
    ],
    "inabordable": [
        "inabordable"
    ],
    "inabouti": [
        "inabouti"
    ],
    "inaboutie": [
        "inabouti"
    ],
    "inacceptable": [
        "inacceptable"
    ],
    "inacceptables": [
        "inacceptable"
    ],
    "inaccessibilite": [
        "inaccessibilite"
    ],
    "inaccessible": [
        "inaccessible"
    ],
    "inaccessibles": [
        "inaccessible"
    ],
    "inaccompli": [
        "inaccompli"
    ],
    "inaccomplis": [
        "inaccompli"
    ],
    "inaccomplissement": [
        "inaccomplissement"
    ],
    "inaccoutume": [
        "inaccoutume"
    ],
    "inaccoutumee": [
        "inaccoutume"
    ],
    "inaccoutumees": [
        "inaccoutume"
    ],
    "inacheve": [
        "inacheve"
    ],
    "inachevee": [
        "inacheve"
    ],
    "inachevees": [
        "inacheve"
    ],
    "inacheves": [
        "inacheve"
    ],
    "inachevement": [
        "inachevement"
    ],
    "inactif": [
        "inactif"
    ],
    "inactifs": [
        "inactif"
    ],
    "inaction": [
        "inaction"
    ],
    "inactivation": [
        "inactivation"
    ],
    "inactive": [
        "inactive",
        "inactif"
    ],
    "inactives": [
        "inactif"
    ],
    "inactivite": [
        "inactivite"
    ],
    "inactuel": [
        "inactuel"
    ],
    "inadaptable": [
        "inadaptable"
    ],
    "inadaptation": [
        "inadaptation"
    ],
    "inadapte": [
        "inadapte"
    ],
    "inadaptee": [
        "inadapte"
    ],
    "inadaptees": [
        "inadapte"
    ],
    "inadaptes": [
        "inadapte"
    ],
    "inadmissible": [
        "inadmissible"
    ],
    "inadmissibles": [
        "inadmissible"
    ],
    "inadvertance": [
        "inadvertance"
    ],
    "inadvertances": [
        "inadvertance"
    ],
    "inadequat": [
        "inadequat"
    ],
    "inadequate": [
        "inadequat"
    ],
    "inadequatement": [
        "inadequatement"
    ],
    "inadequates": [
        "inadequate",
        "inadequat"
    ],
    "inadequation": [
        "inadequation"
    ],
    "inadequats": [
        "inadequat"
    ],
    "inalienable": [
        "inalienable"
    ],
    "inalienables": [
        "inalienable"
    ],
    "inalterable": [
        "inalterable"
    ],
    "inalterables": [
        "inalterable"
    ],
    "inaltere": [
        "inaltere"
    ],
    "inalteree": [
        "inaltere"
    ],
    "inalterees": [
        "inaltere"
    ],
    "inalteres": [
        "inaltere"
    ],
    "inamical": [
        "inamical"
    ],
    "inamicale": [
        "inamical"
    ],
    "inamicaux": [
        "inamical"
    ],
    "inamovible": [
        "inamovible"
    ],
    "inamovibles": [
        "inamovible"
    ],
    "inanalysable": [
        "inanalysable"
    ],
    "inanalysables": [
        "inanalysable"
    ],
    "inane": [
        "inane"
    ],
    "inanimation": [
        "inanimation"
    ],
    "inanime": [
        "inanime"
    ],
    "inanimee": [
        "inanime"
    ],
    "inanimees": [
        "inanime"
    ],
    "inanimes": [
        "inanime"
    ],
    "inanition": [
        "inanition"
    ],
    "inanite": [
        "inanite"
    ],
    "inapaisable": [
        "inapaisable"
    ],
    "inapaisee": [
        "inapaise"
    ],
    "inapaisees": [
        "inapaise"
    ],
    "inapaises": [
        "inapaise"
    ],
    "inapercu": [
        "inapercu"
    ],
    "inapercue": [
        "inapercu"
    ],
    "inapercues": [
        "inapercu"
    ],
    "inapercus": [
        "inapercu"
    ],
    "inapplicable": [
        "inapplicable"
    ],
    "inapplicables": [
        "inapplicable"
    ],
    "inapplication": [
        "inapplication"
    ],
    "inapprivoisables": [
        "inapprivoisable"
    ],
    "inapprochable": [
        "inapprochable"
    ],
    "inapproprie": [
        "inapproprie"
    ],
    "inappropriee": [
        "inapproprie"
    ],
    "inappropriees": [
        "inapproprie"
    ],
    "inappropries": [
        "inapproprie"
    ],
    "inappreciable": [
        "inappreciable"
    ],
    "inappreciables": [
        "inappreciable"
    ],
    "inappreciee": [
        "inapprecie"
    ],
    "inappetence": [
        "inappetence"
    ],
    "inapte": [
        "inapte"
    ],
    "inaptes": [
        "inapte"
    ],
    "inaptitude": [
        "inaptitude"
    ],
    "inaptitudes": [
        "inaptitude"
    ],
    "inarrangeable": [
        "inarrangeable"
    ],
    "inarticule": [
        "inarticule"
    ],
    "inarticulee": [
        "inarticule"
    ],
    "inarticulees": [
        "inarticule"
    ],
    "inarticules": [
        "inarticule"
    ],
    "inassimilable": [
        "inassimilable"
    ],
    "inassimilables": [
        "inassimilable"
    ],
    "inassouvi": [
        "inassouvi"
    ],
    "inassouvie": [
        "inassouvi"
    ],
    "inassouvies": [
        "inassouvi"
    ],
    "inassouvis": [
        "inassouvi"
    ],
    "inassouvissable": [
        "inassouvissable"
    ],
    "inassouvissables": [
        "inassouvissable"
    ],
    "inassouvissement": [
        "inassouvissement"
    ],
    "inassurable": [
        "inassurable"
    ],
    "inattaquable": [
        "inattaquable"
    ],
    "inattaquables": [
        "inattaquable"
    ],
    "inatteignable": [
        "inatteignable"
    ],
    "inatteignables": [
        "inatteignable"
    ],
    "inattendu": [
        "inattendu"
    ],
    "inattendue": [
        "inattendu"
    ],
    "inattendues": [
        "inattendu"
    ],
    "inattendus": [
        "inattendu"
    ],
    "inattentif": [
        "inattentif"
    ],
    "inattentifs": [
        "inattentif"
    ],
    "inattention": [
        "inattention"
    ],
    "inattentive": [
        "inattentif"
    ],
    "inattentives": [
        "inattentif"
    ],
    "inattrapable": [
        "inattrapable"
    ],
    "inaudible": [
        "inaudible"
    ],
    "inaudibles": [
        "inaudible"
    ],
    "inaugura": [
        "inaugurer"
    ],
    "inaugurai": [
        "inaugurer"
    ],
    "inaugurais": [
        "inaugurer"
    ],
    "inaugurait": [
        "inaugurer"
    ],
    "inaugural": [
        "inaugural"
    ],
    "inaugurale": [
        "inaugural"
    ],
    "inaugurales": [
        "inaugural"
    ],
    "inaugurant": [
        "inaugurer"
    ],
    "inauguration": [
        "inauguration"
    ],
    "inaugurations": [
        "inauguration"
    ],
    "inaugure": [
        "inaugurer"
    ],
    "inaugurer": [
        "inaugurer"
    ],
    "inaugurera": [
        "inaugurer"
    ],
    "inaugurions": [
        "inaugurer"
    ],
    "inaugurons": [
        "inaugurer"
    ],
    "inaugurerent": [
        "inaugurer"
    ],
    "inauguree": [
        "inaugurer"
    ],
    "inaugures": [
        "inaugurer"
    ],
    "inauthenticite": [
        "inauthenticite"
    ],
    "inaverti": [
        "inaverti"
    ],
    "inavouable": [
        "inavouable"
    ],
    "inavouablement": [
        "inavouablement"
    ],
    "inavouables": [
        "inavouable"
    ],
    "inavoue": [
        "inavoue"
    ],
    "inavouee": [
        "inavoue"
    ],
    "inavouees": [
        "inavoue"
    ],
    "inavoues": [
        "inavoue"
    ],
    "inca": [
        "inca"
    ],
    "incalculable": [
        "incalculable"
    ],
    "incalculables": [
        "incalculable"
    ],
    "incandescence": [
        "incandescence"
    ],
    "incandescences": [
        "incandescence"
    ],
    "incandescent": [
        "incandescent"
    ],
    "incandescente": [
        "incandescent"
    ],
    "incandescentes": [
        "incandescent"
    ],
    "incandescents": [
        "incandescent"
    ],
    "incantation": [
        "incantation"
    ],
    "incantations": [
        "incantation"
    ],
    "incantatoire": [
        "incantatoire"
    ],
    "incantatoires": [
        "incantatoire"
    ],
    "incantatrice": [
        "incantateur"
    ],
    "incapable": [
        "incapable"
    ],
    "incapables": [
        "incapable"
    ],
    "incapacitant": [
        "incapacitant"
    ],
    "incapacitante": [
        "incapacitant"
    ],
    "incapacitants": [
        "incapacitant"
    ],
    "incapacite": [
        "incapacite"
    ],
    "incapacites": [
        "incapacite"
    ],
    "incarcere": [
        "incarcere",
        "incarcerer"
    ],
    "incarceration": [
        "incarceration"
    ],
    "incarcerer": [
        "incarcerer"
    ],
    "incarcerez": [
        "incarcerer"
    ],
    "incarceree": [
        "incarcere",
        "incarcerer"
    ],
    "incarcerees": [
        "incarcere",
        "incarcerer"
    ],
    "incarceres": [
        "incarcere",
        "incarcerer"
    ],
    "incarna": [
        "incarner"
    ],
    "incarnadines": [
        "incarnadin"
    ],
    "incarnai": [
        "incarner"
    ],
    "incarnaient": [
        "incarner"
    ],
    "incarnais": [
        "incarner"
    ],
    "incarnait": [
        "incarner"
    ],
    "incarnant": [
        "incarner"
    ],
    "incarnat": [
        "incarner",
        "incarnat"
    ],
    "incarnation": [
        "incarnation"
    ],
    "incarnations": [
        "incarnation"
    ],
    "incarne": [
        "incarner",
        "incarne"
    ],
    "incarnent": [
        "incarner"
    ],
    "incarner": [
        "incarner"
    ],
    "incarnera": [
        "incarner"
    ],
    "incarneraient": [
        "incarner"
    ],
    "incarnerais": [
        "incarner"
    ],
    "incarnerait": [
        "incarner"
    ],
    "incarnerez": [
        "incarner"
    ],
    "incarnes": [
        "incarner",
        "incarne"
    ],
    "incarnez": [
        "incarner"
    ],
    "incarniez": [
        "incarner"
    ],
    "incarnions": [
        "incarner"
    ],
    "incarnee": [
        "incarner",
        "incarne"
    ],
    "incarnees": [
        "incarner",
        "incarne"
    ],
    "incartade": [
        "incartade"
    ],
    "incartades": [
        "incartade"
    ],
    "incas": [
        "inca"
    ],
    "incassable": [
        "incassable"
    ],
    "incassables": [
        "incassable"
    ],
    "incendia": [
        "incendier"
    ],
    "incendiaient": [
        "incendier"
    ],
    "incendiaire": [
        "incendiaire"
    ],
    "incendiaires": [
        "incendiaire"
    ],
    "incendiait": [
        "incendier"
    ],
    "incendiant": [
        "incendier"
    ],
    "incendie": [
        "incendier",
        "incendie"
    ],
    "incendient": [
        "incendier"
    ],
    "incendier": [
        "incendier"
    ],
    "incendieras": [
        "incendier"
    ],
    "incendies": [
        "incendier",
        "incendie"
    ],
    "incendiez": [
        "incendier"
    ],
    "incendierent": [
        "incendier"
    ],
    "incendiee": [
        "incendier",
        "incendie"
    ],
    "incendiees": [
        "incendier",
        "incendie"
    ],
    "incernable": [
        "incernable"
    ],
    "incertain": [
        "incertain"
    ],
    "incertaine": [
        "incertain"
    ],
    "incertaines": [
        "incertain"
    ],
    "incertains": [
        "incertain"
    ],
    "incertitude": [
        "incertitude"
    ],
    "incertitudes": [
        "incertitude"
    ],
    "incessamment": [
        "incessamment"
    ],
    "incessant": [
        "incessant"
    ],
    "incessante": [
        "incessant"
    ],
    "incessantes": [
        "incessant"
    ],
    "incessants": [
        "incessant"
    ],
    "inceste": [
        "inceste"
    ],
    "incestes": [
        "inceste"
    ],
    "incestueuse": [
        "incestueux"
    ],
    "incestueuses": [
        "incestueux"
    ],
    "incestueux": [
        "incestueux"
    ],
    "inchangeable": [
        "inchangeable"
    ],
    "inchange": [
        "inchange"
    ],
    "inchangee": [
        "inchange"
    ],
    "inchangees": [
        "inchange"
    ],
    "inchanges": [
        "inchange"
    ],
    "inchavirable": [
        "inchavirable"
    ],
    "inchiffrable": [
        "inchiffrable"
    ],
    "incidemment": [
        "incidemment"
    ],
    "incidence": [
        "incidence"
    ],
    "incidences": [
        "incidence"
    ],
    "incident": [
        "incident"
    ],
    "incidente": [
        "incident"
    ],
    "incidentes": [
        "incident"
    ],
    "incidents": [
        "incident"
    ],
    "incinere": [
        "incinerer"
    ],
    "incinerait": [
        "incinerer"
    ],
    "incinerant": [
        "incinerer"
    ],
    "incinerateur": [
        "incinerateur"
    ],
    "incinerateurs": [
        "incinerateur"
    ],
    "incineration": [
        "incineration"
    ],
    "incinerer": [
        "incinerer"
    ],
    "incinerez": [
        "incinerer"
    ],
    "incineree": [
        "incinerer"
    ],
    "incineres": [
        "incinerer"
    ],
    "incirconcis": [
        "incirconcis"
    ],
    "incisa": [
        "inciser"
    ],
    "incisaient": [
        "inciser"
    ],
    "incisait": [
        "inciser"
    ],
    "incisant": [
        "inciser"
    ],
    "incise": [
        "incise",
        "inciser"
    ],
    "inciser": [
        "inciser"
    ],
    "incisera": [
        "inciser"
    ],
    "incises": [
        "incise",
        "inciser"
    ],
    "incisez": [
        "inciser"
    ],
    "incisif": [
        "incisif"
    ],
    "incisifs": [
        "incisif"
    ],
    "incision": [
        "incision"
    ],
    "incisions": [
        "incision"
    ],
    "incisive": [
        "incisive",
        "incisif"
    ],
    "incisives": [
        "incisive",
        "incisif"
    ],
    "incisee": [
        "inciser"
    ],
    "incisees": [
        "inciser"
    ],
    "incita": [
        "inciter"
    ],
    "incitaient": [
        "inciter"
    ],
    "incitait": [
        "inciter"
    ],
    "incitant": [
        "incitant",
        "inciter"
    ],
    "incitateur": [
        "incitateur"
    ],
    "incitatif": [
        "incitatif"
    ],
    "incitation": [
        "incitation"
    ],
    "incitatrice": [
        "incitateur"
    ],
    "incite": [
        "inciter"
    ],
    "incitent": [
        "inciter"
    ],
    "inciter": [
        "inciter"
    ],
    "incitera": [
        "inciter"
    ],
    "inciterai": [
        "inciter"
    ],
    "inciteraient": [
        "inciter"
    ],
    "inciterais": [
        "inciter"
    ],
    "inciterait": [
        "inciter"
    ],
    "inciteront": [
        "inciter"
    ],
    "incitez": [
        "inciter"
    ],
    "incitiez": [
        "inciter"
    ],
    "inciterent": [
        "inciter"
    ],
    "incitee": [
        "inciter"
    ],
    "incites": [
        "inciter",
        "incite"
    ],
    "incivil": [
        "incivil"
    ],
    "incivils": [
        "incivil"
    ],
    "inclassable": [
        "inclassable"
    ],
    "inclassables": [
        "inclassable"
    ],
    "inclina": [
        "incliner"
    ],
    "inclinable": [
        "inclinable"
    ],
    "inclinables": [
        "inclinable"
    ],
    "inclinai": [
        "incliner"
    ],
    "inclinaient": [
        "incliner"
    ],
    "inclinais": [
        "incliner"
    ],
    "inclinaison": [
        "inclinaison"
    ],
    "inclinaisons": [
        "inclinaison"
    ],
    "inclinait": [
        "incliner"
    ],
    "inclinant": [
        "incliner"
    ],
    "inclinante": [
        "inclinant"
    ],
    "inclination": [
        "inclination"
    ],
    "inclinations": [
        "inclination"
    ],
    "incline": [
        "incliner",
        "incline"
    ],
    "inclinent": [
        "incliner"
    ],
    "incliner": [
        "incliner"
    ],
    "inclinerai": [
        "incliner"
    ],
    "inclineraient": [
        "incliner"
    ],
    "inclinerais": [
        "incliner"
    ],
    "inclinerait": [
        "incliner"
    ],
    "inclineras": [
        "incliner"
    ],
    "inclinerez": [
        "incliner"
    ],
    "inclineront": [
        "incliner"
    ],
    "inclinez": [
        "incliner"
    ],
    "inclinions": [
        "incliner"
    ],
    "inclinometre": [
        "inclinometre"
    ],
    "inclinons": [
        "incliner"
    ],
    "inclinat": [
        "incliner"
    ],
    "inclinerent": [
        "incliner"
    ],
    "inclinee": [
        "incliner",
        "incline"
    ],
    "inclinees": [
        "incliner",
        "incline"
    ],
    "inclines": [
        "incliner",
        "incline"
    ],
    "incluais": [
        "inclure"
    ],
    "incluait": [
        "inclure"
    ],
    "incluant": [
        "inclure"
    ],
    "inclue": [
        "inclure"
    ],
    "incluent": [
        "inclure"
    ],
    "incluez": [
        "inclure"
    ],
    "incluons": [
        "inclure"
    ],
    "inclura": [
        "inclure"
    ],
    "inclurai": [
        "inclure"
    ],
    "inclurait": [
        "inclure"
    ],
    "inclure": [
        "inclure"
    ],
    "inclus": [
        "inclus",
        "inclure"
    ],
    "incluse": [
        "inclus"
    ],
    "incluses": [
        "inclus"
    ],
    "inclusion": [
        "inclusion"
    ],
    "inclusive": [
        "inclusif"
    ],
    "inclusivement": [
        "inclusivement"
    ],
    "inclut": [
        "inclure"
    ],
    "inclemence": [
        "inclemence"
    ],
    "inclemences": [
        "inclemence"
    ],
    "inclement": [
        "inclement"
    ],
    "inclemente": [
        "inclement"
    ],
    "incoercible": [
        "incoercible"
    ],
    "incoerciblement": [
        "incoerciblement"
    ],
    "incoercibles": [
        "incoercible"
    ],
    "incognito": [
        "incognito"
    ],
    "incognitos": [
        "incognito"
    ],
    "incoherence": [
        "incoherence"
    ],
    "incoherences": [
        "incoherence"
    ],
    "incoherent": [
        "incoherent"
    ],
    "incoherente": [
        "incoherent"
    ],
    "incoherentes": [
        "incoherent"
    ],
    "incoherents": [
        "incoherent"
    ],
    "incoiffables": [
        "incoiffable"
    ],
    "incollable": [
        "incollable"
    ],
    "incolore": [
        "incolore"
    ],
    "incolores": [
        "incolore"
    ],
    "incombaient": [
        "incomber"
    ],
    "incombait": [
        "incomber"
    ],
    "incombant": [
        "incomber"
    ],
    "incombe": [
        "incomber"
    ],
    "incombent": [
        "incomber"
    ],
    "incomber": [
        "incomber"
    ],
    "incombera": [
        "incomber"
    ],
    "incomberait": [
        "incomber"
    ],
    "incombustible": [
        "incombustible"
    ],
    "incombustibles": [
        "incombustible"
    ],
    "incomberent": [
        "incomber"
    ],
    "incomestible": [
        "incomestible"
    ],
    "incommensurable": [
        "incommensurable"
    ],
    "incommensurablement": [
        "incommensurablement"
    ],
    "incommensurables": [
        "incommensurable"
    ],
    "incommodait": [
        "incommoder"
    ],
    "incommodant": [
        "incommodant"
    ],
    "incommodante": [
        "incommodant"
    ],
    "incommodantes": [
        "incommodant"
    ],
    "incommode": [
        "incommode",
        "incommoder"
    ],
    "incommoder": [
        "incommoder"
    ],
    "incommodera": [
        "incommoder"
    ],
    "incommoderai": [
        "incommoder"
    ],
    "incommodes": [
        "incommode",
        "incommoder"
    ],
    "incommodez": [
        "incommoder"
    ],
    "incommodite": [
        "incommodite"
    ],
    "incommodites": [
        "incommodite"
    ],
    "incommodee": [
        "incommode",
        "incommoder"
    ],
    "incommodees": [
        "incommoder"
    ],
    "incommunicabilite": [
        "incommunicabilite"
    ],
    "incommunicable": [
        "incommunicable"
    ],
    "incommunicables": [
        "incommunicable"
    ],
    "incomparable": [
        "incomparable"
    ],
    "incomparablement": [
        "incomparablement"
    ],
    "incomparables": [
        "incomparable"
    ],
    "incompatibilite": [
        "incompatibilite"
    ],
    "incompatibilites": [
        "incompatibilite"
    ],
    "incompatible": [
        "incompatible"
    ],
    "incompatibles": [
        "incompatible"
    ],
    "incomplet": [
        "incomplet"
    ],
    "incomplets": [
        "incomplet"
    ],
    "incomplete": [
        "incomplet"
    ],
    "incompletement": [
        "incompletement"
    ],
    "incompletes": [
        "incomplet"
    ],
    "incompletude": [
        "incompletude"
    ],
    "incompressible": [
        "incompressible"
    ],
    "incompris": [
        "incompris"
    ],
    "incomprise": [
        "incompris"
    ],
    "incomprises": [
        "incompris"
    ],
    "incomprehensible": [
        "incomprehensible"
    ],
    "incomprehensiblement": [
        "incomprehensiblement"
    ],
    "incomprehensibles": [
        "incomprehensible"
    ],
    "incomprehensif": [
        "incomprehensif"
    ],
    "incomprehensifs": [
        "incomprehensif"
    ],
    "incomprehension": [
        "incomprehension"
    ],
    "incomprehensions": [
        "incomprehension"
    ],
    "incompetence": [
        "incompetence"
    ],
    "incompetences": [
        "incompetence"
    ],
    "incompetent": [
        "incompetent"
    ],
    "incompetente": [
        "incompetent"
    ],
    "incompetents": [
        "incompetent"
    ],
    "inconcevable": [
        "inconcevable"
    ],
    "inconcevablement": [
        "inconcevablement"
    ],
    "inconcevables": [
        "inconcevable"
    ],
    "inconciliable": [
        "inconciliable"
    ],
    "inconciliables": [
        "inconciliable"
    ],
    "inconditionnel": [
        "inconditionnel"
    ],
    "inconditionnelle": [
        "inconditionnel"
    ],
    "inconditionnellement": [
        "inconditionnellement"
    ],
    "inconditionnelles": [
        "inconditionnel"
    ],
    "inconditionnels": [
        "inconditionnel"
    ],
    "inconditionne": [
        "inconditionne"
    ],
    "inconditionnee": [
        "inconditionne"
    ],
    "inconduite": [
        "inconduite"
    ],
    "inconfiance": [
        "inconfiance"
    ],
    "inconfort": [
        "inconfort"
    ],
    "inconfortable": [
        "inconfortable"
    ],
    "inconfortablement": [
        "inconfortablement"
    ],
    "inconfortables": [
        "inconfortable"
    ],
    "incongelables": [
        "incongelable"
    ],
    "incongru": [
        "incongru"
    ],
    "incongrue": [
        "incongru"
    ],
    "incongrues": [
        "incongru"
    ],
    "incongruite": [
        "incongruite"
    ],
    "incongruites": [
        "incongruite"
    ],
    "incongrus": [
        "incongru"
    ],
    "inconnaissable": [
        "inconnaissable"
    ],
    "inconnaissance": [
        "inconnaissance"
    ],
    "inconnu": [
        "inconnu"
    ],
    "inconnue": [
        "inconnu"
    ],
    "inconnues": [
        "inconnu"
    ],
    "inconnus": [
        "inconnu"
    ],
    "inconsciemment": [
        "inconsciemment"
    ],
    "inconscience": [
        "inconscience"
    ],
    "inconsciences": [
        "inconscience"
    ],
    "inconscient": [
        "inconscient"
    ],
    "inconsciente": [
        "inconscient"
    ],
    "inconscientes": [
        "inconscient"
    ],
    "inconscients": [
        "inconscient"
    ],
    "inconsidere": [
        "inconsidere"
    ],
    "inconsideree": [
        "inconsidere"
    ],
    "inconsiderees": [
        "inconsidere"
    ],
    "inconsiderement": [
        "inconsiderement"
    ],
    "inconsideres": [
        "inconsidere"
    ],
    "inconsistance": [
        "inconsistance"
    ],
    "inconsistant": [
        "inconsistant"
    ],
    "inconsistante": [
        "inconsistant"
    ],
    "inconsistantes": [
        "inconsistant"
    ],
    "inconsistants": [
        "inconsistant"
    ],
    "inconsolable": [
        "inconsolable"
    ],
    "inconsolables": [
        "inconsolable"
    ],
    "inconsole": [
        "inconsole"
    ],
    "inconsolee": [
        "inconsole"
    ],
    "inconsolees": [
        "inconsole"
    ],
    "inconsoles": [
        "inconsole"
    ],
    "inconsommable": [
        "inconsommable"
    ],
    "inconstance": [
        "inconstance"
    ],
    "inconstant": [
        "inconstant"
    ],
    "inconstante": [
        "inconstant"
    ],
    "inconstants": [
        "inconstant"
    ],
    "inconstitutionnel": [
        "inconstitutionnel"
    ],
    "inconstitutionnelle": [
        "inconstitutionnel"
    ],
    "inconstructibles": [
        "inconstructible"
    ],
    "inconsequence": [
        "inconsequence"
    ],
    "inconsequences": [
        "inconsequence"
    ],
    "inconsequent": [
        "inconsequent"
    ],
    "inconsequente": [
        "inconsequent"
    ],
    "inconsequents": [
        "inconsequent"
    ],
    "incontestable": [
        "incontestable"
    ],
    "incontestablement": [
        "incontestablement"
    ],
    "incontestables": [
        "incontestable"
    ],
    "inconteste": [
        "inconteste"
    ],
    "incontestee": [
        "inconteste"
    ],
    "incontestes": [
        "inconteste"
    ],
    "incontinence": [
        "incontinence"
    ],
    "incontinences": [
        "incontinence"
    ],
    "incontinent": [
        "incontinent"
    ],
    "incontinente": [
        "incontinent"
    ],
    "incontinentes": [
        "incontinent"
    ],
    "incontinents": [
        "incontinent"
    ],
    "incontournable": [
        "incontournable"
    ],
    "incontournables": [
        "incontournable"
    ],
    "incontrolable": [
        "incontrolable"
    ],
    "incontrolables": [
        "incontrolable"
    ],
    "incontrole": [
        "incontrole"
    ],
    "incontrolee": [
        "incontrole"
    ],
    "incontrolees": [
        "incontrole"
    ],
    "incontroles": [
        "incontrole"
    ],
    "inconvenance": [
        "inconvenance"
    ],
    "inconvenances": [
        "inconvenance"
    ],
    "inconvenant": [
        "inconvenant"
    ],
    "inconvenante": [
        "inconvenant"
    ],
    "inconvenantes": [
        "inconvenant"
    ],
    "inconvenants": [
        "inconvenant"
    ],
    "inconvertible": [
        "inconvertible"
    ],
    "inconvertissable": [
        "inconvertissable"
    ],
    "inconvenient": [
        "inconvenient"
    ],
    "inconvenients": [
        "inconvenient"
    ],
    "incoordination": [
        "incoordination"
    ],
    "incorpora": [
        "incorporer"
    ],
    "incorporable": [
        "incorporable"
    ],
    "incorporaient": [
        "incorporer"
    ],
    "incorporait": [
        "incorporer"
    ],
    "incorporant": [
        "incorporer"
    ],
    "incorporation": [
        "incorporation"
    ],
    "incorporations": [
        "incorporation"
    ],
    "incorpore": [
        "incorporer"
    ],
    "incorporel": [
        "incorporel"
    ],
    "incorporelle": [
        "incorporel"
    ],
    "incorporelles": [
        "incorporel"
    ],
    "incorporent": [
        "incorporer"
    ],
    "incorporer": [
        "incorporer"
    ],
    "incorporez": [
        "incorporer"
    ],
    "incorporee": [
        "incorporer"
    ],
    "incorporees": [
        "incorporer"
    ],
    "incorpores": [
        "incorporer"
    ],
    "incorrect": [
        "incorrect"
    ],
    "incorrecte": [
        "incorrect"
    ],
    "incorrectement": [
        "incorrectement"
    ],
    "incorrection": [
        "incorrection"
    ],
    "incorrects": [
        "incorrect"
    ],
    "incorrigible": [
        "incorrigible"
    ],
    "incorrigiblement": [
        "incorrigiblement"
    ],
    "incorrigibles": [
        "incorrigible"
    ],
    "incorruptibilite": [
        "incorruptibilite"
    ],
    "incorruptible": [
        "incorruptible"
    ],
    "incorruptibles": [
        "incorruptible"
    ],
    "increvable": [
        "increvable"
    ],
    "increvables": [
        "increvable"
    ],
    "incrimina": [
        "incriminer"
    ],
    "incriminant": [
        "incriminer"
    ],
    "incrimination": [
        "incrimination"
    ],
    "incrimine": [
        "incriminer"
    ],
    "incriminent": [
        "incriminer"
    ],
    "incriminer": [
        "incriminer"
    ],
    "incriminee": [
        "incriminer"
    ],
    "incriminees": [
        "incriminer"
    ],
    "incrochetable": [
        "incrochetable"
    ],
    "incroyable": [
        "incroyable"
    ],
    "incroyablement": [
        "incroyablement"
    ],
    "incroyables": [
        "incroyable"
    ],
    "incroyance": [
        "incroyance"
    ],
    "incroyant": [
        "incroyant"
    ],
    "incroyante": [
        "incroyant"
    ],
    "incroyants": [
        "incroyant"
    ],
    "incrusta": [
        "incruster"
    ],
    "incrustaient": [
        "incruster"
    ],
    "incrustais": [
        "incruster"
    ],
    "incrustait": [
        "incruster"
    ],
    "incrustant": [
        "incruster"
    ],
    "incrustation": [
        "incrustation"
    ],
    "incrustations": [
        "incrustation"
    ],
    "incruste": [
        "incruster"
    ],
    "incrustent": [
        "incruster"
    ],
    "incruster": [
        "incruster"
    ],
    "incrusterait": [
        "incruster"
    ],
    "incrustez": [
        "incruster"
    ],
    "incrusterent": [
        "incruster"
    ],
    "incrustee": [
        "incruster"
    ],
    "incrustees": [
        "incruster"
    ],
    "incrustes": [
        "incruster"
    ],
    "incredibilite": [
        "incredibilite"
    ],
    "incredule": [
        "incredule"
    ],
    "incredules": [
        "incredule"
    ],
    "incredulite": [
        "incredulite"
    ],
    "incree": [
        "incree"
    ],
    "increee": [
        "incree"
    ],
    "incubateur": [
        "incubateur"
    ],
    "incubateurs": [
        "incubateur"
    ],
    "incubation": [
        "incubation"
    ],
    "incube": [
        "incuber",
        "incube"
    ],
    "incuber": [
        "incuber"
    ],
    "incubes": [
        "incube"
    ],
    "inculcation": [
        "inculcation"
    ],
    "inculpa": [
        "inculper"
    ],
    "inculpant": [
        "inculper"
    ],
    "inculpation": [
        "inculpation"
    ],
    "inculpations": [
        "inculpation"
    ],
    "inculpe": [
        "inculper",
        "inculpe"
    ],
    "inculpent": [
        "inculper"
    ],
    "inculper": [
        "inculper"
    ],
    "inculpera": [
        "inculper"
    ],
    "inculperai": [
        "inculper"
    ],
    "inculperais": [
        "inculper"
    ],
    "inculperont": [
        "inculper"
    ],
    "inculpez": [
        "inculper"
    ],
    "inculpons": [
        "inculper"
    ],
    "inculpee": [
        "inculper",
        "inculpe"
    ],
    "inculpes": [
        "inculper",
        "inculpe"
    ],
    "inculqua": [
        "inculquer"
    ],
    "inculquait": [
        "inculquer"
    ],
    "inculquant": [
        "inculquer"
    ],
    "inculque": [
        "inculquer"
    ],
    "inculquent": [
        "inculquer"
    ],
    "inculquer": [
        "inculquer"
    ],
    "inculquons": [
        "inculquer"
    ],
    "inculquat": [
        "inculquer"
    ],
    "inculquee": [
        "inculquer"
    ],
    "inculquees": [
        "inculquer"
    ],
    "inculques": [
        "inculquer"
    ],
    "inculte": [
        "inculte"
    ],
    "incultes": [
        "inculte"
    ],
    "incultivable": [
        "incultivable"
    ],
    "incultivables": [
        "incultivable"
    ],
    "inculture": [
        "inculture"
    ],
    "incunables": [
        "incunable"
    ],
    "incurable": [
        "incurable"
    ],
    "incurablement": [
        "incurablement"
    ],
    "incurables": [
        "incurable"
    ],
    "incurie": [
        "incurie"
    ],
    "incurieux": [
        "incurieux"
    ],
    "incuriosite": [
        "incuriosite"
    ],
    "incursion": [
        "incursion"
    ],
    "incursions": [
        "incursion"
    ],
    "incurvaient": [
        "incurver"
    ],
    "incurvait": [
        "incurver"
    ],
    "incurvant": [
        "incurver"
    ],
    "incurvation": [
        "incurvation"
    ],
    "incurve": [
        "incurver",
        "incurve"
    ],
    "incurvent": [
        "incurver"
    ],
    "incurver": [
        "incurver"
    ],
    "incurverent": [
        "incurver"
    ],
    "incurvee": [
        "incurver",
        "incurve"
    ],
    "incurvees": [
        "incurver",
        "incurve"
    ],
    "incurves": [
        "incurver",
        "incurve"
    ],
    "incus": [
        "incus"
    ],
    "indansable": [
        "indansable"
    ],
    "inde": [
        "inde"
    ],
    "indemne": [
        "indemne"
    ],
    "indemnes": [
        "indemne"
    ],
    "indemnisable": [
        "indemnisable"
    ],
    "indemnisation": [
        "indemnisation"
    ],
    "indemnisations": [
        "indemnisation"
    ],
    "indemnise": [
        "indemniser"
    ],
    "indemniser": [
        "indemniser"
    ],
    "indemniserai": [
        "indemniser"
    ],
    "indemniseraient": [
        "indemniser"
    ],
    "indemnisez": [
        "indemniser"
    ],
    "indemnises": [
        "indemniser"
    ],
    "indemnite": [
        "indemnite"
    ],
    "indemnites": [
        "indemnite"
    ],
    "indentation": [
        "indentation"
    ],
    "indenter": [
        "indenter"
    ],
    "indentification": [
        "indentification"
    ],
    "indente": [
        "indenter"
    ],
    "indes": [
        "inde"
    ],
    "indescriptible": [
        "indescriptible"
    ],
    "indescriptiblement": [
        "indescriptiblement"
    ],
    "indescriptibles": [
        "indescriptible"
    ],
    "indestructibilite": [
        "indestructibilite"
    ],
    "indestructible": [
        "indestructible"
    ],
    "indestructibles": [
        "indestructible"
    ],
    "index": [
        "index"
    ],
    "indexation": [
        "indexation"
    ],
    "indexer": [
        "indexer"
    ],
    "indexeur": [
        "indexeur"
    ],
    "indexe": [
        "indexer"
    ],
    "indexee": [
        "indexer"
    ],
    "indianises": [
        "indianiser"
    ],
    "indic": [
        "indic"
    ],
    "indicateur": [
        "indicateur"
    ],
    "indicateurs": [
        "indicateur"
    ],
    "indicatif": [
        "indicatif"
    ],
    "indicatifs": [
        "indicatif"
    ],
    "indication": [
        "indication"
    ],
    "indications": [
        "indication"
    ],
    "indicatrice": [
        "indicateur"
    ],
    "indicatrices": [
        "indicateur"
    ],
    "indice": [
        "indice"
    ],
    "indices": [
        "index",
        "indice"
    ],
    "indiciaire": [
        "indiciaire"
    ],
    "indiciaires": [
        "indiciaire"
    ],
    "indicible": [
        "indicible"
    ],
    "indiciblement": [
        "indiciblement"
    ],
    "indicibles": [
        "indicible"
    ],
    "indics": [
        "indic"
    ],
    "indien": [
        "indien"
    ],
    "indienne": [
        "indien"
    ],
    "indienneries": [
        "indiennerie"
    ],
    "indiennes": [
        "indien"
    ],
    "indiens": [
        "indien"
    ],
    "indiffere": [
        "indifferer"
    ],
    "indifferent": [
        "indifferent",
        "indifferer"
    ],
    "indifferes": [
        "indifferer"
    ],
    "indifferaient": [
        "indifferer"
    ],
    "indifferait": [
        "indifferer"
    ],
    "indifferemment": [
        "indifferemment"
    ],
    "indifference": [
        "indifference"
    ],
    "indifferences": [
        "indifference"
    ],
    "indifferenciation": [
        "indifferenciation"
    ],
    "indifferencie": [
        "indifferencie"
    ],
    "indifferenciee": [
        "indifferencier",
        "indifferencie"
    ],
    "indifferencies": [
        "indifferencie"
    ],
    "indifferente": [
        "indifferent"
    ],
    "indifferentes": [
        "indifferent"
    ],
    "indifferentisme": [
        "indifferentisme"
    ],
    "indifferents": [
        "indifferent"
    ],
    "indigence": [
        "indigence"
    ],
    "indigent": [
        "indigent"
    ],
    "indigente": [
        "indigent"
    ],
    "indigentes": [
        "indigent"
    ],
    "indigents": [
        "indigent"
    ],
    "indigeste": [
        "indigeste"
    ],
    "indigestes": [
        "indigeste"
    ],
    "indigestion": [
        "indigestion"
    ],
    "indigestionner": [
        "indigestionner"
    ],
    "indigestions": [
        "indigestion"
    ],
    "indigna": [
        "indigner"
    ],
    "indignai": [
        "indigner"
    ],
    "indignaient": [
        "indigner"
    ],
    "indignais": [
        "indigner"
    ],
    "indignait": [
        "indigner"
    ],
    "indignant": [
        "indigner"
    ],
    "indignassent": [
        "indigner"
    ],
    "indignation": [
        "indignation"
    ],
    "indignations": [
        "indignation"
    ],
    "indigne": [
        "indigne",
        "indigner"
    ],
    "indignement": [
        "indignement"
    ],
    "indignent": [
        "indigner"
    ],
    "indigner": [
        "indigner"
    ],
    "indignera": [
        "indigner"
    ],
    "indignes": [
        "indigne",
        "indigner"
    ],
    "indignite": [
        "indignite"
    ],
    "indignites": [
        "indignite"
    ],
    "indignerent": [
        "indigner"
    ],
    "indignee": [
        "indigne",
        "indigner"
    ],
    "indignees": [
        "indigne",
        "indigner"
    ],
    "indigo": [
        "indigo"
    ],
    "indigene": [
        "indigene"
    ],
    "indigenes": [
        "indigene"
    ],
    "indiqua": [
        "indiquer"
    ],
    "indiquai": [
        "indiquer"
    ],
    "indiquaient": [
        "indiquer"
    ],
    "indiquais": [
        "indiquer"
    ],
    "indiquait": [
        "indiquer"
    ],
    "indiquant": [
        "indiquer"
    ],
    "indique": [
        "indiquer",
        "indique"
    ],
    "indiquent": [
        "indiquer"
    ],
    "indiquer": [
        "indiquer"
    ],
    "indiquera": [
        "indiquer"
    ],
    "indiquerai": [
        "indiquer"
    ],
    "indiqueraient": [
        "indiquer"
    ],
    "indiquerais": [
        "indiquer"
    ],
    "indiquerait": [
        "indiquer"
    ],
    "indiqueras": [
        "indiquer"
    ],
    "indiquerez": [
        "indiquer"
    ],
    "indiqueriez": [
        "indiquer"
    ],
    "indiquerons": [
        "indiquer"
    ],
    "indiquez": [
        "indiquer"
    ],
    "indiquiez": [
        "indiquer"
    ],
    "indiquions": [
        "indiquer"
    ],
    "indiquons": [
        "indiquer"
    ],
    "indiquat": [
        "indiquer"
    ],
    "indiquerent": [
        "indiquer"
    ],
    "indiquee": [
        "indiquer",
        "indique"
    ],
    "indiquees": [
        "indiquer",
        "indique"
    ],
    "indiques": [
        "indiquer",
        "indique"
    ],
    "indirect": [
        "indirect"
    ],
    "indirecte": [
        "indirect"
    ],
    "indirectement": [
        "indirectement"
    ],
    "indirectes": [
        "indirect"
    ],
    "indirects": [
        "indirect"
    ],
    "indiscernable": [
        "indiscernable"
    ],
    "indiscernables": [
        "indiscernable"
    ],
    "indiscipline": [
        "indiscipline"
    ],
    "indisciplinee": [
        "indiscipline"
    ],
    "indisciplinees": [
        "indiscipline"
    ],
    "indisciplines": [
        "indiscipline"
    ],
    "indiscret": [
        "indiscret"
    ],
    "indiscrets": [
        "indiscret"
    ],
    "indiscrete": [
        "indiscrete",
        "indiscret"
    ],
    "indiscretement": [
        "indiscretement"
    ],
    "indiscretes": [
        "indiscret"
    ],
    "indiscretion": [
        "indiscretion"
    ],
    "indiscretions": [
        "indiscretion"
    ],
    "indiscutable": [
        "indiscutable"
    ],
    "indiscutablement": [
        "indiscutablement"
    ],
    "indiscutables": [
        "indiscutable"
    ],
    "indiscute": [
        "indiscute"
    ],
    "indiscutee": [
        "indiscute"
    ],
    "indiscutes": [
        "indiscute"
    ],
    "indispensable": [
        "indispensable"
    ],
    "indispensables": [
        "indispensable"
    ],
    "indisponibilite": [
        "indisponibilite"
    ],
    "indisponible": [
        "indisponible"
    ],
    "indisponibles": [
        "indisponible"
    ],
    "indisposa": [
        "indisposer"
    ],
    "indisposaient": [
        "indisposer"
    ],
    "indisposait": [
        "indisposer"
    ],
    "indispose": [
        "indispos",
        "indisposer",
        "indispose"
    ],
    "indisposent": [
        "indisposer"
    ],
    "indisposer": [
        "indisposer"
    ],
    "indisposerait": [
        "indisposer"
    ],
    "indisposition": [
        "indisposition"
    ],
    "indisposons": [
        "indisposer"
    ],
    "indisposerent": [
        "indisposer"
    ],
    "indisposee": [
        "indispose",
        "indisposer"
    ],
    "indisposes": [
        "indisposer"
    ],
    "indissociable": [
        "indissociable"
    ],
    "indissociables": [
        "indissociable"
    ],
    "indissocies": [
        "indissocie"
    ],
    "indissoluble": [
        "indissoluble"
    ],
    "indissolublement": [
        "indissolublement"
    ],
    "indissolubles": [
        "indissoluble"
    ],
    "indistinct": [
        "indistinct"
    ],
    "indistincte": [
        "indistinct"
    ],
    "indistinctement": [
        "indistinctement"
    ],
    "indistinctes": [
        "indistinct"
    ],
    "indistinction": [
        "indistinction"
    ],
    "indistincts": [
        "indistinct"
    ],
    "individu": [
        "individu"
    ],
    "individualiser": [
        "individualiser"
    ],
    "individualisme": [
        "individualisme"
    ],
    "individualiste": [
        "individualiste"
    ],
    "individualistes": [
        "individualiste"
    ],
    "individualise": [
        "individualiser",
        "individualise"
    ],
    "individualises": [
        "individualiser"
    ],
    "individualite": [
        "individualite"
    ],
    "individualites": [
        "individualite"
    ],
    "individuel": [
        "individuel"
    ],
    "individuelle": [
        "individuel"
    ],
    "individuellement": [
        "individuellement"
    ],
    "individuelles": [
        "individuel"
    ],
    "individuels": [
        "individuel"
    ],
    "individus": [
        "individu"
    ],
    "individuee": [
        "individue"
    ],
    "indivis": [
        "indivis"
    ],
    "indivises": [
        "indivis"
    ],
    "indivisibilite": [
        "indivisibilite"
    ],
    "indivisible": [
        "indivisible"
    ],
    "indivisibles": [
        "indivisible"
    ],
    "indivision": [
        "indivision"
    ],
    "indivise": [
        "indivise"
    ],
    "indo": [
        "indo"
    ],
    "indochinois": [
        "indochinois"
    ],
    "indochinoise": [
        "indochinois"
    ],
    "indochinoises": [
        "indochinois"
    ],
    "indocile": [
        "indocile"
    ],
    "indocilite": [
        "indocilite"
    ],
    "indole": [
        "indole"
    ],
    "indolemment": [
        "indolemment"
    ],
    "indolence": [
        "indolence"
    ],
    "indolences": [
        "indolence"
    ],
    "indolent": [
        "indolent"
    ],
    "indolente": [
        "indolent"
    ],
    "indolentes": [
        "indolent"
    ],
    "indolents": [
        "indolent"
    ],
    "indolore": [
        "indolore"
    ],
    "indolores": [
        "indolore"
    ],
    "indomptable": [
        "indomptable"
    ],
    "indomptables": [
        "indomptable"
    ],
    "indompte": [
        "indompte"
    ],
    "indomptee": [
        "indompte"
    ],
    "indomptes": [
        "indompte"
    ],
    "indonesien": [
        "indonesien"
    ],
    "indonesienne": [
        "indonesien"
    ],
    "indonesiens": [
        "indonesien"
    ],
    "indoor": [
        "indoor"
    ],
    "indosable": [
        "indosable"
    ],
    "indou": [
        "indou"
    ],
    "indous": [
        "indou"
    ],
    "indu": [
        "indu"
    ],
    "indubitable": [
        "indubitable"
    ],
    "indubitablement": [
        "indubitablement"
    ],
    "indubitables": [
        "indubitable"
    ],
    "inducteur": [
        "inducteur"
    ],
    "inductif": [
        "inductif"
    ],
    "induction": [
        "induction"
    ],
    "inductions": [
        "induction"
    ],
    "inductive": [
        "inductif"
    ],
    "inductrice": [
        "inducteur"
    ],
    "indue": [
        "indu"
    ],
    "indues": [
        "indu"
    ],
    "induiraient": [
        "induire"
    ],
    "induirait": [
        "induire"
    ],
    "induire": [
        "induire"
    ],
    "induis": [
        "induire"
    ],
    "induisaient": [
        "induire"
    ],
    "induisait": [
        "induire"
    ],
    "induisant": [
        "induire"
    ],
    "induisez": [
        "induire"
    ],
    "induisit": [
        "induire"
    ],
    "induit": [
        "induire",
        "induit"
    ],
    "induite": [
        "induire",
        "induit"
    ],
    "induits": [
        "induire"
    ],
    "indulgence": [
        "indulgence"
    ],
    "indulgences": [
        "indulgence"
    ],
    "indulgent": [
        "indulgent"
    ],
    "indulgente": [
        "indulgent"
    ],
    "indulgentes": [
        "indulgent"
    ],
    "indulgents": [
        "indulgent"
    ],
    "indure": [
        "indurer"
    ],
    "induree": [
        "indure"
    ],
    "indurees": [
        "indurer"
    ],
    "indus": [
        "indu"
    ],
    "industrialisation": [
        "industrialisation"
    ],
    "industrialiser": [
        "industrialiser"
    ],
    "industrialise": [
        "industrialise",
        "industrialiser"
    ],
    "industrialisee": [
        "industrialise",
        "industrialiser"
    ],
    "industrialises": [
        "industrialise"
    ],
    "industrie": [
        "industrie"
    ],
    "industriel": [
        "industriel"
    ],
    "industrielle": [
        "industriel"
    ],
    "industriellement": [
        "industriellement"
    ],
    "industrielles": [
        "industriel"
    ],
    "industriels": [
        "industriel"
    ],
    "industries": [
        "industrie",
        "industry"
    ],
    "industrieuse": [
        "industrieux"
    ],
    "industrieusement": [
        "industrieusement"
    ],
    "industrieuses": [
        "industrieux"
    ],
    "industrieux": [
        "industrieux"
    ],
    "indecelable": [
        "indecelable"
    ],
    "indecelables": [
        "indecelable"
    ],
    "indecemment": [
        "indecemment"
    ],
    "indecence": [
        "indecence"
    ],
    "indecences": [
        "indecence"
    ],
    "indecent": [
        "indecent"
    ],
    "indecente": [
        "indecent"
    ],
    "indecentes": [
        "indecent"
    ],
    "indecents": [
        "indecent"
    ],
    "indechiffrable": [
        "indechiffrable"
    ],
    "indechiffrables": [
        "indechiffrable"
    ],
    "indechirable": [
        "indechirable"
    ],
    "indechirables": [
        "indechirable"
    ],
    "indecidable": [
        "indecidable"
    ],
    "indecidables": [
        "indecidable"
    ],
    "indecis": [
        "indecis"
    ],
    "indecise": [
        "indecis",
        "indecise"
    ],
    "indecises": [
        "indecis",
        "indecises"
    ],
    "indecision": [
        "indecision"
    ],
    "indecisions": [
        "indecision"
    ],
    "indecodable": [
        "indecodable"
    ],
    "indecollable": [
        "indecollable"
    ],
    "indecollables": [
        "indecollable"
    ],
    "indecrassables": [
        "indecrassable"
    ],
    "indecrottable": [
        "indecrottable"
    ],
    "indecrottablement": [
        "indecrottablement"
    ],
    "indecrottables": [
        "indecrottable"
    ],
    "indefectible": [
        "indefectible"
    ],
    "indefectiblement": [
        "indefectiblement"
    ],
    "indefectibles": [
        "indefectible"
    ],
    "indefendable": [
        "indefendable"
    ],
    "indefini": [
        "indefini"
    ],
    "indefinie": [
        "indefini"
    ],
    "indefinies": [
        "indefini"
    ],
    "indefiniment": [
        "indefiniment"
    ],
    "indefinis": [
        "indefini"
    ],
    "indefinissable": [
        "indefinissable"
    ],
    "indefinissablement": [
        "indefinissablement"
    ],
    "indefinissables": [
        "indefinissable"
    ],
    "indefinition": [
        "indefinition"
    ],
    "indeformables": [
        "indeformable"
    ],
    "indefriche": [
        "indefriche"
    ],
    "indefrisable": [
        "indefrisable"
    ],
    "indefrisables": [
        "indefrisable"
    ],
    "indelicat": [
        "indelicat"
    ],
    "indelicate": [
        "indelicat"
    ],
    "indelicatesse": [
        "indelicatesse"
    ],
    "indelicatesses": [
        "indelicatesse"
    ],
    "indelicats": [
        "indelicat"
    ],
    "indelivrable": [
        "indelivrable"
    ],
    "indelogeable": [
        "indelogeable"
    ],
    "indelogeables": [
        "indelogeable"
    ],
    "indelebile": [
        "indelebile"
    ],
    "indelebiles": [
        "indelebile"
    ],
    "indemaillable": [
        "indemaillable"
    ],
    "indemaillables": [
        "indemaillable"
    ],
    "indemodable": [
        "indemodable"
    ],
    "indemodables": [
        "indemodable"
    ],
    "indemontrable": [
        "indemontrable"
    ],
    "indemontrables": [
        "indemontrable"
    ],
    "indemelables": [
        "indemelable"
    ],
    "indeniable": [
        "indeniable"
    ],
    "indeniablement": [
        "indeniablement"
    ],
    "indeniables": [
        "indeniable"
    ],
    "indenombrables": [
        "indenombrable"
    ],
    "indenouable": [
        "indenouable"
    ],
    "indepassable": [
        "indepassable"
    ],
    "independamment": [
        "independamment"
    ],
    "independance": [
        "independance"
    ],
    "independant": [
        "independant"
    ],
    "independante": [
        "independant"
    ],
    "independantes": [
        "independant"
    ],
    "independantisme": [
        "independantisme"
    ],
    "independantiste": [
        "independantiste"
    ],
    "independantistes": [
        "independantiste"
    ],
    "independants": [
        "independant"
    ],
    "inderacinable": [
        "inderacinable"
    ],
    "inderacinables": [
        "inderacinable"
    ],
    "indereglables": [
        "indereglable"
    ],
    "indesirable": [
        "indesirable"
    ],
    "indesirables": [
        "indesirable"
    ],
    "indetectable": [
        "indetectable"
    ],
    "indetectables": [
        "indetectable"
    ],
    "indeterminable": [
        "indeterminable"
    ],
    "indetermination": [
        "indetermination"
    ],
    "indetermine": [
        "indetermine"
    ],
    "indeterminee": [
        "indetermine"
    ],
    "indeterminees": [
        "indetermine"
    ],
    "indetermines": [
        "indetermine"
    ],
    "indument": [
        "indument"
    ],
    "ineffable": [
        "ineffable"
    ],
    "ineffablement": [
        "ineffablement"
    ],
    "ineffables": [
        "ineffable"
    ],
    "ineffacable": [
        "ineffacable"
    ],
    "ineffacablement": [
        "ineffacablement"
    ],
    "ineffacables": [
        "ineffacable"
    ],
    "inefficace": [
        "inefficace"
    ],
    "inefficaces": [
        "inefficace"
    ],
    "inefficacite": [
        "inefficacite"
    ],
    "inemploi": [
        "inemploi"
    ],
    "inemployable": [
        "inemployable"
    ],
    "inemployables": [
        "inemployable"
    ],
    "inemploye": [
        "inemploye"
    ],
    "inemployee": [
        "inemploye"
    ],
    "inemployees": [
        "inemploye"
    ],
    "inemployes": [
        "inemploye"
    ],
    "inentamable": [
        "inentamable"
    ],
    "inentame": [
        "inentame"
    ],
    "inentamee": [
        "inentame"
    ],
    "inentamees": [
        "inentame"
    ],
    "inenvisageable": [
        "inenvisageable"
    ],
    "inepte": [
        "inepte"
    ],
    "ineptement": [
        "ineptement"
    ],
    "ineptes": [
        "inepte"
    ],
    "ineptie": [
        "ineptie"
    ],
    "inepties": [
        "ineptie"
    ],
    "inerte": [
        "inerte"
    ],
    "inertes": [
        "inerte"
    ],
    "inertie": [
        "inertie"
    ],
    "inertiel": [
        "inertiel"
    ],
    "inertielle": [
        "inertiel"
    ],
    "inerties": [
        "inertie"
    ],
    "inespoir": [
        "inespoir"
    ],
    "inesperable": [
        "inesperable"
    ],
    "inespere": [
        "inespere"
    ],
    "inesperee": [
        "inespere"
    ],
    "inesperees": [
        "inespere"
    ],
    "inesperement": [
        "inesperement"
    ],
    "inessentiel": [
        "inessentiel"
    ],
    "inesthetique": [
        "inesthetique"
    ],
    "inesthetiques": [
        "inesthetique"
    ],
    "inestimable": [
        "inestimable"
    ],
    "inestimables": [
        "inestimable"
    ],
    "inexact": [
        "inexact"
    ],
    "inexacte": [
        "inexact"
    ],
    "inexactement": [
        "inexactement"
    ],
    "inexactes": [
        "inexact"
    ],
    "inexactitude": [
        "inexactitude"
    ],
    "inexactitudes": [
        "inexactitude"
    ],
    "inexacts": [
        "inexact"
    ],
    "inexcusable": [
        "inexcusable"
    ],
    "inexcusables": [
        "inexcusable"
    ],
    "inexistant": [
        "inexistant"
    ],
    "inexistante": [
        "inexistant"
    ],
    "inexistantes": [
        "inexistant"
    ],
    "inexistants": [
        "inexistant"
    ],
    "inexistence": [
        "inexistence"
    ],
    "inexorabilite": [
        "inexorabilite"
    ],
    "inexorable": [
        "inexorable"
    ],
    "inexorablement": [
        "inexorablement"
    ],
    "inexorables": [
        "inexorable"
    ],
    "inexperte": [
        "inexpert"
    ],
    "inexpiable": [
        "inexpiable"
    ],
    "inexplicable": [
        "inexplicable"
    ],
    "inexplicablement": [
        "inexplicablement"
    ],
    "inexplicables": [
        "inexplicable"
    ],
    "inexplique": [
        "inexplique"
    ],
    "inexpliquee": [
        "inexplique"
    ],
    "inexpliquees": [
        "inexplique"
    ],
    "inexpliques": [
        "inexplique"
    ],
    "inexploitable": [
        "inexploitable"
    ],
    "inexploite": [
        "inexploite"
    ],
    "inexploitee": [
        "inexploite"
    ],
    "inexploitees": [
        "inexploite"
    ],
    "inexploites": [
        "inexploite"
    ],
    "inexplore": [
        "inexplore"
    ],
    "inexploree": [
        "inexplore"
    ],
    "inexplorees": [
        "inexplore"
    ],
    "inexplores": [
        "inexplore"
    ],
    "inexplosible": [
        "inexplosible"
    ],
    "inexplosibles": [
        "inexplosible"
    ],
    "inexpressif": [
        "inexpressif"
    ],
    "inexpressifs": [
        "inexpressif"
    ],
    "inexpression": [
        "inexpression"
    ],
    "inexpressive": [
        "inexpressif"
    ],
    "inexpressives": [
        "inexpressif"
    ],
    "inexprimable": [
        "inexprimable"
    ],
    "inexprimablement": [
        "inexprimablement"
    ],
    "inexprimables": [
        "inexprimable"
    ],
    "inexprime": [
        "inexprime"
    ],
    "inexprimee": [
        "inexprime"
    ],
    "inexpugnable": [
        "inexpugnable"
    ],
    "inexpugnablement": [
        "inexpugnablement"
    ],
    "inexpugnables": [
        "inexpugnable"
    ],
    "inexperience": [
        "inexperience"
    ],
    "inexperiences": [
        "inexperience"
    ],
    "inexperimente": [
        "inexperimente"
    ],
    "inexperimentee": [
        "inexperimente"
    ],
    "inexperimentees": [
        "inexperimente"
    ],
    "inexperimentes": [
        "inexperimente"
    ],
    "inextinguible": [
        "inextinguible"
    ],
    "inextinguibles": [
        "inextinguible"
    ],
    "inextirpable": [
        "inextirpable"
    ],
    "inextricable": [
        "inextricable"
    ],
    "inextricablement": [
        "inextricablement"
    ],
    "inextricables": [
        "inextricable"
    ],
    "infaillibilite": [
        "infaillibilite"
    ],
    "infaillible": [
        "infaillible"
    ],
    "infailliblement": [
        "infailliblement"
    ],
    "infaillibles": [
        "infaillible"
    ],
    "infaisable": [
        "infaisable"
    ],
    "infalsifiable": [
        "infalsifiable"
    ],
    "infamant": [
        "infamant"
    ],
    "infamante": [
        "infamant"
    ],
    "infamantes": [
        "infamant"
    ],
    "infamants": [
        "infamant"
    ],
    "infamie": [
        "infamie"
    ],
    "infamies": [
        "infamie"
    ],
    "infant": [
        "infant"
    ],
    "infante": [
        "infant"
    ],
    "infanterie": [
        "infanterie"
    ],
    "infanteries": [
        "infanterie"
    ],
    "infantes": [
        "infant"
    ],
    "infanticide": [
        "infanticide"
    ],
    "infanticides": [
        "infanticide"
    ],
    "infantile": [
        "infantile"
    ],
    "infantilement": [
        "infantilement"
    ],
    "infantiles": [
        "infantile"
    ],
    "infantiliser": [
        "infantiliser"
    ],
    "infantilisme": [
        "infantilisme"
    ],
    "infantilismes": [
        "infantilisme"
    ],
    "infantilise": [
        "infantiliser"
    ],
    "infants": [
        "infant"
    ],
    "infarctus": [
        "infarctus"
    ],
    "infatigable": [
        "infatigable"
    ],
    "infatigablement": [
        "infatigablement"
    ],
    "infatigables": [
        "infatigable"
    ],
    "infatuation": [
        "infatuation"
    ],
    "infatuer": [
        "infatuer"
    ],
    "infatue": [
        "infatue",
        "infatuer"
    ],
    "infatues": [
        "infatue",
        "infatuer"
    ],
    "infect": [
        "infect"
    ],
    "infectaient": [
        "infecter"
    ],
    "infectait": [
        "infecter"
    ],
    "infectant": [
        "infecter"
    ],
    "infectassent": [
        "infecter"
    ],
    "infecte": [
        "infecte",
        "infecter",
        "infect"
    ],
    "infectement": [
        "infectement"
    ],
    "infectent": [
        "infecter"
    ],
    "infecter": [
        "infecter"
    ],
    "infectera": [
        "infecter"
    ],
    "infectes": [
        "infecte",
        "infecter",
        "infect"
    ],
    "infectez": [
        "infecter"
    ],
    "infectieuse": [
        "infectieux"
    ],
    "infectieuses": [
        "infectieux"
    ],
    "infectieux": [
        "infectieux"
    ],
    "infectiologie": [
        "infectiologie"
    ],
    "infection": [
        "infection"
    ],
    "infections": [
        "infection"
    ],
    "infects": [
        "infect"
    ],
    "infectee": [
        "infecte",
        "infecter"
    ],
    "infectees": [
        "infecte",
        "infecter"
    ],
    "infernal": [
        "infernal"
    ],
    "infernale": [
        "infernal"
    ],
    "infernalement": [
        "infernalement"
    ],
    "infernales": [
        "infernal"
    ],
    "infernaux": [
        "infernal"
    ],
    "infertile": [
        "infertile"
    ],
    "infertiles": [
        "infertile"
    ],
    "infertilite": [
        "infertilite"
    ],
    "infestaient": [
        "infester"
    ],
    "infestait": [
        "infester"
    ],
    "infestant": [
        "infester"
    ],
    "infestation": [
        "infestation"
    ],
    "infeste": [
        "infester"
    ],
    "infestent": [
        "infester"
    ],
    "infester": [
        "infester"
    ],
    "infesteront": [
        "infester"
    ],
    "infestat": [
        "infester"
    ],
    "infesterent": [
        "infester"
    ],
    "infestee": [
        "infester"
    ],
    "infestees": [
        "infester"
    ],
    "infestes": [
        "infester"
    ],
    "infibulation": [
        "infibulation"
    ],
    "infidele": [
        "infidele"
    ],
    "infideles": [
        "infidele"
    ],
    "infidelite": [
        "infidelite"
    ],
    "infidelites": [
        "infidelite"
    ],
    "infigurable": [
        "infigurable"
    ],
    "infiltra": [
        "infiltrer"
    ],
    "infiltraient": [
        "infiltrer"
    ],
    "infiltrait": [
        "infiltrer"
    ],
    "infiltrant": [
        "infiltrer"
    ],
    "infiltrat": [
        "infiltrat"
    ],
    "infiltration": [
        "infiltration"
    ],
    "infiltrations": [
        "infiltration"
    ],
    "infiltre": [
        "infiltrer"
    ],
    "infiltrent": [
        "infiltrer"
    ],
    "infiltrer": [
        "infiltrer"
    ],
    "infiltrera": [
        "infiltrer"
    ],
    "infiltreront": [
        "infiltrer"
    ],
    "infiltrez": [
        "infiltrer"
    ],
    "infiltriez": [
        "infiltrer"
    ],
    "infiltrions": [
        "infiltrer"
    ],
    "infiltrons": [
        "infiltrer"
    ],
    "infiltrerent": [
        "infiltrer"
    ],
    "infiltree": [
        "infiltrer"
    ],
    "infiltrees": [
        "infiltrer"
    ],
    "infiltres": [
        "infiltrer"
    ],
    "infime": [
        "infime"
    ],
    "infimes": [
        "infime"
    ],
    "infini": [
        "infini"
    ],
    "infinie": [
        "infini"
    ],
    "infinies": [
        "infini"
    ],
    "infiniment": [
        "infiniment"
    ],
    "infinis": [
        "infini"
    ],
    "infinitif": [
        "infinitif"
    ],
    "infinitifs": [
        "infinitif"
    ],
    "infinitive": [
        "infinitif"
    ],
    "infinitude": [
        "infinitude"
    ],
    "infinite": [
        "infinite"
    ],
    "infinites": [
        "infinite"
    ],
    "infinitesimal": [
        "infinitesimal"
    ],
    "infinitesimale": [
        "infinitesimal"
    ],
    "infinitesimalement": [
        "infinitesimalement"
    ],
    "infinitesimales": [
        "infinitesimal"
    ],
    "infinitesimaux": [
        "infinitesimal"
    ],
    "infirma": [
        "infirmer"
    ],
    "infirmait": [
        "infirmer"
    ],
    "infirmant": [
        "infirmer"
    ],
    "infirme": [
        "infirme",
        "infirmer"
    ],
    "infirment": [
        "infirmer"
    ],
    "infirmer": [
        "infirmer"
    ],
    "infirmerie": [
        "infirmerie"
    ],
    "infirmeries": [
        "infirmerie"
    ],
    "infirmeront": [
        "infirmer"
    ],
    "infirmes": [
        "infirme"
    ],
    "infirmier": [
        "infirmier"
    ],
    "infirmiers": [
        "infirmier"
    ],
    "infirmite": [
        "infirmite"
    ],
    "infirmites": [
        "infirmite"
    ],
    "infirmiere": [
        "infirmier"
    ],
    "infirmieres": [
        "infirmier"
    ],
    "inflammabilite": [
        "inflammabilite"
    ],
    "inflammable": [
        "inflammable"
    ],
    "inflammables": [
        "inflammable"
    ],
    "inflammation": [
        "inflammation"
    ],
    "inflammatoire": [
        "inflammatoire"
    ],
    "inflammatoires": [
        "inflammatoire"
    ],
    "inflation": [
        "inflation"
    ],
    "inflationniste": [
        "inflationniste"
    ],
    "inflexibilite": [
        "inflexibilite"
    ],
    "inflexible": [
        "inflexible"
    ],
    "inflexiblement": [
        "inflexiblement"
    ],
    "inflexibles": [
        "inflexible"
    ],
    "inflexion": [
        "inflexion"
    ],
    "inflexions": [
        "inflexion"
    ],
    "infliction": [
        "infliction"
    ],
    "inflige": [
        "infliger"
    ],
    "infligea": [
        "infliger"
    ],
    "infligeaient": [
        "infliger"
    ],
    "infligeais": [
        "infliger"
    ],
    "infligeait": [
        "infliger"
    ],
    "infligeant": [
        "infliger"
    ],
    "infligent": [
        "infliger"
    ],
    "infligeons": [
        "infliger"
    ],
    "infliger": [
        "infliger"
    ],
    "infligera": [
        "infliger"
    ],
    "infligerai": [
        "infliger"
    ],
    "infligeraient": [
        "infliger"
    ],
    "infligerais": [
        "infliger"
    ],
    "infligerait": [
        "infliger"
    ],
    "infligerez": [
        "infliger"
    ],
    "infligerions": [
        "infliger"
    ],
    "infliges": [
        "infliger"
    ],
    "infligez": [
        "infliger"
    ],
    "infligeames": [
        "infliger"
    ],
    "infligerent": [
        "infliger"
    ],
    "infligee": [
        "infliger"
    ],
    "infligees": [
        "infliger"
    ],
    "inflorescence": [
        "inflorescence"
    ],
    "inflorescences": [
        "inflorescence"
    ],
    "influaient": [
        "influer"
    ],
    "influait": [
        "influer"
    ],
    "influant": [
        "influer"
    ],
    "influe": [
        "influer"
    ],
    "influence": [
        "influencer",
        "influence"
    ],
    "influencent": [
        "influencer"
    ],
    "influencer": [
        "influencer"
    ],
    "influencera": [
        "influencer"
    ],
    "influencerait": [
        "influencer"
    ],
    "influencerez": [
        "influencer"
    ],
    "influenceriez": [
        "influencer"
    ],
    "influenceront": [
        "influencer"
    ],
    "influences": [
        "influencer",
        "influence"
    ],
    "influencee": [
        "influencer"
    ],
    "influent": [
        "influer",
        "influent"
    ],
    "influente": [
        "influent"
    ],
    "influentes": [
        "influent"
    ],
    "influents": [
        "influent"
    ],
    "influenza": [
        "influenza"
    ],
    "influenca": [
        "influencer"
    ],
    "influencable": [
        "influencable"
    ],
    "influencables": [
        "influencable"
    ],
    "influencaient": [
        "influencer"
    ],
    "influencait": [
        "influencer"
    ],
    "influencant": [
        "influencer"
    ],
    "influer": [
        "influer"
    ],
    "influera": [
        "influer"
    ],
    "influeraient": [
        "influer"
    ],
    "influeront": [
        "influer"
    ],
    "influx": [
        "influx"
    ],
    "inflechi": [
        "inflechir",
        "inflechi"
    ],
    "inflechie": [
        "inflechir",
        "inflechi"
    ],
    "inflechies": [
        "inflechi"
    ],
    "inflechir": [
        "inflechir"
    ],
    "inflechirai": [
        "inflechir"
    ],
    "inflechissaient": [
        "inflechir"
    ],
    "inflechissant": [
        "inflechir"
    ],
    "inflechissement": [
        "inflechissement"
    ],
    "inflechissent": [
        "inflechir"
    ],
    "inflechissez": [
        "inflechir"
    ],
    "inflechit": [
        "inflechir"
    ],
    "info": [
        "info"
    ],
    "infographie": [
        "infographie"
    ],
    "infonde": [
        "infonde"
    ],
    "infondee": [
        "infonde"
    ],
    "infondees": [
        "infonde"
    ],
    "infondes": [
        "infonde"
    ],
    "informa": [
        "informer"
    ],
    "informai": [
        "informer"
    ],
    "informaient": [
        "informer"
    ],
    "informais": [
        "informer"
    ],
    "informait": [
        "informer"
    ],
    "informant": [
        "informer",
        "informant"
    ],
    "informateur": [
        "informateur"
    ],
    "informateurs": [
        "informateur"
    ],
    "informaticien": [
        "informaticien"
    ],
    "informaticienne": [
        "informaticien"
    ],
    "informaticiens": [
        "informaticien"
    ],
    "informatif": [
        "informatif"
    ],
    "information": [
        "information"
    ],
    "informations": [
        "information"
    ],
    "informatique": [
        "informatique"
    ],
    "informatiquement": [
        "informatiquement"
    ],
    "informatiques": [
        "informatique"
    ],
    "informatiser": [
        "informatiser"
    ],
    "informatise": [
        "informatise",
        "informatiser"
    ],
    "informatisee": [
        "informatise",
        "informatiser"
    ],
    "informatisees": [
        "informatise",
        "informatiser"
    ],
    "informatises": [
        "informatise",
        "informatiser"
    ],
    "informative": [
        "informatif"
    ],
    "informatives": [
        "informatif"
    ],
    "informatrice": [
        "informateur"
    ],
    "informe": [
        "informe",
        "informer"
    ],
    "informel": [
        "informel"
    ],
    "informelle": [
        "informel"
    ],
    "informelles": [
        "informel"
    ],
    "informels": [
        "informel"
    ],
    "informent": [
        "informer"
    ],
    "informer": [
        "informer"
    ],
    "informera": [
        "informer"
    ],
    "informerai": [
        "informer"
    ],
    "informerais": [
        "informer"
    ],
    "informeras": [
        "informer"
    ],
    "informerez": [
        "informer"
    ],
    "informerons": [
        "informer"
    ],
    "informeront": [
        "informer"
    ],
    "informes": [
        "informe",
        "informer"
    ],
    "informez": [
        "informer"
    ],
    "informiez": [
        "informer"
    ],
    "informions": [
        "informer"
    ],
    "informons": [
        "informer"
    ],
    "informulable": [
        "informulable"
    ],
    "informulables": [
        "informulable"
    ],
    "informule": [
        "informule"
    ],
    "informulee": [
        "informule"
    ],
    "informulees": [
        "informule"
    ],
    "informerent": [
        "informer"
    ],
    "informee": [
        "informe",
        "informer"
    ],
    "informees": [
        "informe",
        "informer"
    ],
    "infortune": [
        "infortune"
    ],
    "infortunes": [
        "infortune"
    ],
    "infortunee": [
        "infortune"
    ],
    "infortunees": [
        "infortune"
    ],
    "infos": [
        "info"
    ],
    "infoutu": [
        "infoutu"
    ],
    "infoutue": [
        "infoutu"
    ],
    "infoutus": [
        "infoutu"
    ],
    "infra": [
        "infra"
    ],
    "infraction": [
        "infraction"
    ],
    "infractions": [
        "infraction"
    ],
    "infranchi": [
        "infranchi"
    ],
    "infranchissable": [
        "infranchissable"
    ],
    "infranchissables": [
        "infranchissable"
    ],
    "infrangible": [
        "infrangible"
    ],
    "infrarouge": [
        "infrarouge"
    ],
    "infrarouges": [
        "infrarouge"
    ],
    "infrason": [
        "infrason"
    ],
    "infrastructure": [
        "infrastructure"
    ],
    "infrastructures": [
        "infrastructure"
    ],
    "infroissable": [
        "infroissable"
    ],
    "infructueuse": [
        "infructueux"
    ],
    "infructueuses": [
        "infructueux"
    ],
    "infructueux": [
        "infructueux"
    ],
    "infrequentable": [
        "infrequentable"
    ],
    "infrequentables": [
        "infrequentable"
    ],
    "infrequentee": [
        "infrequente"
    ],
    "infrequentes": [
        "infrequente"
    ],
    "infus": [
        "infus"
    ],
    "infusaient": [
        "infuser"
    ],
    "infusait": [
        "infuser"
    ],
    "infusant": [
        "infuser"
    ],
    "infuse": [
        "infus",
        "infuser"
    ],
    "infusent": [
        "infuser"
    ],
    "infuser": [
        "infuser"
    ],
    "infuses": [
        "infus",
        "infuse"
    ],
    "infusion": [
        "infusion"
    ],
    "infusions": [
        "infusion"
    ],
    "infusoires": [
        "infusoire"
    ],
    "infusee": [
        "infuser"
    ],
    "infusees": [
        "infuser"
    ],
    "infame": [
        "infame"
    ],
    "infames": [
        "infame"
    ],
    "infeconde": [
        "infecond"
    ],
    "infecondes": [
        "infecond"
    ],
    "infecondite": [
        "infecondite"
    ],
    "infeode": [
        "infeoder"
    ],
    "infeoder": [
        "infeoder"
    ],
    "infeodee": [
        "infeoder"
    ],
    "inferai": [
        "inferer"
    ],
    "inferer": [
        "inferer"
    ],
    "inferieur": [
        "inferieur"
    ],
    "inferieure": [
        "inferieur"
    ],
    "inferieures": [
        "inferieur"
    ],
    "inferieurs": [
        "inferieur"
    ],
    "inferioriser": [
        "inferioriser"
    ],
    "inferiorite": [
        "inferiorite"
    ],
    "inferiorites": [
        "inferiorite"
    ],
    "infere": [
        "inferer"
    ],
    "ingagnable": [
        "ingagnable"
    ],
    "ingambe": [
        "ingambe"
    ],
    "ingambes": [
        "ingambe"
    ],
    "ingestion": [
        "ingestion"
    ],
    "inglorieusement": [
        "inglorieusement"
    ],
    "inglorieux": [
        "inglorieux"
    ],
    "ingouvernable": [
        "ingouvernable"
    ],
    "ingrat": [
        "ingrat"
    ],
    "ingrate": [
        "ingrat"
    ],
    "ingratement": [
        "ingratement"
    ],
    "ingrates": [
        "ingrat"
    ],
    "ingratitude": [
        "ingratitude"
    ],
    "ingrats": [
        "ingrat"
    ],
    "ingredient": [
        "ingredient"
    ],
    "ingredients": [
        "ingredient"
    ],
    "inguinal": [
        "inguinal"
    ],
    "inguinales": [
        "inguinal"
    ],
    "ingurgita": [
        "ingurgiter"
    ],
    "ingurgitaient": [
        "ingurgiter"
    ],
    "ingurgitais": [
        "ingurgiter"
    ],
    "ingurgitait": [
        "ingurgiter"
    ],
    "ingurgitant": [
        "ingurgiter"
    ],
    "ingurgitation": [
        "ingurgitation"
    ],
    "ingurgite": [
        "ingurgiter"
    ],
    "ingurgitent": [
        "ingurgiter"
    ],
    "ingurgiter": [
        "ingurgiter"
    ],
    "ingurgiterait": [
        "ingurgiter"
    ],
    "ingurgitee": [
        "ingurgiter"
    ],
    "ingurgitees": [
        "ingurgiter"
    ],
    "ingurgites": [
        "ingurgiter"
    ],
    "inguerissable": [
        "inguerissable"
    ],
    "inguerissables": [
        "inguerissable"
    ],
    "ingere": [
        "ingerer"
    ],
    "ingerent": [
        "ingerer"
    ],
    "ingenia": [
        "ingenier"
    ],
    "ingeniai": [
        "ingenier"
    ],
    "ingeniaient": [
        "ingenier"
    ],
    "ingeniais": [
        "ingenier"
    ],
    "ingeniait": [
        "ingenier"
    ],
    "ingeniant": [
        "ingenier"
    ],
    "ingenie": [
        "ingenier"
    ],
    "ingenient": [
        "ingenier"
    ],
    "ingenier": [
        "ingenier"
    ],
    "ingenierie": [
        "ingenierie"
    ],
    "ingenieur": [
        "ingenieur"
    ],
    "ingenieurs": [
        "ingenieur"
    ],
    "ingenieuse": [
        "ingenieux"
    ],
    "ingenieusement": [
        "ingenieusement"
    ],
    "ingenieuses": [
        "ingenieux"
    ],
    "ingenieux": [
        "ingenieux"
    ],
    "ingeniosite": [
        "ingeniosite"
    ],
    "ingeniosites": [
        "ingeniosite"
    ],
    "ingenies": [
        "ingenier"
    ],
    "ingenu": [
        "ingenu"
    ],
    "ingenue": [
        "ingenu"
    ],
    "ingenues": [
        "ingenu"
    ],
    "ingenuite": [
        "ingenuite"
    ],
    "ingenuites": [
        "ingenuite"
    ],
    "ingenument": [
        "ingenument"
    ],
    "ingenus": [
        "ingenu"
    ],
    "ingerable": [
        "ingerable"
    ],
    "ingerant": [
        "ingerer"
    ],
    "ingerence": [
        "ingerence"
    ],
    "ingerences": [
        "ingerence"
    ],
    "ingerer": [
        "ingerer"
    ],
    "ingerons": [
        "ingerer"
    ],
    "ingeree": [
        "ingerer"
    ],
    "ingerees": [
        "ingerer"
    ],
    "ingeres": [
        "ingerer"
    ],
    "inhabile": [
        "inhabile"
    ],
    "inhabitable": [
        "inhabitable"
    ],
    "inhabitables": [
        "inhabitable"
    ],
    "inhabituel": [
        "inhabituel"
    ],
    "inhabituelle": [
        "inhabituel"
    ],
    "inhabituellement": [
        "inhabituellement"
    ],
    "inhabituelles": [
        "inhabituel"
    ],
    "inhabituels": [
        "inhabituel"
    ],
    "inhabite": [
        "inhabite"
    ],
    "inhabitee": [
        "inhabite"
    ],
    "inhabitees": [
        "inhabite"
    ],
    "inhabites": [
        "inhabite"
    ],
    "inhala": [
        "inhaler"
    ],
    "inhalais": [
        "inhaler"
    ],
    "inhalait": [
        "inhaler"
    ],
    "inhalant": [
        "inhalant",
        "inhaler"
    ],
    "inhalateur": [
        "inhalateur"
    ],
    "inhalateurs": [
        "inhalateur"
    ],
    "inhalation": [
        "inhalation"
    ],
    "inhalations": [
        "inhalation"
    ],
    "inhaler": [
        "inhaler"
    ],
    "inhalera": [
        "inhaler"
    ],
    "inhalez": [
        "inhaler"
    ],
    "inhale": [
        "inhaler"
    ],
    "inharmonieux": [
        "inharmonieux"
    ],
    "inhibait": [
        "inhiber"
    ],
    "inhibant": [
        "inhiber"
    ],
    "inhibe": [
        "inhiber",
        "inhibe"
    ],
    "inhibent": [
        "inhiber"
    ],
    "inhiber": [
        "inhiber"
    ],
    "inhibiteur": [
        "inhibiteur"
    ],
    "inhibiteurs": [
        "inhibiteur"
    ],
    "inhibition": [
        "inhibition"
    ],
    "inhibitions": [
        "inhibition"
    ],
    "inhibitrice": [
        "inhibiteur"
    ],
    "inhibat": [
        "inhiber"
    ],
    "inhibee": [
        "inhiber",
        "inhibe"
    ],
    "inhibes": [
        "inhiber",
        "inhibe"
    ],
    "inhospitalier": [
        "inhospitalier"
    ],
    "inhospitaliers": [
        "inhospitalier"
    ],
    "inhospitalite": [
        "inhospitalite"
    ],
    "inhospitaliere": [
        "inhospitalier"
    ],
    "inhospitalieres": [
        "inhospitalier"
    ],
    "inhuma": [
        "inhumer"
    ],
    "inhumaient": [
        "inhumer"
    ],
    "inhumain": [
        "inhumain"
    ],
    "inhumaine": [
        "inhumain"
    ],
    "inhumainement": [
        "inhumainement"
    ],
    "inhumaines": [
        "inhumain"
    ],
    "inhumains": [
        "inhumain"
    ],
    "inhumait": [
        "inhumer"
    ],
    "inhumanite": [
        "inhumanite"
    ],
    "inhumation": [
        "inhumation"
    ],
    "inhumations": [
        "inhumation"
    ],
    "inhume": [
        "inhumer"
    ],
    "inhumer": [
        "inhumer"
    ],
    "inhumons": [
        "inhumer"
    ],
    "inhumee": [
        "inhumer"
    ],
    "inhumes": [
        "inhumer"
    ],
    "inherent": [
        "inherent"
    ],
    "inherente": [
        "inherent"
    ],
    "inherentes": [
        "inherent"
    ],
    "inherents": [
        "inherent"
    ],
    "inidentifiable": [
        "inidentifiable"
    ],
    "inidentifiables": [
        "inidentifiable"
    ],
    "inimaginable": [
        "inimaginable"
    ],
    "inimaginablement": [
        "inimaginablement"
    ],
    "inimaginables": [
        "inimaginable"
    ],
    "inimitable": [
        "inimitable"
    ],
    "inimitablement": [
        "inimitablement"
    ],
    "inimitie": [
        "inimitie"
    ],
    "inimities": [
        "inimitie"
    ],
    "inimite": [
        "inimite"
    ],
    "ininflammable": [
        "ininflammable"
    ],
    "inintelligence": [
        "inintelligence"
    ],
    "inintelligent": [
        "inintelligent"
    ],
    "inintelligents": [
        "inintelligent"
    ],
    "inintelligible": [
        "inintelligible"
    ],
    "inintelligibles": [
        "inintelligible"
    ],
    "ininterpretables": [
        "ininterpretable"
    ],
    "ininterrompu": [
        "ininterrompu"
    ],
    "ininterrompue": [
        "ininterrompu"
    ],
    "ininterrompues": [
        "ininterrompu"
    ],
    "ininterrompus": [
        "ininterrompu"
    ],
    "ininteressant": [
        "ininteressant"
    ],
    "ininteressante": [
        "ininteressant"
    ],
    "ininteressantes": [
        "ininteressant"
    ],
    "ininteressants": [
        "ininteressant"
    ],
    "ininteret": [
        "ininteret"
    ],
    "inique": [
        "inique"
    ],
    "iniques": [
        "inique"
    ],
    "iniquite": [
        "iniquite"
    ],
    "iniquites": [
        "iniquite"
    ],
    "initia": [
        "initier"
    ],
    "initiai": [
        "initier"
    ],
    "initiaient": [
        "initier"
    ],
    "initiais": [
        "initier"
    ],
    "initiait": [
        "initier"
    ],
    "initial": [
        "initial"
    ],
    "initiale": [
        "initiale",
        "initial"
    ],
    "initialement": [
        "initialement"
    ],
    "initiales": [
        "initiale",
        "initial"
    ],
    "initialisation": [
        "initialisation"
    ],
    "initialise": [
        "initialise",
        "initialiser"
    ],
    "initialiser": [
        "initialiser"
    ],
    "initialisez": [
        "initialiser"
    ],
    "initialisee": [
        "initialise"
    ],
    "initialises": [
        "initialise"
    ],
    "initiant": [
        "initier"
    ],
    "initiateur": [
        "initiateur"
    ],
    "initiateurs": [
        "initiateur"
    ],
    "initiation": [
        "initiation"
    ],
    "initiations": [
        "initiation"
    ],
    "initiatique": [
        "initiatique"
    ],
    "initiatiques": [
        "initiatique"
    ],
    "initiative": [
        "initiative"
    ],
    "initiatives": [
        "initiative"
    ],
    "initiatrice": [
        "initiateur"
    ],
    "initiatrices": [
        "initiateur"
    ],
    "initiaux": [
        "initial"
    ],
    "initie": [
        "initier",
        "initie"
    ],
    "initier": [
        "initier"
    ],
    "initiera": [
        "initier"
    ],
    "initierai": [
        "initier"
    ],
    "initierait": [
        "initier"
    ],
    "initierons": [
        "initier"
    ],
    "initiez": [
        "initier"
    ],
    "initiames": [
        "initier"
    ],
    "initiat": [
        "initier"
    ],
    "initierent": [
        "initier"
    ],
    "initiee": [
        "initier",
        "initie"
    ],
    "initiees": [
        "initier",
        "initie"
    ],
    "inities": [
        "initier",
        "initie"
    ],
    "injecta": [
        "injecter"
    ],
    "injectable": [
        "injectable"
    ],
    "injectaient": [
        "injecter"
    ],
    "injectait": [
        "injecter"
    ],
    "injectant": [
        "injecter"
    ],
    "injecte": [
        "injecter",
        "injecte"
    ],
    "injectent": [
        "injecter"
    ],
    "injecter": [
        "injecter"
    ],
    "injectera": [
        "injecter"
    ],
    "injecteras": [
        "injecter"
    ],
    "injectes": [
        "injecter",
        "injecte"
    ],
    "injecteur": [
        "injecteur"
    ],
    "injecteurs": [
        "injecteur"
    ],
    "injectez": [
        "injecter"
    ],
    "injection": [
        "injection"
    ],
    "injections": [
        "injection"
    ],
    "injectee": [
        "injecter",
        "injecte"
    ],
    "injoignable": [
        "injoignable"
    ],
    "injoignables": [
        "injoignable"
    ],
    "injonction": [
        "injonction"
    ],
    "injonctions": [
        "injonction"
    ],
    "injouable": [
        "injouable"
    ],
    "injure": [
        "injure"
    ],
    "injures": [
        "injure"
    ],
    "injuria": [
        "injurier"
    ],
    "injuriai": [
        "injurier"
    ],
    "injuriaient": [
        "injurier"
    ],
    "injuriais": [
        "injurier"
    ],
    "injuriait": [
        "injurier"
    ],
    "injuriant": [
        "injurier"
    ],
    "injurie": [
        "injurier"
    ],
    "injurient": [
        "injurier"
    ],
    "injurier": [
        "injurier"
    ],
    "injuries": [
        "injury",
        "injurier"
    ],
    "injurieuse": [
        "injurieux"
    ],
    "injurieusement": [
        "injurieusement"
    ],
    "injurieux": [
        "injurieux"
    ],
    "injuriee": [
        "injurier"
    ],
    "injuste": [
        "injuste"
    ],
    "injustement": [
        "injustement"
    ],
    "injustes": [
        "injuste"
    ],
    "injustice": [
        "injustice"
    ],
    "injustices": [
        "injustice"
    ],
    "injustifiable": [
        "injustifiable"
    ],
    "injustifiables": [
        "injustifiable"
    ],
    "injustifie": [
        "injustifie"
    ],
    "injustifiee": [
        "injustifie"
    ],
    "injustifiees": [
        "injustifie"
    ],
    "injustifies": [
        "injustifie"
    ],
    "inlassable": [
        "inlassable"
    ],
    "inlassablement": [
        "inlassablement"
    ],
    "inlassables": [
        "inlassable"
    ],
    "innervant": [
        "innerver"
    ],
    "innervation": [
        "innervation"
    ],
    "innerver": [
        "innerver"
    ],
    "innerve": [
        "innerver"
    ],
    "innocemment": [
        "innocemment"
    ],
    "innocence": [
        "innocence"
    ],
    "innocences": [
        "innocence"
    ],
    "innocent": [
        "innocent"
    ],
    "innocentait": [
        "innocenter"
    ],
    "innocentant": [
        "innocenter"
    ],
    "innocente": [
        "innocenter",
        "innocent"
    ],
    "innocenter": [
        "innocenter"
    ],
    "innocentera": [
        "innocenter"
    ],
    "innocenterai": [
        "innocenter"
    ],
    "innocenterait": [
        "innocenter"
    ],
    "innocentes": [
        "innocenter",
        "innocent"
    ],
    "innocents": [
        "innocent"
    ],
    "innocentee": [
        "innocenter"
    ],
    "innocuite": [
        "innocuite"
    ],
    "innombrable": [
        "innombrable"
    ],
    "innombrablement": [
        "innombrablement"
    ],
    "innombrables": [
        "innombrable"
    ],
    "innomines": [
        "innomine"
    ],
    "innommable": [
        "innommable"
    ],
    "innommables": [
        "innommable"
    ],
    "innomme": [
        "innomme"
    ],
    "innommee": [
        "innomme"
    ],
    "innommes": [
        "innomme"
    ],
    "innova": [
        "innover"
    ],
    "innovais": [
        "innover"
    ],
    "innovait": [
        "innover"
    ],
    "innovant": [
        "innovant",
        "innover"
    ],
    "innovante": [
        "innovant"
    ],
    "innovateur": [
        "innovateur"
    ],
    "innovation": [
        "innovation"
    ],
    "innovations": [
        "innovation"
    ],
    "innovatrice": [
        "innovateur"
    ],
    "innove": [
        "innover"
    ],
    "innover": [
        "innover"
    ],
    "innovez": [
        "innover"
    ],
    "inne": [
        "inne"
    ],
    "innee": [
        "inne"
    ],
    "innees": [
        "inne"
    ],
    "innes": [
        "inne"
    ],
    "inoccupations": [
        "inoccupation"
    ],
    "inoccupe": [
        "inoccupe"
    ],
    "inoccupee": [
        "inoccupe"
    ],
    "inoccupees": [
        "inoccupe"
    ],
    "inoccupes": [
        "inoccupe"
    ],
    "inoculant": [
        "inoculer"
    ],
    "inoculation": [
        "inoculation"
    ],
    "inocule": [
        "inoculer"
    ],
    "inoculent": [
        "inoculer"
    ],
    "inoculer": [
        "inoculer"
    ],
    "inoculerait": [
        "inoculer"
    ],
    "inoculee": [
        "inoculer"
    ],
    "inoculees": [
        "inoculer"
    ],
    "inodore": [
        "inodore"
    ],
    "inodores": [
        "inodore"
    ],
    "inoffensif": [
        "inoffensif"
    ],
    "inoffensifs": [
        "inoffensif"
    ],
    "inoffensive": [
        "inoffensif"
    ],
    "inoffensives": [
        "inoffensif"
    ],
    "inonda": [
        "inonder"
    ],
    "inondable": [
        "inondable"
    ],
    "inondables": [
        "inondable"
    ],
    "inondaient": [
        "inonder"
    ],
    "inondait": [
        "inonder"
    ],
    "inondant": [
        "inonder"
    ],
    "inondation": [
        "inondation"
    ],
    "inondations": [
        "inondation"
    ],
    "inonde": [
        "inonde",
        "inonder"
    ],
    "inondent": [
        "inonder"
    ],
    "inonder": [
        "inonder"
    ],
    "inondera": [
        "inonder"
    ],
    "inonderai": [
        "inonder"
    ],
    "inonderait": [
        "inonder"
    ],
    "inonderons": [
        "inonder"
    ],
    "inondez": [
        "inonder"
    ],
    "inondiez": [
        "inonder"
    ],
    "inondat": [
        "inonder"
    ],
    "inonderent": [
        "inonder"
    ],
    "inondee": [
        "inonde",
        "inonder"
    ],
    "inondees": [
        "inonde",
        "inonder"
    ],
    "inondes": [
        "inonde",
        "inonder"
    ],
    "inopine": [
        "inopine"
    ],
    "inopinee": [
        "inopine"
    ],
    "inopinees": [
        "inopine"
    ],
    "inopinement": [
        "inopinement"
    ],
    "inopportun": [
        "inopportun"
    ],
    "inopportune": [
        "inopportun"
    ],
    "inopportunes": [
        "inopportun"
    ],
    "inopportunite": [
        "inopportunite"
    ],
    "inopportuns": [
        "inopportun"
    ],
    "inopportunement": [
        "inopportunement"
    ],
    "inoperable": [
        "inoperable"
    ],
    "inoperables": [
        "inoperable"
    ],
    "inoperant": [
        "inoperant"
    ],
    "inoperante": [
        "inoperant"
    ],
    "inoperantes": [
        "inoperant"
    ],
    "inoperants": [
        "inoperant"
    ],
    "inorganique": [
        "inorganique"
    ],
    "inorganise": [
        "inorganise"
    ],
    "inorganisee": [
        "inorganise"
    ],
    "inorganisees": [
        "inorganise"
    ],
    "inoubliable": [
        "inoubliable"
    ],
    "inoubliablement": [
        "inoubliablement"
    ],
    "inoubliables": [
        "inoubliable"
    ],
    "inoublie": [
        "inoublie"
    ],
    "inoubliees": [
        "inoublie"
    ],
    "inoui": [
        "inoui"
    ],
    "inouie": [
        "inoui"
    ],
    "inouies": [
        "inoui"
    ],
    "inouis": [
        "inoui"
    ],
    "inox": [
        "inox"
    ],
    "inoxydable": [
        "inoxydable"
    ],
    "inoxydables": [
        "inoxydable"
    ],
    "input": [
        "input"
    ],
    "inqualifiable": [
        "inqualifiable"
    ],
    "inqualifiables": [
        "inqualifiable"
    ],
    "inquiet": [
        "inquiet"
    ],
    "inquiets": [
        "inquiet"
    ],
    "inquilisme": [
        "inquilisme"
    ],
    "inquisiteur": [
        "inquisiteur"
    ],
    "inquisiteurs": [
        "inquisiteur"
    ],
    "inquisition": [
        "inquisition"
    ],
    "inquisitionner": [
        "inquisitionner"
    ],
    "inquisitions": [
        "inquisition"
    ],
    "inquisitive": [
        "inquisitif"
    ],
    "inquisitorial": [
        "inquisitorial"
    ],
    "inquisitoriale": [
        "inquisitorial"
    ],
    "inquisitoriales": [
        "inquisitorial"
    ],
    "inquisitoriaux": [
        "inquisitorial"
    ],
    "inquisitrice": [
        "inquisiteur"
    ],
    "inquiete": [
        "inquiet",
        "inquieter"
    ],
    "inquietent": [
        "inquieter"
    ],
    "inquietes": [
        "inquiet",
        "inquieter"
    ],
    "inquieta": [
        "inquieter"
    ],
    "inquietai": [
        "inquieter"
    ],
    "inquietaient": [
        "inquieter"
    ],
    "inquietais": [
        "inquieter"
    ],
    "inquietait": [
        "inquieter"
    ],
    "inquietant": [
        "inquietant",
        "inquieter"
    ],
    "inquietante": [
        "inquietant"
    ],
    "inquietantes": [
        "inquietant"
    ],
    "inquietants": [
        "inquietant"
    ],
    "inquietassent": [
        "inquieter"
    ],
    "inquieter": [
        "inquieter"
    ],
    "inquietera": [
        "inquieter"
    ],
    "inquieterai": [
        "inquieter"
    ],
    "inquieteraient": [
        "inquieter"
    ],
    "inquieterais": [
        "inquieter"
    ],
    "inquieterait": [
        "inquieter"
    ],
    "inquieteras": [
        "inquieter"
    ],
    "inquieteriez": [
        "inquieter"
    ],
    "inquieteront": [
        "inquieter"
    ],
    "inquieteur": [
        "inquieteur"
    ],
    "inquietez": [
        "inquieter"
    ],
    "inquietiez": [
        "inquieter"
    ],
    "inquietions": [
        "inquieter"
    ],
    "inquietons": [
        "inquieter"
    ],
    "inquietude": [
        "inquietude"
    ],
    "inquietudes": [
        "inquietude"
    ],
    "inquietat": [
        "inquieter"
    ],
    "inquieterent": [
        "inquieter"
    ],
    "inquietee": [
        "inquieter"
    ],
    "inquietees": [
        "inquieter"
    ],
    "inracontables": [
        "inracontable"
    ],
    "insaisissable": [
        "insaisissable"
    ],
    "insaisissables": [
        "insaisissable"
    ],
    "insalissable": [
        "insalissable"
    ],
    "insalubre": [
        "insalubre"
    ],
    "insalubres": [
        "insalubre"
    ],
    "insalubrite": [
        "insalubrite"
    ],
    "insane": [
        "insane"
    ],
    "insanes": [
        "insane"
    ],
    "insanite": [
        "insanite"
    ],
    "insanites": [
        "insanite"
    ],
    "insatiable": [
        "insatiable"
    ],
    "insatiablement": [
        "insatiablement"
    ],
    "insatiables": [
        "insatiable"
    ],
    "insatisfaction": [
        "insatisfaction"
    ],
    "insatisfactions": [
        "insatisfaction"
    ],
    "insatisfaisant": [
        "insatisfaisant"
    ],
    "insatisfaisante": [
        "insatisfaisant"
    ],
    "insatisfaisantes": [
        "insatisfaisant"
    ],
    "insatisfait": [
        "insatisfait"
    ],
    "insatisfaite": [
        "insatisfait"
    ],
    "insatisfaites": [
        "insatisfait"
    ],
    "insatisfaits": [
        "insatisfait"
    ],
    "inscription": [
        "inscription"
    ],
    "inscriptions": [
        "inscription"
    ],
    "inscrira": [
        "inscrire"
    ],
    "inscrirai": [
        "inscrire"
    ],
    "inscriraient": [
        "inscrire"
    ],
    "inscrirais": [
        "inscrire"
    ],
    "inscrirait": [
        "inscrire"
    ],
    "inscriras": [
        "inscrire"
    ],
    "inscrire": [
        "inscrire"
    ],
    "inscris": [
        "inscrire"
    ],
    "inscrit": [
        "inscrire",
        "inscrit"
    ],
    "inscrite": [
        "inscrire",
        "inscrit"
    ],
    "inscrites": [
        "inscrire",
        "inscrit"
    ],
    "inscrits": [
        "inscrire",
        "inscrit"
    ],
    "inscrivaient": [
        "inscrire"
    ],
    "inscrivais": [
        "inscrire"
    ],
    "inscrivait": [
        "inscrire"
    ],
    "inscrivant": [
        "inscrire",
        "inscrivant"
    ],
    "inscrive": [
        "inscrire"
    ],
    "inscrivent": [
        "inscrire"
    ],
    "inscrivez": [
        "inscrire"
    ],
    "inscrivirent": [
        "inscrire"
    ],
    "inscrivis": [
        "inscrire"
    ],
    "inscrivit": [
        "inscrire"
    ],
    "inscrivons": [
        "inscrire"
    ],
    "inscrutable": [
        "inscrutable"
    ],
    "insecte": [
        "insecte"
    ],
    "insectes": [
        "insecte"
    ],
    "insecticide": [
        "insecticide"
    ],
    "insecticides": [
        "insecticide"
    ],
    "insectivore": [
        "insectivore"
    ],
    "insensibilisait": [
        "insensibiliser"
    ],
    "insensibiliser": [
        "insensibiliser"
    ],
    "insensibilise": [
        "insensibiliser"
    ],
    "insensibilisee": [
        "insensibiliser"
    ],
    "insensibilite": [
        "insensibilite"
    ],
    "insensible": [
        "insensible"
    ],
    "insensiblement": [
        "insensiblement"
    ],
    "insensibles": [
        "insensible"
    ],
    "insense": [
        "insense"
    ],
    "insensee": [
        "insense"
    ],
    "insensees": [
        "insense"
    ],
    "insensement": [
        "insensement"
    ],
    "insenses": [
        "insense"
    ],
    "insert": [
        "insert"
    ],
    "insertion": [
        "insertion"
    ],
    "inserts": [
        "insert"
    ],
    "insidieuse": [
        "insidieux"
    ],
    "insidieusement": [
        "insidieusement"
    ],
    "insidieuses": [
        "insidieux"
    ],
    "insidieux": [
        "insidieux"
    ],
    "insight": [
        "insight"
    ],
    "insights": [
        "insight"
    ],
    "insigne": [
        "insigne"
    ],
    "insignes": [
        "insigne"
    ],
    "insignifiance": [
        "insignifiance"
    ],
    "insignifiances": [
        "insignifiance"
    ],
    "insignifiant": [
        "insignifiant"
    ],
    "insignifiante": [
        "insignifiant"
    ],
    "insignifiantes": [
        "insignifiant"
    ],
    "insignifiants": [
        "insignifiant"
    ],
    "insincere": [
        "insincere"
    ],
    "insincerite": [
        "insincerite"
    ],
    "insinua": [
        "insinuer"
    ],
    "insinuai": [
        "insinuer"
    ],
    "insinuaient": [
        "insinuer"
    ],
    "insinuais": [
        "insinuer"
    ],
    "insinuait": [
        "insinuer"
    ],
    "insinuant": [
        "insinuant",
        "insinuer"
    ],
    "insinuante": [
        "insinuant"
    ],
    "insinuantes": [
        "insinuant"
    ],
    "insinuants": [
        "insinuant"
    ],
    "insinuation": [
        "insinuation"
    ],
    "insinuations": [
        "insinuation"
    ],
    "insinue": [
        "insinuer"
    ],
    "insinuent": [
        "insinuer"
    ],
    "insinuer": [
        "insinuer"
    ],
    "insinuerai": [
        "insinuer"
    ],
    "insinuerait": [
        "insinuer"
    ],
    "insinues": [
        "insinuer"
    ],
    "insinuez": [
        "insinuer"
    ],
    "insinuiez": [
        "insinuer"
    ],
    "insinuee": [
        "insinuer"
    ],
    "insipide": [
        "insipide"
    ],
    "insipides": [
        "insipide"
    ],
    "insipidite": [
        "insipidite"
    ],
    "insista": [
        "insister"
    ],
    "insistai": [
        "insister"
    ],
    "insistaient": [
        "insister"
    ],
    "insistais": [
        "insister"
    ],
    "insistait": [
        "insister"
    ],
    "insistance": [
        "insistance"
    ],
    "insistances": [
        "insistance"
    ],
    "insistant": [
        "insister",
        "insistant"
    ],
    "insistante": [
        "insistant"
    ],
    "insistantes": [
        "insistant"
    ],
    "insistants": [
        "insistant"
    ],
    "insiste": [
        "insister"
    ],
    "insistent": [
        "insister"
    ],
    "insister": [
        "insister"
    ],
    "insistera": [
        "insister"
    ],
    "insisterai": [
        "insister"
    ],
    "insisteraient": [
        "insister"
    ],
    "insisterais": [
        "insister"
    ],
    "insisterait": [
        "insister"
    ],
    "insisteras": [
        "insister"
    ],
    "insisterons": [
        "insister"
    ],
    "insistes": [
        "insister"
    ],
    "insistez": [
        "insister"
    ],
    "insistiez": [
        "insister"
    ],
    "insistions": [
        "insister"
    ],
    "insistons": [
        "insister"
    ],
    "insistat": [
        "insister"
    ],
    "insisterent": [
        "insister"
    ],
    "insociable": [
        "insociable"
    ],
    "insolant": [
        "insoler"
    ],
    "insolation": [
        "insolation"
    ],
    "insolations": [
        "insolation"
    ],
    "insolemment": [
        "insolemment"
    ],
    "insolence": [
        "insolence"
    ],
    "insolences": [
        "insolence"
    ],
    "insolent": [
        "insoler",
        "insolent"
    ],
    "insolente": [
        "insolent"
    ],
    "insolentes": [
        "insolent"
    ],
    "insolents": [
        "insolent"
    ],
    "insolite": [
        "insolite"
    ],
    "insolitement": [
        "insolitement"
    ],
    "insolites": [
        "insolite"
    ],
    "insoluble": [
        "insoluble"
    ],
    "insolubles": [
        "insoluble"
    ],
    "insolvable": [
        "insolvable"
    ],
    "insolvables": [
        "insolvable"
    ],
    "insole": [
        "insoler"
    ],
    "insomniaque": [
        "insomniaque"
    ],
    "insomniaques": [
        "insomniaque"
    ],
    "insomnie": [
        "insomnie"
    ],
    "insomnies": [
        "insomnie"
    ],
    "insomnieuse": [
        "insomnieux"
    ],
    "insomnieux": [
        "insomnieux"
    ],
    "insondable": [
        "insondable"
    ],
    "insondablement": [
        "insondablement"
    ],
    "insondables": [
        "insondable"
    ],
    "insonore": [
        "insonore"
    ],
    "insonorisation": [
        "insonorisation"
    ],
    "insonoriser": [
        "insonoriser"
    ],
    "insonorise": [
        "insonoriser"
    ],
    "insonorisee": [
        "insonoriser"
    ],
    "insonorisees": [
        "insonoriser"
    ],
    "insonorises": [
        "insonoriser"
    ],
    "insonorite": [
        "insonorite"
    ],
    "insortable": [
        "insortable"
    ],
    "insortables": [
        "insortable"
    ],
    "insouciance": [
        "insouciance"
    ],
    "insouciant": [
        "insouciant"
    ],
    "insouciante": [
        "insouciant"
    ],
    "insouciantes": [
        "insouciant"
    ],
    "insouciants": [
        "insouciant"
    ],
    "insoucieuse": [
        "insoucieux"
    ],
    "insoucieusement": [
        "insoucieusement"
    ],
    "insoucieux": [
        "insoucieux"
    ],
    "insoulevables": [
        "insoulevable"
    ],
    "insoumis": [
        "insoumis"
    ],
    "insoumise": [
        "insoumis"
    ],
    "insoumission": [
        "insoumission"
    ],
    "insoupconnable": [
        "insoupconnable"
    ],
    "insoupconnables": [
        "insoupconnable"
    ],
    "insoupconne": [
        "insoupconne"
    ],
    "insoupconnee": [
        "insoupconne"
    ],
    "insoupconnees": [
        "insoupconne"
    ],
    "insoupconnes": [
        "insoupconne"
    ],
    "insoutenable": [
        "insoutenable"
    ],
    "insoutenables": [
        "insoutenable"
    ],
    "inspecta": [
        "inspecter"
    ],
    "inspectai": [
        "inspecter"
    ],
    "inspectaient": [
        "inspecter"
    ],
    "inspectais": [
        "inspecter"
    ],
    "inspectait": [
        "inspecter"
    ],
    "inspectant": [
        "inspecter"
    ],
    "inspecte": [
        "inspecter"
    ],
    "inspectent": [
        "inspecter"
    ],
    "inspecter": [
        "inspecter"
    ],
    "inspectera": [
        "inspecter"
    ],
    "inspecterais": [
        "inspecter"
    ],
    "inspecterez": [
        "inspecter"
    ],
    "inspecteront": [
        "inspecter"
    ],
    "inspectes": [
        "inspecter"
    ],
    "inspecteur": [
        "inspecteur"
    ],
    "inspecteurs": [
        "inspecteur"
    ],
    "inspectez": [
        "inspecter"
    ],
    "inspectiez": [
        "inspecter"
    ],
    "inspection": [
        "inspection"
    ],
    "inspections": [
        "inspection",
        "inspecter"
    ],
    "inspectons": [
        "inspecter"
    ],
    "inspectrice": [
        "inspecteur"
    ],
    "inspecterent": [
        "inspecter"
    ],
    "inspectee": [
        "inspecter"
    ],
    "inspectees": [
        "inspecter"
    ],
    "inspira": [
        "inspirer"
    ],
    "inspirai": [
        "inspirer"
    ],
    "inspiraient": [
        "inspirer"
    ],
    "inspirais": [
        "inspirer"
    ],
    "inspirait": [
        "inspirer"
    ],
    "inspirant": [
        "inspirant",
        "inspirer"
    ],
    "inspirante": [
        "inspirant"
    ],
    "inspirantes": [
        "inspirant"
    ],
    "inspirants": [
        "inspirant"
    ],
    "inspirateur": [
        "inspirateur"
    ],
    "inspirateurs": [
        "inspirateur"
    ],
    "inspiration": [
        "inspiration"
    ],
    "inspirations": [
        "inspiration"
    ],
    "inspiratoire": [
        "inspiratoire"
    ],
    "inspiratrice": [
        "inspirateur"
    ],
    "inspiratrices": [
        "inspirateur"
    ],
    "inspire": [
        "inspirer",
        "inspire"
    ],
    "inspirent": [
        "inspirer"
    ],
    "inspirer": [
        "inspirer"
    ],
    "inspirera": [
        "inspirer"
    ],
    "inspireraient": [
        "inspirer"
    ],
    "inspirerait": [
        "inspirer"
    ],
    "inspireras": [
        "inspirer"
    ],
    "inspireront": [
        "inspirer"
    ],
    "inspires": [
        "inspirer",
        "inspire"
    ],
    "inspirez": [
        "inspirer"
    ],
    "inspiriez": [
        "inspirer"
    ],
    "inspirions": [
        "inspirer"
    ],
    "inspirat": [
        "inspirer"
    ],
    "inspirerent": [
        "inspirer"
    ],
    "inspiree": [
        "inspirer",
        "inspire"
    ],
    "inspirees": [
        "inspirer",
        "inspire"
    ],
    "instabilite": [
        "instabilite"
    ],
    "instable": [
        "instable"
    ],
    "instables": [
        "instable"
    ],
    "installa": [
        "installer"
    ],
    "installai": [
        "installer"
    ],
    "installaient": [
        "installer"
    ],
    "installais": [
        "installer"
    ],
    "installait": [
        "installer"
    ],
    "installant": [
        "installer"
    ],
    "installasse": [
        "installer"
    ],
    "installateur": [
        "installateur"
    ],
    "installation": [
        "installation"
    ],
    "installations": [
        "installation"
    ],
    "installe": [
        "installer"
    ],
    "installent": [
        "installer"
    ],
    "installer": [
        "installer"
    ],
    "installera": [
        "installer"
    ],
    "installerai": [
        "installer"
    ],
    "installeraient": [
        "installer"
    ],
    "installerais": [
        "installer"
    ],
    "installerait": [
        "installer"
    ],
    "installeras": [
        "installer"
    ],
    "installerez": [
        "installer"
    ],
    "installerions": [
        "installer"
    ],
    "installerons": [
        "installer"
    ],
    "installeront": [
        "installer"
    ],
    "installes": [
        "installer"
    ],
    "installeur": [
        "installeur"
    ],
    "installez": [
        "installer"
    ],
    "installiez": [
        "installer"
    ],
    "installions": [
        "installer"
    ],
    "installons": [
        "installer"
    ],
    "installames": [
        "installer"
    ],
    "installat": [
        "installer"
    ],
    "installerent": [
        "installer"
    ],
    "installee": [
        "installer"
    ],
    "installees": [
        "installer"
    ],
    "instamment": [
        "instamment"
    ],
    "instance": [
        "instance"
    ],
    "instances": [
        "instance"
    ],
    "instant": [
        "instant"
    ],
    "instantane": [
        "instantane"
    ],
    "instantanee": [
        "instantane"
    ],
    "instantanees": [
        "instantane"
    ],
    "instantaneite": [
        "instantaneite"
    ],
    "instantanement": [
        "instantanement"
    ],
    "instantanes": [
        "instantane"
    ],
    "instante": [
        "instant"
    ],
    "instantes": [
        "instant"
    ],
    "instants": [
        "instant"
    ],
    "instaura": [
        "instaurer"
    ],
    "instaurai": [
        "instaurer"
    ],
    "instaurait": [
        "instaurer"
    ],
    "instaurant": [
        "instaurer"
    ],
    "instauration": [
        "instauration"
    ],
    "instauratrice": [
        "instaurateur"
    ],
    "instaure": [
        "instaurer"
    ],
    "instaurer": [
        "instaurer"
    ],
    "instaurera": [
        "instaurer"
    ],
    "instaurerions": [
        "instaurer"
    ],
    "instaurions": [
        "instaurer"
    ],
    "instaurerent": [
        "instaurer"
    ],
    "instauree": [
        "instaurer"
    ],
    "instaurees": [
        "instaurer"
    ],
    "instaures": [
        "instaurer"
    ],
    "instigateur": [
        "instigateur"
    ],
    "instigateurs": [
        "instigateur"
    ],
    "instigation": [
        "instigation"
    ],
    "instigatrice": [
        "instigateur"
    ],
    "instilla": [
        "instiller"
    ],
    "instille": [
        "instiller"
    ],
    "instiller": [
        "instiller"
    ],
    "instillera": [
        "instiller"
    ],
    "instillees": [
        "instiller"
    ],
    "instinct": [
        "instinct"
    ],
    "instinctif": [
        "instinctif"
    ],
    "instinctifs": [
        "instinctif"
    ],
    "instinctive": [
        "instinctif"
    ],
    "instinctivement": [
        "instinctivement"
    ],
    "instinctives": [
        "instinctif"
    ],
    "instinctivo": [
        "instinctivo"
    ],
    "instincts": [
        "instinct"
    ],
    "instinctuel": [
        "instinctuel"
    ],
    "instit": [
        "instit"
    ],
    "instits": [
        "instit"
    ],
    "institua": [
        "instituer"
    ],
    "instituai": [
        "instituer"
    ],
    "instituaient": [
        "instituer"
    ],
    "instituait": [
        "instituer"
    ],
    "instituant": [
        "instituer"
    ],
    "institue": [
        "instituer"
    ],
    "instituent": [
        "instituer"
    ],
    "instituer": [
        "instituer"
    ],
    "instituons": [
        "instituer"
    ],
    "institut": [
        "institut"
    ],
    "instituteur": [
        "instituteur"
    ],
    "instituteurs": [
        "instituteur"
    ],
    "institution": [
        "institution"
    ],
    "institutionnalise": [
        "institutionnaliser"
    ],
    "institutionnel": [
        "institutionnel"
    ],
    "institutionnelle": [
        "institutionnel"
    ],
    "institutionnels": [
        "institutionnel"
    ],
    "institutions": [
        "institution"
    ],
    "institutrice": [
        "instituteur"
    ],
    "institutrices": [
        "instituteur"
    ],
    "instituts": [
        "institut"
    ],
    "instituerent": [
        "instituer"
    ],
    "instituee": [
        "instituer"
    ],
    "instituees": [
        "instituer"
    ],
    "institues": [
        "instituer"
    ],
    "instructeur": [
        "instructeur"
    ],
    "instructeurs": [
        "instructeur"
    ],
    "instructif": [
        "instructif"
    ],
    "instructifs": [
        "instructif"
    ],
    "instruction": [
        "instruction"
    ],
    "instructions": [
        "instruction"
    ],
    "instructive": [
        "instructif"
    ],
    "instructives": [
        "instructif"
    ],
    "instruira": [
        "instruire"
    ],
    "instruirai": [
        "instruire"
    ],
    "instruiraient": [
        "instruire"
    ],
    "instruirait": [
        "instruire"
    ],
    "instruire": [
        "instruire"
    ],
    "instruis": [
        "instruire"
    ],
    "instruisaient": [
        "instruire"
    ],
    "instruisais": [
        "instruire"
    ],
    "instruisait": [
        "instruire"
    ],
    "instruisant": [
        "instruire"
    ],
    "instruise": [
        "instruire"
    ],
    "instruisent": [
        "instruire"
    ],
    "instruisez": [
        "instruire"
    ],
    "instruisirent": [
        "instruire"
    ],
    "instruisis": [
        "instruire"
    ],
    "instruisit": [
        "instruire"
    ],
    "instruisimes": [
        "instruire"
    ],
    "instruit": [
        "instruit",
        "instruire"
    ],
    "instruite": [
        "instruit",
        "instruire"
    ],
    "instruites": [
        "instruit"
    ],
    "instruits": [
        "instruit",
        "instruire"
    ],
    "instrument": [
        "instrument"
    ],
    "instrumentais": [
        "instrumenter"
    ],
    "instrumental": [
        "instrumental"
    ],
    "instrumentale": [
        "instrumental"
    ],
    "instrumentation": [
        "instrumentation"
    ],
    "instrumentaux": [
        "instrumental"
    ],
    "instrumenter": [
        "instrumenter"
    ],
    "instrumentiste": [
        "instrumentiste"
    ],
    "instrumentistes": [
        "instrumentiste"
    ],
    "instruments": [
        "instrument"
    ],
    "insu": [
        "insu"
    ],
    "insubmersible": [
        "insubmersible"
    ],
    "insubmersibles": [
        "insubmersible"
    ],
    "insubordination": [
        "insubordination"
    ],
    "insubordinations": [
        "insubordination"
    ],
    "insubordonne": [
        "insubordonne"
    ],
    "insubordonnee": [
        "insubordonne"
    ],
    "insucces": [
        "insucces"
    ],
    "insuffisamment": [
        "insuffisamment"
    ],
    "insuffisance": [
        "insuffisance"
    ],
    "insuffisances": [
        "insuffisance"
    ],
    "insuffisant": [
        "insuffisant"
    ],
    "insuffisante": [
        "insuffisant"
    ],
    "insuffisantes": [
        "insuffisant"
    ],
    "insuffisants": [
        "insuffisant"
    ],
    "insufflaient": [
        "insuffler"
    ],
    "insufflait": [
        "insuffler"
    ],
    "insufflant": [
        "insuffler"
    ],
    "insufflateur": [
        "insufflateur"
    ],
    "insuffle": [
        "insuffler"
    ],
    "insufflent": [
        "insuffler"
    ],
    "insuffler": [
        "insuffler"
    ],
    "insufflera": [
        "insuffler"
    ],
    "insufflee": [
        "insuffler"
    ],
    "insufflees": [
        "insuffler"
    ],
    "insula": [
        "insula"
    ],
    "insulaire": [
        "insulaire"
    ],
    "insulaires": [
        "insulaire"
    ],
    "insularite": [
        "insularite"
    ],
    "insulation": [
        "insulation"
    ],
    "insuline": [
        "insuline"
    ],
    "insulinique": [
        "insulinique"
    ],
    "insulta": [
        "insulter"
    ],
    "insultaient": [
        "insulter"
    ],
    "insultais": [
        "insulter"
    ],
    "insultait": [
        "insulter"
    ],
    "insultant": [
        "insulter",
        "insultant"
    ],
    "insultante": [
        "insultant"
    ],
    "insultantes": [
        "insultant"
    ],
    "insultants": [
        "insultant"
    ],
    "insulte": [
        "insulter",
        "insulte"
    ],
    "insultent": [
        "insulter"
    ],
    "insulter": [
        "insulter"
    ],
    "insulterai": [
        "insulter"
    ],
    "insulterais": [
        "insulter"
    ],
    "insulteras": [
        "insulter"
    ],
    "insultes": [
        "insulter",
        "insulte"
    ],
    "insulteur": [
        "insulteur"
    ],
    "insulteurs": [
        "insulteur"
    ],
    "insultez": [
        "insulter"
    ],
    "insultions": [
        "insulter"
    ],
    "insultons": [
        "insulter"
    ],
    "insultee": [
        "insulter",
        "insulte"
    ],
    "insultees": [
        "insulter"
    ],
    "insupportable": [
        "insupportable"
    ],
    "insupportablement": [
        "insupportablement"
    ],
    "insupportables": [
        "insupportable"
    ],
    "insupportaient": [
        "insupporter"
    ],
    "insupporte": [
        "insupporter"
    ],
    "insupportent": [
        "insupporter"
    ],
    "insurge": [
        "insurge",
        "insurger"
    ],
    "insurgea": [
        "insurger"
    ],
    "insurgeai": [
        "insurger"
    ],
    "insurgeaient": [
        "insurger"
    ],
    "insurgeais": [
        "insurger"
    ],
    "insurgeait": [
        "insurger"
    ],
    "insurgeant": [
        "insurger"
    ],
    "insurgent": [
        "insurger"
    ],
    "insurgeons": [
        "insurger"
    ],
    "insurger": [
        "insurger"
    ],
    "insurgera": [
        "insurger"
    ],
    "insurgerai": [
        "insurger"
    ],
    "insurgerait": [
        "insurger"
    ],
    "insurgeat": [
        "insurger"
    ],
    "insurgerent": [
        "insurger"
    ],
    "insurgee": [
        "insurge",
        "insurger"
    ],
    "insurges": [
        "insurge",
        "insurger"
    ],
    "insurmontable": [
        "insurmontable"
    ],
    "insurmontables": [
        "insurmontable"
    ],
    "insurpassable": [
        "insurpassable"
    ],
    "insurpasse": [
        "insurpasse"
    ],
    "insurrection": [
        "insurrection"
    ],
    "insurrectionnel": [
        "insurrectionnel"
    ],
    "insurrectionnelle": [
        "insurrectionnel"
    ],
    "insurrections": [
        "insurrection"
    ],
    "insere": [
        "inserer"
    ],
    "inserent": [
        "inserer"
    ],
    "insecable": [
        "insecable"
    ],
    "insecurite": [
        "insecurite"
    ],
    "insecurites": [
        "insecurite"
    ],
    "inseminateur": [
        "inseminateur"
    ],
    "insemination": [
        "insemination"
    ],
    "inseminations": [
        "insemination"
    ],
    "inseminer": [
        "inseminer"
    ],
    "insemine": [
        "inseminer"
    ],
    "inseminee": [
        "inseminer"
    ],
    "insemines": [
        "inseminer"
    ],
    "inseparabilite": [
        "inseparabilite"
    ],
    "inseparable": [
        "inseparable"
    ],
    "inseparablement": [
        "inseparablement"
    ],
    "inseparables": [
        "inseparable"
    ],
    "insera": [
        "inserer"
    ],
    "inseraient": [
        "inserer"
    ],
    "inserait": [
        "inserer"
    ],
    "inserant": [
        "inserer"
    ],
    "inserer": [
        "inserer"
    ],
    "inserera": [
        "inserer"
    ],
    "insererait": [
        "inserer"
    ],
    "insererons": [
        "inserer"
    ],
    "inserez": [
        "inserer"
    ],
    "inserons": [
        "inserer"
    ],
    "insererent": [
        "inserer"
    ],
    "inseree": [
        "inserer"
    ],
    "inserees": [
        "inserer"
    ],
    "inseres": [
        "inserer"
    ],
    "intact": [
        "intact"
    ],
    "intacte": [
        "intact"
    ],
    "intactes": [
        "intact"
    ],
    "intacts": [
        "intact"
    ],
    "intaille": [
        "intaille"
    ],
    "intailles": [
        "intaille"
    ],
    "intangibilite": [
        "intangibilite"
    ],
    "intangible": [
        "intangible"
    ],
    "intangibles": [
        "intangible"
    ],
    "intarissable": [
        "intarissable"
    ],
    "intarissablement": [
        "intarissablement"
    ],
    "intarissables": [
        "intarissable"
    ],
    "intellect": [
        "intellect"
    ],
    "intellectualisation": [
        "intellectualisation"
    ],
    "intellectualise": [
        "intellectualiser"
    ],
    "intellectualiser": [
        "intellectualiser"
    ],
    "intellectualisme": [
        "intellectualisme"
    ],
    "intellectualiste": [
        "intellectualiste"
    ],
    "intellectualisees": [
        "intellectualiser"
    ],
    "intellectuel": [
        "intellectuel"
    ],
    "intellectuelle": [
        "intellectuel"
    ],
    "intellectuellement": [
        "intellectuellement"
    ],
    "intellectuelles": [
        "intellectuel"
    ],
    "intellectuels": [
        "intellectuel"
    ],
    "intellige": [
        "intelliger"
    ],
    "intelligemment": [
        "intelligemment"
    ],
    "intelligence": [
        "intelligence"
    ],
    "intelligences": [
        "intelligence"
    ],
    "intelligent": [
        "intelligent"
    ],
    "intelligente": [
        "intelligent"
    ],
    "intelligentes": [
        "intelligent"
    ],
    "intelligents": [
        "intelligent"
    ],
    "intelligentsia": [
        "intelligentsia"
    ],
    "intelligibilite": [
        "intelligibilite"
    ],
    "intelligible": [
        "intelligible"
    ],
    "intelligiblement": [
        "intelligiblement"
    ],
    "intelligibles": [
        "intelligible"
    ],
    "intello": [
        "intello"
    ],
    "intellos": [
        "intello"
    ],
    "intempestif": [
        "intempestif"
    ],
    "intempestifs": [
        "intempestif"
    ],
    "intempestive": [
        "intempestif"
    ],
    "intempestivement": [
        "intempestivement"
    ],
    "intempestives": [
        "intempestif"
    ],
    "intemporalite": [
        "intemporalite"
    ],
    "intemporel": [
        "intemporel"
    ],
    "intemporelle": [
        "intemporel"
    ],
    "intemporelles": [
        "intemporel"
    ],
    "intemperance": [
        "intemperance"
    ],
    "intemperances": [
        "intemperance"
    ],
    "intemperante": [
        "intemperant"
    ],
    "intemperies": [
        "intemperie"
    ],
    "intenable": [
        "intenable"
    ],
    "intenables": [
        "intenable"
    ],
    "intendance": [
        "intendance"
    ],
    "intendances": [
        "intendance"
    ],
    "intendant": [
        "intendant"
    ],
    "intendante": [
        "intendant"
    ],
    "intendants": [
        "intendant"
    ],
    "intense": [
        "intense"
    ],
    "intenses": [
        "intense"
    ],
    "intensif": [
        "intensif"
    ],
    "intensifia": [
        "intensifier"
    ],
    "intensifiaient": [
        "intensifier"
    ],
    "intensifiait": [
        "intensifier"
    ],
    "intensifiant": [
        "intensifier"
    ],
    "intensification": [
        "intensification"
    ],
    "intensifie": [
        "intensifier"
    ],
    "intensifient": [
        "intensifier"
    ],
    "intensifier": [
        "intensifier"
    ],
    "intensifiez": [
        "intensifier"
    ],
    "intensifiee": [
        "intensifier"
    ],
    "intensifiees": [
        "intensifier"
    ],
    "intensifs": [
        "intensif"
    ],
    "intension": [
        "intension"
    ],
    "intensite": [
        "intensite"
    ],
    "intensites": [
        "intensite"
    ],
    "intensive": [
        "intensif"
    ],
    "intensivement": [
        "intensivement"
    ],
    "intensives": [
        "intensive",
        "intensif"
    ],
    "intensement": [
        "intensement"
    ],
    "intenta": [
        "intenter"
    ],
    "intentait": [
        "intenter"
    ],
    "intente": [
        "intenter"
    ],
    "intenter": [
        "intenter"
    ],
    "intentera": [
        "intenter"
    ],
    "intenterai": [
        "intenter"
    ],
    "intention": [
        "intention"
    ],
    "intentionnalite": [
        "intentionnalite"
    ],
    "intentionnel": [
        "intentionnel"
    ],
    "intentionnelle": [
        "intentionnel"
    ],
    "intentionnellement": [
        "intentionnellement"
    ],
    "intentionnels": [
        "intentionnel"
    ],
    "intentionne": [
        "intentionne"
    ],
    "intentionnee": [
        "intentionne"
    ],
    "intentionnees": [
        "intentionne"
    ],
    "intentionnes": [
        "intentionne"
    ],
    "intentions": [
        "intention",
        "intenter"
    ],
    "intentee": [
        "intenter"
    ],
    "intentees": [
        "intenter"
    ],
    "intentes": [
        "intenter"
    ],
    "inter": [
        "inter"
    ],
    "interactif": [
        "interactif"
    ],
    "interactifs": [
        "interactif"
    ],
    "interaction": [
        "interaction"
    ],
    "interactions": [
        "interaction"
    ],
    "interactive": [
        "interactif"
    ],
    "interactivite": [
        "interactivite"
    ],
    "interagir": [
        "interagir"
    ],
    "interagis": [
        "interagir"
    ],
    "interagissais": [
        "interagir"
    ],
    "interagissant": [
        "interagir"
    ],
    "interagit": [
        "interagir"
    ],
    "interallie": [
        "interallie"
    ],
    "interalliee": [
        "interallie"
    ],
    "interalliees": [
        "interallie"
    ],
    "interallies": [
        "interallie"
    ],
    "interarmes": [
        "interarmes"
    ],
    "interarmees": [
        "interarmees"
    ],
    "intercalaient": [
        "intercaler"
    ],
    "intercalaire": [
        "intercalaire"
    ],
    "intercalaires": [
        "intercalaire"
    ],
    "intercalait": [
        "intercaler"
    ],
    "intercalant": [
        "intercaler"
    ],
    "intercale": [
        "intercaler"
    ],
    "intercalent": [
        "intercaler"
    ],
    "intercaler": [
        "intercaler"
    ],
    "intercalera": [
        "intercaler"
    ],
    "intercalerai": [
        "intercaler"
    ],
    "intercalerez": [
        "intercaler"
    ],
    "intercalee": [
        "intercale"
    ],
    "intercalees": [
        "intercaler",
        "intercale"
    ],
    "intercales": [
        "intercaler",
        "intercale"
    ],
    "intercellulaire": [
        "intercellulaire"
    ],
    "intercepta": [
        "intercepter"
    ],
    "interceptai": [
        "intercepter"
    ],
    "interceptais": [
        "intercepter"
    ],
    "interceptait": [
        "intercepter"
    ],
    "interceptant": [
        "intercepter"
    ],
    "intercepte": [
        "intercepter"
    ],
    "interceptent": [
        "intercepter"
    ],
    "intercepter": [
        "intercepter"
    ],
    "interceptera": [
        "intercepter"
    ],
    "intercepterait": [
        "intercepter"
    ],
    "intercepterez": [
        "intercepter"
    ],
    "intercepterons": [
        "intercepter"
    ],
    "intercepteur": [
        "intercepteur"
    ],
    "intercepteurs": [
        "intercepteur"
    ],
    "interceptez": [
        "intercepter"
    ],
    "interception": [
        "interception"
    ],
    "interceptions": [
        "interception",
        "intercepter"
    ],
    "intercepterent": [
        "intercepter"
    ],
    "interceptee": [
        "intercepter"
    ],
    "interceptees": [
        "intercepter"
    ],
    "interceptes": [
        "intercepter"
    ],
    "intercesseur": [
        "intercesseur"
    ],
    "intercesseurs": [
        "intercesseur"
    ],
    "intercession": [
        "intercession"
    ],
    "interchangeable": [
        "interchangeable"
    ],
    "interchangeables": [
        "interchangeable"
    ],
    "interchanger": [
        "interchanger"
    ],
    "interchange": [
        "interchanger"
    ],
    "interclasse": [
        "interclasse"
    ],
    "interclasses": [
        "interclasse"
    ],
    "interclubs": [
        "interclubs"
    ],
    "intercommunal": [
        "intercommunal"
    ],
    "intercommunautaire": [
        "intercommunautaire"
    ],
    "intercommunication": [
        "intercommunication"
    ],
    "interconnecte": [
        "interconnecter"
    ],
    "interconnectee": [
        "interconnecter"
    ],
    "interconnexion": [
        "interconnexion"
    ],
    "intercontinental": [
        "intercontinental"
    ],
    "intercontinentale": [
        "intercontinental"
    ],
    "intercontinentales": [
        "intercontinental"
    ],
    "intercontinentaux": [
        "intercontinental"
    ],
    "intercostal": [
        "intercostal"
    ],
    "intercostale": [
        "intercostal"
    ],
    "intercostaux": [
        "intercostal"
    ],
    "intercours": [
        "intercours"
    ],
    "intercourse": [
        "intercourse"
    ],
    "interculturel": [
        "interculturel"
    ],
    "interculturels": [
        "interculturel"
    ],
    "intercede": [
        "interceder"
    ],
    "interceda": [
        "interceder"
    ],
    "intercedait": [
        "interceder"
    ],
    "intercedant": [
        "interceder"
    ],
    "interceder": [
        "interceder"
    ],
    "intercedera": [
        "interceder"
    ],
    "intercederai": [
        "interceder"
    ],
    "interdiction": [
        "interdiction"
    ],
    "interdictions": [
        "interdiction"
    ],
    "interdira": [
        "interdire"
    ],
    "interdirai": [
        "interdire"
    ],
    "interdiraient": [
        "interdire"
    ],
    "interdirais": [
        "interdire"
    ],
    "interdirait": [
        "interdire"
    ],
    "interdire": [
        "interdire"
    ],
    "interdirent": [
        "interdire"
    ],
    "interdis": [
        "interdire"
    ],
    "interdisaient": [
        "interdire"
    ],
    "interdisais": [
        "interdire"
    ],
    "interdisait": [
        "interdire"
    ],
    "interdisant": [
        "interdire"
    ],
    "interdisciplinaires": [
        "interdisciplinaire"
    ],
    "interdise": [
        "interdire"
    ],
    "interdisent": [
        "interdire"
    ],
    "interdisez": [
        "interdire"
    ],
    "interdisiez": [
        "interdire"
    ],
    "interdisons": [
        "interdire"
    ],
    "interdissent": [
        "interdire"
    ],
    "interdit": [
        "interdit",
        "interdire"
    ],
    "interdite": [
        "interdit",
        "interdire"
    ],
    "interdites": [
        "interdit",
        "interdire"
    ],
    "interdits": [
        "interdit",
        "interdire"
    ],
    "interdepartementaux": [
        "interdepartemental"
    ],
    "interdependance": [
        "interdependance"
    ],
    "interdependant": [
        "interdependant"
    ],
    "interethnique": [
        "interethnique"
    ],
    "interface": [
        "interface"
    ],
    "interfacer": [
        "interfacer"
    ],
    "interfaces": [
        "interface"
    ],
    "interfere": [
        "interferer"
    ],
    "interferent": [
        "interferer",
        "interferent"
    ],
    "interferaient": [
        "interferer"
    ],
    "interferait": [
        "interferer"
    ],
    "interferant": [
        "interferer"
    ],
    "interference": [
        "interference"
    ],
    "interferences": [
        "interference"
    ],
    "interferer": [
        "interferer"
    ],
    "interferez": [
        "interferer"
    ],
    "interferometrie": [
        "interferometrie"
    ],
    "interferon": [
        "interferon"
    ],
    "interferons": [
        "interferon",
        "interferer"
    ],
    "intergalactique": [
        "intergalactique"
    ],
    "intergalactiques": [
        "intergalactique"
    ],
    "interglaciaire": [
        "interglaciaire"
    ],
    "intergouvernemental": [
        "intergouvernemental"
    ],
    "intergouvernementale": [
        "intergouvernemental"
    ],
    "interjecter": [
        "interjecter"
    ],
    "interjection": [
        "interjection"
    ],
    "interjections": [
        "interjection"
    ],
    "interjeta": [
        "interjeter"
    ],
    "interjeter": [
        "interjeter"
    ],
    "interligne": [
        "interligne"
    ],
    "interlignes": [
        "interligner",
        "interligne"
    ],
    "interlocuteur": [
        "interlocuteur"
    ],
    "interlocuteurs": [
        "interlocuteur"
    ],
    "interlocutoire": [
        "interlocutoire"
    ],
    "interlocutoires": [
        "interlocutoire"
    ],
    "interlocutrice": [
        "interlocuteur"
    ],
    "interlocutrices": [
        "interlocuteur"
    ],
    "interlope": [
        "interlope"
    ],
    "interlopes": [
        "interlope"
    ],
    "interloque": [
        "interloque",
        "interloquer"
    ],
    "interloquee": [
        "interloque",
        "interloquer"
    ],
    "interloquees": [
        "interloque"
    ],
    "interloques": [
        "interloque",
        "interloquer"
    ],
    "interlude": [
        "interlude"
    ],
    "interludes": [
        "interlude"
    ],
    "intermezzo": [
        "intermezzo"
    ],
    "interminable": [
        "interminable"
    ],
    "interminablement": [
        "interminablement"
    ],
    "interminables": [
        "interminable"
    ],
    "interministerielles": [
        "interministeriel"
    ],
    "interministeriels": [
        "interministeriel"
    ],
    "intermission": [
        "intermission"
    ],
    "intermittence": [
        "intermittence"
    ],
    "intermittences": [
        "intermittence"
    ],
    "intermittent": [
        "intermittent"
    ],
    "intermittente": [
        "intermittent"
    ],
    "intermittentes": [
        "intermittent"
    ],
    "intermittents": [
        "intermittent"
    ],
    "intermede": [
        "intermede"
    ],
    "intermedes": [
        "intermede"
    ],
    "intermediaire": [
        "intermediaire"
    ],
    "intermediaires": [
        "intermediaire"
    ],
    "internat": [
        "internat"
    ],
    "international": [
        "international"
    ],
    "internationale": [
        "international"
    ],
    "internationalement": [
        "internationalement"
    ],
    "internationales": [
        "international"
    ],
    "internationalisation": [
        "internationalisation"
    ],
    "internationalisme": [
        "internationalisme"
    ],
    "internationaliste": [
        "internationaliste"
    ],
    "internationalistes": [
        "internationaliste"
    ],
    "internationalisee": [
        "internationaliser"
    ],
    "internationalises": [
        "internationaliser"
    ],
    "internationaux": [
        "international"
    ],
    "internats": [
        "internat"
    ],
    "internaute": [
        "internaute"
    ],
    "internautes": [
        "internaute"
    ],
    "interne": [
        "interne",
        "interner"
    ],
    "internement": [
        "internement"
    ],
    "interner": [
        "interner"
    ],
    "internes": [
        "interne",
        "interner"
    ],
    "internet": [
        "internet"
    ],
    "internez": [
        "interner"
    ],
    "interniste": [
        "interniste"
    ],
    "internee": [
        "interne",
        "interner"
    ],
    "internees": [
        "interne",
        "interner"
    ],
    "interpella": [
        "interpeller"
    ],
    "interpellai": [
        "interpeller"
    ],
    "interpellaient": [
        "interpeller"
    ],
    "interpellais": [
        "interpeller"
    ],
    "interpellait": [
        "interpeller"
    ],
    "interpellant": [
        "interpeller"
    ],
    "interpellateur": [
        "interpellateur"
    ],
    "interpellateurs": [
        "interpellateur"
    ],
    "interpellation": [
        "interpellation"
    ],
    "interpellations": [
        "interpellation"
    ],
    "interpelle": [
        "interpeller"
    ],
    "interpellent": [
        "interpeller"
    ],
    "interpeller": [
        "interpeller"
    ],
    "interpellerait": [
        "interpeller"
    ],
    "interpellez": [
        "interpeller"
    ],
    "interpellerent": [
        "interpeller"
    ],
    "interpellee": [
        "interpeller"
    ],
    "interpellees": [
        "interpeller"
    ],
    "interpelles": [
        "interpeller"
    ],
    "interphase": [
        "interphase"
    ],
    "interphone": [
        "interphone"
    ],
    "interphones": [
        "interphone"
    ],
    "interplanetaire": [
        "interplanetaire"
    ],
    "interplanetaires": [
        "interplanetaire"
    ],
    "interpolateur": [
        "interpolateur"
    ],
    "interpolation": [
        "interpolation"
    ],
    "interpolations": [
        "interpolation"
    ],
    "interpole": [
        "interpoler"
    ],
    "interpolez": [
        "interpoler"
    ],
    "interposa": [
        "interposer"
    ],
    "interposai": [
        "interposer"
    ],
    "interposaient": [
        "interposer"
    ],
    "interposais": [
        "interposer"
    ],
    "interposait": [
        "interposer"
    ],
    "interposant": [
        "interposer"
    ],
    "interpose": [
        "interposer",
        "interpose"
    ],
    "interposent": [
        "interposer"
    ],
    "interposer": [
        "interposer"
    ],
    "interposera": [
        "interposer"
    ],
    "interposeront": [
        "interposer"
    ],
    "interposez": [
        "interposer"
    ],
    "interposition": [
        "interposition"
    ],
    "interposerent": [
        "interposer"
    ],
    "interposee": [
        "interposer",
        "interpose"
    ],
    "interposees": [
        "interposer",
        "interpose"
    ],
    "interposes": [
        "interposer",
        "interpose"
    ],
    "interprofessionnelle": [
        "interprofessionnel"
    ],
    "interprete": [
        "interprete",
        "interpreter"
    ],
    "interpretent": [
        "interpreter"
    ],
    "interpretes": [
        "interprete",
        "interpreter"
    ],
    "interpreta": [
        "interpreter"
    ],
    "interpretable": [
        "interpretable"
    ],
    "interpretai": [
        "interpreter"
    ],
    "interpretaient": [
        "interpreter"
    ],
    "interpretais": [
        "interpreter"
    ],
    "interpretait": [
        "interpreter"
    ],
    "interpretant": [
        "interpreter"
    ],
    "interpretante": [
        "interpretant"
    ],
    "interpretatif": [
        "interpretatif"
    ],
    "interpretation": [
        "interpretation"
    ],
    "interpretations": [
        "interpretation"
    ],
    "interpretative": [
        "interpretatif"
    ],
    "interpretatives": [
        "interpretatif"
    ],
    "interpreter": [
        "interpreter"
    ],
    "interpretera": [
        "interpreter"
    ],
    "interpreteraient": [
        "interpreter"
    ],
    "interpreterait": [
        "interpreter"
    ],
    "interpreteriez": [
        "interpreter"
    ],
    "interpreteur": [
        "interpreteur"
    ],
    "interpretez": [
        "interpreter"
    ],
    "interpretat": [
        "interpreter"
    ],
    "interpreterent": [
        "interpreter"
    ],
    "interpretee": [
        "interpreter"
    ],
    "interpretees": [
        "interpreter"
    ],
    "interpenetre": [
        "interpenetrer"
    ],
    "interpenetrent": [
        "interpenetrer"
    ],
    "interpenetration": [
        "interpenetration"
    ],
    "interpenetrations": [
        "interpenetration"
    ],
    "interpenetrer": [
        "interpenetrer"
    ],
    "interracial": [
        "interracial"
    ],
    "interraciale": [
        "interracial"
    ],
    "interraciaux": [
        "interracial"
    ],
    "interrelations": [
        "interrelation"
    ],
    "interrogateur": [
        "interrogateur"
    ],
    "interrogateurs": [
        "interrogateur"
    ],
    "interrogatif": [
        "interrogatif"
    ],
    "interrogatifs": [
        "interrogatif"
    ],
    "interrogation": [
        "interrogation"
    ],
    "interrogations": [
        "interrogation"
    ],
    "interrogative": [
        "interrogative",
        "interrogatif"
    ],
    "interrogativement": [
        "interrogativement"
    ],
    "interrogatives": [
        "interrogatif"
    ],
    "interrogatoire": [
        "interrogatoire"
    ],
    "interrogatoires": [
        "interrogatoire"
    ],
    "interrogatrice": [
        "interrogateur"
    ],
    "interroge": [
        "interroger"
    ],
    "interrogea": [
        "interroger"
    ],
    "interrogeai": [
        "interroger"
    ],
    "interrogeaient": [
        "interroger"
    ],
    "interrogeais": [
        "interroger"
    ],
    "interrogeait": [
        "interroger"
    ],
    "interrogeant": [
        "interroger",
        "interrogeant"
    ],
    "interrogent": [
        "interroger"
    ],
    "interrogeons": [
        "interroger"
    ],
    "interroger": [
        "interroger"
    ],
    "interrogera": [
        "interroger"
    ],
    "interrogerai": [
        "interroger"
    ],
    "interrogeraient": [
        "interroger"
    ],
    "interrogerais": [
        "interroger"
    ],
    "interrogerait": [
        "interroger"
    ],
    "interrogeras": [
        "interroger"
    ],
    "interrogerez": [
        "interroger"
    ],
    "interrogerons": [
        "interroger"
    ],
    "interrogeront": [
        "interroger"
    ],
    "interroges": [
        "interroger"
    ],
    "interrogez": [
        "interroger"
    ],
    "interrogeames": [
        "interroger"
    ],
    "interrogeat": [
        "interroger"
    ],
    "interrogiez": [
        "interroger"
    ],
    "interrogions": [
        "interroger"
    ],
    "interrogerent": [
        "interroger"
    ],
    "interrogee": [
        "interroger"
    ],
    "interrogees": [
        "interroger"
    ],
    "interrompaient": [
        "interrompre"
    ],
    "interrompais": [
        "interrompre"
    ],
    "interrompait": [
        "interrompre"
    ],
    "interrompant": [
        "interrompre"
    ],
    "interrompe": [
        "interrompre"
    ],
    "interrompent": [
        "interrompre"
    ],
    "interrompes": [
        "interrompre"
    ],
    "interrompez": [
        "interrompre"
    ],
    "interrompiez": [
        "interrompre"
    ],
    "interrompirent": [
        "interrompre"
    ],
    "interrompis": [
        "interrompre"
    ],
    "interrompisse": [
        "interrompre"
    ],
    "interrompit": [
        "interrompre"
    ],
    "interrompons": [
        "interrompre"
    ],
    "interrompra": [
        "interrompre"
    ],
    "interromprai": [
        "interrompre"
    ],
    "interromprais": [
        "interrompre"
    ],
    "interromprait": [
        "interrompre"
    ],
    "interrompras": [
        "interrompre"
    ],
    "interrompre": [
        "interrompre"
    ],
    "interromps": [
        "interrompre"
    ],
    "interrompt": [
        "interrompre"
    ],
    "interrompu": [
        "interrompu",
        "interrompre"
    ],
    "interrompue": [
        "interrompu",
        "interrompre"
    ],
    "interrompues": [
        "interrompu",
        "interrompre"
    ],
    "interrompus": [
        "interrompu",
        "interrompre"
    ],
    "interrupteur": [
        "interrupteur"
    ],
    "interrupteurs": [
        "interrupteur"
    ],
    "interruption": [
        "interruption"
    ],
    "interruptions": [
        "interruption"
    ],
    "interregne": [
        "interregne"
    ],
    "inters": [
        "inter"
    ],
    "intersaison": [
        "intersaison"
    ],
    "interscolaire": [
        "interscolaire"
    ],
    "intersectant": [
        "intersecter"
    ],
    "intersection": [
        "intersection"
    ],
    "intersections": [
        "intersection"
    ],
    "interservices": [
        "interservices"
    ],
    "intersideral": [
        "intersideral"
    ],
    "intersiderale": [
        "intersideral"
    ],
    "intersideraux": [
        "intersideral"
    ],
    "interstellaire": [
        "interstellaire"
    ],
    "interstellaires": [
        "interstellaire"
    ],
    "interstice": [
        "interstice"
    ],
    "interstices": [
        "interstice"
    ],
    "intersubjectif": [
        "intersubjectif"
    ],
    "intertitre": [
        "intertitre"
    ],
    "intertribal": [
        "intertribal"
    ],
    "interurbain": [
        "interurbain"
    ],
    "interurbaine": [
        "interurbain"
    ],
    "intervalle": [
        "intervalle"
    ],
    "intervalles": [
        "intervalle"
    ],
    "intervenaient": [
        "intervenir"
    ],
    "intervenais": [
        "intervenir"
    ],
    "intervenait": [
        "intervenir"
    ],
    "intervenant": [
        "intervenir",
        "intervenant"
    ],
    "intervenante": [
        "intervenant"
    ],
    "intervenants": [
        "intervenant"
    ],
    "intervenez": [
        "intervenir"
    ],
    "interveniez": [
        "intervenir"
    ],
    "intervenir": [
        "intervenir"
    ],
    "intervenons": [
        "intervenir"
    ],
    "intervention": [
        "intervention"
    ],
    "interventionnisme": [
        "interventionnisme"
    ],
    "interventionniste": [
        "interventionniste"
    ],
    "interventionnistes": [
        "interventionniste"
    ],
    "interventions": [
        "intervention"
    ],
    "interventriculaire": [
        "interventriculaire"
    ],
    "intervenu": [
        "intervenir"
    ],
    "intervenue": [
        "intervenir"
    ],
    "intervenues": [
        "intervenir"
    ],
    "intervenus": [
        "intervenir"
    ],
    "interversion": [
        "interversion"
    ],
    "interversions": [
        "interversion"
    ],
    "interverti": [
        "intervertir"
    ],
    "intervertir": [
        "intervertir"
    ],
    "intervertirai": [
        "intervertir"
    ],
    "intervertis": [
        "intervertir"
    ],
    "intervertissait": [
        "intervertir"
    ],
    "intervertissent": [
        "intervertir"
    ],
    "intervertissiez": [
        "intervertir"
    ],
    "intervertissons": [
        "intervertir"
    ],
    "intervertit": [
        "intervertir"
    ],
    "intervertebral": [
        "intervertebral"
    ],
    "intervertebraux": [
        "intervertebral"
    ],
    "interviendra": [
        "intervenir"
    ],
    "interviendrai": [
        "intervenir"
    ],
    "interviendraient": [
        "intervenir"
    ],
    "interviendrais": [
        "intervenir"
    ],
    "interviendrait": [
        "intervenir"
    ],
    "interviendrez": [
        "intervenir"
    ],
    "interviendrons": [
        "intervenir"
    ],
    "interviendront": [
        "intervenir"
    ],
    "intervienne": [
        "intervenir"
    ],
    "interviennent": [
        "intervenir"
    ],
    "interviens": [
        "intervenir"
    ],
    "intervient": [
        "intervenir"
    ],
    "interview": [
        "interview"
    ],
    "interviewaient": [
        "interviewer"
    ],
    "interviewais": [
        "interviewer"
    ],
    "interviewait": [
        "interviewer"
    ],
    "interviewe": [
        "interviewer",
        "interviewe"
    ],
    "interviewer": [
        "interviewer"
    ],
    "interviewers": [
        "interviewer"
    ],
    "intervieweur": [
        "intervieweur"
    ],
    "interviews": [
        "interview"
    ],
    "interviewerent": [
        "interviewer"
    ],
    "interviewee": [
        "interviewer"
    ],
    "interviewes": [
        "interviewer",
        "interviewe"
    ],
    "intervinrent": [
        "intervenir"
    ],
    "intervins": [
        "intervenir"
    ],
    "intervinsse": [
        "intervenir"
    ],
    "intervint": [
        "intervenir"
    ],
    "interzones": [
        "interzone"
    ],
    "interetatique": [
        "interetatique"
    ],
    "intestat": [
        "intestat"
    ],
    "intestats": [
        "intestat"
    ],
    "intestin": [
        "intestin"
    ],
    "intestinal": [
        "intestinal"
    ],
    "intestinale": [
        "intestinal"
    ],
    "intestinales": [
        "intestinal"
    ],
    "intestinaux": [
        "intestinal"
    ],
    "intestine": [
        "intestin"
    ],
    "intestines": [
        "intestin",
        "intestine"
    ],
    "intestins": [
        "intestin"
    ],
    "inti": [
        "inti"
    ],
    "intifada": [
        "intifada"
    ],
    "intima": [
        "intimer"
    ],
    "intimait": [
        "intimer"
    ],
    "intimant": [
        "intimer"
    ],
    "intimation": [
        "intimation"
    ],
    "intime": [
        "intime",
        "intimer"
    ],
    "intimement": [
        "intimement"
    ],
    "intimer": [
        "intimer"
    ],
    "intimerait": [
        "intimer"
    ],
    "intimes": [
        "intime",
        "intimer"
    ],
    "intimida": [
        "intimider"
    ],
    "intimidable": [
        "intimidable"
    ],
    "intimidaient": [
        "intimider"
    ],
    "intimidais": [
        "intimider"
    ],
    "intimidait": [
        "intimider"
    ],
    "intimidant": [
        "intimider",
        "intimidant"
    ],
    "intimidante": [
        "intimidant"
    ],
    "intimidants": [
        "intimidant"
    ],
    "intimidateur": [
        "intimidateur"
    ],
    "intimidation": [
        "intimidation"
    ],
    "intimidations": [
        "intimidation"
    ],
    "intimide": [
        "intimider"
    ],
    "intimident": [
        "intimider"
    ],
    "intimider": [
        "intimider"
    ],
    "intimiderait": [
        "intimider"
    ],
    "intimides": [
        "intimider"
    ],
    "intimidez": [
        "intimider"
    ],
    "intimidiez": [
        "intimider"
    ],
    "intimidat": [
        "intimider"
    ],
    "intimidee": [
        "intimider"
    ],
    "intimidees": [
        "intimider"
    ],
    "intimiste": [
        "intimiste"
    ],
    "intimistes": [
        "intimiste"
    ],
    "intimite": [
        "intimite"
    ],
    "intimites": [
        "intimite"
    ],
    "intimat": [
        "intimer"
    ],
    "intimerent": [
        "intimer"
    ],
    "intirable": [
        "intirable"
    ],
    "intitula": [
        "intituler"
    ],
    "intitulai": [
        "intituler"
    ],
    "intitulaient": [
        "intituler"
    ],
    "intitulais": [
        "intituler"
    ],
    "intitulait": [
        "intituler"
    ],
    "intitulant": [
        "intituler"
    ],
    "intitule": [
        "intitule",
        "intituler"
    ],
    "intituler": [
        "intituler"
    ],
    "intitulerait": [
        "intituler"
    ],
    "intitulee": [
        "intituler"
    ],
    "intitulees": [
        "intituler"
    ],
    "intitules": [
        "intitule",
        "intituler"
    ],
    "intolerable": [
        "intolerable"
    ],
    "intolerablement": [
        "intolerablement"
    ],
    "intolerables": [
        "intolerable"
    ],
    "intolerance": [
        "intolerance"
    ],
    "intolerant": [
        "intolerant"
    ],
    "intolerante": [
        "intolerant"
    ],
    "intolerants": [
        "intolerant"
    ],
    "intonation": [
        "intonation"
    ],
    "intonations": [
        "intonation"
    ],
    "intouchable": [
        "intouchable"
    ],
    "intouchables": [
        "intouchable"
    ],
    "intouche": [
        "intouche"
    ],
    "intouchee": [
        "intouche"
    ],
    "intouchees": [
        "intouche"
    ],
    "intouches": [
        "intouche"
    ],
    "intox": [
        "intox"
    ],
    "intoxe": [
        "intox"
    ],
    "intoxicant": [
        "intoxicant"
    ],
    "intoxication": [
        "intoxication"
    ],
    "intoxications": [
        "intoxication"
    ],
    "intoxiquant": [
        "intoxiquer"
    ],
    "intoxique": [
        "intoxiquer",
        "intoxique"
    ],
    "intoxiquer": [
        "intoxiquer"
    ],
    "intoxiquee": [
        "intoxiquer",
        "intoxique"
    ],
    "intoxiquees": [
        "intoxique"
    ],
    "intoxiques": [
        "intoxiquer",
        "intoxique"
    ],
    "intra": [
        "intra"
    ],
    "intracardiaque": [
        "intracardiaque"
    ],
    "intracranien": [
        "intracranien"
    ],
    "intracranienne": [
        "intracranien"
    ],
    "intracerebrale": [
        "intracerebral"
    ],
    "intradermique": [
        "intradermique"
    ],
    "intrados": [
        "intrados"
    ],
    "intraduisible": [
        "intraduisible"
    ],
    "intraduisibles": [
        "intraduisible"
    ],
    "intrait": [
        "intrait"
    ],
    "intraitable": [
        "intraitable"
    ],
    "intraitables": [
        "intraitable"
    ],
    "intramusculaire": [
        "intramusculaire"
    ],
    "intramusculaires": [
        "intramusculaire"
    ],
    "intranet": [
        "intranet"
    ],
    "intransgressible": [
        "intransgressible"
    ],
    "intransigeance": [
        "intransigeance"
    ],
    "intransigeances": [
        "intransigeance"
    ],
    "intransigeant": [
        "intransigeant"
    ],
    "intransigeante": [
        "intransigeant"
    ],
    "intransigeantes": [
        "intransigeant"
    ],
    "intransigeants": [
        "intransigeant"
    ],
    "intransitif": [
        "intransitif"
    ],
    "intransmissible": [
        "intransmissible"
    ],
    "intransportable": [
        "intransportable"
    ],
    "intransportables": [
        "intransportable"
    ],
    "intraoculaire": [
        "intraoculaire"
    ],
    "intravasculaire": [
        "intravasculaire"
    ],
    "intraveineuse": [
        "intraveineux"
    ],
    "intraveineuses": [
        "intraveineux"
    ],
    "intraveineux": [
        "intraveineux"
    ],
    "intrigant": [
        "intrigant"
    ],
    "intrigante": [
        "intrigant"
    ],
    "intrigantes": [
        "intrigant"
    ],
    "intrigants": [
        "intrigant"
    ],
    "intrigua": [
        "intriguer"
    ],
    "intriguaient": [
        "intriguer"
    ],
    "intriguait": [
        "intriguer"
    ],
    "intriguant": [
        "intriguer"
    ],
    "intriguassent": [
        "intriguer"
    ],
    "intrigue": [
        "intriguer",
        "intrigue"
    ],
    "intriguent": [
        "intriguer"
    ],
    "intriguer": [
        "intriguer"
    ],
    "intriguera": [
        "intriguer"
    ],
    "intriguerait": [
        "intriguer"
    ],
    "intrigues": [
        "intriguer",
        "intrigue"
    ],
    "intriguez": [
        "intriguer"
    ],
    "intriguat": [
        "intriguer"
    ],
    "intriguerent": [
        "intriguer"
    ],
    "intriguee": [
        "intriguer"
    ],
    "intrinseque": [
        "intrinseque"
    ],
    "intrinsequement": [
        "intrinsequement"
    ],
    "introducteur": [
        "introducteur"
    ],
    "introductif": [
        "introductif"
    ],
    "introduction": [
        "introduction"
    ],
    "introductions": [
        "introduction"
    ],
    "introductrice": [
        "introducteur"
    ],
    "introduira": [
        "introduire"
    ],
    "introduirai": [
        "introduire"
    ],
    "introduiraient": [
        "introduire"
    ],
    "introduirais": [
        "introduire"
    ],
    "introduirait": [
        "introduire"
    ],
    "introduire": [
        "introduire"
    ],
    "introduirez": [
        "introduire"
    ],
    "introduirions": [
        "introduire"
    ],
    "introduis": [
        "introduire"
    ],
    "introduisaient": [
        "introduire"
    ],
    "introduisais": [
        "introduire"
    ],
    "introduisait": [
        "introduire"
    ],
    "introduisant": [
        "introduire"
    ],
    "introduise": [
        "introduire"
    ],
    "introduisent": [
        "introduire"
    ],
    "introduisez": [
        "introduire"
    ],
    "introduisirent": [
        "introduire"
    ],
    "introduisis": [
        "introduire"
    ],
    "introduisit": [
        "introduire"
    ],
    "introduisons": [
        "introduire"
    ],
    "introduit": [
        "introduire"
    ],
    "introduite": [
        "introduire"
    ],
    "introduites": [
        "introduire"
    ],
    "introduits": [
        "introduire"
    ],
    "intromission": [
        "intromission"
    ],
    "intronisa": [
        "introniser"
    ],
    "intronisait": [
        "introniser"
    ],
    "intronisation": [
        "intronisation"
    ],
    "intronise": [
        "introniser"
    ],
    "introniser": [
        "introniser"
    ],
    "introspecter": [
        "introspecter"
    ],
    "introspectif": [
        "introspectif"
    ],
    "introspection": [
        "introspection"
    ],
    "introspections": [
        "introspection"
    ],
    "introspective": [
        "introspectif"
    ],
    "introspectives": [
        "introspectif"
    ],
    "introuvable": [
        "introuvable"
    ],
    "introuvables": [
        "introuvable"
    ],
    "introversions": [
        "introversion"
    ],
    "introverti": [
        "introverti"
    ],
    "introvertie": [
        "introverti"
    ],
    "introvertis": [
        "introverti"
    ],
    "introit": [
        "introit"
    ],
    "intrus": [
        "intrus"
    ],
    "intruse": [
        "intrus"
    ],
    "intruses": [
        "intrus"
    ],
    "intrusif": [
        "intrusif"
    ],
    "intrusion": [
        "intrusion"
    ],
    "intrusions": [
        "intrusion"
    ],
    "intrepide": [
        "intrepide"
    ],
    "intrepidement": [
        "intrepidement"
    ],
    "intrepides": [
        "intrepide"
    ],
    "intrepidite": [
        "intrepidite"
    ],
    "intubation": [
        "intubation"
    ],
    "intube": [
        "intuber"
    ],
    "intuber": [
        "intuber"
    ],
    "intubez": [
        "intuber"
    ],
    "intubee": [
        "intuber"
    ],
    "intuitif": [
        "intuitif"
    ],
    "intuitifs": [
        "intuitif"
    ],
    "intuition": [
        "intuition"
    ],
    "intuitions": [
        "intuition"
    ],
    "intuitive": [
        "intuitif",
        "intuitive"
    ],
    "intuitivement": [
        "intuitivement"
    ],
    "intuitives": [
        "intuitif"
    ],
    "intumescence": [
        "intumescence"
    ],
    "intussusception": [
        "intussusception"
    ],
    "integre": [
        "integre",
        "integrer"
    ],
    "integrent": [
        "integrer"
    ],
    "integres": [
        "integre",
        "integrer"
    ],
    "integra": [
        "integrer"
    ],
    "integraient": [
        "integrer"
    ],
    "integrait": [
        "integrer"
    ],
    "integral": [
        "integral"
    ],
    "integrale": [
        "integral",
        "integrale"
    ],
    "integralement": [
        "integralement"
    ],
    "integrales": [
        "integral",
        "integrale"
    ],
    "integralisme": [
        "integralisme"
    ],
    "integralite": [
        "integralite"
    ],
    "integrant": [
        "integrer"
    ],
    "integrante": [
        "integrant"
    ],
    "integrateur": [
        "integrateur"
    ],
    "integration": [
        "integration"
    ],
    "integraux": [
        "integral"
    ],
    "integrer": [
        "integrer"
    ],
    "integrera": [
        "integrer"
    ],
    "integrerais": [
        "integrer"
    ],
    "integreras": [
        "integrer"
    ],
    "integrerez": [
        "integrer"
    ],
    "integreront": [
        "integrer"
    ],
    "integrez": [
        "integrer"
    ],
    "integriez": [
        "integrer"
    ],
    "integrisme": [
        "integrisme"
    ],
    "integrismes": [
        "integrisme"
    ],
    "integriste": [
        "integriste"
    ],
    "integristes": [
        "integriste"
    ],
    "integrite": [
        "integrite"
    ],
    "integrites": [
        "integrite"
    ],
    "integrerent": [
        "integrer"
    ],
    "integree": [
        "integre",
        "integrer"
    ],
    "integrees": [
        "integre",
        "integrer"
    ],
    "interessa": [
        "interesser"
    ],
    "interessai": [
        "interesser"
    ],
    "interessaient": [
        "interesser"
    ],
    "interessais": [
        "interesser"
    ],
    "interessait": [
        "interesser"
    ],
    "interessant": [
        "interessant",
        "interesser"
    ],
    "interessante": [
        "interessant"
    ],
    "interessantes": [
        "interessant"
    ],
    "interessants": [
        "interessant"
    ],
    "interesse": [
        "interesse",
        "interesser"
    ],
    "interessement": [
        "interessement"
    ],
    "interessent": [
        "interesser"
    ],
    "interesser": [
        "interesser"
    ],
    "interessera": [
        "interesser"
    ],
    "interesserai": [
        "interesser"
    ],
    "interesseraient": [
        "interesser"
    ],
    "interesserais": [
        "interesser"
    ],
    "interesserait": [
        "interesser"
    ],
    "interesseras": [
        "interesser"
    ],
    "interesseriez": [
        "interesser"
    ],
    "interesserons": [
        "interesser"
    ],
    "interesseront": [
        "interesser"
    ],
    "interesses": [
        "interesse",
        "interesser"
    ],
    "interessez": [
        "interesser"
    ],
    "interessiez": [
        "interesser"
    ],
    "interessions": [
        "interesser"
    ],
    "interessons": [
        "interesser"
    ],
    "interessat": [
        "interesser"
    ],
    "interesserent": [
        "interesser"
    ],
    "interessee": [
        "interesse",
        "interesser"
    ],
    "interessees": [
        "interesse",
        "interesser"
    ],
    "interieur": [
        "interieur"
    ],
    "interieure": [
        "interieur"
    ],
    "interieurement": [
        "interieurement"
    ],
    "interieures": [
        "interieur"
    ],
    "interieurs": [
        "interieur"
    ],
    "interim": [
        "interim"
    ],
    "interimaire": [
        "interimaire"
    ],
    "interimaires": [
        "interimaire"
    ],
    "interims": [
        "interim"
    ],
    "interiorisa": [
        "interioriser"
    ],
    "interiorisait": [
        "interioriser"
    ],
    "interiorisation": [
        "interiorisation"
    ],
    "interiorise": [
        "interioriser"
    ],
    "interiorisent": [
        "interioriser"
    ],
    "interioriser": [
        "interioriser"
    ],
    "interiorisee": [
        "interioriser"
    ],
    "interiorisees": [
        "interioriser"
    ],
    "interiorises": [
        "interioriser"
    ],
    "interiorite": [
        "interiorite"
    ],
    "interet": [
        "interet"
    ],
    "interets": [
        "interet"
    ],
    "inuit": [
        "inuit"
    ],
    "inupik": [
        "inupik"
    ],
    "inusabilite": [
        "inusabilite"
    ],
    "inusable": [
        "inusable"
    ],
    "inusables": [
        "inusable"
    ],
    "inusite": [
        "inusite"
    ],
    "inusitee": [
        "inusite"
    ],
    "inusitees": [
        "inusite"
    ],
    "inusites": [
        "inusite"
    ],
    "inusuelle": [
        "inusuel"
    ],
    "inutile": [
        "inutile"
    ],
    "inutilement": [
        "inutilement"
    ],
    "inutiles": [
        "inutile"
    ],
    "inutilisable": [
        "inutilisable"
    ],
    "inutilisables": [
        "inutilisable"
    ],
    "inutilisation": [
        "inutilisation"
    ],
    "inutilise": [
        "inutilise"
    ],
    "inutilisee": [
        "inutilise"
    ],
    "inutilisees": [
        "inutilise"
    ],
    "inutilises": [
        "inutilise"
    ],
    "inutilite": [
        "inutilite"
    ],
    "inutilites": [
        "inutilite"
    ],
    "invagination": [
        "invagination"
    ],
    "invaincu": [
        "invaincu"
    ],
    "invaincue": [
        "invaincu"
    ],
    "invaincues": [
        "invaincu"
    ],
    "invaincus": [
        "invaincu"
    ],
    "invalidant": [
        "invalidant"
    ],
    "invalidante": [
        "invalidant"
    ],
    "invalidation": [
        "invalidation"
    ],
    "invalide": [
        "invalider",
        "invalide"
    ],
    "invalider": [
        "invalider"
    ],
    "invalides": [
        "invalider",
        "invalide"
    ],
    "invalidite": [
        "invalidite"
    ],
    "invalidites": [
        "invalidite"
    ],
    "invariable": [
        "invariable"
    ],
    "invariablement": [
        "invariablement"
    ],
    "invariables": [
        "invariable"
    ],
    "invariance": [
        "invariance"
    ],
    "invasif": [
        "invasif"
    ],
    "invasion": [
        "invasion"
    ],
    "invasions": [
        "invasion"
    ],
    "invasive": [
        "invasif"
    ],
    "invasives": [
        "invasif"
    ],
    "invectiva": [
        "invectiver"
    ],
    "invectivai": [
        "invectiver"
    ],
    "invectivaient": [
        "invectiver"
    ],
    "invectivait": [
        "invectiver"
    ],
    "invectivant": [
        "invectiver"
    ],
    "invective": [
        "invective",
        "invectiver"
    ],
    "invectivent": [
        "invectiver"
    ],
    "invectiver": [
        "invectiver"
    ],
    "invectives": [
        "invective"
    ],
    "invendable": [
        "invendable"
    ],
    "invendables": [
        "invendable"
    ],
    "invendu": [
        "invendu"
    ],
    "invendues": [
        "invendu"
    ],
    "invendus": [
        "invendu"
    ],
    "inventa": [
        "inventer"
    ],
    "inventai": [
        "inventer"
    ],
    "inventaient": [
        "inventer"
    ],
    "inventaire": [
        "inventaire"
    ],
    "inventaires": [
        "inventaire"
    ],
    "inventais": [
        "inventer"
    ],
    "inventait": [
        "inventer"
    ],
    "inventant": [
        "inventer"
    ],
    "invente": [
        "inventer"
    ],
    "inventent": [
        "inventer"
    ],
    "inventer": [
        "inventer"
    ],
    "inventera": [
        "inventer"
    ],
    "inventerai": [
        "inventer"
    ],
    "inventeraient": [
        "inventer"
    ],
    "inventerais": [
        "inventer"
    ],
    "inventerait": [
        "inventer"
    ],
    "inventeras": [
        "inventer"
    ],
    "inventerez": [
        "inventer"
    ],
    "inventeriez": [
        "inventer"
    ],
    "inventerions": [
        "inventer"
    ],
    "inventerons": [
        "inventer"
    ],
    "inventeront": [
        "inventer"
    ],
    "inventes": [
        "inventer"
    ],
    "inventeur": [
        "inventeur"
    ],
    "inventeurs": [
        "inventeur"
    ],
    "inventez": [
        "inventer"
    ],
    "inventiez": [
        "inventer"
    ],
    "inventif": [
        "inventif"
    ],
    "inventifs": [
        "inventif"
    ],
    "invention": [
        "invention"
    ],
    "inventions": [
        "invention",
        "inventer"
    ],
    "inventive": [
        "inventif"
    ],
    "inventivite": [
        "inventivite"
    ],
    "inventivites": [
        "inventivite"
    ],
    "inventons": [
        "inventer"
    ],
    "inventoria": [
        "inventorier"
    ],
    "inventoriai": [
        "inventorier"
    ],
    "inventoriaient": [
        "inventorier"
    ],
    "inventoriait": [
        "inventorier"
    ],
    "inventorient": [
        "inventorier"
    ],
    "inventorier": [
        "inventorier"
    ],
    "inventorie": [
        "inventorier"
    ],
    "inventoriee": [
        "inventorier"
    ],
    "inventoriees": [
        "inventorier"
    ],
    "inventat": [
        "inventer"
    ],
    "inventerent": [
        "inventer"
    ],
    "inventee": [
        "inventer"
    ],
    "inventees": [
        "inventer"
    ],
    "inversa": [
        "inverser"
    ],
    "inversaient": [
        "inverser"
    ],
    "inversait": [
        "inverser"
    ],
    "inversant": [
        "inverser"
    ],
    "inverse": [
        "inverse",
        "inverser"
    ],
    "inversement": [
        "inversement"
    ],
    "inversent": [
        "inverser"
    ],
    "inverser": [
        "inverser"
    ],
    "inversera": [
        "inverser"
    ],
    "inverserais": [
        "inverser"
    ],
    "inverserait": [
        "inverser"
    ],
    "inverses": [
        "inverse",
        "inverser"
    ],
    "inverseur": [
        "inverseur"
    ],
    "inversez": [
        "inverser"
    ],
    "inversible": [
        "inversible"
    ],
    "inversion": [
        "inversion"
    ],
    "inversions": [
        "inversion"
    ],
    "inversons": [
        "inverser"
    ],
    "inverserent": [
        "inverser"
    ],
    "inversee": [
        "inverser"
    ],
    "inversees": [
        "inverser"
    ],
    "inverti": [
        "invertir",
        "inverti"
    ],
    "invertis": [
        "inverti"
    ],
    "invertebre": [
        "invertebre"
    ],
    "invertebree": [
        "invertebre"
    ],
    "invertebres": [
        "invertebre"
    ],
    "investi": [
        "investir",
        "investi"
    ],
    "investie": [
        "investir",
        "investi"
    ],
    "investies": [
        "investir",
        "investi"
    ],
    "investigateur": [
        "investigateur"
    ],
    "investigateurs": [
        "investigateur"
    ],
    "investigation": [
        "investigation"
    ],
    "investigations": [
        "investigation"
    ],
    "investigatrice": [
        "investigateur"
    ],
    "investigatrices": [
        "investigateur"
    ],
    "investiguant": [
        "investiguer"
    ],
    "investiguer": [
        "investiguer"
    ],
    "investir": [
        "investir"
    ],
    "investira": [
        "investir"
    ],
    "investirais": [
        "investir"
    ],
    "investirait": [
        "investir"
    ],
    "investirent": [
        "investir"
    ],
    "investirons": [
        "investir"
    ],
    "investiront": [
        "investir"
    ],
    "investis": [
        "investir",
        "investi"
    ],
    "investissaient": [
        "investir"
    ],
    "investissais": [
        "investir"
    ],
    "investissait": [
        "investir"
    ],
    "investissant": [
        "investir"
    ],
    "investisse": [
        "investir"
    ],
    "investissement": [
        "investissement"
    ],
    "investissements": [
        "investissement"
    ],
    "investissent": [
        "investir"
    ],
    "investisseur": [
        "investisseur"
    ],
    "investisseurs": [
        "investisseur"
    ],
    "investissez": [
        "investir"
    ],
    "investissons": [
        "investir"
    ],
    "investit": [
        "investir"
    ],
    "investiture": [
        "investiture"
    ],
    "investitures": [
        "investiture"
    ],
    "invincibilite": [
        "invincibilite"
    ],
    "invincible": [
        "invincible"
    ],
    "invinciblement": [
        "invinciblement"
    ],
    "invincibles": [
        "invincible"
    ],
    "inviolabilite": [
        "inviolabilite"
    ],
    "inviolable": [
        "inviolable"
    ],
    "inviolables": [
        "inviolable"
    ],
    "inviole": [
        "inviole"
    ],
    "inviolee": [
        "inviole"
    ],
    "inviolees": [
        "inviole"
    ],
    "invioles": [
        "inviole"
    ],
    "invisibilite": [
        "invisibilite"
    ],
    "invisible": [
        "invisible"
    ],
    "invisiblement": [
        "invisiblement"
    ],
    "invisibles": [
        "invisible"
    ],
    "invita": [
        "inviter"
    ],
    "invitai": [
        "inviter"
    ],
    "invitaient": [
        "inviter"
    ],
    "invitais": [
        "inviter"
    ],
    "invitait": [
        "inviter"
    ],
    "invitant": [
        "invitant",
        "inviter"
    ],
    "invitante": [
        "invitant"
    ],
    "invitantes": [
        "invitant"
    ],
    "invitants": [
        "invitant"
    ],
    "invitation": [
        "invitation"
    ],
    "invitations": [
        "invitation"
    ],
    "invite": [
        "invite",
        "inviter"
    ],
    "invitent": [
        "inviter"
    ],
    "inviter": [
        "inviter"
    ],
    "invitera": [
        "inviter"
    ],
    "inviterai": [
        "inviter"
    ],
    "inviteraient": [
        "inviter"
    ],
    "inviterais": [
        "inviter"
    ],
    "inviterait": [
        "inviter"
    ],
    "inviteras": [
        "inviter"
    ],
    "inviterez": [
        "inviter"
    ],
    "inviteriez": [
        "inviter"
    ],
    "inviterions": [
        "inviter"
    ],
    "inviterons": [
        "inviter"
    ],
    "inviteront": [
        "inviter"
    ],
    "invites": [
        "invite",
        "inviter"
    ],
    "inviteur": [
        "inviteur"
    ],
    "inviteurs": [
        "inviteur"
    ],
    "invitez": [
        "inviter"
    ],
    "invitiez": [
        "inviter"
    ],
    "invitions": [
        "inviter"
    ],
    "invitons": [
        "inviter"
    ],
    "invitames": [
        "inviter"
    ],
    "invitat": [
        "inviter"
    ],
    "inviterent": [
        "inviter"
    ],
    "invitee": [
        "invite",
        "inviter"
    ],
    "invitees": [
        "invite",
        "inviter"
    ],
    "invivable": [
        "invivable"
    ],
    "invocation": [
        "invocation"
    ],
    "invocations": [
        "invocation"
    ],
    "invocatoire": [
        "invocatoire"
    ],
    "involontaire": [
        "involontaire"
    ],
    "involontairement": [
        "involontairement"
    ],
    "involontaires": [
        "involontaire"
    ],
    "involutif": [
        "involutif"
    ],
    "involutifs": [
        "involutif"
    ],
    "involution": [
        "involution"
    ],
    "invoqua": [
        "invoquer"
    ],
    "invoquai": [
        "invoquer"
    ],
    "invoquaient": [
        "invoquer"
    ],
    "invoquais": [
        "invoquer"
    ],
    "invoquait": [
        "invoquer"
    ],
    "invoquant": [
        "invoquer"
    ],
    "invoque": [
        "invoquer"
    ],
    "invoquent": [
        "invoquer"
    ],
    "invoquer": [
        "invoquer"
    ],
    "invoquera": [
        "invoquer"
    ],
    "invoquerai": [
        "invoquer"
    ],
    "invoquerais": [
        "invoquer"
    ],
    "invoquerait": [
        "invoquer"
    ],
    "invoquerez": [
        "invoquer"
    ],
    "invoquerons": [
        "invoquer"
    ],
    "invoques": [
        "invoquer"
    ],
    "invoquez": [
        "invoquer"
    ],
    "invoquons": [
        "invoquer"
    ],
    "invoquat": [
        "invoquer"
    ],
    "invoquee": [
        "invoquer"
    ],
    "invoquees": [
        "invoquer"
    ],
    "invraisemblable": [
        "invraisemblable"
    ],
    "invraisemblablement": [
        "invraisemblablement"
    ],
    "invraisemblables": [
        "invraisemblable"
    ],
    "invraisemblance": [
        "invraisemblance"
    ],
    "invraisemblances": [
        "invraisemblance"
    ],
    "invulnerabilite": [
        "invulnerabilite"
    ],
    "invulnerable": [
        "invulnerable"
    ],
    "invulnerables": [
        "invulnerable"
    ],
    "inverifiable": [
        "inverifiable"
    ],
    "inverifiables": [
        "inverifiable"
    ],
    "invetere": [
        "inveterer",
        "invetere"
    ],
    "inveteree": [
        "inveterer",
        "invetere"
    ],
    "inveterees": [
        "invetere"
    ],
    "inveteres": [
        "invetere"
    ],
    "inebranlable": [
        "inebranlable"
    ],
    "inebranlablement": [
        "inebranlablement"
    ],
    "inebranlables": [
        "inebranlable"
    ],
    "inebranle": [
        "inebranle"
    ],
    "inechangeable": [
        "inechangeable"
    ],
    "inecoutee": [
        "inecoute"
    ],
    "inedit": [
        "inedit"
    ],
    "inedite": [
        "inedit"
    ],
    "inedites": [
        "inedit"
    ],
    "inedits": [
        "inedit"
    ],
    "ineducable": [
        "ineducable"
    ],
    "inegal": [
        "inegal"
    ],
    "inegalable": [
        "inegalable"
    ],
    "inegalables": [
        "inegalable"
    ],
    "inegale": [
        "inegaler",
        "inegal",
        "inegale"
    ],
    "inegalement": [
        "inegalement"
    ],
    "inegales": [
        "inegal"
    ],
    "inegalite": [
        "inegalite"
    ],
    "inegalites": [
        "inegalite"
    ],
    "inegalee": [
        "inegaler",
        "inegale"
    ],
    "inegalees": [
        "inegale"
    ],
    "inegaux": [
        "inegal"
    ],
    "ineligibilite": [
        "ineligibilite"
    ],
    "ineligible": [
        "ineligible"
    ],
    "ineluctabilite": [
        "ineluctabilite"
    ],
    "ineluctable": [
        "ineluctable"
    ],
    "ineluctablement": [
        "ineluctablement"
    ],
    "ineluctables": [
        "ineluctable"
    ],
    "inelegamment": [
        "inelegamment"
    ],
    "inelegance": [
        "inelegance"
    ],
    "inelegant": [
        "inelegant"
    ],
    "inelegantes": [
        "inelegant"
    ],
    "inenarrable": [
        "inenarrable"
    ],
    "inenarrables": [
        "inenarrable"
    ],
    "inepuisable": [
        "inepuisable"
    ],
    "inepuisablement": [
        "inepuisablement"
    ],
    "inepuisables": [
        "inepuisable"
    ],
    "inepuisees": [
        "inepuise"
    ],
    "inequitable": [
        "inequitable"
    ],
    "inevaluable": [
        "inevaluable"
    ],
    "inevitabilite": [
        "inevitabilite"
    ],
    "inevitable": [
        "inevitable"
    ],
    "inevitablement": [
        "inevitablement"
    ],
    "inevitables": [
        "inevitable"
    ],
    "iode": [
        "iode"
    ],
    "iodle": [
        "iodler"
    ],
    "iodler": [
        "iodler"
    ],
    "iodoforme": [
        "iodoforme"
    ],
    "iodure": [
        "iodure"
    ],
    "iodee": [
        "ioder",
        "iode"
    ],
    "ion": [
        "ion"
    ],
    "ionien": [
        "ionien"
    ],
    "ionienne": [
        "ionienne"
    ],
    "ioniennes": [
        "ionien"
    ],
    "ioniens": [
        "ionien"
    ],
    "ionique": [
        "ionique"
    ],
    "ioniques": [
        "ionique"
    ],
    "ionisant": [
        "ionisant"
    ],
    "ionisante": [
        "ionisant"
    ],
    "ionisation": [
        "ionisation"
    ],
    "ioniser": [
        "ioniser"
    ],
    "ionisez": [
        "ioniser"
    ],
    "ionise": [
        "ioniser",
        "ionise"
    ],
    "ionisee": [
        "ionise"
    ],
    "ionosphere": [
        "ionosphere"
    ],
    "ions": [
        "ion"
    ],
    "iota": [
        "iota"
    ],
    "ipomee": [
        "ipomee"
    ],
    "ippon": [
        "ippon"
    ],
    "ipse": [
        "ipse"
    ],
    "ipeca": [
        "ipeca"
    ],
    "ipecas": [
        "ipeca"
    ],
    "ira": [
        "aller",
        "ira"
    ],
    "irai": [
        "aller"
    ],
    "iraient": [
        "aller"
    ],
    "irais": [
        "aller"
    ],
    "irait": [
        "aller"
    ],
    "irakien": [
        "irakien"
    ],
    "irakienne": [
        "irakien"
    ],
    "irakiens": [
        "irakien"
    ],
    "iranien": [
        "iranien"
    ],
    "iranienne": [
        "iranien"
    ],
    "iraniennes": [
        "iranien"
    ],
    "iraniens": [
        "iranien"
    ],
    "iraquien": [
        "iraquien"
    ],
    "iraquienne": [
        "iraquien"
    ],
    "iraquiens": [
        "iraquien"
    ],
    "iras": [
        "aller"
    ],
    "irascible": [
        "irascible"
    ],
    "irascibles": [
        "irascible"
    ],
    "ire": [
        "ire"
    ],
    "ires": [
        "ire"
    ],
    "irez": [
        "aller"
    ],
    "iridescence": [
        "iridescence"
    ],
    "iridescent": [
        "iridescent"
    ],
    "iridescentes": [
        "iridescent"
    ],
    "iridium": [
        "iridium"
    ],
    "iridologie": [
        "iridologie"
    ],
    "iriez": [
        "aller"
    ],
    "irions": [
        "aller"
    ],
    "iris": [
        "iris"
    ],
    "irisaient": [
        "iriser"
    ],
    "irisait": [
        "iriser"
    ],
    "irisant": [
        "iriser"
    ],
    "irisation": [
        "irisation"
    ],
    "irisations": [
        "irisation"
    ],
    "irise": [
        "irise",
        "iriser"
    ],
    "irisent": [
        "iriser"
    ],
    "iriser": [
        "iriser"
    ],
    "iriserait": [
        "iriser"
    ],
    "irisee": [
        "irise",
        "iriser"
    ],
    "irisees": [
        "irise",
        "iriser"
    ],
    "irises": [
        "iris",
        "irise",
        "iriser"
    ],
    "irlandais": [
        "irlandais"
    ],
    "irlandaise": [
        "irlandais"
    ],
    "irlandaises": [
        "irlandais"
    ],
    "ironie": [
        "ironie"
    ],
    "ironies": [
        "ironie",
        "irony"
    ],
    "ironique": [
        "ironique"
    ],
    "ironiquement": [
        "ironiquement"
    ],
    "ironiques": [
        "ironique"
    ],
    "ironisa": [
        "ironiser"
    ],
    "ironisai": [
        "ironiser"
    ],
    "ironisais": [
        "ironiser"
    ],
    "ironisait": [
        "ironiser"
    ],
    "ironise": [
        "ironiser"
    ],
    "ironisent": [
        "ironiser"
    ],
    "ironiser": [
        "ironiser"
    ],
    "ironisme": [
        "ironisme"
    ],
    "ironiste": [
        "ironiste"
    ],
    "irons": [
        "aller",
        "iron"
    ],
    "iront": [
        "aller"
    ],
    "iroquois": [
        "iroquois"
    ],
    "iroquoise": [
        "iroquois"
    ],
    "irradia": [
        "irradier"
    ],
    "irradiaient": [
        "irradier"
    ],
    "irradiait": [
        "irradier"
    ],
    "irradiant": [
        "irradier",
        "irradiant"
    ],
    "irradiante": [
        "irradiant"
    ],
    "irradiantes": [
        "irradiant"
    ],
    "irradiation": [
        "irradiation"
    ],
    "irradiations": [
        "irradiation"
    ],
    "irradie": [
        "irradier"
    ],
    "irradier": [
        "irradier"
    ],
    "irradiera": [
        "irradier"
    ],
    "irradiez": [
        "irradier"
    ],
    "irradiee": [
        "irradier"
    ],
    "irradiees": [
        "irradier"
    ],
    "irradies": [
        "irradier"
    ],
    "irraisonnable": [
        "irraisonnable"
    ],
    "irraisonne": [
        "irraisonne"
    ],
    "irraisonnee": [
        "irraisonne"
    ],
    "irraisonnes": [
        "irraisonne"
    ],
    "irrationalite": [
        "irrationalite"
    ],
    "irrationnel": [
        "irrationnel"
    ],
    "irrationnelle": [
        "irrationnel"
    ],
    "irrationnellement": [
        "irrationnellement"
    ],
    "irrationnelles": [
        "irrationnel"
    ],
    "irrationnels": [
        "irrationnel"
    ],
    "irrattrapable": [
        "irrattrapable"
    ],
    "irrattrapables": [
        "irrattrapable"
    ],
    "irrecevabilite": [
        "irrecevabilite"
    ],
    "irrecevable": [
        "irrecevable"
    ],
    "irrecevables": [
        "irrecevable"
    ],
    "irremplacable": [
        "irremplacable"
    ],
    "irremplacables": [
        "irremplacable"
    ],
    "irrepresentable": [
        "irrepresentable"
    ],
    "irrespect": [
        "irrespect"
    ],
    "irrespectueuse": [
        "irrespectueux"
    ],
    "irrespectueusement": [
        "irrespectueusement"
    ],
    "irrespectueuses": [
        "irrespectueux"
    ],
    "irrespectueux": [
        "irrespectueux"
    ],
    "irrespirable": [
        "irrespirable"
    ],
    "irrespirables": [
        "irrespirable"
    ],
    "irresponsabilite": [
        "irresponsabilite"
    ],
    "irresponsable": [
        "irresponsable"
    ],
    "irresponsables": [
        "irresponsable"
    ],
    "irrigateur": [
        "irrigateur"
    ],
    "irrigateurs": [
        "irrigateur"
    ],
    "irrigation": [
        "irrigation"
    ],
    "irriguaient": [
        "irriguer"
    ],
    "irriguait": [
        "irriguer"
    ],
    "irriguant": [
        "irriguer"
    ],
    "irrigue": [
        "irriguer"
    ],
    "irriguent": [
        "irriguer"
    ],
    "irriguer": [
        "irriguer"
    ],
    "irriguera": [
        "irriguer"
    ],
    "irrigueraient": [
        "irriguer"
    ],
    "irriguerait": [
        "irriguer"
    ],
    "irriguons": [
        "irriguer"
    ],
    "irriguee": [
        "irriguer"
    ],
    "irriguees": [
        "irriguer"
    ],
    "irrigues": [
        "irriguer"
    ],
    "irrita": [
        "irriter"
    ],
    "irritabilite": [
        "irritabilite"
    ],
    "irritable": [
        "irritable"
    ],
    "irritables": [
        "irritable"
    ],
    "irritai": [
        "irriter"
    ],
    "irritaient": [
        "irriter"
    ],
    "irritais": [
        "irriter"
    ],
    "irritait": [
        "irriter"
    ],
    "irritant": [
        "irritant",
        "irriter"
    ],
    "irritante": [
        "irritant"
    ],
    "irritantes": [
        "irritant"
    ],
    "irritants": [
        "irritant"
    ],
    "irritation": [
        "irritation"
    ],
    "irritations": [
        "irritation"
    ],
    "irrite": [
        "irriter"
    ],
    "irritent": [
        "irriter"
    ],
    "irriter": [
        "irriter"
    ],
    "irritera": [
        "irriter"
    ],
    "irriterait": [
        "irriter"
    ],
    "irriterons": [
        "irriter"
    ],
    "irritez": [
        "irriter"
    ],
    "irritons": [
        "irriter"
    ],
    "irritat": [
        "irriter"
    ],
    "irriterent": [
        "irriter"
    ],
    "irritee": [
        "irriter"
    ],
    "irritees": [
        "irriter"
    ],
    "irrites": [
        "irriter"
    ],
    "irroration": [
        "irroration"
    ],
    "irruption": [
        "irruption"
    ],
    "irruptions": [
        "irruption"
    ],
    "irrealisable": [
        "irrealisable"
    ],
    "irrealisables": [
        "irrealisable"
    ],
    "irrealisait": [
        "irrealiser"
    ],
    "irrealise": [
        "irrealiser",
        "irrealise"
    ],
    "irrealisme": [
        "irrealisme"
    ],
    "irrealiste": [
        "irrealiste"
    ],
    "irrealistes": [
        "irrealiste"
    ],
    "irrealises": [
        "irrealise"
    ],
    "irrealite": [
        "irrealite"
    ],
    "irreconciliable": [
        "irreconciliable"
    ],
    "irreconciliables": [
        "irreconciliable"
    ],
    "irrecuperable": [
        "irrecuperable"
    ],
    "irrecuperables": [
        "irrecuperable"
    ],
    "irrecusable": [
        "irrecusable"
    ],
    "irrecusables": [
        "irrecusable"
    ],
    "irreductible": [
        "irreductible"
    ],
    "irreductiblement": [
        "irreductiblement"
    ],
    "irreductibles": [
        "irreductible"
    ],
    "irreel": [
        "irreel"
    ],
    "irreelle": [
        "irreel"
    ],
    "irreellement": [
        "irreellement"
    ],
    "irreelles": [
        "irreel"
    ],
    "irreels": [
        "irreel"
    ],
    "irreflechi": [
        "irreflechi"
    ],
    "irreflechie": [
        "irreflechi"
    ],
    "irreflechis": [
        "irreflechi"
    ],
    "irrefragable": [
        "irrefragable"
    ],
    "irrefutable": [
        "irrefutable"
    ],
    "irrefutablement": [
        "irrefutablement"
    ],
    "irrefutables": [
        "irrefutable"
    ],
    "irregularite": [
        "irregularite"
    ],
    "irregularites": [
        "irregularite"
    ],
    "irregulier": [
        "irregulier"
    ],
    "irreguliers": [
        "irregulier"
    ],
    "irreguliere": [
        "irregulier"
    ],
    "irregulierement": [
        "irregulierement"
    ],
    "irregulieres": [
        "irregulier"
    ],
    "irreligieuse": [
        "irreligieux"
    ],
    "irreligieux": [
        "irreligieux"
    ],
    "irreligiosite": [
        "irreligiosite"
    ],
    "irremissible": [
        "irremissible"
    ],
    "irremediable": [
        "irremediable"
    ],
    "irremediablement": [
        "irremediablement"
    ],
    "irremediables": [
        "irremediable"
    ],
    "irreparable": [
        "irreparable"
    ],
    "irreparablement": [
        "irreparablement"
    ],
    "irreparables": [
        "irreparable"
    ],
    "irrepressible": [
        "irrepressible"
    ],
    "irrepressibles": [
        "irrepressible"
    ],
    "irreprochable": [
        "irreprochable"
    ],
    "irreprochablement": [
        "irreprochablement"
    ],
    "irreprochables": [
        "irreprochable"
    ],
    "irresistible": [
        "irresistible"
    ],
    "irresistiblement": [
        "irresistiblement"
    ],
    "irresistibles": [
        "irresistible"
    ],
    "irresolu": [
        "irresolu"
    ],
    "irresolue": [
        "irresolu"
    ],
    "irresolues": [
        "irresolu"
    ],
    "irresolus": [
        "irresolu"
    ],
    "irresolution": [
        "irresolution"
    ],
    "irretrecissable": [
        "irretrecissable"
    ],
    "irreversibilite": [
        "irreversibilite"
    ],
    "irreversible": [
        "irreversible"
    ],
    "irreversiblement": [
        "irreversiblement"
    ],
    "irreversibles": [
        "irreversible"
    ],
    "irrevocabilite": [
        "irrevocabilite"
    ],
    "irrevocable": [
        "irrevocable"
    ],
    "irrevocablement": [
        "irrevocablement"
    ],
    "irrevocables": [
        "irrevocable"
    ],
    "irreverence": [
        "irreverence"
    ],
    "irreverencieuse": [
        "irreverencieux"
    ],
    "irreverencieusement": [
        "irreverencieusement"
    ],
    "irreverencieuses": [
        "irreverencieux"
    ],
    "irreverencieux": [
        "irreverencieux"
    ],
    "isabelle": [
        "isabelle"
    ],
    "isard": [
        "isard"
    ],
    "isards": [
        "isard"
    ],
    "isatis": [
        "isatis"
    ],
    "isba": [
        "isba"
    ],
    "isbas": [
        "isba"
    ],
    "ischion": [
        "ischion"
    ],
    "ischemie": [
        "ischemie"
    ],
    "ischemique": [
        "ischemique"
    ],
    "islam": [
        "islam"
    ],
    "islamique": [
        "islamique"
    ],
    "islamiques": [
        "islamique"
    ],
    "islamisants": [
        "islamisant"
    ],
    "islamiser": [
        "islamiser"
    ],
    "islamisme": [
        "islamisme"
    ],
    "islamiste": [
        "islamiste"
    ],
    "islamistes": [
        "islamiste"
    ],
    "islamisee": [
        "islamise"
    ],
    "islamisees": [
        "islamiser"
    ],
    "islandais": [
        "islandais"
    ],
    "islandaise": [
        "islandais"
    ],
    "ismaelien": [
        "ismaelien"
    ],
    "ismaeliens": [
        "ismaelien"
    ],
    "ismaelite": [
        "ismaelite"
    ],
    "ismailiens": [
        "ismailien"
    ],
    "isme": [
        "isme"
    ],
    "isochronisme": [
        "isochronisme"
    ],
    "isocele": [
        "isocele"
    ],
    "isola": [
        "isoler"
    ],
    "isolables": [
        "isolable"
    ],
    "isolai": [
        "isoler"
    ],
    "isolaient": [
        "isoler"
    ],
    "isolais": [
        "isoler"
    ],
    "isolait": [
        "isoler"
    ],
    "isolant": [
        "isolant",
        "isoler"
    ],
    "isolante": [
        "isolant"
    ],
    "isolateur": [
        "isolateur"
    ],
    "isolateurs": [
        "isolateur"
    ],
    "isolation": [
        "isolation"
    ],
    "isolationnisme": [
        "isolationnisme"
    ],
    "isolationniste": [
        "isolationniste"
    ],
    "isolations": [
        "isolation"
    ],
    "isole": [
        "isoler",
        "isole"
    ],
    "isolement": [
        "isolement"
    ],
    "isolements": [
        "isolement"
    ],
    "isolent": [
        "isoler"
    ],
    "isoler": [
        "isoler"
    ],
    "isolera": [
        "isoler"
    ],
    "isoleraient": [
        "isoler"
    ],
    "isolerait": [
        "isoler"
    ],
    "isoleront": [
        "isoler"
    ],
    "isolez": [
        "isoler"
    ],
    "isoliez": [
        "isoler"
    ],
    "isolions": [
        "isoler"
    ],
    "isoloir": [
        "isoloir"
    ],
    "isoloirs": [
        "isoloir"
    ],
    "isolerent": [
        "isoler"
    ],
    "isolee": [
        "isoler",
        "isole"
    ],
    "isolees": [
        "isoler",
        "isole"
    ],
    "isoles": [
        "isoler",
        "isole"
    ],
    "isomere": [
        "isomere"
    ],
    "isometrique": [
        "isometrique"
    ],
    "isoniazide": [
        "isoniazide"
    ],
    "isorel": [
        "isorel"
    ],
    "isotherme": [
        "isotherme"
    ],
    "isothermique": [
        "isothermique"
    ],
    "isotonique": [
        "isotonique"
    ],
    "isotope": [
        "isotope"
    ],
    "isotopes": [
        "isotope"
    ],
    "isotopique": [
        "isotopique"
    ],
    "israelien": [
        "israelien"
    ],
    "israelienne": [
        "israelien"
    ],
    "israeliennes": [
        "israelien"
    ],
    "israeliens": [
        "israelien"
    ],
    "israelite": [
        "israelite"
    ],
    "israelites": [
        "israelite"
    ],
    "issu": [
        "issu"
    ],
    "issue": [
        "issu",
        "issue"
    ],
    "issues": [
        "issu",
        "issue"
    ],
    "issus": [
        "issu"
    ],
    "isthme": [
        "isthme"
    ],
    "isthmes": [
        "isthme"
    ],
    "isthmique": [
        "isthmique"
    ],
    "italianisme": [
        "italianisme"
    ],
    "italiano": [
        "italiano"
    ],
    "italien": [
        "italien"
    ],
    "italienne": [
        "italien"
    ],
    "italiennes": [
        "italien"
    ],
    "italiens": [
        "italien"
    ],
    "italique": [
        "italique"
    ],
    "italiques": [
        "italique"
    ],
    "item": [
        "item"
    ],
    "ithos": [
        "ithos"
    ],
    "ithyphallique": [
        "ithyphallique"
    ],
    "itineraire": [
        "itineraire"
    ],
    "itineraires": [
        "itineraire"
    ],
    "itinerant": [
        "itinerant"
    ],
    "itinerante": [
        "itinerant"
    ],
    "itinerantes": [
        "itinerant"
    ],
    "itinerants": [
        "itinerant"
    ],
    "itou": [
        "itou"
    ],
    "iules": [
        "iule"
    ],
    "ive": [
        "ive"
    ],
    "ives": [
        "ive"
    ],
    "ivoire": [
        "ivoire"
    ],
    "ivoires": [
        "ivoire"
    ],
    "ivoirien": [
        "ivoirien"
    ],
    "ivoirienne": [
        "ivoirienne"
    ],
    "ivoirin": [
        "ivoirin"
    ],
    "ivoirine": [
        "ivoirin"
    ],
    "ivoirines": [
        "ivoirin"
    ],
    "ivoirins": [
        "ivoirin"
    ],
    "ivraie": [
        "ivraie"
    ],
    "ivre": [
        "ivre"
    ],
    "ivres": [
        "ivre"
    ],
    "ivresse": [
        "ivresse"
    ],
    "ivresses": [
        "ivresse"
    ],
    "ivrognait": [
        "ivrogner"
    ],
    "ivrognasse": [
        "ivrogner"
    ],
    "ivrogne": [
        "ivrogne"
    ],
    "ivrogner": [
        "ivrogner"
    ],
    "ivrognerie": [
        "ivrognerie"
    ],
    "ivrognes": [
        "ivrogne"
    ],
    "ivrognesse": [
        "ivrognesse"
    ],
    "ixe": [
        "ixer"
    ],
    "ixieme": [
        "ixieme"
    ],
    "j": [
        "j"
    ],
    "jabadao": [
        "jabadao"
    ],
    "jabot": [
        "jabot"
    ],
    "jaboter": [
        "jaboter"
    ],
    "jabots": [
        "jabot"
    ],
    "jacarandas": [
        "jacaranda"
    ],
    "jacassaient": [
        "jacasser"
    ],
    "jacassais": [
        "jacasser"
    ],
    "jacassait": [
        "jacasser"
    ],
    "jacassant": [
        "jacassant",
        "jacasser"
    ],
    "jacassante": [
        "jacassant"
    ],
    "jacassantes": [
        "jacassant"
    ],
    "jacassants": [
        "jacassant"
    ],
    "jacasse": [
        "jacasser",
        "jacasse"
    ],
    "jacassement": [
        "jacassement"
    ],
    "jacassements": [
        "jacassement"
    ],
    "jacassent": [
        "jacasser"
    ],
    "jacasser": [
        "jacasser"
    ],
    "jacasseraient": [
        "jacasser"
    ],
    "jacasserie": [
        "jacasserie"
    ],
    "jacasseries": [
        "jacasserie"
    ],
    "jacasses": [
        "jacasser",
        "jacasse"
    ],
    "jacasseur": [
        "jacasseur"
    ],
    "jacasseurs": [
        "jacasseur"
    ],
    "jacasseuse": [
        "jacasseur"
    ],
    "jacassez": [
        "jacasser"
    ],
    "jacassiers": [
        "jacassier"
    ],
    "jacassiez": [
        "jacasser"
    ],
    "jacassiere": [
        "jacassier"
    ],
    "jachere": [
        "jachere"
    ],
    "jacheres": [
        "jachere"
    ],
    "jacinthe": [
        "jacinthe"
    ],
    "jacinthes": [
        "jacinthe"
    ],
    "jack": [
        "jack"
    ],
    "jacket": [
        "jacket"
    ],
    "jackets": [
        "jacket"
    ],
    "jackpot": [
        "jackpot"
    ],
    "jacks": [
        "jack"
    ],
    "jacob": [
        "jacob"
    ],
    "jacobin": [
        "jacobin"
    ],
    "jacobine": [
        "jacobin"
    ],
    "jacobins": [
        "jacobin"
    ],
    "jacobite": [
        "jacobite"
    ],
    "jacobites": [
        "jacobite"
    ],
    "jacobees": [
        "jacobee"
    ],
    "jacot": [
        "jacot"
    ],
    "jacquard": [
        "jacquard"
    ],
    "jacqueline": [
        "jacqueline"
    ],
    "jacquemart": [
        "jacquemart"
    ],
    "jacquemarts": [
        "jacquemart"
    ],
    "jacqueries": [
        "jacquerie"
    ],
    "jacques": [
        "jacques"
    ],
    "jacquet": [
        "jacquet"
    ],
    "jacquier": [
        "jacquier"
    ],
    "jacquot": [
        "jacquot"
    ],
    "jactais": [
        "jacter"
    ],
    "jactait": [
        "jacter"
    ],
    "jactance": [
        "jactance"
    ],
    "jactancier": [
        "jactancier"
    ],
    "jactant": [
        "jacter"
    ],
    "jacte": [
        "jacter"
    ],
    "jactent": [
        "jacter"
    ],
    "jacter": [
        "jacter"
    ],
    "jacteraient": [
        "jacter"
    ],
    "jacterais": [
        "jacter"
    ],
    "jactes": [
        "jacter"
    ],
    "jacteur": [
        "jacteur"
    ],
    "jactez": [
        "jacter"
    ],
    "jactions": [
        "jacter"
    ],
    "jaculatoire": [
        "jaculatoire"
    ],
    "jacuzzi": [
        "jacuzzi"
    ],
    "jacuzzis": [
        "jacuzzi"
    ],
    "jade": [
        "jade"
    ],
    "jades": [
        "jade"
    ],
    "jadis": [
        "jadis"
    ],
    "jaffa": [
        "jaffer"
    ],
    "jaffas": [
        "jaffer"
    ],
    "jaffe": [
        "jaffe"
    ],
    "jaffer": [
        "jaffer"
    ],
    "jaguar": [
        "jaguar"
    ],
    "jaguarondi": [
        "jaguarondi"
    ],
    "jaguars": [
        "jaguar"
    ],
    "jailli": [
        "jaillir"
    ],
    "jaillie": [
        "jaillir"
    ],
    "jaillies": [
        "jaillir"
    ],
    "jaillir": [
        "jaillir"
    ],
    "jaillira": [
        "jaillir"
    ],
    "jailliraient": [
        "jaillir"
    ],
    "jaillirait": [
        "jaillir"
    ],
    "jaillirent": [
        "jaillir"
    ],
    "jailliront": [
        "jaillir"
    ],
    "jaillis": [
        "jaillir"
    ],
    "jaillissaient": [
        "jaillir"
    ],
    "jaillissait": [
        "jaillir"
    ],
    "jaillissant": [
        "jaillir",
        "jaillissant"
    ],
    "jaillissante": [
        "jaillissant"
    ],
    "jaillissantes": [
        "jaillissant"
    ],
    "jaillissants": [
        "jaillissant"
    ],
    "jaillisse": [
        "jaillir"
    ],
    "jaillissement": [
        "jaillissement"
    ],
    "jaillissements": [
        "jaillissement"
    ],
    "jaillissent": [
        "jaillir"
    ],
    "jaillit": [
        "jaillir"
    ],
    "jais": [
        "jais"
    ],
    "jaja": [
        "jaja"
    ],
    "jalmince": [
        "jalmince"
    ],
    "jalminces": [
        "jalmince"
    ],
    "jalon": [
        "jalon"
    ],
    "jalonnaient": [
        "jalonner"
    ],
    "jalonnais": [
        "jalonner"
    ],
    "jalonnait": [
        "jalonner"
    ],
    "jalonnant": [
        "jalonner"
    ],
    "jalonne": [
        "jalonne",
        "jalonner"
    ],
    "jalonnent": [
        "jalonner"
    ],
    "jalonner": [
        "jalonner"
    ],
    "jalonnee": [
        "jalonne",
        "jalonner"
    ],
    "jalonnes": [
        "jalonner"
    ],
    "jalons": [
        "jalon"
    ],
    "jalousaient": [
        "jalouser"
    ],
    "jalousais": [
        "jalouser"
    ],
    "jalousait": [
        "jalouser"
    ],
    "jalousant": [
        "jalouser"
    ],
    "jalouse": [
        "jaloux",
        "jalouser"
    ],
    "jalousement": [
        "jalousement"
    ],
    "jalousent": [
        "jalouser"
    ],
    "jalouser": [
        "jalouser"
    ],
    "jalouserais": [
        "jalouser"
    ],
    "jalouses": [
        "jaloux"
    ],
    "jalousie": [
        "jalousie"
    ],
    "jalousies": [
        "jalousie"
    ],
    "jalousee": [
        "jalouser"
    ],
    "jaloux": [
        "jaloux"
    ],
    "jam": [
        "jam"
    ],
    "jamais": [
        "jamais"
    ],
    "jamaicain": [
        "jamaicain"
    ],
    "jamaicaine": [
        "jamaicain"
    ],
    "jamaicains": [
        "jamaicain"
    ],
    "jamaiquain": [
        "jamaiquain"
    ],
    "jamaiquains": [
        "jamaiquain"
    ],
    "jambage": [
        "jambage"
    ],
    "jambages": [
        "jambage"
    ],
    "jambart": [
        "jambart"
    ],
    "jambe": [
        "jambe"
    ],
    "jambes": [
        "jambe"
    ],
    "jambier": [
        "jambier"
    ],
    "jambiere": [
        "jambiere"
    ],
    "jambieres": [
        "jambiere",
        "jambier"
    ],
    "jambon": [
        "jambon"
    ],
    "jambonneau": [
        "jambonneau"
    ],
    "jambonneaux": [
        "jambonneau"
    ],
    "jambons": [
        "jambon"
    ],
    "jamboree": [
        "jamboree"
    ],
    "janissaire": [
        "janissaire"
    ],
    "janissaires": [
        "janissaire"
    ],
    "jans": [
        "jan"
    ],
    "jansenisme": [
        "jansenisme"
    ],
    "janseniste": [
        "janseniste"
    ],
    "jansenistes": [
        "janseniste"
    ],
    "jante": [
        "jante"
    ],
    "jantes": [
        "jante"
    ],
    "janvier": [
        "janvier"
    ],
    "jap": [
        "jap"
    ],
    "japon": [
        "japon"
    ],
    "japonais": [
        "japonais"
    ],
    "japonaise": [
        "japonais"
    ],
    "japonaiserie": [
        "japonaiserie"
    ],
    "japonaises": [
        "japonais"
    ],
    "japonerie": [
        "japonerie"
    ],
    "japoneries": [
        "japonerie"
    ],
    "japonisants": [
        "japonisant"
    ],
    "japoniser": [
        "japoniser"
    ],
    "japons": [
        "japon"
    ],
    "jappa": [
        "japper"
    ],
    "jappaient": [
        "japper"
    ],
    "jappait": [
        "japper"
    ],
    "jappant": [
        "japper"
    ],
    "jappe": [
        "japper"
    ],
    "jappement": [
        "jappement"
    ],
    "jappements": [
        "jappement"
    ],
    "jappent": [
        "japper"
    ],
    "japper": [
        "japper"
    ],
    "jappeur": [
        "jappeur"
    ],
    "japperent": [
        "japper"
    ],
    "japs": [
        "jap"
    ],
    "jaquelin": [
        "jaquelin"
    ],
    "jaquemart": [
        "jaquemart"
    ],
    "jaquemarts": [
        "jaquemart"
    ],
    "jaquet": [
        "jaquet"
    ],
    "jaquette": [
        "jaquette"
    ],
    "jaquettes": [
        "jaquette"
    ],
    "jar": [
        "jar"
    ],
    "jardin": [
        "jardin"
    ],
    "jardinage": [
        "jardinage"
    ],
    "jardinait": [
        "jardiner"
    ],
    "jardinant": [
        "jardiner"
    ],
    "jardine": [
        "jardiner"
    ],
    "jardinent": [
        "jardiner"
    ],
    "jardiner": [
        "jardiner"
    ],
    "jardinerai": [
        "jardiner"
    ],
    "jardineras": [
        "jardiner"
    ],
    "jardinerie": [
        "jardinerie"
    ],
    "jardinet": [
        "jardinet"
    ],
    "jardinets": [
        "jardinet"
    ],
    "jardinier": [
        "jardinier"
    ],
    "jardiniers": [
        "jardinier"
    ],
    "jardiniere": [
        "jardiniere"
    ],
    "jardinieres": [
        "jardiniere"
    ],
    "jardins": [
        "jardin"
    ],
    "jargon": [
        "jargon"
    ],
    "jargonnant": [
        "jargonner"
    ],
    "jargonne": [
        "jargonner"
    ],
    "jargonnent": [
        "jargonner"
    ],
    "jargonner": [
        "jargonner"
    ],
    "jargons": [
        "jargon"
    ],
    "jarnicoton": [
        "jarnicoton"
    ],
    "jarre": [
        "jarre"
    ],
    "jarres": [
        "jarre"
    ],
    "jarret": [
        "jarret"
    ],
    "jarretelle": [
        "jarretelle"
    ],
    "jarretelles": [
        "jarretelle"
    ],
    "jarretiere": [
        "jarretiere"
    ],
    "jarretieres": [
        "jarretiere"
    ],
    "jarrets": [
        "jarret"
    ],
    "jars": [
        "jars",
        "jar"
    ],
    "jas": [
        "jas"
    ],
    "jasaient": [
        "jaser"
    ],
    "jasait": [
        "jaser"
    ],
    "jase": [
        "jaser"
    ],
    "jasent": [
        "jaser"
    ],
    "jaser": [
        "jaser"
    ],
    "jaserait": [
        "jaser"
    ],
    "jases": [
        "jaser"
    ],
    "jaseur": [
        "jaseur"
    ],
    "jasmin": [
        "jasmin"
    ],
    "jasmins": [
        "jasmin"
    ],
    "jaspaient": [
        "jasper"
    ],
    "jaspe": [
        "jaspe",
        "jasper"
    ],
    "jasper": [
        "jasper"
    ],
    "jaspin": [
        "jaspin"
    ],
    "jaspinaient": [
        "jaspiner"
    ],
    "jaspinais": [
        "jaspiner"
    ],
    "jaspinait": [
        "jaspiner"
    ],
    "jaspine": [
        "jaspiner"
    ],
    "jaspinent": [
        "jaspiner"
    ],
    "jaspiner": [
        "jaspiner"
    ],
    "jaspees": [
        "jasper"
    ],
    "jaspes": [
        "jasper"
    ],
    "jatte": [
        "jatte"
    ],
    "jattes": [
        "jatte"
    ],
    "jauge": [
        "jauge",
        "jauger"
    ],
    "jaugea": [
        "jauger"
    ],
    "jaugeait": [
        "jauger"
    ],
    "jaugeant": [
        "jauger"
    ],
    "jaugent": [
        "jauger"
    ],
    "jauger": [
        "jauger"
    ],
    "jauges": [
        "jauge",
        "jauger"
    ],
    "jaugez": [
        "jauger"
    ],
    "jaugee": [
        "jauger"
    ],
    "jaunasse": [
        "jaunasse"
    ],
    "jaunasses": [
        "jaunasse"
    ],
    "jaune": [
        "jaune"
    ],
    "jaunes": [
        "jaune"
    ],
    "jaunets": [
        "jaunet"
    ],
    "jauni": [
        "jauni",
        "jaunir"
    ],
    "jaunie": [
        "jauni",
        "jaunir"
    ],
    "jaunies": [
        "jauni",
        "jaunir"
    ],
    "jaunir": [
        "jaunir"
    ],
    "jaunira": [
        "jaunir"
    ],
    "jauniront": [
        "jaunir"
    ],
    "jaunis": [
        "jauni",
        "jaunir"
    ],
    "jaunissaient": [
        "jaunir"
    ],
    "jaunissait": [
        "jaunir"
    ],
    "jaunissant": [
        "jaunissant",
        "jaunir"
    ],
    "jaunissante": [
        "jaunissant"
    ],
    "jaunissantes": [
        "jaunissant"
    ],
    "jaunissants": [
        "jaunissant"
    ],
    "jaunisse": [
        "jaunisse",
        "jaunir"
    ],
    "jaunissement": [
        "jaunissement"
    ],
    "jaunissent": [
        "jaunir"
    ],
    "jaunisses": [
        "jaunisse"
    ],
    "jaunit": [
        "jaunir"
    ],
    "jaunatre": [
        "jaunatre"
    ],
    "jaunatres": [
        "jaunatre"
    ],
    "java": [
        "java"
    ],
    "javanais": [
        "javanais"
    ],
    "javanaise": [
        "javanais"
    ],
    "javanaises": [
        "javanais"
    ],
    "javas": [
        "java"
    ],
    "javel": [
        "javel"
    ],
    "javeline": [
        "javeline"
    ],
    "javelle": [
        "javelle"
    ],
    "javelles": [
        "javelle"
    ],
    "javellise": [
        "javelliser"
    ],
    "javelliser": [
        "javelliser"
    ],
    "javellisee": [
        "javelliser"
    ],
    "javellisees": [
        "javelliser"
    ],
    "javelot": [
        "javelot"
    ],
    "javelots": [
        "javelot"
    ],
    "javotte": [
        "javotte"
    ],
    "jazz": [
        "jazz"
    ],
    "jazzman": [
        "jazzman"
    ],
    "jazzmen": [
        "jazzman"
    ],
    "jazzy": [
        "jazzy"
    ],
    "jainistes": [
        "jainiste"
    ],
    "je": [
        "je"
    ],
    "jean": [
        "jeans",
        "jean"
    ],
    "jeanneton": [
        "jeanneton"
    ],
    "jeannette": [
        "jeannette"
    ],
    "jeannettes": [
        "jeannette"
    ],
    "jeannot": [
        "jeannot"
    ],
    "jeans": [
        "jean"
    ],
    "jeep": [
        "jeep"
    ],
    "jeeps": [
        "jeep"
    ],
    "jellaba": [
        "jellaba"
    ],
    "jenny": [
        "jenny"
    ],
    "jerez": [
        "jerez"
    ],
    "jerk": [
        "jerk"
    ],
    "jerrican": [
        "jerrican"
    ],
    "jerricane": [
        "jerricane"
    ],
    "jerricanes": [
        "jerricane"
    ],
    "jerricans": [
        "jerrican"
    ],
    "jerrycan": [
        "jerrycan"
    ],
    "jerrycans": [
        "jerrycan"
    ],
    "jersey": [
        "jersey"
    ],
    "jerseys": [
        "jersey"
    ],
    "jet": [
        "jet"
    ],
    "jeta": [
        "jeter"
    ],
    "jetable": [
        "jetable"
    ],
    "jetables": [
        "jetable"
    ],
    "jetai": [
        "jeter"
    ],
    "jetaient": [
        "jeter"
    ],
    "jetais": [
        "jeter"
    ],
    "jetait": [
        "jeter"
    ],
    "jetant": [
        "jeter"
    ],
    "jetas": [
        "jeter"
    ],
    "jeter": [
        "jeter"
    ],
    "jeteur": [
        "jeteur"
    ],
    "jeteurs": [
        "jeteur"
    ],
    "jeteuse": [
        "jeteur"
    ],
    "jeteuses": [
        "jeteur"
    ],
    "jetez": [
        "jeter"
    ],
    "jetiez": [
        "jeter"
    ],
    "jetions": [
        "jeter"
    ],
    "jeton": [
        "jeton"
    ],
    "jetons": [
        "jeton",
        "jeter"
    ],
    "jets": [
        "jet"
    ],
    "jette": [
        "jette",
        "jeter"
    ],
    "jettent": [
        "jeter"
    ],
    "jettera": [
        "jeter"
    ],
    "jetterai": [
        "jeter"
    ],
    "jetteraient": [
        "jeter"
    ],
    "jetterais": [
        "jeter"
    ],
    "jetterait": [
        "jeter"
    ],
    "jetteras": [
        "jeter"
    ],
    "jetterez": [
        "jeter"
    ],
    "jetteriez": [
        "jeter"
    ],
    "jetterions": [
        "jeter"
    ],
    "jetterons": [
        "jeter"
    ],
    "jetteront": [
        "jeter"
    ],
    "jettes": [
        "jeter"
    ],
    "jetames": [
        "jeter"
    ],
    "jetat": [
        "jeter"
    ],
    "jeterent": [
        "jeter"
    ],
    "jete": [
        "jete",
        "jeter"
    ],
    "jetee": [
        "jetee",
        "jete",
        "jeter"
    ],
    "jetees": [
        "jetee",
        "jete",
        "jeter"
    ],
    "jetes": [
        "jete",
        "jeter"
    ],
    "jeu": [
        "jeu"
    ],
    "jeudi": [
        "jeudi"
    ],
    "jeudis": [
        "jeudi"
    ],
    "jeune": [
        "jeuner",
        "jeune"
    ],
    "jeunement": [
        "jeunement"
    ],
    "jeunes": [
        "jeuner",
        "jeune"
    ],
    "jeunesse": [
        "jeunesse"
    ],
    "jeunesses": [
        "jeunesse"
    ],
    "jeunet": [
        "jeunet"
    ],
    "jeunets": [
        "jeunet"
    ],
    "jeunette": [
        "jeunette",
        "jeunet"
    ],
    "jeunettes": [
        "jeunette",
        "jeunet"
    ],
    "jeunot": [
        "jeunot"
    ],
    "jeunots": [
        "jeunot"
    ],
    "jeux": [
        "jeu"
    ],
    "jeuna": [
        "jeuner"
    ],
    "jeunaient": [
        "jeuner"
    ],
    "jeunait": [
        "jeuner"
    ],
    "jeunant": [
        "jeuner"
    ],
    "jeunent": [
        "jeuner"
    ],
    "jeuner": [
        "jeuner"
    ],
    "jeunerai": [
        "jeuner"
    ],
    "jeunerait": [
        "jeuner"
    ],
    "jeuneras": [
        "jeuner"
    ],
    "jeunerons": [
        "jeuner"
    ],
    "jeuneurs": [
        "jeuneur"
    ],
    "jeunez": [
        "jeuner"
    ],
    "jigger": [
        "jigger"
    ],
    "jihad": [
        "jihad"
    ],
    "jingle": [
        "jingle"
    ],
    "jingles": [
        "jingle"
    ],
    "jinjin": [
        "jinjin"
    ],
    "jivaro": [
        "jivaro"
    ],
    "joaillerie": [
        "joaillerie"
    ],
    "joaillier": [
        "joaillier"
    ],
    "joailliers": [
        "joaillier"
    ],
    "job": [
        "job"
    ],
    "jobard": [
        "jobard"
    ],
    "jobardes": [
        "jobard"
    ],
    "jobardise": [
        "jobardise"
    ],
    "jobards": [
        "jobard"
    ],
    "jobs": [
        "job"
    ],
    "jociste": [
        "jociste"
    ],
    "jocistes": [
        "jociste"
    ],
    "jockey": [
        "jockey"
    ],
    "jockeys": [
        "jockey"
    ],
    "jocko": [
        "jocko"
    ],
    "jocrisse": [
        "jocrisse"
    ],
    "jocrisses": [
        "jocrisse"
    ],
    "jodhpurs": [
        "jodhpur"
    ],
    "jodler": [
        "jodler"
    ],
    "jogger": [
        "jogger"
    ],
    "joggers": [
        "jogger"
    ],
    "joggeur": [
        "joggeur"
    ],
    "joggeurs": [
        "joggeur"
    ],
    "joggeuse": [
        "joggeur"
    ],
    "jogging": [
        "jog",
        "jogging"
    ],
    "joggings": [
        "jogging"
    ],
    "johannisberg": [
        "johannisberg"
    ],
    "joice": [
        "joice"
    ],
    "joices": [
        "joice"
    ],
    "joie": [
        "joie"
    ],
    "joies": [
        "joie"
    ],
    "joignable": [
        "joignable"
    ],
    "joignaient": [
        "joindre"
    ],
    "joignais": [
        "joindre"
    ],
    "joignait": [
        "joindre"
    ],
    "joignant": [
        "joindre"
    ],
    "joigne": [
        "joindre"
    ],
    "joignent": [
        "joindre"
    ],
    "joignes": [
        "joindre"
    ],
    "joignez": [
        "joindre"
    ],
    "joigniez": [
        "joindre"
    ],
    "joignions": [
        "joindre"
    ],
    "joignirent": [
        "joindre"
    ],
    "joignis": [
        "joindre"
    ],
    "joignissent": [
        "joindre"
    ],
    "joignit": [
        "joindre"
    ],
    "joignons": [
        "joindre"
    ],
    "joignimes": [
        "joindre"
    ],
    "joindra": [
        "joindre"
    ],
    "joindrai": [
        "joindre"
    ],
    "joindraient": [
        "joindre"
    ],
    "joindrais": [
        "joindre"
    ],
    "joindrait": [
        "joindre"
    ],
    "joindras": [
        "joindre"
    ],
    "joindre": [
        "joindre"
    ],
    "joindrez": [
        "joindre"
    ],
    "joindriez": [
        "joindre"
    ],
    "joindrons": [
        "joindre"
    ],
    "joindront": [
        "joindre"
    ],
    "joins": [
        "join",
        "joindre"
    ],
    "joint": [
        "joindre",
        "joint"
    ],
    "jointe": [
        "joint",
        "jointer"
    ],
    "jointes": [
        "joint",
        "jointer"
    ],
    "jointif": [
        "jointif"
    ],
    "jointifs": [
        "jointif"
    ],
    "jointives": [
        "jointif"
    ],
    "jointoyaient": [
        "jointoyer"
    ],
    "joints": [
        "joindre",
        "joint"
    ],
    "jointure": [
        "jointure"
    ],
    "jointures": [
        "jointure"
    ],
    "jointee": [
        "jointe"
    ],
    "jojo": [
        "jojo"
    ],
    "jojoba": [
        "jojoba"
    ],
    "jojos": [
        "jojo"
    ],
    "jokari": [
        "jokari"
    ],
    "joker": [
        "joker"
    ],
    "jokers": [
        "joker"
    ],
    "joli": [
        "joli"
    ],
    "jolibois": [
        "jolibois"
    ],
    "jolie": [
        "jolie",
        "joli"
    ],
    "jolies": [
        "joli"
    ],
    "joliesse": [
        "joliesse"
    ],
    "joliesses": [
        "joliesse"
    ],
    "joliet": [
        "joliet"
    ],
    "joliette": [
        "joliet"
    ],
    "joliment": [
        "joliment"
    ],
    "jolis": [
        "joli"
    ],
    "jonc": [
        "jonc"
    ],
    "joncaille": [
        "joncaille"
    ],
    "jonchaie": [
        "jonchaie"
    ],
    "jonchaient": [
        "joncher"
    ],
    "jonchaies": [
        "jonchaie"
    ],
    "jonchait": [
        "joncher"
    ],
    "jonchant": [
        "joncher"
    ],
    "jonchent": [
        "joncher"
    ],
    "joncher": [
        "joncher"
    ],
    "joncheraies": [
        "joncheraie"
    ],
    "jonchet": [
        "jonchet"
    ],
    "jonchets": [
        "jonchet"
    ],
    "jonchere": [
        "jonchere"
    ],
    "jonche": [
        "joncher",
        "jonche"
    ],
    "jonchee": [
        "joncher",
        "jonche",
        "jonchee"
    ],
    "jonchees": [
        "joncher",
        "jonche",
        "jonchee"
    ],
    "jonches": [
        "joncher",
        "jonche"
    ],
    "joncs": [
        "jonc"
    ],
    "jonction": [
        "jonction"
    ],
    "jonctions": [
        "jonction"
    ],
    "jonglage": [
        "jonglage"
    ],
    "jonglaient": [
        "jongler"
    ],
    "jonglais": [
        "jongler"
    ],
    "jonglait": [
        "jongler"
    ],
    "jonglant": [
        "jongler"
    ],
    "jongle": [
        "jongler"
    ],
    "jonglent": [
        "jongler"
    ],
    "jongler": [
        "jongler"
    ],
    "jonglera": [
        "jongler"
    ],
    "jonglerie": [
        "jonglerie"
    ],
    "jongleries": [
        "jonglerie"
    ],
    "jongles": [
        "jongler"
    ],
    "jongleur": [
        "jongleur"
    ],
    "jongleurs": [
        "jongleur"
    ],
    "jongleuse": [
        "jongleur"
    ],
    "jongleuses": [
        "jongleur"
    ],
    "jonglez": [
        "jongler"
    ],
    "jonkheer": [
        "jonkheer"
    ],
    "jonque": [
        "jonque"
    ],
    "jonques": [
        "jonque"
    ],
    "jonquille": [
        "jonquille"
    ],
    "jonquilles": [
        "jonquille"
    ],
    "jordanienne": [
        "jordanien",
        "jordanienne"
    ],
    "jordaniens": [
        "jordanien"
    ],
    "jordonner": [
        "jordonner"
    ],
    "joseph": [
        "joseph"
    ],
    "joua": [
        "jouer"
    ],
    "jouable": [
        "jouable"
    ],
    "jouai": [
        "jouer"
    ],
    "jouaient": [
        "jouer"
    ],
    "jouais": [
        "jouer"
    ],
    "jouait": [
        "jouer"
    ],
    "jouant": [
        "jouer"
    ],
    "jouasse": [
        "jouasse"
    ],
    "jouasses": [
        "jouasse"
    ],
    "joubarbe": [
        "joubarbe"
    ],
    "joue": [
        "jouer",
        "joue"
    ],
    "jouent": [
        "jouer"
    ],
    "jouer": [
        "jouer"
    ],
    "jouera": [
        "jouer"
    ],
    "jouerai": [
        "jouer"
    ],
    "joueraient": [
        "jouer"
    ],
    "jouerais": [
        "jouer"
    ],
    "jouerait": [
        "jouer"
    ],
    "joueras": [
        "jouer"
    ],
    "jouerez": [
        "jouer"
    ],
    "joueriez": [
        "jouer"
    ],
    "jouerions": [
        "jouer"
    ],
    "jouerons": [
        "jouer"
    ],
    "joueront": [
        "jouer"
    ],
    "joues": [
        "jouer",
        "joue"
    ],
    "jouet": [
        "jouet"
    ],
    "jouets": [
        "jouet"
    ],
    "joueur": [
        "joueur"
    ],
    "joueurs": [
        "joueur"
    ],
    "joueuse": [
        "joueur"
    ],
    "joueuses": [
        "joueur"
    ],
    "jouez": [
        "jouer"
    ],
    "joufflu": [
        "joufflu"
    ],
    "joufflue": [
        "joufflu"
    ],
    "joufflues": [
        "joufflu"
    ],
    "joufflus": [
        "joufflu"
    ],
    "joug": [
        "joug"
    ],
    "jougs": [
        "joug"
    ],
    "joui": [
        "jouir"
    ],
    "jouiez": [
        "jouer"
    ],
    "jouions": [
        "jouer"
    ],
    "jouir": [
        "jouir"
    ],
    "jouira": [
        "jouir"
    ],
    "jouirai": [
        "jouir"
    ],
    "jouiraient": [
        "jouir"
    ],
    "jouirait": [
        "jouir"
    ],
    "jouiras": [
        "jouir"
    ],
    "jouirent": [
        "jouir"
    ],
    "jouirions": [
        "jouir"
    ],
    "jouirons": [
        "jouir"
    ],
    "jouis": [
        "jouir"
    ],
    "jouissaient": [
        "jouir"
    ],
    "jouissais": [
        "jouir"
    ],
    "jouissait": [
        "jouir"
    ],
    "jouissance": [
        "jouissance"
    ],
    "jouissances": [
        "jouissance"
    ],
    "jouissant": [
        "jouir"
    ],
    "jouissants": [
        "jouissant"
    ],
    "jouisse": [
        "jouir"
    ],
    "jouissent": [
        "jouir"
    ],
    "jouisses": [
        "jouir"
    ],
    "jouisseur": [
        "jouisseur"
    ],
    "jouisseurs": [
        "jouisseur"
    ],
    "jouisseuse": [
        "jouisseur"
    ],
    "jouissez": [
        "jouir"
    ],
    "jouissif": [
        "jouissif"
    ],
    "jouissifs": [
        "jouissif"
    ],
    "jouissions": [
        "jouir"
    ],
    "jouissive": [
        "jouissif"
    ],
    "jouissives": [
        "jouissif"
    ],
    "jouissons": [
        "jouir"
    ],
    "jouit": [
        "jouir"
    ],
    "joujou": [
        "joujou"
    ],
    "joujoux": [
        "joujoux"
    ],
    "joules": [
        "joule"
    ],
    "jouons": [
        "jouer"
    ],
    "jour": [
        "jour"
    ],
    "journal": [
        "journal"
    ],
    "journaleuse": [
        "journaleux"
    ],
    "journaleux": [
        "journaleux"
    ],
    "journalier": [
        "journalier"
    ],
    "journaliers": [
        "journalier"
    ],
    "journalisme": [
        "journalisme"
    ],
    "journaliste": [
        "journaliste"
    ],
    "journalistes": [
        "journaliste"
    ],
    "journalistique": [
        "journalistique"
    ],
    "journalistiques": [
        "journalistique"
    ],
    "journaliere": [
        "journalier"
    ],
    "journalieres": [
        "journaliere",
        "journalier"
    ],
    "journaux": [
        "journal"
    ],
    "journellement": [
        "journellement"
    ],
    "journee": [
        "journee"
    ],
    "journees": [
        "journee"
    ],
    "jours": [
        "jour"
    ],
    "joute": [
        "jouter",
        "joute"
    ],
    "jouter": [
        "jouter"
    ],
    "joutes": [
        "joute"
    ],
    "jouteur": [
        "jouteur"
    ],
    "jouteurs": [
        "jouteur"
    ],
    "jouteuse": [
        "jouteur"
    ],
    "joutez": [
        "jouter"
    ],
    "jouvence": [
        "jouvence"
    ],
    "jouvenceau": [
        "jouvenceau"
    ],
    "jouvenceaux": [
        "jouvenceau"
    ],
    "jouvencelle": [
        "jouvenceau"
    ],
    "jouvencelles": [
        "jouvenceau"
    ],
    "jouxtaient": [
        "jouxter"
    ],
    "jouxtait": [
        "jouxter"
    ],
    "jouxtant": [
        "jouxter"
    ],
    "jouxte": [
        "jouxter",
        "jouxte"
    ],
    "jouames": [
        "jouer"
    ],
    "jouat": [
        "jouer"
    ],
    "jouerent": [
        "jouer"
    ],
    "jouee": [
        "joue",
        "jouer"
    ],
    "jouees": [
        "joue",
        "jouer"
    ],
    "jovial": [
        "jovial"
    ],
    "joviale": [
        "jovial"
    ],
    "jovialement": [
        "jovialement"
    ],
    "joviales": [
        "jovial"
    ],
    "jovialite": [
        "jovialite"
    ],
    "joviaux": [
        "jovial"
    ],
    "joyau": [
        "joyau"
    ],
    "joyaux": [
        "joyau"
    ],
    "joyciennes": [
        "joycien"
    ],
    "joyeuse": [
        "joyeux"
    ],
    "joyeusement": [
        "joyeusement"
    ],
    "joyeuses": [
        "joyeux"
    ],
    "joyeusete": [
        "joyeusete"
    ],
    "joyeusetes": [
        "joyeusete"
    ],
    "joyeux": [
        "joyeux"
    ],
    "joystick": [
        "joystick"
    ],
    "juan": [
        "juan"
    ],
    "jubila": [
        "jubiler"
    ],
    "jubilai": [
        "jubiler"
    ],
    "jubilaient": [
        "jubiler"
    ],
    "jubilaire": [
        "jubilaire"
    ],
    "jubilais": [
        "jubiler"
    ],
    "jubilait": [
        "jubiler"
    ],
    "jubilant": [
        "jubilant",
        "jubiler"
    ],
    "jubilante": [
        "jubilant"
    ],
    "jubilantes": [
        "jubilant"
    ],
    "jubilants": [
        "jubilant"
    ],
    "jubilation": [
        "jubilation"
    ],
    "jubilations": [
        "jubilation"
    ],
    "jubilatoire": [
        "jubilatoire"
    ],
    "jubilatoires": [
        "jubilatoire"
    ],
    "jubile": [
        "jubile",
        "jubiler"
    ],
    "jubilent": [
        "jubiler"
    ],
    "jubiler": [
        "jubiler"
    ],
    "jubilera": [
        "jubiler"
    ],
    "jubileraient": [
        "jubiler"
    ],
    "jubiles": [
        "jubiler"
    ],
    "jubilerent": [
        "jubiler"
    ],
    "jubilee": [
        "jubiler"
    ],
    "jube": [
        "jube"
    ],
    "jucha": [
        "jucher"
    ],
    "juchai": [
        "jucher"
    ],
    "juchaient": [
        "jucher"
    ],
    "juchais": [
        "jucher"
    ],
    "juchait": [
        "jucher"
    ],
    "juchant": [
        "jucher"
    ],
    "juche": [
        "jucher"
    ],
    "juchent": [
        "jucher"
    ],
    "jucher": [
        "jucher"
    ],
    "jucheront": [
        "jucher"
    ],
    "juchions": [
        "jucher"
    ],
    "juchee": [
        "jucher",
        "juchee"
    ],
    "juchees": [
        "jucher"
    ],
    "juches": [
        "jucher"
    ],
    "judas": [
        "judas"
    ],
    "judaicite": [
        "judaicite"
    ],
    "judaique": [
        "judaique"
    ],
    "judaiques": [
        "judaique"
    ],
    "judaisant": [
        "judaisant"
    ],
    "judaiser": [
        "judaiser"
    ],
    "judaisme": [
        "judaisme"
    ],
    "judaisees": [
        "judaiser"
    ],
    "judaite": [
        "judaite"
    ],
    "judiciaire": [
        "judiciaire"
    ],
    "judiciaires": [
        "judiciaire"
    ],
    "judicieuse": [
        "judicieux"
    ],
    "judicieusement": [
        "judicieusement"
    ],
    "judicieuses": [
        "judicieux"
    ],
    "judicieux": [
        "judicieux"
    ],
    "judo": [
        "judo"
    ],
    "judoka": [
        "judoka"
    ],
    "judeen": [
        "judeen"
    ],
    "judeenne": [
        "judeenne"
    ],
    "judeite": [
        "judeite"
    ],
    "judeo": [
        "judeo"
    ],
    "juge": [
        "juge",
        "juger"
    ],
    "jugea": [
        "juger"
    ],
    "jugeai": [
        "juger"
    ],
    "jugeaient": [
        "juger"
    ],
    "jugeais": [
        "juger"
    ],
    "jugeait": [
        "juger"
    ],
    "jugeant": [
        "juger"
    ],
    "jugement": [
        "jugement"
    ],
    "jugements": [
        "jugement"
    ],
    "jugent": [
        "juger"
    ],
    "jugeons": [
        "juger"
    ],
    "jugeote": [
        "jugeote"
    ],
    "juger": [
        "juger"
    ],
    "jugera": [
        "juger"
    ],
    "jugerai": [
        "juger"
    ],
    "jugeraient": [
        "juger"
    ],
    "jugerais": [
        "juger"
    ],
    "jugerait": [
        "juger"
    ],
    "jugeras": [
        "juger"
    ],
    "jugerez": [
        "juger"
    ],
    "jugeriez": [
        "juger"
    ],
    "jugerons": [
        "juger"
    ],
    "jugeront": [
        "juger"
    ],
    "juges": [
        "juge",
        "juger"
    ],
    "jugeur": [
        "jugeur"
    ],
    "jugez": [
        "juger"
    ],
    "jugeames": [
        "juger"
    ],
    "jugeat": [
        "juger"
    ],
    "jugiez": [
        "juger"
    ],
    "jugions": [
        "juger"
    ],
    "jugula": [
        "juguler"
    ],
    "jugulaire": [
        "jugulaire"
    ],
    "jugulaires": [
        "jugulaire"
    ],
    "jugulant": [
        "juguler"
    ],
    "jugule": [
        "juguler"
    ],
    "juguler": [
        "juguler"
    ],
    "jugulee": [
        "juguler"
    ],
    "jugerent": [
        "juger"
    ],
    "jugee": [
        "juger"
    ],
    "jugees": [
        "juger"
    ],
    "juif": [
        "juif"
    ],
    "juifs": [
        "juif"
    ],
    "juillet": [
        "juillet"
    ],
    "juillets": [
        "juillet"
    ],
    "juin": [
        "juin"
    ],
    "juive": [
        "juif"
    ],
    "juiverie": [
        "juiverie"
    ],
    "juiveries": [
        "juiverie"
    ],
    "juives": [
        "juif"
    ],
    "jujube": [
        "jujube"
    ],
    "jujubes": [
        "jujube"
    ],
    "jujubiers": [
        "jujubier"
    ],
    "julep": [
        "julep"
    ],
    "juleps": [
        "julep"
    ],
    "jules": [
        "jules"
    ],
    "julien": [
        "julien"
    ],
    "julienne": [
        "julienne"
    ],
    "juliennes": [
        "julienne"
    ],
    "julot": [
        "julot"
    ],
    "julots": [
        "julot"
    ],
    "jumbo": [
        "jumbo"
    ],
    "jumeau": [
        "jumeau"
    ],
    "jumeaux": [
        "jumeau"
    ],
    "jumelage": [
        "jumelage"
    ],
    "jumeler": [
        "jumeler"
    ],
    "jumelle": [
        "jumelle",
        "jumeau",
        "jumeler"
    ],
    "jumellera": [
        "jumeler"
    ],
    "jumelles": [
        "jumelle",
        "jumeau"
    ],
    "jumele": [
        "jumeler"
    ],
    "jumelee": [
        "jumele",
        "jumeler"
    ],
    "jumelees": [
        "jumele",
        "jumeler"
    ],
    "jumeles": [
        "jumele",
        "jumeler"
    ],
    "jument": [
        "jument"
    ],
    "jumenterie": [
        "jumenterie"
    ],
    "juments": [
        "jument"
    ],
    "jumper": [
        "jumper"
    ],
    "jumping": [
        "jumping",
        "jump"
    ],
    "jungien": [
        "jungien"
    ],
    "jungiens": [
        "jungien"
    ],
    "jungle": [
        "jungle"
    ],
    "jungles": [
        "jungle"
    ],
    "junior": [
        "junior"
    ],
    "juniors": [
        "junior"
    ],
    "junker": [
        "junker",
        "junk"
    ],
    "junkers": [
        "junker"
    ],
    "junkie": [
        "junkie"
    ],
    "junkies": [
        "junkie"
    ],
    "junky": [
        "junky"
    ],
    "junte": [
        "junte"
    ],
    "jupe": [
        "jupe"
    ],
    "jupes": [
        "jupe"
    ],
    "jupette": [
        "jupette"
    ],
    "jupettes": [
        "jupette"
    ],
    "jupiers": [
        "jupier"
    ],
    "jupiterien": [
        "jupiterien"
    ],
    "jupiterienne": [
        "jupiterien"
    ],
    "jupiteriens": [
        "jupiterien"
    ],
    "jupon": [
        "jupon"
    ],
    "juponnee": [
        "juponner"
    ],
    "juponnes": [
        "juponner"
    ],
    "jupons": [
        "jupon"
    ],
    "jupee": [
        "jupe"
    ],
    "jupees": [
        "jupe"
    ],
    "jura": [
        "jurer"
    ],
    "jurai": [
        "jurer"
    ],
    "juraient": [
        "jurer"
    ],
    "jurais": [
        "jurer"
    ],
    "jurait": [
        "jurer"
    ],
    "jurant": [
        "jurer"
    ],
    "jurancon": [
        "jurancon"
    ],
    "jurassien": [
        "jurassien"
    ],
    "jurassiens": [
        "jurassien"
    ],
    "jurassique": [
        "jurassique"
    ],
    "jurassiques": [
        "jurassique"
    ],
    "jure": [
        "jurer",
        "jure"
    ],
    "jurent": [
        "jurer"
    ],
    "jurer": [
        "jurer"
    ],
    "jurera": [
        "jurer"
    ],
    "jurerai": [
        "jurer"
    ],
    "jurerais": [
        "jurer"
    ],
    "jurerait": [
        "jurer"
    ],
    "jureras": [
        "jurer"
    ],
    "jurerez": [
        "jurer"
    ],
    "jureriez": [
        "jurer"
    ],
    "jureront": [
        "jurer"
    ],
    "jures": [
        "jurer",
        "jure"
    ],
    "jurez": [
        "jurer"
    ],
    "juridiction": [
        "juridiction"
    ],
    "juridictionnel": [
        "juridictionnel"
    ],
    "juridictionnelle": [
        "juridictionnel"
    ],
    "juridictions": [
        "juridiction"
    ],
    "juridique": [
        "juridique"
    ],
    "juridiquement": [
        "juridiquement"
    ],
    "juridiques": [
        "juridique"
    ],
    "juriez": [
        "jurer"
    ],
    "jurisprudence": [
        "jurisprudence"
    ],
    "juriste": [
        "juriste"
    ],
    "juristes": [
        "juriste"
    ],
    "juron": [
        "juron"
    ],
    "jurons": [
        "jurer",
        "juron"
    ],
    "jury": [
        "jury"
    ],
    "jurys": [
        "jury"
    ],
    "jurames": [
        "jurer"
    ],
    "jurerent": [
        "jurer"
    ],
    "juree": [
        "jurer",
        "jure"
    ],
    "jurees": [
        "jurer",
        "jure"
    ],
    "jus": [
        "jus"
    ],
    "jusant": [
        "jusant"
    ],
    "jusqu": [
        "jusqu"
    ],
    "jusqu'au": [
        "jusqu'au"
    ],
    "jusqu'a": [
        "jusqu'a"
    ],
    "jusque": [
        "jusque"
    ],
    "jusques": [
        "jusques"
    ],
    "jusquiame": [
        "jusquiame"
    ],
    "justaucorps": [
        "justaucorps"
    ],
    "juste": [
        "juste"
    ],
    "justement": [
        "justement"
    ],
    "justes": [
        "juste"
    ],
    "justesse": [
        "justesse"
    ],
    "justice": [
        "justice"
    ],
    "justices": [
        "justice"
    ],
    "justiciable": [
        "justiciable"
    ],
    "justiciables": [
        "justiciable"
    ],
    "justicier": [
        "justicier"
    ],
    "justiciers": [
        "justicier"
    ],
    "justiciere": [
        "justicier"
    ],
    "justifia": [
        "justifier"
    ],
    "justifiable": [
        "justifiable"
    ],
    "justifiables": [
        "justifiable"
    ],
    "justifiaient": [
        "justifier"
    ],
    "justifiais": [
        "justifier"
    ],
    "justifiait": [
        "justifier"
    ],
    "justifiant": [
        "justifier",
        "justifiant"
    ],
    "justificatif": [
        "justificatif"
    ],
    "justificatifs": [
        "justificatif"
    ],
    "justification": [
        "justification"
    ],
    "justifications": [
        "justification"
    ],
    "justificative": [
        "justificatif"
    ],
    "justificatives": [
        "justificatif"
    ],
    "justifie": [
        "justifier"
    ],
    "justifient": [
        "justifier"
    ],
    "justifier": [
        "justifier"
    ],
    "justifiera": [
        "justifier"
    ],
    "justifierai": [
        "justifier"
    ],
    "justifieraient": [
        "justifier"
    ],
    "justifierais": [
        "justifier"
    ],
    "justifierait": [
        "justifier"
    ],
    "justifiez": [
        "justifier"
    ],
    "justifiat": [
        "justifier"
    ],
    "justifiee": [
        "justifier"
    ],
    "justifiees": [
        "justifier"
    ],
    "justifies": [
        "justify",
        "justifier"
    ],
    "justinien": [
        "justinien"
    ],
    "juta": [
        "juter"
    ],
    "jutait": [
        "juter"
    ],
    "jute": [
        "juter",
        "jute"
    ],
    "juter": [
        "juter"
    ],
    "juteuse": [
        "juteux"
    ],
    "juteuses": [
        "juteux"
    ],
    "juteux": [
        "juteux"
    ],
    "juvenile": [
        "juvenile"
    ],
    "juveniles": [
        "juvenile"
    ],
    "juvenilite": [
        "juvenilite"
    ],
    "juxtaposaient": [
        "juxtaposer"
    ],
    "juxtaposais": [
        "juxtaposer"
    ],
    "juxtaposait": [
        "juxtaposer"
    ],
    "juxtaposant": [
        "juxtaposer"
    ],
    "juxtapose": [
        "juxtaposer"
    ],
    "juxtaposent": [
        "juxtaposer"
    ],
    "juxtaposer": [
        "juxtaposer"
    ],
    "juxtaposition": [
        "juxtaposition"
    ],
    "juxtapositions": [
        "juxtaposition"
    ],
    "juxtaposerent": [
        "juxtaposer"
    ],
    "juxtaposees": [
        "juxtaposer",
        "juxtapose"
    ],
    "juxtaposes": [
        "juxtaposer",
        "juxtapose"
    ],
    "ja": [
        "ja"
    ],
    "jeze": [
        "jeze"
    ],
    "jezes": [
        "jeze"
    ],
    "jejunale": [
        "jejunal"
    ],
    "jejunum": [
        "jejunum"
    ],
    "jeroboam": [
        "jeroboam"
    ],
    "jeroboams": [
        "jeroboam"
    ],
    "jeremiade": [
        "jeremiade"
    ],
    "jeremiades": [
        "jeremiade"
    ],
    "jesuite": [
        "jesuite"
    ],
    "jesuites": [
        "jesuite"
    ],
    "jesuitique": [
        "jesuitique"
    ],
    "jesuitiques": [
        "jesuitique"
    ],
    "jesuitiere": [
        "jesuitiere"
    ],
    "jesus": [
        "jesus"
    ],
    "k": [
        "k"
    ],
    "ka": [
        "ka"
    ],
    "kabarde": [
        "kabarde"
    ],
    "kabbale": [
        "kabbale"
    ],
    "kabbalistique": [
        "kabbalistique"
    ],
    "kabuki": [
        "kabuki"
    ],
    "kabyle": [
        "kabyle"
    ],
    "kabyles": [
        "kabyle"
    ],
    "kacha": [
        "kacha"
    ],
    "kacher": [
        "kacher"
    ],
    "kachoube": [
        "kachoube"
    ],
    "kaddisch": [
        "kaddisch"
    ],
    "kaddish": [
        "kaddish"
    ],
    "kadi": [
        "kadi"
    ],
    "kafir": [
        "kafir"
    ],
    "kafkaien": [
        "kafkaien"
    ],
    "kaftan": [
        "kaftan"
    ],
    "kaftans": [
        "kaftan"
    ],
    "kaiser": [
        "kaiser"
    ],
    "kaki": [
        "kaki"
    ],
    "kakis": [
        "kaki"
    ],
    "kalachnikovs": [
        "kalachnikov"
    ],
    "kali": [
        "kali"
    ],
    "kaliemie": [
        "kaliemie"
    ],
    "kalmouk": [
        "kalmouk"
    ],
    "kalmouks": [
        "kalmouk"
    ],
    "kalpa": [
        "kalpa"
    ],
    "kaleidoscope": [
        "kaleidoscope"
    ],
    "kaleidoscopes": [
        "kaleidoscope"
    ],
    "kama": [
        "kama"
    ],
    "kamala": [
        "kamala"
    ],
    "kami": [
        "kami"
    ],
    "kamikaze": [
        "kamikaze"
    ],
    "kamikazes": [
        "kamikaze"
    ],
    "kan": [
        "kan"
    ],
    "kana": [
        "kana"
    ],
    "kandjar": [
        "kandjar"
    ],
    "kangourou": [
        "kangourou"
    ],
    "kangourous": [
        "kangourou"
    ],
    "kanji": [
        "kanji"
    ],
    "kantien": [
        "kantien"
    ],
    "kantisme": [
        "kantisme"
    ],
    "kaolin": [
        "kaolin"
    ],
    "kaori": [
        "kaori"
    ],
    "kapo": [
        "kapo"
    ],
    "kapok": [
        "kapok"
    ],
    "kapokier": [
        "kapokier"
    ],
    "kapos": [
        "kapo"
    ],
    "kaposi": [
        "kaposi"
    ],
    "kapout": [
        "kapout"
    ],
    "kappa": [
        "kappa"
    ],
    "karaoke": [
        "karaoke"
    ],
    "karaokes": [
        "karaoke"
    ],
    "karate": [
        "karate"
    ],
    "karateka": [
        "karateka"
    ],
    "karatekas": [
        "karateka"
    ],
    "karen": [
        "karen"
    ],
    "kari": [
        "kari"
    ],
    "karite": [
        "karite"
    ],
    "karma": [
        "karma"
    ],
    "karmique": [
        "karmique"
    ],
    "kart": [
        "kart"
    ],
    "karting": [
        "karting"
    ],
    "kasbah": [
        "kasbah"
    ],
    "kascher": [
        "kascher"
    ],
    "kasher": [
        "kasher"
    ],
    "kastro": [
        "kastro"
    ],
    "kastros": [
        "kastro"
    ],
    "kata": [
        "kata"
    ],
    "katal": [
        "katal"
    ],
    "katangais": [
        "katangais"
    ],
    "katas": [
        "kata"
    ],
    "katchinas": [
        "katchina"
    ],
    "katiba": [
        "katiba"
    ],
    "kava": [
        "kava"
    ],
    "kawa": [
        "kawa"
    ],
    "kayac": [
        "kayac"
    ],
    "kayak": [
        "kayak"
    ],
    "kayakiste": [
        "kayakiste"
    ],
    "kazakh": [
        "kazakh"
    ],
    "kazakhs": [
        "kazakh"
    ],
    "kebab": [
        "kebab"
    ],
    "kebabs": [
        "kebab"
    ],
    "kebla": [
        "kebla"
    ],
    "keblas": [
        "kebla"
    ],
    "keepsake": [
        "keepsake"
    ],
    "keffieh": [
        "keffieh"
    ],
    "keiretsu": [
        "keiretsu"
    ],
    "kekchose": [
        "kekchose"
    ],
    "kelvins": [
        "kelvin"
    ],
    "kendo": [
        "kendo"
    ],
    "kermesse": [
        "kermesse"
    ],
    "kermesses": [
        "kermesse"
    ],
    "kerrie": [
        "kerrie"
    ],
    "ket": [
        "ket"
    ],
    "ketch": [
        "ketch"
    ],
    "ketchup": [
        "ketchup"
    ],
    "keuf": [
        "keuf"
    ],
    "keufs": [
        "keuf"
    ],
    "keum": [
        "keum"
    ],
    "keums": [
        "keum"
    ],
    "kevlar": [
        "kevlar"
    ],
    "khalife": [
        "khalife"
    ],
    "khamsin": [
        "khamsin"
    ],
    "khan": [
        "khan"
    ],
    "khanat": [
        "khanat"
    ],
    "khans": [
        "khan"
    ],
    "khat": [
        "khat"
    ],
    "khazar": [
        "khazar"
    ],
    "khmer": [
        "khmer"
    ],
    "khmere": [
        "khmer"
    ],
    "khagne": [
        "khagne"
    ],
    "khagnes": [
        "khagne"
    ],
    "khagneux": [
        "khagneux"
    ],
    "khedival": [
        "khedival"
    ],
    "khedive": [
        "khedive"
    ],
    "khol": [
        "khol"
    ],
    "kibboutz": [
        "kibboutz"
    ],
    "kibboutzim": [
        "kibboutzim"
    ],
    "kick": [
        "kick"
    ],
    "kicker": [
        "kicker"
    ],
    "kicks": [
        "kick"
    ],
    "kid": [
        "kid"
    ],
    "kidnappa": [
        "kidnapper"
    ],
    "kidnappait": [
        "kidnapper"
    ],
    "kidnappant": [
        "kidnapper"
    ],
    "kidnappe": [
        "kidnapper"
    ],
    "kidnappent": [
        "kidnapper"
    ],
    "kidnapper": [
        "kidnapper"
    ],
    "kidnapperai": [
        "kidnapper"
    ],
    "kidnapperaient": [
        "kidnapper"
    ],
    "kidnapperas": [
        "kidnapper"
    ],
    "kidnapperez": [
        "kidnapper"
    ],
    "kidnappeur": [
        "kidnappeur"
    ],
    "kidnappeurs": [
        "kidnappeur"
    ],
    "kidnappez": [
        "kidnapper"
    ],
    "kidnappiez": [
        "kidnapper"
    ],
    "kidnapping": [
        "kidnap",
        "kidnapping"
    ],
    "kidnappings": [
        "kidnapping"
    ],
    "kidnappons": [
        "kidnapper"
    ],
    "kidnappee": [
        "kidnapper"
    ],
    "kidnappees": [
        "kidnapper"
    ],
    "kidnappes": [
        "kidnapper"
    ],
    "kids": [
        "kid"
    ],
    "kief": [
        "kief"
    ],
    "kierkegaardienne": [
        "kierkegaardien"
    ],
    "kif": [
        "kif"
    ],
    "kiki": [
        "kiki"
    ],
    "kil": [
        "kil"
    ],
    "kilbus": [
        "kilbus"
    ],
    "kilim": [
        "kilim"
    ],
    "killer": [
        "killer"
    ],
    "kilo": [
        "kilo"
    ],
    "kilogramme": [
        "kilogramme"
    ],
    "kilogrammes": [
        "kilogramme"
    ],
    "kilohertz": [
        "kilohertz"
    ],
    "kilometre": [
        "kilometre"
    ],
    "kilometres": [
        "kilometre"
    ],
    "kilometrage": [
        "kilometrage"
    ],
    "kilometrages": [
        "kilometrage"
    ],
    "kilometrique": [
        "kilometrique"
    ],
    "kilometriques": [
        "kilometrique"
    ],
    "kilos": [
        "kilo"
    ],
    "kilotonnes": [
        "kilotonne"
    ],
    "kilowattheure": [
        "kilowattheure"
    ],
    "kilowatts": [
        "kilowatt"
    ],
    "kils": [
        "kil"
    ],
    "kilt": [
        "kilt"
    ],
    "kilts": [
        "kilt"
    ],
    "kimono": [
        "kimono"
    ],
    "kimonos": [
        "kimono"
    ],
    "kinase": [
        "kinase"
    ],
    "kinescope": [
        "kinescope"
    ],
    "kinesthesie": [
        "kinesthesie"
    ],
    "kinnor": [
        "kinnor"
    ],
    "kino": [
        "kino"
    ],
    "kine": [
        "kine"
    ],
    "kinesiques": [
        "kinesique"
    ],
    "kinesitherapeute": [
        "kinesitherapeute"
    ],
    "kinesitherapie": [
        "kinesitherapie"
    ],
    "kiosk": [
        "kiosk"
    ],
    "kiosks": [
        "kiosk"
    ],
    "kiosque": [
        "kiosque"
    ],
    "kiosques": [
        "kiosque"
    ],
    "kip": [
        "kip"
    ],
    "kipa": [
        "kipa"
    ],
    "kippa": [
        "kippa"
    ],
    "kipper": [
        "kipper"
    ],
    "kippers": [
        "kipper"
    ],
    "kips": [
        "kip"
    ],
    "kir": [
        "kir"
    ],
    "kirghiz": [
        "kirghiz"
    ],
    "kirghize": [
        "kirghize"
    ],
    "kirghizes": [
        "kirghize"
    ],
    "kirs": [
        "kir"
    ],
    "kirsch": [
        "kirsch"
    ],
    "kit": [
        "kit"
    ],
    "kitch": [
        "kitch"
    ],
    "kitchenette": [
        "kitchenette"
    ],
    "kits": [
        "kit"
    ],
    "kitsch": [
        "kitsch"
    ],
    "kiva": [
        "kiva"
    ],
    "kiwi": [
        "kiwi"
    ],
    "kiwis": [
        "kiwi"
    ],
    "klaxon": [
        "klaxon"
    ],
    "klaxonna": [
        "klaxonner"
    ],
    "klaxonnai": [
        "klaxonner"
    ],
    "klaxonnaient": [
        "klaxonner"
    ],
    "klaxonnais": [
        "klaxonner"
    ],
    "klaxonnait": [
        "klaxonner"
    ],
    "klaxonnant": [
        "klaxonner"
    ],
    "klaxonne": [
        "klaxonner"
    ],
    "klaxonnent": [
        "klaxonner"
    ],
    "klaxonner": [
        "klaxonner"
    ],
    "klaxonnera": [
        "klaxonner"
    ],
    "klaxonnerai": [
        "klaxonner"
    ],
    "klaxonnes": [
        "klaxonner"
    ],
    "klaxonnez": [
        "klaxonner"
    ],
    "klaxons": [
        "klaxon"
    ],
    "klebs": [
        "klebs"
    ],
    "kleenex": [
        "kleenex"
    ],
    "kleptomane": [
        "kleptomane"
    ],
    "kleptomanes": [
        "kleptomane"
    ],
    "kleptomanie": [
        "kleptomanie"
    ],
    "klystron": [
        "klystron"
    ],
    "km": [
        "km"
    ],
    "knickerbockers": [
        "knickerbocker"
    ],
    "knickers": [
        "knicker"
    ],
    "knout": [
        "knout"
    ],
    "koala": [
        "koala"
    ],
    "koalas": [
        "koala"
    ],
    "kobold": [
        "kobold"
    ],
    "kobolds": [
        "kobold"
    ],
    "kodak": [
        "kodak"
    ],
    "kodiak": [
        "kodiak"
    ],
    "kohl": [
        "kohl"
    ],
    "kola": [
        "kola"
    ],
    "kolatiers": [
        "kolatier"
    ],
    "kolkhoze": [
        "kolkhoze"
    ],
    "kolkhozien": [
        "kolkhozien"
    ],
    "kolkhozienne": [
        "kolkhozien"
    ],
    "kolkhoziennes": [
        "kolkhozien"
    ],
    "kolkhoziens": [
        "kolkhozien"
    ],
    "komi": [
        "komi"
    ],
    "komintern": [
        "komintern"
    ],
    "kommandantur": [
        "kommandantur"
    ],
    "kommando": [
        "kommando"
    ],
    "komsomol": [
        "komsomol"
    ],
    "komsomols": [
        "komsomol"
    ],
    "kondo": [
        "kondo"
    ],
    "kopeck": [
        "kopeck"
    ],
    "kopecks": [
        "kopeck"
    ],
    "kopeks": [
        "kopek"
    ],
    "kora": [
        "kora"
    ],
    "koran": [
        "koran"
    ],
    "korrigan": [
        "korrigan"
    ],
    "korrigans": [
        "korrigan"
    ],
    "kore": [
        "kore"
    ],
    "kosovar": [
        "kosovar"
    ],
    "kot": [
        "kot"
    ],
    "koto": [
        "koto"
    ],
    "kouglof": [
        "kouglof"
    ],
    "koulak": [
        "koulak"
    ],
    "koulaks": [
        "koulak"
    ],
    "kouros": [
        "kouros"
    ],
    "kraal": [
        "kraal"
    ],
    "krach": [
        "krach"
    ],
    "krachs": [
        "krach"
    ],
    "kraft": [
        "kraft"
    ],
    "krak": [
        "krak"
    ],
    "kraken": [
        "kraken"
    ],
    "kremlin": [
        "kremlin"
    ],
    "kreutzer": [
        "kreutzer"
    ],
    "kriegspiel": [
        "kriegspiel"
    ],
    "krill": [
        "krill"
    ],
    "kriss": [
        "kriss"
    ],
    "kroumir": [
        "kroumir"
    ],
    "kroumirs": [
        "kroumir"
    ],
    "krypton": [
        "krypton"
    ],
    "ksar": [
        "ksar"
    ],
    "kugelhof": [
        "kugelhof"
    ],
    "kula": [
        "kula"
    ],
    "kummel": [
        "kummel"
    ],
    "kumquat": [
        "kumquat"
    ],
    "kumquats": [
        "kumquat"
    ],
    "kurde": [
        "kurde"
    ],
    "kurdes": [
        "kurde"
    ],
    "kursaal": [
        "kursaal"
    ],
    "kurus": [
        "kuru"
    ],
    "kvas": [
        "kvas"
    ],
    "kyrie": [
        "kyrie"
    ],
    "kyrielle": [
        "kyrielle"
    ],
    "kyrielles": [
        "kyrielle"
    ],
    "kyste": [
        "kyste"
    ],
    "kystes": [
        "kyste"
    ],
    "kystique": [
        "kystique"
    ],
    "kebour": [
        "kebour"
    ],
    "kebours": [
        "kebour"
    ],
    "kefir": [
        "kefir"
    ],
    "kefirs": [
        "kefir"
    ],
    "kenyan": [
        "kenyan"
    ],
    "kepi": [
        "kepi"
    ],
    "kepis": [
        "kepi"
    ],
    "kerabau": [
        "kerabau"
    ],
    "keratinisee": [
        "keratinise"
    ],
    "keratoplastie": [
        "keratoplastie"
    ],
    "keratose": [
        "keratose"
    ],
    "kerosene": [
        "kerosene"
    ],
    "kerosenes": [
        "kerosene"
    ],
    "l": [
        "l"
    ],
    "l'": [
        "l",
        "l'",
        "le"
    ],
    "l'un": [
        "l'un"
    ],
    "l'une": [
        "l'une"
    ],
    "la": [
        "la",
        "le"
    ],
    "labbe": [
        "labbe"
    ],
    "labbes": [
        "labbe"
    ],
    "label": [
        "label"
    ],
    "labelle": [
        "labelle"
    ],
    "labels": [
        "label"
    ],
    "labeur": [
        "labeur"
    ],
    "labeurs": [
        "labeur"
    ],
    "labial": [
        "labial"
    ],
    "labiale": [
        "labial"
    ],
    "labiales": [
        "labial"
    ],
    "labialisant": [
        "labialiser"
    ],
    "labiaux": [
        "labial"
    ],
    "labile": [
        "labile"
    ],
    "labo": [
        "labo"
    ],
    "laborantin": [
        "laborantin"
    ],
    "laborantine": [
        "laborantin"
    ],
    "laborantins": [
        "laborantin"
    ],
    "laboratoire": [
        "laboratoire"
    ],
    "laboratoires": [
        "laboratoire"
    ],
    "laborieuse": [
        "laborieux"
    ],
    "laborieusement": [
        "laborieusement"
    ],
    "laborieuses": [
        "laborieux"
    ],
    "laborieux": [
        "laborieux"
    ],
    "labos": [
        "labo"
    ],
    "labour": [
        "labour"
    ],
    "laboura": [
        "labourer"
    ],
    "labourable": [
        "labourable"
    ],
    "labourage": [
        "labourage"
    ],
    "labouraient": [
        "labourer"
    ],
    "labourais": [
        "labourer"
    ],
    "labourait": [
        "labourer"
    ],
    "labourant": [
        "labourer"
    ],
    "laboure": [
        "labourer"
    ],
    "labourent": [
        "labourer"
    ],
    "labourer": [
        "labourer"
    ],
    "labourerait": [
        "labourer"
    ],
    "laboureur": [
        "laboureur"
    ],
    "laboureurs": [
        "laboureur"
    ],
    "labours": [
        "labour"
    ],
    "labouree": [
        "labourer"
    ],
    "labourees": [
        "labourer"
    ],
    "laboures": [
        "labourer"
    ],
    "labrador": [
        "labrador"
    ],
    "labradors": [
        "labrador"
    ],
    "labre": [
        "labre"
    ],
    "labres": [
        "labre"
    ],
    "labri": [
        "labri"
    ],
    "labris": [
        "labri"
    ],
    "labyrinthe": [
        "labyrinthe"
    ],
    "labyrinthes": [
        "labyrinthe"
    ],
    "labyrinthique": [
        "labyrinthique"
    ],
    "labyrinthiques": [
        "labyrinthique"
    ],
    "lac": [
        "lac"
    ],
    "lacandon": [
        "lacandon"
    ],
    "lacanien": [
        "lacanien"
    ],
    "lacaniens": [
        "lacanien"
    ],
    "lace": [
        "lacer"
    ],
    "lacent": [
        "lacer"
    ],
    "lacer": [
        "lacer"
    ],
    "lacet": [
        "lacet"
    ],
    "lacets": [
        "lacet"
    ],
    "lacis": [
        "lacis"
    ],
    "lack": [
        "lack"
    ],
    "laconique": [
        "laconique"
    ],
    "laconiquement": [
        "laconiquement"
    ],
    "laconiques": [
        "laconique"
    ],
    "laconisme": [
        "laconisme"
    ],
    "lacrymal": [
        "lacrymal"
    ],
    "lacrymale": [
        "lacrymal"
    ],
    "lacrymales": [
        "lacrymal"
    ],
    "lacrymaux": [
        "lacrymal"
    ],
    "lacrymogene": [
        "lacrymogene"
    ],
    "lacrymogenes": [
        "lacrymogene"
    ],
    "lacs": [
        "lacs"
    ],
    "lactaires": [
        "lactaire"
    ],
    "lactate": [
        "lactate"
    ],
    "lactation": [
        "lactation"
    ],
    "lactescent": [
        "lactescent"
    ],
    "lactescente": [
        "lactescent"
    ],
    "lactifere": [
        "lactifere"
    ],
    "lactique": [
        "lactique"
    ],
    "lactose": [
        "lactose"
    ],
    "lacte": [
        "lacte"
    ],
    "lactee": [
        "lacte"
    ],
    "lactes": [
        "lacte"
    ],
    "lacunaire": [
        "lacunaire"
    ],
    "lacune": [
        "lacune"
    ],
    "lacunes": [
        "lacune"
    ],
    "lacustre": [
        "lacustre"
    ],
    "lacustres": [
        "lacustre"
    ],
    "lacere": [
        "lacere",
        "lacerer"
    ],
    "lacerent": [
        "lacerer"
    ],
    "lacedemoniens": [
        "lacedemonien"
    ],
    "lacee": [
        "lacer"
    ],
    "lacees": [
        "lacer"
    ],
    "lacera": [
        "lacerer"
    ],
    "laceraient": [
        "lacerer"
    ],
    "lacerait": [
        "lacerer"
    ],
    "lacerant": [
        "lacerer"
    ],
    "laceration": [
        "laceration"
    ],
    "lacerations": [
        "laceration"
    ],
    "lacerer": [
        "lacerer"
    ],
    "lacerions": [
        "lacerer"
    ],
    "laceree": [
        "lacere",
        "lacerer"
    ],
    "lacerees": [
        "lacere",
        "lacerer"
    ],
    "laceres": [
        "lacere",
        "lacerer"
    ],
    "laces": [
        "lacer",
        "lace"
    ],
    "lad": [
        "lad"
    ],
    "ladies": [
        "ladies",
        "lady"
    ],
    "ladino": [
        "ladino"
    ],
    "ladite": [
        "ladite"
    ],
    "ladre": [
        "ladre"
    ],
    "ladrerie": [
        "ladrerie"
    ],
    "ladreries": [
        "ladrerie"
    ],
    "ladres": [
        "ladre"
    ],
    "lads": [
        "lad"
    ],
    "lady": [
        "lady"
    ],
    "ladys": [
        "lady"
    ],
    "lagan": [
        "lagan"
    ],
    "lagon": [
        "lagon"
    ],
    "lagons": [
        "lagon"
    ],
    "laguiole": [
        "laguiole"
    ],
    "lagunaire": [
        "lagunaire"
    ],
    "lagune": [
        "lagune"
    ],
    "lagunes": [
        "lagune"
    ],
    "lai": [
        "lai"
    ],
    "laid": [
        "lay",
        "laid"
    ],
    "laide": [
        "laid"
    ],
    "laidement": [
        "laidement"
    ],
    "laideron": [
        "laideron"
    ],
    "laiderons": [
        "laideron"
    ],
    "laides": [
        "laid"
    ],
    "laideur": [
        "laideur"
    ],
    "laideurs": [
        "laideur"
    ],
    "laids": [
        "laid"
    ],
    "laie": [
        "laie"
    ],
    "laies": [
        "laie"
    ],
    "lainage": [
        "lainage"
    ],
    "lainages": [
        "lainage"
    ],
    "laine": [
        "laine"
    ],
    "laines": [
        "laine"
    ],
    "laineurs": [
        "laineur"
    ],
    "laineuse": [
        "laineux"
    ],
    "laineuses": [
        "laineux",
        "laineur"
    ],
    "laineux": [
        "laineux"
    ],
    "lainier": [
        "lainier"
    ],
    "lainiere": [
        "lainier",
        "lainiere"
    ],
    "laird": [
        "laird"
    ],
    "lais": [
        "lai"
    ],
    "laissa": [
        "laisser"
    ],
    "laissai": [
        "laisser"
    ],
    "laissaient": [
        "laisser"
    ],
    "laissais": [
        "laisser"
    ],
    "laissait": [
        "laisser"
    ],
    "laissant": [
        "laisser"
    ],
    "laissassent": [
        "laisser"
    ],
    "laisse": [
        "laisse",
        "laisser"
    ],
    "laissent": [
        "laisser"
    ],
    "laisser": [
        "laisser"
    ],
    "laissera": [
        "laisser"
    ],
    "laisserai": [
        "laisser"
    ],
    "laisseraient": [
        "laisser"
    ],
    "laisserais": [
        "laisser"
    ],
    "laisserait": [
        "laisser"
    ],
    "laisseras": [
        "laisser"
    ],
    "laisserez": [
        "laisser"
    ],
    "laisseriez": [
        "laisser"
    ],
    "laisserions": [
        "laisser"
    ],
    "laisserons": [
        "laisser"
    ],
    "laisseront": [
        "laisser"
    ],
    "laisses": [
        "laisse",
        "laisser"
    ],
    "laissez": [
        "laisser"
    ],
    "laissiez": [
        "laisser"
    ],
    "laissions": [
        "laisser"
    ],
    "laissons": [
        "laisser"
    ],
    "laissames": [
        "laisser"
    ],
    "laissat": [
        "laisser"
    ],
    "laisserent": [
        "laisser"
    ],
    "laissee": [
        "laisser"
    ],
    "laissees": [
        "laissee",
        "laisser"
    ],
    "lait": [
        "lait"
    ],
    "laitage": [
        "laitage"
    ],
    "laitages": [
        "laitage"
    ],
    "laitance": [
        "laitance"
    ],
    "laitances": [
        "laitance"
    ],
    "laiterie": [
        "laiterie"
    ],
    "laiteries": [
        "laiterie"
    ],
    "laites": [
        "laite"
    ],
    "laiteuse": [
        "laiteux"
    ],
    "laiteuses": [
        "laiteux"
    ],
    "laiteux": [
        "laiteux"
    ],
    "laitier": [
        "laitier"
    ],
    "laitiers": [
        "laitier"
    ],
    "laitiere": [
        "laitier"
    ],
    "laitieres": [
        "laitier"
    ],
    "laiton": [
        "laiton"
    ],
    "laits": [
        "lait"
    ],
    "laitue": [
        "laitue"
    ],
    "laitues": [
        "laitue"
    ],
    "laizes": [
        "laize"
    ],
    "lala": [
        "lala"
    ],
    "lama": [
        "lama"
    ],
    "lamais": [
        "lamer"
    ],
    "lamantin": [
        "lamantin"
    ],
    "lamantins": [
        "lamantin"
    ],
    "lamartiniennes": [
        "lamartinien"
    ],
    "lamas": [
        "lamer",
        "lama"
    ],
    "lamaisme": [
        "lamaisme"
    ],
    "lambada": [
        "lambada"
    ],
    "lambda": [
        "lambda"
    ],
    "lambdas": [
        "lambda"
    ],
    "lambeau": [
        "lambeau"
    ],
    "lambeaux": [
        "lambeau"
    ],
    "lambel": [
        "lambel"
    ],
    "lambi": [
        "lambi"
    ],
    "lambic": [
        "lambic"
    ],
    "lambin": [
        "lambin"
    ],
    "lambinaient": [
        "lambiner"
    ],
    "lambinais": [
        "lambiner"
    ],
    "lambinait": [
        "lambiner"
    ],
    "lambinant": [
        "lambiner"
    ],
    "lambine": [
        "lambiner",
        "lambine"
    ],
    "lambiner": [
        "lambiner"
    ],
    "lambines": [
        "lambiner"
    ],
    "lambinez": [
        "lambiner"
    ],
    "lambiniez": [
        "lambiner"
    ],
    "lambinions": [
        "lambiner"
    ],
    "lambinons": [
        "lambiner"
    ],
    "lambins": [
        "lambin"
    ],
    "lambrequins": [
        "lambrequin"
    ],
    "lambris": [
        "lambris"
    ],
    "lambrissage": [
        "lambrissage"
    ],
    "lambrisse": [
        "lambrisser"
    ],
    "lambrissee": [
        "lambrisse",
        "lambrisser"
    ],
    "lambrissees": [
        "lambrisse",
        "lambrisser"
    ],
    "lambrusques": [
        "lambrusque"
    ],
    "lambswool": [
        "lambswool"
    ],
    "lame": [
        "lame"
    ],
    "lamedu": [
        "lamedu"
    ],
    "lamede": [
        "lamede"
    ],
    "lamedes": [
        "lamede"
    ],
    "lamelle": [
        "lamelle"
    ],
    "lamelles": [
        "lamelle"
    ],
    "lamellibranches": [
        "lamellibranche"
    ],
    "lamelliforme": [
        "lamelliforme"
    ],
    "lamenta": [
        "lamenter"
    ],
    "lamentable": [
        "lamentable"
    ],
    "lamentablement": [
        "lamentablement"
    ],
    "lamentables": [
        "lamentable"
    ],
    "lamentaient": [
        "lamenter"
    ],
    "lamentais": [
        "lamenter"
    ],
    "lamentait": [
        "lamenter"
    ],
    "lamentant": [
        "lamenter"
    ],
    "lamentation": [
        "lamentation"
    ],
    "lamentations": [
        "lamentation"
    ],
    "lamente": [
        "lamenter"
    ],
    "lamentent": [
        "lamenter"
    ],
    "lamenter": [
        "lamenter"
    ],
    "lamentera": [
        "lamenter"
    ],
    "lamenterait": [
        "lamenter"
    ],
    "lamenteront": [
        "lamenter"
    ],
    "lamentez": [
        "lamenter"
    ],
    "lamentions": [
        "lamenter"
    ],
    "lamento": [
        "lamento"
    ],
    "lamentons": [
        "lamenter"
    ],
    "lamenterent": [
        "lamenter"
    ],
    "lamentes": [
        "lamenter"
    ],
    "lamer": [
        "lamer",
        "lame"
    ],
    "lames": [
        "lamer",
        "lame"
    ],
    "lamie": [
        "lamie"
    ],
    "lamifie": [
        "lamifie"
    ],
    "lamifies": [
        "lamifie"
    ],
    "laminage": [
        "laminage"
    ],
    "laminages": [
        "laminage"
    ],
    "laminaire": [
        "laminaire"
    ],
    "laminaires": [
        "laminaire"
    ],
    "laminait": [
        "laminer"
    ],
    "laminant": [
        "laminer"
    ],
    "lamine": [
        "laminer"
    ],
    "laminectomie": [
        "laminectomie"
    ],
    "laminer": [
        "laminer"
    ],
    "lamineront": [
        "laminer"
    ],
    "lamines": [
        "laminer"
    ],
    "laminoir": [
        "laminoir"
    ],
    "laminoirs": [
        "laminoir"
    ],
    "laminee": [
        "laminer"
    ],
    "laminees": [
        "laminer"
    ],
    "lampa": [
        "lamper"
    ],
    "lampadaire": [
        "lampadaire"
    ],
    "lampadaires": [
        "lampadaire"
    ],
    "lampadophore": [
        "lampadophore"
    ],
    "lampais": [
        "lamper"
    ],
    "lampait": [
        "lamper"
    ],
    "lampant": [
        "lamper"
    ],
    "lamparos": [
        "lamparo"
    ],
    "lampas": [
        "lampas"
    ],
    "lampe": [
        "lamper",
        "lampe"
    ],
    "lampent": [
        "lamper"
    ],
    "lamper": [
        "lamper"
    ],
    "lampes": [
        "lampe"
    ],
    "lampez": [
        "lamper"
    ],
    "lampion": [
        "lampion"
    ],
    "lampions": [
        "lampion"
    ],
    "lampiste": [
        "lampiste"
    ],
    "lampisterie": [
        "lampisterie"
    ],
    "lampisteries": [
        "lampisterie"
    ],
    "lampistes": [
        "lampiste"
    ],
    "lampons": [
        "lampon"
    ],
    "lamproie": [
        "lamproie"
    ],
    "lamproies": [
        "lamproie"
    ],
    "lampyres": [
        "lampyre"
    ],
    "lampee": [
        "lamper",
        "lampee"
    ],
    "lampees": [
        "lampee"
    ],
    "lamee": [
        "lame"
    ],
    "lamees": [
        "lamer"
    ],
    "lance": [
        "lancer",
        "lance",
        "lanc"
    ],
    "lancelot": [
        "lancelot"
    ],
    "lancement": [
        "lancement"
    ],
    "lancements": [
        "lancement"
    ],
    "lancent": [
        "lancer"
    ],
    "lancequine": [
        "lancequiner"
    ],
    "lancequiner": [
        "lancequiner"
    ],
    "lancer": [
        "lancer"
    ],
    "lancera": [
        "lancer"
    ],
    "lancerai": [
        "lancer"
    ],
    "lanceraient": [
        "lancer"
    ],
    "lancerais": [
        "lancer"
    ],
    "lancerait": [
        "lancer"
    ],
    "lanceras": [
        "lancer"
    ],
    "lancerez": [
        "lancer"
    ],
    "lancerons": [
        "lanceron",
        "lancer"
    ],
    "lanceront": [
        "lancer"
    ],
    "lancers": [
        "lancer"
    ],
    "lances": [
        "lancer",
        "lance",
        "lanc"
    ],
    "lancette": [
        "lancette"
    ],
    "lanceur": [
        "lanceur"
    ],
    "lanceurs": [
        "lanceur"
    ],
    "lanceuse": [
        "lanceur"
    ],
    "lancez": [
        "lancer"
    ],
    "lancier": [
        "lancier"
    ],
    "lanciers": [
        "lancier"
    ],
    "lanciez": [
        "lancer"
    ],
    "lancinait": [
        "lanciner"
    ],
    "lancinance": [
        "lancinance"
    ],
    "lancinant": [
        "lanciner",
        "lancinant"
    ],
    "lancinante": [
        "lancinant"
    ],
    "lancinantes": [
        "lancinant"
    ],
    "lancinants": [
        "lancinant"
    ],
    "lancine": [
        "lanciner"
    ],
    "lancions": [
        "lancer"
    ],
    "lancerent": [
        "lancer"
    ],
    "lancee": [
        "lancee",
        "lancer"
    ],
    "lancees": [
        "lancee",
        "lancer"
    ],
    "lanceoles": [
        "lanceole"
    ],
    "land": [
        "land"
    ],
    "landais": [
        "landais"
    ],
    "landaise": [
        "landais"
    ],
    "landaises": [
        "landais"
    ],
    "landau": [
        "landau"
    ],
    "landaulet": [
        "landaulet"
    ],
    "landaus": [
        "landau"
    ],
    "lande": [
        "lande"
    ],
    "landerneau": [
        "landerneau"
    ],
    "landes": [
        "lande"
    ],
    "landiers": [
        "landier"
    ],
    "landing": [
        "land",
        "landing"
    ],
    "landlord": [
        "landlord"
    ],
    "lands": [
        "land"
    ],
    "landsturm": [
        "landsturm"
    ],
    "landwehr": [
        "landwehr"
    ],
    "langage": [
        "langage"
    ],
    "langages": [
        "langage"
    ],
    "langagiers": [
        "langagier"
    ],
    "lange": [
        "langer",
        "lange"
    ],
    "langeait": [
        "langer"
    ],
    "langeant": [
        "langer"
    ],
    "langer": [
        "langer"
    ],
    "langes": [
        "lange"
    ],
    "langoureuse": [
        "langoureux"
    ],
    "langoureusement": [
        "langoureusement"
    ],
    "langoureuses": [
        "langoureux"
    ],
    "langoureux": [
        "langoureux"
    ],
    "langouste": [
        "langouste"
    ],
    "langoustes": [
        "langouste"
    ],
    "langoustine": [
        "langoustine"
    ],
    "langoustines": [
        "langoustine"
    ],
    "langue": [
        "langue"
    ],
    "languedociens": [
        "languedocien"
    ],
    "langues": [
        "langue"
    ],
    "languette": [
        "languette"
    ],
    "languettes": [
        "languette"
    ],
    "langueur": [
        "langueur"
    ],
    "langueurs": [
        "langueur"
    ],
    "langui": [
        "languir"
    ],
    "languide": [
        "languide"
    ],
    "languides": [
        "languide"
    ],
    "languir": [
        "languir"
    ],
    "languirait": [
        "languir"
    ],
    "languirent": [
        "languir"
    ],
    "languiront": [
        "languir"
    ],
    "languis": [
        "languir"
    ],
    "languissaient": [
        "languir"
    ],
    "languissais": [
        "languir"
    ],
    "languissait": [
        "languir"
    ],
    "languissamment": [
        "languissamment"
    ],
    "languissant": [
        "languir",
        "languissant"
    ],
    "languissante": [
        "languissant"
    ],
    "languissantes": [
        "languissant"
    ],
    "languissants": [
        "languissant"
    ],
    "languisse": [
        "languir"
    ],
    "languissent": [
        "languir"
    ],
    "languisses": [
        "languir"
    ],
    "languissons": [
        "languir"
    ],
    "languit": [
        "languir"
    ],
    "langee": [
        "langer"
    ],
    "laniere": [
        "laniere"
    ],
    "lanieres": [
        "laniere"
    ],
    "lanlaire": [
        "lanlaire"
    ],
    "lanoline": [
        "lanoline"
    ],
    "lansquenet": [
        "lansquenet"
    ],
    "lansquenets": [
        "lansquenet"
    ],
    "lansquine": [
        "lansquine"
    ],
    "lansquiner": [
        "lansquiner"
    ],
    "lanternant": [
        "lanterner"
    ],
    "lanterne": [
        "lanterner",
        "lanterne"
    ],
    "lanterner": [
        "lanterner"
    ],
    "lanternes": [
        "lanterne"
    ],
    "lanternez": [
        "lanterner"
    ],
    "lanternier": [
        "lanternier"
    ],
    "lanthane": [
        "lanthane"
    ],
    "lanca": [
        "lancer"
    ],
    "lancai": [
        "lancer"
    ],
    "lancaient": [
        "lancer"
    ],
    "lancais": [
        "lancer"
    ],
    "lancait": [
        "lancer"
    ],
    "lancant": [
        "lancant",
        "lancer"
    ],
    "lancas": [
        "lancer"
    ],
    "lancons": [
        "lancon",
        "lancer"
    ],
    "lancames": [
        "lancer"
    ],
    "lancat": [
        "lancer"
    ],
    "lao": [
        "lao"
    ],
    "laos": [
        "lao"
    ],
    "laotien": [
        "laotien"
    ],
    "laotienne": [
        "laotien"
    ],
    "laotiens": [
        "laotien"
    ],
    "lap": [
        "lap"
    ],
    "lapais": [
        "laper"
    ],
    "lapait": [
        "laper"
    ],
    "lapalissade": [
        "lapalissade"
    ],
    "lapant": [
        "laper"
    ],
    "laparoscopie": [
        "laparoscopie"
    ],
    "laparotomie": [
        "laparotomie"
    ],
    "lape": [
        "laper"
    ],
    "lapement": [
        "lapement"
    ],
    "lapements": [
        "lapement"
    ],
    "lapent": [
        "laper"
    ],
    "laper": [
        "laper"
    ],
    "lapereau": [
        "lapereau"
    ],
    "lapereaux": [
        "lapereau"
    ],
    "lapida": [
        "lapider"
    ],
    "lapidaire": [
        "lapidaire"
    ],
    "lapidaires": [
        "lapidaire"
    ],
    "lapidait": [
        "lapider"
    ],
    "lapidant": [
        "lapider"
    ],
    "lapidation": [
        "lapidation"
    ],
    "lapidations": [
        "lapidation"
    ],
    "lapide": [
        "lapider"
    ],
    "lapident": [
        "lapider"
    ],
    "lapider": [
        "lapider"
    ],
    "lapiderait": [
        "lapider"
    ],
    "lapideras": [
        "lapider"
    ],
    "lapidez": [
        "lapider"
    ],
    "lapidification": [
        "lapidification"
    ],
    "lapidifies": [
        "lapidifier"
    ],
    "lapiderent": [
        "lapider"
    ],
    "lapidee": [
        "lapider"
    ],
    "lapides": [
        "lapider"
    ],
    "lapin": [
        "lapin"
    ],
    "lapine": [
        "lapin"
    ],
    "lapiner": [
        "lapiner"
    ],
    "lapines": [
        "lapin"
    ],
    "lapiniere": [
        "lapiniere"
    ],
    "lapins": [
        "lapin"
    ],
    "lapis": [
        "lapis"
    ],
    "lapon": [
        "lapon"
    ],
    "lapone": [
        "lapon"
    ],
    "lapones": [
        "lapon"
    ],
    "laponne": [
        "lapon"
    ],
    "lapons": [
        "lapon"
    ],
    "lappant": [
        "lapper"
    ],
    "lapper": [
        "lapper"
    ],
    "lappe": [
        "lapper"
    ],
    "laps": [
        "laps",
        "lap"
    ],
    "lapsus": [
        "lapsus"
    ],
    "lapees": [
        "laper"
    ],
    "laquaient": [
        "laquer"
    ],
    "laquais": [
        "laquais"
    ],
    "laquait": [
        "laquer"
    ],
    "laque": [
        "laquer",
        "laque"
    ],
    "laquelle": [
        "laquelle"
    ],
    "laquer": [
        "laquer"
    ],
    "laquerai": [
        "laquer"
    ],
    "laques": [
        "laquer",
        "laque"
    ],
    "laquee": [
        "laque",
        "laquer"
    ],
    "laquees": [
        "laque",
        "laquer"
    ],
    "larbin": [
        "larbin"
    ],
    "larbineries": [
        "larbinerie"
    ],
    "larbins": [
        "larbin"
    ],
    "larcin": [
        "larcin"
    ],
    "larcins": [
        "larcin"
    ],
    "lard": [
        "lard"
    ],
    "larda": [
        "larder"
    ],
    "lardage": [
        "lardage"
    ],
    "lardais": [
        "larder"
    ],
    "lardait": [
        "larder"
    ],
    "lardant": [
        "larder"
    ],
    "larde": [
        "larder"
    ],
    "larder": [
        "larder"
    ],
    "lardeuss": [
        "lardeuss"
    ],
    "lardeux": [
        "lardeux"
    ],
    "lardon": [
        "lardon"
    ],
    "lardons": [
        "larder",
        "lardon"
    ],
    "lards": [
        "lard"
    ],
    "lardu": [
        "lardu"
    ],
    "lardus": [
        "lardu"
    ],
    "lardee": [
        "larder"
    ],
    "lardees": [
        "larder"
    ],
    "lare": [
        "lare"
    ],
    "lares": [
        "lare"
    ],
    "larfeuil": [
        "larfeuil"
    ],
    "larfeuille": [
        "larfeuille"
    ],
    "larfeuilles": [
        "larfeuille"
    ],
    "larfeuils": [
        "larfeuil"
    ],
    "largable": [
        "largable"
    ],
    "largage": [
        "largage"
    ],
    "largages": [
        "largage"
    ],
    "large": [
        "large"
    ],
    "largement": [
        "largement"
    ],
    "larges": [
        "large"
    ],
    "largesse": [
        "largesse"
    ],
    "largesses": [
        "largesse"
    ],
    "largeur": [
        "largeur"
    ],
    "largeurs": [
        "largeur"
    ],
    "larghetto": [
        "larghetto"
    ],
    "largo": [
        "largo"
    ],
    "largua": [
        "larguer"
    ],
    "larguaient": [
        "larguer"
    ],
    "larguais": [
        "larguer"
    ],
    "larguait": [
        "larguer"
    ],
    "larguant": [
        "larguer"
    ],
    "largue": [
        "largue",
        "larguer"
    ],
    "larguent": [
        "larguer"
    ],
    "larguer": [
        "larguer"
    ],
    "larguera": [
        "larguer"
    ],
    "larguerai": [
        "larguer"
    ],
    "larguerait": [
        "larguer"
    ],
    "larguerez": [
        "larguer"
    ],
    "largueront": [
        "larguer"
    ],
    "largues": [
        "largue",
        "larguer"
    ],
    "largueur": [
        "largueur"
    ],
    "larguez": [
        "larguer"
    ],
    "larguiez": [
        "larguer"
    ],
    "larguons": [
        "larguer"
    ],
    "larguee": [
        "largue",
        "larguer"
    ],
    "larguees": [
        "largue",
        "larguer"
    ],
    "larigot": [
        "larigot"
    ],
    "larme": [
        "larme"
    ],
    "larmes": [
        "larme"
    ],
    "larmichette": [
        "larmichette"
    ],
    "larmichettes": [
        "larmichette"
    ],
    "larmiers": [
        "larmier"
    ],
    "larmoie": [
        "larmoyer"
    ],
    "larmoiement": [
        "larmoiement"
    ],
    "larmoiements": [
        "larmoiement"
    ],
    "larmoient": [
        "larmoyer"
    ],
    "larmoyait": [
        "larmoyer"
    ],
    "larmoyant": [
        "larmoyant",
        "larmoyer"
    ],
    "larmoyante": [
        "larmoyant"
    ],
    "larmoyantes": [
        "larmoyant"
    ],
    "larmoyants": [
        "larmoyant"
    ],
    "larmoyer": [
        "larmoyer"
    ],
    "larmoyeur": [
        "larmoyeur"
    ],
    "larmoyons": [
        "larmoyer"
    ],
    "larmoye": [
        "larmoyer"
    ],
    "larron": [
        "larron"
    ],
    "larronne": [
        "larronner"
    ],
    "larrons": [
        "larron"
    ],
    "larsen": [
        "larsen"
    ],
    "larvaire": [
        "larvaire"
    ],
    "larvaires": [
        "larvaire"
    ],
    "larve": [
        "larve"
    ],
    "larves": [
        "larve"
    ],
    "larvicide": [
        "larvicide"
    ],
    "larvee": [
        "larve"
    ],
    "larvees": [
        "larve"
    ],
    "laryngite": [
        "laryngite"
    ],
    "laryngologique": [
        "laryngologique"
    ],
    "laryngologiste": [
        "laryngologiste"
    ],
    "laryngoscope": [
        "laryngoscope"
    ],
    "laryngoscopes": [
        "laryngoscope"
    ],
    "laryngoscopie": [
        "laryngoscopie"
    ],
    "larynge": [
        "larynge"
    ],
    "laryngee": [
        "larynge"
    ],
    "larynx": [
        "larynx"
    ],
    "las": [
        "las",
        "la"
    ],
    "lasagne": [
        "lasagne"
    ],
    "lasagnes": [
        "lasagne"
    ],
    "lascar": [
        "lascar"
    ],
    "lascars": [
        "lascar"
    ],
    "lascif": [
        "lascif"
    ],
    "lascifs": [
        "lascif"
    ],
    "lascive": [
        "lascif"
    ],
    "lascivement": [
        "lascivement"
    ],
    "lascives": [
        "lascif"
    ],
    "lascivite": [
        "lascivite"
    ],
    "lascivites": [
        "lascivite"
    ],
    "laser": [
        "laser"
    ],
    "lasers": [
        "laser"
    ],
    "lassa": [
        "lasser"
    ],
    "lassai": [
        "lasser"
    ],
    "lassaient": [
        "lasser"
    ],
    "lassais": [
        "lasser"
    ],
    "lassait": [
        "lasser"
    ],
    "lassant": [
        "lassant",
        "lasser"
    ],
    "lassante": [
        "lassant"
    ],
    "lassantes": [
        "lassant"
    ],
    "lassants": [
        "lassant"
    ],
    "lasse": [
        "lasser",
        "las"
    ],
    "lassent": [
        "lasser"
    ],
    "lasser": [
        "lasser"
    ],
    "lassera": [
        "lasser"
    ],
    "lasserai": [
        "lasser"
    ],
    "lasseraient": [
        "lasser"
    ],
    "lasserais": [
        "lasser"
    ],
    "lasserait": [
        "lasser"
    ],
    "lasserez": [
        "lasser"
    ],
    "lasseront": [
        "lasser"
    ],
    "lasses": [
        "lasser",
        "lass",
        "las"
    ],
    "lassez": [
        "lasser"
    ],
    "lassitude": [
        "lassitude"
    ],
    "lassitudes": [
        "lassitude"
    ],
    "lasso": [
        "lasso"
    ],
    "lassons": [
        "lasser"
    ],
    "lassos": [
        "lasso"
    ],
    "lasserent": [
        "lasser"
    ],
    "lassee": [
        "lasser"
    ],
    "lassees": [
        "lasser"
    ],
    "lasure": [
        "lasure"
    ],
    "latence": [
        "latence"
    ],
    "latences": [
        "latence"
    ],
    "latent": [
        "latent"
    ],
    "latente": [
        "latent"
    ],
    "latentes": [
        "latent"
    ],
    "latents": [
        "latent"
    ],
    "latex": [
        "latex"
    ],
    "laticlave": [
        "laticlave"
    ],
    "latifundistes": [
        "latifundiste"
    ],
    "latin": [
        "latin"
    ],
    "latine": [
        "latin"
    ],
    "latines": [
        "latin"
    ],
    "latinisaient": [
        "latiniser"
    ],
    "latinismes": [
        "latinisme"
    ],
    "latiniste": [
        "latiniste"
    ],
    "latinistes": [
        "latiniste"
    ],
    "latinise": [
        "latiniser"
    ],
    "latinisee": [
        "latiniser"
    ],
    "latinite": [
        "latinite"
    ],
    "latinites": [
        "latinite"
    ],
    "latino": [
        "latino"
    ],
    "latinos": [
        "latino"
    ],
    "latins": [
        "latin"
    ],
    "latitude": [
        "latitude"
    ],
    "latitudes": [
        "latitude"
    ],
    "latrine": [
        "latrine"
    ],
    "latrines": [
        "latrine"
    ],
    "lats": [
        "lats"
    ],
    "latte": [
        "latte",
        "latter"
    ],
    "latter": [
        "latter"
    ],
    "lattes": [
        "latte",
        "latter"
    ],
    "lattis": [
        "lattis"
    ],
    "latviens": [
        "latvien"
    ],
    "lateral": [
        "lateral"
    ],
    "laterale": [
        "lateral"
    ],
    "lateralement": [
        "lateralement"
    ],
    "laterales": [
        "lateral"
    ],
    "lateralisee": [
        "lateralise"
    ],
    "lateralite": [
        "lateralite"
    ],
    "lateraux": [
        "lateral"
    ],
    "laterite": [
        "laterite"
    ],
    "laube": [
        "laube"
    ],
    "laudanum": [
        "laudanum"
    ],
    "laudateur": [
        "laudateur"
    ],
    "laudative": [
        "laudatif"
    ],
    "laudes": [
        "laude"
    ],
    "laurier": [
        "laurier"
    ],
    "lauriers": [
        "laurier"
    ],
    "laureat": [
        "laureat"
    ],
    "laureate": [
        "laureat"
    ],
    "laureats": [
        "laureat"
    ],
    "lausannoises": [
        "lausannois"
    ],
    "lauzes": [
        "lauze"
    ],
    "lav": [
        "lav"
    ],
    "lava": [
        "laver"
    ],
    "lavable": [
        "lavable"
    ],
    "lavables": [
        "lavable"
    ],
    "lavabo": [
        "lavabo"
    ],
    "lavabos": [
        "lavabo"
    ],
    "lavage": [
        "lavage"
    ],
    "lavages": [
        "lavage"
    ],
    "lavai": [
        "laver"
    ],
    "lavaient": [
        "laver"
    ],
    "lavais": [
        "laver"
    ],
    "lavait": [
        "laver"
    ],
    "lavalliere": [
        "lavalliere"
    ],
    "lavallieres": [
        "lavalliere"
    ],
    "lavande": [
        "lavande"
    ],
    "lavandes": [
        "lavande"
    ],
    "lavandin": [
        "lavandin"
    ],
    "lavandiere": [
        "lavandiere"
    ],
    "lavandieres": [
        "lavandiere"
    ],
    "lavant": [
        "laver"
    ],
    "lavasse": [
        "laver",
        "lavasse"
    ],
    "lave": [
        "lave",
        "laver"
    ],
    "lavedu": [
        "lavedu"
    ],
    "lavement": [
        "lavement"
    ],
    "lavements": [
        "lavement"
    ],
    "lavent": [
        "laver"
    ],
    "laver": [
        "laver"
    ],
    "lavera": [
        "laver"
    ],
    "laverai": [
        "laver"
    ],
    "laverais": [
        "laver"
    ],
    "laverait": [
        "laver"
    ],
    "laveras": [
        "laver"
    ],
    "laverez": [
        "laver"
    ],
    "laverie": [
        "laverie"
    ],
    "laveries": [
        "laverie"
    ],
    "laverions": [
        "laver"
    ],
    "laverons": [
        "laver"
    ],
    "laveront": [
        "laver"
    ],
    "laves": [
        "lave",
        "laver"
    ],
    "lavette": [
        "lavette"
    ],
    "lavettes": [
        "lavette"
    ],
    "laveur": [
        "laveur"
    ],
    "laveurs": [
        "laveur"
    ],
    "laveuse": [
        "laveur"
    ],
    "laveuses": [
        "laveur"
    ],
    "lavez": [
        "laver"
    ],
    "lavions": [
        "laver"
    ],
    "lavis": [
        "lavis"
    ],
    "lavoir": [
        "lavoir"
    ],
    "lavoirs": [
        "lavoir"
    ],
    "lavons": [
        "laver"
    ],
    "lavure": [
        "lavure"
    ],
    "lavures": [
        "lavure"
    ],
    "laverent": [
        "laver"
    ],
    "lavee": [
        "lave",
        "laver"
    ],
    "lavees": [
        "lave",
        "laver"
    ],
    "laxatif": [
        "laxatif"
    ],
    "laxatifs": [
        "laxatif"
    ],
    "laxative": [
        "laxatif"
    ],
    "laxatives": [
        "laxative",
        "laxatif"
    ],
    "laxisme": [
        "laxisme"
    ],
    "laxiste": [
        "laxiste"
    ],
    "laxistes": [
        "laxiste"
    ],
    "laxite": [
        "laxite"
    ],
    "laya": [
        "layer"
    ],
    "layer": [
        "layer"
    ],
    "layette": [
        "layette"
    ],
    "layettes": [
        "layette"
    ],
    "layon": [
        "layon"
    ],
    "layons": [
        "layon"
    ],
    "lazaret": [
        "lazaret"
    ],
    "lazarets": [
        "lazaret"
    ],
    "lazaro": [
        "lazaro"
    ],
    "lazingue": [
        "lazingue"
    ],
    "lazzi": [
        "lazzi"
    ],
    "lazzis": [
        "lazzi"
    ],
    "laca": [
        "lacer"
    ],
    "lacage": [
        "lacage"
    ],
    "lacais": [
        "lacer"
    ],
    "lacait": [
        "lacer"
    ],
    "lacant": [
        "lacer"
    ],
    "laiche": [
        "laiche"
    ],
    "laiches": [
        "laiche"
    ],
    "laic": [
        "laic"
    ],
    "laiciser": [
        "laiciser"
    ],
    "laicite": [
        "laicite"
    ],
    "laics": [
        "laic"
    ],
    "laique": [
        "laique"
    ],
    "laiques": [
        "laique"
    ],
    "laius": [
        "laius"
    ],
    "laiusse": [
        "laiusser"
    ],
    "le": [
        "le"
    ],
    "leader": [
        "leader"
    ],
    "leaders": [
        "leader"
    ],
    "leadership": [
        "leadership"
    ],
    "leasing": [
        "lease",
        "leasing"
    ],
    "lebel": [
        "lebel"
    ],
    "lebels": [
        "lebel"
    ],
    "leben": [
        "leben"
    ],
    "lecteur": [
        "lecteur"
    ],
    "lecteurs": [
        "lecteur"
    ],
    "lectorat": [
        "lectorat"
    ],
    "lectrice": [
        "lecteur"
    ],
    "lectrices": [
        "lecteur"
    ],
    "lecture": [
        "lecture"
    ],
    "lectures": [
        "lecture"
    ],
    "ledit": [
        "ledit"
    ],
    "legato": [
        "legato"
    ],
    "leggins": [
        "leggins"
    ],
    "leghorns": [
        "leghorn"
    ],
    "lego": [
        "lego"
    ],
    "legos": [
        "lego"
    ],
    "legs": [
        "legs",
        "leg"
    ],
    "lei": [
        "lei"
    ],
    "leishmaniose": [
        "leishmaniose"
    ],
    "leitmotiv": [
        "leitmotiv"
    ],
    "leitmotive": [
        "leitmotive"
    ],
    "lek": [
        "lek"
    ],
    "lem": [
        "lem"
    ],
    "lemmes": [
        "lemme"
    ],
    "lemming": [
        "lemming"
    ],
    "lemmings": [
        "lemming"
    ],
    "lendemain": [
        "lendemain"
    ],
    "lendemains": [
        "lendemain"
    ],
    "lent": [
        "lent",
        "lend"
    ],
    "lente": [
        "lente",
        "lent"
    ],
    "lentement": [
        "lentement"
    ],
    "lentes": [
        "lente",
        "lent"
    ],
    "lenteur": [
        "lenteur"
    ],
    "lenteurs": [
        "lenteur"
    ],
    "lenticulaires": [
        "lenticulaire"
    ],
    "lenticules": [
        "lenticule"
    ],
    "lentille": [
        "lentille"
    ],
    "lentilles": [
        "lentille"
    ],
    "lentisque": [
        "lentisque"
    ],
    "lentisques": [
        "lentisque"
    ],
    "lento": [
        "lento"
    ],
    "lents": [
        "lent"
    ],
    "lepton": [
        "lepton"
    ],
    "leptonique": [
        "leptonique"
    ],
    "leptons": [
        "lepton"
    ],
    "lequel": [
        "lequel"
    ],
    "lerch": [
        "lerch"
    ],
    "lerche": [
        "lerche"
    ],
    "les": [
        "les",
        "le"
    ],
    "lesbianisme": [
        "lesbianisme"
    ],
    "lesbien": [
        "lesbien"
    ],
    "lesbienne": [
        "lesbien"
    ],
    "lesbiennes": [
        "lesbien"
    ],
    "lesdites": [
        "lesdites"
    ],
    "lesdits": [
        "lesdits"
    ],
    "lesquelles": [
        "lesquelles"
    ],
    "lesquels": [
        "lesquels"
    ],
    "lessiva": [
        "lessiver"
    ],
    "lessivage": [
        "lessivage"
    ],
    "lessivaient": [
        "lessiver"
    ],
    "lessivait": [
        "lessiver"
    ],
    "lessivant": [
        "lessiver"
    ],
    "lessive": [
        "lessive",
        "lessiver"
    ],
    "lessiver": [
        "lessiver"
    ],
    "lessiverait": [
        "lessiver"
    ],
    "lessives": [
        "lessive",
        "lessiver"
    ],
    "lessiveuse": [
        "lessiveur"
    ],
    "lessiveuses": [
        "lessiveur"
    ],
    "lessivons": [
        "lessiver"
    ],
    "lessivee": [
        "lessiver"
    ],
    "lest": [
        "lest"
    ],
    "leste": [
        "leste",
        "lester"
    ],
    "lestement": [
        "lestement"
    ],
    "lester": [
        "lester"
    ],
    "lestera": [
        "lester"
    ],
    "lesterait": [
        "lester"
    ],
    "lestes": [
        "leste",
        "lester"
    ],
    "lestez": [
        "lester"
    ],
    "lestee": [
        "leste",
        "lester"
    ],
    "lestees": [
        "leste",
        "lester"
    ],
    "let": [
        "let"
    ],
    "letchis": [
        "letchi"
    ],
    "lette": [
        "lette"
    ],
    "lettes": [
        "lette"
    ],
    "letton": [
        "letton"
    ],
    "lettone": [
        "letton",
        "lettone"
    ],
    "lettonne": [
        "letton"
    ],
    "lettonnes": [
        "letton"
    ],
    "lettons": [
        "letton"
    ],
    "lettrage": [
        "lettrage"
    ],
    "lettre": [
        "lettre"
    ],
    "lettres": [
        "lettre"
    ],
    "lettreur": [
        "lettreur"
    ],
    "lettrine": [
        "lettrine"
    ],
    "lettrines": [
        "lettrine"
    ],
    "lettriques": [
        "lettrique"
    ],
    "lettristes": [
        "lettriste"
    ],
    "lettree": [
        "lettre"
    ],
    "leu": [
        "leu"
    ],
    "leucocytaire": [
        "leucocytaire"
    ],
    "leucocyte": [
        "leucocyte"
    ],
    "leucocytes": [
        "leucocyte"
    ],
    "leucocytose": [
        "leucocytose"
    ],
    "leucoplasie": [
        "leucoplasie"
    ],
    "leucopenie": [
        "leucopenie"
    ],
    "leucose": [
        "leucose"
    ],
    "leucotomie": [
        "leucotomie"
    ],
    "leucemie": [
        "leucemie"
    ],
    "leucemies": [
        "leucemie"
    ],
    "leucemique": [
        "leucemique"
    ],
    "leur": [
        "leur"
    ],
    "leurrais": [
        "leurrer"
    ],
    "leurrait": [
        "leurrer"
    ],
    "leurre": [
        "leurre",
        "leurrer"
    ],
    "leurrent": [
        "leurrer"
    ],
    "leurrer": [
        "leurrer"
    ],
    "leurres": [
        "leurre",
        "leurrer"
    ],
    "leurrez": [
        "leurrer"
    ],
    "leurrons": [
        "leurrer"
    ],
    "leurs": [
        "leurs",
        "leur"
    ],
    "lev": [
        "lev"
    ],
    "leva": [
        "lever",
        "leva"
    ],
    "levage": [
        "levage"
    ],
    "levai": [
        "lever"
    ],
    "levaient": [
        "lever"
    ],
    "levain": [
        "levain"
    ],
    "levais": [
        "lever"
    ],
    "levait": [
        "lever"
    ],
    "levant": [
        "lever",
        "levant"
    ],
    "levante": [
        "levant"
    ],
    "levantin": [
        "levantin"
    ],
    "levantines": [
        "levantin"
    ],
    "levantins": [
        "levantin"
    ],
    "lever": [
        "lever"
    ],
    "levers": [
        "lever"
    ],
    "leveur": [
        "leveur"
    ],
    "leveurs": [
        "leveur"
    ],
    "leveuse": [
        "leveur"
    ],
    "levez": [
        "lever"
    ],
    "levier": [
        "levier"
    ],
    "leviers": [
        "levier"
    ],
    "leviez": [
        "lever"
    ],
    "levions": [
        "lever"
    ],
    "levons": [
        "lever"
    ],
    "levreau": [
        "levreau"
    ],
    "levreaux": [
        "levreau"
    ],
    "levrette": [
        "levrette"
    ],
    "levrettes": [
        "levrette"
    ],
    "levure": [
        "levure"
    ],
    "levures": [
        "levure"
    ],
    "levames": [
        "lever"
    ],
    "levat": [
        "lever"
    ],
    "leverent": [
        "lever"
    ],
    "leve": [
        "lever",
        "leve"
    ],
    "levee": [
        "lever",
        "leve",
        "levee"
    ],
    "levees": [
        "lever",
        "leve",
        "levee"
    ],
    "leves": [
        "lever",
        "leve"
    ],
    "lexical": [
        "lexical"
    ],
    "lexicographes": [
        "lexicographe"
    ],
    "lexie": [
        "lexie"
    ],
    "lexique": [
        "lexique"
    ],
    "lexiques": [
        "lexique"
    ],
    "lez": [
        "lez"
    ],
    "lecon": [
        "lecon"
    ],
    "lecons": [
        "lecon"
    ],
    "li": [
        "li"
    ],
    "lia": [
        "lier"
    ],
    "liage": [
        "liage"
    ],
    "liai": [
        "lier"
    ],
    "liaient": [
        "lier"
    ],
    "liais": [
        "lier"
    ],
    "liaison": [
        "liaison"
    ],
    "liaisons": [
        "liaison"
    ],
    "liait": [
        "lier"
    ],
    "liane": [
        "liane"
    ],
    "lianes": [
        "liane"
    ],
    "liant": [
        "liant",
        "lier"
    ],
    "liante": [
        "liant"
    ],
    "liants": [
        "liant"
    ],
    "liard": [
        "liard"
    ],
    "liardais": [
        "liarder"
    ],
    "liards": [
        "liard"
    ],
    "liasse": [
        "lier",
        "liasse"
    ],
    "liasses": [
        "liasse"
    ],
    "libanais": [
        "libanais"
    ],
    "libanaise": [
        "libanais"
    ],
    "libanaises": [
        "libanais"
    ],
    "libation": [
        "libation"
    ],
    "libations": [
        "libation"
    ],
    "libeccio": [
        "libeccio"
    ],
    "libelle": [
        "libeller",
        "libelle"
    ],
    "libeller": [
        "libeller"
    ],
    "libelles": [
        "libelle"
    ],
    "libellule": [
        "libellule"
    ],
    "libellules": [
        "libellule"
    ],
    "libellee": [
        "libeller"
    ],
    "libellees": [
        "libeller"
    ],
    "liber": [
        "liber"
    ],
    "libera": [
        "libera",
        "liberer"
    ],
    "libero": [
        "libero"
    ],
    "libertaire": [
        "libertaire"
    ],
    "libertaires": [
        "libertaire"
    ],
    "liberticide": [
        "liberticide"
    ],
    "libertin": [
        "libertin"
    ],
    "libertinage": [
        "libertinage"
    ],
    "libertine": [
        "libertin"
    ],
    "libertines": [
        "libertin"
    ],
    "libertins": [
        "libertin"
    ],
    "liberte": [
        "liberte"
    ],
    "libertes": [
        "liberte"
    ],
    "libidinal": [
        "libidinal"
    ],
    "libidinale": [
        "libidinal"
    ],
    "libidinales": [
        "libidinal"
    ],
    "libidinaux": [
        "libidinal"
    ],
    "libidineuse": [
        "libidineux"
    ],
    "libidineuses": [
        "libidineux"
    ],
    "libidineux": [
        "libidineux"
    ],
    "libido": [
        "libido"
    ],
    "libraire": [
        "libraire"
    ],
    "libraires": [
        "libraire"
    ],
    "librairie": [
        "librairie"
    ],
    "librairies": [
        "librairie"
    ],
    "libre": [
        "libre"
    ],
    "librement": [
        "librement"
    ],
    "libres": [
        "libre"
    ],
    "librettiste": [
        "librettiste"
    ],
    "librettistes": [
        "librettiste"
    ],
    "libretto": [
        "libretto"
    ],
    "libyen": [
        "libyen"
    ],
    "libyenne": [
        "libyen"
    ],
    "libyens": [
        "libyen"
    ],
    "libere": [
        "libere",
        "liberer"
    ],
    "liberent": [
        "liberer"
    ],
    "liberes": [
        "libere",
        "liberer"
    ],
    "liberable": [
        "liberable"
    ],
    "liberables": [
        "liberable"
    ],
    "liberai": [
        "liberer"
    ],
    "liberaient": [
        "liberer"
    ],
    "liberais": [
        "liberer"
    ],
    "liberait": [
        "liberer"
    ],
    "liberal": [
        "liberal"
    ],
    "liberale": [
        "liberal"
    ],
    "liberalement": [
        "liberalement"
    ],
    "liberales": [
        "liberal"
    ],
    "liberalisation": [
        "liberalisation"
    ],
    "liberalisme": [
        "liberalisme"
    ],
    "liberalite": [
        "liberalite"
    ],
    "liberalites": [
        "liberalite"
    ],
    "liberant": [
        "liberer"
    ],
    "liberateur": [
        "liberateur"
    ],
    "liberateurs": [
        "liberateur"
    ],
    "liberation": [
        "liberation"
    ],
    "liberations": [
        "liberation"
    ],
    "liberatoire": [
        "liberatoire"
    ],
    "liberatrice": [
        "liberateur"
    ],
    "liberatrices": [
        "liberateur"
    ],
    "liberaux": [
        "liberal"
    ],
    "liberer": [
        "liberer"
    ],
    "liberera": [
        "liberer"
    ],
    "libererai": [
        "liberer"
    ],
    "libereraient": [
        "liberer"
    ],
    "libererais": [
        "liberer"
    ],
    "libererait": [
        "liberer"
    ],
    "libereras": [
        "liberer"
    ],
    "libererez": [
        "liberer"
    ],
    "libererons": [
        "liberer"
    ],
    "libereront": [
        "liberer"
    ],
    "liberez": [
        "liberer"
    ],
    "liberien": [
        "liberien"
    ],
    "liberiez": [
        "liberer"
    ],
    "liberions": [
        "liberer"
    ],
    "liberons": [
        "liberer"
    ],
    "liberat": [
        "liberer"
    ],
    "libererent": [
        "liberer"
    ],
    "liberee": [
        "libere",
        "liberer"
    ],
    "liberees": [
        "libere",
        "liberer"
    ],
    "lice": [
        "lice",
        "louse"
    ],
    "licence": [
        "licence"
    ],
    "licences": [
        "licence"
    ],
    "licencia": [
        "licencier"
    ],
    "licenciables": [
        "licenciable"
    ],
    "licenciai": [
        "licencier"
    ],
    "licenciaient": [
        "licencier"
    ],
    "licenciait": [
        "licencier"
    ],
    "licenciant": [
        "licencier"
    ],
    "licencie": [
        "licencie",
        "licencier"
    ],
    "licenciement": [
        "licenciement"
    ],
    "licenciements": [
        "licenciement"
    ],
    "licencient": [
        "licencier"
    ],
    "licencier": [
        "licencier"
    ],
    "licenciera": [
        "licencier"
    ],
    "licencieuse": [
        "licencieux"
    ],
    "licencieuses": [
        "licencieux"
    ],
    "licencieux": [
        "licencieux"
    ],
    "licenciez": [
        "licencier"
    ],
    "licenciee": [
        "licencie",
        "licencier"
    ],
    "licenciees": [
        "licencie"
    ],
    "licencies": [
        "licencie",
        "licencier"
    ],
    "lices": [
        "lice"
    ],
    "lichant": [
        "licher"
    ],
    "lichas": [
        "licher"
    ],
    "liche": [
        "liche",
        "licher"
    ],
    "lichen": [
        "lichen"
    ],
    "lichens": [
        "lichen"
    ],
    "licher": [
        "licher"
    ],
    "lichette": [
        "lichette"
    ],
    "lichettes": [
        "lichette"
    ],
    "lichotter": [
        "lichotter"
    ],
    "lichee": [
        "licher"
    ],
    "lichees": [
        "licher"
    ],
    "liciers": [
        "licier"
    ],
    "licite": [
        "licite"
    ],
    "licites": [
        "licite"
    ],
    "licol": [
        "licol"
    ],
    "licols": [
        "licol"
    ],
    "licorne": [
        "licorne"
    ],
    "licornes": [
        "licorne"
    ],
    "licou": [
        "licou"
    ],
    "licous": [
        "licou"
    ],
    "licteur": [
        "licteur"
    ],
    "licteurs": [
        "licteur"
    ],
    "liceite": [
        "liceite"
    ],
    "lido": [
        "lido"
    ],
    "lidocaine": [
        "lidocaine"
    ],
    "lie": [
        "lie",
        "lier"
    ],
    "lied": [
        "lie",
        "lied"
    ],
    "lieder": [
        "lied"
    ],
    "lien": [
        "lien"
    ],
    "liens": [
        "lien"
    ],
    "lient": [
        "lier"
    ],
    "lier": [
        "lier"
    ],
    "liera": [
        "lier"
    ],
    "lierais": [
        "lier"
    ],
    "lierait": [
        "lier"
    ],
    "lieras": [
        "lier"
    ],
    "lieront": [
        "lier"
    ],
    "lierre": [
        "lierre"
    ],
    "lierres": [
        "lierre"
    ],
    "lies": [
        "lie",
        "lier"
    ],
    "liesse": [
        "liesse"
    ],
    "liesses": [
        "liesse"
    ],
    "lieu": [
        "lieu"
    ],
    "lieudit": [
        "lieudit"
    ],
    "lieudits": [
        "lieudit"
    ],
    "lieue": [
        "lieue"
    ],
    "lieues": [
        "lieue"
    ],
    "lieur": [
        "lieur"
    ],
    "lieus": [
        "lieu"
    ],
    "lieuse": [
        "lieur"
    ],
    "lieutenant": [
        "lieutenant"
    ],
    "lieutenants": [
        "lieutenant"
    ],
    "lieux": [
        "lieu"
    ],
    "liez": [
        "lier"
    ],
    "lift": [
        "lift"
    ],
    "lifter": [
        "lifter"
    ],
    "liftier": [
        "liftier"
    ],
    "liftiers": [
        "liftier"
    ],
    "lifting": [
        "lift",
        "lifting"
    ],
    "liftings": [
        "lifting"
    ],
    "liftiere": [
        "liftier"
    ],
    "lifts": [
        "lift"
    ],
    "lifte": [
        "lifte"
    ],
    "liftee": [
        "lifter",
        "lifte"
    ],
    "liftees": [
        "lifter",
        "lifte"
    ],
    "ligament": [
        "ligament"
    ],
    "ligamentaire": [
        "ligamentaire"
    ],
    "ligaments": [
        "ligament"
    ],
    "ligature": [
        "ligature",
        "ligaturer"
    ],
    "ligaturer": [
        "ligaturer"
    ],
    "ligatures": [
        "ligature"
    ],
    "ligaturez": [
        "ligaturer"
    ],
    "ligaturee": [
        "ligaturer"
    ],
    "lige": [
        "lige"
    ],
    "liges": [
        "lige"
    ],
    "light": [
        "light"
    ],
    "ligna": [
        "ligner"
    ],
    "lignage": [
        "lignage"
    ],
    "lignages": [
        "lignage"
    ],
    "lignards": [
        "lignard"
    ],
    "ligne": [
        "ligne",
        "ligner"
    ],
    "ligner": [
        "ligner"
    ],
    "lignes": [
        "ligne"
    ],
    "ligneuses": [
        "ligneux"
    ],
    "ligneux": [
        "ligneux"
    ],
    "lignite": [
        "lignite"
    ],
    "lignites": [
        "lignite"
    ],
    "lignee": [
        "lignee",
        "ligner"
    ],
    "lignees": [
        "lignee",
        "ligner"
    ],
    "ligot": [
        "ligot"
    ],
    "ligota": [
        "ligoter"
    ],
    "ligotage": [
        "ligotage"
    ],
    "ligotaient": [
        "ligoter"
    ],
    "ligotait": [
        "ligoter"
    ],
    "ligotant": [
        "ligoter"
    ],
    "ligote": [
        "ligote",
        "ligoter"
    ],
    "ligotent": [
        "ligoter"
    ],
    "ligoter": [
        "ligoter"
    ],
    "ligoterai": [
        "ligoter"
    ],
    "ligoterait": [
        "ligoter"
    ],
    "ligoterons": [
        "ligoter"
    ],
    "ligotez": [
        "ligoter"
    ],
    "ligotons": [
        "ligoter"
    ],
    "ligots": [
        "ligot"
    ],
    "ligoterent": [
        "ligoter"
    ],
    "ligotee": [
        "ligote",
        "ligoter"
    ],
    "ligotees": [
        "ligote",
        "ligoter"
    ],
    "ligotes": [
        "ligote",
        "ligoter"
    ],
    "liguaient": [
        "liguer"
    ],
    "liguait": [
        "liguer"
    ],
    "liguant": [
        "liguer"
    ],
    "ligue": [
        "liguer",
        "ligue"
    ],
    "liguent": [
        "liguer"
    ],
    "liguer": [
        "liguer"
    ],
    "ligues": [
        "liguer",
        "ligue"
    ],
    "ligueur": [
        "ligueur"
    ],
    "ligueurs": [
        "ligueur"
    ],
    "liguez": [
        "liguer"
    ],
    "ligure": [
        "ligure"
    ],
    "ligures": [
        "ligure"
    ],
    "liguerent": [
        "liguer"
    ],
    "liguees": [
        "liguer",
        "ligue"
    ],
    "lilas": [
        "lilas"
    ],
    "liliacees": [
        "liliace",
        "liliacee"
    ],
    "lilial": [
        "lilial"
    ],
    "liliale": [
        "lilial"
    ],
    "lilium": [
        "lilium"
    ],
    "lilliputien": [
        "lilliputien"
    ],
    "lilliputienne": [
        "lilliputien"
    ],
    "lilliputiens": [
        "lilliputien"
    ],
    "lillois": [
        "lillois"
    ],
    "lilloise": [
        "lillois"
    ],
    "lima": [
        "limer"
    ],
    "limace": [
        "limace"
    ],
    "limaces": [
        "limace"
    ],
    "limage": [
        "limage"
    ],
    "limaient": [
        "limer"
    ],
    "limaille": [
        "limaille"
    ],
    "limait": [
        "limer"
    ],
    "liman": [
        "liman"
    ],
    "limande": [
        "limande"
    ],
    "limandes": [
        "limande"
    ],
    "limant": [
        "limer"
    ],
    "limacon": [
        "limacon"
    ],
    "limacons": [
        "limacon"
    ],
    "limbe": [
        "limbe"
    ],
    "limbes": [
        "limbe"
    ],
    "limbique": [
        "limbique"
    ],
    "limbo": [
        "limbo"
    ],
    "lime": [
        "limer",
        "lime"
    ],
    "liment": [
        "limer"
    ],
    "limer": [
        "limer"
    ],
    "limerick": [
        "limerick"
    ],
    "limericks": [
        "limerick"
    ],
    "limes": [
        "limer",
        "lime"
    ],
    "limette": [
        "limette"
    ],
    "limez": [
        "limer"
    ],
    "limier": [
        "limier"
    ],
    "limiers": [
        "limier"
    ],
    "liminaire": [
        "liminaire"
    ],
    "limions": [
        "limer"
    ],
    "limita": [
        "limiter"
    ],
    "limitai": [
        "limiter"
    ],
    "limitaient": [
        "limiter"
    ],
    "limitais": [
        "limiter"
    ],
    "limitait": [
        "limiter"
    ],
    "limitant": [
        "limiter"
    ],
    "limitatif": [
        "limitatif"
    ],
    "limitation": [
        "limitation"
    ],
    "limitations": [
        "limitation"
    ],
    "limitative": [
        "limitatif"
    ],
    "limite": [
        "limiter",
        "limite"
    ],
    "limitent": [
        "limiter"
    ],
    "limiter": [
        "limiter"
    ],
    "limitera": [
        "limiter"
    ],
    "limiterai": [
        "limiter"
    ],
    "limiteraient": [
        "limiter"
    ],
    "limiterait": [
        "limiter"
    ],
    "limiteront": [
        "limiter"
    ],
    "limites": [
        "limiter",
        "limite"
    ],
    "limiteur": [
        "limiteur"
    ],
    "limitez": [
        "limiter"
    ],
    "limitions": [
        "limiter"
    ],
    "limitons": [
        "limiter"
    ],
    "limitrophe": [
        "limitrophe"
    ],
    "limitrophes": [
        "limitrophe"
    ],
    "limitee": [
        "limiter",
        "limite"
    ],
    "limitees": [
        "limiter",
        "limite"
    ],
    "limoge": [
        "limoger",
        "limoge"
    ],
    "limogeage": [
        "limogeage"
    ],
    "limoger": [
        "limoger"
    ],
    "limoges": [
        "limoger"
    ],
    "limon": [
        "limon"
    ],
    "limonade": [
        "limonade"
    ],
    "limonades": [
        "limonade"
    ],
    "limonadier": [
        "limonadier"
    ],
    "limonadiers": [
        "limonadier"
    ],
    "limonadiere": [
        "limonadier"
    ],
    "limonaire": [
        "limonaire"
    ],
    "limoneuse": [
        "limoneux"
    ],
    "limoneuses": [
        "limoneux"
    ],
    "limoneux": [
        "limoneux"
    ],
    "limonier": [
        "limonier"
    ],
    "limoniere": [
        "limonier"
    ],
    "limons": [
        "limon"
    ],
    "limoselle": [
        "limoselle"
    ],
    "limousin": [
        "limousin"
    ],
    "limousine": [
        "limousin"
    ],
    "limousines": [
        "limousin",
        "limousine"
    ],
    "limousins": [
        "limousin"
    ],
    "limpide": [
        "limpide"
    ],
    "limpides": [
        "limpide"
    ],
    "limpidite": [
        "limpidite"
    ],
    "limee": [
        "limer"
    ],
    "lin": [
        "lin"
    ],
    "linaire": [
        "linaire"
    ],
    "linceul": [
        "linceul"
    ],
    "linceuls": [
        "linceul"
    ],
    "lindor": [
        "lindor"
    ],
    "line": [
        "line"
    ],
    "linga": [
        "linga"
    ],
    "lingala": [
        "lingala"
    ],
    "lingam": [
        "lingam"
    ],
    "linge": [
        "linge"
    ],
    "linger": [
        "linger"
    ],
    "lingerie": [
        "lingerie"
    ],
    "lingeries": [
        "lingerie"
    ],
    "linges": [
        "linge"
    ],
    "lingette": [
        "lingette"
    ],
    "lingettes": [
        "lingette"
    ],
    "lingot": [
        "lingot"
    ],
    "lingotiere": [
        "lingotier"
    ],
    "lingots": [
        "lingot"
    ],
    "lingual": [
        "lingual"
    ],
    "linguale": [
        "lingual"
    ],
    "linguaux": [
        "lingual"
    ],
    "linguiste": [
        "linguiste"
    ],
    "linguistes": [
        "linguiste"
    ],
    "linguistique": [
        "linguistique"
    ],
    "linguistiquement": [
        "linguistiquement"
    ],
    "linguistiques": [
        "linguistique"
    ],
    "lingere": [
        "lingere",
        "linger"
    ],
    "lingeres": [
        "lingere",
        "linger"
    ],
    "liniment": [
        "liniment"
    ],
    "lino": [
        "lino"
    ],
    "linoleum": [
        "linoleum"
    ],
    "linoleums": [
        "linoleum"
    ],
    "linon": [
        "linon"
    ],
    "linons": [
        "linon"
    ],
    "linos": [
        "lino"
    ],
    "linotte": [
        "linotte"
    ],
    "linottes": [
        "linotte"
    ],
    "linotype": [
        "linotype"
    ],
    "linotypes": [
        "linotype"
    ],
    "linotypistes": [
        "linotypiste"
    ],
    "lins": [
        "lin"
    ],
    "linteau": [
        "linteau"
    ],
    "linteaux": [
        "linteau"
    ],
    "linter": [
        "linter"
    ],
    "lineaire": [
        "lineaire"
    ],
    "lineairement": [
        "lineairement"
    ],
    "lineaires": [
        "lineaire"
    ],
    "lineaments": [
        "lineament"
    ],
    "lion": [
        "lion"
    ],
    "lionceau": [
        "lionceau"
    ],
    "lionceaux": [
        "lionceau"
    ],
    "lionne": [
        "lion"
    ],
    "lionnes": [
        "lion"
    ],
    "lions": [
        "lier",
        "lion"
    ],
    "lipase": [
        "lipase"
    ],
    "lipide": [
        "lipide"
    ],
    "lipides": [
        "lipide"
    ],
    "lipiodol": [
        "lipiodol"
    ],
    "lipome": [
        "lipome"
    ],
    "liposome": [
        "liposome"
    ],
    "liposuccion": [
        "liposuccion"
    ],
    "liposuccions": [
        "liposuccion"
    ],
    "liposucer": [
        "liposucer"
    ],
    "lipothymie": [
        "lipothymie"
    ],
    "lippe": [
        "lippe"
    ],
    "lippes": [
        "lippe"
    ],
    "lippu": [
        "lippu"
    ],
    "lippue": [
        "lippu"
    ],
    "lippues": [
        "lippu"
    ],
    "lippus": [
        "lippu"
    ],
    "lippees": [
        "lippee"
    ],
    "liquette": [
        "liquette"
    ],
    "liquettes": [
        "liquette"
    ],
    "liqueur": [
        "liqueur"
    ],
    "liqueurs": [
        "liqueur"
    ],
    "liquida": [
        "liquider"
    ],
    "liquidai": [
        "liquider"
    ],
    "liquidaient": [
        "liquider"
    ],
    "liquidait": [
        "liquider"
    ],
    "liquidambars": [
        "liquidambar"
    ],
    "liquidant": [
        "liquider"
    ],
    "liquidateur": [
        "liquidateur"
    ],
    "liquidateurs": [
        "liquidateur"
    ],
    "liquidation": [
        "liquidation"
    ],
    "liquidations": [
        "liquidation"
    ],
    "liquidative": [
        "liquidatif"
    ],
    "liquide": [
        "liquider",
        "liquide"
    ],
    "liquident": [
        "liquider"
    ],
    "liquider": [
        "liquider"
    ],
    "liquidera": [
        "liquider"
    ],
    "liquiderai": [
        "liquider"
    ],
    "liquiderais": [
        "liquider"
    ],
    "liquiderait": [
        "liquider"
    ],
    "liquiderons": [
        "liquider"
    ],
    "liquideront": [
        "liquider"
    ],
    "liquides": [
        "liquider",
        "liquide"
    ],
    "liquidez": [
        "liquider"
    ],
    "liquidions": [
        "liquider"
    ],
    "liquidite": [
        "liquidite"
    ],
    "liquidites": [
        "liquidite"
    ],
    "liquidons": [
        "liquider"
    ],
    "liquidee": [
        "liquider"
    ],
    "liquidees": [
        "liquider"
    ],
    "liquor": [
        "liquor"
    ],
    "liquoreux": [
        "liquoreux"
    ],
    "liquoriste": [
        "liquoriste"
    ],
    "liquefaction": [
        "liquefaction"
    ],
    "liquefiaient": [
        "liquefier"
    ],
    "liquefiait": [
        "liquefier"
    ],
    "liquefiante": [
        "liquefiant"
    ],
    "liquefie": [
        "liquefier"
    ],
    "liquefient": [
        "liquefier"
    ],
    "liquefier": [
        "liquefier"
    ],
    "liquefierent": [
        "liquefier"
    ],
    "liquefiee": [
        "liquefier"
    ],
    "liquefiees": [
        "liquefier"
    ],
    "liquefies": [
        "liquefier"
    ],
    "lira": [
        "lire"
    ],
    "lirai": [
        "lire"
    ],
    "liraient": [
        "lire"
    ],
    "lirais": [
        "lire"
    ],
    "lirait": [
        "lire"
    ],
    "liras": [
        "lire",
        "lira"
    ],
    "lire": [
        "lire",
        "lira"
    ],
    "lires": [
        "lire"
    ],
    "lirette": [
        "lirette"
    ],
    "lirez": [
        "lire"
    ],
    "liriez": [
        "lire"
    ],
    "liron": [
        "liron"
    ],
    "lirons": [
        "lire",
        "liron"
    ],
    "liront": [
        "lire"
    ],
    "lis": [
        "lire",
        "lis"
    ],
    "lisaient": [
        "lire"
    ],
    "lisais": [
        "lire"
    ],
    "lisait": [
        "lire"
    ],
    "lisant": [
        "lire",
        "lisant"
    ],
    "lise": [
        "lire",
        "lise"
    ],
    "lisent": [
        "lire"
    ],
    "liseron": [
        "liseron"
    ],
    "liserons": [
        "liseron"
    ],
    "lisere": [
        "lisere",
        "liserer"
    ],
    "liseree": [
        "liserer"
    ],
    "liseres": [
        "lisere",
        "liserer"
    ],
    "lises": [
        "lire",
        "lise"
    ],
    "liseur": [
        "liseur"
    ],
    "liseuse": [
        "liseur"
    ],
    "liseuses": [
        "liseur"
    ],
    "lisez": [
        "lire"
    ],
    "lisibilite": [
        "lisibilite"
    ],
    "lisible": [
        "lisible"
    ],
    "lisiblement": [
        "lisiblement"
    ],
    "lisibles": [
        "lisible"
    ],
    "lisier": [
        "lisier"
    ],
    "lisiez": [
        "lire"
    ],
    "lisions": [
        "lire"
    ],
    "lisiere": [
        "lisiere"
    ],
    "lisieres": [
        "lisiere"
    ],
    "lisons": [
        "lire"
    ],
    "lissa": [
        "lisser"
    ],
    "lissage": [
        "lissage"
    ],
    "lissai": [
        "lisser"
    ],
    "lissaient": [
        "lisser"
    ],
    "lissais": [
        "lisser"
    ],
    "lissait": [
        "lisser"
    ],
    "lissant": [
        "lisser"
    ],
    "lisse": [
        "lisser",
        "lisse"
    ],
    "lissent": [
        "lisser"
    ],
    "lisser": [
        "lisser"
    ],
    "lissera": [
        "lisser"
    ],
    "lisserait": [
        "lisser"
    ],
    "lisses": [
        "lisser",
        "lisse"
    ],
    "lisseur": [
        "lisseur"
    ],
    "lisseurs": [
        "lisseur"
    ],
    "lissez": [
        "lisser"
    ],
    "lissons": [
        "lisser"
    ],
    "lissotriche": [
        "lissotriche"
    ],
    "lisserent": [
        "lisser"
    ],
    "lissee": [
        "lisser"
    ],
    "lissees": [
        "lisser"
    ],
    "liste": [
        "lister",
        "liste"
    ],
    "listel": [
        "listel"
    ],
    "lister": [
        "lister"
    ],
    "listeria": [
        "listeria"
    ],
    "listes": [
        "lister",
        "liste"
    ],
    "listez": [
        "lister"
    ],
    "listing": [
        "list",
        "listing"
    ],
    "listings": [
        "listing"
    ],
    "liston": [
        "liston"
    ],
    "listee": [
        "lister"
    ],
    "listees": [
        "lister"
    ],
    "liserait": [
        "liserer"
    ],
    "lit": [
        "lit",
        "lire",
        "light"
    ],
    "lita": [
        "liter"
    ],
    "litanie": [
        "litanie"
    ],
    "litanies": [
        "litany",
        "litanie"
    ],
    "lite": [
        "liter"
    ],
    "liteaux": [
        "liteau"
    ],
    "liter": [
        "liter"
    ],
    "literie": [
        "literie"
    ],
    "literies": [
        "literie"
    ],
    "lithiase": [
        "lithiase"
    ],
    "lithines": [
        "lithine"
    ],
    "lithique": [
        "lithique"
    ],
    "lithium": [
        "lithium"
    ],
    "litho": [
        "litho"
    ],
    "lithographe": [
        "lithographe"
    ],
    "lithographie": [
        "lithographier",
        "lithographie"
    ],
    "lithographies": [
        "lithographie"
    ],
    "lithophages": [
        "lithophage"
    ],
    "lithos": [
        "litho"
    ],
    "lithosphere": [
        "lithosphere"
    ],
    "lithotripsie": [
        "lithotripsie"
    ],
    "lithotriteur": [
        "lithotriteur"
    ],
    "lithuanien": [
        "lithuanien"
    ],
    "lithuanienne": [
        "lithuanien"
    ],
    "lithuaniennes": [
        "lithuanien"
    ],
    "litige": [
        "litige"
    ],
    "litiges": [
        "litige"
    ],
    "litigieuse": [
        "litigieux"
    ],
    "litigieux": [
        "litigieux"
    ],
    "litiere": [
        "litiere"
    ],
    "litieres": [
        "litiere"
    ],
    "litorne": [
        "litorne"
    ],
    "litote": [
        "litote"
    ],
    "litotes": [
        "litote"
    ],
    "litre": [
        "litre"
    ],
    "litrer": [
        "litrer"
    ],
    "litres": [
        "litre"
    ],
    "litron": [
        "litron"
    ],
    "litronaient": [
        "litroner"
    ],
    "litrons": [
        "litron"
    ],
    "litrone": [
        "litroner"
    ],
    "lits": [
        "lit"
    ],
    "littoral": [
        "littoral"
    ],
    "littorale": [
        "littoral"
    ],
    "littoraux": [
        "littoral"
    ],
    "litteraire": [
        "litteraire"
    ],
    "litterairement": [
        "litterairement"
    ],
    "litteraires": [
        "litteraire"
    ],
    "litteral": [
        "litteral"
    ],
    "litterale": [
        "litteral"
    ],
    "litteralement": [
        "litteralement"
    ],
    "litterales": [
        "litteral"
    ],
    "litteralite": [
        "litteralite"
    ],
    "litterateur": [
        "litterateur"
    ],
    "litterateurs": [
        "litterateur"
    ],
    "litterature": [
        "litterature"
    ],
    "litteratures": [
        "litterature"
    ],
    "litteraux": [
        "litteral"
    ],
    "lituanien": [
        "lituanien"
    ],
    "lituanienne": [
        "lituanien"
    ],
    "lituaniennes": [
        "lituanien"
    ],
    "lituaniens": [
        "lituanien"
    ],
    "liturgie": [
        "liturgie"
    ],
    "liturgies": [
        "liturgy",
        "liturgie"
    ],
    "liturgique": [
        "liturgique"
    ],
    "liturgiques": [
        "liturgique"
    ],
    "litee": [
        "litee"
    ],
    "livarot": [
        "livarot"
    ],
    "live": [
        "live"
    ],
    "livide": [
        "livide"
    ],
    "livides": [
        "livide"
    ],
    "lividite": [
        "lividite"
    ],
    "living": [
        "living",
        "live"
    ],
    "livings": [
        "living"
    ],
    "livoniennes": [
        "livonienne"
    ],
    "livra": [
        "livrer"
    ],
    "livrable": [
        "livrable"
    ],
    "livrables": [
        "livrable"
    ],
    "livrai": [
        "livrer"
    ],
    "livraient": [
        "livrer"
    ],
    "livrais": [
        "livrer"
    ],
    "livraison": [
        "livraison"
    ],
    "livraisons": [
        "livraison"
    ],
    "livrait": [
        "livrer"
    ],
    "livrant": [
        "livrer"
    ],
    "livre": [
        "livrer",
        "livre"
    ],
    "livrent": [
        "livrer"
    ],
    "livrer": [
        "livrer"
    ],
    "livrera": [
        "livrer"
    ],
    "livrerai": [
        "livrer"
    ],
    "livreraient": [
        "livrer"
    ],
    "livrerais": [
        "livrer"
    ],
    "livrerait": [
        "livrer"
    ],
    "livreras": [
        "livrer"
    ],
    "livrerez": [
        "livrer"
    ],
    "livrerons": [
        "livrer"
    ],
    "livreront": [
        "livrer"
    ],
    "livres": [
        "livrer",
        "livre"
    ],
    "livresque": [
        "livresque"
    ],
    "livresques": [
        "livresque"
    ],
    "livret": [
        "livret"
    ],
    "livrets": [
        "livret"
    ],
    "livreur": [
        "livreur"
    ],
    "livreurs": [
        "livreur"
    ],
    "livreuse": [
        "livreur"
    ],
    "livrez": [
        "livrer"
    ],
    "livrions": [
        "livrer"
    ],
    "livrons": [
        "livrer"
    ],
    "livrames": [
        "livrer"
    ],
    "livrat": [
        "livrer"
    ],
    "livrerent": [
        "livrer"
    ],
    "livree": [
        "livrer",
        "livree"
    ],
    "livrees": [
        "livrer",
        "livree"
    ],
    "liveche": [
        "liveche"
    ],
    "liames": [
        "lier"
    ],
    "liat": [
        "lier"
    ],
    "liege": [
        "liege"
    ],
    "lieges": [
        "liege"
    ],
    "lierent": [
        "lier"
    ],
    "lievre": [
        "lievre"
    ],
    "lievres": [
        "lievre"
    ],
    "liee": [
        "lie",
        "lier"
    ],
    "liees": [
        "lie",
        "lier"
    ],
    "liegeois": [
        "liegeois"
    ],
    "llanos": [
        "llano"
    ],
    "lloyd": [
        "lloyd"
    ],
    "loader": [
        "loader"
    ],
    "lob": [
        "lob"
    ],
    "lobaire": [
        "lobaire"
    ],
    "lobbies": [
        "lobbies",
        "lobby"
    ],
    "lobby": [
        "lobby"
    ],
    "lobbying": [
        "lobbying",
        "lobby"
    ],
    "lobe": [
        "lobe",
        "lober"
    ],
    "lobectomie": [
        "lobectomie"
    ],
    "lober": [
        "lober"
    ],
    "lobes": [
        "lobe"
    ],
    "lobotomie": [
        "lobotomie"
    ],
    "lobotomiser": [
        "lobotomiser"
    ],
    "lobotomise": [
        "lobotomiser"
    ],
    "lobotomisee": [
        "lobotomiser"
    ],
    "lobs": [
        "lob"
    ],
    "lobulaire": [
        "lobulaire"
    ],
    "lobee": [
        "lobe"
    ],
    "local": [
        "local"
    ],
    "locale": [
        "local"
    ],
    "localement": [
        "localement"
    ],
    "locales": [
        "local"
    ],
    "localisa": [
        "localiser"
    ],
    "localisable": [
        "localisable"
    ],
    "localisaient": [
        "localiser"
    ],
    "localisais": [
        "localiser"
    ],
    "localisait": [
        "localiser"
    ],
    "localisant": [
        "localiser"
    ],
    "localisateur": [
        "localisateur"
    ],
    "localisation": [
        "localisation"
    ],
    "localisations": [
        "localisation"
    ],
    "localise": [
        "localiser",
        "localise"
    ],
    "localisent": [
        "localiser"
    ],
    "localiser": [
        "localiser"
    ],
    "localisera": [
        "localiser"
    ],
    "localiseront": [
        "localiser"
    ],
    "localisez": [
        "localiser"
    ],
    "localisions": [
        "localiser"
    ],
    "localisons": [
        "localiser"
    ],
    "localisee": [
        "localiser",
        "localise"
    ],
    "localisees": [
        "localiser",
        "localise"
    ],
    "localises": [
        "localiser",
        "localise"
    ],
    "localite": [
        "localite"
    ],
    "localites": [
        "localite"
    ],
    "locataire": [
        "locataire"
    ],
    "locataires": [
        "locataire"
    ],
    "locateurs": [
        "locateur"
    ],
    "locatif": [
        "locatif"
    ],
    "location": [
        "location"
    ],
    "locations": [
        "location"
    ],
    "locative": [
        "locatif"
    ],
    "locatives": [
        "locatif"
    ],
    "locature": [
        "locature"
    ],
    "locaux": [
        "local"
    ],
    "locdu": [
        "locdu"
    ],
    "loch": [
        "loch"
    ],
    "loche": [
        "loche"
    ],
    "loches": [
        "loch",
        "loche"
    ],
    "loco": [
        "loco"
    ],
    "locomobile": [
        "locomobile"
    ],
    "locomoteur": [
        "locomoteur"
    ],
    "locomoteurs": [
        "locomoteur"
    ],
    "locomotion": [
        "locomotion"
    ],
    "locomotive": [
        "locomotive",
        "locomotif"
    ],
    "locomotives": [
        "locomotive",
        "locomotif"
    ],
    "locomotrice": [
        "locomoteur"
    ],
    "locos": [
        "loco"
    ],
    "locus": [
        "locus"
    ],
    "locuste": [
        "locuste"
    ],
    "locustes": [
        "locuste"
    ],
    "locuteur": [
        "locuteur"
    ],
    "locution": [
        "locution"
    ],
    "locutions": [
        "locution"
    ],
    "locutrice": [
        "locuteur"
    ],
    "loden": [
        "loden"
    ],
    "lodens": [
        "loden"
    ],
    "lof": [
        "lof"
    ],
    "lofe": [
        "lofer"
    ],
    "lofez": [
        "lofer"
    ],
    "loft": [
        "loft"
    ],
    "lofts": [
        "loft"
    ],
    "logarithme": [
        "logarithme"
    ],
    "logarithmes": [
        "logarithme"
    ],
    "logarithmique": [
        "logarithmique"
    ],
    "loge": [
        "loge",
        "loger"
    ],
    "logea": [
        "loger"
    ],
    "logeable": [
        "logeable"
    ],
    "logeables": [
        "logeable"
    ],
    "logeai": [
        "loger"
    ],
    "logeaient": [
        "loger"
    ],
    "logeais": [
        "loger"
    ],
    "logeait": [
        "loger"
    ],
    "logeant": [
        "loger"
    ],
    "logeassent": [
        "loger"
    ],
    "logement": [
        "logement"
    ],
    "logements": [
        "logement"
    ],
    "logent": [
        "loger"
    ],
    "loger": [
        "loger"
    ],
    "logera": [
        "loger"
    ],
    "logerai": [
        "loger"
    ],
    "logeraient": [
        "loger"
    ],
    "logerait": [
        "loger"
    ],
    "logeras": [
        "loger"
    ],
    "logerez": [
        "loger"
    ],
    "logerions": [
        "loger"
    ],
    "logerons": [
        "loger"
    ],
    "logeront": [
        "loger"
    ],
    "loges": [
        "loge",
        "loger"
    ],
    "logettes": [
        "logette"
    ],
    "logeur": [
        "logeur"
    ],
    "logeurs": [
        "logeur"
    ],
    "logeuse": [
        "logeur"
    ],
    "logeuses": [
        "logeur"
    ],
    "logez": [
        "loger"
    ],
    "loggia": [
        "loggia"
    ],
    "loggias": [
        "loggia"
    ],
    "logiciel": [
        "logiciel"
    ],
    "logiciels": [
        "logiciel"
    ],
    "logicien": [
        "logicien"
    ],
    "logicienne": [
        "logicien"
    ],
    "logiciens": [
        "logicien"
    ],
    "logiez": [
        "loger"
    ],
    "login": [
        "login"
    ],
    "logions": [
        "loger"
    ],
    "logique": [
        "logique"
    ],
    "logiquement": [
        "logiquement"
    ],
    "logiques": [
        "logique"
    ],
    "logis": [
        "logis"
    ],
    "logisticien": [
        "logisticien"
    ],
    "logistique": [
        "logistique"
    ],
    "logistiques": [
        "logistique"
    ],
    "logo": [
        "logo"
    ],
    "logogriphe": [
        "logogriphe"
    ],
    "logogriphes": [
        "logogriphe"
    ],
    "logomachie": [
        "logomachie"
    ],
    "logorrhee": [
        "logorrhee"
    ],
    "logos": [
        "logo",
        "logos"
    ],
    "logosphere": [
        "logosphere"
    ],
    "logothetes": [
        "logothete"
    ],
    "logue": [
        "loguer"
    ],
    "logerent": [
        "loger"
    ],
    "logee": [
        "loge",
        "loger"
    ],
    "logees": [
        "loger"
    ],
    "loi": [
        "loi"
    ],
    "loin": [
        "loin"
    ],
    "lointain": [
        "lointain"
    ],
    "lointaine": [
        "lointain"
    ],
    "lointainement": [
        "lointainement"
    ],
    "lointaines": [
        "lointain"
    ],
    "lointains": [
        "lointain"
    ],
    "loir": [
        "loir"
    ],
    "loirs": [
        "loir"
    ],
    "lois": [
        "loi"
    ],
    "loisible": [
        "loisible"
    ],
    "loisir": [
        "loisir"
    ],
    "loisirs": [
        "loisir"
    ],
    "lokoum": [
        "lokoum"
    ],
    "lolita": [
        "lolita"
    ],
    "lolitas": [
        "lolita"
    ],
    "lolo": [
        "lolo"
    ],
    "lolos": [
        "lolo"
    ],
    "lombaire": [
        "lombaire"
    ],
    "lombaires": [
        "lombaire"
    ],
    "lombalgie": [
        "lombalgie"
    ],
    "lombard": [
        "lombard"
    ],
    "lombarde": [
        "lombard"
    ],
    "lombardes": [
        "lombard"
    ],
    "lombardo": [
        "lombardo"
    ],
    "lombards": [
        "lombard"
    ],
    "lombes": [
        "lombes"
    ],
    "lombostats": [
        "lombostat"
    ],
    "lombric": [
        "lombric"
    ],
    "lombrics": [
        "lombric"
    ],
    "lompe": [
        "lompe"
    ],
    "londonien": [
        "londonien"
    ],
    "londonienne": [
        "londonien"
    ],
    "londoniennes": [
        "londonien"
    ],
    "londoniens": [
        "londonien"
    ],
    "londres": [
        "londres"
    ],
    "long": [
        "long"
    ],
    "longane": [
        "longane"
    ],
    "longanimite": [
        "longanimite"
    ],
    "longe": [
        "longe",
        "longer"
    ],
    "longea": [
        "longer"
    ],
    "longeai": [
        "longer"
    ],
    "longeaient": [
        "longer"
    ],
    "longeais": [
        "longer"
    ],
    "longeait": [
        "longer"
    ],
    "longeant": [
        "longer"
    ],
    "longent": [
        "longer"
    ],
    "longeons": [
        "longer"
    ],
    "longer": [
        "long",
        "longer"
    ],
    "longera": [
        "longer"
    ],
    "longeraient": [
        "longer"
    ],
    "longerait": [
        "longer"
    ],
    "longerions": [
        "longer"
    ],
    "longeron": [
        "longeron"
    ],
    "longerons": [
        "longeron",
        "longer"
    ],
    "longeront": [
        "longer"
    ],
    "longes": [
        "longe",
        "longer"
    ],
    "longez": [
        "longer"
    ],
    "longeames": [
        "longer"
    ],
    "longicornes": [
        "longicorne"
    ],
    "longiez": [
        "longer"
    ],
    "longiforme": [
        "longiforme"
    ],
    "longiligne": [
        "longiligne"
    ],
    "longilignes": [
        "longiligne"
    ],
    "longions": [
        "longer"
    ],
    "longitude": [
        "longitude"
    ],
    "longitudinal": [
        "longitudinal"
    ],
    "longitudinale": [
        "longitudinal"
    ],
    "longitudinalement": [
        "longitudinalement"
    ],
    "longitudinales": [
        "longitudinal"
    ],
    "longitudinaux": [
        "longitudinal"
    ],
    "longrines": [
        "longrine"
    ],
    "longs": [
        "long"
    ],
    "longtemps": [
        "longtemps"
    ],
    "longue": [
        "long",
        "longue"
    ],
    "longuement": [
        "longuement"
    ],
    "longues": [
        "long",
        "longue"
    ],
    "longuet": [
        "longuet"
    ],
    "longuette": [
        "longuet"
    ],
    "longuettes": [
        "longuet"
    ],
    "longueur": [
        "longueur"
    ],
    "longueurs": [
        "longueur"
    ],
    "longerent": [
        "longer"
    ],
    "longee": [
        "longer"
    ],
    "longevite": [
        "longevite"
    ],
    "look": [
        "look"
    ],
    "looks": [
        "look"
    ],
    "looping": [
        "loop",
        "looping"
    ],
    "loopings": [
        "looping"
    ],
    "looser": [
        "loos",
        "loose",
        "looser"
    ],
    "loosers": [
        "looser"
    ],
    "lopaille": [
        "lopaille"
    ],
    "lope": [
        "lope"
    ],
    "lopes": [
        "lope"
    ],
    "lopette": [
        "lopette"
    ],
    "lopettes": [
        "lopette"
    ],
    "lopin": [
        "lopin"
    ],
    "lopins": [
        "lopin"
    ],
    "loquace": [
        "loquace"
    ],
    "loquaces": [
        "loquace"
    ],
    "loquacite": [
        "loquacite"
    ],
    "loquait": [
        "loquer"
    ],
    "loque": [
        "loquer",
        "loque"
    ],
    "loquedu": [
        "loquedu"
    ],
    "loquedus": [
        "loquedu"
    ],
    "loquer": [
        "loquer"
    ],
    "loques": [
        "loquer",
        "loque"
    ],
    "loquet": [
        "loquet"
    ],
    "loqueteau": [
        "loqueteau"
    ],
    "loqueteuse": [
        "loqueteux"
    ],
    "loqueteuses": [
        "loqueteux"
    ],
    "loqueteux": [
        "loqueteux"
    ],
    "loquets": [
        "loquet"
    ],
    "loquette": [
        "loqueter"
    ],
    "loran": [
        "loran"
    ],
    "lord": [
        "lord"
    ],
    "lordose": [
        "lordose"
    ],
    "lords": [
        "lord"
    ],
    "lorette": [
        "lorette"
    ],
    "lorettes": [
        "lorette"
    ],
    "lorgna": [
        "lorgner"
    ],
    "lorgnaient": [
        "lorgner"
    ],
    "lorgnais": [
        "lorgner"
    ],
    "lorgnait": [
        "lorgner"
    ],
    "lorgnant": [
        "lorgner"
    ],
    "lorgne": [
        "lorgner"
    ],
    "lorgnent": [
        "lorgner"
    ],
    "lorgner": [
        "lorgner"
    ],
    "lorgnerai": [
        "lorgner"
    ],
    "lorgnerez": [
        "lorgner"
    ],
    "lorgnette": [
        "lorgnette"
    ],
    "lorgnettes": [
        "lorgnette"
    ],
    "lorgnez": [
        "lorgner"
    ],
    "lorgnon": [
        "lorgnon"
    ],
    "lorgnons": [
        "lorgnon"
    ],
    "lorgnerent": [
        "lorgner"
    ],
    "lorgnees": [
        "lorgner"
    ],
    "lorgnes": [
        "lorgner"
    ],
    "lori": [
        "lori"
    ],
    "loriot": [
        "loriot"
    ],
    "loriots": [
        "loriot"
    ],
    "loris": [
        "loris"
    ],
    "lorrain": [
        "lorrain"
    ],
    "lorraine": [
        "lorrain"
    ],
    "lorraines": [
        "lorrain",
        "lorraine"
    ],
    "lorrains": [
        "lorrain"
    ],
    "lors": [
        "lors"
    ],
    "lorsqu": [
        "lorsqu"
    ],
    "lorsque": [
        "lorsque"
    ],
    "los": [
        "los"
    ],
    "losange": [
        "losange"
    ],
    "losanges": [
        "losange"
    ],
    "losangee": [
        "losange"
    ],
    "loser": [
        "loser"
    ],
    "losers": [
        "loser"
    ],
    "lot": [
        "lot"
    ],
    "loterie": [
        "loterie"
    ],
    "loteries": [
        "loterie"
    ],
    "loti": [
        "lotir",
        "loti"
    ],
    "lotie": [
        "lotir",
        "loti"
    ],
    "lotier": [
        "lotier"
    ],
    "loties": [
        "loti"
    ],
    "lotion": [
        "lotion"
    ],
    "lotionnes": [
        "lotionner"
    ],
    "lotions": [
        "lotion"
    ],
    "lotir": [
        "lotir"
    ],
    "lotis": [
        "lotir",
        "loti"
    ],
    "lotissement": [
        "lotissement"
    ],
    "lotissements": [
        "lotissement"
    ],
    "loto": [
        "loto"
    ],
    "lotos": [
        "loto"
    ],
    "lots": [
        "lot"
    ],
    "lotta": [
        "lotta"
    ],
    "lotte": [
        "lotte"
    ],
    "lottes": [
        "lotte"
    ],
    "lotus": [
        "lotus"
    ],
    "loua": [
        "louer"
    ],
    "louable": [
        "louable"
    ],
    "louablement": [
        "louablement"
    ],
    "louables": [
        "louable"
    ],
    "louage": [
        "louage"
    ],
    "louai": [
        "louer"
    ],
    "louaient": [
        "louer"
    ],
    "louais": [
        "louer"
    ],
    "louait": [
        "louer"
    ],
    "louange": [
        "louanger",
        "louange"
    ],
    "louangea": [
        "louanger"
    ],
    "louangeaient": [
        "louanger"
    ],
    "louangeant": [
        "louanger"
    ],
    "louanger": [
        "louanger"
    ],
    "louanges": [
        "louanger",
        "louange"
    ],
    "louangeur": [
        "louangeur"
    ],
    "louangeuses": [
        "louangeur"
    ],
    "louangee": [
        "louanger"
    ],
    "louant": [
        "louer"
    ],
    "loubard": [
        "loubard"
    ],
    "loubarde": [
        "loubard"
    ],
    "loubards": [
        "loubard"
    ],
    "loucha": [
        "loucher"
    ],
    "louchai": [
        "loucher"
    ],
    "louchaient": [
        "loucher"
    ],
    "louchais": [
        "loucher"
    ],
    "louchait": [
        "loucher"
    ],
    "louchant": [
        "loucher"
    ],
    "louche": [
        "loucher",
        "louche"
    ],
    "louchebem": [
        "louchebem"
    ],
    "louchement": [
        "louchement"
    ],
    "louchent": [
        "loucher"
    ],
    "loucher": [
        "loucher"
    ],
    "louches": [
        "loucher",
        "louche"
    ],
    "louchet": [
        "louchet"
    ],
    "loucheur": [
        "loucheur"
    ],
    "loucheuse": [
        "loucheur"
    ],
    "louchez": [
        "loucher"
    ],
    "louchon": [
        "louchon"
    ],
    "louchons": [
        "loucher",
        "louchon"
    ],
    "louchat": [
        "loucher"
    ],
    "louchebeme": [
        "louchebeme"
    ],
    "louchee": [
        "loucher"
    ],
    "loue": [
        "loue",
        "louer"
    ],
    "louent": [
        "louer"
    ],
    "louer": [
        "louer"
    ],
    "louera": [
        "louer"
    ],
    "louerai": [
        "louer"
    ],
    "loueraient": [
        "louer"
    ],
    "louerais": [
        "louer"
    ],
    "louerait": [
        "louer"
    ],
    "loueras": [
        "louer"
    ],
    "loueriez": [
        "louer"
    ],
    "louerons": [
        "louer"
    ],
    "loues": [
        "loue",
        "louer"
    ],
    "loueur": [
        "loueur"
    ],
    "loueurs": [
        "loueur"
    ],
    "loueuse": [
        "loueur"
    ],
    "louez": [
        "louer"
    ],
    "louf": [
        "louf"
    ],
    "loufer": [
        "loufer"
    ],
    "loufes": [
        "loufer"
    ],
    "loufiat": [
        "loufiat"
    ],
    "loufiats": [
        "loufiat"
    ],
    "loufoque": [
        "loufoque"
    ],
    "loufoquerie": [
        "loufoquerie"
    ],
    "loufoqueries": [
        "loufoquerie"
    ],
    "loufoques": [
        "loufoque"
    ],
    "louftingue": [
        "louftingue"
    ],
    "louions": [
        "louer"
    ],
    "louis": [
        "louis"
    ],
    "louisianais": [
        "louisianais"
    ],
    "loukoum": [
        "loukoum"
    ],
    "loukoums": [
        "loukoum"
    ],
    "loulou": [
        "loulou"
    ],
    "loulous": [
        "loulou"
    ],
    "louloute": [
        "louloute"
    ],
    "louloutes": [
        "louloute"
    ],
    "louloutte": [
        "louloutte"
    ],
    "louons": [
        "louer"
    ],
    "loup": [
        "loup"
    ],
    "loupa": [
        "louper"
    ],
    "loupai": [
        "louper"
    ],
    "loupaient": [
        "louper"
    ],
    "loupais": [
        "louper"
    ],
    "loupait": [
        "louper"
    ],
    "loupe": [
        "loupe",
        "louper"
    ],
    "loupent": [
        "louper"
    ],
    "louper": [
        "louper"
    ],
    "loupera": [
        "louper"
    ],
    "louperai": [
        "louper"
    ],
    "louperais": [
        "louper"
    ],
    "louperait": [
        "louper"
    ],
    "louperas": [
        "louper"
    ],
    "louperez": [
        "louper"
    ],
    "loupes": [
        "loupe",
        "louper"
    ],
    "loupez": [
        "louper"
    ],
    "loupiat": [
        "loupiat"
    ],
    "loupiez": [
        "louper"
    ],
    "loupiot": [
        "loupiot"
    ],
    "loupiote": [
        "loupiote"
    ],
    "loupiotes": [
        "loupiote"
    ],
    "loupiots": [
        "loupiot"
    ],
    "loupiotte": [
        "loupiotte"
    ],
    "loupiottes": [
        "loupiotte"
    ],
    "loups": [
        "loup"
    ],
    "loupee": [
        "louper"
    ],
    "loupees": [
        "louper"
    ],
    "lourant": [
        "lourer"
    ],
    "lourd": [
        "lourd"
    ],
    "lourdait": [
        "lourder"
    ],
    "lourdant": [
        "lourder"
    ],
    "lourdaud": [
        "lourdaud"
    ],
    "lourdaude": [
        "lourdaud"
    ],
    "lourdaudes": [
        "lourdaud"
    ],
    "lourdauds": [
        "lourdaud"
    ],
    "lourde": [
        "lourder",
        "lourd"
    ],
    "lourdement": [
        "lourdement"
    ],
    "lourder": [
        "lourder"
    ],
    "lourderie": [
        "lourderie"
    ],
    "lourdes": [
        "lourder",
        "lourd"
    ],
    "lourdeur": [
        "lourdeur"
    ],
    "lourdeurs": [
        "lourdeur"
    ],
    "lourdingue": [
        "lourdingue"
    ],
    "lourdingues": [
        "lourdingue"
    ],
    "lourds": [
        "lourd"
    ],
    "lourdee": [
        "lourder"
    ],
    "lourdees": [
        "lourder"
    ],
    "loustic": [
        "loustic"
    ],
    "loustics": [
        "loustic"
    ],
    "loute": [
        "loute"
    ],
    "loutre": [
        "loutre"
    ],
    "loutres": [
        "loutre"
    ],
    "louve": [
        "loup"
    ],
    "louves": [
        "loup"
    ],
    "louvet": [
        "louvet"
    ],
    "louveteau": [
        "louveteau"
    ],
    "louveteaux": [
        "louveteau"
    ],
    "louvetiers": [
        "louvetier"
    ],
    "louvoie": [
        "louvoyer"
    ],
    "louvoiements": [
        "louvoiement"
    ],
    "louvoient": [
        "louvoyer"
    ],
    "louvoyaient": [
        "louvoyer"
    ],
    "louvoyait": [
        "louvoyer"
    ],
    "louvoyant": [
        "louvoyant",
        "louvoyer"
    ],
    "louvoyants": [
        "louvoyant"
    ],
    "louvoyer": [
        "louvoyer"
    ],
    "louvoyons": [
        "louvoyer"
    ],
    "louvoyat": [
        "louvoyer"
    ],
    "louvoye": [
        "louvoyer"
    ],
    "louames": [
        "louer"
    ],
    "louerent": [
        "louer"
    ],
    "louee": [
        "loue",
        "louee",
        "louer"
    ],
    "louees": [
        "loue",
        "louee",
        "louer"
    ],
    "lova": [
        "lover"
    ],
    "lovaient": [
        "lover"
    ],
    "lovais": [
        "lover"
    ],
    "lovait": [
        "lover"
    ],
    "lovant": [
        "lover"
    ],
    "love": [
        "lover"
    ],
    "lovent": [
        "lover"
    ],
    "lover": [
        "lover"
    ],
    "lovee": [
        "lover"
    ],
    "lovees": [
        "lover"
    ],
    "loves": [
        "lover",
        "love"
    ],
    "loyal": [
        "loyal"
    ],
    "loyale": [
        "loyal"
    ],
    "loyalement": [
        "loyalement"
    ],
    "loyales": [
        "loyal"
    ],
    "loyalisme": [
        "loyalisme"
    ],
    "loyaliste": [
        "loyaliste"
    ],
    "loyalistes": [
        "loyaliste"
    ],
    "loyaute": [
        "loyaute"
    ],
    "loyautes": [
        "loyaute"
    ],
    "loyaux": [
        "loyal"
    ],
    "loyer": [
        "loyer"
    ],
    "loyers": [
        "loyer"
    ],
    "lsd": [
        "lsd"
    ],
    "lu": [
        "lu",
        "lire"
    ],
    "lubie": [
        "lubie"
    ],
    "lubies": [
        "lubie"
    ],
    "lubricite": [
        "lubricite"
    ],
    "lubrifiant": [
        "lubrifiant",
        "lubrifier"
    ],
    "lubrifiante": [
        "lubrifiant"
    ],
    "lubrifiants": [
        "lubrifiant"
    ],
    "lubrification": [
        "lubrification"
    ],
    "lubrifie": [
        "lubrifie",
        "lubrifier"
    ],
    "lubrifient": [
        "lubrifier"
    ],
    "lubrifier": [
        "lubrifier"
    ],
    "lubrifiee": [
        "lubrifie",
        "lubrifier"
    ],
    "lubrifiees": [
        "lubrifie",
        "lubrifier"
    ],
    "lubrifies": [
        "lubrifie"
    ],
    "lubrique": [
        "lubrique"
    ],
    "lubriques": [
        "lubrique"
    ],
    "lucarne": [
        "lucarne"
    ],
    "lucarnes": [
        "lucarne"
    ],
    "luce": [
        "luc",
        "luce"
    ],
    "lucet": [
        "lucet"
    ],
    "lucide": [
        "lucide"
    ],
    "lucidement": [
        "lucidement"
    ],
    "lucides": [
        "lucide"
    ],
    "lucidite": [
        "lucidite"
    ],
    "lucidites": [
        "lucidite"
    ],
    "luciferien": [
        "luciferien"
    ],
    "luciferienne": [
        "luciferien"
    ],
    "luciferiens": [
        "luciferien"
    ],
    "lucilie": [
        "lucilie"
    ],
    "luciole": [
        "luciole"
    ],
    "lucioles": [
        "luciole"
    ],
    "lucite": [
        "lucite"
    ],
    "lucratif": [
        "lucratif"
    ],
    "lucratifs": [
        "lucratif"
    ],
    "lucrative": [
        "lucratif"
    ],
    "lucratives": [
        "lucratif"
    ],
    "lucre": [
        "lucre"
    ],
    "luddite": [
        "luddite"
    ],
    "ludion": [
        "ludion"
    ],
    "ludions": [
        "ludion"
    ],
    "ludique": [
        "ludique"
    ],
    "ludiques": [
        "ludique"
    ],
    "lue": [
        "lu",
        "lire"
    ],
    "lues": [
        "lu",
        "lire"
    ],
    "luette": [
        "luette"
    ],
    "luettes": [
        "luette"
    ],
    "lueur": [
        "lueur"
    ],
    "lueurs": [
        "lueur"
    ],
    "luffa": [
        "luffa"
    ],
    "luge": [
        "luge"
    ],
    "luger": [
        "luger"
    ],
    "lugers": [
        "luger"
    ],
    "luges": [
        "luge"
    ],
    "lugubre": [
        "lugubre"
    ],
    "lugubrement": [
        "lugubrement"
    ],
    "lugubres": [
        "lugubre"
    ],
    "lui": [
        "luire",
        "lui"
    ],
    "luira": [
        "luire"
    ],
    "luiraient": [
        "luire"
    ],
    "luirait": [
        "luire"
    ],
    "luire": [
        "luire"
    ],
    "luirent": [
        "luire"
    ],
    "luis": [
        "luire"
    ],
    "luisaient": [
        "luire"
    ],
    "luisait": [
        "luire"
    ],
    "luisance": [
        "luisance"
    ],
    "luisances": [
        "luisance"
    ],
    "luisant": [
        "luire",
        "luisant"
    ],
    "luisante": [
        "luisant"
    ],
    "luisantes": [
        "luisant"
    ],
    "luisants": [
        "luisant"
    ],
    "luise": [
        "luire"
    ],
    "luisent": [
        "luire"
    ],
    "luit": [
        "luire"
    ],
    "lulu": [
        "lulu"
    ],
    "lulus": [
        "lulu"
    ],
    "lumbago": [
        "lumbago"
    ],
    "lumbagos": [
        "lumbago"
    ],
    "lumen": [
        "lumen"
    ],
    "lumignon": [
        "lumignon"
    ],
    "lumignons": [
        "lumignon"
    ],
    "luminaire": [
        "luminaire"
    ],
    "luminaires": [
        "luminaire"
    ],
    "luminescence": [
        "luminescence"
    ],
    "luminescent": [
        "luminescent"
    ],
    "luminescente": [
        "luminescent"
    ],
    "luminescentes": [
        "luminescent"
    ],
    "luminescents": [
        "luminescent"
    ],
    "lumineuse": [
        "lumineux"
    ],
    "lumineusement": [
        "lumineusement"
    ],
    "lumineuses": [
        "lumineux"
    ],
    "lumineux": [
        "lumineux"
    ],
    "luminosite": [
        "luminosite"
    ],
    "luminosites": [
        "luminosite"
    ],
    "lumiere": [
        "lumiere"
    ],
    "lumieres": [
        "lumiere"
    ],
    "lump": [
        "lump"
    ],
    "lunaire": [
        "lunaire"
    ],
    "lunaires": [
        "lunaire"
    ],
    "lunaison": [
        "lunaison"
    ],
    "lunaisons": [
        "lunaison"
    ],
    "lunatique": [
        "lunatique"
    ],
    "lunatiques": [
        "lunatique"
    ],
    "lunch": [
        "lunch"
    ],
    "luncher": [
        "luncher"
    ],
    "lunches": [
        "lunch",
        "lunche"
    ],
    "lundi": [
        "lundi"
    ],
    "lundis": [
        "lundi"
    ],
    "lune": [
        "lune"
    ],
    "lunes": [
        "lune"
    ],
    "lunetier": [
        "lunetier"
    ],
    "lunette": [
        "lunette"
    ],
    "lunetteries": [
        "lunetterie"
    ],
    "lunettes": [
        "lunette"
    ],
    "lunetteux": [
        "lunetteux"
    ],
    "lunule": [
        "lunule"
    ],
    "lunules": [
        "lunule"
    ],
    "lunee": [
        "lune"
    ],
    "lupanar": [
        "lupanar"
    ],
    "lupanars": [
        "lupanar"
    ],
    "lupin": [
        "lupin"
    ],
    "lupins": [
        "lupin"
    ],
    "lupus": [
        "lupus"
    ],
    "lur": [
        "lur"
    ],
    "lurent": [
        "lire"
    ],
    "lurex": [
        "lurex"
    ],
    "luron": [
        "luron"
    ],
    "luronne": [
        "luron"
    ],
    "luronnes": [
        "luron"
    ],
    "lurons": [
        "luron"
    ],
    "lus": [
        "lu",
        "lire"
    ],
    "lusitanienne": [
        "lusitanien"
    ],
    "lustra": [
        "lustrer"
    ],
    "lustrage": [
        "lustrage"
    ],
    "lustraient": [
        "lustrer"
    ],
    "lustrait": [
        "lustrer"
    ],
    "lustral": [
        "lustral"
    ],
    "lustrale": [
        "lustral"
    ],
    "lustrales": [
        "lustral"
    ],
    "lustrant": [
        "lustrer"
    ],
    "lustre": [
        "lustre",
        "lustrer"
    ],
    "lustrer": [
        "lustrer"
    ],
    "lustres": [
        "lustre",
        "lustrer"
    ],
    "lustreur": [
        "lustreur"
    ],
    "lustreuse": [
        "lustreur"
    ],
    "lustrine": [
        "lustrine"
    ],
    "lustree": [
        "lustre",
        "lustrer"
    ],
    "lustrees": [
        "lustre",
        "lustrer"
    ],
    "lustucru": [
        "lustucru"
    ],
    "lut": [
        "lire",
        "lut"
    ],
    "luth": [
        "luth"
    ],
    "lutherie": [
        "lutherie"
    ],
    "luthier": [
        "luthier"
    ],
    "luths": [
        "luth"
    ],
    "lutheranisme": [
        "lutheranisme"
    ],
    "lutherianisme": [
        "lutherianisme"
    ],
    "lutherien": [
        "lutherien"
    ],
    "lutherienne": [
        "lutherien"
    ],
    "lutheriennes": [
        "lutherien"
    ],
    "lutheriens": [
        "lutherien"
    ],
    "lutin": [
        "lutin"
    ],
    "lutinaient": [
        "lutiner"
    ],
    "lutinait": [
        "lutiner"
    ],
    "lutinant": [
        "lutiner"
    ],
    "lutine": [
        "lutiner",
        "lutin"
    ],
    "lutinent": [
        "lutiner"
    ],
    "lutiner": [
        "lutiner"
    ],
    "lutinerais": [
        "lutiner"
    ],
    "lutins": [
        "lutin"
    ],
    "lutinerent": [
        "lutiner"
    ],
    "lutinee": [
        "lutiner"
    ],
    "lutrin": [
        "lutrin"
    ],
    "lutrins": [
        "lutrin"
    ],
    "lutta": [
        "lutter"
    ],
    "luttai": [
        "lutter"
    ],
    "luttaient": [
        "lutter"
    ],
    "luttais": [
        "lutter"
    ],
    "luttait": [
        "lutter"
    ],
    "luttant": [
        "lutter"
    ],
    "lutte": [
        "lutte",
        "lutter"
    ],
    "luttent": [
        "lutter"
    ],
    "lutter": [
        "lutter"
    ],
    "luttera": [
        "lutter"
    ],
    "lutterai": [
        "lutter"
    ],
    "lutterais": [
        "lutter"
    ],
    "lutterait": [
        "lutter"
    ],
    "lutterions": [
        "lutter"
    ],
    "lutterons": [
        "lutter"
    ],
    "lutteront": [
        "lutter"
    ],
    "luttes": [
        "lutte",
        "lutter"
    ],
    "lutteur": [
        "lutteur"
    ],
    "lutteurs": [
        "lutteur"
    ],
    "lutteuse": [
        "lutteur"
    ],
    "lutteuses": [
        "lutteur"
    ],
    "luttez": [
        "lutter"
    ],
    "luttiez": [
        "lutter"
    ],
    "luttions": [
        "lutter"
    ],
    "luttons": [
        "lutter"
    ],
    "luttat": [
        "lutter"
    ],
    "lutterent": [
        "lutter"
    ],
    "lutz": [
        "lutz"
    ],
    "lute": [
        "luter"
    ],
    "lutecien": [
        "lutecien"
    ],
    "lux": [
        "lux"
    ],
    "luxa": [
        "luxer"
    ],
    "luxation": [
        "luxation"
    ],
    "luxations": [
        "luxation"
    ],
    "luxe": [
        "luxer",
        "luxe"
    ],
    "luxembourgeois": [
        "luxembourgeois"
    ],
    "luxembourgeoise": [
        "luxembourgeois"
    ],
    "luxer": [
        "luxer"
    ],
    "luxes": [
        "luxe"
    ],
    "luxueuse": [
        "luxueux"
    ],
    "luxueusement": [
        "luxueusement"
    ],
    "luxueuses": [
        "luxueux"
    ],
    "luxueux": [
        "luxueux"
    ],
    "luxure": [
        "luxure"
    ],
    "luxuriance": [
        "luxuriance"
    ],
    "luxuriant": [
        "luxuriant"
    ],
    "luxuriante": [
        "luxuriant"
    ],
    "luxuriantes": [
        "luxuriant"
    ],
    "luxuriants": [
        "luxuriant"
    ],
    "luxurieuse": [
        "luxurieux"
    ],
    "luxurieux": [
        "luxurieux"
    ],
    "luzerne": [
        "luzerne"
    ],
    "luzernes": [
        "luzerne"
    ],
    "luzernieres": [
        "luzerniere"
    ],
    "lycanthrope": [
        "lycanthrope"
    ],
    "lycanthropes": [
        "lycanthrope"
    ],
    "lycanthropie": [
        "lycanthropie"
    ],
    "lycaons": [
        "lycaon"
    ],
    "lychee": [
        "lychee"
    ],
    "lychees": [
        "lychee"
    ],
    "lychnis": [
        "lychnis"
    ],
    "lycien": [
        "lycien"
    ],
    "lyciennes": [
        "lycien"
    ],
    "lycoperdon": [
        "lycoperdon"
    ],
    "lycoperdons": [
        "lycoperdon"
    ],
    "lycra": [
        "lycra"
    ],
    "lycee": [
        "lycee"
    ],
    "lyceen": [
        "lyceen"
    ],
    "lyceenne": [
        "lyceen"
    ],
    "lyceennes": [
        "lyceen"
    ],
    "lyceens": [
        "lyceen"
    ],
    "lycees": [
        "lycee"
    ],
    "lymphangite": [
        "lymphangite"
    ],
    "lymphatique": [
        "lymphatique"
    ],
    "lymphatiques": [
        "lymphatique"
    ],
    "lymphatisme": [
        "lymphatisme"
    ],
    "lymphe": [
        "lymphe"
    ],
    "lymphes": [
        "lymphe"
    ],
    "lymphocytaire": [
        "lymphocytaire"
    ],
    "lymphocytaires": [
        "lymphocytaire"
    ],
    "lymphocyte": [
        "lymphocyte"
    ],
    "lymphocytes": [
        "lymphocyte"
    ],
    "lymphocytose": [
        "lymphocytose"
    ],
    "lymphome": [
        "lymphome"
    ],
    "lymphomes": [
        "lymphome"
    ],
    "lymphopenie": [
        "lymphopenie"
    ],
    "lymphosarcome": [
        "lymphosarcome"
    ],
    "lymphoide": [
        "lymphoide"
    ],
    "lynch": [
        "lynch"
    ],
    "lynchage": [
        "lynchage"
    ],
    "lynchages": [
        "lynchage"
    ],
    "lynchait": [
        "lyncher"
    ],
    "lynchent": [
        "lyncher"
    ],
    "lyncher": [
        "lyncher"
    ],
    "lyncheurs": [
        "lyncheur"
    ],
    "lynchez": [
        "lyncher"
    ],
    "lynchiez": [
        "lyncher"
    ],
    "lynchons": [
        "lyncher"
    ],
    "lynche": [
        "lyncher"
    ],
    "lynchee": [
        "lyncher"
    ],
    "lynches": [
        "lynch",
        "lyncher"
    ],
    "lynx": [
        "lynx"
    ],
    "lyonnais": [
        "lyonnais"
    ],
    "lyonnaise": [
        "lyonnais"
    ],
    "lyophilisant": [
        "lyophiliser"
    ],
    "lyophiliser": [
        "lyophiliser"
    ],
    "lyophilise": [
        "lyophiliser",
        "lyophilise"
    ],
    "lyophilisee": [
        "lyophilise"
    ],
    "lyophilises": [
        "lyophilise"
    ],
    "lyre": [
        "lyre"
    ],
    "lyres": [
        "lyre"
    ],
    "lyrique": [
        "lyrique"
    ],
    "lyriques": [
        "lyrique"
    ],
    "lyriser": [
        "lyriser"
    ],
    "lyrisme": [
        "lyrisme"
    ],
    "lys": [
        "lys"
    ],
    "lyse": [
        "lyse"
    ],
    "lysergique": [
        "lysergique"
    ],
    "lysimaque": [
        "lysimaque"
    ],
    "lysine": [
        "lysine"
    ],
    "lysosomes": [
        "lysosome"
    ],
    "lacha": [
        "lacher"
    ],
    "lachage": [
        "lachage"
    ],
    "lachai": [
        "lacher"
    ],
    "lachaient": [
        "lacher"
    ],
    "lachais": [
        "lacher"
    ],
    "lachait": [
        "lacher"
    ],
    "lachant": [
        "lacher"
    ],
    "lache": [
        "lache",
        "lacher"
    ],
    "lachement": [
        "lachement"
    ],
    "lachent": [
        "lacher"
    ],
    "lacher": [
        "lacher"
    ],
    "lachera": [
        "lacher"
    ],
    "lacherai": [
        "lacher"
    ],
    "lacheraient": [
        "lacher"
    ],
    "lacherais": [
        "lacher"
    ],
    "lacherait": [
        "lacher"
    ],
    "lacheras": [
        "lacher"
    ],
    "lacherez": [
        "lacher"
    ],
    "lacheriez": [
        "lacher"
    ],
    "lacherons": [
        "lacher"
    ],
    "lacheront": [
        "lacher"
    ],
    "lachers": [
        "lacher"
    ],
    "laches": [
        "lache",
        "lacher"
    ],
    "lachete": [
        "lachete"
    ],
    "lachetes": [
        "lachete"
    ],
    "lacheur": [
        "lacheur"
    ],
    "lacheurs": [
        "lacheur"
    ],
    "lacheuse": [
        "lacheur"
    ],
    "lachez": [
        "lacher"
    ],
    "lachiez": [
        "lacher"
    ],
    "lachions": [
        "lacher"
    ],
    "lachons": [
        "lacher"
    ],
    "lachat": [
        "lacher"
    ],
    "lacherent": [
        "lacher"
    ],
    "lachee": [
        "lache",
        "lacher"
    ],
    "lachees": [
        "lache",
        "lacher"
    ],
    "leche": [
        "leche",
        "lecher"
    ],
    "lechefrite": [
        "lechefrite"
    ],
    "lechent": [
        "lecher"
    ],
    "lecheries": [
        "lecherie"
    ],
    "leches": [
        "leche",
        "lecher"
    ],
    "legue": [
        "leguer",
        "legue"
    ],
    "lepre": [
        "lepre"
    ],
    "lepres": [
        "lepre"
    ],
    "lese": [
        "leser"
    ],
    "levent": [
        "lever"
    ],
    "levera": [
        "lever"
    ],
    "leverai": [
        "lever"
    ],
    "leveraient": [
        "lever"
    ],
    "leverais": [
        "lever"
    ],
    "leverait": [
        "lever"
    ],
    "leveras": [
        "lever"
    ],
    "leverez": [
        "lever"
    ],
    "leverons": [
        "lever"
    ],
    "leveront": [
        "lever"
    ],
    "levre": [
        "levre"
    ],
    "levres": [
        "levre"
    ],
    "lecha": [
        "lecher"
    ],
    "lechage": [
        "lechage"
    ],
    "lechages": [
        "lechage"
    ],
    "lechaient": [
        "lecher"
    ],
    "lechais": [
        "lecher"
    ],
    "lechait": [
        "lecher"
    ],
    "lechant": [
        "lecher"
    ],
    "lechassions": [
        "lecher"
    ],
    "lecher": [
        "lecher"
    ],
    "lechera": [
        "lecher"
    ],
    "lecherai": [
        "lecher"
    ],
    "lecherais": [
        "lecher"
    ],
    "lecherait": [
        "lecher"
    ],
    "lecheras": [
        "lecher"
    ],
    "lecheront": [
        "lecher"
    ],
    "lecheur": [
        "lecheur"
    ],
    "lecheurs": [
        "lecheur"
    ],
    "lecheuse": [
        "lecheur"
    ],
    "lecheuses": [
        "lecheur"
    ],
    "lechez": [
        "lecher"
    ],
    "lechouillait": [
        "lechouiller"
    ],
    "lechouillent": [
        "lechouiller"
    ],
    "lechouiller": [
        "lechouiller"
    ],
    "lechouilles": [
        "lechouiller"
    ],
    "lecherent": [
        "lecher"
    ],
    "lechee": [
        "lecher",
        "leche"
    ],
    "lechees": [
        "lecher",
        "leche"
    ],
    "lecithine": [
        "lecithine"
    ],
    "legal": [
        "legal"
    ],
    "legale": [
        "legal"
    ],
    "legalement": [
        "legalement"
    ],
    "legales": [
        "legal"
    ],
    "legalisant": [
        "legaliser"
    ],
    "legalisation": [
        "legalisation"
    ],
    "legalise": [
        "legalise",
        "legaliser"
    ],
    "legaliser": [
        "legaliser"
    ],
    "legalisez": [
        "legaliser"
    ],
    "legaliste": [
        "legaliste"
    ],
    "legalistes": [
        "legaliste"
    ],
    "legalisee": [
        "legalise",
        "legaliser"
    ],
    "legalite": [
        "legalite"
    ],
    "legat": [
        "legat"
    ],
    "legataire": [
        "legataire"
    ],
    "legataires": [
        "legataire"
    ],
    "legation": [
        "legation"
    ],
    "legations": [
        "legation"
    ],
    "legats": [
        "legat"
    ],
    "legaux": [
        "legal"
    ],
    "legendaire": [
        "legendaire"
    ],
    "legendaires": [
        "legendaire"
    ],
    "legende": [
        "legende"
    ],
    "legender": [
        "legender"
    ],
    "legendes": [
        "legende"
    ],
    "legendee": [
        "legender",
        "legende"
    ],
    "leger": [
        "leger"
    ],
    "legers": [
        "leger"
    ],
    "legifere": [
        "legiferer"
    ],
    "legiferait": [
        "legiferer"
    ],
    "legiferer": [
        "legiferer"
    ],
    "legion": [
        "legion"
    ],
    "legionellose": [
        "legionellose"
    ],
    "legionnaire": [
        "legionnaire"
    ],
    "legionnaires": [
        "legionnaire"
    ],
    "legions": [
        "legion"
    ],
    "legislateur": [
        "legislateur"
    ],
    "legislateurs": [
        "legislateur"
    ],
    "legislatif": [
        "legislatif"
    ],
    "legislatifs": [
        "legislatif"
    ],
    "legislation": [
        "legislation"
    ],
    "legislative": [
        "legislatif"
    ],
    "legislatives": [
        "legislative",
        "legislatif"
    ],
    "legislature": [
        "legislature"
    ],
    "legiste": [
        "legiste"
    ],
    "legistes": [
        "legiste"
    ],
    "legitimaient": [
        "legitimer"
    ],
    "legitimait": [
        "legitimer"
    ],
    "legitimant": [
        "legitimer",
        "legitimant"
    ],
    "legitimation": [
        "legitimation"
    ],
    "legitimations": [
        "legitimation"
    ],
    "legitime": [
        "legitimer",
        "legitime"
    ],
    "legitimement": [
        "legitimement"
    ],
    "legitiment": [
        "legitimer"
    ],
    "legitimer": [
        "legitimer"
    ],
    "legitimera": [
        "legitimer"
    ],
    "legitimes": [
        "legitime"
    ],
    "legitimiste": [
        "legitimiste"
    ],
    "legitimistes": [
        "legitimiste"
    ],
    "legitimite": [
        "legitimite"
    ],
    "legitimee": [
        "legitime",
        "legitimer"
    ],
    "legua": [
        "leguer"
    ],
    "leguaient": [
        "leguer"
    ],
    "leguais": [
        "leguer"
    ],
    "leguait": [
        "leguer"
    ],
    "leguant": [
        "leguer"
    ],
    "leguer": [
        "leguer"
    ],
    "leguera": [
        "leguer"
    ],
    "leguerai": [
        "leguer"
    ],
    "leguerais": [
        "leguer"
    ],
    "leguerez": [
        "leguer"
    ],
    "leguerons": [
        "leguer"
    ],
    "legueront": [
        "leguer"
    ],
    "leguez": [
        "leguer"
    ],
    "legume": [
        "legume"
    ],
    "legumes": [
        "legume"
    ],
    "legumier": [
        "legumier"
    ],
    "legumineuse": [
        "legumineux"
    ],
    "legumineux": [
        "legumineux"
    ],
    "leguee": [
        "leguer"
    ],
    "leguees": [
        "leguer"
    ],
    "legues": [
        "leguer"
    ],
    "legere": [
        "leger"
    ],
    "legerement": [
        "legerement"
    ],
    "legeres": [
        "leger"
    ],
    "legerete": [
        "legerete"
    ],
    "legeretes": [
        "legerete"
    ],
    "lemur": [
        "lemur"
    ],
    "lemure": [
        "lemure"
    ],
    "lemures": [
        "lemure"
    ],
    "lemurien": [
        "lemurien"
    ],
    "lemuriens": [
        "lemurien"
    ],
    "lenifiait": [
        "lenifier"
    ],
    "lenifiant": [
        "lenifiant"
    ],
    "lenifiante": [
        "lenifiant"
    ],
    "lenifiantes": [
        "lenifiant"
    ],
    "lenifiants": [
        "lenifiant"
    ],
    "lenification": [
        "lenification"
    ],
    "leninisme": [
        "leninisme"
    ],
    "leniniste": [
        "leniniste"
    ],
    "leninistes": [
        "leniniste"
    ],
    "lenitive": [
        "lenitif"
    ],
    "lenitives": [
        "lenitif"
    ],
    "leonard": [
        "leonard"
    ],
    "leonin": [
        "leonin"
    ],
    "leonine": [
        "leonin"
    ],
    "leonins": [
        "leonin"
    ],
    "leopard": [
        "leopard"
    ],
    "leopards": [
        "leopard"
    ],
    "leoparde": [
        "leoparde"
    ],
    "lepidoptere": [
        "lepidoptere"
    ],
    "lepidopteres": [
        "lepidoptere"
    ],
    "lepiotes": [
        "lepiote"
    ],
    "lepontique": [
        "lepontique"
    ],
    "lepreuse": [
        "lepreux"
    ],
    "lepreuses": [
        "lepreux"
    ],
    "lepreux": [
        "lepreux"
    ],
    "leprologie": [
        "leprologie"
    ],
    "leproserie": [
        "leproserie"
    ],
    "leproseries": [
        "leproserie"
    ],
    "lerot": [
        "lerot"
    ],
    "lerots": [
        "lerot"
    ],
    "lesaient": [
        "leser"
    ],
    "lesais": [
        "leser"
    ],
    "leser": [
        "leser"
    ],
    "lesina": [
        "lesiner"
    ],
    "lesinaient": [
        "lesiner"
    ],
    "lesinait": [
        "lesiner"
    ],
    "lesine": [
        "lesiner",
        "lesine"
    ],
    "lesinent": [
        "lesiner"
    ],
    "lesiner": [
        "lesiner"
    ],
    "lesinerie": [
        "lesinerie"
    ],
    "lesines": [
        "lesine"
    ],
    "lesinez": [
        "lesiner"
    ],
    "lesion": [
        "lesion"
    ],
    "lesionnaire": [
        "lesionnaire"
    ],
    "lesions": [
        "lesion",
        "leser"
    ],
    "lesons": [
        "leser"
    ],
    "lesee": [
        "leser"
    ],
    "lesees": [
        "leser"
    ],
    "leses": [
        "leser"
    ],
    "letal": [
        "letal"
    ],
    "letale": [
        "letal"
    ],
    "letales": [
        "letal"
    ],
    "letalite": [
        "letalite"
    ],
    "lethargie": [
        "lethargie"
    ],
    "lethargies": [
        "lethargy",
        "lethargie"
    ],
    "lethargique": [
        "lethargique"
    ],
    "lethargiques": [
        "lethargique"
    ],
    "leviathan": [
        "leviathan"
    ],
    "levitation": [
        "levitation"
    ],
    "levite": [
        "levite"
    ],
    "levitent": [
        "leviter"
    ],
    "leviter": [
        "leviter"
    ],
    "levites": [
        "levite"
    ],
    "levitique": [
        "levitique"
    ],
    "levrier": [
        "levrier"
    ],
    "levriers": [
        "levrier"
    ],
    "lezard": [
        "lezard"
    ],
    "lezardaient": [
        "lezarder"
    ],
    "lezardait": [
        "lezarder"
    ],
    "lezarde": [
        "lezard",
        "lezarder",
        "lezarde"
    ],
    "lezardent": [
        "lezarder"
    ],
    "lezarder": [
        "lezarder"
    ],
    "lezardes": [
        "lezard",
        "lezarder",
        "lezarde"
    ],
    "lezards": [
        "lezard"
    ],
    "lezardee": [
        "lezarde"
    ],
    "lezardees": [
        "lezarder",
        "lezarde"
    ],
    "lumes": [
        "lire"
    ],
    "m": [
        "be",
        "m"
    ],
    "m'": [
        "me"
    ],
    "ma": [
        "ma",
        "mon"
    ],
    "maboul": [
        "maboul"
    ],
    "maboule": [
        "maboul"
    ],
    "maboules": [
        "maboul"
    ],
    "mabouls": [
        "maboul"
    ],
    "mac": [
        "mac"
    ],
    "macabre": [
        "macabre"
    ],
    "macabres": [
        "macabre"
    ],
    "macache": [
        "macache"
    ],
    "macadam": [
        "macadam"
    ],
    "macadamia": [
        "macadamia"
    ],
    "macaque": [
        "macaque"
    ],
    "macaques": [
        "macaque"
    ],
    "macarel": [
        "macarel"
    ],
    "macarelle": [
        "macarelle"
    ],
    "macareux": [
        "macareux"
    ],
    "macaron": [
        "macaron"
    ],
    "macaroni": [
        "macaroni"
    ],
    "macaronique": [
        "macaronique"
    ],
    "macaronis": [
        "macaroni"
    ],
    "macarons": [
        "macaron"
    ],
    "macassar": [
        "macassar"
    ],
    "maccarthysme": [
        "maccarthysme"
    ],
    "macchab": [
        "macchab"
    ],
    "macchabs": [
        "macchab"
    ],
    "macchabee": [
        "macchabee"
    ],
    "macchabees": [
        "macchabee"
    ],
    "macfarlane": [
        "macfarlane"
    ],
    "mach": [
        "mach"
    ],
    "machaon": [
        "machaon"
    ],
    "machette": [
        "machette"
    ],
    "machettes": [
        "machette"
    ],
    "machiavelique": [
        "machiavelique"
    ],
    "machiaveliques": [
        "machiavelique"
    ],
    "machiavelisme": [
        "machiavelisme"
    ],
    "machiavelismes": [
        "machiavelisme"
    ],
    "machin": [
        "machin"
    ],
    "machina": [
        "machiner"
    ],
    "machinaient": [
        "machiner"
    ],
    "machinal": [
        "machinal"
    ],
    "machinale": [
        "machinal"
    ],
    "machinalement": [
        "machinalement"
    ],
    "machinales": [
        "machinal"
    ],
    "machination": [
        "machination"
    ],
    "machinations": [
        "machination"
    ],
    "machinaux": [
        "machinal"
    ],
    "machinchouette": [
        "machinchouette"
    ],
    "machine": [
        "machiner",
        "machine"
    ],
    "machiner": [
        "machiner"
    ],
    "machinerie": [
        "machinerie"
    ],
    "machineries": [
        "machinerie",
        "machinery"
    ],
    "machines": [
        "machiner",
        "machine"
    ],
    "machinette": [
        "machinette"
    ],
    "machinique": [
        "machinique"
    ],
    "machinisme": [
        "machinisme"
    ],
    "machiniste": [
        "machiniste"
    ],
    "machinistes": [
        "machiniste"
    ],
    "machino": [
        "machino"
    ],
    "machinos": [
        "machino"
    ],
    "machins": [
        "machin"
    ],
    "machinee": [
        "machiner"
    ],
    "machinees": [
        "machiner"
    ],
    "machisme": [
        "machisme"
    ],
    "machiste": [
        "machiste"
    ],
    "machistes": [
        "machiste"
    ],
    "machmetre": [
        "machmetre"
    ],
    "macho": [
        "macho"
    ],
    "machos": [
        "macho"
    ],
    "macintosh": [
        "macintosh"
    ],
    "macis": [
        "macis"
    ],
    "mackintosh": [
        "mackintosh"
    ],
    "macoute": [
        "macoute"
    ],
    "macoutes": [
        "macoute"
    ],
    "macrame": [
        "macrame"
    ],
    "macres": [
        "macre"
    ],
    "macreuse": [
        "macreuse"
    ],
    "macreuses": [
        "macreuse"
    ],
    "macro": [
        "macro"
    ],
    "macrobiotique": [
        "macrobiotique"
    ],
    "macroclimat": [
        "macroclimat"
    ],
    "macrocosme": [
        "macrocosme"
    ],
    "macrolide": [
        "macrolide"
    ],
    "macrophage": [
        "macrophage"
    ],
    "macroscopique": [
        "macroscopique"
    ],
    "macroeconomie": [
        "macroeconomie"
    ],
    "macs": [
        "mac"
    ],
    "macula": [
        "maculer",
        "macula"
    ],
    "maculage": [
        "maculage"
    ],
    "maculaient": [
        "maculer"
    ],
    "maculait": [
        "maculer"
    ],
    "maculant": [
        "maculer"
    ],
    "maculation": [
        "maculation"
    ],
    "maculature": [
        "maculature"
    ],
    "macule": [
        "macule",
        "maculer"
    ],
    "maculent": [
        "maculer"
    ],
    "maculer": [
        "maculer"
    ],
    "macules": [
        "macule",
        "maculer"
    ],
    "maculerent": [
        "maculer"
    ],
    "maculee": [
        "maculer"
    ],
    "maculees": [
        "maculer"
    ],
    "macumba": [
        "macumba"
    ],
    "macere": [
        "macerer"
    ],
    "macerent": [
        "macerer"
    ],
    "macedoine": [
        "macedoine"
    ],
    "macedoines": [
        "macedoine"
    ],
    "macedonien": [
        "macedonien"
    ],
    "macedonienne": [
        "macedonien",
        "macedonienne"
    ],
    "macedoniennes": [
        "macedonien"
    ],
    "macerai": [
        "macerer"
    ],
    "maceraient": [
        "macerer"
    ],
    "macerait": [
        "macerer"
    ],
    "maceration": [
        "maceration"
    ],
    "macerations": [
        "maceration"
    ],
    "macerer": [
        "macerer"
    ],
    "maceree": [
        "macerer"
    ],
    "maceres": [
        "macerer"
    ],
    "madame": [
        "madame"
    ],
    "madapolam": [
        "madapolam"
    ],
    "madeleine": [
        "madeleine"
    ],
    "madeleines": [
        "madeleine"
    ],
    "mademoiselle": [
        "mademoiselle"
    ],
    "mademoiselles": [
        "mademoiselle"
    ],
    "madone": [
        "madone"
    ],
    "madones": [
        "madone"
    ],
    "madrague": [
        "madrague"
    ],
    "madras": [
        "madras"
    ],
    "madre": [
        "madre"
    ],
    "madrier": [
        "madrier"
    ],
    "madriers": [
        "madrier"
    ],
    "madrigal": [
        "madrigal"
    ],
    "madrigaux": [
        "madrigal"
    ],
    "madrilene": [
        "madrilene"
    ],
    "madrilenes": [
        "madrilene"
    ],
    "madree": [
        "madre"
    ],
    "madrepore": [
        "madrepore"
    ],
    "madrepores": [
        "madrepore"
    ],
    "madres": [
        "madre"
    ],
    "madere": [
        "madere"
    ],
    "maelstrom": [
        "maelstrom"
    ],
    "maestria": [
        "maestria"
    ],
    "maestro": [
        "maestro"
    ],
    "maffia": [
        "maffia"
    ],
    "maffieux": [
        "maffieux"
    ],
    "maffiosi": [
        "maffioso"
    ],
    "mafflu": [
        "mafflu"
    ],
    "mafflue": [
        "mafflu"
    ],
    "mafflus": [
        "mafflu"
    ],
    "mafia": [
        "mafia"
    ],
    "mafias": [
        "mafia"
    ],
    "mafieuse": [
        "mafieux"
    ],
    "mafieuses": [
        "mafieux"
    ],
    "mafieux": [
        "mafieux"
    ],
    "mafiosi": [
        "mafioso"
    ],
    "mafioso": [
        "mafioso"
    ],
    "maganer": [
        "maganer"
    ],
    "magasin": [
        "magasin"
    ],
    "magasinage": [
        "magasinage"
    ],
    "magasine": [
        "magasiner"
    ],
    "magasiner": [
        "magasiner"
    ],
    "magasines": [
        "magasiner"
    ],
    "magasinier": [
        "magasinier"
    ],
    "magasiniers": [
        "magasinier"
    ],
    "magasiniere": [
        "magasinier"
    ],
    "magasins": [
        "magasin"
    ],
    "magazine": [
        "magazine"
    ],
    "magazines": [
        "magazine"
    ],
    "magdalenien": [
        "magdalenien"
    ],
    "magdaleniennes": [
        "magdalenien"
    ],
    "mage": [
        "mage"
    ],
    "magenta": [
        "magenta"
    ],
    "mages": [
        "mage"
    ],
    "maghrebin": [
        "maghrebin"
    ],
    "maghrebine": [
        "maghrebin"
    ],
    "maghrebines": [
        "maghrebin"
    ],
    "maghrebins": [
        "maghrebin"
    ],
    "maghzen": [
        "maghzen"
    ],
    "magicien": [
        "magicien"
    ],
    "magicienne": [
        "magicien"
    ],
    "magiciens": [
        "magicien"
    ],
    "magico": [
        "magico"
    ],
    "magie": [
        "magie"
    ],
    "magies": [
        "magie"
    ],
    "magique": [
        "magique"
    ],
    "magiquement": [
        "magiquement"
    ],
    "magiques": [
        "magique"
    ],
    "magister": [
        "magister"
    ],
    "magisters": [
        "magister"
    ],
    "magistral": [
        "magistral"
    ],
    "magistrale": [
        "magistral"
    ],
    "magistralement": [
        "magistralement"
    ],
    "magistrales": [
        "magistral"
    ],
    "magistrat": [
        "magistrat"
    ],
    "magistrate": [
        "magistrat"
    ],
    "magistrats": [
        "magistrat"
    ],
    "magistrature": [
        "magistrature"
    ],
    "magistratures": [
        "magistrature"
    ],
    "magistraux": [
        "magistral"
    ],
    "magistere": [
        "magistere"
    ],
    "magma": [
        "magma"
    ],
    "magmas": [
        "magma"
    ],
    "magmatique": [
        "magmatique"
    ],
    "magmatiques": [
        "magmatique"
    ],
    "magna": [
        "magner"
    ],
    "magnait": [
        "magner"
    ],
    "magnaneries": [
        "magnanerie"
    ],
    "magnanime": [
        "magnanime"
    ],
    "magnanimes": [
        "magnanime"
    ],
    "magnanimite": [
        "magnanimite"
    ],
    "magnans": [
        "magnan"
    ],
    "magnat": [
        "magnat"
    ],
    "magnats": [
        "magnat"
    ],
    "magne": [
        "magner"
    ],
    "magnent": [
        "magner"
    ],
    "magner": [
        "magner"
    ],
    "magnes": [
        "magner"
    ],
    "magnez": [
        "magner"
    ],
    "magnifiaient": [
        "magnifier"
    ],
    "magnifiais": [
        "magnifier"
    ],
    "magnifiait": [
        "magnifier"
    ],
    "magnifiant": [
        "magnifier"
    ],
    "magnificat": [
        "magnificat"
    ],
    "magnificence": [
        "magnificence"
    ],
    "magnificences": [
        "magnificence"
    ],
    "magnifie": [
        "magnifier"
    ],
    "magnifient": [
        "magnifier"
    ],
    "magnifier": [
        "magnifier"
    ],
    "magnifiez": [
        "magnifier"
    ],
    "magnifique": [
        "magnifique"
    ],
    "magnifiquement": [
        "magnifiquement"
    ],
    "magnifiques": [
        "magnifique"
    ],
    "magnifiee": [
        "magnifier"
    ],
    "magnifiees": [
        "magnifier"
    ],
    "magnifies": [
        "magnifier",
        "magnify"
    ],
    "magnitude": [
        "magnitude"
    ],
    "magnolia": [
        "magnolia"
    ],
    "magnolias": [
        "magnolia"
    ],
    "magnons": [
        "magner"
    ],
    "magnum": [
        "magnum"
    ],
    "magnums": [
        "magnum"
    ],
    "magnesie": [
        "magnesie"
    ],
    "magnesium": [
        "magnesium"
    ],
    "magnetique": [
        "magnetique"
    ],
    "magnetiquement": [
        "magnetiquement"
    ],
    "magnetiques": [
        "magnetique"
    ],
    "magnetisait": [
        "magnetiser"
    ],
    "magnetise": [
        "magnetiser"
    ],
    "magnetiseur": [
        "magnetiseur"
    ],
    "magnetiseuses": [
        "magnetiseur"
    ],
    "magnetisme": [
        "magnetisme"
    ],
    "magnetismes": [
        "magnetisme"
    ],
    "magnetisee": [
        "magnetiser"
    ],
    "magnetisees": [
        "magnetiser"
    ],
    "magnetises": [
        "magnetiser"
    ],
    "magnetite": [
        "magnetite"
    ],
    "magneto": [
        "magneto"
    ],
    "magnetometre": [
        "magnetometre"
    ],
    "magnetophone": [
        "magnetophone"
    ],
    "magnetophones": [
        "magnetophone"
    ],
    "magnetos": [
        "magneto"
    ],
    "magnetoscope": [
        "magnetoscope"
    ],
    "magnetoscopes": [
        "magnetoscope"
    ],
    "magnetron": [
        "magnetron"
    ],
    "magot": [
        "magot"
    ],
    "magots": [
        "magot"
    ],
    "magouillais": [
        "magouiller"
    ],
    "magouillait": [
        "magouiller"
    ],
    "magouillant": [
        "magouiller"
    ],
    "magouille": [
        "magouille",
        "magouiller"
    ],
    "magouiller": [
        "magouiller"
    ],
    "magouilles": [
        "magouille"
    ],
    "magouilleur": [
        "magouilleur"
    ],
    "magouilleurs": [
        "magouilleur"
    ],
    "magouillez": [
        "magouiller"
    ],
    "magret": [
        "magret"
    ],
    "magyar": [
        "magyar"
    ],
    "magyare": [
        "magyar"
    ],
    "magyares": [
        "magyar"
    ],
    "magyars": [
        "magyar"
    ],
    "maharadja": [
        "maharadja"
    ],
    "maharadjah": [
        "maharadjah"
    ],
    "maharadjahs": [
        "maharadjah"
    ],
    "maharadjas": [
        "maharadja"
    ],
    "maharaja": [
        "maharaja"
    ],
    "maharajah": [
        "maharajah"
    ],
    "maharajahs": [
        "maharajah"
    ],
    "maharajas": [
        "maharaja"
    ],
    "maharani": [
        "maharani"
    ],
    "mahatma": [
        "mahatma"
    ],
    "mahatmas": [
        "mahatma"
    ],
    "mahometan": [
        "mahometan"
    ],
    "mahometane": [
        "mahometan"
    ],
    "mahometans": [
        "mahometan"
    ],
    "mahonia": [
        "mahonia"
    ],
    "mahonias": [
        "mahonia"
    ],
    "mahousse": [
        "mahousse"
    ],
    "mahousses": [
        "mahousse"
    ],
    "mai": [
        "mai"
    ],
    "maid": [
        "maid"
    ],
    "maie": [
        "maie"
    ],
    "maies": [
        "maie"
    ],
    "maigre": [
        "maigre"
    ],
    "maigrelet": [
        "maigrelet"
    ],
    "maigrelets": [
        "maigrelet"
    ],
    "maigrelette": [
        "maigrelet"
    ],
    "maigrelettes": [
        "maigrelette",
        "maigrelet"
    ],
    "maigrement": [
        "maigrement"
    ],
    "maigres": [
        "maigre"
    ],
    "maigreur": [
        "maigreur"
    ],
    "maigri": [
        "maigrir"
    ],
    "maigrichon": [
        "maigrichon"
    ],
    "maigrichonne": [
        "maigrichon"
    ],
    "maigrichonnes": [
        "maigrichon"
    ],
    "maigrichons": [
        "maigrichon"
    ],
    "maigrie": [
        "maigrir"
    ],
    "maigriot": [
        "maigriot"
    ],
    "maigrir": [
        "maigrir"
    ],
    "maigris": [
        "maigrir"
    ],
    "maigrissais": [
        "maigrir"
    ],
    "maigrissait": [
        "maigrir"
    ],
    "maigrissant": [
        "maigrir"
    ],
    "maigrisse": [
        "maigrir"
    ],
    "maigrissent": [
        "maigrir"
    ],
    "maigrisses": [
        "maigrir"
    ],
    "maigrissez": [
        "maigrir"
    ],
    "maigrit": [
        "maigrir"
    ],
    "mail": [
        "mail"
    ],
    "mailer": [
        "mailer"
    ],
    "mailing": [
        "mailing",
        "mail"
    ],
    "maillait": [
        "mailler"
    ],
    "maille": [
        "maille",
        "mailler"
    ],
    "maillechort": [
        "maillechort"
    ],
    "mailler": [
        "mailler"
    ],
    "mailles": [
        "maille"
    ],
    "maillet": [
        "maillet"
    ],
    "maillets": [
        "maillet"
    ],
    "mailloche": [
        "mailloche"
    ],
    "maillon": [
        "maillon"
    ],
    "maillons": [
        "maillon",
        "mailler"
    ],
    "maillot": [
        "maillot"
    ],
    "maillotin": [
        "maillotin"
    ],
    "maillotins": [
        "maillotin"
    ],
    "maillots": [
        "maillot"
    ],
    "mails": [
        "mail"
    ],
    "maile": [
        "mailer"
    ],
    "main": [
        "main"
    ],
    "mainate": [
        "mainate"
    ],
    "maincourantier": [
        "maincourantier"
    ],
    "mainlevee": [
        "mainlevee"
    ],
    "mainmise": [
        "mainmise"
    ],
    "mains": [
        "main"
    ],
    "maint": [
        "maint"
    ],
    "mainte": [
        "mainte"
    ],
    "maintenaient": [
        "maintenir"
    ],
    "maintenais": [
        "maintenir"
    ],
    "maintenait": [
        "maintenir"
    ],
    "maintenance": [
        "maintenance"
    ],
    "maintenant": [
        "maintenir",
        "maintenant"
    ],
    "mainteneur": [
        "mainteneur"
    ],
    "mainteneurs": [
        "mainteneur"
    ],
    "maintenez": [
        "maintenir"
    ],
    "mainteniez": [
        "maintenir"
    ],
    "maintenions": [
        "maintenir"
    ],
    "maintenir": [
        "maintenir"
    ],
    "maintenons": [
        "maintenir"
    ],
    "maintenu": [
        "maintenir"
    ],
    "maintenue": [
        "maintenue",
        "maintenir"
    ],
    "maintenues": [
        "maintenir"
    ],
    "maintenus": [
        "maintenir"
    ],
    "maintes": [
        "maintes"
    ],
    "maintien": [
        "maintien"
    ],
    "maintiendra": [
        "maintenir"
    ],
    "maintiendrai": [
        "maintenir"
    ],
    "maintiendraient": [
        "maintenir"
    ],
    "maintiendrait": [
        "maintenir"
    ],
    "maintiendras": [
        "maintenir"
    ],
    "maintiendriez": [
        "maintenir"
    ],
    "maintiendrons": [
        "maintenir"
    ],
    "maintiendront": [
        "maintenir"
    ],
    "maintienne": [
        "maintenir"
    ],
    "maintiennent": [
        "maintenir"
    ],
    "maintiennes": [
        "maintenir"
    ],
    "maintiens": [
        "maintien",
        "maintenir"
    ],
    "maintient": [
        "maintenir"
    ],
    "maintinrent": [
        "maintenir"
    ],
    "maintins": [
        "maintenir"
    ],
    "maintint": [
        "maintenir"
    ],
    "maints": [
        "maints"
    ],
    "maire": [
        "maire"
    ],
    "maires": [
        "maire"
    ],
    "mairesse": [
        "maire"
    ],
    "mairie": [
        "mairie"
    ],
    "mairies": [
        "mairie"
    ],
    "mais": [
        "mais"
    ],
    "maison": [
        "maison"
    ],
    "maisonnette": [
        "maisonnette"
    ],
    "maisonnettes": [
        "maisonnette"
    ],
    "maisonnee": [
        "maisonnee"
    ],
    "maisonnees": [
        "maisonnee"
    ],
    "maisons": [
        "maison"
    ],
    "maja": [
        "maja"
    ],
    "majestueuse": [
        "majestueux"
    ],
    "majestueusement": [
        "majestueusement"
    ],
    "majestueuses": [
        "majestueux"
    ],
    "majestueux": [
        "majestueux"
    ],
    "majeste": [
        "majeste"
    ],
    "majestes": [
        "majeste"
    ],
    "majeur": [
        "majeur"
    ],
    "majeure": [
        "majeur"
    ],
    "majeures": [
        "majeur"
    ],
    "majeurs": [
        "majeur"
    ],
    "majo": [
        "majo"
    ],
    "majolique": [
        "majolique"
    ],
    "major": [
        "major"
    ],
    "majora": [
        "majorer"
    ],
    "majoral": [
        "majoral"
    ],
    "majorat": [
        "majorat"
    ],
    "majoration": [
        "majoration"
    ],
    "majordome": [
        "majordome"
    ],
    "majordomes": [
        "majordome"
    ],
    "majore": [
        "majorer"
    ],
    "majorer": [
        "majorer"
    ],
    "majorette": [
        "majorette"
    ],
    "majorettes": [
        "majorette"
    ],
    "majoritaire": [
        "majoritaire"
    ],
    "majoritairement": [
        "majoritairement"
    ],
    "majoritaires": [
        "majoritaire"
    ],
    "majorite": [
        "majorite"
    ],
    "majorites": [
        "majorite"
    ],
    "majors": [
        "major"
    ],
    "majoree": [
        "majorer"
    ],
    "majuscule": [
        "majuscule"
    ],
    "majuscules": [
        "majuscule"
    ],
    "maki": [
        "maki"
    ],
    "mal": [
        "mal"
    ],
    "malabar": [
        "malabar"
    ],
    "malabars": [
        "malabar"
    ],
    "malachite": [
        "malachite"
    ],
    "malade": [
        "malade"
    ],
    "malades": [
        "malade"
    ],
    "maladie": [
        "maladie"
    ],
    "maladies": [
        "maladie"
    ],
    "maladif": [
        "maladif"
    ],
    "maladifs": [
        "maladif"
    ],
    "maladive": [
        "maladif"
    ],
    "maladivement": [
        "maladivement"
    ],
    "maladives": [
        "maladif"
    ],
    "maladrerie": [
        "maladrerie"
    ],
    "maladresse": [
        "maladresse"
    ],
    "maladresses": [
        "maladresse"
    ],
    "maladroit": [
        "maladroit"
    ],
    "maladroite": [
        "maladroit"
    ],
    "maladroitement": [
        "maladroitement"
    ],
    "maladroites": [
        "maladroit"
    ],
    "maladroits": [
        "maladroit"
    ],
    "malaga": [
        "malaga"
    ],
    "malaire": [
        "malaire"
    ],
    "malais": [
        "malais"
    ],
    "malaise": [
        "malaise"
    ],
    "malaises": [
        "malaise"
    ],
    "malaisien": [
        "malaisien"
    ],
    "malaisienne": [
        "malaisien"
    ],
    "malaisiens": [
        "malaisien"
    ],
    "malaisee": [
        "malaise"
    ],
    "malaisees": [
        "malaise"
    ],
    "malaisement": [
        "malaisement"
    ],
    "malandrin": [
        "malandrin"
    ],
    "malandrins": [
        "malandrin"
    ],
    "malappris": [
        "malappris"
    ],
    "malapprise": [
        "malappris"
    ],
    "malard": [
        "malard"
    ],
    "malards": [
        "malard"
    ],
    "malaria": [
        "malaria"
    ],
    "malarias": [
        "malaria"
    ],
    "malaventures": [
        "malaventure"
    ],
    "malavise": [
        "malavise"
    ],
    "malavisee": [
        "malavise"
    ],
    "malaxa": [
        "malaxer"
    ],
    "malaxaient": [
        "malaxer"
    ],
    "malaxait": [
        "malaxer"
    ],
    "malaxant": [
        "malaxer"
    ],
    "malaxe": [
        "malaxer"
    ],
    "malaxer": [
        "malaxer"
    ],
    "malaxera": [
        "malaxer"
    ],
    "malaxeur": [
        "malaxeur"
    ],
    "malaxez": [
        "malaxer"
    ],
    "malaxee": [
        "malaxer"
    ],
    "malaxees": [
        "malaxer"
    ],
    "malaxes": [
        "malaxer"
    ],
    "malchance": [
        "malchance"
    ],
    "malchances": [
        "malchance"
    ],
    "malchanceuse": [
        "malchanceux"
    ],
    "malchanceuses": [
        "malchanceux"
    ],
    "malchanceux": [
        "malchanceux"
    ],
    "malcommode": [
        "malcommode"
    ],
    "malcommodes": [
        "malcommode"
    ],
    "malcontent": [
        "malcontent"
    ],
    "malcontents": [
        "malcontent"
    ],
    "maldonne": [
        "maldonne"
    ],
    "maldonnes": [
        "maldonne"
    ],
    "male": [
        "mal",
        "male"
    ],
    "malencontre": [
        "malencontre"
    ],
    "malencontres": [
        "malencontre"
    ],
    "malencontreuse": [
        "malencontreux"
    ],
    "malencontreusement": [
        "malencontreusement"
    ],
    "malencontreuses": [
        "malencontreux"
    ],
    "malencontreux": [
        "malencontreux"
    ],
    "malentendant": [
        "malentendant"
    ],
    "malentendante": [
        "malentendant"
    ],
    "malentendants": [
        "malentendant"
    ],
    "malentendu": [
        "malentendu"
    ],
    "malentendus": [
        "malentendu"
    ],
    "males": [
        "mal",
        "male"
    ],
    "malfaisance": [
        "malfaisance"
    ],
    "malfaisances": [
        "malfaisance"
    ],
    "malfaisant": [
        "malfaisant"
    ],
    "malfaisante": [
        "malfaisant"
    ],
    "malfaisantes": [
        "malfaisant"
    ],
    "malfaisants": [
        "malfaisant"
    ],
    "malfaiteur": [
        "malfaiteur"
    ],
    "malfaiteurs": [
        "malfaiteur"
    ],
    "malfame": [
        "malfame"
    ],
    "malfamee": [
        "malfame"
    ],
    "malfames": [
        "malfame"
    ],
    "malfacon": [
        "malfacon"
    ],
    "malfacons": [
        "malfacon"
    ],
    "malformation": [
        "malformation"
    ],
    "malforme": [
        "malforme"
    ],
    "malfrat": [
        "malfrat"
    ],
    "malfrats": [
        "malfrat"
    ],
    "malgache": [
        "malgache"
    ],
    "malgaches": [
        "malgache"
    ],
    "malgracieuse": [
        "malgracieux"
    ],
    "malgracieux": [
        "malgracieux"
    ],
    "malgre": [
        "malgre"
    ],
    "malhabile": [
        "malhabile"
    ],
    "malhabilement": [
        "malhabilement"
    ],
    "malhabiles": [
        "malhabile"
    ],
    "malherbe": [
        "malherbe"
    ],
    "malheur": [
        "malheur"
    ],
    "malheureuse": [
        "malheureux"
    ],
    "malheureusement": [
        "malheureusement"
    ],
    "malheureuses": [
        "malheureux"
    ],
    "malheureux": [
        "malheureux"
    ],
    "malheurs": [
        "malheur"
    ],
    "malhonnete": [
        "malhonnete"
    ],
    "malhonnetement": [
        "malhonnetement"
    ],
    "malhonnetes": [
        "malhonnete"
    ],
    "malhonnetete": [
        "malhonnetete"
    ],
    "malhonnetetes": [
        "malhonnetete"
    ],
    "mali": [
        "mali"
    ],
    "malice": [
        "malice"
    ],
    "malices": [
        "malice"
    ],
    "malicieuse": [
        "malicieux"
    ],
    "malicieusement": [
        "malicieusement"
    ],
    "malicieuses": [
        "malicieux"
    ],
    "malicieux": [
        "malicieux"
    ],
    "malien": [
        "malien"
    ],
    "malienne": [
        "malienne",
        "malien"
    ],
    "maliens": [
        "malien"
    ],
    "maligne": [
        "malin"
    ],
    "malignement": [
        "malignement"
    ],
    "malignes": [
        "malin"
    ],
    "malignite": [
        "malignite"
    ],
    "malignites": [
        "malignite"
    ],
    "malin": [
        "malin"
    ],
    "maline": [
        "malin"
    ],
    "malines": [
        "malin"
    ],
    "malingre": [
        "malingre"
    ],
    "malingres": [
        "malingre"
    ],
    "malinke": [
        "malinke"
    ],
    "malinois": [
        "malinois"
    ],
    "malins": [
        "malin"
    ],
    "malintentionne": [
        "malintentionne"
    ],
    "malintentionnee": [
        "malintentionne"
    ],
    "malintentionnes": [
        "malintentionne"
    ],
    "mallarmeen": [
        "mallarmeen"
    ],
    "malle": [
        "malle"
    ],
    "malles": [
        "malle"
    ],
    "mallette": [
        "mallette"
    ],
    "mallettes": [
        "mallette"
    ],
    "mallophages": [
        "mallophage"
    ],
    "malleabilite": [
        "malleabilite"
    ],
    "malleable": [
        "malleable"
    ],
    "malleables": [
        "malleable"
    ],
    "malleolaire": [
        "malleolaire"
    ],
    "malleole": [
        "malleole"
    ],
    "malm": [
        "malm"
    ],
    "malmenage": [
        "malmenage"
    ],
    "malmenaient": [
        "malmener"
    ],
    "malmenais": [
        "malmener"
    ],
    "malmenait": [
        "malmener"
    ],
    "malmenant": [
        "malmener"
    ],
    "malmener": [
        "malmener"
    ],
    "malmenez": [
        "malmener"
    ],
    "malmene": [
        "malmener"
    ],
    "malmenee": [
        "malmener"
    ],
    "malmenees": [
        "malmener"
    ],
    "malmenes": [
        "malmener"
    ],
    "malmenent": [
        "malmener"
    ],
    "malmeneront": [
        "malmener"
    ],
    "malnutrition": [
        "malnutrition"
    ],
    "malodorant": [
        "malodorant"
    ],
    "malodorante": [
        "malodorant"
    ],
    "malodorantes": [
        "malodorant"
    ],
    "malodorants": [
        "malodorant"
    ],
    "malotru": [
        "malotru"
    ],
    "malotrus": [
        "malotru"
    ],
    "malouin": [
        "malouin"
    ],
    "malouine": [
        "malouin"
    ],
    "malouines": [
        "malouin"
    ],
    "malouins": [
        "malouin"
    ],
    "malpoli": [
        "malpoli"
    ],
    "malpolie": [
        "malpoli"
    ],
    "malpolis": [
        "malpoli"
    ],
    "malpropre": [
        "malpropre"
    ],
    "malproprement": [
        "malproprement"
    ],
    "malpropres": [
        "malpropre"
    ],
    "malproprete": [
        "malproprete"
    ],
    "malsain": [
        "malsain"
    ],
    "malsaine": [
        "malsain"
    ],
    "malsainement": [
        "malsainement"
    ],
    "malsaines": [
        "malsain"
    ],
    "malsains": [
        "malsain"
    ],
    "malsonnants": [
        "malsonnant"
    ],
    "malseance": [
        "malseance"
    ],
    "malseant": [
        "malseant"
    ],
    "malseante": [
        "malseant"
    ],
    "malt": [
        "malt"
    ],
    "malta": [
        "malter"
    ],
    "maltais": [
        "maltais"
    ],
    "maltaises": [
        "maltais"
    ],
    "maltraitaient": [
        "maltraiter"
    ],
    "maltraitais": [
        "maltraiter"
    ],
    "maltraitait": [
        "maltraiter"
    ],
    "maltraitance": [
        "maltraitance"
    ],
    "maltraitances": [
        "maltraitance"
    ],
    "maltraitant": [
        "maltraiter"
    ],
    "maltraite": [
        "maltraiter"
    ],
    "maltraitent": [
        "maltraiter"
    ],
    "maltraiter": [
        "maltraiter"
    ],
    "maltraitera": [
        "maltraiter"
    ],
    "maltraiterez": [
        "maltraiter"
    ],
    "maltraitez": [
        "maltraiter"
    ],
    "maltraitat": [
        "maltraiter"
    ],
    "maltraiterent": [
        "maltraiter"
    ],
    "maltraitee": [
        "maltraiter"
    ],
    "maltraitees": [
        "maltraiter"
    ],
    "maltraites": [
        "maltraiter"
    ],
    "malte": [
        "malter"
    ],
    "maltee": [
        "malter"
    ],
    "malus": [
        "malus"
    ],
    "malveillance": [
        "malveillance"
    ],
    "malveillances": [
        "malveillance"
    ],
    "malveillant": [
        "malveillant"
    ],
    "malveillante": [
        "malveillant"
    ],
    "malveillantes": [
        "malveillant"
    ],
    "malveillants": [
        "malveillant"
    ],
    "malvenu": [
        "malvenu"
    ],
    "malvenue": [
        "malvenu"
    ],
    "malvenus": [
        "malvenu"
    ],
    "malversation": [
        "malversation"
    ],
    "malversations": [
        "malversation"
    ],
    "malvoisie": [
        "malvoisie"
    ],
    "malvoisies": [
        "malvoisie"
    ],
    "malediction": [
        "malediction"
    ],
    "maledictions": [
        "malediction"
    ],
    "malefice": [
        "malefice"
    ],
    "malefices": [
        "malefice"
    ],
    "maleficier": [
        "maleficier"
    ],
    "maleficie": [
        "maleficie"
    ],
    "malefique": [
        "malefique"
    ],
    "malefiques": [
        "malefique"
    ],
    "mam": [
        "mam"
    ],
    "mam'selle": [
        "mam'selle"
    ],
    "mam'zelle": [
        "mam'zelle"
    ],
    "mamaliga": [
        "mamaliga"
    ],
    "mamamouchi": [
        "mamamouchi"
    ],
    "maman": [
        "maman"
    ],
    "mamans": [
        "maman"
    ],
    "mamba": [
        "mamba"
    ],
    "mambo": [
        "mambo"
    ],
    "mambos": [
        "mambo"
    ],
    "mame": [
        "mame"
    ],
    "mamelle": [
        "mamelle"
    ],
    "mamelles": [
        "mamelle"
    ],
    "mamelon": [
        "mamelon"
    ],
    "mamelonnee": [
        "mamelonne"
    ],
    "mamelons": [
        "mamelon"
    ],
    "mamelouk": [
        "mamelouk"
    ],
    "mamelouks": [
        "mamelouk"
    ],
    "mamelu": [
        "mamelu"
    ],
    "mamelue": [
        "mamelu"
    ],
    "mamelues": [
        "mamelu"
    ],
    "mameluk": [
        "mameluk"
    ],
    "mameluks": [
        "mameluk"
    ],
    "mamelus": [
        "mamelu"
    ],
    "mamie": [
        "mamie"
    ],
    "mamies": [
        "mamie"
    ],
    "mamma": [
        "mamma"
    ],
    "mammaire": [
        "mammaire"
    ],
    "mammaires": [
        "mammaire"
    ],
    "mammectomie": [
        "mammectomie"
    ],
    "mammifere": [
        "mammifere"
    ],
    "mammiferes": [
        "mammifere"
    ],
    "mammographie": [
        "mammographie"
    ],
    "mammoplastie": [
        "mammoplastie"
    ],
    "mammouth": [
        "mammouth"
    ],
    "mammouths": [
        "mammouth"
    ],
    "mammy": [
        "mammy"
    ],
    "mamours": [
        "mamours"
    ],
    "mamy": [
        "mamy"
    ],
    "mamys": [
        "mamy"
    ],
    "mamzelle": [
        "mamzelle"
    ],
    "man": [
        "man"
    ],
    "mana": [
        "mana"
    ],
    "manade": [
        "manade"
    ],
    "manades": [
        "manade"
    ],
    "manage": [
        "manager"
    ],
    "manageait": [
        "manager"
    ],
    "management": [
        "management"
    ],
    "manager": [
        "manager"
    ],
    "managerais": [
        "manager"
    ],
    "managers": [
        "manager"
    ],
    "manageur": [
        "manageur"
    ],
    "manant": [
        "manant"
    ],
    "manants": [
        "manant"
    ],
    "manceau": [
        "manceau"
    ],
    "mancenillier": [
        "mancenillier"
    ],
    "manche": [
        "manche"
    ],
    "mancheron": [
        "mancheron"
    ],
    "mancherons": [
        "mancheron"
    ],
    "manches": [
        "manche"
    ],
    "manchette": [
        "manchette"
    ],
    "manchettes": [
        "manchette"
    ],
    "manchon": [
        "manchon"
    ],
    "manchons": [
        "manchon"
    ],
    "manchot": [
        "manchot"
    ],
    "manchote": [
        "manchot"
    ],
    "manchotes": [
        "manchot"
    ],
    "manchots": [
        "manchot"
    ],
    "mandai": [
        "mander"
    ],
    "mandaient": [
        "mander"
    ],
    "mandait": [
        "mander"
    ],
    "mandala": [
        "mandala"
    ],
    "mandalas": [
        "mandala"
    ],
    "mandale": [
        "mandale"
    ],
    "mandales": [
        "mandale"
    ],
    "mandant": [
        "mandant"
    ],
    "mandants": [
        "mandant"
    ],
    "mandarin": [
        "mandarin"
    ],
    "mandarine": [
        "mandarine"
    ],
    "mandarines": [
        "mandarine"
    ],
    "mandarinier": [
        "mandarinier"
    ],
    "mandariniers": [
        "mandarinier"
    ],
    "mandarins": [
        "mandarin"
    ],
    "mandas": [
        "mander"
    ],
    "mandat": [
        "mandat"
    ],
    "mandataire": [
        "mandataire"
    ],
    "mandataires": [
        "mandataire"
    ],
    "mandatait": [
        "mandater"
    ],
    "mandatant": [
        "mandater"
    ],
    "mandatement": [
        "mandatement"
    ],
    "mandater": [
        "mandater"
    ],
    "mandatez": [
        "mandater"
    ],
    "mandats": [
        "mandat"
    ],
    "mandate": [
        "mandater"
    ],
    "mandatee": [
        "mandater"
    ],
    "mandates": [
        "mandater",
        "mandate"
    ],
    "mandchoue": [
        "mandchou"
    ],
    "mandchous": [
        "mandchou"
    ],
    "mande": [
        "mande",
        "mander"
    ],
    "mandement": [
        "mandement"
    ],
    "mandements": [
        "mandement"
    ],
    "mander": [
        "mander"
    ],
    "mandera": [
        "mander"
    ],
    "manderai": [
        "mander"
    ],
    "manderaient": [
        "mander"
    ],
    "manderais": [
        "mander"
    ],
    "mandes": [
        "mander"
    ],
    "mandez": [
        "mander"
    ],
    "mandibulaire": [
        "mandibulaire"
    ],
    "mandibule": [
        "mandibule"
    ],
    "mandibules": [
        "mandibule"
    ],
    "mandingue": [
        "mandingue"
    ],
    "mandingues": [
        "mandingue"
    ],
    "mandoline": [
        "mandoline"
    ],
    "mandolines": [
        "mandoline"
    ],
    "mandore": [
        "mandore"
    ],
    "mandorle": [
        "mandorle"
    ],
    "mandorles": [
        "mandorle"
    ],
    "mandragore": [
        "mandragore"
    ],
    "mandragores": [
        "mandragore"
    ],
    "mandrill": [
        "mandrill"
    ],
    "mandrin": [
        "mandrin"
    ],
    "mandrins": [
        "mandrin"
    ],
    "manducation": [
        "manducation"
    ],
    "manderent": [
        "mander"
    ],
    "mandee": [
        "mander"
    ],
    "manette": [
        "manette"
    ],
    "manettes": [
        "manette"
    ],
    "manga": [
        "manga"
    ],
    "manganite": [
        "manganite"
    ],
    "manganese": [
        "manganese"
    ],
    "mangas": [
        "manga"
    ],
    "mange": [
        "manger"
    ],
    "mangea": [
        "manger"
    ],
    "mangeable": [
        "mangeable"
    ],
    "mangeables": [
        "mangeable"
    ],
    "mangeai": [
        "manger"
    ],
    "mangeaient": [
        "manger"
    ],
    "mangeaille": [
        "mangeaille"
    ],
    "mangeailles": [
        "mangeaille"
    ],
    "mangeais": [
        "manger"
    ],
    "mangeait": [
        "manger"
    ],
    "mangeant": [
        "manger"
    ],
    "mangeas": [
        "manger"
    ],
    "mangeasse": [
        "manger"
    ],
    "mangent": [
        "manger"
    ],
    "mangeoire": [
        "mangeoire"
    ],
    "mangeoires": [
        "mangeoire"
    ],
    "mangeons": [
        "manger"
    ],
    "manger": [
        "manger"
    ],
    "mangera": [
        "manger"
    ],
    "mangerai": [
        "manger"
    ],
    "mangeraient": [
        "manger"
    ],
    "mangerais": [
        "manger"
    ],
    "mangerait": [
        "manger"
    ],
    "mangeras": [
        "manger"
    ],
    "mangerez": [
        "manger"
    ],
    "mangerie": [
        "mangerie"
    ],
    "mangeriez": [
        "manger"
    ],
    "mangerions": [
        "manger"
    ],
    "mangerons": [
        "manger"
    ],
    "mangeront": [
        "manger"
    ],
    "manges": [
        "manx",
        "manger"
    ],
    "mangetout": [
        "mangetout"
    ],
    "mangeur": [
        "mangeur"
    ],
    "mangeurs": [
        "mangeur"
    ],
    "mangeuse": [
        "mangeur"
    ],
    "mangeuses": [
        "mangeur"
    ],
    "mangez": [
        "manger"
    ],
    "mangeames": [
        "manger"
    ],
    "mangeat": [
        "manger"
    ],
    "mangiez": [
        "manger"
    ],
    "mangions": [
        "manger"
    ],
    "mango": [
        "mango"
    ],
    "mangonneaux": [
        "mangonneau"
    ],
    "mangouste": [
        "mangouste"
    ],
    "mangrove": [
        "mangrove"
    ],
    "mangroves": [
        "mangrove"
    ],
    "mangue": [
        "mangue"
    ],
    "mangues": [
        "mangue"
    ],
    "manguier": [
        "manguier"
    ],
    "manguiers": [
        "manguier"
    ],
    "mangerent": [
        "manger"
    ],
    "mangee": [
        "manger"
    ],
    "mangees": [
        "manger"
    ],
    "manhattan": [
        "manhattan"
    ],
    "mania": [
        "manier"
    ],
    "maniabilite": [
        "maniabilite"
    ],
    "maniable": [
        "maniable"
    ],
    "maniables": [
        "maniable"
    ],
    "maniacodepressif": [
        "maniacodepressif"
    ],
    "maniacodepressive": [
        "maniacodepressif"
    ],
    "maniaient": [
        "manier"
    ],
    "maniais": [
        "manier"
    ],
    "maniait": [
        "manier"
    ],
    "maniant": [
        "manier"
    ],
    "maniaque": [
        "maniaque"
    ],
    "maniaquement": [
        "maniaquement"
    ],
    "maniaquerie": [
        "maniaquerie"
    ],
    "maniaqueries": [
        "maniaquerie"
    ],
    "maniaques": [
        "maniaque"
    ],
    "manicheen": [
        "manicheen"
    ],
    "manicheisme": [
        "manicheisme"
    ],
    "manicheiste": [
        "manicheiste"
    ],
    "manie": [
        "manie",
        "manier"
    ],
    "maniement": [
        "maniement"
    ],
    "maniements": [
        "maniement"
    ],
    "manient": [
        "manier"
    ],
    "manier": [
        "manier"
    ],
    "manierais": [
        "manier"
    ],
    "manieront": [
        "manier"
    ],
    "manies": [
        "manie",
        "manier"
    ],
    "manieur": [
        "manieur"
    ],
    "manieurs": [
        "manieur"
    ],
    "manieuse": [
        "manieur"
    ],
    "maniez": [
        "manier"
    ],
    "manif": [
        "manif"
    ],
    "manifesta": [
        "manifester"
    ],
    "manifestai": [
        "manifester"
    ],
    "manifestaient": [
        "manifester"
    ],
    "manifestais": [
        "manifester"
    ],
    "manifestait": [
        "manifester"
    ],
    "manifestant": [
        "manifester",
        "manifestant"
    ],
    "manifestante": [
        "manifestant"
    ],
    "manifestantes": [
        "manifestant"
    ],
    "manifestants": [
        "manifestant"
    ],
    "manifestation": [
        "manifestation"
    ],
    "manifestations": [
        "manifestation"
    ],
    "manifeste": [
        "manifester",
        "manifeste"
    ],
    "manifestement": [
        "manifestement"
    ],
    "manifestent": [
        "manifester"
    ],
    "manifester": [
        "manifester"
    ],
    "manifestera": [
        "manifester"
    ],
    "manifesterai": [
        "manifester"
    ],
    "manifesteraient": [
        "manifester"
    ],
    "manifesterais": [
        "manifester"
    ],
    "manifesterait": [
        "manifester"
    ],
    "manifesteront": [
        "manifester"
    ],
    "manifestes": [
        "manifester",
        "manifeste"
    ],
    "manifestez": [
        "manifester"
    ],
    "manifestiez": [
        "manifester"
    ],
    "manifestions": [
        "manifester"
    ],
    "manifestons": [
        "manifester"
    ],
    "manifestat": [
        "manifester"
    ],
    "manifesterent": [
        "manifester"
    ],
    "manifestee": [
        "manifester"
    ],
    "manifestees": [
        "manifester"
    ],
    "manifold": [
        "manifold"
    ],
    "manifolds": [
        "manifold"
    ],
    "manifs": [
        "manif"
    ],
    "manigance": [
        "manigance",
        "manigancer"
    ],
    "manigancent": [
        "manigancer"
    ],
    "manigancer": [
        "manigancer"
    ],
    "manigancerait": [
        "manigancer"
    ],
    "manigances": [
        "manigance",
        "manigancer"
    ],
    "manigancez": [
        "manigancer"
    ],
    "maniganciez": [
        "manigancer"
    ],
    "manigancee": [
        "manigancer"
    ],
    "manigancaient": [
        "manigancer"
    ],
    "manigancais": [
        "manigancer"
    ],
    "manigancait": [
        "manigancer"
    ],
    "manilla": [
        "maniller"
    ],
    "manille": [
        "manille"
    ],
    "manilles": [
        "manille"
    ],
    "manilleurs": [
        "manilleur"
    ],
    "manillon": [
        "manillon"
    ],
    "manioc": [
        "manioc"
    ],
    "manip": [
        "manip"
    ],
    "manipe": [
        "manip"
    ],
    "manipula": [
        "manipuler"
    ],
    "manipulable": [
        "manipulable"
    ],
    "manipulables": [
        "manipulable"
    ],
    "manipulaient": [
        "manipuler"
    ],
    "manipulais": [
        "manipuler"
    ],
    "manipulait": [
        "manipuler"
    ],
    "manipulant": [
        "manipuler"
    ],
    "manipulateur": [
        "manipulateur"
    ],
    "manipulateurs": [
        "manipulateur"
    ],
    "manipulation": [
        "manipulation"
    ],
    "manipulations": [
        "manipulation"
    ],
    "manipulatrice": [
        "manipulateur"
    ],
    "manipulatrices": [
        "manipulateur"
    ],
    "manipule": [
        "manipule",
        "manipuler"
    ],
    "manipulent": [
        "manipuler"
    ],
    "manipuler": [
        "manipuler"
    ],
    "manipulera": [
        "manipuler"
    ],
    "manipulerai": [
        "manipuler"
    ],
    "manipulerait": [
        "manipuler"
    ],
    "manipuleras": [
        "manipuler"
    ],
    "manipules": [
        "manipule",
        "manipuler"
    ],
    "manipulez": [
        "manipuler"
    ],
    "manipulons": [
        "manipuler"
    ],
    "manipulee": [
        "manipuler"
    ],
    "manipulees": [
        "manipuler"
    ],
    "manitoba": [
        "manitoba"
    ],
    "manitou": [
        "manitou"
    ],
    "manitous": [
        "manitou"
    ],
    "manivelle": [
        "manivelle"
    ],
    "manivelles": [
        "manivelle"
    ],
    "maniere": [
        "maniere",
        "manierer"
    ],
    "manierent": [
        "manier"
    ],
    "manieres": [
        "maniere",
        "manierer"
    ],
    "maniee": [
        "manier"
    ],
    "maniees": [
        "manier"
    ],
    "manierisme": [
        "manierisme"
    ],
    "manierismes": [
        "manierisme"
    ],
    "manieriste": [
        "manieriste"
    ],
    "manieristes": [
        "manieriste"
    ],
    "manieree": [
        "maniere"
    ],
    "manierees": [
        "maniere",
        "manierer"
    ],
    "manne": [
        "manne"
    ],
    "mannequin": [
        "mannequin"
    ],
    "mannequine": [
        "mannequiner"
    ],
    "mannequins": [
        "mannequin"
    ],
    "mannes": [
        "manne"
    ],
    "mannezingue": [
        "mannezingue"
    ],
    "mannitol": [
        "mannitol"
    ],
    "manoeuvra": [
        "manoeuvrer"
    ],
    "manoeuvrabilite": [
        "manoeuvrabilite"
    ],
    "manoeuvrable": [
        "manoeuvrable"
    ],
    "manoeuvraient": [
        "manoeuvrer"
    ],
    "manoeuvrais": [
        "manoeuvrer"
    ],
    "manoeuvrait": [
        "manoeuvrer"
    ],
    "manoeuvrant": [
        "manoeuvrer"
    ],
    "manoeuvre": [
        "manoeuvre",
        "manoeuvrer"
    ],
    "manoeuvrent": [
        "manoeuvrer"
    ],
    "manoeuvrer": [
        "manoeuvrer"
    ],
    "manoeuvres": [
        "manoeuvre",
        "manoeuvrer"
    ],
    "manoeuvrez": [
        "manoeuvrer"
    ],
    "manoeuvrier": [
        "manoeuvrier"
    ],
    "manoeuvriers": [
        "manoeuvrier"
    ],
    "manoeuvriere": [
        "manoeuvrier"
    ],
    "manoeuvrieres": [
        "manoeuvrier"
    ],
    "manoeuvrons": [
        "manoeuvrer"
    ],
    "manoeuvrerent": [
        "manoeuvrer"
    ],
    "manoeuvree": [
        "manoeuvrer"
    ],
    "manoeuvrees": [
        "manoeuvrer"
    ],
    "manoir": [
        "manoir"
    ],
    "manoirs": [
        "manoir"
    ],
    "manometre": [
        "manometre"
    ],
    "manometres": [
        "manometre"
    ],
    "manouche": [
        "manouche"
    ],
    "manouches": [
        "manouche"
    ],
    "manouvrier": [
        "manouvrier"
    ],
    "manqua": [
        "manquer"
    ],
    "manquai": [
        "manquer"
    ],
    "manquaient": [
        "manquer"
    ],
    "manquais": [
        "manquer"
    ],
    "manquait": [
        "manquer"
    ],
    "manquant": [
        "manquer",
        "manquant"
    ],
    "manquante": [
        "manquant"
    ],
    "manquantes": [
        "manquant"
    ],
    "manquants": [
        "manquant"
    ],
    "manquassent": [
        "manquer"
    ],
    "manque": [
        "manque",
        "manquer"
    ],
    "manquement": [
        "manquement"
    ],
    "manquements": [
        "manquement"
    ],
    "manquent": [
        "manquer"
    ],
    "manquer": [
        "manquer"
    ],
    "manquera": [
        "manquer"
    ],
    "manquerai": [
        "manquer"
    ],
    "manqueraient": [
        "manquer"
    ],
    "manquerais": [
        "manquer"
    ],
    "manquerait": [
        "manquer"
    ],
    "manqueras": [
        "manquer"
    ],
    "manquerez": [
        "manquer"
    ],
    "manqueriez": [
        "manquer"
    ],
    "manquerions": [
        "manquer"
    ],
    "manquerons": [
        "manquer"
    ],
    "manqueront": [
        "manquer"
    ],
    "manques": [
        "manque",
        "manquer"
    ],
    "manquez": [
        "manquer"
    ],
    "manquiez": [
        "manquer"
    ],
    "manquions": [
        "manquer"
    ],
    "manquons": [
        "manquer"
    ],
    "manquames": [
        "manquer"
    ],
    "manquat": [
        "manquer"
    ],
    "manquerent": [
        "manquer"
    ],
    "manquee": [
        "manque",
        "manquer"
    ],
    "manquees": [
        "manque",
        "manquer"
    ],
    "mansard": [
        "mansard"
    ],
    "mansarde": [
        "mansarde",
        "mansarder"
    ],
    "mansardes": [
        "mansarde"
    ],
    "mansardee": [
        "mansarde",
        "mansarder"
    ],
    "mansardees": [
        "mansarde",
        "mansarder"
    ],
    "mansion": [
        "mansion"
    ],
    "mansions": [
        "mansion"
    ],
    "mansuetude": [
        "mansuetude"
    ],
    "mansuetudes": [
        "mansuetude"
    ],
    "manta": [
        "manta"
    ],
    "mante": [
        "mante"
    ],
    "manteau": [
        "manteau"
    ],
    "manteaux": [
        "manteau"
    ],
    "mantelet": [
        "mantelet"
    ],
    "mantelets": [
        "mantelet"
    ],
    "mantelure": [
        "mantelure"
    ],
    "mantes": [
        "mante"
    ],
    "mantille": [
        "mantille"
    ],
    "mantilles": [
        "mantille"
    ],
    "mantique": [
        "mantique"
    ],
    "mantra": [
        "mantra"
    ],
    "manubrium": [
        "manubrium"
    ],
    "manucure": [
        "manucurer",
        "manucure"
    ],
    "manucurer": [
        "manucurer"
    ],
    "manucures": [
        "manucurer",
        "manucure"
    ],
    "manucuree": [
        "manucurer"
    ],
    "manucurees": [
        "manucurer"
    ],
    "manuel": [
        "manuel"
    ],
    "manuelle": [
        "manuel"
    ],
    "manuellement": [
        "manuellement"
    ],
    "manuelles": [
        "manuel"
    ],
    "manuels": [
        "manuel"
    ],
    "manufacture": [
        "manufacturer",
        "manufacture"
    ],
    "manufacturer": [
        "manufacturer"
    ],
    "manufactures": [
        "manufacturer",
        "manufacture"
    ],
    "manufacturiers": [
        "manufacturier"
    ],
    "manufacturons": [
        "manufacturer"
    ],
    "manufacturee": [
        "manufacturer"
    ],
    "manufacturees": [
        "manufacturer"
    ],
    "manuscrit": [
        "manuscrit"
    ],
    "manuscrite": [
        "manuscrit"
    ],
    "manuscrites": [
        "manuscrit"
    ],
    "manuscrits": [
        "manuscrit"
    ],
    "manutention": [
        "manutention"
    ],
    "manutentionnaire": [
        "manutentionnaire"
    ],
    "manutentionnaires": [
        "manutentionnaire"
    ],
    "manutentionner": [
        "manutentionner"
    ],
    "manutentions": [
        "manutention"
    ],
    "manuelin": [
        "manuelin"
    ],
    "manzanilla": [
        "manzanilla"
    ],
    "manege": [
        "manege"
    ],
    "maneges": [
        "maneger",
        "manege"
    ],
    "manecanterie": [
        "manecanterie"
    ],
    "mao": [
        "mao"
    ],
    "maori": [
        "maori"
    ],
    "maorie": [
        "maori"
    ],
    "maos": [
        "mao"
    ],
    "maous": [
        "maous"
    ],
    "maousse": [
        "maousse"
    ],
    "maoisme": [
        "maoisme"
    ],
    "maoiste": [
        "maoiste"
    ],
    "mappemonde": [
        "mappemonde"
    ],
    "mappemondes": [
        "mappemonde"
    ],
    "maquaient": [
        "maquer"
    ],
    "maque": [
        "maque",
        "maquer"
    ],
    "maquent": [
        "maquer"
    ],
    "maquer": [
        "maquer"
    ],
    "maquereau": [
        "maquereau"
    ],
    "maquereautage": [
        "maquereautage"
    ],
    "maquereauter": [
        "maquereauter"
    ],
    "maquereautins": [
        "maquereautin"
    ],
    "maquereaux": [
        "maquereau"
    ],
    "maquerellage": [
        "maquerellage"
    ],
    "maquerelle": [
        "maquereau"
    ],
    "maquerelles": [
        "maquereau"
    ],
    "maques": [
        "maque",
        "maquer"
    ],
    "maquette": [
        "maquette"
    ],
    "maquettes": [
        "maquette"
    ],
    "maquettiste": [
        "maquettiste"
    ],
    "maquettistes": [
        "maquettiste"
    ],
    "maquignon": [
        "maquignon"
    ],
    "maquignonnage": [
        "maquignonnage"
    ],
    "maquignonnages": [
        "maquignonnage"
    ],
    "maquignonne": [
        "maquignonner"
    ],
    "maquignonnes": [
        "maquignonner"
    ],
    "maquignons": [
        "maquignon"
    ],
    "maquilla": [
        "maquiller"
    ],
    "maquillage": [
        "maquillage"
    ],
    "maquillages": [
        "maquillage"
    ],
    "maquillai": [
        "maquiller"
    ],
    "maquillais": [
        "maquiller"
    ],
    "maquillait": [
        "maquiller"
    ],
    "maquillant": [
        "maquiller"
    ],
    "maquille": [
        "maquiller"
    ],
    "maquillent": [
        "maquiller"
    ],
    "maquiller": [
        "maquiller"
    ],
    "maquillerai": [
        "maquiller"
    ],
    "maquillerais": [
        "maquiller"
    ],
    "maquilleras": [
        "maquiller"
    ],
    "maquilles": [
        "maquiller"
    ],
    "maquilleur": [
        "maquilleur"
    ],
    "maquilleurs": [
        "maquilleur"
    ],
    "maquilleuse": [
        "maquilleur"
    ],
    "maquilleuses": [
        "maquilleur"
    ],
    "maquillez": [
        "maquiller"
    ],
    "maquilliez": [
        "maquiller"
    ],
    "maquillons": [
        "maquiller"
    ],
    "maquillee": [
        "maquiller"
    ],
    "maquillees": [
        "maquiller"
    ],
    "maquis": [
        "maquis"
    ],
    "maquisard": [
        "maquisard"
    ],
    "maquisarde": [
        "maquisard"
    ],
    "maquisardes": [
        "maquisard"
    ],
    "maquisards": [
        "maquisard"
    ],
    "maquee": [
        "maquer"
    ],
    "mara": [
        "mara"
    ],
    "marabout": [
        "marabout"
    ],
    "marabouts": [
        "marabout"
    ],
    "maracas": [
        "maraca"
    ],
    "marae": [
        "marae"
    ],
    "marais": [
        "marais"
    ],
    "maranta": [
        "maranta"
    ],
    "marante": [
        "marante"
    ],
    "marasme": [
        "marasme"
    ],
    "marasmes": [
        "marasme"
    ],
    "marasquin": [
        "marasquin"
    ],
    "marathon": [
        "marathon"
    ],
    "marathonien": [
        "marathonien"
    ],
    "marathonienne": [
        "marathonien"
    ],
    "marathons": [
        "marathon"
    ],
    "maraud": [
        "maraud"
    ],
    "maraudaient": [
        "marauder"
    ],
    "maraudait": [
        "marauder"
    ],
    "maraude": [
        "marauder",
        "maraud"
    ],
    "marauder": [
        "marauder"
    ],
    "maraudes": [
        "marauder",
        "maraud"
    ],
    "maraudeur": [
        "maraudeur"
    ],
    "maraudeurs": [
        "maraudeur"
    ],
    "maraudeuse": [
        "maraudeur"
    ],
    "marauds": [
        "maraud"
    ],
    "maravedis": [
        "maravedis"
    ],
    "maraicher": [
        "maraicher"
    ],
    "maraichers": [
        "maraicher"
    ],
    "maraichere": [
        "maraicher"
    ],
    "maraicheres": [
        "maraicher"
    ],
    "marbra": [
        "marbrer"
    ],
    "marbraient": [
        "marbrer"
    ],
    "marbrait": [
        "marbrer"
    ],
    "marbre": [
        "marbrer",
        "marbre"
    ],
    "marbrent": [
        "marbrer"
    ],
    "marbrerie": [
        "marbrerie"
    ],
    "marbreries": [
        "marbrerie"
    ],
    "marbres": [
        "marbrer",
        "marbre"
    ],
    "marbrier": [
        "marbrier"
    ],
    "marbrure": [
        "marbrure"
    ],
    "marbrures": [
        "marbrure"
    ],
    "marbree": [
        "marbrer",
        "marbre"
    ],
    "marbrees": [
        "marbrer",
        "marbre"
    ],
    "marc": [
        "marc"
    ],
    "marcassin": [
        "marcassin"
    ],
    "marcassins": [
        "marcassin"
    ],
    "marcel": [
        "marcel"
    ],
    "marceline": [
        "marceline"
    ],
    "marcha": [
        "marcher"
    ],
    "marchai": [
        "marcher"
    ],
    "marchaient": [
        "marcher"
    ],
    "marchais": [
        "marcher"
    ],
    "marchait": [
        "marcher"
    ],
    "marchand": [
        "marchand"
    ],
    "marchandage": [
        "marchandage"
    ],
    "marchandages": [
        "marchandage"
    ],
    "marchandaient": [
        "marchander"
    ],
    "marchandais": [
        "marchander"
    ],
    "marchandait": [
        "marchander"
    ],
    "marchandant": [
        "marchander"
    ],
    "marchande": [
        "marchand",
        "marchander"
    ],
    "marchandent": [
        "marchander"
    ],
    "marchander": [
        "marchander"
    ],
    "marchandera": [
        "marchander"
    ],
    "marchanderais": [
        "marchander"
    ],
    "marchanderez": [
        "marchander"
    ],
    "marchandes": [
        "marchand",
        "marchander"
    ],
    "marchandeuse": [
        "marchandeur"
    ],
    "marchandez": [
        "marchander"
    ],
    "marchandise": [
        "marchandise"
    ],
    "marchandises": [
        "marchandise"
    ],
    "marchandiseur": [
        "marchandiseur"
    ],
    "marchandons": [
        "marchander"
    ],
    "marchands": [
        "marchand"
    ],
    "marchandee": [
        "marchander"
    ],
    "marchant": [
        "marchant",
        "marcher"
    ],
    "marchante": [
        "marchant"
    ],
    "marchantes": [
        "marchant"
    ],
    "marche": [
        "marche",
        "marcher"
    ],
    "marchent": [
        "marcher"
    ],
    "marchepied": [
        "marchepied"
    ],
    "marchepieds": [
        "marchepied"
    ],
    "marcher": [
        "marcher"
    ],
    "marchera": [
        "marcher"
    ],
    "marcherai": [
        "marcher"
    ],
    "marcheraient": [
        "marcher"
    ],
    "marcherais": [
        "marcher"
    ],
    "marcherait": [
        "marcher"
    ],
    "marcheras": [
        "marcher"
    ],
    "marcherez": [
        "marcher"
    ],
    "marcheriez": [
        "marcher"
    ],
    "marcherions": [
        "marcher"
    ],
    "marcherons": [
        "marcher"
    ],
    "marcheront": [
        "marcher"
    ],
    "marches": [
        "march",
        "marche",
        "marcher"
    ],
    "marcheur": [
        "marcheur"
    ],
    "marcheurs": [
        "marcheur"
    ],
    "marcheuse": [
        "marcheur"
    ],
    "marcheuses": [
        "marcheur"
    ],
    "marchez": [
        "marcher"
    ],
    "marchiez": [
        "marcher"
    ],
    "marchions": [
        "marcher"
    ],
    "marchons": [
        "marcher"
    ],
    "marchames": [
        "marcher"
    ],
    "marchat": [
        "marcher"
    ],
    "marcherent": [
        "marcher"
    ],
    "marchees": [
        "marcher"
    ],
    "marconi": [
        "marconi"
    ],
    "marcotin": [
        "marcotin"
    ],
    "marcotte": [
        "marcotte"
    ],
    "marcs": [
        "marc"
    ],
    "mardi": [
        "mardi"
    ],
    "mardis": [
        "mardi"
    ],
    "mare": [
        "mare",
        "mar"
    ],
    "marelle": [
        "marelle"
    ],
    "marelles": [
        "marelle"
    ],
    "marengo": [
        "marengo"
    ],
    "marennes": [
        "marennes"
    ],
    "mares": [
        "mare"
    ],
    "mareyeur": [
        "mareyeur"
    ],
    "mareyeurs": [
        "mareyeur"
    ],
    "mareyeuse": [
        "mareyeur"
    ],
    "mareyeuses": [
        "mareyeur"
    ],
    "margarine": [
        "margarine"
    ],
    "margaux": [
        "margaux"
    ],
    "margay": [
        "margay"
    ],
    "marge": [
        "marge"
    ],
    "margeait": [
        "marger"
    ],
    "margelle": [
        "margelle"
    ],
    "margelles": [
        "margelle"
    ],
    "marger": [
        "marger"
    ],
    "marges": [
        "marge"
    ],
    "margeuse": [
        "margeur"
    ],
    "margina": [
        "marginer"
    ],
    "marginal": [
        "marginal"
    ],
    "marginale": [
        "marginal"
    ],
    "marginalement": [
        "marginalement"
    ],
    "marginales": [
        "marginal"
    ],
    "marginalisant": [
        "marginaliser"
    ],
    "marginaliser": [
        "marginaliser"
    ],
    "marginaliseraient": [
        "marginaliser"
    ],
    "marginalise": [
        "marginaliser"
    ],
    "marginalisee": [
        "marginaliser"
    ],
    "marginalises": [
        "marginaliser"
    ],
    "marginalite": [
        "marginalite"
    ],
    "marginaux": [
        "marginal"
    ],
    "marginee": [
        "marginer"
    ],
    "margis": [
        "margis"
    ],
    "margot": [
        "margot"
    ],
    "margotait": [
        "margoter"
    ],
    "margotin": [
        "margotin"
    ],
    "margotins": [
        "margotin"
    ],
    "margoton": [
        "margoton"
    ],
    "margotte": [
        "margotter"
    ],
    "margottons": [
        "margotter"
    ],
    "margouillat": [
        "margouillat"
    ],
    "margouillats": [
        "margouillat"
    ],
    "margouillis": [
        "margouillis"
    ],
    "margoulette": [
        "margoulette"
    ],
    "margoulin": [
        "margoulin"
    ],
    "margoulins": [
        "margoulin"
    ],
    "margrave": [
        "margrave"
    ],
    "margraviat": [
        "margraviat"
    ],
    "marguerite": [
        "marguerite"
    ],
    "marguerites": [
        "marguerite"
    ],
    "marguillier": [
        "marguillier"
    ],
    "marguilliers": [
        "marguillier"
    ],
    "mari": [
        "mari"
    ],
    "maria": [
        "marier"
    ],
    "mariable": [
        "mariable"
    ],
    "mariachi": [
        "mariachi"
    ],
    "mariachis": [
        "mariachi"
    ],
    "mariage": [
        "mariage"
    ],
    "mariages": [
        "mariage"
    ],
    "mariai": [
        "marier"
    ],
    "mariaient": [
        "marier"
    ],
    "mariais": [
        "marier"
    ],
    "mariait": [
        "marier"
    ],
    "mariales": [
        "marial"
    ],
    "marianne": [
        "marian"
    ],
    "mariant": [
        "marier"
    ],
    "marias": [
        "maria",
        "marier"
    ],
    "mariassent": [
        "marier"
    ],
    "marida": [
        "marida"
    ],
    "maridas": [
        "marida"
    ],
    "marie": [
        "marie",
        "marier"
    ],
    "marient": [
        "marier"
    ],
    "marier": [
        "marier"
    ],
    "mariera": [
        "marier"
    ],
    "marierai": [
        "marier"
    ],
    "marieraient": [
        "marier"
    ],
    "marierais": [
        "marier"
    ],
    "marierait": [
        "marier"
    ],
    "marieras": [
        "marier"
    ],
    "marierez": [
        "marier"
    ],
    "marieriez": [
        "marier"
    ],
    "marierions": [
        "marier"
    ],
    "marierons": [
        "marier"
    ],
    "marieront": [
        "marier"
    ],
    "maries": [
        "mary",
        "marie",
        "marier"
    ],
    "marieur": [
        "marieur"
    ],
    "marieuse": [
        "marieur"
    ],
    "marieuses": [
        "marieur"
    ],
    "mariez": [
        "marier"
    ],
    "marigot": [
        "marigot"
    ],
    "marigots": [
        "marigot"
    ],
    "marihuana": [
        "marihuana"
    ],
    "mariions": [
        "marier"
    ],
    "marijuana": [
        "marijuana"
    ],
    "marimba": [
        "marimba"
    ],
    "marin": [
        "marin"
    ],
    "marina": [
        "marina",
        "mariner"
    ],
    "marinade": [
        "marinade"
    ],
    "marinades": [
        "marinade"
    ],
    "marinage": [
        "marinage"
    ],
    "marinaient": [
        "mariner"
    ],
    "marinait": [
        "mariner"
    ],
    "marinant": [
        "mariner"
    ],
    "marinas": [
        "marina"
    ],
    "marine": [
        "marine",
        "mariner"
    ],
    "mariner": [
        "mariner"
    ],
    "marinera": [
        "mariner"
    ],
    "marines": [
        "marine",
        "mariner"
    ],
    "maringoins": [
        "maringoin"
    ],
    "marinier": [
        "marinier"
    ],
    "mariniers": [
        "marinier"
    ],
    "mariniere": [
        "mariniere"
    ],
    "marinieres": [
        "mariniere"
    ],
    "marins": [
        "marin"
    ],
    "marinee": [
        "mariner"
    ],
    "marinees": [
        "marine",
        "mariner"
    ],
    "mariol": [
        "mariol"
    ],
    "mariole": [
        "mariole"
    ],
    "marioles": [
        "mariole"
    ],
    "mariolle": [
        "mariolle"
    ],
    "mariolles": [
        "mariolle"
    ],
    "marionnette": [
        "marionnette"
    ],
    "marionnettes": [
        "marionnette"
    ],
    "marionnettiste": [
        "marionnettiste"
    ],
    "marions": [
        "marier"
    ],
    "maris": [
        "mari"
    ],
    "maristes": [
        "mariste"
    ],
    "marital": [
        "marital"
    ],
    "maritale": [
        "marital"
    ],
    "maritalement": [
        "maritalement"
    ],
    "maritales": [
        "marital"
    ],
    "maritaux": [
        "marital"
    ],
    "maritime": [
        "maritime"
    ],
    "maritimes": [
        "maritime"
    ],
    "maritorne": [
        "maritorne"
    ],
    "marivaudage": [
        "marivaudage"
    ],
    "marivaudages": [
        "marivaudage"
    ],
    "marivaudant": [
        "marivauder"
    ],
    "marivauder": [
        "marivauder"
    ],
    "mariat": [
        "marier"
    ],
    "marierent": [
        "marier"
    ],
    "mariee": [
        "marie",
        "marier"
    ],
    "mariees": [
        "marie",
        "marier"
    ],
    "marjolaine": [
        "marjolaine"
    ],
    "mark": [
        "mark"
    ],
    "marker": [
        "marker"
    ],
    "marketing": [
        "market",
        "markete",
        "marketing"
    ],
    "marketings": [
        "marketing"
    ],
    "marks": [
        "mark"
    ],
    "marle": [
        "marle"
    ],
    "marles": [
        "marle"
    ],
    "marlin": [
        "marlin"
    ],
    "marlou": [
        "marlou"
    ],
    "marloupin": [
        "marloupin"
    ],
    "marloupinerie": [
        "marloupinerie"
    ],
    "marloupineries": [
        "marloupinerie"
    ],
    "marloupins": [
        "marloupin"
    ],
    "marlous": [
        "marlou"
    ],
    "marmaille": [
        "marmaille"
    ],
    "marmailles": [
        "marmaille"
    ],
    "marmelade": [
        "marmelade"
    ],
    "marmelades": [
        "marmelade"
    ],
    "marmitage": [
        "marmitage"
    ],
    "marmitages": [
        "marmitage"
    ],
    "marmite": [
        "marmite"
    ],
    "marmiter": [
        "marmiter"
    ],
    "marmites": [
        "marmiter",
        "marmite"
    ],
    "marmiteuse": [
        "marmiteux"
    ],
    "marmiteux": [
        "marmiteux"
    ],
    "marmiton": [
        "marmiton"
    ],
    "marmitons": [
        "marmiton"
    ],
    "marmitees": [
        "marmitee"
    ],
    "marmonna": [
        "marmonner"
    ],
    "marmonnaient": [
        "marmonner"
    ],
    "marmonnait": [
        "marmonner"
    ],
    "marmonnant": [
        "marmonner"
    ],
    "marmonne": [
        "marmonner"
    ],
    "marmonnement": [
        "marmonnement"
    ],
    "marmonnements": [
        "marmonnement"
    ],
    "marmonnent": [
        "marmonner"
    ],
    "marmonner": [
        "marmonner"
    ],
    "marmonnes": [
        "marmonner"
    ],
    "marmonnez": [
        "marmonner"
    ],
    "marmonniez": [
        "marmonner"
    ],
    "marmonnee": [
        "marmonner"
    ],
    "marmoreen": [
        "marmoreen"
    ],
    "marmoreenne": [
        "marmoreen"
    ],
    "marmoreens": [
        "marmoreen"
    ],
    "marmot": [
        "marmot"
    ],
    "marmots": [
        "marmot"
    ],
    "marmotta": [
        "marmotter"
    ],
    "marmottages": [
        "marmottage"
    ],
    "marmottait": [
        "marmotter"
    ],
    "marmottant": [
        "marmotter"
    ],
    "marmotte": [
        "marmotter",
        "marmotte"
    ],
    "marmottement": [
        "marmottement"
    ],
    "marmotter": [
        "marmotter"
    ],
    "marmottes": [
        "marmotter",
        "marmotte"
    ],
    "marmouset": [
        "marmouset"
    ],
    "marmousets": [
        "marmouset"
    ],
    "marna": [
        "marner"
    ],
    "marnaise": [
        "marnais"
    ],
    "marnait": [
        "marner"
    ],
    "marne": [
        "marner",
        "marne"
    ],
    "marnent": [
        "marner"
    ],
    "marner": [
        "marner"
    ],
    "marnes": [
        "marne"
    ],
    "marneuse": [
        "marneux"
    ],
    "marnieres": [
        "marniere"
    ],
    "marocain": [
        "marocain"
    ],
    "marocaine": [
        "marocain"
    ],
    "marocaines": [
        "marocain"
    ],
    "marocains": [
        "marocain"
    ],
    "maronite": [
        "maronite"
    ],
    "maronites": [
        "maronite"
    ],
    "maronner": [
        "maronner"
    ],
    "maronne": [
        "maronner"
    ],
    "maroquin": [
        "maroquin"
    ],
    "maroquinerie": [
        "maroquinerie"
    ],
    "maroquineries": [
        "maroquinerie"
    ],
    "maroquinier": [
        "maroquinier"
    ],
    "maroquiniers": [
        "maroquinier"
    ],
    "maroquins": [
        "maroquin"
    ],
    "marotte": [
        "marotte"
    ],
    "marottes": [
        "marotte"
    ],
    "marouette": [
        "marouette"
    ],
    "maroufle": [
        "maroufle"
    ],
    "maroufler": [
        "maroufler"
    ],
    "maroufles": [
        "maroufle"
    ],
    "marqua": [
        "marquer"
    ],
    "marquage": [
        "marquage"
    ],
    "marquai": [
        "marquer"
    ],
    "marquaient": [
        "marquer"
    ],
    "marquais": [
        "marquer"
    ],
    "marquait": [
        "marquer"
    ],
    "marquant": [
        "marquer",
        "marquant"
    ],
    "marquante": [
        "marquant"
    ],
    "marquantes": [
        "marquant"
    ],
    "marquants": [
        "marquant"
    ],
    "marque": [
        "marquer",
        "marque"
    ],
    "marquent": [
        "marquer"
    ],
    "marquer": [
        "marquer"
    ],
    "marquera": [
        "marquer"
    ],
    "marquerai": [
        "marquer"
    ],
    "marqueraient": [
        "marquer"
    ],
    "marquerait": [
        "marquer"
    ],
    "marqueras": [
        "marquer"
    ],
    "marquerez": [
        "marquer"
    ],
    "marquerons": [
        "marquer"
    ],
    "marqueront": [
        "marquer"
    ],
    "marques": [
        "marquer",
        "marque"
    ],
    "marqueterie": [
        "marqueterie"
    ],
    "marqueteries": [
        "marqueterie"
    ],
    "marquette": [
        "marqueter"
    ],
    "marquete": [
        "marqueter"
    ],
    "marquetees": [
        "marqueter"
    ],
    "marquetes": [
        "marqueter"
    ],
    "marqueur": [
        "marqueur"
    ],
    "marqueurs": [
        "marqueur"
    ],
    "marquez": [
        "marquer"
    ],
    "marquiez": [
        "marquer"
    ],
    "marquions": [
        "marquer"
    ],
    "marquis": [
        "marquis"
    ],
    "marquisat": [
        "marquisat"
    ],
    "marquisats": [
        "marquisat"
    ],
    "marquise": [
        "marquis"
    ],
    "marquises": [
        "marquis"
    ],
    "marquisien": [
        "marquisien"
    ],
    "marquisiens": [
        "marquisien"
    ],
    "marquons": [
        "marquer"
    ],
    "marquat": [
        "marquer"
    ],
    "marquerent": [
        "marquer"
    ],
    "marquee": [
        "marquer",
        "marque"
    ],
    "marquees": [
        "marquer",
        "marquee",
        "marque"
    ],
    "marra": [
        "marrer"
    ],
    "marrade": [
        "marrade"
    ],
    "marraient": [
        "marrer"
    ],
    "marraine": [
        "marraine"
    ],
    "marraines": [
        "marraine"
    ],
    "marrais": [
        "marrer"
    ],
    "marrait": [
        "marrer"
    ],
    "marrane": [
        "marrane"
    ],
    "marranes": [
        "marrane"
    ],
    "marrant": [
        "marrer",
        "marrant"
    ],
    "marrante": [
        "marrant"
    ],
    "marrantes": [
        "marrant"
    ],
    "marrants": [
        "marrant"
    ],
    "marre": [
        "marrer",
        "marre"
    ],
    "marrent": [
        "marrer"
    ],
    "marrer": [
        "marrer"
    ],
    "marrera": [
        "marrer"
    ],
    "marrerais": [
        "marrer"
    ],
    "marrerait": [
        "marrer"
    ],
    "marres": [
        "marrer"
    ],
    "marrez": [
        "marrer"
    ],
    "marri": [
        "marri"
    ],
    "marrie": [
        "marri"
    ],
    "marrions": [
        "marrer"
    ],
    "marris": [
        "marri"
    ],
    "marron": [
        "marron"
    ],
    "marronnais": [
        "marronner"
    ],
    "marronnasse": [
        "marronnasse"
    ],
    "marronner": [
        "marronner"
    ],
    "marronnera": [
        "marronner"
    ],
    "marronnier": [
        "marronnier"
    ],
    "marronniers": [
        "marronnier"
    ],
    "marronne": [
        "marronner"
    ],
    "marrons": [
        "marron",
        "marrer"
    ],
    "marree": [
        "marrer"
    ],
    "mars": [
        "mars",
        "mar"
    ],
    "marsala": [
        "marsala"
    ],
    "marsaules": [
        "marsaule"
    ],
    "marseillais": [
        "marseillais"
    ],
    "marseillaise": [
        "marseillais"
    ],
    "marseillaises": [
        "marseillais"
    ],
    "marshal": [
        "marshal"
    ],
    "marshals": [
        "marshal"
    ],
    "marsouin": [
        "marsouin"
    ],
    "marsouins": [
        "marsouin"
    ],
    "marsupial": [
        "marsupial"
    ],
    "marsupiaux": [
        "marsupial"
    ],
    "marsupilami": [
        "marsupilami"
    ],
    "marsupilamis": [
        "marsupilami"
    ],
    "martagon": [
        "martagon"
    ],
    "marteau": [
        "marteau"
    ],
    "marteaux": [
        "marteau"
    ],
    "martel": [
        "martel"
    ],
    "martela": [
        "marteler"
    ],
    "martelage": [
        "martelage"
    ],
    "martelai": [
        "marteler"
    ],
    "martelaient": [
        "marteler"
    ],
    "martelait": [
        "marteler"
    ],
    "martelant": [
        "marteler"
    ],
    "marteler": [
        "marteler"
    ],
    "martelet": [
        "martelet"
    ],
    "marteleur": [
        "marteleur"
    ],
    "martelez": [
        "marteler"
    ],
    "martels": [
        "martel"
    ],
    "martelerent": [
        "marteler"
    ],
    "martele": [
        "marteler"
    ],
    "martelee": [
        "marteler"
    ],
    "martelees": [
        "marteler"
    ],
    "marteles": [
        "marteler"
    ],
    "martial": [
        "martial"
    ],
    "martiale": [
        "martial"
    ],
    "martiales": [
        "martial"
    ],
    "martialites": [
        "martialite"
    ],
    "martiaux": [
        "martial"
    ],
    "martien": [
        "martien"
    ],
    "martienne": [
        "martien",
        "martienne"
    ],
    "martiennes": [
        "martien",
        "martienne"
    ],
    "martiens": [
        "martien"
    ],
    "martin": [
        "martin"
    ],
    "martine": [
        "martiner"
    ],
    "martinet": [
        "martinet"
    ],
    "martinets": [
        "martinet"
    ],
    "martinez": [
        "martiner"
    ],
    "martingale": [
        "martingale"
    ],
    "martingales": [
        "martingale"
    ],
    "martini": [
        "martini"
    ],
    "martiniquais": [
        "martiniquais"
    ],
    "martiniquaise": [
        "martiniquais"
    ],
    "martiniquaises": [
        "martiniquais"
    ],
    "martinis": [
        "martini"
    ],
    "martins": [
        "martin"
    ],
    "martre": [
        "martre"
    ],
    "martres": [
        "martre"
    ],
    "martyr": [
        "martyr"
    ],
    "martyre": [
        "martyr",
        "martyre"
    ],
    "martyres": [
        "martyr",
        "martyre"
    ],
    "martyrisaient": [
        "martyriser"
    ],
    "martyrisait": [
        "martyriser"
    ],
    "martyrisant": [
        "martyriser"
    ],
    "martyrise": [
        "martyriser"
    ],
    "martyrisent": [
        "martyriser"
    ],
    "martyriser": [
        "martyriser"
    ],
    "martyriserait": [
        "martyriser"
    ],
    "martyrisee": [
        "martyriser"
    ],
    "martyrisees": [
        "martyriser"
    ],
    "martyrises": [
        "martyriser"
    ],
    "martyrologe": [
        "martyrologe"
    ],
    "martyrologes": [
        "martyrologe"
    ],
    "martyrs": [
        "martyr"
    ],
    "martelement": [
        "martelement"
    ],
    "martelements": [
        "martelement"
    ],
    "martelent": [
        "marteler"
    ],
    "martelera": [
        "marteler"
    ],
    "marxisme": [
        "marxisme"
    ],
    "marxiste": [
        "marxiste"
    ],
    "marxistes": [
        "marxiste"
    ],
    "mary": [
        "mary"
    ],
    "maryland": [
        "maryland"
    ],
    "maratre": [
        "maratre"
    ],
    "maratres": [
        "maratre"
    ],
    "marecage": [
        "marecage"
    ],
    "marecages": [
        "marecage"
    ],
    "marecageuse": [
        "marecageux"
    ],
    "marecageuses": [
        "marecageux"
    ],
    "marecageux": [
        "marecageux"
    ],
    "marechal": [
        "marechal"
    ],
    "marechalat": [
        "marechalat"
    ],
    "marechale": [
        "marechal"
    ],
    "marechalerie": [
        "marechalerie"
    ],
    "marechalistes": [
        "marechaliste"
    ],
    "marechaussee": [
        "marechaussee"
    ],
    "marechaux": [
        "marechal"
    ],
    "maree": [
        "maree"
    ],
    "marees": [
        "maree"
    ],
    "maremotrice": [
        "maremoteur"
    ],
    "mas": [
        "mas"
    ],
    "masai": [
        "masai"
    ],
    "mascara": [
        "mascara"
    ],
    "mascarade": [
        "mascarade"
    ],
    "mascarades": [
        "mascarade"
    ],
    "mascaret": [
        "mascaret"
    ],
    "mascaron": [
        "mascaron"
    ],
    "mascarons": [
        "mascaron"
    ],
    "mascarpone": [
        "mascarpone"
    ],
    "mascotte": [
        "mascotte"
    ],
    "mascottes": [
        "mascotte"
    ],
    "masculin": [
        "masculin"
    ],
    "masculine": [
        "masculin"
    ],
    "masculines": [
        "masculin",
        "masculine"
    ],
    "masculiniser": [
        "masculiniser"
    ],
    "masculinisee": [
        "masculiniser"
    ],
    "masculinite": [
        "masculinite"
    ],
    "masculins": [
        "masculin"
    ],
    "maser": [
        "maser"
    ],
    "maskinonge": [
        "maskinonge"
    ],
    "maso": [
        "maso"
    ],
    "masochisme": [
        "masochisme"
    ],
    "masochiste": [
        "masochiste"
    ],
    "masochistes": [
        "masochiste"
    ],
    "masos": [
        "maso"
    ],
    "masqua": [
        "masquer"
    ],
    "masquage": [
        "masquage"
    ],
    "masquages": [
        "masquage"
    ],
    "masquaient": [
        "masquer"
    ],
    "masquait": [
        "masquer"
    ],
    "masquant": [
        "masquer"
    ],
    "masque": [
        "masque",
        "masquer"
    ],
    "masquent": [
        "masquer"
    ],
    "masquer": [
        "masquer"
    ],
    "masqueraient": [
        "masquer"
    ],
    "masques": [
        "masque",
        "masquer"
    ],
    "masquons": [
        "masquer"
    ],
    "masquee": [
        "masque",
        "masquer"
    ],
    "masquees": [
        "masque",
        "masquer"
    ],
    "massa": [
        "masser"
    ],
    "massacra": [
        "massacrer"
    ],
    "massacraient": [
        "massacrer"
    ],
    "massacrais": [
        "massacrer"
    ],
    "massacrait": [
        "massacrer"
    ],
    "massacrant": [
        "massacrant",
        "massacrer"
    ],
    "massacrante": [
        "massacrant"
    ],
    "massacre": [
        "massacre",
        "massacrer"
    ],
    "massacrent": [
        "massacrer"
    ],
    "massacrer": [
        "massacrer"
    ],
    "massacrera": [
        "massacrer"
    ],
    "massacrerai": [
        "massacrer"
    ],
    "massacreraient": [
        "massacrer"
    ],
    "massacrerait": [
        "massacrer"
    ],
    "massacrerons": [
        "massacrer"
    ],
    "massacreront": [
        "massacrer"
    ],
    "massacres": [
        "massacre",
        "massacrer"
    ],
    "massacreur": [
        "massacreur"
    ],
    "massacreurs": [
        "massacreur"
    ],
    "massacrez": [
        "massacrer"
    ],
    "massacrons": [
        "massacrer"
    ],
    "massacrat": [
        "massacrer"
    ],
    "massacrerent": [
        "massacrer"
    ],
    "massacree": [
        "massacrer"
    ],
    "massacrees": [
        "massacrer"
    ],
    "massage": [
        "massage"
    ],
    "massages": [
        "massage"
    ],
    "massaient": [
        "masser"
    ],
    "massais": [
        "masser"
    ],
    "massait": [
        "masser"
    ],
    "massant": [
        "masser"
    ],
    "masse": [
        "masser",
        "masse"
    ],
    "massent": [
        "masser"
    ],
    "massepain": [
        "massepain"
    ],
    "massepains": [
        "massepain"
    ],
    "masser": [
        "masser"
    ],
    "massera": [
        "masser"
    ],
    "masserai": [
        "masser"
    ],
    "masseraient": [
        "masser"
    ],
    "masserais": [
        "masser"
    ],
    "masseras": [
        "masser"
    ],
    "masserez": [
        "masser"
    ],
    "masses": [
        "masser",
        "masse",
        "mass"
    ],
    "massettes": [
        "massette"
    ],
    "masseur": [
        "masseur"
    ],
    "masseurs": [
        "masseur"
    ],
    "masseuse": [
        "masseur"
    ],
    "masseuses": [
        "masseur"
    ],
    "massez": [
        "masser"
    ],
    "massicot": [
        "massicot"
    ],
    "massicoter": [
        "massicoter"
    ],
    "massicotier": [
        "massicotier"
    ],
    "massicots": [
        "massicot"
    ],
    "massicote": [
        "massicoter"
    ],
    "massif": [
        "massif"
    ],
    "massifs": [
        "massif"
    ],
    "massive": [
        "massif"
    ],
    "massivement": [
        "massivement"
    ],
    "massives": [
        "massif"
    ],
    "massivite": [
        "massivite"
    ],
    "massue": [
        "massue"
    ],
    "massues": [
        "massue"
    ],
    "masserent": [
        "masser"
    ],
    "massee": [
        "masser"
    ],
    "massees": [
        "masser"
    ],
    "mastaba": [
        "mastaba"
    ],
    "mastabas": [
        "mastaba"
    ],
    "mastar": [
        "mastar"
    ],
    "mastard": [
        "mastard"
    ],
    "mastards": [
        "mastard"
    ],
    "mastectomie": [
        "mastectomie"
    ],
    "master": [
        "master"
    ],
    "masters": [
        "master"
    ],
    "mastic": [
        "mastic"
    ],
    "masticage": [
        "masticage"
    ],
    "masticateurs": [
        "masticateur"
    ],
    "mastication": [
        "mastication"
    ],
    "mastications": [
        "mastication"
    ],
    "mastiff": [
        "mastiff"
    ],
    "mastiqua": [
        "mastiquer"
    ],
    "mastiquaient": [
        "mastiquer"
    ],
    "mastiquais": [
        "mastiquer"
    ],
    "mastiquait": [
        "mastiquer"
    ],
    "mastiquant": [
        "mastiquer"
    ],
    "mastique": [
        "mastiquer"
    ],
    "mastiquent": [
        "mastiquer"
    ],
    "mastiquer": [
        "mastiquer"
    ],
    "mastiquez": [
        "mastiquer"
    ],
    "mastiquons": [
        "mastiquer"
    ],
    "mastiques": [
        "mastiquer"
    ],
    "mastite": [
        "mastite"
    ],
    "mastoc": [
        "mastoc"
    ],
    "mastodonte": [
        "mastodonte"
    ],
    "mastodontes": [
        "mastodonte"
    ],
    "mastoide": [
        "mastoide"
    ],
    "mastroquet": [
        "mastroquet"
    ],
    "mastroquets": [
        "mastroquet"
    ],
    "masturbais": [
        "masturber"
    ],
    "masturbait": [
        "masturber"
    ],
    "masturbant": [
        "masturber"
    ],
    "masturbateur": [
        "masturbateur"
    ],
    "masturbation": [
        "masturbation"
    ],
    "masturbations": [
        "masturbation"
    ],
    "masturbatoire": [
        "masturbatoire"
    ],
    "masturbatoires": [
        "masturbatoire"
    ],
    "masturbe": [
        "masturber"
    ],
    "masturbent": [
        "masturber"
    ],
    "masturber": [
        "masturber"
    ],
    "masturberas": [
        "masturber"
    ],
    "masturbez": [
        "masturber"
    ],
    "masturbee": [
        "masturber"
    ],
    "masturbes": [
        "masturber"
    ],
    "mastere": [
        "mastere"
    ],
    "masure": [
        "masure"
    ],
    "masures": [
        "masure"
    ],
    "mat": [
        "mat"
    ],
    "mat'": [
        "mat"
    ],
    "mata": [
        "mater"
    ],
    "matador": [
        "matador"
    ],
    "matadors": [
        "matador"
    ],
    "mataf": [
        "mataf"
    ],
    "matafs": [
        "mataf"
    ],
    "mataient": [
        "mater"
    ],
    "matais": [
        "mater"
    ],
    "matait": [
        "mater"
    ],
    "matamore": [
        "matamore"
    ],
    "matamores": [
        "matamore"
    ],
    "matant": [
        "mater"
    ],
    "match": [
        "match"
    ],
    "matcha": [
        "matcher"
    ],
    "matche": [
        "matcher"
    ],
    "matches": [
        "matche",
        "match"
    ],
    "matchiche": [
        "matchiche"
    ],
    "matchs": [
        "match"
    ],
    "mate": [
        "mate",
        "mater",
        "mat"
    ],
    "matelas": [
        "matelas"
    ],
    "matelassent": [
        "matelasser"
    ],
    "matelasser": [
        "matelasser"
    ],
    "matelassier": [
        "matelassier"
    ],
    "matelassiers": [
        "matelassier"
    ],
    "matelassiere": [
        "matelassier"
    ],
    "matelassieres": [
        "matelassier"
    ],
    "matelasse": [
        "matelasse",
        "matelasser"
    ],
    "matelassee": [
        "matelasse",
        "matelasser"
    ],
    "matelassees": [
        "matelasser"
    ],
    "matelasses": [
        "matelasser"
    ],
    "matelot": [
        "matelot"
    ],
    "matelote": [
        "matelote"
    ],
    "matelots": [
        "matelot"
    ],
    "matent": [
        "mater"
    ],
    "mater": [
        "mater"
    ],
    "matera": [
        "mater"
    ],
    "materai": [
        "mater"
    ],
    "materais": [
        "mater"
    ],
    "materait": [
        "mater"
    ],
    "maternage": [
        "maternage"
    ],
    "maternalisme": [
        "maternalisme"
    ],
    "maternant": [
        "materner"
    ],
    "maternel": [
        "maternel"
    ],
    "maternelle": [
        "maternel"
    ],
    "maternellement": [
        "maternellement"
    ],
    "maternelles": [
        "maternel"
    ],
    "maternels": [
        "maternel"
    ],
    "materner": [
        "materner"
    ],
    "maternera": [
        "materner"
    ],
    "materniser": [
        "materniser"
    ],
    "maternise": [
        "materniser"
    ],
    "maternite": [
        "maternite"
    ],
    "maternites": [
        "maternite"
    ],
    "materne": [
        "materner"
    ],
    "materons": [
        "mater"
    ],
    "materont": [
        "mater"
    ],
    "mates": [
        "mate",
        "mater",
        "mat"
    ],
    "mateur": [
        "mateur"
    ],
    "mateurs": [
        "mateur"
    ],
    "mateuse": [
        "mateur"
    ],
    "matez": [
        "mater"
    ],
    "math": [
        "math"
    ],
    "matheuse": [
        "matheux"
    ],
    "matheux": [
        "matheux"
    ],
    "maths": [
        "maths"
    ],
    "mathurins": [
        "mathurin"
    ],
    "mathusalems": [
        "mathusalem"
    ],
    "mathematicien": [
        "mathematicien"
    ],
    "mathematicienne": [
        "mathematicien"
    ],
    "mathematiciens": [
        "mathematicien"
    ],
    "mathematique": [
        "mathematique"
    ],
    "mathematiquement": [
        "mathematiquement"
    ],
    "mathematiques": [
        "mathematique"
    ],
    "mathematiser": [
        "mathematiser"
    ],
    "mati": [
        "mati",
        "matir"
    ],
    "matiez": [
        "mater"
    ],
    "matin": [
        "matin"
    ],
    "matinal": [
        "matinal"
    ],
    "matinale": [
        "matinal"
    ],
    "matinalement": [
        "matinalement"
    ],
    "matinales": [
        "matinal"
    ],
    "matinaux": [
        "matinal"
    ],
    "matines": [
        "matiner",
        "matine"
    ],
    "matineux": [
        "matineux"
    ],
    "matins": [
        "matin"
    ],
    "matinee": [
        "matiner",
        "matinee"
    ],
    "matinees": [
        "matinee"
    ],
    "matis": [
        "matir"
    ],
    "matisse": [
        "matir"
    ],
    "matite": [
        "matite"
    ],
    "matiere": [
        "matiere"
    ],
    "matieres": [
        "matiere"
    ],
    "matois": [
        "matois"
    ],
    "matoise": [
        "matois"
    ],
    "matoiserie": [
        "matoiserie"
    ],
    "maton": [
        "maton"
    ],
    "matonne": [
        "maton"
    ],
    "matonnes": [
        "maton"
    ],
    "matons": [
        "mater",
        "maton"
    ],
    "matos": [
        "matos"
    ],
    "matou": [
        "matou"
    ],
    "matous": [
        "matou"
    ],
    "matouse": [
        "matouser"
    ],
    "matouser": [
        "matouser"
    ],
    "matraqua": [
        "matraquer"
    ],
    "matraquage": [
        "matraquage"
    ],
    "matraquages": [
        "matraquage"
    ],
    "matraquaient": [
        "matraquer"
    ],
    "matraquais": [
        "matraquer"
    ],
    "matraquait": [
        "matraquer"
    ],
    "matraquant": [
        "matraquer"
    ],
    "matraque": [
        "matraque",
        "matraquer"
    ],
    "matraquer": [
        "matraquer"
    ],
    "matraques": [
        "matraque",
        "matraquer"
    ],
    "matraqueur": [
        "matraqueur"
    ],
    "matraqueurs": [
        "matraqueur"
    ],
    "matraquez": [
        "matraquer"
    ],
    "matraquee": [
        "matraquer"
    ],
    "matras": [
        "matras"
    ],
    "matriarcal": [
        "matriarcal"
    ],
    "matriarcale": [
        "matriarcal"
    ],
    "matriarcales": [
        "matriarcal"
    ],
    "matriarcat": [
        "matriarcat"
    ],
    "matriarche": [
        "matriarche"
    ],
    "matrice": [
        "matrice"
    ],
    "matrices": [
        "matrix",
        "matrice"
    ],
    "matricide": [
        "matricide"
    ],
    "matriciel": [
        "matriciel"
    ],
    "matricielle": [
        "matriciel"
    ],
    "matricielles": [
        "matriciel"
    ],
    "matriciels": [
        "matriciel"
    ],
    "matriculaire": [
        "matriculaire"
    ],
    "matricule": [
        "matricule"
    ],
    "matricules": [
        "matricule"
    ],
    "matrilineaire": [
        "matrilineaire"
    ],
    "matrilineaires": [
        "matrilineaire"
    ],
    "matrilocales": [
        "matrilocal"
    ],
    "matrimonial": [
        "matrimonial"
    ],
    "matrimoniale": [
        "matrimonial"
    ],
    "matrimoniales": [
        "matrimonial"
    ],
    "matrimoniaux": [
        "matrimonial"
    ],
    "matriochka": [
        "matriochka"
    ],
    "matrone": [
        "matrone"
    ],
    "matrones": [
        "matrone"
    ],
    "mats": [
        "mat"
    ],
    "matte": [
        "matte"
    ],
    "matter": [
        "matter"
    ],
    "mattes": [
        "matte"
    ],
    "matuche": [
        "matuche"
    ],
    "maturation": [
        "maturation"
    ],
    "maturations": [
        "maturation"
    ],
    "mature": [
        "mature"
    ],
    "maturer": [
        "mature",
        "maturer"
    ],
    "matures": [
        "mature"
    ],
    "maturite": [
        "maturite"
    ],
    "matutinal": [
        "matutinal"
    ],
    "matutinale": [
        "matutinal"
    ],
    "matutinales": [
        "matutinal"
    ],
    "matutinaux": [
        "matutinal"
    ],
    "materent": [
        "mater"
    ],
    "matee": [
        "mater"
    ],
    "matees": [
        "mater"
    ],
    "materialisa": [
        "materialiser"
    ],
    "materialisaient": [
        "materialiser"
    ],
    "materialisait": [
        "materialiser"
    ],
    "materialisant": [
        "materialiser"
    ],
    "materialisation": [
        "materialisation"
    ],
    "materialisations": [
        "materialisation"
    ],
    "materialise": [
        "materialiser"
    ],
    "materialisent": [
        "materialiser"
    ],
    "materialiser": [
        "materialiser"
    ],
    "materialisera": [
        "materialiser"
    ],
    "materialiseront": [
        "materialiser"
    ],
    "materialisions": [
        "materialiser"
    ],
    "materialisme": [
        "materialisme"
    ],
    "materialiste": [
        "materialiste"
    ],
    "materialistes": [
        "materialiste"
    ],
    "materialiserent": [
        "materialiser"
    ],
    "materialisee": [
        "materialiser"
    ],
    "materialisees": [
        "materialiser"
    ],
    "materialises": [
        "materialiser",
        "materialise"
    ],
    "materialite": [
        "materialite"
    ],
    "materiau": [
        "materiau"
    ],
    "materiaux": [
        "materiau"
    ],
    "materiel": [
        "materiel"
    ],
    "materielle": [
        "materiel"
    ],
    "materiellement": [
        "materiellement"
    ],
    "materielles": [
        "materiel"
    ],
    "materiels": [
        "materiel"
    ],
    "maudira": [
        "maudire"
    ],
    "maudirai": [
        "maudire"
    ],
    "maudirais": [
        "maudire"
    ],
    "maudirait": [
        "maudire"
    ],
    "maudire": [
        "maudire"
    ],
    "maudirent": [
        "maudire"
    ],
    "maudirons": [
        "maudire"
    ],
    "maudiront": [
        "maudire"
    ],
    "maudis": [
        "maudire"
    ],
    "maudissaient": [
        "maudire"
    ],
    "maudissais": [
        "maudire"
    ],
    "maudissait": [
        "maudire"
    ],
    "maudissant": [
        "maudire"
    ],
    "maudisse": [
        "maudire"
    ],
    "maudissent": [
        "maudire"
    ],
    "maudissez": [
        "maudire"
    ],
    "maudissions": [
        "maudire"
    ],
    "maudit": [
        "maudire",
        "maudit"
    ],
    "maudite": [
        "maudit"
    ],
    "maudites": [
        "maudit"
    ],
    "maudits": [
        "maudit"
    ],
    "maugrea": [
        "maugreer"
    ],
    "maugreai": [
        "maugreer"
    ],
    "maugreaient": [
        "maugreer"
    ],
    "maugreait": [
        "maugreer"
    ],
    "maugreant": [
        "maugreer"
    ],
    "maugree": [
        "maugreer"
    ],
    "maugreer": [
        "maugreer"
    ],
    "maure": [
        "maure"
    ],
    "maures": [
        "maure"
    ],
    "mauresque": [
        "mauresque"
    ],
    "mauresques": [
        "mauresque"
    ],
    "mauricienne": [
        "mauricien"
    ],
    "mauritanienne": [
        "mauritanien"
    ],
    "maurrassien": [
        "maurrassien"
    ],
    "maurrassisme": [
        "maurrassisme"
    ],
    "mauser": [
        "mauser"
    ],
    "mausers": [
        "mauser"
    ],
    "mausolee": [
        "mausolee"
    ],
    "mausolees": [
        "mausolee"
    ],
    "maussade": [
        "maussade"
    ],
    "maussadement": [
        "maussadement"
    ],
    "maussaderie": [
        "maussaderie"
    ],
    "maussaderies": [
        "maussaderie"
    ],
    "maussades": [
        "maussade"
    ],
    "mauvais": [
        "mauvais"
    ],
    "mauvaise": [
        "mauvais"
    ],
    "mauvaisement": [
        "mauvaisement"
    ],
    "mauvaises": [
        "mauvais"
    ],
    "mauvaisete": [
        "mauvaisete"
    ],
    "mauve": [
        "mauve"
    ],
    "mauves": [
        "mauve"
    ],
    "mauviette": [
        "mauviette"
    ],
    "mauviettes": [
        "mauviette"
    ],
    "maux": [
        "mal"
    ],
    "max": [
        "max"
    ],
    "maxi": [
        "maxi"
    ],
    "maxillaire": [
        "maxillaire"
    ],
    "maxillaires": [
        "maxillaire"
    ],
    "maxima": [
        "maximum"
    ],
    "maximal": [
        "maximal"
    ],
    "maximale": [
        "maximal"
    ],
    "maximales": [
        "maximal"
    ],
    "maximalise": [
        "maximaliser"
    ],
    "maximaliser": [
        "maximaliser"
    ],
    "maximalisme": [
        "maximalisme"
    ],
    "maxime": [
        "maxime"
    ],
    "maximes": [
        "maxime"
    ],
    "maximisation": [
        "maximisation"
    ],
    "maximiser": [
        "maximiser"
    ],
    "maximum": [
        "maximum"
    ],
    "maximums": [
        "maximum"
    ],
    "maxis": [
        "maxi"
    ],
    "maxiton": [
        "maxiton"
    ],
    "maya": [
        "maya"
    ],
    "mayas": [
        "maya"
    ],
    "mayo": [
        "mayo"
    ],
    "mayonnaise": [
        "mayonnaise"
    ],
    "mayonnaises": [
        "mayonnaise"
    ],
    "mazagran": [
        "mazagran"
    ],
    "mazagrans": [
        "mazagran"
    ],
    "mazas": [
        "mazer"
    ],
    "mazdeens": [
        "mazdeen"
    ],
    "maze": [
        "mazer"
    ],
    "mazet": [
        "mazet"
    ],
    "mazette": [
        "mazette"
    ],
    "mazettes": [
        "mazette"
    ],
    "mazout": [
        "mazout"
    ],
    "mazoute": [
        "mazouter"
    ],
    "mazoutes": [
        "mazoute"
    ],
    "mazurka": [
        "mazurka"
    ],
    "mazurkas": [
        "mazurka"
    ],
    "macon": [
        "macon"
    ],
    "maconnant": [
        "maconner"
    ],
    "maconne": [
        "maconner",
        "macon"
    ],
    "maconnent": [
        "maconner"
    ],
    "maconner": [
        "maconner"
    ],
    "maconnerie": [
        "maconnerie"
    ],
    "maconneries": [
        "maconnerie"
    ],
    "maconnique": [
        "maconnique"
    ],
    "maconniques": [
        "maconnique"
    ],
    "maconnee": [
        "maconner"
    ],
    "maconnees": [
        "maconner"
    ],
    "maconnes": [
        "maconner"
    ],
    "macons": [
        "macon"
    ],
    "maitre": [
        "maitre"
    ],
    "maitres": [
        "maitre"
    ],
    "maitresse": [
        "maitre",
        "maitresse"
    ],
    "maitresses": [
        "maitre",
        "maitresse"
    ],
    "maitrisa": [
        "maitriser"
    ],
    "maitrisable": [
        "maitrisable"
    ],
    "maitrisables": [
        "maitrisable"
    ],
    "maitrisaient": [
        "maitriser"
    ],
    "maitrisais": [
        "maitriser"
    ],
    "maitrisait": [
        "maitriser"
    ],
    "maitrisant": [
        "maitriser"
    ],
    "maitrise": [
        "maitriser",
        "maitrise"
    ],
    "maitrisent": [
        "maitriser"
    ],
    "maitriser": [
        "maitriser"
    ],
    "maitrisera": [
        "maitriser"
    ],
    "maitriserai": [
        "maitriser"
    ],
    "maitriseraient": [
        "maitriser"
    ],
    "maitriserait": [
        "maitriser"
    ],
    "maitriseras": [
        "maitriser"
    ],
    "maitriserez": [
        "maitriser"
    ],
    "maitriseriez": [
        "maitriser"
    ],
    "maitriserons": [
        "maitriser"
    ],
    "maitriseront": [
        "maitriser"
    ],
    "maitrises": [
        "maitriser",
        "maitrise"
    ],
    "maitrisez": [
        "maitriser"
    ],
    "maitrisiez": [
        "maitriser"
    ],
    "maitrisions": [
        "maitriser"
    ],
    "maitrisons": [
        "maitriser"
    ],
    "maitriserent": [
        "maitriser"
    ],
    "maitrisee": [
        "maitriser",
        "maitrise"
    ],
    "maitrisees": [
        "maitriser",
        "maitrise"
    ],
    "maia": [
        "maia"
    ],
    "maizena": [
        "maizena"
    ],
    "me": [
        "me",
        "i"
    ],
    "mec": [
        "mec"
    ],
    "meccano": [
        "meccano"
    ],
    "meccanos": [
        "meccano"
    ],
    "mechta": [
        "mechta"
    ],
    "mechtas": [
        "mechta"
    ],
    "mecklembourgeois": [
        "mecklembourgeois"
    ],
    "mecs": [
        "mec"
    ],
    "mecton": [
        "mecton"
    ],
    "mectons": [
        "mecton"
    ],
    "media": [
        "media",
        "medium"
    ],
    "medium": [
        "medium"
    ],
    "meeting": [
        "meet",
        "meeting"
    ],
    "meetings": [
        "meeting"
    ],
    "meiji": [
        "meiji"
    ],
    "meilleur": [
        "meilleur"
    ],
    "meilleure": [
        "meilleur"
    ],
    "meilleures": [
        "meilleur"
    ],
    "meilleurs": [
        "meilleur"
    ],
    "melba": [
        "melba"
    ],
    "melkites": [
        "melkite"
    ],
    "melliflues": [
        "melliflue"
    ],
    "mellifere": [
        "mellifere"
    ],
    "melliferes": [
        "mellifere"
    ],
    "melon": [
        "melon"
    ],
    "melons": [
        "melon",
        "meler"
    ],
    "membranaire": [
        "membranaire"
    ],
    "membrane": [
        "membrane"
    ],
    "membranes": [
        "membrane"
    ],
    "membraneuse": [
        "membraneux"
    ],
    "membraneuses": [
        "membraneux"
    ],
    "membraneux": [
        "membraneux"
    ],
    "membre": [
        "membre",
        "membrer"
    ],
    "membres": [
        "membre"
    ],
    "membrues": [
        "membru"
    ],
    "membrure": [
        "membrure"
    ],
    "membrures": [
        "membrure"
    ],
    "mena": [
        "mener"
    ],
    "menace": [
        "menace",
        "menacer"
    ],
    "menacent": [
        "menacer"
    ],
    "menacer": [
        "menacer"
    ],
    "menacera": [
        "menacer"
    ],
    "menaceraient": [
        "menacer"
    ],
    "menacerait": [
        "menacer"
    ],
    "menaceras": [
        "menacer"
    ],
    "menaceriez": [
        "menacer"
    ],
    "menaceront": [
        "menacer"
    ],
    "menaces": [
        "menace",
        "menacer"
    ],
    "menacez": [
        "menacer"
    ],
    "menaciez": [
        "menacer"
    ],
    "menacions": [
        "menacer"
    ],
    "menacerent": [
        "menacer"
    ],
    "menacee": [
        "menace",
        "menacer"
    ],
    "menacees": [
        "menace",
        "menacer"
    ],
    "menai": [
        "mener"
    ],
    "menaient": [
        "mener"
    ],
    "menais": [
        "mener"
    ],
    "menait": [
        "mener"
    ],
    "menant": [
        "mener"
    ],
    "menassent": [
        "mener"
    ],
    "menaca": [
        "menacer"
    ],
    "menacaient": [
        "menacer"
    ],
    "menacais": [
        "menacer"
    ],
    "menacait": [
        "menacer"
    ],
    "menacant": [
        "menacer",
        "menacant"
    ],
    "menacante": [
        "menacant"
    ],
    "menacantes": [
        "menacant"
    ],
    "menacants": [
        "menacant"
    ],
    "menacons": [
        "menacer"
    ],
    "menacat": [
        "menacer"
    ],
    "mencheviks": [
        "menchevik"
    ],
    "mendia": [
        "mendier"
    ],
    "mendiaient": [
        "mendier"
    ],
    "mendiais": [
        "mendier"
    ],
    "mendiait": [
        "mendier"
    ],
    "mendiant": [
        "mendier",
        "mendiant"
    ],
    "mendiante": [
        "mendiant"
    ],
    "mendiantes": [
        "mendiant"
    ],
    "mendiants": [
        "mendiant"
    ],
    "mendicite": [
        "mendicite"
    ],
    "mendicites": [
        "mendicite"
    ],
    "mendie": [
        "mendier"
    ],
    "mendient": [
        "mendier"
    ],
    "mendier": [
        "mendier"
    ],
    "mendierait": [
        "mendier"
    ],
    "mendieras": [
        "mendier"
    ],
    "mendies": [
        "mendier"
    ],
    "mendiez": [
        "mendier"
    ],
    "mendigot": [
        "mendigot"
    ],
    "mendigotant": [
        "mendigoter"
    ],
    "mendigote": [
        "mendigot"
    ],
    "mendigoter": [
        "mendigoter"
    ],
    "mendigots": [
        "mendigot"
    ],
    "mendions": [
        "mendier"
    ],
    "mendiee": [
        "mendier"
    ],
    "mendiees": [
        "mendier"
    ],
    "mende": [
        "mende"
    ],
    "meneau": [
        "meneau"
    ],
    "meneaux": [
        "meneau"
    ],
    "mener": [
        "mener"
    ],
    "meneur": [
        "meneur"
    ],
    "meneurs": [
        "meneur"
    ],
    "meneuse": [
        "meneur"
    ],
    "menez": [
        "menez",
        "mener"
    ],
    "menhaden": [
        "menhaden"
    ],
    "menhir": [
        "menhir"
    ],
    "menhirs": [
        "menhir"
    ],
    "meniez": [
        "mener"
    ],
    "menions": [
        "mener"
    ],
    "mennonite": [
        "mennonite"
    ],
    "mennonites": [
        "mennonite"
    ],
    "menon": [
        "menon"
    ],
    "menons": [
        "menon",
        "mener"
    ],
    "menora": [
        "menora"
    ],
    "menotte": [
        "menotte",
        "menotter"
    ],
    "menotter": [
        "menotter"
    ],
    "menottes": [
        "menotte",
        "menotter"
    ],
    "menottez": [
        "menotter"
    ],
    "menottee": [
        "menotter"
    ],
    "mens": [
        "mens",
        "men",
        "mentir"
    ],
    "mensonge": [
        "mensonge"
    ],
    "mensonger": [
        "mensonger"
    ],
    "mensongers": [
        "mensonger"
    ],
    "mensonges": [
        "mensonge"
    ],
    "mensongere": [
        "mensonger"
    ],
    "mensongerement": [
        "mensongerement"
    ],
    "mensongeres": [
        "mensonger"
    ],
    "menstruation": [
        "menstruation"
    ],
    "menstruations": [
        "menstruation"
    ],
    "menstruel": [
        "menstruel"
    ],
    "menstruelle": [
        "menstruel"
    ],
    "menstruelles": [
        "menstruel"
    ],
    "menstruels": [
        "menstruel"
    ],
    "menstrues": [
        "menstrues"
    ],
    "mensualite": [
        "mensualite"
    ],
    "mensualites": [
        "mensualite"
    ],
    "mensuel": [
        "mensuel"
    ],
    "mensuelle": [
        "mensuel"
    ],
    "mensuellement": [
        "mensuellement"
    ],
    "mensuelles": [
        "mensuel"
    ],
    "mensuels": [
        "mensuel"
    ],
    "mensuration": [
        "mensuration"
    ],
    "mensurations": [
        "mensuration"
    ],
    "ment": [
        "mentir"
    ],
    "mentaient": [
        "mentir"
    ],
    "mentais": [
        "mentir"
    ],
    "mentait": [
        "mentir"
    ],
    "mental": [
        "mental"
    ],
    "mentale": [
        "mental"
    ],
    "mentalement": [
        "mentalement"
    ],
    "mentales": [
        "mental"
    ],
    "mentaliser": [
        "mentaliser"
    ],
    "mentalite": [
        "mentalite"
    ],
    "mentalites": [
        "mentalite"
    ],
    "mentant": [
        "mentir"
    ],
    "mentaux": [
        "mental"
    ],
    "mente": [
        "mentir"
    ],
    "mentent": [
        "mentir"
    ],
    "menterie": [
        "menterie"
    ],
    "menteries": [
        "menterie"
    ],
    "mentes": [
        "mentir"
    ],
    "menteur": [
        "menteur"
    ],
    "menteurs": [
        "menteur"
    ],
    "menteuse": [
        "menteur"
    ],
    "menteuses": [
        "menteur"
    ],
    "mentez": [
        "mentir",
        "mentez"
    ],
    "menthe": [
        "menthe"
    ],
    "menthes": [
        "menthe"
    ],
    "menthol": [
        "menthol"
    ],
    "menthols": [
        "menthol"
    ],
    "menthole": [
        "menthole"
    ],
    "mentholee": [
        "menthole"
    ],
    "mentholees": [
        "menthole"
    ],
    "mentholes": [
        "menthole"
    ],
    "menti": [
        "mentir"
    ],
    "mentiez": [
        "mentir"
    ],
    "mention": [
        "mention"
    ],
    "mentionna": [
        "mentionner"
    ],
    "mentionnai": [
        "mentionner"
    ],
    "mentionnaient": [
        "mentionner"
    ],
    "mentionnais": [
        "mentionner"
    ],
    "mentionnait": [
        "mentionner"
    ],
    "mentionnant": [
        "mentionner"
    ],
    "mentionne": [
        "mentionner"
    ],
    "mentionnent": [
        "mentionner"
    ],
    "mentionner": [
        "mentionner"
    ],
    "mentionnerai": [
        "mentionner"
    ],
    "mentionnerais": [
        "mentionner"
    ],
    "mentionnerait": [
        "mentionner"
    ],
    "mentionneras": [
        "mentionner"
    ],
    "mentionnerez": [
        "mentionner"
    ],
    "mentionnes": [
        "mentionner"
    ],
    "mentionnez": [
        "mentionner"
    ],
    "mentionniez": [
        "mentionner"
    ],
    "mentionnons": [
        "mentionner"
    ],
    "mentionnat": [
        "mentionner"
    ],
    "mentionnee": [
        "mentionner"
    ],
    "mentionnees": [
        "mentionner"
    ],
    "mentions": [
        "mentir",
        "mention"
    ],
    "mentir": [
        "mentir"
    ],
    "mentira": [
        "mentir"
    ],
    "mentirai": [
        "mentir"
    ],
    "mentiraient": [
        "mentir"
    ],
    "mentirais": [
        "mentir"
    ],
    "mentirait": [
        "mentir"
    ],
    "mentiras": [
        "mentir"
    ],
    "mentirez": [
        "mentir"
    ],
    "mentiriez": [
        "mentir"
    ],
    "mentirons": [
        "mentir"
    ],
    "mentiront": [
        "mentir"
    ],
    "mentis": [
        "mentir"
    ],
    "mentissent": [
        "mentir"
    ],
    "mentit": [
        "mentir"
    ],
    "menton": [
        "menton"
    ],
    "mentonnet": [
        "mentonnet"
    ],
    "mentonnier": [
        "mentonnier"
    ],
    "mentonniere": [
        "mentonnier"
    ],
    "mentons": [
        "mentir",
        "menton"
    ],
    "mentor": [
        "mentor"
    ],
    "mentors": [
        "mentor"
    ],
    "mentule": [
        "mentule"
    ],
    "menu": [
        "menu"
    ],
    "menue": [
        "menu"
    ],
    "menues": [
        "menu"
    ],
    "menuet": [
        "menuet"
    ],
    "menuets": [
        "menuet"
    ],
    "menuise": [
        "menuise"
    ],
    "menuiser": [
        "menuiser"
    ],
    "menuisera": [
        "menuiser"
    ],
    "menuiserie": [
        "menuiserie"
    ],
    "menuisier": [
        "menuisier"
    ],
    "menuisiers": [
        "menuisier"
    ],
    "menus": [
        "menu"
    ],
    "menat": [
        "mener"
    ],
    "menerent": [
        "mener"
    ],
    "mene": [
        "mener"
    ],
    "menee": [
        "mener",
        "menee"
    ],
    "menees": [
        "mener",
        "menee"
    ],
    "menes": [
        "mener"
    ],
    "mer": [
        "mer"
    ],
    "mercanti": [
        "mercanti"
    ],
    "mercantile": [
        "mercantile"
    ],
    "mercantiles": [
        "mercantile"
    ],
    "mercantilisme": [
        "mercantilisme"
    ],
    "mercantis": [
        "mercanti"
    ],
    "mercaptan": [
        "mercaptan"
    ],
    "mercenaire": [
        "mercenaire"
    ],
    "mercenaires": [
        "mercenaire"
    ],
    "mercerie": [
        "mercerie"
    ],
    "merceries": [
        "mercerie"
    ],
    "mercerise": [
        "merceriser"
    ],
    "merchandising": [
        "merchandising",
        "merchandise"
    ],
    "merci": [
        "merci"
    ],
    "mercier": [
        "mercier"
    ],
    "merciers": [
        "mercier"
    ],
    "mercis": [
        "merci"
    ],
    "merciere": [
        "mercier"
    ],
    "mercieres": [
        "mercier"
    ],
    "mercredi": [
        "mercredi"
    ],
    "mercredis": [
        "mercredi"
    ],
    "mercure": [
        "mercure"
    ],
    "mercurey": [
        "mercurey"
    ],
    "mercuriale": [
        "mercuriale"
    ],
    "mercuriales": [
        "mercuriale"
    ],
    "mercurochrome": [
        "mercurochrome"
    ],
    "merda": [
        "merder"
    ],
    "merdait": [
        "merder"
    ],
    "merdasse": [
        "merdasse"
    ],
    "merde": [
        "merde",
        "merder"
    ],
    "merdent": [
        "merder"
    ],
    "merder": [
        "merder"
    ],
    "merderai": [
        "merder"
    ],
    "merdes": [
        "merde",
        "merder"
    ],
    "merdeuse": [
        "merdeux"
    ],
    "merdeuses": [
        "merdeux"
    ],
    "merdeux": [
        "merdeux"
    ],
    "merdez": [
        "merder"
    ],
    "merdier": [
        "merdier"
    ],
    "merdiers": [
        "merdier"
    ],
    "merdique": [
        "merdique"
    ],
    "merdiques": [
        "merdique"
    ],
    "merdoie": [
        "merdoyer"
    ],
    "merdouille": [
        "merdouille",
        "merdouiller"
    ],
    "merdoyait": [
        "merdoyer"
    ],
    "merdre": [
        "merdre"
    ],
    "merdee": [
        "merder"
    ],
    "merguez": [
        "merguez"
    ],
    "meringue": [
        "meringuer",
        "meringue"
    ],
    "meringues": [
        "meringue"
    ],
    "meringuee": [
        "meringuer"
    ],
    "meringuees": [
        "meringuer"
    ],
    "merise": [
        "merise"
    ],
    "merises": [
        "merise"
    ],
    "merisier": [
        "merisier"
    ],
    "merisiers": [
        "merisier"
    ],
    "merl": [
        "merl"
    ],
    "merlan": [
        "merlan"
    ],
    "merlans": [
        "merlan"
    ],
    "merle": [
        "merle"
    ],
    "merleau": [
        "merleau"
    ],
    "merles": [
        "merle"
    ],
    "merlette": [
        "merlette"
    ],
    "merlin": [
        "merlin"
    ],
    "merlot": [
        "merlot"
    ],
    "merlu": [
        "merlu"
    ],
    "merluche": [
        "merluche"
    ],
    "merluches": [
        "merluche"
    ],
    "merrain": [
        "merrain"
    ],
    "merrains": [
        "merrain"
    ],
    "mers": [
        "mer"
    ],
    "merveille": [
        "merveille"
    ],
    "merveilles": [
        "merveille"
    ],
    "merveilleuse": [
        "merveilleux"
    ],
    "merveilleusement": [
        "merveilleusement"
    ],
    "merveilleuses": [
        "merveilleux"
    ],
    "merveilleux": [
        "merveilleux"
    ],
    "merveillosite": [
        "merveillosite"
    ],
    "mes": [
        "me",
        "mes"
    ],
    "mesa": [
        "mesa"
    ],
    "mescal": [
        "mescal"
    ],
    "mescaline": [
        "mescaline"
    ],
    "mesclun": [
        "mesclun"
    ],
    "mesdames": [
        "madame"
    ],
    "mesdemoiselles": [
        "mesdemoiselles"
    ],
    "mesmerisme": [
        "mesmerisme"
    ],
    "mesnils": [
        "mesnil"
    ],
    "mesquin": [
        "mesquin"
    ],
    "mesquine": [
        "mesquin"
    ],
    "mesquinement": [
        "mesquinement"
    ],
    "mesquinerie": [
        "mesquinerie"
    ],
    "mesquineries": [
        "mesquinerie"
    ],
    "mesquines": [
        "mesquin"
    ],
    "mesquins": [
        "mesquin"
    ],
    "mess": [
        "mess"
    ],
    "message": [
        "message"
    ],
    "messager": [
        "messager"
    ],
    "messagerie": [
        "messagerie"
    ],
    "messageries": [
        "messagerie"
    ],
    "messagers": [
        "messager"
    ],
    "messages": [
        "message"
    ],
    "messagere": [
        "messager"
    ],
    "messageres": [
        "messager"
    ],
    "messaliste": [
        "messaliste"
    ],
    "messalistes": [
        "messaliste"
    ],
    "messe": [
        "messe"
    ],
    "messeigneurs": [
        "messeigneurs"
    ],
    "messer": [
        "messer"
    ],
    "messes": [
        "messe",
        "mess"
    ],
    "messianique": [
        "messianique"
    ],
    "messianiques": [
        "messianique"
    ],
    "messianisme": [
        "messianisme"
    ],
    "messidor": [
        "messidor"
    ],
    "messie": [
        "messie"
    ],
    "messies": [
        "messie"
    ],
    "messieurs": [
        "monsieur"
    ],
    "messine": [
        "messin"
    ],
    "messire": [
        "messire"
    ],
    "messires": [
        "messire"
    ],
    "messeance": [
        "messeance"
    ],
    "mestre": [
        "mestre"
    ],
    "mesura": [
        "mesurer"
    ],
    "mesurable": [
        "mesurable"
    ],
    "mesurables": [
        "mesurable"
    ],
    "mesurai": [
        "mesurer"
    ],
    "mesuraient": [
        "mesurer"
    ],
    "mesurais": [
        "mesurer"
    ],
    "mesurait": [
        "mesurer"
    ],
    "mesurant": [
        "mesurer"
    ],
    "mesurassent": [
        "mesurer"
    ],
    "mesure": [
        "mesurer",
        "mesure"
    ],
    "mesurent": [
        "mesurer"
    ],
    "mesurer": [
        "mesurer"
    ],
    "mesurera": [
        "mesurer"
    ],
    "mesurerait": [
        "mesurer"
    ],
    "mesurerez": [
        "mesurer"
    ],
    "mesurerons": [
        "mesurer"
    ],
    "mesureront": [
        "mesurer"
    ],
    "mesures": [
        "mesurer",
        "mesure"
    ],
    "mesurette": [
        "mesurette"
    ],
    "mesureur": [
        "mesureur"
    ],
    "mesurez": [
        "mesurer"
    ],
    "mesuriez": [
        "mesurer"
    ],
    "mesurions": [
        "mesurer"
    ],
    "mesurons": [
        "mesuron",
        "mesurer"
    ],
    "mesurat": [
        "mesurer"
    ],
    "mesurerent": [
        "mesurer"
    ],
    "mesuree": [
        "mesurer",
        "mesure"
    ],
    "mesurees": [
        "mesurer",
        "mesure"
    ],
    "met": [
        "meet",
        "mettre"
    ],
    "mets": [
        "met",
        "mettre",
        "mets"
    ],
    "mettable": [
        "mettable"
    ],
    "mettaient": [
        "mettre"
    ],
    "mettais": [
        "mettre"
    ],
    "mettait": [
        "mettre"
    ],
    "mettant": [
        "mettre"
    ],
    "mette": [
        "mettre"
    ],
    "mettent": [
        "mettre"
    ],
    "mettes": [
        "mettre"
    ],
    "metteur": [
        "metteur"
    ],
    "metteurs": [
        "metteur"
    ],
    "metteuse": [
        "metteur"
    ],
    "mettez": [
        "mettre"
    ],
    "mettiez": [
        "mettre"
    ],
    "mettions": [
        "mettre"
    ],
    "mettons": [
        "mettre"
    ],
    "mettra": [
        "mettre"
    ],
    "mettrai": [
        "mettre"
    ],
    "mettraient": [
        "mettre"
    ],
    "mettrais": [
        "mettre"
    ],
    "mettrait": [
        "mettre"
    ],
    "mettras": [
        "mettre"
    ],
    "mettre": [
        "mettre"
    ],
    "mettrez": [
        "mettre"
    ],
    "mettriez": [
        "mettre"
    ],
    "mettrions": [
        "mettre"
    ],
    "mettrons": [
        "mettre"
    ],
    "mettront": [
        "mettre"
    ],
    "meubla": [
        "meubler"
    ],
    "meublaient": [
        "meubler"
    ],
    "meublais": [
        "meubler"
    ],
    "meublait": [
        "meubler"
    ],
    "meublant": [
        "meubler",
        "meublant"
    ],
    "meuble": [
        "meubler",
        "meuble"
    ],
    "meublent": [
        "meubler"
    ],
    "meubler": [
        "meubler"
    ],
    "meubles": [
        "meubler",
        "meuble"
    ],
    "meublerent": [
        "meubler"
    ],
    "meublee": [
        "meubler",
        "meuble"
    ],
    "meublees": [
        "meubler",
        "meuble"
    ],
    "meuf": [
        "meuf"
    ],
    "meufs": [
        "meuf"
    ],
    "meugla": [
        "meugler"
    ],
    "meuglaient": [
        "meugler"
    ],
    "meuglait": [
        "meugler"
    ],
    "meuglant": [
        "meugler"
    ],
    "meugle": [
        "meugler"
    ],
    "meuglement": [
        "meuglement"
    ],
    "meuglements": [
        "meuglement"
    ],
    "meugler": [
        "meugler"
    ],
    "meuh": [
        "meuh"
    ],
    "meulage": [
        "meulage"
    ],
    "meule": [
        "meuler",
        "meule"
    ],
    "meuler": [
        "meuler"
    ],
    "meules": [
        "meuler",
        "meule"
    ],
    "meuleuse": [
        "meuleuse"
    ],
    "meulez": [
        "meuler"
    ],
    "meuliere": [
        "meulier"
    ],
    "meulieres": [
        "meulier"
    ],
    "meunier": [
        "meunier"
    ],
    "meuniers": [
        "meunier"
    ],
    "meuniere": [
        "meunier"
    ],
    "meure": [
        "mourir"
    ],
    "meurent": [
        "mourir"
    ],
    "meures": [
        "mourir"
    ],
    "meurette": [
        "meurette"
    ],
    "meurs": [
        "mourir"
    ],
    "meursault": [
        "meursault"
    ],
    "meurt": [
        "mourir"
    ],
    "meurtre": [
        "meurtre"
    ],
    "meurtres": [
        "meurtre"
    ],
    "meurtri": [
        "meurtri",
        "meurtrir"
    ],
    "meurtrie": [
        "meurtri",
        "meurtrir"
    ],
    "meurtrier": [
        "meurtrier"
    ],
    "meurtriers": [
        "meurtrier"
    ],
    "meurtries": [
        "meurtri",
        "meurtrir"
    ],
    "meurtrir": [
        "meurtrir"
    ],
    "meurtrira": [
        "meurtrir"
    ],
    "meurtriront": [
        "meurtrir"
    ],
    "meurtris": [
        "meurtri",
        "meurtrir"
    ],
    "meurtrissaient": [
        "meurtrir"
    ],
    "meurtrissais": [
        "meurtrir"
    ],
    "meurtrissait": [
        "meurtrir"
    ],
    "meurtrissant": [
        "meurtrir"
    ],
    "meurtrissent": [
        "meurtrir"
    ],
    "meurtrissure": [
        "meurtrissure"
    ],
    "meurtrissures": [
        "meurtrissure"
    ],
    "meurtrit": [
        "meurtrir"
    ],
    "meurtriere": [
        "meurtrier"
    ],
    "meurtrieres": [
        "meurtrier"
    ],
    "meus": [
        "mouvoir"
    ],
    "meusien": [
        "meusien"
    ],
    "meusienne": [
        "meusienne",
        "meusien"
    ],
    "meusiennes": [
        "meusienne",
        "meusien"
    ],
    "meusiens": [
        "meusien"
    ],
    "meut": [
        "mouvoir"
    ],
    "meute": [
        "meute"
    ],
    "meutes": [
        "meute"
    ],
    "meuvent": [
        "mouvoir"
    ],
    "mexicain": [
        "mexicain"
    ],
    "mexicaine": [
        "mexicain"
    ],
    "mexicaines": [
        "mexicain"
    ],
    "mexicains": [
        "mexicain"
    ],
    "mexico": [
        "mexico"
    ],
    "mezcal": [
        "mezcal"
    ],
    "mezzanine": [
        "mezzanine"
    ],
    "mezzanines": [
        "mezzanine"
    ],
    "mezzo": [
        "mezzo"
    ],
    "mezzos": [
        "mezzo"
    ],
    "mi": [
        "mi"
    ],
    "miam": [
        "miam"
    ],
    "miao": [
        "miao"
    ],
    "miaou": [
        "miaou"
    ],
    "miaous": [
        "miaou"
    ],
    "miasme": [
        "miasme"
    ],
    "miasmes": [
        "miasme"
    ],
    "miaula": [
        "miauler"
    ],
    "miaulaient": [
        "miauler"
    ],
    "miaulais": [
        "miauler"
    ],
    "miaulait": [
        "miauler"
    ],
    "miaulant": [
        "miauler"
    ],
    "miaule": [
        "miauler"
    ],
    "miaulement": [
        "miaulement"
    ],
    "miaulements": [
        "miaulement"
    ],
    "miaulent": [
        "miauler"
    ],
    "miauler": [
        "miauler"
    ],
    "miauleur": [
        "miauleur"
    ],
    "miaulez": [
        "miauler"
    ],
    "mica": [
        "mica"
    ],
    "micacees": [
        "micace"
    ],
    "micas": [
        "mica"
    ],
    "miche": [
        "miche"
    ],
    "micheline": [
        "micheline"
    ],
    "miches": [
        "miche"
    ],
    "micheton": [
        "micheton"
    ],
    "michetonnais": [
        "michetonner"
    ],
    "michetonne": [
        "michetonner"
    ],
    "michetonner": [
        "michetonner"
    ],
    "michetonnes": [
        "michetonner"
    ],
    "michetonneuse": [
        "michetonneuse"
    ],
    "michetonneuses": [
        "michetonneuse"
    ],
    "michetons": [
        "micheton"
    ],
    "mickeys": [
        "mickey"
    ],
    "micmac": [
        "micmac"
    ],
    "micmacs": [
        "micmac"
    ],
    "micocoulier": [
        "micocoulier"
    ],
    "micocouliers": [
        "micocoulier"
    ],
    "micro": [
        "micro"
    ],
    "microanalyse": [
        "microanalyse"
    ],
    "microbe": [
        "microbe"
    ],
    "microbes": [
        "microbe"
    ],
    "microbienne": [
        "microbien"
    ],
    "microbiens": [
        "microbien"
    ],
    "microbiologie": [
        "microbiologie"
    ],
    "microbiologiste": [
        "microbiologiste"
    ],
    "microbus": [
        "microbus"
    ],
    "microcassette": [
        "microcassette"
    ],
    "microchimie": [
        "microchimie"
    ],
    "microchirurgie": [
        "microchirurgie"
    ],
    "microcircuit": [
        "microcircuit"
    ],
    "microcircuits": [
        "microcircuit"
    ],
    "microclimat": [
        "microclimat"
    ],
    "microcomposants": [
        "microcomposant"
    ],
    "microcopie": [
        "microcopie"
    ],
    "microcosme": [
        "microcosme"
    ],
    "microcycles": [
        "microcycle"
    ],
    "microcephale": [
        "microcephale"
    ],
    "microcephales": [
        "microcephale"
    ],
    "microfiches": [
        "microfiche"
    ],
    "microfilm": [
        "microfilm"
    ],
    "microfilms": [
        "microfilm"
    ],
    "microgramme": [
        "microgramme"
    ],
    "microgravite": [
        "microgravite"
    ],
    "microlithes": [
        "microlithe"
    ],
    "micrometre": [
        "micrometre"
    ],
    "micrometres": [
        "micrometre"
    ],
    "micron": [
        "micron"
    ],
    "microns": [
        "micron"
    ],
    "microphone": [
        "microphone"
    ],
    "microphones": [
        "microphone"
    ],
    "microprocesseur": [
        "microprocesseur"
    ],
    "microprocesseurs": [
        "microprocesseur"
    ],
    "micros": [
        "micro"
    ],
    "microscope": [
        "microscope"
    ],
    "microscopes": [
        "microscope"
    ],
    "microscopie": [
        "microscopie"
    ],
    "microscopique": [
        "microscopique"
    ],
    "microscopiquement": [
        "microscopiquement"
    ],
    "microscopiques": [
        "microscopique"
    ],
    "microseconde": [
        "microseconde"
    ],
    "microsecondes": [
        "microseconde"
    ],
    "microsillon": [
        "microsillon"
    ],
    "microsillons": [
        "microsillon"
    ],
    "microsociologie": [
        "microsociologie"
    ],
    "microsonde": [
        "microsonde"
    ],
    "microstructure": [
        "microstructure"
    ],
    "microstructures": [
        "microstructure"
    ],
    "microedition": [
        "microedition"
    ],
    "miction": [
        "miction"
    ],
    "mictions": [
        "miction"
    ],
    "midi": [
        "midi"
    ],
    "midinette": [
        "midinette"
    ],
    "midinettes": [
        "midinette"
    ],
    "midis": [
        "midi"
    ],
    "midrash": [
        "midrash"
    ],
    "midship": [
        "midship"
    ],
    "mie": [
        "mie"
    ],
    "miel": [
        "miel"
    ],
    "miellat": [
        "miellat"
    ],
    "mielle": [
        "mielle"
    ],
    "mielleuse": [
        "mielleux"
    ],
    "mielleuses": [
        "mielleux"
    ],
    "mielleux": [
        "mielleux"
    ],
    "miellee": [
        "mielle"
    ],
    "miellees": [
        "mielle"
    ],
    "miels": [
        "miel"
    ],
    "mien": [
        "mien"
    ],
    "mienne": [
        "mienne"
    ],
    "miennes": [
        "miennes"
    ],
    "miens": [
        "miens"
    ],
    "mies": [
        "mie"
    ],
    "miette": [
        "miette"
    ],
    "miettes": [
        "miette"
    ],
    "mieux": [
        "mieux"
    ],
    "mignard": [
        "mignard"
    ],
    "mignardant": [
        "mignarder"
    ],
    "mignarde": [
        "mignard",
        "mignarder"
    ],
    "mignardement": [
        "mignardement"
    ],
    "mignardes": [
        "mignard"
    ],
    "mignardise": [
        "mignardise"
    ],
    "mignardises": [
        "mignardise"
    ],
    "mignards": [
        "mignard"
    ],
    "mignon": [
        "mignon"
    ],
    "mignonne": [
        "mignon"
    ],
    "mignonnement": [
        "mignonnement"
    ],
    "mignonnes": [
        "mignon"
    ],
    "mignonnet": [
        "mignonnet"
    ],
    "mignonnets": [
        "mignonnet"
    ],
    "mignonnette": [
        "mignonnette",
        "mignonnet"
    ],
    "mignonnettes": [
        "mignonnette",
        "mignonnet"
    ],
    "mignons": [
        "mignon"
    ],
    "mignoter": [
        "mignoter"
    ],
    "mignoteront": [
        "mignoter"
    ],
    "mignote": [
        "mignoter"
    ],
    "migraine": [
        "migraine"
    ],
    "migraines": [
        "migraine"
    ],
    "migraineuse": [
        "migraineuse"
    ],
    "migraineux": [
        "migraineux"
    ],
    "migrait": [
        "migrer"
    ],
    "migrant": [
        "migrer",
        "migrant"
    ],
    "migrante": [
        "migrant"
    ],
    "migrants": [
        "migrant"
    ],
    "migrateur": [
        "migrateur"
    ],
    "migrateurs": [
        "migrateur"
    ],
    "migration": [
        "migration"
    ],
    "migrations": [
        "migration"
    ],
    "migratoire": [
        "migratoire"
    ],
    "migratoires": [
        "migratoire"
    ],
    "migratrice": [
        "migrateur"
    ],
    "migratrices": [
        "migrateur"
    ],
    "migre": [
        "migrer"
    ],
    "migrent": [
        "migrer"
    ],
    "migrer": [
        "migrer"
    ],
    "migres": [
        "migrer"
    ],
    "mijauree": [
        "mijauree"
    ],
    "mijaurees": [
        "mijauree"
    ],
    "mijota": [
        "mijoter"
    ],
    "mijotaient": [
        "mijoter"
    ],
    "mijotais": [
        "mijoter"
    ],
    "mijotait": [
        "mijoter"
    ],
    "mijotant": [
        "mijoter"
    ],
    "mijote": [
        "mijoter"
    ],
    "mijotent": [
        "mijoter"
    ],
    "mijoter": [
        "mijoter"
    ],
    "mijotera": [
        "mijoter"
    ],
    "mijotes": [
        "mijoter"
    ],
    "mijoteuse": [
        "mijoteuse"
    ],
    "mijotez": [
        "mijoter"
    ],
    "mijotions": [
        "mijoter"
    ],
    "mijotons": [
        "mijoter"
    ],
    "mijotees": [
        "mijoter"
    ],
    "mikado": [
        "mikado"
    ],
    "mil": [
        "mil"
    ],
    "milady": [
        "milady"
    ],
    "milan": [
        "milan"
    ],
    "milanais": [
        "milanais"
    ],
    "milanaise": [
        "milanais"
    ],
    "milanaises": [
        "milanais"
    ],
    "milans": [
        "milan"
    ],
    "mildiou": [
        "mildiou"
    ],
    "mile": [
        "mile"
    ],
    "miles": [
        "mile"
    ],
    "milice": [
        "milice"
    ],
    "milices": [
        "milice"
    ],
    "milicien": [
        "milicien"
    ],
    "miliciennes": [
        "milicienne",
        "milicien"
    ],
    "miliciens": [
        "milicien"
    ],
    "milieu": [
        "milieu"
    ],
    "milieux": [
        "milieu"
    ],
    "milita": [
        "militer"
    ],
    "militaient": [
        "militer"
    ],
    "militaire": [
        "militaire"
    ],
    "militairement": [
        "militairement"
    ],
    "militaires": [
        "militaire"
    ],
    "militait": [
        "militer"
    ],
    "militant": [
        "militant",
        "militer"
    ],
    "militante": [
        "militant"
    ],
    "militantes": [
        "militant"
    ],
    "militantisme": [
        "militantisme"
    ],
    "militants": [
        "militant"
    ],
    "militarisation": [
        "militarisation"
    ],
    "militariser": [
        "militariser"
    ],
    "militarisme": [
        "militarisme"
    ],
    "militariste": [
        "militariste"
    ],
    "militaristes": [
        "militariste"
    ],
    "militarise": [
        "militariser"
    ],
    "militaro": [
        "militaro"
    ],
    "milite": [
        "militer"
    ],
    "militent": [
        "militer"
    ],
    "militer": [
        "militer"
    ],
    "militerai": [
        "militer"
    ],
    "milites": [
        "militer"
    ],
    "militons": [
        "militer"
    ],
    "militerent": [
        "militer"
    ],
    "mille": [
        "mille"
    ],
    "millefeuille": [
        "millefeuille"
    ],
    "millefeuilles": [
        "millefeuille"
    ],
    "millenium": [
        "millenium"
    ],
    "milles": [
        "mille"
    ],
    "millet": [
        "millet"
    ],
    "milli": [
        "milli"
    ],
    "milliaire": [
        "milliaire"
    ],
    "milliard": [
        "milliard"
    ],
    "milliardaire": [
        "milliardaire"
    ],
    "milliardaires": [
        "milliardaire"
    ],
    "milliardieme": [
        "milliardieme"
    ],
    "milliards": [
        "milliard"
    ],
    "millier": [
        "millier"
    ],
    "milliers": [
        "millier"
    ],
    "milligramme": [
        "milligramme"
    ],
    "milligrammes": [
        "milligramme"
    ],
    "millilitre": [
        "millilitre"
    ],
    "millimetre": [
        "millimetre"
    ],
    "millimetres": [
        "millimetre"
    ],
    "millimetrique": [
        "millimetrique"
    ],
    "millimetriques": [
        "millimetrique"
    ],
    "millimetrees": [
        "millimetre"
    ],
    "million": [
        "million"
    ],
    "millionieme": [
        "millionieme"
    ],
    "millionnaire": [
        "millionnaire"
    ],
    "millionnaires": [
        "millionnaire"
    ],
    "millions": [
        "million"
    ],
    "milliseconde": [
        "milliseconde"
    ],
    "millisecondes": [
        "milliseconde"
    ],
    "millieme": [
        "millieme"
    ],
    "milliemes": [
        "millieme"
    ],
    "millenaire": [
        "millenaire"
    ],
    "millenaires": [
        "millenaire"
    ],
    "millenarisme": [
        "millenarisme"
    ],
    "millenariste": [
        "millenariste"
    ],
    "millesime": [
        "millesimer",
        "millesime"
    ],
    "millesimes": [
        "millesimer",
        "millesime"
    ],
    "millesimee": [
        "millesimer"
    ],
    "millesimees": [
        "millesimer"
    ],
    "milonga": [
        "milonga"
    ],
    "milord": [
        "milord"
    ],
    "milords": [
        "milord"
    ],
    "milouin": [
        "milouin"
    ],
    "milesiennes": [
        "milesien"
    ],
    "mima": [
        "mimer"
    ],
    "mimaient": [
        "mimer"
    ],
    "mimais": [
        "mimer"
    ],
    "mimait": [
        "mimer"
    ],
    "mimant": [
        "mimer"
    ],
    "mimas": [
        "mimer"
    ],
    "mime": [
        "mimer",
        "mime"
    ],
    "miment": [
        "mimer"
    ],
    "mimer": [
        "mimer"
    ],
    "mimerai": [
        "mimer"
    ],
    "mimerait": [
        "mimer"
    ],
    "mimes": [
        "mettre",
        "mime"
    ],
    "mimi": [
        "mimi"
    ],
    "mimique": [
        "mimique"
    ],
    "mimiques": [
        "mimique"
    ],
    "mimis": [
        "mimi"
    ],
    "mimodrames": [
        "mimodrame"
    ],
    "mimolette": [
        "mimolette"
    ],
    "mimosa": [
        "mimosa"
    ],
    "mimosas": [
        "mimosa"
    ],
    "mimosees": [
        "mimosee"
    ],
    "mimames": [
        "mimer"
    ],
    "mimerent": [
        "mimer"
    ],
    "mimee": [
        "mimer"
    ],
    "mimetique": [
        "mimetique"
    ],
    "mimetisme": [
        "mimetisme"
    ],
    "min": [
        "min"
    ],
    "mina": [
        "miner"
    ],
    "minable": [
        "minable"
    ],
    "minablement": [
        "minablement"
    ],
    "minables": [
        "minable"
    ],
    "minage": [
        "minage"
    ],
    "minait": [
        "miner"
    ],
    "minant": [
        "miner"
    ],
    "minaret": [
        "minaret"
    ],
    "minarets": [
        "minaret"
    ],
    "minas": [
        "miner"
    ],
    "minauda": [
        "minauder"
    ],
    "minaudaient": [
        "minauder"
    ],
    "minaudait": [
        "minauder"
    ],
    "minaudant": [
        "minaudant",
        "minauder"
    ],
    "minaudants": [
        "minaudant"
    ],
    "minaude": [
        "minauder"
    ],
    "minaudent": [
        "minauder"
    ],
    "minauder": [
        "minauder"
    ],
    "minauderait": [
        "minauder"
    ],
    "minauderie": [
        "minauderie"
    ],
    "minauderies": [
        "minauderie"
    ],
    "minaudeur": [
        "minaudeur"
    ],
    "minaudez": [
        "minauder"
    ],
    "minaudiere": [
        "minaudiere",
        "minaudier"
    ],
    "minbar": [
        "minbar"
    ],
    "mince": [
        "mince"
    ],
    "minces": [
        "mince"
    ],
    "minceur": [
        "minceur"
    ],
    "minceurs": [
        "minceur"
    ],
    "minci": [
        "mincir"
    ],
    "mincir": [
        "mincir"
    ],
    "mincirait": [
        "mincir"
    ],
    "mincis": [
        "mincir"
    ],
    "mincissaient": [
        "mincir"
    ],
    "mine": [
        "miner",
        "mine"
    ],
    "minent": [
        "miner"
    ],
    "miner": [
        "miner"
    ],
    "minera": [
        "miner"
    ],
    "minerai": [
        "miner",
        "minerai"
    ],
    "minerais": [
        "minerai"
    ],
    "minerval": [
        "minerval"
    ],
    "minerve": [
        "minerve"
    ],
    "mines": [
        "miner",
        "mine"
    ],
    "minestrone": [
        "minestrone"
    ],
    "minet": [
        "minet"
    ],
    "minets": [
        "minet"
    ],
    "minette": [
        "minet"
    ],
    "minettes": [
        "minet"
    ],
    "mineur": [
        "mineur"
    ],
    "mineure": [
        "mineur"
    ],
    "mineures": [
        "mineur"
    ],
    "mineurs": [
        "mineur"
    ],
    "ming": [
        "ming"
    ],
    "mini": [
        "mini"
    ],
    "miniature": [
        "miniature"
    ],
    "miniatures": [
        "miniature"
    ],
    "miniaturisation": [
        "miniaturisation"
    ],
    "miniaturise": [
        "miniaturiser"
    ],
    "miniaturiser": [
        "miniaturiser"
    ],
    "miniaturiste": [
        "miniaturiste"
    ],
    "miniaturisee": [
        "miniaturiser"
    ],
    "miniaturisees": [
        "miniaturiser"
    ],
    "miniaturises": [
        "miniaturiser"
    ],
    "minibar": [
        "minibar"
    ],
    "minibus": [
        "minibus"
    ],
    "minicassette": [
        "minicassette"
    ],
    "minicassettes": [
        "minicassette"
    ],
    "minier": [
        "minier"
    ],
    "miniers": [
        "minier"
    ],
    "minigolf": [
        "minigolf"
    ],
    "minijupe": [
        "minijupe"
    ],
    "minijupes": [
        "minijupe"
    ],
    "minima": [
        "minimum"
    ],
    "minimal": [
        "minimal"
    ],
    "minimale": [
        "minimal"
    ],
    "minimales": [
        "minimal"
    ],
    "minimaliser": [
        "minimaliser"
    ],
    "minimalisme": [
        "minimalisme"
    ],
    "minimaliste": [
        "minimaliste"
    ],
    "minimaux": [
        "minimal"
    ],
    "minimax": [
        "minimax"
    ],
    "minime": [
        "minime"
    ],
    "minimes": [
        "minime"
    ],
    "minimisa": [
        "minimiser"
    ],
    "minimisaient": [
        "minimiser"
    ],
    "minimisait": [
        "minimiser"
    ],
    "minimisant": [
        "minimiser"
    ],
    "minimisation": [
        "minimisation"
    ],
    "minimise": [
        "minimiser"
    ],
    "minimisent": [
        "minimiser"
    ],
    "minimiser": [
        "minimiser"
    ],
    "minimiserons": [
        "minimiser"
    ],
    "minimises": [
        "minimise",
        "minimiser"
    ],
    "minimisez": [
        "minimiser"
    ],
    "minimisons": [
        "minimiser"
    ],
    "minimisee": [
        "minimiser"
    ],
    "minimisees": [
        "minimiser"
    ],
    "minimum": [
        "minimum"
    ],
    "minimums": [
        "minimum"
    ],
    "minis": [
        "mini"
    ],
    "ministrables": [
        "ministrable"
    ],
    "ministre": [
        "ministre"
    ],
    "ministres": [
        "ministre"
    ],
    "ministere": [
        "ministere"
    ],
    "ministeres": [
        "ministere"
    ],
    "ministeriel": [
        "ministeriel"
    ],
    "ministerielle": [
        "ministeriel"
    ],
    "ministerielles": [
        "ministeriel"
    ],
    "ministeriels": [
        "ministeriel"
    ],
    "minitel": [
        "minitel"
    ],
    "minium": [
        "minium"
    ],
    "miniere": [
        "minier"
    ],
    "minieres": [
        "minier"
    ],
    "mino": [
        "mino"
    ],
    "minoen": [
        "minoen"
    ],
    "minoenne": [
        "minoen"
    ],
    "minoens": [
        "minoen"
    ],
    "minois": [
        "minois"
    ],
    "minoritaire": [
        "minoritaire"
    ],
    "minoritaires": [
        "minoritaire"
    ],
    "minorite": [
        "minorite"
    ],
    "minorites": [
        "minorite"
    ],
    "minot": [
        "minot"
    ],
    "minotaure": [
        "minotaure"
    ],
    "minotaures": [
        "minotaure"
    ],
    "minoteries": [
        "minoterie"
    ],
    "minotier": [
        "minotier"
    ],
    "minots": [
        "minot"
    ],
    "minou": [
        "minou"
    ],
    "minouche": [
        "minouche"
    ],
    "minous": [
        "minou"
    ],
    "minuit": [
        "minuit"
    ],
    "minuits": [
        "minuit"
    ],
    "minus": [
        "minus"
    ],
    "minuscule": [
        "minuscule"
    ],
    "minuscules": [
        "minuscule"
    ],
    "minutage": [
        "minutage"
    ],
    "minute": [
        "minuter",
        "minute"
    ],
    "minuter": [
        "minuter"
    ],
    "minuterie": [
        "minuterie"
    ],
    "minuteries": [
        "minuterie"
    ],
    "minutes": [
        "minuter",
        "minute"
    ],
    "minuteur": [
        "minuteur"
    ],
    "minuteurs": [
        "minuteur"
    ],
    "minutie": [
        "minutie"
    ],
    "minuties": [
        "minutie"
    ],
    "minutieuse": [
        "minutieux"
    ],
    "minutieusement": [
        "minutieusement"
    ],
    "minutieuses": [
        "minutieux"
    ],
    "minutieux": [
        "minutieux"
    ],
    "minutions": [
        "minuter"
    ],
    "minutat": [
        "minuter"
    ],
    "minutee": [
        "minuter"
    ],
    "minee": [
        "miner"
    ],
    "minees": [
        "miner"
    ],
    "mineral": [
        "mineral"
    ],
    "minerale": [
        "mineral"
    ],
    "minerales": [
        "mineral"
    ],
    "mineraliers": [
        "mineralier"
    ],
    "mineralisation": [
        "mineralisation"
    ],
    "mineralises": [
        "mineraliser",
        "mineralise"
    ],
    "mineralogique": [
        "mineralogique"
    ],
    "mineralogiques": [
        "mineralogique"
    ],
    "mineraux": [
        "mineral"
    ],
    "mioche": [
        "mioche"
    ],
    "mioches": [
        "mioche"
    ],
    "miquette": [
        "miquette"
    ],
    "mir": [
        "mir"
    ],
    "mira": [
        "mirer"
    ],
    "mirabelle": [
        "mirabelle"
    ],
    "mirabelles": [
        "mirabelle"
    ],
    "mirabellier": [
        "mirabellier"
    ],
    "mirabelliers": [
        "mirabellier"
    ],
    "mirabilis": [
        "mirabilis"
    ],
    "miracle": [
        "miracle"
    ],
    "miracles": [
        "miracle"
    ],
    "miraculant": [
        "miraculant"
    ],
    "miraculantes": [
        "miraculant"
    ],
    "miraculeuse": [
        "miraculeux"
    ],
    "miraculeusement": [
        "miraculeusement"
    ],
    "miraculeuses": [
        "miraculeux"
    ],
    "miraculeux": [
        "miraculeux"
    ],
    "miracule": [
        "miracule"
    ],
    "miraculee": [
        "miracule"
    ],
    "miracules": [
        "miracule"
    ],
    "mirador": [
        "mirador"
    ],
    "miradors": [
        "mirador"
    ],
    "mirage": [
        "mirage"
    ],
    "mirages": [
        "mirage"
    ],
    "miraient": [
        "mirer"
    ],
    "mirais": [
        "mirer"
    ],
    "mirait": [
        "mirer"
    ],
    "mirant": [
        "mirer"
    ],
    "miraud": [
        "miraud"
    ],
    "mirauds": [
        "miraud"
    ],
    "mire": [
        "mirer",
        "mire"
    ],
    "mirent": [
        "mirer",
        "mettre"
    ],
    "mirepoix": [
        "mirepoix"
    ],
    "mirer": [
        "mirer"
    ],
    "mirerais": [
        "mirer"
    ],
    "mires": [
        "mire"
    ],
    "mirette": [
        "mirette"
    ],
    "mirettes": [
        "mirette"
    ],
    "mirez": [
        "mirer"
    ],
    "mirifique": [
        "mirifique"
    ],
    "mirifiques": [
        "mirifique"
    ],
    "mirliflore": [
        "mirliflore"
    ],
    "mirliton": [
        "mirliton"
    ],
    "mirlitons": [
        "mirliton"
    ],
    "mirmidon": [
        "mirmidon"
    ],
    "miro": [
        "miro"
    ],
    "mirobolant": [
        "mirobolant"
    ],
    "mirobolante": [
        "mirobolant"
    ],
    "mirobolantes": [
        "mirobolant"
    ],
    "mirobolants": [
        "mirobolant"
    ],
    "miroir": [
        "miroir"
    ],
    "miroirs": [
        "miroir"
    ],
    "miroita": [
        "miroiter"
    ],
    "miroitaient": [
        "miroiter"
    ],
    "miroitait": [
        "miroiter"
    ],
    "miroitant": [
        "miroiter",
        "miroitant"
    ],
    "miroitante": [
        "miroitant"
    ],
    "miroitantes": [
        "miroitant"
    ],
    "miroitants": [
        "miroitant"
    ],
    "miroite": [
        "miroiter"
    ],
    "miroitement": [
        "miroitement"
    ],
    "miroitements": [
        "miroitement"
    ],
    "miroitent": [
        "miroiter"
    ],
    "miroiter": [
        "miroiter"
    ],
    "miroiterie": [
        "miroiterie"
    ],
    "miroitier": [
        "miroitier"
    ],
    "miroitiers": [
        "miroitier"
    ],
    "miroites": [
        "miroite"
    ],
    "mironton": [
        "mironton"
    ],
    "mirontons": [
        "mironton"
    ],
    "miros": [
        "miro"
    ],
    "miroton": [
        "miroton"
    ],
    "mirus": [
        "mirus"
    ],
    "miree": [
        "mirer"
    ],
    "mis": [
        "mettre",
        "mis"
    ],
    "misa": [
        "miser"
    ],
    "misai": [
        "miser"
    ],
    "misaient": [
        "miser"
    ],
    "misaine": [
        "misaine"
    ],
    "misaines": [
        "misaine"
    ],
    "misais": [
        "miser"
    ],
    "misait": [
        "miser"
    ],
    "misant": [
        "miser"
    ],
    "misanthrope": [
        "misanthrope"
    ],
    "misanthropes": [
        "misanthrope"
    ],
    "misanthropie": [
        "misanthropie"
    ],
    "misanthropiques": [
        "misanthropique"
    ],
    "miscible": [
        "miscible"
    ],
    "mise": [
        "mettre",
        "miser",
        "mise"
    ],
    "misent": [
        "miser"
    ],
    "miser": [
        "miser"
    ],
    "misera": [
        "miser"
    ],
    "miserais": [
        "miser"
    ],
    "miseras": [
        "miser"
    ],
    "miserere": [
        "miserere"
    ],
    "miseriez": [
        "miser"
    ],
    "miseront": [
        "miser"
    ],
    "mises": [
        "mettre",
        "miser",
        "mise"
    ],
    "misez": [
        "miser"
    ],
    "misiez": [
        "miser"
    ],
    "misogyne": [
        "misogyne"
    ],
    "misogynes": [
        "misogyne"
    ],
    "misogynie": [
        "misogynie"
    ],
    "misons": [
        "miser"
    ],
    "miss": [
        "miss"
    ],
    "missel": [
        "missel"
    ],
    "missels": [
        "missel"
    ],
    "missent": [
        "mettre"
    ],
    "missile": [
        "missile"
    ],
    "missiles": [
        "missile"
    ],
    "missilier": [
        "missilier"
    ],
    "mission": [
        "mission"
    ],
    "missionna": [
        "missionner"
    ],
    "missionnaire": [
        "missionnaire"
    ],
    "missionnaires": [
        "missionnaire"
    ],
    "missionne": [
        "missionner"
    ],
    "missionnes": [
        "missionner"
    ],
    "missions": [
        "mettre",
        "mission"
    ],
    "missive": [
        "missive"
    ],
    "missives": [
        "missive"
    ],
    "mister": [
        "mister"
    ],
    "mistigri": [
        "mistigri"
    ],
    "mistigris": [
        "mistigri"
    ],
    "mistonne": [
        "miston"
    ],
    "mistonnes": [
        "miston"
    ],
    "mistoufle": [
        "mistoufle"
    ],
    "mistoufles": [
        "mistoufle"
    ],
    "mistral": [
        "mistral"
    ],
    "mistrals": [
        "mistral"
    ],
    "misat": [
        "miser"
    ],
    "misere": [
        "misere"
    ],
    "miseres": [
        "misere"
    ],
    "miserabilisme": [
        "miserabilisme"
    ],
    "miserabiliste": [
        "miserabiliste"
    ],
    "miserable": [
        "miserable"
    ],
    "miserablement": [
        "miserablement"
    ],
    "miserables": [
        "miserable"
    ],
    "misereuse": [
        "misereux"
    ],
    "misereuses": [
        "misereux"
    ],
    "misereux": [
        "misereux"
    ],
    "misericorde": [
        "misericorde"
    ],
    "misericordes": [
        "misericorde"
    ],
    "misericordieuse": [
        "misericordieux"
    ],
    "misericordieusement": [
        "misericordieusement"
    ],
    "misericordieuses": [
        "misericordieux"
    ],
    "misericordieux": [
        "misericordieux"
    ],
    "mit": [
        "mettre"
    ],
    "mita": [
        "miter",
        "mita"
    ],
    "mitaine": [
        "mitaine"
    ],
    "mitaines": [
        "mitaine"
    ],
    "mitan": [
        "mitan"
    ],
    "mitard": [
        "mitard"
    ],
    "mitarder": [
        "mitarder"
    ],
    "mitards": [
        "mitard"
    ],
    "mitardes": [
        "mitarder"
    ],
    "mitchouriniens": [
        "mitchourinien"
    ],
    "mite": [
        "mite",
        "miter"
    ],
    "mitent": [
        "miter"
    ],
    "miter": [
        "miter"
    ],
    "mites": [
        "mite",
        "miter"
    ],
    "miteuse": [
        "miteux"
    ],
    "miteusement": [
        "miteusement"
    ],
    "miteuserie": [
        "miteuserie"
    ],
    "miteuses": [
        "miteux"
    ],
    "miteux": [
        "miteux"
    ],
    "mithriaque": [
        "mithriaque"
    ],
    "mithridatisation": [
        "mithridatisation"
    ],
    "mithridatise": [
        "mithridatiser"
    ],
    "mithridatises": [
        "mithridatiser"
    ],
    "mitigea": [
        "mitiger"
    ],
    "mitiger": [
        "mitiger"
    ],
    "mitigeurs": [
        "mitigeur"
    ],
    "mitige": [
        "mitige",
        "mitiger"
    ],
    "mitigee": [
        "mitige",
        "mitiger"
    ],
    "mitigees": [
        "mitige",
        "mitiger"
    ],
    "mitiges": [
        "mitiger"
    ],
    "mitochondrial": [
        "mitochondrial"
    ],
    "mitochondrie": [
        "mitochondrie"
    ],
    "mitochondries": [
        "mitochondrie"
    ],
    "miton": [
        "miton"
    ],
    "mitonnaient": [
        "mitonner"
    ],
    "mitonnait": [
        "mitonner"
    ],
    "mitonnant": [
        "mitonner"
    ],
    "mitonne": [
        "mitonner"
    ],
    "mitonnent": [
        "mitonner"
    ],
    "mitonner": [
        "mitonner"
    ],
    "mitonnerait": [
        "mitonner"
    ],
    "mitonnee": [
        "mitonner"
    ],
    "mitonnees": [
        "mitonner"
    ],
    "mitonnes": [
        "mitonner"
    ],
    "mitose": [
        "mitose"
    ],
    "mitotique": [
        "mitotique"
    ],
    "mitoufle": [
        "mitoufle"
    ],
    "mitoyen": [
        "mitoyen"
    ],
    "mitoyenne": [
        "mitoyen"
    ],
    "mitoyennes": [
        "mitoyen"
    ],
    "mitoyennete": [
        "mitoyennete"
    ],
    "mitoyens": [
        "mitoyen"
    ],
    "mitra": [
        "mitrer"
    ],
    "mitrailla": [
        "mitrailler"
    ],
    "mitraillade": [
        "mitraillade"
    ],
    "mitraillades": [
        "mitraillade"
    ],
    "mitraillage": [
        "mitraillage"
    ],
    "mitraillages": [
        "mitraillage"
    ],
    "mitraillaient": [
        "mitrailler"
    ],
    "mitraillait": [
        "mitrailler"
    ],
    "mitraillant": [
        "mitrailler"
    ],
    "mitraille": [
        "mitraille",
        "mitrailler"
    ],
    "mitraillent": [
        "mitrailler"
    ],
    "mitrailler": [
        "mitrailler"
    ],
    "mitrailleraient": [
        "mitrailler"
    ],
    "mitrailles": [
        "mitraille",
        "mitrailler"
    ],
    "mitraillette": [
        "mitraillette"
    ],
    "mitraillettes": [
        "mitraillette"
    ],
    "mitrailleur": [
        "mitrailleur"
    ],
    "mitrailleurs": [
        "mitrailleur"
    ],
    "mitrailleuse": [
        "mitrailleur"
    ],
    "mitrailleuses": [
        "mitrailleur"
    ],
    "mitrailliez": [
        "mitrailler"
    ],
    "mitraillerent": [
        "mitrailler"
    ],
    "mitraillee": [
        "mitrailler"
    ],
    "mitraillees": [
        "mitrailler"
    ],
    "mitral": [
        "mitral"
    ],
    "mitrale": [
        "mitral"
    ],
    "mitre": [
        "mitre",
        "mitrer"
    ],
    "mitres": [
        "mitre",
        "mitrer"
    ],
    "mitron": [
        "mitron"
    ],
    "mitrons": [
        "mitron"
    ],
    "mitee": [
        "mite",
        "miter"
    ],
    "mitees": [
        "mite"
    ],
    "mixage": [
        "mixage"
    ],
    "mixait": [
        "mixer"
    ],
    "mixe": [
        "mixer"
    ],
    "mixer": [
        "mixer"
    ],
    "mixers": [
        "mixer"
    ],
    "mixeur": [
        "mixeur"
    ],
    "mixeurs": [
        "mixeur"
    ],
    "mixite": [
        "mixite"
    ],
    "mixte": [
        "mixte"
    ],
    "mixtes": [
        "mixte"
    ],
    "mixture": [
        "mixture"
    ],
    "mixtures": [
        "mixture"
    ],
    "mixee": [
        "mixer"
    ],
    "mixes": [
        "mix",
        "mixer"
    ],
    "mievre": [
        "mievre"
    ],
    "mievrement": [
        "mievrement"
    ],
    "mievrerie": [
        "mievrerie"
    ],
    "mievreries": [
        "mievrerie"
    ],
    "mievres": [
        "mievre"
    ],
    "ml": [
        "ml"
    ],
    "mlle": [
        "mlle"
    ],
    "mm": [
        "mm"
    ],
    "mme": [
        "mme"
    ],
    "mn": [
        "mn"
    ],
    "mnemonique": [
        "mnemonique"
    ],
    "mnemoniques": [
        "mnemonique"
    ],
    "mnemotechnie": [
        "mnemotechnie"
    ],
    "mnemotechnique": [
        "mnemotechnique"
    ],
    "mnesiques": [
        "mnesique"
    ],
    "mob": [
        "mob"
    ],
    "mobile": [
        "mobile"
    ],
    "mobiles": [
        "mobile"
    ],
    "mobilier": [
        "mobilier"
    ],
    "mobiliers": [
        "mobilier"
    ],
    "mobilisa": [
        "mobiliser"
    ],
    "mobilisable": [
        "mobilisable"
    ],
    "mobilisables": [
        "mobilisable"
    ],
    "mobilisaient": [
        "mobiliser"
    ],
    "mobilisais": [
        "mobiliser"
    ],
    "mobilisait": [
        "mobiliser"
    ],
    "mobilisant": [
        "mobiliser"
    ],
    "mobilisateur": [
        "mobilisateur"
    ],
    "mobilisateurs": [
        "mobilisateur"
    ],
    "mobilisation": [
        "mobilisation"
    ],
    "mobilise": [
        "mobiliser"
    ],
    "mobilisent": [
        "mobiliser"
    ],
    "mobiliser": [
        "mobiliser"
    ],
    "mobilisera": [
        "mobiliser"
    ],
    "mobiliserait": [
        "mobiliser"
    ],
    "mobiliserons": [
        "mobiliser"
    ],
    "mobilisez": [
        "mobiliser"
    ],
    "mobilisions": [
        "mobiliser"
    ],
    "mobilisons": [
        "mobiliser"
    ],
    "mobilisee": [
        "mobiliser"
    ],
    "mobilisees": [
        "mobiliser"
    ],
    "mobilises": [
        "mobilise",
        "mobiliser"
    ],
    "mobilite": [
        "mobilite"
    ],
    "mobiliere": [
        "mobilier"
    ],
    "mobilieres": [
        "mobilier"
    ],
    "mobylette": [
        "mobylette"
    ],
    "mobylettes": [
        "mobylette"
    ],
    "mocassin": [
        "mocassin"
    ],
    "mocassins": [
        "mocassin"
    ],
    "mochard": [
        "mochard"
    ],
    "mocharde": [
        "mochard"
    ],
    "moche": [
        "moche"
    ],
    "moches": [
        "moche"
    ],
    "mochete": [
        "mochete"
    ],
    "mochetes": [
        "mochete"
    ],
    "moco": [
        "moco"
    ],
    "mod": [
        "mod"
    ],
    "modalite": [
        "modalite"
    ],
    "modalites": [
        "modalite"
    ],
    "mode": [
        "mode"
    ],
    "model": [
        "model"
    ],
    "modela": [
        "modeler"
    ],
    "modelable": [
        "modelable"
    ],
    "modelage": [
        "modelage"
    ],
    "modelaient": [
        "modeler"
    ],
    "modelais": [
        "modeler"
    ],
    "modelait": [
        "modeler"
    ],
    "modelant": [
        "modeler"
    ],
    "modeler": [
        "modeler"
    ],
    "modeleur": [
        "modeleur"
    ],
    "modelez": [
        "modeler"
    ],
    "modele": [
        "modeler",
        "modele"
    ],
    "modelee": [
        "modeler"
    ],
    "modelees": [
        "modeler"
    ],
    "modeles": [
        "modeler",
        "modele"
    ],
    "modem": [
        "modem"
    ],
    "modems": [
        "modem"
    ],
    "moderato": [
        "moderato"
    ],
    "moderne": [
        "moderne"
    ],
    "modernes": [
        "moderne"
    ],
    "modernisaient": [
        "moderniser"
    ],
    "modernisait": [
        "moderniser"
    ],
    "modernisation": [
        "modernisation"
    ],
    "modernisations": [
        "modernisation"
    ],
    "modernise": [
        "moderniser"
    ],
    "modernisent": [
        "moderniser"
    ],
    "moderniser": [
        "moderniser"
    ],
    "modernisme": [
        "modernisme"
    ],
    "modernisons": [
        "moderniser"
    ],
    "modernissime": [
        "modernissime"
    ],
    "moderniste": [
        "moderniste"
    ],
    "modernistes": [
        "moderniste"
    ],
    "modernisee": [
        "moderniser"
    ],
    "modernises": [
        "moderniser",
        "modernise"
    ],
    "modernite": [
        "modernite"
    ],
    "modernites": [
        "modernite"
    ],
    "modes": [
        "mode"
    ],
    "modeste": [
        "modeste"
    ],
    "modestement": [
        "modestement"
    ],
    "modestes": [
        "modeste"
    ],
    "modestie": [
        "modestie"
    ],
    "modesties": [
        "modesty",
        "modestie"
    ],
    "modicite": [
        "modicite"
    ],
    "modifia": [
        "modifier"
    ],
    "modifiable": [
        "modifiable"
    ],
    "modifiables": [
        "modifiable"
    ],
    "modifiaient": [
        "modifier"
    ],
    "modifiais": [
        "modifier"
    ],
    "modifiait": [
        "modifier"
    ],
    "modifiant": [
        "modifier"
    ],
    "modificateur": [
        "modificateur"
    ],
    "modification": [
        "modification"
    ],
    "modifications": [
        "modification"
    ],
    "modifie": [
        "modifier",
        "modifie"
    ],
    "modifient": [
        "modifier"
    ],
    "modifier": [
        "modifier"
    ],
    "modifiera": [
        "modifier"
    ],
    "modifierai": [
        "modifier"
    ],
    "modifieraient": [
        "modifier"
    ],
    "modifierais": [
        "modifier"
    ],
    "modifierait": [
        "modifier"
    ],
    "modifiez": [
        "modifier"
    ],
    "modifions": [
        "modifier"
    ],
    "modifiat": [
        "modifier"
    ],
    "modifierent": [
        "modifier"
    ],
    "modifiee": [
        "modifier",
        "modifie"
    ],
    "modifiees": [
        "modifier",
        "modifie"
    ],
    "modifies": [
        "modify",
        "modifier",
        "modifie"
    ],
    "modillon": [
        "modillon"
    ],
    "modillons": [
        "modillon"
    ],
    "modique": [
        "modique"
    ],
    "modiques": [
        "modique"
    ],
    "modiste": [
        "modiste"
    ],
    "modistes": [
        "modiste"
    ],
    "modula": [
        "moduler"
    ],
    "modulable": [
        "modulable"
    ],
    "modulables": [
        "modulable"
    ],
    "modulai": [
        "moduler"
    ],
    "modulaire": [
        "modulaire"
    ],
    "modulaires": [
        "modulaire"
    ],
    "modulais": [
        "moduler"
    ],
    "modulait": [
        "moduler"
    ],
    "modulant": [
        "moduler"
    ],
    "modulateur": [
        "modulateur"
    ],
    "modulation": [
        "modulation"
    ],
    "modulations": [
        "modulation"
    ],
    "module": [
        "module",
        "moduler"
    ],
    "modulent": [
        "moduler"
    ],
    "moduler": [
        "moduler"
    ],
    "modules": [
        "module",
        "moduler"
    ],
    "modulee": [
        "moduler"
    ],
    "modulees": [
        "moduler"
    ],
    "modelent": [
        "modeler"
    ],
    "modere": [
        "modere",
        "moderer"
    ],
    "modelisation": [
        "modelisation"
    ],
    "modelisme": [
        "modelisme"
    ],
    "modeliste": [
        "modeliste"
    ],
    "modelise": [
        "modeliser"
    ],
    "modelisee": [
        "modeliser"
    ],
    "modera": [
        "moderer"
    ],
    "moderai": [
        "moderer"
    ],
    "moderait": [
        "moderer"
    ],
    "moderant": [
        "moderer"
    ],
    "moderateur": [
        "moderateur"
    ],
    "moderateurs": [
        "moderateur"
    ],
    "moderation": [
        "moderation"
    ],
    "moderations": [
        "moderation"
    ],
    "moderer": [
        "moderer"
    ],
    "modereras": [
        "moderer"
    ],
    "moderez": [
        "moderer"
    ],
    "moderee": [
        "modere",
        "moderer"
    ],
    "moderees": [
        "modere",
        "moderer"
    ],
    "moderement": [
        "moderement"
    ],
    "moderes": [
        "modere",
        "moderer"
    ],
    "moelle": [
        "moelle"
    ],
    "moelles": [
        "moelle"
    ],
    "moelleuse": [
        "moelleux"
    ],
    "moelleusement": [
        "moelleusement"
    ],
    "moelleuses": [
        "moelleux"
    ],
    "moelleux": [
        "moelleux"
    ],
    "moellon": [
        "moellon"
    ],
    "moellons": [
        "moellon"
    ],
    "moeurs": [
        "moeurs"
    ],
    "moghol": [
        "moghol"
    ],
    "mogol": [
        "mogol"
    ],
    "mohair": [
        "mohair"
    ],
    "mohairs": [
        "mohair"
    ],
    "mohican": [
        "mohican"
    ],
    "moho": [
        "moho"
    ],
    "moi": [
        "moi",
        "je"
    ],
    "moignon": [
        "moignon"
    ],
    "moignons": [
        "moignon"
    ],
    "moindre": [
        "moindre"
    ],
    "moindrement": [
        "moindrement"
    ],
    "moindres": [
        "moindre"
    ],
    "moine": [
        "moine"
    ],
    "moineau": [
        "moineau"
    ],
    "moineaux": [
        "moineau"
    ],
    "moines": [
        "moine"
    ],
    "moinillon": [
        "moinillon"
    ],
    "moinillons": [
        "moinillon"
    ],
    "moins": [
        "moins"
    ],
    "moiraient": [
        "moirer"
    ],
    "moire": [
        "moirer",
        "moire"
    ],
    "moires": [
        "moirer",
        "moire"
    ],
    "moirure": [
        "moirure"
    ],
    "moirures": [
        "moirure"
    ],
    "moiree": [
        "moirer",
        "moire"
    ],
    "moirees": [
        "moirer",
        "moire"
    ],
    "mois": [
        "mois"
    ],
    "moise": [
        "moise"
    ],
    "moises": [
        "moise"
    ],
    "moisi": [
        "moisi",
        "moisir"
    ],
    "moisie": [
        "moisi",
        "moisir"
    ],
    "moisies": [
        "moisi",
        "moisir"
    ],
    "moisir": [
        "moisir"
    ],
    "moisira": [
        "moisir"
    ],
    "moisirai": [
        "moisir"
    ],
    "moisiraient": [
        "moisir"
    ],
    "moisirais": [
        "moisir"
    ],
    "moisirait": [
        "moisir"
    ],
    "moisiras": [
        "moisir"
    ],
    "moisirez": [
        "moisir"
    ],
    "moisiront": [
        "moisir"
    ],
    "moisis": [
        "moisi",
        "moisir"
    ],
    "moisissaient": [
        "moisir"
    ],
    "moisissais": [
        "moisir"
    ],
    "moisissait": [
        "moisir"
    ],
    "moisissant": [
        "moisir"
    ],
    "moisisse": [
        "moisir"
    ],
    "moisissent": [
        "moisir"
    ],
    "moisissez": [
        "moisir"
    ],
    "moisissure": [
        "moisissure"
    ],
    "moisissures": [
        "moisissure"
    ],
    "moisit": [
        "moisir"
    ],
    "moisson": [
        "moisson"
    ],
    "moissonnait": [
        "moissonner"
    ],
    "moissonnant": [
        "moissonner"
    ],
    "moissonne": [
        "moissonner"
    ],
    "moissonnent": [
        "moissonner"
    ],
    "moissonner": [
        "moissonner"
    ],
    "moissonnera": [
        "moissonner"
    ],
    "moissonnerai": [
        "moissonner"
    ],
    "moissonneur": [
        "moissonneur"
    ],
    "moissonneurs": [
        "moissonneur"
    ],
    "moissonneuse": [
        "moissonneur"
    ],
    "moissonneuses": [
        "moissonneur"
    ],
    "moissonnez": [
        "moissonner"
    ],
    "moissonnee": [
        "moissonner"
    ],
    "moissonnees": [
        "moissonner"
    ],
    "moissonnes": [
        "moissonner"
    ],
    "moissons": [
        "moisson"
    ],
    "moite": [
        "moite"
    ],
    "moites": [
        "moite"
    ],
    "moiteur": [
        "moiteur"
    ],
    "moiteurs": [
        "moiteur"
    ],
    "moiti": [
        "moitir"
    ],
    "moitie": [
        "moitie"
    ],
    "moities": [
        "moitie"
    ],
    "moka": [
        "moka"
    ],
    "mokas": [
        "moka"
    ],
    "moko": [
        "moko"
    ],
    "mol": [
        "mol"
    ],
    "molaire": [
        "molaire"
    ],
    "molaires": [
        "molaire"
    ],
    "molard": [
        "molard"
    ],
    "molasse": [
        "molasse"
    ],
    "moldave": [
        "moldave"
    ],
    "moldaves": [
        "moldave"
    ],
    "mole": [
        "mole"
    ],
    "moles": [
        "mole"
    ],
    "moleskine": [
        "moleskine"
    ],
    "molesquine": [
        "molesquine"
    ],
    "molesta": [
        "molester"
    ],
    "molestaient": [
        "molester"
    ],
    "molestant": [
        "molester"
    ],
    "molestation": [
        "molestation"
    ],
    "moleste": [
        "molester"
    ],
    "molester": [
        "molester"
    ],
    "molestez": [
        "molester"
    ],
    "molestee": [
        "molester"
    ],
    "molestes": [
        "molester"
    ],
    "moleta": [
        "moleter"
    ],
    "molette": [
        "molette"
    ],
    "molettes": [
        "molette"
    ],
    "molieresque": [
        "molieresque"
    ],
    "mollah": [
        "mollah"
    ],
    "mollahs": [
        "mollah"
    ],
    "mollard": [
        "mollard"
    ],
    "mollarder": [
        "mollarder"
    ],
    "mollards": [
        "mollard"
    ],
    "mollarde": [
        "mollarder"
    ],
    "mollasse": [
        "mollasse"
    ],
    "mollasses": [
        "mollasse"
    ],
    "mollasson": [
        "mollasson"
    ],
    "mollassonne": [
        "mollasson"
    ],
    "mollassons": [
        "mollasson"
    ],
    "molle": [
        "mou,mol"
    ],
    "mollement": [
        "mollement"
    ],
    "molles": [
        "mou,mol"
    ],
    "mollesse": [
        "mollesse"
    ],
    "mollesses": [
        "mollesse"
    ],
    "mollet": [
        "mollet"
    ],
    "molletiere": [
        "molletiere"
    ],
    "molletieres": [
        "molletiere"
    ],
    "molleton": [
        "molleton"
    ],
    "molletonneux": [
        "molletonneux"
    ],
    "molletonne": [
        "molletonner",
        "molletonne"
    ],
    "molletonnee": [
        "molletonner",
        "molletonne"
    ],
    "molletons": [
        "molleton"
    ],
    "mollets": [
        "mollet"
    ],
    "mollette": [
        "mollet"
    ],
    "mollettes": [
        "mollet"
    ],
    "molli": [
        "mollir"
    ],
    "mollie": [
        "mollir"
    ],
    "mollir": [
        "mollir"
    ],
    "mollis": [
        "mollir"
    ],
    "mollissaient": [
        "mollir"
    ],
    "mollissait": [
        "mollir"
    ],
    "mollissant": [
        "mollir"
    ],
    "mollisse": [
        "mollir"
    ],
    "mollissent": [
        "mollir"
    ],
    "mollissez": [
        "mollir"
    ],
    "mollit": [
        "mollir"
    ],
    "mollo": [
        "mollo"
    ],
    "mollusque": [
        "mollusque"
    ],
    "mollusques": [
        "mollusque"
    ],
    "moloch": [
        "moloch"
    ],
    "molosse": [
        "molosse"
    ],
    "molosses": [
        "molosse"
    ],
    "mols": [
        "mol"
    ],
    "molto": [
        "molto"
    ],
    "moly": [
        "moly"
    ],
    "molybdene": [
        "molybdene"
    ],
    "molenes": [
        "molene"
    ],
    "moleculaire": [
        "moleculaire"
    ],
    "moleculaires": [
        "moleculaire"
    ],
    "molecule": [
        "molecule"
    ],
    "molecules": [
        "molecule"
    ],
    "moman": [
        "moman"
    ],
    "mombin": [
        "mombin"
    ],
    "moment": [
        "moment"
    ],
    "momentane": [
        "momentane"
    ],
    "momentanee": [
        "momentane"
    ],
    "momentanees": [
        "momentane"
    ],
    "momentanement": [
        "momentanement"
    ],
    "momentanes": [
        "momentane"
    ],
    "moments": [
        "moment"
    ],
    "momerie": [
        "momerie"
    ],
    "momeries": [
        "momerie"
    ],
    "momichons": [
        "momichon"
    ],
    "momie": [
        "momi",
        "momie"
    ],
    "momies": [
        "momi",
        "momie"
    ],
    "momifiait": [
        "momifier"
    ],
    "momifiant": [
        "momifier"
    ],
    "momification": [
        "momification"
    ],
    "momifie": [
        "momifier",
        "momifie"
    ],
    "momifier": [
        "momifier"
    ],
    "momifiee": [
        "momifier",
        "momifie"
    ],
    "momifiees": [
        "momifier",
        "momifie"
    ],
    "momifies": [
        "momifier",
        "momifie"
    ],
    "mominette": [
        "mominette"
    ],
    "mon": [
        "mon"
    ],
    "monacal": [
        "monacal"
    ],
    "monacale": [
        "monacal"
    ],
    "monacales": [
        "monacal"
    ],
    "monachisme": [
        "monachisme"
    ],
    "monades": [
        "monade"
    ],
    "monadologie": [
        "monadologie"
    ],
    "monarchie": [
        "monarchie"
    ],
    "monarchies": [
        "monarchy",
        "monarchie"
    ],
    "monarchique": [
        "monarchique"
    ],
    "monarchiste": [
        "monarchiste"
    ],
    "monarchistes": [
        "monarchiste"
    ],
    "monarque": [
        "monarque"
    ],
    "monarques": [
        "monarque"
    ],
    "monastique": [
        "monastique"
    ],
    "monastiques": [
        "monastique"
    ],
    "monastere": [
        "monastere"
    ],
    "monasteres": [
        "monastere"
    ],
    "monbazillac": [
        "monbazillac"
    ],
    "monceau": [
        "monceau"
    ],
    "monceaux": [
        "monceau"
    ],
    "monda": [
        "monder"
    ],
    "mondain": [
        "mondain"
    ],
    "mondaine": [
        "mondain"
    ],
    "mondainement": [
        "mondainement"
    ],
    "mondaines": [
        "mondain"
    ],
    "mondains": [
        "mondain"
    ],
    "mondanisaient": [
        "mondaniser"
    ],
    "mondanise": [
        "mondaniser"
    ],
    "mondanite": [
        "mondanite"
    ],
    "mondanites": [
        "mondanite"
    ],
    "monde": [
        "monde"
    ],
    "monder": [
        "monder"
    ],
    "mondes": [
        "monde"
    ],
    "mondial": [
        "mondial"
    ],
    "mondiale": [
        "mondial",
        "mondiale"
    ],
    "mondialement": [
        "mondialement"
    ],
    "mondiales": [
        "mondial"
    ],
    "mondialisation": [
        "mondialisation"
    ],
    "mondialisent": [
        "mondialiser"
    ],
    "mondialistes": [
        "mondialiste"
    ],
    "mondiaux": [
        "mondial"
    ],
    "mondovision": [
        "mondovision"
    ],
    "mondee": [
        "monder"
    ],
    "mongo": [
        "mongo"
    ],
    "mongol": [
        "mongol"
    ],
    "mongole": [
        "mongol"
    ],
    "mongoles": [
        "mongol"
    ],
    "mongolie": [
        "mongolie"
    ],
    "mongolien": [
        "mongolien"
    ],
    "mongolienne": [
        "mongolien"
    ],
    "mongoliennes": [
        "mongolien"
    ],
    "mongoliens": [
        "mongolien"
    ],
    "mongolique": [
        "mongolique"
    ],
    "mongoliques": [
        "mongolique"
    ],
    "mongoloide": [
        "mongoloide"
    ],
    "mongols": [
        "mongol"
    ],
    "moniale": [
        "moniale"
    ],
    "moniales": [
        "moniale"
    ],
    "moniteur": [
        "moniteur"
    ],
    "moniteurs": [
        "moniteur"
    ],
    "monition": [
        "monition"
    ],
    "monitor": [
        "monitor"
    ],
    "monitorage": [
        "monitorage"
    ],
    "monitoring": [
        "monitoring",
        "monitor"
    ],
    "monitrice": [
        "moniteur"
    ],
    "monitrices": [
        "moniteur"
    ],
    "monnaie": [
        "monnayer",
        "monnaie"
    ],
    "monnaiera": [
        "monnayer"
    ],
    "monnaierai": [
        "monnayer"
    ],
    "monnaies": [
        "monnaie"
    ],
    "monnaya": [
        "monnayer"
    ],
    "monnayable": [
        "monnayable"
    ],
    "monnayables": [
        "monnayable"
    ],
    "monnayait": [
        "monnayer"
    ],
    "monnayant": [
        "monnayer"
    ],
    "monnaye": [
        "monnayer"
    ],
    "monnayer": [
        "monnayer"
    ],
    "monnayeur": [
        "monnayeur"
    ],
    "monnayeurs": [
        "monnayeur"
    ],
    "monnayee": [
        "monnayer"
    ],
    "mono": [
        "mono"
    ],
    "monoamine": [
        "monoamine"
    ],
    "monobloc": [
        "monobloc"
    ],
    "monocellulaire": [
        "monocellulaire"
    ],
    "monochrome": [
        "monochrome"
    ],
    "monochromes": [
        "monochrome"
    ],
    "monochromie": [
        "monochromie"
    ],
    "monocle": [
        "monocle"
    ],
    "monocles": [
        "monocle"
    ],
    "monoclonal": [
        "monoclonal"
    ],
    "monoclonaux": [
        "monoclonal"
    ],
    "monocoque": [
        "monocoque"
    ],
    "monocorde": [
        "monocorde"
    ],
    "monocordes": [
        "monocorde"
    ],
    "monocratie": [
        "monocratie"
    ],
    "monoculaire": [
        "monoculaire"
    ],
    "monoculaires": [
        "monoculaire"
    ],
    "monoculture": [
        "monoculture"
    ],
    "monocycle": [
        "monocycle"
    ],
    "monocylindre": [
        "monocylindre"
    ],
    "monodie": [
        "monodie"
    ],
    "monofilament": [
        "monofilament"
    ],
    "monogame": [
        "monogame"
    ],
    "monogames": [
        "monogame"
    ],
    "monogamie": [
        "monogamie"
    ],
    "monogramme": [
        "monogramme"
    ],
    "monogrammes": [
        "monogramme"
    ],
    "monogrammees": [
        "monogramme"
    ],
    "monographie": [
        "monographie"
    ],
    "monographies": [
        "monographie"
    ],
    "monokini": [
        "monokini"
    ],
    "monolinguisme": [
        "monolinguisme"
    ],
    "monolithe": [
        "monolithe"
    ],
    "monolithes": [
        "monolithe"
    ],
    "monolithique": [
        "monolithique"
    ],
    "monolithiques": [
        "monolithique"
    ],
    "monolithisme": [
        "monolithisme"
    ],
    "monologua": [
        "monologuer"
    ],
    "monologuaient": [
        "monologuer"
    ],
    "monologuais": [
        "monologuer"
    ],
    "monologuait": [
        "monologuer"
    ],
    "monologuant": [
        "monologuer"
    ],
    "monologue": [
        "monologuer",
        "monologue"
    ],
    "monologuer": [
        "monologuer"
    ],
    "monologues": [
        "monologue"
    ],
    "monomane": [
        "monomane"
    ],
    "monomanes": [
        "monomane"
    ],
    "monomaniaque": [
        "monomaniaque"
    ],
    "monomaniaques": [
        "monomaniaque"
    ],
    "monomanie": [
        "monomanie"
    ],
    "monomoteur": [
        "monomoteur"
    ],
    "monomoteurs": [
        "monomoteur"
    ],
    "mononucleaire": [
        "mononucleaire"
    ],
    "mononucleose": [
        "mononucleose"
    ],
    "monoparental": [
        "monoparental"
    ],
    "monoparentale": [
        "monoparental"
    ],
    "monoparentales": [
        "monoparental"
    ],
    "monoparentaux": [
        "monoparental"
    ],
    "monophasee": [
        "monophase"
    ],
    "monoplace": [
        "monoplace"
    ],
    "monoplaces": [
        "monoplace"
    ],
    "monoplan": [
        "monoplan"
    ],
    "monoplans": [
        "monoplan"
    ],
    "monopode": [
        "monopode"
    ],
    "monopole": [
        "monopole"
    ],
    "monopoles": [
        "monopole"
    ],
    "monopolisa": [
        "monopoliser"
    ],
    "monopolisaient": [
        "monopoliser"
    ],
    "monopolisais": [
        "monopoliser"
    ],
    "monopolisait": [
        "monopoliser"
    ],
    "monopolise": [
        "monopoliser"
    ],
    "monopolisent": [
        "monopoliser"
    ],
    "monopoliser": [
        "monopoliser"
    ],
    "monopolisera": [
        "monopoliser"
    ],
    "monopolisez": [
        "monopoliser"
    ],
    "monopoliserent": [
        "monopoliser"
    ],
    "monopolises": [
        "monopoliser"
    ],
    "monopoly": [
        "monopoly"
    ],
    "monoprix": [
        "monoprix"
    ],
    "monorail": [
        "monorail"
    ],
    "monorails": [
        "monorail"
    ],
    "monospace": [
        "monospace"
    ],
    "monosyllabe": [
        "monosyllabe"
    ],
    "monosyllabes": [
        "monosyllabe"
    ],
    "monosyllabique": [
        "monosyllabique"
    ],
    "monosyllabiques": [
        "monosyllabique"
    ],
    "monotheisme": [
        "monotheisme"
    ],
    "monotheismes": [
        "monotheisme"
    ],
    "monotheiste": [
        "monotheiste"
    ],
    "monotheistes": [
        "monotheiste"
    ],
    "monotone": [
        "monotone"
    ],
    "monotonement": [
        "monotonement"
    ],
    "monotones": [
        "monotone"
    ],
    "monotonie": [
        "monotonie"
    ],
    "monotype": [
        "monotype"
    ],
    "monoxyde": [
        "monoxyde"
    ],
    "monoxyle": [
        "monoxyle"
    ],
    "mons": [
        "mon",
        "mons"
    ],
    "monseigneur": [
        "monseigneur"
    ],
    "monsieur": [
        "monsieur"
    ],
    "monsignor": [
        "monsignor"
    ],
    "monsignore": [
        "monsignore"
    ],
    "monstrance": [
        "monstrance"
    ],
    "monstrances": [
        "monstrance"
    ],
    "monstre": [
        "monstre"
    ],
    "monstres": [
        "monstre"
    ],
    "monstrueuse": [
        "monstrueux"
    ],
    "monstrueusement": [
        "monstrueusement"
    ],
    "monstrueuses": [
        "monstrueux"
    ],
    "monstrueux": [
        "monstrueux"
    ],
    "monstruosite": [
        "monstruosite"
    ],
    "monstruosites": [
        "monstruosite"
    ],
    "mont": [
        "mont"
    ],
    "monta": [
        "monter"
    ],
    "montage": [
        "montage"
    ],
    "montages": [
        "montage"
    ],
    "montagnard": [
        "montagnard"
    ],
    "montagnarde": [
        "montagnard"
    ],
    "montagnardes": [
        "montagnard"
    ],
    "montagnards": [
        "montagnard"
    ],
    "montagne": [
        "montagne"
    ],
    "montagnes": [
        "montagne"
    ],
    "montagneuse": [
        "montagneux"
    ],
    "montagneuses": [
        "montagneux"
    ],
    "montagneux": [
        "montagneux"
    ],
    "montai": [
        "monter"
    ],
    "montaient": [
        "monter"
    ],
    "montais": [
        "monter"
    ],
    "montaison": [
        "montaison"
    ],
    "montait": [
        "monter"
    ],
    "montant": [
        "montant",
        "monter"
    ],
    "montante": [
        "montant"
    ],
    "montantes": [
        "montant"
    ],
    "montants": [
        "montant"
    ],
    "monte": [
        "monte",
        "monter"
    ],
    "montent": [
        "monter"
    ],
    "monter": [
        "monter"
    ],
    "montera": [
        "monter"
    ],
    "monterai": [
        "monter"
    ],
    "monteraient": [
        "monter"
    ],
    "monterais": [
        "monter"
    ],
    "monterait": [
        "monter"
    ],
    "monteras": [
        "monter"
    ],
    "monterez": [
        "monter"
    ],
    "monteriez": [
        "monter"
    ],
    "monterons": [
        "monter"
    ],
    "monteront": [
        "monter"
    ],
    "montes": [
        "monte",
        "monter"
    ],
    "monteur": [
        "monteur"
    ],
    "monteurs": [
        "monteur"
    ],
    "monteuse": [
        "monteur"
    ],
    "montez": [
        "monter"
    ],
    "montgolfiere": [
        "montgolfiere"
    ],
    "montgolfieres": [
        "montgolfiere"
    ],
    "monticule": [
        "monticule"
    ],
    "monticules": [
        "monticule"
    ],
    "montiez": [
        "monter"
    ],
    "montions": [
        "monter"
    ],
    "montjoie": [
        "montjoie"
    ],
    "montmartrois": [
        "montmartrois"
    ],
    "montmartroise": [
        "montmartrois"
    ],
    "montmartroises": [
        "montmartrois"
    ],
    "montons": [
        "monter"
    ],
    "montparno": [
        "montparno"
    ],
    "montpellieraine": [
        "montpellierain"
    ],
    "montra": [
        "montrer"
    ],
    "montrable": [
        "montrable"
    ],
    "montrables": [
        "montrable"
    ],
    "montrai": [
        "montrer"
    ],
    "montraient": [
        "montrer"
    ],
    "montrais": [
        "montrer"
    ],
    "montrait": [
        "montrer"
    ],
    "montrant": [
        "montrer"
    ],
    "montrassent": [
        "montrer"
    ],
    "montre": [
        "montre",
        "montrer"
    ],
    "montrent": [
        "montrer"
    ],
    "montrer": [
        "montrer"
    ],
    "montrera": [
        "montrer"
    ],
    "montrerai": [
        "montrer"
    ],
    "montreraient": [
        "montrer"
    ],
    "montrerais": [
        "montrer"
    ],
    "montrerait": [
        "montrer"
    ],
    "montreras": [
        "montrer"
    ],
    "montrerez": [
        "montrer"
    ],
    "montreriez": [
        "montrer"
    ],
    "montrerons": [
        "montrer"
    ],
    "montreront": [
        "montrer"
    ],
    "montres": [
        "montre",
        "montrer"
    ],
    "montreur": [
        "montreur"
    ],
    "montreurs": [
        "montreur"
    ],
    "montreuse": [
        "montreur"
    ],
    "montreuses": [
        "montreur"
    ],
    "montrez": [
        "montrer"
    ],
    "montriez": [
        "montrer"
    ],
    "montrions": [
        "montrer"
    ],
    "montrons": [
        "montrer"
    ],
    "montrames": [
        "montrer"
    ],
    "montrat": [
        "montrer"
    ],
    "montrerent": [
        "montrer"
    ],
    "montree": [
        "montrer"
    ],
    "montrees": [
        "montrer"
    ],
    "monts": [
        "mont"
    ],
    "montueuse": [
        "montueux"
    ],
    "montueuses": [
        "montueux"
    ],
    "montueux": [
        "montueux"
    ],
    "monture": [
        "monture"
    ],
    "montures": [
        "monture"
    ],
    "montames": [
        "monter"
    ],
    "montat": [
        "monter"
    ],
    "monterent": [
        "monter"
    ],
    "montee": [
        "montee",
        "monte",
        "monter"
    ],
    "montees": [
        "montee",
        "monte",
        "monter"
    ],
    "montenegrin": [
        "montenegrin"
    ],
    "montenegrines": [
        "montenegrin"
    ],
    "monument": [
        "monument"
    ],
    "monumental": [
        "monumental"
    ],
    "monumentale": [
        "monumental"
    ],
    "monumentalement": [
        "monumentalement"
    ],
    "monumentales": [
        "monumental"
    ],
    "monumentalite": [
        "monumentalite"
    ],
    "monumentaux": [
        "monumental"
    ],
    "monuments": [
        "monument"
    ],
    "monetaire": [
        "monetaire"
    ],
    "monetaires": [
        "monetaire"
    ],
    "monetariste": [
        "monetariste"
    ],
    "monomes": [
        "monome"
    ],
    "moonisme": [
        "moonisme"
    ],
    "moonistes": [
        "mooniste"
    ],
    "moore": [
        "moore"
    ],
    "moos": [
        "moos"
    ],
    "moose": [
        "moose"
    ],
    "moqua": [
        "moquer"
    ],
    "moquai": [
        "moquer"
    ],
    "moquaient": [
        "moquer"
    ],
    "moquais": [
        "moquer"
    ],
    "moquait": [
        "moquer"
    ],
    "moquant": [
        "moquer"
    ],
    "moque": [
        "moquer",
        "moque"
    ],
    "moquent": [
        "moquer"
    ],
    "moquer": [
        "moquer"
    ],
    "moquera": [
        "moquer"
    ],
    "moquerai": [
        "moquer"
    ],
    "moqueraient": [
        "moquer"
    ],
    "moquerais": [
        "moquer"
    ],
    "moquerait": [
        "moquer"
    ],
    "moqueras": [
        "moquer"
    ],
    "moquerez": [
        "moquer"
    ],
    "moquerie": [
        "moquerie"
    ],
    "moqueries": [
        "moquerie"
    ],
    "moqueriez": [
        "moquer"
    ],
    "moqueront": [
        "moquer"
    ],
    "moques": [
        "moquer",
        "moque"
    ],
    "moquette": [
        "moquetter",
        "moquette"
    ],
    "moquettes": [
        "moquetter",
        "moquette"
    ],
    "moquettees": [
        "moquetter"
    ],
    "moqueur": [
        "moqueur"
    ],
    "moqueurs": [
        "moqueur"
    ],
    "moqueuse": [
        "moqueur"
    ],
    "moqueusement": [
        "moqueusement"
    ],
    "moqueuses": [
        "moqueur"
    ],
    "moquez": [
        "moquer"
    ],
    "moquiez": [
        "moquer"
    ],
    "moquions": [
        "moquer"
    ],
    "moquons": [
        "moquer"
    ],
    "moquat": [
        "moquer"
    ],
    "moquerent": [
        "moquer"
    ],
    "moquee": [
        "moquer"
    ],
    "moquees": [
        "moquer"
    ],
    "moraillon": [
        "moraillon"
    ],
    "moraine": [
        "moraine"
    ],
    "moraines": [
        "moraine"
    ],
    "morainique": [
        "morainique"
    ],
    "morainiques": [
        "morainique"
    ],
    "moral": [
        "moral"
    ],
    "morale": [
        "moral",
        "morale"
    ],
    "moralement": [
        "moralement"
    ],
    "morales": [
        "moral",
        "morale"
    ],
    "moralisante": [
        "moralisant"
    ],
    "moralisateur": [
        "moralisateur"
    ],
    "moralisateurs": [
        "moralisateur"
    ],
    "moralisation": [
        "moralisation"
    ],
    "moralisatrice": [
        "moralisateur"
    ],
    "moralise": [
        "moraliser"
    ],
    "moraliser": [
        "moraliser"
    ],
    "moralisme": [
        "moralisme"
    ],
    "moraliste": [
        "moraliste"
    ],
    "moralistes": [
        "moraliste"
    ],
    "moralisee": [
        "moraliser"
    ],
    "moralite": [
        "moralite"
    ],
    "moralites": [
        "moralite"
    ],
    "morasse": [
        "morasse"
    ],
    "morasses": [
        "morasse"
    ],
    "moratoire": [
        "moratoire"
    ],
    "moraux": [
        "moral"
    ],
    "morave": [
        "morave"
    ],
    "moraves": [
        "morave"
    ],
    "morbac": [
        "morbac"
    ],
    "morbacs": [
        "morbac"
    ],
    "morbaque": [
        "morbaque"
    ],
    "morbaques": [
        "morbaque"
    ],
    "morbide": [
        "morbide"
    ],
    "morbidement": [
        "morbidement"
    ],
    "morbides": [
        "morbide"
    ],
    "morbidesse": [
        "morbidesse"
    ],
    "morbidite": [
        "morbidite"
    ],
    "morbier": [
        "morbier"
    ],
    "morbleu": [
        "morbleu"
    ],
    "morceau": [
        "morceau"
    ],
    "morceaux": [
        "morceau"
    ],
    "morcela": [
        "morceler"
    ],
    "morcelait": [
        "morceler"
    ],
    "morcelant": [
        "morceler"
    ],
    "morceler": [
        "morceler"
    ],
    "morcellement": [
        "morcellement"
    ],
    "morcellements": [
        "morcellement"
    ],
    "morcellent": [
        "morceler"
    ],
    "morcellera": [
        "morceler"
    ],
    "morcele": [
        "morceler",
        "morcele"
    ],
    "morcelee": [
        "morceler",
        "morcele"
    ],
    "morcelees": [
        "morceler"
    ],
    "morceles": [
        "morceler",
        "morcele"
    ],
    "morcif": [
        "morcif"
    ],
    "morcifs": [
        "morcif"
    ],
    "mord": [
        "mordre"
    ],
    "mordaient": [
        "mordre"
    ],
    "mordais": [
        "mordre"
    ],
    "mordait": [
        "mordre"
    ],
    "mordant": [
        "mordant",
        "mordre"
    ],
    "mordante": [
        "mordant"
    ],
    "mordantes": [
        "mordant"
    ],
    "mordants": [
        "mordant"
    ],
    "mordancage": [
        "mordancage"
    ],
    "morde": [
        "mordre"
    ],
    "mordent": [
        "mordre"
    ],
    "mordes": [
        "mordre"
    ],
    "mordeur": [
        "mordeur"
    ],
    "mordeurs": [
        "mordeur"
    ],
    "mordeuse": [
        "mordeuse",
        "mordeur"
    ],
    "mordez": [
        "mordre"
    ],
    "mordicus": [
        "mordicus"
    ],
    "mordieu": [
        "mordieu"
    ],
    "mordilla": [
        "mordiller"
    ],
    "mordillage": [
        "mordillage"
    ],
    "mordillaient": [
        "mordiller"
    ],
    "mordillais": [
        "mordiller"
    ],
    "mordillait": [
        "mordiller"
    ],
    "mordillant": [
        "mordiller"
    ],
    "mordille": [
        "mordiller"
    ],
    "mordillement": [
        "mordillement"
    ],
    "mordillements": [
        "mordillement"
    ],
    "mordillent": [
        "mordiller"
    ],
    "mordiller": [
        "mordiller"
    ],
    "mordillera": [
        "mordiller"
    ],
    "mordillez": [
        "mordiller"
    ],
    "mordillee": [
        "mordiller"
    ],
    "mordillees": [
        "mordiller"
    ],
    "mordilles": [
        "mordiller"
    ],
    "mordions": [
        "mordre"
    ],
    "mordirent": [
        "mordre"
    ],
    "mordis": [
        "mordre"
    ],
    "mordissent": [
        "mordre"
    ],
    "mordit": [
        "mordre"
    ],
    "mordorait": [
        "mordorer"
    ],
    "mordore": [
        "mordore"
    ],
    "mordoree": [
        "mordorer",
        "mordore"
    ],
    "mordorees": [
        "mordorer",
        "mordore"
    ],
    "mordores": [
        "mordorer",
        "mordore"
    ],
    "mordra": [
        "mordre"
    ],
    "mordrai": [
        "mordre"
    ],
    "mordraient": [
        "mordre"
    ],
    "mordrais": [
        "mordre"
    ],
    "mordrait": [
        "mordre"
    ],
    "mordras": [
        "mordre"
    ],
    "mordre": [
        "mordre"
    ],
    "mordrez": [
        "mordre"
    ],
    "mordront": [
        "mordre"
    ],
    "mords": [
        "mordre"
    ],
    "mordu": [
        "mordre",
        "mordu"
    ],
    "mordue": [
        "mordre",
        "mordu"
    ],
    "mordues": [
        "mordre",
        "mordu"
    ],
    "mordus": [
        "mordre",
        "mordu"
    ],
    "more": [
        "more"
    ],
    "moreau": [
        "moreau"
    ],
    "morelle": [
        "morelle"
    ],
    "mores": [
        "more"
    ],
    "moresque": [
        "moresque"
    ],
    "morfal": [
        "morfal"
    ],
    "morfale": [
        "morfaler",
        "morfal"
    ],
    "morfaler": [
        "morfaler"
    ],
    "morfales": [
        "morfaler",
        "morfal"
    ],
    "morfalou": [
        "morfalou"
    ],
    "morfals": [
        "morfal"
    ],
    "morfalee": [
        "morfaler"
    ],
    "morfil": [
        "morfil"
    ],
    "morflais": [
        "morfler"
    ],
    "morflait": [
        "morfler"
    ],
    "morfle": [
        "morfler"
    ],
    "morfler": [
        "morfler"
    ],
    "morflera": [
        "morfler"
    ],
    "morfleras": [
        "morfler"
    ],
    "morflerez": [
        "morfler"
    ],
    "morfles": [
        "morfler"
    ],
    "morflee": [
        "morfler"
    ],
    "morfond": [
        "morfondre"
    ],
    "morfondaient": [
        "morfondre"
    ],
    "morfondais": [
        "morfondre"
    ],
    "morfondait": [
        "morfondre"
    ],
    "morfondant": [
        "morfondre"
    ],
    "morfonde": [
        "morfondre"
    ],
    "morfondis": [
        "morfondre"
    ],
    "morfondra": [
        "morfondre"
    ],
    "morfondre": [
        "morfondre"
    ],
    "morfonds": [
        "morfondre"
    ],
    "morfondu": [
        "morfondu",
        "morfondre"
    ],
    "morfondue": [
        "morfondu"
    ],
    "morgana": [
        "morganer"
    ],
    "morganatique": [
        "morganatique"
    ],
    "morganatiques": [
        "morganatique"
    ],
    "morgane": [
        "morganer"
    ],
    "morganer": [
        "morganer"
    ],
    "morganerai": [
        "morganer"
    ],
    "morgeline": [
        "morgeline"
    ],
    "morgon": [
        "morgon"
    ],
    "morgue": [
        "morgue"
    ],
    "morgues": [
        "morgue"
    ],
    "moria": [
        "moria"
    ],
    "moribond": [
        "moribond"
    ],
    "moribonde": [
        "moribond"
    ],
    "moribondes": [
        "moribond"
    ],
    "moribonds": [
        "moribond"
    ],
    "moricaud": [
        "moricaud"
    ],
    "moricaude": [
        "moricaud"
    ],
    "moricaudes": [
        "moricaud"
    ],
    "moricauds": [
        "moricaud"
    ],
    "morigene": [
        "morigener"
    ],
    "morigena": [
        "morigener"
    ],
    "morigenai": [
        "morigener"
    ],
    "morigenais": [
        "morigener"
    ],
    "morigenait": [
        "morigener"
    ],
    "morigenant": [
        "morigener"
    ],
    "morigener": [
        "morigener"
    ],
    "morigenee": [
        "morigener"
    ],
    "morille": [
        "morille"
    ],
    "morilles": [
        "morille"
    ],
    "morillon": [
        "morillon"
    ],
    "morillons": [
        "morillon"
    ],
    "morlingue": [
        "morlingue"
    ],
    "morlingues": [
        "morlingue"
    ],
    "mormon": [
        "mormon"
    ],
    "mormone": [
        "mormon"
    ],
    "mormones": [
        "mormon"
    ],
    "mormons": [
        "mormon"
    ],
    "morne": [
        "morne"
    ],
    "mornement": [
        "mornement"
    ],
    "mornes": [
        "morne"
    ],
    "mornifle": [
        "mornifle"
    ],
    "moro": [
        "moro"
    ],
    "morose": [
        "morose"
    ],
    "morosement": [
        "morosement"
    ],
    "moroses": [
        "morose"
    ],
    "morosite": [
        "morosite"
    ],
    "morosites": [
        "morosite"
    ],
    "morphine": [
        "morphine"
    ],
    "morphing": [
        "morphing"
    ],
    "morphinomane": [
        "morphinomane"
    ],
    "morphique": [
        "morphique"
    ],
    "morpho": [
        "morpho"
    ],
    "morphogenese": [
        "morphogenese"
    ],
    "morphogenetique": [
        "morphogenetique"
    ],
    "morphologie": [
        "morphologie"
    ],
    "morphologique": [
        "morphologique"
    ],
    "morphologiques": [
        "morphologique"
    ],
    "morpion": [
        "morpion"
    ],
    "morpions": [
        "morpion"
    ],
    "mors": [
        "mors",
        "mor"
    ],
    "morse": [
        "morse"
    ],
    "morsure": [
        "morsure"
    ],
    "morsures": [
        "morsure"
    ],
    "mort": [
        "mourir",
        "mort"
    ],
    "mortadelle": [
        "mortadelle"
    ],
    "mortaise": [
        "mortaise"
    ],
    "mortaiser": [
        "mortaiser"
    ],
    "mortaises": [
        "mortaise"
    ],
    "mortaiseuse": [
        "mortaiseur"
    ],
    "mortalite": [
        "mortalite"
    ],
    "morte": [
        "mourir",
        "mort"
    ],
    "mortel": [
        "mortel"
    ],
    "mortelle": [
        "mortel"
    ],
    "mortellement": [
        "mortellement"
    ],
    "mortelles": [
        "mortel"
    ],
    "mortels": [
        "mortel"
    ],
    "mortes": [
        "mourir",
        "mort"
    ],
    "mortibus": [
        "mortibus"
    ],
    "mortier": [
        "mortier"
    ],
    "mortiers": [
        "mortier"
    ],
    "mortifia": [
        "mortifier"
    ],
    "mortifiai": [
        "mortifier"
    ],
    "mortifiaient": [
        "mortifier"
    ],
    "mortifiait": [
        "mortifier"
    ],
    "mortifiant": [
        "mortifiant",
        "mortifier"
    ],
    "mortifiante": [
        "mortifiant"
    ],
    "mortifiantes": [
        "mortifiant"
    ],
    "mortifiants": [
        "mortifiant"
    ],
    "mortification": [
        "mortification"
    ],
    "mortifications": [
        "mortification"
    ],
    "mortifie": [
        "mortifier"
    ],
    "mortifier": [
        "mortifier"
    ],
    "mortifiee": [
        "mortifier"
    ],
    "mortifies": [
        "mortifier"
    ],
    "mortifere": [
        "mortifere"
    ],
    "mortiferes": [
        "mortifere"
    ],
    "morts": [
        "mourir",
        "mort"
    ],
    "mortuaire": [
        "mortuaire"
    ],
    "mortuaires": [
        "mortuaire"
    ],
    "morue": [
        "morue"
    ],
    "morues": [
        "morue"
    ],
    "morula": [
        "morula"
    ],
    "morvandiau": [
        "morvandiau"
    ],
    "morve": [
        "morve"
    ],
    "morves": [
        "morve"
    ],
    "morveuse": [
        "morveux"
    ],
    "morveuses": [
        "morveux"
    ],
    "morveux": [
        "morveux"
    ],
    "mos": [
        "mos",
        "mo"
    ],
    "mosaique": [
        "mosaique"
    ],
    "mosaiques": [
        "mosaique"
    ],
    "mosaiquee": [
        "mosaique"
    ],
    "mosaiste": [
        "mosaiste"
    ],
    "moscoutaire": [
        "moscoutaire"
    ],
    "moscovite": [
        "moscovite"
    ],
    "moscovites": [
        "moscovite"
    ],
    "mosellane": [
        "mosellan"
    ],
    "mosellanes": [
        "mosellan"
    ],
    "mosquee": [
        "mosquee"
    ],
    "mosquees": [
        "mosquee"
    ],
    "mot": [
        "mot"
    ],
    "motard": [
        "motard"
    ],
    "motarde": [
        "motard"
    ],
    "motardes": [
        "motard"
    ],
    "motards": [
        "motard"
    ],
    "motel": [
        "motel"
    ],
    "motels": [
        "motel"
    ],
    "motesse": [
        "motesse"
    ],
    "motet": [
        "motet"
    ],
    "motets": [
        "motet"
    ],
    "moteur": [
        "moteur"
    ],
    "moteurs": [
        "moteur"
    ],
    "motif": [
        "motif"
    ],
    "motifs": [
        "motif"
    ],
    "motilite": [
        "motilite"
    ],
    "motion": [
        "motion"
    ],
    "motions": [
        "motion"
    ],
    "motiva": [
        "motiver"
    ],
    "motivai": [
        "motiver"
    ],
    "motivaient": [
        "motiver"
    ],
    "motivais": [
        "motiver"
    ],
    "motivait": [
        "motiver"
    ],
    "motivant": [
        "motiver",
        "motivant"
    ],
    "motivante": [
        "motivant"
    ],
    "motivateur": [
        "motivateur"
    ],
    "motivation": [
        "motivation"
    ],
    "motivations": [
        "motivation"
    ],
    "motive": [
        "motiver",
        "motive"
    ],
    "motivent": [
        "motiver"
    ],
    "motiver": [
        "motiver"
    ],
    "motivera": [
        "motiver"
    ],
    "motivez": [
        "motiver"
    ],
    "motivee": [
        "motiver",
        "motive"
    ],
    "motivees": [
        "motiver",
        "motive"
    ],
    "motives": [
        "motiver",
        "motive"
    ],
    "moto": [
        "moto"
    ],
    "motocross": [
        "motocross"
    ],
    "motoculteur": [
        "motoculteur"
    ],
    "motoculture": [
        "motoculture"
    ],
    "motocycles": [
        "motocycle"
    ],
    "motocyclette": [
        "motocyclette"
    ],
    "motocyclettes": [
        "motocyclette"
    ],
    "motocyclisme": [
        "motocyclisme"
    ],
    "motocycliste": [
        "motocycliste"
    ],
    "motocyclistes": [
        "motocycliste"
    ],
    "motoneige": [
        "motoneige"
    ],
    "motoneiges": [
        "motoneige"
    ],
    "motoneurone": [
        "motoneurone"
    ],
    "motorisation": [
        "motorisation"
    ],
    "motoriser": [
        "motoriser"
    ],
    "motorise": [
        "motorise",
        "motoriser"
    ],
    "motorisee": [
        "motorise",
        "motoriser"
    ],
    "motorisees": [
        "motorise",
        "motoriser"
    ],
    "motorises": [
        "motorise",
        "motoriser"
    ],
    "motos": [
        "moto"
    ],
    "motrice": [
        "moteur",
        "motrice"
    ],
    "motrices": [
        "moteur",
        "motrice"
    ],
    "motricite": [
        "motricite"
    ],
    "mots": [
        "mot"
    ],
    "motte": [
        "motte"
    ],
    "mottereau": [
        "mottereau"
    ],
    "mottes": [
        "motte"
    ],
    "motteux": [
        "motteux"
    ],
    "motus": [
        "motus"
    ],
    "mou": [
        "mou"
    ],
    "mouais": [
        "mouais"
    ],
    "moucha": [
        "moucher"
    ],
    "mouchachou": [
        "mouchachou"
    ],
    "mouchage": [
        "mouchage"
    ],
    "mouchai": [
        "moucher"
    ],
    "mouchaient": [
        "moucher"
    ],
    "mouchait": [
        "moucher"
    ],
    "mouchant": [
        "moucher"
    ],
    "mouchard": [
        "mouchard"
    ],
    "moucharda": [
        "moucharder"
    ],
    "mouchardage": [
        "mouchardage"
    ],
    "mouchardait": [
        "moucharder"
    ],
    "moucharde": [
        "mouchard",
        "moucharder"
    ],
    "mouchardent": [
        "moucharder"
    ],
    "moucharder": [
        "moucharder"
    ],
    "mouchardera": [
        "moucharder"
    ],
    "moucharderait": [
        "moucharder"
    ],
    "mouchardes": [
        "mouchard",
        "moucharder"
    ],
    "mouchards": [
        "mouchard"
    ],
    "mouche": [
        "moucher",
        "mouche"
    ],
    "mouchent": [
        "moucher"
    ],
    "moucher": [
        "moucher"
    ],
    "moucheron": [
        "moucheron"
    ],
    "moucherons": [
        "moucheron"
    ],
    "mouches": [
        "moucher",
        "mouche"
    ],
    "mouchetait": [
        "moucheter"
    ],
    "mouchetant": [
        "moucheter"
    ],
    "mouchette": [
        "mouchette",
        "moucheter"
    ],
    "moucheture": [
        "moucheture"
    ],
    "mouchetures": [
        "moucheture"
    ],
    "mouchete": [
        "mouchete",
        "moucheter"
    ],
    "mouchetee": [
        "mouchete",
        "moucheter"
    ],
    "mouchetees": [
        "mouchete",
        "moucheter"
    ],
    "mouchetes": [
        "mouchete",
        "moucheter"
    ],
    "moucheur": [
        "moucheur"
    ],
    "mouchez": [
        "moucher"
    ],
    "mouchoir": [
        "mouchoir"
    ],
    "mouchoirs": [
        "mouchoir"
    ],
    "mouchons": [
        "moucher"
    ],
    "mouchee": [
        "moucher"
    ],
    "moud": [
        "moudre"
    ],
    "moudjahiddine": [
        "moudjahiddine"
    ],
    "moudjahidin": [
        "moudjahidin"
    ],
    "moudjahidine": [
        "moudjahidine"
    ],
    "moudrai": [
        "moudre"
    ],
    "moudre": [
        "moudre"
    ],
    "mouds": [
        "moudre"
    ],
    "moue": [
        "moue"
    ],
    "moues": [
        "moue"
    ],
    "mouette": [
        "mouette"
    ],
    "mouettes": [
        "mouette"
    ],
    "moufetait": [
        "moufeter"
    ],
    "moufette": [
        "moufette"
    ],
    "moufete": [
        "moufeter"
    ],
    "mouffette": [
        "mouffette"
    ],
    "moufle": [
        "moufle"
    ],
    "moufles": [
        "moufle"
    ],
    "mouflet": [
        "mouflet"
    ],
    "mouflets": [
        "mouflet"
    ],
    "mouflette": [
        "mouflette"
    ],
    "mouflettes": [
        "mouflette"
    ],
    "mouflon": [
        "mouflon"
    ],
    "mouflons": [
        "mouflon"
    ],
    "mouftaient": [
        "moufter"
    ],
    "mouftais": [
        "moufter"
    ],
    "mouftait": [
        "moufter"
    ],
    "moufte": [
        "moufter"
    ],
    "mouftent": [
        "moufter"
    ],
    "moufter": [
        "moufter"
    ],
    "mouftera": [
        "moufter"
    ],
    "mouftes": [
        "moufter"
    ],
    "mouftez": [
        "moufter"
    ],
    "mouilla": [
        "mouiller"
    ],
    "mouillage": [
        "mouillage"
    ],
    "mouillages": [
        "mouillage"
    ],
    "mouillaient": [
        "mouiller"
    ],
    "mouillais": [
        "mouiller"
    ],
    "mouillait": [
        "mouiller"
    ],
    "mouillant": [
        "mouiller",
        "mouillant"
    ],
    "mouillante": [
        "mouillant"
    ],
    "mouillasse": [
        "mouiller"
    ],
    "mouille": [
        "mouille",
        "mouiller"
    ],
    "mouillent": [
        "mouiller"
    ],
    "mouiller": [
        "mouiller"
    ],
    "mouillera": [
        "mouiller"
    ],
    "mouillerai": [
        "mouiller"
    ],
    "mouillerais": [
        "mouiller"
    ],
    "mouillerait": [
        "mouiller"
    ],
    "mouilleras": [
        "mouiller"
    ],
    "mouilleront": [
        "mouiller"
    ],
    "mouilles": [
        "mouille",
        "mouiller"
    ],
    "mouillette": [
        "mouillette"
    ],
    "mouillettes": [
        "mouillette"
    ],
    "mouilleur": [
        "mouilleur"
    ],
    "mouilleuse": [
        "mouilleur"
    ],
    "mouillez": [
        "mouiller"
    ],
    "mouillon": [
        "mouillon"
    ],
    "mouillons": [
        "mouiller",
        "mouillon"
    ],
    "mouillure": [
        "mouillure"
    ],
    "mouillures": [
        "mouillure"
    ],
    "mouillerent": [
        "mouiller"
    ],
    "mouillee": [
        "mouille",
        "mouiller"
    ],
    "mouillees": [
        "mouille",
        "mouiller"
    ],
    "mouise": [
        "mouise"
    ],
    "moujahid": [
        "moujahid"
    ],
    "moujik": [
        "moujik"
    ],
    "moujiks": [
        "moujik"
    ],
    "moujingue": [
        "moujingue"
    ],
    "moujingues": [
        "moujingue"
    ],
    "moukere": [
        "moukere"
    ],
    "moukeres": [
        "moukere"
    ],
    "moula": [
        "mouler"
    ],
    "moulage": [
        "moulage"
    ],
    "moulages": [
        "moulage"
    ],
    "moulaient": [
        "mouler"
    ],
    "moulait": [
        "mouler"
    ],
    "moulant": [
        "mouler",
        "moulant"
    ],
    "moulante": [
        "moulant"
    ],
    "moulantes": [
        "moulant"
    ],
    "moulants": [
        "moulant"
    ],
    "moule": [
        "moule",
        "mouler"
    ],
    "moulent": [
        "mouler"
    ],
    "mouler": [
        "mouler"
    ],
    "mouleraient": [
        "mouler"
    ],
    "moulerait": [
        "mouler"
    ],
    "moules": [
        "moule",
        "mouler"
    ],
    "mouleur": [
        "mouleur"
    ],
    "moulez": [
        "moudre",
        "mouler"
    ],
    "moulin": [
        "moulin"
    ],
    "moulinage": [
        "moulinage"
    ],
    "moulinait": [
        "mouliner"
    ],
    "mouline": [
        "mouliner"
    ],
    "moulinent": [
        "mouliner"
    ],
    "mouliner": [
        "mouliner"
    ],
    "moulines": [
        "mouliner"
    ],
    "moulinet": [
        "moulinet"
    ],
    "moulinets": [
        "moulinet"
    ],
    "moulinette": [
        "moulinette"
    ],
    "moulinettes": [
        "moulinette"
    ],
    "moulinez": [
        "mouliner"
    ],
    "moulins": [
        "moulin"
    ],
    "moult": [
        "moult"
    ],
    "moulu": [
        "moudre",
        "moulu"
    ],
    "moulue": [
        "moudre",
        "moulu"
    ],
    "moulues": [
        "moudre",
        "moulu"
    ],
    "moulurations": [
        "mouluration"
    ],
    "moulure": [
        "moulurer",
        "moulure"
    ],
    "moulures": [
        "moulure"
    ],
    "moulus": [
        "moudre",
        "moulu"
    ],
    "moulut": [
        "moudre"
    ],
    "moulee": [
        "moule",
        "mouler"
    ],
    "moulees": [
        "moule",
        "mouler"
    ],
    "moumounes": [
        "moumoune"
    ],
    "moumoute": [
        "moumoute"
    ],
    "moumoutes": [
        "moumoute"
    ],
    "mound": [
        "mound"
    ],
    "mouquere": [
        "mouquere"
    ],
    "mouraient": [
        "mourir"
    ],
    "mourais": [
        "mourir"
    ],
    "mourait": [
        "mourir"
    ],
    "mourant": [
        "mourir",
        "mourant"
    ],
    "mourante": [
        "mourant"
    ],
    "mourantes": [
        "mourant"
    ],
    "mourants": [
        "mourant"
    ],
    "mourez": [
        "mourir"
    ],
    "mourides": [
        "mouride"
    ],
    "mouriez": [
        "mourir"
    ],
    "mourions": [
        "mourir"
    ],
    "mourir": [
        "mourir"
    ],
    "mouroir": [
        "mouroir"
    ],
    "mouron": [
        "mouron"
    ],
    "mouronne": [
        "mouronner"
    ],
    "mouronner": [
        "mouronner"
    ],
    "mourons": [
        "mourir",
        "mouron"
    ],
    "mourra": [
        "mourir"
    ],
    "mourrai": [
        "mourir"
    ],
    "mourraient": [
        "mourir"
    ],
    "mourrais": [
        "mourir"
    ],
    "mourrait": [
        "mourir"
    ],
    "mourras": [
        "mourir"
    ],
    "mourre": [
        "mourre"
    ],
    "mourrez": [
        "mourir"
    ],
    "mourriez": [
        "mourir"
    ],
    "mourrions": [
        "mourir"
    ],
    "mourrons": [
        "mourir"
    ],
    "mourront": [
        "mourir"
    ],
    "moururent": [
        "mourir"
    ],
    "mourus": [
        "mourir"
    ],
    "mourussent": [
        "mourir"
    ],
    "mourut": [
        "mourir"
    ],
    "mourutes": [
        "mourir"
    ],
    "mous": [
        "mou"
    ],
    "mouscaille": [
        "mouscaille"
    ],
    "mouscailles": [
        "mouscaille"
    ],
    "mousme": [
        "mousme"
    ],
    "mousmes": [
        "mousme"
    ],
    "mousquet": [
        "mousquet"
    ],
    "mousquetades": [
        "mousquetade"
    ],
    "mousquetaire": [
        "mousquetaire"
    ],
    "mousquetaires": [
        "mousquetaire"
    ],
    "mousqueterie": [
        "mousqueterie"
    ],
    "mousqueton": [
        "mousqueton"
    ],
    "mousquetons": [
        "mousqueton"
    ],
    "mousquets": [
        "mousquet"
    ],
    "moussage": [
        "moussage"
    ],
    "moussaient": [
        "mousser"
    ],
    "moussaillon": [
        "moussaillon"
    ],
    "moussaillons": [
        "moussaillon"
    ],
    "moussait": [
        "mousser"
    ],
    "moussaka": [
        "moussaka"
    ],
    "moussakas": [
        "moussaka"
    ],
    "moussant": [
        "mousser",
        "moussant"
    ],
    "moussante": [
        "moussant"
    ],
    "moussants": [
        "moussant"
    ],
    "mousse": [
        "mousser",
        "mousse"
    ],
    "mousseline": [
        "mousseline"
    ],
    "mousselines": [
        "mousseline"
    ],
    "moussent": [
        "mousser"
    ],
    "mousser": [
        "mousser"
    ],
    "mousseron": [
        "mousseron"
    ],
    "mousserons": [
        "mousseron"
    ],
    "mousses": [
        "mousse"
    ],
    "mousseuse": [
        "mousseux"
    ],
    "mousseuses": [
        "mousseux"
    ],
    "mousseux": [
        "mousseux"
    ],
    "mousson": [
        "mousson"
    ],
    "moussons": [
        "mousson"
    ],
    "moussu": [
        "moussu"
    ],
    "moussue": [
        "moussu"
    ],
    "moussues": [
        "moussu"
    ],
    "moussus": [
        "moussu"
    ],
    "moustache": [
        "moustache"
    ],
    "moustaches": [
        "moustache"
    ],
    "moustachu": [
        "moustachu"
    ],
    "moustachue": [
        "moustachu"
    ],
    "moustachues": [
        "moustachu"
    ],
    "moustachus": [
        "moustachu"
    ],
    "moustagache": [
        "moustagache"
    ],
    "moustagaches": [
        "moustagache"
    ],
    "moustiquaire": [
        "moustiquaire"
    ],
    "moustiquaires": [
        "moustiquaire"
    ],
    "moustique": [
        "moustique"
    ],
    "moustiques": [
        "moustique"
    ],
    "moutard": [
        "moutard"
    ],
    "moutarde": [
        "moutarder",
        "moutarde"
    ],
    "moutardes": [
        "moutarde"
    ],
    "moutardier": [
        "moutardier"
    ],
    "moutards": [
        "moutard"
    ],
    "moutier": [
        "moutier"
    ],
    "mouton": [
        "mouton"
    ],
    "moutonnaient": [
        "moutonner"
    ],
    "moutonnait": [
        "moutonner"
    ],
    "moutonnant": [
        "moutonnant",
        "moutonner"
    ],
    "moutonnante": [
        "moutonnant"
    ],
    "moutonnantes": [
        "moutonnant"
    ],
    "moutonnants": [
        "moutonnant"
    ],
    "moutonne": [
        "moutonner"
    ],
    "moutonnement": [
        "moutonnement"
    ],
    "moutonnements": [
        "moutonnement"
    ],
    "moutonnent": [
        "moutonner"
    ],
    "moutonner": [
        "moutonner"
    ],
    "moutonnerie": [
        "moutonnerie"
    ],
    "moutonneux": [
        "moutonneux"
    ],
    "moutonnier": [
        "moutonnier"
    ],
    "moutonniers": [
        "moutonnier"
    ],
    "moutonniere": [
        "moutonnier"
    ],
    "moutons": [
        "mouton"
    ],
    "mouture": [
        "mouture"
    ],
    "moutures": [
        "mouture"
    ],
    "mouvaient": [
        "mouvoir"
    ],
    "mouvais": [
        "mouvoir"
    ],
    "mouvait": [
        "mouvoir"
    ],
    "mouvance": [
        "mouvance"
    ],
    "mouvances": [
        "mouvance"
    ],
    "mouvant": [
        "mouvant",
        "mouvoir"
    ],
    "mouvante": [
        "mouvant"
    ],
    "mouvantes": [
        "mouvant"
    ],
    "mouvants": [
        "mouvant"
    ],
    "mouvement": [
        "mouvement"
    ],
    "mouvementent": [
        "mouvementer"
    ],
    "mouvements": [
        "mouvement"
    ],
    "mouvemente": [
        "mouvementer",
        "mouvemente"
    ],
    "mouvementee": [
        "mouvementer",
        "mouvemente"
    ],
    "mouvementees": [
        "mouvementer",
        "mouvemente"
    ],
    "mouvementes": [
        "mouvementer",
        "mouvemente"
    ],
    "mouvoir": [
        "mouvoir"
    ],
    "moyen": [
        "moyen"
    ],
    "moyennant": [
        "moyennant",
        "moyenner"
    ],
    "moyenne": [
        "moyenner",
        "moyenne",
        "moyen"
    ],
    "moyennement": [
        "moyennement"
    ],
    "moyenner": [
        "moyenner"
    ],
    "moyennes": [
        "moyenne",
        "moyen"
    ],
    "moyens": [
        "moyen"
    ],
    "moyenageuse": [
        "moyenageux"
    ],
    "moyenageuses": [
        "moyenageux"
    ],
    "moyenageux": [
        "moyenageux"
    ],
    "moyer": [
        "moyer"
    ],
    "moyeu": [
        "moyeu"
    ],
    "moyeux": [
        "moyeux"
    ],
    "mozarabe": [
        "mozarabe"
    ],
    "mozartiennes": [
        "mozartien"
    ],
    "mozzarella": [
        "mozzarella"
    ],
    "mozzarelle": [
        "mozzarelle"
    ],
    "mout": [
        "mout"
    ],
    "mouts": [
        "mout"
    ],
    "mua": [
        "muer"
    ],
    "muai": [
        "muer"
    ],
    "muaient": [
        "muer"
    ],
    "muait": [
        "muer"
    ],
    "muant": [
        "muer"
    ],
    "muchacho": [
        "muchacho"
    ],
    "muchachos": [
        "muchacho"
    ],
    "muchas": [
        "mucher"
    ],
    "muche": [
        "mucher"
    ],
    "mucilage": [
        "mucilage"
    ],
    "mucilagineuse": [
        "mucilagineux"
    ],
    "mucor": [
        "mucor"
    ],
    "mucosite": [
        "mucosite"
    ],
    "mucosites": [
        "mucosite"
    ],
    "mucoviscidose": [
        "mucoviscidose"
    ],
    "mucus": [
        "mucus"
    ],
    "mudejar": [
        "mudejar"
    ],
    "mudejare": [
        "mudejar"
    ],
    "mue": [
        "muer",
        "mue"
    ],
    "muent": [
        "muer"
    ],
    "muer": [
        "muer"
    ],
    "muera": [
        "muer"
    ],
    "mueront": [
        "muer"
    ],
    "mues": [
        "muer",
        "mue"
    ],
    "muesli": [
        "muesli"
    ],
    "muet": [
        "muet"
    ],
    "muets": [
        "muet"
    ],
    "muette": [
        "muette",
        "muet"
    ],
    "muettement": [
        "muettement"
    ],
    "muettes": [
        "muette",
        "muet"
    ],
    "muezzin": [
        "muezzin"
    ],
    "muezzins": [
        "muezzin"
    ],
    "muffin": [
        "muffin"
    ],
    "muffins": [
        "muffin"
    ],
    "mufle": [
        "mufle"
    ],
    "muflerie": [
        "muflerie"
    ],
    "mufleries": [
        "muflerie"
    ],
    "mufles": [
        "mufle"
    ],
    "muflier": [
        "muflier"
    ],
    "mufliers": [
        "muflier"
    ],
    "muflee": [
        "muflee"
    ],
    "mufti": [
        "mufti"
    ],
    "muftis": [
        "mufti"
    ],
    "muges": [
        "muge"
    ],
    "mugi": [
        "mugir"
    ],
    "mugir": [
        "mugir"
    ],
    "mugis": [
        "mugir"
    ],
    "mugissaient": [
        "mugir"
    ],
    "mugissait": [
        "mugir"
    ],
    "mugissant": [
        "mugir",
        "mugissant"
    ],
    "mugissante": [
        "mugissant"
    ],
    "mugissantes": [
        "mugissant"
    ],
    "mugissants": [
        "mugissant"
    ],
    "mugissement": [
        "mugissement"
    ],
    "mugissements": [
        "mugissement"
    ],
    "mugissent": [
        "mugir"
    ],
    "mugit": [
        "mugir"
    ],
    "muguet": [
        "muguet"
    ],
    "muguets": [
        "muguet"
    ],
    "muguette": [
        "mugueter"
    ],
    "muids": [
        "muid"
    ],
    "mulard": [
        "mulard"
    ],
    "mule": [
        "mule"
    ],
    "mules": [
        "mule"
    ],
    "mulet": [
        "mulet"
    ],
    "muleta": [
        "muleta"
    ],
    "muletier": [
        "muletier"
    ],
    "muletiers": [
        "muletier"
    ],
    "muletiere": [
        "muletier"
    ],
    "mulets": [
        "mulet"
    ],
    "mulettes": [
        "mulette"
    ],
    "mulhousien": [
        "mulhousien"
    ],
    "mullah": [
        "mullah"
    ],
    "mulon": [
        "mulon"
    ],
    "mulot": [
        "mulot"
    ],
    "mulots": [
        "mulot"
    ],
    "multi": [
        "multi"
    ],
    "multicellulaire": [
        "multicellulaire"
    ],
    "multicolore": [
        "multicolore"
    ],
    "multicolores": [
        "multicolore"
    ],
    "multiconfessionnel": [
        "multiconfessionnel"
    ],
    "multicouche": [
        "multicouche"
    ],
    "multiculturalisme": [
        "multiculturalisme"
    ],
    "multiculturel": [
        "multiculturel"
    ],
    "multiculturelle": [
        "multiculturel"
    ],
    "multidimensionnel": [
        "multidimensionnel"
    ],
    "multidimensionnelle": [
        "multidimensionnel"
    ],
    "multidimensionnels": [
        "multidimensionnel"
    ],
    "multidisciplinaire": [
        "multidisciplinaire"
    ],
    "multifamilial": [
        "multifamilial"
    ],
    "multifonction": [
        "multifonction"
    ],
    "multifonctionnel": [
        "multifonctionnel"
    ],
    "multifonctions": [
        "multifonctions"
    ],
    "multiforme": [
        "multiforme"
    ],
    "multiformes": [
        "multiforme"
    ],
    "multifrequences": [
        "multifrequence"
    ],
    "multigrade": [
        "multigrade"
    ],
    "multimilliardaire": [
        "multimilliardaire"
    ],
    "multimillionnaire": [
        "multimillionnaire"
    ],
    "multimillionnaires": [
        "multimillionnaire"
    ],
    "multimedia": [
        "multimedia"
    ],
    "multinational": [
        "multinational"
    ],
    "multinationale": [
        "multinational",
        "multinationale"
    ],
    "multinationales": [
        "multinational",
        "multinationale"
    ],
    "multinationaux": [
        "multinational"
    ],
    "multipare": [
        "multipare"
    ],
    "multipartite": [
        "multipartite"
    ],
    "multiple": [
        "multiple"
    ],
    "multiples": [
        "multiple"
    ],
    "multiplex": [
        "multiplex"
    ],
    "multiplexe": [
        "multiplexer",
        "multiplexe"
    ],
    "multiplexer": [
        "multiplexer"
    ],
    "multiplexes": [
        "multiplexe"
    ],
    "multiplia": [
        "multiplier"
    ],
    "multipliai": [
        "multiplier"
    ],
    "multipliaient": [
        "multiplier"
    ],
    "multipliais": [
        "multiplier"
    ],
    "multipliait": [
        "multiplier"
    ],
    "multipliant": [
        "multiplier"
    ],
    "multiplicateur": [
        "multiplicateur"
    ],
    "multiplication": [
        "multiplication"
    ],
    "multiplications": [
        "multiplication"
    ],
    "multiplicite": [
        "multiplicite"
    ],
    "multiplicites": [
        "multiplicite"
    ],
    "multiplie": [
        "multiplie",
        "multiplier"
    ],
    "multiplient": [
        "multiplier"
    ],
    "multiplier": [
        "multiplier"
    ],
    "multiplierai": [
        "multiplier"
    ],
    "multiplieraient": [
        "multiplier"
    ],
    "multiplierait": [
        "multiplier"
    ],
    "multiplierons": [
        "multiplier"
    ],
    "multiplieront": [
        "multiplier"
    ],
    "multiplies": [
        "multiply",
        "multiplie",
        "multiplier"
    ],
    "multipliez": [
        "multiplier"
    ],
    "multipliions": [
        "multiplier"
    ],
    "multipliat": [
        "multiplier"
    ],
    "multiplierent": [
        "multiplier"
    ],
    "multipliee": [
        "multiplie",
        "multiplier"
    ],
    "multipliees": [
        "multiplie",
        "multiplier"
    ],
    "multipoints": [
        "multipoints"
    ],
    "multiprise": [
        "multiprise"
    ],
    "multipropriete": [
        "multipropriete"
    ],
    "multiracial": [
        "multiracial"
    ],
    "multiraciale": [
        "multiracial"
    ],
    "multiraciaux": [
        "multiracial"
    ],
    "multirisque": [
        "multirisque"
    ],
    "multirecidiviste": [
        "multirecidiviste"
    ],
    "multiseculaires": [
        "multiseculaire"
    ],
    "multitude": [
        "multitude"
    ],
    "multitudes": [
        "multitude"
    ],
    "multitache": [
        "multitache"
    ],
    "multitaches": [
        "multitache"
    ],
    "mulatre": [
        "mulatre"
    ],
    "mulatres": [
        "mulatre"
    ],
    "mulatresse": [
        "mulatresse"
    ],
    "mulatresses": [
        "mulatresse"
    ],
    "mungo": [
        "mungo"
    ],
    "muni": [
        "munir",
        "muni"
    ],
    "munich": [
        "munich"
    ],
    "munichois": [
        "munichois"
    ],
    "munichoise": [
        "munichois"
    ],
    "municipal": [
        "municipal"
    ],
    "municipale": [
        "municipal"
    ],
    "municipales": [
        "municipal"
    ],
    "municipalite": [
        "municipalite"
    ],
    "municipalites": [
        "municipalite"
    ],
    "municipaux": [
        "municipal"
    ],
    "municipe": [
        "municipe"
    ],
    "municipes": [
        "municipe"
    ],
    "munie": [
        "munir",
        "muni"
    ],
    "munies": [
        "munir"
    ],
    "munificence": [
        "munificence"
    ],
    "munificences": [
        "munificence"
    ],
    "munificente": [
        "munificent"
    ],
    "munificents": [
        "munificent"
    ],
    "munir": [
        "munir"
    ],
    "munis": [
        "munir",
        "muni"
    ],
    "munissaient": [
        "munir"
    ],
    "munissait": [
        "munir"
    ],
    "munissant": [
        "munir"
    ],
    "munissent": [
        "munir"
    ],
    "munit": [
        "munir"
    ],
    "munition": [
        "munition"
    ],
    "munitions": [
        "munition"
    ],
    "munster": [
        "munster"
    ],
    "muon": [
        "muon"
    ],
    "muphti": [
        "muphti"
    ],
    "muqueuse": [
        "muqueux"
    ],
    "muqueuses": [
        "muqueux",
        "muqueuse"
    ],
    "muqueux": [
        "muqueux"
    ],
    "mur": [
        "mur"
    ],
    "mura": [
        "murer"
    ],
    "murage": [
        "murage"
    ],
    "muraient": [
        "murer"
    ],
    "muraille": [
        "muraille"
    ],
    "murailles": [
        "muraille"
    ],
    "murait": [
        "murer"
    ],
    "mural": [
        "mural"
    ],
    "murale": [
        "mural"
    ],
    "murales": [
        "mural"
    ],
    "murant": [
        "murer"
    ],
    "muraux": [
        "mural"
    ],
    "mure": [
        "mur",
        "murer"
    ],
    "murent": [
        "mouvoir"
    ],
    "murer": [
        "murer"
    ],
    "murerait": [
        "murer"
    ],
    "mures": [
        "mur",
        "murer"
    ],
    "muret": [
        "muret"
    ],
    "muretin": [
        "muretin"
    ],
    "muretins": [
        "muretin"
    ],
    "murets": [
        "muret"
    ],
    "murette": [
        "murette"
    ],
    "murettes": [
        "murette"
    ],
    "murex": [
        "murex"
    ],
    "murez": [
        "murer"
    ],
    "muriatique": [
        "muriatique"
    ],
    "murides": [
        "muride"
    ],
    "murin": [
        "murin"
    ],
    "murmel": [
        "murmel"
    ],
    "murmura": [
        "murmurer"
    ],
    "murmurai": [
        "murmurer"
    ],
    "murmuraient": [
        "murmurer"
    ],
    "murmurais": [
        "murmurer"
    ],
    "murmurait": [
        "murmurer"
    ],
    "murmurant": [
        "murmurant",
        "murmurer"
    ],
    "murmurante": [
        "murmurant"
    ],
    "murmurantes": [
        "murmurant"
    ],
    "murmurants": [
        "murmurant"
    ],
    "murmuras": [
        "murmurer"
    ],
    "murmure": [
        "murmure",
        "murmurer"
    ],
    "murmurent": [
        "murmurer"
    ],
    "murmurer": [
        "murmurer"
    ],
    "murmurera": [
        "murmurer"
    ],
    "murmureraient": [
        "murmurer"
    ],
    "murmurerait": [
        "murmurer"
    ],
    "murmureront": [
        "murmurer"
    ],
    "murmures": [
        "murmure",
        "murmurer"
    ],
    "murmurez": [
        "murmurer"
    ],
    "murmurions": [
        "murmurer"
    ],
    "murmurerent": [
        "murmurer"
    ],
    "murmuree": [
        "murmurer"
    ],
    "murmurees": [
        "murmurer"
    ],
    "murs": [
        "mur"
    ],
    "murene": [
        "murene"
    ],
    "murenes": [
        "murene"
    ],
    "murerent": [
        "murer"
    ],
    "muree": [
        "murer"
    ],
    "murees": [
        "murer"
    ],
    "mus": [
        "mouvoir",
        "mu"
    ],
    "musa": [
        "muser"
    ],
    "musagetes": [
        "musagete"
    ],
    "musait": [
        "muser"
    ],
    "musant": [
        "muser"
    ],
    "musaraigne": [
        "musaraigne"
    ],
    "musaraignes": [
        "musaraigne"
    ],
    "musard": [
        "musard"
    ],
    "musarda": [
        "musarder"
    ],
    "musardaient": [
        "musarder"
    ],
    "musardait": [
        "musarder"
    ],
    "musardant": [
        "musarder"
    ],
    "musarde": [
        "musarder"
    ],
    "musarder": [
        "musarder"
    ],
    "musardez": [
        "musarder"
    ],
    "musardise": [
        "musardise"
    ],
    "musards": [
        "musard"
    ],
    "musc": [
        "musc"
    ],
    "muscade": [
        "muscade"
    ],
    "muscadelle": [
        "muscadelle"
    ],
    "muscadet": [
        "muscadet"
    ],
    "muscadin": [
        "muscadin"
    ],
    "muscadine": [
        "muscadine"
    ],
    "muscat": [
        "muscat"
    ],
    "muscats": [
        "muscat"
    ],
    "musclant": [
        "muscler"
    ],
    "muscle": [
        "muscler",
        "muscle"
    ],
    "musclent": [
        "muscler"
    ],
    "muscler": [
        "muscler"
    ],
    "muscles": [
        "muscler",
        "muscle"
    ],
    "musclee": [
        "muscler",
        "muscle"
    ],
    "musclees": [
        "muscler",
        "muscle"
    ],
    "muscovite": [
        "muscovite"
    ],
    "musculaire": [
        "musculaire"
    ],
    "musculaires": [
        "musculaire"
    ],
    "musculation": [
        "musculation"
    ],
    "musculature": [
        "musculature"
    ],
    "musculeuse": [
        "musculeux"
    ],
    "musculeuses": [
        "musculeux"
    ],
    "musculeux": [
        "musculeux"
    ],
    "muse": [
        "muser",
        "muse"
    ],
    "museau": [
        "museau"
    ],
    "museaux": [
        "museau"
    ],
    "muselait": [
        "museler"
    ],
    "muselant": [
        "museler"
    ],
    "museler": [
        "museler"
    ],
    "museliere": [
        "museliere"
    ],
    "muselieres": [
        "museliere"
    ],
    "muselle": [
        "museler"
    ],
    "musellerait": [
        "museler"
    ],
    "muselons": [
        "museler"
    ],
    "musele": [
        "museler"
    ],
    "muselee": [
        "museler"
    ],
    "muselees": [
        "museler"
    ],
    "museles": [
        "museler"
    ],
    "muser": [
        "muser"
    ],
    "muserolle": [
        "muserolle"
    ],
    "muses": [
        "muse"
    ],
    "musette": [
        "musette"
    ],
    "musettes": [
        "musette"
    ],
    "musical": [
        "musical"
    ],
    "musicale": [
        "musical"
    ],
    "musicalement": [
        "musicalement"
    ],
    "musicales": [
        "musical"
    ],
    "musicalite": [
        "musicalite"
    ],
    "musicaux": [
        "musical"
    ],
    "musicien": [
        "musicien"
    ],
    "musicienne": [
        "musicien"
    ],
    "musiciennes": [
        "musicien"
    ],
    "musiciens": [
        "musicien"
    ],
    "musico": [
        "musico"
    ],
    "musicographes": [
        "musicographe"
    ],
    "musicologie": [
        "musicologie"
    ],
    "musicologique": [
        "musicologique"
    ],
    "musicologue": [
        "musicologue"
    ],
    "musicologues": [
        "musicologue"
    ],
    "musicotherapie": [
        "musicotherapie"
    ],
    "musiquait": [
        "musiquer"
    ],
    "musique": [
        "musique",
        "musiquer"
    ],
    "musiquer": [
        "musiquer"
    ],
    "musiques": [
        "musique",
        "musiquer"
    ],
    "musiquette": [
        "musiquette"
    ],
    "musiquettes": [
        "musiquette"
    ],
    "muskogee": [
        "muskogee"
    ],
    "musoir": [
        "musoir"
    ],
    "musque": [
        "musque",
        "musquer"
    ],
    "musquee": [
        "musque",
        "musquer"
    ],
    "musquees": [
        "musque",
        "musquer"
    ],
    "musques": [
        "musque"
    ],
    "mussais": [
        "musser"
    ],
    "musse": [
        "musser"
    ],
    "mussent": [
        "musser"
    ],
    "mussolinien": [
        "mussolinien"
    ],
    "mussolinienne": [
        "mussolinien"
    ],
    "mussoliniens": [
        "mussolinien"
    ],
    "mussee": [
        "musser"
    ],
    "musses": [
        "musser"
    ],
    "must": [
        "must"
    ],
    "mustang": [
        "mustang"
    ],
    "mustangs": [
        "mustang"
    ],
    "mustelides": [
        "mustelide"
    ],
    "musulman": [
        "musulman"
    ],
    "musulmane": [
        "musulman"
    ],
    "musulmanes": [
        "musulman"
    ],
    "musulmans": [
        "musulman"
    ],
    "musee": [
        "muser",
        "musee"
    ],
    "musees": [
        "muser",
        "musee"
    ],
    "museologie": [
        "museologie"
    ],
    "museologique": [
        "museologique"
    ],
    "museologue": [
        "museologue"
    ],
    "museum": [
        "museum"
    ],
    "mutabilite": [
        "mutabilite"
    ],
    "mutable": [
        "mutable"
    ],
    "mutables": [
        "mutable"
    ],
    "mutagene": [
        "mutagene"
    ],
    "mutant": [
        "mutant",
        "muter"
    ],
    "mutante": [
        "mutant"
    ],
    "mutantes": [
        "mutant"
    ],
    "mutants": [
        "mutant"
    ],
    "mutation": [
        "mutation"
    ],
    "mutations": [
        "mutation"
    ],
    "mute": [
        "muter"
    ],
    "mutent": [
        "muter"
    ],
    "muter": [
        "muter"
    ],
    "mutera": [
        "muter"
    ],
    "muterai": [
        "muter"
    ],
    "muteront": [
        "muter"
    ],
    "mutila": [
        "mutiler"
    ],
    "mutilais": [
        "mutiler"
    ],
    "mutilait": [
        "mutiler"
    ],
    "mutilant": [
        "mutiler",
        "mutilant"
    ],
    "mutilante": [
        "mutilant"
    ],
    "mutilateur": [
        "mutilateur"
    ],
    "mutilation": [
        "mutilation"
    ],
    "mutilations": [
        "mutilation"
    ],
    "mutile": [
        "mutiler",
        "mutile"
    ],
    "mutilent": [
        "mutiler"
    ],
    "mutiler": [
        "mutiler"
    ],
    "mutilera": [
        "mutiler"
    ],
    "mutileraient": [
        "mutiler"
    ],
    "mutilee": [
        "mutiler",
        "mutile"
    ],
    "mutilees": [
        "mutiler",
        "mutile"
    ],
    "mutiles": [
        "mutiler",
        "mutile"
    ],
    "mutin": [
        "mutin"
    ],
    "mutina": [
        "mutiner"
    ],
    "mutinaient": [
        "mutiner"
    ],
    "mutine": [
        "mutin",
        "mutine",
        "mutiner"
    ],
    "mutinent": [
        "mutiner"
    ],
    "mutiner": [
        "mutiner"
    ],
    "mutinerie": [
        "mutinerie"
    ],
    "mutineries": [
        "mutinerie"
    ],
    "mutines": [
        "mutin",
        "mutine",
        "mutiner"
    ],
    "mutinez": [
        "mutiner"
    ],
    "mutins": [
        "mutin"
    ],
    "mutinee": [
        "mutiner"
    ],
    "mutique": [
        "mutique"
    ],
    "mutisme": [
        "mutisme"
    ],
    "mutismes": [
        "mutisme"
    ],
    "mutite": [
        "mutite"
    ],
    "mutualisme": [
        "mutualisme"
    ],
    "mutualite": [
        "mutualite"
    ],
    "mutualites": [
        "mutualite"
    ],
    "mutuel": [
        "mutuel"
    ],
    "mutuelle": [
        "mutuel"
    ],
    "mutuellement": [
        "mutuellement"
    ],
    "mutuelles": [
        "mutuel"
    ],
    "mutuels": [
        "mutuel"
    ],
    "mutat": [
        "muter"
    ],
    "mutee": [
        "muter"
    ],
    "mutees": [
        "muter"
    ],
    "mutes": [
        "mute",
        "muter"
    ],
    "muee": [
        "muer"
    ],
    "muees": [
        "muer"
    ],
    "myasthenie": [
        "myasthenie"
    ],
    "mycologie": [
        "mycologie"
    ],
    "mycologue": [
        "mycologue"
    ],
    "mycologues": [
        "mycologue"
    ],
    "mycose": [
        "mycose"
    ],
    "mycene": [
        "mycene"
    ],
    "mycenien": [
        "mycenien"
    ],
    "myceniennes": [
        "mycenien"
    ],
    "myceniens": [
        "mycenien"
    ],
    "mygale": [
        "mygale"
    ],
    "mygales": [
        "mygale"
    ],
    "mylord": [
        "mylord"
    ],
    "myocarde": [
        "myocarde"
    ],
    "myocardiopathie": [
        "myocardiopathie"
    ],
    "myocardique": [
        "myocardique"
    ],
    "myocardite": [
        "myocardite"
    ],
    "myoclonie": [
        "myoclonie"
    ],
    "myoglobine": [
        "myoglobine"
    ],
    "myographe": [
        "myographe"
    ],
    "myopathes": [
        "myopathe"
    ],
    "myopathie": [
        "myopathie"
    ],
    "myopathique": [
        "myopathique"
    ],
    "myope": [
        "myope"
    ],
    "myopes": [
        "myope"
    ],
    "myopie": [
        "myopie"
    ],
    "myopies": [
        "myopie"
    ],
    "myosine": [
        "myosine"
    ],
    "myosis": [
        "myosis"
    ],
    "myosotis": [
        "myosotis"
    ],
    "myriade": [
        "myriade"
    ],
    "myriades": [
        "myriade"
    ],
    "myriophylle": [
        "myriophylle"
    ],
    "myrmidon": [
        "myrmidon"
    ],
    "myrmidons": [
        "myrmidon"
    ],
    "myrrhe": [
        "myrrhe"
    ],
    "myrte": [
        "myrte"
    ],
    "myrtes": [
        "myrte"
    ],
    "myrtille": [
        "myrtille"
    ],
    "myrtilles": [
        "myrtille"
    ],
    "mystagogie": [
        "mystagogie"
    ],
    "mystagogique": [
        "mystagogique"
    ],
    "mystagogue": [
        "mystagogue"
    ],
    "myste": [
        "myste"
    ],
    "mysticisme": [
        "mysticisme"
    ],
    "mysticismes": [
        "mysticisme"
    ],
    "mystificateur": [
        "mystificateur"
    ],
    "mystificateurs": [
        "mystificateur"
    ],
    "mystification": [
        "mystification"
    ],
    "mystifications": [
        "mystification"
    ],
    "mystificatrice": [
        "mystificateur"
    ],
    "mystifie": [
        "mystifier"
    ],
    "mystifier": [
        "mystifier"
    ],
    "mystifiee": [
        "mystifier"
    ],
    "mystifiees": [
        "mystifier"
    ],
    "mystifies": [
        "mystifier",
        "mystify"
    ],
    "mystique": [
        "mystique"
    ],
    "mystiquement": [
        "mystiquement"
    ],
    "mystiques": [
        "mystique"
    ],
    "mystere": [
        "mystere"
    ],
    "mysteres": [
        "mystere"
    ],
    "mysterieuse": [
        "mysterieux"
    ],
    "mysterieusement": [
        "mysterieusement"
    ],
    "mysterieuses": [
        "mysterieux"
    ],
    "mysterieux": [
        "mysterieux"
    ],
    "mythe": [
        "mythe"
    ],
    "mythes": [
        "mythe"
    ],
    "mythifiait": [
        "mythifier"
    ],
    "mythifier": [
        "mythifier"
    ],
    "mythique": [
        "mythique"
    ],
    "mythiques": [
        "mythique"
    ],
    "mythisation": [
        "mythisation"
    ],
    "mytho": [
        "mytho"
    ],
    "mythologie": [
        "mythologie"
    ],
    "mythologies": [
        "mythology",
        "mythologie"
    ],
    "mythologique": [
        "mythologique"
    ],
    "mythologiques": [
        "mythologique"
    ],
    "mythologise": [
        "mythologiser"
    ],
    "mythologue": [
        "mythologue"
    ],
    "mythologues": [
        "mythologue"
    ],
    "mythomane": [
        "mythomane"
    ],
    "mythomanes": [
        "mythomane"
    ],
    "mythomanie": [
        "mythomanie"
    ],
    "myxoedemateuse": [
        "myxoedemateux"
    ],
    "myxomatose": [
        "myxomatose"
    ],
    "myeline": [
        "myeline"
    ],
    "myelite": [
        "myelite"
    ],
    "myeloblaste": [
        "myeloblaste"
    ],
    "myeloblastes": [
        "myeloblaste"
    ],
    "myeloide": [
        "myeloide"
    ],
    "macha": [
        "macher"
    ],
    "machage": [
        "machage"
    ],
    "machaient": [
        "macher"
    ],
    "machais": [
        "macher"
    ],
    "machait": [
        "macher"
    ],
    "machant": [
        "macher"
    ],
    "mache": [
        "mache",
        "macher"
    ],
    "machefer": [
        "machefer"
    ],
    "machent": [
        "macher"
    ],
    "macher": [
        "macher"
    ],
    "macherai": [
        "macher"
    ],
    "macherais": [
        "macher"
    ],
    "macherait": [
        "macher"
    ],
    "macherez": [
        "macher"
    ],
    "maches": [
        "macher"
    ],
    "macheur": [
        "macheur"
    ],
    "macheurs": [
        "macheur"
    ],
    "macheuse": [
        "macheur"
    ],
    "machez": [
        "macher"
    ],
    "machicoulis": [
        "machicoulis"
    ],
    "machoire": [
        "machoire"
    ],
    "machoires": [
        "machoire"
    ],
    "machonna": [
        "machonner"
    ],
    "machonnaient": [
        "machonner"
    ],
    "machonnais": [
        "machonner"
    ],
    "machonnait": [
        "machonner"
    ],
    "machonnant": [
        "machonner"
    ],
    "machonne": [
        "machonner"
    ],
    "machonnements": [
        "machonnement"
    ],
    "machonnent": [
        "machonner"
    ],
    "machonner": [
        "machonner"
    ],
    "machonnes": [
        "machonner"
    ],
    "machons": [
        "macher"
    ],
    "machouilla": [
        "machouiller"
    ],
    "machouillait": [
        "machouiller"
    ],
    "machouillant": [
        "machouiller"
    ],
    "machouille": [
        "machouiller"
    ],
    "machouiller": [
        "machouiller"
    ],
    "machouilles": [
        "machouiller"
    ],
    "machouilleur": [
        "machouilleur"
    ],
    "machouillee": [
        "machouiller"
    ],
    "machure": [
        "machurer"
    ],
    "machuree": [
        "machurer"
    ],
    "macherent": [
        "macher"
    ],
    "machee": [
        "macher"
    ],
    "maconnaise": [
        "maconnais"
    ],
    "maconnaises": [
        "maconnais"
    ],
    "manes": [
        "mane",
        "manes"
    ],
    "matinant": [
        "matiner"
    ],
    "matine": [
        "matiner",
        "matine"
    ],
    "meche": [
        "meche"
    ],
    "meches": [
        "meche"
    ],
    "menent": [
        "mener"
    ],
    "menera": [
        "mener"
    ],
    "menerai": [
        "mener"
    ],
    "meneraient": [
        "mener"
    ],
    "menerais": [
        "mener"
    ],
    "menerait": [
        "mener"
    ],
    "meneras": [
        "mener"
    ],
    "menerez": [
        "mener"
    ],
    "menerons": [
        "mener"
    ],
    "meneront": [
        "mener"
    ],
    "mere": [
        "mere"
    ],
    "meres": [
        "mere"
    ],
    "metre": [
        "metre",
        "metrer"
    ],
    "metres": [
        "metre",
        "metrer"
    ],
    "meandre": [
        "meandre"
    ],
    "meandres": [
        "meandre"
    ],
    "meandreux": [
        "meandreux"
    ],
    "meandrine": [
        "meandrine"
    ],
    "meat": [
        "meat"
    ],
    "mecanicien": [
        "mecanicien"
    ],
    "mecanicienne": [
        "mecanicien"
    ],
    "mecaniciennes": [
        "mecanicien"
    ],
    "mecaniciens": [
        "mecanicien"
    ],
    "mecanique": [
        "mecanique"
    ],
    "mecaniquement": [
        "mecaniquement"
    ],
    "mecaniques": [
        "mecanique"
    ],
    "mecanisait": [
        "mecaniser"
    ],
    "mecanisation": [
        "mecanisation"
    ],
    "mecanise": [
        "mecaniser"
    ],
    "mecaniser": [
        "mecaniser"
    ],
    "mecanisme": [
        "mecanisme"
    ],
    "mecanismes": [
        "mecanisme"
    ],
    "mecanistes": [
        "mecaniste"
    ],
    "mecanisee": [
        "mecaniser"
    ],
    "mecanisees": [
        "mecaniser"
    ],
    "mecanises": [
        "mecaniser"
    ],
    "mecano": [
        "mecano"
    ],
    "mecanographiques": [
        "mecanographique"
    ],
    "mecanos": [
        "mecano"
    ],
    "mechait": [
        "mecher"
    ],
    "mechamment": [
        "mechamment"
    ],
    "mechancete": [
        "mechancete"
    ],
    "mechancetes": [
        "mechancete"
    ],
    "mechant": [
        "mecher",
        "mechant"
    ],
    "mechante": [
        "mechant"
    ],
    "mechantes": [
        "mechant"
    ],
    "mechants": [
        "mechant"
    ],
    "mecher": [
        "mecher"
    ],
    "mechoui": [
        "mechoui"
    ],
    "mechouis": [
        "mechoui"
    ],
    "mecompte": [
        "mecompte"
    ],
    "mecomptes": [
        "mecompte"
    ],
    "meconduite": [
        "meconduite"
    ],
    "meconium": [
        "meconium"
    ],
    "meconnais": [
        "meconnaitre"
    ],
    "meconnaissable": [
        "meconnaissable"
    ],
    "meconnaissables": [
        "meconnaissable"
    ],
    "meconnaissais": [
        "meconnaitre"
    ],
    "meconnaissance": [
        "meconnaissance"
    ],
    "meconnaissant": [
        "meconnaitre"
    ],
    "meconnaisse": [
        "meconnaitre"
    ],
    "meconnaissent": [
        "meconnaitre"
    ],
    "meconnaitra": [
        "meconnaitre"
    ],
    "meconnaitre": [
        "meconnaitre"
    ],
    "meconnu": [
        "meconnu",
        "meconnaitre"
    ],
    "meconnue": [
        "meconnu",
        "meconnaitre"
    ],
    "meconnues": [
        "meconnaitre"
    ],
    "meconnus": [
        "meconnu",
        "meconnaitre"
    ],
    "mecontent": [
        "mecontent"
    ],
    "mecontenta": [
        "mecontenter"
    ],
    "mecontentait": [
        "mecontenter"
    ],
    "mecontente": [
        "mecontenter",
        "mecontent"
    ],
    "mecontentement": [
        "mecontentement"
    ],
    "mecontentements": [
        "mecontentement"
    ],
    "mecontenter": [
        "mecontenter"
    ],
    "mecontentes": [
        "mecontenter",
        "mecontent"
    ],
    "mecontents": [
        "mecontent"
    ],
    "mecru": [
        "mecroire"
    ],
    "mecreance": [
        "mecreance"
    ],
    "mecreant": [
        "mecreant"
    ],
    "mecreante": [
        "mecreant"
    ],
    "mecreants": [
        "mecreant"
    ],
    "mecene": [
        "mecene"
    ],
    "mecenes": [
        "mecene"
    ],
    "mecenat": [
        "mecenat"
    ],
    "medaille": [
        "medailler",
        "medaille"
    ],
    "medailles": [
        "medaille"
    ],
    "medailleurs": [
        "medailleur"
    ],
    "medaillon": [
        "medaillon"
    ],
    "medaillons": [
        "medaillon"
    ],
    "medaillee": [
        "medailler",
        "medaille"
    ],
    "medecin": [
        "medecin"
    ],
    "medecine": [
        "medecine"
    ],
    "medecines": [
        "medecine"
    ],
    "medecins": [
        "medecin"
    ],
    "median": [
        "median"
    ],
    "mediane": [
        "median",
        "mediane"
    ],
    "medianes": [
        "median"
    ],
    "medianoche": [
        "medianoche"
    ],
    "medians": [
        "median"
    ],
    "medias": [
        "media"
    ],
    "mediascope": [
        "mediascope"
    ],
    "mediastin": [
        "mediastin"
    ],
    "mediateur": [
        "mediateur"
    ],
    "mediateurs": [
        "mediateur"
    ],
    "mediation": [
        "mediation"
    ],
    "mediatique": [
        "mediatique"
    ],
    "mediatiques": [
        "mediatique"
    ],
    "mediatisant": [
        "mediatiser"
    ],
    "mediatisation": [
        "mediatisation"
    ],
    "mediatise": [
        "mediatiser"
    ],
    "mediatisee": [
        "mediatiser"
    ],
    "mediatisees": [
        "mediatiser"
    ],
    "mediatises": [
        "mediatiser"
    ],
    "mediator": [
        "mediator"
    ],
    "mediatrice": [
        "mediateur"
    ],
    "mediatrices": [
        "mediateur"
    ],
    "medical": [
        "medical"
    ],
    "medicale": [
        "medical"
    ],
    "medicalement": [
        "medicalement"
    ],
    "medicales": [
        "medical"
    ],
    "medicalisation": [
        "medicalisation"
    ],
    "medicalise": [
        "medicaliser"
    ],
    "medicalisee": [
        "medicaliser"
    ],
    "medicament": [
        "medicament"
    ],
    "medicamentait": [
        "medicamenter"
    ],
    "medicamentation": [
        "medicamentation"
    ],
    "medicamenter": [
        "medicamenter"
    ],
    "medicamenteuse": [
        "medicamenteux"
    ],
    "medicamenteux": [
        "medicamenteux"
    ],
    "medicaments": [
        "medicament"
    ],
    "medicamente": [
        "medicamenter"
    ],
    "medicastre": [
        "medicastre"
    ],
    "medicastres": [
        "medicastre"
    ],
    "medication": [
        "medication"
    ],
    "medications": [
        "medication"
    ],
    "medicaux": [
        "medical"
    ],
    "medicinal": [
        "medicinal"
    ],
    "medicinale": [
        "medicinal"
    ],
    "medicinales": [
        "medicinal"
    ],
    "medicinaux": [
        "medicinal"
    ],
    "medicine": [
        "mediciner"
    ],
    "medina": [
        "medina"
    ],
    "medinas": [
        "medina"
    ],
    "mediocre": [
        "mediocre"
    ],
    "mediocrement": [
        "mediocrement"
    ],
    "mediocres": [
        "mediocre"
    ],
    "mediocrite": [
        "mediocrite"
    ],
    "mediocrites": [
        "mediocrite"
    ],
    "medire": [
        "medire"
    ],
    "medis": [
        "medire"
    ],
    "medisaient": [
        "medire"
    ],
    "medisait": [
        "medire"
    ],
    "medisance": [
        "medisance"
    ],
    "medisances": [
        "medisance"
    ],
    "medisant": [
        "medisant",
        "medire"
    ],
    "medisante": [
        "medisant"
    ],
    "medisants": [
        "medisant"
    ],
    "medise": [
        "medire"
    ],
    "medisent": [
        "medire"
    ],
    "medisez": [
        "medire"
    ],
    "medisons": [
        "medire"
    ],
    "medit": [
        "medire"
    ],
    "medita": [
        "mediter"
    ],
    "meditai": [
        "mediter"
    ],
    "meditaient": [
        "mediter"
    ],
    "meditais": [
        "mediter"
    ],
    "meditait": [
        "mediter"
    ],
    "meditant": [
        "mediter",
        "meditant"
    ],
    "meditatif": [
        "meditatif"
    ],
    "meditatifs": [
        "meditatif"
    ],
    "meditation": [
        "meditation"
    ],
    "meditations": [
        "meditation"
    ],
    "meditative": [
        "meditatif"
    ],
    "meditativement": [
        "meditativement"
    ],
    "meditatives": [
        "meditatif"
    ],
    "medite": [
        "mediter"
    ],
    "meditent": [
        "mediter"
    ],
    "mediter": [
        "mediter"
    ],
    "meditera": [
        "mediter"
    ],
    "mediterait": [
        "mediter"
    ],
    "mediteras": [
        "mediter"
    ],
    "mediterranee": [
        "mediterrane"
    ],
    "mediterraneen": [
        "mediterraneen"
    ],
    "mediterraneenne": [
        "mediterraneen"
    ],
    "mediterraneennes": [
        "mediterraneen",
        "mediterraneenne"
    ],
    "mediterraneens": [
        "mediterraneen"
    ],
    "medites": [
        "mediter"
    ],
    "meditez": [
        "mediter"
    ],
    "meditiez": [
        "mediter"
    ],
    "meditons": [
        "mediter"
    ],
    "mediterent": [
        "mediter"
    ],
    "meditee": [
        "mediter"
    ],
    "meditees": [
        "mediter"
    ],
    "mediumnique": [
        "mediumnique"
    ],
    "mediumniques": [
        "mediumnique"
    ],
    "mediumnite": [
        "mediumnite"
    ],
    "mediums": [
        "medium"
    ],
    "medius": [
        "medius"
    ],
    "medieval": [
        "medieval"
    ],
    "medievale": [
        "medieval"
    ],
    "medievales": [
        "medieval"
    ],
    "medievaux": [
        "medieval"
    ],
    "medieviste": [
        "medieviste"
    ],
    "medievistes": [
        "medieviste"
    ],
    "medoc": [
        "medoc"
    ],
    "medocs": [
        "medoc"
    ],
    "medulla": [
        "medulla"
    ],
    "medullaire": [
        "medullaire"
    ],
    "medusa": [
        "meduser"
    ],
    "medusait": [
        "meduser"
    ],
    "medusant": [
        "meduser"
    ],
    "meduse": [
        "meduse",
        "meduser"
    ],
    "medusent": [
        "meduser"
    ],
    "meduser": [
        "meduser"
    ],
    "meduses": [
        "meduse",
        "meduser"
    ],
    "medusee": [
        "meduse",
        "meduser"
    ],
    "medusees": [
        "meduse",
        "meduser"
    ],
    "mefait": [
        "mefait"
    ],
    "mefaits": [
        "mefait"
    ],
    "mefiaient": [
        "mefier"
    ],
    "mefiais": [
        "mefier"
    ],
    "mefiait": [
        "mefier"
    ],
    "mefiance": [
        "mefiance"
    ],
    "mefiances": [
        "mefiance"
    ],
    "mefiant": [
        "mefier",
        "mefiant"
    ],
    "mefiante": [
        "mefiant"
    ],
    "mefiantes": [
        "mefiant"
    ],
    "mefiants": [
        "mefiant"
    ],
    "mefie": [
        "mefier"
    ],
    "mefient": [
        "mefier"
    ],
    "mefier": [
        "mefier"
    ],
    "mefiera": [
        "mefier"
    ],
    "mefierai": [
        "mefier"
    ],
    "mefierais": [
        "mefier"
    ],
    "mefierait": [
        "mefier"
    ],
    "mefieront": [
        "mefier"
    ],
    "mefies": [
        "mefier"
    ],
    "mefiez": [
        "mefier"
    ],
    "mefiions": [
        "mefier"
    ],
    "mefions": [
        "mefier"
    ],
    "mefierent": [
        "mefier"
    ],
    "mefiee": [
        "mefier"
    ],
    "meforme": [
        "meforme"
    ],
    "mega": [
        "mega"
    ],
    "megacolon": [
        "megacolon"
    ],
    "megahertz": [
        "megahertz"
    ],
    "megajoules": [
        "megajoule"
    ],
    "megalithe": [
        "megalithe"
    ],
    "megalithique": [
        "megalithique"
    ],
    "megalo": [
        "megalo"
    ],
    "megalomane": [
        "megalomane"
    ],
    "megalomanes": [
        "megalomane"
    ],
    "megalomaniaque": [
        "megalomaniaque"
    ],
    "megalomanie": [
        "megalomanie"
    ],
    "megalopole": [
        "megalopole"
    ],
    "megalos": [
        "megalo"
    ],
    "megalosaure": [
        "megalosaure"
    ],
    "megaphone": [
        "megaphone"
    ],
    "megaphones": [
        "megaphone"
    ],
    "megapole": [
        "megapole"
    ],
    "megaron": [
        "megaron"
    ],
    "megatheriums": [
        "megatherium"
    ],
    "megatonne": [
        "megatonne"
    ],
    "megatonnes": [
        "megatonne"
    ],
    "megawatts": [
        "megawatt"
    ],
    "megisserie": [
        "megisserie"
    ],
    "megissiers": [
        "megissier"
    ],
    "megot": [
        "megot"
    ],
    "megotage": [
        "megotage"
    ],
    "megotages": [
        "megotage"
    ],
    "megotaient": [
        "megoter"
    ],
    "megotait": [
        "megoter"
    ],
    "megote": [
        "megoter"
    ],
    "megoter": [
        "megoter"
    ],
    "megots": [
        "megot"
    ],
    "megere": [
        "meger"
    ],
    "megeres": [
        "megere",
        "meger"
    ],
    "mehari": [
        "mehari"
    ],
    "mehariste": [
        "mehariste"
    ],
    "meharistes": [
        "mehariste"
    ],
    "meiose": [
        "meiose"
    ],
    "mejugement": [
        "mejugement"
    ],
    "mejugez": [
        "mejuger"
    ],
    "mejuge": [
        "mejuger"
    ],
    "mejuges": [
        "mejuger"
    ],
    "melancolie": [
        "melancolie"
    ],
    "melancolies": [
        "melancolie"
    ],
    "melancolieux": [
        "melancolieux"
    ],
    "melancolique": [
        "melancolique"
    ],
    "melancoliquement": [
        "melancoliquement"
    ],
    "melancoliques": [
        "melancolique"
    ],
    "melancoliser": [
        "melancoliser"
    ],
    "melange": [
        "melange",
        "melanger"
    ],
    "melangea": [
        "melanger"
    ],
    "melangeaient": [
        "melanger"
    ],
    "melangeais": [
        "melanger"
    ],
    "melangeait": [
        "melanger"
    ],
    "melangeant": [
        "melangeant",
        "melanger"
    ],
    "melangent": [
        "melanger"
    ],
    "melangeons": [
        "melanger"
    ],
    "melanger": [
        "melanger"
    ],
    "melangera": [
        "melanger"
    ],
    "melangerai": [
        "melanger"
    ],
    "melangeraient": [
        "melanger"
    ],
    "melanges": [
        "melange",
        "melanger"
    ],
    "melangeur": [
        "melangeur"
    ],
    "melangeurs": [
        "melangeur"
    ],
    "melangez": [
        "melanger"
    ],
    "melangions": [
        "melanger"
    ],
    "melangerent": [
        "melanger"
    ],
    "melangee": [
        "melange",
        "melanger"
    ],
    "melangees": [
        "melange",
        "melanger"
    ],
    "melanine": [
        "melanine"
    ],
    "melanome": [
        "melanome"
    ],
    "melanomes": [
        "melanome"
    ],
    "melanesiennes": [
        "melanesien",
        "melanesienne"
    ],
    "melasse": [
        "meler",
        "melasse"
    ],
    "melatonine": [
        "melatonine"
    ],
    "melilot": [
        "melilot"
    ],
    "melinite": [
        "melinite"
    ],
    "melisse": [
        "melisse"
    ],
    "melo": [
        "melo"
    ],
    "melodie": [
        "melodie"
    ],
    "melodies": [
        "melody",
        "melodie"
    ],
    "melodieuse": [
        "melodieux"
    ],
    "melodieusement": [
        "melodieusement"
    ],
    "melodieuses": [
        "melodieux"
    ],
    "melodieux": [
        "melodieux"
    ],
    "melodique": [
        "melodique"
    ],
    "melodiques": [
        "melodique"
    ],
    "melodramatique": [
        "melodramatique"
    ],
    "melodramatiques": [
        "melodramatique"
    ],
    "melodrame": [
        "melodrame"
    ],
    "melodrames": [
        "melodrame"
    ],
    "melomane": [
        "melomane"
    ],
    "melomanes": [
        "melomane"
    ],
    "melopee": [
        "melopee"
    ],
    "melopees": [
        "melopee"
    ],
    "melos": [
        "melo"
    ],
    "meleze": [
        "meleze"
    ],
    "melezes": [
        "meleze"
    ],
    "mementos": [
        "memento"
    ],
    "memo": [
        "memo"
    ],
    "memoire": [
        "memoire"
    ],
    "memoires": [
        "memoire"
    ],
    "memorabilite": [
        "memorabilite"
    ],
    "memorable": [
        "memorable"
    ],
    "memorables": [
        "memorable"
    ],
    "memorandum": [
        "memorandum"
    ],
    "memorandums": [
        "memorandum"
    ],
    "memorial": [
        "memorial"
    ],
    "memorialiste": [
        "memorialiste"
    ],
    "memorialistes": [
        "memorialiste"
    ],
    "memoriaux": [
        "memorial"
    ],
    "memoriel": [
        "memoriel"
    ],
    "memorielle": [
        "memoriel"
    ],
    "memoriels": [
        "memoriel"
    ],
    "memorisables": [
        "memorisable"
    ],
    "memorisaient": [
        "memoriser"
    ],
    "memorisait": [
        "memoriser"
    ],
    "memorisation": [
        "memorisation"
    ],
    "memorise": [
        "memoriser"
    ],
    "memorisent": [
        "memoriser"
    ],
    "memoriser": [
        "memoriser"
    ],
    "memoriserai": [
        "memoriser"
    ],
    "memoriserais": [
        "memoriser"
    ],
    "memorisez": [
        "memoriser"
    ],
    "memorisiez": [
        "memoriser"
    ],
    "memorisee": [
        "memoriser"
    ],
    "memorisees": [
        "memoriser"
    ],
    "memorises": [
        "memoriser",
        "memorise"
    ],
    "memos": [
        "memo"
    ],
    "memere": [
        "memere"
    ],
    "memeres": [
        "memere"
    ],
    "meme": [
        "meme"
    ],
    "memes": [
        "meme",
        "memes"
    ],
    "menade": [
        "menade"
    ],
    "menades": [
        "menade"
    ],
    "menage": [
        "menager",
        "menage"
    ],
    "menagea": [
        "menager"
    ],
    "menageaient": [
        "menager"
    ],
    "menageais": [
        "menager"
    ],
    "menageait": [
        "menager"
    ],
    "menageant": [
        "menager"
    ],
    "menagement": [
        "menagement"
    ],
    "menagements": [
        "menagement"
    ],
    "menagent": [
        "menager"
    ],
    "menager": [
        "menager"
    ],
    "menagera": [
        "menager"
    ],
    "menagerai": [
        "menager"
    ],
    "menagerait": [
        "menager"
    ],
    "menageras": [
        "menager"
    ],
    "menagerie": [
        "menagerie"
    ],
    "menageries": [
        "menagerie"
    ],
    "menagers": [
        "menager"
    ],
    "menages": [
        "menager",
        "menage"
    ],
    "menagez": [
        "menager"
    ],
    "menageat": [
        "menager"
    ],
    "menagiez": [
        "menager"
    ],
    "menagions": [
        "menager"
    ],
    "menagere": [
        "menager"
    ],
    "menagerent": [
        "menager"
    ],
    "menageres": [
        "menager"
    ],
    "menagee": [
        "menager"
    ],
    "menagees": [
        "menager"
    ],
    "menesse": [
        "menesse"
    ],
    "menestrel": [
        "menestrel"
    ],
    "menestrels": [
        "menestrel"
    ],
    "meninges": [
        "meninge"
    ],
    "meningiome": [
        "meningiome"
    ],
    "meningite": [
        "meningite"
    ],
    "meningites": [
        "meningite"
    ],
    "meningocoque": [
        "meningocoque"
    ],
    "meningee": [
        "meninge"
    ],
    "menisque": [
        "menisque"
    ],
    "menisques": [
        "menisque"
    ],
    "menopause": [
        "menopause"
    ],
    "menopausee": [
        "menopause"
    ],
    "menopausees": [
        "menopause"
    ],
    "mephistophelique": [
        "mephistophelique"
    ],
    "mephistopheliques": [
        "mephistophelique"
    ],
    "mephitique": [
        "mephitique"
    ],
    "mephitiques": [
        "mephitique"
    ],
    "meplat": [
        "meplat"
    ],
    "meplats": [
        "meplat"
    ],
    "meprenais": [
        "meprendre"
    ],
    "meprenait": [
        "meprendre"
    ],
    "meprenant": [
        "meprendre"
    ],
    "meprend": [
        "meprendre"
    ],
    "meprendre": [
        "meprendre"
    ],
    "meprendriez": [
        "meprendre"
    ],
    "meprends": [
        "meprendre"
    ],
    "meprenez": [
        "meprendre"
    ],
    "mepreniez": [
        "meprendre"
    ],
    "meprenne": [
        "meprendre"
    ],
    "meprennent": [
        "meprendre"
    ],
    "mepris": [
        "meprendre",
        "mepris"
    ],
    "meprisa": [
        "mepriser"
    ],
    "meprisable": [
        "meprisable"
    ],
    "meprisables": [
        "meprisable"
    ],
    "meprisai": [
        "mepriser"
    ],
    "meprisaient": [
        "mepriser"
    ],
    "meprisais": [
        "mepriser"
    ],
    "meprisait": [
        "mepriser"
    ],
    "meprisamment": [
        "meprisamment"
    ],
    "meprisant": [
        "meprisant",
        "mepriser"
    ],
    "meprisante": [
        "meprisant"
    ],
    "meprisantes": [
        "meprisant"
    ],
    "meprisants": [
        "meprisant"
    ],
    "meprise": [
        "meprise",
        "mepriser"
    ],
    "meprisent": [
        "mepriser"
    ],
    "mepriser": [
        "mepriser"
    ],
    "meprisera": [
        "mepriser"
    ],
    "mepriserai": [
        "mepriser"
    ],
    "mepriseraient": [
        "mepriser"
    ],
    "mepriserais": [
        "mepriser"
    ],
    "mepriserait": [
        "mepriser"
    ],
    "mepriseras": [
        "mepriser"
    ],
    "mepriseriez": [
        "mepriser"
    ],
    "meprises": [
        "meprise",
        "mepriser"
    ],
    "meprisez": [
        "mepriser"
    ],
    "meprisiez": [
        "mepriser"
    ],
    "meprisions": [
        "mepriser"
    ],
    "meprisons": [
        "mepriser"
    ],
    "meprisee": [
        "mepriser"
    ],
    "meprisees": [
        "mepriser"
    ],
    "meprit": [
        "meprendre"
    ],
    "meridien": [
        "meridien"
    ],
    "meridienne": [
        "meridien"
    ],
    "meridiennes": [
        "meridien"
    ],
    "meridiens": [
        "meridien"
    ],
    "meridional": [
        "meridional"
    ],
    "meridionale": [
        "meridional"
    ],
    "meridionales": [
        "meridional"
    ],
    "meridionaux": [
        "meridional"
    ],
    "merinos": [
        "merinos"
    ],
    "merita": [
        "meriter"
    ],
    "meritaient": [
        "meriter"
    ],
    "meritais": [
        "meriter"
    ],
    "meritait": [
        "meriter"
    ],
    "meritant": [
        "meritant",
        "meriter"
    ],
    "meritante": [
        "meritant"
    ],
    "meritantes": [
        "meritant"
    ],
    "meritants": [
        "meritant"
    ],
    "meritassent": [
        "meriter"
    ],
    "merite": [
        "merite",
        "meriter"
    ],
    "meritent": [
        "meriter"
    ],
    "meriter": [
        "meriter"
    ],
    "meritera": [
        "meriter"
    ],
    "meriterai": [
        "meriter"
    ],
    "meriteraient": [
        "meriter"
    ],
    "meriterais": [
        "meriter"
    ],
    "meriterait": [
        "meriter"
    ],
    "meriteras": [
        "meriter"
    ],
    "meriteriez": [
        "meriter"
    ],
    "meriteront": [
        "meriter"
    ],
    "merites": [
        "merite",
        "meriter"
    ],
    "meritez": [
        "meriter"
    ],
    "meritiez": [
        "meriter"
    ],
    "meritions": [
        "meriter"
    ],
    "meritocratie": [
        "meritocratie"
    ],
    "meritoire": [
        "meritoire"
    ],
    "meritoires": [
        "meritoire"
    ],
    "meritons": [
        "meriter"
    ],
    "meritat": [
        "meriter"
    ],
    "meritee": [
        "meriter"
    ],
    "meritees": [
        "meriter"
    ],
    "merou": [
        "merou"
    ],
    "merovingien": [
        "merovingien"
    ],
    "merovingienne": [
        "merovingien"
    ],
    "merovingiennes": [
        "merovingien"
    ],
    "mesalliance": [
        "mesalliance"
    ],
    "mesalliances": [
        "mesalliance"
    ],
    "mesallieras": [
        "mesallier"
    ],
    "mesallies": [
        "mesallier"
    ],
    "mesange": [
        "mesange"
    ],
    "mesanges": [
        "mesange"
    ],
    "mesaventure": [
        "mesaventure"
    ],
    "mesaventures": [
        "mesaventure"
    ],
    "mesencephale": [
        "mesencephale"
    ],
    "mesentente": [
        "mesentente"
    ],
    "mesententes": [
        "mesentente"
    ],
    "mesentere": [
        "mesentere"
    ],
    "mesenterique": [
        "mesenterique"
    ],
    "mesestimant": [
        "mesestimer"
    ],
    "mesestime": [
        "mesestime",
        "mesestimer"
    ],
    "mesestimer": [
        "mesestimer"
    ],
    "mesestimez": [
        "mesestimer"
    ],
    "mesintelligence": [
        "mesintelligence"
    ],
    "mesinterpreter": [
        "mesinterpreter"
    ],
    "mesodermiques": [
        "mesodermique"
    ],
    "mesomorphe": [
        "mesomorphe"
    ],
    "mesomorphique": [
        "mesomorphique"
    ],
    "meson": [
        "meson"
    ],
    "mesons": [
        "meson"
    ],
    "mesopotamien": [
        "mesopotamien"
    ],
    "mesopotamienne": [
        "mesopotamienne"
    ],
    "mesopotamiens": [
        "mesopotamien"
    ],
    "mesosphere": [
        "mesosphere"
    ],
    "mesozoique": [
        "mesozoique"
    ],
    "mesusage": [
        "mesusage"
    ],
    "mesuser": [
        "mesuser"
    ],
    "meta": [
        "meta"
    ],
    "metabolique": [
        "metabolique"
    ],
    "metaboliser": [
        "metaboliser"
    ],
    "metabolisme": [
        "metabolisme"
    ],
    "metabolismes": [
        "metabolisme"
    ],
    "metabolite": [
        "metabolite"
    ],
    "metacarpe": [
        "metacarpe"
    ],
    "metacarpien": [
        "metacarpien"
    ],
    "metacarpiens": [
        "metacarpien"
    ],
    "metairie": [
        "metairie"
    ],
    "metairies": [
        "metairie"
    ],
    "metal": [
        "metal"
    ],
    "metallique": [
        "metallique"
    ],
    "metalliques": [
        "metallique"
    ],
    "metallisation": [
        "metallisation"
    ],
    "metallise": [
        "metalliser"
    ],
    "metallisent": [
        "metalliser"
    ],
    "metallisee": [
        "metalliser"
    ],
    "metallisees": [
        "metalliser"
    ],
    "metallises": [
        "metalliser"
    ],
    "metallo": [
        "metallo"
    ],
    "metallographie": [
        "metallographie"
    ],
    "metallos": [
        "metallo"
    ],
    "metallurgie": [
        "metallurgie"
    ],
    "metallurgique": [
        "metallurgique"
    ],
    "metallurgiques": [
        "metallurgique"
    ],
    "metallurgiste": [
        "metallurgiste"
    ],
    "metallurgistes": [
        "metallurgiste"
    ],
    "metamorphique": [
        "metamorphique"
    ],
    "metamorphosa": [
        "metamorphoser"
    ],
    "metamorphosaient": [
        "metamorphoser"
    ],
    "metamorphosait": [
        "metamorphoser"
    ],
    "metamorphosant": [
        "metamorphoser"
    ],
    "metamorphose": [
        "metamorphose",
        "metamorphoser"
    ],
    "metamorphosent": [
        "metamorphoser"
    ],
    "metamorphoser": [
        "metamorphoser"
    ],
    "metamorphoseraient": [
        "metamorphoser"
    ],
    "metamorphoserait": [
        "metamorphoser"
    ],
    "metamorphoses": [
        "metamorphose",
        "metamorphoser"
    ],
    "metamorphosez": [
        "metamorphoser"
    ],
    "metamorphosions": [
        "metamorphoser"
    ],
    "metamorphosat": [
        "metamorphoser"
    ],
    "metamorphoserent": [
        "metamorphoser"
    ],
    "metamorphosee": [
        "metamorphoser"
    ],
    "metamorphosees": [
        "metamorphoser"
    ],
    "metaphase": [
        "metaphase"
    ],
    "metaphore": [
        "metaphore"
    ],
    "metaphores": [
        "metaphore"
    ],
    "metaphorique": [
        "metaphorique"
    ],
    "metaphoriquement": [
        "metaphoriquement"
    ],
    "metaphoriques": [
        "metaphorique"
    ],
    "metaphysicien": [
        "metaphysicien"
    ],
    "metaphysicienne": [
        "metaphysicien"
    ],
    "metaphysiciens": [
        "metaphysicien"
    ],
    "metaphysique": [
        "metaphysique"
    ],
    "metaphysiquement": [
        "metaphysiquement"
    ],
    "metaphysiques": [
        "metaphysique"
    ],
    "metapsychique": [
        "metapsychique"
    ],
    "metapsychologie": [
        "metapsychologie"
    ],
    "metapsychologique": [
        "metapsychologique"
    ],
    "metastase": [
        "metastaser",
        "metastase"
    ],
    "metastases": [
        "metastase"
    ],
    "metastatique": [
        "metastatique"
    ],
    "metatarses": [
        "metatarse"
    ],
    "metatarsienne": [
        "metatarsien"
    ],
    "metaux": [
        "metal"
    ],
    "metayage": [
        "metayage"
    ],
    "metayer": [
        "metayer"
    ],
    "metayers": [
        "metayer"
    ],
    "metazoaires": [
        "metazoaire"
    ],
    "metempsychose": [
        "metempsychose"
    ],
    "metempsycose": [
        "metempsycose"
    ],
    "methacrylate": [
        "methacrylate"
    ],
    "methadone": [
        "methadone"
    ],
    "methanal": [
        "methanal"
    ],
    "methane": [
        "methane"
    ],
    "methanol": [
        "methanol"
    ],
    "methode": [
        "methode"
    ],
    "methodes": [
        "methode"
    ],
    "methodique": [
        "methodique"
    ],
    "methodiquement": [
        "methodiquement"
    ],
    "methodiques": [
        "methodique"
    ],
    "methodisme": [
        "methodisme"
    ],
    "methodiste": [
        "methodiste"
    ],
    "methodistes": [
        "methodiste"
    ],
    "methodologie": [
        "methodologie"
    ],
    "methodologique": [
        "methodologique"
    ],
    "methyle": [
        "methyle"
    ],
    "methylique": [
        "methylique"
    ],
    "methylene": [
        "methylene"
    ],
    "methedrine": [
        "methedrine"
    ],
    "meticuleuse": [
        "meticuleux"
    ],
    "meticuleusement": [
        "meticuleusement"
    ],
    "meticuleuses": [
        "meticuleux"
    ],
    "meticuleux": [
        "meticuleux"
    ],
    "meticulosite": [
        "meticulosite"
    ],
    "metier": [
        "metier"
    ],
    "metiers": [
        "metier"
    ],
    "metingue": [
        "metingue"
    ],
    "metis": [
        "metis"
    ],
    "metissage": [
        "metissage"
    ],
    "metissages": [
        "metissage"
    ],
    "metisse": [
        "metis",
        "metisser"
    ],
    "metisser": [
        "metisser"
    ],
    "metisses": [
        "metis"
    ],
    "metissez": [
        "metisser"
    ],
    "metissee": [
        "metisser"
    ],
    "metonymie": [
        "metonymie"
    ],
    "metopes": [
        "metope"
    ],
    "metra": [
        "metrer"
    ],
    "metrage": [
        "metrage"
    ],
    "metrages": [
        "metrage"
    ],
    "metras": [
        "metrer"
    ],
    "metreur": [
        "metreur"
    ],
    "metrique": [
        "metrique"
    ],
    "metriques": [
        "metrique"
    ],
    "metrite": [
        "metrite"
    ],
    "metrites": [
        "metrite"
    ],
    "metro": [
        "metro"
    ],
    "metronome": [
        "metronome"
    ],
    "metronomes": [
        "metronome"
    ],
    "metropole": [
        "metropole"
    ],
    "metropoles": [
        "metropole"
    ],
    "metropolitain": [
        "metropolitain"
    ],
    "metropolitaine": [
        "metropolitain"
    ],
    "metropolitaines": [
        "metropolitain"
    ],
    "metropolitains": [
        "metropolitain"
    ],
    "metropolite": [
        "metropolite"
    ],
    "metros": [
        "metro"
    ],
    "meteque": [
        "meteque"
    ],
    "meteques": [
        "meteque"
    ],
    "meteo": [
        "meteo"
    ],
    "meteore": [
        "meteore"
    ],
    "meteores": [
        "meteore"
    ],
    "meteorique": [
        "meteorique"
    ],
    "meteoriquement": [
        "meteoriquement"
    ],
    "meteorite": [
        "meteorite"
    ],
    "meteorites": [
        "meteorite"
    ],
    "meteoritique": [
        "meteoritique"
    ],
    "meteorologie": [
        "meteorologie"
    ],
    "meteorologique": [
        "meteorologique"
    ],
    "meteorologiques": [
        "meteorologique"
    ],
    "meteorologiste": [
        "meteorologiste"
    ],
    "meteorologue": [
        "meteorologue"
    ],
    "meteorologues": [
        "meteorologue"
    ],
    "mevente": [
        "mevente"
    ],
    "mezig": [
        "mezig"
    ],
    "mezigue": [
        "mezigue"
    ],
    "mela": [
        "meler"
    ],
    "melai": [
        "meler"
    ],
    "melaient": [
        "meler"
    ],
    "melais": [
        "meler"
    ],
    "melait": [
        "meler"
    ],
    "melant": [
        "meler"
    ],
    "mele": [
        "mele",
        "meler"
    ],
    "melent": [
        "meler"
    ],
    "meler": [
        "meler"
    ],
    "melera": [
        "meler"
    ],
    "melerai": [
        "meler"
    ],
    "meleraient": [
        "meler"
    ],
    "melerais": [
        "meler"
    ],
    "melerait": [
        "meler"
    ],
    "meleront": [
        "meler"
    ],
    "meles": [
        "mele",
        "meler"
    ],
    "melez": [
        "meler"
    ],
    "meliez": [
        "meler"
    ],
    "melions": [
        "meler"
    ],
    "melat": [
        "meler"
    ],
    "melerent": [
        "meler"
    ],
    "melecasse": [
        "melecasse"
    ],
    "melee": [
        "meler",
        "melee"
    ],
    "melees": [
        "meler",
        "melee"
    ],
    "memement": [
        "memement"
    ],
    "mome": [
        "mome"
    ],
    "momes": [
        "mome"
    ],
    "mu": [
        "mouvoir"
    ],
    "murement": [
        "murement"
    ],
    "muri": [
        "murir"
    ],
    "murie": [
        "murir"
    ],
    "murier": [
        "murier"
    ],
    "muriers": [
        "murier"
    ],
    "muries": [
        "murir"
    ],
    "murir": [
        "murir"
    ],
    "murira": [
        "murir"
    ],
    "muriraient": [
        "murir"
    ],
    "murirez": [
        "murir"
    ],
    "muris": [
        "murir"
    ],
    "murissaient": [
        "murir"
    ],
    "murissait": [
        "murir"
    ],
    "murissant": [
        "murir",
        "murissant"
    ],
    "murissante": [
        "murissant"
    ],
    "murissantes": [
        "murissant"
    ],
    "murissants": [
        "murissant"
    ],
    "murisse": [
        "murir"
    ],
    "murissement": [
        "murissement"
    ],
    "murissements": [
        "murissement"
    ],
    "murissent": [
        "murir"
    ],
    "murisseries": [
        "murisserie"
    ],
    "murit": [
        "murir"
    ],
    "muron": [
        "muron"
    ],
    "n": [
        "ne",
        "n"
    ],
    "n'": [
        "ne",
        "n'",
        "n"
    ],
    "na": [
        "na"
    ],
    "nabab": [
        "nabab"
    ],
    "nababs": [
        "nabab"
    ],
    "nabi": [
        "nabi"
    ],
    "nable": [
        "nable"
    ],
    "nabot": [
        "nabot"
    ],
    "nabote": [
        "nabot"
    ],
    "nabots": [
        "nabot"
    ],
    "nacarat": [
        "nacarat"
    ],
    "nacelle": [
        "nacelle"
    ],
    "nacelles": [
        "nacelle"
    ],
    "nacra": [
        "nacrer"
    ],
    "nacraient": [
        "nacrer"
    ],
    "nacre": [
        "nacre",
        "nacrer"
    ],
    "nacres": [
        "nacre",
        "nacrer"
    ],
    "nacrure": [
        "nacrure"
    ],
    "nacree": [
        "nacre",
        "nacrer"
    ],
    "nacrees": [
        "nacre",
        "nacrer"
    ],
    "nada": [
        "nada"
    ],
    "nadir": [
        "nadir"
    ],
    "naevus": [
        "naevus"
    ],
    "naga": [
        "naga"
    ],
    "nage": [
        "nage",
        "nager"
    ],
    "nagea": [
        "nager"
    ],
    "nageai": [
        "nager"
    ],
    "nageaient": [
        "nager"
    ],
    "nageais": [
        "nager"
    ],
    "nageait": [
        "nager"
    ],
    "nageant": [
        "nageant",
        "nager"
    ],
    "nageante": [
        "nageant"
    ],
    "nagent": [
        "nager"
    ],
    "nageoire": [
        "nageoire"
    ],
    "nageoires": [
        "nageoire"
    ],
    "nageons": [
        "nager"
    ],
    "nager": [
        "nager"
    ],
    "nagera": [
        "nager"
    ],
    "nagerai": [
        "nager"
    ],
    "nageraient": [
        "nager"
    ],
    "nagerais": [
        "nager"
    ],
    "nagerait": [
        "nager"
    ],
    "nageras": [
        "nager"
    ],
    "nagerez": [
        "nager"
    ],
    "nagerons": [
        "nager"
    ],
    "nageront": [
        "nager"
    ],
    "nages": [
        "nage",
        "nager"
    ],
    "nageur": [
        "nageur"
    ],
    "nageurs": [
        "nageur"
    ],
    "nageuse": [
        "nageur"
    ],
    "nageuses": [
        "nageur"
    ],
    "nagez": [
        "nager"
    ],
    "nageat": [
        "nager"
    ],
    "nagiez": [
        "nager"
    ],
    "nagions": [
        "nager"
    ],
    "naguere": [
        "naguere"
    ],
    "nagerent": [
        "nager"
    ],
    "nain": [
        "nain"
    ],
    "naine": [
        "nain"
    ],
    "naines": [
        "nain"
    ],
    "nains": [
        "nain"
    ],
    "naira": [
        "naira"
    ],
    "nais": [
        "naitre"
    ],
    "naissaient": [
        "naitre"
    ],
    "naissain": [
        "naissain"
    ],
    "naissais": [
        "naitre"
    ],
    "naissait": [
        "naitre"
    ],
    "naissance": [
        "naissance"
    ],
    "naissances": [
        "naissance"
    ],
    "naissant": [
        "naitre",
        "naissant"
    ],
    "naissante": [
        "naissant"
    ],
    "naissantes": [
        "naissant"
    ],
    "naissants": [
        "naissant"
    ],
    "naisse": [
        "naitre"
    ],
    "naissent": [
        "naitre"
    ],
    "naisses": [
        "naitre"
    ],
    "naisseur": [
        "naisseur"
    ],
    "naissez": [
        "naitre"
    ],
    "naissions": [
        "naitre"
    ],
    "naissons": [
        "naitre"
    ],
    "naja": [
        "naja"
    ],
    "najas": [
        "naja"
    ],
    "namibiens": [
        "namibien"
    ],
    "nana": [
        "nana"
    ],
    "nanan": [
        "nanan"
    ],
    "nanar": [
        "nanar"
    ],
    "nanard": [
        "nanard"
    ],
    "nanas": [
        "nana"
    ],
    "nanceiens": [
        "nanceien"
    ],
    "nanisme": [
        "nanisme"
    ],
    "nankin": [
        "nankin"
    ],
    "nano": [
        "nano"
    ],
    "nanometre": [
        "nanometre"
    ],
    "nanometres": [
        "nanometre"
    ],
    "nanoseconde": [
        "nanoseconde"
    ],
    "nanosecondes": [
        "nanoseconde"
    ],
    "nanotechnologie": [
        "nanotechnologie"
    ],
    "nant": [
        "nant"
    ],
    "nantais": [
        "nantais"
    ],
    "nantaise": [
        "nantais",
        "nantaise"
    ],
    "nantaises": [
        "nantais"
    ],
    "nanti": [
        "nantir",
        "nanti"
    ],
    "nantie": [
        "nantir",
        "nanti"
    ],
    "nanties": [
        "nantir"
    ],
    "nantir": [
        "nantir"
    ],
    "nantis": [
        "nantir",
        "nanti"
    ],
    "nantissement": [
        "nantissement"
    ],
    "nap": [
        "nap"
    ],
    "napalm": [
        "napalm"
    ],
    "napel": [
        "napel"
    ],
    "naphtaline": [
        "naphtaline"
    ],
    "naphtalines": [
        "naphtaline"
    ],
    "naphtalene": [
        "naphtalene"
    ],
    "naphte": [
        "naphte"
    ],
    "napolitain": [
        "napolitain"
    ],
    "napolitaine": [
        "napolitain"
    ],
    "napolitaines": [
        "napolitain"
    ],
    "napolitains": [
        "napolitain"
    ],
    "napoleon": [
        "napoleon"
    ],
    "napoleonien": [
        "napoleonien"
    ],
    "napoleonienne": [
        "napoleonien"
    ],
    "napoleoniennes": [
        "napoleonien"
    ],
    "napoleoniens": [
        "napoleonien"
    ],
    "napoleons": [
        "napoleon"
    ],
    "nappa": [
        "napper"
    ],
    "nappage": [
        "nappage"
    ],
    "nappaient": [
        "napper"
    ],
    "nappait": [
        "napper"
    ],
    "nappe": [
        "nappe",
        "napper"
    ],
    "napper": [
        "napper"
    ],
    "napperon": [
        "napperon"
    ],
    "napperons": [
        "napperon"
    ],
    "nappes": [
        "nappe",
        "napper"
    ],
    "nappee": [
        "napper"
    ],
    "nappees": [
        "napper"
    ],
    "naquirent": [
        "naitre"
    ],
    "naquis": [
        "naitre"
    ],
    "naquisse": [
        "naitre"
    ],
    "naquissent": [
        "naitre"
    ],
    "naquit": [
        "naitre"
    ],
    "narbonnais": [
        "narbonnais"
    ],
    "narcisse": [
        "narcisse"
    ],
    "narcisses": [
        "narcisse"
    ],
    "narcissique": [
        "narcissique"
    ],
    "narcissiquement": [
        "narcissiquement"
    ],
    "narcissiques": [
        "narcissique"
    ],
    "narcissisme": [
        "narcissisme"
    ],
    "narcissiste": [
        "narcissiste"
    ],
    "narcolepsie": [
        "narcolepsie"
    ],
    "narcoleptique": [
        "narcoleptique"
    ],
    "narcose": [
        "narcose"
    ],
    "narcotique": [
        "narcotique"
    ],
    "narcotiques": [
        "narcotique"
    ],
    "narcotrafic": [
        "narcotrafic"
    ],
    "narcotrafiquants": [
        "narcotrafiquant"
    ],
    "nard": [
        "nard"
    ],
    "nards": [
        "nard"
    ],
    "narghileh": [
        "narghileh"
    ],
    "narghile": [
        "narghile"
    ],
    "nargua": [
        "narguer"
    ],
    "narguaient": [
        "narguer"
    ],
    "narguais": [
        "narguer"
    ],
    "narguait": [
        "narguer"
    ],
    "narguant": [
        "narguer"
    ],
    "nargue": [
        "narguer"
    ],
    "narguent": [
        "narguer"
    ],
    "narguer": [
        "narguer"
    ],
    "nargues": [
        "narguer"
    ],
    "narguez": [
        "narguer"
    ],
    "narguile": [
        "narguile"
    ],
    "narguiles": [
        "narguile"
    ],
    "narguons": [
        "narguer"
    ],
    "narguees": [
        "narguer"
    ],
    "narine": [
        "narine"
    ],
    "narines": [
        "narine"
    ],
    "narquois": [
        "narquois"
    ],
    "narquoise": [
        "narquois"
    ],
    "narquoisement": [
        "narquoisement"
    ],
    "narquoiserie": [
        "narquoiserie"
    ],
    "narquoises": [
        "narquois"
    ],
    "narra": [
        "narrer"
    ],
    "narrai": [
        "narrer"
    ],
    "narrait": [
        "narrer"
    ],
    "narrant": [
        "narrer"
    ],
    "narrateur": [
        "narrateur"
    ],
    "narratif": [
        "narratif"
    ],
    "narratifs": [
        "narratif"
    ],
    "narration": [
        "narration"
    ],
    "narrations": [
        "narration"
    ],
    "narrative": [
        "narratif"
    ],
    "narratives": [
        "narratif",
        "narrative"
    ],
    "narratrice": [
        "narrateur"
    ],
    "narratrices": [
        "narrateur"
    ],
    "narre": [
        "narrer"
    ],
    "narrer": [
        "narrer"
    ],
    "narree": [
        "narrer"
    ],
    "narrees": [
        "narrer"
    ],
    "narthex": [
        "narthex"
    ],
    "narval": [
        "narval"
    ],
    "narvals": [
        "narval"
    ],
    "nasal": [
        "nasal"
    ],
    "nasale": [
        "nasal"
    ],
    "nasales": [
        "nasal"
    ],
    "nasard": [
        "nasard"
    ],
    "nasardes": [
        "nasard"
    ],
    "nasaux": [
        "nasal"
    ],
    "nasdaq": [
        "nasdaq"
    ],
    "nase": [
        "nase"
    ],
    "naseau": [
        "naseau"
    ],
    "naseaux": [
        "naseau"
    ],
    "nases": [
        "nase"
    ],
    "nasilla": [
        "nasiller"
    ],
    "nasillaient": [
        "nasiller"
    ],
    "nasillait": [
        "nasiller"
    ],
    "nasillant": [
        "nasiller"
    ],
    "nasillard": [
        "nasillard"
    ],
    "nasillarde": [
        "nasillard"
    ],
    "nasillardes": [
        "nasillard"
    ],
    "nasillards": [
        "nasillard"
    ],
    "nasille": [
        "nasiller"
    ],
    "nasillement": [
        "nasillement"
    ],
    "nasillent": [
        "nasiller"
    ],
    "nasiller": [
        "nasiller"
    ],
    "nasillonne": [
        "nasillonner"
    ],
    "nasique": [
        "nasique"
    ],
    "nasopharynx": [
        "nasopharynx"
    ],
    "nasse": [
        "nasse"
    ],
    "nasses": [
        "nasse"
    ],
    "nasserien": [
        "nasserien"
    ],
    "natal": [
        "natal"
    ],
    "natale": [
        "natal"
    ],
    "natales": [
        "natal"
    ],
    "natalite": [
        "natalite"
    ],
    "natals": [
        "natal"
    ],
    "natation": [
        "natation"
    ],
    "natatoire": [
        "natatoire"
    ],
    "natif": [
        "natif"
    ],
    "natifs": [
        "natif"
    ],
    "nation": [
        "nation"
    ],
    "national": [
        "national"
    ],
    "nationale": [
        "national",
        "nationale"
    ],
    "nationalement": [
        "nationalement"
    ],
    "nationales": [
        "national",
        "nationale"
    ],
    "nationalisait": [
        "nationaliser"
    ],
    "nationalisation": [
        "nationalisation"
    ],
    "nationalisations": [
        "nationalisation"
    ],
    "nationalisent": [
        "nationaliser"
    ],
    "nationaliser": [
        "nationaliser"
    ],
    "nationalisme": [
        "nationalisme"
    ],
    "nationalisons": [
        "nationaliser"
    ],
    "nationaliste": [
        "nationaliste"
    ],
    "nationalistes": [
        "nationaliste"
    ],
    "nationalise": [
        "nationaliser"
    ],
    "nationalisee": [
        "nationaliser"
    ],
    "nationalisees": [
        "nationaliser"
    ],
    "nationalises": [
        "nationaliser"
    ],
    "nationalite": [
        "nationalite"
    ],
    "nationalites": [
        "nationalite"
    ],
    "nationaux": [
        "national"
    ],
    "nations": [
        "nation"
    ],
    "native": [
        "native",
        "natif"
    ],
    "natives": [
        "native",
        "natif"
    ],
    "nativite": [
        "nativite"
    ],
    "nativites": [
        "nativite"
    ],
    "natron": [
        "natron"
    ],
    "natrum": [
        "natrum"
    ],
    "natremie": [
        "natremie"
    ],
    "natta": [
        "natter"
    ],
    "natte": [
        "natter",
        "natte"
    ],
    "natter": [
        "natter",
        "nat"
    ],
    "nattes": [
        "natter",
        "natte"
    ],
    "nattier": [
        "nattier"
    ],
    "nattee": [
        "natter"
    ],
    "nattees": [
        "natter"
    ],
    "naturalisation": [
        "naturalisation"
    ],
    "naturaliser": [
        "naturaliser"
    ],
    "naturalisme": [
        "naturalisme"
    ],
    "naturaliste": [
        "naturaliste"
    ],
    "naturalistes": [
        "naturaliste"
    ],
    "naturalise": [
        "naturalise",
        "naturaliser"
    ],
    "naturalisee": [
        "naturalise"
    ],
    "naturalises": [
        "naturalise",
        "naturaliser"
    ],
    "nature": [
        "nature"
    ],
    "naturel": [
        "naturel"
    ],
    "naturelle": [
        "naturel"
    ],
    "naturellement": [
        "naturellement"
    ],
    "naturelles": [
        "naturel"
    ],
    "naturels": [
        "naturel"
    ],
    "natures": [
        "nature"
    ],
    "naturisme": [
        "naturisme"
    ],
    "naturiste": [
        "naturiste"
    ],
    "naturistes": [
        "naturiste"
    ],
    "naturlich": [
        "naturlich"
    ],
    "naturopathe": [
        "naturopathe"
    ],
    "naufrage": [
        "naufrager",
        "naufrage"
    ],
    "naufrageant": [
        "naufrager"
    ],
    "naufragent": [
        "naufrager"
    ],
    "naufrager": [
        "naufrager"
    ],
    "naufrages": [
        "naufrager",
        "naufrage"
    ],
    "naufrageur": [
        "naufrageur"
    ],
    "naufrageurs": [
        "naufrageur"
    ],
    "naufrageuse": [
        "naufrageur"
    ],
    "naufragee": [
        "naufrager",
        "naufrage"
    ],
    "naufragees": [
        "naufrage"
    ],
    "nauseabond": [
        "nauseabond"
    ],
    "nauseabonde": [
        "nauseabond"
    ],
    "nauseabondes": [
        "nauseabond"
    ],
    "nauseabonds": [
        "nauseabond"
    ],
    "nausee": [
        "nausee"
    ],
    "nausees": [
        "nausee"
    ],
    "nauseeuse": [
        "nauseeux"
    ],
    "nauseeuses": [
        "nauseeux"
    ],
    "nauseeux": [
        "nauseeux"
    ],
    "nautes": [
        "naute"
    ],
    "nautile": [
        "nautile"
    ],
    "nautilus": [
        "nautilus"
    ],
    "nautique": [
        "nautique"
    ],
    "nautiques": [
        "nautique"
    ],
    "nautonier": [
        "nautonier"
    ],
    "nautoniers": [
        "nautonier"
    ],
    "navaja": [
        "navaja"
    ],
    "navajas": [
        "navaja"
    ],
    "navajo": [
        "navajo"
    ],
    "navajos": [
        "navajo"
    ],
    "naval": [
        "naval"
    ],
    "navale": [
        "naval",
        "navale"
    ],
    "navales": [
        "naval",
        "navale"
    ],
    "navals": [
        "naval"
    ],
    "navarin": [
        "navarin"
    ],
    "navarins": [
        "navarin"
    ],
    "navarrais": [
        "navarrais"
    ],
    "nave": [
        "nave"
    ],
    "navel": [
        "navel"
    ],
    "navet": [
        "navet"
    ],
    "navets": [
        "navet"
    ],
    "navette": [
        "navette"
    ],
    "navettes": [
        "navette"
    ],
    "navicert": [
        "navicert"
    ],
    "navigabilite": [
        "navigabilite"
    ],
    "navigable": [
        "navigable"
    ],
    "navigables": [
        "navigable"
    ],
    "navigant": [
        "navigant"
    ],
    "navigante": [
        "navigant"
    ],
    "navigateur": [
        "navigateur"
    ],
    "navigateurs": [
        "navigateur"
    ],
    "navigation": [
        "navigation"
    ],
    "navigations": [
        "navigation"
    ],
    "navigatrice": [
        "navigateur"
    ],
    "navigua": [
        "naviguer"
    ],
    "naviguaient": [
        "naviguer"
    ],
    "naviguais": [
        "naviguer"
    ],
    "naviguait": [
        "naviguer"
    ],
    "naviguant": [
        "naviguer"
    ],
    "navigue": [
        "naviguer"
    ],
    "naviguent": [
        "naviguer"
    ],
    "naviguer": [
        "naviguer"
    ],
    "naviguera": [
        "naviguer"
    ],
    "naviguerai": [
        "naviguer"
    ],
    "navigueraient": [
        "naviguer"
    ],
    "naviguerons": [
        "naviguer"
    ],
    "navigues": [
        "naviguer"
    ],
    "naviguez": [
        "naviguer"
    ],
    "naviguiez": [
        "naviguer"
    ],
    "naviguions": [
        "naviguer"
    ],
    "naviguons": [
        "naviguer"
    ],
    "naviguerent": [
        "naviguer"
    ],
    "navire": [
        "navire"
    ],
    "navires": [
        "navire"
    ],
    "navra": [
        "navrer"
    ],
    "navrait": [
        "navrer"
    ],
    "navrance": [
        "navrance"
    ],
    "navrant": [
        "navrant",
        "navrer"
    ],
    "navrante": [
        "navrant"
    ],
    "navrantes": [
        "navrant"
    ],
    "navrants": [
        "navrant"
    ],
    "navre": [
        "navre",
        "navrer"
    ],
    "navrer": [
        "navrer"
    ],
    "navres": [
        "navre",
        "navrer"
    ],
    "navrez": [
        "navrer"
    ],
    "navree": [
        "navre",
        "navrer"
    ],
    "navrees": [
        "navre",
        "navrer"
    ],
    "nay": [
        "nay"
    ],
    "nazareen": [
        "nazareen"
    ],
    "naze": [
        "naze"
    ],
    "nazes": [
        "naze"
    ],
    "nazi": [
        "nazi"
    ],
    "nazie": [
        "nazi"
    ],
    "nazies": [
        "nazi"
    ],
    "nazillons": [
        "nazillon"
    ],
    "nazis": [
        "nazi"
    ],
    "nazisme": [
        "nazisme"
    ],
    "nait": [
        "naitre"
    ],
    "naitra": [
        "naitre"
    ],
    "naitrai": [
        "naitre"
    ],
    "naitraient": [
        "naitre"
    ],
    "naitrait": [
        "naitre"
    ],
    "naitre": [
        "naitre"
    ],
    "naitrions": [
        "naitre"
    ],
    "naitront": [
        "naitre"
    ],
    "naiade": [
        "naiade"
    ],
    "naiades": [
        "naiade"
    ],
    "naif": [
        "naif"
    ],
    "naifs": [
        "naif"
    ],
    "naive": [
        "naif",
        "naive"
    ],
    "naivement": [
        "naivement"
    ],
    "naives": [
        "naif",
        "naive"
    ],
    "naivete": [
        "naivete"
    ],
    "naivetes": [
        "naivete"
    ],
    "ne": [
        "naitre",
        "ne"
    ],
    "nec": [
        "nec"
    ],
    "neck": [
        "neck"
    ],
    "nectar": [
        "nectar"
    ],
    "nectarine": [
        "nectarine"
    ],
    "nectarines": [
        "nectarine"
    ],
    "nef": [
        "nef"
    ],
    "nefs": [
        "nef"
    ],
    "negro": [
        "negro"
    ],
    "neige": [
        "neige",
        "neiger"
    ],
    "neigeait": [
        "neiger"
    ],
    "neiger": [
        "neiger"
    ],
    "neigera": [
        "neiger"
    ],
    "neigerait": [
        "neiger"
    ],
    "neiges": [
        "neige",
        "neiger"
    ],
    "neigeuse": [
        "neigeux"
    ],
    "neigeuses": [
        "neigeux"
    ],
    "neigeux": [
        "neigeux"
    ],
    "nem": [
        "nem"
    ],
    "nemrod": [
        "nemrod"
    ],
    "nems": [
        "nem"
    ],
    "nenni": [
        "nenni"
    ],
    "nephtys": [
        "nephtys"
    ],
    "neptunienne": [
        "neptunien"
    ],
    "neptuniens": [
        "neptunien"
    ],
    "nerf": [
        "nerf"
    ],
    "nerfs": [
        "nerf"
    ],
    "nerprun": [
        "nerprun"
    ],
    "nerpruns": [
        "nerprun"
    ],
    "nerva": [
        "nerver"
    ],
    "nerver": [
        "nerver"
    ],
    "nerveuse": [
        "nerveux"
    ],
    "nerveusement": [
        "nerveusement"
    ],
    "nerveuses": [
        "nerveux"
    ],
    "nerveux": [
        "nerveux"
    ],
    "nervi": [
        "nervi"
    ],
    "nervis": [
        "nervi"
    ],
    "nervosite": [
        "nervosite"
    ],
    "nervosites": [
        "nervosite"
    ],
    "nervure": [
        "nervurer",
        "nervure"
    ],
    "nervures": [
        "nervure"
    ],
    "nervuree": [
        "nervurer"
    ],
    "nervurees": [
        "nervurer"
    ],
    "nerve": [
        "nerver"
    ],
    "nescafe": [
        "nescafe"
    ],
    "nestor": [
        "nestor"
    ],
    "nestorianisme": [
        "nestorianisme"
    ],
    "nestorien": [
        "nestorien"
    ],
    "nestorienne": [
        "nestorien"
    ],
    "nestoriennes": [
        "nestorien"
    ],
    "nestoriens": [
        "nestorien"
    ],
    "net": [
        "net"
    ],
    "nets": [
        "net"
    ],
    "nette": [
        "net"
    ],
    "nettement": [
        "nettement"
    ],
    "nettes": [
        "net"
    ],
    "nettete": [
        "nettete"
    ],
    "nettoie": [
        "nettoyer"
    ],
    "nettoiement": [
        "nettoiement"
    ],
    "nettoient": [
        "nettoyer"
    ],
    "nettoiera": [
        "nettoyer"
    ],
    "nettoierai": [
        "nettoyer"
    ],
    "nettoieraient": [
        "nettoyer"
    ],
    "nettoierais": [
        "nettoyer"
    ],
    "nettoierait": [
        "nettoyer"
    ],
    "nettoieras": [
        "nettoyer"
    ],
    "nettoierez": [
        "nettoyer"
    ],
    "nettoierons": [
        "nettoyer"
    ],
    "nettoies": [
        "nettoyer"
    ],
    "nettoya": [
        "nettoyer"
    ],
    "nettoyable": [
        "nettoyable"
    ],
    "nettoyables": [
        "nettoyable"
    ],
    "nettoyage": [
        "nettoyage"
    ],
    "nettoyages": [
        "nettoyage"
    ],
    "nettoyai": [
        "nettoyer"
    ],
    "nettoyaient": [
        "nettoyer"
    ],
    "nettoyais": [
        "nettoyer"
    ],
    "nettoyait": [
        "nettoyer"
    ],
    "nettoyant": [
        "nettoyant",
        "nettoyer"
    ],
    "nettoyante": [
        "nettoyant"
    ],
    "nettoyants": [
        "nettoyant"
    ],
    "nettoyer": [
        "nettoyer"
    ],
    "nettoyeur": [
        "nettoyeur"
    ],
    "nettoyeurs": [
        "nettoyeur"
    ],
    "nettoyeuse": [
        "nettoyeur"
    ],
    "nettoyeuses": [
        "nettoyeur"
    ],
    "nettoyez": [
        "nettoyer"
    ],
    "nettoyiez": [
        "nettoyer"
    ],
    "nettoyons": [
        "nettoyer"
    ],
    "nettoyat": [
        "nettoyer"
    ],
    "nettoyerent": [
        "nettoyer"
    ],
    "nettoye": [
        "nettoyer"
    ],
    "nettoyee": [
        "nettoyer"
    ],
    "nettoyees": [
        "nettoyer"
    ],
    "nettoyes": [
        "nettoyer"
    ],
    "neuf": [
        "neuf"
    ],
    "neufs": [
        "neuf"
    ],
    "neuneu": [
        "neuneu"
    ],
    "neural": [
        "neural"
    ],
    "neurale": [
        "neural"
    ],
    "neurales": [
        "neural"
    ],
    "neurasthenie": [
        "neurasthenie"
    ],
    "neurasthenique": [
        "neurasthenique"
    ],
    "neurastheniques": [
        "neurasthenique"
    ],
    "neurinome": [
        "neurinome"
    ],
    "neurobiologie": [
        "neurobiologie"
    ],
    "neurobiologiste": [
        "neurobiologiste"
    ],
    "neurochimie": [
        "neurochimie"
    ],
    "neurochimique": [
        "neurochimique"
    ],
    "neurochirurgie": [
        "neurochirurgie"
    ],
    "neurochirurgien": [
        "neurochirurgien"
    ],
    "neurochirurgienne": [
        "neurochirurgien"
    ],
    "neurofibromatose": [
        "neurofibromatose"
    ],
    "neuroleptique": [
        "neuroleptique"
    ],
    "neuroleptiques": [
        "neuroleptique"
    ],
    "neurolinguistique": [
        "neurolinguistique"
    ],
    "neurologie": [
        "neurologie"
    ],
    "neurologique": [
        "neurologique"
    ],
    "neurologiquement": [
        "neurologiquement"
    ],
    "neurologiques": [
        "neurologique"
    ],
    "neurologiste": [
        "neurologiste"
    ],
    "neurologue": [
        "neurologue"
    ],
    "neurologues": [
        "neurologue"
    ],
    "neuromusculaire": [
        "neuromusculaire"
    ],
    "neuronal": [
        "neuronal"
    ],
    "neuronale": [
        "neuronal"
    ],
    "neuronales": [
        "neuronal"
    ],
    "neuronaux": [
        "neuronal"
    ],
    "neurone": [
        "neurone"
    ],
    "neurones": [
        "neurone"
    ],
    "neuronique": [
        "neuronique"
    ],
    "neuropathie": [
        "neuropathie"
    ],
    "neuropathologie": [
        "neuropathologie"
    ],
    "neuropeptide": [
        "neuropeptide"
    ],
    "neurophysiologie": [
        "neurophysiologie"
    ],
    "neuroplegique": [
        "neuroplegique"
    ],
    "neuropsychiatrie": [
        "neuropsychiatrie"
    ],
    "neuropsychologiques": [
        "neuropsychologique"
    ],
    "neuropsychologue": [
        "neuropsychologue"
    ],
    "neuroscience": [
        "neuroscience"
    ],
    "neurotoxine": [
        "neurotoxine"
    ],
    "neurotoxique": [
        "neurotoxique"
    ],
    "neurotransmetteur": [
        "neurotransmetteur"
    ],
    "neurotransmetteurs": [
        "neurotransmetteur"
    ],
    "neutralisaient": [
        "neutraliser"
    ],
    "neutralisait": [
        "neutraliser"
    ],
    "neutralisant": [
        "neutralisant",
        "neutraliser"
    ],
    "neutralisante": [
        "neutralisant"
    ],
    "neutralisateur": [
        "neutralisateur"
    ],
    "neutralisation": [
        "neutralisation"
    ],
    "neutralise": [
        "neutraliser"
    ],
    "neutralisent": [
        "neutraliser"
    ],
    "neutraliser": [
        "neutraliser"
    ],
    "neutralisera": [
        "neutraliser"
    ],
    "neutraliserai": [
        "neutraliser"
    ],
    "neutraliseraient": [
        "neutraliser"
    ],
    "neutraliserait": [
        "neutraliser"
    ],
    "neutraliseront": [
        "neutraliser"
    ],
    "neutralisez": [
        "neutraliser"
    ],
    "neutralisiez": [
        "neutraliser"
    ],
    "neutralisons": [
        "neutraliser"
    ],
    "neutraliste": [
        "neutraliste"
    ],
    "neutralisee": [
        "neutraliser"
    ],
    "neutralisees": [
        "neutraliser"
    ],
    "neutralises": [
        "neutralise",
        "neutraliser"
    ],
    "neutralite": [
        "neutralite"
    ],
    "neutre": [
        "neutre"
    ],
    "neutres": [
        "neutre"
    ],
    "neutrino": [
        "neutrino"
    ],
    "neutrinos": [
        "neutrino"
    ],
    "neutron": [
        "neutron"
    ],
    "neutronique": [
        "neutronique"
    ],
    "neutrons": [
        "neutron"
    ],
    "neutropenie": [
        "neutropenie"
    ],
    "neuvaine": [
        "neuvaine"
    ],
    "neuvaines": [
        "neuvaine"
    ],
    "neuve": [
        "neuf"
    ],
    "neuves": [
        "neuf"
    ],
    "neuvieme": [
        "neuvieme"
    ],
    "neuviemes": [
        "neuvieme"
    ],
    "neveu": [
        "neveu"
    ],
    "neveux": [
        "neveux"
    ],
    "new": [
        "new"
    ],
    "news": [
        "new"
    ],
    "ney": [
        "ney"
    ],
    "nez": [
        "nez"
    ],
    "ni": [
        "ni"
    ],
    "nia": [
        "nier"
    ],
    "niable": [
        "niable"
    ],
    "niai": [
        "nier"
    ],
    "niaient": [
        "nier"
    ],
    "niais": [
        "niais",
        "nier"
    ],
    "niaise": [
        "niais",
        "niaiser"
    ],
    "niaisement": [
        "niaisement"
    ],
    "niaiser": [
        "niaiser"
    ],
    "niaiserie": [
        "niaiserie"
    ],
    "niaiseries": [
        "niaiserie"
    ],
    "niaises": [
        "niais"
    ],
    "niaiseuse": [
        "niaiseux"
    ],
    "niaiseux": [
        "niaiseux"
    ],
    "niait": [
        "nier"
    ],
    "niakoue": [
        "niakoue"
    ],
    "niakoues": [
        "niakoue"
    ],
    "niant": [
        "nier"
    ],
    "nib": [
        "nib"
    ],
    "nibard": [
        "nibard"
    ],
    "nibards": [
        "nibard"
    ],
    "nibergue": [
        "nibergue"
    ],
    "nicaraguayen": [
        "nicaraguayen"
    ],
    "nicaraguayenne": [
        "nicaraguayen"
    ],
    "nicaraguayens": [
        "nicaraguayen"
    ],
    "nice": [
        "nice"
    ],
    "nicet": [
        "nicet"
    ],
    "nicha": [
        "nicher"
    ],
    "nichaient": [
        "nicher"
    ],
    "nichait": [
        "nicher"
    ],
    "nichan": [
        "nichan"
    ],
    "nichant": [
        "nicher"
    ],
    "niche": [
        "niche",
        "nicher"
    ],
    "nichent": [
        "nicher"
    ],
    "nicher": [
        "nicher"
    ],
    "niches": [
        "nich",
        "niche",
        "nicher"
    ],
    "nicheurs": [
        "nicheur"
    ],
    "nichions": [
        "nicher"
    ],
    "nichon": [
        "nichon"
    ],
    "nichonnee": [
        "nichonnee"
    ],
    "nichonnees": [
        "nichonnee"
    ],
    "nichons": [
        "nichon",
        "nicher"
    ],
    "nicherent": [
        "nicher"
    ],
    "nichee": [
        "nichee",
        "nicher"
    ],
    "nichees": [
        "nichee",
        "nicher"
    ],
    "nickel": [
        "nickel"
    ],
    "nickelle": [
        "nickeler"
    ],
    "nickels": [
        "nickel"
    ],
    "nickele": [
        "nickeler",
        "nickele"
    ],
    "nickelee": [
        "nickeler",
        "nickele"
    ],
    "nickelees": [
        "nickeler",
        "nickele"
    ],
    "nickeles": [
        "nickeler",
        "nickele"
    ],
    "nicotine": [
        "nicotine"
    ],
    "nicotinise": [
        "nicotiniser"
    ],
    "nicotinises": [
        "nicotiniser"
    ],
    "nictation": [
        "nictation"
    ],
    "nictitant": [
        "nictitant"
    ],
    "nictitante": [
        "nictitant"
    ],
    "nid": [
        "nid"
    ],
    "nidification": [
        "nidification"
    ],
    "nidificatrices": [
        "nidificateur"
    ],
    "nidifie": [
        "nidifier"
    ],
    "nids": [
        "nid"
    ],
    "nie": [
        "nie",
        "nier"
    ],
    "nielle": [
        "nielle",
        "nieller"
    ],
    "nient": [
        "nier"
    ],
    "nier": [
        "nier"
    ],
    "niera": [
        "nier"
    ],
    "nierai": [
        "nier"
    ],
    "nierais": [
        "nier"
    ],
    "nierait": [
        "nier"
    ],
    "nieras": [
        "nier"
    ],
    "nierez": [
        "nier"
    ],
    "nieriez": [
        "nier"
    ],
    "nierons": [
        "nier"
    ],
    "nieront": [
        "nier"
    ],
    "nies": [
        "ny",
        "nie",
        "nier"
    ],
    "niet": [
        "niet"
    ],
    "nietzscheen": [
        "nietzscheen"
    ],
    "nietzscheenne": [
        "nietzscheenne",
        "nietzscheen"
    ],
    "nietzscheennes": [
        "nietzscheenne",
        "nietzscheen"
    ],
    "niez": [
        "nier"
    ],
    "nigaud": [
        "nigaud"
    ],
    "nigaude": [
        "nigaud"
    ],
    "nigaudement": [
        "nigaudement"
    ],
    "nigauderie": [
        "nigauderie"
    ],
    "nigauds": [
        "nigaud"
    ],
    "nigelle": [
        "nigel"
    ],
    "niguedouille": [
        "niguedouille"
    ],
    "nigerian": [
        "nigerian"
    ],
    "nigeriane": [
        "nigerian"
    ],
    "nigerians": [
        "nigerian"
    ],
    "nigerien": [
        "nigerien"
    ],
    "nigeriens": [
        "nigerien"
    ],
    "nihilisme": [
        "nihilisme"
    ],
    "nihiliste": [
        "nihiliste"
    ],
    "nihilistes": [
        "nihiliste"
    ],
    "nikkei": [
        "nikkei"
    ],
    "nil": [
        "nil"
    ],
    "nim": [
        "nim"
    ],
    "nimba": [
        "nimber"
    ],
    "nimbaient": [
        "nimber"
    ],
    "nimbait": [
        "nimber"
    ],
    "nimbant": [
        "nimber"
    ],
    "nimbe": [
        "nimber",
        "nimbe"
    ],
    "nimbent": [
        "nimber"
    ],
    "nimber": [
        "nimber"
    ],
    "nimbes": [
        "nimber",
        "nimbe"
    ],
    "nimbo": [
        "nimbo"
    ],
    "nimbostratus": [
        "nimbostratus"
    ],
    "nimbus": [
        "nimbus"
    ],
    "nimbee": [
        "nimber",
        "nimbe"
    ],
    "nimbees": [
        "nimber"
    ],
    "ninas": [
        "nina",
        "ninas"
    ],
    "niobium": [
        "niobium"
    ],
    "niolo": [
        "niolo"
    ],
    "nions": [
        "nier"
    ],
    "nioulouque": [
        "nioulouque"
    ],
    "nippe": [
        "nipper",
        "nippe"
    ],
    "nipper": [
        "nipper"
    ],
    "nippes": [
        "nipper",
        "nippe"
    ],
    "nippez": [
        "nipper"
    ],
    "nippo": [
        "nippo"
    ],
    "nippon": [
        "nippon"
    ],
    "nippone": [
        "nippon"
    ],
    "nippones": [
        "nippon"
    ],
    "nipponne": [
        "nipponne"
    ],
    "nippons": [
        "nippon"
    ],
    "nippee": [
        "nipper"
    ],
    "nippees": [
        "nipper"
    ],
    "niquait": [
        "niquer"
    ],
    "nique": [
        "nique",
        "niquer"
    ],
    "niquedouille": [
        "niquedouille"
    ],
    "niquent": [
        "niquer"
    ],
    "niquer": [
        "niquer"
    ],
    "niquera": [
        "niquer"
    ],
    "niquerait": [
        "niquer"
    ],
    "niques": [
        "niquer"
    ],
    "niquez": [
        "niquer"
    ],
    "niquons": [
        "niquer"
    ],
    "niquee": [
        "niquer"
    ],
    "nirvana": [
        "nirvana"
    ],
    "nirvanas": [
        "nirvana"
    ],
    "nisan": [
        "nisan"
    ],
    "nitratant": [
        "nitrater"
    ],
    "nitrate": [
        "nitrate"
    ],
    "nitrates": [
        "nitrate"
    ],
    "nitre": [
        "nitre"
    ],
    "nitreuse": [
        "nitreux"
    ],
    "nitreux": [
        "nitreux"
    ],
    "nitrique": [
        "nitrique"
    ],
    "nitrite": [
        "nitrite"
    ],
    "nitroglycerine": [
        "nitroglycerine"
    ],
    "nitrogene": [
        "nitrogene"
    ],
    "nivaquine": [
        "nivaquine"
    ],
    "niveau": [
        "niveau"
    ],
    "niveaux": [
        "niveau"
    ],
    "nivelait": [
        "niveler"
    ],
    "nivelant": [
        "niveler"
    ],
    "niveler": [
        "niveler"
    ],
    "niveleur": [
        "niveleur"
    ],
    "niveleurs": [
        "niveleur"
    ],
    "niveleuse": [
        "niveleur"
    ],
    "nivelle": [
        "niveler"
    ],
    "nivellement": [
        "nivellement"
    ],
    "nivellent": [
        "niveler"
    ],
    "nivelat": [
        "niveler"
    ],
    "nivele": [
        "niveler"
    ],
    "nivelee": [
        "niveler"
    ],
    "nivelees": [
        "niveler"
    ],
    "niveles": [
        "niveler"
    ],
    "nivernais": [
        "nivernais"
    ],
    "nivernaise": [
        "nivernaise"
    ],
    "nivose": [
        "nivose"
    ],
    "nixe": [
        "nixe"
    ],
    "nicois": [
        "nicois"
    ],
    "nicoise": [
        "nicois"
    ],
    "nicoises": [
        "nicois"
    ],
    "niece": [
        "niece"
    ],
    "nieces": [
        "niece"
    ],
    "nieme": [
        "nieme"
    ],
    "niere": [
        "niere"
    ],
    "nierent": [
        "nier"
    ],
    "niebe": [
        "niebe"
    ],
    "niee": [
        "nie",
        "nier"
    ],
    "nobiliaire": [
        "nobiliaire"
    ],
    "nobiliaires": [
        "nobiliaire"
    ],
    "nobilitas": [
        "nobilitas"
    ],
    "noblaillon": [
        "noblaillon"
    ],
    "noble": [
        "noble"
    ],
    "noblement": [
        "noblement"
    ],
    "nobles": [
        "noble"
    ],
    "noblesse": [
        "noblesse"
    ],
    "noblesses": [
        "noblesse"
    ],
    "nobliau": [
        "nobliau"
    ],
    "nobliaux": [
        "nobliau"
    ],
    "noce": [
        "noce"
    ],
    "nocer": [
        "nocer"
    ],
    "noces": [
        "noce"
    ],
    "noceur": [
        "noceur"
    ],
    "noceurs": [
        "noceur"
    ],
    "noceuse": [
        "noceur"
    ],
    "noceuses": [
        "noceur"
    ],
    "nocher": [
        "nocher"
    ],
    "nochere": [
        "nochere"
    ],
    "nocif": [
        "nocif"
    ],
    "nocifs": [
        "nocif"
    ],
    "nocive": [
        "nocif"
    ],
    "nocives": [
        "nocif"
    ],
    "nocivite": [
        "nocivite"
    ],
    "noctambule": [
        "noctambule"
    ],
    "noctambules": [
        "noctambule"
    ],
    "noctambulisme": [
        "noctambulisme"
    ],
    "nocturnal": [
        "nocturnal"
    ],
    "nocturne": [
        "nocturne"
    ],
    "nocturnes": [
        "nocturne"
    ],
    "nodal": [
        "nodal"
    ],
    "nodales": [
        "nodal"
    ],
    "nodosites": [
        "nodosite"
    ],
    "nodule": [
        "nodule"
    ],
    "nodules": [
        "nodule"
    ],
    "noduleux": [
        "noduleux"
    ],
    "nodus": [
        "nodus"
    ],
    "noeud": [
        "noeud"
    ],
    "noeuds": [
        "noeud"
    ],
    "noie": [
        "noyer"
    ],
    "noient": [
        "noyer"
    ],
    "noiera": [
        "noyer"
    ],
    "noierai": [
        "noyer"
    ],
    "noieraient": [
        "noyer"
    ],
    "noierait": [
        "noyer"
    ],
    "noieras": [
        "noyer"
    ],
    "noierez": [
        "noyer"
    ],
    "noieront": [
        "noyer"
    ],
    "noies": [
        "noyer"
    ],
    "noir": [
        "noir"
    ],
    "noiraud": [
        "noiraud"
    ],
    "noiraude": [
        "noiraud"
    ],
    "noiraudes": [
        "noiraud"
    ],
    "noirauds": [
        "noiraud"
    ],
    "noirceur": [
        "noirceur"
    ],
    "noirceurs": [
        "noirceur"
    ],
    "noirci": [
        "noircir",
        "noirci"
    ],
    "noircie": [
        "noircir",
        "noirci"
    ],
    "noircies": [
        "noircir",
        "noirci"
    ],
    "noircir": [
        "noircir"
    ],
    "noircirai": [
        "noircir"
    ],
    "noircirais": [
        "noircir"
    ],
    "noircirait": [
        "noircir"
    ],
    "noircirent": [
        "noircir"
    ],
    "noircis": [
        "noircir",
        "noirci"
    ],
    "noircissaient": [
        "noircir"
    ],
    "noircissais": [
        "noircir"
    ],
    "noircissait": [
        "noircir"
    ],
    "noircissant": [
        "noircir"
    ],
    "noircisse": [
        "noircir"
    ],
    "noircissent": [
        "noircir"
    ],
    "noircissez": [
        "noircir"
    ],
    "noircit": [
        "noircir"
    ],
    "noire": [
        "noir"
    ],
    "noires": [
        "noir"
    ],
    "noirs": [
        "noir"
    ],
    "noiratre": [
        "noiratre"
    ],
    "noiratres": [
        "noiratre"
    ],
    "noise": [
        "noise"
    ],
    "noises": [
        "noise"
    ],
    "noisetier": [
        "noisetier"
    ],
    "noisetiers": [
        "noisetier"
    ],
    "noisette": [
        "noisette"
    ],
    "noisettes": [
        "noisette"
    ],
    "noix": [
        "noix"
    ],
    "nok": [
        "nok"
    ],
    "nolis": [
        "nolis"
    ],
    "nom": [
        "nom"
    ],
    "nomade": [
        "nomade"
    ],
    "nomades": [
        "nomade"
    ],
    "nomadisait": [
        "nomadiser"
    ],
    "nomadisant": [
        "nomadiser"
    ],
    "nomadisent": [
        "nomadiser"
    ],
    "nomadisme": [
        "nomadisme"
    ],
    "nombre": [
        "nombre"
    ],
    "nombres": [
        "nombre"
    ],
    "nombreuse": [
        "nombreux"
    ],
    "nombreuses": [
        "nombreux"
    ],
    "nombreux": [
        "nombreux"
    ],
    "nombril": [
        "nombril"
    ],
    "nombrilisme": [
        "nombrilisme"
    ],
    "nombriliste": [
        "nombriliste"
    ],
    "nombrils": [
        "nombril"
    ],
    "nome": [
        "nome"
    ],
    "nomenclature": [
        "nomenclature"
    ],
    "nomenclatures": [
        "nomenclature"
    ],
    "nomenklatura": [
        "nomenklatura"
    ],
    "nominal": [
        "nominal"
    ],
    "nominale": [
        "nominal"
    ],
    "nominalement": [
        "nominalement"
    ],
    "nominales": [
        "nominal"
    ],
    "nominaliste": [
        "nominaliste"
    ],
    "nominatif": [
        "nominatif"
    ],
    "nominatifs": [
        "nominatif"
    ],
    "nomination": [
        "nomination"
    ],
    "nominations": [
        "nomination"
    ],
    "nominative": [
        "nominatif"
    ],
    "nominatives": [
        "nominatif"
    ],
    "nominaux": [
        "nominal"
    ],
    "nomine": [
        "nominer"
    ],
    "nominer": [
        "nominer"
    ],
    "nominee": [
        "nominer"
    ],
    "nominees": [
        "nominee",
        "nominer"
    ],
    "nomines": [
        "nominer"
    ],
    "nomma": [
        "nommer"
    ],
    "nommai": [
        "nommer"
    ],
    "nommaient": [
        "nommer"
    ],
    "nommais": [
        "nommer"
    ],
    "nommait": [
        "nommer"
    ],
    "nommant": [
        "nommer"
    ],
    "nomme": [
        "nomme",
        "nommer"
    ],
    "nomment": [
        "nommer"
    ],
    "nommer": [
        "nommer"
    ],
    "nommera": [
        "nommer"
    ],
    "nommerai": [
        "nommer"
    ],
    "nommerais": [
        "nommer"
    ],
    "nommerait": [
        "nommer"
    ],
    "nommeras": [
        "nommer"
    ],
    "nommeriez": [
        "nommer"
    ],
    "nommerons": [
        "nommer"
    ],
    "nommeront": [
        "nommer"
    ],
    "nommes": [
        "nomme",
        "nommer"
    ],
    "nommez": [
        "nommer"
    ],
    "nommiez": [
        "nommer"
    ],
    "nommions": [
        "nommer"
    ],
    "nommons": [
        "nommer"
    ],
    "nommat": [
        "nommer"
    ],
    "nommerent": [
        "nommer"
    ],
    "nommee": [
        "nomme",
        "nommer"
    ],
    "nommees": [
        "nomme",
        "nommer"
    ],
    "nommement": [
        "nommement"
    ],
    "noms": [
        "nom"
    ],
    "non": [
        "non"
    ],
    "nonagenaire": [
        "nonagenaire"
    ],
    "nonagenaires": [
        "nonagenaire"
    ],
    "nonante": [
        "nonante"
    ],
    "nonce": [
        "nonce"
    ],
    "nonchalamment": [
        "nonchalamment"
    ],
    "nonchalance": [
        "nonchalance"
    ],
    "nonchalant": [
        "nonchalant"
    ],
    "nonchalante": [
        "nonchalant"
    ],
    "nonchalantes": [
        "nonchalant"
    ],
    "nonchalants": [
        "nonchalant"
    ],
    "nonciature": [
        "nonciature"
    ],
    "none": [
        "none"
    ],
    "nones": [
        "none"
    ],
    "nonette": [
        "nonette"
    ],
    "nonettes": [
        "nonette"
    ],
    "nonidi": [
        "nonidi"
    ],
    "nonnain": [
        "nonnain"
    ],
    "nonne": [
        "nonne"
    ],
    "nonnes": [
        "nonne"
    ],
    "nonnette": [
        "nonnette"
    ],
    "nonnettes": [
        "nonnette"
    ],
    "nonobstant": [
        "nonobstant"
    ],
    "nonpareille": [
        "nonpareil"
    ],
    "nonsense": [
        "nonsense"
    ],
    "nope": [
        "nope"
    ],
    "noradrenaline": [
        "noradrenaline"
    ],
    "nord": [
        "nord"
    ],
    "nordet": [
        "nordet"
    ],
    "nordicite": [
        "nordicite"
    ],
    "nordique": [
        "nordique"
    ],
    "nordiques": [
        "nordique"
    ],
    "nordiste": [
        "nordiste"
    ],
    "nordistes": [
        "nordiste"
    ],
    "noria": [
        "noria"
    ],
    "norias": [
        "noria"
    ],
    "normal": [
        "normal"
    ],
    "normale": [
        "normale",
        "normal"
    ],
    "normalement": [
        "normalement"
    ],
    "normales": [
        "normale",
        "normal"
    ],
    "normalien": [
        "normalien"
    ],
    "normalienne": [
        "normalien"
    ],
    "normaliennes": [
        "normalien"
    ],
    "normaliens": [
        "normalien"
    ],
    "normalisation": [
        "normalisation"
    ],
    "normalise": [
        "normaliser"
    ],
    "normalisent": [
        "normaliser"
    ],
    "normaliser": [
        "normaliser"
    ],
    "normalisons": [
        "normaliser"
    ],
    "normalisee": [
        "normaliser"
    ],
    "normalisees": [
        "normaliser"
    ],
    "normalises": [
        "normalise",
        "normaliser"
    ],
    "normalite": [
        "normalite"
    ],
    "normand": [
        "normand"
    ],
    "normande": [
        "normand"
    ],
    "normandes": [
        "normand"
    ],
    "normands": [
        "normand"
    ],
    "normatif": [
        "normatif"
    ],
    "normative": [
        "normatif"
    ],
    "normaux": [
        "normal"
    ],
    "norme": [
        "norme"
    ],
    "normes": [
        "norme"
    ],
    "noroit": [
        "noroit"
    ],
    "norroise": [
        "norrois"
    ],
    "norvegien": [
        "norvegien"
    ],
    "norvegienne": [
        "norvegien",
        "norvegienne"
    ],
    "norvegiennes": [
        "norvegien",
        "norvegienne"
    ],
    "norvegiens": [
        "norvegien"
    ],
    "nos": [
        "nos",
        "notre"
    ],
    "nosocomiale": [
        "nosocomial"
    ],
    "nostalgie": [
        "nostalgie"
    ],
    "nostalgies": [
        "nostalgie"
    ],
    "nostalgique": [
        "nostalgique"
    ],
    "nostalgiquement": [
        "nostalgiquement"
    ],
    "nostalgiques": [
        "nostalgique"
    ],
    "not": [
        "not"
    ],
    "nota": [
        "nota",
        "noter"
    ],
    "notabilite": [
        "notabilite"
    ],
    "notabilites": [
        "notabilite"
    ],
    "notable": [
        "notable"
    ],
    "notablement": [
        "notablement"
    ],
    "notables": [
        "notable"
    ],
    "notai": [
        "noter"
    ],
    "notaient": [
        "noter"
    ],
    "notaire": [
        "notaire"
    ],
    "notaires": [
        "notaire"
    ],
    "notais": [
        "noter"
    ],
    "notait": [
        "noter"
    ],
    "notamment": [
        "notamment"
    ],
    "notant": [
        "noter"
    ],
    "notarial": [
        "notarial"
    ],
    "notariale": [
        "notarial"
    ],
    "notariat": [
        "notariat"
    ],
    "notariaux": [
        "notarial"
    ],
    "notarie": [
        "notarier",
        "notarie"
    ],
    "notariee": [
        "notarie"
    ],
    "notariees": [
        "notarier"
    ],
    "notaries": [
        "notarier",
        "notarie"
    ],
    "notation": [
        "notation"
    ],
    "notations": [
        "notation"
    ],
    "note": [
        "note",
        "noter"
    ],
    "notent": [
        "noter"
    ],
    "noter": [
        "noter"
    ],
    "notera": [
        "noter"
    ],
    "noterai": [
        "noter"
    ],
    "noterais": [
        "noter"
    ],
    "noterait": [
        "noter"
    ],
    "noteras": [
        "noter"
    ],
    "noterez": [
        "noter"
    ],
    "noterons": [
        "noter"
    ],
    "noteront": [
        "noter"
    ],
    "notes": [
        "note",
        "noter"
    ],
    "notez": [
        "noter"
    ],
    "notice": [
        "notice"
    ],
    "notices": [
        "notice"
    ],
    "notiez": [
        "noter"
    ],
    "notifia": [
        "notifier"
    ],
    "notifiai": [
        "notifier"
    ],
    "notifiaient": [
        "notifier"
    ],
    "notifiait": [
        "notifier"
    ],
    "notifiant": [
        "notifier"
    ],
    "notification": [
        "notification"
    ],
    "notifier": [
        "notifier"
    ],
    "notifiez": [
        "notifier"
    ],
    "notifions": [
        "notifier"
    ],
    "notifie": [
        "notifier"
    ],
    "notifiee": [
        "notifie",
        "notifier"
    ],
    "notifiees": [
        "notifie",
        "notifier"
    ],
    "notion": [
        "notion"
    ],
    "notions": [
        "noter",
        "notion"
    ],
    "notoire": [
        "notoire"
    ],
    "notoirement": [
        "notoirement"
    ],
    "notoires": [
        "notoire"
    ],
    "notonecte": [
        "notonecte"
    ],
    "notonectes": [
        "notonecte"
    ],
    "notons": [
        "noter"
    ],
    "notoriete": [
        "notoriete"
    ],
    "notorietes": [
        "notoriete"
    ],
    "notre": [
        "notre"
    ],
    "notules": [
        "notule"
    ],
    "noterent": [
        "noter"
    ],
    "notee": [
        "note",
        "noter"
    ],
    "notees": [
        "note",
        "noter"
    ],
    "noua": [
        "nouer"
    ],
    "nouage": [
        "nouage"
    ],
    "nouai": [
        "nouer"
    ],
    "nouaient": [
        "nouer"
    ],
    "nouais": [
        "nouer"
    ],
    "nouait": [
        "nouer"
    ],
    "nouant": [
        "nouer"
    ],
    "nouas": [
        "nouer"
    ],
    "nouba": [
        "nouba"
    ],
    "noubas": [
        "nouba"
    ],
    "noue": [
        "noue",
        "nouer"
    ],
    "nouent": [
        "nouer"
    ],
    "nouer": [
        "nouer"
    ],
    "nouera": [
        "nouer"
    ],
    "nouerais": [
        "nouer"
    ],
    "nouerait": [
        "nouer"
    ],
    "nouerez": [
        "nouer"
    ],
    "noueront": [
        "nouer"
    ],
    "noueuse": [
        "noueux"
    ],
    "noueuses": [
        "noueux"
    ],
    "noueux": [
        "noueux"
    ],
    "nouez": [
        "nouer"
    ],
    "nougat": [
        "nougat"
    ],
    "nougatine": [
        "nougatine"
    ],
    "nougatines": [
        "nougatine"
    ],
    "nougats": [
        "nougat"
    ],
    "nouille": [
        "nouille"
    ],
    "nouilles": [
        "nouille"
    ],
    "noumene": [
        "noumene"
    ],
    "nounou": [
        "nounou"
    ],
    "nounours": [
        "nounours"
    ],
    "nounous": [
        "nounou"
    ],
    "nourri": [
        "nourrir",
        "nourri"
    ],
    "nourrice": [
        "nourrice"
    ],
    "nourrices": [
        "nourrice"
    ],
    "nourricier": [
        "nourricier"
    ],
    "nourriciers": [
        "nourricier"
    ],
    "nourriciere": [
        "nourricier"
    ],
    "nourricieres": [
        "nourricier"
    ],
    "nourrie": [
        "nourrir",
        "nourri"
    ],
    "nourries": [
        "nourrir",
        "nourri"
    ],
    "nourrir": [
        "nourrir"
    ],
    "nourrira": [
        "nourrir"
    ],
    "nourrirai": [
        "nourrir"
    ],
    "nourriraient": [
        "nourrir"
    ],
    "nourrirais": [
        "nourrir"
    ],
    "nourrirait": [
        "nourrir"
    ],
    "nourriras": [
        "nourrir"
    ],
    "nourrirent": [
        "nourrir"
    ],
    "nourrirez": [
        "nourrir"
    ],
    "nourririons": [
        "nourrir"
    ],
    "nourrirons": [
        "nourrir"
    ],
    "nourriront": [
        "nourrir"
    ],
    "nourris": [
        "nourrir",
        "nourri"
    ],
    "nourrissage": [
        "nourrissage"
    ],
    "nourrissaient": [
        "nourrir"
    ],
    "nourrissais": [
        "nourrir"
    ],
    "nourrissait": [
        "nourrir"
    ],
    "nourrissant": [
        "nourrir",
        "nourrissant"
    ],
    "nourrissante": [
        "nourrissant"
    ],
    "nourrissantes": [
        "nourrissant"
    ],
    "nourrissants": [
        "nourrissant"
    ],
    "nourrisse": [
        "nourrir"
    ],
    "nourrissent": [
        "nourrir"
    ],
    "nourrisses": [
        "nourrir"
    ],
    "nourrisseur": [
        "nourrisseur"
    ],
    "nourrissez": [
        "nourrir"
    ],
    "nourrissiez": [
        "nourrir"
    ],
    "nourrissions": [
        "nourrir"
    ],
    "nourrisson": [
        "nourrisson"
    ],
    "nourrissons": [
        "nourrisson",
        "nourrir"
    ],
    "nourrit": [
        "nourrir"
    ],
    "nourriture": [
        "nourriture"
    ],
    "nourritures": [
        "nourriture"
    ],
    "nous": [
        "nous"
    ],
    "nouveau": [
        "nouveau"
    ],
    "nouveaute": [
        "nouveaute"
    ],
    "nouveautes": [
        "nouveaute"
    ],
    "nouveaux": [
        "nouveau"
    ],
    "nouvel": [
        "nouvel"
    ],
    "nouvelle": [
        "nouvelle",
        "nouveau"
    ],
    "nouvellement": [
        "nouvellement"
    ],
    "nouvelles": [
        "nouvelle",
        "nouveau"
    ],
    "nouvellete": [
        "nouvellete"
    ],
    "nouvelliste": [
        "nouvelliste"
    ],
    "nouerent": [
        "nouer"
    ],
    "nouee": [
        "noue",
        "nouer"
    ],
    "nouees": [
        "noue",
        "nouer"
    ],
    "noues": [
        "noue",
        "nouer"
    ],
    "nova": [
        "nova",
        "nover"
    ],
    "novateur": [
        "novateur"
    ],
    "novateurs": [
        "novateur"
    ],
    "novation": [
        "novation"
    ],
    "novatrice": [
        "novateur"
    ],
    "novatrices": [
        "novateur"
    ],
    "nove": [
        "nover"
    ],
    "novelettes": [
        "novelette"
    ],
    "novembre": [
        "novembre"
    ],
    "novice": [
        "novice"
    ],
    "novices": [
        "novice"
    ],
    "noviciat": [
        "noviciat"
    ],
    "novilleros": [
        "novillero"
    ],
    "novillo": [
        "novillo"
    ],
    "novocaine": [
        "novocaine"
    ],
    "novotique": [
        "novotique"
    ],
    "novelisation": [
        "novelisation"
    ],
    "noya": [
        "noyer"
    ],
    "noyade": [
        "noyade"
    ],
    "noyades": [
        "noyade"
    ],
    "noyaient": [
        "noyer"
    ],
    "noyais": [
        "noyer"
    ],
    "noyait": [
        "noyer"
    ],
    "noyant": [
        "noyer"
    ],
    "noyau": [
        "noyau"
    ],
    "noyauta": [
        "noyauter"
    ],
    "noyautage": [
        "noyautage"
    ],
    "noyautant": [
        "noyauter"
    ],
    "noyautent": [
        "noyauter"
    ],
    "noyauter": [
        "noyauter"
    ],
    "noyaute": [
        "noyauter"
    ],
    "noyautee": [
        "noyauter"
    ],
    "noyautees": [
        "noyauter"
    ],
    "noyaux": [
        "noyau"
    ],
    "noyer": [
        "noyer"
    ],
    "noyers": [
        "noyer"
    ],
    "noyez": [
        "noyer"
    ],
    "noyions": [
        "noyer"
    ],
    "noyons": [
        "noyer"
    ],
    "noyerent": [
        "noyer"
    ],
    "noye": [
        "noyer",
        "noye"
    ],
    "noyee": [
        "noyer",
        "noye"
    ],
    "noyees": [
        "noyer",
        "noye"
    ],
    "noyes": [
        "noyer",
        "noye"
    ],
    "noel": [
        "noel"
    ],
    "noels": [
        "noel"
    ],
    "nu": [
        "nu"
    ],
    "nuage": [
        "nuage"
    ],
    "nuages": [
        "nuage"
    ],
    "nuageuse": [
        "nuageux"
    ],
    "nuageuses": [
        "nuageux"
    ],
    "nuageux": [
        "nuageux"
    ],
    "nuance": [
        "nuance",
        "nuancer"
    ],
    "nuancer": [
        "nuancer"
    ],
    "nuances": [
        "nuance",
        "nuancer"
    ],
    "nuancier": [
        "nuancier"
    ],
    "nuancee": [
        "nuancer",
        "nuance"
    ],
    "nuancees": [
        "nuancer",
        "nuance"
    ],
    "nuanca": [
        "nuancer"
    ],
    "nuancaient": [
        "nuancer"
    ],
    "nuancait": [
        "nuancer"
    ],
    "nuancant": [
        "nuancer"
    ],
    "nuancat": [
        "nuancer"
    ],
    "nuas": [
        "nuer"
    ],
    "nubien": [
        "nubien"
    ],
    "nubienne": [
        "nubien"
    ],
    "nubiens": [
        "nubien"
    ],
    "nubile": [
        "nubile"
    ],
    "nubiles": [
        "nubile"
    ],
    "nubilite": [
        "nubilite"
    ],
    "nubuck": [
        "nubuck"
    ],
    "nucal": [
        "nucal"
    ],
    "nucleaire": [
        "nucleaire"
    ],
    "nucleaires": [
        "nucleaire"
    ],
    "nucleique": [
        "nucleique"
    ],
    "nucleoside": [
        "nucleoside"
    ],
    "nucleotides": [
        "nucleotide"
    ],
    "nucleus": [
        "nucleus"
    ],
    "nucleee": [
        "nuclee"
    ],
    "nudisme": [
        "nudisme"
    ],
    "nudiste": [
        "nudiste"
    ],
    "nudistes": [
        "nudiste"
    ],
    "nudite": [
        "nudite"
    ],
    "nudites": [
        "nudite"
    ],
    "nue": [
        "nu"
    ],
    "nuer": [
        "nu",
        "nuer"
    ],
    "nues": [
        "nu"
    ],
    "nui": [
        "nuire"
    ],
    "nuira": [
        "nuire"
    ],
    "nuirai": [
        "nuire"
    ],
    "nuirait": [
        "nuire"
    ],
    "nuiras": [
        "nuire"
    ],
    "nuire": [
        "nuire"
    ],
    "nuiront": [
        "nuire"
    ],
    "nuis": [
        "nuire"
    ],
    "nuisaient": [
        "nuire"
    ],
    "nuisait": [
        "nuire"
    ],
    "nuisance": [
        "nuisance"
    ],
    "nuisances": [
        "nuisance"
    ],
    "nuisant": [
        "nuire"
    ],
    "nuise": [
        "nuire"
    ],
    "nuisent": [
        "nuire"
    ],
    "nuisette": [
        "nuisette"
    ],
    "nuisez": [
        "nuire"
    ],
    "nuisible": [
        "nuisible"
    ],
    "nuisibles": [
        "nuisible"
    ],
    "nuisit": [
        "nuire"
    ],
    "nuit": [
        "nuit",
        "nuire"
    ],
    "nuitamment": [
        "nuitamment"
    ],
    "nuitards": [
        "nuitard"
    ],
    "nuiteux": [
        "nuiteux"
    ],
    "nuits": [
        "nuit"
    ],
    "nuitee": [
        "nuitee"
    ],
    "nuitees": [
        "nuitee"
    ],
    "nul": [
        "nul"
    ],
    "nullard": [
        "nullard"
    ],
    "nullarde": [
        "nullard"
    ],
    "nullardes": [
        "nullard"
    ],
    "nullards": [
        "nullard"
    ],
    "nulle": [
        "nul",
        "nulle"
    ],
    "nullement": [
        "nullement"
    ],
    "nulles": [
        "nul",
        "nulles"
    ],
    "nullissime": [
        "nullissime"
    ],
    "nullite": [
        "nullite"
    ],
    "nullites": [
        "nullite"
    ],
    "nullos": [
        "nullos"
    ],
    "nuls": [
        "nul",
        "nuls"
    ],
    "numide": [
        "numide"
    ],
    "numides": [
        "numide"
    ],
    "numismate": [
        "numismate"
    ],
    "numismates": [
        "numismate"
    ],
    "numismatique": [
        "numismatique"
    ],
    "numeraire": [
        "numeraire"
    ],
    "numeral": [
        "numeral"
    ],
    "numerateur": [
        "numerateur"
    ],
    "numeration": [
        "numeration"
    ],
    "numerique": [
        "numerique"
    ],
    "numeriquement": [
        "numeriquement"
    ],
    "numeriques": [
        "numerique"
    ],
    "numerisation": [
        "numerisation"
    ],
    "numerise": [
        "numeriser"
    ],
    "numeriser": [
        "numeriser"
    ],
    "numerisez": [
        "numeriser"
    ],
    "numerisee": [
        "numeriser"
    ],
    "numerisees": [
        "numeriser"
    ],
    "numero": [
        "numero"
    ],
    "numerologie": [
        "numerologie"
    ],
    "numerologue": [
        "numerologue"
    ],
    "numeros": [
        "numero"
    ],
    "numerota": [
        "numeroter"
    ],
    "numerotage": [
        "numerotage"
    ],
    "numerotaient": [
        "numeroter"
    ],
    "numerotait": [
        "numeroter"
    ],
    "numerotation": [
        "numerotation"
    ],
    "numerote": [
        "numerote",
        "numeroter"
    ],
    "numerotent": [
        "numeroter"
    ],
    "numeroter": [
        "numeroter"
    ],
    "numerotez": [
        "numeroter"
    ],
    "numerotee": [
        "numerote",
        "numeroter"
    ],
    "numerotees": [
        "numerote",
        "numeroter"
    ],
    "numerotes": [
        "numerote",
        "numeroter"
    ],
    "nunchaku": [
        "nunchaku"
    ],
    "nunchakus": [
        "nunchaku"
    ],
    "nuncupatifs": [
        "nuncupatif"
    ],
    "nunuche": [
        "nunuche"
    ],
    "nunuches": [
        "nunuche"
    ],
    "nuptial": [
        "nuptial"
    ],
    "nuptiale": [
        "nuptial"
    ],
    "nuptiales": [
        "nuptial"
    ],
    "nuptialite": [
        "nuptialite"
    ],
    "nuptiaux": [
        "nuptial"
    ],
    "nuque": [
        "nuque"
    ],
    "nuques": [
        "nuque"
    ],
    "nurse": [
        "nurse"
    ],
    "nurseries": [
        "nursery",
        "nurseries"
    ],
    "nursery": [
        "nursery"
    ],
    "nurses": [
        "nurse"
    ],
    "nursing": [
        "nursing",
        "nurse"
    ],
    "nus": [
        "nu"
    ],
    "nutriment": [
        "nutriment"
    ],
    "nutriments": [
        "nutriment"
    ],
    "nutritif": [
        "nutritif"
    ],
    "nutritifs": [
        "nutritif"
    ],
    "nutrition": [
        "nutrition"
    ],
    "nutritionnel": [
        "nutritionnel"
    ],
    "nutritionnelle": [
        "nutritionnel"
    ],
    "nutritionniste": [
        "nutritionniste"
    ],
    "nutritive": [
        "nutritif"
    ],
    "nutritives": [
        "nutritif"
    ],
    "nuee": [
        "nuee"
    ],
    "nuees": [
        "nuee",
        "nuer"
    ],
    "nyctalope": [
        "nyctalope"
    ],
    "nyctalopes": [
        "nyctalope"
    ],
    "nylon": [
        "nylon"
    ],
    "nylons": [
        "nylon"
    ],
    "nymphal": [
        "nymphal"
    ],
    "nymphe": [
        "nymphe"
    ],
    "nymphes": [
        "nymphe"
    ],
    "nymphette": [
        "nymphette"
    ],
    "nymphettes": [
        "nymphette"
    ],
    "nympho": [
        "nympho"
    ],
    "nymphomane": [
        "nymphomane"
    ],
    "nymphomanes": [
        "nymphomane"
    ],
    "nymphomanie": [
        "nymphomanie"
    ],
    "nymphos": [
        "nympho"
    ],
    "nymphea": [
        "nymphea"
    ],
    "nympheas": [
        "nymphea"
    ],
    "nymphees": [
        "nymphee"
    ],
    "nefles": [
        "nefle"
    ],
    "negre": [
        "negre"
    ],
    "negres": [
        "negre"
    ],
    "nepe": [
        "nepe"
    ],
    "nepes": [
        "nepe"
    ],
    "neandertalien": [
        "neandertalien"
    ],
    "neandertaliens": [
        "neandertalien"
    ],
    "neanderthalien": [
        "neanderthalien"
    ],
    "neanmoins": [
        "neanmoins"
    ],
    "neant": [
        "neant"
    ],
    "neantisation": [
        "neantisation"
    ],
    "neantisee": [
        "neantiser"
    ],
    "neants": [
        "neant"
    ],
    "nebuleuse": [
        "nebuleux"
    ],
    "nebuleuses": [
        "nebuleux",
        "nebuleuse"
    ],
    "nebuleux": [
        "nebuleux"
    ],
    "nebuliseur": [
        "nebuliseur"
    ],
    "nebulosite": [
        "nebulosite"
    ],
    "necessaire": [
        "necessaire"
    ],
    "necessairement": [
        "necessairement"
    ],
    "necessaires": [
        "necessaire"
    ],
    "necessita": [
        "necessiter"
    ],
    "necessitaient": [
        "necessiter"
    ],
    "necessitait": [
        "necessiter"
    ],
    "necessitant": [
        "necessiter"
    ],
    "necessite": [
        "necessite",
        "necessiter"
    ],
    "necessitent": [
        "necessiter"
    ],
    "necessiter": [
        "necessiter"
    ],
    "necessitera": [
        "necessiter"
    ],
    "necessiterait": [
        "necessiter"
    ],
    "necessiteuse": [
        "necessiteux"
    ],
    "necessiteuses": [
        "necessiteux"
    ],
    "necessiteux": [
        "necessiteux"
    ],
    "necessitee": [
        "necessiter"
    ],
    "necessitees": [
        "necessiter"
    ],
    "necessites": [
        "necessite",
        "necessiter"
    ],
    "necro": [
        "necro"
    ],
    "necrobioses": [
        "necrobiose"
    ],
    "necrologe": [
        "necrologe"
    ],
    "necrologie": [
        "necrologie"
    ],
    "necrologies": [
        "necrologie"
    ],
    "necrologique": [
        "necrologique"
    ],
    "necrologiques": [
        "necrologique"
    ],
    "necrologue": [
        "necrologue"
    ],
    "necromancie": [
        "necromancie"
    ],
    "necromancien": [
        "necromancien"
    ],
    "necromancienne": [
        "necromancien"
    ],
    "necromanciens": [
        "necromancien"
    ],
    "necromant": [
        "necromant"
    ],
    "necrophage": [
        "necrophage"
    ],
    "necrophagie": [
        "necrophagie"
    ],
    "necrophile": [
        "necrophile"
    ],
    "necrophiles": [
        "necrophile"
    ],
    "necrophilie": [
        "necrophilie"
    ],
    "necropole": [
        "necropole"
    ],
    "necropoles": [
        "necropole"
    ],
    "necropsie": [
        "necropsie"
    ],
    "necros": [
        "necro"
    ],
    "necrosant": [
        "necroser"
    ],
    "necrose": [
        "necrose",
        "necroser"
    ],
    "necroser": [
        "necroser"
    ],
    "necroses": [
        "necrose",
        "necrosis"
    ],
    "necrosee": [
        "necroser"
    ],
    "necrotique": [
        "necrotique"
    ],
    "nee": [
        "naitre",
        "ne"
    ],
    "neerlandais": [
        "neerlandais"
    ],
    "neerlandaise": [
        "neerlandais"
    ],
    "neerlandaises": [
        "neerlandais"
    ],
    "nees": [
        "naitre",
        "ne"
    ],
    "nefaste": [
        "nefaste"
    ],
    "nefastes": [
        "nefaste"
    ],
    "neflier": [
        "neflier"
    ],
    "nefliers": [
        "neflier"
    ],
    "negateur": [
        "negateur"
    ],
    "negatif": [
        "negatif"
    ],
    "negatifs": [
        "negatif"
    ],
    "negation": [
        "negation"
    ],
    "negationnisme": [
        "negationnisme"
    ],
    "negations": [
        "negation"
    ],
    "negative": [
        "negatif",
        "negative"
    ],
    "negativement": [
        "negativement"
    ],
    "negatives": [
        "negatif",
        "negative"
    ],
    "negativisme": [
        "negativisme"
    ],
    "negativiste": [
        "negativiste"
    ],
    "negativite": [
        "negativite"
    ],
    "neglige": [
        "negliger",
        "neglige"
    ],
    "negligea": [
        "negliger"
    ],
    "negligeable": [
        "negligeable"
    ],
    "negligeables": [
        "negligeable"
    ],
    "negligeai": [
        "negliger"
    ],
    "negligeaient": [
        "negliger"
    ],
    "negligeais": [
        "negliger"
    ],
    "negligeait": [
        "negliger"
    ],
    "negligeant": [
        "negliger"
    ],
    "negligemment": [
        "negligemment"
    ],
    "negligence": [
        "negligence"
    ],
    "negligences": [
        "negligence"
    ],
    "negligent": [
        "negliger",
        "negligent"
    ],
    "negligente": [
        "negligent"
    ],
    "negligents": [
        "negligent"
    ],
    "negligeons": [
        "negliger"
    ],
    "negliger": [
        "negliger"
    ],
    "negligera": [
        "negliger"
    ],
    "negligerai": [
        "negliger"
    ],
    "negligerait": [
        "negliger"
    ],
    "negligeriez": [
        "negliger"
    ],
    "negliges": [
        "negliger",
        "neglige"
    ],
    "negligez": [
        "negliger"
    ],
    "negligeat": [
        "negliger"
    ],
    "negligiez": [
        "negliger"
    ],
    "negligions": [
        "negliger"
    ],
    "negligerent": [
        "negliger"
    ],
    "negligee": [
        "negliger",
        "neglige"
    ],
    "negligees": [
        "negliger",
        "neglige"
    ],
    "negoce": [
        "negoce"
    ],
    "negoces": [
        "negoce"
    ],
    "negocia": [
        "negocier"
    ],
    "negociable": [
        "negociable"
    ],
    "negociables": [
        "negociable"
    ],
    "negociaient": [
        "negocier"
    ],
    "negociais": [
        "negocier"
    ],
    "negociait": [
        "negocier"
    ],
    "negociant": [
        "negociant",
        "negocier"
    ],
    "negociante": [
        "negociant"
    ],
    "negociants": [
        "negociant"
    ],
    "negociateur": [
        "negociateur"
    ],
    "negociateurs": [
        "negociateur"
    ],
    "negociation": [
        "negociation"
    ],
    "negociations": [
        "negociation"
    ],
    "negociatrice": [
        "negociateur"
    ],
    "negociatrices": [
        "negociateur"
    ],
    "negocie": [
        "negocier"
    ],
    "negocient": [
        "negocier"
    ],
    "negocier": [
        "negocier"
    ],
    "negociera": [
        "negocier"
    ],
    "negocierai": [
        "negocier"
    ],
    "negocieraient": [
        "negocier"
    ],
    "negocierions": [
        "negocier"
    ],
    "negocierons": [
        "negocier"
    ],
    "negocieront": [
        "negocier"
    ],
    "negociez": [
        "negocier"
    ],
    "negocions": [
        "negocier"
    ],
    "negociee": [
        "negocier"
    ],
    "negociees": [
        "negocier"
    ],
    "negocies": [
        "negocier"
    ],
    "negresse": [
        "negre"
    ],
    "negresses": [
        "negre"
    ],
    "negrier": [
        "negrier"
    ],
    "negriers": [
        "negrier"
    ],
    "negril": [
        "negril"
    ],
    "negrillon": [
        "negrillon"
    ],
    "negrillons": [
        "negrillon"
    ],
    "negritude": [
        "negritude"
    ],
    "negriere": [
        "negrier"
    ],
    "negrophile": [
        "negrophile"
    ],
    "negrophiles": [
        "negrophile"
    ],
    "negros": [
        "negro"
    ],
    "negroide": [
        "negroide"
    ],
    "negroides": [
        "negroide"
    ],
    "negus": [
        "negus"
    ],
    "nematodes": [
        "nematode"
    ],
    "nenesse": [
        "nenesse"
    ],
    "nenesses": [
        "nenesse"
    ],
    "nenette": [
        "nenette"
    ],
    "nenettes": [
        "nenette"
    ],
    "nenuphar": [
        "nenuphar"
    ],
    "nenuphars": [
        "nenuphar"
    ],
    "nene": [
        "nene"
    ],
    "nenes": [
        "nene"
    ],
    "neo": [
        "neo"
    ],
    "neoclassique": [
        "neoclassique"
    ],
    "neocolonial": [
        "neocolonial"
    ],
    "neocolonialisme": [
        "neocolonialisme"
    ],
    "neocortex": [
        "neocortex"
    ],
    "neofascisme": [
        "neofascisme"
    ],
    "neogothique": [
        "neogothique"
    ],
    "neoliberalisme": [
        "neoliberalisme"
    ],
    "neolithique": [
        "neolithique"
    ],
    "neolithiques": [
        "neolithique"
    ],
    "neologisme": [
        "neologisme"
    ],
    "neologismes": [
        "neologisme"
    ],
    "neon": [
        "neon"
    ],
    "neonatal": [
        "neonatal"
    ],
    "neonatale": [
        "neonatal"
    ],
    "neonazie": [
        "neonazi"
    ],
    "neonazis": [
        "neonazi"
    ],
    "neons": [
        "neon"
    ],
    "neophyte": [
        "neophyte"
    ],
    "neophytes": [
        "neophyte"
    ],
    "neoplasie": [
        "neoplasie"
    ],
    "neoplasique": [
        "neoplasique"
    ],
    "neoplasme": [
        "neoplasme"
    ],
    "neoplatonisme": [
        "neoplatonisme"
    ],
    "neoprene": [
        "neoprene"
    ],
    "neorealisme": [
        "neorealisme"
    ],
    "nepalais": [
        "nepalais"
    ],
    "nepalaise": [
        "nepalais"
    ],
    "nepalaises": [
        "nepalais"
    ],
    "nepenthes": [
        "nepenthes"
    ],
    "nephrectomie": [
        "nephrectomie"
    ],
    "nephrite": [
        "nephrite"
    ],
    "nephrologie": [
        "nephrologie"
    ],
    "nephrologue": [
        "nephrologue"
    ],
    "nephretique": [
        "nephretique"
    ],
    "nephretiques": [
        "nephretique"
    ],
    "nepotisme": [
        "nepotisme"
    ],
    "neroli": [
        "neroli"
    ],
    "nereide": [
        "nereide"
    ],
    "nereides": [
        "nereide"
    ],
    "nes": [
        "naitre",
        "ne"
    ],
    "nevralgie": [
        "nevralgie"
    ],
    "nevralgies": [
        "nevralgie"
    ],
    "nevralgique": [
        "nevralgique"
    ],
    "nevralgiques": [
        "nevralgique"
    ],
    "nevrite": [
        "nevrite"
    ],
    "nevropathe": [
        "nevropathe"
    ],
    "nevropteres": [
        "nevroptere"
    ],
    "nevrose": [
        "nevrose"
    ],
    "nevroses": [
        "nevrose"
    ],
    "nevrosee": [
        "nevrose"
    ],
    "nevrosees": [
        "nevrose"
    ],
    "nevrotique": [
        "nevrotique"
    ],
    "nevrotiques": [
        "nevrotique"
    ],
    "neve": [
        "neve"
    ],
    "neves": [
        "neve"
    ],
    "notres": [
        "notres"
    ],
    "o": [
        "o"
    ],
    "oaristys": [
        "oaristys"
    ],
    "oasis": [
        "oasis"
    ],
    "ob": [
        "ob"
    ],
    "obi": [
        "obi"
    ],
    "obituaire": [
        "obituaire"
    ],
    "objecta": [
        "objecter"
    ],
    "objectai": [
        "objecter"
    ],
    "objectais": [
        "objecter"
    ],
    "objectait": [
        "objecter"
    ],
    "objectal": [
        "objectal"
    ],
    "objectale": [
        "objectal"
    ],
    "objectant": [
        "objecter"
    ],
    "objecte": [
        "objecter"
    ],
    "objectent": [
        "objecter"
    ],
    "objecter": [
        "objecter"
    ],
    "objectera": [
        "objecter"
    ],
    "objecterez": [
        "objecter"
    ],
    "objecteront": [
        "objecter"
    ],
    "objecteur": [
        "objecteur"
    ],
    "objecteurs": [
        "objecteur"
    ],
    "objectez": [
        "objecter"
    ],
    "objectif": [
        "objectif"
    ],
    "objectifs": [
        "objectif"
    ],
    "objection": [
        "objection"
    ],
    "objections": [
        "objection",
        "objecter"
    ],
    "objectivation": [
        "objectivation"
    ],
    "objective": [
        "objectif",
        "objectiver"
    ],
    "objectivement": [
        "objectivement"
    ],
    "objectivent": [
        "objectiver"
    ],
    "objectives": [
        "objectif",
        "objective"
    ],
    "objectivite": [
        "objectivite"
    ],
    "objecterent": [
        "objecter"
    ],
    "objet": [
        "objet"
    ],
    "objets": [
        "objet"
    ],
    "objurgation": [
        "objurgation"
    ],
    "objurgations": [
        "objurgation"
    ],
    "objurgua": [
        "objurguer"
    ],
    "objurguant": [
        "objurguer"
    ],
    "oblatif": [
        "oblatif"
    ],
    "oblation": [
        "oblation"
    ],
    "oblative": [
        "oblatif"
    ],
    "oblats": [
        "oblat"
    ],
    "obligado": [
        "obligado"
    ],
    "obligataire": [
        "obligataire"
    ],
    "obligataires": [
        "obligataire"
    ],
    "obligation": [
        "obligation"
    ],
    "obligations": [
        "obligation"
    ],
    "obligatoire": [
        "obligatoire"
    ],
    "obligatoirement": [
        "obligatoirement"
    ],
    "obligatoires": [
        "obligatoire"
    ],
    "oblige": [
        "oblige",
        "obliger"
    ],
    "obligea": [
        "obliger"
    ],
    "obligeai": [
        "obliger"
    ],
    "obligeaient": [
        "obliger"
    ],
    "obligeais": [
        "obliger"
    ],
    "obligeait": [
        "obliger"
    ],
    "obligeamment": [
        "obligeamment"
    ],
    "obligeance": [
        "obligeance"
    ],
    "obligeances": [
        "obligeance"
    ],
    "obligeant": [
        "obliger",
        "obligeant"
    ],
    "obligeante": [
        "obligeant"
    ],
    "obligeantes": [
        "obligeant"
    ],
    "obligeants": [
        "obligeant"
    ],
    "obligent": [
        "obliger"
    ],
    "obligeons": [
        "obliger"
    ],
    "obliger": [
        "obliger"
    ],
    "obligera": [
        "obliger"
    ],
    "obligerai": [
        "obliger"
    ],
    "obligerais": [
        "obliger"
    ],
    "obligerait": [
        "obliger"
    ],
    "obligeras": [
        "obliger"
    ],
    "obligerez": [
        "obliger"
    ],
    "obligeriez": [
        "obliger"
    ],
    "obligeront": [
        "obliger"
    ],
    "obliges": [
        "oblige",
        "obliger"
    ],
    "obligez": [
        "obliger"
    ],
    "obligeat": [
        "obliger"
    ],
    "obligiez": [
        "obliger"
    ],
    "obligerent": [
        "obliger"
    ],
    "obligee": [
        "oblige",
        "obliger"
    ],
    "obligees": [
        "oblige",
        "obliger"
    ],
    "obliqua": [
        "obliquer"
    ],
    "obliquaient": [
        "obliquer"
    ],
    "obliquait": [
        "obliquer"
    ],
    "obliquant": [
        "obliquer"
    ],
    "oblique": [
        "oblique",
        "obliquer"
    ],
    "obliquement": [
        "obliquement"
    ],
    "obliquent": [
        "obliquer"
    ],
    "obliquer": [
        "obliquer"
    ],
    "obliques": [
        "oblique"
    ],
    "obliquez": [
        "obliquer"
    ],
    "obliquite": [
        "obliquite"
    ],
    "obliquames": [
        "obliquer"
    ],
    "obliquerent": [
        "obliquer"
    ],
    "oblitere": [
        "obliterer",
        "oblitere"
    ],
    "obliterent": [
        "obliterer"
    ],
    "obliteraient": [
        "obliterer"
    ],
    "obliterait": [
        "obliterer"
    ],
    "obliteration": [
        "obliteration"
    ],
    "obliterer": [
        "obliterer"
    ],
    "obliterons": [
        "obliterer"
    ],
    "oblitererent": [
        "obliterer"
    ],
    "obliteree": [
        "obliterer"
    ],
    "obliterees": [
        "obliterer"
    ],
    "obliteres": [
        "obliterer",
        "oblitere"
    ],
    "oblong": [
        "oblong"
    ],
    "oblongs": [
        "oblong"
    ],
    "oblongue": [
        "oblong"
    ],
    "oblongues": [
        "oblong"
    ],
    "obnubila": [
        "obnubiler"
    ],
    "obnubilait": [
        "obnubiler"
    ],
    "obnubilant": [
        "obnubiler"
    ],
    "obnubilation": [
        "obnubilation"
    ],
    "obnubile": [
        "obnubile",
        "obnubiler"
    ],
    "obnubiler": [
        "obnubiler"
    ],
    "obnubilee": [
        "obnubile",
        "obnubiler"
    ],
    "obnubilees": [
        "obnubiler"
    ],
    "obnubiles": [
        "obnubiler"
    ],
    "obole": [
        "obole"
    ],
    "oboles": [
        "obole"
    ],
    "obscur": [
        "obscur"
    ],
    "obscurantisme": [
        "obscurantisme"
    ],
    "obscurantismes": [
        "obscurantisme"
    ],
    "obscurantiste": [
        "obscurantiste"
    ],
    "obscurci": [
        "obscurcir"
    ],
    "obscurcie": [
        "obscurcir"
    ],
    "obscurcies": [
        "obscurcir"
    ],
    "obscurcir": [
        "obscurcir"
    ],
    "obscurcira": [
        "obscurcir"
    ],
    "obscurcirait": [
        "obscurcir"
    ],
    "obscurcis": [
        "obscurcir"
    ],
    "obscurcissaient": [
        "obscurcir"
    ],
    "obscurcissait": [
        "obscurcir"
    ],
    "obscurcissant": [
        "obscurcir"
    ],
    "obscurcissement": [
        "obscurcissement"
    ],
    "obscurcissements": [
        "obscurcissement"
    ],
    "obscurcissent": [
        "obscurcir"
    ],
    "obscurcit": [
        "obscurcir"
    ],
    "obscure": [
        "obscur"
    ],
    "obscures": [
        "obscure",
        "obscur"
    ],
    "obscurite": [
        "obscurite"
    ],
    "obscurites": [
        "obscurite"
    ],
    "obscurs": [
        "obscur"
    ],
    "obscurement": [
        "obscurement"
    ],
    "obscene": [
        "obscene"
    ],
    "obscenement": [
        "obscenement"
    ],
    "obscenes": [
        "obscene"
    ],
    "obscenite": [
        "obscenite"
    ],
    "obscenites": [
        "obscenite"
    ],
    "observa": [
        "observer"
    ],
    "observable": [
        "observable"
    ],
    "observai": [
        "observer"
    ],
    "observaient": [
        "observer"
    ],
    "observais": [
        "observer"
    ],
    "observait": [
        "observer"
    ],
    "observance": [
        "observance"
    ],
    "observances": [
        "observance"
    ],
    "observant": [
        "observer",
        "observant"
    ],
    "observateur": [
        "observateur"
    ],
    "observateurs": [
        "observateur"
    ],
    "observation": [
        "observation"
    ],
    "observations": [
        "observation"
    ],
    "observatoire": [
        "observatoire"
    ],
    "observatoires": [
        "observatoire"
    ],
    "observatrice": [
        "observateur"
    ],
    "observatrices": [
        "observateur"
    ],
    "observe": [
        "observer",
        "observe"
    ],
    "observent": [
        "observer"
    ],
    "observer": [
        "observer"
    ],
    "observera": [
        "observer"
    ],
    "observerai": [
        "observer"
    ],
    "observeraient": [
        "observer"
    ],
    "observerais": [
        "observer"
    ],
    "observerait": [
        "observer"
    ],
    "observerez": [
        "observer"
    ],
    "observerons": [
        "observer"
    ],
    "observeront": [
        "observer"
    ],
    "observes": [
        "observer",
        "observe"
    ],
    "observez": [
        "observer"
    ],
    "observiez": [
        "observer"
    ],
    "observions": [
        "observer"
    ],
    "observons": [
        "observer"
    ],
    "observames": [
        "observer"
    ],
    "observerent": [
        "observer"
    ],
    "observee": [
        "observer",
        "observe"
    ],
    "observees": [
        "observer",
        "observe"
    ],
    "obsessif": [
        "obsessif"
    ],
    "obsession": [
        "obsession"
    ],
    "obsessionnel": [
        "obsessionnel"
    ],
    "obsessionnelle": [
        "obsessionnel"
    ],
    "obsessionnellement": [
        "obsessionnellement"
    ],
    "obsessionnelles": [
        "obsessionnel"
    ],
    "obsessionnels": [
        "obsessionnel"
    ],
    "obsessions": [
        "obsession"
    ],
    "obsessive": [
        "obsessif"
    ],
    "obsidienne": [
        "obsidienne"
    ],
    "obsidional": [
        "obsidional"
    ],
    "obsidionale": [
        "obsidional"
    ],
    "obsolescence": [
        "obsolescence"
    ],
    "obsolete": [
        "obsolete"
    ],
    "obsoletes": [
        "obsolete"
    ],
    "obstacle": [
        "obstacle"
    ],
    "obstacles": [
        "obstacle"
    ],
    "obstina": [
        "obstiner"
    ],
    "obstinai": [
        "obstiner"
    ],
    "obstinaient": [
        "obstiner"
    ],
    "obstinais": [
        "obstiner"
    ],
    "obstinait": [
        "obstiner"
    ],
    "obstinant": [
        "obstiner"
    ],
    "obstination": [
        "obstination"
    ],
    "obstinations": [
        "obstination"
    ],
    "obstine": [
        "obstine",
        "obstiner"
    ],
    "obstinent": [
        "obstiner"
    ],
    "obstiner": [
        "obstiner"
    ],
    "obstinera": [
        "obstiner"
    ],
    "obstineraient": [
        "obstiner"
    ],
    "obstinerait": [
        "obstiner"
    ],
    "obstineras": [
        "obstiner"
    ],
    "obstinerez": [
        "obstiner"
    ],
    "obstineriez": [
        "obstiner"
    ],
    "obstineront": [
        "obstiner"
    ],
    "obstines": [
        "obstine",
        "obstiner"
    ],
    "obstinez": [
        "obstiner"
    ],
    "obstinions": [
        "obstiner"
    ],
    "obstinons": [
        "obstiner"
    ],
    "obstinerent": [
        "obstiner"
    ],
    "obstinee": [
        "obstine",
        "obstiner"
    ],
    "obstinees": [
        "obstine"
    ],
    "obstinement": [
        "obstinement"
    ],
    "obstrua": [
        "obstruer"
    ],
    "obstruaient": [
        "obstruer"
    ],
    "obstruait": [
        "obstruer"
    ],
    "obstruant": [
        "obstruer"
    ],
    "obstructif": [
        "obstructif"
    ],
    "obstruction": [
        "obstruction"
    ],
    "obstructionnisme": [
        "obstructionnisme"
    ],
    "obstructions": [
        "obstruction"
    ],
    "obstructive": [
        "obstructif"
    ],
    "obstrue": [
        "obstrue",
        "obstruer"
    ],
    "obstruent": [
        "obstruer"
    ],
    "obstruer": [
        "obstruer"
    ],
    "obstrueraient": [
        "obstruer"
    ],
    "obstrueront": [
        "obstruer"
    ],
    "obstruez": [
        "obstruer"
    ],
    "obstruee": [
        "obstrue",
        "obstruer"
    ],
    "obstruees": [
        "obstruer"
    ],
    "obstrues": [
        "obstrue",
        "obstruer"
    ],
    "obstetrical": [
        "obstetrical"
    ],
    "obstetricien": [
        "obstetricien"
    ],
    "obstetricienne": [
        "obstetricien"
    ],
    "obstetriciens": [
        "obstetricien"
    ],
    "obstetrique": [
        "obstetrique"
    ],
    "obsede": [
        "obseder",
        "obsede"
    ],
    "obsedent": [
        "obseder"
    ],
    "obsedes": [
        "obseder",
        "obsede"
    ],
    "obseques": [
        "obseques"
    ],
    "obseda": [
        "obseder"
    ],
    "obsedaient": [
        "obseder"
    ],
    "obsedais": [
        "obseder"
    ],
    "obsedait": [
        "obseder"
    ],
    "obsedant": [
        "obsedant",
        "obseder"
    ],
    "obsedante": [
        "obsedant"
    ],
    "obsedantes": [
        "obsedant"
    ],
    "obsedants": [
        "obsedant"
    ],
    "obseder": [
        "obseder"
    ],
    "obsederent": [
        "obseder"
    ],
    "obsedee": [
        "obseder",
        "obsede"
    ],
    "obsedees": [
        "obseder",
        "obsede"
    ],
    "obsequieuse": [
        "obsequieux"
    ],
    "obsequieusement": [
        "obsequieusement"
    ],
    "obsequieuses": [
        "obsequieux"
    ],
    "obsequieux": [
        "obsequieux"
    ],
    "obsequiosite": [
        "obsequiosite"
    ],
    "obtempere": [
        "obtemperer"
    ],
    "obtempera": [
        "obtemperer"
    ],
    "obtemperai": [
        "obtemperer"
    ],
    "obtemperaient": [
        "obtemperer"
    ],
    "obtemperait": [
        "obtemperer"
    ],
    "obtemperer": [
        "obtemperer"
    ],
    "obtemperez": [
        "obtemperer"
    ],
    "obtemperions": [
        "obtemperer"
    ],
    "obtempererent": [
        "obtemperer"
    ],
    "obtenaient": [
        "obtenir"
    ],
    "obtenais": [
        "obtenir"
    ],
    "obtenait": [
        "obtenir"
    ],
    "obtenant": [
        "obtenir"
    ],
    "obtenez": [
        "obtenir"
    ],
    "obteniez": [
        "obtenir"
    ],
    "obtenions": [
        "obtenir"
    ],
    "obtenir": [
        "obtenir"
    ],
    "obtenons": [
        "obtenir"
    ],
    "obtention": [
        "obtention"
    ],
    "obtenu": [
        "obtenir"
    ],
    "obtenue": [
        "obtenir"
    ],
    "obtenues": [
        "obtenir"
    ],
    "obtenus": [
        "obtenir"
    ],
    "obtiendra": [
        "obtenir"
    ],
    "obtiendrai": [
        "obtenir"
    ],
    "obtiendraient": [
        "obtenir"
    ],
    "obtiendrais": [
        "obtenir"
    ],
    "obtiendrait": [
        "obtenir"
    ],
    "obtiendras": [
        "obtenir"
    ],
    "obtiendrez": [
        "obtenir"
    ],
    "obtiendriez": [
        "obtenir"
    ],
    "obtiendrions": [
        "obtenir"
    ],
    "obtiendrons": [
        "obtenir"
    ],
    "obtiendront": [
        "obtenir"
    ],
    "obtienne": [
        "obtenir"
    ],
    "obtiennent": [
        "obtenir"
    ],
    "obtiennes": [
        "obtenir"
    ],
    "obtiens": [
        "obtenir"
    ],
    "obtient": [
        "obtenir"
    ],
    "obtinrent": [
        "obtenir"
    ],
    "obtins": [
        "obtenir"
    ],
    "obtinsse": [
        "obtenir"
    ],
    "obtint": [
        "obtenir"
    ],
    "obtura": [
        "obturer"
    ],
    "obturait": [
        "obturer"
    ],
    "obturateur": [
        "obturateur"
    ],
    "obturateurs": [
        "obturateur"
    ],
    "obturation": [
        "obturation"
    ],
    "obture": [
        "obturer"
    ],
    "obturer": [
        "obturer"
    ],
    "obturez": [
        "obturer"
    ],
    "obturee": [
        "obturer"
    ],
    "obtus": [
        "obtus"
    ],
    "obtuse": [
        "obtus"
    ],
    "obtuses": [
        "obtus"
    ],
    "obtinmes": [
        "obtenir"
    ],
    "obus": [
        "obus"
    ],
    "obusier": [
        "obusier"
    ],
    "obusiers": [
        "obusier"
    ],
    "obverse": [
        "obvers"
    ],
    "obvie": [
        "obvie"
    ],
    "obvier": [
        "obvier"
    ],
    "obere": [
        "oberer"
    ],
    "obese": [
        "obese"
    ],
    "obeses": [
        "obese"
    ],
    "obedience": [
        "obedience"
    ],
    "obediences": [
        "obedience"
    ],
    "obei": [
        "obeir"
    ],
    "obeie": [
        "obeir"
    ],
    "obeir": [
        "obeir"
    ],
    "obeira": [
        "obeir"
    ],
    "obeirai": [
        "obeir"
    ],
    "obeiraient": [
        "obeir"
    ],
    "obeirais": [
        "obeir"
    ],
    "obeirait": [
        "obeir"
    ],
    "obeiras": [
        "obeir"
    ],
    "obeirent": [
        "obeir"
    ],
    "obeirez": [
        "obeir"
    ],
    "obeiriez": [
        "obeir"
    ],
    "obeirons": [
        "obeir"
    ],
    "obeiront": [
        "obeir"
    ],
    "obeis": [
        "obeir"
    ],
    "obeissaient": [
        "obeir"
    ],
    "obeissais": [
        "obeir"
    ],
    "obeissait": [
        "obeir"
    ],
    "obeissance": [
        "obeissance"
    ],
    "obeissant": [
        "obeissant",
        "obeir"
    ],
    "obeissante": [
        "obeissant"
    ],
    "obeissantes": [
        "obeissant"
    ],
    "obeissants": [
        "obeissant"
    ],
    "obeisse": [
        "obeir"
    ],
    "obeissent": [
        "obeir"
    ],
    "obeisses": [
        "obeir"
    ],
    "obeissez": [
        "obeir"
    ],
    "obeissiez": [
        "obeir"
    ],
    "obeissions": [
        "obeir"
    ],
    "obeissons": [
        "obeir"
    ],
    "obeit": [
        "obeir"
    ],
    "obelisque": [
        "obelisque"
    ],
    "obelisques": [
        "obelisque"
    ],
    "oberant": [
        "oberer"
    ],
    "oberer": [
        "oberer"
    ],
    "obesite": [
        "obesite"
    ],
    "obesites": [
        "obesite"
    ],
    "obeimes": [
        "obeir"
    ],
    "ocarina": [
        "ocarina"
    ],
    "ocarinas": [
        "ocarina"
    ],
    "occase": [
        "occase"
    ],
    "occases": [
        "occase"
    ],
    "occasion": [
        "occasion"
    ],
    "occasionna": [
        "occasionner"
    ],
    "occasionnait": [
        "occasionner"
    ],
    "occasionnant": [
        "occasionner"
    ],
    "occasionne": [
        "occasionner"
    ],
    "occasionnel": [
        "occasionnel"
    ],
    "occasionnelle": [
        "occasionnel"
    ],
    "occasionnellement": [
        "occasionnellement"
    ],
    "occasionnelles": [
        "occasionnel"
    ],
    "occasionnels": [
        "occasionnel"
    ],
    "occasionnent": [
        "occasionner"
    ],
    "occasionner": [
        "occasionner"
    ],
    "occasionnerent": [
        "occasionner"
    ],
    "occasionnee": [
        "occasionner"
    ],
    "occasionnees": [
        "occasionner"
    ],
    "occasionnes": [
        "occasionner"
    ],
    "occasions": [
        "occasion"
    ],
    "occident": [
        "occident"
    ],
    "occidental": [
        "occidental"
    ],
    "occidentale": [
        "occidental"
    ],
    "occidentales": [
        "occidental"
    ],
    "occidentalisation": [
        "occidentalisation"
    ],
    "occidentalise": [
        "occidentaliser"
    ],
    "occidentalisme": [
        "occidentalisme"
    ],
    "occidentaux": [
        "occidental"
    ],
    "occipital": [
        "occipital"
    ],
    "occipitale": [
        "occipital"
    ],
    "occipitales": [
        "occipital"
    ],
    "occipitaux": [
        "occipital"
    ],
    "occiput": [
        "occiput"
    ],
    "occire": [
        "occire"
    ],
    "occis": [
        "occis"
    ],
    "occitan": [
        "occitan"
    ],
    "occitane": [
        "occitan"
    ],
    "occitans": [
        "occitan"
    ],
    "occlusion": [
        "occlusion"
    ],
    "occlut": [
        "occlure"
    ],
    "occulta": [
        "occulter"
    ],
    "occultaient": [
        "occulter"
    ],
    "occultait": [
        "occulter"
    ],
    "occultant": [
        "occulter"
    ],
    "occultation": [
        "occultation"
    ],
    "occultations": [
        "occultation"
    ],
    "occulte": [
        "occulter",
        "occulte"
    ],
    "occultement": [
        "occultement"
    ],
    "occultent": [
        "occulter"
    ],
    "occulter": [
        "occulter"
    ],
    "occultera": [
        "occulter"
    ],
    "occultes": [
        "occulte"
    ],
    "occultez": [
        "occulter"
    ],
    "occultisme": [
        "occultisme"
    ],
    "occultismes": [
        "occultisme"
    ],
    "occultiste": [
        "occultiste"
    ],
    "occultistes": [
        "occultiste"
    ],
    "occultee": [
        "occulter"
    ],
    "occupa": [
        "occuper"
    ],
    "occupai": [
        "occuper"
    ],
    "occupaient": [
        "occuper"
    ],
    "occupais": [
        "occuper"
    ],
    "occupait": [
        "occuper"
    ],
    "occupant": [
        "occuper",
        "occupant"
    ],
    "occupante": [
        "occupant"
    ],
    "occupantes": [
        "occupant"
    ],
    "occupants": [
        "occupant"
    ],
    "occupas": [
        "occuper"
    ],
    "occupation": [
        "occupation"
    ],
    "occupations": [
        "occupation"
    ],
    "occupe": [
        "occuper",
        "occupe"
    ],
    "occupent": [
        "occuper"
    ],
    "occuper": [
        "occuper"
    ],
    "occupera": [
        "occuper"
    ],
    "occuperai": [
        "occuper"
    ],
    "occuperaient": [
        "occuper"
    ],
    "occuperais": [
        "occuper"
    ],
    "occuperait": [
        "occuper"
    ],
    "occuperas": [
        "occuper"
    ],
    "occuperez": [
        "occuper"
    ],
    "occuperions": [
        "occuper"
    ],
    "occuperons": [
        "occuper"
    ],
    "occuperont": [
        "occuper"
    ],
    "occupes": [
        "occuper",
        "occupe"
    ],
    "occupez": [
        "occuper"
    ],
    "occupiez": [
        "occuper"
    ],
    "occupions": [
        "occuper"
    ],
    "occupons": [
        "occuper"
    ],
    "occupat": [
        "occuper"
    ],
    "occuperent": [
        "occuper"
    ],
    "occupee": [
        "occuper",
        "occupe"
    ],
    "occupees": [
        "occuper",
        "occupe"
    ],
    "occurrence": [
        "occurrence"
    ],
    "occurrences": [
        "occurrence"
    ],
    "occurrentes": [
        "occurrent"
    ],
    "ocelles": [
        "ocelle"
    ],
    "ocellee": [
        "ocelle"
    ],
    "ocelot": [
        "ocelot"
    ],
    "ocelots": [
        "ocelot"
    ],
    "ocre": [
        "ocre",
        "ocrer"
    ],
    "ocres": [
        "ocre",
        "ocrer"
    ],
    "ocreux": [
        "ocreux"
    ],
    "ocree": [
        "ocre",
        "ocrer"
    ],
    "ocrees": [
        "ocrer"
    ],
    "octane": [
        "octane"
    ],
    "octant": [
        "octant"
    ],
    "octante": [
        "octante"
    ],
    "octave": [
        "octave"
    ],
    "octaves": [
        "octave"
    ],
    "octavia": [
        "octavier"
    ],
    "octavie": [
        "octavier"
    ],
    "octavo": [
        "octavo"
    ],
    "octet": [
        "octet"
    ],
    "octets": [
        "octet"
    ],
    "octidi": [
        "octidi"
    ],
    "octobre": [
        "octobre"
    ],
    "octogonal": [
        "octogonal"
    ],
    "octogonale": [
        "octogonal"
    ],
    "octogonales": [
        "octogonal"
    ],
    "octogonaux": [
        "octogonal"
    ],
    "octogone": [
        "octogone"
    ],
    "octogones": [
        "octogone"
    ],
    "octogenaire": [
        "octogenaire"
    ],
    "octogenaires": [
        "octogenaire"
    ],
    "octosyllabe": [
        "octosyllabe"
    ],
    "octosyllabes": [
        "octosyllabe"
    ],
    "octroi": [
        "octroi"
    ],
    "octroie": [
        "octroyer"
    ],
    "octroient": [
        "octroyer"
    ],
    "octroiera": [
        "octroyer"
    ],
    "octrois": [
        "octroi"
    ],
    "octroya": [
        "octroyer"
    ],
    "octroyaient": [
        "octroyer"
    ],
    "octroyait": [
        "octroyer"
    ],
    "octroyant": [
        "octroyer"
    ],
    "octroyer": [
        "octroyer"
    ],
    "octroyons": [
        "octroyer"
    ],
    "octroyat": [
        "octroyer"
    ],
    "octroye": [
        "octroyer"
    ],
    "octroyee": [
        "octroyer"
    ],
    "octroyees": [
        "octroyer"
    ],
    "octroyes": [
        "octroyer"
    ],
    "octuor": [
        "octuor"
    ],
    "octuple": [
        "octuple"
    ],
    "oculaire": [
        "oculaire"
    ],
    "oculaires": [
        "oculaire"
    ],
    "oculi": [
        "oculus"
    ],
    "oculiste": [
        "oculiste"
    ],
    "oculistes": [
        "oculiste"
    ],
    "oculomoteur": [
        "oculomoteur"
    ],
    "oculus": [
        "oculus"
    ],
    "ocytocine": [
        "ocytocine"
    ],
    "ocean": [
        "ocean"
    ],
    "oceane": [
        "ocean"
    ],
    "oceanienne": [
        "oceanien"
    ],
    "oceanique": [
        "oceanique"
    ],
    "oceaniques": [
        "oceanique"
    ],
    "oceanographe": [
        "oceanographe"
    ],
    "oceanographie": [
        "oceanographie"
    ],
    "oceanographique": [
        "oceanographique"
    ],
    "oceanographiques": [
        "oceanographique"
    ],
    "oceanologie": [
        "oceanologie"
    ],
    "oceanologue": [
        "oceanologue"
    ],
    "oceans": [
        "ocean"
    ],
    "odalisque": [
        "odalisque"
    ],
    "odalisques": [
        "odalisque"
    ],
    "ode": [
        "ode"
    ],
    "odelette": [
        "odelette"
    ],
    "odelettes": [
        "odelette"
    ],
    "odes": [
        "ode"
    ],
    "odeur": [
        "odeur"
    ],
    "odeurs": [
        "odeur"
    ],
    "odieuse": [
        "odieux"
    ],
    "odieusement": [
        "odieusement"
    ],
    "odieuses": [
        "odieux"
    ],
    "odieux": [
        "odieux"
    ],
    "odometre": [
        "odometre"
    ],
    "odontologie": [
        "odontologie"
    ],
    "odontologiste": [
        "odontologiste"
    ],
    "odontologues": [
        "odontologue"
    ],
    "odorant": [
        "odorant",
        "odorer"
    ],
    "odorante": [
        "odorant"
    ],
    "odorantes": [
        "odorant"
    ],
    "odorants": [
        "odorant"
    ],
    "odorat": [
        "odorat"
    ],
    "odoriferant": [
        "odoriferant"
    ],
    "odoriferante": [
        "odoriferant"
    ],
    "odoriferantes": [
        "odoriferant"
    ],
    "odoriferants": [
        "odoriferant"
    ],
    "odyssee": [
        "odyssee"
    ],
    "odyssees": [
        "odyssee"
    ],
    "odeon": [
        "odeon"
    ],
    "oecumenique": [
        "oecumenique"
    ],
    "oecumeniques": [
        "oecumenique"
    ],
    "oecumenisme": [
        "oecumenisme"
    ],
    "oedipe": [
        "oedipe"
    ],
    "oedipien": [
        "oedipien"
    ],
    "oedipienne": [
        "oedipien"
    ],
    "oedeme": [
        "oedeme"
    ],
    "oedemes": [
        "oedeme"
    ],
    "oedemateuse": [
        "oedemateux"
    ],
    "oeil": [
        "oeil"
    ],
    "oeillade": [
        "oeillade"
    ],
    "oeillades": [
        "oeillade"
    ],
    "oeillet": [
        "oeillet"
    ],
    "oeilleton": [
        "oeilleton"
    ],
    "oeilletons": [
        "oeilleton"
    ],
    "oeillets": [
        "oeillet"
    ],
    "oeillette": [
        "oeillette"
    ],
    "oeillere": [
        "oeillere"
    ],
    "oeilleres": [
        "oeillere"
    ],
    "oeils": [
        "oeil"
    ],
    "oenologie": [
        "oenologie"
    ],
    "oenologique": [
        "oenologique"
    ],
    "oenologues": [
        "oenologue"
    ],
    "oenophile": [
        "oenophile"
    ],
    "oenothera": [
        "oenothera"
    ],
    "oenothere": [
        "oenothere"
    ],
    "oesophage": [
        "oesophage"
    ],
    "oesophages": [
        "oesophage"
    ],
    "oesophagien": [
        "oesophagien"
    ],
    "oesophagienne": [
        "oesophagien"
    ],
    "oesophagiennes": [
        "oesophagien"
    ],
    "oestrogene": [
        "oestrogene"
    ],
    "oestrogenes": [
        "oestrogene"
    ],
    "oeuf": [
        "oeuf"
    ],
    "oeufs": [
        "oeuf"
    ],
    "oeuvraient": [
        "oeuvrer"
    ],
    "oeuvrait": [
        "oeuvrer"
    ],
    "oeuvrant": [
        "oeuvrer"
    ],
    "oeuvre": [
        "oeuvrer",
        "oeuvre"
    ],
    "oeuvrent": [
        "oeuvrer"
    ],
    "oeuvrer": [
        "oeuvrer"
    ],
    "oeuvrera": [
        "oeuvrer"
    ],
    "oeuvres": [
        "oeuvrer",
        "oeuvre"
    ],
    "oeuvrette": [
        "oeuvrette"
    ],
    "oeuvrettes": [
        "oeuvrette"
    ],
    "oeuvrez": [
        "oeuvrer"
    ],
    "oeuvrions": [
        "oeuvrer"
    ],
    "off": [
        "off"
    ],
    "offensa": [
        "offenser"
    ],
    "offensaient": [
        "offenser"
    ],
    "offensais": [
        "offenser"
    ],
    "offensait": [
        "offenser"
    ],
    "offensant": [
        "offensant",
        "offenser"
    ],
    "offensante": [
        "offensant"
    ],
    "offensantes": [
        "offensant"
    ],
    "offensants": [
        "offensant"
    ],
    "offense": [
        "offense",
        "offenser"
    ],
    "offensent": [
        "offenser"
    ],
    "offenser": [
        "offenser"
    ],
    "offensera": [
        "offenser"
    ],
    "offenserai": [
        "offenser"
    ],
    "offenseraient": [
        "offenser"
    ],
    "offenserais": [
        "offenser"
    ],
    "offenserez": [
        "offenser"
    ],
    "offenseront": [
        "offenser"
    ],
    "offenses": [
        "offense",
        "offenser"
    ],
    "offenseur": [
        "offenseur"
    ],
    "offenseurs": [
        "offenseur"
    ],
    "offensez": [
        "offenser"
    ],
    "offensif": [
        "offensif"
    ],
    "offensifs": [
        "offensif"
    ],
    "offensive": [
        "offensif",
        "offensive"
    ],
    "offensives": [
        "offensif",
        "offensive"
    ],
    "offensons": [
        "offenser"
    ],
    "offenserent": [
        "offenser"
    ],
    "offensee": [
        "offense",
        "offenser"
    ],
    "offensees": [
        "offense",
        "offenser"
    ],
    "offert": [
        "offrir"
    ],
    "offerte": [
        "offrir"
    ],
    "offertes": [
        "offrir"
    ],
    "offertoire": [
        "offertoire"
    ],
    "offerts": [
        "offrir"
    ],
    "office": [
        "office"
    ],
    "offices": [
        "office"
    ],
    "officiaient": [
        "officier"
    ],
    "officiais": [
        "officier"
    ],
    "officiait": [
        "officier"
    ],
    "official": [
        "official"
    ],
    "officialisait": [
        "officialiser"
    ],
    "officialise": [
        "officialiser"
    ],
    "officialiser": [
        "officialiser"
    ],
    "officialisez": [
        "officialiser"
    ],
    "officialite": [
        "officialite"
    ],
    "officiant": [
        "officiant",
        "officier"
    ],
    "officiants": [
        "officiant"
    ],
    "officie": [
        "officier"
    ],
    "officiel": [
        "officiel"
    ],
    "officielle": [
        "officiel"
    ],
    "officiellement": [
        "officiellement"
    ],
    "officielles": [
        "officiel"
    ],
    "officiels": [
        "officiel"
    ],
    "officient": [
        "officier"
    ],
    "officier": [
        "officier"
    ],
    "officiers": [
        "officier"
    ],
    "officieuse": [
        "officieux"
    ],
    "officieusement": [
        "officieusement"
    ],
    "officieuses": [
        "officieux"
    ],
    "officieux": [
        "officieux"
    ],
    "officiez": [
        "officier"
    ],
    "officine": [
        "officine"
    ],
    "officines": [
        "officine"
    ],
    "officions": [
        "officier"
    ],
    "officiere": [
        "officier"
    ],
    "offraient": [
        "offrir"
    ],
    "offrais": [
        "offrir"
    ],
    "offrait": [
        "offrir"
    ],
    "offrande": [
        "offrande"
    ],
    "offrandes": [
        "offrande"
    ],
    "offrant": [
        "offrant",
        "offrir"
    ],
    "offrante": [
        "offrant"
    ],
    "offrantes": [
        "offrant"
    ],
    "offrants": [
        "offrant"
    ],
    "offre": [
        "offre",
        "offrir"
    ],
    "offrent": [
        "offrir"
    ],
    "offres": [
        "offre",
        "offrir"
    ],
    "offrez": [
        "offrir"
    ],
    "offriez": [
        "offrir"
    ],
    "offrions": [
        "offrir"
    ],
    "offrir": [
        "offrir"
    ],
    "offrira": [
        "offrir"
    ],
    "offrirai": [
        "offrir"
    ],
    "offriraient": [
        "offrir"
    ],
    "offrirais": [
        "offrir"
    ],
    "offrirait": [
        "offrir"
    ],
    "offriras": [
        "offrir"
    ],
    "offrirent": [
        "offrir"
    ],
    "offrirez": [
        "offrir"
    ],
    "offririez": [
        "offrir"
    ],
    "offrirons": [
        "offrir"
    ],
    "offriront": [
        "offrir"
    ],
    "offris": [
        "offrir"
    ],
    "offrit": [
        "offrir"
    ],
    "offrons": [
        "offrir"
    ],
    "offset": [
        "offset"
    ],
    "offshore": [
        "offshore"
    ],
    "offuscation": [
        "offuscation"
    ],
    "offuscations": [
        "offuscation"
    ],
    "offusqua": [
        "offusquer"
    ],
    "offusquaient": [
        "offusquer"
    ],
    "offusquais": [
        "offusquer"
    ],
    "offusquait": [
        "offusquer"
    ],
    "offusquant": [
        "offusquer",
        "offusquant"
    ],
    "offusque": [
        "offusquer",
        "offusque"
    ],
    "offusquent": [
        "offusquer"
    ],
    "offusquer": [
        "offusquer"
    ],
    "offusquerai": [
        "offusquer"
    ],
    "offusquerait": [
        "offusquer"
    ],
    "offusquerez": [
        "offusquer"
    ],
    "offusques": [
        "offusquer",
        "offusque"
    ],
    "offusquat": [
        "offusquer"
    ],
    "offusquerent": [
        "offusquer"
    ],
    "offusquee": [
        "offusquer",
        "offusque"
    ],
    "offusquees": [
        "offusquer",
        "offusque"
    ],
    "oflag": [
        "oflag"
    ],
    "oflags": [
        "oflag"
    ],
    "ogival": [
        "ogival"
    ],
    "ogive": [
        "ogive"
    ],
    "ogives": [
        "ogive"
    ],
    "ognons": [
        "ognon"
    ],
    "ogre": [
        "ogre"
    ],
    "ogres": [
        "ogre"
    ],
    "ogresse": [
        "ogresse"
    ],
    "ogresses": [
        "ogresse"
    ],
    "oh": [
        "oh"
    ],
    "ohms": [
        "ohm"
    ],
    "ohe": [
        "ohe"
    ],
    "oie": [
        "oie",
        "ouir"
    ],
    "oies": [
        "oie",
        "ouir"
    ],
    "oignait": [
        "oindre"
    ],
    "oignant": [
        "oindre"
    ],
    "oigne": [
        "oindre"
    ],
    "oignes": [
        "oindre"
    ],
    "oignez": [
        "oindre"
    ],
    "oignit": [
        "oindre"
    ],
    "oignon": [
        "oignon"
    ],
    "oignons": [
        "oindre",
        "oignon"
    ],
    "oille": [
        "oille"
    ],
    "oindra": [
        "oindre"
    ],
    "oindre": [
        "oindre"
    ],
    "oing": [
        "oing"
    ],
    "oins": [
        "oindre"
    ],
    "oint": [
        "oindre",
        "oint"
    ],
    "ointe": [
        "oindre",
        "oint"
    ],
    "ointes": [
        "oindre",
        "oint"
    ],
    "oints": [
        "oindre",
        "oint"
    ],
    "ois": [
        "ouir"
    ],
    "oiseau": [
        "oiseau"
    ],
    "oiseaux": [
        "oiseau"
    ],
    "oiselet": [
        "oiselet"
    ],
    "oiselets": [
        "oiselet"
    ],
    "oiseleur": [
        "oiseleur"
    ],
    "oiseleurs": [
        "oiseleur"
    ],
    "oiselez": [
        "oiseler"
    ],
    "oiselier": [
        "oiselier"
    ],
    "oiseliers": [
        "oiselier"
    ],
    "oiseliere": [
        "oiselier"
    ],
    "oiselle": [
        "oiselle"
    ],
    "oisellerie": [
        "oisellerie"
    ],
    "oiselles": [
        "oiselle"
    ],
    "oiseuse": [
        "oiseux"
    ],
    "oiseuses": [
        "oiseux"
    ],
    "oiseux": [
        "oiseux"
    ],
    "oisif": [
        "oisif"
    ],
    "oisifs": [
        "oisif"
    ],
    "oisillon": [
        "oisillon"
    ],
    "oisillons": [
        "oisillon"
    ],
    "oisive": [
        "oisif"
    ],
    "oisivement": [
        "oisivement"
    ],
    "oisives": [
        "oisif"
    ],
    "oisivete": [
        "oisivete"
    ],
    "oison": [
        "oison"
    ],
    "oisons": [
        "oison"
    ],
    "oit": [
        "ouir"
    ],
    "ok": [
        "ok"
    ],
    "oka": [
        "oka"
    ],
    "okapi": [
        "okapi"
    ],
    "okoume": [
        "okoume"
    ],
    "ola": [
        "ola"
    ],
    "olfactif": [
        "olfactif"
    ],
    "olfactifs": [
        "olfactif"
    ],
    "olfactive": [
        "olfactif"
    ],
    "olfactives": [
        "olfactif"
    ],
    "olfactometre": [
        "olfactometre"
    ],
    "olibrius": [
        "olibrius"
    ],
    "olifant": [
        "olifant"
    ],
    "oligarchie": [
        "oligarchie"
    ],
    "olivaies": [
        "olivaie"
    ],
    "olive": [
        "olive"
    ],
    "oliver": [
        "oliver"
    ],
    "oliveraie": [
        "oliveraie"
    ],
    "oliveraies": [
        "oliveraie"
    ],
    "olives": [
        "olive"
    ],
    "olivette": [
        "olivette"
    ],
    "olivettes": [
        "olivette"
    ],
    "olivier": [
        "olivier"
    ],
    "oliviers": [
        "olivier"
    ],
    "olivine": [
        "olivine"
    ],
    "olivatre": [
        "olivatre"
    ],
    "olivatres": [
        "olivatre"
    ],
    "olle": [
        "olle"
    ],
    "olmeque": [
        "olmeque"
    ],
    "olmeques": [
        "olmeque"
    ],
    "olographe": [
        "olographe"
    ],
    "olympe": [
        "olympe"
    ],
    "olympes": [
        "olympe"
    ],
    "olympiade": [
        "olympiade"
    ],
    "olympiades": [
        "olympiade"
    ],
    "olympien": [
        "olympien"
    ],
    "olympienne": [
        "olympien"
    ],
    "olympiens": [
        "olympien"
    ],
    "olympique": [
        "olympique"
    ],
    "olympiques": [
        "olympique"
    ],
    "ole": [
        "ole"
    ],
    "oleagineux": [
        "oleagineux"
    ],
    "olecrane": [
        "olecrane"
    ],
    "olefine": [
        "olefine"
    ],
    "oleiculteurs": [
        "oleiculteur"
    ],
    "oleine": [
        "oleine"
    ],
    "oleoduc": [
        "oleoduc"
    ],
    "oleoducs": [
        "oleoduc"
    ],
    "omani": [
        "omani"
    ],
    "ombelle": [
        "ombelle"
    ],
    "ombelles": [
        "ombelle"
    ],
    "ombelliferes": [
        "ombellifere"
    ],
    "ombilic": [
        "ombilic"
    ],
    "ombilical": [
        "ombilical"
    ],
    "ombilicale": [
        "ombilical"
    ],
    "ombilicaux": [
        "ombilical"
    ],
    "omble": [
        "omble"
    ],
    "ombles": [
        "omble"
    ],
    "ombra": [
        "ombrer"
    ],
    "ombrage": [
        "ombrage",
        "ombrager"
    ],
    "ombragea": [
        "ombrager"
    ],
    "ombrageaient": [
        "ombrager"
    ],
    "ombrageait": [
        "ombrager"
    ],
    "ombragent": [
        "ombrager"
    ],
    "ombrager": [
        "ombrager"
    ],
    "ombrages": [
        "ombrage",
        "ombrager"
    ],
    "ombrageuse": [
        "ombrageux"
    ],
    "ombrageusement": [
        "ombrageusement"
    ],
    "ombrageuses": [
        "ombrageux"
    ],
    "ombrageux": [
        "ombrageux"
    ],
    "ombragee": [
        "ombrage",
        "ombrager"
    ],
    "ombragees": [
        "ombrage",
        "ombrager"
    ],
    "ombraient": [
        "ombrer"
    ],
    "ombrait": [
        "ombrer"
    ],
    "ombrant": [
        "ombrer",
        "ombrant"
    ],
    "ombre": [
        "ombrer",
        "ombre"
    ],
    "ombrelle": [
        "ombrelle"
    ],
    "ombrelles": [
        "ombrelle"
    ],
    "ombrer": [
        "ombrer"
    ],
    "ombres": [
        "ombrer",
        "ombre"
    ],
    "ombreuse": [
        "ombreux"
    ],
    "ombreuses": [
        "ombreux"
    ],
    "ombreux": [
        "ombreux"
    ],
    "ombree": [
        "ombree",
        "ombrer"
    ],
    "ombrees": [
        "ombree",
        "ombrer"
    ],
    "omelette": [
        "omelette"
    ],
    "omelettes": [
        "omelette"
    ],
    "omerta": [
        "omerta"
    ],
    "omet": [
        "omettre"
    ],
    "omets": [
        "omettre"
    ],
    "omettaient": [
        "omettre"
    ],
    "omettais": [
        "omettre"
    ],
    "omettait": [
        "omettre"
    ],
    "omettant": [
        "omettre"
    ],
    "omette": [
        "omettre"
    ],
    "omettent": [
        "omettre"
    ],
    "omettez": [
        "omettre"
    ],
    "omettiez": [
        "omettre"
    ],
    "omettrai": [
        "omettre"
    ],
    "omettre": [
        "omettre"
    ],
    "omettrez": [
        "omettre"
    ],
    "omicron": [
        "omicron"
    ],
    "omis": [
        "omis",
        "omettre"
    ],
    "omise": [
        "omettre"
    ],
    "omises": [
        "omettre"
    ],
    "omission": [
        "omission"
    ],
    "omissions": [
        "omission"
    ],
    "omit": [
        "omettre"
    ],
    "omni": [
        "omni"
    ],
    "omnibus": [
        "omnibus"
    ],
    "omnidirectionnel": [
        "omnidirectionnel"
    ],
    "omnidirectionnelle": [
        "omnidirectionnel"
    ],
    "omnipotence": [
        "omnipotence"
    ],
    "omnipotent": [
        "omnipotent"
    ],
    "omnipotente": [
        "omnipotent"
    ],
    "omnipotentes": [
        "omnipotent"
    ],
    "omnipresence": [
        "omnipresence"
    ],
    "omnipresent": [
        "omnipresent"
    ],
    "omnipresente": [
        "omnipresent"
    ],
    "omnipresentes": [
        "omnipresent"
    ],
    "omnipresents": [
        "omnipresent"
    ],
    "omnipuissance": [
        "omnipuissance"
    ],
    "omniscience": [
        "omniscience"
    ],
    "omniscient": [
        "omniscient"
    ],
    "omnisciente": [
        "omniscient"
    ],
    "omniscients": [
        "omniscient"
    ],
    "omnisports": [
        "omnisports"
    ],
    "omnium": [
        "omnium"
    ],
    "omnivore": [
        "omnivore"
    ],
    "omnivores": [
        "omnivore"
    ],
    "omoplate": [
        "omoplate"
    ],
    "omoplates": [
        "omoplate"
    ],
    "omphalos": [
        "omphalos"
    ],
    "omega": [
        "omega"
    ],
    "on": [
        "on",
        "il"
    ],
    "onagre": [
        "onagre"
    ],
    "onanisme": [
        "onanisme"
    ],
    "onanismes": [
        "onanisme"
    ],
    "onaniste": [
        "onaniste"
    ],
    "onc": [
        "onc"
    ],
    "once": [
        "once"
    ],
    "onces": [
        "once"
    ],
    "oncle": [
        "oncle"
    ],
    "oncles": [
        "oncle"
    ],
    "oncologie": [
        "oncologie"
    ],
    "oncologique": [
        "oncologique"
    ],
    "oncologue": [
        "oncologue"
    ],
    "oncologues": [
        "oncologue"
    ],
    "onction": [
        "onction"
    ],
    "onctions": [
        "onction"
    ],
    "onctueuse": [
        "onctueux"
    ],
    "onctueusement": [
        "onctueusement"
    ],
    "onctueuses": [
        "onctueux"
    ],
    "onctueux": [
        "onctueux"
    ],
    "onctuosite": [
        "onctuosite"
    ],
    "ondatra": [
        "ondatra"
    ],
    "onde": [
        "onde"
    ],
    "onder": [
        "onder"
    ],
    "ondes": [
        "onde"
    ],
    "ondin": [
        "ondin"
    ],
    "ondine": [
        "ondine"
    ],
    "ondines": [
        "ondine"
    ],
    "ondins": [
        "ondin"
    ],
    "ondoie": [
        "ondoyer"
    ],
    "ondoiement": [
        "ondoiement"
    ],
    "ondoiements": [
        "ondoiement"
    ],
    "ondoient": [
        "ondoyer"
    ],
    "ondoyaient": [
        "ondoyer"
    ],
    "ondoyait": [
        "ondoyer"
    ],
    "ondoyant": [
        "ondoyer",
        "ondoyant"
    ],
    "ondoyante": [
        "ondoyant"
    ],
    "ondoyantes": [
        "ondoyant"
    ],
    "ondoyants": [
        "ondoyant"
    ],
    "ondoyer": [
        "ondoyer"
    ],
    "ondoyons": [
        "ondoyer"
    ],
    "ondoye": [
        "ondoyer"
    ],
    "ondula": [
        "onduler"
    ],
    "ondulaient": [
        "onduler"
    ],
    "ondulait": [
        "onduler"
    ],
    "ondulant": [
        "onduler",
        "ondulant"
    ],
    "ondulante": [
        "ondulant"
    ],
    "ondulantes": [
        "ondulant"
    ],
    "ondulants": [
        "ondulant"
    ],
    "ondulation": [
        "ondulation"
    ],
    "ondulations": [
        "ondulation"
    ],
    "ondulatoire": [
        "ondulatoire"
    ],
    "ondulatoires": [
        "ondulatoire"
    ],
    "ondule": [
        "ondule",
        "onduler"
    ],
    "ondulent": [
        "onduler"
    ],
    "onduler": [
        "onduler"
    ],
    "ondulerait": [
        "onduler"
    ],
    "onduleuse": [
        "onduleux"
    ],
    "onduleuses": [
        "onduleux"
    ],
    "onduleux": [
        "onduleux"
    ],
    "ondulons": [
        "onduler"
    ],
    "ondulerent": [
        "onduler"
    ],
    "ondulee": [
        "ondule",
        "onduler"
    ],
    "ondulees": [
        "ondule",
        "onduler"
    ],
    "ondules": [
        "ondule",
        "onduler"
    ],
    "ondee": [
        "ondee"
    ],
    "ondees": [
        "ondee"
    ],
    "ongle": [
        "ongle"
    ],
    "ongles": [
        "ongle"
    ],
    "onglet": [
        "onglet"
    ],
    "onglets": [
        "onglet"
    ],
    "onglon": [
        "onglon"
    ],
    "onglee": [
        "onglee"
    ],
    "onguent": [
        "onguent"
    ],
    "onguents": [
        "onguent"
    ],
    "ongule": [
        "ongule"
    ],
    "ongules": [
        "ongule"
    ],
    "onirique": [
        "onirique"
    ],
    "oniriques": [
        "onirique"
    ],
    "onirisme": [
        "onirisme"
    ],
    "onirologie": [
        "onirologie"
    ],
    "onomatopee": [
        "onomatopee"
    ],
    "onomatopees": [
        "onomatopee"
    ],
    "onomatopeique": [
        "onomatopeique"
    ],
    "onopordons": [
        "onopordon"
    ],
    "ont": [
        "avoir"
    ],
    "onto": [
        "onto"
    ],
    "ontologie": [
        "ontologie"
    ],
    "ontologique": [
        "ontologique"
    ],
    "ontologiquement": [
        "ontologiquement"
    ],
    "onusienne": [
        "onusien"
    ],
    "onusiennes": [
        "onusien"
    ],
    "onusiens": [
        "onusien"
    ],
    "onyx": [
        "onyx"
    ],
    "onze": [
        "onze"
    ],
    "onzieme": [
        "onzieme"
    ],
    "onereuse": [
        "onereux"
    ],
    "onereuses": [
        "onereux"
    ],
    "onereux": [
        "onereux"
    ],
    "opacifiait": [
        "opacifier"
    ],
    "opacifiant": [
        "opacifier"
    ],
    "opacification": [
        "opacification"
    ],
    "opacifie": [
        "opacifier"
    ],
    "opacifient": [
        "opacifier"
    ],
    "opacifier": [
        "opacifier"
    ],
    "opacite": [
        "opacite"
    ],
    "opacites": [
        "opacite"
    ],
    "opale": [
        "opale"
    ],
    "opales": [
        "opale"
    ],
    "opalescence": [
        "opalescence"
    ],
    "opalescent": [
        "opalescent"
    ],
    "opalescente": [
        "opalescent"
    ],
    "opalescentes": [
        "opalescent"
    ],
    "opalin": [
        "opalin"
    ],
    "opaline": [
        "opalin"
    ],
    "opalines": [
        "opalin"
    ],
    "opalins": [
        "opalin"
    ],
    "opaque": [
        "opaque"
    ],
    "opaques": [
        "opaque"
    ],
    "ope": [
        "ope"
    ],
    "open": [
        "open"
    ],
    "opercule": [
        "opercule"
    ],
    "ophidien": [
        "ophidien"
    ],
    "ophidiens": [
        "ophidien"
    ],
    "ophite": [
        "ophite"
    ],
    "ophtalmique": [
        "ophtalmique"
    ],
    "ophtalmologie": [
        "ophtalmologie"
    ],
    "ophtalmologique": [
        "ophtalmologique"
    ],
    "ophtalmologiste": [
        "ophtalmologiste"
    ],
    "ophtalmologistes": [
        "ophtalmologiste"
    ],
    "ophtalmologue": [
        "ophtalmologue"
    ],
    "ophtalmoscope": [
        "ophtalmoscope"
    ],
    "opiace": [
        "opiacer",
        "opiace"
    ],
    "opiacees": [
        "opiacer",
        "opiace"
    ],
    "opiaces": [
        "opiace"
    ],
    "opiat": [
        "opiat"
    ],
    "opiats": [
        "opiat"
    ],
    "opimes": [
        "opimes"
    ],
    "opina": [
        "opiner"
    ],
    "opinai": [
        "opiner"
    ],
    "opinaient": [
        "opiner"
    ],
    "opinais": [
        "opiner"
    ],
    "opinait": [
        "opiner"
    ],
    "opinant": [
        "opiner"
    ],
    "opine": [
        "opiner"
    ],
    "opinel": [
        "opinel"
    ],
    "opinels": [
        "opinel"
    ],
    "opiner": [
        "opiner"
    ],
    "opines": [
        "opiner"
    ],
    "opinion": [
        "opinion"
    ],
    "opinions": [
        "opiner",
        "opinion"
    ],
    "opiniatra": [
        "opiniatrer"
    ],
    "opiniatre": [
        "opiniatrer",
        "opiniatre"
    ],
    "opiniatrement": [
        "opiniatrement"
    ],
    "opiniatres": [
        "opiniatre"
    ],
    "opiniatrete": [
        "opiniatrete"
    ],
    "opiniatrez": [
        "opiniatrer"
    ],
    "opinerent": [
        "opiner"
    ],
    "opiomane": [
        "opiomane"
    ],
    "opium": [
        "opium"
    ],
    "opopanax": [
        "opopanax"
    ],
    "opoponax": [
        "opoponax"
    ],
    "opossum": [
        "opossum"
    ],
    "opossums": [
        "opossum"
    ],
    "opotherapiques": [
        "opotherapique"
    ],
    "oppidum": [
        "oppidum"
    ],
    "opportun": [
        "opportun"
    ],
    "opportune": [
        "opportun"
    ],
    "opportunes": [
        "opportun"
    ],
    "opportunisme": [
        "opportunisme"
    ],
    "opportuniste": [
        "opportuniste"
    ],
    "opportunistes": [
        "opportuniste"
    ],
    "opportunite": [
        "opportunite"
    ],
    "opportunites": [
        "opportunite"
    ],
    "opportuns": [
        "opportun"
    ],
    "opportunement": [
        "opportunement"
    ],
    "opposa": [
        "opposer"
    ],
    "opposable": [
        "opposable"
    ],
    "opposables": [
        "opposable"
    ],
    "opposai": [
        "opposer"
    ],
    "opposaient": [
        "opposer"
    ],
    "opposais": [
        "opposer"
    ],
    "opposait": [
        "opposer"
    ],
    "opposant": [
        "opposant",
        "opposer"
    ],
    "opposante": [
        "opposant"
    ],
    "opposants": [
        "opposant"
    ],
    "oppose": [
        "oppose",
        "opposer"
    ],
    "opposent": [
        "opposer"
    ],
    "opposer": [
        "opposer"
    ],
    "opposera": [
        "opposer"
    ],
    "opposerai": [
        "opposer"
    ],
    "opposeraient": [
        "opposer"
    ],
    "opposerais": [
        "opposer"
    ],
    "opposerait": [
        "opposer"
    ],
    "opposerez": [
        "opposer"
    ],
    "opposerions": [
        "opposer"
    ],
    "opposerons": [
        "opposer"
    ],
    "opposeront": [
        "opposer"
    ],
    "opposes": [
        "oppose",
        "opposer"
    ],
    "opposez": [
        "opposer"
    ],
    "opposions": [
        "opposer"
    ],
    "opposition": [
        "opposition"
    ],
    "oppositionnel": [
        "oppositionnel"
    ],
    "oppositionnelle": [
        "oppositionnel"
    ],
    "oppositions": [
        "opposition"
    ],
    "opposons": [
        "opposer"
    ],
    "opposat": [
        "opposer"
    ],
    "opposerent": [
        "opposer"
    ],
    "opposee": [
        "oppose",
        "opposer"
    ],
    "opposees": [
        "oppose",
        "opposer"
    ],
    "oppressa": [
        "oppresser"
    ],
    "oppressaient": [
        "oppresser"
    ],
    "oppressait": [
        "oppresser"
    ],
    "oppressant": [
        "oppresser",
        "oppressant"
    ],
    "oppressante": [
        "oppressant"
    ],
    "oppressantes": [
        "oppressant"
    ],
    "oppressants": [
        "oppressant"
    ],
    "oppresse": [
        "oppresser",
        "oppresse"
    ],
    "oppressent": [
        "oppresser"
    ],
    "oppresser": [
        "oppresser"
    ],
    "oppresseur": [
        "oppresseur"
    ],
    "oppresseurs": [
        "oppresseur"
    ],
    "oppressif": [
        "oppressif"
    ],
    "oppression": [
        "oppression"
    ],
    "oppressions": [
        "oppression"
    ],
    "oppressive": [
        "oppressif"
    ],
    "oppressee": [
        "oppresser",
        "oppresse"
    ],
    "oppressees": [
        "oppresser",
        "oppresse"
    ],
    "opprimait": [
        "opprimer"
    ],
    "opprimant": [
        "opprimer"
    ],
    "opprime": [
        "opprimer",
        "opprime"
    ],
    "oppriment": [
        "opprimer"
    ],
    "opprimer": [
        "opprimer"
    ],
    "opprimez": [
        "opprimer"
    ],
    "opprimee": [
        "opprimer",
        "opprime"
    ],
    "opprimees": [
        "opprimer",
        "opprime"
    ],
    "opprimes": [
        "opprimer",
        "opprime"
    ],
    "opprobre": [
        "opprobre"
    ],
    "opprobres": [
        "opprobre"
    ],
    "opta": [
        "opter"
    ],
    "optai": [
        "opter"
    ],
    "optaient": [
        "opter"
    ],
    "optais": [
        "opter"
    ],
    "optait": [
        "opter"
    ],
    "optalidon": [
        "optalidon"
    ],
    "optant": [
        "optant"
    ],
    "optatif": [
        "optatif"
    ],
    "optatifs": [
        "optatif"
    ],
    "opte": [
        "opter"
    ],
    "optent": [
        "opter"
    ],
    "opter": [
        "opter"
    ],
    "opterais": [
        "opter"
    ],
    "optes": [
        "opter"
    ],
    "opticien": [
        "opticien"
    ],
    "opticienne": [
        "opticien"
    ],
    "opticiens": [
        "opticien"
    ],
    "optima": [
        "optimum"
    ],
    "optimal": [
        "optimal"
    ],
    "optimale": [
        "optimal"
    ],
    "optimales": [
        "optimal"
    ],
    "optimaux": [
        "optimal"
    ],
    "optime": [
        "optime"
    ],
    "optimisation": [
        "optimisation"
    ],
    "optimise": [
        "optimiser"
    ],
    "optimiser": [
        "optimiser"
    ],
    "optimisez": [
        "optimiser"
    ],
    "optimisme": [
        "optimisme"
    ],
    "optimiste": [
        "optimiste"
    ],
    "optimistes": [
        "optimiste"
    ],
    "optimisees": [
        "optimiser"
    ],
    "optimum": [
        "optimum"
    ],
    "option": [
        "option"
    ],
    "optionnel": [
        "optionnel"
    ],
    "optionnelle": [
        "optionnel"
    ],
    "options": [
        "option",
        "opter"
    ],
    "optique": [
        "optique"
    ],
    "optiques": [
        "optique"
    ],
    "optometrie": [
        "optometrie"
    ],
    "optometriste": [
        "optometriste"
    ],
    "optons": [
        "opter"
    ],
    "optat": [
        "opter"
    ],
    "opterent": [
        "opter"
    ],
    "opulence": [
        "opulence"
    ],
    "opulences": [
        "opulence"
    ],
    "opulent": [
        "opulent"
    ],
    "opulente": [
        "opulent"
    ],
    "opulentes": [
        "opulent"
    ],
    "opulents": [
        "opulent"
    ],
    "opus": [
        "opus"
    ],
    "opuscule": [
        "opuscule"
    ],
    "opuscules": [
        "opuscule"
    ],
    "opere": [
        "operer",
        "opere"
    ],
    "operent": [
        "operer"
    ],
    "opera": [
        "opera",
        "operer"
    ],
    "operable": [
        "operable"
    ],
    "operaient": [
        "operer"
    ],
    "operais": [
        "operer"
    ],
    "operait": [
        "operer"
    ],
    "operant": [
        "operer",
        "operant"
    ],
    "operas": [
        "opera"
    ],
    "operateur": [
        "operateur"
    ],
    "operateurs": [
        "operateur"
    ],
    "operation": [
        "operation"
    ],
    "operationnel": [
        "operationnel"
    ],
    "operationnelle": [
        "operationnel"
    ],
    "operationnelles": [
        "operationnel"
    ],
    "operationnels": [
        "operationnel"
    ],
    "operations": [
        "operation"
    ],
    "operatique": [
        "operatique"
    ],
    "operatoire": [
        "operatoire"
    ],
    "operatoires": [
        "operatoire"
    ],
    "operatrice": [
        "operateur"
    ],
    "operatrices": [
        "operateur"
    ],
    "operer": [
        "operer"
    ],
    "operera": [
        "operer"
    ],
    "opererai": [
        "operer"
    ],
    "opereraient": [
        "operer"
    ],
    "opererait": [
        "operer"
    ],
    "opereras": [
        "operer"
    ],
    "opererez": [
        "operer"
    ],
    "opererons": [
        "operer"
    ],
    "opereront": [
        "operer"
    ],
    "operette": [
        "operette"
    ],
    "operettes": [
        "operette"
    ],
    "operez": [
        "operer"
    ],
    "operiez": [
        "operer"
    ],
    "operions": [
        "operer"
    ],
    "operons": [
        "operer"
    ],
    "operat": [
        "operer"
    ],
    "opererent": [
        "operer"
    ],
    "operee": [
        "operer",
        "opere"
    ],
    "operees": [
        "operer",
        "opere"
    ],
    "operes": [
        "operer",
        "opere"
    ],
    "or": [
        "or"
    ],
    "oracle": [
        "oracle"
    ],
    "oracles": [
        "oracle"
    ],
    "orage": [
        "orage"
    ],
    "orages": [
        "orage"
    ],
    "orageuse": [
        "orageux"
    ],
    "orageuses": [
        "orageux"
    ],
    "orageux": [
        "orageux"
    ],
    "oraison": [
        "oraison"
    ],
    "oraisons": [
        "oraison"
    ],
    "oral": [
        "oral"
    ],
    "orale": [
        "oral"
    ],
    "oralement": [
        "oralement"
    ],
    "orales": [
        "oral"
    ],
    "oralite": [
        "oralite"
    ],
    "oranais": [
        "oranais"
    ],
    "oranaise": [
        "oranais"
    ],
    "orange": [
        "orange",
        "oranger"
    ],
    "orangeade": [
        "orangeade"
    ],
    "orangeades": [
        "orangeade"
    ],
    "oranger": [
        "oranger"
    ],
    "orangeraie": [
        "orangeraie"
    ],
    "orangeraies": [
        "orangeraie"
    ],
    "orangerie": [
        "orangerie"
    ],
    "orangeries": [
        "orangerie"
    ],
    "orangers": [
        "oranger"
    ],
    "oranges": [
        "orange",
        "oranger"
    ],
    "orangistes": [
        "orangiste"
    ],
    "orangee": [
        "orange",
        "oranger"
    ],
    "orangees": [
        "orange",
        "oranger"
    ],
    "orant": [
        "orant"
    ],
    "orante": [
        "orant"
    ],
    "orantes": [
        "orant"
    ],
    "orants": [
        "orant"
    ],
    "orateur": [
        "orateur"
    ],
    "orateurs": [
        "orateur"
    ],
    "oratoire": [
        "oratoire"
    ],
    "oratoires": [
        "oratoire"
    ],
    "oratorien": [
        "oratorien"
    ],
    "oratoriens": [
        "oratorien"
    ],
    "oratorio": [
        "oratorio"
    ],
    "oratorios": [
        "oratorio"
    ],
    "oratrice": [
        "orateur"
    ],
    "oraux": [
        "oral"
    ],
    "orbe": [
        "orbe"
    ],
    "orbes": [
        "orbe"
    ],
    "orbiculaire": [
        "orbiculaire"
    ],
    "orbitaire": [
        "orbitaire"
    ],
    "orbitaires": [
        "orbitaire"
    ],
    "orbital": [
        "orbital"
    ],
    "orbitale": [
        "orbital"
    ],
    "orbitales": [
        "orbital"
    ],
    "orbitaux": [
        "orbital"
    ],
    "orbite": [
        "orbite"
    ],
    "orbiter": [
        "orbiter"
    ],
    "orbites": [
        "orbite"
    ],
    "orbitons": [
        "orbiter"
    ],
    "orbitele": [
        "orbitele"
    ],
    "orbiteles": [
        "orbitele"
    ],
    "orchestra": [
        "orchestrer"
    ],
    "orchestraient": [
        "orchestrer"
    ],
    "orchestrait": [
        "orchestrer"
    ],
    "orchestral": [
        "orchestral"
    ],
    "orchestrale": [
        "orchestral"
    ],
    "orchestration": [
        "orchestration"
    ],
    "orchestrations": [
        "orchestration"
    ],
    "orchestraux": [
        "orchestral"
    ],
    "orchestre": [
        "orchestre",
        "orchestrer"
    ],
    "orchestrent": [
        "orchestrer"
    ],
    "orchestrer": [
        "orchestrer"
    ],
    "orchestres": [
        "orchestre",
        "orchestrer"
    ],
    "orchestree": [
        "orchestre",
        "orchestrer"
    ],
    "orchestrees": [
        "orchestre",
        "orchestrer"
    ],
    "orchidee": [
        "orchidee"
    ],
    "orchidees": [
        "orchidee"
    ],
    "orchis": [
        "orchis"
    ],
    "ord": [
        "ord"
    ],
    "ordalie": [
        "ordalie"
    ],
    "ordinaire": [
        "ordinaire"
    ],
    "ordinairement": [
        "ordinairement"
    ],
    "ordinaires": [
        "ordinaire"
    ],
    "ordinal": [
        "ordinal"
    ],
    "ordinant": [
        "ordinant"
    ],
    "ordinateur": [
        "ordinateur"
    ],
    "ordinateurs": [
        "ordinateur"
    ],
    "ordination": [
        "ordination"
    ],
    "ordo": [
        "ordo"
    ],
    "ordonna": [
        "ordonner"
    ],
    "ordonnai": [
        "ordonner"
    ],
    "ordonnaient": [
        "ordonner"
    ],
    "ordonnais": [
        "ordonner"
    ],
    "ordonnait": [
        "ordonner"
    ],
    "ordonnance": [
        "ordonnance"
    ],
    "ordonnancement": [
        "ordonnancement"
    ],
    "ordonnancer": [
        "ordonnancer"
    ],
    "ordonnances": [
        "ordonnance"
    ],
    "ordonnancee": [
        "ordonnancer"
    ],
    "ordonnant": [
        "ordonner"
    ],
    "ordonnateur": [
        "ordonnateur"
    ],
    "ordonnateurs": [
        "ordonnateur"
    ],
    "ordonnatrice": [
        "ordonnateur"
    ],
    "ordonne": [
        "ordonner",
        "ordonne"
    ],
    "ordonnent": [
        "ordonner"
    ],
    "ordonner": [
        "ordonner"
    ],
    "ordonnera": [
        "ordonner"
    ],
    "ordonnerai": [
        "ordonner"
    ],
    "ordonnerais": [
        "ordonner"
    ],
    "ordonnerait": [
        "ordonner"
    ],
    "ordonneront": [
        "ordonner"
    ],
    "ordonnes": [
        "ordonner",
        "ordonne"
    ],
    "ordonnez": [
        "ordonner"
    ],
    "ordonniez": [
        "ordonner"
    ],
    "ordonnons": [
        "ordonner"
    ],
    "ordonnerent": [
        "ordonner"
    ],
    "ordonnee": [
        "ordonner",
        "ordonne"
    ],
    "ordonnees": [
        "ordonner",
        "ordonne"
    ],
    "ordre": [
        "ordre"
    ],
    "ordres": [
        "ordre"
    ],
    "ordure": [
        "ordure"
    ],
    "ordureries": [
        "ordurerie"
    ],
    "ordures": [
        "ordure"
    ],
    "ordurier": [
        "ordurier"
    ],
    "orduriers": [
        "ordurier"
    ],
    "orduriere": [
        "ordurier"
    ],
    "ordurieres": [
        "ordurier"
    ],
    "ore": [
        "ore"
    ],
    "oreille": [
        "oreille"
    ],
    "oreiller": [
        "oreiller"
    ],
    "oreillers": [
        "oreiller"
    ],
    "oreilles": [
        "oreille"
    ],
    "oreillette": [
        "oreillette"
    ],
    "oreillettes": [
        "oreillette"
    ],
    "oreillons": [
        "oreillon"
    ],
    "orfraie": [
        "orfraie"
    ],
    "orfevre": [
        "orfevre"
    ],
    "orfevrerie": [
        "orfevrerie"
    ],
    "orfevreries": [
        "orfevrerie"
    ],
    "orfevres": [
        "orfevre"
    ],
    "orfevree": [
        "orfevre"
    ],
    "organdi": [
        "organdi"
    ],
    "organdis": [
        "organdi"
    ],
    "organe": [
        "organe"
    ],
    "organes": [
        "organe"
    ],
    "organiciser": [
        "organiciser"
    ],
    "organigramme": [
        "organigramme"
    ],
    "organique": [
        "organique"
    ],
    "organiquement": [
        "organiquement"
    ],
    "organiques": [
        "organique"
    ],
    "organisa": [
        "organiser"
    ],
    "organisai": [
        "organiser"
    ],
    "organisaient": [
        "organiser"
    ],
    "organisais": [
        "organiser"
    ],
    "organisait": [
        "organiser"
    ],
    "organisant": [
        "organiser"
    ],
    "organisateur": [
        "organisateur"
    ],
    "organisateurs": [
        "organisateur"
    ],
    "organisation": [
        "organisation"
    ],
    "organisationnelle": [
        "organisationnel"
    ],
    "organisations": [
        "organisation"
    ],
    "organisatrice": [
        "organisateur"
    ],
    "organise": [
        "organise",
        "organiser"
    ],
    "organisent": [
        "organiser"
    ],
    "organiser": [
        "organiser"
    ],
    "organisera": [
        "organiser"
    ],
    "organiserai": [
        "organiser"
    ],
    "organiserais": [
        "organiser"
    ],
    "organiserait": [
        "organiser"
    ],
    "organiserez": [
        "organiser"
    ],
    "organiseriez": [
        "organiser"
    ],
    "organiserons": [
        "organiser"
    ],
    "organiseront": [
        "organiser"
    ],
    "organises": [
        "organise",
        "organiser"
    ],
    "organiseur": [
        "organiseur"
    ],
    "organisez": [
        "organiser"
    ],
    "organisiez": [
        "organiser"
    ],
    "organisions": [
        "organiser"
    ],
    "organisme": [
        "organisme"
    ],
    "organismes": [
        "organisme"
    ],
    "organisons": [
        "organiser"
    ],
    "organiste": [
        "organiste"
    ],
    "organistes": [
        "organiste"
    ],
    "organistique": [
        "organistique"
    ],
    "organisames": [
        "organiser"
    ],
    "organisat": [
        "organiser"
    ],
    "organiserent": [
        "organiser"
    ],
    "organisee": [
        "organise",
        "organiser"
    ],
    "organisees": [
        "organise",
        "organiser"
    ],
    "organometallique": [
        "organometallique"
    ],
    "organon": [
        "organon"
    ],
    "orgasme": [
        "orgasme"
    ],
    "orgasmes": [
        "orgasme"
    ],
    "orgasmique": [
        "orgasmique"
    ],
    "orgastique": [
        "orgastique"
    ],
    "orge": [
        "orge"
    ],
    "orgeat": [
        "orgeat"
    ],
    "orgelet": [
        "orgelet"
    ],
    "orgelets": [
        "orgelet"
    ],
    "orges": [
        "orge"
    ],
    "orgiaque": [
        "orgiaque"
    ],
    "orgiastique": [
        "orgiastique"
    ],
    "orgiastiques": [
        "orgiastique"
    ],
    "orgie": [
        "orgie"
    ],
    "orgies": [
        "orgy",
        "orgie"
    ],
    "orgue": [
        "orgue"
    ],
    "orgueil": [
        "orgueil"
    ],
    "orgueilleuse": [
        "orgueilleux"
    ],
    "orgueilleusement": [
        "orgueilleusement"
    ],
    "orgueilleuses": [
        "orgueilleux"
    ],
    "orgueilleux": [
        "orgueilleux"
    ],
    "orgueils": [
        "orgueil"
    ],
    "orgues": [
        "orgue"
    ],
    "oribus": [
        "oribus"
    ],
    "orient": [
        "orient"
    ],
    "orienta": [
        "orienter"
    ],
    "orientable": [
        "orientable"
    ],
    "orientai": [
        "orienter"
    ],
    "orientaient": [
        "orienter"
    ],
    "orientais": [
        "orienter"
    ],
    "orientait": [
        "orienter"
    ],
    "oriental": [
        "oriental"
    ],
    "orientale": [
        "oriental"
    ],
    "orientales": [
        "oriental"
    ],
    "orientalisme": [
        "orientalisme"
    ],
    "orientaliste": [
        "orientaliste"
    ],
    "orientalistes": [
        "orientaliste"
    ],
    "orientant": [
        "orienter"
    ],
    "orientateurs": [
        "orientateur"
    ],
    "orientation": [
        "orientation"
    ],
    "orientations": [
        "orientation"
    ],
    "orientaux": [
        "oriental"
    ],
    "oriente": [
        "orienter",
        "oriente"
    ],
    "orientent": [
        "orienter"
    ],
    "orienter": [
        "orienter"
    ],
    "orienterai": [
        "orienter"
    ],
    "orienterait": [
        "orienter"
    ],
    "orienterez": [
        "orienter"
    ],
    "orienteur": [
        "orienteur"
    ],
    "orienteurs": [
        "orienteur"
    ],
    "orienteuse": [
        "orienteur"
    ],
    "orientez": [
        "orienter"
    ],
    "orients": [
        "orient"
    ],
    "orienterent": [
        "orienter"
    ],
    "orientee": [
        "orienter",
        "oriente"
    ],
    "orientees": [
        "orienter",
        "oriente"
    ],
    "orientes": [
        "orienter",
        "oriente"
    ],
    "orifice": [
        "orifice"
    ],
    "orifices": [
        "orifice"
    ],
    "oriflamme": [
        "oriflamme"
    ],
    "oriflammes": [
        "oriflamme"
    ],
    "origami": [
        "origami"
    ],
    "origan": [
        "origan"
    ],
    "originaire": [
        "originaire"
    ],
    "originairement": [
        "originairement"
    ],
    "originaires": [
        "originaire"
    ],
    "original": [
        "original"
    ],
    "originale": [
        "original"
    ],
    "originalement": [
        "originalement"
    ],
    "originales": [
        "original"
    ],
    "originalite": [
        "originalite"
    ],
    "originalites": [
        "originalite"
    ],
    "originaux": [
        "original"
    ],
    "origine": [
        "origine"
    ],
    "originel": [
        "originel"
    ],
    "originelle": [
        "originel"
    ],
    "originellement": [
        "originellement"
    ],
    "originelles": [
        "originel"
    ],
    "originels": [
        "originel"
    ],
    "origines": [
        "origine"
    ],
    "orignal": [
        "orignal"
    ],
    "orignaux": [
        "orignal"
    ],
    "orillon": [
        "orillon"
    ],
    "orillons": [
        "orillon"
    ],
    "orin": [
        "orin"
    ],
    "oriol": [
        "oriol"
    ],
    "oripeaux": [
        "oripeau"
    ],
    "orlon": [
        "orlon"
    ],
    "orleanais": [
        "orleanais"
    ],
    "orleanaise": [
        "orleanais"
    ],
    "orleanaises": [
        "orleanais"
    ],
    "orleanisme": [
        "orleanisme"
    ],
    "orleaniste": [
        "orleaniste"
    ],
    "orleanistes": [
        "orleaniste"
    ],
    "orme": [
        "orme"
    ],
    "ormeau": [
        "ormeau"
    ],
    "ormeaux": [
        "ormeau"
    ],
    "ormes": [
        "orme"
    ],
    "orna": [
        "orner"
    ],
    "ornaient": [
        "orner"
    ],
    "ornait": [
        "orner"
    ],
    "ornant": [
        "orner"
    ],
    "orne": [
        "orner",
        "orne"
    ],
    "ornement": [
        "ornement"
    ],
    "ornemental": [
        "ornemental"
    ],
    "ornementale": [
        "ornemental"
    ],
    "ornementales": [
        "ornemental"
    ],
    "ornementation": [
        "ornementation"
    ],
    "ornementations": [
        "ornementation"
    ],
    "ornementer": [
        "ornementer"
    ],
    "ornements": [
        "ornement"
    ],
    "ornemente": [
        "ornementer"
    ],
    "ornementee": [
        "ornementer"
    ],
    "ornementes": [
        "ornementer"
    ],
    "ornent": [
        "orner"
    ],
    "orner": [
        "orner"
    ],
    "ornera": [
        "orner"
    ],
    "ornerait": [
        "orner"
    ],
    "orneront": [
        "orner"
    ],
    "ornez": [
        "orner"
    ],
    "ornithologie": [
        "ornithologie"
    ],
    "ornithologique": [
        "ornithologique"
    ],
    "ornithologue": [
        "ornithologue"
    ],
    "ornithologues": [
        "ornithologue"
    ],
    "ornithoptere": [
        "ornithoptere"
    ],
    "ornithorynque": [
        "ornithorynque"
    ],
    "ornithorynques": [
        "ornithorynque"
    ],
    "orniere": [
        "orniere"
    ],
    "ornieres": [
        "orniere"
    ],
    "ornat": [
        "orner"
    ],
    "ornerent": [
        "orner"
    ],
    "ornee": [
        "orner",
        "orne"
    ],
    "ornees": [
        "orner",
        "orne"
    ],
    "ornes": [
        "orner",
        "orne"
    ],
    "orographie": [
        "orographie"
    ],
    "oronge": [
        "oronge"
    ],
    "oronges": [
        "oronge"
    ],
    "oropharynx": [
        "oropharynx"
    ],
    "orpailleur": [
        "orpailleur"
    ],
    "orpailleurs": [
        "orpailleur"
    ],
    "orphelin": [
        "orphelin"
    ],
    "orphelinat": [
        "orphelinat"
    ],
    "orphelinats": [
        "orphelinat"
    ],
    "orpheline": [
        "orphelin"
    ],
    "orphelines": [
        "orphelin"
    ],
    "orphelins": [
        "orphelin"
    ],
    "orphie": [
        "orphie"
    ],
    "orphique": [
        "orphique"
    ],
    "orphiques": [
        "orphique"
    ],
    "orphisme": [
        "orphisme"
    ],
    "orphee": [
        "orphee"
    ],
    "orpheon": [
        "orpheon"
    ],
    "orpheoniste": [
        "orpheoniste"
    ],
    "orpheonistes": [
        "orpheoniste"
    ],
    "orpheons": [
        "orpheon"
    ],
    "orpiment": [
        "orpiment"
    ],
    "orpin": [
        "orpin"
    ],
    "orque": [
        "orque"
    ],
    "orques": [
        "orque"
    ],
    "ors": [
        "or"
    ],
    "orsec": [
        "orsec"
    ],
    "ort": [
        "ort"
    ],
    "orteil": [
        "orteil"
    ],
    "orteils": [
        "orteil"
    ],
    "ortho": [
        "ortho"
    ],
    "orthodontie": [
        "orthodontie"
    ],
    "orthodontique": [
        "orthodontique"
    ],
    "orthodontiste": [
        "orthodontiste"
    ],
    "orthodontistes": [
        "orthodontiste"
    ],
    "orthodoxe": [
        "orthodoxe"
    ],
    "orthodoxes": [
        "orthodoxe"
    ],
    "orthodoxie": [
        "orthodoxie"
    ],
    "orthogonal": [
        "orthogonal"
    ],
    "orthogonaux": [
        "orthogonal"
    ],
    "orthographe": [
        "orthographe"
    ],
    "orthographiait": [
        "orthographier"
    ],
    "orthographie": [
        "orthographier"
    ],
    "orthographier": [
        "orthographier"
    ],
    "orthographique": [
        "orthographique"
    ],
    "orthographiques": [
        "orthographique"
    ],
    "orthographiees": [
        "orthographier"
    ],
    "orthophonie": [
        "orthophonie"
    ],
    "orthophoniste": [
        "orthophoniste"
    ],
    "orthophonistes": [
        "orthophoniste"
    ],
    "orthoptere": [
        "orthoptere"
    ],
    "orthopteres": [
        "orthoptere"
    ],
    "orthopedie": [
        "orthopedie"
    ],
    "orthopedique": [
        "orthopedique"
    ],
    "orthopediques": [
        "orthopedique"
    ],
    "orthopediste": [
        "orthopediste"
    ],
    "orthostatique": [
        "orthostatique"
    ],
    "ortie": [
        "ortie"
    ],
    "orties": [
        "ortie"
    ],
    "ortolan": [
        "ortolan"
    ],
    "ortolans": [
        "ortolan"
    ],
    "ortedrine": [
        "ortedrine"
    ],
    "orvet": [
        "orvet"
    ],
    "orycterope": [
        "orycterope"
    ],
    "oryx": [
        "oryx"
    ],
    "oreade": [
        "oreade"
    ],
    "oree": [
        "oree"
    ],
    "oremus": [
        "oremus"
    ],
    "os": [
        "os"
    ],
    "osa": [
        "oser"
    ],
    "osai": [
        "oser"
    ],
    "osaient": [
        "oser"
    ],
    "osais": [
        "oser"
    ],
    "osait": [
        "oser"
    ],
    "osant": [
        "oser"
    ],
    "oscar": [
        "oscar"
    ],
    "oscars": [
        "oscar"
    ],
    "oscilla": [
        "osciller"
    ],
    "oscillai": [
        "osciller"
    ],
    "oscillaient": [
        "osciller"
    ],
    "oscillais": [
        "osciller"
    ],
    "oscillait": [
        "osciller"
    ],
    "oscillant": [
        "osciller",
        "oscillant"
    ],
    "oscillante": [
        "oscillant"
    ],
    "oscillants": [
        "oscillant"
    ],
    "oscillateur": [
        "oscillateur"
    ],
    "oscillation": [
        "oscillation"
    ],
    "oscillations": [
        "oscillation"
    ],
    "oscillatoire": [
        "oscillatoire"
    ],
    "oscillatoires": [
        "oscillatoire"
    ],
    "oscille": [
        "osciller"
    ],
    "oscillent": [
        "osciller"
    ],
    "osciller": [
        "osciller"
    ],
    "oscillez": [
        "osciller"
    ],
    "oscillographe": [
        "oscillographe"
    ],
    "oscillometre": [
        "oscillometre"
    ],
    "oscilloscope": [
        "oscilloscope"
    ],
    "oscillerent": [
        "osciller"
    ],
    "ose": [
        "oser",
        "ose"
    ],
    "oseille": [
        "oseille"
    ],
    "oseilles": [
        "oseille"
    ],
    "osent": [
        "oser"
    ],
    "oser": [
        "oser"
    ],
    "osera": [
        "oser"
    ],
    "oserai": [
        "oser"
    ],
    "oseraie": [
        "oseraie"
    ],
    "oseraient": [
        "oseraient"
    ],
    "oseraies": [
        "oseraie"
    ],
    "oserais": [
        "oser"
    ],
    "oserait": [
        "oser"
    ],
    "oseras": [
        "oser"
    ],
    "oserez": [
        "oser"
    ],
    "oseriez": [
        "oser"
    ],
    "oserions": [
        "oser"
    ],
    "oserons": [
        "oser"
    ],
    "oseront": [
        "oser"
    ],
    "oses": [
        "oser",
        "ose"
    ],
    "osez": [
        "oser"
    ],
    "osier": [
        "osier"
    ],
    "osiers": [
        "osier"
    ],
    "osiez": [
        "oser"
    ],
    "osions": [
        "oser"
    ],
    "osmium": [
        "osmium"
    ],
    "osmonde": [
        "osmonde"
    ],
    "osmose": [
        "osmose"
    ],
    "osmoses": [
        "osmose"
    ],
    "osons": [
        "oser"
    ],
    "ossature": [
        "ossature"
    ],
    "ossatures": [
        "ossature"
    ],
    "osselet": [
        "osselet"
    ],
    "osselets": [
        "osselet"
    ],
    "ossement": [
        "ossement"
    ],
    "ossements": [
        "ossement"
    ],
    "osseuse": [
        "osseux"
    ],
    "osseuses": [
        "osseux"
    ],
    "osseux": [
        "osseux"
    ],
    "ossification": [
        "ossification"
    ],
    "ossifie": [
        "ossifier"
    ],
    "ossuaire": [
        "ossuaire"
    ],
    "ossuaires": [
        "ossuaire"
    ],
    "ossue": [
        "ossu"
    ],
    "ost": [
        "ost"
    ],
    "ostensible": [
        "ostensible"
    ],
    "ostensiblement": [
        "ostensiblement"
    ],
    "ostensoir": [
        "ostensoir"
    ],
    "ostensoirs": [
        "ostensoir"
    ],
    "ostentation": [
        "ostentation"
    ],
    "ostentatoire": [
        "ostentatoire"
    ],
    "ostentatoirement": [
        "ostentatoirement"
    ],
    "ostinato": [
        "ostinato"
    ],
    "ostracisme": [
        "ostracisme"
    ],
    "ostrogoth": [
        "ostrogoth"
    ],
    "ostrogoths": [
        "ostrogoth"
    ],
    "ostreiculteur": [
        "ostreiculteur"
    ],
    "ostreiculteurs": [
        "ostreiculteur"
    ],
    "ostreiculture": [
        "ostreiculture"
    ],
    "osteoarthrite": [
        "osteoarthrite"
    ],
    "osteogenese": [
        "osteogenese"
    ],
    "osteogeniques": [
        "osteogenique"
    ],
    "osteologique": [
        "osteologique"
    ],
    "osteomyelite": [
        "osteomyelite"
    ],
    "osteopathe": [
        "osteopathe"
    ],
    "osteopathes": [
        "osteopathe"
    ],
    "osteopathie": [
        "osteopathie"
    ],
    "osteoporose": [
        "osteoporose"
    ],
    "osteosarcome": [
        "osteosarcome"
    ],
    "osteotomie": [
        "osteotomie"
    ],
    "osames": [
        "oser"
    ],
    "osat": [
        "oser"
    ],
    "oserent": [
        "oser"
    ],
    "osee": [
        "oser",
        "ose"
    ],
    "osees": [
        "oser",
        "ose"
    ],
    "otage": [
        "otage"
    ],
    "otages": [
        "otage"
    ],
    "otalgie": [
        "otalgie"
    ],
    "otarie": [
        "otarie"
    ],
    "otaries": [
        "otarie"
    ],
    "otite": [
        "otite"
    ],
    "otites": [
        "otite"
    ],
    "otoscope": [
        "otoscope"
    ],
    "otospongiose": [
        "otospongiose"
    ],
    "ottoman": [
        "ottoman"
    ],
    "ottomane": [
        "ottomane",
        "ottoman"
    ],
    "ottomanes": [
        "ottoman"
    ],
    "ottomans": [
        "ottoman"
    ],
    "ou": [
        "ou"
    ],
    "ouah": [
        "ouah"
    ],
    "ouaille": [
        "ouaille"
    ],
    "ouailles": [
        "ouaille"
    ],
    "ouais": [
        "ouais"
    ],
    "ouananiche": [
        "ouananiche"
    ],
    "ouananiches": [
        "ouananiche"
    ],
    "ouaouaron": [
        "ouaouaron"
    ],
    "ouata": [
        "ouater"
    ],
    "ouatant": [
        "ouater"
    ],
    "ouate": [
        "ouater",
        "ouate"
    ],
    "ouates": [
        "ouater",
        "ouate"
    ],
    "ouateuse": [
        "ouateux"
    ],
    "ouateux": [
        "ouateux"
    ],
    "ouatiner": [
        "ouatiner"
    ],
    "ouatine": [
        "ouatiner"
    ],
    "ouatinee": [
        "ouatiner"
    ],
    "ouatinees": [
        "ouatiner"
    ],
    "ouatee": [
        "ouate",
        "ouater"
    ],
    "ouatees": [
        "ouate",
        "ouater"
    ],
    "oubli": [
        "oubli"
    ],
    "oublia": [
        "oublier"
    ],
    "oubliable": [
        "oubliable"
    ],
    "oubliai": [
        "oublier"
    ],
    "oubliaient": [
        "oublier"
    ],
    "oubliais": [
        "oublier"
    ],
    "oubliait": [
        "oublier"
    ],
    "oubliant": [
        "oublier"
    ],
    "oublias": [
        "oublier"
    ],
    "oubliasse": [
        "oublier"
    ],
    "oublie": [
        "oublie",
        "oublier"
    ],
    "oublient": [
        "oublier"
    ],
    "oublier": [
        "oublier"
    ],
    "oubliera": [
        "oublier"
    ],
    "oublierai": [
        "oublier"
    ],
    "oublieraient": [
        "oublier"
    ],
    "oublierais": [
        "oublier"
    ],
    "oublierait": [
        "oublier"
    ],
    "oublieras": [
        "oublier"
    ],
    "oublierez": [
        "oublier"
    ],
    "oublierions": [
        "oublier"
    ],
    "oublierons": [
        "oublier"
    ],
    "oublieront": [
        "oublier"
    ],
    "oublies": [
        "oublie",
        "oubli",
        "oublier"
    ],
    "oubliette": [
        "oubliette"
    ],
    "oubliettes": [
        "oubliette"
    ],
    "oublieuse": [
        "oublieux"
    ],
    "oublieuses": [
        "oublieux"
    ],
    "oublieux": [
        "oublieux"
    ],
    "oubliez": [
        "oublier"
    ],
    "oubliiez": [
        "oublier"
    ],
    "oubliions": [
        "oublier"
    ],
    "oublions": [
        "oublier"
    ],
    "oublis": [
        "oubli"
    ],
    "oubliames": [
        "oublier"
    ],
    "oubliat": [
        "oublier"
    ],
    "oublierent": [
        "oublier"
    ],
    "oubliee": [
        "oublie",
        "oublier"
    ],
    "oubliees": [
        "oublie",
        "oublier"
    ],
    "ouche": [
        "ouche"
    ],
    "oued": [
        "oued"
    ],
    "oueds": [
        "oued"
    ],
    "ouest": [
        "ouest"
    ],
    "ouf": [
        "ouf"
    ],
    "ougandais": [
        "ougandais"
    ],
    "ougandaise": [
        "ougandais"
    ],
    "ouh": [
        "ouh"
    ],
    "oui": [
        "oui",
        "ouir"
    ],
    "ouiche": [
        "ouiche"
    ],
    "ouighour": [
        "ouighour"
    ],
    "ouighours": [
        "ouighour"
    ],
    "ouille": [
        "ouille",
        "ouiller"
    ],
    "ouistiti": [
        "ouistiti"
    ],
    "ouistitis": [
        "ouistiti"
    ],
    "oukases": [
        "oukase"
    ],
    "oulema": [
        "oulema"
    ],
    "oulemas": [
        "oulema"
    ],
    "ounce": [
        "ounce"
    ],
    "ouragan": [
        "ouragan"
    ],
    "ouragans": [
        "ouragan"
    ],
    "ouralienne": [
        "ouralien"
    ],
    "ouraniennes": [
        "ouranien"
    ],
    "ourdi": [
        "ourdir"
    ],
    "ourdie": [
        "ourdir"
    ],
    "ourdies": [
        "ourdir"
    ],
    "ourdir": [
        "ourdir"
    ],
    "ourdira": [
        "ourdir"
    ],
    "ourdis": [
        "ourdir"
    ],
    "ourdissage": [
        "ourdissage"
    ],
    "ourdissait": [
        "ourdir"
    ],
    "ourdissant": [
        "ourdir"
    ],
    "ourdissent": [
        "ourdir"
    ],
    "ourdisseur": [
        "ourdisseur"
    ],
    "ourdisseurs": [
        "ourdisseur"
    ],
    "ourdisseuses": [
        "ourdisseur"
    ],
    "ourdissoir": [
        "ourdissoir"
    ],
    "ourdit": [
        "ourdir"
    ],
    "ourdou": [
        "ourdou"
    ],
    "ourlaient": [
        "ourler"
    ],
    "ourlait": [
        "ourler"
    ],
    "ourlant": [
        "ourler"
    ],
    "ourle": [
        "ourler"
    ],
    "ourlent": [
        "ourler"
    ],
    "ourler": [
        "ourler"
    ],
    "ourlet": [
        "ourlet"
    ],
    "ourlets": [
        "ourlet"
    ],
    "ourlee": [
        "ourler"
    ],
    "ourlees": [
        "ourler"
    ],
    "ourles": [
        "ourler"
    ],
    "ouroboros": [
        "ouroboros"
    ],
    "ours": [
        "ours"
    ],
    "ourse": [
        "ours"
    ],
    "ourses": [
        "ours"
    ],
    "oursin": [
        "oursin"
    ],
    "oursins": [
        "oursin"
    ],
    "ourson": [
        "ourson"
    ],
    "oursonne": [
        "ourson"
    ],
    "oursonnes": [
        "ourson"
    ],
    "oursons": [
        "ourson"
    ],
    "ousque": [
        "ousque"
    ],
    "oust": [
        "oust"
    ],
    "oustachi": [
        "oustachi"
    ],
    "oustachis": [
        "oustachi"
    ],
    "ouste": [
        "ouste"
    ],
    "out": [
        "out"
    ],
    "outarde": [
        "outarde"
    ],
    "outardes": [
        "outarde"
    ],
    "outil": [
        "outil"
    ],
    "outillage": [
        "outillage"
    ],
    "outillages": [
        "outillage"
    ],
    "outiller": [
        "outiller"
    ],
    "outilleur": [
        "outilleur"
    ],
    "outille": [
        "outiller",
        "outille"
    ],
    "outillee": [
        "outille"
    ],
    "outillees": [
        "outiller",
        "outille"
    ],
    "outilles": [
        "outiller",
        "outille"
    ],
    "outils": [
        "outil"
    ],
    "outlaw": [
        "outlaw"
    ],
    "outlaws": [
        "outlaw"
    ],
    "outrage": [
        "outrager",
        "outrage"
    ],
    "outrageant": [
        "outrager",
        "outrageant"
    ],
    "outrageante": [
        "outrageant"
    ],
    "outrageantes": [
        "outrageant"
    ],
    "outrageants": [
        "outrageant"
    ],
    "outragent": [
        "outrager"
    ],
    "outrager": [
        "outrager"
    ],
    "outragerais": [
        "outrager"
    ],
    "outrages": [
        "outrager",
        "outrage"
    ],
    "outrageuse": [
        "outrageux"
    ],
    "outrageusement": [
        "outrageusement"
    ],
    "outrageuses": [
        "outrageux"
    ],
    "outrageux": [
        "outrageux"
    ],
    "outragez": [
        "outrager"
    ],
    "outragerent": [
        "outrager"
    ],
    "outragee": [
        "outrager"
    ],
    "outragees": [
        "outrager"
    ],
    "outrait": [
        "outrer"
    ],
    "outrance": [
        "outrance"
    ],
    "outrances": [
        "outrance"
    ],
    "outrancier": [
        "outrancier"
    ],
    "outranciere": [
        "outrancier"
    ],
    "outrancieres": [
        "outrancier"
    ],
    "outrant": [
        "outrer"
    ],
    "outre": [
        "outre",
        "outrer"
    ],
    "outrecuidance": [
        "outrecuidance"
    ],
    "outrecuidant": [
        "outrecuidant"
    ],
    "outrecuidante": [
        "outrecuidant"
    ],
    "outrecuidantes": [
        "outrecuidant"
    ],
    "outrecuidants": [
        "outrecuidant"
    ],
    "outremer": [
        "outremer"
    ],
    "outrepassa": [
        "outrepasser"
    ],
    "outrepassaient": [
        "outrepasser"
    ],
    "outrepassait": [
        "outrepasser"
    ],
    "outrepassant": [
        "outrepasser"
    ],
    "outrepasse": [
        "outrepasser"
    ],
    "outrepassent": [
        "outrepasser"
    ],
    "outrepasser": [
        "outrepasser"
    ],
    "outrepasserai": [
        "outrepasser"
    ],
    "outrepasses": [
        "outrepasser"
    ],
    "outrepassez": [
        "outrepasser"
    ],
    "outrer": [
        "outrer"
    ],
    "outres": [
        "outre",
        "outrer"
    ],
    "outrigger": [
        "outrigger"
    ],
    "outree": [
        "outrer",
        "outre"
    ],
    "outrees": [
        "outrer",
        "outre"
    ],
    "outsider": [
        "outsider"
    ],
    "outsiders": [
        "outsider"
    ],
    "ouvert": [
        "ouvrir",
        "ouvert"
    ],
    "ouverte": [
        "ouvrir",
        "ouvert"
    ],
    "ouvertement": [
        "ouvertement"
    ],
    "ouvertes": [
        "ouvrir",
        "ouvert"
    ],
    "ouverts": [
        "ouvrir",
        "ouvert"
    ],
    "ouverture": [
        "ouverture"
    ],
    "ouvertures": [
        "ouverture"
    ],
    "ouvrable": [
        "ouvrable"
    ],
    "ouvrables": [
        "ouvrable"
    ],
    "ouvrage": [
        "ouvrager",
        "ouvrage"
    ],
    "ouvrageant": [
        "ouvrager"
    ],
    "ouvrager": [
        "ouvrager"
    ],
    "ouvrages": [
        "ouvrage"
    ],
    "ouvragee": [
        "ouvrager",
        "ouvrage"
    ],
    "ouvragees": [
        "ouvrager",
        "ouvrage"
    ],
    "ouvraient": [
        "ouvrir"
    ],
    "ouvrais": [
        "ouvrir"
    ],
    "ouvrait": [
        "ouvrir"
    ],
    "ouvrant": [
        "ouvrant",
        "ouvrir"
    ],
    "ouvrants": [
        "ouvrant"
    ],
    "ouvre": [
        "ouvrir",
        "ouvre",
        "ouvrer"
    ],
    "ouvrent": [
        "ouvrir"
    ],
    "ouvrer": [
        "ouvrer"
    ],
    "ouvres": [
        "ouvrir",
        "ouvre"
    ],
    "ouvreur": [
        "ouvreur"
    ],
    "ouvreurs": [
        "ouvreur"
    ],
    "ouvreuse": [
        "ouvreur"
    ],
    "ouvreuses": [
        "ouvreur"
    ],
    "ouvrez": [
        "ouvrir"
    ],
    "ouvrier": [
        "ouvrier"
    ],
    "ouvriers": [
        "ouvrier"
    ],
    "ouvriez": [
        "ouvrir"
    ],
    "ouvrions": [
        "ouvrir"
    ],
    "ouvrir": [
        "ouvrir"
    ],
    "ouvrira": [
        "ouvrir"
    ],
    "ouvrirai": [
        "ouvrir"
    ],
    "ouvriraient": [
        "ouvrir"
    ],
    "ouvrirais": [
        "ouvrir"
    ],
    "ouvrirait": [
        "ouvrir"
    ],
    "ouvriras": [
        "ouvrir"
    ],
    "ouvrirent": [
        "ouvrir"
    ],
    "ouvrirez": [
        "ouvrir"
    ],
    "ouvririez": [
        "ouvrir"
    ],
    "ouvririons": [
        "ouvrir"
    ],
    "ouvrirons": [
        "ouvrir"
    ],
    "ouvriront": [
        "ouvrir"
    ],
    "ouvris": [
        "ouvrir"
    ],
    "ouvrissent": [
        "ouvrir"
    ],
    "ouvrit": [
        "ouvrir"
    ],
    "ouvriere": [
        "ouvrier"
    ],
    "ouvrieres": [
        "ouvrier"
    ],
    "ouvrierisme": [
        "ouvrierisme"
    ],
    "ouvrieriste": [
        "ouvrieriste"
    ],
    "ouvroir": [
        "ouvroir"
    ],
    "ouvroirs": [
        "ouvroir"
    ],
    "ouvrons": [
        "ouvrir"
    ],
    "ouvrees": [
        "ouvre"
    ],
    "ouvrimes": [
        "ouvrir"
    ],
    "ouzbeks": [
        "ouzbek"
    ],
    "ouzo": [
        "ouzo"
    ],
    "ouzos": [
        "ouzo"
    ],
    "ouie": [
        "ouie",
        "ouir"
    ],
    "ouies": [
        "ouie"
    ],
    "ouigour": [
        "ouigour"
    ],
    "ouir": [
        "ouir"
    ],
    "ouirais": [
        "ouir"
    ],
    "ouis": [
        "ouir"
    ],
    "ouit": [
        "ouir"
    ],
    "ovaire": [
        "ovaire"
    ],
    "ovaires": [
        "ovaire"
    ],
    "ovalaire": [
        "ovalaire"
    ],
    "ovale": [
        "ovale"
    ],
    "ovales": [
        "ovale"
    ],
    "ovalisees": [
        "ovaliser"
    ],
    "ovariectomie": [
        "ovariectomie"
    ],
    "ovarien": [
        "ovarien"
    ],
    "ovarienne": [
        "ovarien"
    ],
    "ovariotomie": [
        "ovariotomie"
    ],
    "ovation": [
        "ovation"
    ],
    "ovationnaient": [
        "ovationner"
    ],
    "ovationner": [
        "ovationner"
    ],
    "ovationne": [
        "ovationner"
    ],
    "ovationnes": [
        "ovationner"
    ],
    "ovations": [
        "ovation"
    ],
    "ove": [
        "ove"
    ],
    "overdose": [
        "overdose"
    ],
    "overdoses": [
        "overdose"
    ],
    "overdrive": [
        "overdrive"
    ],
    "ovibos": [
        "ovibos"
    ],
    "ovin": [
        "ovin"
    ],
    "ovins": [
        "ovin"
    ],
    "ovipare": [
        "ovipare"
    ],
    "ovipares": [
        "ovipare"
    ],
    "ovni": [
        "ovni"
    ],
    "ovnis": [
        "ovni"
    ],
    "ovocyte": [
        "ovocyte"
    ],
    "ovocytes": [
        "ovocyte"
    ],
    "ovoidal": [
        "ovoidal"
    ],
    "ovoidale": [
        "ovoidal"
    ],
    "ovoide": [
        "ovoide"
    ],
    "ovoides": [
        "ovoide"
    ],
    "ovulaire": [
        "ovulaire"
    ],
    "ovulation": [
        "ovulation"
    ],
    "ovule": [
        "ovuler",
        "ovule"
    ],
    "ovuler": [
        "ovuler"
    ],
    "ovules": [
        "ovuler",
        "ovule"
    ],
    "ovee": [
        "ove"
    ],
    "oxalate": [
        "oxalate"
    ],
    "oxer": [
        "ox",
        "oxer"
    ],
    "oxfordien": [
        "oxfordien"
    ],
    "oxfordiennes": [
        "oxfordien"
    ],
    "oxfords": [
        "oxford"
    ],
    "oxhydrique": [
        "oxhydrique"
    ],
    "oxo": [
        "oxo"
    ],
    "oxonienne": [
        "oxonien"
    ],
    "oxychlorure": [
        "oxychlorure"
    ],
    "oxydant": [
        "oxydant"
    ],
    "oxydants": [
        "oxydant"
    ],
    "oxydation": [
        "oxydation"
    ],
    "oxyde": [
        "oxyder",
        "oxyde"
    ],
    "oxyder": [
        "oxyder"
    ],
    "oxydes": [
        "oxyde"
    ],
    "oxydee": [
        "oxyder"
    ],
    "oxydees": [
        "oxyder"
    ],
    "oxygene": [
        "oxygene",
        "oxygener"
    ],
    "oxygenent": [
        "oxygener"
    ],
    "oxygenation": [
        "oxygenation"
    ],
    "oxygener": [
        "oxygener"
    ],
    "oxygenee": [
        "oxygene",
        "oxygener"
    ],
    "oxygenees": [
        "oxygene"
    ],
    "oxygenes": [
        "oxygene"
    ],
    "oxymore": [
        "oxymore"
    ],
    "oxymores": [
        "oxymore"
    ],
    "oxymoron": [
        "oxymoron"
    ],
    "oxymetrie": [
        "oxymetrie"
    ],
    "oyant": [
        "ouir",
        "oyant"
    ],
    "oyat": [
        "oyat"
    ],
    "oyats": [
        "oyat"
    ],
    "oye": [
        "oye"
    ],
    "oyez": [
        "ouir"
    ],
    "oyons": [
        "ouir"
    ],
    "ozone": [
        "ozone"
    ],
    "oil": [
        "oil"
    ],
    "p.": [
        "p."
    ],
    "p.m.": [
        "p.m."
    ],
    "pa": [
        "pa"
    ],
    "pacage": [
        "pacage"
    ],
    "pacages": [
        "pacage"
    ],
    "pacas": [
        "paca"
    ],
    "pacemaker": [
        "pacemaker"
    ],
    "pacemakers": [
        "pacemaker"
    ],
    "pacha": [
        "pacha"
    ],
    "pachas": [
        "pacha"
    ],
    "pachinko": [
        "pachinko"
    ],
    "pachon": [
        "pachon"
    ],
    "pachyderme": [
        "pachyderme"
    ],
    "pachydermes": [
        "pachyderme"
    ],
    "pachydermique": [
        "pachydermique"
    ],
    "pachydermiques": [
        "pachydermique"
    ],
    "pacifiait": [
        "pacifier"
    ],
    "pacifiant": [
        "pacifier"
    ],
    "pacifiante": [
        "pacifiant"
    ],
    "pacifiantes": [
        "pacifiant"
    ],
    "pacificateur": [
        "pacificateur"
    ],
    "pacificateurs": [
        "pacificateur"
    ],
    "pacification": [
        "pacification"
    ],
    "pacificatrice": [
        "pacificateur"
    ],
    "pacifie": [
        "pacifier"
    ],
    "pacifier": [
        "pacifier"
    ],
    "pacifique": [
        "pacifique"
    ],
    "pacifiquement": [
        "pacifiquement"
    ],
    "pacifiques": [
        "pacifique"
    ],
    "pacifisme": [
        "pacifisme"
    ],
    "pacifiste": [
        "pacifiste"
    ],
    "pacifistes": [
        "pacifiste"
    ],
    "pacifiee": [
        "pacifier"
    ],
    "pacifiees": [
        "pacifier"
    ],
    "pacifies": [
        "pacifier"
    ],
    "pack": [
        "pack"
    ],
    "package": [
        "package"
    ],
    "packaging": [
        "package",
        "packaging"
    ],
    "packs": [
        "pack"
    ],
    "packson": [
        "packson"
    ],
    "pacotille": [
        "pacotille"
    ],
    "pacotilles": [
        "pacotille"
    ],
    "pacs": [
        "pacs"
    ],
    "pacsif": [
        "pacsif"
    ],
    "pacsifs": [
        "pacsif"
    ],
    "pacson": [
        "pacson"
    ],
    "pacsons": [
        "pacson"
    ],
    "pacses": [
        "pacser"
    ],
    "pacte": [
        "pacte"
    ],
    "pactes": [
        "pacte"
    ],
    "pactisaient": [
        "pactiser"
    ],
    "pactisait": [
        "pactiser"
    ],
    "pactisant": [
        "pactiser"
    ],
    "pactise": [
        "pactiser"
    ],
    "pactiser": [
        "pactiser"
    ],
    "pactiseras": [
        "pactiser"
    ],
    "pactiseurs": [
        "pactiseur"
    ],
    "pactisez": [
        "pactiser"
    ],
    "pactisions": [
        "pactiser"
    ],
    "pactole": [
        "pactole"
    ],
    "pactoles": [
        "pactole"
    ],
    "pad": [
        "pad"
    ],
    "paddock": [
        "paddock"
    ],
    "paddocker": [
        "paddocker"
    ],
    "paddocks": [
        "paddock"
    ],
    "paddy": [
        "paddy"
    ],
    "padouanes": [
        "padouan"
    ],
    "paella": [
        "paella"
    ],
    "paellas": [
        "paella"
    ],
    "paf": [
        "paf"
    ],
    "pagaie": [
        "pagayer",
        "pagaie"
    ],
    "pagaient": [
        "pagayer"
    ],
    "pagaiera": [
        "pagayer"
    ],
    "pagaies": [
        "pagayer",
        "pagaie"
    ],
    "pagaille": [
        "pagaille"
    ],
    "pagailles": [
        "pagaille"
    ],
    "pagailleux": [
        "pagailleux"
    ],
    "paganisme": [
        "paganisme"
    ],
    "pagaya": [
        "pagayer"
    ],
    "pagayait": [
        "pagayer"
    ],
    "pagayant": [
        "pagayer"
    ],
    "pagaye": [
        "pagaye",
        "pagayer"
    ],
    "pagayer": [
        "pagayer"
    ],
    "pagayeur": [
        "pagayeur"
    ],
    "pagayeurs": [
        "pagayeur"
    ],
    "pagayez": [
        "pagayer"
    ],
    "pagayerent": [
        "pagayer"
    ],
    "page": [
        "pager",
        "page"
    ],
    "pageais": [
        "pager"
    ],
    "pageait": [
        "pager"
    ],
    "pageant": [
        "pager"
    ],
    "pagels": [
        "pagel"
    ],
    "pageot": [
        "pageot"
    ],
    "pageots": [
        "pageot"
    ],
    "pager": [
        "pager"
    ],
    "pages": [
        "pager",
        "page"
    ],
    "pagination": [
        "pagination"
    ],
    "paginer": [
        "paginer"
    ],
    "pagne": [
        "pagne"
    ],
    "pagnes": [
        "pagne"
    ],
    "pagnon": [
        "pagnon"
    ],
    "pagnote": [
        "pagnoter"
    ],
    "pagnoter": [
        "pagnoter"
    ],
    "pagode": [
        "pagode"
    ],
    "pagodes": [
        "pagode"
    ],
    "pagodon": [
        "pagodon"
    ],
    "pagure": [
        "pagure"
    ],
    "pagures": [
        "pagure"
    ],
    "pagus": [
        "pagus"
    ],
    "pagee": [
        "pager"
    ],
    "paie": [
        "payer",
        "paie"
    ],
    "paiement": [
        "paiement"
    ],
    "paiements": [
        "paiement"
    ],
    "paient": [
        "payer"
    ],
    "paiera": [
        "payer"
    ],
    "paierai": [
        "payer"
    ],
    "paieraient": [
        "payer"
    ],
    "paierais": [
        "payer"
    ],
    "paierait": [
        "payer"
    ],
    "paieras": [
        "payer"
    ],
    "paierez": [
        "payer"
    ],
    "paierie": [
        "paierie"
    ],
    "paieriez": [
        "payer"
    ],
    "paierions": [
        "payer"
    ],
    "paierons": [
        "payer"
    ],
    "paieront": [
        "payer"
    ],
    "paies": [
        "payer",
        "paie"
    ],
    "paillard": [
        "paillard"
    ],
    "paillardait": [
        "paillarder"
    ],
    "paillarde": [
        "paillard"
    ],
    "paillardement": [
        "paillardement"
    ],
    "paillardes": [
        "paillard"
    ],
    "paillardise": [
        "paillardise"
    ],
    "paillards": [
        "paillard"
    ],
    "paillasse": [
        "paillasse"
    ],
    "paillasses": [
        "paillasse"
    ],
    "paillasson": [
        "paillasson"
    ],
    "paillassons": [
        "paillasson"
    ],
    "paille": [
        "paille"
    ],
    "pailler": [
        "pailler"
    ],
    "pailles": [
        "paille"
    ],
    "pailleter": [
        "pailleter"
    ],
    "paillette": [
        "paillette",
        "pailleter"
    ],
    "paillettes": [
        "paillette",
        "pailleter"
    ],
    "paillete": [
        "paillete",
        "pailleter"
    ],
    "pailletee": [
        "paillete",
        "pailleter"
    ],
    "pailletees": [
        "paillete",
        "pailleter"
    ],
    "pailletes": [
        "paillete",
        "pailleter"
    ],
    "pailleux": [
        "pailleux"
    ],
    "paillis": [
        "paillis"
    ],
    "paillon": [
        "paillon"
    ],
    "paillons": [
        "paillon"
    ],
    "paillot": [
        "paillot"
    ],
    "paillote": [
        "paillote"
    ],
    "paillotes": [
        "paillote"
    ],
    "paillu": [
        "paillu"
    ],
    "paillee": [
        "paille",
        "pailler"
    ],
    "paillees": [
        "paille",
        "pailler"
    ],
    "paimpolaise": [
        "paimpolais"
    ],
    "paimpolaises": [
        "paimpolais"
    ],
    "pain": [
        "pain"
    ],
    "pains": [
        "pain"
    ],
    "pair": [
        "pair"
    ],
    "paire": [
        "paire",
        "pair"
    ],
    "paires": [
        "paire",
        "pair"
    ],
    "pairesses": [
        "pairesse"
    ],
    "pairie": [
        "pairie"
    ],
    "pairs": [
        "pair"
    ],
    "pais": [
        "paitre"
    ],
    "paisible": [
        "paisible"
    ],
    "paisiblement": [
        "paisiblement"
    ],
    "paisibles": [
        "paisible"
    ],
    "paissaient": [
        "paitre"
    ],
    "paissait": [
        "paitre"
    ],
    "paissant": [
        "paitre"
    ],
    "paissent": [
        "paitre"
    ],
    "paiute": [
        "paiute"
    ],
    "paiutes": [
        "paiute"
    ],
    "paix": [
        "paix"
    ],
    "pakistanais": [
        "pakistanais"
    ],
    "pakistanaise": [
        "pakistanais"
    ],
    "pakistanaises": [
        "pakistanais"
    ],
    "pakistano": [
        "pakistano"
    ],
    "pal": [
        "pal"
    ],
    "palabra": [
        "palabrer"
    ],
    "palabraient": [
        "palabrer"
    ],
    "palabrait": [
        "palabrer"
    ],
    "palabrant": [
        "palabrer"
    ],
    "palabre": [
        "palabrer",
        "palabre"
    ],
    "palabrent": [
        "palabrer"
    ],
    "palabrer": [
        "palabrer"
    ],
    "palabres": [
        "palabre"
    ],
    "palabreur": [
        "palabreur"
    ],
    "palabreurs": [
        "palabreur"
    ],
    "palace": [
        "palace"
    ],
    "palaces": [
        "palace"
    ],
    "paladin": [
        "paladin"
    ],
    "paladins": [
        "paladin"
    ],
    "palais": [
        "palais"
    ],
    "palan": [
        "palan"
    ],
    "palanche": [
        "palanche"
    ],
    "palanches": [
        "palanche"
    ],
    "palangrotte": [
        "palangrotte"
    ],
    "palanquer": [
        "palanquer"
    ],
    "palanquin": [
        "palanquin"
    ],
    "palanquins": [
        "palanquin"
    ],
    "palanquee": [
        "palanquer"
    ],
    "palanquees": [
        "palanquer"
    ],
    "palans": [
        "palan"
    ],
    "palastre": [
        "palastre"
    ],
    "palatales": [
        "palatal"
    ],
    "palatin": [
        "palatin"
    ],
    "palatine": [
        "palatin"
    ],
    "palatines": [
        "palatine"
    ],
    "palatisation": [
        "palatisation"
    ],
    "palazzo": [
        "palazzo"
    ],
    "pale": [
        "pale"
    ],
    "palefrenier": [
        "palefrenier"
    ],
    "palefreniers": [
        "palefrenier"
    ],
    "palefreniere": [
        "palefrenier"
    ],
    "palefroi": [
        "palefroi"
    ],
    "palefrois": [
        "palefroi"
    ],
    "paleron": [
        "paleron"
    ],
    "pales": [
        "pale"
    ],
    "palestinien": [
        "palestinien"
    ],
    "palestinienne": [
        "palestinien"
    ],
    "palestiniens": [
        "palestinien"
    ],
    "palestre": [
        "palestre"
    ],
    "palestres": [
        "palestre"
    ],
    "palet": [
        "palet"
    ],
    "paletot": [
        "paletot"
    ],
    "paletots": [
        "paletot"
    ],
    "palets": [
        "palet"
    ],
    "palette": [
        "palette"
    ],
    "palettes": [
        "palette"
    ],
    "palier": [
        "palier"
    ],
    "paliers": [
        "palier"
    ],
    "palikare": [
        "palikare"
    ],
    "palikares": [
        "palikare"
    ],
    "palilalie": [
        "palilalie"
    ],
    "palimpseste": [
        "palimpseste"
    ],
    "palindrome": [
        "palindrome"
    ],
    "palindromes": [
        "palindrome"
    ],
    "palinodie": [
        "palinodie"
    ],
    "palinodier": [
        "palinodier"
    ],
    "palinodies": [
        "palinodie"
    ],
    "palis": [
        "palis",
        "palir"
    ],
    "palissade": [
        "palissade",
        "palissader"
    ],
    "palissades": [
        "palissade",
        "palissader"
    ],
    "palissadee": [
        "palissader"
    ],
    "palissandre": [
        "palissandre"
    ],
    "palissant": [
        "palir",
        "palissant",
        "palisser"
    ],
    "palissonnage": [
        "palissonnage"
    ],
    "paliere": [
        "palier"
    ],
    "palladiennes": [
        "palladien"
    ],
    "palladium": [
        "palladium"
    ],
    "palle": [
        "palle"
    ],
    "palliait": [
        "pallier"
    ],
    "palliatif": [
        "palliatif"
    ],
    "palliatifs": [
        "palliatif"
    ],
    "pallient": [
        "pallier"
    ],
    "pallier": [
        "pallier"
    ],
    "palliera": [
        "pallier"
    ],
    "pallie": [
        "pallier"
    ],
    "palmaient": [
        "palmer"
    ],
    "palmaire": [
        "palmaire"
    ],
    "palmares": [
        "palmares"
    ],
    "palmas": [
        "palma"
    ],
    "palme": [
        "palmer",
        "palme"
    ],
    "palmer": [
        "palmer"
    ],
    "palmeraie": [
        "palmeraie"
    ],
    "palmeraies": [
        "palmeraie"
    ],
    "palmes": [
        "palmer",
        "palme"
    ],
    "palmette": [
        "palmette"
    ],
    "palmettes": [
        "palmette"
    ],
    "palmier": [
        "palmier"
    ],
    "palmiers": [
        "palmier"
    ],
    "palmipede": [
        "palmipede"
    ],
    "palmipedes": [
        "palmipede"
    ],
    "palmiste": [
        "palmiste"
    ],
    "palmistes": [
        "palmiste"
    ],
    "palmure": [
        "palmure"
    ],
    "palmures": [
        "palmure"
    ],
    "palmee": [
        "palme"
    ],
    "palmees": [
        "palme",
        "palmer"
    ],
    "palombe": [
        "palombe"
    ],
    "palombes": [
        "palombe"
    ],
    "palonnier": [
        "palonnier"
    ],
    "palot": [
        "palot"
    ],
    "palots": [
        "palot"
    ],
    "palourde": [
        "palourde"
    ],
    "palourdes": [
        "palourde"
    ],
    "palpa": [
        "palper"
    ],
    "palpable": [
        "palpable"
    ],
    "palpables": [
        "palpable"
    ],
    "palpaient": [
        "palper"
    ],
    "palpais": [
        "palper"
    ],
    "palpait": [
        "palper"
    ],
    "palpant": [
        "palper"
    ],
    "palpation": [
        "palpation"
    ],
    "palpations": [
        "palpation"
    ],
    "palpe": [
        "palper",
        "palpe"
    ],
    "palpent": [
        "palper"
    ],
    "palper": [
        "palper"
    ],
    "palpera": [
        "palper"
    ],
    "palperai": [
        "palper"
    ],
    "palpes": [
        "palper"
    ],
    "palpeur": [
        "palpeur"
    ],
    "palpeurs": [
        "palpeur"
    ],
    "palpez": [
        "palper"
    ],
    "palpita": [
        "palpiter"
    ],
    "palpitaient": [
        "palpiter"
    ],
    "palpitait": [
        "palpiter"
    ],
    "palpitant": [
        "palpitant",
        "palpiter"
    ],
    "palpitante": [
        "palpitant"
    ],
    "palpitantes": [
        "palpitant"
    ],
    "palpitants": [
        "palpitant"
    ],
    "palpitation": [
        "palpitation"
    ],
    "palpitations": [
        "palpitation"
    ],
    "palpite": [
        "palpiter"
    ],
    "palpitement": [
        "palpitement"
    ],
    "palpitent": [
        "palpiter"
    ],
    "palpiter": [
        "palpiter"
    ],
    "palpiterait": [
        "palpiter"
    ],
    "palpites": [
        "palpiter"
    ],
    "palpiterent": [
        "palpiter"
    ],
    "palpons": [
        "palper"
    ],
    "palperent": [
        "palper"
    ],
    "palpees": [
        "palper"
    ],
    "pals": [
        "pal"
    ],
    "palsambleu": [
        "palsambleu"
    ],
    "paltoquet": [
        "paltoquet"
    ],
    "palu": [
        "palu"
    ],
    "paluchait": [
        "palucher"
    ],
    "paluche": [
        "paluche"
    ],
    "palucher": [
        "palucher"
    ],
    "paluches": [
        "paluche"
    ],
    "paludamentum": [
        "paludamentum"
    ],
    "paludes": [
        "palude"
    ],
    "paludiers": [
        "paludier"
    ],
    "paludiques": [
        "paludique"
    ],
    "paludisme": [
        "paludisme"
    ],
    "paludiere": [
        "paludiere"
    ],
    "paludeenne": [
        "paludeen"
    ],
    "paludeennes": [
        "paludeen"
    ],
    "paludeens": [
        "paludeen"
    ],
    "palus": [
        "palus"
    ],
    "palustre": [
        "palustre"
    ],
    "palynologie": [
        "palynologie"
    ],
    "paleo": [
        "paleo"
    ],
    "paleographie": [
        "paleographie"
    ],
    "paleolithique": [
        "paleolithique"
    ],
    "paleolithiques": [
        "paleolithique"
    ],
    "paleontologie": [
        "paleontologie"
    ],
    "paleontologiques": [
        "paleontologique"
    ],
    "paleontologiste": [
        "paleontologiste"
    ],
    "paleontologistes": [
        "paleontologiste"
    ],
    "paleontologue": [
        "paleontologue"
    ],
    "paleontologues": [
        "paleontologue"
    ],
    "paleozoique": [
        "paleozoique"
    ],
    "paletuvier": [
        "paletuvier"
    ],
    "paletuviers": [
        "paletuvier"
    ],
    "pampa": [
        "pampa"
    ],
    "pampas": [
        "pampa"
    ],
    "pampero": [
        "pampero"
    ],
    "pamphlet": [
        "pamphlet"
    ],
    "pamphlets": [
        "pamphlet"
    ],
    "pamphletaire": [
        "pamphletaire"
    ],
    "pamphletaires": [
        "pamphletaire"
    ],
    "pamplemousse": [
        "pamplemousse"
    ],
    "pamplemousses": [
        "pamplemousse"
    ],
    "pamplemoussier": [
        "pamplemoussier"
    ],
    "pamplemoussiers": [
        "pamplemoussier"
    ],
    "pampre": [
        "pampre"
    ],
    "pampres": [
        "pampre"
    ],
    "pan": [
        "pan"
    ],
    "pana": [
        "paner"
    ],
    "panachage": [
        "panachage"
    ],
    "panachait": [
        "panacher"
    ],
    "panache": [
        "panacher",
        "panache"
    ],
    "panacher": [
        "panacher"
    ],
    "panaches": [
        "panache"
    ],
    "panachee": [
        "panacher"
    ],
    "panacee": [
        "panacee"
    ],
    "panacees": [
        "panacee"
    ],
    "panade": [
        "panade"
    ],
    "panades": [
        "panade"
    ],
    "panais": [
        "panais"
    ],
    "panama": [
        "panama"
    ],
    "panamas": [
        "panama"
    ],
    "panamienne": [
        "panamien"
    ],
    "panamiens": [
        "panamien"
    ],
    "panameen": [
        "panameen"
    ],
    "panameenne": [
        "panameenne"
    ],
    "panamericain": [
        "panamericain"
    ],
    "panamericaine": [
        "panamericain"
    ],
    "panarabisme": [
        "panarabisme"
    ],
    "panard": [
        "panard"
    ],
    "panards": [
        "panard"
    ],
    "panaris": [
        "panaris"
    ],
    "panatella": [
        "panatella"
    ],
    "panathenaique": [
        "panathenaique"
    ],
    "panathenees": [
        "panathenees"
    ],
    "pancake": [
        "pancake"
    ],
    "pancakes": [
        "pancake"
    ],
    "pancarte": [
        "pancarte"
    ],
    "pancartes": [
        "pancarte"
    ],
    "panceltique": [
        "panceltique"
    ],
    "pancetta": [
        "pancetta"
    ],
    "panclastite": [
        "panclastite"
    ],
    "pancrace": [
        "pancrace"
    ],
    "pancraces": [
        "pancrace"
    ],
    "pancreas": [
        "pancreas"
    ],
    "pancreatectomie": [
        "pancreatectomie"
    ],
    "pancreatique": [
        "pancreatique"
    ],
    "pancreatiques": [
        "pancreatique"
    ],
    "pancreatite": [
        "pancreatite"
    ],
    "panda": [
        "panda"
    ],
    "pandanus": [
        "pandanus"
    ],
    "pandas": [
        "panda"
    ],
    "pandit": [
        "pandit"
    ],
    "pandore": [
        "pandore"
    ],
    "pandores": [
        "pandore"
    ],
    "pandemie": [
        "pandemie"
    ],
    "pandemonium": [
        "pandemonium"
    ],
    "pandemoniums": [
        "pandemonium"
    ],
    "pane": [
        "pane",
        "paner"
    ],
    "panel": [
        "panel"
    ],
    "paner": [
        "paner"
    ],
    "panetier": [
        "panetier"
    ],
    "panetiere": [
        "panetier"
    ],
    "panetieres": [
        "panetier"
    ],
    "pangermanisme": [
        "pangermanisme"
    ],
    "panic": [
        "panic"
    ],
    "panicules": [
        "panicule"
    ],
    "panier": [
        "panier"
    ],
    "paniers": [
        "panier"
    ],
    "panification": [
        "panification"
    ],
    "panini": [
        "panini"
    ],
    "paniqua": [
        "paniquer"
    ],
    "paniquaient": [
        "paniquer"
    ],
    "paniquais": [
        "paniquer"
    ],
    "paniquait": [
        "paniquer"
    ],
    "paniquant": [
        "paniquer",
        "paniquant"
    ],
    "paniquards": [
        "paniquard"
    ],
    "panique": [
        "panique",
        "paniquer"
    ],
    "paniquent": [
        "paniquer"
    ],
    "paniquer": [
        "paniquer"
    ],
    "paniquera": [
        "paniquer"
    ],
    "paniquerai": [
        "paniquer"
    ],
    "paniqueraient": [
        "paniquer"
    ],
    "paniquerais": [
        "paniquer"
    ],
    "paniqueras": [
        "paniquer"
    ],
    "paniqueront": [
        "paniquer"
    ],
    "paniques": [
        "panique",
        "paniquer"
    ],
    "paniquez": [
        "paniquer"
    ],
    "paniquons": [
        "paniquer"
    ],
    "paniquerent": [
        "paniquer"
    ],
    "paniquee": [
        "panique",
        "paniquer"
    ],
    "panis": [
        "panis"
    ],
    "paniere": [
        "paniere"
    ],
    "panieres": [
        "paniere"
    ],
    "panka": [
        "panka"
    ],
    "pankas": [
        "panka"
    ],
    "panna": [
        "panner"
    ],
    "pannais": [
        "panner"
    ],
    "pannait": [
        "panner"
    ],
    "panne": [
        "panne",
        "panner"
    ],
    "panneau": [
        "panneau"
    ],
    "panneaux": [
        "panneau"
    ],
    "panner": [
        "panner"
    ],
    "pannes": [
        "panne"
    ],
    "panneton": [
        "panneton"
    ],
    "pano": [
        "pano"
    ],
    "panonceau": [
        "panonceau"
    ],
    "panonceaux": [
        "panonceau"
    ],
    "panoplie": [
        "panoplie"
    ],
    "panoplies": [
        "panoplie"
    ],
    "panorama": [
        "panorama"
    ],
    "panoramas": [
        "panorama"
    ],
    "panoramique": [
        "panoramiquer",
        "panoramique"
    ],
    "panoramiquer": [
        "panoramiquer"
    ],
    "panoramiques": [
        "panoramique"
    ],
    "panos": [
        "pano"
    ],
    "panosse": [
        "panosse"
    ],
    "panouille": [
        "panouille"
    ],
    "panouilles": [
        "panouille"
    ],
    "pans": [
        "pan"
    ],
    "pansa": [
        "panser"
    ],
    "pansage": [
        "pansage"
    ],
    "pansait": [
        "panser"
    ],
    "pansant": [
        "panser"
    ],
    "pansas": [
        "panser"
    ],
    "panse": [
        "panse",
        "panser"
    ],
    "pansement": [
        "pansement"
    ],
    "pansements": [
        "pansement"
    ],
    "pansent": [
        "panser"
    ],
    "panser": [
        "panser"
    ],
    "panserai": [
        "panser"
    ],
    "panses": [
        "panse",
        "panser"
    ],
    "pansez": [
        "panser"
    ],
    "pansiez": [
        "panser"
    ],
    "pansions": [
        "panser"
    ],
    "panspermie": [
        "panspermie"
    ],
    "pansu": [
        "pansu"
    ],
    "pansue": [
        "pansu"
    ],
    "pansues": [
        "pansu"
    ],
    "pansus": [
        "pansu"
    ],
    "panserent": [
        "panser"
    ],
    "pansee": [
        "panser"
    ],
    "pansees": [
        "panser"
    ],
    "pantagruelique": [
        "pantagruelique"
    ],
    "pantagrueliques": [
        "pantagruelique"
    ],
    "pantalon": [
        "pantalon"
    ],
    "pantalonnade": [
        "pantalonnade"
    ],
    "pantalonnades": [
        "pantalonnade"
    ],
    "pantalons": [
        "pantalon"
    ],
    "pante": [
        "pante"
    ],
    "pantela": [
        "panteler"
    ],
    "pantelaient": [
        "panteler"
    ],
    "pantelait": [
        "panteler"
    ],
    "pantelant": [
        "pantelant",
        "panteler"
    ],
    "pantelante": [
        "pantelant"
    ],
    "pantelantes": [
        "pantelant"
    ],
    "pantelants": [
        "pantelant"
    ],
    "panteler": [
        "panteler"
    ],
    "pantelle": [
        "panteler"
    ],
    "pantele": [
        "panteler"
    ],
    "pantes": [
        "pante"
    ],
    "panthere": [
        "panthere"
    ],
    "pantheres": [
        "panthere"
    ],
    "pantheisme": [
        "pantheisme"
    ],
    "pantheiste": [
        "pantheiste"
    ],
    "pantheon": [
        "pantheon"
    ],
    "pantheons": [
        "pantheon"
    ],
    "pantin": [
        "pantin"
    ],
    "pantins": [
        "pantins",
        "pantin"
    ],
    "pantiere": [
        "pantiere"
    ],
    "pantocrator": [
        "pantocrator"
    ],
    "pantographe": [
        "pantographe"
    ],
    "pantographes": [
        "pantographe"
    ],
    "pantois": [
        "pantois"
    ],
    "pantoise": [
        "pantois"
    ],
    "pantoises": [
        "pantois"
    ],
    "pantomime": [
        "pantomime"
    ],
    "pantomimes": [
        "pantomime"
    ],
    "pantometres": [
        "pantometre"
    ],
    "pantouflard": [
        "pantouflard"
    ],
    "pantouflarde": [
        "pantouflard"
    ],
    "pantouflards": [
        "pantouflard"
    ],
    "pantoufle": [
        "pantoufler",
        "pantoufle"
    ],
    "pantoufler": [
        "pantoufler"
    ],
    "pantoufles": [
        "pantoufler",
        "pantoufle"
    ],
    "panty": [
        "panty"
    ],
    "panurge": [
        "panurge"
    ],
    "panurgisme": [
        "panurgisme"
    ],
    "panzer": [
        "panzer"
    ],
    "panzers": [
        "panzer"
    ],
    "panee": [
        "pane",
        "paner"
    ],
    "panees": [
        "pane",
        "paner"
    ],
    "panegyrique": [
        "panegyrique"
    ],
    "panegyriques": [
        "panegyrique"
    ],
    "panegyristes": [
        "panegyriste"
    ],
    "panes": [
        "pane",
        "paner"
    ],
    "paolistes": [
        "paoliste"
    ],
    "paolo": [
        "paolo"
    ],
    "paon": [
        "paon"
    ],
    "paonne": [
        "paon"
    ],
    "paons": [
        "paon"
    ],
    "papa": [
        "papa"
    ],
    "papable": [
        "papable"
    ],
    "papal": [
        "papal"
    ],
    "papale": [
        "papal"
    ],
    "papamobile": [
        "papamobile"
    ],
    "paparazzi": [
        "paparazzi"
    ],
    "paparazzis": [
        "paparazzi"
    ],
    "paparazzo": [
        "paparazzo"
    ],
    "papas": [
        "papas",
        "papa"
    ],
    "papaute": [
        "papaute"
    ],
    "papaux": [
        "papal"
    ],
    "papaver": [
        "papaver"
    ],
    "papaverine": [
        "papaverine"
    ],
    "papaye": [
        "papaye"
    ],
    "papayer": [
        "papayer"
    ],
    "papayers": [
        "papayer"
    ],
    "papayes": [
        "papaye"
    ],
    "pape": [
        "pape"
    ],
    "papegai": [
        "papegai"
    ],
    "papegais": [
        "papegai"
    ],
    "papelard": [
        "papelard"
    ],
    "papelarde": [
        "papelard"
    ],
    "papelards": [
        "papelard"
    ],
    "paperasse": [
        "paperasse"
    ],
    "paperasser": [
        "paperasser"
    ],
    "paperasserie": [
        "paperasserie"
    ],
    "paperasseries": [
        "paperasserie"
    ],
    "paperasses": [
        "paperasse"
    ],
    "paperassier": [
        "paperassier"
    ],
    "papes": [
        "pape"
    ],
    "papesse": [
        "papesse"
    ],
    "papet": [
        "papet"
    ],
    "papeterie": [
        "papeterie"
    ],
    "papeteries": [
        "papeterie"
    ],
    "papetier": [
        "papetier"
    ],
    "papetiers": [
        "papetier"
    ],
    "papi": [
        "papi"
    ],
    "papier": [
        "papier"
    ],
    "papiers": [
        "papier"
    ],
    "papilionace": [
        "papilionace"
    ],
    "papilionacee": [
        "papilionace"
    ],
    "papilionacees": [
        "papilionace"
    ],
    "papillaire": [
        "papillaire"
    ],
    "papille": [
        "papille"
    ],
    "papilles": [
        "papille"
    ],
    "papillomavirus": [
        "papillomavirus"
    ],
    "papillomes": [
        "papillome"
    ],
    "papillon": [
        "papillon"
    ],
    "papillonna": [
        "papillonner"
    ],
    "papillonnage": [
        "papillonnage"
    ],
    "papillonnaient": [
        "papillonner"
    ],
    "papillonnais": [
        "papillonner"
    ],
    "papillonnait": [
        "papillonner"
    ],
    "papillonnant": [
        "papillonnant"
    ],
    "papillonnante": [
        "papillonnant"
    ],
    "papillonne": [
        "papillonner"
    ],
    "papillonnement": [
        "papillonnement"
    ],
    "papillonnent": [
        "papillonner"
    ],
    "papillonner": [
        "papillonner"
    ],
    "papillonnes": [
        "papillonner"
    ],
    "papillons": [
        "papillon"
    ],
    "papillotaient": [
        "papilloter"
    ],
    "papillotait": [
        "papilloter"
    ],
    "papillotant": [
        "papillotant",
        "papilloter"
    ],
    "papillotantes": [
        "papillotant"
    ],
    "papillotants": [
        "papillotant"
    ],
    "papillote": [
        "papilloter",
        "papillote"
    ],
    "papillotent": [
        "papilloter"
    ],
    "papilloter": [
        "papilloter"
    ],
    "papillotes": [
        "papillote"
    ],
    "papilloterent": [
        "papilloter"
    ],
    "papis": [
        "papi"
    ],
    "papisme": [
        "papisme"
    ],
    "papiste": [
        "papiste"
    ],
    "papistes": [
        "papiste"
    ],
    "papotage": [
        "papotage"
    ],
    "papotages": [
        "papotage"
    ],
    "papotaient": [
        "papoter"
    ],
    "papotait": [
        "papoter"
    ],
    "papotant": [
        "papoter"
    ],
    "papote": [
        "papoter"
    ],
    "papotent": [
        "papoter"
    ],
    "papoter": [
        "papoter"
    ],
    "papotera": [
        "papoter"
    ],
    "papotez": [
        "papoter"
    ],
    "papoterent": [
        "papoter"
    ],
    "papou": [
        "papou"
    ],
    "papouille": [
        "papouille",
        "papouiller"
    ],
    "papouillent": [
        "papouiller"
    ],
    "papouiller": [
        "papouiller"
    ],
    "papouilles": [
        "papouille"
    ],
    "papouillez": [
        "papouiller"
    ],
    "papous": [
        "papou"
    ],
    "paprika": [
        "paprika"
    ],
    "papy": [
        "papy"
    ],
    "papyrus": [
        "papyrus"
    ],
    "papys": [
        "papy"
    ],
    "paqson": [
        "paqson"
    ],
    "paquebot": [
        "paquebot"
    ],
    "paquebots": [
        "paquebot"
    ],
    "paquet": [
        "paquet"
    ],
    "paqueta": [
        "paqueter"
    ],
    "paquetage": [
        "paquetage"
    ],
    "paquetages": [
        "paquetage"
    ],
    "paquets": [
        "paquet"
    ],
    "paquette": [
        "paqueter"
    ],
    "paquete": [
        "paquete"
    ],
    "par": [
        "par"
    ],
    "para": [
        "para",
        "parer"
    ],
    "parabellum": [
        "parabellum"
    ],
    "parabellums": [
        "parabellum"
    ],
    "parabole": [
        "parabole"
    ],
    "paraboles": [
        "parabole"
    ],
    "parabolique": [
        "parabolique"
    ],
    "paraboliquement": [
        "paraboliquement"
    ],
    "paraboliques": [
        "parabolique"
    ],
    "paraboloide": [
        "paraboloide"
    ],
    "parachevaient": [
        "parachever"
    ],
    "parachevait": [
        "parachever"
    ],
    "parachevant": [
        "parachever"
    ],
    "parachever": [
        "parachever"
    ],
    "paracheverent": [
        "parachever"
    ],
    "paracheve": [
        "parachever"
    ],
    "parachutage": [
        "parachutage"
    ],
    "parachutages": [
        "parachutage"
    ],
    "parachute": [
        "parachuter",
        "parachute"
    ],
    "parachutent": [
        "parachuter"
    ],
    "parachuter": [
        "parachuter"
    ],
    "parachuterais": [
        "parachuter"
    ],
    "parachuterons": [
        "parachuter"
    ],
    "parachutes": [
        "parachuter",
        "parachute"
    ],
    "parachutez": [
        "parachuter"
    ],
    "parachutisme": [
        "parachutisme"
    ],
    "parachutiste": [
        "parachutiste"
    ],
    "parachutistes": [
        "parachutiste"
    ],
    "parachuterent": [
        "parachuter"
    ],
    "parachutee": [
        "parachuter"
    ],
    "parachutees": [
        "parachuter"
    ],
    "parachevement": [
        "parachevement"
    ],
    "parachevent": [
        "parachever"
    ],
    "parachevera": [
        "parachever"
    ],
    "paracheveraient": [
        "parachever"
    ],
    "paraclet": [
        "paraclet"
    ],
    "paracetamol": [
        "paracetamol"
    ],
    "parada": [
        "parader"
    ],
    "paradaient": [
        "parader"
    ],
    "paradais": [
        "parader"
    ],
    "paradait": [
        "parader"
    ],
    "paradant": [
        "parader"
    ],
    "parade": [
        "parader",
        "parade"
    ],
    "paradent": [
        "parader"
    ],
    "parader": [
        "parader"
    ],
    "paradera": [
        "parader"
    ],
    "parades": [
        "parader",
        "parade"
    ],
    "paradeurs": [
        "paradeur"
    ],
    "paradigme": [
        "paradigme"
    ],
    "paradigmes": [
        "paradigme"
    ],
    "paradis": [
        "paradis"
    ],
    "paradisiaque": [
        "paradisiaque"
    ],
    "paradisiaques": [
        "paradisiaque"
    ],
    "paradisiers": [
        "paradisier"
    ],
    "paradons": [
        "parader"
    ],
    "parador": [
        "parador"
    ],
    "parados": [
        "parados"
    ],
    "paradoxal": [
        "paradoxal"
    ],
    "paradoxale": [
        "paradoxal"
    ],
    "paradoxalement": [
        "paradoxalement"
    ],
    "paradoxales": [
        "paradoxal"
    ],
    "paradoxaux": [
        "paradoxal"
    ],
    "paradoxe": [
        "paradoxe"
    ],
    "paradoxes": [
        "paradox",
        "paradoxe"
    ],
    "paradoxie": [
        "paradoxie"
    ],
    "paraderent": [
        "parader"
    ],
    "paradee": [
        "parader"
    ],
    "parafer": [
        "parafer"
    ],
    "paraffine": [
        "paraffine"
    ],
    "paraffinee": [
        "paraffine"
    ],
    "paraffines": [
        "paraffine"
    ],
    "parage": [
        "parage"
    ],
    "parages": [
        "parage"
    ],
    "paragouvernementales": [
        "paragouvernemental"
    ],
    "paragraphe": [
        "paragraphe"
    ],
    "paragraphes": [
        "paragraphe"
    ],
    "paraguayen": [
        "paraguayen"
    ],
    "paraguayenne": [
        "paraguayen"
    ],
    "paraguayennes": [
        "paraguayen"
    ],
    "paraguayens": [
        "paraguayen"
    ],
    "parai": [
        "parer"
    ],
    "paraient": [
        "parer"
    ],
    "parais": [
        "paraitre",
        "parer"
    ],
    "paraissaient": [
        "paraitre"
    ],
    "paraissais": [
        "paraitre"
    ],
    "paraissait": [
        "paraitre"
    ],
    "paraissant": [
        "paraitre"
    ],
    "paraisse": [
        "paraitre"
    ],
    "paraissent": [
        "paraitre"
    ],
    "paraissez": [
        "paraitre"
    ],
    "paraissiez": [
        "paraitre"
    ],
    "paraissions": [
        "paraitre"
    ],
    "paraissons": [
        "paraitre"
    ],
    "parait": [
        "paraitre",
        "parait",
        "parer"
    ],
    "parallaxe": [
        "parallaxe"
    ],
    "parallaxes": [
        "parallaxe"
    ],
    "parallele": [
        "parallele"
    ],
    "parallelement": [
        "parallelement"
    ],
    "paralleles": [
        "parallele"
    ],
    "parallelisme": [
        "parallelisme"
    ],
    "paralleliste": [
        "paralleliste"
    ],
    "parallelogramme": [
        "parallelogramme"
    ],
    "parallelepipede": [
        "parallelepipede"
    ],
    "parallelepipedes": [
        "parallelepipede"
    ],
    "parallelepipedique": [
        "parallelepipedique"
    ],
    "paralogismes": [
        "paralogisme"
    ],
    "paralympiques": [
        "paralympique"
    ],
    "paralysa": [
        "paralyser"
    ],
    "paralysaient": [
        "paralyser"
    ],
    "paralysais": [
        "paralyser"
    ],
    "paralysait": [
        "paralyser"
    ],
    "paralysant": [
        "paralysant",
        "paralyser"
    ],
    "paralysante": [
        "paralysant"
    ],
    "paralysantes": [
        "paralysant"
    ],
    "paralysants": [
        "paralysant"
    ],
    "paralyse": [
        "paralyser",
        "paralyse"
    ],
    "paralysent": [
        "paralyser"
    ],
    "paralyser": [
        "paralyser"
    ],
    "paralysera": [
        "paralyser"
    ],
    "paralyserait": [
        "paralyser"
    ],
    "paralyserez": [
        "paralyser"
    ],
    "paralysie": [
        "paralysie"
    ],
    "paralysies": [
        "paralysie"
    ],
    "paralysat": [
        "paralyser"
    ],
    "paralyserent": [
        "paralyser"
    ],
    "paralysee": [
        "paralyser",
        "paralyse"
    ],
    "paralysees": [
        "paralyser",
        "paralyse"
    ],
    "paralyses": [
        "paralyser",
        "paralysis",
        "paralyse"
    ],
    "paralytique": [
        "paralytique"
    ],
    "paralytiques": [
        "paralytique"
    ],
    "paramagnetique": [
        "paramagnetique"
    ],
    "paramilitaire": [
        "paramilitaire"
    ],
    "paramilitaires": [
        "paramilitaire"
    ],
    "paramnesie": [
        "paramnesie"
    ],
    "parametre": [
        "parametre"
    ],
    "parametres": [
        "parametre"
    ],
    "paramedical": [
        "paramedical"
    ],
    "paramedicale": [
        "paramedical"
    ],
    "paramedicaux": [
        "paramedical"
    ],
    "parametrique": [
        "parametrique"
    ],
    "parangon": [
        "parangon"
    ],
    "parangonnages": [
        "parangonnage"
    ],
    "parangons": [
        "parangon"
    ],
    "parano": [
        "parano"
    ],
    "paranormal": [
        "paranormal"
    ],
    "paranormale": [
        "paranormal"
    ],
    "paranormales": [
        "paranormal"
    ],
    "paranormaux": [
        "paranormal"
    ],
    "paranos": [
        "parano"
    ],
    "paranoia": [
        "paranoia"
    ],
    "paranoiaque": [
        "paranoiaque"
    ],
    "paranoiaques": [
        "paranoiaque"
    ],
    "paranoide": [
        "paranoide"
    ],
    "parant": [
        "parer"
    ],
    "paraneoplasique": [
        "paraneoplasique"
    ],
    "parapente": [
        "parapente"
    ],
    "parapet": [
        "parapet"
    ],
    "parapets": [
        "parapet"
    ],
    "paraphait": [
        "parapher"
    ],
    "paraphant": [
        "parapher"
    ],
    "parapharmacie": [
        "parapharmacie"
    ],
    "paraphe": [
        "parapher",
        "paraphe"
    ],
    "parapher": [
        "parapher"
    ],
    "paraphes": [
        "parapher",
        "paraphe"
    ],
    "parapheurs": [
        "parapheur"
    ],
    "paraphez": [
        "parapher"
    ],
    "paraphrasa": [
        "paraphraser"
    ],
    "paraphrasait": [
        "paraphraser"
    ],
    "paraphrasant": [
        "paraphraser"
    ],
    "paraphrase": [
        "paraphrase",
        "paraphraser"
    ],
    "paraphraser": [
        "paraphraser"
    ],
    "paraphrases": [
        "paraphrase",
        "paraphraser"
    ],
    "paraphee": [
        "parapher"
    ],
    "parapluie": [
        "parapluie"
    ],
    "parapluies": [
        "parapluie"
    ],
    "paraplegique": [
        "paraplegique"
    ],
    "paraplegiques": [
        "paraplegique"
    ],
    "parapsychique": [
        "parapsychique"
    ],
    "parapsychologie": [
        "parapsychologie"
    ],
    "parapsychologique": [
        "parapsychologique"
    ],
    "parapsychologiques": [
        "parapsychologique"
    ],
    "parapsychologue": [
        "parapsychologue"
    ],
    "parapsychologues": [
        "parapsychologue"
    ],
    "parareligieuse": [
        "parareligieux"
    ],
    "paras": [
        "para"
    ],
    "parascolaire": [
        "parascolaire"
    ],
    "parascolaires": [
        "parascolaire"
    ],
    "parasceve": [
        "parasceve"
    ],
    "parasitaire": [
        "parasitaire"
    ],
    "parasitaires": [
        "parasitaire"
    ],
    "parasitait": [
        "parasiter"
    ],
    "parasite": [
        "parasiter",
        "parasite"
    ],
    "parasitent": [
        "parasiter"
    ],
    "parasiter": [
        "parasiter"
    ],
    "parasites": [
        "parasiter",
        "parasite"
    ],
    "parasiticide": [
        "parasiticide"
    ],
    "parasitisme": [
        "parasitisme"
    ],
    "parasitologie": [
        "parasitologie"
    ],
    "parasitose": [
        "parasitose"
    ],
    "parasitee": [
        "parasiter"
    ],
    "parasol": [
        "parasol"
    ],
    "parasols": [
        "parasol"
    ],
    "parathyroidienne": [
        "parathyroidien"
    ],
    "paratonnerre": [
        "paratonnerre"
    ],
    "paratonnerres": [
        "paratonnerre"
    ],
    "paravent": [
        "paravent"
    ],
    "paravents": [
        "paravent"
    ],
    "paraitra": [
        "paraitre"
    ],
    "paraitrai": [
        "paraitre"
    ],
    "paraitraient": [
        "paraitre"
    ],
    "paraitrais": [
        "paraitre"
    ],
    "paraitrait": [
        "paraitre"
    ],
    "paraitras": [
        "paraitre"
    ],
    "paraitre": [
        "paraitre"
    ],
    "paraitrez": [
        "paraitre"
    ],
    "paraitront": [
        "paraitre"
    ],
    "parbleu": [
        "parbleu"
    ],
    "parc": [
        "parc"
    ],
    "parcage": [
        "parcage"
    ],
    "parce": [
        "parce"
    ],
    "parcellaire": [
        "parcellaire"
    ],
    "parcelle": [
        "parcelle"
    ],
    "parcelles": [
        "parcelle"
    ],
    "parchemin": [
        "parchemin"
    ],
    "parchemineuse": [
        "parchemineux"
    ],
    "parchemins": [
        "parchemin"
    ],
    "parchemine": [
        "parchemine",
        "parcheminer"
    ],
    "parcheminee": [
        "parchemine",
        "parcheminer"
    ],
    "parcheminees": [
        "parchemine",
        "parcheminer"
    ],
    "parchemines": [
        "parchemine"
    ],
    "parcimonie": [
        "parcimonie"
    ],
    "parcimonieuse": [
        "parcimonieux"
    ],
    "parcimonieusement": [
        "parcimonieusement"
    ],
    "parcimonieuses": [
        "parcimonieux"
    ],
    "parcimonieux": [
        "parcimonieux"
    ],
    "parcmetre": [
        "parcmetre"
    ],
    "parcmetres": [
        "parcmetre"
    ],
    "parcometre": [
        "parcometre"
    ],
    "parcouraient": [
        "parcourir"
    ],
    "parcourais": [
        "parcourir"
    ],
    "parcourait": [
        "parcourir"
    ],
    "parcourant": [
        "parcourir"
    ],
    "parcoure": [
        "parcourir"
    ],
    "parcourent": [
        "parcourir"
    ],
    "parcourez": [
        "parcourir"
    ],
    "parcouriez": [
        "parcourir"
    ],
    "parcourions": [
        "parcourir"
    ],
    "parcourir": [
        "parcourir"
    ],
    "parcourons": [
        "parcourir"
    ],
    "parcourra": [
        "parcourir"
    ],
    "parcourrai": [
        "parcourir"
    ],
    "parcourraient": [
        "parcourir"
    ],
    "parcourrais": [
        "parcourir"
    ],
    "parcourrait": [
        "parcourir"
    ],
    "parcourrez": [
        "parcourir"
    ],
    "parcourrions": [
        "parcourir"
    ],
    "parcourront": [
        "parcourir"
    ],
    "parcours": [
        "parcourir",
        "parcours"
    ],
    "parcourt": [
        "parcourir"
    ],
    "parcouru": [
        "parcourir"
    ],
    "parcourue": [
        "parcourir"
    ],
    "parcourues": [
        "parcourir"
    ],
    "parcoururent": [
        "parcourir"
    ],
    "parcourus": [
        "parcourir"
    ],
    "parcourut": [
        "parcourir"
    ],
    "parcourumes": [
        "parcourir"
    ],
    "parcs": [
        "parc"
    ],
    "pardessus": [
        "pardessus"
    ],
    "pardi": [
        "pardi"
    ],
    "pardieu": [
        "pardieu"
    ],
    "pardingue": [
        "pardingue"
    ],
    "pardon": [
        "pardon"
    ],
    "pardonna": [
        "pardonner"
    ],
    "pardonnable": [
        "pardonnable"
    ],
    "pardonnaient": [
        "pardonner"
    ],
    "pardonnais": [
        "pardonner"
    ],
    "pardonnait": [
        "pardonner"
    ],
    "pardonnant": [
        "pardonner"
    ],
    "pardonne": [
        "pardonner"
    ],
    "pardonnent": [
        "pardonner"
    ],
    "pardonner": [
        "pardonner"
    ],
    "pardonnera": [
        "pardonner"
    ],
    "pardonnerai": [
        "pardonner"
    ],
    "pardonneraient": [
        "pardonner"
    ],
    "pardonnerais": [
        "pardonner"
    ],
    "pardonnerait": [
        "pardonner"
    ],
    "pardonneras": [
        "pardonner"
    ],
    "pardonnerez": [
        "pardonner"
    ],
    "pardonneriez": [
        "pardonner"
    ],
    "pardonnerons": [
        "pardonner"
    ],
    "pardonneront": [
        "pardonner"
    ],
    "pardonnes": [
        "pardonner"
    ],
    "pardonnez": [
        "pardonner"
    ],
    "pardonniez": [
        "pardonner"
    ],
    "pardonnions": [
        "pardonner"
    ],
    "pardonnons": [
        "pardonner"
    ],
    "pardonnat": [
        "pardonner"
    ],
    "pardonnerent": [
        "pardonner"
    ],
    "pardonnee": [
        "pardonner"
    ],
    "pardonnees": [
        "pardonner"
    ],
    "pardons": [
        "pardon"
    ],
    "pare": [
        "parer",
        "pare"
    ],
    "pareil": [
        "pareil"
    ],
    "pareille": [
        "pareil"
    ],
    "pareillement": [
        "pareillement"
    ],
    "pareilles": [
        "pareil"
    ],
    "pareils": [
        "pareil"
    ],
    "parement": [
        "parement"
    ],
    "parements": [
        "parement"
    ],
    "parenchyme": [
        "parenchyme"
    ],
    "parent": [
        "parent",
        "parer"
    ],
    "parentage": [
        "parentage"
    ],
    "parental": [
        "parental"
    ],
    "parentale": [
        "parental"
    ],
    "parentales": [
        "parental"
    ],
    "parentaux": [
        "parental"
    ],
    "parente": [
        "parent",
        "parente"
    ],
    "parentes": [
        "parent",
        "parente"
    ],
    "parenthese": [
        "parenthese"
    ],
    "parentheses": [
        "parenthese"
    ],
    "parents": [
        "parent"
    ],
    "parentele": [
        "parentele"
    ],
    "parenteles": [
        "parentele"
    ],
    "parer": [
        "parer"
    ],
    "parerai": [
        "parer"
    ],
    "parerait": [
        "parer"
    ],
    "paressaient": [
        "paresser"
    ],
    "paressais": [
        "paresser"
    ],
    "paressait": [
        "paresser"
    ],
    "paressant": [
        "paresser"
    ],
    "paresse": [
        "paresser",
        "paresse"
    ],
    "paresser": [
        "paresser"
    ],
    "paresses": [
        "paresse"
    ],
    "paresseuse": [
        "paresseux"
    ],
    "paresseusement": [
        "paresseusement"
    ],
    "paresseuses": [
        "paresseux"
    ],
    "paresseux": [
        "paresseux"
    ],
    "paressions": [
        "paresser"
    ],
    "paresthesie": [
        "paresthesie"
    ],
    "pareur": [
        "pareur"
    ],
    "parez": [
        "parer"
    ],
    "parfaire": [
        "parfaire"
    ],
    "parfais": [
        "parfaire"
    ],
    "parfaisais": [
        "parfaire"
    ],
    "parfaisait": [
        "parfaire"
    ],
    "parfait": [
        "parfaire",
        "parfait"
    ],
    "parfaite": [
        "parfaire",
        "parfait"
    ],
    "parfaitement": [
        "parfaitement"
    ],
    "parfaites": [
        "parfaire",
        "parfait"
    ],
    "parfaits": [
        "parfaire",
        "parfait"
    ],
    "parferont": [
        "parfaire"
    ],
    "parfit": [
        "parfaire"
    ],
    "parfois": [
        "parfois"
    ],
    "parfum": [
        "parfum"
    ],
    "parfuma": [
        "parfumer"
    ],
    "parfumaient": [
        "parfumer"
    ],
    "parfumait": [
        "parfumer"
    ],
    "parfume": [
        "parfume",
        "parfumer"
    ],
    "parfument": [
        "parfumer"
    ],
    "parfumer": [
        "parfumer"
    ],
    "parfumera": [
        "parfumer"
    ],
    "parfumerie": [
        "parfumerie"
    ],
    "parfumeries": [
        "parfumerie"
    ],
    "parfumeur": [
        "parfumeur"
    ],
    "parfumeurs": [
        "parfumeur"
    ],
    "parfumeuse": [
        "parfumeur"
    ],
    "parfumez": [
        "parfumer"
    ],
    "parfums": [
        "parfum"
    ],
    "parfumee": [
        "parfume",
        "parfumer"
    ],
    "parfumees": [
        "parfume",
        "parfumer"
    ],
    "parfumes": [
        "parfume",
        "parfumer"
    ],
    "pari": [
        "pari"
    ],
    "paria": [
        "parier",
        "paria"
    ],
    "pariade": [
        "pariade"
    ],
    "pariaient": [
        "parier"
    ],
    "pariais": [
        "parier"
    ],
    "pariait": [
        "parier"
    ],
    "pariant": [
        "parier"
    ],
    "parias": [
        "paria"
    ],
    "parie": [
        "parier"
    ],
    "parient": [
        "parier"
    ],
    "parier": [
        "parier"
    ],
    "parierai": [
        "parier"
    ],
    "parierais": [
        "parier"
    ],
    "parierait": [
        "parier"
    ],
    "parieriez": [
        "parier"
    ],
    "paries": [
        "parier"
    ],
    "parieur": [
        "parieur"
    ],
    "parieurs": [
        "parieur"
    ],
    "parieuse": [
        "parieur"
    ],
    "pariez": [
        "parier"
    ],
    "parigot": [
        "parigot"
    ],
    "parigote": [
        "parigot"
    ],
    "parigotes": [
        "parigot"
    ],
    "parigots": [
        "parigot"
    ],
    "parions": [
        "parier"
    ],
    "paris": [
        "pari"
    ],
    "parisien": [
        "parisien"
    ],
    "parisienne": [
        "parisien"
    ],
    "parisiennes": [
        "parisien"
    ],
    "parisiens": [
        "parisien"
    ],
    "paritaire": [
        "paritaire"
    ],
    "parite": [
        "parite"
    ],
    "parietal": [
        "parietal"
    ],
    "parietale": [
        "parietal"
    ],
    "parietaux": [
        "parietal"
    ],
    "parjurant": [
        "parjurer"
    ],
    "parjure": [
        "parjure",
        "parjurer"
    ],
    "parjurer": [
        "parjurer"
    ],
    "parjurera": [
        "parjurer"
    ],
    "parjures": [
        "parjure",
        "parjurer"
    ],
    "parjuree": [
        "parjurer"
    ],
    "parka": [
        "parka"
    ],
    "parking": [
        "park",
        "parking"
    ],
    "parkings": [
        "parking"
    ],
    "parkinson": [
        "parkinson"
    ],
    "parkinsonien": [
        "parkinsonien"
    ],
    "parkinsonienne": [
        "parkinsonien"
    ],
    "parkinsoniens": [
        "parkinsonien"
    ],
    "parla": [
        "parler"
    ],
    "parlai": [
        "parler"
    ],
    "parlaient": [
        "parler"
    ],
    "parlais": [
        "parler"
    ],
    "parlait": [
        "parler"
    ],
    "parlant": [
        "parler",
        "parlant"
    ],
    "parlante": [
        "parlant",
        "parlante"
    ],
    "parlantes": [
        "parlant"
    ],
    "parlants": [
        "parlant"
    ],
    "parlas": [
        "parler"
    ],
    "parlassent": [
        "parler"
    ],
    "parlasses": [
        "parler"
    ],
    "parle": [
        "parler",
        "parle"
    ],
    "parlement": [
        "parlement"
    ],
    "parlementaire": [
        "parlementaire"
    ],
    "parlementaires": [
        "parlementaire"
    ],
    "parlementait": [
        "parlementer"
    ],
    "parlementant": [
        "parlementer"
    ],
    "parlementarisme": [
        "parlementarisme"
    ],
    "parlementariste": [
        "parlementariste"
    ],
    "parlemente": [
        "parlementer"
    ],
    "parlementent": [
        "parlementer"
    ],
    "parlementer": [
        "parlementer"
    ],
    "parlementons": [
        "parlementer"
    ],
    "parlements": [
        "parlement"
    ],
    "parlementerent": [
        "parlementer"
    ],
    "parlent": [
        "parler"
    ],
    "parler": [
        "parler"
    ],
    "parlera": [
        "parler"
    ],
    "parlerai": [
        "parler"
    ],
    "parleraient": [
        "parler"
    ],
    "parlerais": [
        "parler"
    ],
    "parlerait": [
        "parler"
    ],
    "parleras": [
        "parler"
    ],
    "parlerez": [
        "parler"
    ],
    "parlerie": [
        "parlerie"
    ],
    "parleriez": [
        "parler"
    ],
    "parlerions": [
        "parler"
    ],
    "parlerons": [
        "parler"
    ],
    "parleront": [
        "parler"
    ],
    "parlers": [
        "parler"
    ],
    "parles": [
        "parler",
        "parle"
    ],
    "parleur": [
        "parleur"
    ],
    "parleurs": [
        "parleur"
    ],
    "parleuse": [
        "parleur"
    ],
    "parlez": [
        "parler"
    ],
    "parliez": [
        "parler"
    ],
    "parlions": [
        "parler"
    ],
    "parloir": [
        "parloir"
    ],
    "parloirs": [
        "parloir"
    ],
    "parlons": [
        "parler"
    ],
    "parlophone": [
        "parlophone"
    ],
    "parlotaient": [
        "parloter"
    ],
    "parlote": [
        "parlote"
    ],
    "parloter": [
        "parloter"
    ],
    "parlotes": [
        "parlote"
    ],
    "parlotte": [
        "parlotte"
    ],
    "parlottes": [
        "parlotte"
    ],
    "parlames": [
        "parler"
    ],
    "parlat": [
        "parler"
    ],
    "parlerent": [
        "parler"
    ],
    "parlee": [
        "parler",
        "parle"
    ],
    "parlees": [
        "parler",
        "parle"
    ],
    "parme": [
        "parme"
    ],
    "parmentier": [
        "parmentier"
    ],
    "parmentures": [
        "parmenture"
    ],
    "parmesan": [
        "parmesan"
    ],
    "parmesane": [
        "parmesan"
    ],
    "parmesans": [
        "parmesan"
    ],
    "parmi": [
        "parmi"
    ],
    "parmelies": [
        "parmelie"
    ],
    "parmenidien": [
        "parmenidien"
    ],
    "parnassienne": [
        "parnassien"
    ],
    "parodiai": [
        "parodier"
    ],
    "parodiait": [
        "parodier"
    ],
    "parodiant": [
        "parodier"
    ],
    "parodie": [
        "parodier",
        "parodie"
    ],
    "parodier": [
        "parodier"
    ],
    "parodies": [
        "parodie",
        "parody"
    ],
    "parodique": [
        "parodique"
    ],
    "parodiquement": [
        "parodiquement"
    ],
    "parodiques": [
        "parodique"
    ],
    "parodontal": [
        "parodontal"
    ],
    "parodontale": [
        "parodontal"
    ],
    "paroi": [
        "paroi"
    ],
    "paroir": [
        "paroir"
    ],
    "paroirs": [
        "paroir"
    ],
    "parois": [
        "paroi"
    ],
    "paroisse": [
        "paroisse"
    ],
    "paroisses": [
        "paroisse"
    ],
    "paroissial": [
        "paroissial"
    ],
    "paroissiale": [
        "paroissial"
    ],
    "paroissiales": [
        "paroissial"
    ],
    "paroissiaux": [
        "paroissial"
    ],
    "paroissien": [
        "paroissien"
    ],
    "paroissienne": [
        "paroissien"
    ],
    "paroissiennes": [
        "paroissien"
    ],
    "paroissiens": [
        "paroissien"
    ],
    "parole": [
        "parole"
    ],
    "paroles": [
        "parole"
    ],
    "paroli": [
        "paroli"
    ],
    "parolier": [
        "parolier"
    ],
    "paroliere": [
        "parolier"
    ],
    "paronomasie": [
        "paronomasie"
    ],
    "paros": [
        "paros"
    ],
    "parotidienne": [
        "parotidien"
    ],
    "parousie": [
        "parousie"
    ],
    "paroxysme": [
        "paroxysme"
    ],
    "paroxysmes": [
        "paroxysme"
    ],
    "paroxysmique": [
        "paroxysmique"
    ],
    "paroxysmiques": [
        "paroxysmique"
    ],
    "paroxystique": [
        "paroxystique"
    ],
    "paroxystiques": [
        "paroxystique"
    ],
    "parpaillot": [
        "parpaillot"
    ],
    "parpaillote": [
        "parpaillot"
    ],
    "parpaillotes": [
        "parpaillot"
    ],
    "parpaing": [
        "parpaing"
    ],
    "parpaings": [
        "parpaing"
    ],
    "parquait": [
        "parquer"
    ],
    "parque": [
        "parque",
        "parquer"
    ],
    "parquent": [
        "parquer"
    ],
    "parquer": [
        "parquer"
    ],
    "parquet": [
        "parquet"
    ],
    "parquetage": [
        "parquetage"
    ],
    "parqueteur": [
        "parqueteur"
    ],
    "parqueteuse": [
        "parqueteur"
    ],
    "parquets": [
        "parquet"
    ],
    "parquete": [
        "parqueter"
    ],
    "parquetee": [
        "parqueter"
    ],
    "parquetees": [
        "parqueter"
    ],
    "parquez": [
        "parquer"
    ],
    "parquee": [
        "parque",
        "parquer"
    ],
    "parquees": [
        "parquer"
    ],
    "parques": [
        "parque",
        "parquer"
    ],
    "parr": [
        "parr"
    ],
    "parrain": [
        "parrain"
    ],
    "parrainage": [
        "parrainage"
    ],
    "parrainait": [
        "parrainer"
    ],
    "parrainant": [
        "parrainer"
    ],
    "parraine": [
        "parrainer"
    ],
    "parrainent": [
        "parrainer"
    ],
    "parrainer": [
        "parrainer"
    ],
    "parrainerai": [
        "parrainer"
    ],
    "parraineuse": [
        "parraineur"
    ],
    "parrains": [
        "parrain"
    ],
    "parrainee": [
        "parrainer"
    ],
    "parraines": [
        "parrainer"
    ],
    "parricide": [
        "parricide"
    ],
    "parricides": [
        "parricide"
    ],
    "pars": [
        "par",
        "pars",
        "partir"
    ],
    "parsec": [
        "parsec"
    ],
    "parsecs": [
        "parsec"
    ],
    "parsemaient": [
        "parsemer"
    ],
    "parsemant": [
        "parsemer"
    ],
    "parsemer": [
        "parsemer"
    ],
    "parseme": [
        "parseme",
        "parsemer"
    ],
    "parsemee": [
        "parseme",
        "parsemer"
    ],
    "parsemees": [
        "parseme",
        "parsemer"
    ],
    "parsemes": [
        "parsemer"
    ],
    "parsi": [
        "parsi"
    ],
    "parsis": [
        "parsi"
    ],
    "parsement": [
        "parsemer"
    ],
    "part": [
        "partir",
        "part"
    ],
    "partage": [
        "partager",
        "partage"
    ],
    "partagea": [
        "partager"
    ],
    "partageable": [
        "partageable"
    ],
    "partageai": [
        "partager"
    ],
    "partageaient": [
        "partager"
    ],
    "partageais": [
        "partager"
    ],
    "partageait": [
        "partager"
    ],
    "partageant": [
        "partager",
        "partageant"
    ],
    "partagent": [
        "partager"
    ],
    "partageons": [
        "partager"
    ],
    "partager": [
        "partager"
    ],
    "partagera": [
        "partager"
    ],
    "partagerai": [
        "partager"
    ],
    "partageraient": [
        "partager"
    ],
    "partagerais": [
        "partager"
    ],
    "partagerait": [
        "partager"
    ],
    "partageras": [
        "partager"
    ],
    "partagerez": [
        "partager"
    ],
    "partageriez": [
        "partager"
    ],
    "partagerions": [
        "partager"
    ],
    "partagerons": [
        "partager"
    ],
    "partageront": [
        "partager"
    ],
    "partages": [
        "partager",
        "partage"
    ],
    "partageur": [
        "partageur"
    ],
    "partageurs": [
        "partageur"
    ],
    "partageuse": [
        "partageux"
    ],
    "partageux": [
        "partageux"
    ],
    "partagez": [
        "partager"
    ],
    "partageames": [
        "partager"
    ],
    "partageat": [
        "partager"
    ],
    "partagiez": [
        "partager"
    ],
    "partagions": [
        "partager"
    ],
    "partagerent": [
        "partager"
    ],
    "partagee": [
        "partager",
        "partage"
    ],
    "partagees": [
        "partager",
        "partage"
    ],
    "partaient": [
        "partir"
    ],
    "partais": [
        "partir"
    ],
    "partait": [
        "partir"
    ],
    "partance": [
        "partance"
    ],
    "partant": [
        "partir",
        "partant"
    ],
    "partante": [
        "partant"
    ],
    "partantes": [
        "partant"
    ],
    "partants": [
        "partant"
    ],
    "parte": [
        "partir"
    ],
    "partenaire": [
        "partenaire"
    ],
    "partenaires": [
        "partenaire"
    ],
    "partenariat": [
        "partenariat"
    ],
    "partent": [
        "partir"
    ],
    "parterre": [
        "parterre"
    ],
    "parterres": [
        "parterre"
    ],
    "partes": [
        "partir"
    ],
    "partez": [
        "partir"
    ],
    "parthe": [
        "parthe"
    ],
    "parthes": [
        "parthe"
    ],
    "parthique": [
        "parthique"
    ],
    "parthenogenese": [
        "parthenogenese"
    ],
    "parthenogenetique": [
        "parthenogenetique"
    ],
    "parti": [
        "parti",
        "partir"
    ],
    "partial": [
        "partial"
    ],
    "partiale": [
        "partial"
    ],
    "partiales": [
        "partial"
    ],
    "partialite": [
        "partialite"
    ],
    "partiaux": [
        "partial"
    ],
    "participa": [
        "participer"
    ],
    "participai": [
        "participer"
    ],
    "participaient": [
        "participer"
    ],
    "participais": [
        "participer"
    ],
    "participait": [
        "participer"
    ],
    "participant": [
        "participer",
        "participant"
    ],
    "participante": [
        "participant"
    ],
    "participantes": [
        "participant"
    ],
    "participants": [
        "participant"
    ],
    "participation": [
        "participation"
    ],
    "participations": [
        "participation"
    ],
    "participative": [
        "participatif"
    ],
    "participe": [
        "participe",
        "participer"
    ],
    "participent": [
        "participer"
    ],
    "participer": [
        "participer"
    ],
    "participera": [
        "participer"
    ],
    "participerai": [
        "participer"
    ],
    "participeraient": [
        "participer"
    ],
    "participerais": [
        "participer"
    ],
    "participerait": [
        "participer"
    ],
    "participeras": [
        "participer"
    ],
    "participerez": [
        "participer"
    ],
    "participerons": [
        "participer"
    ],
    "participeront": [
        "participer"
    ],
    "participes": [
        "participe",
        "participer"
    ],
    "participez": [
        "participer"
    ],
    "participiez": [
        "participer"
    ],
    "participions": [
        "participer"
    ],
    "participons": [
        "participer"
    ],
    "participat": [
        "participer"
    ],
    "participerent": [
        "participer"
    ],
    "particularisme": [
        "particularisme"
    ],
    "particularismes": [
        "particularisme"
    ],
    "particularisees": [
        "particulariser"
    ],
    "particularite": [
        "particularite"
    ],
    "particularites": [
        "particularite"
    ],
    "particule": [
        "particule"
    ],
    "particules": [
        "particule"
    ],
    "particulier": [
        "particulier"
    ],
    "particuliers": [
        "particulier"
    ],
    "particuliere": [
        "particulier"
    ],
    "particulierement": [
        "particulierement"
    ],
    "particulieres": [
        "particulier"
    ],
    "partie": [
        "partie",
        "partir"
    ],
    "partiel": [
        "partiel"
    ],
    "partielle": [
        "partiel"
    ],
    "partiellement": [
        "partiellement"
    ],
    "partielles": [
        "partiel"
    ],
    "partiels": [
        "partiel"
    ],
    "parties": [
        "party",
        "partie",
        "partir"
    ],
    "partiez": [
        "partir"
    ],
    "partions": [
        "partir"
    ],
    "partir": [
        "partir"
    ],
    "partira": [
        "partir"
    ],
    "partirai": [
        "partir"
    ],
    "partiraient": [
        "partir"
    ],
    "partirais": [
        "partir"
    ],
    "partirait": [
        "partir"
    ],
    "partiras": [
        "partir"
    ],
    "partirent": [
        "partir"
    ],
    "partirez": [
        "partir"
    ],
    "partiriez": [
        "partir"
    ],
    "partirions": [
        "partir"
    ],
    "partirons": [
        "partir"
    ],
    "partiront": [
        "partir"
    ],
    "partis": [
        "parti",
        "partir"
    ],
    "partisan": [
        "partisan"
    ],
    "partisane": [
        "partisan"
    ],
    "partisanes": [
        "partisan"
    ],
    "partisans": [
        "partisan"
    ],
    "partisse": [
        "partir"
    ],
    "partissent": [
        "partir"
    ],
    "partit": [
        "partir"
    ],
    "partita": [
        "partita"
    ],
    "partitas": [
        "partita"
    ],
    "partitif": [
        "partitif"
    ],
    "partition": [
        "partition"
    ],
    "partitions": [
        "partition"
    ],
    "partner": [
        "partner"
    ],
    "partons": [
        "partir"
    ],
    "partouse": [
        "partouse"
    ],
    "partouser": [
        "partouser"
    ],
    "partout": [
        "partout"
    ],
    "partouzait": [
        "partouzer"
    ],
    "partouzarde": [
        "partouzard"
    ],
    "partouzardes": [
        "partouzard"
    ],
    "partouzards": [
        "partouzard"
    ],
    "partouze": [
        "partouze"
    ],
    "partouzent": [
        "partouzer"
    ],
    "partouzer": [
        "partouzer"
    ],
    "partouzes": [
        "partouze"
    ],
    "partouzeur": [
        "partouzeur"
    ],
    "partouzeurs": [
        "partouzeur"
    ],
    "parts": [
        "part"
    ],
    "parturiente": [
        "parturiente"
    ],
    "parturientes": [
        "parturiente"
    ],
    "parturition": [
        "parturition"
    ],
    "parturitions": [
        "parturition"
    ],
    "party": [
        "party"
    ],
    "partimes": [
        "partir"
    ],
    "paru": [
        "paraitre"
    ],
    "parue": [
        "paraitre"
    ],
    "parure": [
        "parure"
    ],
    "parurent": [
        "paraitre"
    ],
    "parures": [
        "parure"
    ],
    "parus": [
        "paraitre"
    ],
    "parussent": [
        "paraitre"
    ],
    "parut": [
        "paraitre"
    ],
    "parution": [
        "parution"
    ],
    "parvenaient": [
        "parvenir"
    ],
    "parvenais": [
        "parvenir"
    ],
    "parvenait": [
        "parvenir"
    ],
    "parvenant": [
        "parvenir"
    ],
    "parvenez": [
        "parvenir"
    ],
    "parveniez": [
        "parvenir"
    ],
    "parvenions": [
        "parvenir"
    ],
    "parvenir": [
        "parvenir"
    ],
    "parvenons": [
        "parvenir"
    ],
    "parvenu": [
        "parvenu",
        "parvenir"
    ],
    "parvenue": [
        "parvenu",
        "parvenir"
    ],
    "parvenues": [
        "parvenu",
        "parvenir"
    ],
    "parvenus": [
        "parvenu",
        "parvenir"
    ],
    "parviendra": [
        "parvenir"
    ],
    "parviendrai": [
        "parvenir"
    ],
    "parviendraient": [
        "parvenir"
    ],
    "parviendrais": [
        "parvenir"
    ],
    "parviendrait": [
        "parvenir"
    ],
    "parviendras": [
        "parvenir"
    ],
    "parviendrez": [
        "parvenir"
    ],
    "parviendrions": [
        "parvenir"
    ],
    "parviendrons": [
        "parvenir"
    ],
    "parviendront": [
        "parvenir"
    ],
    "parvienne": [
        "parvenir"
    ],
    "parviennent": [
        "parvenir"
    ],
    "parviens": [
        "parvenir"
    ],
    "parvient": [
        "parvenir"
    ],
    "parvinrent": [
        "parvenir"
    ],
    "parvins": [
        "parvenir"
    ],
    "parvinssent": [
        "parvenir"
    ],
    "parvint": [
        "parvenir"
    ],
    "parvis": [
        "parvis"
    ],
    "parvinmes": [
        "parvenir"
    ],
    "paratre": [
        "paratre"
    ],
    "paree": [
        "parer",
        "pare"
    ],
    "parees": [
        "parer",
        "pare"
    ],
    "paregorique": [
        "paregorique"
    ],
    "pareo": [
        "pareo"
    ],
    "pareos": [
        "pareo"
    ],
    "pares": [
        "parer",
        "pare"
    ],
    "paresie": [
        "paresie"
    ],
    "pas": [
        "pas"
    ],
    "pascal": [
        "pascal"
    ],
    "pascale": [
        "pascal"
    ],
    "pascales": [
        "pascal"
    ],
    "pascalien": [
        "pascalien"
    ],
    "pascaliennes": [
        "pascalien"
    ],
    "pascaliens": [
        "pascalien"
    ],
    "paseo": [
        "paseo"
    ],
    "pasionaria": [
        "pasionaria"
    ],
    "pasionarias": [
        "pasionaria"
    ],
    "paso": [
        "paso"
    ],
    "pasos": [
        "paso"
    ],
    "pasque": [
        "pasque"
    ],
    "pasquins": [
        "pasquin"
    ],
    "passa": [
        "passer"
    ],
    "passable": [
        "passable"
    ],
    "passablement": [
        "passablement"
    ],
    "passables": [
        "passable"
    ],
    "passade": [
        "passade"
    ],
    "passades": [
        "passade"
    ],
    "passage": [
        "passage"
    ],
    "passager": [
        "passager"
    ],
    "passagers": [
        "passager"
    ],
    "passages": [
        "passage"
    ],
    "passagere": [
        "passager"
    ],
    "passagerement": [
        "passagerement"
    ],
    "passageres": [
        "passager"
    ],
    "passai": [
        "passer"
    ],
    "passaient": [
        "passer"
    ],
    "passais": [
        "passer"
    ],
    "passait": [
        "passer"
    ],
    "passant": [
        "passer",
        "passant"
    ],
    "passante": [
        "passant"
    ],
    "passantes": [
        "passant"
    ],
    "passants": [
        "passant"
    ],
    "passas": [
        "passer"
    ],
    "passation": [
        "passation"
    ],
    "passavant": [
        "passavant"
    ],
    "passe": [
        "passer",
        "passe"
    ],
    "passement": [
        "passement"
    ],
    "passementaient": [
        "passementer"
    ],
    "passementent": [
        "passementer"
    ],
    "passementerie": [
        "passementerie"
    ],
    "passementeries": [
        "passementerie"
    ],
    "passementier": [
        "passementier"
    ],
    "passementiere": [
        "passementier"
    ],
    "passemente": [
        "passementer"
    ],
    "passent": [
        "passer"
    ],
    "passepoil": [
        "passepoil"
    ],
    "passeport": [
        "passeport"
    ],
    "passeports": [
        "passeport"
    ],
    "passer": [
        "passer",
        "prendre"
    ],
    "passera": [
        "passer"
    ],
    "passerai": [
        "passer"
    ],
    "passeraient": [
        "passer"
    ],
    "passerais": [
        "passer"
    ],
    "passerait": [
        "passer"
    ],
    "passeras": [
        "passer"
    ],
    "passereau": [
        "passereau"
    ],
    "passereaux": [
        "passereau"
    ],
    "passerelle": [
        "passerelle"
    ],
    "passerelles": [
        "passerelle"
    ],
    "passerez": [
        "passer"
    ],
    "passeriez": [
        "passer"
    ],
    "passerions": [
        "passer"
    ],
    "passerons": [
        "passer"
    ],
    "passeront": [
        "passer"
    ],
    "passeroses": [
        "passerose"
    ],
    "passes": [
        "passer",
        "passe",
        "pass"
    ],
    "passeur": [
        "passeur"
    ],
    "passeurs": [
        "passeur"
    ],
    "passeuse": [
        "passeur"
    ],
    "passez": [
        "passer"
    ],
    "passible": [
        "passible"
    ],
    "passibles": [
        "passible"
    ],
    "passiez": [
        "passer"
    ],
    "passif": [
        "passif"
    ],
    "passiflore": [
        "passiflore"
    ],
    "passifs": [
        "passif"
    ],
    "passim": [
        "passim"
    ],
    "passing": [
        "passing",
        "pass"
    ],
    "passion": [
        "passion"
    ],
    "passionna": [
        "passionner"
    ],
    "passionnai": [
        "passionner"
    ],
    "passionnaient": [
        "passionner"
    ],
    "passionnais": [
        "passionner"
    ],
    "passionnait": [
        "passionner"
    ],
    "passionnant": [
        "passionner",
        "passionnant"
    ],
    "passionnante": [
        "passionnant"
    ],
    "passionnantes": [
        "passionnant"
    ],
    "passionnants": [
        "passionnant"
    ],
    "passionne": [
        "passionner",
        "passionne"
    ],
    "passionnel": [
        "passionnel"
    ],
    "passionnelle": [
        "passionnel"
    ],
    "passionnellement": [
        "passionnellement"
    ],
    "passionnelles": [
        "passionnel"
    ],
    "passionnels": [
        "passionnel"
    ],
    "passionnent": [
        "passionner"
    ],
    "passionner": [
        "passionner"
    ],
    "passionnera": [
        "passionner"
    ],
    "passionnerait": [
        "passionner"
    ],
    "passionneras": [
        "passionner"
    ],
    "passionnons": [
        "passionner"
    ],
    "passionnerent": [
        "passionner"
    ],
    "passionnee": [
        "passionner",
        "passionne"
    ],
    "passionnees": [
        "passionner",
        "passionne"
    ],
    "passionnement": [
        "passionnement"
    ],
    "passionnes": [
        "passionner",
        "passionne"
    ],
    "passions": [
        "passer",
        "passion"
    ],
    "passive": [
        "passif",
        "passiver"
    ],
    "passivement": [
        "passivement"
    ],
    "passiver": [
        "passiver"
    ],
    "passives": [
        "passive",
        "passif"
    ],
    "passivete": [
        "passivete"
    ],
    "passivite": [
        "passivite"
    ],
    "passoire": [
        "passoire"
    ],
    "passoires": [
        "passoire"
    ],
    "passons": [
        "passer"
    ],
    "passames": [
        "passer"
    ],
    "passat": [
        "passer"
    ],
    "passates": [
        "passer"
    ],
    "passerent": [
        "passer"
    ],
    "passee": [
        "passer",
        "passe"
    ],
    "passees": [
        "passer",
        "passe"
    ],
    "passeiste": [
        "passeiste"
    ],
    "past": [
        "past"
    ],
    "pastaga": [
        "pastaga"
    ],
    "pastagas": [
        "pastaga"
    ],
    "pastel": [
        "pastel"
    ],
    "pastels": [
        "pastel"
    ],
    "pastenague": [
        "pastenague"
    ],
    "pasteur": [
        "pasteur"
    ],
    "pasteurella": [
        "pasteurella"
    ],
    "pasteurisation": [
        "pasteurisation"
    ],
    "pasteuriser": [
        "pasteuriser"
    ],
    "pasteurise": [
        "pasteurise"
    ],
    "pasteurisee": [
        "pasteurise"
    ],
    "pasteurises": [
        "pasteurise"
    ],
    "pasteurs": [
        "pasteur"
    ],
    "pasticha": [
        "pasticher"
    ],
    "pastichai": [
        "pasticher"
    ],
    "pastichait": [
        "pasticher"
    ],
    "pastiche": [
        "pastiche",
        "pasticher"
    ],
    "pasticher": [
        "pasticher"
    ],
    "pastiches": [
        "pastiche"
    ],
    "pasticheur": [
        "pasticheur"
    ],
    "pastille": [
        "pastille"
    ],
    "pastiller": [
        "pastiller"
    ],
    "pastilles": [
        "pastille"
    ],
    "pastis": [
        "pastis"
    ],
    "pastophore": [
        "pastophore"
    ],
    "pastoral": [
        "pastoral"
    ],
    "pastorale": [
        "pastoral",
        "pastorale"
    ],
    "pastorales": [
        "pastoral",
        "pastorale"
    ],
    "pastoraux": [
        "pastoral"
    ],
    "pastour": [
        "pastour"
    ],
    "pastoureau": [
        "pastoureau"
    ],
    "pastoureaux": [
        "pastoureau"
    ],
    "pastourelle": [
        "pastoureau"
    ],
    "pastourelles": [
        "pastoureau"
    ],
    "pasteque": [
        "pasteque"
    ],
    "pasteques": [
        "pasteque"
    ],
    "pat": [
        "pate",
        "pat"
    ],
    "patache": [
        "patache"
    ],
    "patachon": [
        "patachon"
    ],
    "patafiole": [
        "patafioler"
    ],
    "patagon": [
        "patagon"
    ],
    "patagonien": [
        "patagonien"
    ],
    "patagons": [
        "patagon"
    ],
    "patapouf": [
        "patapouf"
    ],
    "patapoufs": [
        "patapouf"
    ],
    "pataques": [
        "pataques"
    ],
    "patarin": [
        "patarin"
    ],
    "patata": [
        "patata"
    ],
    "patate": [
        "patate"
    ],
    "patates": [
        "patate"
    ],
    "patati": [
        "patati"
    ],
    "patatras": [
        "patatras"
    ],
    "pataud": [
        "pataud"
    ],
    "pataude": [
        "pataud"
    ],
    "pataudes": [
        "pataud"
    ],
    "patauds": [
        "pataud"
    ],
    "pataugas": [
        "pataugas"
    ],
    "patauge": [
        "patauger"
    ],
    "pataugea": [
        "patauger"
    ],
    "pataugeaient": [
        "patauger"
    ],
    "pataugeais": [
        "patauger"
    ],
    "pataugeait": [
        "patauger"
    ],
    "pataugeant": [
        "patauger"
    ],
    "pataugent": [
        "patauger"
    ],
    "pataugeoire": [
        "pataugeoire"
    ],
    "pataugeons": [
        "patauger"
    ],
    "patauger": [
        "patauger"
    ],
    "pataugera": [
        "patauger"
    ],
    "pataugerais": [
        "patauger"
    ],
    "pataugerons": [
        "patauger"
    ],
    "patauges": [
        "patauger"
    ],
    "pataugez": [
        "patauger"
    ],
    "pataugis": [
        "pataugis"
    ],
    "pataugerent": [
        "patauger"
    ],
    "patch": [
        "patch"
    ],
    "patches": [
        "patch"
    ],
    "patchouli": [
        "patchouli"
    ],
    "patchs": [
        "patch"
    ],
    "patchwork": [
        "patchwork"
    ],
    "patelin": [
        "patelin"
    ],
    "pateline": [
        "patelin"
    ],
    "patelins": [
        "patelin"
    ],
    "patellaire": [
        "patellaire"
    ],
    "patelles": [
        "patelle"
    ],
    "patent": [
        "patent"
    ],
    "patente": [
        "patent",
        "patente"
    ],
    "patentes": [
        "patenter",
        "patent",
        "patente"
    ],
    "patents": [
        "patent"
    ],
    "patentee": [
        "patente"
    ],
    "patentees": [
        "patente"
    ],
    "patenotres": [
        "patenotre"
    ],
    "pater": [
        "pater"
    ],
    "paternalisme": [
        "paternalisme"
    ],
    "paternaliste": [
        "paternaliste"
    ],
    "paternalistes": [
        "paternaliste"
    ],
    "paterne": [
        "paterne"
    ],
    "paternel": [
        "paternel"
    ],
    "paternelle": [
        "paternel"
    ],
    "paternellement": [
        "paternellement"
    ],
    "paternelles": [
        "paternel"
    ],
    "paternels": [
        "paternel"
    ],
    "paternite": [
        "paternite"
    ],
    "paternites": [
        "paternite"
    ],
    "pathogene": [
        "pathogene"
    ],
    "pathogenique": [
        "pathogenique"
    ],
    "pathologie": [
        "pathologie"
    ],
    "pathologique": [
        "pathologique"
    ],
    "pathologiquement": [
        "pathologiquement"
    ],
    "pathologiques": [
        "pathologique"
    ],
    "pathologiste": [
        "pathologiste"
    ],
    "pathos": [
        "pathos"
    ],
    "pathetique": [
        "pathetique"
    ],
    "pathetiquement": [
        "pathetiquement"
    ],
    "pathetiques": [
        "pathetique"
    ],
    "pathetisme": [
        "pathetisme"
    ],
    "patibulaire": [
        "patibulaire"
    ],
    "patibulaires": [
        "patibulaire"
    ],
    "patiemment": [
        "patiemment"
    ],
    "patience": [
        "patience"
    ],
    "patiences": [
        "patience"
    ],
    "patient": [
        "patient"
    ],
    "patienta": [
        "patienter"
    ],
    "patientai": [
        "patienter"
    ],
    "patientaient": [
        "patienter"
    ],
    "patientait": [
        "patienter"
    ],
    "patientant": [
        "patienter"
    ],
    "patiente": [
        "patienter",
        "patient"
    ],
    "patientent": [
        "patienter"
    ],
    "patienter": [
        "patienter"
    ],
    "patientera": [
        "patienter"
    ],
    "patienteraient": [
        "patienter"
    ],
    "patienterait": [
        "patienter"
    ],
    "patienteras": [
        "patienter"
    ],
    "patienterez": [
        "patienter"
    ],
    "patienterons": [
        "patienter"
    ],
    "patientes": [
        "patienter",
        "patient"
    ],
    "patientez": [
        "patienter"
    ],
    "patientions": [
        "patienter"
    ],
    "patientons": [
        "patienter"
    ],
    "patients": [
        "patient"
    ],
    "patienterent": [
        "patienter"
    ],
    "patin": [
        "patin"
    ],
    "patina": [
        "patiner"
    ],
    "patinage": [
        "patinage"
    ],
    "patinaient": [
        "patiner"
    ],
    "patinais": [
        "patiner"
    ],
    "patinait": [
        "patiner"
    ],
    "patinant": [
        "patiner"
    ],
    "patine": [
        "patine",
        "patiner"
    ],
    "patinent": [
        "patiner"
    ],
    "patiner": [
        "patiner"
    ],
    "patinerais": [
        "patiner"
    ],
    "patinerons": [
        "patiner"
    ],
    "patines": [
        "patine",
        "patiner"
    ],
    "patinette": [
        "patinette"
    ],
    "patinettes": [
        "patinette"
    ],
    "patineur": [
        "patineur"
    ],
    "patineurs": [
        "patineur"
    ],
    "patineuse": [
        "patineur"
    ],
    "patineuses": [
        "patineur"
    ],
    "patinez": [
        "patiner"
    ],
    "patiniez": [
        "patiner"
    ],
    "patinions": [
        "patiner"
    ],
    "patinoire": [
        "patinoire"
    ],
    "patinoires": [
        "patinoire"
    ],
    "patinons": [
        "patiner"
    ],
    "patins": [
        "patin"
    ],
    "patinee": [
        "patiner"
    ],
    "patinees": [
        "patiner"
    ],
    "patio": [
        "patio"
    ],
    "patios": [
        "patio"
    ],
    "patoche": [
        "patoche"
    ],
    "patoches": [
        "patoche"
    ],
    "patois": [
        "patois"
    ],
    "patoisante": [
        "patoisant"
    ],
    "patoise": [
        "patoiser"
    ],
    "patouillard": [
        "patouillard"
    ],
    "patouille": [
        "patouiller"
    ],
    "patouillons": [
        "patouiller"
    ],
    "patraque": [
        "patraque"
    ],
    "patri": [
        "patri"
    ],
    "patriarcal": [
        "patriarcal"
    ],
    "patriarcale": [
        "patriarcal"
    ],
    "patriarcales": [
        "patriarcal"
    ],
    "patriarcat": [
        "patriarcat"
    ],
    "patriarcats": [
        "patriarcat"
    ],
    "patriarcaux": [
        "patriarcal"
    ],
    "patriarche": [
        "patriarche"
    ],
    "patriarches": [
        "patriarche"
    ],
    "patriarchie": [
        "patriarchie"
    ],
    "patriciat": [
        "patriciat"
    ],
    "patricien": [
        "patricien"
    ],
    "patricienne": [
        "patricien"
    ],
    "patriciennes": [
        "patricien"
    ],
    "patriciens": [
        "patricien"
    ],
    "patrie": [
        "patrie"
    ],
    "patries": [
        "patrie"
    ],
    "patrilineaire": [
        "patrilineaire"
    ],
    "patrimoine": [
        "patrimoine"
    ],
    "patrimoines": [
        "patrimoine"
    ],
    "patrimonial": [
        "patrimonial"
    ],
    "patriotard": [
        "patriotard"
    ],
    "patriotardes": [
        "patriotard"
    ],
    "patriotards": [
        "patriotard"
    ],
    "patriote": [
        "patriote"
    ],
    "patriotes": [
        "patriote"
    ],
    "patriotique": [
        "patriotique"
    ],
    "patriotiquement": [
        "patriotiquement"
    ],
    "patriotiques": [
        "patriotique"
    ],
    "patriotisme": [
        "patriotisme"
    ],
    "patron": [
        "patron"
    ],
    "patronage": [
        "patronage"
    ],
    "patronages": [
        "patronage"
    ],
    "patronal": [
        "patronal"
    ],
    "patronale": [
        "patronal"
    ],
    "patronales": [
        "patronal"
    ],
    "patronat": [
        "patronat"
    ],
    "patronaux": [
        "patronal"
    ],
    "patronna": [
        "patronner"
    ],
    "patronne": [
        "patron",
        "patronner"
    ],
    "patronner": [
        "patronner"
    ],
    "patronnes": [
        "patron",
        "patronner"
    ],
    "patronnesse": [
        "patronnesse"
    ],
    "patronnesses": [
        "patronnesse"
    ],
    "patronnee": [
        "patronner"
    ],
    "patrons": [
        "patron"
    ],
    "patronyme": [
        "patronyme"
    ],
    "patronymes": [
        "patronyme"
    ],
    "patronymique": [
        "patronymique"
    ],
    "patronymiques": [
        "patronymique"
    ],
    "patrouilla": [
        "patrouiller"
    ],
    "patrouillaient": [
        "patrouiller"
    ],
    "patrouillais": [
        "patrouiller"
    ],
    "patrouillait": [
        "patrouiller"
    ],
    "patrouillant": [
        "patrouiller"
    ],
    "patrouille": [
        "patrouille",
        "patrouiller"
    ],
    "patrouillent": [
        "patrouiller"
    ],
    "patrouiller": [
        "patrouiller"
    ],
    "patrouillerai": [
        "patrouiller"
    ],
    "patrouilleras": [
        "patrouiller"
    ],
    "patrouillerez": [
        "patrouiller"
    ],
    "patrouilleront": [
        "patrouiller"
    ],
    "patrouilles": [
        "patrouille",
        "patrouiller"
    ],
    "patrouilleur": [
        "patrouilleur"
    ],
    "patrouilleurs": [
        "patrouilleur"
    ],
    "patrouillez": [
        "patrouiller"
    ],
    "patrouilliez": [
        "patrouiller"
    ],
    "patrouillions": [
        "patrouiller"
    ],
    "patrouillee": [
        "patrouiller"
    ],
    "patrouillees": [
        "patrouiller"
    ],
    "patte": [
        "patte"
    ],
    "pattemouille": [
        "pattemouille"
    ],
    "pattemouilles": [
        "pattemouille"
    ],
    "pattern": [
        "pattern"
    ],
    "pattes": [
        "patte"
    ],
    "pattu": [
        "pattu"
    ],
    "pattus": [
        "pattu"
    ],
    "pattee": [
        "patte"
    ],
    "paturon": [
        "paturon"
    ],
    "paturons": [
        "paturon"
    ],
    "patene": [
        "patene"
    ],
    "patenes": [
        "patene"
    ],
    "patere": [
        "patere"
    ],
    "pateres": [
        "patere"
    ],
    "pauchouse": [
        "pauchouse"
    ],
    "pauline": [
        "pauline"
    ],
    "paulinienne": [
        "paulinien"
    ],
    "paulownias": [
        "paulownia"
    ],
    "pauma": [
        "paumer"
    ],
    "paumais": [
        "paumer"
    ],
    "paumait": [
        "paumer"
    ],
    "paumant": [
        "paumer"
    ],
    "paume": [
        "paume",
        "paumer"
    ],
    "paumelle": [
        "paumelle"
    ],
    "paumelles": [
        "paumelle"
    ],
    "paument": [
        "paumer"
    ],
    "paumer": [
        "paumer"
    ],
    "paumes": [
        "paume",
        "paumer"
    ],
    "paumee": [
        "paume",
        "paumer"
    ],
    "paumees": [
        "paume",
        "paumer"
    ],
    "paupiette": [
        "paupiette"
    ],
    "paupiettes": [
        "paupiette"
    ],
    "paupiere": [
        "paupiere"
    ],
    "paupieres": [
        "paupiere"
    ],
    "pauperisation": [
        "pauperisation"
    ],
    "pauperise": [
        "pauperiser"
    ],
    "pauperisme": [
        "pauperisme"
    ],
    "pause": [
        "pause"
    ],
    "pauser": [
        "pauser"
    ],
    "pauses": [
        "pause"
    ],
    "pausez": [
        "pauser"
    ],
    "pauvre": [
        "pauvre"
    ],
    "pauvrement": [
        "pauvrement"
    ],
    "pauvres": [
        "pauvre"
    ],
    "pauvresse": [
        "pauvresse"
    ],
    "pauvresses": [
        "pauvresse"
    ],
    "pauvret": [
        "pauvret"
    ],
    "pauvrets": [
        "pauvret"
    ],
    "pauvrette": [
        "pauvrette"
    ],
    "pauvrettes": [
        "pauvrette"
    ],
    "pauvrete": [
        "pauvrete"
    ],
    "pauvretes": [
        "pauvrete"
    ],
    "pavage": [
        "pavage"
    ],
    "pavait": [
        "paver"
    ],
    "pavana": [
        "pavaner"
    ],
    "pavanaient": [
        "pavaner"
    ],
    "pavanait": [
        "pavaner"
    ],
    "pavanant": [
        "pavaner"
    ],
    "pavane": [
        "pavaner",
        "pavane"
    ],
    "pavanent": [
        "pavaner"
    ],
    "pavaner": [
        "pavaner"
    ],
    "pavanera": [
        "pavaner"
    ],
    "pavanerez": [
        "pavaner"
    ],
    "pavanes": [
        "pavaner",
        "pavane"
    ],
    "pavanons": [
        "pavaner"
    ],
    "pave": [
        "pave",
        "paver"
    ],
    "pavement": [
        "pavement"
    ],
    "pavements": [
        "pavement"
    ],
    "paver": [
        "paver"
    ],
    "paveton": [
        "paveton"
    ],
    "pavetons": [
        "paveton"
    ],
    "paveur": [
        "paveur"
    ],
    "paveurs": [
        "paveur"
    ],
    "pavez": [
        "paver"
    ],
    "pavillon": [
        "pavillon"
    ],
    "pavillonnaire": [
        "pavillonnaire"
    ],
    "pavillonnaires": [
        "pavillonnaire"
    ],
    "pavillons": [
        "pavillon"
    ],
    "pavlovien": [
        "pavlovien"
    ],
    "pavlovienne": [
        "pavlovien"
    ],
    "pavois": [
        "pavois"
    ],
    "pavoisa": [
        "pavoiser"
    ],
    "pavoisaient": [
        "pavoiser"
    ],
    "pavoisait": [
        "pavoiser"
    ],
    "pavoise": [
        "pavoiser"
    ],
    "pavoisement": [
        "pavoisement"
    ],
    "pavoisent": [
        "pavoiser"
    ],
    "pavoiser": [
        "pavoiser"
    ],
    "pavoisera": [
        "pavoiser"
    ],
    "pavoiseraient": [
        "pavoiser"
    ],
    "pavoisee": [
        "pavoiser"
    ],
    "pavoisees": [
        "pavoiser"
    ],
    "pavoises": [
        "pavoiser"
    ],
    "pavot": [
        "pavot"
    ],
    "pavots": [
        "pavot"
    ],
    "pavee": [
        "pave"
    ],
    "pavees": [
        "pave"
    ],
    "paves": [
        "pave",
        "paver"
    ],
    "paxon": [
        "paxon"
    ],
    "paya": [
        "payer"
    ],
    "payable": [
        "payable"
    ],
    "payables": [
        "payable"
    ],
    "payai": [
        "payer"
    ],
    "payaient": [
        "payer"
    ],
    "payais": [
        "payer"
    ],
    "payait": [
        "payer"
    ],
    "payant": [
        "payer",
        "payant"
    ],
    "payante": [
        "payant"
    ],
    "payantes": [
        "payant"
    ],
    "payants": [
        "payant"
    ],
    "payassent": [
        "payer"
    ],
    "payassiez": [
        "payer"
    ],
    "paye": [
        "payer",
        "paye"
    ],
    "payement": [
        "payement"
    ],
    "payements": [
        "payement"
    ],
    "payent": [
        "payer"
    ],
    "payer": [
        "payer"
    ],
    "payera": [
        "payer"
    ],
    "payerai": [
        "payer"
    ],
    "payeraient": [
        "payer"
    ],
    "payerais": [
        "payer"
    ],
    "payerait": [
        "payer"
    ],
    "payeras": [
        "payer"
    ],
    "payerez": [
        "payer"
    ],
    "payeriez": [
        "payer"
    ],
    "payerons": [
        "payer"
    ],
    "payeront": [
        "payer"
    ],
    "payes": [
        "payer",
        "paye"
    ],
    "payeur": [
        "payeur"
    ],
    "payeurs": [
        "payeur"
    ],
    "payez": [
        "payer"
    ],
    "payiez": [
        "payer"
    ],
    "payions": [
        "payer"
    ],
    "payons": [
        "payer"
    ],
    "pays": [
        "pay",
        "pays"
    ],
    "paysage": [
        "paysage"
    ],
    "paysager": [
        "paysager"
    ],
    "paysages": [
        "paysage"
    ],
    "paysagiste": [
        "paysagiste"
    ],
    "paysagistes": [
        "paysagiste"
    ],
    "paysan": [
        "paysan"
    ],
    "paysanne": [
        "paysan"
    ],
    "paysannerie": [
        "paysannerie"
    ],
    "paysannes": [
        "paysan"
    ],
    "paysans": [
        "paysan"
    ],
    "payse": [
        "payse"
    ],
    "payames": [
        "payer"
    ],
    "payat": [
        "payer"
    ],
    "payerent": [
        "payer"
    ],
    "payee": [
        "payer",
        "paye"
    ],
    "payees": [
        "payer",
        "paye"
    ],
    "pait": [
        "paitre"
    ],
    "paitre": [
        "paitre"
    ],
    "paitront": [
        "paitre"
    ],
    "paien": [
        "paien"
    ],
    "paienne": [
        "paien"
    ],
    "paiennes": [
        "paien"
    ],
    "paiens": [
        "paien"
    ],
    "pc": [
        "pc"
    ],
    "pchitt": [
        "pchitt"
    ],
    "peanuts": [
        "peanut",
        "peanuts"
    ],
    "peau": [
        "peau"
    ],
    "peaucier": [
        "peaucier"
    ],
    "peauciers": [
        "peaucier"
    ],
    "peaufina": [
        "peaufiner"
    ],
    "peaufinage": [
        "peaufinage"
    ],
    "peaufinait": [
        "peaufiner"
    ],
    "peaufinant": [
        "peaufiner"
    ],
    "peaufiner": [
        "peaufiner"
    ],
    "peaufine": [
        "peaufiner"
    ],
    "peaufinee": [
        "peaufiner"
    ],
    "peaufines": [
        "peaufiner"
    ],
    "peausserie": [
        "peausserie"
    ],
    "peausseries": [
        "peausserie"
    ],
    "peaussier": [
        "peaussier"
    ],
    "peaux": [
        "peau"
    ],
    "pec": [
        "pec"
    ],
    "peccable": [
        "peccable"
    ],
    "peccadille": [
        "peccadille"
    ],
    "peccadilles": [
        "peccadille"
    ],
    "peccata": [
        "peccata"
    ],
    "peccavi": [
        "peccavi"
    ],
    "pecnots": [
        "pecnot"
    ],
    "pecorino": [
        "pecorino"
    ],
    "pectoral": [
        "pectoral"
    ],
    "pectorale": [
        "pectoral"
    ],
    "pectorales": [
        "pectoral"
    ],
    "pectoraux": [
        "pectoral"
    ],
    "pedigree": [
        "pedigree"
    ],
    "pedigrees": [
        "pedigree"
    ],
    "pedzouille": [
        "pedzouille"
    ],
    "pedzouilles": [
        "pedzouille"
    ],
    "peeling": [
        "peeling",
        "peel"
    ],
    "peigna": [
        "peigner"
    ],
    "peignaient": [
        "peindre",
        "peigner"
    ],
    "peignais": [
        "peindre",
        "peigner"
    ],
    "peignait": [
        "peindre"
    ],
    "peignant": [
        "peindre"
    ],
    "peigne": [
        "peigne",
        "peigner"
    ],
    "peignent": [
        "peindre",
        "peigner"
    ],
    "peigner": [
        "peigner"
    ],
    "peignerais": [
        "peigner"
    ],
    "peignerait": [
        "peigner"
    ],
    "peignes": [
        "peigne",
        "peigner"
    ],
    "peignez": [
        "peindre",
        "peigner"
    ],
    "peigniez": [
        "peigner"
    ],
    "peignions": [
        "peigner"
    ],
    "peignis": [
        "peindre"
    ],
    "peignit": [
        "peindre"
    ],
    "peignoir": [
        "peignoir"
    ],
    "peignoirs": [
        "peignoir"
    ],
    "peignons": [
        "peindre"
    ],
    "peignee": [
        "peignee"
    ],
    "peignees": [
        "peignee"
    ],
    "peina": [
        "peiner"
    ],
    "peinaient": [
        "peiner"
    ],
    "peinais": [
        "peiner"
    ],
    "peinait": [
        "peiner"
    ],
    "peinant": [
        "peiner"
    ],
    "peinard": [
        "peinard"
    ],
    "peinarde": [
        "peinard"
    ],
    "peinardement": [
        "peinardement"
    ],
    "peinardes": [
        "peinard"
    ],
    "peinards": [
        "peinard"
    ],
    "peindra": [
        "peindre"
    ],
    "peindrai": [
        "peindre"
    ],
    "peindrais": [
        "peindre"
    ],
    "peindrait": [
        "peindre"
    ],
    "peindras": [
        "peindre"
    ],
    "peindre": [
        "peindre"
    ],
    "peine": [
        "peiner",
        "peine"
    ],
    "peinent": [
        "peiner"
    ],
    "peiner": [
        "peiner"
    ],
    "peinera": [
        "peiner"
    ],
    "peinerait": [
        "peiner"
    ],
    "peinerez": [
        "peiner"
    ],
    "peines": [
        "peiner",
        "peine"
    ],
    "peineuse": [
        "peineuse"
    ],
    "peinez": [
        "peiner"
    ],
    "peinions": [
        "peiner"
    ],
    "peinons": [
        "peiner"
    ],
    "peins": [
        "peindre"
    ],
    "peint": [
        "peint",
        "peindre"
    ],
    "peinte": [
        "peint",
        "peindre"
    ],
    "peintes": [
        "peint",
        "peindre"
    ],
    "peintre": [
        "peintre"
    ],
    "peintres": [
        "peintre"
    ],
    "peints": [
        "peint",
        "peindre"
    ],
    "peinture": [
        "peinturer",
        "peinture"
    ],
    "peintures": [
        "peinture"
    ],
    "peinturlure": [
        "peinturlurer"
    ],
    "peinturlurent": [
        "peinturlurer"
    ],
    "peinturlurer": [
        "peinturlurer"
    ],
    "peinturlures": [
        "peinturlurer"
    ],
    "peinturlureur": [
        "peinturlureur"
    ],
    "peinturlureurs": [
        "peinturlureur"
    ],
    "peinturluree": [
        "peinturlurer"
    ],
    "peinturlurees": [
        "peinturlurer"
    ],
    "peinturee": [
        "peinturer"
    ],
    "peinat": [
        "peiner"
    ],
    "peinerent": [
        "peiner"
    ],
    "peinee": [
        "peiner"
    ],
    "peinees": [
        "peiner"
    ],
    "pela": [
        "peler"
    ],
    "pelade": [
        "pelade"
    ],
    "pelades": [
        "pelade"
    ],
    "pelage": [
        "pelage"
    ],
    "pelages": [
        "pelage"
    ],
    "pelaient": [
        "peler"
    ],
    "pelait": [
        "peler"
    ],
    "pelant": [
        "peler"
    ],
    "peler": [
        "peler"
    ],
    "pelisse": [
        "pelisse"
    ],
    "pelisses": [
        "pelisse"
    ],
    "pellagre": [
        "pellagre"
    ],
    "pelle": [
        "pelle"
    ],
    "pelles": [
        "pelle"
    ],
    "pelletage": [
        "pelletage"
    ],
    "pelletaient": [
        "pelleter"
    ],
    "pelletait": [
        "pelleter"
    ],
    "pelletant": [
        "pelleter"
    ],
    "pelleter": [
        "pelleter"
    ],
    "pelleterie": [
        "pelleterie"
    ],
    "pelleteur": [
        "pelleteur"
    ],
    "pelleteuse": [
        "pelleteur"
    ],
    "pelleteuses": [
        "pelleteur"
    ],
    "pelletiers": [
        "pelletier"
    ],
    "pellette": [
        "pelleter"
    ],
    "pelletee": [
        "pelletee"
    ],
    "pelletees": [
        "pelletee"
    ],
    "pelliculages": [
        "pelliculage"
    ],
    "pelliculaire": [
        "pelliculaire"
    ],
    "pellicule": [
        "pelliculer",
        "pellicule"
    ],
    "pellicules": [
        "pellicule"
    ],
    "pelliculee": [
        "pelliculer"
    ],
    "pelloche": [
        "pelloche"
    ],
    "pelota": [
        "peloter"
    ],
    "pelotage": [
        "pelotage"
    ],
    "pelotages": [
        "pelotage"
    ],
    "pelotaient": [
        "peloter"
    ],
    "pelotais": [
        "peloter"
    ],
    "pelotait": [
        "peloter"
    ],
    "pelotant": [
        "peloter"
    ],
    "pelote": [
        "peloter",
        "pelote"
    ],
    "pelotent": [
        "peloter"
    ],
    "peloter": [
        "peloter"
    ],
    "peloterai": [
        "peloter"
    ],
    "peloterait": [
        "peloter"
    ],
    "pelotes": [
        "peloter",
        "pelote"
    ],
    "peloteur": [
        "peloteur"
    ],
    "peloteurs": [
        "peloteur"
    ],
    "peloteuse": [
        "peloteur"
    ],
    "pelotez": [
        "peloter"
    ],
    "peloton": [
        "peloton"
    ],
    "pelotonna": [
        "pelotonner"
    ],
    "pelotonnai": [
        "pelotonner"
    ],
    "pelotonnaient": [
        "pelotonner"
    ],
    "pelotonnais": [
        "pelotonner"
    ],
    "pelotonnait": [
        "pelotonner"
    ],
    "pelotonnant": [
        "pelotonner"
    ],
    "pelotonne": [
        "pelotonner"
    ],
    "pelotonnent": [
        "pelotonner"
    ],
    "pelotonner": [
        "pelotonner"
    ],
    "pelotonnee": [
        "pelotonner"
    ],
    "pelotonnees": [
        "pelotonner"
    ],
    "pelotonnes": [
        "pelotonner"
    ],
    "pelotons": [
        "peloton",
        "peloter"
    ],
    "pelotee": [
        "peloter"
    ],
    "pelouse": [
        "pelouse"
    ],
    "pelouses": [
        "pelouse"
    ],
    "peluche": [
        "peluche"
    ],
    "peluches": [
        "peluche"
    ],
    "pelucheuse": [
        "pelucheux"
    ],
    "pelucheuses": [
        "pelucheux"
    ],
    "pelucheux": [
        "pelucheux"
    ],
    "peluchee": [
        "peluche"
    ],
    "pelure": [
        "pelure"
    ],
    "pelures": [
        "pelure"
    ],
    "pelvien": [
        "pelvien"
    ],
    "pelvienne": [
        "pelvien"
    ],
    "pelvis": [
        "pelvis"
    ],
    "pele": [
        "peler",
        "pele"
    ],
    "pelee": [
        "peler",
        "pele"
    ],
    "pelees": [
        "peler",
        "pele"
    ],
    "peles": [
        "peler",
        "pele"
    ],
    "pembina": [
        "pembina"
    ],
    "pemmican": [
        "pemmican"
    ],
    "penalties": [
        "penalties",
        "penalty"
    ],
    "penalty": [
        "penalty"
    ],
    "penaud": [
        "penaud"
    ],
    "penaude": [
        "penaud"
    ],
    "penaudes": [
        "penaud"
    ],
    "penauds": [
        "penaud"
    ],
    "pence": [
        "pence",
        "penny"
    ],
    "pencha": [
        "pencher"
    ],
    "penchai": [
        "pencher"
    ],
    "penchaient": [
        "pencher"
    ],
    "penchais": [
        "pencher"
    ],
    "penchait": [
        "pencher"
    ],
    "penchant": [
        "penchant",
        "pencher"
    ],
    "penchante": [
        "penchant"
    ],
    "penchants": [
        "penchant"
    ],
    "penche": [
        "penche",
        "pencher"
    ],
    "penchement": [
        "penchement"
    ],
    "penchent": [
        "pencher"
    ],
    "pencher": [
        "pencher"
    ],
    "penchera": [
        "pencher"
    ],
    "pencherai": [
        "pencher"
    ],
    "pencheraient": [
        "pencher"
    ],
    "pencherais": [
        "pencher"
    ],
    "pencherait": [
        "pencher"
    ],
    "pencheras": [
        "pencher"
    ],
    "pencherez": [
        "pencher"
    ],
    "pencheriez": [
        "pencher"
    ],
    "pencherons": [
        "pencher"
    ],
    "pencheront": [
        "pencher"
    ],
    "penches": [
        "penche",
        "pencher"
    ],
    "penchez": [
        "pencher"
    ],
    "penchiez": [
        "pencher"
    ],
    "penchions": [
        "pencher"
    ],
    "penchons": [
        "pencher"
    ],
    "penchames": [
        "pencher"
    ],
    "penchat": [
        "pencher"
    ],
    "pencherent": [
        "pencher"
    ],
    "penchee": [
        "penche",
        "pencher"
    ],
    "penchees": [
        "penche",
        "pencher"
    ],
    "pend": [
        "pendre"
    ],
    "pendable": [
        "pendable"
    ],
    "pendables": [
        "pendable"
    ],
    "pendaient": [
        "pendre"
    ],
    "pendais": [
        "pendre"
    ],
    "pendaison": [
        "pendaison"
    ],
    "pendaisons": [
        "pendaison"
    ],
    "pendait": [
        "pendre"
    ],
    "pendant": [
        "pendant",
        "pendre"
    ],
    "pendante": [
        "pendant"
    ],
    "pendantes": [
        "pendant"
    ],
    "pendants": [
        "pendant"
    ],
    "pendard": [
        "pendard"
    ],
    "pendarde": [
        "pendard"
    ],
    "pendards": [
        "pendard"
    ],
    "pende": [
        "pendre"
    ],
    "pendeloque": [
        "pendeloque"
    ],
    "pendeloques": [
        "pendeloque"
    ],
    "pendent": [
        "pendre"
    ],
    "pendentif": [
        "pendentif"
    ],
    "pendentifs": [
        "pendentif"
    ],
    "penderie": [
        "penderie"
    ],
    "penderies": [
        "penderie"
    ],
    "pendeur": [
        "pendeur"
    ],
    "pendez": [
        "pendre"
    ],
    "pendillaient": [
        "pendiller"
    ],
    "pendillait": [
        "pendiller"
    ],
    "pendillant": [
        "pendiller"
    ],
    "pendille": [
        "pendiller"
    ],
    "pendirent": [
        "pendre"
    ],
    "pendit": [
        "pendre"
    ],
    "pendjabi": [
        "pendjabi"
    ],
    "pendons": [
        "pendre"
    ],
    "pendouillaient": [
        "pendouiller"
    ],
    "pendouillait": [
        "pendouiller"
    ],
    "pendouillant": [
        "pendouiller"
    ],
    "pendouille": [
        "pendouiller"
    ],
    "pendouillent": [
        "pendouiller"
    ],
    "pendouiller": [
        "pendouiller"
    ],
    "pendouilles": [
        "pendouiller"
    ],
    "pendra": [
        "pendre"
    ],
    "pendrai": [
        "pendre"
    ],
    "pendrais": [
        "pendre"
    ],
    "pendrait": [
        "pendre"
    ],
    "pendras": [
        "pendre"
    ],
    "pendre": [
        "pendre"
    ],
    "pendrez": [
        "pendre"
    ],
    "pendrons": [
        "pendre"
    ],
    "pendront": [
        "pendre"
    ],
    "pends": [
        "pendre"
    ],
    "pendu": [
        "pendu",
        "pendre"
    ],
    "pendue": [
        "pendu",
        "pendre"
    ],
    "pendues": [
        "pendu",
        "pendre"
    ],
    "pendulaire": [
        "pendulaire"
    ],
    "pendulait": [
        "penduler"
    ],
    "pendule": [
        "pendule"
    ],
    "pendules": [
        "pendule"
    ],
    "pendulette": [
        "pendulette"
    ],
    "pendulettes": [
        "pendulette"
    ],
    "pendus": [
        "pendu",
        "pendre"
    ],
    "pennage": [
        "pennage"
    ],
    "penne": [
        "penne"
    ],
    "pennes": [
        "penne"
    ],
    "pennies": [
        "penny",
        "pennies"
    ],
    "pennon": [
        "pennon"
    ],
    "pennons": [
        "pennon"
    ],
    "penny": [
        "penny"
    ],
    "pennees": [
        "penne"
    ],
    "penon": [
        "penon"
    ],
    "pensa": [
        "penser"
    ],
    "pensable": [
        "pensable"
    ],
    "pensai": [
        "penser"
    ],
    "pensaient": [
        "penser"
    ],
    "pensais": [
        "penser"
    ],
    "pensait": [
        "penser"
    ],
    "pensant": [
        "penser",
        "pensant"
    ],
    "pensante": [
        "pensant"
    ],
    "pensantes": [
        "pensant"
    ],
    "pensants": [
        "pensant"
    ],
    "pense": [
        "penser"
    ],
    "pensent": [
        "penser"
    ],
    "penser": [
        "penser"
    ],
    "pensera": [
        "penser"
    ],
    "penserai": [
        "penser"
    ],
    "penseraient": [
        "penser"
    ],
    "penserais": [
        "penser"
    ],
    "penserait": [
        "penser"
    ],
    "penseras": [
        "penser"
    ],
    "penserez": [
        "penser"
    ],
    "penseriez": [
        "penser"
    ],
    "penserions": [
        "penser"
    ],
    "penserons": [
        "penser"
    ],
    "penseront": [
        "penser"
    ],
    "penses": [
        "penser"
    ],
    "penseur": [
        "penseur"
    ],
    "penseurs": [
        "penseur"
    ],
    "penseuse": [
        "penseur"
    ],
    "penseuses": [
        "penseur"
    ],
    "pensez": [
        "penser"
    ],
    "pensiez": [
        "penser"
    ],
    "pensif": [
        "pensif"
    ],
    "pensifs": [
        "pensif"
    ],
    "pension": [
        "pension"
    ],
    "pensionna": [
        "pensionner"
    ],
    "pensionnaire": [
        "pensionnaire"
    ],
    "pensionnaires": [
        "pensionnaire"
    ],
    "pensionnat": [
        "pensionnat"
    ],
    "pensionnats": [
        "pensionnat"
    ],
    "pensionner": [
        "pensionner"
    ],
    "pensionne": [
        "pensionner",
        "pensionne"
    ],
    "pensionnes": [
        "pensionner",
        "pensionne"
    ],
    "pensions": [
        "penser",
        "pension"
    ],
    "pensive": [
        "pensif"
    ],
    "pensivement": [
        "pensivement"
    ],
    "pensons": [
        "penser"
    ],
    "pensum": [
        "pensum"
    ],
    "pensums": [
        "pensum"
    ],
    "pensames": [
        "penser"
    ],
    "pensat": [
        "penser"
    ],
    "penserent": [
        "penser"
    ],
    "pensee": [
        "penser",
        "pensee"
    ],
    "pensees": [
        "penser",
        "pensee"
    ],
    "pentacle": [
        "pentacle"
    ],
    "pentacles": [
        "pentacle"
    ],
    "pentagonal": [
        "pentagonal"
    ],
    "pentagone": [
        "pentagone"
    ],
    "pentagones": [
        "pentagone"
    ],
    "pentagramme": [
        "pentagramme"
    ],
    "pentagrammes": [
        "pentagramme"
    ],
    "pentametre": [
        "pentametre"
    ],
    "pentametres": [
        "pentametre"
    ],
    "pentasyllabe": [
        "pentasyllabe"
    ],
    "pentateuque": [
        "pentateuque"
    ],
    "pentathlon": [
        "pentathlon"
    ],
    "pente": [
        "pente"
    ],
    "pentecote": [
        "pentecote"
    ],
    "pentecotiste": [
        "pentecotiste"
    ],
    "pentecotistes": [
        "pentecotiste"
    ],
    "pentes": [
        "pente"
    ],
    "penthiobarbital": [
        "penthiobarbital"
    ],
    "penthotal": [
        "penthotal"
    ],
    "penthouse": [
        "penthouse"
    ],
    "pentothal": [
        "pentothal"
    ],
    "pentu": [
        "pentu"
    ],
    "pentue": [
        "pentu"
    ],
    "pentues": [
        "pentu"
    ],
    "penture": [
        "penture"
    ],
    "pentures": [
        "penture"
    ],
    "pentus": [
        "pentu"
    ],
    "pentelique": [
        "pentelique"
    ],
    "people": [
        "people"
    ],
    "pep": [
        "pep"
    ],
    "peppermint": [
        "peppermint"
    ],
    "peps": [
        "pep"
    ],
    "pepsine": [
        "pepsine"
    ],
    "peptide": [
        "peptide"
    ],
    "peptique": [
        "peptique"
    ],
    "percale": [
        "percale"
    ],
    "percales": [
        "percale"
    ],
    "perce": [
        "percer",
        "perce"
    ],
    "percement": [
        "percement"
    ],
    "percent": [
        "percer"
    ],
    "percepteur": [
        "percepteur"
    ],
    "percepteurs": [
        "percepteur"
    ],
    "perceptible": [
        "perceptible"
    ],
    "perceptibles": [
        "perceptible"
    ],
    "perceptif": [
        "perceptif"
    ],
    "perception": [
        "perception"
    ],
    "perceptions": [
        "perception"
    ],
    "perceptive": [
        "perceptif"
    ],
    "perceptives": [
        "perceptif"
    ],
    "perceptrice": [
        "percepteur"
    ],
    "perceptuels": [
        "perceptuel"
    ],
    "percer": [
        "percer"
    ],
    "percera": [
        "percer"
    ],
    "percerai": [
        "percer"
    ],
    "percerait": [
        "percer"
    ],
    "percerez": [
        "percer"
    ],
    "perceur": [
        "perceur"
    ],
    "perceurs": [
        "perceur"
    ],
    "perceuse": [
        "perceur"
    ],
    "perceuses": [
        "perceur"
    ],
    "percevaient": [
        "percevoir"
    ],
    "percevais": [
        "percevoir"
    ],
    "percevait": [
        "percevoir"
    ],
    "percevant": [
        "percevoir",
        "percevant"
    ],
    "percevez": [
        "percevoir"
    ],
    "perceviez": [
        "percevoir"
    ],
    "percevions": [
        "percevoir"
    ],
    "percevoir": [
        "percevoir"
    ],
    "percevons": [
        "percevoir"
    ],
    "percevra": [
        "percevoir"
    ],
    "percevrais": [
        "percevoir"
    ],
    "percevrait": [
        "percevoir"
    ],
    "percevrez": [
        "percevoir"
    ],
    "percez": [
        "percer"
    ],
    "percha": [
        "percher"
    ],
    "perchaient": [
        "percher"
    ],
    "perchais": [
        "percher"
    ],
    "perchait": [
        "percher"
    ],
    "perche": [
        "perche",
        "percher"
    ],
    "perchent": [
        "percher"
    ],
    "percher": [
        "percher"
    ],
    "percheron": [
        "percheron"
    ],
    "percheronne": [
        "percheron"
    ],
    "percheronnes": [
        "percheron"
    ],
    "percherons": [
        "percheron"
    ],
    "perches": [
        "perche",
        "percher",
        "perch"
    ],
    "perchettes": [
        "perchette"
    ],
    "percheurs": [
        "percheur"
    ],
    "perchiste": [
        "perchiste"
    ],
    "perchlorate": [
        "perchlorate"
    ],
    "perchlorique": [
        "perchlorique"
    ],
    "perchman": [
        "perchman"
    ],
    "perchmans": [
        "perchman"
    ],
    "perchoir": [
        "perchoir"
    ],
    "perchoirs": [
        "perchoir"
    ],
    "percherent": [
        "percher"
    ],
    "perchee": [
        "percher",
        "perchee"
    ],
    "perchees": [
        "percher",
        "perchee"
    ],
    "percions": [
        "percer"
    ],
    "perclus": [
        "perclus"
    ],
    "percluse": [
        "perclus"
    ],
    "percluses": [
        "perclus"
    ],
    "perco": [
        "perco"
    ],
    "percolateur": [
        "percolateur"
    ],
    "percolateurs": [
        "percolateur"
    ],
    "percolation": [
        "percolation"
    ],
    "percoler": [
        "percoler"
    ],
    "percos": [
        "perco"
    ],
    "percussion": [
        "percussion"
    ],
    "percussionniste": [
        "percussionniste"
    ],
    "percussionnistes": [
        "percussionniste"
    ],
    "percussions": [
        "percussion"
    ],
    "percuta": [
        "percuter"
    ],
    "percutait": [
        "percuter"
    ],
    "percutant": [
        "percuter",
        "percutant"
    ],
    "percutante": [
        "percutant"
    ],
    "percutantes": [
        "percutant"
    ],
    "percutants": [
        "percutant"
    ],
    "percute": [
        "percuter"
    ],
    "percutent": [
        "percuter"
    ],
    "percuter": [
        "percuter"
    ],
    "percuterait": [
        "percuter"
    ],
    "percutes": [
        "percuter"
    ],
    "percuteur": [
        "percuteur"
    ],
    "percuteurs": [
        "percuteur"
    ],
    "percutez": [
        "percuter"
    ],
    "percutee": [
        "percuter"
    ],
    "percutees": [
        "percuter"
    ],
    "percerent": [
        "percer"
    ],
    "percee": [
        "percer",
        "percee"
    ],
    "percees": [
        "percer",
        "percee"
    ],
    "perces": [
        "percer"
    ],
    "perd": [
        "perdre"
    ],
    "perdaient": [
        "perdre"
    ],
    "perdais": [
        "perdre"
    ],
    "perdait": [
        "perdre"
    ],
    "perdant": [
        "perdant",
        "perdre"
    ],
    "perdante": [
        "perdant"
    ],
    "perdants": [
        "perdant"
    ],
    "perde": [
        "perdre"
    ],
    "perdent": [
        "perdre"
    ],
    "perdes": [
        "perdre"
    ],
    "perdez": [
        "perdre"
    ],
    "perdiez": [
        "perdre"
    ],
    "perdions": [
        "perdre"
    ],
    "perdirent": [
        "perdre"
    ],
    "perdis": [
        "perdre"
    ],
    "perdisse": [
        "perdre"
    ],
    "perdit": [
        "perdre"
    ],
    "perdition": [
        "perdition"
    ],
    "perdons": [
        "perdre"
    ],
    "perdra": [
        "perdre"
    ],
    "perdrai": [
        "perdre"
    ],
    "perdraient": [
        "perdre"
    ],
    "perdrais": [
        "perdre"
    ],
    "perdrait": [
        "perdre"
    ],
    "perdras": [
        "perdre"
    ],
    "perdre": [
        "perdre"
    ],
    "perdreau": [
        "perdreau"
    ],
    "perdreaux": [
        "perdreau"
    ],
    "perdrez": [
        "perdre"
    ],
    "perdriez": [
        "perdre"
    ],
    "perdrions": [
        "perdre"
    ],
    "perdrix": [
        "perdrix"
    ],
    "perdrons": [
        "perdre"
    ],
    "perdront": [
        "perdre"
    ],
    "perds": [
        "perdre"
    ],
    "perdu": [
        "perdu",
        "perdre"
    ],
    "perdue": [
        "perdu",
        "perdre"
    ],
    "perdues": [
        "perdu",
        "perdre"
    ],
    "perdurable": [
        "perdurable"
    ],
    "perdurait": [
        "perdurer"
    ],
    "perdure": [
        "perdurer"
    ],
    "perdurent": [
        "perdurer"
    ],
    "perdurer": [
        "perdurer"
    ],
    "perdurera": [
        "perdurer"
    ],
    "perdus": [
        "perdu",
        "perdre"
    ],
    "perdimes": [
        "perdre"
    ],
    "perestroika": [
        "perestroika"
    ],
    "perfectibilite": [
        "perfectibilite"
    ],
    "perfectible": [
        "perfectible"
    ],
    "perfectibles": [
        "perfectible"
    ],
    "perfection": [
        "perfection"
    ],
    "perfectionna": [
        "perfectionner"
    ],
    "perfectionnaient": [
        "perfectionner"
    ],
    "perfectionnais": [
        "perfectionner"
    ],
    "perfectionnait": [
        "perfectionner"
    ],
    "perfectionnant": [
        "perfectionner"
    ],
    "perfectionne": [
        "perfectionner"
    ],
    "perfectionnement": [
        "perfectionnement"
    ],
    "perfectionnements": [
        "perfectionnement"
    ],
    "perfectionnent": [
        "perfectionner"
    ],
    "perfectionner": [
        "perfectionner"
    ],
    "perfectionnerais": [
        "perfectionner"
    ],
    "perfectionnions": [
        "perfectionner"
    ],
    "perfectionnisme": [
        "perfectionnisme"
    ],
    "perfectionniste": [
        "perfectionniste"
    ],
    "perfectionnistes": [
        "perfectionniste"
    ],
    "perfectionnerent": [
        "perfectionner"
    ],
    "perfectionnee": [
        "perfectionner"
    ],
    "perfectionnees": [
        "perfectionner"
    ],
    "perfectionnes": [
        "perfectionner"
    ],
    "perfections": [
        "perfection"
    ],
    "perfecto": [
        "perfecto"
    ],
    "perfectos": [
        "perfecto"
    ],
    "perfide": [
        "perfide"
    ],
    "perfidement": [
        "perfidement"
    ],
    "perfides": [
        "perfide"
    ],
    "perfidie": [
        "perfidie"
    ],
    "perfidies": [
        "perfidie"
    ],
    "perfora": [
        "perforer"
    ],
    "perforage": [
        "perforage"
    ],
    "perforait": [
        "perforer"
    ],
    "perforant": [
        "perforant",
        "perforer"
    ],
    "perforante": [
        "perforant"
    ],
    "perforantes": [
        "perforant"
    ],
    "perforants": [
        "perforant"
    ],
    "perforateur": [
        "perforateur"
    ],
    "perforation": [
        "perforation"
    ],
    "perforations": [
        "perforation"
    ],
    "perforatrice": [
        "perforateur"
    ],
    "perfore": [
        "perforer",
        "perfore"
    ],
    "perforer": [
        "perforer"
    ],
    "perforera": [
        "perforer"
    ],
    "perforeuse": [
        "perforeuse"
    ],
    "perforez": [
        "perforer"
    ],
    "perforions": [
        "perforer"
    ],
    "performance": [
        "performance"
    ],
    "performances": [
        "performance"
    ],
    "performant": [
        "performant"
    ],
    "performante": [
        "performant"
    ],
    "performantes": [
        "performant"
    ],
    "performants": [
        "performant"
    ],
    "performer": [
        "performer"
    ],
    "perforee": [
        "perforer",
        "perfore"
    ],
    "perforees": [
        "perforer",
        "perfore"
    ],
    "perfores": [
        "perforer",
        "perfore"
    ],
    "perfuse": [
        "perfuser"
    ],
    "perfuser": [
        "perfuser"
    ],
    "perfusion": [
        "perfusion"
    ],
    "perfusions": [
        "perfusion"
    ],
    "pergola": [
        "pergola"
    ],
    "pergelisol": [
        "pergelisol"
    ],
    "perla": [
        "perler"
    ],
    "perlaient": [
        "perler"
    ],
    "perlait": [
        "perler"
    ],
    "perlant": [
        "perler"
    ],
    "perle": [
        "perle",
        "perler"
    ],
    "perlent": [
        "perler"
    ],
    "perler": [
        "perler"
    ],
    "perleront": [
        "perler"
    ],
    "perles": [
        "perle",
        "perler"
    ],
    "perlimpinpin": [
        "perlimpinpin"
    ],
    "perliere": [
        "perliere",
        "perlier"
    ],
    "perlieres": [
        "perlier"
    ],
    "perlot": [
        "perlot"
    ],
    "perlots": [
        "perlot"
    ],
    "perlouse": [
        "perlouse"
    ],
    "perlouses": [
        "perlouse"
    ],
    "perlouze": [
        "perlouze"
    ],
    "perlouzes": [
        "perlouze"
    ],
    "perlerent": [
        "perler"
    ],
    "perlee": [
        "perle",
        "perler"
    ],
    "perlees": [
        "perle",
        "perler"
    ],
    "perm": [
        "perm"
    ],
    "permafrost": [
        "permafrost"
    ],
    "permalloy": [
        "permalloy"
    ],
    "permane": [
        "permaner"
    ],
    "permanence": [
        "permanence"
    ],
    "permanences": [
        "permanence"
    ],
    "permanent": [
        "permanent"
    ],
    "permanente": [
        "permanent",
        "permanente",
        "permanenter"
    ],
    "permanenter": [
        "permanenter"
    ],
    "permanentes": [
        "permanent",
        "permanente",
        "permanenter"
    ],
    "permanents": [
        "permanent"
    ],
    "permanentee": [
        "permanenter"
    ],
    "permanganate": [
        "permanganate"
    ],
    "perme": [
        "perme"
    ],
    "permes": [
        "perme"
    ],
    "permet": [
        "permettre"
    ],
    "permets": [
        "permettre"
    ],
    "permettaient": [
        "permettre"
    ],
    "permettais": [
        "permettre"
    ],
    "permettait": [
        "permettre"
    ],
    "permettant": [
        "permettre"
    ],
    "permette": [
        "permettre"
    ],
    "permettent": [
        "permettre"
    ],
    "permettes": [
        "permettre"
    ],
    "permettez": [
        "permettre"
    ],
    "permettiez": [
        "permettre"
    ],
    "permettions": [
        "permettre"
    ],
    "permettons": [
        "permettre"
    ],
    "permettra": [
        "permettre"
    ],
    "permettrai": [
        "permettre"
    ],
    "permettraient": [
        "permettre"
    ],
    "permettrais": [
        "permettre"
    ],
    "permettrait": [
        "permettre"
    ],
    "permettras": [
        "permettre"
    ],
    "permettre": [
        "permettre"
    ],
    "permettrez": [
        "permettre"
    ],
    "permettriez": [
        "permettre"
    ],
    "permettrions": [
        "permettre"
    ],
    "permettrons": [
        "permettre"
    ],
    "permettront": [
        "permettre"
    ],
    "permirent": [
        "permettre"
    ],
    "permis": [
        "permettre",
        "permis"
    ],
    "permise": [
        "permettre"
    ],
    "permises": [
        "permettre"
    ],
    "permissent": [
        "permettre"
    ],
    "permissifs": [
        "permissif"
    ],
    "permission": [
        "permission"
    ],
    "permissionnaire": [
        "permissionnaire"
    ],
    "permissionnaires": [
        "permissionnaire"
    ],
    "permissions": [
        "permission"
    ],
    "permissive": [
        "permissif"
    ],
    "permissivite": [
        "permissivite"
    ],
    "permit": [
        "permettre"
    ],
    "permutant": [
        "permuter",
        "permutant"
    ],
    "permutation": [
        "permutation"
    ],
    "permutations": [
        "permutation"
    ],
    "permute": [
        "permuter"
    ],
    "permutent": [
        "permuter"
    ],
    "permuter": [
        "permuter"
    ],
    "permuterent": [
        "permuter"
    ],
    "permeabilite": [
        "permeabilite"
    ],
    "permeable": [
        "permeable"
    ],
    "permeables": [
        "permeable"
    ],
    "pernicieuse": [
        "pernicieux"
    ],
    "pernicieuses": [
        "pernicieux"
    ],
    "pernicieux": [
        "pernicieux"
    ],
    "pernod": [
        "pernod"
    ],
    "pernods": [
        "pernod"
    ],
    "peroxydase": [
        "peroxydase"
    ],
    "peroxyde": [
        "peroxyde",
        "peroxyder"
    ],
    "perpendiculaire": [
        "perpendiculaire"
    ],
    "perpendiculairement": [
        "perpendiculairement"
    ],
    "perpendiculaires": [
        "perpendiculaire"
    ],
    "perpette": [
        "perpette"
    ],
    "perpignan": [
        "perpignan"
    ],
    "perplexe": [
        "perplexe"
    ],
    "perplexes": [
        "perplexe",
        "perplex"
    ],
    "perplexite": [
        "perplexite"
    ],
    "perplexites": [
        "perplexite"
    ],
    "perpete": [
        "perpete"
    ],
    "perpetrent": [
        "perpetrer"
    ],
    "perpetres": [
        "perpetrer",
        "perpetre"
    ],
    "perpetra": [
        "perpetrer"
    ],
    "perpetrait": [
        "perpetrer"
    ],
    "perpetration": [
        "perpetration"
    ],
    "perpetrer": [
        "perpetrer"
    ],
    "perpetrons": [
        "perpetrer"
    ],
    "perpetre": [
        "perpetrer"
    ],
    "perpetree": [
        "perpetrer"
    ],
    "perpetrees": [
        "perpetrer"
    ],
    "perpetua": [
        "perpetuer"
    ],
    "perpetuaient": [
        "perpetuer"
    ],
    "perpetuait": [
        "perpetuer"
    ],
    "perpetuant": [
        "perpetuer"
    ],
    "perpetuation": [
        "perpetuation"
    ],
    "perpetue": [
        "perpetuer",
        "perpetue"
    ],
    "perpetuel": [
        "perpetuel"
    ],
    "perpetuelle": [
        "perpetuel"
    ],
    "perpetuellement": [
        "perpetuellement"
    ],
    "perpetuelles": [
        "perpetuel"
    ],
    "perpetuels": [
        "perpetuel"
    ],
    "perpetuent": [
        "perpetuer"
    ],
    "perpetuer": [
        "perpetuer"
    ],
    "perpetuera": [
        "perpetuer"
    ],
    "perpetuerait": [
        "perpetuer"
    ],
    "perpetuite": [
        "perpetuite"
    ],
    "perpetuites": [
        "perpetuite"
    ],
    "perpetuee": [
        "perpetuer",
        "perpetue"
    ],
    "perpetues": [
        "perpetuer"
    ],
    "perquise": [
        "perquise"
    ],
    "perquisition": [
        "perquisition"
    ],
    "perquisitionne": [
        "perquisitionner"
    ],
    "perquisitionnent": [
        "perquisitionner"
    ],
    "perquisitionner": [
        "perquisitionner"
    ],
    "perquisitionnera": [
        "perquisitionner"
    ],
    "perquisitions": [
        "perquisition"
    ],
    "perrier": [
        "perrier"
    ],
    "perrieres": [
        "perriere"
    ],
    "perron": [
        "perron"
    ],
    "perrons": [
        "perron"
    ],
    "perroquet": [
        "perroquet"
    ],
    "perroquets": [
        "perroquet"
    ],
    "perruche": [
        "perruche"
    ],
    "perruches": [
        "perruche"
    ],
    "perruque": [
        "perruque"
    ],
    "perruques": [
        "perruque"
    ],
    "perruquier": [
        "perruquier"
    ],
    "perruquiers": [
        "perruquier"
    ],
    "perruquiere": [
        "perruquier"
    ],
    "perre": [
        "perre"
    ],
    "perres": [
        "perre"
    ],
    "pers": [
        "pers",
        "per"
    ],
    "persan": [
        "persan"
    ],
    "persane": [
        "persan"
    ],
    "persanes": [
        "persan"
    ],
    "persans": [
        "persan"
    ],
    "perse": [
        "perse"
    ],
    "perses": [
        "perse"
    ],
    "persienne": [
        "persienne"
    ],
    "persiennes": [
        "persienne"
    ],
    "persifla": [
        "persifler"
    ],
    "persiflage": [
        "persiflage"
    ],
    "persiflages": [
        "persiflage"
    ],
    "persiflait": [
        "persifler"
    ],
    "persifle": [
        "persifle",
        "persifler"
    ],
    "persifler": [
        "persifler"
    ],
    "persifleur": [
        "persifleur"
    ],
    "persifleurs": [
        "persifleur"
    ],
    "persifleuse": [
        "persifleur"
    ],
    "persil": [
        "persil"
    ],
    "persille": [
        "persiller",
        "persille"
    ],
    "persillee": [
        "persiller",
        "persille"
    ],
    "persillees": [
        "persille"
    ],
    "persique": [
        "persique"
    ],
    "persista": [
        "persister"
    ],
    "persistai": [
        "persister"
    ],
    "persistaient": [
        "persister"
    ],
    "persistais": [
        "persister"
    ],
    "persistait": [
        "persister"
    ],
    "persistance": [
        "persistance"
    ],
    "persistant": [
        "persistant",
        "persister"
    ],
    "persistante": [
        "persistant"
    ],
    "persistantes": [
        "persistant"
    ],
    "persistants": [
        "persistant"
    ],
    "persiste": [
        "persister"
    ],
    "persistent": [
        "persister"
    ],
    "persister": [
        "persister"
    ],
    "persistera": [
        "persister"
    ],
    "persisterai": [
        "persister"
    ],
    "persisterait": [
        "persister"
    ],
    "persisteriez": [
        "persister"
    ],
    "persistes": [
        "persister"
    ],
    "persistez": [
        "persister"
    ],
    "persistions": [
        "persister"
    ],
    "persistons": [
        "persister"
    ],
    "persisterent": [
        "persister"
    ],
    "perso": [
        "perso"
    ],
    "personnage": [
        "personnage"
    ],
    "personnages": [
        "personnage"
    ],
    "personnalisaient": [
        "personnaliser"
    ],
    "personnalisation": [
        "personnalisation"
    ],
    "personnalise": [
        "personnaliser",
        "personnalise"
    ],
    "personnalisent": [
        "personnaliser"
    ],
    "personnaliser": [
        "personnaliser"
    ],
    "personnalisez": [
        "personnaliser"
    ],
    "personnalisme": [
        "personnalisme"
    ],
    "personnalisons": [
        "personnaliser"
    ],
    "personnalisee": [
        "personnaliser",
        "personnalise"
    ],
    "personnalisees": [
        "personnalise"
    ],
    "personnalite": [
        "personnalite"
    ],
    "personnalites": [
        "personnalite"
    ],
    "personne": [
        "personne"
    ],
    "personnel": [
        "personnel"
    ],
    "personnelle": [
        "personnel"
    ],
    "personnellement": [
        "personnellement"
    ],
    "personnelles": [
        "personnel"
    ],
    "personnels": [
        "personnel"
    ],
    "personnes": [
        "personnes",
        "personne"
    ],
    "personnifiaient": [
        "personnifier"
    ],
    "personnifiait": [
        "personnifier"
    ],
    "personnifiant": [
        "personnifier"
    ],
    "personnification": [
        "personnification"
    ],
    "personnifications": [
        "personnification"
    ],
    "personnifie": [
        "personnifier",
        "personnifie"
    ],
    "personnifier": [
        "personnifier"
    ],
    "personnifiee": [
        "personnifier",
        "personnifie"
    ],
    "persos": [
        "perso"
    ],
    "perspective": [
        "perspectif",
        "perspective"
    ],
    "perspectives": [
        "perspectif",
        "perspective"
    ],
    "perspicace": [
        "perspicace"
    ],
    "perspicaces": [
        "perspicace"
    ],
    "perspicacite": [
        "perspicacite"
    ],
    "perspiration": [
        "perspiration"
    ],
    "persuada": [
        "persuader"
    ],
    "persuadai": [
        "persuader"
    ],
    "persuadaient": [
        "persuader"
    ],
    "persuadais": [
        "persuader"
    ],
    "persuadait": [
        "persuader"
    ],
    "persuadant": [
        "persuader"
    ],
    "persuade": [
        "persuade",
        "persuader"
    ],
    "persuadent": [
        "persuader"
    ],
    "persuader": [
        "persuader"
    ],
    "persuadera": [
        "persuader"
    ],
    "persuaderai": [
        "persuader"
    ],
    "persuaderais": [
        "persuader"
    ],
    "persuaderait": [
        "persuader"
    ],
    "persuaderas": [
        "persuader"
    ],
    "persuaderez": [
        "persuader"
    ],
    "persuaderons": [
        "persuader"
    ],
    "persuadez": [
        "persuader"
    ],
    "persuadiez": [
        "persuader"
    ],
    "persuadons": [
        "persuader"
    ],
    "persuaderent": [
        "persuader"
    ],
    "persuadee": [
        "persuade",
        "persuader"
    ],
    "persuadees": [
        "persuade",
        "persuader"
    ],
    "persuades": [
        "persuade",
        "persuader"
    ],
    "persuasif": [
        "persuasif"
    ],
    "persuasifs": [
        "persuasif"
    ],
    "persuasion": [
        "persuasion"
    ],
    "persuasive": [
        "persuasif"
    ],
    "persuasives": [
        "persuasif"
    ],
    "persecutaient": [
        "persecuter"
    ],
    "persecutait": [
        "persecuter"
    ],
    "persecutant": [
        "persecuter"
    ],
    "persecute": [
        "persecute",
        "persecuter"
    ],
    "persecutent": [
        "persecuter"
    ],
    "persecuter": [
        "persecuter"
    ],
    "persecuteraient": [
        "persecuter"
    ],
    "persecuterez": [
        "persecuter"
    ],
    "persecutes": [
        "persecute",
        "persecuter"
    ],
    "persecuteur": [
        "persecuteur"
    ],
    "persecuteurs": [
        "persecuteur"
    ],
    "persecutez": [
        "persecuter"
    ],
    "persecution": [
        "persecution"
    ],
    "persecutions": [
        "persecution"
    ],
    "persecutrices": [
        "persecuteur"
    ],
    "persecutee": [
        "persecute",
        "persecuter"
    ],
    "persecutees": [
        "persecute",
        "persecuter"
    ],
    "perseides": [
        "perseides"
    ],
    "persevere": [
        "perseverer"
    ],
    "perseveres": [
        "persevere",
        "perseverer"
    ],
    "persevera": [
        "perseverer"
    ],
    "perseverai": [
        "perseverer"
    ],
    "perseveraient": [
        "perseverer"
    ],
    "perseverait": [
        "perseverer"
    ],
    "perseveramment": [
        "perseveramment"
    ],
    "perseverance": [
        "perseverance"
    ],
    "perseverant": [
        "perseverant",
        "perseverer"
    ],
    "perseverante": [
        "perseverant"
    ],
    "perseverantes": [
        "perseverant"
    ],
    "perseverants": [
        "perseverant"
    ],
    "perseverer": [
        "perseverer"
    ],
    "persevererai": [
        "perseverer"
    ],
    "persevererait": [
        "perseverer"
    ],
    "perseverez": [
        "perseverer"
    ],
    "perseveriez": [
        "perseverer"
    ],
    "perseverions": [
        "perseverer"
    ],
    "perseverons": [
        "perseverer"
    ],
    "perte": [
        "perte"
    ],
    "pertes": [
        "perte"
    ],
    "pertinemment": [
        "pertinemment"
    ],
    "pertinence": [
        "pertinence"
    ],
    "pertinent": [
        "pertinent"
    ],
    "pertinente": [
        "pertinent"
    ],
    "pertinentes": [
        "pertinent"
    ],
    "pertinents": [
        "pertinent"
    ],
    "pertuis": [
        "pertuis"
    ],
    "pertuisane": [
        "pertuisane"
    ],
    "pertuisanes": [
        "pertuisane"
    ],
    "perturba": [
        "perturber"
    ],
    "perturbaient": [
        "perturber"
    ],
    "perturbait": [
        "perturber"
    ],
    "perturbant": [
        "perturber",
        "perturbant"
    ],
    "perturbante": [
        "perturbant"
    ],
    "perturbants": [
        "perturbant"
    ],
    "perturbateur": [
        "perturbateur"
    ],
    "perturbateurs": [
        "perturbateur"
    ],
    "perturbation": [
        "perturbation"
    ],
    "perturbations": [
        "perturbation"
    ],
    "perturbatrice": [
        "perturbateur"
    ],
    "perturbe": [
        "perturber",
        "perturbe"
    ],
    "perturbent": [
        "perturber"
    ],
    "perturber": [
        "perturber"
    ],
    "perturbera": [
        "perturber"
    ],
    "perturberait": [
        "perturber"
    ],
    "perturberont": [
        "perturber"
    ],
    "perturbez": [
        "perturber"
    ],
    "perturbee": [
        "perturber",
        "perturbe"
    ],
    "perturbees": [
        "perturber",
        "perturbe"
    ],
    "perturbes": [
        "perturber",
        "perturbe"
    ],
    "pervenche": [
        "pervenche"
    ],
    "pervenches": [
        "pervenche"
    ],
    "pervers": [
        "pervers"
    ],
    "perverse": [
        "pervers"
    ],
    "perversement": [
        "perversement"
    ],
    "perverses": [
        "pervers"
    ],
    "perversion": [
        "perversion"
    ],
    "perversions": [
        "perversion"
    ],
    "perversite": [
        "perversite"
    ],
    "perverti": [
        "pervertir",
        "perverti"
    ],
    "pervertie": [
        "pervertir",
        "perverti"
    ],
    "perverties": [
        "pervertir",
        "perverti"
    ],
    "pervertir": [
        "pervertir"
    ],
    "pervertis": [
        "pervertir",
        "perverti"
    ],
    "pervertissaient": [
        "pervertir"
    ],
    "pervertissait": [
        "pervertir"
    ],
    "pervertissant": [
        "pervertir"
    ],
    "pervertisse": [
        "pervertir"
    ],
    "pervertit": [
        "pervertir"
    ],
    "perca": [
        "percer"
    ],
    "percage": [
        "percage"
    ],
    "percaient": [
        "percer"
    ],
    "percais": [
        "percer"
    ],
    "percait": [
        "percer"
    ],
    "percant": [
        "percer",
        "percant"
    ],
    "percante": [
        "percant"
    ],
    "percantes": [
        "percant"
    ],
    "percants": [
        "percant"
    ],
    "percois": [
        "percevoir"
    ],
    "percoit": [
        "percevoir"
    ],
    "percoive": [
        "percevoir"
    ],
    "percoivent": [
        "percevoir"
    ],
    "percons": [
        "percer"
    ],
    "percu": [
        "percevoir",
        "percu"
    ],
    "percue": [
        "percevoir",
        "percu"
    ],
    "percues": [
        "percevoir",
        "percu"
    ],
    "percurent": [
        "percevoir"
    ],
    "percus": [
        "percevoir",
        "percu"
    ],
    "percut": [
        "percevoir"
    ],
    "percat": [
        "percer"
    ],
    "pesa": [
        "peser"
    ],
    "pesage": [
        "pesage"
    ],
    "pesai": [
        "peser"
    ],
    "pesaient": [
        "peser"
    ],
    "pesais": [
        "peser"
    ],
    "pesait": [
        "peser"
    ],
    "pesamment": [
        "pesamment"
    ],
    "pesant": [
        "pesant",
        "peser"
    ],
    "pesante": [
        "pesant"
    ],
    "pesantes": [
        "pesant"
    ],
    "pesanteur": [
        "pesanteur"
    ],
    "pesanteurs": [
        "pesanteur"
    ],
    "pesants": [
        "pesant"
    ],
    "peser": [
        "peser"
    ],
    "peseta": [
        "peseta"
    ],
    "pesetas": [
        "peseta"
    ],
    "peseurs": [
        "peseur"
    ],
    "pesez": [
        "peser"
    ],
    "pesions": [
        "peser"
    ],
    "peso": [
        "peso"
    ],
    "peson": [
        "peson"
    ],
    "pesons": [
        "peser"
    ],
    "pesos": [
        "peso"
    ],
    "pessah": [
        "pessah"
    ],
    "pessaire": [
        "pessaire"
    ],
    "pesse": [
        "pesse"
    ],
    "pessimisme": [
        "pessimisme"
    ],
    "pessimiste": [
        "pessimiste"
    ],
    "pessimistes": [
        "pessimiste"
    ],
    "pesta": [
        "pester"
    ],
    "pestaient": [
        "pester"
    ],
    "pestais": [
        "pester"
    ],
    "pestait": [
        "pester"
    ],
    "pestant": [
        "pester"
    ],
    "peste": [
        "pester",
        "peste"
    ],
    "pestent": [
        "pester"
    ],
    "pester": [
        "pester"
    ],
    "pestes": [
        "pester",
        "peste"
    ],
    "pesteuse": [
        "pesteux"
    ],
    "pestez": [
        "pester"
    ],
    "pesticide": [
        "pesticide"
    ],
    "pesticides": [
        "pesticide"
    ],
    "pestifere": [
        "pestifere"
    ],
    "pestiferee": [
        "pestifere"
    ],
    "pestiferees": [
        "pestifere"
    ],
    "pestiferes": [
        "pestifere"
    ],
    "pestilence": [
        "pestilence"
    ],
    "pestilences": [
        "pestilence"
    ],
    "pestilentiel": [
        "pestilentiel"
    ],
    "pestilentielle": [
        "pestilentiel"
    ],
    "pestilentielles": [
        "pestilentiel"
    ],
    "pestilentiels": [
        "pestilentiel"
    ],
    "pesat": [
        "peser"
    ],
    "peserent": [
        "peser"
    ],
    "pese": [
        "peser"
    ],
    "pesee": [
        "pesee",
        "peser"
    ],
    "pesees": [
        "pesee",
        "peser"
    ],
    "peses": [
        "peser"
    ],
    "pet": [
        "pet"
    ],
    "petiot": [
        "petiot"
    ],
    "petiote": [
        "petiot"
    ],
    "petiots": [
        "petiot"
    ],
    "petit": [
        "petit"
    ],
    "petite": [
        "petit"
    ],
    "petitement": [
        "petitement"
    ],
    "petites": [
        "petite",
        "petit"
    ],
    "petitesse": [
        "petitesse"
    ],
    "petitesses": [
        "petitesse"
    ],
    "petits": [
        "petit"
    ],
    "peton": [
        "peton"
    ],
    "petons": [
        "peton",
        "peter"
    ],
    "petros": [
        "petro"
    ],
    "pets": [
        "pet"
    ],
    "petzouille": [
        "petzouille"
    ],
    "petzouilles": [
        "petzouille"
    ],
    "peu": [
        "peu"
    ],
    "peuchere": [
        "peuchere"
    ],
    "peuh": [
        "peuh"
    ],
    "peuhl": [
        "peuhl"
    ],
    "peul": [
        "peul"
    ],
    "peulh": [
        "peulh"
    ],
    "peupla": [
        "peupler"
    ],
    "peuplade": [
        "peuplade"
    ],
    "peuplades": [
        "peuplade"
    ],
    "peuplaient": [
        "peupler"
    ],
    "peuplait": [
        "peupler"
    ],
    "peuplant": [
        "peupler"
    ],
    "peuple": [
        "peuple",
        "peupler"
    ],
    "peuplement": [
        "peuplement"
    ],
    "peuplements": [
        "peuplement"
    ],
    "peuplent": [
        "peupler"
    ],
    "peupler": [
        "peupler"
    ],
    "peuplera": [
        "peupler"
    ],
    "peupleraie": [
        "peupleraie"
    ],
    "peuplerait": [
        "peupler"
    ],
    "peupleront": [
        "peupler"
    ],
    "peuples": [
        "peuple",
        "peupler"
    ],
    "peuplier": [
        "peuplier"
    ],
    "peupliers": [
        "peuplier"
    ],
    "peuplerent": [
        "peupler"
    ],
    "peuplee": [
        "peuple",
        "peupler"
    ],
    "peuplees": [
        "peuple",
        "peupler"
    ],
    "peur": [
        "peur"
    ],
    "peureuse": [
        "peureux"
    ],
    "peureusement": [
        "peureusement"
    ],
    "peureuses": [
        "peureux"
    ],
    "peureux": [
        "peureux"
    ],
    "peurs": [
        "peur"
    ],
    "peut": [
        "pouvoir"
    ],
    "peuvent": [
        "pouvoir"
    ],
    "peux": [
        "pouvoir"
    ],
    "peyotl": [
        "peyotl"
    ],
    "pfennig": [
        "pfennig"
    ],
    "pfennigs": [
        "pfennig"
    ],
    "pff": [
        "pff"
    ],
    "pfft": [
        "pfft"
    ],
    "pfutt": [
        "pfutt"
    ],
    "ph": [
        "ph"
    ],
    "phacochere": [
        "phacochere"
    ],
    "phacocheres": [
        "phacochere"
    ],
    "phagocyte": [
        "phagocyte",
        "phagocyter"
    ],
    "phagocyter": [
        "phagocyter"
    ],
    "phagocytes": [
        "phagocyte"
    ],
    "phalange": [
        "phalange"
    ],
    "phalanges": [
        "phalange"
    ],
    "phalangettes": [
        "phalangette"
    ],
    "phalangine": [
        "phalangine"
    ],
    "phalangisme": [
        "phalangisme"
    ],
    "phalangiste": [
        "phalangiste"
    ],
    "phalangistes": [
        "phalangiste"
    ],
    "phalanstere": [
        "phalanstere"
    ],
    "phalarope": [
        "phalarope"
    ],
    "phallique": [
        "phallique"
    ],
    "phalliques": [
        "phallique"
    ],
    "phallo": [
        "phallo"
    ],
    "phallocentrique": [
        "phallocentrique"
    ],
    "phallocrate": [
        "phallocrate"
    ],
    "phallocratie": [
        "phallocratie"
    ],
    "phallocratique": [
        "phallocratique"
    ],
    "phallocratiques": [
        "phallocratique"
    ],
    "phallologie": [
        "phallologie"
    ],
    "phallophore": [
        "phallophore"
    ],
    "phalloides": [
        "phalloide"
    ],
    "phallus": [
        "phallus"
    ],
    "phalene": [
        "phalene"
    ],
    "phalenes": [
        "phalene"
    ],
    "phalere": [
        "phalere"
    ],
    "phantasme": [
        "phantasme"
    ],
    "phantasmes": [
        "phantasme"
    ],
    "phaneres": [
        "phanere"
    ],
    "phanerogames": [
        "phanerogame"
    ],
    "pharamineuses": [
        "pharamineux"
    ],
    "pharamineux": [
        "pharamineux"
    ],
    "pharaon": [
        "pharaon"
    ],
    "pharaonique": [
        "pharaonique"
    ],
    "pharaoniques": [
        "pharaonique"
    ],
    "pharaonnes": [
        "pharaon"
    ],
    "pharaons": [
        "pharaon"
    ],
    "phare": [
        "phare"
    ],
    "phares": [
        "phare"
    ],
    "pharisaique": [
        "pharisaique"
    ],
    "pharisaiques": [
        "pharisaique"
    ],
    "pharisaisme": [
        "pharisaisme"
    ],
    "pharisaismes": [
        "pharisaisme"
    ],
    "pharisien": [
        "pharisien"
    ],
    "pharisiens": [
        "pharisien"
    ],
    "pharma": [
        "pharma"
    ],
    "pharmaceutique": [
        "pharmaceutique"
    ],
    "pharmaceutiques": [
        "pharmaceutique"
    ],
    "pharmacie": [
        "pharmacie"
    ],
    "pharmacien": [
        "pharmacien"
    ],
    "pharmacienne": [
        "pharmacien"
    ],
    "pharmaciens": [
        "pharmacien"
    ],
    "pharmacies": [
        "pharmacy",
        "pharmacie"
    ],
    "pharmaco": [
        "pharmaco"
    ],
    "pharmacognosie": [
        "pharmacognosie"
    ],
    "pharmacologie": [
        "pharmacologie"
    ],
    "pharmacologique": [
        "pharmacologique"
    ],
    "pharmacomanie": [
        "pharmacomanie"
    ],
    "pharmacopee": [
        "pharmacopee"
    ],
    "pharmacotherapie": [
        "pharmacotherapie"
    ],
    "pharyngite": [
        "pharyngite"
    ],
    "pharynx": [
        "pharynx"
    ],
    "phascolome": [
        "phascolome"
    ],
    "phase": [
        "phase"
    ],
    "phases": [
        "phase"
    ],
    "phasmes": [
        "phasme"
    ],
    "phaeton": [
        "phaeton"
    ],
    "phi": [
        "phi"
    ],
    "philanthrope": [
        "philanthrope"
    ],
    "philanthropes": [
        "philanthrope"
    ],
    "philanthropie": [
        "philanthropie"
    ],
    "philanthropique": [
        "philanthropique"
    ],
    "philanthropiques": [
        "philanthropique"
    ],
    "philarete": [
        "philarete"
    ],
    "philatelie": [
        "philatelie"
    ],
    "philateliste": [
        "philateliste"
    ],
    "philatelistes": [
        "philateliste"
    ],
    "philharmonie": [
        "philharmonie"
    ],
    "philharmonique": [
        "philharmonique"
    ],
    "philhellene": [
        "philhellene"
    ],
    "philhellenes": [
        "philhellene"
    ],
    "philippin": [
        "philippin"
    ],
    "philippine": [
        "philippin"
    ],
    "philippines": [
        "philippin"
    ],
    "philippins": [
        "philippin"
    ],
    "philistin": [
        "philistin"
    ],
    "philistins": [
        "philistin"
    ],
    "philo": [
        "philo"
    ],
    "philodendron": [
        "philodendron"
    ],
    "philodendrons": [
        "philodendron"
    ],
    "philologie": [
        "philologie"
    ],
    "philologique": [
        "philologique"
    ],
    "philologiques": [
        "philologique"
    ],
    "philologue": [
        "philologue"
    ],
    "philologues": [
        "philologue"
    ],
    "philos": [
        "philo"
    ],
    "philosophaient": [
        "philosopher"
    ],
    "philosophaillerie": [
        "philosophaillerie"
    ],
    "philosophait": [
        "philosopher"
    ],
    "philosophal": [
        "philosophal"
    ],
    "philosophale": [
        "philosophal"
    ],
    "philosophales": [
        "philosophal"
    ],
    "philosophant": [
        "philosophant",
        "philosopher"
    ],
    "philosophard": [
        "philosophard"
    ],
    "philosophe": [
        "philosophe",
        "philosopher"
    ],
    "philosopher": [
        "philosopher"
    ],
    "philosophes": [
        "philosophe",
        "philosopher"
    ],
    "philosophie": [
        "philosophie"
    ],
    "philosophies": [
        "philosophy",
        "philosophie"
    ],
    "philosophique": [
        "philosophique"
    ],
    "philosophiquement": [
        "philosophiquement"
    ],
    "philosophiques": [
        "philosophique"
    ],
    "philosophons": [
        "philosopher"
    ],
    "philosemites": [
        "philosemite"
    ],
    "philosemitisme": [
        "philosemitisme"
    ],
    "philotechnique": [
        "philotechnique"
    ],
    "philtre": [
        "philtre"
    ],
    "philtres": [
        "philtre"
    ],
    "phimosis": [
        "phimosis"
    ],
    "phlox": [
        "phlox"
    ],
    "phlebite": [
        "phlebite"
    ],
    "phlebites": [
        "phlebite"
    ],
    "phlebographie": [
        "phlebographie"
    ],
    "phlebologue": [
        "phlebologue"
    ],
    "phlebotomie": [
        "phlebotomie"
    ],
    "phobie": [
        "phobie"
    ],
    "phobies": [
        "phobie"
    ],
    "phobique": [
        "phobique"
    ],
    "phobiques": [
        "phobique"
    ],
    "phoceenne": [
        "phoceen"
    ],
    "phoenix": [
        "phoenix"
    ],
    "phonatoire": [
        "phonatoire"
    ],
    "phone": [
        "phone"
    ],
    "phones": [
        "phone"
    ],
    "phonique": [
        "phonique"
    ],
    "phoniques": [
        "phonique"
    ],
    "phono": [
        "phono"
    ],
    "phonographe": [
        "phonographe"
    ],
    "phonographes": [
        "phonographe"
    ],
    "phonographiques": [
        "phonographique"
    ],
    "phonologie": [
        "phonologie"
    ],
    "phonos": [
        "phono"
    ],
    "phonemes": [
        "phoneme"
    ],
    "phoneticien": [
        "phoneticien"
    ],
    "phonetique": [
        "phonetique"
    ],
    "phonetiquement": [
        "phonetiquement"
    ],
    "phonetiques": [
        "phonetique"
    ],
    "phoque": [
        "phoque"
    ],
    "phoques": [
        "phoque"
    ],
    "phosgene": [
        "phosgene"
    ],
    "phosphatase": [
        "phosphatase"
    ],
    "phosphate": [
        "phosphate"
    ],
    "phosphates": [
        "phosphate"
    ],
    "phosphatine": [
        "phosphatine"
    ],
    "phospholipide": [
        "phospholipide"
    ],
    "phosphore": [
        "phosphorer",
        "phosphore"
    ],
    "phosphorescence": [
        "phosphorescence"
    ],
    "phosphorescences": [
        "phosphorescence"
    ],
    "phosphorescent": [
        "phosphorescent"
    ],
    "phosphorescente": [
        "phosphorescent"
    ],
    "phosphorescentes": [
        "phosphorescent"
    ],
    "phosphorescents": [
        "phosphorescent"
    ],
    "phosphorylation": [
        "phosphorylation"
    ],
    "phosphene": [
        "phosphene"
    ],
    "phosphenes": [
        "phosphene"
    ],
    "phot": [
        "phot"
    ],
    "photique": [
        "photique"
    ],
    "photo": [
        "photo"
    ],
    "photochimique": [
        "photochimique"
    ],
    "photocomposition": [
        "photocomposition"
    ],
    "photoconducteur": [
        "photoconducteur"
    ],
    "photocopie": [
        "photocopier",
        "photocopie"
    ],
    "photocopient": [
        "photocopier"
    ],
    "photocopier": [
        "photocopier"
    ],
    "photocopiera": [
        "photocopier"
    ],
    "photocopierai": [
        "photocopier"
    ],
    "photocopies": [
        "photocopier",
        "photocopy",
        "photocopie"
    ],
    "photocopieur": [
        "photocopieur"
    ],
    "photocopieurs": [
        "photocopieur"
    ],
    "photocopieuse": [
        "photocopieur"
    ],
    "photocopieuses": [
        "photocopieur"
    ],
    "photocopiee": [
        "photocopier"
    ],
    "photocopiees": [
        "photocopier"
    ],
    "photogramme": [
        "photogramme"
    ],
    "photographe": [
        "photographe"
    ],
    "photographes": [
        "photographe"
    ],
    "photographia": [
        "photographier"
    ],
    "photographiable": [
        "photographiable"
    ],
    "photographiaient": [
        "photographier"
    ],
    "photographiais": [
        "photographier"
    ],
    "photographiait": [
        "photographier"
    ],
    "photographiant": [
        "photographier"
    ],
    "photographie": [
        "photographie",
        "photographier"
    ],
    "photographient": [
        "photographier"
    ],
    "photographier": [
        "photographier"
    ],
    "photographierai": [
        "photographier"
    ],
    "photographierait": [
        "photographier"
    ],
    "photographierions": [
        "photographier"
    ],
    "photographierons": [
        "photographier"
    ],
    "photographieront": [
        "photographier"
    ],
    "photographies": [
        "photographie",
        "photographier",
        "photography"
    ],
    "photographiez": [
        "photographier"
    ],
    "photographique": [
        "photographique"
    ],
    "photographiques": [
        "photographique"
    ],
    "photographiat": [
        "photographier"
    ],
    "photographierent": [
        "photographier"
    ],
    "photographiee": [
        "photographier"
    ],
    "photographiees": [
        "photographier"
    ],
    "photograveur": [
        "photograveur"
    ],
    "photogravure": [
        "photogravure"
    ],
    "photogenie": [
        "photogenie"
    ],
    "photogenique": [
        "photogenique"
    ],
    "photogeniques": [
        "photogenique"
    ],
    "photojournalisme": [
        "photojournalisme"
    ],
    "photojournaliste": [
        "photojournaliste"
    ],
    "photomaton": [
        "photomaton"
    ],
    "photomatons": [
        "photomaton"
    ],
    "photomicrographie": [
        "photomicrographie"
    ],
    "photomontage": [
        "photomontage"
    ],
    "photomontages": [
        "photomontage"
    ],
    "photon": [
        "photon"
    ],
    "photonique": [
        "photonique"
    ],
    "photons": [
        "photon"
    ],
    "photophobie": [
        "photophobie"
    ],
    "photopile": [
        "photopile"
    ],
    "photoperiodique": [
        "photoperiodique"
    ],
    "photos": [
        "photo"
    ],
    "photosensibilite": [
        "photosensibilite"
    ],
    "photosensible": [
        "photosensible"
    ],
    "photosensibles": [
        "photosensible"
    ],
    "photostat": [
        "photostat"
    ],
    "photosynthese": [
        "photosynthese"
    ],
    "phototaxie": [
        "phototaxie"
    ],
    "phototype": [
        "phototype"
    ],
    "photovoltaique": [
        "photovoltaique"
    ],
    "photoelectrique": [
        "photoelectrique"
    ],
    "phragmites": [
        "phragmite"
    ],
    "phrase": [
        "phrase",
        "phraser"
    ],
    "phraser": [
        "phraser"
    ],
    "phrases": [
        "phrase",
        "phraser"
    ],
    "phraseur": [
        "phraseur"
    ],
    "phraseurs": [
        "phraseur"
    ],
    "phrasee": [
        "phraser"
    ],
    "phraseologie": [
        "phraseologie"
    ],
    "phraseologies": [
        "phraseologie"
    ],
    "phraseologique": [
        "phraseologique"
    ],
    "phrygien": [
        "phrygien"
    ],
    "phrygiens": [
        "phrygien"
    ],
    "phreatique": [
        "phreatique"
    ],
    "phreatiques": [
        "phreatique"
    ],
    "phrenique": [
        "phrenique"
    ],
    "phrenologie": [
        "phrenologie"
    ],
    "phrenologiste": [
        "phrenologiste"
    ],
    "phrenologistes": [
        "phrenologiste"
    ],
    "phrenologues": [
        "phrenologue"
    ],
    "phtaleine": [
        "phtaleine"
    ],
    "phtiriasis": [
        "phtiriasis"
    ],
    "phtisie": [
        "phtisie"
    ],
    "phtisiologie": [
        "phtisiologie"
    ],
    "phtisique": [
        "phtisique"
    ],
    "phtisiques": [
        "phtisique"
    ],
    "phylactere": [
        "phylactere"
    ],
    "phylloxera": [
        "phylloxera"
    ],
    "phylogenese": [
        "phylogenese"
    ],
    "phylum": [
        "phylum"
    ],
    "phynances": [
        "phynances"
    ],
    "physicien": [
        "physicien"
    ],
    "physicienne": [
        "physicien"
    ],
    "physiciennes": [
        "physicien"
    ],
    "physiciens": [
        "physicien"
    ],
    "physio": [
        "physio"
    ],
    "physiologie": [
        "physiologie"
    ],
    "physiologies": [
        "physiology",
        "physiologie"
    ],
    "physiologique": [
        "physiologique"
    ],
    "physiologiquement": [
        "physiologiquement"
    ],
    "physiologiques": [
        "physiologique"
    ],
    "physiologiste": [
        "physiologiste"
    ],
    "physionomie": [
        "physionomie"
    ],
    "physionomies": [
        "physionomie"
    ],
    "physionomique": [
        "physionomique"
    ],
    "physionomiste": [
        "physionomiste"
    ],
    "physionomistes": [
        "physionomiste"
    ],
    "physiotherapie": [
        "physiotherapie"
    ],
    "physique": [
        "physique"
    ],
    "physiquement": [
        "physiquement"
    ],
    "physiques": [
        "physique"
    ],
    "phytoplancton": [
        "phytoplancton"
    ],
    "phenate": [
        "phenate"
    ],
    "phenicien": [
        "phenicien"
    ],
    "phenicienne": [
        "phenicien"
    ],
    "pheniciennes": [
        "phenicien"
    ],
    "pheniciens": [
        "phenicien"
    ],
    "phenique": [
        "phenique"
    ],
    "pheniques": [
        "phenique"
    ],
    "phenix": [
        "phenix"
    ],
    "phenobarbital": [
        "phenobarbital"
    ],
    "phenol": [
        "phenol"
    ],
    "phenomene": [
        "phenomene"
    ],
    "phenomenes": [
        "phenomene"
    ],
    "phenomenal": [
        "phenomenal"
    ],
    "phenomenale": [
        "phenomenal"
    ],
    "phenomenalement": [
        "phenomenalement"
    ],
    "phenomenales": [
        "phenomenal"
    ],
    "phenomenaux": [
        "phenomenal"
    ],
    "phenomenologie": [
        "phenomenologie"
    ],
    "phenomenologique": [
        "phenomenologique"
    ],
    "phenomenologues": [
        "phenomenologue"
    ],
    "phenothiazine": [
        "phenothiazine"
    ],
    "phenotype": [
        "phenotype"
    ],
    "pheochromocytome": [
        "pheochromocytome"
    ],
    "pheromone": [
        "pheromone"
    ],
    "pheromones": [
        "pheromone"
    ],
    "pi": [
        "pi"
    ],
    "piaf": [
        "piaf"
    ],
    "piaffa": [
        "piaffer"
    ],
    "piaffaient": [
        "piaffer"
    ],
    "piaffait": [
        "piaffer"
    ],
    "piaffant": [
        "piaffer",
        "piaffant"
    ],
    "piaffante": [
        "piaffant"
    ],
    "piaffantes": [
        "piaffant"
    ],
    "piaffants": [
        "piaffant"
    ],
    "piaffe": [
        "piaffer"
    ],
    "piaffement": [
        "piaffement"
    ],
    "piaffements": [
        "piaffement"
    ],
    "piaffent": [
        "piaffer"
    ],
    "piaffer": [
        "piaffer"
    ],
    "piaffes": [
        "piaffer"
    ],
    "piafs": [
        "piaf"
    ],
    "piailla": [
        "piailler"
    ],
    "piaillaient": [
        "piailler"
    ],
    "piaillais": [
        "piailler"
    ],
    "piaillait": [
        "piailler"
    ],
    "piaillant": [
        "piaillant",
        "piailler"
    ],
    "piaillante": [
        "piaillant"
    ],
    "piaillantes": [
        "piaillant"
    ],
    "piaillarde": [
        "piaillard"
    ],
    "piaillards": [
        "piaillard"
    ],
    "piaille": [
        "piailler"
    ],
    "piaillement": [
        "piaillement"
    ],
    "piaillements": [
        "piaillement"
    ],
    "piaillent": [
        "piailler"
    ],
    "piailler": [
        "piailler"
    ],
    "piaillerie": [
        "piaillerie"
    ],
    "piailleries": [
        "piaillerie"
    ],
    "piailleurs": [
        "piailleur"
    ],
    "piailleuse": [
        "piailleur"
    ],
    "piaillerent": [
        "piailler"
    ],
    "pian": [
        "pian"
    ],
    "pianissimo": [
        "pianissimo"
    ],
    "pianissimos": [
        "pianissimo"
    ],
    "pianiste": [
        "pianiste"
    ],
    "pianistes": [
        "pianiste"
    ],
    "piano": [
        "piano"
    ],
    "pianola": [
        "pianola"
    ],
    "pianos": [
        "piano"
    ],
    "pianota": [
        "pianoter"
    ],
    "pianotage": [
        "pianotage"
    ],
    "pianotaient": [
        "pianoter"
    ],
    "pianotait": [
        "pianoter"
    ],
    "pianotant": [
        "pianoter"
    ],
    "pianote": [
        "pianoter"
    ],
    "pianoter": [
        "pianoter"
    ],
    "pianoterent": [
        "pianoter"
    ],
    "pianotee": [
        "pianoter"
    ],
    "piastre": [
        "piastre"
    ],
    "piastres": [
        "piastre"
    ],
    "piaula": [
        "piauler"
    ],
    "piaulaient": [
        "piauler"
    ],
    "piaulait": [
        "piauler"
    ],
    "piaulant": [
        "piaulant",
        "piauler"
    ],
    "piaulante": [
        "piaulant"
    ],
    "piaule": [
        "piaule",
        "piauler"
    ],
    "piaulement": [
        "piaulement"
    ],
    "piaulements": [
        "piaulement"
    ],
    "piaulent": [
        "piauler"
    ],
    "piauler": [
        "piauler"
    ],
    "piaulera": [
        "piauler"
    ],
    "piaules": [
        "piaule"
    ],
    "piauleur": [
        "piauleur"
    ],
    "piaulerent": [
        "piauler"
    ],
    "piaye": [
        "piaye"
    ],
    "piazza": [
        "piazza"
    ],
    "piazzetta": [
        "piazzetta"
    ],
    "pibloque": [
        "pibloque"
    ],
    "pic": [
        "pic"
    ],
    "pica": [
        "pica"
    ],
    "picador": [
        "picador"
    ],
    "picadors": [
        "picador"
    ],
    "picaillon": [
        "picaillon"
    ],
    "picaillons": [
        "picaillon"
    ],
    "picard": [
        "picard"
    ],
    "picarde": [
        "picard"
    ],
    "picardes": [
        "picard"
    ],
    "picards": [
        "picard"
    ],
    "picaresque": [
        "picaresque"
    ],
    "picaresques": [
        "picaresque"
    ],
    "picaro": [
        "picaro"
    ],
    "picassien": [
        "picassien"
    ],
    "piccolo": [
        "piccolo"
    ],
    "piccolos": [
        "piccolo"
    ],
    "pichenette": [
        "pichenette"
    ],
    "pichenettes": [
        "pichenette"
    ],
    "pichet": [
        "pichet"
    ],
    "pichets": [
        "pichet"
    ],
    "picker": [
        "picker"
    ],
    "pickles": [
        "pickle"
    ],
    "pickpocket": [
        "pickpocket"
    ],
    "pickpockets": [
        "pickpocket"
    ],
    "pico": [
        "pico"
    ],
    "picolaient": [
        "picoler"
    ],
    "picolais": [
        "picoler"
    ],
    "picolait": [
        "picoler"
    ],
    "picolant": [
        "picoler"
    ],
    "picole": [
        "picoler"
    ],
    "picolent": [
        "picoler"
    ],
    "picoler": [
        "picoler"
    ],
    "picolerait": [
        "picoler"
    ],
    "picoles": [
        "picoler"
    ],
    "picoleur": [
        "picoleur"
    ],
    "picoleurs": [
        "picoleur"
    ],
    "picolez": [
        "picoler"
    ],
    "picoliez": [
        "picoler"
    ],
    "picolo": [
        "picolo"
    ],
    "picora": [
        "picorer"
    ],
    "picoraient": [
        "picorer"
    ],
    "picorait": [
        "picorer"
    ],
    "picorant": [
        "picorer"
    ],
    "picore": [
        "picorer"
    ],
    "picorent": [
        "picorer"
    ],
    "picorer": [
        "picorer"
    ],
    "picoreur": [
        "picoreur"
    ],
    "picorez": [
        "picorer"
    ],
    "picoree": [
        "picoree",
        "picorer"
    ],
    "picorees": [
        "picorer"
    ],
    "picores": [
        "picorer"
    ],
    "picot": [
        "picot"
    ],
    "picota": [
        "picoter"
    ],
    "picotaient": [
        "picoter"
    ],
    "picotait": [
        "picoter"
    ],
    "picotant": [
        "picoter"
    ],
    "picote": [
        "picoter",
        "picote"
    ],
    "picotement": [
        "picotement"
    ],
    "picotements": [
        "picotement"
    ],
    "picotent": [
        "picoter"
    ],
    "picoter": [
        "picoter"
    ],
    "picotin": [
        "picotin"
    ],
    "picotis": [
        "picotis"
    ],
    "picots": [
        "picot"
    ],
    "picotees": [
        "picoter"
    ],
    "picrate": [
        "picrate"
    ],
    "picrique": [
        "picrique"
    ],
    "pics": [
        "pic"
    ],
    "picsou": [
        "picsou"
    ],
    "pictogramme": [
        "pictogramme"
    ],
    "pictogrammes": [
        "pictogramme"
    ],
    "picton": [
        "picton"
    ],
    "pictural": [
        "pictural"
    ],
    "picturale": [
        "pictural"
    ],
    "picturalement": [
        "picturalement"
    ],
    "picturales": [
        "pictural"
    ],
    "picte": [
        "picter"
    ],
    "pidgin": [
        "pidgin"
    ],
    "pie": [
        "pie"
    ],
    "pied": [
        "pied"
    ],
    "piedmont": [
        "piedmont"
    ],
    "pieds": [
        "pied"
    ],
    "pier": [
        "pier"
    ],
    "piercing": [
        "piercing",
        "pierce"
    ],
    "piercings": [
        "piercing"
    ],
    "pierraille": [
        "pierraille"
    ],
    "pierrailles": [
        "pierraille"
    ],
    "pierre": [
        "pierre"
    ],
    "pierreries": [
        "pierreries"
    ],
    "pierres": [
        "pierre"
    ],
    "pierreuse": [
        "pierreux"
    ],
    "pierreuses": [
        "pierreux"
    ],
    "pierreux": [
        "pierreux"
    ],
    "pierrier": [
        "pierrier"
    ],
    "pierriers": [
        "pierrier"
    ],
    "pierriere": [
        "pierriere"
    ],
    "pierrot": [
        "pierrot"
    ],
    "pierrots": [
        "pierrot"
    ],
    "pierrures": [
        "pierrure"
    ],
    "pies": [
        "pie"
    ],
    "pieta": [
        "pieta",
        "pieter"
    ],
    "pieu": [
        "pieu"
    ],
    "pieuse": [
        "pieux"
    ],
    "pieusement": [
        "pieusement"
    ],
    "pieuses": [
        "pieux"
    ],
    "pieutait": [
        "pieuter"
    ],
    "pieute": [
        "pieuter"
    ],
    "pieuter": [
        "pieuter"
    ],
    "pieuterez": [
        "pieuter"
    ],
    "pieutes": [
        "pieuter"
    ],
    "pieutez": [
        "pieuter"
    ],
    "pieutee": [
        "pieuter"
    ],
    "pieuvre": [
        "pieuvre"
    ],
    "pieuvres": [
        "pieuvre"
    ],
    "pieux": [
        "pieux"
    ],
    "pif": [
        "pif"
    ],
    "pifer": [
        "pifer"
    ],
    "piffait": [
        "piffer"
    ],
    "piffer": [
        "piffer"
    ],
    "piffre": [
        "piffre"
    ],
    "piffrer": [
        "piffrer"
    ],
    "piffe": [
        "piffer"
    ],
    "pifometre": [
        "pifometre"
    ],
    "pige": [
        "pige",
        "piger"
    ],
    "pigeais": [
        "piger"
    ],
    "pigeait": [
        "piger"
    ],
    "pigent": [
        "piger"
    ],
    "pigeon": [
        "pigeon"
    ],
    "pigeonnant": [
        "pigeonner",
        "pigeonnant"
    ],
    "pigeonnante": [
        "pigeonnant"
    ],
    "pigeonnants": [
        "pigeonnant"
    ],
    "pigeonne": [
        "pigeonner",
        "pigeon"
    ],
    "pigeonneau": [
        "pigeonneau"
    ],
    "pigeonneaux": [
        "pigeonneau"
    ],
    "pigeonner": [
        "pigeonner"
    ],
    "pigeonnier": [
        "pigeonnier"
    ],
    "pigeonniers": [
        "pigeonnier"
    ],
    "pigeons": [
        "pigeon",
        "piger"
    ],
    "piger": [
        "piger"
    ],
    "pigera": [
        "piger"
    ],
    "pigerai": [
        "piger"
    ],
    "pigeraient": [
        "piger"
    ],
    "pigerait": [
        "piger"
    ],
    "pigeras": [
        "piger"
    ],
    "pigerez": [
        "piger"
    ],
    "piges": [
        "pige",
        "piger"
    ],
    "pigez": [
        "piger"
    ],
    "pigiste": [
        "pigiste"
    ],
    "pigistes": [
        "pigiste"
    ],
    "pigment": [
        "pigment"
    ],
    "pigmentaire": [
        "pigmentaire"
    ],
    "pigmentation": [
        "pigmentation"
    ],
    "pigments": [
        "pigment"
    ],
    "pigne": [
        "pigne"
    ],
    "pigner": [
        "pigner"
    ],
    "pignes": [
        "pigne"
    ],
    "pignochait": [
        "pignocher"
    ],
    "pignole": [
        "pignole"
    ],
    "pignon": [
        "pignon"
    ],
    "pignons": [
        "pignon"
    ],
    "pignouf": [
        "pignouf"
    ],
    "pignoufs": [
        "pignouf"
    ],
    "pila": [
        "piler"
    ],
    "pilaf": [
        "pilaf"
    ],
    "pilaient": [
        "piler"
    ],
    "pilait": [
        "piler"
    ],
    "pilant": [
        "piler"
    ],
    "pilastre": [
        "pilastre"
    ],
    "pilastres": [
        "pilastre"
    ],
    "pilchards": [
        "pilchard"
    ],
    "pile": [
        "piler",
        "pile",
        "pil"
    ],
    "pilent": [
        "piler"
    ],
    "piler": [
        "piler"
    ],
    "piles": [
        "pile",
        "piler"
    ],
    "pileuse": [
        "pileux"
    ],
    "pileuses": [
        "pileux",
        "pileur"
    ],
    "pileux": [
        "pileux"
    ],
    "pilier": [
        "pilier"
    ],
    "piliers": [
        "pilier"
    ],
    "pilifere": [
        "pilifere"
    ],
    "pilla": [
        "piller"
    ],
    "pillage": [
        "pillage"
    ],
    "pillages": [
        "pillage"
    ],
    "pillaient": [
        "piller"
    ],
    "pillais": [
        "piller"
    ],
    "pillait": [
        "piller"
    ],
    "pillant": [
        "piller"
    ],
    "pillard": [
        "pillard"
    ],
    "pillarde": [
        "pillard"
    ],
    "pillards": [
        "pillard"
    ],
    "pille": [
        "piller"
    ],
    "pillent": [
        "piller"
    ],
    "piller": [
        "piller"
    ],
    "pillera": [
        "piller"
    ],
    "pillerait": [
        "piller"
    ],
    "pillerons": [
        "piller"
    ],
    "pilleront": [
        "piller"
    ],
    "pilles": [
        "piller"
    ],
    "pilleur": [
        "pilleur"
    ],
    "pilleurs": [
        "pilleur"
    ],
    "pilleuse": [
        "pilleur"
    ],
    "pillez": [
        "piller"
    ],
    "pilliez": [
        "piller"
    ],
    "pillons": [
        "piller"
    ],
    "pillerent": [
        "piller"
    ],
    "pillee": [
        "piller"
    ],
    "pillees": [
        "piller"
    ],
    "piloches": [
        "piloche"
    ],
    "pilon": [
        "pilon"
    ],
    "pilonnage": [
        "pilonnage"
    ],
    "pilonnages": [
        "pilonnage"
    ],
    "pilonnaient": [
        "pilonner"
    ],
    "pilonnait": [
        "pilonner"
    ],
    "pilonnant": [
        "pilonner"
    ],
    "pilonnent": [
        "pilonner"
    ],
    "pilonner": [
        "pilonner"
    ],
    "pilonnera": [
        "pilonner"
    ],
    "pilonneurs": [
        "pilonneur"
    ],
    "pilonnez": [
        "pilonner"
    ],
    "pilonne": [
        "pilonner"
    ],
    "pilonnee": [
        "pilonner"
    ],
    "pilonnees": [
        "pilonner"
    ],
    "pilonnes": [
        "pilonner"
    ],
    "pilons": [
        "pilon"
    ],
    "pilori": [
        "pilori"
    ],
    "piloris": [
        "pilori"
    ],
    "pilosite": [
        "pilosite"
    ],
    "pilot": [
        "pilot"
    ],
    "pilota": [
        "piloter"
    ],
    "pilotage": [
        "pilotage"
    ],
    "pilotaient": [
        "piloter"
    ],
    "pilotais": [
        "piloter"
    ],
    "pilotait": [
        "piloter"
    ],
    "pilotant": [
        "piloter"
    ],
    "pilote": [
        "pilote",
        "piloter"
    ],
    "pilotent": [
        "piloter"
    ],
    "piloter": [
        "piloter"
    ],
    "pilotera": [
        "piloter"
    ],
    "piloterai": [
        "piloter"
    ],
    "piloterait": [
        "piloter"
    ],
    "piloteras": [
        "piloter"
    ],
    "piloteront": [
        "piloter"
    ],
    "pilotes": [
        "pilote",
        "piloter"
    ],
    "pilotez": [
        "piloter"
    ],
    "pilotiez": [
        "piloter"
    ],
    "pilotin": [
        "pilotin"
    ],
    "pilotis": [
        "pilotis"
    ],
    "piloterent": [
        "piloter"
    ],
    "pilotee": [
        "piloter"
    ],
    "pilotees": [
        "piloter"
    ],
    "pilou": [
        "pilou"
    ],
    "pilsen": [
        "pilsen"
    ],
    "pilule": [
        "pilule"
    ],
    "pilules": [
        "pilule"
    ],
    "pilum": [
        "pilum"
    ],
    "pilee": [
        "pilee",
        "piler"
    ],
    "pilees": [
        "pilee",
        "piler"
    ],
    "pimbeche": [
        "pimbeche"
    ],
    "pimbeches": [
        "pimbeche"
    ],
    "piment": [
        "piment"
    ],
    "pimenta": [
        "pimenter"
    ],
    "pimentait": [
        "pimenter"
    ],
    "pimentant": [
        "pimenter"
    ],
    "pimente": [
        "pimente",
        "pimenter"
    ],
    "pimentent": [
        "pimenter"
    ],
    "pimenter": [
        "pimenter"
    ],
    "piments": [
        "piment"
    ],
    "pimentee": [
        "pimente",
        "pimenter"
    ],
    "pimentees": [
        "pimente",
        "pimenter"
    ],
    "pimentes": [
        "pimente"
    ],
    "pimpant": [
        "pimpant"
    ],
    "pimpante": [
        "pimpant"
    ],
    "pimpantes": [
        "pimpant"
    ],
    "pimpants": [
        "pimpant"
    ],
    "pimpon": [
        "pimpon"
    ],
    "pimpons": [
        "pimpon"
    ],
    "pimprenelle": [
        "pimprenelle"
    ],
    "pimprenelles": [
        "pimprenelle"
    ],
    "pin": [
        "pin"
    ],
    "pin's": [
        "pin's"
    ],
    "pina": [
        "piner"
    ],
    "pinacle": [
        "pinacle"
    ],
    "pinacles": [
        "pinacle"
    ],
    "pinacotheque": [
        "pinacotheque"
    ],
    "pinaillage": [
        "pinaillage"
    ],
    "pinaillait": [
        "pinailler"
    ],
    "pinaille": [
        "pinailler"
    ],
    "pinailler": [
        "pinailler"
    ],
    "pinailles": [
        "pinailler"
    ],
    "pinailleur": [
        "pinailleur"
    ],
    "pinard": [
        "pinard"
    ],
    "pinardiers": [
        "pinardier"
    ],
    "pinardiere": [
        "pinardier"
    ],
    "pinards": [
        "pinard"
    ],
    "pinasse": [
        "pinasse"
    ],
    "pinasses": [
        "pinasse"
    ],
    "pince": [
        "pincer",
        "pince"
    ],
    "pinceau": [
        "pinceau"
    ],
    "pinceaux": [
        "pinceau"
    ],
    "pincement": [
        "pincement"
    ],
    "pincements": [
        "pincement"
    ],
    "pincent": [
        "pincer"
    ],
    "pincer": [
        "pouvoir",
        "pincer"
    ],
    "pincera": [
        "pincer"
    ],
    "pincerai": [
        "pincer"
    ],
    "pinceras": [
        "pincer"
    ],
    "pincerez": [
        "pincer"
    ],
    "pincerons": [
        "pincer"
    ],
    "pinces": [
        "pincer",
        "pince"
    ],
    "pincette": [
        "pincette"
    ],
    "pincettes": [
        "pincette"
    ],
    "pinceur": [
        "pinceur"
    ],
    "pincez": [
        "pincer"
    ],
    "pinchart": [
        "pinchart"
    ],
    "pinciez": [
        "pincer"
    ],
    "pincions": [
        "pincer"
    ],
    "pincerent": [
        "pincer"
    ],
    "pincee": [
        "pincer",
        "pincee"
    ],
    "pincees": [
        "pincer",
        "pincee"
    ],
    "pine": [
        "piner",
        "pine"
    ],
    "pineau": [
        "pineau"
    ],
    "piner": [
        "piner"
    ],
    "pines": [
        "pine"
    ],
    "pinglot": [
        "pinglot"
    ],
    "pinglots": [
        "pinglot"
    ],
    "pingouin": [
        "pingouin"
    ],
    "pingouins": [
        "pingouin"
    ],
    "pingre": [
        "pingre"
    ],
    "pingrerie": [
        "pingrerie"
    ],
    "pingres": [
        "pingre"
    ],
    "pink": [
        "pink"
    ],
    "pinot": [
        "pinot"
    ],
    "pinots": [
        "pinot"
    ],
    "pins": [
        "pin"
    ],
    "pinson": [
        "pinson"
    ],
    "pinsons": [
        "pinson"
    ],
    "pinta": [
        "pinter"
    ],
    "pintade": [
        "pintade"
    ],
    "pintades": [
        "pintade"
    ],
    "pintait": [
        "pinter"
    ],
    "pinte": [
        "pinte",
        "pinter"
    ],
    "pinter": [
        "pinter"
    ],
    "pintes": [
        "pinte",
        "pinter"
    ],
    "pintee": [
        "pinter"
    ],
    "pinca": [
        "pincer"
    ],
    "pincage": [
        "pincage"
    ],
    "pincai": [
        "pincer"
    ],
    "pincaient": [
        "pincer"
    ],
    "pincais": [
        "pincer"
    ],
    "pincait": [
        "pincer"
    ],
    "pincant": [
        "pincer"
    ],
    "pincard": [
        "pincard"
    ],
    "pincon": [
        "pincon"
    ],
    "pincons": [
        "pincer",
        "pincon"
    ],
    "pincotait": [
        "pincoter"
    ],
    "pincotant": [
        "pincoter"
    ],
    "pincote": [
        "pincoter"
    ],
    "pincure": [
        "pincure"
    ],
    "pinede": [
        "pinede"
    ],
    "pinedes": [
        "pinede"
    ],
    "pineal": [
        "pineal"
    ],
    "pineale": [
        "pineal"
    ],
    "pineales": [
        "pineal"
    ],
    "piochaient": [
        "piocher"
    ],
    "piochais": [
        "piocher"
    ],
    "piochait": [
        "piocher"
    ],
    "piochant": [
        "piocher"
    ],
    "pioche": [
        "pioche",
        "piocher"
    ],
    "piochent": [
        "piocher"
    ],
    "piocher": [
        "piocher"
    ],
    "pioches": [
        "pioche",
        "piocher"
    ],
    "piocheur": [
        "piocheur"
    ],
    "piochez": [
        "piocher"
    ],
    "piochee": [
        "piocher"
    ],
    "piochees": [
        "piocher"
    ],
    "piolet": [
        "piolet"
    ],
    "pion": [
        "pion"
    ],
    "pionce": [
        "pioncer"
    ],
    "pioncent": [
        "pioncer"
    ],
    "pioncer": [
        "pioncer"
    ],
    "pioncera": [
        "pioncer"
    ],
    "pionces": [
        "pioncer"
    ],
    "pioncez": [
        "pioncer"
    ],
    "pionne": [
        "pion"
    ],
    "pionner": [
        "pionner"
    ],
    "pionnier": [
        "pionnier"
    ],
    "pionniers": [
        "pionnier"
    ],
    "pionniere": [
        "pionnier"
    ],
    "pionnieres": [
        "pionnier"
    ],
    "pions": [
        "pion"
    ],
    "pioncais": [
        "pioncer"
    ],
    "pioncait": [
        "pioncer"
    ],
    "pioncant": [
        "pioncer"
    ],
    "piot": [
        "piot"
    ],
    "piots": [
        "piot"
    ],
    "pioupiou": [
        "pioupiou"
    ],
    "pioupious": [
        "pioupiou"
    ],
    "pipa": [
        "pipa",
        "piper"
    ],
    "pipai": [
        "piper"
    ],
    "pipais": [
        "piper"
    ],
    "pipait": [
        "piper"
    ],
    "pipant": [
        "piper"
    ],
    "pipasse": [
        "piper"
    ],
    "pipe": [
        "pipe",
        "piper"
    ],
    "pipeau": [
        "pipeau"
    ],
    "pipeaux": [
        "pipeau"
    ],
    "pipelet": [
        "pipelet"
    ],
    "pipelets": [
        "pipelet"
    ],
    "pipelette": [
        "pipelette"
    ],
    "pipelettes": [
        "pipelette"
    ],
    "pipeline": [
        "pipeline"
    ],
    "pipelines": [
        "pipeline"
    ],
    "piper": [
        "piper"
    ],
    "pipera": [
        "piper"
    ],
    "piperade": [
        "piperade"
    ],
    "piperie": [
        "piperie"
    ],
    "pipes": [
        "pipe",
        "piper"
    ],
    "pipette": [
        "pipette"
    ],
    "pipettes": [
        "pipette"
    ],
    "pipeur": [
        "pipeur"
    ],
    "pipeuse": [
        "pipeur"
    ],
    "pipeuses": [
        "pipeur"
    ],
    "pipi": [
        "pipi"
    ],
    "pipiers": [
        "pipier"
    ],
    "pipis": [
        "pipi"
    ],
    "pipistrelle": [
        "pipistrelle"
    ],
    "pipo": [
        "pipo"
    ],
    "pipee": [
        "pipee"
    ],
    "pipees": [
        "pipee"
    ],
    "piqua": [
        "piquer"
    ],
    "piquage": [
        "piquage"
    ],
    "piquages": [
        "piquage"
    ],
    "piquai": [
        "piquer"
    ],
    "piquaient": [
        "piquer"
    ],
    "piquais": [
        "piquer"
    ],
    "piquait": [
        "piquer"
    ],
    "piquant": [
        "piquer",
        "piquant"
    ],
    "piquante": [
        "piquant"
    ],
    "piquantes": [
        "piquant"
    ],
    "piquants": [
        "piquant"
    ],
    "pique": [
        "pique",
        "piquer"
    ],
    "piquent": [
        "piquer"
    ],
    "piquer": [
        "piquer"
    ],
    "piquera": [
        "piquer"
    ],
    "piquerai": [
        "piquer"
    ],
    "piqueraient": [
        "piquer"
    ],
    "piquerais": [
        "piquer"
    ],
    "piquerait": [
        "piquer"
    ],
    "piqueras": [
        "piquer"
    ],
    "piquerez": [
        "piquer"
    ],
    "piquerons": [
        "piqueron"
    ],
    "piqueront": [
        "piquer"
    ],
    "piques": [
        "pique",
        "piquer"
    ],
    "piquet": [
        "piquet"
    ],
    "piquetage": [
        "piquetage"
    ],
    "piquetaient": [
        "piqueter"
    ],
    "piquetait": [
        "piqueter"
    ],
    "piqueter": [
        "piqueter"
    ],
    "piquetis": [
        "piquetis"
    ],
    "piquets": [
        "piquet"
    ],
    "piquette": [
        "piquette"
    ],
    "piquettes": [
        "piquette"
    ],
    "piquete": [
        "piqueter"
    ],
    "piquetee": [
        "piqueter",
        "piquete"
    ],
    "piquetees": [
        "piqueter"
    ],
    "piquetes": [
        "piqueter"
    ],
    "piqueur": [
        "piqueur"
    ],
    "piqueurs": [
        "piqueur"
    ],
    "piqueuse": [
        "piqueur",
        "piqueux"
    ],
    "piqueuses": [
        "piqueur",
        "piqueux"
    ],
    "piqueux": [
        "piqueux"
    ],
    "piquez": [
        "piquer"
    ],
    "piquier": [
        "piquier"
    ],
    "piquiez": [
        "piquer"
    ],
    "piquions": [
        "piquer"
    ],
    "piquons": [
        "piquer"
    ],
    "piquouse": [
        "piquouse"
    ],
    "piquouser": [
        "piquouser"
    ],
    "piquouses": [
        "piquouse"
    ],
    "piquouze": [
        "piquouze"
    ],
    "piquouzes": [
        "piquouze"
    ],
    "piquerent": [
        "piquer"
    ],
    "piquee": [
        "pique",
        "piquer"
    ],
    "piquees": [
        "pique",
        "piquer"
    ],
    "piqure": [
        "piqure"
    ],
    "piqures": [
        "piqure"
    ],
    "pirandellienne": [
        "pirandellien"
    ],
    "piranha": [
        "piranha"
    ],
    "piranhas": [
        "piranha"
    ],
    "piratage": [
        "piratage"
    ],
    "piratages": [
        "piratage"
    ],
    "pirataient": [
        "pirater"
    ],
    "piratant": [
        "pirater"
    ],
    "pirate": [
        "pirate",
        "pirater"
    ],
    "piratent": [
        "pirater"
    ],
    "pirater": [
        "pirater"
    ],
    "piraterie": [
        "piraterie"
    ],
    "pirateries": [
        "piraterie"
    ],
    "pirates": [
        "pirate",
        "pirater"
    ],
    "piratez": [
        "pirater"
    ],
    "piratee": [
        "pirater"
    ],
    "pire": [
        "pire"
    ],
    "pires": [
        "pire"
    ],
    "piriforme": [
        "piriforme"
    ],
    "piriformes": [
        "piriforme"
    ],
    "pirogue": [
        "pirogue"
    ],
    "pirogues": [
        "pirogue"
    ],
    "pirojki": [
        "pirojki"
    ],
    "pirojkis": [
        "pirojki"
    ],
    "pirolle": [
        "pirolle"
    ],
    "pirouetta": [
        "pirouetter"
    ],
    "pirouettais": [
        "pirouetter"
    ],
    "pirouettait": [
        "pirouetter"
    ],
    "pirouettant": [
        "pirouetter"
    ],
    "pirouette": [
        "pirouetter",
        "pirouette"
    ],
    "pirouetter": [
        "pirouetter"
    ],
    "pirouettes": [
        "pirouetter",
        "pirouette"
    ],
    "pis": [
        "pis",
        "pi"
    ],
    "pisa": [
        "piser"
    ],
    "pisan": [
        "pisan"
    ],
    "pisans": [
        "pisan"
    ],
    "piscicole": [
        "piscicole"
    ],
    "piscicoles": [
        "piscicole"
    ],
    "pisciculteur": [
        "pisciculteur"
    ],
    "pisciculture": [
        "pisciculture"
    ],
    "pisciforme": [
        "pisciforme"
    ],
    "piscine": [
        "piscine"
    ],
    "piscines": [
        "piscine"
    ],
    "pisiforme": [
        "pisiforme"
    ],
    "pissa": [
        "pisser"
    ],
    "pissaient": [
        "pisser"
    ],
    "pissais": [
        "pisser"
    ],
    "pissait": [
        "pisser"
    ],
    "pissaladiere": [
        "pissaladiere"
    ],
    "pissant": [
        "pisser"
    ],
    "pissat": [
        "pissat",
        "pisser"
    ],
    "pisse": [
        "pisse",
        "pisser"
    ],
    "pissenlit": [
        "pissenlit"
    ],
    "pissenlits": [
        "pissenlit"
    ],
    "pissent": [
        "pisser"
    ],
    "pisser": [
        "pisser"
    ],
    "pissera": [
        "pisser"
    ],
    "pisserai": [
        "pisser"
    ],
    "pisseraient": [
        "pisser"
    ],
    "pisserais": [
        "pisser"
    ],
    "pisserait": [
        "pisser"
    ],
    "pisseras": [
        "pisser"
    ],
    "pisses": [
        "pisse",
        "pisser",
        "piss"
    ],
    "pissette": [
        "pissette"
    ],
    "pisseur": [
        "pisseur"
    ],
    "pisseurs": [
        "pisseur"
    ],
    "pisseuse": [
        "pisseur"
    ],
    "pisseuses": [
        "pisseur"
    ],
    "pisseux": [
        "pisseux"
    ],
    "pissez": [
        "pisser"
    ],
    "pissoir": [
        "pissoir"
    ],
    "pissons": [
        "pisser"
    ],
    "pissotiere": [
        "pissotiere"
    ],
    "pissotieres": [
        "pissotiere"
    ],
    "pissou": [
        "pissou"
    ],
    "pisserent": [
        "pisser"
    ],
    "pissee": [
        "pisser"
    ],
    "pista": [
        "pister"
    ],
    "pistache": [
        "pistache"
    ],
    "pistaches": [
        "pistache"
    ],
    "pistachier": [
        "pistachier"
    ],
    "pistachiers": [
        "pistachier"
    ],
    "pistage": [
        "pistage"
    ],
    "pistais": [
        "pister"
    ],
    "pistait": [
        "pister"
    ],
    "pistant": [
        "pister"
    ],
    "pistard": [
        "pistard"
    ],
    "pistards": [
        "pistard"
    ],
    "piste": [
        "piste",
        "pister"
    ],
    "pistent": [
        "pister"
    ],
    "pister": [
        "pister"
    ],
    "pistera": [
        "pister"
    ],
    "pisterai": [
        "pister"
    ],
    "pistes": [
        "piste",
        "pister"
    ],
    "pisteur": [
        "pisteur"
    ],
    "pisteurs": [
        "pisteur"
    ],
    "pistez": [
        "pister"
    ],
    "pistil": [
        "pistil"
    ],
    "pistils": [
        "pistil"
    ],
    "pistole": [
        "pistole"
    ],
    "pistolero": [
        "pistolero"
    ],
    "pistoleros": [
        "pistolero"
    ],
    "pistoles": [
        "pistole"
    ],
    "pistolet": [
        "pistolet"
    ],
    "pistolets": [
        "pistolet"
    ],
    "pistoleurs": [
        "pistoleur"
    ],
    "pistoletade": [
        "pistoletade"
    ],
    "piston": [
        "piston"
    ],
    "pistonnais": [
        "pistonner"
    ],
    "pistonner": [
        "pistonner"
    ],
    "pistonnera": [
        "pistonner"
    ],
    "pistonnerai": [
        "pistonner"
    ],
    "pistonnions": [
        "pistonner"
    ],
    "pistonne": [
        "pistonne",
        "pistonner"
    ],
    "pistonnee": [
        "pistonne",
        "pistonner"
    ],
    "pistonnes": [
        "pistonne",
        "pistonner"
    ],
    "pistons": [
        "piston"
    ],
    "pistou": [
        "pistou"
    ],
    "pistee": [
        "pister"
    ],
    "pistees": [
        "pister"
    ],
    "pise": [
        "pise"
    ],
    "pita": [
        "pita"
    ],
    "pitaine": [
        "pitaine"
    ],
    "pitance": [
        "pitance"
    ],
    "pitances": [
        "pitance"
    ],
    "pitancher": [
        "pitancher"
    ],
    "pitancherai": [
        "pitancher"
    ],
    "pitancier": [
        "pitancier"
    ],
    "pitas": [
        "pita"
    ],
    "pitbull": [
        "pitbull"
    ],
    "pitbulls": [
        "pitbull"
    ],
    "pitch": [
        "pitch"
    ],
    "pitcher": [
        "pitcher"
    ],
    "pitchoun": [
        "pitchoun"
    ],
    "pitchoune": [
        "pitchoun"
    ],
    "pitchounet": [
        "pitchounet"
    ],
    "pitchounette": [
        "pitchounette"
    ],
    "pitchpin": [
        "pitchpin"
    ],
    "piteuse": [
        "piteux"
    ],
    "piteusement": [
        "piteusement"
    ],
    "piteuses": [
        "piteux"
    ],
    "piteux": [
        "piteux"
    ],
    "pithiviers": [
        "pithiviers"
    ],
    "pithecanthrope": [
        "pithecanthrope"
    ],
    "pithecanthropes": [
        "pithecanthrope"
    ],
    "pitie": [
        "pitie"
    ],
    "pities": [
        "pitie",
        "pity"
    ],
    "piton": [
        "piton"
    ],
    "pitonnant": [
        "pitonner"
    ],
    "pitonner": [
        "pitonner"
    ],
    "pitons": [
        "piton"
    ],
    "pitoyable": [
        "pitoyable"
    ],
    "pitoyablement": [
        "pitoyablement"
    ],
    "pitoyables": [
        "pitoyable"
    ],
    "pitre": [
        "pitre"
    ],
    "pitrerie": [
        "pitrerie"
    ],
    "pitreries": [
        "pitrerie"
    ],
    "pitres": [
        "pitre"
    ],
    "pittoresque": [
        "pittoresque"
    ],
    "pittoresques": [
        "pittoresque"
    ],
    "pituitaire": [
        "pituitaire"
    ],
    "pituitaires": [
        "pituitaire"
    ],
    "pituite": [
        "pituite"
    ],
    "pityriasis": [
        "pityriasis"
    ],
    "piu": [
        "piu"
    ],
    "pive": [
        "pive"
    ],
    "pivert": [
        "pivert"
    ],
    "piverts": [
        "pivert"
    ],
    "pivoine": [
        "pivoine"
    ],
    "pivoines": [
        "pivoine"
    ],
    "pivot": [
        "pivot"
    ],
    "pivota": [
        "pivoter"
    ],
    "pivotai": [
        "pivoter"
    ],
    "pivotaient": [
        "pivoter"
    ],
    "pivotait": [
        "pivoter"
    ],
    "pivotant": [
        "pivotant",
        "pivoter"
    ],
    "pivotante": [
        "pivotant"
    ],
    "pivotantes": [
        "pivotant"
    ],
    "pivotants": [
        "pivotant"
    ],
    "pivote": [
        "pivoter"
    ],
    "pivotement": [
        "pivotement"
    ],
    "pivotent": [
        "pivoter"
    ],
    "pivoter": [
        "pivoter"
    ],
    "pivotes": [
        "pivoter"
    ],
    "pivotez": [
        "pivoter"
    ],
    "pivots": [
        "pivot"
    ],
    "pivoterent": [
        "pivoter"
    ],
    "pixel": [
        "pixel"
    ],
    "pixellises": [
        "pixelliser"
    ],
    "pixels": [
        "pixel"
    ],
    "pizza": [
        "pizza"
    ],
    "pizzaiolo": [
        "pizzaiolo"
    ],
    "pizzas": [
        "pizza"
    ],
    "pizzeria": [
        "pizzeria"
    ],
    "pizzerias": [
        "pizzeria"
    ],
    "pizzicato": [
        "pizzicato"
    ],
    "piece": [
        "piece"
    ],
    "pieces": [
        "piece"
    ],
    "piege": [
        "piege",
        "pieger"
    ],
    "piegent": [
        "pieger"
    ],
    "pieges": [
        "piege",
        "pieger"
    ],
    "piete": [
        "piete",
        "pieter"
    ],
    "pietement": [
        "pietement"
    ],
    "pietre": [
        "pietre"
    ],
    "pietrement": [
        "pietrement"
    ],
    "pietres": [
        "pietre"
    ],
    "piecette": [
        "piecette"
    ],
    "piecettes": [
        "piecette"
    ],
    "piedestal": [
        "piedestal"
    ],
    "piedestaux": [
        "piedestal"
    ],
    "piedroit": [
        "piedroit"
    ],
    "piedroits": [
        "piedroit"
    ],
    "piegeage": [
        "piegeage"
    ],
    "piegeages": [
        "piegeage"
    ],
    "piegeais": [
        "pieger"
    ],
    "piegeait": [
        "pieger"
    ],
    "piegeant": [
        "pieger"
    ],
    "pieger": [
        "pieger"
    ],
    "piegerai": [
        "pieger"
    ],
    "piegerais": [
        "pieger"
    ],
    "piegerait": [
        "pieger"
    ],
    "piegerez": [
        "pieger"
    ],
    "piegeront": [
        "pieger"
    ],
    "piegeur": [
        "piegeur"
    ],
    "piegeurs": [
        "piegeur"
    ],
    "piegeuse": [
        "piegeur"
    ],
    "piegeuses": [
        "piegeur"
    ],
    "piegez": [
        "pieger"
    ],
    "piegee": [
        "pieger"
    ],
    "piegees": [
        "pieger"
    ],
    "piemont": [
        "piemont"
    ],
    "piemontais": [
        "piemontais"
    ],
    "piemontaise": [
        "piemontais"
    ],
    "pieride": [
        "pieride"
    ],
    "pierides": [
        "pieride"
    ],
    "pietaille": [
        "pietaille"
    ],
    "pietait": [
        "pieter"
    ],
    "pietant": [
        "pieter"
    ],
    "pieter": [
        "pieter"
    ],
    "pietin": [
        "pietin"
    ],
    "pietina": [
        "pietiner"
    ],
    "pietinai": [
        "pietiner"
    ],
    "pietinaient": [
        "pietiner"
    ],
    "pietinais": [
        "pietiner"
    ],
    "pietinait": [
        "pietiner"
    ],
    "pietinant": [
        "pietinant",
        "pietiner"
    ],
    "pietinante": [
        "pietinant"
    ],
    "pietine": [
        "pietiner"
    ],
    "pietinement": [
        "pietinement"
    ],
    "pietinements": [
        "pietinement"
    ],
    "pietinent": [
        "pietiner"
    ],
    "pietiner": [
        "pietiner"
    ],
    "pietinera": [
        "pietiner"
    ],
    "pietinerai": [
        "pietiner"
    ],
    "pietinerais": [
        "pietiner"
    ],
    "pietinerait": [
        "pietiner"
    ],
    "pietineront": [
        "pietiner"
    ],
    "pietinez": [
        "pietiner"
    ],
    "pietinons": [
        "pietiner"
    ],
    "pietinerent": [
        "pietiner"
    ],
    "pietinee": [
        "pietiner"
    ],
    "pietinees": [
        "pietiner"
    ],
    "pietines": [
        "pietiner"
    ],
    "pietiste": [
        "pietiste"
    ],
    "pieton": [
        "pieton"
    ],
    "pietonne": [
        "pieton"
    ],
    "pietonnes": [
        "pieton"
    ],
    "pietonnier": [
        "pietonnier"
    ],
    "pietonniere": [
        "pietonnier"
    ],
    "pietonnieres": [
        "pietonnier"
    ],
    "pietons": [
        "pieton"
    ],
    "placage": [
        "placage"
    ],
    "placages": [
        "placage"
    ],
    "placard": [
        "placard"
    ],
    "placardait": [
        "placarder"
    ],
    "placarde": [
        "placarder"
    ],
    "placarder": [
        "placarder"
    ],
    "placardes": [
        "placarder"
    ],
    "placardier": [
        "placardier"
    ],
    "placards": [
        "placard"
    ],
    "placardee": [
        "placarder"
    ],
    "placardees": [
        "placarder"
    ],
    "place": [
        "place",
        "placer"
    ],
    "placebo": [
        "placebo"
    ],
    "placebos": [
        "placebo"
    ],
    "placement": [
        "placement"
    ],
    "placements": [
        "placement"
    ],
    "placent": [
        "placer"
    ],
    "placenta": [
        "placenta"
    ],
    "placentaire": [
        "placentaire"
    ],
    "placentas": [
        "placenta"
    ],
    "placer": [
        "placer"
    ],
    "placera": [
        "placer"
    ],
    "placerai": [
        "placer"
    ],
    "placeraient": [
        "placer"
    ],
    "placerais": [
        "placer"
    ],
    "placerait": [
        "placer"
    ],
    "placeras": [
        "placer"
    ],
    "placerez": [
        "placer"
    ],
    "placerons": [
        "placer"
    ],
    "placeront": [
        "placer"
    ],
    "places": [
        "place",
        "placer"
    ],
    "placet": [
        "placet"
    ],
    "placets": [
        "placet"
    ],
    "placette": [
        "placette"
    ],
    "placettes": [
        "placette"
    ],
    "placeur": [
        "placeur"
    ],
    "placeurs": [
        "placeur"
    ],
    "placeuse": [
        "placeur"
    ],
    "placeuses": [
        "placeur"
    ],
    "placez": [
        "placer"
    ],
    "placide": [
        "placide"
    ],
    "placidement": [
        "placidement"
    ],
    "placides": [
        "placide"
    ],
    "placidite": [
        "placidite"
    ],
    "placier": [
        "placier"
    ],
    "placiers": [
        "placier"
    ],
    "placiez": [
        "placer"
    ],
    "placions": [
        "placer"
    ],
    "placoplatre": [
        "placoplatre"
    ],
    "placerent": [
        "placer"
    ],
    "placee": [
        "place",
        "placer"
    ],
    "placees": [
        "place",
        "placer"
    ],
    "plafond": [
        "plafond"
    ],
    "plafonds": [
        "plafond"
    ],
    "plafonnant": [
        "plafonner"
    ],
    "plafonne": [
        "plafonne",
        "plafonner"
    ],
    "plafonnement": [
        "plafonnement"
    ],
    "plafonner": [
        "plafonner"
    ],
    "plafonnier": [
        "plafonnier"
    ],
    "plafonniers": [
        "plafonnier"
    ],
    "plafonniere": [
        "plafonnier"
    ],
    "plafonnons": [
        "plafonner"
    ],
    "plafonnee": [
        "plafonner"
    ],
    "plafonnees": [
        "plafonne"
    ],
    "plage": [
        "plage"
    ],
    "plages": [
        "plage"
    ],
    "plagiaire": [
        "plagiaire"
    ],
    "plagiaires": [
        "plagiaire"
    ],
    "plagiant": [
        "plagier"
    ],
    "plagiat": [
        "plagiat"
    ],
    "plagiats": [
        "plagiat"
    ],
    "plagie": [
        "plagier"
    ],
    "plagier": [
        "plagier"
    ],
    "plagies": [
        "plagier"
    ],
    "plagioclase": [
        "plagioclase"
    ],
    "plaid": [
        "plaid"
    ],
    "plaida": [
        "plaider"
    ],
    "plaidable": [
        "plaidable"
    ],
    "plaidai": [
        "plaider"
    ],
    "plaidaient": [
        "plaider"
    ],
    "plaidais": [
        "plaider"
    ],
    "plaidait": [
        "plaider"
    ],
    "plaidant": [
        "plaider"
    ],
    "plaidants": [
        "plaidant"
    ],
    "plaide": [
        "plaider"
    ],
    "plaident": [
        "plaider"
    ],
    "plaider": [
        "plaider"
    ],
    "plaidera": [
        "plaider"
    ],
    "plaiderai": [
        "plaider"
    ],
    "plaiderait": [
        "plaider"
    ],
    "plaideras": [
        "plaider"
    ],
    "plaiderez": [
        "plaider"
    ],
    "plaiderons": [
        "plaider"
    ],
    "plaideront": [
        "plaider"
    ],
    "plaides": [
        "plaider"
    ],
    "plaideur": [
        "plaideur"
    ],
    "plaideurs": [
        "plaideur"
    ],
    "plaidez": [
        "plaider"
    ],
    "plaidiez": [
        "plaider"
    ],
    "plaidions": [
        "plaider"
    ],
    "plaidoirie": [
        "plaidoirie"
    ],
    "plaidoiries": [
        "plaidoirie"
    ],
    "plaidons": [
        "plaider"
    ],
    "plaidoyer": [
        "plaidoyer"
    ],
    "plaidoyers": [
        "plaidoyer"
    ],
    "plaids": [
        "plaid"
    ],
    "plaiderent": [
        "plaider"
    ],
    "plaidee": [
        "plaider"
    ],
    "plaie": [
        "plaie"
    ],
    "plaies": [
        "plaie"
    ],
    "plaignaient": [
        "plaindre"
    ],
    "plaignais": [
        "plaindre"
    ],
    "plaignait": [
        "plaindre"
    ],
    "plaignant": [
        "plaignant",
        "plaindre"
    ],
    "plaignante": [
        "plaignant"
    ],
    "plaignantes": [
        "plaignant"
    ],
    "plaignants": [
        "plaignant"
    ],
    "plaigne": [
        "plaindre"
    ],
    "plaignent": [
        "plaindre"
    ],
    "plaignes": [
        "plaindre"
    ],
    "plaignez": [
        "plaindre"
    ],
    "plaigniez": [
        "plaindre"
    ],
    "plaignions": [
        "plaindre"
    ],
    "plaignirent": [
        "plaindre"
    ],
    "plaignis": [
        "plaindre"
    ],
    "plaignit": [
        "plaindre"
    ],
    "plaignons": [
        "plaindre"
    ],
    "plain": [
        "plain"
    ],
    "plaindra": [
        "plaindre"
    ],
    "plaindrai": [
        "plaindre"
    ],
    "plaindraient": [
        "plaindre"
    ],
    "plaindrais": [
        "plaindre"
    ],
    "plaindrait": [
        "plaindre"
    ],
    "plaindras": [
        "plaindre"
    ],
    "plaindre": [
        "plaindre"
    ],
    "plaindrez": [
        "plaindre"
    ],
    "plaindriez": [
        "plaindre"
    ],
    "plaindrions": [
        "plaindre"
    ],
    "plaindront": [
        "plaindre"
    ],
    "plaine": [
        "plaine"
    ],
    "plaines": [
        "plaine",
        "plain"
    ],
    "plains": [
        "plaindre",
        "plain"
    ],
    "plaint": [
        "plaindre"
    ],
    "plainte": [
        "plainte",
        "plaindre"
    ],
    "plaintes": [
        "plainte",
        "plaindre"
    ],
    "plaintif": [
        "plaintif"
    ],
    "plaintifs": [
        "plaintif"
    ],
    "plaintive": [
        "plaintif"
    ],
    "plaintivement": [
        "plaintivement"
    ],
    "plaintives": [
        "plaintif"
    ],
    "plaints": [
        "plaindre"
    ],
    "plaira": [
        "plaire"
    ],
    "plairai": [
        "plaire"
    ],
    "plairaient": [
        "plaire"
    ],
    "plairais": [
        "plaire"
    ],
    "plairait": [
        "plaire"
    ],
    "plairas": [
        "plaire"
    ],
    "plaire": [
        "plaire"
    ],
    "plairez": [
        "plaire"
    ],
    "plairiez": [
        "plaire"
    ],
    "plairont": [
        "plaire"
    ],
    "plais": [
        "plaire"
    ],
    "plaisaient": [
        "plaire"
    ],
    "plaisais": [
        "plaire"
    ],
    "plaisait": [
        "plaire"
    ],
    "plaisamment": [
        "plaisamment"
    ],
    "plaisance": [
        "plaisance"
    ],
    "plaisancier": [
        "plaisancier"
    ],
    "plaisanciers": [
        "plaisancier"
    ],
    "plaisant": [
        "plaisant",
        "plaire"
    ],
    "plaisanta": [
        "plaisanter"
    ],
    "plaisantai": [
        "plaisanter"
    ],
    "plaisantaient": [
        "plaisanter"
    ],
    "plaisantais": [
        "plaisanter"
    ],
    "plaisantait": [
        "plaisanter"
    ],
    "plaisantant": [
        "plaisanter"
    ],
    "plaisante": [
        "plaisant",
        "plaisanter"
    ],
    "plaisantent": [
        "plaisanter"
    ],
    "plaisanter": [
        "plaisanter"
    ],
    "plaisantera": [
        "plaisanter"
    ],
    "plaisanterai": [
        "plaisanter"
    ],
    "plaisanteraient": [
        "plaisanter"
    ],
    "plaisanterais": [
        "plaisanter"
    ],
    "plaisanteras": [
        "plaisanter"
    ],
    "plaisanterie": [
        "plaisanterie"
    ],
    "plaisanteries": [
        "plaisanterie"
    ],
    "plaisanterons": [
        "plaisanter"
    ],
    "plaisantes": [
        "plaisant",
        "plaisanter"
    ],
    "plaisantez": [
        "plaisanter"
    ],
    "plaisantiez": [
        "plaisanter"
    ],
    "plaisantin": [
        "plaisantin"
    ],
    "plaisantins": [
        "plaisantin"
    ],
    "plaisantions": [
        "plaisanter"
    ],
    "plaisantons": [
        "plaisanter"
    ],
    "plaisants": [
        "plaisant"
    ],
    "plaisanterent": [
        "plaisanter"
    ],
    "plaise": [
        "plaire"
    ],
    "plaisent": [
        "plaire"
    ],
    "plaises": [
        "plaire"
    ],
    "plaisez": [
        "plaire"
    ],
    "plaisiez": [
        "plaire"
    ],
    "plaisions": [
        "plaire"
    ],
    "plaisir": [
        "plaisir"
    ],
    "plaisirs": [
        "plaisir"
    ],
    "plaisons": [
        "plaire"
    ],
    "plan": [
        "plan"
    ],
    "plana": [
        "planer"
    ],
    "planaient": [
        "planer"
    ],
    "planais": [
        "planer"
    ],
    "planait": [
        "planer"
    ],
    "planant": [
        "planer",
        "planant"
    ],
    "planante": [
        "planant"
    ],
    "planantes": [
        "planant"
    ],
    "planants": [
        "planant"
    ],
    "planas": [
        "planer"
    ],
    "planchais": [
        "plancher"
    ],
    "planche": [
        "planche",
        "plancher"
    ],
    "planchent": [
        "plancher"
    ],
    "plancher": [
        "plancher"
    ],
    "planchers": [
        "plancher"
    ],
    "planches": [
        "planche",
        "plancher"
    ],
    "planchette": [
        "planchette"
    ],
    "planchettes": [
        "planchette"
    ],
    "planchiste": [
        "planchiste"
    ],
    "plancton": [
        "plancton"
    ],
    "planctons": [
        "plancton"
    ],
    "plane": [
        "planer",
        "plane",
        "plan"
    ],
    "planelle": [
        "planelle"
    ],
    "planement": [
        "planement"
    ],
    "planent": [
        "planer"
    ],
    "planer": [
        "planer"
    ],
    "planera": [
        "planer"
    ],
    "planerait": [
        "planer"
    ],
    "planerions": [
        "planer"
    ],
    "planeront": [
        "planer"
    ],
    "planes": [
        "planer",
        "plane",
        "plan"
    ],
    "planeur": [
        "planeur"
    ],
    "planeurs": [
        "planeur"
    ],
    "planez": [
        "planer"
    ],
    "planiez": [
        "planer"
    ],
    "planifiable": [
        "planifiable"
    ],
    "planifiaient": [
        "planifier"
    ],
    "planifiait": [
        "planifier"
    ],
    "planifiant": [
        "planifier"
    ],
    "planificateur": [
        "planificateur"
    ],
    "planification": [
        "planification"
    ],
    "planificatrice": [
        "planificateur"
    ],
    "planifie": [
        "planifier"
    ],
    "planifient": [
        "planifier"
    ],
    "planifier": [
        "planifier"
    ],
    "planifierais": [
        "planifier"
    ],
    "planifiez": [
        "planifier"
    ],
    "planifions": [
        "planifier"
    ],
    "planifiee": [
        "planifier"
    ],
    "planifies": [
        "planifier"
    ],
    "planisphere": [
        "planisphere"
    ],
    "planispheres": [
        "planisphere"
    ],
    "planitude": [
        "planitude"
    ],
    "planning": [
        "planning",
        "plan"
    ],
    "plannings": [
        "planning"
    ],
    "planqua": [
        "planquer"
    ],
    "planquaient": [
        "planquer"
    ],
    "planquais": [
        "planquer"
    ],
    "planquait": [
        "planquer"
    ],
    "planquant": [
        "planquer"
    ],
    "planque": [
        "planquer",
        "planque"
    ],
    "planquent": [
        "planquer"
    ],
    "planquer": [
        "planquer"
    ],
    "planquera": [
        "planquer"
    ],
    "planquerai": [
        "planquer"
    ],
    "planquerais": [
        "planquer"
    ],
    "planquerait": [
        "planquer"
    ],
    "planqueras": [
        "planquer"
    ],
    "planques": [
        "planquer",
        "planque"
    ],
    "planquez": [
        "planquer"
    ],
    "planquiez": [
        "planquer"
    ],
    "planquions": [
        "planquer"
    ],
    "planquons": [
        "planquer"
    ],
    "planquerent": [
        "planquer"
    ],
    "planquee": [
        "planquer",
        "planque"
    ],
    "planquees": [
        "planquer",
        "planque"
    ],
    "plans": [
        "plan"
    ],
    "plant": [
        "plant"
    ],
    "planta": [
        "planter"
    ],
    "plantage": [
        "plantage"
    ],
    "plantai": [
        "planter"
    ],
    "plantaient": [
        "planter"
    ],
    "plantain": [
        "plantain"
    ],
    "plantains": [
        "plantain"
    ],
    "plantaire": [
        "plantaire"
    ],
    "plantaires": [
        "plantaire"
    ],
    "plantais": [
        "planter"
    ],
    "plantait": [
        "planter"
    ],
    "plantant": [
        "planter"
    ],
    "plantation": [
        "plantation"
    ],
    "plantations": [
        "plantation"
    ],
    "plante": [
        "plante",
        "planter"
    ],
    "plantent": [
        "planter"
    ],
    "planter": [
        "planter"
    ],
    "plantera": [
        "planter"
    ],
    "planterai": [
        "planter"
    ],
    "planterais": [
        "planter"
    ],
    "planterait": [
        "planter"
    ],
    "planteras": [
        "planter"
    ],
    "planterez": [
        "planter"
    ],
    "planterons": [
        "planter"
    ],
    "planteront": [
        "planter"
    ],
    "plantes": [
        "plante",
        "planter"
    ],
    "planteur": [
        "planteur"
    ],
    "planteurs": [
        "planteur"
    ],
    "plantez": [
        "planter"
    ],
    "plantier": [
        "plantier"
    ],
    "plantiez": [
        "planter"
    ],
    "plantigrade": [
        "plantigrade"
    ],
    "plantions": [
        "planter"
    ],
    "plantoir": [
        "plantoir"
    ],
    "planton": [
        "planton"
    ],
    "plantons": [
        "planton",
        "planter"
    ],
    "plants": [
        "plant"
    ],
    "plantureuse": [
        "plantureux"
    ],
    "plantureuses": [
        "plantureux"
    ],
    "plantureux": [
        "plantureux"
    ],
    "planterent": [
        "planter"
    ],
    "plantee": [
        "plante",
        "planter"
    ],
    "plantees": [
        "plante",
        "planter"
    ],
    "planete": [
        "planete"
    ],
    "planetes": [
        "planete"
    ],
    "planetaire": [
        "planetaire"
    ],
    "planetaires": [
        "planetaire"
    ],
    "planetarium": [
        "planetarium"
    ],
    "planetariums": [
        "planetarium"
    ],
    "planetoide": [
        "planetoide"
    ],
    "plaqua": [
        "plaquer"
    ],
    "plaquage": [
        "plaquage"
    ],
    "plaquages": [
        "plaquage"
    ],
    "plaquai": [
        "plaquer"
    ],
    "plaquaient": [
        "plaquer"
    ],
    "plaquais": [
        "plaquer"
    ],
    "plaquait": [
        "plaquer"
    ],
    "plaquant": [
        "plaquer"
    ],
    "plaque": [
        "plaquer",
        "plaque"
    ],
    "plaqueminiers": [
        "plaqueminier"
    ],
    "plaquent": [
        "plaquer"
    ],
    "plaquer": [
        "plaquer"
    ],
    "plaquera": [
        "plaquer"
    ],
    "plaquerai": [
        "plaquer"
    ],
    "plaquerais": [
        "plaquer"
    ],
    "plaquerait": [
        "plaquer"
    ],
    "plaqueras": [
        "plaquer"
    ],
    "plaques": [
        "plaquer",
        "plaque"
    ],
    "plaquettaire": [
        "plaquettaire"
    ],
    "plaquette": [
        "plaquette"
    ],
    "plaquettes": [
        "plaquette"
    ],
    "plaqueur": [
        "plaqueur"
    ],
    "plaquez": [
        "plaquer"
    ],
    "plaquerent": [
        "plaquer"
    ],
    "plaquee": [
        "plaquer",
        "plaque"
    ],
    "plaquees": [
        "plaquer",
        "plaque"
    ],
    "plasma": [
        "plasma"
    ],
    "plasmagene": [
        "plasmagene"
    ],
    "plasmapherese": [
        "plasmapherese"
    ],
    "plasmique": [
        "plasmique"
    ],
    "plaste": [
        "plaste"
    ],
    "plastic": [
        "plastic"
    ],
    "plasticage": [
        "plasticage"
    ],
    "plasticages": [
        "plasticage"
    ],
    "plasticien": [
        "plasticien"
    ],
    "plasticienne": [
        "plasticien"
    ],
    "plasticite": [
        "plasticite"
    ],
    "plastie": [
        "plastie"
    ],
    "plastifiant": [
        "plastifiant"
    ],
    "plastification": [
        "plastification"
    ],
    "plastifier": [
        "plastifier"
    ],
    "plastifie": [
        "plastifier"
    ],
    "plastifiee": [
        "plastifier"
    ],
    "plastifiees": [
        "plastifier"
    ],
    "plastifies": [
        "plastifier"
    ],
    "plastiquage": [
        "plastiquage"
    ],
    "plastiquais": [
        "plastiquer"
    ],
    "plastique": [
        "plastique",
        "plastiquer"
    ],
    "plastiquer": [
        "plastiquer"
    ],
    "plastiques": [
        "plastique"
    ],
    "plastiqueur": [
        "plastiqueur"
    ],
    "plastisol": [
        "plastisol"
    ],
    "plastoc": [
        "plastoc"
    ],
    "plastron": [
        "plastron"
    ],
    "plastronnaient": [
        "plastronner"
    ],
    "plastronnait": [
        "plastronner"
    ],
    "plastronnant": [
        "plastronner"
    ],
    "plastronne": [
        "plastronner"
    ],
    "plastronnent": [
        "plastronner"
    ],
    "plastronner": [
        "plastronner"
    ],
    "plastronnes": [
        "plastronner"
    ],
    "plastronneur": [
        "plastronneur"
    ],
    "plastrons": [
        "plastron"
    ],
    "plat": [
        "plat"
    ],
    "platane": [
        "platane"
    ],
    "platanes": [
        "platane"
    ],
    "plate": [
        "plat",
        "plate"
    ],
    "plateau": [
        "plateau"
    ],
    "plateaux": [
        "plateau"
    ],
    "platebandes": [
        "platebande"
    ],
    "plateforme": [
        "plateforme"
    ],
    "platelage": [
        "platelage"
    ],
    "platement": [
        "platement"
    ],
    "plateresque": [
        "plateresque"
    ],
    "plateresques": [
        "plateresque"
    ],
    "plates": [
        "plat",
        "plate"
    ],
    "platine": [
        "platine"
    ],
    "platines": [
        "platine"
    ],
    "platinee": [
        "platiner",
        "platine"
    ],
    "platinees": [
        "platine"
    ],
    "platitude": [
        "platitude"
    ],
    "platitudes": [
        "platitude"
    ],
    "platiere": [
        "platiere"
    ],
    "platonicien": [
        "platonicien"
    ],
    "platonicienne": [
        "platonicien"
    ],
    "platoniciens": [
        "platonicien"
    ],
    "platonique": [
        "platonique"
    ],
    "platoniquement": [
        "platoniquement"
    ],
    "platoniques": [
        "platonique"
    ],
    "platonisant": [
        "platonisant"
    ],
    "plats": [
        "plat"
    ],
    "platures": [
        "plature"
    ],
    "platyrrhiniens": [
        "platyrrhinien"
    ],
    "platee": [
        "platee"
    ],
    "platees": [
        "platee"
    ],
    "plausibilite": [
        "plausibilite"
    ],
    "plausible": [
        "plausible"
    ],
    "plausiblement": [
        "plausiblement"
    ],
    "plausibles": [
        "plausible"
    ],
    "play": [
        "play"
    ],
    "playboy": [
        "playboy"
    ],
    "playmate": [
        "playmate"
    ],
    "playmates": [
        "playmate"
    ],
    "playon": [
        "playon"
    ],
    "plaza": [
        "plaza"
    ],
    "plazza": [
        "plazza"
    ],
    "placa": [
        "placer"
    ],
    "placai": [
        "placer"
    ],
    "placaient": [
        "placer"
    ],
    "placais": [
        "placer"
    ],
    "placait": [
        "placer"
    ],
    "placant": [
        "placer"
    ],
    "placons": [
        "placer"
    ],
    "placat": [
        "placer"
    ],
    "plait": [
        "plaire"
    ],
    "please": [
        "please"
    ],
    "plectre": [
        "plectre"
    ],
    "plein": [
        "plein"
    ],
    "pleine": [
        "plein"
    ],
    "pleinement": [
        "pleinement"
    ],
    "pleines": [
        "plein"
    ],
    "pleins": [
        "plein"
    ],
    "plessis": [
        "plessis"
    ],
    "plet": [
        "plet"
    ],
    "pleur": [
        "pleur"
    ],
    "pleura": [
        "pleurer"
    ],
    "pleurai": [
        "pleurer"
    ],
    "pleuraient": [
        "pleurer"
    ],
    "pleurais": [
        "pleurer"
    ],
    "pleurait": [
        "pleurer"
    ],
    "pleural": [
        "pleural"
    ],
    "pleurale": [
        "pleural"
    ],
    "pleurant": [
        "pleurer",
        "pleurant"
    ],
    "pleurante": [
        "pleurant"
    ],
    "pleurantes": [
        "pleurant"
    ],
    "pleurants": [
        "pleurant"
    ],
    "pleurard": [
        "pleurard"
    ],
    "pleurarde": [
        "pleurard"
    ],
    "pleurards": [
        "pleurard"
    ],
    "pleure": [
        "pleurer"
    ],
    "pleurement": [
        "pleurement"
    ],
    "pleurements": [
        "pleurement"
    ],
    "pleurent": [
        "pleurer"
    ],
    "pleurer": [
        "pleurer"
    ],
    "pleurera": [
        "pleurer"
    ],
    "pleurerai": [
        "pleurer"
    ],
    "pleureraient": [
        "pleurer"
    ],
    "pleurerais": [
        "pleurer"
    ],
    "pleurerait": [
        "pleurer"
    ],
    "pleureras": [
        "pleurer"
    ],
    "pleurerez": [
        "pleurer"
    ],
    "pleurerons": [
        "pleurer"
    ],
    "pleureront": [
        "pleurer"
    ],
    "pleures": [
        "pleurer"
    ],
    "pleureur": [
        "pleureur"
    ],
    "pleureurs": [
        "pleureur"
    ],
    "pleureuse": [
        "pleureur"
    ],
    "pleureuses": [
        "pleureur"
    ],
    "pleureux": [
        "pleureur"
    ],
    "pleurez": [
        "pleurer"
    ],
    "pleuriez": [
        "pleurer"
    ],
    "pleurions": [
        "pleurer"
    ],
    "pleurite": [
        "pleurite"
    ],
    "pleurnicha": [
        "pleurnicher"
    ],
    "pleurnichage": [
        "pleurnichage"
    ],
    "pleurnichages": [
        "pleurnichage"
    ],
    "pleurnichais": [
        "pleurnicher"
    ],
    "pleurnichait": [
        "pleurnicher"
    ],
    "pleurnichant": [
        "pleurnicher"
    ],
    "pleurnichard": [
        "pleurnichard"
    ],
    "pleurnicharde": [
        "pleurnichard"
    ],
    "pleurnichardes": [
        "pleurnichard"
    ],
    "pleurnichards": [
        "pleurnichard"
    ],
    "pleurniche": [
        "pleurnicher"
    ],
    "pleurnichement": [
        "pleurnichement"
    ],
    "pleurnichements": [
        "pleurnichement"
    ],
    "pleurnichent": [
        "pleurnicher"
    ],
    "pleurnicher": [
        "pleurnicher"
    ],
    "pleurnicherais": [
        "pleurnicher"
    ],
    "pleurnicherait": [
        "pleurnicher"
    ],
    "pleurnicheras": [
        "pleurnicher"
    ],
    "pleurnicherie": [
        "pleurnicherie"
    ],
    "pleurnicheries": [
        "pleurnicherie"
    ],
    "pleurniches": [
        "pleurnicher"
    ],
    "pleurnicheur": [
        "pleurnicheur"
    ],
    "pleurnicheurs": [
        "pleurnicheur"
    ],
    "pleurnicheuse": [
        "pleurnicheur"
    ],
    "pleurnicheuses": [
        "pleurnicheur"
    ],
    "pleurnichez": [
        "pleurnicher"
    ],
    "pleurons": [
        "pleurer"
    ],
    "pleurotes": [
        "pleurote"
    ],
    "pleurs": [
        "pleur"
    ],
    "pleurat": [
        "pleurer"
    ],
    "pleurerent": [
        "pleurer"
    ],
    "pleuree": [
        "pleurer"
    ],
    "pleurees": [
        "pleurer"
    ],
    "pleuresie": [
        "pleuresie"
    ],
    "pleuretique": [
        "pleuretique"
    ],
    "pleut": [
        "pleuvoir"
    ],
    "pleutre": [
        "pleutre"
    ],
    "pleutrerie": [
        "pleutrerie"
    ],
    "pleutres": [
        "pleutre"
    ],
    "pleuvaient": [
        "pleuvoir"
    ],
    "pleuvait": [
        "pleuvoir"
    ],
    "pleuvant": [
        "pleuvoir"
    ],
    "pleuve": [
        "pleuvoir"
    ],
    "pleuvent": [
        "pleuvoir"
    ],
    "pleuvinait": [
        "pleuviner"
    ],
    "pleuvine": [
        "pleuviner"
    ],
    "pleuviner": [
        "pleuviner"
    ],
    "pleuvioter": [
        "pleuvioter"
    ],
    "pleuvoir": [
        "pleuvoir"
    ],
    "pleuvra": [
        "pleuvoir"
    ],
    "pleuvrait": [
        "pleuvoir"
    ],
    "plexi": [
        "plexi"
    ],
    "plexiglas": [
        "plexiglas"
    ],
    "plexus": [
        "plexus"
    ],
    "pleyel": [
        "pleyel"
    ],
    "pli": [
        "pli"
    ],
    "plia": [
        "plier"
    ],
    "pliable": [
        "pliable"
    ],
    "pliage": [
        "pliage"
    ],
    "pliages": [
        "pliage"
    ],
    "pliai": [
        "plier"
    ],
    "pliaient": [
        "plier"
    ],
    "pliais": [
        "plier"
    ],
    "pliait": [
        "plier"
    ],
    "pliant": [
        "plier",
        "pliant"
    ],
    "pliante": [
        "pliant"
    ],
    "pliantes": [
        "pliant"
    ],
    "pliants": [
        "pliant"
    ],
    "plie": [
        "plier",
        "plie"
    ],
    "plient": [
        "plier"
    ],
    "plier": [
        "plier"
    ],
    "pliera": [
        "plier"
    ],
    "plierai": [
        "plier"
    ],
    "plieraient": [
        "plier"
    ],
    "plierait": [
        "plier"
    ],
    "plieras": [
        "plier"
    ],
    "plierez": [
        "plier"
    ],
    "plierons": [
        "plier"
    ],
    "plies": [
        "plier",
        "ply",
        "plie"
    ],
    "plieur": [
        "plieur"
    ],
    "plieuse": [
        "plieur"
    ],
    "pliez": [
        "plier"
    ],
    "plinthe": [
        "plinthe"
    ],
    "plinthes": [
        "plinthe"
    ],
    "pliocene": [
        "pliocene"
    ],
    "plioir": [
        "plioir"
    ],
    "plions": [
        "plion",
        "plier"
    ],
    "plique": [
        "plique"
    ],
    "plis": [
        "pli"
    ],
    "plissa": [
        "plisser"
    ],
    "plissai": [
        "plisser"
    ],
    "plissaient": [
        "plisser"
    ],
    "plissais": [
        "plisser"
    ],
    "plissait": [
        "plisser"
    ],
    "plissant": [
        "plisser"
    ],
    "plisse": [
        "plisser",
        "plisse"
    ],
    "plissement": [
        "plissement"
    ],
    "plissements": [
        "plissement"
    ],
    "plissent": [
        "plisser"
    ],
    "plisser": [
        "plisser"
    ],
    "plisseront": [
        "plisser"
    ],
    "plisseur": [
        "plisseur"
    ],
    "plissure": [
        "plissure"
    ],
    "plissures": [
        "plissure"
    ],
    "plisserent": [
        "plisser"
    ],
    "plissee": [
        "plisser",
        "plisse"
    ],
    "plissees": [
        "plisser",
        "plisse"
    ],
    "plisses": [
        "plisser",
        "plisse"
    ],
    "pliure": [
        "pliure"
    ],
    "pliures": [
        "pliure"
    ],
    "pliat": [
        "plier"
    ],
    "plierent": [
        "plier"
    ],
    "pliee": [
        "plier"
    ],
    "pliees": [
        "plier"
    ],
    "ploc": [
        "ploc"
    ],
    "ploie": [
        "ployer"
    ],
    "ploiement": [
        "ploiement"
    ],
    "ploient": [
        "ployer"
    ],
    "plomb": [
        "plomb"
    ],
    "plombage": [
        "plombage"
    ],
    "plombages": [
        "plombage"
    ],
    "plombaient": [
        "plomber"
    ],
    "plombait": [
        "plomber"
    ],
    "plombant": [
        "plomber"
    ],
    "plombe": [
        "plomber",
        "plombe"
    ],
    "plombent": [
        "plomber"
    ],
    "plomber": [
        "plomber"
    ],
    "plomberie": [
        "plomberie"
    ],
    "plomberies": [
        "plomberie"
    ],
    "plombes": [
        "plomber",
        "plombe"
    ],
    "plombez": [
        "plomber"
    ],
    "plombier": [
        "plombier"
    ],
    "plombiers": [
        "plombier"
    ],
    "plombieres": [
        "plombieres"
    ],
    "plombs": [
        "plomb"
    ],
    "plombure": [
        "plombure"
    ],
    "plombee": [
        "plombee",
        "plomber",
        "plombe"
    ],
    "plombees": [
        "plombee",
        "plomber",
        "plombe"
    ],
    "plonge": [
        "plonger",
        "plonge"
    ],
    "plongea": [
        "plonger"
    ],
    "plongeai": [
        "plonger"
    ],
    "plongeaient": [
        "plonger"
    ],
    "plongeais": [
        "plonger"
    ],
    "plongeait": [
        "plonger"
    ],
    "plongeant": [
        "plongeant",
        "plonger"
    ],
    "plongeante": [
        "plongeant"
    ],
    "plongeantes": [
        "plongeant"
    ],
    "plongeants": [
        "plongeant"
    ],
    "plongement": [
        "plongement"
    ],
    "plongent": [
        "plonger"
    ],
    "plongeoir": [
        "plongeoir"
    ],
    "plongeoirs": [
        "plongeoir"
    ],
    "plongeon": [
        "plongeon"
    ],
    "plongeons": [
        "plongeon",
        "plonger"
    ],
    "plonger": [
        "plonger"
    ],
    "plongera": [
        "plonger"
    ],
    "plongerai": [
        "plonger"
    ],
    "plongeraient": [
        "plonger"
    ],
    "plongerais": [
        "plonger"
    ],
    "plongerait": [
        "plonger"
    ],
    "plongeras": [
        "plonger"
    ],
    "plongerez": [
        "plonger"
    ],
    "plongeriez": [
        "plonger"
    ],
    "plongerons": [
        "plonger"
    ],
    "plongeront": [
        "plonger"
    ],
    "plonges": [
        "plonger"
    ],
    "plongeur": [
        "plongeur"
    ],
    "plongeurs": [
        "plongeur"
    ],
    "plongeuse": [
        "plongeur"
    ],
    "plongeuses": [
        "plongeur"
    ],
    "plongez": [
        "plonger"
    ],
    "plongeames": [
        "plonger"
    ],
    "plongeat": [
        "plonger"
    ],
    "plongiez": [
        "plonger"
    ],
    "plongions": [
        "plonger"
    ],
    "plongerent": [
        "plonger"
    ],
    "plongee": [
        "plongee",
        "plonger"
    ],
    "plongees": [
        "plongee",
        "plonger"
    ],
    "plot": [
        "plot"
    ],
    "plots": [
        "plot"
    ],
    "plouc": [
        "plouc"
    ],
    "ploucs": [
        "plouc"
    ],
    "plouf": [
        "plouf"
    ],
    "plouk": [
        "plouk"
    ],
    "ploutocrate": [
        "ploutocrate"
    ],
    "ploutocrates": [
        "ploutocrate"
    ],
    "ploutocratie": [
        "ploutocratie"
    ],
    "ploya": [
        "ployer"
    ],
    "ployaient": [
        "ployer"
    ],
    "ployait": [
        "ployer"
    ],
    "ployant": [
        "ployant",
        "ployer"
    ],
    "ployante": [
        "ployant"
    ],
    "ployer": [
        "ployer"
    ],
    "ploye": [
        "ployer"
    ],
    "ployee": [
        "ployer"
    ],
    "ployees": [
        "ployer"
    ],
    "ployes": [
        "ployer"
    ],
    "plu": [
        "pleuvoir"
    ],
    "pluche": [
        "plucher"
    ],
    "plucher": [
        "plucher"
    ],
    "pluches": [
        "pluches"
    ],
    "plue": [
        "plue"
    ],
    "pluie": [
        "pluie"
    ],
    "pluies": [
        "pluie"
    ],
    "plum": [
        "plume"
    ],
    "pluma": [
        "plumer"
    ],
    "plumage": [
        "plumage"
    ],
    "plumages": [
        "plumage"
    ],
    "plumaient": [
        "plumer"
    ],
    "plumait": [
        "plumer"
    ],
    "plumant": [
        "plumer"
    ],
    "plumard": [
        "plumard"
    ],
    "plumards": [
        "plumard"
    ],
    "plumassiere": [
        "plumassier"
    ],
    "plume": [
        "plume",
        "plumer"
    ],
    "plumeau": [
        "plumeau"
    ],
    "plumeaux": [
        "plumeau"
    ],
    "plument": [
        "plumer"
    ],
    "plumer": [
        "plumer"
    ],
    "plumes": [
        "plume",
        "plumer"
    ],
    "plumet": [
        "plumet"
    ],
    "plumetis": [
        "plumetis"
    ],
    "plumets": [
        "plumet"
    ],
    "plumeuse": [
        "plumeux"
    ],
    "plumeuses": [
        "plumeux"
    ],
    "plumeux": [
        "plumeux"
    ],
    "plumez": [
        "plumer"
    ],
    "plumier": [
        "plumier"
    ],
    "plumiers": [
        "plumier"
    ],
    "plumitif": [
        "plumitif"
    ],
    "plumitifs": [
        "plumitif"
    ],
    "plumitives": [
        "plumitive"
    ],
    "plumules": [
        "plumule"
    ],
    "plumee": [
        "plumer",
        "plumee"
    ],
    "plumees": [
        "plumer"
    ],
    "plupart": [
        "plupart"
    ],
    "pluralisme": [
        "pluralisme"
    ],
    "pluraliste": [
        "pluraliste"
    ],
    "pluralite": [
        "pluralite"
    ],
    "plurent": [
        "plaire"
    ],
    "pluriannuel": [
        "pluriannuel"
    ],
    "pluridisciplinaire": [
        "pluridisciplinaire"
    ],
    "pluriel": [
        "pluriel"
    ],
    "plurielle": [
        "pluriel"
    ],
    "pluriels": [
        "pluriel"
    ],
    "plurinational": [
        "plurinational"
    ],
    "plus": [
        "plus",
        "plaire"
    ],
    "plusieurs": [
        "plusieurs"
    ],
    "plusse": [
        "plaire"
    ],
    "plut": [
        "plaire"
    ],
    "pluton": [
        "pluton"
    ],
    "plutonien": [
        "plutonien"
    ],
    "plutonienne": [
        "plutonien"
    ],
    "plutonique": [
        "plutonique"
    ],
    "plutonium": [
        "plutonium"
    ],
    "plutot": [
        "plutot"
    ],
    "pluvial": [
        "pluvial"
    ],
    "pluviale": [
        "pluvial"
    ],
    "pluviales": [
        "pluvial"
    ],
    "pluviaux": [
        "pluvial"
    ],
    "pluvier": [
        "pluvier"
    ],
    "pluviers": [
        "pluvier"
    ],
    "pluvieuse": [
        "pluvieux"
    ],
    "pluvieuses": [
        "pluvieux"
    ],
    "pluvieux": [
        "pluvieux"
    ],
    "pluviometre": [
        "pluviometre"
    ],
    "pluviometres": [
        "pluviometre"
    ],
    "pluviometrie": [
        "pluviometrie"
    ],
    "pluviometrique": [
        "pluviometrique"
    ],
    "pluviosite": [
        "pluviosite"
    ],
    "pluviose": [
        "pluviose"
    ],
    "platra": [
        "platrer"
    ],
    "platrait": [
        "platrer"
    ],
    "platras": [
        "platras"
    ],
    "platre": [
        "platrer",
        "platre"
    ],
    "platrent": [
        "platrer"
    ],
    "platrer": [
        "platrer"
    ],
    "platres": [
        "platrer",
        "platre"
    ],
    "platreuse": [
        "platreux"
    ],
    "platreuses": [
        "platreux"
    ],
    "platreux": [
        "platreux"
    ],
    "platrier": [
        "platrier"
    ],
    "platriers": [
        "platrier"
    ],
    "platree": [
        "platrer",
        "platre"
    ],
    "platrees": [
        "platrer"
    ],
    "plebe": [
        "plebe"
    ],
    "plevre": [
        "plevre"
    ],
    "plevres": [
        "plevre"
    ],
    "plebiscite": [
        "plebisciter",
        "plebiscite"
    ],
    "plebisciter": [
        "plebisciter"
    ],
    "plebiscites": [
        "plebisciter",
        "plebiscite"
    ],
    "plebeien": [
        "plebeien"
    ],
    "plebeienne": [
        "plebeien"
    ],
    "plebeiennes": [
        "plebeien"
    ],
    "plebeiens": [
        "plebeien"
    ],
    "pleiade": [
        "pleiade"
    ],
    "pleiades": [
        "pleiade"
    ],
    "pleistocene": [
        "pleistocene"
    ],
    "plenier": [
        "plenier"
    ],
    "pleniers": [
        "plenier"
    ],
    "plenipotentiaire": [
        "plenipotentiaire"
    ],
    "plenipotentiaires": [
        "plenipotentiaire"
    ],
    "plenitude": [
        "plenitude"
    ],
    "plenitudes": [
        "plenitude"
    ],
    "pleniere": [
        "plenier"
    ],
    "plenieres": [
        "plenier"
    ],
    "plenum": [
        "plenum"
    ],
    "pleonasme": [
        "pleonasme"
    ],
    "pleonasmes": [
        "pleonasme"
    ],
    "pleonastiques": [
        "pleonastique"
    ],
    "plesiosaure": [
        "plesiosaure"
    ],
    "plethore": [
        "plethore"
    ],
    "plethorique": [
        "plethorique"
    ],
    "plethoriques": [
        "plethorique"
    ],
    "pneu": [
        "pneu"
    ],
    "pneumatique": [
        "pneumatique"
    ],
    "pneumatiques": [
        "pneumatique"
    ],
    "pneumatophore": [
        "pneumatophore"
    ],
    "pneumo": [
        "pneumo"
    ],
    "pneumoconiose": [
        "pneumoconiose"
    ],
    "pneumocoque": [
        "pneumocoque"
    ],
    "pneumocoques": [
        "pneumocoque"
    ],
    "pneumocystose": [
        "pneumocystose"
    ],
    "pneumologue": [
        "pneumologue"
    ],
    "pneumonectomie": [
        "pneumonectomie"
    ],
    "pneumonie": [
        "pneumonie"
    ],
    "pneumonies": [
        "pneumonie"
    ],
    "pneumonique": [
        "pneumonique"
    ],
    "pneumopathie": [
        "pneumopathie"
    ],
    "pneumos": [
        "pneumo"
    ],
    "pneumothorax": [
        "pneumothorax"
    ],
    "pneus": [
        "pneu"
    ],
    "pochade": [
        "pochade"
    ],
    "pochades": [
        "pochade"
    ],
    "pochage": [
        "pochage"
    ],
    "pochard": [
        "pochard"
    ],
    "pocharde": [
        "pochard"
    ],
    "pochards": [
        "pochard"
    ],
    "poche": [
        "poche",
        "pocher"
    ],
    "pocher": [
        "pocher"
    ],
    "poches": [
        "poche",
        "pocher"
    ],
    "pochetron": [
        "pochetron"
    ],
    "pochetrons": [
        "pochetron"
    ],
    "pochette": [
        "pochette"
    ],
    "pochettes": [
        "pochette"
    ],
    "pochete": [
        "pochete"
    ],
    "pochetee": [
        "pochetee",
        "pochete"
    ],
    "pochetees": [
        "pochete"
    ],
    "pochoir": [
        "pochoir"
    ],
    "pochon": [
        "pochon"
    ],
    "pochons": [
        "pochon"
    ],
    "pochtron": [
        "pochtron"
    ],
    "pochtrons": [
        "pochtron"
    ],
    "pochee": [
        "poche",
        "pocher"
    ],
    "pochees": [
        "poche",
        "pocher"
    ],
    "podagre": [
        "podagre"
    ],
    "podestat": [
        "podestat"
    ],
    "podestats": [
        "podestat"
    ],
    "podium": [
        "podium"
    ],
    "podiums": [
        "podium"
    ],
    "podologue": [
        "podologue"
    ],
    "podometre": [
        "podometre"
    ],
    "poecile": [
        "poecile"
    ],
    "pogne": [
        "pogne"
    ],
    "pognes": [
        "pogne"
    ],
    "pognon": [
        "pognon"
    ],
    "pogo": [
        "pogo"
    ],
    "pogrom": [
        "pogrom"
    ],
    "pogrome": [
        "pogrome"
    ],
    "pogromes": [
        "pogrome"
    ],
    "pogroms": [
        "pogrom"
    ],
    "poids": [
        "poids"
    ],
    "poignaient": [
        "poigner"
    ],
    "poignait": [
        "poigner"
    ],
    "poignant": [
        "poigner",
        "poignant"
    ],
    "poignante": [
        "poignant"
    ],
    "poignantes": [
        "poignant"
    ],
    "poignants": [
        "poignant"
    ],
    "poignard": [
        "poignard"
    ],
    "poignarda": [
        "poignarder"
    ],
    "poignardaient": [
        "poignarder"
    ],
    "poignardais": [
        "poignarder"
    ],
    "poignardait": [
        "poignarder"
    ],
    "poignardant": [
        "poignarder"
    ],
    "poignarde": [
        "poignarder"
    ],
    "poignardent": [
        "poignarder"
    ],
    "poignarder": [
        "poignarder"
    ],
    "poignardera": [
        "poignarder"
    ],
    "poignarderai": [
        "poignarder"
    ],
    "poignarderais": [
        "poignarder"
    ],
    "poignarderait": [
        "poignarder"
    ],
    "poignarderont": [
        "poignarder"
    ],
    "poignardez": [
        "poignarder"
    ],
    "poignards": [
        "poignard"
    ],
    "poignardee": [
        "poignarder"
    ],
    "poignardees": [
        "poignarder"
    ],
    "poignardes": [
        "poignarder"
    ],
    "poigne": [
        "poigne"
    ],
    "poignent": [
        "poigner"
    ],
    "poigner": [
        "poigner"
    ],
    "poignerait": [
        "poigner"
    ],
    "poignes": [
        "poigne"
    ],
    "poignet": [
        "poignet"
    ],
    "poignets": [
        "poignet"
    ],
    "poignons": [
        "poigner"
    ],
    "poignee": [
        "poignee"
    ],
    "poignees": [
        "poignee"
    ],
    "poil": [
        "poil"
    ],
    "poilaient": [
        "poiler"
    ],
    "poilais": [
        "poiler"
    ],
    "poilait": [
        "poiler"
    ],
    "poilant": [
        "poiler",
        "poilant"
    ],
    "poile": [
        "poiler"
    ],
    "poiler": [
        "poiler"
    ],
    "poileux": [
        "poileux"
    ],
    "poils": [
        "poil"
    ],
    "poilu": [
        "poilu"
    ],
    "poilue": [
        "poilu"
    ],
    "poilues": [
        "poilu"
    ],
    "poilus": [
        "poilu"
    ],
    "poiles": [
        "poiler"
    ],
    "poindra": [
        "poindre"
    ],
    "poindre": [
        "poindre"
    ],
    "poing": [
        "po",
        "poing"
    ],
    "poings": [
        "poing"
    ],
    "poinsettia": [
        "poinsettia"
    ],
    "point": [
        "point",
        "poindre"
    ],
    "pointa": [
        "pointer"
    ],
    "pointage": [
        "pointage"
    ],
    "pointages": [
        "pointage"
    ],
    "pointai": [
        "pointer"
    ],
    "pointaient": [
        "pointer"
    ],
    "pointais": [
        "pointer"
    ],
    "pointait": [
        "pointer"
    ],
    "pointant": [
        "pointer"
    ],
    "pointe": [
        "pointer",
        "pointe"
    ],
    "pointeau": [
        "pointeau"
    ],
    "pointement": [
        "pointement"
    ],
    "pointent": [
        "pointer"
    ],
    "pointer": [
        "pointer"
    ],
    "pointera": [
        "pointer"
    ],
    "pointerai": [
        "pointer"
    ],
    "pointeraient": [
        "pointer"
    ],
    "pointerais": [
        "pointer"
    ],
    "pointerait": [
        "pointer"
    ],
    "pointeras": [
        "pointer"
    ],
    "pointerez": [
        "pointer"
    ],
    "pointeront": [
        "pointer"
    ],
    "pointers": [
        "pointer"
    ],
    "pointes": [
        "pointer",
        "pointe"
    ],
    "pointeur": [
        "pointeur"
    ],
    "pointeurs": [
        "pointeur"
    ],
    "pointeuse": [
        "pointeur"
    ],
    "pointeuses": [
        "pointeur"
    ],
    "pointez": [
        "pointer"
    ],
    "pointiez": [
        "pointer"
    ],
    "pointillaient": [
        "pointiller"
    ],
    "pointillant": [
        "pointiller"
    ],
    "pointille": [
        "pointille",
        "pointiller"
    ],
    "pointilleuse": [
        "pointilleux"
    ],
    "pointilleuses": [
        "pointilleux"
    ],
    "pointilleux": [
        "pointilleux"
    ],
    "pointillisme": [
        "pointillisme"
    ],
    "pointilliste": [
        "pointilliste"
    ],
    "pointillistes": [
        "pointilliste"
    ],
    "pointillee": [
        "pointiller"
    ],
    "pointillees": [
        "pointiller"
    ],
    "pointilles": [
        "pointille",
        "pointiller"
    ],
    "pointons": [
        "pointer"
    ],
    "points": [
        "point"
    ],
    "pointu": [
        "pointu"
    ],
    "pointue": [
        "pointu"
    ],
    "pointues": [
        "pointu"
    ],
    "pointure": [
        "pointure"
    ],
    "pointures": [
        "pointure"
    ],
    "pointus": [
        "pointu"
    ],
    "pointames": [
        "pointer"
    ],
    "pointerent": [
        "pointer"
    ],
    "pointee": [
        "pointer",
        "pointe"
    ],
    "pointees": [
        "pointer",
        "pointe"
    ],
    "poincon": [
        "poincon"
    ],
    "poinconnait": [
        "poinconner"
    ],
    "poinconner": [
        "poinconner"
    ],
    "poinconneraient": [
        "poinconner"
    ],
    "poinconneur": [
        "poinconneur"
    ],
    "poinconneurs": [
        "poinconneur"
    ],
    "poinconne": [
        "poinconner"
    ],
    "poinconnee": [
        "poinconner"
    ],
    "poinconnes": [
        "poinconner"
    ],
    "poincons": [
        "poincon"
    ],
    "poire": [
        "poire"
    ],
    "poireau": [
        "poireau"
    ],
    "poireautai": [
        "poireauter"
    ],
    "poireautaient": [
        "poireauter"
    ],
    "poireautais": [
        "poireauter"
    ],
    "poireautait": [
        "poireauter"
    ],
    "poireaute": [
        "poireauter"
    ],
    "poireauter": [
        "poireauter"
    ],
    "poireautes": [
        "poireauter"
    ],
    "poireautions": [
        "poireauter"
    ],
    "poireaux": [
        "poireau"
    ],
    "poirer": [
        "poirer"
    ],
    "poires": [
        "poire"
    ],
    "poirier": [
        "poirier"
    ],
    "poiriers": [
        "poirier"
    ],
    "poirota": [
        "poiroter"
    ],
    "poirotait": [
        "poiroter"
    ],
    "poiroter": [
        "poiroter"
    ],
    "poiree": [
        "poire"
    ],
    "pois": [
        "pois"
    ],
    "poiscaille": [
        "poiscaille"
    ],
    "poiscailles": [
        "poiscaille"
    ],
    "poison": [
        "poison"
    ],
    "poisons": [
        "poison"
    ],
    "poissaient": [
        "poisser"
    ],
    "poissait": [
        "poisser"
    ],
    "poissard": [
        "poissard"
    ],
    "poissardes": [
        "poissard"
    ],
    "poisse": [
        "poisse",
        "poisser"
    ],
    "poissent": [
        "poisser"
    ],
    "poisser": [
        "poisser"
    ],
    "poisses": [
        "poisse",
        "poisser"
    ],
    "poisseuse": [
        "poisseux"
    ],
    "poisseuses": [
        "poisseux"
    ],
    "poisseux": [
        "poisseux"
    ],
    "poisson": [
        "poisson"
    ],
    "poissonnerie": [
        "poissonnerie"
    ],
    "poissonneuse": [
        "poissonneux"
    ],
    "poissonneuses": [
        "poissonneux"
    ],
    "poissonneux": [
        "poissonneux"
    ],
    "poissonnier": [
        "poissonnier"
    ],
    "poissonniers": [
        "poissonnier"
    ],
    "poissonniere": [
        "poissonniere"
    ],
    "poissonnieres": [
        "poissonnier"
    ],
    "poissons": [
        "poisson",
        "poisser"
    ],
    "poissee": [
        "poisser"
    ],
    "poissees": [
        "poisser"
    ],
    "poitevin": [
        "poitevin"
    ],
    "poitevins": [
        "poitevin"
    ],
    "poitrail": [
        "poitrail"
    ],
    "poitrails": [
        "poitrail"
    ],
    "poitrinaire": [
        "poitrinaire"
    ],
    "poitrinaires": [
        "poitrinaire"
    ],
    "poitrinant": [
        "poitriner"
    ],
    "poitrine": [
        "poitrine"
    ],
    "poitrines": [
        "poitrine"
    ],
    "poitrinieres": [
        "poitriniere"
    ],
    "poivra": [
        "poivrer"
    ],
    "poivrade": [
        "poivrade"
    ],
    "poivrades": [
        "poivrade"
    ],
    "poivrais": [
        "poivrer"
    ],
    "poivrait": [
        "poivrer"
    ],
    "poivre": [
        "poivrer",
        "poivre"
    ],
    "poivrent": [
        "poivrer"
    ],
    "poivrer": [
        "poivrer"
    ],
    "poivres": [
        "poivrer",
        "poivre"
    ],
    "poivrez": [
        "poivrer"
    ],
    "poivrier": [
        "poivrier"
    ],
    "poivriers": [
        "poivrier"
    ],
    "poivriere": [
        "poivriere"
    ],
    "poivrieres": [
        "poivriere"
    ],
    "poivron": [
        "poivron"
    ],
    "poivrons": [
        "poivron"
    ],
    "poivrot": [
        "poivrot"
    ],
    "poivrote": [
        "poivrot"
    ],
    "poivrotes": [
        "poivrot"
    ],
    "poivrots": [
        "poivrot"
    ],
    "poivree": [
        "poivrer",
        "poivre"
    ],
    "poivrees": [
        "poivrer",
        "poivre"
    ],
    "poix": [
        "poix"
    ],
    "poker": [
        "poker"
    ],
    "pokers": [
        "poker"
    ],
    "polack": [
        "polack"
    ],
    "polacks": [
        "polack"
    ],
    "polaire": [
        "polaire"
    ],
    "polaires": [
        "polaire"
    ],
    "polak": [
        "polak"
    ],
    "polaks": [
        "polak"
    ],
    "polaque": [
        "polaque"
    ],
    "polaques": [
        "polaque"
    ],
    "polar": [
        "polar"
    ],
    "polarde": [
        "polard"
    ],
    "polardes": [
        "polard"
    ],
    "polards": [
        "polard"
    ],
    "polarisaient": [
        "polariser"
    ],
    "polarisait": [
        "polariser"
    ],
    "polarisant": [
        "polarisant",
        "polariser"
    ],
    "polarisants": [
        "polarisant"
    ],
    "polarisation": [
        "polarisation"
    ],
    "polarise": [
        "polarise",
        "polariser"
    ],
    "polarisent": [
        "polariser"
    ],
    "polariser": [
        "polariser"
    ],
    "polarisee": [
        "polarise",
        "polariser"
    ],
    "polarite": [
        "polarite"
    ],
    "polaroid": [
        "polaroid"
    ],
    "polaroids": [
        "polaroid"
    ],
    "polars": [
        "polar"
    ],
    "polder": [
        "polder"
    ],
    "polders": [
        "polder"
    ],
    "pole": [
        "pole"
    ],
    "polenta": [
        "polenta"
    ],
    "poli": [
        "polir",
        "poli"
    ],
    "police": [
        "policer",
        "police"
    ],
    "policeman": [
        "policeman"
    ],
    "policemen": [
        "policeman"
    ],
    "policer": [
        "policer"
    ],
    "polices": [
        "policer",
        "police"
    ],
    "polichinelle": [
        "polichinelle"
    ],
    "polichinelles": [
        "polichinelle"
    ],
    "policier": [
        "policier"
    ],
    "policiers": [
        "policier"
    ],
    "policiere": [
        "policier"
    ],
    "policieres": [
        "policier"
    ],
    "policlinique": [
        "policlinique"
    ],
    "policee": [
        "policer",
        "police"
    ],
    "policees": [
        "policer",
        "police"
    ],
    "polie": [
        "polir",
        "poli"
    ],
    "polies": [
        "polir",
        "poli"
    ],
    "poliment": [
        "poliment"
    ],
    "polio": [
        "polio"
    ],
    "poliomyelite": [
        "poliomyelite"
    ],
    "poliomyelitique": [
        "poliomyelitique"
    ],
    "poliomyelitiques": [
        "poliomyelitique"
    ],
    "poliorcetique": [
        "poliorcetique"
    ],
    "polios": [
        "polio"
    ],
    "polir": [
        "polir"
    ],
    "poliras": [
        "polir"
    ],
    "polis": [
        "polir",
        "poli"
    ],
    "polish": [
        "polish"
    ],
    "polissage": [
        "polissage"
    ],
    "polissages": [
        "polissage"
    ],
    "polissaient": [
        "polir"
    ],
    "polissais": [
        "polir"
    ],
    "polissait": [
        "polir"
    ],
    "polissant": [
        "polir"
    ],
    "polissent": [
        "polir"
    ],
    "polisseur": [
        "polisseur"
    ],
    "polisseurs": [
        "polisseur"
    ],
    "polisseuse": [
        "polisseur"
    ],
    "polissoir": [
        "polissoir"
    ],
    "polisson": [
        "polisson"
    ],
    "polissonnait": [
        "polissonner"
    ],
    "polissonne": [
        "polisson"
    ],
    "polissonner": [
        "polissonner"
    ],
    "polissonnerie": [
        "polissonnerie"
    ],
    "polissonneries": [
        "polissonnerie"
    ],
    "polissonnes": [
        "polisson"
    ],
    "polissons": [
        "polisson"
    ],
    "polissure": [
        "polissure"
    ],
    "polit": [
        "polir"
    ],
    "politburo": [
        "politburo"
    ],
    "politesse": [
        "politesse"
    ],
    "politesses": [
        "politesse"
    ],
    "politicard": [
        "politicard"
    ],
    "politicards": [
        "politicard"
    ],
    "politicien": [
        "politicien"
    ],
    "politicienne": [
        "politicien"
    ],
    "politiciennes": [
        "politicien"
    ],
    "politiciens": [
        "politicien"
    ],
    "politico": [
        "politico"
    ],
    "politique": [
        "politique"
    ],
    "politiquement": [
        "politiquement"
    ],
    "politiques": [
        "politique"
    ],
    "politisation": [
        "politisation"
    ],
    "politiser": [
        "politiser"
    ],
    "politise": [
        "politiser"
    ],
    "politisee": [
        "politiser"
    ],
    "politises": [
        "politiser"
    ],
    "polka": [
        "polka"
    ],
    "polkas": [
        "polka"
    ],
    "pollen": [
        "pollen"
    ],
    "pollens": [
        "pollen"
    ],
    "pollinies": [
        "pollinie"
    ],
    "pollinique": [
        "pollinique"
    ],
    "pollinisateur": [
        "pollinisateur"
    ],
    "pollinisation": [
        "pollinisation"
    ],
    "polliniser": [
        "polliniser"
    ],
    "pollinise": [
        "polliniser"
    ],
    "pollope": [
        "pollope"
    ],
    "polluait": [
        "polluer"
    ],
    "polluant": [
        "polluer",
        "polluant"
    ],
    "polluante": [
        "polluant"
    ],
    "polluants": [
        "polluant"
    ],
    "pollue": [
        "polluer"
    ],
    "polluent": [
        "polluer"
    ],
    "polluer": [
        "polluer"
    ],
    "pollueront": [
        "polluer"
    ],
    "pollues": [
        "polluer"
    ],
    "pollueur": [
        "pollueur"
    ],
    "pollueurs": [
        "pollueur"
    ],
    "pollueuse": [
        "pollueur"
    ],
    "polluez": [
        "polluer"
    ],
    "pollution": [
        "pollution"
    ],
    "pollutions": [
        "pollution"
    ],
    "polluee": [
        "polluer"
    ],
    "polluees": [
        "polluer"
    ],
    "polo": [
        "polo"
    ],
    "poloche": [
        "poloche"
    ],
    "polochon": [
        "polochon"
    ],
    "polochons": [
        "polochon"
    ],
    "polonais": [
        "polonais"
    ],
    "polonaise": [
        "polonais"
    ],
    "polonaises": [
        "polonais"
    ],
    "polope": [
        "polope"
    ],
    "polos": [
        "polo"
    ],
    "polski": [
        "polski"
    ],
    "poltron": [
        "poltron"
    ],
    "poltronne": [
        "poltron"
    ],
    "poltronnerie": [
        "poltronnerie"
    ],
    "poltrons": [
        "poltron"
    ],
    "poly": [
        "poly"
    ],
    "polyacrylate": [
        "polyacrylate"
    ],
    "polyamide": [
        "polyamide"
    ],
    "polyamides": [
        "polyamide"
    ],
    "polyandre": [
        "polyandre"
    ],
    "polyarthrite": [
        "polyarthrite"
    ],
    "polycarbonate": [
        "polycarbonate"
    ],
    "polychlorure": [
        "polychlorure"
    ],
    "polychrome": [
        "polychrome"
    ],
    "polychromes": [
        "polychrome"
    ],
    "polychromie": [
        "polychromie"
    ],
    "polychromees": [
        "polychrome"
    ],
    "polyclinique": [
        "polyclinique"
    ],
    "polycopiait": [
        "polycopier"
    ],
    "polycopie": [
        "polycopie"
    ],
    "polycopier": [
        "polycopier"
    ],
    "polycopiee": [
        "polycopier"
    ],
    "polycopies": [
        "polycopie",
        "polycopier"
    ],
    "polyculture": [
        "polyculture"
    ],
    "polycephale": [
        "polycephale"
    ],
    "polydactylie": [
        "polydactylie"
    ],
    "polyester": [
        "polyester"
    ],
    "polygame": [
        "polygame"
    ],
    "polygamie": [
        "polygamie"
    ],
    "polyglotte": [
        "polyglotte"
    ],
    "polyglottes": [
        "polyglotte"
    ],
    "polygonal": [
        "polygonal"
    ],
    "polygonales": [
        "polygonal"
    ],
    "polygonaux": [
        "polygonal"
    ],
    "polygone": [
        "polygone"
    ],
    "polygones": [
        "polygone"
    ],
    "polygraphe": [
        "polygraphe"
    ],
    "polygraphes": [
        "polygraphe"
    ],
    "polygenique": [
        "polygenique"
    ],
    "polykystique": [
        "polykystique"
    ],
    "polymorphe": [
        "polymorphe"
    ],
    "polymorphes": [
        "polymorphe"
    ],
    "polymorphie": [
        "polymorphie"
    ],
    "polymorphismes": [
        "polymorphisme"
    ],
    "polymere": [
        "polymere"
    ],
    "polymerase": [
        "polymerase"
    ],
    "polymerique": [
        "polymerique"
    ],
    "polymeriques": [
        "polymerique"
    ],
    "polynesien": [
        "polynesien"
    ],
    "polynesienne": [
        "polynesien"
    ],
    "polynesiennes": [
        "polynesien"
    ],
    "polynesiens": [
        "polynesien"
    ],
    "polype": [
        "polype"
    ],
    "polypes": [
        "polype"
    ],
    "polyphone": [
        "polyphone"
    ],
    "polyphonie": [
        "polyphonie"
    ],
    "polyphonique": [
        "polyphonique"
    ],
    "polypier": [
        "polypier"
    ],
    "polypiers": [
        "polypier"
    ],
    "polypropylene": [
        "polypropylene"
    ],
    "polysaccharides": [
        "polysaccharide"
    ],
    "polystyrene": [
        "polystyrene"
    ],
    "polysyllabe": [
        "polysyllabe"
    ],
    "polysyllabique": [
        "polysyllabique"
    ],
    "polytechnicien": [
        "polytechnicien"
    ],
    "polytechnicienne": [
        "polytechnicien"
    ],
    "polytechniciens": [
        "polytechnicien"
    ],
    "polytechnique": [
        "polytechnique"
    ],
    "polythene": [
        "polythene"
    ],
    "polytheiste": [
        "polytheiste"
    ],
    "polytonal": [
        "polytonal"
    ],
    "polytonalite": [
        "polytonalite"
    ],
    "polyurethane": [
        "polyurethane"
    ],
    "polyvalence": [
        "polyvalence"
    ],
    "polyvalent": [
        "polyvalent"
    ],
    "polyvalente": [
        "polyvalent"
    ],
    "polyvalents": [
        "polyvalent"
    ],
    "polyvinyle": [
        "polyvinyle"
    ],
    "polyvinylique": [
        "polyvinylique"
    ],
    "polyedre": [
        "polyedre"
    ],
    "polyedres": [
        "polyedre"
    ],
    "polyethylene": [
        "polyethylene"
    ],
    "polemique": [
        "polemiquer",
        "polemique"
    ],
    "polemiquer": [
        "polemiquer"
    ],
    "polemiques": [
        "polemiquer",
        "polemique"
    ],
    "polemiste": [
        "polemiste"
    ],
    "polemistes": [
        "polemiste"
    ],
    "pomelo": [
        "pomelo"
    ],
    "pomerols": [
        "pomerol"
    ],
    "pommade": [
        "pommade",
        "pommader"
    ],
    "pommader": [
        "pommader"
    ],
    "pommades": [
        "pommade",
        "pommader"
    ],
    "pommadin": [
        "pommadin"
    ],
    "pommadees": [
        "pommade"
    ],
    "pommaient": [
        "pommer"
    ],
    "pommard": [
        "pommard"
    ],
    "pommards": [
        "pommard"
    ],
    "pomme": [
        "pomme",
        "pommer"
    ],
    "pommeau": [
        "pommeau"
    ],
    "pommeaux": [
        "pommeau"
    ],
    "pommeler": [
        "pommeler"
    ],
    "pommele": [
        "pommeler",
        "pommele"
    ],
    "pommelees": [
        "pommeler",
        "pommele"
    ],
    "pommeles": [
        "pommele"
    ],
    "pommer": [
        "pommer"
    ],
    "pommeraie": [
        "pommeraie"
    ],
    "pommes": [
        "pomme",
        "pommer"
    ],
    "pommette": [
        "pommette"
    ],
    "pommettes": [
        "pommette"
    ],
    "pommier": [
        "pommier"
    ],
    "pommiers": [
        "pommier"
    ],
    "pommee": [
        "pomme",
        "pommer"
    ],
    "pommees": [
        "pomme",
        "pommer"
    ],
    "pompadour": [
        "pompadour"
    ],
    "pompage": [
        "pompage"
    ],
    "pompai": [
        "pomper"
    ],
    "pompaient": [
        "pomper"
    ],
    "pompais": [
        "pomper"
    ],
    "pompait": [
        "pomper"
    ],
    "pompant": [
        "pomper"
    ],
    "pompe": [
        "pomper",
        "pompe"
    ],
    "pompent": [
        "pomper"
    ],
    "pomper": [
        "pomper"
    ],
    "pompera": [
        "pomper"
    ],
    "pomperais": [
        "pomper"
    ],
    "pomperait": [
        "pomper"
    ],
    "pompes": [
        "pomper",
        "pompe"
    ],
    "pompette": [
        "pompette"
    ],
    "pompeur": [
        "pompeur"
    ],
    "pompeuse": [
        "pompeux"
    ],
    "pompeusement": [
        "pompeusement"
    ],
    "pompeuses": [
        "pompeux"
    ],
    "pompeux": [
        "pompeux"
    ],
    "pompez": [
        "pomper"
    ],
    "pompidoliens": [
        "pompidolien"
    ],
    "pompier": [
        "pompier"
    ],
    "pompiers": [
        "pompier"
    ],
    "pompions": [
        "pomper"
    ],
    "pompiste": [
        "pompiste"
    ],
    "pompistes": [
        "pompiste"
    ],
    "pompierisme": [
        "pompierisme"
    ],
    "pompon": [
        "pompon"
    ],
    "pomponna": [
        "pomponner"
    ],
    "pomponnaient": [
        "pomponner"
    ],
    "pomponnait": [
        "pomponner"
    ],
    "pomponnant": [
        "pomponner"
    ],
    "pomponne": [
        "pomponner"
    ],
    "pomponnent": [
        "pomponner"
    ],
    "pomponner": [
        "pomponner"
    ],
    "pomponniez": [
        "pomponner"
    ],
    "pomponnee": [
        "pomponner"
    ],
    "pomponnees": [
        "pomponner"
    ],
    "pomponnes": [
        "pomponner"
    ],
    "pompons": [
        "pomper",
        "pompon"
    ],
    "pompee": [
        "pomper"
    ],
    "pompeien": [
        "pompeien"
    ],
    "pompeienne": [
        "pompeien"
    ],
    "pompeiennes": [
        "pompeien"
    ],
    "pompeiens": [
        "pompeien"
    ],
    "pomeranien": [
        "pomeranien"
    ],
    "pomeranienne": [
        "pomeranien"
    ],
    "pomeraniennes": [
        "pomeranien"
    ],
    "pomeraniens": [
        "pomeranien"
    ],
    "ponant": [
        "ponant"
    ],
    "ponce": [
        "ponce",
        "poncer"
    ],
    "ponceau": [
        "ponceau"
    ],
    "ponceaux": [
        "ponceau"
    ],
    "poncer": [
        "poncer"
    ],
    "ponces": [
        "poncer"
    ],
    "ponceuse": [
        "ponceur"
    ],
    "poncho": [
        "poncho"
    ],
    "ponchos": [
        "poncho"
    ],
    "poncif": [
        "poncif"
    ],
    "poncifs": [
        "poncif"
    ],
    "ponction": [
        "ponction"
    ],
    "ponctionna": [
        "ponctionner"
    ],
    "ponctionnait": [
        "ponctionner"
    ],
    "ponctionne": [
        "ponctionner"
    ],
    "ponctionner": [
        "ponctionner"
    ],
    "ponctions": [
        "ponction"
    ],
    "ponctua": [
        "ponctuer"
    ],
    "ponctuaient": [
        "ponctuer"
    ],
    "ponctuait": [
        "ponctuer"
    ],
    "ponctualite": [
        "ponctualite"
    ],
    "ponctuant": [
        "ponctuer"
    ],
    "ponctuation": [
        "ponctuation"
    ],
    "ponctuations": [
        "ponctuation"
    ],
    "ponctue": [
        "ponctuer"
    ],
    "ponctuel": [
        "ponctuel"
    ],
    "ponctuelle": [
        "ponctuel"
    ],
    "ponctuellement": [
        "ponctuellement"
    ],
    "ponctuelles": [
        "ponctuel"
    ],
    "ponctuels": [
        "ponctuel"
    ],
    "ponctuent": [
        "ponctuer"
    ],
    "ponctuer": [
        "ponctuer"
    ],
    "ponctuerent": [
        "ponctuer"
    ],
    "ponctuee": [
        "ponctue",
        "ponctuer"
    ],
    "ponctuees": [
        "ponctue",
        "ponctuer"
    ],
    "ponctues": [
        "ponctue",
        "ponctuer"
    ],
    "poncee": [
        "poncer"
    ],
    "poncees": [
        "poncer"
    ],
    "pond": [
        "pondre"
    ],
    "pondaient": [
        "pondre"
    ],
    "pondait": [
        "pondre"
    ],
    "pondant": [
        "pondre"
    ],
    "ponde": [
        "pondre"
    ],
    "pondent": [
        "pondre"
    ],
    "pondes": [
        "pondre"
    ],
    "pondeur": [
        "pondeur"
    ],
    "pondeuse": [
        "pondeur"
    ],
    "pondeuses": [
        "pondeur"
    ],
    "pondez": [
        "pondre"
    ],
    "pondiez": [
        "pondre"
    ],
    "pondoir": [
        "pondoir"
    ],
    "pondoirs": [
        "pondoir"
    ],
    "pondra": [
        "pondre"
    ],
    "pondrai": [
        "pondre"
    ],
    "pondraient": [
        "pondre"
    ],
    "pondrais": [
        "pondre"
    ],
    "pondras": [
        "pondre"
    ],
    "pondre": [
        "pondre"
    ],
    "pondront": [
        "pondre"
    ],
    "ponds": [
        "pond",
        "pondre"
    ],
    "pondu": [
        "pondre"
    ],
    "pondue": [
        "pondre"
    ],
    "pondus": [
        "pondre"
    ],
    "ponderable": [
        "ponderable"
    ],
    "ponderables": [
        "ponderable"
    ],
    "ponderale": [
        "ponderal"
    ],
    "ponderation": [
        "ponderation"
    ],
    "ponderer": [
        "ponderer"
    ],
    "pondere": [
        "ponderer",
        "pondere"
    ],
    "ponderee": [
        "ponderer",
        "pondere"
    ],
    "ponderees": [
        "pondere"
    ],
    "ponderes": [
        "pondere"
    ],
    "ponette": [
        "ponette"
    ],
    "ponettes": [
        "ponette"
    ],
    "poney": [
        "poney"
    ],
    "poneys": [
        "poney"
    ],
    "pongiste": [
        "pongiste"
    ],
    "pongistes": [
        "pongiste"
    ],
    "pongo": [
        "pongo"
    ],
    "ponge": [
        "ponge"
    ],
    "pont": [
        "pont"
    ],
    "pontage": [
        "pontage"
    ],
    "pontages": [
        "pontage"
    ],
    "ponte": [
        "ponte",
        "ponter"
    ],
    "ponter": [
        "ponter"
    ],
    "pontes": [
        "ponte"
    ],
    "pontet": [
        "pontet"
    ],
    "pontets": [
        "pontet"
    ],
    "pontife": [
        "pontife"
    ],
    "pontifes": [
        "pontife"
    ],
    "pontifia": [
        "pontifier"
    ],
    "pontifiait": [
        "pontifier"
    ],
    "pontifiant": [
        "pontifier",
        "pontifiant"
    ],
    "pontifiante": [
        "pontifiant"
    ],
    "pontifiants": [
        "pontifiant"
    ],
    "pontifical": [
        "pontifical"
    ],
    "pontificale": [
        "pontifical"
    ],
    "pontificales": [
        "pontifical"
    ],
    "pontificat": [
        "pontificat"
    ],
    "pontificaux": [
        "pontifical"
    ],
    "pontifie": [
        "pontifier"
    ],
    "pontifier": [
        "pontifier"
    ],
    "pontifierent": [
        "pontifier"
    ],
    "pontil": [
        "pontil"
    ],
    "pontin": [
        "pontin"
    ],
    "pontins": [
        "pontin"
    ],
    "ponton": [
        "ponton"
    ],
    "pontonnier": [
        "pontonnier"
    ],
    "pontonniers": [
        "pontonnier"
    ],
    "pontons": [
        "ponton"
    ],
    "ponts": [
        "pont"
    ],
    "poncage": [
        "poncage"
    ],
    "poncait": [
        "poncer"
    ],
    "poncant": [
        "poncer"
    ],
    "pool": [
        "pool"
    ],
    "pop": [
        "pop"
    ],
    "popaul": [
        "popaul"
    ],
    "pope": [
        "pope"
    ],
    "popeline": [
        "popeline"
    ],
    "popes": [
        "pope"
    ],
    "popistes": [
        "popiste"
    ],
    "poplite": [
        "poplite"
    ],
    "poplitee": [
        "poplite"
    ],
    "popote": [
        "popote"
    ],
    "popotes": [
        "popote"
    ],
    "popotin": [
        "popotin"
    ],
    "populace": [
        "populace"
    ],
    "populacier": [
        "populacier"
    ],
    "populaciere": [
        "populacier"
    ],
    "populacieres": [
        "populacier"
    ],
    "populaire": [
        "populaire"
    ],
    "populairement": [
        "populairement"
    ],
    "populaires": [
        "populaire"
    ],
    "populariser": [
        "populariser"
    ],
    "popularise": [
        "populariser"
    ],
    "popularite": [
        "popularite"
    ],
    "popularites": [
        "popularite"
    ],
    "population": [
        "population"
    ],
    "populations": [
        "population"
    ],
    "populeuse": [
        "populeux"
    ],
    "populeuses": [
        "populeux"
    ],
    "populeux": [
        "populeux"
    ],
    "populisme": [
        "populisme"
    ],
    "populismes": [
        "populisme"
    ],
    "populiste": [
        "populiste"
    ],
    "populistes": [
        "populiste"
    ],
    "populo": [
        "populo"
    ],
    "poquait": [
        "poquer"
    ],
    "poque": [
        "poque"
    ],
    "poquette": [
        "poquette"
    ],
    "porc": [
        "porc"
    ],
    "porcelaine": [
        "porcelaine"
    ],
    "porcelaines": [
        "porcelaine"
    ],
    "porcelainiers": [
        "porcelainier"
    ],
    "porcelet": [
        "porcelet"
    ],
    "porcelets": [
        "porcelet"
    ],
    "porche": [
        "porche"
    ],
    "porcher": [
        "porcher"
    ],
    "porcherie": [
        "porcherie"
    ],
    "porcheries": [
        "porcherie"
    ],
    "porches": [
        "porche",
        "porch"
    ],
    "porchere": [
        "porcher"
    ],
    "porcheres": [
        "porcher"
    ],
    "porcif": [
        "porcif"
    ],
    "porcifs": [
        "porcif"
    ],
    "porcin": [
        "porcin"
    ],
    "porcine": [
        "porcin"
    ],
    "porcins": [
        "porcin"
    ],
    "porcs": [
        "porc"
    ],
    "pore": [
        "pore"
    ],
    "pores": [
        "pore"
    ],
    "poreuse": [
        "poreux"
    ],
    "poreuses": [
        "poreux"
    ],
    "poreux": [
        "poreux"
    ],
    "porno": [
        "porno"
    ],
    "pornocrate": [
        "pornocrate"
    ],
    "pornocrates": [
        "pornocrate"
    ],
    "pornographe": [
        "pornographe"
    ],
    "pornographes": [
        "pornographe"
    ],
    "pornographie": [
        "pornographie"
    ],
    "pornographies": [
        "pornographie",
        "pornography"
    ],
    "pornographique": [
        "pornographique"
    ],
    "pornographiques": [
        "pornographique"
    ],
    "pornos": [
        "porno"
    ],
    "porosite": [
        "porosite"
    ],
    "porphyre": [
        "porphyre"
    ],
    "porphyres": [
        "porphyre"
    ],
    "porphyrie": [
        "porphyrie"
    ],
    "porque": [
        "porque"
    ],
    "porridge": [
        "porridge"
    ],
    "port": [
        "port"
    ],
    "porta": [
        "porter"
    ],
    "portabilite": [
        "portabilite"
    ],
    "portable": [
        "portable"
    ],
    "portables": [
        "portable"
    ],
    "portage": [
        "portage"
    ],
    "portager": [
        "portager"
    ],
    "portai": [
        "porter"
    ],
    "portaient": [
        "porter"
    ],
    "portail": [
        "portail"
    ],
    "portails": [
        "portail"
    ],
    "portais": [
        "porter"
    ],
    "portait": [
        "porter"
    ],
    "portal": [
        "portal"
    ],
    "portance": [
        "portance"
    ],
    "portant": [
        "portant",
        "porter"
    ],
    "portante": [
        "portant"
    ],
    "portants": [
        "portant"
    ],
    "portassent": [
        "porter"
    ],
    "portatif": [
        "portatif"
    ],
    "portatifs": [
        "portatif"
    ],
    "portative": [
        "portatif"
    ],
    "portatives": [
        "portatif"
    ],
    "porte": [
        "porte",
        "porter"
    ],
    "portefaix": [
        "portefaix"
    ],
    "portefeuille": [
        "portefeuille"
    ],
    "portefeuilles": [
        "portefeuille"
    ],
    "portemanteau": [
        "portemanteau"
    ],
    "portemanteaux": [
        "portemanteau"
    ],
    "portement": [
        "portement"
    ],
    "portent": [
        "porter"
    ],
    "porter": [
        "porter"
    ],
    "portera": [
        "porter"
    ],
    "porterai": [
        "porter"
    ],
    "porteraient": [
        "porter"
    ],
    "porterais": [
        "porter"
    ],
    "porterait": [
        "porter"
    ],
    "porteras": [
        "porter"
    ],
    "porterez": [
        "porter"
    ],
    "porterie": [
        "porterie"
    ],
    "porteriez": [
        "porter"
    ],
    "porterons": [
        "porter"
    ],
    "porteront": [
        "porter"
    ],
    "portes": [
        "porte",
        "porter"
    ],
    "porteur": [
        "porteur"
    ],
    "porteurs": [
        "porteur"
    ],
    "porteuse": [
        "porteur"
    ],
    "porteuses": [
        "porteur"
    ],
    "portez": [
        "porter"
    ],
    "portfolio": [
        "portfolio"
    ],
    "portier": [
        "portier"
    ],
    "portiers": [
        "portier"
    ],
    "portiez": [
        "porter"
    ],
    "portillon": [
        "portillon"
    ],
    "portillons": [
        "portillon"
    ],
    "portion": [
        "portion"
    ],
    "portions": [
        "portion",
        "porter"
    ],
    "portique": [
        "portique"
    ],
    "portiques": [
        "portique"
    ],
    "portiere": [
        "portier"
    ],
    "portieres": [
        "portier"
    ],
    "portland": [
        "portland"
    ],
    "porto": [
        "porto"
    ],
    "portons": [
        "porter"
    ],
    "portor": [
        "portor"
    ],
    "portoricain": [
        "portoricain"
    ],
    "portoricaine": [
        "portoricain"
    ],
    "portoricaines": [
        "portoricain"
    ],
    "portoricains": [
        "portoricain"
    ],
    "portos": [
        "porto"
    ],
    "portraire": [
        "portraire"
    ],
    "portrait": [
        "portraire",
        "portrait"
    ],
    "portraitiste": [
        "portraitiste"
    ],
    "portraitistes": [
        "portraitiste"
    ],
    "portraits": [
        "portraire",
        "portrait"
    ],
    "portraiturant": [
        "portraiturer"
    ],
    "portraiture": [
        "portraiturer"
    ],
    "portraiturer": [
        "portraiturer"
    ],
    "portraitures": [
        "portraiturer",
        "portraiture"
    ],
    "ports": [
        "port"
    ],
    "portuaire": [
        "portuaire"
    ],
    "portuaires": [
        "portuaire"
    ],
    "portugais": [
        "portugais"
    ],
    "portugaise": [
        "portugais"
    ],
    "portugaises": [
        "portugais"
    ],
    "portulan": [
        "portulan"
    ],
    "portulans": [
        "portulan"
    ],
    "portus": [
        "portus"
    ],
    "portames": [
        "porter"
    ],
    "portat": [
        "porter"
    ],
    "porterent": [
        "porter"
    ],
    "portee": [
        "portee",
        "porter"
    ],
    "portees": [
        "portee",
        "porte",
        "porter"
    ],
    "posa": [
        "poser"
    ],
    "posada": [
        "posada"
    ],
    "posadas": [
        "posada"
    ],
    "posai": [
        "poser"
    ],
    "posaient": [
        "poser"
    ],
    "posais": [
        "poser"
    ],
    "posait": [
        "poser"
    ],
    "posant": [
        "poser"
    ],
    "posas": [
        "poser"
    ],
    "pose": [
        "pose",
        "poser"
    ],
    "posemetre": [
        "posemetre"
    ],
    "posent": [
        "poser"
    ],
    "poser": [
        "poser"
    ],
    "posera": [
        "poser"
    ],
    "poserai": [
        "poser"
    ],
    "poseraient": [
        "poser"
    ],
    "poserais": [
        "poser"
    ],
    "poserait": [
        "poser"
    ],
    "poseras": [
        "poser"
    ],
    "poserez": [
        "poser"
    ],
    "poseriez": [
        "poser"
    ],
    "poserions": [
        "poser"
    ],
    "poserons": [
        "poser"
    ],
    "poseront": [
        "poser"
    ],
    "poses": [
        "pose",
        "poser"
    ],
    "poseur": [
        "poseur"
    ],
    "poseurs": [
        "poseur"
    ],
    "poseuse": [
        "poseur"
    ],
    "posez": [
        "poser"
    ],
    "posiez": [
        "poser"
    ],
    "posions": [
        "poser"
    ],
    "positif": [
        "positif"
    ],
    "positifs": [
        "positif"
    ],
    "position": [
        "position"
    ],
    "positionne": [
        "positionner"
    ],
    "positionnel": [
        "positionnel"
    ],
    "positionnement": [
        "positionnement"
    ],
    "positionnent": [
        "positionner"
    ],
    "positionner": [
        "positionner"
    ],
    "positionnera": [
        "positionner"
    ],
    "positionneur": [
        "positionneur"
    ],
    "positionnee": [
        "positionner"
    ],
    "positions": [
        "position"
    ],
    "positive": [
        "positif"
    ],
    "positivement": [
        "positivement"
    ],
    "positiver": [
        "positiver"
    ],
    "positives": [
        "positif",
        "positive"
    ],
    "positivisme": [
        "positivisme"
    ],
    "positiviste": [
        "positiviste"
    ],
    "positivistes": [
        "positiviste"
    ],
    "positivite": [
        "positivite"
    ],
    "positon": [
        "positon"
    ],
    "positron": [
        "positron"
    ],
    "positrons": [
        "positron"
    ],
    "posologie": [
        "posologie"
    ],
    "posologies": [
        "posologie"
    ],
    "posons": [
        "poser"
    ],
    "possesseur": [
        "possesseur"
    ],
    "possesseurs": [
        "possesseur"
    ],
    "possessif": [
        "possessif"
    ],
    "possessifs": [
        "possessif"
    ],
    "possession": [
        "possession"
    ],
    "possessions": [
        "possession"
    ],
    "possessive": [
        "possessif"
    ],
    "possessives": [
        "possessif",
        "possessive"
    ],
    "possessivite": [
        "possessivite"
    ],
    "possibilite": [
        "possibilite"
    ],
    "possibilites": [
        "possibilite"
    ],
    "possible": [
        "possible"
    ],
    "possiblement": [
        "possiblement"
    ],
    "possibles": [
        "possible"
    ],
    "possede": [
        "posseder",
        "possede"
    ],
    "possedent": [
        "posseder"
    ],
    "possedes": [
        "posseder",
        "possede"
    ],
    "posseda": [
        "posseder"
    ],
    "possedaient": [
        "posseder"
    ],
    "possedais": [
        "posseder"
    ],
    "possedait": [
        "posseder"
    ],
    "possedant": [
        "posseder",
        "possedant"
    ],
    "possedante": [
        "possedant"
    ],
    "possedants": [
        "possedant"
    ],
    "possedasse": [
        "posseder"
    ],
    "posseder": [
        "posseder"
    ],
    "possedera": [
        "posseder"
    ],
    "possederai": [
        "posseder"
    ],
    "possederaient": [
        "posseder"
    ],
    "possederais": [
        "posseder"
    ],
    "possederait": [
        "posseder"
    ],
    "possederas": [
        "posseder"
    ],
    "possederez": [
        "posseder"
    ],
    "possederont": [
        "posseder"
    ],
    "possedez": [
        "posseder"
    ],
    "possediez": [
        "posseder"
    ],
    "possedions": [
        "posseder"
    ],
    "possedons": [
        "posseder"
    ],
    "possedat": [
        "posseder"
    ],
    "possedee": [
        "posseder",
        "possede"
    ],
    "possedees": [
        "posseder",
        "possede"
    ],
    "post": [
        "post"
    ],
    "posta": [
        "poster"
    ],
    "postage": [
        "postage"
    ],
    "postai": [
        "poster"
    ],
    "postaient": [
        "poster"
    ],
    "postais": [
        "poster"
    ],
    "postait": [
        "poster"
    ],
    "postal": [
        "postal"
    ],
    "postale": [
        "postal"
    ],
    "postales": [
        "postal"
    ],
    "postant": [
        "poster"
    ],
    "postaux": [
        "postal"
    ],
    "postcombustion": [
        "postcombustion"
    ],
    "postcure": [
        "postcure"
    ],
    "postdater": [
        "postdater"
    ],
    "postdate": [
        "postdater"
    ],
    "postdoctoral": [
        "postdoctoral"
    ],
    "poste": [
        "poster",
        "poste"
    ],
    "postent": [
        "poster"
    ],
    "poster": [
        "poster"
    ],
    "postera": [
        "poster"
    ],
    "posterai": [
        "poster"
    ],
    "posterait": [
        "poster"
    ],
    "posteras": [
        "poster"
    ],
    "posterons": [
        "poster"
    ],
    "posters": [
        "poster"
    ],
    "postes": [
        "poster",
        "poste"
    ],
    "postez": [
        "poster"
    ],
    "postface": [
        "postface"
    ],
    "postfaces": [
        "postface"
    ],
    "posthume": [
        "posthume"
    ],
    "posthumes": [
        "posthume"
    ],
    "postiche": [
        "postiche"
    ],
    "postiches": [
        "postiche"
    ],
    "postier": [
        "postier"
    ],
    "postiers": [
        "postier"
    ],
    "postillon": [
        "postillon"
    ],
    "postillonna": [
        "postillonner"
    ],
    "postillonnait": [
        "postillonner"
    ],
    "postillonnant": [
        "postillonner"
    ],
    "postillonne": [
        "postillonner"
    ],
    "postillonnent": [
        "postillonner"
    ],
    "postillonner": [
        "postillonner"
    ],
    "postillonnes": [
        "postillonner"
    ],
    "postillonneur": [
        "postillonneur"
    ],
    "postillonneurs": [
        "postillonneur"
    ],
    "postillonnez": [
        "postillonner"
    ],
    "postillons": [
        "postillon"
    ],
    "postiere": [
        "postier"
    ],
    "postmoderne": [
        "postmoderne"
    ],
    "postmodernisme": [
        "postmodernisme"
    ],
    "postmoderniste": [
        "postmoderniste"
    ],
    "postnatal": [
        "postnatal"
    ],
    "postnatale": [
        "postnatal"
    ],
    "postoperatoire": [
        "postoperatoire"
    ],
    "postoperatoires": [
        "postoperatoire"
    ],
    "postproduction": [
        "postproduction"
    ],
    "postsynchronisation": [
        "postsynchronisation"
    ],
    "postulai": [
        "postuler"
    ],
    "postulaient": [
        "postuler"
    ],
    "postulait": [
        "postuler"
    ],
    "postulant": [
        "postuler",
        "postulant"
    ],
    "postulante": [
        "postulant"
    ],
    "postulantes": [
        "postulant"
    ],
    "postulants": [
        "postulant"
    ],
    "postulat": [
        "postulat"
    ],
    "postulations": [
        "postulation"
    ],
    "postulats": [
        "postulat"
    ],
    "postule": [
        "postuler"
    ],
    "postulent": [
        "postuler"
    ],
    "postuler": [
        "postuler"
    ],
    "postuleras": [
        "postuler"
    ],
    "postules": [
        "postuler"
    ],
    "posturaux": [
        "postural"
    ],
    "posture": [
        "posture"
    ],
    "postures": [
        "posture"
    ],
    "postee": [
        "poster",
        "poste"
    ],
    "postees": [
        "poster",
        "poste"
    ],
    "posterieur": [
        "posterieur"
    ],
    "posterieure": [
        "posterieur"
    ],
    "posterieurement": [
        "posterieurement"
    ],
    "posterieures": [
        "posterieur"
    ],
    "posterieurs": [
        "posterieur"
    ],
    "posterite": [
        "posterite"
    ],
    "posterites": [
        "posterite"
    ],
    "posames": [
        "poser"
    ],
    "posat": [
        "poser"
    ],
    "poserent": [
        "poser"
    ],
    "posee": [
        "pose",
        "poser"
    ],
    "posees": [
        "pose",
        "poser"
    ],
    "posement": [
        "posement"
    ],
    "pot": [
        "pot"
    ],
    "potable": [
        "potable"
    ],
    "potables": [
        "potable"
    ],
    "potache": [
        "potache"
    ],
    "potaches": [
        "potache"
    ],
    "potage": [
        "potage"
    ],
    "potager": [
        "potager"
    ],
    "potagers": [
        "potager"
    ],
    "potages": [
        "potage"
    ],
    "potagere": [
        "potager"
    ],
    "potageres": [
        "potager"
    ],
    "potard": [
        "potard"
    ],
    "potassa": [
        "potasser"
    ],
    "potassait": [
        "potasser"
    ],
    "potasse": [
        "potasse",
        "potasser"
    ],
    "potassent": [
        "potasser"
    ],
    "potasser": [
        "potasser"
    ],
    "potasserai": [
        "potasser"
    ],
    "potasses": [
        "potasser"
    ],
    "potassez": [
        "potasser"
    ],
    "potassium": [
        "potassium"
    ],
    "pote": [
        "pote"
    ],
    "poteau": [
        "poteau"
    ],
    "poteaux": [
        "poteau"
    ],
    "potele": [
        "potele"
    ],
    "potelee": [
        "potele"
    ],
    "potelees": [
        "potele"
    ],
    "poteles": [
        "potele"
    ],
    "potence": [
        "potence"
    ],
    "potences": [
        "potence"
    ],
    "potencee": [
        "potence"
    ],
    "potentat": [
        "potentat"
    ],
    "potentats": [
        "potentat"
    ],
    "potentialisation": [
        "potentialisation"
    ],
    "potentialiser": [
        "potentialiser"
    ],
    "potentialite": [
        "potentialite"
    ],
    "potentiel": [
        "potentiel"
    ],
    "potentielle": [
        "potentiel"
    ],
    "potentiellement": [
        "potentiellement"
    ],
    "potentielles": [
        "potentiel"
    ],
    "potentiels": [
        "potentiel"
    ],
    "potentiometre": [
        "potentiometre"
    ],
    "poter": [
        "poter"
    ],
    "poterie": [
        "poterie"
    ],
    "poteries": [
        "poterie"
    ],
    "poterne": [
        "poterne"
    ],
    "poternes": [
        "poterne"
    ],
    "potes": [
        "pote"
    ],
    "potiche": [
        "potiche"
    ],
    "potiches": [
        "potiche"
    ],
    "potier": [
        "potier"
    ],
    "potiers": [
        "potier"
    ],
    "potimarron": [
        "potimarron"
    ],
    "potin": [
        "potin"
    ],
    "potinais": [
        "potiner"
    ],
    "potine": [
        "potiner"
    ],
    "potines": [
        "potiner"
    ],
    "potins": [
        "potin"
    ],
    "potion": [
        "potion"
    ],
    "potions": [
        "potion"
    ],
    "potiron": [
        "potiron"
    ],
    "potirons": [
        "potiron"
    ],
    "potiere": [
        "potier"
    ],
    "potlatch": [
        "potlatch"
    ],
    "potos": [
        "potos"
    ],
    "pots": [
        "pot"
    ],
    "potee": [
        "potee"
    ],
    "potees": [
        "potee"
    ],
    "pou": [
        "pou"
    ],
    "pouacre": [
        "pouacre"
    ],
    "pouah": [
        "pouah"
    ],
    "poubelle": [
        "poubelle"
    ],
    "poubelles": [
        "poubelle"
    ],
    "pouce": [
        "pouce"
    ],
    "pouces": [
        "pouce"
    ],
    "poucet": [
        "poucet"
    ],
    "poucets": [
        "poucet"
    ],
    "poucette": [
        "poucette"
    ],
    "poucettes": [
        "poucette"
    ],
    "pouding": [
        "pouding"
    ],
    "poudingue": [
        "poudingue"
    ],
    "poudra": [
        "poudrer"
    ],
    "poudrage": [
        "poudrage"
    ],
    "poudraient": [
        "poudrer"
    ],
    "poudrait": [
        "poudrer"
    ],
    "poudrant": [
        "poudrer"
    ],
    "poudre": [
        "poudre",
        "poudrer"
    ],
    "poudrent": [
        "poudrer"
    ],
    "poudrer": [
        "poudrer"
    ],
    "poudres": [
        "poudre",
        "poudrer"
    ],
    "poudrette": [
        "poudrette"
    ],
    "poudreuse": [
        "poudreux"
    ],
    "poudreuses": [
        "poudreux"
    ],
    "poudreux": [
        "poudreux"
    ],
    "poudrier": [
        "poudrier"
    ],
    "poudriers": [
        "poudrier"
    ],
    "poudriere": [
        "poudriere"
    ],
    "poudroie": [
        "poudroyer"
    ],
    "poudroiement": [
        "poudroiement"
    ],
    "poudroiements": [
        "poudroiement"
    ],
    "poudroyaient": [
        "poudroyer"
    ],
    "poudroyait": [
        "poudroyer"
    ],
    "poudroyante": [
        "poudroyant"
    ],
    "poudroyantes": [
        "poudroyant"
    ],
    "poudree": [
        "poudre",
        "poudrer"
    ],
    "poudrees": [
        "poudre",
        "poudrer"
    ],
    "pouf": [
        "pouf"
    ],
    "pouffa": [
        "pouffer"
    ],
    "pouffaient": [
        "pouffer"
    ],
    "pouffait": [
        "pouffer"
    ],
    "pouffant": [
        "pouffer",
        "pouffant"
    ],
    "pouffante": [
        "pouffant"
    ],
    "pouffantes": [
        "pouffant"
    ],
    "pouffe": [
        "pouffer"
    ],
    "pouffement": [
        "pouffement"
    ],
    "pouffements": [
        "pouffement"
    ],
    "pouffent": [
        "pouffer"
    ],
    "pouffer": [
        "pouffer"
    ],
    "poufferais": [
        "pouffer"
    ],
    "poufferait": [
        "pouffer"
    ],
    "pouffes": [
        "pouffer"
    ],
    "pouffiasse": [
        "pouffiasse"
    ],
    "pouffiasses": [
        "pouffiasse"
    ],
    "pouffions": [
        "pouffer"
    ],
    "pouffons": [
        "pouffer"
    ],
    "poufferent": [
        "pouffer"
    ],
    "poufiasse": [
        "poufiasse"
    ],
    "poufiasses": [
        "poufiasse"
    ],
    "poufs": [
        "pouf"
    ],
    "pouh": [
        "pouh"
    ],
    "pouic": [
        "pouic"
    ],
    "pouille": [
        "pouille"
    ],
    "pouillerie": [
        "pouillerie"
    ],
    "pouilleries": [
        "pouillerie"
    ],
    "pouilles": [
        "pouille"
    ],
    "pouilleuse": [
        "pouilleux"
    ],
    "pouilleuses": [
        "pouilleux"
    ],
    "pouilleux": [
        "pouilleux"
    ],
    "pouillot": [
        "pouillot"
    ],
    "pouillots": [
        "pouillot"
    ],
    "pouilly": [
        "pouilly"
    ],
    "poujadisme": [
        "poujadisme"
    ],
    "poujadiste": [
        "poujadiste"
    ],
    "poujadistes": [
        "poujadiste"
    ],
    "poulaga": [
        "poulaga"
    ],
    "poulagas": [
        "poulaga"
    ],
    "poulaille": [
        "poulaille"
    ],
    "poulailler": [
        "poulailler"
    ],
    "poulaillers": [
        "poulailler"
    ],
    "poulain": [
        "poulain"
    ],
    "poulaine": [
        "poulain"
    ],
    "poulaines": [
        "poulain"
    ],
    "poulains": [
        "poulain"
    ],
    "poularde": [
        "poulard"
    ],
    "poulardes": [
        "poulard"
    ],
    "poulardin": [
        "poulardin"
    ],
    "poulardins": [
        "poulardin"
    ],
    "poulbot": [
        "poulbot"
    ],
    "poulbots": [
        "poulbot"
    ],
    "poule": [
        "poule"
    ],
    "poules": [
        "poule"
    ],
    "poulet": [
        "poulet"
    ],
    "poulets": [
        "poulet"
    ],
    "poulette": [
        "poulette"
    ],
    "poulettes": [
        "poulette"
    ],
    "pouliche": [
        "pouliche"
    ],
    "pouliches": [
        "pouliche"
    ],
    "poulie": [
        "poulie"
    ],
    "poulies": [
        "poulie"
    ],
    "pouliniere": [
        "pouliniere"
    ],
    "poulot": [
        "poulot"
    ],
    "poulots": [
        "poulot"
    ],
    "poulottant": [
        "poulotter"
    ],
    "poulotter": [
        "poulotter"
    ],
    "poulpe": [
        "poulpe"
    ],
    "poulpes": [
        "poulpe"
    ],
    "pouls": [
        "pouls"
    ],
    "poumon": [
        "poumon"
    ],
    "poumons": [
        "poumon"
    ],
    "pound": [
        "pound"
    ],
    "pounds": [
        "pound"
    ],
    "poupard": [
        "poupard"
    ],
    "poupards": [
        "poupard"
    ],
    "poupe": [
        "poupe"
    ],
    "poupin": [
        "poupin"
    ],
    "poupine": [
        "poupin"
    ],
    "poupon": [
        "poupon"
    ],
    "pouponnage": [
        "pouponnage"
    ],
    "pouponne": [
        "pouponner"
    ],
    "pouponnent": [
        "pouponner"
    ],
    "pouponner": [
        "pouponner"
    ],
    "pouponniere": [
        "pouponniere"
    ],
    "pouponnieres": [
        "pouponniere"
    ],
    "poupons": [
        "poupon"
    ],
    "poupoule": [
        "poupoule"
    ],
    "poupee": [
        "poupee"
    ],
    "poupees": [
        "poupee"
    ],
    "pour": [
        "pour"
    ],
    "pourboire": [
        "pourboire"
    ],
    "pourboires": [
        "pourboire"
    ],
    "pourceau": [
        "pourceau"
    ],
    "pourceaux": [
        "pourceau"
    ],
    "pourcent": [
        "pourcent"
    ],
    "pourcentage": [
        "pourcentage"
    ],
    "pourcentages": [
        "pourcentage"
    ],
    "pourcents": [
        "pourcent"
    ],
    "pourchas": [
        "pourchas"
    ],
    "pourchassa": [
        "pourchasser"
    ],
    "pourchassaient": [
        "pourchasser"
    ],
    "pourchassais": [
        "pourchasser"
    ],
    "pourchassait": [
        "pourchasser"
    ],
    "pourchassant": [
        "pourchasser"
    ],
    "pourchasse": [
        "pourchasser"
    ],
    "pourchassent": [
        "pourchasser"
    ],
    "pourchasser": [
        "pourchasser"
    ],
    "pourchassera": [
        "pourchasser"
    ],
    "pourchasserai": [
        "pourchasser"
    ],
    "pourchasseraient": [
        "pourchasser"
    ],
    "pourchasserait": [
        "pourchasser"
    ],
    "pourchasserons": [
        "pourchasser"
    ],
    "pourchasseront": [
        "pourchasser"
    ],
    "pourchasseur": [
        "pourchasseur"
    ],
    "pourchassez": [
        "pourchasser"
    ],
    "pourchassons": [
        "pourchasser"
    ],
    "pourchasserent": [
        "pourchasser"
    ],
    "pourchassee": [
        "pourchasser"
    ],
    "pourchassees": [
        "pourchasser"
    ],
    "pourchasses": [
        "pourchasser"
    ],
    "pourcif": [
        "pourcif"
    ],
    "pourfendait": [
        "pourfendre"
    ],
    "pourfendant": [
        "pourfendre"
    ],
    "pourfende": [
        "pourfendre"
    ],
    "pourfendeur": [
        "pourfendeur"
    ],
    "pourfendions": [
        "pourfendre"
    ],
    "pourfendre": [
        "pourfendre"
    ],
    "pourfends": [
        "pourfendre"
    ],
    "pourfendu": [
        "pourfendre"
    ],
    "pourim": [
        "pourim"
    ],
    "pourliche": [
        "pourliche"
    ],
    "pourliches": [
        "pourliche"
    ],
    "pourleche": [
        "pourlecher"
    ],
    "pourlechent": [
        "pourlecher"
    ],
    "pourlechaient": [
        "pourlecher"
    ],
    "pourlechait": [
        "pourlecher"
    ],
    "pourlechant": [
        "pourlecher"
    ],
    "pourlecher": [
        "pourlecher"
    ],
    "pourlechee": [
        "pourlecher"
    ],
    "pourparler": [
        "pourparler"
    ],
    "pourparlers": [
        "pourparlers"
    ],
    "pourpier": [
        "pourpier"
    ],
    "pourpiers": [
        "pourpier"
    ],
    "pourpoint": [
        "pourpoint"
    ],
    "pourpoints": [
        "pourpoint"
    ],
    "pourpre": [
        "pourpre"
    ],
    "pourpres": [
        "pourpre"
    ],
    "pourpree": [
        "pourpre",
        "pourprer"
    ],
    "pourprees": [
        "pourprer"
    ],
    "pourquoi": [
        "pourquoi"
    ],
    "pourra": [
        "pouvoir"
    ],
    "pourrai": [
        "pouvoir"
    ],
    "pourraient": [
        "pouvoir"
    ],
    "pourrais": [
        "pouvoir"
    ],
    "pourrait": [
        "pouvoir"
    ],
    "pourras": [
        "pouvoir"
    ],
    "pourrez": [
        "pouvoir"
    ],
    "pourri": [
        "pourri",
        "pourrir"
    ],
    "pourrie": [
        "pourri",
        "pourrir"
    ],
    "pourries": [
        "pourri",
        "pourrir"
    ],
    "pourriez": [
        "pouvoir"
    ],
    "pourrions": [
        "pouvoir"
    ],
    "pourrir": [
        "pourrir"
    ],
    "pourrira": [
        "pourrir"
    ],
    "pourrirai": [
        "pourrir"
    ],
    "pourrirait": [
        "pourrir"
    ],
    "pourriras": [
        "pourrir"
    ],
    "pourrirent": [
        "pourrir"
    ],
    "pourrirez": [
        "pourrir"
    ],
    "pourririez": [
        "pourrir"
    ],
    "pourrirons": [
        "pourrir"
    ],
    "pourriront": [
        "pourrir"
    ],
    "pourris": [
        "pourri",
        "pourrir"
    ],
    "pourrissaient": [
        "pourrir"
    ],
    "pourrissais": [
        "pourrir"
    ],
    "pourrissait": [
        "pourrir"
    ],
    "pourrissant": [
        "pourrissant",
        "pourrir"
    ],
    "pourrissante": [
        "pourrissant"
    ],
    "pourrissantes": [
        "pourrissant"
    ],
    "pourrissants": [
        "pourrissant"
    ],
    "pourrisse": [
        "pourrir"
    ],
    "pourrissement": [
        "pourrissement"
    ],
    "pourrissent": [
        "pourrir"
    ],
    "pourrisseur": [
        "pourrisseur"
    ],
    "pourrissez": [
        "pourrir"
    ],
    "pourrissoir": [
        "pourrissoir"
    ],
    "pourrissons": [
        "pourrir"
    ],
    "pourrit": [
        "pourrir"
    ],
    "pourriture": [
        "pourriture"
    ],
    "pourritures": [
        "pourriture"
    ],
    "pourrons": [
        "pouvoir"
    ],
    "pourront": [
        "pouvoir"
    ],
    "poursuis": [
        "poursuivre"
    ],
    "poursuit": [
        "poursuivre"
    ],
    "poursuite": [
        "poursuite"
    ],
    "poursuites": [
        "poursuite"
    ],
    "poursuivaient": [
        "poursuivre"
    ],
    "poursuivais": [
        "poursuivre"
    ],
    "poursuivait": [
        "poursuivre"
    ],
    "poursuivant": [
        "poursuivre",
        "poursuivant"
    ],
    "poursuivante": [
        "poursuivant"
    ],
    "poursuivants": [
        "poursuivant"
    ],
    "poursuive": [
        "poursuivre"
    ],
    "poursuivent": [
        "poursuivre"
    ],
    "poursuives": [
        "poursuivre"
    ],
    "poursuiveurs": [
        "poursuiveur"
    ],
    "poursuivez": [
        "poursuivre"
    ],
    "poursuivi": [
        "poursuivre"
    ],
    "poursuivie": [
        "poursuivre"
    ],
    "poursuivies": [
        "poursuivre"
    ],
    "poursuiviez": [
        "poursuivre"
    ],
    "poursuivions": [
        "poursuivre"
    ],
    "poursuivirent": [
        "poursuivre"
    ],
    "poursuivis": [
        "poursuivre"
    ],
    "poursuivit": [
        "poursuivre"
    ],
    "poursuivons": [
        "poursuivre"
    ],
    "poursuivra": [
        "poursuivre"
    ],
    "poursuivrai": [
        "poursuivre"
    ],
    "poursuivraient": [
        "poursuivre"
    ],
    "poursuivrais": [
        "poursuivre"
    ],
    "poursuivrait": [
        "poursuivre"
    ],
    "poursuivras": [
        "poursuivre"
    ],
    "poursuivre": [
        "poursuivre"
    ],
    "poursuivrez": [
        "poursuivre"
    ],
    "poursuivrions": [
        "poursuivre"
    ],
    "poursuivrons": [
        "poursuivre"
    ],
    "poursuivront": [
        "poursuivre"
    ],
    "poursuivimes": [
        "poursuivre"
    ],
    "pourtant": [
        "pourtant"
    ],
    "pourtour": [
        "pourtour"
    ],
    "pourtours": [
        "pourtour"
    ],
    "pourvoi": [
        "pourvoi"
    ],
    "pourvoie": [
        "pourvoir"
    ],
    "pourvoient": [
        "pourvoir"
    ],
    "pourvoir": [
        "pourvoir"
    ],
    "pourvoira": [
        "pourvoir"
    ],
    "pourvoirai": [
        "pourvoir"
    ],
    "pourvoiraient": [
        "pourvoir"
    ],
    "pourvoirait": [
        "pourvoir"
    ],
    "pourvoirons": [
        "pourvoir"
    ],
    "pourvoiront": [
        "pourvoir"
    ],
    "pourvois": [
        "pourvoir",
        "pourvoi"
    ],
    "pourvoit": [
        "pourvoir"
    ],
    "pourvoyaient": [
        "pourvoir"
    ],
    "pourvoyait": [
        "pourvoir"
    ],
    "pourvoyant": [
        "pourvoir"
    ],
    "pourvoyeur": [
        "pourvoyeur"
    ],
    "pourvoyeurs": [
        "pourvoyeur"
    ],
    "pourvoyeuse": [
        "pourvoyeur"
    ],
    "pourvoyons": [
        "pourvoir"
    ],
    "pourvu": [
        "pourvoir"
    ],
    "pourvue": [
        "pourvoir"
    ],
    "pourvues": [
        "pourvoir"
    ],
    "pourvus": [
        "pourvoir"
    ],
    "pourvut": [
        "pourvoir"
    ],
    "poussa": [
        "pousser"
    ],
    "poussah": [
        "poussah"
    ],
    "poussai": [
        "pousser"
    ],
    "poussaient": [
        "pousser"
    ],
    "poussais": [
        "pousser"
    ],
    "poussait": [
        "pousser"
    ],
    "poussant": [
        "pousser"
    ],
    "poussas": [
        "pousser"
    ],
    "pousse": [
        "pousse",
        "pousser"
    ],
    "poussent": [
        "pousser"
    ],
    "pousser": [
        "pousser"
    ],
    "poussera": [
        "pousser"
    ],
    "pousserai": [
        "pousser"
    ],
    "pousseraient": [
        "pousser"
    ],
    "pousserais": [
        "pousser"
    ],
    "pousserait": [
        "pousser"
    ],
    "pousseras": [
        "pousser"
    ],
    "pousserez": [
        "pousser"
    ],
    "pousseriez": [
        "pousser"
    ],
    "pousserions": [
        "pousser"
    ],
    "pousserons": [
        "pousser"
    ],
    "pousseront": [
        "pousser"
    ],
    "pousses": [
        "pousse",
        "pousser"
    ],
    "poussette": [
        "poussette"
    ],
    "poussettes": [
        "poussette"
    ],
    "pousseur": [
        "pousseur"
    ],
    "pousseurs": [
        "pousseur"
    ],
    "poussez": [
        "pousser"
    ],
    "poussier": [
        "poussier"
    ],
    "poussiez": [
        "pousser"
    ],
    "poussif": [
        "poussif"
    ],
    "poussifs": [
        "poussif"
    ],
    "poussin": [
        "poussin"
    ],
    "poussine": [
        "poussine"
    ],
    "poussiniere": [
        "poussiniere"
    ],
    "poussins": [
        "poussin"
    ],
    "poussions": [
        "pousser"
    ],
    "poussive": [
        "poussif"
    ],
    "poussivement": [
        "poussivement"
    ],
    "poussives": [
        "poussif"
    ],
    "poussiere": [
        "poussiere"
    ],
    "poussieres": [
        "poussiere"
    ],
    "poussiereuse": [
        "poussiereux"
    ],
    "poussiereuses": [
        "poussiereux"
    ],
    "poussiereux": [
        "poussiereux"
    ],
    "poussoir": [
        "poussoir"
    ],
    "poussons": [
        "pousser"
    ],
    "poussames": [
        "pousser"
    ],
    "poussat": [
        "pousser"
    ],
    "pousserent": [
        "pousser"
    ],
    "poussee": [
        "poussee",
        "pousser",
        "pousse"
    ],
    "poussees": [
        "poussee",
        "pousser",
        "pousse"
    ],
    "poutargue": [
        "poutargue"
    ],
    "poutine": [
        "poutine"
    ],
    "poutou": [
        "poutou"
    ],
    "poutrages": [
        "poutrage"
    ],
    "poutraison": [
        "poutraison"
    ],
    "poutre": [
        "poutre"
    ],
    "poutrelle": [
        "poutrelle"
    ],
    "poutrelles": [
        "poutrelle"
    ],
    "poutres": [
        "poutre"
    ],
    "pouvaient": [
        "pouvoir"
    ],
    "pouvais": [
        "pouvoir"
    ],
    "pouvait": [
        "pouvoir"
    ],
    "pouvant": [
        "pouvoir"
    ],
    "pouvez": [
        "pouvoir"
    ],
    "pouviez": [
        "pouvoir"
    ],
    "pouvions": [
        "pouvoir"
    ],
    "pouvoir": [
        "pouvoir"
    ],
    "pouvoirs": [
        "pouvoir"
    ],
    "pouvons": [
        "pouvoir"
    ],
    "poux": [
        "pou"
    ],
    "pouzzolane": [
        "pouzzolane"
    ],
    "poeme": [
        "poeme"
    ],
    "poemes": [
        "poeme"
    ],
    "poete": [
        "poete"
    ],
    "poetes": [
        "poete"
    ],
    "poesie": [
        "poesie"
    ],
    "poesies": [
        "poesie"
    ],
    "poetesse": [
        "poete"
    ],
    "poetesses": [
        "poete"
    ],
    "poeticien": [
        "poeticien"
    ],
    "poetique": [
        "poetique"
    ],
    "poetiquement": [
        "poetiquement"
    ],
    "poetiques": [
        "poetique"
    ],
    "poetisait": [
        "poetiser"
    ],
    "poetisant": [
        "poetiser"
    ],
    "poetise": [
        "poetiser"
    ],
    "poetiser": [
        "poetiser"
    ],
    "poetisez": [
        "poetiser"
    ],
    "poele": [
        "poele",
        "poeler"
    ],
    "poeles": [
        "poele"
    ],
    "poelon": [
        "poelon"
    ],
    "poelees": [
        "poeler"
    ],
    "practice": [
        "practice"
    ],
    "pradelle": [
        "pradel",
        "pradelle"
    ],
    "praesidium": [
        "praesidium"
    ],
    "pragmatique": [
        "pragmatique"
    ],
    "pragmatiquement": [
        "pragmatiquement"
    ],
    "pragmatiques": [
        "pragmatique"
    ],
    "pragmatisme": [
        "pragmatisme"
    ],
    "pragmatiste": [
        "pragmatiste"
    ],
    "praire": [
        "praire"
    ],
    "praires": [
        "praire"
    ],
    "prairial": [
        "prairial"
    ],
    "prairie": [
        "prairie"
    ],
    "prairies": [
        "prairie"
    ],
    "praline": [
        "praline"
    ],
    "pralines": [
        "praliner",
        "praline"
    ],
    "prang": [
        "prang"
    ],
    "praticable": [
        "praticable"
    ],
    "praticables": [
        "praticable"
    ],
    "praticien": [
        "praticien"
    ],
    "praticienne": [
        "praticien"
    ],
    "praticiens": [
        "praticien"
    ],
    "pratiqua": [
        "pratiquer"
    ],
    "pratiquai": [
        "pratiquer"
    ],
    "pratiquaient": [
        "pratiquer"
    ],
    "pratiquais": [
        "pratiquer"
    ],
    "pratiquait": [
        "pratiquer"
    ],
    "pratiquant": [
        "pratiquant",
        "pratiquer"
    ],
    "pratiquante": [
        "pratiquant"
    ],
    "pratiquants": [
        "pratiquant"
    ],
    "pratique": [
        "pratique",
        "pratiquer"
    ],
    "pratiquement": [
        "pratiquement"
    ],
    "pratiquent": [
        "pratiquer"
    ],
    "pratiquer": [
        "pratiquer"
    ],
    "pratiquera": [
        "pratiquer"
    ],
    "pratiquerai": [
        "pratiquer"
    ],
    "pratiquerais": [
        "pratiquer"
    ],
    "pratiquerait": [
        "pratiquer"
    ],
    "pratiquerons": [
        "pratiquer"
    ],
    "pratiques": [
        "pratique",
        "pratiquer"
    ],
    "pratiquez": [
        "pratiquer"
    ],
    "pratiquiez": [
        "pratiquer"
    ],
    "pratiquions": [
        "pratiquer"
    ],
    "pratiquons": [
        "pratiquer"
    ],
    "pratiquat": [
        "pratiquer"
    ],
    "pratiquerent": [
        "pratiquer"
    ],
    "pratiquee": [
        "pratiquer"
    ],
    "pratiquees": [
        "pratiquer"
    ],
    "praxie": [
        "praxie"
    ],
    "premier": [
        "premier"
    ],
    "premiers": [
        "premier"
    ],
    "premium": [
        "premium"
    ],
    "premiere": [
        "premier"
    ],
    "premierement": [
        "premierement"
    ],
    "premieres": [
        "premier",
        "premiere"
    ],
    "prenable": [
        "prenable"
    ],
    "prenables": [
        "prenable"
    ],
    "prenaient": [
        "prendre"
    ],
    "prenais": [
        "prendre"
    ],
    "prenait": [
        "prendre"
    ],
    "prenant": [
        "prenant",
        "prendre"
    ],
    "prenante": [
        "prenant"
    ],
    "prenantes": [
        "prenant"
    ],
    "prenants": [
        "prenant"
    ],
    "prend": [
        "prendre"
    ],
    "prendra": [
        "prendre"
    ],
    "prendrai": [
        "prendre"
    ],
    "prendraient": [
        "prendre"
    ],
    "prendrais": [
        "prendre"
    ],
    "prendrait": [
        "prendre"
    ],
    "prendras": [
        "prendre"
    ],
    "prendre": [
        "prendre"
    ],
    "prendrez": [
        "prendre"
    ],
    "prendriez": [
        "prendre"
    ],
    "prendrions": [
        "prendre"
    ],
    "prendrons": [
        "prendre"
    ],
    "prendront": [
        "prendre"
    ],
    "prends": [
        "prendre"
    ],
    "preneur": [
        "preneur"
    ],
    "preneurs": [
        "preneur"
    ],
    "preneuse": [
        "preneur"
    ],
    "prenez": [
        "prendre"
    ],
    "preniez": [
        "prendre"
    ],
    "prenions": [
        "prendre"
    ],
    "prenne": [
        "prendre"
    ],
    "prennent": [
        "prendre"
    ],
    "prennes": [
        "prendre"
    ],
    "prenons": [
        "prendre"
    ],
    "presbyte": [
        "presbyte"
    ],
    "presbyterium": [
        "presbyterium"
    ],
    "presbytie": [
        "presbytie"
    ],
    "presbytere": [
        "presbytere"
    ],
    "presbyterien": [
        "presbyterien"
    ],
    "presbyterienne": [
        "presbyterien"
    ],
    "presbyteriennes": [
        "presbyterien"
    ],
    "prescience": [
        "prescience"
    ],
    "presciente": [
        "prescient"
    ],
    "prescription": [
        "prescription"
    ],
    "prescriptions": [
        "prescription"
    ],
    "prescrirait": [
        "prescrire"
    ],
    "prescrire": [
        "prescrire"
    ],
    "prescris": [
        "prescrire"
    ],
    "prescrit": [
        "prescrire"
    ],
    "prescrite": [
        "prescrire"
    ],
    "prescrites": [
        "prescrire"
    ],
    "prescrits": [
        "prescrire"
    ],
    "prescrivaient": [
        "prescrire"
    ],
    "prescrivais": [
        "prescrire"
    ],
    "prescrivait": [
        "prescrire"
    ],
    "prescrivant": [
        "prescrire"
    ],
    "prescrive": [
        "prescrire"
    ],
    "prescrivent": [
        "prescrire"
    ],
    "prescrivez": [
        "prescrire"
    ],
    "prescrivis": [
        "prescrire"
    ],
    "prescrivit": [
        "prescrire"
    ],
    "presqu'ile": [
        "presqu'ile"
    ],
    "presqu'iles": [
        "presqu'ile"
    ],
    "presque": [
        "presque"
    ],
    "pressa": [
        "presser"
    ],
    "pressage": [
        "pressage"
    ],
    "pressai": [
        "presser"
    ],
    "pressaient": [
        "presser"
    ],
    "pressais": [
        "presser"
    ],
    "pressait": [
        "presser"
    ],
    "pressant": [
        "pressant",
        "presser"
    ],
    "pressante": [
        "pressant"
    ],
    "pressantes": [
        "pressant"
    ],
    "pressants": [
        "pressant"
    ],
    "presse": [
        "presser",
        "presse"
    ],
    "pressement": [
        "pressement"
    ],
    "pressements": [
        "pressement"
    ],
    "pressens": [
        "pressentir"
    ],
    "pressent": [
        "presser",
        "pressentir"
    ],
    "pressentaient": [
        "pressentir"
    ],
    "pressentais": [
        "pressentir"
    ],
    "pressentait": [
        "pressentir"
    ],
    "pressentant": [
        "pressentir"
    ],
    "pressentent": [
        "pressentir"
    ],
    "pressentez": [
        "pressentir"
    ],
    "pressenti": [
        "pressentir",
        "pressenti"
    ],
    "pressentie": [
        "pressentir",
        "pressenti"
    ],
    "pressenties": [
        "pressenti"
    ],
    "pressentiez": [
        "pressentir"
    ],
    "pressentiment": [
        "pressentiment"
    ],
    "pressentiments": [
        "pressentiment"
    ],
    "pressentions": [
        "pressentir"
    ],
    "pressentir": [
        "pressentir"
    ],
    "pressentirez": [
        "pressentir"
    ],
    "pressentis": [
        "pressentir",
        "pressenti"
    ],
    "pressentit": [
        "pressentir"
    ],
    "pressentons": [
        "pressentir"
    ],
    "pressentimes": [
        "pressentir"
    ],
    "presser": [
        "presser"
    ],
    "pressera": [
        "presser"
    ],
    "presserai": [
        "presser"
    ],
    "presseraient": [
        "presser"
    ],
    "presserait": [
        "presser"
    ],
    "presseront": [
        "presser"
    ],
    "presses": [
        "press",
        "presser",
        "presse"
    ],
    "presseur": [
        "presseur"
    ],
    "pressez": [
        "presser"
    ],
    "pressiez": [
        "presser"
    ],
    "pressing": [
        "press",
        "pressing"
    ],
    "pressings": [
        "pressing"
    ],
    "pression": [
        "pression"
    ],
    "pressionnee": [
        "pressionne"
    ],
    "pressions": [
        "presser",
        "pression"
    ],
    "pressoir": [
        "pressoir"
    ],
    "pressoirs": [
        "pressoir"
    ],
    "pressons": [
        "presser"
    ],
    "pressurant": [
        "pressurer"
    ],
    "pressure": [
        "pressurer"
    ],
    "pressurer": [
        "pressurer"
    ],
    "pressures": [
        "pressure",
        "pressurer"
    ],
    "pressurisation": [
        "pressurisation"
    ],
    "pressuriser": [
        "pressuriser"
    ],
    "pressurisez": [
        "pressuriser"
    ],
    "pressurise": [
        "pressurise",
        "pressuriser"
    ],
    "pressurisee": [
        "pressurise",
        "pressuriser"
    ],
    "pressurisees": [
        "pressuriser"
    ],
    "pressurises": [
        "pressurise",
        "pressuriser"
    ],
    "pressuree": [
        "pressurer"
    ],
    "pressat": [
        "presser"
    ],
    "presserent": [
        "presser"
    ],
    "pressee": [
        "presse"
    ],
    "pressees": [
        "presse"
    ],
    "prestance": [
        "prestance"
    ],
    "prestataire": [
        "prestataire"
    ],
    "prestataires": [
        "prestataire"
    ],
    "prestation": [
        "prestation"
    ],
    "prestations": [
        "prestation"
    ],
    "preste": [
        "preste"
    ],
    "prestement": [
        "prestement"
    ],
    "prestes": [
        "preste"
    ],
    "prestesse": [
        "prestesse"
    ],
    "prestidigitateur": [
        "prestidigitateur"
    ],
    "prestidigitateurs": [
        "prestidigitateur"
    ],
    "prestidigitation": [
        "prestidigitation"
    ],
    "prestidigitations": [
        "prestidigitation"
    ],
    "prestidigitatrice": [
        "prestidigitateur"
    ],
    "prestige": [
        "prestige"
    ],
    "prestiges": [
        "prestige"
    ],
    "prestigieuse": [
        "prestigieux"
    ],
    "prestigieuses": [
        "prestigieux"
    ],
    "prestigieux": [
        "prestigieux"
    ],
    "presto": [
        "presto"
    ],
    "preuve": [
        "preuve"
    ],
    "preuves": [
        "preuve"
    ],
    "preux": [
        "preux"
    ],
    "pria": [
        "prier"
    ],
    "priai": [
        "prier"
    ],
    "priaient": [
        "prier"
    ],
    "priais": [
        "prier"
    ],
    "priait": [
        "prier"
    ],
    "priant": [
        "prier",
        "priant"
    ],
    "priapique": [
        "priapique"
    ],
    "priapiques": [
        "priapique"
    ],
    "priapisme": [
        "priapisme"
    ],
    "priasse": [
        "prier"
    ],
    "prie": [
        "prier"
    ],
    "prient": [
        "prier"
    ],
    "prier": [
        "prier"
    ],
    "priera": [
        "prier"
    ],
    "prierai": [
        "prier"
    ],
    "prieraient": [
        "prier"
    ],
    "prierais": [
        "prier"
    ],
    "prierait": [
        "prier"
    ],
    "prieras": [
        "prier"
    ],
    "prierez": [
        "prier"
    ],
    "prierons": [
        "prier"
    ],
    "prieront": [
        "prier"
    ],
    "pries": [
        "prier",
        "pry"
    ],
    "prieur": [
        "prieur"
    ],
    "prieure": [
        "prieur",
        "prieure"
    ],
    "prieurs": [
        "prieur"
    ],
    "prieures": [
        "prieure"
    ],
    "priez": [
        "prier"
    ],
    "priions": [
        "prier"
    ],
    "prima": [
        "primer"
    ],
    "primaire": [
        "primaire"
    ],
    "primaires": [
        "primaire"
    ],
    "primait": [
        "primer"
    ],
    "primal": [
        "primal"
    ],
    "primale": [
        "primal"
    ],
    "primant": [
        "primer"
    ],
    "primat": [
        "primat"
    ],
    "primate": [
        "primate"
    ],
    "primates": [
        "primate"
    ],
    "primatologue": [
        "primatologue"
    ],
    "primaute": [
        "primaute"
    ],
    "prime": [
        "primer",
        "prime"
    ],
    "priment": [
        "primer"
    ],
    "primer": [
        "primer"
    ],
    "primerait": [
        "primer"
    ],
    "primerose": [
        "primerose"
    ],
    "primes": [
        "prime",
        "prendre"
    ],
    "primesautier": [
        "primesautier"
    ],
    "primesautiers": [
        "primesautier"
    ],
    "primesautiere": [
        "primesautier"
    ],
    "primeur": [
        "primeur"
    ],
    "primeurs": [
        "primeur"
    ],
    "primevere": [
        "primevere"
    ],
    "primeveres": [
        "primevere"
    ],
    "primidi": [
        "primidi"
    ],
    "primitif": [
        "primitif"
    ],
    "primitifs": [
        "primitif"
    ],
    "primitive": [
        "primitif"
    ],
    "primitivement": [
        "primitivement"
    ],
    "primitives": [
        "primitif",
        "primitive"
    ],
    "primitivisme": [
        "primitivisme"
    ],
    "primo": [
        "primo"
    ],
    "primordial": [
        "primordial"
    ],
    "primordiale": [
        "primordial"
    ],
    "primordialement": [
        "primordialement"
    ],
    "primordiales": [
        "primordial"
    ],
    "primordiaux": [
        "primordial"
    ],
    "primee": [
        "primer",
        "prime"
    ],
    "primees": [
        "primer",
        "prime"
    ],
    "prin": [
        "prin"
    ],
    "prince": [
        "prince"
    ],
    "princeps": [
        "princeps"
    ],
    "princes": [
        "prince"
    ],
    "princesse": [
        "prince"
    ],
    "princesses": [
        "prince",
        "princess"
    ],
    "princier": [
        "princier"
    ],
    "princiers": [
        "princier"
    ],
    "principal": [
        "principal"
    ],
    "principale": [
        "principal"
    ],
    "principalement": [
        "principalement"
    ],
    "principales": [
        "principal"
    ],
    "principat": [
        "principat"
    ],
    "principaute": [
        "principaute"
    ],
    "principautes": [
        "principaute"
    ],
    "principaux": [
        "principal"
    ],
    "principe": [
        "principe"
    ],
    "principes": [
        "principe"
    ],
    "princiere": [
        "princier"
    ],
    "princierement": [
        "princierement"
    ],
    "princieres": [
        "princier"
    ],
    "printanier": [
        "printanier"
    ],
    "printaniers": [
        "printanier"
    ],
    "printaniere": [
        "printanier"
    ],
    "printanieres": [
        "printanier"
    ],
    "printemps": [
        "printemps"
    ],
    "prion": [
        "prion"
    ],
    "prions": [
        "prion",
        "prier"
    ],
    "prioritaire": [
        "prioritaire"
    ],
    "prioritaires": [
        "prioritaire"
    ],
    "priorite": [
        "priorite"
    ],
    "priorites": [
        "priorite"
    ],
    "prirent": [
        "prendre"
    ],
    "pris": [
        "pris",
        "prendre"
    ],
    "prisa": [
        "priser"
    ],
    "prisaient": [
        "priser"
    ],
    "prisait": [
        "priser"
    ],
    "prisant": [
        "priser"
    ],
    "prise": [
        "prise",
        "priser",
        "pris",
        "prendre"
    ],
    "prisent": [
        "priser"
    ],
    "priser": [
        "priser"
    ],
    "prises": [
        "prise",
        "priser",
        "pris",
        "prendre"
    ],
    "priseur": [
        "priseur"
    ],
    "priseurs": [
        "priseur"
    ],
    "prisez": [
        "priser"
    ],
    "prismatique": [
        "prismatique"
    ],
    "prismatiques": [
        "prismatique"
    ],
    "prisme": [
        "prisme"
    ],
    "prismes": [
        "prisme"
    ],
    "prison": [
        "prison"
    ],
    "prisonnier": [
        "prisonnier"
    ],
    "prisonniers": [
        "prisonnier"
    ],
    "prisonniere": [
        "prisonnier"
    ],
    "prisonnieres": [
        "prisonnier"
    ],
    "prisons": [
        "prison",
        "priser"
    ],
    "prisse": [
        "prendre"
    ],
    "prissent": [
        "prendre"
    ],
    "prissions": [
        "prendre"
    ],
    "pristi": [
        "pristi"
    ],
    "prisunic": [
        "prisunic"
    ],
    "prisee": [
        "priser"
    ],
    "prisees": [
        "prisee",
        "priser"
    ],
    "prit": [
        "prendre"
    ],
    "priva": [
        "priver"
    ],
    "privai": [
        "priver"
    ],
    "privaient": [
        "priver"
    ],
    "privais": [
        "priver"
    ],
    "privait": [
        "priver"
    ],
    "privant": [
        "priver"
    ],
    "privasse": [
        "priver"
    ],
    "privatif": [
        "privatif"
    ],
    "privatifs": [
        "privatif"
    ],
    "privation": [
        "privation"
    ],
    "privations": [
        "privation"
    ],
    "privatisation": [
        "privatisation"
    ],
    "privatiser": [
        "privatiser"
    ],
    "privatise": [
        "privatiser"
    ],
    "privatisee": [
        "privatiser"
    ],
    "privatises": [
        "privatiser"
    ],
    "privative": [
        "privatif"
    ],
    "privatives": [
        "privatif"
    ],
    "privaute": [
        "privaute"
    ],
    "privautes": [
        "privaute"
    ],
    "prive": [
        "priver",
        "prive"
    ],
    "privent": [
        "priver"
    ],
    "priver": [
        "priver"
    ],
    "privera": [
        "priver"
    ],
    "priverai": [
        "priver"
    ],
    "priveraient": [
        "priver"
    ],
    "priverais": [
        "priver"
    ],
    "priverait": [
        "priver"
    ],
    "priveras": [
        "priver"
    ],
    "priveriez": [
        "priver"
    ],
    "prives": [
        "priver",
        "prive"
    ],
    "privez": [
        "priver"
    ],
    "priviez": [
        "priver"
    ],
    "privilege": [
        "privilege"
    ],
    "privileges": [
        "privilege"
    ],
    "privilegiait": [
        "privilegier"
    ],
    "privilegiant": [
        "privilegier"
    ],
    "privilegie": [
        "privilegie",
        "privilegier"
    ],
    "privilegient": [
        "privilegier"
    ],
    "privilegier": [
        "privilegier"
    ],
    "privilegions": [
        "privilegier"
    ],
    "privilegiee": [
        "privilegie",
        "privilegier"
    ],
    "privilegiees": [
        "privilegie",
        "privilegier"
    ],
    "privilegies": [
        "privilegie",
        "privilegier"
    ],
    "privions": [
        "priver"
    ],
    "privons": [
        "priver"
    ],
    "privat": [
        "priver"
    ],
    "priverent": [
        "priver"
    ],
    "privee": [
        "priver",
        "prive"
    ],
    "privees": [
        "priver",
        "prive"
    ],
    "privement": [
        "privement"
    ],
    "prix": [
        "prix"
    ],
    "priames": [
        "prier"
    ],
    "priat": [
        "prier"
    ],
    "priere": [
        "priere"
    ],
    "prierent": [
        "prier"
    ],
    "prieres": [
        "priere"
    ],
    "priee": [
        "prier"
    ],
    "priees": [
        "prier"
    ],
    "pro": [
        "pro"
    ],
    "proactif": [
        "proactif"
    ],
    "probabilite": [
        "probabilite"
    ],
    "probabilites": [
        "probabilite"
    ],
    "probable": [
        "probable"
    ],
    "probablement": [
        "probablement"
    ],
    "probables": [
        "probable"
    ],
    "probant": [
        "probant"
    ],
    "probante": [
        "probant"
    ],
    "probantes": [
        "probant"
    ],
    "probants": [
        "probant"
    ],
    "probation": [
        "probation"
    ],
    "probatoire": [
        "probatoire"
    ],
    "probe": [
        "probe"
    ],
    "probes": [
        "probe"
    ],
    "probite": [
        "probite"
    ],
    "probloc": [
        "probloc"
    ],
    "problocs": [
        "probloc"
    ],
    "probloque": [
        "probloque"
    ],
    "probloques": [
        "probloque"
    ],
    "probleme": [
        "probleme"
    ],
    "problemes": [
        "probleme"
    ],
    "problematique": [
        "problematique"
    ],
    "problematiques": [
        "problematique"
    ],
    "proc": [
        "proc"
    ],
    "procalmadiol": [
        "procalmadiol"
    ],
    "procaine": [
        "procaine"
    ],
    "process": [
        "process"
    ],
    "processeur": [
        "processeur"
    ],
    "processeurs": [
        "processeur"
    ],
    "procession": [
        "procession"
    ],
    "processionnaient": [
        "processionner"
    ],
    "processionnaire": [
        "processionnaire"
    ],
    "processionnaires": [
        "processionnaire"
    ],
    "processionnant": [
        "processionner"
    ],
    "processionnelle": [
        "processionnel"
    ],
    "processionnelles": [
        "processionnel"
    ],
    "processions": [
        "procession"
    ],
    "processus": [
        "processus"
    ],
    "prochain": [
        "prochain"
    ],
    "prochaine": [
        "prochain"
    ],
    "prochainement": [
        "prochainement"
    ],
    "prochaines": [
        "prochain"
    ],
    "prochains": [
        "prochain"
    ],
    "proche": [
        "proche"
    ],
    "proches": [
        "proche"
    ],
    "prochinois": [
        "prochinois"
    ],
    "prochinoise": [
        "prochinois"
    ],
    "proclama": [
        "proclamer"
    ],
    "proclamai": [
        "proclamer"
    ],
    "proclamaient": [
        "proclamer"
    ],
    "proclamais": [
        "proclamer"
    ],
    "proclamait": [
        "proclamer"
    ],
    "proclamant": [
        "proclamer"
    ],
    "proclamation": [
        "proclamation"
    ],
    "proclamations": [
        "proclamation"
    ],
    "proclamatrices": [
        "proclamateur"
    ],
    "proclame": [
        "proclamer"
    ],
    "proclament": [
        "proclamer"
    ],
    "proclamer": [
        "proclamer"
    ],
    "proclamera": [
        "proclamer"
    ],
    "proclamerai": [
        "proclamer"
    ],
    "proclameraient": [
        "proclamer"
    ],
    "proclamerait": [
        "proclamer"
    ],
    "proclamerons": [
        "proclamer"
    ],
    "proclamez": [
        "proclamer"
    ],
    "proclamiez": [
        "proclamer"
    ],
    "proclamions": [
        "proclamer"
    ],
    "proclamons": [
        "proclamer"
    ],
    "proclamat": [
        "proclamer"
    ],
    "proclamerent": [
        "proclamer"
    ],
    "proclamee": [
        "proclamer"
    ],
    "proclamees": [
        "proclamer"
    ],
    "proclames": [
        "proclamer"
    ],
    "procommuniste": [
        "procommuniste"
    ],
    "proconsul": [
        "proconsul"
    ],
    "proconsuls": [
        "proconsul"
    ],
    "procrastination": [
        "procrastination"
    ],
    "procrea": [
        "procreer"
    ],
    "procreant": [
        "procreer"
    ],
    "procreateur": [
        "procreateur"
    ],
    "procreateurs": [
        "procreateur"
    ],
    "procreation": [
        "procreation"
    ],
    "procreations": [
        "procreation"
    ],
    "procreative": [
        "procreatif"
    ],
    "procreatrice": [
        "procreateur"
    ],
    "procreatrices": [
        "procreateur"
    ],
    "procree": [
        "procreer"
    ],
    "procreent": [
        "procreer"
    ],
    "procreer": [
        "procreer"
    ],
    "procreerons": [
        "procreer"
    ],
    "procs": [
        "proc"
    ],
    "proctologie": [
        "proctologie"
    ],
    "proctologue": [
        "proctologue"
    ],
    "proctologues": [
        "proctologue"
    ],
    "procura": [
        "procurer"
    ],
    "procurai": [
        "procurer"
    ],
    "procuraient": [
        "procurer"
    ],
    "procurais": [
        "procurer"
    ],
    "procurait": [
        "procurer"
    ],
    "procurant": [
        "procurer"
    ],
    "procurateur": [
        "procurateur"
    ],
    "procurateurs": [
        "procurateur"
    ],
    "procuraties": [
        "procuratie"
    ],
    "procuration": [
        "procuration"
    ],
    "procuratrice": [
        "procurateur"
    ],
    "procure": [
        "procure",
        "procurer"
    ],
    "procurent": [
        "procurer"
    ],
    "procurer": [
        "procurer"
    ],
    "procurera": [
        "procurer"
    ],
    "procurerai": [
        "procurer"
    ],
    "procureraient": [
        "procurer"
    ],
    "procurerais": [
        "procurer"
    ],
    "procurerait": [
        "procurer"
    ],
    "procureras": [
        "procurer"
    ],
    "procureriez": [
        "procurer"
    ],
    "procurerons": [
        "procurer"
    ],
    "procureront": [
        "procurer"
    ],
    "procures": [
        "procure",
        "procurer"
    ],
    "procureur": [
        "procureur"
    ],
    "procureurs": [
        "procureur"
    ],
    "procureuse": [
        "procureur"
    ],
    "procureuses": [
        "procureur"
    ],
    "procurez": [
        "procurer"
    ],
    "procuriez": [
        "procurer"
    ],
    "procurions": [
        "procurer"
    ],
    "procurat": [
        "procurer"
    ],
    "procurerent": [
        "procurer"
    ],
    "procuree": [
        "procurer"
    ],
    "procurees": [
        "procurer"
    ],
    "procede": [
        "proceder",
        "procede"
    ],
    "procedent": [
        "proceder"
    ],
    "proces": [
        "proces"
    ],
    "proceda": [
        "proceder"
    ],
    "procedaient": [
        "proceder"
    ],
    "procedais": [
        "proceder"
    ],
    "procedait": [
        "proceder"
    ],
    "procedant": [
        "proceder"
    ],
    "proceder": [
        "proceder"
    ],
    "procedera": [
        "proceder"
    ],
    "procederaient": [
        "proceder"
    ],
    "procederais": [
        "proceder"
    ],
    "procederait": [
        "proceder"
    ],
    "procederez": [
        "proceder"
    ],
    "procederiez": [
        "proceder"
    ],
    "procederons": [
        "proceder"
    ],
    "procederont": [
        "proceder"
    ],
    "procedez": [
        "proceder"
    ],
    "procediez": [
        "proceder"
    ],
    "procedions": [
        "proceder"
    ],
    "procedons": [
        "proceder"
    ],
    "procedural": [
        "procedural"
    ],
    "procedurale": [
        "procedural"
    ],
    "procedure": [
        "procedure"
    ],
    "procedures": [
        "procedure"
    ],
    "procedurier": [
        "procedurier"
    ],
    "proceduriere": [
        "procedurier"
    ],
    "procedurieres": [
        "procedurier"
    ],
    "procedames": [
        "proceder"
    ],
    "procedat": [
        "proceder"
    ],
    "procedes": [
        "proceder",
        "procede"
    ],
    "prodigalite": [
        "prodigalite"
    ],
    "prodigalites": [
        "prodigalite"
    ],
    "prodige": [
        "prodige"
    ],
    "prodiges": [
        "prodige"
    ],
    "prodigieuse": [
        "prodigieux"
    ],
    "prodigieusement": [
        "prodigieusement"
    ],
    "prodigieuses": [
        "prodigieux"
    ],
    "prodigieux": [
        "prodigieux"
    ],
    "prodigua": [
        "prodiguer"
    ],
    "prodiguaient": [
        "prodiguer"
    ],
    "prodiguais": [
        "prodiguer"
    ],
    "prodiguait": [
        "prodiguer"
    ],
    "prodiguant": [
        "prodiguer"
    ],
    "prodigue": [
        "prodigue",
        "prodiguer"
    ],
    "prodiguent": [
        "prodiguer"
    ],
    "prodiguer": [
        "prodiguer"
    ],
    "prodiguera": [
        "prodiguer"
    ],
    "prodiguerais": [
        "prodiguer"
    ],
    "prodigueras": [
        "prodiguer"
    ],
    "prodigueront": [
        "prodiguer"
    ],
    "prodigues": [
        "prodigue",
        "prodiguer"
    ],
    "prodiguions": [
        "prodiguer"
    ],
    "prodiguerent": [
        "prodiguer"
    ],
    "prodiguee": [
        "prodiguer"
    ],
    "prodiguees": [
        "prodiguer"
    ],
    "prodrome": [
        "prodrome"
    ],
    "prodromes": [
        "prodrome"
    ],
    "producteur": [
        "producteur"
    ],
    "producteurs": [
        "producteur"
    ],
    "productif": [
        "productif"
    ],
    "productifs": [
        "productif"
    ],
    "production": [
        "production"
    ],
    "productions": [
        "production"
    ],
    "productive": [
        "productif"
    ],
    "productives": [
        "productif"
    ],
    "productivite": [
        "productivite"
    ],
    "productrice": [
        "producteur"
    ],
    "productrices": [
        "producteur"
    ],
    "produira": [
        "produire"
    ],
    "produiraient": [
        "produire"
    ],
    "produirais": [
        "produire"
    ],
    "produirait": [
        "produire"
    ],
    "produiras": [
        "produire"
    ],
    "produire": [
        "produire"
    ],
    "produirez": [
        "produire"
    ],
    "produiriez": [
        "produire"
    ],
    "produirons": [
        "produire"
    ],
    "produiront": [
        "produire"
    ],
    "produis": [
        "produire"
    ],
    "produisaient": [
        "produire"
    ],
    "produisais": [
        "produire"
    ],
    "produisait": [
        "produire"
    ],
    "produisant": [
        "produire"
    ],
    "produise": [
        "produire"
    ],
    "produisent": [
        "produire"
    ],
    "produises": [
        "produire"
    ],
    "produisez": [
        "produire"
    ],
    "produisions": [
        "produire"
    ],
    "produisirent": [
        "produire"
    ],
    "produisis": [
        "produire"
    ],
    "produisit": [
        "produire"
    ],
    "produisons": [
        "produire"
    ],
    "produit": [
        "produire",
        "produit"
    ],
    "produite": [
        "produire",
        "produit"
    ],
    "produites": [
        "produire",
        "produit"
    ],
    "produits": [
        "produire",
        "produit"
    ],
    "prof": [
        "prof"
    ],
    "profana": [
        "profaner"
    ],
    "profanaient": [
        "profaner"
    ],
    "profanait": [
        "profaner"
    ],
    "profanant": [
        "profaner"
    ],
    "profanateur": [
        "profanateur"
    ],
    "profanateurs": [
        "profanateur"
    ],
    "profanation": [
        "profanation"
    ],
    "profanations": [
        "profanation"
    ],
    "profanatoire": [
        "profanatoire"
    ],
    "profane": [
        "profaner",
        "profane"
    ],
    "profanent": [
        "profaner"
    ],
    "profaner": [
        "profaner"
    ],
    "profanera": [
        "profaner"
    ],
    "profanes": [
        "profaner",
        "profane"
    ],
    "profanez": [
        "profaner"
    ],
    "profanerent": [
        "profaner"
    ],
    "profanee": [
        "profaner"
    ],
    "profanees": [
        "profaner"
    ],
    "professa": [
        "professer"
    ],
    "professaient": [
        "professer"
    ],
    "professait": [
        "professer"
    ],
    "professant": [
        "professer"
    ],
    "professe": [
        "professe",
        "professer"
    ],
    "professent": [
        "professer"
    ],
    "professer": [
        "professer"
    ],
    "professeur": [
        "professeur"
    ],
    "professeure": [
        "professeur"
    ],
    "professeurs": [
        "professeur"
    ],
    "professiez": [
        "professer"
    ],
    "profession": [
        "profession"
    ],
    "professionnalisme": [
        "professionnalisme"
    ],
    "professionnel": [
        "professionnel"
    ],
    "professionnelle": [
        "professionnel"
    ],
    "professionnellement": [
        "professionnellement"
    ],
    "professionnelles": [
        "professionnel"
    ],
    "professionnels": [
        "professionnel"
    ],
    "professions": [
        "profession",
        "professer"
    ],
    "professons": [
        "professer"
    ],
    "professoral": [
        "professoral"
    ],
    "professorat": [
        "professorat"
    ],
    "professees": [
        "professer"
    ],
    "profil": [
        "profil"
    ],
    "profila": [
        "profiler"
    ],
    "profilage": [
        "profilage"
    ],
    "profilaient": [
        "profiler"
    ],
    "profilait": [
        "profiler"
    ],
    "profilant": [
        "profiler"
    ],
    "profile": [
        "profiler",
        "profile"
    ],
    "profilent": [
        "profiler"
    ],
    "profiler": [
        "profiler"
    ],
    "profileur": [
        "profileur"
    ],
    "profileuse": [
        "profileur"
    ],
    "profils": [
        "profil"
    ],
    "profilerent": [
        "profiler"
    ],
    "profilee": [
        "profiler"
    ],
    "profilees": [
        "profiler"
    ],
    "profiles": [
        "profiler",
        "profile"
    ],
    "profit": [
        "profit"
    ],
    "profita": [
        "profiter"
    ],
    "profitabilite": [
        "profitabilite"
    ],
    "profitable": [
        "profitable"
    ],
    "profitables": [
        "profitable"
    ],
    "profitai": [
        "profiter"
    ],
    "profitaient": [
        "profiter"
    ],
    "profitais": [
        "profiter"
    ],
    "profitait": [
        "profiter"
    ],
    "profitant": [
        "profitant",
        "profiter"
    ],
    "profite": [
        "profiter"
    ],
    "profitent": [
        "profiter"
    ],
    "profiter": [
        "profiter"
    ],
    "profitera": [
        "profiter"
    ],
    "profiterai": [
        "profiter"
    ],
    "profiteraient": [
        "profiter"
    ],
    "profiterais": [
        "profiter"
    ],
    "profiterait": [
        "profiter"
    ],
    "profiteras": [
        "profiter"
    ],
    "profiterez": [
        "profiter"
    ],
    "profiteriez": [
        "profiter"
    ],
    "profiterole": [
        "profiterole"
    ],
    "profiteroles": [
        "profiterole"
    ],
    "profiterons": [
        "profiter"
    ],
    "profiteront": [
        "profiter"
    ],
    "profites": [
        "profiter"
    ],
    "profiteur": [
        "profiteur"
    ],
    "profiteurs": [
        "profiteur"
    ],
    "profiteuse": [
        "profiteur"
    ],
    "profitez": [
        "profiter"
    ],
    "profitiez": [
        "profiter"
    ],
    "profitions": [
        "profiter"
    ],
    "profitons": [
        "profiter"
    ],
    "profits": [
        "profit"
    ],
    "profitames": [
        "profiter"
    ],
    "profitat": [
        "profiter"
    ],
    "profiterent": [
        "profiter"
    ],
    "profitee": [
        "profiter"
    ],
    "profond": [
        "profond"
    ],
    "profonde": [
        "profond"
    ],
    "profondes": [
        "profond"
    ],
    "profondeur": [
        "profondeur"
    ],
    "profondeurs": [
        "profondeur"
    ],
    "profonds": [
        "profond"
    ],
    "profondement": [
        "profondement"
    ],
    "profs": [
        "prof"
    ],
    "profus": [
        "profus"
    ],
    "profuse": [
        "profus"
    ],
    "profuses": [
        "profus"
    ],
    "profusion": [
        "profusion"
    ],
    "profusions": [
        "profusion"
    ],
    "profere": [
        "proferer"
    ],
    "proferent": [
        "proferer"
    ],
    "profera": [
        "proferer"
    ],
    "proferaient": [
        "proferer"
    ],
    "proferait": [
        "proferer"
    ],
    "proferant": [
        "proferer"
    ],
    "proferations": [
        "proferation"
    ],
    "proferer": [
        "proferer"
    ],
    "profereraient": [
        "proferer"
    ],
    "proferez": [
        "proferer"
    ],
    "proferions": [
        "proferer"
    ],
    "proferat": [
        "proferer"
    ],
    "proferee": [
        "proferer"
    ],
    "proferees": [
        "proferer"
    ],
    "proferes": [
        "proferer"
    ],
    "progesterone": [
        "progesterone"
    ],
    "prognathe": [
        "prognathe"
    ],
    "prognathisme": [
        "prognathisme"
    ],
    "programma": [
        "programmer"
    ],
    "programmable": [
        "programmable"
    ],
    "programmables": [
        "programmable"
    ],
    "programmaient": [
        "programmer"
    ],
    "programmait": [
        "programmer"
    ],
    "programmateur": [
        "programmateur"
    ],
    "programmateurs": [
        "programmateur"
    ],
    "programmation": [
        "programmation"
    ],
    "programmatrice": [
        "programmateur"
    ],
    "programme": [
        "programmer",
        "programme"
    ],
    "programment": [
        "programmer"
    ],
    "programmer": [
        "programmer"
    ],
    "programmerai": [
        "programmer"
    ],
    "programmes": [
        "programmer",
        "programme"
    ],
    "programmeur": [
        "programmeur"
    ],
    "programmeurs": [
        "programmeur"
    ],
    "programmeuse": [
        "programmeur"
    ],
    "programmez": [
        "programmer"
    ],
    "programmons": [
        "programmer"
    ],
    "programmee": [
        "programmer",
        "programme"
    ],
    "programmees": [
        "programmer",
        "programme"
    ],
    "progressa": [
        "progresser"
    ],
    "progressai": [
        "progresser"
    ],
    "progressaient": [
        "progresser"
    ],
    "progressais": [
        "progresser"
    ],
    "progressait": [
        "progresser"
    ],
    "progressant": [
        "progresser"
    ],
    "progresse": [
        "progresser"
    ],
    "progressent": [
        "progresser"
    ],
    "progresser": [
        "progresser"
    ],
    "progressera": [
        "progresser"
    ],
    "progresseraient": [
        "progresser"
    ],
    "progresserais": [
        "progresser"
    ],
    "progresserait": [
        "progresser"
    ],
    "progresserez": [
        "progresser"
    ],
    "progresserons": [
        "progresser"
    ],
    "progresseront": [
        "progresser"
    ],
    "progresses": [
        "progresser",
        "progress"
    ],
    "progressez": [
        "progresser"
    ],
    "progressif": [
        "progressif"
    ],
    "progression": [
        "progression"
    ],
    "progressions": [
        "progresser",
        "progression"
    ],
    "progressisme": [
        "progressisme"
    ],
    "progressiste": [
        "progressiste"
    ],
    "progressistes": [
        "progressiste"
    ],
    "progressive": [
        "progressif"
    ],
    "progressivement": [
        "progressivement"
    ],
    "progressives": [
        "progressive",
        "progressif"
    ],
    "progressons": [
        "progresser"
    ],
    "progresserent": [
        "progresser"
    ],
    "progressee": [
        "progresser"
    ],
    "progres": [
        "progres"
    ],
    "progeniteur": [
        "progeniteur"
    ],
    "progeniture": [
        "progeniture"
    ],
    "progenitures": [
        "progeniture"
    ],
    "prohibait": [
        "prohiber"
    ],
    "prohibe": [
        "prohiber",
        "prohibe"
    ],
    "prohibent": [
        "prohiber"
    ],
    "prohibition": [
        "prohibition"
    ],
    "prohibitive": [
        "prohibitif"
    ],
    "prohibee": [
        "prohiber",
        "prohibe"
    ],
    "prohibees": [
        "prohiber",
        "prohibe"
    ],
    "prohibes": [
        "prohiber",
        "prohibe"
    ],
    "proie": [
        "proie"
    ],
    "proies": [
        "proie"
    ],
    "projecteur": [
        "projecteur"
    ],
    "projecteurs": [
        "projecteur"
    ],
    "projectif": [
        "projectif"
    ],
    "projectile": [
        "projectile"
    ],
    "projectiles": [
        "projectile"
    ],
    "projection": [
        "projection"
    ],
    "projectionniste": [
        "projectionniste"
    ],
    "projectionnistes": [
        "projectionniste"
    ],
    "projections": [
        "projection"
    ],
    "projet": [
        "projet"
    ],
    "projeta": [
        "projeter"
    ],
    "projetai": [
        "projeter"
    ],
    "projetaient": [
        "projeter"
    ],
    "projetais": [
        "projeter"
    ],
    "projetait": [
        "projeter"
    ],
    "projetant": [
        "projeter"
    ],
    "projeter": [
        "projeter"
    ],
    "projetez": [
        "projeter"
    ],
    "projetiez": [
        "projeter"
    ],
    "projetions": [
        "projeter"
    ],
    "projetons": [
        "projeter"
    ],
    "projets": [
        "projet"
    ],
    "projette": [
        "projeter"
    ],
    "projettent": [
        "projeter"
    ],
    "projettera": [
        "projeter"
    ],
    "projetterait": [
        "projeter"
    ],
    "projetteriez": [
        "projeter"
    ],
    "projetterons": [
        "projeter"
    ],
    "projettes": [
        "projeter"
    ],
    "projetames": [
        "projeter"
    ],
    "projetat": [
        "projeter"
    ],
    "projeterent": [
        "projeter"
    ],
    "projete": [
        "projeter"
    ],
    "projetee": [
        "projeter"
    ],
    "projetees": [
        "projeter"
    ],
    "projetes": [
        "projeter"
    ],
    "projo": [
        "projo"
    ],
    "projos": [
        "projo"
    ],
    "prolapsus": [
        "prolapsus"
    ],
    "prolifique": [
        "prolifique"
    ],
    "prolifiques": [
        "prolifique"
    ],
    "prolifere": [
        "prolifere",
        "proliferer"
    ],
    "proliferent": [
        "proliferer"
    ],
    "proliferaient": [
        "proliferer"
    ],
    "proliferait": [
        "proliferer"
    ],
    "proliferant": [
        "proliferant",
        "proliferer"
    ],
    "proliferante": [
        "proliferant"
    ],
    "proliferantes": [
        "proliferant"
    ],
    "proliferants": [
        "proliferant"
    ],
    "proliferation": [
        "proliferation"
    ],
    "proliferer": [
        "proliferer"
    ],
    "proliferera": [
        "proliferer"
    ],
    "proline": [
        "proline"
    ],
    "prolixe": [
        "prolixe"
    ],
    "prolixes": [
        "prolixe"
    ],
    "prolixite": [
        "prolixite"
    ],
    "prolo": [
        "prolo"
    ],
    "prologue": [
        "prologue"
    ],
    "prolongateur": [
        "prolongateur"
    ],
    "prolongation": [
        "prolongation"
    ],
    "prolongations": [
        "prolongation"
    ],
    "prolonge": [
        "prolonger",
        "prolonge"
    ],
    "prolongea": [
        "prolonger"
    ],
    "prolongeaient": [
        "prolonger"
    ],
    "prolongeais": [
        "prolonger"
    ],
    "prolongeait": [
        "prolonger"
    ],
    "prolongeant": [
        "prolonger"
    ],
    "prolongement": [
        "prolongement"
    ],
    "prolongements": [
        "prolongement"
    ],
    "prolongent": [
        "prolonger"
    ],
    "prolonger": [
        "prolonger"
    ],
    "prolongera": [
        "prolonger"
    ],
    "prolongeraient": [
        "prolonger"
    ],
    "prolongerait": [
        "prolonger"
    ],
    "prolongerons": [
        "prolonger"
    ],
    "prolonges": [
        "prolonger",
        "prolonge"
    ],
    "prolongez": [
        "prolonger"
    ],
    "prolongeat": [
        "prolonger"
    ],
    "prolongerent": [
        "prolonger"
    ],
    "prolongee": [
        "prolonger",
        "prolonge"
    ],
    "prolongees": [
        "prolonger",
        "prolonge"
    ],
    "prolos": [
        "prolo"
    ],
    "prolegomenes": [
        "prolegomenes"
    ],
    "proletaire": [
        "proletaire"
    ],
    "proletaires": [
        "proletaire"
    ],
    "proletariat": [
        "proletariat"
    ],
    "proletariats": [
        "proletariat"
    ],
    "proletarien": [
        "proletarien"
    ],
    "proletarienne": [
        "proletarien"
    ],
    "proletariennes": [
        "proletarien"
    ],
    "proletariens": [
        "proletarien"
    ],
    "proletarisation": [
        "proletarisation"
    ],
    "proletariser": [
        "proletariser"
    ],
    "promazine": [
        "promazine"
    ],
    "promena": [
        "promener"
    ],
    "promenade": [
        "promenade"
    ],
    "promenades": [
        "promenade"
    ],
    "promenai": [
        "promener"
    ],
    "promenaient": [
        "promener"
    ],
    "promenais": [
        "promener"
    ],
    "promenait": [
        "promener"
    ],
    "promenant": [
        "promener"
    ],
    "promener": [
        "promener"
    ],
    "promeneur": [
        "promeneur"
    ],
    "promeneurs": [
        "promeneur"
    ],
    "promeneuse": [
        "promeneur"
    ],
    "promeneuses": [
        "promeneur"
    ],
    "promenez": [
        "promener"
    ],
    "promeniez": [
        "promener"
    ],
    "promenions": [
        "promener"
    ],
    "promenoir": [
        "promenoir"
    ],
    "promenons": [
        "promener"
    ],
    "promenames": [
        "promener"
    ],
    "promenat": [
        "promener"
    ],
    "promenerent": [
        "promener"
    ],
    "promene": [
        "promener"
    ],
    "promenee": [
        "promener"
    ],
    "promenees": [
        "promener"
    ],
    "promenes": [
        "promener"
    ],
    "promesse": [
        "promesse"
    ],
    "promesses": [
        "promesse"
    ],
    "promet": [
        "promettre"
    ],
    "promets": [
        "promettre"
    ],
    "promettaient": [
        "promettre"
    ],
    "promettais": [
        "promettre"
    ],
    "promettait": [
        "promettre"
    ],
    "promettant": [
        "promettre"
    ],
    "promette": [
        "promettre"
    ],
    "promettent": [
        "promettre"
    ],
    "promettes": [
        "promettre"
    ],
    "prometteur": [
        "prometteur"
    ],
    "prometteurs": [
        "prometteur"
    ],
    "prometteuse": [
        "prometteur"
    ],
    "prometteuses": [
        "prometteur"
    ],
    "promettez": [
        "promettre"
    ],
    "promettiez": [
        "promettre"
    ],
    "promettons": [
        "promettre"
    ],
    "promettra": [
        "promettre"
    ],
    "promettrai": [
        "promettre"
    ],
    "promettraient": [
        "promettre"
    ],
    "promettrais": [
        "promettre"
    ],
    "promettrait": [
        "promettre"
    ],
    "promettras": [
        "promettre"
    ],
    "promettre": [
        "promettre"
    ],
    "promettriez": [
        "promettre"
    ],
    "promettront": [
        "promettre"
    ],
    "promeut": [
        "promouvoir"
    ],
    "promirent": [
        "promettre"
    ],
    "promis": [
        "promis",
        "promettre"
    ],
    "promiscuite": [
        "promiscuite"
    ],
    "promiscuites": [
        "promiscuite"
    ],
    "promise": [
        "promis",
        "promettre"
    ],
    "promises": [
        "promis",
        "promise",
        "promettre"
    ],
    "promit": [
        "promettre"
    ],
    "promo": [
        "promo"
    ],
    "promontoire": [
        "promontoire"
    ],
    "promontoires": [
        "promontoire"
    ],
    "promos": [
        "promo"
    ],
    "promoteur": [
        "promoteur"
    ],
    "promoteurs": [
        "promoteur"
    ],
    "promotion": [
        "promotion"
    ],
    "promotionnait": [
        "promotionner"
    ],
    "promotionnel": [
        "promotionnel"
    ],
    "promotionnelle": [
        "promotionnel"
    ],
    "promotionnelles": [
        "promotionnel"
    ],
    "promotions": [
        "promotion"
    ],
    "promotrice": [
        "promoteur"
    ],
    "promouvaient": [
        "promouvoir"
    ],
    "promouvez": [
        "promouvoir"
    ],
    "promouvoir": [
        "promouvoir"
    ],
    "prompt": [
        "prompt"
    ],
    "prompte": [
        "prompt"
    ],
    "promptement": [
        "promptement"
    ],
    "promptes": [
        "prompt"
    ],
    "prompteur": [
        "prompteur"
    ],
    "prompteurs": [
        "prompteur"
    ],
    "promptitude": [
        "promptitude"
    ],
    "prompto": [
        "prompto"
    ],
    "prompts": [
        "prompt"
    ],
    "promu": [
        "promouvoir",
        "promu"
    ],
    "promue": [
        "promouvoir",
        "promu"
    ],
    "promues": [
        "promouvoir",
        "promu"
    ],
    "promulgation": [
        "promulgation"
    ],
    "promulguait": [
        "promulguer"
    ],
    "promulguant": [
        "promulguer"
    ],
    "promulguer": [
        "promulguer"
    ],
    "promulguera": [
        "promulguer"
    ],
    "promulgue": [
        "promulguer"
    ],
    "promulguee": [
        "promulguer"
    ],
    "promulguees": [
        "promulguer"
    ],
    "promulgues": [
        "promulguer"
    ],
    "promus": [
        "promouvoir",
        "promu"
    ],
    "promut": [
        "promouvoir"
    ],
    "promenent": [
        "promener"
    ],
    "promenera": [
        "promener"
    ],
    "promenerai": [
        "promener"
    ],
    "promeneraient": [
        "promener"
    ],
    "promenerais": [
        "promener"
    ],
    "promenerait": [
        "promener"
    ],
    "promeneras": [
        "promener"
    ],
    "promenerez": [
        "promener"
    ],
    "promenerions": [
        "promener"
    ],
    "promenerons": [
        "promener"
    ],
    "prometheen": [
        "prometheen"
    ],
    "prometheenne": [
        "prometheen"
    ],
    "promimes": [
        "promettre"
    ],
    "pronateurs": [
        "pronateur"
    ],
    "pronation": [
        "pronation"
    ],
    "pronom": [
        "pronom"
    ],
    "pronominal": [
        "pronominal"
    ],
    "pronominale": [
        "pronominal"
    ],
    "pronominaux": [
        "pronominal"
    ],
    "pronoms": [
        "pronom"
    ],
    "prononce": [
        "prononce",
        "prononcer"
    ],
    "prononcent": [
        "prononcer"
    ],
    "prononcer": [
        "prononcer"
    ],
    "prononcera": [
        "prononcer"
    ],
    "prononcerai": [
        "prononcer"
    ],
    "prononceraient": [
        "prononcer"
    ],
    "prononcerais": [
        "prononcer"
    ],
    "prononcerait": [
        "prononcer"
    ],
    "prononceras": [
        "prononcer"
    ],
    "prononcerez": [
        "prononcer"
    ],
    "prononceriez": [
        "prononcer"
    ],
    "prononcerons": [
        "prononcer"
    ],
    "prononceront": [
        "prononcer"
    ],
    "prononces": [
        "prononce",
        "prononcer"
    ],
    "prononcez": [
        "prononcer"
    ],
    "prononciation": [
        "prononciation"
    ],
    "prononciations": [
        "prononciation"
    ],
    "prononciez": [
        "prononcer"
    ],
    "prononcions": [
        "prononcer"
    ],
    "prononcerent": [
        "prononcer"
    ],
    "prononcee": [
        "prononce",
        "prononcer"
    ],
    "prononcees": [
        "prononce",
        "prononcer"
    ],
    "prononca": [
        "prononcer"
    ],
    "prononcable": [
        "prononcable"
    ],
    "prononcai": [
        "prononcer"
    ],
    "prononcaient": [
        "prononcer"
    ],
    "prononcais": [
        "prononcer"
    ],
    "prononcait": [
        "prononcer"
    ],
    "prononcant": [
        "prononcer"
    ],
    "prononcas": [
        "prononcer"
    ],
    "prononcons": [
        "prononcer"
    ],
    "prononcat": [
        "prononcer"
    ],
    "pronostic": [
        "pronostic"
    ],
    "pronostics": [
        "pronostic"
    ],
    "pronostiquait": [
        "pronostiquer"
    ],
    "pronostique": [
        "pronostique",
        "pronostiquer"
    ],
    "pronostiquer": [
        "pronostiquer"
    ],
    "pronostiqueur": [
        "pronostiqueur"
    ],
    "pronostiquiez": [
        "pronostiquer"
    ],
    "pronunciamiento": [
        "pronunciamiento"
    ],
    "propagande": [
        "propagande"
    ],
    "propagandes": [
        "propagande"
    ],
    "propagandiste": [
        "propagandiste"
    ],
    "propagandistes": [
        "propagandiste"
    ],
    "propagateur": [
        "propagateur"
    ],
    "propagateurs": [
        "propagateur"
    ],
    "propagation": [
        "propagation"
    ],
    "propagations": [
        "propagation"
    ],
    "propage": [
        "propager"
    ],
    "propagea": [
        "propager"
    ],
    "propageaient": [
        "propager"
    ],
    "propageait": [
        "propager"
    ],
    "propageant": [
        "propager"
    ],
    "propagent": [
        "propager"
    ],
    "propager": [
        "propager"
    ],
    "propagera": [
        "propager"
    ],
    "propageraient": [
        "propager"
    ],
    "propagerait": [
        "propager"
    ],
    "propagez": [
        "propager"
    ],
    "propageat": [
        "propager"
    ],
    "propagerent": [
        "propager"
    ],
    "propagee": [
        "propager"
    ],
    "propagees": [
        "propager"
    ],
    "propages": [
        "propager"
    ],
    "propane": [
        "propane"
    ],
    "propension": [
        "propension"
    ],
    "propergol": [
        "propergol"
    ],
    "prophase": [
        "prophase"
    ],
    "prophylactique": [
        "prophylactique"
    ],
    "prophylactiques": [
        "prophylactique"
    ],
    "prophylaxie": [
        "prophylaxie"
    ],
    "prophete": [
        "prophete"
    ],
    "prophetes": [
        "prophete"
    ],
    "prophetesse": [
        "prophete"
    ],
    "prophetie": [
        "prophetie"
    ],
    "propheties": [
        "prophetie"
    ],
    "prophetique": [
        "prophetique"
    ],
    "prophetiquement": [
        "prophetiquement"
    ],
    "prophetiques": [
        "prophetique"
    ],
    "prophetisaient": [
        "prophetiser"
    ],
    "prophetisait": [
        "prophetiser"
    ],
    "prophetisant": [
        "prophetiser"
    ],
    "prophetise": [
        "prophetiser"
    ],
    "prophetisent": [
        "prophetiser"
    ],
    "prophetiser": [
        "prophetiser"
    ],
    "prophetisez": [
        "prophetiser"
    ],
    "propice": [
        "propice"
    ],
    "propices": [
        "propice"
    ],
    "propionate": [
        "propionate"
    ],
    "propitiatoire": [
        "propitiatoire"
    ],
    "propitiatoires": [
        "propitiatoire"
    ],
    "propolis": [
        "propolis"
    ],
    "proportion": [
        "proportion"
    ],
    "proportionnalite": [
        "proportionnalite"
    ],
    "proportionnel": [
        "proportionnel"
    ],
    "proportionnelle": [
        "proportionnel"
    ],
    "proportionnellement": [
        "proportionnellement"
    ],
    "proportionnelles": [
        "proportionnel"
    ],
    "proportionner": [
        "proportionner"
    ],
    "proportionne": [
        "proportionne",
        "proportionner"
    ],
    "proportionnee": [
        "proportionne",
        "proportionner"
    ],
    "proportionnees": [
        "proportionne",
        "proportionner"
    ],
    "proportionnes": [
        "proportionne",
        "proportionner"
    ],
    "proportions": [
        "proportion"
    ],
    "propos": [
        "propos"
    ],
    "proposa": [
        "proposer"
    ],
    "proposai": [
        "proposer"
    ],
    "proposaient": [
        "proposer"
    ],
    "proposais": [
        "proposer"
    ],
    "proposait": [
        "proposer"
    ],
    "proposant": [
        "proposer"
    ],
    "propose": [
        "propose",
        "proposer"
    ],
    "proposent": [
        "proposer"
    ],
    "proposer": [
        "proposer"
    ],
    "proposera": [
        "proposer"
    ],
    "proposerai": [
        "proposer"
    ],
    "proposeraient": [
        "proposer"
    ],
    "proposerais": [
        "proposer"
    ],
    "proposerait": [
        "proposer"
    ],
    "proposeras": [
        "proposer"
    ],
    "proposerez": [
        "proposer"
    ],
    "proposeriez": [
        "proposer"
    ],
    "proposerions": [
        "proposer"
    ],
    "proposerons": [
        "proposer"
    ],
    "proposeront": [
        "proposer"
    ],
    "proposes": [
        "propose",
        "proposer"
    ],
    "proposez": [
        "proposer"
    ],
    "proposiez": [
        "proposer"
    ],
    "proposions": [
        "proposer"
    ],
    "proposition": [
        "proposition"
    ],
    "propositions": [
        "proposition"
    ],
    "proposons": [
        "proposer"
    ],
    "proposames": [
        "proposer"
    ],
    "proposat": [
        "proposer"
    ],
    "proposerent": [
        "proposer"
    ],
    "proposee": [
        "propose",
        "proposer"
    ],
    "proposees": [
        "propose",
        "proposer"
    ],
    "propre": [
        "propre"
    ],
    "proprement": [
        "proprement"
    ],
    "propres": [
        "propre"
    ],
    "propret": [
        "propret"
    ],
    "proprets": [
        "propret"
    ],
    "proprette": [
        "propret"
    ],
    "proprettes": [
        "propret"
    ],
    "proprete": [
        "proprete"
    ],
    "proprio": [
        "proprio"
    ],
    "proprios": [
        "proprio"
    ],
    "proprietaire": [
        "proprietaire"
    ],
    "proprietaires": [
        "proprietaire"
    ],
    "propriete": [
        "propriete"
    ],
    "proprietes": [
        "propriete"
    ],
    "propulsa": [
        "propulser"
    ],
    "propulsaient": [
        "propulser"
    ],
    "propulsais": [
        "propulser"
    ],
    "propulsait": [
        "propulser"
    ],
    "propulsant": [
        "propulser"
    ],
    "propulse": [
        "propulser"
    ],
    "propulsent": [
        "propulser"
    ],
    "propulser": [
        "propulser"
    ],
    "propulsera": [
        "propulser"
    ],
    "propulserait": [
        "propulser"
    ],
    "propulseur": [
        "propulseur"
    ],
    "propulseurs": [
        "propulseur"
    ],
    "propulsif": [
        "propulsif"
    ],
    "propulsion": [
        "propulsion"
    ],
    "propulsions": [
        "propulsion"
    ],
    "propulsat": [
        "propulser"
    ],
    "propulsee": [
        "propulser"
    ],
    "propulsees": [
        "propulser"
    ],
    "propulses": [
        "propulser"
    ],
    "propylene": [
        "propylene"
    ],
    "propylees": [
        "propylee"
    ],
    "propedeute": [
        "propedeute"
    ],
    "prorata": [
        "prorata"
    ],
    "prorogation": [
        "prorogation"
    ],
    "proroger": [
        "proroger"
    ],
    "proroge": [
        "proroger"
    ],
    "pros": [
        "pro"
    ],
    "prosateur": [
        "prosateur"
    ],
    "prosateurs": [
        "prosateur"
    ],
    "prosaique": [
        "prosaique"
    ],
    "prosaiquement": [
        "prosaiquement"
    ],
    "prosaiques": [
        "prosaique"
    ],
    "prosaisme": [
        "prosaisme"
    ],
    "proscenium": [
        "proscenium"
    ],
    "proscription": [
        "proscription"
    ],
    "proscriptions": [
        "proscription"
    ],
    "proscrire": [
        "proscrire"
    ],
    "proscrit": [
        "proscrire",
        "proscrit"
    ],
    "proscrite": [
        "proscrire",
        "proscrit"
    ],
    "proscrites": [
        "proscrire",
        "proscrit"
    ],
    "proscrits": [
        "proscrire",
        "proscrit"
    ],
    "proscrivait": [
        "proscrire"
    ],
    "proscrivant": [
        "proscrire"
    ],
    "proscrivit": [
        "proscrire"
    ],
    "prose": [
        "prose"
    ],
    "prosit": [
        "prosit"
    ],
    "prosodie": [
        "prosodie"
    ],
    "prosodique": [
        "prosodique"
    ],
    "prosopopees": [
        "prosopopee"
    ],
    "prosovietique": [
        "prosovietique"
    ],
    "prospect": [
        "prospect"
    ],
    "prospectais": [
        "prospecter"
    ],
    "prospectait": [
        "prospecter"
    ],
    "prospectant": [
        "prospecter"
    ],
    "prospecte": [
        "prospecter"
    ],
    "prospecter": [
        "prospecter"
    ],
    "prospecteur": [
        "prospecteur"
    ],
    "prospecteurs": [
        "prospecteur"
    ],
    "prospectif": [
        "prospectif"
    ],
    "prospection": [
        "prospection"
    ],
    "prospections": [
        "prospecter",
        "prospection"
    ],
    "prospective": [
        "prospective",
        "prospectif"
    ],
    "prospectus": [
        "prospectus"
    ],
    "prospere": [
        "prosperer",
        "prospere"
    ],
    "prosperent": [
        "prosperer"
    ],
    "prosperes": [
        "prosperer",
        "prospere"
    ],
    "prospera": [
        "prosperer"
    ],
    "prosperaient": [
        "prosperer"
    ],
    "prosperait": [
        "prosperer"
    ],
    "prosperer": [
        "prosperer"
    ],
    "prosperera": [
        "prosperer"
    ],
    "prospereraient": [
        "prosperer"
    ],
    "prosperite": [
        "prosperite"
    ],
    "prosperites": [
        "prosperite"
    ],
    "prosperons": [
        "prosperer"
    ],
    "prospererent": [
        "prosperer"
    ],
    "prostate": [
        "prostate"
    ],
    "prostatectomie": [
        "prostatectomie"
    ],
    "prostatique": [
        "prostatique"
    ],
    "prostatite": [
        "prostatite"
    ],
    "prosterna": [
        "prosterner"
    ],
    "prosternaient": [
        "prosterner"
    ],
    "prosternais": [
        "prosterner"
    ],
    "prosternait": [
        "prosterner"
    ],
    "prosternant": [
        "prosterner"
    ],
    "prosternation": [
        "prosternation"
    ],
    "prosternations": [
        "prosternation"
    ],
    "prosterne": [
        "prosterner"
    ],
    "prosternent": [
        "prosterner"
    ],
    "prosterner": [
        "prosterner"
    ],
    "prosternera": [
        "prosterner"
    ],
    "prosternerait": [
        "prosterner"
    ],
    "prosterneras": [
        "prosterner"
    ],
    "prosternerons": [
        "prosterner"
    ],
    "prosterneront": [
        "prosterner"
    ],
    "prosternez": [
        "prosterner"
    ],
    "prosternons": [
        "prosterner"
    ],
    "prosternerent": [
        "prosterner"
    ],
    "prosternee": [
        "prosterner"
    ],
    "prosternees": [
        "prosterner"
    ],
    "prosternes": [
        "prosterner"
    ],
    "prosthetique": [
        "prosthetique"
    ],
    "prostitua": [
        "prostituer"
    ],
    "prostituais": [
        "prostituer"
    ],
    "prostituait": [
        "prostituer"
    ],
    "prostituant": [
        "prostituer"
    ],
    "prostitue": [
        "prostituer",
        "prostitue"
    ],
    "prostituent": [
        "prostituer"
    ],
    "prostituer": [
        "prostituer"
    ],
    "prostituerais": [
        "prostituer"
    ],
    "prostitution": [
        "prostitution"
    ],
    "prostitutionnel": [
        "prostitutionnel"
    ],
    "prostitutions": [
        "prostitution"
    ],
    "prostituee": [
        "prostituer",
        "prostitue"
    ],
    "prostituees": [
        "prostituer",
        "prostitue"
    ],
    "prostitues": [
        "prostituer",
        "prostitue"
    ],
    "prostrant": [
        "prostrer"
    ],
    "prostration": [
        "prostration"
    ],
    "prostrations": [
        "prostration"
    ],
    "prostre": [
        "prostre"
    ],
    "prostree": [
        "prostre"
    ],
    "prostrees": [
        "prostre"
    ],
    "prostres": [
        "prostre"
    ],
    "proselyte": [
        "proselyte"
    ],
    "proselytes": [
        "proselyte"
    ],
    "proselytique": [
        "proselytique"
    ],
    "proselytisme": [
        "proselytisme"
    ],
    "protagoniste": [
        "protagoniste"
    ],
    "protagonistes": [
        "protagoniste"
    ],
    "protal": [
        "protal"
    ],
    "prote": [
        "prote"
    ],
    "protecteur": [
        "protecteur"
    ],
    "protecteurs": [
        "protecteur"
    ],
    "protection": [
        "protection"
    ],
    "protectionnisme": [
        "protectionnisme"
    ],
    "protections": [
        "protection"
    ],
    "protectorat": [
        "protectorat"
    ],
    "protectorats": [
        "protectorat"
    ],
    "protectrice": [
        "protecteur"
    ],
    "protectrices": [
        "protecteur"
    ],
    "protes": [
        "prote"
    ],
    "protesta": [
        "protester"
    ],
    "protestai": [
        "protester"
    ],
    "protestaient": [
        "protester"
    ],
    "protestais": [
        "protester"
    ],
    "protestait": [
        "protester"
    ],
    "protestant": [
        "protestant",
        "protester"
    ],
    "protestante": [
        "protestant"
    ],
    "protestantes": [
        "protestant"
    ],
    "protestantisme": [
        "protestantisme"
    ],
    "protestants": [
        "protestant"
    ],
    "protestataires": [
        "protestataire"
    ],
    "protestation": [
        "protestation"
    ],
    "protestations": [
        "protestation"
    ],
    "proteste": [
        "protester"
    ],
    "protestent": [
        "protester"
    ],
    "protester": [
        "protester"
    ],
    "protestera": [
        "protester"
    ],
    "protesterai": [
        "protester"
    ],
    "protesterais": [
        "protester"
    ],
    "protesterait": [
        "protester"
    ],
    "protesterons": [
        "protester"
    ],
    "protestes": [
        "protester"
    ],
    "protestez": [
        "protester"
    ],
    "protestions": [
        "protester"
    ],
    "protestons": [
        "protester"
    ],
    "protestames": [
        "protester"
    ],
    "protestat": [
        "protester"
    ],
    "protesterent": [
        "protester"
    ],
    "proteus": [
        "proteus"
    ],
    "prothrombine": [
        "prothrombine"
    ],
    "prothese": [
        "prothese"
    ],
    "protheses": [
        "prothese"
    ],
    "prothesiste": [
        "prothesiste"
    ],
    "prothesistes": [
        "prothesiste"
    ],
    "prothetique": [
        "prothetique"
    ],
    "protide": [
        "protide"
    ],
    "protides": [
        "protide"
    ],
    "protidique": [
        "protidique"
    ],
    "protistes": [
        "protiste"
    ],
    "protococcus": [
        "protococcus"
    ],
    "protocolaire": [
        "protocolaire"
    ],
    "protocolaires": [
        "protocolaire"
    ],
    "protocole": [
        "protocole"
    ],
    "protocoles": [
        "protocole"
    ],
    "protocoques": [
        "protocoque"
    ],
    "protohistoire": [
        "protohistoire"
    ],
    "proton": [
        "proton"
    ],
    "protonique": [
        "protonique"
    ],
    "protonotaire": [
        "protonotaire"
    ],
    "protons": [
        "proton"
    ],
    "protoplasme": [
        "protoplasme"
    ],
    "protoplasmes": [
        "protoplasme"
    ],
    "protoplasmique": [
        "protoplasmique"
    ],
    "protoplaste": [
        "protoplaste"
    ],
    "prototype": [
        "prototype"
    ],
    "prototypes": [
        "prototype"
    ],
    "protoxyde": [
        "protoxyde"
    ],
    "protozoaire": [
        "protozoaire"
    ],
    "protrusion": [
        "protrusion"
    ],
    "protuberance": [
        "protuberance"
    ],
    "protuberances": [
        "protuberance"
    ],
    "protuberant": [
        "protuberant"
    ],
    "protuberante": [
        "protuberant"
    ],
    "protuberantes": [
        "protuberant"
    ],
    "protuberants": [
        "protuberant"
    ],
    "protege": [
        "proteger",
        "protege"
    ],
    "protegent": [
        "proteger"
    ],
    "proteges": [
        "proteger",
        "protege"
    ],
    "protease": [
        "protease"
    ],
    "protegea": [
        "proteger"
    ],
    "protegeai": [
        "proteger"
    ],
    "protegeaient": [
        "proteger"
    ],
    "protegeais": [
        "proteger"
    ],
    "protegeait": [
        "proteger"
    ],
    "protegeant": [
        "proteger"
    ],
    "protegeons": [
        "proteger"
    ],
    "proteger": [
        "proteger"
    ],
    "protegera": [
        "proteger"
    ],
    "protegerai": [
        "proteger"
    ],
    "protegeraient": [
        "proteger"
    ],
    "protegerais": [
        "proteger"
    ],
    "protegerait": [
        "proteger"
    ],
    "protegeras": [
        "proteger"
    ],
    "protegerez": [
        "proteger"
    ],
    "protegeriez": [
        "proteger"
    ],
    "protegerons": [
        "proteger"
    ],
    "protegeront": [
        "proteger"
    ],
    "protegez": [
        "proteger"
    ],
    "protegeat": [
        "proteger"
    ],
    "protegiez": [
        "proteger"
    ],
    "protegions": [
        "proteger"
    ],
    "protegee": [
        "proteger",
        "protege"
    ],
    "protegees": [
        "proteger",
        "protege"
    ],
    "proteiforme": [
        "proteiforme"
    ],
    "proteine": [
        "proteine"
    ],
    "proteines": [
        "proteine"
    ],
    "proteinique": [
        "proteinique"
    ],
    "proteinurie": [
        "proteinurie"
    ],
    "proteinee": [
        "proteine"
    ],
    "proteique": [
        "proteique"
    ],
    "proteolytique": [
        "proteolytique"
    ],
    "protet": [
        "protet"
    ],
    "protets": [
        "protet"
    ],
    "proudhonisme": [
        "proudhonisme"
    ],
    "proue": [
        "proue"
    ],
    "proues": [
        "proue"
    ],
    "prouesse": [
        "prouesse"
    ],
    "prouesses": [
        "prouesse"
    ],
    "proustien": [
        "proustien"
    ],
    "proustienne": [
        "proustien"
    ],
    "prout": [
        "prout"
    ],
    "prouts": [
        "prout"
    ],
    "prouva": [
        "prouver"
    ],
    "prouvable": [
        "prouvable"
    ],
    "prouvai": [
        "prouver"
    ],
    "prouvaient": [
        "prouver"
    ],
    "prouvais": [
        "prouver"
    ],
    "prouvait": [
        "prouver"
    ],
    "prouvant": [
        "prouver"
    ],
    "prouve": [
        "prouve",
        "prouver"
    ],
    "prouvent": [
        "prouver"
    ],
    "prouver": [
        "prouver"
    ],
    "prouvera": [
        "prouver"
    ],
    "prouverai": [
        "prouver"
    ],
    "prouveraient": [
        "prouver"
    ],
    "prouverait": [
        "prouver"
    ],
    "prouveras": [
        "prouver"
    ],
    "prouverez": [
        "prouver"
    ],
    "prouverons": [
        "prouver"
    ],
    "prouveront": [
        "prouver"
    ],
    "prouves": [
        "prouve",
        "prouver"
    ],
    "prouvez": [
        "prouver"
    ],
    "prouviez": [
        "prouver"
    ],
    "prouvons": [
        "prouver"
    ],
    "prouverent": [
        "prouver"
    ],
    "prouvee": [
        "prouve",
        "prouver"
    ],
    "prouvees": [
        "prouve",
        "prouver"
    ],
    "provenaient": [
        "provenir"
    ],
    "provenait": [
        "provenir"
    ],
    "provenance": [
        "provenance"
    ],
    "provenances": [
        "provenance"
    ],
    "provenant": [
        "provenir"
    ],
    "provende": [
        "provende"
    ],
    "provenir": [
        "provenir"
    ],
    "provenu": [
        "provenir"
    ],
    "provencal": [
        "provencal"
    ],
    "provencale": [
        "provencal"
    ],
    "provencales": [
        "provencal"
    ],
    "provencaux": [
        "provencal"
    ],
    "proverbe": [
        "proverbe"
    ],
    "proverbes": [
        "proverbe"
    ],
    "proverbial": [
        "proverbial"
    ],
    "proverbiale": [
        "proverbial"
    ],
    "providence": [
        "providence"
    ],
    "providentiel": [
        "providentiel"
    ],
    "providentielle": [
        "providentiel"
    ],
    "providentiellement": [
        "providentiellement"
    ],
    "providentielles": [
        "providentiel"
    ],
    "providentiels": [
        "providentiel"
    ],
    "provider": [
        "provider"
    ],
    "proviendrait": [
        "provenir"
    ],
    "provienne": [
        "provenir"
    ],
    "proviennent": [
        "provenir"
    ],
    "provient": [
        "provenir"
    ],
    "provietnamien": [
        "provietnamien"
    ],
    "province": [
        "province"
    ],
    "provinces": [
        "province"
    ],
    "provincial": [
        "provincial"
    ],
    "provinciale": [
        "provincial"
    ],
    "provincialement": [
        "provincialement"
    ],
    "provinciales": [
        "provincial"
    ],
    "provinciaux": [
        "provincial"
    ],
    "proviseur": [
        "proviseur"
    ],
    "proviseurs": [
        "proviseur"
    ],
    "provision": [
        "provision"
    ],
    "provisionnel": [
        "provisionnel"
    ],
    "provisionner": [
        "provisionner"
    ],
    "provisionnons": [
        "provisionner"
    ],
    "provisions": [
        "provision"
    ],
    "provisoire": [
        "provisoire"
    ],
    "provisoirement": [
        "provisoirement"
    ],
    "provisoires": [
        "provisoire"
    ],
    "provo": [
        "provo"
    ],
    "provoc": [
        "provoc"
    ],
    "provocant": [
        "provocant"
    ],
    "provocante": [
        "provocant"
    ],
    "provocantes": [
        "provocant"
    ],
    "provocants": [
        "provocant"
    ],
    "provocateur": [
        "provocateur"
    ],
    "provocateurs": [
        "provocateur"
    ],
    "provocation": [
        "provocation"
    ],
    "provocations": [
        "provocation"
    ],
    "provocatrice": [
        "provocateur"
    ],
    "provolone": [
        "provolone"
    ],
    "provoqua": [
        "provoquer"
    ],
    "provoquai": [
        "provoquer"
    ],
    "provoquaient": [
        "provoquer"
    ],
    "provoquais": [
        "provoquer"
    ],
    "provoquait": [
        "provoquer"
    ],
    "provoquant": [
        "provoquer"
    ],
    "provoque": [
        "provoquer",
        "provoque"
    ],
    "provoquent": [
        "provoquer"
    ],
    "provoquer": [
        "provoquer"
    ],
    "provoquera": [
        "provoquer"
    ],
    "provoquerai": [
        "provoquer"
    ],
    "provoqueraient": [
        "provoquer"
    ],
    "provoquerais": [
        "provoquer"
    ],
    "provoquerait": [
        "provoquer"
    ],
    "provoquerez": [
        "provoquer"
    ],
    "provoqueriez": [
        "provoquer"
    ],
    "provoquerions": [
        "provoquer"
    ],
    "provoquerons": [
        "provoquer"
    ],
    "provoqueront": [
        "provoquer"
    ],
    "provoques": [
        "provoquer",
        "provoque"
    ],
    "provoquez": [
        "provoquer"
    ],
    "provoquions": [
        "provoquer"
    ],
    "provoquons": [
        "provoquer"
    ],
    "provoquat": [
        "provoquer"
    ],
    "provoquerent": [
        "provoquer"
    ],
    "provoquee": [
        "provoquer",
        "provoque"
    ],
    "provoquees": [
        "provoquer",
        "provoque"
    ],
    "provos": [
        "provo"
    ],
    "provediteur": [
        "provediteur"
    ],
    "provediteurs": [
        "provediteur"
    ],
    "proximal": [
        "proximal"
    ],
    "proximale": [
        "proximal"
    ],
    "proximite": [
        "proximite"
    ],
    "proxo": [
        "proxo"
    ],
    "proxos": [
        "proxo"
    ],
    "proxenete": [
        "proxenete"
    ],
    "proxenetes": [
        "proxenete"
    ],
    "proxenetisme": [
        "proxenetisme"
    ],
    "proze": [
        "proze"
    ],
    "proedre": [
        "proedre"
    ],
    "proeminait": [
        "proeminer"
    ],
    "proemine": [
        "proeminer"
    ],
    "proeminence": [
        "proeminence"
    ],
    "proeminences": [
        "proeminence"
    ],
    "proeminent": [
        "proeminent"
    ],
    "proeminente": [
        "proeminent"
    ],
    "proeminentes": [
        "proeminent"
    ],
    "proeminents": [
        "proeminent"
    ],
    "prud'homme": [
        "prud'homme"
    ],
    "prud'hommes": [
        "prud'homme"
    ],
    "prude": [
        "prude"
    ],
    "prudemment": [
        "prudemment"
    ],
    "prudence": [
        "prudence"
    ],
    "prudences": [
        "prudence"
    ],
    "prudent": [
        "prudent"
    ],
    "prudente": [
        "prudent"
    ],
    "prudentes": [
        "prudent"
    ],
    "prudents": [
        "prudent"
    ],
    "pruderie": [
        "pruderie"
    ],
    "pruderies": [
        "pruderie"
    ],
    "prudes": [
        "prude"
    ],
    "prudhommesque": [
        "prudhommesque"
    ],
    "prudhommesques": [
        "prudhommesque"
    ],
    "prune": [
        "prune"
    ],
    "pruneau": [
        "pruneau"
    ],
    "pruneaux": [
        "pruneau"
    ],
    "prunelle": [
        "prunelle"
    ],
    "prunelles": [
        "prunelle"
    ],
    "prunellier": [
        "prunellier"
    ],
    "prunelliers": [
        "prunellier"
    ],
    "prunes": [
        "prune"
    ],
    "prunier": [
        "prunier"
    ],
    "pruniers": [
        "prunier"
    ],
    "prunus": [
        "prunus"
    ],
    "prurigo": [
        "prurigo"
    ],
    "prurit": [
        "prurit"
    ],
    "prussianise": [
        "prussianiser"
    ],
    "prussien": [
        "prussien"
    ],
    "prussienne": [
        "prussien"
    ],
    "prussiennes": [
        "prussien"
    ],
    "prussiens": [
        "prussien"
    ],
    "prussik": [
        "prussik"
    ],
    "prussique": [
        "prussique"
    ],
    "prytanee": [
        "prytanee"
    ],
    "prele": [
        "prele"
    ],
    "pres": [
        "pres",
        "pre"
    ],
    "pre": [
        "pre"
    ],
    "preadolescence": [
        "preadolescence"
    ],
    "preadolescente": [
        "preadolescent"
    ],
    "prealable": [
        "prealable"
    ],
    "prealablement": [
        "prealablement"
    ],
    "prealables": [
        "prealable"
    ],
    "preambule": [
        "preambule"
    ],
    "preambules": [
        "preambule"
    ],
    "preau": [
        "preau"
    ],
    "preaux": [
        "preau"
    ],
    "preavis": [
        "preavis"
    ],
    "prebendes": [
        "prebende"
    ],
    "precaire": [
        "precaire"
    ],
    "precairement": [
        "precairement"
    ],
    "precaires": [
        "precaire"
    ],
    "precambrien": [
        "precambrien"
    ],
    "precambrienne": [
        "precambrien"
    ],
    "precarite": [
        "precarite"
    ],
    "precaution": [
        "precaution"
    ],
    "precautionneuse": [
        "precautionneux"
    ],
    "precautionneusement": [
        "precautionneusement"
    ],
    "precautionneuses": [
        "precautionneux"
    ],
    "precautionneux": [
        "precautionneux"
    ],
    "precautions": [
        "precaution"
    ],
    "precellence": [
        "precellence"
    ],
    "precelles": [
        "precelles"
    ],
    "precepte": [
        "precepte"
    ],
    "preceptes": [
        "precepte"
    ],
    "precepteur": [
        "precepteur"
    ],
    "precepteurs": [
        "precepteur"
    ],
    "preceptrice": [
        "precepteur"
    ],
    "precession": [
        "precession"
    ],
    "prechauffage": [
        "prechauffage"
    ],
    "prechauffer": [
        "prechauffer"
    ],
    "precieuse": [
        "precieux"
    ],
    "precieusement": [
        "precieusement"
    ],
    "precieuses": [
        "precieux",
        "precieuse"
    ],
    "precieux": [
        "precieux"
    ],
    "preciosite": [
        "preciosite"
    ],
    "preciosites": [
        "preciosite"
    ],
    "precipice": [
        "precipice"
    ],
    "precipices": [
        "precipice"
    ],
    "precipita": [
        "precipiter"
    ],
    "precipitai": [
        "precipiter"
    ],
    "precipitaient": [
        "precipiter"
    ],
    "precipitais": [
        "precipiter"
    ],
    "precipitait": [
        "precipiter"
    ],
    "precipitamment": [
        "precipitamment"
    ],
    "precipitant": [
        "precipiter",
        "precipitant"
    ],
    "precipitation": [
        "precipitation"
    ],
    "precipitations": [
        "precipitation"
    ],
    "precipite": [
        "precipiter",
        "precipite"
    ],
    "precipitent": [
        "precipiter"
    ],
    "precipiter": [
        "precipiter"
    ],
    "precipitera": [
        "precipiter"
    ],
    "precipiterai": [
        "precipiter"
    ],
    "precipiteraient": [
        "precipiter"
    ],
    "precipiterais": [
        "precipiter"
    ],
    "precipiterait": [
        "precipiter"
    ],
    "precipiteras": [
        "precipiter"
    ],
    "precipiterez": [
        "precipiter"
    ],
    "precipiterions": [
        "precipiter"
    ],
    "precipiteront": [
        "precipiter"
    ],
    "precipites": [
        "precipiter",
        "precipite"
    ],
    "precipitez": [
        "precipiter"
    ],
    "precipitiez": [
        "precipiter"
    ],
    "precipitions": [
        "precipiter"
    ],
    "precipitons": [
        "precipiter"
    ],
    "precipitames": [
        "precipiter"
    ],
    "precipitat": [
        "precipiter"
    ],
    "precipiterent": [
        "precipiter"
    ],
    "precipitee": [
        "precipiter",
        "precipite"
    ],
    "precipitees": [
        "precipiter",
        "precipite"
    ],
    "preciputs": [
        "preciput"
    ],
    "precis": [
        "precis"
    ],
    "precisa": [
        "preciser"
    ],
    "precisai": [
        "preciser"
    ],
    "precisaient": [
        "preciser"
    ],
    "precisais": [
        "preciser"
    ],
    "precisait": [
        "preciser"
    ],
    "precisant": [
        "preciser"
    ],
    "precise": [
        "precis",
        "preciser"
    ],
    "precisent": [
        "preciser"
    ],
    "preciser": [
        "preciser"
    ],
    "precisera": [
        "preciser"
    ],
    "preciserai": [
        "preciser"
    ],
    "preciserais": [
        "preciser"
    ],
    "preciserait": [
        "preciser"
    ],
    "preciserez": [
        "preciser"
    ],
    "preciseront": [
        "preciser"
    ],
    "precises": [
        "precis",
        "preciser"
    ],
    "precisez": [
        "preciser"
    ],
    "precision": [
        "precision"
    ],
    "precisions": [
        "preciser",
        "precision"
    ],
    "precisons": [
        "preciser"
    ],
    "precisat": [
        "preciser"
    ],
    "preciserent": [
        "preciser"
    ],
    "precisee": [
        "preciser"
    ],
    "precisees": [
        "preciser"
    ],
    "precisement": [
        "precisement"
    ],
    "precite": [
        "precite"
    ],
    "precitee": [
        "precite"
    ],
    "precitees": [
        "precite"
    ],
    "precites": [
        "precite"
    ],
    "precoce": [
        "precoce"
    ],
    "precocement": [
        "precocement"
    ],
    "precoces": [
        "precoce"
    ],
    "precocite": [
        "precocite"
    ],
    "precognition": [
        "precognition"
    ],
    "precolombien": [
        "precolombien"
    ],
    "precolombienne": [
        "precolombien"
    ],
    "precolombiennes": [
        "precolombien"
    ],
    "preconisa": [
        "preconiser"
    ],
    "preconisaient": [
        "preconiser"
    ],
    "preconisais": [
        "preconiser"
    ],
    "preconisait": [
        "preconiser"
    ],
    "preconisant": [
        "preconiser"
    ],
    "preconisation": [
        "preconisation"
    ],
    "preconise": [
        "preconiser"
    ],
    "preconisent": [
        "preconiser"
    ],
    "preconiser": [
        "preconiser"
    ],
    "preconiserais": [
        "preconiser"
    ],
    "preconises": [
        "preconiser"
    ],
    "preconisez": [
        "preconiser"
    ],
    "preconisiez": [
        "preconiser"
    ],
    "preconisat": [
        "preconiser"
    ],
    "preconisee": [
        "preconiser"
    ],
    "preconisees": [
        "preconiser"
    ],
    "preconcu": [
        "preconcu"
    ],
    "preconcue": [
        "preconcu"
    ],
    "preconcues": [
        "preconcu",
        "preconcevoir"
    ],
    "precuit": [
        "precuit"
    ],
    "precuites": [
        "precuit"
    ],
    "precurseur": [
        "precurseur"
    ],
    "precurseurs": [
        "precurseur"
    ],
    "precede": [
        "preceder"
    ],
    "precedent": [
        "preceder",
        "precedent"
    ],
    "preceda": [
        "preceder"
    ],
    "precedai": [
        "preceder"
    ],
    "precedaient": [
        "preceder"
    ],
    "precedais": [
        "preceder"
    ],
    "precedait": [
        "preceder"
    ],
    "precedant": [
        "preceder"
    ],
    "precedassent": [
        "preceder"
    ],
    "precedemment": [
        "precedemment"
    ],
    "precedente": [
        "precedent"
    ],
    "precedentes": [
        "precedent"
    ],
    "precedents": [
        "precedent"
    ],
    "preceder": [
        "preceder"
    ],
    "precedera": [
        "preceder"
    ],
    "precederai": [
        "preceder"
    ],
    "precederaient": [
        "preceder"
    ],
    "precederait": [
        "preceder"
    ],
    "precederions": [
        "preceder"
    ],
    "precedez": [
        "preceder"
    ],
    "precedons": [
        "preceder"
    ],
    "precederent": [
        "preceder"
    ],
    "precedee": [
        "preceder"
    ],
    "precedees": [
        "preceder"
    ],
    "precedes": [
        "preceder",
        "precede"
    ],
    "predateur": [
        "predateur"
    ],
    "predateurs": [
        "predateur"
    ],
    "predation": [
        "predation"
    ],
    "predatrice": [
        "predateur"
    ],
    "predelle": [
        "predelle"
    ],
    "predestinaient": [
        "predestiner"
    ],
    "predestination": [
        "predestination"
    ],
    "predestinations": [
        "predestination"
    ],
    "predestine": [
        "predestiner",
        "predestine"
    ],
    "predestinee": [
        "predestiner",
        "predestine"
    ],
    "predestinees": [
        "predestine"
    ],
    "predestines": [
        "predestiner",
        "predestine"
    ],
    "predicant": [
        "predicant"
    ],
    "predicants": [
        "predicant"
    ],
    "predicat": [
        "predicat"
    ],
    "predicateur": [
        "predicateur"
    ],
    "predicateurs": [
        "predicateur"
    ],
    "predication": [
        "predication"
    ],
    "predications": [
        "predication"
    ],
    "predictible": [
        "predictible"
    ],
    "predictif": [
        "predictif"
    ],
    "prediction": [
        "prediction"
    ],
    "predictions": [
        "prediction"
    ],
    "predictive": [
        "predictif"
    ],
    "predigestion": [
        "predigestion"
    ],
    "predigere": [
        "predigere"
    ],
    "predilection": [
        "predilection"
    ],
    "predilections": [
        "predilection"
    ],
    "predira": [
        "predire"
    ],
    "predire": [
        "predire"
    ],
    "predirent": [
        "predire"
    ],
    "predirez": [
        "predire"
    ],
    "predis": [
        "predire"
    ],
    "predisaient": [
        "predire"
    ],
    "predisait": [
        "predire"
    ],
    "predisant": [
        "predire"
    ],
    "predise": [
        "predire"
    ],
    "predisent": [
        "predire"
    ],
    "predisez": [
        "predire"
    ],
    "predisiez": [
        "predire"
    ],
    "predisposait": [
        "predisposer"
    ],
    "predisposant": [
        "predisposer"
    ],
    "predispose": [
        "predisposer"
    ],
    "predisposition": [
        "predisposition"
    ],
    "predispositions": [
        "predisposition"
    ],
    "predisposee": [
        "predisposer"
    ],
    "predisposees": [
        "predisposer"
    ],
    "predisposes": [
        "predisposer",
        "predispose"
    ],
    "predit": [
        "predit",
        "predire"
    ],
    "predite": [
        "predit",
        "predire"
    ],
    "predominaient": [
        "predominer"
    ],
    "predominait": [
        "predominer"
    ],
    "predominance": [
        "predominance"
    ],
    "predominant": [
        "predominant",
        "predominer"
    ],
    "predominante": [
        "predominant"
    ],
    "predomine": [
        "predominer"
    ],
    "predominer": [
        "predominer"
    ],
    "predecesseur": [
        "predecesseur"
    ],
    "predecesseurs": [
        "predecesseur"
    ],
    "predecoupee": [
        "predecoupe"
    ],
    "predefini": [
        "predefinir"
    ],
    "predefinies": [
        "predefinir"
    ],
    "predeterminer": [
        "predeterminer"
    ],
    "predetermine": [
        "predeterminer"
    ],
    "predeterminee": [
        "predeterminer"
    ],
    "predeterminees": [
        "predeterminer"
    ],
    "predetermines": [
        "predeterminer"
    ],
    "preemption": [
        "preemption"
    ],
    "preemptive": [
        "preemptif"
    ],
    "preencolle": [
        "preencolle"
    ],
    "preexistaient": [
        "preexister"
    ],
    "preexistait": [
        "preexister"
    ],
    "preexistant": [
        "preexistant"
    ],
    "preexistante": [
        "preexistant"
    ],
    "preexistants": [
        "preexistant"
    ],
    "preexiste": [
        "preexister"
    ],
    "prefabrique": [
        "prefabrique"
    ],
    "prefabriquee": [
        "prefabrique"
    ],
    "prefabriquees": [
        "prefabrique"
    ],
    "prefabriques": [
        "prefabrique"
    ],
    "preface": [
        "preface",
        "prefacer"
    ],
    "prefacent": [
        "prefacer"
    ],
    "prefacer": [
        "prefacer"
    ],
    "prefaces": [
        "preface"
    ],
    "prefacier": [
        "prefacier"
    ],
    "prefacees": [
        "prefacer"
    ],
    "prefectance": [
        "prefectance"
    ],
    "prefectorale": [
        "prefectoral"
    ],
    "prefecture": [
        "prefecture"
    ],
    "prefectures": [
        "prefecture"
    ],
    "prefet": [
        "prefet"
    ],
    "prefets": [
        "prefet"
    ],
    "prefiguraient": [
        "prefigurer"
    ],
    "prefigurait": [
        "prefigurer"
    ],
    "prefigurant": [
        "prefigurer"
    ],
    "prefiguration": [
        "prefiguration"
    ],
    "prefigure": [
        "prefigurer"
    ],
    "prefigurent": [
        "prefigurer"
    ],
    "prefigurer": [
        "prefigurer"
    ],
    "prefiguree": [
        "prefigurer"
    ],
    "prefix": [
        "prefix"
    ],
    "prefixation": [
        "prefixation"
    ],
    "prefixe": [
        "prefixer",
        "prefixe"
    ],
    "prefixes": [
        "prefixe",
        "prefix"
    ],
    "preformait": [
        "preformer"
    ],
    "preformation": [
        "preformation"
    ],
    "preformer": [
        "preformer"
    ],
    "prefrontal": [
        "prefrontal"
    ],
    "prefrontale": [
        "prefrontal"
    ],
    "prefere": [
        "preferer",
        "prefere"
    ],
    "preferent": [
        "preferer"
    ],
    "preferes": [
        "preferer",
        "prefere"
    ],
    "prefera": [
        "preferer"
    ],
    "preferable": [
        "preferable"
    ],
    "preferablement": [
        "preferablement"
    ],
    "preferables": [
        "preferable"
    ],
    "preferai": [
        "preferer"
    ],
    "preferaient": [
        "preferer"
    ],
    "preferais": [
        "preferer"
    ],
    "preferait": [
        "preferer"
    ],
    "preferant": [
        "preferer"
    ],
    "preference": [
        "preference"
    ],
    "preferences": [
        "preference"
    ],
    "preferentiel": [
        "preferentiel"
    ],
    "preferentielle": [
        "preferentiel"
    ],
    "preferer": [
        "preferer"
    ],
    "preferera": [
        "preferer"
    ],
    "prefererai": [
        "preferer"
    ],
    "prefereraient": [
        "preferer"
    ],
    "prefererais": [
        "preferer"
    ],
    "prefererait": [
        "preferer"
    ],
    "prefereras": [
        "preferer"
    ],
    "prefererez": [
        "preferer"
    ],
    "prefereriez": [
        "preferer"
    ],
    "prefererions": [
        "preferer"
    ],
    "prefereront": [
        "preferer"
    ],
    "preferez": [
        "preferer"
    ],
    "preferiez": [
        "preferer"
    ],
    "preferions": [
        "preferer"
    ],
    "preferons": [
        "preferer"
    ],
    "preferames": [
        "preferer"
    ],
    "preferat": [
        "preferer"
    ],
    "prefererent": [
        "preferer"
    ],
    "preferee": [
        "preferer",
        "prefere"
    ],
    "preferees": [
        "preferer",
        "prefere"
    ],
    "pregnance": [
        "pregnance"
    ],
    "pregnante": [
        "pregnant"
    ],
    "prehenseur": [
        "prehenseur"
    ],
    "prehensile": [
        "prehensile"
    ],
    "prehension": [
        "prehension"
    ],
    "prehensives": [
        "prehensif"
    ],
    "prehistoire": [
        "prehistoire"
    ],
    "prehistorien": [
        "prehistorien"
    ],
    "prehistorique": [
        "prehistorique"
    ],
    "prehistoriques": [
        "prehistorique"
    ],
    "prehominien": [
        "prehominien"
    ],
    "preindustriel": [
        "preindustriel"
    ],
    "prejudice": [
        "prejudice"
    ],
    "prejudices": [
        "prejudice"
    ],
    "prejudiciable": [
        "prejudiciable"
    ],
    "prejudiciables": [
        "prejudiciable"
    ],
    "prejuge": [
        "prejuge",
        "prejuger"
    ],
    "prejugeait": [
        "prejuger"
    ],
    "prejugeant": [
        "prejuger"
    ],
    "prejuger": [
        "prejuger"
    ],
    "prejugee": [
        "prejuger"
    ],
    "prejuges": [
        "prejuge",
        "prejuger"
    ],
    "prelassaient": [
        "prelasser"
    ],
    "prelassais": [
        "prelasser"
    ],
    "prelassait": [
        "prelasser"
    ],
    "prelassant": [
        "prelasser"
    ],
    "prelasse": [
        "prelasser"
    ],
    "prelassent": [
        "prelasser"
    ],
    "prelasser": [
        "prelasser"
    ],
    "prelassera": [
        "prelasser"
    ],
    "prelasseront": [
        "prelasser"
    ],
    "prelassez": [
        "prelasser"
    ],
    "prelassiez": [
        "prelasser"
    ],
    "prelasserent": [
        "prelasser"
    ],
    "prelat": [
        "prelat"
    ],
    "prelats": [
        "prelat"
    ],
    "prelavage": [
        "prelavage"
    ],
    "prelaver": [
        "prelaver"
    ],
    "prelegs": [
        "prelegs"
    ],
    "preleva": [
        "prelever"
    ],
    "prelevaient": [
        "prelever"
    ],
    "prelevais": [
        "prelever"
    ],
    "prelevait": [
        "prelever"
    ],
    "prelevant": [
        "prelever"
    ],
    "prelever": [
        "prelever"
    ],
    "prelevez": [
        "prelever"
    ],
    "prelevons": [
        "prelever"
    ],
    "preleverent": [
        "prelever"
    ],
    "preleve": [
        "prelever"
    ],
    "prelevee": [
        "prelever"
    ],
    "prelevees": [
        "prelever"
    ],
    "preleves": [
        "prelever"
    ],
    "preliminaire": [
        "preliminaire"
    ],
    "preliminaires": [
        "preliminaire"
    ],
    "preluda": [
        "preluder"
    ],
    "preludaient": [
        "preluder"
    ],
    "preludait": [
        "preluder"
    ],
    "preludant": [
        "preluder"
    ],
    "prelude": [
        "preluder",
        "prelude"
    ],
    "preludent": [
        "preluder"
    ],
    "preluder": [
        "preluder"
    ],
    "preluderait": [
        "preluder"
    ],
    "preludes": [
        "prelude"
    ],
    "preludat": [
        "preluder"
    ],
    "preluderent": [
        "preluder"
    ],
    "prelevement": [
        "prelevement"
    ],
    "prelevements": [
        "prelevement"
    ],
    "prelevent": [
        "prelever"
    ],
    "preleveraient": [
        "prelever"
    ],
    "preleverait": [
        "prelever"
    ],
    "preleverez": [
        "prelever"
    ],
    "preleverions": [
        "prelever"
    ],
    "prematurite": [
        "prematurite"
    ],
    "premature": [
        "premature"
    ],
    "prematuree": [
        "premature"
    ],
    "prematurees": [
        "premature"
    ],
    "prematurement": [
        "prematurement"
    ],
    "prematures": [
        "premature"
    ],
    "premenstruel": [
        "premenstruel"
    ],
    "premenstruelle": [
        "premenstruel"
    ],
    "premices": [
        "premices"
    ],
    "premisse": [
        "premisse"
    ],
    "premisses": [
        "premiss",
        "premisse"
    ],
    "premolaire": [
        "premolaire"
    ],
    "premolaires": [
        "premolaire"
    ],
    "premonition": [
        "premonition"
    ],
    "premonitions": [
        "premonition"
    ],
    "premonitoire": [
        "premonitoire"
    ],
    "premonitoires": [
        "premonitoire"
    ],
    "premontres": [
        "premontre"
    ],
    "premuni": [
        "premunir"
    ],
    "premunie": [
        "premunir"
    ],
    "premunir": [
        "premunir"
    ],
    "premuniraient": [
        "premunir"
    ],
    "premunis": [
        "premunir"
    ],
    "premunissent": [
        "premunir"
    ],
    "premeditait": [
        "premediter"
    ],
    "premeditation": [
        "premeditation"
    ],
    "premeditations": [
        "premeditation"
    ],
    "premedite": [
        "premedite",
        "premediter"
    ],
    "premediter": [
        "premediter"
    ],
    "premeditera": [
        "premediter"
    ],
    "premeditons": [
        "premediter"
    ],
    "premeditee": [
        "premedite",
        "premediter"
    ],
    "premeditees": [
        "premedite",
        "premediter"
    ],
    "premedites": [
        "premedite",
        "premediter"
    ],
    "prenatal": [
        "prenatal"
    ],
    "prenatale": [
        "prenatal"
    ],
    "prenatales": [
        "prenatal"
    ],
    "prenataux": [
        "prenatal"
    ],
    "prenom": [
        "prenom"
    ],
    "prenomma": [
        "prenommer"
    ],
    "prenommaient": [
        "prenommer"
    ],
    "prenommais": [
        "prenommer"
    ],
    "prenommait": [
        "prenommer"
    ],
    "prenommant": [
        "prenommer"
    ],
    "prenomme": [
        "prenommer",
        "prenomme"
    ],
    "prenomment": [
        "prenommer"
    ],
    "prenommer": [
        "prenommer"
    ],
    "prenommez": [
        "prenommer"
    ],
    "prenommat": [
        "prenommer"
    ],
    "prenommerent": [
        "prenommer"
    ],
    "prenommee": [
        "prenommer",
        "prenomme"
    ],
    "prenoms": [
        "prenom"
    ],
    "prenuptial": [
        "prenuptial"
    ],
    "prenuptiale": [
        "prenuptial"
    ],
    "preoccupa": [
        "preoccuper"
    ],
    "preoccupai": [
        "preoccuper"
    ],
    "preoccupaient": [
        "preoccuper"
    ],
    "preoccupais": [
        "preoccuper"
    ],
    "preoccupait": [
        "preoccuper"
    ],
    "preoccupant": [
        "preoccuper",
        "preoccupant"
    ],
    "preoccupante": [
        "preoccupant"
    ],
    "preoccupantes": [
        "preoccupant"
    ],
    "preoccupation": [
        "preoccupation"
    ],
    "preoccupations": [
        "preoccupation"
    ],
    "preoccupe": [
        "preoccuper",
        "preoccupe"
    ],
    "preoccupent": [
        "preoccuper"
    ],
    "preoccuper": [
        "preoccuper"
    ],
    "preoccupera": [
        "preoccuper"
    ],
    "preoccuperai": [
        "preoccuper"
    ],
    "preoccuperaient": [
        "preoccuper"
    ],
    "preoccuperais": [
        "preoccuper"
    ],
    "preoccuperait": [
        "preoccuper"
    ],
    "preoccupes": [
        "preoccuper",
        "preoccupe"
    ],
    "preoccupez": [
        "preoccuper"
    ],
    "preoccupiez": [
        "preoccuper"
    ],
    "preoccupions": [
        "preoccuper"
    ],
    "preoccupons": [
        "preoccuper"
    ],
    "preoccupat": [
        "preoccuper"
    ],
    "preoccupates": [
        "preoccuper"
    ],
    "preoccuperent": [
        "preoccuper"
    ],
    "preoccupee": [
        "preoccuper",
        "preoccupe"
    ],
    "preoccupees": [
        "preoccuper",
        "preoccupe"
    ],
    "preoperatoire": [
        "preoperatoire"
    ],
    "prepa": [
        "prepa"
    ],
    "prepara": [
        "preparer"
    ],
    "preparai": [
        "preparer"
    ],
    "preparaient": [
        "preparer"
    ],
    "preparais": [
        "preparer"
    ],
    "preparait": [
        "preparer"
    ],
    "preparant": [
        "preparer"
    ],
    "preparateur": [
        "preparateur"
    ],
    "preparateurs": [
        "preparateur"
    ],
    "preparatif": [
        "preparatif"
    ],
    "preparatifs": [
        "preparatif"
    ],
    "preparation": [
        "preparation"
    ],
    "preparations": [
        "preparation"
    ],
    "preparatoire": [
        "preparatoire"
    ],
    "preparatoires": [
        "preparatoire"
    ],
    "preparatrice": [
        "preparateur"
    ],
    "preparatrices": [
        "preparateur"
    ],
    "prepare": [
        "preparer"
    ],
    "preparent": [
        "preparer"
    ],
    "preparer": [
        "preparer"
    ],
    "preparera": [
        "preparer"
    ],
    "preparerai": [
        "preparer"
    ],
    "prepareraient": [
        "preparer"
    ],
    "preparerais": [
        "preparer"
    ],
    "preparerait": [
        "preparer"
    ],
    "prepareras": [
        "preparer"
    ],
    "preparerez": [
        "preparer"
    ],
    "preparerons": [
        "preparer"
    ],
    "prepareront": [
        "preparer"
    ],
    "prepares": [
        "prepare",
        "preparer"
    ],
    "preparez": [
        "preparer"
    ],
    "prepariez": [
        "preparer"
    ],
    "preparions": [
        "preparer"
    ],
    "preparons": [
        "preparer"
    ],
    "preparat": [
        "preparer"
    ],
    "preparerent": [
        "preparer"
    ],
    "preparee": [
        "preparer"
    ],
    "preparees": [
        "preparer"
    ],
    "prepayee": [
        "prepayer"
    ],
    "preponderance": [
        "preponderance"
    ],
    "preponderant": [
        "preponderant"
    ],
    "preponderante": [
        "preponderant"
    ],
    "preponderants": [
        "preponderant"
    ],
    "preposition": [
        "preposition"
    ],
    "prepositions": [
        "preposition"
    ],
    "prepose": [
        "preposer",
        "prepose"
    ],
    "preposee": [
        "preposer",
        "prepose"
    ],
    "preposees": [
        "prepose"
    ],
    "preposes": [
        "preposer",
        "prepose"
    ],
    "prepotence": [
        "prepotence"
    ],
    "preprogramme": [
        "preprogramme"
    ],
    "preprogrammee": [
        "preprogramme"
    ],
    "prepubere": [
        "prepubere"
    ],
    "prepuce": [
        "prepuce"
    ],
    "prepuces": [
        "prepuce"
    ],
    "preraphaelite": [
        "preraphaelite"
    ],
    "prerentree": [
        "prerentree"
    ],
    "preretraite": [
        "preretraite"
    ],
    "prerogative": [
        "prerogative"
    ],
    "prerogatives": [
        "prerogative"
    ],
    "preroman": [
        "preroman"
    ],
    "preregle": [
        "preregler"
    ],
    "prerevolutionnaire": [
        "prerevolutionnaire"
    ],
    "presage": [
        "presage",
        "presager"
    ],
    "presagea": [
        "presager"
    ],
    "presageaient": [
        "presager"
    ],
    "presageait": [
        "presager"
    ],
    "presagent": [
        "presager"
    ],
    "presager": [
        "presager"
    ],
    "presagerait": [
        "presager"
    ],
    "presages": [
        "presage"
    ],
    "prescolaire": [
        "prescolaire"
    ],
    "prescolaires": [
        "prescolaire"
    ],
    "presence": [
        "presence"
    ],
    "presences": [
        "presence"
    ],
    "present": [
        "present"
    ],
    "presenta": [
        "presenter"
    ],
    "presentable": [
        "presentable"
    ],
    "presentables": [
        "presentable"
    ],
    "presentai": [
        "presenter"
    ],
    "presentaient": [
        "presenter"
    ],
    "presentais": [
        "presenter"
    ],
    "presentait": [
        "presenter"
    ],
    "presentant": [
        "presenter"
    ],
    "presentassent": [
        "presenter"
    ],
    "presentateur": [
        "presentateur"
    ],
    "presentateurs": [
        "presentateur"
    ],
    "presentation": [
        "presentation"
    ],
    "presentations": [
        "presentation"
    ],
    "presentatrice": [
        "presentateur"
    ],
    "presentatrices": [
        "presentateur"
    ],
    "presente": [
        "present",
        "presente",
        "presenter"
    ],
    "presentement": [
        "presentement"
    ],
    "presentent": [
        "presenter"
    ],
    "presenter": [
        "poster",
        "presenter"
    ],
    "presentera": [
        "presenter"
    ],
    "presenterai": [
        "presenter"
    ],
    "presenteraient": [
        "presenter"
    ],
    "presenterais": [
        "presenter"
    ],
    "presenterait": [
        "presenter"
    ],
    "presenteras": [
        "presenter"
    ],
    "presenterez": [
        "presenter"
    ],
    "presenteriez": [
        "presenter"
    ],
    "presenterons": [
        "presenter"
    ],
    "presenteront": [
        "presenter"
    ],
    "presentes": [
        "present",
        "presente",
        "presenter"
    ],
    "presentez": [
        "presenter"
    ],
    "presentiez": [
        "presenter"
    ],
    "presentions": [
        "presenter"
    ],
    "presentoir": [
        "presentoir"
    ],
    "presentoirs": [
        "presentoir"
    ],
    "presentons": [
        "presenter"
    ],
    "presents": [
        "present"
    ],
    "presentat": [
        "presenter"
    ],
    "presenterent": [
        "presenter"
    ],
    "presentee": [
        "presenter"
    ],
    "presentees": [
        "presenter"
    ],
    "preserva": [
        "preserver"
    ],
    "preservaient": [
        "preserver"
    ],
    "preservais": [
        "preserver"
    ],
    "preservait": [
        "preserver"
    ],
    "preservant": [
        "preserver"
    ],
    "preservateur": [
        "preservateur"
    ],
    "preservatif": [
        "preservatif"
    ],
    "preservatifs": [
        "preservatif"
    ],
    "preservation": [
        "preservation"
    ],
    "preserve": [
        "preserver"
    ],
    "preservent": [
        "preserver"
    ],
    "preserver": [
        "preserver"
    ],
    "preservera": [
        "preserver"
    ],
    "preserverai": [
        "preserver"
    ],
    "preserverait": [
        "preserver"
    ],
    "preservez": [
        "preserver"
    ],
    "preservons": [
        "preserver"
    ],
    "preservee": [
        "preserver"
    ],
    "preservees": [
        "preserver"
    ],
    "preserves": [
        "preserver",
        "preserve"
    ],
    "presida": [
        "presider"
    ],
    "presidai": [
        "presider"
    ],
    "presidaient": [
        "presider"
    ],
    "presidais": [
        "presider"
    ],
    "presidait": [
        "presider"
    ],
    "presidant": [
        "presider"
    ],
    "preside": [
        "presider",
        "preside"
    ],
    "presidence": [
        "presidence"
    ],
    "presidences": [
        "presidence"
    ],
    "president": [
        "presider",
        "president"
    ],
    "presidente": [
        "president"
    ],
    "presidentes": [
        "president"
    ],
    "presidentiable": [
        "presidentiable"
    ],
    "presidentiables": [
        "presidentiable"
    ],
    "presidentiel": [
        "presidentiel"
    ],
    "presidentielle": [
        "presidentiel"
    ],
    "presidentielles": [
        "presidentiel"
    ],
    "presidentiels": [
        "presidentiel"
    ],
    "presidents": [
        "president"
    ],
    "presider": [
        "presider"
    ],
    "presidera": [
        "presider"
    ],
    "presiderai": [
        "presider"
    ],
    "presiderais": [
        "presider"
    ],
    "presiderait": [
        "presider"
    ],
    "presideras": [
        "presider"
    ],
    "presiderez": [
        "presider"
    ],
    "presides": [
        "presider",
        "preside"
    ],
    "presidiez": [
        "presider"
    ],
    "presidium": [
        "presidium"
    ],
    "presidons": [
        "presider"
    ],
    "presidat": [
        "presider"
    ],
    "presiderent": [
        "presider"
    ],
    "presidee": [
        "presider"
    ],
    "presocratique": [
        "presocratique"
    ],
    "presocratiques": [
        "presocratique"
    ],
    "presomptif": [
        "presomptif"
    ],
    "presomption": [
        "presomption"
    ],
    "presomptions": [
        "presomption"
    ],
    "presomptive": [
        "presomptif"
    ],
    "presomptueuse": [
        "presomptueux"
    ],
    "presomptueuses": [
        "presomptueux"
    ],
    "presomptueux": [
        "presomptueux"
    ],
    "presumables": [
        "presumable"
    ],
    "presumai": [
        "presumer"
    ],
    "presumais": [
        "presumer"
    ],
    "presumait": [
        "presumer"
    ],
    "presumant": [
        "presumer"
    ],
    "presume": [
        "presume",
        "presumer"
    ],
    "presumer": [
        "presumer"
    ],
    "presumerai": [
        "presumer"
    ],
    "presumez": [
        "presumer"
    ],
    "presumons": [
        "presumer"
    ],
    "presumee": [
        "presume",
        "presumer"
    ],
    "presumees": [
        "presume"
    ],
    "presumes": [
        "presume",
        "presumer"
    ],
    "presupposant": [
        "presupposer"
    ],
    "presuppose": [
        "presupposer"
    ],
    "presupposent": [
        "presupposer"
    ],
    "presupposee": [
        "presupposer"
    ],
    "preseance": [
        "preseance"
    ],
    "preseances": [
        "preseance"
    ],
    "preselection": [
        "preselection"
    ],
    "preselectionne": [
        "preselectionner"
    ],
    "preselectionnee": [
        "preselectionner"
    ],
    "preselections": [
        "preselection"
    ],
    "preseniles": [
        "presenile"
    ],
    "pretend": [
        "pretendre"
    ],
    "pretendaient": [
        "pretendre"
    ],
    "pretendais": [
        "pretendre"
    ],
    "pretendait": [
        "pretendre"
    ],
    "pretendant": [
        "pretendant",
        "pretendre"
    ],
    "pretendante": [
        "pretendant"
    ],
    "pretendants": [
        "pretendant"
    ],
    "pretende": [
        "pretendre"
    ],
    "pretendent": [
        "pretendre"
    ],
    "pretendez": [
        "pretendre"
    ],
    "pretendiez": [
        "pretendre"
    ],
    "pretendions": [
        "pretendre"
    ],
    "pretendirent": [
        "pretendre"
    ],
    "pretendis": [
        "pretendre"
    ],
    "pretendissent": [
        "pretendre"
    ],
    "pretendit": [
        "pretendre"
    ],
    "pretendons": [
        "pretendre"
    ],
    "pretendra": [
        "pretendre"
    ],
    "pretendrai": [
        "pretendre"
    ],
    "pretendraient": [
        "pretendre"
    ],
    "pretendrais": [
        "pretendre"
    ],
    "pretendrait": [
        "pretendre"
    ],
    "pretendras": [
        "pretendre"
    ],
    "pretendre": [
        "pretendre"
    ],
    "pretendront": [
        "pretendre"
    ],
    "pretends": [
        "pretend",
        "pretendre"
    ],
    "pretendu": [
        "pretendu",
        "pretendre"
    ],
    "pretendue": [
        "pretendu",
        "pretendre"
    ],
    "pretendues": [
        "pretendu",
        "pretendre"
    ],
    "pretendument": [
        "pretendument"
    ],
    "pretendus": [
        "pretendu",
        "pretendre"
    ],
    "pretentaine": [
        "pretentaine"
    ],
    "pretentiard": [
        "pretentiard"
    ],
    "pretentiarde": [
        "pretentiard"
    ],
    "pretentiards": [
        "pretentiard"
    ],
    "pretentieuse": [
        "pretentieux"
    ],
    "pretentieuses": [
        "pretentieux"
    ],
    "pretentieux": [
        "pretentieux"
    ],
    "pretention": [
        "pretention"
    ],
    "pretentions": [
        "pretention"
    ],
    "preternaturel": [
        "preternaturel"
    ],
    "preteur": [
        "preteur"
    ],
    "preteurs": [
        "preteur"
    ],
    "pretexta": [
        "pretexter"
    ],
    "pretextai": [
        "pretexter"
    ],
    "pretextait": [
        "pretexter"
    ],
    "pretextant": [
        "pretexter"
    ],
    "pretexte": [
        "pretexter",
        "pretexte"
    ],
    "pretextent": [
        "pretexter"
    ],
    "pretexter": [
        "pretexter"
    ],
    "pretextes": [
        "pretexte"
    ],
    "pretoire": [
        "pretoire"
    ],
    "pretoires": [
        "pretoire"
    ],
    "pretorien": [
        "pretorien"
    ],
    "pretorienne": [
        "pretorien"
    ],
    "pretoriennes": [
        "pretorien"
    ],
    "pretoriens": [
        "pretorien"
    ],
    "preture": [
        "preture"
    ],
    "prevalaient": [
        "prevaloir"
    ],
    "prevalait": [
        "prevaloir"
    ],
    "prevalant": [
        "prevaloir"
    ],
    "prevalence": [
        "prevalence"
    ],
    "prevalent": [
        "prevalent",
        "prevaloir"
    ],
    "prevalez": [
        "prevaloir"
    ],
    "prevaloir": [
        "prevaloir"
    ],
    "prevalu": [
        "prevaloir"
    ],
    "prevalut": [
        "prevaloir"
    ],
    "prevaricateur": [
        "prevaricateur"
    ],
    "prevaudra": [
        "prevaloir"
    ],
    "prevaudrait": [
        "prevaloir"
    ],
    "prevaudront": [
        "prevaloir"
    ],
    "prevaut": [
        "prevaloir"
    ],
    "prevenaient": [
        "prevenir"
    ],
    "prevenais": [
        "prevenir"
    ],
    "prevenait": [
        "prevenir"
    ],
    "prevenance": [
        "prevenance"
    ],
    "prevenances": [
        "prevenance"
    ],
    "prevenant": [
        "prevenir",
        "prevenant"
    ],
    "prevenante": [
        "prevenant"
    ],
    "prevenants": [
        "prevenant"
    ],
    "prevenez": [
        "prevenir"
    ],
    "preveniez": [
        "prevenir"
    ],
    "prevenions": [
        "prevenir"
    ],
    "prevenir": [
        "prevenir"
    ],
    "prevenons": [
        "prevenir"
    ],
    "preventif": [
        "preventif"
    ],
    "prevention": [
        "prevention"
    ],
    "preventions": [
        "prevention"
    ],
    "preventive": [
        "preventif"
    ],
    "preventivement": [
        "preventivement"
    ],
    "preventives": [
        "preventif",
        "preventive"
    ],
    "preventorium": [
        "preventorium"
    ],
    "prevenu": [
        "prevenir",
        "prevenu"
    ],
    "prevenue": [
        "prevenir",
        "prevenu"
    ],
    "prevenues": [
        "prevenir",
        "prevenu"
    ],
    "prevenus": [
        "prevenir",
        "prevenu"
    ],
    "previendra": [
        "prevenir"
    ],
    "previendrai": [
        "prevenir"
    ],
    "previendrais": [
        "prevenir"
    ],
    "previendrait": [
        "prevenir"
    ],
    "previendras": [
        "prevenir"
    ],
    "previendrez": [
        "prevenir"
    ],
    "previendrons": [
        "prevenir"
    ],
    "previendront": [
        "prevenir"
    ],
    "previenne": [
        "prevenir"
    ],
    "previennent": [
        "prevenir"
    ],
    "previennes": [
        "prevenir"
    ],
    "previens": [
        "prevenir"
    ],
    "previent": [
        "prevenir"
    ],
    "previns": [
        "prevenir"
    ],
    "prevint": [
        "prevenir"
    ],
    "previs": [
        "previs"
    ],
    "previsibilite": [
        "previsibilite"
    ],
    "previsible": [
        "previsible"
    ],
    "previsibles": [
        "previsible"
    ],
    "prevision": [
        "prevision"
    ],
    "previsionnel": [
        "previsionnel"
    ],
    "previsionnelles": [
        "previsionnel"
    ],
    "previsionnels": [
        "previsionnel"
    ],
    "previsions": [
        "prevision"
    ],
    "previt": [
        "prevoir"
    ],
    "prevoie": [
        "prevoir"
    ],
    "prevoient": [
        "prevoir"
    ],
    "prevoies": [
        "prevoir"
    ],
    "prevoir": [
        "prevoir"
    ],
    "prevoira": [
        "prevoir"
    ],
    "prevoirait": [
        "prevoir"
    ],
    "prevois": [
        "prevoir"
    ],
    "prevoit": [
        "prevoir"
    ],
    "prevoyaient": [
        "prevoir"
    ],
    "prevoyais": [
        "prevoir"
    ],
    "prevoyait": [
        "prevoir"
    ],
    "prevoyance": [
        "prevoyance"
    ],
    "prevoyances": [
        "prevoyance"
    ],
    "prevoyant": [
        "prevoir",
        "prevoyant"
    ],
    "prevoyante": [
        "prevoyant"
    ],
    "prevoyantes": [
        "prevoyant"
    ],
    "prevoyants": [
        "prevoyant"
    ],
    "prevoyez": [
        "prevoir"
    ],
    "prevoyions": [
        "prevoir"
    ],
    "prevoyons": [
        "prevoir"
    ],
    "prevu": [
        "prevoir"
    ],
    "prevue": [
        "prevoir"
    ],
    "prevues": [
        "prevoir"
    ],
    "prevus": [
        "prevoir"
    ],
    "prevot": [
        "prevot"
    ],
    "prevots": [
        "prevot"
    ],
    "prevote": [
        "prevote"
    ],
    "preelectoral": [
        "preelectoral"
    ],
    "preelectorale": [
        "preelectoral"
    ],
    "preeminence": [
        "preeminence"
    ],
    "preeminente": [
        "preeminent"
    ],
    "preetabli": [
        "preetablir",
        "preetabli"
    ],
    "preetablie": [
        "preetablir",
        "preetabli"
    ],
    "preetablies": [
        "preetabli"
    ],
    "preetablis": [
        "preetabli"
    ],
    "precha": [
        "precher"
    ],
    "prechaient": [
        "precher"
    ],
    "prechais": [
        "precher"
    ],
    "prechait": [
        "precher"
    ],
    "prechant": [
        "precher"
    ],
    "preche": [
        "preche",
        "precher"
    ],
    "prechent": [
        "precher"
    ],
    "precher": [
        "precher"
    ],
    "preches": [
        "preche",
        "precher"
    ],
    "precheur": [
        "precheur"
    ],
    "precheurs": [
        "precheur"
    ],
    "precheuse": [
        "precheur"
    ],
    "prechez": [
        "precher"
    ],
    "prechee": [
        "precher"
    ],
    "preles": [
        "prele"
    ],
    "pret": [
        "pret"
    ],
    "preta": [
        "preter"
    ],
    "pretai": [
        "preter"
    ],
    "pretaient": [
        "preter"
    ],
    "pretais": [
        "preter"
    ],
    "pretait": [
        "preter"
    ],
    "pretant": [
        "preter"
    ],
    "pretassent": [
        "preter"
    ],
    "prete": [
        "pret",
        "prete",
        "preter"
    ],
    "pretent": [
        "preter"
    ],
    "preter": [
        "preter"
    ],
    "pretera": [
        "preter"
    ],
    "preterai": [
        "preter"
    ],
    "preteraient": [
        "preter"
    ],
    "preterais": [
        "preter"
    ],
    "preterait": [
        "preter"
    ],
    "preteras": [
        "preter"
    ],
    "preterez": [
        "preter"
    ],
    "preteriez": [
        "preter"
    ],
    "preterions": [
        "preter"
    ],
    "preterons": [
        "preter"
    ],
    "preteront": [
        "preter"
    ],
    "pretes": [
        "pret",
        "prete",
        "preter"
    ],
    "preteuse": [
        "preteur"
    ],
    "pretez": [
        "preter"
    ],
    "pretiez": [
        "preter"
    ],
    "pretions": [
        "preter"
    ],
    "pretons": [
        "preter"
    ],
    "pretraille": [
        "pretraille"
    ],
    "pretre": [
        "pretre"
    ],
    "pretres": [
        "pretre"
    ],
    "pretresse": [
        "pretre"
    ],
    "pretresses": [
        "pretre"
    ],
    "pretrise": [
        "pretrise"
    ],
    "prets": [
        "pret"
    ],
    "pretames": [
        "preter"
    ],
    "pretat": [
        "preter"
    ],
    "preterent": [
        "preter"
    ],
    "pretee": [
        "prete",
        "preter"
    ],
    "pretees": [
        "prete",
        "preter"
    ],
    "pronais": [
        "proner"
    ],
    "pronait": [
        "proner"
    ],
    "pronant": [
        "proner"
    ],
    "prone": [
        "prone",
        "proner"
    ],
    "pronent": [
        "proner"
    ],
    "proner": [
        "proner"
    ],
    "pronera": [
        "proner"
    ],
    "pronerez": [
        "proner"
    ],
    "prones": [
        "prone",
        "proner"
    ],
    "proneur": [
        "proneur"
    ],
    "pronez": [
        "proner"
    ],
    "pronons": [
        "proner"
    ],
    "pronee": [
        "proner"
    ],
    "pronees": [
        "proner"
    ],
    "psalliotes": [
        "psalliote"
    ],
    "psalmiste": [
        "psalmiste"
    ],
    "psalmodia": [
        "psalmodier"
    ],
    "psalmodiaient": [
        "psalmodier"
    ],
    "psalmodiais": [
        "psalmodier"
    ],
    "psalmodiait": [
        "psalmodier"
    ],
    "psalmodiant": [
        "psalmodier"
    ],
    "psalmodie": [
        "psalmodie",
        "psalmodier"
    ],
    "psalmodient": [
        "psalmodier"
    ],
    "psalmodier": [
        "psalmodier"
    ],
    "psalmodies": [
        "psalmodie",
        "psalmodier"
    ],
    "psaume": [
        "psaume"
    ],
    "psaumes": [
        "psaume"
    ],
    "psautier": [
        "psautier"
    ],
    "pschent": [
        "pschent"
    ],
    "pschitt": [
        "pschitt"
    ],
    "pseudo": [
        "pseudo"
    ],
    "pseudobulbaire": [
        "pseudobulbaire"
    ],
    "pseudomonas": [
        "pseudomonas"
    ],
    "pseudonyme": [
        "pseudonyme"
    ],
    "pseudonymes": [
        "pseudonyme"
    ],
    "pseudopodes": [
        "pseudopode"
    ],
    "pseudos": [
        "pseudo"
    ],
    "psi": [
        "psi"
    ],
    "psilocybine": [
        "psilocybine"
    ],
    "psitt": [
        "psitt"
    ],
    "psittacose": [
        "psittacose"
    ],
    "psoriasis": [
        "psoriasis"
    ],
    "pst": [
        "pst"
    ],
    "psy": [
        "psy"
    ],
    "psychanalyse": [
        "psychanalyse",
        "psychanalyser"
    ],
    "psychanalyser": [
        "psychanalyser"
    ],
    "psychanalyserai": [
        "psychanalyser"
    ],
    "psychanalyses": [
        "psychanalyse",
        "psychanalyser"
    ],
    "psychanalyste": [
        "psychanalyste"
    ],
    "psychanalystes": [
        "psychanalyste"
    ],
    "psychanalytique": [
        "psychanalytique"
    ],
    "psychanalytiques": [
        "psychanalytique"
    ],
    "psychastheniques": [
        "psychasthenique"
    ],
    "psychiatre": [
        "psychiatre"
    ],
    "psychiatres": [
        "psychiatre"
    ],
    "psychiatrie": [
        "psychiatrie"
    ],
    "psychiatrique": [
        "psychiatrique"
    ],
    "psychiatriques": [
        "psychiatrique"
    ],
    "psychique": [
        "psychique"
    ],
    "psychiquement": [
        "psychiquement"
    ],
    "psychiques": [
        "psychique"
    ],
    "psychisme": [
        "psychisme"
    ],
    "psychismes": [
        "psychisme"
    ],
    "psycho": [
        "psycho"
    ],
    "psychochirurgie": [
        "psychochirurgie"
    ],
    "psychodrame": [
        "psychodrame"
    ],
    "psychodysleptique": [
        "psychodysleptique"
    ],
    "psychogene": [
        "psychogene"
    ],
    "psychogenes": [
        "psychogene"
    ],
    "psychokinesie": [
        "psychokinesie"
    ],
    "psycholinguistes": [
        "psycholinguiste"
    ],
    "psycholinguistique": [
        "psycholinguistique"
    ],
    "psychologie": [
        "psychologie"
    ],
    "psychologies": [
        "psychologie",
        "psychology"
    ],
    "psychologique": [
        "psychologique"
    ],
    "psychologiquement": [
        "psychologiquement"
    ],
    "psychologiques": [
        "psychologique"
    ],
    "psychologisation": [
        "psychologisation"
    ],
    "psychologue": [
        "psychologue"
    ],
    "psychologues": [
        "psychologue"
    ],
    "psychomotrice": [
        "psychomoteur"
    ],
    "psychometrique": [
        "psychometrique"
    ],
    "psychonevrose": [
        "psychonevrose"
    ],
    "psychopathe": [
        "psychopathe"
    ],
    "psychopathes": [
        "psychopathe"
    ],
    "psychopathie": [
        "psychopathie"
    ],
    "psychopathique": [
        "psychopathique"
    ],
    "psychopathologie": [
        "psychopathologie"
    ],
    "psychopathologique": [
        "psychopathologique"
    ],
    "psychopharmacologie": [
        "psychopharmacologie"
    ],
    "psychophysiologie": [
        "psychophysiologie"
    ],
    "psychophysiologique": [
        "psychophysiologique"
    ],
    "psychorigide": [
        "psychorigide"
    ],
    "psychose": [
        "psychose"
    ],
    "psychosexuel": [
        "psychosexuel"
    ],
    "psychosociologie": [
        "psychosociologie"
    ],
    "psychosociologue": [
        "psychosociologue"
    ],
    "psychosomaticien": [
        "psychosomaticien"
    ],
    "psychosomatique": [
        "psychosomatique"
    ],
    "psychosomatiques": [
        "psychosomatique"
    ],
    "psychotechnicien": [
        "psychotechnicien"
    ],
    "psychotechniciens": [
        "psychotechnicien"
    ],
    "psychotechnique": [
        "psychotechnique"
    ],
    "psychotherapeute": [
        "psychotherapeute"
    ],
    "psychotherapie": [
        "psychotherapie"
    ],
    "psychotique": [
        "psychotique"
    ],
    "psychotiques": [
        "psychotique"
    ],
    "psychotoniques": [
        "psychotonique"
    ],
    "psychotrope": [
        "psychotrope"
    ],
    "psychotropes": [
        "psychotrope"
    ],
    "psyche": [
        "psyche"
    ],
    "psychedelique": [
        "psychedelique"
    ],
    "psychedeliques": [
        "psychedelique"
    ],
    "psyches": [
        "psyche"
    ],
    "psyllium": [
        "psyllium"
    ],
    "psys": [
        "psy"
    ],
    "ptosis": [
        "ptosis"
    ],
    "ptyx": [
        "ptyx"
    ],
    "pterodactyle": [
        "pterodactyle"
    ],
    "pterodactyles": [
        "pterodactyle"
    ],
    "pu": [
        "pouvoir"
    ],
    "pua": [
        "puer"
    ],
    "puaient": [
        "puer"
    ],
    "puais": [
        "puer"
    ],
    "puait": [
        "puer"
    ],
    "puant": [
        "puer",
        "puant"
    ],
    "puante": [
        "puant"
    ],
    "puantes": [
        "puant"
    ],
    "puanteur": [
        "puanteur"
    ],
    "puanteurs": [
        "puanteur"
    ],
    "puants": [
        "puant"
    ],
    "pub": [
        "pub"
    ],
    "pubertaire": [
        "pubertaire"
    ],
    "pubertaires": [
        "pubertaire"
    ],
    "puberte": [
        "puberte"
    ],
    "pubescentes": [
        "pubescent"
    ],
    "pubien": [
        "pubien"
    ],
    "pubienne": [
        "pubien"
    ],
    "pubiennes": [
        "pubien"
    ],
    "pubiens": [
        "pubien"
    ],
    "pubis": [
        "pubis"
    ],
    "publia": [
        "publier"
    ],
    "publiable": [
        "publiable"
    ],
    "publiables": [
        "publiable"
    ],
    "publiai": [
        "publier"
    ],
    "publiaient": [
        "publier"
    ],
    "publiais": [
        "publier"
    ],
    "publiait": [
        "publier"
    ],
    "publiant": [
        "publier"
    ],
    "public": [
        "public"
    ],
    "publicain": [
        "publicain"
    ],
    "publicains": [
        "publicain"
    ],
    "publication": [
        "publication"
    ],
    "publications": [
        "publication"
    ],
    "publiciste": [
        "publiciste"
    ],
    "publicistes": [
        "publiciste"
    ],
    "publicitaire": [
        "publicitaire"
    ],
    "publicitairement": [
        "publicitairement"
    ],
    "publicitaires": [
        "publicitaire"
    ],
    "publicite": [
        "publicite"
    ],
    "publicites": [
        "publicite"
    ],
    "publico": [
        "publico"
    ],
    "publics": [
        "public"
    ],
    "publie": [
        "publier"
    ],
    "publient": [
        "publier"
    ],
    "publier": [
        "publier"
    ],
    "publiera": [
        "publier"
    ],
    "publierai": [
        "publier"
    ],
    "publieraient": [
        "publier"
    ],
    "publierais": [
        "publier"
    ],
    "publierait": [
        "publier"
    ],
    "publierez": [
        "publier"
    ],
    "publierions": [
        "publier"
    ],
    "publierons": [
        "publier"
    ],
    "publieront": [
        "publier"
    ],
    "publies": [
        "publier"
    ],
    "publieur": [
        "publieur"
    ],
    "publiez": [
        "publier"
    ],
    "publions": [
        "publier"
    ],
    "publiphone": [
        "publiphone"
    ],
    "publique": [
        "public"
    ],
    "publiquement": [
        "publiquement"
    ],
    "publiques": [
        "public"
    ],
    "publireportage": [
        "publireportage"
    ],
    "publiat": [
        "publier"
    ],
    "publierent": [
        "publier"
    ],
    "publiee": [
        "publier"
    ],
    "publiees": [
        "publier"
    ],
    "pubs": [
        "pub"
    ],
    "pubere": [
        "pubere"
    ],
    "puberes": [
        "pubere"
    ],
    "puce": [
        "puce"
    ],
    "puceau": [
        "puceau"
    ],
    "puceaux": [
        "puceau"
    ],
    "pucelage": [
        "pucelage"
    ],
    "pucelages": [
        "pucelage"
    ],
    "pucelle": [
        "puceau"
    ],
    "pucelles": [
        "puceau"
    ],
    "puceron": [
        "puceron"
    ],
    "pucerons": [
        "puceron"
    ],
    "puces": [
        "puce"
    ],
    "pucher": [
        "pucher"
    ],
    "pucheux": [
        "pucheux"
    ],
    "pucier": [
        "pucier"
    ],
    "puciers": [
        "pucier"
    ],
    "pudding": [
        "pudding"
    ],
    "puddings": [
        "pudding"
    ],
    "puddle": [
        "puddler"
    ],
    "pudeur": [
        "pudeur"
    ],
    "pudeurs": [
        "pudeur"
    ],
    "pudibond": [
        "pudibond"
    ],
    "pudibonde": [
        "pudibond"
    ],
    "pudibonderie": [
        "pudibonderie"
    ],
    "pudibonderies": [
        "pudibonderie"
    ],
    "pudibondes": [
        "pudibond"
    ],
    "pudibonds": [
        "pudibond"
    ],
    "pudicite": [
        "pudicite"
    ],
    "pudique": [
        "pudique"
    ],
    "pudiquement": [
        "pudiquement"
    ],
    "pudiques": [
        "pudique"
    ],
    "pue": [
        "puer"
    ],
    "pueblo": [
        "pueblo"
    ],
    "puent": [
        "puer"
    ],
    "puer": [
        "puer"
    ],
    "puera": [
        "puer"
    ],
    "puerait": [
        "puer"
    ],
    "pueras": [
        "puer"
    ],
    "puerez": [
        "puer"
    ],
    "puerperale": [
        "puerperal"
    ],
    "pues": [
        "puer"
    ],
    "puez": [
        "puer"
    ],
    "puff": [
        "puff"
    ],
    "puffin": [
        "puffin"
    ],
    "pugilat": [
        "pugilat"
    ],
    "pugilats": [
        "pugilat"
    ],
    "pugiler": [
        "pugiler"
    ],
    "pugiliste": [
        "pugiliste"
    ],
    "pugilistes": [
        "pugiliste"
    ],
    "pugilistique": [
        "pugilistique"
    ],
    "pugnace": [
        "pugnace"
    ],
    "pugnacite": [
        "pugnacite"
    ],
    "puis": [
        "puis",
        "pouvoir"
    ],
    "puisa": [
        "puiser"
    ],
    "puisai": [
        "puiser"
    ],
    "puisaient": [
        "puiser"
    ],
    "puisais": [
        "puiser"
    ],
    "puisait": [
        "puiser"
    ],
    "puisant": [
        "puiser"
    ],
    "puisard": [
        "puisard"
    ],
    "puisards": [
        "puisard"
    ],
    "puisatier": [
        "puisatier"
    ],
    "puise": [
        "puiser"
    ],
    "puisent": [
        "puiser"
    ],
    "puiser": [
        "puiser"
    ],
    "puisera": [
        "puiser"
    ],
    "puiserai": [
        "puiser"
    ],
    "puiserait": [
        "puiser"
    ],
    "puiserez": [
        "puiser"
    ],
    "puiseront": [
        "puiser"
    ],
    "puises": [
        "puiser"
    ],
    "puisette": [
        "puisette"
    ],
    "puisez": [
        "puiser"
    ],
    "puisions": [
        "puiser"
    ],
    "puisons": [
        "puiser"
    ],
    "puisqu": [
        "puisqu"
    ],
    "puisque": [
        "puisque"
    ],
    "puissamment": [
        "puissamment"
    ],
    "puissance": [
        "puissance"
    ],
    "puissances": [
        "puissance"
    ],
    "puissant": [
        "puissant"
    ],
    "puissante": [
        "puissant"
    ],
    "puissantes": [
        "puissant"
    ],
    "puissants": [
        "puissant"
    ],
    "puisse": [
        "pouvoir"
    ],
    "puissent": [
        "pouvoir"
    ],
    "puisses": [
        "pouvoir"
    ],
    "puissiez": [
        "pouvoir"
    ],
    "puissions": [
        "pouvoir"
    ],
    "puisee": [
        "puiser"
    ],
    "puisees": [
        "puiser"
    ],
    "puits": [
        "puits"
    ],
    "pull": [
        "pull"
    ],
    "pullman": [
        "pullman"
    ],
    "pullmans": [
        "pullman"
    ],
    "pulls": [
        "pull"
    ],
    "pullula": [
        "pulluler"
    ],
    "pullulaient": [
        "pulluler"
    ],
    "pullulait": [
        "pulluler"
    ],
    "pullulant": [
        "pulluler"
    ],
    "pullulantes": [
        "pullulant"
    ],
    "pullulants": [
        "pullulant"
    ],
    "pullule": [
        "pulluler"
    ],
    "pullulement": [
        "pullulement"
    ],
    "pullulent": [
        "pulluler"
    ],
    "pulluler": [
        "pulluler"
    ],
    "pulluleront": [
        "pulluler"
    ],
    "pulmonaire": [
        "pulmonaire"
    ],
    "pulmonaires": [
        "pulmonaire"
    ],
    "pulmonie": [
        "pulmonie"
    ],
    "pulmonique": [
        "pulmonique"
    ],
    "pulpe": [
        "pulpe"
    ],
    "pulpes": [
        "pulpe"
    ],
    "pulpeuse": [
        "pulpeux"
    ],
    "pulpeuses": [
        "pulpeux"
    ],
    "pulpeux": [
        "pulpeux"
    ],
    "pulque": [
        "pulque"
    ],
    "pulsait": [
        "pulser"
    ],
    "pulsant": [
        "pulser"
    ],
    "pulsar": [
        "pulsar"
    ],
    "pulsatile": [
        "pulsatile"
    ],
    "pulsation": [
        "pulsation"
    ],
    "pulsations": [
        "pulsation"
    ],
    "pulsative": [
        "pulsatif"
    ],
    "pulse": [
        "pulser"
    ],
    "pulser": [
        "pulser"
    ],
    "pulseur": [
        "pulseur"
    ],
    "pulsion": [
        "pulsion"
    ],
    "pulsions": [
        "pulsion"
    ],
    "pulsoreacteurs": [
        "pulsoreacteur"
    ],
    "pulverin": [
        "pulverin"
    ],
    "pulverisa": [
        "pulveriser"
    ],
    "pulverisaient": [
        "pulveriser"
    ],
    "pulverisais": [
        "pulveriser"
    ],
    "pulverisait": [
        "pulveriser"
    ],
    "pulverisant": [
        "pulveriser"
    ],
    "pulverisateur": [
        "pulverisateur"
    ],
    "pulverisateurs": [
        "pulverisateur"
    ],
    "pulverisation": [
        "pulverisation"
    ],
    "pulverisations": [
        "pulverisation"
    ],
    "pulverise": [
        "pulveriser"
    ],
    "pulverisent": [
        "pulveriser"
    ],
    "pulveriser": [
        "pulveriser"
    ],
    "pulveriserai": [
        "pulveriser"
    ],
    "pulveriserait": [
        "pulveriser"
    ],
    "pulveriserons": [
        "pulveriser"
    ],
    "pulveriseront": [
        "pulveriser"
    ],
    "pulverises": [
        "pulveriser"
    ],
    "pulverisez": [
        "pulveriser"
    ],
    "pulverisee": [
        "pulveriser"
    ],
    "pulverisees": [
        "pulveriser"
    ],
    "pulverulence": [
        "pulverulence"
    ],
    "pulverulentes": [
        "pulverulent"
    ],
    "puma": [
        "puma"
    ],
    "pumas": [
        "puma"
    ],
    "punais": [
        "punais"
    ],
    "punaisait": [
        "punaiser"
    ],
    "punaise": [
        "punaiser",
        "punaise"
    ],
    "punaises": [
        "punaiser",
        "punaise"
    ],
    "punaisee": [
        "punaiser"
    ],
    "punaisees": [
        "punaiser"
    ],
    "punch": [
        "punch"
    ],
    "puncheur": [
        "puncheur"
    ],
    "punchs": [
        "punch"
    ],
    "punctiforme": [
        "punctiforme"
    ],
    "puncture": [
        "puncture"
    ],
    "puni": [
        "puni",
        "punir"
    ],
    "punie": [
        "puni",
        "punir"
    ],
    "punies": [
        "puni",
        "punir"
    ],
    "punique": [
        "punique"
    ],
    "puniques": [
        "punique"
    ],
    "punir": [
        "punir"
    ],
    "punira": [
        "punir"
    ],
    "punirai": [
        "punir"
    ],
    "punirais": [
        "punir"
    ],
    "punirait": [
        "punir"
    ],
    "puniras": [
        "punir"
    ],
    "punirez": [
        "punir"
    ],
    "punirons": [
        "punir"
    ],
    "puniront": [
        "punir"
    ],
    "punis": [
        "puni",
        "punir"
    ],
    "punissable": [
        "punissable"
    ],
    "punissables": [
        "punissable"
    ],
    "punissaient": [
        "punir"
    ],
    "punissais": [
        "punir"
    ],
    "punissait": [
        "punir"
    ],
    "punissant": [
        "punir"
    ],
    "punisse": [
        "punir"
    ],
    "punissent": [
        "punir"
    ],
    "punisses": [
        "punir"
    ],
    "punisseur": [
        "punisseur"
    ],
    "punissez": [
        "punir"
    ],
    "punissions": [
        "punir"
    ],
    "punissons": [
        "punir"
    ],
    "punit": [
        "punir"
    ],
    "punitif": [
        "punitif"
    ],
    "punition": [
        "punition"
    ],
    "punitions": [
        "punition"
    ],
    "punitive": [
        "punitif"
    ],
    "punitives": [
        "punitif"
    ],
    "punk": [
        "punk"
    ],
    "punkette": [
        "punkette"
    ],
    "punks": [
        "punk"
    ],
    "punt": [
        "punt"
    ],
    "pupazzo": [
        "pupazzo"
    ],
    "pupe": [
        "pupe"
    ],
    "pupillaire": [
        "pupillaire"
    ],
    "pupillaires": [
        "pupillaire"
    ],
    "pupille": [
        "pupille"
    ],
    "pupilles": [
        "pupille"
    ],
    "pupitre": [
        "pupitre"
    ],
    "pupitres": [
        "pupitre"
    ],
    "pupitreur": [
        "pupitreur"
    ],
    "pur": [
        "pur"
    ],
    "pure": [
        "pur"
    ],
    "pureau": [
        "pureau"
    ],
    "purement": [
        "purement"
    ],
    "purent": [
        "pouvoir"
    ],
    "pures": [
        "pur"
    ],
    "purete": [
        "purete"
    ],
    "puretes": [
        "purete"
    ],
    "purgatif": [
        "purgatif"
    ],
    "purgation": [
        "purgation"
    ],
    "purgations": [
        "purgation"
    ],
    "purgative": [
        "purgatif"
    ],
    "purgatoire": [
        "purgatoire"
    ],
    "purgatoires": [
        "purgatoire"
    ],
    "purge": [
        "purger",
        "purge"
    ],
    "purgea": [
        "purger"
    ],
    "purgeaient": [
        "purger"
    ],
    "purgeais": [
        "purger"
    ],
    "purgeait": [
        "purger"
    ],
    "purgeant": [
        "purger"
    ],
    "purgent": [
        "purger"
    ],
    "purger": [
        "purger"
    ],
    "purgera": [
        "purger"
    ],
    "purgerai": [
        "purger"
    ],
    "purgerais": [
        "purger"
    ],
    "purgeras": [
        "purger"
    ],
    "purgerez": [
        "purger"
    ],
    "purgeriez": [
        "purger"
    ],
    "purges": [
        "purger",
        "purge"
    ],
    "purgez": [
        "purger"
    ],
    "purgiez": [
        "purger"
    ],
    "purgee": [
        "purger"
    ],
    "purgees": [
        "purger"
    ],
    "purifiaient": [
        "purifier"
    ],
    "purifiais": [
        "purifier"
    ],
    "purifiait": [
        "purifier"
    ],
    "purifiant": [
        "purifier",
        "purifiant"
    ],
    "purificateur": [
        "purificateur"
    ],
    "purificateurs": [
        "purificateur"
    ],
    "purification": [
        "purification"
    ],
    "purifications": [
        "purification"
    ],
    "purificatoire": [
        "purificatoire"
    ],
    "purificatrice": [
        "purificateur"
    ],
    "purificatrices": [
        "purificateur"
    ],
    "purifie": [
        "purifier"
    ],
    "purifient": [
        "purifier"
    ],
    "purifier": [
        "purifier"
    ],
    "purifiera": [
        "purifier"
    ],
    "purifiez": [
        "purifier"
    ],
    "purifions": [
        "purifier"
    ],
    "purifiat": [
        "purifier"
    ],
    "purifiee": [
        "purifier"
    ],
    "purifiees": [
        "purifier"
    ],
    "purifies": [
        "purifier",
        "purify"
    ],
    "purin": [
        "purin"
    ],
    "puriste": [
        "puriste"
    ],
    "puristes": [
        "puriste"
    ],
    "puritain": [
        "puritain"
    ],
    "puritaine": [
        "puritain"
    ],
    "puritaines": [
        "puritain"
    ],
    "puritains": [
        "puritain"
    ],
    "puritanisme": [
        "puritanisme"
    ],
    "purotin": [
        "purotin"
    ],
    "purotins": [
        "purotin"
    ],
    "purpura": [
        "purpura"
    ],
    "purpurin": [
        "purpurin"
    ],
    "purpurine": [
        "purpurin"
    ],
    "purpurines": [
        "purpurin"
    ],
    "purpurins": [
        "purpurin"
    ],
    "purs": [
        "pur"
    ],
    "purulence": [
        "purulence"
    ],
    "purulences": [
        "purulence"
    ],
    "purulent": [
        "purulent"
    ],
    "purulente": [
        "purulent"
    ],
    "purulentes": [
        "purulent"
    ],
    "purulents": [
        "purulent"
    ],
    "puree": [
        "puree"
    ],
    "purees": [
        "puree"
    ],
    "pus": [
        "pouvoir",
        "pus"
    ],
    "pusillanime": [
        "pusillanime"
    ],
    "pusillanimes": [
        "pusillanime"
    ],
    "pusillanimite": [
        "pusillanimite"
    ],
    "pusse": [
        "pouvoir"
    ],
    "pussent": [
        "pouvoir"
    ],
    "pusses": [
        "pouvoir"
    ],
    "pussiez": [
        "pouvoir"
    ],
    "pustule": [
        "pustule"
    ],
    "pustules": [
        "pustule"
    ],
    "pustuleuse": [
        "pustuleux"
    ],
    "pustuleux": [
        "pustuleux"
    ],
    "put": [
        "pouvoir"
    ],
    "putain": [
        "putain"
    ],
    "putains": [
        "putain"
    ],
    "putanat": [
        "putanat"
    ],
    "putasse": [
        "putasser"
    ],
    "putasserie": [
        "putasserie"
    ],
    "putasseries": [
        "putasserie"
    ],
    "putasses": [
        "putasser"
    ],
    "putassier": [
        "putassier"
    ],
    "putassiers": [
        "putassier"
    ],
    "putassiere": [
        "putassier"
    ],
    "putassieres": [
        "putassier"
    ],
    "putatif": [
        "putatif"
    ],
    "putatifs": [
        "putatif"
    ],
    "putative": [
        "putatif"
    ],
    "pute": [
        "pute"
    ],
    "putes": [
        "pouvoir",
        "pute"
    ],
    "putier": [
        "putier"
    ],
    "putois": [
        "putois"
    ],
    "putrescence": [
        "putrescence"
    ],
    "putrescences": [
        "putrescence"
    ],
    "putrescent": [
        "putrescent"
    ],
    "putrescents": [
        "putrescent"
    ],
    "putrescible": [
        "putrescible"
    ],
    "putrescine": [
        "putrescine"
    ],
    "putride": [
        "putride"
    ],
    "putrides": [
        "putride"
    ],
    "putrefaction": [
        "putrefaction"
    ],
    "putrefiaient": [
        "putrefier"
    ],
    "putrefiait": [
        "putrefier"
    ],
    "putrefiant": [
        "putrefier"
    ],
    "putrefient": [
        "putrefier"
    ],
    "putrefier": [
        "putrefier"
    ],
    "putrefie": [
        "putrefier"
    ],
    "putrefiee": [
        "putrefier"
    ],
    "putrefiees": [
        "putrefier"
    ],
    "putrefies": [
        "putrefier"
    ],
    "putsch": [
        "putsch"
    ],
    "putschiste": [
        "putschiste"
    ],
    "putt": [
        "putt"
    ],
    "putter": [
        "putter"
    ],
    "putti": [
        "putto"
    ],
    "putting": [
        "putt",
        "putting",
        "put"
    ],
    "puy": [
        "puy"
    ],
    "puzzle": [
        "puzzle"
    ],
    "puzzles": [
        "puzzle"
    ],
    "puericultrice": [
        "puericulteur"
    ],
    "puericultrices": [
        "puericulteur"
    ],
    "puericulture": [
        "puericulture"
    ],
    "pueril": [
        "pueril"
    ],
    "puerile": [
        "pueril"
    ],
    "puerilement": [
        "puerilement"
    ],
    "pueriles": [
        "pueril"
    ],
    "puerilite": [
        "puerilite"
    ],
    "puerilites": [
        "puerilite"
    ],
    "puerils": [
        "pueril"
    ],
    "puine": [
        "puine"
    ],
    "puinee": [
        "puine"
    ],
    "puines": [
        "puine"
    ],
    "pygmee": [
        "pygmee"
    ],
    "pygmees": [
        "pygmee"
    ],
    "pyjama": [
        "pyjamas",
        "pyjama"
    ],
    "pyjamas": [
        "pyjama"
    ],
    "pylore": [
        "pylore"
    ],
    "pylorique": [
        "pylorique"
    ],
    "pylone": [
        "pylone"
    ],
    "pylones": [
        "pylone"
    ],
    "pyogene": [
        "pyogene"
    ],
    "pyralene": [
        "pyralene"
    ],
    "pyrame": [
        "pyrame"
    ],
    "pyramidal": [
        "pyramidal"
    ],
    "pyramidale": [
        "pyramidal"
    ],
    "pyramidalement": [
        "pyramidalement"
    ],
    "pyramidales": [
        "pyramidal"
    ],
    "pyramidaux": [
        "pyramidal"
    ],
    "pyramide": [
        "pyramide"
    ],
    "pyramides": [
        "pyramide"
    ],
    "pyrex": [
        "pyrex"
    ],
    "pyrexie": [
        "pyrexie"
    ],
    "pyridoxine": [
        "pyridoxine"
    ],
    "pyrite": [
        "pyrite"
    ],
    "pyrites": [
        "pyrite"
    ],
    "pyroclastique": [
        "pyroclastique"
    ],
    "pyroclastiques": [
        "pyroclastique"
    ],
    "pyrogravees": [
        "pyrograver"
    ],
    "pyrogene": [
        "pyrogene"
    ],
    "pyrolyse": [
        "pyrolyse"
    ],
    "pyromane": [
        "pyromane"
    ],
    "pyromanes": [
        "pyromane"
    ],
    "pyromanie": [
        "pyromanie"
    ],
    "pyrometre": [
        "pyrometre"
    ],
    "pyrosphere": [
        "pyrosphere"
    ],
    "pyrotechnicien": [
        "pyrotechnicien"
    ],
    "pyrotechnie": [
        "pyrotechnie"
    ],
    "pyrotechnique": [
        "pyrotechnique"
    ],
    "pyroxene": [
        "pyroxene"
    ],
    "pyrrhique": [
        "pyrrhique"
    ],
    "pyrrhonien": [
        "pyrrhonien"
    ],
    "pyrrhonisme": [
        "pyrrhonisme"
    ],
    "pyrethre": [
        "pyrethre"
    ],
    "pyreneen": [
        "pyreneen"
    ],
    "pyreneenne": [
        "pyreneenne"
    ],
    "pyrethrine": [
        "pyrethrine"
    ],
    "pythagoricien": [
        "pythagoricien"
    ],
    "pythagoriques": [
        "pythagorique"
    ],
    "pythie": [
        "pythie"
    ],
    "pythies": [
        "pythie"
    ],
    "python": [
        "python"
    ],
    "pythonisse": [
        "pythonisse"
    ],
    "pythons": [
        "python"
    ],
    "pyxides": [
        "pyxide"
    ],
    "palement": [
        "palement"
    ],
    "paleur": [
        "paleur"
    ],
    "paleurs": [
        "paleur"
    ],
    "pali": [
        "palir"
    ],
    "palichon": [
        "palichon"
    ],
    "palichonne": [
        "palichon"
    ],
    "palichons": [
        "palichon"
    ],
    "palie": [
        "palir"
    ],
    "palies": [
        "palir"
    ],
    "palir": [
        "palir"
    ],
    "palirait": [
        "palir"
    ],
    "palirent": [
        "palir"
    ],
    "palissaient": [
        "palir"
    ],
    "palissait": [
        "palir"
    ],
    "palissante": [
        "palissant"
    ],
    "palissantes": [
        "palissant"
    ],
    "palissent": [
        "palir"
    ],
    "palissions": [
        "palir"
    ],
    "palit": [
        "palir"
    ],
    "palotte": [
        "palot"
    ],
    "palottes": [
        "palot"
    ],
    "pama": [
        "pamer"
    ],
    "pamaient": [
        "pamer"
    ],
    "pamait": [
        "pamer"
    ],
    "pamant": [
        "pamer"
    ],
    "pame": [
        "pamer"
    ],
    "pament": [
        "pamer"
    ],
    "pamer": [
        "pamer"
    ],
    "pamerais": [
        "pamer"
    ],
    "pamerait": [
        "pamer"
    ],
    "pameront": [
        "pamer"
    ],
    "pamez": [
        "pamer"
    ],
    "pamoison": [
        "pamoison"
    ],
    "pamoisons": [
        "pamoison"
    ],
    "pamerent": [
        "pamer"
    ],
    "pamee": [
        "pamer"
    ],
    "pamees": [
        "pamer"
    ],
    "pames": [
        "pamer"
    ],
    "paque": [
        "paque"
    ],
    "paquerette": [
        "paquerette"
    ],
    "paquerettes": [
        "paquerette"
    ],
    "paques": [
        "paques"
    ],
    "paquis": [
        "paquis"
    ],
    "pate": [
        "pate"
    ],
    "pates": [
        "pate"
    ],
    "pateuse": [
        "pateux"
    ],
    "pateusement": [
        "pateusement"
    ],
    "pateuses": [
        "pateux"
    ],
    "pateux": [
        "pateux"
    ],
    "pati": [
        "patir"
    ],
    "patir": [
        "patir"
    ],
    "patira": [
        "patir"
    ],
    "patiraient": [
        "patir"
    ],
    "patirait": [
        "patir"
    ],
    "patirent": [
        "patir"
    ],
    "patiront": [
        "patir"
    ],
    "patis": [
        "patis",
        "patir"
    ],
    "patissaient": [
        "patisser"
    ],
    "patissais": [
        "patisser"
    ],
    "patissait": [
        "patisser"
    ],
    "patisse": [
        "patisser"
    ],
    "patissent": [
        "patisser"
    ],
    "patisserie": [
        "patisserie"
    ],
    "patisseries": [
        "patisserie"
    ],
    "patisses": [
        "patisser"
    ],
    "patissez": [
        "patisser"
    ],
    "patissier": [
        "patissier"
    ],
    "patissiers": [
        "patissier"
    ],
    "patissiere": [
        "patissier"
    ],
    "patissons": [
        "patir"
    ],
    "patit": [
        "patir"
    ],
    "paton": [
        "paton"
    ],
    "patons": [
        "paton"
    ],
    "patour": [
        "patour"
    ],
    "patre": [
        "patre"
    ],
    "patres": [
        "patre"
    ],
    "paturage": [
        "paturage"
    ],
    "paturages": [
        "paturage"
    ],
    "paturaient": [
        "paturer"
    ],
    "pature": [
        "pature",
        "paturer"
    ],
    "paturent": [
        "paturer"
    ],
    "paturer": [
        "paturer"
    ],
    "patures": [
        "pature"
    ],
    "paturin": [
        "paturin"
    ],
    "patee": [
        "patee"
    ],
    "patees": [
        "patee"
    ],
    "peche": [
        "peche",
        "pecher"
    ],
    "pechent": [
        "pecher"
    ],
    "pegre": [
        "pegre"
    ],
    "pelent": [
        "peler"
    ],
    "pelerai": [
        "peler"
    ],
    "pelerin": [
        "pelerin"
    ],
    "pelerinage": [
        "pelerinage"
    ],
    "pelerinages": [
        "pelerinage"
    ],
    "pelerine": [
        "pelerin"
    ],
    "pelerines": [
        "pelerin"
    ],
    "pelerins": [
        "pelerin"
    ],
    "pere": [
        "pere"
    ],
    "peres": [
        "pere"
    ],
    "pesent": [
        "peser"
    ],
    "pesera": [
        "peser"
    ],
    "peserai": [
        "peser"
    ],
    "peseraient": [
        "peser"
    ],
    "peserais": [
        "peser"
    ],
    "peserait": [
        "peser"
    ],
    "peseras": [
        "peser"
    ],
    "peseront": [
        "peser"
    ],
    "pete": [
        "pete",
        "peter"
    ],
    "petent": [
        "peter"
    ],
    "petes": [
        "pete",
        "peter"
    ],
    "petesec": [
        "petesec"
    ],
    "peze": [
        "peze"
    ],
    "peage": [
        "peage"
    ],
    "peages": [
        "peage"
    ],
    "peagiste": [
        "peagiste"
    ],
    "pean": [
        "pean"
    ],
    "pebroc": [
        "pebroc"
    ],
    "pebroque": [
        "pebroque"
    ],
    "pebroques": [
        "pebroque"
    ],
    "pecan": [
        "pecan"
    ],
    "pecari": [
        "pecari"
    ],
    "pecaris": [
        "pecari"
    ],
    "pechais": [
        "pecher"
    ],
    "pechait": [
        "pecher"
    ],
    "pechant": [
        "pecher"
    ],
    "pecher": [
        "pecher"
    ],
    "pecherai": [
        "pecher"
    ],
    "pecherais": [
        "pecher"
    ],
    "pecherait": [
        "pecher"
    ],
    "pecheresse": [
        "pecheur"
    ],
    "pecheresses": [
        "pecheur"
    ],
    "pecheur": [
        "pecheur"
    ],
    "pecheurs": [
        "pecheur"
    ],
    "pechez": [
        "pecher"
    ],
    "pechons": [
        "pechon"
    ],
    "peches": [
        "peche",
        "pecher"
    ],
    "pecore": [
        "pecore"
    ],
    "pecores": [
        "pecore"
    ],
    "pecule": [
        "pecule"
    ],
    "pecules": [
        "pecule"
    ],
    "pecune": [
        "pecune"
    ],
    "pecuniaire": [
        "pecuniaire"
    ],
    "pecuniairement": [
        "pecuniairement"
    ],
    "pecuniaires": [
        "pecuniaire"
    ],
    "pecunieux": [
        "pecunieux"
    ],
    "pedagogie": [
        "pedagogie"
    ],
    "pedagogique": [
        "pedagogique"
    ],
    "pedagogiques": [
        "pedagogique"
    ],
    "pedagogue": [
        "pedagogue"
    ],
    "pedagogues": [
        "pedagogue"
    ],
    "pedala": [
        "pedaler"
    ],
    "pedalage": [
        "pedalage"
    ],
    "pedalai": [
        "pedaler"
    ],
    "pedalaient": [
        "pedaler"
    ],
    "pedalais": [
        "pedaler"
    ],
    "pedalait": [
        "pedaler"
    ],
    "pedalant": [
        "pedaler"
    ],
    "pedale": [
        "pedaler",
        "pedal",
        "pedale"
    ],
    "pedalent": [
        "pedaler"
    ],
    "pedaler": [
        "pedaler"
    ],
    "pedalerait": [
        "pedaler"
    ],
    "pedalerons": [
        "pedaler"
    ],
    "pedales": [
        "pedaler",
        "pedal",
        "pedale"
    ],
    "pedaleur": [
        "pedaleur"
    ],
    "pedaleuses": [
        "pedaleur"
    ],
    "pedalier": [
        "pedalier"
    ],
    "pedaliers": [
        "pedalier"
    ],
    "pedalo": [
        "pedalo"
    ],
    "pedalos": [
        "pedalo"
    ],
    "pedalerent": [
        "pedaler"
    ],
    "pedalees": [
        "pedaler"
    ],
    "pedant": [
        "pedant"
    ],
    "pedante": [
        "pedant"
    ],
    "pedanterie": [
        "pedanterie"
    ],
    "pedanteries": [
        "pedanterie"
    ],
    "pedantes": [
        "pedant"
    ],
    "pedantesque": [
        "pedantesque"
    ],
    "pedantisme": [
        "pedantisme"
    ],
    "pedants": [
        "pedant"
    ],
    "pedestre": [
        "pedestre"
    ],
    "pedestrement": [
        "pedestrement"
    ],
    "pedestres": [
        "pedestre"
    ],
    "pedezouille": [
        "pedezouille"
    ],
    "pediatre": [
        "pediatre"
    ],
    "pediatres": [
        "pediatre"
    ],
    "pediatrie": [
        "pediatrie"
    ],
    "pediatrique": [
        "pediatrique"
    ],
    "pedibus": [
        "pedibus"
    ],
    "pedicule": [
        "pedicule"
    ],
    "pedicure": [
        "pedicure"
    ],
    "pedicures": [
        "pedicure"
    ],
    "pedicurie": [
        "pedicurie"
    ],
    "pedieuse": [
        "pedieux"
    ],
    "pedieux": [
        "pedieux"
    ],
    "pedologue": [
        "pedologue"
    ],
    "pedometre": [
        "pedometre"
    ],
    "pedoncule": [
        "pedoncule"
    ],
    "pedoncules": [
        "pedoncule"
    ],
    "pedophile": [
        "pedophile"
    ],
    "pedophiles": [
        "pedophile"
    ],
    "pedophilie": [
        "pedophilie"
    ],
    "pedophiliques": [
        "pedophilique"
    ],
    "pedopsychiatre": [
        "pedopsychiatre"
    ],
    "pedoque": [
        "pedoque"
    ],
    "pede": [
        "pede"
    ],
    "pedege": [
        "pedege"
    ],
    "pederaste": [
        "pederaste"
    ],
    "pederastes": [
        "pederaste"
    ],
    "pederastie": [
        "pederastie"
    ],
    "pederastique": [
        "pederastique"
    ],
    "pedes": [
        "pede"
    ],
    "pegamoid": [
        "pegamoid"
    ],
    "pegriot": [
        "pegriot"
    ],
    "pegriots": [
        "pegriot"
    ],
    "pejoratif": [
        "pejoratif"
    ],
    "pejoratifs": [
        "pejoratif"
    ],
    "pejorative": [
        "pejoratif"
    ],
    "pejorativement": [
        "pejorativement"
    ],
    "pejoratives": [
        "pejoratif"
    ],
    "pekan": [
        "pekan"
    ],
    "pekin": [
        "pekin"
    ],
    "pekinois": [
        "pekinois"
    ],
    "pekinoise": [
        "pekinois"
    ],
    "pekins": [
        "pekin"
    ],
    "pelagique": [
        "pelagique"
    ],
    "pelasgiques": [
        "pelasgique"
    ],
    "pelican": [
        "pelican"
    ],
    "pelicans": [
        "pelican"
    ],
    "pelot": [
        "pelot"
    ],
    "penal": [
        "penal"
    ],
    "penale": [
        "penal"
    ],
    "penalement": [
        "penalement"
    ],
    "penales": [
        "penal"
    ],
    "penalisaient": [
        "penaliser"
    ],
    "penalisation": [
        "penalisation"
    ],
    "penalise": [
        "penaliser"
    ],
    "penaliser": [
        "penaliser"
    ],
    "penalisera": [
        "penaliser"
    ],
    "penaliserai": [
        "penaliser"
    ],
    "penaliste": [
        "penaliste"
    ],
    "penalistes": [
        "penaliste"
    ],
    "penalisee": [
        "penaliser"
    ],
    "penalises": [
        "penalise",
        "penaliser"
    ],
    "penalite": [
        "penalite"
    ],
    "penalites": [
        "penalite"
    ],
    "penard": [
        "penard"
    ],
    "penarde": [
        "penard"
    ],
    "penardement": [
        "penardement"
    ],
    "penardes": [
        "penard"
    ],
    "penards": [
        "penard"
    ],
    "penates": [
        "penates"
    ],
    "penaux": [
        "penal"
    ],
    "penible": [
        "penible"
    ],
    "peniblement": [
        "peniblement"
    ],
    "penibles": [
        "penible"
    ],
    "peniche": [
        "peniche"
    ],
    "peniches": [
        "peniche"
    ],
    "penicilline": [
        "penicilline"
    ],
    "penien": [
        "penien"
    ],
    "penienne": [
        "penien"
    ],
    "penil": [
        "penil"
    ],
    "peninsulaire": [
        "peninsulaire"
    ],
    "peninsulaires": [
        "peninsulaire"
    ],
    "peninsule": [
        "peninsule"
    ],
    "peninsules": [
        "peninsule"
    ],
    "penis": [
        "penis"
    ],
    "penitence": [
        "penitence"
    ],
    "penitences": [
        "penitence"
    ],
    "penitencier": [
        "penitencier"
    ],
    "penitenciers": [
        "penitencier"
    ],
    "penitent": [
        "penitent"
    ],
    "penitente": [
        "penitent"
    ],
    "penitentes": [
        "penitent"
    ],
    "penitentiaire": [
        "penitentiaire"
    ],
    "penitentiaires": [
        "penitentiaire"
    ],
    "penitentielle": [
        "penitentiel"
    ],
    "penitents": [
        "penitent"
    ],
    "penologie": [
        "penologie"
    ],
    "penombre": [
        "penombre"
    ],
    "penombres": [
        "penombre"
    ],
    "penultieme": [
        "penultieme"
    ],
    "penurie": [
        "penurie"
    ],
    "penuries": [
        "penurie"
    ],
    "penetre": [
        "penetre",
        "penetrer"
    ],
    "penetrent": [
        "penetrer"
    ],
    "penetres": [
        "penetre",
        "penetrer"
    ],
    "peneplaines": [
        "peneplaine"
    ],
    "penetra": [
        "penetrer"
    ],
    "penetrable": [
        "penetrable"
    ],
    "penetrables": [
        "penetrable"
    ],
    "penetrai": [
        "penetrer"
    ],
    "penetraient": [
        "penetrer"
    ],
    "penetrais": [
        "penetrer"
    ],
    "penetrait": [
        "penetrer"
    ],
    "penetrant": [
        "penetrant",
        "penetrer"
    ],
    "penetrante": [
        "penetrant"
    ],
    "penetrantes": [
        "penetrant"
    ],
    "penetrants": [
        "penetrant"
    ],
    "penetration": [
        "penetration"
    ],
    "penetrations": [
        "penetration"
    ],
    "penetrer": [
        "penetrer"
    ],
    "penetrera": [
        "penetrer"
    ],
    "penetrerai": [
        "penetrer"
    ],
    "penetreraient": [
        "penetrer"
    ],
    "penetrerait": [
        "penetrer"
    ],
    "penetrerons": [
        "penetrer"
    ],
    "penetreront": [
        "penetrer"
    ],
    "penetrez": [
        "penetrer"
    ],
    "penetrions": [
        "penetrer"
    ],
    "penetrons": [
        "penetrer"
    ],
    "penetrames": [
        "penetrer"
    ],
    "penetrat": [
        "penetrer"
    ],
    "penetrerent": [
        "penetrer"
    ],
    "penetree": [
        "penetre",
        "penetrer"
    ],
    "penetrees": [
        "penetrer"
    ],
    "peon": [
        "peon"
    ],
    "peons": [
        "peon"
    ],
    "peottes": [
        "peotte"
    ],
    "pepettes": [
        "pepettes"
    ],
    "pepia": [
        "pepier"
    ],
    "pepiaient": [
        "pepier"
    ],
    "pepiait": [
        "pepier"
    ],
    "pepiant": [
        "pepiant"
    ],
    "pepie": [
        "pepie",
        "pepier"
    ],
    "pepiement": [
        "pepiement"
    ],
    "pepiements": [
        "pepiement"
    ],
    "pepient": [
        "pepier"
    ],
    "pepier": [
        "pepier"
    ],
    "pepin": [
        "pepin"
    ],
    "pepiniere": [
        "pepiniere"
    ],
    "pepinieres": [
        "pepiniere"
    ],
    "pepinieriste": [
        "pepinieriste"
    ],
    "pepinieristes": [
        "pepinieriste"
    ],
    "pepins": [
        "pepin"
    ],
    "pepite": [
        "pepite"
    ],
    "pepites": [
        "pepite"
    ],
    "pepies": [
        "pepier"
    ],
    "peplum": [
        "peplum"
    ],
    "peplums": [
        "peplum"
    ],
    "pepere": [
        "pepere"
    ],
    "peperes": [
        "pepere"
    ],
    "pepetes": [
        "pepetes"
    ],
    "pepe": [
        "pepe"
    ],
    "pepee": [
        "pepee"
    ],
    "pepees": [
        "pepee"
    ],
    "pepes": [
        "pepe"
    ],
    "pequenaud": [
        "pequenaud"
    ],
    "pequenaude": [
        "pequenaud"
    ],
    "pequenaudes": [
        "pequenaud"
    ],
    "pequenauds": [
        "pequenaud"
    ],
    "pequenot": [
        "pequenot"
    ],
    "pequenots": [
        "pequenot"
    ],
    "pequin": [
        "pequin"
    ],
    "pequins": [
        "pequin"
    ],
    "peremptoire": [
        "peremptoire"
    ],
    "peremptoirement": [
        "peremptoirement"
    ],
    "peremptoires": [
        "peremptoire"
    ],
    "perenne": [
        "perenne"
    ],
    "perennes": [
        "perenne"
    ],
    "perennise": [
        "perenniser"
    ],
    "perennite": [
        "perennite"
    ],
    "peri": [
        "peri",
        "perir"
    ],
    "pericarde": [
        "pericarde"
    ],
    "pericardique": [
        "pericardique"
    ],
    "pericardite": [
        "pericardite"
    ],
    "pericarpe": [
        "pericarpe"
    ],
    "periclita": [
        "pericliter"
    ],
    "periclitait": [
        "pericliter"
    ],
    "periclitant": [
        "pericliter"
    ],
    "periclitent": [
        "pericliter"
    ],
    "pericliter": [
        "pericliter"
    ],
    "pericliterent": [
        "pericliter"
    ],
    "periclite": [
        "pericliter"
    ],
    "peridurale": [
        "peridurale",
        "peridural"
    ],
    "perie": [
        "peri",
        "perir"
    ],
    "perif": [
        "perif"
    ],
    "perigourdin": [
        "perigourdin"
    ],
    "perigourdine": [
        "perigourdin"
    ],
    "perigourdins": [
        "perigourdin"
    ],
    "perigee": [
        "perigee"
    ],
    "peril": [
        "peril"
    ],
    "perilleuse": [
        "perilleux"
    ],
    "perilleusement": [
        "perilleusement"
    ],
    "perilleuses": [
        "perilleux"
    ],
    "perilleux": [
        "perilleux"
    ],
    "perils": [
        "peril"
    ],
    "perime": [
        "perime",
        "perimer"
    ],
    "periment": [
        "perimer"
    ],
    "perimer": [
        "perimer"
    ],
    "perimetre": [
        "perimetre"
    ],
    "perimetres": [
        "perimetre"
    ],
    "perimee": [
        "perime",
        "perimer"
    ],
    "perimees": [
        "perime",
        "perimer"
    ],
    "perimes": [
        "perime",
        "perimer"
    ],
    "perinee": [
        "perinee"
    ],
    "periode": [
        "periode"
    ],
    "periodes": [
        "periode"
    ],
    "periodicite": [
        "periodicite"
    ],
    "periodique": [
        "periodique"
    ],
    "periodiquement": [
        "periodiquement"
    ],
    "periodiques": [
        "periodique"
    ],
    "peripateticiennes": [
        "peripateticien",
        "peripateticienne"
    ],
    "periph": [
        "periph"
    ],
    "periphrase": [
        "periphrase"
    ],
    "periphrases": [
        "periphrase"
    ],
    "peripherie": [
        "peripherie"
    ],
    "peripheries": [
        "periphery",
        "peripherie"
    ],
    "peripherique": [
        "peripherique"
    ],
    "peripheriques": [
        "peripherique"
    ],
    "periple": [
        "periple"
    ],
    "periples": [
        "periple"
    ],
    "peripetie": [
        "peripetie"
    ],
    "peripeties": [
        "peripetie"
    ],
    "perir": [
        "perir"
    ],
    "perira": [
        "perir"
    ],
    "perirais": [
        "perir"
    ],
    "perirait": [
        "perir"
    ],
    "periras": [
        "perir"
    ],
    "perirent": [
        "perir"
    ],
    "perirez": [
        "perir"
    ],
    "peririez": [
        "perir"
    ],
    "perirons": [
        "perir"
    ],
    "periront": [
        "perir"
    ],
    "peris": [
        "peri",
        "perir"
    ],
    "periscolaire": [
        "periscolaire"
    ],
    "periscope": [
        "periscope"
    ],
    "periscopes": [
        "periscope"
    ],
    "periscopique": [
        "periscopique"
    ],
    "perissable": [
        "perissable"
    ],
    "perissables": [
        "perissable"
    ],
    "perissaient": [
        "perir"
    ],
    "perissait": [
        "perir"
    ],
    "perissant": [
        "perir"
    ],
    "perisse": [
        "perir"
    ],
    "perissent": [
        "perir"
    ],
    "perissez": [
        "perir"
    ],
    "perissodactyle": [
        "perissodactyle"
    ],
    "perissoire": [
        "perissoire"
    ],
    "perissoires": [
        "perissoire"
    ],
    "perissons": [
        "perir"
    ],
    "peristaltique": [
        "peristaltique"
    ],
    "peristaltiques": [
        "peristaltique"
    ],
    "peristaltisme": [
        "peristaltisme"
    ],
    "peristyle": [
        "peristyle"
    ],
    "perit": [
        "perir"
    ],
    "peritoine": [
        "peritoine"
    ],
    "peritonite": [
        "peritonite"
    ],
    "peritoneal": [
        "peritoneal"
    ],
    "peritoneale": [
        "peritoneal"
    ],
    "periurbaines": [
        "periurbain"
    ],
    "perodictique": [
        "perodictique"
    ],
    "peroniste": [
        "peroniste"
    ],
    "peronnelle": [
        "peronnelle"
    ],
    "perone": [
        "perone"
    ],
    "perones": [
        "perone"
    ],
    "perorais": [
        "perorer"
    ],
    "peroraison": [
        "peroraison"
    ],
    "peroraisons": [
        "peroraison"
    ],
    "perorait": [
        "perorer"
    ],
    "perorant": [
        "perorer"
    ],
    "perore": [
        "perorer"
    ],
    "perorer": [
        "perorer"
    ],
    "peroreur": [
        "peroreur"
    ],
    "perorons": [
        "perorer"
    ],
    "perot": [
        "perot"
    ],
    "perou": [
        "perou"
    ],
    "peruvien": [
        "peruvien"
    ],
    "peruvienne": [
        "peruvien"
    ],
    "peruviens": [
        "peruvien"
    ],
    "peregrinant": [
        "peregriner"
    ],
    "peregrination": [
        "peregrination"
    ],
    "peregrinations": [
        "peregrination"
    ],
    "peregrine": [
        "peregriner"
    ],
    "peregriner": [
        "peregriner"
    ],
    "peregrines": [
        "peregrine",
        "peregriner"
    ],
    "perequation": [
        "perequation"
    ],
    "perequations": [
        "perequation"
    ],
    "petaient": [
        "peter"
    ],
    "petainiste": [
        "petainiste"
    ],
    "petainistes": [
        "petainiste"
    ],
    "petais": [
        "peter"
    ],
    "petait": [
        "peter"
    ],
    "petale": [
        "petale"
    ],
    "petales": [
        "petale"
    ],
    "petaloides": [
        "petaloide"
    ],
    "petanque": [
        "petanque"
    ],
    "petant": [
        "peter",
        "petant"
    ],
    "petante": [
        "petant"
    ],
    "petantes": [
        "petant"
    ],
    "petants": [
        "petant"
    ],
    "petaradaient": [
        "petarader"
    ],
    "petaradait": [
        "petarader"
    ],
    "petaradant": [
        "petarader",
        "petaradant"
    ],
    "petaradante": [
        "petaradant"
    ],
    "petaradantes": [
        "petaradant"
    ],
    "petaradants": [
        "petaradant"
    ],
    "petarade": [
        "petarade",
        "petarader"
    ],
    "petarader": [
        "petarader"
    ],
    "petarades": [
        "petarade",
        "petarader"
    ],
    "petard": [
        "petard"
    ],
    "petarde": [
        "petarder"
    ],
    "petardier": [
        "petardier"
    ],
    "petardiere": [
        "petardier"
    ],
    "petards": [
        "petard"
    ],
    "petase": [
        "petase"
    ],
    "petasse": [
        "petasse"
    ],
    "petassent": [
        "petasser"
    ],
    "petasses": [
        "petasse"
    ],
    "petaudiere": [
        "petaudiere"
    ],
    "peter": [
        "peter"
    ],
    "petera": [
        "peter"
    ],
    "peterai": [
        "peter"
    ],
    "peterais": [
        "peter"
    ],
    "peterait": [
        "peter"
    ],
    "peteras": [
        "peter"
    ],
    "peteur": [
        "peteur"
    ],
    "peteuse": [
        "peteux",
        "peteuse"
    ],
    "peteux": [
        "peteux"
    ],
    "petez": [
        "peter"
    ],
    "petiez": [
        "peter"
    ],
    "petilla": [
        "petiller"
    ],
    "petillaient": [
        "petiller"
    ],
    "petillait": [
        "petiller"
    ],
    "petillant": [
        "petillant",
        "petiller"
    ],
    "petillante": [
        "petillant"
    ],
    "petillantes": [
        "petillant"
    ],
    "petillants": [
        "petillant"
    ],
    "petille": [
        "petiller"
    ],
    "petillement": [
        "petillement"
    ],
    "petillements": [
        "petillement"
    ],
    "petillent": [
        "petiller"
    ],
    "petiller": [
        "petiller"
    ],
    "petilles": [
        "petiller"
    ],
    "petillerent": [
        "petiller"
    ],
    "petiole": [
        "petiole"
    ],
    "petition": [
        "petition"
    ],
    "petitionnaires": [
        "petitionnaire"
    ],
    "petitionnent": [
        "petitionner"
    ],
    "petitionner": [
        "petitionner"
    ],
    "petitions": [
        "petition"
    ],
    "petochais": [
        "petocher"
    ],
    "petochait": [
        "petocher"
    ],
    "petochard": [
        "petochard"
    ],
    "petoche": [
        "petoche"
    ],
    "petoches": [
        "petoche"
    ],
    "petoire": [
        "petoire"
    ],
    "petoires": [
        "petoire"
    ],
    "petomane": [
        "petomane"
    ],
    "petomanes": [
        "petomane"
    ],
    "petoncle": [
        "petoncle"
    ],
    "petoncles": [
        "petoncle"
    ],
    "petouille": [
        "petouiller"
    ],
    "petoulet": [
        "petoulet"
    ],
    "petrarquistes": [
        "petrarquiste"
    ],
    "petrel": [
        "petrel"
    ],
    "petreux": [
        "petreux"
    ],
    "petri": [
        "petri",
        "petrir"
    ],
    "petrie": [
        "petri",
        "petrir"
    ],
    "petries": [
        "petrir"
    ],
    "petrifia": [
        "petrifier"
    ],
    "petrifiaient": [
        "petrifier"
    ],
    "petrifiais": [
        "petrifier"
    ],
    "petrifiait": [
        "petrifier"
    ],
    "petrifiant": [
        "petrifier"
    ],
    "petrifiante": [
        "petrifiant"
    ],
    "petrifiantes": [
        "petrifiant"
    ],
    "petrification": [
        "petrification"
    ],
    "petrifie": [
        "petrifie",
        "petrifier"
    ],
    "petrifient": [
        "petrifier"
    ],
    "petrifier": [
        "petrifier"
    ],
    "petrifieront": [
        "petrifier"
    ],
    "petrifiez": [
        "petrifier"
    ],
    "petrifiat": [
        "petrifier"
    ],
    "petrifierent": [
        "petrifier"
    ],
    "petrifiee": [
        "petrifie",
        "petrifier"
    ],
    "petrifiees": [
        "petrifie",
        "petrifier"
    ],
    "petrifies": [
        "petrifie",
        "petrifier"
    ],
    "petrin": [
        "petrin"
    ],
    "petrins": [
        "petrin"
    ],
    "petrir": [
        "petrir"
    ],
    "petrirai": [
        "petrir"
    ],
    "petrirent": [
        "petrir"
    ],
    "petris": [
        "petri",
        "petrir"
    ],
    "petrissage": [
        "petrissage"
    ],
    "petrissaient": [
        "petrir"
    ],
    "petrissait": [
        "petrir"
    ],
    "petrissant": [
        "petrir"
    ],
    "petrisse": [
        "petrir"
    ],
    "petrissent": [
        "petrir"
    ],
    "petrisseur": [
        "petrisseur"
    ],
    "petrissez": [
        "petrir"
    ],
    "petrit": [
        "petrir"
    ],
    "petrochimie": [
        "petrochimie"
    ],
    "petrochimique": [
        "petrochimique"
    ],
    "petrodollars": [
        "petrodollar"
    ],
    "petrole": [
        "petrole"
    ],
    "petroles": [
        "petrole"
    ],
    "petrolette": [
        "petrolette"
    ],
    "petroleuse": [
        "petroleur"
    ],
    "petroleuses": [
        "petroleur"
    ],
    "petrolier": [
        "petrolier"
    ],
    "petroliers": [
        "petrolier"
    ],
    "petrolifere": [
        "petrolifere"
    ],
    "petroliferes": [
        "petrolifere"
    ],
    "petroliere": [
        "petrolier"
    ],
    "petrolieres": [
        "petrolier"
    ],
    "petrousquin": [
        "petrousquin"
    ],
    "petrus": [
        "petrus"
    ],
    "petree": [
        "petre"
    ],
    "petulance": [
        "petulance"
    ],
    "petulant": [
        "petulant"
    ],
    "petulante": [
        "petulant"
    ],
    "petulantes": [
        "petulant"
    ],
    "petulants": [
        "petulant"
    ],
    "petunant": [
        "petuner"
    ],
    "petuner": [
        "petuner"
    ],
    "petunez": [
        "petuner"
    ],
    "petunia": [
        "petunia"
    ],
    "petunias": [
        "petunia"
    ],
    "petune": [
        "petuner"
    ],
    "petechiale": [
        "petechial"
    ],
    "petechie": [
        "petechie"
    ],
    "petechies": [
        "petechie"
    ],
    "petee": [
        "pete",
        "peter"
    ],
    "petees": [
        "pete"
    ],
    "pecha": [
        "pecher"
    ],
    "pechaient": [
        "pecher"
    ],
    "pechera": [
        "pecher"
    ],
    "pecheras": [
        "pecher"
    ],
    "pecherie": [
        "pecherie"
    ],
    "pecheries": [
        "pecherie"
    ],
    "pecherons": [
        "pecher"
    ],
    "pechers": [
        "pecher"
    ],
    "pecheuse": [
        "pecheur"
    ],
    "pecheuses": [
        "pecheur"
    ],
    "pechions": [
        "pecher"
    ],
    "pechee": [
        "pecher"
    ],
    "pechees": [
        "pecher"
    ],
    "pene": [
        "pene"
    ],
    "poles": [
        "pole"
    ],
    "pumes": [
        "pouvoir"
    ],
    "q": [
        "q"
    ],
    "qu": [
        "qu"
    ],
    "qu'": [
        "que",
        "qu'"
    ],
    "quadra": [
        "quadra"
    ],
    "quadragenaire": [
        "quadragenaire"
    ],
    "quadragenaires": [
        "quadragenaire"
    ],
    "quadrangle": [
        "quadrangle"
    ],
    "quadrangulaire": [
        "quadrangulaire"
    ],
    "quadrangulaires": [
        "quadrangulaire"
    ],
    "quadrant": [
        "quadrant"
    ],
    "quadrants": [
        "quadrant"
    ],
    "quadras": [
        "quadra"
    ],
    "quadratique": [
        "quadratique"
    ],
    "quadrature": [
        "quadrature"
    ],
    "quadri": [
        "quadri"
    ],
    "quadriceps": [
        "quadriceps"
    ],
    "quadrichromie": [
        "quadrichromie"
    ],
    "quadrichromies": [
        "quadrichromie"
    ],
    "quadridimensionnel": [
        "quadridimensionnel"
    ],
    "quadriennal": [
        "quadriennal"
    ],
    "quadrige": [
        "quadrige"
    ],
    "quadrilatere": [
        "quadrilatere"
    ],
    "quadrilateres": [
        "quadrilatere"
    ],
    "quadrillage": [
        "quadrillage"
    ],
    "quadrillages": [
        "quadrillage"
    ],
    "quadrillaient": [
        "quadriller"
    ],
    "quadrillais": [
        "quadriller"
    ],
    "quadrillait": [
        "quadriller"
    ],
    "quadrille": [
        "quadriller",
        "quadrille"
    ],
    "quadrillent": [
        "quadriller"
    ],
    "quadriller": [
        "quadriller"
    ],
    "quadrillerez": [
        "quadriller"
    ],
    "quadrilles": [
        "quadriller",
        "quadrille"
    ],
    "quadrillez": [
        "quadriller"
    ],
    "quadrillion": [
        "quadrillion"
    ],
    "quadrillons": [
        "quadriller"
    ],
    "quadrillee": [
        "quadriller"
    ],
    "quadrillees": [
        "quadriller"
    ],
    "quadrilobe": [
        "quadrilobe"
    ],
    "quadrimestre": [
        "quadrimestre"
    ],
    "quadrimoteur": [
        "quadrimoteur"
    ],
    "quadripartite": [
        "quadripartite"
    ],
    "quadripartites": [
        "quadripartite"
    ],
    "quadriphonie": [
        "quadriphonie"
    ],
    "quadriphonique": [
        "quadriphonique"
    ],
    "quadriplegique": [
        "quadriplegique"
    ],
    "quadrireacteur": [
        "quadrireacteur"
    ],
    "quadrivium": [
        "quadrivium"
    ],
    "quadrumane": [
        "quadrumane"
    ],
    "quadrupla": [
        "quadrupler"
    ],
    "quadruplait": [
        "quadrupler"
    ],
    "quadruple": [
        "quadrupler",
        "quadruple"
    ],
    "quadrupler": [
        "quadrupler"
    ],
    "quadruples": [
        "quadrupler",
        "quadruple"
    ],
    "quadruplees": [
        "quadruplee"
    ],
    "quadrupede": [
        "quadrupede"
    ],
    "quadrupedes": [
        "quadrupede"
    ],
    "quai": [
        "quai"
    ],
    "quais": [
        "quai"
    ],
    "quaker": [
        "quaker"
    ],
    "quakeresse": [
        "quakeresse"
    ],
    "quakers": [
        "quaker"
    ],
    "qualifia": [
        "qualifier"
    ],
    "qualifiable": [
        "qualifiable"
    ],
    "qualifiaient": [
        "qualifier"
    ],
    "qualifiais": [
        "qualifier"
    ],
    "qualifiait": [
        "qualifier"
    ],
    "qualifiant": [
        "qualifier"
    ],
    "qualifiassent": [
        "qualifier"
    ],
    "qualificatif": [
        "qualificatif"
    ],
    "qualificatifs": [
        "qualificatif"
    ],
    "qualification": [
        "qualification"
    ],
    "qualifications": [
        "qualification"
    ],
    "qualifie": [
        "qualifie",
        "qualifier"
    ],
    "qualifient": [
        "qualifier"
    ],
    "qualifier": [
        "qualifier"
    ],
    "qualifiera": [
        "qualifier"
    ],
    "qualifierai": [
        "qualifier"
    ],
    "qualifierais": [
        "qualifier"
    ],
    "qualifierait": [
        "qualifier"
    ],
    "qualifieriez": [
        "qualifier"
    ],
    "qualifiez": [
        "qualifier"
    ],
    "qualifiat": [
        "qualifier"
    ],
    "qualifiee": [
        "qualifie",
        "qualifier"
    ],
    "qualifiees": [
        "qualifie",
        "qualifier"
    ],
    "qualifies": [
        "qualifie",
        "qualify",
        "qualifier"
    ],
    "qualitatif": [
        "qualitatif"
    ],
    "qualitatifs": [
        "qualitatif"
    ],
    "qualitative": [
        "qualitatif"
    ],
    "qualite": [
        "qualite"
    ],
    "qualites": [
        "qualite"
    ],
    "quand": [
        "quand"
    ],
    "quant": [
        "quant",
        "quand"
    ],
    "quanta": [
        "quantum"
    ],
    "quantifiable": [
        "quantifiable"
    ],
    "quantifier": [
        "quantifier"
    ],
    "quantifiee": [
        "quantifier"
    ],
    "quantique": [
        "quantique"
    ],
    "quantiques": [
        "quantique"
    ],
    "quantitatif": [
        "quantitatif"
    ],
    "quantitative": [
        "quantitatif"
    ],
    "quantitativement": [
        "quantitativement"
    ],
    "quantitatives": [
        "quantitatif"
    ],
    "quantite": [
        "quantite"
    ],
    "quantites": [
        "quantite"
    ],
    "quantieme": [
        "quantieme"
    ],
    "quantiemes": [
        "quantieme"
    ],
    "quanto": [
        "quanto"
    ],
    "quantum": [
        "quantum"
    ],
    "quarantaine": [
        "quarantaine"
    ],
    "quarantaines": [
        "quarantaine"
    ],
    "quarante": [
        "quarante"
    ],
    "quarantenaire": [
        "quarantenaire"
    ],
    "quarantenaires": [
        "quarantenaire"
    ],
    "quarantieme": [
        "quarantieme"
    ],
    "quarantiemes": [
        "quarantieme"
    ],
    "quark": [
        "quark"
    ],
    "quarks": [
        "quark"
    ],
    "quarre": [
        "quarre"
    ],
    "quarrez": [
        "quarrer"
    ],
    "quart": [
        "quart"
    ],
    "quartaut": [
        "quartaut"
    ],
    "quarte": [
        "quarte"
    ],
    "quartenier": [
        "quartenier"
    ],
    "quarter": [
        "quarter"
    ],
    "quarteron": [
        "quarteron"
    ],
    "quarteronnes": [
        "quarteron"
    ],
    "quarterons": [
        "quarteron"
    ],
    "quartet": [
        "quartet"
    ],
    "quartette": [
        "quartette"
    ],
    "quartettes": [
        "quartette"
    ],
    "quartidi": [
        "quartidi"
    ],
    "quartier": [
        "quartier"
    ],
    "quartiers": [
        "quartier"
    ],
    "quarto": [
        "quarto"
    ],
    "quarts": [
        "quart"
    ],
    "quartz": [
        "quartz"
    ],
    "quasar": [
        "quasar"
    ],
    "quasi": [
        "quasi"
    ],
    "quasiment": [
        "quasiment"
    ],
    "quasimodo": [
        "quasimodo"
    ],
    "quasimodos": [
        "quasimodo"
    ],
    "quat'zarts": [
        "quat'zarts"
    ],
    "quater": [
        "quater"
    ],
    "quaternaire": [
        "quaternaire"
    ],
    "quatorze": [
        "quatorze"
    ],
    "quatorzieme": [
        "quatorzieme"
    ],
    "quatrain": [
        "quatrain"
    ],
    "quatrains": [
        "quatrain"
    ],
    "quatre": [
        "quatre"
    ],
    "quatrillion": [
        "quatrillion"
    ],
    "quatrieme": [
        "quatrieme"
    ],
    "quatriemement": [
        "quatriemement"
    ],
    "quatriemes": [
        "quatrieme"
    ],
    "quattrocento": [
        "quattrocento"
    ],
    "quatuor": [
        "quatuor"
    ],
    "quatuors": [
        "quatuor"
    ],
    "que": [
        "que"
    ],
    "quechua": [
        "quechua"
    ],
    "quel": [
        "quel"
    ],
    "quelconque": [
        "quelconque"
    ],
    "quelconques": [
        "quelconque"
    ],
    "quelle": [
        "quelle"
    ],
    "quelles": [
        "quelles"
    ],
    "quelqu'un": [
        "quelqu'un"
    ],
    "quelqu'une": [
        "quelqu'une"
    ],
    "quelque": [
        "quelque"
    ],
    "quelquefois": [
        "quelquefois"
    ],
    "quelques": [
        "quelques"
    ],
    "quels": [
        "quels"
    ],
    "quenelle": [
        "quenelle"
    ],
    "quenelles": [
        "quenelle"
    ],
    "quenotte": [
        "quenotte"
    ],
    "quenottes": [
        "quenotte"
    ],
    "quenouille": [
        "quenouille"
    ],
    "quenouilles": [
        "quenouille"
    ],
    "querella": [
        "quereller"
    ],
    "querellaient": [
        "quereller"
    ],
    "querellais": [
        "quereller"
    ],
    "querellait": [
        "quereller"
    ],
    "querellant": [
        "quereller"
    ],
    "querelle": [
        "quereller",
        "querelle"
    ],
    "querellent": [
        "quereller"
    ],
    "quereller": [
        "quereller"
    ],
    "querelles": [
        "quereller",
        "querelle"
    ],
    "querelleur": [
        "querelleur"
    ],
    "querelleurs": [
        "querelleur"
    ],
    "querelleuse": [
        "querelleux"
    ],
    "querellez": [
        "quereller"
    ],
    "querellons": [
        "quereller"
    ],
    "querellerent": [
        "quereller"
    ],
    "querellee": [
        "quereller"
    ],
    "querellees": [
        "quereller"
    ],
    "questeur": [
        "questeur"
    ],
    "questeurs": [
        "questeur"
    ],
    "question": [
        "question"
    ],
    "questionna": [
        "questionner"
    ],
    "questionnai": [
        "questionner"
    ],
    "questionnaient": [
        "questionner"
    ],
    "questionnaire": [
        "questionnaire"
    ],
    "questionnaires": [
        "questionnaire"
    ],
    "questionnais": [
        "questionner"
    ],
    "questionnait": [
        "questionner"
    ],
    "questionnant": [
        "questionner"
    ],
    "questionne": [
        "questionner"
    ],
    "questionnement": [
        "questionnement"
    ],
    "questionnements": [
        "questionnement"
    ],
    "questionnent": [
        "questionner"
    ],
    "questionner": [
        "questionner"
    ],
    "questionnera": [
        "questionner"
    ],
    "questionnerai": [
        "questionner"
    ],
    "questionnerait": [
        "questionner"
    ],
    "questionnerons": [
        "questionner"
    ],
    "questionneront": [
        "questionner"
    ],
    "questionneur": [
        "questionneur"
    ],
    "questionneurs": [
        "questionneur"
    ],
    "questionneuse": [
        "questionneur"
    ],
    "questionnez": [
        "questionner"
    ],
    "questionnions": [
        "questionner"
    ],
    "questionnons": [
        "questionner"
    ],
    "questionnat": [
        "questionner"
    ],
    "questionnerent": [
        "questionner"
    ],
    "questionnee": [
        "questionner"
    ],
    "questionnes": [
        "questionner"
    ],
    "questions": [
        "question"
    ],
    "questure": [
        "questure"
    ],
    "quetsche": [
        "quetsche"
    ],
    "quetsches": [
        "quetsche"
    ],
    "quette": [
        "quette"
    ],
    "quetzal": [
        "quetzal"
    ],
    "queue": [
        "queue"
    ],
    "queues": [
        "queue"
    ],
    "queursoir": [
        "queursoir"
    ],
    "queutard": [
        "queutard"
    ],
    "queute": [
        "queuter"
    ],
    "queutee": [
        "queuter"
    ],
    "qui": [
        "qui",
        "que"
    ],
    "quibus": [
        "quibus"
    ],
    "quiche": [
        "quiche"
    ],
    "quiches": [
        "quiche"
    ],
    "quichotte": [
        "quichotte"
    ],
    "quick": [
        "quick"
    ],
    "quiconque": [
        "quiconque"
    ],
    "quidam": [
        "quidam"
    ],
    "quidams": [
        "quidam"
    ],
    "quiet": [
        "quiet"
    ],
    "quiets": [
        "quiet"
    ],
    "quignon": [
        "quignon"
    ],
    "quignons": [
        "quignon"
    ],
    "quillai": [
        "quiller"
    ],
    "quillards": [
        "quillard"
    ],
    "quille": [
        "quille"
    ],
    "quiller": [
        "quiller"
    ],
    "quilles": [
        "quille"
    ],
    "quillon": [
        "quillon"
    ],
    "quillons": [
        "quillon"
    ],
    "quillee": [
        "quiller"
    ],
    "quimpe": [
        "quimper"
    ],
    "quimpent": [
        "quimper"
    ],
    "quimper": [
        "quimper"
    ],
    "quincaille": [
        "quincaille"
    ],
    "quincaillerie": [
        "quincaillerie"
    ],
    "quincailleries": [
        "quincaillerie"
    ],
    "quincaillier": [
        "quincaillier"
    ],
    "quincailliers": [
        "quincaillier"
    ],
    "quincailliere": [
        "quincaillier"
    ],
    "quinconce": [
        "quinconce"
    ],
    "quinconces": [
        "quinconce"
    ],
    "quine": [
        "quine"
    ],
    "quinine": [
        "quinine"
    ],
    "quinium": [
        "quinium"
    ],
    "quinoa": [
        "quinoa"
    ],
    "quinqua": [
        "quinqua"
    ],
    "quinquagenaire": [
        "quinquagenaire"
    ],
    "quinquagenaires": [
        "quinquagenaire"
    ],
    "quinquagesime": [
        "quinquagesime"
    ],
    "quinquennal": [
        "quinquennal"
    ],
    "quinquennat": [
        "quinquennat"
    ],
    "quinquet": [
        "quinquet"
    ],
    "quinquets": [
        "quinquet"
    ],
    "quinquina": [
        "quinquina"
    ],
    "quint": [
        "quint"
    ],
    "quintaine": [
        "quintaine"
    ],
    "quintal": [
        "quintal"
    ],
    "quintaux": [
        "quintal"
    ],
    "quinte": [
        "quinte"
    ],
    "quintes": [
        "quinte"
    ],
    "quintessence": [
        "quintessence"
    ],
    "quintessencie": [
        "quintessencier",
        "quintessencie"
    ],
    "quintessenciee": [
        "quintessencie"
    ],
    "quintessenciees": [
        "quintessencie"
    ],
    "quintet": [
        "quintet"
    ],
    "quintette": [
        "quintette"
    ],
    "quintettes": [
        "quintette"
    ],
    "quinteux": [
        "quinteux"
    ],
    "quintidi": [
        "quintidi"
    ],
    "quinto": [
        "quinto"
    ],
    "quintolet": [
        "quintolet"
    ],
    "quinton": [
        "quinton"
    ],
    "quintupla": [
        "quintupler"
    ],
    "quintuple": [
        "quintupler",
        "quintuple"
    ],
    "quintuples": [
        "quintupler",
        "quintuple"
    ],
    "quintuplees": [
        "quintupler",
        "quintuplee"
    ],
    "quinzaine": [
        "quinzaine"
    ],
    "quinzaines": [
        "quinzaine"
    ],
    "quinze": [
        "quinze"
    ],
    "quinzieme": [
        "quinzieme"
    ],
    "quipos": [
        "quipo"
    ],
    "quiproquo": [
        "quiproquo"
    ],
    "quiproquos": [
        "quiproquo"
    ],
    "quipu": [
        "quipu"
    ],
    "quiquette": [
        "quiquette"
    ],
    "quiqui": [
        "quiqui"
    ],
    "quiscale": [
        "quiscale"
    ],
    "quite": [
        "quite"
    ],
    "quitta": [
        "quitter"
    ],
    "quittai": [
        "quitter"
    ],
    "quittaient": [
        "quitter"
    ],
    "quittais": [
        "quitter"
    ],
    "quittait": [
        "quitter"
    ],
    "quittance": [
        "quittance"
    ],
    "quittances": [
        "quittance"
    ],
    "quittant": [
        "quitter"
    ],
    "quittas": [
        "quitter"
    ],
    "quittassent": [
        "quitter"
    ],
    "quitte": [
        "quitter",
        "quitte"
    ],
    "quittent": [
        "quitter"
    ],
    "quitter": [
        "quitter"
    ],
    "quittera": [
        "quitter"
    ],
    "quitterai": [
        "quitter"
    ],
    "quitteraient": [
        "quitter"
    ],
    "quitterais": [
        "quitter"
    ],
    "quitterait": [
        "quitter"
    ],
    "quitteras": [
        "quitter"
    ],
    "quitterez": [
        "quitter"
    ],
    "quitteriez": [
        "quitter"
    ],
    "quitterions": [
        "quitter"
    ],
    "quitterons": [
        "quitter"
    ],
    "quitteront": [
        "quitter"
    ],
    "quittes": [
        "quitter",
        "quitte"
    ],
    "quittez": [
        "quitter"
    ],
    "quittiez": [
        "quitter"
    ],
    "quittions": [
        "quitter"
    ],
    "quittons": [
        "quitter"
    ],
    "quittames": [
        "quitter"
    ],
    "quittat": [
        "quitter"
    ],
    "quitterent": [
        "quitter"
    ],
    "quittee": [
        "quitter"
    ],
    "quittees": [
        "quitter"
    ],
    "quitus": [
        "quitus"
    ],
    "quiz": [
        "quiz"
    ],
    "quiete": [
        "quiet"
    ],
    "quietement": [
        "quietement"
    ],
    "quietes": [
        "quiet"
    ],
    "quietisme": [
        "quietisme"
    ],
    "quietiste": [
        "quietiste"
    ],
    "quietude": [
        "quietude"
    ],
    "quietudes": [
        "quietude"
    ],
    "quoaillant": [
        "quoailler"
    ],
    "quoi": [
        "quoi"
    ],
    "quoique": [
        "quoique"
    ],
    "quolibet": [
        "quolibet"
    ],
    "quolibets": [
        "quolibet"
    ],
    "quorum": [
        "quorum"
    ],
    "quota": [
        "quota"
    ],
    "quotas": [
        "quota"
    ],
    "quotidien": [
        "quotidien"
    ],
    "quotidienne": [
        "quotidien"
    ],
    "quotidiennement": [
        "quotidiennement"
    ],
    "quotidiennes": [
        "quotidien"
    ],
    "quotidiennete": [
        "quotidiennete"
    ],
    "quotidiens": [
        "quotidien"
    ],
    "quotient": [
        "quotient"
    ],
    "quotients": [
        "quotient"
    ],
    "quotite": [
        "quotite"
    ],
    "quebecois": [
        "quebecois"
    ],
    "quebecoise": [
        "quebecois"
    ],
    "quemanda": [
        "quemander"
    ],
    "quemandaient": [
        "quemander"
    ],
    "quemandait": [
        "quemander"
    ],
    "quemandant": [
        "quemander"
    ],
    "quemande": [
        "quemander"
    ],
    "quemandent": [
        "quemander"
    ],
    "quemander": [
        "quemander"
    ],
    "quemandeur": [
        "quemandeur"
    ],
    "quemandeurs": [
        "quemandeur"
    ],
    "quemandeuse": [
        "quemandeur"
    ],
    "quemandeuses": [
        "quemandeur"
    ],
    "quemandons": [
        "quemander"
    ],
    "quequette": [
        "quequette"
    ],
    "quequettes": [
        "quequette"
    ],
    "querir": [
        "querir"
    ],
    "queta": [
        "queter"
    ],
    "quetai": [
        "queter"
    ],
    "quetaient": [
        "queter"
    ],
    "quetais": [
        "queter"
    ],
    "quetait": [
        "queter"
    ],
    "quetant": [
        "queter"
    ],
    "quete": [
        "queter",
        "quete"
    ],
    "quetent": [
        "queter"
    ],
    "queter": [
        "queter"
    ],
    "quetes": [
        "quete"
    ],
    "queteur": [
        "queteur"
    ],
    "queteurs": [
        "queteur"
    ],
    "queteuse": [
        "queteur"
    ],
    "quetez": [
        "queter"
    ],
    "quetees": [
        "queter"
    ],
    "ra": [
        "ra"
    ],
    "rab": [
        "rab"
    ],
    "rabais": [
        "rabais"
    ],
    "rabaissa": [
        "rabaisser"
    ],
    "rabaissaient": [
        "rabaisser"
    ],
    "rabaissais": [
        "rabaisser"
    ],
    "rabaissait": [
        "rabaisser"
    ],
    "rabaissant": [
        "rabaisser"
    ],
    "rabaisse": [
        "rabaisser"
    ],
    "rabaissement": [
        "rabaissement"
    ],
    "rabaissent": [
        "rabaisser"
    ],
    "rabaisser": [
        "rabaisser"
    ],
    "rabaissera": [
        "rabaisser"
    ],
    "rabaisserait": [
        "rabaisser"
    ],
    "rabaisses": [
        "rabaisser"
    ],
    "rabaissez": [
        "rabaisser"
    ],
    "rabaissee": [
        "rabaisser"
    ],
    "rabaissees": [
        "rabaisser"
    ],
    "raban": [
        "raban"
    ],
    "rabane": [
        "rabane"
    ],
    "rabanes": [
        "rabane"
    ],
    "rabans": [
        "raban"
    ],
    "rabat": [
        "rabat",
        "rabattre"
    ],
    "rabats": [
        "rabat",
        "rabattre"
    ],
    "rabattable": [
        "rabattable"
    ],
    "rabattaient": [
        "rabattre"
    ],
    "rabattais": [
        "rabattre"
    ],
    "rabattait": [
        "rabattre"
    ],
    "rabattant": [
        "rabattre",
        "rabattant"
    ],
    "rabatte": [
        "rabattre"
    ],
    "rabattent": [
        "rabattre"
    ],
    "rabatteur": [
        "rabatteur"
    ],
    "rabatteurs": [
        "rabatteur"
    ],
    "rabatteuse": [
        "rabatteur"
    ],
    "rabatteuses": [
        "rabatteur"
    ],
    "rabattez": [
        "rabattre"
    ],
    "rabattions": [
        "rabattre"
    ],
    "rabattirent": [
        "rabattre"
    ],
    "rabattis": [
        "rabattre"
    ],
    "rabattit": [
        "rabattre"
    ],
    "rabattra": [
        "rabattre"
    ],
    "rabattraient": [
        "rabattre"
    ],
    "rabattrait": [
        "rabattre"
    ],
    "rabattras": [
        "rabattre"
    ],
    "rabattre": [
        "rabattre"
    ],
    "rabattrons": [
        "rabattre"
    ],
    "rabattu": [
        "rabattu",
        "rabattre"
    ],
    "rabattue": [
        "rabattu",
        "rabattre"
    ],
    "rabattues": [
        "rabattu",
        "rabattre"
    ],
    "rabattus": [
        "rabattu",
        "rabattre"
    ],
    "rabbi": [
        "rabbi"
    ],
    "rabbin": [
        "rabbin"
    ],
    "rabbinat": [
        "rabbinat"
    ],
    "rabbinique": [
        "rabbinique"
    ],
    "rabbiniques": [
        "rabbinique"
    ],
    "rabbins": [
        "rabbin"
    ],
    "rabe": [
        "rabe"
    ],
    "rabelaisien": [
        "rabelaisien"
    ],
    "rabelaisienne": [
        "rabelaisien"
    ],
    "rabelaisiennes": [
        "rabelaisien"
    ],
    "rabelaisiens": [
        "rabelaisien"
    ],
    "rabes": [
        "rabe"
    ],
    "rabibochage": [
        "rabibochage"
    ],
    "rabiboche": [
        "rabibocher"
    ],
    "rabibochent": [
        "rabibocher"
    ],
    "rabibocher": [
        "rabibocher"
    ],
    "rabibocherez": [
        "rabibocher"
    ],
    "rabibochees": [
        "rabibocher"
    ],
    "rabiboches": [
        "rabibocher"
    ],
    "rabiot": [
        "rabiot"
    ],
    "rabiotait": [
        "rabioter"
    ],
    "rabioter": [
        "rabioter"
    ],
    "rabique": [
        "rabique"
    ],
    "rabonnir": [
        "rabonnir"
    ],
    "rabot": [
        "rabot"
    ],
    "rabotage": [
        "rabotage"
    ],
    "rabotais": [
        "raboter"
    ],
    "rabotait": [
        "raboter"
    ],
    "rabotant": [
        "raboter"
    ],
    "rabotent": [
        "raboter"
    ],
    "raboter": [
        "raboter"
    ],
    "raboteur": [
        "raboteur"
    ],
    "raboteuse": [
        "raboteux"
    ],
    "raboteuses": [
        "raboteux"
    ],
    "raboteux": [
        "raboteux"
    ],
    "rabotin": [
        "rabotin"
    ],
    "rabots": [
        "rabot"
    ],
    "rabote": [
        "raboter"
    ],
    "rabotee": [
        "raboter"
    ],
    "rabotees": [
        "raboter"
    ],
    "rabotes": [
        "raboter"
    ],
    "rabougri": [
        "rabougri",
        "rabougrir"
    ],
    "rabougrie": [
        "rabougri",
        "rabougrir"
    ],
    "rabougries": [
        "rabougri"
    ],
    "rabougrir": [
        "rabougrir"
    ],
    "rabougris": [
        "rabougri",
        "rabougrir"
    ],
    "rabougrissent": [
        "rabougrir"
    ],
    "rabougrit": [
        "rabougrir"
    ],
    "rabouilleres": [
        "rabouiller"
    ],
    "rabouin": [
        "rabouin"
    ],
    "rabouler": [
        "rabouler"
    ],
    "rabouter": [
        "rabouter"
    ],
    "raboute": [
        "rabouter"
    ],
    "rabroua": [
        "rabrouer"
    ],
    "rabrouai": [
        "rabrouer"
    ],
    "rabrouaient": [
        "rabrouer"
    ],
    "rabrouait": [
        "rabrouer"
    ],
    "rabrouant": [
        "rabrouer"
    ],
    "rabroue": [
        "rabrouer"
    ],
    "rabrouer": [
        "rabrouer"
    ],
    "rabrouat": [
        "rabrouer"
    ],
    "rabrouerent": [
        "rabrouer"
    ],
    "rabrouee": [
        "rabrouer"
    ],
    "rabs": [
        "rab"
    ],
    "rabacha": [
        "rabacher"
    ],
    "rabachage": [
        "rabachage"
    ],
    "rabachages": [
        "rabachage"
    ],
    "rabachaient": [
        "rabacher"
    ],
    "rabachais": [
        "rabacher"
    ],
    "rabachait": [
        "rabacher"
    ],
    "rabachant": [
        "rabacher"
    ],
    "rabache": [
        "rabacher"
    ],
    "rabachent": [
        "rabacher"
    ],
    "rabacher": [
        "rabacher"
    ],
    "rabacherait": [
        "rabacher"
    ],
    "rabaches": [
        "rabacher"
    ],
    "rabacheur": [
        "rabacheur"
    ],
    "rabachee": [
        "rabacher"
    ],
    "rabachees": [
        "rabacher"
    ],
    "rac": [
        "rac"
    ],
    "racaille": [
        "racaille"
    ],
    "racailles": [
        "racaille"
    ],
    "raccommoda": [
        "raccommoder"
    ],
    "raccommodage": [
        "raccommodage"
    ],
    "raccommodages": [
        "raccommodage"
    ],
    "raccommodaient": [
        "raccommoder"
    ],
    "raccommodait": [
        "raccommoder"
    ],
    "raccommodant": [
        "raccommoder"
    ],
    "raccommode": [
        "raccommoder"
    ],
    "raccommodements": [
        "raccommodement"
    ],
    "raccommodent": [
        "raccommoder"
    ],
    "raccommoder": [
        "raccommoder"
    ],
    "raccommodera": [
        "raccommoder"
    ],
    "raccommoderai": [
        "raccommoder"
    ],
    "raccommodeurs": [
        "raccommodeur"
    ],
    "raccommodez": [
        "raccommoder"
    ],
    "raccommodions": [
        "raccommoder"
    ],
    "raccommodee": [
        "raccommoder"
    ],
    "raccommodees": [
        "raccommoder"
    ],
    "raccommodes": [
        "raccommoder"
    ],
    "raccompagna": [
        "raccompagner"
    ],
    "raccompagnai": [
        "raccompagner"
    ],
    "raccompagnaient": [
        "raccompagner"
    ],
    "raccompagnais": [
        "raccompagner"
    ],
    "raccompagnait": [
        "raccompagner"
    ],
    "raccompagnant": [
        "raccompagner"
    ],
    "raccompagne": [
        "raccompagner"
    ],
    "raccompagnent": [
        "raccompagner"
    ],
    "raccompagner": [
        "raccompagner"
    ],
    "raccompagnera": [
        "raccompagner"
    ],
    "raccompagnerai": [
        "raccompagner"
    ],
    "raccompagnerais": [
        "raccompagner"
    ],
    "raccompagnerait": [
        "raccompagner"
    ],
    "raccompagneras": [
        "raccompagner"
    ],
    "raccompagnerez": [
        "raccompagner"
    ],
    "raccompagnes": [
        "raccompagner"
    ],
    "raccompagnez": [
        "raccompagner"
    ],
    "raccompagnons": [
        "raccompagner"
    ],
    "raccompagnerent": [
        "raccompagner"
    ],
    "raccompagnee": [
        "raccompagner"
    ],
    "raccord": [
        "raccord"
    ],
    "raccordaient": [
        "raccorder"
    ],
    "raccordait": [
        "raccorder"
    ],
    "raccordant": [
        "raccorder"
    ],
    "raccorde": [
        "raccorder"
    ],
    "raccordement": [
        "raccordement"
    ],
    "raccordements": [
        "raccordement"
    ],
    "raccordent": [
        "raccorder"
    ],
    "raccorder": [
        "raccorder"
    ],
    "raccorderait": [
        "raccorder"
    ],
    "raccordez": [
        "raccorder"
    ],
    "raccords": [
        "raccord"
    ],
    "raccordee": [
        "raccorder"
    ],
    "raccordees": [
        "raccorder"
    ],
    "raccordes": [
        "raccorder"
    ],
    "raccourci": [
        "raccourci",
        "raccourcir"
    ],
    "raccourcie": [
        "raccourcir"
    ],
    "raccourcies": [
        "raccourcir"
    ],
    "raccourcir": [
        "raccourcir"
    ],
    "raccourcira": [
        "raccourcir"
    ],
    "raccourciras": [
        "raccourcir"
    ],
    "raccourcirons": [
        "raccourcir"
    ],
    "raccourcis": [
        "raccourci",
        "raccourcir"
    ],
    "raccourcissaient": [
        "raccourcir"
    ],
    "raccourcissait": [
        "raccourcir"
    ],
    "raccourcissant": [
        "raccourcir"
    ],
    "raccourcisse": [
        "raccourcir"
    ],
    "raccourcissement": [
        "raccourcissement"
    ],
    "raccourcissent": [
        "raccourcir"
    ],
    "raccourcit": [
        "raccourcir"
    ],
    "raccroc": [
        "raccroc"
    ],
    "raccrocha": [
        "raccrocher"
    ],
    "raccrochage": [
        "raccrochage"
    ],
    "raccrochages": [
        "raccrochage"
    ],
    "raccrochai": [
        "raccrocher"
    ],
    "raccrochaient": [
        "raccrocher"
    ],
    "raccrochais": [
        "raccrocher"
    ],
    "raccrochait": [
        "raccrocher"
    ],
    "raccrochant": [
        "raccrocher"
    ],
    "raccroche": [
        "raccrocher"
    ],
    "raccrochent": [
        "raccrocher"
    ],
    "raccrocher": [
        "raccrocher"
    ],
    "raccrochera": [
        "raccrocher"
    ],
    "raccrocherai": [
        "raccrocher"
    ],
    "raccrocheraient": [
        "raccrocher"
    ],
    "raccrocherais": [
        "raccrocher"
    ],
    "raccrocherait": [
        "raccrocher"
    ],
    "raccrocheras": [
        "raccrocher"
    ],
    "raccroches": [
        "raccrocher"
    ],
    "raccrocheur": [
        "raccrocheur"
    ],
    "raccrocheurs": [
        "raccrocheur"
    ],
    "raccrochez": [
        "raccrocher"
    ],
    "raccrochons": [
        "raccrocher"
    ],
    "raccrocherent": [
        "raccrocher"
    ],
    "raccrochee": [
        "raccrocher"
    ],
    "raccrochees": [
        "raccrocher"
    ],
    "raccrocs": [
        "raccroc"
    ],
    "raccusa": [
        "raccuser"
    ],
    "race": [
        "race"
    ],
    "races": [
        "race"
    ],
    "rachat": [
        "rachat"
    ],
    "rachats": [
        "rachat"
    ],
    "racheta": [
        "racheter"
    ],
    "rachetai": [
        "racheter"
    ],
    "rachetaient": [
        "racheter"
    ],
    "rachetait": [
        "racheter"
    ],
    "rachetant": [
        "racheter"
    ],
    "racheter": [
        "racheter"
    ],
    "rachetez": [
        "racheter"
    ],
    "rachetiez": [
        "racheter"
    ],
    "rachetat": [
        "racheter"
    ],
    "racheterent": [
        "racheter"
    ],
    "rachete": [
        "racheter"
    ],
    "rachetee": [
        "racheter"
    ],
    "rachetees": [
        "racheter"
    ],
    "rachetes": [
        "racheter"
    ],
    "rachianesthesie": [
        "rachianesthesie"
    ],
    "rachidien": [
        "rachidien"
    ],
    "rachidienne": [
        "rachidien"
    ],
    "rachis": [
        "rachis"
    ],
    "rachitique": [
        "rachitique"
    ],
    "rachitiques": [
        "rachitique"
    ],
    "rachitisme": [
        "rachitisme"
    ],
    "racho": [
        "racho"
    ],
    "rachetent": [
        "racheter"
    ],
    "rachetera": [
        "racheter"
    ],
    "racheterai": [
        "racheter"
    ],
    "racheterais": [
        "racheter"
    ],
    "racheterait": [
        "racheter"
    ],
    "racheterez": [
        "racheter"
    ],
    "racheteront": [
        "racheter"
    ],
    "racial": [
        "racial"
    ],
    "raciale": [
        "racial"
    ],
    "racialement": [
        "racialement"
    ],
    "raciales": [
        "racial"
    ],
    "raciaux": [
        "racial"
    ],
    "racinait": [
        "raciner"
    ],
    "racine": [
        "racine"
    ],
    "raciner": [
        "raciner"
    ],
    "racines": [
        "raciner",
        "racine"
    ],
    "racingman": [
        "racingman"
    ],
    "racinienne": [
        "racinien"
    ],
    "raciniennes": [
        "racinien"
    ],
    "raciniens": [
        "racinien"
    ],
    "racinee": [
        "raciner"
    ],
    "racinees": [
        "raciner"
    ],
    "racisme": [
        "racisme"
    ],
    "racismes": [
        "racisme"
    ],
    "raciste": [
        "raciste"
    ],
    "racistes": [
        "raciste"
    ],
    "rack": [
        "rack"
    ],
    "racket": [
        "racket"
    ],
    "rackets": [
        "racket"
    ],
    "rackette": [
        "racketter"
    ],
    "racketter": [
        "racketter"
    ],
    "racketteur": [
        "racketteur"
    ],
    "rackettez": [
        "racketter"
    ],
    "rackettons": [
        "racketter"
    ],
    "racla": [
        "racler"
    ],
    "raclages": [
        "raclage"
    ],
    "raclaient": [
        "racler"
    ],
    "raclais": [
        "racler"
    ],
    "raclait": [
        "racler"
    ],
    "raclant": [
        "raclant",
        "racler"
    ],
    "raclante": [
        "raclant"
    ],
    "racle": [
        "racler",
        "racle"
    ],
    "raclement": [
        "raclement"
    ],
    "raclements": [
        "raclement"
    ],
    "raclent": [
        "racler"
    ],
    "racler": [
        "racler"
    ],
    "raclerai": [
        "racler"
    ],
    "racleras": [
        "racler"
    ],
    "racles": [
        "racler"
    ],
    "raclette": [
        "raclette"
    ],
    "racleur": [
        "racleur"
    ],
    "racleuse": [
        "racleur"
    ],
    "racloir": [
        "racloir"
    ],
    "raclons": [
        "raclon"
    ],
    "raclure": [
        "raclure"
    ],
    "raclures": [
        "raclure"
    ],
    "raclerent": [
        "racler"
    ],
    "raclee": [
        "racler",
        "raclee"
    ],
    "raclees": [
        "racler",
        "raclee"
    ],
    "racolage": [
        "racolage"
    ],
    "racolages": [
        "racolage"
    ],
    "racolaient": [
        "racoler"
    ],
    "racolais": [
        "racoler"
    ],
    "racolait": [
        "racoler"
    ],
    "racolant": [
        "racoler"
    ],
    "racole": [
        "racoler"
    ],
    "racolent": [
        "racoler"
    ],
    "racoler": [
        "racoler"
    ],
    "racoles": [
        "racoler"
    ],
    "racoleur": [
        "racoleur"
    ],
    "racoleurs": [
        "racoleur"
    ],
    "racoleuse": [
        "racoleur"
    ],
    "racoleuses": [
        "racoleur"
    ],
    "raconta": [
        "raconter"
    ],
    "racontable": [
        "racontable"
    ],
    "racontables": [
        "racontable"
    ],
    "racontai": [
        "raconter"
    ],
    "racontaient": [
        "raconter"
    ],
    "racontais": [
        "raconter"
    ],
    "racontait": [
        "raconter"
    ],
    "racontant": [
        "raconter"
    ],
    "racontar": [
        "racontar"
    ],
    "racontars": [
        "racontar"
    ],
    "racontas": [
        "raconter"
    ],
    "raconte": [
        "raconter"
    ],
    "racontent": [
        "raconter"
    ],
    "raconter": [
        "raconter"
    ],
    "racontera": [
        "raconter"
    ],
    "raconterai": [
        "raconter"
    ],
    "raconteraient": [
        "raconter"
    ],
    "raconterais": [
        "raconter"
    ],
    "raconterait": [
        "raconter"
    ],
    "raconteras": [
        "raconter"
    ],
    "raconterez": [
        "raconter"
    ],
    "raconterons": [
        "raconter"
    ],
    "raconteront": [
        "raconter"
    ],
    "racontes": [
        "raconter"
    ],
    "raconteur": [
        "raconteur"
    ],
    "raconteuse": [
        "raconteur"
    ],
    "racontez": [
        "raconter"
    ],
    "racontiez": [
        "raconter"
    ],
    "racontions": [
        "raconter"
    ],
    "racontons": [
        "raconter"
    ],
    "racontat": [
        "raconter"
    ],
    "raconterent": [
        "raconter"
    ],
    "racontee": [
        "raconter"
    ],
    "racontees": [
        "raconter"
    ],
    "racorni": [
        "racornir"
    ],
    "racornie": [
        "racornir"
    ],
    "racornies": [
        "racornir"
    ],
    "racornir": [
        "racornir"
    ],
    "racornis": [
        "racornir"
    ],
    "racornissait": [
        "racornir"
    ],
    "racornissent": [
        "racornir"
    ],
    "racornit": [
        "racornir"
    ],
    "racee": [
        "race"
    ],
    "rad": [
        "rad"
    ],
    "rada": [
        "rader"
    ],
    "radada": [
        "radada"
    ],
    "radar": [
        "radar"
    ],
    "radars": [
        "radar"
    ],
    "radasse": [
        "rader"
    ],
    "radasses": [
        "rader"
    ],
    "rade": [
        "rade"
    ],
    "radeau": [
        "radeau"
    ],
    "radeaux": [
        "radeau"
    ],
    "rader": [
        "rader"
    ],
    "rades": [
        "rade"
    ],
    "radeuse": [
        "radeuse"
    ],
    "radeuses": [
        "radeuse"
    ],
    "radial": [
        "radial"
    ],
    "radiale": [
        "radial"
    ],
    "radiales": [
        "radial"
    ],
    "radiant": [
        "radiant"
    ],
    "radiante": [
        "radiant"
    ],
    "radiateur": [
        "radiateur"
    ],
    "radiateurs": [
        "radiateur"
    ],
    "radiation": [
        "radiation"
    ],
    "radiations": [
        "radiation"
    ],
    "radiative": [
        "radiatif"
    ],
    "radiaux": [
        "radial"
    ],
    "radical": [
        "radical"
    ],
    "radicale": [
        "radical"
    ],
    "radicalement": [
        "radicalement"
    ],
    "radicales": [
        "radical"
    ],
    "radicalisation": [
        "radicalisation"
    ],
    "radicaliser": [
        "radicaliser"
    ],
    "radicalisme": [
        "radicalisme"
    ],
    "radicalise": [
        "radicaliser"
    ],
    "radicaux": [
        "radical"
    ],
    "radicelles": [
        "radicelle"
    ],
    "radiculaire": [
        "radiculaire"
    ],
    "radicule": [
        "radicule"
    ],
    "radicules": [
        "radicule"
    ],
    "radier": [
        "radier"
    ],
    "radiers": [
        "radier"
    ],
    "radiesthesiste": [
        "radiesthesiste"
    ],
    "radieuse": [
        "radieux"
    ],
    "radieusement": [
        "radieusement"
    ],
    "radieuses": [
        "radieux"
    ],
    "radieux": [
        "radieux"
    ],
    "radin": [
        "radin"
    ],
    "radinait": [
        "radiner"
    ],
    "radine": [
        "radin",
        "radiner"
    ],
    "radinent": [
        "radiner"
    ],
    "radiner": [
        "radiner"
    ],
    "radinerie": [
        "radinerie"
    ],
    "radines": [
        "radin",
        "radiner"
    ],
    "radinez": [
        "radiner"
    ],
    "radins": [
        "radin"
    ],
    "radinee": [
        "radiner"
    ],
    "radio": [
        "radio"
    ],
    "radioactif": [
        "radioactif"
    ],
    "radioactifs": [
        "radioactif"
    ],
    "radioactive": [
        "radioactif"
    ],
    "radioactives": [
        "radioactif"
    ],
    "radioactivite": [
        "radioactivite"
    ],
    "radioamateur": [
        "radioamateur"
    ],
    "radioastronome": [
        "radioastronome"
    ],
    "radiobalisage": [
        "radiobalisage"
    ],
    "radiobalise": [
        "radiobalise"
    ],
    "radiocassette": [
        "radiocassette"
    ],
    "radiodiffusion": [
        "radiodiffusion"
    ],
    "radiodiffuse": [
        "radiodiffuser"
    ],
    "radiodiffusee": [
        "radiodiffuser"
    ],
    "radiodiffusees": [
        "radiodiffuser"
    ],
    "radiogoniometre": [
        "radiogoniometre"
    ],
    "radiogoniometrique": [
        "radiogoniometrique"
    ],
    "radiogramme": [
        "radiogramme"
    ],
    "radiogrammes": [
        "radiogramme"
    ],
    "radiographiant": [
        "radiographier"
    ],
    "radiographie": [
        "radiographie",
        "radiographier"
    ],
    "radiographient": [
        "radiographier"
    ],
    "radiographier": [
        "radiographier"
    ],
    "radiographies": [
        "radiographie",
        "radiographier"
    ],
    "radiographique": [
        "radiographique"
    ],
    "radiographiee": [
        "radiographier"
    ],
    "radioguidage": [
        "radioguidage"
    ],
    "radioguidera": [
        "radioguider"
    ],
    "radiologie": [
        "radiologie"
    ],
    "radiologique": [
        "radiologique"
    ],
    "radiologiques": [
        "radiologique"
    ],
    "radiologiste": [
        "radiologiste"
    ],
    "radiologue": [
        "radiologue"
    ],
    "radiologues": [
        "radiologue"
    ],
    "radiometre": [
        "radiometre"
    ],
    "radiometres": [
        "radiometre"
    ],
    "radiometrie": [
        "radiometrie"
    ],
    "radiophare": [
        "radiophare"
    ],
    "radiophonie": [
        "radiophonie"
    ],
    "radiophonique": [
        "radiophonique"
    ],
    "radiophoniques": [
        "radiophonique"
    ],
    "radioreveil": [
        "radioreveil"
    ],
    "radios": [
        "radio"
    ],
    "radioscopie": [
        "radioscopie"
    ],
    "radioscopique": [
        "radioscopique"
    ],
    "radioscopiques": [
        "radioscopique"
    ],
    "radiosonde": [
        "radiosonde"
    ],
    "radiotherapie": [
        "radiotherapie"
    ],
    "radiotelescope": [
        "radiotelescope"
    ],
    "radiotelescopes": [
        "radiotelescope"
    ],
    "radiotelegraphie": [
        "radiotelegraphie"
    ],
    "radiotelegraphiste": [
        "radiotelegraphiste"
    ],
    "radiotelephone": [
        "radiotelephone"
    ],
    "radiotelephones": [
        "radiotelephone"
    ],
    "radiotelephonie": [
        "radiotelephonie"
    ],
    "radiotelephonique": [
        "radiotelephonique"
    ],
    "radioelectrique": [
        "radioelectrique"
    ],
    "radioelement": [
        "radioelement"
    ],
    "radis": [
        "radis"
    ],
    "radium": [
        "radium"
    ],
    "radius": [
        "radius"
    ],
    "radie": [
        "radier",
        "radie"
    ],
    "radiee": [
        "radier",
        "radie"
    ],
    "radies": [
        "radier",
        "radie"
    ],
    "radja": [
        "radja"
    ],
    "radjah": [
        "radjah"
    ],
    "radjahs": [
        "radjah"
    ],
    "radon": [
        "radon"
    ],
    "radotage": [
        "radotage"
    ],
    "radotages": [
        "radotage"
    ],
    "radotait": [
        "radoter"
    ],
    "radotant": [
        "radoter"
    ],
    "radote": [
        "radoter"
    ],
    "radotent": [
        "radoter"
    ],
    "radoter": [
        "radoter"
    ],
    "radotes": [
        "radoter"
    ],
    "radoteur": [
        "radoteur"
    ],
    "radoteurs": [
        "radoteur"
    ],
    "radoteuses": [
        "radoteur"
    ],
    "radotez": [
        "radoter"
    ],
    "radoub": [
        "radoub"
    ],
    "radoubait": [
        "radouber"
    ],
    "radouber": [
        "radouber"
    ],
    "radoubeur": [
        "radoubeur"
    ],
    "radouci": [
        "radoucir"
    ],
    "radoucie": [
        "radoucir"
    ],
    "radoucir": [
        "radoucir"
    ],
    "radouciraient": [
        "radoucir"
    ],
    "radoucis": [
        "radoucir"
    ],
    "radoucissais": [
        "radoucir"
    ],
    "radoucissait": [
        "radoucir"
    ],
    "radoucissement": [
        "radoucissement"
    ],
    "radoucit": [
        "radoucir"
    ],
    "rads": [
        "rad"
    ],
    "radome": [
        "radome"
    ],
    "rafa": [
        "rafer"
    ],
    "rafale": [
        "rafale"
    ],
    "rafales": [
        "rafale"
    ],
    "rafe": [
        "rafer"
    ],
    "raff": [
        "raff"
    ],
    "raffermi": [
        "raffermir"
    ],
    "raffermie": [
        "raffermir"
    ],
    "raffermir": [
        "raffermir"
    ],
    "raffermira": [
        "raffermir"
    ],
    "raffermis": [
        "raffermir"
    ],
    "raffermissait": [
        "raffermir"
    ],
    "raffermissent": [
        "raffermir"
    ],
    "raffermit": [
        "raffermir"
    ],
    "raffinage": [
        "raffinage"
    ],
    "raffinait": [
        "raffiner"
    ],
    "raffinant": [
        "raffiner"
    ],
    "raffine": [
        "raffine",
        "raffiner"
    ],
    "raffinement": [
        "raffinement"
    ],
    "raffinements": [
        "raffinement"
    ],
    "raffiner": [
        "raffiner"
    ],
    "raffinerie": [
        "raffinerie"
    ],
    "raffineries": [
        "raffinerie"
    ],
    "raffineur": [
        "raffineur"
    ],
    "raffinee": [
        "raffine",
        "raffiner"
    ],
    "raffinees": [
        "raffine",
        "raffiner"
    ],
    "raffines": [
        "raffine",
        "raffiner"
    ],
    "raffolaient": [
        "raffoler"
    ],
    "raffolais": [
        "raffoler"
    ],
    "raffolait": [
        "raffoler"
    ],
    "raffolant": [
        "raffoler"
    ],
    "raffole": [
        "raffoler"
    ],
    "raffolent": [
        "raffoler"
    ],
    "raffoler": [
        "raffoler"
    ],
    "raffoleront": [
        "raffoler"
    ],
    "raffoles": [
        "raffoler"
    ],
    "raffolez": [
        "raffoler"
    ],
    "raffoliez": [
        "raffoler"
    ],
    "raffut": [
        "raffut"
    ],
    "raffuts": [
        "raffut"
    ],
    "rafiau": [
        "rafiau"
    ],
    "rafiot": [
        "rafiot"
    ],
    "rafiots": [
        "rafiot"
    ],
    "rafistola": [
        "rafistoler"
    ],
    "rafistolage": [
        "rafistolage"
    ],
    "rafistolages": [
        "rafistolage"
    ],
    "rafistolaient": [
        "rafistoler"
    ],
    "rafistolais": [
        "rafistoler"
    ],
    "rafistolait": [
        "rafistoler"
    ],
    "rafistole": [
        "rafistoler"
    ],
    "rafistoler": [
        "rafistoler"
    ],
    "rafistolez": [
        "rafistoler"
    ],
    "rafistolee": [
        "rafistoler"
    ],
    "rafistolees": [
        "rafistoler"
    ],
    "rafistoles": [
        "rafistoler"
    ],
    "rafla": [
        "rafler"
    ],
    "raflais": [
        "rafler"
    ],
    "raflait": [
        "rafler"
    ],
    "raflant": [
        "rafler"
    ],
    "rafle": [
        "rafler",
        "rafle"
    ],
    "raflent": [
        "rafler"
    ],
    "rafler": [
        "rafler"
    ],
    "raflera": [
        "rafler"
    ],
    "raflerai": [
        "rafler"
    ],
    "raflerait": [
        "rafler"
    ],
    "rafles": [
        "rafler",
        "rafle"
    ],
    "raflez": [
        "rafler"
    ],
    "raflee": [
        "rafler"
    ],
    "raflees": [
        "rafler"
    ],
    "rafraichi": [
        "rafraichir"
    ],
    "rafraichie": [
        "rafraichir"
    ],
    "rafraichies": [
        "rafraichir"
    ],
    "rafraichir": [
        "rafraichir"
    ],
    "rafraichira": [
        "rafraichir"
    ],
    "rafraichirais": [
        "rafraichir"
    ],
    "rafraichirait": [
        "rafraichir"
    ],
    "rafraichirent": [
        "rafraichir"
    ],
    "rafraichiront": [
        "rafraichir"
    ],
    "rafraichis": [
        "rafraichir"
    ],
    "rafraichissaient": [
        "rafraichir"
    ],
    "rafraichissais": [
        "rafraichir"
    ],
    "rafraichissait": [
        "rafraichir"
    ],
    "rafraichissant": [
        "rafraichissant",
        "rafraichir"
    ],
    "rafraichissante": [
        "rafraichissant"
    ],
    "rafraichissantes": [
        "rafraichissant"
    ],
    "rafraichissants": [
        "rafraichissant"
    ],
    "rafraichisse": [
        "rafraichir"
    ],
    "rafraichissement": [
        "rafraichissement"
    ],
    "rafraichissements": [
        "rafraichissement"
    ],
    "rafraichissent": [
        "rafraichir"
    ],
    "rafraichisseur": [
        "rafraichisseur"
    ],
    "rafraichissez": [
        "rafraichir"
    ],
    "rafraichissoir": [
        "rafraichissoir"
    ],
    "rafraichissoirs": [
        "rafraichissoir"
    ],
    "rafraichissons": [
        "rafraichir"
    ],
    "rafraichit": [
        "rafraichir"
    ],
    "raft": [
        "raft"
    ],
    "rafting": [
        "raft",
        "rafting"
    ],
    "rag": [
        "rag"
    ],
    "raga": [
        "raga"
    ],
    "ragaillardi": [
        "ragaillardir"
    ],
    "ragaillardie": [
        "ragaillardir"
    ],
    "ragaillardir": [
        "ragaillardir"
    ],
    "ragaillardira": [
        "ragaillardir"
    ],
    "ragaillardirait": [
        "ragaillardir"
    ],
    "ragaillardis": [
        "ragaillardir"
    ],
    "ragaillardissaient": [
        "ragaillardir"
    ],
    "ragaillardisse": [
        "ragaillardir"
    ],
    "ragaillardit": [
        "ragaillardir"
    ],
    "rage": [
        "rage",
        "rager"
    ],
    "ragea": [
        "rager"
    ],
    "rageaient": [
        "rager"
    ],
    "rageais": [
        "rager"
    ],
    "rageait": [
        "rager"
    ],
    "rageant": [
        "rageant",
        "rager"
    ],
    "ragent": [
        "rager"
    ],
    "rager": [
        "rager"
    ],
    "rages": [
        "rage",
        "rager"
    ],
    "rageur": [
        "rageur"
    ],
    "rageurs": [
        "rageur"
    ],
    "rageuse": [
        "rageur"
    ],
    "rageusement": [
        "rageusement"
    ],
    "rageuses": [
        "rageur"
    ],
    "ragez": [
        "rager"
    ],
    "raglan": [
        "raglan"
    ],
    "raglans": [
        "raglan"
    ],
    "ragnagnas": [
        "ragnagnas"
    ],
    "ragondins": [
        "ragondin"
    ],
    "ragot": [
        "ragot"
    ],
    "ragota": [
        "ragoter"
    ],
    "ragotait": [
        "ragoter"
    ],
    "ragote": [
        "ragoter"
    ],
    "ragoter": [
        "ragoter"
    ],
    "ragots": [
        "ragot"
    ],
    "ragougnasse": [
        "ragougnasse"
    ],
    "ragougnasses": [
        "ragougnasse"
    ],
    "ragout": [
        "ragout"
    ],
    "ragoutant": [
        "ragoutant",
        "ragouter"
    ],
    "ragoutante": [
        "ragoutant"
    ],
    "ragoutantes": [
        "ragoutant"
    ],
    "ragoutants": [
        "ragoutant"
    ],
    "ragouts": [
        "ragout"
    ],
    "ragrafait": [
        "ragrafer"
    ],
    "ragrafant": [
        "ragrafer"
    ],
    "ragrafe": [
        "ragrafer"
    ],
    "ragtime": [
        "ragtime"
    ],
    "rai": [
        "rai"
    ],
    "raid": [
        "raid"
    ],
    "raide": [
        "raide"
    ],
    "raidement": [
        "raidement"
    ],
    "raider": [
        "raider"
    ],
    "raiders": [
        "raider"
    ],
    "raides": [
        "raide"
    ],
    "raideur": [
        "raideur"
    ],
    "raidi": [
        "raidir"
    ],
    "raidie": [
        "raidir"
    ],
    "raidies": [
        "raidir"
    ],
    "raidillon": [
        "raidillon"
    ],
    "raidillons": [
        "raidillon"
    ],
    "raidir": [
        "raidir"
    ],
    "raidirent": [
        "raidir"
    ],
    "raidis": [
        "raidir"
    ],
    "raidissaient": [
        "raidir"
    ],
    "raidissais": [
        "raidir"
    ],
    "raidissait": [
        "raidir"
    ],
    "raidissant": [
        "raidir"
    ],
    "raidisse": [
        "raidir"
    ],
    "raidissement": [
        "raidissement"
    ],
    "raidissements": [
        "raidissement"
    ],
    "raidissent": [
        "raidir"
    ],
    "raidissez": [
        "raidir"
    ],
    "raidit": [
        "raidir"
    ],
    "raids": [
        "raid"
    ],
    "raie": [
        "raie",
        "rayer"
    ],
    "raient": [
        "rayer"
    ],
    "raies": [
        "raie",
        "rayer"
    ],
    "raifort": [
        "raifort"
    ],
    "rail": [
        "rail"
    ],
    "railla": [
        "railler"
    ],
    "raillaient": [
        "railler"
    ],
    "raillait": [
        "railler"
    ],
    "raillant": [
        "railler"
    ],
    "raille": [
        "railler"
    ],
    "railler": [
        "railler"
    ],
    "raillera": [
        "railler"
    ],
    "raillerai": [
        "railler"
    ],
    "raillerie": [
        "raillerie"
    ],
    "railleries": [
        "raillerie"
    ],
    "railleur": [
        "railleur"
    ],
    "railleurs": [
        "railleur"
    ],
    "railleuse": [
        "railleur"
    ],
    "railleuses": [
        "railleur"
    ],
    "raillez": [
        "railler"
    ],
    "raillerent": [
        "railler"
    ],
    "raillee": [
        "railler"
    ],
    "railles": [
        "railler"
    ],
    "rails": [
        "rail"
    ],
    "railway": [
        "railway"
    ],
    "rain": [
        "rain"
    ],
    "raine": [
        "rainer"
    ],
    "rainer": [
        "rainer"
    ],
    "raines": [
        "rainer"
    ],
    "rainette": [
        "rainette"
    ],
    "rainettes": [
        "rainette"
    ],
    "raineuse": [
        "raineuse"
    ],
    "rainure": [
        "rainurer",
        "rainure"
    ],
    "rainurer": [
        "rainurer"
    ],
    "rainures": [
        "rainurer",
        "rainure"
    ],
    "raiponce": [
        "raiponce"
    ],
    "raire": [
        "raire"
    ],
    "rais": [
        "rai",
        "rais"
    ],
    "raisin": [
        "raisin"
    ],
    "raisinets": [
        "raisinet"
    ],
    "raisins": [
        "raisin"
    ],
    "raisine": [
        "raisine"
    ],
    "raison": [
        "raison"
    ],
    "raisonna": [
        "raisonner"
    ],
    "raisonnable": [
        "raisonnable"
    ],
    "raisonnablement": [
        "raisonnablement"
    ],
    "raisonnables": [
        "raisonnable"
    ],
    "raisonnai": [
        "raisonner"
    ],
    "raisonnaient": [
        "raisonner"
    ],
    "raisonnais": [
        "raisonner"
    ],
    "raisonnait": [
        "raisonner"
    ],
    "raisonnant": [
        "raisonner"
    ],
    "raisonnante": [
        "raisonnant"
    ],
    "raisonnassent": [
        "raisonner"
    ],
    "raisonne": [
        "raisonne",
        "raisonner"
    ],
    "raisonnement": [
        "raisonnement"
    ],
    "raisonnements": [
        "raisonnement"
    ],
    "raisonnent": [
        "raisonner"
    ],
    "raisonner": [
        "raisonner"
    ],
    "raisonnes": [
        "raisonner"
    ],
    "raisonneur": [
        "raisonneur"
    ],
    "raisonneurs": [
        "raisonneur"
    ],
    "raisonneuse": [
        "raisonneur"
    ],
    "raisonnez": [
        "raisonner"
    ],
    "raisonniez": [
        "raisonner"
    ],
    "raisonnons": [
        "raisonner"
    ],
    "raisonnee": [
        "raisonne",
        "raisonner"
    ],
    "raisons": [
        "raison"
    ],
    "rait": [
        "raire"
    ],
    "raites": [
        "raire"
    ],
    "raja": [
        "raja"
    ],
    "rajah": [
        "rajah"
    ],
    "rajahs": [
        "rajah"
    ],
    "rajeuni": [
        "rajeunir"
    ],
    "rajeunie": [
        "rajeunir"
    ],
    "rajeunies": [
        "rajeunir"
    ],
    "rajeunir": [
        "rajeunir"
    ],
    "rajeunira": [
        "rajeunir"
    ],
    "rajeunirai": [
        "rajeunir"
    ],
    "rajeunirait": [
        "rajeunir"
    ],
    "rajeunirez": [
        "rajeunir"
    ],
    "rajeunis": [
        "rajeunir"
    ],
    "rajeunissaient": [
        "rajeunir"
    ],
    "rajeunissais": [
        "rajeunir"
    ],
    "rajeunissait": [
        "rajeunir"
    ],
    "rajeunissant": [
        "rajeunissant",
        "rajeunir"
    ],
    "rajeunissante": [
        "rajeunissant"
    ],
    "rajeunisse": [
        "rajeunir"
    ],
    "rajeunissement": [
        "rajeunissement"
    ],
    "rajeunissent": [
        "rajeunir"
    ],
    "rajeunisseurs": [
        "rajeunisseur"
    ],
    "rajeunissez": [
        "rajeunir"
    ],
    "rajeunissons": [
        "rajeunir"
    ],
    "rajeunit": [
        "rajeunir"
    ],
    "rajout": [
        "rajout"
    ],
    "rajouta": [
        "rajouter"
    ],
    "rajoutaient": [
        "rajouter"
    ],
    "rajoutais": [
        "rajouter"
    ],
    "rajoutait": [
        "rajouter"
    ],
    "rajoutant": [
        "rajouter"
    ],
    "rajoute": [
        "rajouter"
    ],
    "rajoutent": [
        "rajouter"
    ],
    "rajouter": [
        "rajouter"
    ],
    "rajoutera": [
        "rajouter"
    ],
    "rajouterais": [
        "rajouter"
    ],
    "rajouterait": [
        "rajouter"
    ],
    "rajouteras": [
        "rajouter"
    ],
    "rajouterez": [
        "rajouter"
    ],
    "rajoutes": [
        "rajouter"
    ],
    "rajoutez": [
        "rajouter"
    ],
    "rajoutons": [
        "rajouter"
    ],
    "rajouts": [
        "rajout"
    ],
    "rajoutee": [
        "rajouter"
    ],
    "rajoutees": [
        "rajouter"
    ],
    "rajusta": [
        "rajuster"
    ],
    "rajustaient": [
        "rajuster"
    ],
    "rajustais": [
        "rajuster"
    ],
    "rajustait": [
        "rajuster"
    ],
    "rajustant": [
        "rajuster"
    ],
    "rajuste": [
        "rajuster"
    ],
    "rajustement": [
        "rajustement"
    ],
    "rajustent": [
        "rajuster"
    ],
    "rajuster": [
        "rajuster"
    ],
    "rajusteront": [
        "rajuster"
    ],
    "rajustee": [
        "rajuster"
    ],
    "rajustees": [
        "rajuster"
    ],
    "raki": [
        "raki"
    ],
    "ralbol": [
        "ralbol"
    ],
    "ralenti": [
        "ralentir",
        "ralenti"
    ],
    "ralentie": [
        "ralentir"
    ],
    "ralenties": [
        "ralentir"
    ],
    "ralentir": [
        "ralentir"
    ],
    "ralentira": [
        "ralentir"
    ],
    "ralentirai": [
        "ralentir"
    ],
    "ralentiraient": [
        "ralentir"
    ],
    "ralentirais": [
        "ralentir"
    ],
    "ralentirait": [
        "ralentir"
    ],
    "ralentirent": [
        "ralentir"
    ],
    "ralentirez": [
        "ralentir"
    ],
    "ralentiriez": [
        "ralentir"
    ],
    "ralentiront": [
        "ralentir"
    ],
    "ralentis": [
        "ralentir",
        "ralenti"
    ],
    "ralentissaient": [
        "ralentir"
    ],
    "ralentissais": [
        "ralentir"
    ],
    "ralentissait": [
        "ralentir"
    ],
    "ralentissant": [
        "ralentir"
    ],
    "ralentisse": [
        "ralentir"
    ],
    "ralentissement": [
        "ralentissement"
    ],
    "ralentissements": [
        "ralentissement"
    ],
    "ralentissent": [
        "ralentir"
    ],
    "ralentisseur": [
        "ralentisseur"
    ],
    "ralentisseurs": [
        "ralentisseur"
    ],
    "ralentissez": [
        "ralentir"
    ],
    "ralentissiez": [
        "ralentir"
    ],
    "ralentissions": [
        "ralentir"
    ],
    "ralentissons": [
        "ralentir"
    ],
    "ralentit": [
        "ralentir"
    ],
    "ralingue": [
        "ralingue"
    ],
    "ralingues": [
        "ralingue"
    ],
    "raller": [
        "raller"
    ],
    "rallia": [
        "rallier"
    ],
    "ralliai": [
        "rallier"
    ],
    "ralliaient": [
        "rallier"
    ],
    "ralliais": [
        "rallier"
    ],
    "ralliait": [
        "rallier"
    ],
    "ralliant": [
        "rallier"
    ],
    "ralliassent": [
        "rallier"
    ],
    "rallie": [
        "rallier",
        "rallie"
    ],
    "ralliement": [
        "ralliement"
    ],
    "ralliements": [
        "ralliement"
    ],
    "rallient": [
        "rallier"
    ],
    "rallier": [
        "rallier"
    ],
    "ralliera": [
        "rallier"
    ],
    "rallierai": [
        "rallier"
    ],
    "rallieraient": [
        "rallier"
    ],
    "rallierait": [
        "rallier"
    ],
    "rallieriez": [
        "rallier"
    ],
    "rallierons": [
        "rallier"
    ],
    "rallieront": [
        "rallier"
    ],
    "rallies": [
        "rally",
        "rallier",
        "rallie"
    ],
    "ralliez": [
        "rallier"
    ],
    "rallions": [
        "raller"
    ],
    "rallierent": [
        "rallier"
    ],
    "ralliee": [
        "rallier"
    ],
    "ralliees": [
        "rallier"
    ],
    "rallonge": [
        "rallonge",
        "rallonger"
    ],
    "rallongea": [
        "rallonger"
    ],
    "rallongeaient": [
        "rallonger"
    ],
    "rallongeait": [
        "rallonger"
    ],
    "rallongement": [
        "rallongement"
    ],
    "rallongent": [
        "rallonger"
    ],
    "rallonger": [
        "rallonger"
    ],
    "rallongerait": [
        "rallonger"
    ],
    "rallonges": [
        "rallonge",
        "rallonger"
    ],
    "rallongez": [
        "rallonger"
    ],
    "rallongee": [
        "rallonger"
    ],
    "ralluma": [
        "rallumer"
    ],
    "rallumage": [
        "rallumage"
    ],
    "rallumai": [
        "rallumer"
    ],
    "rallumaient": [
        "rallumer"
    ],
    "rallumais": [
        "rallumer"
    ],
    "rallumait": [
        "rallumer"
    ],
    "rallumant": [
        "rallumer"
    ],
    "rallume": [
        "rallumer"
    ],
    "rallument": [
        "rallumer"
    ],
    "rallumer": [
        "rallumer"
    ],
    "rallumerai": [
        "rallumer"
    ],
    "rallumeront": [
        "rallumer"
    ],
    "rallumes": [
        "rallumer"
    ],
    "rallumez": [
        "rallumer"
    ],
    "rallumons": [
        "rallumer"
    ],
    "rallumerent": [
        "rallumer"
    ],
    "rallumee": [
        "rallumer"
    ],
    "rallumees": [
        "rallumer"
    ],
    "rallye": [
        "rallye"
    ],
    "rallyes": [
        "rallye"
    ],
    "rallege": [
        "ralleger"
    ],
    "ralleger": [
        "ralleger"
    ],
    "ram": [
        "ram"
    ],
    "rama": [
        "ramer"
    ],
    "ramadan": [
        "ramadan"
    ],
    "ramage": [
        "ramage"
    ],
    "ramageait": [
        "ramager"
    ],
    "ramager": [
        "ramager"
    ],
    "ramages": [
        "ramage"
    ],
    "ramai": [
        "ramer"
    ],
    "ramaient": [
        "ramer"
    ],
    "ramais": [
        "ramer"
    ],
    "ramait": [
        "ramer"
    ],
    "ramant": [
        "ramer"
    ],
    "ramarraient": [
        "ramarrer"
    ],
    "ramarrer": [
        "ramarrer"
    ],
    "ramas": [
        "ramas",
        "ramer"
    ],
    "ramassa": [
        "ramasser"
    ],
    "ramassage": [
        "ramassage"
    ],
    "ramassages": [
        "ramassage"
    ],
    "ramassai": [
        "ramasser"
    ],
    "ramassaient": [
        "ramasser"
    ],
    "ramassais": [
        "ramasser"
    ],
    "ramassait": [
        "ramasser"
    ],
    "ramassant": [
        "ramasser"
    ],
    "ramasse": [
        "ramasse",
        "ramasser"
    ],
    "ramassent": [
        "ramasser"
    ],
    "ramasser": [
        "ramasser"
    ],
    "ramassera": [
        "ramasser"
    ],
    "ramasserai": [
        "ramasser"
    ],
    "ramasseraient": [
        "ramasser"
    ],
    "ramasserais": [
        "ramasser"
    ],
    "ramasserait": [
        "ramasser"
    ],
    "ramasseras": [
        "ramasser"
    ],
    "ramasseront": [
        "ramasser"
    ],
    "ramasses": [
        "ramasse",
        "ramasser"
    ],
    "ramasseur": [
        "ramasseur"
    ],
    "ramasseurs": [
        "ramasseur"
    ],
    "ramasseuse": [
        "ramasseur"
    ],
    "ramassez": [
        "ramasser"
    ],
    "ramassiez": [
        "ramasser"
    ],
    "ramassions": [
        "ramasser"
    ],
    "ramassis": [
        "ramassis"
    ],
    "ramassons": [
        "ramasser"
    ],
    "ramassat": [
        "ramasser"
    ],
    "ramasserent": [
        "ramasser"
    ],
    "ramassee": [
        "ramasse",
        "ramasser"
    ],
    "ramassees": [
        "ramasse",
        "ramasser"
    ],
    "rambarde": [
        "rambarde"
    ],
    "rambardes": [
        "rambarde"
    ],
    "rambin": [
        "rambin"
    ],
    "rambinait": [
        "rambiner"
    ],
    "rambine": [
        "rambiner"
    ],
    "rambinent": [
        "rambiner"
    ],
    "rambiner": [
        "rambiner"
    ],
    "rambineur": [
        "rambineur"
    ],
    "rambla": [
        "rambla"
    ],
    "rambot": [
        "rambot"
    ],
    "rambour": [
        "rambour"
    ],
    "ramdam": [
        "ramdam"
    ],
    "ramdams": [
        "ramdam"
    ],
    "rame": [
        "rame",
        "ramer"
    ],
    "rameau": [
        "rameau"
    ],
    "rameaux": [
        "rameau"
    ],
    "ramena": [
        "ramener"
    ],
    "ramenai": [
        "ramener"
    ],
    "ramenaient": [
        "ramener"
    ],
    "ramenais": [
        "ramener"
    ],
    "ramenait": [
        "ramener"
    ],
    "ramenant": [
        "ramener"
    ],
    "ramenard": [
        "ramenard"
    ],
    "ramenards": [
        "ramenard"
    ],
    "ramende": [
        "ramender"
    ],
    "ramener": [
        "ramener"
    ],
    "ramenez": [
        "ramener"
    ],
    "rameniez": [
        "ramener"
    ],
    "ramenions": [
        "ramener"
    ],
    "ramenons": [
        "ramener"
    ],
    "rament": [
        "ramer"
    ],
    "ramenames": [
        "ramener"
    ],
    "ramenat": [
        "ramener"
    ],
    "ramenerent": [
        "ramener"
    ],
    "ramene": [
        "ramener"
    ],
    "ramenee": [
        "ramener"
    ],
    "ramenees": [
        "ramener"
    ],
    "ramenes": [
        "ramener"
    ],
    "ramer": [
        "ramer"
    ],
    "ramera": [
        "ramer"
    ],
    "rameras": [
        "ramer"
    ],
    "ramerons": [
        "ramer"
    ],
    "rameront": [
        "ramer"
    ],
    "rames": [
        "rame",
        "ramer"
    ],
    "ramette": [
        "ramette"
    ],
    "rameur": [
        "rameur"
    ],
    "rameurs": [
        "rameur"
    ],
    "rameutais": [
        "rameuter"
    ],
    "rameutait": [
        "rameuter"
    ],
    "rameutant": [
        "rameuter"
    ],
    "rameute": [
        "rameuter"
    ],
    "rameutent": [
        "rameuter"
    ],
    "rameuter": [
        "rameuter"
    ],
    "rameutez": [
        "rameuter"
    ],
    "rameutons": [
        "rameuter"
    ],
    "rameutees": [
        "rameuter"
    ],
    "rameutes": [
        "rameuter"
    ],
    "ramez": [
        "ramer"
    ],
    "rami": [
        "rami"
    ],
    "ramier": [
        "ramier"
    ],
    "ramiers": [
        "ramier"
    ],
    "ramies": [
        "ramie"
    ],
    "ramifia": [
        "ramifier"
    ],
    "ramifiaient": [
        "ramifier"
    ],
    "ramifiait": [
        "ramifier"
    ],
    "ramifiant": [
        "ramifiant"
    ],
    "ramification": [
        "ramification"
    ],
    "ramifications": [
        "ramification"
    ],
    "ramifie": [
        "ramifie",
        "ramifier"
    ],
    "ramifient": [
        "ramifier"
    ],
    "ramifier": [
        "ramifier"
    ],
    "ramifiee": [
        "ramifie",
        "ramifier"
    ],
    "ramifiees": [
        "ramifie"
    ],
    "ramifies": [
        "ramifie"
    ],
    "ramille": [
        "ramille"
    ],
    "ramilles": [
        "ramille"
    ],
    "raminagrobis": [
        "raminagrobis"
    ],
    "ramions": [
        "ramer"
    ],
    "ramis": [
        "rami"
    ],
    "ramolli": [
        "ramollir",
        "ramolli"
    ],
    "ramollie": [
        "ramollir",
        "ramolli"
    ],
    "ramollies": [
        "ramollir",
        "ramolli"
    ],
    "ramollir": [
        "ramollir"
    ],
    "ramollirent": [
        "ramollir"
    ],
    "ramollis": [
        "ramollir",
        "ramolli"
    ],
    "ramollissait": [
        "ramollir"
    ],
    "ramollisse": [
        "ramollir"
    ],
    "ramollissement": [
        "ramollissement"
    ],
    "ramollissent": [
        "ramollir"
    ],
    "ramollit": [
        "ramollir"
    ],
    "ramollo": [
        "ramollo"
    ],
    "ramollos": [
        "ramollo"
    ],
    "ramon": [
        "ramon"
    ],
    "ramonage": [
        "ramonage"
    ],
    "ramonages": [
        "ramonage"
    ],
    "ramonait": [
        "ramoner"
    ],
    "ramonant": [
        "ramoner"
    ],
    "ramone": [
        "ramoner"
    ],
    "ramonent": [
        "ramoner"
    ],
    "ramoner": [
        "ramoner"
    ],
    "ramones": [
        "ramoner"
    ],
    "ramoneur": [
        "ramoneur"
    ],
    "ramoneurs": [
        "ramoneur"
    ],
    "ramons": [
        "ramer"
    ],
    "ramonee": [
        "ramoner"
    ],
    "ramonees": [
        "ramoner"
    ],
    "rampa": [
        "ramper"
    ],
    "rampai": [
        "ramper"
    ],
    "rampaient": [
        "ramper"
    ],
    "rampais": [
        "ramper"
    ],
    "rampait": [
        "ramper"
    ],
    "rampant": [
        "rampant",
        "ramper"
    ],
    "rampante": [
        "rampant"
    ],
    "rampantes": [
        "rampant"
    ],
    "rampants": [
        "rampant"
    ],
    "rampe": [
        "ramper",
        "rampe"
    ],
    "rampement": [
        "rampement"
    ],
    "rampements": [
        "rampement"
    ],
    "rampent": [
        "ramper"
    ],
    "ramper": [
        "ramper"
    ],
    "rampera": [
        "ramper"
    ],
    "ramperai": [
        "ramper"
    ],
    "ramperaient": [
        "ramper"
    ],
    "ramperais": [
        "ramper"
    ],
    "ramperas": [
        "ramper"
    ],
    "ramperez": [
        "ramper"
    ],
    "rampes": [
        "ramper",
        "rampe"
    ],
    "rampez": [
        "ramper"
    ],
    "rampiez": [
        "ramper"
    ],
    "rampions": [
        "ramper"
    ],
    "ramponneau": [
        "ramponneau"
    ],
    "rampons": [
        "ramper"
    ],
    "ramperent": [
        "ramper"
    ],
    "rampee": [
        "ramper"
    ],
    "rams": [
        "rams",
        "ram"
    ],
    "ramser": [
        "ramser"
    ],
    "ramure": [
        "ramure"
    ],
    "ramures": [
        "ramure"
    ],
    "ramenent": [
        "ramener"
    ],
    "ramenera": [
        "ramener"
    ],
    "ramenerai": [
        "ramener"
    ],
    "rameneraient": [
        "ramener"
    ],
    "ramenerais": [
        "ramener"
    ],
    "ramenerait": [
        "ramener"
    ],
    "rameneras": [
        "ramener"
    ],
    "ramenerez": [
        "ramener"
    ],
    "rameneriez": [
        "ramener"
    ],
    "ramenerions": [
        "ramener"
    ],
    "ramenerons": [
        "ramener"
    ],
    "rameneront": [
        "ramener"
    ],
    "ramerent": [
        "ramer"
    ],
    "ramee": [
        "ramee"
    ],
    "ramees": [
        "ramee",
        "ramer"
    ],
    "ran": [
        "ran",
        "run"
    ],
    "ranatres": [
        "ranatre"
    ],
    "rancard": [
        "rancard"
    ],
    "rancardait": [
        "rancarder"
    ],
    "rancarde": [
        "rancarder"
    ],
    "rancarder": [
        "rancarder"
    ],
    "rancardez": [
        "rancarder"
    ],
    "rancards": [
        "rancard"
    ],
    "rancardee": [
        "rancarder"
    ],
    "rancardes": [
        "rancarder"
    ],
    "rancart": [
        "rancart"
    ],
    "rancarts": [
        "rancart"
    ],
    "rance": [
        "rancer",
        "rance"
    ],
    "rances": [
        "rance"
    ],
    "ranch": [
        "ranch"
    ],
    "ranche": [
        "ranche"
    ],
    "rancher": [
        "rancher"
    ],
    "ranches": [
        "ranche",
        "ranch"
    ],
    "rancho": [
        "rancho"
    ],
    "ranchs": [
        "ranch"
    ],
    "ranci": [
        "ranci",
        "rancir"
    ],
    "rancie": [
        "ranci"
    ],
    "rancies": [
        "ranci",
        "rancir"
    ],
    "rancio": [
        "rancio"
    ],
    "rancir": [
        "rancir"
    ],
    "rancis": [
        "ranci",
        "rancir"
    ],
    "rancissait": [
        "rancir"
    ],
    "rancissure": [
        "rancissure"
    ],
    "rancit": [
        "rancir"
    ],
    "rancoeur": [
        "rancoeur"
    ],
    "rancoeurs": [
        "rancoeur"
    ],
    "rancune": [
        "rancune"
    ],
    "rancunes": [
        "rancune"
    ],
    "rancuneuses": [
        "rancuneux"
    ],
    "rancunier": [
        "rancunier"
    ],
    "rancuniers": [
        "rancunier"
    ],
    "rancuniere": [
        "rancunier"
    ],
    "rancunieres": [
        "rancunier"
    ],
    "randonnait": [
        "randonner"
    ],
    "randonne": [
        "randonner"
    ],
    "randonner": [
        "randonner"
    ],
    "randonneur": [
        "randonneur"
    ],
    "randonneurs": [
        "randonneur"
    ],
    "randonneuse": [
        "randonneur"
    ],
    "randonnez": [
        "randonner"
    ],
    "randonnee": [
        "randonner",
        "randonnee"
    ],
    "randonnees": [
        "randonner",
        "randonnee"
    ],
    "rang": [
        "ring",
        "rang"
    ],
    "range": [
        "range",
        "ranger"
    ],
    "rangea": [
        "ranger"
    ],
    "rangeai": [
        "ranger"
    ],
    "rangeaient": [
        "ranger"
    ],
    "rangeais": [
        "ranger"
    ],
    "rangeait": [
        "ranger"
    ],
    "rangeant": [
        "ranger"
    ],
    "rangement": [
        "rangement"
    ],
    "rangements": [
        "rangement"
    ],
    "rangent": [
        "ranger"
    ],
    "rangeons": [
        "ranger"
    ],
    "ranger": [
        "ranger"
    ],
    "rangera": [
        "ranger"
    ],
    "rangerai": [
        "ranger"
    ],
    "rangerais": [
        "ranger"
    ],
    "rangerait": [
        "ranger"
    ],
    "rangeras": [
        "ranger"
    ],
    "rangerez": [
        "ranger"
    ],
    "rangerons": [
        "ranger"
    ],
    "rangeront": [
        "ranger"
    ],
    "rangers": [
        "ranger"
    ],
    "ranges": [
        "range",
        "ranger"
    ],
    "rangez": [
        "ranger"
    ],
    "rangeames": [
        "ranger"
    ],
    "rangeat": [
        "ranger"
    ],
    "rangions": [
        "ranger"
    ],
    "rangs": [
        "rang"
    ],
    "rangerent": [
        "ranger"
    ],
    "rangee": [
        "rangee",
        "range",
        "ranger"
    ],
    "rangees": [
        "rangee",
        "range",
        "ranger"
    ],
    "rani": [
        "rani"
    ],
    "ranima": [
        "ranimer"
    ],
    "ranimaient": [
        "ranimer"
    ],
    "ranimait": [
        "ranimer"
    ],
    "ranimant": [
        "ranimer"
    ],
    "ranimation": [
        "ranimation"
    ],
    "ranime": [
        "ranimer"
    ],
    "raniment": [
        "ranimer"
    ],
    "ranimer": [
        "ranimer"
    ],
    "ranimera": [
        "ranimer"
    ],
    "ranimez": [
        "ranimer"
    ],
    "ranimions": [
        "ranimer"
    ],
    "ranimat": [
        "ranimer"
    ],
    "ranimerent": [
        "ranimer"
    ],
    "ranimee": [
        "ranimer"
    ],
    "ranimees": [
        "ranimer"
    ],
    "ranimes": [
        "ranimer"
    ],
    "rantanplan": [
        "rantanplan"
    ],
    "ranz": [
        "ranz"
    ],
    "rancon": [
        "rancon"
    ],
    "ranconnage": [
        "ranconnage"
    ],
    "ranconnaient": [
        "ranconner"
    ],
    "ranconnait": [
        "ranconner"
    ],
    "ranconne": [
        "ranconner"
    ],
    "ranconnement": [
        "ranconnement"
    ],
    "ranconner": [
        "ranconner"
    ],
    "ranconneurs": [
        "ranconneur"
    ],
    "ranconnee": [
        "ranconner"
    ],
    "ranconnees": [
        "ranconner"
    ],
    "ranconnes": [
        "ranconner"
    ],
    "rancons": [
        "rancon"
    ],
    "raout": [
        "raout"
    ],
    "raouts": [
        "raout"
    ],
    "rap": [
        "rap"
    ],
    "rapace": [
        "rapace"
    ],
    "rapaces": [
        "rapace"
    ],
    "rapacite": [
        "rapacite"
    ],
    "rapatria": [
        "rapatrier"
    ],
    "rapatriait": [
        "rapatrier"
    ],
    "rapatriant": [
        "rapatrier"
    ],
    "rapatrie": [
        "rapatrie",
        "rapatrier"
    ],
    "rapatriement": [
        "rapatriement"
    ],
    "rapatriements": [
        "rapatriement"
    ],
    "rapatrient": [
        "rapatrier"
    ],
    "rapatrier": [
        "rapatrier"
    ],
    "rapatriera": [
        "rapatrier"
    ],
    "rapatriez": [
        "rapatrier"
    ],
    "rapatriee": [
        "rapatrier"
    ],
    "rapatriees": [
        "rapatrier"
    ],
    "rapatries": [
        "rapatrie",
        "rapatrier"
    ],
    "rapetassage": [
        "rapetassage"
    ],
    "rapetassages": [
        "rapetassage"
    ],
    "rapetasser": [
        "rapetasser"
    ],
    "rapetasseur": [
        "rapetasseur"
    ],
    "rapetassions": [
        "rapetasser"
    ],
    "rapetasse": [
        "rapetasser"
    ],
    "rapetassees": [
        "rapetasser"
    ],
    "rapetasses": [
        "rapetasser"
    ],
    "rapetissaient": [
        "rapetisser"
    ],
    "rapetissais": [
        "rapetisser"
    ],
    "rapetissait": [
        "rapetisser"
    ],
    "rapetissant": [
        "rapetisser"
    ],
    "rapetisse": [
        "rapetisser"
    ],
    "rapetissement": [
        "rapetissement"
    ],
    "rapetissent": [
        "rapetisser"
    ],
    "rapetisser": [
        "rapetisser"
    ],
    "rapetissera": [
        "rapetisser"
    ],
    "rapetissez": [
        "rapetisser"
    ],
    "rapetissons": [
        "rapetisser"
    ],
    "rapetisserent": [
        "rapetisser"
    ],
    "rapetissee": [
        "rapetisser"
    ],
    "rapetissees": [
        "rapetisser"
    ],
    "rapetisses": [
        "rapetisser"
    ],
    "raphaelesque": [
        "raphaelesque"
    ],
    "raphia": [
        "raphia"
    ],
    "raphe": [
        "raphe"
    ],
    "rapiat": [
        "rapiat"
    ],
    "rapiater": [
        "rapiater"
    ],
    "rapiaterie": [
        "rapiaterie"
    ],
    "rapiats": [
        "rapiat"
    ],
    "rapide": [
        "rapide"
    ],
    "rapidement": [
        "rapidement"
    ],
    "rapides": [
        "rapide"
    ],
    "rapidite": [
        "rapidite"
    ],
    "rapidites": [
        "rapidite"
    ],
    "rapidos": [
        "rapidos"
    ],
    "rapin": [
        "rapin"
    ],
    "rapine": [
        "rapine"
    ],
    "rapinent": [
        "rapiner"
    ],
    "rapines": [
        "rapine",
        "rapiner"
    ],
    "rapins": [
        "rapin"
    ],
    "rapiere": [
        "rapiere"
    ],
    "rapiecer": [
        "rapiecer"
    ],
    "rapiecerait": [
        "rapiecer"
    ],
    "rapiece": [
        "rapiecer"
    ],
    "rapiecee": [
        "rapiecer"
    ],
    "rapiecees": [
        "rapiecer"
    ],
    "rapieces": [
        "rapiecer"
    ],
    "rapiecage": [
        "rapiecage"
    ],
    "rapiecages": [
        "rapiecage"
    ],
    "raplapla": [
        "raplapla"
    ],
    "rapointir": [
        "rapointir"
    ],
    "rappel": [
        "rappel"
    ],
    "rappela": [
        "rappeler"
    ],
    "rappelai": [
        "rappeler"
    ],
    "rappelaient": [
        "rappeler"
    ],
    "rappelais": [
        "rappeler"
    ],
    "rappelait": [
        "rappeler"
    ],
    "rappelant": [
        "rappeler"
    ],
    "rappeler": [
        "rappeler"
    ],
    "rappelez": [
        "rappeler"
    ],
    "rappeliez": [
        "rappeler"
    ],
    "rappelions": [
        "rappeler"
    ],
    "rappelle": [
        "rappeler"
    ],
    "rappellent": [
        "rappeler"
    ],
    "rappellera": [
        "rappeler"
    ],
    "rappellerai": [
        "rappeler"
    ],
    "rappelleraient": [
        "rappeler"
    ],
    "rappellerais": [
        "rappeler"
    ],
    "rappellerait": [
        "rappeler"
    ],
    "rappelleras": [
        "rappeler"
    ],
    "rappellerez": [
        "rappeler"
    ],
    "rappelleriez": [
        "rappeler"
    ],
    "rappellerons": [
        "rappeler"
    ],
    "rappelleront": [
        "rappeler"
    ],
    "rappelles": [
        "rappeler"
    ],
    "rappelons": [
        "rappeler"
    ],
    "rappels": [
        "rappel"
    ],
    "rappelames": [
        "rappeler"
    ],
    "rappelat": [
        "rappeler"
    ],
    "rappelerent": [
        "rappeler"
    ],
    "rappele": [
        "rappele",
        "rappeler"
    ],
    "rappelee": [
        "rappele",
        "rappeler"
    ],
    "rappeles": [
        "rappele",
        "rappeler"
    ],
    "rapper": [
        "rapper"
    ],
    "rappeur": [
        "rappeur"
    ],
    "rappeurs": [
        "rappeur"
    ],
    "rappeuse": [
        "rappeur"
    ],
    "rappliqua": [
        "rappliquer"
    ],
    "rappliquaient": [
        "rappliquer"
    ],
    "rappliquais": [
        "rappliquer"
    ],
    "rappliquait": [
        "rappliquer"
    ],
    "rapplique": [
        "rappliquer"
    ],
    "rappliquent": [
        "rappliquer"
    ],
    "rappliquer": [
        "rappliquer"
    ],
    "rappliquera": [
        "rappliquer"
    ],
    "rappliquerais": [
        "rappliquer"
    ],
    "rappliquerait": [
        "rappliquer"
    ],
    "rappliqueriez": [
        "rappliquer"
    ],
    "rappliqueront": [
        "rappliquer"
    ],
    "rappliques": [
        "rappliquer"
    ],
    "rappliquez": [
        "rappliquer"
    ],
    "rappliquerent": [
        "rappliquer"
    ],
    "rapport": [
        "rapport"
    ],
    "rapporta": [
        "rapporter"
    ],
    "rapportage": [
        "rapportage"
    ],
    "rapportai": [
        "rapporter"
    ],
    "rapportaient": [
        "rapporter"
    ],
    "rapportais": [
        "rapporter"
    ],
    "rapportait": [
        "rapporter"
    ],
    "rapportant": [
        "rapporter"
    ],
    "rapporte": [
        "rapporte",
        "rapporter"
    ],
    "rapportent": [
        "rapporter"
    ],
    "rapporter": [
        "rapporter"
    ],
    "rapportera": [
        "rapporter"
    ],
    "rapporterai": [
        "rapporter"
    ],
    "rapporteraient": [
        "rapporter"
    ],
    "rapporterais": [
        "rapporter"
    ],
    "rapporterait": [
        "rapporter"
    ],
    "rapporteras": [
        "rapporter"
    ],
    "rapporterez": [
        "rapporter"
    ],
    "rapporteriez": [
        "rapporter"
    ],
    "rapporterons": [
        "rapporter"
    ],
    "rapporteront": [
        "rapporter"
    ],
    "rapportes": [
        "rapporte",
        "rapporter"
    ],
    "rapporteur": [
        "rapporteur"
    ],
    "rapporteurs": [
        "rapporteur"
    ],
    "rapporteuse": [
        "rapporteur"
    ],
    "rapporteuses": [
        "rapporteur"
    ],
    "rapportez": [
        "rapporter"
    ],
    "rapportiez": [
        "rapporter"
    ],
    "rapportions": [
        "rapporter"
    ],
    "rapportons": [
        "rapporter"
    ],
    "rapports": [
        "rapport"
    ],
    "rapportat": [
        "rapporter"
    ],
    "rapporterent": [
        "rapporter"
    ],
    "rapportee": [
        "rapporte",
        "rapporter"
    ],
    "rapportees": [
        "rapporte",
        "rapporter"
    ],
    "rapprendre": [
        "rapprendre"
    ],
    "rappris": [
        "rapprendre"
    ],
    "rapprocha": [
        "rapprocher"
    ],
    "rapprochai": [
        "rapprocher"
    ],
    "rapprochaient": [
        "rapprocher"
    ],
    "rapprochais": [
        "rapprocher"
    ],
    "rapprochait": [
        "rapprocher"
    ],
    "rapprochant": [
        "rapprocher"
    ],
    "rapproche": [
        "rapprocher",
        "rapproche"
    ],
    "rapprochement": [
        "rapprochement"
    ],
    "rapprochements": [
        "rapprochement"
    ],
    "rapprochent": [
        "rapprocher"
    ],
    "rapprocher": [
        "rapprocher"
    ],
    "rapprochera": [
        "rapprocher"
    ],
    "rapprocherais": [
        "rapprocher"
    ],
    "rapprocherait": [
        "rapprocher"
    ],
    "rapprocheront": [
        "rapprocher"
    ],
    "rapprocheur": [
        "rapprocheur"
    ],
    "rapprochez": [
        "rapprocher"
    ],
    "rapprochiez": [
        "rapprocher"
    ],
    "rapprochions": [
        "rapprocher"
    ],
    "rapprochons": [
        "rapprocher"
    ],
    "rapprochat": [
        "rapprocher"
    ],
    "rapprocherent": [
        "rapprocher"
    ],
    "rapprochee": [
        "rapprocher",
        "rapproche"
    ],
    "rapprochees": [
        "rapprocher",
        "rapproche"
    ],
    "rapproches": [
        "rapprocher",
        "rapproche"
    ],
    "rappropriait": [
        "rapproprier"
    ],
    "rapsodie": [
        "rapsodie"
    ],
    "rapt": [
        "rapt"
    ],
    "rapts": [
        "rapt"
    ],
    "raquaient": [
        "raquer"
    ],
    "raquait": [
        "raquer"
    ],
    "raque": [
        "raquer"
    ],
    "raquent": [
        "raquer"
    ],
    "raquer": [
        "raquer"
    ],
    "raques": [
        "raquer"
    ],
    "raquette": [
        "raquette"
    ],
    "raquettes": [
        "raquette"
    ],
    "raquez": [
        "raquer"
    ],
    "raquons": [
        "raquer"
    ],
    "raquee": [
        "raquer"
    ],
    "raquees": [
        "raquer"
    ],
    "rare": [
        "rare"
    ],
    "rarement": [
        "rarement"
    ],
    "rares": [
        "rare"
    ],
    "rarete": [
        "rarete"
    ],
    "raretes": [
        "rarete"
    ],
    "rarissime": [
        "rarissime"
    ],
    "rarissimement": [
        "rarissimement"
    ],
    "rarissimes": [
        "rarissime"
    ],
    "rarefaction": [
        "rarefaction"
    ],
    "rarefia": [
        "rarefier"
    ],
    "rarefiaient": [
        "rarefier"
    ],
    "rarefiait": [
        "rarefier"
    ],
    "rarefiant": [
        "rarefier"
    ],
    "rarefie": [
        "rarefie",
        "rarefier"
    ],
    "rarefient": [
        "rarefier"
    ],
    "rarefier": [
        "rarefier"
    ],
    "rarefierent": [
        "rarefier"
    ],
    "rarefiee": [
        "rarefie",
        "rarefier"
    ],
    "rarefiees": [
        "rarefie"
    ],
    "rarefies": [
        "rarefier"
    ],
    "ras": [
        "ra",
        "ras"
    ],
    "rasa": [
        "raser"
    ],
    "rasade": [
        "rasade"
    ],
    "rasades": [
        "rasade"
    ],
    "rasage": [
        "rasage"
    ],
    "rasages": [
        "rasage"
    ],
    "rasai": [
        "raser"
    ],
    "rasaient": [
        "raser"
    ],
    "rasais": [
        "raser"
    ],
    "rasait": [
        "raser"
    ],
    "rasant": [
        "raser",
        "rasant"
    ],
    "rasante": [
        "rasant"
    ],
    "rasantes": [
        "rasant"
    ],
    "rasants": [
        "rasant"
    ],
    "rascasse": [
        "rascasse"
    ],
    "rascasses": [
        "rascasse"
    ],
    "rase": [
        "ras",
        "raser"
    ],
    "rasent": [
        "raser"
    ],
    "raser": [
        "raser"
    ],
    "rasera": [
        "raser"
    ],
    "raserai": [
        "raser"
    ],
    "raserais": [
        "raser"
    ],
    "raserait": [
        "raser"
    ],
    "raseras": [
        "raser"
    ],
    "raserez": [
        "raser"
    ],
    "raseront": [
        "raser"
    ],
    "rases": [
        "ras",
        "raser"
    ],
    "raseur": [
        "raseur"
    ],
    "raseurs": [
        "raseur"
    ],
    "raseuse": [
        "raseur"
    ],
    "raseuses": [
        "raseur"
    ],
    "rasez": [
        "raser"
    ],
    "rash": [
        "rash"
    ],
    "rasibus": [
        "rasibus"
    ],
    "rasiez": [
        "raser"
    ],
    "rasif": [
        "rasif"
    ],
    "rasifs": [
        "rasif"
    ],
    "rasoir": [
        "rasoir"
    ],
    "rasoirs": [
        "rasoir"
    ],
    "rasons": [
        "raser"
    ],
    "rassasiaient": [
        "rassasier"
    ],
    "rassasiais": [
        "rassasier"
    ],
    "rassasiait": [
        "rassasier"
    ],
    "rassasiant": [
        "rassasier",
        "rassasiant"
    ],
    "rassasiantes": [
        "rassasiant"
    ],
    "rassasie": [
        "rassasier",
        "rassasie"
    ],
    "rassasient": [
        "rassasier"
    ],
    "rassasier": [
        "rassasier"
    ],
    "rassasieraient": [
        "rassasier"
    ],
    "rassasiez": [
        "rassasier"
    ],
    "rassasiat": [
        "rassasier"
    ],
    "rassasiee": [
        "rassasier",
        "rassasie"
    ],
    "rassasiees": [
        "rassasie"
    ],
    "rassasies": [
        "rassasier",
        "rassasie"
    ],
    "rasse": [
        "rasse"
    ],
    "rassembla": [
        "rassembler"
    ],
    "rassemblai": [
        "rassembler"
    ],
    "rassemblaient": [
        "rassembler"
    ],
    "rassemblais": [
        "rassembler"
    ],
    "rassemblait": [
        "rassembler"
    ],
    "rassemblant": [
        "rassembler"
    ],
    "rassemble": [
        "rassembler"
    ],
    "rassemblement": [
        "rassemblement"
    ],
    "rassemblements": [
        "rassemblement"
    ],
    "rassemblent": [
        "rassembler"
    ],
    "rassembler": [
        "rassembler"
    ],
    "rassemblera": [
        "rassembler"
    ],
    "rassemblerai": [
        "rassembler"
    ],
    "rassembleraient": [
        "rassembler"
    ],
    "rassemblerais": [
        "rassembler"
    ],
    "rassemblerait": [
        "rassembler"
    ],
    "rassembleras": [
        "rassembler"
    ],
    "rassemblerez": [
        "rassembler"
    ],
    "rassemblerons": [
        "rassembler"
    ],
    "rassembleront": [
        "rassembler"
    ],
    "rassembles": [
        "rassembler"
    ],
    "rassembleur": [
        "rassembleur"
    ],
    "rassemblez": [
        "rassembler"
    ],
    "rassemblons": [
        "rassembler"
    ],
    "rassemblerent": [
        "rassembler"
    ],
    "rassemblee": [
        "rassembler"
    ],
    "rassemblees": [
        "rassembler"
    ],
    "rasseoir": [
        "rasseoir"
    ],
    "rasseyaient": [
        "rasseoir"
    ],
    "rasseyais": [
        "rasseoir"
    ],
    "rasseyait": [
        "rasseoir"
    ],
    "rasseyant": [
        "rasseoir"
    ],
    "rasseyent": [
        "rasseoir"
    ],
    "rasseyez": [
        "rasseoir"
    ],
    "rasseyons": [
        "rasseoir"
    ],
    "rassied": [
        "rasseoir"
    ],
    "rassieds": [
        "rasseoir"
    ],
    "rassir": [
        "rassir"
    ],
    "rassirent": [
        "rasseoir"
    ],
    "rassis": [
        "rasseoir",
        "rassis"
    ],
    "rassise": [
        "rasseoir",
        "rassis"
    ],
    "rassit": [
        "rasseoir"
    ],
    "rassoie": [
        "rasseoir"
    ],
    "rassoient": [
        "rasseoir"
    ],
    "rassoies": [
        "rasseoir"
    ],
    "rassois": [
        "rasseoir"
    ],
    "rassoit": [
        "rasseoir"
    ],
    "rassortiment": [
        "rassortiment"
    ],
    "rassortir": [
        "rassortir"
    ],
    "rassote": [
        "rassoter"
    ],
    "rassoyait": [
        "rasseoir"
    ],
    "rassura": [
        "rassurer"
    ],
    "rassurai": [
        "rassurer"
    ],
    "rassuraient": [
        "rassurer"
    ],
    "rassurais": [
        "rassurer"
    ],
    "rassurait": [
        "rassurer"
    ],
    "rassurant": [
        "rassurant",
        "rassurer"
    ],
    "rassurante": [
        "rassurant"
    ],
    "rassurantes": [
        "rassurant"
    ],
    "rassurants": [
        "rassurant"
    ],
    "rassure": [
        "rassurer"
    ],
    "rassurement": [
        "rassurement"
    ],
    "rassurent": [
        "rassurer"
    ],
    "rassurer": [
        "rassurer"
    ],
    "rassurera": [
        "rassurer"
    ],
    "rassurerait": [
        "rassurer"
    ],
    "rassureront": [
        "rassurer"
    ],
    "rassures": [
        "rassurer"
    ],
    "rassurez": [
        "rassurer"
    ],
    "rassuriez": [
        "rassurer"
    ],
    "rassurons": [
        "rassurer"
    ],
    "rassurames": [
        "rassurer"
    ],
    "rassurat": [
        "rassurer"
    ],
    "rassurerent": [
        "rassurer"
    ],
    "rassuree": [
        "rassurer"
    ],
    "rassurees": [
        "rassurer"
    ],
    "rasserene": [
        "rasserener"
    ],
    "rasserena": [
        "rasserener"
    ],
    "rasserenai": [
        "rasserener"
    ],
    "rasserenait": [
        "rasserener"
    ],
    "rasserenant": [
        "rasserener"
    ],
    "rasserener": [
        "rasserener"
    ],
    "rasserenera": [
        "rasserener"
    ],
    "rasserenee": [
        "rasserener"
    ],
    "rasserenees": [
        "rasserener"
    ],
    "rasserenes": [
        "rasserener"
    ],
    "rasta": [
        "rasta"
    ],
    "rastafari": [
        "rastafari"
    ],
    "rastaquouere": [
        "rastaquouere"
    ],
    "rastaquoueres": [
        "rastaquouere"
    ],
    "rastas": [
        "rasta"
    ],
    "raserent": [
        "raser"
    ],
    "rasee": [
        "raser"
    ],
    "rasees": [
        "raser"
    ],
    "rat": [
        "rat"
    ],
    "rata": [
        "rata",
        "rater"
    ],
    "ratafia": [
        "ratafia"
    ],
    "ratage": [
        "ratage"
    ],
    "ratages": [
        "ratage"
    ],
    "ratai": [
        "rater"
    ],
    "rataient": [
        "rater"
    ],
    "ratais": [
        "rater"
    ],
    "ratait": [
        "rater"
    ],
    "ratant": [
        "rater"
    ],
    "rataplan": [
        "rataplan"
    ],
    "ratatinai": [
        "ratatiner"
    ],
    "ratatinaient": [
        "ratatiner"
    ],
    "ratatinais": [
        "ratatiner"
    ],
    "ratatinait": [
        "ratatiner"
    ],
    "ratatine": [
        "ratatine",
        "ratatiner"
    ],
    "ratatinent": [
        "ratatiner"
    ],
    "ratatiner": [
        "ratatiner"
    ],
    "ratatinerait": [
        "ratatiner"
    ],
    "ratatineront": [
        "ratatiner"
    ],
    "ratatinee": [
        "ratatine",
        "ratatiner"
    ],
    "ratatinees": [
        "ratatine",
        "ratatiner"
    ],
    "ratatines": [
        "ratatine",
        "ratatiner"
    ],
    "ratatouille": [
        "ratatouille"
    ],
    "ratatouilles": [
        "ratatouille"
    ],
    "rate": [
        "rate",
        "rater"
    ],
    "ratent": [
        "rater"
    ],
    "rater": [
        "rater"
    ],
    "ratera": [
        "rater"
    ],
    "raterai": [
        "rater"
    ],
    "raterais": [
        "rater"
    ],
    "raterait": [
        "rater"
    ],
    "rateras": [
        "rater"
    ],
    "raterez": [
        "rater"
    ],
    "rateriez": [
        "rater"
    ],
    "raterons": [
        "rater"
    ],
    "rateront": [
        "rater"
    ],
    "rates": [
        "rate",
        "rater"
    ],
    "ratez": [
        "rater"
    ],
    "ratiboisaient": [
        "ratiboiser"
    ],
    "ratiboisait": [
        "ratiboiser"
    ],
    "ratiboiser": [
        "ratiboiser"
    ],
    "ratiboises": [
        "ratiboiser"
    ],
    "ratiboise": [
        "ratiboiser"
    ],
    "ratiche": [
        "ratiche"
    ],
    "ratiches": [
        "ratiche"
    ],
    "ratichon": [
        "ratichon"
    ],
    "ratichons": [
        "ratichon"
    ],
    "raticide": [
        "raticide"
    ],
    "ratier": [
        "ratier"
    ],
    "ratiez": [
        "rater"
    ],
    "ratifia": [
        "ratifier"
    ],
    "ratifiant": [
        "ratifier"
    ],
    "ratification": [
        "ratification"
    ],
    "ratifie": [
        "ratifier"
    ],
    "ratifient": [
        "ratifier"
    ],
    "ratifier": [
        "ratifier"
    ],
    "ratifieront": [
        "ratifier"
    ],
    "ratifiee": [
        "ratifier"
    ],
    "ratifies": [
        "ratifier",
        "ratify"
    ],
    "ratine": [
        "ratine"
    ],
    "ratio": [
        "ratio"
    ],
    "ratiocinait": [
        "ratiociner"
    ],
    "ratiocinant": [
        "ratiociner"
    ],
    "ratiocination": [
        "ratiocination"
    ],
    "ratiocinations": [
        "ratiocination"
    ],
    "ratiocineur": [
        "ratiocineur"
    ],
    "ration": [
        "ration"
    ],
    "rational": [
        "rational"
    ],
    "rationalisation": [
        "rationalisation"
    ],
    "rationalise": [
        "rationaliser"
    ],
    "rationaliser": [
        "rationaliser"
    ],
    "rationalisez": [
        "rationaliser"
    ],
    "rationalisme": [
        "rationalisme"
    ],
    "rationaliste": [
        "rationaliste"
    ],
    "rationalistes": [
        "rationaliste"
    ],
    "rationalisee": [
        "rationalise"
    ],
    "rationalite": [
        "rationalite"
    ],
    "rationne": [
        "rationner"
    ],
    "rationnel": [
        "rationnel"
    ],
    "rationnelle": [
        "rationnel"
    ],
    "rationnellement": [
        "rationnellement"
    ],
    "rationnelles": [
        "rationnel"
    ],
    "rationnels": [
        "rationnel"
    ],
    "rationnement": [
        "rationnement"
    ],
    "rationner": [
        "rationner"
    ],
    "rationnez": [
        "rationner"
    ],
    "rationnee": [
        "rationner"
    ],
    "rationnees": [
        "rationner"
    ],
    "rationnes": [
        "rationner"
    ],
    "rations": [
        "ration",
        "rater"
    ],
    "ratissa": [
        "ratisser"
    ],
    "ratissage": [
        "ratissage"
    ],
    "ratissaient": [
        "ratisser"
    ],
    "ratissais": [
        "ratisser"
    ],
    "ratissait": [
        "ratisser"
    ],
    "ratissant": [
        "ratisser"
    ],
    "ratisse": [
        "ratisser"
    ],
    "ratissent": [
        "ratisser"
    ],
    "ratisser": [
        "ratisser"
    ],
    "ratisserai": [
        "ratisser"
    ],
    "ratisseront": [
        "ratisser"
    ],
    "ratisseur": [
        "ratisseur"
    ],
    "ratissez": [
        "ratisser"
    ],
    "ratissons": [
        "ratisser"
    ],
    "ratissee": [
        "ratisser"
    ],
    "ratissees": [
        "ratisser"
    ],
    "ratisses": [
        "ratisser"
    ],
    "ratite": [
        "ratite"
    ],
    "ratites": [
        "ratite"
    ],
    "ratiere": [
        "ratiere"
    ],
    "ratieres": [
        "ratiere"
    ],
    "raton": [
        "raton"
    ],
    "ratonnade": [
        "ratonnade"
    ],
    "ratonnades": [
        "ratonnade"
    ],
    "ratonnent": [
        "ratonner"
    ],
    "ratonner": [
        "ratonner"
    ],
    "ratons": [
        "raton",
        "rater"
    ],
    "rats": [
        "rat"
    ],
    "rattacha": [
        "rattacher"
    ],
    "rattachaient": [
        "rattacher"
    ],
    "rattachais": [
        "rattacher"
    ],
    "rattachait": [
        "rattacher"
    ],
    "rattachant": [
        "rattacher"
    ],
    "rattache": [
        "rattacher"
    ],
    "rattachement": [
        "rattachement"
    ],
    "rattachent": [
        "rattacher"
    ],
    "rattacher": [
        "rattacher"
    ],
    "rattachera": [
        "rattacher"
    ],
    "rattacherait": [
        "rattacher"
    ],
    "rattachez": [
        "rattacher"
    ],
    "rattachions": [
        "rattacher"
    ],
    "rattachons": [
        "rattacher"
    ],
    "rattachat": [
        "rattacher"
    ],
    "rattachee": [
        "rattacher"
    ],
    "rattachees": [
        "rattacher"
    ],
    "rattaches": [
        "rattacher"
    ],
    "ratte": [
        "ratte"
    ],
    "rattrapa": [
        "rattraper"
    ],
    "rattrapage": [
        "rattrapage"
    ],
    "rattrapages": [
        "rattrapage"
    ],
    "rattrapai": [
        "rattraper"
    ],
    "rattrapaient": [
        "rattraper"
    ],
    "rattrapais": [
        "rattraper"
    ],
    "rattrapait": [
        "rattraper"
    ],
    "rattrapant": [
        "rattraper"
    ],
    "rattrape": [
        "rattraper"
    ],
    "rattrapent": [
        "rattraper"
    ],
    "rattraper": [
        "rattraper"
    ],
    "rattrapera": [
        "rattraper"
    ],
    "rattraperai": [
        "rattraper"
    ],
    "rattraperaient": [
        "rattraper"
    ],
    "rattraperais": [
        "rattraper"
    ],
    "rattraperait": [
        "rattraper"
    ],
    "rattraperas": [
        "rattraper"
    ],
    "rattraperez": [
        "rattraper"
    ],
    "rattraperons": [
        "rattraper"
    ],
    "rattraperont": [
        "rattraper"
    ],
    "rattrapes": [
        "rattraper"
    ],
    "rattrapez": [
        "rattraper"
    ],
    "rattrapiez": [
        "rattraper"
    ],
    "rattrapions": [
        "rattraper"
    ],
    "rattrapons": [
        "rattraper"
    ],
    "rattrapat": [
        "rattraper"
    ],
    "rattraperent": [
        "rattraper"
    ],
    "rattrapee": [
        "rattraper"
    ],
    "rattrapees": [
        "rattraper"
    ],
    "ratura": [
        "raturer"
    ],
    "raturai": [
        "raturer"
    ],
    "raturais": [
        "raturer"
    ],
    "raturait": [
        "raturer"
    ],
    "rature": [
        "raturer",
        "rature"
    ],
    "raturer": [
        "raturer"
    ],
    "ratures": [
        "raturer",
        "rature"
    ],
    "raturee": [
        "raturer"
    ],
    "raturees": [
        "raturer"
    ],
    "raterent": [
        "rater"
    ],
    "ratee": [
        "rate",
        "rater"
    ],
    "ratees": [
        "rate",
        "rater"
    ],
    "raucite": [
        "raucite"
    ],
    "rauqua": [
        "rauquer"
    ],
    "rauque": [
        "rauquer",
        "rauque"
    ],
    "rauquement": [
        "rauquement"
    ],
    "rauques": [
        "rauque"
    ],
    "ravage": [
        "ravage",
        "ravager"
    ],
    "ravagea": [
        "ravager"
    ],
    "ravageaient": [
        "ravager"
    ],
    "ravageais": [
        "ravager"
    ],
    "ravageait": [
        "ravager"
    ],
    "ravageant": [
        "ravageant"
    ],
    "ravageante": [
        "ravageant"
    ],
    "ravagent": [
        "ravager"
    ],
    "ravager": [
        "ravager"
    ],
    "ravagera": [
        "ravager"
    ],
    "ravagerai": [
        "ravager"
    ],
    "ravageraient": [
        "ravager"
    ],
    "ravages": [
        "ravage",
        "ravager"
    ],
    "ravageur": [
        "ravageur"
    ],
    "ravageurs": [
        "ravageur"
    ],
    "ravageuse": [
        "ravageur"
    ],
    "ravageuses": [
        "ravageur"
    ],
    "ravagez": [
        "ravager"
    ],
    "ravagerent": [
        "ravager"
    ],
    "ravagee": [
        "ravage",
        "ravager"
    ],
    "ravagees": [
        "ravage",
        "ravager"
    ],
    "raval": [
        "raval"
    ],
    "ravala": [
        "ravaler"
    ],
    "ravalai": [
        "ravaler"
    ],
    "ravalaient": [
        "ravaler"
    ],
    "ravalais": [
        "ravaler"
    ],
    "ravalait": [
        "ravaler"
    ],
    "ravalant": [
        "ravaler"
    ],
    "ravale": [
        "ravaler"
    ],
    "ravalement": [
        "ravalement"
    ],
    "ravalent": [
        "ravaler"
    ],
    "ravaler": [
        "ravaler"
    ],
    "ravalera": [
        "ravaler"
    ],
    "ravaleront": [
        "ravaler"
    ],
    "ravales": [
        "ravaler"
    ],
    "ravaleur": [
        "ravaleur"
    ],
    "ravalez": [
        "ravaler"
    ],
    "ravalons": [
        "ravaler"
    ],
    "ravalat": [
        "ravaler"
    ],
    "ravalee": [
        "ravaler"
    ],
    "ravalees": [
        "ravaler"
    ],
    "ravaudage": [
        "ravaudage"
    ],
    "ravaudait": [
        "ravauder"
    ],
    "ravaudant": [
        "ravauder"
    ],
    "ravaude": [
        "ravauder"
    ],
    "ravauder": [
        "ravauder"
    ],
    "ravaudees": [
        "ravauder"
    ],
    "ravaudes": [
        "ravauder"
    ],
    "rave": [
        "rave"
    ],
    "ravenelles": [
        "ravenelle"
    ],
    "ravennate": [
        "ravennate"
    ],
    "raves": [
        "rave"
    ],
    "ravi": [
        "ravir",
        "ravi"
    ],
    "ravie": [
        "ravir",
        "ravi"
    ],
    "ravier": [
        "ravier"
    ],
    "raviers": [
        "ravier"
    ],
    "ravies": [
        "ravir",
        "ravi"
    ],
    "ravigotait": [
        "ravigoter"
    ],
    "ravigotant": [
        "ravigotant"
    ],
    "ravigotants": [
        "ravigotant"
    ],
    "ravigote": [
        "ravigote"
    ],
    "ravigoter": [
        "ravigoter"
    ],
    "ravin": [
        "ravin"
    ],
    "ravina": [
        "raviner"
    ],
    "ravinaient": [
        "raviner"
    ],
    "ravinant": [
        "raviner"
    ],
    "ravine": [
        "raviner",
        "ravine"
    ],
    "ravinement": [
        "ravinement"
    ],
    "ravinements": [
        "ravinement"
    ],
    "ravinent": [
        "raviner"
    ],
    "raviner": [
        "raviner"
    ],
    "ravines": [
        "raviner",
        "ravine"
    ],
    "ravins": [
        "ravin"
    ],
    "ravinee": [
        "raviner"
    ],
    "ravinees": [
        "raviner"
    ],
    "ravioli": [
        "ravioli"
    ],
    "raviolis": [
        "ravioli"
    ],
    "ravir": [
        "ravir"
    ],
    "ravirait": [
        "ravir"
    ],
    "ravirent": [
        "ravir"
    ],
    "raviront": [
        "ravir"
    ],
    "ravis": [
        "ravir",
        "ravi"
    ],
    "ravisa": [
        "raviser"
    ],
    "ravisais": [
        "raviser"
    ],
    "ravisait": [
        "raviser"
    ],
    "ravisant": [
        "raviser"
    ],
    "ravise": [
        "raviser"
    ],
    "ravisent": [
        "raviser"
    ],
    "raviser": [
        "raviser"
    ],
    "ravisera": [
        "raviser"
    ],
    "raviserais": [
        "raviser"
    ],
    "ravises": [
        "raviser"
    ],
    "ravisez": [
        "raviser"
    ],
    "ravissaient": [
        "ravir"
    ],
    "ravissait": [
        "ravir"
    ],
    "ravissant": [
        "ravir",
        "ravissant"
    ],
    "ravissante": [
        "ravissant"
    ],
    "ravissantes": [
        "ravissant"
    ],
    "ravissants": [
        "ravissant"
    ],
    "ravisse": [
        "ravir"
    ],
    "ravissement": [
        "ravissement"
    ],
    "ravissements": [
        "ravissement"
    ],
    "ravissent": [
        "ravir"
    ],
    "ravisseur": [
        "ravisseur"
    ],
    "ravisseurs": [
        "ravisseur"
    ],
    "ravisseuse": [
        "ravisseur"
    ],
    "ravisee": [
        "raviser"
    ],
    "ravit": [
        "ravir"
    ],
    "ravitaillaient": [
        "ravitailler"
    ],
    "ravitaillait": [
        "ravitailler"
    ],
    "ravitaille": [
        "ravitailler"
    ],
    "ravitaillement": [
        "ravitaillement"
    ],
    "ravitaillements": [
        "ravitaillement"
    ],
    "ravitaillent": [
        "ravitailler"
    ],
    "ravitailler": [
        "ravitailler"
    ],
    "ravitaillera": [
        "ravitailler"
    ],
    "ravitaillerait": [
        "ravitailler"
    ],
    "ravitailleras": [
        "ravitailler"
    ],
    "ravitaillerez": [
        "ravitailler"
    ],
    "ravitailleur": [
        "ravitailleur"
    ],
    "ravitailleurs": [
        "ravitailleur"
    ],
    "ravitailleuse": [
        "ravitailleur"
    ],
    "ravitaillons": [
        "ravitailler"
    ],
    "ravitaillee": [
        "ravitailler"
    ],
    "ravitaillees": [
        "ravitailler"
    ],
    "ravitailles": [
        "ravitailler"
    ],
    "raviva": [
        "raviver"
    ],
    "ravivaient": [
        "raviver"
    ],
    "ravivait": [
        "raviver"
    ],
    "ravivant": [
        "raviver"
    ],
    "ravive": [
        "raviver"
    ],
    "ravivement": [
        "ravivement"
    ],
    "ravivent": [
        "raviver"
    ],
    "raviver": [
        "raviver"
    ],
    "ravivez": [
        "raviver"
    ],
    "ravivat": [
        "raviver"
    ],
    "ravivee": [
        "raviver"
    ],
    "ravoir": [
        "ravoir"
    ],
    "raya": [
        "rayer"
    ],
    "rayables": [
        "rayable"
    ],
    "rayaient": [
        "rayer"
    ],
    "rayait": [
        "rayer"
    ],
    "rayant": [
        "rayer"
    ],
    "raye": [
        "raye",
        "rayer"
    ],
    "rayent": [
        "rayer"
    ],
    "rayer": [
        "rayer"
    ],
    "rayera": [
        "rayer"
    ],
    "rayerai": [
        "rayer"
    ],
    "rayerais": [
        "rayer"
    ],
    "rayeras": [
        "rayer"
    ],
    "rayeront": [
        "rayer"
    ],
    "rayez": [
        "rayer"
    ],
    "rayions": [
        "rayer"
    ],
    "rayon": [
        "rayon"
    ],
    "rayonna": [
        "rayonner"
    ],
    "rayonnage": [
        "rayonnage"
    ],
    "rayonnages": [
        "rayonnage"
    ],
    "rayonnaient": [
        "rayonner"
    ],
    "rayonnais": [
        "rayonner"
    ],
    "rayonnait": [
        "rayonner"
    ],
    "rayonnant": [
        "rayonner",
        "rayonnant"
    ],
    "rayonnante": [
        "rayonnant"
    ],
    "rayonnantes": [
        "rayonnant"
    ],
    "rayonnants": [
        "rayonnant"
    ],
    "rayonne": [
        "rayonner",
        "rayon"
    ],
    "rayonnement": [
        "rayonnement"
    ],
    "rayonnements": [
        "rayonnement"
    ],
    "rayonnent": [
        "rayonner"
    ],
    "rayonner": [
        "rayonner"
    ],
    "rayonnera": [
        "rayonner"
    ],
    "rayonnerait": [
        "rayonner"
    ],
    "rayonnes": [
        "rayonner"
    ],
    "rayonneur": [
        "rayonneur"
    ],
    "rayonnez": [
        "rayonner"
    ],
    "rayons": [
        "rayon",
        "rayer"
    ],
    "rayure": [
        "rayure"
    ],
    "rayures": [
        "rayure"
    ],
    "rayat": [
        "rayer"
    ],
    "rayee": [
        "raye",
        "rayer"
    ],
    "rayees": [
        "raye",
        "rayer"
    ],
    "rayes": [
        "raye",
        "rayer"
    ],
    "raz": [
        "raz"
    ],
    "razzia": [
        "razzia"
    ],
    "razziais": [
        "razzier"
    ],
    "razzias": [
        "razzia"
    ],
    "razzier": [
        "razzier"
    ],
    "raia": [
        "raia"
    ],
    "re": [
        "re",
        "r"
    ],
    "reader": [
        "reader"
    ],
    "rebab": [
        "rebab"
    ],
    "rebaise": [
        "rebaiser"
    ],
    "rebaisent": [
        "rebaiser"
    ],
    "rebaiser": [
        "rebaiser"
    ],
    "rebaissa": [
        "rebaisser"
    ],
    "rebaissait": [
        "rebaisser"
    ],
    "rebaisse": [
        "rebaisser"
    ],
    "rebander": [
        "rebander"
    ],
    "rebaptisa": [
        "rebaptiser"
    ],
    "rebaptise": [
        "rebaptiser"
    ],
    "rebaptiser": [
        "rebaptiser"
    ],
    "rebaptisee": [
        "rebaptiser"
    ],
    "rebaptisees": [
        "rebaptiser"
    ],
    "rebarre": [
        "rebarre"
    ],
    "rebasculait": [
        "rebasculer"
    ],
    "rebascule": [
        "rebasculer"
    ],
    "rebasculera": [
        "rebasculer"
    ],
    "rebat": [
        "rebattre"
    ],
    "rebats": [
        "rebattre"
    ],
    "rebattait": [
        "rebattre"
    ],
    "rebattent": [
        "rebattre"
    ],
    "rebattez": [
        "rebattre"
    ],
    "rebattit": [
        "rebattre"
    ],
    "rebattre": [
        "rebattre"
    ],
    "rebattu": [
        "rebattre",
        "rebattu"
    ],
    "rebattue": [
        "rebattre",
        "rebattu"
    ],
    "rebattues": [
        "rebattre",
        "rebattu"
    ],
    "rebattus": [
        "rebattre",
        "rebattu"
    ],
    "rebec": [
        "rebec"
    ],
    "rebecter": [
        "rebecter"
    ],
    "rebecte": [
        "rebecter"
    ],
    "rebella": [
        "rebeller"
    ],
    "rebellaient": [
        "rebeller"
    ],
    "rebellais": [
        "rebeller"
    ],
    "rebellait": [
        "rebeller"
    ],
    "rebellant": [
        "rebeller"
    ],
    "rebelle": [
        "rebeller",
        "rebelle"
    ],
    "rebellent": [
        "rebeller"
    ],
    "rebeller": [
        "rebeller"
    ],
    "rebelles": [
        "rebeller",
        "rebelle"
    ],
    "rebellez": [
        "rebeller"
    ],
    "rebellat": [
        "rebeller"
    ],
    "rebellerent": [
        "rebeller"
    ],
    "rebellee": [
        "rebeller"
    ],
    "rebelote": [
        "rebelote"
    ],
    "rebiffa": [
        "rebiffer"
    ],
    "rebiffai": [
        "rebiffer"
    ],
    "rebiffaient": [
        "rebiffer"
    ],
    "rebiffais": [
        "rebiffer"
    ],
    "rebiffait": [
        "rebiffer"
    ],
    "rebiffant": [
        "rebiffer"
    ],
    "rebiffe": [
        "rebiffer"
    ],
    "rebiffent": [
        "rebiffer"
    ],
    "rebiffer": [
        "rebiffer"
    ],
    "rebifferai": [
        "rebiffer"
    ],
    "rebiffes": [
        "rebiffer"
    ],
    "rebifferent": [
        "rebiffer"
    ],
    "rebiffee": [
        "rebiffer"
    ],
    "rebiquaient": [
        "rebiquer"
    ],
    "rebiquait": [
        "rebiquer"
    ],
    "rebique": [
        "rebiquer"
    ],
    "rebiquer": [
        "rebiquer"
    ],
    "rebiquee": [
        "rebiquer"
    ],
    "reblanchir": [
        "reblanchir"
    ],
    "reblochon": [
        "reblochon"
    ],
    "reblochons": [
        "reblochon"
    ],
    "rebloquer": [
        "rebloquer"
    ],
    "rebobiner": [
        "rebobiner"
    ],
    "reboire": [
        "reboire"
    ],
    "rebois": [
        "reboire"
    ],
    "reboise": [
        "reboiser"
    ],
    "reboisement": [
        "reboisement"
    ],
    "reboisees": [
        "reboiser"
    ],
    "reboit": [
        "reboire"
    ],
    "rebond": [
        "rebond"
    ],
    "rebondi": [
        "rebondi",
        "rebondir"
    ],
    "rebondie": [
        "rebondi",
        "rebondir"
    ],
    "rebondies": [
        "rebondi",
        "rebondir"
    ],
    "rebondir": [
        "rebondir"
    ],
    "rebondira": [
        "rebondir"
    ],
    "rebondiraient": [
        "rebondir"
    ],
    "rebondirait": [
        "rebondir"
    ],
    "rebondirent": [
        "rebondir"
    ],
    "rebondis": [
        "rebondi",
        "rebondir"
    ],
    "rebondissaient": [
        "rebondir"
    ],
    "rebondissais": [
        "rebondir"
    ],
    "rebondissait": [
        "rebondir"
    ],
    "rebondissant": [
        "rebondissant"
    ],
    "rebondissante": [
        "rebondissant"
    ],
    "rebondissantes": [
        "rebondissant"
    ],
    "rebondissants": [
        "rebondissant"
    ],
    "rebondisse": [
        "rebondir"
    ],
    "rebondissement": [
        "rebondissement"
    ],
    "rebondissements": [
        "rebondissement"
    ],
    "rebondissent": [
        "rebondir"
    ],
    "rebondit": [
        "rebondir"
    ],
    "rebonds": [
        "rebond"
    ],
    "rebonjour": [
        "rebonjour"
    ],
    "rebooter": [
        "rebooter"
    ],
    "rebord": [
        "rebord"
    ],
    "reborder": [
        "reborder"
    ],
    "rebords": [
        "rebord"
    ],
    "rebordee": [
        "reborder"
    ],
    "reboucha": [
        "reboucher"
    ],
    "rebouchait": [
        "reboucher"
    ],
    "rebouchant": [
        "reboucher"
    ],
    "rebouche": [
        "reboucher"
    ],
    "rebouchent": [
        "reboucher"
    ],
    "reboucher": [
        "reboucher"
    ],
    "reboucheront": [
        "reboucher"
    ],
    "rebouchez": [
        "reboucher"
    ],
    "reboucherent": [
        "reboucher"
    ],
    "rebouchee": [
        "reboucher"
    ],
    "rebouchees": [
        "reboucher"
    ],
    "rebouches": [
        "reboucher"
    ],
    "reboucla": [
        "reboucler"
    ],
    "reboucle": [
        "reboucler"
    ],
    "reboucler": [
        "reboucler"
    ],
    "rebouclee": [
        "reboucler"
    ],
    "reboule": [
        "reboule"
    ],
    "rebourrer": [
        "rebourrer"
    ],
    "rebours": [
        "rebours"
    ],
    "reboute": [
        "rebouter"
    ],
    "rebouter": [
        "rebouter"
    ],
    "rebouteuse": [
        "rebouteur"
    ],
    "rebouteux": [
        "rebouteux"
    ],
    "reboutez": [
        "rebouter"
    ],
    "reboutonna": [
        "reboutonner"
    ],
    "reboutonnaient": [
        "reboutonner"
    ],
    "reboutonnais": [
        "reboutonner"
    ],
    "reboutonnant": [
        "reboutonner"
    ],
    "reboutonne": [
        "reboutonner"
    ],
    "reboutonner": [
        "reboutonner"
    ],
    "reboutonnerait": [
        "reboutonner"
    ],
    "reboutonnez": [
        "reboutonner"
    ],
    "reboutonnerent": [
        "reboutonner"
    ],
    "reboutonnee": [
        "reboutonner"
    ],
    "reboutonnes": [
        "reboutonner"
    ],
    "rebraguetter": [
        "rebraguetter"
    ],
    "rebraguette": [
        "rebraguetter"
    ],
    "rebrancha": [
        "rebrancher"
    ],
    "rebranche": [
        "rebrancher"
    ],
    "rebrancher": [
        "rebrancher"
    ],
    "rebranchez": [
        "rebrancher"
    ],
    "rebranchee": [
        "rebrancher"
    ],
    "rebrodait": [
        "rebroder"
    ],
    "rebrodee": [
        "rebroder"
    ],
    "rebrodes": [
        "rebroder"
    ],
    "rebrosser": [
        "rebrosser"
    ],
    "rebroussa": [
        "rebrousser"
    ],
    "rebroussai": [
        "rebrousser"
    ],
    "rebroussaient": [
        "rebrousser"
    ],
    "rebroussait": [
        "rebrousser"
    ],
    "rebroussant": [
        "rebrousser"
    ],
    "rebrousse": [
        "rebrousser"
    ],
    "rebroussement": [
        "rebroussement"
    ],
    "rebroussent": [
        "rebrousser"
    ],
    "rebrousser": [
        "rebrousser"
    ],
    "rebrousserai": [
        "rebrousser"
    ],
    "rebrousserez": [
        "rebrousser"
    ],
    "rebroussez": [
        "rebrousser"
    ],
    "rebroussons": [
        "rebrousser"
    ],
    "rebroussames": [
        "rebrousser"
    ],
    "rebroussat": [
        "rebrousser"
    ],
    "rebrousserent": [
        "rebrousser"
    ],
    "rebroussee": [
        "rebrousser"
    ],
    "rebroussees": [
        "rebrousser"
    ],
    "rebrousses": [
        "rebrousser"
    ],
    "rebrule": [
        "rebruler"
    ],
    "rebu": [
        "reboire"
    ],
    "rebuffade": [
        "rebuffade"
    ],
    "rebuffades": [
        "rebuffade"
    ],
    "rebus": [
        "reboire",
        "rebus"
    ],
    "rebut": [
        "reboire",
        "rebut"
    ],
    "rebuta": [
        "rebuter"
    ],
    "rebutaient": [
        "rebuter"
    ],
    "rebutait": [
        "rebuter"
    ],
    "rebutant": [
        "rebutant",
        "rebuter"
    ],
    "rebutante": [
        "rebutant"
    ],
    "rebutantes": [
        "rebutant"
    ],
    "rebutants": [
        "rebutant"
    ],
    "rebute": [
        "rebuter"
    ],
    "rebutent": [
        "rebuter"
    ],
    "rebuter": [
        "rebuter"
    ],
    "rebutera": [
        "rebuter"
    ],
    "rebuterait": [
        "rebuter"
    ],
    "rebuts": [
        "rebut"
    ],
    "rebuterent": [
        "rebuter"
    ],
    "rebutee": [
        "rebuter"
    ],
    "rebutees": [
        "rebuter"
    ],
    "rebutes": [
        "rebuter"
    ],
    "rebuvait": [
        "reboire"
    ],
    "rebati": [
        "rebatir"
    ],
    "rebatie": [
        "rebatir"
    ],
    "rebaties": [
        "rebatir"
    ],
    "rebatir": [
        "rebatir"
    ],
    "rebatirai": [
        "rebatir"
    ],
    "rebatirent": [
        "rebatir"
    ],
    "rebatirons": [
        "rebatir"
    ],
    "rebatis": [
        "rebatir"
    ],
    "rebatissaient": [
        "rebatir"
    ],
    "rebatissant": [
        "rebatir"
    ],
    "rebatissent": [
        "rebatir"
    ],
    "rebatissons": [
        "rebatir"
    ],
    "rebatit": [
        "rebatir"
    ],
    "rebequer": [
        "rebequer"
    ],
    "recache": [
        "recacher"
    ],
    "recacher": [
        "recacher"
    ],
    "recacheter": [
        "recacheter"
    ],
    "recachetee": [
        "recacheter"
    ],
    "recadre": [
        "recadrer"
    ],
    "recadrer": [
        "recadrer"
    ],
    "recadrez": [
        "recadrer"
    ],
    "recala": [
        "recaler"
    ],
    "recalage": [
        "recalage"
    ],
    "recalculant": [
        "recalculer"
    ],
    "recalcule": [
        "recalculer"
    ],
    "recalculer": [
        "recalculer"
    ],
    "recalculez": [
        "recalculer"
    ],
    "recaler": [
        "recaler"
    ],
    "recalez": [
        "recaler"
    ],
    "recale": [
        "recale",
        "recaler"
    ],
    "recalee": [
        "recale",
        "recaler"
    ],
    "recales": [
        "recale",
        "recaler"
    ],
    "recarreler": [
        "recarreler"
    ],
    "recasa": [
        "recaser"
    ],
    "recasable": [
        "recasable"
    ],
    "recaser": [
        "recaser"
    ],
    "recaserai": [
        "recaser"
    ],
    "recasser": [
        "recasser"
    ],
    "recasses": [
        "recasser"
    ],
    "recasse": [
        "recasser"
    ],
    "recassee": [
        "recasser"
    ],
    "recase": [
        "recaser"
    ],
    "recel": [
        "recel"
    ],
    "recelaient": [
        "receler"
    ],
    "recelait": [
        "receler"
    ],
    "recelant": [
        "receler"
    ],
    "receler": [
        "receler"
    ],
    "receleur": [
        "receleur"
    ],
    "receleurs": [
        "receleur"
    ],
    "receleuse": [
        "receleur"
    ],
    "receleuses": [
        "receleur"
    ],
    "recelons": [
        "receler"
    ],
    "recele": [
        "receler"
    ],
    "recelee": [
        "receler"
    ],
    "recelees": [
        "receler"
    ],
    "receles": [
        "receler"
    ],
    "recensa": [
        "recenser"
    ],
    "recensais": [
        "recenser"
    ],
    "recensait": [
        "recenser"
    ],
    "recensant": [
        "recenser"
    ],
    "recense": [
        "recenser"
    ],
    "recensement": [
        "recensement"
    ],
    "recensements": [
        "recensement"
    ],
    "recensent": [
        "recenser"
    ],
    "recenser": [
        "recenser"
    ],
    "recenseur": [
        "recenseur"
    ],
    "recension": [
        "recension"
    ],
    "recensames": [
        "recenser"
    ],
    "recenserent": [
        "recenser"
    ],
    "recensees": [
        "recenser"
    ],
    "recenses": [
        "recenser"
    ],
    "recentrage": [
        "recentrage"
    ],
    "recentre": [
        "recentrer"
    ],
    "recentrer": [
        "recentrer"
    ],
    "recentrons": [
        "recentrer"
    ],
    "recentree": [
        "recentrer"
    ],
    "recette": [
        "recette"
    ],
    "recettes": [
        "recette"
    ],
    "recevabilite": [
        "recevabilite"
    ],
    "recevable": [
        "recevable"
    ],
    "recevables": [
        "recevable"
    ],
    "recevaient": [
        "recevoir"
    ],
    "recevais": [
        "recevoir"
    ],
    "recevait": [
        "recevoir"
    ],
    "recevant": [
        "recevoir"
    ],
    "receveur": [
        "receveur"
    ],
    "receveurs": [
        "receveur"
    ],
    "receveuse": [
        "receveur"
    ],
    "receveuses": [
        "receveur"
    ],
    "recevez": [
        "recevoir"
    ],
    "receviez": [
        "recevoir"
    ],
    "recevions": [
        "recevoir"
    ],
    "recevoir": [
        "recevoir"
    ],
    "recevons": [
        "recevoir"
    ],
    "recevra": [
        "recevoir"
    ],
    "recevrai": [
        "recevoir"
    ],
    "recevraient": [
        "recevoir"
    ],
    "recevrais": [
        "recevoir"
    ],
    "recevrait": [
        "recevoir"
    ],
    "recevras": [
        "recevoir"
    ],
    "recevrez": [
        "recevoir"
    ],
    "recevriez": [
        "recevoir"
    ],
    "recevrions": [
        "recevoir"
    ],
    "recevrons": [
        "recevoir"
    ],
    "recevront": [
        "recevoir"
    ],
    "rechampi": [
        "rechampi"
    ],
    "rechampis": [
        "rechampir"
    ],
    "rechampit": [
        "rechampir"
    ],
    "rechange": [
        "rechange",
        "rechanger"
    ],
    "rechanger": [
        "rechanger"
    ],
    "rechanges": [
        "rechange"
    ],
    "rechanta": [
        "rechanter"
    ],
    "rechanter": [
        "rechanter"
    ],
    "rechante": [
        "rechanter"
    ],
    "rechaper": [
        "rechaper"
    ],
    "recharge": [
        "recharger",
        "recharge"
    ],
    "rechargea": [
        "recharger"
    ],
    "rechargeable": [
        "rechargeable"
    ],
    "rechargeaient": [
        "recharger"
    ],
    "rechargeais": [
        "recharger"
    ],
    "rechargeait": [
        "recharger"
    ],
    "rechargeant": [
        "recharger"
    ],
    "rechargement": [
        "rechargement"
    ],
    "rechargent": [
        "recharger"
    ],
    "recharger": [
        "recharger"
    ],
    "rechargerai": [
        "recharger"
    ],
    "rechargerait": [
        "recharger"
    ],
    "rechargerons": [
        "recharger"
    ],
    "recharges": [
        "recharger",
        "recharge"
    ],
    "rechargez": [
        "recharger"
    ],
    "rechargee": [
        "recharger"
    ],
    "rechargees": [
        "recharger"
    ],
    "rechasser": [
        "rechasser"
    ],
    "rechaussaient": [
        "rechausser"
    ],
    "rechaussant": [
        "rechausser"
    ],
    "rechausser": [
        "rechausser"
    ],
    "rechausserait": [
        "rechausser"
    ],
    "rechaussee": [
        "rechausser"
    ],
    "rechercha": [
        "rechercher"
    ],
    "recherchai": [
        "rechercher"
    ],
    "recherchaient": [
        "rechercher"
    ],
    "recherchais": [
        "rechercher"
    ],
    "recherchait": [
        "rechercher"
    ],
    "recherchant": [
        "rechercher"
    ],
    "recherche": [
        "rechercher",
        "recherche"
    ],
    "recherchent": [
        "rechercher"
    ],
    "rechercher": [
        "rechercher"
    ],
    "recherchera": [
        "rechercher"
    ],
    "rechercherai": [
        "rechercher"
    ],
    "rechercherais": [
        "rechercher"
    ],
    "rechercherait": [
        "rechercher"
    ],
    "rechercherions": [
        "rechercher"
    ],
    "rechercherons": [
        "rechercher"
    ],
    "rechercheront": [
        "rechercher"
    ],
    "recherches": [
        "rechercher",
        "recherche"
    ],
    "recherchez": [
        "rechercher"
    ],
    "recherchiez": [
        "rechercher"
    ],
    "recherchions": [
        "rechercher"
    ],
    "recherchiste": [
        "recherchiste"
    ],
    "recherchons": [
        "rechercher"
    ],
    "recherchee": [
        "rechercher",
        "recherche"
    ],
    "recherchees": [
        "rechercher",
        "recherche"
    ],
    "rechigna": [
        "rechigner"
    ],
    "rechignaient": [
        "rechigner"
    ],
    "rechignais": [
        "rechigner"
    ],
    "rechignait": [
        "rechigner"
    ],
    "rechignant": [
        "rechigner"
    ],
    "rechigne": [
        "rechigner"
    ],
    "rechignent": [
        "rechigner"
    ],
    "rechigner": [
        "rechigner"
    ],
    "rechignerais": [
        "rechigner"
    ],
    "rechignes": [
        "rechigner"
    ],
    "rechignee": [
        "rechigner"
    ],
    "rechignees": [
        "rechigner"
    ],
    "rechuta": [
        "rechuter"
    ],
    "rechutant": [
        "rechuter"
    ],
    "rechute": [
        "rechute",
        "rechuter"
    ],
    "rechuter": [
        "rechuter"
    ],
    "rechutera": [
        "rechuter"
    ],
    "rechuterait": [
        "rechuter"
    ],
    "rechuteront": [
        "rechuter"
    ],
    "rechutes": [
        "rechute",
        "rechuter"
    ],
    "reclassement": [
        "reclassement"
    ],
    "reclasser": [
        "reclasser"
    ],
    "reclasse": [
        "reclasser"
    ],
    "reclassee": [
        "reclasser"
    ],
    "reclouer": [
        "reclouer"
    ],
    "reclure": [
        "reclure"
    ],
    "reclus": [
        "reclus"
    ],
    "recluse": [
        "reclus"
    ],
    "recluses": [
        "reclus",
        "recluse"
    ],
    "recodage": [
        "recodage"
    ],
    "recogner": [
        "recogner"
    ],
    "recognition": [
        "recognition"
    ],
    "recoiffa": [
        "recoiffer"
    ],
    "recoiffai": [
        "recoiffer"
    ],
    "recoiffaient": [
        "recoiffer"
    ],
    "recoiffait": [
        "recoiffer"
    ],
    "recoiffant": [
        "recoiffer"
    ],
    "recoiffe": [
        "recoiffer"
    ],
    "recoiffent": [
        "recoiffer"
    ],
    "recoiffer": [
        "recoiffer"
    ],
    "recoiffez": [
        "recoiffer"
    ],
    "recoifferent": [
        "recoiffer"
    ],
    "recoiffee": [
        "recoiffer"
    ],
    "recoiffes": [
        "recoiffer"
    ],
    "recoin": [
        "recoin"
    ],
    "recoins": [
        "recoin"
    ],
    "recolla": [
        "recoller"
    ],
    "recollage": [
        "recollage"
    ],
    "recollait": [
        "recoller"
    ],
    "recolle": [
        "recoller"
    ],
    "recollent": [
        "recoller"
    ],
    "recoller": [
        "recoller"
    ],
    "recollera": [
        "recoller"
    ],
    "recollee": [
        "recoller"
    ],
    "recolles": [
        "recoller"
    ],
    "recoloration": [
        "recoloration"
    ],
    "recombinaison": [
        "recombinaison"
    ],
    "recombinant": [
        "recombiner",
        "recombinant"
    ],
    "recombiner": [
        "recombiner"
    ],
    "recombine": [
        "recombiner"
    ],
    "recommanda": [
        "recommander"
    ],
    "recommandable": [
        "recommandable"
    ],
    "recommandables": [
        "recommandable"
    ],
    "recommandai": [
        "recommander"
    ],
    "recommandaient": [
        "recommander"
    ],
    "recommandais": [
        "recommander"
    ],
    "recommandait": [
        "recommander"
    ],
    "recommandant": [
        "recommander"
    ],
    "recommandation": [
        "recommandation"
    ],
    "recommandations": [
        "recommandation"
    ],
    "recommande": [
        "recommande",
        "recommander"
    ],
    "recommandent": [
        "recommander"
    ],
    "recommander": [
        "recommander"
    ],
    "recommandera": [
        "recommander"
    ],
    "recommanderai": [
        "recommander"
    ],
    "recommanderais": [
        "recommander"
    ],
    "recommanderait": [
        "recommander"
    ],
    "recommanderiez": [
        "recommander"
    ],
    "recommandes": [
        "recommande",
        "recommander"
    ],
    "recommandez": [
        "recommander"
    ],
    "recommandiez": [
        "recommander"
    ],
    "recommandons": [
        "recommander"
    ],
    "recommandat": [
        "recommander"
    ],
    "recommanderent": [
        "recommander"
    ],
    "recommandee": [
        "recommande",
        "recommander"
    ],
    "recommandees": [
        "recommande",
        "recommander"
    ],
    "recommence": [
        "recommencer"
    ],
    "recommencement": [
        "recommencement"
    ],
    "recommencements": [
        "recommencement"
    ],
    "recommencent": [
        "recommencer"
    ],
    "recommencer": [
        "recommencer"
    ],
    "recommencera": [
        "recommencer"
    ],
    "recommencerai": [
        "recommencer"
    ],
    "recommenceraient": [
        "recommencer"
    ],
    "recommencerais": [
        "recommencer"
    ],
    "recommencerait": [
        "recommencer"
    ],
    "recommenceras": [
        "recommencer"
    ],
    "recommencerez": [
        "recommencer"
    ],
    "recommenceriez": [
        "recommencer"
    ],
    "recommencerions": [
        "recommencer"
    ],
    "recommencerons": [
        "recommencer"
    ],
    "recommenceront": [
        "recommencer"
    ],
    "recommences": [
        "recommencer"
    ],
    "recommencez": [
        "recommencer"
    ],
    "recommenciez": [
        "recommencer"
    ],
    "recommencions": [
        "recommencer"
    ],
    "recommencerent": [
        "recommencer"
    ],
    "recommencee": [
        "recommencer"
    ],
    "recommencees": [
        "recommencer"
    ],
    "recommenca": [
        "recommencer"
    ],
    "recommencai": [
        "recommencer"
    ],
    "recommencaient": [
        "recommencer"
    ],
    "recommencais": [
        "recommencer"
    ],
    "recommencait": [
        "recommencer"
    ],
    "recommencant": [
        "recommencer"
    ],
    "recommencons": [
        "recommencer"
    ],
    "recommencames": [
        "recommencer"
    ],
    "recommencat": [
        "recommencer"
    ],
    "recommercer": [
        "recommercer"
    ],
    "recompleter": [
        "recompleter"
    ],
    "recomplete": [
        "recompleter"
    ],
    "recomposa": [
        "recomposer"
    ],
    "recomposaient": [
        "recomposer"
    ],
    "recomposais": [
        "recomposer"
    ],
    "recomposait": [
        "recomposer"
    ],
    "recompose": [
        "recomposer"
    ],
    "recomposent": [
        "recomposer"
    ],
    "recomposer": [
        "recomposer"
    ],
    "recomposera": [
        "recomposer"
    ],
    "recomposition": [
        "recomposition"
    ],
    "recomposerent": [
        "recomposer"
    ],
    "recomposee": [
        "recomposer"
    ],
    "recomposes": [
        "recomposer"
    ],
    "recompta": [
        "recompter"
    ],
    "recomptaient": [
        "recompter"
    ],
    "recomptais": [
        "recompter"
    ],
    "recomptait": [
        "recompter"
    ],
    "recomptant": [
        "recompter"
    ],
    "recompte": [
        "recompter"
    ],
    "recompter": [
        "recompter"
    ],
    "recomptez": [
        "recompter"
    ],
    "recomptons": [
        "recompter"
    ],
    "recomptees": [
        "recompter"
    ],
    "reconditionne": [
        "reconditionner"
    ],
    "reconditionnement": [
        "reconditionnement"
    ],
    "reconditionnons": [
        "reconditionner"
    ],
    "reconditionnee": [
        "reconditionner"
    ],
    "reconductible": [
        "reconductible"
    ],
    "reconduction": [
        "reconduction"
    ],
    "reconduirai": [
        "reconduire"
    ],
    "reconduirais": [
        "reconduire"
    ],
    "reconduirait": [
        "reconduire"
    ],
    "reconduire": [
        "reconduire"
    ],
    "reconduirez": [
        "reconduire"
    ],
    "reconduirons": [
        "reconduire"
    ],
    "reconduis": [
        "reconduire"
    ],
    "reconduisaient": [
        "reconduire"
    ],
    "reconduisais": [
        "reconduire"
    ],
    "reconduisait": [
        "reconduire"
    ],
    "reconduisant": [
        "reconduire"
    ],
    "reconduise": [
        "reconduire"
    ],
    "reconduisent": [
        "reconduire"
    ],
    "reconduisez": [
        "reconduire"
    ],
    "reconduisions": [
        "reconduire"
    ],
    "reconduisirent": [
        "reconduire"
    ],
    "reconduisit": [
        "reconduire"
    ],
    "reconduit": [
        "reconduire"
    ],
    "reconduite": [
        "reconduire"
    ],
    "reconduits": [
        "reconduire"
    ],
    "reconfiguration": [
        "reconfiguration"
    ],
    "reconfigure": [
        "reconfigurer"
    ],
    "reconfigurer": [
        "reconfigurer"
    ],
    "reconfigurez": [
        "reconfigurer"
    ],
    "reconfigures": [
        "reconfigurer"
    ],
    "recongeler": [
        "recongeler"
    ],
    "reconnais": [
        "reconnaitre"
    ],
    "reconnaissable": [
        "reconnaissable"
    ],
    "reconnaissables": [
        "reconnaissable"
    ],
    "reconnaissaient": [
        "reconnaitre"
    ],
    "reconnaissais": [
        "reconnaitre"
    ],
    "reconnaissait": [
        "reconnaitre"
    ],
    "reconnaissance": [
        "reconnaissance"
    ],
    "reconnaissances": [
        "reconnaissance"
    ],
    "reconnaissant": [
        "reconnaitre",
        "reconnaissant"
    ],
    "reconnaissante": [
        "reconnaissant"
    ],
    "reconnaissantes": [
        "reconnaissant"
    ],
    "reconnaissants": [
        "reconnaissant"
    ],
    "reconnaisse": [
        "reconnaitre"
    ],
    "reconnaissent": [
        "reconnaitre"
    ],
    "reconnaisses": [
        "reconnaitre"
    ],
    "reconnaissez": [
        "reconnaitre"
    ],
    "reconnaissiez": [
        "reconnaitre"
    ],
    "reconnaissions": [
        "reconnaitre"
    ],
    "reconnaissons": [
        "reconnaitre"
    ],
    "reconnait": [
        "reconnaitre"
    ],
    "reconnaitra": [
        "reconnaitre"
    ],
    "reconnaitrai": [
        "reconnaitre"
    ],
    "reconnaitraient": [
        "reconnaitre"
    ],
    "reconnaitrais": [
        "reconnaitre"
    ],
    "reconnaitrait": [
        "reconnaitre"
    ],
    "reconnaitras": [
        "reconnaitre"
    ],
    "reconnaitre": [
        "reconnaitre"
    ],
    "reconnaitrez": [
        "reconnaitre"
    ],
    "reconnaitriez": [
        "reconnaitre"
    ],
    "reconnaitrions": [
        "reconnaitre"
    ],
    "reconnaitrons": [
        "reconnaitre"
    ],
    "reconnaitront": [
        "reconnaitre"
    ],
    "reconnecte": [
        "reconnecter"
    ],
    "reconnecter": [
        "reconnecter"
    ],
    "reconnectez": [
        "reconnecter"
    ],
    "reconnectes": [
        "reconnecter"
    ],
    "reconnu": [
        "reconnu",
        "reconnaitre"
    ],
    "reconnue": [
        "reconnu",
        "reconnaitre"
    ],
    "reconnues": [
        "reconnu",
        "reconnaitre"
    ],
    "reconnurent": [
        "reconnaitre"
    ],
    "reconnus": [
        "reconnu",
        "reconnaitre"
    ],
    "reconnusse": [
        "reconnaitre"
    ],
    "reconnussent": [
        "reconnaitre"
    ],
    "reconnut": [
        "reconnaitre"
    ],
    "reconnumes": [
        "reconnaitre"
    ],
    "reconquerra": [
        "reconquerir"
    ],
    "reconquerrait": [
        "reconquerir"
    ],
    "reconquerrons": [
        "reconquerir"
    ],
    "reconquiert": [
        "reconquerir"
    ],
    "reconquirent": [
        "reconquerir"
    ],
    "reconquis": [
        "reconquis",
        "reconquerir"
    ],
    "reconquise": [
        "reconquis",
        "reconquerir"
    ],
    "reconquises": [
        "reconquis",
        "reconquerir"
    ],
    "reconquista": [
        "reconquista"
    ],
    "reconquit": [
        "reconquerir"
    ],
    "reconquiere": [
        "reconquerir"
    ],
    "reconquerais": [
        "reconquerir"
    ],
    "reconquerait": [
        "reconquerir"
    ],
    "reconquerir": [
        "reconquerir"
    ],
    "reconquerons": [
        "reconquerir"
    ],
    "reconquete": [
        "reconquete"
    ],
    "reconsidere": [
        "reconsiderer"
    ],
    "reconsiderent": [
        "reconsiderer"
    ],
    "reconsidera": [
        "reconsiderer"
    ],
    "reconsiderant": [
        "reconsiderer"
    ],
    "reconsiderer": [
        "reconsiderer"
    ],
    "reconsiderez": [
        "reconsiderer"
    ],
    "reconsideree": [
        "reconsiderer"
    ],
    "reconstitua": [
        "reconstituer"
    ],
    "reconstituaient": [
        "reconstituer"
    ],
    "reconstituais": [
        "reconstituer"
    ],
    "reconstituait": [
        "reconstituer"
    ],
    "reconstituant": [
        "reconstituer",
        "reconstituant"
    ],
    "reconstituante": [
        "reconstituant"
    ],
    "reconstituantes": [
        "reconstituant"
    ],
    "reconstituants": [
        "reconstituant"
    ],
    "reconstitue": [
        "reconstituer"
    ],
    "reconstituent": [
        "reconstituer"
    ],
    "reconstituer": [
        "reconstituer"
    ],
    "reconstitueraient": [
        "reconstituer"
    ],
    "reconstituerais": [
        "reconstituer"
    ],
    "reconstituerait": [
        "reconstituer"
    ],
    "reconstituerons": [
        "reconstituer"
    ],
    "reconstitues": [
        "reconstituer"
    ],
    "reconstituons": [
        "reconstituer"
    ],
    "reconstitution": [
        "reconstitution"
    ],
    "reconstitutions": [
        "reconstitution"
    ],
    "reconstituames": [
        "reconstituer"
    ],
    "reconstituat": [
        "reconstituer"
    ],
    "reconstituee": [
        "reconstituer"
    ],
    "reconstituees": [
        "reconstituer"
    ],
    "reconstructeur": [
        "reconstructeur"
    ],
    "reconstruction": [
        "reconstruction"
    ],
    "reconstructions": [
        "reconstruction"
    ],
    "reconstructrice": [
        "reconstructeur"
    ],
    "reconstruira": [
        "reconstruire"
    ],
    "reconstruirai": [
        "reconstruire"
    ],
    "reconstruirais": [
        "reconstruire"
    ],
    "reconstruirait": [
        "reconstruire"
    ],
    "reconstruiras": [
        "reconstruire"
    ],
    "reconstruire": [
        "reconstruire"
    ],
    "reconstruirons": [
        "reconstruire"
    ],
    "reconstruiront": [
        "reconstruire"
    ],
    "reconstruis": [
        "reconstruire"
    ],
    "reconstruisaient": [
        "reconstruire"
    ],
    "reconstruisait": [
        "reconstruire"
    ],
    "reconstruisant": [
        "reconstruire"
    ],
    "reconstruisent": [
        "reconstruire"
    ],
    "reconstruisez": [
        "reconstruire"
    ],
    "reconstruisirent": [
        "reconstruire"
    ],
    "reconstruisons": [
        "reconstruire"
    ],
    "reconstruit": [
        "reconstruire"
    ],
    "reconstruite": [
        "reconstruire"
    ],
    "reconstruites": [
        "reconstruire"
    ],
    "reconstruits": [
        "reconstruire"
    ],
    "reconsulter": [
        "reconsulter"
    ],
    "recontacter": [
        "recontacter"
    ],
    "reconter": [
        "reconter"
    ],
    "recontrer": [
        "recontrer"
    ],
    "reconventionnelle": [
        "reconventionnel"
    ],
    "reconversion": [
        "reconversion"
    ],
    "reconverti": [
        "reconvertir"
    ],
    "reconvertie": [
        "reconvertir"
    ],
    "reconvertir": [
        "reconvertir"
    ],
    "reconvertirent": [
        "reconvertir"
    ],
    "reconvertis": [
        "reconvertir"
    ],
    "reconvertissant": [
        "reconvertir"
    ],
    "reconvertisse": [
        "reconvertir"
    ],
    "reconvertit": [
        "reconvertir"
    ],
    "reconvoquer": [
        "reconvoquer"
    ],
    "recopia": [
        "recopier"
    ],
    "recopiage": [
        "recopiage"
    ],
    "recopiai": [
        "recopier"
    ],
    "recopiaient": [
        "recopier"
    ],
    "recopiais": [
        "recopier"
    ],
    "recopiait": [
        "recopier"
    ],
    "recopiant": [
        "recopier"
    ],
    "recopie": [
        "recopier"
    ],
    "recopient": [
        "recopier"
    ],
    "recopier": [
        "recopier"
    ],
    "recopierai": [
        "recopier"
    ],
    "recopierait": [
        "recopier"
    ],
    "recopies": [
        "recopier"
    ],
    "recopiez": [
        "recopier"
    ],
    "recopiat": [
        "recopier"
    ],
    "recopiee": [
        "recopier"
    ],
    "recopiees": [
        "recopier"
    ],
    "record": [
        "record"
    ],
    "recorder": [
        "recorder"
    ],
    "recordman": [
        "recordman"
    ],
    "recordmen": [
        "recordman"
    ],
    "records": [
        "record"
    ],
    "recors": [
        "recors"
    ],
    "recoucha": [
        "recoucher"
    ],
    "recouchai": [
        "recoucher"
    ],
    "recouchais": [
        "recoucher"
    ],
    "recouchait": [
        "recoucher"
    ],
    "recouchant": [
        "recoucher"
    ],
    "recouche": [
        "recoucher"
    ],
    "recoucher": [
        "recoucher"
    ],
    "recoucherais": [
        "recoucher"
    ],
    "recoucheriez": [
        "recoucher"
    ],
    "recouchez": [
        "recoucher"
    ],
    "recoucherent": [
        "recoucher"
    ],
    "recouchee": [
        "recoucher"
    ],
    "recouchees": [
        "recoucher"
    ],
    "recouches": [
        "recoucher"
    ],
    "recoud": [
        "recoudre"
    ],
    "recoudra": [
        "recoudre"
    ],
    "recoudrai": [
        "recoudre"
    ],
    "recoudras": [
        "recoudre"
    ],
    "recoudre": [
        "recoudre"
    ],
    "recouds": [
        "recoudre"
    ],
    "recouler": [
        "recouler"
    ],
    "recoupa": [
        "recouper"
    ],
    "recoupaient": [
        "recouper"
    ],
    "recoupait": [
        "recouper"
    ],
    "recoupant": [
        "recouper"
    ],
    "recoupe": [
        "recouper"
    ],
    "recoupement": [
        "recoupement"
    ],
    "recoupements": [
        "recoupement"
    ],
    "recoupent": [
        "recouper"
    ],
    "recouper": [
        "recouper"
    ],
    "recouperait": [
        "recouper"
    ],
    "recouperont": [
        "recouper"
    ],
    "recoupez": [
        "recouper"
    ],
    "recoupions": [
        "recouper"
    ],
    "recoupes": [
        "recouper"
    ],
    "recourait": [
        "recourir"
    ],
    "recourant": [
        "recourir"
    ],
    "recourba": [
        "recourber"
    ],
    "recourbaient": [
        "recourber"
    ],
    "recourbait": [
        "recourber"
    ],
    "recourbant": [
        "recourber"
    ],
    "recourbe": [
        "recourbe",
        "recourber"
    ],
    "recourber": [
        "recourber"
    ],
    "recourbee": [
        "recourbe",
        "recourber"
    ],
    "recourbees": [
        "recourbe",
        "recourber"
    ],
    "recourbes": [
        "recourbe",
        "recourber"
    ],
    "recoure": [
        "recourir"
    ],
    "recourent": [
        "recourir"
    ],
    "recourez": [
        "recourir"
    ],
    "recourir": [
        "recourir"
    ],
    "recourons": [
        "recourir"
    ],
    "recourrait": [
        "recourir"
    ],
    "recours": [
        "recourir",
        "recours"
    ],
    "recourt": [
        "recourir"
    ],
    "recouru": [
        "recourir"
    ],
    "recoururent": [
        "recourir"
    ],
    "recourus": [
        "recourir"
    ],
    "recourut": [
        "recourir"
    ],
    "recousais": [
        "recoudre"
    ],
    "recousait": [
        "recoudre"
    ],
    "recousant": [
        "recoudre"
    ],
    "recouse": [
        "recoudre"
    ],
    "recousez": [
        "recoudre"
    ],
    "recousu": [
        "recoudre"
    ],
    "recousue": [
        "recoudre"
    ],
    "recousus": [
        "recoudre"
    ],
    "recouvert": [
        "recouvrir",
        "recouvert"
    ],
    "recouverte": [
        "recouvrir",
        "recouvert"
    ],
    "recouvertes": [
        "recouvrir",
        "recouvert"
    ],
    "recouverts": [
        "recouvrir",
        "recouvert"
    ],
    "recouvra": [
        "recouvrer"
    ],
    "recouvrables": [
        "recouvrable"
    ],
    "recouvrai": [
        "recouvrer"
    ],
    "recouvraient": [
        "recouvrir"
    ],
    "recouvrais": [
        "recouvrir"
    ],
    "recouvrait": [
        "recouvrir"
    ],
    "recouvrance": [
        "recouvrance"
    ],
    "recouvrant": [
        "recouvrir",
        "recouvrant"
    ],
    "recouvre": [
        "recouvrer",
        "recouvrir"
    ],
    "recouvrement": [
        "recouvrement"
    ],
    "recouvrent": [
        "recouvrir"
    ],
    "recouvrer": [
        "recouvrer"
    ],
    "recouvrerai": [
        "recouvrer"
    ],
    "recouvrerait": [
        "recouvrer"
    ],
    "recouvrerez": [
        "recouvrer"
    ],
    "recouvreront": [
        "recouvrer"
    ],
    "recouvrez": [
        "recouvrir"
    ],
    "recouvriez": [
        "recouvrir"
    ],
    "recouvrir": [
        "recouvrir"
    ],
    "recouvrira": [
        "recouvrir"
    ],
    "recouvrirai": [
        "recouvrir"
    ],
    "recouvriraient": [
        "recouvrir"
    ],
    "recouvrirait": [
        "recouvrir"
    ],
    "recouvrirent": [
        "recouvrir"
    ],
    "recouvris": [
        "recouvrir"
    ],
    "recouvrissent": [
        "recouvrir"
    ],
    "recouvrit": [
        "recouvrir"
    ],
    "recouvrons": [
        "recouvrir"
    ],
    "recouvrat": [
        "recouvrer"
    ],
    "recouvree": [
        "recouvrer"
    ],
    "recouvrees": [
        "recouvrer"
    ],
    "recouvres": [
        "recouvrer"
    ],
    "recracha": [
        "recracher"
    ],
    "recrachaient": [
        "recracher"
    ],
    "recrachais": [
        "recracher"
    ],
    "recrachait": [
        "recracher"
    ],
    "recrachant": [
        "recracher"
    ],
    "recrache": [
        "recracher"
    ],
    "recrachent": [
        "recracher"
    ],
    "recracher": [
        "recracher"
    ],
    "recrachera": [
        "recracher"
    ],
    "recraches": [
        "recracher"
    ],
    "recrachez": [
        "recracher"
    ],
    "recrachee": [
        "recracher"
    ],
    "recreuse": [
        "recreuser"
    ],
    "recreuser": [
        "recreuser"
    ],
    "recroisait": [
        "recroiser"
    ],
    "recroisant": [
        "recroiser"
    ],
    "recroise": [
        "recroiser"
    ],
    "recroiser": [
        "recroiser"
    ],
    "recroiseras": [
        "recroiser"
    ],
    "recroiserons": [
        "recroiser"
    ],
    "recroises": [
        "recroiser"
    ],
    "recroquevilla": [
        "recroqueviller"
    ],
    "recroquevillai": [
        "recroqueviller"
    ],
    "recroquevillaient": [
        "recroqueviller"
    ],
    "recroquevillais": [
        "recroqueviller"
    ],
    "recroquevillait": [
        "recroqueviller"
    ],
    "recroquevillant": [
        "recroqueviller"
    ],
    "recroqueville": [
        "recroqueviller",
        "recroqueville"
    ],
    "recroquevillement": [
        "recroquevillement"
    ],
    "recroquevillent": [
        "recroqueviller"
    ],
    "recroqueviller": [
        "recroqueviller"
    ],
    "recroquevillions": [
        "recroqueviller"
    ],
    "recroquevillee": [
        "recroqueviller",
        "recroqueville"
    ],
    "recroquevillees": [
        "recroqueviller",
        "recroqueville"
    ],
    "recroquevilles": [
        "recroqueviller",
        "recroqueville"
    ],
    "recru": [
        "recroitre",
        "recru"
    ],
    "recrudescence": [
        "recrudescence"
    ],
    "recrudescente": [
        "recrudescent"
    ],
    "recrue": [
        "recru",
        "recrue"
    ],
    "recrues": [
        "recru",
        "recrue"
    ],
    "recrus": [
        "recroitre",
        "recru"
    ],
    "recruta": [
        "recruter"
    ],
    "recrutaient": [
        "recruter"
    ],
    "recrutais": [
        "recruter"
    ],
    "recrutait": [
        "recruter"
    ],
    "recrutant": [
        "recruter"
    ],
    "recrute": [
        "recruter"
    ],
    "recrutement": [
        "recrutement"
    ],
    "recrutent": [
        "recruter"
    ],
    "recruter": [
        "recruter"
    ],
    "recrutera": [
        "recruter"
    ],
    "recruterai": [
        "recruter"
    ],
    "recruterez": [
        "recruter"
    ],
    "recruteur": [
        "recruteur"
    ],
    "recruteurs": [
        "recruteur"
    ],
    "recrutez": [
        "recruter"
    ],
    "recrutiez": [
        "recruter"
    ],
    "recrutions": [
        "recruter"
    ],
    "recrutons": [
        "recruter"
    ],
    "recrutee": [
        "recruter"
    ],
    "recrutees": [
        "recruter"
    ],
    "recrutes": [
        "recruter"
    ],
    "recrea": [
        "recreer"
    ],
    "recreaient": [
        "recreer"
    ],
    "recreais": [
        "recreer"
    ],
    "recreait": [
        "recreer"
    ],
    "recreant": [
        "recreer"
    ],
    "recreation": [
        "recreation"
    ],
    "recree": [
        "recreer"
    ],
    "recreent": [
        "recreer"
    ],
    "recreer": [
        "recreer"
    ],
    "recreerait": [
        "recreer"
    ],
    "recrepi": [
        "recrepir"
    ],
    "recrepie": [
        "recrepir"
    ],
    "recrepir": [
        "recrepir"
    ],
    "recrepis": [
        "recrepir"
    ],
    "recrepit": [
        "recrepir"
    ],
    "recreee": [
        "recreer"
    ],
    "recreees": [
        "recreer"
    ],
    "recrees": [
        "recreer"
    ],
    "recta": [
        "recta"
    ],
    "rectal": [
        "rectal"
    ],
    "rectale": [
        "rectal"
    ],
    "rectangle": [
        "rectangle"
    ],
    "rectangles": [
        "rectangle"
    ],
    "rectangulaire": [
        "rectangulaire"
    ],
    "rectangulaires": [
        "rectangulaire"
    ],
    "rectaux": [
        "rectal"
    ],
    "recteur": [
        "recteur"
    ],
    "recteurs": [
        "recteur"
    ],
    "rectifia": [
        "rectifier"
    ],
    "rectifiai": [
        "rectifier"
    ],
    "rectifiait": [
        "rectifier"
    ],
    "rectifiant": [
        "rectifier"
    ],
    "rectificatif": [
        "rectificatif"
    ],
    "rectification": [
        "rectification"
    ],
    "rectifications": [
        "rectification"
    ],
    "rectifie": [
        "rectifier"
    ],
    "rectifient": [
        "rectifier"
    ],
    "rectifier": [
        "rectifier"
    ],
    "rectifiera": [
        "rectifier"
    ],
    "rectifierai": [
        "rectifier"
    ],
    "rectifierez": [
        "rectifier"
    ],
    "rectifies": [
        "rectifier",
        "rectify"
    ],
    "rectifiez": [
        "rectifier"
    ],
    "rectifions": [
        "rectifier"
    ],
    "rectifierent": [
        "rectifier"
    ],
    "rectifiee": [
        "rectifier"
    ],
    "rectifiees": [
        "rectifier"
    ],
    "rectiligne": [
        "rectiligne"
    ],
    "rectilignes": [
        "rectiligne"
    ],
    "rectilineaire": [
        "rectilineaire"
    ],
    "rectitude": [
        "rectitude"
    ],
    "recto": [
        "recto"
    ],
    "rectorat": [
        "rectorat"
    ],
    "rectos": [
        "recto"
    ],
    "rectrices": [
        "recteur"
    ],
    "rectum": [
        "rectum"
    ],
    "recueil": [
        "recueil"
    ],
    "recueillaient": [
        "recueillir"
    ],
    "recueillais": [
        "recueillir"
    ],
    "recueillait": [
        "recueillir"
    ],
    "recueillant": [
        "recueillir"
    ],
    "recueille": [
        "recueillir"
    ],
    "recueillement": [
        "recueillement"
    ],
    "recueillements": [
        "recueillement"
    ],
    "recueillent": [
        "recueillir"
    ],
    "recueillera": [
        "recueillir"
    ],
    "recueillerai": [
        "recueillir"
    ],
    "recueilleraient": [
        "recueillir"
    ],
    "recueillerait": [
        "recueillir"
    ],
    "recueilleront": [
        "recueillir"
    ],
    "recueillez": [
        "recueillir"
    ],
    "recueilli": [
        "recueilli",
        "recueillir"
    ],
    "recueillie": [
        "recueilli",
        "recueillir"
    ],
    "recueillies": [
        "recueilli",
        "recueillir"
    ],
    "recueillions": [
        "recueillir"
    ],
    "recueillir": [
        "recueillir"
    ],
    "recueillirent": [
        "recueillir"
    ],
    "recueillis": [
        "recueilli",
        "recueillir"
    ],
    "recueillit": [
        "recueillir"
    ],
    "recueillons": [
        "recueillir"
    ],
    "recueils": [
        "recueil"
    ],
    "recuire": [
        "recuire"
    ],
    "recuisson": [
        "recuisson"
    ],
    "recuit": [
        "recuire",
        "recuit"
    ],
    "recuite": [
        "recuire",
        "recuit"
    ],
    "recuites": [
        "recuire",
        "recuit"
    ],
    "recuits": [
        "recuit"
    ],
    "recul": [
        "recul"
    ],
    "recula": [
        "reculer"
    ],
    "reculade": [
        "reculade"
    ],
    "reculades": [
        "reculade"
    ],
    "reculai": [
        "reculer"
    ],
    "reculaient": [
        "reculer"
    ],
    "reculais": [
        "reculer"
    ],
    "reculait": [
        "reculer"
    ],
    "reculant": [
        "reculant",
        "reculer"
    ],
    "recule": [
        "reculer",
        "recule"
    ],
    "reculent": [
        "reculer"
    ],
    "reculer": [
        "reculer"
    ],
    "reculera": [
        "reculer"
    ],
    "reculerai": [
        "reculer"
    ],
    "reculeraient": [
        "reculer"
    ],
    "reculerais": [
        "reculer"
    ],
    "reculerait": [
        "reculer"
    ],
    "reculeras": [
        "reculer"
    ],
    "reculerons": [
        "reculer"
    ],
    "reculeront": [
        "reculer"
    ],
    "recules": [
        "reculer",
        "recule"
    ],
    "reculez": [
        "reculer"
    ],
    "reculons": [
        "reculer"
    ],
    "reculotta": [
        "reculotter"
    ],
    "reculotte": [
        "reculotter"
    ],
    "reculotter": [
        "reculotter"
    ],
    "reculottee": [
        "reculotter"
    ],
    "reculs": [
        "recul"
    ],
    "reculat": [
        "reculer"
    ],
    "reculerent": [
        "reculer"
    ],
    "reculee": [
        "reculer",
        "recule"
    ],
    "reculees": [
        "reculer",
        "recule"
    ],
    "recyclable": [
        "recyclable"
    ],
    "recyclables": [
        "recyclable"
    ],
    "recyclage": [
        "recyclage"
    ],
    "recyclaient": [
        "recycler"
    ],
    "recyclait": [
        "recycler"
    ],
    "recycle": [
        "recycler"
    ],
    "recyclent": [
        "recycler"
    ],
    "recycler": [
        "recycler"
    ],
    "recyclerai": [
        "recycler"
    ],
    "recycleur": [
        "recycleur"
    ],
    "recyclez": [
        "recycler"
    ],
    "recycliez": [
        "recycler"
    ],
    "recyclee": [
        "recycler"
    ],
    "recyclees": [
        "recycler"
    ],
    "recycles": [
        "recycle",
        "recycler"
    ],
    "recabler": [
        "recabler"
    ],
    "recelent": [
        "receler"
    ],
    "reces": [
        "reces"
    ],
    "recepages": [
        "recepage"
    ],
    "redan": [
        "redan"
    ],
    "reddition": [
        "reddition"
    ],
    "redemanda": [
        "redemander"
    ],
    "redemandai": [
        "redemander"
    ],
    "redemandaient": [
        "redemander"
    ],
    "redemandais": [
        "redemander"
    ],
    "redemandait": [
        "redemander"
    ],
    "redemandant": [
        "redemander"
    ],
    "redemande": [
        "redemander"
    ],
    "redemandent": [
        "redemander"
    ],
    "redemander": [
        "redemander"
    ],
    "redemanderai": [
        "redemander"
    ],
    "redemanderait": [
        "redemander"
    ],
    "redemanderas": [
        "redemander"
    ],
    "redemanderez": [
        "redemander"
    ],
    "redemanderont": [
        "redemander"
    ],
    "redemandes": [
        "redemander"
    ],
    "redemandez": [
        "redemander"
    ],
    "redemandions": [
        "redemander"
    ],
    "redents": [
        "redent"
    ],
    "redescend": [
        "redescendre"
    ],
    "redescendaient": [
        "redescendre"
    ],
    "redescendais": [
        "redescendre"
    ],
    "redescendait": [
        "redescendre"
    ],
    "redescendant": [
        "redescendre"
    ],
    "redescende": [
        "redescendre"
    ],
    "redescendent": [
        "redescendre"
    ],
    "redescendes": [
        "redescendre"
    ],
    "redescendez": [
        "redescendre"
    ],
    "redescendiez": [
        "redescendre"
    ],
    "redescendions": [
        "redescendre"
    ],
    "redescendirent": [
        "redescendre"
    ],
    "redescendis": [
        "redescendre"
    ],
    "redescendit": [
        "redescendre"
    ],
    "redescendons": [
        "redescendre"
    ],
    "redescendra": [
        "redescendre"
    ],
    "redescendrai": [
        "redescendre"
    ],
    "redescendrais": [
        "redescendre"
    ],
    "redescendrait": [
        "redescendre"
    ],
    "redescendre": [
        "redescendre"
    ],
    "redescendrons": [
        "redescendre"
    ],
    "redescendront": [
        "redescendre"
    ],
    "redescends": [
        "redescendre"
    ],
    "redescendu": [
        "redescendre"
    ],
    "redescendue": [
        "redescendre"
    ],
    "redescendues": [
        "redescendre"
    ],
    "redescendus": [
        "redescendre"
    ],
    "redescente": [
        "redescente"
    ],
    "redessina": [
        "redessiner"
    ],
    "redessinaient": [
        "redessiner"
    ],
    "redessinait": [
        "redessiner"
    ],
    "redessine": [
        "redessiner"
    ],
    "redessinent": [
        "redessiner"
    ],
    "redessiner": [
        "redessiner"
    ],
    "redessinee": [
        "redessiner"
    ],
    "redevable": [
        "redevable"
    ],
    "redevables": [
        "redevable"
    ],
    "redevais": [
        "redevoir"
    ],
    "redevait": [
        "redevoir"
    ],
    "redevance": [
        "redevance"
    ],
    "redevances": [
        "redevance"
    ],
    "redevenaient": [
        "redevenir"
    ],
    "redevenais": [
        "redevenir"
    ],
    "redevenait": [
        "redevenir"
    ],
    "redevenant": [
        "redevenir"
    ],
    "redevenez": [
        "redevenir"
    ],
    "redeveniez": [
        "redevenir"
    ],
    "redevenir": [
        "redevenir"
    ],
    "redevenons": [
        "redevenir"
    ],
    "redevenu": [
        "redevenir"
    ],
    "redevenue": [
        "redevenir"
    ],
    "redevenues": [
        "redevenir"
    ],
    "redevenus": [
        "redevenir"
    ],
    "redeviendra": [
        "redevenir"
    ],
    "redeviendrai": [
        "redevenir"
    ],
    "redeviendraient": [
        "redevenir"
    ],
    "redeviendrais": [
        "redevenir"
    ],
    "redeviendrait": [
        "redevenir"
    ],
    "redeviendras": [
        "redevenir"
    ],
    "redeviendrez": [
        "redevenir"
    ],
    "redeviendriez": [
        "redevenir"
    ],
    "redeviendrons": [
        "redevenir"
    ],
    "redeviendront": [
        "redevenir"
    ],
    "redevienne": [
        "redevenir"
    ],
    "redeviennent": [
        "redevenir"
    ],
    "redeviennes": [
        "redevenir"
    ],
    "redeviens": [
        "redevenir"
    ],
    "redevient": [
        "redevenir"
    ],
    "redevinrent": [
        "redevenir"
    ],
    "redevins": [
        "redevenir"
    ],
    "redevint": [
        "redevenir"
    ],
    "redevoir": [
        "redevoir"
    ],
    "redevra": [
        "redevoir"
    ],
    "redevrez": [
        "redevoir"
    ],
    "rediffusent": [
        "rediffuser"
    ],
    "rediffuser": [
        "rediffuser"
    ],
    "rediffuserons": [
        "rediffuser"
    ],
    "rediffusez": [
        "rediffuser"
    ],
    "rediffusion": [
        "rediffusion"
    ],
    "rediffusions": [
        "rediffusion"
    ],
    "rediffuse": [
        "rediffuser"
    ],
    "rediffuses": [
        "rediffuser"
    ],
    "redimensionner": [
        "redimensionner"
    ],
    "redimensionnees": [
        "redimensionner"
    ],
    "redingote": [
        "redingote"
    ],
    "redingotes": [
        "redingote"
    ],
    "redirai": [
        "redire"
    ],
    "redirais": [
        "redire"
    ],
    "redirait": [
        "redire"
    ],
    "redire": [
        "redire"
    ],
    "redirez": [
        "redire"
    ],
    "rediriez": [
        "redire"
    ],
    "redirige": [
        "rediriger"
    ],
    "rediriger": [
        "rediriger"
    ],
    "redis": [
        "redire"
    ],
    "redisais": [
        "redire"
    ],
    "redisait": [
        "redire"
    ],
    "redisant": [
        "redire"
    ],
    "rediscuter": [
        "rediscuter"
    ],
    "rediscutera": [
        "rediscuter"
    ],
    "rediscuterons": [
        "rediscuter"
    ],
    "redise": [
        "redire"
    ],
    "redisent": [
        "redire"
    ],
    "redises": [
        "redire"
    ],
    "redisposer": [
        "redisposer"
    ],
    "redistribua": [
        "redistribuer"
    ],
    "redistribuais": [
        "redistribuer"
    ],
    "redistribuait": [
        "redistribuer"
    ],
    "redistribue": [
        "redistribuer"
    ],
    "redistribuent": [
        "redistribuer"
    ],
    "redistribuer": [
        "redistribuer"
    ],
    "redistribueras": [
        "redistribuer"
    ],
    "redistribuons": [
        "redistribuer"
    ],
    "redistribution": [
        "redistribution"
    ],
    "redistributions": [
        "redistribution"
    ],
    "redistribues": [
        "redistribuer"
    ],
    "redit": [
        "redire"
    ],
    "redite": [
        "redite",
        "redire"
    ],
    "redites": [
        "redite",
        "redire"
    ],
    "redits": [
        "redire"
    ],
    "redondance": [
        "redondance"
    ],
    "redondances": [
        "redondance"
    ],
    "redondant": [
        "redondant"
    ],
    "redondante": [
        "redondant"
    ],
    "redondantes": [
        "redondant"
    ],
    "redondants": [
        "redondant"
    ],
    "redonna": [
        "redonner"
    ],
    "redonnai": [
        "redonner"
    ],
    "redonnaient": [
        "redonner"
    ],
    "redonnais": [
        "redonner"
    ],
    "redonnait": [
        "redonner"
    ],
    "redonnant": [
        "redonner"
    ],
    "redonne": [
        "redonner"
    ],
    "redonnent": [
        "redonner"
    ],
    "redonner": [
        "redonner"
    ],
    "redonnera": [
        "redonner"
    ],
    "redonnerai": [
        "redonner"
    ],
    "redonneraient": [
        "redonner"
    ],
    "redonnerais": [
        "redonner"
    ],
    "redonnerait": [
        "redonner"
    ],
    "redonneras": [
        "redonner"
    ],
    "redonnerons": [
        "redonner"
    ],
    "redonneront": [
        "redonner"
    ],
    "redonnes": [
        "redonner"
    ],
    "redonnez": [
        "redonner"
    ],
    "redonniez": [
        "redonner"
    ],
    "redonnons": [
        "redonner"
    ],
    "redonnat": [
        "redonner"
    ],
    "redorer": [
        "redorer"
    ],
    "redormir": [
        "redormir"
    ],
    "redors": [
        "redormir"
    ],
    "redort": [
        "redormir"
    ],
    "redore": [
        "redorer"
    ],
    "redorees": [
        "redorer"
    ],
    "redoubla": [
        "redoubler"
    ],
    "redoublai": [
        "redoubler"
    ],
    "redoublaient": [
        "redoubler"
    ],
    "redoublais": [
        "redoubler"
    ],
    "redoublait": [
        "redoubler"
    ],
    "redoublant": [
        "redoubler",
        "redoublant"
    ],
    "redoublants": [
        "redoublant"
    ],
    "redouble": [
        "redouble",
        "redoubler"
    ],
    "redoublement": [
        "redoublement"
    ],
    "redoublent": [
        "redoubler"
    ],
    "redoubler": [
        "redoubler"
    ],
    "redoublera": [
        "redoubler"
    ],
    "redoublerai": [
        "redoubler"
    ],
    "redoublerait": [
        "redoubler"
    ],
    "redoubleront": [
        "redoubler"
    ],
    "redoublez": [
        "redoubler"
    ],
    "redoublions": [
        "redoubler"
    ],
    "redoublons": [
        "redoubler"
    ],
    "redoublerent": [
        "redoubler"
    ],
    "redoublee": [
        "redouble",
        "redoubler"
    ],
    "redoublees": [
        "redouble"
    ],
    "redoubles": [
        "redouble",
        "redoubler"
    ],
    "redouta": [
        "redouter"
    ],
    "redoutable": [
        "redoutable"
    ],
    "redoutablement": [
        "redoutablement"
    ],
    "redoutables": [
        "redoutable"
    ],
    "redoutaient": [
        "redouter"
    ],
    "redoutais": [
        "redouter"
    ],
    "redoutait": [
        "redouter"
    ],
    "redoutant": [
        "redouter"
    ],
    "redoutasse": [
        "redouter"
    ],
    "redoute": [
        "redoute",
        "redouter"
    ],
    "redoutent": [
        "redouter"
    ],
    "redouter": [
        "redouter"
    ],
    "redouterait": [
        "redouter"
    ],
    "redouteras": [
        "redouter"
    ],
    "redoutes": [
        "redoute",
        "redouter"
    ],
    "redoutez": [
        "redouter"
    ],
    "redoutiez": [
        "redouter"
    ],
    "redoutions": [
        "redouter"
    ],
    "redoutons": [
        "redouter"
    ],
    "redoutat": [
        "redouter"
    ],
    "redouterent": [
        "redouter"
    ],
    "redoutee": [
        "redouter"
    ],
    "redoutees": [
        "redouter"
    ],
    "redoux": [
        "redoux"
    ],
    "redressa": [
        "redresser"
    ],
    "redressai": [
        "redresser"
    ],
    "redressaient": [
        "redresser"
    ],
    "redressais": [
        "redresser"
    ],
    "redressait": [
        "redresser"
    ],
    "redressant": [
        "redresser"
    ],
    "redresse": [
        "redresser"
    ],
    "redressement": [
        "redressement"
    ],
    "redressements": [
        "redressement"
    ],
    "redressent": [
        "redresser"
    ],
    "redresser": [
        "redresser"
    ],
    "redressera": [
        "redresser"
    ],
    "redresserai": [
        "redresser"
    ],
    "redresserait": [
        "redresser"
    ],
    "redresserons": [
        "redresser"
    ],
    "redresses": [
        "redress",
        "redresser"
    ],
    "redresseur": [
        "redresseur"
    ],
    "redresseurs": [
        "redresseur"
    ],
    "redresseuse": [
        "redresseur"
    ],
    "redressez": [
        "redresser"
    ],
    "redressons": [
        "redresser"
    ],
    "redressat": [
        "redresser"
    ],
    "redresserent": [
        "redresser"
    ],
    "redressee": [
        "redresser"
    ],
    "redressees": [
        "redresser"
    ],
    "redeconner": [
        "redeconner"
    ],
    "redecore": [
        "redecore"
    ],
    "redecoupage": [
        "redecoupage"
    ],
    "redecouvert": [
        "redecouvrir"
    ],
    "redecouverte": [
        "redecouverte"
    ],
    "redecouvertes": [
        "redecouvrir"
    ],
    "redecouverts": [
        "redecouvert"
    ],
    "redecouvraient": [
        "redecouvrir"
    ],
    "redecouvrait": [
        "redecouvrir"
    ],
    "redecouvrant": [
        "redecouvrir"
    ],
    "redecouvre": [
        "redecouvrir"
    ],
    "redecouvrent": [
        "redecouvrir"
    ],
    "redecouvrions": [
        "redecouvrir"
    ],
    "redecouvrir": [
        "redecouvrir"
    ],
    "redecouvrira": [
        "redecouvrir"
    ],
    "redecouvriront": [
        "redecouvrir"
    ],
    "redecouvris": [
        "redecouvrir"
    ],
    "redecouvrit": [
        "redecouvrir"
    ],
    "redecouvrons": [
        "redecouvrir"
    ],
    "redefini": [
        "redefinir"
    ],
    "redefinir": [
        "redefinir"
    ],
    "redefinis": [
        "redefinir"
    ],
    "redefinissons": [
        "redefinir"
    ],
    "redefinition": [
        "redefinition"
    ],
    "redegringoler": [
        "redegringoler"
    ],
    "redemarra": [
        "redemarrer"
    ],
    "redemarrage": [
        "redemarrage"
    ],
    "redemarraient": [
        "redemarrer"
    ],
    "redemarrais": [
        "redemarrer"
    ],
    "redemarrait": [
        "redemarrer"
    ],
    "redemarrant": [
        "redemarrer"
    ],
    "redemarre": [
        "redemarrer"
    ],
    "redemarrent": [
        "redemarrer"
    ],
    "redemarrer": [
        "redemarrer"
    ],
    "redemarrera": [
        "redemarrer"
    ],
    "redemarrerait": [
        "redemarrer"
    ],
    "redemarrez": [
        "redemarrer"
    ],
    "redemarrons": [
        "redemarrer"
    ],
    "redemolir": [
        "redemolir"
    ],
    "redeploie": [
        "redeployer"
    ],
    "redeploiement": [
        "redeploiement"
    ],
    "redeployer": [
        "redeployer"
    ],
    "redeployez": [
        "redeployer"
    ],
    "redeposer": [
        "redeposer"
    ],
    "redepose": [
        "redeposer"
    ],
    "refabriquer": [
        "refabriquer"
    ],
    "refaire": [
        "refaire"
    ],
    "refais": [
        "refaire"
    ],
    "refaisaient": [
        "refaire"
    ],
    "refaisais": [
        "refaire"
    ],
    "refaisait": [
        "refaire"
    ],
    "refaisant": [
        "refaire"
    ],
    "refaisions": [
        "refaire"
    ],
    "refaisons": [
        "refaire"
    ],
    "refait": [
        "refait",
        "refaire"
    ],
    "refaite": [
        "refait",
        "refaire"
    ],
    "refaites": [
        "refait",
        "refaire"
    ],
    "refaits": [
        "refait",
        "refaire"
    ],
    "refamiliariser": [
        "refamiliariser"
    ],
    "refasse": [
        "refaire"
    ],
    "refassent": [
        "refaire"
    ],
    "refasses": [
        "refaire"
    ],
    "refassiez": [
        "refaire"
    ],
    "refaufile": [
        "refaufiler"
    ],
    "refaconner": [
        "refaconner"
    ],
    "refendre": [
        "refendre"
    ],
    "refendu": [
        "refendre"
    ],
    "refera": [
        "refaire"
    ],
    "referai": [
        "refaire"
    ],
    "referais": [
        "refaire"
    ],
    "referait": [
        "referer",
        "refaire"
    ],
    "referas": [
        "refaire"
    ],
    "referendum": [
        "referendum"
    ],
    "referions": [
        "refaire"
    ],
    "referma": [
        "refermer"
    ],
    "refermai": [
        "refermer"
    ],
    "refermaient": [
        "refermer"
    ],
    "refermais": [
        "refermer"
    ],
    "refermait": [
        "refermer"
    ],
    "refermant": [
        "refermer"
    ],
    "refermassent": [
        "refermer"
    ],
    "referme": [
        "refermer"
    ],
    "referment": [
        "refermer"
    ],
    "refermer": [
        "refermer"
    ],
    "refermera": [
        "refermer"
    ],
    "refermeraient": [
        "refermer"
    ],
    "refermerais": [
        "refermer"
    ],
    "refermerait": [
        "refermer"
    ],
    "refermeront": [
        "refermer"
    ],
    "refermes": [
        "refermer"
    ],
    "refermez": [
        "refermer"
    ],
    "refermons": [
        "refermer"
    ],
    "refermames": [
        "refermer"
    ],
    "refermat": [
        "refermer"
    ],
    "refermerent": [
        "refermer"
    ],
    "refermee": [
        "refermer"
    ],
    "refermees": [
        "refermer"
    ],
    "referons": [
        "refaire"
    ],
    "referont": [
        "refaire"
    ],
    "refeuilleter": [
        "refeuilleter"
    ],
    "reficelai": [
        "reficeler"
    ],
    "reficelle": [
        "reficeler"
    ],
    "refil": [
        "refil"
    ],
    "refila": [
        "refiler"
    ],
    "refilai": [
        "refiler"
    ],
    "refilaient": [
        "refiler"
    ],
    "refilais": [
        "refiler"
    ],
    "refilait": [
        "refiler"
    ],
    "refilant": [
        "refiler"
    ],
    "refile": [
        "refiler"
    ],
    "refilent": [
        "refiler"
    ],
    "refiler": [
        "refiler"
    ],
    "refilera": [
        "refiler"
    ],
    "refilerait": [
        "refiler"
    ],
    "refiles": [
        "refiler"
    ],
    "refilez": [
        "refiler"
    ],
    "refilee": [
        "refiler"
    ],
    "refilees": [
        "refiler"
    ],
    "refinancement": [
        "refinancement"
    ],
    "refinancee": [
        "refinancer"
    ],
    "refirent": [
        "refaire"
    ],
    "refis": [
        "refaire"
    ],
    "refit": [
        "refaire"
    ],
    "reflet": [
        "reflet"
    ],
    "reflets": [
        "reflet"
    ],
    "refleurir": [
        "refleurir"
    ],
    "refleurira": [
        "refleurir"
    ],
    "refleurissaient": [
        "refleurir"
    ],
    "refleurissait": [
        "refleurir"
    ],
    "refleurissent": [
        "refleurir"
    ],
    "refleurit": [
        "refleurir"
    ],
    "reflex": [
        "reflex"
    ],
    "reflua": [
        "refluer"
    ],
    "refluaient": [
        "refluer"
    ],
    "refluait": [
        "refluer"
    ],
    "refluant": [
        "refluer"
    ],
    "reflue": [
        "refluer"
    ],
    "refluent": [
        "refluer"
    ],
    "refluer": [
        "refluer"
    ],
    "refluera": [
        "refluer"
    ],
    "reflux": [
        "reflux"
    ],
    "refluerent": [
        "refluer"
    ],
    "refluee": [
        "refluer"
    ],
    "reflete": [
        "refleter"
    ],
    "refletent": [
        "refleter"
    ],
    "refleta": [
        "refleter"
    ],
    "refletaient": [
        "refleter"
    ],
    "refletait": [
        "refleter"
    ],
    "refletant": [
        "refleter"
    ],
    "refleter": [
        "refleter"
    ],
    "refletera": [
        "refleter"
    ],
    "refleteraient": [
        "refleter"
    ],
    "refleterait": [
        "refleter"
    ],
    "refletons": [
        "refleter"
    ],
    "refleterent": [
        "refleter"
    ],
    "refletee": [
        "refleter"
    ],
    "refletees": [
        "refleter"
    ],
    "refletes": [
        "refleter"
    ],
    "refoncer": [
        "refoncer"
    ],
    "refondant": [
        "refonder"
    ],
    "refonde": [
        "refonder"
    ],
    "refondre": [
        "refondre"
    ],
    "refonds": [
        "refondre"
    ],
    "refondu": [
        "refondre"
    ],
    "refondus": [
        "refondre"
    ],
    "refont": [
        "refaire"
    ],
    "refonte": [
        "refonte"
    ],
    "reforger": [
        "reforger"
    ],
    "reforge": [
        "reforger"
    ],
    "reforgee": [
        "reforger"
    ],
    "reforma": [
        "reformer"
    ],
    "reformaient": [
        "reformer"
    ],
    "reformait": [
        "reformer"
    ],
    "reformant": [
        "reformer"
    ],
    "reformassent": [
        "reformer"
    ],
    "reformater": [
        "reformater"
    ],
    "reformation": [
        "reformation"
    ],
    "reforme": [
        "reforme",
        "reformer"
    ],
    "reforment": [
        "reformer"
    ],
    "reformer": [
        "reformer"
    ],
    "reformerons": [
        "reformer"
    ],
    "reformeront": [
        "reformer"
    ],
    "reformez": [
        "reformer"
    ],
    "reformulation": [
        "reformulation"
    ],
    "reformuler": [
        "reformuler"
    ],
    "reformule": [
        "reformuler"
    ],
    "reformulee": [
        "reformuler"
    ],
    "reformerent": [
        "reformer"
    ],
    "reformee": [
        "reforme",
        "reformer"
    ],
    "reformes": [
        "reforme",
        "reformer"
    ],
    "refouiller": [
        "refouiller"
    ],
    "refouille": [
        "refouiller"
    ],
    "refoula": [
        "refouler"
    ],
    "refoulai": [
        "refouler"
    ],
    "refoulaient": [
        "refouler"
    ],
    "refoulais": [
        "refouler"
    ],
    "refoulait": [
        "refouler"
    ],
    "refoulant": [
        "refoulant",
        "refouler"
    ],
    "refoulante": [
        "refoulant"
    ],
    "refoule": [
        "refoule",
        "refouler"
    ],
    "refoulement": [
        "refoulement"
    ],
    "refoulements": [
        "refoulement"
    ],
    "refoulent": [
        "refouler"
    ],
    "refouler": [
        "refouler"
    ],
    "refoulerait": [
        "refouler"
    ],
    "refoulez": [
        "refouler"
    ],
    "refouloir": [
        "refouloir"
    ],
    "refoulee": [
        "refoule",
        "refouler"
    ],
    "refoulees": [
        "refoule",
        "refouler"
    ],
    "refoules": [
        "refoule",
        "refouler"
    ],
    "refourgua": [
        "refourguer"
    ],
    "refourgue": [
        "refourguer"
    ],
    "refourguer": [
        "refourguer"
    ],
    "refourguera": [
        "refourguer"
    ],
    "refourguerait": [
        "refourguer"
    ],
    "refourguions": [
        "refourguer"
    ],
    "refourguees": [
        "refourguer"
    ],
    "refourgues": [
        "refourguer"
    ],
    "refourrait": [
        "refourrer"
    ],
    "refous": [
        "refoutre"
    ],
    "refout": [
        "refoutre"
    ],
    "refoutait": [
        "refoutre"
    ],
    "refoute": [
        "refoutre"
    ],
    "refoutent": [
        "refoutre"
    ],
    "refoutes": [
        "refoutre"
    ],
    "refoutez": [
        "refoutre"
    ],
    "refoutre": [
        "refoutre"
    ],
    "refoutu": [
        "refoutre"
    ],
    "refrain": [
        "refrain"
    ],
    "refrains": [
        "refrain"
    ],
    "refranchies": [
        "refranchir"
    ],
    "refranchir": [
        "refranchir"
    ],
    "refrappe": [
        "refrapper"
    ],
    "refrapper": [
        "refrapper"
    ],
    "refroidi": [
        "refroidir",
        "refroidi"
    ],
    "refroidie": [
        "refroidir",
        "refroidi"
    ],
    "refroidies": [
        "refroidir",
        "refroidi"
    ],
    "refroidir": [
        "refroidir"
    ],
    "refroidira": [
        "refroidir"
    ],
    "refroidiraient": [
        "refroidir"
    ],
    "refroidirais": [
        "refroidir"
    ],
    "refroidirait": [
        "refroidir"
    ],
    "refroidis": [
        "refroidir",
        "refroidi"
    ],
    "refroidissaient": [
        "refroidir"
    ],
    "refroidissais": [
        "refroidir"
    ],
    "refroidissait": [
        "refroidir"
    ],
    "refroidissant": [
        "refroidir",
        "refroidissant"
    ],
    "refroidisse": [
        "refroidir"
    ],
    "refroidissement": [
        "refroidissement"
    ],
    "refroidissent": [
        "refroidir"
    ],
    "refroidisseur": [
        "refroidisseur"
    ],
    "refroidissiez": [
        "refroidir"
    ],
    "refroidit": [
        "refroidir"
    ],
    "refrene": [
        "refrener"
    ],
    "refrena": [
        "refrener"
    ],
    "refrenai": [
        "refrener"
    ],
    "refrenait": [
        "refrener"
    ],
    "refrenant": [
        "refrener"
    ],
    "refrener": [
        "refrener"
    ],
    "refrenerait": [
        "refrener"
    ],
    "refrenes": [
        "refrener"
    ],
    "refuge": [
        "refuge"
    ],
    "refuges": [
        "refuge"
    ],
    "refuites": [
        "refuite"
    ],
    "refumer": [
        "refumer"
    ],
    "refus": [
        "refus"
    ],
    "refusa": [
        "refuser"
    ],
    "refusai": [
        "refuser"
    ],
    "refusaient": [
        "refuser"
    ],
    "refusais": [
        "refuser"
    ],
    "refusait": [
        "refuser"
    ],
    "refusant": [
        "refuser"
    ],
    "refuse": [
        "refuser",
        "refuse"
    ],
    "refusent": [
        "refuser"
    ],
    "refuser": [
        "refuser"
    ],
    "refusera": [
        "refuser"
    ],
    "refuserai": [
        "refuser"
    ],
    "refuseraient": [
        "refuser"
    ],
    "refuserais": [
        "refuser"
    ],
    "refuserait": [
        "refuser"
    ],
    "refuseras": [
        "refuser"
    ],
    "refuserez": [
        "refuser"
    ],
    "refuseriez": [
        "refuser"
    ],
    "refuserions": [
        "refuser"
    ],
    "refuseront": [
        "refuser"
    ],
    "refuses": [
        "refuser",
        "refuse"
    ],
    "refusez": [
        "refuser"
    ],
    "refusiez": [
        "refuser"
    ],
    "refusions": [
        "refuser"
    ],
    "refusons": [
        "refuser"
    ],
    "refusat": [
        "refuser"
    ],
    "refuserent": [
        "refuser"
    ],
    "refusee": [
        "refuser",
        "refuse"
    ],
    "refusees": [
        "refuser",
        "refuse"
    ],
    "refimes": [
        "refaire"
    ],
    "reg": [
        "reg"
    ],
    "regagna": [
        "regagner"
    ],
    "regagnai": [
        "regagner"
    ],
    "regagnaient": [
        "regagner"
    ],
    "regagnais": [
        "regagner"
    ],
    "regagnait": [
        "regagner"
    ],
    "regagnant": [
        "regagner"
    ],
    "regagne": [
        "regagner"
    ],
    "regagnent": [
        "regagner"
    ],
    "regagner": [
        "regagner"
    ],
    "regagnera": [
        "regagner"
    ],
    "regagnerai": [
        "regagner"
    ],
    "regagneraient": [
        "regagner"
    ],
    "regagnerais": [
        "regagner"
    ],
    "regagnerait": [
        "regagner"
    ],
    "regagneras": [
        "regagner"
    ],
    "regagnerez": [
        "regagner"
    ],
    "regagnerons": [
        "regagner"
    ],
    "regagneront": [
        "regagner"
    ],
    "regagnez": [
        "regagner"
    ],
    "regagniez": [
        "regagner"
    ],
    "regagnions": [
        "regagner"
    ],
    "regagnons": [
        "regagner"
    ],
    "regagnames": [
        "regagner"
    ],
    "regagnat": [
        "regagner"
    ],
    "regagnerent": [
        "regagner"
    ],
    "regagnee": [
        "regagner"
    ],
    "regagnes": [
        "regagner"
    ],
    "regain": [
        "regain"
    ],
    "regains": [
        "regain"
    ],
    "regard": [
        "regard"
    ],
    "regarda": [
        "regarder"
    ],
    "regardable": [
        "regardable"
    ],
    "regardables": [
        "regardable"
    ],
    "regardai": [
        "regarder"
    ],
    "regardaient": [
        "regarder"
    ],
    "regardais": [
        "regarder"
    ],
    "regardait": [
        "regarder"
    ],
    "regardant": [
        "regardant",
        "regarder"
    ],
    "regardante": [
        "regardant"
    ],
    "regardants": [
        "regardant"
    ],
    "regarde": [
        "regarder"
    ],
    "regardent": [
        "regarder"
    ],
    "regarder": [
        "regarder"
    ],
    "regardera": [
        "regarder"
    ],
    "regarderai": [
        "regarder"
    ],
    "regarderaient": [
        "regarder"
    ],
    "regarderais": [
        "regarder"
    ],
    "regarderait": [
        "regarder"
    ],
    "regarderas": [
        "regarder"
    ],
    "regarderez": [
        "regarder"
    ],
    "regarderiez": [
        "regarder"
    ],
    "regarderions": [
        "regarder"
    ],
    "regarderons": [
        "regarder"
    ],
    "regarderont": [
        "regarder"
    ],
    "regardes": [
        "regarder"
    ],
    "regardeur": [
        "regardeur"
    ],
    "regardez": [
        "regarder"
    ],
    "regardiez": [
        "regarder"
    ],
    "regardions": [
        "regarder"
    ],
    "regardons": [
        "regarder"
    ],
    "regards": [
        "regard"
    ],
    "regardames": [
        "regarder"
    ],
    "regardat": [
        "regarder"
    ],
    "regarderent": [
        "regarder"
    ],
    "regardee": [
        "regarder"
    ],
    "regardees": [
        "regarder"
    ],
    "regarni": [
        "regarnir"
    ],
    "regarnies": [
        "regarnir"
    ],
    "regarnir": [
        "regarnir"
    ],
    "regarnirez": [
        "regarnir"
    ],
    "regarnis": [
        "regarnir"
    ],
    "regarnissez": [
        "regarnir"
    ],
    "regeles": [
        "regeler"
    ],
    "regency": [
        "regency"
    ],
    "reggae": [
        "reggae"
    ],
    "reggaes": [
        "reggae"
    ],
    "regimba": [
        "regimber"
    ],
    "regimbais": [
        "regimber"
    ],
    "regimbait": [
        "regimber"
    ],
    "regimbe": [
        "regimber"
    ],
    "regimbements": [
        "regimbement"
    ],
    "regimber": [
        "regimber"
    ],
    "registre": [
        "registre"
    ],
    "registres": [
        "registre"
    ],
    "reglisse": [
        "reglisse",
        "reglisser"
    ],
    "regonflage": [
        "regonflage"
    ],
    "regonflait": [
        "regonfler"
    ],
    "regonfle": [
        "regonfler"
    ],
    "regonfler": [
        "regonfler"
    ],
    "regonflera": [
        "regonfler"
    ],
    "regonflerais": [
        "regonfler"
    ],
    "regonflerait": [
        "regonfler"
    ],
    "regonfles": [
        "regonfler"
    ],
    "regorge": [
        "regorger"
    ],
    "regorgea": [
        "regorger"
    ],
    "regorgeaient": [
        "regorger"
    ],
    "regorgeais": [
        "regorger"
    ],
    "regorgeait": [
        "regorger"
    ],
    "regorgeant": [
        "regorger"
    ],
    "regorgent": [
        "regorger"
    ],
    "regorger": [
        "regorger"
    ],
    "regorges": [
        "regorger"
    ],
    "regouter": [
        "regouter"
    ],
    "regoute": [
        "regouter"
    ],
    "regrattieres": [
        "regrattier"
    ],
    "regreffe": [
        "regreffer"
    ],
    "regret": [
        "regret"
    ],
    "regrets": [
        "regret"
    ],
    "regretta": [
        "regretter"
    ],
    "regrettable": [
        "regrettable"
    ],
    "regrettablement": [
        "regrettablement"
    ],
    "regrettables": [
        "regrettable"
    ],
    "regrettai": [
        "regretter"
    ],
    "regrettaient": [
        "regretter"
    ],
    "regrettais": [
        "regretter"
    ],
    "regrettait": [
        "regretter"
    ],
    "regrettant": [
        "regretter"
    ],
    "regrette": [
        "regretter"
    ],
    "regrettent": [
        "regretter"
    ],
    "regretter": [
        "regretter",
        "rester"
    ],
    "regrettera": [
        "regretter"
    ],
    "regretterai": [
        "regretter"
    ],
    "regretteraient": [
        "regretter"
    ],
    "regretterais": [
        "regretter"
    ],
    "regretterait": [
        "regretter"
    ],
    "regretteras": [
        "regretter"
    ],
    "regretterez": [
        "regretter"
    ],
    "regretteriez": [
        "regretter"
    ],
    "regretterons": [
        "regretter"
    ],
    "regretteront": [
        "regretter"
    ],
    "regrettes": [
        "regretter"
    ],
    "regrettez": [
        "regretter"
    ],
    "regrettiez": [
        "regretter"
    ],
    "regrettions": [
        "regretter"
    ],
    "regrettons": [
        "regretter"
    ],
    "regrettat": [
        "regretter"
    ],
    "regretterent": [
        "regretter"
    ],
    "regrettee": [
        "regretter"
    ],
    "regrettees": [
        "regretter"
    ],
    "regrimpa": [
        "regrimper"
    ],
    "regrimpaient": [
        "regrimper"
    ],
    "regrimpait": [
        "regrimper"
    ],
    "regrimpe": [
        "regrimper"
    ],
    "regrimpent": [
        "regrimper"
    ],
    "regrimper": [
        "regrimper"
    ],
    "regrimperas": [
        "regrimper"
    ],
    "regrimperons": [
        "regrimper"
    ],
    "regrimpez": [
        "regrimper"
    ],
    "regrossir": [
        "regrossir"
    ],
    "regroupa": [
        "regrouper"
    ],
    "regroupaient": [
        "regrouper"
    ],
    "regroupait": [
        "regrouper"
    ],
    "regroupant": [
        "regrouper"
    ],
    "regroupe": [
        "regrouper"
    ],
    "regroupement": [
        "regroupement"
    ],
    "regroupements": [
        "regroupement"
    ],
    "regroupent": [
        "regrouper"
    ],
    "regrouper": [
        "regrouper"
    ],
    "regrouperaient": [
        "regrouper"
    ],
    "regrouperions": [
        "regrouper"
    ],
    "regroupez": [
        "regrouper"
    ],
    "regrouperent": [
        "regrouper"
    ],
    "regroupee": [
        "regrouper"
    ],
    "regroupees": [
        "regrouper"
    ],
    "regroupes": [
        "regrouper"
    ],
    "regreaient": [
        "regreer"
    ],
    "regreer": [
        "regreer"
    ],
    "regree": [
        "regreer"
    ],
    "rehaussaient": [
        "rehausser"
    ],
    "rehaussait": [
        "rehausser"
    ],
    "rehaussant": [
        "rehausser"
    ],
    "rehausse": [
        "rehausser",
        "rehausse"
    ],
    "rehaussement": [
        "rehaussement"
    ],
    "rehaussent": [
        "rehausser"
    ],
    "rehausser": [
        "rehausser"
    ],
    "rehaussera": [
        "rehausser"
    ],
    "rehausses": [
        "rehausser",
        "rehausse"
    ],
    "rehausseur": [
        "rehausseur"
    ],
    "rehaussez": [
        "rehausser"
    ],
    "rehaussee": [
        "rehausser"
    ],
    "rehaussees": [
        "rehausser"
    ],
    "rehaut": [
        "rehaut"
    ],
    "rehauts": [
        "rehaut"
    ],
    "reich": [
        "reich"
    ],
    "reichsmark": [
        "reichsmark"
    ],
    "reichstag": [
        "reichstag"
    ],
    "reichswehr": [
        "reichswehr"
    ],
    "rein": [
        "rein"
    ],
    "reine": [
        "reine"
    ],
    "reines": [
        "reine"
    ],
    "reinette": [
        "reinette"
    ],
    "reinettes": [
        "reinette"
    ],
    "reins": [
        "rein"
    ],
    "reis": [
        "reis"
    ],
    "rejailli": [
        "rejaillir"
    ],
    "rejaillir": [
        "rejaillir"
    ],
    "rejailliraient": [
        "rejaillir"
    ],
    "rejaillirait": [
        "rejaillir"
    ],
    "rejaillissaient": [
        "rejaillir"
    ],
    "rejaillissait": [
        "rejaillir"
    ],
    "rejaillissant": [
        "rejaillir"
    ],
    "rejaillissements": [
        "rejaillissement"
    ],
    "rejaillissent": [
        "rejaillir"
    ],
    "rejaillit": [
        "rejaillir"
    ],
    "rejet": [
        "rejet"
    ],
    "rejeta": [
        "rejeter"
    ],
    "rejetable": [
        "rejetable"
    ],
    "rejetai": [
        "rejeter"
    ],
    "rejetaient": [
        "rejeter"
    ],
    "rejetais": [
        "rejeter"
    ],
    "rejetait": [
        "rejeter"
    ],
    "rejetant": [
        "rejeter"
    ],
    "rejeter": [
        "rejeter"
    ],
    "rejetez": [
        "rejeter"
    ],
    "rejetiez": [
        "rejeter"
    ],
    "rejetions": [
        "rejeter"
    ],
    "rejeton": [
        "rejeton"
    ],
    "rejetons": [
        "rejeter",
        "rejeton"
    ],
    "rejets": [
        "rejet"
    ],
    "rejette": [
        "rejeter"
    ],
    "rejettent": [
        "rejeter"
    ],
    "rejettera": [
        "rejeter"
    ],
    "rejetterai": [
        "rejeter"
    ],
    "rejetteraient": [
        "rejeter"
    ],
    "rejetterais": [
        "rejeter"
    ],
    "rejetterait": [
        "rejeter"
    ],
    "rejetteras": [
        "rejeter"
    ],
    "rejetteront": [
        "rejeter"
    ],
    "rejettes": [
        "rejeter"
    ],
    "rejetat": [
        "rejeter"
    ],
    "rejeterent": [
        "rejeter"
    ],
    "rejete": [
        "rejeter",
        "rejete"
    ],
    "rejetee": [
        "rejeter",
        "rejete"
    ],
    "rejetees": [
        "rejeter",
        "rejete"
    ],
    "rejetes": [
        "rejeter",
        "rejete"
    ],
    "rejoignaient": [
        "rejoindre"
    ],
    "rejoignais": [
        "rejoindre"
    ],
    "rejoignait": [
        "rejoindre"
    ],
    "rejoignant": [
        "rejoindre"
    ],
    "rejoigne": [
        "rejoindre"
    ],
    "rejoignent": [
        "rejoindre"
    ],
    "rejoignes": [
        "rejoindre"
    ],
    "rejoignez": [
        "rejoindre"
    ],
    "rejoigniez": [
        "rejoindre"
    ],
    "rejoignions": [
        "rejoindre"
    ],
    "rejoignirent": [
        "rejoindre"
    ],
    "rejoignis": [
        "rejoindre"
    ],
    "rejoignisse": [
        "rejoindre"
    ],
    "rejoignissent": [
        "rejoindre"
    ],
    "rejoignit": [
        "rejoindre"
    ],
    "rejoignons": [
        "rejoindre"
    ],
    "rejoignimes": [
        "rejoindre"
    ],
    "rejoindra": [
        "rejoindre"
    ],
    "rejoindrai": [
        "rejoindre"
    ],
    "rejoindraient": [
        "rejoindre"
    ],
    "rejoindrais": [
        "rejoindre"
    ],
    "rejoindrait": [
        "rejoindre"
    ],
    "rejoindras": [
        "rejoindre"
    ],
    "rejoindre": [
        "rejoindre"
    ],
    "rejoindrez": [
        "rejoindre"
    ],
    "rejoindrions": [
        "rejoindre"
    ],
    "rejoindrons": [
        "rejoindre"
    ],
    "rejoindront": [
        "rejoindre"
    ],
    "rejoins": [
        "rejoindre",
        "rejoin"
    ],
    "rejoint": [
        "rejoint",
        "rejoindre"
    ],
    "rejointe": [
        "rejoindre"
    ],
    "rejointes": [
        "rejoindre"
    ],
    "rejointoyer": [
        "rejointoyer"
    ],
    "rejointoye": [
        "rejointoyer"
    ],
    "rejointoyes": [
        "rejointoyer"
    ],
    "rejoints": [
        "rejoint",
        "rejoindre"
    ],
    "rejoua": [
        "rejouer"
    ],
    "rejouaient": [
        "rejouer"
    ],
    "rejouais": [
        "rejouer"
    ],
    "rejouant": [
        "rejouer"
    ],
    "rejoue": [
        "rejouer"
    ],
    "rejouent": [
        "rejouer"
    ],
    "rejouer": [
        "rejouer"
    ],
    "rejouerait": [
        "rejouer"
    ],
    "rejoueras": [
        "rejouer"
    ],
    "rejouerez": [
        "rejouer"
    ],
    "rejouerons": [
        "rejouer"
    ],
    "rejoues": [
        "rejouer"
    ],
    "rejouez": [
        "rejouer"
    ],
    "rejouons": [
        "rejouer"
    ],
    "rejuger": [
        "rejuger"
    ],
    "rejugez": [
        "rejuger"
    ],
    "rejuge": [
        "rejuger"
    ],
    "rejuges": [
        "rejuger"
    ],
    "relacent": [
        "relacer"
    ],
    "relacer": [
        "relacer"
    ],
    "relaie": [
        "relayer"
    ],
    "relaient": [
        "relayer"
    ],
    "relaiera": [
        "relayer"
    ],
    "relaieraient": [
        "relayer"
    ],
    "relaierait": [
        "relayer"
    ],
    "relaieront": [
        "relayer"
    ],
    "relais": [
        "relais"
    ],
    "relaisser": [
        "relaisser"
    ],
    "relance": [
        "relance",
        "relancer"
    ],
    "relancement": [
        "relancement"
    ],
    "relancent": [
        "relancer"
    ],
    "relancer": [
        "relancer"
    ],
    "relancera": [
        "relancer"
    ],
    "relancerait": [
        "relancer"
    ],
    "relanceront": [
        "relancer"
    ],
    "relances": [
        "relance",
        "relancer"
    ],
    "relanceur": [
        "relanceur"
    ],
    "relancez": [
        "relancer"
    ],
    "relancerent": [
        "relancer"
    ],
    "relancee": [
        "relancer"
    ],
    "relancees": [
        "relancer"
    ],
    "relanca": [
        "relancer"
    ],
    "relancai": [
        "relancer"
    ],
    "relancaient": [
        "relancer"
    ],
    "relancais": [
        "relancer"
    ],
    "relancait": [
        "relancer"
    ],
    "relancant": [
        "relancer"
    ],
    "relancons": [
        "relancer"
    ],
    "relancat": [
        "relancer"
    ],
    "relaps": [
        "relaps"
    ],
    "relapse": [
        "relaps"
    ],
    "relapses": [
        "relapse",
        "relaps"
    ],
    "relargue": [
        "relargue"
    ],
    "relata": [
        "relater"
    ],
    "relatai": [
        "relater"
    ],
    "relataient": [
        "relater"
    ],
    "relatais": [
        "relater"
    ],
    "relatait": [
        "relater"
    ],
    "relatant": [
        "relater"
    ],
    "relate": [
        "relater"
    ],
    "relatent": [
        "relater"
    ],
    "relater": [
        "relater"
    ],
    "relateraient": [
        "relater"
    ],
    "relateront": [
        "relater"
    ],
    "relatif": [
        "relatif"
    ],
    "relatifs": [
        "relatif"
    ],
    "relation": [
        "relation"
    ],
    "relationnel": [
        "relationnel"
    ],
    "relationnelle": [
        "relationnel"
    ],
    "relationnelles": [
        "relationnel"
    ],
    "relationnels": [
        "relationnel"
    ],
    "relations": [
        "relation",
        "relater"
    ],
    "relative": [
        "relatif",
        "relative"
    ],
    "relativement": [
        "relativement"
    ],
    "relatives": [
        "relatif",
        "relative"
    ],
    "relativisant": [
        "relativiser"
    ],
    "relativisation": [
        "relativisation"
    ],
    "relativise": [
        "relativiser"
    ],
    "relativisent": [
        "relativiser"
    ],
    "relativiser": [
        "relativiser"
    ],
    "relativisme": [
        "relativisme"
    ],
    "relativiste": [
        "relativiste"
    ],
    "relativite": [
        "relativite"
    ],
    "relatee": [
        "relater"
    ],
    "relatees": [
        "relater"
    ],
    "relates": [
        "relate",
        "relater"
    ],
    "relavait": [
        "relaver"
    ],
    "relave": [
        "relaver"
    ],
    "relaver": [
        "relaver"
    ],
    "relaves": [
        "relaver"
    ],
    "relax": [
        "relax"
    ],
    "relaxais": [
        "relaxer"
    ],
    "relaxant": [
        "relaxer",
        "relaxant"
    ],
    "relaxante": [
        "relaxant"
    ],
    "relaxantes": [
        "relaxant"
    ],
    "relaxants": [
        "relaxant"
    ],
    "relaxation": [
        "relaxation"
    ],
    "relaxe": [
        "relaxe",
        "relaxer"
    ],
    "relaxer": [
        "relaxer"
    ],
    "relaxes": [
        "relaxe",
        "relaxer",
        "relax"
    ],
    "relaxez": [
        "relaxer"
    ],
    "relaxons": [
        "relaxer"
    ],
    "relaxee": [
        "relaxer"
    ],
    "relaya": [
        "relayer"
    ],
    "relayaient": [
        "relayer"
    ],
    "relayait": [
        "relayer"
    ],
    "relayant": [
        "relayer"
    ],
    "relaye": [
        "relayer"
    ],
    "relayent": [
        "relayer"
    ],
    "relayer": [
        "relayer"
    ],
    "relayera": [
        "relayer"
    ],
    "relayerai": [
        "relayer"
    ],
    "relayeur": [
        "relayeur"
    ],
    "relayez": [
        "relayer"
    ],
    "relayions": [
        "relayer"
    ],
    "relayons": [
        "relayer"
    ],
    "relayames": [
        "relayer"
    ],
    "relayerent": [
        "relayer"
    ],
    "relayee": [
        "relayer"
    ],
    "relayees": [
        "relayer"
    ],
    "relayes": [
        "relayer"
    ],
    "relaca": [
        "relacer"
    ],
    "relacaient": [
        "relacer"
    ],
    "relacait": [
        "relacer"
    ],
    "relecture": [
        "relecture"
    ],
    "relent": [
        "relent"
    ],
    "relents": [
        "relent"
    ],
    "releva": [
        "relever"
    ],
    "relevable": [
        "relevable"
    ],
    "relevai": [
        "relever"
    ],
    "relevaient": [
        "relever"
    ],
    "relevailles": [
        "relevailles"
    ],
    "relevais": [
        "relever"
    ],
    "relevait": [
        "relever"
    ],
    "relevant": [
        "relevant",
        "relever"
    ],
    "relever": [
        "relever"
    ],
    "releveur": [
        "releveur"
    ],
    "releveurs": [
        "releveur"
    ],
    "relevez": [
        "relever"
    ],
    "releviez": [
        "relever"
    ],
    "relevions": [
        "relever"
    ],
    "relevons": [
        "relever"
    ],
    "relevames": [
        "relever"
    ],
    "relevat": [
        "relever"
    ],
    "releverent": [
        "relever"
    ],
    "releve": [
        "releve",
        "relever"
    ],
    "relevee": [
        "releve",
        "relever",
        "relevee"
    ],
    "relevees": [
        "releve",
        "relever",
        "relevee"
    ],
    "releves": [
        "releve",
        "relever"
    ],
    "reliage": [
        "reliage"
    ],
    "reliaient": [
        "relier"
    ],
    "reliait": [
        "relier"
    ],
    "reliant": [
        "relier"
    ],
    "relie": [
        "relie",
        "relier"
    ],
    "relief": [
        "relief"
    ],
    "reliefs": [
        "relief"
    ],
    "relient": [
        "relier"
    ],
    "relier": [
        "relier"
    ],
    "reliera": [
        "relier"
    ],
    "relieur": [
        "relieur"
    ],
    "relieurs": [
        "relieur"
    ],
    "reliez": [
        "relier"
    ],
    "religieuse": [
        "religieux"
    ],
    "religieusement": [
        "religieusement"
    ],
    "religieuses": [
        "religieux"
    ],
    "religieux": [
        "religieux"
    ],
    "religion": [
        "religion"
    ],
    "religionnaires": [
        "religionnaire"
    ],
    "religions": [
        "religion"
    ],
    "religiosite": [
        "religiosite"
    ],
    "reliquaire": [
        "reliquaire"
    ],
    "reliquaires": [
        "reliquaire"
    ],
    "reliquat": [
        "reliquat"
    ],
    "reliquats": [
        "reliquat"
    ],
    "relique": [
        "relique"
    ],
    "reliques": [
        "relique"
    ],
    "relirai": [
        "relire"
    ],
    "relirais": [
        "relire"
    ],
    "relirait": [
        "relire"
    ],
    "reliras": [
        "relire"
    ],
    "relire": [
        "relire"
    ],
    "relirez": [
        "relire"
    ],
    "relirons": [
        "relire"
    ],
    "relis": [
        "relire"
    ],
    "relisaient": [
        "relire"
    ],
    "relisais": [
        "relire"
    ],
    "relisait": [
        "relire"
    ],
    "relisant": [
        "relire"
    ],
    "relise": [
        "relire"
    ],
    "relisez": [
        "relire"
    ],
    "relisions": [
        "relire"
    ],
    "relit": [
        "relire"
    ],
    "reliure": [
        "reliure"
    ],
    "reliures": [
        "reliure"
    ],
    "reliat": [
        "relier"
    ],
    "reliee": [
        "relie",
        "relier"
    ],
    "reliees": [
        "relie",
        "relier"
    ],
    "relies": [
        "relie",
        "relier",
        "rely"
    ],
    "reloge": [
        "reloger"
    ],
    "relogement": [
        "relogement"
    ],
    "relogements": [
        "relogement"
    ],
    "reloger": [
        "reloger"
    ],
    "relogerais": [
        "reloger"
    ],
    "relooker": [
        "relooker"
    ],
    "relookerai": [
        "relooker"
    ],
    "relooke": [
        "relooker"
    ],
    "relookee": [
        "relooker"
    ],
    "reloquer": [
        "reloquer"
    ],
    "relouer": [
        "relouer"
    ],
    "relouerons": [
        "relouer"
    ],
    "relourde": [
        "relourder"
    ],
    "relourder": [
        "relourder"
    ],
    "reloue": [
        "relouer"
    ],
    "relu": [
        "relu",
        "relire"
    ],
    "relue": [
        "relu",
        "relire"
    ],
    "relues": [
        "relire"
    ],
    "relui": [
        "reluire"
    ],
    "reluire": [
        "reluire"
    ],
    "reluiront": [
        "reluire"
    ],
    "reluis": [
        "reluire"
    ],
    "reluisaient": [
        "reluire"
    ],
    "reluisais": [
        "reluire"
    ],
    "reluisant": [
        "reluire",
        "reluisant"
    ],
    "reluisante": [
        "reluisant"
    ],
    "reluisantes": [
        "reluisant"
    ],
    "reluisants": [
        "reluisant"
    ],
    "reluise": [
        "reluire"
    ],
    "reluisent": [
        "reluire"
    ],
    "reluit": [
        "reluire"
    ],
    "reluqua": [
        "reluquer"
    ],
    "reluquaient": [
        "reluquer"
    ],
    "reluquais": [
        "reluquer"
    ],
    "reluquait": [
        "reluquer"
    ],
    "reluquant": [
        "reluquer"
    ],
    "reluque": [
        "reluquer"
    ],
    "reluquent": [
        "reluquer"
    ],
    "reluquer": [
        "reluquer"
    ],
    "reluques": [
        "reluquer"
    ],
    "reluquiez": [
        "reluquer"
    ],
    "reluquee": [
        "reluquer"
    ],
    "relus": [
        "relu",
        "relire"
    ],
    "relut": [
        "relire"
    ],
    "relacha": [
        "relacher"
    ],
    "relachai": [
        "relacher"
    ],
    "relachaient": [
        "relacher"
    ],
    "relachais": [
        "relacher"
    ],
    "relachait": [
        "relacher"
    ],
    "relachant": [
        "relacher"
    ],
    "relache": [
        "relacher",
        "relache"
    ],
    "relachement": [
        "relachement"
    ],
    "relachements": [
        "relachement"
    ],
    "relachent": [
        "relacher"
    ],
    "relacher": [
        "relacher"
    ],
    "relachera": [
        "relacher"
    ],
    "relacherai": [
        "relacher"
    ],
    "relacheraient": [
        "relacher"
    ],
    "relacherait": [
        "relacher"
    ],
    "relacheras": [
        "relacher"
    ],
    "relacherez": [
        "relacher"
    ],
    "relacherons": [
        "relacher"
    ],
    "relacheront": [
        "relacher"
    ],
    "relachez": [
        "relacher"
    ],
    "relachiez": [
        "relacher"
    ],
    "relachons": [
        "relacher"
    ],
    "relacherent": [
        "relacher"
    ],
    "relachee": [
        "relacher",
        "relache"
    ],
    "relachees": [
        "relacher",
        "relache"
    ],
    "relaches": [
        "relacher",
        "relache"
    ],
    "relegue": [
        "releguer",
        "relegue"
    ],
    "releguent": [
        "releguer"
    ],
    "relevement": [
        "relevement"
    ],
    "relevements": [
        "relevement"
    ],
    "relevent": [
        "relever"
    ],
    "relevera": [
        "relever"
    ],
    "releverai": [
        "relever"
    ],
    "releveraient": [
        "relever"
    ],
    "releverais": [
        "relever"
    ],
    "releverait": [
        "relever"
    ],
    "releveras": [
        "relever"
    ],
    "releverez": [
        "relever"
    ],
    "releverions": [
        "relever"
    ],
    "releverons": [
        "relever"
    ],
    "releveront": [
        "relever"
    ],
    "relegation": [
        "relegation"
    ],
    "relegua": [
        "releguer"
    ],
    "releguai": [
        "releguer"
    ],
    "releguaient": [
        "releguer"
    ],
    "releguait": [
        "releguer"
    ],
    "releguant": [
        "releguer"
    ],
    "releguer": [
        "releguer"
    ],
    "releguera": [
        "releguer"
    ],
    "relegueraient": [
        "releguer"
    ],
    "releguerait": [
        "releguer"
    ],
    "releguons": [
        "releguer"
    ],
    "releguerent": [
        "releguer"
    ],
    "releguee": [
        "releguer",
        "relegue"
    ],
    "releguees": [
        "releguer",
        "relegue"
    ],
    "relegues": [
        "releguer",
        "relegue"
    ],
    "remaigrir": [
        "remaigrir"
    ],
    "remaillage": [
        "remaillage"
    ],
    "remaillaient": [
        "remailler"
    ],
    "remaillant": [
        "remailler"
    ],
    "remailler": [
        "remailler"
    ],
    "remailleuse": [
        "mailleur"
    ],
    "remailles": [
        "remailler"
    ],
    "remake": [
        "remake"
    ],
    "remange": [
        "remanger"
    ],
    "remanger": [
        "remanger"
    ],
    "remangerait": [
        "remanger"
    ],
    "remania": [
        "remanier"
    ],
    "remaniait": [
        "remanier"
    ],
    "remaniant": [
        "remanier"
    ],
    "remanie": [
        "remanier"
    ],
    "remaniement": [
        "remaniement"
    ],
    "remaniements": [
        "remaniement"
    ],
    "remanier": [
        "remanier"
    ],
    "remaniee": [
        "remanier"
    ],
    "remanies": [
        "remanier"
    ],
    "remaquilla": [
        "remaquiller"
    ],
    "remaquillait": [
        "remaquiller"
    ],
    "remaquille": [
        "remaquiller"
    ],
    "remaquiller": [
        "remaquiller"
    ],
    "remaquillee": [
        "remaquiller"
    ],
    "remarchait": [
        "remarcher"
    ],
    "remarche": [
        "remarcher"
    ],
    "remarchent": [
        "remarcher"
    ],
    "remarcher": [
        "remarcher"
    ],
    "remarchera": [
        "remarcher"
    ],
    "remarcheras": [
        "remarcher"
    ],
    "remaria": [
        "remarier"
    ],
    "remariage": [
        "remariage"
    ],
    "remariaient": [
        "remarier"
    ],
    "remariait": [
        "remarier"
    ],
    "remariant": [
        "remarier"
    ],
    "remarie": [
        "remarier"
    ],
    "remarient": [
        "remarier"
    ],
    "remarier": [
        "remarier"
    ],
    "remariera": [
        "remarier"
    ],
    "remarierai": [
        "remarier"
    ],
    "remarierais": [
        "remarier"
    ],
    "remarierait": [
        "remarier"
    ],
    "remarieras": [
        "remarier"
    ],
    "remarierez": [
        "remarier"
    ],
    "remarieront": [
        "remarier"
    ],
    "remaries": [
        "remarier"
    ],
    "remariez": [
        "remarier"
    ],
    "remariions": [
        "remarier"
    ],
    "remariee": [
        "remarier"
    ],
    "remarqua": [
        "remarquer"
    ],
    "remarquable": [
        "remarquable"
    ],
    "remarquablement": [
        "remarquablement"
    ],
    "remarquables": [
        "remarquable"
    ],
    "remarquai": [
        "remarquer"
    ],
    "remarquaient": [
        "remarquer"
    ],
    "remarquais": [
        "remarquer"
    ],
    "remarquait": [
        "remarquer"
    ],
    "remarquant": [
        "remarquer"
    ],
    "remarquas": [
        "remarquer"
    ],
    "remarque": [
        "remarque",
        "remarquer"
    ],
    "remarquent": [
        "remarquer"
    ],
    "remarquer": [
        "remarquer"
    ],
    "remarquera": [
        "remarquer"
    ],
    "remarquerai": [
        "remarquer"
    ],
    "remarqueraient": [
        "remarquer"
    ],
    "remarquerais": [
        "remarquer"
    ],
    "remarquerait": [
        "remarquer"
    ],
    "remarqueras": [
        "remarquer"
    ],
    "remarquerez": [
        "remarquer"
    ],
    "remarqueriez": [
        "remarquer"
    ],
    "remarqueront": [
        "remarquer"
    ],
    "remarques": [
        "remarque",
        "remarquer"
    ],
    "remarquez": [
        "remarquer"
    ],
    "remarquiez": [
        "remarquer"
    ],
    "remarquions": [
        "remarquer"
    ],
    "remarquons": [
        "remarquer"
    ],
    "remarquames": [
        "remarquer"
    ],
    "remarquat": [
        "remarquer"
    ],
    "remarquerent": [
        "remarquer"
    ],
    "remarquee": [
        "remarquer"
    ],
    "remarquees": [
        "remarquer"
    ],
    "remballa": [
        "remballer"
    ],
    "remballage": [
        "remballage"
    ],
    "remballaient": [
        "remballer"
    ],
    "remballait": [
        "remballer"
    ],
    "remballant": [
        "remballer"
    ],
    "remballe": [
        "remballer"
    ],
    "remballent": [
        "remballer"
    ],
    "remballer": [
        "remballer"
    ],
    "remballez": [
        "remballer"
    ],
    "remballes": [
        "remballer"
    ],
    "rembarqua": [
        "rembarquer"
    ],
    "rembarquaient": [
        "rembarquer"
    ],
    "rembarque": [
        "rembarquer"
    ],
    "rembarquement": [
        "rembarquement"
    ],
    "rembarquements": [
        "rembarquement"
    ],
    "rembarquer": [
        "rembarquer"
    ],
    "rembarquez": [
        "rembarquer"
    ],
    "rembarquerent": [
        "rembarquer"
    ],
    "rembarquees": [
        "rembarquer"
    ],
    "rembarra": [
        "rembarrer"
    ],
    "rembarrais": [
        "rembarrer"
    ],
    "rembarrait": [
        "rembarrer"
    ],
    "rembarre": [
        "rembarrer"
    ],
    "rembarrer": [
        "rembarrer"
    ],
    "rembarres": [
        "rembarrer"
    ],
    "rembarree": [
        "rembarrer"
    ],
    "rembauche": [
        "rembaucher"
    ],
    "rembauches": [
        "rembaucher"
    ],
    "remblai": [
        "remblai"
    ],
    "remblaiement": [
        "remblaiement"
    ],
    "remblais": [
        "remblai"
    ],
    "remblaya": [
        "remblayer"
    ],
    "remblayer": [
        "remblayer"
    ],
    "remblaye": [
        "remblayer"
    ],
    "remblayee": [
        "remblayer"
    ],
    "rembobinage": [
        "rembobinage"
    ],
    "rembobine": [
        "rembobiner"
    ],
    "rembobiner": [
        "rembobiner"
    ],
    "rembobinez": [
        "rembobiner"
    ],
    "rembour": [
        "rembour"
    ],
    "rembourrage": [
        "rembourrage"
    ],
    "rembourrages": [
        "rembourrage"
    ],
    "rembourraient": [
        "rembourrer"
    ],
    "rembourrait": [
        "rembourrer"
    ],
    "rembourrant": [
        "rembourrer"
    ],
    "rembourre": [
        "rembourrer"
    ],
    "rembourrer": [
        "rembourrer"
    ],
    "rembourree": [
        "rembourrer"
    ],
    "rembourrees": [
        "rembourrer"
    ],
    "rembourres": [
        "rembourrer"
    ],
    "remboursa": [
        "rembourser"
    ],
    "remboursable": [
        "remboursable"
    ],
    "remboursaient": [
        "rembourser"
    ],
    "remboursais": [
        "rembourser"
    ],
    "remboursait": [
        "rembourser"
    ],
    "remboursant": [
        "rembourser"
    ],
    "rembourse": [
        "rembourser"
    ],
    "remboursement": [
        "remboursement"
    ],
    "remboursements": [
        "remboursement"
    ],
    "remboursent": [
        "rembourser"
    ],
    "rembourser": [
        "rembourser"
    ],
    "remboursera": [
        "rembourser"
    ],
    "rembourserai": [
        "rembourser"
    ],
    "rembourserais": [
        "rembourser"
    ],
    "rembourserait": [
        "rembourser"
    ],
    "rembourseras": [
        "rembourser"
    ],
    "rembourserez": [
        "rembourser"
    ],
    "rembourserons": [
        "rembourser"
    ],
    "rembourseront": [
        "rembourser"
    ],
    "rembourses": [
        "rembourser"
    ],
    "remboursez": [
        "rembourser"
    ],
    "remboursons": [
        "rembourser"
    ],
    "remboursat": [
        "rembourser"
    ],
    "rembourserent": [
        "rembourser"
    ],
    "remboursee": [
        "rembourser"
    ],
    "remboursees": [
        "rembourser"
    ],
    "remboiter": [
        "remboiter"
    ],
    "rembruni": [
        "rembrunir"
    ],
    "rembrunir": [
        "rembrunir"
    ],
    "rembrunis": [
        "rembrunir"
    ],
    "rembrunissait": [
        "rembrunir"
    ],
    "rembrunissent": [
        "rembrunir"
    ],
    "rembrunit": [
        "rembrunir"
    ],
    "remembrance": [
        "remembrance"
    ],
    "remembrement": [
        "remembrement"
    ],
    "remembres": [
        "remembrer"
    ],
    "remercia": [
        "remercier"
    ],
    "remerciai": [
        "remercier"
    ],
    "remerciaient": [
        "remercier"
    ],
    "remerciais": [
        "remercier"
    ],
    "remerciait": [
        "remercier"
    ],
    "remerciant": [
        "remercier"
    ],
    "remercie": [
        "remercier"
    ],
    "remerciement": [
        "remerciement"
    ],
    "remerciements": [
        "remerciement"
    ],
    "remercient": [
        "remercier"
    ],
    "remercier": [
        "remercier"
    ],
    "remerciera": [
        "remercier"
    ],
    "remercierai": [
        "remercier"
    ],
    "remercierais": [
        "remercier"
    ],
    "remercierait": [
        "remercier"
    ],
    "remercieras": [
        "remercier"
    ],
    "remercierez": [
        "remercier"
    ],
    "remercierons": [
        "remercier"
    ],
    "remercieront": [
        "remercier"
    ],
    "remercies": [
        "remercier"
    ],
    "remerciez": [
        "remercier"
    ],
    "remercions": [
        "remercier"
    ],
    "remerciames": [
        "remercier"
    ],
    "remercierent": [
        "remercier"
    ],
    "remerciee": [
        "remercier"
    ],
    "remet": [
        "remettre"
    ],
    "remets": [
        "remettre"
    ],
    "remettaient": [
        "remettre"
    ],
    "remettais": [
        "remettre"
    ],
    "remettait": [
        "remettre"
    ],
    "remettant": [
        "remettre",
        "remettant"
    ],
    "remette": [
        "remettre"
    ],
    "remettent": [
        "remettre"
    ],
    "remettes": [
        "remettre"
    ],
    "remettez": [
        "remettre"
    ],
    "remettiez": [
        "remettre"
    ],
    "remettions": [
        "remettre"
    ],
    "remettons": [
        "remettre"
    ],
    "remettra": [
        "remettre"
    ],
    "remettrai": [
        "remettre"
    ],
    "remettraient": [
        "remettre"
    ],
    "remettrais": [
        "remettre"
    ],
    "remettrait": [
        "remettre"
    ],
    "remettras": [
        "remettre"
    ],
    "remettre": [
        "remettre"
    ],
    "remettrez": [
        "remettre"
    ],
    "remettriez": [
        "remettre"
    ],
    "remettrions": [
        "remettre"
    ],
    "remettrons": [
        "remettre"
    ],
    "remettront": [
        "remettre"
    ],
    "remeuble": [
        "remeubler"
    ],
    "remirent": [
        "remettre"
    ],
    "remis": [
        "remis",
        "remettre"
    ],
    "remisa": [
        "remiser"
    ],
    "remisai": [
        "remiser"
    ],
    "remisaient": [
        "remiser"
    ],
    "remisait": [
        "remiser"
    ],
    "remise": [
        "remis",
        "remettre",
        "remise",
        "remiser"
    ],
    "remisent": [
        "remiser"
    ],
    "remiser": [
        "remiser"
    ],
    "remises": [
        "remis",
        "remettre",
        "remise",
        "remiser"
    ],
    "remisez": [
        "remiser"
    ],
    "remisons": [
        "remiser"
    ],
    "remisse": [
        "remettre"
    ],
    "remiserent": [
        "remiser"
    ],
    "remisee": [
        "remiser"
    ],
    "remit": [
        "remettre"
    ],
    "remix": [
        "remix"
    ],
    "remixer": [
        "remixer"
    ],
    "remmailleuses": [
        "remmailleuse"
    ],
    "remmenaient": [
        "remmener"
    ],
    "remmener": [
        "remmener"
    ],
    "remmenez": [
        "remmener"
    ],
    "remmenee": [
        "remmener"
    ],
    "remmene": [
        "remmener"
    ],
    "remmenes": [
        "remmener"
    ],
    "remobilises": [
        "remobiliser"
    ],
    "remodela": [
        "remodeler"
    ],
    "remodelage": [
        "remodelage"
    ],
    "remodelant": [
        "remodeler"
    ],
    "remodeler": [
        "remodeler"
    ],
    "remodele": [
        "remodeler"
    ],
    "remodelee": [
        "remodeler"
    ],
    "remodelees": [
        "remodeler"
    ],
    "remodeles": [
        "remodeler"
    ],
    "remonta": [
        "remonter"
    ],
    "remontage": [
        "remontage"
    ],
    "remontai": [
        "remonter"
    ],
    "remontaient": [
        "remonter"
    ],
    "remontais": [
        "remonter"
    ],
    "remontait": [
        "remonter"
    ],
    "remontant": [
        "remonter",
        "remontant"
    ],
    "remontantes": [
        "remontant"
    ],
    "remontants": [
        "remontant"
    ],
    "remonte": [
        "remonter",
        "remonte"
    ],
    "remontent": [
        "remonter"
    ],
    "remonter": [
        "remonter"
    ],
    "remontera": [
        "remonter"
    ],
    "remonterai": [
        "remonter"
    ],
    "remonteraient": [
        "remonter"
    ],
    "remonterait": [
        "remonter"
    ],
    "remonteras": [
        "remonter"
    ],
    "remonterez": [
        "remonter"
    ],
    "remonteriez": [
        "remonter"
    ],
    "remonterons": [
        "remonter"
    ],
    "remonteront": [
        "remonter"
    ],
    "remontes": [
        "remonter",
        "remonte"
    ],
    "remontez": [
        "remonter"
    ],
    "remontiez": [
        "remonter"
    ],
    "remontions": [
        "remonter"
    ],
    "remontoir": [
        "remontoir"
    ],
    "remontons": [
        "remonter"
    ],
    "remontrait": [
        "remontrer"
    ],
    "remontrance": [
        "remontrance"
    ],
    "remontrances": [
        "remontrance"
    ],
    "remontrassent": [
        "remontrer"
    ],
    "remontre": [
        "remontrer"
    ],
    "remontrer": [
        "remontrer"
    ],
    "remontrera": [
        "remontrer"
    ],
    "remontrerai": [
        "remontrer"
    ],
    "remontrerais": [
        "remontrer"
    ],
    "remontrerait": [
        "remontrer"
    ],
    "remontreras": [
        "remontrer"
    ],
    "remontres": [
        "remontrer"
    ],
    "remontrez": [
        "remontrer"
    ],
    "remontames": [
        "remonter"
    ],
    "remontat": [
        "remonter"
    ],
    "remonterent": [
        "remonter"
    ],
    "remontee": [
        "remonter",
        "remontee"
    ],
    "remontees": [
        "remonter",
        "remontee"
    ],
    "remord": [
        "remordre"
    ],
    "remordait": [
        "remordre"
    ],
    "remords": [
        "remordre",
        "remords"
    ],
    "remordu": [
        "remordre"
    ],
    "remorqua": [
        "remorquer"
    ],
    "remorquage": [
        "remorquage"
    ],
    "remorquaient": [
        "remorquer"
    ],
    "remorquait": [
        "remorquer"
    ],
    "remorquant": [
        "remorquer"
    ],
    "remorque": [
        "remorque",
        "remorquer"
    ],
    "remorquer": [
        "remorquer"
    ],
    "remorquera": [
        "remorquer"
    ],
    "remorquerai": [
        "remorquer"
    ],
    "remorques": [
        "remorque",
        "remorquer"
    ],
    "remorqueur": [
        "remorqueur"
    ],
    "remorqueurs": [
        "remorqueur"
    ],
    "remorqueuse": [
        "remorqueur"
    ],
    "remorquez": [
        "remorquer"
    ],
    "remorquions": [
        "remorquer"
    ],
    "remorquons": [
        "remorquer"
    ],
    "remorquee": [
        "remorquer"
    ],
    "remoucha": [
        "remoucher"
    ],
    "remouillaient": [
        "remouiller"
    ],
    "remouiller": [
        "remouiller"
    ],
    "remous": [
        "remous"
    ],
    "rempaillaient": [
        "rempailler"
    ],
    "rempailler": [
        "rempailler"
    ],
    "rempailleur": [
        "rempailleur"
    ],
    "rempailleurs": [
        "rempailleur"
    ],
    "rempailleuses": [
        "rempailleur"
    ],
    "rempaillee": [
        "rempailler"
    ],
    "rempaquette": [
        "rempaqueter"
    ],
    "rempaquete": [
        "rempaqueter"
    ],
    "rempart": [
        "rempart"
    ],
    "remparts": [
        "rempart"
    ],
    "rempilait": [
        "rempiler"
    ],
    "rempile": [
        "rempiler"
    ],
    "rempilent": [
        "rempiler"
    ],
    "rempiler": [
        "rempiler"
    ],
    "rempilerai": [
        "rempiler"
    ],
    "rempilerais": [
        "rempiler"
    ],
    "rempilerez": [
        "rempiler"
    ],
    "rempiles": [
        "rempiler"
    ],
    "rempilez": [
        "rempiler"
    ],
    "remplace": [
        "remplacer"
    ],
    "remplacement": [
        "remplacement"
    ],
    "remplacements": [
        "remplacement"
    ],
    "remplacent": [
        "remplacer"
    ],
    "remplacer": [
        "remplacer"
    ],
    "remplacera": [
        "remplacer"
    ],
    "remplacerai": [
        "remplacer"
    ],
    "remplaceraient": [
        "remplacer"
    ],
    "remplacerais": [
        "remplacer"
    ],
    "remplacerait": [
        "remplacer"
    ],
    "remplaceras": [
        "remplacer"
    ],
    "remplacerez": [
        "remplacer"
    ],
    "remplaceriez": [
        "remplacer"
    ],
    "remplacerons": [
        "remplacer"
    ],
    "remplaceront": [
        "remplacer"
    ],
    "remplaces": [
        "remplacer"
    ],
    "remplacez": [
        "remplacer"
    ],
    "remplaciez": [
        "remplacer"
    ],
    "remplacerent": [
        "remplacer"
    ],
    "remplacee": [
        "remplacer"
    ],
    "remplacees": [
        "remplacer"
    ],
    "remplaca": [
        "remplacer"
    ],
    "remplacable": [
        "remplacable"
    ],
    "remplacables": [
        "remplacable"
    ],
    "remplacai": [
        "remplacer"
    ],
    "remplacaient": [
        "remplacer"
    ],
    "remplacais": [
        "remplacer"
    ],
    "remplacait": [
        "remplacer"
    ],
    "remplacant": [
        "remplacant",
        "remplacer"
    ],
    "remplacante": [
        "remplacant"
    ],
    "remplacantes": [
        "remplacant"
    ],
    "remplacants": [
        "remplacant"
    ],
    "remplacons": [
        "remplacer"
    ],
    "remplacat": [
        "remplacer"
    ],
    "rempli": [
        "remplir",
        "rempli"
    ],
    "remplie": [
        "remplier",
        "rempli"
    ],
    "remplies": [
        "remplier",
        "rempli"
    ],
    "remplir": [
        "remplir"
    ],
    "remplira": [
        "remplir"
    ],
    "remplirai": [
        "remplir"
    ],
    "rempliraient": [
        "remplir"
    ],
    "remplirais": [
        "remplir"
    ],
    "remplirait": [
        "remplir"
    ],
    "rempliras": [
        "remplir"
    ],
    "remplirent": [
        "remplir"
    ],
    "remplirez": [
        "remplir"
    ],
    "remplirons": [
        "remplir"
    ],
    "rempliront": [
        "remplir"
    ],
    "remplis": [
        "remplir",
        "rempli"
    ],
    "remplissage": [
        "remplissage"
    ],
    "remplissaient": [
        "remplir"
    ],
    "remplissais": [
        "remplir"
    ],
    "remplissait": [
        "remplir"
    ],
    "remplissant": [
        "remplir"
    ],
    "remplisse": [
        "remplir"
    ],
    "remplissent": [
        "remplir"
    ],
    "remplisses": [
        "remplir"
    ],
    "remplisseur": [
        "remplisseur"
    ],
    "remplissez": [
        "remplir"
    ],
    "remplissiez": [
        "remplir"
    ],
    "remplissions": [
        "remplir"
    ],
    "remplissons": [
        "remplir"
    ],
    "remplit": [
        "remplir"
    ],
    "remploi": [
        "remploi"
    ],
    "remployee": [
        "remployer"
    ],
    "remplumer": [
        "remplumer"
    ],
    "remplumez": [
        "remplumer"
    ],
    "remplume": [
        "remplumer"
    ],
    "rempochait": [
        "rempocher"
    ],
    "rempoche": [
        "rempocher"
    ],
    "remporta": [
        "remporter"
    ],
    "remportai": [
        "remporter"
    ],
    "remportaient": [
        "remporter"
    ],
    "remportais": [
        "remporter"
    ],
    "remportait": [
        "remporter"
    ],
    "remportant": [
        "remporter"
    ],
    "remportassent": [
        "remporter"
    ],
    "remporte": [
        "remporter"
    ],
    "remportent": [
        "remporter"
    ],
    "remporter": [
        "remporter"
    ],
    "remportera": [
        "remporter"
    ],
    "remporterai": [
        "remporter"
    ],
    "remporterait": [
        "remporter"
    ],
    "remporterez": [
        "remporter"
    ],
    "remporterons": [
        "remporter"
    ],
    "remportez": [
        "remporter"
    ],
    "remportiez": [
        "remporter"
    ],
    "remportions": [
        "remporter"
    ],
    "remportat": [
        "remporter"
    ],
    "remporterent": [
        "remporter"
    ],
    "remportee": [
        "remporter"
    ],
    "remportees": [
        "remporter"
    ],
    "remportes": [
        "remporter"
    ],
    "rempoter": [
        "rempoter"
    ],
    "remprunter": [
        "remprunter"
    ],
    "remua": [
        "remuer"
    ],
    "remuage": [
        "remuage"
    ],
    "remuai": [
        "remuer"
    ],
    "remuaient": [
        "remuer"
    ],
    "remuais": [
        "remuer"
    ],
    "remuait": [
        "remuer"
    ],
    "remuant": [
        "remuer",
        "remuant"
    ],
    "remuante": [
        "remuant"
    ],
    "remuantes": [
        "remuant"
    ],
    "remuants": [
        "remuant"
    ],
    "remue": [
        "remuer",
        "remue"
    ],
    "remuement": [
        "remuement"
    ],
    "remuements": [
        "remuement"
    ],
    "remuent": [
        "remuer"
    ],
    "remuer": [
        "remuer"
    ],
    "remuera": [
        "remuer"
    ],
    "remuerai": [
        "remuer"
    ],
    "remueraient": [
        "remuer"
    ],
    "remuerais": [
        "remuer"
    ],
    "remuerait": [
        "remuer"
    ],
    "remueront": [
        "remuer"
    ],
    "remues": [
        "remuer",
        "remue"
    ],
    "remueur": [
        "remueur"
    ],
    "remueurs": [
        "remueur"
    ],
    "remuez": [
        "remuer"
    ],
    "remugle": [
        "remugle"
    ],
    "remugles": [
        "remugle"
    ],
    "remuions": [
        "remuer"
    ],
    "remuons": [
        "remuer"
    ],
    "remuscle": [
        "remuscler"
    ],
    "remuscler": [
        "remuscler"
    ],
    "remuames": [
        "remuer"
    ],
    "remuat": [
        "remuer"
    ],
    "remuerent": [
        "remuer"
    ],
    "remuee": [
        "remuer"
    ],
    "remuees": [
        "remuer"
    ],
    "remacha": [
        "remacher"
    ],
    "remachaient": [
        "remacher"
    ],
    "remachais": [
        "remacher"
    ],
    "remachait": [
        "remacher"
    ],
    "remachant": [
        "remacher"
    ],
    "remache": [
        "remacher"
    ],
    "remachent": [
        "remacher"
    ],
    "remacher": [
        "remacher"
    ],
    "remachez": [
        "remacher"
    ],
    "remachee": [
        "remacher"
    ],
    "remachees": [
        "remacher"
    ],
    "remede": [
        "remede"
    ],
    "remedes": [
        "remede"
    ],
    "remedia": [
        "remedier"
    ],
    "remediable": [
        "remediable"
    ],
    "remediait": [
        "remedier"
    ],
    "remedie": [
        "remedier"
    ],
    "remedier": [
        "remedier"
    ],
    "remediera": [
        "remedier"
    ],
    "remedierait": [
        "remedier"
    ],
    "remedierons": [
        "remedier"
    ],
    "remediez": [
        "remedier"
    ],
    "remedions": [
        "remedier"
    ],
    "rememora": [
        "rememorer"
    ],
    "rememorais": [
        "rememorer"
    ],
    "rememorait": [
        "rememorer"
    ],
    "rememorant": [
        "rememorer"
    ],
    "rememoration": [
        "rememoration"
    ],
    "rememorative": [
        "rememoratif"
    ],
    "rememore": [
        "rememorer"
    ],
    "rememorent": [
        "rememorer"
    ],
    "rememorer": [
        "rememorer"
    ],
    "remimes": [
        "remettre"
    ],
    "renais": [
        "renaitre"
    ],
    "renaissaient": [
        "renaitre"
    ],
    "renaissais": [
        "renaitre"
    ],
    "renaissait": [
        "renaitre"
    ],
    "renaissance": [
        "renaissance"
    ],
    "renaissances": [
        "renaissance"
    ],
    "renaissant": [
        "renaissant",
        "renaitre"
    ],
    "renaissante": [
        "renaissant"
    ],
    "renaissantes": [
        "renaissant"
    ],
    "renaissants": [
        "renaissant"
    ],
    "renaisse": [
        "renaitre"
    ],
    "renaissent": [
        "renaitre"
    ],
    "renaisses": [
        "renaitre"
    ],
    "renaissons": [
        "renaitre"
    ],
    "renaquit": [
        "renaitre"
    ],
    "renard": [
        "renard"
    ],
    "renarde": [
        "renard"
    ],
    "renardeau": [
        "renardeau"
    ],
    "renardeaux": [
        "renardeau"
    ],
    "renardes": [
        "renard"
    ],
    "renards": [
        "renard"
    ],
    "renaud": [
        "renaud"
    ],
    "renaudais": [
        "renauder"
    ],
    "renaudait": [
        "renauder"
    ],
    "renaudant": [
        "renauder"
    ],
    "renaude": [
        "renauder"
    ],
    "renaudent": [
        "renauder"
    ],
    "renauder": [
        "renauder"
    ],
    "renaudeur": [
        "renaudeur"
    ],
    "renait": [
        "renaitre"
    ],
    "renaitra": [
        "renaitre"
    ],
    "renaitrai": [
        "renaitre"
    ],
    "renaitraient": [
        "renaitre"
    ],
    "renaitrais": [
        "renaitre"
    ],
    "renaitrait": [
        "renaitre"
    ],
    "renaitras": [
        "renaitre"
    ],
    "renaitre": [
        "renaitre"
    ],
    "renaitrez": [
        "renaitre"
    ],
    "renaitrons": [
        "renaitre"
    ],
    "renaitront": [
        "renaitre"
    ],
    "rencard": [
        "rencard"
    ],
    "rencardaient": [
        "rencarder"
    ],
    "rencardait": [
        "rencarder"
    ],
    "rencarde": [
        "rencarder"
    ],
    "rencarder": [
        "rencarder"
    ],
    "rencards": [
        "rencard"
    ],
    "rencardee": [
        "rencarder"
    ],
    "rencardees": [
        "rencarder"
    ],
    "rencardes": [
        "rencarder"
    ],
    "rencheri": [
        "rencherir"
    ],
    "rencherir": [
        "rencherir"
    ],
    "rencheriront": [
        "rencherir"
    ],
    "rencheris": [
        "rencherir"
    ],
    "rencherissais": [
        "rencherir"
    ],
    "rencherissait": [
        "rencherir"
    ],
    "rencherissant": [
        "rencherir"
    ],
    "rencherissent": [
        "rencherir"
    ],
    "rencherit": [
        "rencherir"
    ],
    "rencogna": [
        "rencogner"
    ],
    "rencognait": [
        "rencogner"
    ],
    "rencognant": [
        "rencogner"
    ],
    "rencogne": [
        "rencogner"
    ],
    "rencogner": [
        "rencogner"
    ],
    "rencognerait": [
        "rencogner"
    ],
    "rencognes": [
        "rencogner"
    ],
    "rencontra": [
        "rencontrer"
    ],
    "rencontrai": [
        "rencontrer"
    ],
    "rencontraient": [
        "rencontrer"
    ],
    "rencontrais": [
        "rencontrer"
    ],
    "rencontrait": [
        "rencontrer"
    ],
    "rencontrant": [
        "rencontrer"
    ],
    "rencontrasse": [
        "rencontrer"
    ],
    "rencontre": [
        "rencontrer",
        "rencontre"
    ],
    "rencontrent": [
        "rencontrer"
    ],
    "rencontrer": [
        "rencontrer"
    ],
    "rencontrera": [
        "rencontrer"
    ],
    "rencontrerai": [
        "rencontrer"
    ],
    "rencontreraient": [
        "rencontrer"
    ],
    "rencontrerais": [
        "rencontrer"
    ],
    "rencontrerait": [
        "rencontrer"
    ],
    "rencontreras": [
        "rencontrer"
    ],
    "rencontrerez": [
        "rencontrer"
    ],
    "rencontreriez": [
        "rencontrer"
    ],
    "rencontrerions": [
        "rencontrer"
    ],
    "rencontrerons": [
        "rencontrer"
    ],
    "rencontreront": [
        "rencontrer"
    ],
    "rencontres": [
        "rencontrer",
        "rencontre"
    ],
    "rencontrez": [
        "rencontrer"
    ],
    "rencontriez": [
        "rencontrer"
    ],
    "rencontrions": [
        "rencontrer"
    ],
    "rencontrons": [
        "rencontrer"
    ],
    "rencontrames": [
        "rencontrer"
    ],
    "rencontrat": [
        "rencontrer"
    ],
    "rencontrerent": [
        "rencontrer"
    ],
    "rencontree": [
        "rencontrer",
        "rencontre"
    ],
    "rencontrees": [
        "rencontrer",
        "rencontre"
    ],
    "rend": [
        "rendre"
    ],
    "rendaient": [
        "rendre"
    ],
    "rendais": [
        "rendre"
    ],
    "rendait": [
        "rendre"
    ],
    "rendant": [
        "rendant",
        "rendre"
    ],
    "rende": [
        "rendre"
    ],
    "rendement": [
        "rendement"
    ],
    "rendements": [
        "rendement"
    ],
    "rendent": [
        "rendre"
    ],
    "rendes": [
        "rendre"
    ],
    "rendez": [
        "rendre"
    ],
    "rendiez": [
        "rendre"
    ],
    "rendions": [
        "rendre"
    ],
    "rendirent": [
        "rendre"
    ],
    "rendis": [
        "rendre"
    ],
    "rendisse": [
        "rendre"
    ],
    "rendissent": [
        "rendre"
    ],
    "rendit": [
        "rendre"
    ],
    "rendons": [
        "rendre"
    ],
    "rendormais": [
        "rendormir"
    ],
    "rendormait": [
        "rendormir"
    ],
    "rendormant": [
        "rendormir"
    ],
    "rendorme": [
        "rendormir"
    ],
    "rendorment": [
        "rendormir"
    ],
    "rendormez": [
        "rendormir"
    ],
    "rendormi": [
        "rendormir"
    ],
    "rendormiez": [
        "rendormir"
    ],
    "rendormir": [
        "rendormir"
    ],
    "rendormira": [
        "rendormir"
    ],
    "rendormirai": [
        "rendormir"
    ],
    "rendormirait": [
        "rendormir"
    ],
    "rendormis": [
        "rendormir"
    ],
    "rendormit": [
        "rendormir"
    ],
    "rendors": [
        "rendormir"
    ],
    "rendort": [
        "rendormir"
    ],
    "rendra": [
        "rendre"
    ],
    "rendrai": [
        "rendre"
    ],
    "rendraient": [
        "rendre"
    ],
    "rendrais": [
        "rendre"
    ],
    "rendrait": [
        "rendre"
    ],
    "rendras": [
        "rendre"
    ],
    "rendre": [
        "rendre"
    ],
    "rendrez": [
        "rendre"
    ],
    "rendriez": [
        "rendre"
    ],
    "rendrons": [
        "rendre"
    ],
    "rendront": [
        "rendre"
    ],
    "rends": [
        "rendre"
    ],
    "rendu": [
        "rendu",
        "rendre"
    ],
    "rendue": [
        "rendu",
        "rendre"
    ],
    "rendues": [
        "rendu",
        "rendre"
    ],
    "rendus": [
        "rendu",
        "rendre"
    ],
    "rendimes": [
        "rendre"
    ],
    "reneige": [
        "reneiger"
    ],
    "reneiger": [
        "reneiger"
    ],
    "renettoyer": [
        "renettoyer"
    ],
    "renferma": [
        "renfermer"
    ],
    "renfermaient": [
        "renfermer"
    ],
    "renfermait": [
        "renfermer"
    ],
    "renfermant": [
        "renfermer"
    ],
    "renferme": [
        "renferme",
        "renfermer"
    ],
    "renfermement": [
        "renfermement"
    ],
    "renferment": [
        "renfermer"
    ],
    "renfermer": [
        "renfermer"
    ],
    "renfermerait": [
        "renfermer"
    ],
    "renfermez": [
        "renfermer"
    ],
    "renfermee": [
        "renferme",
        "renfermer"
    ],
    "renfermees": [
        "renferme",
        "renfermer"
    ],
    "renfermes": [
        "renferme",
        "renfermer"
    ],
    "renfila": [
        "renfiler"
    ],
    "renfilait": [
        "renfiler"
    ],
    "renfilant": [
        "renfiler"
    ],
    "renfile": [
        "renfiler"
    ],
    "renfiler": [
        "renfiler"
    ],
    "renflait": [
        "renfler"
    ],
    "renflant": [
        "renfler"
    ],
    "renflement": [
        "renflement"
    ],
    "renflements": [
        "renflement"
    ],
    "renflent": [
        "renfler"
    ],
    "renfloua": [
        "renflouer"
    ],
    "renflouage": [
        "renflouage"
    ],
    "renflouait": [
        "renflouer"
    ],
    "renflouant": [
        "renflouer"
    ],
    "renfloue": [
        "renflouer"
    ],
    "renflouement": [
        "renflouement"
    ],
    "renflouent": [
        "renflouer"
    ],
    "renflouer": [
        "renflouer"
    ],
    "renflouee": [
        "renflouer"
    ],
    "renfloues": [
        "renflouer"
    ],
    "renfle": [
        "renfler",
        "renfle"
    ],
    "renflee": [
        "renfler",
        "renfle"
    ],
    "renflees": [
        "renfler",
        "renfle"
    ],
    "renfles": [
        "renfler"
    ],
    "renfonce": [
        "renfoncer"
    ],
    "renfoncement": [
        "renfoncement"
    ],
    "renfoncements": [
        "renfoncement"
    ],
    "renfoncer": [
        "renfoncer"
    ],
    "renfoncee": [
        "renfoncer"
    ],
    "renfoncees": [
        "renfoncer"
    ],
    "renfonces": [
        "renfoncer"
    ],
    "renfonca": [
        "renfoncer"
    ],
    "renfoncait": [
        "renfoncer"
    ],
    "renforce": [
        "renforcer"
    ],
    "renforcement": [
        "renforcement"
    ],
    "renforcements": [
        "renforcement"
    ],
    "renforcent": [
        "renforcer"
    ],
    "renforcer": [
        "renforcer"
    ],
    "renforcera": [
        "renforcer"
    ],
    "renforcerai": [
        "renforcer"
    ],
    "renforceraient": [
        "renforcer"
    ],
    "renforcerait": [
        "renforcer"
    ],
    "renforcerez": [
        "renforcer"
    ],
    "renforcerons": [
        "renforcer"
    ],
    "renforcez": [
        "renforcer"
    ],
    "renforciez": [
        "renforcer"
    ],
    "renforcerent": [
        "renforcer"
    ],
    "renforcee": [
        "renforcer"
    ],
    "renforcees": [
        "renforcer"
    ],
    "renforces": [
        "renforcer"
    ],
    "renfort": [
        "renfort"
    ],
    "renforts": [
        "renfort"
    ],
    "renforca": [
        "renforcer"
    ],
    "renforcaient": [
        "renforcer"
    ],
    "renforcait": [
        "renforcer"
    ],
    "renforcant": [
        "renforcer"
    ],
    "renforcons": [
        "renforcer"
    ],
    "renforcat": [
        "renforcer"
    ],
    "renfourche": [
        "renfourcher"
    ],
    "renfournait": [
        "renfourner"
    ],
    "renfrogna": [
        "renfrogner"
    ],
    "renfrognait": [
        "renfrogner"
    ],
    "renfrognant": [
        "renfrogner"
    ],
    "renfrogne": [
        "renfrogne",
        "renfrogner"
    ],
    "renfrognement": [
        "renfrognement"
    ],
    "renfrogner": [
        "renfrogner"
    ],
    "renfrognerait": [
        "renfrogner"
    ],
    "renfrognee": [
        "renfrogne",
        "renfrogner"
    ],
    "renfrognes": [
        "renfrogne",
        "renfrogner"
    ],
    "rengageait": [
        "rengager"
    ],
    "rengagement": [
        "rengagement"
    ],
    "rengager": [
        "rengager"
    ],
    "rengagerais": [
        "rengager"
    ],
    "rengagez": [
        "rengager"
    ],
    "rengages": [
        "rengager",
        "rengage"
    ],
    "rengaina": [
        "rengainer"
    ],
    "rengainait": [
        "rengainer"
    ],
    "rengainant": [
        "rengainer"
    ],
    "rengaine": [
        "rengainer",
        "rengaine"
    ],
    "rengainer": [
        "rengainer"
    ],
    "rengaines": [
        "rengainer",
        "rengaine"
    ],
    "rengainez": [
        "rengainer"
    ],
    "rengainerent": [
        "rengainer"
    ],
    "rengorge": [
        "rengorger"
    ],
    "rengorgea": [
        "rengorger"
    ],
    "rengorgeai": [
        "rengorger"
    ],
    "rengorgeaient": [
        "rengorger"
    ],
    "rengorgeais": [
        "rengorger"
    ],
    "rengorgeait": [
        "rengorger"
    ],
    "rengorgeant": [
        "rengorger"
    ],
    "rengorgement": [
        "rengorgement"
    ],
    "rengorgements": [
        "rengorgement"
    ],
    "rengorgent": [
        "rengorger"
    ],
    "rengorger": [
        "rengorger"
    ],
    "rengorges": [
        "rengorger"
    ],
    "rengracie": [
        "rengracier"
    ],
    "renia": [
        "renier"
    ],
    "reniai": [
        "renier"
    ],
    "reniaient": [
        "renier"
    ],
    "reniais": [
        "renier"
    ],
    "reniait": [
        "renier"
    ],
    "reniant": [
        "renier"
    ],
    "renie": [
        "renier"
    ],
    "reniement": [
        "reniement"
    ],
    "reniements": [
        "reniement"
    ],
    "renient": [
        "renier"
    ],
    "renier": [
        "renier"
    ],
    "renierai": [
        "renier"
    ],
    "renierais": [
        "renier"
    ],
    "renierait": [
        "renier"
    ],
    "renieras": [
        "renier"
    ],
    "renieront": [
        "renier"
    ],
    "renies": [
        "renier"
    ],
    "reniez": [
        "renier"
    ],
    "renifla": [
        "renifler"
    ],
    "reniflage": [
        "reniflage"
    ],
    "reniflai": [
        "renifler"
    ],
    "reniflaient": [
        "renifler"
    ],
    "reniflais": [
        "renifler"
    ],
    "reniflait": [
        "renifler"
    ],
    "reniflant": [
        "renifler",
        "reniflant"
    ],
    "renifle": [
        "renifler"
    ],
    "reniflement": [
        "reniflement"
    ],
    "reniflements": [
        "reniflement"
    ],
    "reniflent": [
        "renifler"
    ],
    "renifler": [
        "renifler"
    ],
    "reniflera": [
        "renifler"
    ],
    "reniflerait": [
        "renifler"
    ],
    "renifleries": [
        "reniflerie"
    ],
    "reniflette": [
        "reniflette"
    ],
    "renifleur": [
        "renifleur"
    ],
    "renifleurs": [
        "renifleur"
    ],
    "renifleuse": [
        "renifleur"
    ],
    "reniflez": [
        "renifler"
    ],
    "reniflee": [
        "renifler"
    ],
    "reniflees": [
        "renifler"
    ],
    "renions": [
        "renier"
    ],
    "renierent": [
        "renier"
    ],
    "reniee": [
        "renier"
    ],
    "reniees": [
        "renier"
    ],
    "rennais": [
        "rennais"
    ],
    "rennaises": [
        "rennais"
    ],
    "renne": [
        "renne"
    ],
    "rennes": [
        "renne"
    ],
    "renom": [
        "renom"
    ],
    "renommait": [
        "renommer"
    ],
    "renommer": [
        "renommer"
    ],
    "renommera": [
        "renommer"
    ],
    "renommez": [
        "renommer"
    ],
    "renomme": [
        "renommer",
        "renomme"
    ],
    "renommee": [
        "renommer",
        "renomme",
        "renommee"
    ],
    "renommees": [
        "renommer",
        "renomme"
    ],
    "renommes": [
        "renommer",
        "renomme"
    ],
    "renonce": [
        "renonce",
        "renoncer"
    ],
    "renoncement": [
        "renoncement"
    ],
    "renoncements": [
        "renoncement"
    ],
    "renoncent": [
        "renoncer"
    ],
    "renoncer": [
        "renoncer"
    ],
    "renoncera": [
        "renoncer"
    ],
    "renoncerai": [
        "renoncer"
    ],
    "renonceraient": [
        "renoncer"
    ],
    "renoncerais": [
        "renoncer"
    ],
    "renoncerait": [
        "renoncer"
    ],
    "renonceras": [
        "renoncer"
    ],
    "renoncerez": [
        "renoncer"
    ],
    "renonceriez": [
        "renoncer"
    ],
    "renoncerions": [
        "renoncer"
    ],
    "renoncerons": [
        "renoncer"
    ],
    "renonceront": [
        "renoncer"
    ],
    "renonces": [
        "renonce",
        "renoncer"
    ],
    "renoncez": [
        "renoncer"
    ],
    "renonciateur": [
        "renonciateur"
    ],
    "renonciation": [
        "renonciation"
    ],
    "renonciations": [
        "renonciation"
    ],
    "renonciez": [
        "renoncer"
    ],
    "renoncions": [
        "renoncer"
    ],
    "renonculacees": [
        "renonculacee"
    ],
    "renoncule": [
        "renoncule"
    ],
    "renoncules": [
        "renoncule"
    ],
    "renoncerent": [
        "renoncer"
    ],
    "renoncee": [
        "renoncer"
    ],
    "renonca": [
        "renoncer"
    ],
    "renoncai": [
        "renoncer"
    ],
    "renoncaient": [
        "renoncer"
    ],
    "renoncais": [
        "renoncer"
    ],
    "renoncait": [
        "renoncer"
    ],
    "renoncant": [
        "renoncer"
    ],
    "renoncons": [
        "renoncer"
    ],
    "renoncat": [
        "renoncer"
    ],
    "renoter": [
        "renoter"
    ],
    "renoua": [
        "renouer"
    ],
    "renouai": [
        "renouer"
    ],
    "renouaient": [
        "renouer"
    ],
    "renouais": [
        "renouer"
    ],
    "renouait": [
        "renouer"
    ],
    "renouant": [
        "renouer"
    ],
    "renoue": [
        "renouer"
    ],
    "renouent": [
        "renouer"
    ],
    "renouer": [
        "renouer"
    ],
    "renouerait": [
        "renouer"
    ],
    "renoueront": [
        "renouer"
    ],
    "renouons": [
        "renouer"
    ],
    "renouveau": [
        "renouveau"
    ],
    "renouveaux": [
        "renouveau"
    ],
    "renouvela": [
        "renouveler"
    ],
    "renouvelable": [
        "renouvelable"
    ],
    "renouvelai": [
        "renouveler"
    ],
    "renouvelaient": [
        "renouveler"
    ],
    "renouvelais": [
        "renouveler"
    ],
    "renouvelait": [
        "renouveler"
    ],
    "renouvelant": [
        "renouveler"
    ],
    "renouveler": [
        "renouveler"
    ],
    "renouvelez": [
        "renouveler"
    ],
    "renouvelions": [
        "renouveler"
    ],
    "renouvelle": [
        "renouveler"
    ],
    "renouvellement": [
        "renouvellement"
    ],
    "renouvellements": [
        "renouvellement"
    ],
    "renouvellent": [
        "renouveler"
    ],
    "renouvellera": [
        "renouveler"
    ],
    "renouvellerai": [
        "renouveler"
    ],
    "renouvellerait": [
        "renouveler"
    ],
    "renouvellerons": [
        "renouveler"
    ],
    "renouvelleront": [
        "renouveler"
    ],
    "renouvelles": [
        "renouveler"
    ],
    "renouvelons": [
        "renouveler"
    ],
    "renouvelames": [
        "renouveler"
    ],
    "renouvelat": [
        "renouveler"
    ],
    "renouvelerent": [
        "renouveler"
    ],
    "renouvele": [
        "renouveler"
    ],
    "renouvelee": [
        "renouveler"
    ],
    "renouvelees": [
        "renouveler"
    ],
    "renouveles": [
        "renouveler"
    ],
    "renouerent": [
        "renouer"
    ],
    "renouee": [
        "renouer",
        "renouee"
    ],
    "renoues": [
        "renouer"
    ],
    "renquillait": [
        "renquiller"
    ],
    "renquille": [
        "renquiller"
    ],
    "renseigna": [
        "renseigner"
    ],
    "renseignai": [
        "renseigner"
    ],
    "renseignaient": [
        "renseigner"
    ],
    "renseignais": [
        "renseigner"
    ],
    "renseignait": [
        "renseigner"
    ],
    "renseignant": [
        "renseigner"
    ],
    "renseigne": [
        "renseigner"
    ],
    "renseignement": [
        "renseignement"
    ],
    "renseignements": [
        "renseignement"
    ],
    "renseignent": [
        "renseigner"
    ],
    "renseigner": [
        "renseigner"
    ],
    "renseignera": [
        "renseigner"
    ],
    "renseignerai": [
        "renseigner"
    ],
    "renseigneraient": [
        "renseigner"
    ],
    "renseignerais": [
        "renseigner"
    ],
    "renseignerait": [
        "renseigner"
    ],
    "renseigneras": [
        "renseigner"
    ],
    "renseigneriez": [
        "renseigner"
    ],
    "renseignerons": [
        "renseigner"
    ],
    "renseigneront": [
        "renseigner"
    ],
    "renseignez": [
        "renseigner"
    ],
    "renseignat": [
        "renseigner"
    ],
    "renseignerent": [
        "renseigner"
    ],
    "renseignee": [
        "renseigner"
    ],
    "renseignees": [
        "renseigner"
    ],
    "renseignes": [
        "renseigner"
    ],
    "renta": [
        "renter"
    ],
    "rentabilisation": [
        "rentabilisation"
    ],
    "rentabilise": [
        "rentabiliser"
    ],
    "rentabiliser": [
        "rentabiliser"
    ],
    "rentabilisee": [
        "rentabiliser"
    ],
    "rentabilite": [
        "rentabilite"
    ],
    "rentable": [
        "rentable"
    ],
    "rentables": [
        "rentable"
    ],
    "rentamer": [
        "rentamer"
    ],
    "rente": [
        "rente"
    ],
    "renter": [
        "renter"
    ],
    "rentes": [
        "rente"
    ],
    "rentier": [
        "rentier"
    ],
    "rentiers": [
        "rentier"
    ],
    "rentiere": [
        "rentier"
    ],
    "rentieres": [
        "rentier"
    ],
    "rentoilages": [
        "rentoilage"
    ],
    "rentoilee": [
        "rentoiler"
    ],
    "rentra": [
        "rentrer"
    ],
    "rentrai": [
        "rentrer"
    ],
    "rentraient": [
        "rentrer"
    ],
    "rentrais": [
        "rentraire",
        "rentrer"
    ],
    "rentrait": [
        "rentraire",
        "rentrer"
    ],
    "rentrant": [
        "rentrant",
        "rentrer"
    ],
    "rentrante": [
        "rentrant"
    ],
    "rentrantes": [
        "rentrant"
    ],
    "rentrants": [
        "rentrant"
    ],
    "rentre": [
        "rentre",
        "rentrer"
    ],
    "rentrent": [
        "rentrer"
    ],
    "rentrer": [
        "rentrer"
    ],
    "rentrera": [
        "rentrer"
    ],
    "rentrerai": [
        "rentrer"
    ],
    "rentreraient": [
        "rentrer"
    ],
    "rentrerais": [
        "rentrer"
    ],
    "rentrerait": [
        "rentrer"
    ],
    "rentreras": [
        "rentrer"
    ],
    "rentrerez": [
        "rentrer"
    ],
    "rentreriez": [
        "rentrer"
    ],
    "rentrerions": [
        "rentrer"
    ],
    "rentrerons": [
        "rentrer"
    ],
    "rentreront": [
        "rentrer"
    ],
    "rentres": [
        "rentre",
        "rentrer"
    ],
    "rentrez": [
        "rentrer"
    ],
    "rentriez": [
        "rentrer"
    ],
    "rentrions": [
        "rentrer"
    ],
    "rentrons": [
        "rentrer"
    ],
    "rentrames": [
        "rentrer"
    ],
    "rentrat": [
        "rentrer"
    ],
    "rentrerent": [
        "rentrer"
    ],
    "rentree": [
        "rentree",
        "rentrer"
    ],
    "rentrees": [
        "rentree",
        "rentrer"
    ],
    "rentee": [
        "renter"
    ],
    "renverra": [
        "renvoyer"
    ],
    "renverrai": [
        "renvoyer"
    ],
    "renverraient": [
        "renvoyer"
    ],
    "renverrais": [
        "renvoyer"
    ],
    "renverrait": [
        "renvoyer"
    ],
    "renverras": [
        "renvoyer"
    ],
    "renverrez": [
        "renvoyer"
    ],
    "renverrions": [
        "renvoyer"
    ],
    "renverrons": [
        "renvoyer"
    ],
    "renverront": [
        "renvoyer"
    ],
    "renversa": [
        "renverser"
    ],
    "renversai": [
        "renverser"
    ],
    "renversaient": [
        "renverser"
    ],
    "renversais": [
        "renverser"
    ],
    "renversait": [
        "renverser"
    ],
    "renversant": [
        "renversant",
        "renverser"
    ],
    "renversante": [
        "renversant"
    ],
    "renversantes": [
        "renversant"
    ],
    "renverse": [
        "renverse",
        "renverser"
    ],
    "renversement": [
        "renversement"
    ],
    "renversements": [
        "renversement"
    ],
    "renversent": [
        "renverser"
    ],
    "renverser": [
        "renverser"
    ],
    "renversera": [
        "renverser"
    ],
    "renverserai": [
        "renverser"
    ],
    "renverserais": [
        "renverser"
    ],
    "renverserait": [
        "renverser"
    ],
    "renverseras": [
        "renverser"
    ],
    "renverseront": [
        "renverser"
    ],
    "renverses": [
        "renverse",
        "renverser"
    ],
    "renverseur": [
        "renverseur"
    ],
    "renversez": [
        "renverser"
    ],
    "renversons": [
        "renverser"
    ],
    "renversat": [
        "renverser"
    ],
    "renverserent": [
        "renverser"
    ],
    "renversee": [
        "renverse",
        "renverser"
    ],
    "renversees": [
        "renverse",
        "renverser"
    ],
    "renvoi": [
        "renvoi"
    ],
    "renvoie": [
        "renvoyer"
    ],
    "renvoient": [
        "renvoyer"
    ],
    "renvoies": [
        "renvoyer"
    ],
    "renvois": [
        "renvoi"
    ],
    "renvoya": [
        "renvoyer"
    ],
    "renvoyai": [
        "renvoyer"
    ],
    "renvoyaient": [
        "renvoyer"
    ],
    "renvoyais": [
        "renvoyer"
    ],
    "renvoyait": [
        "renvoyer"
    ],
    "renvoyant": [
        "renvoyer"
    ],
    "renvoyer": [
        "renvoyer"
    ],
    "renvoyez": [
        "renvoyer"
    ],
    "renvoyiez": [
        "renvoyer"
    ],
    "renvoyions": [
        "renvoyer"
    ],
    "renvoyons": [
        "renvoyer"
    ],
    "renvoyat": [
        "renvoyer"
    ],
    "renvoyerent": [
        "renvoyer"
    ],
    "renvoye": [
        "renvoyer"
    ],
    "renvoyee": [
        "renvoyer"
    ],
    "renvoyees": [
        "renvoyer"
    ],
    "renvoyes": [
        "renvoyer"
    ],
    "renacla": [
        "renacler"
    ],
    "renaclaient": [
        "renacler"
    ],
    "renaclais": [
        "renacler"
    ],
    "renaclait": [
        "renacler"
    ],
    "renaclant": [
        "renacler"
    ],
    "renacle": [
        "renacler"
    ],
    "renaclent": [
        "renacler"
    ],
    "renacler": [
        "renacler"
    ],
    "renacles": [
        "renacler"
    ],
    "renaclez": [
        "renacler"
    ],
    "renaclions": [
        "renacler"
    ],
    "rene": [
        "renaitre",
        "rene"
    ],
    "renee": [
        "renaitre"
    ],
    "renegat": [
        "renegat"
    ],
    "renegate": [
        "renegat"
    ],
    "renegats": [
        "renegat"
    ],
    "renegociation": [
        "renegociation"
    ],
    "renegocie": [
        "renegocier"
    ],
    "renegocier": [
        "renegocier"
    ],
    "renegociees": [
        "renegocier"
    ],
    "renegocies": [
        "renegocier"
    ],
    "rep": [
        "rep"
    ],
    "repaie": [
        "repayer"
    ],
    "repaies": [
        "repayer"
    ],
    "repaire": [
        "repaire"
    ],
    "repaires": [
        "repaire"
    ],
    "repais": [
        "repaitre"
    ],
    "repaissaient": [
        "repaitre"
    ],
    "repaissais": [
        "repaitre"
    ],
    "repaissait": [
        "repaitre"
    ],
    "repaissant": [
        "repaitre"
    ],
    "repaissent": [
        "repaitre"
    ],
    "reparais": [
        "reparer",
        "reparaitre"
    ],
    "reparaissaient": [
        "reparaitre"
    ],
    "reparaissait": [
        "reparaitre"
    ],
    "reparaissant": [
        "reparaitre"
    ],
    "reparaisse": [
        "reparaitre"
    ],
    "reparaissent": [
        "reparaitre"
    ],
    "reparaissez": [
        "reparaitre"
    ],
    "reparaissons": [
        "reparaitre"
    ],
    "reparait": [
        "reparer",
        "reparaitre"
    ],
    "reparaitra": [
        "reparaitre"
    ],
    "reparaitrait": [
        "reparaitre"
    ],
    "reparaitre": [
        "reparaitre"
    ],
    "reparcourant": [
        "reparcourir"
    ],
    "reparcourir": [
        "reparcourir"
    ],
    "reparcouru": [
        "reparcourir"
    ],
    "reparla": [
        "reparler"
    ],
    "reparlaient": [
        "reparler"
    ],
    "reparlais": [
        "reparler"
    ],
    "reparlait": [
        "reparler"
    ],
    "reparlant": [
        "reparler"
    ],
    "reparle": [
        "reparler"
    ],
    "reparlent": [
        "reparler"
    ],
    "reparler": [
        "reparler"
    ],
    "reparlera": [
        "reparler"
    ],
    "reparlerai": [
        "reparler"
    ],
    "reparlerez": [
        "reparler"
    ],
    "reparlerions": [
        "reparler"
    ],
    "reparlerons": [
        "reparler"
    ],
    "reparles": [
        "reparler"
    ],
    "reparlez": [
        "reparler"
    ],
    "reparliez": [
        "reparler"
    ],
    "reparlons": [
        "reparler"
    ],
    "reparlames": [
        "reparler"
    ],
    "repars": [
        "repartir"
    ],
    "repart": [
        "repartir"
    ],
    "repartaient": [
        "repartir"
    ],
    "repartais": [
        "repartir"
    ],
    "repartait": [
        "repartir"
    ],
    "repartant": [
        "repartir"
    ],
    "reparte": [
        "repartir"
    ],
    "repartent": [
        "repartir"
    ],
    "repartes": [
        "repartir"
    ],
    "repartez": [
        "repartir"
    ],
    "reparti": [
        "reparti",
        "repartir"
    ],
    "repartie": [
        "repartie",
        "repartir"
    ],
    "reparties": [
        "repartie",
        "repartir"
    ],
    "repartiez": [
        "repartir"
    ],
    "repartions": [
        "repartir"
    ],
    "repartir": [
        "repartir"
    ],
    "repartira": [
        "repartir"
    ],
    "repartirai": [
        "repartir"
    ],
    "repartiraient": [
        "repartir"
    ],
    "repartirais": [
        "repartir"
    ],
    "repartirait": [
        "repartir"
    ],
    "repartiras": [
        "repartir"
    ],
    "repartirent": [
        "repartir"
    ],
    "repartirez": [
        "repartir"
    ],
    "repartirons": [
        "repartir"
    ],
    "repartiront": [
        "repartir"
    ],
    "repartis": [
        "reparti",
        "repartir"
    ],
    "repartisse": [
        "repartir"
    ],
    "repartit": [
        "repartir"
    ],
    "repartons": [
        "repartir"
    ],
    "repartimes": [
        "repartir"
    ],
    "reparu": [
        "reparaitre"
    ],
    "reparue": [
        "reparaitre"
    ],
    "reparurent": [
        "reparaitre"
    ],
    "reparut": [
        "reparaitre"
    ],
    "repas": [
        "repas"
    ],
    "repassa": [
        "repasser"
    ],
    "repassage": [
        "repassage"
    ],
    "repassages": [
        "repassage"
    ],
    "repassai": [
        "repasser"
    ],
    "repassaient": [
        "repasser"
    ],
    "repassais": [
        "repasser"
    ],
    "repassait": [
        "repasser"
    ],
    "repassant": [
        "repasser"
    ],
    "repasse": [
        "repasser"
    ],
    "repassent": [
        "repasser"
    ],
    "repasser": [
        "repasser"
    ],
    "repassera": [
        "repasser"
    ],
    "repasserai": [
        "repasser"
    ],
    "repasseraient": [
        "repasser"
    ],
    "repasserais": [
        "repasser"
    ],
    "repasserait": [
        "repasser"
    ],
    "repasseras": [
        "repasser"
    ],
    "repasserez": [
        "repasser"
    ],
    "repasserons": [
        "repasser"
    ],
    "repasseront": [
        "repasser"
    ],
    "repasses": [
        "repasser"
    ],
    "repasseur": [
        "repasseur"
    ],
    "repasseuse": [
        "repasseur"
    ],
    "repasseuses": [
        "repasseur"
    ],
    "repassez": [
        "repasser"
    ],
    "repassiez": [
        "repasser"
    ],
    "repassions": [
        "repasser"
    ],
    "repassons": [
        "repasser"
    ],
    "repassee": [
        "repasser"
    ],
    "repassees": [
        "repasser"
    ],
    "repavage": [
        "repavage"
    ],
    "repaver": [
        "repaver"
    ],
    "repave": [
        "repaver"
    ],
    "repayais": [
        "repayer"
    ],
    "repayait": [
        "repayer"
    ],
    "repaye": [
        "repayer"
    ],
    "repayer": [
        "repayer"
    ],
    "repait": [
        "repaitre"
    ],
    "repaitre": [
        "repaitre"
    ],
    "repeigna": [
        "repeigner"
    ],
    "repeignais": [
        "repeigner"
    ],
    "repeignait": [
        "repeigner"
    ],
    "repeignant": [
        "repeigner"
    ],
    "repeigne": [
        "repeigner"
    ],
    "repeignent": [
        "repeigner"
    ],
    "repeignez": [
        "repeigner"
    ],
    "repeignit": [
        "repeindre"
    ],
    "repeignee": [
        "repeigner"
    ],
    "repeignees": [
        "repeigner"
    ],
    "repeindra": [
        "repeindre"
    ],
    "repeindrai": [
        "repeindre"
    ],
    "repeindrait": [
        "repeindre"
    ],
    "repeindre": [
        "repeindre"
    ],
    "repeins": [
        "repeindre"
    ],
    "repeint": [
        "repeint",
        "repeindre"
    ],
    "repeinte": [
        "repeindre"
    ],
    "repeintes": [
        "repeindre"
    ],
    "repeints": [
        "repeint",
        "repeindre"
    ],
    "rependra": [
        "rependre"
    ],
    "rependre": [
        "rependre"
    ],
    "repends": [
        "rependre"
    ],
    "rependu": [
        "rependre"
    ],
    "rependus": [
        "rependre"
    ],
    "repens": [
        "repentir"
    ],
    "repensa": [
        "repenser"
    ],
    "repensai": [
        "repenser"
    ],
    "repensais": [
        "repenser"
    ],
    "repensait": [
        "repenser"
    ],
    "repensant": [
        "repenser"
    ],
    "repense": [
        "repenser"
    ],
    "repensent": [
        "repenser"
    ],
    "repenser": [
        "repenser"
    ],
    "repensera": [
        "repenser"
    ],
    "repenserai": [
        "repenser"
    ],
    "repenserais": [
        "repenser"
    ],
    "repenserez": [
        "repenser"
    ],
    "repenses": [
        "repenser"
    ],
    "repensez": [
        "repenser"
    ],
    "repensons": [
        "repenser"
    ],
    "repensee": [
        "repenser"
    ],
    "repent": [
        "repentir"
    ],
    "repentaient": [
        "repentir"
    ],
    "repentait": [
        "repentir"
    ],
    "repentance": [
        "repentance"
    ],
    "repentant": [
        "repentir",
        "repentant"
    ],
    "repentante": [
        "repentant"
    ],
    "repentantes": [
        "repentant"
    ],
    "repentants": [
        "repentant"
    ],
    "repentent": [
        "repentir"
    ],
    "repentez": [
        "repentir"
    ],
    "repenti": [
        "repenti",
        "repentir"
    ],
    "repentie": [
        "repenti",
        "repentir"
    ],
    "repenties": [
        "repenti",
        "repentir"
    ],
    "repentir": [
        "repentir"
    ],
    "repentira": [
        "repentir"
    ],
    "repentirai": [
        "repentir"
    ],
    "repentirais": [
        "repentir"
    ],
    "repentiras": [
        "repentir"
    ],
    "repentirez": [
        "repentir"
    ],
    "repentirs": [
        "repentir"
    ],
    "repentis": [
        "repenti",
        "repentir"
    ],
    "repentisse": [
        "repentir"
    ],
    "repentissent": [
        "repentir"
    ],
    "repentit": [
        "repentir"
    ],
    "repentons": [
        "repentir"
    ],
    "reperdaient": [
        "reperdre"
    ],
    "reperdais": [
        "reperdre"
    ],
    "reperdons": [
        "reperdre"
    ],
    "reperdre": [
        "reperdre"
    ],
    "reperds": [
        "reperdre"
    ],
    "reperdu": [
        "reperdre"
    ],
    "reperdue": [
        "reperdre"
    ],
    "reperdues": [
        "reperdre"
    ],
    "repeuplaient": [
        "repeupler"
    ],
    "repeuplait": [
        "repeupler"
    ],
    "repeuple": [
        "repeupler"
    ],
    "repeuplement": [
        "repeuplement"
    ],
    "repeupler": [
        "repeupler"
    ],
    "repeuplee": [
        "repeupler"
    ],
    "repeuplees": [
        "repeupler"
    ],
    "repincer": [
        "repincer"
    ],
    "repince": [
        "repincer"
    ],
    "repiqua": [
        "repiquer"
    ],
    "repiquage": [
        "repiquage"
    ],
    "repiquaient": [
        "repiquer"
    ],
    "repiquait": [
        "repiquer"
    ],
    "repique": [
        "repique",
        "repiquer"
    ],
    "repiquer": [
        "repiquer"
    ],
    "repiquerai": [
        "repiquer"
    ],
    "repiquees": [
        "repiquer"
    ],
    "replace": [
        "replacer"
    ],
    "replacement": [
        "replacement"
    ],
    "replacent": [
        "replacer"
    ],
    "replacer": [
        "replacer"
    ],
    "replacerai": [
        "replacer"
    ],
    "replacerez": [
        "replacer"
    ],
    "replacez": [
        "replacer"
    ],
    "replacerent": [
        "replacer"
    ],
    "replacee": [
        "replacer"
    ],
    "replaces": [
        "replace",
        "replacer"
    ],
    "replanta": [
        "replanter"
    ],
    "replantait": [
        "replanter"
    ],
    "replantation": [
        "replantation"
    ],
    "replante": [
        "replanter"
    ],
    "replantent": [
        "replanter"
    ],
    "replanter": [
        "replanter"
    ],
    "replantez": [
        "replanter"
    ],
    "replantee": [
        "replanter"
    ],
    "replantees": [
        "replanter"
    ],
    "replantes": [
        "replanter"
    ],
    "replat": [
        "replat"
    ],
    "replats": [
        "replat"
    ],
    "replaca": [
        "replacer"
    ],
    "replacaient": [
        "replacer"
    ],
    "replacais": [
        "replacer"
    ],
    "replacait": [
        "replacer"
    ],
    "replacant": [
        "replacer"
    ],
    "replacons": [
        "replacer"
    ],
    "replet": [
        "replet"
    ],
    "replets": [
        "replet"
    ],
    "repli": [
        "repli"
    ],
    "replia": [
        "replier"
    ],
    "repliai": [
        "replier"
    ],
    "repliaient": [
        "replier"
    ],
    "repliais": [
        "replier"
    ],
    "repliait": [
        "replier"
    ],
    "repliant": [
        "replier"
    ],
    "replie": [
        "replier"
    ],
    "repliement": [
        "repliement"
    ],
    "replient": [
        "replier"
    ],
    "replier": [
        "replier"
    ],
    "repliera": [
        "replier"
    ],
    "replierai": [
        "replier"
    ],
    "replierez": [
        "replier"
    ],
    "replierons": [
        "replier"
    ],
    "replieront": [
        "replier"
    ],
    "replies": [
        "reply",
        "replier"
    ],
    "repliez": [
        "replier"
    ],
    "replions": [
        "replier"
    ],
    "replis": [
        "repli"
    ],
    "repliat": [
        "replier"
    ],
    "replierent": [
        "replier"
    ],
    "repliee": [
        "replier"
    ],
    "repliees": [
        "replier"
    ],
    "replonge": [
        "replonger"
    ],
    "replongea": [
        "replonger"
    ],
    "replongeai": [
        "replonger"
    ],
    "replongeaient": [
        "replonger"
    ],
    "replongeais": [
        "replonger"
    ],
    "replongeait": [
        "replonger"
    ],
    "replongeant": [
        "replonger"
    ],
    "replongent": [
        "replonger"
    ],
    "replonger": [
        "replonger"
    ],
    "replongera": [
        "replonger"
    ],
    "replongerai": [
        "replonger"
    ],
    "replongerais": [
        "replonger"
    ],
    "replongerait": [
        "replonger"
    ],
    "replonges": [
        "replonger"
    ],
    "replongiez": [
        "replonger"
    ],
    "replongee": [
        "replonger"
    ],
    "replongees": [
        "replonger"
    ],
    "reployait": [
        "reployer"
    ],
    "replatra": [
        "replatrer"
    ],
    "replatrage": [
        "replatrage"
    ],
    "replatraient": [
        "replatrer"
    ],
    "replatrer": [
        "replatrer"
    ],
    "replatrerait": [
        "replatrer"
    ],
    "replatre": [
        "replatrer"
    ],
    "replatree": [
        "replatrer"
    ],
    "replatrees": [
        "replatrer"
    ],
    "replete": [
        "replet"
    ],
    "repletes": [
        "replet"
    ],
    "report": [
        "report"
    ],
    "reporta": [
        "reporter"
    ],
    "reportage": [
        "reportage"
    ],
    "reportages": [
        "reportage"
    ],
    "reportait": [
        "reporter"
    ],
    "reportant": [
        "reporter"
    ],
    "reporte": [
        "reporter"
    ],
    "reportent": [
        "reporter"
    ],
    "reporter": [
        "reporter"
    ],
    "reportera": [
        "reporter"
    ],
    "reporterai": [
        "reporter"
    ],
    "reporterait": [
        "reporter"
    ],
    "reporters": [
        "reporter"
    ],
    "reportez": [
        "reporter"
    ],
    "reportons": [
        "reporter"
    ],
    "reports": [
        "report"
    ],
    "reporterent": [
        "reporter"
    ],
    "reportee": [
        "reporter"
    ],
    "reportees": [
        "reporter"
    ],
    "reportes": [
        "reporter"
    ],
    "repos": [
        "repos"
    ],
    "reposa": [
        "reposer"
    ],
    "reposai": [
        "reposer"
    ],
    "reposaient": [
        "reposer"
    ],
    "reposais": [
        "reposer"
    ],
    "reposait": [
        "reposer"
    ],
    "reposant": [
        "reposant",
        "reposer"
    ],
    "reposante": [
        "reposant"
    ],
    "reposantes": [
        "reposant"
    ],
    "reposants": [
        "reposant"
    ],
    "repose": [
        "reposer",
        "repose"
    ],
    "reposent": [
        "reposer"
    ],
    "reposer": [
        "reposer"
    ],
    "reposera": [
        "reposer"
    ],
    "reposerai": [
        "reposer"
    ],
    "reposeraient": [
        "reposer"
    ],
    "reposerais": [
        "reposer"
    ],
    "reposerait": [
        "reposer"
    ],
    "reposeras": [
        "reposer"
    ],
    "reposerez": [
        "reposer"
    ],
    "reposerions": [
        "reposer"
    ],
    "reposerons": [
        "reposer"
    ],
    "reposeront": [
        "reposer"
    ],
    "reposes": [
        "reposer",
        "repose"
    ],
    "reposez": [
        "reposer"
    ],
    "reposiez": [
        "reposer"
    ],
    "reposions": [
        "reposer"
    ],
    "repositionnent": [
        "repositionner"
    ],
    "repositionner": [
        "repositionner"
    ],
    "repositionnez": [
        "repositionner"
    ],
    "reposoir": [
        "reposoir"
    ],
    "reposoirs": [
        "reposoir"
    ],
    "reposons": [
        "reposer"
    ],
    "reposseder": [
        "reposseder"
    ],
    "repostait": [
        "reposter"
    ],
    "reposat": [
        "reposer"
    ],
    "reposerent": [
        "reposer"
    ],
    "reposee": [
        "repose",
        "reposer"
    ],
    "reposees": [
        "repose",
        "reposer"
    ],
    "repoudraient": [
        "repoudrer"
    ],
    "repoudrait": [
        "repoudrer"
    ],
    "repoudrant": [
        "repoudrer"
    ],
    "repoudre": [
        "repoudrer"
    ],
    "repoudrer": [
        "repoudrer"
    ],
    "repoudree": [
        "repoudrer"
    ],
    "repoussa": [
        "repousser"
    ],
    "repoussage": [
        "repoussage"
    ],
    "repoussai": [
        "repousser"
    ],
    "repoussaient": [
        "repousser"
    ],
    "repoussais": [
        "repousser"
    ],
    "repoussait": [
        "repousser"
    ],
    "repoussant": [
        "repousser",
        "repoussant"
    ],
    "repoussante": [
        "repoussant"
    ],
    "repoussantes": [
        "repoussant"
    ],
    "repoussants": [
        "repoussant"
    ],
    "repousse": [
        "repousse",
        "repousser"
    ],
    "repoussent": [
        "repousser"
    ],
    "repousser": [
        "repousser"
    ],
    "repoussera": [
        "repousser"
    ],
    "repousserai": [
        "repousser"
    ],
    "repousseraient": [
        "repousser"
    ],
    "repousserais": [
        "repousser"
    ],
    "repousserait": [
        "repousser"
    ],
    "repousserons": [
        "repousser"
    ],
    "repousseront": [
        "repousser"
    ],
    "repousses": [
        "repousse",
        "repousser"
    ],
    "repoussez": [
        "repousser"
    ],
    "repoussions": [
        "repousser"
    ],
    "repoussoir": [
        "repoussoir"
    ],
    "repoussoirs": [
        "repoussoir"
    ],
    "repoussons": [
        "repousser"
    ],
    "repoussames": [
        "repousser"
    ],
    "repoussat": [
        "repousser"
    ],
    "repousserent": [
        "repousser"
    ],
    "repoussee": [
        "repousser"
    ],
    "repoussees": [
        "repousser"
    ],
    "reprenaient": [
        "reprendre"
    ],
    "reprenais": [
        "reprendre"
    ],
    "reprenait": [
        "reprendre"
    ],
    "reprenant": [
        "reprendre"
    ],
    "reprend": [
        "reprendre"
    ],
    "reprendra": [
        "reprendre"
    ],
    "reprendrai": [
        "reprendre"
    ],
    "reprendraient": [
        "reprendre"
    ],
    "reprendrais": [
        "reprendre"
    ],
    "reprendrait": [
        "reprendre"
    ],
    "reprendras": [
        "reprendre"
    ],
    "reprendre": [
        "reprendre"
    ],
    "reprendrez": [
        "reprendre"
    ],
    "reprendriez": [
        "reprendre"
    ],
    "reprendrions": [
        "reprendre"
    ],
    "reprendrons": [
        "reprendre"
    ],
    "reprendront": [
        "reprendre"
    ],
    "reprends": [
        "reprendre"
    ],
    "repreneur": [
        "repreneur"
    ],
    "repreneurs": [
        "repreneur"
    ],
    "reprenez": [
        "reprendre"
    ],
    "repreniez": [
        "reprendre"
    ],
    "reprenions": [
        "reprendre"
    ],
    "reprenne": [
        "reprendre"
    ],
    "reprennent": [
        "reprendre"
    ],
    "reprennes": [
        "reprendre"
    ],
    "reprenons": [
        "reprendre"
    ],
    "reprirent": [
        "reprendre"
    ],
    "repris": [
        "repris",
        "reprendre"
    ],
    "reprisaient": [
        "repriser"
    ],
    "reprisait": [
        "repriser"
    ],
    "reprisant": [
        "repriser"
    ],
    "reprise": [
        "repriser",
        "repris",
        "reprendre",
        "reprise"
    ],
    "reprisent": [
        "repriser"
    ],
    "repriser": [
        "repriser"
    ],
    "reprises": [
        "repriser",
        "repris",
        "reprendre",
        "reprise"
    ],
    "reprisse": [
        "reprendre"
    ],
    "reprissent": [
        "reprendre"
    ],
    "reprisee": [
        "repriser"
    ],
    "reprisees": [
        "repriser"
    ],
    "reprit": [
        "reprendre"
    ],
    "reprocha": [
        "reprocher"
    ],
    "reprochai": [
        "reprocher"
    ],
    "reprochaient": [
        "reprocher"
    ],
    "reprochais": [
        "reprocher"
    ],
    "reprochait": [
        "reprocher"
    ],
    "reprochant": [
        "reprocher"
    ],
    "reproche": [
        "reprocher",
        "reproche"
    ],
    "reprochent": [
        "reprocher"
    ],
    "reprocher": [
        "reprocher"
    ],
    "reprochera": [
        "reprocher"
    ],
    "reprocherai": [
        "reprocher"
    ],
    "reprocherais": [
        "reprocher"
    ],
    "reprocherait": [
        "reprocher"
    ],
    "reprocheras": [
        "reprocher"
    ],
    "reprocheriez": [
        "reprocher"
    ],
    "reprocherons": [
        "reprocher"
    ],
    "reprocheront": [
        "reprocher"
    ],
    "reproches": [
        "reprocher",
        "reproche"
    ],
    "reprochez": [
        "reprocher"
    ],
    "reprochiez": [
        "reprocher"
    ],
    "reprochions": [
        "reprocher"
    ],
    "reprochons": [
        "reprocher"
    ],
    "reprochat": [
        "reprocher"
    ],
    "reprocherent": [
        "reprocher"
    ],
    "reprochee": [
        "reprocher"
    ],
    "reprochees": [
        "reprocher"
    ],
    "reproducteur": [
        "reproducteur"
    ],
    "reproducteurs": [
        "reproducteur"
    ],
    "reproductible": [
        "reproductible"
    ],
    "reproductif": [
        "reproductif"
    ],
    "reproductifs": [
        "reproductif"
    ],
    "reproduction": [
        "reproduction"
    ],
    "reproductions": [
        "reproduction"
    ],
    "reproductive": [
        "reproductif"
    ],
    "reproductrice": [
        "reproducteur"
    ],
    "reproductrices": [
        "reproducteur"
    ],
    "reproduira": [
        "reproduire"
    ],
    "reproduirai": [
        "reproduire"
    ],
    "reproduiraient": [
        "reproduire"
    ],
    "reproduirait": [
        "reproduire"
    ],
    "reproduire": [
        "reproduire"
    ],
    "reproduirons": [
        "reproduire"
    ],
    "reproduiront": [
        "reproduire"
    ],
    "reproduis": [
        "reproduire"
    ],
    "reproduisaient": [
        "reproduire"
    ],
    "reproduisait": [
        "reproduire"
    ],
    "reproduisant": [
        "reproduire"
    ],
    "reproduise": [
        "reproduire"
    ],
    "reproduisent": [
        "reproduire"
    ],
    "reproduisez": [
        "reproduire"
    ],
    "reproduisirent": [
        "reproduire"
    ],
    "reproduisit": [
        "reproduire"
    ],
    "reproduisons": [
        "reproduire"
    ],
    "reproduit": [
        "reproduire"
    ],
    "reproduite": [
        "reproduire"
    ],
    "reproduites": [
        "reproduire"
    ],
    "reproduits": [
        "reproduire"
    ],
    "reprogrammant": [
        "reprogrammer"
    ],
    "reprogramme": [
        "reprogrammer"
    ],
    "reprogramment": [
        "reprogrammer"
    ],
    "reprogrammer": [
        "reprogrammer"
    ],
    "reprogrammera": [
        "reprogrammer"
    ],
    "reprogrammee": [
        "reprogrammer"
    ],
    "reprogrammes": [
        "reprogrammer"
    ],
    "reprographie": [
        "reprographie"
    ],
    "reproposer": [
        "reproposer"
    ],
    "represailles": [
        "represaille"
    ],
    "representa": [
        "representer"
    ],
    "representai": [
        "representer"
    ],
    "representaient": [
        "representer"
    ],
    "representais": [
        "representer"
    ],
    "representait": [
        "representer"
    ],
    "representant": [
        "representer",
        "representant"
    ],
    "representante": [
        "representant"
    ],
    "representantes": [
        "representant"
    ],
    "representants": [
        "representant"
    ],
    "representatif": [
        "representatif"
    ],
    "representatifs": [
        "representatif"
    ],
    "representation": [
        "representation"
    ],
    "representations": [
        "representation"
    ],
    "representative": [
        "representatif"
    ],
    "representatives": [
        "representative",
        "representatif"
    ],
    "represente": [
        "representer",
        "represente"
    ],
    "representent": [
        "representer"
    ],
    "representer": [
        "representer"
    ],
    "representera": [
        "representer"
    ],
    "representerai": [
        "representer"
    ],
    "representeraient": [
        "representer"
    ],
    "representerais": [
        "representer"
    ],
    "representerait": [
        "representer"
    ],
    "representeras": [
        "representer"
    ],
    "representerez": [
        "representer"
    ],
    "representeront": [
        "representer"
    ],
    "representes": [
        "representer",
        "represente"
    ],
    "representez": [
        "representer"
    ],
    "representiez": [
        "representer"
    ],
    "representions": [
        "representer"
    ],
    "representons": [
        "representer"
    ],
    "representat": [
        "representer"
    ],
    "representerent": [
        "representer"
    ],
    "representee": [
        "representer",
        "represente"
    ],
    "representees": [
        "representer",
        "represente"
    ],
    "reprimes": [
        "reprendre",
        "reprimer"
    ],
    "reps": [
        "reps",
        "rep"
    ],
    "reptation": [
        "reptation"
    ],
    "reptations": [
        "reptation"
    ],
    "reptile": [
        "reptile"
    ],
    "reptiles": [
        "reptile"
    ],
    "reptilien": [
        "reptilien"
    ],
    "reptilienne": [
        "reptilien"
    ],
    "reptiliennes": [
        "reptilien"
    ],
    "reptiliens": [
        "reptilien"
    ],
    "repu": [
        "repu"
    ],
    "republication": [
        "republication"
    ],
    "republier": [
        "republier"
    ],
    "republions": [
        "republier"
    ],
    "repue": [
        "repu"
    ],
    "repues": [
        "repu"
    ],
    "repuiser": [
        "repuiser"
    ],
    "repus": [
        "repu"
    ],
    "repere": [
        "reperer",
        "repere"
    ],
    "reperent": [
        "reperer"
    ],
    "reperes": [
        "reperer",
        "repere"
    ],
    "repera": [
        "reperer"
    ],
    "reperable": [
        "reperable"
    ],
    "reperables": [
        "reperable"
    ],
    "reperage": [
        "reperage"
    ],
    "reperages": [
        "reperage"
    ],
    "reperaient": [
        "reperer"
    ],
    "reperais": [
        "reperer"
    ],
    "reperait": [
        "reperer"
    ],
    "reperant": [
        "reperer"
    ],
    "reperer": [
        "reperer"
    ],
    "reperera": [
        "reperer"
    ],
    "repererai": [
        "reperer"
    ],
    "repereraient": [
        "reperer"
    ],
    "repererais": [
        "reperer"
    ],
    "repererait": [
        "reperer"
    ],
    "repererons": [
        "reperer"
    ],
    "repereront": [
        "reperer"
    ],
    "repereur": [
        "repereur"
    ],
    "reperez": [
        "reperer"
    ],
    "reperiez": [
        "reperer"
    ],
    "reperions": [
        "reperer"
    ],
    "repererent": [
        "reperer"
    ],
    "reperee": [
        "reperer"
    ],
    "reperees": [
        "reperer"
    ],
    "repetrir": [
        "repetrir"
    ],
    "repetrissait": [
        "repetrir"
    ],
    "repetrit": [
        "repetrir"
    ],
    "repecha": [
        "repecher"
    ],
    "repechage": [
        "repechage"
    ],
    "repechages": [
        "repechage"
    ],
    "repechai": [
        "repecher"
    ],
    "repechait": [
        "repecher"
    ],
    "repechant": [
        "repecher"
    ],
    "repeche": [
        "repecher"
    ],
    "repecher": [
        "repecher"
    ],
    "repechera": [
        "repecher"
    ],
    "repecherait": [
        "repecher"
    ],
    "repeches": [
        "repecher"
    ],
    "repecherent": [
        "repecher"
    ],
    "repechee": [
        "repecher"
    ],
    "repechees": [
        "repecher"
    ],
    "requalifier": [
        "requalifier"
    ],
    "requiem": [
        "requiem"
    ],
    "requiems": [
        "requiem"
    ],
    "requiers": [
        "requerir"
    ],
    "requiert": [
        "requerir"
    ],
    "requin": [
        "requin"
    ],
    "requinqua": [
        "requinquer"
    ],
    "requinquait": [
        "requinquer"
    ],
    "requinque": [
        "requinquer"
    ],
    "requinquent": [
        "requinquer"
    ],
    "requinquer": [
        "requinquer"
    ],
    "requinquera": [
        "requinquer"
    ],
    "requinquerait": [
        "requinquer"
    ],
    "requinquee": [
        "requinquer"
    ],
    "requinques": [
        "requinquer"
    ],
    "requins": [
        "requin"
    ],
    "requis": [
        "requerir",
        "requis"
    ],
    "requise": [
        "requerir",
        "requis"
    ],
    "requises": [
        "requerir",
        "requis"
    ],
    "requiere": [
        "requerir"
    ],
    "requierent": [
        "requerir"
    ],
    "requeraient": [
        "requerir"
    ],
    "requerais": [
        "requerir"
    ],
    "requerait": [
        "requerir"
    ],
    "requerant": [
        "requerir",
        "requerant"
    ],
    "requerante": [
        "requerant"
    ],
    "requerants": [
        "requerant"
    ],
    "requerir": [
        "requerir"
    ],
    "requerons": [
        "requerir"
    ],
    "requete": [
        "requete"
    ],
    "requetes": [
        "requete"
    ],
    "resalir": [
        "resalir"
    ],
    "resape": [
        "resaper"
    ],
    "resapent": [
        "resaper"
    ],
    "resapee": [
        "resaper"
    ],
    "resapes": [
        "resaper"
    ],
    "rescaper": [
        "rescaper"
    ],
    "rescapes": [
        "rescape",
        "rescaper"
    ],
    "rescape": [
        "rescape",
        "rescaper"
    ],
    "rescapee": [
        "rescape",
        "rescaper"
    ],
    "rescapees": [
        "rescape",
        "rescaper"
    ],
    "rescision": [
        "rescision"
    ],
    "rescousse": [
        "rescousse"
    ],
    "rescrit": [
        "rescrit"
    ],
    "reservir": [
        "reservir"
    ],
    "reset": [
        "reset"
    ],
    "resocialisation": [
        "resocialisation"
    ],
    "resongeait": [
        "resonger"
    ],
    "resonger": [
        "resonger"
    ],
    "respect": [
        "respect"
    ],
    "respecta": [
        "respecter"
    ],
    "respectabilite": [
        "respectabilite"
    ],
    "respectable": [
        "respectable"
    ],
    "respectables": [
        "respectable"
    ],
    "respectai": [
        "respecter"
    ],
    "respectaient": [
        "respecter"
    ],
    "respectais": [
        "respecter"
    ],
    "respectait": [
        "respecter"
    ],
    "respectant": [
        "respecter"
    ],
    "respecte": [
        "respecte",
        "respecter"
    ],
    "respectent": [
        "respecter"
    ],
    "respecter": [
        "respecter"
    ],
    "respectera": [
        "respecter"
    ],
    "respecterai": [
        "respecter"
    ],
    "respecteraient": [
        "respecter"
    ],
    "respecterais": [
        "respecter"
    ],
    "respecterait": [
        "respecter"
    ],
    "respecteras": [
        "respecter"
    ],
    "respecterez": [
        "respecter"
    ],
    "respecterons": [
        "respecter"
    ],
    "respecteront": [
        "respecter"
    ],
    "respectes": [
        "respecte",
        "respecter"
    ],
    "respectez": [
        "respecter"
    ],
    "respectiez": [
        "respecter"
    ],
    "respectif": [
        "respectif"
    ],
    "respectifs": [
        "respectif"
    ],
    "respections": [
        "respecter"
    ],
    "respective": [
        "respectif"
    ],
    "respectivement": [
        "respectivement"
    ],
    "respectives": [
        "respectif"
    ],
    "respectons": [
        "respecter"
    ],
    "respects": [
        "respect"
    ],
    "respectueuse": [
        "respectueux"
    ],
    "respectueusement": [
        "respectueusement"
    ],
    "respectueuses": [
        "respectueux"
    ],
    "respectueux": [
        "respectueux"
    ],
    "respectat": [
        "respecter"
    ],
    "respectee": [
        "respecte",
        "respecter"
    ],
    "respectees": [
        "respecte",
        "respecter"
    ],
    "respir": [
        "respir"
    ],
    "respira": [
        "respirer"
    ],
    "respirable": [
        "respirable"
    ],
    "respirables": [
        "respirable"
    ],
    "respirai": [
        "respirer"
    ],
    "respiraient": [
        "respirer"
    ],
    "respirais": [
        "respirer"
    ],
    "respirait": [
        "respirer"
    ],
    "respirant": [
        "respirer"
    ],
    "respirateur": [
        "respirateur"
    ],
    "respirateurs": [
        "respirateur"
    ],
    "respiration": [
        "respiration"
    ],
    "respirations": [
        "respiration"
    ],
    "respiratoire": [
        "respiratoire"
    ],
    "respiratoires": [
        "respiratoire"
    ],
    "respire": [
        "respirer"
    ],
    "respirent": [
        "respirer"
    ],
    "respirer": [
        "respirer"
    ],
    "respirera": [
        "respirer"
    ],
    "respirerai": [
        "respirer"
    ],
    "respirerais": [
        "respirer"
    ],
    "respirerait": [
        "respirer"
    ],
    "respireras": [
        "respirer"
    ],
    "respirerez": [
        "respirer"
    ],
    "respirerons": [
        "respirer"
    ],
    "respireront": [
        "respirer"
    ],
    "respires": [
        "respirer"
    ],
    "respirez": [
        "respirer"
    ],
    "respiriez": [
        "respirer"
    ],
    "respirions": [
        "respirer"
    ],
    "respirons": [
        "respirer"
    ],
    "respirat": [
        "respirer"
    ],
    "respirerent": [
        "respirer"
    ],
    "respiree": [
        "respirer"
    ],
    "respirees": [
        "respirer"
    ],
    "resplendi": [
        "resplendir"
    ],
    "resplendir": [
        "resplendir"
    ],
    "resplendira": [
        "resplendir"
    ],
    "resplendiraient": [
        "resplendir"
    ],
    "resplendirent": [
        "resplendir"
    ],
    "resplendis": [
        "resplendir"
    ],
    "resplendissaient": [
        "resplendir"
    ],
    "resplendissait": [
        "resplendir"
    ],
    "resplendissant": [
        "resplendissant",
        "resplendir"
    ],
    "resplendissante": [
        "resplendissant"
    ],
    "resplendissantes": [
        "resplendissant"
    ],
    "resplendissants": [
        "resplendissant"
    ],
    "resplendisse": [
        "resplendir"
    ],
    "resplendissement": [
        "resplendissement"
    ],
    "resplendissent": [
        "resplendir"
    ],
    "resplendissez": [
        "resplendir"
    ],
    "resplendit": [
        "resplendir"
    ],
    "responsabilisation": [
        "responsabilisation"
    ],
    "responsabilise": [
        "responsabiliser"
    ],
    "responsabiliser": [
        "responsabiliser"
    ],
    "responsabilite": [
        "responsabilite"
    ],
    "responsabilites": [
        "responsabilite"
    ],
    "responsable": [
        "responsable"
    ],
    "responsables": [
        "responsable"
    ],
    "resquillaient": [
        "resquiller"
    ],
    "resquillant": [
        "resquiller"
    ],
    "resquille": [
        "resquiller",
        "resquille"
    ],
    "resquiller": [
        "resquiller"
    ],
    "resquillera": [
        "resquiller"
    ],
    "resquilles": [
        "resquiller"
    ],
    "resquilleur": [
        "resquilleur"
    ],
    "resquilleurs": [
        "resquilleur"
    ],
    "resquilleuse": [
        "resquilleur"
    ],
    "resquilleuses": [
        "resquilleur"
    ],
    "ressac": [
        "ressac"
    ],
    "ressacs": [
        "ressac"
    ],
    "ressaie": [
        "ressayer"
    ],
    "ressaisi": [
        "ressaisir"
    ],
    "ressaisie": [
        "ressaisir"
    ],
    "ressaisir": [
        "ressaisir"
    ],
    "ressaisira": [
        "ressaisir"
    ],
    "ressaisirais": [
        "ressaisir"
    ],
    "ressaisis": [
        "ressaisir"
    ],
    "ressaisissaient": [
        "ressaisir"
    ],
    "ressaisissais": [
        "ressaisir"
    ],
    "ressaisissait": [
        "ressaisir"
    ],
    "ressaisissant": [
        "ressaisir"
    ],
    "ressaisisse": [
        "ressaisir"
    ],
    "ressaisissement": [
        "ressaisissement"
    ],
    "ressaisisses": [
        "ressaisir"
    ],
    "ressaisissez": [
        "ressaisir"
    ],
    "ressaisissions": [
        "ressaisir"
    ],
    "ressaisissons": [
        "ressaisir"
    ],
    "ressaisit": [
        "ressaisir"
    ],
    "ressassaient": [
        "ressasser"
    ],
    "ressassais": [
        "ressasser"
    ],
    "ressassait": [
        "ressasser"
    ],
    "ressassant": [
        "ressasser"
    ],
    "ressasse": [
        "ressasser"
    ],
    "ressassement": [
        "ressassement"
    ],
    "ressassent": [
        "ressasser"
    ],
    "ressasser": [
        "ressasser"
    ],
    "ressasseur": [
        "ressasseur"
    ],
    "ressassez": [
        "ressasser"
    ],
    "ressassions": [
        "ressasser"
    ],
    "ressasserent": [
        "ressasser"
    ],
    "ressassee": [
        "ressasser"
    ],
    "ressassees": [
        "ressasser"
    ],
    "ressasses": [
        "ressasser"
    ],
    "ressaut": [
        "ressaut"
    ],
    "ressauter": [
        "ressauter"
    ],
    "ressauts": [
        "ressaut"
    ],
    "ressaute": [
        "ressauter"
    ],
    "ressayer": [
        "ressayer"
    ],
    "ressembla": [
        "ressembler"
    ],
    "ressemblaient": [
        "ressembler"
    ],
    "ressemblais": [
        "ressembler"
    ],
    "ressemblait": [
        "ressembler"
    ],
    "ressemblance": [
        "ressemblance"
    ],
    "ressemblances": [
        "ressemblance"
    ],
    "ressemblant": [
        "ressemblant",
        "ressembler"
    ],
    "ressemblante": [
        "ressemblant"
    ],
    "ressemblantes": [
        "ressemblant"
    ],
    "ressemblants": [
        "ressemblant"
    ],
    "ressemblassent": [
        "ressembler"
    ],
    "ressemble": [
        "ressembler"
    ],
    "ressemblent": [
        "ressembler"
    ],
    "ressembler": [
        "ressembler"
    ],
    "ressemblera": [
        "ressembler"
    ],
    "ressemblerai": [
        "ressembler"
    ],
    "ressembleraient": [
        "ressembler"
    ],
    "ressemblerais": [
        "ressembler"
    ],
    "ressemblerait": [
        "ressembler"
    ],
    "ressembleras": [
        "ressembler"
    ],
    "ressemblerez": [
        "ressembler"
    ],
    "ressembleront": [
        "ressembler"
    ],
    "ressembles": [
        "ressembler"
    ],
    "ressemblez": [
        "ressembler"
    ],
    "ressembliez": [
        "ressembler"
    ],
    "ressemblions": [
        "ressembler"
    ],
    "ressemblons": [
        "ressembler"
    ],
    "ressemblat": [
        "ressembler"
    ],
    "ressemblerent": [
        "ressembler"
    ],
    "ressemelage": [
        "ressemelage"
    ],
    "ressemelages": [
        "ressemelage"
    ],
    "ressemelait": [
        "ressemeler"
    ],
    "ressemeler": [
        "ressemeler"
    ],
    "ressemellent": [
        "ressemeler"
    ],
    "ressemelee": [
        "ressemeler"
    ],
    "ressemer": [
        "ressemer"
    ],
    "ressens": [
        "ressentir"
    ],
    "ressent": [
        "ressentir"
    ],
    "ressentaient": [
        "ressentir"
    ],
    "ressentais": [
        "ressentir"
    ],
    "ressentait": [
        "ressentir"
    ],
    "ressentant": [
        "ressentir"
    ],
    "ressente": [
        "ressentir"
    ],
    "ressentent": [
        "ressentir"
    ],
    "ressentes": [
        "ressentir"
    ],
    "ressentez": [
        "ressentir"
    ],
    "ressenti": [
        "ressentir",
        "ressenti"
    ],
    "ressentie": [
        "ressentir",
        "ressenti"
    ],
    "ressenties": [
        "ressentir",
        "ressenti"
    ],
    "ressentiez": [
        "ressentir"
    ],
    "ressentiment": [
        "ressentiment"
    ],
    "ressentiments": [
        "ressentiment"
    ],
    "ressentions": [
        "ressentir"
    ],
    "ressentir": [
        "ressentir"
    ],
    "ressentira": [
        "ressentir"
    ],
    "ressentirai": [
        "ressentir"
    ],
    "ressentirais": [
        "ressentir"
    ],
    "ressentirait": [
        "ressentir"
    ],
    "ressentiras": [
        "ressentir"
    ],
    "ressentirent": [
        "ressentir"
    ],
    "ressentirez": [
        "ressentir"
    ],
    "ressentiriez": [
        "ressentir"
    ],
    "ressentirions": [
        "ressentir"
    ],
    "ressentiront": [
        "ressentir"
    ],
    "ressentis": [
        "ressentir",
        "ressenti"
    ],
    "ressentit": [
        "ressentir"
    ],
    "ressentons": [
        "ressentir"
    ],
    "ressentimes": [
        "ressentir"
    ],
    "resserra": [
        "resserrer"
    ],
    "resserrage": [
        "resserrage"
    ],
    "resserraient": [
        "resserrer"
    ],
    "resserrait": [
        "resserrer"
    ],
    "resserrant": [
        "resserrer"
    ],
    "resserre": [
        "resserre",
        "resserrer"
    ],
    "resserrement": [
        "resserrement"
    ],
    "resserrent": [
        "resserrer"
    ],
    "resserrer": [
        "resserrer"
    ],
    "resserrera": [
        "resserrer"
    ],
    "resserrerai": [
        "resserrer"
    ],
    "resserrerait": [
        "resserrer"
    ],
    "resserres": [
        "resserre",
        "resserrer"
    ],
    "resserrez": [
        "resserrer"
    ],
    "resserrions": [
        "resserrer"
    ],
    "resserrons": [
        "resserrer"
    ],
    "resserrerent": [
        "resserrer"
    ],
    "resserree": [
        "resserre",
        "resserrer"
    ],
    "resserrees": [
        "resserre",
        "resserrer"
    ],
    "ressers": [
        "resservir"
    ],
    "ressert": [
        "resservir"
    ],
    "resservais": [
        "resservir"
    ],
    "resservait": [
        "resservir"
    ],
    "resservez": [
        "resservir"
    ],
    "resservi": [
        "resservir"
    ],
    "resservir": [
        "resservir"
    ],
    "resservirai": [
        "resservir"
    ],
    "resservirais": [
        "resservir"
    ],
    "resservirait": [
        "resservir"
    ],
    "resservis": [
        "resservir"
    ],
    "resservit": [
        "resservir"
    ],
    "ressors": [
        "ressortir"
    ],
    "ressort": [
        "ressort",
        "ressortir"
    ],
    "ressortaient": [
        "ressortir"
    ],
    "ressortais": [
        "ressortir"
    ],
    "ressortait": [
        "ressortir"
    ],
    "ressortant": [
        "ressortir"
    ],
    "ressorte": [
        "ressortir"
    ],
    "ressortent": [
        "ressortir"
    ],
    "ressortes": [
        "ressortir"
    ],
    "ressortez": [
        "ressortir"
    ],
    "ressorti": [
        "ressortir"
    ],
    "ressortie": [
        "ressortir"
    ],
    "ressorties": [
        "ressortir"
    ],
    "ressortions": [
        "ressortir"
    ],
    "ressortir": [
        "ressortir"
    ],
    "ressortira": [
        "ressortir"
    ],
    "ressortirai": [
        "ressortir"
    ],
    "ressortiraient": [
        "ressortir"
    ],
    "ressortirais": [
        "ressortir"
    ],
    "ressortirait": [
        "ressortir"
    ],
    "ressortiras": [
        "ressortir"
    ],
    "ressortirent": [
        "ressortir"
    ],
    "ressortirez": [
        "ressortir"
    ],
    "ressortiront": [
        "ressortir"
    ],
    "ressortis": [
        "ressortir"
    ],
    "ressortissant": [
        "ressortissant"
    ],
    "ressortissante": [
        "ressortissant"
    ],
    "ressortissants": [
        "ressortissant"
    ],
    "ressortit": [
        "ressortir"
    ],
    "ressortons": [
        "ressortir"
    ],
    "ressorts": [
        "ressort"
    ],
    "ressortimes": [
        "ressortir"
    ],
    "ressoudant": [
        "ressouder"
    ],
    "ressoude": [
        "ressouder"
    ],
    "ressouder": [
        "ressouder"
    ],
    "ressoudee": [
        "ressouder"
    ],
    "ressoudes": [
        "ressouder"
    ],
    "ressource": [
        "ressource",
        "ressourcer"
    ],
    "ressourcement": [
        "ressourcement"
    ],
    "ressourcer": [
        "ressourcer"
    ],
    "ressources": [
        "ressource"
    ],
    "ressourcais": [
        "ressourcer"
    ],
    "ressourcait": [
        "ressourcer"
    ],
    "ressouvenait": [
        "ressouvenir"
    ],
    "ressouvenant": [
        "ressouvenir"
    ],
    "ressouvenir": [
        "ressouvenir"
    ],
    "ressouvenue": [
        "ressouvenir"
    ],
    "ressouviens": [
        "ressouvenir"
    ],
    "ressouvint": [
        "ressouvenir"
    ],
    "ressui": [
        "ressui"
    ],
    "ressuiement": [
        "ressuiement"
    ],
    "ressurgi": [
        "ressurgir"
    ],
    "ressurgie": [
        "ressurgir"
    ],
    "ressurgir": [
        "ressurgir"
    ],
    "ressurgirait": [
        "ressurgir"
    ],
    "ressurgirent": [
        "ressurgir"
    ],
    "ressurgiront": [
        "ressurgir"
    ],
    "ressurgissait": [
        "ressurgir"
    ],
    "ressurgissant": [
        "ressurgir"
    ],
    "ressurgissent": [
        "ressurgir"
    ],
    "ressurgit": [
        "ressurgir"
    ],
    "ressuscita": [
        "ressusciter"
    ],
    "ressuscitai": [
        "ressusciter"
    ],
    "ressuscitaient": [
        "ressusciter"
    ],
    "ressuscitais": [
        "ressusciter"
    ],
    "ressuscitait": [
        "ressusciter"
    ],
    "ressuscitant": [
        "ressusciter"
    ],
    "ressuscite": [
        "ressusciter"
    ],
    "ressuscitent": [
        "ressusciter"
    ],
    "ressusciter": [
        "ressusciter"
    ],
    "ressuscitera": [
        "ressusciter"
    ],
    "ressusciterai": [
        "ressusciter"
    ],
    "ressusciteraient": [
        "ressusciter"
    ],
    "ressusciterait": [
        "ressusciter"
    ],
    "ressusciteras": [
        "ressusciter"
    ],
    "ressusciterez": [
        "ressusciter"
    ],
    "ressusciterons": [
        "ressusciter"
    ],
    "ressusciteront": [
        "ressusciter"
    ],
    "ressuscites": [
        "ressusciter"
    ],
    "ressuscitez": [
        "ressusciter"
    ],
    "ressuscitons": [
        "ressusciter"
    ],
    "ressuscitat": [
        "ressusciter"
    ],
    "ressuscitee": [
        "ressusciter"
    ],
    "ressuscitees": [
        "ressusciter"
    ],
    "ressuye": [
        "ressuyer"
    ],
    "ressuyee": [
        "ressuyer"
    ],
    "ressue": [
        "ressuer"
    ],
    "resta": [
        "rester"
    ],
    "restai": [
        "rester"
    ],
    "restaient": [
        "rester"
    ],
    "restais": [
        "rester"
    ],
    "restait": [
        "rester"
    ],
    "restant": [
        "restant",
        "rester"
    ],
    "restante": [
        "restant"
    ],
    "restantes": [
        "restant"
    ],
    "restants": [
        "restant"
    ],
    "restassent": [
        "rester"
    ],
    "restau": [
        "restau"
    ],
    "restaura": [
        "restaurer"
    ],
    "restaurait": [
        "restaurer"
    ],
    "restaurant": [
        "restaurer",
        "restaurant"
    ],
    "restaurants": [
        "restaurant"
    ],
    "restaurateur": [
        "restaurateur"
    ],
    "restaurateurs": [
        "restaurateur"
    ],
    "restauration": [
        "restauration"
    ],
    "restaurations": [
        "restauration"
    ],
    "restauratrice": [
        "restaurateur"
    ],
    "restaure": [
        "restaurer"
    ],
    "restaurent": [
        "restaurer"
    ],
    "restaurer": [
        "restaurer"
    ],
    "restaurera": [
        "restaurer"
    ],
    "restaurerai": [
        "restaurer"
    ],
    "restaureraient": [
        "restaurer"
    ],
    "restaurerait": [
        "restaurer"
    ],
    "restaurez": [
        "restaurer"
    ],
    "restaurons": [
        "restaurer"
    ],
    "restauroute": [
        "restauroute"
    ],
    "restauree": [
        "restaurer"
    ],
    "restaurees": [
        "restaurer"
    ],
    "restaures": [
        "restaurer"
    ],
    "restaus": [
        "restau"
    ],
    "reste": [
        "reste",
        "rester"
    ],
    "restent": [
        "rester",
        "ruer"
    ],
    "rester": [
        "rester"
    ],
    "restera": [
        "rester"
    ],
    "resterai": [
        "rester"
    ],
    "resteraient": [
        "rester"
    ],
    "resterais": [
        "rester"
    ],
    "resterait": [
        "rester"
    ],
    "resteras": [
        "rester"
    ],
    "resterez": [
        "rester"
    ],
    "resteriez": [
        "rester"
    ],
    "resterions": [
        "rester"
    ],
    "resterons": [
        "rester"
    ],
    "resteront": [
        "rester"
    ],
    "restes": [
        "reste",
        "rester"
    ],
    "restez": [
        "rester"
    ],
    "restiez": [
        "rester"
    ],
    "restions": [
        "rester"
    ],
    "restituaient": [
        "restituer"
    ],
    "restituait": [
        "restituer"
    ],
    "restituant": [
        "restituer"
    ],
    "restitue": [
        "restituer"
    ],
    "restituent": [
        "restituer"
    ],
    "restituer": [
        "restituer"
    ],
    "restituera": [
        "restituer"
    ],
    "restituerai": [
        "restituer"
    ],
    "restituerait": [
        "restituer"
    ],
    "restituerons": [
        "restituer"
    ],
    "restituez": [
        "restituer"
    ],
    "restituiez": [
        "restituer"
    ],
    "restitution": [
        "restitution"
    ],
    "restituee": [
        "restituer"
    ],
    "restituees": [
        "restituer"
    ],
    "restitues": [
        "restituer"
    ],
    "resto": [
        "resto"
    ],
    "restons": [
        "rester"
    ],
    "restoroute": [
        "restoroute"
    ],
    "restos": [
        "resto"
    ],
    "restreignait": [
        "restreindre"
    ],
    "restreignant": [
        "restreindre"
    ],
    "restreignent": [
        "restreindre"
    ],
    "restreignez": [
        "restreindre"
    ],
    "restreignit": [
        "restreindre"
    ],
    "restreindre": [
        "restreindre"
    ],
    "restreins": [
        "restreindre"
    ],
    "restreint": [
        "restreindre",
        "restreint"
    ],
    "restreinte": [
        "restreindre",
        "restreint"
    ],
    "restreintes": [
        "restreindre",
        "restreint"
    ],
    "restreints": [
        "restreindre",
        "restreint"
    ],
    "restrictif": [
        "restrictif"
    ],
    "restriction": [
        "restriction"
    ],
    "restrictions": [
        "restriction"
    ],
    "restrictive": [
        "restrictif"
    ],
    "restrictives": [
        "restrictif"
    ],
    "restructurant": [
        "restructurer"
    ],
    "restructuration": [
        "restructuration"
    ],
    "restructurations": [
        "restructuration"
    ],
    "restructurer": [
        "restructurer"
    ],
    "restructureront": [
        "restructurer"
    ],
    "restructurons": [
        "restructurer"
    ],
    "restructure": [
        "restructurer"
    ],
    "restructuree": [
        "restructurer"
    ],
    "restames": [
        "rester"
    ],
    "restat": [
        "rester"
    ],
    "resterent": [
        "rester"
    ],
    "restee": [
        "rester"
    ],
    "restees": [
        "rester"
    ],
    "resucee": [
        "resucee"
    ],
    "resurgi": [
        "resurgir"
    ],
    "resurgies": [
        "resurgir"
    ],
    "resurgir": [
        "resurgir"
    ],
    "resurgira": [
        "resurgir"
    ],
    "resurgirai": [
        "resurgir"
    ],
    "resurgirait": [
        "resurgir"
    ],
    "resurgirent": [
        "resurgir"
    ],
    "resurgiront": [
        "resurgir"
    ],
    "resurgis": [
        "resurgir"
    ],
    "resurgissaient": [
        "resurgir"
    ],
    "resurgissait": [
        "resurgir"
    ],
    "resurgissant": [
        "resurgir"
    ],
    "resurgisse": [
        "resurgir"
    ],
    "resurgissent": [
        "resurgir"
    ],
    "resurgit": [
        "resurgir"
    ],
    "retable": [
        "retable"
    ],
    "retables": [
        "retable"
    ],
    "retaillaient": [
        "retailler"
    ],
    "retaillait": [
        "retailler"
    ],
    "retaille": [
        "retailler"
    ],
    "retailler": [
        "retailler"
    ],
    "retaillee": [
        "retailler"
    ],
    "retaillees": [
        "retailler"
    ],
    "retailles": [
        "retailler"
    ],
    "retapa": [
        "retaper"
    ],
    "retapaient": [
        "retaper"
    ],
    "retapait": [
        "retaper"
    ],
    "retapant": [
        "retaper"
    ],
    "retape": [
        "retaper",
        "retape"
    ],
    "retapent": [
        "retaper"
    ],
    "retaper": [
        "retaper"
    ],
    "retaperait": [
        "retaper"
    ],
    "retapeur": [
        "retapeur"
    ],
    "retapez": [
        "retaper"
    ],
    "retapissant": [
        "retapisser"
    ],
    "retapisse": [
        "retapisser"
    ],
    "retapissent": [
        "retapisser"
    ],
    "retapisser": [
        "retapisser"
    ],
    "retapisserait": [
        "retapisser"
    ],
    "retapisses": [
        "retapisser"
    ],
    "retapissee": [
        "retapisser"
    ],
    "retapissees": [
        "retapisser"
    ],
    "retapee": [
        "retaper"
    ],
    "retapees": [
        "retaper"
    ],
    "retapes": [
        "retaper"
    ],
    "retard": [
        "retard"
    ],
    "retarda": [
        "retarder"
    ],
    "retardaient": [
        "retarder"
    ],
    "retardais": [
        "retarder"
    ],
    "retardait": [
        "retarder"
    ],
    "retardant": [
        "retarder"
    ],
    "retardataire": [
        "retardataire"
    ],
    "retardataires": [
        "retardataire"
    ],
    "retardateur": [
        "retardateur"
    ],
    "retarde": [
        "retarder",
        "retarde"
    ],
    "retardement": [
        "retardement"
    ],
    "retardent": [
        "retarder"
    ],
    "retarder": [
        "retarder"
    ],
    "retardera": [
        "retarder"
    ],
    "retarderai": [
        "retarder"
    ],
    "retarderaient": [
        "retarder"
    ],
    "retarderait": [
        "retarder"
    ],
    "retarderez": [
        "retarder"
    ],
    "retarderiez": [
        "retarder"
    ],
    "retardes": [
        "retarder",
        "retarde"
    ],
    "retardez": [
        "retarder"
    ],
    "retardions": [
        "retarder"
    ],
    "retardons": [
        "retarder"
    ],
    "retards": [
        "retard"
    ],
    "retardat": [
        "retarder"
    ],
    "retarderent": [
        "retarder"
    ],
    "retardee": [
        "retarder",
        "retarde"
    ],
    "retardees": [
        "retarder",
        "retarde"
    ],
    "reteindre": [
        "reteindre"
    ],
    "reteints": [
        "reteindre"
    ],
    "retenaient": [
        "retenir"
    ],
    "retenais": [
        "retenir"
    ],
    "retenait": [
        "retenir"
    ],
    "retenant": [
        "retenir"
    ],
    "retendait": [
        "retendre"
    ],
    "retendre": [
        "retendre"
    ],
    "retends": [
        "retendre"
    ],
    "retendu": [
        "retendre"
    ],
    "retendues": [
        "retendre"
    ],
    "retenez": [
        "retenir"
    ],
    "reteniez": [
        "retenir"
    ],
    "retenions": [
        "retenir"
    ],
    "retenir": [
        "retenir"
    ],
    "retenons": [
        "retenir"
    ],
    "retente": [
        "retenter"
    ],
    "retenter": [
        "retenter"
    ],
    "retentes": [
        "retenter"
    ],
    "retenti": [
        "retentir"
    ],
    "retentir": [
        "retentir"
    ],
    "retentira": [
        "retentir"
    ],
    "retentirait": [
        "retentir"
    ],
    "retentirent": [
        "retentir"
    ],
    "retentiront": [
        "retentir"
    ],
    "retentissaient": [
        "retentir"
    ],
    "retentissait": [
        "retentir"
    ],
    "retentissant": [
        "retentir",
        "retentissant"
    ],
    "retentissante": [
        "retentissant"
    ],
    "retentissantes": [
        "retentissant"
    ],
    "retentissants": [
        "retentissant"
    ],
    "retentisse": [
        "retentir"
    ],
    "retentissement": [
        "retentissement"
    ],
    "retentissent": [
        "retentir"
    ],
    "retentit": [
        "retentir"
    ],
    "retenu": [
        "retenir",
        "retenu"
    ],
    "retenue": [
        "retenir",
        "retenu",
        "retenue"
    ],
    "retenues": [
        "retenir",
        "retenu",
        "retenue"
    ],
    "retenus": [
        "retenir",
        "retenu"
    ],
    "retiendra": [
        "retenir"
    ],
    "retiendrai": [
        "retenir"
    ],
    "retiendraient": [
        "retenir"
    ],
    "retiendrais": [
        "retenir"
    ],
    "retiendrait": [
        "retenir"
    ],
    "retiendras": [
        "retenir"
    ],
    "retiendrez": [
        "retenir"
    ],
    "retiendrions": [
        "retenir"
    ],
    "retiendrons": [
        "retenir"
    ],
    "retiendront": [
        "retenir"
    ],
    "retienne": [
        "retenir"
    ],
    "retiennent": [
        "retenir"
    ],
    "retiennes": [
        "retenir"
    ],
    "retiens": [
        "retenir"
    ],
    "retient": [
        "retenir"
    ],
    "retinrent": [
        "retenir"
    ],
    "retins": [
        "retenir"
    ],
    "retint": [
        "retenir"
    ],
    "retira": [
        "retirer"
    ],
    "retirable": [
        "retirable"
    ],
    "retirai": [
        "retirer"
    ],
    "retiraient": [
        "retirer"
    ],
    "retirais": [
        "retirer"
    ],
    "retirait": [
        "retirer"
    ],
    "retirant": [
        "retirer"
    ],
    "retire": [
        "retire",
        "retirer"
    ],
    "retirement": [
        "retirement"
    ],
    "retirent": [
        "retirer"
    ],
    "retirer": [
        "retirer"
    ],
    "retirera": [
        "retirer"
    ],
    "retirerai": [
        "retirer"
    ],
    "retireraient": [
        "retirer"
    ],
    "retirerais": [
        "retirer"
    ],
    "retirerait": [
        "retirer"
    ],
    "retireras": [
        "retirer"
    ],
    "retirerez": [
        "retirer"
    ],
    "retireriez": [
        "retirer"
    ],
    "retirerions": [
        "retirer"
    ],
    "retirerons": [
        "retirer"
    ],
    "retireront": [
        "retirer"
    ],
    "retires": [
        "retire",
        "retirer"
    ],
    "retirez": [
        "retirer"
    ],
    "retiriez": [
        "retirer"
    ],
    "retirions": [
        "retirer"
    ],
    "retiro": [
        "retiro"
    ],
    "retirons": [
        "retirer"
    ],
    "retirames": [
        "retirer"
    ],
    "retirat": [
        "retirer"
    ],
    "retirerent": [
        "retirer"
    ],
    "retiree": [
        "retire",
        "retirer"
    ],
    "retirees": [
        "retire",
        "retirer"
    ],
    "retissaient": [
        "retisser"
    ],
    "retissait": [
        "retisser"
    ],
    "retisser": [
        "retisser"
    ],
    "retomba": [
        "retomber"
    ],
    "retombai": [
        "retomber"
    ],
    "retombaient": [
        "retomber"
    ],
    "retombais": [
        "retomber"
    ],
    "retombait": [
        "retomber"
    ],
    "retombant": [
        "retombant",
        "retomber"
    ],
    "retombante": [
        "retombant"
    ],
    "retombantes": [
        "retombant"
    ],
    "retombe": [
        "retombe",
        "retomber"
    ],
    "retombement": [
        "retombement"
    ],
    "retombent": [
        "retomber"
    ],
    "retomber": [
        "retomber"
    ],
    "retombera": [
        "retomber"
    ],
    "retomberai": [
        "retomber"
    ],
    "retomberaient": [
        "retomber"
    ],
    "retomberais": [
        "retomber"
    ],
    "retomberait": [
        "retomber"
    ],
    "retomberas": [
        "retomber"
    ],
    "retomberez": [
        "retomber"
    ],
    "retomberont": [
        "retomber"
    ],
    "retombes": [
        "retomber"
    ],
    "retombez": [
        "retomber"
    ],
    "retombions": [
        "retomber"
    ],
    "retombons": [
        "retomber"
    ],
    "retombames": [
        "retomber"
    ],
    "retombat": [
        "retomber"
    ],
    "retomberent": [
        "retomber"
    ],
    "retombee": [
        "retombee",
        "retomber"
    ],
    "retombees": [
        "retombee",
        "retomber"
    ],
    "retordre": [
        "retordre"
    ],
    "retors": [
        "retors"
    ],
    "retorse": [
        "retors"
    ],
    "retorses": [
        "retors"
    ],
    "retoucha": [
        "retoucher"
    ],
    "retouchai": [
        "retoucher"
    ],
    "retouchait": [
        "retoucher"
    ],
    "retouchant": [
        "retoucher"
    ],
    "retouche": [
        "retouche",
        "retoucher"
    ],
    "retouchent": [
        "retoucher"
    ],
    "retoucher": [
        "retoucher"
    ],
    "retouchera": [
        "retoucher"
    ],
    "retoucherais": [
        "retoucher"
    ],
    "retoucherait": [
        "retoucher"
    ],
    "retouches": [
        "retouche",
        "retoucher"
    ],
    "retoucheur": [
        "retoucheur"
    ],
    "retouchez": [
        "retoucher"
    ],
    "retouchee": [
        "retoucher"
    ],
    "retouchees": [
        "retoucher"
    ],
    "retour": [
        "retour"
    ],
    "retourna": [
        "retourner"
    ],
    "retournai": [
        "retourner"
    ],
    "retournaient": [
        "retourner"
    ],
    "retournais": [
        "retourner"
    ],
    "retournait": [
        "retourner"
    ],
    "retournant": [
        "retourner"
    ],
    "retourne": [
        "retourner",
        "retourne"
    ],
    "retournement": [
        "retournement"
    ],
    "retournements": [
        "retournement"
    ],
    "retournent": [
        "retourner"
    ],
    "retourner": [
        "retourner"
    ],
    "retournera": [
        "retourner"
    ],
    "retournerai": [
        "retourner"
    ],
    "retourneraient": [
        "retourner"
    ],
    "retournerais": [
        "retourner"
    ],
    "retournerait": [
        "retourner"
    ],
    "retourneras": [
        "retourner"
    ],
    "retournerez": [
        "retourner"
    ],
    "retourneriez": [
        "retourner"
    ],
    "retournerions": [
        "retourner"
    ],
    "retournerons": [
        "retourner"
    ],
    "retourneront": [
        "retourner"
    ],
    "retournes": [
        "retourner",
        "retourne"
    ],
    "retournez": [
        "retourner"
    ],
    "retourniez": [
        "retourner"
    ],
    "retournions": [
        "retourner"
    ],
    "retournons": [
        "retourner"
    ],
    "retournames": [
        "retourner"
    ],
    "retournat": [
        "retourner"
    ],
    "retournerent": [
        "retourner"
    ],
    "retournee": [
        "retourner"
    ],
    "retournees": [
        "retourner"
    ],
    "retours": [
        "retour"
    ],
    "retrace": [
        "retracer"
    ],
    "retracent": [
        "retracer"
    ],
    "retracer": [
        "retracer"
    ],
    "retracera": [
        "retracer"
    ],
    "retracerais": [
        "retracer"
    ],
    "retracerait": [
        "retracer"
    ],
    "retraceront": [
        "retracer"
    ],
    "retracez": [
        "retracer"
    ],
    "retracions": [
        "retracer"
    ],
    "retracee": [
        "retracer"
    ],
    "retraduction": [
        "retraduction"
    ],
    "retraduit": [
        "retraduire"
    ],
    "retraire": [
        "retraire"
    ],
    "retrait": [
        "retraire",
        "retrait"
    ],
    "retraitait": [
        "retraiter"
    ],
    "retraite": [
        "retraite",
        "retraiter"
    ],
    "retraitement": [
        "retraitement"
    ],
    "retraites": [
        "retraite",
        "retraiter"
    ],
    "retraitions": [
        "retraiter"
    ],
    "retraits": [
        "retraire",
        "retrait"
    ],
    "retraitee": [
        "retraite",
        "retraiter"
    ],
    "retraitees": [
        "retraite",
        "retraiter"
    ],
    "retranchai": [
        "retrancher"
    ],
    "retranchaient": [
        "retrancher"
    ],
    "retranchait": [
        "retrancher"
    ],
    "retranchant": [
        "retrancher"
    ],
    "retranche": [
        "retrancher"
    ],
    "retranchement": [
        "retranchement"
    ],
    "retranchements": [
        "retranchement"
    ],
    "retranchent": [
        "retrancher"
    ],
    "retrancher": [
        "retrancher"
    ],
    "retranchera": [
        "retrancher"
    ],
    "retranchez": [
        "retrancher"
    ],
    "retranchions": [
        "retrancher"
    ],
    "retranchee": [
        "retrancher"
    ],
    "retranchees": [
        "retrancher"
    ],
    "retranches": [
        "retrancher"
    ],
    "retranscription": [
        "retranscription"
    ],
    "retranscrire": [
        "retranscrire"
    ],
    "retranscris": [
        "retranscrire"
    ],
    "retranscrit": [
        "retranscrire"
    ],
    "retranscrits": [
        "retranscrire"
    ],
    "retransforme": [
        "retransformer"
    ],
    "retransformer": [
        "retransformer"
    ],
    "retransformera": [
        "retransformer"
    ],
    "retransferer": [
        "retransferer"
    ],
    "retransmet": [
        "retransmettre"
    ],
    "retransmettait": [
        "retransmettre"
    ],
    "retransmettant": [
        "retransmettre"
    ],
    "retransmettez": [
        "retransmettre"
    ],
    "retransmettra": [
        "retransmettre"
    ],
    "retransmettre": [
        "retransmettre"
    ],
    "retransmettrons": [
        "retransmettre"
    ],
    "retransmis": [
        "retransmettre"
    ],
    "retransmise": [
        "retransmettre"
    ],
    "retransmission": [
        "retransmission"
    ],
    "retransmissions": [
        "retransmission"
    ],
    "retransmit": [
        "retransmettre"
    ],
    "retravaillait": [
        "retravailler"
    ],
    "retravaille": [
        "retravailler"
    ],
    "retravaillent": [
        "retravailler"
    ],
    "retravailler": [
        "retravailler"
    ],
    "retravaillera": [
        "retravailler"
    ],
    "retravaillerai": [
        "retravailler"
    ],
    "retravaillerait": [
        "retravailler"
    ],
    "retravaillerez": [
        "retravailler"
    ],
    "retravailles": [
        "retravailler"
    ],
    "retravaillez": [
        "retravailler"
    ],
    "retravaillee": [
        "retravailler"
    ],
    "retraversa": [
        "retraverser"
    ],
    "retraversai": [
        "retraverser"
    ],
    "retraversaient": [
        "retraverser"
    ],
    "retraversais": [
        "retraverser"
    ],
    "retraversait": [
        "retraverser"
    ],
    "retraversant": [
        "retraverser"
    ],
    "retraverse": [
        "retraverser"
    ],
    "retraversent": [
        "retraverser"
    ],
    "retraverser": [
        "retraverser"
    ],
    "retraverserait": [
        "retraverser"
    ],
    "retraversions": [
        "retraverser"
    ],
    "retraversons": [
        "retraverser"
    ],
    "retraversee": [
        "retraverser"
    ],
    "retracaient": [
        "retracer"
    ],
    "retracais": [
        "retracer"
    ],
    "retracait": [
        "retracer"
    ],
    "retracant": [
        "retracer"
    ],
    "retreinte": [
        "retreinte"
    ],
    "retrempai": [
        "retremper"
    ],
    "retrempaient": [
        "retremper"
    ],
    "retrempait": [
        "retremper"
    ],
    "retremper": [
        "retremper"
    ],
    "retrempe": [
        "retremper"
    ],
    "retriever": [
        "retriever"
    ],
    "retroussa": [
        "retrousser"
    ],
    "retroussage": [
        "retroussage"
    ],
    "retroussaient": [
        "retrousser"
    ],
    "retroussais": [
        "retrousser"
    ],
    "retroussait": [
        "retrousser"
    ],
    "retroussant": [
        "retrousser"
    ],
    "retrousse": [
        "retrousser",
        "retrousse"
    ],
    "retroussent": [
        "retrousser"
    ],
    "retrousser": [
        "retrousser"
    ],
    "retroussette": [
        "retroussette"
    ],
    "retroussez": [
        "retrousser"
    ],
    "retroussis": [
        "retroussis"
    ],
    "retroussee": [
        "retrousser",
        "retrousse"
    ],
    "retroussees": [
        "retrousser",
        "retrousse"
    ],
    "retrousses": [
        "retrousser",
        "retrousse"
    ],
    "retrouva": [
        "retrouver"
    ],
    "retrouvai": [
        "retrouver"
    ],
    "retrouvaient": [
        "retrouver"
    ],
    "retrouvaille": [
        "retrouvaille"
    ],
    "retrouvailles": [
        "retrouvaille"
    ],
    "retrouvais": [
        "retrouver"
    ],
    "retrouvait": [
        "retrouver"
    ],
    "retrouvant": [
        "retrouver"
    ],
    "retrouvas": [
        "retrouver"
    ],
    "retrouve": [
        "retrouver"
    ],
    "retrouvent": [
        "retrouver"
    ],
    "retrouver": [
        "retrouver"
    ],
    "retrouvera": [
        "retrouver"
    ],
    "retrouverai": [
        "retrouver"
    ],
    "retrouveraient": [
        "retrouver"
    ],
    "retrouverais": [
        "retrouver"
    ],
    "retrouverait": [
        "retrouver"
    ],
    "retrouveras": [
        "retrouver"
    ],
    "retrouverez": [
        "retrouver"
    ],
    "retrouveriez": [
        "retrouver"
    ],
    "retrouverions": [
        "retrouver"
    ],
    "retrouverons": [
        "retrouver"
    ],
    "retrouveront": [
        "retrouver"
    ],
    "retrouves": [
        "retrouver"
    ],
    "retrouvez": [
        "retrouver"
    ],
    "retrouviez": [
        "retrouver"
    ],
    "retrouvions": [
        "retrouver"
    ],
    "retrouvons": [
        "retrouver"
    ],
    "retrouvames": [
        "retrouver"
    ],
    "retrouvat": [
        "retrouver"
    ],
    "retrouverent": [
        "retrouver"
    ],
    "retrouvee": [
        "retrouver"
    ],
    "retrouvees": [
        "retrouver"
    ],
    "rets": [
        "rets"
    ],
    "retsina": [
        "retsina"
    ],
    "retuber": [
        "retuber"
    ],
    "retuer": [
        "retuer"
    ],
    "retate": [
        "retater"
    ],
    "retelephone": [
        "retelephoner"
    ],
    "retelephoner": [
        "retelephoner"
    ],
    "retinmes": [
        "retenir"
    ],
    "reubeu": [
        "reubeu"
    ],
    "reubeus": [
        "reubeu"
    ],
    "revalidation": [
        "revalidation"
    ],
    "revalider": [
        "revalider"
    ],
    "revaloir": [
        "revaloir"
    ],
    "revalorisait": [
        "revaloriser"
    ],
    "revalorisation": [
        "revalorisation"
    ],
    "revalorisent": [
        "revaloriser"
    ],
    "revaloriser": [
        "revaloriser"
    ],
    "revalorise": [
        "revaloriser"
    ],
    "revancha": [
        "revancher"
    ],
    "revanchaient": [
        "revancher"
    ],
    "revanchard": [
        "revanchard"
    ],
    "revancharde": [
        "revanchard"
    ],
    "revanchardes": [
        "revanchard"
    ],
    "revanchards": [
        "revanchard"
    ],
    "revanche": [
        "revanche"
    ],
    "revanchent": [
        "revancher"
    ],
    "revancher": [
        "revancher"
    ],
    "revanches": [
        "revanche"
    ],
    "revaudra": [
        "revaloir"
    ],
    "revaudrai": [
        "revaloir"
    ],
    "revaudraient": [
        "revaloir"
    ],
    "revaudrais": [
        "revaloir"
    ],
    "revaudrait": [
        "revaloir"
    ],
    "revaudras": [
        "revaloir"
    ],
    "revenaient": [
        "revenir"
    ],
    "revenais": [
        "revenir"
    ],
    "revenait": [
        "revenir"
    ],
    "revenant": [
        "revenant",
        "revenir"
    ],
    "revenante": [
        "revenant"
    ],
    "revenants": [
        "revenant"
    ],
    "revend": [
        "revendre"
    ],
    "revendable": [
        "revendable"
    ],
    "revendaient": [
        "revendre"
    ],
    "revendais": [
        "revendre"
    ],
    "revendait": [
        "revendre"
    ],
    "revendant": [
        "revendre"
    ],
    "revendent": [
        "revendre"
    ],
    "revendes": [
        "revendre"
    ],
    "revendeur": [
        "revendeur"
    ],
    "revendeurs": [
        "revendeur"
    ],
    "revendeuse": [
        "revendeur"
    ],
    "revendez": [
        "revendre"
    ],
    "revendicateur": [
        "revendicateur"
    ],
    "revendicateurs": [
        "revendicateur"
    ],
    "revendicatif": [
        "revendicatif"
    ],
    "revendicatifs": [
        "revendicatif"
    ],
    "revendication": [
        "revendication"
    ],
    "revendications": [
        "revendication"
    ],
    "revendicative": [
        "revendicatif"
    ],
    "revendicatives": [
        "revendicatif"
    ],
    "revendicatrice": [
        "revendicateur"
    ],
    "revendicatrices": [
        "revendicateur"
    ],
    "revendiqua": [
        "revendiquer"
    ],
    "revendiquai": [
        "revendiquer"
    ],
    "revendiquaient": [
        "revendiquer"
    ],
    "revendiquais": [
        "revendiquer"
    ],
    "revendiquait": [
        "revendiquer"
    ],
    "revendiquant": [
        "revendiquer"
    ],
    "revendique": [
        "revendiquer"
    ],
    "revendiquent": [
        "revendiquer"
    ],
    "revendiquer": [
        "revendiquer"
    ],
    "revendiquera": [
        "revendiquer"
    ],
    "revendiquerais": [
        "revendiquer"
    ],
    "revendiquerait": [
        "revendiquer"
    ],
    "revendiquez": [
        "revendiquer"
    ],
    "revendiquons": [
        "revendiquer"
    ],
    "revendiquat": [
        "revendiquer"
    ],
    "revendiquee": [
        "revendiquer"
    ],
    "revendis": [
        "revendre"
    ],
    "revendit": [
        "revendre"
    ],
    "revendra": [
        "revendre"
    ],
    "revendrai": [
        "revendre"
    ],
    "revendraient": [
        "revendre"
    ],
    "revendrais": [
        "revendre"
    ],
    "revendrait": [
        "revendre"
    ],
    "revendre": [
        "revendre"
    ],
    "revendrons": [
        "revendre"
    ],
    "revendront": [
        "revendre"
    ],
    "revends": [
        "revendre"
    ],
    "revendu": [
        "revendre"
    ],
    "revendue": [
        "revendre"
    ],
    "revendues": [
        "revendre"
    ],
    "revendus": [
        "revendre"
    ],
    "revenez": [
        "revenir"
    ],
    "reveniez": [
        "revenir"
    ],
    "revenions": [
        "revenir"
    ],
    "revenir": [
        "revenir"
    ],
    "revenons": [
        "revenir"
    ],
    "revente": [
        "revente"
    ],
    "reventes": [
        "revente"
    ],
    "revenu": [
        "revenu",
        "revenir"
    ],
    "revenue": [
        "revenu",
        "revenir"
    ],
    "revenues": [
        "revenu",
        "revenue",
        "revenir"
    ],
    "revenus": [
        "revenu",
        "revenir"
    ],
    "reverdi": [
        "reverdir"
    ],
    "reverdie": [
        "reverdir"
    ],
    "reverdies": [
        "reverdir"
    ],
    "reverdir": [
        "reverdir"
    ],
    "reverdiront": [
        "reverdir"
    ],
    "reverdissaient": [
        "reverdir"
    ],
    "reverdit": [
        "reverdir"
    ],
    "reverni": [
        "revernir"
    ],
    "revernie": [
        "revernir"
    ],
    "revernir": [
        "revernir"
    ],
    "reverra": [
        "revoir"
    ],
    "reverrai": [
        "revoir"
    ],
    "reverraient": [
        "revoir"
    ],
    "reverrais": [
        "revoir"
    ],
    "reverrait": [
        "revoir"
    ],
    "reverras": [
        "revoir"
    ],
    "reverrez": [
        "revoir"
    ],
    "reverrions": [
        "revoir"
    ],
    "reverrons": [
        "revoir"
    ],
    "reverront": [
        "revoir"
    ],
    "revers": [
        "revers",
        "rever"
    ],
    "reversa": [
        "reverser"
    ],
    "reversaient": [
        "reverser"
    ],
    "reversait": [
        "reverser"
    ],
    "reversant": [
        "reverser"
    ],
    "reverse": [
        "reverser"
    ],
    "reverser": [
        "reverser"
    ],
    "reverserait": [
        "reverser"
    ],
    "reversez": [
        "reverser"
    ],
    "reveuille": [
        "revouloir"
    ],
    "reveulent": [
        "revouloir"
    ],
    "reveux": [
        "revouloir"
    ],
    "revida": [
        "revider"
    ],
    "reviderent": [
        "revider"
    ],
    "reviendra": [
        "revenir"
    ],
    "reviendrai": [
        "revenir"
    ],
    "reviendraient": [
        "revenir"
    ],
    "reviendrais": [
        "revenir"
    ],
    "reviendrait": [
        "revenir"
    ],
    "reviendras": [
        "revenir"
    ],
    "reviendrez": [
        "revenir"
    ],
    "reviendriez": [
        "revenir"
    ],
    "reviendrions": [
        "revenir"
    ],
    "reviendrons": [
        "revenir"
    ],
    "reviendront": [
        "revenir"
    ],
    "revienne": [
        "revenir"
    ],
    "reviennent": [
        "revenir"
    ],
    "reviennes": [
        "revenir"
    ],
    "reviens": [
        "revenir"
    ],
    "revient": [
        "revient",
        "revenir"
    ],
    "revigoraient": [
        "revigorer"
    ],
    "revigorant": [
        "revigorer",
        "revigorant"
    ],
    "revigorante": [
        "revigorant"
    ],
    "revigorantes": [
        "revigorant"
    ],
    "revigore": [
        "revigorer"
    ],
    "revigorent": [
        "revigorer"
    ],
    "revigorer": [
        "revigorer"
    ],
    "revigoree": [
        "revigorer"
    ],
    "revigorees": [
        "revigorer"
    ],
    "revinrent": [
        "revenir"
    ],
    "revins": [
        "revenir"
    ],
    "revinssent": [
        "revenir"
    ],
    "revint": [
        "revenir"
    ],
    "revirement": [
        "revirement"
    ],
    "revirements": [
        "revirement"
    ],
    "revirent": [
        "revirer",
        "revoir"
    ],
    "revirer": [
        "revirer"
    ],
    "revis": [
        "revivre"
    ],
    "revisita": [
        "revisiter"
    ],
    "revisite": [
        "revisiter"
    ],
    "revisitent": [
        "revisiter"
    ],
    "revisiter": [
        "revisiter"
    ],
    "revisitee": [
        "revisiter"
    ],
    "revissa": [
        "revisser"
    ],
    "revisse": [
        "revisser"
    ],
    "revisser": [
        "revisser"
    ],
    "revissees": [
        "revisser"
    ],
    "revit": [
        "revivre",
        "revoir"
    ],
    "revitalisant": [
        "revitalisant"
    ],
    "revitalisation": [
        "revitalisation"
    ],
    "revitalise": [
        "revitaliser"
    ],
    "revitaliser": [
        "revitaliser"
    ],
    "revitalisera": [
        "revitaliser"
    ],
    "revivaient": [
        "revivre"
    ],
    "revivais": [
        "revivre"
    ],
    "revivait": [
        "revivre"
    ],
    "revival": [
        "revival"
    ],
    "revivant": [
        "revivre"
    ],
    "revive": [
        "revivre"
    ],
    "revivent": [
        "revivre"
    ],
    "revivez": [
        "revivre"
    ],
    "revivifiant": [
        "revivifier"
    ],
    "revivifie": [
        "revivifier",
        "revivifie"
    ],
    "revivifier": [
        "revivifier"
    ],
    "revivifiee": [
        "revivifier"
    ],
    "revivifiees": [
        "revivifier"
    ],
    "revivions": [
        "revivre"
    ],
    "reviviscence": [
        "reviviscence"
    ],
    "revivons": [
        "revivre"
    ],
    "revivra": [
        "revivre"
    ],
    "revivrai": [
        "revivre"
    ],
    "revivraient": [
        "revivre"
    ],
    "revivrais": [
        "revivre"
    ],
    "revivrait": [
        "revivre"
    ],
    "revivras": [
        "revivre"
    ],
    "revivre": [
        "revivre"
    ],
    "revivrez": [
        "revivre"
    ],
    "revivrons": [
        "revivre"
    ],
    "revoici": [
        "revoici"
    ],
    "revoie": [
        "revoir"
    ],
    "revoient": [
        "revoir"
    ],
    "revoies": [
        "revoir"
    ],
    "revoila": [
        "revoila"
    ],
    "revoir": [
        "revoir"
    ],
    "revois": [
        "revoir"
    ],
    "revoit": [
        "revoir"
    ],
    "revolait": [
        "revoler"
    ],
    "revole": [
        "revoler"
    ],
    "revolent": [
        "revoler"
    ],
    "revoler": [
        "revoler"
    ],
    "revolera": [
        "revoler"
    ],
    "revolver": [
        "revolver"
    ],
    "revolvers": [
        "revolver"
    ],
    "revomir": [
        "revomir"
    ],
    "revomissant": [
        "revomir"
    ],
    "revoter": [
        "revoter"
    ],
    "revoulait": [
        "revouloir"
    ],
    "revoulez": [
        "revouloir"
    ],
    "revouloir": [
        "revouloir"
    ],
    "revoyaient": [
        "revoir"
    ],
    "revoyais": [
        "revoir"
    ],
    "revoyait": [
        "revoir"
    ],
    "revoyant": [
        "revoir"
    ],
    "revoyez": [
        "revoir"
    ],
    "revoyiez": [
        "revoir"
    ],
    "revoyions": [
        "revoir"
    ],
    "revoyons": [
        "revoir"
    ],
    "revoyure": [
        "revoyure"
    ],
    "revu": [
        "revu",
        "revoir"
    ],
    "revue": [
        "revu",
        "revoir",
        "revue"
    ],
    "revues": [
        "revu",
        "revoir",
        "revue"
    ],
    "revuistes": [
        "revuiste"
    ],
    "revus": [
        "revu",
        "revoir"
    ],
    "revecu": [
        "revivre"
    ],
    "revecue": [
        "revivre"
    ],
    "revecues": [
        "revecu"
    ],
    "revecurent": [
        "revivre"
    ],
    "revecut": [
        "revivre"
    ],
    "reverifier": [
        "reverifier"
    ],
    "reverifie": [
        "reverifie"
    ],
    "reveche": [
        "reveche"
    ],
    "reveches": [
        "reveche"
    ],
    "revet": [
        "revetir"
    ],
    "revetaient": [
        "revetir"
    ],
    "revetais": [
        "revetir"
    ],
    "revetait": [
        "revetir"
    ],
    "revetant": [
        "revetir"
    ],
    "revetement": [
        "revetement"
    ],
    "revetements": [
        "revetement"
    ],
    "revetent": [
        "revetir"
    ],
    "revetez": [
        "revetir"
    ],
    "revetir": [
        "revetir"
    ],
    "revetira": [
        "revetir"
    ],
    "revetirait": [
        "revetir"
    ],
    "revetirent": [
        "revetir"
    ],
    "revetiront": [
        "revetir"
    ],
    "revetis": [
        "revetir"
    ],
    "revetit": [
        "revetir"
    ],
    "revets": [
        "revetir"
    ],
    "revetu": [
        "revetir",
        "revetu"
    ],
    "revetue": [
        "revetir",
        "revetu"
    ],
    "revetues": [
        "revetir",
        "revetu"
    ],
    "revetus": [
        "revetir",
        "revetu"
    ],
    "revimes": [
        "revoir"
    ],
    "rewrite": [
        "rewriter"
    ],
    "rex": [
        "rex"
    ],
    "rexiste": [
        "rexiste"
    ],
    "rexistes": [
        "rexiste"
    ],
    "rez": [
        "rez"
    ],
    "rezzou": [
        "rezzou"
    ],
    "rezzous": [
        "rezzou"
    ],
    "recois": [
        "recevoir"
    ],
    "recoit": [
        "recevoir"
    ],
    "recoive": [
        "recevoir"
    ],
    "recoivent": [
        "recevoir"
    ],
    "recoives": [
        "recevoir"
    ],
    "recu": [
        "recu",
        "recevoir"
    ],
    "recue": [
        "recu",
        "recevoir"
    ],
    "recues": [
        "recu",
        "recevoir"
    ],
    "recurent": [
        "recurer",
        "recevoir"
    ],
    "recus": [
        "recu",
        "recevoir"
    ],
    "recut": [
        "recevoir"
    ],
    "recumes": [
        "recevoir"
    ],
    "reitre": [
        "reitre"
    ],
    "reitres": [
        "reitre"
    ],
    "rhabilla": [
        "rhabiller"
    ],
    "rhabillage": [
        "rhabillage"
    ],
    "rhabillaient": [
        "rhabiller"
    ],
    "rhabillais": [
        "rhabiller"
    ],
    "rhabillait": [
        "rhabiller"
    ],
    "rhabillant": [
        "rhabiller"
    ],
    "rhabille": [
        "rhabiller"
    ],
    "rhabillent": [
        "rhabiller"
    ],
    "rhabiller": [
        "rhabiller"
    ],
    "rhabilles": [
        "rhabiller"
    ],
    "rhabilleur": [
        "rhabilleur"
    ],
    "rhabillez": [
        "rhabiller"
    ],
    "rhabilliez": [
        "rhabiller"
    ],
    "rhabillons": [
        "rhabiller"
    ],
    "rhabillerent": [
        "rhabiller"
    ],
    "rhabillee": [
        "rhabiller"
    ],
    "rhabillees": [
        "rhabiller"
    ],
    "rhapsodie": [
        "rhapsodie"
    ],
    "rhapsodies": [
        "rhapsodie"
    ],
    "rhingraves": [
        "rhingrave"
    ],
    "rhinite": [
        "rhinite"
    ],
    "rhinites": [
        "rhinite"
    ],
    "rhino": [
        "rhino"
    ],
    "rhinoceros": [
        "rhinoceros"
    ],
    "rhinoplastie": [
        "rhinoplastie"
    ],
    "rhinos": [
        "rhino"
    ],
    "rhinoscopie": [
        "rhinoscopie"
    ],
    "rhizome": [
        "rhizome"
    ],
    "rhizopus": [
        "rhizopus"
    ],
    "rho": [
        "rho"
    ],
    "rhodamine": [
        "rhodamine"
    ],
    "rhodanien": [
        "rhodanien"
    ],
    "rhodia": [
        "rhodia"
    ],
    "rhodium": [
        "rhodium"
    ],
    "rhodo": [
        "rhodo"
    ],
    "rhododendron": [
        "rhododendron"
    ],
    "rhododendrons": [
        "rhododendron"
    ],
    "rhodoid": [
        "rhodoid"
    ],
    "rhombe": [
        "rhombe"
    ],
    "rhomboidal": [
        "rhomboidal"
    ],
    "rhomboides": [
        "rhomboide"
    ],
    "rhovyl": [
        "rhovyl"
    ],
    "rhubarbe": [
        "rhubarbe"
    ],
    "rhubarbes": [
        "rhubarbe"
    ],
    "rhum": [
        "rhum"
    ],
    "rhumatisant": [
        "rhumatisant"
    ],
    "rhumatisante": [
        "rhumatisant"
    ],
    "rhumatisants": [
        "rhumatisant"
    ],
    "rhumatismal": [
        "rhumatismal"
    ],
    "rhumatismale": [
        "rhumatismal"
    ],
    "rhumatismales": [
        "rhumatismal"
    ],
    "rhumatisme": [
        "rhumatisme"
    ],
    "rhumatismes": [
        "rhumatisme"
    ],
    "rhumatologie": [
        "rhumatologie"
    ],
    "rhumatologue": [
        "rhumatologue"
    ],
    "rhumatoide": [
        "rhumatoide"
    ],
    "rhumbs": [
        "rhumb"
    ],
    "rhume": [
        "rhume"
    ],
    "rhumerie": [
        "rhumerie"
    ],
    "rhumes": [
        "rhume"
    ],
    "rhynchites": [
        "rhynchite"
    ],
    "rhyolite": [
        "rhyolite"
    ],
    "rhythm'n'blues": [
        "rhythm'n'blues"
    ],
    "rhenan": [
        "rhenan"
    ],
    "rhenane": [
        "rhenan"
    ],
    "rhenans": [
        "rhenan"
    ],
    "rheostat": [
        "rheostat"
    ],
    "rhesus": [
        "rhesus"
    ],
    "rheteur": [
        "rheteur"
    ],
    "rheteurs": [
        "rheteur"
    ],
    "rhetoricien": [
        "rhetoricien"
    ],
    "rhetorique": [
        "rhetorique"
    ],
    "rhetoriques": [
        "rhetorique"
    ],
    "ri": [
        "ri",
        "rire"
    ],
    "ria": [
        "ria"
    ],
    "riaient": [
        "rire"
    ],
    "riais": [
        "rire"
    ],
    "riait": [
        "rire"
    ],
    "rial": [
        "rial"
    ],
    "rials": [
        "rial"
    ],
    "riant": [
        "riant",
        "rire"
    ],
    "riante": [
        "riant"
    ],
    "riantes": [
        "riant"
    ],
    "riants": [
        "riant"
    ],
    "ribambelle": [
        "ribambelle"
    ],
    "ribambelles": [
        "ribambelle"
    ],
    "ribaud": [
        "ribaud"
    ],
    "ribaude": [
        "ribaud"
    ],
    "ribaudes": [
        "ribaud"
    ],
    "ribauds": [
        "ribaud"
    ],
    "ribes": [
        "ribes"
    ],
    "rible": [
        "ribler"
    ],
    "ribleur": [
        "ribleur"
    ],
    "riboflavine": [
        "riboflavine"
    ],
    "ribosomes": [
        "ribosome"
    ],
    "ribot": [
        "ribot"
    ],
    "ribote": [
        "ribot"
    ],
    "riboter": [
        "riboter"
    ],
    "riboteur": [
        "riboteur"
    ],
    "ribouis": [
        "ribouis"
    ],
    "riboulait": [
        "ribouler"
    ],
    "riboulant": [
        "ribouler"
    ],
    "riboulants": [
        "riboulant"
    ],
    "ribouldingue": [
        "ribouldingue"
    ],
    "ribouler": [
        "ribouler"
    ],
    "ricain": [
        "ricain"
    ],
    "ricaine": [
        "ricain"
    ],
    "ricaines": [
        "ricain"
    ],
    "ricains": [
        "ricain"
    ],
    "ricana": [
        "ricaner"
    ],
    "ricanai": [
        "ricaner"
    ],
    "ricanaient": [
        "ricaner"
    ],
    "ricanais": [
        "ricaner"
    ],
    "ricanait": [
        "ricaner"
    ],
    "ricanant": [
        "ricaner",
        "ricanant"
    ],
    "ricanante": [
        "ricanant"
    ],
    "ricanantes": [
        "ricanant"
    ],
    "ricanants": [
        "ricanant"
    ],
    "ricane": [
        "ricaner"
    ],
    "ricanement": [
        "ricanement"
    ],
    "ricanements": [
        "ricanement"
    ],
    "ricanent": [
        "ricaner"
    ],
    "ricaner": [
        "ricaner"
    ],
    "ricaneraient": [
        "ricaner"
    ],
    "ricaneront": [
        "ricaner"
    ],
    "ricanes": [
        "ricaner"
    ],
    "ricaneur": [
        "ricaneur"
    ],
    "ricaneurs": [
        "ricaneur"
    ],
    "ricaneuse": [
        "ricaneur"
    ],
    "ricanions": [
        "ricaner"
    ],
    "ricanerent": [
        "ricaner"
    ],
    "ricassant": [
        "ricasser"
    ],
    "ricasser": [
        "ricasser"
    ],
    "richard": [
        "richard"
    ],
    "richarde": [
        "richard"
    ],
    "richards": [
        "richard"
    ],
    "riche": [
        "riche"
    ],
    "richelieu": [
        "richelieu"
    ],
    "richelieus": [
        "richelieu"
    ],
    "richement": [
        "richement"
    ],
    "riches": [
        "rich",
        "riche"
    ],
    "richesse": [
        "richesse"
    ],
    "richesses": [
        "richesse"
    ],
    "richissime": [
        "richissime"
    ],
    "richissimes": [
        "richissime"
    ],
    "richomme": [
        "richomme"
    ],
    "ricin": [
        "ricin"
    ],
    "ricocha": [
        "ricocher"
    ],
    "ricochaient": [
        "ricocher"
    ],
    "ricochait": [
        "ricocher"
    ],
    "ricochant": [
        "ricocher"
    ],
    "ricoche": [
        "ricocher"
    ],
    "ricochent": [
        "ricocher"
    ],
    "ricocher": [
        "ricocher"
    ],
    "ricochet": [
        "ricochet"
    ],
    "ricochets": [
        "ricochet"
    ],
    "ricotta": [
        "ricotta"
    ],
    "rictus": [
        "rictus"
    ],
    "rida": [
        "rider"
    ],
    "ridaient": [
        "rider"
    ],
    "ridait": [
        "rider"
    ],
    "ridant": [
        "rider"
    ],
    "ride": [
        "ride",
        "rider"
    ],
    "rideau": [
        "rideau"
    ],
    "rideaux": [
        "rideau"
    ],
    "ridelle": [
        "rideau"
    ],
    "ridelles": [
        "rideau"
    ],
    "rident": [
        "rider"
    ],
    "rider": [
        "rider"
    ],
    "rides": [
        "ride",
        "rider"
    ],
    "ridicule": [
        "ridicule"
    ],
    "ridiculement": [
        "ridiculement"
    ],
    "ridicules": [
        "ridicule"
    ],
    "ridiculisa": [
        "ridiculiser"
    ],
    "ridiculisaient": [
        "ridiculiser"
    ],
    "ridiculisais": [
        "ridiculiser"
    ],
    "ridiculisait": [
        "ridiculiser"
    ],
    "ridiculisant": [
        "ridiculiser"
    ],
    "ridiculisation": [
        "ridiculisation"
    ],
    "ridiculise": [
        "ridiculiser"
    ],
    "ridiculisent": [
        "ridiculiser"
    ],
    "ridiculiser": [
        "ridiculiser"
    ],
    "ridiculisera": [
        "ridiculiser"
    ],
    "ridiculiserai": [
        "ridiculiser"
    ],
    "ridiculiserais": [
        "ridiculiser"
    ],
    "ridiculiserait": [
        "ridiculiser"
    ],
    "ridiculiseras": [
        "ridiculiser"
    ],
    "ridiculises": [
        "ridiculiser"
    ],
    "ridiculisez": [
        "ridiculiser"
    ],
    "ridiculisiez": [
        "ridiculiser"
    ],
    "ridiculisee": [
        "ridiculiser"
    ],
    "ridiculisees": [
        "ridiculiser"
    ],
    "ridiculites": [
        "ridiculite"
    ],
    "ridule": [
        "ridule"
    ],
    "ridules": [
        "ridule"
    ],
    "ridee": [
        "ride",
        "rider"
    ],
    "ridees": [
        "ride",
        "rider"
    ],
    "rie": [
        "rire"
    ],
    "riel": [
        "riel"
    ],
    "rien": [
        "rien"
    ],
    "riens": [
        "rien"
    ],
    "rient": [
        "rire"
    ],
    "ries": [
        "rire"
    ],
    "riesling": [
        "riesling"
    ],
    "rieur": [
        "rieur"
    ],
    "rieurs": [
        "rieur"
    ],
    "rieuse": [
        "rieur",
        "rieux"
    ],
    "rieuses": [
        "rieux"
    ],
    "riez": [
        "rire"
    ],
    "rif": [
        "rif"
    ],
    "rifain": [
        "rifain"
    ],
    "rifains": [
        "rifain"
    ],
    "riff": [
        "riff"
    ],
    "riffaude": [
        "riffauder"
    ],
    "riffauder": [
        "riffauder"
    ],
    "riffs": [
        "riff"
    ],
    "rififi": [
        "rififi"
    ],
    "riflard": [
        "riflard"
    ],
    "rifle": [
        "rifle"
    ],
    "rifles": [
        "rifle"
    ],
    "riflette": [
        "riflette"
    ],
    "rift": [
        "rift"
    ],
    "rigaudon": [
        "rigaudon"
    ],
    "rigaudons": [
        "rigaudon"
    ],
    "rigide": [
        "rigide"
    ],
    "rigidement": [
        "rigidement"
    ],
    "rigides": [
        "rigide"
    ],
    "rigidifier": [
        "rigidifier"
    ],
    "rigidite": [
        "rigidite"
    ],
    "rigidites": [
        "rigidite"
    ],
    "rigodon": [
        "rigodon"
    ],
    "rigola": [
        "rigoler"
    ],
    "rigolade": [
        "rigolade"
    ],
    "rigolades": [
        "rigolade"
    ],
    "rigolage": [
        "rigolage"
    ],
    "rigolaient": [
        "rigoler"
    ],
    "rigolais": [
        "rigoler"
    ],
    "rigolait": [
        "rigoler"
    ],
    "rigolant": [
        "rigoler"
    ],
    "rigolard": [
        "rigolard"
    ],
    "rigolarde": [
        "rigolard"
    ],
    "rigolardes": [
        "rigolard"
    ],
    "rigolards": [
        "rigolard"
    ],
    "rigole": [
        "rigole",
        "rigoler"
    ],
    "rigolent": [
        "rigoler"
    ],
    "rigoler": [
        "rigoler"
    ],
    "rigolera": [
        "rigoler"
    ],
    "rigolerai": [
        "rigoler"
    ],
    "rigoleraient": [
        "rigoler"
    ],
    "rigolerais": [
        "rigoler"
    ],
    "rigolerait": [
        "rigoler"
    ],
    "rigoleras": [
        "rigoler"
    ],
    "rigolerez": [
        "rigoler"
    ],
    "rigoleront": [
        "rigoler"
    ],
    "rigoles": [
        "rigole",
        "rigoler"
    ],
    "rigoleur": [
        "rigoleur"
    ],
    "rigolez": [
        "rigoler"
    ],
    "rigoliez": [
        "rigoler"
    ],
    "rigolions": [
        "rigoler"
    ],
    "rigollot": [
        "rigollot"
    ],
    "rigolo": [
        "rigolo"
    ],
    "rigolons": [
        "rigoler"
    ],
    "rigolos": [
        "rigolo"
    ],
    "rigolote": [
        "rigolo",
        "rigolote"
    ],
    "rigolotes": [
        "rigolo",
        "rigolote"
    ],
    "rigolerent": [
        "rigoler"
    ],
    "rigorisme": [
        "rigorisme"
    ],
    "rigoriste": [
        "rigoriste"
    ],
    "rigoristes": [
        "rigoriste"
    ],
    "rigoureuse": [
        "rigoureux"
    ],
    "rigoureusement": [
        "rigoureusement"
    ],
    "rigoureuses": [
        "rigoureux"
    ],
    "rigoureux": [
        "rigoureux"
    ],
    "rigueur": [
        "rigueur"
    ],
    "rigueurs": [
        "rigueur"
    ],
    "riiez": [
        "rire"
    ],
    "riions": [
        "rire"
    ],
    "rikiki": [
        "rikiki"
    ],
    "rillettes": [
        "rillettes"
    ],
    "rillons": [
        "rillons"
    ],
    "rima": [
        "rimer"
    ],
    "rimaient": [
        "rimer"
    ],
    "rimaillerie": [
        "rimaillerie"
    ],
    "rimailles": [
        "rimailler"
    ],
    "rimailleur": [
        "rimailleur"
    ],
    "rimailleurs": [
        "rimailleur"
    ],
    "rimait": [
        "rimer"
    ],
    "rimante": [
        "rimant"
    ],
    "rimaye": [
        "rimaye"
    ],
    "rimbaldien": [
        "rimbaldien"
    ],
    "rime": [
        "rime",
        "rimer"
    ],
    "riment": [
        "rimer"
    ],
    "rimer": [
        "rimer"
    ],
    "rimes": [
        "rime",
        "rire",
        "rimer"
    ],
    "rimeur": [
        "rimeur"
    ],
    "rimeurs": [
        "rimeur"
    ],
    "rimeuse": [
        "rimeur"
    ],
    "rimez": [
        "rimer"
    ],
    "rimions": [
        "rimer"
    ],
    "rimmel": [
        "rimmel"
    ],
    "rimee": [
        "rimer"
    ],
    "rince": [
        "rincer"
    ],
    "rinceau": [
        "rinceau"
    ],
    "rinceaux": [
        "rinceau"
    ],
    "rincent": [
        "rincer"
    ],
    "rincer": [
        "rincer"
    ],
    "rincera": [
        "rincer"
    ],
    "rincerai": [
        "rincer"
    ],
    "rinceraient": [
        "rincer"
    ],
    "rinces": [
        "rincer"
    ],
    "rincette": [
        "rincette"
    ],
    "rinceur": [
        "rinceur"
    ],
    "rincez": [
        "rincer"
    ],
    "rincerent": [
        "rincer"
    ],
    "rincee": [
        "rincer",
        "rincee"
    ],
    "rincees": [
        "rincer"
    ],
    "rinforzando": [
        "rinforzando"
    ],
    "ring": [
        "ring"
    ],
    "ringard": [
        "ringard"
    ],
    "ringarde": [
        "ringard"
    ],
    "ringardes": [
        "ringard"
    ],
    "ringardise": [
        "ringardise"
    ],
    "ringardises": [
        "ringardise"
    ],
    "ringards": [
        "ringard"
    ],
    "rings": [
        "ring"
    ],
    "rink": [
        "rink"
    ],
    "rinker": [
        "rinker"
    ],
    "rinca": [
        "rincer"
    ],
    "rincage": [
        "rincage"
    ],
    "rincages": [
        "rincage"
    ],
    "rincaient": [
        "rincer"
    ],
    "rincais": [
        "rincer"
    ],
    "rincait": [
        "rincer"
    ],
    "rincant": [
        "rincer"
    ],
    "rioja": [
        "rioja"
    ],
    "rions": [
        "rire"
    ],
    "ripa": [
        "riper"
    ],
    "ripaillait": [
        "ripailler"
    ],
    "ripaille": [
        "ripaille",
        "ripailler"
    ],
    "ripailler": [
        "ripailler"
    ],
    "ripailles": [
        "ripaille"
    ],
    "ripaillons": [
        "ripailler"
    ],
    "ripant": [
        "riper"
    ],
    "ripaton": [
        "ripaton"
    ],
    "ripatons": [
        "ripaton"
    ],
    "ripe": [
        "riper",
        "rip"
    ],
    "riper": [
        "ripe",
        "riper"
    ],
    "ripes": [
        "riper"
    ],
    "ripeur": [
        "ripeur"
    ],
    "ripolin": [
        "ripolin"
    ],
    "ripoliner": [
        "ripoliner"
    ],
    "ripolines": [
        "ripoliner"
    ],
    "ripoline": [
        "ripoliner"
    ],
    "ripolinee": [
        "ripoliner"
    ],
    "ripolinees": [
        "ripoliner"
    ],
    "riposta": [
        "riposter"
    ],
    "ripostai": [
        "riposter"
    ],
    "ripostaient": [
        "riposter"
    ],
    "ripostais": [
        "riposter"
    ],
    "ripostait": [
        "riposter"
    ],
    "ripostant": [
        "riposter"
    ],
    "riposte": [
        "riposter",
        "riposte"
    ],
    "ripostent": [
        "riposter"
    ],
    "riposter": [
        "riposter"
    ],
    "ripostera": [
        "riposter"
    ],
    "riposterai": [
        "riposter"
    ],
    "riposterez": [
        "riposter"
    ],
    "riposterons": [
        "riposter"
    ],
    "riposteront": [
        "riposter"
    ],
    "ripostes": [
        "riposter",
        "riposte"
    ],
    "ripostez": [
        "riposter"
    ],
    "ripostions": [
        "riposter"
    ],
    "ripostons": [
        "riposter"
    ],
    "ripou": [
        "ripou"
    ],
    "ripoux": [
        "ripoux"
    ],
    "ripper": [
        "ripper"
    ],
    "ripuaire": [
        "ripuaire"
    ],
    "riquiqui": [
        "riquiqui"
    ],
    "rira": [
        "rire"
    ],
    "rirai": [
        "rire"
    ],
    "riraient": [
        "rire"
    ],
    "rirais": [
        "rire"
    ],
    "rirait": [
        "rire"
    ],
    "riras": [
        "rire"
    ],
    "rire": [
        "rire"
    ],
    "rirent": [
        "rire"
    ],
    "rires": [
        "rire"
    ],
    "rirez": [
        "rire"
    ],
    "rirons": [
        "rire"
    ],
    "riront": [
        "rire"
    ],
    "ris": [
        "ri",
        "ris",
        "rire"
    ],
    "rise": [
        "rise"
    ],
    "riser": [
        "riser"
    ],
    "risette": [
        "risette"
    ],
    "risettes": [
        "risette"
    ],
    "risibilite": [
        "risibilite"
    ],
    "risible": [
        "risible"
    ],
    "risiblement": [
        "risiblement"
    ],
    "risibles": [
        "risible"
    ],
    "risorius": [
        "risorius"
    ],
    "risotto": [
        "risotto"
    ],
    "risqua": [
        "risquer"
    ],
    "risquai": [
        "risquer"
    ],
    "risquaient": [
        "risquer"
    ],
    "risquais": [
        "risquer"
    ],
    "risquait": [
        "risquer"
    ],
    "risquant": [
        "risquer"
    ],
    "risque": [
        "risque",
        "risquer"
    ],
    "risquent": [
        "risquer"
    ],
    "risquer": [
        "risquer"
    ],
    "risquera": [
        "risquer"
    ],
    "risquerai": [
        "risquer"
    ],
    "risqueraient": [
        "risquer"
    ],
    "risquerais": [
        "risquer"
    ],
    "risquerait": [
        "risquer"
    ],
    "risqueras": [
        "risquer"
    ],
    "risquerez": [
        "risquer"
    ],
    "risqueriez": [
        "risquer"
    ],
    "risquerions": [
        "risquer"
    ],
    "risquerons": [
        "risquer"
    ],
    "risqueront": [
        "risquer"
    ],
    "risques": [
        "risque",
        "risquer"
    ],
    "risquez": [
        "risquer"
    ],
    "risquiez": [
        "risquer"
    ],
    "risquions": [
        "risquer"
    ],
    "risquons": [
        "risquer"
    ],
    "risquat": [
        "risquer"
    ],
    "risquee": [
        "risque",
        "risquer"
    ],
    "risquees": [
        "risque",
        "risquer"
    ],
    "rissolaient": [
        "rissoler"
    ],
    "rissolait": [
        "rissoler"
    ],
    "rissole": [
        "rissoler",
        "rissole"
    ],
    "rissolent": [
        "rissoler"
    ],
    "rissoler": [
        "rissoler"
    ],
    "rissoles": [
        "rissole"
    ],
    "rissolee": [
        "rissole"
    ],
    "rissolees": [
        "rissoler",
        "rissole"
    ],
    "ristournait": [
        "ristourner"
    ],
    "ristourne": [
        "ristourne",
        "ristourner"
    ],
    "ristournes": [
        "ristourne"
    ],
    "risee": [
        "risee"
    ],
    "risees": [
        "risee"
    ],
    "rit": [
        "rire"
    ],
    "rital": [
        "rital"
    ],
    "ritale": [
        "rital"
    ],
    "ritales": [
        "rital"
    ],
    "ritals": [
        "rital"
    ],
    "rite": [
        "rite"
    ],
    "rites": [
        "rite"
    ],
    "ritournelle": [
        "ritournelle"
    ],
    "ritournelles": [
        "ritournelle"
    ],
    "rittes": [
        "ritt"
    ],
    "ritualisa": [
        "ritualiser"
    ],
    "ritualisation": [
        "ritualisation"
    ],
    "ritualiste": [
        "ritualiste"
    ],
    "ritualistes": [
        "ritualiste"
    ],
    "ritualise": [
        "ritualiser"
    ],
    "ritualises": [
        "ritualiser"
    ],
    "rituel": [
        "rituel"
    ],
    "rituelle": [
        "rituel"
    ],
    "rituellement": [
        "rituellement"
    ],
    "rituelles": [
        "rituel"
    ],
    "rituels": [
        "rituel"
    ],
    "riva": [
        "river"
    ],
    "rivage": [
        "rivage"
    ],
    "rivages": [
        "rivage"
    ],
    "rivaient": [
        "river"
    ],
    "rivais": [
        "river"
    ],
    "rivait": [
        "river"
    ],
    "rival": [
        "rival"
    ],
    "rivale": [
        "rival"
    ],
    "rivales": [
        "rival"
    ],
    "rivalisaient": [
        "rivaliser"
    ],
    "rivalisait": [
        "rivaliser"
    ],
    "rivalisant": [
        "rivaliser"
    ],
    "rivalise": [
        "rivaliser"
    ],
    "rivalisent": [
        "rivaliser"
    ],
    "rivaliser": [
        "rivaliser"
    ],
    "rivalisera": [
        "rivaliser"
    ],
    "rivaliserait": [
        "rivaliser"
    ],
    "rivaliserent": [
        "rivaliser"
    ],
    "rivalite": [
        "rivalite"
    ],
    "rivalites": [
        "rivalite"
    ],
    "rivant": [
        "river"
    ],
    "rivaux": [
        "rival"
    ],
    "rive": [
        "river",
        "rive"
    ],
    "river": [
        "river"
    ],
    "riverain": [
        "riverain"
    ],
    "riveraines": [
        "riverain"
    ],
    "riverains": [
        "riverain"
    ],
    "riverait": [
        "river"
    ],
    "rives": [
        "river",
        "rive"
    ],
    "rivet": [
        "rivet"
    ],
    "rivetage": [
        "rivetage"
    ],
    "riveteuse": [
        "riveteur",
        "riveteuse"
    ],
    "rivets": [
        "rivet"
    ],
    "rivette": [
        "riveter"
    ],
    "rivete": [
        "riveter"
    ],
    "rivetees": [
        "riveter"
    ],
    "riviera": [
        "riviera"
    ],
    "rivieras": [
        "riviera"
    ],
    "riviere": [
        "riviere"
    ],
    "rivieres": [
        "riviere"
    ],
    "rivoir": [
        "rivoir"
    ],
    "rivee": [
        "river"
    ],
    "rivees": [
        "river"
    ],
    "rixdales": [
        "rixdale"
    ],
    "rixe": [
        "rixe"
    ],
    "rixes": [
        "rixe"
    ],
    "riz": [
        "riz"
    ],
    "riziere": [
        "riziere"
    ],
    "rizieres": [
        "riziere"
    ],
    "roadster": [
        "roadster"
    ],
    "robe": [
        "robe"
    ],
    "rober": [
        "rober"
    ],
    "robert": [
        "robert"
    ],
    "roberts": [
        "robert"
    ],
    "robes": [
        "robe"
    ],
    "robette": [
        "robette"
    ],
    "robin": [
        "robin"
    ],
    "robinet": [
        "robinet"
    ],
    "robinets": [
        "robinet"
    ],
    "robinetterie": [
        "robinetterie"
    ],
    "robiniers": [
        "robinier"
    ],
    "robins": [
        "robin"
    ],
    "robinsonnade": [
        "robinsonnade"
    ],
    "robinsons": [
        "robinson"
    ],
    "roblot": [
        "roblot"
    ],
    "roboratif": [
        "roboratif"
    ],
    "roborative": [
        "roboratif"
    ],
    "roboratives": [
        "roboratif"
    ],
    "robot": [
        "robot"
    ],
    "robotique": [
        "robotique"
    ],
    "robotiques": [
        "robotique"
    ],
    "robotise": [
        "robotiser"
    ],
    "robotisee": [
        "robotiser"
    ],
    "robotisees": [
        "robotiser"
    ],
    "robots": [
        "robot"
    ],
    "roburite": [
        "roburite"
    ],
    "robuste": [
        "robuste"
    ],
    "robustement": [
        "robustement"
    ],
    "robustes": [
        "robuste"
    ],
    "robustesse": [
        "robustesse"
    ],
    "roc": [
        "roc"
    ],
    "rocade": [
        "rocade"
    ],
    "rocades": [
        "rocade"
    ],
    "rocaille": [
        "rocailler",
        "rocaille"
    ],
    "rocailles": [
        "rocaille"
    ],
    "rocailleuse": [
        "rocailleux"
    ],
    "rocailleuses": [
        "rocailleux"
    ],
    "rocailleux": [
        "rocailleux"
    ],
    "rocambole": [
        "rocambole"
    ],
    "rocambolesque": [
        "rocambolesque"
    ],
    "rocambolesques": [
        "rocambolesque"
    ],
    "rochas": [
        "rocher"
    ],
    "rochassier": [
        "rochassier"
    ],
    "roche": [
        "roche",
        "rocher"
    ],
    "rochelle": [
        "rochelle"
    ],
    "rocher": [
        "rocher"
    ],
    "rochers": [
        "rocher"
    ],
    "roches": [
        "roche"
    ],
    "rochet": [
        "rochet"
    ],
    "rocheuse": [
        "rocheux"
    ],
    "rocheuses": [
        "rocheux"
    ],
    "rocheux": [
        "rocheux"
    ],
    "rochiers": [
        "rochier"
    ],
    "rock": [
        "rock",
        "rocke"
    ],
    "rock'n'roll": [
        "rock'n'roll"
    ],
    "rocker": [
        "rocker"
    ],
    "rockers": [
        "rocker"
    ],
    "rocket": [
        "rocket"
    ],
    "rockets": [
        "rocket"
    ],
    "rockeur": [
        "rockeur"
    ],
    "rockeurs": [
        "rockeur"
    ],
    "rockeuse": [
        "rockeur"
    ],
    "rocks": [
        "rock"
    ],
    "rococo": [
        "rococo"
    ],
    "rococos": [
        "rococo"
    ],
    "rocs": [
        "roc"
    ],
    "rodage": [
        "rodage"
    ],
    "rodages": [
        "rodage"
    ],
    "rodait": [
        "roder"
    ],
    "rode": [
        "ride",
        "roder"
    ],
    "rodeo": [
        "rodeo"
    ],
    "roder": [
        "roder"
    ],
    "roderait": [
        "roder"
    ],
    "rodomontades": [
        "rodomontade"
    ],
    "rodee": [
        "roder"
    ],
    "rodees": [
        "roder"
    ],
    "rodeos": [
        "rodeo"
    ],
    "rodes": [
        "roder"
    ],
    "roentgens": [
        "roentgen"
    ],
    "rogations": [
        "rogation"
    ],
    "rogatoire": [
        "rogatoire"
    ],
    "rogatoires": [
        "rogatoire"
    ],
    "rogaton": [
        "rogaton"
    ],
    "rogatons": [
        "rogaton"
    ],
    "rogna": [
        "rogner"
    ],
    "rognais": [
        "rogner"
    ],
    "rognait": [
        "rogner"
    ],
    "rognant": [
        "rogner"
    ],
    "rogne": [
        "rogner",
        "rogne"
    ],
    "rognent": [
        "rogner"
    ],
    "rogner": [
        "rogner"
    ],
    "rognes": [
        "rogner",
        "rogne"
    ],
    "rogneux": [
        "rogneux"
    ],
    "rognez": [
        "rogner"
    ],
    "rognon": [
        "rognon"
    ],
    "rognonnait": [
        "rognonner"
    ],
    "rognons": [
        "rognon"
    ],
    "rognure": [
        "rognure"
    ],
    "rognures": [
        "rognure"
    ],
    "rognee": [
        "rogner"
    ],
    "rognees": [
        "rogner"
    ],
    "rogomme": [
        "rogomme"
    ],
    "rogommes": [
        "rogomme"
    ],
    "rogue": [
        "rogue"
    ],
    "rogues": [
        "rogue"
    ],
    "roi": [
        "roi"
    ],
    "roide": [
        "roide"
    ],
    "roidement": [
        "roidement"
    ],
    "roides": [
        "roide"
    ],
    "roideur": [
        "roideur"
    ],
    "roidi": [
        "roidir"
    ],
    "roidie": [
        "roidir"
    ],
    "roidir": [
        "roidir"
    ],
    "roidissait": [
        "roidir"
    ],
    "rois": [
        "roi"
    ],
    "roitelet": [
        "roitelet"
    ],
    "roitelets": [
        "roitelet"
    ],
    "roll": [
        "roll"
    ],
    "rolle": [
        "rolle"
    ],
    "roller": [
        "roller"
    ],
    "rollers": [
        "roller"
    ],
    "rollmops": [
        "rollmops"
    ],
    "rom": [
        "rom"
    ],
    "romain": [
        "romain"
    ],
    "romaine": [
        "romain"
    ],
    "romaines": [
        "romain"
    ],
    "romains": [
        "romain"
    ],
    "roman": [
        "roman"
    ],
    "romance": [
        "romancer",
        "romance"
    ],
    "romancer": [
        "romancer"
    ],
    "romancero": [
        "romancero"
    ],
    "romances": [
        "romance"
    ],
    "romanche": [
        "romanche"
    ],
    "romancier": [
        "romancier"
    ],
    "romanciers": [
        "romancier"
    ],
    "romanciere": [
        "romancier"
    ],
    "romancieres": [
        "romancier"
    ],
    "romancee": [
        "romancer",
        "romance"
    ],
    "romancees": [
        "romance"
    ],
    "romande": [
        "romand"
    ],
    "romane": [
        "roman"
    ],
    "romanes": [
        "roman"
    ],
    "romanesque": [
        "romanesque"
    ],
    "romanesques": [
        "romanesque"
    ],
    "romani": [
        "romani"
    ],
    "romanichel": [
        "romanichel"
    ],
    "romanichelle": [
        "romanichel"
    ],
    "romanichelles": [
        "romanichel"
    ],
    "romanichels": [
        "romanichel"
    ],
    "romanisation": [
        "romanisation"
    ],
    "romanistes": [
        "romaniste"
    ],
    "romanite": [
        "romanite"
    ],
    "romano": [
        "romano"
    ],
    "romanos": [
        "romano"
    ],
    "romans": [
        "roman"
    ],
    "romanticisme": [
        "romanticisme"
    ],
    "romantique": [
        "romantique"
    ],
    "romantiquement": [
        "romantiquement"
    ],
    "romantiques": [
        "romantique"
    ],
    "romantisme": [
        "romantisme"
    ],
    "romantismes": [
        "romantisme"
    ],
    "romarin": [
        "romarin"
    ],
    "rombiere": [
        "rombier"
    ],
    "rombieres": [
        "rombier",
        "rombiere"
    ],
    "rompaient": [
        "rompre"
    ],
    "rompais": [
        "rompre"
    ],
    "rompait": [
        "rompre"
    ],
    "rompant": [
        "rompre"
    ],
    "rompe": [
        "rompre"
    ],
    "rompent": [
        "rompre"
    ],
    "rompez": [
        "rompre"
    ],
    "rompiez": [
        "rompre"
    ],
    "rompirent": [
        "rompre"
    ],
    "rompis": [
        "rompre"
    ],
    "rompissent": [
        "rompre"
    ],
    "rompit": [
        "rompre"
    ],
    "rompons": [
        "rompre"
    ],
    "rompra": [
        "rompre"
    ],
    "romprai": [
        "rompre"
    ],
    "rompraient": [
        "rompre"
    ],
    "romprais": [
        "rompre"
    ],
    "romprait": [
        "rompre"
    ],
    "rompre": [
        "rompre"
    ],
    "romprez": [
        "rompre"
    ],
    "romprions": [
        "rompre"
    ],
    "romprons": [
        "rompre"
    ],
    "romps": [
        "romp",
        "rompre"
    ],
    "rompt": [
        "rompre"
    ],
    "rompu": [
        "rompu",
        "rompre"
    ],
    "rompue": [
        "rompu",
        "rompre"
    ],
    "rompues": [
        "rompu",
        "rompre"
    ],
    "rompus": [
        "rompu",
        "rompre"
    ],
    "roms": [
        "rom"
    ],
    "ron": [
        "ron"
    ],
    "ronce": [
        "ronce"
    ],
    "ronces": [
        "ronce"
    ],
    "roncet": [
        "roncet"
    ],
    "ronceux": [
        "ronceux"
    ],
    "ronchon": [
        "ronchon"
    ],
    "ronchonna": [
        "ronchonner"
    ],
    "ronchonnaient": [
        "ronchonner"
    ],
    "ronchonnais": [
        "ronchonner"
    ],
    "ronchonnait": [
        "ronchonner"
    ],
    "ronchonnant": [
        "ronchonner"
    ],
    "ronchonne": [
        "ronchon",
        "ronchonner"
    ],
    "ronchonnent": [
        "ronchonner"
    ],
    "ronchonner": [
        "ronchonner"
    ],
    "ronchonnes": [
        "ronchonner"
    ],
    "ronchonneur": [
        "ronchonneur"
    ],
    "ronchonneuse": [
        "ronchonneur"
    ],
    "ronchonnot": [
        "ronchonnot"
    ],
    "roncier": [
        "roncier"
    ],
    "ronciers": [
        "roncier"
    ],
    "rond": [
        "rond"
    ],
    "rondache": [
        "rondache"
    ],
    "ronde": [
        "rond",
        "ronde"
    ],
    "rondeau": [
        "rondeau"
    ],
    "rondelet": [
        "rondelet"
    ],
    "rondelette": [
        "rondelet"
    ],
    "rondelettes": [
        "rondelet"
    ],
    "rondelle": [
        "rondelle"
    ],
    "rondelles": [
        "rondelle"
    ],
    "rondement": [
        "rondement"
    ],
    "rondes": [
        "rond",
        "ronde"
    ],
    "rondeur": [
        "rondeur"
    ],
    "rondeurs": [
        "rondeur"
    ],
    "rondin": [
        "rondin"
    ],
    "rondins": [
        "rondin"
    ],
    "rondo": [
        "rondo"
    ],
    "rondos": [
        "rondo"
    ],
    "rondouillard": [
        "rondouillard"
    ],
    "rondouillarde": [
        "rondouillard"
    ],
    "rondouillards": [
        "rondouillard"
    ],
    "ronds": [
        "rond"
    ],
    "ronfla": [
        "ronfler"
    ],
    "ronflaient": [
        "ronfler"
    ],
    "ronflais": [
        "ronfler"
    ],
    "ronflait": [
        "ronfler"
    ],
    "ronflant": [
        "ronfler",
        "ronflant"
    ],
    "ronflante": [
        "ronflant"
    ],
    "ronflantes": [
        "ronflant"
    ],
    "ronflants": [
        "ronflant"
    ],
    "ronfle": [
        "ronfler"
    ],
    "ronflement": [
        "ronflement"
    ],
    "ronflements": [
        "ronflement"
    ],
    "ronflent": [
        "ronfler"
    ],
    "ronfler": [
        "ronfler"
    ],
    "ronflerais": [
        "ronfler"
    ],
    "ronfleras": [
        "ronfler"
    ],
    "ronfles": [
        "ronfler"
    ],
    "ronflette": [
        "ronflette"
    ],
    "ronfleur": [
        "ronfleur"
    ],
    "ronfleurs": [
        "ronfleur"
    ],
    "ronfleuse": [
        "ronfleur"
    ],
    "ronflez": [
        "ronfler"
    ],
    "ronfliez": [
        "ronfler"
    ],
    "ronflotait": [
        "ronfloter"
    ],
    "ronflotant": [
        "ronfloter"
    ],
    "ronflote": [
        "ronfloter"
    ],
    "ronflerent": [
        "ronfler"
    ],
    "ronge": [
        "ronger"
    ],
    "rongea": [
        "ronger"
    ],
    "rongeai": [
        "ronger"
    ],
    "rongeaient": [
        "ronger"
    ],
    "rongeais": [
        "ronger"
    ],
    "rongeait": [
        "ronger"
    ],
    "rongeant": [
        "ronger",
        "rongeant"
    ],
    "rongeante": [
        "rongeant"
    ],
    "rongeantes": [
        "rongeant"
    ],
    "rongement": [
        "rongement"
    ],
    "rongent": [
        "ronger"
    ],
    "ronger": [
        "ronger"
    ],
    "rongera": [
        "ronger"
    ],
    "rongerait": [
        "ronger"
    ],
    "ronges": [
        "ronger"
    ],
    "rongeur": [
        "rongeur"
    ],
    "rongeurs": [
        "rongeur"
    ],
    "rongeuse": [
        "rongeur"
    ],
    "rongeuses": [
        "rongeur"
    ],
    "rongez": [
        "ronger"
    ],
    "rongeat": [
        "ronger"
    ],
    "rongicide": [
        "rongicide"
    ],
    "rongerent": [
        "ronger"
    ],
    "rongee": [
        "ronger"
    ],
    "rongees": [
        "ronger"
    ],
    "ronin": [
        "ronin"
    ],
    "ronron": [
        "ronron"
    ],
    "ronronna": [
        "ronronner"
    ],
    "ronronnaient": [
        "ronronner"
    ],
    "ronronnais": [
        "ronronner"
    ],
    "ronronnait": [
        "ronronner"
    ],
    "ronronnant": [
        "ronronnant",
        "ronronner"
    ],
    "ronronnante": [
        "ronronnant"
    ],
    "ronronnantes": [
        "ronronnant"
    ],
    "ronronnants": [
        "ronronnant"
    ],
    "ronronne": [
        "ronronner"
    ],
    "ronronnement": [
        "ronronnement"
    ],
    "ronronnements": [
        "ronronnement"
    ],
    "ronronnent": [
        "ronronner"
    ],
    "ronronner": [
        "ronronner"
    ],
    "ronronnerait": [
        "ronronner"
    ],
    "ronronnons": [
        "ronronner"
    ],
    "ronronnerent": [
        "ronronner"
    ],
    "ronrons": [
        "ronron"
    ],
    "roneo": [
        "roneo"
    ],
    "roneotions": [
        "roneoter"
    ],
    "roneotyper": [
        "roneotyper"
    ],
    "roneotype": [
        "roneotyper"
    ],
    "roneotypes": [
        "roneotyper"
    ],
    "roneote": [
        "roneoter"
    ],
    "roof": [
        "roof"
    ],
    "roploplos": [
        "roploplo"
    ],
    "roque": [
        "roque",
        "roquer"
    ],
    "roquefort": [
        "roquefort"
    ],
    "roquentin": [
        "roquentin"
    ],
    "roquer": [
        "roquer"
    ],
    "roques": [
        "roque"
    ],
    "roquet": [
        "roquet"
    ],
    "roquets": [
        "roquet"
    ],
    "roquette": [
        "roquette"
    ],
    "roquettes": [
        "roquette"
    ],
    "rorqual": [
        "rorqual"
    ],
    "rorquals": [
        "rorqual"
    ],
    "rosa": [
        "roser"
    ],
    "rosace": [
        "rosace"
    ],
    "rosaces": [
        "rosace"
    ],
    "rosages": [
        "rosage"
    ],
    "rosaire": [
        "rosaire"
    ],
    "rosaires": [
        "rosaire"
    ],
    "rosales": [
        "rosales"
    ],
    "rosat": [
        "rosat"
    ],
    "rosbif": [
        "rosbif"
    ],
    "rosbifs": [
        "rosbif"
    ],
    "rose": [
        "rose",
        "roser",
        "rise"
    ],
    "roseau": [
        "roseau"
    ],
    "roseaux": [
        "roseau"
    ],
    "roseliere": [
        "roselier"
    ],
    "roselieres": [
        "roselier"
    ],
    "roser": [
        "roser"
    ],
    "roseraie": [
        "roseraie"
    ],
    "roseraies": [
        "roseraie"
    ],
    "roses": [
        "rose"
    ],
    "rosette": [
        "rosette"
    ],
    "rosettes": [
        "rosette"
    ],
    "roseur": [
        "roseur"
    ],
    "roseurs": [
        "roseur"
    ],
    "rosi": [
        "rosir"
    ],
    "rosicrucien": [
        "rosicrucien"
    ],
    "rosicrucienne": [
        "rosicrucien",
        "rosicrucienne"
    ],
    "rosicruciens": [
        "rosicrucien"
    ],
    "rosie": [
        "rosir"
    ],
    "rosier": [
        "rosier",
        "rosy"
    ],
    "rosiers": [
        "rosier"
    ],
    "rosies": [
        "rosir"
    ],
    "rosir": [
        "rosir"
    ],
    "rosis": [
        "rosir"
    ],
    "rosissaient": [
        "rosir"
    ],
    "rosissait": [
        "rosir"
    ],
    "rosissant": [
        "rosir"
    ],
    "rosissent": [
        "rosir"
    ],
    "rosit": [
        "rosir"
    ],
    "rosiere": [
        "rosiere"
    ],
    "rossa": [
        "rosser"
    ],
    "rossaient": [
        "rosser"
    ],
    "rossait": [
        "rosser"
    ],
    "rossant": [
        "rosser"
    ],
    "rossard": [
        "rossard"
    ],
    "rossards": [
        "rossard"
    ],
    "rosse": [
        "rosse",
        "rosser"
    ],
    "rossent": [
        "rosser"
    ],
    "rosser": [
        "rosser"
    ],
    "rosserai": [
        "rosser"
    ],
    "rosserie": [
        "rosserie"
    ],
    "rosseries": [
        "rosserie"
    ],
    "rosses": [
        "ross",
        "rosse",
        "rosser"
    ],
    "rossez": [
        "rosser"
    ],
    "rossignol": [
        "rossignol"
    ],
    "rossignols": [
        "rossignol"
    ],
    "rossinante": [
        "rossinante"
    ],
    "rossinantes": [
        "rossinante"
    ],
    "rossee": [
        "rosser",
        "rossee"
    ],
    "rostre": [
        "rostre"
    ],
    "rostres": [
        "rostre"
    ],
    "rosatre": [
        "rosatre"
    ],
    "rosatres": [
        "rosatre"
    ],
    "rosee": [
        "roser",
        "rosee"
    ],
    "rosees": [
        "roser",
        "rosee"
    ],
    "roseole": [
        "roseole"
    ],
    "rot": [
        "rot"
    ],
    "rota": [
        "roter"
    ],
    "rotaient": [
        "roter"
    ],
    "rotais": [
        "roter"
    ],
    "rotait": [
        "roter"
    ],
    "rotant": [
        "roter"
    ],
    "rotariens": [
        "rotarien"
    ],
    "rotary": [
        "rotary"
    ],
    "rotateur": [
        "rotateur"
    ],
    "rotatif": [
        "rotatif"
    ],
    "rotatifs": [
        "rotatif"
    ],
    "rotation": [
        "rotation"
    ],
    "rotationnel": [
        "rotationnel"
    ],
    "rotations": [
        "rotation"
    ],
    "rotative": [
        "rotatif",
        "rotative"
    ],
    "rotatives": [
        "rotatif",
        "rotative"
    ],
    "rotativistes": [
        "rotativiste"
    ],
    "rotatoire": [
        "rotatoire"
    ],
    "rote": [
        "roter",
        "rote"
    ],
    "rotengles": [
        "rotengle"
    ],
    "rotent": [
        "roter"
    ],
    "roter": [
        "roter"
    ],
    "rotera": [
        "roter"
    ],
    "rotes": [
        "roter"
    ],
    "roteur": [
        "roteur"
    ],
    "roteuse": [
        "roteur"
    ],
    "roteuses": [
        "roteur"
    ],
    "rotez": [
        "roter"
    ],
    "rotin": [
        "rotin"
    ],
    "roto": [
        "roto"
    ],
    "rotonde": [
        "rotonde",
        "rotond"
    ],
    "rotondes": [
        "rotond"
    ],
    "rotondite": [
        "rotondite"
    ],
    "rotondites": [
        "rotondite"
    ],
    "rotoplos": [
        "rotoplos"
    ],
    "rotoplots": [
        "rotoplots"
    ],
    "rotor": [
        "rotor"
    ],
    "rotors": [
        "rotor"
    ],
    "rotos": [
        "roto"
    ],
    "rototo": [
        "rototo"
    ],
    "rototos": [
        "rototo"
    ],
    "rots": [
        "rot"
    ],
    "rotule": [
        "rotule"
    ],
    "rotules": [
        "rotule"
    ],
    "rotulien": [
        "rotulien"
    ],
    "roture": [
        "roture"
    ],
    "roturier": [
        "roturier"
    ],
    "roturiers": [
        "roturier"
    ],
    "roturiere": [
        "roturier"
    ],
    "rotees": [
        "roter"
    ],
    "rotenone": [
        "rotenone"
    ],
    "roua": [
        "rouer"
    ],
    "rouage": [
        "rouage"
    ],
    "rouages": [
        "rouage"
    ],
    "rouaient": [
        "rouer"
    ],
    "rouais": [
        "rouer"
    ],
    "rouait": [
        "rouer"
    ],
    "rouan": [
        "rouan"
    ],
    "rouant": [
        "rouer"
    ],
    "roubaisienne": [
        "roubaisien"
    ],
    "roubignoles": [
        "roubignoles"
    ],
    "roublard": [
        "roublard"
    ],
    "roublarde": [
        "roublard"
    ],
    "roublarder": [
        "roublarder"
    ],
    "roublardes": [
        "roublard"
    ],
    "roublardise": [
        "roublardise"
    ],
    "roublardises": [
        "roublardise"
    ],
    "rouble": [
        "rouble"
    ],
    "roubles": [
        "rouble"
    ],
    "roucoula": [
        "roucouler"
    ],
    "roucoulade": [
        "roucoulade"
    ],
    "roucoulades": [
        "roucoulade"
    ],
    "roucoulaient": [
        "roucouler"
    ],
    "roucoulais": [
        "roucouler"
    ],
    "roucoulait": [
        "roucouler"
    ],
    "roucoulant": [
        "roucoulant",
        "roucouler"
    ],
    "roucoulante": [
        "roucoulant"
    ],
    "roucoulantes": [
        "roucoulant"
    ],
    "roucoulants": [
        "roucoulant"
    ],
    "roucoule": [
        "roucouler"
    ],
    "roucoulement": [
        "roucoulement"
    ],
    "roucoulements": [
        "roucoulement"
    ],
    "roucoulent": [
        "roucouler"
    ],
    "roucouler": [
        "roucouler"
    ],
    "roucoulerez": [
        "roucouler"
    ],
    "roucouleur": [
        "roucouleur"
    ],
    "roucoules": [
        "roucouler"
    ],
    "roudoudou": [
        "roudoudou"
    ],
    "roudoudous": [
        "roudoudou"
    ],
    "roue": [
        "roue",
        "rouer"
    ],
    "rouelle": [
        "rouelle"
    ],
    "rouennaise": [
        "rouennais"
    ],
    "rouenneries": [
        "rouennerie"
    ],
    "rouent": [
        "rouer"
    ],
    "rouer": [
        "rouer"
    ],
    "rouerai": [
        "rouer"
    ],
    "rouergat": [
        "rouergat"
    ],
    "rouerie": [
        "rouerie"
    ],
    "roueries": [
        "rouerie"
    ],
    "roueront": [
        "rouer"
    ],
    "roues": [
        "roue",
        "rouer"
    ],
    "rouet": [
        "rouet"
    ],
    "rouf": [
        "rouf"
    ],
    "rouflaquettes": [
        "rouflaquette"
    ],
    "rouge": [
        "rouge"
    ],
    "rougeaud": [
        "rougeaud"
    ],
    "rougeaude": [
        "rougeaud"
    ],
    "rougeaudes": [
        "rougeaud"
    ],
    "rougeauds": [
        "rougeaud"
    ],
    "rougeoie": [
        "rougeoyer"
    ],
    "rougeoiement": [
        "rougeoiement"
    ],
    "rougeoiements": [
        "rougeoiement"
    ],
    "rougeoient": [
        "rougeoyer"
    ],
    "rougeole": [
        "rougeole"
    ],
    "rougeoya": [
        "rougeoyer"
    ],
    "rougeoyaient": [
        "rougeoyer"
    ],
    "rougeoyait": [
        "rougeoyer"
    ],
    "rougeoyant": [
        "rougeoyant",
        "rougeoyer"
    ],
    "rougeoyante": [
        "rougeoyant"
    ],
    "rougeoyantes": [
        "rougeoyant"
    ],
    "rougeoyants": [
        "rougeoyant"
    ],
    "rougeoyer": [
        "rougeoyer"
    ],
    "rougeoye": [
        "rougeoyer"
    ],
    "rouges": [
        "rouge"
    ],
    "rouget": [
        "rouget"
    ],
    "rougets": [
        "rouget"
    ],
    "rougeur": [
        "rougeur"
    ],
    "rougeurs": [
        "rougeur"
    ],
    "rougeatre": [
        "rougeatre"
    ],
    "rougeatres": [
        "rougeatre"
    ],
    "rough": [
        "rough"
    ],
    "rougi": [
        "rougir"
    ],
    "rougie": [
        "rougir"
    ],
    "rougies": [
        "rougir"
    ],
    "rougir": [
        "rougir"
    ],
    "rougira": [
        "rougir"
    ],
    "rougiraient": [
        "rougir"
    ],
    "rougirais": [
        "rougir"
    ],
    "rougirait": [
        "rougir"
    ],
    "rougirent": [
        "rougir"
    ],
    "rougirez": [
        "rougir"
    ],
    "rougis": [
        "rougir"
    ],
    "rougissaient": [
        "rougir"
    ],
    "rougissais": [
        "rougir"
    ],
    "rougissait": [
        "rougir"
    ],
    "rougissant": [
        "rougir",
        "rougissant"
    ],
    "rougissante": [
        "rougissant"
    ],
    "rougissantes": [
        "rougissant"
    ],
    "rougissants": [
        "rougissant"
    ],
    "rougisse": [
        "rougir"
    ],
    "rougissement": [
        "rougissement"
    ],
    "rougissements": [
        "rougissement"
    ],
    "rougissent": [
        "rougir"
    ],
    "rougissez": [
        "rougir"
    ],
    "rougit": [
        "rougir"
    ],
    "roui": [
        "rouir"
    ],
    "rouies": [
        "rouir"
    ],
    "rouillaient": [
        "rouiller"
    ],
    "rouillait": [
        "rouiller"
    ],
    "rouillant": [
        "rouiller"
    ],
    "rouillarde": [
        "rouillarde"
    ],
    "rouille": [
        "rouille",
        "rouiller"
    ],
    "rouillent": [
        "rouiller"
    ],
    "rouiller": [
        "rouiller"
    ],
    "rouillerait": [
        "rouiller"
    ],
    "rouilleront": [
        "rouiller"
    ],
    "rouilles": [
        "rouille",
        "rouiller"
    ],
    "rouilleux": [
        "rouilleux"
    ],
    "rouillures": [
        "rouillure"
    ],
    "rouillee": [
        "rouiller"
    ],
    "rouillees": [
        "rouiller"
    ],
    "rouissant": [
        "rouir"
    ],
    "rouissent": [
        "rouir"
    ],
    "roula": [
        "rouler"
    ],
    "roulade": [
        "roulade"
    ],
    "roulades": [
        "roulade"
    ],
    "roulage": [
        "roulage"
    ],
    "roulages": [
        "roulage"
    ],
    "roulai": [
        "rouler"
    ],
    "roulaient": [
        "rouler"
    ],
    "roulais": [
        "rouler"
    ],
    "roulait": [
        "rouler"
    ],
    "roulant": [
        "roulant",
        "rouler"
    ],
    "roulante": [
        "roulante",
        "roulant"
    ],
    "roulantes": [
        "roulante",
        "roulant"
    ],
    "roulants": [
        "roulant"
    ],
    "roule": [
        "rouler",
        "roule"
    ],
    "rouleau": [
        "rouleau"
    ],
    "rouleaux": [
        "rouleau"
    ],
    "roulement": [
        "roulement"
    ],
    "roulements": [
        "roulement"
    ],
    "roulent": [
        "rouler"
    ],
    "rouler": [
        "rouler"
    ],
    "roulera": [
        "rouler"
    ],
    "roulerai": [
        "rouler"
    ],
    "rouleraient": [
        "rouler"
    ],
    "roulerais": [
        "rouler"
    ],
    "roulerait": [
        "rouler"
    ],
    "rouleras": [
        "rouler"
    ],
    "roulerez": [
        "rouler"
    ],
    "rouleriez": [
        "rouler"
    ],
    "roulerons": [
        "rouler"
    ],
    "rouleront": [
        "rouler"
    ],
    "roules": [
        "rouler",
        "roule"
    ],
    "roulette": [
        "roulette"
    ],
    "roulettes": [
        "roulette"
    ],
    "rouleur": [
        "rouleur"
    ],
    "rouleurs": [
        "rouleur"
    ],
    "rouleuse": [
        "rouleur"
    ],
    "rouleuses": [
        "rouleur"
    ],
    "roulez": [
        "rouler"
    ],
    "roulier": [
        "roulier"
    ],
    "rouliers": [
        "roulier"
    ],
    "rouliez": [
        "rouler"
    ],
    "roulions": [
        "rouler"
    ],
    "roulis": [
        "roulis"
    ],
    "roulons": [
        "rouler"
    ],
    "roulottait": [
        "roulotter"
    ],
    "roulotte": [
        "roulotte"
    ],
    "roulottent": [
        "roulotter"
    ],
    "roulottes": [
        "roulotte"
    ],
    "roulottiers": [
        "roulottier"
    ],
    "roulottiere": [
        "roulottier"
    ],
    "roulure": [
        "roulure"
    ],
    "roulures": [
        "roulure"
    ],
    "roulames": [
        "rouler"
    ],
    "roulat": [
        "rouler"
    ],
    "roulerent": [
        "rouler"
    ],
    "roulee": [
        "rouler",
        "roule"
    ],
    "roulees": [
        "rouler",
        "roule"
    ],
    "roumain": [
        "roumain"
    ],
    "roumaine": [
        "roumain"
    ],
    "roumaines": [
        "roumain"
    ],
    "roumains": [
        "roumain"
    ],
    "roumi": [
        "roumi"
    ],
    "roumis": [
        "roumi"
    ],
    "round": [
        "round"
    ],
    "rounds": [
        "round"
    ],
    "roupane": [
        "roupane"
    ],
    "roupette": [
        "roupette"
    ],
    "roupettes": [
        "roupettes"
    ],
    "roupie": [
        "roupie"
    ],
    "roupies": [
        "roupie"
    ],
    "roupillaient": [
        "roupiller"
    ],
    "roupillais": [
        "roupiller"
    ],
    "roupillait": [
        "roupiller"
    ],
    "roupille": [
        "roupiller"
    ],
    "roupillent": [
        "roupiller"
    ],
    "roupiller": [
        "roupiller"
    ],
    "roupillerai": [
        "roupiller"
    ],
    "roupillerais": [
        "roupiller"
    ],
    "roupillerait": [
        "roupiller"
    ],
    "roupilles": [
        "roupiller"
    ],
    "roupillez": [
        "roupiller"
    ],
    "roupillon": [
        "roupillon"
    ],
    "roupillons": [
        "roupillon"
    ],
    "rouquemoute": [
        "rouquemoute"
    ],
    "rouquette": [
        "rouquette"
    ],
    "rouquin": [
        "rouquin"
    ],
    "rouquine": [
        "rouquin"
    ],
    "rouquines": [
        "rouquin"
    ],
    "rouquins": [
        "rouquin"
    ],
    "rouscaillait": [
        "rouscailler"
    ],
    "rouscaillant": [
        "rouscailler"
    ],
    "rouscaille": [
        "rouscailler"
    ],
    "rouscaillent": [
        "rouscailler"
    ],
    "rouscailler": [
        "rouscailler"
    ],
    "rouspete": [
        "rouspeter"
    ],
    "rouspetent": [
        "rouspeter"
    ],
    "rouspetes": [
        "rouspeter"
    ],
    "rouspeta": [
        "rouspeter"
    ],
    "rouspetage": [
        "rouspetage"
    ],
    "rouspetaient": [
        "rouspeter"
    ],
    "rouspetais": [
        "rouspeter"
    ],
    "rouspetait": [
        "rouspeter"
    ],
    "rouspetance": [
        "rouspetance"
    ],
    "rouspetant": [
        "rouspeter"
    ],
    "rouspeter": [
        "rouspeter"
    ],
    "rouspetera": [
        "rouspeter"
    ],
    "rouspeteur": [
        "rouspeteur"
    ],
    "rouspeteurs": [
        "rouspeteur"
    ],
    "rouspetez": [
        "rouspeter"
    ],
    "rousse": [
        "roux",
        "rousser"
    ],
    "rousseau": [
        "rousseau"
    ],
    "rousseauiste": [
        "rousseauiste"
    ],
    "rousseaux": [
        "rousseau"
    ],
    "rousselee": [
        "rousseler"
    ],
    "rousserolle": [
        "rousserolle"
    ],
    "rousses": [
        "roux"
    ],
    "roussette": [
        "roussette"
    ],
    "roussettes": [
        "roussette"
    ],
    "rousseur": [
        "rousseur"
    ],
    "rousseurs": [
        "rousseur"
    ],
    "roussi": [
        "roussir",
        "roussi"
    ],
    "roussie": [
        "roussir",
        "roussi"
    ],
    "roussies": [
        "roussir",
        "roussi"
    ],
    "roussin": [
        "roussin"
    ],
    "roussins": [
        "roussin"
    ],
    "roussir": [
        "roussir"
    ],
    "roussis": [
        "roussir",
        "roussi"
    ],
    "roussissaient": [
        "roussir"
    ],
    "roussissait": [
        "roussir"
    ],
    "roussissant": [
        "roussir"
    ],
    "roussissures": [
        "roussissure"
    ],
    "roussit": [
        "roussir"
    ],
    "roussatre": [
        "roussatre"
    ],
    "roussatres": [
        "roussatre"
    ],
    "rouste": [
        "rouste"
    ],
    "roustes": [
        "rouste"
    ],
    "rousti": [
        "roustir"
    ],
    "rousties": [
        "roustir"
    ],
    "roustis": [
        "roustir"
    ],
    "rouston": [
        "rouston"
    ],
    "roustons": [
        "roustons"
    ],
    "routage": [
        "routage"
    ],
    "routard": [
        "routard"
    ],
    "routarde": [
        "routard"
    ],
    "routards": [
        "routard"
    ],
    "route": [
        "route",
        "router"
    ],
    "router": [
        "router"
    ],
    "routes": [
        "route"
    ],
    "routeur": [
        "routeur"
    ],
    "routeurs": [
        "routeur"
    ],
    "routier": [
        "routier"
    ],
    "routiers": [
        "routier"
    ],
    "routin": [
        "routin"
    ],
    "routine": [
        "routine"
    ],
    "routines": [
        "routine"
    ],
    "routinier": [
        "routinier"
    ],
    "routiniers": [
        "routinier"
    ],
    "routiniere": [
        "routinier"
    ],
    "routinieres": [
        "routinier"
    ],
    "routiere": [
        "routier"
    ],
    "routieres": [
        "routier"
    ],
    "rouvert": [
        "rouvrir"
    ],
    "rouverte": [
        "rouvert",
        "rouvrir"
    ],
    "rouvertes": [
        "rouvert",
        "rouvrir"
    ],
    "rouverts": [
        "rouvert",
        "rouvrir"
    ],
    "rouvraient": [
        "rouvrir"
    ],
    "rouvrais": [
        "rouvrir"
    ],
    "rouvrait": [
        "rouvrir"
    ],
    "rouvrant": [
        "rouvrir"
    ],
    "rouvre": [
        "rouvre",
        "rouvrir"
    ],
    "rouvrent": [
        "rouvrir"
    ],
    "rouvres": [
        "rouvre",
        "rouvrir"
    ],
    "rouvrez": [
        "rouvrir"
    ],
    "rouvriez": [
        "rouvrir"
    ],
    "rouvrir": [
        "rouvrir"
    ],
    "rouvrira": [
        "rouvrir"
    ],
    "rouvrirai": [
        "rouvrir"
    ],
    "rouvriraient": [
        "rouvrir"
    ],
    "rouvrirais": [
        "rouvrir"
    ],
    "rouvrirait": [
        "rouvrir"
    ],
    "rouvrirent": [
        "rouvrir"
    ],
    "rouvrirez": [
        "rouvrir"
    ],
    "rouvriront": [
        "rouvrir"
    ],
    "rouvris": [
        "rouvrir"
    ],
    "rouvrit": [
        "rouvrir"
    ],
    "rouvrons": [
        "rouvrir"
    ],
    "roux": [
        "roux"
    ],
    "rouee": [
        "roue",
        "rouer"
    ],
    "roy": [
        "roy"
    ],
    "royal": [
        "royal"
    ],
    "royale": [
        "royale",
        "royal"
    ],
    "royalement": [
        "royalement"
    ],
    "royales": [
        "royal"
    ],
    "royaliste": [
        "royaliste"
    ],
    "royalistes": [
        "royaliste"
    ],
    "royalties": [
        "royalties",
        "royalty"
    ],
    "royalty": [
        "royalty"
    ],
    "royaume": [
        "royaume"
    ],
    "royaumes": [
        "royaume"
    ],
    "royaute": [
        "royaute"
    ],
    "royautes": [
        "royaute"
    ],
    "royaux": [
        "royal"
    ],
    "ru": [
        "ru"
    ],
    "rua": [
        "ruer"
    ],
    "ruade": [
        "ruade"
    ],
    "ruades": [
        "ruade"
    ],
    "ruai": [
        "ruer"
    ],
    "ruaient": [
        "ruer"
    ],
    "ruais": [
        "ruer"
    ],
    "ruait": [
        "ruer"
    ],
    "ruant": [
        "ruer"
    ],
    "ruban": [
        "ruban"
    ],
    "rubans": [
        "ruban"
    ],
    "rubato": [
        "rubato"
    ],
    "rubia": [
        "rubia"
    ],
    "rubican": [
        "rubican"
    ],
    "rubicond": [
        "rubicond"
    ],
    "rubiconde": [
        "rubicond"
    ],
    "rubicondes": [
        "rubicond"
    ],
    "rubiconds": [
        "rubicond"
    ],
    "rubis": [
        "rubis"
    ],
    "rubricard": [
        "rubricard"
    ],
    "rubrique": [
        "rubrique"
    ],
    "rubriques": [
        "rubrique"
    ],
    "rubenienne": [
        "rubenien"
    ],
    "rubeole": [
        "rubeole"
    ],
    "ruche": [
        "rucher",
        "ruche"
    ],
    "rucher": [
        "rucher"
    ],
    "ruchers": [
        "rucher"
    ],
    "ruches": [
        "ruche"
    ],
    "ruchee": [
        "ruche"
    ],
    "rucksack": [
        "rucksack"
    ],
    "rude": [
        "rude"
    ],
    "rudement": [
        "rudement"
    ],
    "rudes": [
        "rude"
    ],
    "rudesse": [
        "rudesse"
    ],
    "rudesses": [
        "rudesse"
    ],
    "rudiment": [
        "rudiment"
    ],
    "rudimentaire": [
        "rudimentaire"
    ],
    "rudimentaires": [
        "rudimentaire"
    ],
    "rudiments": [
        "rudiment"
    ],
    "rudoie": [
        "rudoyer"
    ],
    "rudoiement": [
        "rudoiement"
    ],
    "rudoiements": [
        "rudoiement"
    ],
    "rudoient": [
        "rudoyer"
    ],
    "rudoies": [
        "rudoyer"
    ],
    "rudoya": [
        "rudoyer"
    ],
    "rudoyais": [
        "rudoyer"
    ],
    "rudoyait": [
        "rudoyer"
    ],
    "rudoyant": [
        "rudoyer"
    ],
    "rudoyer": [
        "rudoyer"
    ],
    "rudoyerent": [
        "rudoyer"
    ],
    "rudoye": [
        "rudoyer"
    ],
    "rudoyes": [
        "rudoyer"
    ],
    "rue": [
        "rue",
        "ruer"
    ],
    "ruelle": [
        "ruelle"
    ],
    "ruelles": [
        "ruelle"
    ],
    "ruent": [
        "ruer"
    ],
    "ruer": [
        "ruer"
    ],
    "rueront": [
        "ruer"
    ],
    "rues": [
        "rue",
        "ruer"
    ],
    "ruffian": [
        "ruffian"
    ],
    "ruffians": [
        "ruffian"
    ],
    "rufian": [
        "rufian"
    ],
    "rugby": [
        "rugby"
    ],
    "rugbyman": [
        "rugbyman"
    ],
    "rugbymen": [
        "rugbyman"
    ],
    "rugi": [
        "rugir"
    ],
    "rugir": [
        "rugir"
    ],
    "rugiraient": [
        "rugir"
    ],
    "rugirent": [
        "rugir"
    ],
    "rugiront": [
        "rugir"
    ],
    "rugis": [
        "rugir"
    ],
    "rugissaient": [
        "rugir"
    ],
    "rugissait": [
        "rugir"
    ],
    "rugissant": [
        "rugir",
        "rugissant"
    ],
    "rugissante": [
        "rugissant"
    ],
    "rugissantes": [
        "rugissant"
    ],
    "rugissants": [
        "rugissant"
    ],
    "rugisse": [
        "rugir"
    ],
    "rugissement": [
        "rugissement"
    ],
    "rugissements": [
        "rugissement"
    ],
    "rugissent": [
        "rugir"
    ],
    "rugissez": [
        "rugir"
    ],
    "rugit": [
        "rugir"
    ],
    "rugosite": [
        "rugosite"
    ],
    "rugosites": [
        "rugosite"
    ],
    "rugueuse": [
        "rugueux"
    ],
    "rugueuses": [
        "rugueux"
    ],
    "rugueux": [
        "rugueux"
    ],
    "ruina": [
        "ruiner"
    ],
    "ruinaient": [
        "ruiner"
    ],
    "ruinais": [
        "ruiner"
    ],
    "ruinait": [
        "ruiner"
    ],
    "ruinant": [
        "ruiner"
    ],
    "ruine": [
        "ruine",
        "ruiner"
    ],
    "ruinent": [
        "ruiner"
    ],
    "ruiner": [
        "ruiner"
    ],
    "ruinera": [
        "ruiner"
    ],
    "ruinerai": [
        "ruiner"
    ],
    "ruinerais": [
        "ruiner"
    ],
    "ruinerait": [
        "ruiner"
    ],
    "ruineras": [
        "ruiner"
    ],
    "ruinerez": [
        "ruiner"
    ],
    "ruinerons": [
        "ruiner"
    ],
    "ruineront": [
        "ruiner"
    ],
    "ruines": [
        "ruine",
        "ruiner"
    ],
    "ruineuse": [
        "ruineux"
    ],
    "ruineuses": [
        "ruineux"
    ],
    "ruineux": [
        "ruineux"
    ],
    "ruinez": [
        "ruiner"
    ],
    "ruiniez": [
        "ruiner"
    ],
    "ruinat": [
        "ruiner"
    ],
    "ruinee": [
        "ruine",
        "ruiner"
    ],
    "ruinees": [
        "ruine",
        "ruiner"
    ],
    "ruisseau": [
        "ruisseau"
    ],
    "ruisseaux": [
        "ruisseau"
    ],
    "ruissela": [
        "ruisseler"
    ],
    "ruisselaient": [
        "ruisseler"
    ],
    "ruisselait": [
        "ruisseler"
    ],
    "ruisselant": [
        "ruisselant",
        "ruisseler"
    ],
    "ruisselante": [
        "ruisselant"
    ],
    "ruisselantes": [
        "ruisselant"
    ],
    "ruisselants": [
        "ruisselant"
    ],
    "ruisseler": [
        "ruisseler"
    ],
    "ruisselet": [
        "ruisselet"
    ],
    "ruisselets": [
        "ruisselet"
    ],
    "ruisselle": [
        "ruisseler"
    ],
    "ruissellement": [
        "ruissellement"
    ],
    "ruissellements": [
        "ruissellement"
    ],
    "ruissellent": [
        "ruisseler"
    ],
    "ruissellerait": [
        "ruisseler"
    ],
    "ruisselat": [
        "ruisseler"
    ],
    "ruisselerent": [
        "ruisseler"
    ],
    "ruissele": [
        "ruisseler"
    ],
    "ruisson": [
        "ruisson"
    ],
    "rumba": [
        "rumba"
    ],
    "rumbas": [
        "rumba"
    ],
    "rumeur": [
        "rumeur"
    ],
    "rumeurs": [
        "rumeur"
    ],
    "rumina": [
        "ruminer"
    ],
    "ruminaient": [
        "ruminer"
    ],
    "ruminais": [
        "ruminer"
    ],
    "ruminait": [
        "ruminer"
    ],
    "ruminant": [
        "ruminant",
        "ruminer"
    ],
    "ruminante": [
        "ruminant"
    ],
    "ruminants": [
        "ruminant"
    ],
    "rumination": [
        "rumination"
    ],
    "ruminations": [
        "rumination"
    ],
    "rumine": [
        "ruminer"
    ],
    "ruminement": [
        "ruminement"
    ],
    "ruminements": [
        "ruminement"
    ],
    "ruminent": [
        "ruminer"
    ],
    "ruminer": [
        "ruminer"
    ],
    "ruminerez": [
        "ruminer"
    ],
    "rumineront": [
        "ruminer"
    ],
    "ruminee": [
        "ruminer"
    ],
    "ruminees": [
        "ruminer"
    ],
    "rumines": [
        "ruminer"
    ],
    "rumsteck": [
        "rumsteck"
    ],
    "rune": [
        "rune"
    ],
    "runes": [
        "rune"
    ],
    "runique": [
        "runique"
    ],
    "runiques": [
        "runique"
    ],
    "running": [
        "running",
        "run"
    ],
    "ruons": [
        "ruer"
    ],
    "rupestre": [
        "rupestre"
    ],
    "rupestres": [
        "rupestre"
    ],
    "rupin": [
        "rupin"
    ],
    "rupinasse": [
        "rupiner"
    ],
    "rupine": [
        "rupin"
    ],
    "rupines": [
        "rupin"
    ],
    "rupiniez": [
        "rupiner"
    ],
    "rupins": [
        "rupin"
    ],
    "rupteur": [
        "rupteur"
    ],
    "rupture": [
        "rupture"
    ],
    "ruptures": [
        "rupture"
    ],
    "rural": [
        "rural"
    ],
    "rurale": [
        "rural"
    ],
    "rurales": [
        "rural"
    ],
    "ruraux": [
        "rural"
    ],
    "rus": [
        "ru"
    ],
    "rusa": [
        "ruser"
    ],
    "rusais": [
        "ruser"
    ],
    "rusait": [
        "ruser"
    ],
    "rusant": [
        "ruser"
    ],
    "ruse": [
        "ruse",
        "ruser"
    ],
    "rusent": [
        "ruser"
    ],
    "ruser": [
        "ruser"
    ],
    "rusera": [
        "ruser"
    ],
    "ruserai": [
        "ruser"
    ],
    "ruserais": [
        "ruser"
    ],
    "ruses": [
        "ruse",
        "ruser"
    ],
    "rush": [
        "rush"
    ],
    "rushes": [
        "rush"
    ],
    "russe": [
        "russe"
    ],
    "russes": [
        "russ",
        "russe"
    ],
    "russifiant": [
        "russifier"
    ],
    "russification": [
        "russification"
    ],
    "russifie": [
        "russifier"
    ],
    "russifiee": [
        "russifier"
    ],
    "russophone": [
        "russophone"
    ],
    "russules": [
        "russule"
    ],
    "rustaud": [
        "rustaud"
    ],
    "rustaude": [
        "rustaud"
    ],
    "rustaudes": [
        "rustaud"
    ],
    "rustauds": [
        "rustaud"
    ],
    "rusticite": [
        "rusticite"
    ],
    "rustine": [
        "rustine"
    ],
    "rustines": [
        "rustine"
    ],
    "rustique": [
        "rustiquer",
        "rustique"
    ],
    "rustiques": [
        "rustique"
    ],
    "rustre": [
        "rustre"
    ],
    "rustres": [
        "rustre"
    ],
    "rusames": [
        "ruser"
    ],
    "rusee": [
        "ruse",
        "ruser"
    ],
    "rusees": [
        "ruse",
        "ruser"
    ],
    "rut": [
        "rut"
    ],
    "rutabaga": [
        "rutabaga"
    ],
    "rutabagas": [
        "rutabaga"
    ],
    "rutherford": [
        "rutherford"
    ],
    "rutilaient": [
        "rutiler"
    ],
    "rutilait": [
        "rutiler"
    ],
    "rutilances": [
        "rutilance"
    ],
    "rutilant": [
        "rutilant",
        "rutiler"
    ],
    "rutilante": [
        "rutilant"
    ],
    "rutilantes": [
        "rutilant"
    ],
    "rutilants": [
        "rutilant"
    ],
    "rutile": [
        "rutiler"
    ],
    "rutilent": [
        "rutiler"
    ],
    "rutiler": [
        "rutiler"
    ],
    "ruames": [
        "ruer"
    ],
    "ruat": [
        "ruer"
    ],
    "ruerent": [
        "ruer"
    ],
    "ruee": [
        "ruee",
        "ruer"
    ],
    "ruees": [
        "ruee",
        "ruer"
    ],
    "rythmaient": [
        "rythmer"
    ],
    "rythmait": [
        "rythmer"
    ],
    "rythmant": [
        "rythmer"
    ],
    "rythme": [
        "rythme",
        "rythmer"
    ],
    "rythment": [
        "rythmer"
    ],
    "rythmer": [
        "rythmer"
    ],
    "rythmera": [
        "rythmer"
    ],
    "rythmes": [
        "rythme",
        "rythmer"
    ],
    "rythmique": [
        "rythmique"
    ],
    "rythmiquement": [
        "rythmiquement"
    ],
    "rythmiques": [
        "rythmique"
    ],
    "rythmee": [
        "rythme",
        "rythmer"
    ],
    "rythmees": [
        "rythme",
        "rythmer"
    ],
    "rable": [
        "rabler",
        "rable"
    ],
    "rablee": [
        "rable"
    ],
    "rables": [
        "rabler",
        "rable"
    ],
    "rala": [
        "raler"
    ],
    "ralai": [
        "raler"
    ],
    "ralaient": [
        "raler"
    ],
    "ralais": [
        "raler"
    ],
    "ralait": [
        "raler"
    ],
    "ralant": [
        "raler",
        "ralant"
    ],
    "ralante": [
        "ralant"
    ],
    "rale": [
        "raler",
        "rale"
    ],
    "ralement": [
        "ralement"
    ],
    "ralent": [
        "raler"
    ],
    "raler": [
        "raler"
    ],
    "ralera": [
        "raler"
    ],
    "ralerai": [
        "raler"
    ],
    "ralerait": [
        "raler"
    ],
    "rales": [
        "raler",
        "rale"
    ],
    "raleur": [
        "raleur"
    ],
    "raleurs": [
        "raleur"
    ],
    "raleuse": [
        "raleux",
        "raleur"
    ],
    "raleuses": [
        "raleur"
    ],
    "raleux": [
        "raleux"
    ],
    "ralez": [
        "raler"
    ],
    "rapa": [
        "raper"
    ],
    "rapaient": [
        "raper"
    ],
    "rapait": [
        "raper"
    ],
    "rapant": [
        "raper"
    ],
    "rape": [
        "raper",
        "rape"
    ],
    "rapent": [
        "raper"
    ],
    "raper": [
        "raper"
    ],
    "raperait": [
        "raper"
    ],
    "raperas": [
        "raper"
    ],
    "rapes": [
        "raper",
        "rape"
    ],
    "rapeuse": [
        "rapeux"
    ],
    "rapeuses": [
        "rapeux"
    ],
    "rapeux": [
        "rapeux"
    ],
    "rapee": [
        "raper",
        "rape"
    ],
    "rapees": [
        "raper",
        "rape"
    ],
    "rateau": [
        "rateau"
    ],
    "rateaux": [
        "rateau"
    ],
    "ratelait": [
        "rateler"
    ],
    "rateler": [
        "rateler"
    ],
    "ratelier": [
        "ratelier"
    ],
    "rateliers": [
        "ratelier"
    ],
    "ratelees": [
        "rateler"
    ],
    "regle": [
        "regle",
        "regler"
    ],
    "reglement": [
        "reglement"
    ],
    "reglements": [
        "reglement"
    ],
    "reglent": [
        "regler"
    ],
    "regles": [
        "regle",
        "regler"
    ],
    "regne": [
        "regner",
        "regne"
    ],
    "regnent": [
        "regner"
    ],
    "regnes": [
        "regner",
        "regne"
    ],
    "rea": [
        "reer",
        "rea"
    ],
    "reabonnement": [
        "reabonnement"
    ],
    "reabonner": [
        "reabonner"
    ],
    "reabsorption": [
        "reabsorption"
    ],
    "reac": [
        "reac"
    ],
    "reaccoutumer": [
        "reaccoutumer"
    ],
    "reaccoutumerait": [
        "reaccoutumer"
    ],
    "reacheminer": [
        "reacheminer"
    ],
    "reacs": [
        "reac"
    ],
    "reactant": [
        "reactant"
    ],
    "reacteur": [
        "reacteur"
    ],
    "reacteurs": [
        "reacteur"
    ],
    "reactif": [
        "reactif"
    ],
    "reactifs": [
        "reactif"
    ],
    "reaction": [
        "reaction"
    ],
    "reactionnaire": [
        "reactionnaire"
    ],
    "reactionnaires": [
        "reactionnaire"
    ],
    "reactionnel": [
        "reactionnel"
    ],
    "reactions": [
        "reaction"
    ],
    "reactiva": [
        "reactiver"
    ],
    "reactivait": [
        "reactiver"
    ],
    "reactivation": [
        "reactivation"
    ],
    "reactive": [
        "reactiver",
        "reactif"
    ],
    "reactiver": [
        "reactiver"
    ],
    "reactiveront": [
        "reactiver"
    ],
    "reactives": [
        "reactiver",
        "reactif"
    ],
    "reactivez": [
        "reactiver"
    ],
    "reactiviez": [
        "reactiver"
    ],
    "reactivite": [
        "reactivite"
    ],
    "reactivee": [
        "reactiver"
    ],
    "reactivees": [
        "reactiver"
    ],
    "reactualisation": [
        "reactualisation"
    ],
    "reactualise": [
        "reactualiser"
    ],
    "reactualiser": [
        "reactualiser"
    ],
    "readaptait": [
        "readapter"
    ],
    "readaptant": [
        "readapter"
    ],
    "readaptation": [
        "readaptation"
    ],
    "readapte": [
        "readapter"
    ],
    "readapter": [
        "readapter"
    ],
    "readmis": [
        "readmettre"
    ],
    "readmise": [
        "readmettre"
    ],
    "readmission": [
        "readmission"
    ],
    "readopter": [
        "readopter"
    ],
    "reaffectait": [
        "reaffecter"
    ],
    "reaffectation": [
        "reaffectation"
    ],
    "reaffecter": [
        "reaffecter"
    ],
    "reaffectons": [
        "reaffecter"
    ],
    "reaffecte": [
        "reaffecter"
    ],
    "reaffectee": [
        "reaffecter"
    ],
    "reaffectes": [
        "reaffecter"
    ],
    "reaffichees": [
        "reafficher"
    ],
    "reaffirmai": [
        "reaffirmer"
    ],
    "reaffirmaient": [
        "reaffirmer"
    ],
    "reaffirmait": [
        "reaffirmer"
    ],
    "reaffirmation": [
        "reaffirmation"
    ],
    "reaffirme": [
        "reaffirmer"
    ],
    "reaffirmer": [
        "reaffirmer"
    ],
    "reaffirmee": [
        "reaffirmer"
    ],
    "reaffutee": [
        "reaffuter"
    ],
    "reagencement": [
        "reagencement"
    ],
    "reagi": [
        "reagir"
    ],
    "reagir": [
        "reagir"
    ],
    "reagira": [
        "reagir"
    ],
    "reagirai": [
        "reagir"
    ],
    "reagiraient": [
        "reagir"
    ],
    "reagirais": [
        "reagir"
    ],
    "reagirait": [
        "reagir"
    ],
    "reagiras": [
        "reagir"
    ],
    "reagirent": [
        "reagir"
    ],
    "reagirez": [
        "reagir"
    ],
    "reagiriez": [
        "reagir"
    ],
    "reagirons": [
        "reagir"
    ],
    "reagiront": [
        "reagir"
    ],
    "reagis": [
        "reagir"
    ],
    "reagissaient": [
        "reagir"
    ],
    "reagissais": [
        "reagir"
    ],
    "reagissait": [
        "reagir"
    ],
    "reagissant": [
        "reagir"
    ],
    "reagissante": [
        "reagissant"
    ],
    "reagisse": [
        "reagir"
    ],
    "reagissent": [
        "reagir"
    ],
    "reagisses": [
        "reagir"
    ],
    "reagissez": [
        "reagir"
    ],
    "reagissiez": [
        "reagir"
    ],
    "reagissions": [
        "reagir"
    ],
    "reagissons": [
        "reagir"
    ],
    "reagit": [
        "reagir"
    ],
    "reait": [
        "reer"
    ],
    "reajusta": [
        "reajuster"
    ],
    "reajustaient": [
        "reajuster"
    ],
    "reajustait": [
        "reajuster"
    ],
    "reajustant": [
        "reajuster"
    ],
    "reajuste": [
        "reajuster"
    ],
    "reajustement": [
        "reajustement"
    ],
    "reajustements": [
        "reajustement"
    ],
    "reajuster": [
        "reajuster"
    ],
    "reajustees": [
        "reajuster"
    ],
    "reajustes": [
        "reajuster"
    ],
    "real": [
        "real"
    ],
    "realigne": [
        "realigner"
    ],
    "realignement": [
        "realignement"
    ],
    "realigner": [
        "realigner"
    ],
    "realimenter": [
        "realimenter"
    ],
    "realisa": [
        "realiser"
    ],
    "realisable": [
        "realisable"
    ],
    "realisables": [
        "realisable"
    ],
    "realisai": [
        "realiser"
    ],
    "realisaient": [
        "realiser"
    ],
    "realisais": [
        "realiser"
    ],
    "realisait": [
        "realiser"
    ],
    "realisant": [
        "realiser"
    ],
    "realisateur": [
        "realisateur"
    ],
    "realisateurs": [
        "realisateur"
    ],
    "realisation": [
        "realisation"
    ],
    "realisations": [
        "realisation"
    ],
    "realisatrice": [
        "realisateur"
    ],
    "realisatrices": [
        "realisateur"
    ],
    "realise": [
        "realiser",
        "realise"
    ],
    "realisent": [
        "realiser"
    ],
    "realiser": [
        "realiser"
    ],
    "realisera": [
        "realiser"
    ],
    "realiserai": [
        "realiser"
    ],
    "realiseraient": [
        "realiser"
    ],
    "realiserais": [
        "realiser"
    ],
    "realiserait": [
        "realiser"
    ],
    "realiseras": [
        "realiser"
    ],
    "realiserez": [
        "realiser"
    ],
    "realiserions": [
        "realiser"
    ],
    "realiseront": [
        "realiser"
    ],
    "realises": [
        "realiser",
        "realise"
    ],
    "realisez": [
        "realiser"
    ],
    "realisiez": [
        "realiser"
    ],
    "realisions": [
        "realiser"
    ],
    "realisme": [
        "realisme"
    ],
    "realisons": [
        "realiser"
    ],
    "realiste": [
        "realiste"
    ],
    "realistes": [
        "realiste"
    ],
    "realisames": [
        "realiser"
    ],
    "realisat": [
        "realiser"
    ],
    "realiserent": [
        "realiser"
    ],
    "realisee": [
        "realiser",
        "realise"
    ],
    "realisees": [
        "realiser",
        "realise"
    ],
    "realite": [
        "realite"
    ],
    "realites": [
        "realite"
    ],
    "reamorce": [
        "reamorcer"
    ],
    "reamorcent": [
        "reamorcer"
    ],
    "reamorcer": [
        "reamorcer"
    ],
    "reamorcage": [
        "reamorcage"
    ],
    "reamorcait": [
        "reamorcer"
    ],
    "reamenageait": [
        "reamenager"
    ],
    "reamenagement": [
        "reamenagement"
    ],
    "reamenagements": [
        "reamenagement"
    ],
    "reamenager": [
        "reamenager"
    ],
    "reamenage": [
        "reamenager"
    ],
    "reanimait": [
        "reanimer"
    ],
    "reanimateur": [
        "reanimateur"
    ],
    "reanimation": [
        "reanimation"
    ],
    "reanime": [
        "reanimer"
    ],
    "reanimer": [
        "reanimer"
    ],
    "reanimeraient": [
        "reanimer"
    ],
    "reanimez": [
        "reanimer"
    ],
    "reanimions": [
        "reanimer"
    ],
    "reanimee": [
        "reanimer"
    ],
    "reapercevoir": [
        "reapercevoir"
    ],
    "reapparais": [
        "reapparaitre"
    ],
    "reapparaissaient": [
        "reapparaitre"
    ],
    "reapparaissais": [
        "reapparaitre"
    ],
    "reapparaissait": [
        "reapparaitre"
    ],
    "reapparaissant": [
        "reapparaitre"
    ],
    "reapparaisse": [
        "reapparaitre"
    ],
    "reapparaissent": [
        "reapparaitre"
    ],
    "reapparaisses": [
        "reapparaitre"
    ],
    "reapparait": [
        "reapparaitre"
    ],
    "reapparaitra": [
        "reapparaitre"
    ],
    "reapparaitrai": [
        "reapparaitre"
    ],
    "reapparaitraient": [
        "reapparaitre"
    ],
    "reapparaitrait": [
        "reapparaitre"
    ],
    "reapparaitre": [
        "reapparaitre"
    ],
    "reapparaitront": [
        "reapparaitre"
    ],
    "reapparition": [
        "reapparition"
    ],
    "reapparitions": [
        "reapparition"
    ],
    "reapparu": [
        "reapparaitre"
    ],
    "reapparue": [
        "reapparaitre"
    ],
    "reapparues": [
        "reapparaitre"
    ],
    "reapparurent": [
        "reapparaitre"
    ],
    "reapparus": [
        "reapparaitre"
    ],
    "reapparut": [
        "reapparaitre"
    ],
    "reappeler": [
        "reappeler"
    ],
    "reapprenaient": [
        "reapprendre"
    ],
    "reapprenais": [
        "reapprendre"
    ],
    "reapprenait": [
        "reapprendre"
    ],
    "reapprend": [
        "reapprendre"
    ],
    "reapprendraient": [
        "reapprendre"
    ],
    "reapprendre": [
        "reapprendre"
    ],
    "reapprendrez": [
        "reapprendre"
    ],
    "reapprends": [
        "reapprendre"
    ],
    "reapprenne": [
        "reapprendre"
    ],
    "reappris": [
        "reapprendre"
    ],
    "reapprises": [
        "reapprendre"
    ],
    "reapprit": [
        "reapprendre"
    ],
    "reapprovisionne": [
        "reapprovisionner"
    ],
    "reapprovisionnement": [
        "reapprovisionnement"
    ],
    "reapprovisionner": [
        "reapprovisionner"
    ],
    "reapprovisionnerait": [
        "reapprovisionner"
    ],
    "reapprovisionnee": [
        "reapprovisionner"
    ],
    "reargenter": [
        "reargenter"
    ],
    "rearma": [
        "rearmer"
    ],
    "rearmant": [
        "rearmer"
    ],
    "rearme": [
        "rearmer"
    ],
    "rearmement": [
        "rearmement"
    ],
    "rearmer": [
        "rearmer"
    ],
    "rearmees": [
        "rearmer"
    ],
    "rearrange": [
        "rearranger"
    ],
    "rearrangeait": [
        "rearranger"
    ],
    "rearrangeant": [
        "rearranger"
    ],
    "rearrangement": [
        "rearrangement"
    ],
    "rearrangent": [
        "rearranger"
    ],
    "rearranger": [
        "rearranger"
    ],
    "reassembler": [
        "reassembler"
    ],
    "reassignation": [
        "reassignation"
    ],
    "reassigner": [
        "reassigner"
    ],
    "reassigneront": [
        "reassigner"
    ],
    "reassigne": [
        "reassigner"
    ],
    "reassimile": [
        "reassimiler"
    ],
    "reassorties": [
        "reassortir"
    ],
    "reassortir": [
        "reassortir"
    ],
    "reassumer": [
        "reassumer"
    ],
    "reassurer": [
        "reassurer"
    ],
    "reattaquai": [
        "reattaquer"
    ],
    "reattaquait": [
        "reattaquer"
    ],
    "reattaque": [
        "reattaquer"
    ],
    "reattaquer": [
        "reattaquer"
    ],
    "reaux": [
        "real"
    ],
    "rebarbatif": [
        "rebarbatif"
    ],
    "rebarbatifs": [
        "rebarbatif"
    ],
    "rebarbative": [
        "rebarbatif"
    ],
    "rebarbatives": [
        "rebarbatif"
    ],
    "rebecca": [
        "rebecca"
    ],
    "rebellion": [
        "rebellion"
    ],
    "rebellions": [
        "rebellion"
    ],
    "recalcitrant": [
        "recalcitrant"
    ],
    "recalcitrante": [
        "recalcitrant"
    ],
    "recalcitrantes": [
        "recalcitrant"
    ],
    "recalcitrants": [
        "recalcitrant"
    ],
    "recapitula": [
        "recapituler"
    ],
    "recapitulai": [
        "recapituler"
    ],
    "recapitulais": [
        "recapituler"
    ],
    "recapitulait": [
        "recapituler"
    ],
    "recapitulant": [
        "recapituler"
    ],
    "recapitulatif": [
        "recapitulatif"
    ],
    "recapitulation": [
        "recapitulation"
    ],
    "recapitule": [
        "recapituler"
    ],
    "recapitulent": [
        "recapituler"
    ],
    "recapituler": [
        "recapituler"
    ],
    "recapitulez": [
        "recapituler"
    ],
    "recapitulions": [
        "recapituler"
    ],
    "recapitulons": [
        "recapituler"
    ],
    "recapitulee": [
        "recapituler"
    ],
    "recemment": [
        "recemment"
    ],
    "recent": [
        "recent"
    ],
    "recente": [
        "recent"
    ],
    "recentes": [
        "recent"
    ],
    "recents": [
        "recent"
    ],
    "receptacle": [
        "receptacle"
    ],
    "receptacles": [
        "receptacle"
    ],
    "recepteur": [
        "recepteur"
    ],
    "recepteurs": [
        "recepteur"
    ],
    "receptif": [
        "receptif"
    ],
    "receptifs": [
        "receptif"
    ],
    "reception": [
        "reception"
    ],
    "receptionna": [
        "receptionner"
    ],
    "receptionnant": [
        "receptionner"
    ],
    "receptionne": [
        "receptionner"
    ],
    "receptionnent": [
        "receptionner"
    ],
    "receptionner": [
        "receptionner"
    ],
    "receptionnera": [
        "receptionner"
    ],
    "receptionniste": [
        "receptionniste"
    ],
    "receptionnistes": [
        "receptionniste"
    ],
    "receptionnees": [
        "receptionner"
    ],
    "receptions": [
        "reception"
    ],
    "receptive": [
        "receptif"
    ],
    "receptives": [
        "receptif"
    ],
    "receptivite": [
        "receptivite"
    ],
    "receptrice": [
        "recepteur"
    ],
    "recessif": [
        "recessif"
    ],
    "recessifs": [
        "recessif"
    ],
    "recession": [
        "recession"
    ],
    "recessive": [
        "recessif"
    ],
    "rechappai": [
        "rechapper"
    ],
    "rechappais": [
        "rechapper"
    ],
    "rechappait": [
        "rechapper"
    ],
    "rechappe": [
        "rechapper",
        "rechappe"
    ],
    "rechappent": [
        "rechapper"
    ],
    "rechapper": [
        "rechapper"
    ],
    "rechappera": [
        "rechapper"
    ],
    "rechapperaient": [
        "rechapper"
    ],
    "rechapperais": [
        "rechapper"
    ],
    "rechapperait": [
        "rechapper"
    ],
    "rechappes": [
        "rechapper",
        "rechappe"
    ],
    "rechappez": [
        "rechapper"
    ],
    "rechappons": [
        "rechapper"
    ],
    "rechaud": [
        "rechaud"
    ],
    "rechauds": [
        "rechaud"
    ],
    "rechauffa": [
        "rechauffer"
    ],
    "rechauffage": [
        "rechauffage"
    ],
    "rechauffai": [
        "rechauffer"
    ],
    "rechauffaient": [
        "rechauffer"
    ],
    "rechauffais": [
        "rechauffer"
    ],
    "rechauffait": [
        "rechauffer"
    ],
    "rechauffant": [
        "rechauffer"
    ],
    "rechauffante": [
        "rechauffant"
    ],
    "rechauffantes": [
        "rechauffant"
    ],
    "rechauffants": [
        "rechauffant"
    ],
    "rechauffe": [
        "rechauffe",
        "rechauffer"
    ],
    "rechauffement": [
        "rechauffement"
    ],
    "rechauffent": [
        "rechauffer"
    ],
    "rechauffer": [
        "rechauffer"
    ],
    "rechauffera": [
        "rechauffer"
    ],
    "rechaufferai": [
        "rechauffer"
    ],
    "rechaufferait": [
        "rechauffer"
    ],
    "rechaufferas": [
        "rechauffer"
    ],
    "rechaufferez": [
        "rechauffer"
    ],
    "rechaufferont": [
        "rechauffer"
    ],
    "rechauffeur": [
        "rechauffeur"
    ],
    "rechauffez": [
        "rechauffer"
    ],
    "rechauffions": [
        "rechauffer"
    ],
    "rechauffons": [
        "rechauffer"
    ],
    "rechauffat": [
        "rechauffer"
    ],
    "rechaufferent": [
        "rechauffer"
    ],
    "rechauffee": [
        "rechauffe",
        "rechauffer"
    ],
    "rechauffees": [
        "rechauffe",
        "rechauffer"
    ],
    "rechauffes": [
        "rechauffe",
        "rechauffer"
    ],
    "recidivai": [
        "recidiver"
    ],
    "recidivaient": [
        "recidiver"
    ],
    "recidivant": [
        "recidivant"
    ],
    "recidivante": [
        "recidivant"
    ],
    "recidive": [
        "recidiver",
        "recidive"
    ],
    "recidiver": [
        "recidiver"
    ],
    "recidiveras": [
        "recidiver"
    ],
    "recidives": [
        "recidiver",
        "recidive"
    ],
    "recidivez": [
        "recidiver"
    ],
    "recidiviste": [
        "recidiviste"
    ],
    "recidivistes": [
        "recidiviste"
    ],
    "recif": [
        "recif"
    ],
    "recifale": [
        "recifal"
    ],
    "recifs": [
        "recif"
    ],
    "recipiendaire": [
        "recipiendaire"
    ],
    "recipiendaires": [
        "recipiendaire"
    ],
    "recipient": [
        "recipient"
    ],
    "recipients": [
        "recipient"
    ],
    "reciprocite": [
        "reciprocite"
    ],
    "reciproque": [
        "reciproque"
    ],
    "reciproquement": [
        "reciproquement"
    ],
    "reciproques": [
        "reciproque",
        "reciproquer"
    ],
    "recit": [
        "recit"
    ],
    "recita": [
        "reciter"
    ],
    "recitai": [
        "reciter"
    ],
    "recitaient": [
        "reciter"
    ],
    "recitais": [
        "reciter"
    ],
    "recitait": [
        "reciter"
    ],
    "recital": [
        "recital"
    ],
    "recitals": [
        "recital"
    ],
    "recitant": [
        "reciter",
        "recitant"
    ],
    "recitante": [
        "recitant"
    ],
    "recitants": [
        "recitant"
    ],
    "recitassent": [
        "reciter"
    ],
    "recitatif": [
        "recitatif"
    ],
    "recitatifs": [
        "recitatif"
    ],
    "recitation": [
        "recitation"
    ],
    "recitations": [
        "recitation"
    ],
    "recite": [
        "reciter"
    ],
    "recitent": [
        "reciter"
    ],
    "reciter": [
        "reciter"
    ],
    "recitera": [
        "reciter"
    ],
    "reciterai": [
        "reciter"
    ],
    "reciteraient": [
        "reciter"
    ],
    "reciterait": [
        "reciter"
    ],
    "reciteras": [
        "reciter"
    ],
    "reciterez": [
        "reciter"
    ],
    "reciterons": [
        "reciter"
    ],
    "reciteront": [
        "reciter"
    ],
    "recites": [
        "recite",
        "reciter"
    ],
    "recitez": [
        "reciter"
    ],
    "recitions": [
        "reciter"
    ],
    "recitons": [
        "reciter"
    ],
    "recits": [
        "recit"
    ],
    "reciterent": [
        "reciter"
    ],
    "recitee": [
        "reciter"
    ],
    "recitees": [
        "reciter"
    ],
    "reclama": [
        "reclamer"
    ],
    "reclamai": [
        "reclamer"
    ],
    "reclamaient": [
        "reclamer"
    ],
    "reclamais": [
        "reclamer"
    ],
    "reclamait": [
        "reclamer"
    ],
    "reclamant": [
        "reclamer"
    ],
    "reclamantes": [
        "reclamant"
    ],
    "reclamation": [
        "reclamation"
    ],
    "reclamations": [
        "reclamation"
    ],
    "reclame": [
        "reclamer",
        "reclame"
    ],
    "reclament": [
        "reclamer"
    ],
    "reclamer": [
        "reclamer"
    ],
    "reclamera": [
        "reclamer"
    ],
    "reclamerai": [
        "reclamer"
    ],
    "reclameraient": [
        "reclamer"
    ],
    "reclamerais": [
        "reclamer"
    ],
    "reclamerait": [
        "reclamer"
    ],
    "reclameras": [
        "reclamer"
    ],
    "reclamerez": [
        "reclamer"
    ],
    "reclameriez": [
        "reclamer"
    ],
    "reclamerons": [
        "reclamer"
    ],
    "reclameront": [
        "reclamer"
    ],
    "reclames": [
        "reclamer",
        "reclame"
    ],
    "reclamez": [
        "reclamer"
    ],
    "reclamiez": [
        "reclamer"
    ],
    "reclamions": [
        "reclamer"
    ],
    "reclamons": [
        "reclamer"
    ],
    "reclamerent": [
        "reclamer"
    ],
    "reclamee": [
        "reclamer"
    ],
    "reclamees": [
        "reclamer"
    ],
    "reclusion": [
        "reclusion"
    ],
    "reclusionnaires": [
        "reclusionnaire"
    ],
    "reclusions": [
        "reclusion"
    ],
    "recollet": [
        "recollet"
    ],
    "recollets": [
        "recollet"
    ],
    "recolta": [
        "recolter"
    ],
    "recoltable": [
        "recoltable"
    ],
    "recoltai": [
        "recolter"
    ],
    "recoltaient": [
        "recolter"
    ],
    "recoltais": [
        "recolter"
    ],
    "recoltait": [
        "recolter"
    ],
    "recoltant": [
        "recoltant",
        "recolter"
    ],
    "recolte": [
        "recolte",
        "recolter"
    ],
    "recoltent": [
        "recolter"
    ],
    "recolter": [
        "recolter"
    ],
    "recoltera": [
        "recolter"
    ],
    "recolterai": [
        "recolter"
    ],
    "recolteraient": [
        "recolter"
    ],
    "recolterais": [
        "recolter"
    ],
    "recolterait": [
        "recolter"
    ],
    "recolteras": [
        "recolter"
    ],
    "recolterons": [
        "recolter"
    ],
    "recolteront": [
        "recolter"
    ],
    "recoltes": [
        "recolte",
        "recolter"
    ],
    "recolteurs": [
        "recolteur"
    ],
    "recolteuse": [
        "recolteur"
    ],
    "recoltez": [
        "recolter"
    ],
    "recoltions": [
        "recolter"
    ],
    "recoltons": [
        "recolter"
    ],
    "recoltee": [
        "recolter"
    ],
    "recoltees": [
        "recolter"
    ],
    "recompensa": [
        "recompenser"
    ],
    "recompensaient": [
        "recompenser"
    ],
    "recompensait": [
        "recompenser"
    ],
    "recompensant": [
        "recompenser"
    ],
    "recompense": [
        "recompense",
        "recompenser"
    ],
    "recompensent": [
        "recompenser"
    ],
    "recompenser": [
        "recompenser"
    ],
    "recompensera": [
        "recompenser"
    ],
    "recompenserai": [
        "recompenser"
    ],
    "recompenserais": [
        "recompenser"
    ],
    "recompenserons": [
        "recompenser"
    ],
    "recompenseront": [
        "recompenser"
    ],
    "recompenses": [
        "recompense",
        "recompenser"
    ],
    "recompensez": [
        "recompenser"
    ],
    "recompensons": [
        "recompenser"
    ],
    "recompenserent": [
        "recompenser"
    ],
    "recompensee": [
        "recompenser"
    ],
    "recompensees": [
        "recompenser"
    ],
    "reconcilia": [
        "reconcilier"
    ],
    "reconciliaient": [
        "reconcilier"
    ],
    "reconciliait": [
        "reconcilier"
    ],
    "reconciliant": [
        "reconcilier"
    ],
    "reconciliateur": [
        "reconciliateur"
    ],
    "reconciliation": [
        "reconciliation"
    ],
    "reconciliations": [
        "reconciliation"
    ],
    "reconciliatrice": [
        "reconciliateur"
    ],
    "reconcilie": [
        "reconcilier"
    ],
    "reconcilient": [
        "reconcilier"
    ],
    "reconcilier": [
        "reconcilier"
    ],
    "reconciliera": [
        "reconcilier"
    ],
    "reconcilierai": [
        "reconcilier"
    ],
    "reconcilieraient": [
        "reconcilier"
    ],
    "reconcilierait": [
        "reconcilier"
    ],
    "reconcilierez": [
        "reconcilier"
    ],
    "reconciliez": [
        "reconcilier"
    ],
    "reconciliions": [
        "reconcilier"
    ],
    "reconcilions": [
        "reconcilier"
    ],
    "reconciliames": [
        "reconcilier"
    ],
    "reconciliee": [
        "reconcilier"
    ],
    "reconciliees": [
        "reconcilier"
    ],
    "reconcilies": [
        "reconcilier"
    ],
    "reconfort": [
        "reconfort"
    ],
    "reconforta": [
        "reconforter"
    ],
    "reconfortaient": [
        "reconforter"
    ],
    "reconfortait": [
        "reconforter"
    ],
    "reconfortant": [
        "reconfortant",
        "reconforter"
    ],
    "reconfortante": [
        "reconfortant"
    ],
    "reconfortantes": [
        "reconfortant"
    ],
    "reconfortants": [
        "reconfortant"
    ],
    "reconforte": [
        "reconforter"
    ],
    "reconfortent": [
        "reconforter"
    ],
    "reconforter": [
        "reconforter"
    ],
    "reconfortera": [
        "reconforter"
    ],
    "reconforterai": [
        "reconforter"
    ],
    "reconforterait": [
        "reconforter"
    ],
    "reconforteras": [
        "reconforter"
    ],
    "reconforterez": [
        "reconforter"
    ],
    "reconfortez": [
        "reconforter"
    ],
    "reconforts": [
        "reconfort"
    ],
    "reconfortee": [
        "reconforter"
    ],
    "reconfortes": [
        "reconforter"
    ],
    "recri": [
        "recri"
    ],
    "recria": [
        "recrier"
    ],
    "recriai": [
        "recrier"
    ],
    "recriaient": [
        "recrier"
    ],
    "recriait": [
        "recrier"
    ],
    "recrie": [
        "recrier"
    ],
    "recrient": [
        "recrier"
    ],
    "recrier": [
        "recrier"
    ],
    "recriminait": [
        "recriminer"
    ],
    "recrimination": [
        "recrimination"
    ],
    "recriminations": [
        "recrimination"
    ],
    "recriminer": [
        "recriminer"
    ],
    "recrirai": [
        "recrire"
    ],
    "recrire": [
        "recrire"
    ],
    "recris": [
        "recrire",
        "recri"
    ],
    "recrit": [
        "recrire"
    ],
    "recrites": [
        "recrire"
    ],
    "recrivent": [
        "recrire"
    ],
    "recrivit": [
        "recrire"
    ],
    "recrierent": [
        "recrier"
    ],
    "recriee": [
        "recrier"
    ],
    "recriees": [
        "recrier"
    ],
    "recries": [
        "recrier"
    ],
    "recre": [
        "recre"
    ],
    "recreatif": [
        "recreatif"
    ],
    "recreations": [
        "recreation"
    ],
    "recreative": [
        "recreatif"
    ],
    "recreatives": [
        "recreatif"
    ],
    "recres": [
        "recre"
    ],
    "recup": [
        "recup"
    ],
    "recupe": [
        "recup"
    ],
    "recupere": [
        "recuperer"
    ],
    "recuperent": [
        "recuperer"
    ],
    "recuperes": [
        "recuperer"
    ],
    "recupera": [
        "recuperer"
    ],
    "recuperable": [
        "recuperable"
    ],
    "recuperables": [
        "recuperable"
    ],
    "recuperai": [
        "recuperer"
    ],
    "recuperaient": [
        "recuperer"
    ],
    "recuperais": [
        "recuperer"
    ],
    "recuperait": [
        "recuperer"
    ],
    "recuperant": [
        "recuperer"
    ],
    "recuperateur": [
        "recuperateur"
    ],
    "recuperateurs": [
        "recuperateur"
    ],
    "recuperation": [
        "recuperation"
    ],
    "recuperations": [
        "recuperation"
    ],
    "recuperer": [
        "recuperer"
    ],
    "recuperera": [
        "recuperer"
    ],
    "recupererai": [
        "recuperer"
    ],
    "recupererais": [
        "recuperer"
    ],
    "recupererait": [
        "recuperer"
    ],
    "recupereras": [
        "recuperer"
    ],
    "recupererez": [
        "recuperer"
    ],
    "recupererons": [
        "recuperer"
    ],
    "recupereront": [
        "recuperer"
    ],
    "recuperez": [
        "recuperer"
    ],
    "recuperiez": [
        "recuperer"
    ],
    "recuperions": [
        "recuperer"
    ],
    "recuperons": [
        "recuperer"
    ],
    "recuperames": [
        "recuperer"
    ],
    "recupererent": [
        "recuperer"
    ],
    "recuperee": [
        "recuperer"
    ],
    "recuperees": [
        "recuperer"
    ],
    "recurage": [
        "recurage"
    ],
    "recuraient": [
        "recurer"
    ],
    "recurais": [
        "recurer"
    ],
    "recurait": [
        "recurer"
    ],
    "recurant": [
        "recurer"
    ],
    "recure": [
        "recurer"
    ],
    "recurer": [
        "recurer"
    ],
    "recurerai": [
        "recurer"
    ],
    "recurrence": [
        "recurrence"
    ],
    "recurrences": [
        "recurrence"
    ],
    "recurrent": [
        "recurrent"
    ],
    "recurrente": [
        "recurrent"
    ],
    "recurrentes": [
        "recurrent"
    ],
    "recurrents": [
        "recurrent"
    ],
    "recursif": [
        "recursif"
    ],
    "recuree": [
        "recurer"
    ],
    "recurees": [
        "recurer"
    ],
    "recures": [
        "recurer"
    ],
    "recusa": [
        "recuser"
    ],
    "recusable": [
        "recusable"
    ],
    "recusables": [
        "recusable"
    ],
    "recusaient": [
        "recuser"
    ],
    "recusais": [
        "recuser"
    ],
    "recusait": [
        "recuser"
    ],
    "recusant": [
        "recuser"
    ],
    "recusation": [
        "recusation"
    ],
    "recusations": [
        "recusation"
    ],
    "recuse": [
        "recuser"
    ],
    "recuser": [
        "recuser"
    ],
    "recuserait": [
        "recuser"
    ],
    "recuserons": [
        "recuser"
    ],
    "recusons": [
        "recuser"
    ],
    "recuserent": [
        "recuser"
    ],
    "recusee": [
        "recuser"
    ],
    "recepisse": [
        "recepisse"
    ],
    "redacteur": [
        "redacteur"
    ],
    "redacteurs": [
        "redacteur"
    ],
    "redaction": [
        "redaction"
    ],
    "redactionnel": [
        "redactionnel"
    ],
    "redactionnelle": [
        "redactionnel"
    ],
    "redactions": [
        "redaction"
    ],
    "redactrice": [
        "redacteur"
    ],
    "redactrices": [
        "redacteur"
    ],
    "redempteur": [
        "redempteur"
    ],
    "redemption": [
        "redemption"
    ],
    "redemptions": [
        "redemption"
    ],
    "redemptoriste": [
        "redemptoriste"
    ],
    "redemptrice": [
        "redempteur"
    ],
    "redhibition": [
        "redhibition"
    ],
    "redhibitoire": [
        "redhibitoire"
    ],
    "redhibitoires": [
        "redhibitoire"
    ],
    "redige": [
        "rediger"
    ],
    "redigea": [
        "rediger"
    ],
    "redigeai": [
        "rediger"
    ],
    "redigeaient": [
        "rediger"
    ],
    "redigeais": [
        "rediger"
    ],
    "redigeait": [
        "rediger"
    ],
    "redigeant": [
        "rediger"
    ],
    "redigent": [
        "rediger"
    ],
    "redigeons": [
        "rediger"
    ],
    "rediger": [
        "rediger"
    ],
    "redigera": [
        "rediger"
    ],
    "redigerai": [
        "rediger"
    ],
    "redigerais": [
        "rediger"
    ],
    "redigeras": [
        "rediger"
    ],
    "redigerez": [
        "rediger"
    ],
    "rediges": [
        "rediger"
    ],
    "redigez": [
        "rediger"
    ],
    "redigiez": [
        "rediger"
    ],
    "redigions": [
        "rediger"
    ],
    "redigerent": [
        "rediger"
    ],
    "redigee": [
        "rediger"
    ],
    "redigees": [
        "rediger"
    ],
    "redimaient": [
        "redimer"
    ],
    "reducteur": [
        "reducteur"
    ],
    "reducteurs": [
        "reducteur"
    ],
    "reduction": [
        "reduction"
    ],
    "reductionnisme": [
        "reductionnisme"
    ],
    "reductionniste": [
        "reductionniste"
    ],
    "reductions": [
        "reduction"
    ],
    "reduira": [
        "reduire"
    ],
    "reduirai": [
        "reduire"
    ],
    "reduiraient": [
        "reduire"
    ],
    "reduirait": [
        "reduire"
    ],
    "reduire": [
        "reduire"
    ],
    "reduirons": [
        "reduire"
    ],
    "reduiront": [
        "reduire"
    ],
    "reduis": [
        "reduire"
    ],
    "reduisaient": [
        "reduire"
    ],
    "reduisais": [
        "reduire"
    ],
    "reduisait": [
        "reduire"
    ],
    "reduisant": [
        "reduire"
    ],
    "reduise": [
        "reduire"
    ],
    "reduisent": [
        "reduire"
    ],
    "reduises": [
        "reduire"
    ],
    "reduisez": [
        "reduire"
    ],
    "reduisions": [
        "reduire"
    ],
    "reduisirent": [
        "reduire"
    ],
    "reduisis": [
        "reduire"
    ],
    "reduisit": [
        "reduire"
    ],
    "reduisons": [
        "reduire"
    ],
    "reduit": [
        "reduit",
        "reduire"
    ],
    "reduite": [
        "reduit",
        "reduire"
    ],
    "reduites": [
        "reduit",
        "reduire"
    ],
    "reduits": [
        "reduit",
        "reduire"
    ],
    "reduplication": [
        "reduplication"
    ],
    "reel": [
        "reel"
    ],
    "reelle": [
        "reel"
    ],
    "reellement": [
        "reellement"
    ],
    "reelles": [
        "reel"
    ],
    "reels": [
        "reel"
    ],
    "reemballer": [
        "reemballer"
    ],
    "reembarque": [
        "reembarquer"
    ],
    "reembarquement": [
        "reembarquement"
    ],
    "reembarquer": [
        "reembarquer"
    ],
    "reembauche": [
        "reembaucher"
    ],
    "reembaucher": [
        "reembaucher"
    ],
    "reemploi": [
        "reemploi"
    ],
    "reemployant": [
        "reemployer"
    ],
    "reemployer": [
        "reemployer"
    ],
    "reemprunter": [
        "reemprunter"
    ],
    "reencadrer": [
        "reencadrer"
    ],
    "reenclenches": [
        "reenclencher"
    ],
    "reendossant": [
        "reendosser"
    ],
    "reendosser": [
        "reendosser"
    ],
    "reengage": [
        "reengager"
    ],
    "reengagement": [
        "reengagement"
    ],
    "reengager": [
        "reengager"
    ],
    "reengagees": [
        "reengager"
    ],
    "reenregistrer": [
        "reenregistrer"
    ],
    "reenregistre": [
        "reenregistrer"
    ],
    "reentendaient": [
        "reentendre"
    ],
    "reentendais": [
        "reentendre"
    ],
    "reentendons": [
        "reentendre"
    ],
    "reentendre": [
        "reentendre"
    ],
    "reentends": [
        "reentendre"
    ],
    "reentendu": [
        "reentendre"
    ],
    "reenterrer": [
        "reenterrer"
    ],
    "reentrainer": [
        "reentrainer"
    ],
    "reenvahir": [
        "reenvahir"
    ],
    "reenvisager": [
        "reenvisager"
    ],
    "reessaie": [
        "reessayer"
    ],
    "reessaient": [
        "reessayer"
    ],
    "reessaiera": [
        "reessayer"
    ],
    "reessaierai": [
        "reessayer"
    ],
    "reessaieras": [
        "reessayer"
    ],
    "reessaieront": [
        "reessayer"
    ],
    "reessayant": [
        "reessayer"
    ],
    "reessaye": [
        "reessayer"
    ],
    "reessayer": [
        "reessayer"
    ],
    "reessayez": [
        "reessayer"
    ],
    "reessayiez": [
        "reessayer"
    ],
    "reessayons": [
        "reessayer"
    ],
    "reexamen": [
        "reexamen"
    ],
    "reexaminant": [
        "reexaminer"
    ],
    "reexamine": [
        "reexaminer"
    ],
    "reexaminer": [
        "reexaminer"
    ],
    "reexaminerons": [
        "reexaminer"
    ],
    "reexamines": [
        "reexaminer"
    ],
    "reexaminez": [
        "reexaminer"
    ],
    "reexaminiez": [
        "reexaminer"
    ],
    "reexaminions": [
        "reexaminer"
    ],
    "reexaminee": [
        "reexaminer"
    ],
    "reexaminees": [
        "reexaminer"
    ],
    "reexpedia": [
        "reexpedier"
    ],
    "reexpediait": [
        "reexpedier"
    ],
    "reexpediant": [
        "reexpedier"
    ],
    "reexpedier": [
        "reexpedier"
    ],
    "reexpediez": [
        "reexpedier"
    ],
    "reexpedions": [
        "reexpedier"
    ],
    "reexpedition": [
        "reexpedition"
    ],
    "reexpedie": [
        "reexpedier"
    ],
    "reexpedies": [
        "reexpedier"
    ],
    "ref": [
        "ref"
    ],
    "refection": [
        "refection"
    ],
    "refections": [
        "refection"
    ],
    "refectoire": [
        "refectoire"
    ],
    "refectoires": [
        "refectoire"
    ],
    "reflecteur": [
        "reflecteur"
    ],
    "reflecteurs": [
        "reflecteur"
    ],
    "reflexe": [
        "reflexe"
    ],
    "reflexes": [
        "reflexe",
        "reflex"
    ],
    "reflexif": [
        "reflexif"
    ],
    "reflexion": [
        "reflexion"
    ],
    "reflexions": [
        "reflexion"
    ],
    "reflexive": [
        "reflexif"
    ],
    "reflexologie": [
        "reflexologie"
    ],
    "reflechi": [
        "reflechir",
        "reflechi"
    ],
    "reflechie": [
        "reflechir",
        "reflechi"
    ],
    "reflechies": [
        "reflechir",
        "reflechi"
    ],
    "reflechir": [
        "reflechir"
    ],
    "reflechira": [
        "reflechir"
    ],
    "reflechirai": [
        "reflechir"
    ],
    "reflechirais": [
        "reflechir"
    ],
    "reflechirait": [
        "reflechir"
    ],
    "reflechiras": [
        "reflechir"
    ],
    "reflechirent": [
        "reflechir"
    ],
    "reflechirez": [
        "reflechir"
    ],
    "reflechiriez": [
        "reflechir"
    ],
    "reflechirons": [
        "reflechir"
    ],
    "reflechiront": [
        "reflechir"
    ],
    "reflechis": [
        "reflechir",
        "reflechi"
    ],
    "reflechissaient": [
        "reflechir"
    ],
    "reflechissais": [
        "reflechir"
    ],
    "reflechissait": [
        "reflechir"
    ],
    "reflechissant": [
        "reflechir",
        "reflechissant"
    ],
    "reflechissante": [
        "reflechissant"
    ],
    "reflechissantes": [
        "reflechissant"
    ],
    "reflechissants": [
        "reflechissant"
    ],
    "reflechisse": [
        "reflechir"
    ],
    "reflechissent": [
        "reflechir"
    ],
    "reflechisses": [
        "reflechir"
    ],
    "reflechissez": [
        "reflechir"
    ],
    "reflechissiez": [
        "reflechir"
    ],
    "reflechissons": [
        "reflechir"
    ],
    "reflechit": [
        "reflechir"
    ],
    "reformateur": [
        "reformateur"
    ],
    "reformateurs": [
        "reformateur"
    ],
    "reformera": [
        "reformer"
    ],
    "reformisme": [
        "reformisme"
    ],
    "reformiste": [
        "reformiste"
    ],
    "reformistes": [
        "reformiste"
    ],
    "reformons": [
        "reformer"
    ],
    "reformees": [
        "reforme"
    ],
    "refractaire": [
        "refractaire"
    ],
    "refractaires": [
        "refractaire"
    ],
    "refractant": [
        "refracter"
    ],
    "refractera": [
        "refracter"
    ],
    "refracterait": [
        "refracter"
    ],
    "refraction": [
        "refraction"
    ],
    "refractionniste": [
        "refractionniste"
    ],
    "refracte": [
        "refracter"
    ],
    "refrigerent": [
        "refrigerer"
    ],
    "refrigerant": [
        "refrigerer",
        "refrigerant"
    ],
    "refrigerante": [
        "refrigerant"
    ],
    "refrigerantes": [
        "refrigerant"
    ],
    "refrigerants": [
        "refrigerant"
    ],
    "refrigerateur": [
        "refrigerateur"
    ],
    "refrigerateurs": [
        "refrigerateur"
    ],
    "refrigeration": [
        "refrigeration"
    ],
    "refrigerer": [
        "refrigerer"
    ],
    "refrigere": [
        "refrigerer",
        "refrigere"
    ],
    "refrigeree": [
        "refrigerer",
        "refrigere"
    ],
    "refrigerees": [
        "refrigerer",
        "refrigere"
    ],
    "refrigeres": [
        "refrigerer",
        "refrigere"
    ],
    "refrenez": [
        "refrener"
    ],
    "refrenee": [
        "refrener"
    ],
    "refugia": [
        "refugier"
    ],
    "refugiai": [
        "refugier"
    ],
    "refugiaient": [
        "refugier"
    ],
    "refugiais": [
        "refugier"
    ],
    "refugiait": [
        "refugier"
    ],
    "refugiant": [
        "refugier"
    ],
    "refugie": [
        "refugie",
        "refugier"
    ],
    "refugient": [
        "refugier"
    ],
    "refugier": [
        "refugier"
    ],
    "refugiera": [
        "refugier"
    ],
    "refugierais": [
        "refugier"
    ],
    "refugies": [
        "refugie",
        "refugier"
    ],
    "refugiez": [
        "refugier"
    ],
    "refugiions": [
        "refugier"
    ],
    "refugions": [
        "refugier"
    ],
    "refugierent": [
        "refugier"
    ],
    "refugiee": [
        "refugie",
        "refugier"
    ],
    "refugiees": [
        "refugie",
        "refugier"
    ],
    "refuta": [
        "refuter"
    ],
    "refutable": [
        "refutable"
    ],
    "refutaient": [
        "refuter"
    ],
    "refutant": [
        "refuter"
    ],
    "refutation": [
        "refutation"
    ],
    "refutations": [
        "refutation"
    ],
    "refute": [
        "refuter"
    ],
    "refutent": [
        "refuter"
    ],
    "refuter": [
        "refuter"
    ],
    "refutons": [
        "refuter"
    ],
    "refuterent": [
        "refuter"
    ],
    "refutee": [
        "refuter"
    ],
    "refutees": [
        "refuter"
    ],
    "refere": [
        "referer",
        "refere"
    ],
    "referent": [
        "referent",
        "referer"
    ],
    "referaient": [
        "referer"
    ],
    "referant": [
        "referer"
    ],
    "reference": [
        "referencer",
        "reference"
    ],
    "referencement": [
        "referencement"
    ],
    "referencer": [
        "referencer"
    ],
    "references": [
        "reference"
    ],
    "referencee": [
        "referencer"
    ],
    "referendaire": [
        "referendaire"
    ],
    "referendums": [
        "referendum"
    ],
    "referer": [
        "referer"
    ],
    "referera": [
        "referer"
    ],
    "refererai": [
        "referer"
    ],
    "refererez": [
        "referer"
    ],
    "referez": [
        "referer"
    ],
    "referiez": [
        "referer"
    ],
    "refererent": [
        "referer"
    ],
    "referee": [
        "referer"
    ],
    "referes": [
        "refere"
    ],
    "regal": [
        "regal"
    ],
    "regala": [
        "regaler"
    ],
    "regalade": [
        "regalade"
    ],
    "regalai": [
        "regaler"
    ],
    "regalaient": [
        "regaler"
    ],
    "regalais": [
        "regaler"
    ],
    "regalait": [
        "regaler"
    ],
    "regalant": [
        "regaler"
    ],
    "regale": [
        "regaler",
        "regale"
    ],
    "regalent": [
        "regaler"
    ],
    "regaler": [
        "regaler"
    ],
    "regalera": [
        "regaler"
    ],
    "regaleraient": [
        "regaler"
    ],
    "regalerais": [
        "regaler"
    ],
    "regalerait": [
        "regaler"
    ],
    "regaleras": [
        "regaler"
    ],
    "regalerez": [
        "regaler"
    ],
    "regaleront": [
        "regaler"
    ],
    "regaleur": [
        "regaleur"
    ],
    "regalez": [
        "regaler"
    ],
    "regalien": [
        "regalien"
    ],
    "regalions": [
        "regaler"
    ],
    "regals": [
        "regal"
    ],
    "regalat": [
        "regaler"
    ],
    "regalerent": [
        "regaler"
    ],
    "regalee": [
        "regaler"
    ],
    "regales": [
        "regaler",
        "regale"
    ],
    "regate": [
        "regate"
    ],
    "regates": [
        "regate"
    ],
    "regence": [
        "regence"
    ],
    "regent": [
        "regent"
    ],
    "regentaient": [
        "regenter"
    ],
    "regentait": [
        "regenter"
    ],
    "regentant": [
        "regenter"
    ],
    "regente": [
        "regent",
        "regenter"
    ],
    "regentent": [
        "regenter"
    ],
    "regenter": [
        "regenter"
    ],
    "regenteraient": [
        "regenter"
    ],
    "regentes": [
        "regent",
        "regenter"
    ],
    "regentee": [
        "regenter"
    ],
    "regi": [
        "regir"
    ],
    "regicide": [
        "regicide"
    ],
    "regicides": [
        "regicide"
    ],
    "regie": [
        "regie",
        "regir"
    ],
    "regies": [
        "regie",
        "regir"
    ],
    "regime": [
        "regime"
    ],
    "regiment": [
        "regiment"
    ],
    "regimentaire": [
        "regimentaire"
    ],
    "regimentaires": [
        "regimentaire"
    ],
    "regiments": [
        "regiment"
    ],
    "regimes": [
        "regime"
    ],
    "region": [
        "region"
    ],
    "regional": [
        "regional"
    ],
    "regionale": [
        "regional"
    ],
    "regionales": [
        "regional"
    ],
    "regionaliser": [
        "regionaliser"
    ],
    "regionalisme": [
        "regionalisme"
    ],
    "regionaliste": [
        "regionaliste"
    ],
    "regionalistes": [
        "regionaliste"
    ],
    "regionaux": [
        "regional"
    ],
    "regions": [
        "region"
    ],
    "regir": [
        "regir"
    ],
    "regira": [
        "regir"
    ],
    "regiraient": [
        "regir"
    ],
    "regirait": [
        "regir"
    ],
    "regiront": [
        "regir"
    ],
    "regis": [
        "regir"
    ],
    "regissaient": [
        "regir"
    ],
    "regissait": [
        "regir"
    ],
    "regissant": [
        "regir"
    ],
    "regissent": [
        "regir"
    ],
    "regisseur": [
        "regisseur"
    ],
    "regisseurs": [
        "regisseur"
    ],
    "regisseuse": [
        "regisseur"
    ],
    "regit": [
        "regir"
    ],
    "regla": [
        "regler"
    ],
    "reglable": [
        "reglable"
    ],
    "reglables": [
        "reglable"
    ],
    "reglage": [
        "reglage"
    ],
    "reglages": [
        "reglage"
    ],
    "reglai": [
        "regler"
    ],
    "reglaient": [
        "regler"
    ],
    "reglais": [
        "regler"
    ],
    "reglait": [
        "regler"
    ],
    "reglant": [
        "regler"
    ],
    "reglasse": [
        "regler"
    ],
    "reglementaire": [
        "reglementaire"
    ],
    "reglementairement": [
        "reglementairement"
    ],
    "reglementaires": [
        "reglementaire"
    ],
    "reglementait": [
        "reglementer"
    ],
    "reglementant": [
        "reglementer"
    ],
    "reglementation": [
        "reglementation"
    ],
    "reglementations": [
        "reglementation"
    ],
    "reglemente": [
        "reglementer"
    ],
    "reglementer": [
        "reglementer"
    ],
    "reglementee": [
        "reglementer"
    ],
    "reglementees": [
        "reglementer"
    ],
    "reglementes": [
        "reglementer"
    ],
    "regler": [
        "regler"
    ],
    "reglera": [
        "regler"
    ],
    "reglerai": [
        "regler"
    ],
    "reglerais": [
        "regler"
    ],
    "reglerait": [
        "regler"
    ],
    "regleras": [
        "regler"
    ],
    "reglerez": [
        "regler"
    ],
    "reglerions": [
        "regler"
    ],
    "reglerons": [
        "regler"
    ],
    "regleront": [
        "regler"
    ],
    "reglette": [
        "reglette"
    ],
    "regleur": [
        "regleur"
    ],
    "reglez": [
        "regler"
    ],
    "regliez": [
        "regler"
    ],
    "reglions": [
        "regler"
    ],
    "reglisses": [
        "reglisse"
    ],
    "reglo": [
        "reglo"
    ],
    "reglons": [
        "regler"
    ],
    "reglos": [
        "reglo"
    ],
    "reglure": [
        "reglure"
    ],
    "reglat": [
        "regler"
    ],
    "reglerent": [
        "regler"
    ],
    "reglee": [
        "regle",
        "regler"
    ],
    "reglees": [
        "regle",
        "regler"
    ],
    "regna": [
        "regner"
    ],
    "regnaient": [
        "regner"
    ],
    "regnais": [
        "regner"
    ],
    "regnait": [
        "regner"
    ],
    "regnant": [
        "regner",
        "regnant"
    ],
    "regnante": [
        "regnant"
    ],
    "regnants": [
        "regnant"
    ],
    "regnas": [
        "regner"
    ],
    "regner": [
        "regner"
    ],
    "regnera": [
        "regner"
    ],
    "regnerai": [
        "regner"
    ],
    "regneraient": [
        "regner"
    ],
    "regnerais": [
        "regner"
    ],
    "regnerait": [
        "regner"
    ],
    "regneras": [
        "regner"
    ],
    "regnerez": [
        "regner"
    ],
    "regnerons": [
        "regner"
    ],
    "regneront": [
        "regner"
    ],
    "regnez": [
        "regner"
    ],
    "regnions": [
        "regner"
    ],
    "regnons": [
        "regner"
    ],
    "regnerent": [
        "regner"
    ],
    "regressait": [
        "regresser"
    ],
    "regressant": [
        "regresser"
    ],
    "regresse": [
        "regresser"
    ],
    "regresser": [
        "regresser"
    ],
    "regressera": [
        "regresser"
    ],
    "regressif": [
        "regressif"
    ],
    "regression": [
        "regression"
    ],
    "regressions": [
        "regression"
    ],
    "regressive": [
        "regressif"
    ],
    "regul": [
        "regul"
    ],
    "regulant": [
        "reguler"
    ],
    "regularisa": [
        "regulariser"
    ],
    "regularisation": [
        "regularisation"
    ],
    "regularisations": [
        "regularisation"
    ],
    "regulariser": [
        "regulariser"
    ],
    "regularisera": [
        "regulariser"
    ],
    "regularise": [
        "regulariser"
    ],
    "regularite": [
        "regularite"
    ],
    "regulateur": [
        "regulateur"
    ],
    "regulateurs": [
        "regulateur"
    ],
    "regulation": [
        "regulation"
    ],
    "regulatrice": [
        "regulateur"
    ],
    "regulatrices": [
        "regulatrice",
        "regulateur"
    ],
    "regule": [
        "regule",
        "reguler"
    ],
    "regulent": [
        "reguler"
    ],
    "reguler": [
        "reguler"
    ],
    "regulera": [
        "reguler"
    ],
    "regulier": [
        "regulier"
    ],
    "reguliers": [
        "regulier"
    ],
    "reguliere": [
        "regulier"
    ],
    "regulierement": [
        "regulierement"
    ],
    "regulieres": [
        "regulier"
    ],
    "regulee": [
        "reguler"
    ],
    "regulees": [
        "reguler"
    ],
    "regules": [
        "reguler"
    ],
    "regurgitaient": [
        "regurgiter"
    ],
    "regurgitant": [
        "regurgiter"
    ],
    "regurgitation": [
        "regurgitation"
    ],
    "regurgitations": [
        "regurgitation"
    ],
    "regurgite": [
        "regurgiter"
    ],
    "regurgiter": [
        "regurgiter"
    ],
    "regurgiteras": [
        "regurgiter"
    ],
    "regenere": [
        "regenere",
        "regenerer"
    ],
    "regenerent": [
        "regenerer"
    ],
    "regenerait": [
        "regenerer"
    ],
    "regenerant": [
        "regenerer"
    ],
    "regenerateur": [
        "regenerateur"
    ],
    "regenerateurs": [
        "regenerateur"
    ],
    "regeneration": [
        "regeneration"
    ],
    "regeneratrice": [
        "regenerateur"
    ],
    "regenerer": [
        "regenerer"
    ],
    "regenerera": [
        "regenerer"
    ],
    "regenererait": [
        "regenerer"
    ],
    "regenerescence": [
        "regenerescence"
    ],
    "regeneree": [
        "regenere",
        "regenerer"
    ],
    "regenerees": [
        "regenere"
    ],
    "regeneres": [
        "regenere",
        "regenerer"
    ],
    "rehabilitaient": [
        "rehabiliter"
    ],
    "rehabilitait": [
        "rehabiliter"
    ],
    "rehabilitant": [
        "rehabiliter"
    ],
    "rehabilitation": [
        "rehabilitation"
    ],
    "rehabilite": [
        "rehabilite",
        "rehabiliter"
    ],
    "rehabilitent": [
        "rehabiliter"
    ],
    "rehabiliter": [
        "rehabiliter"
    ],
    "rehabilitera": [
        "rehabiliter"
    ],
    "rehabiliterait": [
        "rehabiliter"
    ],
    "rehabilitee": [
        "rehabilite",
        "rehabiliter"
    ],
    "rehabilitees": [
        "rehabiliter"
    ],
    "rehabilites": [
        "rehabilite",
        "rehabiliter"
    ],
    "rehabituais": [
        "rehabituer"
    ],
    "rehabituait": [
        "rehabituer"
    ],
    "rehabitue": [
        "rehabituer"
    ],
    "rehabituer": [
        "rehabituer"
    ],
    "rehydratation": [
        "rehydratation"
    ],
    "rehydrater": [
        "rehydrater"
    ],
    "rehydrate": [
        "rehydrater"
    ],
    "reifies": [
        "reifier"
    ],
    "reimplantation": [
        "reimplantation"
    ],
    "reimplanter": [
        "reimplanter"
    ],
    "reimplante": [
        "reimplanter"
    ],
    "reimplantee": [
        "reimplanter"
    ],
    "reimpression": [
        "reimpression"
    ],
    "reimprima": [
        "reimprimer"
    ],
    "reimprimer": [
        "reimprimer"
    ],
    "reimprime": [
        "reimprimer"
    ],
    "reincarcerer": [
        "reincarcerer"
    ],
    "reincarnait": [
        "reincarner"
    ],
    "reincarnation": [
        "reincarnation"
    ],
    "reincarnations": [
        "reincarnation"
    ],
    "reincarne": [
        "reincarner"
    ],
    "reincarnent": [
        "reincarner"
    ],
    "reincarner": [
        "reincarner"
    ],
    "reincarnera": [
        "reincarner"
    ],
    "reincarnerait": [
        "reincarner"
    ],
    "reincarneront": [
        "reincarner"
    ],
    "reincarnons": [
        "reincarner"
    ],
    "reincarnerent": [
        "reincarner"
    ],
    "reincarnee": [
        "reincarner"
    ],
    "reincarnes": [
        "reincarner"
    ],
    "reincorpora": [
        "reincorporer"
    ],
    "reincorpore": [
        "reincorporer"
    ],
    "reincorpores": [
        "reincorporer"
    ],
    "reinfecter": [
        "reinfecter"
    ],
    "reinfecte": [
        "reinfecter"
    ],
    "reinitialisation": [
        "reinitialisation"
    ],
    "reinitialiser": [
        "reinitialiser"
    ],
    "reinitialisez": [
        "reinitialiser"
    ],
    "reinitialise": [
        "reinitialiser"
    ],
    "reinjecter": [
        "reinjecter"
    ],
    "reinjection": [
        "reinjection"
    ],
    "reinscrire": [
        "reinscrire"
    ],
    "reinscrit": [
        "reinscrire"
    ],
    "reinsertion": [
        "reinsertion"
    ],
    "reinstalla": [
        "reinstaller"
    ],
    "reinstallaient": [
        "reinstaller"
    ],
    "reinstallait": [
        "reinstaller"
    ],
    "reinstallant": [
        "reinstaller"
    ],
    "reinstallation": [
        "reinstallation"
    ],
    "reinstalle": [
        "reinstaller"
    ],
    "reinstallent": [
        "reinstaller"
    ],
    "reinstaller": [
        "reinstaller"
    ],
    "reinstallez": [
        "reinstaller"
    ],
    "reinstallons": [
        "reinstaller"
    ],
    "reinstallee": [
        "reinstaller"
    ],
    "reinstallees": [
        "reinstaller"
    ],
    "reinstalles": [
        "reinstaller"
    ],
    "reinstaurer": [
        "reinstaurer"
    ],
    "reinserer": [
        "reinserer"
    ],
    "reinsere": [
        "reinserer"
    ],
    "reinterprete": [
        "reinterpreter"
    ],
    "reinterpretation": [
        "reinterpretation"
    ],
    "reinterpreter": [
        "reinterpreter"
    ],
    "reinterroge": [
        "reinterroger"
    ],
    "reinterroger": [
        "reinterroger"
    ],
    "reintroduire": [
        "reintroduire"
    ],
    "reintroduisait": [
        "reintroduire"
    ],
    "reintroduisit": [
        "reintroduire"
    ],
    "reintroduit": [
        "reintroduire"
    ],
    "reintroduite": [
        "reintroduire"
    ],
    "reintegre": [
        "reintegrer"
    ],
    "reintegrent": [
        "reintegrer"
    ],
    "reintegra": [
        "reintegrer"
    ],
    "reintegrai": [
        "reintegrer"
    ],
    "reintegraient": [
        "reintegrer"
    ],
    "reintegrais": [
        "reintegrer"
    ],
    "reintegrait": [
        "reintegrer"
    ],
    "reintegrant": [
        "reintegrer"
    ],
    "reintegration": [
        "reintegration"
    ],
    "reintegrations": [
        "reintegration"
    ],
    "reintegrer": [
        "reintegrer"
    ],
    "reintegrerait": [
        "reintegrer"
    ],
    "reintegrez": [
        "reintegrer"
    ],
    "reintegrions": [
        "reintegrer"
    ],
    "reintegrons": [
        "reintegrer"
    ],
    "reintegrerent": [
        "reintegrer"
    ],
    "reintegree": [
        "reintegrer"
    ],
    "reintegres": [
        "reintegrer"
    ],
    "reinventa": [
        "reinventer"
    ],
    "reinventaient": [
        "reinventer"
    ],
    "reinventait": [
        "reinventer"
    ],
    "reinventant": [
        "reinventer"
    ],
    "reinvente": [
        "reinventer"
    ],
    "reinventent": [
        "reinventer"
    ],
    "reinventer": [
        "reinventer"
    ],
    "reinventeraient": [
        "reinventer"
    ],
    "reinvention": [
        "reinvention"
    ],
    "reinventees": [
        "reinventer"
    ],
    "reinvesti": [
        "reinvestir"
    ],
    "reinvestir": [
        "reinvestir"
    ],
    "reinvestirent": [
        "reinvestir"
    ],
    "reinvestis": [
        "reinvestir"
    ],
    "reinvestissait": [
        "reinvestir"
    ],
    "reinvestissement": [
        "reinvestissement"
    ],
    "reinvestissent": [
        "reinvestir"
    ],
    "reinvestit": [
        "reinvestir"
    ],
    "reinvita": [
        "reinviter"
    ],
    "reinvite": [
        "reinviter"
    ],
    "reinviter": [
        "reinviter"
    ],
    "reinviterai": [
        "reinviter"
    ],
    "reitere": [
        "reiterer"
    ],
    "reitera": [
        "reiterer"
    ],
    "reiterait": [
        "reiterer"
    ],
    "reiterant": [
        "reiterer"
    ],
    "reiteration": [
        "reiteration"
    ],
    "reiterations": [
        "reiteration"
    ],
    "reiterer": [
        "reiterer"
    ],
    "reiterera": [
        "reiterer"
    ],
    "reitererent": [
        "reiterer"
    ],
    "reiteree": [
        "reiterer"
    ],
    "reiterees": [
        "reiterer"
    ],
    "reiteres": [
        "reiterer"
    ],
    "rejoui": [
        "rejoui",
        "rejouir"
    ],
    "rejouie": [
        "rejoui",
        "rejouir"
    ],
    "rejouies": [
        "rejoui",
        "rejouir"
    ],
    "rejouir": [
        "rejouir"
    ],
    "rejouira": [
        "rejouir"
    ],
    "rejouirai": [
        "rejouir"
    ],
    "rejouirais": [
        "rejouir"
    ],
    "rejouirait": [
        "rejouir"
    ],
    "rejouirent": [
        "rejouir"
    ],
    "rejouirez": [
        "rejouir"
    ],
    "rejouirons": [
        "rejouir"
    ],
    "rejouiront": [
        "rejouir"
    ],
    "rejouis": [
        "rejoui",
        "rejouir"
    ],
    "rejouissaient": [
        "rejouir"
    ],
    "rejouissais": [
        "rejouir"
    ],
    "rejouissait": [
        "rejouir"
    ],
    "rejouissance": [
        "rejouissance"
    ],
    "rejouissances": [
        "rejouissance"
    ],
    "rejouissant": [
        "rejouissant",
        "rejouir"
    ],
    "rejouissante": [
        "rejouissant"
    ],
    "rejouissantes": [
        "rejouissant"
    ],
    "rejouissants": [
        "rejouissant"
    ],
    "rejouisse": [
        "rejouir"
    ],
    "rejouissent": [
        "rejouir"
    ],
    "rejouissez": [
        "rejouir"
    ],
    "rejouissiez": [
        "rejouir"
    ],
    "rejouissions": [
        "rejouir"
    ],
    "rejouissons": [
        "rejouir"
    ],
    "rejouit": [
        "rejouir"
    ],
    "remanence": [
        "remanence"
    ],
    "remanent": [
        "remanent"
    ],
    "remanente": [
        "remanent"
    ],
    "remiges": [
        "remige"
    ],
    "reminiscence": [
        "reminiscence"
    ],
    "reminiscences": [
        "reminiscence"
    ],
    "remission": [
        "remission"
    ],
    "remissions": [
        "remission"
    ],
    "remiz": [
        "remiz"
    ],
    "remora": [
        "remora"
    ],
    "remoulade": [
        "remoulade"
    ],
    "remouleur": [
        "remouleur"
    ],
    "remouleurs": [
        "remouleur"
    ],
    "remunere": [
        "remunerer"
    ],
    "remuneraient": [
        "remunerer"
    ],
    "remunerateur": [
        "remunerateur"
    ],
    "remunerateurs": [
        "remunerateur"
    ],
    "remuneration": [
        "remuneration"
    ],
    "remunerations": [
        "remuneration"
    ],
    "remuneratoires": [
        "remuneratoire"
    ],
    "remuneratrice": [
        "remunerateur"
    ],
    "remunerer": [
        "remunerer"
    ],
    "remunerees": [
        "remunerer"
    ],
    "remuneres": [
        "remunerer"
    ],
    "renal": [
        "renal"
    ],
    "renale": [
        "renal"
    ],
    "renales": [
        "renal"
    ],
    "renaux": [
        "renal"
    ],
    "renettes": [
        "renette"
    ],
    "renine": [
        "renine"
    ],
    "renovait": [
        "renover"
    ],
    "renovant": [
        "renover"
    ],
    "renovateur": [
        "renovateur"
    ],
    "renovateurs": [
        "renovateur"
    ],
    "renovation": [
        "renovation"
    ],
    "renovations": [
        "renovation"
    ],
    "renovatrice": [
        "renovateur"
    ],
    "renove": [
        "renover"
    ],
    "renover": [
        "renover"
    ],
    "renovee": [
        "renover"
    ],
    "renovees": [
        "renover"
    ],
    "renoves": [
        "renover"
    ],
    "reoccupait": [
        "reoccuper"
    ],
    "reoccuper": [
        "reoccuper"
    ],
    "reoccupons": [
        "reoccuper"
    ],
    "reopere": [
        "reoperer"
    ],
    "reoperer": [
        "reoperer"
    ],
    "reordonnant": [
        "reordonner"
    ],
    "reordonner": [
        "reordonner"
    ],
    "reorganisa": [
        "reorganiser"
    ],
    "reorganisait": [
        "reorganiser"
    ],
    "reorganisant": [
        "reorganiser"
    ],
    "reorganisation": [
        "reorganisation"
    ],
    "reorganisations": [
        "reorganisation"
    ],
    "reorganise": [
        "reorganiser"
    ],
    "reorganiser": [
        "reorganiser"
    ],
    "reorganisez": [
        "reorganiser"
    ],
    "reorganisees": [
        "reorganiser"
    ],
    "reorganises": [
        "reorganiser",
        "reorganise"
    ],
    "reorientation": [
        "reorientation"
    ],
    "reorienter": [
        "reorienter"
    ],
    "reoriente": [
        "reorienter"
    ],
    "reouverture": [
        "reouverture"
    ],
    "reouvertures": [
        "reouverture"
    ],
    "repand": [
        "repandre"
    ],
    "repandaient": [
        "repandre"
    ],
    "repandais": [
        "repandre"
    ],
    "repandait": [
        "repandre"
    ],
    "repandant": [
        "repandre"
    ],
    "repande": [
        "repandre"
    ],
    "repandent": [
        "repandre"
    ],
    "repandeur": [
        "repandeur"
    ],
    "repandez": [
        "repandre"
    ],
    "repandirent": [
        "repandre"
    ],
    "repandit": [
        "repandre"
    ],
    "repandons": [
        "repandre"
    ],
    "repandra": [
        "repandre"
    ],
    "repandrai": [
        "repandre"
    ],
    "repandraient": [
        "repandre"
    ],
    "repandrait": [
        "repandre"
    ],
    "repandras": [
        "repandre"
    ],
    "repandre": [
        "repandre"
    ],
    "repandrez": [
        "repandre"
    ],
    "repandrons": [
        "repandre"
    ],
    "repandront": [
        "repandre"
    ],
    "repands": [
        "repandre"
    ],
    "repandu": [
        "repandre",
        "repandu"
    ],
    "repandue": [
        "repandre",
        "repandu"
    ],
    "repandues": [
        "repandre",
        "repandu"
    ],
    "repandus": [
        "repandre",
        "repandu"
    ],
    "repara": [
        "reparer"
    ],
    "reparable": [
        "reparable"
    ],
    "reparables": [
        "reparable"
    ],
    "reparaient": [
        "reparer"
    ],
    "reparant": [
        "reparer"
    ],
    "reparateur": [
        "reparateur"
    ],
    "reparateurs": [
        "reparateur"
    ],
    "reparation": [
        "reparation"
    ],
    "reparations": [
        "reparation"
    ],
    "reparatrice": [
        "reparateur"
    ],
    "reparatrices": [
        "reparateur"
    ],
    "repare": [
        "reparer"
    ],
    "reparent": [
        "reparer"
    ],
    "reparer": [
        "reparer"
    ],
    "reparera": [
        "reparer"
    ],
    "reparerai": [
        "reparer"
    ],
    "repareraient": [
        "reparer"
    ],
    "reparerait": [
        "reparer"
    ],
    "repareras": [
        "reparer"
    ],
    "reparerez": [
        "reparer"
    ],
    "reparerons": [
        "reparer"
    ],
    "repareront": [
        "reparer"
    ],
    "reparez": [
        "reparer"
    ],
    "repariez": [
        "reparer"
    ],
    "reparions": [
        "reparer"
    ],
    "reparons": [
        "reparer"
    ],
    "repartissaient": [
        "repartir"
    ],
    "repartissait": [
        "repartir"
    ],
    "repartissant": [
        "repartir"
    ],
    "repartissent": [
        "repartir"
    ],
    "repartissez": [
        "repartir"
    ],
    "repartissons": [
        "repartir"
    ],
    "repartiteur": [
        "repartiteur"
    ],
    "repartition": [
        "repartition"
    ],
    "repartitions": [
        "repartition"
    ],
    "reparerent": [
        "reparer"
    ],
    "reparee": [
        "reparer"
    ],
    "reparees": [
        "reparer"
    ],
    "repares": [
        "reparer"
    ],
    "repercussion": [
        "repercussion"
    ],
    "repercussions": [
        "repercussion"
    ],
    "repercuta": [
        "repercuter"
    ],
    "repercutaient": [
        "repercuter"
    ],
    "repercutait": [
        "repercuter"
    ],
    "repercutant": [
        "repercuter"
    ],
    "repercute": [
        "repercuter"
    ],
    "repercutent": [
        "repercuter"
    ],
    "repercuter": [
        "repercuter"
    ],
    "repercuterait": [
        "repercuter"
    ],
    "repercuteront": [
        "repercuter"
    ],
    "repercutons": [
        "repercuter"
    ],
    "repercuterent": [
        "repercuter"
    ],
    "repercutee": [
        "repercuter"
    ],
    "repercutees": [
        "repercuter"
    ],
    "repercutes": [
        "repercuter"
    ],
    "repertoire": [
        "repertoire"
    ],
    "repertoires": [
        "repertoire"
    ],
    "repertoriant": [
        "repertorier"
    ],
    "repertorier": [
        "repertorier"
    ],
    "repertorie": [
        "repertorier"
    ],
    "repertoriee": [
        "repertorier"
    ],
    "repertoriees": [
        "repertorier"
    ],
    "repertories": [
        "repertory",
        "repertorier"
    ],
    "repit": [
        "repit"
    ],
    "repits": [
        "repit"
    ],
    "replication": [
        "replication"
    ],
    "repliqua": [
        "repliquer"
    ],
    "repliquai": [
        "repliquer"
    ],
    "repliquaient": [
        "repliquer"
    ],
    "repliquais": [
        "repliquer"
    ],
    "repliquait": [
        "repliquer"
    ],
    "repliquant": [
        "repliquer"
    ],
    "replique": [
        "repliquer",
        "replique"
    ],
    "repliquent": [
        "repliquer"
    ],
    "repliquer": [
        "repliquer"
    ],
    "repliquera": [
        "repliquer"
    ],
    "repliquerons": [
        "repliquer"
    ],
    "repliqueront": [
        "repliquer"
    ],
    "repliques": [
        "repliquer",
        "replique"
    ],
    "repliquat": [
        "repliquer"
    ],
    "repliquerent": [
        "repliquer"
    ],
    "repond": [
        "repondre"
    ],
    "repondaient": [
        "repondre"
    ],
    "repondais": [
        "repondre"
    ],
    "repondait": [
        "repondre"
    ],
    "repondant": [
        "repondre",
        "repondant"
    ],
    "repondants": [
        "repondant"
    ],
    "reponde": [
        "repondre"
    ],
    "repondent": [
        "repondre"
    ],
    "repondes": [
        "repondre"
    ],
    "repondeur": [
        "repondeur"
    ],
    "repondeurs": [
        "repondeur"
    ],
    "repondeuse": [
        "repondeur"
    ],
    "repondez": [
        "repondre"
    ],
    "repondiez": [
        "repondre"
    ],
    "repondions": [
        "repondre"
    ],
    "repondirent": [
        "repondre"
    ],
    "repondis": [
        "repondre"
    ],
    "repondit": [
        "repondre"
    ],
    "repondons": [
        "repondre"
    ],
    "repondra": [
        "repondre"
    ],
    "repondrai": [
        "repondre"
    ],
    "repondraient": [
        "repondre"
    ],
    "repondrais": [
        "repondre"
    ],
    "repondrait": [
        "repondre"
    ],
    "repondras": [
        "repondre"
    ],
    "repondre": [
        "repondre"
    ],
    "repondrez": [
        "repondre"
    ],
    "repondriez": [
        "repondre"
    ],
    "repondrons": [
        "repondre"
    ],
    "repondront": [
        "repondre"
    ],
    "reponds": [
        "repondre"
    ],
    "repondu": [
        "repondre"
    ],
    "repondues": [
        "repondre"
    ],
    "repondimes": [
        "repondre"
    ],
    "repons": [
        "repons"
    ],
    "reponse": [
        "reponse"
    ],
    "reponses": [
        "reponse"
    ],
    "represseur": [
        "represseur"
    ],
    "repressif": [
        "repressif"
    ],
    "repression": [
        "repression"
    ],
    "repressions": [
        "repression"
    ],
    "repressive": [
        "repressif"
    ],
    "repressives": [
        "repressif"
    ],
    "reprima": [
        "reprimer"
    ],
    "reprimai": [
        "reprimer"
    ],
    "reprimaient": [
        "reprimer"
    ],
    "reprimais": [
        "reprimer"
    ],
    "reprimait": [
        "reprimer"
    ],
    "reprimanda": [
        "reprimander"
    ],
    "reprimandait": [
        "reprimander"
    ],
    "reprimande": [
        "reprimande",
        "reprimander"
    ],
    "reprimander": [
        "reprimander"
    ],
    "reprimandes": [
        "reprimande"
    ],
    "reprimandiez": [
        "reprimander"
    ],
    "reprimandee": [
        "reprimander"
    ],
    "reprimant": [
        "reprimer"
    ],
    "reprime": [
        "reprimer"
    ],
    "reprimer": [
        "reprimer"
    ],
    "reprimerai": [
        "reprimer"
    ],
    "reprimerait": [
        "reprimer"
    ],
    "reprimerez": [
        "reprimer"
    ],
    "reprimames": [
        "reprimer"
    ],
    "reprimerent": [
        "reprimer"
    ],
    "reprimee": [
        "reprimer"
    ],
    "reprimees": [
        "reprimer"
    ],
    "reprobateur": [
        "reprobateur"
    ],
    "reprobateurs": [
        "reprobateur"
    ],
    "reprobation": [
        "reprobation"
    ],
    "reprobatrice": [
        "reprobateur"
    ],
    "reprouvais": [
        "reprouver"
    ],
    "reprouvait": [
        "reprouver"
    ],
    "reprouvant": [
        "reprouver"
    ],
    "reprouve": [
        "reprouve",
        "reprouver"
    ],
    "reprouvent": [
        "reprouver"
    ],
    "reprouver": [
        "reprouver"
    ],
    "reprouverait": [
        "reprouver"
    ],
    "reprouveront": [
        "reprouver"
    ],
    "reprouves": [
        "reprouve",
        "reprouver"
    ],
    "reprouvez": [
        "reprouver"
    ],
    "reprouvons": [
        "reprouver"
    ],
    "reprouvat": [
        "reprouver"
    ],
    "reprouvees": [
        "reprouve",
        "reprouver"
    ],
    "reprehensible": [
        "reprehensible"
    ],
    "reprehensibles": [
        "reprehensible"
    ],
    "republicain": [
        "republicain"
    ],
    "republicaine": [
        "republicain"
    ],
    "republicaines": [
        "republicain"
    ],
    "republicains": [
        "republicain"
    ],
    "republique": [
        "republique"
    ],
    "republiques": [
        "republique"
    ],
    "repudiant": [
        "repudier"
    ],
    "repudiation": [
        "repudiation"
    ],
    "repudie": [
        "repudier"
    ],
    "repudier": [
        "repudier"
    ],
    "repudiera": [
        "repudier"
    ],
    "repudierai": [
        "repudier"
    ],
    "repudies": [
        "repudier"
    ],
    "repudiee": [
        "repudier"
    ],
    "repudiees": [
        "repudier"
    ],
    "repugna": [
        "repugner"
    ],
    "repugnai": [
        "repugner"
    ],
    "repugnaient": [
        "repugner"
    ],
    "repugnais": [
        "repugner"
    ],
    "repugnait": [
        "repugner"
    ],
    "repugnance": [
        "repugnance"
    ],
    "repugnances": [
        "repugnance"
    ],
    "repugnant": [
        "repugnant",
        "repugner"
    ],
    "repugnante": [
        "repugnant"
    ],
    "repugnantes": [
        "repugnant"
    ],
    "repugnants": [
        "repugnant"
    ],
    "repugne": [
        "repugner"
    ],
    "repugnent": [
        "repugner"
    ],
    "repugner": [
        "repugner"
    ],
    "repugnerait": [
        "repugner"
    ],
    "repugneront": [
        "repugner"
    ],
    "repugnes": [
        "repugner"
    ],
    "repugnez": [
        "repugner"
    ],
    "repugniez": [
        "repugner"
    ],
    "repugnons": [
        "repugner"
    ],
    "repugnat": [
        "repugner"
    ],
    "repugnee": [
        "repugner"
    ],
    "repulsif": [
        "repulsif"
    ],
    "repulsion": [
        "repulsion"
    ],
    "repulsions": [
        "repulsion"
    ],
    "repulsive": [
        "repulsif"
    ],
    "reputaient": [
        "reputer"
    ],
    "reputait": [
        "reputer"
    ],
    "reputation": [
        "reputation"
    ],
    "reputations": [
        "reputation"
    ],
    "repute": [
        "reputer",
        "repute"
    ],
    "reputent": [
        "reputer"
    ],
    "reputer": [
        "reputer"
    ],
    "reputee": [
        "reputer",
        "repute"
    ],
    "reputees": [
        "reputer",
        "repute"
    ],
    "reputes": [
        "reputer",
        "repute"
    ],
    "repete": [
        "repeter",
        "repete"
    ],
    "repetent": [
        "repeter"
    ],
    "repetes": [
        "repeter",
        "repete"
    ],
    "repeta": [
        "repeter"
    ],
    "repetai": [
        "repeter"
    ],
    "repetaient": [
        "repeter"
    ],
    "repetais": [
        "repeter"
    ],
    "repetait": [
        "repeter"
    ],
    "repetant": [
        "repeter"
    ],
    "repeter": [
        "repeter"
    ],
    "repetera": [
        "repeter"
    ],
    "repeterai": [
        "repeter"
    ],
    "repeteraient": [
        "repeter"
    ],
    "repeterais": [
        "repeter"
    ],
    "repeterait": [
        "repeter"
    ],
    "repeteras": [
        "repeter"
    ],
    "repeterez": [
        "repeter"
    ],
    "repeteriez": [
        "repeter"
    ],
    "repetez": [
        "repeter"
    ],
    "repetiez": [
        "repeter"
    ],
    "repetions": [
        "repeter"
    ],
    "repetiteur": [
        "repetiteur"
    ],
    "repetiteurs": [
        "repetiteur"
    ],
    "repetitif": [
        "repetitif"
    ],
    "repetitifs": [
        "repetitif"
    ],
    "repetition": [
        "repetition"
    ],
    "repetitions": [
        "repetition"
    ],
    "repetitive": [
        "repetitif"
    ],
    "repetitives": [
        "repetitif"
    ],
    "repetitrice": [
        "repetiteur"
    ],
    "repetons": [
        "repeter"
    ],
    "repetat": [
        "repeter"
    ],
    "repeterent": [
        "repeter"
    ],
    "repetee": [
        "repeter",
        "repete"
    ],
    "repetees": [
        "repeter",
        "repete"
    ],
    "requisition": [
        "requisition"
    ],
    "requisitionnais": [
        "requisitionner"
    ],
    "requisitionnait": [
        "requisitionner"
    ],
    "requisitionnant": [
        "requisitionner"
    ],
    "requisitionne": [
        "requisitionner"
    ],
    "requisitionner": [
        "requisitionner"
    ],
    "requisitionnez": [
        "requisitionner"
    ],
    "requisitionnons": [
        "requisitionner"
    ],
    "requisitionnee": [
        "requisitionner"
    ],
    "requisitionnees": [
        "requisitionner"
    ],
    "requisitionnes": [
        "requisitionner"
    ],
    "requisitions": [
        "requisition"
    ],
    "requisitoire": [
        "requisitoire"
    ],
    "requisitoires": [
        "requisitoire"
    ],
    "reseau": [
        "reseau"
    ],
    "reseaux": [
        "reseau"
    ],
    "resection": [
        "resection"
    ],
    "reserva": [
        "reserver"
    ],
    "reservai": [
        "reserver"
    ],
    "reservaient": [
        "reserver"
    ],
    "reservais": [
        "reserver"
    ],
    "reservait": [
        "reserver"
    ],
    "reservant": [
        "reserver"
    ],
    "reservataire": [
        "reservataire"
    ],
    "reservation": [
        "reservation"
    ],
    "reservations": [
        "reservation"
    ],
    "reserve": [
        "reserve",
        "reserver"
    ],
    "reservent": [
        "reserver"
    ],
    "reserver": [
        "reserver"
    ],
    "reservera": [
        "reserver"
    ],
    "reserverai": [
        "reserver"
    ],
    "reserverait": [
        "reserver"
    ],
    "reserveriez": [
        "reserver"
    ],
    "reserveront": [
        "reserver"
    ],
    "reserves": [
        "reserve",
        "reserver"
    ],
    "reservez": [
        "reserver"
    ],
    "reserviez": [
        "reserver"
    ],
    "reservions": [
        "reserver"
    ],
    "reserviste": [
        "reserviste"
    ],
    "reservistes": [
        "reserviste"
    ],
    "reservoir": [
        "reservoir"
    ],
    "reservoirs": [
        "reservoir"
    ],
    "reservons": [
        "reserver"
    ],
    "reservat": [
        "reserver"
    ],
    "reserverent": [
        "reserver"
    ],
    "reservee": [
        "reserve",
        "reserver"
    ],
    "reservees": [
        "reserve",
        "reserver"
    ],
    "residaient": [
        "resider"
    ],
    "residais": [
        "resider"
    ],
    "residait": [
        "resider"
    ],
    "residant": [
        "resider",
        "residant"
    ],
    "reside": [
        "resider"
    ],
    "residence": [
        "residence"
    ],
    "residences": [
        "residence"
    ],
    "resident": [
        "resider",
        "resident"
    ],
    "residente": [
        "resident"
    ],
    "residentiel": [
        "residentiel"
    ],
    "residentielle": [
        "residentiel"
    ],
    "residentielles": [
        "residentiel"
    ],
    "residentiels": [
        "residentiel"
    ],
    "residents": [
        "resident"
    ],
    "resider": [
        "resider"
    ],
    "residera": [
        "resider"
    ],
    "residerez": [
        "resider"
    ],
    "resides": [
        "resider",
        "reside"
    ],
    "residez": [
        "resider"
    ],
    "residons": [
        "resider"
    ],
    "residu": [
        "residu"
    ],
    "residuel": [
        "residuel"
    ],
    "residuelle": [
        "residuel"
    ],
    "residuelles": [
        "residuel"
    ],
    "residuels": [
        "residuel"
    ],
    "residus": [
        "residu"
    ],
    "resigna": [
        "resigner"
    ],
    "resignai": [
        "resigner"
    ],
    "resignaient": [
        "resigner"
    ],
    "resignais": [
        "resigner"
    ],
    "resignait": [
        "resigner"
    ],
    "resignant": [
        "resigner"
    ],
    "resignassent": [
        "resigner"
    ],
    "resignation": [
        "resignation"
    ],
    "resignations": [
        "resignation"
    ],
    "resigne": [
        "resigne",
        "resigner"
    ],
    "resignent": [
        "resigner"
    ],
    "resigner": [
        "resigner"
    ],
    "resignera": [
        "resigner"
    ],
    "resignerais": [
        "resigner"
    ],
    "resignerait": [
        "resigner"
    ],
    "resigneront": [
        "resigner"
    ],
    "resignez": [
        "resigner"
    ],
    "resignions": [
        "resigner"
    ],
    "resignames": [
        "resigner"
    ],
    "resignat": [
        "resigner"
    ],
    "resignerent": [
        "resigner"
    ],
    "resignee": [
        "resigne",
        "resigner"
    ],
    "resignees": [
        "resigne",
        "resigner"
    ],
    "resignes": [
        "resigne",
        "resigner"
    ],
    "resilia": [
        "resilier"
    ],
    "resiliable": [
        "resiliable"
    ],
    "resiliation": [
        "resiliation"
    ],
    "resilie": [
        "resilier"
    ],
    "resilience": [
        "resilience"
    ],
    "resilier": [
        "resilier"
    ],
    "resilierait": [
        "resilier"
    ],
    "resiliee": [
        "resilier"
    ],
    "resiliees": [
        "resilier"
    ],
    "resille": [
        "resille"
    ],
    "resilles": [
        "resille"
    ],
    "resine": [
        "resine"
    ],
    "resines": [
        "resine"
    ],
    "resineuse": [
        "resineux"
    ],
    "resineuses": [
        "resineux"
    ],
    "resineux": [
        "resineux"
    ],
    "resinee": [
        "resiner"
    ],
    "resipiscence": [
        "resipiscence"
    ],
    "resista": [
        "resister"
    ],
    "resistai": [
        "resister"
    ],
    "resistaient": [
        "resister"
    ],
    "resistais": [
        "resister"
    ],
    "resistait": [
        "resister"
    ],
    "resistance": [
        "resistance"
    ],
    "resistances": [
        "resistance"
    ],
    "resistant": [
        "resistant",
        "resister"
    ],
    "resistante": [
        "resistant"
    ],
    "resistantes": [
        "resistant"
    ],
    "resistants": [
        "resistant"
    ],
    "resiste": [
        "resister"
    ],
    "resistent": [
        "resister"
    ],
    "resister": [
        "resister"
    ],
    "resistera": [
        "resister"
    ],
    "resisterai": [
        "resister"
    ],
    "resisteraient": [
        "resister"
    ],
    "resisterais": [
        "resister"
    ],
    "resisterait": [
        "resister"
    ],
    "resisteras": [
        "resister"
    ],
    "resisterez": [
        "resister"
    ],
    "resisteriez": [
        "resister"
    ],
    "resisterions": [
        "resister"
    ],
    "resisterons": [
        "resister"
    ],
    "resisteront": [
        "resister"
    ],
    "resistes": [
        "resister"
    ],
    "resistez": [
        "resister"
    ],
    "resistible": [
        "resistible"
    ],
    "resistiez": [
        "resister"
    ],
    "resistions": [
        "resister"
    ],
    "resistons": [
        "resister"
    ],
    "resistat": [
        "resister"
    ],
    "resisterent": [
        "resister"
    ],
    "resolu": [
        "resoudre",
        "resolu"
    ],
    "resoluble": [
        "resoluble"
    ],
    "resolue": [
        "resolu"
    ],
    "resolues": [
        "resolu"
    ],
    "resolument": [
        "resolument"
    ],
    "resolurent": [
        "resoudre"
    ],
    "resolus": [
        "resoudre",
        "resolu"
    ],
    "resolut": [
        "resoudre"
    ],
    "resolution": [
        "resolution"
    ],
    "resolutions": [
        "resolution"
    ],
    "resolvaient": [
        "resoudre"
    ],
    "resolvais": [
        "resoudre"
    ],
    "resolvait": [
        "resoudre"
    ],
    "resolvant": [
        "resoudre"
    ],
    "resolve": [
        "resoudre"
    ],
    "resolvent": [
        "resoudre"
    ],
    "resolves": [
        "resolve",
        "resoudre"
    ],
    "resolvez": [
        "resoudre"
    ],
    "resolviez": [
        "resoudre"
    ],
    "resolvons": [
        "resoudre"
    ],
    "resonance": [
        "resonance"
    ],
    "resonances": [
        "resonance"
    ],
    "resonateur": [
        "resonateur"
    ],
    "resonna": [
        "resonner"
    ],
    "resonnaient": [
        "resonner"
    ],
    "resonnait": [
        "resonner"
    ],
    "resonnant": [
        "resonner",
        "resonnant"
    ],
    "resonnante": [
        "resonnant"
    ],
    "resonnants": [
        "resonnant"
    ],
    "resonne": [
        "resonner"
    ],
    "resonnent": [
        "resonner"
    ],
    "resonner": [
        "resonner"
    ],
    "resonnera": [
        "resonner"
    ],
    "resonneraient": [
        "resonner"
    ],
    "resonneront": [
        "resonner"
    ],
    "resonnez": [
        "resonner"
    ],
    "resonnerent": [
        "resonner"
    ],
    "resorba": [
        "resorber"
    ],
    "resorbable": [
        "resorbable"
    ],
    "resorbaient": [
        "resorber"
    ],
    "resorbait": [
        "resorber"
    ],
    "resorbant": [
        "resorber"
    ],
    "resorbe": [
        "resorber"
    ],
    "resorbent": [
        "resorber"
    ],
    "resorber": [
        "resorber"
    ],
    "resorberait": [
        "resorber"
    ],
    "resorberons": [
        "resorber"
    ],
    "resorbee": [
        "resorber"
    ],
    "resorbes": [
        "resorber"
    ],
    "resorption": [
        "resorption"
    ],
    "resorptions": [
        "resorption"
    ],
    "resoudra": [
        "resoudre"
    ],
    "resoudrai": [
        "resoudre"
    ],
    "resoudraient": [
        "resoudre"
    ],
    "resoudrais": [
        "resoudre"
    ],
    "resoudrait": [
        "resoudre"
    ],
    "resoudras": [
        "resoudre"
    ],
    "resoudre": [
        "resoudre"
    ],
    "resoudrez": [
        "resoudre"
    ],
    "resoudrons": [
        "resoudre"
    ],
    "resoudront": [
        "resoudre"
    ],
    "resous": [
        "resoudre"
    ],
    "resout": [
        "resoudre"
    ],
    "resulta": [
        "resulter"
    ],
    "resultaient": [
        "resulter"
    ],
    "resultais": [
        "resulter"
    ],
    "resultait": [
        "resulter"
    ],
    "resultant": [
        "resulter",
        "resultant"
    ],
    "resultante": [
        "resultante",
        "resultant"
    ],
    "resultantes": [
        "resultante"
    ],
    "resultat": [
        "resultat"
    ],
    "resultats": [
        "resultat"
    ],
    "resulte": [
        "resulter"
    ],
    "resultent": [
        "resulter"
    ],
    "resulter": [
        "resulter"
    ],
    "resulteraient": [
        "resulter"
    ],
    "resulterait": [
        "resulter"
    ],
    "resulteront": [
        "resulter"
    ],
    "resultees": [
        "resulter"
    ],
    "resuma": [
        "resumer"
    ],
    "resumai": [
        "resumer"
    ],
    "resumaient": [
        "resumer"
    ],
    "resumais": [
        "resumer"
    ],
    "resumait": [
        "resumer"
    ],
    "resumant": [
        "resumer"
    ],
    "resume": [
        "resumer",
        "resume"
    ],
    "resument": [
        "resumer"
    ],
    "resumer": [
        "resumer"
    ],
    "resumera": [
        "resumer"
    ],
    "resumerai": [
        "resumer"
    ],
    "resumerait": [
        "resumer"
    ],
    "resumeriez": [
        "resumer"
    ],
    "resumez": [
        "resumer"
    ],
    "resumons": [
        "resumer"
    ],
    "resumee": [
        "resumer"
    ],
    "resumees": [
        "resumer"
    ],
    "resumes": [
        "resumer",
        "resume"
    ],
    "resurgence": [
        "resurgence"
    ],
    "resurgences": [
        "resurgence"
    ],
    "resurgente": [
        "resurgent"
    ],
    "resurrection": [
        "resurrection"
    ],
    "resurrections": [
        "resurrection"
    ],
    "reseda": [
        "reseda"
    ],
    "resedas": [
        "reseda"
    ],
    "resequer": [
        "resequer"
    ],
    "retabli": [
        "retablir"
    ],
    "retablie": [
        "retablir"
    ],
    "retablies": [
        "retablir"
    ],
    "retablir": [
        "retablir"
    ],
    "retablira": [
        "retablir"
    ],
    "retablirai": [
        "retablir"
    ],
    "retablirait": [
        "retablir"
    ],
    "retabliras": [
        "retablir"
    ],
    "retablirent": [
        "retablir"
    ],
    "retablirez": [
        "retablir"
    ],
    "retablirons": [
        "retablir"
    ],
    "retabliront": [
        "retablir"
    ],
    "retablis": [
        "retablir"
    ],
    "retablissaient": [
        "retablir"
    ],
    "retablissais": [
        "retablir"
    ],
    "retablissait": [
        "retablir"
    ],
    "retablissant": [
        "retablir"
    ],
    "retablisse": [
        "retablir"
    ],
    "retablissement": [
        "retablissement"
    ],
    "retablissements": [
        "retablissement"
    ],
    "retablissent": [
        "retablir"
    ],
    "retablisses": [
        "retablir"
    ],
    "retablissez": [
        "retablir"
    ],
    "retablissons": [
        "retablir"
    ],
    "retablit": [
        "retablir"
    ],
    "retamai": [
        "retamer"
    ],
    "retamait": [
        "retamer"
    ],
    "retame": [
        "retamer"
    ],
    "retamer": [
        "retamer"
    ],
    "retameras": [
        "retamer"
    ],
    "retameur": [
        "retameur"
    ],
    "retamees": [
        "retamer"
    ],
    "retames": [
        "retamer"
    ],
    "retention": [
        "retention"
    ],
    "reticence": [
        "reticence"
    ],
    "reticences": [
        "reticence"
    ],
    "reticent": [
        "reticent"
    ],
    "reticente": [
        "reticent"
    ],
    "reticentes": [
        "reticent"
    ],
    "reticents": [
        "reticent"
    ],
    "reticulaire": [
        "reticulaire"
    ],
    "reticulaires": [
        "reticulaire"
    ],
    "reticulation": [
        "reticulation"
    ],
    "reticule": [
        "reticule"
    ],
    "reticulum": [
        "reticulum"
    ],
    "reticulee": [
        "reticuler",
        "reticule"
    ],
    "retif": [
        "retif"
    ],
    "retifs": [
        "retif"
    ],
    "retinal": [
        "retinal"
    ],
    "retine": [
        "retine"
    ],
    "retines": [
        "retine"
    ],
    "retinien": [
        "retinien"
    ],
    "retinienne": [
        "retinien"
    ],
    "retiniennes": [
        "retinien"
    ],
    "retinite": [
        "retinite"
    ],
    "retinopathie": [
        "retinopathie"
    ],
    "retive": [
        "retif"
    ],
    "retives": [
        "retif"
    ],
    "retorqua": [
        "retorquer"
    ],
    "retorquai": [
        "retorquer"
    ],
    "retorquais": [
        "retorquer"
    ],
    "retorquait": [
        "retorquer"
    ],
    "retorquant": [
        "retorquer"
    ],
    "retorque": [
        "retorquer"
    ],
    "retorquer": [
        "retorquer"
    ],
    "retorquera": [
        "retorquer"
    ],
    "retorquerent": [
        "retorquer"
    ],
    "retorsion": [
        "retorsion"
    ],
    "retracta": [
        "retracter"
    ],
    "retractable": [
        "retractable"
    ],
    "retractais": [
        "retracter"
    ],
    "retractait": [
        "retracter"
    ],
    "retractant": [
        "retracter"
    ],
    "retractation": [
        "retractation"
    ],
    "retractations": [
        "retractation"
    ],
    "retracte": [
        "retracter"
    ],
    "retractent": [
        "retracter"
    ],
    "retracter": [
        "retracter"
    ],
    "retractera": [
        "retracter"
    ],
    "retracterait": [
        "retracter"
    ],
    "retracteur": [
        "retracteur"
    ],
    "retracteurs": [
        "retracteur"
    ],
    "retractez": [
        "retracter"
    ],
    "retractile": [
        "retractile"
    ],
    "retractiles": [
        "retractile"
    ],
    "retraction": [
        "retraction"
    ],
    "retracterent": [
        "retracter"
    ],
    "retractee": [
        "retracter"
    ],
    "retractees": [
        "retracter"
    ],
    "retractes": [
        "retracter"
    ],
    "retreint": [
        "retreindre"
    ],
    "retribuant": [
        "retribuer"
    ],
    "retribue": [
        "retribuer",
        "retribue"
    ],
    "retribuer": [
        "retribuer"
    ],
    "retribution": [
        "retribution"
    ],
    "retributions": [
        "retribution"
    ],
    "retribuee": [
        "retribuer",
        "retribue"
    ],
    "retribues": [
        "retribuer"
    ],
    "retro": [
        "retro"
    ],
    "retroactif": [
        "retroactif"
    ],
    "retroaction": [
        "retroaction"
    ],
    "retroactive": [
        "retroactif"
    ],
    "retroactivement": [
        "retroactivement"
    ],
    "retrocession": [
        "retrocession"
    ],
    "retrocede": [
        "retroceder"
    ],
    "retrocedait": [
        "retroceder"
    ],
    "retroceder": [
        "retroceder"
    ],
    "retrofusee": [
        "retrofusee"
    ],
    "retrofusees": [
        "retrofusee"
    ],
    "retrograda": [
        "retrograder"
    ],
    "retrogradation": [
        "retrogradation"
    ],
    "retrogradations": [
        "retrogradation"
    ],
    "retrograde": [
        "retrograder",
        "retrograde"
    ],
    "retrogradent": [
        "retrograder"
    ],
    "retrograder": [
        "retrograder"
    ],
    "retrogrades": [
        "retrograder",
        "retrograde"
    ],
    "retrogradez": [
        "retrograder"
    ],
    "retrogradee": [
        "retrograder"
    ],
    "retrogression": [
        "retrogression"
    ],
    "retroprojecteur": [
        "retroprojecteur"
    ],
    "retropropulsion": [
        "retropropulsion"
    ],
    "retros": [
        "retro"
    ],
    "retrospectif": [
        "retrospectif"
    ],
    "retrospectifs": [
        "retrospectif"
    ],
    "retrospection": [
        "retrospection"
    ],
    "retrospective": [
        "retrospective",
        "retrospectif"
    ],
    "retrospectivement": [
        "retrospectivement"
    ],
    "retrospectives": [
        "retrospective",
        "retrospectif"
    ],
    "retroversion": [
        "retroversion"
    ],
    "retrovirale": [
        "retroviral"
    ],
    "retrovirus": [
        "retrovirus"
    ],
    "retroviseur": [
        "retroviseur"
    ],
    "retroviseurs": [
        "retroviseur"
    ],
    "retreci": [
        "retreci",
        "retrecir"
    ],
    "retrecie": [
        "retreci",
        "retrecir"
    ],
    "retrecies": [
        "retreci",
        "retrecir"
    ],
    "retrecir": [
        "retrecir"
    ],
    "retrecirent": [
        "retrecir"
    ],
    "retrecis": [
        "retreci",
        "retrecir"
    ],
    "retrecissaient": [
        "retrecir"
    ],
    "retrecissait": [
        "retrecir"
    ],
    "retrecissant": [
        "retrecir"
    ],
    "retrecisse": [
        "retrecir"
    ],
    "retrecissement": [
        "retrecissement"
    ],
    "retrecissements": [
        "retrecissement"
    ],
    "retrecissent": [
        "retrecir"
    ],
    "retrecissez": [
        "retrecir"
    ],
    "retrecit": [
        "retrecir"
    ],
    "reuni": [
        "reunir"
    ],
    "reunie": [
        "reunir"
    ],
    "reunies": [
        "reunir"
    ],
    "reunification": [
        "reunification"
    ],
    "reunifier": [
        "reunifier"
    ],
    "reunifie": [
        "reunifier"
    ],
    "reunifiee": [
        "reunifier"
    ],
    "reunifiees": [
        "reunifier"
    ],
    "reunion": [
        "reunion"
    ],
    "reunionnais": [
        "reunionnais"
    ],
    "reunionnite": [
        "reunionnite"
    ],
    "reunions": [
        "reunion"
    ],
    "reunir": [
        "reunir"
    ],
    "reunira": [
        "reunir"
    ],
    "reunirai": [
        "reunir"
    ],
    "reuniraient": [
        "reunir"
    ],
    "reunirais": [
        "reunir"
    ],
    "reunirait": [
        "reunir"
    ],
    "reuniras": [
        "reunir"
    ],
    "reunirent": [
        "reunir"
    ],
    "reunirons": [
        "reunir"
    ],
    "reuniront": [
        "reunir"
    ],
    "reunis": [
        "reunir"
    ],
    "reunissaient": [
        "reunir"
    ],
    "reunissais": [
        "reunir"
    ],
    "reunissait": [
        "reunir"
    ],
    "reunissant": [
        "reunir"
    ],
    "reunisse": [
        "reunir"
    ],
    "reunissent": [
        "reunir"
    ],
    "reunisses": [
        "reunir"
    ],
    "reunissez": [
        "reunir"
    ],
    "reunissions": [
        "reunir"
    ],
    "reunissons": [
        "reunir"
    ],
    "reunit": [
        "reunir"
    ],
    "reunimes": [
        "reunir"
    ],
    "reussi": [
        "reussir",
        "reussi"
    ],
    "reussie": [
        "reussir",
        "reussi"
    ],
    "reussies": [
        "reussir",
        "reussi"
    ],
    "reussir": [
        "reussir"
    ],
    "reussira": [
        "reussir"
    ],
    "reussirai": [
        "reussir"
    ],
    "reussiraient": [
        "reussir"
    ],
    "reussirais": [
        "reussir"
    ],
    "reussirait": [
        "reussir"
    ],
    "reussiras": [
        "reussir"
    ],
    "reussirent": [
        "reussir"
    ],
    "reussirez": [
        "reussir"
    ],
    "reussiriez": [
        "reussir"
    ],
    "reussirions": [
        "reussir"
    ],
    "reussirons": [
        "reussir"
    ],
    "reussiront": [
        "reussir"
    ],
    "reussis": [
        "reussir",
        "reussi"
    ],
    "reussissaient": [
        "reussir"
    ],
    "reussissais": [
        "reussir"
    ],
    "reussissait": [
        "reussir"
    ],
    "reussissant": [
        "reussir"
    ],
    "reussisse": [
        "reussir"
    ],
    "reussissent": [
        "reussir"
    ],
    "reussisses": [
        "reussir"
    ],
    "reussissez": [
        "reussir"
    ],
    "reussissiez": [
        "reussir"
    ],
    "reussissions": [
        "reussir"
    ],
    "reussissons": [
        "reussir"
    ],
    "reussit": [
        "reussir"
    ],
    "reussite": [
        "reussite"
    ],
    "reussites": [
        "reussite"
    ],
    "reussimes": [
        "reussir"
    ],
    "reutilisables": [
        "reutilisable"
    ],
    "reutilisait": [
        "reutiliser"
    ],
    "reutilisation": [
        "reutilisation"
    ],
    "reutilise": [
        "reutiliser"
    ],
    "reutiliser": [
        "reutiliser"
    ],
    "reutilises": [
        "reutiliser"
    ],
    "reveil": [
        "reveil"
    ],
    "reveilla": [
        "reveiller"
    ],
    "reveillai": [
        "reveiller"
    ],
    "reveillaient": [
        "reveiller"
    ],
    "reveillais": [
        "reveiller"
    ],
    "reveillait": [
        "reveiller"
    ],
    "reveillant": [
        "reveiller"
    ],
    "reveille": [
        "reveiller"
    ],
    "reveillent": [
        "reveiller"
    ],
    "reveiller": [
        "reveiller"
    ],
    "reveillera": [
        "reveiller"
    ],
    "reveillerai": [
        "reveiller"
    ],
    "reveilleraient": [
        "reveiller"
    ],
    "reveillerais": [
        "reveiller"
    ],
    "reveillerait": [
        "reveiller"
    ],
    "reveilleras": [
        "reveiller"
    ],
    "reveillerez": [
        "reveiller"
    ],
    "reveilleriez": [
        "reveiller"
    ],
    "reveillerons": [
        "reveiller"
    ],
    "reveilleront": [
        "reveiller"
    ],
    "reveilles": [
        "reveiller"
    ],
    "reveilleurs": [
        "reveilleur"
    ],
    "reveillez": [
        "reveiller"
    ],
    "reveilliez": [
        "reveiller"
    ],
    "reveillions": [
        "reveiller"
    ],
    "reveillon": [
        "reveillon"
    ],
    "reveillonnaient": [
        "reveillonner"
    ],
    "reveillonnait": [
        "reveillonner"
    ],
    "reveillonne": [
        "reveillonner"
    ],
    "reveillonner": [
        "reveillonner"
    ],
    "reveillonnerons": [
        "reveillonner"
    ],
    "reveillonneurs": [
        "reveillonneur"
    ],
    "reveillonnons": [
        "reveillonner"
    ],
    "reveillonnames": [
        "reveillonner"
    ],
    "reveillonnerent": [
        "reveillonner"
    ],
    "reveillons": [
        "reveillon",
        "reveiller"
    ],
    "reveillames": [
        "reveiller"
    ],
    "reveillat": [
        "reveiller"
    ],
    "reveillerent": [
        "reveiller"
    ],
    "reveillee": [
        "reveiller"
    ],
    "reveillees": [
        "reveiller"
    ],
    "reveils": [
        "reveil"
    ],
    "reverbere": [
        "reverbere",
        "reverberer"
    ],
    "reverberent": [
        "reverberer"
    ],
    "reverberes": [
        "reverbere"
    ],
    "reverbera": [
        "reverberer"
    ],
    "reverberaient": [
        "reverberer"
    ],
    "reverberait": [
        "reverberer"
    ],
    "reverberant": [
        "reverberant",
        "reverberer"
    ],
    "reverberation": [
        "reverberation"
    ],
    "reverberations": [
        "reverberation"
    ],
    "reverberer": [
        "reverberer"
    ],
    "reverberee": [
        "reverberer"
    ],
    "reversibilite": [
        "reversibilite"
    ],
    "reversible": [
        "reversible"
    ],
    "reversibles": [
        "reversible"
    ],
    "reversion": [
        "reversion"
    ],
    "revisa": [
        "reviser"
    ],
    "revisai": [
        "reviser"
    ],
    "revisaient": [
        "reviser"
    ],
    "revisais": [
        "reviser"
    ],
    "revisait": [
        "reviser"
    ],
    "revisant": [
        "reviser"
    ],
    "revise": [
        "reviser"
    ],
    "revisent": [
        "reviser"
    ],
    "reviser": [
        "reviser"
    ],
    "reviserais": [
        "reviser"
    ],
    "reviserait": [
        "reviser"
    ],
    "revises": [
        "revise",
        "reviser"
    ],
    "reviseur": [
        "reviseur"
    ],
    "revisez": [
        "reviser"
    ],
    "revisiez": [
        "reviser"
    ],
    "revision": [
        "revision"
    ],
    "revisionnisme": [
        "revisionnisme"
    ],
    "revisionniste": [
        "revisionniste"
    ],
    "revisionnistes": [
        "revisionniste"
    ],
    "revisions": [
        "revision"
    ],
    "reviso": [
        "reviso"
    ],
    "revisons": [
        "reviser"
    ],
    "revisee": [
        "reviser"
    ],
    "revisees": [
        "reviser"
    ],
    "revocable": [
        "revocable"
    ],
    "revocables": [
        "revocable"
    ],
    "revocation": [
        "revocation"
    ],
    "revocations": [
        "revocation"
    ],
    "revolta": [
        "revolter"
    ],
    "revoltai": [
        "revolter"
    ],
    "revoltaient": [
        "revolter"
    ],
    "revoltais": [
        "revolter"
    ],
    "revoltait": [
        "revolter"
    ],
    "revoltant": [
        "revolter",
        "revoltant"
    ],
    "revoltante": [
        "revoltant"
    ],
    "revoltantes": [
        "revoltant"
    ],
    "revoltants": [
        "revoltant"
    ],
    "revolte": [
        "revolte",
        "revolter"
    ],
    "revoltent": [
        "revolter"
    ],
    "revolter": [
        "revolter"
    ],
    "revolteront": [
        "revolter"
    ],
    "revoltes": [
        "revolte",
        "revolter"
    ],
    "revoltez": [
        "revolter"
    ],
    "revoltions": [
        "revolter"
    ],
    "revoltons": [
        "revolter"
    ],
    "revoltat": [
        "revolter"
    ],
    "revolterent": [
        "revolter"
    ],
    "revoltee": [
        "revolte",
        "revolter"
    ],
    "revoltees": [
        "revolte",
        "revolter"
    ],
    "revolu": [
        "revolu"
    ],
    "revolue": [
        "revolu"
    ],
    "revolues": [
        "revolu"
    ],
    "revolus": [
        "revolu"
    ],
    "revolution": [
        "revolution"
    ],
    "revolutionna": [
        "revolutionner"
    ],
    "revolutionnaient": [
        "revolutionner"
    ],
    "revolutionnaire": [
        "revolutionnaire"
    ],
    "revolutionnairement": [
        "revolutionnairement"
    ],
    "revolutionnaires": [
        "revolutionnaire"
    ],
    "revolutionnait": [
        "revolutionner"
    ],
    "revolutionner": [
        "revolutionner"
    ],
    "revolutionnera": [
        "revolutionner"
    ],
    "revolutionnerait": [
        "revolutionner"
    ],
    "revolutionneront": [
        "revolutionner"
    ],
    "revolutionne": [
        "revolutionner"
    ],
    "revolutionnees": [
        "revolutionner"
    ],
    "revolutions": [
        "revolution"
    ],
    "revoquais": [
        "revoquer"
    ],
    "revoque": [
        "revoquer"
    ],
    "revoquer": [
        "revoquer"
    ],
    "revoquee": [
        "revoquer"
    ],
    "revoquees": [
        "revoquer"
    ],
    "revoques": [
        "revoquer"
    ],
    "revulsaient": [
        "revulser"
    ],
    "revulsait": [
        "revulser"
    ],
    "revulsant": [
        "revulser"
    ],
    "revulse": [
        "revulse",
        "revulser"
    ],
    "revulser": [
        "revulser"
    ],
    "revulserait": [
        "revulser"
    ],
    "revulsif": [
        "revulsif"
    ],
    "revulsifs": [
        "revulsif"
    ],
    "revulsion": [
        "revulsion"
    ],
    "revulsive": [
        "revulsif"
    ],
    "revulserent": [
        "revulser"
    ],
    "revulsee": [
        "revulse",
        "revulser"
    ],
    "revulses": [
        "revulse",
        "revulser"
    ],
    "revele": [
        "revele",
        "reveler"
    ],
    "revelent": [
        "reveler"
    ],
    "reveles": [
        "revele",
        "reveler"
    ],
    "revere": [
        "reverer"
    ],
    "reverent": [
        "rever",
        "reverer"
    ],
    "revela": [
        "reveler"
    ],
    "revelai": [
        "reveler"
    ],
    "revelaient": [
        "reveler"
    ],
    "revelais": [
        "reveler"
    ],
    "revelait": [
        "reveler"
    ],
    "revelant": [
        "reveler"
    ],
    "revelateur": [
        "revelateur"
    ],
    "revelateurs": [
        "revelateur"
    ],
    "revelation": [
        "revelation"
    ],
    "revelations": [
        "revelation"
    ],
    "revelatrice": [
        "revelateur"
    ],
    "revelatrices": [
        "revelateur"
    ],
    "reveler": [
        "reveler"
    ],
    "revelera": [
        "reveler"
    ],
    "revelerai": [
        "reveler"
    ],
    "reveleraient": [
        "reveler"
    ],
    "revelerais": [
        "reveler"
    ],
    "revelerait": [
        "reveler"
    ],
    "reveleras": [
        "reveler"
    ],
    "revelerez": [
        "reveler"
    ],
    "revelerons": [
        "reveler"
    ],
    "reveleront": [
        "reveler"
    ],
    "revelez": [
        "reveler"
    ],
    "reveliez": [
        "reveler"
    ],
    "revelons": [
        "reveler"
    ],
    "revelat": [
        "reveler"
    ],
    "revelerent": [
        "reveler"
    ],
    "revelee": [
        "revele",
        "reveler"
    ],
    "revelees": [
        "revele",
        "reveler"
    ],
    "reverait": [
        "rever",
        "reverer"
    ],
    "reverant": [
        "reverer"
    ],
    "reverence": [
        "reverence"
    ],
    "reverences": [
        "reverence"
    ],
    "reverenciel": [
        "reverenciel"
    ],
    "reverencieuse": [
        "reverencieux"
    ],
    "reverencieusement": [
        "reverencieusement"
    ],
    "reverencieux": [
        "reverencieux"
    ],
    "reverend": [
        "reverend"
    ],
    "reverende": [
        "reverend"
    ],
    "reverendissime": [
        "reverendissime"
    ],
    "reverends": [
        "reverend"
    ],
    "reverer": [
        "reverer"
    ],
    "revererait": [
        "reverer"
    ],
    "reverons": [
        "reverer"
    ],
    "reveree": [
        "reverer"
    ],
    "reechelonnement": [
        "reechelonnement"
    ],
    "reecoutais": [
        "reecouter"
    ],
    "reecoutait": [
        "reecouter"
    ],
    "reecoute": [
        "reecouter"
    ],
    "reecoutent": [
        "reecouter"
    ],
    "reecouter": [
        "reecouter"
    ],
    "reecouterez": [
        "reecouter"
    ],
    "reecrira": [
        "reecrire"
    ],
    "reecrirai": [
        "reecrire"
    ],
    "reecrire": [
        "reecrire"
    ],
    "reecris": [
        "reecrire"
    ],
    "reecrit": [
        "reecrire"
    ],
    "reecrite": [
        "reecrire"
    ],
    "reecrits": [
        "reecrire"
    ],
    "reecriture": [
        "reecriture"
    ],
    "reecritures": [
        "reecriture"
    ],
    "reecrivaient": [
        "reecrire"
    ],
    "reecrive": [
        "reecrire"
    ],
    "reecrivez": [
        "reecrire"
    ],
    "reedifier": [
        "reedifier"
    ],
    "reedifieras": [
        "reedifier"
    ],
    "reeditait": [
        "reediter"
    ],
    "reeditant": [
        "reediter"
    ],
    "reediter": [
        "reediter"
    ],
    "reedition": [
        "reedition"
    ],
    "reeditions": [
        "reedition"
    ],
    "reedite": [
        "reediter"
    ],
    "reeditees": [
        "reediter"
    ],
    "reedites": [
        "reediter"
    ],
    "reeducateur": [
        "reeducateur"
    ],
    "reeducation": [
        "reeducation"
    ],
    "reeduquais": [
        "reeduquer"
    ],
    "reeduquait": [
        "reeduquer"
    ],
    "reeduque": [
        "reeduquer"
    ],
    "reeduquer": [
        "reeduquer"
    ],
    "reeduques": [
        "reeduquer"
    ],
    "reelection": [
        "reelection"
    ],
    "reeligible": [
        "reeligible"
    ],
    "reelira": [
        "reelire"
    ],
    "reelire": [
        "reelire"
    ],
    "reelisent": [
        "reelire"
    ],
    "reelisez": [
        "reelire"
    ],
    "reelu": [
        "reelu",
        "reelire"
    ],
    "reelus": [
        "reelus",
        "reelire"
    ],
    "reelut": [
        "reelire"
    ],
    "reequilibrage": [
        "reequilibrage"
    ],
    "reequilibrait": [
        "reequilibrer"
    ],
    "reequilibrant": [
        "reequilibrer"
    ],
    "reequilibre": [
        "reequilibrer"
    ],
    "reequilibrer": [
        "reequilibrer"
    ],
    "reequilibrera": [
        "reequilibrer"
    ],
    "reequipent": [
        "reequiper"
    ],
    "reequiper": [
        "reequiper"
    ],
    "reequipe": [
        "reequiper"
    ],
    "reequipee": [
        "reequiper"
    ],
    "reetudier": [
        "reetudier"
    ],
    "reetudiez": [
        "reetudier"
    ],
    "reevaluation": [
        "reevaluation"
    ],
    "reevalue": [
        "reevaluer"
    ],
    "reevaluer": [
        "reevaluer"
    ],
    "reevaluera": [
        "reevaluer"
    ],
    "reevaluez": [
        "reevaluer"
    ],
    "reevaluee": [
        "reevaluer"
    ],
    "reevaluees": [
        "reevaluer"
    ],
    "reevalues": [
        "reevaluer"
    ],
    "reche": [
        "reche"
    ],
    "reches": [
        "reche"
    ],
    "renes": [
        "rene"
    ],
    "reva": [
        "rever"
    ],
    "revai": [
        "rever"
    ],
    "revaient": [
        "rever"
    ],
    "revais": [
        "rever"
    ],
    "revait": [
        "rever"
    ],
    "revant": [
        "rever"
    ],
    "revassa": [
        "revasser"
    ],
    "revassai": [
        "revasser"
    ],
    "revassaient": [
        "revasser"
    ],
    "revassais": [
        "revasser"
    ],
    "revassait": [
        "revasser"
    ],
    "revassant": [
        "revasser",
        "revassant"
    ],
    "revasse": [
        "revasser"
    ],
    "revassent": [
        "revasser"
    ],
    "revasser": [
        "revasser"
    ],
    "revasserie": [
        "revasserie"
    ],
    "revasseries": [
        "revasserie"
    ],
    "reve": [
        "rever",
        "reve"
    ],
    "revent": [
        "rever"
    ],
    "rever": [
        "rever"
    ],
    "revera": [
        "rever"
    ],
    "reverai": [
        "rever"
    ],
    "reveraient": [
        "rever"
    ],
    "reverie": [
        "reverie"
    ],
    "reveries": [
        "reverie"
    ],
    "reveront": [
        "rever"
    ],
    "reves": [
        "rever",
        "reve"
    ],
    "reveur": [
        "reveur"
    ],
    "reveurs": [
        "reveur"
    ],
    "reveuse": [
        "reveur"
    ],
    "reveusement": [
        "reveusement"
    ],
    "reveuses": [
        "reveur"
    ],
    "revez": [
        "rever"
    ],
    "reviez": [
        "rever"
    ],
    "revions": [
        "rever"
    ],
    "revons": [
        "rever"
    ],
    "revat": [
        "rever"
    ],
    "revee": [
        "rever",
        "reve"
    ],
    "revees": [
        "rever",
        "reve"
    ],
    "roda": [
        "roder"
    ],
    "rodai": [
        "roder"
    ],
    "rodaient": [
        "roder"
    ],
    "rodailler": [
        "rodailler"
    ],
    "rodais": [
        "roder"
    ],
    "rodant": [
        "roder"
    ],
    "rodent": [
        "roder"
    ],
    "rodera": [
        "roder"
    ],
    "roderai": [
        "roder"
    ],
    "rodeur": [
        "rodeur"
    ],
    "rodeurs": [
        "rodeur"
    ],
    "rodeuse": [
        "rodeur"
    ],
    "rodeuses": [
        "rodeur"
    ],
    "rodez": [
        "roder"
    ],
    "rodiez": [
        "roder"
    ],
    "rodions": [
        "roder"
    ],
    "rodames": [
        "roder"
    ],
    "roderent": [
        "roder"
    ],
    "role": [
        "role"
    ],
    "roles": [
        "role"
    ],
    "ronier": [
        "ronier"
    ],
    "roniers": [
        "ronier"
    ],
    "ronins": [
        "ronin"
    ],
    "roti": [
        "rotir",
        "roti"
    ],
    "rotie": [
        "rotir",
        "rotie",
        "roti"
    ],
    "roties": [
        "rotir",
        "rotie",
        "roti"
    ],
    "rotir": [
        "rotir"
    ],
    "rotiront": [
        "rotir"
    ],
    "rotis": [
        "rotir",
        "roti"
    ],
    "rotissaient": [
        "rotir"
    ],
    "rotissait": [
        "rotir"
    ],
    "rotissant": [
        "rotir"
    ],
    "rotissent": [
        "rotir"
    ],
    "rotisserie": [
        "rotisserie"
    ],
    "rotisseur": [
        "rotisseur"
    ],
    "rotisseurs": [
        "rotisseur"
    ],
    "rotisseuse": [
        "rotisseur"
    ],
    "rotisseuses": [
        "rotisseur"
    ],
    "rotissez": [
        "rotir"
    ],
    "rotissions": [
        "rotir"
    ],
    "rotissoire": [
        "rotissoire"
    ],
    "rotissoires": [
        "rotissoire"
    ],
    "rotit": [
        "rotir"
    ],
    "rontgens": [
        "rontgen"
    ],
    "s": [
        "avoir",
        "s"
    ],
    "s'": [
        "s'",
        "s",
        "se"
    ],
    "sa": [
        "sa",
        "son"
    ],
    "sabayon": [
        "sabayon"
    ],
    "sabayons": [
        "sabayon"
    ],
    "sabbat": [
        "sabbat"
    ],
    "sabbatique": [
        "sabbatique"
    ],
    "sabbatiques": [
        "sabbatique"
    ],
    "sabbats": [
        "sabbat"
    ],
    "sabelles": [
        "sabelle"
    ],
    "sabin": [
        "sabin"
    ],
    "sabines": [
        "sabine"
    ],
    "sabins": [
        "sabin"
    ],
    "sabir": [
        "sabir"
    ],
    "sabla": [
        "sabler"
    ],
    "sablaient": [
        "sabler"
    ],
    "sablait": [
        "sabler"
    ],
    "sablant": [
        "sabler"
    ],
    "sable": [
        "sable",
        "sabler"
    ],
    "sabler": [
        "sabler"
    ],
    "sablera": [
        "sabler"
    ],
    "sablerais": [
        "sabler"
    ],
    "sables": [
        "sable",
        "sabler"
    ],
    "sableuse": [
        "sableux"
    ],
    "sableuses": [
        "sableux"
    ],
    "sableux": [
        "sableux"
    ],
    "sablez": [
        "sabler"
    ],
    "sablier": [
        "sablier"
    ],
    "sabliers": [
        "sablier"
    ],
    "sabliere": [
        "sabliere"
    ],
    "sablieres": [
        "sabliere"
    ],
    "sablonneuse": [
        "sablonneux"
    ],
    "sablonneuses": [
        "sablonneux"
    ],
    "sablonneux": [
        "sablonneux"
    ],
    "sablons": [
        "sablon"
    ],
    "sablee": [
        "sable",
        "sabler"
    ],
    "sablees": [
        "sable"
    ],
    "sabord": [
        "sabord"
    ],
    "sabordage": [
        "sabordage"
    ],
    "sabordait": [
        "saborder"
    ],
    "saborde": [
        "saborder"
    ],
    "sabordent": [
        "saborder"
    ],
    "saborder": [
        "saborder"
    ],
    "sabordez": [
        "saborder"
    ],
    "sabords": [
        "sabord"
    ],
    "sabordee": [
        "saborder"
    ],
    "sabordes": [
        "saborder"
    ],
    "sabot": [
        "sabot"
    ],
    "sabotage": [
        "sabotage"
    ],
    "sabotages": [
        "sabotage"
    ],
    "sabotais": [
        "saboter"
    ],
    "sabotait": [
        "saboter"
    ],
    "sabotant": [
        "saboter"
    ],
    "sabote": [
        "saboter"
    ],
    "sabotent": [
        "saboter"
    ],
    "saboter": [
        "saboter"
    ],
    "saboterai": [
        "saboter"
    ],
    "saboterait": [
        "saboter"
    ],
    "saboterie": [
        "saboterie"
    ],
    "saboteront": [
        "saboter"
    ],
    "saboteur": [
        "saboteur"
    ],
    "saboteurs": [
        "saboteur"
    ],
    "saboteuse": [
        "saboteur"
    ],
    "sabotez": [
        "saboter"
    ],
    "sabotier": [
        "sabotier"
    ],
    "sabotiers": [
        "sabotier"
    ],
    "sabotons": [
        "saboter"
    ],
    "sabots": [
        "sabot"
    ],
    "sabotee": [
        "saboter"
    ],
    "sabotees": [
        "saboter"
    ],
    "sabotes": [
        "saboter"
    ],
    "saboule": [
        "sabouler"
    ],
    "saboulent": [
        "sabouler"
    ],
    "sabouler": [
        "sabouler"
    ],
    "saboules": [
        "sabouler"
    ],
    "sabra": [
        "sabra",
        "sabrer"
    ],
    "sabrait": [
        "sabrer"
    ],
    "sabrant": [
        "sabrer"
    ],
    "sabre": [
        "sabrer",
        "sabre"
    ],
    "sabrent": [
        "sabrer"
    ],
    "sabrer": [
        "sabrer"
    ],
    "sabrerai": [
        "sabrer"
    ],
    "sabreraient": [
        "sabrer"
    ],
    "sabrerais": [
        "sabrer"
    ],
    "sabreras": [
        "sabrer"
    ],
    "sabrerons": [
        "sabrer"
    ],
    "sabres": [
        "sabrer",
        "sabre"
    ],
    "sabretache": [
        "sabretache"
    ],
    "sabretaches": [
        "sabretache"
    ],
    "sabreur": [
        "sabreur"
    ],
    "sabreurs": [
        "sabreur"
    ],
    "sabrez": [
        "sabrer"
    ],
    "sabree": [
        "sabrer"
    ],
    "sabrees": [
        "sabrer"
    ],
    "sabeen": [
        "sabeen"
    ],
    "sabeenne": [
        "sabeenne"
    ],
    "sac": [
        "sac"
    ],
    "saccade": [
        "saccade",
        "saccader"
    ],
    "saccader": [
        "saccader"
    ],
    "saccades": [
        "saccade",
        "saccader"
    ],
    "saccadee": [
        "saccade",
        "saccader"
    ],
    "saccadees": [
        "saccade"
    ],
    "saccage": [
        "saccage",
        "saccager"
    ],
    "saccagea": [
        "saccager"
    ],
    "saccageaient": [
        "saccager"
    ],
    "saccageais": [
        "saccager"
    ],
    "saccageait": [
        "saccager"
    ],
    "saccageant": [
        "saccager"
    ],
    "saccagent": [
        "saccager"
    ],
    "saccageons": [
        "saccager"
    ],
    "saccager": [
        "saccager"
    ],
    "saccageraient": [
        "saccager"
    ],
    "saccages": [
        "saccage",
        "saccager"
    ],
    "saccageurs": [
        "saccageur"
    ],
    "saccagez": [
        "saccager"
    ],
    "saccagiez": [
        "saccager"
    ],
    "saccagne": [
        "saccagne"
    ],
    "saccagerent": [
        "saccager"
    ],
    "saccagee": [
        "saccager"
    ],
    "saccagees": [
        "saccager"
    ],
    "saccharine": [
        "saccharine"
    ],
    "saccharomyces": [
        "saccharomyces"
    ],
    "saccharose": [
        "saccharose"
    ],
    "sacculine": [
        "sacculine"
    ],
    "sacculines": [
        "sacculine"
    ],
    "sacerdoce": [
        "sacerdoce"
    ],
    "sacerdoces": [
        "sacerdoce"
    ],
    "sacerdotal": [
        "sacerdotal"
    ],
    "sacerdotale": [
        "sacerdotal"
    ],
    "sacerdotales": [
        "sacerdotal"
    ],
    "sacerdotaux": [
        "sacerdotal"
    ],
    "sachant": [
        "savoir"
    ],
    "sache": [
        "savoir"
    ],
    "sachem": [
        "sachem"
    ],
    "sachent": [
        "savoir"
    ],
    "saches": [
        "savoir"
    ],
    "sachet": [
        "sachet"
    ],
    "sachets": [
        "sachet"
    ],
    "sachez": [
        "savoir"
    ],
    "sachiez": [
        "savoir"
    ],
    "sachions": [
        "savoir"
    ],
    "sachons": [
        "savoir"
    ],
    "sacoche": [
        "sacoche"
    ],
    "sacoches": [
        "sacoche"
    ],
    "sacqua": [
        "sacquer"
    ],
    "sacquais": [
        "sacquer"
    ],
    "sacquant": [
        "sacquer"
    ],
    "sacque": [
        "sacquer"
    ],
    "sacquer": [
        "sacquer"
    ],
    "sacra": [
        "sacrer"
    ],
    "sacrait": [
        "sacrer"
    ],
    "sacralisation": [
        "sacralisation"
    ],
    "sacralises": [
        "sacraliser"
    ],
    "sacramentel": [
        "sacramentel"
    ],
    "sacramentelle": [
        "sacramentel"
    ],
    "sacramentelles": [
        "sacramentel"
    ],
    "sacrant": [
        "sacrer"
    ],
    "sacre": [
        "sacre",
        "sacrer"
    ],
    "sacrebleu": [
        "sacrebleu"
    ],
    "sacredieu": [
        "sacredieu"
    ],
    "sacrement": [
        "sacrement"
    ],
    "sacrements": [
        "sacrement"
    ],
    "sacrer": [
        "sacrer"
    ],
    "sacrera": [
        "sacrer"
    ],
    "sacrerai": [
        "sacrer"
    ],
    "sacres": [
        "sacre",
        "sacrer"
    ],
    "sacret": [
        "sacret"
    ],
    "sacrifia": [
        "sacrifier"
    ],
    "sacrifiaient": [
        "sacrifier"
    ],
    "sacrifiais": [
        "sacrifier"
    ],
    "sacrifiait": [
        "sacrifier"
    ],
    "sacrifiant": [
        "sacrifier"
    ],
    "sacrificateur": [
        "sacrificateur"
    ],
    "sacrificateurs": [
        "sacrificateur"
    ],
    "sacrifice": [
        "sacrifice"
    ],
    "sacrifices": [
        "sacrifice"
    ],
    "sacrificiel": [
        "sacrificiel"
    ],
    "sacrificielle": [
        "sacrificiel"
    ],
    "sacrificiels": [
        "sacrificiel"
    ],
    "sacrifie": [
        "sacrifie",
        "sacrifier"
    ],
    "sacrifient": [
        "sacrifier"
    ],
    "sacrifier": [
        "sacrifier"
    ],
    "sacrifiera": [
        "sacrifier"
    ],
    "sacrifierai": [
        "sacrifier"
    ],
    "sacrifieraient": [
        "sacrifier"
    ],
    "sacrifierais": [
        "sacrifier"
    ],
    "sacrifierait": [
        "sacrifier"
    ],
    "sacrifieras": [
        "sacrifier"
    ],
    "sacrifierez": [
        "sacrifier"
    ],
    "sacrifieriez": [
        "sacrifier"
    ],
    "sacrifierions": [
        "sacrifier"
    ],
    "sacrifierons": [
        "sacrifier"
    ],
    "sacrifies": [
        "sacrifie",
        "sacrifier"
    ],
    "sacrifiez": [
        "sacrifier"
    ],
    "sacrifiiez": [
        "sacrifier"
    ],
    "sacrifions": [
        "sacrifier"
    ],
    "sacrifiat": [
        "sacrifier"
    ],
    "sacrifierent": [
        "sacrifier"
    ],
    "sacrifiee": [
        "sacrifie",
        "sacrifier"
    ],
    "sacrifiees": [
        "sacrifie",
        "sacrifier"
    ],
    "sacrilege": [
        "sacrilege"
    ],
    "sacrileges": [
        "sacrilege"
    ],
    "sacripant": [
        "sacripant"
    ],
    "sacripants": [
        "sacripant"
    ],
    "sacristain": [
        "sacristain"
    ],
    "sacristaine": [
        "sacristain"
    ],
    "sacristaines": [
        "sacristain"
    ],
    "sacristains": [
        "sacristain"
    ],
    "sacristie": [
        "sacristie"
    ],
    "sacristies": [
        "sacristie"
    ],
    "sacristine": [
        "sacristine"
    ],
    "sacro": [
        "sacro"
    ],
    "sacrum": [
        "sacrum"
    ],
    "sacredie": [
        "sacredie"
    ],
    "sacree": [
        "sacre",
        "sacrer"
    ],
    "sacrees": [
        "sacre",
        "sacrer"
    ],
    "sacs": [
        "sac"
    ],
    "sadduceen": [
        "sadduceen"
    ],
    "sadienne": [
        "sadien"
    ],
    "sadique": [
        "sadique"
    ],
    "sadiquement": [
        "sadiquement"
    ],
    "sadiques": [
        "sadique"
    ],
    "sadisme": [
        "sadisme"
    ],
    "sadismes": [
        "sadisme"
    ],
    "sado": [
        "sado"
    ],
    "sadomasochisme": [
        "sadomasochisme"
    ],
    "sadomasochiste": [
        "sadomasochiste"
    ],
    "sados": [
        "sado"
    ],
    "saduceen": [
        "saduceen"
    ],
    "safari": [
        "safari"
    ],
    "safaris": [
        "safari"
    ],
    "safran": [
        "safran"
    ],
    "safrane": [
        "safrane",
        "safraner"
    ],
    "saga": [
        "saga"
    ],
    "sagace": [
        "sagace"
    ],
    "sagaces": [
        "sagace"
    ],
    "sagacite": [
        "sagacite"
    ],
    "sagaie": [
        "sagaie"
    ],
    "sagaies": [
        "sagaie"
    ],
    "sagard": [
        "sagard"
    ],
    "sagas": [
        "saga"
    ],
    "sage": [
        "sage"
    ],
    "sagement": [
        "sagement"
    ],
    "sages": [
        "sage"
    ],
    "sagesse": [
        "sagesse"
    ],
    "sagesses": [
        "sagesse"
    ],
    "sagettes": [
        "sagette"
    ],
    "sagittaire": [
        "sagittaire"
    ],
    "sagittaires": [
        "sagittaire"
    ],
    "sagittal": [
        "sagittal"
    ],
    "sagittale": [
        "sagittal"
    ],
    "sagouin": [
        "sagouin"
    ],
    "sagouins": [
        "sagouin"
    ],
    "sagoutier": [
        "sagoutier"
    ],
    "sagum": [
        "sagum"
    ],
    "saharien": [
        "saharien"
    ],
    "saharienne": [
        "saharien"
    ],
    "sahariennes": [
        "saharien"
    ],
    "sahariens": [
        "saharien"
    ],
    "sahib": [
        "sahib"
    ],
    "sahibs": [
        "sahib"
    ],
    "saie": [
        "saie"
    ],
    "saigna": [
        "saigner"
    ],
    "saignaient": [
        "saigner"
    ],
    "saignais": [
        "saigner"
    ],
    "saignait": [
        "saigner"
    ],
    "saignant": [
        "saignant",
        "saigner"
    ],
    "saignante": [
        "saignant"
    ],
    "saignantes": [
        "saignant"
    ],
    "saignants": [
        "saignant"
    ],
    "saignasse": [
        "saigner"
    ],
    "saigne": [
        "saigner"
    ],
    "saignement": [
        "saignement"
    ],
    "saignements": [
        "saignement"
    ],
    "saignent": [
        "saigner"
    ],
    "saigner": [
        "saigner"
    ],
    "saignera": [
        "saigner"
    ],
    "saignerai": [
        "saigner"
    ],
    "saignerais": [
        "saigner"
    ],
    "saignerait": [
        "saigner"
    ],
    "saigneras": [
        "saigner"
    ],
    "saignerez": [
        "saigner"
    ],
    "saigneront": [
        "saigner"
    ],
    "saignes": [
        "saigner"
    ],
    "saigneur": [
        "saigneur"
    ],
    "saignez": [
        "saigner"
    ],
    "saigniez": [
        "saigner"
    ],
    "saignons": [
        "saigner"
    ],
    "saignee": [
        "saigner",
        "saignee"
    ],
    "saignees": [
        "saigner",
        "saignee"
    ],
    "saillaient": [
        "sailler"
    ],
    "saillait": [
        "sailler"
    ],
    "saillant": [
        "sailler",
        "saillant"
    ],
    "saillante": [
        "saillant"
    ],
    "saillantes": [
        "saillant"
    ],
    "saillants": [
        "saillant"
    ],
    "saille": [
        "sailler"
    ],
    "saillent": [
        "sailler"
    ],
    "sailli": [
        "saillir"
    ],
    "saillie": [
        "saillie",
        "saillir"
    ],
    "saillies": [
        "saillie"
    ],
    "saillir": [
        "saillir"
    ],
    "saillissent": [
        "saillir"
    ],
    "saillit": [
        "saillir"
    ],
    "sain": [
        "sain"
    ],
    "saindoux": [
        "saindoux"
    ],
    "saine": [
        "sain"
    ],
    "sainement": [
        "sainement"
    ],
    "saines": [
        "sain"
    ],
    "sainfoin": [
        "sainfoin"
    ],
    "sainfoins": [
        "sainfoin"
    ],
    "sains": [
        "sain"
    ],
    "saint": [
        "saint"
    ],
    "sainte": [
        "saint"
    ],
    "saintement": [
        "saintement"
    ],
    "saintes": [
        "saint"
    ],
    "saintete": [
        "saintete"
    ],
    "saintetes": [
        "saintete"
    ],
    "saints": [
        "saint"
    ],
    "sais": [
        "savoir",
        "sais"
    ],
    "saisi": [
        "saisir",
        "saisi"
    ],
    "saisie": [
        "saisir",
        "saisie",
        "saisi"
    ],
    "saisies": [
        "saisir",
        "saisie",
        "saisi"
    ],
    "saisir": [
        "saisir"
    ],
    "saisira": [
        "saisir"
    ],
    "saisirai": [
        "saisir"
    ],
    "saisirais": [
        "saisir"
    ],
    "saisirait": [
        "saisir"
    ],
    "saisiras": [
        "saisir"
    ],
    "saisirent": [
        "saisir"
    ],
    "saisirez": [
        "saisir"
    ],
    "saisirions": [
        "saisir"
    ],
    "saisirons": [
        "saisir"
    ],
    "saisiront": [
        "saisir"
    ],
    "saisis": [
        "saisir",
        "saisi"
    ],
    "saisissable": [
        "saisissable"
    ],
    "saisissables": [
        "saisissable"
    ],
    "saisissaient": [
        "saisir"
    ],
    "saisissais": [
        "saisir"
    ],
    "saisissait": [
        "saisir"
    ],
    "saisissant": [
        "saisir",
        "saisissant"
    ],
    "saisissante": [
        "saisissant"
    ],
    "saisissantes": [
        "saisissant"
    ],
    "saisissants": [
        "saisissant"
    ],
    "saisisse": [
        "saisir"
    ],
    "saisissement": [
        "saisissement"
    ],
    "saisissements": [
        "saisissement"
    ],
    "saisissent": [
        "saisir"
    ],
    "saisisses": [
        "saisir"
    ],
    "saisissez": [
        "saisir"
    ],
    "saisissiez": [
        "saisir"
    ],
    "saisissions": [
        "saisir"
    ],
    "saisissons": [
        "saisir"
    ],
    "saisit": [
        "saisir"
    ],
    "saison": [
        "saison"
    ],
    "saisonnier": [
        "saisonnier"
    ],
    "saisonniers": [
        "saisonnier"
    ],
    "saisonniere": [
        "saisonnier"
    ],
    "saisonnieres": [
        "saisonnier"
    ],
    "saisons": [
        "saison"
    ],
    "sait": [
        "savoir"
    ],
    "saki": [
        "saki"
    ],
    "sake": [
        "sake"
    ],
    "sakes": [
        "sake"
    ],
    "sala": [
        "saler"
    ],
    "salace": [
        "salace"
    ],
    "salaces": [
        "salace"
    ],
    "salacite": [
        "salacite"
    ],
    "salacites": [
        "salacite"
    ],
    "salade": [
        "salade"
    ],
    "salader": [
        "salader"
    ],
    "salades": [
        "salade"
    ],
    "saladier": [
        "saladier"
    ],
    "saladiers": [
        "saladier"
    ],
    "salaient": [
        "saler"
    ],
    "salaire": [
        "salaire"
    ],
    "salaires": [
        "salaire"
    ],
    "salaison": [
        "salaison"
    ],
    "salaisons": [
        "salaison"
    ],
    "salait": [
        "saler"
    ],
    "salam": [
        "salam"
    ],
    "salamalec": [
        "salamalec"
    ],
    "salamalecs": [
        "salamalec"
    ],
    "salamandre": [
        "salamandre"
    ],
    "salamandres": [
        "salamandre"
    ],
    "salami": [
        "salami"
    ],
    "salamis": [
        "salami"
    ],
    "salanque": [
        "salanque"
    ],
    "salant": [
        "saler",
        "salant"
    ],
    "salants": [
        "salant"
    ],
    "salariait": [
        "salarier"
    ],
    "salariale": [
        "salarial"
    ],
    "salariat": [
        "salariat"
    ],
    "salariaux": [
        "salarial"
    ],
    "salarier": [
        "salarier"
    ],
    "salarie": [
        "salarie",
        "salarier"
    ],
    "salariee": [
        "salarie",
        "salarier"
    ],
    "salaries": [
        "salarie",
        "salary",
        "salarier"
    ],
    "salas": [
        "saler"
    ],
    "salat": [
        "salat"
    ],
    "salaud": [
        "salaud"
    ],
    "salauds": [
        "salaud"
    ],
    "salazariste": [
        "salazariste"
    ],
    "sale": [
        "saler",
        "sale"
    ],
    "salement": [
        "salement"
    ],
    "saler": [
        "saler"
    ],
    "salera": [
        "saler"
    ],
    "sales": [
        "saler",
        "sale"
    ],
    "salete": [
        "salete"
    ],
    "saletes": [
        "salete"
    ],
    "saleur": [
        "saleur"
    ],
    "salez": [
        "saler"
    ],
    "sali": [
        "salir"
    ],
    "salicaires": [
        "salicaire"
    ],
    "salicine": [
        "salicine"
    ],
    "salicole": [
        "salicole"
    ],
    "salicorne": [
        "salicorne"
    ],
    "salie": [
        "salir"
    ],
    "salies": [
        "salir"
    ],
    "saligaud": [
        "saligaud"
    ],
    "saligauds": [
        "saligaud"
    ],
    "salin": [
        "salin"
    ],
    "saline": [
        "salin",
        "saline"
    ],
    "salines": [
        "salin",
        "saline"
    ],
    "salingue": [
        "salingue"
    ],
    "salingues": [
        "salingue"
    ],
    "salinite": [
        "salinite"
    ],
    "salins": [
        "salin"
    ],
    "salique": [
        "salique"
    ],
    "salir": [
        "salir"
    ],
    "salira": [
        "salir"
    ],
    "salirai": [
        "salir"
    ],
    "saliraient": [
        "salir"
    ],
    "salirais": [
        "salir"
    ],
    "salirait": [
        "salir"
    ],
    "salirez": [
        "salir"
    ],
    "salis": [
        "salir"
    ],
    "salissaient": [
        "salir"
    ],
    "salissait": [
        "salir"
    ],
    "salissant": [
        "salissant",
        "salir"
    ],
    "salissante": [
        "salissant"
    ],
    "salissantes": [
        "salissant"
    ],
    "salissants": [
        "salissant"
    ],
    "salisse": [
        "salir"
    ],
    "salissent": [
        "salir"
    ],
    "salisses": [
        "salir"
    ],
    "salisseur": [
        "salisseur"
    ],
    "salissez": [
        "salir"
    ],
    "salissiez": [
        "salir"
    ],
    "salissure": [
        "salissure"
    ],
    "salissures": [
        "salissure"
    ],
    "salit": [
        "salir"
    ],
    "saliva": [
        "saliver"
    ],
    "salivaient": [
        "saliver"
    ],
    "salivaire": [
        "salivaire"
    ],
    "salivaires": [
        "salivaire"
    ],
    "salivais": [
        "saliver"
    ],
    "salivait": [
        "saliver"
    ],
    "salivant": [
        "saliver",
        "salivant"
    ],
    "salivation": [
        "salivation"
    ],
    "salive": [
        "saliver",
        "salive"
    ],
    "salivent": [
        "saliver"
    ],
    "saliver": [
        "saliver"
    ],
    "salives": [
        "saliver",
        "salive"
    ],
    "saliveur": [
        "saliveur"
    ],
    "saliveuse": [
        "saliveux"
    ],
    "saliveuses": [
        "saliveux"
    ],
    "salivez": [
        "saliver"
    ],
    "saliere": [
        "saliere"
    ],
    "salieres": [
        "saliere"
    ],
    "salle": [
        "salle"
    ],
    "salles": [
        "salle"
    ],
    "salmigondis": [
        "salmigondis"
    ],
    "salmis": [
        "salmis"
    ],
    "salmonelle": [
        "salmonelle"
    ],
    "salmonellose": [
        "salmonellose"
    ],
    "salmonide": [
        "salmonide"
    ],
    "saloir": [
        "saloir"
    ],
    "saloirs": [
        "saloir"
    ],
    "salon": [
        "salon"
    ],
    "salonnard": [
        "salonnard"
    ],
    "salonniers": [
        "salonnier"
    ],
    "salonnieres": [
        "salonniere"
    ],
    "salons": [
        "saler",
        "salon"
    ],
    "saloon": [
        "saloon"
    ],
    "saloons": [
        "saloon"
    ],
    "salop": [
        "salop"
    ],
    "salopard": [
        "salopard"
    ],
    "salopards": [
        "salopard"
    ],
    "salope": [
        "saloper",
        "salope"
    ],
    "salopent": [
        "saloper"
    ],
    "saloper": [
        "saloper"
    ],
    "saloperie": [
        "saloperie"
    ],
    "saloperies": [
        "saloperie"
    ],
    "salopes": [
        "saloper",
        "salope"
    ],
    "salopette": [
        "salopette"
    ],
    "salopettes": [
        "salopette"
    ],
    "salopez": [
        "saloper"
    ],
    "salopiaud": [
        "salopiaud"
    ],
    "salopiauds": [
        "salopiaud"
    ],
    "salopiaux": [
        "salopiau"
    ],
    "salopiot": [
        "salopiot"
    ],
    "salopiots": [
        "salopiot"
    ],
    "salops": [
        "salop"
    ],
    "salopee": [
        "saloper"
    ],
    "salopees": [
        "saloper"
    ],
    "salpicon": [
        "salpicon"
    ],
    "salpingite": [
        "salpingite"
    ],
    "salpetre": [
        "salpetre"
    ],
    "salpetreux": [
        "salpetreux"
    ],
    "salpetriere": [
        "salpetriere"
    ],
    "salpetrees": [
        "salpetrer"
    ],
    "salpetres": [
        "salpetrer"
    ],
    "sals": [
        "sal"
    ],
    "salsa": [
        "salsa"
    ],
    "salsepareille": [
        "salsepareille"
    ],
    "salsifis": [
        "salsifis"
    ],
    "saltimbanque": [
        "saltimbanque"
    ],
    "saltimbanques": [
        "saltimbanque"
    ],
    "salto": [
        "salto"
    ],
    "salua": [
        "saluer"
    ],
    "saluai": [
        "saluer"
    ],
    "saluaient": [
        "saluer"
    ],
    "saluais": [
        "saluer"
    ],
    "saluait": [
        "saluer"
    ],
    "saluant": [
        "saluer"
    ],
    "salubre": [
        "salubre"
    ],
    "salubres": [
        "salubre"
    ],
    "salubrite": [
        "salubrite"
    ],
    "salue": [
        "saluer"
    ],
    "saluent": [
        "saluer"
    ],
    "saluer": [
        "saluer"
    ],
    "saluera": [
        "saluer"
    ],
    "saluerai": [
        "saluer"
    ],
    "salueraient": [
        "saluer"
    ],
    "saluerais": [
        "saluer"
    ],
    "saluerait": [
        "saluer"
    ],
    "salueras": [
        "saluer"
    ],
    "saluerons": [
        "saluer"
    ],
    "salueront": [
        "saluer"
    ],
    "salues": [
        "saluer"
    ],
    "salueur": [
        "salueur"
    ],
    "saluez": [
        "saluer"
    ],
    "saluiez": [
        "saluer"
    ],
    "saluions": [
        "saluer"
    ],
    "saluons": [
        "saluer"
    ],
    "salut": [
        "salut"
    ],
    "salutaire": [
        "salutaire"
    ],
    "salutairement": [
        "salutairement"
    ],
    "salutaires": [
        "salutaire"
    ],
    "salutation": [
        "salutation"
    ],
    "salutations": [
        "salutation"
    ],
    "salutiste": [
        "salutiste"
    ],
    "salutistes": [
        "salutiste"
    ],
    "saluts": [
        "salut"
    ],
    "saluames": [
        "saluer"
    ],
    "saluat": [
        "saluer"
    ],
    "saluerent": [
        "saluer"
    ],
    "saluee": [
        "saluer"
    ],
    "saluees": [
        "saluer"
    ],
    "salvadorien": [
        "salvadorien"
    ],
    "salvadorienne": [
        "salvadorien",
        "salvadorienne"
    ],
    "salvadoriens": [
        "salvadorien"
    ],
    "salvateur": [
        "salvateur"
    ],
    "salvateurs": [
        "salvateur"
    ],
    "salvation": [
        "salvation"
    ],
    "salvatrice": [
        "salvateur",
        "sauveur"
    ],
    "salve": [
        "salve"
    ],
    "salves": [
        "salve"
    ],
    "salvifique": [
        "salvifique"
    ],
    "salzbourgeoises": [
        "salzbourgeois"
    ],
    "salee": [
        "saler",
        "sale"
    ],
    "salees": [
        "saler",
        "sale"
    ],
    "salesienne": [
        "salesien"
    ],
    "samaras": [
        "samara"
    ],
    "samaritain": [
        "samaritain"
    ],
    "samaritaine": [
        "samaritaine"
    ],
    "samaritains": [
        "samaritain"
    ],
    "samba": [
        "samba"
    ],
    "sambenito": [
        "sambenito"
    ],
    "sambo": [
        "sambo"
    ],
    "samedi": [
        "samedi"
    ],
    "samedis": [
        "samedi"
    ],
    "samizdats": [
        "samizdat"
    ],
    "sammy": [
        "sammy"
    ],
    "samoan": [
        "samoan"
    ],
    "samoans": [
        "samoan"
    ],
    "samourai": [
        "samourai"
    ],
    "samourais": [
        "samourai"
    ],
    "samovar": [
        "samovar"
    ],
    "samovars": [
        "samovar"
    ],
    "samoyede": [
        "samoyede"
    ],
    "sampan": [
        "sampan"
    ],
    "sampang": [
        "sampang"
    ],
    "sampangs": [
        "sampang"
    ],
    "sample": [
        "sample"
    ],
    "sampler": [
        "sampler"
    ],
    "samurai": [
        "samurai"
    ],
    "sana": [
        "sana"
    ],
    "sanas": [
        "sana"
    ],
    "sanatorium": [
        "sanatorium"
    ],
    "sanatoriums": [
        "sanatorium"
    ],
    "sancerre": [
        "sancerre"
    ],
    "sanctifiai": [
        "sanctifier"
    ],
    "sanctifiait": [
        "sanctifier"
    ],
    "sanctifiante": [
        "sanctifiant"
    ],
    "sanctification": [
        "sanctification"
    ],
    "sanctificatrice": [
        "sanctificateur"
    ],
    "sanctifie": [
        "sanctifier"
    ],
    "sanctifier": [
        "sanctifier"
    ],
    "sanctifiez": [
        "sanctifier"
    ],
    "sanctifiee": [
        "sanctifier"
    ],
    "sanctifiees": [
        "sanctifier"
    ],
    "sanctifies": [
        "sanctifier"
    ],
    "sanction": [
        "sanction"
    ],
    "sanctionnaient": [
        "sanctionner"
    ],
    "sanctionnait": [
        "sanctionner"
    ],
    "sanctionnant": [
        "sanctionner"
    ],
    "sanctionne": [
        "sanctionner"
    ],
    "sanctionner": [
        "sanctionner"
    ],
    "sanctionnera": [
        "sanctionner"
    ],
    "sanctionnerait": [
        "sanctionner"
    ],
    "sanctionnez": [
        "sanctionner"
    ],
    "sanctionnions": [
        "sanctionner"
    ],
    "sanctionnerent": [
        "sanctionner"
    ],
    "sanctionnee": [
        "sanctionner"
    ],
    "sanctionnees": [
        "sanctionner"
    ],
    "sanctionnes": [
        "sanctionner"
    ],
    "sanctions": [
        "sanction"
    ],
    "sanctuaire": [
        "sanctuaire"
    ],
    "sanctuaires": [
        "sanctuaire"
    ],
    "sanctus": [
        "sanctus"
    ],
    "sandale": [
        "sandal"
    ],
    "sandales": [
        "sandale",
        "sandal"
    ],
    "sandalettes": [
        "sandalette"
    ],
    "sandalier": [
        "sandalier"
    ],
    "sanderling": [
        "sanderling"
    ],
    "sandiniste": [
        "sandiniste"
    ],
    "sandinistes": [
        "sandiniste"
    ],
    "sandjak": [
        "sandjak"
    ],
    "sandow": [
        "sandow"
    ],
    "sandows": [
        "sandow"
    ],
    "sandre": [
        "sandre"
    ],
    "sandres": [
        "sandre"
    ],
    "sandwich": [
        "sandwich"
    ],
    "sandwiches": [
        "sandwich",
        "sandwiche"
    ],
    "sandwichs": [
        "sandwich"
    ],
    "sang": [
        "sang",
        "sing"
    ],
    "sangla": [
        "sangler"
    ],
    "sanglai": [
        "sangler"
    ],
    "sanglait": [
        "sangler"
    ],
    "sanglant": [
        "sanglant",
        "sangler"
    ],
    "sanglante": [
        "sanglant"
    ],
    "sanglantes": [
        "sanglant"
    ],
    "sanglants": [
        "sanglant"
    ],
    "sangle": [
        "sangle",
        "sangler"
    ],
    "sanglent": [
        "sangler"
    ],
    "sangler": [
        "sangler"
    ],
    "sangles": [
        "sangle",
        "sangler"
    ],
    "sanglez": [
        "sangler"
    ],
    "sanglier": [
        "sanglier"
    ],
    "sangliers": [
        "sanglier"
    ],
    "sanglot": [
        "sanglot"
    ],
    "sanglota": [
        "sangloter"
    ],
    "sanglotai": [
        "sangloter"
    ],
    "sanglotaient": [
        "sangloter"
    ],
    "sanglotais": [
        "sangloter"
    ],
    "sanglotait": [
        "sangloter"
    ],
    "sanglotant": [
        "sanglotant",
        "sangloter"
    ],
    "sanglotante": [
        "sanglotant"
    ],
    "sanglotants": [
        "sanglotant"
    ],
    "sanglote": [
        "sangloter"
    ],
    "sanglotent": [
        "sangloter"
    ],
    "sangloter": [
        "sangloter"
    ],
    "sanglotez": [
        "sangloter"
    ],
    "sanglots": [
        "sanglot"
    ],
    "sanglotames": [
        "sangloter"
    ],
    "sanglotes": [
        "sangloter"
    ],
    "sanglee": [
        "sangler"
    ],
    "sanglees": [
        "sangler"
    ],
    "sangria": [
        "sangria"
    ],
    "sangs": [
        "sang"
    ],
    "sangsue": [
        "sangsue"
    ],
    "sangsues": [
        "sangsue"
    ],
    "sanguin": [
        "sanguin"
    ],
    "sanguinaire": [
        "sanguinaire"
    ],
    "sanguinaires": [
        "sanguinaire"
    ],
    "sanguine": [
        "sanguine",
        "sanguin"
    ],
    "sanguines": [
        "sanguine",
        "sanguin"
    ],
    "sanguinolent": [
        "sanguinolent"
    ],
    "sanguinolente": [
        "sanguinolent"
    ],
    "sanguinolentes": [
        "sanguinolent"
    ],
    "sanguinolents": [
        "sanguinolent"
    ],
    "sanguins": [
        "sanguin"
    ],
    "sanhedrin": [
        "sanhedrin"
    ],
    "sanie": [
        "sanie"
    ],
    "sanies": [
        "sanie"
    ],
    "sanieuses": [
        "sanieux"
    ],
    "sanieux": [
        "sanieux"
    ],
    "sanitaire": [
        "sanitaire"
    ],
    "sanitaires": [
        "sanitaire"
    ],
    "sans": [
        "sans"
    ],
    "sanscrit": [
        "sanscrit"
    ],
    "sanscrite": [
        "sanscrit"
    ],
    "sanscrits": [
        "sanscrit"
    ],
    "sanskrit": [
        "sanskrit"
    ],
    "sansonnet": [
        "sansonnet"
    ],
    "sansonnets": [
        "sansonnet"
    ],
    "santal": [
        "santal"
    ],
    "santals": [
        "santal"
    ],
    "santiag": [
        "santiag"
    ],
    "santiags": [
        "santiag"
    ],
    "santoche": [
        "santoche"
    ],
    "santon": [
        "santon"
    ],
    "santons": [
        "santon"
    ],
    "sante": [
        "sante"
    ],
    "santes": [
        "sante"
    ],
    "saoudien": [
        "saoudien"
    ],
    "saoudienne": [
        "saoudien",
        "saoudienne"
    ],
    "saoudiennes": [
        "saoudien",
        "saoudienne"
    ],
    "saoudiens": [
        "saoudien"
    ],
    "saoudite": [
        "saoudite"
    ],
    "saoul": [
        "saoul"
    ],
    "saoula": [
        "saouler"
    ],
    "saoulaient": [
        "saouler"
    ],
    "saoulais": [
        "saouler"
    ],
    "saoulait": [
        "saouler"
    ],
    "saoulant": [
        "saouler"
    ],
    "saoulard": [
        "saoulard"
    ],
    "saoule": [
        "saouler",
        "saoul"
    ],
    "saoulent": [
        "saouler"
    ],
    "saouler": [
        "saouler"
    ],
    "saoulerait": [
        "saouler"
    ],
    "saouleras": [
        "saouler"
    ],
    "saoulerez": [
        "saouler"
    ],
    "saoulerie": [
        "saoulerie"
    ],
    "saouleries": [
        "saoulerie"
    ],
    "saoules": [
        "saouler",
        "saoul"
    ],
    "saoulez": [
        "saouler"
    ],
    "saoulions": [
        "saouler"
    ],
    "saouls": [
        "saoul"
    ],
    "saoulee": [
        "saouler"
    ],
    "saoulees": [
        "saouler"
    ],
    "sapaient": [
        "saper"
    ],
    "sapait": [
        "saper"
    ],
    "sapajou": [
        "sapajou"
    ],
    "sapajous": [
        "sapajou"
    ],
    "sape": [
        "sape",
        "saper"
    ],
    "sapement": [
        "sapement"
    ],
    "sapements": [
        "sapement"
    ],
    "sapent": [
        "saper"
    ],
    "saper": [
        "saper"
    ],
    "saperai": [
        "saper"
    ],
    "saperlipopette": [
        "saperlipopette"
    ],
    "saperlotte": [
        "saperlotte"
    ],
    "sapes": [
        "sape",
        "saper"
    ],
    "sapeur": [
        "sapeur"
    ],
    "sapeurs": [
        "sapeur"
    ],
    "sapez": [
        "saper"
    ],
    "saphir": [
        "saphir"
    ],
    "saphirs": [
        "saphir"
    ],
    "saphisme": [
        "saphisme"
    ],
    "saphene": [
        "saphene"
    ],
    "sapide": [
        "sapide"
    ],
    "sapides": [
        "sapide"
    ],
    "sapidite": [
        "sapidite"
    ],
    "sapien": [
        "sapiens"
    ],
    "sapience": [
        "sapience"
    ],
    "sapiens": [
        "sapiens"
    ],
    "sapin": [
        "sapin"
    ],
    "sapines": [
        "sapine"
    ],
    "sapinette": [
        "sapinette"
    ],
    "sapinettes": [
        "sapinette"
    ],
    "sapiniere": [
        "sapiniere"
    ],
    "sapinieres": [
        "sapiniere"
    ],
    "sapins": [
        "sapin"
    ],
    "saponaires": [
        "saponaire"
    ],
    "saponification": [
        "saponification"
    ],
    "saponifiees": [
        "saponifier"
    ],
    "saponite": [
        "saponite"
    ],
    "sapotille": [
        "sapotille"
    ],
    "sapotillier": [
        "sapotillier"
    ],
    "sapristi": [
        "sapristi"
    ],
    "sapee": [
        "saper"
    ],
    "sapees": [
        "saper"
    ],
    "saque": [
        "saquer"
    ],
    "saquent": [
        "saquer"
    ],
    "saquer": [
        "saquer"
    ],
    "saquee": [
        "saquer"
    ],
    "saques": [
        "saquer"
    ],
    "sar": [
        "sar"
    ],
    "sara": [
        "sara"
    ],
    "sarabande": [
        "sarabande"
    ],
    "sarabandes": [
        "sarabande"
    ],
    "sarbacane": [
        "sarbacane"
    ],
    "sarbacanes": [
        "sarbacane"
    ],
    "sarcasme": [
        "sarcasme"
    ],
    "sarcasmes": [
        "sarcasme"
    ],
    "sarcastique": [
        "sarcastique"
    ],
    "sarcastiquement": [
        "sarcastiquement"
    ],
    "sarcastiques": [
        "sarcastique"
    ],
    "sarcelle": [
        "sarcelle"
    ],
    "sarcelles": [
        "sarcelle"
    ],
    "sarcine": [
        "sarcine"
    ],
    "sarclage": [
        "sarclage"
    ],
    "sarclait": [
        "sarcler"
    ],
    "sarclant": [
        "sarcler"
    ],
    "sarcle": [
        "sarcler"
    ],
    "sarclent": [
        "sarcler"
    ],
    "sarcler": [
        "sarcler"
    ],
    "sarclette": [
        "sarclette"
    ],
    "sarcleuse": [
        "sarcleur"
    ],
    "sarcloir": [
        "sarcloir"
    ],
    "sarclees": [
        "sarcler"
    ],
    "sarcome": [
        "sarcome"
    ],
    "sarcophage": [
        "sarcophage"
    ],
    "sarcophages": [
        "sarcophage"
    ],
    "sarcoidose": [
        "sarcoidose"
    ],
    "sardanapalesques": [
        "sardanapalesque"
    ],
    "sardanes": [
        "sardane"
    ],
    "sarde": [
        "sarde"
    ],
    "sardinaient": [
        "sardiner"
    ],
    "sardine": [
        "sardine"
    ],
    "sardines": [
        "sardine"
    ],
    "sardiniers": [
        "sardinier"
    ],
    "sardoine": [
        "sardoine"
    ],
    "sardonique": [
        "sardonique"
    ],
    "sardoniquement": [
        "sardoniquement"
    ],
    "sardoniques": [
        "sardonique"
    ],
    "sargasse": [
        "sargasse"
    ],
    "sargasses": [
        "sargasse"
    ],
    "sari": [
        "sari"
    ],
    "sarigue": [
        "sarigue"
    ],
    "sarin": [
        "sarin"
    ],
    "saris": [
        "sari"
    ],
    "sarment": [
        "sarment"
    ],
    "sarments": [
        "sarment"
    ],
    "sarong": [
        "sarong"
    ],
    "saroual": [
        "saroual"
    ],
    "sarouel": [
        "sarouel"
    ],
    "sarracenie": [
        "sarracenie"
    ],
    "sarrasin": [
        "sarrasin"
    ],
    "sarrasine": [
        "sarrasin"
    ],
    "sarrasines": [
        "sarrasin"
    ],
    "sarrasins": [
        "sarrasin"
    ],
    "sarrau": [
        "sarrau"
    ],
    "sarraus": [
        "sarrau"
    ],
    "sarreau": [
        "sarreau"
    ],
    "sarriette": [
        "sarriette"
    ],
    "sarrois": [
        "sarrois"
    ],
    "sarroise": [
        "sarrois"
    ],
    "sarrussophone": [
        "sarrussophone"
    ],
    "sas": [
        "sas",
        "sa"
    ],
    "sashimi": [
        "sashimi"
    ],
    "sassafras": [
        "sassafras"
    ],
    "sassanide": [
        "sassanide"
    ],
    "sassanides": [
        "sassanide"
    ],
    "sasse": [
        "sasser"
    ],
    "sasseur": [
        "sasseur"
    ],
    "satan": [
        "satan"
    ],
    "satana": [
        "sataner"
    ],
    "satanaient": [
        "sataner"
    ],
    "satanas": [
        "sataner"
    ],
    "sataner": [
        "sataner"
    ],
    "satanique": [
        "satanique"
    ],
    "sataniques": [
        "satanique"
    ],
    "sataniser": [
        "sataniser"
    ],
    "satanisme": [
        "satanisme"
    ],
    "sataniste": [
        "sataniste"
    ],
    "satane": [
        "sataner",
        "satane"
    ],
    "satanee": [
        "sataner",
        "satane"
    ],
    "satanees": [
        "satane"
    ],
    "satanes": [
        "sataner",
        "satane"
    ],
    "satelliser": [
        "satelliser"
    ],
    "satellisee": [
        "satelliser"
    ],
    "satellitaire": [
        "satellitaire"
    ],
    "satellite": [
        "satellite"
    ],
    "satellites": [
        "satellite"
    ],
    "sati": [
        "sati"
    ],
    "satiation": [
        "satiation"
    ],
    "satin": [
        "satin"
    ],
    "satinait": [
        "satiner"
    ],
    "satine": [
        "satine",
        "satiner"
    ],
    "satinette": [
        "satinette"
    ],
    "satins": [
        "satin"
    ],
    "satinee": [
        "satine",
        "satiner"
    ],
    "satinees": [
        "satine",
        "satiner"
    ],
    "satines": [
        "satine",
        "satiner"
    ],
    "satire": [
        "satire"
    ],
    "satires": [
        "satire"
    ],
    "satirique": [
        "satirique"
    ],
    "satiriques": [
        "satirique"
    ],
    "satirisaient": [
        "satiriser"
    ],
    "satiriste": [
        "satiriste"
    ],
    "satisfaction": [
        "satisfaction"
    ],
    "satisfactions": [
        "satisfaction"
    ],
    "satisfaire": [
        "satisfaire"
    ],
    "satisfais": [
        "satisfaire"
    ],
    "satisfaisaient": [
        "satisfaire"
    ],
    "satisfaisais": [
        "satisfaire"
    ],
    "satisfaisait": [
        "satisfaire"
    ],
    "satisfaisant": [
        "satisfaisant",
        "satisfaire"
    ],
    "satisfaisante": [
        "satisfaisant"
    ],
    "satisfaisantes": [
        "satisfaisant"
    ],
    "satisfaisants": [
        "satisfaisant"
    ],
    "satisfait": [
        "satisfait",
        "satisfaire"
    ],
    "satisfaite": [
        "satisfait",
        "satisfaire"
    ],
    "satisfaites": [
        "satisfait",
        "satisfaire"
    ],
    "satisfaits": [
        "satisfait",
        "satisfaire"
    ],
    "satisfasse": [
        "satisfaire"
    ],
    "satisfassent": [
        "satisfaire"
    ],
    "satisfecit": [
        "satisfecit"
    ],
    "satisfera": [
        "satisfaire"
    ],
    "satisferai": [
        "satisfaire"
    ],
    "satisferaient": [
        "satisfaire"
    ],
    "satisferais": [
        "satisfaire"
    ],
    "satisferait": [
        "satisfaire"
    ],
    "satisferiez": [
        "satisfaire"
    ],
    "satisferons": [
        "satisfaire"
    ],
    "satisferont": [
        "satisfaire"
    ],
    "satisfirent": [
        "satisfaire"
    ],
    "satisfis": [
        "satisfaire"
    ],
    "satisfit": [
        "satisfaire"
    ],
    "satisfont": [
        "satisfaire"
    ],
    "satiete": [
        "satiete"
    ],
    "satonne": [
        "satonner"
    ],
    "satonner": [
        "satonner"
    ],
    "satrape": [
        "satrape"
    ],
    "satrapes": [
        "satrape"
    ],
    "satrapie": [
        "satrapie"
    ],
    "saturait": [
        "saturer"
    ],
    "saturant": [
        "saturer"
    ],
    "saturation": [
        "saturation"
    ],
    "sature": [
        "sature",
        "saturer"
    ],
    "saturent": [
        "saturer"
    ],
    "saturer": [
        "saturer"
    ],
    "saturnales": [
        "saturnales"
    ],
    "saturnien": [
        "saturnien"
    ],
    "saturniennes": [
        "saturnienne"
    ],
    "saturniens": [
        "saturnien"
    ],
    "saturnisme": [
        "saturnisme"
    ],
    "saturons": [
        "saturer"
    ],
    "saturee": [
        "sature",
        "saturer"
    ],
    "saturees": [
        "sature",
        "saturer"
    ],
    "satures": [
        "sature",
        "saturer"
    ],
    "satyre": [
        "satyre"
    ],
    "satyres": [
        "satyre"
    ],
    "satyrique": [
        "satyrique"
    ],
    "sauce": [
        "saucer",
        "sauce"
    ],
    "saucent": [
        "saucer"
    ],
    "saucer": [
        "saucer"
    ],
    "sauces": [
        "saucer",
        "sauce"
    ],
    "saucier": [
        "saucier"
    ],
    "sauciflard": [
        "sauciflard"
    ],
    "saucisse": [
        "saucisse"
    ],
    "saucisses": [
        "saucisse"
    ],
    "saucisson": [
        "saucisson"
    ],
    "saucissonnage": [
        "saucissonnage"
    ],
    "saucissonnages": [
        "saucissonnage"
    ],
    "saucissonnant": [
        "saucissonner"
    ],
    "saucissonne": [
        "saucissonner"
    ],
    "saucissonner": [
        "saucissonner"
    ],
    "saucissonnee": [
        "saucissonner"
    ],
    "saucissonnes": [
        "saucissonner"
    ],
    "saucissons": [
        "saucisson"
    ],
    "sauciere": [
        "sauciere"
    ],
    "saucieres": [
        "sauciere"
    ],
    "saucee": [
        "sauce",
        "saucee"
    ],
    "sauf": [
        "sauf"
    ],
    "saufs": [
        "sauf"
    ],
    "sauge": [
        "sauge"
    ],
    "saugrenu": [
        "saugrenu"
    ],
    "saugrenue": [
        "saugrenu"
    ],
    "saugrenues": [
        "saugrenu"
    ],
    "saugrenus": [
        "saugrenu"
    ],
    "saulaie": [
        "saulaie"
    ],
    "saulaies": [
        "saulaie"
    ],
    "saule": [
        "saule"
    ],
    "saules": [
        "saule"
    ],
    "saulnier": [
        "saulnier"
    ],
    "saumon": [
        "saumon"
    ],
    "saumoneau": [
        "saumoneau"
    ],
    "saumonette": [
        "saumonette"
    ],
    "saumons": [
        "saumon"
    ],
    "saumone": [
        "saumone"
    ],
    "saumonee": [
        "saumone"
    ],
    "saumonees": [
        "saumone"
    ],
    "saumurage": [
        "saumurage"
    ],
    "saumure": [
        "saumure"
    ],
    "saumurer": [
        "saumurer"
    ],
    "saumurees": [
        "saumure"
    ],
    "saumatre": [
        "saumatre"
    ],
    "saumatres": [
        "saumatre"
    ],
    "sauna": [
        "sauna"
    ],
    "saunas": [
        "sauna"
    ],
    "saunier": [
        "saunier"
    ],
    "sauniers": [
        "saunier"
    ],
    "saunieres": [
        "sauniere"
    ],
    "saupoudra": [
        "saupoudrer"
    ],
    "saupoudrage": [
        "saupoudrage"
    ],
    "saupoudrai": [
        "saupoudrer"
    ],
    "saupoudraient": [
        "saupoudrer"
    ],
    "saupoudrait": [
        "saupoudrer"
    ],
    "saupoudrant": [
        "saupoudrer"
    ],
    "saupoudre": [
        "saupoudrer"
    ],
    "saupoudrer": [
        "saupoudrer"
    ],
    "saupoudreur": [
        "saupoudreur"
    ],
    "saupoudrez": [
        "saupoudrer"
    ],
    "saupoudriez": [
        "saupoudrer"
    ],
    "saupoudrons": [
        "saupoudrer"
    ],
    "saupoudree": [
        "saupoudrer"
    ],
    "saupoudrees": [
        "saupoudrer"
    ],
    "saupoudres": [
        "saupoudrer"
    ],
    "saur": [
        "saur"
    ],
    "saura": [
        "savoir",
        "saura"
    ],
    "saurai": [
        "savoir"
    ],
    "sauraient": [
        "savoir"
    ],
    "saurais": [
        "savoir",
        "saurer"
    ],
    "saurait": [
        "savoir"
    ],
    "sauras": [
        "savoir"
    ],
    "saurer": [
        "saurer"
    ],
    "sauret": [
        "sauret"
    ],
    "saurets": [
        "sauret"
    ],
    "saurez": [
        "savoir",
        "saurer"
    ],
    "sauri": [
        "saurir"
    ],
    "saurien": [
        "saurien"
    ],
    "sauriens": [
        "saurien"
    ],
    "sauriez": [
        "savoir",
        "saurer"
    ],
    "saurin": [
        "saurin"
    ],
    "saurions": [
        "savoir",
        "saurer"
    ],
    "saurons": [
        "savoir",
        "saurer"
    ],
    "sauront": [
        "savoir"
    ],
    "saurs": [
        "saur"
    ],
    "saussaies": [
        "saussaie"
    ],
    "saut": [
        "saut"
    ],
    "sauta": [
        "sauter"
    ],
    "sautai": [
        "sauter"
    ],
    "sautaient": [
        "sauter"
    ],
    "sautais": [
        "sauter"
    ],
    "sautait": [
        "sauter"
    ],
    "sautant": [
        "sautant",
        "sauter"
    ],
    "sautante": [
        "sautant"
    ],
    "saute": [
        "saute",
        "sauter"
    ],
    "sautelant": [
        "sauteler"
    ],
    "sautelle": [
        "sautelle"
    ],
    "sautent": [
        "sauter"
    ],
    "sauter": [
        "sauter"
    ],
    "sautera": [
        "sauter"
    ],
    "sauterai": [
        "sauter"
    ],
    "sauteraient": [
        "sauter"
    ],
    "sauterais": [
        "sauter"
    ],
    "sauterait": [
        "sauter"
    ],
    "sauteras": [
        "sauter"
    ],
    "sauterelle": [
        "sauterelle"
    ],
    "sauterelles": [
        "sauterelle",
        "sauterelles"
    ],
    "sauterez": [
        "sauter"
    ],
    "sauterie": [
        "sauterie"
    ],
    "sauteries": [
        "sauterie"
    ],
    "sauteriez": [
        "sauter"
    ],
    "sauternes": [
        "sauternes"
    ],
    "sauterons": [
        "sauter"
    ],
    "sauteront": [
        "sauter"
    ],
    "sautes": [
        "saute",
        "sauter"
    ],
    "sauteur": [
        "sauteur"
    ],
    "sauteurs": [
        "sauteur"
    ],
    "sauteuse": [
        "sauteur"
    ],
    "sauteuses": [
        "sauteur"
    ],
    "sautez": [
        "sauter"
    ],
    "sautiez": [
        "sauter"
    ],
    "sautilla": [
        "sautiller"
    ],
    "sautillaient": [
        "sautiller"
    ],
    "sautillais": [
        "sautiller"
    ],
    "sautillait": [
        "sautiller"
    ],
    "sautillant": [
        "sautiller",
        "sautillant"
    ],
    "sautillante": [
        "sautillant"
    ],
    "sautillantes": [
        "sautillant"
    ],
    "sautillants": [
        "sautillant"
    ],
    "sautille": [
        "sautiller"
    ],
    "sautillement": [
        "sautillement"
    ],
    "sautillements": [
        "sautillement"
    ],
    "sautillent": [
        "sautiller"
    ],
    "sautiller": [
        "sautiller"
    ],
    "sautilles": [
        "sautiller"
    ],
    "sautillez": [
        "sautiller"
    ],
    "sautillerent": [
        "sautiller"
    ],
    "sautions": [
        "sauter"
    ],
    "sautoir": [
        "sautoir"
    ],
    "sautoirs": [
        "sautoir"
    ],
    "sauton": [
        "sauton"
    ],
    "sautons": [
        "sauton",
        "sauter"
    ],
    "sauts": [
        "saut"
    ],
    "sautames": [
        "sauter"
    ],
    "sautat": [
        "sauter"
    ],
    "sauterent": [
        "sauter"
    ],
    "sautee": [
        "saute",
        "sauter"
    ],
    "sautees": [
        "saute",
        "sauter"
    ],
    "sauva": [
        "sauver"
    ],
    "sauvage": [
        "sauvage"
    ],
    "sauvagement": [
        "sauvagement"
    ],
    "sauvageon": [
        "sauvageon"
    ],
    "sauvageonne": [
        "sauvageon"
    ],
    "sauvageonnes": [
        "sauvageon"
    ],
    "sauvageons": [
        "sauvageon"
    ],
    "sauvagerie": [
        "sauvagerie"
    ],
    "sauvageries": [
        "sauvagerie"
    ],
    "sauvages": [
        "sauvage"
    ],
    "sauvagesse": [
        "sauvagesse"
    ],
    "sauvagesses": [
        "sauvagesse"
    ],
    "sauvagin": [
        "sauvagin"
    ],
    "sauvagine": [
        "sauvagin"
    ],
    "sauvagines": [
        "sauvagin"
    ],
    "sauvai": [
        "sauver"
    ],
    "sauvaient": [
        "sauver"
    ],
    "sauvais": [
        "sauver"
    ],
    "sauvait": [
        "sauver"
    ],
    "sauvant": [
        "sauver"
    ],
    "sauve": [
        "sauver",
        "sauve",
        "sauf"
    ],
    "sauvegardaient": [
        "sauvegarder"
    ],
    "sauvegardait": [
        "sauvegarder"
    ],
    "sauvegardant": [
        "sauvegarder"
    ],
    "sauvegarde": [
        "sauvegarde",
        "sauvegarder"
    ],
    "sauvegarder": [
        "sauvegarder"
    ],
    "sauvegarderaient": [
        "sauvegarder"
    ],
    "sauvegarderait": [
        "sauvegarder"
    ],
    "sauvegardes": [
        "sauvegarde",
        "sauvegarder"
    ],
    "sauvegardat": [
        "sauvegarder"
    ],
    "sauvegardee": [
        "sauvegarder"
    ],
    "sauvegardees": [
        "sauvegarder"
    ],
    "sauvent": [
        "sauver"
    ],
    "sauver": [
        "sauver"
    ],
    "sauvera": [
        "sauver"
    ],
    "sauverai": [
        "sauver"
    ],
    "sauveraient": [
        "sauver"
    ],
    "sauverais": [
        "sauver"
    ],
    "sauverait": [
        "sauver"
    ],
    "sauveras": [
        "sauver"
    ],
    "sauverez": [
        "sauver"
    ],
    "sauverons": [
        "sauver"
    ],
    "sauveront": [
        "sauver"
    ],
    "sauves": [
        "sauver",
        "sauf"
    ],
    "sauvetage": [
        "sauvetage"
    ],
    "sauvetages": [
        "sauvetage"
    ],
    "sauveteur": [
        "sauveteur"
    ],
    "sauveteurs": [
        "sauveteur"
    ],
    "sauvette": [
        "sauveter"
    ],
    "sauvete": [
        "sauvete"
    ],
    "sauveur": [
        "sauveur"
    ],
    "sauveurs": [
        "sauveur"
    ],
    "sauveuse": [
        "sauveur"
    ],
    "sauvez": [
        "sauver"
    ],
    "sauviez": [
        "sauver"
    ],
    "sauvignon": [
        "sauvignon"
    ],
    "sauvions": [
        "sauver"
    ],
    "sauvons": [
        "sauver"
    ],
    "sauvames": [
        "sauver"
    ],
    "sauvat": [
        "sauver"
    ],
    "sauverent": [
        "sauver"
    ],
    "sauvee": [
        "sauver"
    ],
    "sauvees": [
        "sauver"
    ],
    "sauca": [
        "saucer"
    ],
    "saucant": [
        "saucer"
    ],
    "saucons": [
        "saucer"
    ],
    "savaient": [
        "savoir"
    ],
    "savais": [
        "savoir"
    ],
    "savait": [
        "savoir"
    ],
    "savamment": [
        "savamment"
    ],
    "savane": [
        "savane"
    ],
    "savanes": [
        "savane"
    ],
    "savant": [
        "savant"
    ],
    "savantasses": [
        "savantasse"
    ],
    "savante": [
        "savant"
    ],
    "savantes": [
        "savant"
    ],
    "savantissimes": [
        "savantissime"
    ],
    "savants": [
        "savant"
    ],
    "savarin": [
        "savarin"
    ],
    "savata": [
        "savater"
    ],
    "savatait": [
        "savater"
    ],
    "savate": [
        "savater",
        "savate"
    ],
    "savater": [
        "savater"
    ],
    "savates": [
        "savater",
        "savate"
    ],
    "savent": [
        "savoir"
    ],
    "savetier": [
        "savetier"
    ],
    "savetiers": [
        "savetier"
    ],
    "saveur": [
        "saveur"
    ],
    "saveurs": [
        "saveur"
    ],
    "savez": [
        "savoir"
    ],
    "saviez": [
        "savoir"
    ],
    "savions": [
        "savoir"
    ],
    "savoir": [
        "savoir"
    ],
    "savoirs": [
        "savoir"
    ],
    "savon": [
        "savon"
    ],
    "savonna": [
        "savonner"
    ],
    "savonnage": [
        "savonnage"
    ],
    "savonnages": [
        "savonnage"
    ],
    "savonnai": [
        "savonner"
    ],
    "savonnaient": [
        "savonner"
    ],
    "savonnais": [
        "savonner"
    ],
    "savonnait": [
        "savonner"
    ],
    "savonnant": [
        "savonner"
    ],
    "savonne": [
        "savonner"
    ],
    "savonnent": [
        "savonner"
    ],
    "savonner": [
        "savonner"
    ],
    "savonnera": [
        "savonner"
    ],
    "savonneries": [
        "savonnerie"
    ],
    "savonnette": [
        "savonnette"
    ],
    "savonnettes": [
        "savonnette"
    ],
    "savonneuse": [
        "savonneux"
    ],
    "savonneuses": [
        "savonneux"
    ],
    "savonneux": [
        "savonneux"
    ],
    "savonnier": [
        "savonnier"
    ],
    "savonnee": [
        "savonner",
        "savonnee"
    ],
    "savonnees": [
        "savonner"
    ],
    "savons": [
        "savoir",
        "savon"
    ],
    "savoura": [
        "savourer"
    ],
    "savourai": [
        "savourer"
    ],
    "savouraient": [
        "savourer"
    ],
    "savourais": [
        "savourer"
    ],
    "savourait": [
        "savourer"
    ],
    "savourant": [
        "savourer"
    ],
    "savoure": [
        "savourer"
    ],
    "savourent": [
        "savourer"
    ],
    "savourer": [
        "savourer"
    ],
    "savourera": [
        "savourer"
    ],
    "savourerai": [
        "savourer"
    ],
    "savourerait": [
        "savourer"
    ],
    "savourerons": [
        "savourer"
    ],
    "savoureuse": [
        "savoureux"
    ],
    "savoureusement": [
        "savoureusement"
    ],
    "savoureuses": [
        "savoureux"
    ],
    "savoureux": [
        "savoureux"
    ],
    "savourez": [
        "savourer"
    ],
    "savourions": [
        "savourer"
    ],
    "savourons": [
        "savourer"
    ],
    "savourerent": [
        "savourer"
    ],
    "savouree": [
        "savourer"
    ],
    "savoures": [
        "savourer"
    ],
    "savoyard": [
        "savoyard"
    ],
    "savoyarde": [
        "savoyard"
    ],
    "savoyardes": [
        "savoyard"
    ],
    "savoyards": [
        "savoyard"
    ],
    "sax": [
        "sax"
    ],
    "saxes": [
        "saxe"
    ],
    "saxhorn": [
        "saxhorn"
    ],
    "saxifragacees": [
        "saxifragacee"
    ],
    "saxifrage": [
        "saxifrage"
    ],
    "saxifrages": [
        "saxifrage"
    ],
    "saxo": [
        "saxo"
    ],
    "saxon": [
        "saxon"
    ],
    "saxonne": [
        "saxon"
    ],
    "saxonnes": [
        "saxonne",
        "saxon"
    ],
    "saxons": [
        "saxon"
    ],
    "saxophone": [
        "saxophone"
    ],
    "saxophones": [
        "saxophone"
    ],
    "saxophoniste": [
        "saxophoniste"
    ],
    "saxophonistes": [
        "saxophoniste"
    ],
    "saxos": [
        "saxo"
    ],
    "saynete": [
        "saynete"
    ],
    "saynetes": [
        "saynete"
    ],
    "sayon": [
        "sayon"
    ],
    "sai": [
        "sai"
    ],
    "sbire": [
        "sbire"
    ],
    "sbires": [
        "sbire"
    ],
    "scabieuse": [
        "scabieux"
    ],
    "scabreuse": [
        "scabreux"
    ],
    "scabreuses": [
        "scabreux"
    ],
    "scabreux": [
        "scabreux"
    ],
    "scaferlati": [
        "scaferlati"
    ],
    "scalaire": [
        "scalaire"
    ],
    "scalp": [
        "scalp"
    ],
    "scalpa": [
        "scalper"
    ],
    "scalpaient": [
        "scalper"
    ],
    "scalpait": [
        "scalper"
    ],
    "scalpe": [
        "scalper"
    ],
    "scalpel": [
        "scalpel"
    ],
    "scalpels": [
        "scalpel"
    ],
    "scalpent": [
        "scalper"
    ],
    "scalper": [
        "scalper"
    ],
    "scalpera": [
        "scalper"
    ],
    "scalpeur": [
        "scalpeur"
    ],
    "scalpez": [
        "scalper"
    ],
    "scalps": [
        "scalp"
    ],
    "scalpes": [
        "scalper"
    ],
    "scalene": [
        "scalene"
    ],
    "scampi": [
        "scampi"
    ],
    "scanda": [
        "scander"
    ],
    "scandaient": [
        "scander"
    ],
    "scandait": [
        "scander"
    ],
    "scandale": [
        "scandale"
    ],
    "scandales": [
        "scandale"
    ],
    "scandaleuse": [
        "scandaleux"
    ],
    "scandaleusement": [
        "scandaleusement"
    ],
    "scandaleuses": [
        "scandaleux"
    ],
    "scandaleux": [
        "scandaleux"
    ],
    "scandalisa": [
        "scandaliser"
    ],
    "scandalisai": [
        "scandaliser"
    ],
    "scandalisaient": [
        "scandaliser"
    ],
    "scandalisais": [
        "scandaliser"
    ],
    "scandalisait": [
        "scandaliser"
    ],
    "scandalisant": [
        "scandaliser"
    ],
    "scandalise": [
        "scandalise",
        "scandaliser"
    ],
    "scandalisent": [
        "scandaliser"
    ],
    "scandaliser": [
        "scandaliser"
    ],
    "scandalisera": [
        "scandaliser"
    ],
    "scandaliserait": [
        "scandaliser"
    ],
    "scandalisons": [
        "scandaliser"
    ],
    "scandaliserent": [
        "scandaliser"
    ],
    "scandalisee": [
        "scandalise",
        "scandaliser"
    ],
    "scandalisees": [
        "scandalise",
        "scandaliser"
    ],
    "scandalises": [
        "scandalise",
        "scandaliser"
    ],
    "scandant": [
        "scander"
    ],
    "scande": [
        "scander"
    ],
    "scandent": [
        "scander"
    ],
    "scander": [
        "scander"
    ],
    "scandera": [
        "scander"
    ],
    "scandinave": [
        "scandinave"
    ],
    "scandinaves": [
        "scandinave"
    ],
    "scandee": [
        "scander"
    ],
    "scandees": [
        "scander"
    ],
    "scandes": [
        "scander"
    ],
    "scannage": [
        "scannage"
    ],
    "scannais": [
        "scanner"
    ],
    "scanne": [
        "scanner"
    ],
    "scannent": [
        "scanner"
    ],
    "scanner": [
        "scanner"
    ],
    "scannera": [
        "scanner"
    ],
    "scanneront": [
        "scanner"
    ],
    "scanners": [
        "scanner"
    ],
    "scannes": [
        "scanner"
    ],
    "scanneur": [
        "scanneur"
    ],
    "scannez": [
        "scanner"
    ],
    "scanning": [
        "scanning",
        "scan"
    ],
    "scannons": [
        "scanner"
    ],
    "scannee": [
        "scanner"
    ],
    "scanographie": [
        "scanographie"
    ],
    "scansion": [
        "scansion"
    ],
    "scansions": [
        "scansion"
    ],
    "scaphandre": [
        "scaphandre"
    ],
    "scaphandres": [
        "scaphandre"
    ],
    "scaphandrier": [
        "scaphandrier"
    ],
    "scaphandriers": [
        "scaphandrier"
    ],
    "scaphoide": [
        "scaphoide"
    ],
    "scapin": [
        "scapin"
    ],
    "scapulaire": [
        "scapulaire"
    ],
    "scapulaires": [
        "scapulaire"
    ],
    "scarabee": [
        "scarabee"
    ],
    "scarabees": [
        "scarabee"
    ],
    "scare": [
        "scare"
    ],
    "scarifiant": [
        "scarifier"
    ],
    "scarification": [
        "scarification"
    ],
    "scarifications": [
        "scarification"
    ],
    "scarifie": [
        "scarifier"
    ],
    "scarlatin": [
        "scarlatine"
    ],
    "scarlatine": [
        "scarlatin",
        "scarlatine"
    ],
    "scarlatines": [
        "scarlatin"
    ],
    "scarole": [
        "scarole"
    ],
    "scaroles": [
        "scarole"
    ],
    "scat": [
        "scat"
    ],
    "scato": [
        "scato"
    ],
    "scatologie": [
        "scatologie"
    ],
    "scatologique": [
        "scatologique"
    ],
    "scatologiques": [
        "scatologique"
    ],
    "scatologue": [
        "scatologue"
    ],
    "scatophiles": [
        "scatophile"
    ],
    "scatos": [
        "scato"
    ],
    "scatter": [
        "scatter"
    ],
    "scazons": [
        "scazon"
    ],
    "sceau": [
        "sceau"
    ],
    "sceaux": [
        "sceau"
    ],
    "scella": [
        "sceller"
    ],
    "scellage": [
        "scellage"
    ],
    "scellaient": [
        "sceller"
    ],
    "scellait": [
        "sceller"
    ],
    "scellant": [
        "sceller"
    ],
    "scelle": [
        "scelle",
        "sceller"
    ],
    "scellement": [
        "scellement"
    ],
    "scellements": [
        "scellement"
    ],
    "scellent": [
        "sceller"
    ],
    "sceller": [
        "sceller"
    ],
    "scellera": [
        "sceller"
    ],
    "scellerait": [
        "sceller"
    ],
    "scelleront": [
        "sceller"
    ],
    "scellez": [
        "sceller"
    ],
    "scellons": [
        "sceller"
    ],
    "scellerent": [
        "sceller"
    ],
    "scellee": [
        "scelle",
        "sceller"
    ],
    "scellees": [
        "scelle",
        "sceller"
    ],
    "scelles": [
        "scelle",
        "sceller"
    ],
    "scenarii": [
        "scenario",
        "scenarii"
    ],
    "scepticisme": [
        "scepticisme"
    ],
    "sceptique": [
        "sceptique"
    ],
    "sceptiques": [
        "sceptique"
    ],
    "sceptre": [
        "sceptre"
    ],
    "sceptres": [
        "sceptre"
    ],
    "schah": [
        "schah"
    ],
    "schako": [
        "schako"
    ],
    "schampooing": [
        "schampooing"
    ],
    "schbeb": [
        "schbeb"
    ],
    "scheik": [
        "scheik"
    ],
    "schilling": [
        "schilling"
    ],
    "schillings": [
        "schilling"
    ],
    "schismatique": [
        "schismatique"
    ],
    "schismatiques": [
        "schismatique"
    ],
    "schisme": [
        "schisme"
    ],
    "schismes": [
        "schisme"
    ],
    "schiste": [
        "schiste"
    ],
    "schistes": [
        "schiste"
    ],
    "schisteuses": [
        "schisteux"
    ],
    "schizophasie": [
        "schizophasie"
    ],
    "schizophrene": [
        "schizophrene"
    ],
    "schizophrenes": [
        "schizophrene"
    ],
    "schizophrenie": [
        "schizophrenie"
    ],
    "schizophrenique": [
        "schizophrenique"
    ],
    "schizophreniques": [
        "schizophrenique"
    ],
    "schizoide": [
        "schizoide"
    ],
    "schizoides": [
        "schizoide"
    ],
    "schlague": [
        "schlague"
    ],
    "schlass": [
        "schlass"
    ],
    "schlem": [
        "schlem"
    ],
    "schleu": [
        "schleu"
    ],
    "schlinguait": [
        "schlinguer"
    ],
    "schlinguant": [
        "schlinguer"
    ],
    "schlingue": [
        "schlinguer"
    ],
    "schlinguer": [
        "schlinguer"
    ],
    "schlingues": [
        "schlinguer"
    ],
    "schlitte": [
        "schlitte"
    ],
    "schmecte": [
        "schmecter"
    ],
    "schnaps": [
        "schnaps"
    ],
    "schnauzer": [
        "schnauzer"
    ],
    "schnick": [
        "schnick"
    ],
    "schnitzel": [
        "schnitzel"
    ],
    "schnock": [
        "schnock"
    ],
    "schnocks": [
        "schnock"
    ],
    "schnoque": [
        "schnoque"
    ],
    "schnoques": [
        "schnoque"
    ],
    "schnouf": [
        "schnouf"
    ],
    "schnouff": [
        "schnouff"
    ],
    "schnouffe": [
        "schnouffer"
    ],
    "schooner": [
        "schooner"
    ],
    "schooners": [
        "schooner"
    ],
    "schpile": [
        "schpile"
    ],
    "schproum": [
        "schproum"
    ],
    "schtroumf": [
        "schtroumf"
    ],
    "schtroumpf": [
        "schtroumpf"
    ],
    "schtroumpfs": [
        "schtroumpf"
    ],
    "schupo": [
        "schupo"
    ],
    "schupos": [
        "schupo"
    ],
    "schuss": [
        "schuss"
    ],
    "scheme": [
        "scheme"
    ],
    "schemes": [
        "scheme"
    ],
    "schema": [
        "schema"
    ],
    "schemas": [
        "schema"
    ],
    "schematique": [
        "schematique"
    ],
    "schematiquement": [
        "schematiquement"
    ],
    "schematiques": [
        "schematique"
    ],
    "schematise": [
        "schematiser"
    ],
    "schematiser": [
        "schematiser"
    ],
    "schematisme": [
        "schematisme"
    ],
    "schematisee": [
        "schematiser"
    ],
    "scia": [
        "scier"
    ],
    "sciage": [
        "sciage"
    ],
    "sciaient": [
        "scier"
    ],
    "sciais": [
        "scier"
    ],
    "sciait": [
        "scier"
    ],
    "scialytique": [
        "scialytique"
    ],
    "sciant": [
        "scier",
        "sciant"
    ],
    "sciatique": [
        "sciatique"
    ],
    "scie": [
        "scie",
        "scier"
    ],
    "sciemment": [
        "sciemment"
    ],
    "science": [
        "science"
    ],
    "sciences": [
        "science"
    ],
    "scient": [
        "scier"
    ],
    "scientificite": [
        "scientificite"
    ],
    "scientifique": [
        "scientifique"
    ],
    "scientifiquement": [
        "scientifiquement"
    ],
    "scientifiques": [
        "scientifique"
    ],
    "scientisme": [
        "scientisme"
    ],
    "scientiste": [
        "scientiste"
    ],
    "scientologie": [
        "scientologie"
    ],
    "scientologue": [
        "scientologue"
    ],
    "scientologues": [
        "scientologue"
    ],
    "scier": [
        "scier"
    ],
    "sciera": [
        "scier"
    ],
    "scierait": [
        "scier"
    ],
    "scierie": [
        "scierie"
    ],
    "scieries": [
        "scierie"
    ],
    "scieront": [
        "scier"
    ],
    "scies": [
        "scie",
        "scier"
    ],
    "scieur": [
        "scieur"
    ],
    "scieurs": [
        "scieur"
    ],
    "sciez": [
        "scier"
    ],
    "scindaient": [
        "scinder"
    ],
    "scindait": [
        "scinder"
    ],
    "scindant": [
        "scinder"
    ],
    "scinde": [
        "scinder"
    ],
    "scinder": [
        "scinder"
    ],
    "scinderas": [
        "scinder"
    ],
    "scindez": [
        "scinder"
    ],
    "scinderent": [
        "scinder"
    ],
    "scindee": [
        "scinder"
    ],
    "scindes": [
        "scinder"
    ],
    "scintigraphie": [
        "scintigraphie"
    ],
    "scintillaient": [
        "scintiller"
    ],
    "scintillait": [
        "scintiller"
    ],
    "scintillant": [
        "scintiller",
        "scintillant"
    ],
    "scintillante": [
        "scintillant"
    ],
    "scintillantes": [
        "scintillant"
    ],
    "scintillants": [
        "scintillant"
    ],
    "scintillation": [
        "scintillation"
    ],
    "scintillations": [
        "scintillation"
    ],
    "scintille": [
        "scintiller"
    ],
    "scintillement": [
        "scintillement"
    ],
    "scintillements": [
        "scintillement"
    ],
    "scintillent": [
        "scintiller"
    ],
    "scintiller": [
        "scintiller"
    ],
    "scintilleraient": [
        "scintiller"
    ],
    "scintillerais": [
        "scintiller"
    ],
    "scintilleront": [
        "scintiller"
    ],
    "scintilles": [
        "scintiller"
    ],
    "scintillons": [
        "scintiller"
    ],
    "scintillerent": [
        "scintiller"
    ],
    "scion": [
        "scion"
    ],
    "scions": [
        "scion"
    ],
    "scirpe": [
        "scirpe"
    ],
    "scirpes": [
        "scirpe"
    ],
    "scission": [
        "scission"
    ],
    "scissionniste": [
        "scissionniste"
    ],
    "scissiparite": [
        "scissiparite"
    ],
    "scissures": [
        "scissure"
    ],
    "sciure": [
        "sciure"
    ],
    "sciures": [
        "sciure"
    ],
    "sciene": [
        "sciene"
    ],
    "scierent": [
        "scier"
    ],
    "sciee": [
        "scier"
    ],
    "sciees": [
        "scier"
    ],
    "sclereux": [
        "sclereux"
    ],
    "sclerodermie": [
        "sclerodermie"
    ],
    "sclerosante": [
        "sclerosant"
    ],
    "sclerose": [
        "sclerose",
        "scleroser"
    ],
    "scleroserai": [
        "scleroser"
    ],
    "scleroses": [
        "sclerose",
        "sclerosis"
    ],
    "sclerosee": [
        "sclerose",
        "scleroser"
    ],
    "sclerotique": [
        "sclerotique"
    ],
    "sclerotiques": [
        "sclerotique"
    ],
    "scolaire": [
        "scolaire"
    ],
    "scolairement": [
        "scolairement"
    ],
    "scolaires": [
        "scolaire"
    ],
    "scolarisation": [
        "scolarisation"
    ],
    "scolariser": [
        "scolariser"
    ],
    "scolarite": [
        "scolarite"
    ],
    "scolarites": [
        "scolarite"
    ],
    "scolastique": [
        "scolastique"
    ],
    "scolastiques": [
        "scolastique"
    ],
    "scolie": [
        "scolie"
    ],
    "scoliose": [
        "scoliose"
    ],
    "scolioses": [
        "scoliose"
    ],
    "scolopendre": [
        "scolopendre"
    ],
    "scolopendres": [
        "scolopendre"
    ],
    "scolyte": [
        "scolyte"
    ],
    "scone": [
        "scone"
    ],
    "scones": [
        "scone"
    ],
    "sconse": [
        "sconse"
    ],
    "scoop": [
        "scoop"
    ],
    "scoops": [
        "scoop"
    ],
    "scooter": [
        "scooter"
    ],
    "scooters": [
        "scooter"
    ],
    "scope": [
        "scope"
    ],
    "scopes": [
        "scope"
    ],
    "scopie": [
        "scopie"
    ],
    "scopitones": [
        "scopitone"
    ],
    "scopolamine": [
        "scopolamine"
    ],
    "scorbut": [
        "scorbut"
    ],
    "score": [
        "score"
    ],
    "scores": [
        "score"
    ],
    "scories": [
        "scorie"
    ],
    "scorpion": [
        "scorpion"
    ],
    "scorpions": [
        "scorpion"
    ],
    "scotch": [
        "scotch"
    ],
    "scotchais": [
        "scotcher"
    ],
    "scotcher": [
        "scotcher"
    ],
    "scotches": [
        "scotch",
        "scotcher"
    ],
    "scotchons": [
        "scotcher"
    ],
    "scotchs": [
        "scotch"
    ],
    "scotche": [
        "scotcher"
    ],
    "scotchee": [
        "scotcher"
    ],
    "scotchees": [
        "scotcher"
    ],
    "scotomisant": [
        "scotomiser"
    ],
    "scotomiser": [
        "scotomiser"
    ],
    "scottish": [
        "scottish"
    ],
    "scoubidou": [
        "scoubidou"
    ],
    "scoubidous": [
        "scoubidou"
    ],
    "scoumoune": [
        "scoumoune"
    ],
    "scout": [
        "scout"
    ],
    "scoute": [
        "scout"
    ],
    "scoutisme": [
        "scoutisme"
    ],
    "scouts": [
        "scout"
    ],
    "scrabble": [
        "scrabble"
    ],
    "scratch": [
        "scratch"
    ],
    "scratcher": [
        "scratcher"
    ],
    "scratching": [
        "scratch",
        "scratching"
    ],
    "scriban": [
        "scriban"
    ],
    "scribe": [
        "scribe"
    ],
    "scribes": [
        "scribe"
    ],
    "scribouillages": [
        "scribouillage"
    ],
    "scribouillard": [
        "scribouillard"
    ],
    "scribouillards": [
        "scribouillard"
    ],
    "scribouille": [
        "scribouiller"
    ],
    "scribouiller": [
        "scribouiller"
    ],
    "script": [
        "script"
    ],
    "scripte": [
        "scripte"
    ],
    "scripteur": [
        "scripteur"
    ],
    "scripteurs": [
        "scripteur"
    ],
    "scripts": [
        "script"
    ],
    "scrofulaire": [
        "scrofulaire"
    ],
    "scrofule": [
        "scrofule"
    ],
    "scrofules": [
        "scrofule"
    ],
    "scrofuleux": [
        "scrofuleux"
    ],
    "scrogneugneu": [
        "scrogneugneu"
    ],
    "scrotal": [
        "scrotal"
    ],
    "scrotum": [
        "scrotum"
    ],
    "scrub": [
        "scrub"
    ],
    "scrubs": [
        "scrub"
    ],
    "scrupule": [
        "scrupule"
    ],
    "scrupules": [
        "scrupule"
    ],
    "scrupuleuse": [
        "scrupuleux"
    ],
    "scrupuleusement": [
        "scrupuleusement"
    ],
    "scrupuleuses": [
        "scrupuleux"
    ],
    "scrupuleux": [
        "scrupuleux"
    ],
    "scrupulosite": [
        "scrupulosite"
    ],
    "scruta": [
        "scruter"
    ],
    "scrutai": [
        "scruter"
    ],
    "scrutaient": [
        "scruter"
    ],
    "scrutais": [
        "scruter"
    ],
    "scrutait": [
        "scruter"
    ],
    "scrutant": [
        "scruter"
    ],
    "scrutateur": [
        "scrutateur"
    ],
    "scrutateurs": [
        "scrutateur"
    ],
    "scrutation": [
        "scrutation"
    ],
    "scrutatrices": [
        "scrutateur"
    ],
    "scrute": [
        "scruter"
    ],
    "scrutent": [
        "scruter"
    ],
    "scruter": [
        "scruter"
    ],
    "scrutera": [
        "scruter"
    ],
    "scruterai": [
        "scruter"
    ],
    "scruterait": [
        "scruter"
    ],
    "scruteront": [
        "scruter"
    ],
    "scrutez": [
        "scruter"
    ],
    "scrutin": [
        "scrutin"
    ],
    "scrutins": [
        "scrutin"
    ],
    "scrutions": [
        "scruter"
    ],
    "scrutons": [
        "scruter"
    ],
    "scrutames": [
        "scruter"
    ],
    "scruterent": [
        "scruter"
    ],
    "scrutee": [
        "scruter"
    ],
    "scrutes": [
        "scruter"
    ],
    "sculpta": [
        "sculpter"
    ],
    "sculptaient": [
        "sculpter"
    ],
    "sculptais": [
        "sculpter"
    ],
    "sculptait": [
        "sculpter"
    ],
    "sculptant": [
        "sculpter"
    ],
    "sculpte": [
        "sculpte",
        "sculpter"
    ],
    "sculptent": [
        "sculpter"
    ],
    "sculpter": [
        "sculpter"
    ],
    "sculptera": [
        "sculpter"
    ],
    "sculpterai": [
        "sculpter"
    ],
    "sculpterait": [
        "sculpter"
    ],
    "sculpteras": [
        "sculpter"
    ],
    "sculpterez": [
        "sculpter"
    ],
    "sculptes": [
        "sculpte",
        "sculpter"
    ],
    "sculpteur": [
        "sculpteur"
    ],
    "sculpteurs": [
        "sculpteur"
    ],
    "sculptez": [
        "sculpter"
    ],
    "sculptiez": [
        "sculpter"
    ],
    "sculptrice": [
        "sculpteur"
    ],
    "sculptural": [
        "sculptural"
    ],
    "sculpturale": [
        "sculptural"
    ],
    "sculpturales": [
        "sculptural"
    ],
    "sculpturaux": [
        "sculptural"
    ],
    "sculpture": [
        "sculpture"
    ],
    "sculptures": [
        "sculpture"
    ],
    "sculptates": [
        "sculpter"
    ],
    "sculptee": [
        "sculpte",
        "sculpter"
    ],
    "sculptees": [
        "sculpte",
        "sculpter"
    ],
    "scutigere": [
        "scutigere"
    ],
    "scutigeres": [
        "scutigere"
    ],
    "scythe": [
        "scythe"
    ],
    "scythes": [
        "scythe"
    ],
    "scene": [
        "scene"
    ],
    "scenes": [
        "scene"
    ],
    "scelerat": [
        "scelerat"
    ],
    "scelerate": [
        "scelerat"
    ],
    "scelerates": [
        "scelerat"
    ],
    "sceleratesse": [
        "sceleratesse"
    ],
    "sceleratesses": [
        "sceleratesse"
    ],
    "scelerats": [
        "scelerat"
    ],
    "scenar": [
        "scenar"
    ],
    "scenarimage": [
        "scenarimage"
    ],
    "scenario": [
        "scenario"
    ],
    "scenarios": [
        "scenario"
    ],
    "scenariste": [
        "scenariste"
    ],
    "scenaristes": [
        "scenariste"
    ],
    "scenaristique": [
        "scenaristique"
    ],
    "scenars": [
        "scenar"
    ],
    "scenique": [
        "scenique"
    ],
    "sceniques": [
        "scenique"
    ],
    "scenographe": [
        "scenographe"
    ],
    "scenographie": [
        "scenographie"
    ],
    "scenographique": [
        "scenographique"
    ],
    "se": [
        "se"
    ],
    "seaborgium": [
        "seaborgium"
    ],
    "seau": [
        "seau"
    ],
    "seaux": [
        "seau"
    ],
    "sec": [
        "sec"
    ],
    "secco": [
        "secco"
    ],
    "seccos": [
        "secco"
    ],
    "seccotine": [
        "seccotine"
    ],
    "second": [
        "second"
    ],
    "secondaient": [
        "seconder"
    ],
    "secondaire": [
        "secondaire"
    ],
    "secondairement": [
        "secondairement"
    ],
    "secondaires": [
        "secondaire"
    ],
    "secondais": [
        "seconder"
    ],
    "secondait": [
        "seconder"
    ],
    "secondant": [
        "seconder"
    ],
    "seconde": [
        "seconder",
        "second",
        "seconde"
    ],
    "secondement": [
        "secondement"
    ],
    "secondent": [
        "seconder"
    ],
    "seconder": [
        "seconder"
    ],
    "secondera": [
        "seconder"
    ],
    "seconderai": [
        "seconder"
    ],
    "seconderas": [
        "seconder"
    ],
    "seconderez": [
        "seconder"
    ],
    "seconderont": [
        "seconder"
    ],
    "secondes": [
        "seconder",
        "second",
        "seconde"
    ],
    "secondo": [
        "secondo"
    ],
    "seconds": [
        "second"
    ],
    "secondee": [
        "seconder"
    ],
    "secoua": [
        "secouer"
    ],
    "secouai": [
        "secouer"
    ],
    "secouaient": [
        "secouer"
    ],
    "secouais": [
        "secouer"
    ],
    "secouait": [
        "secouer"
    ],
    "secouant": [
        "secouer"
    ],
    "secouassent": [
        "secouer"
    ],
    "secoue": [
        "secouer"
    ],
    "secouement": [
        "secouement"
    ],
    "secouent": [
        "secouer"
    ],
    "secouer": [
        "secouer"
    ],
    "secouera": [
        "secouer"
    ],
    "secouerai": [
        "secouer"
    ],
    "secoueraient": [
        "secouer"
    ],
    "secouerais": [
        "secouer"
    ],
    "secouerait": [
        "secouer"
    ],
    "secouerez": [
        "secouer"
    ],
    "secoueront": [
        "secouer"
    ],
    "secoues": [
        "secouer"
    ],
    "secoueur": [
        "secoueur"
    ],
    "secoueurs": [
        "secoueur"
    ],
    "secouez": [
        "secouer"
    ],
    "secouions": [
        "secouer"
    ],
    "secouons": [
        "secouer"
    ],
    "secourable": [
        "secourable"
    ],
    "secourables": [
        "secourable"
    ],
    "secouraient": [
        "secourir"
    ],
    "secourait": [
        "secourir"
    ],
    "secourant": [
        "secourir"
    ],
    "secoures": [
        "secourir"
    ],
    "secourez": [
        "secourir"
    ],
    "secourions": [
        "secourir"
    ],
    "secourir": [
        "secourir"
    ],
    "secourisme": [
        "secourisme"
    ],
    "secouriste": [
        "secouriste"
    ],
    "secouristes": [
        "secouriste"
    ],
    "secourra": [
        "secourir"
    ],
    "secours": [
        "secourir",
        "secours"
    ],
    "secourt": [
        "secourir"
    ],
    "secouru": [
        "secourir"
    ],
    "secourue": [
        "secourir"
    ],
    "secourues": [
        "secourir"
    ],
    "secourus": [
        "secourir"
    ],
    "secourut": [
        "secourir"
    ],
    "secousse": [
        "secousse"
    ],
    "secousses": [
        "secousse"
    ],
    "secouames": [
        "secouer"
    ],
    "secouerent": [
        "secouer"
    ],
    "secouee": [
        "secouer"
    ],
    "secouees": [
        "secouer"
    ],
    "secret": [
        "secret"
    ],
    "secrets": [
        "secret"
    ],
    "secrete": [
        "secreter",
        "secret",
        "secrete"
    ],
    "secretement": [
        "secretement"
    ],
    "secretent": [
        "secreter"
    ],
    "secretes": [
        "secreter",
        "secret",
        "secrete"
    ],
    "secretaient": [
        "secreter"
    ],
    "secretaire": [
        "secretaire"
    ],
    "secretairerie": [
        "secretairerie"
    ],
    "secretaires": [
        "secretaire"
    ],
    "secretariat": [
        "secretariat"
    ],
    "secretariats": [
        "secretariat"
    ],
    "secreter": [
        "secreter"
    ],
    "secretee": [
        "secreter"
    ],
    "secs": [
        "sec"
    ],
    "sectaire": [
        "sectaire"
    ],
    "sectaires": [
        "sectaire"
    ],
    "sectarisme": [
        "sectarisme"
    ],
    "sectateur": [
        "sectateur"
    ],
    "sectateurs": [
        "sectateur"
    ],
    "secte": [
        "secte"
    ],
    "sectes": [
        "secte"
    ],
    "secteur": [
        "secteur"
    ],
    "secteurs": [
        "secteur"
    ],
    "section": [
        "section"
    ],
    "sectionna": [
        "sectionner"
    ],
    "sectionnaient": [
        "sectionner"
    ],
    "sectionnant": [
        "sectionner"
    ],
    "sectionne": [
        "sectionner"
    ],
    "sectionnement": [
        "sectionnement"
    ],
    "sectionnent": [
        "sectionner"
    ],
    "sectionner": [
        "sectionner"
    ],
    "sectionnera": [
        "sectionner"
    ],
    "sectionnez": [
        "sectionner"
    ],
    "sectionnee": [
        "sectionner"
    ],
    "sectionnees": [
        "sectionner"
    ],
    "sectionnes": [
        "sectionner"
    ],
    "sections": [
        "section"
    ],
    "sectorielles": [
        "sectoriel"
    ],
    "sectoriels": [
        "sectoriel"
    ],
    "sectorisation": [
        "sectorisation"
    ],
    "secundo": [
        "secundo"
    ],
    "sedan": [
        "sedan"
    ],
    "sedums": [
        "sedum"
    ],
    "seersucker": [
        "seersucker"
    ],
    "segment": [
        "segment"
    ],
    "segmentaire": [
        "segmentaire"
    ],
    "segmentale": [
        "segmental"
    ],
    "segmentez": [
        "segmenter"
    ],
    "segments": [
        "segment"
    ],
    "segmente": [
        "segmenter"
    ],
    "seguedilla": [
        "seguedilla"
    ],
    "seguedillas": [
        "seguedilla"
    ],
    "seiche": [
        "seiche"
    ],
    "seiches": [
        "seiche"
    ],
    "seigle": [
        "seigle"
    ],
    "seigles": [
        "seigle"
    ],
    "seigneur": [
        "seigneur"
    ],
    "seigneurial": [
        "seigneurial"
    ],
    "seigneuriale": [
        "seigneurial"
    ],
    "seigneuriales": [
        "seigneurial"
    ],
    "seigneuriaux": [
        "seigneurial"
    ],
    "seigneurie": [
        "seigneurie"
    ],
    "seigneuries": [
        "seigneurie"
    ],
    "seigneurs": [
        "seigneur"
    ],
    "seille": [
        "seille"
    ],
    "seilles": [
        "seille"
    ],
    "seillon": [
        "seillon"
    ],
    "sein": [
        "sein"
    ],
    "seine": [
        "seine"
    ],
    "seing": [
        "seing"
    ],
    "seins": [
        "sein"
    ],
    "seize": [
        "seize"
    ],
    "seizieme": [
        "seizieme"
    ],
    "sel": [
        "sel"
    ],
    "seldjoukide": [
        "seldjoukide"
    ],
    "seldjoukides": [
        "seldjoukide"
    ],
    "select": [
        "select"
    ],
    "selects": [
        "select"
    ],
    "self": [
        "self"
    ],
    "selfs": [
        "self"
    ],
    "sellait": [
        "seller"
    ],
    "selle": [
        "seller",
        "selle"
    ],
    "seller": [
        "seller"
    ],
    "sellerie": [
        "sellerie"
    ],
    "selleries": [
        "sellerie"
    ],
    "selles": [
        "seller",
        "selle"
    ],
    "sellette": [
        "sellette"
    ],
    "sellez": [
        "seller"
    ],
    "sellier": [
        "sellier"
    ],
    "sellee": [
        "seller"
    ],
    "sellees": [
        "seller"
    ],
    "selon": [
        "selon"
    ],
    "sels": [
        "sel"
    ],
    "seltz": [
        "seltz"
    ],
    "selva": [
        "selva"
    ],
    "sema": [
        "semer"
    ],
    "semaient": [
        "semer"
    ],
    "semailles": [
        "semaille"
    ],
    "semaine": [
        "semaine"
    ],
    "semaines": [
        "semaine"
    ],
    "semainier": [
        "semainier"
    ],
    "semait": [
        "semer"
    ],
    "semant": [
        "semer"
    ],
    "sembla": [
        "sembler"
    ],
    "semblable": [
        "semblable"
    ],
    "semblablement": [
        "semblablement"
    ],
    "semblables": [
        "semblable"
    ],
    "semblaient": [
        "sembler"
    ],
    "semblais": [
        "sembler"
    ],
    "semblait": [
        "sembler"
    ],
    "semblance": [
        "semblance"
    ],
    "semblant": [
        "semblant",
        "sembler"
    ],
    "semblants": [
        "semblant"
    ],
    "semble": [
        "sembler"
    ],
    "semblent": [
        "sembler"
    ],
    "sembler": [
        "sembler"
    ],
    "semblera": [
        "sembler"
    ],
    "sembleraient": [
        "sembler"
    ],
    "semblerait": [
        "sembler"
    ],
    "sembleront": [
        "sembler"
    ],
    "sembles": [
        "sembler"
    ],
    "semblez": [
        "sembler"
    ],
    "sembliez": [
        "sembler"
    ],
    "semblions": [
        "sembler"
    ],
    "semblons": [
        "sembler"
    ],
    "semblat": [
        "sembler"
    ],
    "semblerent": [
        "sembler"
    ],
    "semelle": [
        "semelle"
    ],
    "semelles": [
        "semelle"
    ],
    "semence": [
        "semence"
    ],
    "semences": [
        "semence"
    ],
    "semer": [
        "semer"
    ],
    "semestre": [
        "semestre"
    ],
    "semestres": [
        "semestre"
    ],
    "semestriel": [
        "semestriel"
    ],
    "semestrielle": [
        "semestriel"
    ],
    "semestriellement": [
        "semestriellement"
    ],
    "semeur": [
        "semeur"
    ],
    "semeurs": [
        "semeur"
    ],
    "semeuse": [
        "semeuse"
    ],
    "semeuses": [
        "semeur"
    ],
    "semez": [
        "semer"
    ],
    "semi": [
        "semi"
    ],
    "semis": [
        "semi",
        "semis"
    ],
    "semoir": [
        "semoir"
    ],
    "semoirs": [
        "semoir"
    ],
    "semonce": [
        "semoncer",
        "semonce"
    ],
    "semoncer": [
        "semoncer"
    ],
    "semonces": [
        "semonce"
    ],
    "semons": [
        "semer"
    ],
    "semonca": [
        "semoncer"
    ],
    "semoncait": [
        "semoncer"
    ],
    "semoncant": [
        "semoncer"
    ],
    "semoule": [
        "semoule"
    ],
    "sempiternel": [
        "sempiternel"
    ],
    "sempiternelle": [
        "sempiternel"
    ],
    "sempiternellement": [
        "sempiternellement"
    ],
    "sempiternelles": [
        "sempiternel"
    ],
    "sempiternels": [
        "sempiternel"
    ],
    "semtex": [
        "semtex"
    ],
    "semat": [
        "semer"
    ],
    "seme": [
        "semer",
        "seme"
    ],
    "semee": [
        "semer",
        "seme"
    ],
    "semees": [
        "semer"
    ],
    "semes": [
        "semer",
        "seme"
    ],
    "sen": [
        "sen"
    ],
    "senestre": [
        "senestre"
    ],
    "senior": [
        "senior"
    ],
    "seniors": [
        "senior"
    ],
    "senne": [
        "seine"
    ],
    "sens": [
        "sen",
        "sens",
        "sentir"
    ],
    "sensas": [
        "sensas"
    ],
    "sensass": [
        "sensass"
    ],
    "sensation": [
        "sensation"
    ],
    "sensationnalisme": [
        "sensationnalisme"
    ],
    "sensationnel": [
        "sensationnel"
    ],
    "sensationnelle": [
        "sensationnel"
    ],
    "sensationnellement": [
        "sensationnellement"
    ],
    "sensationnelles": [
        "sensationnel"
    ],
    "sensationnels": [
        "sensationnel"
    ],
    "sensations": [
        "sensation"
    ],
    "senseur": [
        "senseur"
    ],
    "senseurs": [
        "senseur"
    ],
    "sensibilisait": [
        "sensibiliser"
    ],
    "sensibilisation": [
        "sensibilisation"
    ],
    "sensibilise": [
        "sensibiliser"
    ],
    "sensibiliser": [
        "sensibiliser"
    ],
    "sensibilisee": [
        "sensibiliser"
    ],
    "sensibilises": [
        "sensibiliser"
    ],
    "sensibilite": [
        "sensibilite"
    ],
    "sensibilites": [
        "sensibilite"
    ],
    "sensible": [
        "sensible"
    ],
    "sensiblement": [
        "sensiblement"
    ],
    "sensiblerie": [
        "sensiblerie"
    ],
    "sensibleries": [
        "sensiblerie"
    ],
    "sensibles": [
        "sensible"
    ],
    "sensitif": [
        "sensitif"
    ],
    "sensitifs": [
        "sensitif"
    ],
    "sensitive": [
        "sensitif"
    ],
    "sensitives": [
        "sensitif",
        "sensitive"
    ],
    "sensorialite": [
        "sensorialite"
    ],
    "sensoriel": [
        "sensoriel"
    ],
    "sensorielle": [
        "sensoriel"
    ],
    "sensorielles": [
        "sensoriel"
    ],
    "sensoriels": [
        "sensoriel"
    ],
    "sensualiste": [
        "sensualiste"
    ],
    "sensualite": [
        "sensualite"
    ],
    "sensualites": [
        "sensualite"
    ],
    "sensuel": [
        "sensuel"
    ],
    "sensuelle": [
        "sensuel"
    ],
    "sensuellement": [
        "sensuellement"
    ],
    "sensuelles": [
        "sensuel"
    ],
    "sensuels": [
        "sensuel"
    ],
    "sense": [
        "sense"
    ],
    "sensee": [
        "sense"
    ],
    "sensees": [
        "sense"
    ],
    "sensement": [
        "sensement"
    ],
    "senses": [
        "sense"
    ],
    "sent": [
        "sentir",
        "send"
    ],
    "sentaient": [
        "sentir"
    ],
    "sentais": [
        "sentir"
    ],
    "sentait": [
        "sentir"
    ],
    "sentant": [
        "sentant",
        "sentir"
    ],
    "sente": [
        "sente",
        "sentir"
    ],
    "sentence": [
        "sentence"
    ],
    "sentences": [
        "sentence"
    ],
    "sentencieuse": [
        "sentencieux"
    ],
    "sentencieusement": [
        "sentencieusement"
    ],
    "sentencieuses": [
        "sentencieux"
    ],
    "sentencieux": [
        "sentencieux"
    ],
    "sentent": [
        "sentir"
    ],
    "sentes": [
        "sente",
        "sentir"
    ],
    "senteur": [
        "senteur"
    ],
    "senteurs": [
        "senteur"
    ],
    "sentez": [
        "sentir"
    ],
    "senti": [
        "senti",
        "sentir"
    ],
    "sentie": [
        "senti",
        "sentir"
    ],
    "sentier": [
        "sentier"
    ],
    "sentiers": [
        "sentier"
    ],
    "senties": [
        "senti",
        "sentir"
    ],
    "sentiez": [
        "sentir"
    ],
    "sentiment": [
        "sentiment"
    ],
    "sentimental": [
        "sentimental"
    ],
    "sentimentale": [
        "sentimental"
    ],
    "sentimentalement": [
        "sentimentalement"
    ],
    "sentimentales": [
        "sentimental"
    ],
    "sentimentaliser": [
        "sentimentaliser"
    ],
    "sentimentalisme": [
        "sentimentalisme"
    ],
    "sentimentalite": [
        "sentimentalite"
    ],
    "sentimentalites": [
        "sentimentalite"
    ],
    "sentimentaux": [
        "sentimental"
    ],
    "sentiments": [
        "sentiment"
    ],
    "sentine": [
        "sentine"
    ],
    "sentinelle": [
        "sentinelle"
    ],
    "sentinelles": [
        "sentinelle"
    ],
    "sentines": [
        "sentine"
    ],
    "sentions": [
        "sentir"
    ],
    "sentir": [
        "sentir"
    ],
    "sentira": [
        "sentir"
    ],
    "sentirai": [
        "sentir"
    ],
    "sentiraient": [
        "sentir"
    ],
    "sentirais": [
        "sentir"
    ],
    "sentirait": [
        "sentir"
    ],
    "sentiras": [
        "sentir"
    ],
    "sentirent": [
        "sentir"
    ],
    "sentirez": [
        "sentir"
    ],
    "sentiriez": [
        "sentir"
    ],
    "sentirons": [
        "sentir"
    ],
    "sentiront": [
        "sentir"
    ],
    "sentis": [
        "senti",
        "sentir"
    ],
    "sentisse": [
        "sentir"
    ],
    "sentissent": [
        "sentir"
    ],
    "sentit": [
        "sentir"
    ],
    "sentons": [
        "sentir"
    ],
    "sentimes": [
        "sentir"
    ],
    "seppuku": [
        "seppuku"
    ],
    "seps": [
        "sep",
        "seps"
    ],
    "sept": [
        "sept"
    ],
    "septale": [
        "septal"
    ],
    "septante": [
        "septante"
    ],
    "septaux": [
        "septal"
    ],
    "septembre": [
        "septembre"
    ],
    "septembriseur": [
        "septembriseur"
    ],
    "septennat": [
        "septennat"
    ],
    "septentrion": [
        "septentrion"
    ],
    "septentrional": [
        "septentrional"
    ],
    "septentrionale": [
        "septentrional"
    ],
    "septentrionales": [
        "septentrional"
    ],
    "septicite": [
        "septicite"
    ],
    "septicemie": [
        "septicemie"
    ],
    "septicemique": [
        "septicemique"
    ],
    "septidi": [
        "septidi"
    ],
    "septime": [
        "septime"
    ],
    "septique": [
        "septique"
    ],
    "septieme": [
        "septieme"
    ],
    "septiemes": [
        "septieme"
    ],
    "septuagenaire": [
        "septuagenaire"
    ],
    "septuagenaires": [
        "septuagenaire"
    ],
    "septum": [
        "septum"
    ],
    "septuor": [
        "septuor"
    ],
    "septuple": [
        "septuple"
    ],
    "sepuku": [
        "sepuku"
    ],
    "sequin": [
        "sequin"
    ],
    "sequins": [
        "sequin"
    ],
    "sera": [
        "etre"
    ],
    "serai": [
        "etre"
    ],
    "seraient": [
        "etre"
    ],
    "serais": [
        "etre"
    ],
    "serait": [
        "etre"
    ],
    "seras": [
        "etre"
    ],
    "serbe": [
        "serbe"
    ],
    "serbes": [
        "serbe"
    ],
    "serein": [
        "serein"
    ],
    "sereine": [
        "serein"
    ],
    "sereinement": [
        "sereinement"
    ],
    "sereines": [
        "serein"
    ],
    "sereins": [
        "serein"
    ],
    "serez": [
        "etre"
    ],
    "serf": [
        "serf"
    ],
    "serfouette": [
        "serfouette"
    ],
    "serfs": [
        "serf"
    ],
    "serge": [
        "serge"
    ],
    "sergent": [
        "sergent"
    ],
    "sergents": [
        "sergent"
    ],
    "serges": [
        "serge"
    ],
    "sergot": [
        "sergot"
    ],
    "sergots": [
        "sergot"
    ],
    "serial": [
        "serial"
    ],
    "seriez": [
        "etre"
    ],
    "serin": [
        "serin"
    ],
    "serinais": [
        "seriner"
    ],
    "serinait": [
        "seriner"
    ],
    "serine": [
        "seriner",
        "serin"
    ],
    "seriner": [
        "seriner"
    ],
    "serinera": [
        "seriner"
    ],
    "serines": [
        "seriner",
        "serin"
    ],
    "seringa": [
        "seringa"
    ],
    "seringas": [
        "seringa"
    ],
    "seringuaient": [
        "seringuer"
    ],
    "seringuait": [
        "seringuer"
    ],
    "seringue": [
        "seringue"
    ],
    "seringueiros": [
        "seringueiro"
    ],
    "seringuer": [
        "seringuer"
    ],
    "seringues": [
        "seringue"
    ],
    "seringuee": [
        "seringuer"
    ],
    "serinions": [
        "seriner"
    ],
    "serins": [
        "serin"
    ],
    "serinees": [
        "seriner"
    ],
    "serions": [
        "etre"
    ],
    "serment": [
        "serment"
    ],
    "serments": [
        "serment"
    ],
    "sermon": [
        "sermon"
    ],
    "sermonna": [
        "sermonner"
    ],
    "sermonnaient": [
        "sermonner"
    ],
    "sermonnait": [
        "sermonner"
    ],
    "sermonnant": [
        "sermonner"
    ],
    "sermonne": [
        "sermonner"
    ],
    "sermonner": [
        "sermonner"
    ],
    "sermonnerai": [
        "sermonner"
    ],
    "sermonnes": [
        "sermonner"
    ],
    "sermonneur": [
        "sermonneur"
    ],
    "sermonneurs": [
        "sermonneur"
    ],
    "sermonnez": [
        "sermonner"
    ],
    "sermonnee": [
        "sermonner"
    ],
    "sermons": [
        "sermon"
    ],
    "serons": [
        "etre"
    ],
    "seront": [
        "etre"
    ],
    "serpe": [
        "serpe"
    ],
    "serpent": [
        "serpent"
    ],
    "serpentaient": [
        "serpenter"
    ],
    "serpentaire": [
        "serpentaire"
    ],
    "serpentait": [
        "serpenter"
    ],
    "serpentant": [
        "serpentant",
        "serpenter"
    ],
    "serpente": [
        "serpenter"
    ],
    "serpenteau": [
        "serpenteau"
    ],
    "serpentement": [
        "serpentement"
    ],
    "serpentements": [
        "serpentement"
    ],
    "serpentent": [
        "serpenter"
    ],
    "serpenter": [
        "serpenter"
    ],
    "serpentiforme": [
        "serpentiforme"
    ],
    "serpentin": [
        "serpentin"
    ],
    "serpentine": [
        "serpentin"
    ],
    "serpentines": [
        "serpentin",
        "serpentine"
    ],
    "serpentins": [
        "serpentin"
    ],
    "serpentons": [
        "serpenter"
    ],
    "serpents": [
        "serpent"
    ],
    "serpes": [
        "serpe"
    ],
    "serpette": [
        "serpette"
    ],
    "serpilliere": [
        "serpilliere"
    ],
    "serpillieres": [
        "serpilliere"
    ],
    "serpolet": [
        "serpolet"
    ],
    "serra": [
        "serrer",
        "serra"
    ],
    "serrage": [
        "serrage"
    ],
    "serrai": [
        "serrer"
    ],
    "serraient": [
        "serrer"
    ],
    "serrais": [
        "serrer"
    ],
    "serrait": [
        "serrer"
    ],
    "serrant": [
        "serrer"
    ],
    "serrante": [
        "serrante"
    ],
    "serre": [
        "serrer",
        "serre"
    ],
    "serrement": [
        "serrement"
    ],
    "serrements": [
        "serrement"
    ],
    "serrent": [
        "serrer"
    ],
    "serrer": [
        "serrer"
    ],
    "serrera": [
        "serrer"
    ],
    "serrerai": [
        "serrer"
    ],
    "serreraient": [
        "serrer"
    ],
    "serrerais": [
        "serrer"
    ],
    "serrerait": [
        "serrer"
    ],
    "serrerez": [
        "serrer"
    ],
    "serrerons": [
        "serrer"
    ],
    "serreront": [
        "serrer"
    ],
    "serres": [
        "serrer",
        "serre"
    ],
    "serrez": [
        "serrer"
    ],
    "serriez": [
        "serrer"
    ],
    "serrions": [
        "serrer"
    ],
    "serrons": [
        "serrer"
    ],
    "serrure": [
        "serrure"
    ],
    "serrurerie": [
        "serrurerie"
    ],
    "serrures": [
        "serrure"
    ],
    "serrurier": [
        "serrurier"
    ],
    "serruriers": [
        "serrurier"
    ],
    "serruriere": [
        "serrurier"
    ],
    "serrames": [
        "serrer"
    ],
    "serrat": [
        "serrer"
    ],
    "serrerent": [
        "serrer"
    ],
    "serree": [
        "serrer",
        "serre"
    ],
    "serrees": [
        "serrer",
        "serre"
    ],
    "sers": [
        "servir"
    ],
    "sert": [
        "servir",
        "sert"
    ],
    "sertao": [
        "sertao"
    ],
    "serti": [
        "serti",
        "sertir"
    ],
    "sertie": [
        "sertir"
    ],
    "serties": [
        "sertir"
    ],
    "sertir": [
        "sertir"
    ],
    "sertirait": [
        "sertir"
    ],
    "sertis": [
        "serti",
        "sertir"
    ],
    "sertissage": [
        "sertissage"
    ],
    "sertissaient": [
        "sertir"
    ],
    "sertissait": [
        "sertir"
    ],
    "sertissant": [
        "sertir"
    ],
    "sertissent": [
        "sertir"
    ],
    "sertisseur": [
        "sertisseur"
    ],
    "servage": [
        "servage"
    ],
    "servaient": [
        "servir"
    ],
    "servais": [
        "servir"
    ],
    "servait": [
        "servir"
    ],
    "serval": [
        "serval"
    ],
    "servant": [
        "servir",
        "servant"
    ],
    "servante": [
        "servant"
    ],
    "servantes": [
        "servant"
    ],
    "servants": [
        "servant"
    ],
    "serve": [
        "servir",
        "serve"
    ],
    "servent": [
        "servir"
    ],
    "serves": [
        "servir",
        "serve"
    ],
    "serveur": [
        "serveur"
    ],
    "serveurs": [
        "serveur"
    ],
    "serveuse": [
        "serveur"
    ],
    "serveuses": [
        "serveur"
    ],
    "servez": [
        "servir"
    ],
    "servi": [
        "servi",
        "servir"
    ],
    "serviabilite": [
        "serviabilite"
    ],
    "serviable": [
        "serviable"
    ],
    "serviables": [
        "serviable"
    ],
    "service": [
        "service"
    ],
    "services": [
        "service"
    ],
    "servie": [
        "servi",
        "servir"
    ],
    "servies": [
        "servi",
        "servir"
    ],
    "serviette": [
        "serviette"
    ],
    "serviettes": [
        "serviette"
    ],
    "serviez": [
        "servir"
    ],
    "servile": [
        "servile"
    ],
    "servilement": [
        "servilement"
    ],
    "serviles": [
        "servile"
    ],
    "servilite": [
        "servilite"
    ],
    "servilites": [
        "servilite"
    ],
    "servions": [
        "servir"
    ],
    "servir": [
        "servir"
    ],
    "servira": [
        "servir"
    ],
    "servirai": [
        "servir"
    ],
    "serviraient": [
        "servir"
    ],
    "servirais": [
        "servir"
    ],
    "servirait": [
        "servir"
    ],
    "serviras": [
        "servir"
    ],
    "servirent": [
        "servir"
    ],
    "servirez": [
        "servir"
    ],
    "serviriez": [
        "servir"
    ],
    "servirions": [
        "servir"
    ],
    "servirons": [
        "servir"
    ],
    "serviront": [
        "servir"
    ],
    "servis": [
        "servi",
        "servir"
    ],
    "servissent": [
        "servir"
    ],
    "servit": [
        "servir"
    ],
    "serviteur": [
        "serviteur"
    ],
    "serviteurs": [
        "serviteur"
    ],
    "servitude": [
        "servitude"
    ],
    "servitudes": [
        "servitude"
    ],
    "servofrein": [
        "servofrein"
    ],
    "servomoteur": [
        "servomoteur"
    ],
    "servomoteurs": [
        "servomoteur"
    ],
    "servomecanisme": [
        "servomecanisme"
    ],
    "servons": [
        "servir"
    ],
    "servimes": [
        "servir"
    ],
    "ses": [
        "ses",
        "son"
    ],
    "session": [
        "session"
    ],
    "sessions": [
        "session"
    ],
    "sesterces": [
        "sesterce"
    ],
    "set": [
        "set"
    ],
    "sets": [
        "set"
    ],
    "setter": [
        "setter"
    ],
    "setters": [
        "setter"
    ],
    "seuil": [
        "seuil"
    ],
    "seuils": [
        "seuil"
    ],
    "seul": [
        "seul"
    ],
    "seulabre": [
        "seulabre"
    ],
    "seulabres": [
        "seulabre"
    ],
    "seule": [
        "seul"
    ],
    "seulement": [
        "seulement"
    ],
    "seules": [
        "seul"
    ],
    "seulet": [
        "seulet"
    ],
    "seulette": [
        "seulet"
    ],
    "seulettes": [
        "seulet"
    ],
    "seuls": [
        "seul"
    ],
    "seventies": [
        "seventies"
    ],
    "sevrage": [
        "sevrage"
    ],
    "sevrages": [
        "sevrage"
    ],
    "sevrait": [
        "sevrer"
    ],
    "sevrer": [
        "sevrer"
    ],
    "sevre": [
        "sevrer"
    ],
    "sevree": [
        "sevrer"
    ],
    "sevrees": [
        "sevrer"
    ],
    "sevres": [
        "sevrer",
        "sevres"
    ],
    "sexagenaire": [
        "sexagenaire"
    ],
    "sexagenaires": [
        "sexagenaire"
    ],
    "sexe": [
        "sexe"
    ],
    "sexes": [
        "sex",
        "sexe"
    ],
    "sexisme": [
        "sexisme"
    ],
    "sexiste": [
        "sexiste"
    ],
    "sexistes": [
        "sexiste"
    ],
    "sexologie": [
        "sexologie"
    ],
    "sexologique": [
        "sexologique"
    ],
    "sexologue": [
        "sexologue"
    ],
    "sexologues": [
        "sexologue"
    ],
    "sextant": [
        "sextant"
    ],
    "sextidi": [
        "sextidi"
    ],
    "sextile": [
        "sextil"
    ],
    "sexto": [
        "sexto"
    ],
    "sextuor": [
        "sextuor"
    ],
    "sextuple": [
        "sextuple"
    ],
    "sexualiser": [
        "sexualiser"
    ],
    "sexualise": [
        "sexualiser"
    ],
    "sexualite": [
        "sexualite"
    ],
    "sexuel": [
        "sexuel"
    ],
    "sexuelle": [
        "sexuel"
    ],
    "sexuellement": [
        "sexuellement"
    ],
    "sexuelles": [
        "sexuel"
    ],
    "sexuels": [
        "sexuel"
    ],
    "sexue": [
        "sexue"
    ],
    "sexues": [
        "sexue"
    ],
    "sexy": [
        "sexy"
    ],
    "seyait": [
        "seoir"
    ],
    "seyant": [
        "seyant"
    ],
    "seyante": [
        "seyant"
    ],
    "seyantes": [
        "seyant"
    ],
    "seyants": [
        "seyant"
    ],
    "senor": [
        "senor"
    ],
    "shabbat": [
        "shabbat"
    ],
    "shah": [
        "shah"
    ],
    "shahs": [
        "shah"
    ],
    "shaker": [
        "shaker"
    ],
    "shakespearien": [
        "shakespearien"
    ],
    "shakespearienne": [
        "shakespearien"
    ],
    "shakespeariens": [
        "shakespearien"
    ],
    "shako": [
        "shako"
    ],
    "shakos": [
        "shako"
    ],
    "shale": [
        "shale"
    ],
    "shaman": [
        "shaman"
    ],
    "shamans": [
        "shaman"
    ],
    "shamisen": [
        "shamisen"
    ],
    "shampoing": [
        "shampoing"
    ],
    "shampoings": [
        "shampoing"
    ],
    "shampooiner": [
        "shampooiner"
    ],
    "shampooing": [
        "shampooing",
        "shampoo"
    ],
    "shampooings": [
        "shampooing"
    ],
    "shampouine": [
        "shampouiner"
    ],
    "shampouiner": [
        "shampouiner"
    ],
    "shampouineur": [
        "shampouineur"
    ],
    "shampouineuse": [
        "shampouineur"
    ],
    "shampouineuses": [
        "shampouineur"
    ],
    "shanghaien": [
        "shanghaien"
    ],
    "shanghaiens": [
        "shanghaien"
    ],
    "shantung": [
        "shantung"
    ],
    "shed": [
        "shed"
    ],
    "shekels": [
        "shekel"
    ],
    "sheriff": [
        "sheriff"
    ],
    "sherpa": [
        "sherpa"
    ],
    "sherpas": [
        "sherpa"
    ],
    "sherry": [
        "sherry"
    ],
    "shetland": [
        "shetland"
    ],
    "shetlands": [
        "shetland"
    ],
    "shiatsu": [
        "shiatsu"
    ],
    "shift": [
        "shift"
    ],
    "shilling": [
        "shilling"
    ],
    "shillings": [
        "shilling"
    ],
    "shilom": [
        "shilom"
    ],
    "shimmy": [
        "shimmy"
    ],
    "shingle": [
        "shingle"
    ],
    "shintoisme": [
        "shintoisme"
    ],
    "shintoiste": [
        "shintoiste"
    ],
    "shinto": [
        "shinto"
    ],
    "shipchandler": [
        "shipchandler"
    ],
    "shipping": [
        "shipping",
        "ship"
    ],
    "shirting": [
        "shirting"
    ],
    "shit": [
        "shit"
    ],
    "shocking": [
        "shocking",
        "shock"
    ],
    "shogoun": [
        "shogoun"
    ],
    "shogun": [
        "shogun"
    ],
    "shogunal": [
        "shogunal"
    ],
    "shogunale": [
        "shogunal"
    ],
    "shogunat": [
        "shogunat"
    ],
    "shoot": [
        "shoot"
    ],
    "shoota": [
        "shooter"
    ],
    "shootai": [
        "shooter"
    ],
    "shootais": [
        "shooter"
    ],
    "shootait": [
        "shooter"
    ],
    "shootant": [
        "shooter"
    ],
    "shoote": [
        "shooter"
    ],
    "shootent": [
        "shooter"
    ],
    "shooter": [
        "shooter"
    ],
    "shootera": [
        "shooter"
    ],
    "shooterai": [
        "shooter"
    ],
    "shooteraient": [
        "shooter"
    ],
    "shooteras": [
        "shooter"
    ],
    "shootes": [
        "shooter"
    ],
    "shooteuse": [
        "shooteur"
    ],
    "shootiez": [
        "shooter"
    ],
    "shootions": [
        "shooter"
    ],
    "shootons": [
        "shooter"
    ],
    "shoots": [
        "shoot"
    ],
    "shootee": [
        "shooter"
    ],
    "shopping": [
        "shopping",
        "shop"
    ],
    "shoppings": [
        "shopping"
    ],
    "short": [
        "short"
    ],
    "shorts": [
        "short"
    ],
    "shoshones": [
        "shoshone"
    ],
    "show": [
        "show"
    ],
    "showbiz": [
        "showbiz"
    ],
    "shows": [
        "show"
    ],
    "shrapnel": [
        "shrapnel"
    ],
    "shrapnell": [
        "shrapnell"
    ],
    "shrapnells": [
        "shrapnell"
    ],
    "shrapnels": [
        "shrapnel"
    ],
    "shunt": [
        "shunt"
    ],
    "shunte": [
        "shunter"
    ],
    "shunter": [
        "shunter"
    ],
    "sheol": [
        "sheol"
    ],
    "sherif": [
        "sherif"
    ],
    "sherifs": [
        "sherif"
    ],
    "si": [
        "si"
    ],
    "siam": [
        "siam"
    ],
    "siamois": [
        "siamois"
    ],
    "siamoise": [
        "siamois"
    ],
    "siamoises": [
        "siamois"
    ],
    "sibilant": [
        "sibilant"
    ],
    "sibylle": [
        "sibylle"
    ],
    "sibylles": [
        "sibylle"
    ],
    "sibyllin": [
        "sibyllin"
    ],
    "sibylline": [
        "sibyllin"
    ],
    "sibyllines": [
        "sibyllin"
    ],
    "sibyllins": [
        "sibyllin"
    ],
    "siberien": [
        "siberien"
    ],
    "siberienne": [
        "siberienne",
        "siberien"
    ],
    "siberiennes": [
        "siberien"
    ],
    "siberiens": [
        "siberien"
    ],
    "sic": [
        "sic"
    ],
    "sicaire": [
        "sicaire"
    ],
    "sicaires": [
        "sicaire"
    ],
    "sicilien": [
        "sicilien"
    ],
    "sicilienne": [
        "sicilien"
    ],
    "siciliennes": [
        "sicilien"
    ],
    "siciliens": [
        "sicilien"
    ],
    "sicle": [
        "sicle"
    ],
    "sida": [
        "sida"
    ],
    "sidas": [
        "sida"
    ],
    "sidaique": [
        "sidaique"
    ],
    "sidi": [
        "sidi"
    ],
    "sidis": [
        "sidi"
    ],
    "sidere": [
        "sidere",
        "siderer"
    ],
    "sideenne": [
        "sideen"
    ],
    "sideens": [
        "sideen"
    ],
    "siderais": [
        "siderer"
    ],
    "siderait": [
        "siderer"
    ],
    "sideral": [
        "sideral"
    ],
    "siderale": [
        "sideral"
    ],
    "siderales": [
        "sideral"
    ],
    "siderant": [
        "siderer",
        "siderant"
    ],
    "siderante": [
        "siderant"
    ],
    "sideration": [
        "sideration"
    ],
    "sideraux": [
        "sideral"
    ],
    "siderer": [
        "siderer"
    ],
    "siderite": [
        "siderite"
    ],
    "siderurgie": [
        "siderurgie"
    ],
    "siderurgique": [
        "siderurgique"
    ],
    "siderurgiques": [
        "siderurgique"
    ],
    "siderurgistes": [
        "siderurgiste"
    ],
    "sideree": [
        "sidere",
        "siderer"
    ],
    "siderees": [
        "sidere",
        "siderer"
    ],
    "sideres": [
        "sidere",
        "siderer"
    ],
    "sied": [
        "seoir"
    ],
    "sien": [
        "sien"
    ],
    "sienne": [
        "sienne"
    ],
    "siennes": [
        "siennes"
    ],
    "siennois": [
        "siennois"
    ],
    "siennoise": [
        "siennois"
    ],
    "siennoises": [
        "siennois"
    ],
    "siens": [
        "siens"
    ],
    "sierra": [
        "sierra"
    ],
    "sierras": [
        "sierra"
    ],
    "siesta": [
        "siester"
    ],
    "siestant": [
        "siester"
    ],
    "sieste": [
        "sieste"
    ],
    "siestes": [
        "sieste"
    ],
    "sieur": [
        "sieur"
    ],
    "sieurs": [
        "sieur"
    ],
    "siffla": [
        "siffler"
    ],
    "sifflai": [
        "siffler"
    ],
    "sifflaient": [
        "siffler"
    ],
    "sifflais": [
        "siffler"
    ],
    "sifflait": [
        "siffler"
    ],
    "sifflant": [
        "siffler",
        "sifflant"
    ],
    "sifflante": [
        "sifflante"
    ],
    "sifflantes": [
        "sifflant"
    ],
    "sifflants": [
        "sifflant"
    ],
    "sifflard": [
        "sifflard"
    ],
    "siffle": [
        "siffler"
    ],
    "sifflement": [
        "sifflement"
    ],
    "sifflements": [
        "sifflement"
    ],
    "sifflent": [
        "siffler"
    ],
    "siffler": [
        "siffler"
    ],
    "sifflera": [
        "siffler"
    ],
    "sifflerai": [
        "siffler"
    ],
    "siffleraient": [
        "siffler"
    ],
    "sifflerait": [
        "siffler"
    ],
    "siffleras": [
        "siffler"
    ],
    "siffles": [
        "siffler"
    ],
    "sifflet": [
        "sifflet"
    ],
    "sifflets": [
        "sifflet"
    ],
    "siffleur": [
        "siffleur"
    ],
    "sifflez": [
        "siffler"
    ],
    "siffliez": [
        "siffler"
    ],
    "sifflota": [
        "siffloter"
    ],
    "sifflotais": [
        "siffloter"
    ],
    "sifflotait": [
        "siffloter"
    ],
    "sifflotant": [
        "siffloter"
    ],
    "sifflote": [
        "siffloter"
    ],
    "sifflotement": [
        "sifflotement"
    ],
    "siffloter": [
        "siffloter"
    ],
    "siffloterai": [
        "siffloter"
    ],
    "sifflotiez": [
        "siffloter"
    ],
    "sifflotis": [
        "sifflotis"
    ],
    "siffloterent": [
        "siffloter"
    ],
    "sifflerent": [
        "siffler"
    ],
    "sifflee": [
        "siffler"
    ],
    "sifflees": [
        "siffler"
    ],
    "sigillaire": [
        "sigillaire"
    ],
    "sigille": [
        "sigille"
    ],
    "sigillee": [
        "sigille"
    ],
    "sigisbee": [
        "sigisbee"
    ],
    "sigisbees": [
        "sigisbee"
    ],
    "sigle": [
        "sigle"
    ],
    "sigles": [
        "sigle"
    ],
    "sigmoide": [
        "sigmoide"
    ],
    "signa": [
        "signer"
    ],
    "signai": [
        "signer"
    ],
    "signaient": [
        "signer"
    ],
    "signais": [
        "signer"
    ],
    "signait": [
        "signer"
    ],
    "signal": [
        "signal"
    ],
    "signala": [
        "signaler"
    ],
    "signalai": [
        "signaler"
    ],
    "signalaient": [
        "signaler"
    ],
    "signalais": [
        "signaler"
    ],
    "signalait": [
        "signaler"
    ],
    "signalant": [
        "signaler"
    ],
    "signale": [
        "signale",
        "signaler"
    ],
    "signalement": [
        "signalement"
    ],
    "signalements": [
        "signalement"
    ],
    "signalent": [
        "signaler"
    ],
    "signaler": [
        "signaler"
    ],
    "signalera": [
        "signaler"
    ],
    "signalerai": [
        "signaler"
    ],
    "signalerait": [
        "signaler"
    ],
    "signaleront": [
        "signaler"
    ],
    "signales": [
        "signale",
        "signaler"
    ],
    "signaleur": [
        "signaleur"
    ],
    "signaleurs": [
        "signaleur"
    ],
    "signalez": [
        "signaler"
    ],
    "signalisation": [
        "signalisation"
    ],
    "signalisations": [
        "signalisation"
    ],
    "signaliser": [
        "signaliser"
    ],
    "signalons": [
        "signaler"
    ],
    "signalat": [
        "signaler"
    ],
    "signalee": [
        "signale",
        "signaler"
    ],
    "signalees": [
        "signale",
        "signaler"
    ],
    "signaletique": [
        "signaletique"
    ],
    "signaletiques": [
        "signaletique"
    ],
    "signant": [
        "signer"
    ],
    "signasse": [
        "signer"
    ],
    "signataire": [
        "signataire"
    ],
    "signataires": [
        "signataire"
    ],
    "signature": [
        "signature"
    ],
    "signatures": [
        "signature"
    ],
    "signaux": [
        "signal"
    ],
    "signe": [
        "signe",
        "signer"
    ],
    "signent": [
        "signer"
    ],
    "signer": [
        "signer"
    ],
    "signera": [
        "signer"
    ],
    "signerai": [
        "signer"
    ],
    "signeraient": [
        "signer"
    ],
    "signerais": [
        "signer"
    ],
    "signerait": [
        "signer"
    ],
    "signeras": [
        "signer"
    ],
    "signerez": [
        "signer"
    ],
    "signeriez": [
        "signer"
    ],
    "signerions": [
        "signer"
    ],
    "signerons": [
        "signer"
    ],
    "signeront": [
        "signer"
    ],
    "signes": [
        "signe",
        "signer"
    ],
    "signet": [
        "signet"
    ],
    "signets": [
        "signet"
    ],
    "signez": [
        "signer"
    ],
    "signiez": [
        "signer"
    ],
    "signifia": [
        "signifier"
    ],
    "signifiaient": [
        "signifier"
    ],
    "signifiais": [
        "signifier"
    ],
    "signifiait": [
        "signifier"
    ],
    "signifiance": [
        "signifiance"
    ],
    "signifiant": [
        "signifier",
        "signifiant"
    ],
    "signifiante": [
        "signifiant"
    ],
    "signifiantes": [
        "signifiant"
    ],
    "signifiants": [
        "signifiant"
    ],
    "significatif": [
        "significatif"
    ],
    "significatifs": [
        "significatif"
    ],
    "signification": [
        "signification"
    ],
    "significations": [
        "signification"
    ],
    "significative": [
        "significatif"
    ],
    "significativement": [
        "significativement"
    ],
    "significatives": [
        "significatif"
    ],
    "signifie": [
        "signifie",
        "signifier"
    ],
    "signifient": [
        "signifier"
    ],
    "signifier": [
        "signifier"
    ],
    "signifiera": [
        "signifier"
    ],
    "signifierai": [
        "signifier"
    ],
    "signifierait": [
        "signifier"
    ],
    "signifiat": [
        "signifier"
    ],
    "signifierent": [
        "signifier"
    ],
    "signifiee": [
        "signifier"
    ],
    "signifiees": [
        "signifier"
    ],
    "signons": [
        "signer"
    ],
    "signor": [
        "signor"
    ],
    "signora": [
        "signor"
    ],
    "signorina": [
        "signorina"
    ],
    "signames": [
        "signer"
    ],
    "signat": [
        "signer"
    ],
    "signerent": [
        "signer"
    ],
    "signee": [
        "signe",
        "signer"
    ],
    "signees": [
        "signe",
        "signer"
    ],
    "sikh": [
        "sikh"
    ],
    "sikhs": [
        "sikh"
    ],
    "sil": [
        "sil"
    ],
    "silence": [
        "silence"
    ],
    "silences": [
        "silence"
    ],
    "silencieuse": [
        "silencieux"
    ],
    "silencieusement": [
        "silencieusement"
    ],
    "silencieuses": [
        "silencieux"
    ],
    "silencieux": [
        "silencieux"
    ],
    "silex": [
        "silex"
    ],
    "silhouettait": [
        "silhouetter"
    ],
    "silhouettant": [
        "silhouetter"
    ],
    "silhouette": [
        "silhouetter",
        "silhouette"
    ],
    "silhouettent": [
        "silhouetter"
    ],
    "silhouetter": [
        "silhouetter"
    ],
    "silhouettes": [
        "silhouette"
    ],
    "silhouettee": [
        "silhouetter"
    ],
    "silicate": [
        "silicate"
    ],
    "silice": [
        "silice"
    ],
    "silices": [
        "silice"
    ],
    "siliceuse": [
        "siliceux"
    ],
    "siliceux": [
        "siliceux"
    ],
    "silicium": [
        "silicium"
    ],
    "silicone": [
        "siliconer",
        "silicone"
    ],
    "siliconer": [
        "siliconer"
    ],
    "siliconee": [
        "siliconer"
    ],
    "siliconees": [
        "siliconer"
    ],
    "silicose": [
        "silicose"
    ],
    "silicosee": [
        "silicose"
    ],
    "silionne": [
        "silionne"
    ],
    "sillage": [
        "sillage"
    ],
    "sillages": [
        "sillage"
    ],
    "sillet": [
        "sillet"
    ],
    "sillon": [
        "sillon"
    ],
    "sillonna": [
        "sillonner"
    ],
    "sillonnaient": [
        "sillonner"
    ],
    "sillonnais": [
        "sillonner"
    ],
    "sillonnait": [
        "sillonner"
    ],
    "sillonnant": [
        "sillonner"
    ],
    "sillonne": [
        "sillonner"
    ],
    "sillonnent": [
        "sillonner"
    ],
    "sillonner": [
        "sillonner"
    ],
    "sillonnes": [
        "sillonner"
    ],
    "sillonnez": [
        "sillonner"
    ],
    "sillonnons": [
        "sillonner"
    ],
    "sillonnerent": [
        "sillonner"
    ],
    "sillonnee": [
        "sillonne",
        "sillonner"
    ],
    "sillonnees": [
        "sillonner"
    ],
    "sillons": [
        "sillon",
        "siller"
    ],
    "silo": [
        "silo"
    ],
    "silos": [
        "silo"
    ],
    "sils": [
        "sil"
    ],
    "silvaner": [
        "silvaner"
    ],
    "silene": [
        "silene"
    ],
    "silenes": [
        "silene"
    ],
    "silesien": [
        "silesien"
    ],
    "sima": [
        "sima"
    ],
    "simagree": [
        "simagree"
    ],
    "simagrees": [
        "simagree"
    ],
    "simarre": [
        "simarre"
    ],
    "simien": [
        "simien"
    ],
    "simienne": [
        "simien"
    ],
    "simiens": [
        "simien"
    ],
    "simiesque": [
        "simiesque"
    ],
    "simiesques": [
        "simiesque"
    ],
    "similaire": [
        "similaire"
    ],
    "similairement": [
        "similairement"
    ],
    "similaires": [
        "similaire"
    ],
    "similarite": [
        "similarite"
    ],
    "similarites": [
        "similarite"
    ],
    "simili": [
        "simili"
    ],
    "similicuir": [
        "similicuir"
    ],
    "similitude": [
        "similitude"
    ],
    "similitudes": [
        "similitude"
    ],
    "similor": [
        "similor"
    ],
    "similors": [
        "similor"
    ],
    "simoniaque": [
        "simoniaque"
    ],
    "simoun": [
        "simoun"
    ],
    "simple": [
        "simple"
    ],
    "simplement": [
        "simplement"
    ],
    "simples": [
        "simple"
    ],
    "simplesse": [
        "simplesse"
    ],
    "simplet": [
        "simplet"
    ],
    "simplets": [
        "simplet"
    ],
    "simplette": [
        "simplet",
        "simplette"
    ],
    "simplettes": [
        "simplet"
    ],
    "simplicite": [
        "simplicite"
    ],
    "simplifiaient": [
        "simplifier"
    ],
    "simplifiais": [
        "simplifier"
    ],
    "simplifiait": [
        "simplifier"
    ],
    "simplifiant": [
        "simplifier"
    ],
    "simplification": [
        "simplification"
    ],
    "simplifications": [
        "simplification"
    ],
    "simplifie": [
        "simplifier"
    ],
    "simplifient": [
        "simplifier"
    ],
    "simplifier": [
        "simplifier"
    ],
    "simplifiera": [
        "simplifier"
    ],
    "simplifierait": [
        "simplifier"
    ],
    "simplifiez": [
        "simplifier"
    ],
    "simplifions": [
        "simplifier"
    ],
    "simplifiee": [
        "simplifier"
    ],
    "simplifiees": [
        "simplifier"
    ],
    "simplifies": [
        "simplifier",
        "simplify"
    ],
    "simplissime": [
        "simplissime"
    ],
    "simpliste": [
        "simpliste"
    ],
    "simplistes": [
        "simpliste"
    ],
    "simula": [
        "simuler"
    ],
    "simulacre": [
        "simulacre"
    ],
    "simulacres": [
        "simulacre"
    ],
    "simulaient": [
        "simuler"
    ],
    "simulais": [
        "simuler"
    ],
    "simulait": [
        "simuler"
    ],
    "simulant": [
        "simuler"
    ],
    "simulateur": [
        "simulateur"
    ],
    "simulateurs": [
        "simulateur"
    ],
    "simulation": [
        "simulation"
    ],
    "simulations": [
        "simulation"
    ],
    "simulatrice": [
        "simulateur"
    ],
    "simule": [
        "simuler",
        "simule"
    ],
    "simulent": [
        "simuler"
    ],
    "simuler": [
        "simuler"
    ],
    "simulera": [
        "simuler"
    ],
    "simulerai": [
        "simuler"
    ],
    "simulerez": [
        "simuler"
    ],
    "simules": [
        "simuler",
        "simule"
    ],
    "simulez": [
        "simuler"
    ],
    "simuliez": [
        "simuler"
    ],
    "simulons": [
        "simuler"
    ],
    "simultane": [
        "simultane"
    ],
    "simultanee": [
        "simultane"
    ],
    "simultanees": [
        "simultane"
    ],
    "simultaneite": [
        "simultaneite"
    ],
    "simultanement": [
        "simultanement"
    ],
    "simultanes": [
        "simultane"
    ],
    "simulerent": [
        "simuler"
    ],
    "simulee": [
        "simuler",
        "simule"
    ],
    "simulees": [
        "simuler",
        "simule"
    ],
    "sinapisme": [
        "sinapisme"
    ],
    "sinapismes": [
        "sinapisme"
    ],
    "sinciput": [
        "sinciput"
    ],
    "sincere": [
        "sincere"
    ],
    "sincerement": [
        "sincerement"
    ],
    "sinceres": [
        "sincere"
    ],
    "sincerite": [
        "sincerite"
    ],
    "sindon": [
        "sindon"
    ],
    "singe": [
        "singer",
        "singe"
    ],
    "singea": [
        "singer"
    ],
    "singeaient": [
        "singer"
    ],
    "singeait": [
        "singer"
    ],
    "singeant": [
        "singer"
    ],
    "singent": [
        "singer"
    ],
    "singer": [
        "singer"
    ],
    "singerie": [
        "singerie"
    ],
    "singeries": [
        "singerie"
    ],
    "singes": [
        "singer",
        "singe",
        "singes"
    ],
    "singiez": [
        "singer"
    ],
    "single": [
        "single"
    ],
    "singles": [
        "single"
    ],
    "singleton": [
        "singleton"
    ],
    "singularisait": [
        "singulariser"
    ],
    "singularise": [
        "singulariser"
    ],
    "singulariser": [
        "singulariser"
    ],
    "singularises": [
        "singulariser"
    ],
    "singularite": [
        "singularite"
    ],
    "singularites": [
        "singularite"
    ],
    "singulier": [
        "singulier"
    ],
    "singuliers": [
        "singulier"
    ],
    "singuliere": [
        "singulier"
    ],
    "singulierement": [
        "singulierement"
    ],
    "singulieres": [
        "singulier"
    ],
    "singees": [
        "singer"
    ],
    "sinistre": [
        "sinistre"
    ],
    "sinistrement": [
        "sinistrement"
    ],
    "sinistres": [
        "sinistre"
    ],
    "sinistrose": [
        "sinistrose"
    ],
    "sinistree": [
        "sinistre"
    ],
    "sinistrees": [
        "sinistre"
    ],
    "sino": [
        "sino"
    ],
    "sinologie": [
        "sinologie"
    ],
    "sinon": [
        "sinon"
    ],
    "sinople": [
        "sinople"
    ],
    "sinoque": [
        "sinoque"
    ],
    "sinoques": [
        "sinoque"
    ],
    "sinoquet": [
        "sinoquet"
    ],
    "sinuaient": [
        "sinuer"
    ],
    "sinuait": [
        "sinuer"
    ],
    "sinuant": [
        "sinuer"
    ],
    "sinue": [
        "sinuer"
    ],
    "sinuent": [
        "sinuer"
    ],
    "sinuer": [
        "sinuer"
    ],
    "sinueuse": [
        "sinueux"
    ],
    "sinueusement": [
        "sinueusement"
    ],
    "sinueuses": [
        "sinueux"
    ],
    "sinueux": [
        "sinueux"
    ],
    "sinuosite": [
        "sinuosite"
    ],
    "sinuosites": [
        "sinuosite"
    ],
    "sinus": [
        "sinus"
    ],
    "sinusal": [
        "sinusal"
    ],
    "sinusale": [
        "sinusal"
    ],
    "sinusite": [
        "sinusite"
    ],
    "sinusites": [
        "sinusite"
    ],
    "sinusoidal": [
        "sinusoidal"
    ],
    "sinusoidale": [
        "sinusoidal"
    ],
    "sinusoidaux": [
        "sinusoidal"
    ],
    "sinusoides": [
        "sinusoide"
    ],
    "sinecure": [
        "sinecure"
    ],
    "sinecures": [
        "sinecure"
    ],
    "sionisme": [
        "sionisme"
    ],
    "sioniste": [
        "sioniste"
    ],
    "sionistes": [
        "sioniste"
    ],
    "sioux": [
        "sioux"
    ],
    "siphon": [
        "siphon"
    ],
    "siphonnage": [
        "siphonnage"
    ],
    "siphonnait": [
        "siphonner"
    ],
    "siphonne": [
        "siphonne",
        "siphonner"
    ],
    "siphonner": [
        "siphonner"
    ],
    "siphonnee": [
        "siphonne",
        "siphonner"
    ],
    "siphonnes": [
        "siphonne",
        "siphonner"
    ],
    "siphons": [
        "siphon"
    ],
    "sipo": [
        "sipo"
    ],
    "sir": [
        "sir"
    ],
    "sirdar": [
        "sirdar"
    ],
    "sire": [
        "sire"
    ],
    "sires": [
        "sire"
    ],
    "sirocco": [
        "sirocco"
    ],
    "sirop": [
        "sirop"
    ],
    "sirops": [
        "sirop"
    ],
    "sirota": [
        "siroter"
    ],
    "sirotaient": [
        "siroter"
    ],
    "sirotais": [
        "siroter"
    ],
    "sirotait": [
        "siroter"
    ],
    "sirotant": [
        "siroter"
    ],
    "sirote": [
        "siroter"
    ],
    "sirotent": [
        "siroter"
    ],
    "siroter": [
        "siroter"
    ],
    "siroterais": [
        "siroter"
    ],
    "sirotiez": [
        "siroter"
    ],
    "sirotions": [
        "siroter"
    ],
    "sirupeuse": [
        "sirupeux"
    ],
    "sirupeuses": [
        "sirupeux"
    ],
    "sirupeux": [
        "sirupeux"
    ],
    "sirventes": [
        "sirventes"
    ],
    "sirene": [
        "sirene"
    ],
    "sirenes": [
        "sirene"
    ],
    "sis": [
        "sis"
    ],
    "sisal": [
        "sisal"
    ],
    "sise": [
        "sis"
    ],
    "sises": [
        "sis"
    ],
    "sismique": [
        "sismique"
    ],
    "sismiques": [
        "sismique"
    ],
    "sismographe": [
        "sismographe"
    ],
    "sismographes": [
        "sismographe"
    ],
    "sismologie": [
        "sismologie"
    ],
    "sismologique": [
        "sismologique"
    ],
    "sismologue": [
        "sismologue"
    ],
    "sismologues": [
        "sismologue"
    ],
    "sismometre": [
        "sismometre"
    ],
    "sismotherapie": [
        "sismotherapie"
    ],
    "sisymbre": [
        "sisymbre"
    ],
    "sitar": [
        "sitar"
    ],
    "sitariste": [
        "sitariste"
    ],
    "sitcom": [
        "sitcom"
    ],
    "sitcoms": [
        "sitcom"
    ],
    "site": [
        "site"
    ],
    "sites": [
        "site"
    ],
    "sittelle": [
        "sittelle"
    ],
    "situ": [
        "situ"
    ],
    "situa": [
        "situer"
    ],
    "situable": [
        "situable"
    ],
    "situaient": [
        "situer"
    ],
    "situais": [
        "situer"
    ],
    "situait": [
        "situer"
    ],
    "situant": [
        "situer"
    ],
    "situasse": [
        "situer"
    ],
    "situation": [
        "situation"
    ],
    "situationnel": [
        "situationnel"
    ],
    "situationnisme": [
        "situationnisme"
    ],
    "situationnistes": [
        "situationniste"
    ],
    "situations": [
        "situation"
    ],
    "situe": [
        "situe",
        "situer"
    ],
    "situent": [
        "situer"
    ],
    "situer": [
        "situer"
    ],
    "situera": [
        "situer"
    ],
    "situerai": [
        "situer"
    ],
    "situeraient": [
        "situer"
    ],
    "situerais": [
        "situer"
    ],
    "situerait": [
        "situer"
    ],
    "situes": [
        "situe",
        "situer"
    ],
    "situez": [
        "situer"
    ],
    "situions": [
        "situer"
    ],
    "situons": [
        "situer"
    ],
    "situat": [
        "situer"
    ],
    "situerent": [
        "situer"
    ],
    "situee": [
        "situe",
        "situer"
    ],
    "situees": [
        "situe",
        "situer"
    ],
    "sitot": [
        "sitot"
    ],
    "six": [
        "six"
    ],
    "sixain": [
        "sixain"
    ],
    "sixieme": [
        "sixieme"
    ],
    "sixiemement": [
        "sixiemement"
    ],
    "sixiemes": [
        "sixieme"
    ],
    "sixte": [
        "sixte"
    ],
    "sixties": [
        "sixties"
    ],
    "sixtus": [
        "sixtus"
    ],
    "sizain": [
        "sizain"
    ],
    "siecle": [
        "siecle"
    ],
    "siecles": [
        "siecle"
    ],
    "siege": [
        "sieger",
        "siege"
    ],
    "siegent": [
        "sieger"
    ],
    "sieges": [
        "sieger",
        "siege"
    ],
    "sieent": [
        "seoir"
    ],
    "siegeaient": [
        "sieger"
    ],
    "siegeais": [
        "sieger"
    ],
    "siegeait": [
        "sieger"
    ],
    "siegeant": [
        "sieger"
    ],
    "siegeons": [
        "sieger"
    ],
    "sieger": [
        "sieger"
    ],
    "siegera": [
        "sieger"
    ],
    "siegerai": [
        "sieger"
    ],
    "siegeraient": [
        "sieger"
    ],
    "siegerait": [
        "sieger"
    ],
    "siegeras": [
        "sieger"
    ],
    "siegerons": [
        "sieger"
    ],
    "siegeront": [
        "sieger"
    ],
    "siegez": [
        "sieger"
    ],
    "siegiez": [
        "sieger"
    ],
    "siegions": [
        "sieger"
    ],
    "siera": [
        "seoir"
    ],
    "sierait": [
        "seoir"
    ],
    "ska": [
        "ska"
    ],
    "skaal": [
        "skaal"
    ],
    "skate": [
        "skate"
    ],
    "skateboard": [
        "skateboard"
    ],
    "skateboards": [
        "skateboard"
    ],
    "skates": [
        "skate"
    ],
    "skating": [
        "skate",
        "skating"
    ],
    "skai": [
        "skai"
    ],
    "skeet": [
        "skeet"
    ],
    "skeets": [
        "skeet"
    ],
    "sketch": [
        "sketch"
    ],
    "sketches": [
        "sketch"
    ],
    "sketchs": [
        "sketch"
    ],
    "ski": [
        "ski"
    ],
    "skiable": [
        "skiable"
    ],
    "skiais": [
        "skier"
    ],
    "skiait": [
        "skier"
    ],
    "skiant": [
        "skier"
    ],
    "skie": [
        "skier"
    ],
    "skient": [
        "skier"
    ],
    "skier": [
        "skier"
    ],
    "skierai": [
        "skier"
    ],
    "skierait": [
        "skier"
    ],
    "skies": [
        "skier",
        "sky"
    ],
    "skieur": [
        "skieur"
    ],
    "skieurs": [
        "skieur"
    ],
    "skieuse": [
        "skieur"
    ],
    "skieuses": [
        "skieur"
    ],
    "skiez": [
        "skier"
    ],
    "skiff": [
        "skiff"
    ],
    "skiffs": [
        "skiff"
    ],
    "skin": [
        "skin"
    ],
    "skinhead": [
        "skinhead"
    ],
    "skinheads": [
        "skinhead"
    ],
    "skins": [
        "skin"
    ],
    "skip": [
        "skip"
    ],
    "skipper": [
        "skipper"
    ],
    "skis": [
        "ski"
    ],
    "skunks": [
        "skunks"
    ],
    "skydome": [
        "skydome"
    ],
    "slalom": [
        "slalom"
    ],
    "slalomant": [
        "slalomer"
    ],
    "slalomer": [
        "slalomer"
    ],
    "slaloms": [
        "slalom"
    ],
    "slalome": [
        "slalomer"
    ],
    "slang": [
        "slang"
    ],
    "slash": [
        "slash"
    ],
    "slave": [
        "slave"
    ],
    "slaves": [
        "slave"
    ],
    "slavisant": [
        "slaviser"
    ],
    "slavisme": [
        "slavisme"
    ],
    "slavon": [
        "slavon"
    ],
    "slavophiles": [
        "slavophile"
    ],
    "sleeping": [
        "sleeping",
        "sleep"
    ],
    "sleepings": [
        "sleeping"
    ],
    "slibard": [
        "slibard"
    ],
    "slice": [
        "slice"
    ],
    "slip": [
        "slip"
    ],
    "slips": [
        "slip"
    ],
    "slogan": [
        "slogan"
    ],
    "slogans": [
        "slogan"
    ],
    "sloop": [
        "sloop"
    ],
    "sloughi": [
        "sloughi"
    ],
    "slovaque": [
        "slovaque"
    ],
    "slovaques": [
        "slovaque"
    ],
    "slovene": [
        "slovene"
    ],
    "slow": [
        "slow"
    ],
    "slows": [
        "slow"
    ],
    "slug": [
        "slug"
    ],
    "slush": [
        "slush"
    ],
    "smack": [
        "smack"
    ],
    "smacks": [
        "smack"
    ],
    "smala": [
        "smala"
    ],
    "smalah": [
        "smalah"
    ],
    "smaragdin": [
        "smaragdin"
    ],
    "smart": [
        "smart"
    ],
    "smash": [
        "smash"
    ],
    "smashe": [
        "smasher"
    ],
    "smasher": [
        "smasher"
    ],
    "smegma": [
        "smegma"
    ],
    "smicard": [
        "smicard"
    ],
    "smicards": [
        "smicard"
    ],
    "smigard": [
        "smigard"
    ],
    "smiley": [
        "smiley"
    ],
    "smocks": [
        "smocks",
        "smock"
    ],
    "smog": [
        "smog"
    ],
    "smoking": [
        "smoking",
        "smoke"
    ],
    "smokings": [
        "smoking"
    ],
    "smorrebrod": [
        "smorrebrod"
    ],
    "smurf": [
        "smurf"
    ],
    "smyrniote": [
        "smyrniote"
    ],
    "snack": [
        "snack"
    ],
    "snacks": [
        "snack"
    ],
    "snif": [
        "snif"
    ],
    "snifer": [
        "snifer"
    ],
    "sniff": [
        "sniff"
    ],
    "sniffaient": [
        "sniffer"
    ],
    "sniffais": [
        "sniffer"
    ],
    "sniffait": [
        "sniffer"
    ],
    "sniffant": [
        "sniffer"
    ],
    "sniffe": [
        "sniffer"
    ],
    "sniffent": [
        "sniffer"
    ],
    "sniffer": [
        "sniffer"
    ],
    "snifferai": [
        "sniffer"
    ],
    "sniffes": [
        "sniffer"
    ],
    "sniffette": [
        "sniffette"
    ],
    "sniffez": [
        "sniffer"
    ],
    "sniffee": [
        "sniffer"
    ],
    "sniffees": [
        "sniffer"
    ],
    "snipe": [
        "snipe"
    ],
    "sniper": [
        "sniper"
    ],
    "snipers": [
        "sniper"
    ],
    "snob": [
        "snob"
    ],
    "snobaient": [
        "snober"
    ],
    "snobais": [
        "snober"
    ],
    "snobe": [
        "snober"
    ],
    "snobent": [
        "snober"
    ],
    "snober": [
        "snober"
    ],
    "snoberez": [
        "snober"
    ],
    "snobez": [
        "snober"
    ],
    "snobinard": [
        "snobinard"
    ],
    "snobinarde": [
        "snobinard"
    ],
    "snobinardes": [
        "snobinard"
    ],
    "snobinards": [
        "snobinard"
    ],
    "snobisme": [
        "snobisme"
    ],
    "snobismes": [
        "snobisme"
    ],
    "snobs": [
        "snob"
    ],
    "snobee": [
        "snober"
    ],
    "snobes": [
        "snober"
    ],
    "sobre": [
        "sobre"
    ],
    "sobrement": [
        "sobrement"
    ],
    "sobres": [
        "sobre"
    ],
    "sobriquet": [
        "sobriquet"
    ],
    "sobriquets": [
        "sobriquet"
    ],
    "sobriete": [
        "sobriete"
    ],
    "soc": [
        "soc"
    ],
    "soccer": [
        "soccer"
    ],
    "sociabiliser": [
        "sociabiliser"
    ],
    "sociabilite": [
        "sociabilite"
    ],
    "sociable": [
        "sociable"
    ],
    "sociables": [
        "sociable"
    ],
    "social": [
        "social"
    ],
    "sociale": [
        "social"
    ],
    "socialement": [
        "socialement"
    ],
    "sociales": [
        "social"
    ],
    "socialisation": [
        "socialisation"
    ],
    "socialise": [
        "socialiser"
    ],
    "socialiser": [
        "socialiser"
    ],
    "socialisez": [
        "socialiser"
    ],
    "socialisme": [
        "socialisme"
    ],
    "socialismes": [
        "socialisme"
    ],
    "socialiste": [
        "socialiste"
    ],
    "socialistes": [
        "socialiste"
    ],
    "socialo": [
        "socialo"
    ],
    "socialos": [
        "socialo"
    ],
    "sociaux": [
        "social"
    ],
    "sociniens": [
        "socinien"
    ],
    "socio": [
        "socio"
    ],
    "sociobiologie": [
        "sociobiologie"
    ],
    "socioculturel": [
        "socioculturel"
    ],
    "socioculturelles": [
        "socioculturel"
    ],
    "sociologie": [
        "sociologie"
    ],
    "sociologique": [
        "sociologique"
    ],
    "sociologiquement": [
        "sociologiquement"
    ],
    "sociologiques": [
        "sociologique"
    ],
    "sociologue": [
        "sociologue"
    ],
    "sociologues": [
        "sociologue"
    ],
    "sociopathe": [
        "sociopathe"
    ],
    "sociopathes": [
        "sociopathe"
    ],
    "sociopathie": [
        "sociopathie"
    ],
    "sociopolitique": [
        "sociopolitique"
    ],
    "socius": [
        "socius"
    ],
    "societaire": [
        "societaire"
    ],
    "societaires": [
        "societaire"
    ],
    "societal": [
        "societal"
    ],
    "societale": [
        "societal"
    ],
    "societe": [
        "societe"
    ],
    "societes": [
        "societe"
    ],
    "socket": [
        "socket"
    ],
    "socle": [
        "socle"
    ],
    "socles": [
        "socle"
    ],
    "socque": [
        "socque"
    ],
    "socques": [
        "socque"
    ],
    "socquette": [
        "socquette"
    ],
    "socquettes": [
        "socquette"
    ],
    "socratique": [
        "socratique"
    ],
    "socratiques": [
        "socratique"
    ],
    "socs": [
        "soc"
    ],
    "soda": [
        "soda"
    ],
    "sodas": [
        "soda"
    ],
    "sodique": [
        "sodique"
    ],
    "sodium": [
        "sodium"
    ],
    "sodomie": [
        "sodomie"
    ],
    "sodomisa": [
        "sodomiser"
    ],
    "sodomisait": [
        "sodomiser"
    ],
    "sodomisant": [
        "sodomiser"
    ],
    "sodomisation": [
        "sodomisation"
    ],
    "sodomise": [
        "sodomiser"
    ],
    "sodomiser": [
        "sodomiser"
    ],
    "sodomiseront": [
        "sodomiser"
    ],
    "sodomisez": [
        "sodomiser"
    ],
    "sodomisee": [
        "sodomiser"
    ],
    "sodomises": [
        "sodomiser"
    ],
    "sodomite": [
        "sodomite"
    ],
    "sodomites": [
        "sodomite"
    ],
    "sodomitiques": [
        "sodomitique"
    ],
    "soeur": [
        "soeur"
    ],
    "soeurette": [
        "soeurette"
    ],
    "soeurs": [
        "soeur"
    ],
    "sofa": [
        "sofa"
    ],
    "sofas": [
        "sofa"
    ],
    "soft": [
        "soft"
    ],
    "softball": [
        "softball"
    ],
    "soi": [
        "soi"
    ],
    "soie": [
        "soie"
    ],
    "soient": [
        "etre"
    ],
    "soierie": [
        "soierie"
    ],
    "soieries": [
        "soierie"
    ],
    "soies": [
        "soie"
    ],
    "soif": [
        "soif"
    ],
    "soiffard": [
        "soiffard"
    ],
    "soiffarde": [
        "soiffard"
    ],
    "soiffards": [
        "soiffard"
    ],
    "soifs": [
        "soif"
    ],
    "soigna": [
        "soigner"
    ],
    "soignable": [
        "soignable"
    ],
    "soignai": [
        "soigner"
    ],
    "soignaient": [
        "soigner"
    ],
    "soignais": [
        "soigner"
    ],
    "soignait": [
        "soigner"
    ],
    "soignant": [
        "soignant",
        "soigner"
    ],
    "soignante": [
        "soignant"
    ],
    "soignantes": [
        "soignant"
    ],
    "soignants": [
        "soignant"
    ],
    "soigne": [
        "soigne",
        "soigner"
    ],
    "soignent": [
        "soigner"
    ],
    "soigner": [
        "saler",
        "soigner"
    ],
    "soignera": [
        "soigner"
    ],
    "soignerai": [
        "soigner"
    ],
    "soigneraient": [
        "soigner"
    ],
    "soignerais": [
        "soigner"
    ],
    "soignerait": [
        "soigner"
    ],
    "soigneras": [
        "soigner"
    ],
    "soignerez": [
        "soigner"
    ],
    "soignerons": [
        "soigner"
    ],
    "soigneront": [
        "soigner"
    ],
    "soignes": [
        "soigne",
        "soigner"
    ],
    "soigneur": [
        "soigneur"
    ],
    "soigneurs": [
        "soigneur"
    ],
    "soigneuse": [
        "soigneux"
    ],
    "soigneusement": [
        "soigneusement"
    ],
    "soigneuses": [
        "soigneux"
    ],
    "soigneux": [
        "soigneux"
    ],
    "soignez": [
        "soigner"
    ],
    "soigniez": [
        "soigner"
    ],
    "soignons": [
        "soigner"
    ],
    "soignerent": [
        "soigner"
    ],
    "soignee": [
        "soigne",
        "soigner"
    ],
    "soignees": [
        "soigne",
        "soigner"
    ],
    "soin": [
        "soin"
    ],
    "soins": [
        "soin"
    ],
    "soir": [
        "soir"
    ],
    "soirs": [
        "soir"
    ],
    "soiree": [
        "soiree"
    ],
    "soirees": [
        "soiree"
    ],
    "sois": [
        "etre"
    ],
    "soissonnais": [
        "soissonnais"
    ],
    "soit": [
        "soit",
        "etre"
    ],
    "soixantaine": [
        "soixantaine"
    ],
    "soixante": [
        "soixante"
    ],
    "soixantieme": [
        "soixantieme"
    ],
    "soja": [
        "soja"
    ],
    "sol": [
        "sol"
    ],
    "solaire": [
        "solaire"
    ],
    "solaires": [
        "solaire"
    ],
    "solanacee": [
        "solanacee"
    ],
    "solanacees": [
        "solanacee"
    ],
    "solarium": [
        "solarium"
    ],
    "solariums": [
        "solarium"
    ],
    "solda": [
        "solder"
    ],
    "soldaient": [
        "solder"
    ],
    "soldait": [
        "solder"
    ],
    "soldat": [
        "solder",
        "soldat"
    ],
    "soldate": [
        "soldat"
    ],
    "soldatesque": [
        "soldatesque"
    ],
    "soldats": [
        "soldat"
    ],
    "solde": [
        "solder",
        "solde"
    ],
    "soldent": [
        "solder"
    ],
    "solder": [
        "solder"
    ],
    "soldera": [
        "solder"
    ],
    "solderais": [
        "solder"
    ],
    "solderait": [
        "solder"
    ],
    "solderie": [
        "solderie"
    ],
    "soldes": [
        "solder",
        "solde"
    ],
    "soldeur": [
        "soldeur"
    ],
    "soldeurs": [
        "soldeur"
    ],
    "soldez": [
        "solder"
    ],
    "solderent": [
        "solder"
    ],
    "soldee": [
        "solder"
    ],
    "soldees": [
        "solder"
    ],
    "sole": [
        "sole"
    ],
    "soleil": [
        "soleil"
    ],
    "soleilleux": [
        "soleilleux"
    ],
    "soleils": [
        "soleil"
    ],
    "solen": [
        "solen"
    ],
    "solennel": [
        "solennel"
    ],
    "solennelle": [
        "solennel"
    ],
    "solennellement": [
        "solennellement"
    ],
    "solennelles": [
        "solennel"
    ],
    "solennels": [
        "solennel"
    ],
    "solenniser": [
        "solenniser"
    ],
    "solenniserent": [
        "solenniser"
    ],
    "solennite": [
        "solennite"
    ],
    "solennites": [
        "solennite"
    ],
    "soles": [
        "sole"
    ],
    "solex": [
        "solex"
    ],
    "solfatares": [
        "solfatare"
    ],
    "solfege": [
        "solfege"
    ],
    "soli": [
        "solo"
    ],
    "solicitor": [
        "solicitor"
    ],
    "solicitors": [
        "solicitor"
    ],
    "solidaire": [
        "solidaire"
    ],
    "solidairement": [
        "solidairement"
    ],
    "solidaires": [
        "solidaire"
    ],
    "solidariser": [
        "solidariser"
    ],
    "solidarisez": [
        "solidariser"
    ],
    "solidarite": [
        "solidarite"
    ],
    "solidarites": [
        "solidarite"
    ],
    "solide": [
        "solide"
    ],
    "solidement": [
        "solidement"
    ],
    "solides": [
        "solide"
    ],
    "solidifia": [
        "solidifier"
    ],
    "solidifiait": [
        "solidifier"
    ],
    "solidification": [
        "solidification"
    ],
    "solidifie": [
        "solidifier"
    ],
    "solidifient": [
        "solidifier"
    ],
    "solidifier": [
        "solidifier"
    ],
    "solidifiee": [
        "solidifier"
    ],
    "solidifiees": [
        "solidifier"
    ],
    "solidifies": [
        "solidify",
        "solidifier"
    ],
    "solidite": [
        "solidite"
    ],
    "solidus": [
        "solidus"
    ],
    "soliflore": [
        "soliflore"
    ],
    "soliloqua": [
        "soliloquer"
    ],
    "soliloquait": [
        "soliloquer"
    ],
    "soliloque": [
        "soliloque",
        "soliloquer"
    ],
    "soliloquer": [
        "soliloquer"
    ],
    "soliloques": [
        "soliloque"
    ],
    "solipsisme": [
        "solipsisme"
    ],
    "solipsiste": [
        "solipsiste"
    ],
    "soliste": [
        "soliste"
    ],
    "solistes": [
        "soliste"
    ],
    "solitaire": [
        "solitaire"
    ],
    "solitairement": [
        "solitairement"
    ],
    "solitaires": [
        "solitaire"
    ],
    "solitude": [
        "solitude"
    ],
    "solitudes": [
        "solitude"
    ],
    "solive": [
        "solive"
    ],
    "soliveau": [
        "soliveau"
    ],
    "solives": [
        "solive"
    ],
    "sollicita": [
        "solliciter"
    ],
    "sollicitai": [
        "solliciter"
    ],
    "sollicitaient": [
        "solliciter"
    ],
    "sollicitais": [
        "solliciter"
    ],
    "sollicitait": [
        "solliciter"
    ],
    "sollicitant": [
        "solliciter"
    ],
    "sollicitation": [
        "sollicitation"
    ],
    "sollicitations": [
        "sollicitation"
    ],
    "sollicite": [
        "solliciter"
    ],
    "sollicitent": [
        "solliciter"
    ],
    "solliciter": [
        "solliciter"
    ],
    "sollicitera": [
        "solliciter"
    ],
    "solliciteraient": [
        "solliciter"
    ],
    "solliciteur": [
        "solliciteur"
    ],
    "solliciteurs": [
        "solliciteur"
    ],
    "solliciteuse": [
        "solliciteur"
    ],
    "sollicitez": [
        "solliciter"
    ],
    "sollicitons": [
        "solliciter"
    ],
    "sollicitude": [
        "sollicitude"
    ],
    "sollicitudes": [
        "sollicitude"
    ],
    "sollicitat": [
        "solliciter"
    ],
    "solliciterent": [
        "solliciter"
    ],
    "sollicitee": [
        "solliciter"
    ],
    "sollicitees": [
        "solliciter"
    ],
    "sollicites": [
        "solliciter"
    ],
    "solo": [
        "solo"
    ],
    "solognot": [
        "solognot"
    ],
    "solognote": [
        "solognot"
    ],
    "solognots": [
        "solognot"
    ],
    "solos": [
        "solo"
    ],
    "sols": [
        "sol"
    ],
    "solstice": [
        "solstice"
    ],
    "solstices": [
        "solstice"
    ],
    "solubilite": [
        "solubilite"
    ],
    "soluble": [
        "soluble"
    ],
    "solubles": [
        "soluble"
    ],
    "solucamphre": [
        "solucamphre"
    ],
    "solution": [
        "solution"
    ],
    "solutionnait": [
        "solutionner"
    ],
    "solutionner": [
        "solutionner"
    ],
    "solutionneur": [
        "solutionneur"
    ],
    "solutionnons": [
        "solutionner"
    ],
    "solutions": [
        "solution"
    ],
    "solute": [
        "solute"
    ],
    "solutes": [
        "solute"
    ],
    "solvabilite": [
        "solvabilite"
    ],
    "solvable": [
        "solvable"
    ],
    "solvant": [
        "solvant"
    ],
    "solvants": [
        "solvant"
    ],
    "solecismes": [
        "solecisme"
    ],
    "solenoide": [
        "solenoide"
    ],
    "solenoides": [
        "solenoide"
    ],
    "soma": [
        "soma"
    ],
    "somalien": [
        "somalien"
    ],
    "somalienne": [
        "somalien"
    ],
    "somaliens": [
        "somalien"
    ],
    "somalis": [
        "somali"
    ],
    "somatique": [
        "somatique"
    ],
    "somatiques": [
        "somatique"
    ],
    "somatisant": [
        "somatiser"
    ],
    "somatise": [
        "somatiser"
    ],
    "somatiser": [
        "somatiser"
    ],
    "somatiserez": [
        "somatiser"
    ],
    "somatisee": [
        "somatiser"
    ],
    "sombra": [
        "sombrer"
    ],
    "sombrai": [
        "sombrer"
    ],
    "sombraient": [
        "sombrer"
    ],
    "sombrais": [
        "sombrer"
    ],
    "sombrait": [
        "sombrer"
    ],
    "sombrant": [
        "sombrer"
    ],
    "sombre": [
        "sombre",
        "sombrer"
    ],
    "sombrement": [
        "sombrement"
    ],
    "sombrent": [
        "sombrer"
    ],
    "sombrer": [
        "sombrer"
    ],
    "sombrera": [
        "sombrer"
    ],
    "sombreraient": [
        "sombrer"
    ],
    "sombrerais": [
        "sombrer"
    ],
    "sombrerait": [
        "sombrer"
    ],
    "sombrerez": [
        "sombrer"
    ],
    "sombrero": [
        "sombrero"
    ],
    "sombrerons": [
        "sombrer"
    ],
    "sombreros": [
        "sombrero"
    ],
    "sombres": [
        "sombre",
        "sombrer"
    ],
    "sombrez": [
        "sombrer"
    ],
    "sombrions": [
        "sombrer"
    ],
    "sombrons": [
        "sombrer"
    ],
    "sombrerent": [
        "sombrer"
    ],
    "sombree": [
        "sombrer"
    ],
    "sombrees": [
        "sombrer"
    ],
    "somma": [
        "sommer"
    ],
    "sommai": [
        "sommer"
    ],
    "sommaire": [
        "sommaire"
    ],
    "sommairement": [
        "sommairement"
    ],
    "sommaires": [
        "sommaire"
    ],
    "sommais": [
        "sommer"
    ],
    "sommait": [
        "sommer"
    ],
    "sommant": [
        "sommer"
    ],
    "sommation": [
        "sommation"
    ],
    "sommations": [
        "sommation"
    ],
    "somme": [
        "somme",
        "sommer"
    ],
    "sommeil": [
        "sommeil"
    ],
    "sommeilla": [
        "sommeiller"
    ],
    "sommeillaient": [
        "sommeiller"
    ],
    "sommeillais": [
        "sommeiller"
    ],
    "sommeillait": [
        "sommeiller"
    ],
    "sommeillant": [
        "sommeiller",
        "sommeillant"
    ],
    "sommeillante": [
        "sommeillant"
    ],
    "sommeillants": [
        "sommeillant"
    ],
    "sommeille": [
        "sommeiller"
    ],
    "sommeillent": [
        "sommeiller"
    ],
    "sommeiller": [
        "sommeiller"
    ],
    "sommeilleux": [
        "sommeilleux"
    ],
    "sommeillerent": [
        "sommeiller"
    ],
    "sommeils": [
        "sommeil"
    ],
    "sommelier": [
        "sommelier"
    ],
    "somment": [
        "sommer"
    ],
    "sommer": [
        "sommer"
    ],
    "sommes": [
        "somme",
        "etre",
        "sommer"
    ],
    "sommet": [
        "sommet"
    ],
    "sommets": [
        "sommet"
    ],
    "sommier": [
        "sommier"
    ],
    "sommiers": [
        "sommier"
    ],
    "sommiez": [
        "sommer"
    ],
    "sommitales": [
        "sommital"
    ],
    "sommite": [
        "sommite"
    ],
    "sommites": [
        "sommite"
    ],
    "sommons": [
        "sommer"
    ],
    "sommerent": [
        "sommer"
    ],
    "sommee": [
        "sommer"
    ],
    "somnambulant": [
        "somnambuler"
    ],
    "somnambule": [
        "somnambule"
    ],
    "somnambules": [
        "somnambule"
    ],
    "somnambulique": [
        "somnambulique"
    ],
    "somnambuliquement": [
        "somnambuliquement"
    ],
    "somnambuliques": [
        "somnambulique"
    ],
    "somnambulisme": [
        "somnambulisme"
    ],
    "somnifere": [
        "somnifere"
    ],
    "somniferes": [
        "somnifere"
    ],
    "somno": [
        "somno"
    ],
    "somnola": [
        "somnoler"
    ],
    "somnolai": [
        "somnoler"
    ],
    "somnolaient": [
        "somnoler"
    ],
    "somnolais": [
        "somnoler"
    ],
    "somnolait": [
        "somnoler"
    ],
    "somnolant": [
        "somnoler"
    ],
    "somnole": [
        "somnoler"
    ],
    "somnolence": [
        "somnolence"
    ],
    "somnolences": [
        "somnolence"
    ],
    "somnolent": [
        "somnolent",
        "somnoler"
    ],
    "somnolente": [
        "somnolent"
    ],
    "somnolentes": [
        "somnolent"
    ],
    "somnolents": [
        "somnolent"
    ],
    "somnoler": [
        "somnoler"
    ],
    "somnolerais": [
        "somnoler"
    ],
    "somnolez": [
        "somnoler"
    ],
    "somozistes": [
        "somoziste"
    ],
    "somptuaire": [
        "somptuaire"
    ],
    "somptuaires": [
        "somptuaire"
    ],
    "somptueuse": [
        "somptueux"
    ],
    "somptueusement": [
        "somptueusement"
    ],
    "somptueuses": [
        "somptueux"
    ],
    "somptueux": [
        "somptueux"
    ],
    "somptuosite": [
        "somptuosite"
    ],
    "somptuosites": [
        "somptuosite"
    ],
    "son": [
        "son"
    ],
    "sonagramme": [
        "sonagramme"
    ],
    "sonar": [
        "sonar"
    ],
    "sonars": [
        "sonar"
    ],
    "sonate": [
        "sonate"
    ],
    "sonates": [
        "sonate"
    ],
    "sonatine": [
        "sonatine"
    ],
    "sonda": [
        "sonder"
    ],
    "sondage": [
        "sondage"
    ],
    "sondages": [
        "sondage"
    ],
    "sondaient": [
        "sonder"
    ],
    "sondait": [
        "sonder"
    ],
    "sondant": [
        "sonder"
    ],
    "sondas": [
        "sonder"
    ],
    "sonde": [
        "sonde",
        "sonder"
    ],
    "sondent": [
        "sonder"
    ],
    "sonder": [
        "sonder"
    ],
    "sonderai": [
        "sonder"
    ],
    "sondes": [
        "sonde",
        "sonder"
    ],
    "sondeur": [
        "sondeur"
    ],
    "sondeurs": [
        "sondeur"
    ],
    "sondeuse": [
        "sondeur"
    ],
    "sondez": [
        "sonder"
    ],
    "sondions": [
        "sonder"
    ],
    "sondons": [
        "sonder"
    ],
    "sonderent": [
        "sonder"
    ],
    "sondee": [
        "sonde",
        "sonder"
    ],
    "song": [
        "song"
    ],
    "songe": [
        "songe",
        "songer"
    ],
    "songea": [
        "songer"
    ],
    "songeai": [
        "songer"
    ],
    "songeaient": [
        "songer"
    ],
    "songeais": [
        "songer"
    ],
    "songeait": [
        "songer"
    ],
    "songeant": [
        "songer"
    ],
    "songeasse": [
        "songer"
    ],
    "songent": [
        "songer"
    ],
    "songeons": [
        "songer"
    ],
    "songer": [
        "songer"
    ],
    "songera": [
        "songer"
    ],
    "songerai": [
        "songer"
    ],
    "songeraient": [
        "songer"
    ],
    "songerais": [
        "songer"
    ],
    "songerait": [
        "songer"
    ],
    "songerie": [
        "songerie"
    ],
    "songeries": [
        "songerie"
    ],
    "songeriez": [
        "songer"
    ],
    "songerons": [
        "songer"
    ],
    "songes": [
        "songe",
        "songer"
    ],
    "songeur": [
        "songeur"
    ],
    "songeurs": [
        "songeur"
    ],
    "songeuse": [
        "songeur"
    ],
    "songeusement": [
        "songeusement"
    ],
    "songeuses": [
        "songeur"
    ],
    "songez": [
        "songer"
    ],
    "songeat": [
        "songer"
    ],
    "songiez": [
        "songer"
    ],
    "songions": [
        "songer"
    ],
    "songerent": [
        "songer"
    ],
    "sonique": [
        "sonique"
    ],
    "soniques": [
        "sonique"
    ],
    "sonna": [
        "sonner"
    ],
    "sonnai": [
        "sonner"
    ],
    "sonnaient": [
        "sonner"
    ],
    "sonnaillaient": [
        "sonnailler"
    ],
    "sonnaille": [
        "sonnaille"
    ],
    "sonnailler": [
        "sonnailler"
    ],
    "sonnailles": [
        "sonnaille"
    ],
    "sonnais": [
        "sonner"
    ],
    "sonnait": [
        "sonner"
    ],
    "sonnant": [
        "sonner",
        "sonnant"
    ],
    "sonnante": [
        "sonnant"
    ],
    "sonnantes": [
        "sonnant"
    ],
    "sonnants": [
        "sonnant"
    ],
    "sonne": [
        "sonner",
        "sonne"
    ],
    "sonnent": [
        "sonner"
    ],
    "sonner": [
        "sonner"
    ],
    "sonnera": [
        "sonner"
    ],
    "sonnerai": [
        "sonner"
    ],
    "sonnerais": [
        "sonner"
    ],
    "sonnerait": [
        "sonner"
    ],
    "sonneras": [
        "sonner"
    ],
    "sonnerez": [
        "sonner"
    ],
    "sonnerie": [
        "sonnerie"
    ],
    "sonneries": [
        "sonnerie"
    ],
    "sonneront": [
        "sonner"
    ],
    "sonnes": [
        "sonner",
        "sonne"
    ],
    "sonnet": [
        "sonnet"
    ],
    "sonnets": [
        "sonnet"
    ],
    "sonnette": [
        "sonnette"
    ],
    "sonnettes": [
        "sonnette"
    ],
    "sonneur": [
        "sonneur"
    ],
    "sonneurs": [
        "sonneur"
    ],
    "sonnez": [
        "sonner"
    ],
    "sonniez": [
        "sonner"
    ],
    "sonnons": [
        "sonner"
    ],
    "sonnat": [
        "sonner"
    ],
    "sonnerent": [
        "sonner"
    ],
    "sonnee": [
        "sonner",
        "sonne"
    ],
    "sonnees": [
        "sonner",
        "sonne"
    ],
    "sono": [
        "sono"
    ],
    "sonoluminescence": [
        "sonoluminescence"
    ],
    "sonometres": [
        "sonometre"
    ],
    "sonore": [
        "sonore"
    ],
    "sonorement": [
        "sonorement"
    ],
    "sonores": [
        "sonore"
    ],
    "sonorisateurs": [
        "sonorisateur"
    ],
    "sonorisation": [
        "sonorisation"
    ],
    "sonorise": [
        "sonoriser"
    ],
    "sonoriser": [
        "sonoriser"
    ],
    "sonorisees": [
        "sonoriser"
    ],
    "sonorite": [
        "sonorite"
    ],
    "sonorites": [
        "sonorite"
    ],
    "sonos": [
        "sono"
    ],
    "sonotheque": [
        "sonotheque"
    ],
    "sonotone": [
        "sonotone"
    ],
    "sonotones": [
        "sonotone"
    ],
    "sons": [
        "son"
    ],
    "sont": [
        "etre"
    ],
    "sopha": [
        "sopha"
    ],
    "sophie": [
        "sophie"
    ],
    "sophisme": [
        "sophisme"
    ],
    "sophismes": [
        "sophisme"
    ],
    "sophiste": [
        "sophiste"
    ],
    "sophistes": [
        "sophiste"
    ],
    "sophistication": [
        "sophistication"
    ],
    "sophistications": [
        "sophistication"
    ],
    "sophistique": [
        "sophistique",
        "sophistiquer"
    ],
    "sophistiquee": [
        "sophistique",
        "sophistiquer"
    ],
    "sophistiquees": [
        "sophistique",
        "sophistiquer"
    ],
    "sophistiques": [
        "sophistique",
        "sophistiquer"
    ],
    "sophora": [
        "sophora"
    ],
    "sopor": [
        "sopor"
    ],
    "soporifique": [
        "soporifique"
    ],
    "soporifiques": [
        "soporifique"
    ],
    "soprano": [
        "soprano"
    ],
    "sopranos": [
        "soprano"
    ],
    "sorbes": [
        "sorbe"
    ],
    "sorbet": [
        "sorbet"
    ],
    "sorbetiere": [
        "sorbetiere"
    ],
    "sorbetieres": [
        "sorbetiere"
    ],
    "sorbets": [
        "sorbet"
    ],
    "sorbier": [
        "sorbier"
    ],
    "sorbiers": [
        "sorbier"
    ],
    "sorbitol": [
        "sorbitol"
    ],
    "sorbonnarde": [
        "sorbonnard"
    ],
    "sorbonne": [
        "sorbon",
        "sorbonne"
    ],
    "sorcellerie": [
        "sorcellerie"
    ],
    "sorcelleries": [
        "sorcellerie"
    ],
    "sorcier": [
        "sorcier"
    ],
    "sorciers": [
        "sorcier"
    ],
    "sorciere": [
        "sorcier"
    ],
    "sorcieres": [
        "sorcier"
    ],
    "sordide": [
        "sordide"
    ],
    "sordidement": [
        "sordidement"
    ],
    "sordides": [
        "sordide"
    ],
    "sordidite": [
        "sordidite"
    ],
    "sorgho": [
        "sorgho"
    ],
    "sorite": [
        "sorite"
    ],
    "sornette": [
        "sornette"
    ],
    "sornettes": [
        "sornette"
    ],
    "sororal": [
        "sororal"
    ],
    "sororale": [
        "sororal"
    ],
    "sororales": [
        "sororal"
    ],
    "sororite": [
        "sororite"
    ],
    "sors": [
        "sortir"
    ],
    "sort": [
        "sortir",
        "sort"
    ],
    "sortable": [
        "sortable"
    ],
    "sortables": [
        "sortable"
    ],
    "sortaient": [
        "sortir"
    ],
    "sortais": [
        "sortir"
    ],
    "sortait": [
        "sortir"
    ],
    "sortant": [
        "sortir",
        "sortant"
    ],
    "sortante": [
        "sortant"
    ],
    "sortantes": [
        "sortant"
    ],
    "sortants": [
        "sortant"
    ],
    "sorte": [
        "sortir",
        "sorte"
    ],
    "sortent": [
        "sortir"
    ],
    "sortes": [
        "sortir",
        "sorte"
    ],
    "sortez": [
        "sortir"
    ],
    "sorti": [
        "sortir"
    ],
    "sortie": [
        "sortir",
        "sortie"
    ],
    "sorties": [
        "sortir",
        "sortie"
    ],
    "sortiez": [
        "sortir"
    ],
    "sortilege": [
        "sortilege"
    ],
    "sortileges": [
        "sortilege"
    ],
    "sortions": [
        "sortir"
    ],
    "sortir": [
        "sortir"
    ],
    "sortira": [
        "sortir"
    ],
    "sortirai": [
        "sortir"
    ],
    "sortiraient": [
        "sortir"
    ],
    "sortirais": [
        "sortir"
    ],
    "sortirait": [
        "sortir"
    ],
    "sortiras": [
        "sortir"
    ],
    "sortirent": [
        "sortir"
    ],
    "sortirez": [
        "sortir"
    ],
    "sortiriez": [
        "sortir"
    ],
    "sortirions": [
        "sortir"
    ],
    "sortirons": [
        "sortir"
    ],
    "sortiront": [
        "sortir"
    ],
    "sortis": [
        "sortir"
    ],
    "sortit": [
        "sortir"
    ],
    "sortons": [
        "sortir"
    ],
    "sorts": [
        "sort"
    ],
    "sortimes": [
        "sortir"
    ],
    "sosie": [
        "sosie"
    ],
    "sosies": [
        "sosie"
    ],
    "sostenuto": [
        "sostenuto"
    ],
    "sot": [
        "sot"
    ],
    "sotie": [
        "sotie"
    ],
    "sots": [
        "sot"
    ],
    "sotte": [
        "sot"
    ],
    "sottement": [
        "sottement"
    ],
    "sottes": [
        "sot"
    ],
    "sottise": [
        "sottise"
    ],
    "sottises": [
        "sottise"
    ],
    "sou": [
        "sou"
    ],
    "souabe": [
        "souabe"
    ],
    "souabes": [
        "souabe"
    ],
    "soubassement": [
        "soubassement"
    ],
    "soubassements": [
        "soubassement"
    ],
    "soubise": [
        "soubise"
    ],
    "soubresaut": [
        "soubresaut"
    ],
    "soubresautaient": [
        "soubresauter"
    ],
    "soubresautait": [
        "soubresauter"
    ],
    "soubresauts": [
        "soubresaut"
    ],
    "soubrette": [
        "soubrette"
    ],
    "soubrettes": [
        "soubrette"
    ],
    "souche": [
        "souche"
    ],
    "souches": [
        "souche"
    ],
    "souchet": [
        "souchet"
    ],
    "souchette": [
        "souchette"
    ],
    "souci": [
        "souci"
    ],
    "soucia": [
        "soucier"
    ],
    "souciai": [
        "soucier"
    ],
    "souciaient": [
        "soucier"
    ],
    "souciais": [
        "soucier"
    ],
    "souciait": [
        "soucier"
    ],
    "souciant": [
        "soucier"
    ],
    "soucie": [
        "soucier"
    ],
    "soucient": [
        "soucier"
    ],
    "soucier": [
        "soucier"
    ],
    "souciera": [
        "soucier"
    ],
    "soucierai": [
        "soucier"
    ],
    "soucieraient": [
        "soucier"
    ],
    "soucierais": [
        "soucier"
    ],
    "soucierait": [
        "soucier"
    ],
    "soucierez": [
        "soucier"
    ],
    "soucies": [
        "soucier"
    ],
    "soucieuse": [
        "soucieux"
    ],
    "soucieuses": [
        "soucieux"
    ],
    "soucieux": [
        "soucieux"
    ],
    "souciez": [
        "soucier"
    ],
    "soucions": [
        "soucier"
    ],
    "soucis": [
        "souci"
    ],
    "souciat": [
        "soucier"
    ],
    "soucierent": [
        "soucier"
    ],
    "souciee": [
        "soucier"
    ],
    "souciees": [
        "soucier"
    ],
    "soucoupe": [
        "soucoupe"
    ],
    "soucoupes": [
        "soucoupe"
    ],
    "soudage": [
        "soudage"
    ],
    "soudaient": [
        "souder"
    ],
    "soudain": [
        "soudain"
    ],
    "soudaine": [
        "soudain"
    ],
    "soudainement": [
        "soudainement"
    ],
    "soudaines": [
        "soudain"
    ],
    "soudainete": [
        "soudainete"
    ],
    "soudains": [
        "soudain"
    ],
    "soudait": [
        "souder"
    ],
    "soudanais": [
        "soudanais"
    ],
    "soudanaise": [
        "soudanais"
    ],
    "soudant": [
        "souder"
    ],
    "soudard": [
        "soudard"
    ],
    "soudards": [
        "soudard"
    ],
    "soude": [
        "soude",
        "souder"
    ],
    "soudent": [
        "souder"
    ],
    "souder": [
        "souder"
    ],
    "souderait": [
        "souder"
    ],
    "soudeur": [
        "soudeur"
    ],
    "soudeurs": [
        "soudeur"
    ],
    "soudeuse": [
        "soudeur"
    ],
    "soudez": [
        "souder"
    ],
    "soudoie": [
        "soudoyer"
    ],
    "soudoya": [
        "soudoyer"
    ],
    "soudoyaient": [
        "soudoyer"
    ],
    "soudoyait": [
        "soudoyer"
    ],
    "soudoyant": [
        "soudoyer"
    ],
    "soudoyer": [
        "soudoyer"
    ],
    "soudoyez": [
        "soudoyer"
    ],
    "soudoye": [
        "soudoyer"
    ],
    "soudoyee": [
        "soudoyer"
    ],
    "soudoyes": [
        "soudoyer"
    ],
    "soudure": [
        "soudure"
    ],
    "soudures": [
        "soudure"
    ],
    "souderent": [
        "souder"
    ],
    "soudee": [
        "soude",
        "souder"
    ],
    "soudees": [
        "soude",
        "souder"
    ],
    "soudes": [
        "soude",
        "souder"
    ],
    "soue": [
        "soue"
    ],
    "souffert": [
        "souffrir"
    ],
    "soufferte": [
        "souffrir"
    ],
    "souffertes": [
        "souffrir"
    ],
    "soufferts": [
        "souffrir"
    ],
    "souffla": [
        "souffler"
    ],
    "soufflages": [
        "soufflage"
    ],
    "soufflai": [
        "souffler"
    ],
    "soufflaient": [
        "souffler"
    ],
    "soufflais": [
        "souffler"
    ],
    "soufflait": [
        "souffler"
    ],
    "soufflant": [
        "soufflant",
        "souffler"
    ],
    "soufflante": [
        "soufflant"
    ],
    "soufflants": [
        "soufflant"
    ],
    "souffle": [
        "souffle",
        "souffler"
    ],
    "soufflement": [
        "soufflement"
    ],
    "soufflements": [
        "soufflement"
    ],
    "soufflent": [
        "souffler"
    ],
    "souffler": [
        "souffler"
    ],
    "soufflera": [
        "souffler"
    ],
    "soufflerai": [
        "souffler"
    ],
    "soufflerais": [
        "souffler"
    ],
    "soufflerait": [
        "souffler"
    ],
    "soufflerez": [
        "souffler"
    ],
    "soufflerie": [
        "soufflerie"
    ],
    "souffleront": [
        "souffler"
    ],
    "souffles": [
        "souffle",
        "souffler"
    ],
    "soufflet": [
        "soufflet"
    ],
    "souffletai": [
        "souffleter"
    ],
    "souffletaient": [
        "souffleter"
    ],
    "souffletait": [
        "souffleter"
    ],
    "souffletant": [
        "souffleter"
    ],
    "souffleter": [
        "souffleter"
    ],
    "soufflets": [
        "soufflet"
    ],
    "soufflette": [
        "souffleter"
    ],
    "soufflettent": [
        "souffleter"
    ],
    "soufflettes": [
        "souffleter"
    ],
    "soufflete": [
        "souffleter"
    ],
    "souffletee": [
        "souffleter"
    ],
    "souffletes": [
        "souffleter"
    ],
    "souffleur": [
        "souffleur"
    ],
    "souffleurs": [
        "souffleur"
    ],
    "souffleuse": [
        "souffleur"
    ],
    "soufflez": [
        "souffler"
    ],
    "soufflons": [
        "souffler"
    ],
    "soufflure": [
        "soufflure"
    ],
    "soufflures": [
        "soufflure"
    ],
    "soufflat": [
        "souffler"
    ],
    "soufflerent": [
        "souffler"
    ],
    "soufflee": [
        "souffle",
        "souffler"
    ],
    "soufflees": [
        "souffle",
        "souffler"
    ],
    "souffraient": [
        "souffrir"
    ],
    "souffrais": [
        "souffrir"
    ],
    "souffrait": [
        "souffrir"
    ],
    "souffrance": [
        "souffrance"
    ],
    "souffrances": [
        "souffrance"
    ],
    "souffrant": [
        "souffrir",
        "souffrant"
    ],
    "souffrante": [
        "souffrant"
    ],
    "souffrantes": [
        "souffrant"
    ],
    "souffrants": [
        "souffrant"
    ],
    "souffre": [
        "souffrir"
    ],
    "souffrent": [
        "souffrir"
    ],
    "souffres": [
        "souffrir"
    ],
    "souffreteuse": [
        "souffreteux"
    ],
    "souffreteuses": [
        "souffreteux"
    ],
    "souffreteux": [
        "souffreteux"
    ],
    "souffrez": [
        "souffrir"
    ],
    "souffriez": [
        "souffrir"
    ],
    "souffrions": [
        "souffrir"
    ],
    "souffrir": [
        "souffrir"
    ],
    "souffrira": [
        "souffrir"
    ],
    "souffrirai": [
        "souffrir"
    ],
    "souffriraient": [
        "souffrir"
    ],
    "souffrirais": [
        "souffrir"
    ],
    "souffrirait": [
        "souffrir"
    ],
    "souffriras": [
        "souffrir"
    ],
    "souffrirent": [
        "souffrir"
    ],
    "souffrirez": [
        "souffrir"
    ],
    "souffririez": [
        "souffrir"
    ],
    "souffririons": [
        "souffrir"
    ],
    "souffrirons": [
        "souffrir"
    ],
    "souffriront": [
        "souffrir"
    ],
    "souffris": [
        "souffrir"
    ],
    "souffrisse": [
        "souffrir"
    ],
    "souffrissent": [
        "souffrir"
    ],
    "souffrit": [
        "souffrir"
    ],
    "souffrons": [
        "souffrir"
    ],
    "soufi": [
        "soufi"
    ],
    "soufis": [
        "soufi"
    ],
    "soufrages": [
        "soufrage"
    ],
    "soufre": [
        "soufre",
        "soufrer"
    ],
    "soufree": [
        "soufre",
        "soufrer"
    ],
    "soufrees": [
        "soufre",
        "soufrer"
    ],
    "soufres": [
        "soufre"
    ],
    "souhait": [
        "souhait"
    ],
    "souhaita": [
        "souhaiter"
    ],
    "souhaitable": [
        "souhaitable"
    ],
    "souhaitables": [
        "souhaitable"
    ],
    "souhaitai": [
        "souhaiter"
    ],
    "souhaitaient": [
        "souhaiter"
    ],
    "souhaitais": [
        "souhaiter"
    ],
    "souhaitait": [
        "souhaiter"
    ],
    "souhaitant": [
        "souhaiter"
    ],
    "souhaite": [
        "souhaiter"
    ],
    "souhaitent": [
        "souhaiter"
    ],
    "souhaiter": [
        "souhaiter"
    ],
    "souhaitera": [
        "souhaiter"
    ],
    "souhaiterai": [
        "souhaiter"
    ],
    "souhaiteraient": [
        "souhaiter"
    ],
    "souhaiterais": [
        "souhaiter"
    ],
    "souhaiterait": [
        "souhaiter"
    ],
    "souhaiteras": [
        "souhaiter"
    ],
    "souhaiterez": [
        "souhaiter"
    ],
    "souhaiteriez": [
        "souhaiter"
    ],
    "souhaiterions": [
        "souhaiter"
    ],
    "souhaiterons": [
        "souhaiter"
    ],
    "souhaiteront": [
        "souhaiter"
    ],
    "souhaites": [
        "souhaiter"
    ],
    "souhaitez": [
        "souhaiter"
    ],
    "souhaitiez": [
        "souhaiter"
    ],
    "souhaitions": [
        "souhaiter"
    ],
    "souhaitons": [
        "souhaiter"
    ],
    "souhaits": [
        "souhait"
    ],
    "souhaitames": [
        "souhaiter"
    ],
    "souhaitat": [
        "souhaiter"
    ],
    "souhaiterent": [
        "souhaiter"
    ],
    "souhaitee": [
        "souhaiter"
    ],
    "souhaitees": [
        "souhaiter"
    ],
    "souilla": [
        "souiller"
    ],
    "souillage": [
        "souillage"
    ],
    "souillaient": [
        "souiller"
    ],
    "souillait": [
        "souiller"
    ],
    "souillant": [
        "souiller"
    ],
    "souillarde": [
        "souillard"
    ],
    "souille": [
        "souille",
        "souiller"
    ],
    "souillent": [
        "souiller"
    ],
    "souiller": [
        "souiller"
    ],
    "souillerai": [
        "souiller"
    ],
    "souilleraient": [
        "souiller"
    ],
    "souillerait": [
        "souiller"
    ],
    "souilleras": [
        "souiller"
    ],
    "souilleront": [
        "souiller"
    ],
    "souilles": [
        "souille",
        "souiller"
    ],
    "souillez": [
        "souiller"
    ],
    "souillon": [
        "souillon"
    ],
    "souillonnes": [
        "souillonner"
    ],
    "souillons": [
        "souillon"
    ],
    "souillure": [
        "souillure"
    ],
    "souillures": [
        "souillure"
    ],
    "souillee": [
        "souiller"
    ],
    "souillees": [
        "souiller"
    ],
    "souk": [
        "souk"
    ],
    "souks": [
        "souk"
    ],
    "soul": [
        "soul"
    ],
    "soulage": [
        "soulager"
    ],
    "soulagea": [
        "soulager"
    ],
    "soulageai": [
        "soulager"
    ],
    "soulageaient": [
        "soulager"
    ],
    "soulageait": [
        "soulager"
    ],
    "soulageant": [
        "soulager",
        "soulageant"
    ],
    "soulagement": [
        "soulagement"
    ],
    "soulagements": [
        "soulagement"
    ],
    "soulagent": [
        "soulager"
    ],
    "soulageons": [
        "soulager"
    ],
    "soulager": [
        "soulager"
    ],
    "soulagera": [
        "soulager"
    ],
    "soulagerai": [
        "soulager"
    ],
    "soulageraient": [
        "soulager"
    ],
    "soulagerait": [
        "soulager"
    ],
    "soulagerez": [
        "soulager"
    ],
    "soulages": [
        "soulager"
    ],
    "soulagez": [
        "soulager"
    ],
    "soulageames": [
        "soulager"
    ],
    "soulagerent": [
        "soulager"
    ],
    "soulagee": [
        "soulager"
    ],
    "soulagees": [
        "soulager"
    ],
    "soule": [
        "soule",
        "souler",
        "soul"
    ],
    "souleva": [
        "soulever"
    ],
    "soulevai": [
        "soulever"
    ],
    "soulevaient": [
        "soulever"
    ],
    "soulevais": [
        "soulever"
    ],
    "soulevait": [
        "soulever"
    ],
    "soulevant": [
        "soulever"
    ],
    "soulever": [
        "soulever"
    ],
    "soulevez": [
        "soulever"
    ],
    "soulevions": [
        "soulever"
    ],
    "soulevons": [
        "soulever"
    ],
    "soulevat": [
        "soulever"
    ],
    "souleverent": [
        "soulever"
    ],
    "souleve": [
        "souleve",
        "soulever"
    ],
    "soulevee": [
        "souleve",
        "soulever"
    ],
    "soulevees": [
        "souleve",
        "soulever"
    ],
    "souleves": [
        "souleve",
        "soulever"
    ],
    "soulier": [
        "soulier"
    ],
    "souliers": [
        "soulier"
    ],
    "souligna": [
        "souligner"
    ],
    "soulignai": [
        "souligner"
    ],
    "soulignaient": [
        "souligner"
    ],
    "soulignais": [
        "souligner"
    ],
    "soulignait": [
        "souligner"
    ],
    "soulignant": [
        "souligner"
    ],
    "souligne": [
        "souligner"
    ],
    "soulignent": [
        "souligner"
    ],
    "souligner": [
        "souligner"
    ],
    "soulignera": [
        "souligner"
    ],
    "souligneraient": [
        "souligner"
    ],
    "soulignerait": [
        "souligner"
    ],
    "soulignez": [
        "souligner"
    ],
    "souligniez": [
        "souligner"
    ],
    "soulignions": [
        "souligner"
    ],
    "soulignee": [
        "souligner"
    ],
    "soulignees": [
        "souligner"
    ],
    "soulignes": [
        "souligner"
    ],
    "soulevement": [
        "soulevement"
    ],
    "soulevements": [
        "soulevement"
    ],
    "soulevent": [
        "soulever"
    ],
    "soulevera": [
        "soulever"
    ],
    "souleverai": [
        "soulever"
    ],
    "souleveraient": [
        "soulever"
    ],
    "souleverais": [
        "soulever"
    ],
    "souleverait": [
        "soulever"
    ],
    "souleverez": [
        "soulever"
    ],
    "souleveriez": [
        "soulever"
    ],
    "souleverons": [
        "soulever"
    ],
    "souleveront": [
        "soulever"
    ],
    "soumet": [
        "soumettre"
    ],
    "soumets": [
        "soumettre"
    ],
    "soumettaient": [
        "soumettre"
    ],
    "soumettais": [
        "soumettre"
    ],
    "soumettait": [
        "soumettre"
    ],
    "soumettant": [
        "soumettre"
    ],
    "soumette": [
        "soumettre"
    ],
    "soumettent": [
        "soumettre"
    ],
    "soumettez": [
        "soumettre"
    ],
    "soumettions": [
        "soumettre"
    ],
    "soumettons": [
        "soumettre"
    ],
    "soumettra": [
        "soumettre"
    ],
    "soumettrai": [
        "soumettre"
    ],
    "soumettraient": [
        "soumettre"
    ],
    "soumettrais": [
        "soumettre"
    ],
    "soumettrait": [
        "soumettre"
    ],
    "soumettras": [
        "soumettre"
    ],
    "soumettre": [
        "soumettre"
    ],
    "soumettrez": [
        "soumettre"
    ],
    "soumettront": [
        "soumettre"
    ],
    "soumirent": [
        "soumettre"
    ],
    "soumis": [
        "soumis",
        "soumettre"
    ],
    "soumise": [
        "soumis",
        "soumettre"
    ],
    "soumises": [
        "soumis",
        "soumettre"
    ],
    "soumission": [
        "soumission"
    ],
    "soumissionner": [
        "soumissionner"
    ],
    "soumissions": [
        "soumission"
    ],
    "soumit": [
        "soumettre"
    ],
    "soupa": [
        "souper"
    ],
    "soupaient": [
        "souper"
    ],
    "soupais": [
        "souper"
    ],
    "soupait": [
        "souper"
    ],
    "soupant": [
        "souper"
    ],
    "soupape": [
        "soupape"
    ],
    "soupapes": [
        "soupape"
    ],
    "soupasse": [
        "souper"
    ],
    "soupe": [
        "soupe",
        "souper"
    ],
    "soupent": [
        "souper"
    ],
    "soupente": [
        "soupente"
    ],
    "soupentes": [
        "soupente"
    ],
    "souper": [
        "souper"
    ],
    "soupera": [
        "souper"
    ],
    "souperaient": [
        "souper"
    ],
    "souperait": [
        "souper"
    ],
    "souperons": [
        "souper"
    ],
    "soupers": [
        "souper"
    ],
    "soupes": [
        "soupe",
        "souper"
    ],
    "soupesa": [
        "soupeser"
    ],
    "soupesait": [
        "soupeser"
    ],
    "soupesant": [
        "soupeser"
    ],
    "soupeser": [
        "soupeser"
    ],
    "soupesez": [
        "soupeser"
    ],
    "soupese": [
        "soupeser"
    ],
    "soupesee": [
        "soupeser"
    ],
    "soupeses": [
        "soupeser"
    ],
    "soupeur": [
        "soupeur"
    ],
    "soupeurs": [
        "soupeur"
    ],
    "soupez": [
        "souper"
    ],
    "soupier": [
        "soupier"
    ],
    "soupir": [
        "soupir"
    ],
    "soupira": [
        "soupirer"
    ],
    "soupirai": [
        "soupirer"
    ],
    "soupiraient": [
        "soupirer"
    ],
    "soupirail": [
        "soupirail"
    ],
    "soupirais": [
        "soupirer"
    ],
    "soupirait": [
        "soupirer"
    ],
    "soupirant": [
        "soupirer",
        "soupirant"
    ],
    "soupirants": [
        "soupirant"
    ],
    "soupiraux": [
        "soupirail"
    ],
    "soupire": [
        "soupirer"
    ],
    "soupirent": [
        "soupirer"
    ],
    "soupirer": [
        "soupirer"
    ],
    "soupirerait": [
        "soupirer"
    ],
    "soupires": [
        "soupirer"
    ],
    "soupirez": [
        "soupirer"
    ],
    "soupirions": [
        "soupirer"
    ],
    "soupirons": [
        "soupirer"
    ],
    "soupirs": [
        "soupir"
    ],
    "soupirat": [
        "soupirer"
    ],
    "soupirerent": [
        "soupirer"
    ],
    "soupiere": [
        "soupiere"
    ],
    "soupieres": [
        "soupiere"
    ],
    "souple": [
        "souple"
    ],
    "souplement": [
        "souplement"
    ],
    "souples": [
        "souple"
    ],
    "souplesse": [
        "souplesse"
    ],
    "souplesses": [
        "souplesse"
    ],
    "soupons": [
        "souper"
    ],
    "soupames": [
        "souper"
    ],
    "soupcon": [
        "soupcon"
    ],
    "soupconna": [
        "soupconner"
    ],
    "soupconnable": [
        "soupconnable"
    ],
    "soupconnai": [
        "soupconner"
    ],
    "soupconnaient": [
        "soupconner"
    ],
    "soupconnais": [
        "soupconner"
    ],
    "soupconnait": [
        "soupconner"
    ],
    "soupconnant": [
        "soupconner"
    ],
    "soupconne": [
        "soupconner"
    ],
    "soupconnent": [
        "soupconner"
    ],
    "soupconner": [
        "soupconner"
    ],
    "soupconnera": [
        "soupconner"
    ],
    "soupconnerais": [
        "soupconner"
    ],
    "soupconnerait": [
        "soupconner"
    ],
    "soupconneriez": [
        "soupconner"
    ],
    "soupconneront": [
        "soupconner"
    ],
    "soupconnes": [
        "soupconner"
    ],
    "soupconneuse": [
        "soupconneux"
    ],
    "soupconneuses": [
        "soupconneux"
    ],
    "soupconneux": [
        "soupconneux"
    ],
    "soupconnez": [
        "soupconner"
    ],
    "soupconniez": [
        "soupconner"
    ],
    "soupconnions": [
        "soupconner"
    ],
    "soupconnons": [
        "soupconner"
    ],
    "soupconnat": [
        "soupconner"
    ],
    "soupconnerent": [
        "soupconner"
    ],
    "soupconnee": [
        "soupconner"
    ],
    "soupconnees": [
        "soupconner"
    ],
    "soupcons": [
        "soupcon"
    ],
    "souperent": [
        "souper"
    ],
    "soupeserait": [
        "soupeser"
    ],
    "souquaient": [
        "souquer"
    ],
    "souque": [
        "souquer"
    ],
    "souquenille": [
        "souquenille"
    ],
    "souquenilles": [
        "souquenille"
    ],
    "souquer": [
        "souquer"
    ],
    "souquez": [
        "souquer"
    ],
    "sourate": [
        "sourate"
    ],
    "sourates": [
        "sourate"
    ],
    "source": [
        "source"
    ],
    "sources": [
        "source"
    ],
    "sourcier": [
        "sourcier"
    ],
    "sourciers": [
        "sourcier"
    ],
    "sourcil": [
        "sourcil"
    ],
    "sourciliere": [
        "sourcilier"
    ],
    "sourcilieres": [
        "sourcilier"
    ],
    "sourcilla": [
        "sourciller"
    ],
    "sourcillai": [
        "sourciller"
    ],
    "sourcille": [
        "sourciller"
    ],
    "sourciller": [
        "sourciller"
    ],
    "sourcilleuse": [
        "sourcilleux"
    ],
    "sourcilleuses": [
        "sourcilleux"
    ],
    "sourcilleux": [
        "sourcilleux"
    ],
    "sourcils": [
        "sourcil"
    ],
    "sourd": [
        "sourdre",
        "sourd"
    ],
    "sourdaient": [
        "sourdaient"
    ],
    "sourdait": [
        "sourdait"
    ],
    "sourdant": [
        "sourdre"
    ],
    "sourde": [
        "sourdre",
        "sourd"
    ],
    "sourdement": [
        "sourdement"
    ],
    "sourdes": [
        "sourd"
    ],
    "sourdine": [
        "sourdine"
    ],
    "sourdingue": [
        "sourdingue"
    ],
    "sourdingues": [
        "sourdingue"
    ],
    "sourdre": [
        "sourdre"
    ],
    "sourdront": [
        "sourdre"
    ],
    "sourds": [
        "sourdre",
        "sourd"
    ],
    "souri": [
        "sourire"
    ],
    "souriaient": [
        "sourire"
    ],
    "souriais": [
        "sourire"
    ],
    "souriait": [
        "sourire"
    ],
    "souriant": [
        "souriant",
        "sourire"
    ],
    "souriante": [
        "souriant"
    ],
    "souriantes": [
        "souriant"
    ],
    "souriants": [
        "souriant"
    ],
    "souriceau": [
        "souriceau"
    ],
    "souriceaux": [
        "souriceau"
    ],
    "souriciere": [
        "souriciere"
    ],
    "souricieres": [
        "souriciere"
    ],
    "sourie": [
        "sourire"
    ],
    "sourient": [
        "sourire"
    ],
    "souries": [
        "sourire"
    ],
    "souriez": [
        "sourire"
    ],
    "souriions": [
        "sourire"
    ],
    "sourions": [
        "sourire"
    ],
    "sourira": [
        "sourire"
    ],
    "sourirai": [
        "sourire"
    ],
    "souriraient": [
        "sourire"
    ],
    "sourirais": [
        "sourire"
    ],
    "sourirait": [
        "sourire"
    ],
    "souriras": [
        "sourire"
    ],
    "sourire": [
        "sourire"
    ],
    "sourirent": [
        "sourire"
    ],
    "sourires": [
        "sourire"
    ],
    "sourirons": [
        "sourire"
    ],
    "souriront": [
        "sourire"
    ],
    "souris": [
        "souris",
        "sourire"
    ],
    "sourit": [
        "sourire"
    ],
    "sournois": [
        "sournois"
    ],
    "sournoise": [
        "sournois"
    ],
    "sournoisement": [
        "sournoisement"
    ],
    "sournoiserie": [
        "sournoiserie"
    ],
    "sournoiseries": [
        "sournoiserie"
    ],
    "sournoises": [
        "sournois"
    ],
    "sourimes": [
        "sourire"
    ],
    "sous": [
        "sou",
        "sous"
    ],
    "souscripteur": [
        "souscripteur"
    ],
    "souscripteurs": [
        "souscripteur"
    ],
    "souscription": [
        "souscription"
    ],
    "souscriptions": [
        "souscription"
    ],
    "souscrira": [
        "souscrire"
    ],
    "souscrirai": [
        "souscrire"
    ],
    "souscrirait": [
        "souscrire"
    ],
    "souscrire": [
        "souscrire"
    ],
    "souscris": [
        "souscrire"
    ],
    "souscrit": [
        "souscrire",
        "souscrit"
    ],
    "souscrite": [
        "souscrire",
        "souscrit"
    ],
    "souscrites": [
        "souscrire",
        "souscrit"
    ],
    "souscrits": [
        "souscrire",
        "souscrit"
    ],
    "souscrivais": [
        "souscrire"
    ],
    "souscrivait": [
        "souscrire"
    ],
    "souscrivez": [
        "souscrire"
    ],
    "souscrivons": [
        "souscrire"
    ],
    "soussigner": [
        "sous-signer"
    ],
    "soussigne": [
        "soussigne"
    ],
    "soussignee": [
        "soussigne"
    ],
    "soussignes": [
        "soussigne"
    ],
    "soussou": [
        "soussou"
    ],
    "soussous": [
        "soussou"
    ],
    "soustraction": [
        "soustraction"
    ],
    "soustractions": [
        "soustraction"
    ],
    "soustrairait": [
        "soustraire"
    ],
    "soustraire": [
        "soustraire"
    ],
    "soustrais": [
        "soustraire"
    ],
    "soustrait": [
        "soustraire"
    ],
    "soustraite": [
        "soustraire"
    ],
    "soustraites": [
        "soustraire"
    ],
    "soustraits": [
        "soustraire"
    ],
    "soustrayaient": [
        "soustraire"
    ],
    "soustrayait": [
        "soustraire"
    ],
    "soustrayant": [
        "soustraire"
    ],
    "soustrayez": [
        "soustraire"
    ],
    "soutachait": [
        "soutacher"
    ],
    "soutache": [
        "soutacher",
        "soutache"
    ],
    "soutaches": [
        "soutacher",
        "soutache"
    ],
    "soutachee": [
        "soutacher"
    ],
    "soutachees": [
        "soutacher"
    ],
    "soutane": [
        "soutane"
    ],
    "soutanelle": [
        "soutanelle"
    ],
    "soutanes": [
        "soutane"
    ],
    "soute": [
        "soute"
    ],
    "soutenable": [
        "soutenable"
    ],
    "soutenaient": [
        "soutenir"
    ],
    "soutenais": [
        "soutenir"
    ],
    "soutenait": [
        "soutenir"
    ],
    "soutenance": [
        "soutenance"
    ],
    "soutenant": [
        "soutenir",
        "soutenant"
    ],
    "souteneur": [
        "souteneur"
    ],
    "souteneurs": [
        "souteneur"
    ],
    "soutenez": [
        "soutenir"
    ],
    "souteniez": [
        "soutenir"
    ],
    "soutenions": [
        "soutenir"
    ],
    "soutenir": [
        "soutenir"
    ],
    "soutenons": [
        "soutenir"
    ],
    "soutenu": [
        "soutenir",
        "soutenu"
    ],
    "soutenue": [
        "soutenir",
        "soutenu"
    ],
    "soutenues": [
        "soutenir",
        "soutenu"
    ],
    "soutenus": [
        "soutenir",
        "soutenu"
    ],
    "souter": [
        "souter"
    ],
    "souterrain": [
        "souterrain"
    ],
    "souterraine": [
        "souterrain"
    ],
    "souterrainement": [
        "souterrainement"
    ],
    "souterraines": [
        "souterrain"
    ],
    "souterrains": [
        "souterrain"
    ],
    "soutes": [
        "soute"
    ],
    "soutien": [
        "soutien"
    ],
    "soutiendra": [
        "soutenir"
    ],
    "soutiendrai": [
        "soutenir"
    ],
    "soutiendraient": [
        "soutenir"
    ],
    "soutiendrais": [
        "soutenir"
    ],
    "soutiendrait": [
        "soutenir"
    ],
    "soutiendras": [
        "soutenir"
    ],
    "soutiendrez": [
        "soutenir"
    ],
    "soutiendriez": [
        "soutenir"
    ],
    "soutiendrons": [
        "soutenir"
    ],
    "soutiendront": [
        "soutenir"
    ],
    "soutienne": [
        "soutenir"
    ],
    "soutiennent": [
        "soutenir"
    ],
    "soutiennes": [
        "soutenir"
    ],
    "soutiens": [
        "soutenir",
        "soutien"
    ],
    "soutient": [
        "soutenir"
    ],
    "soutier": [
        "soutier"
    ],
    "soutiers": [
        "soutier"
    ],
    "soutif": [
        "soutif"
    ],
    "soutifs": [
        "soutif"
    ],
    "soutinrent": [
        "soutenir"
    ],
    "soutins": [
        "soutenir"
    ],
    "soutint": [
        "soutenir"
    ],
    "soutirage": [
        "soutirage"
    ],
    "soutiraient": [
        "soutirer"
    ],
    "soutire": [
        "soutirer"
    ],
    "soutirent": [
        "soutirer"
    ],
    "soutirer": [
        "soutirer"
    ],
    "soutirerai": [
        "soutirer"
    ],
    "soutirez": [
        "soutirer"
    ],
    "soutiree": [
        "soutirer"
    ],
    "soutirees": [
        "soutirer"
    ],
    "soutra": [
        "soutra"
    ],
    "soutenement": [
        "soutenement"
    ],
    "souvenaient": [
        "souvenir"
    ],
    "souvenais": [
        "souvenir"
    ],
    "souvenait": [
        "souvenir"
    ],
    "souvenance": [
        "souvenance"
    ],
    "souvenances": [
        "souvenance"
    ],
    "souvenant": [
        "souvenir"
    ],
    "souvenez": [
        "souvenir"
    ],
    "souveniez": [
        "souvenir"
    ],
    "souvenions": [
        "souvenir"
    ],
    "souvenir": [
        "souvenir"
    ],
    "souvenirs": [
        "souvenir"
    ],
    "souvenons": [
        "souvenir"
    ],
    "souvent": [
        "souvent"
    ],
    "souventefois": [
        "souventefois"
    ],
    "souvenu": [
        "souvenir"
    ],
    "souvenue": [
        "souvenir"
    ],
    "souvenus": [
        "souvenir"
    ],
    "souverain": [
        "souverain"
    ],
    "souveraine": [
        "souverain"
    ],
    "souverainement": [
        "souverainement"
    ],
    "souveraines": [
        "souverain"
    ],
    "souverainete": [
        "souverainete"
    ],
    "souverainetes": [
        "souverainete"
    ],
    "souverains": [
        "souverain"
    ],
    "souviendra": [
        "souvenir"
    ],
    "souviendrai": [
        "souvenir"
    ],
    "souviendraient": [
        "souvenir"
    ],
    "souviendrais": [
        "souvenir"
    ],
    "souviendrait": [
        "souvenir"
    ],
    "souviendras": [
        "souvenir"
    ],
    "souviendrez": [
        "souvenir"
    ],
    "souviendriez": [
        "souvenir"
    ],
    "souviendrons": [
        "souvenir"
    ],
    "souviendront": [
        "souvenir"
    ],
    "souvienne": [
        "souvenir"
    ],
    "souviennent": [
        "souvenir"
    ],
    "souviennes": [
        "souvenir"
    ],
    "souviens": [
        "souvenir"
    ],
    "souvient": [
        "souvenir"
    ],
    "souvinrent": [
        "souvenir"
    ],
    "souvins": [
        "souvenir"
    ],
    "souvinssent": [
        "souvenir"
    ],
    "souvint": [
        "souvenir"
    ],
    "souvlaki": [
        "souvlaki"
    ],
    "soviet": [
        "soviet"
    ],
    "soviets": [
        "soviet"
    ],
    "sovietique": [
        "sovietique"
    ],
    "sovietiques": [
        "sovietique"
    ],
    "sovietisation": [
        "sovietisation"
    ],
    "sovietisme": [
        "sovietisme"
    ],
    "sovietologues": [
        "sovietologue"
    ],
    "sovkhoze": [
        "sovkhoze"
    ],
    "sovkhozes": [
        "sovkhoze"
    ],
    "soya": [
        "soya"
    ],
    "soyeuse": [
        "soyeux"
    ],
    "soyeusement": [
        "soyeusement"
    ],
    "soyeuses": [
        "soyeux"
    ],
    "soyeux": [
        "soyeux"
    ],
    "soyez": [
        "etre"
    ],
    "soyons": [
        "etre"
    ],
    "soulait": [
        "souler"
    ],
    "soulant": [
        "souler",
        "soulant"
    ],
    "soulante": [
        "soulant"
    ],
    "soulard": [
        "soulard"
    ],
    "soularde": [
        "soulard"
    ],
    "soulards": [
        "soulard"
    ],
    "soulaud": [
        "soulaud"
    ],
    "soulauds": [
        "soulaud"
    ],
    "soulent": [
        "souler"
    ],
    "souler": [
        "souler"
    ],
    "soulerais": [
        "souler"
    ],
    "soulerait": [
        "souler"
    ],
    "soulerie": [
        "soulerie"
    ],
    "soulez": [
        "souler"
    ],
    "soulographe": [
        "soulographe"
    ],
    "soulographie": [
        "soulographie"
    ],
    "soulons": [
        "souler"
    ],
    "soulot": [
        "soulot"
    ],
    "soulots": [
        "soulot"
    ],
    "souls": [
        "soul"
    ],
    "soulerent": [
        "souler"
    ],
    "soulee": [
        "souler"
    ],
    "soulees": [
        "souler"
    ],
    "soules": [
        "souler"
    ],
    "spa": [
        "spa"
    ],
    "spacieuse": [
        "spacieux"
    ],
    "spacieuses": [
        "spacieux"
    ],
    "spacieux": [
        "spacieux"
    ],
    "spadassin": [
        "spadassin"
    ],
    "spadassins": [
        "spadassin"
    ],
    "spadille": [
        "spadille"
    ],
    "spaghetti": [
        "spaghetti"
    ],
    "spaghettis": [
        "spaghetti"
    ],
    "spahi": [
        "spahi"
    ],
    "spahis": [
        "spahi"
    ],
    "spamming": [
        "spamming"
    ],
    "sparadrap": [
        "sparadrap"
    ],
    "sparadraps": [
        "sparadrap"
    ],
    "spartakistes": [
        "spartakiste"
    ],
    "sparte": [
        "sparte"
    ],
    "sparterie": [
        "sparterie"
    ],
    "spartiate": [
        "spartiate"
    ],
    "spartiates": [
        "spartiate"
    ],
    "sparteine": [
        "sparteine"
    ],
    "spas": [
        "spa"
    ],
    "spasme": [
        "spasme"
    ],
    "spasmes": [
        "spasme"
    ],
    "spasmodique": [
        "spasmodique"
    ],
    "spasmodiquement": [
        "spasmodiquement"
    ],
    "spasmodiques": [
        "spasmodique"
    ],
    "spasmophile": [
        "spasmophile"
    ],
    "spasmophilie": [
        "spasmophilie"
    ],
    "spasticite": [
        "spasticite"
    ],
    "spastique": [
        "spastique"
    ],
    "spath": [
        "spath"
    ],
    "spatial": [
        "spatial"
    ],
    "spatiale": [
        "spatial"
    ],
    "spatialement": [
        "spatialement"
    ],
    "spatiales": [
        "spatial"
    ],
    "spatiaux": [
        "spatial"
    ],
    "spationaute": [
        "spationaute"
    ],
    "spatiotemporel": [
        "spatiotemporel"
    ],
    "spatule": [
        "spatule"
    ],
    "spatuler": [
        "spatuler"
    ],
    "spatules": [
        "spatule"
    ],
    "spatulee": [
        "spatule"
    ],
    "spatulees": [
        "spatule"
    ],
    "speakeasy": [
        "speakeasy"
    ],
    "speaker": [
        "speaker"
    ],
    "speakerine": [
        "speaker"
    ],
    "speakerines": [
        "speaker"
    ],
    "speakers": [
        "speaker"
    ],
    "species": [
        "species"
    ],
    "spectacle": [
        "spectacle"
    ],
    "spectacles": [
        "spectacle"
    ],
    "spectaculaire": [
        "spectaculaire"
    ],
    "spectaculairement": [
        "spectaculairement"
    ],
    "spectaculaires": [
        "spectaculaire"
    ],
    "spectateur": [
        "spectateur"
    ],
    "spectateurs": [
        "spectateur"
    ],
    "spectatrice": [
        "spectateur"
    ],
    "spectatrices": [
        "spectateur"
    ],
    "spectral": [
        "spectral"
    ],
    "spectrale": [
        "spectral"
    ],
    "spectrales": [
        "spectral"
    ],
    "spectraux": [
        "spectral"
    ],
    "spectre": [
        "spectre"
    ],
    "spectres": [
        "spectre"
    ],
    "spectrogramme": [
        "spectrogramme"
    ],
    "spectrographe": [
        "spectrographe"
    ],
    "spectrographie": [
        "spectrographie"
    ],
    "spectrographique": [
        "spectrographique"
    ],
    "spectroheliographe": [
        "spectroheliographe"
    ],
    "spectrometre": [
        "spectrometre"
    ],
    "spectrometrie": [
        "spectrometrie"
    ],
    "spectrometrique": [
        "spectrometrique"
    ],
    "spectrophotometre": [
        "spectrophotometre"
    ],
    "spectroscope": [
        "spectroscope"
    ],
    "spectroscopie": [
        "spectroscopie"
    ],
    "speech": [
        "speech"
    ],
    "speed": [
        "speed"
    ],
    "speede": [
        "speeder",
        "speede"
    ],
    "speeder": [
        "speeder"
    ],
    "speedes": [
        "speeder",
        "speede"
    ],
    "speedee": [
        "speeder",
        "speede"
    ],
    "spencer": [
        "spencer"
    ],
    "spencers": [
        "spencer"
    ],
    "spenglerienne": [
        "spenglerienne"
    ],
    "spermaceti": [
        "spermaceti"
    ],
    "spermatique": [
        "spermatique"
    ],
    "spermato": [
        "spermato"
    ],
    "spermatogenese": [
        "spermatogenese"
    ],
    "spermatos": [
        "spermato"
    ],
    "spermatozoide": [
        "spermatozoide"
    ],
    "spermatozoides": [
        "spermatozoide"
    ],
    "sperme": [
        "sperme"
    ],
    "spermes": [
        "sperme"
    ],
    "spermicide": [
        "spermicide"
    ],
    "spermogramme": [
        "spermogramme"
    ],
    "spermophiles": [
        "spermophile"
    ],
    "spetsnaz": [
        "spetsnaz"
    ],
    "sphaigne": [
        "sphaigne"
    ],
    "sphaignes": [
        "sphaigne"
    ],
    "sphincter": [
        "sphincter",
        "sphinct"
    ],
    "sphincters": [
        "sphincter"
    ],
    "sphinge": [
        "sphinge"
    ],
    "sphinges": [
        "sphinge"
    ],
    "sphinx": [
        "sphinx"
    ],
    "sphygmomanometre": [
        "sphygmomanometre"
    ],
    "sphere": [
        "sphere"
    ],
    "spheres": [
        "sphere"
    ],
    "sphenoide": [
        "sphenoide"
    ],
    "sphericite": [
        "sphericite"
    ],
    "spherique": [
        "spherique"
    ],
    "spheriquement": [
        "spheriquement"
    ],
    "spheriques": [
        "spherique"
    ],
    "spheroide": [
        "spheroide"
    ],
    "spheroides": [
        "spheroide"
    ],
    "spi": [
        "spi"
    ],
    "spic": [
        "spic"
    ],
    "spica": [
        "spica"
    ],
    "spics": [
        "spic"
    ],
    "spicules": [
        "spicule"
    ],
    "spider": [
        "spider"
    ],
    "spin": [
        "spin"
    ],
    "spina": [
        "spina"
    ],
    "spinal": [
        "spinal"
    ],
    "spinale": [
        "spinal"
    ],
    "spinaux": [
        "spinal"
    ],
    "spinnaker": [
        "spinnaker"
    ],
    "spinnakers": [
        "spinnaker"
    ],
    "spinozisme": [
        "spinozisme"
    ],
    "spirale": [
        "spiral",
        "spirale"
    ],
    "spiraler": [
        "spiraler"
    ],
    "spirales": [
        "spiral",
        "spirale"
    ],
    "spiralees": [
        "spirale"
    ],
    "spire": [
        "spire"
    ],
    "spires": [
        "spire"
    ],
    "spirite": [
        "spirite"
    ],
    "spirites": [
        "spirite"
    ],
    "spiritisme": [
        "spiritisme"
    ],
    "spiritualisaient": [
        "spiritualiser"
    ],
    "spiritualise": [
        "spiritualiser"
    ],
    "spiritualiser": [
        "spiritualiser"
    ],
    "spiritualisme": [
        "spiritualisme"
    ],
    "spiritualiste": [
        "spiritualiste"
    ],
    "spiritualistes": [
        "spiritualiste"
    ],
    "spiritualite": [
        "spiritualite"
    ],
    "spiritualites": [
        "spiritualite"
    ],
    "spirituel": [
        "spirituel"
    ],
    "spirituelle": [
        "spirituel"
    ],
    "spirituellement": [
        "spirituellement"
    ],
    "spirituelles": [
        "spirituel"
    ],
    "spirituels": [
        "spirituel"
    ],
    "spiritueux": [
        "spiritueux"
    ],
    "spirochete": [
        "spirochete"
    ],
    "spirographe": [
        "spirographe"
    ],
    "spirometres": [
        "spirometre"
    ],
    "spiruline": [
        "spiruline"
    ],
    "spirees": [
        "spiree"
    ],
    "spitz": [
        "spitz"
    ],
    "splash": [
        "splash"
    ],
    "spleen": [
        "spleen"
    ],
    "spleens": [
        "spleen"
    ],
    "splendeur": [
        "splendeur"
    ],
    "splendeurs": [
        "splendeur"
    ],
    "splendide": [
        "splendide"
    ],
    "splendidement": [
        "splendidement"
    ],
    "splendides": [
        "splendide"
    ],
    "splittaient": [
        "splitter"
    ],
    "splitter": [
        "splitter"
    ],
    "splenectomie": [
        "splenectomie"
    ],
    "splenique": [
        "splenique"
    ],
    "spoiler": [
        "spoiler"
    ],
    "spoliait": [
        "spolier"
    ],
    "spoliation": [
        "spoliation"
    ],
    "spoliations": [
        "spoliation"
    ],
    "spolie": [
        "spolier",
        "spolie"
    ],
    "spolier": [
        "spolier"
    ],
    "spoliee": [
        "spolier"
    ],
    "spoliees": [
        "spolie"
    ],
    "spolies": [
        "spolier"
    ],
    "spondylarthrose": [
        "spondylarthrose"
    ],
    "spondylite": [
        "spondylite"
    ],
    "spondees": [
        "spondee"
    ],
    "spongieuse": [
        "spongieux"
    ],
    "spongieuses": [
        "spongieux"
    ],
    "spongieux": [
        "spongieux"
    ],
    "spongiforme": [
        "spongiforme"
    ],
    "sponsor": [
        "sponsor"
    ],
    "sponsoring": [
        "sponsoring",
        "sponsor"
    ],
    "sponsorisait": [
        "sponsoriser"
    ],
    "sponsorise": [
        "sponsoriser",
        "sponsorise"
    ],
    "sponsoriser": [
        "sponsoriser"
    ],
    "sponsorisera": [
        "sponsoriser"
    ],
    "sponsorisee": [
        "sponsoriser"
    ],
    "sponsorises": [
        "sponsoriser"
    ],
    "sponsors": [
        "sponsor"
    ],
    "spontane": [
        "spontane"
    ],
    "spontanee": [
        "spontane"
    ],
    "spontanees": [
        "spontane"
    ],
    "spontaneistes": [
        "spontaneiste"
    ],
    "spontaneite": [
        "spontaneite"
    ],
    "spontanement": [
        "spontanement"
    ],
    "spontanes": [
        "spontane"
    ],
    "spoon": [
        "spoon"
    ],
    "sporadique": [
        "sporadique"
    ],
    "sporadiquement": [
        "sporadiquement"
    ],
    "sporadiques": [
        "sporadique"
    ],
    "spore": [
        "spore"
    ],
    "spores": [
        "spore"
    ],
    "sport": [
        "sport"
    ],
    "sportif": [
        "sportif"
    ],
    "sportifs": [
        "sportif"
    ],
    "sportive": [
        "sportif"
    ],
    "sportivement": [
        "sportivement"
    ],
    "sportives": [
        "sportif"
    ],
    "sportivite": [
        "sportivite"
    ],
    "sports": [
        "sport"
    ],
    "sportsman": [
        "sportsman"
    ],
    "sportsmen": [
        "sportsman"
    ],
    "sportswear": [
        "sportswear"
    ],
    "spot": [
        "spot"
    ],
    "spots": [
        "spot"
    ],
    "spoutnik": [
        "spoutnik"
    ],
    "spoutniks": [
        "spoutnik"
    ],
    "sprat": [
        "sprat"
    ],
    "sprats": [
        "sprat"
    ],
    "spray": [
        "spray"
    ],
    "sprays": [
        "spray"
    ],
    "sprechgesang": [
        "sprechgesang"
    ],
    "spring": [
        "spring"
    ],
    "springer": [
        "springer"
    ],
    "sprinkler": [
        "sprinkler"
    ],
    "sprinklers": [
        "sprinkler"
    ],
    "sprint": [
        "sprint"
    ],
    "sprinta": [
        "sprinter"
    ],
    "sprintait": [
        "sprinter"
    ],
    "sprintant": [
        "sprinter"
    ],
    "sprinte": [
        "sprinter"
    ],
    "sprinter": [
        "sprinter"
    ],
    "sprinters": [
        "sprinter"
    ],
    "sprinteur": [
        "sprinteur"
    ],
    "sprinteurs": [
        "sprinteur"
    ],
    "sprints": [
        "sprint"
    ],
    "spruce": [
        "spruce"
    ],
    "spumescent": [
        "spumescent"
    ],
    "spumosite": [
        "spumosite"
    ],
    "special": [
        "special"
    ],
    "speciale": [
        "speciale",
        "special"
    ],
    "specialement": [
        "specialement"
    ],
    "speciales": [
        "speciale",
        "special"
    ],
    "specialisa": [
        "specialiser"
    ],
    "specialisaient": [
        "specialiser"
    ],
    "specialisait": [
        "specialiser"
    ],
    "specialisant": [
        "specialiser"
    ],
    "specialisation": [
        "specialisation"
    ],
    "specialise": [
        "specialise",
        "specialiser"
    ],
    "specialiser": [
        "specialiser"
    ],
    "specialiste": [
        "specialiste"
    ],
    "specialistes": [
        "specialiste"
    ],
    "specialisee": [
        "specialise",
        "specialiser"
    ],
    "specialisees": [
        "specialise",
        "specialiser"
    ],
    "specialises": [
        "specialise",
        "specialiser"
    ],
    "specialite": [
        "specialite"
    ],
    "specialites": [
        "specialite"
    ],
    "speciaux": [
        "special"
    ],
    "specieuse": [
        "specieux"
    ],
    "specieusement": [
        "specieusement"
    ],
    "specieuses": [
        "specieux"
    ],
    "specieux": [
        "specieux"
    ],
    "specifiais": [
        "specifier"
    ],
    "specifiait": [
        "specifier"
    ],
    "specifiant": [
        "specifier"
    ],
    "specification": [
        "specification"
    ],
    "specifications": [
        "specification"
    ],
    "specificite": [
        "specificite"
    ],
    "specificites": [
        "specificite"
    ],
    "specifie": [
        "specifie",
        "specifier"
    ],
    "specifient": [
        "specifier"
    ],
    "specifier": [
        "specifier"
    ],
    "specifiera": [
        "specifier"
    ],
    "specifiez": [
        "specifier"
    ],
    "specifique": [
        "specifique"
    ],
    "specifiquement": [
        "specifiquement"
    ],
    "specifiques": [
        "specifique"
    ],
    "specifiee": [
        "specifie"
    ],
    "specifiees": [
        "specifie",
        "specifier"
    ],
    "specifies": [
        "specifie",
        "specify"
    ],
    "specimen": [
        "specimen"
    ],
    "specimens": [
        "specimen"
    ],
    "speculaient": [
        "speculer"
    ],
    "speculaire": [
        "speculaire"
    ],
    "speculait": [
        "speculer"
    ],
    "speculant": [
        "speculer"
    ],
    "speculateur": [
        "speculateur"
    ],
    "speculateurs": [
        "speculateur"
    ],
    "speculatif": [
        "speculatif"
    ],
    "speculatifs": [
        "speculatif"
    ],
    "speculation": [
        "speculation"
    ],
    "speculations": [
        "speculation"
    ],
    "speculative": [
        "speculatif"
    ],
    "speculatives": [
        "speculatif"
    ],
    "speculatrice": [
        "speculateur"
    ],
    "speculatrices": [
        "speculateur"
    ],
    "specule": [
        "speculer"
    ],
    "speculent": [
        "speculer"
    ],
    "speculer": [
        "speculer"
    ],
    "speculeraient": [
        "speculer"
    ],
    "speculez": [
        "speculer"
    ],
    "speculoos": [
        "speculoos"
    ],
    "speculum": [
        "speculum"
    ],
    "speleo": [
        "speleo"
    ],
    "speleologie": [
        "speleologie"
    ],
    "speleologue": [
        "speleologue"
    ],
    "speleologues": [
        "speleologue"
    ],
    "speleotomie": [
        "speleotomie"
    ],
    "squale": [
        "squale"
    ],
    "squales": [
        "squale"
    ],
    "squames": [
        "squame"
    ],
    "squameuse": [
        "squameux"
    ],
    "squameux": [
        "squameux"
    ],
    "square": [
        "square"
    ],
    "squares": [
        "square"
    ],
    "squash": [
        "squash"
    ],
    "squat": [
        "squat"
    ],
    "squats": [
        "squat"
    ],
    "squattait": [
        "squatter"
    ],
    "squatte": [
        "squatter"
    ],
    "squatter": [
        "squatter"
    ],
    "squatteras": [
        "squatter"
    ],
    "squatters": [
        "squatter"
    ],
    "squatteur": [
        "squatteur"
    ],
    "squatteurs": [
        "squatteur"
    ],
    "squattez": [
        "squatter"
    ],
    "squattee": [
        "squatter"
    ],
    "squattees": [
        "squatter"
    ],
    "squatterise": [
        "squatteriser"
    ],
    "squattes": [
        "squatter"
    ],
    "squaw": [
        "squaw"
    ],
    "squaws": [
        "squaw"
    ],
    "squeeze": [
        "squeeze"
    ],
    "squeezent": [
        "squeezer"
    ],
    "squeezer": [
        "squeezer"
    ],
    "squelette": [
        "squelette"
    ],
    "squelettes": [
        "squelette"
    ],
    "squelettique": [
        "squelettique"
    ],
    "squelettiques": [
        "squelettique"
    ],
    "squire": [
        "squire"
    ],
    "squires": [
        "squire"
    ],
    "stabilisa": [
        "stabiliser"
    ],
    "stabilisait": [
        "stabiliser"
    ],
    "stabilisant": [
        "stabiliser",
        "stabilisant"
    ],
    "stabilisante": [
        "stabilisant"
    ],
    "stabilisateur": [
        "stabilisateur"
    ],
    "stabilisateurs": [
        "stabilisateur"
    ],
    "stabilisation": [
        "stabilisation"
    ],
    "stabilisatrice": [
        "stabilisateur"
    ],
    "stabilise": [
        "stabiliser",
        "stabilise"
    ],
    "stabilisent": [
        "stabiliser"
    ],
    "stabiliser": [
        "stabiliser"
    ],
    "stabilisez": [
        "stabiliser"
    ],
    "stabilisons": [
        "stabiliser"
    ],
    "stabiliserent": [
        "stabiliser"
    ],
    "stabilisee": [
        "stabiliser",
        "stabilise"
    ],
    "stabilisees": [
        "stabilise"
    ],
    "stabilises": [
        "stabiliser",
        "stabilise"
    ],
    "stabilite": [
        "stabilite"
    ],
    "stable": [
        "stable"
    ],
    "stablement": [
        "stablement"
    ],
    "stables": [
        "stable"
    ],
    "stabulation": [
        "stabulation"
    ],
    "staccato": [
        "staccato"
    ],
    "stade": [
        "stade"
    ],
    "stades": [
        "stade"
    ],
    "stadium": [
        "stadium"
    ],
    "staff": [
        "staff"
    ],
    "staffs": [
        "staff"
    ],
    "stage": [
        "stage"
    ],
    "stages": [
        "stage"
    ],
    "stagflation": [
        "stagflation"
    ],
    "stagiaire": [
        "stagiaire"
    ],
    "stagiaires": [
        "stagiaire"
    ],
    "stagna": [
        "stagner"
    ],
    "stagnaient": [
        "stagner"
    ],
    "stagnait": [
        "stagner"
    ],
    "stagnant": [
        "stagner",
        "stagnant"
    ],
    "stagnante": [
        "stagnant"
    ],
    "stagnantes": [
        "stagnant"
    ],
    "stagnation": [
        "stagnation"
    ],
    "stagne": [
        "stagner"
    ],
    "stagnent": [
        "stagner"
    ],
    "stagner": [
        "stagner"
    ],
    "stagnez": [
        "stagner"
    ],
    "stakhanoviste": [
        "stakhanoviste"
    ],
    "stalactite": [
        "stalactite"
    ],
    "stalactites": [
        "stalactite"
    ],
    "stalag": [
        "stalag"
    ],
    "stalagmite": [
        "stalagmite"
    ],
    "stalagmites": [
        "stalagmite"
    ],
    "stalags": [
        "stalag"
    ],
    "stalinien": [
        "stalinien"
    ],
    "stalinienne": [
        "stalinien"
    ],
    "staliniennes": [
        "stalinien"
    ],
    "staliniens": [
        "stalinien"
    ],
    "stalinisme": [
        "stalinisme"
    ],
    "stalinisee": [
        "staliniser"
    ],
    "stalino": [
        "stalino"
    ],
    "stalle": [
        "stalle"
    ],
    "stalles": [
        "stalle"
    ],
    "stals": [
        "stal"
    ],
    "stance": [
        "stance"
    ],
    "stances": [
        "stance"
    ],
    "stand": [
        "stand"
    ],
    "standard": [
        "standard"
    ],
    "standardisation": [
        "standardisation"
    ],
    "standardiste": [
        "standardiste"
    ],
    "standardistes": [
        "standardiste"
    ],
    "standardise": [
        "standardise",
        "standardiser"
    ],
    "standardisee": [
        "standardise",
        "standardiser"
    ],
    "standardisees": [
        "standardise",
        "standardiser"
    ],
    "standardises": [
        "standardise"
    ],
    "standards": [
        "standard"
    ],
    "standing": [
        "standing",
        "stand"
    ],
    "stands": [
        "stand"
    ],
    "staphylococcie": [
        "staphylococcie"
    ],
    "staphylococcique": [
        "staphylococcique"
    ],
    "staphylocoque": [
        "staphylocoque"
    ],
    "staphylocoques": [
        "staphylocoque"
    ],
    "star": [
        "star"
    ],
    "starking": [
        "starking"
    ],
    "starlette": [
        "starlette"
    ],
    "starlettes": [
        "starlette"
    ],
    "staroste": [
        "staroste"
    ],
    "stars": [
        "star"
    ],
    "starter": [
        "starter"
    ],
    "stase": [
        "stase"
    ],
    "stat": [
        "stat"
    ],
    "state": [
        "stater"
    ],
    "stater": [
        "stater"
    ],
    "statices": [
        "statice"
    ],
    "station": [
        "station"
    ],
    "stationna": [
        "stationner"
    ],
    "stationnaient": [
        "stationner"
    ],
    "stationnaire": [
        "stationnaire"
    ],
    "stationnait": [
        "stationner"
    ],
    "stationnant": [
        "stationner"
    ],
    "stationne": [
        "stationner"
    ],
    "stationnement": [
        "stationnement"
    ],
    "stationnements": [
        "stationnement"
    ],
    "stationnent": [
        "stationner"
    ],
    "stationner": [
        "stationner"
    ],
    "stationnera": [
        "stationner"
    ],
    "stationnez": [
        "stationner"
    ],
    "stationnions": [
        "stationner"
    ],
    "stationnerent": [
        "stationner"
    ],
    "stationnee": [
        "stationner"
    ],
    "stationnees": [
        "stationner"
    ],
    "stationnes": [
        "stationner"
    ],
    "stations": [
        "station"
    ],
    "statique": [
        "statique"
    ],
    "statiques": [
        "statique"
    ],
    "statisticien": [
        "statisticien"
    ],
    "statisticienne": [
        "statisticien"
    ],
    "statistique": [
        "statistique"
    ],
    "statistiquement": [
        "statistiquement"
    ],
    "statistiquer": [
        "statistiquer"
    ],
    "statistiques": [
        "statistique"
    ],
    "statuaient": [
        "statuer"
    ],
    "statuaire": [
        "statuaire"
    ],
    "statuant": [
        "statuer"
    ],
    "statue": [
        "statuer",
        "statue"
    ],
    "statuer": [
        "statuer"
    ],
    "statuera": [
        "statuer"
    ],
    "statuerai": [
        "statuer"
    ],
    "statuerait": [
        "statuer"
    ],
    "statues": [
        "statuer",
        "statue"
    ],
    "statuette": [
        "statuette"
    ],
    "statuettes": [
        "statuette"
    ],
    "statufia": [
        "statufier"
    ],
    "statufiais": [
        "statufier"
    ],
    "statufiait": [
        "statufier"
    ],
    "statufiant": [
        "statufier"
    ],
    "statufier": [
        "statufier"
    ],
    "statufierent": [
        "statufier"
    ],
    "statufie": [
        "statufier"
    ],
    "statufiee": [
        "statufier"
    ],
    "statufiees": [
        "statufier"
    ],
    "statufies": [
        "statufier"
    ],
    "stature": [
        "stature"
    ],
    "statures": [
        "stature"
    ],
    "status": [
        "status"
    ],
    "statut": [
        "statut"
    ],
    "statutaire": [
        "statutaire"
    ],
    "statuts": [
        "statut"
    ],
    "statere": [
        "statere"
    ],
    "stateres": [
        "statere"
    ],
    "stayer": [
        "stayer"
    ],
    "steak": [
        "steak"
    ],
    "steaks": [
        "steak"
    ],
    "steamboat": [
        "steamboat"
    ],
    "steamer": [
        "steamer"
    ],
    "steamers": [
        "steamer"
    ],
    "steeple": [
        "steeple"
    ],
    "steeples": [
        "steeple"
    ],
    "stegomya": [
        "stegomya"
    ],
    "stellaire": [
        "stellaire"
    ],
    "stellaires": [
        "stellaire"
    ],
    "stem": [
        "stem"
    ],
    "stencil": [
        "stencil"
    ],
    "stendhalien": [
        "stendhalien"
    ],
    "stentor": [
        "stentor"
    ],
    "stentors": [
        "stentor"
    ],
    "steppe": [
        "steppe"
    ],
    "stepper": [
        "stepper"
    ],
    "steppers": [
        "stepper"
    ],
    "steppes": [
        "steppe"
    ],
    "stercoraire": [
        "stercoraire"
    ],
    "stercoraires": [
        "stercoraire"
    ],
    "sterling": [
        "sterling"
    ],
    "sternal": [
        "sternal"
    ],
    "sternale": [
        "sternal"
    ],
    "sterne": [
        "sterne"
    ],
    "sternes": [
        "sterne"
    ],
    "sternum": [
        "sternum"
    ],
    "stetson": [
        "stetson"
    ],
    "steward": [
        "steward"
    ],
    "stick": [
        "stick"
    ],
    "sticker": [
        "sticker"
    ],
    "sticks": [
        "stick"
    ],
    "stigma": [
        "stigma"
    ],
    "stigmate": [
        "stigmate"
    ],
    "stigmates": [
        "stigmate"
    ],
    "stigmatisaient": [
        "stigmatiser"
    ],
    "stigmatisait": [
        "stigmatiser"
    ],
    "stigmatisant": [
        "stigmatiser"
    ],
    "stigmatiser": [
        "stigmatiser"
    ],
    "stigmatise": [
        "stigmatiser",
        "stigmatise"
    ],
    "stigmatisee": [
        "stigmatiser",
        "stigmatise"
    ],
    "stigmatises": [
        "stigmatiser",
        "stigmatise"
    ],
    "stilton": [
        "stilton"
    ],
    "stimula": [
        "stimuler"
    ],
    "stimulaient": [
        "stimuler"
    ],
    "stimulait": [
        "stimuler"
    ],
    "stimulant": [
        "stimulant",
        "stimuler"
    ],
    "stimulante": [
        "stimulant"
    ],
    "stimulantes": [
        "stimulant"
    ],
    "stimulants": [
        "stimulant"
    ],
    "stimulateur": [
        "stimulateur"
    ],
    "stimulation": [
        "stimulation"
    ],
    "stimulations": [
        "stimulation"
    ],
    "stimule": [
        "stimuler"
    ],
    "stimulent": [
        "stimuler"
    ],
    "stimuler": [
        "stimuler"
    ],
    "stimulera": [
        "stimuler"
    ],
    "stimulerait": [
        "stimuler"
    ],
    "stimuleront": [
        "stimuler"
    ],
    "stimulez": [
        "stimuler"
    ],
    "stimuli": [
        "stimulus"
    ],
    "stimulons": [
        "stimuler"
    ],
    "stimulus": [
        "stimulus"
    ],
    "stimulee": [
        "stimuler"
    ],
    "stimulees": [
        "stimuler"
    ],
    "stimules": [
        "stimuler"
    ],
    "stipendies": [
        "stipendier",
        "stipendie"
    ],
    "stipes": [
        "stipe"
    ],
    "stipulait": [
        "stipuler"
    ],
    "stipulant": [
        "stipuler",
        "stipulant"
    ],
    "stipulation": [
        "stipulation"
    ],
    "stipulations": [
        "stipulation"
    ],
    "stipule": [
        "stipule",
        "stipuler"
    ],
    "stipulent": [
        "stipuler"
    ],
    "stipuler": [
        "stipuler"
    ],
    "stipulee": [
        "stipule",
        "stipuler"
    ],
    "stipulees": [
        "stipule",
        "stipuler"
    ],
    "stipules": [
        "stipuler"
    ],
    "stochastique": [
        "stochastique"
    ],
    "stock": [
        "stock"
    ],
    "stockage": [
        "stockage"
    ],
    "stockages": [
        "stockage"
    ],
    "stockaient": [
        "stocker"
    ],
    "stockait": [
        "stocker"
    ],
    "stocke": [
        "stocker"
    ],
    "stockent": [
        "stocker"
    ],
    "stocker": [
        "stocker"
    ],
    "stockez": [
        "stocker"
    ],
    "stockons": [
        "stocker"
    ],
    "stocks": [
        "stock"
    ],
    "stockee": [
        "stocker"
    ],
    "stockees": [
        "stocker"
    ],
    "stockes": [
        "stocker"
    ],
    "stoker": [
        "stoker"
    ],
    "stokes": [
        "stokes",
        "stoke"
    ],
    "stomacal": [
        "stomacal"
    ],
    "stomacale": [
        "stomacal"
    ],
    "stomacales": [
        "stomacal"
    ],
    "stomacaux": [
        "stomacal"
    ],
    "stomates": [
        "stomate"
    ],
    "stomie": [
        "stomie"
    ],
    "stomoxys": [
        "stomoxys"
    ],
    "stone": [
        "stone"
    ],
    "stones": [
        "stone"
    ],
    "stop": [
        "stop"
    ],
    "stoppa": [
        "stopper"
    ],
    "stoppage": [
        "stoppage"
    ],
    "stoppai": [
        "stopper"
    ],
    "stoppaient": [
        "stopper"
    ],
    "stoppais": [
        "stopper"
    ],
    "stoppait": [
        "stopper"
    ],
    "stoppant": [
        "stopper"
    ],
    "stoppe": [
        "stopper"
    ],
    "stoppent": [
        "stopper"
    ],
    "stopper": [
        "stopper"
    ],
    "stoppera": [
        "stopper"
    ],
    "stopperai": [
        "stopper"
    ],
    "stopperiez": [
        "stopper"
    ],
    "stoppes": [
        "stopper"
    ],
    "stoppeur": [
        "stoppeur"
    ],
    "stoppeurs": [
        "stoppeur"
    ],
    "stoppeuse": [
        "stoppeur"
    ],
    "stoppez": [
        "stopper"
    ],
    "stoppions": [
        "stopper"
    ],
    "stoppons": [
        "stopper"
    ],
    "stoppat": [
        "stopper"
    ],
    "stopperent": [
        "stopper"
    ],
    "stoppee": [
        "stopper"
    ],
    "stoppees": [
        "stopper"
    ],
    "stops": [
        "stop"
    ],
    "storage": [
        "storage"
    ],
    "store": [
        "store"
    ],
    "stores": [
        "store"
    ],
    "stout": [
        "stout"
    ],
    "stoicien": [
        "stoicien"
    ],
    "stoiciens": [
        "stoicien"
    ],
    "stoicisme": [
        "stoicisme"
    ],
    "stoique": [
        "stoique"
    ],
    "stoiquement": [
        "stoiquement"
    ],
    "stoiques": [
        "stoique"
    ],
    "strabisme": [
        "strabisme"
    ],
    "strabismes": [
        "strabisme"
    ],
    "stradivarius": [
        "stradivarius"
    ],
    "straight": [
        "straight"
    ],
    "stramoine": [
        "stramoine"
    ],
    "stramonium": [
        "stramonium"
    ],
    "strangula": [
        "stranguler"
    ],
    "strangulant": [
        "stranguler"
    ],
    "strangulation": [
        "strangulation"
    ],
    "stranguler": [
        "stranguler"
    ],
    "strangule": [
        "stranguler"
    ],
    "strangulees": [
        "stranguler"
    ],
    "strapontin": [
        "strapontin"
    ],
    "strapontins": [
        "strapontin"
    ],
    "strasbourgeois": [
        "strasbourgeois"
    ],
    "strasbourgeoise": [
        "strasbourgeois"
    ],
    "strass": [
        "strass"
    ],
    "strasse": [
        "strasse"
    ],
    "stratageme": [
        "stratageme"
    ],
    "stratagemes": [
        "stratageme"
    ],
    "strate": [
        "strate"
    ],
    "strates": [
        "strate"
    ],
    "stratification": [
        "stratification"
    ],
    "stratifications": [
        "stratification"
    ],
    "stratifie": [
        "stratifie"
    ],
    "stratifiee": [
        "stratifie",
        "stratifier"
    ],
    "stratifiees": [
        "stratifie"
    ],
    "stratigraphique": [
        "stratigraphique"
    ],
    "stratosphere": [
        "stratosphere"
    ],
    "stratospherique": [
        "stratospherique"
    ],
    "stratospheriques": [
        "stratospherique"
    ],
    "stratus": [
        "stratus"
    ],
    "stratege": [
        "stratege"
    ],
    "strateges": [
        "stratege"
    ],
    "strategie": [
        "strategie"
    ],
    "strategies": [
        "strategie",
        "strategy"
    ],
    "strategique": [
        "strategique"
    ],
    "strategiquement": [
        "strategiquement"
    ],
    "strategiques": [
        "strategique"
    ],
    "strategiste": [
        "strategiste"
    ],
    "strelitzia": [
        "strelitzia"
    ],
    "streptococcie": [
        "streptococcie"
    ],
    "streptococcique": [
        "streptococcique"
    ],
    "streptocoque": [
        "streptocoque"
    ],
    "streptokinase": [
        "streptokinase"
    ],
    "streptomycine": [
        "streptomycine"
    ],
    "stress": [
        "stress"
    ],
    "stressais": [
        "stresser"
    ],
    "stressait": [
        "stresser"
    ],
    "stressant": [
        "stressant",
        "stresser"
    ],
    "stressante": [
        "stressant"
    ],
    "stressantes": [
        "stressant"
    ],
    "stressants": [
        "stressant"
    ],
    "stresse": [
        "stresser"
    ],
    "stressent": [
        "stresser"
    ],
    "stresser": [
        "stresser"
    ],
    "stressera": [
        "stresser"
    ],
    "stresserai": [
        "stresser"
    ],
    "stressee": [
        "stresser"
    ],
    "stressees": [
        "stresser"
    ],
    "stresses": [
        "stress",
        "stresser"
    ],
    "stretch": [
        "stretch"
    ],
    "stretching": [
        "stretch",
        "stretching"
    ],
    "striaient": [
        "strier"
    ],
    "striait": [
        "strier"
    ],
    "striations": [
        "striation"
    ],
    "strict": [
        "strict"
    ],
    "stricte": [
        "strict"
    ],
    "strictement": [
        "strictement"
    ],
    "strictes": [
        "strict"
    ],
    "stricts": [
        "strict"
    ],
    "stridence": [
        "stridence"
    ],
    "stridences": [
        "stridence"
    ],
    "strident": [
        "strident"
    ],
    "stridente": [
        "strident"
    ],
    "stridentes": [
        "strident"
    ],
    "stridents": [
        "strident"
    ],
    "strider": [
        "strider"
    ],
    "stridor": [
        "stridor"
    ],
    "stridulait": [
        "striduler"
    ],
    "stridulation": [
        "stridulation"
    ],
    "stridulations": [
        "stridulation"
    ],
    "stridule": [
        "striduler"
    ],
    "striduler": [
        "striduler"
    ],
    "striduleuse": [
        "striduleux"
    ],
    "strie": [
        "strie",
        "strier"
    ],
    "strient": [
        "strier"
    ],
    "strier": [
        "strier"
    ],
    "stries": [
        "strie",
        "strier"
    ],
    "string": [
        "string"
    ],
    "strings": [
        "string"
    ],
    "strip": [
        "strip"
    ],
    "stripper": [
        "stripper"
    ],
    "striptease": [
        "striptease"
    ],
    "stripteaseuse": [
        "stripteaseur"
    ],
    "stripteaseuses": [
        "stripteaseur"
    ],
    "striures": [
        "striure"
    ],
    "striee": [
        "strie",
        "strier"
    ],
    "striees": [
        "strie",
        "strier"
    ],
    "stroboscope": [
        "stroboscope"
    ],
    "stroboscopique": [
        "stroboscopique"
    ],
    "strontiane": [
        "strontiane"
    ],
    "strontium": [
        "strontium"
    ],
    "strophe": [
        "strophe"
    ],
    "strophes": [
        "strophe"
    ],
    "stropiats": [
        "stropiat"
    ],
    "structura": [
        "structurer"
    ],
    "structuraient": [
        "structurer"
    ],
    "structurait": [
        "structurer"
    ],
    "structural": [
        "structural"
    ],
    "structurale": [
        "structural"
    ],
    "structuralement": [
        "structuralement"
    ],
    "structurales": [
        "structural"
    ],
    "structuralisme": [
        "structuralisme"
    ],
    "structuraliste": [
        "structuraliste"
    ],
    "structuralistes": [
        "structuraliste"
    ],
    "structurant": [
        "structurer"
    ],
    "structurations": [
        "structuration"
    ],
    "structuraux": [
        "structural"
    ],
    "structure": [
        "structurer",
        "structure"
    ],
    "structurel": [
        "structurel"
    ],
    "structurelle": [
        "structurel"
    ],
    "structurellement": [
        "structurellement"
    ],
    "structurels": [
        "structurel"
    ],
    "structurent": [
        "structurer"
    ],
    "structurer": [
        "structurer"
    ],
    "structures": [
        "structurer",
        "structure"
    ],
    "structuree": [
        "structurer",
        "structure"
    ],
    "strudel": [
        "strudel"
    ],
    "strudels": [
        "strudel"
    ],
    "strychnine": [
        "strychnine"
    ],
    "strychnos": [
        "strychnos"
    ],
    "stryges": [
        "stryge"
    ],
    "stuc": [
        "stuc"
    ],
    "stucs": [
        "stuc"
    ],
    "studette": [
        "studette"
    ],
    "studieuse": [
        "studieux"
    ],
    "studieusement": [
        "studieusement"
    ],
    "studieuses": [
        "studieux"
    ],
    "studieux": [
        "studieux"
    ],
    "studio": [
        "studio"
    ],
    "studiolo": [
        "studiolo"
    ],
    "studios": [
        "studio"
    ],
    "stuka": [
        "stuka"
    ],
    "stukas": [
        "stuka"
    ],
    "stup": [
        "stups"
    ],
    "stupas": [
        "stupa"
    ],
    "stupeur": [
        "stupeur"
    ],
    "stupide": [
        "stupide"
    ],
    "stupidement": [
        "stupidement"
    ],
    "stupides": [
        "stupide"
    ],
    "stupidite": [
        "stupidite"
    ],
    "stupidites": [
        "stupidite"
    ],
    "stuporeuse": [
        "stuporeux"
    ],
    "stupre": [
        "stupre"
    ],
    "stups": [
        "stups",
        "stup"
    ],
    "stupefaction": [
        "stupefaction"
    ],
    "stupefait": [
        "stupefait"
    ],
    "stupefaite": [
        "stupefait"
    ],
    "stupefaites": [
        "stupefait"
    ],
    "stupefaits": [
        "stupefait"
    ],
    "stupefia": [
        "stupefier"
    ],
    "stupefiaient": [
        "stupefier"
    ],
    "stupefiait": [
        "stupefier"
    ],
    "stupefiant": [
        "stupefiant",
        "stupefier"
    ],
    "stupefiante": [
        "stupefiant"
    ],
    "stupefiantes": [
        "stupefiant"
    ],
    "stupefiants": [
        "stupefiant"
    ],
    "stupefie": [
        "stupefier"
    ],
    "stupefient": [
        "stupefier"
    ],
    "stupefier": [
        "stupefier"
    ],
    "stupefierait": [
        "stupefier"
    ],
    "stupefiez": [
        "stupefier"
    ],
    "stupefiee": [
        "stupefier"
    ],
    "stupefiees": [
        "stupefier"
    ],
    "stupefies": [
        "stupefier"
    ],
    "stygien": [
        "stygien"
    ],
    "style": [
        "style",
        "styler"
    ],
    "styler": [
        "styler"
    ],
    "styles": [
        "style",
        "styler"
    ],
    "stylet": [
        "stylet"
    ],
    "stylets": [
        "stylet"
    ],
    "stylisa": [
        "styliser"
    ],
    "stylisation": [
        "stylisation"
    ],
    "stylise": [
        "styliser"
    ],
    "stylisme": [
        "stylisme"
    ],
    "styliste": [
        "styliste"
    ],
    "stylistes": [
        "styliste"
    ],
    "stylistique": [
        "stylistique"
    ],
    "stylistiques": [
        "stylistique"
    ],
    "stylisee": [
        "styliser"
    ],
    "stylisees": [
        "styliser"
    ],
    "stylises": [
        "styliser"
    ],
    "stylite": [
        "stylite"
    ],
    "stylo": [
        "stylo"
    ],
    "stylobille": [
        "stylobille"
    ],
    "stylographe": [
        "stylographe"
    ],
    "stylographes": [
        "stylographe"
    ],
    "stylomine": [
        "stylomine"
    ],
    "stylos": [
        "stylo"
    ],
    "styloide": [
        "styloide"
    ],
    "stylee": [
        "style",
        "styler"
    ],
    "stylees": [
        "style",
        "styler"
    ],
    "styrax": [
        "styrax"
    ],
    "styrene": [
        "styrene"
    ],
    "stele": [
        "stele"
    ],
    "steles": [
        "stele"
    ],
    "stere": [
        "stere"
    ],
    "steres": [
        "stere"
    ],
    "stearate": [
        "stearate"
    ],
    "stearique": [
        "stearique"
    ],
    "steatopyges": [
        "steatopyge"
    ],
    "stegosaure": [
        "stegosaure"
    ],
    "steno": [
        "steno"
    ],
    "stenodactylo": [
        "stenodactylo"
    ],
    "stenodactylographie": [
        "stenodactylographie"
    ],
    "stenographe": [
        "stenographe"
    ],
    "stenographiai": [
        "stenographier"
    ],
    "stenographie": [
        "stenographie"
    ],
    "stenographique": [
        "stenographique"
    ],
    "stenographiques": [
        "stenographique"
    ],
    "stenope": [
        "stenope"
    ],
    "stenopes": [
        "stenope"
    ],
    "stenos": [
        "steno"
    ],
    "stenose": [
        "stenose"
    ],
    "stenotype": [
        "stenotype"
    ],
    "stenotypiste": [
        "stenotypiste"
    ],
    "stenotypistes": [
        "stenotypiste"
    ],
    "stephanois": [
        "stephanois"
    ],
    "sterile": [
        "sterile"
    ],
    "sterilement": [
        "sterilement"
    ],
    "steriles": [
        "sterile"
    ],
    "sterilet": [
        "sterilet"
    ],
    "sterilisa": [
        "steriliser"
    ],
    "sterilisait": [
        "steriliser"
    ],
    "sterilisant": [
        "sterilisant",
        "steriliser"
    ],
    "sterilisante": [
        "sterilisant"
    ],
    "sterilisantes": [
        "sterilisant"
    ],
    "sterilisateur": [
        "sterilisateur"
    ],
    "sterilisation": [
        "sterilisation"
    ],
    "sterilisations": [
        "sterilisation"
    ],
    "sterilise": [
        "steriliser",
        "sterilise"
    ],
    "sterilisent": [
        "steriliser"
    ],
    "steriliser": [
        "steriliser"
    ],
    "sterilisez": [
        "steriliser"
    ],
    "sterilisee": [
        "steriliser",
        "sterilise"
    ],
    "sterilisees": [
        "steriliser",
        "sterilise"
    ],
    "sterilises": [
        "steriliser",
        "sterilise"
    ],
    "sterilite": [
        "sterilite"
    ],
    "steroide": [
        "steroide"
    ],
    "steroides": [
        "steroide"
    ],
    "stereo": [
        "stereo"
    ],
    "stereophonie": [
        "stereophonie"
    ],
    "stereophonique": [
        "stereophonique"
    ],
    "stereos": [
        "stereo"
    ],
    "stereoscope": [
        "stereoscope"
    ],
    "stereoscopie": [
        "stereoscopie"
    ],
    "stereoscopique": [
        "stereoscopique"
    ],
    "stereotype": [
        "stereotyper",
        "stereotype"
    ],
    "stereotyper": [
        "stereotyper"
    ],
    "stereotypes": [
        "stereotyper",
        "stereotype"
    ],
    "stereotypie": [
        "stereotypie"
    ],
    "stereotypee": [
        "stereotyper",
        "stereotype"
    ],
    "stereotypees": [
        "stereotyper",
        "stereotype"
    ],
    "stethoscope": [
        "stethoscope"
    ],
    "stethoscopes": [
        "stethoscope"
    ],
    "su": [
        "savoir",
        "su"
    ],
    "sua": [
        "suer"
    ],
    "suaient": [
        "suer"
    ],
    "suaire": [
        "suaire"
    ],
    "suaires": [
        "suaire"
    ],
    "suais": [
        "suer"
    ],
    "suait": [
        "suer"
    ],
    "suant": [
        "suer",
        "suant"
    ],
    "suante": [
        "suant"
    ],
    "suantes": [
        "suant"
    ],
    "suants": [
        "suant"
    ],
    "suave": [
        "suave"
    ],
    "suavement": [
        "suavement"
    ],
    "suaves": [
        "suave"
    ],
    "suavite": [
        "suavite"
    ],
    "sub": [
        "sub"
    ],
    "subaigue": [
        "subaigu"
    ],
    "subalterne": [
        "subalterne"
    ],
    "subalternes": [
        "subalterne"
    ],
    "subaquatique": [
        "subaquatique"
    ],
    "subatomique": [
        "subatomique"
    ],
    "subatomiques": [
        "subatomique"
    ],
    "subcarpatique": [
        "subcarpatique"
    ],
    "subcellulaire": [
        "subcellulaire"
    ],
    "subconsciemment": [
        "subconsciemment"
    ],
    "subconscient": [
        "subconscient"
    ],
    "subconsciente": [
        "subconscient"
    ],
    "subconscientes": [
        "subconscient"
    ],
    "subconscients": [
        "subconscient"
    ],
    "subculture": [
        "subculture"
    ],
    "subdivisa": [
        "subdiviser"
    ],
    "subdivisaient": [
        "subdiviser"
    ],
    "subdivisait": [
        "subdiviser"
    ],
    "subdivisent": [
        "subdiviser"
    ],
    "subdivision": [
        "subdivision"
    ],
    "subdivisions": [
        "subdivision"
    ],
    "subdivise": [
        "subdiviser"
    ],
    "subdivisee": [
        "subdiviser"
    ],
    "subdivises": [
        "subdiviser"
    ],
    "subduction": [
        "subduction"
    ],
    "suber": [
        "suber"
    ],
    "subi": [
        "subir"
    ],
    "subie": [
        "subir"
    ],
    "subies": [
        "subir"
    ],
    "subir": [
        "subir"
    ],
    "subira": [
        "subir"
    ],
    "subirai": [
        "subir"
    ],
    "subiraient": [
        "subir"
    ],
    "subirais": [
        "subir"
    ],
    "subirait": [
        "subir"
    ],
    "subiras": [
        "subir"
    ],
    "subirent": [
        "subir"
    ],
    "subirez": [
        "subir"
    ],
    "subirions": [
        "subir"
    ],
    "subirons": [
        "subir"
    ],
    "subiront": [
        "subir"
    ],
    "subis": [
        "subir"
    ],
    "subissaient": [
        "subir"
    ],
    "subissais": [
        "subir"
    ],
    "subissait": [
        "subir"
    ],
    "subissant": [
        "subir"
    ],
    "subisse": [
        "subir"
    ],
    "subissent": [
        "subir"
    ],
    "subisses": [
        "subir"
    ],
    "subissez": [
        "subir"
    ],
    "subissiez": [
        "subir"
    ],
    "subissions": [
        "subir"
    ],
    "subissons": [
        "subir"
    ],
    "subit": [
        "subit",
        "subir"
    ],
    "subite": [
        "subit"
    ],
    "subitement": [
        "subitement"
    ],
    "subites": [
        "subit",
        "subir"
    ],
    "subito": [
        "subito"
    ],
    "subits": [
        "subit"
    ],
    "subjectif": [
        "subjectif"
    ],
    "subjectifs": [
        "subjectif"
    ],
    "subjective": [
        "subjectif",
        "subjectiver"
    ],
    "subjectivement": [
        "subjectivement"
    ],
    "subjectives": [
        "subjectif"
    ],
    "subjectivisme": [
        "subjectivisme"
    ],
    "subjectiviste": [
        "subjectiviste"
    ],
    "subjectivite": [
        "subjectivite"
    ],
    "subjonctif": [
        "subjonctif"
    ],
    "subjonctifs": [
        "subjonctif"
    ],
    "subjugation": [
        "subjugation"
    ],
    "subjugua": [
        "subjuguer"
    ],
    "subjuguaient": [
        "subjuguer"
    ],
    "subjuguait": [
        "subjuguer"
    ],
    "subjuguant": [
        "subjuguer"
    ],
    "subjugue": [
        "subjuguer"
    ],
    "subjuguer": [
        "subjuguer"
    ],
    "subjuguerais": [
        "subjuguer"
    ],
    "subjuguerait": [
        "subjuguer"
    ],
    "subjugues": [
        "subjuguer"
    ],
    "subjuguee": [
        "subjuguer"
    ],
    "subjuguees": [
        "subjuguer"
    ],
    "sublimable": [
        "sublimable"
    ],
    "sublimais": [
        "sublimer"
    ],
    "sublimait": [
        "sublimer"
    ],
    "sublimant": [
        "sublimer"
    ],
    "sublimation": [
        "sublimation"
    ],
    "sublimations": [
        "sublimation"
    ],
    "sublime": [
        "sublime",
        "sublimer"
    ],
    "sublimement": [
        "sublimement"
    ],
    "subliment": [
        "sublimer"
    ],
    "sublimer": [
        "sublimer"
    ],
    "sublimes": [
        "sublime",
        "sublimer"
    ],
    "subliminal": [
        "subliminal"
    ],
    "subliminale": [
        "subliminal"
    ],
    "subliminales": [
        "subliminal"
    ],
    "subliminaux": [
        "subliminal"
    ],
    "sublimissime": [
        "sublimissime"
    ],
    "sublimite": [
        "sublimite"
    ],
    "sublimites": [
        "sublimite"
    ],
    "sublimee": [
        "sublimer"
    ],
    "sublimees": [
        "sublimer"
    ],
    "sublingual": [
        "sublingual"
    ],
    "sublinguaux": [
        "sublingual"
    ],
    "sublunaire": [
        "sublunaire"
    ],
    "sublunaires": [
        "sublunaire"
    ],
    "submerge": [
        "submerge",
        "submerger"
    ],
    "submergea": [
        "submerger"
    ],
    "submergeaient": [
        "submerger"
    ],
    "submergeait": [
        "submerger"
    ],
    "submergeant": [
        "submerger"
    ],
    "submergent": [
        "submerger"
    ],
    "submerger": [
        "submerger"
    ],
    "submergera": [
        "submerger"
    ],
    "submergerait": [
        "submerger"
    ],
    "submergeat": [
        "submerger"
    ],
    "submergerent": [
        "submerger"
    ],
    "submergee": [
        "submerge",
        "submerger"
    ],
    "submergees": [
        "submerge",
        "submerger"
    ],
    "submerges": [
        "submerge",
        "submerger"
    ],
    "submersible": [
        "submersible"
    ],
    "submersibles": [
        "submersible"
    ],
    "submersion": [
        "submersion"
    ],
    "subodora": [
        "subodorer"
    ],
    "subodorais": [
        "subodorer"
    ],
    "subodorait": [
        "subodorer"
    ],
    "subodorant": [
        "subodorer"
    ],
    "subodore": [
        "subodorer"
    ],
    "subodorent": [
        "subodorer"
    ],
    "subodorer": [
        "subodorer"
    ],
    "subodorerent": [
        "subodorer"
    ],
    "subodores": [
        "subodorer"
    ],
    "suborbitale": [
        "suborbital"
    ],
    "subordination": [
        "subordination"
    ],
    "subordonnaient": [
        "subordonner"
    ],
    "subordonnais": [
        "subordonner"
    ],
    "subordonnant": [
        "subordonner"
    ],
    "subordonne": [
        "subordonne",
        "subordonner"
    ],
    "subordonner": [
        "subordonner"
    ],
    "subordonnee": [
        "subordonnee",
        "subordonne",
        "subordonner"
    ],
    "subordonnees": [
        "subordonnee",
        "subordonne",
        "subordonner"
    ],
    "subordonnes": [
        "subordonne",
        "subordonner"
    ],
    "subornation": [
        "subornation"
    ],
    "suborner": [
        "suborner"
    ],
    "suborneur": [
        "suborneur"
    ],
    "suborneurs": [
        "suborneur"
    ],
    "suborne": [
        "suborner"
    ],
    "subornee": [
        "suborner"
    ],
    "subornes": [
        "suborner"
    ],
    "subreptice": [
        "subreptice"
    ],
    "subrepticement": [
        "subrepticement"
    ],
    "subreptices": [
        "subreptice"
    ],
    "subrogation": [
        "subrogation"
    ],
    "subroge": [
        "subroger"
    ],
    "subrecargue": [
        "subrecargue"
    ],
    "subsaharienne": [
        "subsaharien"
    ],
    "subside": [
        "subside"
    ],
    "subsides": [
        "subside"
    ],
    "subsidiaire": [
        "subsidiaire"
    ],
    "subsidiairement": [
        "subsidiairement"
    ],
    "subsidiaires": [
        "subsidiaire"
    ],
    "subsista": [
        "subsister"
    ],
    "subsistaient": [
        "subsister"
    ],
    "subsistait": [
        "subsister"
    ],
    "subsistance": [
        "subsistance"
    ],
    "subsistances": [
        "subsistance"
    ],
    "subsistant": [
        "subsister",
        "subsistant"
    ],
    "subsistantes": [
        "subsistant"
    ],
    "subsistants": [
        "subsistant"
    ],
    "subsiste": [
        "subsister"
    ],
    "subsistent": [
        "subsister"
    ],
    "subsister": [
        "subsister"
    ],
    "subsistera": [
        "subsister"
    ],
    "subsisteraient": [
        "subsister"
    ],
    "subsisterait": [
        "subsister"
    ],
    "subsisteront": [
        "subsister"
    ],
    "subsistions": [
        "subsister"
    ],
    "subsistons": [
        "subsister"
    ],
    "subsistames": [
        "subsister"
    ],
    "subsistat": [
        "subsister"
    ],
    "subsisterent": [
        "subsister"
    ],
    "subsonique": [
        "subsonique"
    ],
    "substance": [
        "substance"
    ],
    "substances": [
        "substance"
    ],
    "substantiel": [
        "substantiel"
    ],
    "substantielle": [
        "substantiel"
    ],
    "substantiellement": [
        "substantiellement"
    ],
    "substantielles": [
        "substantiel"
    ],
    "substantiels": [
        "substantiel"
    ],
    "substantif": [
        "substantif"
    ],
    "substantifique": [
        "substantifique"
    ],
    "substantifs": [
        "substantif"
    ],
    "substitua": [
        "substituer"
    ],
    "substituai": [
        "substituer"
    ],
    "substituaient": [
        "substituer"
    ],
    "substituait": [
        "substituer"
    ],
    "substituant": [
        "substituer"
    ],
    "substitue": [
        "substituer"
    ],
    "substituent": [
        "substituer"
    ],
    "substituer": [
        "substituer"
    ],
    "substituerait": [
        "substituer"
    ],
    "substituerez": [
        "substituer"
    ],
    "substituez": [
        "substituer"
    ],
    "substituons": [
        "substituer"
    ],
    "substitut": [
        "substitut"
    ],
    "substitution": [
        "substitution"
    ],
    "substitutions": [
        "substitution"
    ],
    "substituts": [
        "substitut"
    ],
    "substituees": [
        "substituer"
    ],
    "substitues": [
        "substituer"
    ],
    "substrat": [
        "substrat"
    ],
    "substratum": [
        "substratum"
    ],
    "substruction": [
        "substruction"
    ],
    "subsequemment": [
        "subsequemment"
    ],
    "subsequent": [
        "subsequent"
    ],
    "subsequente": [
        "subsequent"
    ],
    "subsequentes": [
        "subsequent"
    ],
    "subsequents": [
        "subsequent"
    ],
    "subterfuge": [
        "subterfuge"
    ],
    "subterfuges": [
        "subterfuge"
    ],
    "subtil": [
        "subtil"
    ],
    "subtile": [
        "subtil"
    ],
    "subtilement": [
        "subtilement"
    ],
    "subtiles": [
        "subtil"
    ],
    "subtilisa": [
        "subtiliser"
    ],
    "subtilisait": [
        "subtiliser"
    ],
    "subtilisant": [
        "subtiliser"
    ],
    "subtilisassent": [
        "subtiliser"
    ],
    "subtilise": [
        "subtiliser"
    ],
    "subtiliser": [
        "subtiliser"
    ],
    "subtilisera": [
        "subtiliser"
    ],
    "subtilisee": [
        "subtiliser"
    ],
    "subtilisees": [
        "subtiliser"
    ],
    "subtilises": [
        "subtiliser"
    ],
    "subtilite": [
        "subtilite"
    ],
    "subtilites": [
        "subtilite"
    ],
    "subtils": [
        "subtil"
    ],
    "subtropical": [
        "subtropical"
    ],
    "subtropicale": [
        "subtropical"
    ],
    "subtropicales": [
        "subtropical"
    ],
    "suburbain": [
        "suburbain"
    ],
    "suburbaine": [
        "suburbain"
    ],
    "suburbaines": [
        "suburbain"
    ],
    "suburbains": [
        "suburbain"
    ],
    "subvenant": [
        "subvenir"
    ],
    "subvenez": [
        "subvenir"
    ],
    "subvenir": [
        "subvenir"
    ],
    "subvention": [
        "subvention"
    ],
    "subventionnant": [
        "subventionner"
    ],
    "subventionne": [
        "subventionne",
        "subventionner"
    ],
    "subventionnent": [
        "subventionner"
    ],
    "subventionner": [
        "subventionner"
    ],
    "subventionnera": [
        "subventionner"
    ],
    "subventionnee": [
        "subventionne",
        "subventionner"
    ],
    "subventionnees": [
        "subventionne"
    ],
    "subventionnes": [
        "subventionne",
        "subventionner"
    ],
    "subventions": [
        "subvention"
    ],
    "subvenu": [
        "subvenir"
    ],
    "subversif": [
        "subversif"
    ],
    "subversifs": [
        "subversif"
    ],
    "subversion": [
        "subversion"
    ],
    "subversions": [
        "subversion"
    ],
    "subversive": [
        "subversif"
    ],
    "subversives": [
        "subversive",
        "subversif"
    ],
    "subvertir": [
        "subvertir"
    ],
    "subviendra": [
        "subvenir"
    ],
    "subviendrait": [
        "subvenir"
    ],
    "subviens": [
        "subvenir"
    ],
    "subvient": [
        "subvenir"
    ],
    "suc": [
        "suc"
    ],
    "successeur": [
        "successeur"
    ],
    "successeurs": [
        "successeur"
    ],
    "successibles": [
        "successible"
    ],
    "successif": [
        "successif"
    ],
    "successifs": [
        "successif"
    ],
    "succession": [
        "succession"
    ],
    "successions": [
        "succession"
    ],
    "successive": [
        "successif"
    ],
    "successivement": [
        "successivement"
    ],
    "successives": [
        "successif"
    ],
    "successoral": [
        "successoral"
    ],
    "successorale": [
        "successoral"
    ],
    "succinct": [
        "succinct"
    ],
    "succincte": [
        "succinct"
    ],
    "succinctement": [
        "succinctement"
    ],
    "succinctes": [
        "succinct"
    ],
    "succion": [
        "succion"
    ],
    "succions": [
        "succion"
    ],
    "succomba": [
        "succomber"
    ],
    "succombai": [
        "succomber"
    ],
    "succombaient": [
        "succomber"
    ],
    "succombais": [
        "succomber"
    ],
    "succombait": [
        "succomber"
    ],
    "succombant": [
        "succomber"
    ],
    "succombe": [
        "succomber"
    ],
    "succombent": [
        "succomber"
    ],
    "succomber": [
        "succomber"
    ],
    "succombera": [
        "succomber"
    ],
    "succomberai": [
        "succomber"
    ],
    "succomberaient": [
        "succomber"
    ],
    "succomberais": [
        "succomber"
    ],
    "succomberait": [
        "succomber"
    ],
    "succomberont": [
        "succomber"
    ],
    "succombes": [
        "succomber"
    ],
    "succombez": [
        "succomber"
    ],
    "succombions": [
        "succomber"
    ],
    "succomberent": [
        "succomber"
    ],
    "succube": [
        "succube"
    ],
    "succubes": [
        "succube"
    ],
    "succulence": [
        "succulence"
    ],
    "succulent": [
        "succulent"
    ],
    "succulente": [
        "succulent"
    ],
    "succulentes": [
        "succulent"
    ],
    "succulents": [
        "succulent"
    ],
    "succursale": [
        "succursale"
    ],
    "succursales": [
        "succursale"
    ],
    "succede": [
        "succeder"
    ],
    "succedent": [
        "succeder"
    ],
    "succes": [
        "succes"
    ],
    "succeda": [
        "succeder"
    ],
    "succedaient": [
        "succeder"
    ],
    "succedait": [
        "succeder"
    ],
    "succedant": [
        "succeder"
    ],
    "succedane": [
        "succedane"
    ],
    "succedanes": [
        "succedane"
    ],
    "succedassent": [
        "succeder"
    ],
    "succeder": [
        "succeder"
    ],
    "succedera": [
        "succeder"
    ],
    "succederai": [
        "succeder"
    ],
    "succederaient": [
        "succeder"
    ],
    "succederait": [
        "succeder"
    ],
    "succederas": [
        "succeder"
    ],
    "succederez": [
        "succeder"
    ],
    "succederiez": [
        "succeder"
    ],
    "succederont": [
        "succeder"
    ],
    "succedions": [
        "succeder"
    ],
    "succedames": [
        "succeder"
    ],
    "succedat": [
        "succeder"
    ],
    "succederent": [
        "succeder"
    ],
    "succedees": [
        "succeder"
    ],
    "suce": [
        "sucer"
    ],
    "sucent": [
        "sucer"
    ],
    "sucer": [
        "sucer"
    ],
    "sucera": [
        "sucer"
    ],
    "sucerai": [
        "sucer"
    ],
    "suceraient": [
        "sucer"
    ],
    "sucerais": [
        "sucer"
    ],
    "sucerait": [
        "sucer"
    ],
    "suces": [
        "sucer"
    ],
    "sucette": [
        "sucette"
    ],
    "sucettes": [
        "sucette"
    ],
    "suceur": [
        "suceur"
    ],
    "suceurs": [
        "suceur"
    ],
    "suceuse": [
        "suceur"
    ],
    "suceuses": [
        "suceur"
    ],
    "sucez": [
        "sucer"
    ],
    "sucra": [
        "sucrer"
    ],
    "sucrait": [
        "sucrer"
    ],
    "sucrant": [
        "sucrer"
    ],
    "sucre": [
        "sucrer",
        "sucre"
    ],
    "sucrent": [
        "sucrer"
    ],
    "sucrer": [
        "sucrer"
    ],
    "sucrerait": [
        "sucrer"
    ],
    "sucrerie": [
        "sucrerie"
    ],
    "sucreries": [
        "sucrerie"
    ],
    "sucres": [
        "sucrer",
        "sucre"
    ],
    "sucrette": [
        "sucrette"
    ],
    "sucrettes": [
        "sucrette"
    ],
    "sucrier": [
        "sucrier"
    ],
    "sucriers": [
        "sucrier"
    ],
    "sucrins": [
        "sucrin"
    ],
    "sucriere": [
        "sucrier"
    ],
    "sucrieres": [
        "sucrier"
    ],
    "sucree": [
        "sucrer",
        "sucre"
    ],
    "sucrees": [
        "sucrer",
        "sucre"
    ],
    "sucs": [
        "suc"
    ],
    "sucerent": [
        "sucer"
    ],
    "sucee": [
        "sucer"
    ],
    "sucees": [
        "sucer"
    ],
    "sud": [
        "sud"
    ],
    "sudation": [
        "sudation"
    ],
    "sudatoires": [
        "sudatoire"
    ],
    "sudiste": [
        "sudiste"
    ],
    "sudistes": [
        "sudiste"
    ],
    "sudoripare": [
        "sudoripare"
    ],
    "sudoripares": [
        "sudoripare"
    ],
    "sudete": [
        "sudete"
    ],
    "sudetes": [
        "sudete"
    ],
    "sue": [
        "savoir",
        "su",
        "suer"
    ],
    "suent": [
        "suer"
    ],
    "suer": [
        "suer"
    ],
    "suerai": [
        "suer"
    ],
    "suerais": [
        "suer"
    ],
    "suerait": [
        "suer"
    ],
    "suerte": [
        "suerte"
    ],
    "sues": [
        "savoir",
        "su",
        "sue",
        "suer"
    ],
    "sueur": [
        "sueur"
    ],
    "sueurs": [
        "sueur"
    ],
    "suez": [
        "suer"
    ],
    "suffi": [
        "suffire"
    ],
    "sufficit": [
        "sufficit"
    ],
    "suffira": [
        "suffire"
    ],
    "suffirai": [
        "suffire"
    ],
    "suffiraient": [
        "suffire"
    ],
    "suffirais": [
        "suffire"
    ],
    "suffirait": [
        "suffire"
    ],
    "suffire": [
        "suffire"
    ],
    "suffirent": [
        "suffire"
    ],
    "suffiront": [
        "suffire"
    ],
    "suffis": [
        "suffire"
    ],
    "suffisaient": [
        "suffire"
    ],
    "suffisais": [
        "suffire"
    ],
    "suffisait": [
        "suffire"
    ],
    "suffisamment": [
        "suffisamment"
    ],
    "suffisance": [
        "suffisance"
    ],
    "suffisances": [
        "suffisance"
    ],
    "suffisant": [
        "suffisant",
        "suffire"
    ],
    "suffisante": [
        "suffisant"
    ],
    "suffisantes": [
        "suffisant"
    ],
    "suffisants": [
        "suffisant"
    ],
    "suffise": [
        "suffire"
    ],
    "suffisent": [
        "suffire"
    ],
    "suffisez": [
        "suffire"
    ],
    "suffisions": [
        "suffire"
    ],
    "suffisons": [
        "suffire"
    ],
    "suffit": [
        "suffire"
    ],
    "suffixes": [
        "suffixe",
        "suffix"
    ],
    "suffocant": [
        "suffocant"
    ],
    "suffocante": [
        "suffocant"
    ],
    "suffocantes": [
        "suffocant"
    ],
    "suffocants": [
        "suffocant"
    ],
    "suffocation": [
        "suffocation"
    ],
    "suffocations": [
        "suffocation"
    ],
    "suffoqua": [
        "suffoquer"
    ],
    "suffoquai": [
        "suffoquer"
    ],
    "suffoquaient": [
        "suffoquer"
    ],
    "suffoquais": [
        "suffoquer"
    ],
    "suffoquait": [
        "suffoquer"
    ],
    "suffoquant": [
        "suffoquer"
    ],
    "suffoque": [
        "suffoquer"
    ],
    "suffoquent": [
        "suffoquer"
    ],
    "suffoquer": [
        "suffoquer"
    ],
    "suffoquera": [
        "suffoquer"
    ],
    "suffoquerait": [
        "suffoquer"
    ],
    "suffoqueront": [
        "suffoquer"
    ],
    "suffoquez": [
        "suffoquer"
    ],
    "suffoquions": [
        "suffoquer"
    ],
    "suffoquons": [
        "suffoquer"
    ],
    "suffoquerent": [
        "suffoquer"
    ],
    "suffoquee": [
        "suffoquer"
    ],
    "suffoques": [
        "suffoquer"
    ],
    "suffrage": [
        "suffrage"
    ],
    "suffrages": [
        "suffrage"
    ],
    "suffragette": [
        "suffragette"
    ],
    "suffragettes": [
        "suffragette"
    ],
    "suffete": [
        "suffete"
    ],
    "suggestibilite": [
        "suggestibilite"
    ],
    "suggestif": [
        "suggestif"
    ],
    "suggestifs": [
        "suggestif"
    ],
    "suggestion": [
        "suggestion"
    ],
    "suggestionner": [
        "suggestionner"
    ],
    "suggestionne": [
        "suggestionner"
    ],
    "suggestions": [
        "suggestion"
    ],
    "suggestive": [
        "suggestif"
    ],
    "suggestives": [
        "suggestif"
    ],
    "suggestivite": [
        "suggestivite"
    ],
    "suggere": [
        "suggerer"
    ],
    "suggerent": [
        "suggerer"
    ],
    "suggeres": [
        "suggerer"
    ],
    "suggera": [
        "suggerer"
    ],
    "suggerai": [
        "suggerer"
    ],
    "suggeraient": [
        "suggerer"
    ],
    "suggerais": [
        "suggerer"
    ],
    "suggerait": [
        "suggerer"
    ],
    "suggerant": [
        "suggerer"
    ],
    "suggerer": [
        "suggerer"
    ],
    "suggerera": [
        "suggerer"
    ],
    "suggererai": [
        "suggerer"
    ],
    "suggererais": [
        "suggerer"
    ],
    "suggererait": [
        "suggerer"
    ],
    "suggerez": [
        "suggerer"
    ],
    "suggeriez": [
        "suggerer"
    ],
    "suggerions": [
        "suggerer"
    ],
    "suggerons": [
        "suggerer"
    ],
    "suggerat": [
        "suggerer"
    ],
    "suggererent": [
        "suggerer"
    ],
    "suggeree": [
        "suggerer"
    ],
    "suggerees": [
        "suggerer"
    ],
    "sui": [
        "sui"
    ],
    "suicida": [
        "suicider"
    ],
    "suicidaient": [
        "suicider"
    ],
    "suicidaire": [
        "suicidaire"
    ],
    "suicidaires": [
        "suicidaire"
    ],
    "suicidait": [
        "suicider"
    ],
    "suicidant": [
        "suicidant"
    ],
    "suicidants": [
        "suicidant"
    ],
    "suicide": [
        "suicider",
        "suicide"
    ],
    "suicident": [
        "suicider"
    ],
    "suicider": [
        "suicider"
    ],
    "suicidera": [
        "suicider"
    ],
    "suiciderai": [
        "suicider"
    ],
    "suiciderais": [
        "suicider"
    ],
    "suiciderait": [
        "suicider"
    ],
    "suiciderez": [
        "suicider"
    ],
    "suicideriez": [
        "suicider"
    ],
    "suicides": [
        "suicider",
        "suicide"
    ],
    "suicidez": [
        "suicider"
    ],
    "suicidiez": [
        "suicider"
    ],
    "suicidons": [
        "suicider"
    ],
    "suicidat": [
        "suicider"
    ],
    "suiciderent": [
        "suicider"
    ],
    "suicidee": [
        "suicider",
        "suicide"
    ],
    "suicidees": [
        "suicider",
        "suicide"
    ],
    "suie": [
        "suie"
    ],
    "suies": [
        "suie"
    ],
    "suif": [
        "suif"
    ],
    "suifer": [
        "suifer"
    ],
    "suiffard": [
        "suiffard"
    ],
    "suiffeuses": [
        "suiffeux"
    ],
    "suiffeux": [
        "suiffeux"
    ],
    "suiffe": [
        "suiffer"
    ],
    "suiffee": [
        "suiffer"
    ],
    "suiffes": [
        "suiffer"
    ],
    "suifes": [
        "suifer"
    ],
    "suint": [
        "suint"
    ],
    "suinta": [
        "suinter"
    ],
    "suintaient": [
        "suinter"
    ],
    "suintait": [
        "suinter"
    ],
    "suintant": [
        "suintant",
        "suinter"
    ],
    "suintante": [
        "suintant"
    ],
    "suintantes": [
        "suintant"
    ],
    "suintants": [
        "suintant"
    ],
    "suinte": [
        "suinter"
    ],
    "suintement": [
        "suintement"
    ],
    "suintements": [
        "suintement"
    ],
    "suintent": [
        "suinter"
    ],
    "suinter": [
        "suinter"
    ],
    "suis": [
        "etre",
        "suivre"
    ],
    "suisse": [
        "suisse"
    ],
    "suisses": [
        "suisse"
    ],
    "suissesse": [
        "suisse"
    ],
    "suissesses": [
        "suisse"
    ],
    "suit": [
        "suivre"
    ],
    "suite": [
        "suite"
    ],
    "suites": [
        "suit",
        "suite"
    ],
    "suitee": [
        "suitee"
    ],
    "suiv": [
        "suiv"
    ],
    "suivaient": [
        "suivre"
    ],
    "suivais": [
        "suivre"
    ],
    "suivait": [
        "suivre"
    ],
    "suivant": [
        "suivre",
        "suivant"
    ],
    "suivante": [
        "suivant"
    ],
    "suivantes": [
        "suivant"
    ],
    "suivants": [
        "suivant"
    ],
    "suive": [
        "suivre"
    ],
    "suivent": [
        "suivre"
    ],
    "suives": [
        "suivre"
    ],
    "suiveur": [
        "suiveur"
    ],
    "suiveurs": [
        "suiveur"
    ],
    "suiveuse": [
        "suiveur"
    ],
    "suiveuses": [
        "suiveur"
    ],
    "suivez": [
        "suivre"
    ],
    "suivi": [
        "suivi",
        "suivre"
    ],
    "suivie": [
        "suivi",
        "suivre"
    ],
    "suivies": [
        "suivi",
        "suivre"
    ],
    "suiviez": [
        "suivre"
    ],
    "suivions": [
        "suivre"
    ],
    "suivirent": [
        "suivre"
    ],
    "suivis": [
        "suivi",
        "suivre"
    ],
    "suivissent": [
        "suivre"
    ],
    "suivistes": [
        "suiviste"
    ],
    "suivit": [
        "suivre"
    ],
    "suivons": [
        "suivre"
    ],
    "suivra": [
        "suivre"
    ],
    "suivrai": [
        "suivre"
    ],
    "suivraient": [
        "suivre"
    ],
    "suivrais": [
        "suivre"
    ],
    "suivrait": [
        "suivre"
    ],
    "suivras": [
        "suivre"
    ],
    "suivre": [
        "suivre"
    ],
    "suivrez": [
        "suivre"
    ],
    "suivriez": [
        "suivre"
    ],
    "suivrions": [
        "suivre"
    ],
    "suivrons": [
        "suivre"
    ],
    "suivront": [
        "suivre"
    ],
    "suivimes": [
        "suivre"
    ],
    "sujet": [
        "sujet"
    ],
    "sujets": [
        "sujet"
    ],
    "sujette": [
        "sujet",
        "sujette"
    ],
    "sujettes": [
        "sujet",
        "sujette"
    ],
    "sujetion": [
        "sujetion"
    ],
    "sujetions": [
        "sujetion"
    ],
    "sulfamide": [
        "sulfamide"
    ],
    "sulfamides": [
        "sulfamide"
    ],
    "sulfatages": [
        "sulfatage"
    ],
    "sulfatant": [
        "sulfater"
    ],
    "sulfate": [
        "sulfater",
        "sulfate"
    ],
    "sulfater": [
        "sulfater"
    ],
    "sulfates": [
        "sulfate"
    ],
    "sulfateuse": [
        "sulfateur"
    ],
    "sulfateuses": [
        "sulfateur"
    ],
    "sulfatees": [
        "sulfate"
    ],
    "sulfhydrique": [
        "sulfhydrique"
    ],
    "sulfite": [
        "sulfite"
    ],
    "sulfonate": [
        "sulfonate"
    ],
    "sulfonique": [
        "sulfonique"
    ],
    "sulfonee": [
        "sulfoner"
    ],
    "sulfones": [
        "sulfoner"
    ],
    "sulfure": [
        "sulfure"
    ],
    "sulfures": [
        "sulfure"
    ],
    "sulfureuse": [
        "sulfureux"
    ],
    "sulfureuses": [
        "sulfureux"
    ],
    "sulfureux": [
        "sulfureux"
    ],
    "sulfurique": [
        "sulfurique"
    ],
    "sulfurise": [
        "sulfurise"
    ],
    "sulfuree": [
        "sulfure"
    ],
    "sulky": [
        "sulky"
    ],
    "sulpicien": [
        "sulpicien"
    ],
    "sulpicienne": [
        "sulpicien"
    ],
    "sulpiciennes": [
        "sulpicien"
    ],
    "sultan": [
        "sultan"
    ],
    "sultanat": [
        "sultanat"
    ],
    "sultane": [
        "sultane"
    ],
    "sultanes": [
        "sultan"
    ],
    "sultans": [
        "sultan"
    ],
    "sumac": [
        "sumac"
    ],
    "summum": [
        "summum"
    ],
    "sumo": [
        "sumo"
    ],
    "sumerien": [
        "sumerien"
    ],
    "sunlight": [
        "sunlight"
    ],
    "sunlights": [
        "sunlight"
    ],
    "sunna": [
        "sunna"
    ],
    "sunnites": [
        "sunnite"
    ],
    "suons": [
        "suer"
    ],
    "super": [
        "super"
    ],
    "superbe": [
        "superbe"
    ],
    "superbement": [
        "superbement"
    ],
    "superbes": [
        "superbe"
    ],
    "supercalculateur": [
        "supercalculateur"
    ],
    "supercarburant": [
        "supercarburant"
    ],
    "superchampion": [
        "superchampion"
    ],
    "superchampions": [
        "superchampion"
    ],
    "supercherie": [
        "supercherie"
    ],
    "supercheries": [
        "supercherie"
    ],
    "superfamille": [
        "superfamille"
    ],
    "superficialite": [
        "superficialite"
    ],
    "superficialites": [
        "superficialite"
    ],
    "superficie": [
        "superficie"
    ],
    "superficiel": [
        "superficiel"
    ],
    "superficielle": [
        "superficiel"
    ],
    "superficiellement": [
        "superficiellement"
    ],
    "superficielles": [
        "superficiel"
    ],
    "superficiels": [
        "superficiel"
    ],
    "superfin": [
        "superfin"
    ],
    "superflu": [
        "superflu"
    ],
    "superflue": [
        "superflu"
    ],
    "superflues": [
        "superflu"
    ],
    "superfluite": [
        "superfluite"
    ],
    "superfluites": [
        "superfluite"
    ],
    "superflus": [
        "superflu"
    ],
    "superforteresses": [
        "superforteresse"
    ],
    "superfetatoire": [
        "superfetatoire"
    ],
    "superfetatoires": [
        "superfetatoire"
    ],
    "supergrand": [
        "supergrand"
    ],
    "superintendant": [
        "superintendant"
    ],
    "superintendante": [
        "superintendante"
    ],
    "superintendants": [
        "superintendant"
    ],
    "superlatif": [
        "superlatif"
    ],
    "superlatifs": [
        "superlatif"
    ],
    "superlative": [
        "superlatif"
    ],
    "superlativement": [
        "superlativement"
    ],
    "superman": [
        "superman"
    ],
    "supermarche": [
        "supermarche"
    ],
    "supermarches": [
        "supermarche"
    ],
    "supermen": [
        "superman"
    ],
    "supernova": [
        "supernova"
    ],
    "supernovas": [
        "supernova"
    ],
    "superordinateur": [
        "superordinateur"
    ],
    "superphosphates": [
        "superphosphate"
    ],
    "superposa": [
        "superposer"
    ],
    "superposable": [
        "superposable"
    ],
    "superposables": [
        "superposable"
    ],
    "superposaient": [
        "superposer"
    ],
    "superposait": [
        "superposer"
    ],
    "superposant": [
        "superposer"
    ],
    "superpose": [
        "superposer",
        "superpose"
    ],
    "superposent": [
        "superposer"
    ],
    "superposer": [
        "superposer"
    ],
    "superposez": [
        "superposer"
    ],
    "superposition": [
        "superposition"
    ],
    "superpositions": [
        "superposition"
    ],
    "superposee": [
        "superposer",
        "superpose"
    ],
    "superposees": [
        "superposer",
        "superpose"
    ],
    "superposes": [
        "superposer",
        "superpose"
    ],
    "superpouvoirs": [
        "superpouvoir"
    ],
    "superproduction": [
        "superproduction"
    ],
    "superproductions": [
        "superproduction"
    ],
    "superpuissance": [
        "superpuissance"
    ],
    "superpuissances": [
        "superpuissance"
    ],
    "superpuissant": [
        "superpuissant"
    ],
    "superpuissante": [
        "superpuissant"
    ],
    "superpuissants": [
        "superpuissant"
    ],
    "supers": [
        "super"
    ],
    "supersonique": [
        "supersonique"
    ],
    "supersoniques": [
        "supersonique"
    ],
    "superstar": [
        "superstar"
    ],
    "superstars": [
        "superstar"
    ],
    "superstitieuse": [
        "superstitieux"
    ],
    "superstitieusement": [
        "superstitieusement"
    ],
    "superstitieuses": [
        "superstitieux"
    ],
    "superstitieux": [
        "superstitieux"
    ],
    "superstition": [
        "superstition"
    ],
    "superstitions": [
        "superstition"
    ],
    "superstructure": [
        "superstructure"
    ],
    "superstructures": [
        "superstructure"
    ],
    "supertanker": [
        "supertanker"
    ],
    "supervisa": [
        "superviser"
    ],
    "supervisais": [
        "superviser"
    ],
    "supervisait": [
        "superviser"
    ],
    "supervisant": [
        "superviser"
    ],
    "supervise": [
        "superviser"
    ],
    "supervisent": [
        "superviser"
    ],
    "superviser": [
        "superviser"
    ],
    "supervisera": [
        "superviser"
    ],
    "superviserai": [
        "superviser"
    ],
    "superviserais": [
        "superviser"
    ],
    "superviserait": [
        "superviser"
    ],
    "superviseras": [
        "superviser"
    ],
    "superviserez": [
        "superviser"
    ],
    "superviserons": [
        "superviser"
    ],
    "superviseront": [
        "superviser"
    ],
    "superviseur": [
        "superviseur"
    ],
    "superviseurs": [
        "superviseur"
    ],
    "supervisez": [
        "superviser"
    ],
    "supervisiez": [
        "superviser"
    ],
    "supervision": [
        "supervision"
    ],
    "supervisions": [
        "supervision"
    ],
    "supervisons": [
        "superviser"
    ],
    "supervisee": [
        "superviser"
    ],
    "supervisees": [
        "superviser"
    ],
    "supervises": [
        "superviser",
        "supervise"
    ],
    "supin": [
        "supin"
    ],
    "supination": [
        "supination"
    ],
    "supplanta": [
        "supplanter"
    ],
    "supplantait": [
        "supplanter"
    ],
    "supplantant": [
        "supplanter"
    ],
    "supplante": [
        "supplanter"
    ],
    "supplantent": [
        "supplanter"
    ],
    "supplanter": [
        "supplanter"
    ],
    "supplantee": [
        "supplanter"
    ],
    "supplia": [
        "supplier"
    ],
    "suppliai": [
        "supplier"
    ],
    "suppliaient": [
        "supplier"
    ],
    "suppliais": [
        "supplier"
    ],
    "suppliait": [
        "supplier"
    ],
    "suppliant": [
        "supplier",
        "suppliant"
    ],
    "suppliante": [
        "suppliant"
    ],
    "suppliantes": [
        "suppliant"
    ],
    "suppliants": [
        "suppliant"
    ],
    "supplication": [
        "supplication"
    ],
    "supplications": [
        "supplication"
    ],
    "supplice": [
        "supplice"
    ],
    "supplices": [
        "supplice"
    ],
    "supplicia": [
        "supplicier"
    ],
    "suppliciant": [
        "suppliciant"
    ],
    "suppliciantes": [
        "suppliciant"
    ],
    "supplicient": [
        "supplicier"
    ],
    "supplicier": [
        "supplicier"
    ],
    "supplicierez": [
        "supplicier"
    ],
    "supplicie": [
        "supplicie",
        "supplicier"
    ],
    "suppliciee": [
        "supplicie"
    ],
    "suppliciees": [
        "supplicie",
        "supplicier"
    ],
    "supplicies": [
        "supplicie",
        "supplicier"
    ],
    "supplie": [
        "supplier"
    ],
    "supplient": [
        "supplier"
    ],
    "supplier": [
        "supplier"
    ],
    "suppliera": [
        "supplier"
    ],
    "supplierai": [
        "supplier"
    ],
    "supplieraient": [
        "supplier"
    ],
    "supplierais": [
        "supplier"
    ],
    "supplierait": [
        "supplier"
    ],
    "supplieras": [
        "supplier"
    ],
    "supplierez": [
        "supplier"
    ],
    "supplieriez": [
        "supplier"
    ],
    "supplieront": [
        "supplier"
    ],
    "supplies": [
        "supplier",
        "supply"
    ],
    "suppliez": [
        "supplier"
    ],
    "supplions": [
        "supplier"
    ],
    "supplique": [
        "supplique"
    ],
    "suppliques": [
        "supplique"
    ],
    "suppliat": [
        "supplier"
    ],
    "suppliee": [
        "supplier"
    ],
    "suppleaient": [
        "suppleer"
    ],
    "suppleait": [
        "suppleer"
    ],
    "suppleance": [
        "suppleance"
    ],
    "suppleant": [
        "suppleer",
        "suppleant"
    ],
    "suppleante": [
        "suppleant"
    ],
    "suppleants": [
        "suppleant"
    ],
    "supplee": [
        "suppleer"
    ],
    "suppleent": [
        "suppleer"
    ],
    "suppleer": [
        "suppleer"
    ],
    "suppleeraient": [
        "suppleer"
    ],
    "suppleerait": [
        "suppleer"
    ],
    "suppleerez": [
        "suppleer"
    ],
    "supplement": [
        "supplement"
    ],
    "supplementaire": [
        "supplementaire"
    ],
    "supplementaires": [
        "supplementaire"
    ],
    "supplementer": [
        "supplementer"
    ],
    "supplements": [
        "supplement"
    ],
    "supplementees": [
        "supplementer"
    ],
    "suppletifs": [
        "suppletif"
    ],
    "suppletive": [
        "suppletif"
    ],
    "support": [
        "support"
    ],
    "supporta": [
        "supporter"
    ],
    "supportable": [
        "supportable"
    ],
    "supportables": [
        "supportable"
    ],
    "supportai": [
        "supporter"
    ],
    "supportaient": [
        "supporter"
    ],
    "supportais": [
        "supporter"
    ],
    "supportait": [
        "supporter"
    ],
    "supportant": [
        "supporter"
    ],
    "supporte": [
        "supporter"
    ],
    "supportent": [
        "supporter"
    ],
    "supporter": [
        "supporter"
    ],
    "supportera": [
        "supporter"
    ],
    "supporterai": [
        "supporter"
    ],
    "supporteraient": [
        "supporter"
    ],
    "supporterais": [
        "supporter"
    ],
    "supporterait": [
        "supporter"
    ],
    "supporteras": [
        "supporter"
    ],
    "supporterez": [
        "supporter"
    ],
    "supporteriez": [
        "supporter"
    ],
    "supporterons": [
        "supporter"
    ],
    "supporteront": [
        "supporter"
    ],
    "supporters": [
        "supporter"
    ],
    "supportes": [
        "supporter"
    ],
    "supporteur": [
        "supporteur"
    ],
    "supportez": [
        "supporter"
    ],
    "supportiez": [
        "supporter"
    ],
    "supportions": [
        "supporter"
    ],
    "supportons": [
        "supporter"
    ],
    "supportrice": [
        "supporteur"
    ],
    "supportrices": [
        "supporteur"
    ],
    "supports": [
        "support"
    ],
    "supportat": [
        "supporter"
    ],
    "supporterent": [
        "supporter"
    ],
    "supportee": [
        "supporter"
    ],
    "supportees": [
        "supporter"
    ],
    "supposa": [
        "supposer"
    ],
    "supposable": [
        "supposable"
    ],
    "supposai": [
        "supposer"
    ],
    "supposaient": [
        "supposer"
    ],
    "supposais": [
        "supposer"
    ],
    "supposait": [
        "supposer"
    ],
    "supposant": [
        "supposer"
    ],
    "suppose": [
        "supposer",
        "suppose"
    ],
    "supposent": [
        "supposer"
    ],
    "supposer": [
        "supposer"
    ],
    "supposera": [
        "supposer"
    ],
    "supposerai": [
        "supposer"
    ],
    "supposerait": [
        "supposer"
    ],
    "supposeront": [
        "supposer"
    ],
    "supposes": [
        "supposer",
        "suppose"
    ],
    "supposez": [
        "supposer"
    ],
    "supposiez": [
        "supposer"
    ],
    "supposions": [
        "supposer"
    ],
    "supposition": [
        "supposition"
    ],
    "suppositions": [
        "supposition"
    ],
    "suppositoire": [
        "suppositoire"
    ],
    "suppositoires": [
        "suppositoire"
    ],
    "supposons": [
        "supposer"
    ],
    "supposames": [
        "supposer"
    ],
    "supposerent": [
        "supposer"
    ],
    "supposee": [
        "supposer",
        "suppose"
    ],
    "supposees": [
        "supposer",
        "suppose"
    ],
    "supposement": [
        "supposement"
    ],
    "suppresseur": [
        "suppresseur"
    ],
    "suppression": [
        "suppression"
    ],
    "suppressions": [
        "suppression"
    ],
    "supprima": [
        "supprimer"
    ],
    "supprimai": [
        "supprimer"
    ],
    "supprimaient": [
        "supprimer"
    ],
    "supprimais": [
        "supprimer"
    ],
    "supprimait": [
        "supprimer"
    ],
    "supprimant": [
        "supprimer"
    ],
    "supprime": [
        "supprimer"
    ],
    "suppriment": [
        "supprimer"
    ],
    "supprimer": [
        "supprimer"
    ],
    "supprimera": [
        "supprimer"
    ],
    "supprimerai": [
        "supprimer"
    ],
    "supprimeraient": [
        "supprimer"
    ],
    "supprimerait": [
        "supprimer"
    ],
    "supprimerons": [
        "supprimer"
    ],
    "supprimez": [
        "supprimer"
    ],
    "supprimons": [
        "supprimer"
    ],
    "supprimat": [
        "supprimer"
    ],
    "supprimee": [
        "supprimer"
    ],
    "supprimees": [
        "supprimer"
    ],
    "supprimes": [
        "supprimer"
    ],
    "suppuraient": [
        "suppurer"
    ],
    "suppurait": [
        "suppurer"
    ],
    "suppurant": [
        "suppurer",
        "suppurant"
    ],
    "suppurante": [
        "suppurant"
    ],
    "suppurantes": [
        "suppurant"
    ],
    "suppuration": [
        "suppuration"
    ],
    "suppurations": [
        "suppuration"
    ],
    "suppure": [
        "suppurer"
    ],
    "suppurent": [
        "suppurer"
    ],
    "suppurer": [
        "suppurer"
    ],
    "suppurerait": [
        "suppurer"
    ],
    "supputa": [
        "supputer"
    ],
    "supputai": [
        "supputer"
    ],
    "supputaient": [
        "supputer"
    ],
    "supputais": [
        "supputer"
    ],
    "supputait": [
        "supputer"
    ],
    "supputant": [
        "supputer"
    ],
    "supputation": [
        "supputation"
    ],
    "supputations": [
        "supputation"
    ],
    "suppute": [
        "supputer"
    ],
    "supputent": [
        "supputer"
    ],
    "supputer": [
        "supputer"
    ],
    "supputees": [
        "supputer"
    ],
    "suppot": [
        "suppot"
    ],
    "suppots": [
        "suppot"
    ],
    "supra": [
        "supra"
    ],
    "supraconducteur": [
        "supraconducteur"
    ],
    "supraconducteurs": [
        "supraconducteur"
    ],
    "supraconductivite": [
        "supraconductivite"
    ],
    "supraconductrice": [
        "supraconducteur"
    ],
    "supranational": [
        "supranational"
    ],
    "supranationales": [
        "supranational"
    ],
    "supranaturel": [
        "supranaturel"
    ],
    "supraterrestre": [
        "supraterrestre"
    ],
    "suprematie": [
        "suprematie"
    ],
    "supreme": [
        "supreme"
    ],
    "supremement": [
        "supremement"
    ],
    "supremes": [
        "supreme"
    ],
    "superette": [
        "superette"
    ],
    "superieur": [
        "superieur"
    ],
    "superieure": [
        "superieur"
    ],
    "superieurement": [
        "superieurement"
    ],
    "superieures": [
        "superieur"
    ],
    "superieurs": [
        "superieur"
    ],
    "superiorite": [
        "superiorite"
    ],
    "superiorites": [
        "superiorite"
    ],
    "sur": [
        "sur"
    ],
    "surabondaient": [
        "surabonder"
    ],
    "surabondamment": [
        "surabondamment"
    ],
    "surabondance": [
        "surabondance"
    ],
    "surabondances": [
        "surabondance"
    ],
    "surabondant": [
        "surabondant"
    ],
    "surabondante": [
        "surabondant"
    ],
    "surabondantes": [
        "surabondant"
    ],
    "surabondent": [
        "surabonder"
    ],
    "suractiver": [
        "suractiver"
    ],
    "suractivite": [
        "suractivite"
    ],
    "suractive": [
        "suractive"
    ],
    "suractivee": [
        "suractive"
    ],
    "suradaptation": [
        "suradaptation"
    ],
    "suradapte": [
        "suradapte"
    ],
    "surah": [
        "surah"
    ],
    "suraigu": [
        "suraigu"
    ],
    "suraigus": [
        "suraigu"
    ],
    "suraigue": [
        "suraigu"
    ],
    "suraigues": [
        "suraigu"
    ],
    "surajoute": [
        "surajouter"
    ],
    "surajouter": [
        "surajouter"
    ],
    "surajoutee": [
        "surajouter"
    ],
    "surajoutes": [
        "surajouter"
    ],
    "suralimentation": [
        "suralimentation"
    ],
    "suralimenter": [
        "suralimenter"
    ],
    "suralimentes": [
        "suralimenter",
        "suralimente"
    ],
    "suralimentee": [
        "suralimente"
    ],
    "suranne": [
        "suranne"
    ],
    "surannee": [
        "suranne"
    ],
    "surannees": [
        "suranne"
    ],
    "surannes": [
        "suranne"
    ],
    "surard": [
        "surard"
    ],
    "surarmement": [
        "surarmement"
    ],
    "surarme": [
        "surarmer"
    ],
    "surarmee": [
        "surarmer"
    ],
    "surarmes": [
        "surarmer"
    ],
    "surbaisse": [
        "surbaisse",
        "surbaisser"
    ],
    "surbaissee": [
        "surbaisse",
        "surbaisser"
    ],
    "surbaissees": [
        "surbaisse"
    ],
    "surbaisses": [
        "surbaisse"
    ],
    "surbooke": [
        "surbooke"
    ],
    "surbookee": [
        "surbooke"
    ],
    "surbookees": [
        "surbooke"
    ],
    "surboum": [
        "surboum"
    ],
    "surboums": [
        "surboum"
    ],
    "surbrillance": [
        "surbrillance"
    ],
    "surbrode": [
        "surbrode"
    ],
    "surcapacite": [
        "surcapacite"
    ],
    "surcharge": [
        "surcharge",
        "surcharger"
    ],
    "surchargeaient": [
        "surcharger"
    ],
    "surchargeait": [
        "surcharger"
    ],
    "surchargeant": [
        "surcharger"
    ],
    "surcharger": [
        "surcharger"
    ],
    "surcharges": [
        "surcharge",
        "surcharger"
    ],
    "surchargee": [
        "surcharger"
    ],
    "surchargees": [
        "surcharger"
    ],
    "surchauffait": [
        "surchauffer"
    ],
    "surchauffe": [
        "surchauffer",
        "surchauffe"
    ],
    "surchauffer": [
        "surchauffer"
    ],
    "surchauffez": [
        "surchauffer"
    ],
    "surchauffee": [
        "surchauffer"
    ],
    "surchauffees": [
        "surchauffer"
    ],
    "surchauffes": [
        "surchauffer"
    ],
    "surchoix": [
        "surchoix"
    ],
    "surclassait": [
        "surclasser"
    ],
    "surclassant": [
        "surclasser"
    ],
    "surclasse": [
        "surclasser"
    ],
    "surclassent": [
        "surclasser"
    ],
    "surclasser": [
        "surclasser"
    ],
    "surclasserais": [
        "surclasser"
    ],
    "surclasserait": [
        "surclasser"
    ],
    "surclasseras": [
        "surclasser"
    ],
    "surclasses": [
        "surclasser"
    ],
    "surcompensation": [
        "surcompensation"
    ],
    "surcompenser": [
        "surcompenser"
    ],
    "surcompense": [
        "surcompenser"
    ],
    "surcomprimee": [
        "surcomprimer"
    ],
    "surconsommation": [
        "surconsommation"
    ],
    "surconsomme": [
        "surconsommer"
    ],
    "surcontre": [
        "surcontre"
    ],
    "surcot": [
        "surcot"
    ],
    "surcots": [
        "surcot"
    ],
    "surcoupe": [
        "surcouper"
    ],
    "surcout": [
        "surcout"
    ],
    "surcroit": [
        "surcroit"
    ],
    "surcroits": [
        "surcroit"
    ],
    "surdimensionne": [
        "surdimensionne"
    ],
    "surdimensionnee": [
        "surdimensionne"
    ],
    "surdite": [
        "surdite"
    ],
    "surdore": [
        "surdorer"
    ],
    "surdoree": [
        "surdorer"
    ],
    "surdosage": [
        "surdosage"
    ],
    "surdose": [
        "surdose"
    ],
    "surdoue": [
        "surdoue"
    ],
    "surdouee": [
        "surdoue"
    ],
    "surdoues": [
        "surdoue"
    ],
    "surdetermine": [
        "surdeterminer"
    ],
    "surdevelopper": [
        "surdevelopper"
    ],
    "surdeveloppe": [
        "surdeveloppe"
    ],
    "surdeveloppee": [
        "surdeveloppe"
    ],
    "surdeveloppees": [
        "surdeveloppe"
    ],
    "surdeveloppes": [
        "surdeveloppe"
    ],
    "sure": [
        "sur"
    ],
    "sureau": [
        "sureau"
    ],
    "sureaux": [
        "sureau"
    ],
    "sureffectif": [
        "sureffectif"
    ],
    "suremploi": [
        "suremploi"
    ],
    "surenchere": [
        "surenchere"
    ],
    "surencheres": [
        "surenchere"
    ],
    "surencheri": [
        "surencherir"
    ],
    "surencherir": [
        "surencherir"
    ],
    "surencherissant": [
        "surencherir"
    ],
    "surencherissent": [
        "surencherir"
    ],
    "surencherit": [
        "surencherir"
    ],
    "surencombree": [
        "surencombre"
    ],
    "surendettes": [
        "surendette"
    ],
    "surent": [
        "savoir"
    ],
    "surentrainement": [
        "surentrainement"
    ],
    "surentraine": [
        "surentraine"
    ],
    "surentrainees": [
        "surentrainer",
        "surentraine"
    ],
    "surentraines": [
        "surentrainer",
        "surentraine"
    ],
    "sures": [
        "sur"
    ],
    "surestimation": [
        "surestimation"
    ],
    "surestime": [
        "surestimer"
    ],
    "surestimer": [
        "surestimer"
    ],
    "surestimerais": [
        "surestimer"
    ],
    "surestimez": [
        "surestimer"
    ],
    "surestimee": [
        "surestimer"
    ],
    "surestimes": [
        "surestimer"
    ],
    "suret": [
        "suret"
    ],
    "surets": [
        "suret"
    ],
    "surette": [
        "suret"
    ],
    "surexcitait": [
        "surexciter"
    ],
    "surexcitant": [
        "surexciter"
    ],
    "surexcitation": [
        "surexcitation"
    ],
    "surexcite": [
        "surexciter"
    ],
    "surexciter": [
        "surexciter"
    ],
    "surexcitee": [
        "surexciter"
    ],
    "surexcitees": [
        "surexciter"
    ],
    "surexcites": [
        "surexciter"
    ],
    "surexploite": [
        "surexploiter"
    ],
    "surexposition": [
        "surexposition"
    ],
    "surexpose": [
        "surexposer"
    ],
    "surexposee": [
        "surexposer"
    ],
    "surexposees": [
        "surexposer"
    ],
    "surexposes": [
        "surexposer"
    ],
    "surf": [
        "surf"
    ],
    "surface": [
        "surface"
    ],
    "surfacer": [
        "surfacer"
    ],
    "surfaces": [
        "surface",
        "surfac"
    ],
    "surfactant": [
        "surfactant"
    ],
    "surfacturation": [
        "surfacturation"
    ],
    "surfacture": [
        "surfacturer"
    ],
    "surfacturer": [
        "surfacturer"
    ],
    "surfactures": [
        "surfacturer"
    ],
    "surfaire": [
        "surfaire"
    ],
    "surfais": [
        "surfer"
    ],
    "surfaisait": [
        "surfaire"
    ],
    "surfait": [
        "surfer",
        "surfait"
    ],
    "surfaite": [
        "surfait",
        "surfaire"
    ],
    "surfaites": [
        "surfait"
    ],
    "surfaits": [
        "surfait",
        "surfaire"
    ],
    "surfant": [
        "surfer"
    ],
    "surfacage": [
        "surfacage"
    ],
    "surfe": [
        "surfer"
    ],
    "surfent": [
        "surfer"
    ],
    "surfer": [
        "surfer"
    ],
    "surferas": [
        "surfer"
    ],
    "surfes": [
        "surfer"
    ],
    "surfeur": [
        "surfeur"
    ],
    "surfeurs": [
        "surfeur"
    ],
    "surfeuse": [
        "surfeur"
    ],
    "surfeuses": [
        "surfeur"
    ],
    "surfez": [
        "surfer"
    ],
    "surfilage": [
        "surfilage"
    ],
    "surfin": [
        "surfin"
    ],
    "surfine": [
        "surfin"
    ],
    "surfons": [
        "surfer"
    ],
    "surgeler": [
        "surgeler"
    ],
    "surgele": [
        "surgele",
        "surgeler"
    ],
    "surgelee": [
        "surgele",
        "surgeler"
    ],
    "surgelees": [
        "surgele",
        "surgeler"
    ],
    "surgeles": [
        "surgele",
        "surgeler"
    ],
    "surgeon": [
        "surgeon"
    ],
    "surgeonnent": [
        "surgeonner"
    ],
    "surgeons": [
        "surgeon"
    ],
    "surgi": [
        "surgir"
    ],
    "surgie": [
        "surgir"
    ],
    "surgies": [
        "surgir"
    ],
    "surgir": [
        "surgir"
    ],
    "surgira": [
        "surgir"
    ],
    "surgiraient": [
        "surgir"
    ],
    "surgirait": [
        "surgir"
    ],
    "surgirent": [
        "surgir"
    ],
    "surgiront": [
        "surgir"
    ],
    "surgis": [
        "surgir"
    ],
    "surgissaient": [
        "surgir"
    ],
    "surgissais": [
        "surgir"
    ],
    "surgissait": [
        "surgir"
    ],
    "surgissant": [
        "surgir"
    ],
    "surgisse": [
        "surgir"
    ],
    "surgissement": [
        "surgissement"
    ],
    "surgissements": [
        "surgissement"
    ],
    "surgissent": [
        "surgir"
    ],
    "surgissez": [
        "surgir"
    ],
    "surgit": [
        "surgir"
    ],
    "surge": [
        "surge"
    ],
    "surgenerateur": [
        "surgenerateur"
    ],
    "surhomme": [
        "surhomme"
    ],
    "surhommes": [
        "surhomme"
    ],
    "surhumain": [
        "surhumain"
    ],
    "surhumaine": [
        "surhumain"
    ],
    "surhumaines": [
        "surhumain"
    ],
    "surhumains": [
        "surhumain"
    ],
    "surhumanite": [
        "surhumanite"
    ],
    "suri": [
        "surir",
        "suri"
    ],
    "suricate": [
        "suricate"
    ],
    "surie": [
        "suri"
    ],
    "suries": [
        "suri"
    ],
    "surimi": [
        "surimi"
    ],
    "surimpression": [
        "surimpression"
    ],
    "surimpressions": [
        "surimpression"
    ],
    "surin": [
        "surin"
    ],
    "surinait": [
        "suriner"
    ],
    "surine": [
        "suriner"
    ],
    "surinent": [
        "suriner"
    ],
    "suriner": [
        "suriner"
    ],
    "surinerais": [
        "suriner"
    ],
    "surinfections": [
        "surinfection"
    ],
    "surinformation": [
        "surinformation"
    ],
    "surinforme": [
        "surinformer"
    ],
    "surins": [
        "surin"
    ],
    "surintendance": [
        "surintendance"
    ],
    "surintendant": [
        "surintendant"
    ],
    "surintendante": [
        "surintendant"
    ],
    "surintensite": [
        "surintensite"
    ],
    "surinvestissement": [
        "surinvestissement"
    ],
    "surir": [
        "surir"
    ],
    "surit": [
        "surir"
    ],
    "surjet": [
        "surjet"
    ],
    "surjeteuse": [
        "jeteur"
    ],
    "surjets": [
        "surjet"
    ],
    "surlendemain": [
        "surlendemain"
    ],
    "surligner": [
        "surligner"
    ],
    "surligneur": [
        "surligneur"
    ],
    "surligne": [
        "surligner"
    ],
    "surmenage": [
        "surmenage"
    ],
    "surmenait": [
        "surmener"
    ],
    "surmenant": [
        "surmener",
        "surmenant"
    ],
    "surmener": [
        "surmener"
    ],
    "surmenez": [
        "surmener"
    ],
    "surmene": [
        "surmener",
        "surmene"
    ],
    "surmenee": [
        "surmener",
        "surmene"
    ],
    "surmenees": [
        "surmener",
        "surmene"
    ],
    "surmenes": [
        "surmener",
        "surmene"
    ],
    "surmoi": [
        "surmoi"
    ],
    "surmonta": [
        "surmonter"
    ],
    "surmontai": [
        "surmonter"
    ],
    "surmontaient": [
        "surmonter"
    ],
    "surmontais": [
        "surmonter"
    ],
    "surmontait": [
        "surmonter"
    ],
    "surmontant": [
        "surmonter"
    ],
    "surmonte": [
        "surmonter"
    ],
    "surmontent": [
        "surmonter"
    ],
    "surmonter": [
        "surmonter"
    ],
    "surmontera": [
        "surmonter"
    ],
    "surmonterai": [
        "surmonter"
    ],
    "surmonteraient": [
        "surmonter"
    ],
    "surmonterait": [
        "surmonter"
    ],
    "surmonteras": [
        "surmonter"
    ],
    "surmonterez": [
        "surmonter"
    ],
    "surmonterons": [
        "surmonter"
    ],
    "surmontez": [
        "surmonter"
    ],
    "surmontions": [
        "surmonter"
    ],
    "surmonterent": [
        "surmonter"
    ],
    "surmontee": [
        "surmonter"
    ],
    "surmontees": [
        "surmonter"
    ],
    "surmontes": [
        "surmonter"
    ],
    "surmulot": [
        "surmulot"
    ],
    "surmulots": [
        "surmulot"
    ],
    "surmultipliee": [
        "surmultiplier",
        "surmultiplie"
    ],
    "surmultipliees": [
        "surmultiplie"
    ],
    "surmale": [
        "surmale"
    ],
    "surmedicalisation": [
        "surmedicalisation"
    ],
    "surnage": [
        "surnager"
    ],
    "surnagea": [
        "surnager"
    ],
    "surnageaient": [
        "surnager"
    ],
    "surnageait": [
        "surnager"
    ],
    "surnageant": [
        "surnager",
        "surnageant"
    ],
    "surnageants": [
        "surnageant"
    ],
    "surnagent": [
        "surnager"
    ],
    "surnageons": [
        "surnager"
    ],
    "surnager": [
        "surnager"
    ],
    "surnagera": [
        "surnager"
    ],
    "surnages": [
        "surnager"
    ],
    "surnagerent": [
        "surnager"
    ],
    "surnaturel": [
        "surnaturel"
    ],
    "surnaturelle": [
        "surnaturel"
    ],
    "surnaturelles": [
        "surnaturel"
    ],
    "surnaturels": [
        "surnaturel"
    ],
    "surnom": [
        "surnom"
    ],
    "surnombre": [
        "surnombre"
    ],
    "surnomma": [
        "surnommer"
    ],
    "surnommaient": [
        "surnommer"
    ],
    "surnommais": [
        "surnommer"
    ],
    "surnommait": [
        "surnommer"
    ],
    "surnommant": [
        "surnommer"
    ],
    "surnomme": [
        "surnomme",
        "surnommer"
    ],
    "surnomment": [
        "surnommer"
    ],
    "surnommer": [
        "surnommer"
    ],
    "surnommera": [
        "surnommer"
    ],
    "surnommerais": [
        "surnommer"
    ],
    "surnommions": [
        "surnommer"
    ],
    "surnommerent": [
        "surnommer"
    ],
    "surnommee": [
        "surnomme",
        "surnommer"
    ],
    "surnommes": [
        "surnomme",
        "surnommer"
    ],
    "surnoms": [
        "surnom"
    ],
    "surnumeraire": [
        "surnumeraire"
    ],
    "surnumeraires": [
        "surnumeraire"
    ],
    "suroxygener": [
        "suroxygener"
    ],
    "suroxygene": [
        "suroxygene"
    ],
    "suroit": [
        "suroit"
    ],
    "suroits": [
        "suroit"
    ],
    "surpassa": [
        "surpasser"
    ],
    "surpassaient": [
        "surpasser"
    ],
    "surpassais": [
        "surpasser"
    ],
    "surpassait": [
        "surpasser"
    ],
    "surpassant": [
        "surpasser"
    ],
    "surpasse": [
        "surpasser"
    ],
    "surpassent": [
        "surpasser"
    ],
    "surpasser": [
        "surpasser"
    ],
    "surpassera": [
        "surpasser"
    ],
    "surpasserai": [
        "surpasser"
    ],
    "surpasseraient": [
        "surpasser"
    ],
    "surpasserait": [
        "surpasser"
    ],
    "surpasseras": [
        "surpasser"
    ],
    "surpasses": [
        "surpasser",
        "surpass"
    ],
    "surpassez": [
        "surpasser"
    ],
    "surpassons": [
        "surpasser"
    ],
    "surpassat": [
        "surpasser"
    ],
    "surpassee": [
        "surpasser"
    ],
    "surpassees": [
        "surpasser"
    ],
    "surpatte": [
        "surpatte"
    ],
    "surpattes": [
        "surpatte"
    ],
    "surpaye": [
        "surpayer"
    ],
    "surpayes": [
        "surpayer"
    ],
    "surpeuplement": [
        "surpeuplement"
    ],
    "surpeupler": [
        "surpeupler"
    ],
    "surpeuple": [
        "surpeuple"
    ],
    "surpeuplee": [
        "surpeuple"
    ],
    "surpeuplees": [
        "surpeuple"
    ],
    "surpeuples": [
        "surpeuple"
    ],
    "surpiqures": [
        "surpiqure"
    ],
    "surplace": [
        "surplace"
    ],
    "surplis": [
        "surplis"
    ],
    "surplomb": [
        "surplomb"
    ],
    "surplomba": [
        "surplomber"
    ],
    "surplombaient": [
        "surplomber"
    ],
    "surplombait": [
        "surplomber"
    ],
    "surplombant": [
        "surplombant",
        "surplomber"
    ],
    "surplombante": [
        "surplombant"
    ],
    "surplombe": [
        "surplomber"
    ],
    "surplombent": [
        "surplomber"
    ],
    "surplomber": [
        "surplomber"
    ],
    "surplomberait": [
        "surplomber"
    ],
    "surplombions": [
        "surplomber"
    ],
    "surplombs": [
        "surplomb"
    ],
    "surplombee": [
        "surplomber"
    ],
    "surplombes": [
        "surplomber"
    ],
    "surplus": [
        "surplus"
    ],
    "surpoids": [
        "surpoids"
    ],
    "surpopulation": [
        "surpopulation"
    ],
    "surprenaient": [
        "surprendre"
    ],
    "surprenais": [
        "surprendre"
    ],
    "surprenait": [
        "surprendre"
    ],
    "surprenant": [
        "surprenant",
        "surprendre"
    ],
    "surprenante": [
        "surprenant"
    ],
    "surprenantes": [
        "surprenant"
    ],
    "surprenants": [
        "surprenant"
    ],
    "surprend": [
        "surprendre"
    ],
    "surprendra": [
        "surprendre"
    ],
    "surprendrai": [
        "surprendre"
    ],
    "surprendraient": [
        "surprendre"
    ],
    "surprendrais": [
        "surprendre"
    ],
    "surprendrait": [
        "surprendre"
    ],
    "surprendras": [
        "surprendre"
    ],
    "surprendre": [
        "surprendre"
    ],
    "surprendrez": [
        "surprendre"
    ],
    "surprendrons": [
        "surprendre"
    ],
    "surprendront": [
        "surprendre"
    ],
    "surprends": [
        "surprendre"
    ],
    "surprenez": [
        "surprendre"
    ],
    "surpreniez": [
        "surprendre"
    ],
    "surprenions": [
        "surprendre"
    ],
    "surprenne": [
        "surprendre"
    ],
    "surprennent": [
        "surprendre"
    ],
    "surprenons": [
        "surprendre"
    ],
    "surpresseur": [
        "surpresseur"
    ],
    "surpression": [
        "surpression"
    ],
    "surprime": [
        "surprime"
    ],
    "surprirent": [
        "surprendre"
    ],
    "surpris": [
        "surpris",
        "surprendre"
    ],
    "surprise": [
        "surprise",
        "surpris",
        "surprendre"
    ],
    "surprises": [
        "surprise",
        "surpris",
        "surprendre"
    ],
    "surprit": [
        "surprendre"
    ],
    "surproduction": [
        "surproduction"
    ],
    "surprotecteur": [
        "surprotecteur"
    ],
    "surprotectrice": [
        "surprotecteur"
    ],
    "surprotege": [
        "surproteger"
    ],
    "surprotegeais": [
        "surproteger"
    ],
    "surproteger": [
        "surproteger"
    ],
    "surpuissance": [
        "surpuissance"
    ],
    "surpuissant": [
        "surpuissant"
    ],
    "surpuissante": [
        "surpuissant"
    ],
    "surpuissants": [
        "surpuissant"
    ],
    "surqualifie": [
        "surqualifie"
    ],
    "surqualifiee": [
        "surqualifie"
    ],
    "surrealisme": [
        "surrealisme"
    ],
    "surrealiste": [
        "surrealiste"
    ],
    "surrealistes": [
        "surrealiste"
    ],
    "surrealite": [
        "surrealite"
    ],
    "surreel": [
        "surreel"
    ],
    "surreelle": [
        "surreel"
    ],
    "surreelles": [
        "surreel"
    ],
    "surregime": [
        "surregime"
    ],
    "surrenal": [
        "surrenal"
    ],
    "surrenale": [
        "surrenal"
    ],
    "surrenales": [
        "surrenal"
    ],
    "surrenalien": [
        "surrenalien"
    ],
    "surreservation": [
        "surreservation"
    ],
    "surs": [
        "sur"
    ],
    "sursature": [
        "sursaturer"
    ],
    "sursaturee": [
        "sursature"
    ],
    "sursaturees": [
        "sursature"
    ],
    "sursaut": [
        "sursaut"
    ],
    "sursauta": [
        "sursauter"
    ],
    "sursautai": [
        "sursauter"
    ],
    "sursautaient": [
        "sursauter"
    ],
    "sursautais": [
        "sursauter"
    ],
    "sursautait": [
        "sursauter"
    ],
    "sursautant": [
        "sursauter"
    ],
    "sursaute": [
        "sursauter"
    ],
    "sursautent": [
        "sursauter"
    ],
    "sursauter": [
        "sursauter"
    ],
    "sursauteraient": [
        "sursauter"
    ],
    "sursauterais": [
        "sursauter"
    ],
    "sursautez": [
        "sursauter"
    ],
    "sursautons": [
        "sursauter"
    ],
    "sursauts": [
        "sursaut"
    ],
    "sursautat": [
        "sursauter"
    ],
    "sursauterent": [
        "sursauter"
    ],
    "surseoir": [
        "surseoir"
    ],
    "sursis": [
        "surseoir",
        "sursis"
    ],
    "sursitaire": [
        "sursitaire"
    ],
    "sursitaires": [
        "sursitaire"
    ],
    "surtaxe": [
        "surtaxe"
    ],
    "surtaxer": [
        "surtaxer"
    ],
    "surtaxes": [
        "surtaxe",
        "surtaxer"
    ],
    "surtendu": [
        "surtendu"
    ],
    "surtension": [
        "surtension"
    ],
    "surtout": [
        "surtout"
    ],
    "surtouts": [
        "surtout"
    ],
    "surveilla": [
        "surveiller"
    ],
    "surveillaient": [
        "surveiller"
    ],
    "surveillais": [
        "surveiller"
    ],
    "surveillait": [
        "surveiller"
    ],
    "surveillance": [
        "surveillance"
    ],
    "surveillances": [
        "surveillance"
    ],
    "surveillant": [
        "surveillant",
        "surveiller"
    ],
    "surveillante": [
        "surveillant"
    ],
    "surveillantes": [
        "surveillant"
    ],
    "surveillants": [
        "surveillant"
    ],
    "surveille": [
        "surveiller"
    ],
    "surveillent": [
        "surveiller"
    ],
    "surveiller": [
        "surveiller"
    ],
    "surveillera": [
        "surveiller"
    ],
    "surveillerai": [
        "surveiller"
    ],
    "surveilleraient": [
        "surveiller"
    ],
    "surveillerais": [
        "surveiller"
    ],
    "surveillerait": [
        "surveiller"
    ],
    "surveilleras": [
        "surveiller"
    ],
    "surveillerez": [
        "surveiller"
    ],
    "surveillerons": [
        "surveiller"
    ],
    "surveilleront": [
        "surveiller"
    ],
    "surveilles": [
        "surveiller"
    ],
    "surveillez": [
        "surveiller"
    ],
    "surveilliez": [
        "surveiller"
    ],
    "surveillions": [
        "surveiller"
    ],
    "surveillons": [
        "surveiller"
    ],
    "surveillat": [
        "surveiller"
    ],
    "surveillee": [
        "surveiller"
    ],
    "surveillees": [
        "surveiller"
    ],
    "survenaient": [
        "survenir"
    ],
    "survenais": [
        "survenir"
    ],
    "survenait": [
        "survenir"
    ],
    "survenant": [
        "survenir"
    ],
    "survenants": [
        "survenant"
    ],
    "survenir": [
        "survenir"
    ],
    "survenu": [
        "survenir"
    ],
    "survenue": [
        "survenir",
        "survenue"
    ],
    "survenues": [
        "survenir",
        "survenue"
    ],
    "survenus": [
        "survenir"
    ],
    "survie": [
        "survie"
    ],
    "surviendra": [
        "survenir"
    ],
    "surviendraient": [
        "survenir"
    ],
    "surviendrait": [
        "survenir"
    ],
    "surviendront": [
        "survenir"
    ],
    "survienne": [
        "survenir"
    ],
    "surviennent": [
        "survenir"
    ],
    "survient": [
        "survenir"
    ],
    "survinrent": [
        "survenir"
    ],
    "survint": [
        "survenir"
    ],
    "survire": [
        "survirer"
    ],
    "survis": [
        "survivre"
    ],
    "survit": [
        "survivre"
    ],
    "survitesse": [
        "survitesse"
    ],
    "survivaient": [
        "survivre"
    ],
    "survivais": [
        "survivre"
    ],
    "survivait": [
        "survivre"
    ],
    "survivaliste": [
        "survivaliste"
    ],
    "survivance": [
        "survivance"
    ],
    "survivances": [
        "survivance"
    ],
    "survivant": [
        "survivant",
        "survivre"
    ],
    "survivante": [
        "survivant"
    ],
    "survivantes": [
        "survivant"
    ],
    "survivants": [
        "survivant"
    ],
    "survive": [
        "survivre"
    ],
    "survivent": [
        "survivre"
    ],
    "survives": [
        "survive",
        "survivre"
    ],
    "survivez": [
        "survivre"
    ],
    "surviviez": [
        "survivre"
    ],
    "survivions": [
        "survivre"
    ],
    "survivons": [
        "survivre"
    ],
    "survivra": [
        "survivre"
    ],
    "survivrai": [
        "survivre"
    ],
    "survivraient": [
        "survivre"
    ],
    "survivrais": [
        "survivre"
    ],
    "survivrait": [
        "survivre"
    ],
    "survivras": [
        "survivre"
    ],
    "survivre": [
        "survivre"
    ],
    "survivrez": [
        "survivre"
    ],
    "survivriez": [
        "survivre"
    ],
    "survivrons": [
        "survivre"
    ],
    "survivront": [
        "survivre"
    ],
    "survol": [
        "survol"
    ],
    "survola": [
        "survoler"
    ],
    "survolaient": [
        "survoler"
    ],
    "survolais": [
        "survoler"
    ],
    "survolait": [
        "survoler"
    ],
    "survolant": [
        "survoler"
    ],
    "survole": [
        "survoler"
    ],
    "survolent": [
        "survoler"
    ],
    "survoler": [
        "survoler"
    ],
    "survolera": [
        "survoler"
    ],
    "survolerai": [
        "survoler"
    ],
    "survolerez": [
        "survoler"
    ],
    "survolerons": [
        "survoler"
    ],
    "survolez": [
        "survoler"
    ],
    "survolions": [
        "survoler"
    ],
    "survolons": [
        "survoler"
    ],
    "survols": [
        "survol"
    ],
    "survoltage": [
        "survoltage"
    ],
    "survoltait": [
        "survolter"
    ],
    "survolteur": [
        "survolteur"
    ],
    "survolte": [
        "survolte",
        "survolter"
    ],
    "survoltee": [
        "survolte",
        "survolter"
    ],
    "survoltees": [
        "survolte"
    ],
    "survoltes": [
        "survolte",
        "survolter"
    ],
    "survolames": [
        "survoler"
    ],
    "survolee": [
        "survoler"
    ],
    "survolees": [
        "survoler"
    ],
    "survecu": [
        "survivre"
    ],
    "survecurent": [
        "survivre"
    ],
    "survecus": [
        "survivre"
    ],
    "survecut": [
        "survivre"
    ],
    "survecumes": [
        "survivre"
    ],
    "survet": [
        "survet"
    ],
    "survetement": [
        "survetement"
    ],
    "survetements": [
        "survetement"
    ],
    "survets": [
        "survet"
    ],
    "surelevait": [
        "surelever"
    ],
    "surelever": [
        "surelever"
    ],
    "surelevez": [
        "surelever"
    ],
    "sureleve": [
        "surelever"
    ],
    "surelevee": [
        "surelever"
    ],
    "surelevees": [
        "surelever"
    ],
    "sureleves": [
        "surelever"
    ],
    "surelevation": [
        "surelevation"
    ],
    "sureminente": [
        "sureminent"
    ],
    "surequipee": [
        "surequiper"
    ],
    "surevaluation": [
        "surevaluation"
    ],
    "surevalue": [
        "surevaluer"
    ],
    "sus": [
        "savoir",
        "sus"
    ],
    "susceptibilite": [
        "susceptibilite"
    ],
    "susceptibilites": [
        "susceptibilite"
    ],
    "susceptible": [
        "susceptible"
    ],
    "susceptibles": [
        "susceptible"
    ],
    "suscita": [
        "susciter"
    ],
    "suscitaient": [
        "susciter"
    ],
    "suscitais": [
        "susciter"
    ],
    "suscitait": [
        "susciter"
    ],
    "suscitant": [
        "susciter"
    ],
    "suscite": [
        "susciter"
    ],
    "suscitent": [
        "susciter"
    ],
    "susciter": [
        "susciter"
    ],
    "susciteraient": [
        "susciter"
    ],
    "susciterait": [
        "susciter"
    ],
    "susciteront": [
        "susciter"
    ],
    "suscites": [
        "susciter"
    ],
    "suscitee": [
        "susciter"
    ],
    "suscitees": [
        "susciter"
    ],
    "suscription": [
        "suscription"
    ],
    "susdit": [
        "susdit"
    ],
    "susdite": [
        "susdit"
    ],
    "susdites": [
        "susdit"
    ],
    "sushi": [
        "sushi"
    ],
    "susmentionne": [
        "susmentionne"
    ],
    "susmentionnee": [
        "susmentionne"
    ],
    "susnomme": [
        "susnomme"
    ],
    "susnommee": [
        "susnomme"
    ],
    "susnommes": [
        "susnomme"
    ],
    "suspect": [
        "suspect"
    ],
    "suspectaient": [
        "suspecter"
    ],
    "suspectais": [
        "suspecter"
    ],
    "suspectait": [
        "suspecter"
    ],
    "suspectant": [
        "suspecter"
    ],
    "suspecte": [
        "suspecter",
        "suspect"
    ],
    "suspectent": [
        "suspecter"
    ],
    "suspecter": [
        "suspecter"
    ],
    "suspectera": [
        "suspecter"
    ],
    "suspecteraient": [
        "suspecter"
    ],
    "suspecterait": [
        "suspecter"
    ],
    "suspecteront": [
        "suspecter"
    ],
    "suspectes": [
        "suspecter",
        "suspect"
    ],
    "suspectez": [
        "suspecter"
    ],
    "suspectiez": [
        "suspecter"
    ],
    "suspectons": [
        "suspecter"
    ],
    "suspects": [
        "suspect"
    ],
    "suspectee": [
        "suspecter"
    ],
    "suspectees": [
        "suspecter"
    ],
    "suspend": [
        "suspendre"
    ],
    "suspendaient": [
        "suspendre"
    ],
    "suspendais": [
        "suspendre"
    ],
    "suspendait": [
        "suspendre"
    ],
    "suspendant": [
        "suspendre"
    ],
    "suspende": [
        "suspendre"
    ],
    "suspendent": [
        "suspendre"
    ],
    "suspendez": [
        "suspendre"
    ],
    "suspendirent": [
        "suspendre"
    ],
    "suspendit": [
        "suspendre"
    ],
    "suspendons": [
        "suspendre"
    ],
    "suspendra": [
        "suspendre"
    ],
    "suspendrai": [
        "suspendre"
    ],
    "suspendrait": [
        "suspendre"
    ],
    "suspendre": [
        "suspendre"
    ],
    "suspendrez": [
        "suspendre"
    ],
    "suspendrons": [
        "suspendre"
    ],
    "suspendront": [
        "suspendre"
    ],
    "suspends": [
        "suspend",
        "suspendre"
    ],
    "suspendu": [
        "suspendu",
        "suspendre"
    ],
    "suspendue": [
        "suspendu",
        "suspendre"
    ],
    "suspendues": [
        "suspendu",
        "suspendre"
    ],
    "suspendus": [
        "suspendu",
        "suspendre"
    ],
    "suspens": [
        "suspens"
    ],
    "suspense": [
        "suspense"
    ],
    "suspenses": [
        "suspense"
    ],
    "suspenseur": [
        "suspenseur"
    ],
    "suspenseurs": [
        "suspenseur"
    ],
    "suspensif": [
        "suspensif"
    ],
    "suspension": [
        "suspension"
    ],
    "suspensions": [
        "suspension"
    ],
    "suspensive": [
        "suspensif"
    ],
    "suspensoir": [
        "suspensoir"
    ],
    "suspensoirs": [
        "suspensoir"
    ],
    "suspente": [
        "suspente"
    ],
    "suspentes": [
        "suspente"
    ],
    "suspicieuse": [
        "suspicieux"
    ],
    "suspicieusement": [
        "suspicieusement"
    ],
    "suspicieuses": [
        "suspicieux"
    ],
    "suspicieux": [
        "suspicieux"
    ],
    "suspicion": [
        "suspicion"
    ],
    "suspicions": [
        "suspicion"
    ],
    "susse": [
        "savoir"
    ],
    "sussent": [
        "savoir"
    ],
    "sustentation": [
        "sustentation"
    ],
    "sustente": [
        "sustenter"
    ],
    "sustenter": [
        "sustenter"
    ],
    "sustentes": [
        "sustenter"
    ],
    "susu": [
        "susu"
    ],
    "susucre": [
        "susucre"
    ],
    "susurra": [
        "susurrer"
    ],
    "susurrai": [
        "susurrer"
    ],
    "susurraient": [
        "susurrer"
    ],
    "susurrait": [
        "susurrer"
    ],
    "susurrant": [
        "susurrer"
    ],
    "susurre": [
        "susurrer"
    ],
    "susurrement": [
        "susurrement"
    ],
    "susurrements": [
        "susurrement"
    ],
    "susurrent": [
        "susurrer"
    ],
    "susurrer": [
        "susurrer"
    ],
    "susurrerai": [
        "susurrer"
    ],
    "susurree": [
        "susurrer"
    ],
    "susurrees": [
        "susurrer"
    ],
    "susurres": [
        "susurrer"
    ],
    "susvisee": [
        "susvise"
    ],
    "sut": [
        "savoir"
    ],
    "sutra": [
        "sutra"
    ],
    "suturant": [
        "suturer"
    ],
    "suture": [
        "suturer",
        "suture"
    ],
    "suturer": [
        "suturer"
    ],
    "sutures": [
        "suture"
    ],
    "suturee": [
        "suturer"
    ],
    "sutemi": [
        "sutemi"
    ],
    "suzerain": [
        "suzerain"
    ],
    "suzeraine": [
        "suzerain"
    ],
    "suzerainete": [
        "suzerainete"
    ],
    "suzerains": [
        "suzerain"
    ],
    "suat": [
        "suer"
    ],
    "suca": [
        "sucer"
    ],
    "sucage": [
        "sucage"
    ],
    "sucages": [
        "sucage"
    ],
    "sucaient": [
        "sucer"
    ],
    "sucais": [
        "sucer"
    ],
    "sucait": [
        "sucer"
    ],
    "sucant": [
        "sucer"
    ],
    "sucoir": [
        "sucoir"
    ],
    "sucoirs": [
        "sucoir"
    ],
    "sucon": [
        "sucon"
    ],
    "sucons": [
        "sucon"
    ],
    "sucota": [
        "sucoter"
    ],
    "sucotait": [
        "sucoter"
    ],
    "sucotant": [
        "sucoter"
    ],
    "sucote": [
        "sucoter"
    ],
    "sucotements": [
        "sucotement"
    ],
    "sucotent": [
        "sucoter"
    ],
    "sucoter": [
        "sucoter"
    ],
    "suede": [
        "suede"
    ],
    "suedine": [
        "suedine"
    ],
    "suedois": [
        "suedois"
    ],
    "suedoise": [
        "suedois"
    ],
    "suedoises": [
        "suedois"
    ],
    "suee": [
        "suee",
        "suer"
    ],
    "suees": [
        "suee"
    ],
    "svastika": [
        "svastika"
    ],
    "svastikas": [
        "svastika"
    ],
    "svelte": [
        "svelte"
    ],
    "sveltes": [
        "svelte"
    ],
    "sveltesse": [
        "sveltesse"
    ],
    "svp": [
        "svp"
    ],
    "swahili": [
        "swahili"
    ],
    "sweater": [
        "sweater"
    ],
    "sweaters": [
        "sweater"
    ],
    "sweepstake": [
        "sweepstake"
    ],
    "swiftiennes": [
        "swiftien"
    ],
    "swing": [
        "swing"
    ],
    "swings": [
        "swing"
    ],
    "swinguaient": [
        "swinguer"
    ],
    "sybarites": [
        "sybarite"
    ],
    "sybaritisme": [
        "sybaritisme"
    ],
    "sycomore": [
        "sycomore"
    ],
    "sycomores": [
        "sycomore"
    ],
    "sycophante": [
        "sycophante"
    ],
    "sycophantes": [
        "sycophante"
    ],
    "syllabe": [
        "syllabe"
    ],
    "syllabes": [
        "syllabe"
    ],
    "syllabus": [
        "syllabus"
    ],
    "syllepse": [
        "syllepse"
    ],
    "syllogisme": [
        "syllogisme"
    ],
    "syllogismes": [
        "syllogisme"
    ],
    "syllogistique": [
        "syllogistique"
    ],
    "syllogistiques": [
        "syllogistique"
    ],
    "sylphes": [
        "sylphe"
    ],
    "sylphide": [
        "sylphide"
    ],
    "sylphides": [
        "sylphide"
    ],
    "sylvain": [
        "sylvain"
    ],
    "sylvains": [
        "sylvain"
    ],
    "sylvaner": [
        "sylvaner"
    ],
    "sylve": [
        "sylve"
    ],
    "sylvestre": [
        "sylvestre"
    ],
    "sylvestres": [
        "sylvestre"
    ],
    "sylviculture": [
        "sylviculture"
    ],
    "sylvie": [
        "sylvie"
    ],
    "symbionte": [
        "symbionte"
    ],
    "symbiose": [
        "symbiose"
    ],
    "symbiote": [
        "symbiote"
    ],
    "symbiotes": [
        "symbiote"
    ],
    "symbiotique": [
        "symbiotique"
    ],
    "symbole": [
        "symbole"
    ],
    "symboles": [
        "symbole"
    ],
    "symbolique": [
        "symbolique"
    ],
    "symboliquement": [
        "symboliquement"
    ],
    "symboliques": [
        "symbolique"
    ],
    "symbolisa": [
        "symboliser"
    ],
    "symbolisaient": [
        "symboliser"
    ],
    "symbolisait": [
        "symboliser"
    ],
    "symbolisant": [
        "symbolisant",
        "symboliser"
    ],
    "symbolisation": [
        "symbolisation"
    ],
    "symbolise": [
        "symboliser"
    ],
    "symbolisent": [
        "symboliser"
    ],
    "symboliser": [
        "symboliser"
    ],
    "symbolisera": [
        "symboliser"
    ],
    "symboliserai": [
        "symboliser"
    ],
    "symboliserait": [
        "symboliser"
    ],
    "symbolisme": [
        "symbolisme"
    ],
    "symboliste": [
        "symboliste"
    ],
    "symbolisat": [
        "symboliser"
    ],
    "symbolisee": [
        "symboliser"
    ],
    "symbolises": [
        "symbolise",
        "symboliser"
    ],
    "sympa": [
        "sympa"
    ],
    "sympas": [
        "sympa"
    ],
    "sympathectomie": [
        "sympathectomie"
    ],
    "sympathie": [
        "sympathie"
    ],
    "sympathies": [
        "sympathie",
        "sympathy"
    ],
    "sympathique": [
        "sympathique"
    ],
    "sympathiques": [
        "sympathique"
    ],
    "sympathisai": [
        "sympathiser"
    ],
    "sympathisaient": [
        "sympathiser"
    ],
    "sympathisait": [
        "sympathiser"
    ],
    "sympathisant": [
        "sympathiser",
        "sympathisant"
    ],
    "sympathisante": [
        "sympathisant"
    ],
    "sympathisantes": [
        "sympathisant"
    ],
    "sympathisants": [
        "sympathisant"
    ],
    "sympathise": [
        "sympathiser"
    ],
    "sympathiser": [
        "sympathiser"
    ],
    "sympathisera": [
        "sympathiser"
    ],
    "sympathiserez": [
        "sympathiser"
    ],
    "sympathisez": [
        "sympathiser"
    ],
    "sympathisions": [
        "sympathiser"
    ],
    "sympathisons": [
        "sympathiser"
    ],
    "sympathomimetique": [
        "sympathomimetique"
    ],
    "symphonie": [
        "symphonie"
    ],
    "symphonies": [
        "symphony",
        "symphonie"
    ],
    "symphonique": [
        "symphonique"
    ],
    "symphoniques": [
        "symphonique"
    ],
    "symphorines": [
        "symphorine"
    ],
    "symphyse": [
        "symphyse"
    ],
    "symposium": [
        "symposium"
    ],
    "symposiums": [
        "symposium"
    ],
    "symptomatique": [
        "symptomatique"
    ],
    "symptomatiques": [
        "symptomatique"
    ],
    "symptomatologie": [
        "symptomatologie"
    ],
    "symptome": [
        "symptome"
    ],
    "symptomes": [
        "symptome"
    ],
    "symetrie": [
        "symetrie"
    ],
    "symetries": [
        "symetrie"
    ],
    "symetrique": [
        "symetrique"
    ],
    "symetriquement": [
        "symetriquement"
    ],
    "symetriques": [
        "symetrique"
    ],
    "synagogale": [
        "synagogal"
    ],
    "synagogaux": [
        "synagogal"
    ],
    "synagogue": [
        "synagogue"
    ],
    "synagogues": [
        "synagogue"
    ],
    "synapse": [
        "synapse"
    ],
    "synapses": [
        "synapse"
    ],
    "synaptique": [
        "synaptique"
    ],
    "synaptiques": [
        "synaptique"
    ],
    "synchro": [
        "synchro"
    ],
    "synchrone": [
        "synchrone"
    ],
    "synchrones": [
        "synchrone"
    ],
    "synchronie": [
        "synchronie"
    ],
    "synchronique": [
        "synchronique"
    ],
    "synchronisaient": [
        "synchroniser"
    ],
    "synchronisation": [
        "synchronisation"
    ],
    "synchronise": [
        "synchroniser"
    ],
    "synchroniser": [
        "synchroniser"
    ],
    "synchronisera": [
        "synchroniser"
    ],
    "synchroniseur": [
        "synchroniseur"
    ],
    "synchronisez": [
        "synchroniser"
    ],
    "synchronisme": [
        "synchronisme"
    ],
    "synchronisons": [
        "synchroniser"
    ],
    "synchronisee": [
        "synchroniser"
    ],
    "synchronisees": [
        "synchroniser"
    ],
    "synchronises": [
        "synchroniser"
    ],
    "synchros": [
        "synchro"
    ],
    "synchrotron": [
        "synchrotron"
    ],
    "syncopal": [
        "syncopal"
    ],
    "syncope": [
        "syncoper",
        "syncope"
    ],
    "syncoper": [
        "syncoper"
    ],
    "syncopes": [
        "syncoper",
        "syncope"
    ],
    "syncopee": [
        "syncoper",
        "syncope"
    ],
    "syncopees": [
        "syncope"
    ],
    "syncretisme": [
        "syncretisme"
    ],
    "syncretiste": [
        "syncretiste"
    ],
    "syncytial": [
        "syncytial"
    ],
    "syndic": [
        "syndic"
    ],
    "syndical": [
        "syndical"
    ],
    "syndicale": [
        "syndical"
    ],
    "syndicales": [
        "syndical"
    ],
    "syndicalisation": [
        "syndicalisation"
    ],
    "syndicaliser": [
        "syndicaliser"
    ],
    "syndicalisme": [
        "syndicalisme"
    ],
    "syndicaliste": [
        "syndicaliste"
    ],
    "syndicalistes": [
        "syndicaliste"
    ],
    "syndicat": [
        "syndicat"
    ],
    "syndication": [
        "syndication"
    ],
    "syndicats": [
        "syndicat"
    ],
    "syndicaux": [
        "syndical"
    ],
    "syndics": [
        "syndic"
    ],
    "syndique": [
        "syndiquer",
        "syndique"
    ],
    "syndiquer": [
        "syndiquer"
    ],
    "syndiquez": [
        "syndiquer"
    ],
    "syndiquee": [
        "syndiquer",
        "syndique"
    ],
    "syndiquees": [
        "syndique"
    ],
    "syndiques": [
        "syndiquer",
        "syndique"
    ],
    "syndrome": [
        "syndrome"
    ],
    "syndromes": [
        "syndrome"
    ],
    "synecdoque": [
        "synecdoque"
    ],
    "synergie": [
        "synergie"
    ],
    "synergies": [
        "synergie",
        "synergy"
    ],
    "synergique": [
        "synergique"
    ],
    "synergetique": [
        "synergetique"
    ],
    "synesthesie": [
        "synesthesie"
    ],
    "synode": [
        "synode"
    ],
    "synonyme": [
        "synonyme"
    ],
    "synonymes": [
        "synonyme"
    ],
    "synopsie": [
        "synopsie"
    ],
    "synopsis": [
        "synopsis"
    ],
    "synoptique": [
        "synoptique"
    ],
    "synoviales": [
        "synovial"
    ],
    "synovite": [
        "synovite"
    ],
    "syntagme": [
        "syntagme"
    ],
    "syntaxe": [
        "syntaxe"
    ],
    "syntaxes": [
        "syntax",
        "syntaxe"
    ],
    "syntaxique": [
        "syntaxique"
    ],
    "synthese": [
        "synthese"
    ],
    "syntheses": [
        "synthesis",
        "synthese"
    ],
    "synthe": [
        "synthe"
    ],
    "synthes": [
        "synthe"
    ],
    "synthetique": [
        "synthetique"
    ],
    "synthetiquement": [
        "synthetiquement"
    ],
    "synthetiques": [
        "synthetique"
    ],
    "synthetise": [
        "synthetiser"
    ],
    "synthetisent": [
        "synthetiser"
    ],
    "synthetiser": [
        "synthetiser"
    ],
    "synthetisera": [
        "synthetiser"
    ],
    "synthetiseur": [
        "synthetiseur"
    ],
    "synthetiseurs": [
        "synthetiseur"
    ],
    "synthetisee": [
        "synthetiser"
    ],
    "synthetises": [
        "synthetiser"
    ],
    "synereses": [
        "synerese"
    ],
    "syphilis": [
        "syphilis"
    ],
    "syphilitique": [
        "syphilitique"
    ],
    "syphilitiques": [
        "syphilitique"
    ],
    "syrah": [
        "syrah"
    ],
    "syriaque": [
        "syriaque"
    ],
    "syriaques": [
        "syriaque"
    ],
    "syrien": [
        "syrien"
    ],
    "syrienne": [
        "syrien"
    ],
    "syriennes": [
        "syrien"
    ],
    "syriens": [
        "syrien"
    ],
    "syringomyelie": [
        "syringomyelie"
    ],
    "syrinx": [
        "syrinx"
    ],
    "syro": [
        "syro"
    ],
    "syrtes": [
        "syrte"
    ],
    "systole": [
        "systole"
    ],
    "systolique": [
        "systolique"
    ],
    "systoliques": [
        "systolique"
    ],
    "systeme": [
        "systeme"
    ],
    "systemes": [
        "systeme"
    ],
    "systematique": [
        "systematique"
    ],
    "systematiquement": [
        "systematiquement"
    ],
    "systematiques": [
        "systematique"
    ],
    "systematisation": [
        "systematisation"
    ],
    "systematiser": [
        "systematiser"
    ],
    "systematise": [
        "systematise"
    ],
    "systematisee": [
        "systematise"
    ],
    "systematises": [
        "systematise"
    ],
    "systemique": [
        "systemique"
    ],
    "syzygie": [
        "syzygie"
    ],
    "syzygies": [
        "syzygie"
    ],
    "syenite": [
        "syenite"
    ],
    "seche": [
        "secher",
        "sec"
    ],
    "sechement": [
        "sechement"
    ],
    "sechent": [
        "secher"
    ],
    "seches": [
        "secher",
        "sec"
    ],
    "sement": [
        "semer"
    ],
    "semera": [
        "semer"
    ],
    "semerai": [
        "semer"
    ],
    "semerais": [
        "semer"
    ],
    "semerait": [
        "semer"
    ],
    "semeras": [
        "semer"
    ],
    "semerez": [
        "semer"
    ],
    "semerions": [
        "semer"
    ],
    "semerons": [
        "semer"
    ],
    "semeront": [
        "semer"
    ],
    "seve": [
        "seve"
    ],
    "seves": [
        "seve"
    ],
    "seance": [
        "seance"
    ],
    "seances": [
        "seance"
    ],
    "seant": [
        "seant"
    ],
    "seante": [
        "seant"
    ],
    "sebace": [
        "sebace"
    ],
    "sebacee": [
        "sebace"
    ],
    "sebacees": [
        "sebace"
    ],
    "sebaste": [
        "sebaste"
    ],
    "sebile": [
        "sebile"
    ],
    "sebiles": [
        "sebile"
    ],
    "seborrhee": [
        "seborrhee"
    ],
    "seborrheique": [
        "seborrheique"
    ],
    "sebum": [
        "sebum"
    ],
    "secateur": [
        "secateur"
    ],
    "secateurs": [
        "secateur"
    ],
    "secession": [
        "secession"
    ],
    "secessionniste": [
        "secessionniste"
    ],
    "secessionnistes": [
        "secessionniste"
    ],
    "secha": [
        "secher"
    ],
    "sechage": [
        "sechage"
    ],
    "sechai": [
        "secher"
    ],
    "sechaient": [
        "secher"
    ],
    "sechais": [
        "secher"
    ],
    "sechait": [
        "secher"
    ],
    "sechant": [
        "secher"
    ],
    "sechard": [
        "sechard"
    ],
    "secher": [
        "secher"
    ],
    "sechera": [
        "secher"
    ],
    "secherai": [
        "secher"
    ],
    "secheraient": [
        "secher"
    ],
    "secherais": [
        "secher"
    ],
    "secherait": [
        "secher"
    ],
    "secheresse": [
        "secheresse"
    ],
    "secheresses": [
        "secheresse"
    ],
    "secherez": [
        "secher"
    ],
    "secherie": [
        "secherie"
    ],
    "secheries": [
        "secherie"
    ],
    "secheront": [
        "secher"
    ],
    "secheuse": [
        "secheur"
    ],
    "sechez": [
        "secher"
    ],
    "sechiez": [
        "secher"
    ],
    "sechions": [
        "secher"
    ],
    "sechoir": [
        "sechoir"
    ],
    "sechoirs": [
        "sechoir"
    ],
    "sechons": [
        "secher"
    ],
    "sechat": [
        "secher"
    ],
    "secherent": [
        "secher"
    ],
    "sechee": [
        "secher"
    ],
    "sechees": [
        "secher"
    ],
    "secolle": [
        "secolle"
    ],
    "secot": [
        "secot"
    ],
    "secretais": [
        "secreter"
    ],
    "secretait": [
        "secreter"
    ],
    "secretant": [
        "secreter"
    ],
    "secreteur": [
        "secreteur"
    ],
    "secreteurs": [
        "secreteur"
    ],
    "secretez": [
        "secreter"
    ],
    "secretine": [
        "secretine"
    ],
    "secretion": [
        "secretion"
    ],
    "secretions": [
        "secretion"
    ],
    "secretat": [
        "secreter"
    ],
    "secu": [
        "secu"
    ],
    "seculaire": [
        "seculaire"
    ],
    "seculairement": [
        "seculairement"
    ],
    "seculaires": [
        "seculaire"
    ],
    "seculariser": [
        "seculariser"
    ],
    "secularisees": [
        "seculariser"
    ],
    "seculier": [
        "seculier"
    ],
    "seculiers": [
        "seculier"
    ],
    "seculiere": [
        "seculier"
    ],
    "securisait": [
        "securiser"
    ],
    "securisant": [
        "securisant",
        "securiser"
    ],
    "securisante": [
        "securisant"
    ],
    "securisation": [
        "securisation"
    ],
    "securiser": [
        "securiser"
    ],
    "securisez": [
        "securiser"
    ],
    "securise": [
        "securiser"
    ],
    "securisee": [
        "securiser"
    ],
    "securisees": [
        "securiser"
    ],
    "securises": [
        "securiser"
    ],
    "securit": [
        "securit"
    ],
    "securitaire": [
        "securitaire"
    ],
    "securite": [
        "securite"
    ],
    "securites": [
        "securite"
    ],
    "sedatif": [
        "sedatif"
    ],
    "sedatifs": [
        "sedatif"
    ],
    "sedation": [
        "sedation"
    ],
    "sedative": [
        "sedatif"
    ],
    "sedatives": [
        "sedative",
        "sedatif"
    ],
    "sedentaire": [
        "sedentaire"
    ],
    "sedentaires": [
        "sedentaire"
    ],
    "sedentarisaient": [
        "sedentariser"
    ],
    "sedentarisation": [
        "sedentarisation"
    ],
    "sedentarise": [
        "sedentariser"
    ],
    "sedentariser": [
        "sedentariser"
    ],
    "sedentarisme": [
        "sedentarisme"
    ],
    "sedentarite": [
        "sedentarite"
    ],
    "sediment": [
        "sediment"
    ],
    "sedimentaire": [
        "sedimentaire"
    ],
    "sedimentaires": [
        "sedimentaire"
    ],
    "sedimentation": [
        "sedimentation"
    ],
    "sedimentations": [
        "sedimentation"
    ],
    "sedimente": [
        "sedimenter"
    ],
    "sediments": [
        "sediment"
    ],
    "sedimentee": [
        "sedimenter"
    ],
    "seditieuse": [
        "seditieux"
    ],
    "seditieuses": [
        "seditieux"
    ],
    "seditieux": [
        "seditieux"
    ],
    "sedition": [
        "sedition"
    ],
    "seducteur": [
        "seducteur"
    ],
    "seducteurs": [
        "seducteur"
    ],
    "seduction": [
        "seduction"
    ],
    "seductions": [
        "seduction"
    ],
    "seductrice": [
        "seducteur"
    ],
    "seductrices": [
        "seducteur"
    ],
    "seduira": [
        "seduire"
    ],
    "seduirait": [
        "seduire"
    ],
    "seduiras": [
        "seduire"
    ],
    "seduire": [
        "seduire"
    ],
    "seduis": [
        "seduire"
    ],
    "seduisaient": [
        "seduire"
    ],
    "seduisait": [
        "seduire"
    ],
    "seduisant": [
        "seduire",
        "seduisant"
    ],
    "seduisante": [
        "seduisant"
    ],
    "seduisantes": [
        "seduisant"
    ],
    "seduisants": [
        "seduisant"
    ],
    "seduise": [
        "seduire"
    ],
    "seduisent": [
        "seduire"
    ],
    "seduises": [
        "seduire"
    ],
    "seduisez": [
        "seduire"
    ],
    "seduisirent": [
        "seduire"
    ],
    "seduisit": [
        "seduire"
    ],
    "seduit": [
        "seduire",
        "seduit"
    ],
    "seduite": [
        "seduire",
        "seduit"
    ],
    "seduites": [
        "seduire",
        "seduit"
    ],
    "seduits": [
        "seduire",
        "seduit"
    ],
    "sefarade": [
        "sefarade"
    ],
    "segregation": [
        "segregation"
    ],
    "segregationniste": [
        "segregationniste"
    ],
    "seguedille": [
        "seguedille"
    ],
    "seide": [
        "seide"
    ],
    "seides": [
        "seide"
    ],
    "seisme": [
        "seisme"
    ],
    "seismes": [
        "seisme"
    ],
    "sejour": [
        "sejour"
    ],
    "sejourna": [
        "sejourner"
    ],
    "sejournaient": [
        "sejourner"
    ],
    "sejournais": [
        "sejourner"
    ],
    "sejournait": [
        "sejourner"
    ],
    "sejournant": [
        "sejourner"
    ],
    "sejourne": [
        "sejourner"
    ],
    "sejournent": [
        "sejourner"
    ],
    "sejourner": [
        "sejourner"
    ],
    "sejourneraient": [
        "sejourner"
    ],
    "sejournerez": [
        "sejourner"
    ],
    "sejourneriez": [
        "sejourner"
    ],
    "sejournerons": [
        "sejourner"
    ],
    "sejournes": [
        "sejourner"
    ],
    "sejournez": [
        "sejourner"
    ],
    "sejourniez": [
        "sejourner"
    ],
    "sejournions": [
        "sejourner"
    ],
    "sejournames": [
        "sejourner"
    ],
    "sejours": [
        "sejour"
    ],
    "selecte": [
        "select"
    ],
    "selecteur": [
        "selecteur"
    ],
    "selecteurs": [
        "selecteur"
    ],
    "selectif": [
        "selectif"
    ],
    "selectifs": [
        "selectif"
    ],
    "selection": [
        "selection"
    ],
    "selectionna": [
        "selectionner"
    ],
    "selectionnaient": [
        "selectionner"
    ],
    "selectionnait": [
        "selectionner"
    ],
    "selectionnant": [
        "selectionner"
    ],
    "selectionne": [
        "selectionne",
        "selectionner"
    ],
    "selectionner": [
        "selectionner"
    ],
    "selectionnera": [
        "selectionner"
    ],
    "selectionnerai": [
        "selectionner"
    ],
    "selectionnerais": [
        "selectionner"
    ],
    "selectionneur": [
        "selectionneur"
    ],
    "selectionneuse": [
        "selectionneuse"
    ],
    "selectionnez": [
        "selectionner"
    ],
    "selectionnee": [
        "selectionne",
        "selectionner"
    ],
    "selectionnees": [
        "selectionne",
        "selectionner"
    ],
    "selectionnes": [
        "selectionne",
        "selectionner"
    ],
    "selections": [
        "selection",
        "selecter"
    ],
    "selective": [
        "selectif"
    ],
    "selectivement": [
        "selectivement"
    ],
    "selectives": [
        "selectif",
        "selective"
    ],
    "selectivite": [
        "selectivite"
    ],
    "selenite": [
        "selenite"
    ],
    "selenites": [
        "selenite"
    ],
    "selenium": [
        "selenium"
    ],
    "seleniure": [
        "seleniure"
    ],
    "selenographie": [
        "selenographie"
    ],
    "semantique": [
        "semantique"
    ],
    "semantiques": [
        "semantique"
    ],
    "semaphore": [
        "semaphore"
    ],
    "semaphores": [
        "semaphore"
    ],
    "semaphoriques": [
        "semaphorique"
    ],
    "semillant": [
        "semillant"
    ],
    "semillante": [
        "semillant"
    ],
    "semillon": [
        "semillon"
    ],
    "seminaire": [
        "seminaire"
    ],
    "seminaires": [
        "seminaire"
    ],
    "seminal": [
        "seminal"
    ],
    "seminale": [
        "seminal"
    ],
    "seminales": [
        "seminal"
    ],
    "seminariste": [
        "seminariste"
    ],
    "seminaristes": [
        "seminariste"
    ],
    "seminaux": [
        "seminal"
    ],
    "seminole": [
        "seminole"
    ],
    "seminoles": [
        "seminole"
    ],
    "seminome": [
        "seminome"
    ],
    "semiologie": [
        "semiologie"
    ],
    "semiologue": [
        "semiologue"
    ],
    "semiotique": [
        "semiotique"
    ],
    "semiotiques": [
        "semiotique"
    ],
    "semite": [
        "semite"
    ],
    "semites": [
        "semite"
    ],
    "semitique": [
        "semitique"
    ],
    "semitiques": [
        "semitique"
    ],
    "senat": [
        "senat"
    ],
    "senateur": [
        "senateur"
    ],
    "senateurs": [
        "senateur"
    ],
    "senatorial": [
        "senatorial"
    ],
    "senatoriale": [
        "senatorial"
    ],
    "senatoriales": [
        "senatorial"
    ],
    "senatrice": [
        "senateur"
    ],
    "senescence": [
        "senescence"
    ],
    "seneve": [
        "seneve"
    ],
    "senile": [
        "senile"
    ],
    "senilement": [
        "senilement"
    ],
    "seniles": [
        "senile"
    ],
    "senilite": [
        "senilite"
    ],
    "sene": [
        "sene"
    ],
    "senechal": [
        "senechal"
    ],
    "senechaux": [
        "senechal"
    ],
    "senegalais": [
        "senegalais"
    ],
    "senegalaise": [
        "senegalais"
    ],
    "senegalaises": [
        "senegalais"
    ],
    "senes": [
        "sene"
    ],
    "seoudite": [
        "seoudite"
    ],
    "sepale": [
        "sepale"
    ],
    "sepales": [
        "sepale"
    ],
    "separa": [
        "separer"
    ],
    "separable": [
        "separable"
    ],
    "separai": [
        "separer"
    ],
    "separaient": [
        "separer"
    ],
    "separais": [
        "separer"
    ],
    "separait": [
        "separer"
    ],
    "separant": [
        "separer"
    ],
    "separateur": [
        "separateur"
    ],
    "separation": [
        "separation"
    ],
    "separations": [
        "separation"
    ],
    "separatiste": [
        "separatiste"
    ],
    "separatistes": [
        "separatiste"
    ],
    "separatrice": [
        "separateur"
    ],
    "separe": [
        "separer",
        "separe"
    ],
    "separent": [
        "separer"
    ],
    "separer": [
        "separer"
    ],
    "separera": [
        "separer"
    ],
    "separerai": [
        "separer"
    ],
    "separeraient": [
        "separer"
    ],
    "separerais": [
        "separer"
    ],
    "separerait": [
        "separer"
    ],
    "separeras": [
        "separer"
    ],
    "separerez": [
        "separer"
    ],
    "separerons": [
        "separer"
    ],
    "separeront": [
        "separer"
    ],
    "separez": [
        "separer"
    ],
    "separiez": [
        "separer"
    ],
    "separions": [
        "separer"
    ],
    "separons": [
        "separer"
    ],
    "separames": [
        "separer"
    ],
    "separat": [
        "separer"
    ],
    "separerent": [
        "separer"
    ],
    "separee": [
        "separer",
        "separe"
    ],
    "separees": [
        "separer",
        "separe"
    ],
    "separement": [
        "separement"
    ],
    "separes": [
        "separer",
        "separe"
    ],
    "sepharade": [
        "sepharade"
    ],
    "sepharades": [
        "sepharade"
    ],
    "sepia": [
        "sepia"
    ],
    "sepias": [
        "sepia"
    ],
    "sepulcral": [
        "sepulcral"
    ],
    "sepulcrale": [
        "sepulcral"
    ],
    "sepulcrales": [
        "sepulcral"
    ],
    "sepulcre": [
        "sepulcre"
    ],
    "sepulcres": [
        "sepulcre"
    ],
    "sepulture": [
        "sepulture"
    ],
    "sepultures": [
        "sepulture"
    ],
    "sequanaise": [
        "sequanais"
    ],
    "sequelle": [
        "sequelle"
    ],
    "sequelles": [
        "sequelle"
    ],
    "sequence": [
        "sequence"
    ],
    "sequencer": [
        "sequencer"
    ],
    "sequences": [
        "sequence"
    ],
    "sequenceur": [
        "sequenceur"
    ],
    "sequentiel": [
        "sequentiel"
    ],
    "sequentielle": [
        "sequentiel"
    ],
    "sequentiellement": [
        "sequentiellement"
    ],
    "sequencage": [
        "sequencage"
    ],
    "sequestraient": [
        "sequestrer"
    ],
    "sequestrait": [
        "sequestrer"
    ],
    "sequestration": [
        "sequestration"
    ],
    "sequestrations": [
        "sequestration"
    ],
    "sequestre": [
        "sequestrer",
        "sequestre"
    ],
    "sequestrer": [
        "sequestrer"
    ],
    "sequestres": [
        "sequestrer",
        "sequestre"
    ],
    "sequestrez": [
        "sequestrer"
    ],
    "sequestree": [
        "sequestrer"
    ],
    "sequoia": [
        "sequoia"
    ],
    "sequoias": [
        "sequoia"
    ],
    "serac": [
        "serac"
    ],
    "seracs": [
        "serac"
    ],
    "serail": [
        "serail"
    ],
    "seraphin": [
        "seraphin"
    ],
    "seraphins": [
        "seraphin"
    ],
    "seraphique": [
        "seraphique"
    ],
    "seraphiques": [
        "seraphique"
    ],
    "sereux": [
        "sereux"
    ],
    "seriant": [
        "serier"
    ],
    "serie": [
        "serie"
    ],
    "seriel": [
        "seriel"
    ],
    "serielle": [
        "seriel"
    ],
    "serier": [
        "serier"
    ],
    "series": [
        "serie"
    ],
    "serieuse": [
        "serieux"
    ],
    "serieusement": [
        "serieusement"
    ],
    "serieuses": [
        "serieux"
    ],
    "serieux": [
        "serieux"
    ],
    "serique": [
        "serique"
    ],
    "serologie": [
        "serologie"
    ],
    "seronegatif": [
        "seronegatif"
    ],
    "seronegatifs": [
        "seronegatif"
    ],
    "seronegative": [
        "seronegatif"
    ],
    "seropo": [
        "seropo"
    ],
    "seropositif": [
        "seropositif"
    ],
    "seropositifs": [
        "seropositif"
    ],
    "seropositive": [
        "seropositif",
        "seropositive"
    ],
    "seropositives": [
        "seropositif"
    ],
    "seropositivite": [
        "seropositivite"
    ],
    "serosite": [
        "serosite"
    ],
    "serotonine": [
        "serotonine"
    ],
    "serum": [
        "serum"
    ],
    "serums": [
        "serum"
    ],
    "serenade": [
        "serenade"
    ],
    "serenades": [
        "serenade"
    ],
    "serenissime": [
        "serenissime"
    ],
    "serenite": [
        "serenite"
    ],
    "sesame": [
        "sesame"
    ],
    "sesamoides": [
        "sesamoide"
    ],
    "seton": [
        "seton"
    ],
    "sevi": [
        "sevir"
    ],
    "sevice": [
        "sevices"
    ],
    "sevices": [
        "sevices"
    ],
    "sevillan": [
        "sevillan"
    ],
    "sevillane": [
        "sevillan"
    ],
    "sevir": [
        "sevir"
    ],
    "sevira": [
        "sevir"
    ],
    "sevirai": [
        "sevir"
    ],
    "sevissaient": [
        "sevir"
    ],
    "sevissais": [
        "sevir"
    ],
    "sevissait": [
        "sevir"
    ],
    "sevissant": [
        "sevir"
    ],
    "sevisse": [
        "sevir"
    ],
    "sevissent": [
        "sevir"
    ],
    "sevit": [
        "sevir"
    ],
    "sevrienne": [
        "sevrienne"
    ],
    "sevriennes": [
        "sevrienne"
    ],
    "severe": [
        "severe"
    ],
    "severement": [
        "severement"
    ],
    "severes": [
        "severe"
    ],
    "severite": [
        "severite"
    ],
    "severites": [
        "severite"
    ],
    "sezigue": [
        "sezigue"
    ],
    "sumes": [
        "savoir"
    ],
    "surement": [
        "surement"
    ],
    "surete": [
        "surete"
    ],
    "suretes": [
        "surete"
    ],
    "t": [
        "t"
    ],
    "t'": [
        "t",
        "t'",
        "tu"
    ],
    "ta": [
        "ta",
        "ton"
    ],
    "tab": [
        "tab"
    ],
    "tabac": [
        "tabac"
    ],
    "tabacs": [
        "tabac"
    ],
    "tabagie": [
        "tabagie"
    ],
    "tabagies": [
        "tabagie"
    ],
    "tabagisme": [
        "tabagisme"
    ],
    "tabard": [
        "tabard"
    ],
    "tabaski": [
        "tabaski"
    ],
    "tabassage": [
        "tabassage"
    ],
    "tabassages": [
        "tabassage"
    ],
    "tabassaient": [
        "tabasser"
    ],
    "tabassais": [
        "tabasser"
    ],
    "tabassait": [
        "tabasser"
    ],
    "tabassant": [
        "tabasser"
    ],
    "tabasse": [
        "tabasser"
    ],
    "tabassent": [
        "tabasser"
    ],
    "tabasser": [
        "tabasser"
    ],
    "tabassera": [
        "tabasser"
    ],
    "tabasseraient": [
        "tabasser"
    ],
    "tabasserais": [
        "tabasser"
    ],
    "tabasses": [
        "tabasser"
    ],
    "tabassez": [
        "tabasser"
    ],
    "tabassons": [
        "tabasser"
    ],
    "tabasserent": [
        "tabasser"
    ],
    "tabassee": [
        "tabassee",
        "tabasser"
    ],
    "tabatiere": [
        "tabatiere"
    ],
    "tabatieres": [
        "tabatiere"
    ],
    "tabellion": [
        "tabellion"
    ],
    "tabellions": [
        "tabellion"
    ],
    "tabernacle": [
        "tabernacle"
    ],
    "tabernacles": [
        "tabernacle"
    ],
    "tabla": [
        "tabler",
        "tabla"
    ],
    "tablais": [
        "tabler"
    ],
    "tablant": [
        "tabler"
    ],
    "tablature": [
        "tablature"
    ],
    "table": [
        "tabler",
        "table"
    ],
    "tableau": [
        "tableau"
    ],
    "tableautin": [
        "tableautin"
    ],
    "tableautins": [
        "tableautin"
    ],
    "tableaux": [
        "tableau"
    ],
    "tabler": [
        "tabler"
    ],
    "tablerez": [
        "tabler"
    ],
    "tables": [
        "tabler",
        "table"
    ],
    "tablette": [
        "tablette"
    ],
    "tabletterie": [
        "tabletterie"
    ],
    "tablettes": [
        "tablette"
    ],
    "tableur": [
        "tableur"
    ],
    "tablier": [
        "tablier"
    ],
    "tabliers": [
        "tablier"
    ],
    "tablons": [
        "tabler"
    ],
    "tabloid": [
        "tabloid"
    ],
    "tabloide": [
        "tabloide"
    ],
    "tabloides": [
        "tabloide"
    ],
    "tabloids": [
        "tabloid"
    ],
    "tablee": [
        "tablee"
    ],
    "tablees": [
        "tablee",
        "tabler"
    ],
    "tabor": [
        "tabor"
    ],
    "taborites": [
        "taborite"
    ],
    "tabors": [
        "tabor"
    ],
    "tabou": [
        "tabou"
    ],
    "taboue": [
        "tabou",
        "tabouer"
    ],
    "taboues": [
        "tabou"
    ],
    "taboule": [
        "taboule"
    ],
    "tabouret": [
        "tabouret"
    ],
    "tabourets": [
        "tabouret"
    ],
    "tabous": [
        "tabou"
    ],
    "tabula": [
        "tabuler"
    ],
    "tabulaire": [
        "tabulaire"
    ],
    "tabulateur": [
        "tabulateur"
    ],
    "tabulations": [
        "tabulation"
    ],
    "tabes": [
        "tabes"
    ],
    "tac": [
        "tac"
    ],
    "tacatac": [
        "tacatac"
    ],
    "tacatacatac": [
        "tacatacatac"
    ],
    "tacauds": [
        "tacaud"
    ],
    "tachaient": [
        "tacher"
    ],
    "tachait": [
        "tacher"
    ],
    "tachant": [
        "tacher"
    ],
    "tache": [
        "tacher",
        "tache"
    ],
    "tachent": [
        "tacher"
    ],
    "tacher": [
        "tacher"
    ],
    "tachera": [
        "tacher"
    ],
    "tacherai": [
        "tacher"
    ],
    "tacherais": [
        "tacher"
    ],
    "tacherait": [
        "tacher"
    ],
    "taches": [
        "tacher",
        "tache"
    ],
    "tachetaient": [
        "tacheter"
    ],
    "tachetant": [
        "tacheter"
    ],
    "tacheter": [
        "tacheter"
    ],
    "tachetures": [
        "tacheture"
    ],
    "tachete": [
        "tacheter"
    ],
    "tachetee": [
        "tacheter"
    ],
    "tachetees": [
        "tacheter"
    ],
    "tachetes": [
        "tacheter"
    ],
    "tachez": [
        "tacher"
    ],
    "tachiste": [
        "tachiste"
    ],
    "tachons": [
        "tacher"
    ],
    "tachyarythmie": [
        "tachyarythmie"
    ],
    "tachycarde": [
        "tachycarder"
    ],
    "tachycardie": [
        "tachycardie"
    ],
    "tachycardies": [
        "tachycardie"
    ],
    "tachymetre": [
        "tachymetre"
    ],
    "tachyon": [
        "tachyon"
    ],
    "tachyons": [
        "tachyon"
    ],
    "tachee": [
        "tacher"
    ],
    "tachees": [
        "tacher"
    ],
    "tacheometre": [
        "tacheometre"
    ],
    "tacite": [
        "tacite"
    ],
    "tacitement": [
        "tacitement"
    ],
    "tacites": [
        "tacite"
    ],
    "taciturne": [
        "taciturne"
    ],
    "taciturnes": [
        "taciturne"
    ],
    "taciturnite": [
        "taciturnite"
    ],
    "tacle": [
        "tacle"
    ],
    "tacler": [
        "tacler"
    ],
    "taco": [
        "taco"
    ],
    "tacon": [
        "tacon"
    ],
    "taconnet": [
        "taconnet"
    ],
    "tacos": [
        "taco"
    ],
    "tacot": [
        "tacot"
    ],
    "tacots": [
        "tacot"
    ],
    "tacs": [
        "tac"
    ],
    "tact": [
        "tact"
    ],
    "tacticien": [
        "tacticien"
    ],
    "tacticienne": [
        "tacticien"
    ],
    "tacticiens": [
        "tacticien"
    ],
    "tactile": [
        "tactile"
    ],
    "tactilement": [
        "tactilement"
    ],
    "tactiles": [
        "tactile"
    ],
    "tactique": [
        "tactique"
    ],
    "tactiquement": [
        "tactiquement"
    ],
    "tactiques": [
        "tactique"
    ],
    "tadjik": [
        "tadjik"
    ],
    "tadorne": [
        "tadorne"
    ],
    "tadornes": [
        "tadorne"
    ],
    "taenia": [
        "taenia"
    ],
    "taf": [
        "taf"
    ],
    "tafanard": [
        "tafanard"
    ],
    "taffe": [
        "taffe"
    ],
    "taffes": [
        "taffe"
    ],
    "taffetas": [
        "taffetas"
    ],
    "tafia": [
        "tafia"
    ],
    "tafs": [
        "taf"
    ],
    "tag": [
        "tag"
    ],
    "tagada": [
        "tagada"
    ],
    "tagalog": [
        "tagalog"
    ],
    "tagger": [
        "tagger"
    ],
    "tagliatelle": [
        "tagliatelle"
    ],
    "tagliatelles": [
        "tagliatelle"
    ],
    "taguais": [
        "taguer"
    ],
    "tague": [
        "taguer"
    ],
    "taguer": [
        "taguer"
    ],
    "tagueur": [
        "tagueur"
    ],
    "tagueurs": [
        "tagueur"
    ],
    "tahitien": [
        "tahitien"
    ],
    "tahitienne": [
        "tahitien"
    ],
    "tahitiennes": [
        "tahitien"
    ],
    "tahitiens": [
        "tahitien"
    ],
    "taie": [
        "taie"
    ],
    "taies": [
        "taie"
    ],
    "taifas": [
        "taifa"
    ],
    "tailla": [
        "tailler"
    ],
    "taillable": [
        "taillable"
    ],
    "taillables": [
        "taillable"
    ],
    "taillada": [
        "taillader"
    ],
    "tailladait": [
        "taillader"
    ],
    "tailladant": [
        "taillader"
    ],
    "taillade": [
        "taillader",
        "taillade"
    ],
    "tailladent": [
        "taillader"
    ],
    "taillader": [
        "taillader"
    ],
    "tailladez": [
        "taillader"
    ],
    "tailladee": [
        "taillader"
    ],
    "tailladees": [
        "taillader"
    ],
    "taillades": [
        "taillader"
    ],
    "taillaient": [
        "tailler"
    ],
    "taillais": [
        "tailler"
    ],
    "taillait": [
        "tailler"
    ],
    "taillandier": [
        "taillandier"
    ],
    "taillant": [
        "tailler"
    ],
    "taillants": [
        "taillant"
    ],
    "taille": [
        "taille",
        "tailler"
    ],
    "taillent": [
        "tailler"
    ],
    "tailler": [
        "tailler"
    ],
    "taillera": [
        "tailler"
    ],
    "taillerai": [
        "tailler"
    ],
    "taillerais": [
        "tailler"
    ],
    "taillerait": [
        "tailler"
    ],
    "taillerez": [
        "tailler"
    ],
    "tailleront": [
        "tailler"
    ],
    "tailles": [
        "taille",
        "tailler"
    ],
    "tailleur": [
        "tailleur"
    ],
    "tailleurs": [
        "tailleur"
    ],
    "tailleuse": [
        "tailleuse"
    ],
    "taillez": [
        "tailler"
    ],
    "taillis": [
        "taillis"
    ],
    "tailloir": [
        "tailloir"
    ],
    "tailloirs": [
        "tailloir"
    ],
    "taillons": [
        "taillon",
        "tailler"
    ],
    "taillerent": [
        "tailler"
    ],
    "taillee": [
        "taille",
        "tailler"
    ],
    "taillees": [
        "taille",
        "tailler"
    ],
    "tain": [
        "tain"
    ],
    "taira": [
        "taire"
    ],
    "tairai": [
        "taire"
    ],
    "tairaient": [
        "taire"
    ],
    "tairais": [
        "taire"
    ],
    "tairait": [
        "taire"
    ],
    "tairas": [
        "taire"
    ],
    "taire": [
        "taire"
    ],
    "tairez": [
        "taire"
    ],
    "tairions": [
        "taire"
    ],
    "tairons": [
        "taire"
    ],
    "tairont": [
        "taire"
    ],
    "tais": [
        "taire"
    ],
    "taisaient": [
        "taire"
    ],
    "taisais": [
        "taire"
    ],
    "taisait": [
        "taire"
    ],
    "taisant": [
        "taire"
    ],
    "taise": [
        "taire"
    ],
    "taisent": [
        "taire"
    ],
    "taises": [
        "taire"
    ],
    "taiseux": [
        "taiseux"
    ],
    "taisez": [
        "taire"
    ],
    "taisiez": [
        "taire"
    ],
    "taisions": [
        "taire"
    ],
    "taisons": [
        "taire"
    ],
    "tait": [
        "taire"
    ],
    "tajine": [
        "tajine"
    ],
    "tajines": [
        "tajine"
    ],
    "tala": [
        "tala"
    ],
    "talait": [
        "taler"
    ],
    "talas": [
        "tala"
    ],
    "talbin": [
        "talbin"
    ],
    "talbins": [
        "talbin"
    ],
    "talc": [
        "talc"
    ],
    "tale": [
        "taler"
    ],
    "talent": [
        "taler",
        "talent"
    ],
    "talents": [
        "talent"
    ],
    "talentueuse": [
        "talentueux"
    ],
    "talentueusement": [
        "talentueusement"
    ],
    "talentueuses": [
        "talentueux"
    ],
    "talentueux": [
        "talentueux"
    ],
    "taler": [
        "taler"
    ],
    "taleth": [
        "taleth"
    ],
    "taleths": [
        "taleth"
    ],
    "taliban": [
        "taliban"
    ],
    "talibans": [
        "taliban"
    ],
    "talion": [
        "talion"
    ],
    "talisman": [
        "talisman"
    ],
    "talismans": [
        "talisman"
    ],
    "talkie": [
        "talkie"
    ],
    "talkies": [
        "talkie"
    ],
    "talle": [
        "talle"
    ],
    "taller": [
        "taller",
        "tall"
    ],
    "tallipot": [
        "tallipot"
    ],
    "tallons": [
        "taller"
    ],
    "talmouse": [
        "talmouse"
    ],
    "talmudique": [
        "talmudique"
    ],
    "talmudiques": [
        "talmudique"
    ],
    "talmudiste": [
        "talmudiste"
    ],
    "talmudistes": [
        "talmudiste"
    ],
    "talochaient": [
        "talocher"
    ],
    "talochait": [
        "talocher"
    ],
    "taloche": [
        "talocher",
        "taloche"
    ],
    "talocher": [
        "talocher"
    ],
    "taloches": [
        "taloche"
    ],
    "talon": [
        "talon"
    ],
    "talonna": [
        "talonner"
    ],
    "talonnades": [
        "talonnade"
    ],
    "talonnait": [
        "talonner"
    ],
    "talonnant": [
        "talonner"
    ],
    "talonne": [
        "talonner"
    ],
    "talonnent": [
        "talonner"
    ],
    "talonner": [
        "talonner"
    ],
    "talonnette": [
        "talonnette"
    ],
    "talonnettes": [
        "talonnette"
    ],
    "talonneur": [
        "talonneur"
    ],
    "talonnons": [
        "talonner"
    ],
    "talonnee": [
        "talonner"
    ],
    "talonnes": [
        "talonner"
    ],
    "talons": [
        "taler",
        "talon"
    ],
    "talqua": [
        "talquer"
    ],
    "talquer": [
        "talquer"
    ],
    "talquat": [
        "talquer"
    ],
    "talque": [
        "talquer"
    ],
    "talquees": [
        "talquer"
    ],
    "talures": [
        "talure"
    ],
    "talus": [
        "talus"
    ],
    "talee": [
        "taler",
        "tale"
    ],
    "talees": [
        "tale"
    ],
    "tales": [
        "tale"
    ],
    "tamagotchi": [
        "tamagotchi"
    ],
    "tamanoir": [
        "tamanoir"
    ],
    "tamarin": [
        "tamarin"
    ],
    "tamarinier": [
        "tamarinier"
    ],
    "tamariniers": [
        "tamarinier"
    ],
    "tamaris": [
        "tamaris"
    ],
    "tambouille": [
        "tambouille"
    ],
    "tambouilles": [
        "tambouille"
    ],
    "tambour": [
        "tambour"
    ],
    "tambourin": [
        "tambourin"
    ],
    "tambourina": [
        "tambouriner"
    ],
    "tambourinade": [
        "tambourinade"
    ],
    "tambourinaient": [
        "tambouriner"
    ],
    "tambourinaire": [
        "tambourinaire"
    ],
    "tambourinaires": [
        "tambourinaire"
    ],
    "tambourinais": [
        "tambouriner"
    ],
    "tambourinait": [
        "tambouriner"
    ],
    "tambourinant": [
        "tambouriner"
    ],
    "tambourine": [
        "tambouriner"
    ],
    "tambourinement": [
        "tambourinement"
    ],
    "tambourinent": [
        "tambouriner"
    ],
    "tambouriner": [
        "tambouriner"
    ],
    "tambourineur": [
        "tambourineur"
    ],
    "tambourins": [
        "tambourin"
    ],
    "tambourinerent": [
        "tambouriner"
    ],
    "tambourinee": [
        "tambouriner"
    ],
    "tambours": [
        "tambour"
    ],
    "tamia": [
        "tamia"
    ],
    "tamis": [
        "tamis"
    ],
    "tamisage": [
        "tamisage"
    ],
    "tamisaient": [
        "tamiser"
    ],
    "tamisais": [
        "tamiser"
    ],
    "tamisait": [
        "tamiser"
    ],
    "tamisant": [
        "tamiser"
    ],
    "tamise": [
        "tamise",
        "tamiser"
    ],
    "tamisent": [
        "tamiser"
    ],
    "tamiser": [
        "tamiser"
    ],
    "tamiseur": [
        "tamiseur"
    ],
    "tamisez": [
        "tamiser"
    ],
    "tamisee": [
        "tamise",
        "tamiser"
    ],
    "tamisees": [
        "tamise",
        "tamiser"
    ],
    "tamises": [
        "tamise",
        "tamiser"
    ],
    "tamoul": [
        "tamoul"
    ],
    "tamoure": [
        "tamoure"
    ],
    "tampax": [
        "tampax"
    ],
    "tampon": [
        "tampon"
    ],
    "tamponna": [
        "tamponner"
    ],
    "tamponnade": [
        "tamponnade"
    ],
    "tamponnage": [
        "tamponnage"
    ],
    "tamponnages": [
        "tamponnage"
    ],
    "tamponnai": [
        "tamponner"
    ],
    "tamponnaient": [
        "tamponner"
    ],
    "tamponnais": [
        "tamponner"
    ],
    "tamponnait": [
        "tamponner"
    ],
    "tamponnant": [
        "tamponner"
    ],
    "tamponne": [
        "tamponner"
    ],
    "tamponnement": [
        "tamponnement"
    ],
    "tamponnent": [
        "tamponner"
    ],
    "tamponner": [
        "tamponner"
    ],
    "tamponnera": [
        "tamponner"
    ],
    "tamponneur": [
        "tamponneur"
    ],
    "tamponneuse": [
        "tamponneur"
    ],
    "tamponneuses": [
        "tamponneur"
    ],
    "tamponnez": [
        "tamponner"
    ],
    "tamponnoir": [
        "tamponnoir"
    ],
    "tamponnoirs": [
        "tamponnoir"
    ],
    "tamponnee": [
        "tamponner"
    ],
    "tamponnes": [
        "tamponner"
    ],
    "tampons": [
        "tampon"
    ],
    "tamtam": [
        "tamtam"
    ],
    "tan": [
        "tan"
    ],
    "tanaisie": [
        "tanaisie"
    ],
    "tance": [
        "tancer"
    ],
    "tancer": [
        "tancer"
    ],
    "tanche": [
        "tanche"
    ],
    "tanches": [
        "tanche"
    ],
    "tancee": [
        "tancer"
    ],
    "tances": [
        "tancer"
    ],
    "tandem": [
        "tandem"
    ],
    "tandems": [
        "tandem"
    ],
    "tandoori": [
        "tandoori"
    ],
    "tangage": [
        "tangage"
    ],
    "tangara": [
        "tangara"
    ],
    "tangaras": [
        "tangara"
    ],
    "tangence": [
        "tangence"
    ],
    "tangent": [
        "tangent"
    ],
    "tangente": [
        "tangent",
        "tangente"
    ],
    "tangentes": [
        "tangent",
        "tangente"
    ],
    "tangentiel": [
        "tangentiel"
    ],
    "tangents": [
        "tangent"
    ],
    "tangerine": [
        "tangerine"
    ],
    "tangibilite": [
        "tangibilite"
    ],
    "tangible": [
        "tangible"
    ],
    "tangibles": [
        "tangible"
    ],
    "tango": [
        "tango"
    ],
    "tangon": [
        "tangon"
    ],
    "tangos": [
        "tango"
    ],
    "tangua": [
        "tanguer"
    ],
    "tanguaient": [
        "tanguer"
    ],
    "tanguait": [
        "tanguer"
    ],
    "tanguant": [
        "tanguer"
    ],
    "tangue": [
        "tangue",
        "tanguer"
    ],
    "tanguent": [
        "tanguer"
    ],
    "tanguer": [
        "tanguer"
    ],
    "tangueraient": [
        "tanguer"
    ],
    "tangerois": [
        "tangerois"
    ],
    "tanin": [
        "tanin"
    ],
    "taniere": [
        "taniere"
    ],
    "tanieres": [
        "taniere"
    ],
    "tank": [
        "tank"
    ],
    "tanka": [
        "tanka"
    ],
    "tanker": [
        "tanker"
    ],
    "tankers": [
        "tanker"
    ],
    "tankiste": [
        "tankiste"
    ],
    "tankistes": [
        "tankiste"
    ],
    "tanks": [
        "tank"
    ],
    "tanna": [
        "tanner"
    ],
    "tannage": [
        "tannage"
    ],
    "tannaient": [
        "tanner"
    ],
    "tannait": [
        "tanner"
    ],
    "tannant": [
        "tanner",
        "tannant"
    ],
    "tannante": [
        "tannant"
    ],
    "tannantes": [
        "tannant"
    ],
    "tanne": [
        "tanner",
        "tanne"
    ],
    "tannent": [
        "tanner"
    ],
    "tanner": [
        "tanner"
    ],
    "tannerai": [
        "tanner"
    ],
    "tannerie": [
        "tannerie"
    ],
    "tannes": [
        "tanner",
        "tanne"
    ],
    "tanneur": [
        "tanneur"
    ],
    "tanneurs": [
        "tanneur"
    ],
    "tannin": [
        "tannin"
    ],
    "tannee": [
        "tanner",
        "tanne",
        "tannee"
    ],
    "tannees": [
        "tanner",
        "tanne",
        "tannee"
    ],
    "tanrec": [
        "tanrec"
    ],
    "tans": [
        "tan"
    ],
    "tansad": [
        "tansad"
    ],
    "tant": [
        "tant"
    ],
    "tante": [
        "tante"
    ],
    "tantes": [
        "tante"
    ],
    "tantine": [
        "tantine"
    ],
    "tantines": [
        "tantine"
    ],
    "tantinet": [
        "tantinet"
    ],
    "tantiemes": [
        "tantieme"
    ],
    "tantouse": [
        "tantouse"
    ],
    "tantouses": [
        "tantouse"
    ],
    "tantouze": [
        "tantouze"
    ],
    "tantouzes": [
        "tantouze"
    ],
    "tantra": [
        "tantra"
    ],
    "tantrique": [
        "tantrique"
    ],
    "tantriques": [
        "tantrique"
    ],
    "tantrisme": [
        "tantrisme"
    ],
    "tantot": [
        "tantot"
    ],
    "tancai": [
        "tancer"
    ],
    "tancait": [
        "tancer"
    ],
    "tancant": [
        "tancer"
    ],
    "tao": [
        "tao"
    ],
    "taon": [
        "taon"
    ],
    "taons": [
        "taon"
    ],
    "taoisme": [
        "taoisme"
    ],
    "taoiste": [
        "taoiste"
    ],
    "taoistes": [
        "taoiste"
    ],
    "tap": [
        "tap"
    ],
    "tapa": [
        "taper"
    ],
    "tapage": [
        "tapage"
    ],
    "tapageait": [
        "tapager"
    ],
    "tapages": [
        "tapage"
    ],
    "tapageur": [
        "tapageur"
    ],
    "tapageurs": [
        "tapageur"
    ],
    "tapageuse": [
        "tapageur"
    ],
    "tapageuses": [
        "tapageur"
    ],
    "tapai": [
        "taper"
    ],
    "tapaient": [
        "taper"
    ],
    "tapais": [
        "taper"
    ],
    "tapait": [
        "taper"
    ],
    "tapant": [
        "taper",
        "tapant"
    ],
    "tapante": [
        "tapant"
    ],
    "tapantes": [
        "tapant"
    ],
    "tapas": [
        "taper",
        "tapa"
    ],
    "tape": [
        "taper",
        "tap",
        "tape"
    ],
    "tapecul": [
        "tapecul"
    ],
    "tapement": [
        "tapement"
    ],
    "tapements": [
        "tapement"
    ],
    "tapenade": [
        "tapenade"
    ],
    "tapent": [
        "taper"
    ],
    "taper": [
        "taper"
    ],
    "tapera": [
        "taper"
    ],
    "taperai": [
        "taper"
    ],
    "taperaient": [
        "taper"
    ],
    "taperais": [
        "taper"
    ],
    "taperait": [
        "taper"
    ],
    "taperas": [
        "taper"
    ],
    "taperez": [
        "taper"
    ],
    "taperiez": [
        "taper"
    ],
    "taperont": [
        "taper"
    ],
    "tapes": [
        "taper",
        "tap",
        "tape"
    ],
    "tapette": [
        "tapette"
    ],
    "tapettes": [
        "tapette"
    ],
    "tapeur": [
        "tapeur"
    ],
    "tapeurs": [
        "tapeur"
    ],
    "tapeuses": [
        "tapeur"
    ],
    "tapez": [
        "taper"
    ],
    "tapi": [
        "tapir",
        "tapi"
    ],
    "tapie": [
        "tapir",
        "tapi"
    ],
    "tapies": [
        "tapir",
        "tapi"
    ],
    "tapiez": [
        "taper"
    ],
    "tapin": [
        "tapin"
    ],
    "tapinage": [
        "tapinage"
    ],
    "tapinaient": [
        "tapiner"
    ],
    "tapinais": [
        "tapiner"
    ],
    "tapinait": [
        "tapiner"
    ],
    "tapinant": [
        "tapiner"
    ],
    "tapine": [
        "tapiner"
    ],
    "tapinent": [
        "tapiner"
    ],
    "tapiner": [
        "tapiner"
    ],
    "tapinera": [
        "tapiner"
    ],
    "tapinerai": [
        "tapiner"
    ],
    "tapinerais": [
        "tapiner"
    ],
    "tapines": [
        "tapiner"
    ],
    "tapineuse": [
        "tapineur"
    ],
    "tapineuses": [
        "tapineur"
    ],
    "tapins": [
        "tapin"
    ],
    "tapinee": [
        "tapiner"
    ],
    "tapioca": [
        "tapioca"
    ],
    "tapir": [
        "tapir"
    ],
    "tapira": [
        "tapir"
    ],
    "tapirs": [
        "tapir"
    ],
    "tapis": [
        "tapir",
        "tapis"
    ],
    "tapissa": [
        "tapisser"
    ],
    "tapissaient": [
        "tapisser"
    ],
    "tapissais": [
        "tapisser"
    ],
    "tapissait": [
        "tapisser"
    ],
    "tapissant": [
        "tapisser"
    ],
    "tapisse": [
        "tapisser"
    ],
    "tapissent": [
        "tapir",
        "tapisser"
    ],
    "tapisser": [
        "tapisser"
    ],
    "tapisserai": [
        "tapisser"
    ],
    "tapisserie": [
        "tapisserie"
    ],
    "tapisseries": [
        "tapisserie"
    ],
    "tapissier": [
        "tapissier"
    ],
    "tapissiers": [
        "tapissier"
    ],
    "tapissiere": [
        "tapissier"
    ],
    "tapissee": [
        "tapisser"
    ],
    "tapissees": [
        "tapisser"
    ],
    "tapisses": [
        "tapisser"
    ],
    "tapit": [
        "tapir"
    ],
    "tapons": [
        "taper"
    ],
    "tapota": [
        "tapoter"
    ],
    "tapotai": [
        "tapoter"
    ],
    "tapotaient": [
        "tapoter"
    ],
    "tapotais": [
        "tapoter"
    ],
    "tapotait": [
        "tapoter"
    ],
    "tapotant": [
        "tapoter"
    ],
    "tapote": [
        "tapoter"
    ],
    "tapotement": [
        "tapotement"
    ],
    "tapotements": [
        "tapotement"
    ],
    "tapotent": [
        "tapoter"
    ],
    "tapoter": [
        "tapoter"
    ],
    "tapotez": [
        "tapoter"
    ],
    "tapotis": [
        "tapotis"
    ],
    "tapotons": [
        "tapoter"
    ],
    "tapoterent": [
        "tapoter"
    ],
    "tapames": [
        "taper"
    ],
    "taperent": [
        "taper"
    ],
    "tapee": [
        "taper",
        "tapee",
        "tape"
    ],
    "tapees": [
        "taper",
        "tapee",
        "tape"
    ],
    "taquet": [
        "taquet"
    ],
    "taquets": [
        "taquet"
    ],
    "taquin": [
        "taquin"
    ],
    "taquina": [
        "taquiner"
    ],
    "taquinaient": [
        "taquiner"
    ],
    "taquinais": [
        "taquiner"
    ],
    "taquinait": [
        "taquiner"
    ],
    "taquinant": [
        "taquiner"
    ],
    "taquine": [
        "taquiner",
        "taquin"
    ],
    "taquinent": [
        "taquiner"
    ],
    "taquiner": [
        "taquiner"
    ],
    "taquinerait": [
        "taquiner"
    ],
    "taquinerie": [
        "taquinerie"
    ],
    "taquineries": [
        "taquinerie"
    ],
    "taquines": [
        "taquiner",
        "taquin"
    ],
    "taquinez": [
        "taquiner"
    ],
    "taquins": [
        "taquin"
    ],
    "taquinee": [
        "taquiner"
    ],
    "taquoir": [
        "taquoir"
    ],
    "tara": [
        "tarer"
    ],
    "tarabiscot": [
        "tarabiscot"
    ],
    "tarabiscotages": [
        "tarabiscotage"
    ],
    "tarabiscote": [
        "tarabiscote"
    ],
    "tarabiscotee": [
        "tarabiscote",
        "tarabiscoter"
    ],
    "tarabiscotees": [
        "tarabiscote"
    ],
    "tarabiscotes": [
        "tarabiscote",
        "tarabiscoter"
    ],
    "tarabustait": [
        "tarabuster"
    ],
    "tarabuste": [
        "tarabuster"
    ],
    "tarabustent": [
        "tarabuster"
    ],
    "tarabuster": [
        "tarabuster"
    ],
    "tarabustes": [
        "tarabuster"
    ],
    "tarabusterent": [
        "tarabuster"
    ],
    "tarama": [
        "tarama"
    ],
    "tarare": [
        "tarare"
    ],
    "taratata": [
        "taratata"
    ],
    "taraud": [
        "taraud"
    ],
    "taraudaient": [
        "tarauder"
    ],
    "taraudait": [
        "tarauder"
    ],
    "taraudant": [
        "taraudant"
    ],
    "taraude": [
        "tarauder"
    ],
    "taraudent": [
        "tarauder"
    ],
    "tarauder": [
        "tarauder"
    ],
    "tarauds": [
        "taraud"
    ],
    "tarauderent": [
        "tarauder"
    ],
    "taraudee": [
        "tarauder"
    ],
    "taraudees": [
        "tarauder"
    ],
    "taraudes": [
        "tarauder"
    ],
    "tarbais": [
        "tarbais"
    ],
    "tarbouche": [
        "tarbouche"
    ],
    "tarbouif": [
        "tarbouif"
    ],
    "tard": [
        "tard"
    ],
    "tarda": [
        "tarder"
    ],
    "tardai": [
        "tarder"
    ],
    "tardaient": [
        "tarder"
    ],
    "tardais": [
        "tarder"
    ],
    "tardait": [
        "tarder"
    ],
    "tardant": [
        "tarder"
    ],
    "tarde": [
        "tarder"
    ],
    "tardent": [
        "tarder"
    ],
    "tarder": [
        "tarder"
    ],
    "tardera": [
        "tarder"
    ],
    "tarderai": [
        "tarder"
    ],
    "tarderaient": [
        "tarder"
    ],
    "tarderais": [
        "tarder"
    ],
    "tarderait": [
        "tarder"
    ],
    "tarderas": [
        "tarder"
    ],
    "tarderez": [
        "tarder"
    ],
    "tarderie": [
        "tarderie"
    ],
    "tarderies": [
        "tarderie"
    ],
    "tarderiez": [
        "tarder"
    ],
    "tarderions": [
        "tarder"
    ],
    "tarderons": [
        "tarder"
    ],
    "tarderont": [
        "tarder"
    ],
    "tardes": [
        "tarder"
    ],
    "tardez": [
        "tarder"
    ],
    "tardiez": [
        "tarder"
    ],
    "tardif": [
        "tardif"
    ],
    "tardifs": [
        "tardif"
    ],
    "tardigrade": [
        "tardigrade"
    ],
    "tardillon": [
        "tardillon"
    ],
    "tardions": [
        "tarder"
    ],
    "tardive": [
        "tardif"
    ],
    "tardivement": [
        "tardivement"
    ],
    "tardives": [
        "tardif"
    ],
    "tardons": [
        "tarder"
    ],
    "tardames": [
        "tarder"
    ],
    "tarderent": [
        "tarder"
    ],
    "tardee": [
        "tarder"
    ],
    "tare": [
        "tarer",
        "tare"
    ],
    "tarentelle": [
        "tarentelle"
    ],
    "tarentelles": [
        "tarentelle"
    ],
    "tarentule": [
        "tarentule"
    ],
    "tarentules": [
        "tarentule"
    ],
    "tares": [
        "tarer",
        "tare"
    ],
    "taret": [
        "taret"
    ],
    "tarets": [
        "taret"
    ],
    "targe": [
        "targe"
    ],
    "targette": [
        "targette"
    ],
    "targettes": [
        "targette"
    ],
    "targua": [
        "targuer"
    ],
    "targuaient": [
        "targuer"
    ],
    "targuais": [
        "targuer"
    ],
    "targuait": [
        "targuer"
    ],
    "targuant": [
        "targuer"
    ],
    "targue": [
        "targuer"
    ],
    "targuent": [
        "targuer"
    ],
    "targuer": [
        "targuer"
    ],
    "targuez": [
        "targuer"
    ],
    "targui": [
        "targui"
    ],
    "targuat": [
        "targuer"
    ],
    "tari": [
        "tarir",
        "tari"
    ],
    "taride": [
        "taride"
    ],
    "tarie": [
        "tarir",
        "tari"
    ],
    "taries": [
        "tarir",
        "tari"
    ],
    "tarif": [
        "tarif"
    ],
    "tarification": [
        "tarification"
    ],
    "tarifications": [
        "tarification"
    ],
    "tarifie": [
        "tarifier"
    ],
    "tarifs": [
        "tarif"
    ],
    "tarifee": [
        "tarifer"
    ],
    "tarifees": [
        "tarifer"
    ],
    "tarifes": [
        "tarifer"
    ],
    "tarin": [
        "tarin"
    ],
    "tarir": [
        "tarir"
    ],
    "tarira": [
        "tarir"
    ],
    "tarirent": [
        "tarir"
    ],
    "taris": [
        "tarir",
        "tari"
    ],
    "tarissaient": [
        "tarir"
    ],
    "tarissait": [
        "tarir"
    ],
    "tarissant": [
        "tarir"
    ],
    "tarisse": [
        "tarir"
    ],
    "tarissement": [
        "tarissement"
    ],
    "tarissent": [
        "tarir"
    ],
    "tarissez": [
        "tarir"
    ],
    "tarit": [
        "tarir"
    ],
    "tariere": [
        "tariere"
    ],
    "tarieres": [
        "tariere"
    ],
    "tarlatane": [
        "tarlatane"
    ],
    "tarmac": [
        "tarmac"
    ],
    "taro": [
        "taro"
    ],
    "tarot": [
        "tarot"
    ],
    "tarots": [
        "tarot"
    ],
    "tarpan": [
        "tarpan"
    ],
    "tarpans": [
        "tarpan"
    ],
    "tarpon": [
        "tarpon"
    ],
    "tarpe": [
        "tarpe"
    ],
    "tarpeienne": [
        "tarpeienne"
    ],
    "tarse": [
        "tarse"
    ],
    "tarses": [
        "tarse"
    ],
    "tarsienne": [
        "tarsien"
    ],
    "tarsiens": [
        "tarsien"
    ],
    "tarsier": [
        "tarsier"
    ],
    "tartan": [
        "tartan"
    ],
    "tartane": [
        "tartan"
    ],
    "tartare": [
        "tartare"
    ],
    "tartares": [
        "tartare"
    ],
    "tartarin": [
        "tartarin"
    ],
    "tartarinades": [
        "tartarinade"
    ],
    "tartarins": [
        "tartarin"
    ],
    "tarte": [
        "tarte"
    ],
    "tartelette": [
        "tartelette"
    ],
    "tartelettes": [
        "tartelette"
    ],
    "tartempion": [
        "tartempion"
    ],
    "tartes": [
        "tarte"
    ],
    "tartignolle": [
        "tartignolle"
    ],
    "tartignolles": [
        "tartignolle"
    ],
    "tartina": [
        "tartiner"
    ],
    "tartinaient": [
        "tartiner"
    ],
    "tartinais": [
        "tartiner"
    ],
    "tartinait": [
        "tartiner"
    ],
    "tartinant": [
        "tartiner"
    ],
    "tartine": [
        "tartine",
        "tartiner"
    ],
    "tartinent": [
        "tartiner"
    ],
    "tartiner": [
        "tartiner"
    ],
    "tartinerait": [
        "tartiner"
    ],
    "tartines": [
        "tartine",
        "tartiner"
    ],
    "tartinez": [
        "tartiner"
    ],
    "tartinee": [
        "tartiner"
    ],
    "tartinees": [
        "tartiner"
    ],
    "tartir": [
        "tartir"
    ],
    "tartiss": [
        "tartiss"
    ],
    "tartissent": [
        "tartir"
    ],
    "tartisses": [
        "tartir"
    ],
    "tartouille": [
        "tartouille"
    ],
    "tartouilles": [
        "tartouille"
    ],
    "tartre": [
        "tartre"
    ],
    "tartufe": [
        "tartufe"
    ],
    "tartuferie": [
        "tartuferie"
    ],
    "tartuferies": [
        "tartuferie"
    ],
    "tartufferie": [
        "tartufferie"
    ],
    "tartuffes": [
        "tartuffe"
    ],
    "tarzan": [
        "tarzan"
    ],
    "tarzans": [
        "tarzan"
    ],
    "taree": [
        "tarer",
        "tare"
    ],
    "tarees": [
        "tarer",
        "tare"
    ],
    "tas": [
        "ta",
        "tas"
    ],
    "tasmanien": [
        "tasmanien"
    ],
    "tassa": [
        "tasser"
    ],
    "tassai": [
        "tasser"
    ],
    "tassaient": [
        "tasser"
    ],
    "tassais": [
        "tasser"
    ],
    "tassait": [
        "tasser"
    ],
    "tassant": [
        "tasser"
    ],
    "tasse": [
        "tasse",
        "tasser"
    ],
    "tasseau": [
        "tasseau"
    ],
    "tassement": [
        "tassement"
    ],
    "tassements": [
        "tassement"
    ],
    "tassent": [
        "tasser"
    ],
    "tasser": [
        "tasser"
    ],
    "tassera": [
        "tasser"
    ],
    "tasserai": [
        "tasser"
    ],
    "tasserait": [
        "tasser"
    ],
    "tasses": [
        "tasse",
        "tasser"
    ],
    "tassez": [
        "tasser"
    ],
    "tassiez": [
        "tasser"
    ],
    "tassili": [
        "tassili"
    ],
    "tassons": [
        "tasser"
    ],
    "tasserent": [
        "tasser"
    ],
    "tassee": [
        "tasse",
        "tasser"
    ],
    "tassees": [
        "tasse",
        "tasser"
    ],
    "tata": [
        "tater",
        "tata"
    ],
    "tatami": [
        "tatami"
    ],
    "tatamis": [
        "tatami"
    ],
    "tatane": [
        "tatane"
    ],
    "tatanes": [
        "tatane"
    ],
    "tatar": [
        "tatar"
    ],
    "tatars": [
        "tatar"
    ],
    "tatas": [
        "tata"
    ],
    "tatillon": [
        "tatillon"
    ],
    "tatillonne": [
        "tatillon"
    ],
    "tatillonner": [
        "tatillonner"
    ],
    "tatillonnes": [
        "tatillon"
    ],
    "tatillons": [
        "tatillon"
    ],
    "tatin": [
        "tatin"
    ],
    "tatou": [
        "tatou"
    ],
    "tatouage": [
        "tatouage"
    ],
    "tatouages": [
        "tatouage"
    ],
    "tatouaient": [
        "tatouer"
    ],
    "tatouait": [
        "tatouer"
    ],
    "tatoue": [
        "tatoue",
        "tatouer"
    ],
    "tatouent": [
        "tatouer"
    ],
    "tatouer": [
        "tatouer"
    ],
    "tatoueur": [
        "tatoueur"
    ],
    "tatoueurs": [
        "tatoueur"
    ],
    "tatoueuse": [
        "tatoueur"
    ],
    "tatouez": [
        "tatouer"
    ],
    "tatous": [
        "tatou"
    ],
    "tatouee": [
        "tatoue",
        "tatouer"
    ],
    "tatouees": [
        "tatoue",
        "tatouer"
    ],
    "tatoues": [
        "tatoue",
        "tatouer"
    ],
    "tau": [
        "tau"
    ],
    "taube": [
        "taube"
    ],
    "taudis": [
        "taudis"
    ],
    "taulard": [
        "taulard"
    ],
    "taularde": [
        "taulard"
    ],
    "taulardes": [
        "taulard"
    ],
    "taulards": [
        "taulard"
    ],
    "taule": [
        "taule"
    ],
    "taules": [
        "taule"
    ],
    "taulier": [
        "taulier"
    ],
    "tauliers": [
        "taulier"
    ],
    "tauliere": [
        "taulier"
    ],
    "taulieres": [
        "taulier"
    ],
    "taupe": [
        "taupe"
    ],
    "taupes": [
        "taupe"
    ],
    "taupicide": [
        "taupicide"
    ],
    "taupin": [
        "taupin"
    ],
    "taupiniere": [
        "taupiniere"
    ],
    "taupinieres": [
        "taupiniere"
    ],
    "taupinees": [
        "taupinee"
    ],
    "taure": [
        "taure"
    ],
    "taureau": [
        "taureau"
    ],
    "taureaux": [
        "taureau"
    ],
    "taurillon": [
        "taurillon"
    ],
    "taurillons": [
        "taurillon"
    ],
    "taurin": [
        "taurin"
    ],
    "taurine": [
        "taurin"
    ],
    "taurins": [
        "taurin"
    ],
    "taurobole": [
        "taurobole"
    ],
    "tauromachie": [
        "tauromachie"
    ],
    "tauromachique": [
        "tauromachique"
    ],
    "tautologie": [
        "tautologie"
    ],
    "taux": [
        "taux"
    ],
    "tavel": [
        "tavel"
    ],
    "tavelant": [
        "taveler"
    ],
    "tavelures": [
        "tavelure"
    ],
    "tavele": [
        "tavele",
        "taveler"
    ],
    "tavelee": [
        "tavele",
        "taveler"
    ],
    "tavelees": [
        "taveler"
    ],
    "taverne": [
        "taverne"
    ],
    "tavernes": [
        "taverne"
    ],
    "tavernier": [
        "tavernier"
    ],
    "taverniers": [
        "tavernier"
    ],
    "taxa": [
        "taxer"
    ],
    "taxables": [
        "taxable"
    ],
    "taxaient": [
        "taxer"
    ],
    "taxait": [
        "taxer"
    ],
    "taxant": [
        "taxer"
    ],
    "taxation": [
        "taxation"
    ],
    "taxaudier": [
        "taxaudier"
    ],
    "taxe": [
        "taxe",
        "taxer"
    ],
    "taxent": [
        "taxer"
    ],
    "taxer": [
        "taxer"
    ],
    "taxerait": [
        "taxer"
    ],
    "taxes": [
        "tax",
        "taxe",
        "taxer"
    ],
    "taxez": [
        "taxer"
    ],
    "taxi": [
        "taxi"
    ],
    "taxidermie": [
        "taxidermie"
    ],
    "taxidermiste": [
        "taxidermiste"
    ],
    "taxidermistes": [
        "taxidermiste"
    ],
    "taximan": [
        "taximan"
    ],
    "taximen": [
        "taximan"
    ],
    "taximetre": [
        "taximetre"
    ],
    "taxinomie": [
        "taxinomie"
    ],
    "taxinomique": [
        "taxinomique"
    ],
    "taxinomiste": [
        "taxinomiste"
    ],
    "taxiphone": [
        "taxiphone"
    ],
    "taxiphones": [
        "taxiphone"
    ],
    "taxis": [
        "taxi"
    ],
    "taxonomie": [
        "taxonomie"
    ],
    "taxonomique": [
        "taxonomique"
    ],
    "taxee": [
        "taxe",
        "taxer"
    ],
    "taylorisme": [
        "taylorisme"
    ],
    "taylorise": [
        "tayloriser"
    ],
    "taiaut": [
        "taiaut"
    ],
    "taiga": [
        "taiga"
    ],
    "taigas": [
        "taiga"
    ],
    "tchadiens": [
        "tchadien"
    ],
    "tchador": [
        "tchador"
    ],
    "tchao": [
        "tchao"
    ],
    "tchatchant": [
        "tchatcher"
    ],
    "tchatche": [
        "tchatche",
        "tchatcher"
    ],
    "tchatchent": [
        "tchatcher"
    ],
    "tchatcher": [
        "tchatcher"
    ],
    "tchatches": [
        "tchatcher"
    ],
    "tcherkesse": [
        "tcherkesse"
    ],
    "tchernoziom": [
        "tchernoziom"
    ],
    "tchetnik": [
        "tchetnik"
    ],
    "tchetniks": [
        "tchetnik"
    ],
    "tcheque": [
        "tcheque"
    ],
    "tcheques": [
        "tcheque"
    ],
    "tchecoslovaque": [
        "tchecoslovaque"
    ],
    "tchecoslovaques": [
        "tchecoslovaque"
    ],
    "tchekhoviennes": [
        "tchekhovien"
    ],
    "tchekiste": [
        "tchekiste"
    ],
    "tchetchene": [
        "tchetchene"
    ],
    "tchetchenes": [
        "tchetchene"
    ],
    "te": [
        "te",
        "tu"
    ],
    "team": [
        "team"
    ],
    "teams": [
        "team"
    ],
    "teaser": [
        "teaser"
    ],
    "tec": [
        "tec"
    ],
    "technicien": [
        "technicien"
    ],
    "technicienne": [
        "technicien"
    ],
    "techniciens": [
        "technicien"
    ],
    "technicite": [
        "technicite"
    ],
    "technicolor": [
        "technicolor"
    ],
    "technique": [
        "technique"
    ],
    "techniquement": [
        "techniquement"
    ],
    "techniques": [
        "technique"
    ],
    "techno": [
        "techno"
    ],
    "technocrate": [
        "technocrate"
    ],
    "technocrates": [
        "technocrate"
    ],
    "technocratique": [
        "technocratique"
    ],
    "technocratisme": [
        "technocratisme"
    ],
    "technologie": [
        "technologie"
    ],
    "technologies": [
        "technology",
        "technologie"
    ],
    "technologique": [
        "technologique"
    ],
    "technologiquement": [
        "technologiquement"
    ],
    "technologiques": [
        "technologique"
    ],
    "technetium": [
        "technetium"
    ],
    "teck": [
        "teck"
    ],
    "teckel": [
        "teckel"
    ],
    "teckels": [
        "teckel"
    ],
    "tectonique": [
        "tectonique"
    ],
    "tectoniques": [
        "tectonique"
    ],
    "tee": [
        "tee"
    ],
    "teenager": [
        "teenager"
    ],
    "teenagers": [
        "teenager"
    ],
    "tees": [
        "tee"
    ],
    "tefillin": [
        "tefillin"
    ],
    "teignais": [
        "teindre"
    ],
    "teignait": [
        "teindre"
    ],
    "teignant": [
        "teindre"
    ],
    "teigne": [
        "teigne",
        "teindre"
    ],
    "teignent": [
        "teindre"
    ],
    "teignes": [
        "teigne"
    ],
    "teigneuse": [
        "teigneux"
    ],
    "teigneuses": [
        "teigneux"
    ],
    "teigneux": [
        "teigneux"
    ],
    "teignit": [
        "teindre"
    ],
    "teille": [
        "teiller"
    ],
    "teindra": [
        "teindre"
    ],
    "teindrai": [
        "teindre"
    ],
    "teindrait": [
        "teindre"
    ],
    "teindre": [
        "teindre"
    ],
    "teins": [
        "teindre"
    ],
    "teint": [
        "teindre",
        "teint"
    ],
    "teinta": [
        "teinter"
    ],
    "teintaient": [
        "teinter"
    ],
    "teintait": [
        "teinter"
    ],
    "teintant": [
        "teinter"
    ],
    "teinte": [
        "teinter",
        "teinte",
        "teint"
    ],
    "teintent": [
        "teinter"
    ],
    "teinter": [
        "teinter"
    ],
    "teinteraient": [
        "teinter"
    ],
    "teintes": [
        "teinter",
        "teinte",
        "teint"
    ],
    "teints": [
        "teindre",
        "teint"
    ],
    "teinture": [
        "teinture"
    ],
    "teinturerie": [
        "teinturerie"
    ],
    "teintureries": [
        "teinturerie"
    ],
    "teintures": [
        "teinture"
    ],
    "teinturier": [
        "teinturier"
    ],
    "teinturiers": [
        "teinturier"
    ],
    "teinturiere": [
        "teinturier"
    ],
    "teintee": [
        "teinter"
    ],
    "teintees": [
        "teinter"
    ],
    "tek": [
        "tek"
    ],
    "tel": [
        "tel"
    ],
    "tell": [
        "tell"
    ],
    "telle": [
        "telle"
    ],
    "tellement": [
        "tellement"
    ],
    "telles": [
        "telles"
    ],
    "tellure": [
        "tellure"
    ],
    "tellurique": [
        "tellurique"
    ],
    "telluriques": [
        "tellurique"
    ],
    "tels": [
        "tels"
    ],
    "telson": [
        "telson"
    ],
    "tem": [
        "tem"
    ],
    "tempe": [
        "tempe"
    ],
    "tempera": [
        "tempera",
        "temperer"
    ],
    "tempes": [
        "tempe"
    ],
    "tempi": [
        "tempo"
    ],
    "temple": [
        "temple"
    ],
    "temples": [
        "temple"
    ],
    "templier": [
        "templier"
    ],
    "templiers": [
        "templier"
    ],
    "templiere": [
        "templier"
    ],
    "tempo": [
        "tempo"
    ],
    "temporaire": [
        "temporaire"
    ],
    "temporairement": [
        "temporairement"
    ],
    "temporaires": [
        "temporaire"
    ],
    "temporal": [
        "temporal"
    ],
    "temporale": [
        "temporal"
    ],
    "temporales": [
        "temporal"
    ],
    "temporalite": [
        "temporalite"
    ],
    "temporalites": [
        "temporalite"
    ],
    "temporaux": [
        "temporal"
    ],
    "temporel": [
        "temporel"
    ],
    "temporelle": [
        "temporel"
    ],
    "temporellement": [
        "temporellement"
    ],
    "temporelles": [
        "temporel"
    ],
    "temporels": [
        "temporel"
    ],
    "temporisaient": [
        "temporiser"
    ],
    "temporisait": [
        "temporiser"
    ],
    "temporisateur": [
        "temporisateur"
    ],
    "temporisation": [
        "temporisation"
    ],
    "temporise": [
        "temporiser"
    ],
    "temporisent": [
        "temporiser"
    ],
    "temporiser": [
        "temporiser"
    ],
    "temporiserai": [
        "temporiser"
    ],
    "temporisez": [
        "temporiser"
    ],
    "temporisons": [
        "temporiser"
    ],
    "temporisee": [
        "temporiser"
    ],
    "tempos": [
        "tempo"
    ],
    "temps": [
        "temps",
        "temp"
    ],
    "tempura": [
        "tempura"
    ],
    "tempuras": [
        "tempura"
    ],
    "tempere": [
        "tempere",
        "temperer"
    ],
    "temperaient": [
        "temperer"
    ],
    "temperait": [
        "temperer"
    ],
    "temperament": [
        "temperament"
    ],
    "temperaments": [
        "temperament"
    ],
    "temperance": [
        "temperance"
    ],
    "temperature": [
        "temperature"
    ],
    "temperatures": [
        "temperature"
    ],
    "temperer": [
        "temperer"
    ],
    "tempereraient": [
        "temperer"
    ],
    "tempererait": [
        "temperer"
    ],
    "temperee": [
        "tempere",
        "temperer"
    ],
    "temperees": [
        "tempere",
        "temperer"
    ],
    "temperes": [
        "tempere",
        "temperer"
    ],
    "tempetueux": [
        "tempetueux"
    ],
    "tempeta": [
        "tempeter"
    ],
    "tempetaient": [
        "tempeter"
    ],
    "tempetais": [
        "tempeter"
    ],
    "tempetait": [
        "tempeter"
    ],
    "tempetant": [
        "tempeter"
    ],
    "tempete": [
        "tempeter",
        "tempete"
    ],
    "tempetent": [
        "tempeter"
    ],
    "tempeter": [
        "tempeter"
    ],
    "tempetes": [
        "tempete"
    ],
    "tenable": [
        "tenable"
    ],
    "tenace": [
        "tenace"
    ],
    "tenacement": [
        "tenacement"
    ],
    "tenaces": [
        "tenace"
    ],
    "tenaient": [
        "tenir"
    ],
    "tenaillaient": [
        "tenailler"
    ],
    "tenaillait": [
        "tenailler"
    ],
    "tenaillant": [
        "tenailler"
    ],
    "tenaille": [
        "tenailler",
        "tenaille"
    ],
    "tenaillent": [
        "tenailler"
    ],
    "tenailler": [
        "tenailler"
    ],
    "tenailles": [
        "tenaille"
    ],
    "tenaillee": [
        "tenailler"
    ],
    "tenais": [
        "tenir"
    ],
    "tenait": [
        "tenir"
    ],
    "tenancier": [
        "tenancier"
    ],
    "tenanciers": [
        "tenancier"
    ],
    "tenanciere": [
        "tenancier"
    ],
    "tenancieres": [
        "tenancier"
    ],
    "tenant": [
        "tenir",
        "tenant"
    ],
    "tenante": [
        "tenant"
    ],
    "tenants": [
        "tenant"
    ],
    "tend": [
        "tendre"
    ],
    "tendaient": [
        "tendre"
    ],
    "tendais": [
        "tendre"
    ],
    "tendait": [
        "tendre"
    ],
    "tendance": [
        "tendance"
    ],
    "tendances": [
        "tendance"
    ],
    "tendancieuse": [
        "tendancieux"
    ],
    "tendancieusement": [
        "tendancieusement"
    ],
    "tendancieuses": [
        "tendancieux"
    ],
    "tendancieux": [
        "tendancieux"
    ],
    "tendant": [
        "tendre"
    ],
    "tende": [
        "tendre"
    ],
    "tendelet": [
        "tendelet"
    ],
    "tendent": [
        "tendre"
    ],
    "tender": [
        "tender"
    ],
    "tenders": [
        "tender"
    ],
    "tendeur": [
        "tendeur"
    ],
    "tendeurs": [
        "tendeur"
    ],
    "tendez": [
        "tendre"
    ],
    "tendiez": [
        "tendre"
    ],
    "tendineuses": [
        "tendineux"
    ],
    "tendinite": [
        "tendinite"
    ],
    "tendions": [
        "tendre"
    ],
    "tendirent": [
        "tendre"
    ],
    "tendis": [
        "tendre"
    ],
    "tendissent": [
        "tendre"
    ],
    "tendit": [
        "tendre"
    ],
    "tendon": [
        "tendon"
    ],
    "tendons": [
        "tendre",
        "tendon"
    ],
    "tendra": [
        "tendre"
    ],
    "tendrai": [
        "tendre"
    ],
    "tendraient": [
        "tendre"
    ],
    "tendrais": [
        "tendre"
    ],
    "tendrait": [
        "tendre"
    ],
    "tendre": [
        "tendre"
    ],
    "tendrement": [
        "tendrement"
    ],
    "tendres": [
        "tendre"
    ],
    "tendresse": [
        "tendresse"
    ],
    "tendresses": [
        "tendresse"
    ],
    "tendrete": [
        "tendrete"
    ],
    "tendron": [
        "tendron"
    ],
    "tendrons": [
        "tendre",
        "tendron"
    ],
    "tendront": [
        "tendre"
    ],
    "tends": [
        "tend",
        "tendre"
    ],
    "tendu": [
        "tendre",
        "tendu"
    ],
    "tendue": [
        "tendre",
        "tendu"
    ],
    "tendues": [
        "tendre",
        "tendu"
    ],
    "tendus": [
        "tendre",
        "tendu"
    ],
    "teneur": [
        "teneur"
    ],
    "tenez": [
        "tenir"
    ],
    "teniez": [
        "tenir"
    ],
    "tenions": [
        "tenir"
    ],
    "tenir": [
        "tenir"
    ],
    "tennis": [
        "tennis"
    ],
    "tennisman": [
        "tennisman"
    ],
    "tennismen": [
        "tennisman"
    ],
    "tenon": [
        "tenon"
    ],
    "tenons": [
        "tenir",
        "tenon"
    ],
    "tenseur": [
        "tenseur"
    ],
    "tensiometre": [
        "tensiometre"
    ],
    "tension": [
        "tension"
    ],
    "tensions": [
        "tension"
    ],
    "tenta": [
        "tenter"
    ],
    "tentaculaire": [
        "tentaculaire"
    ],
    "tentaculaires": [
        "tentaculaire"
    ],
    "tentacule": [
        "tentacule"
    ],
    "tentacules": [
        "tentacule"
    ],
    "tentai": [
        "tenter"
    ],
    "tentaient": [
        "tenter"
    ],
    "tentais": [
        "tenter"
    ],
    "tentait": [
        "tenter"
    ],
    "tentant": [
        "tenter",
        "tentant"
    ],
    "tentante": [
        "tentant"
    ],
    "tentantes": [
        "tentant"
    ],
    "tentants": [
        "tentant"
    ],
    "tentateur": [
        "tentateur"
    ],
    "tentateurs": [
        "tentateur"
    ],
    "tentation": [
        "tentation"
    ],
    "tentations": [
        "tentation"
    ],
    "tentative": [
        "tentative"
    ],
    "tentatives": [
        "tentative"
    ],
    "tentatrice": [
        "tentateur"
    ],
    "tentatrices": [
        "tentateur"
    ],
    "tente": [
        "tenter",
        "tente"
    ],
    "tentent": [
        "tenter"
    ],
    "tenter": [
        "tenter"
    ],
    "tentera": [
        "tenter"
    ],
    "tenterai": [
        "tenter"
    ],
    "tenteraient": [
        "tenter"
    ],
    "tenterais": [
        "tenter"
    ],
    "tenterait": [
        "tenter"
    ],
    "tenteras": [
        "tenter"
    ],
    "tenterez": [
        "tenter"
    ],
    "tenteriez": [
        "tenter"
    ],
    "tenterons": [
        "tenter"
    ],
    "tenteront": [
        "tenter"
    ],
    "tentes": [
        "tenter",
        "tente"
    ],
    "tentez": [
        "tenter"
    ],
    "tentiaire": [
        "tentiaire"
    ],
    "tentiez": [
        "tenter"
    ],
    "tentions": [
        "tenter"
    ],
    "tentons": [
        "tenter"
    ],
    "tenture": [
        "tenture"
    ],
    "tentures": [
        "tenture"
    ],
    "tentames": [
        "tenter"
    ],
    "tentat": [
        "tenter"
    ],
    "tenterent": [
        "tenter"
    ],
    "tentee": [
        "tenter",
        "tente"
    ],
    "tentees": [
        "tenter"
    ],
    "tenu": [
        "tenu",
        "tenir"
    ],
    "tenue": [
        "tenu",
        "tenir",
        "tenue"
    ],
    "tenues": [
        "tenu",
        "tenir",
        "tenue"
    ],
    "tenure": [
        "tenure"
    ],
    "tenus": [
        "tenu",
        "tenir"
    ],
    "tepidarium": [
        "tepidarium"
    ],
    "tequila": [
        "tequila"
    ],
    "tequilas": [
        "tequila"
    ],
    "ter": [
        "ter"
    ],
    "terce": [
        "tercer"
    ],
    "tercer": [
        "tercer"
    ],
    "tercets": [
        "tercet"
    ],
    "tercio": [
        "tercio"
    ],
    "tergal": [
        "tergal"
    ],
    "tergiversaient": [
        "tergiverser"
    ],
    "tergiversais": [
        "tergiverser"
    ],
    "tergiversant": [
        "tergiverser"
    ],
    "tergiversation": [
        "tergiversation"
    ],
    "tergiversations": [
        "tergiversation"
    ],
    "tergiverse": [
        "tergiverser"
    ],
    "tergiverser": [
        "tergiverser"
    ],
    "tergiverses": [
        "tergiverser"
    ],
    "tergiversez": [
        "tergiverser"
    ],
    "tergiversons": [
        "tergiverser"
    ],
    "terme": [
        "terme"
    ],
    "termes": [
        "terme"
    ],
    "termina": [
        "terminer"
    ],
    "terminai": [
        "terminer"
    ],
    "terminaient": [
        "terminer"
    ],
    "terminais": [
        "terminer"
    ],
    "terminaison": [
        "terminaison"
    ],
    "terminaisons": [
        "terminaison"
    ],
    "terminait": [
        "terminer"
    ],
    "terminal": [
        "terminal"
    ],
    "terminale": [
        "terminal"
    ],
    "terminales": [
        "terminal"
    ],
    "terminant": [
        "terminer"
    ],
    "terminateur": [
        "terminateur"
    ],
    "terminatrice": [
        "terminateur"
    ],
    "terminaux": [
        "terminal"
    ],
    "termine": [
        "terminer"
    ],
    "terminent": [
        "terminer"
    ],
    "terminer": [
        "terminer"
    ],
    "terminera": [
        "terminer"
    ],
    "terminerai": [
        "terminer"
    ],
    "termineraient": [
        "terminer"
    ],
    "terminerait": [
        "terminer"
    ],
    "termineras": [
        "terminer"
    ],
    "terminerez": [
        "terminer"
    ],
    "terminerons": [
        "terminer"
    ],
    "termineront": [
        "terminer"
    ],
    "termines": [
        "terminer"
    ],
    "terminez": [
        "terminer"
    ],
    "terminiez": [
        "terminer"
    ],
    "terminions": [
        "terminer"
    ],
    "terminologie": [
        "terminologie"
    ],
    "terminologique": [
        "terminologique"
    ],
    "terminons": [
        "terminer"
    ],
    "terminus": [
        "terminus"
    ],
    "terminat": [
        "terminer"
    ],
    "terminerent": [
        "terminer"
    ],
    "terminee": [
        "terminer"
    ],
    "terminees": [
        "terminer"
    ],
    "termite": [
        "termite"
    ],
    "termites": [
        "termite"
    ],
    "termitiere": [
        "termitiere"
    ],
    "termitieres": [
        "termitiere"
    ],
    "ternaire": [
        "ternaire"
    ],
    "terne": [
        "terne"
    ],
    "ternes": [
        "terne"
    ],
    "terni": [
        "ternir",
        "terni"
    ],
    "ternie": [
        "ternir",
        "terni"
    ],
    "ternies": [
        "ternir",
        "terni"
    ],
    "ternir": [
        "ternir"
    ],
    "ternirai": [
        "ternir"
    ],
    "ternirait": [
        "ternir"
    ],
    "ternis": [
        "ternir",
        "terni"
    ],
    "ternissaient": [
        "ternir"
    ],
    "ternissait": [
        "ternir"
    ],
    "ternissant": [
        "ternir"
    ],
    "ternisse": [
        "ternir"
    ],
    "ternissent": [
        "ternir"
    ],
    "ternit": [
        "ternir"
    ],
    "terra": [
        "terrer"
    ],
    "terrage": [
        "terrage"
    ],
    "terrai": [
        "terrer"
    ],
    "terraient": [
        "terrer"
    ],
    "terrain": [
        "terrain"
    ],
    "terrains": [
        "terrain"
    ],
    "terrait": [
        "terrer"
    ],
    "terramycine": [
        "terramycine"
    ],
    "terrant": [
        "terrer"
    ],
    "terraplane": [
        "terraplane"
    ],
    "terrarium": [
        "terrarium"
    ],
    "terrassa": [
        "terrasser"
    ],
    "terrassai": [
        "terrasser"
    ],
    "terrassaient": [
        "terrasser"
    ],
    "terrassait": [
        "terrasser"
    ],
    "terrassant": [
        "terrasser"
    ],
    "terrasse": [
        "terrasse",
        "terrasser"
    ],
    "terrassement": [
        "terrassement"
    ],
    "terrassements": [
        "terrassement"
    ],
    "terrasser": [
        "terrasser"
    ],
    "terrasserait": [
        "terrasser"
    ],
    "terrasses": [
        "terrasse",
        "terrasser"
    ],
    "terrassier": [
        "terrassier"
    ],
    "terrassiers": [
        "terrassier"
    ],
    "terrasson": [
        "terrasson"
    ],
    "terrassat": [
        "terrasser"
    ],
    "terrasserent": [
        "terrasser"
    ],
    "terrassee": [
        "terrasser"
    ],
    "terrassees": [
        "terrasser"
    ],
    "terre": [
        "terrer",
        "terre"
    ],
    "terreau": [
        "terreau"
    ],
    "terreaux": [
        "terreau"
    ],
    "terrent": [
        "terrer"
    ],
    "terrer": [
        "terrer"
    ],
    "terrerait": [
        "terrer"
    ],
    "terreront": [
        "terrer"
    ],
    "terres": [
        "terrer",
        "terre"
    ],
    "terrestre": [
        "terrestre"
    ],
    "terrestres": [
        "terrestre"
    ],
    "terreur": [
        "terreur"
    ],
    "terreurs": [
        "terreur"
    ],
    "terreuse": [
        "terreux"
    ],
    "terreuses": [
        "terreux"
    ],
    "terreux": [
        "terreux"
    ],
    "terrez": [
        "terrer"
    ],
    "terri": [
        "terrir",
        "terri"
    ],
    "terrible": [
        "terrible"
    ],
    "terriblement": [
        "terriblement"
    ],
    "terribles": [
        "terrible"
    ],
    "terrien": [
        "terrien"
    ],
    "terrienne": [
        "terrien"
    ],
    "terriennes": [
        "terrien"
    ],
    "terriens": [
        "terrien"
    ],
    "terrier": [
        "terrier"
    ],
    "terriers": [
        "terrier"
    ],
    "terrifia": [
        "terrifier"
    ],
    "terrifiaient": [
        "terrifier"
    ],
    "terrifiait": [
        "terrifier"
    ],
    "terrifiant": [
        "terrifiant",
        "terrifier"
    ],
    "terrifiante": [
        "terrifiant"
    ],
    "terrifiantes": [
        "terrifiant"
    ],
    "terrifiants": [
        "terrifiant"
    ],
    "terrifie": [
        "terrifier",
        "terrifie"
    ],
    "terrifient": [
        "terrifier"
    ],
    "terrifier": [
        "terrifier"
    ],
    "terrifierait": [
        "terrifier"
    ],
    "terrifiez": [
        "terrifier"
    ],
    "terrifions": [
        "terrifier"
    ],
    "terrifique": [
        "terrifique"
    ],
    "terrifiee": [
        "terrifier",
        "terrifie"
    ],
    "terrifiees": [
        "terrifier",
        "terrifie"
    ],
    "terrifies": [
        "terrifier",
        "terrify",
        "terrifie"
    ],
    "terril": [
        "terril"
    ],
    "terrils": [
        "terril"
    ],
    "terrine": [
        "terrine"
    ],
    "terrines": [
        "terrine"
    ],
    "territoire": [
        "territoire"
    ],
    "territoires": [
        "territoire"
    ],
    "territorial": [
        "territorial"
    ],
    "territoriale": [
        "territorial"
    ],
    "territorialement": [
        "territorialement"
    ],
    "territoriales": [
        "territorial"
    ],
    "territorialite": [
        "territorialite"
    ],
    "territoriaux": [
        "territorial"
    ],
    "terroir": [
        "terroir"
    ],
    "terrons": [
        "terrer"
    ],
    "terrorisa": [
        "terroriser"
    ],
    "terrorisaient": [
        "terroriser"
    ],
    "terrorisait": [
        "terroriser"
    ],
    "terrorisant": [
        "terrorisant",
        "terroriser"
    ],
    "terrorisante": [
        "terrorisant"
    ],
    "terrorisants": [
        "terrorisant"
    ],
    "terrorise": [
        "terrorise",
        "terroriser"
    ],
    "terrorisent": [
        "terroriser"
    ],
    "terroriser": [
        "terroriser"
    ],
    "terroriseront": [
        "terroriser"
    ],
    "terrorises": [
        "terrorise",
        "terroriser"
    ],
    "terrorisez": [
        "terroriser"
    ],
    "terrorisme": [
        "terrorisme"
    ],
    "terrorismes": [
        "terrorisme"
    ],
    "terroriste": [
        "terroriste"
    ],
    "terroristes": [
        "terroriste"
    ],
    "terrorisee": [
        "terrorise",
        "terroriser"
    ],
    "terrorisees": [
        "terrorise",
        "terroriser"
    ],
    "terree": [
        "terrer"
    ],
    "terrees": [
        "terrer"
    ],
    "tertiaire": [
        "tertiaire"
    ],
    "tertiaires": [
        "tertiaire"
    ],
    "tertio": [
        "tertio"
    ],
    "tertre": [
        "tertre"
    ],
    "tertres": [
        "tertre"
    ],
    "tes": [
        "tes",
        "te"
    ],
    "tesla": [
        "tesla"
    ],
    "tessiture": [
        "tessiture"
    ],
    "tesson": [
        "tesson"
    ],
    "tessons": [
        "tesson"
    ],
    "test": [
        "test"
    ],
    "testa": [
        "tester"
    ],
    "testais": [
        "tester"
    ],
    "testait": [
        "tester"
    ],
    "testament": [
        "testament"
    ],
    "testamentaire": [
        "testamentaire"
    ],
    "testamentaires": [
        "testamentaire"
    ],
    "testaments": [
        "testament"
    ],
    "testant": [
        "tester"
    ],
    "teste": [
        "tester",
        "teste"
    ],
    "testent": [
        "tester"
    ],
    "tester": [
        "tester"
    ],
    "testera": [
        "tester"
    ],
    "testeras": [
        "tester"
    ],
    "testerons": [
        "tester"
    ],
    "testeront": [
        "tester"
    ],
    "testes": [
        "tester"
    ],
    "testeur": [
        "testeur"
    ],
    "testeuse": [
        "testeur"
    ],
    "testez": [
        "tester"
    ],
    "testiculaire": [
        "testiculaire"
    ],
    "testicule": [
        "testicule"
    ],
    "testicules": [
        "testicule"
    ],
    "testiez": [
        "tester"
    ],
    "testions": [
        "tester"
    ],
    "testons": [
        "tester",
        "teston"
    ],
    "testosterone": [
        "testosterone"
    ],
    "testosterones": [
        "testosterone"
    ],
    "tests": [
        "test"
    ],
    "testu": [
        "testu"
    ],
    "testerent": [
        "tester"
    ],
    "testee": [
        "tester"
    ],
    "testees": [
        "tester"
    ],
    "tette": [
        "tette"
    ],
    "teuton": [
        "teuton"
    ],
    "teutonique": [
        "teutonique"
    ],
    "teutoniques": [
        "teutonique"
    ],
    "teutonne": [
        "teutonne",
        "teuton"
    ],
    "teutonnes": [
        "teutonne",
        "teuton"
    ],
    "teutons": [
        "teuton"
    ],
    "tex": [
        "tex"
    ],
    "texan": [
        "texan"
    ],
    "texane": [
        "texan"
    ],
    "texanes": [
        "texan"
    ],
    "texans": [
        "texan"
    ],
    "texte": [
        "texte"
    ],
    "textes": [
        "texte"
    ],
    "textile": [
        "textile"
    ],
    "textiles": [
        "textile"
    ],
    "texto": [
        "texto"
    ],
    "textologie": [
        "textologie"
    ],
    "textuel": [
        "textuel"
    ],
    "textuelle": [
        "textuel"
    ],
    "textuellement": [
        "textuellement"
    ],
    "textuelles": [
        "textuel"
    ],
    "texture": [
        "texture"
    ],
    "textures": [
        "texture"
    ],
    "thalamique": [
        "thalamique"
    ],
    "thalamus": [
        "thalamus"
    ],
    "thalasso": [
        "thalasso"
    ],
    "thalassotherapeutes": [
        "thalassotherapeute"
    ],
    "thalassotherapie": [
        "thalassotherapie"
    ],
    "thalassemie": [
        "thalassemie"
    ],
    "thaler": [
        "thaler"
    ],
    "thalers": [
        "thaler"
    ],
    "thalidomide": [
        "thalidomide"
    ],
    "thallium": [
        "thallium"
    ],
    "thalweg": [
        "thalweg"
    ],
    "thanatologie": [
        "thanatologie"
    ],
    "thanatologique": [
        "thanatologique"
    ],
    "thanatopraxie": [
        "thanatopraxie"
    ],
    "thanatos": [
        "thanatos"
    ],
    "thanksgiving": [
        "thanksgiving"
    ],
    "thatcheriennes": [
        "thatcherien"
    ],
    "thaumaturge": [
        "thaumaturge"
    ],
    "thaumaturges": [
        "thaumaturge"
    ],
    "thaumaturgie": [
        "thaumaturgie"
    ],
    "thai": [
        "thai"
    ],
    "thaie": [
        "thai"
    ],
    "thailandais": [
        "thailandais"
    ],
    "thailandaise": [
        "thailandais"
    ],
    "thailandaises": [
        "thailandais"
    ],
    "thais": [
        "thai"
    ],
    "thermal": [
        "thermal"
    ],
    "thermale": [
        "thermal"
    ],
    "thermales": [
        "thermal"
    ],
    "thermaux": [
        "thermal"
    ],
    "thermes": [
        "thermes"
    ],
    "thermidor": [
        "thermidor"
    ],
    "thermidorienne": [
        "thermidorien"
    ],
    "thermique": [
        "thermique"
    ],
    "thermiques": [
        "thermique"
    ],
    "thermite": [
        "thermite"
    ],
    "thermo": [
        "thermo"
    ],
    "thermocollants": [
        "thermocollant"
    ],
    "thermodynamique": [
        "thermodynamique"
    ],
    "thermoformage": [
        "thermoformage"
    ],
    "thermographe": [
        "thermographe"
    ],
    "thermographie": [
        "thermographie"
    ],
    "thermogene": [
        "thermogene"
    ],
    "thermoluminescence": [
        "thermoluminescence"
    ],
    "thermometre": [
        "thermometre"
    ],
    "thermometres": [
        "thermometre"
    ],
    "thermonucleaire": [
        "thermonucleaire"
    ],
    "thermonucleaires": [
        "thermonucleaire"
    ],
    "thermoregulateur": [
        "thermoregulateur"
    ],
    "thermos": [
        "thermos"
    ],
    "thermosensible": [
        "thermosensible"
    ],
    "thermostat": [
        "thermostat"
    ],
    "thermostats": [
        "thermostat"
    ],
    "thermoelectriques": [
        "thermoelectrique"
    ],
    "thesaurus": [
        "thesaurus"
    ],
    "thessalien": [
        "thessalien"
    ],
    "thessaliens": [
        "thessalien"
    ],
    "thiamine": [
        "thiamine"
    ],
    "thibaude": [
        "thibaude"
    ],
    "thomas": [
        "thomas"
    ],
    "thomisme": [
        "thomisme"
    ],
    "thomiste": [
        "thomiste"
    ],
    "thon": [
        "thon"
    ],
    "thonier": [
        "thonier"
    ],
    "thoniers": [
        "thonier"
    ],
    "thons": [
        "thon"
    ],
    "thoracentese": [
        "thoracentese"
    ],
    "thoracique": [
        "thoracique"
    ],
    "thoraciques": [
        "thoracique"
    ],
    "thoracotomie": [
        "thoracotomie"
    ],
    "thorax": [
        "thorax"
    ],
    "thorine": [
        "thorine"
    ],
    "thoron": [
        "thoron"
    ],
    "thrace": [
        "thrace"
    ],
    "thraces": [
        "thrace"
    ],
    "thrill": [
        "thrill"
    ],
    "thriller": [
        "thriller"
    ],
    "thrillers": [
        "thriller"
    ],
    "thrombolyse": [
        "thrombolyse"
    ],
    "thrombolytique": [
        "thrombolytique"
    ],
    "thrombose": [
        "thrombose"
    ],
    "thrombotique": [
        "thrombotique"
    ],
    "threne": [
        "threne"
    ],
    "thug": [
        "thug"
    ],
    "thugs": [
        "thug"
    ],
    "thune": [
        "thune"
    ],
    "thunes": [
        "thune"
    ],
    "thuriferaire": [
        "thuriferaire"
    ],
    "thuriferaires": [
        "thuriferaire"
    ],
    "thuya": [
        "thuya"
    ],
    "thuyas": [
        "thuya"
    ],
    "thym": [
        "thym"
    ],
    "thymectomie": [
        "thymectomie"
    ],
    "thymine": [
        "thymine"
    ],
    "thymus": [
        "thymus"
    ],
    "thyroxine": [
        "thyroxine"
    ],
    "thyroide": [
        "thyroide"
    ],
    "thyroidectomie": [
        "thyroidectomie"
    ],
    "thyroidien": [
        "thyroidien"
    ],
    "thyroidienne": [
        "thyroidien"
    ],
    "thyrses": [
        "thyrse"
    ],
    "thyreotoxicose": [
        "thyreotoxicose"
    ],
    "theme": [
        "theme"
    ],
    "themes": [
        "theme"
    ],
    "these": [
        "these"
    ],
    "theses": [
        "thesis",
        "these"
    ],
    "the": [
        "the"
    ],
    "thebaide": [
        "thebaide"
    ],
    "thebaides": [
        "thebaide"
    ],
    "thebaine": [
        "thebaine"
    ],
    "theier": [
        "theier"
    ],
    "theine": [
        "theine"
    ],
    "theiste": [
        "theiste"
    ],
    "theiere": [
        "theiere"
    ],
    "theieres": [
        "theiere"
    ],
    "thematique": [
        "thematique"
    ],
    "thematiquement": [
        "thematiquement"
    ],
    "thematiques": [
        "thematique"
    ],
    "theo": [
        "theo"
    ],
    "theocratique": [
        "theocratique"
    ],
    "theodolite": [
        "theodolite"
    ],
    "theologales": [
        "theologal"
    ],
    "theologie": [
        "theologie"
    ],
    "theologien": [
        "theologien"
    ],
    "theologiennes": [
        "theologien"
    ],
    "theologiens": [
        "theologien"
    ],
    "theologies": [
        "theologie",
        "theology"
    ],
    "theologique": [
        "theologique"
    ],
    "theologiquement": [
        "theologiquement"
    ],
    "theologiques": [
        "theologique"
    ],
    "theophylline": [
        "theophylline"
    ],
    "theorbe": [
        "theorbe"
    ],
    "theorbes": [
        "theorbe"
    ],
    "theoricien": [
        "theoricien"
    ],
    "theoricienne": [
        "theoricien"
    ],
    "theoriciens": [
        "theoricien"
    ],
    "theorie": [
        "theorie"
    ],
    "theories": [
        "theory",
        "theorie"
    ],
    "theorique": [
        "theorique"
    ],
    "theoriquement": [
        "theoriquement"
    ],
    "theoriques": [
        "theorique"
    ],
    "theorise": [
        "theoriser"
    ],
    "theoriser": [
        "theoriser"
    ],
    "theoreme": [
        "theoreme"
    ],
    "theoremes": [
        "theoreme"
    ],
    "theosophes": [
        "theosophe"
    ],
    "theosophie": [
        "theosophie"
    ],
    "theosophique": [
        "theosophique"
    ],
    "therapeute": [
        "therapeute"
    ],
    "therapeutes": [
        "therapeute"
    ],
    "therapeutique": [
        "therapeutique"
    ],
    "therapeutiques": [
        "therapeutique"
    ],
    "therapie": [
        "therapie"
    ],
    "therapies": [
        "therapie",
        "therapy"
    ],
    "thes": [
        "the"
    ],
    "thesard": [
        "thesard"
    ],
    "thesards": [
        "thesard"
    ],
    "thesaurise": [
        "thesauriser"
    ],
    "thesauriser": [
        "thesauriser"
    ],
    "thesaurises": [
        "thesauriser"
    ],
    "theurgiques": [
        "theurgique"
    ],
    "theatral": [
        "theatral"
    ],
    "theatrale": [
        "theatral"
    ],
    "theatralement": [
        "theatralement"
    ],
    "theatrales": [
        "theatral"
    ],
    "theatralisant": [
        "theatraliser"
    ],
    "theatralise": [
        "theatraliser"
    ],
    "theatralisee": [
        "theatraliser"
    ],
    "theatralite": [
        "theatralite"
    ],
    "theatraux": [
        "theatral"
    ],
    "theatre": [
        "theatre"
    ],
    "theatres": [
        "theatre"
    ],
    "theatreuse": [
        "theatreux"
    ],
    "theatreux": [
        "theatreux"
    ],
    "theta": [
        "theta"
    ],
    "tiama": [
        "tiama"
    ],
    "tian": [
        "tian"
    ],
    "tiare": [
        "tiare"
    ],
    "tiares": [
        "tiare"
    ],
    "tibia": [
        "tibia"
    ],
    "tibial": [
        "tibial"
    ],
    "tibiale": [
        "tibial"
    ],
    "tibias": [
        "tibia"
    ],
    "tibetain": [
        "tibetain"
    ],
    "tibetaine": [
        "tibetain"
    ],
    "tibetaines": [
        "tibetain"
    ],
    "tibetains": [
        "tibetain"
    ],
    "tic": [
        "tic"
    ],
    "ticheurte": [
        "ticheurte"
    ],
    "ticket": [
        "ticket"
    ],
    "tickets": [
        "ticket"
    ],
    "tics": [
        "tic"
    ],
    "ticsons": [
        "ticson"
    ],
    "tictaquer": [
        "tictaquer"
    ],
    "tien": [
        "tien"
    ],
    "tiendra": [
        "tenir"
    ],
    "tiendrai": [
        "tenir"
    ],
    "tiendraient": [
        "tenir"
    ],
    "tiendrais": [
        "tenir"
    ],
    "tiendrait": [
        "tenir"
    ],
    "tiendras": [
        "tenir"
    ],
    "tiendrez": [
        "tenir"
    ],
    "tiendriez": [
        "tenir"
    ],
    "tiendrons": [
        "tenir"
    ],
    "tiendront": [
        "tenir"
    ],
    "tienne": [
        "tenir",
        "tienne"
    ],
    "tiennent": [
        "tenir"
    ],
    "tiennes": [
        "tiennes",
        "tenir"
    ],
    "tiens": [
        "tenir",
        "tien",
        "tiens"
    ],
    "tient": [
        "tenir"
    ],
    "tierce": [
        "tiers",
        "tierce"
    ],
    "tiercefeuille": [
        "tiercefeuille"
    ],
    "tiercelet": [
        "tiercelet"
    ],
    "tiercelets": [
        "tiercelet"
    ],
    "tierces": [
        "tiers",
        "tierce"
    ],
    "tiers": [
        "tier",
        "tiers"
    ],
    "tif": [
        "tif"
    ],
    "tifs": [
        "tif"
    ],
    "tige": [
        "tige"
    ],
    "tigelles": [
        "tigelle"
    ],
    "tiges": [
        "tig",
        "tige"
    ],
    "tignasse": [
        "tignasse"
    ],
    "tignasses": [
        "tignasse"
    ],
    "tigre": [
        "tigrer",
        "tigre"
    ],
    "tigres": [
        "tigrer",
        "tigre"
    ],
    "tigresse": [
        "tigre"
    ],
    "tigresses": [
        "tigre"
    ],
    "tigrure": [
        "tigrure"
    ],
    "tigree": [
        "tigrer",
        "tigre"
    ],
    "tigrees": [
        "tigre"
    ],
    "tiki": [
        "tiki"
    ],
    "tilbury": [
        "tilbury"
    ],
    "tilburys": [
        "tilbury"
    ],
    "till": [
        "till"
    ],
    "tillac": [
        "tillac"
    ],
    "tillacs": [
        "tillac"
    ],
    "tille": [
        "tille"
    ],
    "tiller": [
        "tiller"
    ],
    "tilles": [
        "tille"
    ],
    "tilleul": [
        "tilleul"
    ],
    "tilleuls": [
        "tilleul"
    ],
    "tilt": [
        "tilt"
    ],
    "tilts": [
        "tilt"
    ],
    "timbale": [
        "timbale"
    ],
    "timbales": [
        "timbale"
    ],
    "timbalier": [
        "timbalier"
    ],
    "timbaliers": [
        "timbalier"
    ],
    "timbrage": [
        "timbrage"
    ],
    "timbrait": [
        "timbrer"
    ],
    "timbre": [
        "timbrer",
        "timbre"
    ],
    "timbrer": [
        "timbrer"
    ],
    "timbres": [
        "timbrer",
        "timbre"
    ],
    "timbrat": [
        "timbrer"
    ],
    "timbree": [
        "timbrer",
        "timbre"
    ],
    "timbrees": [
        "timbrer",
        "timbre"
    ],
    "timide": [
        "timide"
    ],
    "timidement": [
        "timidement"
    ],
    "timides": [
        "timide"
    ],
    "timidite": [
        "timidite"
    ],
    "timidites": [
        "timidite"
    ],
    "timing": [
        "timing",
        "time"
    ],
    "timings": [
        "timing"
    ],
    "timon": [
        "timon"
    ],
    "timonerie": [
        "timonerie"
    ],
    "timonier": [
        "timonier"
    ],
    "timoniers": [
        "timonier"
    ],
    "timons": [
        "timon"
    ],
    "timore": [
        "timore"
    ],
    "timoree": [
        "timore"
    ],
    "timorees": [
        "timore"
    ],
    "timores": [
        "timore"
    ],
    "tin": [
        "tin"
    ],
    "tine": [
        "tine"
    ],
    "tinette": [
        "tinette"
    ],
    "tinettes": [
        "tinette"
    ],
    "tinrent": [
        "tenir"
    ],
    "tins": [
        "tenir",
        "tin"
    ],
    "tinssent": [
        "tenir"
    ],
    "tint": [
        "tenir"
    ],
    "tinta": [
        "tinter"
    ],
    "tintaient": [
        "tinter"
    ],
    "tintait": [
        "tinter"
    ],
    "tintamarre": [
        "tintamarre"
    ],
    "tintamarrent": [
        "tintamarrer"
    ],
    "tintamarres": [
        "tintamarre"
    ],
    "tintamarresque": [
        "tintamarresque"
    ],
    "tintamarresques": [
        "tintamarresque"
    ],
    "tintant": [
        "tinter"
    ],
    "tinte": [
        "tinter"
    ],
    "tintement": [
        "tintement"
    ],
    "tintements": [
        "tintement"
    ],
    "tintent": [
        "tinter"
    ],
    "tinter": [
        "tinter"
    ],
    "tintin": [
        "tintin"
    ],
    "tintinnabula": [
        "tintinnabuler"
    ],
    "tintinnabulaient": [
        "tintinnabuler"
    ],
    "tintinnabulant": [
        "tintinnabulant",
        "tintinnabuler"
    ],
    "tintinnabulante": [
        "tintinnabulant"
    ],
    "tintinnabulantes": [
        "tintinnabulant"
    ],
    "tintinnabulants": [
        "tintinnabulant"
    ],
    "tintinnabule": [
        "tintinnabuler"
    ],
    "tintinnabulement": [
        "tintinnabulement"
    ],
    "tintinnabulements": [
        "tintinnabulement"
    ],
    "tintinnabulent": [
        "tintinnabuler"
    ],
    "tintinnabuler": [
        "tintinnabuler"
    ],
    "tintouin": [
        "tintouin"
    ],
    "tintouins": [
        "tintouin"
    ],
    "tinterent": [
        "tinter"
    ],
    "tintes": [
        "tinter"
    ],
    "tinee": [
        "tinee"
    ],
    "tipe": [
        "tiper"
    ],
    "tipi": [
        "tipi"
    ],
    "tipis": [
        "tipi"
    ],
    "tipper": [
        "tipper"
    ],
    "tipule": [
        "tipule"
    ],
    "tiqua": [
        "tiquer"
    ],
    "tiquai": [
        "tiquer"
    ],
    "tiquaient": [
        "tiquer"
    ],
    "tiquais": [
        "tiquer"
    ],
    "tiquait": [
        "tiquer"
    ],
    "tiquant": [
        "tiquer"
    ],
    "tique": [
        "tique",
        "tiquer"
    ],
    "tiquent": [
        "tiquer"
    ],
    "tiquer": [
        "tiquer"
    ],
    "tiquerais": [
        "tiquer"
    ],
    "tiques": [
        "tique"
    ],
    "tiquete": [
        "tiquete"
    ],
    "tir": [
        "tir"
    ],
    "tira": [
        "tirer"
    ],
    "tirade": [
        "tirade"
    ],
    "tirades": [
        "tirade"
    ],
    "tirage": [
        "tirage"
    ],
    "tirages": [
        "tirage"
    ],
    "tirai": [
        "tirer"
    ],
    "tiraient": [
        "tirer"
    ],
    "tirailla": [
        "tirailler"
    ],
    "tiraillaient": [
        "tirailler"
    ],
    "tiraillait": [
        "tirailler"
    ],
    "tiraillant": [
        "tirailler"
    ],
    "tiraille": [
        "tiraille",
        "tirailler"
    ],
    "tiraillement": [
        "tiraillement"
    ],
    "tiraillements": [
        "tiraillement"
    ],
    "tiraillent": [
        "tirailler"
    ],
    "tirailler": [
        "tirailler"
    ],
    "tiraillerait": [
        "tirailler"
    ],
    "tirailleries": [
        "tiraillerie"
    ],
    "tirailleur": [
        "tirailleur"
    ],
    "tirailleurs": [
        "tirailleur"
    ],
    "tiraillez": [
        "tirailler"
    ],
    "tiraillons": [
        "tirailler"
    ],
    "tiraillee": [
        "tirailler"
    ],
    "tiraillees": [
        "tirailler"
    ],
    "tirailles": [
        "tirailler"
    ],
    "tirais": [
        "tirer"
    ],
    "tirait": [
        "tirer"
    ],
    "tiramisu": [
        "tiramisu"
    ],
    "tirant": [
        "tirant",
        "tirer"
    ],
    "tirants": [
        "tirant"
    ],
    "tiras": [
        "tirer"
    ],
    "tirassent": [
        "tirasser"
    ],
    "tire": [
        "tire",
        "tirer"
    ],
    "tirebouchonner": [
        "tirebouchonner"
    ],
    "tirebouchonne": [
        "tirebouchonner"
    ],
    "tirebouchonnee": [
        "tirebouchonner"
    ],
    "tirelire": [
        "tirelire"
    ],
    "tirelirent": [
        "tirelirer"
    ],
    "tirelires": [
        "tirelire"
    ],
    "tirent": [
        "tirer"
    ],
    "tirer": [
        "tirer"
    ],
    "tirera": [
        "tirer"
    ],
    "tirerai": [
        "tirer"
    ],
    "tireraient": [
        "tirer"
    ],
    "tirerais": [
        "tirer"
    ],
    "tirerait": [
        "tirer"
    ],
    "tireras": [
        "tirer"
    ],
    "tirerez": [
        "tirer"
    ],
    "tireriez": [
        "tirer"
    ],
    "tirerions": [
        "tirer"
    ],
    "tirerons": [
        "tirer"
    ],
    "tireront": [
        "tirer"
    ],
    "tires": [
        "tire",
        "tirer"
    ],
    "tiret": [
        "tiret"
    ],
    "tirets": [
        "tiret"
    ],
    "tirette": [
        "tirette"
    ],
    "tirettes": [
        "tirette"
    ],
    "tireur": [
        "tireur"
    ],
    "tireurs": [
        "tireur"
    ],
    "tireuse": [
        "tireur"
    ],
    "tireuses": [
        "tireur"
    ],
    "tirez": [
        "tirer"
    ],
    "tiriez": [
        "tirer"
    ],
    "tirions": [
        "tirer"
    ],
    "tiroir": [
        "tiroir"
    ],
    "tiroirs": [
        "tiroir"
    ],
    "tirons": [
        "tirer"
    ],
    "tirs": [
        "tir"
    ],
    "tirames": [
        "tirer"
    ],
    "tirat": [
        "tirer"
    ],
    "tirerent": [
        "tirer"
    ],
    "tiree": [
        "tire",
        "tiree",
        "tirer"
    ],
    "tirees": [
        "tire",
        "tiree",
        "tirer"
    ],
    "tisa": [
        "tiser"
    ],
    "tisane": [
        "tisaner",
        "tisane"
    ],
    "tisanes": [
        "tisane"
    ],
    "tisaniere": [
        "tisaniere"
    ],
    "tiser": [
        "tiser"
    ],
    "tison": [
        "tison"
    ],
    "tisonna": [
        "tisonner"
    ],
    "tisonnait": [
        "tisonner"
    ],
    "tisonnant": [
        "tisonner"
    ],
    "tisonne": [
        "tisonne",
        "tisonner"
    ],
    "tisonnent": [
        "tisonner"
    ],
    "tisonner": [
        "tisonner"
    ],
    "tisonnier": [
        "tisonnier"
    ],
    "tisonniers": [
        "tisonnier"
    ],
    "tisonnes": [
        "tisonne"
    ],
    "tisons": [
        "tison"
    ],
    "tissa": [
        "tisser"
    ],
    "tissage": [
        "tissage"
    ],
    "tissages": [
        "tissage"
    ],
    "tissaient": [
        "tisser"
    ],
    "tissais": [
        "tisser"
    ],
    "tissait": [
        "tisser"
    ],
    "tissant": [
        "tisser"
    ],
    "tisse": [
        "tisse",
        "tisser"
    ],
    "tissent": [
        "tisser"
    ],
    "tisser": [
        "tisser"
    ],
    "tisserai": [
        "tisser"
    ],
    "tisserais": [
        "tisser"
    ],
    "tisserait": [
        "tisser"
    ],
    "tisserand": [
        "tisserand"
    ],
    "tisserande": [
        "tisserand"
    ],
    "tisserands": [
        "tisserand"
    ],
    "tisserons": [
        "tisser"
    ],
    "tisseur": [
        "tisseur"
    ],
    "tisseuse": [
        "tisseur"
    ],
    "tissez": [
        "tisser"
    ],
    "tissons": [
        "tisser"
    ],
    "tissu": [
        "tissu"
    ],
    "tissue": [
        "tissu"
    ],
    "tissues": [
        "tissu",
        "tissue"
    ],
    "tissulaire": [
        "tissulaire"
    ],
    "tissulaires": [
        "tissulaire"
    ],
    "tissus": [
        "tissu"
    ],
    "tissuterie": [
        "tissuterie"
    ],
    "tissutier": [
        "tissutier"
    ],
    "tissat": [
        "tisser"
    ],
    "tisserent": [
        "tisser"
    ],
    "tissee": [
        "tisse",
        "tisser"
    ],
    "tissees": [
        "tisse",
        "tisser"
    ],
    "tisses": [
        "tisse",
        "tisser"
    ],
    "titan": [
        "titan"
    ],
    "titane": [
        "titane"
    ],
    "titanesque": [
        "titanesque"
    ],
    "titanesques": [
        "titanesque"
    ],
    "titanique": [
        "titanique"
    ],
    "titans": [
        "titan"
    ],
    "titi": [
        "titi"
    ],
    "titilla": [
        "titiller"
    ],
    "titillaient": [
        "titiller"
    ],
    "titillais": [
        "titiller"
    ],
    "titillait": [
        "titiller"
    ],
    "titillant": [
        "titiller"
    ],
    "titillation": [
        "titillation"
    ],
    "titillations": [
        "titillation"
    ],
    "titille": [
        "titiller"
    ],
    "titillement": [
        "titillement"
    ],
    "titillements": [
        "titillement"
    ],
    "titillent": [
        "titiller"
    ],
    "titiller": [
        "titiller"
    ],
    "titillera": [
        "titiller"
    ],
    "titillees": [
        "titiller"
    ],
    "titilles": [
        "titiller"
    ],
    "titis": [
        "titi"
    ],
    "titisme": [
        "titisme"
    ],
    "titra": [
        "titrer"
    ],
    "titrage": [
        "titrage"
    ],
    "titrait": [
        "titrer"
    ],
    "titre": [
        "titrer",
        "titre"
    ],
    "titrer": [
        "titrer"
    ],
    "titres": [
        "titrer",
        "titre"
    ],
    "titree": [
        "titrer",
        "titre"
    ],
    "titrees": [
        "titre"
    ],
    "tituba": [
        "tituber"
    ],
    "titubai": [
        "tituber"
    ],
    "titubaient": [
        "tituber"
    ],
    "titubais": [
        "tituber"
    ],
    "titubait": [
        "tituber"
    ],
    "titubant": [
        "tituber",
        "titubant"
    ],
    "titubante": [
        "titubant"
    ],
    "titubantes": [
        "titubant"
    ],
    "titubants": [
        "titubant"
    ],
    "titubation": [
        "titubation"
    ],
    "titubations": [
        "titubation"
    ],
    "titube": [
        "tituber"
    ],
    "titubement": [
        "titubement"
    ],
    "titubent": [
        "tituber"
    ],
    "tituber": [
        "tituber"
    ],
    "titubez": [
        "tituber"
    ],
    "titubiez": [
        "tituber"
    ],
    "titubions": [
        "tituber"
    ],
    "tituberent": [
        "tituber"
    ],
    "titulaire": [
        "titulaire"
    ],
    "titulaires": [
        "titulaire"
    ],
    "titularisation": [
        "titularisation"
    ],
    "titulariser": [
        "titulariser"
    ],
    "titularise": [
        "titulariser"
    ],
    "titularisee": [
        "titulariser"
    ],
    "tiede": [
        "tiede"
    ],
    "tiedement": [
        "tiedement"
    ],
    "tiedes": [
        "tiede"
    ],
    "tiedasse": [
        "tiedasse"
    ],
    "tiedasses": [
        "tiedasse"
    ],
    "tiedeur": [
        "tiedeur"
    ],
    "tiedeurs": [
        "tiedeur"
    ],
    "tiedi": [
        "tiedir"
    ],
    "tiedie": [
        "tiedir"
    ],
    "tiedies": [
        "tiedir"
    ],
    "tiedir": [
        "tiedir"
    ],
    "tiedirait": [
        "tiedir"
    ],
    "tiedis": [
        "tiedir"
    ],
    "tiedissaient": [
        "tiedir"
    ],
    "tiedissait": [
        "tiedir"
    ],
    "tiedissant": [
        "tiedir"
    ],
    "tiedissent": [
        "tiedir"
    ],
    "tiedit": [
        "tiedir"
    ],
    "to": [
        "to"
    ],
    "toast": [
        "toast"
    ],
    "toaster": [
        "toaster"
    ],
    "toasteur": [
        "toasteur"
    ],
    "toasts": [
        "toast"
    ],
    "toaste": [
        "toaster"
    ],
    "toboggan": [
        "toboggan"
    ],
    "toboggans": [
        "toboggan"
    ],
    "toc": [
        "toc.",
        "toc"
    ],
    "tocade": [
        "tocade"
    ],
    "tocante": [
        "tocante"
    ],
    "tocard": [
        "tocard"
    ],
    "tocarde": [
        "tocard"
    ],
    "tocardes": [
        "tocard"
    ],
    "tocards": [
        "tocard"
    ],
    "toccata": [
        "toccata"
    ],
    "tocs": [
        "toc"
    ],
    "tocsin": [
        "tocsin"
    ],
    "tocsins": [
        "tocsin"
    ],
    "toffee": [
        "toffee"
    ],
    "tofu": [
        "tofu"
    ],
    "toge": [
        "toge"
    ],
    "toges": [
        "toge"
    ],
    "togolais": [
        "togolais"
    ],
    "togolaise": [
        "togolais"
    ],
    "togolaises": [
        "togolais"
    ],
    "toi": [
        "toi",
        "tu"
    ],
    "toilasses": [
        "toiler"
    ],
    "toile": [
        "toiler",
        "toile"
    ],
    "toiles": [
        "toiler",
        "toile"
    ],
    "toiletta": [
        "toiletter"
    ],
    "toilettage": [
        "toilettage"
    ],
    "toilettait": [
        "toiletter"
    ],
    "toilette": [
        "toiletter",
        "toilette"
    ],
    "toiletter": [
        "toiletter"
    ],
    "toilettes": [
        "toiletter",
        "toilette"
    ],
    "toiletteur": [
        "toiletteur"
    ],
    "toilettees": [
        "toiletter"
    ],
    "toilee": [
        "toiler"
    ],
    "toisa": [
        "toiser"
    ],
    "toisaient": [
        "toiser"
    ],
    "toisait": [
        "toiser"
    ],
    "toisant": [
        "toiser"
    ],
    "toise": [
        "toiser",
        "toise"
    ],
    "toisent": [
        "toiser"
    ],
    "toiser": [
        "toiser"
    ],
    "toises": [
        "toiser",
        "toise"
    ],
    "toisez": [
        "toiser"
    ],
    "toison": [
        "toison"
    ],
    "toisons": [
        "toison"
    ],
    "toiserent": [
        "toiser"
    ],
    "toisee": [
        "toiser"
    ],
    "toit": [
        "toit"
    ],
    "toits": [
        "toit"
    ],
    "toiture": [
        "toiture"
    ],
    "toitures": [
        "toiture"
    ],
    "tokamak": [
        "tokamak"
    ],
    "tokay": [
        "tokay"
    ],
    "tokharien": [
        "tokharien"
    ],
    "tolar": [
        "tolar"
    ],
    "tolet": [
        "tolet"
    ],
    "tolets": [
        "tolet"
    ],
    "tolle": [
        "tolle"
    ],
    "tolstoien": [
        "tolstoien"
    ],
    "tolteque": [
        "tolteque"
    ],
    "tolteques": [
        "tolteque"
    ],
    "tolu": [
        "tolu"
    ],
    "toluidine": [
        "toluidine"
    ],
    "toluene": [
        "toluene"
    ],
    "tolere": [
        "tolerer"
    ],
    "tolerent": [
        "tolerer"
    ],
    "tolera": [
        "tolerer"
    ],
    "tolerable": [
        "tolerable"
    ],
    "tolerables": [
        "tolerable"
    ],
    "toleraient": [
        "tolerer"
    ],
    "tolerais": [
        "tolerer"
    ],
    "tolerait": [
        "tolerer"
    ],
    "tolerance": [
        "tolerance"
    ],
    "tolerant": [
        "tolerer",
        "tolerant"
    ],
    "tolerante": [
        "tolerant"
    ],
    "tolerantes": [
        "tolerant"
    ],
    "tolerants": [
        "tolerant"
    ],
    "tolerer": [
        "tolerer"
    ],
    "tolerera": [
        "tolerer"
    ],
    "tolererai": [
        "tolerer"
    ],
    "tolererais": [
        "tolerer"
    ],
    "tolererait": [
        "tolerer"
    ],
    "tolererions": [
        "tolerer"
    ],
    "tolererons": [
        "tolerer"
    ],
    "tolereront": [
        "tolerer"
    ],
    "tolerez": [
        "tolerer"
    ],
    "toleriez": [
        "tolerer"
    ],
    "tolerions": [
        "tolerer"
    ],
    "tolerons": [
        "tolerer"
    ],
    "tolerat": [
        "tolerer"
    ],
    "toleree": [
        "tolerer"
    ],
    "tolerees": [
        "tolerer"
    ],
    "toleres": [
        "tolerer"
    ],
    "tom": [
        "tom"
    ],
    "toma": [
        "tomer"
    ],
    "tomahawk": [
        "tomahawk"
    ],
    "tomahawks": [
        "tomahawk"
    ],
    "toman": [
        "toman"
    ],
    "tomate": [
        "tomate"
    ],
    "tomates": [
        "tomate"
    ],
    "tomba": [
        "tomber"
    ],
    "tombai": [
        "tomber"
    ],
    "tombaient": [
        "tomber"
    ],
    "tombais": [
        "tomber"
    ],
    "tombait": [
        "tomber"
    ],
    "tombal": [
        "tombal"
    ],
    "tombale": [
        "tombal"
    ],
    "tombales": [
        "tombal"
    ],
    "tombant": [
        "tombant",
        "tomber"
    ],
    "tombante": [
        "tombant"
    ],
    "tombantes": [
        "tombant"
    ],
    "tombants": [
        "tombant"
    ],
    "tombe": [
        "tomber",
        "tombe"
    ],
    "tombeau": [
        "tombeau"
    ],
    "tombeaux": [
        "tombeau"
    ],
    "tombent": [
        "tomber"
    ],
    "tomber": [
        "tomber"
    ],
    "tombera": [
        "tomber"
    ],
    "tomberai": [
        "tomber"
    ],
    "tomberaient": [
        "tomber"
    ],
    "tomberais": [
        "tomber"
    ],
    "tomberait": [
        "tomber"
    ],
    "tomberas": [
        "tomber"
    ],
    "tombereau": [
        "tombereau"
    ],
    "tombereaux": [
        "tombereau"
    ],
    "tomberez": [
        "tomber"
    ],
    "tomberiez": [
        "tomber"
    ],
    "tomberions": [
        "tomber"
    ],
    "tomberons": [
        "tomber"
    ],
    "tomberont": [
        "tomber"
    ],
    "tombes": [
        "tomber",
        "tombe"
    ],
    "tombeur": [
        "tombeur"
    ],
    "tombeurs": [
        "tombeur"
    ],
    "tombeuse": [
        "tombeur"
    ],
    "tombeuses": [
        "tombeur"
    ],
    "tombez": [
        "tomber"
    ],
    "tombiez": [
        "tomber"
    ],
    "tombions": [
        "tomber"
    ],
    "tombola": [
        "tombola"
    ],
    "tombolas": [
        "tombola"
    ],
    "tombons": [
        "tomber"
    ],
    "tombames": [
        "tomber"
    ],
    "tombat": [
        "tomber"
    ],
    "tomberent": [
        "tomber"
    ],
    "tombee": [
        "tombee",
        "tomber",
        "tombe"
    ],
    "tombees": [
        "tombee",
        "tomber",
        "tombe"
    ],
    "tome": [
        "tome"
    ],
    "tomes": [
        "tome"
    ],
    "tomettes": [
        "tomette"
    ],
    "tomme": [
        "tomme"
    ],
    "tommes": [
        "tomme"
    ],
    "tommette": [
        "tommette"
    ],
    "tommettes": [
        "tommette"
    ],
    "tommies": [
        "tommy",
        "tommies"
    ],
    "tommy": [
        "tommy"
    ],
    "tomodensitometre": [
        "tomodensitometre"
    ],
    "tomodensitometrie": [
        "tomodensitometrie"
    ],
    "tomographe": [
        "tomographe"
    ],
    "tomographie": [
        "tomographie"
    ],
    "ton": [
        "ton"
    ],
    "tonal": [
        "tonal"
    ],
    "tonale": [
        "tonal"
    ],
    "tonalite": [
        "tonalite"
    ],
    "tonalites": [
        "tonalite"
    ],
    "tond": [
        "tondre"
    ],
    "tondais": [
        "tondre"
    ],
    "tondait": [
        "tondre"
    ],
    "tondant": [
        "tondre"
    ],
    "tonde": [
        "tondre"
    ],
    "tondent": [
        "tondre"
    ],
    "tondes": [
        "tondre"
    ],
    "tondeur": [
        "tondeur"
    ],
    "tondeuse": [
        "tondeur"
    ],
    "tondeuses": [
        "tondeur"
    ],
    "tondit": [
        "tondre"
    ],
    "tondons": [
        "tondre"
    ],
    "tondrai": [
        "tondre"
    ],
    "tondrais": [
        "tondre"
    ],
    "tondre": [
        "tondre"
    ],
    "tonds": [
        "tondre"
    ],
    "tondu": [
        "tondu",
        "tondre"
    ],
    "tondue": [
        "tondu",
        "tondre"
    ],
    "tondues": [
        "tondu",
        "tondre"
    ],
    "tondus": [
        "tondu",
        "tondre"
    ],
    "toner": [
        "toner"
    ],
    "tong": [
        "tong"
    ],
    "tongs": [
        "tong"
    ],
    "tonic": [
        "tonic"
    ],
    "tonicardiaque": [
        "tonicardiaque"
    ],
    "tonicite": [
        "tonicite"
    ],
    "tonics": [
        "tonic"
    ],
    "tonie": [
        "tonie"
    ],
    "tonifiaient": [
        "tonifier"
    ],
    "tonifiant": [
        "tonifiant",
        "tonifier"
    ],
    "tonifiante": [
        "tonifiant"
    ],
    "tonifiants": [
        "tonifiant"
    ],
    "tonifie": [
        "tonifier"
    ],
    "tonifient": [
        "tonifier"
    ],
    "tonifier": [
        "tonifier"
    ],
    "tonique": [
        "tonique"
    ],
    "toniques": [
        "tonique"
    ],
    "tonitrua": [
        "tonitruer"
    ],
    "tonitruaient": [
        "tonitruer"
    ],
    "tonitruais": [
        "tonitruer"
    ],
    "tonitruait": [
        "tonitruer"
    ],
    "tonitruance": [
        "tonitruance"
    ],
    "tonitruances": [
        "tonitruance"
    ],
    "tonitruant": [
        "tonitruer",
        "tonitruant"
    ],
    "tonitruante": [
        "tonitruant"
    ],
    "tonitruantes": [
        "tonitruant"
    ],
    "tonitruants": [
        "tonitruant"
    ],
    "tonitrue": [
        "tonitruer"
    ],
    "tonitruent": [
        "tonitruer"
    ],
    "tonitruer": [
        "tonitruer"
    ],
    "tonka": [
        "tonka"
    ],
    "tonkinois": [
        "tonkinois"
    ],
    "tonkinoise": [
        "tonkinois"
    ],
    "tonna": [
        "tonner"
    ],
    "tonnage": [
        "tonnage"
    ],
    "tonnages": [
        "tonnage"
    ],
    "tonnaient": [
        "tonner"
    ],
    "tonnais": [
        "tonner"
    ],
    "tonnait": [
        "tonner"
    ],
    "tonnant": [
        "tonner",
        "tonnant"
    ],
    "tonnante": [
        "tonnant"
    ],
    "tonnantes": [
        "tonnant"
    ],
    "tonnants": [
        "tonnant"
    ],
    "tonne": [
        "tonner",
        "tonne"
    ],
    "tonneau": [
        "tonneau"
    ],
    "tonneaux": [
        "tonneau"
    ],
    "tonnelet": [
        "tonnelet"
    ],
    "tonnelets": [
        "tonnelet"
    ],
    "tonnelier": [
        "tonnelier"
    ],
    "tonneliers": [
        "tonnelier"
    ],
    "tonnelle": [
        "tonnelle"
    ],
    "tonnellerie": [
        "tonnellerie"
    ],
    "tonnelleries": [
        "tonnellerie"
    ],
    "tonnelles": [
        "tonnelle"
    ],
    "tonnent": [
        "tonner"
    ],
    "tonner": [
        "tonner",
        "ton"
    ],
    "tonnerait": [
        "tonner"
    ],
    "tonnerre": [
        "tonnerre"
    ],
    "tonnerres": [
        "tonnerre"
    ],
    "tonnes": [
        "tonner",
        "tonne"
    ],
    "tonnez": [
        "tonner"
    ],
    "tons": [
        "ton"
    ],
    "tonsure": [
        "tonsure",
        "tonsurer"
    ],
    "tonsures": [
        "tonsure"
    ],
    "tonte": [
        "tonte"
    ],
    "tonton": [
        "tonton"
    ],
    "tontons": [
        "tonton"
    ],
    "tonus": [
        "tonus"
    ],
    "top": [
        "top"
    ],
    "topa": [
        "toper"
    ],
    "topaze": [
        "topaze"
    ],
    "topazes": [
        "topaze"
    ],
    "tope": [
        "tope",
        "toper"
    ],
    "toper": [
        "toper"
    ],
    "topette": [
        "topette"
    ],
    "topettes": [
        "topette"
    ],
    "topez": [
        "toper"
    ],
    "tophus": [
        "tophus"
    ],
    "topinambour": [
        "topinambour"
    ],
    "topinambours": [
        "topinambour"
    ],
    "topions": [
        "toper"
    ],
    "topique": [
        "topique"
    ],
    "topless": [
        "topless"
    ],
    "topo": [
        "topo"
    ],
    "topographie": [
        "topographie"
    ],
    "topographique": [
        "topographique"
    ],
    "topographiquement": [
        "topographiquement"
    ],
    "topographiques": [
        "topographique"
    ],
    "topologie": [
        "topologie"
    ],
    "topologique": [
        "topologique"
    ],
    "topons": [
        "toper"
    ],
    "toponymie": [
        "toponymie"
    ],
    "topos": [
        "topo"
    ],
    "tops": [
        "top"
    ],
    "topes": [
        "toper"
    ],
    "toqua": [
        "toquer"
    ],
    "toquade": [
        "toquade"
    ],
    "toquades": [
        "toquade"
    ],
    "toquais": [
        "toquer"
    ],
    "toquait": [
        "toquer"
    ],
    "toquant": [
        "toquer"
    ],
    "toquante": [
        "toquante"
    ],
    "toquantes": [
        "toquante"
    ],
    "toquard": [
        "toquard"
    ],
    "toquarde": [
        "toquard"
    ],
    "toquardes": [
        "toquard"
    ],
    "toquards": [
        "toquard"
    ],
    "toque": [
        "toquer",
        "toque"
    ],
    "toquer": [
        "toquer"
    ],
    "toques": [
        "toquer",
        "toque"
    ],
    "toquez": [
        "toquer"
    ],
    "toquee": [
        "toquer",
        "toque"
    ],
    "toquees": [
        "toquer",
        "toque"
    ],
    "torana": [
        "torana"
    ],
    "torcha": [
        "torcher"
    ],
    "torchaient": [
        "torcher"
    ],
    "torchais": [
        "torcher"
    ],
    "torchait": [
        "torcher"
    ],
    "torchant": [
        "torcher"
    ],
    "torchassions": [
        "torcher"
    ],
    "torche": [
        "torcher",
        "torche"
    ],
    "torchent": [
        "torcher"
    ],
    "torcher": [
        "torcher"
    ],
    "torcherais": [
        "torcher"
    ],
    "torcheras": [
        "torcher"
    ],
    "torches": [
        "torch",
        "torcher",
        "torche"
    ],
    "torchez": [
        "torcher"
    ],
    "torchis": [
        "torchis"
    ],
    "torchon": [
        "torchon"
    ],
    "torchonnait": [
        "torchonner"
    ],
    "torchonne": [
        "torchonner"
    ],
    "torchonner": [
        "torchonner"
    ],
    "torchons": [
        "torchon"
    ],
    "torchere": [
        "torchere"
    ],
    "torcheres": [
        "torchere"
    ],
    "torchee": [
        "torcher"
    ],
    "torchees": [
        "torchee"
    ],
    "tord": [
        "tordre"
    ],
    "tordage": [
        "tordage"
    ],
    "tordaient": [
        "tordre"
    ],
    "tordais": [
        "tordre"
    ],
    "tordait": [
        "tordre"
    ],
    "tordant": [
        "tordre",
        "tordant"
    ],
    "tordante": [
        "tordant"
    ],
    "tordantes": [
        "tordant"
    ],
    "tordants": [
        "tordant"
    ],
    "torde": [
        "tordre"
    ],
    "tordent": [
        "tordre"
    ],
    "tordeur": [
        "tordeur"
    ],
    "tordeurs": [
        "tordeur"
    ],
    "tordez": [
        "tordre"
    ],
    "tordiez": [
        "tordre"
    ],
    "tordion": [
        "tordion"
    ],
    "tordions": [
        "tordion"
    ],
    "tordirent": [
        "tordre"
    ],
    "tordis": [
        "tordre"
    ],
    "tordit": [
        "tordre"
    ],
    "tordra": [
        "tordre"
    ],
    "tordrai": [
        "tordre"
    ],
    "tordraient": [
        "tordre"
    ],
    "tordrais": [
        "tordre"
    ],
    "tordrait": [
        "tordre"
    ],
    "tordras": [
        "tordre"
    ],
    "tordre": [
        "tordre"
    ],
    "tordrez": [
        "tordre"
    ],
    "tordront": [
        "tordre"
    ],
    "tords": [
        "tordre"
    ],
    "tordu": [
        "tordre",
        "tordu"
    ],
    "tordue": [
        "tordre",
        "tordu"
    ],
    "tordues": [
        "tordre",
        "tordu"
    ],
    "tordus": [
        "tordre",
        "tordu"
    ],
    "tore": [
        "tear",
        "tore"
    ],
    "torera": [
        "torera"
    ],
    "torero": [
        "torero"
    ],
    "toreros": [
        "torero"
    ],
    "tores": [
        "tore"
    ],
    "torgnole": [
        "torgnole"
    ],
    "torgnoles": [
        "torgnole"
    ],
    "tories": [
        "tories",
        "tory"
    ],
    "toril": [
        "toril"
    ],
    "tornade": [
        "tornade"
    ],
    "tornades": [
        "tornade"
    ],
    "toro": [
        "toro"
    ],
    "torons": [
        "toron"
    ],
    "torpeur": [
        "torpeur"
    ],
    "torpeurs": [
        "torpeur"
    ],
    "torpide": [
        "torpide"
    ],
    "torpillage": [
        "torpillage"
    ],
    "torpillages": [
        "torpillage"
    ],
    "torpillaient": [
        "torpiller"
    ],
    "torpillait": [
        "torpiller"
    ],
    "torpille": [
        "torpiller",
        "torpille"
    ],
    "torpiller": [
        "torpiller"
    ],
    "torpillera": [
        "torpiller"
    ],
    "torpilles": [
        "torpiller",
        "torpille"
    ],
    "torpilleur": [
        "torpilleur"
    ],
    "torpilleurs": [
        "torpilleur"
    ],
    "torpillee": [
        "torpiller"
    ],
    "torpedo": [
        "torpedo"
    ],
    "torpedos": [
        "torpedo"
    ],
    "torque": [
        "torque"
    ],
    "torrent": [
        "torrent"
    ],
    "torrentiel": [
        "torrentiel"
    ],
    "torrentielle": [
        "torrentiel"
    ],
    "torrentielles": [
        "torrentiel"
    ],
    "torrentiels": [
        "torrentiel"
    ],
    "torrents": [
        "torrent"
    ],
    "torrentueuses": [
        "torrentueux"
    ],
    "torrentueux": [
        "torrentueux"
    ],
    "torride": [
        "torride"
    ],
    "torrides": [
        "torride"
    ],
    "torrefaction": [
        "torrefaction"
    ],
    "torrefiait": [
        "torrefier"
    ],
    "torrefiant": [
        "torrefier"
    ],
    "torrefie": [
        "torrefier",
        "torrefie"
    ],
    "torrefient": [
        "torrefier"
    ],
    "torrefiee": [
        "torrefie"
    ],
    "torrefiees": [
        "torrefie"
    ],
    "tors": [
        "tor",
        "tors"
    ],
    "torsada": [
        "torsader"
    ],
    "torsade": [
        "torsader",
        "torsade"
    ],
    "torsades": [
        "torsader",
        "torsade"
    ],
    "torsadee": [
        "torsader"
    ],
    "torsadees": [
        "torsader"
    ],
    "torse": [
        "torse",
        "tors"
    ],
    "torses": [
        "torse",
        "tors"
    ],
    "torsion": [
        "torsion"
    ],
    "torsions": [
        "torsion"
    ],
    "tort": [
        "tort"
    ],
    "tortellini": [
        "tortellini"
    ],
    "tortellinis": [
        "tortellini"
    ],
    "torticolis": [
        "torticolis"
    ],
    "tortil": [
        "tortil"
    ],
    "tortilla": [
        "tortiller",
        "tortilla"
    ],
    "tortillaient": [
        "tortiller"
    ],
    "tortillais": [
        "tortiller"
    ],
    "tortillait": [
        "tortiller"
    ],
    "tortillant": [
        "tortiller"
    ],
    "tortillard": [
        "tortillard"
    ],
    "tortillards": [
        "tortillard"
    ],
    "tortillas": [
        "tortilla"
    ],
    "tortille": [
        "tortiller",
        "tortille"
    ],
    "tortillement": [
        "tortillement"
    ],
    "tortillements": [
        "tortillement"
    ],
    "tortillent": [
        "tortiller"
    ],
    "tortiller": [
        "tortiller"
    ],
    "tortillez": [
        "tortiller"
    ],
    "tortillon": [
        "tortillon"
    ],
    "tortillons": [
        "tortillon"
    ],
    "tortillee": [
        "tortiller"
    ],
    "tortillees": [
        "tortiller"
    ],
    "tortilles": [
        "tortiller"
    ],
    "tortils": [
        "tortil"
    ],
    "tortionnaire": [
        "tortionnaire"
    ],
    "tortionnaires": [
        "tortionnaire"
    ],
    "tortora": [
        "tortorer"
    ],
    "tortorait": [
        "tortorer"
    ],
    "tortorant": [
        "tortorer"
    ],
    "tortore": [
        "tortorer",
        "tortore"
    ],
    "tortorent": [
        "tortorer"
    ],
    "tortorer": [
        "tortorer"
    ],
    "torts": [
        "tort"
    ],
    "tortu": [
        "tortu"
    ],
    "tortue": [
        "tortu",
        "tortue"
    ],
    "tortues": [
        "tortu",
        "tortue"
    ],
    "tortueuse": [
        "tortueux"
    ],
    "tortueuses": [
        "tortueux"
    ],
    "tortueux": [
        "tortueux"
    ],
    "tortura": [
        "torturer"
    ],
    "torturai": [
        "torturer"
    ],
    "torturaient": [
        "torturer"
    ],
    "torturais": [
        "torturer"
    ],
    "torturait": [
        "torturer"
    ],
    "torturant": [
        "torturer",
        "torturant"
    ],
    "torturante": [
        "torturant"
    ],
    "torturantes": [
        "torturant"
    ],
    "torturants": [
        "torturant"
    ],
    "torture": [
        "torturer",
        "torture"
    ],
    "torturent": [
        "torturer"
    ],
    "torturer": [
        "torturer"
    ],
    "torturera": [
        "torturer"
    ],
    "torturerai": [
        "torturer"
    ],
    "tortureraient": [
        "torturer"
    ],
    "torturerez": [
        "torturer"
    ],
    "tortureront": [
        "torturer"
    ],
    "tortures": [
        "torturer",
        "torture"
    ],
    "tortureurs": [
        "tortureur"
    ],
    "torturez": [
        "torturer"
    ],
    "torturions": [
        "torturer"
    ],
    "torturons": [
        "torturer"
    ],
    "torturerent": [
        "torturer"
    ],
    "torturee": [
        "torturer",
        "torture"
    ],
    "torturees": [
        "torturer",
        "torture"
    ],
    "tortus": [
        "tortu"
    ],
    "torve": [
        "torve"
    ],
    "torves": [
        "torve"
    ],
    "toreador": [
        "toreador"
    ],
    "toreadors": [
        "toreador"
    ],
    "toree": [
        "toreer"
    ],
    "toreer": [
        "toreer"
    ],
    "tos": [
        "to"
    ],
    "toscan": [
        "toscan"
    ],
    "toscane": [
        "toscan"
    ],
    "toscanes": [
        "toscan"
    ],
    "toscans": [
        "toscan"
    ],
    "toss": [
        "toss"
    ],
    "tosse": [
        "tosser"
    ],
    "total": [
        "total"
    ],
    "totale": [
        "total"
    ],
    "totalement": [
        "totalement"
    ],
    "totales": [
        "total"
    ],
    "totalisait": [
        "totaliser"
    ],
    "totalisant": [
        "totalisant",
        "totaliser"
    ],
    "totalisateur": [
        "totalisateur"
    ],
    "totalisation": [
        "totalisation"
    ],
    "totalise": [
        "totaliser"
    ],
    "totalisent": [
        "totaliser"
    ],
    "totaliser": [
        "totaliser"
    ],
    "totalitaire": [
        "totalitaire"
    ],
    "totalitaires": [
        "totalitaire"
    ],
    "totalitarisme": [
        "totalitarisme"
    ],
    "totalitarismes": [
        "totalitarisme"
    ],
    "totalite": [
        "totalite"
    ],
    "totalites": [
        "totalite"
    ],
    "totaux": [
        "total"
    ],
    "totem": [
        "totem"
    ],
    "totems": [
        "totem"
    ],
    "toto": [
        "toto"
    ],
    "totoche": [
        "totoche"
    ],
    "totoches": [
        "totoche"
    ],
    "toton": [
        "toton"
    ],
    "totons": [
        "toton"
    ],
    "totos": [
        "toto"
    ],
    "totemique": [
        "totemique"
    ],
    "totemiques": [
        "totemique"
    ],
    "totemisme": [
        "totemisme"
    ],
    "touareg": [
        "touareg"
    ],
    "touaregs": [
        "touareg"
    ],
    "toubab": [
        "toubab"
    ],
    "toubabs": [
        "toubab"
    ],
    "toubib": [
        "toubib"
    ],
    "toubibs": [
        "toubib"
    ],
    "toucan": [
        "toucan"
    ],
    "toucha": [
        "toucher"
    ],
    "touchai": [
        "toucher"
    ],
    "touchaient": [
        "toucher"
    ],
    "touchais": [
        "toucher"
    ],
    "touchait": [
        "toucher"
    ],
    "touchant": [
        "touchant",
        "toucher"
    ],
    "touchante": [
        "touchant"
    ],
    "touchantes": [
        "touchant"
    ],
    "touchants": [
        "touchant"
    ],
    "touche": [
        "toucher",
        "touche"
    ],
    "touchent": [
        "toucher"
    ],
    "toucher": [
        "toucher"
    ],
    "touchera": [
        "toucher"
    ],
    "toucherai": [
        "toucher"
    ],
    "toucheraient": [
        "toucher"
    ],
    "toucherais": [
        "toucher"
    ],
    "toucherait": [
        "toucher"
    ],
    "toucheras": [
        "toucher"
    ],
    "toucherez": [
        "toucher"
    ],
    "toucherions": [
        "toucher"
    ],
    "toucherons": [
        "toucher"
    ],
    "toucheront": [
        "toucher"
    ],
    "touchers": [
        "toucher"
    ],
    "touches": [
        "toucher",
        "touch",
        "touche"
    ],
    "touchette": [
        "touchette"
    ],
    "touchez": [
        "toucher"
    ],
    "touchiez": [
        "toucher"
    ],
    "touchions": [
        "toucher"
    ],
    "touchons": [
        "toucher"
    ],
    "touchotter": [
        "touchotter"
    ],
    "touchat": [
        "toucher"
    ],
    "toucherent": [
        "toucher"
    ],
    "touchee": [
        "toucher",
        "touche"
    ],
    "touchees": [
        "toucher",
        "touche"
    ],
    "toue": [
        "touer",
        "toue"
    ],
    "touer": [
        "touer"
    ],
    "toues": [
        "toue"
    ],
    "touffe": [
        "touffe"
    ],
    "touffes": [
        "touffe"
    ],
    "touffeur": [
        "touffeur"
    ],
    "touffeurs": [
        "touffeur"
    ],
    "touffu": [
        "touffu"
    ],
    "touffue": [
        "touffu"
    ],
    "touffues": [
        "touffu"
    ],
    "touffus": [
        "touffu"
    ],
    "touillais": [
        "touiller"
    ],
    "touillait": [
        "touiller"
    ],
    "touillant": [
        "touiller"
    ],
    "touille": [
        "touille",
        "touiller"
    ],
    "touillent": [
        "touiller"
    ],
    "touiller": [
        "touiller"
    ],
    "touillee": [
        "touille"
    ],
    "touillees": [
        "touille",
        "touiller"
    ],
    "touilles": [
        "touiller"
    ],
    "toujours": [
        "toujours"
    ],
    "toulonnais": [
        "toulonnais"
    ],
    "touloupes": [
        "touloupe"
    ],
    "toulousain": [
        "toulousain"
    ],
    "toulousaine": [
        "toulousain"
    ],
    "toulousaines": [
        "toulousain"
    ],
    "toulousains": [
        "toulousain"
    ],
    "toundra": [
        "toundra"
    ],
    "toundras": [
        "toundra"
    ],
    "toungouse": [
        "toungouse"
    ],
    "toupet": [
        "toupet"
    ],
    "toupets": [
        "toupet"
    ],
    "toupie": [
        "toupie"
    ],
    "toupies": [
        "toupie"
    ],
    "toupilleur": [
        "toupilleur"
    ],
    "toupinant": [
        "toupiner"
    ],
    "touque": [
        "touque"
    ],
    "touques": [
        "touque"
    ],
    "tour": [
        "tour"
    ],
    "tourangeau": [
        "tourangeau"
    ],
    "tourangeaux": [
        "tourangeau"
    ],
    "tourangelle": [
        "tourangeau"
    ],
    "tourangelles": [
        "tourangeau"
    ],
    "tourbe": [
        "tourbe"
    ],
    "tourbes": [
        "tourbe"
    ],
    "tourbeuse": [
        "tourbeux"
    ],
    "tourbeux": [
        "tourbeux"
    ],
    "tourbiers": [
        "tourbier"
    ],
    "tourbillon": [
        "tourbillon"
    ],
    "tourbillonna": [
        "tourbillonner"
    ],
    "tourbillonnaient": [
        "tourbillonner"
    ],
    "tourbillonnaire": [
        "tourbillonnaire"
    ],
    "tourbillonnais": [
        "tourbillonner"
    ],
    "tourbillonnait": [
        "tourbillonner"
    ],
    "tourbillonnant": [
        "tourbillonnant",
        "tourbillonner"
    ],
    "tourbillonnante": [
        "tourbillonnant"
    ],
    "tourbillonnantes": [
        "tourbillonnant"
    ],
    "tourbillonnants": [
        "tourbillonnant"
    ],
    "tourbillonne": [
        "tourbillonner"
    ],
    "tourbillonnement": [
        "tourbillonnement"
    ],
    "tourbillonnements": [
        "tourbillonnement"
    ],
    "tourbillonnent": [
        "tourbillonner"
    ],
    "tourbillonner": [
        "tourbillonner"
    ],
    "tourbillonnez": [
        "tourbillonner"
    ],
    "tourbillonnerent": [
        "tourbillonner"
    ],
    "tourbillons": [
        "tourbillon"
    ],
    "tourbiere": [
        "tourbiere"
    ],
    "tourbieres": [
        "tourbiere"
    ],
    "tourde": [
        "tourd"
    ],
    "tourelle": [
        "tourelle"
    ],
    "tourelles": [
        "tourelle"
    ],
    "touret": [
        "touret"
    ],
    "tourillon": [
        "tourillon"
    ],
    "tourisme": [
        "tourisme"
    ],
    "touriste": [
        "touriste"
    ],
    "touristes": [
        "touriste"
    ],
    "touristique": [
        "touristique"
    ],
    "touristiques": [
        "touristique"
    ],
    "touriere": [
        "tourier"
    ],
    "tourlourou": [
        "tourlourou"
    ],
    "tourlousine": [
        "tourlousine"
    ],
    "tourmalines": [
        "tourmaline"
    ],
    "tourment": [
        "tourment"
    ],
    "tourmenta": [
        "tourmenter"
    ],
    "tourmentai": [
        "tourmenter"
    ],
    "tourmentaient": [
        "tourmenter"
    ],
    "tourmentais": [
        "tourmenter"
    ],
    "tourmentait": [
        "tourmenter"
    ],
    "tourmentant": [
        "tourmentant",
        "tourmenter"
    ],
    "tourmentante": [
        "tourmentant"
    ],
    "tourmentantes": [
        "tourmentant"
    ],
    "tourmente": [
        "tourmenter",
        "tourmente"
    ],
    "tourmentent": [
        "tourmenter"
    ],
    "tourmenter": [
        "tourmenter"
    ],
    "tourmentera": [
        "tourmenter"
    ],
    "tourmenterai": [
        "tourmenter"
    ],
    "tourmenteraient": [
        "tourmenter"
    ],
    "tourmenteront": [
        "tourmenter"
    ],
    "tourmentes": [
        "tourmenter",
        "tourmente"
    ],
    "tourmenteur": [
        "tourmenteur"
    ],
    "tourmenteurs": [
        "tourmenteur"
    ],
    "tourmentez": [
        "tourmenter"
    ],
    "tourmentiez": [
        "tourmenter"
    ],
    "tourmentin": [
        "tourmentin"
    ],
    "tourmentins": [
        "tourmentin"
    ],
    "tourments": [
        "tourment"
    ],
    "tourmentat": [
        "tourmenter"
    ],
    "tourmenterent": [
        "tourmenter"
    ],
    "tourmentee": [
        "tourmenter",
        "tourmente"
    ],
    "tourmentees": [
        "tourmenter",
        "tourmente"
    ],
    "tourna": [
        "tourner"
    ],
    "tournage": [
        "tournage"
    ],
    "tournages": [
        "tournage"
    ],
    "tournai": [
        "tourner"
    ],
    "tournaient": [
        "tourner"
    ],
    "tournaillaient": [
        "tournailler"
    ],
    "tournailler": [
        "tournailler"
    ],
    "tournaille": [
        "tournailler"
    ],
    "tournais": [
        "tourner"
    ],
    "tournait": [
        "tourner"
    ],
    "tournant": [
        "tourner",
        "tournant"
    ],
    "tournante": [
        "tournant"
    ],
    "tournantes": [
        "tournant"
    ],
    "tournants": [
        "tournant"
    ],
    "tournas": [
        "tourner"
    ],
    "tourne": [
        "tourner",
        "tourne"
    ],
    "tourneboulant": [
        "tournebouler"
    ],
    "tourneboule": [
        "tournebouler"
    ],
    "tourneboulee": [
        "tournebouler"
    ],
    "tourneboules": [
        "tournebouler"
    ],
    "tournebroche": [
        "tournebroche"
    ],
    "tournedos": [
        "tournedos"
    ],
    "tournelle": [
        "tournelle"
    ],
    "tournemain": [
        "tournemain"
    ],
    "tournements": [
        "tournement"
    ],
    "tournent": [
        "tourner"
    ],
    "tourner": [
        "tourner"
    ],
    "tournera": [
        "tourner"
    ],
    "tournerai": [
        "tourner"
    ],
    "tourneraient": [
        "tourner"
    ],
    "tournerais": [
        "tourner"
    ],
    "tournerait": [
        "tourner"
    ],
    "tourneras": [
        "tourner"
    ],
    "tournerez": [
        "tourner"
    ],
    "tourneries": [
        "tournerie"
    ],
    "tourneriez": [
        "tourner"
    ],
    "tournerions": [
        "tourner"
    ],
    "tournerons": [
        "tourner"
    ],
    "tourneront": [
        "tourner"
    ],
    "tournes": [
        "tourner",
        "tourne"
    ],
    "tournesol": [
        "tournesol"
    ],
    "tournesols": [
        "tournesol"
    ],
    "tournette": [
        "tournette"
    ],
    "tourneur": [
        "tourneur"
    ],
    "tourneurs": [
        "tourneur"
    ],
    "tourneuses": [
        "tourneur"
    ],
    "tournevis": [
        "tournevis"
    ],
    "tournez": [
        "tourner"
    ],
    "tournicota": [
        "tournicoter"
    ],
    "tournicotais": [
        "tournicoter"
    ],
    "tournicotait": [
        "tournicoter"
    ],
    "tournicotant": [
        "tournicoter"
    ],
    "tournicote": [
        "tournicoter"
    ],
    "tournicotent": [
        "tournicoter"
    ],
    "tournicoter": [
        "tournicoter"
    ],
    "tournicoterais": [
        "tournicoter"
    ],
    "tournicotes": [
        "tournicoter"
    ],
    "tournillant": [
        "tourniller"
    ],
    "tournions": [
        "tourner"
    ],
    "tourniquant": [
        "tourniquer"
    ],
    "tournique": [
        "tourniquer"
    ],
    "tourniquer": [
        "tourniquer"
    ],
    "tourniquet": [
        "tourniquet"
    ],
    "tourniquets": [
        "tourniquet"
    ],
    "tournis": [
        "tournis"
    ],
    "tournoi": [
        "tournoi"
    ],
    "tournoie": [
        "tournoyer"
    ],
    "tournoiement": [
        "tournoiement"
    ],
    "tournoiements": [
        "tournoiement"
    ],
    "tournoient": [
        "tournoyer"
    ],
    "tournoieraient": [
        "tournoyer"
    ],
    "tournoieront": [
        "tournoyer"
    ],
    "tournois": [
        "tournois",
        "tournoi"
    ],
    "tournons": [
        "tourner"
    ],
    "tournoya": [
        "tournoyer"
    ],
    "tournoyaient": [
        "tournoyer"
    ],
    "tournoyais": [
        "tournoyer"
    ],
    "tournoyait": [
        "tournoyer"
    ],
    "tournoyant": [
        "tournoyant",
        "tournoyer"
    ],
    "tournoyante": [
        "tournoyant"
    ],
    "tournoyantes": [
        "tournoyant"
    ],
    "tournoyants": [
        "tournoyant"
    ],
    "tournoyer": [
        "tournoyer"
    ],
    "tournoyerent": [
        "tournoyer"
    ],
    "tournoye": [
        "tournoyer"
    ],
    "tournure": [
        "tournure"
    ],
    "tournures": [
        "tournure"
    ],
    "tournames": [
        "tourner"
    ],
    "tournat": [
        "tourner"
    ],
    "tournerent": [
        "tourner"
    ],
    "tournee": [
        "tourner",
        "tourne",
        "tournee"
    ],
    "tournees": [
        "tourner",
        "tourne",
        "tournee"
    ],
    "tours": [
        "tour"
    ],
    "tourte": [
        "tourte"
    ],
    "tourteau": [
        "tourteau"
    ],
    "tourteaux": [
        "tourteau"
    ],
    "tourtereau": [
        "tourtereau"
    ],
    "tourtereaux": [
        "tourtereau"
    ],
    "tourterelle": [
        "tourtereau"
    ],
    "tourterelles": [
        "tourtereau"
    ],
    "tourtes": [
        "tourte"
    ],
    "tourtiere": [
        "tourtiere"
    ],
    "tourtieres": [
        "tourtiere"
    ],
    "tous": [
        "tous",
        "tout"
    ],
    "toussa": [
        "tousser"
    ],
    "toussai": [
        "tousser"
    ],
    "toussaient": [
        "tousser"
    ],
    "toussaint": [
        "toussaint"
    ],
    "toussais": [
        "tousser"
    ],
    "toussait": [
        "tousser"
    ],
    "toussant": [
        "tousser"
    ],
    "tousse": [
        "tousser"
    ],
    "toussent": [
        "tousser"
    ],
    "tousser": [
        "tousser"
    ],
    "toussera": [
        "tousser"
    ],
    "tousserait": [
        "tousser"
    ],
    "tousses": [
        "tousser"
    ],
    "tousseur": [
        "tousseur"
    ],
    "tousseurs": [
        "tousseur"
    ],
    "tousseux": [
        "tousseux"
    ],
    "toussez": [
        "tousser"
    ],
    "toussions": [
        "tousser"
    ],
    "toussons": [
        "tousser"
    ],
    "toussota": [
        "toussoter"
    ],
    "toussotai": [
        "toussoter"
    ],
    "toussotaient": [
        "toussoter"
    ],
    "toussotait": [
        "toussoter"
    ],
    "toussotant": [
        "toussoter"
    ],
    "toussote": [
        "toussoter"
    ],
    "toussotement": [
        "toussotement"
    ],
    "toussotements": [
        "toussotement"
    ],
    "toussotent": [
        "toussoter"
    ],
    "toussoter": [
        "toussoter"
    ],
    "toussoteux": [
        "toussoteux"
    ],
    "toussotiez": [
        "toussoter"
    ],
    "tout": [
        "tout"
    ],
    "toute": [
        "toute",
        "tout"
    ],
    "toutefois": [
        "toutefois"
    ],
    "toutes": [
        "tout",
        "toutes"
    ],
    "toutim": [
        "toutim"
    ],
    "toutime": [
        "toutime"
    ],
    "toutou": [
        "toutou"
    ],
    "toutous": [
        "toutou"
    ],
    "touts": [
        "tout"
    ],
    "toux": [
        "toux"
    ],
    "toxicite": [
        "toxicite"
    ],
    "toxico": [
        "toxico"
    ],
    "toxicologie": [
        "toxicologie"
    ],
    "toxicologique": [
        "toxicologique"
    ],
    "toxicologue": [
        "toxicologue"
    ],
    "toxicologues": [
        "toxicologue"
    ],
    "toxicomane": [
        "toxicomane"
    ],
    "toxicomanes": [
        "toxicomane"
    ],
    "toxicomanie": [
        "toxicomanie"
    ],
    "toxicos": [
        "toxico"
    ],
    "toxine": [
        "toxine"
    ],
    "toxines": [
        "toxine"
    ],
    "toxique": [
        "toxique"
    ],
    "toxiques": [
        "toxique"
    ],
    "toxoplasmose": [
        "toxoplasmose"
    ],
    "trabans": [
        "traban"
    ],
    "traboules": [
        "traboule"
    ],
    "trabuco": [
        "trabuco"
    ],
    "trac": [
        "trac"
    ],
    "tracas": [
        "tracas"
    ],
    "tracassa": [
        "tracasser"
    ],
    "tracassaient": [
        "tracasser"
    ],
    "tracassait": [
        "tracasser"
    ],
    "tracassant": [
        "tracasser"
    ],
    "tracasse": [
        "tracasser"
    ],
    "tracassent": [
        "tracasser"
    ],
    "tracasser": [
        "tracasser"
    ],
    "tracassera": [
        "tracasser"
    ],
    "tracasserais": [
        "tracasser"
    ],
    "tracasserait": [
        "tracasser"
    ],
    "tracasserie": [
        "tracasserie"
    ],
    "tracasseries": [
        "tracasserie"
    ],
    "tracasserons": [
        "tracasser"
    ],
    "tracasses": [
        "tracasser"
    ],
    "tracassez": [
        "tracasser"
    ],
    "tracassier": [
        "tracassier"
    ],
    "tracassin": [
        "tracassin"
    ],
    "tracassiere": [
        "tracassier"
    ],
    "tracassieres": [
        "tracassier"
    ],
    "tracassee": [
        "tracasser"
    ],
    "tracassees": [
        "tracasser"
    ],
    "trace": [
        "trace",
        "tracer"
    ],
    "tracent": [
        "tracer"
    ],
    "tracer": [
        "tracer"
    ],
    "tracera": [
        "tracer"
    ],
    "tracerez": [
        "tracer"
    ],
    "tracerons": [
        "tracer"
    ],
    "traces": [
        "trace",
        "tracer"
    ],
    "traceur": [
        "traceur"
    ],
    "traceurs": [
        "traceur"
    ],
    "traceuse": [
        "traceur"
    ],
    "traceuses": [
        "traceur"
    ],
    "tracez": [
        "tracer"
    ],
    "trachome": [
        "trachome"
    ],
    "tracheal": [
        "tracheal"
    ],
    "tracheale": [
        "tracheal"
    ],
    "trachee": [
        "trachee"
    ],
    "trachees": [
        "trachee"
    ],
    "tracheite": [
        "tracheite"
    ],
    "tracheotomie": [
        "tracheotomie"
    ],
    "tracions": [
        "tracer"
    ],
    "tracs": [
        "trac"
    ],
    "tract": [
        "tract"
    ],
    "tractage": [
        "tractage"
    ],
    "tractait": [
        "tracter"
    ],
    "tractant": [
        "tracter"
    ],
    "tractation": [
        "tractation"
    ],
    "tractations": [
        "tractation"
    ],
    "tracter": [
        "tracter"
    ],
    "tracteur": [
        "tracteur"
    ],
    "tracteurs": [
        "tracteur"
    ],
    "traction": [
        "traction"
    ],
    "tractions": [
        "traction"
    ],
    "tractopelle": [
        "tractopelle"
    ],
    "tractoriste": [
        "tractoriste"
    ],
    "tractoristes": [
        "tractoriste"
    ],
    "tracts": [
        "tract"
    ],
    "tractus": [
        "tractus"
    ],
    "tracte": [
        "tracter",
        "tracte"
    ],
    "tractee": [
        "tracter"
    ],
    "tractes": [
        "tracte"
    ],
    "tracerent": [
        "tracer"
    ],
    "tracee": [
        "tracer"
    ],
    "tracees": [
        "tracer"
    ],
    "trader": [
        "trader"
    ],
    "tradition": [
        "tradition"
    ],
    "traditionalisme": [
        "traditionalisme"
    ],
    "traditionaliste": [
        "traditionaliste"
    ],
    "traditionalistes": [
        "traditionaliste"
    ],
    "traditionnel": [
        "traditionnel"
    ],
    "traditionnelle": [
        "traditionnel"
    ],
    "traditionnellement": [
        "traditionnellement"
    ],
    "traditionnelles": [
        "traditionnel"
    ],
    "traditionnels": [
        "traditionnel"
    ],
    "traditions": [
        "tradition"
    ],
    "traduc": [
        "traduc"
    ],
    "traducteur": [
        "traducteur"
    ],
    "traducteurs": [
        "traducteur"
    ],
    "traduction": [
        "traduction"
    ],
    "traductions": [
        "traduction"
    ],
    "traductrice": [
        "traducteur"
    ],
    "traductrices": [
        "traducteur"
    ],
    "traduira": [
        "traduire"
    ],
    "traduirai": [
        "traduire"
    ],
    "traduiraient": [
        "traduire"
    ],
    "traduirais": [
        "traduire"
    ],
    "traduirait": [
        "traduire"
    ],
    "traduire": [
        "traduire"
    ],
    "traduirez": [
        "traduire"
    ],
    "traduis": [
        "traduire"
    ],
    "traduisaient": [
        "traduire"
    ],
    "traduisais": [
        "traduire"
    ],
    "traduisait": [
        "traduire"
    ],
    "traduisant": [
        "traduire"
    ],
    "traduise": [
        "traduire"
    ],
    "traduisent": [
        "traduire"
    ],
    "traduises": [
        "traduire"
    ],
    "traduisez": [
        "traduire"
    ],
    "traduisibles": [
        "traduisible"
    ],
    "traduisions": [
        "traduire"
    ],
    "traduisis": [
        "traduire"
    ],
    "traduisit": [
        "traduire"
    ],
    "traduisons": [
        "traduire"
    ],
    "traduit": [
        "traduire"
    ],
    "traduite": [
        "traduire"
    ],
    "traduites": [
        "traduire"
    ],
    "traduits": [
        "traduire"
    ],
    "trafalgar": [
        "trafalgar"
    ],
    "trafic": [
        "trafic"
    ],
    "traficotaient": [
        "traficoter"
    ],
    "traficotait": [
        "traficoter"
    ],
    "traficote": [
        "traficoter"
    ],
    "traficoter": [
        "traficoter"
    ],
    "traficotes": [
        "traficoter"
    ],
    "traficoteurs": [
        "traficoteur"
    ],
    "traficotez": [
        "traficoter"
    ],
    "trafics": [
        "trafic"
    ],
    "trafiquaient": [
        "trafiquer"
    ],
    "trafiquais": [
        "trafiquer"
    ],
    "trafiquait": [
        "trafiquer"
    ],
    "trafiquant": [
        "trafiquer",
        "trafiquant"
    ],
    "trafiquante": [
        "trafiquant"
    ],
    "trafiquants": [
        "trafiquant"
    ],
    "trafique": [
        "trafiquer"
    ],
    "trafiquent": [
        "trafiquer"
    ],
    "trafiquer": [
        "trafiquer"
    ],
    "trafiquerais": [
        "trafiquer"
    ],
    "trafiques": [
        "trafiquer"
    ],
    "trafiquez": [
        "trafiquer"
    ],
    "trafiquions": [
        "trafiquer"
    ],
    "trafiquee": [
        "trafiquer"
    ],
    "trafiquees": [
        "trafiquer"
    ],
    "tragicomedies": [
        "tragicomedie"
    ],
    "tragique": [
        "tragique"
    ],
    "tragiquement": [
        "tragiquement"
    ],
    "tragiques": [
        "tragique"
    ],
    "tragedie": [
        "tragedie"
    ],
    "tragedien": [
        "tragedien"
    ],
    "tragedienne": [
        "tragedien"
    ],
    "tragediennes": [
        "tragedien"
    ],
    "tragediens": [
        "tragedien"
    ],
    "tragedies": [
        "tragedie",
        "tragedy"
    ],
    "trahi": [
        "trahir",
        "trahi"
    ],
    "trahie": [
        "trahir",
        "trahi"
    ],
    "trahies": [
        "trahir",
        "trahi"
    ],
    "trahir": [
        "trahir"
    ],
    "trahira": [
        "trahir"
    ],
    "trahirai": [
        "trahir"
    ],
    "trahiraient": [
        "trahir"
    ],
    "trahirais": [
        "trahir"
    ],
    "trahirait": [
        "trahir"
    ],
    "trahiras": [
        "trahir"
    ],
    "trahirent": [
        "trahir"
    ],
    "trahirez": [
        "trahir"
    ],
    "trahiriez": [
        "trahir"
    ],
    "trahirons": [
        "trahir"
    ],
    "trahiront": [
        "trahir"
    ],
    "trahis": [
        "trahir",
        "trahi"
    ],
    "trahison": [
        "trahison"
    ],
    "trahisons": [
        "trahison"
    ],
    "trahissaient": [
        "trahir"
    ],
    "trahissais": [
        "trahir"
    ],
    "trahissait": [
        "trahir"
    ],
    "trahissant": [
        "trahir",
        "trahissant"
    ],
    "trahisse": [
        "trahir"
    ],
    "trahissent": [
        "trahir"
    ],
    "trahissez": [
        "trahir"
    ],
    "trahissiez": [
        "trahir"
    ],
    "trahissions": [
        "trahir"
    ],
    "trahissons": [
        "trahir"
    ],
    "trahit": [
        "trahir"
    ],
    "traie": [
        "traire"
    ],
    "train": [
        "train"
    ],
    "trainglots": [
        "trainglot"
    ],
    "training": [
        "train",
        "training"
    ],
    "trains": [
        "train"
    ],
    "traintrain": [
        "traintrain"
    ],
    "traira": [
        "traire"
    ],
    "trairait": [
        "traire"
    ],
    "traire": [
        "traire"
    ],
    "trais": [
        "traire"
    ],
    "trait": [
        "trait",
        "traire"
    ],
    "traita": [
        "traiter"
    ],
    "traitable": [
        "traitable"
    ],
    "traitables": [
        "traitable"
    ],
    "traitai": [
        "traiter"
    ],
    "traitaient": [
        "traiter"
    ],
    "traitais": [
        "traiter"
    ],
    "traitait": [
        "traiter"
    ],
    "traitant": [
        "traiter",
        "traitant"
    ],
    "traitante": [
        "traitant"
    ],
    "traitants": [
        "traitant"
    ],
    "traitassent": [
        "traiter"
    ],
    "traite": [
        "traiter",
        "trait",
        "traite"
    ],
    "traitement": [
        "traitement"
    ],
    "traitements": [
        "traitement"
    ],
    "traitent": [
        "traiter"
    ],
    "traiter": [
        "traiter"
    ],
    "traitera": [
        "traiter"
    ],
    "traiterai": [
        "traiter"
    ],
    "traiteraient": [
        "traiter"
    ],
    "traiterais": [
        "traiter"
    ],
    "traiterait": [
        "traiter"
    ],
    "traiteras": [
        "traiter"
    ],
    "traiterez": [
        "traiter"
    ],
    "traiteriez": [
        "traiter"
    ],
    "traiterons": [
        "traiter"
    ],
    "traiteront": [
        "traiter"
    ],
    "traites": [
        "traiter",
        "trait",
        "traite"
    ],
    "traiteur": [
        "traiteur"
    ],
    "traiteurs": [
        "traiteur"
    ],
    "traitez": [
        "traiter"
    ],
    "traitiez": [
        "traiter"
    ],
    "traitions": [
        "traiter"
    ],
    "traitons": [
        "traiter"
    ],
    "traits": [
        "trait",
        "traire"
    ],
    "traitat": [
        "traiter"
    ],
    "traiterent": [
        "traiter"
    ],
    "traitee": [
        "traiter",
        "traite"
    ],
    "traitees": [
        "traiter",
        "traite"
    ],
    "trajectographie": [
        "trajectographie"
    ],
    "trajectoire": [
        "trajectoire"
    ],
    "trajectoires": [
        "trajectoire"
    ],
    "trajet": [
        "trajet"
    ],
    "trajets": [
        "trajet"
    ],
    "tralala": [
        "tralala"
    ],
    "tralalas": [
        "tralala"
    ],
    "tram": [
        "tram"
    ],
    "tramaient": [
        "tramer"
    ],
    "tramail": [
        "tramail"
    ],
    "tramails": [
        "tramail"
    ],
    "tramait": [
        "tramer"
    ],
    "tramant": [
        "tramer"
    ],
    "trame": [
        "tramer",
        "trame"
    ],
    "trament": [
        "tramer"
    ],
    "tramer": [
        "tramer"
    ],
    "trames": [
        "tramer",
        "trame"
    ],
    "tramez": [
        "tramer"
    ],
    "tramontane": [
        "tramontane"
    ],
    "tramontanes": [
        "tramontane"
    ],
    "tramp": [
        "tramp"
    ],
    "trampoline": [
        "trampoline"
    ],
    "trams": [
        "tram"
    ],
    "tramway": [
        "tramway"
    ],
    "tramways": [
        "tramway"
    ],
    "trancha": [
        "trancher"
    ],
    "tranchage": [
        "tranchage"
    ],
    "tranchai": [
        "trancher"
    ],
    "tranchaient": [
        "trancher"
    ],
    "tranchais": [
        "trancher"
    ],
    "tranchait": [
        "trancher"
    ],
    "tranchant": [
        "trancher",
        "tranchant"
    ],
    "tranchante": [
        "tranchant"
    ],
    "tranchantes": [
        "tranchant"
    ],
    "tranchants": [
        "tranchant"
    ],
    "tranche": [
        "trancher",
        "tranche"
    ],
    "tranchecaille": [
        "tranchecaille"
    ],
    "tranchelards": [
        "tranchelard"
    ],
    "tranchent": [
        "trancher"
    ],
    "trancher": [
        "trancher"
    ],
    "tranchera": [
        "trancher"
    ],
    "trancherai": [
        "trancher"
    ],
    "trancherais": [
        "trancher"
    ],
    "trancherait": [
        "trancher"
    ],
    "trancheras": [
        "trancher"
    ],
    "trancheront": [
        "trancher"
    ],
    "tranches": [
        "trancher",
        "tranche"
    ],
    "tranchet": [
        "tranchet"
    ],
    "tranchets": [
        "tranchet"
    ],
    "trancheur": [
        "trancheur"
    ],
    "trancheuse": [
        "trancheur"
    ],
    "tranchez": [
        "trancher"
    ],
    "tranchiez": [
        "trancher"
    ],
    "tranchoir": [
        "tranchoir"
    ],
    "tranchoirs": [
        "tranchoir"
    ],
    "tranchons": [
        "trancher"
    ],
    "tranchat": [
        "trancher"
    ],
    "trancherent": [
        "trancher"
    ],
    "tranchee": [
        "tranche",
        "trancher",
        "tranchee"
    ],
    "tranchees": [
        "tranche",
        "trancher",
        "tranchee"
    ],
    "tranquille": [
        "tranquille"
    ],
    "tranquillement": [
        "tranquillement"
    ],
    "tranquilles": [
        "tranquille"
    ],
    "tranquillisa": [
        "tranquilliser"
    ],
    "tranquillisai": [
        "tranquilliser"
    ],
    "tranquillisaient": [
        "tranquilliser"
    ],
    "tranquillisait": [
        "tranquilliser"
    ],
    "tranquillisant": [
        "tranquillisant",
        "tranquilliser"
    ],
    "tranquillisante": [
        "tranquillisant"
    ],
    "tranquillisantes": [
        "tranquillisant"
    ],
    "tranquillisants": [
        "tranquillisant"
    ],
    "tranquillise": [
        "tranquilliser"
    ],
    "tranquillisent": [
        "tranquilliser"
    ],
    "tranquilliser": [
        "tranquilliser"
    ],
    "tranquillisera": [
        "tranquilliser"
    ],
    "tranquilliserait": [
        "tranquilliser"
    ],
    "tranquillises": [
        "tranquilliser"
    ],
    "tranquillisez": [
        "tranquilliser"
    ],
    "tranquillisee": [
        "tranquilliser"
    ],
    "tranquillite": [
        "tranquillite"
    ],
    "tranquillites": [
        "tranquillite"
    ],
    "tranquillos": [
        "tranquillos"
    ],
    "trans": [
        "tran",
        "trans"
    ],
    "transaction": [
        "transaction"
    ],
    "transactionnelle": [
        "transactionnel"
    ],
    "transactions": [
        "transaction"
    ],
    "transafricain": [
        "transafricain"
    ],
    "transalpines": [
        "transalpin"
    ],
    "transamazonienne": [
        "transamazonien"
    ],
    "transaminase": [
        "transaminase"
    ],
    "transaminases": [
        "transaminase"
    ],
    "transat": [
        "transat"
    ],
    "transatlantique": [
        "transatlantique"
    ],
    "transatlantiques": [
        "transatlantique"
    ],
    "transats": [
        "transat"
    ],
    "transbahutaient": [
        "transbahuter"
    ],
    "transbahutant": [
        "transbahuter"
    ],
    "transbahute": [
        "transbahuter"
    ],
    "transbahutent": [
        "transbahuter"
    ],
    "transbahuter": [
        "transbahuter"
    ],
    "transbahutez": [
        "transbahuter"
    ],
    "transbahutee": [
        "transbahuter"
    ],
    "transbahutes": [
        "transbahuter"
    ],
    "transbordement": [
        "transbordement"
    ],
    "transbordements": [
        "transbordement"
    ],
    "transborder": [
        "transborder"
    ],
    "transbordeur": [
        "transbordeur"
    ],
    "transborde": [
        "transborder"
    ],
    "transcanadienne": [
        "transcanadienne"
    ],
    "transcaspien": [
        "transcaspien"
    ],
    "transcendance": [
        "transcendance"
    ],
    "transcendant": [
        "transcendant",
        "transcender"
    ],
    "transcendantal": [
        "transcendantal"
    ],
    "transcendantale": [
        "transcendantal"
    ],
    "transcendantales": [
        "transcendantal"
    ],
    "transcendantalistes": [
        "transcendantaliste"
    ],
    "transcendante": [
        "transcendant"
    ],
    "transcendantes": [
        "transcendant"
    ],
    "transcendants": [
        "transcendant"
    ],
    "transcende": [
        "transcender"
    ],
    "transcendent": [
        "transcender"
    ],
    "transcender": [
        "transcender"
    ],
    "transcendons": [
        "transcender"
    ],
    "transcendee": [
        "transcender"
    ],
    "transcontinental": [
        "transcontinental"
    ],
    "transcontinentale": [
        "transcontinental"
    ],
    "transcriptase": [
        "transcriptase"
    ],
    "transcripteur": [
        "transcripteur"
    ],
    "transcription": [
        "transcription"
    ],
    "transcriptions": [
        "transcription"
    ],
    "transcrire": [
        "transcrire"
    ],
    "transcris": [
        "transcrire"
    ],
    "transcrit": [
        "transcrire"
    ],
    "transcrite": [
        "transcrire"
    ],
    "transcrites": [
        "transcrire"
    ],
    "transcrits": [
        "transcrire"
    ],
    "transcrivaient": [
        "transcrire"
    ],
    "transcrivais": [
        "transcrire"
    ],
    "transcrivait": [
        "transcrire"
    ],
    "transcrivant": [
        "transcrire"
    ],
    "transcrive": [
        "transcrire"
    ],
    "transcrivez": [
        "transcrire"
    ],
    "transcrivis": [
        "transcrire"
    ],
    "transcrivit": [
        "transcrire"
    ],
    "transcutane": [
        "transcutane"
    ],
    "transdermique": [
        "transdermique"
    ],
    "transducteur": [
        "transducteur"
    ],
    "transducteurs": [
        "transducteur"
    ],
    "transduction": [
        "transduction"
    ],
    "transe": [
        "transe"
    ],
    "transept": [
        "transept"
    ],
    "transepts": [
        "transept"
    ],
    "transes": [
        "transe"
    ],
    "transfert": [
        "transfert"
    ],
    "transferts": [
        "transfert"
    ],
    "transfigura": [
        "transfigurer"
    ],
    "transfiguraient": [
        "transfigurer"
    ],
    "transfigurait": [
        "transfigurer"
    ],
    "transfigurant": [
        "transfigurer"
    ],
    "transfiguration": [
        "transfiguration"
    ],
    "transfigurations": [
        "transfiguration"
    ],
    "transfiguratrice": [
        "transfigurateur"
    ],
    "transfigure": [
        "transfigurer"
    ],
    "transfigurent": [
        "transfigurer"
    ],
    "transfigurer": [
        "transfigurer"
    ],
    "transfigurerait": [
        "transfigurer"
    ],
    "transfigurez": [
        "transfigurer"
    ],
    "transfiguree": [
        "transfigurer"
    ],
    "transfigurees": [
        "transfigurer"
    ],
    "transfigures": [
        "transfigurer"
    ],
    "transfilaient": [
        "transfiler"
    ],
    "transfilee": [
        "transfiler"
    ],
    "transfo": [
        "transfo"
    ],
    "transforma": [
        "transformer"
    ],
    "transformable": [
        "transformable"
    ],
    "transformai": [
        "transformer"
    ],
    "transformaient": [
        "transformer"
    ],
    "transformais": [
        "transformer"
    ],
    "transformait": [
        "transformer"
    ],
    "transformant": [
        "transformer",
        "transformant"
    ],
    "transformas": [
        "transformer"
    ],
    "transformateur": [
        "transformateur"
    ],
    "transformateurs": [
        "transformateur"
    ],
    "transformation": [
        "transformation"
    ],
    "transformations": [
        "transformation"
    ],
    "transformatrice": [
        "transformateur"
    ],
    "transforme": [
        "transformer",
        "transforme"
    ],
    "transforment": [
        "transformer"
    ],
    "transformer": [
        "transformer"
    ],
    "transformera": [
        "transformer"
    ],
    "transformerai": [
        "transformer"
    ],
    "transformeraient": [
        "transformer"
    ],
    "transformerais": [
        "transformer"
    ],
    "transformerait": [
        "transformer"
    ],
    "transformeras": [
        "transformer"
    ],
    "transformeriez": [
        "transformer"
    ],
    "transformerons": [
        "transformer"
    ],
    "transformeront": [
        "transformer"
    ],
    "transformes": [
        "transformer",
        "transforme"
    ],
    "transformez": [
        "transformer"
    ],
    "transformiez": [
        "transformer"
    ],
    "transformiste": [
        "transformiste"
    ],
    "transformons": [
        "transformer"
    ],
    "transformat": [
        "transformer"
    ],
    "transformerent": [
        "transformer"
    ],
    "transformee": [
        "transformer",
        "transforme"
    ],
    "transformees": [
        "transformer"
    ],
    "transfos": [
        "transfo"
    ],
    "transfuge": [
        "transfuge"
    ],
    "transfuges": [
        "transfuge"
    ],
    "transfusait": [
        "transfuser"
    ],
    "transfuse": [
        "transfuser",
        "transfuse"
    ],
    "transfuser": [
        "transfuser"
    ],
    "transfuseur": [
        "transfuseur"
    ],
    "transfusion": [
        "transfusion"
    ],
    "transfusions": [
        "transfusion"
    ],
    "transfusee": [
        "transfuse"
    ],
    "transfuses": [
        "transfuser"
    ],
    "transfere": [
        "transferer"
    ],
    "transferement": [
        "transferement"
    ],
    "transferements": [
        "transferement"
    ],
    "transferent": [
        "transferer"
    ],
    "transfera": [
        "transferer"
    ],
    "transferable": [
        "transferable"
    ],
    "transferaient": [
        "transferer"
    ],
    "transferais": [
        "transferer"
    ],
    "transferait": [
        "transferer"
    ],
    "transferant": [
        "transferer"
    ],
    "transferer": [
        "transferer"
    ],
    "transferera": [
        "transferer"
    ],
    "transfererai": [
        "transferer"
    ],
    "transfererait": [
        "transferer"
    ],
    "transfereras": [
        "transferer"
    ],
    "transfererez": [
        "transferer"
    ],
    "transfererons": [
        "transferer"
    ],
    "transfereront": [
        "transferer"
    ],
    "transferez": [
        "transferer"
    ],
    "transferiez": [
        "transferer"
    ],
    "transferons": [
        "transferer"
    ],
    "transferames": [
        "transferer"
    ],
    "transfererent": [
        "transferer"
    ],
    "transferee": [
        "transferer"
    ],
    "transferees": [
        "transferee",
        "transferer"
    ],
    "transferes": [
        "transferer"
    ],
    "transgressait": [
        "transgresser"
    ],
    "transgresse": [
        "transgresser"
    ],
    "transgressent": [
        "transgresser"
    ],
    "transgresser": [
        "transgresser"
    ],
    "transgresseur": [
        "transgresseur"
    ],
    "transgressez": [
        "transgresser"
    ],
    "transgression": [
        "transgression"
    ],
    "transgressions": [
        "transgression"
    ],
    "transgressons": [
        "transgresser"
    ],
    "transgressee": [
        "transgresser"
    ],
    "transgressees": [
        "transgresser"
    ],
    "transgenique": [
        "transgenique"
    ],
    "transgeniques": [
        "transgenique"
    ],
    "transhistorique": [
        "transhistorique"
    ],
    "transhumait": [
        "transhumer"
    ],
    "transhumance": [
        "transhumance"
    ],
    "transhumances": [
        "transhumance"
    ],
    "transhumant": [
        "transhumant"
    ],
    "transhumantes": [
        "transhumant"
    ],
    "transhumants": [
        "transhumant"
    ],
    "transhumes": [
        "transhumer"
    ],
    "transi": [
        "transir",
        "transi"
    ],
    "transie": [
        "transir",
        "transi"
    ],
    "transies": [
        "transir",
        "transi"
    ],
    "transige": [
        "transiger"
    ],
    "transigeait": [
        "transiger"
    ],
    "transigeant": [
        "transiger"
    ],
    "transigent": [
        "transiger"
    ],
    "transigeons": [
        "transiger"
    ],
    "transiger": [
        "transiger"
    ],
    "transigera": [
        "transiger"
    ],
    "transigerai": [
        "transiger"
    ],
    "transillumination": [
        "transillumination"
    ],
    "transir": [
        "transir"
    ],
    "transis": [
        "transir",
        "transi"
    ],
    "transistor": [
        "transistor"
    ],
    "transistorisees": [
        "transistorise"
    ],
    "transistorises": [
        "transistorise",
        "transistoriser"
    ],
    "transistors": [
        "transistor"
    ],
    "transit": [
        "transir",
        "transit"
    ],
    "transitaient": [
        "transiter"
    ],
    "transitaire": [
        "transitaire"
    ],
    "transitaires": [
        "transitaire"
    ],
    "transitais": [
        "transiter"
    ],
    "transitait": [
        "transiter"
    ],
    "transitant": [
        "transiter"
    ],
    "transite": [
        "transiter"
    ],
    "transitent": [
        "transiter"
    ],
    "transiter": [
        "transiter"
    ],
    "transitif": [
        "transitif"
    ],
    "transitifs": [
        "transitif"
    ],
    "transition": [
        "transition"
    ],
    "transitionnel": [
        "transitionnel"
    ],
    "transitionnelle": [
        "transitionnel"
    ],
    "transitions": [
        "transition"
    ],
    "transitoire": [
        "transitoire"
    ],
    "transitoirement": [
        "transitoirement"
    ],
    "transitoires": [
        "transitoire"
    ],
    "transits": [
        "transit"
    ],
    "translater": [
        "translater"
    ],
    "translates": [
        "translate",
        "translater"
    ],
    "translation": [
        "translation"
    ],
    "translations": [
        "translation"
    ],
    "translocation": [
        "translocation"
    ],
    "translucide": [
        "translucide"
    ],
    "translucides": [
        "translucide"
    ],
    "translucidite": [
        "translucidite"
    ],
    "transmet": [
        "transmettre"
    ],
    "transmets": [
        "transmettre"
    ],
    "transmettaient": [
        "transmettre"
    ],
    "transmettais": [
        "transmettre"
    ],
    "transmettait": [
        "transmettre"
    ],
    "transmettant": [
        "transmettre"
    ],
    "transmette": [
        "transmettre"
    ],
    "transmettent": [
        "transmettre"
    ],
    "transmetteur": [
        "transmetteur"
    ],
    "transmetteurs": [
        "transmetteur"
    ],
    "transmettez": [
        "transmettre"
    ],
    "transmettions": [
        "transmettre"
    ],
    "transmettons": [
        "transmettre"
    ],
    "transmettra": [
        "transmettre"
    ],
    "transmettrai": [
        "transmettre"
    ],
    "transmettrait": [
        "transmettre"
    ],
    "transmettras": [
        "transmettre"
    ],
    "transmettre": [
        "transmettre"
    ],
    "transmettrez": [
        "transmettre"
    ],
    "transmettrons": [
        "transmettre"
    ],
    "transmettront": [
        "transmettre"
    ],
    "transmigrait": [
        "transmigrer"
    ],
    "transmigration": [
        "transmigration"
    ],
    "transmigrent": [
        "transmigrer"
    ],
    "transmirent": [
        "transmettre"
    ],
    "transmis": [
        "transmis",
        "transmettre"
    ],
    "transmise": [
        "transmis",
        "transmettre"
    ],
    "transmises": [
        "transmis",
        "transmettre"
    ],
    "transmissible": [
        "transmissible"
    ],
    "transmissibles": [
        "transmissible"
    ],
    "transmission": [
        "transmission"
    ],
    "transmissions": [
        "transmission"
    ],
    "transmit": [
        "transmettre"
    ],
    "transmuait": [
        "transmuer"
    ],
    "transmuer": [
        "transmuer"
    ],
    "transmutait": [
        "transmuter"
    ],
    "transmutant": [
        "transmuter"
    ],
    "transmutation": [
        "transmutation"
    ],
    "transmutations": [
        "transmutation"
    ],
    "transmute": [
        "transmuter"
    ],
    "transmutent": [
        "transmuter"
    ],
    "transmuter": [
        "transmuter"
    ],
    "transmue": [
        "transmuer"
    ],
    "transmuee": [
        "transmuer"
    ],
    "transmuees": [
        "transmuer"
    ],
    "transmues": [
        "transmuer"
    ],
    "transnational": [
        "transnational"
    ],
    "transnationaux": [
        "transnational"
    ],
    "transoceanique": [
        "transoceanique"
    ],
    "transoceaniques": [
        "transoceanique"
    ],
    "transparaissaient": [
        "transparaitre"
    ],
    "transparaissait": [
        "transparaitre"
    ],
    "transparaisse": [
        "transparaitre"
    ],
    "transparaissent": [
        "transparaitre"
    ],
    "transparait": [
        "transparaitre"
    ],
    "transparaitre": [
        "transparaitre"
    ],
    "transparence": [
        "transparence"
    ],
    "transparences": [
        "transparence"
    ],
    "transparent": [
        "transparent"
    ],
    "transparente": [
        "transparent"
    ],
    "transparentes": [
        "transparent"
    ],
    "transparents": [
        "transparent"
    ],
    "transperce": [
        "transpercer"
    ],
    "transpercent": [
        "transpercer"
    ],
    "transpercer": [
        "transpercer"
    ],
    "transpercerai": [
        "transpercer"
    ],
    "transpercerait": [
        "transpercer"
    ],
    "transpercez": [
        "transpercer"
    ],
    "transpercerent": [
        "transpercer"
    ],
    "transpercee": [
        "transpercer"
    ],
    "transpercees": [
        "transpercer"
    ],
    "transperces": [
        "transpercer"
    ],
    "transperca": [
        "transpercer"
    ],
    "transpercaient": [
        "transpercer"
    ],
    "transpercait": [
        "transpercer"
    ],
    "transpercant": [
        "transpercer"
    ],
    "transpira": [
        "transpirer"
    ],
    "transpiraient": [
        "transpirer"
    ],
    "transpirais": [
        "transpirer"
    ],
    "transpirait": [
        "transpirer"
    ],
    "transpirant": [
        "transpirer",
        "transpirant"
    ],
    "transpirante": [
        "transpirant"
    ],
    "transpirants": [
        "transpirant"
    ],
    "transpiration": [
        "transpiration"
    ],
    "transpire": [
        "transpirer"
    ],
    "transpirent": [
        "transpirer"
    ],
    "transpirer": [
        "transpirer"
    ],
    "transpirera": [
        "transpirer"
    ],
    "transpirerait": [
        "transpirer"
    ],
    "transpires": [
        "transpirer",
        "transpire"
    ],
    "transpirez": [
        "transpirer"
    ],
    "transplantable": [
        "transplantable"
    ],
    "transplantait": [
        "transplanter"
    ],
    "transplantation": [
        "transplantation"
    ],
    "transplantations": [
        "transplantation"
    ],
    "transplante": [
        "transplanter",
        "transplante"
    ],
    "transplanter": [
        "transplanter"
    ],
    "transplantons": [
        "transplanter"
    ],
    "transplants": [
        "transplant"
    ],
    "transplantee": [
        "transplanter",
        "transplante"
    ],
    "transplantees": [
        "transplante"
    ],
    "transplantes": [
        "transplanter",
        "transplante"
    ],
    "transpondeur": [
        "transpondeur"
    ],
    "transport": [
        "transport"
    ],
    "transporta": [
        "transporter"
    ],
    "transportable": [
        "transportable"
    ],
    "transportables": [
        "transportable"
    ],
    "transportai": [
        "transporter"
    ],
    "transportaient": [
        "transporter"
    ],
    "transportais": [
        "transporter"
    ],
    "transportait": [
        "transporter"
    ],
    "transportant": [
        "transporter"
    ],
    "transportation": [
        "transportation"
    ],
    "transporte": [
        "transporter",
        "transporte"
    ],
    "transportent": [
        "transporter"
    ],
    "transporter": [
        "transporter"
    ],
    "transportera": [
        "transporter"
    ],
    "transporteraient": [
        "transporter"
    ],
    "transporterais": [
        "transporter"
    ],
    "transporterait": [
        "transporter"
    ],
    "transporterons": [
        "transporter"
    ],
    "transporteur": [
        "transporteur"
    ],
    "transporteurs": [
        "transporteur"
    ],
    "transporteuse": [
        "transporteur"
    ],
    "transportez": [
        "transporter"
    ],
    "transportiez": [
        "transporter"
    ],
    "transportions": [
        "transporter"
    ],
    "transportons": [
        "transporter"
    ],
    "transports": [
        "transport"
    ],
    "transportames": [
        "transporter"
    ],
    "transportat": [
        "transporter"
    ],
    "transporterent": [
        "transporter"
    ],
    "transportee": [
        "transporter",
        "transporte"
    ],
    "transportees": [
        "transporter",
        "transporte"
    ],
    "transportes": [
        "transporter",
        "transporte"
    ],
    "transposable": [
        "transposable"
    ],
    "transposables": [
        "transposable"
    ],
    "transposaient": [
        "transposer"
    ],
    "transposait": [
        "transposer"
    ],
    "transposant": [
        "transposer"
    ],
    "transpose": [
        "transposer"
    ],
    "transposent": [
        "transposer"
    ],
    "transposer": [
        "transposer"
    ],
    "transposez": [
        "transposer"
    ],
    "transposition": [
        "transposition"
    ],
    "transpositions": [
        "transposition"
    ],
    "transposon": [
        "transposon"
    ],
    "transposons": [
        "transposer"
    ],
    "transposee": [
        "transposee",
        "transposer"
    ],
    "transposes": [
        "transpose",
        "transposer"
    ],
    "transsaharienne": [
        "transsaharien"
    ],
    "transsexualisme": [
        "transsexualisme"
    ],
    "transsexualite": [
        "transsexualite"
    ],
    "transsexuel": [
        "transsexuel"
    ],
    "transsexuelle": [
        "transsexuel"
    ],
    "transsexuels": [
        "transsexuel"
    ],
    "transsiberien": [
        "transsiberien"
    ],
    "transsiberienne": [
        "transsiberien"
    ],
    "transsubstantiation": [
        "transsubstantiation"
    ],
    "transsudait": [
        "transsuder"
    ],
    "transsudant": [
        "transsuder"
    ],
    "transsudat": [
        "transsudat"
    ],
    "transuranienne": [
        "transuranien"
    ],
    "transvasait": [
        "transvaser"
    ],
    "transvase": [
        "transvaser"
    ],
    "transvaser": [
        "transvaser"
    ],
    "transvasons": [
        "transvaser"
    ],
    "transvaserent": [
        "transvaser"
    ],
    "transvasees": [
        "transvaser"
    ],
    "transversal": [
        "transversal"
    ],
    "transversale": [
        "transversal"
    ],
    "transversalement": [
        "transversalement"
    ],
    "transversales": [
        "transversal"
    ],
    "transversaux": [
        "transversal"
    ],
    "transverse": [
        "transverse"
    ],
    "transvestisme": [
        "transvestisme"
    ],
    "transylvain": [
        "transylvain"
    ],
    "transylvanienne": [
        "transylvanien"
    ],
    "trappe": [
        "trappe"
    ],
    "trappes": [
        "trappe"
    ],
    "trappeur": [
        "trappeur"
    ],
    "trappeurs": [
        "trappeur"
    ],
    "trappiste": [
        "trappiste"
    ],
    "trappistes": [
        "trappiste"
    ],
    "trappon": [
        "trappon"
    ],
    "trapu": [
        "trapu"
    ],
    "trapue": [
        "trapu"
    ],
    "trapues": [
        "trapu"
    ],
    "trapus": [
        "trapu"
    ],
    "trapeze": [
        "trapeze"
    ],
    "trapezes": [
        "trapeze"
    ],
    "trapeziste": [
        "trapeziste"
    ],
    "trapezistes": [
        "trapeziste"
    ],
    "trapezoidal": [
        "trapezoidal"
    ],
    "trapezoidale": [
        "trapezoidal"
    ],
    "trapezoidales": [
        "trapezoidal"
    ],
    "trapezoidaux": [
        "trapezoidal"
    ],
    "trapezoide": [
        "trapezoide"
    ],
    "traqua": [
        "traquer"
    ],
    "traquaient": [
        "traquer"
    ],
    "traquais": [
        "traquer"
    ],
    "traquait": [
        "traquer"
    ],
    "traquant": [
        "traquer"
    ],
    "traque": [
        "traque",
        "traquer"
    ],
    "traquenard": [
        "traquenard"
    ],
    "traquenards": [
        "traquenard"
    ],
    "traquent": [
        "traquer"
    ],
    "traquer": [
        "traquer"
    ],
    "traquera": [
        "traquer"
    ],
    "traquerai": [
        "traquer"
    ],
    "traquerais": [
        "traquer"
    ],
    "traquerait": [
        "traquer"
    ],
    "traquerons": [
        "traquer"
    ],
    "traqueront": [
        "traquer"
    ],
    "traques": [
        "traque",
        "traquer"
    ],
    "traquet": [
        "traquet"
    ],
    "traquets": [
        "traquet"
    ],
    "traqueur": [
        "traqueur"
    ],
    "traqueurs": [
        "traqueur"
    ],
    "traqueuse": [
        "traqueur"
    ],
    "traquez": [
        "traquer"
    ],
    "traquiez": [
        "traquer"
    ],
    "traquions": [
        "traquer"
    ],
    "traquons": [
        "traquer"
    ],
    "traquerent": [
        "traquer"
    ],
    "traquee": [
        "traquer"
    ],
    "traquees": [
        "traquer"
    ],
    "trattoria": [
        "trattoria"
    ],
    "trattorias": [
        "trattoria"
    ],
    "trauma": [
        "trauma"
    ],
    "traumas": [
        "trauma"
    ],
    "traumatique": [
        "traumatique"
    ],
    "traumatiques": [
        "traumatique"
    ],
    "traumatisant": [
        "traumatiser",
        "traumatisant"
    ],
    "traumatisante": [
        "traumatisant"
    ],
    "traumatisantes": [
        "traumatisant"
    ],
    "traumatisants": [
        "traumatisant"
    ],
    "traumatise": [
        "traumatiser"
    ],
    "traumatiser": [
        "traumatiser"
    ],
    "traumatisme": [
        "traumatisme"
    ],
    "traumatismes": [
        "traumatisme"
    ],
    "traumatisee": [
        "traumatiser"
    ],
    "traumatisees": [
        "traumatiser"
    ],
    "traumatises": [
        "traumatiser"
    ],
    "traumatologie": [
        "traumatologie"
    ],
    "traumatologique": [
        "traumatologique"
    ],
    "traumatologue": [
        "traumatologue"
    ],
    "travail": [
        "travail"
    ],
    "travailla": [
        "travailler"
    ],
    "travaillai": [
        "travailler"
    ],
    "travaillaient": [
        "travailler"
    ],
    "travaillais": [
        "travailler"
    ],
    "travaillait": [
        "travailler"
    ],
    "travaillant": [
        "travailler"
    ],
    "travaillassent": [
        "travailler"
    ],
    "travaille": [
        "travaille",
        "travailler"
    ],
    "travaillent": [
        "travailler"
    ],
    "travailler": [
        "travailler"
    ],
    "travaillera": [
        "travailler"
    ],
    "travaillerai": [
        "travailler"
    ],
    "travailleraient": [
        "travailler"
    ],
    "travaillerais": [
        "travailler"
    ],
    "travaillerait": [
        "travailler"
    ],
    "travailleras": [
        "travailler"
    ],
    "travaillerez": [
        "travailler"
    ],
    "travailleriez": [
        "travailler"
    ],
    "travaillerions": [
        "travailler"
    ],
    "travaillerons": [
        "travailler"
    ],
    "travailleront": [
        "travailler"
    ],
    "travailles": [
        "travaille",
        "travailler"
    ],
    "travailleur": [
        "travailleur"
    ],
    "travailleurs": [
        "travailleur"
    ],
    "travailleuse": [
        "travailleur"
    ],
    "travailleuses": [
        "travailleur"
    ],
    "travaillez": [
        "travailler"
    ],
    "travailliez": [
        "travailler"
    ],
    "travaillions": [
        "travailler"
    ],
    "travailliste": [
        "travailliste"
    ],
    "travaillistes": [
        "travailliste"
    ],
    "travaillons": [
        "travailler"
    ],
    "travaillames": [
        "travailler"
    ],
    "travaillat": [
        "travailler"
    ],
    "travaillerent": [
        "travailler"
    ],
    "travaillee": [
        "travaille",
        "travailler"
    ],
    "travaillees": [
        "travaille",
        "travailler"
    ],
    "travaux": [
        "travail"
    ],
    "trave": [
        "trave"
    ],
    "traveller": [
        "traveller"
    ],
    "travellers": [
        "traveller"
    ],
    "travelling": [
        "travel",
        "travelling"
    ],
    "travellings": [
        "travelling"
    ],
    "travelo": [
        "travelo"
    ],
    "travelos": [
        "travelo"
    ],
    "travers": [
        "travers"
    ],
    "traversa": [
        "traverser"
    ],
    "traversable": [
        "traversable"
    ],
    "traversables": [
        "traversable"
    ],
    "traversai": [
        "traverser"
    ],
    "traversaient": [
        "traverser"
    ],
    "traversais": [
        "traverser"
    ],
    "traversait": [
        "traverser"
    ],
    "traversant": [
        "traversant",
        "traverser"
    ],
    "traverse": [
        "traverser",
        "traverse"
    ],
    "traversent": [
        "traverser"
    ],
    "traverser": [
        "traverser"
    ],
    "traversera": [
        "traverser"
    ],
    "traverserai": [
        "traverser"
    ],
    "traverseraient": [
        "traverser"
    ],
    "traverserais": [
        "traverser"
    ],
    "traverserait": [
        "traverser"
    ],
    "traverseras": [
        "traverser"
    ],
    "traverserez": [
        "traverser"
    ],
    "traverserons": [
        "traverser"
    ],
    "traverseront": [
        "traverser"
    ],
    "traverses": [
        "traverser",
        "traverse"
    ],
    "traversez": [
        "traverser"
    ],
    "traversier": [
        "traversier"
    ],
    "traversiez": [
        "traverser"
    ],
    "traversin": [
        "traversin"
    ],
    "traversine": [
        "traversine"
    ],
    "traversins": [
        "traversin"
    ],
    "traversions": [
        "traverser"
    ],
    "traversiere": [
        "traversier"
    ],
    "traversieres": [
        "traversier"
    ],
    "traversons": [
        "traverser"
    ],
    "traversames": [
        "traverser"
    ],
    "traverserent": [
        "traverser"
    ],
    "traversee": [
        "traversee",
        "traverser"
    ],
    "traversees": [
        "traversee",
        "traverser"
    ],
    "travertin": [
        "travertin"
    ],
    "travesti": [
        "travestir",
        "travesti"
    ],
    "travestie": [
        "travestir",
        "travesti"
    ],
    "travesties": [
        "travesty",
        "travestir"
    ],
    "travestir": [
        "travestir"
    ],
    "travestis": [
        "travestir",
        "travesti"
    ],
    "travestisme": [
        "travestisme"
    ],
    "travestissais": [
        "travestir"
    ],
    "travestissant": [
        "travestir"
    ],
    "travestissement": [
        "travestissement"
    ],
    "travestissements": [
        "travestissement"
    ],
    "travestissez": [
        "travestir"
    ],
    "travestit": [
        "travestir"
    ],
    "travois": [
        "travois"
    ],
    "travee": [
        "travee"
    ],
    "travees": [
        "travee"
    ],
    "trax": [
        "trax"
    ],
    "trayait": [
        "traire"
    ],
    "trayant": [
        "traire"
    ],
    "trayeuse": [
        "trayeur"
    ],
    "trayeuses": [
        "trayeur"
    ],
    "trayon": [
        "trayon"
    ],
    "trayons": [
        "trayon"
    ],
    "traca": [
        "tracer"
    ],
    "tracabilite": [
        "tracabilite"
    ],
    "tracage": [
        "tracage"
    ],
    "tracai": [
        "tracer"
    ],
    "tracaient": [
        "tracer"
    ],
    "tracais": [
        "tracer"
    ],
    "tracait": [
        "tracer"
    ],
    "tracant": [
        "tracer"
    ],
    "tracante": [
        "tracant"
    ],
    "tracantes": [
        "tracant"
    ],
    "tracons": [
        "tracer"
    ],
    "tracat": [
        "tracer"
    ],
    "traina": [
        "trainer"
    ],
    "trainage": [
        "trainage"
    ],
    "trainai": [
        "trainer"
    ],
    "trainaient": [
        "trainer"
    ],
    "trainaillait": [
        "trainailler"
    ],
    "trainaillant": [
        "trainailler"
    ],
    "trainaille": [
        "trainailler"
    ],
    "trainailler": [
        "trainailler"
    ],
    "trainaillons": [
        "trainailler"
    ],
    "trainais": [
        "trainer"
    ],
    "trainait": [
        "trainer"
    ],
    "trainant": [
        "trainer",
        "trainant"
    ],
    "trainante": [
        "trainant"
    ],
    "trainantes": [
        "trainant"
    ],
    "trainants": [
        "trainant"
    ],
    "trainard": [
        "trainard"
    ],
    "trainarde": [
        "trainard"
    ],
    "trainards": [
        "trainard"
    ],
    "trainassaient": [
        "trainasser"
    ],
    "trainassais": [
        "trainasser"
    ],
    "trainassait": [
        "trainasser"
    ],
    "trainassant": [
        "trainasser"
    ],
    "trainasse": [
        "trainasser"
    ],
    "trainassent": [
        "trainasser"
    ],
    "trainasser": [
        "trainasser"
    ],
    "trainasserai": [
        "trainasser"
    ],
    "trainasses": [
        "trainasser"
    ],
    "trainassez": [
        "trainasser"
    ],
    "trainassons": [
        "trainasser"
    ],
    "traine": [
        "trainer",
        "traine"
    ],
    "traineau": [
        "traineau"
    ],
    "traineaux": [
        "traineau"
    ],
    "trainement": [
        "trainement"
    ],
    "trainent": [
        "trainer"
    ],
    "trainer": [
        "trainer"
    ],
    "trainera": [
        "trainer"
    ],
    "trainerai": [
        "trainer"
    ],
    "traineraient": [
        "trainer"
    ],
    "trainerais": [
        "trainer"
    ],
    "trainerait": [
        "trainer"
    ],
    "traineras": [
        "trainer"
    ],
    "trainerez": [
        "trainer"
    ],
    "trainerons": [
        "trainer"
    ],
    "traineront": [
        "trainer"
    ],
    "traines": [
        "trainer",
        "traine"
    ],
    "traineur": [
        "traineur"
    ],
    "traineurs": [
        "traineur"
    ],
    "traineuses": [
        "traineur",
        "traineuse"
    ],
    "trainez": [
        "trainer"
    ],
    "trainier": [
        "trainier"
    ],
    "trainiez": [
        "trainer"
    ],
    "trainions": [
        "trainer"
    ],
    "trainons": [
        "trainer"
    ],
    "trainames": [
        "trainer"
    ],
    "trainat": [
        "trainer"
    ],
    "trainerent": [
        "trainer"
    ],
    "trainee": [
        "trainer",
        "trainee"
    ],
    "trainees": [
        "trainer",
        "trainee"
    ],
    "traitre": [
        "traitre"
    ],
    "traitres": [
        "traitre"
    ],
    "traitresse": [
        "traitresse",
        "traitre"
    ],
    "traitresses": [
        "traitresse",
        "traitre"
    ],
    "traitreusement": [
        "traitreusement"
    ],
    "traitrise": [
        "traitrise"
    ],
    "traitrises": [
        "traitrise"
    ],
    "trecento": [
        "trecento"
    ],
    "treillage": [
        "treillage"
    ],
    "treillages": [
        "treillage"
    ],
    "treillard": [
        "treillard"
    ],
    "treille": [
        "treille"
    ],
    "treilles": [
        "treille"
    ],
    "treillis": [
        "treillis"
    ],
    "treillisse": [
        "treillisser"
    ],
    "treillissee": [
        "treillisser"
    ],
    "treizaine": [
        "treizain"
    ],
    "treize": [
        "treize"
    ],
    "treizieme": [
        "treizieme"
    ],
    "trek": [
        "trek"
    ],
    "trekkeur": [
        "trekkeur"
    ],
    "trekking": [
        "trekking",
        "trek"
    ],
    "trembla": [
        "trembler"
    ],
    "tremblai": [
        "trembler"
    ],
    "tremblaient": [
        "trembler"
    ],
    "tremblais": [
        "trembler"
    ],
    "tremblait": [
        "trembler"
    ],
    "tremblant": [
        "tremblant",
        "trembler"
    ],
    "tremblante": [
        "tremblant"
    ],
    "tremblantes": [
        "tremblant"
    ],
    "tremblants": [
        "tremblant"
    ],
    "tremble": [
        "trembler",
        "tremble"
    ],
    "tremblement": [
        "tremblement"
    ],
    "tremblements": [
        "tremblement"
    ],
    "tremblent": [
        "trembler"
    ],
    "trembler": [
        "trembler"
    ],
    "tremblera": [
        "trembler"
    ],
    "tremblerai": [
        "trembler"
    ],
    "trembleraient": [
        "trembler"
    ],
    "tremblerais": [
        "trembler"
    ],
    "tremblerait": [
        "trembler"
    ],
    "tremblerons": [
        "trembler"
    ],
    "trembleront": [
        "trembler"
    ],
    "trembles": [
        "trembler",
        "tremble"
    ],
    "trembleur": [
        "trembleur"
    ],
    "trembleurs": [
        "trembleur"
    ],
    "tremblez": [
        "trembler"
    ],
    "trembliez": [
        "trembler"
    ],
    "tremblions": [
        "trembler"
    ],
    "tremblochant": [
        "tremblocher"
    ],
    "tremblons": [
        "trembler"
    ],
    "tremblota": [
        "trembloter"
    ],
    "tremblotaient": [
        "trembloter"
    ],
    "tremblotait": [
        "trembloter"
    ],
    "tremblotant": [
        "tremblotant",
        "trembloter"
    ],
    "tremblotante": [
        "tremblotant"
    ],
    "tremblotantes": [
        "tremblotant"
    ],
    "tremblotants": [
        "tremblotant"
    ],
    "tremblote": [
        "tremblote",
        "trembloter"
    ],
    "tremblotement": [
        "tremblotement"
    ],
    "tremblotements": [
        "tremblotement"
    ],
    "tremblotent": [
        "trembloter"
    ],
    "trembloter": [
        "trembloter"
    ],
    "tremblat": [
        "trembler"
    ],
    "tremblerent": [
        "trembler"
    ],
    "tremblee": [
        "trembler",
        "tremble"
    ],
    "tremblees": [
        "trembler",
        "tremble"
    ],
    "tremolos": [
        "tremolo"
    ],
    "trempa": [
        "tremper"
    ],
    "trempage": [
        "trempage"
    ],
    "trempages": [
        "trempage"
    ],
    "trempai": [
        "tremper"
    ],
    "trempaient": [
        "tremper"
    ],
    "trempais": [
        "tremper"
    ],
    "trempait": [
        "tremper"
    ],
    "trempant": [
        "tremper"
    ],
    "trempe": [
        "trempe",
        "tremper"
    ],
    "trempent": [
        "tremper"
    ],
    "tremper": [
        "tremper"
    ],
    "trempera": [
        "tremper"
    ],
    "tremperaient": [
        "tremper"
    ],
    "tremperais": [
        "tremper"
    ],
    "tremperait": [
        "tremper"
    ],
    "trempes": [
        "trempe",
        "tremper"
    ],
    "trempette": [
        "trempette"
    ],
    "trempeur": [
        "trempeur"
    ],
    "trempez": [
        "tremper"
    ],
    "trempions": [
        "tremper"
    ],
    "tremplin": [
        "tremplin"
    ],
    "trempoline": [
        "trempoline"
    ],
    "trempons": [
        "tremper"
    ],
    "tremperent": [
        "tremper"
    ],
    "trempee": [
        "trempe",
        "tremper"
    ],
    "trempees": [
        "trempe",
        "tremper"
    ],
    "trench": [
        "trench"
    ],
    "trentaine": [
        "trentaine"
    ],
    "trente": [
        "trente"
    ],
    "trentenaire": [
        "trentenaire"
    ],
    "trentenaires": [
        "trentenaire"
    ],
    "trentieme": [
        "trentieme"
    ],
    "tressa": [
        "tresser"
    ],
    "tressaient": [
        "tresser"
    ],
    "tressaillaient": [
        "tressaillir"
    ],
    "tressaillais": [
        "tressaillir"
    ],
    "tressaillait": [
        "tressaillir"
    ],
    "tressaillant": [
        "tressaillir"
    ],
    "tressaille": [
        "tressaillir"
    ],
    "tressaillement": [
        "tressaillement"
    ],
    "tressaillements": [
        "tressaillement"
    ],
    "tressaillent": [
        "tressaillir"
    ],
    "tressaillez": [
        "tressaillir"
    ],
    "tressailli": [
        "tressaillir"
    ],
    "tressaillir": [
        "tressaillir"
    ],
    "tressaillira": [
        "tressaillir"
    ],
    "tressaillirait": [
        "tressaillir"
    ],
    "tressaillirent": [
        "tressaillir"
    ],
    "tressaillis": [
        "tressaillir"
    ],
    "tressaillit": [
        "tressaillir"
    ],
    "tressait": [
        "tresser"
    ],
    "tressant": [
        "tresser"
    ],
    "tressauta": [
        "tressauter"
    ],
    "tressautaient": [
        "tressauter"
    ],
    "tressautait": [
        "tressauter"
    ],
    "tressautant": [
        "tressautant",
        "tressauter"
    ],
    "tressautante": [
        "tressautant"
    ],
    "tressaute": [
        "tressauter"
    ],
    "tressautement": [
        "tressautement"
    ],
    "tressautements": [
        "tressautement"
    ],
    "tressautent": [
        "tressauter"
    ],
    "tressauter": [
        "tressauter"
    ],
    "tressautera": [
        "tressauter"
    ],
    "tressautes": [
        "tressauter"
    ],
    "tresse": [
        "tresse",
        "tresser"
    ],
    "tressent": [
        "tresser"
    ],
    "tresser": [
        "tresser"
    ],
    "tresseraient": [
        "tresser"
    ],
    "tresseras": [
        "tresser"
    ],
    "tresses": [
        "tresse",
        "tresser"
    ],
    "tresseurs": [
        "tresseur"
    ],
    "tressons": [
        "tresser"
    ],
    "tresserent": [
        "tresser"
    ],
    "tressee": [
        "tresser"
    ],
    "tressees": [
        "tresser"
    ],
    "treuil": [
        "treuil"
    ],
    "treuiller": [
        "treuiller"
    ],
    "treuils": [
        "treuil"
    ],
    "tri": [
        "tri"
    ],
    "tria": [
        "trier"
    ],
    "triade": [
        "triade"
    ],
    "triades": [
        "triade"
    ],
    "triage": [
        "triage"
    ],
    "triaient": [
        "trier"
    ],
    "triais": [
        "trier"
    ],
    "triait": [
        "trier"
    ],
    "trial": [
        "trial"
    ],
    "triangle": [
        "triangle"
    ],
    "triangles": [
        "triangle"
    ],
    "triangulaire": [
        "triangulaire"
    ],
    "triangulairement": [
        "triangulairement"
    ],
    "triangulaires": [
        "triangulaire"
    ],
    "triangulation": [
        "triangulation"
    ],
    "trianguler": [
        "trianguler"
    ],
    "triangulez": [
        "trianguler"
    ],
    "trianon": [
        "trianon"
    ],
    "triant": [
        "trier"
    ],
    "trias": [
        "trias"
    ],
    "triasique": [
        "triasique"
    ],
    "triathlon": [
        "triathlon"
    ],
    "triathlete": [
        "triathlete"
    ],
    "tribal": [
        "tribal"
    ],
    "tribale": [
        "tribal"
    ],
    "tribales": [
        "tribal"
    ],
    "tribart": [
        "tribart"
    ],
    "tribaux": [
        "tribal"
    ],
    "tribord": [
        "tribord"
    ],
    "tribu": [
        "tribu"
    ],
    "tribulation": [
        "tribulation"
    ],
    "tribulations": [
        "tribulation"
    ],
    "tribun": [
        "tribun"
    ],
    "tribunal": [
        "tribunal"
    ],
    "tribunat": [
        "tribunat"
    ],
    "tribunaux": [
        "tribunal"
    ],
    "tribune": [
        "tribune"
    ],
    "tribunes": [
        "tribune"
    ],
    "tribuns": [
        "tribun"
    ],
    "tribus": [
        "tribu"
    ],
    "tribut": [
        "tribut"
    ],
    "tributaire": [
        "tributaire"
    ],
    "tributaires": [
        "tributaire"
    ],
    "tributs": [
        "tribut"
    ],
    "tric": [
        "tric"
    ],
    "tricard": [
        "tricard"
    ],
    "tricarde": [
        "tricard"
    ],
    "tricards": [
        "tricard"
    ],
    "tricentenaire": [
        "tricentenaire"
    ],
    "triceps": [
        "triceps"
    ],
    "tricha": [
        "tricher"
    ],
    "trichaient": [
        "tricher"
    ],
    "trichais": [
        "tricher"
    ],
    "trichait": [
        "tricher"
    ],
    "trichant": [
        "tricher"
    ],
    "triche": [
        "tricher",
        "triche"
    ],
    "trichent": [
        "tricher"
    ],
    "tricher": [
        "tricher"
    ],
    "trichera": [
        "tricher"
    ],
    "tricherai": [
        "tricher"
    ],
    "tricherais": [
        "tricher"
    ],
    "tricherait": [
        "tricher"
    ],
    "tricherie": [
        "tricherie"
    ],
    "tricheries": [
        "tricherie"
    ],
    "tricheront": [
        "tricher"
    ],
    "triches": [
        "tricher",
        "triche"
    ],
    "tricheur": [
        "tricheur"
    ],
    "tricheurs": [
        "tricheur"
    ],
    "tricheuse": [
        "tricheur"
    ],
    "tricheuses": [
        "tricheur"
    ],
    "trichez": [
        "tricher"
    ],
    "trichiez": [
        "tricher"
    ],
    "trichinose": [
        "trichinose"
    ],
    "trichloracetique": [
        "trichloracetique"
    ],
    "trichlorure": [
        "trichlorure"
    ],
    "trichlorethylene": [
        "trichlorethylene"
    ],
    "trichons": [
        "tricher"
    ],
    "trichophyties": [
        "trichophytie"
    ],
    "trichee": [
        "tricher"
    ],
    "trichees": [
        "tricher"
    ],
    "trick": [
        "trick"
    ],
    "tricoises": [
        "tricoises"
    ],
    "tricolore": [
        "tricolore"
    ],
    "tricolores": [
        "tricolore"
    ],
    "tricorne": [
        "tricorne"
    ],
    "tricornes": [
        "tricorne"
    ],
    "tricot": [
        "tricot"
    ],
    "tricota": [
        "tricoter"
    ],
    "tricotage": [
        "tricotage"
    ],
    "tricotages": [
        "tricotage"
    ],
    "tricotai": [
        "tricoter"
    ],
    "tricotaient": [
        "tricoter"
    ],
    "tricotais": [
        "tricoter"
    ],
    "tricotait": [
        "tricoter"
    ],
    "tricotant": [
        "tricoter"
    ],
    "tricote": [
        "tricoter"
    ],
    "tricotent": [
        "tricoter"
    ],
    "tricoter": [
        "tricoter"
    ],
    "tricotera": [
        "tricoter"
    ],
    "tricoterai": [
        "tricoter"
    ],
    "tricoterait": [
        "tricoter"
    ],
    "tricoteras": [
        "tricoter"
    ],
    "tricoterons": [
        "tricoter"
    ],
    "tricoteur": [
        "tricoteur"
    ],
    "tricoteuse": [
        "tricoteur"
    ],
    "tricoteuses": [
        "tricoteur"
    ],
    "tricotez": [
        "tricoter"
    ],
    "tricots": [
        "tricot"
    ],
    "tricotee": [
        "tricoter"
    ],
    "tricotees": [
        "tricoter"
    ],
    "tricotes": [
        "tricoter"
    ],
    "trictrac": [
        "trictrac"
    ],
    "tricuspide": [
        "tricuspide"
    ],
    "tricycle": [
        "tricycle"
    ],
    "tricycles": [
        "tricycle"
    ],
    "tricycliste": [
        "tricycliste"
    ],
    "tricephale": [
        "tricephale"
    ],
    "triceratops": [
        "triceratops"
    ],
    "trident": [
        "trident"
    ],
    "tridents": [
        "trident"
    ],
    "tridi": [
        "tridi"
    ],
    "tridimensionnel": [
        "tridimensionnel"
    ],
    "tridimensionnelle": [
        "tridimensionnel"
    ],
    "trie": [
        "trier"
    ],
    "triennale": [
        "triennal"
    ],
    "triennales": [
        "triennal"
    ],
    "trient": [
        "trier"
    ],
    "trier": [
        "trier"
    ],
    "triera": [
        "trier"
    ],
    "trierait": [
        "trier"
    ],
    "trieur": [
        "trieur"
    ],
    "trieurs": [
        "trieur"
    ],
    "trieuse": [
        "trieur"
    ],
    "trieuses": [
        "trieur"
    ],
    "triez": [
        "trier"
    ],
    "trifolium": [
        "trifolium"
    ],
    "triforium": [
        "triforium"
    ],
    "trifouillaient": [
        "trifouiller"
    ],
    "trifouillait": [
        "trifouiller"
    ],
    "trifouille": [
        "trifouiller"
    ],
    "trifouiller": [
        "trifouiller"
    ],
    "trifouillez": [
        "trifouiller"
    ],
    "trigger": [
        "trigger"
    ],
    "trigles": [
        "trigle"
    ],
    "triglyceride": [
        "triglyceride"
    ],
    "triglycerides": [
        "triglyceride"
    ],
    "trigonometrie": [
        "trigonometrie"
    ],
    "trigrammes": [
        "trigramme"
    ],
    "trilaterale": [
        "trilateral"
    ],
    "trilingue": [
        "trilingue"
    ],
    "trilingues": [
        "trilingue"
    ],
    "trillant": [
        "triller"
    ],
    "trille": [
        "trille",
        "triller"
    ],
    "trilles": [
        "trille"
    ],
    "trillion": [
        "trillion"
    ],
    "trillions": [
        "triller",
        "trillion"
    ],
    "trilobite": [
        "trilobite"
    ],
    "trilobee": [
        "trilobe"
    ],
    "trilobes": [
        "trilobe"
    ],
    "trilogie": [
        "trilogie"
    ],
    "trimait": [
        "trimer"
    ],
    "trimant": [
        "trimer"
    ],
    "trimard": [
        "trimard"
    ],
    "trimarde": [
        "trimarder"
    ],
    "trimarder": [
        "trimarder"
    ],
    "trimardeur": [
        "trimardeur"
    ],
    "trimardeurs": [
        "trimardeur"
    ],
    "trimards": [
        "trimard"
    ],
    "trimbala": [
        "trimbaler"
    ],
    "trimbalaient": [
        "trimbaler"
    ],
    "trimbalais": [
        "trimbaler"
    ],
    "trimbalait": [
        "trimbaler"
    ],
    "trimbalant": [
        "trimbaler"
    ],
    "trimbale": [
        "trimbaler"
    ],
    "trimbalent": [
        "trimbaler"
    ],
    "trimbaler": [
        "trimbaler"
    ],
    "trimbalerai": [
        "trimbaler"
    ],
    "trimbalerait": [
        "trimbaler"
    ],
    "trimbalerez": [
        "trimbaler"
    ],
    "trimbales": [
        "trimbaler"
    ],
    "trimbalez": [
        "trimbaler"
    ],
    "trimballage": [
        "trimballage"
    ],
    "trimballaient": [
        "trimballer"
    ],
    "trimballais": [
        "trimballer"
    ],
    "trimballait": [
        "trimballer"
    ],
    "trimballe": [
        "trimballer"
    ],
    "trimballent": [
        "trimballer"
    ],
    "trimballer": [
        "trimballer"
    ],
    "trimballera": [
        "trimballer"
    ],
    "trimballes": [
        "trimballer"
    ],
    "trimballez": [
        "trimballer"
    ],
    "trimballat": [
        "trimballer"
    ],
    "trimballee": [
        "trimballer"
    ],
    "trimbalons": [
        "trimbaler"
    ],
    "trimbalee": [
        "trimbaler"
    ],
    "trime": [
        "trimer"
    ],
    "triment": [
        "trimer"
    ],
    "trimer": [
        "trimer"
    ],
    "trimes": [
        "trimer"
    ],
    "trimestre": [
        "trimestre"
    ],
    "trimestres": [
        "trimestre"
    ],
    "trimestriel": [
        "trimestriel"
    ],
    "trimestrielle": [
        "trimestriel"
    ],
    "trimestriellement": [
        "trimestriellement"
    ],
    "trimestrielles": [
        "trimestriel"
    ],
    "trimestriels": [
        "trimestriel"
    ],
    "trimeur": [
        "trimeur"
    ],
    "trimeurs": [
        "trimeur"
    ],
    "trimmer": [
        "trimmer",
        "trim"
    ],
    "trimons": [
        "trimer"
    ],
    "trinacrie": [
        "trinacrie"
    ],
    "trine": [
        "trin"
    ],
    "tringlaient": [
        "tringler"
    ],
    "tringlais": [
        "tringler"
    ],
    "tringlait": [
        "tringler"
    ],
    "tringle": [
        "tringler",
        "tringle"
    ],
    "tringler": [
        "tringler"
    ],
    "tringlerais": [
        "tringler"
    ],
    "tringles": [
        "tringler",
        "tringle"
    ],
    "tringlette": [
        "tringlette"
    ],
    "tringlot": [
        "tringlot"
    ],
    "tringlots": [
        "tringlot"
    ],
    "tringlee": [
        "tringler"
    ],
    "trinidadienne": [
        "trinidadienne"
    ],
    "trinitaire": [
        "trinitaire"
    ],
    "trinitrine": [
        "trinitrine"
    ],
    "trinite": [
        "trinite"
    ],
    "trinqua": [
        "trinquer"
    ],
    "trinquaient": [
        "trinquer"
    ],
    "trinquais": [
        "trinquer"
    ],
    "trinquait": [
        "trinquer"
    ],
    "trinquant": [
        "trinquer"
    ],
    "trinque": [
        "trinquer"
    ],
    "trinquent": [
        "trinquer"
    ],
    "trinquer": [
        "trinquer"
    ],
    "trinquera": [
        "trinquer"
    ],
    "trinquerai": [
        "trinquer"
    ],
    "trinquerais": [
        "trinquer"
    ],
    "trinquerait": [
        "trinquer"
    ],
    "trinqueras": [
        "trinquer"
    ],
    "trinquerez": [
        "trinquer"
    ],
    "trinquerons": [
        "trinquer"
    ],
    "trinques": [
        "trinquer"
    ],
    "trinquette": [
        "trinquette"
    ],
    "trinquez": [
        "trinquer"
    ],
    "trinquions": [
        "trinquer"
    ],
    "trinquons": [
        "trinquer"
    ],
    "trinquames": [
        "trinquer"
    ],
    "trinquerent": [
        "trinquer"
    ],
    "trinome": [
        "trinome"
    ],
    "trio": [
        "trio"
    ],
    "triode": [
        "triode"
    ],
    "triolet": [
        "triolet"
    ],
    "triolets": [
        "triolet"
    ],
    "triolisme": [
        "triolisme"
    ],
    "triompha": [
        "triompher"
    ],
    "triomphai": [
        "triompher"
    ],
    "triomphaient": [
        "triompher"
    ],
    "triomphais": [
        "triompher"
    ],
    "triomphait": [
        "triompher"
    ],
    "triomphal": [
        "triomphal"
    ],
    "triomphale": [
        "triomphal"
    ],
    "triomphalement": [
        "triomphalement"
    ],
    "triomphales": [
        "triomphal"
    ],
    "triomphalisme": [
        "triomphalisme"
    ],
    "triomphaliste": [
        "triomphaliste"
    ],
    "triomphalistes": [
        "triomphaliste"
    ],
    "triomphant": [
        "triomphant",
        "triompher"
    ],
    "triomphante": [
        "triomphant"
    ],
    "triomphantes": [
        "triomphant"
    ],
    "triomphants": [
        "triomphant"
    ],
    "triomphateur": [
        "triomphateur"
    ],
    "triomphateurs": [
        "triomphateur"
    ],
    "triomphatrice": [
        "triomphateur"
    ],
    "triomphatrices": [
        "triomphateur"
    ],
    "triomphaux": [
        "triomphal"
    ],
    "triomphe": [
        "triomphe",
        "triompher"
    ],
    "triomphent": [
        "triompher"
    ],
    "triompher": [
        "triompher"
    ],
    "triomphera": [
        "triompher"
    ],
    "triompherai": [
        "triompher"
    ],
    "triompherais": [
        "triompher"
    ],
    "triompherait": [
        "triompher"
    ],
    "triompheras": [
        "triompher"
    ],
    "triompherez": [
        "triompher"
    ],
    "triompherions": [
        "triompher"
    ],
    "triompherons": [
        "triompher"
    ],
    "triompheront": [
        "triompher"
    ],
    "triomphes": [
        "triomphe",
        "triompher"
    ],
    "triomphez": [
        "triompher"
    ],
    "triomphions": [
        "triompher"
    ],
    "triomphons": [
        "triompher"
    ],
    "triomphames": [
        "triompher"
    ],
    "triomphat": [
        "triompher"
    ],
    "triompherent": [
        "triompher"
    ],
    "trional": [
        "trional"
    ],
    "trionix": [
        "trionix"
    ],
    "trios": [
        "trio"
    ],
    "trip": [
        "trip"
    ],
    "tripaille": [
        "tripaille"
    ],
    "tripailles": [
        "tripaille"
    ],
    "tripang": [
        "tripang"
    ],
    "tripangs": [
        "tripang"
    ],
    "tripant": [
        "tripant"
    ],
    "tripartite": [
        "tripartite"
    ],
    "tripartites": [
        "tripartite"
    ],
    "tripatouillage": [
        "tripatouillage"
    ],
    "tripatouillages": [
        "tripatouillage"
    ],
    "tripatouillant": [
        "tripatouiller"
    ],
    "tripatouillent": [
        "tripatouiller"
    ],
    "tripatouiller": [
        "tripatouiller"
    ],
    "tripatouillez": [
        "tripatouiller"
    ],
    "tripatouille": [
        "tripatouiller"
    ],
    "tripatouillee": [
        "tripatouiller"
    ],
    "tripe": [
        "tripe"
    ],
    "triper": [
        "triper"
    ],
    "triperie": [
        "triperie"
    ],
    "triperies": [
        "triperie"
    ],
    "tripes": [
        "tripe"
    ],
    "tripette": [
        "tripette"
    ],
    "triphase": [
        "triphase"
    ],
    "triphosphate": [
        "triphosphate"
    ],
    "tripier": [
        "tripier"
    ],
    "tripiers": [
        "tripier"
    ],
    "tripiere": [
        "tripier"
    ],
    "tripla": [
        "tripler"
    ],
    "triplace": [
        "triplace"
    ],
    "triplai": [
        "tripler"
    ],
    "triplaient": [
        "tripler"
    ],
    "triplait": [
        "tripler"
    ],
    "triplant": [
        "tripler"
    ],
    "triple": [
        "triple",
        "tripler"
    ],
    "triplement": [
        "triplement"
    ],
    "triplent": [
        "tripler"
    ],
    "tripler": [
        "tripler"
    ],
    "triplerais": [
        "tripler"
    ],
    "triplerait": [
        "tripler"
    ],
    "triples": [
        "triple"
    ],
    "triplets": [
        "triplet"
    ],
    "triplette": [
        "triplette"
    ],
    "triplex": [
        "triplex"
    ],
    "triplice": [
        "triplice"
    ],
    "triplions": [
        "tripler"
    ],
    "triplons": [
        "tripler"
    ],
    "triploide": [
        "triploide"
    ],
    "triplerent": [
        "tripler"
    ],
    "triplee": [
        "tripler",
        "triple"
    ],
    "triplees": [
        "triple"
    ],
    "tripode": [
        "tripode"
    ],
    "tripoli": [
        "tripoli"
    ],
    "triporteur": [
        "triporteur"
    ],
    "triporteurs": [
        "triporteur"
    ],
    "tripot": [
        "tripot"
    ],
    "tripota": [
        "tripoter"
    ],
    "tripotage": [
        "tripotage"
    ],
    "tripotages": [
        "tripotage"
    ],
    "tripotaient": [
        "tripoter"
    ],
    "tripotais": [
        "tripoter"
    ],
    "tripotait": [
        "tripoter"
    ],
    "tripotant": [
        "tripoter"
    ],
    "tripote": [
        "tripoter"
    ],
    "tripotent": [
        "tripoter"
    ],
    "tripoter": [
        "tripoter"
    ],
    "tripoterai": [
        "tripoter"
    ],
    "tripotes": [
        "tripoter"
    ],
    "tripoteur": [
        "tripoteur"
    ],
    "tripoteuse": [
        "tripoteur"
    ],
    "tripotez": [
        "tripoter"
    ],
    "tripotiez": [
        "tripoter"
    ],
    "tripots": [
        "tripot"
    ],
    "tripoterent": [
        "tripoter"
    ],
    "tripotee": [
        "tripotee",
        "tripoter"
    ],
    "tripotees": [
        "tripoter"
    ],
    "tripoux": [
        "tripoux"
    ],
    "trips": [
        "trip"
    ],
    "triptyque": [
        "triptyque"
    ],
    "triptyques": [
        "triptyque"
    ],
    "triquais": [
        "triquer"
    ],
    "triquait": [
        "triquer"
    ],
    "trique": [
        "triquer",
        "trique"
    ],
    "triqueballe": [
        "triqueballe"
    ],
    "triquer": [
        "triquer"
    ],
    "triques": [
        "trique"
    ],
    "trireme": [
        "trireme"
    ],
    "triremes": [
        "trireme"
    ],
    "tris": [
        "tri"
    ],
    "trisaieul": [
        "trisaieul"
    ],
    "trisaieule": [
        "trisaieul"
    ],
    "trisaieuls": [
        "trisaieul"
    ],
    "trismique": [
        "trismique"
    ],
    "trismus": [
        "trismus"
    ],
    "trismegiste": [
        "trismegiste"
    ],
    "trisomie": [
        "trisomie"
    ],
    "trisomique": [
        "trisomique"
    ],
    "trissait": [
        "trisser"
    ],
    "trisse": [
        "trisser"
    ],
    "trissent": [
        "trisser"
    ],
    "trisser": [
        "trisser"
    ],
    "trisses": [
        "trisser"
    ],
    "triste": [
        "triste"
    ],
    "tristement": [
        "tristement"
    ],
    "tristes": [
        "triste"
    ],
    "tristesse": [
        "tristesse"
    ],
    "tristesses": [
        "tristesse"
    ],
    "tristouillard": [
        "tristouillard"
    ],
    "tristouillarde": [
        "tristouillard"
    ],
    "tristouille": [
        "tristouille"
    ],
    "tristouilles": [
        "tristouille"
    ],
    "tristounet": [
        "tristounet"
    ],
    "tristounette": [
        "tristounet"
    ],
    "tristounettes": [
        "tristounet"
    ],
    "tritheisme": [
        "tritheisme"
    ],
    "tritherapie": [
        "tritherapie"
    ],
    "tritium": [
        "tritium"
    ],
    "triton": [
        "triton"
    ],
    "tritons": [
        "triton"
    ],
    "tritura": [
        "triturer"
    ],
    "trituraient": [
        "triturer"
    ],
    "triturais": [
        "triturer"
    ],
    "triturait": [
        "triturer"
    ],
    "triturant": [
        "triturant",
        "triturer"
    ],
    "trituration": [
        "trituration"
    ],
    "triturations": [
        "trituration"
    ],
    "triture": [
        "triturer"
    ],
    "triturent": [
        "triturer"
    ],
    "triturer": [
        "triturer"
    ],
    "triturera": [
        "triturer"
    ],
    "triturons": [
        "triturer"
    ],
    "trituree": [
        "triturer"
    ],
    "triturees": [
        "triturer"
    ],
    "tritures": [
        "triturer"
    ],
    "triumvir": [
        "triumvir"
    ],
    "triumvirat": [
        "triumvirat"
    ],
    "trivial": [
        "trivial"
    ],
    "triviale": [
        "trivial"
    ],
    "trivialement": [
        "trivialement"
    ],
    "triviales": [
        "trivial"
    ],
    "trivialiser": [
        "trivialiser"
    ],
    "trivialite": [
        "trivialite"
    ],
    "trivialites": [
        "trivialite"
    ],
    "triviaux": [
        "trivial"
    ],
    "trivium": [
        "trivium"
    ],
    "trierent": [
        "trier"
    ],
    "triee": [
        "trier"
    ],
    "triees": [
        "trier"
    ],
    "tries": [
        "try",
        "trier"
    ],
    "trobriandais": [
        "trobriandais"
    ],
    "troc": [
        "troc"
    ],
    "trocart": [
        "trocart"
    ],
    "trochanter": [
        "trochanter"
    ],
    "trochaique": [
        "trochaique"
    ],
    "troche": [
        "troche"
    ],
    "trochures": [
        "trochure"
    ],
    "trochee": [
        "trochee"
    ],
    "trocs": [
        "troc"
    ],
    "troglodyte": [
        "troglodyte"
    ],
    "troglodytes": [
        "troglodyte"
    ],
    "troglodytique": [
        "troglodytique"
    ],
    "troglodytiques": [
        "troglodytique"
    ],
    "trogne": [
        "trogne"
    ],
    "trognes": [
        "trogne"
    ],
    "trognon": [
        "trognon"
    ],
    "trognons": [
        "trognon"
    ],
    "trois": [
        "trois"
    ],
    "troisieme": [
        "troisieme"
    ],
    "troisiemement": [
        "troisiemement"
    ],
    "troisiemes": [
        "troisieme"
    ],
    "troll": [
        "troll"
    ],
    "trolle": [
        "trolle"
    ],
    "trolley": [
        "trolley"
    ],
    "trolleybus": [
        "trolleybus"
    ],
    "trolleys": [
        "trolley"
    ],
    "trolls": [
        "troll"
    ],
    "trombe": [
        "trombe"
    ],
    "trombes": [
        "trombe"
    ],
    "trombine": [
        "trombine"
    ],
    "trombines": [
        "trombine"
    ],
    "trombinoscope": [
        "trombinoscope"
    ],
    "tromblon": [
        "tromblon"
    ],
    "tromblons": [
        "tromblon"
    ],
    "trombone": [
        "trombone"
    ],
    "trombones": [
        "trombone"
    ],
    "tromboniste": [
        "tromboniste"
    ],
    "trommel": [
        "trommel"
    ],
    "trompa": [
        "tromper"
    ],
    "trompai": [
        "tromper"
    ],
    "trompaient": [
        "tromper"
    ],
    "trompais": [
        "tromper"
    ],
    "trompait": [
        "tromper"
    ],
    "trompant": [
        "tromper"
    ],
    "trompe": [
        "tromper",
        "trompe"
    ],
    "trompent": [
        "tromper"
    ],
    "tromper": [
        "tromper"
    ],
    "trompera": [
        "tromper"
    ],
    "tromperai": [
        "tromper"
    ],
    "tromperaient": [
        "tromper"
    ],
    "tromperais": [
        "tromper"
    ],
    "tromperait": [
        "tromper"
    ],
    "tromperas": [
        "tromper"
    ],
    "tromperez": [
        "tromper"
    ],
    "tromperie": [
        "tromperie"
    ],
    "tromperies": [
        "tromperie"
    ],
    "tromperiez": [
        "tromper"
    ],
    "tromperons": [
        "tromper"
    ],
    "tromperont": [
        "tromper"
    ],
    "trompes": [
        "tromper",
        "trompe"
    ],
    "trompeter": [
        "trompeter"
    ],
    "trompette": [
        "trompette"
    ],
    "trompettes": [
        "trompette"
    ],
    "trompettiste": [
        "trompettiste"
    ],
    "trompettistes": [
        "trompettiste"
    ],
    "trompeur": [
        "trompeur"
    ],
    "trompeurs": [
        "trompeur"
    ],
    "trompeuse": [
        "trompeur"
    ],
    "trompeusement": [
        "trompeusement"
    ],
    "trompeuses": [
        "trompeur"
    ],
    "trompez": [
        "tromper"
    ],
    "trompiez": [
        "tromper"
    ],
    "trompions": [
        "tromper"
    ],
    "trompons": [
        "tromper"
    ],
    "trompames": [
        "tromper"
    ],
    "trompat": [
        "tromper"
    ],
    "tromperent": [
        "tromper"
    ],
    "trompee": [
        "tromper",
        "trompe"
    ],
    "trompees": [
        "tromper",
        "trompe"
    ],
    "tronc": [
        "tronc"
    ],
    "tronchais": [
        "troncher"
    ],
    "tronche": [
        "tronche",
        "troncher"
    ],
    "troncher": [
        "troncher"
    ],
    "tronches": [
        "tronche"
    ],
    "tronchee": [
        "troncher"
    ],
    "tronconique": [
        "tronconique"
    ],
    "troncs": [
        "tronc"
    ],
    "tronquer": [
        "tronquer"
    ],
    "tronque": [
        "tronque",
        "tronquer"
    ],
    "tronquee": [
        "tronque",
        "tronquer"
    ],
    "tronquees": [
        "tronque",
        "tronquer"
    ],
    "tronques": [
        "tronque"
    ],
    "troncon": [
        "troncon"
    ],
    "tronconnaient": [
        "tronconner"
    ],
    "tronconnait": [
        "tronconner"
    ],
    "tronconne": [
        "tronconner"
    ],
    "tronconner": [
        "tronconner"
    ],
    "tronconneuse": [
        "tronconneur"
    ],
    "tronconneuses": [
        "tronconneur"
    ],
    "tronconnee": [
        "tronconner"
    ],
    "tronconnees": [
        "tronconner"
    ],
    "tronconnes": [
        "tronconner"
    ],
    "troncons": [
        "troncon"
    ],
    "trop": [
        "trop"
    ],
    "trope": [
        "trope"
    ],
    "trophee": [
        "trophee"
    ],
    "trophees": [
        "trophee"
    ],
    "tropical": [
        "tropical"
    ],
    "tropicale": [
        "tropical"
    ],
    "tropicales": [
        "tropical"
    ],
    "tropicaux": [
        "tropical"
    ],
    "tropique": [
        "tropique"
    ],
    "tropiques": [
        "tropique"
    ],
    "tropisme": [
        "tropisme"
    ],
    "tropismes": [
        "tropisme"
    ],
    "troposphere": [
        "troposphere"
    ],
    "tropospherique": [
        "tropospherique"
    ],
    "tropospheriques": [
        "tropospherique"
    ],
    "tropezienne": [
        "tropezien"
    ],
    "tropeziens": [
        "tropezien"
    ],
    "troqua": [
        "troquer"
    ],
    "troquaient": [
        "troquer"
    ],
    "troquais": [
        "troquer"
    ],
    "troquait": [
        "troquer"
    ],
    "troquant": [
        "troquer"
    ],
    "troquas": [
        "troquer"
    ],
    "troque": [
        "troquer"
    ],
    "troquer": [
        "troquer"
    ],
    "troquera": [
        "troquer"
    ],
    "troquerai": [
        "troquer"
    ],
    "troquerais": [
        "troquer"
    ],
    "troquet": [
        "troquet"
    ],
    "troquets": [
        "troquet"
    ],
    "troquez": [
        "troquer"
    ],
    "troquerent": [
        "troquer"
    ],
    "troquee": [
        "troquer"
    ],
    "troquees": [
        "troquer"
    ],
    "troques": [
        "troquer"
    ],
    "trot": [
        "trot"
    ],
    "trots": [
        "trot"
    ],
    "trotskisme": [
        "trotskisme"
    ],
    "trotskiste": [
        "trotskiste"
    ],
    "trotskistes": [
        "trotskiste"
    ],
    "trotskystes": [
        "trotskyste"
    ],
    "trotta": [
        "trotter"
    ],
    "trottaient": [
        "trotter"
    ],
    "trottais": [
        "trotter"
    ],
    "trottait": [
        "trotter"
    ],
    "trottant": [
        "trotter"
    ],
    "trotte": [
        "trotte",
        "trotter"
    ],
    "trottent": [
        "trotter"
    ],
    "trotter": [
        "trotter"
    ],
    "trottera": [
        "trotter"
    ],
    "trotterions": [
        "trotter"
    ],
    "trottes": [
        "trotte",
        "trotter"
    ],
    "trotteur": [
        "trotteur"
    ],
    "trotteurs": [
        "trotteur"
    ],
    "trotteuse": [
        "trotteur"
    ],
    "trotteuses": [
        "trotteur"
    ],
    "trottez": [
        "trotter"
    ],
    "trottignolles": [
        "trottignolle"
    ],
    "trottin": [
        "trottin"
    ],
    "trottina": [
        "trottiner"
    ],
    "trottinais": [
        "trottiner"
    ],
    "trottinait": [
        "trottiner"
    ],
    "trottinant": [
        "trottinant",
        "trottiner"
    ],
    "trottine": [
        "trottiner"
    ],
    "trottinement": [
        "trottinement"
    ],
    "trottinements": [
        "trottinement"
    ],
    "trottinent": [
        "trottiner"
    ],
    "trottiner": [
        "trottiner"
    ],
    "trottinerait": [
        "trottiner"
    ],
    "trottinette": [
        "trottinette"
    ],
    "trottinettes": [
        "trottinette"
    ],
    "trottinez": [
        "trottiner"
    ],
    "trottinions": [
        "trottiner"
    ],
    "trottins": [
        "trottin"
    ],
    "trottions": [
        "trotter"
    ],
    "trottoir": [
        "trottoir"
    ],
    "trottoirs": [
        "trottoir"
    ],
    "trottons": [
        "trotter"
    ],
    "trou": [
        "trou"
    ],
    "troua": [
        "trouer"
    ],
    "trouai": [
        "trouer"
    ],
    "trouaient": [
        "trouer"
    ],
    "trouais": [
        "trouer"
    ],
    "trouait": [
        "trouer"
    ],
    "trouant": [
        "trouer"
    ],
    "troubades": [
        "troubade"
    ],
    "troubadour": [
        "troubadour"
    ],
    "troubadours": [
        "troubadour"
    ],
    "troubla": [
        "troubler"
    ],
    "troublai": [
        "troubler"
    ],
    "troublaient": [
        "troubler"
    ],
    "troublais": [
        "troubler"
    ],
    "troublait": [
        "troubler"
    ],
    "troublant": [
        "troubler",
        "troublant"
    ],
    "troublante": [
        "troublant"
    ],
    "troublantes": [
        "troublant"
    ],
    "troublants": [
        "troublant"
    ],
    "trouble": [
        "troubler",
        "trouble"
    ],
    "troublent": [
        "troubler"
    ],
    "troubler": [
        "troubler"
    ],
    "troublera": [
        "troubler"
    ],
    "troublerais": [
        "troubler"
    ],
    "troublerait": [
        "troubler"
    ],
    "troubleront": [
        "troubler"
    ],
    "troubles": [
        "troubler",
        "trouble"
    ],
    "troublez": [
        "troubler"
    ],
    "troublat": [
        "troubler"
    ],
    "troublerent": [
        "troubler"
    ],
    "troublee": [
        "troubler",
        "trouble"
    ],
    "troublees": [
        "troubler",
        "trouble"
    ],
    "trouduc": [
        "trouduc"
    ],
    "trouducuteries": [
        "trouducuterie"
    ],
    "troue": [
        "trouer",
        "troue"
    ],
    "trouent": [
        "trouer"
    ],
    "trouer": [
        "trouer"
    ],
    "trouerai": [
        "trouer"
    ],
    "trouerais": [
        "trouer"
    ],
    "trouez": [
        "trouer"
    ],
    "troufignard": [
        "troufignard"
    ],
    "troufignon": [
        "troufignon"
    ],
    "troufignons": [
        "troufignon"
    ],
    "troufion": [
        "troufion"
    ],
    "troufions": [
        "troufion"
    ],
    "trouillait": [
        "trouiller"
    ],
    "trouillard": [
        "trouillard"
    ],
    "trouillarde": [
        "trouillard"
    ],
    "trouillards": [
        "trouillard"
    ],
    "trouille": [
        "trouille"
    ],
    "trouilles": [
        "trouille"
    ],
    "trouillometre": [
        "trouillometre"
    ],
    "troupe": [
        "troupe"
    ],
    "troupeau": [
        "troupeau"
    ],
    "troupeaux": [
        "troupeau"
    ],
    "troupes": [
        "troupe"
    ],
    "troupier": [
        "troupier"
    ],
    "troupiers": [
        "troupier"
    ],
    "trous": [
        "trou"
    ],
    "troussa": [
        "trousser"
    ],
    "troussaient": [
        "trousser"
    ],
    "troussait": [
        "trousser"
    ],
    "troussant": [
        "trousser"
    ],
    "trousse": [
        "trousser",
        "trousse"
    ],
    "trousseau": [
        "trousseau"
    ],
    "trousseaux": [
        "trousseau"
    ],
    "troussequin": [
        "troussequin"
    ],
    "trousser": [
        "trousser"
    ],
    "trousses": [
        "trousser",
        "trousse"
    ],
    "trousseur": [
        "trousseur"
    ],
    "trousserent": [
        "trousser"
    ],
    "troussee": [
        "trousser",
        "trousse"
    ],
    "troussees": [
        "trousser",
        "trousse"
    ],
    "trouva": [
        "trouver"
    ],
    "trouvable": [
        "trouvable"
    ],
    "trouvai": [
        "trouver"
    ],
    "trouvaient": [
        "trouver"
    ],
    "trouvaille": [
        "trouvaille"
    ],
    "trouvailles": [
        "trouvaille"
    ],
    "trouvais": [
        "trouver"
    ],
    "trouvait": [
        "trouver"
    ],
    "trouvant": [
        "trouver"
    ],
    "trouvas": [
        "trouver"
    ],
    "trouvasse": [
        "trouver"
    ],
    "trouvassent": [
        "trouver"
    ],
    "trouve": [
        "trouver",
        "trouve"
    ],
    "trouvent": [
        "trouver"
    ],
    "trouver": [
        "trouver"
    ],
    "trouvera": [
        "trouver"
    ],
    "trouverai": [
        "trouver"
    ],
    "trouveraient": [
        "trouver"
    ],
    "trouverais": [
        "trouver"
    ],
    "trouverait": [
        "trouver"
    ],
    "trouveras": [
        "trouver"
    ],
    "trouverez": [
        "trouver"
    ],
    "trouveriez": [
        "trouver"
    ],
    "trouverions": [
        "trouver"
    ],
    "trouverons": [
        "trouver"
    ],
    "trouveront": [
        "trouver"
    ],
    "trouves": [
        "trouver",
        "trouve"
    ],
    "trouveur": [
        "trouveur"
    ],
    "trouveurs": [
        "trouveur"
    ],
    "trouvez": [
        "trouver"
    ],
    "trouviez": [
        "trouver"
    ],
    "trouvions": [
        "trouver"
    ],
    "trouvons": [
        "trouver"
    ],
    "trouvames": [
        "trouver"
    ],
    "trouvat": [
        "trouver"
    ],
    "trouvere": [
        "trouvere"
    ],
    "trouverent": [
        "trouver"
    ],
    "trouveres": [
        "trouvere"
    ],
    "trouvee": [
        "trouver",
        "trouve"
    ],
    "trouvees": [
        "trouver",
        "trouve"
    ],
    "trouerent": [
        "trouer"
    ],
    "trouee": [
        "trouer",
        "troue",
        "trouee"
    ],
    "trouees": [
        "trouer",
        "troue",
        "trouee"
    ],
    "troues": [
        "trouer",
        "troue"
    ],
    "troyen": [
        "troyen"
    ],
    "troyenne": [
        "troyen"
    ],
    "troene": [
        "troene"
    ],
    "troenes": [
        "troene"
    ],
    "troika": [
        "troika"
    ],
    "troikas": [
        "troika"
    ],
    "truand": [
        "truand"
    ],
    "truandage": [
        "truandage"
    ],
    "truandages": [
        "truandage"
    ],
    "truandaille": [
        "truandaille"
    ],
    "truande": [
        "truand",
        "truander"
    ],
    "truander": [
        "truander"
    ],
    "truanderie": [
        "truanderie"
    ],
    "truandes": [
        "truand",
        "truander"
    ],
    "truands": [
        "truand"
    ],
    "trublion": [
        "trublion"
    ],
    "trublions": [
        "trublion"
    ],
    "truc": [
        "truc"
    ],
    "trucage": [
        "trucage"
    ],
    "trucages": [
        "trucage"
    ],
    "truchement": [
        "truchement"
    ],
    "truchements": [
        "truchement"
    ],
    "trucida": [
        "trucider"
    ],
    "trucidais": [
        "trucider"
    ],
    "trucidant": [
        "trucider"
    ],
    "trucident": [
        "trucider"
    ],
    "trucider": [
        "trucider"
    ],
    "truciderai": [
        "trucider"
    ],
    "trucides": [
        "trucider"
    ],
    "trucidons": [
        "trucider"
    ],
    "trucide": [
        "trucider"
    ],
    "trucidee": [
        "trucider"
    ],
    "truck": [
        "truck"
    ],
    "trucks": [
        "truck"
    ],
    "trucmuche": [
        "trucmuche"
    ],
    "trucs": [
        "truc"
    ],
    "truculence": [
        "truculence"
    ],
    "truculent": [
        "truculent"
    ],
    "truculente": [
        "truculent"
    ],
    "truelle": [
        "truelle"
    ],
    "truelles": [
        "truelle"
    ],
    "truffaient": [
        "truffer"
    ],
    "truffait": [
        "truffer"
    ],
    "truffant": [
        "truffer"
    ],
    "truffe": [
        "truffe",
        "truffer"
    ],
    "truffer": [
        "truffer"
    ],
    "truffes": [
        "truffe",
        "truffer"
    ],
    "truffier": [
        "truffier"
    ],
    "truffiers": [
        "truffier"
    ],
    "truffons": [
        "truffer"
    ],
    "truffee": [
        "truffer"
    ],
    "truffees": [
        "truffer"
    ],
    "truie": [
        "truie"
    ],
    "truies": [
        "truie"
    ],
    "truisme": [
        "truisme"
    ],
    "truismes": [
        "truisme"
    ],
    "truite": [
        "truite"
    ],
    "truitelle": [
        "truitelle"
    ],
    "truites": [
        "truite"
    ],
    "trumeau": [
        "trumeau"
    ],
    "trumeaux": [
        "trumeau"
    ],
    "truqua": [
        "truquer"
    ],
    "truquage": [
        "truquage"
    ],
    "truquages": [
        "truquage"
    ],
    "truquaient": [
        "truquer"
    ],
    "truquait": [
        "truquer"
    ],
    "truquant": [
        "truquer"
    ],
    "truque": [
        "truque",
        "truquer"
    ],
    "truquer": [
        "truquer"
    ],
    "truquerai": [
        "truquer"
    ],
    "truquerez": [
        "truquer"
    ],
    "truqueur": [
        "truqueur"
    ],
    "truqueurs": [
        "truqueur"
    ],
    "truqueuse": [
        "truqueur"
    ],
    "truquez": [
        "truquer"
    ],
    "truquions": [
        "truquer"
    ],
    "truquee": [
        "truque",
        "truquer"
    ],
    "truquees": [
        "truque",
        "truquer"
    ],
    "truques": [
        "truque",
        "truquer"
    ],
    "trusquin": [
        "trusquin"
    ],
    "trust": [
        "trust"
    ],
    "trustais": [
        "truster"
    ],
    "trustait": [
        "truster"
    ],
    "truste": [
        "truster"
    ],
    "trustee": [
        "trustee"
    ],
    "trustees": [
        "trustee"
    ],
    "trusteeship": [
        "trusteeship"
    ],
    "trusteeships": [
        "trusteeship"
    ],
    "truster": [
        "truster"
    ],
    "trusterait": [
        "truster"
    ],
    "trusts": [
        "trust"
    ],
    "trypanosome": [
        "trypanosome"
    ],
    "trypanosomes": [
        "trypanosome"
    ],
    "trypanosomiase": [
        "trypanosomiase"
    ],
    "trypsine": [
        "trypsine"
    ],
    "tryptophane": [
        "tryptophane"
    ],
    "tralee": [
        "tralee"
    ],
    "trefle": [
        "trefle"
    ],
    "trefles": [
        "trefle"
    ],
    "trepe": [
        "trepe"
    ],
    "tres": [
        "tres"
    ],
    "trebucha": [
        "trebucher"
    ],
    "trebuchai": [
        "trebucher"
    ],
    "trebuchaient": [
        "trebucher"
    ],
    "trebuchais": [
        "trebucher"
    ],
    "trebuchait": [
        "trebucher"
    ],
    "trebuchant": [
        "trebuchant",
        "trebucher"
    ],
    "trebuchante": [
        "trebuchant"
    ],
    "trebuchantes": [
        "trebuchant"
    ],
    "trebuchants": [
        "trebuchant"
    ],
    "trebuche": [
        "trebucher"
    ],
    "trebuchement": [
        "trebuchement"
    ],
    "trebuchements": [
        "trebuchement"
    ],
    "trebuchent": [
        "trebucher"
    ],
    "trebucher": [
        "trebucher"
    ],
    "trebuches": [
        "trebucher"
    ],
    "trebuchet": [
        "trebuchet"
    ],
    "trebuchez": [
        "trebucher"
    ],
    "trebuchons": [
        "trebucher"
    ],
    "trefiles": [
        "trefiler"
    ],
    "treflieres": [
        "trefliere"
    ],
    "trefonds": [
        "trefonds"
    ],
    "trema": [
        "trema"
    ],
    "tremail": [
        "tremail"
    ],
    "tremas": [
        "trema"
    ],
    "tremie": [
        "tremie"
    ],
    "tremies": [
        "tremie"
    ],
    "tremiere": [
        "tremiere"
    ],
    "tremieres": [
        "tremiere"
    ],
    "tremois": [
        "tremois"
    ],
    "tremolo": [
        "tremolo"
    ],
    "tremoussa": [
        "tremousser"
    ],
    "tremoussaient": [
        "tremousser"
    ],
    "tremoussait": [
        "tremousser"
    ],
    "tremoussant": [
        "tremousser"
    ],
    "tremousse": [
        "tremousser"
    ],
    "tremoussement": [
        "tremoussement"
    ],
    "tremoussements": [
        "tremoussement"
    ],
    "tremoussent": [
        "tremousser"
    ],
    "tremousser": [
        "tremousser"
    ],
    "tremousses": [
        "tremousser"
    ],
    "tremoussat": [
        "tremousser"
    ],
    "tremousserent": [
        "tremousser"
    ],
    "tremulant": [
        "tremuler",
        "tremulant"
    ],
    "tremulante": [
        "tremulant"
    ],
    "tremulation": [
        "tremulation"
    ],
    "tremuler": [
        "tremuler"
    ],
    "trepan": [
        "trepan"
    ],
    "trepanation": [
        "trepanation"
    ],
    "trepaner": [
        "trepaner"
    ],
    "trepane": [
        "trepaner",
        "trepane"
    ],
    "trepanee": [
        "trepane"
    ],
    "trepas": [
        "trepas"
    ],
    "trepassaient": [
        "trepasser"
    ],
    "trepassait": [
        "trepasser"
    ],
    "trepassant": [
        "trepasser"
    ],
    "trepasse": [
        "trepasse",
        "trepasser"
    ],
    "trepassent": [
        "trepasser"
    ],
    "trepasser": [
        "trepasser"
    ],
    "trepasserait": [
        "trepasser"
    ],
    "trepasseront": [
        "trepasser"
    ],
    "trepassee": [
        "trepasse",
        "trepasser"
    ],
    "trepassees": [
        "trepasse"
    ],
    "trepasses": [
        "trepasse"
    ],
    "trepidant": [
        "trepidant",
        "trepider"
    ],
    "trepidante": [
        "trepidant"
    ],
    "trepidantes": [
        "trepidant"
    ],
    "trepidants": [
        "trepidant"
    ],
    "trepidation": [
        "trepidation"
    ],
    "trepidations": [
        "trepidation"
    ],
    "trepide": [
        "trepider"
    ],
    "trepident": [
        "trepider"
    ],
    "trepider": [
        "trepider"
    ],
    "trepied": [
        "trepied"
    ],
    "trepieds": [
        "trepied"
    ],
    "trepigna": [
        "trepigner"
    ],
    "trepignaient": [
        "trepigner"
    ],
    "trepignais": [
        "trepigner"
    ],
    "trepignait": [
        "trepigner"
    ],
    "trepignant": [
        "trepignant"
    ],
    "trepignante": [
        "trepignant"
    ],
    "trepignants": [
        "trepignant"
    ],
    "trepigne": [
        "trepigner"
    ],
    "trepignement": [
        "trepignement"
    ],
    "trepignements": [
        "trepignement"
    ],
    "trepignent": [
        "trepigner"
    ],
    "trepigner": [
        "trepigner"
    ],
    "trepignerai": [
        "trepigner"
    ],
    "trepignez": [
        "trepigner"
    ],
    "trepignee": [
        "trepigner"
    ],
    "treponeme": [
        "treponeme"
    ],
    "treponemes": [
        "treponeme"
    ],
    "tresor": [
        "tresor"
    ],
    "tresorerie": [
        "tresorerie"
    ],
    "tresorier": [
        "tresorier"
    ],
    "tresoriers": [
        "tresorier"
    ],
    "tresoriere": [
        "tresorier"
    ],
    "tresors": [
        "tresor"
    ],
    "treteau": [
        "treteau"
    ],
    "treteaux": [
        "treteau"
    ],
    "treve": [
        "treve"
    ],
    "treves": [
        "treve"
    ],
    "troler": [
        "troler"
    ],
    "trona": [
        "troner"
    ],
    "tronaient": [
        "troner"
    ],
    "tronais": [
        "troner"
    ],
    "tronait": [
        "troner"
    ],
    "tronant": [
        "troner"
    ],
    "trone": [
        "troner",
        "trone"
    ],
    "tronent": [
        "troner"
    ],
    "troner": [
        "troner"
    ],
    "tronerait": [
        "troner"
    ],
    "trones": [
        "trone"
    ],
    "tsar": [
        "tsar"
    ],
    "tsarine": [
        "tsar"
    ],
    "tsarisme": [
        "tsarisme"
    ],
    "tsariste": [
        "tsariste"
    ],
    "tsaristes": [
        "tsariste"
    ],
    "tsars": [
        "tsar"
    ],
    "tsarevitch": [
        "tsarevitch"
    ],
    "tsigane": [
        "tsigane"
    ],
    "tsiganes": [
        "tsigane"
    ],
    "tsuica": [
        "tsuica"
    ],
    "tsunami": [
        "tsunami"
    ],
    "tu": [
        "taire",
        "tu"
    ],
    "tua": [
        "tuer"
    ],
    "tuai": [
        "tuer"
    ],
    "tuaient": [
        "tuer"
    ],
    "tuais": [
        "tuer"
    ],
    "tuait": [
        "tuer"
    ],
    "tuant": [
        "tuer",
        "tuant"
    ],
    "tuante": [
        "tuant"
    ],
    "tuantes": [
        "tuant"
    ],
    "tuants": [
        "tuant"
    ],
    "tuas": [
        "tuer"
    ],
    "tub": [
        "tub"
    ],
    "tuba": [
        "tuba",
        "tuber"
    ],
    "tubages": [
        "tubage"
    ],
    "tubard": [
        "tubard"
    ],
    "tubarde": [
        "tubard"
    ],
    "tubardise": [
        "tubardise"
    ],
    "tubards": [
        "tubard"
    ],
    "tubas": [
        "tuba"
    ],
    "tube": [
        "tube",
        "tuber"
    ],
    "tuber": [
        "tuber"
    ],
    "tubercule": [
        "tubercule"
    ],
    "tubercules": [
        "tubercule"
    ],
    "tuberculeuse": [
        "tuberculeux"
    ],
    "tuberculeuses": [
        "tuberculeux"
    ],
    "tuberculeux": [
        "tuberculeux"
    ],
    "tuberculine": [
        "tuberculine"
    ],
    "tuberculose": [
        "tuberculose"
    ],
    "tubes": [
        "tube"
    ],
    "tubs": [
        "tub"
    ],
    "tubulaire": [
        "tubulaire"
    ],
    "tubulaires": [
        "tubulaire"
    ],
    "tubule": [
        "tubule"
    ],
    "tubuleuses": [
        "tubuleux"
    ],
    "tubulure": [
        "tubulure"
    ],
    "tubulures": [
        "tubulure"
    ],
    "tubereuse": [
        "tubereux"
    ],
    "tubereuses": [
        "tubereux"
    ],
    "tubereux": [
        "tubereux"
    ],
    "tuberosite": [
        "tuberosite"
    ],
    "tudesque": [
        "tudesque"
    ],
    "tudesques": [
        "tudesque"
    ],
    "tudieu": [
        "tudieu"
    ],
    "tue": [
        "tuer",
        "tue",
        "tu"
    ],
    "tuent": [
        "tuer"
    ],
    "tuer": [
        "tuer"
    ],
    "tuera": [
        "tuer"
    ],
    "tuerai": [
        "tuer"
    ],
    "tuerais": [
        "tuer"
    ],
    "tuerait": [
        "tuer"
    ],
    "tueras": [
        "tuer"
    ],
    "tuerez": [
        "tuer"
    ],
    "tuerie": [
        "tuerie"
    ],
    "tueries": [
        "tuerie"
    ],
    "tueriez": [
        "tuer"
    ],
    "tuerions": [
        "tuer"
    ],
    "tuerons": [
        "tuer"
    ],
    "tueront": [
        "tuer"
    ],
    "tues": [
        "tuer",
        "tue",
        "tu"
    ],
    "tueur": [
        "tueur"
    ],
    "tueurs": [
        "tueur"
    ],
    "tueuse": [
        "tueuse"
    ],
    "tueuses": [
        "tueur"
    ],
    "tuez": [
        "tuer"
    ],
    "tuf": [
        "tuf"
    ],
    "tuffeau": [
        "tuffeau"
    ],
    "tuffeaux": [
        "tuffeau"
    ],
    "tuiez": [
        "tuer"
    ],
    "tuile": [
        "tuile"
    ],
    "tuilerie": [
        "tuilerie"
    ],
    "tuileries": [
        "tuilerie"
    ],
    "tuiles": [
        "tuile"
    ],
    "tuions": [
        "tuer"
    ],
    "tularemie": [
        "tularemie"
    ],
    "tulipe": [
        "tulipe"
    ],
    "tulipes": [
        "tulipe"
    ],
    "tulipier": [
        "tulipier"
    ],
    "tulipiers": [
        "tulipier"
    ],
    "tulle": [
        "tulle"
    ],
    "tulles": [
        "tulle"
    ],
    "tumescence": [
        "tumescence"
    ],
    "tumescent": [
        "tumescent"
    ],
    "tumeur": [
        "tumeur"
    ],
    "tumeurs": [
        "tumeur"
    ],
    "tumorale": [
        "tumoral"
    ],
    "tumoraux": [
        "tumoral"
    ],
    "tumuli": [
        "tumulus"
    ],
    "tumulte": [
        "tumulte"
    ],
    "tumultes": [
        "tumulte"
    ],
    "tumultuaire": [
        "tumultuaire"
    ],
    "tumultueuse": [
        "tumultueux"
    ],
    "tumultueusement": [
        "tumultueusement"
    ],
    "tumultueuses": [
        "tumultueux"
    ],
    "tumultueux": [
        "tumultueux"
    ],
    "tumulus": [
        "tumulus"
    ],
    "tumefaction": [
        "tumefaction"
    ],
    "tumefie": [
        "tumefier",
        "tumefie"
    ],
    "tumefier": [
        "tumefier"
    ],
    "tumefiee": [
        "tumefier",
        "tumefie"
    ],
    "tumefiees": [
        "tumefie"
    ],
    "tumefies": [
        "tumefier",
        "tumefie"
    ],
    "tune": [
        "tune"
    ],
    "tuner": [
        "tuner"
    ],
    "tunes": [
        "tune"
    ],
    "tungstene": [
        "tungstene"
    ],
    "tunique": [
        "tunique"
    ],
    "tuniques": [
        "tunique"
    ],
    "tunisien": [
        "tunisien"
    ],
    "tunisienne": [
        "tunisien"
    ],
    "tunisiennes": [
        "tunisien"
    ],
    "tunisiens": [
        "tunisien"
    ],
    "tunnel": [
        "tunnel"
    ],
    "tunnels": [
        "tunnel"
    ],
    "tuons": [
        "tuer"
    ],
    "tuque": [
        "tuque"
    ],
    "turban": [
        "turban"
    ],
    "turbans": [
        "turban"
    ],
    "turbin": [
        "turbin"
    ],
    "turbina": [
        "turbiner"
    ],
    "turbinaient": [
        "turbiner"
    ],
    "turbinait": [
        "turbiner"
    ],
    "turbine": [
        "turbiner",
        "turbine"
    ],
    "turbiner": [
        "turbiner"
    ],
    "turbines": [
        "turbiner",
        "turbine"
    ],
    "turbinez": [
        "turbiner"
    ],
    "turbins": [
        "turbin"
    ],
    "turbo": [
        "turbo"
    ],
    "turbocompresseur": [
        "turbocompresseur"
    ],
    "turbocompresseurs": [
        "turbocompresseur"
    ],
    "turbopropulseur": [
        "turbopropulseur"
    ],
    "turboreacteur": [
        "turboreacteur"
    ],
    "turbos": [
        "turbo"
    ],
    "turbot": [
        "turbot"
    ],
    "turbotiere": [
        "turbotiere"
    ],
    "turbotieres": [
        "turbotiere"
    ],
    "turbulence": [
        "turbulence"
    ],
    "turbulences": [
        "turbulence"
    ],
    "turbulent": [
        "turbulent"
    ],
    "turbulente": [
        "turbulent"
    ],
    "turbulentes": [
        "turbulent"
    ],
    "turbulents": [
        "turbulent"
    ],
    "turbe": [
        "turbe"
    ],
    "turbes": [
        "turbe"
    ],
    "turc": [
        "turc"
    ],
    "turco": [
        "turco"
    ],
    "turcoman": [
        "turcoman"
    ],
    "turcomans": [
        "turcoman"
    ],
    "turcos": [
        "turco"
    ],
    "turcs": [
        "turc"
    ],
    "turdus": [
        "turdus"
    ],
    "turelure": [
        "turelure"
    ],
    "turent": [
        "taire"
    ],
    "turf": [
        "turf"
    ],
    "turfiste": [
        "turfiste"
    ],
    "turfistes": [
        "turfiste"
    ],
    "turfs": [
        "turf"
    ],
    "turgescence": [
        "turgescence"
    ],
    "turgescent": [
        "turgescent"
    ],
    "turgescente": [
        "turgescent"
    ],
    "turgescentes": [
        "turgescent"
    ],
    "turgescents": [
        "turgescent"
    ],
    "turgide": [
        "turgide"
    ],
    "turgotine": [
        "turgotine"
    ],
    "turinois": [
        "turinois"
    ],
    "turinoise": [
        "turinois"
    ],
    "turista": [
        "turista"
    ],
    "turistas": [
        "turista"
    ],
    "turkmenes": [
        "turkmene"
    ],
    "turlu": [
        "turlu"
    ],
    "turlupinade": [
        "turlupinade"
    ],
    "turlupinades": [
        "turlupinade"
    ],
    "turlupinaient": [
        "turlupiner"
    ],
    "turlupinait": [
        "turlupiner"
    ],
    "turlupine": [
        "turlupiner"
    ],
    "turlupinent": [
        "turlupiner"
    ],
    "turlupiner": [
        "turlupiner"
    ],
    "turlupinera": [
        "turlupiner"
    ],
    "turlupins": [
        "turlupin"
    ],
    "turlupinee": [
        "turlupiner"
    ],
    "turlutaines": [
        "turlutaine"
    ],
    "turlute": [
        "turluter"
    ],
    "turlutent": [
        "turluter"
    ],
    "turluter": [
        "turluter"
    ],
    "turlutes": [
        "turluter"
    ],
    "turlutte": [
        "turlutte"
    ],
    "turlututu": [
        "turlututu"
    ],
    "turne": [
        "turne"
    ],
    "turnes": [
        "turne"
    ],
    "turnover": [
        "turnover"
    ],
    "turpides": [
        "turpide"
    ],
    "turpitude": [
        "turpitude"
    ],
    "turpitudes": [
        "turpitude"
    ],
    "turque": [
        "turc"
    ],
    "turquerie": [
        "turquerie"
    ],
    "turques": [
        "turc"
    ],
    "turquin": [
        "turquin"
    ],
    "turquoise": [
        "turquoise"
    ],
    "turquoises": [
        "turquoise"
    ],
    "tus": [
        "taire",
        "tu"
    ],
    "tussent": [
        "taire"
    ],
    "tussilage": [
        "tussilage"
    ],
    "tussor": [
        "tussor"
    ],
    "tut": [
        "taire"
    ],
    "tutelle": [
        "tutelle"
    ],
    "tuteur": [
        "tuteur"
    ],
    "tuteurs": [
        "tuteur"
    ],
    "tutoie": [
        "tutoyer"
    ],
    "tutoiement": [
        "tutoiement"
    ],
    "tutoiements": [
        "tutoiement"
    ],
    "tutoient": [
        "tutoyer"
    ],
    "tutoiera": [
        "tutoyer"
    ],
    "tutoierai": [
        "tutoyer"
    ],
    "tutoies": [
        "tutoyer"
    ],
    "tutorat": [
        "tutorat"
    ],
    "tutorial": [
        "tutorial"
    ],
    "tutoriaux": [
        "tutorial"
    ],
    "tutoya": [
        "tutoyer"
    ],
    "tutoyaient": [
        "tutoyer"
    ],
    "tutoyais": [
        "tutoyer"
    ],
    "tutoyait": [
        "tutoyer"
    ],
    "tutoyant": [
        "tutoyer"
    ],
    "tutoyer": [
        "tutoyer"
    ],
    "tutoyeuses": [
        "tutoyeur"
    ],
    "tutoyez": [
        "tutoyer"
    ],
    "tutoyions": [
        "tutoyer"
    ],
    "tutoyons": [
        "tutoyer"
    ],
    "tutoyat": [
        "tutoyer"
    ],
    "tutoyerent": [
        "tutoyer"
    ],
    "tutoye": [
        "tutoyer"
    ],
    "tutoyee": [
        "tutoyer"
    ],
    "tutoyes": [
        "tutoyer"
    ],
    "tutrice": [
        "tuteur"
    ],
    "tutu": [
        "tutu"
    ],
    "tutus": [
        "tutu"
    ],
    "tutute": [
        "tutut"
    ],
    "tutelaire": [
        "tutelaire"
    ],
    "tutelaires": [
        "tutelaire"
    ],
    "tuyau": [
        "tuyau"
    ],
    "tuyautages": [
        "tuyautage"
    ],
    "tuyautait": [
        "tuyauter"
    ],
    "tuyautent": [
        "tuyauter"
    ],
    "tuyauter": [
        "tuyauter"
    ],
    "tuyautera": [
        "tuyauter"
    ],
    "tuyauterie": [
        "tuyauterie"
    ],
    "tuyauteries": [
        "tuyauterie"
    ],
    "tuyauteur": [
        "tuyauteur"
    ],
    "tuyauteurs": [
        "tuyauteur"
    ],
    "tuyaute": [
        "tuyaute",
        "tuyauter"
    ],
    "tuyautee": [
        "tuyauter"
    ],
    "tuyautees": [
        "tuyauter"
    ],
    "tuyautes": [
        "tuyaute",
        "tuyauter"
    ],
    "tuyaux": [
        "tuyau"
    ],
    "tuyere": [
        "tuyere"
    ],
    "tuyeres": [
        "tuyere"
    ],
    "tuat": [
        "tuer"
    ],
    "tuerent": [
        "tuer"
    ],
    "tuee": [
        "tuer",
        "tue"
    ],
    "tuees": [
        "tuer",
        "tue"
    ],
    "tweed": [
        "tweed"
    ],
    "tweeds": [
        "tweed"
    ],
    "twill": [
        "twill"
    ],
    "twist": [
        "twist"
    ],
    "twistant": [
        "twister"
    ],
    "twister": [
        "twister"
    ],
    "twists": [
        "twist"
    ],
    "twistees": [
        "twister"
    ],
    "tympan": [
        "tympan"
    ],
    "tympanique": [
        "tympanique"
    ],
    "tympanon": [
        "tympanon"
    ],
    "tympans": [
        "tympan"
    ],
    "type": [
        "type",
        "typer"
    ],
    "typer": [
        "typer"
    ],
    "types": [
        "type",
        "typer"
    ],
    "typhique": [
        "typhique"
    ],
    "typhiques": [
        "typhique"
    ],
    "typhon": [
        "typhon"
    ],
    "typhons": [
        "typhon"
    ],
    "typhoide": [
        "typhoide"
    ],
    "typhus": [
        "typhus"
    ],
    "typique": [
        "typique"
    ],
    "typiquement": [
        "typiquement"
    ],
    "typiques": [
        "typique"
    ],
    "typo": [
        "typo"
    ],
    "typographe": [
        "typographe"
    ],
    "typographes": [
        "typographe"
    ],
    "typographie": [
        "typographie"
    ],
    "typographier": [
        "typographier"
    ],
    "typographique": [
        "typographique"
    ],
    "typographiques": [
        "typographique"
    ],
    "typologie": [
        "typologie"
    ],
    "typometre": [
        "typometre"
    ],
    "typos": [
        "typo"
    ],
    "typee": [
        "type"
    ],
    "tyran": [
        "tyran"
    ],
    "tyranneau": [
        "tyranneau"
    ],
    "tyranneaux": [
        "tyranneau"
    ],
    "tyrannicide": [
        "tyrannicide"
    ],
    "tyrannicides": [
        "tyrannicide"
    ],
    "tyrannie": [
        "tyrannie"
    ],
    "tyrannies": [
        "tyrannie",
        "tyranny"
    ],
    "tyrannique": [
        "tyrannique"
    ],
    "tyranniquement": [
        "tyranniquement"
    ],
    "tyranniques": [
        "tyrannique"
    ],
    "tyrannisais": [
        "tyranniser"
    ],
    "tyrannisait": [
        "tyranniser"
    ],
    "tyrannisant": [
        "tyranniser"
    ],
    "tyrannise": [
        "tyranniser"
    ],
    "tyrannisent": [
        "tyranniser"
    ],
    "tyranniser": [
        "tyranniser"
    ],
    "tyranniserent": [
        "tyranniser"
    ],
    "tyrannisee": [
        "tyranniser"
    ],
    "tyrannosaure": [
        "tyrannosaure"
    ],
    "tyrannosaures": [
        "tyrannosaure"
    ],
    "tyrans": [
        "tyran"
    ],
    "tyrienne": [
        "tyrien"
    ],
    "tyrolien": [
        "tyrolien"
    ],
    "tyrolienne": [
        "tyrolien"
    ],
    "tyroliennes": [
        "tyrolien"
    ],
    "tyroliens": [
        "tyrolien"
    ],
    "tyrrhenienne": [
        "tyrrhenienne",
        "tyrrhenien"
    ],
    "tzar": [
        "tzar"
    ],
    "tzarevitch": [
        "tzarevitch"
    ],
    "tzarine": [
        "tzar"
    ],
    "tzars": [
        "tzar"
    ],
    "tzigane": [
        "tzigane"
    ],
    "tziganes": [
        "tzigane"
    ],
    "tacha": [
        "tacher"
    ],
    "tachai": [
        "tacher"
    ],
    "tachais": [
        "tacher"
    ],
    "tacheraient": [
        "tacher"
    ],
    "tacheras": [
        "tacher"
    ],
    "tacherez": [
        "tacher"
    ],
    "tacheron": [
        "tacheron"
    ],
    "tacherons": [
        "tacher",
        "tacheron"
    ],
    "tacheront": [
        "tacher"
    ],
    "tachions": [
        "tacher"
    ],
    "tachat": [
        "tacher"
    ],
    "tacherent": [
        "tacher"
    ],
    "tatai": [
        "tater"
    ],
    "tataient": [
        "tater"
    ],
    "tatais": [
        "tater"
    ],
    "tatait": [
        "tater"
    ],
    "tatant": [
        "tater"
    ],
    "tate": [
        "tater"
    ],
    "tatent": [
        "tater"
    ],
    "tater": [
        "tater",
        "tate"
    ],
    "tatera": [
        "tater"
    ],
    "taterai": [
        "tater"
    ],
    "tateras": [
        "tater"
    ],
    "taterez": [
        "tater"
    ],
    "tatez": [
        "tater"
    ],
    "tatiez": [
        "tater"
    ],
    "tatonna": [
        "tatonner"
    ],
    "tatonnai": [
        "tatonner"
    ],
    "tatonnaient": [
        "tatonner"
    ],
    "tatonnais": [
        "tatonner"
    ],
    "tatonnait": [
        "tatonner"
    ],
    "tatonnant": [
        "tatonnant",
        "tatonner"
    ],
    "tatonnante": [
        "tatonnant"
    ],
    "tatonnantes": [
        "tatonnant"
    ],
    "tatonnants": [
        "tatonnant"
    ],
    "tatonne": [
        "tatonner"
    ],
    "tatonnement": [
        "tatonnement"
    ],
    "tatonnements": [
        "tatonnement"
    ],
    "tatonnent": [
        "tatonner"
    ],
    "tatonner": [
        "tatonner"
    ],
    "tatonnera": [
        "tatonner"
    ],
    "tatonnerais": [
        "tatonner"
    ],
    "tatonnions": [
        "tatonner"
    ],
    "tatonnames": [
        "tatonner"
    ],
    "tatonnat": [
        "tatonner"
    ],
    "tatonnerent": [
        "tatonner"
    ],
    "tatonnee": [
        "tatonner"
    ],
    "tatons": [
        "tater"
    ],
    "taterent": [
        "tater"
    ],
    "tates": [
        "tater"
    ],
    "tete": [
        "teter",
        "tete"
    ],
    "tetent": [
        "teter"
    ],
    "teflon": [
        "teflon"
    ],
    "tegument": [
        "tegument"
    ],
    "tegumentaire": [
        "tegumentaire"
    ],
    "tegenaires": [
        "tegenaire"
    ],
    "tel.": [
        "tel."
    ],
    "telencephale": [
        "telencephale"
    ],
    "telescopage": [
        "telescopage"
    ],
    "telescopait": [
        "telescoper"
    ],
    "telescope": [
        "telescope",
        "telescoper"
    ],
    "telescopent": [
        "telescoper"
    ],
    "telescoper": [
        "telescoper"
    ],
    "telescopes": [
        "telescope",
        "telescoper"
    ],
    "telescopique": [
        "telescopique"
    ],
    "telescopiques": [
        "telescopique"
    ],
    "telescoperent": [
        "telescoper"
    ],
    "telescopee": [
        "telescoper"
    ],
    "telescopees": [
        "telescoper"
    ],
    "telescripteurs": [
        "telescripteur"
    ],
    "telex": [
        "telex"
    ],
    "telexa": [
        "telexer"
    ],
    "telexer": [
        "telexer"
    ],
    "telexes": [
        "telexer",
        "telex"
    ],
    "telexe": [
        "telexer"
    ],
    "teloche": [
        "teloche"
    ],
    "telegue": [
        "telegue"
    ],
    "tele": [
        "tele"
    ],
    "teleachat": [
        "teleachat"
    ],
    "teleavertisseur": [
        "teleavertisseur"
    ],
    "telecabine": [
        "telecabine"
    ],
    "telecartes": [
        "telecarte"
    ],
    "telecharge": [
        "telecharger"
    ],
    "telechargeables": [
        "telechargeable"
    ],
    "telechargement": [
        "telechargement"
    ],
    "telechargent": [
        "telecharger"
    ],
    "telechargeons": [
        "telecharger"
    ],
    "telecharger": [
        "telecharger"
    ],
    "telechargera": [
        "telecharger"
    ],
    "telechargerai": [
        "telecharger"
    ],
    "telechargerons": [
        "telecharger"
    ],
    "telechargez": [
        "telecharger"
    ],
    "telechargee": [
        "telecharger"
    ],
    "telechargees": [
        "telecharger"
    ],
    "telecharges": [
        "telecharger"
    ],
    "telecinema": [
        "telecinema"
    ],
    "telecommande": [
        "telecommander",
        "telecommande"
    ],
    "telecommander": [
        "telecommander"
    ],
    "telecommandes": [
        "telecommander",
        "telecommande"
    ],
    "telecommandee": [
        "telecommander"
    ],
    "telecommandees": [
        "telecommander"
    ],
    "telecommunication": [
        "telecommunication"
    ],
    "telecommunications": [
        "telecommunication"
    ],
    "telecoms": [
        "telecom"
    ],
    "teleconference": [
        "teleconference"
    ],
    "telecopieur": [
        "telecopieur"
    ],
    "telecran": [
        "telecran"
    ],
    "telecrans": [
        "telecran"
    ],
    "telediffuser": [
        "telediffuser"
    ],
    "telediffusion": [
        "telediffusion"
    ],
    "telefax": [
        "telefax"
    ],
    "telefaxe": [
        "telefaxer"
    ],
    "telefaxez": [
        "telefaxer"
    ],
    "telefilm": [
        "telefilm"
    ],
    "telefilms": [
        "telefilm"
    ],
    "teleferiques": [
        "teleferique"
    ],
    "telegramme": [
        "telegramme"
    ],
    "telegrammes": [
        "telegramme"
    ],
    "telegraphe": [
        "telegraphe"
    ],
    "telegraphes": [
        "telegraphe"
    ],
    "telegraphia": [
        "telegraphier"
    ],
    "telegraphiai": [
        "telegraphier"
    ],
    "telegraphiait": [
        "telegraphier"
    ],
    "telegraphiant": [
        "telegraphier"
    ],
    "telegraphie": [
        "telegraphier",
        "telegraphie"
    ],
    "telegraphient": [
        "telegraphier"
    ],
    "telegraphier": [
        "telegraphier"
    ],
    "telegraphierai": [
        "telegraphier"
    ],
    "telegraphierais": [
        "telegraphier"
    ],
    "telegraphierait": [
        "telegraphier"
    ],
    "telegraphiez": [
        "telegraphier"
    ],
    "telegraphions": [
        "telegraphier"
    ],
    "telegraphique": [
        "telegraphique"
    ],
    "telegraphiques": [
        "telegraphique"
    ],
    "telegraphiste": [
        "telegraphiste"
    ],
    "telegraphistes": [
        "telegraphiste"
    ],
    "telegraphiames": [
        "telegraphier"
    ],
    "telegraphiee": [
        "telegraphier"
    ],
    "telegraphiees": [
        "telegraphier"
    ],
    "telegraphies": [
        "telegraphier"
    ],
    "teleguidage": [
        "teleguidage"
    ],
    "teleguider": [
        "teleguider"
    ],
    "teleguide": [
        "teleguider"
    ],
    "teleguidee": [
        "teleguider"
    ],
    "teleguidees": [
        "teleguider"
    ],
    "teleguides": [
        "teleguider"
    ],
    "telegenie": [
        "telegenie"
    ],
    "telegenique": [
        "telegenique"
    ],
    "telekinesie": [
        "telekinesie"
    ],
    "telemark": [
        "telemark"
    ],
    "telemarketing": [
        "telemarketing"
    ],
    "telematique": [
        "telematique"
    ],
    "telemesure": [
        "telemesure"
    ],
    "telemesures": [
        "telemesure"
    ],
    "telemetre": [
        "telemetre"
    ],
    "telemetres": [
        "telemetre"
    ],
    "telemetrie": [
        "telemetrie"
    ],
    "telemetrique": [
        "telemetrique"
    ],
    "telemetriques": [
        "telemetrique"
    ],
    "teleobjectif": [
        "teleobjectif"
    ],
    "teleobjectifs": [
        "teleobjectif"
    ],
    "teleologique": [
        "teleologique"
    ],
    "telepathe": [
        "telepathe"
    ],
    "telepathes": [
        "telepathe"
    ],
    "telepathie": [
        "telepathie"
    ],
    "telepathique": [
        "telepathique"
    ],
    "telepathiquement": [
        "telepathiquement"
    ],
    "telepathiques": [
        "telepathique"
    ],
    "telephona": [
        "telephoner"
    ],
    "telephonage": [
        "telephonage"
    ],
    "telephonai": [
        "telephoner"
    ],
    "telephonaient": [
        "telephoner"
    ],
    "telephonais": [
        "telephoner"
    ],
    "telephonait": [
        "telephoner"
    ],
    "telephonant": [
        "telephoner"
    ],
    "telephone": [
        "telephoner",
        "telephone"
    ],
    "telephonent": [
        "telephoner"
    ],
    "telephoner": [
        "telephoner"
    ],
    "telephonera": [
        "telephoner"
    ],
    "telephonerai": [
        "telephoner"
    ],
    "telephoneraient": [
        "telephoner"
    ],
    "telephonerais": [
        "telephoner"
    ],
    "telephonerait": [
        "telephoner"
    ],
    "telephoneras": [
        "telephoner"
    ],
    "telephonerez": [
        "telephoner"
    ],
    "telephoneriez": [
        "telephoner"
    ],
    "telephonerons": [
        "telephoner"
    ],
    "telephoneront": [
        "telephoner"
    ],
    "telephones": [
        "telephoner",
        "telephone"
    ],
    "telephonez": [
        "telephoner"
    ],
    "telephonie": [
        "telephonie"
    ],
    "telephoniez": [
        "telephoner"
    ],
    "telephonions": [
        "telephoner"
    ],
    "telephonique": [
        "telephonique"
    ],
    "telephoniquement": [
        "telephoniquement"
    ],
    "telephoniques": [
        "telephonique"
    ],
    "telephoniste": [
        "telephoniste"
    ],
    "telephonistes": [
        "telephoniste"
    ],
    "telephonons": [
        "telephoner"
    ],
    "telephonat": [
        "telephoner"
    ],
    "telephonee": [
        "telephone"
    ],
    "telephonees": [
        "telephone"
    ],
    "telepherique": [
        "telepherique"
    ],
    "teleport": [
        "teleport"
    ],
    "teleportation": [
        "teleportation"
    ],
    "teleprompteur": [
        "teleprompteur"
    ],
    "telereportage": [
        "telereportage"
    ],
    "teleroman": [
        "teleroman"
    ],
    "teles": [
        "tele"
    ],
    "telescripteur": [
        "telescripteur"
    ],
    "telesiege": [
        "telesiege"
    ],
    "telesieges": [
        "telesiege"
    ],
    "teleski": [
        "teleski"
    ],
    "telespectateur": [
        "telespectateur"
    ],
    "telespectateurs": [
        "telespectateur"
    ],
    "telespectatrice": [
        "telespectateur"
    ],
    "telespectatrices": [
        "telespectateur"
    ],
    "telesurveillance": [
        "telesurveillance"
    ],
    "teletexte": [
        "teletexte"
    ],
    "teletravail": [
        "teletravail"
    ],
    "teletravailleuse": [
        "teletravailleur"
    ],
    "teletype": [
        "teletype"
    ],
    "teletypes": [
        "teletype"
    ],
    "televangeliste": [
        "televangeliste"
    ],
    "televangelistes": [
        "televangeliste"
    ],
    "televendeur": [
        "televendeur"
    ],
    "televente": [
        "televente"
    ],
    "televise": [
        "televiser",
        "televise"
    ],
    "televisera": [
        "televiser"
    ],
    "televises": [
        "televiser",
        "televise"
    ],
    "televiseur": [
        "televiseur"
    ],
    "televiseurs": [
        "televiseur"
    ],
    "television": [
        "television"
    ],
    "televisions": [
        "television"
    ],
    "televisuel": [
        "televisuel"
    ],
    "televisuelle": [
        "televisuel"
    ],
    "televisuels": [
        "televisuel"
    ],
    "televisee": [
        "televiser",
        "televise"
    ],
    "televisees": [
        "televiser",
        "televise"
    ],
    "temoigna": [
        "temoigner"
    ],
    "temoignage": [
        "temoignage"
    ],
    "temoignages": [
        "temoignage"
    ],
    "temoignaient": [
        "temoigner"
    ],
    "temoignais": [
        "temoigner"
    ],
    "temoignait": [
        "temoigner"
    ],
    "temoignant": [
        "temoigner"
    ],
    "temoigne": [
        "temoigner"
    ],
    "temoignent": [
        "temoigner"
    ],
    "temoigner": [
        "temoigner"
    ],
    "temoignera": [
        "temoigner"
    ],
    "temoignerai": [
        "temoigner"
    ],
    "temoigneraient": [
        "temoigner"
    ],
    "temoignerais": [
        "temoigner"
    ],
    "temoignerait": [
        "temoigner"
    ],
    "temoigneras": [
        "temoigner"
    ],
    "temoignerez": [
        "temoigner"
    ],
    "temoigneront": [
        "temoigner"
    ],
    "temoignes": [
        "temoigner"
    ],
    "temoignez": [
        "temoigner"
    ],
    "temoigniez": [
        "temoigner"
    ],
    "temoignat": [
        "temoigner"
    ],
    "temoignerent": [
        "temoigner"
    ],
    "temoignee": [
        "temoigner"
    ],
    "temoignees": [
        "temoigner"
    ],
    "temoin": [
        "temoin"
    ],
    "temoins": [
        "temoin"
    ],
    "temeraire": [
        "temeraire"
    ],
    "temerairement": [
        "temerairement"
    ],
    "temeraires": [
        "temeraire"
    ],
    "temerite": [
        "temerite"
    ],
    "temerites": [
        "temerite"
    ],
    "tenacite": [
        "tenacite"
    ],
    "tenia": [
        "tenia"
    ],
    "tenias": [
        "tenia"
    ],
    "tenor": [
        "tenor"
    ],
    "tenors": [
        "tenor"
    ],
    "tenuite": [
        "tenuite"
    ],
    "tenebre": [
        "tenebre"
    ],
    "tenebres": [
        "tenebres"
    ],
    "tenebreuse": [
        "tenebreux"
    ],
    "tenebreuses": [
        "tenebreux"
    ],
    "tenebreux": [
        "tenebreux"
    ],
    "tenebrionide": [
        "tenebrionide"
    ],
    "teraoctets": [
        "teraoctet"
    ],
    "teratologique": [
        "teratologique"
    ],
    "teratologiques": [
        "teratologique"
    ],
    "teratome": [
        "teratome"
    ],
    "terebenthine": [
        "terebenthine"
    ],
    "terebinthe": [
        "terebinthe"
    ],
    "terebinthes": [
        "terebinthe"
    ],
    "terebrant": [
        "terebrant"
    ],
    "terebrants": [
        "terebrant"
    ],
    "teta": [
        "teter"
    ],
    "tetaient": [
        "teter"
    ],
    "tetais": [
        "teter"
    ],
    "tetait": [
        "teter"
    ],
    "tetanie": [
        "tetanie"
    ],
    "tetanique": [
        "tetanique"
    ],
    "tetaniques": [
        "tetanique"
    ],
    "tetanisait": [
        "tetaniser"
    ],
    "tetanisant": [
        "tetaniser"
    ],
    "tetanisation": [
        "tetanisation"
    ],
    "tetanisent": [
        "tetaniser"
    ],
    "tetaniser": [
        "tetaniser"
    ],
    "tetanise": [
        "tetaniser",
        "tetanise"
    ],
    "tetanisee": [
        "tetaniser",
        "tetanise"
    ],
    "tetanisees": [
        "tetanise"
    ],
    "tetanises": [
        "tetanise"
    ],
    "tetanos": [
        "tetanos"
    ],
    "tetant": [
        "teter"
    ],
    "tetasses": [
        "teter"
    ],
    "teter": [
        "teter"
    ],
    "teteur": [
        "teteur"
    ],
    "tetiez": [
        "teter"
    ],
    "tetine": [
        "tetine"
    ],
    "tetines": [
        "tetine"
    ],
    "tetins": [
        "tetin"
    ],
    "teton": [
        "teton"
    ],
    "tetons": [
        "teter",
        "teton"
    ],
    "tetra": [
        "tetra"
    ],
    "tetrachlorure": [
        "tetrachlorure"
    ],
    "tetracycline": [
        "tetracycline"
    ],
    "tetradrachme": [
        "tetradrachme"
    ],
    "tetragones": [
        "tetragone"
    ],
    "tetragramme": [
        "tetragramme"
    ],
    "tetragrammes": [
        "tetragramme"
    ],
    "tetralogie": [
        "tetralogie"
    ],
    "tetramere": [
        "tetramere"
    ],
    "tetrametre": [
        "tetrametre"
    ],
    "tetraplegie": [
        "tetraplegie"
    ],
    "tetraplegique": [
        "tetraplegique"
    ],
    "tetrarque": [
        "tetrarque"
    ],
    "tetrarques": [
        "tetrarque"
    ],
    "tetras": [
        "tetras"
    ],
    "tetrodotoxine": [
        "tetrodotoxine"
    ],
    "tetere": [
        "teter"
    ],
    "teterent": [
        "teter"
    ],
    "tetee": [
        "teter",
        "tetee"
    ],
    "tetees": [
        "teter",
        "tetee"
    ],
    "teve": [
        "teve"
    ],
    "tezig": [
        "tezig"
    ],
    "tezigue": [
        "tezigue"
    ],
    "tet": [
        "tet"
    ],
    "tetard": [
        "tetard"
    ],
    "tetards": [
        "tetard"
    ],
    "tetes": [
        "tete"
    ],
    "tetiere": [
        "tetiere"
    ],
    "tetieres": [
        "tetiere"
    ],
    "tetu": [
        "tetu"
    ],
    "tetue": [
        "tetu"
    ],
    "tetues": [
        "tetu"
    ],
    "tetus": [
        "tetu"
    ],
    "tinmes": [
        "tenir"
    ],
    "tolarde": [
        "tolard"
    ],
    "tole": [
        "tole"
    ],
    "tolerie": [
        "tolerie"
    ],
    "toles": [
        "tole"
    ],
    "tolier": [
        "tolier"
    ],
    "toliers": [
        "tolier"
    ],
    "toliere": [
        "tolier"
    ],
    "tot": [
        "tot"
    ],
    "tumes": [
        "taire"
    ],
    "u": [
        "u"
    ],
    "ubac": [
        "ubac"
    ],
    "ubique": [
        "ubique"
    ],
    "ubiquiste": [
        "ubiquiste"
    ],
    "ubiquitaire": [
        "ubiquitaire"
    ],
    "ubiquite": [
        "ubiquite"
    ],
    "ubuesque": [
        "ubuesque"
    ],
    "ufologie": [
        "ufologie"
    ],
    "uhlan": [
        "uhlan"
    ],
    "uhlans": [
        "uhlan"
    ],
    "uht": [
        "uht"
    ],
    "ukase": [
        "ukase"
    ],
    "ukases": [
        "ukase"
    ],
    "ukrainien": [
        "ukrainien"
    ],
    "ukrainienne": [
        "ukrainien"
    ],
    "ukrainiennes": [
        "ukrainien"
    ],
    "ukrainiens": [
        "ukrainien"
    ],
    "ukulele": [
        "ukulele"
    ],
    "ulcere": [
        "ulcerer",
        "ulcere"
    ],
    "ulceres": [
        "ulcerer",
        "ulcere"
    ],
    "ulcera": [
        "ulcerer"
    ],
    "ulcerait": [
        "ulcerer"
    ],
    "ulcerant": [
        "ulcerer"
    ],
    "ulcerations": [
        "ulceration"
    ],
    "ulcerative": [
        "ulceratif"
    ],
    "ulcereuse": [
        "ulcereux"
    ],
    "ulcereuses": [
        "ulcereux"
    ],
    "ulcereux": [
        "ulcereux"
    ],
    "ulceree": [
        "ulcere",
        "ulcerer"
    ],
    "ulcerees": [
        "ulcere",
        "ulcerer"
    ],
    "ulna": [
        "ulna"
    ],
    "ulnaire": [
        "ulnaire"
    ],
    "ultimatum": [
        "ultimatum"
    ],
    "ultimatums": [
        "ultimatum"
    ],
    "ultime": [
        "ultime"
    ],
    "ultimement": [
        "ultimement"
    ],
    "ultimes": [
        "ultime"
    ],
    "ultimo": [
        "ultimo"
    ],
    "ultra": [
        "ultra"
    ],
    "ultrafin": [
        "ultrafin"
    ],
    "ultragauche": [
        "ultragauche"
    ],
    "ultraleger": [
        "ultraleger"
    ],
    "ultramarine": [
        "ultramarin"
    ],
    "ultramoderne": [
        "ultramoderne"
    ],
    "ultramodernes": [
        "ultramoderne"
    ],
    "ultramontain": [
        "ultramontain"
    ],
    "ultramontains": [
        "ultramontain"
    ],
    "ultraperformant": [
        "ultraperformant"
    ],
    "ultrarapide": [
        "ultrarapide"
    ],
    "ultrarapides": [
        "ultrarapide"
    ],
    "ultras": [
        "ultra"
    ],
    "ultrasecret": [
        "ultrasecret"
    ],
    "ultrasecrete": [
        "ultrasecret"
    ],
    "ultrasensible": [
        "ultrasensible"
    ],
    "ultrasensibles": [
        "ultrasensible"
    ],
    "ultrason": [
        "ultrason"
    ],
    "ultrasonique": [
        "ultrasonique"
    ],
    "ultrasons": [
        "ultrason"
    ],
    "ultraviolet": [
        "ultraviolet"
    ],
    "ultraviolets": [
        "ultraviolet"
    ],
    "ultraviolette": [
        "ultraviolet"
    ],
    "ultraviolettes": [
        "ultraviolet"
    ],
    "ultravirus": [
        "ultravirus"
    ],
    "ulterieur": [
        "ulterieur"
    ],
    "ulterieure": [
        "ulterieur"
    ],
    "ulterieurement": [
        "ulterieurement"
    ],
    "ulterieures": [
        "ulterieur"
    ],
    "ulterieurs": [
        "ulterieur"
    ],
    "ulula": [
        "ululer"
    ],
    "ululait": [
        "ululer"
    ],
    "ululant": [
        "ululer"
    ],
    "ulule": [
        "ululer"
    ],
    "ululement": [
        "ululement"
    ],
    "ululements": [
        "ululement"
    ],
    "ululer": [
        "ululer"
    ],
    "umbanda": [
        "umbanda"
    ],
    "un": [
        "un"
    ],
    "unanime": [
        "unanime"
    ],
    "unanimement": [
        "unanimement"
    ],
    "unanimes": [
        "unanime"
    ],
    "unanimisme": [
        "unanimisme"
    ],
    "unanimite": [
        "unanimite"
    ],
    "unau": [
        "unau"
    ],
    "underground": [
        "underground"
    ],
    "une": [
        "une",
        "un"
    ],
    "unes": [
        "unes",
        "un"
    ],
    "unetelle": [
        "unetelle"
    ],
    "ungueal": [
        "ungueal"
    ],
    "uni": [
        "uni",
        "unir"
    ],
    "uniate": [
        "uniate"
    ],
    "unicellulaire": [
        "unicellulaire"
    ],
    "unicite": [
        "unicite"
    ],
    "unicorne": [
        "unicorne"
    ],
    "unidimensionnel": [
        "unidimensionnel"
    ],
    "unidimensionnelle": [
        "unidimensionnel"
    ],
    "unidirectionnel": [
        "unidirectionnel"
    ],
    "unidirectionnelle": [
        "unidirectionnel"
    ],
    "unidirectionnels": [
        "unidirectionnel"
    ],
    "unie": [
        "uni",
        "unir"
    ],
    "unies": [
        "uni",
        "unir"
    ],
    "unification": [
        "unification"
    ],
    "unificatrice": [
        "unificateur"
    ],
    "unifie": [
        "unifier"
    ],
    "unifient": [
        "unifier"
    ],
    "unifier": [
        "unifier"
    ],
    "unifiez": [
        "unifier"
    ],
    "unifiee": [
        "unifier"
    ],
    "unifiees": [
        "unifier"
    ],
    "unifies": [
        "unifier",
        "unify"
    ],
    "uniforme": [
        "uniforme"
    ],
    "uniformes": [
        "uniforme"
    ],
    "uniformisait": [
        "uniformiser"
    ],
    "uniformisation": [
        "uniformisation"
    ],
    "uniformise": [
        "uniformiser"
    ],
    "uniformiser": [
        "uniformiser"
    ],
    "uniformisee": [
        "uniformiser"
    ],
    "uniformises": [
        "uniformiser"
    ],
    "uniformite": [
        "uniformite"
    ],
    "uniformement": [
        "uniformement"
    ],
    "unijambiste": [
        "unijambiste"
    ],
    "unijambistes": [
        "unijambiste"
    ],
    "unilateral": [
        "unilateral"
    ],
    "unilaterale": [
        "unilateral"
    ],
    "unilateralement": [
        "unilateralement"
    ],
    "unilaterales": [
        "unilateral"
    ],
    "unilateralite": [
        "unilateralite"
    ],
    "unilateraux": [
        "unilateral"
    ],
    "uniment": [
        "uniment"
    ],
    "uninominal": [
        "uninominal"
    ],
    "uninominales": [
        "uninominal"
    ],
    "union": [
        "union"
    ],
    "unioniste": [
        "unioniste"
    ],
    "unionistes": [
        "unioniste"
    ],
    "unions": [
        "union"
    ],
    "uniprix": [
        "uniprix"
    ],
    "unique": [
        "unique"
    ],
    "uniquement": [
        "uniquement"
    ],
    "uniques": [
        "unique"
    ],
    "unir": [
        "unir"
    ],
    "unira": [
        "unir"
    ],
    "unirai": [
        "unir"
    ],
    "uniraient": [
        "unir"
    ],
    "unirait": [
        "unir"
    ],
    "unirent": [
        "unir"
    ],
    "unirez": [
        "unir"
    ],
    "unirions": [
        "unir"
    ],
    "unirons": [
        "unir"
    ],
    "uniront": [
        "unir"
    ],
    "unis": [
        "uni",
        "unir"
    ],
    "unisexe": [
        "unisexe"
    ],
    "unisexes": [
        "unisexe"
    ],
    "unissaient": [
        "unir"
    ],
    "unissais": [
        "unir"
    ],
    "unissait": [
        "unir"
    ],
    "unissant": [
        "unir"
    ],
    "unisse": [
        "unir"
    ],
    "unissent": [
        "unir"
    ],
    "unisses": [
        "unir"
    ],
    "unissez": [
        "unir"
    ],
    "unissiez": [
        "unir"
    ],
    "unissions": [
        "unir"
    ],
    "unisson": [
        "unisson"
    ],
    "unissons": [
        "unir"
    ],
    "unit": [
        "unir"
    ],
    "unitaire": [
        "unitaire"
    ],
    "unitarien": [
        "unitarien"
    ],
    "unitarienne": [
        "unitarien"
    ],
    "unite": [
        "unite"
    ],
    "unites": [
        "unite"
    ],
    "univalves": [
        "univalve"
    ],
    "univers": [
        "univers"
    ],
    "universal": [
        "universal"
    ],
    "universalisais": [
        "universaliser"
    ],
    "universalise": [
        "universaliser"
    ],
    "universalisme": [
        "universalisme"
    ],
    "universaliste": [
        "universaliste"
    ],
    "universalite": [
        "universalite"
    ],
    "universel": [
        "universel"
    ],
    "universelle": [
        "universel"
    ],
    "universellement": [
        "universellement"
    ],
    "universelles": [
        "universel"
    ],
    "universels": [
        "universel"
    ],
    "universitaire": [
        "universitaire"
    ],
    "universitaires": [
        "universitaire"
    ],
    "universite": [
        "universite"
    ],
    "universites": [
        "universite"
    ],
    "univoque": [
        "univoque"
    ],
    "unieme": [
        "unieme"
    ],
    "uns": [
        "uns"
    ],
    "untel": [
        "untel"
    ],
    "upanisads": [
        "upanisad"
    ],
    "upanishad": [
        "upanishad"
    ],
    "upas": [
        "upas"
    ],
    "update": [
        "update"
    ],
    "updater": [
        "updater"
    ],
    "upgradee": [
        "upgrader"
    ],
    "uppercut": [
        "uppercut"
    ],
    "uppercuts": [
        "uppercut"
    ],
    "urane": [
        "urane"
    ],
    "uraniens": [
        "uranien"
    ],
    "uranisme": [
        "uranisme"
    ],
    "uraniste": [
        "uraniste"
    ],
    "uranium": [
        "uranium"
    ],
    "urbain": [
        "urbain"
    ],
    "urbaine": [
        "urbain"
    ],
    "urbaines": [
        "urbain"
    ],
    "urbains": [
        "urbain"
    ],
    "urbanisation": [
        "urbanisation"
    ],
    "urbanisme": [
        "urbanisme"
    ],
    "urbaniste": [
        "urbaniste"
    ],
    "urbanistes": [
        "urbaniste"
    ],
    "urbanise": [
        "urbaniser"
    ],
    "urbanisee": [
        "urbaniser"
    ],
    "urbanite": [
        "urbanite"
    ],
    "urdu": [
        "urdu"
    ],
    "ures": [
        "ure"
    ],
    "uretere": [
        "uretere"
    ],
    "urf": [
        "urf"
    ],
    "urge": [
        "urger"
    ],
    "urgeait": [
        "urger"
    ],
    "urgemment": [
        "urgemment"
    ],
    "urgence": [
        "urgence"
    ],
    "urgences": [
        "urgence"
    ],
    "urgent": [
        "urger",
        "urgent"
    ],
    "urgente": [
        "urgent"
    ],
    "urgentes": [
        "urgent"
    ],
    "urgentissime": [
        "urgentissime"
    ],
    "urgentiste": [
        "urgentiste"
    ],
    "urgents": [
        "urgent"
    ],
    "urger": [
        "urger"
    ],
    "urina": [
        "uriner"
    ],
    "urinaient": [
        "uriner"
    ],
    "urinaire": [
        "urinaire"
    ],
    "urinaires": [
        "urinaire"
    ],
    "urinais": [
        "uriner"
    ],
    "urinait": [
        "uriner"
    ],
    "urinal": [
        "urinal"
    ],
    "urinant": [
        "uriner"
    ],
    "urine": [
        "uriner",
        "urine"
    ],
    "urinent": [
        "uriner"
    ],
    "uriner": [
        "uriner"
    ],
    "urinera": [
        "uriner"
    ],
    "urines": [
        "uriner",
        "urine"
    ],
    "urineuse": [
        "urineux"
    ],
    "urinez": [
        "uriner"
    ],
    "urinoir": [
        "urinoir"
    ],
    "urinoirs": [
        "urinoir"
    ],
    "urinons": [
        "uriner"
    ],
    "urique": [
        "urique"
    ],
    "urne": [
        "urne"
    ],
    "urnes": [
        "urne"
    ],
    "urographie": [
        "urographie"
    ],
    "urokinase": [
        "urokinase"
    ],
    "urologie": [
        "urologie"
    ],
    "urologique": [
        "urologique"
    ],
    "urologue": [
        "urologue"
    ],
    "uroscopie": [
        "uroscopie"
    ],
    "ursuline": [
        "ursuline"
    ],
    "ursulines": [
        "ursuline"
    ],
    "urticaire": [
        "urticaire"
    ],
    "urticante": [
        "urticant"
    ],
    "urticantes": [
        "urticant"
    ],
    "urticants": [
        "urticant"
    ],
    "urubu": [
        "urubu"
    ],
    "urubus": [
        "urubu"
    ],
    "uruguayen": [
        "uruguayen"
    ],
    "urus": [
        "urus"
    ],
    "uretre": [
        "uretre"
    ],
    "uree": [
        "uree"
    ],
    "uremie": [
        "uremie"
    ],
    "uremique": [
        "uremique"
    ],
    "urethane": [
        "urethane"
    ],
    "uretrite": [
        "uretrite"
    ],
    "us": [
        "me",
        "we",
        "us"
    ],
    "usa": [
        "user"
    ],
    "usage": [
        "usage"
    ],
    "usager": [
        "usager"
    ],
    "usagers": [
        "usager"
    ],
    "usages": [
        "usage"
    ],
    "usageres": [
        "usager"
    ],
    "usagee": [
        "usage"
    ],
    "usagees": [
        "usage"
    ],
    "usai": [
        "user"
    ],
    "usaient": [
        "user"
    ],
    "usais": [
        "user"
    ],
    "usait": [
        "user"
    ],
    "usant": [
        "user",
        "usant"
    ],
    "usante": [
        "usant"
    ],
    "use": [
        "user",
        "use"
    ],
    "usent": [
        "user"
    ],
    "user": [
        "user"
    ],
    "usera": [
        "user"
    ],
    "userai": [
        "user"
    ],
    "userais": [
        "user"
    ],
    "userait": [
        "user"
    ],
    "useriez": [
        "user"
    ],
    "userons": [
        "user"
    ],
    "useront": [
        "user"
    ],
    "uses": [
        "user",
        "use"
    ],
    "usez": [
        "user"
    ],
    "usinage": [
        "usinage"
    ],
    "usinaient": [
        "usiner"
    ],
    "usinant": [
        "usiner"
    ],
    "usine": [
        "usiner",
        "usine"
    ],
    "usiner": [
        "usiner"
    ],
    "usines": [
        "usiner",
        "usine"
    ],
    "usinier": [
        "usinier"
    ],
    "usiniers": [
        "usinier"
    ],
    "usiniere": [
        "usinier"
    ],
    "usinee": [
        "usiner"
    ],
    "usinees": [
        "usiner"
    ],
    "usions": [
        "user"
    ],
    "usite": [
        "usite"
    ],
    "usites": [
        "usite"
    ],
    "usons": [
        "user"
    ],
    "ustensile": [
        "ustensile"
    ],
    "ustensiles": [
        "ustensile"
    ],
    "ustion": [
        "ustion"
    ],
    "usuel": [
        "usuel"
    ],
    "usuelle": [
        "usuel"
    ],
    "usuellement": [
        "usuellement"
    ],
    "usuelles": [
        "usuel"
    ],
    "usuels": [
        "usuel"
    ],
    "usufruit": [
        "usufruit"
    ],
    "usufruitier": [
        "usufruitier"
    ],
    "usuraire": [
        "usuraire"
    ],
    "usuraires": [
        "usuraire"
    ],
    "usure": [
        "usure"
    ],
    "usures": [
        "usure"
    ],
    "usurier": [
        "usurier"
    ],
    "usuriers": [
        "usurier"
    ],
    "usuriere": [
        "usurier"
    ],
    "usurpaient": [
        "usurper"
    ],
    "usurpait": [
        "usurper"
    ],
    "usurpant": [
        "usurper"
    ],
    "usurpateur": [
        "usurpateur"
    ],
    "usurpateurs": [
        "usurpateur"
    ],
    "usurpation": [
        "usurpation"
    ],
    "usurpatrice": [
        "usurpateur"
    ],
    "usurpent": [
        "usurper"
    ],
    "usurper": [
        "usurper"
    ],
    "usurperont": [
        "usurper"
    ],
    "usurpe": [
        "usurper"
    ],
    "usurpee": [
        "usurper"
    ],
    "usurpees": [
        "usurper"
    ],
    "usurpes": [
        "usurper"
    ],
    "usat": [
        "user"
    ],
    "userent": [
        "user"
    ],
    "usee": [
        "user",
        "use"
    ],
    "usees": [
        "user",
        "use"
    ],
    "ut": [
        "ut"
    ],
    "utile": [
        "utile"
    ],
    "utilement": [
        "utilement"
    ],
    "utiles": [
        "utile"
    ],
    "utilisa": [
        "utiliser"
    ],
    "utilisable": [
        "utilisable"
    ],
    "utilisables": [
        "utilisable"
    ],
    "utilisai": [
        "utiliser"
    ],
    "utilisaient": [
        "utiliser"
    ],
    "utilisais": [
        "utiliser"
    ],
    "utilisait": [
        "utiliser"
    ],
    "utilisant": [
        "utiliser"
    ],
    "utilisateur": [
        "utilisateur"
    ],
    "utilisateurs": [
        "utilisateur"
    ],
    "utilisation": [
        "utilisation"
    ],
    "utilisations": [
        "utilisation"
    ],
    "utilisatrice": [
        "utilisateur"
    ],
    "utilise": [
        "utiliser",
        "utilise"
    ],
    "utilisent": [
        "utiliser"
    ],
    "utiliser": [
        "utiliser"
    ],
    "utilisera": [
        "utiliser"
    ],
    "utiliserai": [
        "utiliser"
    ],
    "utiliseraient": [
        "utiliser"
    ],
    "utiliserais": [
        "utiliser"
    ],
    "utiliserait": [
        "utiliser"
    ],
    "utiliseras": [
        "utiliser"
    ],
    "utiliserez": [
        "utiliser"
    ],
    "utiliseriez": [
        "utiliser"
    ],
    "utiliserions": [
        "utiliser"
    ],
    "utiliserons": [
        "utiliser"
    ],
    "utiliseront": [
        "utiliser"
    ],
    "utilises": [
        "utiliser",
        "utilise"
    ],
    "utilisez": [
        "utiliser"
    ],
    "utilisiez": [
        "utiliser"
    ],
    "utilisions": [
        "utiliser"
    ],
    "utilisons": [
        "utiliser"
    ],
    "utilisat": [
        "utiliser"
    ],
    "utiliserent": [
        "utiliser"
    ],
    "utilisee": [
        "utiliser",
        "utilise"
    ],
    "utilisees": [
        "utiliser",
        "utilise"
    ],
    "utilitaire": [
        "utilitaire"
    ],
    "utilitaires": [
        "utilitaire"
    ],
    "utilitarisme": [
        "utilitarisme"
    ],
    "utilite": [
        "utilite"
    ],
    "utilites": [
        "utilite"
    ],
    "utopie": [
        "utopie"
    ],
    "utopies": [
        "utopie"
    ],
    "utopique": [
        "utopique"
    ],
    "utopiques": [
        "utopique"
    ],
    "utopiste": [
        "utopiste"
    ],
    "utopistes": [
        "utopiste"
    ],
    "uterin": [
        "uterin"
    ],
    "uterine": [
        "uterin"
    ],
    "uterines": [
        "uterin"
    ],
    "uterins": [
        "uterin"
    ],
    "uterus": [
        "uterus"
    ],
    "uxorilocal": [
        "uxorilocal"
    ],
    "v": [
        "v"
    ],
    "va": [
        "aller",
        "va"
    ],
    "vacance": [
        "vacance"
    ],
    "vacances": [
        "vacance"
    ],
    "vacancier": [
        "vacancier"
    ],
    "vacanciers": [
        "vacancier"
    ],
    "vacanciere": [
        "vacancier"
    ],
    "vacancieres": [
        "vacancier"
    ],
    "vacant": [
        "vacant"
    ],
    "vacante": [
        "vacant"
    ],
    "vacantes": [
        "vacant"
    ],
    "vacants": [
        "vacant"
    ],
    "vacarme": [
        "vacarme"
    ],
    "vacarmes": [
        "vacarme"
    ],
    "vacataire": [
        "vacataire"
    ],
    "vacation": [
        "vacation"
    ],
    "vacations": [
        "vacation"
    ],
    "vaccin": [
        "vaccin"
    ],
    "vaccinal": [
        "vaccinal"
    ],
    "vaccinant": [
        "vaccinant"
    ],
    "vaccination": [
        "vaccination"
    ],
    "vaccinations": [
        "vaccination"
    ],
    "vaccine": [
        "vacciner",
        "vaccine"
    ],
    "vaccinent": [
        "vacciner"
    ],
    "vacciner": [
        "vacciner"
    ],
    "vaccins": [
        "vaccin"
    ],
    "vaccinee": [
        "vacciner",
        "vaccine"
    ],
    "vaccinees": [
        "vacciner"
    ],
    "vaccines": [
        "vacciner",
        "vaccine"
    ],
    "vachard": [
        "vachard"
    ],
    "vacharde": [
        "vachard"
    ],
    "vachardes": [
        "vachard"
    ],
    "vachardise": [
        "vachardise"
    ],
    "vachards": [
        "vachard"
    ],
    "vache": [
        "vache"
    ],
    "vachement": [
        "vachement"
    ],
    "vacher": [
        "vacher"
    ],
    "vacherie": [
        "vacherie"
    ],
    "vacheries": [
        "vacherie"
    ],
    "vacherin": [
        "vacherin"
    ],
    "vachers": [
        "vacher"
    ],
    "vaches": [
        "vache"
    ],
    "vachette": [
        "vachette"
    ],
    "vachettes": [
        "vachette"
    ],
    "vachere": [
        "vachere"
    ],
    "vacheres": [
        "vachere"
    ],
    "vacilla": [
        "vaciller"
    ],
    "vacillai": [
        "vaciller"
    ],
    "vacillaient": [
        "vaciller"
    ],
    "vacillait": [
        "vaciller"
    ],
    "vacillant": [
        "vacillant",
        "vaciller"
    ],
    "vacillante": [
        "vacillant"
    ],
    "vacillantes": [
        "vacillant"
    ],
    "vacillants": [
        "vacillant"
    ],
    "vacillations": [
        "vacillation"
    ],
    "vacille": [
        "vaciller"
    ],
    "vacillement": [
        "vacillement"
    ],
    "vacillent": [
        "vaciller"
    ],
    "vaciller": [
        "vaciller"
    ],
    "vacillat": [
        "vaciller"
    ],
    "vacillerent": [
        "vaciller"
    ],
    "vacuite": [
        "vacuite"
    ],
    "vacuole": [
        "vacuole"
    ],
    "vacuolisation": [
        "vacuolisation"
    ],
    "vacuum": [
        "vacuum"
    ],
    "vadrouillais": [
        "vadrouiller"
    ],
    "vadrouillait": [
        "vadrouiller"
    ],
    "vadrouille": [
        "vadrouiller",
        "vadrouille"
    ],
    "vadrouillent": [
        "vadrouiller"
    ],
    "vadrouiller": [
        "vadrouiller"
    ],
    "vadrouilles": [
        "vadrouiller",
        "vadrouille"
    ],
    "vadrouilleur": [
        "vadrouilleur"
    ],
    "vadrouilleurs": [
        "vadrouilleur"
    ],
    "vadrouilleuse": [
        "vadrouilleur"
    ],
    "vadrouilleuses": [
        "vadrouilleur"
    ],
    "vadrouillez": [
        "vadrouiller"
    ],
    "vagabond": [
        "vagabond"
    ],
    "vagabonda": [
        "vagabonder"
    ],
    "vagabondage": [
        "vagabondage"
    ],
    "vagabondages": [
        "vagabondage"
    ],
    "vagabondaient": [
        "vagabonder"
    ],
    "vagabondais": [
        "vagabonder"
    ],
    "vagabondait": [
        "vagabonder"
    ],
    "vagabondant": [
        "vagabonder"
    ],
    "vagabonde": [
        "vagabond",
        "vagabonder"
    ],
    "vagabondent": [
        "vagabonder"
    ],
    "vagabonder": [
        "vagabonder"
    ],
    "vagabondes": [
        "vagabond",
        "vagabonder"
    ],
    "vagabondiez": [
        "vagabonder"
    ],
    "vagabonds": [
        "vagabond"
    ],
    "vagabonderent": [
        "vagabonder"
    ],
    "vagal": [
        "vagal"
    ],
    "vagi": [
        "vagir"
    ],
    "vagin": [
        "vagin"
    ],
    "vaginal": [
        "vaginal"
    ],
    "vaginale": [
        "vaginal"
    ],
    "vaginales": [
        "vaginal"
    ],
    "vaginaux": [
        "vaginal"
    ],
    "vaginite": [
        "vaginite"
    ],
    "vagins": [
        "vagin"
    ],
    "vagir": [
        "vagir"
    ],
    "vagis": [
        "vagir"
    ],
    "vagissaient": [
        "vagir"
    ],
    "vagissais": [
        "vagir"
    ],
    "vagissait": [
        "vagir"
    ],
    "vagissant": [
        "vagissant",
        "vagir"
    ],
    "vagissement": [
        "vagissement"
    ],
    "vagissements": [
        "vagissement"
    ],
    "vagissent": [
        "vagir"
    ],
    "vagissons": [
        "vagir"
    ],
    "vagit": [
        "vagir"
    ],
    "vagotomie": [
        "vagotomie"
    ],
    "vagua": [
        "vaguer"
    ],
    "vaguait": [
        "vaguer"
    ],
    "vaguant": [
        "vaguer"
    ],
    "vague": [
        "vague",
        "vaguer"
    ],
    "vaguelette": [
        "vaguelette"
    ],
    "vaguelettes": [
        "vaguelette"
    ],
    "vaguement": [
        "vaguement"
    ],
    "vaguemestre": [
        "vaguemestre"
    ],
    "vaguent": [
        "vaguer"
    ],
    "vaguer": [
        "vaguer"
    ],
    "vagues": [
        "vague"
    ],
    "vahine": [
        "vahine"
    ],
    "vahines": [
        "vahine"
    ],
    "vaillamment": [
        "vaillamment"
    ],
    "vaillance": [
        "vaillance"
    ],
    "vaillant": [
        "vaillant"
    ],
    "vaillante": [
        "vaillant"
    ],
    "vaillantes": [
        "vaillant"
    ],
    "vaillants": [
        "vaillant"
    ],
    "vaille": [
        "valoir"
    ],
    "vaillent": [
        "valoir"
    ],
    "vain": [
        "vain"
    ],
    "vainc": [
        "vaincre"
    ],
    "vaincra": [
        "vaincre"
    ],
    "vaincrai": [
        "vaincre"
    ],
    "vaincraient": [
        "vaincre"
    ],
    "vaincrais": [
        "vaincre"
    ],
    "vaincrait": [
        "vaincre"
    ],
    "vaincras": [
        "vaincre"
    ],
    "vaincre": [
        "vaincre"
    ],
    "vaincrez": [
        "vaincre"
    ],
    "vaincrons": [
        "vaincre"
    ],
    "vaincront": [
        "vaincre"
    ],
    "vaincs": [
        "vaincre"
    ],
    "vaincu": [
        "vaincre",
        "vaincu"
    ],
    "vaincue": [
        "vaincre",
        "vaincu"
    ],
    "vaincues": [
        "vaincre",
        "vaincu"
    ],
    "vaincus": [
        "vaincre",
        "vaincu"
    ],
    "vaine": [
        "vain"
    ],
    "vainement": [
        "vainement"
    ],
    "vaines": [
        "vain"
    ],
    "vainquant": [
        "vaincre"
    ],
    "vainquent": [
        "vaincre"
    ],
    "vainqueur": [
        "vainqueur"
    ],
    "vainqueurs": [
        "vainqueur"
    ],
    "vainquez": [
        "vaincre"
    ],
    "vainquions": [
        "vaincre"
    ],
    "vainquirent": [
        "vaincre"
    ],
    "vainquit": [
        "vaincre"
    ],
    "vainquons": [
        "vaincre"
    ],
    "vains": [
        "vain"
    ],
    "vair": [
        "vair"
    ],
    "vairon": [
        "vairon"
    ],
    "vairons": [
        "vairon"
    ],
    "vais": [
        "aller"
    ],
    "vaisseau": [
        "vaisseau"
    ],
    "vaisseaux": [
        "vaisseau"
    ],
    "vaisselier": [
        "vaisselier"
    ],
    "vaisseliers": [
        "vaisselier"
    ],
    "vaisselle": [
        "vaisselle"
    ],
    "vaisselles": [
        "vaisselle"
    ],
    "val": [
        "val"
    ],
    "valable": [
        "valable"
    ],
    "valablement": [
        "valablement"
    ],
    "valables": [
        "valable"
    ],
    "valaient": [
        "valoir"
    ],
    "valais": [
        "valoir"
    ],
    "valait": [
        "valoir"
    ],
    "valant": [
        "valoir"
    ],
    "valaque": [
        "valaque"
    ],
    "valdingua": [
        "valdinguer"
    ],
    "valdingue": [
        "valdinguer"
    ],
    "valdinguer": [
        "valdinguer"
    ],
    "valdingues": [
        "valdinguer"
    ],
    "valdotains": [
        "valdotain"
    ],
    "valence": [
        "valence"
    ],
    "valencien": [
        "valencien"
    ],
    "valencienne": [
        "valencien"
    ],
    "valent": [
        "valoir"
    ],
    "valentin": [
        "valentin"
    ],
    "valentine": [
        "valentin"
    ],
    "valentinien": [
        "valentinien"
    ],
    "valet": [
        "valet"
    ],
    "valetaille": [
        "valetaille"
    ],
    "valeter": [
        "valeter"
    ],
    "valets": [
        "valet"
    ],
    "valeur": [
        "valeur"
    ],
    "valeureuse": [
        "valeureux"
    ],
    "valeureusement": [
        "valeureusement"
    ],
    "valeureuses": [
        "valeureux"
    ],
    "valeureux": [
        "valeureux"
    ],
    "valeurs": [
        "valeur"
    ],
    "valez": [
        "valoir"
    ],
    "valgus": [
        "valgus"
    ],
    "valida": [
        "valider"
    ],
    "validait": [
        "valider"
    ],
    "validant": [
        "valider"
    ],
    "validation": [
        "validation"
    ],
    "valide": [
        "valide",
        "valider"
    ],
    "valident": [
        "valider"
    ],
    "valider": [
        "valider"
    ],
    "valideront": [
        "valider"
    ],
    "valides": [
        "valide"
    ],
    "validite": [
        "validite"
    ],
    "validee": [
        "valider",
        "valide"
    ],
    "valiez": [
        "valoir"
    ],
    "valions": [
        "valoir"
    ],
    "valise": [
        "valise",
        "valiser"
    ],
    "valises": [
        "valise"
    ],
    "valkyries": [
        "valkyrie"
    ],
    "valleuse": [
        "valleuse"
    ],
    "vallon": [
        "vallon"
    ],
    "vallonnaient": [
        "vallonner"
    ],
    "vallonnait": [
        "vallonner"
    ],
    "vallonnement": [
        "vallonnement"
    ],
    "vallonnements": [
        "vallonnement"
    ],
    "vallonner": [
        "vallonner"
    ],
    "vallonne": [
        "vallonne"
    ],
    "vallonnee": [
        "vallonne",
        "vallonner"
    ],
    "vallonnees": [
        "vallonne"
    ],
    "vallonnes": [
        "vallonne"
    ],
    "vallons": [
        "vallon"
    ],
    "vallee": [
        "vallee"
    ],
    "vallees": [
        "vallee"
    ],
    "valoche": [
        "valoche"
    ],
    "valoches": [
        "valoche"
    ],
    "valoir": [
        "valoir"
    ],
    "valons": [
        "valoir"
    ],
    "valorisait": [
        "valoriser"
    ],
    "valorisant": [
        "valorisant"
    ],
    "valorisante": [
        "valorisant"
    ],
    "valorisation": [
        "valorisation"
    ],
    "valorise": [
        "valoriser"
    ],
    "valoriser": [
        "valoriser"
    ],
    "valorisez": [
        "valoriser"
    ],
    "valorisee": [
        "valoriser"
    ],
    "valorises": [
        "valoriser"
    ],
    "valpolicella": [
        "valpolicella"
    ],
    "vals": [
        "val"
    ],
    "valsa": [
        "valser"
    ],
    "valsaient": [
        "valser"
    ],
    "valsait": [
        "valser"
    ],
    "valsant": [
        "valser"
    ],
    "valse": [
        "valse",
        "valser"
    ],
    "valsent": [
        "valser"
    ],
    "valser": [
        "valser"
    ],
    "valsera": [
        "valser"
    ],
    "valses": [
        "valse",
        "valser"
    ],
    "valseur": [
        "valseur"
    ],
    "valseurs": [
        "valseur"
    ],
    "valseuse": [
        "valseur"
    ],
    "valseuses": [
        "valseur"
    ],
    "valsez": [
        "valser"
    ],
    "valsons": [
        "valser"
    ],
    "valserent": [
        "valser"
    ],
    "valu": [
        "valoir"
    ],
    "value": [
        "valoir"
    ],
    "values": [
        "value",
        "valoir"
    ],
    "valurent": [
        "valoir"
    ],
    "valut": [
        "valoir"
    ],
    "valve": [
        "valve"
    ],
    "valves": [
        "valve"
    ],
    "valvulaires": [
        "valvulaire"
    ],
    "valvule": [
        "valvule"
    ],
    "valeriane": [
        "valeriane"
    ],
    "valetudinaire": [
        "valetudinaire"
    ],
    "vamp": [
        "vamp"
    ],
    "vampe": [
        "vamper"
    ],
    "vamper": [
        "vamper"
    ],
    "vampire": [
        "vampire"
    ],
    "vampires": [
        "vampire"
    ],
    "vampirique": [
        "vampirique"
    ],
    "vampirisant": [
        "vampiriser"
    ],
    "vampirise": [
        "vampiriser"
    ],
    "vampirisme": [
        "vampirisme"
    ],
    "vampirisee": [
        "vampiriser"
    ],
    "vampirisees": [
        "vampiriser"
    ],
    "vamps": [
        "vamp"
    ],
    "van": [
        "van"
    ],
    "vanadium": [
        "vanadium"
    ],
    "vandale": [
        "vandale"
    ],
    "vandales": [
        "vandale"
    ],
    "vandalisent": [
        "vandaliser"
    ],
    "vandaliser": [
        "vandaliser"
    ],
    "vandalisme": [
        "vandalisme"
    ],
    "vandalise": [
        "vandaliser"
    ],
    "vandoises": [
        "vandoise"
    ],
    "vanille": [
        "vanille"
    ],
    "vanillee": [
        "vanille"
    ],
    "vanillees": [
        "vanille"
    ],
    "vaniteuse": [
        "vaniteux"
    ],
    "vaniteusement": [
        "vaniteusement"
    ],
    "vaniteuses": [
        "vaniteux"
    ],
    "vaniteux": [
        "vaniteux"
    ],
    "vanite": [
        "vanite"
    ],
    "vanites": [
        "vanite"
    ],
    "vanna": [
        "vanner"
    ],
    "vannais": [
        "vanner"
    ],
    "vannait": [
        "vanner"
    ],
    "vanne": [
        "vanner",
        "vanne"
    ],
    "vanneau": [
        "vanneau"
    ],
    "vanneaux": [
        "vanneau"
    ],
    "vannent": [
        "vanner"
    ],
    "vanner": [
        "vanner"
    ],
    "vannerie": [
        "vannerie"
    ],
    "vanneries": [
        "vannerie"
    ],
    "vannes": [
        "vanner",
        "vanne"
    ],
    "vanneur": [
        "vanneur"
    ],
    "vanneurs": [
        "vanneur"
    ],
    "vannier": [
        "vannier"
    ],
    "vanniers": [
        "vannier"
    ],
    "vannieres": [
        "vanniere"
    ],
    "vannerent": [
        "vanner"
    ],
    "vannee": [
        "vanner",
        "vanne"
    ],
    "vans": [
        "van"
    ],
    "vanta": [
        "vanter"
    ],
    "vantai": [
        "vanter"
    ],
    "vantaient": [
        "vanter"
    ],
    "vantail": [
        "vantail"
    ],
    "vantais": [
        "vanter"
    ],
    "vantait": [
        "vanter"
    ],
    "vantant": [
        "vanter"
    ],
    "vantard": [
        "vantard"
    ],
    "vantarde": [
        "vantard"
    ],
    "vantardes": [
        "vantard"
    ],
    "vantardise": [
        "vantardise"
    ],
    "vantardises": [
        "vantardise"
    ],
    "vantards": [
        "vantard"
    ],
    "vantaux": [
        "vantail"
    ],
    "vante": [
        "vanter"
    ],
    "vantent": [
        "vanter"
    ],
    "vanter": [
        "vanter"
    ],
    "vantera": [
        "vanter"
    ],
    "vanterai": [
        "vanter"
    ],
    "vanterais": [
        "vanter"
    ],
    "vanterait": [
        "vanter"
    ],
    "vanteras": [
        "vanter"
    ],
    "vanterie": [
        "vanterie"
    ],
    "vanteries": [
        "vanterie"
    ],
    "vanteront": [
        "vanter"
    ],
    "vantes": [
        "vanter"
    ],
    "vantez": [
        "vanter"
    ],
    "vantiez": [
        "vanter"
    ],
    "vantions": [
        "vanter"
    ],
    "vantons": [
        "vanter"
    ],
    "vantat": [
        "vanter"
    ],
    "vantee": [
        "vanter"
    ],
    "vantees": [
        "vanter"
    ],
    "vape": [
        "vape"
    ],
    "vapes": [
        "vape"
    ],
    "vapeur": [
        "vapeur"
    ],
    "vapeurs": [
        "vapeur"
    ],
    "vaporetto": [
        "vaporetto"
    ],
    "vaporeuse": [
        "vaporeux"
    ],
    "vaporeuses": [
        "vaporeux"
    ],
    "vaporeux": [
        "vaporeux"
    ],
    "vaporisa": [
        "vaporiser"
    ],
    "vaporisais": [
        "vaporiser"
    ],
    "vaporisait": [
        "vaporiser"
    ],
    "vaporisant": [
        "vaporiser"
    ],
    "vaporisateur": [
        "vaporisateur"
    ],
    "vaporisateurs": [
        "vaporisateur"
    ],
    "vaporisation": [
        "vaporisation"
    ],
    "vaporisations": [
        "vaporisation"
    ],
    "vaporise": [
        "vaporiser"
    ],
    "vaporiser": [
        "vaporiser"
    ],
    "vaporiserait": [
        "vaporiser"
    ],
    "vaporises": [
        "vaporiser"
    ],
    "vaporisez": [
        "vaporiser"
    ],
    "vaporisee": [
        "vaporiser"
    ],
    "vaps": [
        "vaps"
    ],
    "vaquai": [
        "vaquer"
    ],
    "vaquaient": [
        "vaquer"
    ],
    "vaquais": [
        "vaquer"
    ],
    "vaquait": [
        "vaquer"
    ],
    "vaquant": [
        "vaquer"
    ],
    "vaque": [
        "vaquer"
    ],
    "vaquent": [
        "vaquer"
    ],
    "vaquer": [
        "vaquer"
    ],
    "vaquerait": [
        "vaquer"
    ],
    "vaquero": [
        "vaquero"
    ],
    "vaqueros": [
        "vaquero"
    ],
    "vaquions": [
        "vaquer"
    ],
    "vaquons": [
        "vaquer"
    ],
    "var": [
        "var"
    ],
    "vara": [
        "vara"
    ],
    "varan": [
        "varan"
    ],
    "varans": [
        "varan"
    ],
    "varappe": [
        "varappe"
    ],
    "varapper": [
        "varapper"
    ],
    "varappeur": [
        "varappeur"
    ],
    "varech": [
        "varech"
    ],
    "varechs": [
        "varech"
    ],
    "varenne": [
        "varenne"
    ],
    "varennes": [
        "varenne"
    ],
    "vareuse": [
        "vareuse"
    ],
    "vareuses": [
        "vareuse"
    ],
    "varia": [
        "varia"
    ],
    "variabilite": [
        "variabilite"
    ],
    "variable": [
        "variable"
    ],
    "variables": [
        "variable"
    ],
    "variaient": [
        "varier"
    ],
    "variais": [
        "varier"
    ],
    "variait": [
        "varier"
    ],
    "variance": [
        "variance"
    ],
    "variant": [
        "varier",
        "variant"
    ],
    "variante": [
        "variante",
        "variant"
    ],
    "variantes": [
        "variante",
        "variant"
    ],
    "variateur": [
        "variateur"
    ],
    "variation": [
        "variation"
    ],
    "variations": [
        "variation"
    ],
    "varice": [
        "varice"
    ],
    "varicelle": [
        "varicelle"
    ],
    "varices": [
        "varice"
    ],
    "varie": [
        "varie",
        "varier"
    ],
    "varient": [
        "varier"
    ],
    "varier": [
        "varier"
    ],
    "varierai": [
        "varier"
    ],
    "varieraient": [
        "varier"
    ],
    "varierait": [
        "varier"
    ],
    "varieront": [
        "varier"
    ],
    "variole": [
        "variole"
    ],
    "variorum": [
        "variorum"
    ],
    "variqueuses": [
        "variqueux"
    ],
    "variqueux": [
        "variqueux"
    ],
    "variat": [
        "varier"
    ],
    "variee": [
        "varie",
        "varier"
    ],
    "variees": [
        "varie",
        "varier"
    ],
    "varies": [
        "varie",
        "varier",
        "vary"
    ],
    "varietal": [
        "varietal"
    ],
    "variete": [
        "variete"
    ],
    "varietes": [
        "variete"
    ],
    "varlet": [
        "varlet"
    ],
    "varlope": [
        "varlope"
    ],
    "varon": [
        "varon"
    ],
    "varsovien": [
        "varsovien"
    ],
    "vas": [
        "aller"
    ],
    "vasa": [
        "vaser"
    ],
    "vasais": [
        "vasais"
    ],
    "vasait": [
        "vaser"
    ],
    "vasards": [
        "vasard"
    ],
    "vasculaire": [
        "vasculaire"
    ],
    "vasculaires": [
        "vasculaire"
    ],
    "vascularise": [
        "vascularise"
    ],
    "vase": [
        "vase"
    ],
    "vasectomie": [
        "vasectomie"
    ],
    "vaseline": [
        "vaseline",
        "vaseliner"
    ],
    "vaseliner": [
        "vaseliner"
    ],
    "vaselinez": [
        "vaseliner"
    ],
    "vaser": [
        "vaser"
    ],
    "vases": [
        "vase"
    ],
    "vaseuse": [
        "vaseux"
    ],
    "vaseuses": [
        "vaseux"
    ],
    "vaseux": [
        "vaseux"
    ],
    "vasistas": [
        "vasistas"
    ],
    "vasiere": [
        "vasiere"
    ],
    "vasieres": [
        "vasiere"
    ],
    "vasoconstricteur": [
        "vasoconstricteur"
    ],
    "vasoconstriction": [
        "vasoconstriction"
    ],
    "vasodilatateur": [
        "vasodilatateur"
    ],
    "vasodilatation": [
        "vasodilatation"
    ],
    "vasomoteurs": [
        "vasomoteur"
    ],
    "vasopressine": [
        "vasopressine"
    ],
    "vasouillard": [
        "vasouillard"
    ],
    "vasouillarde": [
        "vasouillard"
    ],
    "vasouille": [
        "vasouiller"
    ],
    "vasouiller": [
        "vasouiller"
    ],
    "vasouilles": [
        "vasouiller"
    ],
    "vasque": [
        "vasque"
    ],
    "vasques": [
        "vasque"
    ],
    "vassal": [
        "vassal"
    ],
    "vassale": [
        "vassal"
    ],
    "vassalite": [
        "vassalite"
    ],
    "vassaux": [
        "vassal"
    ],
    "vaste": [
        "vaste"
    ],
    "vastes": [
        "vaste"
    ],
    "vastitude": [
        "vastitude"
    ],
    "vastitudes": [
        "vastitude"
    ],
    "vastite": [
        "vastite"
    ],
    "vater": [
        "vater"
    ],
    "vaticane": [
        "vaticane"
    ],
    "vaticanesque": [
        "vaticanesque"
    ],
    "vaticinait": [
        "vaticiner"
    ],
    "vaticinant": [
        "vaticiner"
    ],
    "vaticination": [
        "vaticination"
    ],
    "vaticinations": [
        "vaticination"
    ],
    "vaticine": [
        "vaticiner"
    ],
    "vaticiner": [
        "vaticiner"
    ],
    "vateres": [
        "vatere"
    ],
    "vau": [
        "vau"
    ],
    "vauclusien": [
        "vauclusien"
    ],
    "vauclusiennes": [
        "vauclusien"
    ],
    "vaudeville": [
        "vaudeville"
    ],
    "vaudevilles": [
        "vaudeville"
    ],
    "vaudevillesque": [
        "vaudevillesque"
    ],
    "vaudevillesques": [
        "vaudevillesque"
    ],
    "vaudois": [
        "vaudois"
    ],
    "vaudoise": [
        "vaudois"
    ],
    "vaudou": [
        "vaudou"
    ],
    "vaudoue": [
        "vaudou"
    ],
    "vaudoues": [
        "vaudou"
    ],
    "vaudouisme": [
        "vaudouisme"
    ],
    "vaudous": [
        "vaudou"
    ],
    "vaudra": [
        "valoir"
    ],
    "vaudrai": [
        "valoir"
    ],
    "vaudraient": [
        "valoir"
    ],
    "vaudrais": [
        "valoir"
    ],
    "vaudrait": [
        "valoir"
    ],
    "vaudras": [
        "valoir"
    ],
    "vaudrez": [
        "valoir"
    ],
    "vaudrions": [
        "valoir"
    ],
    "vaudrons": [
        "valoir"
    ],
    "vaudront": [
        "valoir"
    ],
    "vaurien": [
        "vaurien"
    ],
    "vaurienne": [
        "vaurien"
    ],
    "vauriens": [
        "vaurien"
    ],
    "vaut": [
        "valoir"
    ],
    "vautour": [
        "vautour"
    ],
    "vautours": [
        "vautour"
    ],
    "vautra": [
        "vautrer"
    ],
    "vautraient": [
        "vautrer"
    ],
    "vautrais": [
        "vautrer"
    ],
    "vautrait": [
        "vautrer"
    ],
    "vautrant": [
        "vautrer"
    ],
    "vautre": [
        "vautrer",
        "vautre"
    ],
    "vautrent": [
        "vautrer"
    ],
    "vautrer": [
        "vautrer"
    ],
    "vautreraient": [
        "vautrer"
    ],
    "vautrerais": [
        "vautrer"
    ],
    "vautrez": [
        "vautrer"
    ],
    "vautrerent": [
        "vautrer"
    ],
    "vautree": [
        "vautrer",
        "vautre"
    ],
    "vautrees": [
        "vautrer",
        "vautre"
    ],
    "vautres": [
        "vautrer",
        "vautre"
    ],
    "vauvert": [
        "vauvert"
    ],
    "vaux": [
        "valoir",
        "val"
    ],
    "vauxhall": [
        "vauxhall"
    ],
    "veau": [
        "veau"
    ],
    "veaux": [
        "veau"
    ],
    "vecteur": [
        "vecteur"
    ],
    "vecteurs": [
        "vecteur"
    ],
    "vectoriel": [
        "vectoriel"
    ],
    "vectorielle": [
        "vectoriel"
    ],
    "vedettariat": [
        "vedettariat"
    ],
    "vedette": [
        "vedette"
    ],
    "vedettes": [
        "vedette"
    ],
    "veilla": [
        "veiller"
    ],
    "veillai": [
        "veiller"
    ],
    "veillaient": [
        "veiller"
    ],
    "veillais": [
        "veiller"
    ],
    "veillait": [
        "veiller"
    ],
    "veillant": [
        "veiller"
    ],
    "veille": [
        "veiller",
        "veille"
    ],
    "veillent": [
        "veiller"
    ],
    "veiller": [
        "veiller"
    ],
    "veillera": [
        "veiller"
    ],
    "veillerai": [
        "veiller"
    ],
    "veillerais": [
        "veiller"
    ],
    "veillerait": [
        "veiller"
    ],
    "veilleras": [
        "veiller"
    ],
    "veillerez": [
        "veiller"
    ],
    "veillerons": [
        "veiller"
    ],
    "veilleront": [
        "veiller"
    ],
    "veilles": [
        "veiller",
        "veille"
    ],
    "veilleur": [
        "veilleur"
    ],
    "veilleurs": [
        "veilleur"
    ],
    "veilleuse": [
        "veilleuse"
    ],
    "veilleuses": [
        "veilleuse"
    ],
    "veillez": [
        "veiller"
    ],
    "veillions": [
        "veiller"
    ],
    "veillons": [
        "veiller"
    ],
    "veillames": [
        "veiller"
    ],
    "veillat": [
        "veiller"
    ],
    "veillerent": [
        "veiller"
    ],
    "veillee": [
        "veillee",
        "veiller",
        "veille"
    ],
    "veillees": [
        "veillee",
        "veille"
    ],
    "veinaient": [
        "veiner"
    ],
    "veinait": [
        "veiner"
    ],
    "veinard": [
        "veinard"
    ],
    "veinarde": [
        "veinard"
    ],
    "veinardes": [
        "veinard"
    ],
    "veinards": [
        "veinard"
    ],
    "veine": [
        "veiner",
        "veine"
    ],
    "veinent": [
        "veiner"
    ],
    "veines": [
        "veiner",
        "veine"
    ],
    "veineuse": [
        "veineux"
    ],
    "veineux": [
        "veineux"
    ],
    "veinule": [
        "veinule"
    ],
    "veinules": [
        "veinule"
    ],
    "veinures": [
        "veinure"
    ],
    "veinee": [
        "veiner",
        "veine"
    ],
    "veinees": [
        "veiner",
        "veine"
    ],
    "velcro": [
        "velcro"
    ],
    "veld": [
        "veld"
    ],
    "veldt": [
        "veldt"
    ],
    "vellave": [
        "vellave"
    ],
    "velleitaire": [
        "velleitaire"
    ],
    "velleite": [
        "velleite"
    ],
    "velleites": [
        "velleite"
    ],
    "velours": [
        "velours"
    ],
    "veloutaient": [
        "velouter"
    ],
    "veloutait": [
        "velouter"
    ],
    "veloute": [
        "velouter",
        "veloute"
    ],
    "veloutent": [
        "velouter"
    ],
    "velouter": [
        "velouter"
    ],
    "velouteuse": [
        "velouteux"
    ],
    "velouteux": [
        "velouteux"
    ],
    "veloutee": [
        "velouter",
        "veloute"
    ],
    "veloutees": [
        "velouter",
        "veloute"
    ],
    "veloutes": [
        "veloute"
    ],
    "velte": [
        "velte"
    ],
    "velu": [
        "velu"
    ],
    "velue": [
        "velu"
    ],
    "velues": [
        "velu"
    ],
    "velum": [
        "velum"
    ],
    "velus": [
        "velu"
    ],
    "velux": [
        "velux"
    ],
    "velvet": [
        "velvet"
    ],
    "venaient": [
        "venir"
    ],
    "venais": [
        "venir"
    ],
    "venaison": [
        "venaison"
    ],
    "venaisons": [
        "venaison"
    ],
    "venait": [
        "venir"
    ],
    "venant": [
        "venir",
        "venant"
    ],
    "vend": [
        "vendre"
    ],
    "vendable": [
        "vendable"
    ],
    "vendables": [
        "vendable"
    ],
    "vendaient": [
        "vendre"
    ],
    "vendais": [
        "vendre"
    ],
    "vendait": [
        "vendre"
    ],
    "vendange": [
        "vendanger",
        "vendange"
    ],
    "vendangeait": [
        "vendanger"
    ],
    "vendanger": [
        "vendanger"
    ],
    "vendanges": [
        "vendanger",
        "vendange"
    ],
    "vendangeur": [
        "vendangeur"
    ],
    "vendangeurs": [
        "vendangeur"
    ],
    "vendangeuses": [
        "vendangeur"
    ],
    "vendant": [
        "vendre"
    ],
    "vende": [
        "vendre"
    ],
    "vendent": [
        "vendre"
    ],
    "vendes": [
        "vendre"
    ],
    "vendetta": [
        "vendetta"
    ],
    "vendettas": [
        "vendetta"
    ],
    "vendeur": [
        "vendeur"
    ],
    "vendeurs": [
        "vendeur"
    ],
    "vendeuse": [
        "vendeur"
    ],
    "vendeuses": [
        "vendeur"
    ],
    "vendez": [
        "vendre"
    ],
    "vendiez": [
        "vendre"
    ],
    "vendions": [
        "vendre"
    ],
    "vendirent": [
        "vendre"
    ],
    "vendis": [
        "vendre"
    ],
    "vendisse": [
        "vendre"
    ],
    "vendit": [
        "vendre"
    ],
    "vendons": [
        "vendre"
    ],
    "vendra": [
        "vendre"
    ],
    "vendrai": [
        "vendre"
    ],
    "vendraient": [
        "vendre"
    ],
    "vendrais": [
        "vendre"
    ],
    "vendrait": [
        "vendre"
    ],
    "vendras": [
        "vendre"
    ],
    "vendre": [
        "vendre"
    ],
    "vendredi": [
        "vendredi"
    ],
    "vendredis": [
        "vendredi"
    ],
    "vendrez": [
        "vendre"
    ],
    "vendriez": [
        "vendre"
    ],
    "vendrons": [
        "vendre"
    ],
    "vendront": [
        "vendre"
    ],
    "vends": [
        "vendre"
    ],
    "vendu": [
        "vendu",
        "vendre"
    ],
    "vendue": [
        "vendu",
        "vendre"
    ],
    "vendues": [
        "vendu",
        "vendre"
    ],
    "vendus": [
        "vendu",
        "vendre"
    ],
    "vendeen": [
        "vendeen"
    ],
    "vendeenne": [
        "vendeen"
    ],
    "vendeennes": [
        "vendeen"
    ],
    "vendeens": [
        "vendeen"
    ],
    "vendemiaire": [
        "vendemiaire"
    ],
    "vendomois": [
        "vendomois"
    ],
    "venelle": [
        "venelle"
    ],
    "venelles": [
        "venelle"
    ],
    "venette": [
        "venette"
    ],
    "veneur": [
        "veneur"
    ],
    "veneurs": [
        "veneur"
    ],
    "venez": [
        "venir"
    ],
    "venge": [
        "venger"
    ],
    "vengea": [
        "venger"
    ],
    "vengeai": [
        "venger"
    ],
    "vengeaient": [
        "venger"
    ],
    "vengeais": [
        "venger"
    ],
    "vengeait": [
        "venger"
    ],
    "vengeance": [
        "vengeance"
    ],
    "vengeances": [
        "vengeance"
    ],
    "vengeant": [
        "venger"
    ],
    "vengent": [
        "venger"
    ],
    "vengeons": [
        "venger"
    ],
    "venger": [
        "venger"
    ],
    "vengera": [
        "venger"
    ],
    "vengerai": [
        "venger"
    ],
    "vengerais": [
        "venger"
    ],
    "vengerait": [
        "venger"
    ],
    "vengeresse": [
        "vengeur"
    ],
    "vengeresses": [
        "vengeur"
    ],
    "vengerez": [
        "venger"
    ],
    "vengerons": [
        "venger"
    ],
    "vengeront": [
        "venger"
    ],
    "venges": [
        "venger"
    ],
    "vengeur": [
        "vengeur"
    ],
    "vengeurs": [
        "vengeur"
    ],
    "vengez": [
        "venger"
    ],
    "vengeat": [
        "venger"
    ],
    "vengiez": [
        "venger"
    ],
    "vengerent": [
        "venger"
    ],
    "vengee": [
        "venger"
    ],
    "vengees": [
        "venger"
    ],
    "veniez": [
        "venir"
    ],
    "venimeuse": [
        "venimeux"
    ],
    "venimeusement": [
        "venimeusement"
    ],
    "venimeuses": [
        "venimeux"
    ],
    "venimeux": [
        "venimeux"
    ],
    "venin": [
        "venin"
    ],
    "venins": [
        "venin"
    ],
    "venions": [
        "venir"
    ],
    "venir": [
        "venir"
    ],
    "venise": [
        "venise"
    ],
    "venons": [
        "venir"
    ],
    "vent": [
        "vent"
    ],
    "venta": [
        "venter"
    ],
    "ventail": [
        "ventail"
    ],
    "ventas": [
        "venter"
    ],
    "vente": [
        "vente",
        "venter"
    ],
    "venter": [
        "venter"
    ],
    "ventes": [
        "vente",
        "venter"
    ],
    "venteuse": [
        "venteux"
    ],
    "venteuses": [
        "venteux"
    ],
    "venteux": [
        "venteux"
    ],
    "ventilant": [
        "ventiler"
    ],
    "ventilateur": [
        "ventilateur"
    ],
    "ventilateurs": [
        "ventilateur"
    ],
    "ventilation": [
        "ventilation"
    ],
    "ventilations": [
        "ventilation"
    ],
    "ventile": [
        "ventiler",
        "ventile"
    ],
    "ventiler": [
        "ventiler"
    ],
    "ventilez": [
        "ventiler"
    ],
    "ventilo": [
        "ventilo"
    ],
    "ventilos": [
        "ventilo"
    ],
    "ventilee": [
        "ventiler",
        "ventile"
    ],
    "ventilees": [
        "ventile"
    ],
    "ventiles": [
        "ventiler",
        "ventile"
    ],
    "ventis": [
        "ventis"
    ],
    "ventouse": [
        "ventouser",
        "ventouse"
    ],
    "ventousent": [
        "ventouser"
    ],
    "ventouses": [
        "ventouse"
    ],
    "ventousee": [
        "ventouser"
    ],
    "ventral": [
        "ventral"
    ],
    "ventrale": [
        "ventral"
    ],
    "ventre": [
        "ventre"
    ],
    "ventrebleu": [
        "ventrebleu"
    ],
    "ventres": [
        "ventre"
    ],
    "ventriculaire": [
        "ventriculaire"
    ],
    "ventricule": [
        "ventricule"
    ],
    "ventricules": [
        "ventricule"
    ],
    "ventriloque": [
        "ventriloque"
    ],
    "ventriloques": [
        "ventriloque"
    ],
    "ventriloquie": [
        "ventriloquie"
    ],
    "ventripotent": [
        "ventripotent"
    ],
    "ventripotents": [
        "ventripotent"
    ],
    "ventriere": [
        "ventriere"
    ],
    "ventru": [
        "ventru"
    ],
    "ventrue": [
        "ventru"
    ],
    "ventrues": [
        "ventru"
    ],
    "ventrus": [
        "ventru"
    ],
    "ventree": [
        "ventree"
    ],
    "ventrees": [
        "ventree"
    ],
    "vents": [
        "vent"
    ],
    "ventee": [
        "vente"
    ],
    "ventees": [
        "vente"
    ],
    "ventose": [
        "ventose"
    ],
    "venu": [
        "venir",
        "venu"
    ],
    "venue": [
        "venir",
        "venu",
        "venue"
    ],
    "venues": [
        "venir",
        "venu",
        "venue"
    ],
    "venus": [
        "venir",
        "venu",
        "venus"
    ],
    "ver": [
        "ver"
    ],
    "verbal": [
        "verbal"
    ],
    "verbale": [
        "verbal"
    ],
    "verbalement": [
        "verbalement"
    ],
    "verbales": [
        "verbal"
    ],
    "verbalisation": [
        "verbalisation"
    ],
    "verbalise": [
        "verbaliser"
    ],
    "verbaliser": [
        "verbaliser"
    ],
    "verbalisez": [
        "verbaliser"
    ],
    "verbalisme": [
        "verbalisme"
    ],
    "verbaliste": [
        "verbaliste"
    ],
    "verbalisee": [
        "verbaliser"
    ],
    "verbatim": [
        "verbatim"
    ],
    "verbaux": [
        "verbal"
    ],
    "verbe": [
        "verbe"
    ],
    "verbes": [
        "verbe"
    ],
    "verbeuse": [
        "verbeux"
    ],
    "verbeuses": [
        "verbeux"
    ],
    "verbeux": [
        "verbeux"
    ],
    "verbiage": [
        "verbiage"
    ],
    "verbosite": [
        "verbosite"
    ],
    "verbosites": [
        "verbosite"
    ],
    "verdelet": [
        "verdelet"
    ],
    "verdeur": [
        "verdeur"
    ],
    "verdeurs": [
        "verdeur"
    ],
    "verdi": [
        "verdir",
        "verdi"
    ],
    "verdict": [
        "verdict"
    ],
    "verdicts": [
        "verdict"
    ],
    "verdie": [
        "verdir",
        "verdi"
    ],
    "verdier": [
        "verdier"
    ],
    "verdiers": [
        "verdier"
    ],
    "verdies": [
        "verdir",
        "verdi"
    ],
    "verdine": [
        "verdin"
    ],
    "verdir": [
        "verdir"
    ],
    "verdis": [
        "verdir",
        "verdi"
    ],
    "verdissaient": [
        "verdir"
    ],
    "verdissait": [
        "verdir"
    ],
    "verdissant": [
        "verdissant"
    ],
    "verdissante": [
        "verdissant"
    ],
    "verdissants": [
        "verdissant"
    ],
    "verdissent": [
        "verdir"
    ],
    "verdit": [
        "verdir"
    ],
    "verdoie": [
        "verdoyer"
    ],
    "verdoiement": [
        "verdoiement"
    ],
    "verdoient": [
        "verdoyer"
    ],
    "verdoyant": [
        "verdoyant",
        "verdoyer"
    ],
    "verdoyante": [
        "verdoyant"
    ],
    "verdoyantes": [
        "verdoyant"
    ],
    "verdoyants": [
        "verdoyant"
    ],
    "verdoyer": [
        "verdoyer"
    ],
    "verdure": [
        "verdure"
    ],
    "verdures": [
        "verdure"
    ],
    "verdatre": [
        "verdatre"
    ],
    "verdatres": [
        "verdatre"
    ],
    "verge": [
        "verge"
    ],
    "vergence": [
        "vergence"
    ],
    "verger": [
        "verger"
    ],
    "vergers": [
        "verger"
    ],
    "verges": [
        "verge"
    ],
    "vergeture": [
        "vergeture"
    ],
    "vergetures": [
        "vergeture"
    ],
    "verglace": [
        "verglace",
        "verglacer"
    ],
    "verglacee": [
        "verglace",
        "verglacer"
    ],
    "verglacees": [
        "verglace",
        "verglacer"
    ],
    "verglas": [
        "verglas"
    ],
    "vergne": [
        "vergne"
    ],
    "vergnes": [
        "vergne"
    ],
    "vergogne": [
        "vergogne"
    ],
    "vergogneux": [
        "vergogneux"
    ],
    "vergue": [
        "vergue"
    ],
    "vergues": [
        "vergue"
    ],
    "verjus": [
        "verjus"
    ],
    "verlan": [
        "verlan"
    ],
    "vermeil": [
        "vermeil"
    ],
    "vermeille": [
        "vermeil"
    ],
    "vermeilles": [
        "vermeil"
    ],
    "vermeils": [
        "vermeil"
    ],
    "vermicelle": [
        "vermicelle"
    ],
    "vermicelles": [
        "vermicelle"
    ],
    "vermiculaire": [
        "vermiculaire"
    ],
    "vermiculaires": [
        "vermiculaire"
    ],
    "vermiculees": [
        "vermicule"
    ],
    "vermifuge": [
        "vermifuge"
    ],
    "vermillon": [
        "vermillon"
    ],
    "vermillonnait": [
        "vermillonner"
    ],
    "vermillonnee": [
        "vermillonner"
    ],
    "vermillonnes": [
        "vermillonner"
    ],
    "vermillons": [
        "vermillon"
    ],
    "vermine": [
        "vermine"
    ],
    "vermines": [
        "vermine"
    ],
    "vermineux": [
        "vermineux"
    ],
    "vermisseau": [
        "vermisseau"
    ],
    "vermisseaux": [
        "vermisseau"
    ],
    "vermoulu": [
        "vermoulu"
    ],
    "vermoulue": [
        "vermoulu"
    ],
    "vermoulues": [
        "vermoulu"
    ],
    "vermoulure": [
        "vermoulure"
    ],
    "vermoulures": [
        "vermoulure"
    ],
    "vermoulus": [
        "vermoulu"
    ],
    "vermout": [
        "vermout"
    ],
    "vermouth": [
        "vermouth"
    ],
    "vermouths": [
        "vermouth"
    ],
    "vernaculaire": [
        "vernaculaire"
    ],
    "vernal": [
        "vernal"
    ],
    "verne": [
        "verne"
    ],
    "verni": [
        "vernir",
        "verni"
    ],
    "vernie": [
        "vernir",
        "verni"
    ],
    "vernier": [
        "vernier"
    ],
    "vernies": [
        "vernir",
        "verni"
    ],
    "vernir": [
        "vernir"
    ],
    "vernis": [
        "vernir",
        "vernis"
    ],
    "vernissage": [
        "vernissage"
    ],
    "vernissages": [
        "vernissage"
    ],
    "vernissaient": [
        "vernir"
    ],
    "vernissait": [
        "vernir"
    ],
    "vernissant": [
        "vernir"
    ],
    "vernissent": [
        "vernir"
    ],
    "vernisser": [
        "vernisser"
    ],
    "vernisseur": [
        "vernisseur"
    ],
    "vernisse": [
        "vernisser",
        "vernisse"
    ],
    "vernissee": [
        "vernisser",
        "vernisse"
    ],
    "vernissees": [
        "vernisser",
        "vernisse"
    ],
    "vernisses": [
        "vernisser",
        "vernisse"
    ],
    "vernit": [
        "vernir"
    ],
    "verra": [
        "voir"
    ],
    "verrai": [
        "voir"
    ],
    "verraient": [
        "voir"
    ],
    "verrais": [
        "voir"
    ],
    "verrait": [
        "voir"
    ],
    "verras": [
        "voir"
    ],
    "verrat": [
        "verrat"
    ],
    "verrats": [
        "verrat"
    ],
    "verre": [
        "verre"
    ],
    "verrerie": [
        "verrerie"
    ],
    "verreries": [
        "verrerie"
    ],
    "verres": [
        "verre"
    ],
    "verrez": [
        "voir"
    ],
    "verrier": [
        "verrier"
    ],
    "verriers": [
        "verrier"
    ],
    "verriez": [
        "voir"
    ],
    "verrions": [
        "voir"
    ],
    "verriere": [
        "verriere"
    ],
    "verrieres": [
        "verriere"
    ],
    "verrons": [
        "voir"
    ],
    "verront": [
        "voir"
    ],
    "verroterie": [
        "verroterie"
    ],
    "verroteries": [
        "verroterie"
    ],
    "verrou": [
        "verrou"
    ],
    "verrouilla": [
        "verrouiller"
    ],
    "verrouillage": [
        "verrouillage"
    ],
    "verrouillai": [
        "verrouiller"
    ],
    "verrouillait": [
        "verrouiller"
    ],
    "verrouillant": [
        "verrouiller"
    ],
    "verrouille": [
        "verrouille",
        "verrouiller"
    ],
    "verrouillent": [
        "verrouiller"
    ],
    "verrouiller": [
        "verrouiller"
    ],
    "verrouilles": [
        "verrouille",
        "verrouiller"
    ],
    "verrouillez": [
        "verrouiller"
    ],
    "verrouillons": [
        "verrouiller"
    ],
    "verrouillerent": [
        "verrouiller"
    ],
    "verrouillee": [
        "verrouille",
        "verrouiller"
    ],
    "verrouillees": [
        "verrouille",
        "verrouiller"
    ],
    "verrous": [
        "verrou"
    ],
    "verrue": [
        "verrue"
    ],
    "verrues": [
        "verrue"
    ],
    "verruqueuse": [
        "verruqueux"
    ],
    "vers": [
        "vers"
    ],
    "versa": [
        "verser"
    ],
    "versai": [
        "verser"
    ],
    "versaient": [
        "verser"
    ],
    "versaillais": [
        "versaillais"
    ],
    "versaillaise": [
        "versaillais"
    ],
    "versais": [
        "verser"
    ],
    "versait": [
        "verser"
    ],
    "versant": [
        "versant",
        "verser"
    ],
    "versants": [
        "versant"
    ],
    "versatile": [
        "versatile"
    ],
    "versatiles": [
        "versatile"
    ],
    "versatilite": [
        "versatilite"
    ],
    "verse": [
        "verse",
        "verser"
    ],
    "verseau": [
        "verseau"
    ],
    "versement": [
        "versement"
    ],
    "versements": [
        "versement"
    ],
    "versent": [
        "verser"
    ],
    "verser": [
        "verser"
    ],
    "versera": [
        "verser"
    ],
    "verserai": [
        "verser"
    ],
    "verserais": [
        "verser"
    ],
    "verserait": [
        "verser"
    ],
    "verseras": [
        "verser"
    ],
    "verserez": [
        "verser"
    ],
    "verseriez": [
        "verser"
    ],
    "verserons": [
        "verser"
    ],
    "verseront": [
        "verser"
    ],
    "verses": [
        "verse",
        "verser"
    ],
    "verset": [
        "verset"
    ],
    "versets": [
        "verset"
    ],
    "verseur": [
        "verseur"
    ],
    "verseurs": [
        "verseur"
    ],
    "verseuse": [
        "verseur"
    ],
    "verseuses": [
        "verseur"
    ],
    "versez": [
        "verser"
    ],
    "versicolores": [
        "versicolore"
    ],
    "versiculets": [
        "versiculet"
    ],
    "versiez": [
        "verser"
    ],
    "versificateur": [
        "versificateur"
    ],
    "versification": [
        "versification"
    ],
    "versifier": [
        "versifier"
    ],
    "versifiees": [
        "versifie"
    ],
    "version": [
        "version"
    ],
    "versions": [
        "version",
        "verser"
    ],
    "verso": [
        "verso"
    ],
    "versons": [
        "verser"
    ],
    "versos": [
        "verso"
    ],
    "verstes": [
        "verste"
    ],
    "versus": [
        "versus"
    ],
    "versames": [
        "verser"
    ],
    "versat": [
        "verser"
    ],
    "verserent": [
        "verser"
    ],
    "versee": [
        "verse",
        "verser"
    ],
    "versees": [
        "verse",
        "verser"
    ],
    "vert": [
        "vert"
    ],
    "verte": [
        "vert"
    ],
    "vertement": [
        "vertement"
    ],
    "vertes": [
        "vert"
    ],
    "vertex": [
        "vertex"
    ],
    "vertical": [
        "vertical"
    ],
    "verticale": [
        "vertical",
        "verticale"
    ],
    "verticalement": [
        "verticalement"
    ],
    "verticales": [
        "vertical",
        "verticale"
    ],
    "verticalite": [
        "verticalite"
    ],
    "verticaux": [
        "vertical"
    ],
    "verticille": [
        "verticille"
    ],
    "vertige": [
        "vertige"
    ],
    "vertiges": [
        "vertige"
    ],
    "vertigineuse": [
        "vertigineux"
    ],
    "vertigineusement": [
        "vertigineusement"
    ],
    "vertigineuses": [
        "vertigineux"
    ],
    "vertigineux": [
        "vertigineux"
    ],
    "vertigo": [
        "vertigo"
    ],
    "verts": [
        "vert"
    ],
    "vertu": [
        "vertu"
    ],
    "vertubleu": [
        "vertubleu"
    ],
    "vertueuse": [
        "vertueux"
    ],
    "vertueusement": [
        "vertueusement"
    ],
    "vertueuses": [
        "vertueux"
    ],
    "vertueux": [
        "vertueux"
    ],
    "vertugadin": [
        "vertugadin"
    ],
    "vertus": [
        "vertu"
    ],
    "vertebre": [
        "vertebre"
    ],
    "vertebres": [
        "vertebre"
    ],
    "vertebral": [
        "vertebral"
    ],
    "vertebrale": [
        "vertebral"
    ],
    "vertebrales": [
        "vertebral"
    ],
    "vertebraux": [
        "vertebral"
    ],
    "verve": [
        "verve"
    ],
    "verveine": [
        "verveine"
    ],
    "verveux": [
        "verveux"
    ],
    "vesce": [
        "vesce"
    ],
    "vesces": [
        "vesce"
    ],
    "vespa": [
        "vespa"
    ],
    "vespas": [
        "vespa"
    ],
    "vespasienne": [
        "vespasien",
        "vespasienne"
    ],
    "vespasiennes": [
        "vespasien"
    ],
    "vespree": [
        "vespree"
    ],
    "vesperal": [
        "vesperal"
    ],
    "vesperale": [
        "vesperal"
    ],
    "vesperales": [
        "vesperal"
    ],
    "vesperaux": [
        "vesperal"
    ],
    "vesses": [
        "vesse"
    ],
    "vessie": [
        "vessie"
    ],
    "vessies": [
        "vessie"
    ],
    "vestalat": [
        "vestalat"
    ],
    "vestale": [
        "vestale"
    ],
    "vestales": [
        "vestale"
    ],
    "veste": [
        "veste"
    ],
    "vestes": [
        "veste"
    ],
    "vestiaire": [
        "vestiaire"
    ],
    "vestiaires": [
        "vestiaire"
    ],
    "vestibule": [
        "vestibule"
    ],
    "vestibules": [
        "vestibule"
    ],
    "vestige": [
        "vestige"
    ],
    "vestiges": [
        "vestige"
    ],
    "vestimentaire": [
        "vestimentaire"
    ],
    "vestimentaires": [
        "vestimentaire"
    ],
    "veston": [
        "veston"
    ],
    "vestons": [
        "veston"
    ],
    "veto": [
        "veto"
    ],
    "veuf": [
        "veuf"
    ],
    "veufs": [
        "veuf"
    ],
    "veuille": [
        "vouloir"
    ],
    "veuillent": [
        "vouloir"
    ],
    "veuilles": [
        "vouloir"
    ],
    "veuillez": [
        "vouloir"
    ],
    "veule": [
        "veule"
    ],
    "veulent": [
        "vouloir"
    ],
    "veulerie": [
        "veulerie"
    ],
    "veuleries": [
        "veulerie"
    ],
    "veules": [
        "veule"
    ],
    "veut": [
        "vouloir"
    ],
    "veuvage": [
        "veuvage"
    ],
    "veuvages": [
        "veuvage"
    ],
    "veuve": [
        "veuf"
    ],
    "veuves": [
        "veuf"
    ],
    "veux": [
        "vouloir"
    ],
    "vexa": [
        "vexer"
    ],
    "vexai": [
        "vexer"
    ],
    "vexait": [
        "vexer"
    ],
    "vexant": [
        "vexant",
        "vexer"
    ],
    "vexante": [
        "vexant"
    ],
    "vexantes": [
        "vexant"
    ],
    "vexants": [
        "vexant"
    ],
    "vexation": [
        "vexation"
    ],
    "vexations": [
        "vexation"
    ],
    "vexatoire": [
        "vexatoire"
    ],
    "vexatoires": [
        "vexatoire"
    ],
    "vexe": [
        "vexer",
        "vexe"
    ],
    "vexent": [
        "vexer"
    ],
    "vexer": [
        "vexer"
    ],
    "vexera": [
        "vexer"
    ],
    "vexerai": [
        "vexer"
    ],
    "vexerait": [
        "vexer"
    ],
    "vexeras": [
        "vexer"
    ],
    "vexerez": [
        "vexer"
    ],
    "vexerions": [
        "vexer"
    ],
    "vexes": [
        "vexer",
        "vexe",
        "vex"
    ],
    "vexez": [
        "vexer"
    ],
    "vexons": [
        "vexer"
    ],
    "vexee": [
        "vexer",
        "vexe"
    ],
    "vexees": [
        "vexer",
        "vexe"
    ],
    "via": [
        "via"
    ],
    "viabilite": [
        "viabilite"
    ],
    "viable": [
        "viable"
    ],
    "viables": [
        "viable"
    ],
    "viaduc": [
        "viaduc"
    ],
    "viager": [
        "viager"
    ],
    "viagra": [
        "viagra"
    ],
    "viagere": [
        "viager"
    ],
    "viandard": [
        "viandard"
    ],
    "viandasse": [
        "viander"
    ],
    "viande": [
        "viander",
        "viande"
    ],
    "viander": [
        "viander"
    ],
    "viandes": [
        "viande"
    ],
    "viandeuse": [
        "viandeux"
    ],
    "viandox": [
        "viandox"
    ],
    "viatique": [
        "viatique"
    ],
    "vibra": [
        "vibrer"
    ],
    "vibraient": [
        "vibrer"
    ],
    "vibrais": [
        "vibrer"
    ],
    "vibrait": [
        "vibrer"
    ],
    "vibrant": [
        "vibrant",
        "vibrer"
    ],
    "vibrante": [
        "vibrant"
    ],
    "vibrantes": [
        "vibrant"
    ],
    "vibrants": [
        "vibrant"
    ],
    "vibraphone": [
        "vibraphone"
    ],
    "vibraphones": [
        "vibraphone"
    ],
    "vibrateur": [
        "vibrateur"
    ],
    "vibrateurs": [
        "vibrateur"
    ],
    "vibratile": [
        "vibratile"
    ],
    "vibratiles": [
        "vibratile"
    ],
    "vibration": [
        "vibration"
    ],
    "vibrations": [
        "vibration"
    ],
    "vibrato": [
        "vibrato"
    ],
    "vibratoire": [
        "vibratoire"
    ],
    "vibratoires": [
        "vibratoire"
    ],
    "vibratos": [
        "vibrato"
    ],
    "vibre": [
        "vibrer"
    ],
    "vibrent": [
        "vibrer"
    ],
    "vibrer": [
        "vibrer"
    ],
    "vibrera": [
        "vibrer"
    ],
    "vibreur": [
        "vibreur"
    ],
    "vibrez": [
        "vibrer"
    ],
    "vibrionnaient": [
        "vibrionner"
    ],
    "vibrionnait": [
        "vibrionner"
    ],
    "vibrionnant": [
        "vibrionner"
    ],
    "vibrionne": [
        "vibrionner"
    ],
    "vibrions": [
        "vibrion"
    ],
    "vibrisses": [
        "vibrisse"
    ],
    "vibromasseur": [
        "vibromasseur"
    ],
    "vibromasseurs": [
        "vibromasseur"
    ],
    "vibree": [
        "vibrer"
    ],
    "vibrees": [
        "vibrer"
    ],
    "vibura": [
        "viburer"
    ],
    "viburait": [
        "viburer"
    ],
    "vibure": [
        "viburer"
    ],
    "vicaire": [
        "vicaire"
    ],
    "vicaires": [
        "vicaire"
    ],
    "vice": [
        "vice"
    ],
    "vicelard": [
        "vicelard"
    ],
    "vicelarde": [
        "vicelard"
    ],
    "vicelardes": [
        "vicelard"
    ],
    "vicelardise": [
        "vicelardise"
    ],
    "vicelardises": [
        "vicelardise"
    ],
    "vicelards": [
        "vicelard"
    ],
    "vices": [
        "vice"
    ],
    "vichy": [
        "vichy"
    ],
    "vichysme": [
        "vichysme"
    ],
    "vichyssois": [
        "vichyssois"
    ],
    "vichyssoise": [
        "vichyssois"
    ],
    "vichyste": [
        "vichyste"
    ],
    "vichystes": [
        "vichyste"
    ],
    "vicier": [
        "vicier"
    ],
    "vicieuse": [
        "vicieux"
    ],
    "vicieusement": [
        "vicieusement"
    ],
    "vicieuses": [
        "vicieux"
    ],
    "vicieux": [
        "vicieux"
    ],
    "vicinal": [
        "vicinal"
    ],
    "vicinales": [
        "vicinal"
    ],
    "vicinalite": [
        "vicinalite"
    ],
    "vicinaux": [
        "vicinal"
    ],
    "vicissitude": [
        "vicissitude"
    ],
    "vicissitudes": [
        "vicissitude"
    ],
    "vicie": [
        "vicier",
        "vicie"
    ],
    "viciee": [
        "vicier"
    ],
    "vicies": [
        "vicie"
    ],
    "vicomte": [
        "vicomte"
    ],
    "vicomtes": [
        "vicomte"
    ],
    "vicomtesse": [
        "vicomte"
    ],
    "vicomtesses": [
        "vicomte"
    ],
    "victimaire": [
        "victimaire"
    ],
    "victime": [
        "victime"
    ],
    "victimes": [
        "victime"
    ],
    "victimologie": [
        "victimologie"
    ],
    "victoire": [
        "victoire"
    ],
    "victoires": [
        "victoire"
    ],
    "victoria": [
        "victoria"
    ],
    "victorias": [
        "victoria"
    ],
    "victorien": [
        "victorien"
    ],
    "victorienne": [
        "victorien"
    ],
    "victoriennes": [
        "victorien"
    ],
    "victoriens": [
        "victorien"
    ],
    "victorieuse": [
        "victorieux"
    ],
    "victorieusement": [
        "victorieusement"
    ],
    "victorieuses": [
        "victorieux"
    ],
    "victorieux": [
        "victorieux"
    ],
    "victuaille": [
        "victuaille"
    ],
    "victuailles": [
        "victuaille"
    ],
    "vida": [
        "vider"
    ],
    "vidage": [
        "vidage"
    ],
    "vidai": [
        "vider"
    ],
    "vidaient": [
        "vider"
    ],
    "vidais": [
        "vider"
    ],
    "vidait": [
        "vider"
    ],
    "vidame": [
        "vidame"
    ],
    "vidange": [
        "vidanger",
        "vidange"
    ],
    "vidanger": [
        "vidanger"
    ],
    "vidanges": [
        "vidange"
    ],
    "vidangeur": [
        "vidangeur"
    ],
    "vidangeurs": [
        "vidangeur"
    ],
    "vidangez": [
        "vidanger"
    ],
    "vidangee": [
        "vidanger"
    ],
    "vidant": [
        "vider"
    ],
    "vidas": [
        "vider"
    ],
    "vide": [
        "vider",
        "vide"
    ],
    "vident": [
        "vider"
    ],
    "vider": [
        "vider"
    ],
    "videra": [
        "vider"
    ],
    "viderai": [
        "vider"
    ],
    "viderais": [
        "vider"
    ],
    "viderait": [
        "vider"
    ],
    "videras": [
        "vider"
    ],
    "viderions": [
        "vider"
    ],
    "videront": [
        "vider"
    ],
    "vides": [
        "vider",
        "vide"
    ],
    "videur": [
        "videur"
    ],
    "videurs": [
        "videur"
    ],
    "videz": [
        "vider"
    ],
    "vidicon": [
        "vidicon"
    ],
    "vidiez": [
        "vider"
    ],
    "vidons": [
        "vider"
    ],
    "viduite": [
        "viduite"
    ],
    "vidures": [
        "vidure"
    ],
    "viderent": [
        "vider"
    ],
    "videaste": [
        "videaste"
    ],
    "videastes": [
        "videaste"
    ],
    "videe": [
        "vider",
        "vide"
    ],
    "videes": [
        "vider",
        "vide"
    ],
    "video": [
        "video"
    ],
    "videocassette": [
        "videocassette"
    ],
    "videocassettes": [
        "videocassette"
    ],
    "videoclip": [
        "videoclip"
    ],
    "videoclub": [
        "videoclub"
    ],
    "videoconference": [
        "videoconference"
    ],
    "videogramme": [
        "videogramme"
    ],
    "videophone": [
        "videophone"
    ],
    "videophonie": [
        "videophonie"
    ],
    "videos": [
        "video"
    ],
    "videosurveillance": [
        "videosurveillance"
    ],
    "videotheque": [
        "videotheque"
    ],
    "vie": [
        "vie"
    ],
    "vieil": [
        "vieil"
    ],
    "vieillard": [
        "vieillard"
    ],
    "vieillarde": [
        "vieillard"
    ],
    "vieillardes": [
        "vieillard"
    ],
    "vieillards": [
        "vieillard"
    ],
    "vieille": [
        "vieux"
    ],
    "vieillerie": [
        "vieillerie"
    ],
    "vieilleries": [
        "vieillerie"
    ],
    "vieilles": [
        "vieux"
    ],
    "vieillesse": [
        "vieillesse"
    ],
    "vieillesses": [
        "vieillesse"
    ],
    "vieilli": [
        "vieilli",
        "vieillir"
    ],
    "vieillie": [
        "vieilli",
        "vieillir"
    ],
    "vieillies": [
        "vieilli",
        "vieillir"
    ],
    "vieillir": [
        "vieillir"
    ],
    "vieillira": [
        "vieillir"
    ],
    "vieillirai": [
        "vieillir"
    ],
    "vieilliraient": [
        "vieillir"
    ],
    "vieillirais": [
        "vieillir"
    ],
    "vieillirait": [
        "vieillir"
    ],
    "vieilliras": [
        "vieillir"
    ],
    "vieillirent": [
        "vieillir"
    ],
    "vieillirez": [
        "vieillir"
    ],
    "vieillirons": [
        "vieillir"
    ],
    "vieilliront": [
        "vieillir"
    ],
    "vieillis": [
        "vieilli",
        "vieillir"
    ],
    "vieillissaient": [
        "vieillir"
    ],
    "vieillissais": [
        "vieillir"
    ],
    "vieillissait": [
        "vieillir"
    ],
    "vieillissant": [
        "vieillissant",
        "vieillir"
    ],
    "vieillissante": [
        "vieillissant"
    ],
    "vieillissantes": [
        "vieillissant"
    ],
    "vieillissants": [
        "vieillissant"
    ],
    "vieillisse": [
        "vieillir"
    ],
    "vieillissement": [
        "vieillissement"
    ],
    "vieillissent": [
        "vieillir"
    ],
    "vieillissez": [
        "vieillir"
    ],
    "vieillissiez": [
        "vieillir"
    ],
    "vieillissions": [
        "vieillir"
    ],
    "vieillissons": [
        "vieillir"
    ],
    "vieillit": [
        "vieillir"
    ],
    "vieillot": [
        "vieillot"
    ],
    "vieillots": [
        "vieillot"
    ],
    "vieillotte": [
        "vieillot"
    ],
    "vieillottes": [
        "vieillot"
    ],
    "vielle": [
        "vielle"
    ],
    "vielles": [
        "vielle"
    ],
    "vielleux": [
        "vielleux"
    ],
    "viendra": [
        "venir"
    ],
    "viendrai": [
        "venir"
    ],
    "viendraient": [
        "venir"
    ],
    "viendrais": [
        "venir"
    ],
    "viendrait": [
        "venir"
    ],
    "viendras": [
        "venir"
    ],
    "viendrez": [
        "venir"
    ],
    "viendriez": [
        "venir"
    ],
    "viendrions": [
        "venir"
    ],
    "viendrons": [
        "venir"
    ],
    "viendront": [
        "venir"
    ],
    "vienne": [
        "venir"
    ],
    "viennent": [
        "venir"
    ],
    "viennes": [
        "venir"
    ],
    "viennois": [
        "viennois"
    ],
    "viennoise": [
        "viennois"
    ],
    "viennoiserie": [
        "viennoiserie"
    ],
    "viennoiseries": [
        "viennoiserie"
    ],
    "viennoises": [
        "viennois"
    ],
    "viens": [
        "venir"
    ],
    "vient": [
        "venir"
    ],
    "vierge": [
        "vierge"
    ],
    "vierges": [
        "vierge"
    ],
    "vies": [
        "vie"
    ],
    "vietnamien": [
        "vietnamien"
    ],
    "vietnamienne": [
        "vietnamien"
    ],
    "vietnamiennes": [
        "vietnamien"
    ],
    "vietnamiens": [
        "vietnamien"
    ],
    "vieux": [
        "vieux"
    ],
    "vif": [
        "vif"
    ],
    "vifs": [
        "vif"
    ],
    "vigie": [
        "vigie"
    ],
    "vigies": [
        "vigie"
    ],
    "vigil": [
        "vigil"
    ],
    "vigilance": [
        "vigilance"
    ],
    "vigilances": [
        "vigilance"
    ],
    "vigilant": [
        "vigiler",
        "vigilant"
    ],
    "vigilante": [
        "vigilant"
    ],
    "vigilantes": [
        "vigilante",
        "vigilant"
    ],
    "vigilants": [
        "vigilant"
    ],
    "vigile": [
        "vigil",
        "vigile"
    ],
    "vigiler": [
        "vigiler"
    ],
    "vigiles": [
        "vigil",
        "vigile"
    ],
    "vigne": [
        "vigne"
    ],
    "vigneaux": [
        "vigneau"
    ],
    "vigneron": [
        "vigneron"
    ],
    "vigneronne": [
        "vigneron"
    ],
    "vigneronnes": [
        "vigneron"
    ],
    "vignerons": [
        "vigneron"
    ],
    "vignes": [
        "vigne"
    ],
    "vignette": [
        "vignette"
    ],
    "vignettes": [
        "vignette"
    ],
    "vignoble": [
        "vignoble"
    ],
    "vignobles": [
        "vignoble"
    ],
    "vigogne": [
        "vigogne"
    ],
    "vigoureuse": [
        "vigoureux"
    ],
    "vigoureusement": [
        "vigoureusement"
    ],
    "vigoureuses": [
        "vigoureux"
    ],
    "vigoureux": [
        "vigoureux"
    ],
    "vigousse": [
        "vigousse"
    ],
    "vigueur": [
        "vigueur"
    ],
    "vigueurs": [
        "vigueur"
    ],
    "viguier": [
        "viguier"
    ],
    "viguiers": [
        "viguier"
    ],
    "viking": [
        "viking"
    ],
    "vikings": [
        "viking"
    ],
    "vil": [
        "vil"
    ],
    "vilain": [
        "vilain"
    ],
    "vilaine": [
        "vilain"
    ],
    "vilainement": [
        "vilainement"
    ],
    "vilaines": [
        "vilain"
    ],
    "vilains": [
        "vilain"
    ],
    "vile": [
        "vil"
    ],
    "vilebrequin": [
        "vilebrequin"
    ],
    "vilebrequins": [
        "vilebrequin"
    ],
    "vilement": [
        "vilement"
    ],
    "vilenie": [
        "vilenie"
    ],
    "vilenies": [
        "vilenie"
    ],
    "viles": [
        "vil"
    ],
    "vilipendaient": [
        "vilipender"
    ],
    "vilipendant": [
        "vilipender"
    ],
    "vilipender": [
        "vilipender"
    ],
    "vilipende": [
        "vilipende",
        "vilipender"
    ],
    "vilipendees": [
        "vilipende",
        "vilipender"
    ],
    "vilipendes": [
        "vilipender"
    ],
    "villa": [
        "villa"
    ],
    "village": [
        "village"
    ],
    "villageois": [
        "villageois"
    ],
    "villageoise": [
        "villageois"
    ],
    "villageoises": [
        "villageois"
    ],
    "villages": [
        "village"
    ],
    "villas": [
        "villa"
    ],
    "ville": [
        "ville"
    ],
    "villes": [
        "ville"
    ],
    "villette": [
        "villette"
    ],
    "villegiaturait": [
        "villegiaturer"
    ],
    "villegiature": [
        "villegiature",
        "villegiaturer"
    ],
    "villegiaturer": [
        "villegiaturer"
    ],
    "villegiatures": [
        "villegiature"
    ],
    "vils": [
        "vil"
    ],
    "vin": [
        "vin"
    ],
    "vina": [
        "vina"
    ],
    "vinaigre": [
        "vinaigrer",
        "vinaigre"
    ],
    "vinaigrer": [
        "vinaigrer"
    ],
    "vinaigres": [
        "vinaigre"
    ],
    "vinaigrette": [
        "vinaigrette"
    ],
    "vinaigree": [
        "vinaigrer"
    ],
    "vinasse": [
        "vinasse"
    ],
    "vindicatif": [
        "vindicatif"
    ],
    "vindicatifs": [
        "vindicatif"
    ],
    "vindicative": [
        "vindicatif"
    ],
    "vindicativement": [
        "vindicativement"
    ],
    "vindicatives": [
        "vindicatif"
    ],
    "vindicte": [
        "vindicte"
    ],
    "vine": [
        "viner"
    ],
    "viner": [
        "viner"
    ],
    "vines": [
        "vine",
        "viner"
    ],
    "vineuse": [
        "vineux"
    ],
    "vineuses": [
        "vineux"
    ],
    "vineux": [
        "vineux"
    ],
    "vinez": [
        "viner"
    ],
    "vingt": [
        "vingt"
    ],
    "vingtaine": [
        "vingtaine"
    ],
    "vingtaines": [
        "vingtaine"
    ],
    "vingtieme": [
        "vingtieme"
    ],
    "vingtiemes": [
        "vingtieme"
    ],
    "vinicole": [
        "vinicole"
    ],
    "vinificatrice": [
        "vinificateur"
    ],
    "vinrent": [
        "venir"
    ],
    "vins": [
        "venir",
        "vin",
        "vins"
    ],
    "vinsse": [
        "venir"
    ],
    "vinssent": [
        "venir"
    ],
    "vint": [
        "venir"
    ],
    "vintage": [
        "vintage"
    ],
    "vinyle": [
        "vinyle"
    ],
    "vinyles": [
        "vinyle"
    ],
    "vinylique": [
        "vinylique"
    ],
    "vioc": [
        "vioc"
    ],
    "viocard": [
        "viocard"
    ],
    "viocque": [
        "viocque"
    ],
    "viocs": [
        "vioc"
    ],
    "viol": [
        "viol"
    ],
    "viola": [
        "violer"
    ],
    "violacer": [
        "violacer"
    ],
    "violace": [
        "violacer",
        "violace"
    ],
    "violacee": [
        "violacer",
        "violace"
    ],
    "violacees": [
        "violacer",
        "violace"
    ],
    "violaces": [
        "violacer",
        "violace"
    ],
    "violaient": [
        "violer"
    ],
    "violais": [
        "violer"
    ],
    "violait": [
        "violer"
    ],
    "violant": [
        "violer"
    ],
    "violation": [
        "violation"
    ],
    "violations": [
        "violation"
    ],
    "violacait": [
        "violacer"
    ],
    "viole": [
        "viole",
        "violer"
    ],
    "violemment": [
        "violemment"
    ],
    "violence": [
        "violence"
    ],
    "violences": [
        "violence"
    ],
    "violent": [
        "violent",
        "violer"
    ],
    "violentaient": [
        "violenter"
    ],
    "violentait": [
        "violenter"
    ],
    "violente": [
        "violent",
        "violenter"
    ],
    "violenter": [
        "violenter"
    ],
    "violentes": [
        "violent"
    ],
    "violents": [
        "violent"
    ],
    "violentee": [
        "violenter"
    ],
    "violer": [
        "violer"
    ],
    "violerai": [
        "violer"
    ],
    "violerais": [
        "violer"
    ],
    "violerait": [
        "violer"
    ],
    "violeras": [
        "violer"
    ],
    "violeront": [
        "violer"
    ],
    "violes": [
        "viole",
        "violer"
    ],
    "violet": [
        "violet"
    ],
    "violeta": [
        "violeter"
    ],
    "violets": [
        "violet"
    ],
    "violette": [
        "violet",
        "violette"
    ],
    "violettes": [
        "violet",
        "violette"
    ],
    "violeur": [
        "violeur"
    ],
    "violeurs": [
        "violeur"
    ],
    "violeuses": [
        "violeur"
    ],
    "violez": [
        "violer"
    ],
    "violine": [
        "violine"
    ],
    "violines": [
        "violine"
    ],
    "violon": [
        "violon"
    ],
    "violoncelle": [
        "violoncelle"
    ],
    "violoncelles": [
        "violoncelle"
    ],
    "violoncelliste": [
        "violoncelliste"
    ],
    "violoncellistes": [
        "violoncelliste"
    ],
    "violone": [
        "violoner"
    ],
    "violoneux": [
        "violoneux"
    ],
    "violoniste": [
        "violoniste"
    ],
    "violonistes": [
        "violoniste"
    ],
    "violons": [
        "violer",
        "violon"
    ],
    "viols": [
        "viol"
    ],
    "violatre": [
        "violatre"
    ],
    "violatres": [
        "violatre"
    ],
    "violee": [
        "violer"
    ],
    "violees": [
        "violer"
    ],
    "vioque": [
        "vioque"
    ],
    "vioques": [
        "vioque"
    ],
    "viorne": [
        "viorne"
    ],
    "viornes": [
        "viorne"
    ],
    "vipere": [
        "vipere"
    ],
    "viperes": [
        "vipere"
    ],
    "vipereau": [
        "vipereau"
    ],
    "viperine": [
        "viperin"
    ],
    "viperines": [
        "viperin"
    ],
    "vira": [
        "virer"
    ],
    "virage": [
        "virage"
    ],
    "virages": [
        "virage"
    ],
    "virago": [
        "virago"
    ],
    "viragos": [
        "virago"
    ],
    "virai": [
        "virer"
    ],
    "viraient": [
        "virer"
    ],
    "virais": [
        "virer"
    ],
    "virait": [
        "virer"
    ],
    "viral": [
        "viral"
    ],
    "virale": [
        "viral"
    ],
    "virales": [
        "viral"
    ],
    "virant": [
        "virer"
    ],
    "viraux": [
        "viral"
    ],
    "vire": [
        "vire",
        "virer"
    ],
    "virement": [
        "virement"
    ],
    "virements": [
        "virement"
    ],
    "virent": [
        "virer"
    ],
    "virer": [
        "virer"
    ],
    "virera": [
        "virer"
    ],
    "virerai": [
        "virer"
    ],
    "virerais": [
        "virer"
    ],
    "virerait": [
        "virer"
    ],
    "vireras": [
        "virer"
    ],
    "virerez": [
        "virer"
    ],
    "vireront": [
        "virer"
    ],
    "vires": [
        "vire",
        "virer"
    ],
    "vireuse": [
        "vireux"
    ],
    "virevolta": [
        "virevolter"
    ],
    "virevoltaient": [
        "virevolter"
    ],
    "virevoltait": [
        "virevolter"
    ],
    "virevoltant": [
        "virevoltant",
        "virevolter"
    ],
    "virevoltante": [
        "virevoltant"
    ],
    "virevoltantes": [
        "virevoltant"
    ],
    "virevolte": [
        "virevolte",
        "virevolter"
    ],
    "virevoltent": [
        "virevolter"
    ],
    "virevolter": [
        "virevolter"
    ],
    "virevoltes": [
        "virevolte",
        "virevolter"
    ],
    "virez": [
        "virer"
    ],
    "virgilien": [
        "virgilien"
    ],
    "virgilienne": [
        "virgilien"
    ],
    "virginal": [
        "virginal"
    ],
    "virginale": [
        "virginal"
    ],
    "virginalement": [
        "virginalement"
    ],
    "virginales": [
        "virginal"
    ],
    "virginaux": [
        "virginal"
    ],
    "virginie": [
        "virginie"
    ],
    "virginien": [
        "virginien"
    ],
    "virginiens": [
        "virginien"
    ],
    "virginite": [
        "virginite"
    ],
    "virginites": [
        "virginite"
    ],
    "virgule": [
        "virgule"
    ],
    "virgules": [
        "virgule"
    ],
    "viriez": [
        "virer"
    ],
    "viril": [
        "viril"
    ],
    "virile": [
        "viril"
    ],
    "virilement": [
        "virilement"
    ],
    "viriles": [
        "viril"
    ],
    "virilise": [
        "viriliser"
    ],
    "viriliser": [
        "viriliser"
    ],
    "virilises": [
        "viriliser"
    ],
    "virilite": [
        "virilite"
    ],
    "virilites": [
        "virilite"
    ],
    "virils": [
        "viril"
    ],
    "viroles": [
        "virole"
    ],
    "virolet": [
        "virolet"
    ],
    "virologie": [
        "virologie"
    ],
    "virologiste": [
        "virologiste"
    ],
    "virologue": [
        "virologue"
    ],
    "virologues": [
        "virologue"
    ],
    "virons": [
        "virer"
    ],
    "virtualite": [
        "virtualite"
    ],
    "virtualites": [
        "virtualite"
    ],
    "virtuel": [
        "virtuel"
    ],
    "virtuelle": [
        "virtuel"
    ],
    "virtuellement": [
        "virtuellement"
    ],
    "virtuelles": [
        "virtuel"
    ],
    "virtuels": [
        "virtuel"
    ],
    "virtuose": [
        "virtuose"
    ],
    "virtuoses": [
        "virtuose"
    ],
    "virtuosite": [
        "virtuosite"
    ],
    "virulence": [
        "virulence"
    ],
    "virulent": [
        "virulent"
    ],
    "virulente": [
        "virulent"
    ],
    "virulentes": [
        "virulent"
    ],
    "virulents": [
        "virulent"
    ],
    "virus": [
        "virus"
    ],
    "virat": [
        "virer"
    ],
    "virerent": [
        "virer"
    ],
    "viree": [
        "viree",
        "virer"
    ],
    "virees": [
        "viree",
        "virer"
    ],
    "vis": [
        "vis",
        "vivre",
        "voir"
    ],
    "visa": [
        "visa",
        "viser"
    ],
    "visage": [
        "visage"
    ],
    "visages": [
        "visage"
    ],
    "visagiste": [
        "visagiste"
    ],
    "visai": [
        "viser"
    ],
    "visaient": [
        "viser"
    ],
    "visais": [
        "viser"
    ],
    "visait": [
        "viser"
    ],
    "visant": [
        "viser"
    ],
    "visas": [
        "visa",
        "viser"
    ],
    "viscose": [
        "viscose"
    ],
    "viscoses": [
        "viscose"
    ],
    "viscosite": [
        "viscosite"
    ],
    "viscosites": [
        "viscosite"
    ],
    "viscere": [
        "viscere"
    ],
    "visceres": [
        "viscere"
    ],
    "visceral": [
        "visceral"
    ],
    "viscerale": [
        "visceral"
    ],
    "visceralement": [
        "visceralement"
    ],
    "viscerales": [
        "visceral"
    ],
    "visceraux": [
        "visceral"
    ],
    "vise": [
        "viser",
        "vise"
    ],
    "visent": [
        "viser"
    ],
    "viser": [
        "viser"
    ],
    "visera": [
        "viser"
    ],
    "viserai": [
        "viser"
    ],
    "viseraient": [
        "viser"
    ],
    "viserais": [
        "viser"
    ],
    "viserait": [
        "viser"
    ],
    "viseront": [
        "viser"
    ],
    "vises": [
        "viser",
        "vise"
    ],
    "viseur": [
        "viseur"
    ],
    "viseurs": [
        "viseur"
    ],
    "visez": [
        "viser"
    ],
    "vishnouisme": [
        "vishnouisme"
    ],
    "visibilite": [
        "visibilite"
    ],
    "visible": [
        "visible"
    ],
    "visiblement": [
        "visiblement"
    ],
    "visibles": [
        "visible"
    ],
    "visiez": [
        "viser"
    ],
    "visioconference": [
        "visioconference"
    ],
    "vision": [
        "vision"
    ],
    "visionna": [
        "visionner"
    ],
    "visionnage": [
        "visionnage"
    ],
    "visionnaire": [
        "visionnaire"
    ],
    "visionnaires": [
        "visionnaire"
    ],
    "visionnant": [
        "visionner"
    ],
    "visionne": [
        "visionner"
    ],
    "visionnent": [
        "visionner"
    ],
    "visionner": [
        "visionner"
    ],
    "visionnera": [
        "visionner"
    ],
    "visionneront": [
        "visionner"
    ],
    "visionneuse": [
        "visionneur"
    ],
    "visionnez": [
        "visionner"
    ],
    "visionnons": [
        "visionner"
    ],
    "visionnes": [
        "visionner"
    ],
    "visions": [
        "vision",
        "viser"
    ],
    "visiophone": [
        "visiophone"
    ],
    "visita": [
        "visiter"
    ],
    "visitai": [
        "visiter"
    ],
    "visitaient": [
        "visiter"
    ],
    "visitais": [
        "visiter"
    ],
    "visitait": [
        "visiter"
    ],
    "visitandines": [
        "visitandine"
    ],
    "visitant": [
        "visiter"
    ],
    "visitation": [
        "visitation"
    ],
    "visite": [
        "visite",
        "visiter"
    ],
    "visitent": [
        "visiter"
    ],
    "visiter": [
        "visiter"
    ],
    "visitera": [
        "visiter"
    ],
    "visiterai": [
        "visiter"
    ],
    "visiteraient": [
        "visiter"
    ],
    "visiterait": [
        "visiter"
    ],
    "visiteras": [
        "visiter"
    ],
    "visiterez": [
        "visiter"
    ],
    "visiterons": [
        "visiter"
    ],
    "visites": [
        "visite",
        "visiter"
    ],
    "visiteur": [
        "visiteur"
    ],
    "visiteurs": [
        "visiteur"
    ],
    "visiteuse": [
        "visiteur"
    ],
    "visiteuses": [
        "visiteur"
    ],
    "visitez": [
        "visiter"
    ],
    "visitiez": [
        "visiter"
    ],
    "visitions": [
        "visiter"
    ],
    "visitons": [
        "visiter"
    ],
    "visitames": [
        "visiter"
    ],
    "visitat": [
        "visiter"
    ],
    "visiterent": [
        "visiter"
    ],
    "visitee": [
        "visiter"
    ],
    "visitees": [
        "visiter"
    ],
    "visiere": [
        "visiere"
    ],
    "visieres": [
        "visiere"
    ],
    "vison": [
        "vison"
    ],
    "visons": [
        "viser",
        "vison"
    ],
    "visqueuse": [
        "visqueux"
    ],
    "visqueuses": [
        "visqueux"
    ],
    "visqueux": [
        "visqueux"
    ],
    "vissa": [
        "visser"
    ],
    "vissaient": [
        "visser"
    ],
    "vissait": [
        "visser"
    ],
    "vissant": [
        "visser"
    ],
    "visse": [
        "visse",
        "visser"
    ],
    "vissent": [
        "voir",
        "visser"
    ],
    "visser": [
        "visser"
    ],
    "visserait": [
        "visser"
    ],
    "visserie": [
        "visserie"
    ],
    "vissez": [
        "visser"
    ],
    "visserent": [
        "visser"
    ],
    "vissee": [
        "visse",
        "visser"
    ],
    "vissees": [
        "visse",
        "visser"
    ],
    "visses": [
        "visse",
        "visser"
    ],
    "vista": [
        "vista"
    ],
    "visualisaient": [
        "visualiser"
    ],
    "visualisais": [
        "visualiser"
    ],
    "visualisant": [
        "visualiser"
    ],
    "visualisation": [
        "visualisation"
    ],
    "visualise": [
        "visualiser"
    ],
    "visualiser": [
        "visualiser"
    ],
    "visualiserai": [
        "visualiser"
    ],
    "visualises": [
        "visualiser",
        "visualise"
    ],
    "visualisez": [
        "visualiser"
    ],
    "visualisee": [
        "visualiser"
    ],
    "visualisees": [
        "visualiser"
    ],
    "visuel": [
        "visuel"
    ],
    "visuelle": [
        "visuel"
    ],
    "visuellement": [
        "visuellement"
    ],
    "visuelles": [
        "visuel"
    ],
    "visuels": [
        "visuel"
    ],
    "visee": [
        "viser",
        "visee",
        "vise"
    ],
    "visees": [
        "viser",
        "visee",
        "vise"
    ],
    "vit": [
        "vivre",
        "voir"
    ],
    "vital": [
        "vital"
    ],
    "vitale": [
        "vital"
    ],
    "vitales": [
        "vital"
    ],
    "vitaliser": [
        "vitaliser"
    ],
    "vitalite": [
        "vitalite"
    ],
    "vitamine": [
        "vitamine"
    ],
    "vitaminer": [
        "vitaminer"
    ],
    "vitamines": [
        "vitamine"
    ],
    "vitaminee": [
        "vitamine"
    ],
    "vitaminees": [
        "vitamine"
    ],
    "vitaux": [
        "vital"
    ],
    "vite": [
        "vite"
    ],
    "vitellin": [
        "vitellin"
    ],
    "vitement": [
        "vitement"
    ],
    "vitesse": [
        "vitesse"
    ],
    "vitesses": [
        "vitesse"
    ],
    "viticole": [
        "viticole"
    ],
    "viticulteur": [
        "viticulteur"
    ],
    "viticulteurs": [
        "viticulteur"
    ],
    "viticultrice": [
        "viticulteur"
    ],
    "viticulture": [
        "viticulture"
    ],
    "vitiligo": [
        "vitiligo"
    ],
    "vitrage": [
        "vitrage"
    ],
    "vitrages": [
        "vitrage"
    ],
    "vitrail": [
        "vitrail"
    ],
    "vitrauphanie": [
        "vitrauphanie"
    ],
    "vitraux": [
        "vitrail"
    ],
    "vitre": [
        "vitrer",
        "vitre"
    ],
    "vitres": [
        "vitrer",
        "vitre"
    ],
    "vitreuse": [
        "vitreux"
    ],
    "vitreuses": [
        "vitreux"
    ],
    "vitreux": [
        "vitreux"
    ],
    "vitrier": [
        "vitrier"
    ],
    "vitriers": [
        "vitrier"
    ],
    "vitrifia": [
        "vitrifier"
    ],
    "vitrifie": [
        "vitrifier"
    ],
    "vitrifient": [
        "vitrifier"
    ],
    "vitrifier": [
        "vitrifier"
    ],
    "vitrifiee": [
        "vitrifier"
    ],
    "vitrifiees": [
        "vitrifier"
    ],
    "vitrifies": [
        "vitrifier"
    ],
    "vitrine": [
        "vitrine"
    ],
    "vitrines": [
        "vitrine"
    ],
    "vitriol": [
        "vitriol"
    ],
    "vitrioler": [
        "vitrioler"
    ],
    "vitrioleurs": [
        "vitrioleur"
    ],
    "vitriolique": [
        "vitriolique"
    ],
    "vitriols": [
        "vitriol"
    ],
    "vitriole": [
        "vitrioler"
    ],
    "vitrophanie": [
        "vitrophanie"
    ],
    "vitree": [
        "vitrer",
        "vitre"
    ],
    "vitrees": [
        "vitrer",
        "vitre"
    ],
    "vits": [
        "vit"
    ],
    "vitupere": [
        "vituperer"
    ],
    "vituperaient": [
        "vituperer"
    ],
    "vituperait": [
        "vituperer"
    ],
    "vituperant": [
        "vituperer"
    ],
    "vituperations": [
        "vituperation"
    ],
    "vituperer": [
        "vituperer"
    ],
    "vivable": [
        "vivable"
    ],
    "vivables": [
        "vivable"
    ],
    "vivace": [
        "vivace"
    ],
    "vivaces": [
        "vivace"
    ],
    "vivacite": [
        "vivacite"
    ],
    "vivacites": [
        "vivacite"
    ],
    "vivaient": [
        "vivre"
    ],
    "vivais": [
        "vivre"
    ],
    "vivait": [
        "vivre"
    ],
    "vivandier": [
        "vivandier"
    ],
    "vivandiers": [
        "vivandier"
    ],
    "vivandiere": [
        "vivandier"
    ],
    "vivandieres": [
        "vivandier"
    ],
    "vivant": [
        "vivre",
        "vivant"
    ],
    "vivante": [
        "vivant"
    ],
    "vivantes": [
        "vivant"
    ],
    "vivants": [
        "vivant"
    ],
    "vivarium": [
        "vivarium"
    ],
    "vivat": [
        "vivat"
    ],
    "vivats": [
        "vivats"
    ],
    "vive": [
        "vive",
        "vivre",
        "vif"
    ],
    "vivement": [
        "vivement"
    ],
    "vivent": [
        "vivre"
    ],
    "vives": [
        "vive",
        "vivre",
        "vif"
    ],
    "viveur": [
        "viveur"
    ],
    "viveurs": [
        "viveur"
    ],
    "vivez": [
        "vivre"
    ],
    "vivier": [
        "vivier"
    ],
    "viviers": [
        "vivier"
    ],
    "viviez": [
        "vivre"
    ],
    "vivifiait": [
        "vivifier"
    ],
    "vivifiant": [
        "vivifiant",
        "vivifier"
    ],
    "vivifiante": [
        "vivifiant"
    ],
    "vivifiantes": [
        "vivifiant"
    ],
    "vivifiants": [
        "vivifiant"
    ],
    "vivification": [
        "vivification"
    ],
    "vivifie": [
        "vivifier"
    ],
    "vivifier": [
        "vivifier"
    ],
    "vivifiee": [
        "vivifier"
    ],
    "vivifiees": [
        "vivifier"
    ],
    "vivions": [
        "vivre"
    ],
    "vivisecteur": [
        "vivisecteur"
    ],
    "vivisection": [
        "vivisection"
    ],
    "vivisections": [
        "vivisection"
    ],
    "vivons": [
        "vivre"
    ],
    "vivota": [
        "vivoter"
    ],
    "vivotaient": [
        "vivoter"
    ],
    "vivotais": [
        "vivoter"
    ],
    "vivotait": [
        "vivoter"
    ],
    "vivotant": [
        "vivoter"
    ],
    "vivote": [
        "vivoter"
    ],
    "vivotent": [
        "vivoter"
    ],
    "vivoter": [
        "vivoter"
    ],
    "vivoterent": [
        "vivoter"
    ],
    "vivra": [
        "vivre"
    ],
    "vivrai": [
        "vivre"
    ],
    "vivraient": [
        "vivre"
    ],
    "vivrais": [
        "vivre"
    ],
    "vivrait": [
        "vivre"
    ],
    "vivras": [
        "vivre"
    ],
    "vivre": [
        "vivre"
    ],
    "vivres": [
        "vivre"
    ],
    "vivrez": [
        "vivre"
    ],
    "vivriers": [
        "vivrier"
    ],
    "vivriez": [
        "vivre"
    ],
    "vivrions": [
        "vivre"
    ],
    "vivrons": [
        "vivre"
    ],
    "vivront": [
        "vivre"
    ],
    "vizir": [
        "vizir"
    ],
    "vizirs": [
        "vizir"
    ],
    "vlan": [
        "vlan"
    ],
    "vlouf": [
        "vlouf"
    ],
    "vocable": [
        "vocable"
    ],
    "vocables": [
        "vocable"
    ],
    "vocabulaire": [
        "vocabulaire"
    ],
    "vocabulaires": [
        "vocabulaire"
    ],
    "vocal": [
        "vocal"
    ],
    "vocale": [
        "vocal"
    ],
    "vocalement": [
        "vocalement"
    ],
    "vocales": [
        "vocal"
    ],
    "vocalique": [
        "vocalique"
    ],
    "vocalisait": [
        "vocaliser"
    ],
    "vocalisant": [
        "vocaliser"
    ],
    "vocalisation": [
        "vocalisation"
    ],
    "vocalisations": [
        "vocalisation"
    ],
    "vocalise": [
        "vocalise",
        "vocaliser"
    ],
    "vocaliser": [
        "vocaliser"
    ],
    "vocalises": [
        "vocalise"
    ],
    "vocaliste": [
        "vocaliste"
    ],
    "vocatif": [
        "vocatif"
    ],
    "vocatifs": [
        "vocatif"
    ],
    "vocation": [
        "vocation"
    ],
    "vocations": [
        "vocation"
    ],
    "vocaux": [
        "vocal"
    ],
    "vocifere": [
        "vociferer"
    ],
    "vociferent": [
        "vociferer"
    ],
    "vocifera": [
        "vociferer"
    ],
    "vociferai": [
        "vociferer"
    ],
    "vociferaient": [
        "vociferer"
    ],
    "vociferais": [
        "vociferer"
    ],
    "vociferait": [
        "vociferer"
    ],
    "vociferant": [
        "vociferant",
        "vociferer"
    ],
    "vociferante": [
        "vociferant"
    ],
    "vociferantes": [
        "vociferant"
    ],
    "vociferants": [
        "vociferant"
    ],
    "vociferation": [
        "vociferation"
    ],
    "vociferations": [
        "vociferation"
    ],
    "vociferer": [
        "vociferer"
    ],
    "vociferes": [
        "vociferer"
    ],
    "vocodeur": [
        "vocodeur"
    ],
    "vodka": [
        "vodka"
    ],
    "vodkas": [
        "vodka"
    ],
    "vodou": [
        "vodou"
    ],
    "vodous": [
        "vodou"
    ],
    "voeu": [
        "voeu"
    ],
    "voeux": [
        "voeu"
    ],
    "vogua": [
        "voguer"
    ],
    "voguaient": [
        "voguer"
    ],
    "voguais": [
        "voguer"
    ],
    "voguait": [
        "voguer"
    ],
    "voguant": [
        "voguer"
    ],
    "vogue": [
        "voguer",
        "vogue"
    ],
    "voguent": [
        "voguer"
    ],
    "voguer": [
        "voguer"
    ],
    "voguera": [
        "voguer"
    ],
    "voguerai": [
        "voguer"
    ],
    "voguerait": [
        "voguer"
    ],
    "voguerions": [
        "voguer"
    ],
    "voguerons": [
        "voguer"
    ],
    "vogues": [
        "voguer",
        "vogue"
    ],
    "voguions": [
        "voguer"
    ],
    "voguons": [
        "voguer"
    ],
    "voici": [
        "voici"
    ],
    "voie": [
        "voie",
        "voir"
    ],
    "voient": [
        "voir"
    ],
    "voies": [
        "voie",
        "voir"
    ],
    "voila": [
        "voiler",
        "voila"
    ],
    "voilage": [
        "voilage"
    ],
    "voilages": [
        "voilage"
    ],
    "voilaient": [
        "voiler"
    ],
    "voilais": [
        "voiler"
    ],
    "voilait": [
        "voiler"
    ],
    "voilant": [
        "voiler"
    ],
    "voile": [
        "voile",
        "voiler"
    ],
    "voilent": [
        "voiler"
    ],
    "voiler": [
        "voiler"
    ],
    "voilera": [
        "voiler"
    ],
    "voileront": [
        "voiler"
    ],
    "voiles": [
        "voile",
        "voiler"
    ],
    "voilette": [
        "voilette"
    ],
    "voilettes": [
        "voilette"
    ],
    "voilez": [
        "voiler"
    ],
    "voilier": [
        "voilier"
    ],
    "voiliers": [
        "voilier"
    ],
    "voilons": [
        "voiler"
    ],
    "voilure": [
        "voilure"
    ],
    "voilures": [
        "voilure"
    ],
    "voilerent": [
        "voiler"
    ],
    "voilee": [
        "voile",
        "voiler"
    ],
    "voilees": [
        "voile",
        "voiler"
    ],
    "voir": [
        "voir"
    ],
    "voire": [
        "voire"
    ],
    "voirie": [
        "voirie"
    ],
    "vois": [
        "voir"
    ],
    "voisin": [
        "voisin"
    ],
    "voisinage": [
        "voisinage"
    ],
    "voisinages": [
        "voisinage"
    ],
    "voisinaient": [
        "voisiner"
    ],
    "voisinait": [
        "voisiner"
    ],
    "voisinant": [
        "voisiner"
    ],
    "voisine": [
        "voisin",
        "voisiner"
    ],
    "voisinent": [
        "voisiner"
    ],
    "voisiner": [
        "voisiner"
    ],
    "voisines": [
        "voisin"
    ],
    "voisins": [
        "voisin"
    ],
    "voit": [
        "voir"
    ],
    "voituraient": [
        "voiturer"
    ],
    "voiturait": [
        "voiturer"
    ],
    "voiture": [
        "voiturer",
        "voiture"
    ],
    "voiturer": [
        "voiturer"
    ],
    "voitureront": [
        "voiturer"
    ],
    "voitures": [
        "voiturer",
        "voiture"
    ],
    "voiturette": [
        "voiturette"
    ],
    "voiturettes": [
        "voiturette"
    ],
    "voiturier": [
        "voiturier"
    ],
    "voituriers": [
        "voiturier"
    ],
    "voiturin": [
        "voiturin"
    ],
    "voix": [
        "voix"
    ],
    "vol": [
        "vol"
    ],
    "vola": [
        "voler"
    ],
    "volage": [
        "volage"
    ],
    "volages": [
        "volage"
    ],
    "volai": [
        "voler"
    ],
    "volaient": [
        "voler"
    ],
    "volaille": [
        "volaille"
    ],
    "volailler": [
        "volailler"
    ],
    "volaillers": [
        "volailler"
    ],
    "volailles": [
        "volaille"
    ],
    "volais": [
        "voler"
    ],
    "volait": [
        "voler"
    ],
    "volant": [
        "voler",
        "volant"
    ],
    "volante": [
        "volant",
        "volanter"
    ],
    "volantes": [
        "volant",
        "volanter"
    ],
    "volants": [
        "volant"
    ],
    "volapuk": [
        "volapuk"
    ],
    "volassent": [
        "voler"
    ],
    "volatil": [
        "volatil"
    ],
    "volatile": [
        "volatile",
        "volatil"
    ],
    "volatiles": [
        "volatile",
        "volatil"
    ],
    "volatilisa": [
        "volatiliser"
    ],
    "volatilisaient": [
        "volatiliser"
    ],
    "volatilisait": [
        "volatiliser"
    ],
    "volatilisant": [
        "volatiliser"
    ],
    "volatilisation": [
        "volatilisation"
    ],
    "volatilise": [
        "volatiliser"
    ],
    "volatilisent": [
        "volatiliser"
    ],
    "volatiliser": [
        "volatiliser"
    ],
    "volatilisee": [
        "volatiliser"
    ],
    "volatilisees": [
        "volatiliser"
    ],
    "volatilises": [
        "volatiliser"
    ],
    "volatilite": [
        "volatilite"
    ],
    "volatils": [
        "volatil"
    ],
    "volcan": [
        "volcan"
    ],
    "volcanique": [
        "volcanique"
    ],
    "volcaniques": [
        "volcanique"
    ],
    "volcanologique": [
        "volcanologique"
    ],
    "volcanologue": [
        "volcanologue"
    ],
    "volcans": [
        "volcan"
    ],
    "vole": [
        "voler",
        "vole"
    ],
    "volent": [
        "voler"
    ],
    "voler": [
        "voler"
    ],
    "volera": [
        "voler"
    ],
    "volerai": [
        "voler"
    ],
    "voleraient": [
        "voler"
    ],
    "volerais": [
        "voler"
    ],
    "volerait": [
        "voler"
    ],
    "voleras": [
        "voler"
    ],
    "volerez": [
        "voler"
    ],
    "volerie": [
        "volerie"
    ],
    "voleriez": [
        "voler"
    ],
    "volerons": [
        "voler"
    ],
    "voleront": [
        "voler"
    ],
    "voles": [
        "voler",
        "vole"
    ],
    "volet": [
        "volet"
    ],
    "voleta": [
        "voleter"
    ],
    "voletaient": [
        "voleter"
    ],
    "voletait": [
        "voleter"
    ],
    "voletant": [
        "voletant",
        "voleter"
    ],
    "voletante": [
        "voletant"
    ],
    "voletantes": [
        "voletant"
    ],
    "voleter": [
        "voleter"
    ],
    "voletez": [
        "voleter"
    ],
    "volets": [
        "volet"
    ],
    "volette": [
        "voleter"
    ],
    "volettent": [
        "voleter"
    ],
    "voleur": [
        "voleur"
    ],
    "voleurs": [
        "voleur"
    ],
    "voleuse": [
        "voleur"
    ],
    "voleuses": [
        "voleur"
    ],
    "volez": [
        "voler"
    ],
    "voliez": [
        "voler"
    ],
    "volige": [
        "volige"
    ],
    "voliges": [
        "volige"
    ],
    "volions": [
        "voler"
    ],
    "volition": [
        "volition"
    ],
    "volitions": [
        "volition"
    ],
    "voliere": [
        "voliere"
    ],
    "volieres": [
        "voliere"
    ],
    "volley": [
        "volley"
    ],
    "volleyeur": [
        "volleyeur"
    ],
    "volleyeurs": [
        "volleyeur"
    ],
    "volons": [
        "voler"
    ],
    "volontaire": [
        "volontaire"
    ],
    "volontairement": [
        "volontairement"
    ],
    "volontaires": [
        "volontaire"
    ],
    "volontariat": [
        "volontariat"
    ],
    "volontarisme": [
        "volontarisme"
    ],
    "volontariste": [
        "volontariste"
    ],
    "volontaristes": [
        "volontariste"
    ],
    "volontiers": [
        "volontiers"
    ],
    "volonte": [
        "volonte"
    ],
    "volontes": [
        "volonte"
    ],
    "vols": [
        "vol"
    ],
    "volt": [
        "volt"
    ],
    "voltage": [
        "voltage"
    ],
    "voltaient": [
        "volter"
    ],
    "voltaire": [
        "voltaire"
    ],
    "voltaires": [
        "voltaire"
    ],
    "voltairien": [
        "voltairien"
    ],
    "voltaique": [
        "voltaique"
    ],
    "volte": [
        "volte"
    ],
    "volter": [
        "volter"
    ],
    "voltes": [
        "volte"
    ],
    "voltige": [
        "voltige",
        "voltiger"
    ],
    "voltigea": [
        "voltiger"
    ],
    "voltigeaient": [
        "voltiger"
    ],
    "voltigeait": [
        "voltiger"
    ],
    "voltigeant": [
        "voltiger"
    ],
    "voltigement": [
        "voltigement"
    ],
    "voltigent": [
        "voltiger"
    ],
    "voltiger": [
        "voltiger"
    ],
    "voltiges": [
        "voltige"
    ],
    "voltigeur": [
        "voltigeur"
    ],
    "voltigeurs": [
        "voltigeur"
    ],
    "voltigerent": [
        "voltiger"
    ],
    "voltmetre": [
        "voltmetre"
    ],
    "volts": [
        "volt"
    ],
    "volubile": [
        "volubile"
    ],
    "volubilement": [
        "volubilement"
    ],
    "volubiles": [
        "volubile"
    ],
    "volubilis": [
        "volubilis"
    ],
    "volubilite": [
        "volubilite"
    ],
    "volume": [
        "volume"
    ],
    "volumes": [
        "volume"
    ],
    "volumineuse": [
        "volumineux"
    ],
    "volumineuses": [
        "volumineux"
    ],
    "volumineux": [
        "volumineux"
    ],
    "volumique": [
        "volumique"
    ],
    "volumetrique": [
        "volumetrique"
    ],
    "voluptueuse": [
        "voluptueux"
    ],
    "voluptueusement": [
        "voluptueusement"
    ],
    "voluptueuses": [
        "voluptueux"
    ],
    "voluptueux": [
        "voluptueux"
    ],
    "volupte": [
        "volupte"
    ],
    "voluptes": [
        "volupte"
    ],
    "volute": [
        "volute"
    ],
    "volutes": [
        "volute"
    ],
    "volvaires": [
        "volvaire"
    ],
    "volve": [
        "volve"
    ],
    "volat": [
        "voler"
    ],
    "volerent": [
        "voler"
    ],
    "volee": [
        "voler",
        "vole",
        "volee"
    ],
    "volees": [
        "voler",
        "vole",
        "volee"
    ],
    "volemie": [
        "volemie"
    ],
    "vomi": [
        "vomir",
        "vomi"
    ],
    "vomie": [
        "vomir"
    ],
    "vomies": [
        "vomir"
    ],
    "vomique": [
        "vomique"
    ],
    "vomir": [
        "vomir"
    ],
    "vomira": [
        "vomir"
    ],
    "vomirai": [
        "vomir"
    ],
    "vomirais": [
        "vomir"
    ],
    "vomirait": [
        "vomir"
    ],
    "vomiras": [
        "vomir"
    ],
    "vomirent": [
        "vomir"
    ],
    "vomirez": [
        "vomir"
    ],
    "vomiront": [
        "vomir"
    ],
    "vomis": [
        "vomir",
        "vomi"
    ],
    "vomissaient": [
        "vomir"
    ],
    "vomissais": [
        "vomir"
    ],
    "vomissait": [
        "vomir"
    ],
    "vomissant": [
        "vomir",
        "vomissant"
    ],
    "vomisse": [
        "vomir"
    ],
    "vomissement": [
        "vomissement"
    ],
    "vomissements": [
        "vomissement"
    ],
    "vomissent": [
        "vomir"
    ],
    "vomisseur": [
        "vomisseur"
    ],
    "vomissez": [
        "vomir"
    ],
    "vomissions": [
        "vomir"
    ],
    "vomissure": [
        "vomissure"
    ],
    "vomissures": [
        "vomissure"
    ],
    "vomit": [
        "vomir"
    ],
    "vomitif": [
        "vomitif"
    ],
    "vomitifs": [
        "vomitif"
    ],
    "vomitives": [
        "vomitif"
    ],
    "vomitoire": [
        "vomitoire"
    ],
    "vomitoires": [
        "vomitoire"
    ],
    "vont": [
        "aller"
    ],
    "vopo": [
        "vopo"
    ],
    "vorace": [
        "vorace"
    ],
    "voracement": [
        "voracement"
    ],
    "voraces": [
        "vorace"
    ],
    "voracite": [
        "voracite"
    ],
    "vortex": [
        "vortex"
    ],
    "vos": [
        "vos",
        "votre"
    ],
    "vosgien": [
        "vosgien"
    ],
    "vosgienne": [
        "vosgien"
    ],
    "vota": [
        "voter"
    ],
    "votaient": [
        "voter"
    ],
    "votais": [
        "voter"
    ],
    "votait": [
        "voter"
    ],
    "votant": [
        "voter",
        "votant"
    ],
    "votants": [
        "votant"
    ],
    "vote": [
        "vote",
        "voter"
    ],
    "votent": [
        "voter"
    ],
    "voter": [
        "voter"
    ],
    "votera": [
        "voter"
    ],
    "voterai": [
        "voter"
    ],
    "voterais": [
        "voter"
    ],
    "voterait": [
        "voter"
    ],
    "voteras": [
        "voter"
    ],
    "voterez": [
        "voter"
    ],
    "voterons": [
        "voter"
    ],
    "voteront": [
        "voter"
    ],
    "votes": [
        "vote",
        "voter"
    ],
    "votez": [
        "voter"
    ],
    "votiez": [
        "voter"
    ],
    "votif": [
        "votif"
    ],
    "votifs": [
        "votif"
    ],
    "votions": [
        "voter"
    ],
    "votive": [
        "votif"
    ],
    "votives": [
        "votif"
    ],
    "votons": [
        "voter"
    ],
    "votre": [
        "votre"
    ],
    "voterent": [
        "voter"
    ],
    "votee": [
        "voter"
    ],
    "votees": [
        "voter"
    ],
    "voua": [
        "vouer"
    ],
    "vouai": [
        "vouer"
    ],
    "vouaient": [
        "vouer"
    ],
    "vouais": [
        "vouer"
    ],
    "vouait": [
        "vouer"
    ],
    "vouant": [
        "vouer"
    ],
    "voudra": [
        "vouloir"
    ],
    "voudrai": [
        "vouloir"
    ],
    "voudraient": [
        "vouloir"
    ],
    "voudrais": [
        "vouloir"
    ],
    "voudrait": [
        "vouloir"
    ],
    "voudras": [
        "vouloir"
    ],
    "voudrez": [
        "vouloir"
    ],
    "voudriez": [
        "vouloir"
    ],
    "voudrions": [
        "vouloir"
    ],
    "voudrons": [
        "vouloir"
    ],
    "voudront": [
        "vouloir"
    ],
    "voue": [
        "voue",
        "vouer"
    ],
    "vouent": [
        "vouer"
    ],
    "vouer": [
        "vouer"
    ],
    "vouera": [
        "vouer"
    ],
    "vouerait": [
        "vouer"
    ],
    "vouge": [
        "vouge"
    ],
    "vouivre": [
        "vouivre"
    ],
    "vouivres": [
        "vouivre"
    ],
    "voulaient": [
        "vouloir"
    ],
    "voulais": [
        "vouloir"
    ],
    "voulait": [
        "vouloir"
    ],
    "voulant": [
        "vouloir"
    ],
    "voulez": [
        "vouler",
        "vouloir"
    ],
    "vouliez": [
        "vouloir"
    ],
    "voulions": [
        "vouloir"
    ],
    "vouloir": [
        "vouloir"
    ],
    "vouloirs": [
        "vouloir"
    ],
    "voulons": [
        "vouloir"
    ],
    "voulu": [
        "vouloir",
        "voulu"
    ],
    "voulue": [
        "vouloir",
        "voulu"
    ],
    "voulues": [
        "vouloir",
        "voulu"
    ],
    "voulurent": [
        "vouloir"
    ],
    "voulus": [
        "vouloir",
        "voulu"
    ],
    "voulusse": [
        "vouloir"
    ],
    "voulussent": [
        "vouloir"
    ],
    "voulut": [
        "vouloir"
    ],
    "voulumes": [
        "vouloir"
    ],
    "vouons": [
        "vouer"
    ],
    "vous": [
        "vous"
    ],
    "vousoyait": [
        "vousoyer"
    ],
    "vousoyez": [
        "vousoyer"
    ],
    "voussoie": [
        "voussoyer"
    ],
    "voussoiement": [
        "voussoiement"
    ],
    "voussoient": [
        "voussoyer"
    ],
    "voussoyait": [
        "voussoyer"
    ],
    "voussoyer": [
        "voussoyer"
    ],
    "voussoyez": [
        "voussoyer"
    ],
    "voussure": [
        "voussure"
    ],
    "voussures": [
        "voussure"
    ],
    "vouvoie": [
        "vouvoyer"
    ],
    "vouvoiement": [
        "vouvoiement"
    ],
    "vouvoiements": [
        "vouvoiement"
    ],
    "vouvoient": [
        "vouvoyer"
    ],
    "vouvoies": [
        "vouvoyer"
    ],
    "vouvoya": [
        "vouvoyer"
    ],
    "vouvoyait": [
        "vouvoyer"
    ],
    "vouvoyant": [
        "vouvoyer"
    ],
    "vouvoyer": [
        "vouvoyer"
    ],
    "vouvray": [
        "vouvray"
    ],
    "vouerent": [
        "vouer"
    ],
    "vouee": [
        "voue",
        "vouer"
    ],
    "vouees": [
        "voue",
        "vouer"
    ],
    "voues": [
        "voue",
        "vouer"
    ],
    "voyage": [
        "voyager",
        "voyage"
    ],
    "voyagea": [
        "voyager"
    ],
    "voyageaient": [
        "voyager"
    ],
    "voyageais": [
        "voyager"
    ],
    "voyageait": [
        "voyager"
    ],
    "voyageant": [
        "voyager"
    ],
    "voyagent": [
        "voyager"
    ],
    "voyageons": [
        "voyager"
    ],
    "voyager": [
        "voyager"
    ],
    "voyagera": [
        "voyager"
    ],
    "voyagerai": [
        "voyager"
    ],
    "voyagerais": [
        "voyager"
    ],
    "voyagerait": [
        "voyager"
    ],
    "voyageras": [
        "voyager"
    ],
    "voyagerez": [
        "voyager"
    ],
    "voyageriez": [
        "voyager"
    ],
    "voyagerons": [
        "voyager"
    ],
    "voyageront": [
        "voyager"
    ],
    "voyages": [
        "voyager",
        "voyage"
    ],
    "voyageur": [
        "voyageur"
    ],
    "voyageurs": [
        "voyageur"
    ],
    "voyageuse": [
        "voyageur"
    ],
    "voyageuses": [
        "voyageur"
    ],
    "voyagez": [
        "voyager"
    ],
    "voyagiez": [
        "voyager"
    ],
    "voyagions": [
        "voyager"
    ],
    "voyagerent": [
        "voyager"
    ],
    "voyaient": [
        "voir"
    ],
    "voyais": [
        "voir"
    ],
    "voyait": [
        "voir"
    ],
    "voyance": [
        "voyance"
    ],
    "voyances": [
        "voyance"
    ],
    "voyant": [
        "voir",
        "voyant"
    ],
    "voyante": [
        "voyant"
    ],
    "voyantes": [
        "voyant"
    ],
    "voyants": [
        "voyant"
    ],
    "voyelle": [
        "voyelle"
    ],
    "voyelles": [
        "voyelle"
    ],
    "voyer": [
        "voyer"
    ],
    "voyeur": [
        "voyeur"
    ],
    "voyeurisme": [
        "voyeurisme"
    ],
    "voyeurs": [
        "voyeur"
    ],
    "voyeuse": [
        "voyeur"
    ],
    "voyez": [
        "voir"
    ],
    "voyiez": [
        "voir"
    ],
    "voyions": [
        "voir"
    ],
    "voyons": [
        "voir"
    ],
    "voyou": [
        "voyou"
    ],
    "voyoucratie": [
        "voyoucratie"
    ],
    "voyous": [
        "voyou"
    ],
    "voyoute": [
        "voyou"
    ],
    "voyouterie": [
        "voyouterie"
    ],
    "voyoutes": [
        "voyou"
    ],
    "voyoutisme": [
        "voyoutisme"
    ],
    "voivodie": [
        "voivodie"
    ],
    "voivodies": [
        "voivodie"
    ],
    "vouta": [
        "vouter"
    ],
    "voutaient": [
        "vouter"
    ],
    "voutait": [
        "vouter"
    ],
    "voutant": [
        "vouter"
    ],
    "voute": [
        "voute",
        "vouter"
    ],
    "voutent": [
        "vouter"
    ],
    "vouter": [
        "vouter"
    ],
    "voutes": [
        "voute",
        "vouter"
    ],
    "voutat": [
        "vouter"
    ],
    "vouterent": [
        "vouter"
    ],
    "voutee": [
        "voute",
        "vouter"
    ],
    "voutees": [
        "voute",
        "vouter"
    ],
    "vrac": [
        "vrac"
    ],
    "vraie": [],
    "vraies": [],
    "vraiment": [
        "vraiment"
    ],
    "vrais": [],
    "vraisemblable": [
        "vraisemblable"
    ],
    "vraisemblablement": [
        "vraisemblablement"
    ],
    "vraisemblables": [
        "vraisemblable"
    ],
    "vraisemblance": [
        "vraisemblance"
    ],
    "vraisemblances": [
        "vraisemblance"
    ],
    "vraquier": [
        "vraquier"
    ],
    "vrilla": [
        "vriller"
    ],
    "vrillaient": [
        "vriller"
    ],
    "vrillait": [
        "vriller"
    ],
    "vrillant": [
        "vriller"
    ],
    "vrille": [
        "vriller",
        "vrille"
    ],
    "vrillement": [
        "vrillement"
    ],
    "vrillent": [
        "vriller"
    ],
    "vriller": [
        "vriller"
    ],
    "vrilles": [
        "vriller",
        "vrille"
    ],
    "vrillette": [
        "vrillette"
    ],
    "vrillettes": [
        "vrillette"
    ],
    "vrillerent": [
        "vriller"
    ],
    "vrillees": [
        "vriller"
    ],
    "vrombir": [
        "vrombir"
    ],
    "vrombis": [
        "vrombir"
    ],
    "vrombissaient": [
        "vrombir"
    ],
    "vrombissait": [
        "vrombir"
    ],
    "vrombissant": [
        "vrombir",
        "vrombissant"
    ],
    "vrombissante": [
        "vrombissant"
    ],
    "vrombissantes": [
        "vrombissant"
    ],
    "vrombissement": [
        "vrombissement"
    ],
    "vrombissements": [
        "vrombissement"
    ],
    "vrombissent": [
        "vrombir"
    ],
    "vrombissions": [
        "vrombir"
    ],
    "vrombit": [
        "vrombir"
    ],
    "vroom": [
        "vroom"
    ],
    "vroum": [
        "vroum"
    ],
    "vu": [
        "voir",
        "vu"
    ],
    "vue": [
        "voir",
        "vu",
        "vue"
    ],
    "vues": [
        "voir",
        "vu",
        "vue"
    ],
    "vulcain": [
        "vulcain"
    ],
    "vulcanienne": [
        "vulcanienne"
    ],
    "vulcanisait": [
        "vulcaniser"
    ],
    "vulcanisation": [
        "vulcanisation"
    ],
    "vulcaniser": [
        "vulcaniser"
    ],
    "vulcanise": [
        "vulcanise"
    ],
    "vulcanologue": [
        "vulcanologue"
    ],
    "vulgaire": [
        "vulgaire"
    ],
    "vulgairement": [
        "vulgairement"
    ],
    "vulgaires": [
        "vulgaire"
    ],
    "vulgarisateurs": [
        "vulgarisateur"
    ],
    "vulgarisation": [
        "vulgarisation"
    ],
    "vulgarisations": [
        "vulgarisation"
    ],
    "vulgariser": [
        "vulgariser"
    ],
    "vulgarisee": [
        "vulgarise"
    ],
    "vulgarite": [
        "vulgarite"
    ],
    "vulgarites": [
        "vulgarite"
    ],
    "vulgate": [
        "vulgate"
    ],
    "vulnerabilite": [
        "vulnerabilite"
    ],
    "vulnerable": [
        "vulnerable"
    ],
    "vulnerables": [
        "vulnerable"
    ],
    "vulneraire": [
        "vulneraire"
    ],
    "vulneraires": [
        "vulneraire"
    ],
    "vulnerant": [
        "vulnerant"
    ],
    "vulpin": [
        "vulpin"
    ],
    "vulvaire": [
        "vulvaire"
    ],
    "vulvaires": [
        "vulvaire"
    ],
    "vulve": [
        "vulve"
    ],
    "vulves": [
        "vulve"
    ],
    "vus": [
        "voir",
        "vu"
    ],
    "vecu": [
        "vivre",
        "vecu"
    ],
    "vecue": [
        "vivre",
        "vecu"
    ],
    "vecues": [
        "vivre",
        "vecu"
    ],
    "vecurent": [
        "vivre"
    ],
    "vecus": [
        "vivre",
        "vecu"
    ],
    "vecussent": [
        "vivre"
    ],
    "vecut": [
        "vivre"
    ],
    "veces": [
        "veces"
    ],
    "vecumes": [
        "vivre"
    ],
    "vegete": [
        "vegeter"
    ],
    "vegetent": [
        "vegeter"
    ],
    "vegetes": [
        "vegeter"
    ],
    "vegeta": [
        "vegeter"
    ],
    "vegetaient": [
        "vegeter"
    ],
    "vegetais": [
        "vegeter"
    ],
    "vegetait": [
        "vegeter"
    ],
    "vegetal": [
        "vegetal"
    ],
    "vegetale": [
        "vegetal"
    ],
    "vegetales": [
        "vegetal"
    ],
    "vegetalien": [
        "vegetalien"
    ],
    "vegetalienne": [
        "vegetalien"
    ],
    "vegetalisme": [
        "vegetalisme"
    ],
    "vegetarien": [
        "vegetarien"
    ],
    "vegetarienne": [
        "vegetarien"
    ],
    "vegetariennes": [
        "vegetarien"
    ],
    "vegetariens": [
        "vegetarien"
    ],
    "vegetarisme": [
        "vegetarisme"
    ],
    "vegetatif": [
        "vegetatif"
    ],
    "vegetatifs": [
        "vegetatif"
    ],
    "vegetation": [
        "vegetation"
    ],
    "vegetations": [
        "vegetation"
    ],
    "vegetative": [
        "vegetatif"
    ],
    "vegetatives": [
        "vegetatif"
    ],
    "vegetaux": [
        "vegetal"
    ],
    "vegeter": [
        "vegeter"
    ],
    "vegeteras": [
        "vegeter"
    ],
    "vegeterez": [
        "vegeter"
    ],
    "vegetons": [
        "vegeter"
    ],
    "vegetat": [
        "vegeter"
    ],
    "vehiculaient": [
        "vehiculer"
    ],
    "vehiculait": [
        "vehiculer"
    ],
    "vehiculant": [
        "vehiculer"
    ],
    "vehicule": [
        "vehiculer",
        "vehicule"
    ],
    "vehiculent": [
        "vehiculer"
    ],
    "vehiculer": [
        "vehiculer"
    ],
    "vehicules": [
        "vehiculer",
        "vehicule"
    ],
    "vehiculez": [
        "vehiculer"
    ],
    "vehiculee": [
        "vehiculer"
    ],
    "vehemence": [
        "vehemence"
    ],
    "vehement": [
        "vehement"
    ],
    "vehemente": [
        "vehement"
    ],
    "vehementement": [
        "vehementement"
    ],
    "vehementes": [
        "vehement"
    ],
    "vehements": [
        "vehement"
    ],
    "velaires": [
        "velaire"
    ],
    "velar": [
        "velar"
    ],
    "velin": [
        "velin"
    ],
    "velins": [
        "velin"
    ],
    "veliplanchiste": [
        "veliplanchiste"
    ],
    "velique": [
        "velique"
    ],
    "velo": [
        "velo"
    ],
    "veloce": [
        "veloce"
    ],
    "velocement": [
        "velocement"
    ],
    "veloces": [
        "veloce"
    ],
    "velocipede": [
        "velocipede"
    ],
    "velocipedes": [
        "velocipede"
    ],
    "velocipedique": [
        "velocipedique"
    ],
    "velocipediques": [
        "velocipedique"
    ],
    "velocipedistes": [
        "velocipediste"
    ],
    "velocite": [
        "velocite"
    ],
    "velodrome": [
        "velodrome"
    ],
    "velodromes": [
        "velodrome"
    ],
    "velomoteur": [
        "velomoteur"
    ],
    "velomoteurs": [
        "velomoteur"
    ],
    "velos": [
        "velo"
    ],
    "velums": [
        "velum"
    ],
    "venal": [
        "venal"
    ],
    "venale": [
        "venal"
    ],
    "venales": [
        "venal"
    ],
    "venalite": [
        "venalite"
    ],
    "venaux": [
        "venal"
    ],
    "venerie": [
        "venerie"
    ],
    "veniel": [
        "veniel"
    ],
    "venielle": [
        "veniel"
    ],
    "venielles": [
        "veniel"
    ],
    "veniels": [
        "veniel"
    ],
    "venitien": [
        "venitien"
    ],
    "venitienne": [
        "venitienne",
        "venitien"
    ],
    "venitiennes": [
        "venitienne",
        "venitien"
    ],
    "venitiens": [
        "venitien"
    ],
    "venusien": [
        "venusien"
    ],
    "venusienne": [
        "venusien"
    ],
    "venusiens": [
        "venusien"
    ],
    "venuste": [
        "venuste"
    ],
    "venere": [
        "venerer",
        "venere"
    ],
    "venerent": [
        "venerer"
    ],
    "veneres": [
        "venerer",
        "venere"
    ],
    "veneneuse": [
        "veneneux"
    ],
    "veneneuses": [
        "veneneux"
    ],
    "veneneux": [
        "veneneux"
    ],
    "venerable": [
        "venerable"
    ],
    "venerables": [
        "venerable"
    ],
    "venerai": [
        "venerer"
    ],
    "veneraient": [
        "venerer"
    ],
    "venerais": [
        "venerer"
    ],
    "venerait": [
        "venerer"
    ],
    "venerant": [
        "venerer"
    ],
    "veneras": [
        "venerer"
    ],
    "veneration": [
        "veneration"
    ],
    "venerations": [
        "veneration"
    ],
    "venerer": [
        "venerer"
    ],
    "venerera": [
        "venerer"
    ],
    "venereraient": [
        "venerer"
    ],
    "venererais": [
        "venerer"
    ],
    "venerez": [
        "venerer"
    ],
    "venerien": [
        "venerien"
    ],
    "venerienne": [
        "venerien"
    ],
    "veneriennes": [
        "venerien"
    ],
    "veneriens": [
        "venerien"
    ],
    "venerions": [
        "venerer"
    ],
    "venerons": [
        "venerer"
    ],
    "veneree": [
        "venerer",
        "venere"
    ],
    "venerees": [
        "venerer",
        "venere"
    ],
    "venereologie": [
        "venereologie"
    ],
    "venezuelien": [
        "venezuelien"
    ],
    "venezuelienne": [
        "venezuelien"
    ],
    "venezueliens": [
        "venezuelien"
    ],
    "verace": [
        "verace"
    ],
    "veraces": [
        "verace"
    ],
    "veracite": [
        "veracite"
    ],
    "veranda": [
        "veranda"
    ],
    "verandas": [
        "veranda"
    ],
    "vereuse": [
        "vereux"
    ],
    "vereuses": [
        "vereux"
    ],
    "vereux": [
        "vereux"
    ],
    "veridique": [
        "veridique"
    ],
    "veridiquement": [
        "veridiquement"
    ],
    "veridiques": [
        "veridique"
    ],
    "verif": [
        "verif"
    ],
    "verifia": [
        "verifier"
    ],
    "verifiable": [
        "verifiable"
    ],
    "verifiables": [
        "verifiable"
    ],
    "verifiai": [
        "verifier"
    ],
    "verifiaient": [
        "verifier"
    ],
    "verifiais": [
        "verifier"
    ],
    "verifiait": [
        "verifier"
    ],
    "verifiant": [
        "verifier"
    ],
    "verificateur": [
        "verificateur"
    ],
    "verificateurs": [
        "verificateur"
    ],
    "verification": [
        "verification"
    ],
    "verifications": [
        "verification"
    ],
    "verificatrice": [
        "verificateur"
    ],
    "verifie": [
        "verifier",
        "verifie"
    ],
    "verifient": [
        "verifier"
    ],
    "verifier": [
        "verifier"
    ],
    "verifiera": [
        "verifier"
    ],
    "verifierai": [
        "verifier"
    ],
    "verifierais": [
        "verifier"
    ],
    "verifierait": [
        "verifier"
    ],
    "verifieras": [
        "verifier"
    ],
    "verifierons": [
        "verifier"
    ],
    "verifieront": [
        "verifier"
    ],
    "verifies": [
        "verify",
        "verifier",
        "verifie"
    ],
    "verifieur": [
        "verifieur"
    ],
    "verifiez": [
        "verifier"
    ],
    "verifiions": [
        "verifier"
    ],
    "verifions": [
        "verifier"
    ],
    "verifierent": [
        "verifier"
    ],
    "verifiee": [
        "verifier",
        "verifie"
    ],
    "verifiees": [
        "verifier",
        "verifie"
    ],
    "verin": [
        "verin"
    ],
    "verins": [
        "verin"
    ],
    "veriste": [
        "veriste"
    ],
    "veritable": [
        "veritable"
    ],
    "veritablement": [
        "veritablement"
    ],
    "veritables": [
        "veritable"
    ],
    "verite": [
        "verite"
    ],
    "verites": [
        "verite"
    ],
    "verole": [
        "veroler",
        "verole"
    ],
    "veroles": [
        "veroler",
        "verole"
    ],
    "verolee": [
        "veroler",
        "verole"
    ],
    "verolees": [
        "veroler",
        "verole"
    ],
    "veronaise": [
        "veronais"
    ],
    "veronal": [
        "veronal"
    ],
    "veronique": [
        "veronique"
    ],
    "veroniques": [
        "veronique"
    ],
    "vesanie": [
        "vesanie"
    ],
    "vesanies": [
        "vesanie"
    ],
    "vesicale": [
        "vesical"
    ],
    "vesicante": [
        "vesicant"
    ],
    "vesicatoire": [
        "vesicatoire"
    ],
    "vesicatoires": [
        "vesicatoire"
    ],
    "vesiculaire": [
        "vesiculaire"
    ],
    "vesicule": [
        "vesicule"
    ],
    "vesicules": [
        "vesicule"
    ],
    "vesuviennes": [
        "vesuvien"
    ],
    "vetille": [
        "vetille"
    ],
    "vetilles": [
        "vetille"
    ],
    "vetilleuse": [
        "vetilleux"
    ],
    "vetilleuses": [
        "vetilleux"
    ],
    "vetilleux": [
        "vetilleux"
    ],
    "vetiver": [
        "vetiver"
    ],
    "vetuste": [
        "vetuste"
    ],
    "vetustes": [
        "vetuste"
    ],
    "vetyver": [
        "vetyver"
    ],
    "veteran": [
        "veteran"
    ],
    "veterans": [
        "veteran"
    ],
    "veterinaire": [
        "veterinaire"
    ],
    "veterinaires": [
        "veterinaire"
    ],
    "velage": [
        "velage"
    ],
    "velages": [
        "velage"
    ],
    "veler": [
        "veler"
    ],
    "vele": [
        "veler"
    ],
    "vepre": [
        "vepres"
    ],
    "vepres": [
        "vepre"
    ],
    "vet": [
        "vetir"
    ],
    "vetaient": [
        "vetir"
    ],
    "vetait": [
        "vetir"
    ],
    "vetant": [
        "vetir"
    ],
    "vete": [
        "vetir"
    ],
    "vetement": [
        "vetement"
    ],
    "vetements": [
        "vetement"
    ],
    "vetent": [
        "vetir"
    ],
    "vetez": [
        "vetir"
    ],
    "vetir": [
        "vetir"
    ],
    "vetira": [
        "vetir"
    ],
    "vetirais": [
        "vetir"
    ],
    "vetirait": [
        "vetir"
    ],
    "vetirons": [
        "vetir"
    ],
    "vetis": [
        "vetir"
    ],
    "vetit": [
        "vetir"
    ],
    "vetons": [
        "vetir"
    ],
    "vets": [
        "vetir",
        "vet"
    ],
    "vetu": [
        "vetir",
        "vetu"
    ],
    "vetue": [
        "vetir",
        "vetu"
    ],
    "vetues": [
        "vetir",
        "vetu"
    ],
    "veture": [
        "veture"
    ],
    "vetures": [
        "veture"
    ],
    "vetus": [
        "vetir",
        "vetu"
    ],
    "vimes": [
        "voir"
    ],
    "votres": [
        "votres"
    ],
    "w": [
        "w"
    ],
    "wagnerien": [
        "wagnerien"
    ],
    "wagnerienne": [
        "wagnerien"
    ],
    "wagneriennes": [
        "wagnerien"
    ],
    "wagon": [
        "wagon"
    ],
    "wagonnet": [
        "wagonnet"
    ],
    "wagonnets": [
        "wagonnet"
    ],
    "wagons": [
        "wagon"
    ],
    "wali": [
        "wali"
    ],
    "walkman": [
        "walkman"
    ],
    "walkmans": [
        "walkman"
    ],
    "walkyrie": [
        "walkyrie"
    ],
    "wallaby": [
        "wallaby"
    ],
    "wallace": [
        "wallace"
    ],
    "wallon": [
        "wallon"
    ],
    "wallonne": [
        "wallon"
    ],
    "walter": [
        "walter"
    ],
    "wapiti": [
        "wapiti"
    ],
    "wapitis": [
        "wapiti"
    ],
    "warning": [
        "warn",
        "warning"
    ],
    "warnings": [
        "warning"
    ],
    "warrants": [
        "warrant"
    ],
    "wassingue": [
        "wassingue"
    ],
    "wassingues": [
        "wassingue"
    ],
    "water": [
        "water"
    ],
    "waterman": [
        "waterman"
    ],
    "waterproof": [
        "waterproof"
    ],
    "waters": [
        "water"
    ],
    "watt": [
        "watt"
    ],
    "wattman": [
        "wattman"
    ],
    "watts": [
        "watt"
    ],
    "wax": [
        "wax"
    ],
    "web": [
        "web"
    ],
    "webcam": [
        "webcam"
    ],
    "weimarienne": [
        "weimarien"
    ],
    "weltanschauung": [
        "weltanschauung"
    ],
    "welter": [
        "welter"
    ],
    "welters": [
        "welter"
    ],
    "western": [
        "western"
    ],
    "westerns": [
        "western"
    ],
    "westphalien": [
        "westphalien"
    ],
    "westphaliennes": [
        "westphalien"
    ],
    "wharf": [
        "wharf"
    ],
    "whig": [
        "whig"
    ],
    "whigs": [
        "whig"
    ],
    "whipcord": [
        "whipcord"
    ],
    "whiskey": [
        "whiskey"
    ],
    "whiskies": [
        "whisky",
        "whiskies"
    ],
    "whisky": [
        "whisky"
    ],
    "whiskys": [
        "whisky"
    ],
    "whist": [
        "whist"
    ],
    "wicket": [
        "wicket"
    ],
    "wigwam": [
        "wigwam"
    ],
    "wigwams": [
        "wigwam"
    ],
    "wildcat": [
        "wildcat"
    ],
    "wilhelmien": [
        "wilhelmien"
    ],
    "willaya": [
        "willaya"
    ],
    "willayas": [
        "willaya"
    ],
    "william": [
        "william"
    ],
    "williams": [
        "williams"
    ],
    "winchester": [
        "winchester"
    ],
    "winchesters": [
        "winchester"
    ],
    "windsurf": [
        "windsurf"
    ],
    "wintergreen": [
        "wintergreen"
    ],
    "wishbone": [
        "wishbone"
    ],
    "wisigothe": [
        "wisigoth"
    ],
    "wisigothique": [
        "wisigothique"
    ],
    "wisigothiques": [
        "wisigothique"
    ],
    "wisigoths": [
        "wisigoth"
    ],
    "witz": [
        "witz"
    ],
    "wombat": [
        "wombat"
    ],
    "woofer": [
        "woofer"
    ],
    "woofers": [
        "woofer"
    ],
    "wouah": [
        "wouah"
    ],
    "wurtembergeois": [
        "wurtembergeois"
    ],
    "wurtembergeoise": [
        "wurtembergeois"
    ],
    "x": [
        "x"
    ],
    "xavier": [
        "xavier"
    ],
    "xiang": [
        "xiang"
    ],
    "xiphidion": [
        "xiphidion"
    ],
    "xiphoide": [
        "xiphoide"
    ],
    "xieme": [
        "xieme"
    ],
    "xylographie": [
        "xylographie"
    ],
    "xylophone": [
        "xylophone"
    ],
    "xylophones": [
        "xylophone"
    ],
    "xylophoniste": [
        "xylophoniste"
    ],
    "xylene": [
        "xylene"
    ],
    "xenogenese": [
        "xenogenese"
    ],
    "xenogreffe": [
        "xenogreffe"
    ],
    "xenon": [
        "xenon"
    ],
    "xenophilie": [
        "xenophilie"
    ],
    "xenophobe": [
        "xenophobe"
    ],
    "xenophobes": [
        "xenophobe"
    ],
    "xenophobie": [
        "xenophobie"
    ],
    "xerographie": [
        "xerographie"
    ],
    "xerographique": [
        "xerographique"
    ],
    "xeres": [
        "xeres"
    ],
    "y": [
        "y",
        "yu"
    ],
    "ya": [
        "you",
        "ya"
    ],
    "yacht": [
        "yacht"
    ],
    "yachting": [
        "yachting"
    ],
    "yachtman": [
        "yachtman"
    ],
    "yachtmen": [
        "yachtman"
    ],
    "yachts": [
        "yacht"
    ],
    "yachtwoman": [
        "yachtwoman"
    ],
    "yack": [
        "yack"
    ],
    "yacks": [
        "yack"
    ],
    "yak": [
        "yak"
    ],
    "yakitori": [
        "yakitori"
    ],
    "yaks": [
        "yak"
    ],
    "yakusa": [
        "yakusa"
    ],
    "yakuza": [
        "yakuza"
    ],
    "yakuzas": [
        "yakuza"
    ],
    "yali": [
        "yali"
    ],
    "yalis": [
        "yali"
    ],
    "yama": [
        "yama"
    ],
    "yang": [
        "yang"
    ],
    "yankee": [
        "yankee"
    ],
    "yankees": [
        "yankee"
    ],
    "yanquis": [
        "yanqui"
    ],
    "yaourt": [
        "yaourt"
    ],
    "yaourtieres": [
        "yaourtiere"
    ],
    "yaourts": [
        "yaourt"
    ],
    "yard": [
        "yard"
    ],
    "yards": [
        "yard"
    ],
    "yatagan": [
        "yatagan"
    ],
    "yatagans": [
        "yatagan"
    ],
    "yeah": [
        "yeah"
    ],
    "yearling": [
        "yearling"
    ],
    "yen": [
        "yen"
    ],
    "yens": [
        "yen"
    ],
    "yeshiva": [
        "yeshiva"
    ],
    "yeti": [
        "yeti"
    ],
    "yeuse": [
        "yeuse"
    ],
    "yeuses": [
        "yeuse"
    ],
    "yeux": [
        "oeil"
    ],
    "yiddish": [
        "yiddish"
    ],
    "yin": [
        "yin"
    ],
    "yodlait": [
        "yodler"
    ],
    "yodler": [
        "yodler"
    ],
    "yoga": [
        "yoga"
    ],
    "yoghourt": [
        "yoghourt"
    ],
    "yogi": [
        "yogi"
    ],
    "yogis": [
        "yogi"
    ],
    "yogourt": [
        "yogourt"
    ],
    "yole": [
        "yole"
    ],
    "york": [
        "york"
    ],
    "yorkshire": [
        "yorkshire"
    ],
    "yougoslave": [
        "yougoslave"
    ],
    "yougoslaves": [
        "yougoslave"
    ],
    "youp": [
        "youp"
    ],
    "youpi": [
        "youpi"
    ],
    "youpin": [
        "youpin"
    ],
    "youpine": [
        "youpin"
    ],
    "yourte": [
        "yourte"
    ],
    "yourtes": [
        "yourte"
    ],
    "youtre": [
        "youtre"
    ],
    "youyou": [
        "youyou"
    ],
    "youyous": [
        "youyou"
    ],
    "yoyo": [
        "yoyo"
    ],
    "yoyos": [
        "yoyo"
    ],
    "yperite": [
        "yperite"
    ],
    "yu": [
        "y"
    ],
    "yuan": [
        "yuan"
    ],
    "yuans": [
        "yuan"
    ],
    "yucca": [
        "yucca"
    ],
    "yuccas": [
        "yucca"
    ],
    "yue": [
        "yue"
    ],
    "yuppie": [
        "yuppie"
    ],
    "yuppies": [
        "yuppie"
    ],
    "yebles": [
        "yeble"
    ],
    "yemenites": [
        "yemenite"
    ],
    "yeye": [
        "yeye"
    ],
    "yeyes": [
        "yeye"
    ],
    "z": [
        "z"
    ],
    "zade": [
        "zader"
    ],
    "zaibatsu": [
        "zaibatsu"
    ],
    "zain": [
        "zain"
    ],
    "zakouski": [
        "zakouski"
    ],
    "zakouskis": [
        "zakouski"
    ],
    "zani": [
        "zani"
    ],
    "zanimaux": [
        "zanimaux"
    ],
    "zanzi": [
        "zanzi"
    ],
    "zanzibar": [
        "zanzibar"
    ],
    "zappant": [
        "zapper"
    ],
    "zappe": [
        "zapper"
    ],
    "zapper": [
        "zapper"
    ],
    "zapperai": [
        "zapper"
    ],
    "zapperait": [
        "zapper"
    ],
    "zappes": [
        "zapper"
    ],
    "zappeur": [
        "zappeur"
    ],
    "zappez": [
        "zapper"
    ],
    "zapping": [
        "zapping"
    ],
    "zarabe": [
        "zarabe"
    ],
    "zarbi": [
        "zarbi"
    ],
    "zarbis": [
        "zarbi"
    ],
    "zazou": [
        "zazou"
    ],
    "zazous": [
        "zazou"
    ],
    "zairois": [
        "zairois"
    ],
    "zairoise": [
        "zairois"
    ],
    "zairoises": [
        "zairois"
    ],
    "zeb": [
        "zeb"
    ],
    "zef": [
        "zef"
    ],
    "zelle": [
        "zelle"
    ],
    "zemstvo": [
        "zemstvo"
    ],
    "zen": [
        "zen"
    ],
    "zens": [
        "zen"
    ],
    "zeppelin": [
        "zeppelin"
    ],
    "zeppelins": [
        "zeppelin"
    ],
    "zest": [
        "zest"
    ],
    "zeste": [
        "zeste"
    ],
    "zester": [
        "zester"
    ],
    "zestes": [
        "zeste"
    ],
    "zibeline": [
        "zibeline"
    ],
    "zibelines": [
        "zibeline"
    ],
    "zicmu": [
        "zicmu"
    ],
    "zieute": [
        "zieuter"
    ],
    "zieutent": [
        "zieuter"
    ],
    "zieuter": [
        "zieuter"
    ],
    "zieutes": [
        "zieuter"
    ],
    "zieutez": [
        "zieuter"
    ],
    "zig": [
        "zig"
    ],
    "ziggourat": [
        "ziggourat"
    ],
    "ziggourats": [
        "ziggourat"
    ],
    "zigomar": [
        "zigomar"
    ],
    "zigomars": [
        "zigomar"
    ],
    "zigoto": [
        "zigoto"
    ],
    "zigotos": [
        "zigoto"
    ],
    "zigouillais": [
        "zigouiller"
    ],
    "zigouillait": [
        "zigouiller"
    ],
    "zigouille": [
        "zigouiller"
    ],
    "zigouillent": [
        "zigouiller"
    ],
    "zigouiller": [
        "zigouiller"
    ],
    "zigouillez": [
        "zigouiller"
    ],
    "zigouillees": [
        "zigouiller"
    ],
    "zigouilles": [
        "zigouiller"
    ],
    "zigounette": [
        "zigounette"
    ],
    "zigue": [
        "zigue"
    ],
    "zigues": [
        "zigue"
    ],
    "zigzag": [
        "zigzag"
    ],
    "zigzagant": [
        "zigzagant"
    ],
    "zigzagante": [
        "zigzagant"
    ],
    "zigzagantes": [
        "zigzagant"
    ],
    "zigzags": [
        "zigzag"
    ],
    "zigzagua": [
        "zigzaguer"
    ],
    "zigzaguai": [
        "zigzaguer"
    ],
    "zigzaguaient": [
        "zigzaguer"
    ],
    "zigzaguait": [
        "zigzaguer"
    ],
    "zigzaguant": [
        "zigzaguer"
    ],
    "zigzague": [
        "zigzaguer"
    ],
    "zigzaguent": [
        "zigzaguer"
    ],
    "zigzaguer": [
        "zigzaguer"
    ],
    "zigzaguerent": [
        "zigzaguer"
    ],
    "zigzaguee": [
        "zigzaguer"
    ],
    "zinc": [
        "zinc"
    ],
    "zincs": [
        "zinc"
    ],
    "zingage": [
        "zingage"
    ],
    "zingaro": [
        "zingaro"
    ],
    "zingue": [
        "zinguer"
    ],
    "zingues": [
        "zinguer"
    ],
    "zinnia": [
        "zinnia"
    ],
    "zinnias": [
        "zinnia"
    ],
    "zinzin": [
        "zinzin"
    ],
    "zinzins": [
        "zinzin"
    ],
    "zinzolin": [
        "zinzolin"
    ],
    "zip": [
        "zip"
    ],
    "zippa": [
        "zipper"
    ],
    "zippait": [
        "zipper"
    ],
    "zipper": [
        "zipper"
    ],
    "zippe": [
        "zipper"
    ],
    "zircon": [
        "zircon"
    ],
    "zirconium": [
        "zirconium"
    ],
    "zircons": [
        "zircon"
    ],
    "zizanie": [
        "zizanie"
    ],
    "zizanies": [
        "zizanie"
    ],
    "zizi": [
        "zizi"
    ],
    "zizique": [
        "zizique"
    ],
    "zizis": [
        "zizi"
    ],
    "zloty": [
        "zloty"
    ],
    "zlotys": [
        "zloty"
    ],
    "zob": [
        "zob"
    ],
    "zobs": [
        "zob"
    ],
    "zodiac": [
        "zodiac"
    ],
    "zodiacal": [
        "zodiacal"
    ],
    "zodiacale": [
        "zodiacal"
    ],
    "zodiaque": [
        "zodiaque"
    ],
    "zombi": [
        "zombi"
    ],
    "zombie": [
        "zombie"
    ],
    "zombies": [
        "zombie"
    ],
    "zombification": [
        "zombification"
    ],
    "zombis": [
        "zombi"
    ],
    "zona": [
        "zoner",
        "zona"
    ],
    "zonage": [
        "zonage"
    ],
    "zonait": [
        "zoner"
    ],
    "zonal": [
        "zonal"
    ],
    "zonant": [
        "zoner"
    ],
    "zonard": [
        "zonard"
    ],
    "zonarde": [
        "zonard"
    ],
    "zonardes": [
        "zonard"
    ],
    "zonards": [
        "zonard"
    ],
    "zonas": [
        "zona"
    ],
    "zone": [
        "zoner",
        "zone"
    ],
    "zoner": [
        "zoner"
    ],
    "zonera": [
        "zoner"
    ],
    "zones": [
        "zone"
    ],
    "zoning": [
        "zoning"
    ],
    "zonzon": [
        "zonzon"
    ],
    "zoo": [
        "zoo"
    ],
    "zoologie": [
        "zoologie"
    ],
    "zoologique": [
        "zoologique"
    ],
    "zoologiques": [
        "zoologique"
    ],
    "zoologiste": [
        "zoologiste"
    ],
    "zoologue": [
        "zoologue"
    ],
    "zoom": [
        "zoom"
    ],
    "zoome": [
        "zoomer"
    ],
    "zoomer": [
        "zoomer"
    ],
    "zoomes": [
        "zoomer"
    ],
    "zoomez": [
        "zoomer"
    ],
    "zooms": [
        "zoom"
    ],
    "zoophile": [
        "zoophile"
    ],
    "zoophiles": [
        "zoophile"
    ],
    "zoophilie": [
        "zoophilie"
    ],
    "zoos": [
        "zoo"
    ],
    "zoreille": [
        "zoreille"
    ],
    "zoreilles": [
        "zoreille"
    ],
    "zorille": [
        "zorille"
    ],
    "zoroastrien": [
        "zoroastrien"
    ],
    "zoroastriens": [
        "zoroastrien"
    ],
    "zoroastrisme": [
        "zoroastrisme"
    ],
    "zou": [
        "zou"
    ],
    "zouave": [
        "zouave"
    ],
    "zouaves": [
        "zouave"
    ],
    "zouk": [
        "zouk"
    ],
    "zoulou": [
        "zoulou"
    ],
    "zouloue": [
        "zoulou"
    ],
    "zoulous": [
        "zoulou"
    ],
    "zoziaux": [
        "zoziaux"
    ],
    "zozo": [
        "zozo"
    ],
    "zozos": [
        "zozo"
    ],
    "zozotait": [
        "zozoter"
    ],
    "zozotant": [
        "zozoter"
    ],
    "zozote": [
        "zozoter"
    ],
    "zozotement": [
        "zozotement"
    ],
    "zozotements": [
        "zozotement"
    ],
    "zozotes": [
        "zozoter"
    ],
    "zozoteuse": [
        "zozoteur"
    ],
    "zozotez": [
        "zozoter"
    ],
    "zurichois": [
        "zurichois"
    ],
    "zurichoise": [
        "zurichois"
    ],
    "zut": [
        "zut"
    ],
    "zydeco": [
        "zydeco"
    ],
    "zyeuta": [
        "zyeuter"
    ],
    "zyeutais": [
        "zyeuter"
    ],
    "zyeutait": [
        "zyeuter"
    ],
    "zyeutant": [
        "zyeuter"
    ],
    "zyeute": [
        "zyeuter"
    ],
    "zyeuter": [
        "zyeuter"
    ],
    "zyeutes": [
        "zyeuter"
    ],
    "zygoma": [
        "zygoma"
    ],
    "zygomatique": [
        "zygomatique"
    ],
    "zygomatiques": [
        "zygomatique"
    ],
    "zygote": [
        "zygote"
    ],
    "zyklon": [
        "zyklon"
    ],
    "zzz": [
        "zzz"
    ],
    "zzzz": [
        "zzzz"
    ],
    "zebre": [
        "zebre",
        "zebrer"
    ],
    "zebrent": [
        "zebrer"
    ],
    "zebres": [
        "zebre",
        "zebrer"
    ],
    "zele": [
        "zele"
    ],
    "zeles": [
        "zele"
    ],
    "zebra": [
        "zebrer"
    ],
    "zebraient": [
        "zebrer"
    ],
    "zebrait": [
        "zebrer"
    ],
    "zebrant": [
        "zebrer"
    ],
    "zebrer": [
        "zebrer"
    ],
    "zebrure": [
        "zebrure"
    ],
    "zebrures": [
        "zebrure"
    ],
    "zebree": [
        "zebre",
        "zebrer"
    ],
    "zebrees": [
        "zebre",
        "zebrer"
    ],
    "zebu": [
        "zebu"
    ],
    "zebus": [
        "zebu"
    ],
    "zelateur": [
        "zelateur"
    ],
    "zelateurs": [
        "zelateur"
    ],
    "zelatrice": [
        "zelateur"
    ],
    "zelote": [
        "zelote"
    ],
    "zelotes": [
        "zelote"
    ],
    "zelee": [
        "zele"
    ],
    "zelees": [
        "zele"
    ],
    "zenana": [
        "zenana"
    ],
    "zenith": [
        "zenith"
    ],
    "zenithale": [
        "zenithal"
    ],
    "zenithales": [
        "zenithal"
    ],
    "zephire": [
        "zephire"
    ],
    "zephyr": [
        "zephyr"
    ],
    "zephyrs": [
        "zephyr"
    ],
    "zero": [
        "zero"
    ],
    "zeros": [
        "zero"
    ],
    "zezaie": [
        "zezayer"
    ],
    "zezaiement": [
        "zezaiement"
    ],
    "zezaient": [
        "zezayer"
    ],
    "zezayaient": [
        "zezayer"
    ],
    "zezayant": [
        "zezayer"
    ],
    "zezaye": [
        "zezayer"
    ],
    "zezayer": [
        "zezayer"
    ],
    "zezette": [
        "zezette"
    ],
    "zezettes": [
        "zezette"
    ],
    "acrement": [
        "acrement"
    ],
    "acrete": [
        "acrete"
    ],
    "agisme": [
        "agisme"
    ],
    "agee": [
        "age"
    ],
    "agees": [
        "age"
    ],
    "ames": [
        "ame"
    ],
    "ane": [
        "ane"
    ],
    "anerie": [
        "anerie"
    ],
    "aneries": [
        "anerie"
    ],
    "anes": [
        "ane"
    ],
    "anesse": [
        "anesse"
    ],
    "anesses": [
        "anesse"
    ],
    "anier": [
        "anier"
    ],
    "anon": [
        "anon"
    ],
    "anonna": [
        "anonner"
    ],
    "anonnaient": [
        "anonner"
    ],
    "anonnait": [
        "anonner"
    ],
    "anonnant": [
        "anonner"
    ],
    "anonne": [
        "anonner"
    ],
    "anonnement": [
        "anonnement"
    ],
    "anonnements": [
        "anonnement"
    ],
    "anonner": [
        "anonner"
    ],
    "anonnions": [
        "anonner"
    ],
    "anonnes": [
        "anonner"
    ],
    "anons": [
        "anon"
    ],
    "apre": [
        "apre"
    ],
    "aprement": [
        "aprement"
    ],
    "aprete": [
        "aprete"
    ],
    "apretes": [
        "aprete"
    ],
    "atre": [
        "atre"
    ],
    "atres": [
        "atre"
    ],
    "ca": [
        "ca",
        "can",
        "ceci"
    ],
    "cruti": [
        "cruti"
    ],
    "ere": [
        "ere"
    ],
    "eres": [
        "ere"
    ],
    "eve": [
        "eve"
    ],
    "ebahi": [
        "ebahi",
        "ebahir"
    ],
    "ebahie": [
        "ebahi",
        "ebahir"
    ],
    "ebahies": [
        "ebahi"
    ],
    "ebahir": [
        "ebahir"
    ],
    "ebahirons": [
        "ebahir"
    ],
    "ebahis": [
        "ebahi",
        "ebahir"
    ],
    "ebahissait": [
        "ebahir"
    ],
    "ebahissant": [
        "ebahir"
    ],
    "ebahissement": [
        "ebahissement"
    ],
    "ebahissent": [
        "ebahir"
    ],
    "ebahissons": [
        "ebahir"
    ],
    "ebahit": [
        "ebahir"
    ],
    "ebarbage": [
        "ebarbage"
    ],
    "ebarbait": [
        "ebarber"
    ],
    "ebarber": [
        "ebarber"
    ],
    "ebarbe": [
        "ebarber"
    ],
    "ebat": [
        "ebattre"
    ],
    "ebats": [
        "ebat"
    ],
    "ebattaient": [
        "ebattre"
    ],
    "ebattait": [
        "ebattre"
    ],
    "ebattant": [
        "ebattre"
    ],
    "ebattements": [
        "ebattement"
    ],
    "ebattent": [
        "ebattre"
    ],
    "ebattit": [
        "ebattre"
    ],
    "ebattons": [
        "ebattre"
    ],
    "ebattre": [
        "ebattre"
    ],
    "ebaubi": [
        "ebaubir",
        "ebaubi"
    ],
    "ebaubie": [
        "ebaubir",
        "ebaubi"
    ],
    "ebaubis": [
        "ebaubir"
    ],
    "ebaubissaient": [
        "ebaubir"
    ],
    "ebaucha": [
        "ebaucher"
    ],
    "ebauchai": [
        "ebaucher"
    ],
    "ebauchaient": [
        "ebaucher"
    ],
    "ebauchais": [
        "ebaucher"
    ],
    "ebauchait": [
        "ebaucher"
    ],
    "ebauchant": [
        "ebaucher"
    ],
    "ebauche": [
        "ebaucher",
        "ebauche"
    ],
    "ebauchent": [
        "ebaucher"
    ],
    "ebaucher": [
        "ebaucher"
    ],
    "ebauches": [
        "ebauche"
    ],
    "ebaucheurs": [
        "ebaucheur"
    ],
    "ebauchons": [
        "ebaucher",
        "ebauchon"
    ],
    "ebauchat": [
        "ebaucher"
    ],
    "ebaucherent": [
        "ebaucher"
    ],
    "ebauchee": [
        "ebaucher",
        "ebauche"
    ],
    "ebauchees": [
        "ebauche"
    ],
    "ebaudi": [
        "ebaudir"
    ],
    "eberlua": [
        "eberluer"
    ],
    "eberluait": [
        "eberluer"
    ],
    "eberlue": [
        "eberluer",
        "eberlue"
    ],
    "eberluer": [
        "eberluer"
    ],
    "eberluee": [
        "eberluer",
        "eberlue"
    ],
    "eberluees": [
        "eberlue"
    ],
    "eberlues": [
        "eberluer",
        "eberlue"
    ],
    "ebloui": [
        "ebloui",
        "eblouir"
    ],
    "eblouie": [
        "ebloui",
        "eblouir"
    ],
    "eblouies": [
        "ebloui",
        "eblouir"
    ],
    "eblouir": [
        "eblouir"
    ],
    "eblouira": [
        "eblouir"
    ],
    "eblouirai": [
        "eblouir"
    ],
    "eblouirait": [
        "eblouir"
    ],
    "eblouirent": [
        "eblouir"
    ],
    "eblouirez": [
        "eblouir"
    ],
    "eblouis": [
        "ebloui",
        "eblouir"
    ],
    "eblouissaient": [
        "eblouir"
    ],
    "eblouissait": [
        "eblouir"
    ],
    "eblouissant": [
        "eblouir",
        "eblouissant"
    ],
    "eblouissante": [
        "eblouissant"
    ],
    "eblouissantes": [
        "eblouissant"
    ],
    "eblouissants": [
        "eblouissant"
    ],
    "eblouisse": [
        "eblouir"
    ],
    "eblouissement": [
        "eblouissement"
    ],
    "eblouissements": [
        "eblouissement"
    ],
    "eblouissent": [
        "eblouir"
    ],
    "eblouisses": [
        "eblouir"
    ],
    "eblouissez": [
        "eblouir"
    ],
    "eblouissions": [
        "eblouir"
    ],
    "eblouit": [
        "eblouir"
    ],
    "ebonite": [
        "ebonite"
    ],
    "eborgna": [
        "eborgner"
    ],
    "eborgne": [
        "eborgner"
    ],
    "eborgner": [
        "eborgner"
    ],
    "eboueur": [
        "eboueur"
    ],
    "eboueurs": [
        "eboueur"
    ],
    "ebouillanta": [
        "ebouillanter"
    ],
    "ebouillante": [
        "ebouillante",
        "ebouillanter"
    ],
    "ebouillanter": [
        "ebouillanter"
    ],
    "ebouillantee": [
        "ebouillante",
        "ebouillanter"
    ],
    "ebouillantees": [
        "ebouillante"
    ],
    "ebouillantes": [
        "ebouillante",
        "ebouillanter"
    ],
    "eboula": [
        "ebouler"
    ],
    "eboulaient": [
        "ebouler"
    ],
    "eboulait": [
        "ebouler"
    ],
    "eboulant": [
        "ebouler"
    ],
    "eboule": [
        "ebouler"
    ],
    "eboulement": [
        "eboulement"
    ],
    "eboulements": [
        "eboulement"
    ],
    "eboulent": [
        "ebouler"
    ],
    "ebouler": [
        "ebouler"
    ],
    "ebouleuses": [
        "ebouleux"
    ],
    "eboulis": [
        "eboulis"
    ],
    "eboulerent": [
        "ebouler"
    ],
    "eboulee": [
        "ebouler"
    ],
    "eboulees": [
        "ebouler"
    ],
    "eboules": [
        "ebouler"
    ],
    "ebouriffa": [
        "ebouriffer"
    ],
    "ebouriffaient": [
        "ebouriffer"
    ],
    "ebouriffait": [
        "ebouriffer"
    ],
    "ebouriffant": [
        "ebouriffer",
        "ebouriffant"
    ],
    "ebouriffante": [
        "ebouriffant"
    ],
    "ebouriffe": [
        "ebouriffer",
        "ebouriffe"
    ],
    "ebouriffent": [
        "ebouriffer"
    ],
    "ebouriffer": [
        "ebouriffer"
    ],
    "ebouriffee": [
        "ebouriffer",
        "ebouriffe"
    ],
    "ebouriffees": [
        "ebouriffer",
        "ebouriffe"
    ],
    "ebouriffes": [
        "ebouriffer",
        "ebouriffe"
    ],
    "ebouser": [
        "ebouser"
    ],
    "ebouzer": [
        "ebouzer"
    ],
    "ebouze": [
        "ebouzer"
    ],
    "eboue": [
        "ebouer"
    ],
    "ebrancha": [
        "ebrancher"
    ],
    "ebranchait": [
        "ebrancher"
    ],
    "ebranchant": [
        "ebrancher"
    ],
    "ebranchement": [
        "ebranchement"
    ],
    "ebrancher": [
        "ebrancher"
    ],
    "ebrancherez": [
        "ebrancher"
    ],
    "ebranche": [
        "ebranche"
    ],
    "ebranches": [
        "ebrancher"
    ],
    "ebranla": [
        "ebranler"
    ],
    "ebranlaient": [
        "ebranler"
    ],
    "ebranlait": [
        "ebranler"
    ],
    "ebranlant": [
        "ebranler"
    ],
    "ebranle": [
        "ebranler"
    ],
    "ebranlement": [
        "ebranlement"
    ],
    "ebranlements": [
        "ebranlement"
    ],
    "ebranlent": [
        "ebranler"
    ],
    "ebranler": [
        "ebranler"
    ],
    "ebranlera": [
        "ebranler"
    ],
    "ebranlerai": [
        "ebranler"
    ],
    "ebranleraient": [
        "ebranler"
    ],
    "ebranlerais": [
        "ebranler"
    ],
    "ebranlerait": [
        "ebranler"
    ],
    "ebranlat": [
        "ebranler"
    ],
    "ebranlerent": [
        "ebranler"
    ],
    "ebranlee": [
        "ebranler"
    ],
    "ebranlees": [
        "ebranler"
    ],
    "ebranles": [
        "ebranler"
    ],
    "ebriete": [
        "ebriete"
    ],
    "ebroua": [
        "ebrouer"
    ],
    "ebrouaient": [
        "ebrouer"
    ],
    "ebrouais": [
        "ebrouer"
    ],
    "ebrouait": [
        "ebrouer"
    ],
    "ebrouant": [
        "ebrouer"
    ],
    "ebroue": [
        "ebrouer"
    ],
    "ebrouement": [
        "ebrouement"
    ],
    "ebrouent": [
        "ebrouer"
    ],
    "ebrouer": [
        "ebrouer"
    ],
    "ebrouerent": [
        "ebrouer"
    ],
    "ebruita": [
        "ebruiter"
    ],
    "ebruite": [
        "ebruiter"
    ],
    "ebruitent": [
        "ebruiter"
    ],
    "ebruiter": [
        "ebruiter"
    ],
    "ebruitera": [
        "ebruiter"
    ],
    "ebruiterait": [
        "ebruiter"
    ],
    "ebruitez": [
        "ebruiter"
    ],
    "ebruitons": [
        "ebruiter"
    ],
    "ebruitat": [
        "ebruiter"
    ],
    "ebruitee": [
        "ebruiter"
    ],
    "ebreche": [
        "ebreche",
        "ebrecher"
    ],
    "ebrechaient": [
        "ebrecher"
    ],
    "ebrecher": [
        "ebrecher"
    ],
    "ebrechure": [
        "ebrechure"
    ],
    "ebrechures": [
        "ebrechure"
    ],
    "ebrechee": [
        "ebreche",
        "ebrecher"
    ],
    "ebrechees": [
        "ebreche",
        "ebrecher"
    ],
    "ebreches": [
        "ebreche",
        "ebrecher"
    ],
    "ebullition": [
        "ebullition"
    ],
    "ebene": [
        "ebene"
    ],
    "ebeniste": [
        "ebeniste"
    ],
    "ebenisterie": [
        "ebenisterie"
    ],
    "ebenisteries": [
        "ebenisterie"
    ],
    "ebenistes": [
        "ebeniste"
    ],
    "ecaillage": [
        "ecaillage"
    ],
    "ecaillaient": [
        "ecailler"
    ],
    "ecaillait": [
        "ecailler"
    ],
    "ecaillant": [
        "ecailler"
    ],
    "ecaille": [
        "ecaille",
        "ecailler"
    ],
    "ecaillent": [
        "ecailler"
    ],
    "ecailler": [
        "ecailler"
    ],
    "ecaillera": [
        "ecailler"
    ],
    "ecaillerai": [
        "ecailler"
    ],
    "ecaillers": [
        "ecailler"
    ],
    "ecailles": [
        "ecaille",
        "ecailler"
    ],
    "ecailleur": [
        "ecailleur"
    ],
    "ecailleuse": [
        "ecailleux"
    ],
    "ecailleuses": [
        "ecailleux"
    ],
    "ecailleux": [
        "ecailleux"
    ],
    "ecaillure": [
        "ecaillure"
    ],
    "ecaillures": [
        "ecaillure"
    ],
    "ecaillere": [
        "ecailler"
    ],
    "ecaillee": [
        "ecaille",
        "ecailler"
    ],
    "ecaillees": [
        "ecaille",
        "ecailler"
    ],
    "ecalait": [
        "ecaler"
    ],
    "ecale": [
        "ecale"
    ],
    "ecaler": [
        "ecaler"
    ],
    "ecales": [
        "ecale"
    ],
    "ecarlate": [
        "ecarlate"
    ],
    "ecarlates": [
        "ecarlate"
    ],
    "ecarquilla": [
        "ecarquiller"
    ],
    "ecarquillai": [
        "ecarquiller"
    ],
    "ecarquillaient": [
        "ecarquiller"
    ],
    "ecarquillais": [
        "ecarquiller"
    ],
    "ecarquillait": [
        "ecarquiller"
    ],
    "ecarquillant": [
        "ecarquiller"
    ],
    "ecarquille": [
        "ecarquiller"
    ],
    "ecarquillement": [
        "ecarquillement"
    ],
    "ecarquillent": [
        "ecarquiller"
    ],
    "ecarquiller": [
        "ecarquiller"
    ],
    "ecarquillez": [
        "ecarquiller"
    ],
    "ecarquillions": [
        "ecarquiller"
    ],
    "ecarquillerent": [
        "ecarquiller"
    ],
    "ecarquillee": [
        "ecarquiller"
    ],
    "ecarquillees": [
        "ecarquiller"
    ],
    "ecarquilles": [
        "ecarquiller"
    ],
    "ecart": [
        "ecart"
    ],
    "ecarta": [
        "ecarter"
    ],
    "ecartai": [
        "ecarter"
    ],
    "ecartaient": [
        "ecarter"
    ],
    "ecartais": [
        "ecarter"
    ],
    "ecartait": [
        "ecarter"
    ],
    "ecartant": [
        "ecarter"
    ],
    "ecarte": [
        "ecarte",
        "ecarter"
    ],
    "ecartela": [
        "ecarteler"
    ],
    "ecartelaient": [
        "ecarteler"
    ],
    "ecartelait": [
        "ecarteler"
    ],
    "ecartelant": [
        "ecarteler"
    ],
    "ecarteler": [
        "ecarteler"
    ],
    "ecartele": [
        "ecartele",
        "ecarteler"
    ],
    "ecartelee": [
        "ecartele",
        "ecarteler"
    ],
    "ecartelees": [
        "ecartele",
        "ecarteler"
    ],
    "ecarteles": [
        "ecartele",
        "ecarteler"
    ],
    "ecartement": [
        "ecartement"
    ],
    "ecartements": [
        "ecartement"
    ],
    "ecartent": [
        "ecarter"
    ],
    "ecarter": [
        "ecarter"
    ],
    "ecartera": [
        "ecarter"
    ],
    "ecarteraient": [
        "ecarter"
    ],
    "ecarterait": [
        "ecarter"
    ],
    "ecarteras": [
        "ecarter"
    ],
    "ecarterez": [
        "ecarter"
    ],
    "ecarteront": [
        "ecarter"
    ],
    "ecartes": [
        "ecarte",
        "ecarter"
    ],
    "ecarteur": [
        "ecarteur"
    ],
    "ecartez": [
        "ecarter"
    ],
    "ecartions": [
        "ecarter"
    ],
    "ecartons": [
        "ecarter"
    ],
    "ecarts": [
        "ecart"
    ],
    "ecartames": [
        "ecarter"
    ],
    "ecartat": [
        "ecarter"
    ],
    "ecartelement": [
        "ecartelement"
    ],
    "ecartelements": [
        "ecartelement"
    ],
    "ecartelent": [
        "ecarteler"
    ],
    "ecarteleront": [
        "ecarteler"
    ],
    "ecarterent": [
        "ecarter"
    ],
    "ecartee": [
        "ecarte",
        "ecarter"
    ],
    "ecartees": [
        "ecarte",
        "ecarter"
    ],
    "ecervele": [
        "ecervele"
    ],
    "ecervelee": [
        "ecervele"
    ],
    "ecervelees": [
        "ecervele"
    ],
    "ecerveles": [
        "ecervele"
    ],
    "echafaud": [
        "echafaud"
    ],
    "echafauda": [
        "echafauder"
    ],
    "echafaudage": [
        "echafaudage"
    ],
    "echafaudages": [
        "echafaudage"
    ],
    "echafaudaient": [
        "echafauder"
    ],
    "echafaudais": [
        "echafauder"
    ],
    "echafaudait": [
        "echafauder"
    ],
    "echafaudant": [
        "echafauder"
    ],
    "echafaude": [
        "echafauder"
    ],
    "echafaudent": [
        "echafauder"
    ],
    "echafauder": [
        "echafauder"
    ],
    "echafaudons": [
        "echafauder"
    ],
    "echafauds": [
        "echafaud"
    ],
    "echafauderent": [
        "echafauder"
    ],
    "echafaudees": [
        "echafauder"
    ],
    "echafaudes": [
        "echafauder"
    ],
    "echalas": [
        "echalas"
    ],
    "echalier": [
        "echalier"
    ],
    "echaliers": [
        "echalier"
    ],
    "echalote": [
        "echalote"
    ],
    "echalotes": [
        "echalote"
    ],
    "echancraient": [
        "echancrer"
    ],
    "echancre": [
        "echancre",
        "echancrer"
    ],
    "echancrer": [
        "echancrer"
    ],
    "echancrure": [
        "echancrure"
    ],
    "echancrures": [
        "echancrure"
    ],
    "echancree": [
        "echancre",
        "echancrer"
    ],
    "echancrees": [
        "echancre"
    ],
    "echancres": [
        "echancre"
    ],
    "echange": [
        "echanger",
        "echange"
    ],
    "echangea": [
        "echanger"
    ],
    "echangeables": [
        "echangeable"
    ],
    "echangeai": [
        "echanger"
    ],
    "echangeaient": [
        "echanger"
    ],
    "echangeais": [
        "echanger"
    ],
    "echangeait": [
        "echanger"
    ],
    "echangeant": [
        "echanger"
    ],
    "echangent": [
        "echanger"
    ],
    "echangeons": [
        "echanger"
    ],
    "echanger": [
        "echanger"
    ],
    "echangera": [
        "echanger"
    ],
    "echangerai": [
        "echanger"
    ],
    "echangeraient": [
        "echanger"
    ],
    "echangerais": [
        "echanger"
    ],
    "echangerait": [
        "echanger"
    ],
    "echangeras": [
        "echanger"
    ],
    "echangerez": [
        "echanger"
    ],
    "echangeriez": [
        "echanger"
    ],
    "echangerions": [
        "echanger"
    ],
    "echangerons": [
        "echanger"
    ],
    "echangeront": [
        "echanger"
    ],
    "echanges": [
        "echanger",
        "echange"
    ],
    "echangeur": [
        "echangeur"
    ],
    "echangeurs": [
        "echangeur"
    ],
    "echangez": [
        "echanger"
    ],
    "echangeames": [
        "echanger"
    ],
    "echangiez": [
        "echanger"
    ],
    "echangions": [
        "echanger"
    ],
    "echangisme": [
        "echangisme"
    ],
    "echangiste": [
        "echangiste"
    ],
    "echangistes": [
        "echangiste"
    ],
    "echangerent": [
        "echanger"
    ],
    "echangee": [
        "echanger"
    ],
    "echangees": [
        "echanger"
    ],
    "echanson": [
        "echanson"
    ],
    "echansons": [
        "echanson"
    ],
    "echantillon": [
        "echantillon"
    ],
    "echantillonnage": [
        "echantillonnage"
    ],
    "echantillonne": [
        "echantillonner"
    ],
    "echantillons": [
        "echantillon"
    ],
    "echappa": [
        "echapper"
    ],
    "echappai": [
        "echapper"
    ],
    "echappaient": [
        "echapper"
    ],
    "echappais": [
        "echapper"
    ],
    "echappait": [
        "echapper"
    ],
    "echappant": [
        "echapper"
    ],
    "echappatoire": [
        "echappatoire"
    ],
    "echappatoires": [
        "echappatoire"
    ],
    "echappe": [
        "echapper",
        "echappe"
    ],
    "echappement": [
        "echappement"
    ],
    "echappements": [
        "echappement"
    ],
    "echappent": [
        "echapper"
    ],
    "echapper": [
        "echapper"
    ],
    "echappera": [
        "echapper"
    ],
    "echapperai": [
        "echapper"
    ],
    "echapperaient": [
        "echapper"
    ],
    "echapperais": [
        "echapper"
    ],
    "echapperait": [
        "echapper"
    ],
    "echapperas": [
        "echapper"
    ],
    "echapperez": [
        "echapper"
    ],
    "echapperiez": [
        "echapper"
    ],
    "echapperions": [
        "echapper"
    ],
    "echapperons": [
        "echapper"
    ],
    "echapperont": [
        "echapper"
    ],
    "echappes": [
        "echapper",
        "echappe"
    ],
    "echappez": [
        "echapper"
    ],
    "echappiez": [
        "echapper"
    ],
    "echappions": [
        "echapper"
    ],
    "echappons": [
        "echapper"
    ],
    "echappames": [
        "echapper"
    ],
    "echappat": [
        "echapper"
    ],
    "echapperent": [
        "echapper"
    ],
    "echappee": [
        "echapper",
        "echappe",
        "echappee"
    ],
    "echappees": [
        "echapper",
        "echappe",
        "echappee"
    ],
    "echarde": [
        "echarde"
    ],
    "echardes": [
        "echarde"
    ],
    "echarnait": [
        "echarner"
    ],
    "echarner": [
        "echarner"
    ],
    "echarpe": [
        "echarpe",
        "echarper"
    ],
    "echarpent": [
        "echarper"
    ],
    "echarper": [
        "echarper"
    ],
    "echarperaient": [
        "echarper"
    ],
    "echarpes": [
        "echarpe",
        "echarper"
    ],
    "echarpee": [
        "echarper"
    ],
    "echasse": [
        "echasse"
    ],
    "echasses": [
        "echasse"
    ],
    "echassier": [
        "echassier"
    ],
    "echassiers": [
        "echassier"
    ],
    "echassiere": [
        "echassier"
    ],
    "echassieres": [
        "echassier"
    ],
    "echauder": [
        "echauder"
    ],
    "echauderont": [
        "echauder"
    ],
    "echaude": [
        "echauder",
        "echaude"
    ],
    "echaudee": [
        "echaude"
    ],
    "echaudes": [
        "echauder",
        "echaude"
    ],
    "echauffa": [
        "echauffer"
    ],
    "echauffaient": [
        "echauffer"
    ],
    "echauffais": [
        "echauffer"
    ],
    "echauffait": [
        "echauffer"
    ],
    "echauffant": [
        "echauffer"
    ],
    "echauffe": [
        "echauffer"
    ],
    "echauffement": [
        "echauffement"
    ],
    "echauffements": [
        "echauffement"
    ],
    "echauffent": [
        "echauffer"
    ],
    "echauffer": [
        "echauffer"
    ],
    "echauffez": [
        "echauffer"
    ],
    "echauffons": [
        "echauffer"
    ],
    "echauffouree": [
        "echauffouree"
    ],
    "echauffourees": [
        "echauffouree"
    ],
    "echauffee": [
        "echauffer"
    ],
    "echauffees": [
        "echauffer"
    ],
    "echauffes": [
        "echauffer"
    ],
    "echauguette": [
        "echauguette"
    ],
    "echauguettes": [
        "echauguette"
    ],
    "echec": [
        "echec"
    ],
    "echecs": [
        "echec"
    ],
    "echelle": [
        "echelle"
    ],
    "echelles": [
        "echelle"
    ],
    "echelon": [
        "echelon"
    ],
    "echelonnaient": [
        "echelonner"
    ],
    "echelonnait": [
        "echelonner"
    ],
    "echelonnant": [
        "echelonner"
    ],
    "echelonne": [
        "echelonner"
    ],
    "echelonnent": [
        "echelonner"
    ],
    "echelonner": [
        "echelonner"
    ],
    "echelonnerons": [
        "echelonner"
    ],
    "echelonnee": [
        "echelonner"
    ],
    "echelonnees": [
        "echelonner"
    ],
    "echelonnes": [
        "echelonner"
    ],
    "echelons": [
        "echelon"
    ],
    "echer": [
        "echer"
    ],
    "echeveau": [
        "echeveau"
    ],
    "echeveaux": [
        "echeveau"
    ],
    "echevelait": [
        "echeveler"
    ],
    "echevelant": [
        "echeveler"
    ],
    "echeveler": [
        "echeveler"
    ],
    "echevellement": [
        "echevellement"
    ],
    "echevele": [
        "echevele",
        "echeveler"
    ],
    "echevelee": [
        "echevele",
        "echeveler"
    ],
    "echevelees": [
        "echevele",
        "echeveler"
    ],
    "echeveles": [
        "echevele",
        "echeveler"
    ],
    "echevin": [
        "echevin"
    ],
    "echevins": [
        "echevin"
    ],
    "echina": [
        "echiner"
    ],
    "echinaient": [
        "echiner"
    ],
    "echinais": [
        "echiner"
    ],
    "echinait": [
        "echiner"
    ],
    "echinant": [
        "echiner"
    ],
    "echine": [
        "echiner",
        "echine"
    ],
    "echinent": [
        "echiner"
    ],
    "echiner": [
        "echiner"
    ],
    "echines": [
        "echiner",
        "echine"
    ],
    "echinodermes": [
        "echinoderme"
    ],
    "echinee": [
        "echiner"
    ],
    "echiquier": [
        "echiquier"
    ],
    "echiquiers": [
        "echiquier"
    ],
    "echo": [
        "echo"
    ],
    "echocardiogramme": [
        "echocardiogramme"
    ],
    "echocardiographie": [
        "echocardiographie"
    ],
    "echographie": [
        "echographie"
    ],
    "echographier": [
        "echographier"
    ],
    "echographiste": [
        "echographiste"
    ],
    "echoir": [
        "echoir"
    ],
    "echoirait": [
        "echoir"
    ],
    "echoit": [
        "echoir"
    ],
    "echolocalisation": [
        "echolocalisation"
    ],
    "echolocation": [
        "echolocation"
    ],
    "echoppe": [
        "echoppe"
    ],
    "echoppes": [
        "echoppe"
    ],
    "echos": [
        "echo"
    ],
    "echotier": [
        "echotier"
    ],
    "echotiers": [
        "echotier"
    ],
    "echotiere": [
        "echotier"
    ],
    "echoua": [
        "echouer"
    ],
    "echouage": [
        "echouage"
    ],
    "echouages": [
        "echouage"
    ],
    "echouai": [
        "echouer"
    ],
    "echouaient": [
        "echouer"
    ],
    "echouais": [
        "echouer"
    ],
    "echouait": [
        "echouer"
    ],
    "echouant": [
        "echouer"
    ],
    "echoue": [
        "echouer"
    ],
    "echouement": [
        "echouement"
    ],
    "echouent": [
        "echouer"
    ],
    "echouer": [
        "echouer"
    ],
    "echouera": [
        "echouer"
    ],
    "echouerai": [
        "echouer"
    ],
    "echoueraient": [
        "echouer"
    ],
    "echouerais": [
        "echouer"
    ],
    "echouerait": [
        "echouer"
    ],
    "echoueras": [
        "echouer"
    ],
    "echouerez": [
        "echouer"
    ],
    "echouerons": [
        "echouer"
    ],
    "echoueront": [
        "echouer"
    ],
    "echouez": [
        "echouer"
    ],
    "echouiez": [
        "echouer"
    ],
    "echouions": [
        "echouer"
    ],
    "echouons": [
        "echouer"
    ],
    "echouames": [
        "echouer"
    ],
    "echouat": [
        "echouer"
    ],
    "echouerent": [
        "echouer"
    ],
    "echouee": [
        "echouer"
    ],
    "echouees": [
        "echouer"
    ],
    "echoues": [
        "echouer"
    ],
    "echu": [
        "echoir"
    ],
    "echue": [
        "echoir"
    ],
    "echues": [
        "echoir"
    ],
    "echut": [
        "echoir"
    ],
    "echeance": [
        "echeance"
    ],
    "echeances": [
        "echeance"
    ],
    "echeancier": [
        "echeancier"
    ],
    "echeant": [
        "echeant"
    ],
    "eclaboussa": [
        "eclabousser"
    ],
    "eclaboussaient": [
        "eclabousser"
    ],
    "eclaboussait": [
        "eclabousser"
    ],
    "eclaboussant": [
        "eclaboussant",
        "eclabousser"
    ],
    "eclaboussante": [
        "eclaboussant"
    ],
    "eclaboussantes": [
        "eclaboussant"
    ],
    "eclaboussants": [
        "eclaboussant"
    ],
    "eclabousse": [
        "eclabousser"
    ],
    "eclaboussement": [
        "eclaboussement"
    ],
    "eclaboussements": [
        "eclaboussement"
    ],
    "eclaboussent": [
        "eclabousser"
    ],
    "eclabousser": [
        "eclabousser"
    ],
    "eclaboussera": [
        "eclabousser"
    ],
    "eclabousses": [
        "eclabousser"
    ],
    "eclaboussez": [
        "eclabousser"
    ],
    "eclaboussure": [
        "eclaboussure"
    ],
    "eclaboussures": [
        "eclaboussure"
    ],
    "eclabousserent": [
        "eclabousser"
    ],
    "eclaboussee": [
        "eclabousser"
    ],
    "eclaboussees": [
        "eclabousser"
    ],
    "eclair": [
        "eclair"
    ],
    "eclaira": [
        "eclairer"
    ],
    "eclairage": [
        "eclairage"
    ],
    "eclairages": [
        "eclairage"
    ],
    "eclairagiste": [
        "eclairagiste"
    ],
    "eclairagistes": [
        "eclairagiste"
    ],
    "eclairai": [
        "eclairer"
    ],
    "eclairaient": [
        "eclairer"
    ],
    "eclairais": [
        "eclairer"
    ],
    "eclairait": [
        "eclairer"
    ],
    "eclairant": [
        "eclairant",
        "eclairer"
    ],
    "eclairante": [
        "eclairant"
    ],
    "eclairantes": [
        "eclairant"
    ],
    "eclairants": [
        "eclairant"
    ],
    "eclairci": [
        "eclaircir"
    ],
    "eclaircie": [
        "eclaircie",
        "eclaircir"
    ],
    "eclaircies": [
        "eclaircie",
        "eclaircir"
    ],
    "eclaircir": [
        "eclaircir"
    ],
    "eclaircira": [
        "eclaircir"
    ],
    "eclaircirai": [
        "eclaircir"
    ],
    "eclaircirait": [
        "eclaircir"
    ],
    "eclairciras": [
        "eclaircir"
    ],
    "eclaircirez": [
        "eclaircir"
    ],
    "eclaircirons": [
        "eclaircir"
    ],
    "eclairciront": [
        "eclaircir"
    ],
    "eclaircis": [
        "eclaircir"
    ],
    "eclaircissage": [
        "eclaircissage"
    ],
    "eclaircissaient": [
        "eclaircir"
    ],
    "eclaircissait": [
        "eclaircir"
    ],
    "eclaircissant": [
        "eclaircir"
    ],
    "eclaircisse": [
        "eclaircir"
    ],
    "eclaircissement": [
        "eclaircissement"
    ],
    "eclaircissements": [
        "eclaircissement"
    ],
    "eclaircissent": [
        "eclaircir"
    ],
    "eclaircissez": [
        "eclaircir"
    ],
    "eclaircissons": [
        "eclaircir"
    ],
    "eclaircit": [
        "eclaircir"
    ],
    "eclaire": [
        "eclairer",
        "eclaire"
    ],
    "eclairement": [
        "eclairement"
    ],
    "eclairent": [
        "eclairer"
    ],
    "eclairer": [
        "eclairer"
    ],
    "eclairera": [
        "eclairer"
    ],
    "eclaireraient": [
        "eclairer"
    ],
    "eclairerait": [
        "eclairer"
    ],
    "eclaireront": [
        "eclairer"
    ],
    "eclaires": [
        "eclairer",
        "eclaire"
    ],
    "eclaireur": [
        "eclaireur"
    ],
    "eclaireurs": [
        "eclaireur"
    ],
    "eclaireuse": [
        "eclaireur"
    ],
    "eclaireuses": [
        "eclaireur"
    ],
    "eclairez": [
        "eclairer"
    ],
    "eclairiez": [
        "eclairer"
    ],
    "eclairons": [
        "eclairer"
    ],
    "eclairs": [
        "eclair"
    ],
    "eclairat": [
        "eclairer"
    ],
    "eclairerent": [
        "eclairer"
    ],
    "eclairee": [
        "eclairer",
        "eclaire"
    ],
    "eclairees": [
        "eclairer",
        "eclaire"
    ],
    "eclampsie": [
        "eclampsie"
    ],
    "eclamptique": [
        "eclamptique"
    ],
    "eclat": [
        "eclat"
    ],
    "eclata": [
        "eclater"
    ],
    "eclatage": [
        "eclatage"
    ],
    "eclatai": [
        "eclater"
    ],
    "eclataient": [
        "eclater"
    ],
    "eclatais": [
        "eclater"
    ],
    "eclatait": [
        "eclater"
    ],
    "eclatant": [
        "eclater",
        "eclatant"
    ],
    "eclatante": [
        "eclatant"
    ],
    "eclatantes": [
        "eclatant"
    ],
    "eclatants": [
        "eclatant"
    ],
    "eclate": [
        "eclate",
        "eclater"
    ],
    "eclatement": [
        "eclatement"
    ],
    "eclatements": [
        "eclatement"
    ],
    "eclatent": [
        "eclater"
    ],
    "eclater": [
        "eclater"
    ],
    "eclatera": [
        "eclater"
    ],
    "eclaterai": [
        "eclater"
    ],
    "eclateraient": [
        "eclater"
    ],
    "eclaterais": [
        "eclater"
    ],
    "eclaterait": [
        "eclater"
    ],
    "eclateras": [
        "eclater"
    ],
    "eclateriez": [
        "eclater"
    ],
    "eclateront": [
        "eclater"
    ],
    "eclates": [
        "eclate",
        "eclater"
    ],
    "eclateurs": [
        "eclateur"
    ],
    "eclatez": [
        "eclater"
    ],
    "eclatiez": [
        "eclater"
    ],
    "eclatons": [
        "eclater"
    ],
    "eclats": [
        "eclat"
    ],
    "eclatat": [
        "eclater"
    ],
    "eclaterent": [
        "eclater"
    ],
    "eclatee": [
        "eclate",
        "eclater"
    ],
    "eclatees": [
        "eclate",
        "eclater"
    ],
    "eclectique": [
        "eclectique"
    ],
    "eclectiques": [
        "eclectique"
    ],
    "eclectisme": [
        "eclectisme"
    ],
    "eclipsa": [
        "eclipser"
    ],
    "eclipsai": [
        "eclipser"
    ],
    "eclipsaient": [
        "eclipser"
    ],
    "eclipsait": [
        "eclipser"
    ],
    "eclipsant": [
        "eclipser"
    ],
    "eclipse": [
        "eclipser",
        "eclipse"
    ],
    "eclipsent": [
        "eclipser"
    ],
    "eclipser": [
        "eclipser"
    ],
    "eclipsera": [
        "eclipser"
    ],
    "eclipserais": [
        "eclipser"
    ],
    "eclipserait": [
        "eclipser"
    ],
    "eclipses": [
        "eclipser",
        "eclipse"
    ],
    "eclipsez": [
        "eclipser"
    ],
    "eclipsions": [
        "eclipser"
    ],
    "eclipserent": [
        "eclipser"
    ],
    "eclipsee": [
        "eclipser"
    ],
    "eclipsees": [
        "eclipser"
    ],
    "ecliptique": [
        "ecliptique"
    ],
    "eclisse": [
        "eclisse"
    ],
    "eclisses": [
        "eclisse"
    ],
    "eclopait": [
        "ecloper"
    ],
    "ecloper": [
        "ecloper"
    ],
    "eclope": [
        "eclope",
        "ecloper"
    ],
    "eclopee": [
        "eclope"
    ],
    "eclopes": [
        "eclope",
        "ecloper"
    ],
    "eclore": [
        "eclore"
    ],
    "eclos": [
        "eclos"
    ],
    "eclose": [
        "eclore",
        "eclos"
    ],
    "ecloses": [
        "eclos"
    ],
    "eclosion": [
        "eclosion"
    ],
    "eclosions": [
        "eclosion"
    ],
    "eclusa": [
        "ecluser"
    ],
    "eclusaient": [
        "ecluser"
    ],
    "eclusais": [
        "ecluser"
    ],
    "eclusait": [
        "ecluser"
    ],
    "eclusant": [
        "ecluser"
    ],
    "ecluse": [
        "ecluser",
        "ecluse"
    ],
    "eclusent": [
        "ecluser"
    ],
    "ecluser": [
        "ecluser"
    ],
    "ecluses": [
        "ecluse"
    ],
    "eclusier": [
        "eclusier"
    ],
    "eclusiers": [
        "eclusier"
    ],
    "eclusee": [
        "ecluser"
    ],
    "eclusees": [
        "ecluser"
    ],
    "ecoeura": [
        "ecoeurer"
    ],
    "ecoeuraient": [
        "ecoeurer"
    ],
    "ecoeurais": [
        "ecoeurer"
    ],
    "ecoeurait": [
        "ecoeurer"
    ],
    "ecoeurant": [
        "ecoeurer",
        "ecoeurant"
    ],
    "ecoeurante": [
        "ecoeurant"
    ],
    "ecoeurantes": [
        "ecoeurant"
    ],
    "ecoeurants": [
        "ecoeurant"
    ],
    "ecoeure": [
        "ecoeurer",
        "ecoeure"
    ],
    "ecoeurement": [
        "ecoeurement"
    ],
    "ecoeurements": [
        "ecoeurement"
    ],
    "ecoeurent": [
        "ecoeurer"
    ],
    "ecoeurer": [
        "ecoeurer"
    ],
    "ecoeurerais": [
        "ecoeurer"
    ],
    "ecoeurez": [
        "ecoeurer"
    ],
    "ecoeurerent": [
        "ecoeurer"
    ],
    "ecoeuree": [
        "ecoeurer",
        "ecoeure"
    ],
    "ecoeurees": [
        "ecoeurer"
    ],
    "ecoeures": [
        "ecoeurer",
        "ecoeure"
    ],
    "ecoincon": [
        "ecoincon"
    ],
    "ecole": [
        "ecole"
    ],
    "ecoles": [
        "ecole"
    ],
    "ecolier": [
        "ecolier"
    ],
    "ecoliers": [
        "ecolier"
    ],
    "ecoliere": [
        "ecolier"
    ],
    "ecolieres": [
        "ecolier"
    ],
    "ecolo": [
        "ecolo"
    ],
    "ecologie": [
        "ecologie"
    ],
    "ecologique": [
        "ecologique"
    ],
    "ecologiquement": [
        "ecologiquement"
    ],
    "ecologiques": [
        "ecologique"
    ],
    "ecologiste": [
        "ecologiste"
    ],
    "ecologistes": [
        "ecologiste"
    ],
    "ecolos": [
        "ecolo"
    ],
    "econduira": [
        "econduire"
    ],
    "econduire": [
        "econduire"
    ],
    "econduis": [
        "econduire"
    ],
    "econduisirent": [
        "econduire"
    ],
    "econduisit": [
        "econduire"
    ],
    "econduit": [
        "econduire"
    ],
    "econduite": [
        "econduire"
    ],
    "econduits": [
        "econduire"
    ],
    "econocroques": [
        "econocroques"
    ],
    "economat": [
        "economat"
    ],
    "econome": [
        "econome"
    ],
    "economes": [
        "econome"
    ],
    "economie": [
        "economie"
    ],
    "economies": [
        "economy",
        "economie"
    ],
    "economique": [
        "economique"
    ],
    "economiquement": [
        "economiquement"
    ],
    "economiques": [
        "economique"
    ],
    "economisaient": [
        "economiser"
    ],
    "economisais": [
        "economiser"
    ],
    "economisait": [
        "economiser"
    ],
    "economisant": [
        "economiser"
    ],
    "economise": [
        "economiser"
    ],
    "economisent": [
        "economiser"
    ],
    "economiser": [
        "economiser"
    ],
    "economisera": [
        "economiser"
    ],
    "economiserai": [
        "economiser"
    ],
    "economiserais": [
        "economiser"
    ],
    "economiserait": [
        "economiser"
    ],
    "economiserez": [
        "economiser"
    ],
    "economiserons": [
        "economiser"
    ],
    "economiseront": [
        "economiser"
    ],
    "economiseur": [
        "economiseur"
    ],
    "economiseurs": [
        "economiseur"
    ],
    "economisez": [
        "economiser"
    ],
    "economisme": [
        "economisme"
    ],
    "economisons": [
        "economiser"
    ],
    "economiste": [
        "economiste"
    ],
    "economistes": [
        "economiste"
    ],
    "economisee": [
        "economiser"
    ],
    "economisees": [
        "economiser"
    ],
    "economises": [
        "economiser"
    ],
    "ecopa": [
        "ecoper"
    ],
    "ecopai": [
        "ecoper"
    ],
    "ecopais": [
        "ecoper"
    ],
    "ecopait": [
        "ecoper"
    ],
    "ecope": [
        "ecoper",
        "ecope"
    ],
    "ecopent": [
        "ecoper"
    ],
    "ecoper": [
        "ecoper"
    ],
    "ecopera": [
        "ecoper"
    ],
    "ecoperai": [
        "ecoper"
    ],
    "ecoperait": [
        "ecoper"
    ],
    "ecoperas": [
        "ecoper"
    ],
    "ecoperches": [
        "ecoperche"
    ],
    "ecoperez": [
        "ecoper"
    ],
    "ecoperont": [
        "ecoper"
    ],
    "ecopes": [
        "ecoper",
        "ecope"
    ],
    "ecopez": [
        "ecoper"
    ],
    "ecopiez": [
        "ecoper"
    ],
    "ecopons": [
        "ecoper"
    ],
    "ecopee": [
        "ecoper"
    ],
    "ecorce": [
        "ecorce",
        "ecorcer"
    ],
    "ecorcer": [
        "ecorcer"
    ],
    "ecorces": [
        "ecorce"
    ],
    "ecorcha": [
        "ecorcher"
    ],
    "ecorchage": [
        "ecorchage"
    ],
    "ecorchaient": [
        "ecorcher"
    ],
    "ecorchais": [
        "ecorcher"
    ],
    "ecorchait": [
        "ecorcher"
    ],
    "ecorchant": [
        "ecorcher"
    ],
    "ecorche": [
        "ecorcher",
        "ecorche"
    ],
    "ecorchement": [
        "ecorchement"
    ],
    "ecorchent": [
        "ecorcher"
    ],
    "ecorcher": [
        "ecorcher"
    ],
    "ecorchera": [
        "ecorcher"
    ],
    "ecorcherai": [
        "ecorcher"
    ],
    "ecorcherais": [
        "ecorcher"
    ],
    "ecorcherait": [
        "ecorcher"
    ],
    "ecorcherie": [
        "ecorcherie"
    ],
    "ecorcheront": [
        "ecorcher"
    ],
    "ecorcheur": [
        "ecorcheur"
    ],
    "ecorcheurs": [
        "ecorcheur"
    ],
    "ecorchez": [
        "ecorcher"
    ],
    "ecorchiez": [
        "ecorcher"
    ],
    "ecorchions": [
        "ecorcher"
    ],
    "ecorchure": [
        "ecorchure"
    ],
    "ecorchures": [
        "ecorchure"
    ],
    "ecorchee": [
        "ecorcher",
        "ecorche"
    ],
    "ecorchees": [
        "ecorcher",
        "ecorche"
    ],
    "ecorches": [
        "ecorcher",
        "ecorche"
    ],
    "ecornait": [
        "ecorner"
    ],
    "ecornent": [
        "ecorner"
    ],
    "ecorner": [
        "ecorner"
    ],
    "ecornifler": [
        "ecornifler"
    ],
    "ecorne": [
        "ecorne",
        "ecorner"
    ],
    "ecornee": [
        "ecorne",
        "ecorner"
    ],
    "ecornees": [
        "ecorne",
        "ecorner"
    ],
    "ecornes": [
        "ecorne",
        "ecorner"
    ],
    "ecosphere": [
        "ecosphere"
    ],
    "ecossa": [
        "ecosser"
    ],
    "ecossaient": [
        "ecosser"
    ],
    "ecossais": [
        "ecosser",
        "ecossais"
    ],
    "ecossaise": [
        "ecossais"
    ],
    "ecossaises": [
        "ecossais"
    ],
    "ecossait": [
        "ecosser"
    ],
    "ecossant": [
        "ecosser"
    ],
    "ecosse": [
        "ecosser",
        "ecosse"
    ],
    "ecossent": [
        "ecosser"
    ],
    "ecosser": [
        "ecosser"
    ],
    "ecosses": [
        "ecosser"
    ],
    "ecosysteme": [
        "ecosysteme"
    ],
    "ecosystemes": [
        "ecosysteme"
    ],
    "ecot": [
        "ecot"
    ],
    "ecotone": [
        "ecotone"
    ],
    "ecoula": [
        "ecouler"
    ],
    "ecoulaient": [
        "ecouler"
    ],
    "ecoulait": [
        "ecouler"
    ],
    "ecoulant": [
        "ecouler"
    ],
    "ecoule": [
        "ecouler",
        "ecoule"
    ],
    "ecoulement": [
        "ecoulement"
    ],
    "ecoulements": [
        "ecoulement"
    ],
    "ecoulent": [
        "ecouler"
    ],
    "ecouler": [
        "ecouler"
    ],
    "ecoulera": [
        "ecouler"
    ],
    "ecouleraient": [
        "ecouler"
    ],
    "ecoulerait": [
        "ecouler"
    ],
    "ecouleront": [
        "ecouler"
    ],
    "ecoulat": [
        "ecouler"
    ],
    "ecoulerent": [
        "ecouler"
    ],
    "ecoulee": [
        "ecouler",
        "ecoule"
    ],
    "ecoulees": [
        "ecouler",
        "ecoule"
    ],
    "ecoules": [
        "ecouler",
        "ecoule"
    ],
    "ecourta": [
        "ecourter"
    ],
    "ecourtaient": [
        "ecourter"
    ],
    "ecourtais": [
        "ecourter"
    ],
    "ecourtant": [
        "ecourter"
    ],
    "ecourte": [
        "ecourte",
        "ecourter"
    ],
    "ecourter": [
        "ecourter"
    ],
    "ecourtera": [
        "ecourter"
    ],
    "ecourteraient": [
        "ecourter"
    ],
    "ecourtee": [
        "ecourte",
        "ecourter"
    ],
    "ecourtees": [
        "ecourte",
        "ecourter"
    ],
    "ecourtes": [
        "ecourte",
        "ecourter"
    ],
    "ecouta": [
        "ecouter"
    ],
    "ecoutai": [
        "ecouter"
    ],
    "ecoutaient": [
        "ecouter"
    ],
    "ecoutais": [
        "ecouter"
    ],
    "ecoutait": [
        "ecouter"
    ],
    "ecoutant": [
        "ecoutant",
        "ecouter"
    ],
    "ecoute": [
        "ecoute",
        "ecouter"
    ],
    "ecoutent": [
        "ecouter"
    ],
    "ecouter": [
        "ecouter"
    ],
    "ecoutera": [
        "ecouter"
    ],
    "ecouterai": [
        "ecouter"
    ],
    "ecouteraient": [
        "ecouter"
    ],
    "ecouterais": [
        "ecouter"
    ],
    "ecouterait": [
        "ecouter"
    ],
    "ecouteras": [
        "ecouter"
    ],
    "ecouterez": [
        "ecouter"
    ],
    "ecouteriez": [
        "ecouter"
    ],
    "ecouterons": [
        "ecouter"
    ],
    "ecouteront": [
        "ecouter"
    ],
    "ecoutes": [
        "ecoute",
        "ecouter"
    ],
    "ecouteur": [
        "ecouteur"
    ],
    "ecouteurs": [
        "ecouteur"
    ],
    "ecouteuse": [
        "ecouteur"
    ],
    "ecoutez": [
        "ecouter"
    ],
    "ecoutiez": [
        "ecouter"
    ],
    "ecoutille": [
        "ecoutille"
    ],
    "ecoutilles": [
        "ecoutille"
    ],
    "ecoutions": [
        "ecouter"
    ],
    "ecoutons": [
        "ecouter"
    ],
    "ecoutames": [
        "ecouter"
    ],
    "ecoutat": [
        "ecouter"
    ],
    "ecouterent": [
        "ecouter"
    ],
    "ecoutee": [
        "ecouter"
    ],
    "ecoutees": [
        "ecouter"
    ],
    "ecouvillon": [
        "ecouvillon"
    ],
    "ecouvillonne": [
        "ecouvillonner"
    ],
    "ecouvillons": [
        "ecouvillon"
    ],
    "ecrabouilla": [
        "ecrabouiller"
    ],
    "ecrabouillage": [
        "ecrabouillage"
    ],
    "ecrabouillait": [
        "ecrabouiller"
    ],
    "ecrabouillant": [
        "ecrabouiller"
    ],
    "ecrabouille": [
        "ecrabouiller"
    ],
    "ecrabouillement": [
        "ecrabouillement"
    ],
    "ecrabouillements": [
        "ecrabouillement"
    ],
    "ecrabouiller": [
        "ecrabouiller"
    ],
    "ecrabouillera": [
        "ecrabouiller"
    ],
    "ecrabouillons": [
        "ecrabouiller"
    ],
    "ecrabouillerent": [
        "ecrabouiller"
    ],
    "ecrabouillee": [
        "ecrabouiller"
    ],
    "ecrabouillees": [
        "ecrabouiller"
    ],
    "ecrabouilles": [
        "ecrabouiller"
    ],
    "ecran": [
        "ecran"
    ],
    "ecrans": [
        "ecran"
    ],
    "ecrasa": [
        "ecraser"
    ],
    "ecrasage": [
        "ecrasage"
    ],
    "ecrasai": [
        "ecraser"
    ],
    "ecrasaient": [
        "ecraser"
    ],
    "ecrasais": [
        "ecraser"
    ],
    "ecrasait": [
        "ecraser"
    ],
    "ecrasant": [
        "ecraser",
        "ecrasant"
    ],
    "ecrasante": [
        "ecrasant"
    ],
    "ecrasantes": [
        "ecrasant"
    ],
    "ecrasants": [
        "ecrasant"
    ],
    "ecrase": [
        "ecraser",
        "ecrase"
    ],
    "ecrasement": [
        "ecrasement"
    ],
    "ecrasements": [
        "ecrasement"
    ],
    "ecrasent": [
        "ecraser"
    ],
    "ecraser": [
        "ecraser"
    ],
    "ecrasera": [
        "ecraser"
    ],
    "ecraserai": [
        "ecraser"
    ],
    "ecraseraient": [
        "ecraser"
    ],
    "ecraserais": [
        "ecraser"
    ],
    "ecraserait": [
        "ecraser"
    ],
    "ecraseras": [
        "ecraser"
    ],
    "ecraserez": [
        "ecraser"
    ],
    "ecraserons": [
        "ecraser"
    ],
    "ecraseront": [
        "ecraser"
    ],
    "ecrases": [
        "ecraser",
        "ecrase"
    ],
    "ecraseur": [
        "ecraseur"
    ],
    "ecrasez": [
        "ecraser"
    ],
    "ecrasiez": [
        "ecraser"
    ],
    "ecrasions": [
        "ecraser"
    ],
    "ecrasons": [
        "ecraser"
    ],
    "ecrasure": [
        "ecrasure"
    ],
    "ecrasat": [
        "ecraser"
    ],
    "ecraserent": [
        "ecraser"
    ],
    "ecrasee": [
        "ecraser",
        "ecrase"
    ],
    "ecrasees": [
        "ecraser",
        "ecrase"
    ],
    "ecrevisse": [
        "ecrevisse"
    ],
    "ecrevisses": [
        "ecrevisse"
    ],
    "ecria": [
        "ecrier"
    ],
    "ecriai": [
        "ecrier"
    ],
    "ecriaient": [
        "ecrier"
    ],
    "ecriais": [
        "ecrier"
    ],
    "ecriait": [
        "ecrier"
    ],
    "ecriant": [
        "ecrier"
    ],
    "ecrie": [
        "ecrier"
    ],
    "ecrient": [
        "ecrier"
    ],
    "ecrier": [
        "ecrier"
    ],
    "ecriera": [
        "ecrier"
    ],
    "ecrierait": [
        "ecrier"
    ],
    "ecries": [
        "ecrier"
    ],
    "ecrin": [
        "ecrin"
    ],
    "ecrins": [
        "ecrin"
    ],
    "ecrions": [
        "ecrier"
    ],
    "ecrira": [
        "ecrire"
    ],
    "ecrirai": [
        "ecrire"
    ],
    "ecriraient": [
        "ecrire"
    ],
    "ecrirais": [
        "ecrire"
    ],
    "ecrirait": [
        "ecrire"
    ],
    "ecriras": [
        "ecrire"
    ],
    "ecrire": [
        "ecrire"
    ],
    "ecrirez": [
        "ecrire"
    ],
    "ecririez": [
        "ecrire"
    ],
    "ecrirons": [
        "ecrire"
    ],
    "ecriront": [
        "ecrire"
    ],
    "ecris": [
        "ecrire"
    ],
    "ecrit": [
        "ecrire",
        "ecrit"
    ],
    "ecrite": [
        "ecrire",
        "ecrit"
    ],
    "ecriteau": [
        "ecriteau"
    ],
    "ecriteaux": [
        "ecriteau"
    ],
    "ecrites": [
        "ecrire",
        "ecrit"
    ],
    "ecritoire": [
        "ecritoire"
    ],
    "ecritoires": [
        "ecritoire"
    ],
    "ecrits": [
        "ecrire",
        "ecrit"
    ],
    "ecriture": [
        "ecriture"
    ],
    "ecritures": [
        "ecriture"
    ],
    "ecrivaient": [
        "ecrire"
    ],
    "ecrivailler": [
        "ecrivailler"
    ],
    "ecrivailleur": [
        "ecrivailleur"
    ],
    "ecrivaillon": [
        "ecrivaillon"
    ],
    "ecrivaillons": [
        "ecrivaillon"
    ],
    "ecrivaille": [
        "ecrivailler"
    ],
    "ecrivain": [
        "ecrivain"
    ],
    "ecrivaine": [
        "ecrivain"
    ],
    "ecrivaines": [
        "ecrivain"
    ],
    "ecrivains": [
        "ecrivain"
    ],
    "ecrivais": [
        "ecrire"
    ],
    "ecrivait": [
        "ecrire"
    ],
    "ecrivant": [
        "ecrire"
    ],
    "ecrivassiers": [
        "ecrivassier"
    ],
    "ecrive": [
        "ecrire"
    ],
    "ecrivent": [
        "ecrire"
    ],
    "ecrives": [
        "ecrire"
    ],
    "ecriveur": [
        "ecriveur"
    ],
    "ecrivez": [
        "ecrire"
    ],
    "ecriviez": [
        "ecrire"
    ],
    "ecrivions": [
        "ecrire"
    ],
    "ecrivirent": [
        "ecrire"
    ],
    "ecrivis": [
        "ecrire"
    ],
    "ecrivisse": [
        "ecrire"
    ],
    "ecrivit": [
        "ecrire"
    ],
    "ecrivons": [
        "ecrire"
    ],
    "ecrivimes": [
        "ecrire"
    ],
    "ecriat": [
        "ecrier"
    ],
    "ecrierent": [
        "ecrier"
    ],
    "ecriee": [
        "ecrier"
    ],
    "ecrou": [
        "ecrou"
    ],
    "ecrouelles": [
        "ecrouelles"
    ],
    "ecrouer": [
        "ecrouer"
    ],
    "ecroueront": [
        "ecrouer"
    ],
    "ecroula": [
        "ecrouler"
    ],
    "ecroulai": [
        "ecrouler"
    ],
    "ecroulaient": [
        "ecrouler"
    ],
    "ecroulais": [
        "ecrouler"
    ],
    "ecroulait": [
        "ecrouler"
    ],
    "ecroulant": [
        "ecrouler"
    ],
    "ecroule": [
        "ecrouler"
    ],
    "ecroulement": [
        "ecroulement"
    ],
    "ecroulements": [
        "ecroulement"
    ],
    "ecroulent": [
        "ecrouler"
    ],
    "ecrouler": [
        "ecrouler"
    ],
    "ecroulera": [
        "ecrouler"
    ],
    "ecroulerai": [
        "ecrouler"
    ],
    "ecrouleraient": [
        "ecrouler"
    ],
    "ecroulerais": [
        "ecrouler"
    ],
    "ecroulerait": [
        "ecrouler"
    ],
    "ecrouleras": [
        "ecrouler"
    ],
    "ecroulerions": [
        "ecrouler"
    ],
    "ecrouleront": [
        "ecrouler"
    ],
    "ecroulions": [
        "ecrouler"
    ],
    "ecroulons": [
        "ecrouler"
    ],
    "ecroulat": [
        "ecrouler"
    ],
    "ecroulerent": [
        "ecrouler"
    ],
    "ecroulee": [
        "ecrouler"
    ],
    "ecroulees": [
        "ecrouler"
    ],
    "ecroules": [
        "ecrouler"
    ],
    "ecrous": [
        "ecrou"
    ],
    "ecroue": [
        "ecrouer"
    ],
    "ecrouee": [
        "ecrouer"
    ],
    "ecru": [
        "ecru"
    ],
    "ecrue": [
        "ecru"
    ],
    "ecreme": [
        "ecremer"
    ],
    "ecremage": [
        "ecremage"
    ],
    "ecremer": [
        "ecremer"
    ],
    "ecremeuse": [
        "ecremeur"
    ],
    "ecremees": [
        "ecremer"
    ],
    "ecretait": [
        "ecreter"
    ],
    "ecreter": [
        "ecreter"
    ],
    "ecretee": [
        "ecreter"
    ],
    "ecu": [
        "ecu"
    ],
    "ecubier": [
        "ecubier"
    ],
    "ecueil": [
        "ecueil"
    ],
    "ecueils": [
        "ecueil"
    ],
    "ecuelle": [
        "ecuelle"
    ],
    "ecuelles": [
        "ecuelle"
    ],
    "ecuellee": [
        "ecuellee"
    ],
    "ecuellees": [
        "ecuellee"
    ],
    "ecuisse": [
        "ecuisser"
    ],
    "ecuissees": [
        "ecuisser"
    ],
    "eculer": [
        "eculer"
    ],
    "ecule": [
        "ecule",
        "eculer"
    ],
    "eculee": [
        "ecule",
        "eculer"
    ],
    "eculees": [
        "ecule",
        "eculer"
    ],
    "ecules": [
        "ecule",
        "eculer"
    ],
    "ecuma": [
        "ecumer"
    ],
    "ecumai": [
        "ecumer"
    ],
    "ecumaient": [
        "ecumer"
    ],
    "ecumais": [
        "ecumer"
    ],
    "ecumait": [
        "ecumer"
    ],
    "ecumant": [
        "ecumer",
        "ecumant"
    ],
    "ecumante": [
        "ecumant"
    ],
    "ecumantes": [
        "ecumant"
    ],
    "ecumants": [
        "ecumant"
    ],
    "ecume": [
        "ecumer",
        "ecume"
    ],
    "ecument": [
        "ecumer"
    ],
    "ecumer": [
        "ecumer"
    ],
    "ecumera": [
        "ecumer"
    ],
    "ecumeront": [
        "ecumer"
    ],
    "ecumes": [
        "ecume"
    ],
    "ecumeur": [
        "ecumeur"
    ],
    "ecumeurs": [
        "ecumeur"
    ],
    "ecumeuse": [
        "ecumeux"
    ],
    "ecumeuses": [
        "ecumeur",
        "ecumeux"
    ],
    "ecumeux": [
        "ecumeux"
    ],
    "ecumez": [
        "ecumer"
    ],
    "ecumiez": [
        "ecumer"
    ],
    "ecumoire": [
        "ecumoire"
    ],
    "ecumoires": [
        "ecumoire"
    ],
    "ecumames": [
        "ecumer"
    ],
    "ecumerent": [
        "ecumer"
    ],
    "ecumee": [
        "ecumer"
    ],
    "ecureuil": [
        "ecureuil"
    ],
    "ecureuils": [
        "ecureuil"
    ],
    "ecurie": [
        "ecurie"
    ],
    "ecuries": [
        "ecurie"
    ],
    "ecus": [
        "ecu"
    ],
    "ecusson": [
        "ecusson"
    ],
    "ecussonne": [
        "ecussonner"
    ],
    "ecussonnees": [
        "ecussonner"
    ],
    "ecussonnes": [
        "ecussonner"
    ],
    "ecussons": [
        "ecusson"
    ],
    "ecuyer": [
        "ecuyer"
    ],
    "ecuyers": [
        "ecuyer"
    ],
    "ecuyere": [
        "ecuyer"
    ],
    "ecuyeres": [
        "ecuyer"
    ],
    "edam": [
        "edam"
    ],
    "eden": [
        "eden"
    ],
    "edens": [
        "eden"
    ],
    "edente": [
        "edente",
        "edenter"
    ],
    "edentee": [
        "edente",
        "edenter"
    ],
    "edentees": [
        "edente",
        "edenter"
    ],
    "edentes": [
        "edente",
        "edenter"
    ],
    "edicte": [
        "edicter"
    ],
    "edicter": [
        "edicter"
    ],
    "edictee": [
        "edicter"
    ],
    "edictees": [
        "edicter"
    ],
    "edicule": [
        "edicule"
    ],
    "edicules": [
        "edicule"
    ],
    "edifia": [
        "edifier"
    ],
    "edifiaient": [
        "edifier"
    ],
    "edifiait": [
        "edifier"
    ],
    "edifiant": [
        "edifier",
        "edifiant"
    ],
    "edifiante": [
        "edifiant"
    ],
    "edifiantes": [
        "edifiant"
    ],
    "edifiants": [
        "edifiant"
    ],
    "edification": [
        "edification"
    ],
    "edifice": [
        "edifice"
    ],
    "edifices": [
        "edifice"
    ],
    "edifie": [
        "edifier"
    ],
    "edifient": [
        "edifier"
    ],
    "edifier": [
        "edifier"
    ],
    "edifierait": [
        "edifier"
    ],
    "edifierons": [
        "edifier"
    ],
    "edifions": [
        "edifier"
    ],
    "edifierent": [
        "edifier"
    ],
    "edifiee": [
        "edifier"
    ],
    "edifiees": [
        "edifier"
    ],
    "edifies": [
        "edifier"
    ],
    "ediles": [
        "edile"
    ],
    "edilitaire": [
        "edilitaire"
    ],
    "edilitaires": [
        "edilitaire"
    ],
    "edit": [
        "edit"
    ],
    "editait": [
        "editer"
    ],
    "edite": [
        "editer"
    ],
    "editer": [
        "editer"
    ],
    "editera": [
        "editer"
    ],
    "editerais": [
        "editer"
    ],
    "editeur": [
        "editeur"
    ],
    "editeurs": [
        "editeur"
    ],
    "edition": [
        "edition"
    ],
    "editions": [
        "editer",
        "edition"
    ],
    "edito": [
        "edito"
    ],
    "editons": [
        "editer"
    ],
    "editorial": [
        "editorial"
    ],
    "editoriale": [
        "editorial"
    ],
    "editorialiste": [
        "editorialiste"
    ],
    "editorialistes": [
        "editorialiste"
    ],
    "editoriaux": [
        "editorial"
    ],
    "editos": [
        "edito"
    ],
    "editrice": [
        "editeur"
    ],
    "editrices": [
        "editeur"
    ],
    "edits": [
        "edit"
    ],
    "editee": [
        "editer"
    ],
    "editees": [
        "editer"
    ],
    "edites": [
        "editer"
    ],
    "edouardienne": [
        "edouardien"
    ],
    "edredon": [
        "edredon"
    ],
    "edredons": [
        "edredon"
    ],
    "educable": [
        "educable"
    ],
    "educables": [
        "educable"
    ],
    "educateur": [
        "educateur"
    ],
    "educateurs": [
        "educateur"
    ],
    "educatif": [
        "educatif"
    ],
    "educatifs": [
        "educatif"
    ],
    "education": [
        "education"
    ],
    "educationnel": [
        "educationnel"
    ],
    "educationnelle": [
        "educationnel"
    ],
    "educations": [
        "education"
    ],
    "educative": [
        "educatif"
    ],
    "educatives": [
        "educatif"
    ],
    "educatrice": [
        "educateur"
    ],
    "educatrices": [
        "educateur"
    ],
    "eduen": [
        "eduen"
    ],
    "eduennes": [
        "eduen"
    ],
    "eduens": [
        "eduen"
    ],
    "edulcorais": [
        "edulcorer"
    ],
    "edulcorant": [
        "edulcorant"
    ],
    "edulcorer": [
        "edulcorer"
    ],
    "edulcore": [
        "edulcorer"
    ],
    "edulcoree": [
        "edulcorer"
    ],
    "edulcorees": [
        "edulcorer"
    ],
    "eduquais": [
        "eduquer"
    ],
    "eduquant": [
        "eduquer"
    ],
    "eduque": [
        "eduquer"
    ],
    "eduquer": [
        "eduquer"
    ],
    "eduquera": [
        "eduquer"
    ],
    "eduquez": [
        "eduquer"
    ],
    "eduquons": [
        "eduquer"
    ],
    "eduquee": [
        "eduquer"
    ],
    "eduquees": [
        "eduquer"
    ],
    "eduques": [
        "eduquer"
    ],
    "edenique": [
        "edenique"
    ],
    "edeniques": [
        "edenique"
    ],
    "egaie": [
        "egayer"
    ],
    "egaieraient": [
        "egayer"
    ],
    "egaierait": [
        "egayer"
    ],
    "egaieront": [
        "egayer"
    ],
    "egailla": [
        "egailler"
    ],
    "egaillaient": [
        "egailler"
    ],
    "egaillait": [
        "egailler"
    ],
    "egaillant": [
        "egailler"
    ],
    "egaillent": [
        "egailler"
    ],
    "egailler": [
        "egailler"
    ],
    "egaillerent": [
        "egailler"
    ],
    "egaillee": [
        "egailler"
    ],
    "egaillees": [
        "egailler"
    ],
    "egailles": [
        "egailler"
    ],
    "egal": [
        "egal"
    ],
    "egala": [
        "egaler"
    ],
    "egalable": [
        "egalable"
    ],
    "egalaient": [
        "egaler"
    ],
    "egalais": [
        "egaler"
    ],
    "egalait": [
        "egaler"
    ],
    "egalant": [
        "egaler"
    ],
    "egale": [
        "egaler",
        "egal"
    ],
    "egalement": [
        "egalement"
    ],
    "egalent": [
        "egaler"
    ],
    "egaler": [
        "egaler"
    ],
    "egalera": [
        "egaler"
    ],
    "egalerai": [
        "egaler"
    ],
    "egalerais": [
        "egaler"
    ],
    "egalerait": [
        "egaler"
    ],
    "egaleras": [
        "egaler"
    ],
    "egaleront": [
        "egaler"
    ],
    "egales": [
        "egal"
    ],
    "egalisa": [
        "egaliser"
    ],
    "egalisais": [
        "egaliser"
    ],
    "egalisait": [
        "egaliser"
    ],
    "egalisant": [
        "egaliser"
    ],
    "egalisateur": [
        "egalisateur"
    ],
    "egalisateurs": [
        "egalisateur"
    ],
    "egalisation": [
        "egalisation"
    ],
    "egalisatrice": [
        "egalisateur"
    ],
    "egalise": [
        "egaliser"
    ],
    "egalisent": [
        "egaliser"
    ],
    "egaliser": [
        "egaliser"
    ],
    "egaliseur": [
        "egaliseur"
    ],
    "egalisez": [
        "egaliser"
    ],
    "egaliserent": [
        "egaliser"
    ],
    "egalisees": [
        "egaliser"
    ],
    "egalises": [
        "egaliser"
    ],
    "egalitaire": [
        "egalitaire"
    ],
    "egalitarisme": [
        "egalitarisme"
    ],
    "egalite": [
        "egalite"
    ],
    "egalites": [
        "egalite"
    ],
    "egalat": [
        "egaler"
    ],
    "egalee": [
        "egaler"
    ],
    "egalees": [
        "egaler"
    ],
    "egara": [
        "egarer"
    ],
    "egarai": [
        "egarer"
    ],
    "egaraient": [
        "egarer"
    ],
    "egarais": [
        "egarer"
    ],
    "egarait": [
        "egarer"
    ],
    "egarant": [
        "egarer"
    ],
    "egard": [
        "egard"
    ],
    "egards": [
        "egard"
    ],
    "egare": [
        "egarer",
        "egare"
    ],
    "egarement": [
        "egarement"
    ],
    "egarements": [
        "egarement"
    ],
    "egarent": [
        "egarer"
    ],
    "egarer": [
        "egarer"
    ],
    "egareraient": [
        "egarer"
    ],
    "egarerais": [
        "egarer"
    ],
    "egarerait": [
        "egarer"
    ],
    "egarerions": [
        "egarer"
    ],
    "egares": [
        "egarer",
        "egare"
    ],
    "egarez": [
        "egarer"
    ],
    "egarons": [
        "egarer"
    ],
    "egarat": [
        "egarer"
    ],
    "egarerent": [
        "egarer"
    ],
    "egaree": [
        "egarer",
        "egare"
    ],
    "egarees": [
        "egarer",
        "egare"
    ],
    "egaux": [
        "egal"
    ],
    "egaya": [
        "egayer"
    ],
    "egayaient": [
        "egayer"
    ],
    "egayait": [
        "egayer"
    ],
    "egayant": [
        "egayer"
    ],
    "egayante": [
        "egayant"
    ],
    "egaye": [
        "egayer"
    ],
    "egayer": [
        "egayer"
    ],
    "egayerais": [
        "egayer"
    ],
    "egayez": [
        "egayer"
    ],
    "egayat": [
        "egayer"
    ],
    "egayerent": [
        "egayer"
    ],
    "egayee": [
        "egayer"
    ],
    "egayees": [
        "egayer"
    ],
    "egayes": [
        "egayer"
    ],
    "egide": [
        "egide"
    ],
    "egipan": [
        "egipan"
    ],
    "egipans": [
        "egipan"
    ],
    "eglantier": [
        "eglantier"
    ],
    "eglantiers": [
        "eglantier"
    ],
    "eglantine": [
        "eglantine"
    ],
    "eglantines": [
        "eglantine"
    ],
    "eglise": [
        "eglise"
    ],
    "eglises": [
        "eglise"
    ],
    "eglogue": [
        "eglogue"
    ],
    "eglogues": [
        "eglogue"
    ],
    "egocentrique": [
        "egocentrique"
    ],
    "egocentriques": [
        "egocentrique"
    ],
    "egocentrisme": [
        "egocentrisme"
    ],
    "egocentrismes": [
        "egocentrisme"
    ],
    "egocentriste": [
        "egocentriste"
    ],
    "egocentristes": [
        "egocentriste"
    ],
    "egorge": [
        "egorger"
    ],
    "egorgea": [
        "egorger"
    ],
    "egorgeaient": [
        "egorger"
    ],
    "egorgeais": [
        "egorger"
    ],
    "egorgeait": [
        "egorger"
    ],
    "egorgeant": [
        "egorger"
    ],
    "egorgement": [
        "egorgement"
    ],
    "egorgements": [
        "egorgement"
    ],
    "egorgent": [
        "egorger"
    ],
    "egorgeoir": [
        "egorgeoir"
    ],
    "egorger": [
        "egorger"
    ],
    "egorgerai": [
        "egorger"
    ],
    "egorgeraient": [
        "egorger"
    ],
    "egorgerais": [
        "egorger"
    ],
    "egorgeras": [
        "egorger"
    ],
    "egorgeront": [
        "egorger"
    ],
    "egorgeur": [
        "egorgeur"
    ],
    "egorgeurs": [
        "egorgeur"
    ],
    "egorgeuses": [
        "egorgeur"
    ],
    "egorgez": [
        "egorger"
    ],
    "egorgerent": [
        "egorger"
    ],
    "egorgee": [
        "egorger"
    ],
    "egorgees": [
        "egorger"
    ],
    "egorges": [
        "egorger"
    ],
    "egosilla": [
        "egosiller"
    ],
    "egosillaient": [
        "egosiller"
    ],
    "egosillait": [
        "egosiller"
    ],
    "egosillant": [
        "egosiller"
    ],
    "egosille": [
        "egosiller"
    ],
    "egosillent": [
        "egosiller"
    ],
    "egosiller": [
        "egosiller"
    ],
    "egotisme": [
        "egotisme"
    ],
    "egotiste": [
        "egotiste"
    ],
    "egotistes": [
        "egotiste"
    ],
    "egout": [
        "egout"
    ],
    "egoutier": [
        "egoutier"
    ],
    "egoutiers": [
        "egoutier"
    ],
    "egouts": [
        "egout"
    ],
    "egoutta": [
        "egoutter"
    ],
    "egouttaient": [
        "egoutter"
    ],
    "egouttait": [
        "egoutter"
    ],
    "egouttant": [
        "egoutter"
    ],
    "egoutte": [
        "egoutter"
    ],
    "egouttement": [
        "egouttement"
    ],
    "egouttent": [
        "egoutter"
    ],
    "egoutter": [
        "egoutter"
    ],
    "egoutterait": [
        "egoutter"
    ],
    "egouttez": [
        "egoutter"
    ],
    "egouttis": [
        "egouttis"
    ],
    "egouttoir": [
        "egouttoir"
    ],
    "egoutterent": [
        "egoutter"
    ],
    "egoine": [
        "egoine"
    ],
    "egoisme": [
        "egoisme"
    ],
    "egoismes": [
        "egoisme"
    ],
    "egoiste": [
        "egoiste"
    ],
    "egoistement": [
        "egoistement"
    ],
    "egoistes": [
        "egoiste"
    ],
    "egrainer": [
        "egrainer"
    ],
    "egrappait": [
        "egrapper"
    ],
    "egratigna": [
        "egratigner"
    ],
    "egratignaient": [
        "egratigner"
    ],
    "egratignait": [
        "egratigner"
    ],
    "egratignant": [
        "egratigner"
    ],
    "egratigne": [
        "egratigner"
    ],
    "egratignent": [
        "egratigner"
    ],
    "egratigner": [
        "egratigner"
    ],
    "egratignes": [
        "egratigner"
    ],
    "egratignure": [
        "egratignure"
    ],
    "egratignures": [
        "egratignure"
    ],
    "egratignee": [
        "egratigner"
    ],
    "egrena": [
        "egrener"
    ],
    "egrenage": [
        "egrenage"
    ],
    "egrenaient": [
        "egrener"
    ],
    "egrenais": [
        "egrener"
    ],
    "egrenait": [
        "egrener"
    ],
    "egrenant": [
        "egrener"
    ],
    "egrener": [
        "egrener"
    ],
    "egreneuse": [
        "egreneur"
    ],
    "egrenerent": [
        "egrener"
    ],
    "egrene": [
        "egrener"
    ],
    "egrenee": [
        "egrener"
    ],
    "egrenees": [
        "egrener"
    ],
    "egrenes": [
        "egrener"
    ],
    "egrillard": [
        "egrillard"
    ],
    "egrillarde": [
        "egrillard"
    ],
    "egrillardes": [
        "egrillard"
    ],
    "egrillards": [
        "egrillard"
    ],
    "egrotant": [
        "egrotant"
    ],
    "egrotantes": [
        "egrotant"
    ],
    "egrotants": [
        "egrotant"
    ],
    "egrenements": [
        "egrenement"
    ],
    "egrenent": [
        "egrener"
    ],
    "egyptien": [
        "egyptien"
    ],
    "egyptienne": [
        "egyptien"
    ],
    "egyptiennes": [
        "egyptien"
    ],
    "egyptiens": [
        "egyptien"
    ],
    "egyptologie": [
        "egyptologie"
    ],
    "egyptologue": [
        "egyptologue"
    ],
    "egyptologues": [
        "egyptologue"
    ],
    "egeenne": [
        "egeen"
    ],
    "egerie": [
        "egerie"
    ],
    "ehonte": [
        "ehonte"
    ],
    "ehontee": [
        "ehonte"
    ],
    "ehontees": [
        "ehonte"
    ],
    "ehontes": [
        "ehonte"
    ],
    "ejacula": [
        "ejaculer"
    ],
    "ejaculait": [
        "ejaculer"
    ],
    "ejaculant": [
        "ejaculer"
    ],
    "ejaculat": [
        "ejaculat"
    ],
    "ejaculateur": [
        "ejaculateur"
    ],
    "ejaculateurs": [
        "ejaculateur"
    ],
    "ejaculation": [
        "ejaculation"
    ],
    "ejaculations": [
        "ejaculation"
    ],
    "ejacule": [
        "ejaculer"
    ],
    "ejaculent": [
        "ejaculer"
    ],
    "ejaculer": [
        "ejaculer"
    ],
    "ejacules": [
        "ejaculer"
    ],
    "ejecta": [
        "ejecter"
    ],
    "ejectable": [
        "ejectable"
    ],
    "ejectables": [
        "ejectable"
    ],
    "ejectaient": [
        "ejecter"
    ],
    "ejectait": [
        "ejecter"
    ],
    "ejectant": [
        "ejecter"
    ],
    "ejectas": [
        "ejecter"
    ],
    "ejecte": [
        "ejecter"
    ],
    "ejectent": [
        "ejecter"
    ],
    "ejecter": [
        "ejecter"
    ],
    "ejectera": [
        "ejecter"
    ],
    "ejecterais": [
        "ejecter"
    ],
    "ejecteur": [
        "ejecteur"
    ],
    "ejecteurs": [
        "ejecteur"
    ],
    "ejectez": [
        "ejecter"
    ],
    "ejection": [
        "ejection"
    ],
    "ejections": [
        "ejection"
    ],
    "ejectons": [
        "ejecter"
    ],
    "ejecterent": [
        "ejecter"
    ],
    "ejectee": [
        "ejecter"
    ],
    "ejectees": [
        "ejecter"
    ],
    "ejectes": [
        "ejecter"
    ],
    "elabora": [
        "elaborer"
    ],
    "elaborai": [
        "elaborer"
    ],
    "elaboraient": [
        "elaborer"
    ],
    "elaborait": [
        "elaborer"
    ],
    "elaborant": [
        "elaborer"
    ],
    "elaboration": [
        "elaboration"
    ],
    "elaborations": [
        "elaboration"
    ],
    "elabore": [
        "elabore",
        "elaborer"
    ],
    "elaborent": [
        "elaborer"
    ],
    "elaborer": [
        "elaborer"
    ],
    "elaboreraient": [
        "elaborer"
    ],
    "elaboriez": [
        "elaborer"
    ],
    "elaborions": [
        "elaborer"
    ],
    "elaborons": [
        "elaborer"
    ],
    "elaborerent": [
        "elaborer"
    ],
    "elaboree": [
        "elabore",
        "elaborer"
    ],
    "elaborees": [
        "elabore",
        "elaborer"
    ],
    "elabores": [
        "elabore",
        "elaborer"
    ],
    "elagage": [
        "elagage"
    ],
    "elaguais": [
        "elaguer"
    ],
    "elaguait": [
        "elaguer"
    ],
    "elague": [
        "elaguer"
    ],
    "elaguer": [
        "elaguer"
    ],
    "elagueur": [
        "elagueur"
    ],
    "elagueurs": [
        "elagueur"
    ],
    "elaguez": [
        "elaguer"
    ],
    "elaguons": [
        "elaguer"
    ],
    "elagues": [
        "elaguer"
    ],
    "elan": [
        "elan"
    ],
    "elance": [
        "elancer",
        "elance"
    ],
    "elancement": [
        "elancement"
    ],
    "elancements": [
        "elancement"
    ],
    "elancent": [
        "elancer"
    ],
    "elancer": [
        "elancer"
    ],
    "elancera": [
        "elancer"
    ],
    "elanceraient": [
        "elancer"
    ],
    "elancerait": [
        "elancer"
    ],
    "elancerions": [
        "elancer"
    ],
    "elanceront": [
        "elancer"
    ],
    "elancions": [
        "elancer"
    ],
    "elancerent": [
        "elancer"
    ],
    "elancee": [
        "elancer",
        "elance"
    ],
    "elancees": [
        "elancer",
        "elance"
    ],
    "elances": [
        "elancer",
        "elance"
    ],
    "elans": [
        "elan"
    ],
    "elanca": [
        "elancer"
    ],
    "elancai": [
        "elancer"
    ],
    "elancaient": [
        "elancer"
    ],
    "elancais": [
        "elancer"
    ],
    "elancait": [
        "elancer"
    ],
    "elancant": [
        "elancer"
    ],
    "elargi": [
        "elargir"
    ],
    "elargie": [
        "elargir"
    ],
    "elargies": [
        "elargir"
    ],
    "elargir": [
        "elargir"
    ],
    "elargira": [
        "elargir"
    ],
    "elargirait": [
        "elargir"
    ],
    "elargirent": [
        "elargir"
    ],
    "elargirez": [
        "elargir"
    ],
    "elargirons": [
        "elargir"
    ],
    "elargis": [
        "elargir"
    ],
    "elargissaient": [
        "elargir"
    ],
    "elargissait": [
        "elargir"
    ],
    "elargissant": [
        "elargir"
    ],
    "elargissement": [
        "elargissement"
    ],
    "elargissent": [
        "elargir"
    ],
    "elargissez": [
        "elargir"
    ],
    "elargissions": [
        "elargir"
    ],
    "elargit": [
        "elargir"
    ],
    "elasticimetrie": [
        "elasticimetrie"
    ],
    "elasticite": [
        "elasticite"
    ],
    "elastique": [
        "elastique"
    ],
    "elastiques": [
        "elastique"
    ],
    "elastomere": [
        "elastomere"
    ],
    "electeur": [
        "electeur"
    ],
    "electeurs": [
        "electeur"
    ],
    "electif": [
        "electif"
    ],
    "election": [
        "election"
    ],
    "elections": [
        "election"
    ],
    "elective": [
        "electif"
    ],
    "electivement": [
        "electivement"
    ],
    "electives": [
        "elective",
        "electif"
    ],
    "electoral": [
        "electoral"
    ],
    "electorale": [
        "electoral"
    ],
    "electoralement": [
        "electoralement"
    ],
    "electorales": [
        "electoral"
    ],
    "electorat": [
        "electorat"
    ],
    "electoraux": [
        "electoral"
    ],
    "electrice": [
        "electeur"
    ],
    "electrices": [
        "electeur"
    ],
    "electricien": [
        "electricien"
    ],
    "electricienne": [
        "electricien"
    ],
    "electriciennes": [
        "electricien"
    ],
    "electriciens": [
        "electricien"
    ],
    "electricite": [
        "electricite"
    ],
    "electrifia": [
        "electrifier"
    ],
    "electrifiait": [
        "electrifier"
    ],
    "electrifiant": [
        "electrifier"
    ],
    "electrification": [
        "electrification"
    ],
    "electrifier": [
        "electrifier"
    ],
    "electrifie": [
        "electrifier"
    ],
    "electrifiee": [
        "electrifier"
    ],
    "electrifiees": [
        "electrifier"
    ],
    "electrifies": [
        "electrifier",
        "electrify"
    ],
    "electrique": [
        "electrique"
    ],
    "electriquement": [
        "electriquement"
    ],
    "electriques": [
        "electrique"
    ],
    "electrisa": [
        "electriser"
    ],
    "electrisaient": [
        "electriser"
    ],
    "electrisais": [
        "electriser"
    ],
    "electrisait": [
        "electriser"
    ],
    "electrisant": [
        "electriser",
        "electrisant"
    ],
    "electrisante": [
        "electrisant"
    ],
    "electrisation": [
        "electrisation"
    ],
    "electrise": [
        "electriser"
    ],
    "electrisent": [
        "electriser"
    ],
    "electriser": [
        "electriser"
    ],
    "electriserent": [
        "electriser"
    ],
    "electrisee": [
        "electriser"
    ],
    "electrisees": [
        "electriser"
    ],
    "electroacoustique": [
        "electroacoustique"
    ],
    "electroaimant": [
        "electroaimant"
    ],
    "electroaimants": [
        "electroaimant"
    ],
    "electrobiologie": [
        "electrobiologie"
    ],
    "electrocardiogramme": [
        "electrocardiogramme"
    ],
    "electrochimie": [
        "electrochimie"
    ],
    "electrochimique": [
        "electrochimique"
    ],
    "electrochimiques": [
        "electrochimique"
    ],
    "electrochoc": [
        "electrochoc"
    ],
    "electrochocs": [
        "electrochoc"
    ],
    "electrocutant": [
        "electrocuter"
    ],
    "electrocute": [
        "electrocuter"
    ],
    "electrocutent": [
        "electrocuter"
    ],
    "electrocuter": [
        "electrocuter"
    ],
    "electrocutera": [
        "electrocuter"
    ],
    "electrocutes": [
        "electrocuter"
    ],
    "electrocutez": [
        "electrocuter"
    ],
    "electrocution": [
        "electrocution"
    ],
    "electrocutee": [
        "electrocuter"
    ],
    "electrode": [
        "electrode"
    ],
    "electrodes": [
        "electrode"
    ],
    "electrodynamique": [
        "electrodynamique"
    ],
    "electroencephalogramme": [
        "electroencephalogramme"
    ],
    "electroencephalographie": [
        "electroencephalographie"
    ],
    "electrogene": [
        "electrogene"
    ],
    "electrologie": [
        "electrologie"
    ],
    "electrolyse": [
        "electrolyse",
        "electrolyser"
    ],
    "electrolyte": [
        "electrolyte"
    ],
    "electrolytes": [
        "electrolyte"
    ],
    "electrolytique": [
        "electrolytique"
    ],
    "electromagnetique": [
        "electromagnetique"
    ],
    "electromagnetiques": [
        "electromagnetique"
    ],
    "electromagnetisme": [
        "electromagnetisme"
    ],
    "electrometre": [
        "electrometre"
    ],
    "electromenager": [
        "electromenager"
    ],
    "electron": [
        "electron"
    ],
    "electronicien": [
        "electronicien"
    ],
    "electroniciens": [
        "electronicien"
    ],
    "electronique": [
        "electronique"
    ],
    "electroniquement": [
        "electroniquement"
    ],
    "electroniques": [
        "electronique"
    ],
    "electrons": [
        "electron"
    ],
    "electronucleaire": [
        "electronucleaire"
    ],
    "electronvolts": [
        "electronvolt"
    ],
    "electrophone": [
        "electrophone"
    ],
    "electrophones": [
        "electrophone"
    ],
    "electrophorese": [
        "electrophorese"
    ],
    "electrostatique": [
        "electrostatique"
    ],
    "electrostatiques": [
        "electrostatique"
    ],
    "electrum": [
        "electrum"
    ],
    "electuaires": [
        "electuaire"
    ],
    "eleusinienne": [
        "eleusinien"
    ],
    "eleva": [
        "elever"
    ],
    "elevage": [
        "elevage"
    ],
    "elevages": [
        "elevage"
    ],
    "elevai": [
        "elever"
    ],
    "elevaient": [
        "elever"
    ],
    "elevais": [
        "elever"
    ],
    "elevait": [
        "elever"
    ],
    "elevant": [
        "elever"
    ],
    "elever": [
        "elever"
    ],
    "eleveur": [
        "eleveur"
    ],
    "eleveurs": [
        "eleveur"
    ],
    "eleveuse": [
        "eleveur"
    ],
    "elevez": [
        "elever"
    ],
    "eleviez": [
        "elever"
    ],
    "elevions": [
        "elever"
    ],
    "elevons": [
        "elevon",
        "elever"
    ],
    "elevures": [
        "elevure"
    ],
    "elevat": [
        "elever"
    ],
    "eleverent": [
        "elever"
    ],
    "eleve": [
        "eleve",
        "elever"
    ],
    "elevee": [
        "eleve",
        "elever"
    ],
    "elevees": [
        "eleve",
        "elever"
    ],
    "eleves": [
        "eleve",
        "elever"
    ],
    "elia": [
        "elier"
    ],
    "elias": [
        "elier"
    ],
    "eliciter": [
        "eliciter"
    ],
    "elie": [
        "elier"
    ],
    "eligibilite": [
        "eligibilite"
    ],
    "eligible": [
        "eligible"
    ],
    "eligibles": [
        "eligible"
    ],
    "elime": [
        "elimer",
        "elime"
    ],
    "elimer": [
        "elimer"
    ],
    "elimina": [
        "eliminer"
    ],
    "eliminais": [
        "eliminer"
    ],
    "eliminait": [
        "eliminer"
    ],
    "eliminant": [
        "eliminer"
    ],
    "eliminateur": [
        "eliminateur"
    ],
    "eliminateurs": [
        "eliminateur"
    ],
    "elimination": [
        "elimination"
    ],
    "eliminations": [
        "elimination"
    ],
    "eliminatoire": [
        "eliminatoire"
    ],
    "eliminatoires": [
        "eliminatoire"
    ],
    "elimine": [
        "elimine",
        "eliminer"
    ],
    "eliminent": [
        "eliminer"
    ],
    "eliminer": [
        "eliminer"
    ],
    "eliminera": [
        "eliminer"
    ],
    "eliminerai": [
        "eliminer"
    ],
    "elimineraient": [
        "eliminer"
    ],
    "eliminerais": [
        "eliminer"
    ],
    "eliminerait": [
        "eliminer"
    ],
    "elimineras": [
        "eliminer"
    ],
    "eliminerez": [
        "eliminer"
    ],
    "eliminerons": [
        "eliminer"
    ],
    "elimineront": [
        "eliminer"
    ],
    "elimines": [
        "elimine",
        "eliminer"
    ],
    "eliminez": [
        "eliminer"
    ],
    "eliminiez": [
        "eliminer"
    ],
    "eliminons": [
        "eliminer"
    ],
    "eliminerent": [
        "eliminer"
    ],
    "eliminee": [
        "elimine",
        "eliminer"
    ],
    "eliminees": [
        "elimine",
        "eliminer"
    ],
    "elimames": [
        "elimer"
    ],
    "elimee": [
        "elimer",
        "elime"
    ],
    "elimees": [
        "elimer",
        "elime"
    ],
    "elimes": [
        "elimer",
        "elime"
    ],
    "elingue": [
        "elingue"
    ],
    "elirait": [
        "elire"
    ],
    "elire": [
        "elire"
    ],
    "elirez": [
        "elire"
    ],
    "eliront": [
        "elire"
    ],
    "elis": [
        "elire"
    ],
    "elisabethain": [
        "elisabethain"
    ],
    "elisabethaine": [
        "elisabethain"
    ],
    "elisaient": [
        "elire"
    ],
    "elisais": [
        "elire"
    ],
    "elisait": [
        "elire"
    ],
    "elisant": [
        "elire"
    ],
    "elise": [
        "elire"
    ],
    "elisent": [
        "elire"
    ],
    "elisez": [
        "elire"
    ],
    "elit": [
        "elire"
    ],
    "elite": [
        "elite"
    ],
    "elites": [
        "elite"
    ],
    "elitisme": [
        "elitisme"
    ],
    "elitiste": [
        "elitiste"
    ],
    "elitistes": [
        "elitiste"
    ],
    "elixir": [
        "elixir"
    ],
    "elixirs": [
        "elixir"
    ],
    "elocution": [
        "elocution"
    ],
    "eloge": [
        "eloge"
    ],
    "eloges": [
        "eloge"
    ],
    "elogieuse": [
        "elogieux"
    ],
    "elogieuses": [
        "elogieux"
    ],
    "elogieux": [
        "elogieux"
    ],
    "eloigna": [
        "eloigner"
    ],
    "eloignai": [
        "eloigner"
    ],
    "eloignaient": [
        "eloigner"
    ],
    "eloignais": [
        "eloigner"
    ],
    "eloignait": [
        "eloigner"
    ],
    "eloignant": [
        "eloigner"
    ],
    "eloigne": [
        "eloigner",
        "eloigne"
    ],
    "eloignement": [
        "eloignement"
    ],
    "eloignent": [
        "eloigner"
    ],
    "eloigner": [
        "eloigner"
    ],
    "eloignera": [
        "eloigner"
    ],
    "eloignerai": [
        "eloigner"
    ],
    "eloigneraient": [
        "eloigner"
    ],
    "eloignerais": [
        "eloigner"
    ],
    "eloignerait": [
        "eloigner"
    ],
    "eloigneras": [
        "eloigner"
    ],
    "eloignerez": [
        "eloigner"
    ],
    "eloignerons": [
        "eloigner"
    ],
    "eloigneront": [
        "eloigner"
    ],
    "eloignes": [
        "eloigner",
        "eloigne"
    ],
    "eloignez": [
        "eloigner"
    ],
    "eloignions": [
        "eloigner"
    ],
    "eloignons": [
        "eloigner"
    ],
    "eloignames": [
        "eloigner"
    ],
    "eloignat": [
        "eloigner"
    ],
    "eloignerent": [
        "eloigner"
    ],
    "eloignee": [
        "eloigner",
        "eloigne"
    ],
    "eloignees": [
        "eloigner",
        "eloigne"
    ],
    "elongation": [
        "elongation"
    ],
    "elongations": [
        "elongation"
    ],
    "eloquemment": [
        "eloquemment"
    ],
    "eloquence": [
        "eloquence"
    ],
    "eloquent": [
        "eloquent"
    ],
    "eloquente": [
        "eloquent"
    ],
    "eloquentes": [
        "eloquent"
    ],
    "eloquents": [
        "eloquent"
    ],
    "elu": [
        "elu",
        "elire"
    ],
    "elucida": [
        "elucider"
    ],
    "elucidai": [
        "elucider"
    ],
    "elucidation": [
        "elucidation"
    ],
    "elucide": [
        "elucider"
    ],
    "elucider": [
        "elucider"
    ],
    "elucideraient": [
        "elucider"
    ],
    "eluciderait": [
        "elucider"
    ],
    "elucidee": [
        "elucider"
    ],
    "elucidees": [
        "elucider"
    ],
    "elucides": [
        "elucider"
    ],
    "elucubration": [
        "elucubration"
    ],
    "elucubrations": [
        "elucubration"
    ],
    "elucubre": [
        "elucubrer"
    ],
    "elucubrent": [
        "elucubrer"
    ],
    "elucubrer": [
        "elucubrer"
    ],
    "eluda": [
        "eluder"
    ],
    "eludai": [
        "eluder"
    ],
    "eludaient": [
        "eluder"
    ],
    "eludais": [
        "eluder"
    ],
    "eludait": [
        "eluder"
    ],
    "eludant": [
        "eluder"
    ],
    "elude": [
        "eluder"
    ],
    "eludent": [
        "eluder"
    ],
    "eluder": [
        "eluder"
    ],
    "eludes": [
        "elude",
        "eluder"
    ],
    "eludez": [
        "eluder"
    ],
    "eludat": [
        "eluder"
    ],
    "eludee": [
        "eluder"
    ],
    "eludees": [
        "eluder"
    ],
    "elue": [
        "eluer",
        "elu"
    ],
    "elues": [
        "elu"
    ],
    "elus": [
        "elu",
        "elire"
    ],
    "elusifs": [
        "elusif"
    ],
    "elusive": [
        "elusif"
    ],
    "elut": [
        "elire"
    ],
    "elysee": [
        "elysee"
    ],
    "elyseen": [
        "elyseen"
    ],
    "elyseenne": [
        "elyseen"
    ],
    "elytre": [
        "elytre"
    ],
    "elytres": [
        "elytre"
    ],
    "elevent": [
        "elever"
    ],
    "elevera": [
        "elever"
    ],
    "eleverai": [
        "elever"
    ],
    "eleveraient": [
        "elever"
    ],
    "eleverais": [
        "elever"
    ],
    "eleverait": [
        "elever"
    ],
    "eleveras": [
        "elever"
    ],
    "eleveriez": [
        "elever"
    ],
    "eleverons": [
        "elever"
    ],
    "eleveront": [
        "elever"
    ],
    "eleates": [
        "eleate"
    ],
    "elegamment": [
        "elegamment"
    ],
    "elegance": [
        "elegance"
    ],
    "elegances": [
        "elegance"
    ],
    "elegant": [
        "elegant"
    ],
    "elegante": [
        "elegant"
    ],
    "elegantes": [
        "elegant"
    ],
    "elegants": [
        "elegant"
    ],
    "elegiaque": [
        "elegiaque"
    ],
    "elegiaques": [
        "elegiaque"
    ],
    "elegie": [
        "elegie"
    ],
    "elegies": [
        "elegie"
    ],
    "element": [
        "element"
    ],
    "elementaire": [
        "elementaire"
    ],
    "elementaires": [
        "elementaire"
    ],
    "elementarite": [
        "elementarite"
    ],
    "elements": [
        "element"
    ],
    "elephant": [
        "elephant"
    ],
    "elephante": [
        "elephant"
    ],
    "elephanteau": [
        "elephanteau"
    ],
    "elephantes": [
        "elephant"
    ],
    "elephantesque": [
        "elephantesque"
    ],
    "elephantesques": [
        "elephantesque"
    ],
    "elephantiasique": [
        "elephantiasique"
    ],
    "elephantiasis": [
        "elephantiasis"
    ],
    "elephantine": [
        "elephantin"
    ],
    "elephantines": [
        "elephantin"
    ],
    "elephants": [
        "elephant"
    ],
    "elevateur": [
        "elevateur"
    ],
    "elevateurs": [
        "elevateur"
    ],
    "elevation": [
        "elevation"
    ],
    "elevations": [
        "elevation"
    ],
    "elevatrice": [
        "elevateur"
    ],
    "elevatrices": [
        "elevateur"
    ],
    "emaciait": [
        "emacier"
    ],
    "emacie": [
        "emacie",
        "emacier"
    ],
    "emaciee": [
        "emacie",
        "emacier"
    ],
    "emaciees": [
        "emacie",
        "emacier"
    ],
    "emacies": [
        "emacie",
        "emacier"
    ],
    "email": [
        "email"
    ],
    "emailla": [
        "emailler"
    ],
    "emaillaient": [
        "emailler"
    ],
    "emaillait": [
        "emailler"
    ],
    "emaillant": [
        "emailler"
    ],
    "emaille": [
        "emailler",
        "emaille"
    ],
    "emaillent": [
        "emailler"
    ],
    "emailler": [
        "emailler"
    ],
    "emaillee": [
        "emailler",
        "emaille"
    ],
    "emaillees": [
        "emailler",
        "emaille"
    ],
    "emailles": [
        "emailler",
        "emaille"
    ],
    "emanaient": [
        "emaner"
    ],
    "emanait": [
        "emaner"
    ],
    "emanant": [
        "emaner"
    ],
    "emanation": [
        "emanation"
    ],
    "emanations": [
        "emanation"
    ],
    "emancipait": [
        "emanciper"
    ],
    "emancipateur": [
        "emancipateur"
    ],
    "emancipation": [
        "emancipation"
    ],
    "emancipatrice": [
        "emancipateur"
    ],
    "emancipe": [
        "emancipe",
        "emanciper"
    ],
    "emancipent": [
        "emanciper"
    ],
    "emanciper": [
        "emanciper"
    ],
    "emancipee": [
        "emancipe",
        "emanciper"
    ],
    "emancipees": [
        "emancipe",
        "emanciper"
    ],
    "emancipes": [
        "emancipe",
        "emanciper"
    ],
    "emane": [
        "emaner"
    ],
    "emanent": [
        "emaner"
    ],
    "emaner": [
        "emaner"
    ],
    "emanera": [
        "emaner"
    ],
    "emanerait": [
        "emaner"
    ],
    "emanee": [
        "emaner"
    ],
    "emanees": [
        "emaner"
    ],
    "emanes": [
        "emaner"
    ],
    "emarge": [
        "emarger"
    ],
    "emargeaient": [
        "emarger"
    ],
    "emargeait": [
        "emarger"
    ],
    "emargeant": [
        "emarger"
    ],
    "emargement": [
        "emargement"
    ],
    "emarger": [
        "emarger"
    ],
    "emasculaient": [
        "emasculer"
    ],
    "emasculation": [
        "emasculation"
    ],
    "emascule": [
        "emasculer"
    ],
    "emasculer": [
        "emasculer"
    ],
    "emasculee": [
        "emasculer"
    ],
    "emasculees": [
        "emasculer"
    ],
    "emascules": [
        "emasculer"
    ],
    "emaux": [
        "email"
    ],
    "emeraude": [
        "emeraude"
    ],
    "emeraudes": [
        "emeraude"
    ],
    "emerge": [
        "emerge",
        "emerger"
    ],
    "emergea": [
        "emerger"
    ],
    "emergeai": [
        "emerger"
    ],
    "emergeaient": [
        "emerger"
    ],
    "emergeais": [
        "emerger"
    ],
    "emergeait": [
        "emerger"
    ],
    "emergeant": [
        "emerger",
        "emergeant"
    ],
    "emergence": [
        "emergence"
    ],
    "emergences": [
        "emergence"
    ],
    "emergent": [
        "emerger",
        "emergent"
    ],
    "emergente": [
        "emergent"
    ],
    "emergeons": [
        "emerger"
    ],
    "emerger": [
        "emerger"
    ],
    "emergera": [
        "emerger"
    ],
    "emergerait": [
        "emerger"
    ],
    "emergeras": [
        "emerger"
    ],
    "emergerons": [
        "emerger"
    ],
    "emergeront": [
        "emerger"
    ],
    "emerges": [
        "emerge",
        "emerger"
    ],
    "emergeat": [
        "emerger"
    ],
    "emergions": [
        "emerger"
    ],
    "emergerent": [
        "emerger"
    ],
    "emergee": [
        "emerge",
        "emerger"
    ],
    "emergees": [
        "emerge"
    ],
    "emeri": [
        "emeri"
    ],
    "emerillon": [
        "emerillon"
    ],
    "emerillonne": [
        "emerillonne"
    ],
    "emerise": [
        "emeriser"
    ],
    "emerisees": [
        "emeriser"
    ],
    "emersion": [
        "emersion"
    ],
    "emerveilla": [
        "emerveiller"
    ],
    "emerveillai": [
        "emerveiller"
    ],
    "emerveillaient": [
        "emerveiller"
    ],
    "emerveillais": [
        "emerveiller"
    ],
    "emerveillait": [
        "emerveiller"
    ],
    "emerveillant": [
        "emerveiller"
    ],
    "emerveille": [
        "emerveiller"
    ],
    "emerveillement": [
        "emerveillement"
    ],
    "emerveillements": [
        "emerveillement"
    ],
    "emerveillent": [
        "emerveiller"
    ],
    "emerveiller": [
        "emerveiller"
    ],
    "emerveillerait": [
        "emerveiller"
    ],
    "emerveillerent": [
        "emerveiller"
    ],
    "emerveillee": [
        "emerveiller"
    ],
    "emerveillees": [
        "emerveiller"
    ],
    "emerveilles": [
        "emerveiller"
    ],
    "emet": [
        "emettre"
    ],
    "emets": [
        "emettre"
    ],
    "emettaient": [
        "emettre"
    ],
    "emettait": [
        "emettre"
    ],
    "emettant": [
        "emettre"
    ],
    "emette": [
        "emettre"
    ],
    "emettent": [
        "emettre"
    ],
    "emetteur": [
        "emetteur"
    ],
    "emetteurs": [
        "emetteur"
    ],
    "emettez": [
        "emettre"
    ],
    "emettons": [
        "emettre"
    ],
    "emettra": [
        "emettre"
    ],
    "emettrai": [
        "emettre"
    ],
    "emettre": [
        "emettre"
    ],
    "emettrice": [
        "emetteur"
    ],
    "emettrons": [
        "emettre"
    ],
    "emettront": [
        "emettre"
    ],
    "emeu": [
        "emeu"
    ],
    "emeus": [
        "emeu",
        "emouvoir"
    ],
    "emeut": [
        "emouvoir"
    ],
    "emeute": [
        "emeute"
    ],
    "emeutes": [
        "emeute"
    ],
    "emeutier": [
        "emeutier"
    ],
    "emeutiers": [
        "emeutier"
    ],
    "emeuve": [
        "emouvoir"
    ],
    "emeuvent": [
        "emouvoir"
    ],
    "emietta": [
        "emietter"
    ],
    "emiettaient": [
        "emietter"
    ],
    "emiettait": [
        "emietter"
    ],
    "emiette": [
        "emietter"
    ],
    "emiettement": [
        "emiettement"
    ],
    "emiettements": [
        "emiettement"
    ],
    "emiettent": [
        "emietter"
    ],
    "emietter": [
        "emietter"
    ],
    "emietterait": [
        "emietter"
    ],
    "emiettez": [
        "emietter"
    ],
    "emietterent": [
        "emietter"
    ],
    "emiettee": [
        "emietter"
    ],
    "emiettes": [
        "emietter"
    ],
    "emigra": [
        "emigrer"
    ],
    "emigrai": [
        "emigrer"
    ],
    "emigraient": [
        "emigrer"
    ],
    "emigrais": [
        "emigrer"
    ],
    "emigrait": [
        "emigrer"
    ],
    "emigrant": [
        "emigrer",
        "emigrant"
    ],
    "emigrante": [
        "emigrant"
    ],
    "emigrants": [
        "emigrant"
    ],
    "emigration": [
        "emigration"
    ],
    "emigre": [
        "emigrer",
        "emigre"
    ],
    "emigrent": [
        "emigrer"
    ],
    "emigrer": [
        "emigrer"
    ],
    "emigrerent": [
        "emigrer"
    ],
    "emigree": [
        "emigrer",
        "emigre"
    ],
    "emigres": [
        "emigrer",
        "emigre"
    ],
    "emilien": [
        "emilien"
    ],
    "emilienne": [
        "emilien"
    ],
    "emincer": [
        "emincer"
    ],
    "emincez": [
        "emincer"
    ],
    "emince": [
        "emincer",
        "emince"
    ],
    "emincee": [
        "emincer"
    ],
    "emincees": [
        "emincer"
    ],
    "eminces": [
        "emincer",
        "emince"
    ],
    "eminemment": [
        "eminemment"
    ],
    "eminence": [
        "eminence"
    ],
    "eminences": [
        "eminence"
    ],
    "eminent": [
        "eminent"
    ],
    "eminente": [
        "eminent"
    ],
    "eminentes": [
        "eminent"
    ],
    "eminentissimes": [
        "eminentissime"
    ],
    "eminents": [
        "eminent"
    ],
    "emir": [
        "emir"
    ],
    "emirat": [
        "emirat"
    ],
    "emirats": [
        "emirat"
    ],
    "emirs": [
        "emir"
    ],
    "emis": [
        "emettre"
    ],
    "emise": [
        "emettre"
    ],
    "emises": [
        "emettre"
    ],
    "emissaire": [
        "emissaire"
    ],
    "emissaires": [
        "emissaire"
    ],
    "emission": [
        "emission"
    ],
    "emissions": [
        "emettre",
        "emission"
    ],
    "emit": [
        "emettre"
    ],
    "emoi": [
        "emoi"
    ],
    "emois": [
        "emoi"
    ],
    "emollient": [
        "emollient"
    ],
    "emolliente": [
        "emollient"
    ],
    "emoluments": [
        "emolument"
    ],
    "emondait": [
        "emonder"
    ],
    "emonder": [
        "emonder"
    ],
    "emondera": [
        "emonder"
    ],
    "emondeur": [
        "emondeur"
    ],
    "emondons": [
        "emonder"
    ],
    "emonde": [
        "emonder"
    ],
    "emondee": [
        "emonder"
    ],
    "emondees": [
        "emonder"
    ],
    "emotif": [
        "emotif"
    ],
    "emotifs": [
        "emotif"
    ],
    "emotion": [
        "emotion"
    ],
    "emotionnante": [
        "emotionnant"
    ],
    "emotionne": [
        "emotionner"
    ],
    "emotionnel": [
        "emotionnel"
    ],
    "emotionnelle": [
        "emotionnel"
    ],
    "emotionnellement": [
        "emotionnellement"
    ],
    "emotionnelles": [
        "emotionnel"
    ],
    "emotionnels": [
        "emotionnel"
    ],
    "emotions": [
        "emotion"
    ],
    "emotive": [
        "emotif"
    ],
    "emotives": [
        "emotif"
    ],
    "emotivite": [
        "emotivite"
    ],
    "emouchets": [
        "emouchet"
    ],
    "emoulu": [
        "emoulu",
        "emoudre"
    ],
    "emoulue": [
        "emoulu",
        "emoudre"
    ],
    "emoulus": [
        "emoudre"
    ],
    "emoussa": [
        "emousser"
    ],
    "emoussai": [
        "emousser"
    ],
    "emoussaient": [
        "emousser"
    ],
    "emoussait": [
        "emousser"
    ],
    "emoussant": [
        "emousser"
    ],
    "emousse": [
        "emousse",
        "emousser"
    ],
    "emoussement": [
        "emoussement"
    ],
    "emoussent": [
        "emousser"
    ],
    "emousser": [
        "emousser"
    ],
    "emousseront": [
        "emousser"
    ],
    "emousserent": [
        "emousser"
    ],
    "emoussee": [
        "emousse",
        "emousser"
    ],
    "emoussees": [
        "emousse",
        "emousser"
    ],
    "emousses": [
        "emousse",
        "emousser"
    ],
    "emoustilla": [
        "emoustiller"
    ],
    "emoustillait": [
        "emoustiller"
    ],
    "emoustillant": [
        "emoustillant",
        "emoustiller"
    ],
    "emoustillante": [
        "emoustillant"
    ],
    "emoustiller": [
        "emoustiller"
    ],
    "emoustillera": [
        "emoustiller"
    ],
    "emoustille": [
        "emoustiller"
    ],
    "emoustillee": [
        "emoustiller"
    ],
    "emoustillees": [
        "emoustiller"
    ],
    "emoustilles": [
        "emoustiller"
    ],
    "emouvaient": [
        "emouvoir"
    ],
    "emouvais": [
        "emouvoir"
    ],
    "emouvait": [
        "emouvoir"
    ],
    "emouvant": [
        "emouvant",
        "emouvoir"
    ],
    "emouvante": [
        "emouvant"
    ],
    "emouvantes": [
        "emouvant"
    ],
    "emouvants": [
        "emouvant"
    ],
    "emouvez": [
        "emouvoir"
    ],
    "emouvoir": [
        "emouvoir"
    ],
    "emouvrait": [
        "emouvoir"
    ],
    "emu": [
        "emu",
        "emouvoir"
    ],
    "emue": [
        "emu",
        "emouvoir"
    ],
    "emues": [
        "emu",
        "emouvoir"
    ],
    "emulation": [
        "emulation"
    ],
    "emulations": [
        "emulation"
    ],
    "emule": [
        "emule"
    ],
    "emuler": [
        "emuler"
    ],
    "emules": [
        "emule"
    ],
    "emulsifiant": [
        "emulsifiant"
    ],
    "emulsifier": [
        "emulsifier"
    ],
    "emulsion": [
        "emulsion"
    ],
    "emulsionne": [
        "emulsionner"
    ],
    "emulsive": [
        "emulsif"
    ],
    "emurent": [
        "emouvoir"
    ],
    "emus": [
        "emu",
        "emouvoir"
    ],
    "emussent": [
        "emouvoir"
    ],
    "emut": [
        "emouvoir"
    ],
    "emechent": [
        "emecher"
    ],
    "emeche": [
        "emecher",
        "emeche"
    ],
    "emechee": [
        "emecher",
        "emeche"
    ],
    "emechees": [
        "emecher",
        "emeche"
    ],
    "emeches": [
        "emecher",
        "emeche"
    ],
    "emerite": [
        "emerite"
    ],
    "emerites": [
        "emerite"
    ],
    "emetine": [
        "emetine"
    ],
    "emetique": [
        "emetique"
    ],
    "enamourant": [
        "enamourer"
    ],
    "enarque": [
        "enarque"
    ],
    "enarques": [
        "enarque"
    ],
    "energie": [
        "energie"
    ],
    "energies": [
        "energy",
        "energie"
    ],
    "energique": [
        "energique"
    ],
    "energiquement": [
        "energiquement"
    ],
    "energiques": [
        "energique"
    ],
    "energisant": [
        "energisant"
    ],
    "energisante": [
        "energisant"
    ],
    "energisee": [
        "energise"
    ],
    "energumene": [
        "energumene"
    ],
    "energumenes": [
        "energumene"
    ],
    "energetique": [
        "energetique"
    ],
    "energetiques": [
        "energetique"
    ],
    "enerva": [
        "enerver"
    ],
    "enervai": [
        "enerver"
    ],
    "enervaient": [
        "enerver"
    ],
    "enervais": [
        "enerver"
    ],
    "enervait": [
        "enerver"
    ],
    "enervant": [
        "enervant",
        "enerver"
    ],
    "enervante": [
        "enervant"
    ],
    "enervantes": [
        "enervant"
    ],
    "enervants": [
        "enervant"
    ],
    "enerve": [
        "enerve",
        "enerver"
    ],
    "enervement": [
        "enervement"
    ],
    "enervements": [
        "enervement"
    ],
    "enervent": [
        "enerver"
    ],
    "enerver": [
        "enerver"
    ],
    "enervera": [
        "enerver"
    ],
    "enerverai": [
        "enerver"
    ],
    "enerveraient": [
        "enerver"
    ],
    "enerverait": [
        "enerver"
    ],
    "enerveront": [
        "enerver"
    ],
    "enerves": [
        "enerve",
        "enerver"
    ],
    "enervez": [
        "enerver"
    ],
    "enerviez": [
        "enerver"
    ],
    "enervions": [
        "enerver"
    ],
    "enervons": [
        "enerver"
    ],
    "enervames": [
        "enerver"
    ],
    "enervee": [
        "enerve",
        "enerver"
    ],
    "enervees": [
        "enerve",
        "enerver"
    ],
    "enigmatique": [
        "enigmatique"
    ],
    "enigmatiquement": [
        "enigmatiquement"
    ],
    "enigmatiques": [
        "enigmatique"
    ],
    "enigme": [
        "enigme"
    ],
    "enigmes": [
        "enigme"
    ],
    "enieme": [
        "enieme"
    ],
    "enonce": [
        "enoncer",
        "enonce"
    ],
    "enoncent": [
        "enoncer"
    ],
    "enoncer": [
        "enoncer"
    ],
    "enonceront": [
        "enoncer"
    ],
    "enonciateurs": [
        "enonciateur"
    ],
    "enonciation": [
        "enonciation"
    ],
    "enoncee": [
        "enoncer"
    ],
    "enoncees": [
        "enoncer"
    ],
    "enonces": [
        "enonce"
    ],
    "enonca": [
        "enoncer"
    ],
    "enoncai": [
        "enoncer"
    ],
    "enoncaient": [
        "enoncer"
    ],
    "enoncais": [
        "enoncer"
    ],
    "enoncait": [
        "enoncer"
    ],
    "enoncant": [
        "enoncer"
    ],
    "enorme": [
        "enorme"
    ],
    "enormes": [
        "enorme"
    ],
    "enormite": [
        "enormite"
    ],
    "enormites": [
        "enormite"
    ],
    "enormement": [
        "enormement"
    ],
    "enucleation": [
        "enucleation"
    ],
    "enucleer": [
        "enucleer"
    ],
    "enuclee": [
        "enucleer"
    ],
    "enuclees": [
        "enucleer"
    ],
    "enumere": [
        "enumerer"
    ],
    "enumerent": [
        "enumerer"
    ],
    "enumeres": [
        "enumerer"
    ],
    "enumera": [
        "enumerer"
    ],
    "enumerai": [
        "enumerer"
    ],
    "enumeraient": [
        "enumerer"
    ],
    "enumerais": [
        "enumerer"
    ],
    "enumerait": [
        "enumerer"
    ],
    "enumerant": [
        "enumerer"
    ],
    "enumeration": [
        "enumeration"
    ],
    "enumerations": [
        "enumeration"
    ],
    "enumerative": [
        "enumeratif"
    ],
    "enumerer": [
        "enumerer"
    ],
    "enumererai": [
        "enumerer"
    ],
    "enumererais": [
        "enumerer"
    ],
    "enumerez": [
        "enumerer"
    ],
    "enumerons": [
        "enumerer"
    ],
    "enumerees": [
        "enumerer"
    ],
    "enuresie": [
        "enuresie"
    ],
    "enuretique": [
        "enuretique"
    ],
    "eocene": [
        "eocene"
    ],
    "eolien": [
        "eolien"
    ],
    "eolienne": [
        "eolien"
    ],
    "eoliennes": [
        "eolien"
    ],
    "eoliens": [
        "eolien"
    ],
    "eon": [
        "eon"
    ],
    "eonisme": [
        "eonisme"
    ],
    "eosine": [
        "eosine"
    ],
    "epagneul": [
        "epagneul"
    ],
    "epagneule": [
        "epagneul"
    ],
    "epagomenes": [
        "epagomene"
    ],
    "epais": [
        "epais"
    ],
    "epaisse": [
        "epais"
    ],
    "epaissement": [
        "epaissement"
    ],
    "epaisses": [
        "epais"
    ],
    "epaisseur": [
        "epaisseur"
    ],
    "epaisseurs": [
        "epaisseur"
    ],
    "epaissi": [
        "epaissir"
    ],
    "epaissie": [
        "epaissir"
    ],
    "epaissies": [
        "epaissir"
    ],
    "epaissir": [
        "epaissir"
    ],
    "epaissirais": [
        "epaissir"
    ],
    "epaissirent": [
        "epaissir"
    ],
    "epaissis": [
        "epaissir"
    ],
    "epaississaient": [
        "epaissir"
    ],
    "epaississait": [
        "epaissir"
    ],
    "epaississant": [
        "epaissir"
    ],
    "epaississe": [
        "epaissir"
    ],
    "epaississement": [
        "epaississement"
    ],
    "epaississent": [
        "epaissir"
    ],
    "epaissit": [
        "epaissir"
    ],
    "epancha": [
        "epancher"
    ],
    "epanchaient": [
        "epancher"
    ],
    "epanchais": [
        "epancher"
    ],
    "epanchait": [
        "epancher"
    ],
    "epanchant": [
        "epancher"
    ],
    "epanche": [
        "epancher"
    ],
    "epanchement": [
        "epanchement"
    ],
    "epanchements": [
        "epanchement"
    ],
    "epanchent": [
        "epancher"
    ],
    "epancher": [
        "epancher"
    ],
    "epancherait": [
        "epancher"
    ],
    "epand": [
        "epandre"
    ],
    "epandage": [
        "epandage"
    ],
    "epandages": [
        "epandage"
    ],
    "epandaient": [
        "epandre"
    ],
    "epandait": [
        "epandre"
    ],
    "epandant": [
        "epandre"
    ],
    "epandent": [
        "epandre"
    ],
    "epandeur": [
        "epandeur"
    ],
    "epandez": [
        "epandre"
    ],
    "epandre": [
        "epandre"
    ],
    "epands": [
        "epandre"
    ],
    "epandu": [
        "epandre"
    ],
    "epandue": [
        "epandre"
    ],
    "epandues": [
        "epandre"
    ],
    "epanoui": [
        "epanoui",
        "epanouir"
    ],
    "epanouie": [
        "epanoui",
        "epanouir"
    ],
    "epanouies": [
        "epanoui",
        "epanouir"
    ],
    "epanouir": [
        "epanouir"
    ],
    "epanouira": [
        "epanouir"
    ],
    "epanouirait": [
        "epanouir"
    ],
    "epanouirent": [
        "epanouir"
    ],
    "epanouis": [
        "epanoui",
        "epanouir"
    ],
    "epanouissaient": [
        "epanouir"
    ],
    "epanouissais": [
        "epanouir"
    ],
    "epanouissait": [
        "epanouir"
    ],
    "epanouissant": [
        "epanouissant",
        "epanouir"
    ],
    "epanouissante": [
        "epanouissant"
    ],
    "epanouissantes": [
        "epanouissant"
    ],
    "epanouisse": [
        "epanouir"
    ],
    "epanouissement": [
        "epanouissement"
    ],
    "epanouissements": [
        "epanouissement"
    ],
    "epanouissent": [
        "epanouir"
    ],
    "epanouisses": [
        "epanouir"
    ],
    "epanouit": [
        "epanouir"
    ],
    "epargna": [
        "epargner"
    ],
    "epargnaient": [
        "epargner"
    ],
    "epargnais": [
        "epargner"
    ],
    "epargnait": [
        "epargner"
    ],
    "epargnant": [
        "epargner",
        "epargnant"
    ],
    "epargnantes": [
        "epargnant"
    ],
    "epargnants": [
        "epargnant"
    ],
    "epargne": [
        "epargner",
        "epargne"
    ],
    "epargnent": [
        "epargner"
    ],
    "epargner": [
        "epargner"
    ],
    "epargnera": [
        "epargner"
    ],
    "epargnerai": [
        "epargner"
    ],
    "epargnerais": [
        "epargner"
    ],
    "epargnerait": [
        "epargner"
    ],
    "epargneras": [
        "epargner"
    ],
    "epargnerez": [
        "epargner"
    ],
    "epargneriez": [
        "epargner"
    ],
    "epargnerons": [
        "epargner"
    ],
    "epargneront": [
        "epargner"
    ],
    "epargnes": [
        "epargner",
        "epargne"
    ],
    "epargnez": [
        "epargner"
    ],
    "epargniez": [
        "epargner"
    ],
    "epargnions": [
        "epargner"
    ],
    "epargnons": [
        "epargner"
    ],
    "epargnat": [
        "epargner"
    ],
    "epargnerent": [
        "epargner"
    ],
    "epargnee": [
        "epargner"
    ],
    "epargnees": [
        "epargner"
    ],
    "eparpilla": [
        "eparpiller"
    ],
    "eparpillaient": [
        "eparpiller"
    ],
    "eparpillait": [
        "eparpiller"
    ],
    "eparpillant": [
        "eparpiller"
    ],
    "eparpille": [
        "eparpiller",
        "eparpille"
    ],
    "eparpillement": [
        "eparpillement"
    ],
    "eparpillent": [
        "eparpiller"
    ],
    "eparpiller": [
        "eparpiller"
    ],
    "eparpillera": [
        "eparpiller"
    ],
    "eparpilleraient": [
        "eparpiller"
    ],
    "eparpillez": [
        "eparpiller"
    ],
    "eparpillons": [
        "eparpiller"
    ],
    "eparpillerent": [
        "eparpiller"
    ],
    "eparpillee": [
        "eparpiller",
        "eparpille"
    ],
    "eparpillees": [
        "eparpiller",
        "eparpille"
    ],
    "eparpilles": [
        "eparpiller",
        "eparpille"
    ],
    "epars": [
        "epars"
    ],
    "eparse": [
        "epars"
    ],
    "eparses": [
        "epars"
    ],
    "epart": [
        "epart"
    ],
    "epastrouillant": [
        "epastrouillant"
    ],
    "epastrouillera": [
        "epastrouiller"
    ],
    "epata": [
        "epater"
    ],
    "epataient": [
        "epater"
    ],
    "epatais": [
        "epater"
    ],
    "epatait": [
        "epater"
    ],
    "epatamment": [
        "epatamment"
    ],
    "epatant": [
        "epatant",
        "epater"
    ],
    "epatante": [
        "epatant"
    ],
    "epatantes": [
        "epatant"
    ],
    "epatants": [
        "epatant"
    ],
    "epate": [
        "epater",
        "epate"
    ],
    "epatement": [
        "epatement"
    ],
    "epatent": [
        "epater"
    ],
    "epater": [
        "epater"
    ],
    "epatera": [
        "epater"
    ],
    "epaterait": [
        "epater"
    ],
    "epateras": [
        "epater"
    ],
    "epates": [
        "epater",
        "epate"
    ],
    "epateur": [
        "epateur"
    ],
    "epateurs": [
        "epateur"
    ],
    "epatez": [
        "epater"
    ],
    "epatee": [
        "epater",
        "epate"
    ],
    "epaula": [
        "epauler"
    ],
    "epaulaient": [
        "epauler"
    ],
    "epaulait": [
        "epauler"
    ],
    "epaulant": [
        "epauler"
    ],
    "epaulard": [
        "epaulard"
    ],
    "epaulards": [
        "epaulard"
    ],
    "epaule": [
        "epaule",
        "epauler"
    ],
    "epaulement": [
        "epaulement"
    ],
    "epaulements": [
        "epaulement"
    ],
    "epaulent": [
        "epauler"
    ],
    "epauler": [
        "epauler"
    ],
    "epauleras": [
        "epauler"
    ],
    "epaules": [
        "epaule",
        "epauler"
    ],
    "epaulette": [
        "epaulette"
    ],
    "epaulettes": [
        "epaulette"
    ],
    "epaulez": [
        "epauler"
    ],
    "epauliere": [
        "epauliere"
    ],
    "epaulieres": [
        "epauliere"
    ],
    "epaulerent": [
        "epauler"
    ],
    "epaulee": [
        "epauler"
    ],
    "epaulees": [
        "epauler"
    ],
    "epave": [
        "epave"
    ],
    "epaves": [
        "epave"
    ],
    "epeautre": [
        "epeautre"
    ],
    "epectase": [
        "epectase"
    ],
    "epeichette": [
        "epeichette"
    ],
    "epeire": [
        "epeire"
    ],
    "epela": [
        "epeler"
    ],
    "epelais": [
        "epeler"
    ],
    "epelait": [
        "epeler"
    ],
    "epelant": [
        "epeler"
    ],
    "epeler": [
        "epeler"
    ],
    "epelez": [
        "epeler"
    ],
    "epeliez": [
        "epeler"
    ],
    "epelions": [
        "epeler"
    ],
    "epellation": [
        "epellation"
    ],
    "epelle": [
        "epeler"
    ],
    "epellent": [
        "epeler"
    ],
    "epellerais": [
        "epeler"
    ],
    "epelles": [
        "epeler"
    ],
    "epele": [
        "epeler"
    ],
    "epeles": [
        "epeler"
    ],
    "ependyme": [
        "ependyme"
    ],
    "eperdu": [
        "eperdre",
        "eperdu"
    ],
    "eperdue": [
        "eperdre",
        "eperdu"
    ],
    "eperdues": [
        "eperdre",
        "eperdu"
    ],
    "eperdument": [
        "eperdument"
    ],
    "eperdus": [
        "eperdre",
        "eperdu"
    ],
    "eperlan": [
        "eperlan"
    ],
    "eperlans": [
        "eperlan"
    ],
    "eperon": [
        "eperon"
    ],
    "eperonna": [
        "eperonner"
    ],
    "eperonnant": [
        "eperonner"
    ],
    "eperonne": [
        "eperonner"
    ],
    "eperonner": [
        "eperonner"
    ],
    "eperonnera": [
        "eperonner"
    ],
    "eperonnez": [
        "eperonner"
    ],
    "eperonnerent": [
        "eperonner"
    ],
    "eperonnee": [
        "eperonner"
    ],
    "eperonnes": [
        "eperonner"
    ],
    "eperons": [
        "eperon"
    ],
    "epervier": [
        "epervier"
    ],
    "eperviers": [
        "epervier"
    ],
    "eperviere": [
        "eperviere"
    ],
    "epervieres": [
        "eperviere"
    ],
    "epeurant": [
        "epeurer"
    ],
    "epeurer": [
        "epeurer"
    ],
    "epeure": [
        "epeurer"
    ],
    "epeuree": [
        "epeurer"
    ],
    "ephebe": [
        "ephebe"
    ],
    "ephebes": [
        "ephebe"
    ],
    "ephebie": [
        "ephebie"
    ],
    "ephedrine": [
        "ephedrine"
    ],
    "ephelides": [
        "ephelide"
    ],
    "ephemere": [
        "ephemere"
    ],
    "ephemerement": [
        "ephemerement"
    ],
    "ephemeres": [
        "ephemere"
    ],
    "ephemeride": [
        "ephemeride"
    ],
    "ephemerides": [
        "ephemeride"
    ],
    "ephesiens": [
        "ephesien"
    ],
    "epi": [
        "epi"
    ],
    "epia": [
        "epier"
    ],
    "epiai": [
        "epier"
    ],
    "epiaient": [
        "epier"
    ],
    "epiais": [
        "epier"
    ],
    "epiait": [
        "epier"
    ],
    "epiant": [
        "epier"
    ],
    "epicanthus": [
        "epicanthus"
    ],
    "epice": [
        "epicer",
        "epice"
    ],
    "epicemard": [
        "epicemard"
    ],
    "epicemards": [
        "epicemard"
    ],
    "epicentre": [
        "epicentre"
    ],
    "epicer": [
        "epicer"
    ],
    "epicerie": [
        "epicerie"
    ],
    "epiceries": [
        "epicerie"
    ],
    "epices": [
        "epicer",
        "epice"
    ],
    "epicier": [
        "epicier"
    ],
    "epiciers": [
        "epicier"
    ],
    "epiciere": [
        "epicier"
    ],
    "epicieres": [
        "epicier"
    ],
    "epicondyle": [
        "epicondyle"
    ],
    "epicranienne": [
        "epicranien"
    ],
    "epicurien": [
        "epicurien"
    ],
    "epicurienne": [
        "epicurien"
    ],
    "epicuriens": [
        "epicurien"
    ],
    "epicurisme": [
        "epicurisme"
    ],
    "epicea": [
        "epicea"
    ],
    "epicee": [
        "epice",
        "epicer"
    ],
    "epicees": [
        "epice"
    ],
    "epiderme": [
        "epiderme"
    ],
    "epidermes": [
        "epiderme"
    ],
    "epidermique": [
        "epidermique"
    ],
    "epidermiques": [
        "epidermique"
    ],
    "epidiascopes": [
        "epidiascope"
    ],
    "epididyme": [
        "epididyme"
    ],
    "epididymes": [
        "epididyme"
    ],
    "epidural": [
        "epidural"
    ],
    "epidurale": [
        "epidural"
    ],
    "epidemie": [
        "epidemie"
    ],
    "epidemies": [
        "epidemie"
    ],
    "epidemiologie": [
        "epidemiologie"
    ],
    "epidemiologique": [
        "epidemiologique"
    ],
    "epidemiologiste": [
        "epidemiologiste"
    ],
    "epidemique": [
        "epidemique"
    ],
    "epidemiques": [
        "epidemique"
    ],
    "epie": [
        "epier"
    ],
    "epient": [
        "epier"
    ],
    "epier": [
        "epier"
    ],
    "epierais": [
        "epier"
    ],
    "epierait": [
        "epier"
    ],
    "epierrer": [
        "epierrer"
    ],
    "epies": [
        "epier"
    ],
    "epieu": [
        "epieu"
    ],
    "epieux": [
        "epieux"
    ],
    "epiez": [
        "epier"
    ],
    "epigastre": [
        "epigastre"
    ],
    "epigastrique": [
        "epigastrique"
    ],
    "epiglotte": [
        "epiglotte"
    ],
    "epigone": [
        "epigone"
    ],
    "epigones": [
        "epigone"
    ],
    "epigramme": [
        "epigramme"
    ],
    "epigrammes": [
        "epigramme"
    ],
    "epigraphe": [
        "epigraphe"
    ],
    "epigraphie": [
        "epigraphie"
    ],
    "epigraphistes": [
        "epigraphiste"
    ],
    "epilais": [
        "epiler"
    ],
    "epilait": [
        "epiler"
    ],
    "epilant": [
        "epiler"
    ],
    "epilateur": [
        "epilateur"
    ],
    "epilation": [
        "epilation"
    ],
    "epilatoire": [
        "epilatoire"
    ],
    "epile": [
        "epiler"
    ],
    "epilent": [
        "epiler"
    ],
    "epilepsie": [
        "epilepsie"
    ],
    "epileptiforme": [
        "epileptiforme"
    ],
    "epileptique": [
        "epileptique"
    ],
    "epileptiques": [
        "epileptique"
    ],
    "epiler": [
        "epiler"
    ],
    "epileuse": [
        "epileur"
    ],
    "epilez": [
        "epiler"
    ],
    "epiloguaient": [
        "epiloguer"
    ],
    "epilogue": [
        "epiloguer",
        "epilogue"
    ],
    "epiloguer": [
        "epiloguer"
    ],
    "epilogues": [
        "epilogue"
    ],
    "epiloguions": [
        "epiloguer"
    ],
    "epiloguerent": [
        "epiloguer"
    ],
    "epilee": [
        "epiler"
    ],
    "epilees": [
        "epiler"
    ],
    "epiles": [
        "epiler"
    ],
    "epinaie": [
        "epinaie"
    ],
    "epinard": [
        "epinard"
    ],
    "epinards": [
        "epinard"
    ],
    "epine": [
        "epine"
    ],
    "epines": [
        "epine"
    ],
    "epinette": [
        "epinette"
    ],
    "epinettes": [
        "epinette"
    ],
    "epineuse": [
        "epineux"
    ],
    "epineuses": [
        "epineux"
    ],
    "epineux": [
        "epineux"
    ],
    "epingla": [
        "epingler"
    ],
    "epinglage": [
        "epinglage"
    ],
    "epinglai": [
        "epingler"
    ],
    "epinglaient": [
        "epingler"
    ],
    "epinglait": [
        "epingler"
    ],
    "epingle": [
        "epingle",
        "epingler"
    ],
    "epinglent": [
        "epingler"
    ],
    "epingler": [
        "epingler"
    ],
    "epinglera": [
        "epingler"
    ],
    "epinglerai": [
        "epingler"
    ],
    "epingleront": [
        "epingler"
    ],
    "epingles": [
        "epingle",
        "epingler"
    ],
    "epinglette": [
        "epinglette"
    ],
    "epinglez": [
        "epingler"
    ],
    "epinglons": [
        "epingler"
    ],
    "epinglerent": [
        "epingler"
    ],
    "epinglee": [
        "epingler"
    ],
    "epinglees": [
        "epingle",
        "epingler"
    ],
    "epiniers": [
        "epinier"
    ],
    "epiniere": [
        "epinier"
    ],
    "epinoches": [
        "epinoche"
    ],
    "epions": [
        "epier"
    ],
    "epiphane": [
        "epiphane"
    ],
    "epiphanie": [
        "epiphanie"
    ],
    "epiphylle": [
        "epiphylle"
    ],
    "epiphylles": [
        "epiphylle"
    ],
    "epiphysaire": [
        "epiphysaire"
    ],
    "epiphyse": [
        "epiphyse"
    ],
    "epiphyte": [
        "epiphyte"
    ],
    "epiphytes": [
        "epiphyte"
    ],
    "epiphenomene": [
        "epiphenomene"
    ],
    "epiploon": [
        "epiploon"
    ],
    "epiploons": [
        "epiploon"
    ],
    "epique": [
        "epique"
    ],
    "epiques": [
        "epique"
    ],
    "epis": [
        "epi"
    ],
    "episcopal": [
        "episcopal"
    ],
    "episcopale": [
        "episcopal"
    ],
    "episcopales": [
        "episcopal"
    ],
    "episcopalien": [
        "episcopalien"
    ],
    "episcopalienne": [
        "episcopalien"
    ],
    "episcopat": [
        "episcopat"
    ],
    "episcopaux": [
        "episcopal"
    ],
    "episiotomie": [
        "episiotomie"
    ],
    "episode": [
        "episode"
    ],
    "episodes": [
        "episode"
    ],
    "episodique": [
        "episodique"
    ],
    "episodiquement": [
        "episodiquement"
    ],
    "episodiques": [
        "episodique"
    ],
    "episser": [
        "episser"
    ],
    "epissoirs": [
        "epissoir"
    ],
    "epissures": [
        "epissure"
    ],
    "episse": [
        "episser"
    ],
    "epistolaire": [
        "epistolaire"
    ],
    "epistolaires": [
        "epistolaire"
    ],
    "epistolier": [
        "epistolier"
    ],
    "epistoliere": [
        "epistolier"
    ],
    "epistemologie": [
        "epistemologie"
    ],
    "epistemologique": [
        "epistemologique"
    ],
    "epistemologues": [
        "epistemologue"
    ],
    "epitaphe": [
        "epitaphe"
    ],
    "epitaphes": [
        "epitaphe"
    ],
    "epithalame": [
        "epithalame"
    ],
    "epithalames": [
        "epithalame"
    ],
    "epithete": [
        "epithete"
    ],
    "epithetes": [
        "epithete"
    ],
    "epithelial": [
        "epithelial"
    ],
    "epitheliale": [
        "epithelial"
    ],
    "epithelioma": [
        "epithelioma"
    ],
    "epithelium": [
        "epithelium"
    ],
    "epitoge": [
        "epitoge"
    ],
    "epitome": [
        "epitome"
    ],
    "epierent": [
        "epier"
    ],
    "epiee": [
        "epier"
    ],
    "epiees": [
        "epier"
    ],
    "eploie": [
        "eployer"
    ],
    "eploient": [
        "eployer"
    ],
    "eplore": [
        "eplore"
    ],
    "eploree": [
        "eplore"
    ],
    "eplorees": [
        "eplore"
    ],
    "eplores": [
        "eplore"
    ],
    "eployai": [
        "eployer"
    ],
    "eployait": [
        "eployer"
    ],
    "eployer": [
        "eployer"
    ],
    "eploye": [
        "eployer"
    ],
    "eployee": [
        "eployer"
    ],
    "eployees": [
        "eployer"
    ],
    "eployes": [
        "eployer"
    ],
    "eplucha": [
        "eplucher"
    ],
    "epluchage": [
        "epluchage"
    ],
    "epluchages": [
        "epluchage"
    ],
    "epluchaient": [
        "eplucher"
    ],
    "epluchais": [
        "eplucher"
    ],
    "epluchait": [
        "eplucher"
    ],
    "epluchant": [
        "eplucher"
    ],
    "epluche": [
        "eplucher"
    ],
    "epluchent": [
        "eplucher"
    ],
    "eplucher": [
        "eplucher"
    ],
    "epluchera": [
        "eplucher"
    ],
    "eplucherai": [
        "eplucher"
    ],
    "eplucherons": [
        "eplucher"
    ],
    "epluches": [
        "eplucher"
    ],
    "eplucheur": [
        "eplucheur"
    ],
    "eplucheurs": [
        "eplucheur"
    ],
    "eplucheuses": [
        "eplucheur"
    ],
    "epluchez": [
        "eplucher"
    ],
    "epluchions": [
        "eplucher"
    ],
    "epluchons": [
        "eplucher"
    ],
    "epluchure": [
        "epluchure"
    ],
    "epluchures": [
        "epluchure"
    ],
    "epluchat": [
        "eplucher"
    ],
    "epluchee": [
        "eplucher"
    ],
    "epluchees": [
        "eplucher"
    ],
    "epointe": [
        "epointer"
    ],
    "epointees": [
        "epointer"
    ],
    "epointes": [
        "epointer"
    ],
    "eponge": [
        "eponger",
        "eponge"
    ],
    "epongea": [
        "eponger"
    ],
    "epongeage": [
        "epongeage"
    ],
    "epongeaient": [
        "eponger"
    ],
    "epongeais": [
        "eponger"
    ],
    "epongeait": [
        "eponger"
    ],
    "epongeant": [
        "eponger"
    ],
    "epongent": [
        "eponger"
    ],
    "epongeons": [
        "eponger"
    ],
    "eponger": [
        "eponger"
    ],
    "eponges": [
        "eponger",
        "eponge"
    ],
    "epongez": [
        "eponger"
    ],
    "epongiez": [
        "eponger"
    ],
    "epongerent": [
        "eponger"
    ],
    "epongee": [
        "eponger"
    ],
    "eponyme": [
        "eponyme"
    ],
    "epopee": [
        "epopee"
    ],
    "epopees": [
        "epopee"
    ],
    "epoque": [
        "epoque"
    ],
    "epoques": [
        "epoque"
    ],
    "epouillage": [
        "epouillage"
    ],
    "epouillaient": [
        "epouiller"
    ],
    "epouillait": [
        "epouiller"
    ],
    "epouille": [
        "epouiller"
    ],
    "epouillent": [
        "epouiller"
    ],
    "epouiller": [
        "epouiller"
    ],
    "epouilles": [
        "epouiller"
    ],
    "epoumonaient": [
        "epoumoner"
    ],
    "epoumonait": [
        "epoumoner"
    ],
    "epoumonant": [
        "epoumoner"
    ],
    "epoumone": [
        "epoumoner"
    ],
    "epoumoner": [
        "epoumoner"
    ],
    "epoumonerent": [
        "epoumoner"
    ],
    "epoumones": [
        "epoumoner"
    ],
    "epousa": [
        "epouser"
    ],
    "epousable": [
        "epousable"
    ],
    "epousai": [
        "epouser"
    ],
    "epousaient": [
        "epouser"
    ],
    "epousailles": [
        "epousailles"
    ],
    "epousais": [
        "epouser"
    ],
    "epousait": [
        "epouser"
    ],
    "epousant": [
        "epouser"
    ],
    "epouse": [
        "epouser",
        "epoux"
    ],
    "epousent": [
        "epouser"
    ],
    "epouser": [
        "epouser"
    ],
    "epousera": [
        "epouser"
    ],
    "epouserai": [
        "epouser"
    ],
    "epouseraient": [
        "epouser"
    ],
    "epouserais": [
        "epouser"
    ],
    "epouserait": [
        "epouser"
    ],
    "epouseras": [
        "epouser"
    ],
    "epouserez": [
        "epouser"
    ],
    "epouseriez": [
        "epouser"
    ],
    "epouserons": [
        "epouser"
    ],
    "epouseront": [
        "epouser"
    ],
    "epouses": [
        "epouser",
        "epoux"
    ],
    "epouseur": [
        "epouseur"
    ],
    "epouseurs": [
        "epouseur"
    ],
    "epousez": [
        "epouser"
    ],
    "epousiez": [
        "epouser"
    ],
    "epousions": [
        "epouser"
    ],
    "epousons": [
        "epouser"
    ],
    "epousseta": [
        "epousseter"
    ],
    "epoussetage": [
        "epoussetage"
    ],
    "epoussetaient": [
        "epousseter"
    ],
    "epoussetais": [
        "epousseter"
    ],
    "epoussetait": [
        "epousseter"
    ],
    "epoussetant": [
        "epousseter"
    ],
    "epousseter": [
        "epousseter"
    ],
    "epoussetez": [
        "epousseter"
    ],
    "epoussette": [
        "epousseter"
    ],
    "epoussettent": [
        "epousseter"
    ],
    "epousseterent": [
        "epousseter"
    ],
    "epoussete": [
        "epousseter"
    ],
    "epoussetee": [
        "epousseter"
    ],
    "epoussetes": [
        "epousseter"
    ],
    "epoustouflait": [
        "epoustoufler"
    ],
    "epoustouflant": [
        "epoustouflant",
        "epoustoufler"
    ],
    "epoustouflante": [
        "epoustouflant"
    ],
    "epoustouflantes": [
        "epoustouflant"
    ],
    "epoustouflants": [
        "epoustouflant"
    ],
    "epoustoufle": [
        "epoustoufler"
    ],
    "epoustoufler": [
        "epoustoufler"
    ],
    "epoustouflee": [
        "epoustoufler"
    ],
    "epoustoufles": [
        "epoustoufler"
    ],
    "epousat": [
        "epouser"
    ],
    "epouserent": [
        "epouser"
    ],
    "epousee": [
        "epouser",
        "epousee"
    ],
    "epousees": [
        "epouser",
        "epousee"
    ],
    "epouvanta": [
        "epouvanter"
    ],
    "epouvantable": [
        "epouvantable"
    ],
    "epouvantablement": [
        "epouvantablement"
    ],
    "epouvantables": [
        "epouvantable"
    ],
    "epouvantaient": [
        "epouvanter"
    ],
    "epouvantail": [
        "epouvantail"
    ],
    "epouvantails": [
        "epouvantail"
    ],
    "epouvantait": [
        "epouvanter"
    ],
    "epouvante": [
        "epouvante",
        "epouvanter"
    ],
    "epouvantement": [
        "epouvantement"
    ],
    "epouvantements": [
        "epouvantement"
    ],
    "epouvantent": [
        "epouvanter"
    ],
    "epouvanter": [
        "epouvanter"
    ],
    "epouvanteraient": [
        "epouvanter"
    ],
    "epouvantes": [
        "epouvante",
        "epouvanter"
    ],
    "epouvantez": [
        "epouvanter"
    ],
    "epouvanterent": [
        "epouvanter"
    ],
    "epouvantee": [
        "epouvante",
        "epouvanter"
    ],
    "epouvantees": [
        "epouvante",
        "epouvanter"
    ],
    "epoux": [
        "epoux"
    ],
    "epoxy": [
        "epoxy"
    ],
    "epoxyde": [
        "epoxyde"
    ],
    "eprenait": [
        "eprendre"
    ],
    "eprenant": [
        "eprendre"
    ],
    "eprend": [
        "eprendre"
    ],
    "eprendre": [
        "eprendre"
    ],
    "eprends": [
        "eprendre"
    ],
    "eprenne": [
        "eprendre"
    ],
    "eprennent": [
        "eprendre"
    ],
    "epreuve": [
        "epreuve"
    ],
    "epreuves": [
        "epreuve"
    ],
    "epris": [
        "epris",
        "eprendre"
    ],
    "eprise": [
        "epris",
        "eprendre"
    ],
    "eprises": [
        "epris",
        "eprendre"
    ],
    "eprit": [
        "eprendre"
    ],
    "eprouva": [
        "eprouver"
    ],
    "eprouvai": [
        "eprouver"
    ],
    "eprouvaient": [
        "eprouver"
    ],
    "eprouvais": [
        "eprouver"
    ],
    "eprouvait": [
        "eprouver"
    ],
    "eprouvant": [
        "eprouvant",
        "eprouver"
    ],
    "eprouvante": [
        "eprouvant"
    ],
    "eprouvantes": [
        "eprouvant"
    ],
    "eprouvants": [
        "eprouvant"
    ],
    "eprouve": [
        "eprouve",
        "eprouver"
    ],
    "eprouvent": [
        "eprouver"
    ],
    "eprouver": [
        "eprouver"
    ],
    "eprouvera": [
        "eprouver"
    ],
    "eprouverai": [
        "eprouver"
    ],
    "eprouveraient": [
        "eprouver"
    ],
    "eprouverais": [
        "eprouver"
    ],
    "eprouverait": [
        "eprouver"
    ],
    "eprouveras": [
        "eprouver"
    ],
    "eprouverez": [
        "eprouver"
    ],
    "eprouveront": [
        "eprouver"
    ],
    "eprouves": [
        "eprouve",
        "eprouver"
    ],
    "eprouvette": [
        "eprouvette"
    ],
    "eprouvettes": [
        "eprouvette"
    ],
    "eprouvez": [
        "eprouver"
    ],
    "eprouviez": [
        "eprouver"
    ],
    "eprouvions": [
        "eprouver"
    ],
    "eprouvons": [
        "eprouver"
    ],
    "eprouvames": [
        "eprouver"
    ],
    "eprouvat": [
        "eprouver"
    ],
    "eprouverent": [
        "eprouver"
    ],
    "eprouvee": [
        "eprouve",
        "eprouver"
    ],
    "eprouvees": [
        "eprouve",
        "eprouver"
    ],
    "epucer": [
        "epucer"
    ],
    "epuisa": [
        "epuiser"
    ],
    "epuisai": [
        "epuiser"
    ],
    "epuisaient": [
        "epuiser"
    ],
    "epuisais": [
        "epuiser"
    ],
    "epuisait": [
        "epuiser"
    ],
    "epuisant": [
        "epuisant",
        "epuiser"
    ],
    "epuisante": [
        "epuisant"
    ],
    "epuisantes": [
        "epuisant"
    ],
    "epuisants": [
        "epuisant"
    ],
    "epuise": [
        "epuise",
        "epuiser"
    ],
    "epuisement": [
        "epuisement"
    ],
    "epuisements": [
        "epuisement"
    ],
    "epuisent": [
        "epuiser"
    ],
    "epuiser": [
        "epuiser"
    ],
    "epuisera": [
        "epuiser"
    ],
    "epuiseraient": [
        "epuiser"
    ],
    "epuiserait": [
        "epuiser"
    ],
    "epuiseras": [
        "epuiser"
    ],
    "epuiserons": [
        "epuiser"
    ],
    "epuiseront": [
        "epuiser"
    ],
    "epuises": [
        "epuise",
        "epuiser"
    ],
    "epuisette": [
        "epuisette"
    ],
    "epuisettes": [
        "epuisette"
    ],
    "epuisez": [
        "epuiser"
    ],
    "epuisiez": [
        "epuiser"
    ],
    "epuisons": [
        "epuiser"
    ],
    "epuisat": [
        "epuiser"
    ],
    "epuiserent": [
        "epuiser"
    ],
    "epuisee": [
        "epuise",
        "epuiser"
    ],
    "epuisees": [
        "epuise",
        "epuiser"
    ],
    "epulie": [
        "epulie"
    ],
    "epurait": [
        "epurer"
    ],
    "epurant": [
        "epurer"
    ],
    "epurateur": [
        "epurateur"
    ],
    "epuration": [
        "epuration"
    ],
    "epurations": [
        "epuration"
    ],
    "epurative": [
        "epuratif"
    ],
    "epure": [
        "epure",
        "epurer"
    ],
    "epurer": [
        "epurer"
    ],
    "epures": [
        "epure",
        "epurer"
    ],
    "epuree": [
        "epurer"
    ],
    "epurees": [
        "epurer"
    ],
    "epucat": [
        "epucer"
    ],
    "epee": [
        "epee"
    ],
    "epees": [
        "epee"
    ],
    "epeiste": [
        "epeiste"
    ],
    "epeistes": [
        "epeiste"
    ],
    "epepine": [
        "epepiner"
    ],
    "epitre": [
        "epitre"
    ],
    "epitres": [
        "epitre"
    ],
    "equanimite": [
        "equanimite"
    ],
    "equarisseur": [
        "equarisseur"
    ],
    "equarisseurs": [
        "equarisseur"
    ],
    "equarri": [
        "equarri",
        "equarrir"
    ],
    "equarrie": [
        "equarri"
    ],
    "equarries": [
        "equarri",
        "equarrir"
    ],
    "equarrir": [
        "equarrir"
    ],
    "equarris": [
        "equarri",
        "equarrir"
    ],
    "equarrissage": [
        "equarrissage"
    ],
    "equarrissait": [
        "equarrir"
    ],
    "equarrisseur": [
        "equarrisseur"
    ],
    "equarrisseurs": [
        "equarrisseur"
    ],
    "equateur": [
        "equateur"
    ],
    "equation": [
        "equation"
    ],
    "equations": [
        "equation"
    ],
    "equatorial": [
        "equatorial"
    ],
    "equatoriale": [
        "equatorial"
    ],
    "equatoriaux": [
        "equatorial"
    ],
    "equatorien": [
        "equatorien"
    ],
    "equatoriennes": [
        "equatorien"
    ],
    "equerrage": [
        "equerrage"
    ],
    "equerre": [
        "equerre"
    ],
    "equerres": [
        "equerre"
    ],
    "equestre": [
        "equestre"
    ],
    "equestres": [
        "equestre"
    ],
    "equeuter": [
        "equeuter"
    ],
    "equeutees": [
        "equeute"
    ],
    "equidistance": [
        "equidistance"
    ],
    "equidistant": [
        "equidistant"
    ],
    "equidistante": [
        "equidistant"
    ],
    "equidistantes": [
        "equidistant"
    ],
    "equidistants": [
        "equidistant"
    ],
    "equides": [
        "equide"
    ],
    "equilateral": [
        "equilateral"
    ],
    "equilateraux": [
        "equilateral"
    ],
    "equilibra": [
        "equilibrer"
    ],
    "equilibrage": [
        "equilibrage"
    ],
    "equilibraient": [
        "equilibrer"
    ],
    "equilibrais": [
        "equilibrer"
    ],
    "equilibrait": [
        "equilibrer"
    ],
    "equilibrant": [
        "equilibrer"
    ],
    "equilibrante": [
        "equilibrant"
    ],
    "equilibre": [
        "equilibrer",
        "equilibre"
    ],
    "equilibrent": [
        "equilibrer"
    ],
    "equilibrer": [
        "equilibrer"
    ],
    "equilibres": [
        "equilibrer",
        "equilibre"
    ],
    "equilibreur": [
        "equilibreur"
    ],
    "equilibrisme": [
        "equilibrisme"
    ],
    "equilibriste": [
        "equilibriste"
    ],
    "equilibristes": [
        "equilibriste"
    ],
    "equilibrerent": [
        "equilibrer"
    ],
    "equilibree": [
        "equilibre",
        "equilibrer"
    ],
    "equilibrees": [
        "equilibre",
        "equilibrer"
    ],
    "equin": [
        "equin"
    ],
    "equine": [
        "equin"
    ],
    "equinoxe": [
        "equinoxe"
    ],
    "equinoxes": [
        "equinoxe"
    ],
    "equipa": [
        "equiper"
    ],
    "equipage": [
        "equipage"
    ],
    "equipages": [
        "equipage"
    ],
    "equipai": [
        "equiper"
    ],
    "equipait": [
        "equiper"
    ],
    "equipant": [
        "equiper"
    ],
    "equipe": [
        "equiper",
        "equipe"
    ],
    "equipement": [
        "equipement"
    ],
    "equipements": [
        "equipement"
    ],
    "equipent": [
        "equiper"
    ],
    "equiper": [
        "equiper"
    ],
    "equipera": [
        "equiper"
    ],
    "equiperai": [
        "equiper"
    ],
    "equiperais": [
        "equiper"
    ],
    "equipes": [
        "equiper",
        "equipe"
    ],
    "equipez": [
        "equiper"
    ],
    "equipier": [
        "equipier"
    ],
    "equipiers": [
        "equipier"
    ],
    "equipiere": [
        "equipier"
    ],
    "equipons": [
        "equiper"
    ],
    "equiperent": [
        "equiper"
    ],
    "equipee": [
        "equiper",
        "equipee"
    ],
    "equipees": [
        "equiper",
        "equipee"
    ],
    "equitable": [
        "equitable"
    ],
    "equitablement": [
        "equitablement"
    ],
    "equitables": [
        "equitable"
    ],
    "equitation": [
        "equitation"
    ],
    "equite": [
        "equite"
    ],
    "equivalaient": [
        "equivaloir"
    ],
    "equivalait": [
        "equivaloir"
    ],
    "equivalant": [
        "equivaloir"
    ],
    "equivalence": [
        "equivalence"
    ],
    "equivalences": [
        "equivalence"
    ],
    "equivalent": [
        "equivalent",
        "equivaloir"
    ],
    "equivalente": [
        "equivalent"
    ],
    "equivalentes": [
        "equivalent"
    ],
    "equivalents": [
        "equivalent"
    ],
    "equivaloir": [
        "equivaloir"
    ],
    "equivalu": [
        "equivaloir"
    ],
    "equivalut": [
        "equivaloir"
    ],
    "equivaudra": [
        "equivaloir"
    ],
    "equivaudrait": [
        "equivaloir"
    ],
    "equivaut": [
        "equivaloir"
    ],
    "equivoque": [
        "equivoque"
    ],
    "equivoquer": [
        "equivoquer"
    ],
    "equivoques": [
        "equivoque"
    ],
    "erable": [
        "erable"
    ],
    "erables": [
        "erable"
    ],
    "erablieres": [
        "erabliere"
    ],
    "eradicateur": [
        "eradicateur"
    ],
    "eradication": [
        "eradication"
    ],
    "eradiquer": [
        "eradiquer"
    ],
    "eradiquerai": [
        "eradiquer"
    ],
    "eradiqueront": [
        "eradiquer"
    ],
    "eradiquons": [
        "eradiquer"
    ],
    "eradique": [
        "eradiquer"
    ],
    "eradiquee": [
        "eradiquer"
    ],
    "erafla": [
        "erafler"
    ],
    "eraflait": [
        "erafler"
    ],
    "erafle": [
        "erafler"
    ],
    "erafler": [
        "erafler"
    ],
    "eraflez": [
        "erafler"
    ],
    "eraflure": [
        "eraflure"
    ],
    "eraflures": [
        "eraflure"
    ],
    "eraflee": [
        "erafler"
    ],
    "eraflees": [
        "erafler"
    ],
    "erafles": [
        "erafler"
    ],
    "erailla": [
        "erailler"
    ],
    "eraillaient": [
        "erailler"
    ],
    "eraillait": [
        "erailler"
    ],
    "eraillant": [
        "erailler"
    ],
    "eraille": [
        "eraille",
        "erailler"
    ],
    "eraillent": [
        "erailler"
    ],
    "erailler": [
        "erailler"
    ],
    "eraillures": [
        "eraillure"
    ],
    "eraillee": [
        "eraille",
        "erailler"
    ],
    "eraillees": [
        "eraille",
        "erailler"
    ],
    "erailles": [
        "eraille",
        "erailler"
    ],
    "erectile": [
        "erectile"
    ],
    "erectiles": [
        "erectile"
    ],
    "erection": [
        "erection"
    ],
    "erections": [
        "erection"
    ],
    "ereintait": [
        "ereinter"
    ],
    "ereintant": [
        "ereintant",
        "ereinter"
    ],
    "ereintante": [
        "ereintant"
    ],
    "ereintants": [
        "ereintant"
    ],
    "ereinte": [
        "ereinte",
        "ereinter"
    ],
    "ereintement": [
        "ereintement"
    ],
    "ereintent": [
        "ereinter"
    ],
    "ereinter": [
        "ereinter"
    ],
    "ereinteur": [
        "ereinteur"
    ],
    "ereintee": [
        "ereinte",
        "ereinter"
    ],
    "ereintees": [
        "ereinte",
        "ereinter"
    ],
    "ereintes": [
        "ereinte",
        "ereinter"
    ],
    "erige": [
        "eriger"
    ],
    "erigea": [
        "eriger"
    ],
    "erigeaient": [
        "eriger"
    ],
    "erigeait": [
        "eriger"
    ],
    "erigeant": [
        "eriger"
    ],
    "erigent": [
        "eriger"
    ],
    "eriger": [
        "eriger"
    ],
    "erigeat": [
        "eriger"
    ],
    "erigee": [
        "eriger"
    ],
    "erigees": [
        "eriger"
    ],
    "eriges": [
        "eriger"
    ],
    "erode": [
        "eroder",
        "erode"
    ],
    "erodent": [
        "eroder"
    ],
    "eroder": [
        "eroder"
    ],
    "erodee": [
        "eroder",
        "erode"
    ],
    "erodees": [
        "eroder",
        "erode"
    ],
    "erodes": [
        "eroder",
        "erode"
    ],
    "erogene": [
        "erogene"
    ],
    "erogenes": [
        "erogene"
    ],
    "eros": [
        "eros"
    ],
    "erosion": [
        "erosion"
    ],
    "erosions": [
        "erosion"
    ],
    "erotique": [
        "erotique"
    ],
    "erotiquement": [
        "erotiquement"
    ],
    "erotiques": [
        "erotique"
    ],
    "erotise": [
        "erotiser"
    ],
    "erotiser": [
        "erotiser"
    ],
    "erotisme": [
        "erotisme"
    ],
    "erotisee": [
        "erotiser"
    ],
    "erotomane": [
        "erotomane"
    ],
    "erotomanie": [
        "erotomanie"
    ],
    "eructa": [
        "eructer"
    ],
    "eructait": [
        "eructer"
    ],
    "eructant": [
        "eructer"
    ],
    "eructation": [
        "eructation"
    ],
    "eructations": [
        "eructation"
    ],
    "eructe": [
        "eructer"
    ],
    "eructer": [
        "eructer"
    ],
    "eructes": [
        "eructer"
    ],
    "eructees": [
        "eructer"
    ],
    "erudit": [
        "erudit"
    ],
    "erudite": [
        "erudit"
    ],
    "erudites": [
        "erudit"
    ],
    "erudition": [
        "erudition"
    ],
    "erudits": [
        "erudit"
    ],
    "eruption": [
        "eruption"
    ],
    "eruptions": [
        "eruption"
    ],
    "eruptive": [
        "eruptif"
    ],
    "eruptives": [
        "eruptif"
    ],
    "erythromycine": [
        "erythromycine"
    ],
    "erythrophobie": [
        "erythrophobie"
    ],
    "erythreenne": [
        "erythreen"
    ],
    "erytheme": [
        "erytheme"
    ],
    "erythemes": [
        "erytheme"
    ],
    "erythemateux": [
        "erythemateux"
    ],
    "esoterique": [
        "esoterique"
    ],
    "esoteriques": [
        "esoterique"
    ],
    "esoterisme": [
        "esoterisme"
    ],
    "esoteristes": [
        "esoteriste"
    ],
    "etable": [
        "etable"
    ],
    "etables": [
        "etable"
    ],
    "etabli": [
        "etabli",
        "etablir"
    ],
    "etablie": [
        "etabli",
        "etablir"
    ],
    "etablies": [
        "etabli",
        "etablir"
    ],
    "etablir": [
        "etablir"
    ],
    "etablira": [
        "etablir"
    ],
    "etablirai": [
        "etablir"
    ],
    "etabliraient": [
        "etablir"
    ],
    "etablirais": [
        "etablir"
    ],
    "etablirait": [
        "etablir"
    ],
    "etablirent": [
        "etablir"
    ],
    "etablirez": [
        "etablir"
    ],
    "etablirions": [
        "etablir"
    ],
    "etablirons": [
        "etablir"
    ],
    "etabliront": [
        "etablir"
    ],
    "etablis": [
        "etabli",
        "etablir"
    ],
    "etablissaient": [
        "etablir"
    ],
    "etablissais": [
        "etablir"
    ],
    "etablissait": [
        "etablir"
    ],
    "etablissant": [
        "etablir"
    ],
    "etablisse": [
        "etablir"
    ],
    "etablissement": [
        "etablissement"
    ],
    "etablissements": [
        "etablissement"
    ],
    "etablissent": [
        "etablir"
    ],
    "etablisses": [
        "etablir"
    ],
    "etablissez": [
        "etablir"
    ],
    "etablissions": [
        "etablir"
    ],
    "etablissons": [
        "etablir"
    ],
    "etablit": [
        "etablir"
    ],
    "etage": [
        "etager",
        "etage"
    ],
    "etagea": [
        "etager"
    ],
    "etageaient": [
        "etager"
    ],
    "etageait": [
        "etager"
    ],
    "etageant": [
        "etager"
    ],
    "etagent": [
        "etager"
    ],
    "etages": [
        "etager",
        "etage"
    ],
    "etagere": [
        "etagere"
    ],
    "etageres": [
        "etagere"
    ],
    "etagee": [
        "etager",
        "etage"
    ],
    "etagees": [
        "etager",
        "etage"
    ],
    "etai": [
        "etai"
    ],
    "etaie": [
        "etayer"
    ],
    "etaient": [
        "etre"
    ],
    "etain": [
        "etain"
    ],
    "etains": [
        "etain"
    ],
    "etais": [
        "etre",
        "etai"
    ],
    "etait": [
        "etre"
    ],
    "etal": [
        "etal"
    ],
    "etala": [
        "etaler"
    ],
    "etalage": [
        "etalage"
    ],
    "etalages": [
        "etalage"
    ],
    "etalagiste": [
        "etalagiste"
    ],
    "etalai": [
        "etaler"
    ],
    "etalaient": [
        "etaler"
    ],
    "etalais": [
        "etaler"
    ],
    "etalait": [
        "etaler"
    ],
    "etalant": [
        "etaler"
    ],
    "etale": [
        "etaler",
        "etale"
    ],
    "etalement": [
        "etalement"
    ],
    "etalements": [
        "etalement"
    ],
    "etalent": [
        "etaler"
    ],
    "etaler": [
        "etaler"
    ],
    "etalera": [
        "etaler"
    ],
    "etalerai": [
        "etaler"
    ],
    "etaleraient": [
        "etaler"
    ],
    "etalerait": [
        "etaler"
    ],
    "etaleras": [
        "etaler"
    ],
    "etaleront": [
        "etaler"
    ],
    "etales": [
        "etaler",
        "etale"
    ],
    "etalez": [
        "etaler"
    ],
    "etalions": [
        "etaler"
    ],
    "etalon": [
        "etalon"
    ],
    "etalonnage": [
        "etalonnage"
    ],
    "etalonnages": [
        "etalonnage"
    ],
    "etalonne": [
        "etalonner"
    ],
    "etalonner": [
        "etalonner"
    ],
    "etalonnes": [
        "etalonne"
    ],
    "etalons": [
        "etalon",
        "etaler"
    ],
    "etals": [
        "etal"
    ],
    "etalat": [
        "etaler"
    ],
    "etalerent": [
        "etaler"
    ],
    "etalee": [
        "etaler"
    ],
    "etalees": [
        "etaler"
    ],
    "etamaient": [
        "etamer"
    ],
    "etambot": [
        "etambot"
    ],
    "etameur": [
        "etameur"
    ],
    "etameurs": [
        "etameur"
    ],
    "etamine": [
        "etamine"
    ],
    "etamines": [
        "etamine"
    ],
    "etampes": [
        "etampe"
    ],
    "etampures": [
        "etampure"
    ],
    "etame": [
        "etame",
        "etamer"
    ],
    "etanchaient": [
        "etancher"
    ],
    "etanchait": [
        "etancher"
    ],
    "etanche": [
        "etanche",
        "etancher"
    ],
    "etanchement": [
        "etanchement"
    ],
    "etanchent": [
        "etancher"
    ],
    "etancher": [
        "etancher"
    ],
    "etancherait": [
        "etancher"
    ],
    "etanches": [
        "etanche",
        "etancher"
    ],
    "etanchee": [
        "etancher"
    ],
    "etancheite": [
        "etancheite"
    ],
    "etang": [
        "etang"
    ],
    "etangs": [
        "etang"
    ],
    "etant": [
        "etre"
    ],
    "etancon": [
        "etancon"
    ],
    "etape": [
        "etape"
    ],
    "etapes": [
        "etape"
    ],
    "etat": [
        "etat"
    ],
    "etatique": [
        "etatique"
    ],
    "etatiques": [
        "etatique"
    ],
    "etatisation": [
        "etatisation"
    ],
    "etatisme": [
        "etatisme"
    ],
    "etats": [
        "etat"
    ],
    "etau": [
        "etau"
    ],
    "etaux": [
        "etau"
    ],
    "etayage": [
        "etayage"
    ],
    "etayaient": [
        "etayer"
    ],
    "etayait": [
        "etayer"
    ],
    "etayant": [
        "etayer"
    ],
    "etaye": [
        "etayer"
    ],
    "etayer": [
        "etayer"
    ],
    "etayez": [
        "etayer"
    ],
    "etayee": [
        "etayer"
    ],
    "etayees": [
        "etayer"
    ],
    "etayes": [
        "etayer"
    ],
    "eteignaient": [
        "eteindre"
    ],
    "eteignais": [
        "eteindre"
    ],
    "eteignait": [
        "eteindre"
    ],
    "eteignant": [
        "eteindre"
    ],
    "eteigne": [
        "eteindre"
    ],
    "eteignent": [
        "eteindre"
    ],
    "eteignes": [
        "eteindre"
    ],
    "eteignez": [
        "eteindre"
    ],
    "eteignions": [
        "eteindre"
    ],
    "eteignirent": [
        "eteindre"
    ],
    "eteignis": [
        "eteindre"
    ],
    "eteignit": [
        "eteindre"
    ],
    "eteignoir": [
        "eteignoir"
    ],
    "eteignons": [
        "eteindre"
    ],
    "eteindra": [
        "eteindre"
    ],
    "eteindrai": [
        "eteindre"
    ],
    "eteindraient": [
        "eteindre"
    ],
    "eteindrais": [
        "eteindre"
    ],
    "eteindrait": [
        "eteindre"
    ],
    "eteindras": [
        "eteindre"
    ],
    "eteindre": [
        "eteindre"
    ],
    "eteindrez": [
        "eteindre"
    ],
    "eteindrons": [
        "eteindre"
    ],
    "eteindront": [
        "eteindre"
    ],
    "eteins": [
        "eteindre"
    ],
    "eteint": [
        "eteindre",
        "eteint"
    ],
    "eteinte": [
        "eteindre",
        "eteint"
    ],
    "eteintes": [
        "eteindre",
        "eteint"
    ],
    "eteints": [
        "eteindre",
        "eteint"
    ],
    "etend": [
        "etendre"
    ],
    "etendage": [
        "etendage"
    ],
    "etendaient": [
        "etendre"
    ],
    "etendais": [
        "etendre"
    ],
    "etendait": [
        "etendre"
    ],
    "etendant": [
        "etendre"
    ],
    "etendard": [
        "etendard"
    ],
    "etendards": [
        "etendard"
    ],
    "etende": [
        "etendre"
    ],
    "etendent": [
        "etendre"
    ],
    "etendez": [
        "etendre"
    ],
    "etendions": [
        "etendre"
    ],
    "etendirent": [
        "etendre"
    ],
    "etendis": [
        "etendre"
    ],
    "etendit": [
        "etendre"
    ],
    "etendoir": [
        "etendoir"
    ],
    "etendons": [
        "etendre"
    ],
    "etendra": [
        "etendre"
    ],
    "etendrai": [
        "etendre"
    ],
    "etendraient": [
        "etendre"
    ],
    "etendrais": [
        "etendre"
    ],
    "etendrait": [
        "etendre"
    ],
    "etendre": [
        "etendre"
    ],
    "etendrez": [
        "etendre"
    ],
    "etendrions": [
        "etendre"
    ],
    "etendrons": [
        "etendre"
    ],
    "etendront": [
        "etendre"
    ],
    "etends": [
        "etendre"
    ],
    "etendu": [
        "etendu",
        "etendre"
    ],
    "etendue": [
        "etendue",
        "etendre"
    ],
    "etendues": [
        "etendue",
        "etendre"
    ],
    "etendus": [
        "etendu",
        "etendre"
    ],
    "etendimes": [
        "etendre"
    ],
    "eternel": [
        "eternel"
    ],
    "eternelle": [
        "eternel"
    ],
    "eternellement": [
        "eternellement"
    ],
    "eternelles": [
        "eternel"
    ],
    "eternels": [
        "eternel"
    ],
    "eternisa": [
        "eterniser"
    ],
    "eternisaient": [
        "eterniser"
    ],
    "eternisais": [
        "eterniser"
    ],
    "eternisait": [
        "eterniser"
    ],
    "eternise": [
        "eterniser"
    ],
    "eternisent": [
        "eterniser"
    ],
    "eterniser": [
        "eterniser"
    ],
    "eterniserai": [
        "eterniser"
    ],
    "eterniserait": [
        "eterniser"
    ],
    "eterniserons": [
        "eterniser"
    ],
    "eternisez": [
        "eterniser"
    ],
    "eternisons": [
        "eterniser"
    ],
    "eternisat": [
        "eterniser"
    ],
    "eternisee": [
        "eterniser"
    ],
    "eternises": [
        "eterniser"
    ],
    "eternite": [
        "eternite"
    ],
    "eternites": [
        "eternite"
    ],
    "eternua": [
        "eternuer"
    ],
    "eternuaient": [
        "eternuer"
    ],
    "eternuais": [
        "eternuer"
    ],
    "eternuait": [
        "eternuer"
    ],
    "eternuant": [
        "eternuer"
    ],
    "eternue": [
        "eternuer"
    ],
    "eternuement": [
        "eternuement"
    ],
    "eternuements": [
        "eternuement"
    ],
    "eternuent": [
        "eternuer"
    ],
    "eternuer": [
        "eternuer"
    ],
    "eternuerait": [
        "eternuer"
    ],
    "eternues": [
        "eternuer"
    ],
    "eternuez": [
        "eternuer"
    ],
    "eteule": [
        "eteule"
    ],
    "eteules": [
        "eteule"
    ],
    "ethane": [
        "ethane"
    ],
    "ethanol": [
        "ethanol"
    ],
    "ether": [
        "ether"
    ],
    "ethers": [
        "ether"
    ],
    "ethiopien": [
        "ethiopien"
    ],
    "ethiopienne": [
        "ethiopien"
    ],
    "ethiopiennes": [
        "ethiopien"
    ],
    "ethiopiens": [
        "ethiopien"
    ],
    "ethique": [
        "ethique"
    ],
    "ethiquement": [
        "ethiquement"
    ],
    "ethiques": [
        "ethique"
    ],
    "ethologie": [
        "ethologie"
    ],
    "ethologue": [
        "ethologue"
    ],
    "ethyle": [
        "ethyle"
    ],
    "ethylique": [
        "ethylique"
    ],
    "ethyliques": [
        "ethylique"
    ],
    "ethylisme": [
        "ethylisme"
    ],
    "ethylotest": [
        "ethylotest"
    ],
    "ethylene": [
        "ethylene"
    ],
    "etherique": [
        "etherique"
    ],
    "ethere": [
        "ethere"
    ],
    "etheree": [
        "ethere"
    ],
    "etherees": [
        "ethere"
    ],
    "etheres": [
        "ethere"
    ],
    "etiage": [
        "etiage"
    ],
    "etier": [
        "etier"
    ],
    "etiers": [
        "etier"
    ],
    "etiez": [
        "etre"
    ],
    "etincela": [
        "etinceler"
    ],
    "etincelaient": [
        "etinceler"
    ],
    "etincelait": [
        "etinceler"
    ],
    "etincelant": [
        "etincelant",
        "etinceler"
    ],
    "etincelante": [
        "etincelant"
    ],
    "etincelantes": [
        "etincelant"
    ],
    "etincelants": [
        "etincelant"
    ],
    "etinceler": [
        "etinceler"
    ],
    "etincelle": [
        "etincelle",
        "etinceler"
    ],
    "etincellement": [
        "etincellement"
    ],
    "etincellements": [
        "etincellement"
    ],
    "etincellent": [
        "etinceler"
    ],
    "etincellera": [
        "etinceler"
    ],
    "etincelles": [
        "etincelle"
    ],
    "etincelerent": [
        "etinceler"
    ],
    "etincele": [
        "etinceler"
    ],
    "etiolaient": [
        "etioler"
    ],
    "etiolais": [
        "etioler"
    ],
    "etiolait": [
        "etioler"
    ],
    "etiolant": [
        "etioler"
    ],
    "etiole": [
        "etioler"
    ],
    "etiolement": [
        "etiolement"
    ],
    "etiolent": [
        "etioler"
    ],
    "etioler": [
        "etioler"
    ],
    "etiologie": [
        "etiologie"
    ],
    "etiologique": [
        "etiologique"
    ],
    "etiologiques": [
        "etiologique"
    ],
    "etiolee": [
        "etioler"
    ],
    "etiolees": [
        "etioler"
    ],
    "etions": [
        "etre"
    ],
    "etique": [
        "etique"
    ],
    "etiques": [
        "etique"
    ],
    "etiquetage": [
        "etiquetage"
    ],
    "etiquetaient": [
        "etiqueter"
    ],
    "etiqueter": [
        "etiqueter"
    ],
    "etiqueteuse": [
        "etiqueteur"
    ],
    "etiquetez": [
        "etiqueter"
    ],
    "etiquette": [
        "etiquette",
        "etiqueter"
    ],
    "etiquettent": [
        "etiqueter"
    ],
    "etiquettes": [
        "etiquette",
        "etiqueter"
    ],
    "etiquete": [
        "etiqueter"
    ],
    "etiquetee": [
        "etiqueter"
    ],
    "etiquetees": [
        "etiqueter"
    ],
    "etiquetes": [
        "etiqueter"
    ],
    "etira": [
        "etirer"
    ],
    "etirable": [
        "etirable"
    ],
    "etirage": [
        "etirage"
    ],
    "etirai": [
        "etirer"
    ],
    "etiraient": [
        "etirer"
    ],
    "etirais": [
        "etirer"
    ],
    "etirait": [
        "etirer"
    ],
    "etirant": [
        "etirer"
    ],
    "etire": [
        "etirer"
    ],
    "etirement": [
        "etirement"
    ],
    "etirements": [
        "etirement"
    ],
    "etirent": [
        "etirer"
    ],
    "etirer": [
        "etirer"
    ],
    "etirerait": [
        "etirer"
    ],
    "etirez": [
        "etirer"
    ],
    "etirerent": [
        "etirer"
    ],
    "etiree": [
        "etirer"
    ],
    "etirees": [
        "etirer"
    ],
    "etires": [
        "etirer"
    ],
    "etisie": [
        "etisie"
    ],
    "etoffaient": [
        "etoffer"
    ],
    "etoffait": [
        "etoffer"
    ],
    "etoffe": [
        "etoffer",
        "etoffe"
    ],
    "etoffer": [
        "etoffer"
    ],
    "etoffes": [
        "etoffer",
        "etoffe"
    ],
    "etoffee": [
        "etoffe",
        "etoffer"
    ],
    "etoffees": [
        "etoffe"
    ],
    "etoila": [
        "etoiler"
    ],
    "etoilaient": [
        "etoiler"
    ],
    "etoilait": [
        "etoiler"
    ],
    "etoile": [
        "etoiler",
        "etoile"
    ],
    "etoilent": [
        "etoiler"
    ],
    "etoiles": [
        "etoiler",
        "etoile"
    ],
    "etoilee": [
        "etoiler",
        "etoile"
    ],
    "etoilees": [
        "etoiler",
        "etoile"
    ],
    "etole": [
        "etole"
    ],
    "etoles": [
        "etole"
    ],
    "etonna": [
        "etonner"
    ],
    "etonnai": [
        "etonner"
    ],
    "etonnaient": [
        "etonner"
    ],
    "etonnais": [
        "etonner"
    ],
    "etonnait": [
        "etonner"
    ],
    "etonnamment": [
        "etonnamment"
    ],
    "etonnant": [
        "etonner",
        "etonnant"
    ],
    "etonnante": [
        "etonnant"
    ],
    "etonnantes": [
        "etonnant"
    ],
    "etonnants": [
        "etonnant"
    ],
    "etonne": [
        "etonne",
        "etonner"
    ],
    "etonnement": [
        "etonnement"
    ],
    "etonnements": [
        "etonnement"
    ],
    "etonnent": [
        "etonner"
    ],
    "etonner": [
        "etonner"
    ],
    "etonnera": [
        "etonner"
    ],
    "etonnerai": [
        "etonner"
    ],
    "etonneraient": [
        "etonner"
    ],
    "etonnerais": [
        "etonner"
    ],
    "etonnerait": [
        "etonner"
    ],
    "etonneras": [
        "etonner"
    ],
    "etonnerez": [
        "etonner"
    ],
    "etonneriez": [
        "etonner"
    ],
    "etonnerons": [
        "etonner"
    ],
    "etonneront": [
        "etonner"
    ],
    "etonnes": [
        "etonne",
        "etonner"
    ],
    "etonnez": [
        "etonner"
    ],
    "etonniez": [
        "etonner"
    ],
    "etonnions": [
        "etonner"
    ],
    "etonnons": [
        "etonner"
    ],
    "etonnames": [
        "etonner"
    ],
    "etonnat": [
        "etonner"
    ],
    "etonnerent": [
        "etonner"
    ],
    "etonnee": [
        "etonne",
        "etonner"
    ],
    "etonnees": [
        "etonne",
        "etonner"
    ],
    "etouffa": [
        "etouffer"
    ],
    "etouffai": [
        "etouffer"
    ],
    "etouffaient": [
        "etouffer"
    ],
    "etouffais": [
        "etouffer"
    ],
    "etouffait": [
        "etouffer"
    ],
    "etouffant": [
        "etouffer",
        "etouffant"
    ],
    "etouffante": [
        "etouffant"
    ],
    "etouffantes": [
        "etouffant"
    ],
    "etouffants": [
        "etouffant"
    ],
    "etouffassent": [
        "etouffer"
    ],
    "etouffe": [
        "etouffer",
        "etouffe"
    ],
    "etouffement": [
        "etouffement"
    ],
    "etouffements": [
        "etouffement"
    ],
    "etouffent": [
        "etouffer"
    ],
    "etouffer": [
        "etouffer"
    ],
    "etouffera": [
        "etouffer"
    ],
    "etoufferai": [
        "etouffer"
    ],
    "etoufferaient": [
        "etouffer"
    ],
    "etoufferais": [
        "etouffer"
    ],
    "etoufferait": [
        "etouffer"
    ],
    "etoufferez": [
        "etouffer"
    ],
    "etoufferiez": [
        "etouffer"
    ],
    "etoufferons": [
        "etouffer"
    ],
    "etoufferont": [
        "etouffer"
    ],
    "etouffes": [
        "etouffer",
        "etouffe"
    ],
    "etouffeur": [
        "etouffeur"
    ],
    "etouffeuses": [
        "etouffeur"
    ],
    "etouffez": [
        "etouffer"
    ],
    "etouffiez": [
        "etouffer"
    ],
    "etouffions": [
        "etouffer"
    ],
    "etouffoir": [
        "etouffoir"
    ],
    "etouffoirs": [
        "etouffoir"
    ],
    "etouffons": [
        "etouffer"
    ],
    "etouffat": [
        "etouffer"
    ],
    "etoufferent": [
        "etouffer"
    ],
    "etouffee": [
        "etouffer",
        "etouffee"
    ],
    "etouffees": [
        "etouffer",
        "etouffee"
    ],
    "etoupe": [
        "etoupe"
    ],
    "etourderie": [
        "etourderie"
    ],
    "etourderies": [
        "etourderie"
    ],
    "etourdi": [
        "etourdi",
        "etourdir"
    ],
    "etourdie": [
        "etourdi",
        "etourdir"
    ],
    "etourdies": [
        "etourdi"
    ],
    "etourdiment": [
        "etourdiment"
    ],
    "etourdir": [
        "etourdir"
    ],
    "etourdira": [
        "etourdir"
    ],
    "etourdirait": [
        "etourdir"
    ],
    "etourdirent": [
        "etourdir"
    ],
    "etourdis": [
        "etourdi",
        "etourdir"
    ],
    "etourdissaient": [
        "etourdir"
    ],
    "etourdissait": [
        "etourdir"
    ],
    "etourdissant": [
        "etourdir",
        "etourdissant"
    ],
    "etourdissante": [
        "etourdissant"
    ],
    "etourdissantes": [
        "etourdissant"
    ],
    "etourdissants": [
        "etourdissant"
    ],
    "etourdissement": [
        "etourdissement"
    ],
    "etourdissements": [
        "etourdissement"
    ],
    "etourdissent": [
        "etourdir"
    ],
    "etourdissez": [
        "etourdir"
    ],
    "etourdissons": [
        "etourdir"
    ],
    "etourdit": [
        "etourdir"
    ],
    "etourneau": [
        "etourneau"
    ],
    "etourneaux": [
        "etourneau"
    ],
    "etrange": [
        "etrange"
    ],
    "etrangement": [
        "etrangement"
    ],
    "etranger": [
        "etranger"
    ],
    "etrangers": [
        "etranger"
    ],
    "etranges": [
        "etrange"
    ],
    "etrangete": [
        "etrangete"
    ],
    "etrangetes": [
        "etrangete"
    ],
    "etrangla": [
        "etrangler"
    ],
    "etranglai": [
        "etrangler"
    ],
    "etranglaient": [
        "etrangler"
    ],
    "etranglais": [
        "etrangler"
    ],
    "etranglait": [
        "etrangler"
    ],
    "etranglant": [
        "etrangler"
    ],
    "etrangle": [
        "etrangler",
        "etrangle"
    ],
    "etranglement": [
        "etranglement"
    ],
    "etranglements": [
        "etranglement"
    ],
    "etranglent": [
        "etrangler"
    ],
    "etrangler": [
        "etrangler"
    ],
    "etranglera": [
        "etrangler"
    ],
    "etranglerai": [
        "etrangler"
    ],
    "etrangleraient": [
        "etrangler"
    ],
    "etranglerais": [
        "etrangler"
    ],
    "etranglerait": [
        "etrangler"
    ],
    "etrangleront": [
        "etrangler"
    ],
    "etrangles": [
        "etrangler",
        "etrangle"
    ],
    "etrangleur": [
        "etrangleur"
    ],
    "etrangleurs": [
        "etrangleur"
    ],
    "etrangleuse": [
        "etrangleur"
    ],
    "etrangleuses": [
        "etrangleur"
    ],
    "etranglez": [
        "etrangler"
    ],
    "etranglat": [
        "etrangler"
    ],
    "etranglee": [
        "etrangler",
        "etrangle"
    ],
    "etranglees": [
        "etrangler",
        "etrangle"
    ],
    "etrangere": [
        "etranger"
    ],
    "etrangeres": [
        "etranger"
    ],
    "etrangeite": [
        "etrangeite"
    ],
    "etrave": [
        "etrave"
    ],
    "etraves": [
        "etrave"
    ],
    "etreignaient": [
        "etreindre"
    ],
    "etreignais": [
        "etreindre"
    ],
    "etreignait": [
        "etreindre"
    ],
    "etreignant": [
        "etreindre"
    ],
    "etreigne": [
        "etreindre"
    ],
    "etreignent": [
        "etreindre"
    ],
    "etreignions": [
        "etreindre"
    ],
    "etreignirent": [
        "etreindre"
    ],
    "etreignit": [
        "etreindre"
    ],
    "etreignons": [
        "etreindre"
    ],
    "etreignimes": [
        "etreindre"
    ],
    "etreindrait": [
        "etreindre"
    ],
    "etreindre": [
        "etreindre"
    ],
    "etreindrons": [
        "etreindre"
    ],
    "etreindront": [
        "etreindre"
    ],
    "etreins": [
        "etreindre"
    ],
    "etreint": [
        "etreindre"
    ],
    "etreinte": [
        "etreindre",
        "etreinte"
    ],
    "etreintes": [
        "etreindre",
        "etreinte"
    ],
    "etreints": [
        "etreindre"
    ],
    "etrenna": [
        "etrenner"
    ],
    "etrennait": [
        "etrenner"
    ],
    "etrennant": [
        "etrenner"
    ],
    "etrenne": [
        "etrenne",
        "etrenner"
    ],
    "etrennent": [
        "etrenner"
    ],
    "etrenner": [
        "etrenner"
    ],
    "etrennera": [
        "etrenner"
    ],
    "etrennerais": [
        "etrenner"
    ],
    "etrennes": [
        "etrenne",
        "etrenner"
    ],
    "etrennee": [
        "etrenner"
    ],
    "etrier": [
        "etrier"
    ],
    "etriers": [
        "etrier"
    ],
    "etrilla": [
        "etriller"
    ],
    "etrillage": [
        "etrillage"
    ],
    "etrillaient": [
        "etriller"
    ],
    "etrillait": [
        "etriller"
    ],
    "etrille": [
        "etrille",
        "etriller"
    ],
    "etriller": [
        "etriller"
    ],
    "etrillerez": [
        "etriller"
    ],
    "etrilles": [
        "etrille",
        "etriller"
    ],
    "etrillee": [
        "etriller"
    ],
    "etripage": [
        "etripage"
    ],
    "etripages": [
        "etripage"
    ],
    "etripaient": [
        "etriper"
    ],
    "etripe": [
        "etriper"
    ],
    "etripent": [
        "etriper"
    ],
    "etriper": [
        "etriper"
    ],
    "etripera": [
        "etriper"
    ],
    "etriperai": [
        "etriper"
    ],
    "etriperaient": [
        "etriper"
    ],
    "etriperais": [
        "etriper"
    ],
    "etriperent": [
        "etriper"
    ],
    "etripee": [
        "etriper"
    ],
    "etripes": [
        "etriper"
    ],
    "etriqua": [
        "etriquer"
    ],
    "etriquaient": [
        "etriquer"
    ],
    "etriquant": [
        "etriquer"
    ],
    "etrique": [
        "etrique",
        "etriquer"
    ],
    "etriquee": [
        "etrique",
        "etriquer"
    ],
    "etriquees": [
        "etrique",
        "etriquer"
    ],
    "etriques": [
        "etrique",
        "etriquer"
    ],
    "etriviere": [
        "etriviere"
    ],
    "etrivieres": [
        "etriviere"
    ],
    "etroit": [
        "etroit"
    ],
    "etroite": [
        "etroit"
    ],
    "etroitement": [
        "etroitement"
    ],
    "etroites": [
        "etroit"
    ],
    "etroitesse": [
        "etroitesse"
    ],
    "etroits": [
        "etroit"
    ],
    "etron": [
        "etron"
    ],
    "etrons": [
        "etron"
    ],
    "etrusque": [
        "etrusque"
    ],
    "etrusques": [
        "etrusque"
    ],
    "etreci": [
        "etrecir"
    ],
    "etrecie": [
        "etrecir"
    ],
    "etrecir": [
        "etrecir"
    ],
    "etrecissement": [
        "etrecissement"
    ],
    "etrecit": [
        "etrecir"
    ],
    "etresillon": [
        "etresillon"
    ],
    "etude": [
        "etude"
    ],
    "etudes": [
        "etude"
    ],
    "etudia": [
        "etudier"
    ],
    "etudiai": [
        "etudier"
    ],
    "etudiaient": [
        "etudier"
    ],
    "etudiais": [
        "etudier"
    ],
    "etudiait": [
        "etudier"
    ],
    "etudiant": [
        "etudiant",
        "etudier"
    ],
    "etudiante": [
        "etudiant"
    ],
    "etudiantes": [
        "etudiant"
    ],
    "etudiants": [
        "etudiant"
    ],
    "etudie": [
        "etudie",
        "etudier"
    ],
    "etudient": [
        "etudier"
    ],
    "etudier": [
        "etudier"
    ],
    "etudiera": [
        "etudier"
    ],
    "etudierai": [
        "etudier"
    ],
    "etudierais": [
        "etudier"
    ],
    "etudierait": [
        "etudier"
    ],
    "etudieras": [
        "etudier"
    ],
    "etudierez": [
        "etudier"
    ],
    "etudierions": [
        "etudier"
    ],
    "etudierons": [
        "etudier"
    ],
    "etudies": [
        "etudie",
        "etudier"
    ],
    "etudiez": [
        "etudier"
    ],
    "etudions": [
        "etudier"
    ],
    "etudierent": [
        "etudier"
    ],
    "etudiee": [
        "etudie",
        "etudier"
    ],
    "etudiees": [
        "etudie",
        "etudier"
    ],
    "etui": [
        "etui"
    ],
    "etuis": [
        "etui"
    ],
    "etuve": [
        "etuver",
        "etuve"
    ],
    "etuver": [
        "etuver"
    ],
    "etuves": [
        "etuve"
    ],
    "etuveuse": [
        "etuveur"
    ],
    "etuvee": [
        "etuvee"
    ],
    "etymologie": [
        "etymologie"
    ],
    "etymologies": [
        "etymologie"
    ],
    "etymologique": [
        "etymologique"
    ],
    "etymologiquement": [
        "etymologiquement"
    ],
    "etymologiques": [
        "etymologique"
    ],
    "etymologiste": [
        "etymologiste"
    ],
    "ete": [
        "etre",
        "ete"
    ],
    "etes": [
        "etre",
        "ete"
    ],
    "eteta": [
        "eteter"
    ],
    "etetait": [
        "eteter"
    ],
    "etete": [
        "eteter"
    ],
    "etetes": [
        "eteter"
    ],
    "evacua": [
        "evacuer"
    ],
    "evacuai": [
        "evacuer"
    ],
    "evacuaient": [
        "evacuer"
    ],
    "evacuais": [
        "evacuer"
    ],
    "evacuait": [
        "evacuer"
    ],
    "evacuant": [
        "evacuer"
    ],
    "evacuation": [
        "evacuation"
    ],
    "evacuations": [
        "evacuation"
    ],
    "evacue": [
        "evacuer",
        "evacue"
    ],
    "evacuent": [
        "evacuer"
    ],
    "evacuer": [
        "evacuer"
    ],
    "evacuera": [
        "evacuer"
    ],
    "evacuerai": [
        "evacuer"
    ],
    "evacueraient": [
        "evacuer"
    ],
    "evacuerais": [
        "evacuer"
    ],
    "evacuerait": [
        "evacuer"
    ],
    "evacuerez": [
        "evacuer"
    ],
    "evacuerions": [
        "evacuer"
    ],
    "evacuerons": [
        "evacuer"
    ],
    "evacueront": [
        "evacuer"
    ],
    "evacuez": [
        "evacuer"
    ],
    "evacuons": [
        "evacuer"
    ],
    "evacuerent": [
        "evacuer"
    ],
    "evacuee": [
        "evacuer",
        "evacue"
    ],
    "evacuees": [
        "evacuer",
        "evacue",
        "evacuee"
    ],
    "evacues": [
        "evacuer",
        "evacue"
    ],
    "evada": [
        "evader"
    ],
    "evadaient": [
        "evader"
    ],
    "evadais": [
        "evader"
    ],
    "evadait": [
        "evader"
    ],
    "evadant": [
        "evader"
    ],
    "evade": [
        "evader",
        "evade"
    ],
    "evadent": [
        "evader"
    ],
    "evader": [
        "evader"
    ],
    "evadera": [
        "evader"
    ],
    "evaderai": [
        "evader"
    ],
    "evaderaient": [
        "evader"
    ],
    "evaderais": [
        "evader"
    ],
    "evaderait": [
        "evader"
    ],
    "evaderas": [
        "evader"
    ],
    "evaderont": [
        "evader"
    ],
    "evades": [
        "evader",
        "evade"
    ],
    "evadez": [
        "evader"
    ],
    "evaderent": [
        "evader"
    ],
    "evadee": [
        "evader",
        "evade"
    ],
    "evadees": [
        "evade"
    ],
    "evalua": [
        "evaluer"
    ],
    "evaluables": [
        "evaluable"
    ],
    "evaluaient": [
        "evaluer"
    ],
    "evaluais": [
        "evaluer"
    ],
    "evaluait": [
        "evaluer"
    ],
    "evaluant": [
        "evaluer"
    ],
    "evaluateur": [
        "evaluateur"
    ],
    "evaluation": [
        "evaluation"
    ],
    "evaluations": [
        "evaluation"
    ],
    "evalue": [
        "evaluer"
    ],
    "evaluent": [
        "evaluer"
    ],
    "evaluer": [
        "evaluer"
    ],
    "evaluerez": [
        "evaluer"
    ],
    "evalueront": [
        "evaluer"
    ],
    "evalues": [
        "evaluer"
    ],
    "evaluez": [
        "evaluer"
    ],
    "evaluons": [
        "evaluer"
    ],
    "evaluat": [
        "evaluer"
    ],
    "evaluerent": [
        "evaluer"
    ],
    "evaluee": [
        "evaluer"
    ],
    "evaluees": [
        "evaluer"
    ],
    "evanescence": [
        "evanescence"
    ],
    "evanescences": [
        "evanescence"
    ],
    "evanescent": [
        "evanescent"
    ],
    "evanescente": [
        "evanescent"
    ],
    "evanescentes": [
        "evanescent"
    ],
    "evanescents": [
        "evanescent"
    ],
    "evangile": [
        "evangile"
    ],
    "evangiles": [
        "evangile"
    ],
    "evangeliaire": [
        "evangeliaire"
    ],
    "evangelique": [
        "evangelique"
    ],
    "evangeliques": [
        "evangelique"
    ],
    "evangelisateur": [
        "evangelisateur"
    ],
    "evangelisation": [
        "evangelisation"
    ],
    "evangelisatrices": [
        "evangelisateur"
    ],
    "evangeliser": [
        "evangeliser"
    ],
    "evangeliseront": [
        "evangeliser"
    ],
    "evangelisons": [
        "evangeliser"
    ],
    "evangeliste": [
        "evangeliste"
    ],
    "evangelistes": [
        "evangeliste"
    ],
    "evangelise": [
        "evangeliser"
    ],
    "evangelises": [
        "evangeliser"
    ],
    "evanoui": [
        "evanoui",
        "evanouir"
    ],
    "evanouie": [
        "evanoui",
        "evanouir"
    ],
    "evanouies": [
        "evanoui",
        "evanouir"
    ],
    "evanouir": [
        "evanouir"
    ],
    "evanouira": [
        "evanouir"
    ],
    "evanouirai": [
        "evanouir"
    ],
    "evanouirait": [
        "evanouir"
    ],
    "evanouirent": [
        "evanouir"
    ],
    "evanouirez": [
        "evanouir"
    ],
    "evanouiront": [
        "evanouir"
    ],
    "evanouis": [
        "evanoui",
        "evanouir"
    ],
    "evanouissaient": [
        "evanouir"
    ],
    "evanouissais": [
        "evanouir"
    ],
    "evanouissait": [
        "evanouir"
    ],
    "evanouissant": [
        "evanouir"
    ],
    "evanouisse": [
        "evanouir"
    ],
    "evanouissement": [
        "evanouissement"
    ],
    "evanouissements": [
        "evanouissement"
    ],
    "evanouissent": [
        "evanouir"
    ],
    "evanouisses": [
        "evanouir"
    ],
    "evanouissez": [
        "evanouir"
    ],
    "evanouit": [
        "evanouir"
    ],
    "evapora": [
        "evaporer"
    ],
    "evaporaient": [
        "evaporer"
    ],
    "evaporais": [
        "evaporer"
    ],
    "evaporait": [
        "evaporer"
    ],
    "evaporateur": [
        "evaporateur"
    ],
    "evaporateurs": [
        "evaporateur"
    ],
    "evaporation": [
        "evaporation"
    ],
    "evapore": [
        "evaporer",
        "evapore"
    ],
    "evaporent": [
        "evaporer"
    ],
    "evaporer": [
        "evaporer"
    ],
    "evaporerait": [
        "evaporer"
    ],
    "evaporeront": [
        "evaporer"
    ],
    "evaporee": [
        "evapore"
    ],
    "evaporees": [
        "evapore",
        "evaporee"
    ],
    "evapores": [
        "evaporer",
        "evapore"
    ],
    "evasaient": [
        "evaser"
    ],
    "evasait": [
        "evaser"
    ],
    "evasant": [
        "evaser"
    ],
    "evase": [
        "evaser",
        "evase"
    ],
    "evasement": [
        "evasement"
    ],
    "evasent": [
        "evaser"
    ],
    "evaser": [
        "evaser"
    ],
    "evasif": [
        "evasif"
    ],
    "evasifs": [
        "evasif"
    ],
    "evasion": [
        "evasion"
    ],
    "evasions": [
        "evasion"
    ],
    "evasive": [
        "evasif"
    ],
    "evasivement": [
        "evasivement"
    ],
    "evasives": [
        "evasif"
    ],
    "evasee": [
        "evaser",
        "evase"
    ],
    "evasees": [
        "evaser",
        "evase"
    ],
    "evases": [
        "evaser",
        "evase"
    ],
    "eveil": [
        "eveil"
    ],
    "eveilla": [
        "eveiller"
    ],
    "eveillai": [
        "eveiller"
    ],
    "eveillaient": [
        "eveiller"
    ],
    "eveillais": [
        "eveiller"
    ],
    "eveillait": [
        "eveiller"
    ],
    "eveillant": [
        "eveiller",
        "eveillant"
    ],
    "eveille": [
        "eveille",
        "eveiller"
    ],
    "eveillent": [
        "eveiller"
    ],
    "eveiller": [
        "eveiller"
    ],
    "eveillera": [
        "eveiller"
    ],
    "eveillerai": [
        "eveiller"
    ],
    "eveilleraient": [
        "eveiller"
    ],
    "eveillerait": [
        "eveiller"
    ],
    "eveilleras": [
        "eveiller"
    ],
    "eveillerez": [
        "eveiller"
    ],
    "eveilleront": [
        "eveiller"
    ],
    "eveilles": [
        "eveille",
        "eveiller"
    ],
    "eveilleur": [
        "eveilleur"
    ],
    "eveillez": [
        "eveiller"
    ],
    "eveillions": [
        "eveiller"
    ],
    "eveillons": [
        "eveiller"
    ],
    "eveillat": [
        "eveiller"
    ],
    "eveillerent": [
        "eveiller"
    ],
    "eveillee": [
        "eveille",
        "eveiller"
    ],
    "eveillees": [
        "eveille",
        "eveiller"
    ],
    "eveils": [
        "eveil"
    ],
    "eveinage": [
        "eveinage"
    ],
    "eventa": [
        "eventer"
    ],
    "eventai": [
        "eventer"
    ],
    "eventaient": [
        "eventer"
    ],
    "eventail": [
        "eventail"
    ],
    "eventails": [
        "eventail"
    ],
    "eventaire": [
        "eventaire"
    ],
    "eventaires": [
        "eventaire"
    ],
    "eventait": [
        "eventer"
    ],
    "eventant": [
        "eventer"
    ],
    "evente": [
        "eventer",
        "evente"
    ],
    "eventent": [
        "eventer"
    ],
    "eventer": [
        "eventer"
    ],
    "eventerai": [
        "eventer"
    ],
    "eventez": [
        "eventer"
    ],
    "eventons": [
        "eventer"
    ],
    "eventra": [
        "eventrer"
    ],
    "eventraient": [
        "eventrer"
    ],
    "eventrait": [
        "eventrer"
    ],
    "eventrant": [
        "eventrer"
    ],
    "eventration": [
        "eventration"
    ],
    "eventre": [
        "eventrer",
        "eventre"
    ],
    "eventrement": [
        "eventrement"
    ],
    "eventrent": [
        "eventrer"
    ],
    "eventrer": [
        "eventrer"
    ],
    "eventrerai": [
        "eventrer"
    ],
    "eventrerait": [
        "eventrer"
    ],
    "eventrerez": [
        "eventrer"
    ],
    "eventres": [
        "eventrer",
        "eventre"
    ],
    "eventreur": [
        "eventreur"
    ],
    "eventreurs": [
        "eventreur"
    ],
    "eventrez": [
        "eventrer"
    ],
    "eventrions": [
        "eventrer"
    ],
    "eventrat": [
        "eventrer"
    ],
    "eventree": [
        "eventrer",
        "eventre"
    ],
    "eventrees": [
        "eventrer",
        "eventre"
    ],
    "events": [
        "event"
    ],
    "eventualite": [
        "eventualite"
    ],
    "eventualites": [
        "eventualite"
    ],
    "eventuel": [
        "eventuel"
    ],
    "eventuelle": [
        "eventuel"
    ],
    "eventuellement": [
        "eventuellement"
    ],
    "eventuelles": [
        "eventuel"
    ],
    "eventuels": [
        "eventuel"
    ],
    "eventee": [
        "eventer",
        "evente"
    ],
    "eventees": [
        "eventer",
        "evente"
    ],
    "eventes": [
        "eventer",
        "evente"
    ],
    "evergete": [
        "evergete"
    ],
    "everse": [
        "everse"
    ],
    "eversees": [
        "everse"
    ],
    "evertua": [
        "evertuer"
    ],
    "evertuaient": [
        "evertuer"
    ],
    "evertuais": [
        "evertuer"
    ],
    "evertuait": [
        "evertuer"
    ],
    "evertuant": [
        "evertuer"
    ],
    "evertue": [
        "evertuer"
    ],
    "evertuent": [
        "evertuer"
    ],
    "evertuer": [
        "evertuer"
    ],
    "eviction": [
        "eviction"
    ],
    "evida": [
        "evider"
    ],
    "evidaient": [
        "evider"
    ],
    "evide": [
        "evider",
        "evide"
    ],
    "evidement": [
        "evidement"
    ],
    "evidemment": [
        "evidemment"
    ],
    "evidence": [
        "evidence"
    ],
    "evidences": [
        "evidence"
    ],
    "evident": [
        "evident",
        "evider"
    ],
    "evidente": [
        "evident"
    ],
    "evidentes": [
        "evident"
    ],
    "evidents": [
        "evident"
    ],
    "evider": [
        "evider"
    ],
    "evidee": [
        "evider",
        "evide"
    ],
    "evidees": [
        "evider"
    ],
    "evides": [
        "evider"
    ],
    "evier": [
        "evier"
    ],
    "eviers": [
        "evier"
    ],
    "evince": [
        "evincer"
    ],
    "evincer": [
        "evincer"
    ],
    "evincerait": [
        "evincer"
    ],
    "evincez": [
        "evincer"
    ],
    "evincee": [
        "evincer"
    ],
    "evinces": [
        "evincer"
    ],
    "evincai": [
        "evincer"
    ],
    "evincant": [
        "evincer"
    ],
    "eviscere": [
        "eviscerer"
    ],
    "eviscerent": [
        "eviscerer"
    ],
    "eviscerant": [
        "eviscerer"
    ],
    "evisceration": [
        "evisceration"
    ],
    "eviscerer": [
        "eviscerer"
    ],
    "evisceree": [
        "eviscerer"
    ],
    "evisceres": [
        "eviscerer"
    ],
    "evita": [
        "eviter"
    ],
    "evitable": [
        "evitable"
    ],
    "evitables": [
        "evitable"
    ],
    "evitai": [
        "eviter"
    ],
    "evitaient": [
        "eviter"
    ],
    "evitais": [
        "eviter"
    ],
    "evitait": [
        "eviter"
    ],
    "evitant": [
        "eviter"
    ],
    "evite": [
        "eviter"
    ],
    "evitement": [
        "evitement"
    ],
    "evitent": [
        "eviter"
    ],
    "eviter": [
        "eviter"
    ],
    "evitera": [
        "eviter"
    ],
    "eviterai": [
        "eviter"
    ],
    "eviteraient": [
        "eviter"
    ],
    "eviterais": [
        "eviter"
    ],
    "eviterait": [
        "eviter"
    ],
    "eviteras": [
        "eviter"
    ],
    "eviterez": [
        "eviter"
    ],
    "eviteriez": [
        "eviter"
    ],
    "eviterons": [
        "eviter"
    ],
    "eviteront": [
        "eviter"
    ],
    "evites": [
        "eviter"
    ],
    "evitez": [
        "eviter"
    ],
    "evitiez": [
        "eviter"
    ],
    "evitions": [
        "eviter"
    ],
    "evitons": [
        "eviter"
    ],
    "evitames": [
        "eviter"
    ],
    "evitat": [
        "eviter"
    ],
    "eviterent": [
        "eviter"
    ],
    "evitee": [
        "eviter",
        "evitee"
    ],
    "evitees": [
        "eviter"
    ],
    "evocateur": [
        "evocateur"
    ],
    "evocateurs": [
        "evocateur"
    ],
    "evocation": [
        "evocation"
    ],
    "evocations": [
        "evocation"
    ],
    "evocatrice": [
        "evocateur"
    ],
    "evocatrices": [
        "evocateur"
    ],
    "evolua": [
        "evoluer"
    ],
    "evoluaient": [
        "evoluer"
    ],
    "evoluais": [
        "evoluer"
    ],
    "evoluait": [
        "evoluer"
    ],
    "evoluant": [
        "evoluer"
    ],
    "evolue": [
        "evoluer",
        "evolue"
    ],
    "evoluent": [
        "evoluer"
    ],
    "evoluer": [
        "evoluer"
    ],
    "evoluera": [
        "evoluer"
    ],
    "evoluerait": [
        "evoluer"
    ],
    "evolueront": [
        "evoluer"
    ],
    "evoluez": [
        "evoluer"
    ],
    "evoluons": [
        "evoluer"
    ],
    "evolutif": [
        "evolutif"
    ],
    "evolution": [
        "evolution"
    ],
    "evolutionniste": [
        "evolutionniste"
    ],
    "evolutions": [
        "evolution"
    ],
    "evolutive": [
        "evolutif"
    ],
    "evolutives": [
        "evolutif"
    ],
    "evoluerent": [
        "evoluer"
    ],
    "evoluee": [
        "evoluer",
        "evolue"
    ],
    "evoluees": [
        "evoluer",
        "evolue"
    ],
    "evolues": [
        "evoluer",
        "evolue"
    ],
    "evoqua": [
        "evoquer"
    ],
    "evoquai": [
        "evoquer"
    ],
    "evoquaient": [
        "evoquer"
    ],
    "evoquais": [
        "evoquer"
    ],
    "evoquait": [
        "evoquer"
    ],
    "evoquant": [
        "evoquer"
    ],
    "evoque": [
        "evoquer"
    ],
    "evoquent": [
        "evoquer"
    ],
    "evoquer": [
        "evoquer"
    ],
    "evoquera": [
        "evoquer"
    ],
    "evoquerai": [
        "evoquer"
    ],
    "evoqueraient": [
        "evoquer"
    ],
    "evoquerait": [
        "evoquer"
    ],
    "evoquerez": [
        "evoquer"
    ],
    "evoquerons": [
        "evoquer"
    ],
    "evoqueront": [
        "evoquer"
    ],
    "evoques": [
        "evoquer"
    ],
    "evoquez": [
        "evoquer"
    ],
    "evoquiez": [
        "evoquer"
    ],
    "evoquions": [
        "evoquer"
    ],
    "evoquons": [
        "evoquer"
    ],
    "evoquames": [
        "evoquer"
    ],
    "evoquat": [
        "evoquer"
    ],
    "evoquerent": [
        "evoquer"
    ],
    "evoquee": [
        "evoquer"
    ],
    "evoquees": [
        "evoquer"
    ],
    "evenement": [
        "evenement"
    ],
    "evenementielle": [
        "evenementiel"
    ],
    "evenements": [
        "evenement"
    ],
    "evenementiel": [
        "evenementiel"
    ],
    "eveche": [
        "eveche"
    ],
    "eveches": [
        "eveche"
    ],
    "eveque": [
        "eveque"
    ],
    "eveques": [
        "eveque"
    ],
    "ewe": [
        "ewe"
    ],
    "ewes": [
        "ewe"
    ],
    "etre": [
        "etre"
    ],
    "etres": [
        "etre"
    ],
    "ile": [
        "ile"
    ],
    "ilette": [
        "ilette"
    ],
    "ilot": [
        "ilot"
    ],
    "ilotier": [
        "ilotier"
    ],
    "ilots": [
        "ilot"
    ],
    "ota": [
        "oter"
    ],
    "otai": [
        "oter"
    ],
    "otaient": [
        "oter"
    ],
    "otais": [
        "oter"
    ],
    "otait": [
        "oter"
    ],
    "otant": [
        "oter"
    ],
    "ote": [
        "ote",
        "oter"
    ],
    "otent": [
        "oter"
    ],
    "oter": [
        "oter"
    ],
    "otera": [
        "oter"
    ],
    "oterai": [
        "oter"
    ],
    "oterais": [
        "oter"
    ],
    "oterait": [
        "oter"
    ],
    "oteras": [
        "oter"
    ],
    "oterez": [
        "oter"
    ],
    "oterions": [
        "oter"
    ],
    "otes": [
        "ote",
        "oter"
    ],
    "otez": [
        "oter"
    ],
    "otiez": [
        "oter"
    ],
    "otons": [
        "oter"
    ],
    "otat": [
        "oter"
    ],
    "oterent": [
        "oter"
    ],
    "otee": [
        "ote",
        "oter"
    ],
    "otees": [
        "ote",
        "oter"
    ],
    "is": [
        "be",
    ],
    "was": [
        "be"
    ],
    "were": [
        "be"
    ],
    "'s": [
        "be",
        "have"
    ],
    "been": [
        "be"
    ],
    "being": [
        "be"
    ],
    "'re": [
        "be"
    ],
    "'m": [
        "be"
    ],
    "am": [
        "be"
    ],
    "had": [
        "have"
    ],
    "has": [
        "have"
    ],
    "'ve": [
        "have"
    ],
    "having": [
        "have"
    ],
    "'d": [
        "would",
        "have"
    ],
    "ve": [
        "have"
    ],
    "its": [
        "it"
    ],
    "they": [
        "it",
        "he"
    ],
    "his": [
        "he"
    ],
    "him": [
        "he"
    ],
    "my": [
        "i"
    ],
    "we": [
        "i"
    ],
    "their": [
        "they"
    ],
    "them": [
        "they"
    ],
    "'em": [
        "they"
    ],
    "your": [
        "you"
    ],
    "ye": [
        "you",
        "thou"
    ],
    "n't": [
        "not"
    ],
    "her": [
        "she"
    ],
    "did": [
        "do"
    ],
    "does": [
        "doe",
        "do"
    ],
    "done": [
        "do"
    ],
    "doing": [
        "do"
    ],
    "our": [
        "we"
    ],
    "'ll": [
        "will"
    ],
    "wo": [
        "will"
    ],
    "ll": [
        "will"
    ],
    "said": [
        "say"
    ],
    "says": [
        "say"
    ],
    "saying": [
        "say"
    ],
    "cans": [
        "can"
    ],
    "can": [
        "can"
    ],
    "could": [
        "can"
    ],
    "going": [
        "go"
    ],
    "went": [
        "go"
    ],
    "goes": [
        "go"
    ],
    "goin'": [
        "go"
    ],
    "got": [
        "get"
    ],
    "getting": [
        "get"
    ],
    "gets": [
        "get"
    ],
    "gotten": [
        "get"
    ],
    "made": [
        "make"
    ],
    "making": [
        "make"
    ],
    "makes": [
        "make"
    ],
    "ups": [
        "up"
    ],
    "upping": [
        "up"
    ],
    "upped": [
        "up"
    ],
    "seen": [
        "see"
    ],
    "saw": [
        "see"
    ],
    "seeing": [
        "see"
    ],
    "sees": [
        "see"
    ],
    "others": [
        "other"
    ],
    "times": [
        "time"
    ],
    "timed": [
        "time"
    ],
    "knew": [
        "know"
    ],
    "known": [
        "know"
    ],
    "knows": [
        "know"
    ],
    "knowing": [
        "know"
    ],
    "took": [
        "take"
    ],
    "taken": [
        "take"
    ],
    "taking": [
        "take"
    ],
    "takes": [
        "take"
    ],
    "years": [
        "year"
    ],
    "better": [
        "good",
        "well"
    ],
    "wells": [
        "well"
    ],
    "welling": [
        "well"
    ],
    "welled": [
        "well"
    ],
    "liked": [
        "like"
    ],
    "likes": [
        "like"
    ],
    "liking": [
        "like"
    ],
    "thens": [
        "then"
    ],
    "thought": [
        "think"
    ],
    "thinking": [
        "think"
    ],
    "thinks": [
        "think"
    ],
    "coming": [
        "come"
    ],
    "comes": [
        "come"
    ],
    "nows": [
        "now"
    ],
    "used": [
        "use"
    ],
    "using": [
        "use"
    ],
    "overs": [
        "over"
    ],
    "goods": [
        "good"
    ],
    "working": [
        "work"
    ],
    "worked": [
        "work"
    ],
    "works": [
        "work"
    ],
    "wrought": [
        "work"
    ],
    "given": [
        "give"
    ],
    "giving": [
        "give"
    ],
    "gives": [
        "give"
    ],
    "newer": [
        "new"
    ],
    "newest": [
        "new"
    ],
    "peoples": [
        "people"
    ],
    "peopling": [
        "people"
    ],
    "peopled": [
        "people"
    ],
    "looked": [
        "look"
    ],
    "looking": [
        "look"
    ],
    "ones": [
        "one"
    ],
    "ways": [
        "way"
    ],
    "rights": [
        "right"
    ],
    "righting": [
        "right"
    ],
    "righted": [
        "right"
    ],
    "backed": [
        "back"
    ],
    "backs": [
        "back"
    ],
    "backing": [
        "back"
    ],
    "men": [
        "man"
    ],
    "manned": [
        "man"
    ],
    "mans": [
        "man"
    ],
    "manning": [
        "man"
    ],
    "found": [
        "find"
    ],
    "finding": [
        "find"
    ],
    "finds": [
        "find"
    ],
    "downs": [
        "down"
    ],
    "downing": [
        "down"
    ],
    "downed": [
        "down"
    ],
    "days": [
        "day"
    ],
    "needs": [
        "need"
    ],
    "needed": [
        "need"
    ],
    "needing": [
        "need"
    ],
    "muches": [
        "much"
    ],
    "wanted": [
        "want"
    ],
    "wants": [
        "want"
    ],
    "wanting": [
        "want"
    ],
    "lasted": [
        "last"
    ],
    "lasts": [
        "last"
    ],
    "lasting": [
        "last"
    ],
    "things": [
        "thing"
    ],
    "owned": [
        "own"
    ],
    "owns": [
        "own"
    ],
    "owning": [
        "own"
    ],
    "told": [
        "tell"
    ],
    "telling": [
        "tell"
    ],
    "tells": [
        "tell"
    ],
    "stills": [
        "still"
    ],
    "stilling": [
        "still"
    ],
    "stilled": [
        "still"
    ],
    "stiller": [
        "still"
    ],
    "stillest": [
        "still"
    ],
    "musts": [
        "must"
    ],
    "children": [
        "child"
    ],
    "shown": [
        "show"
    ],
    "showed": [
        "show"
    ],
    "showing": [
        "show"
    ],
    "means": [
        "mean"
    ],
    "meant": [
        "mean"
    ],
    "meaning": [
        "mean"
    ],
    "puts": [
        "put"
    ],
    "placed": [
        "place"
    ],
    "placing": [
        "place"
    ],
    "ohs": [
        "oh"
    ],
    "governments": [
        "government"
    ],
    "became": [
        "become"
    ],
    "becomes": [
        "become"
    ],
    "becoming": [
        "become"
    ],
    "parted": [
        "part"
    ],
    "parting": [
        "part"
    ],
    "greater": [
        "great"
    ],
    "greatest": [
        "great"
    ],
    "greats": [
        "great"
    ],
    "changed": [
        "change"
    ],
    "changing": [
        "change"
    ],
    "left": [
        "leave"
    ],
    "leaving": [
        "leave"
    ],
    "leaves": [
        "leave",
        "leaf"
    ],
    "older": [
        "old"
    ],
    "oldest": [
        "old"
    ],
    "olds": [
        "old"
    ],
    "casing": [
        "case"
    ],
    "cased": [
        "case"
    ],
    "lives": [
        "live",
        "life"
    ],
    "littles": [
        "little"
    ],
    "houses": [
        "house"
    ],
    "housing": [
        "house"
    ],
    "housed": [
        "house"
    ],
    "systems": [
        "system"
    ],
    "further": [
        "far"
    ],
    "furthest": [
        "far"
    ],
    "farther": [
        "far"
    ],
    "farthest": [
        "far"
    ],
    "pointed": [
        "point"
    ],
    "pointing": [
        "point"
    ],
    "longest": [
        "long"
    ],
    "longed": [
        "long"
    ],
    "longing": [
        "long"
    ],
    "sames": [
        "same"
    ],
    "grouped": [
        "group"
    ],
    "grouping": [
        "group"
    ],
    "ended": [
        "end"
    ],
    "ends": [
        "end"
    ],
    "ending": [
        "end"
    ],
    "called": [
        "call"
    ],
    "calls": [
        "call"
    ],
    "calling": [
        "call"
    ],
    "numbers": [
        "number"
    ],
    "numbered": [
        "number"
    ],
    "numbering": [
        "number"
    ],
    "women": [
        "woman"
    ],
    "felt": [
        "felt",
        "feel"
    ],
    "feels": [
        "felt",
        "feel"
    ],
    "seemed": [
        "seem"
    ],
    "seems": [
        "seem"
    ],
    "seeming": [
        "seem"
    ],
    "mights": [
        "might"
    ],
    "higher": [
        "high"
    ],
    "highest": [
        "high"
    ],
    "highs": [
        "high"
    ],
    "worlds": [
        "world"
    ],
    "areas": [
        "area"
    ],
    "asked": [
        "ask"
    ],
    "asking": [
        "ask"
    ],
    "asks": [
        "ask"
    ],
    "companies": [
        "company"
    ],
    "coursing": [
        "course"
    ],
    "coursed": [
        "course"
    ],
    "homing": [
        "home"
    ],
    "homed": [
        "home"
    ],
    "problems": [
        "problem"
    ],
    "servicing": [
        "service"
    ],
    "serviced": [
        "service"
    ],
    "hands": [
        "hand"
    ],
    "handed": [
        "hand"
    ],
    "handing": [
        "hand"
    ],
    "trying": [
        "try"
    ],
    "tried": [
        "try"
    ],
    "forms": [
        "form"
    ],
    "formed": [
        "form"
    ],
    "forming": [
        "form"
    ],
    "states": [
        "state"
    ],
    "stated": [
        "state"
    ],
    "stating": [
        "state"
    ],
    "setting": [
        "set"
    ],
    "schools": [
        "school"
    ],
    "schooling": [
        "school"
    ],
    "schooled": [
        "school"
    ],
    "turned": [
        "turn"
    ],
    "turning": [
        "turn"
    ],
    "turns": [
        "turn"
    ],
    "earlier": [
        "early"
    ],
    "earliest": [
        "early"
    ],
    "provided": [
        "provide"
    ],
    "provides": [
        "provide"
    ],
    "providing": [
        "provide"
    ],
    "smaller": [
        "small"
    ],
    "smallest": [
        "small"
    ],
    "smalls": [
        "small"
    ],
    "helped": [
        "help"
    ],
    "helping": [
        "help"
    ],
    "helps": [
        "help"
    ],
    "held": [
        "hold"
    ],
    "holds": [
        "hold"
    ],
    "kept": [
        "keep"
    ],
    "keeping": [
        "keep"
    ],
    "keeps": [
        "keep"
    ],
    "started": [
        "start"
    ],
    "starting": [
        "start"
    ],
    "starts": [
        "start"
    ],
    "larger": [
        "large"
    ],
    "largest": [
        "large"
    ],
    "reported": [
        "report"
    ],
    "reporting": [
        "report"
    ],
    "members": [
        "member"
    ],
    "locals": [
        "local"
    ],
    "weeks": [
        "week"
    ],
    "moved": [
        "move"
    ],
    "moving": [
        "move"
    ],
    "moves": [
        "move"
    ],
    "heads": [
        "head"
    ],
    "headed": [
        "head"
    ],
    "heading": [
        "head"
    ],
    "played": [
        "play"
    ],
    "playing": [
        "play"
    ],
    "plays": [
        "play"
    ],
    "seconded": [
        "second"
    ],
    "seconding": [
        "second"
    ],
    "faced": [
        "face"
    ],
    "facing": [
        "face"
    ],
    "runs": [
        "run"
    ],
    "orders": [
        "order"
    ],
    "ordered": [
        "order"
    ],
    "ordering": [
        "order"
    ],
    "opened": [
        "open"
    ],
    "opening": [
        "open"
    ],
    "opens": [
        "open"
    ],
    "examples": [
        "example"
    ],
    "brought": [
        "bring"
    ],
    "bringing": [
        "bring"
    ],
    "brings": [
        "bring"
    ],
    "words": [
        "word"
    ],
    "worded": [
        "word"
    ],
    "wording": [
        "word"
    ],
    "questioned": [
        "question"
    ],
    "questioning": [
        "question"
    ],
    "families": [
        "family"
    ],
    "began": [
        "begin"
    ],
    "beginning": [
        "begin"
    ],
    "begun": [
        "begin"
    ],
    "begins": [
        "begin"
    ],
    "results": [
        "result"
    ],
    "resulted": [
        "result"
    ],
    "resulting": [
        "result"
    ],
    "facts": [
        "fact"
    ],
    "followed": [
        "follow"
    ],
    "following": [
        "follow"
    ],
    "follows": [
        "follow"
    ],
    "paid": [
        "pay"
    ],
    "paying": [
        "pay"
    ],
    "studies": [
        "study"
    ],
    "studied": [
        "study"
    ],
    "studying": [
        "study"
    ],
    "terms": [
        "term"
    ],
    "termed": [
        "term"
    ],
    "terming": [
        "term"
    ],
    "supported": [
        "support"
    ],
    "supporting": [
        "support"
    ],
    "months": [
        "month"
    ],
    "written": [
        "write"
    ],
    "wrote": [
        "write"
    ],
    "writing": [
        "write"
    ],
    "writes": [
        "write"
    ],
    "talking": [
        "talk"
    ],
    "talks": [
        "talk"
    ],
    "talked": [
        "talk"
    ],
    "talkin'": [
        "talk"
    ],
    "levels": [
        "level"
    ],
    "levelled": [
        "level"
    ],
    "levelling": [
        "level"
    ],
    "businesses": [
        "business"
    ],
    "powers": [
        "power"
    ],
    "powered": [
        "power"
    ],
    "powering": [
        "power"
    ],
    "booked": [
        "book"
    ],
    "booking": [
        "book"
    ],
    "sides": [
        "side"
    ],
    "sided": [
        "side"
    ],
    "siding": [
        "side"
    ],
    "younger": [
        "young"
    ],
    "youngest": [
        "young"
    ],
    "generals": [
        "general"
    ],
    "led": [
        "lead"
    ],
    "leading": [
        "lead"
    ],
    "leads": [
        "lead"
    ],
    "nationals": [
        "national"
    ],
    "controls": [
        "control"
    ],
    "controlled": [
        "control"
    ],
    "controlling": [
        "control"
    ],
    "acts": [
        "act"
    ],
    "acting": [
        "act"
    ],
    "acted": [
        "act"
    ],
    "interests": [
        "interest"
    ],
    "interested": [
        "interest"
    ],
    "interesting": [
        "interest"
    ],
    "nights": [
        "night"
    ],
    "names": [
        "name"
    ],
    "named": [
        "name"
    ],
    "naming": [
        "name"
    ],
    "developments": [
        "development"
    ],
    "eyes": [
        "eye"
    ],
    "eyed": [
        "eye"
    ],
    "eyeing": [
        "eye"
    ],
    "watering": [
        "water"
    ],
    "watered": [
        "water"
    ],
    "moneys": [
        "money"
    ],
    "monies": [
        "mony",
        "money"
    ],
    "costs": [
        "cost"
    ],
    "costing": [
        "cost"
    ],
    "costed": [
        "cost"
    ],
    "presented": [
        "present"
    ],
    "presenting": [
        "present"
    ],
    "markets": [
        "market"
    ],
    "marketed": [
        "market"
    ],
    "offered": [
        "offer"
    ],
    "offers": [
        "offer"
    ],
    "offering": [
        "offer"
    ],
    "britishes": [
        "british"
    ],
    "forced": [
        "force"
    ],
    "planned": [
        "plan"
    ],
    "lines": [
        "line"
    ],
    "lined": [
        "line"
    ],
    "lining": [
        "line"
    ],
    "included": [
        "include"
    ],
    "includes": [
        "include"
    ],
    "including": [
        "include"
    ],
    "lived": [
        "live"
    ],
    "views": [
        "view"
    ],
    "viewed": [
        "view"
    ],
    "viewing": [
        "view"
    ],
    "heard": [
        "hear"
    ],
    "hearing": [
        "hear"
    ],
    "hears": [
        "hear"
    ],
    "councils": [
        "council"
    ],
    "policies": [
        "policy"
    ],
    "issued": [
        "issue"
    ],
    "issuing": [
        "issue"
    ],
    "londons": [
        "london"
    ],
    "effects": [
        "effect"
    ],
    "effected": [
        "effect"
    ],
    "effecting": [
        "effect"
    ],
    "courting": [
        "court"
    ],
    "courted": [
        "court"
    ],
    "rooms": [
        "room"
    ],
    "rooming": [
        "room"
    ],
    "roomed": [
        "room"
    ],
    "believed": [
        "believe"
    ],
    "believes": [
        "believe"
    ],
    "believing": [
        "believe"
    ],
    "later": [
        "late"
    ],
    "latest": [
        "late"
    ],
    "stood": [
        "stand"
    ],
    "biggest": [
        "big"
    ],
    "bigger": [
        "big"
    ],
    "meets": [
        "meet"
    ],
    "rounded": [
        "round"
    ],
    "rounding": [
        "round"
    ],
    "rounder": [
        "round"
    ],
    "roundest": [
        "round"
    ],
    "returned": [
        "return"
    ],
    "returning": [
        "return"
    ],
    "returns": [
        "return"
    ],
    "closed": [
        "close"
    ],
    "closer": [
        "close"
    ],
    "closing": [
        "close"
    ],
    "closest": [
        "close"
    ],
    "ideas": [
        "idea"
    ],
    "subjects": [
        "subject"
    ],
    "subjected": [
        "subject"
    ],
    "subjecting": [
        "subject"
    ],
    "allowed": [
        "allow"
    ],
    "allowing": [
        "allow"
    ],
    "allows": [
        "allow"
    ],
    "sorted": [
        "sort"
    ],
    "sorting": [
        "sort"
    ],
    "bodies": [
        "body"
    ],
    "laws": [
        "law"
    ],
    "rated": [
        "rate"
    ],
    "rating": [
        "rate"
    ],
    "enoughs": [
        "enough"
    ],
    "fell": [
        "fall"
    ],
    "falling": [
        "fall"
    ],
    "fallen": [
        "fall"
    ],
    "falls": [
        "fall"
    ],
    "authorities": [
        "authority"
    ],
    "happened": [
        "happen"
    ],
    "happens": [
        "happen"
    ],
    "matters": [
        "matter"
    ],
    "mattered": [
        "matter"
    ],
    "mattering": [
        "matter"
    ],
    "friends": [
        "friend"
    ],
    "increased": [
        "increase"
    ],
    "increases": [
        "increase"
    ],
    "increasing": [
        "increase"
    ],
    "ministers": [
        "minister"
    ],
    "ministering": [
        "minister"
    ],
    "ministered": [
        "minister"
    ],
    "produced": [
        "produce"
    ],
    "producing": [
        "produce"
    ],
    "produces": [
        "produce"
    ],
    "carried": [
        "carry"
    ],
    "carrying": [
        "carry"
    ],
    "carries": [
        "carry"
    ],
    "minds": [
        "mind"
    ],
    "minded": [
        "mind"
    ],
    "minding": [
        "mind"
    ],
    "roads": [
        "road"
    ],
    "leasts": [
        "least"
    ],
    "claims": [
        "claim"
    ],
    "claimed": [
        "claim"
    ],
    "claiming": [
        "claim"
    ],
    "wholes": [
        "whole"
    ],
    "lights": [
        "light"
    ],
    "lighter": [
        "light"
    ],
    "lighting": [
        "light"
    ],
    "lightest": [
        "light"
    ],
    "lighted": [
        "light"
    ],
    "appeared": [
        "appear"
    ],
    "appears": [
        "appear"
    ],
    "appearing": [
        "appear"
    ],
    "caused": [
        "cause"
    ],
    "causing": [
        "cause"
    ],
    "halves": [
        "half",
        "halve"
    ],
    "lower": [
        "low"
    ],
    "lowest": [
        "low"
    ],
    "lows": [
        "low"
    ],
    "lowing": [
        "low"
    ],
    "lowed": [
        "low"
    ],
    "prices": [
        "price"
    ],
    "priced": [
        "price"
    ],
    "pricing": [
        "price"
    ],
    "centred": [
        "centre"
    ],
    "centring": [
        "centre"
    ],
    "hoped": [
        "hope"
    ],
    "hopes": [
        "hope"
    ],
    "hoping": [
        "hope"
    ],
    "recorded": [
        "record"
    ],
    "recording": [
        "record"
    ],
    "cleared": [
        "clear"
    ],
    "clearer": [
        "clear"
    ],
    "clearest": [
        "clear"
    ],
    "clears": [
        "clear"
    ],
    "reasons": [
        "reason"
    ],
    "reasoned": [
        "reason"
    ],
    "reasoning": [
        "reason"
    ],
    "hours": [
        "hour"
    ],
    "processes": [
        "process"
    ],
    "processed": [
        "process"
    ],
    "processing": [
        "process"
    ],
    "wars": [
        "war"
    ],
    "warring": [
        "war"
    ],
    "warred": [
        "war"
    ],
    "fuller": [
        "full"
    ],
    "fullest": [
        "full"
    ],
    "figured": [
        "figure"
    ],
    "figuring": [
        "figure"
    ],
    "majoring": [
        "major"
    ],
    "majored": [
        "major"
    ],
    "experienced": [
        "experience"
    ],
    "experiencing": [
        "experience"
    ],
    "considered": [
        "consider"
    ],
    "considering": [
        "consider"
    ],
    "considers": [
        "consider"
    ],
    "persons": [
        "person"
    ],
    "kinds": [
        "kind"
    ],
    "kinder": [
        "kind"
    ],
    "kindest": [
        "kind"
    ],
    "loved": [
        "love"
    ],
    "loving": [
        "love"
    ],
    "suggested": [
        "suggest"
    ],
    "suggests": [
        "suggest"
    ],
    "suggesting": [
        "suggest"
    ],
    "required": [
        "require"
    ],
    "requires": [
        "require"
    ],
    "requiring": [
        "require"
    ],
    "letting": [
        "let"
    ],
    "lets": [
        "let"
    ],
    "periods": [
        "period"
    ],
    "expected": [
        "expect"
    ],
    "expecting": [
        "expect"
    ],
    "expects": [
        "expect"
    ],
    "dealing": [
        "deal"
    ],
    "dealt": [
        "deal"
    ],
    "sat": [
        "sit"
    ],
    "sitting": [
        "sit"
    ],
    "sits": [
        "sit"
    ],
    "societies": [
        "society"
    ],
    "doors": [
        "door"
    ],
    "based": [
        "base"
    ],
    "basing": [
        "base"
    ],
    "basest": [
        "base"
    ],
    "mothers": [
        "mother"
    ],
    "mothering": [
        "mother"
    ],
    "mothered": [
        "mother"
    ],
    "continued": [
        "continue"
    ],
    "continuing": [
        "continue"
    ],
    "anythings": [
        "anything"
    ],
    "positioned": [
        "position"
    ],
    "positioning": [
        "position"
    ],
    "researching": [
        "research"
    ],
    "researched": [
        "research"
    ],
    "researches": [
        "research"
    ],
    "labouring": [
        "labour"
    ],
    "laboured": [
        "labour"
    ],
    "topped": [
        "top"
    ],
    "topping": [
        "top"
    ],
    "policing": [
        "police"
    ],
    "policed": [
        "police"
    ],
    "shares": [
        "share"
    ],
    "shared": [
        "share"
    ],
    "sharing": [
        "share"
    ],
    "cities": [
        "city"
    ],
    "cared": [
        "care"
    ],
    "caring": [
        "care"
    ],
    "cares": [
        "care"
    ],
    "communities": [
        "community"
    ],
    "added": [
        "add"
    ],
    "adding": [
        "add"
    ],
    "adds": [
        "add"
    ],
    "individuals": [
        "individual"
    ],
    "lost": [
        "lose"
    ],
    "losing": [
        "lose"
    ],
    "loses": [
        "lose"
    ],
    "valued": [
        "value"
    ],
    "valuing": [
        "value"
    ],
    "typed": [
        "type"
    ],
    "typing": [
        "type"
    ],
    "aged": [
        "age"
    ],
    "ageing": [
        "age"
    ],
    "won": [
        "win"
    ],
    "winning": [
        "win"
    ],
    "wins": [
        "win"
    ],
    "stopped": [
        "stop"
    ],
    "stopping": [
        "stop"
    ],
    "designed": [
        "design"
    ],
    "designing": [
        "design"
    ],
    "minuting": [
        "minute"
    ],
    "minuted": [
        "minute"
    ],
    "minutest": [
        "minute"
    ],
    "remained": [
        "remain"
    ],
    "remains": [
        "remain"
    ],
    "remaining": [
        "remain"
    ],
    "voices": [
        "voice"
    ],
    "voiced": [
        "voice"
    ],
    "voicing": [
        "voice"
    ],
    "todays": [
        "today"
    ],
    "bought": [
        "buy"
    ],
    "buying": [
        "buy"
    ],
    "buys": [
        "buy"
    ],
    "accounts": [
        "account"
    ],
    "accounted": [
        "account"
    ],
    "accounting": [
        "account"
    ],
    "worse": [
        "badly",
        "bad"
    ],
    "worst": [
        "bad"
    ],
    "remembered": [
        "remember"
    ],
    "remembering": [
        "remember"
    ],
    "remembers": [
        "remember"
    ],
    "blacked": [
        "black"
    ],
    "blacker": [
        "black"
    ],
    "blackest": [
        "black"
    ],
    "blacking": [
        "black"
    ],
    "landed": [
        "land"
    ],
    "aboves": [
        "above"
    ],
    "programmed": [
        "programme",
        "program"
    ],
    "programming": [
        "programme",
        "program"
    ],
    "walked": [
        "walk"
    ],
    "walking": [
        "walk"
    ],
    "walks": [
        "walk"
    ],
    "britains": [
        "britain"
    ],
    "spoke": [
        "speak"
    ],
    "speaking": [
        "speak"
    ],
    "spoken": [
        "speak"
    ],
    "speaks": [
        "speak"
    ],
    "spake": [
        "speak"
    ],
    "healths": [
        "health"
    ],
    "whites": [
        "white"
    ],
    "whiter": [
        "white"
    ],
    "whitest": [
        "white"
    ],
    "received": [
        "receive"
    ],
    "receiving": [
        "receive"
    ],
    "receives": [
        "receive"
    ],
    "banks": [
        "bank"
    ],
    "banked": [
        "bank"
    ],
    "banking": [
        "bank"
    ],
    "classed": [
        "class"
    ],
    "classing": [
        "class"
    ],
    "covered": [
        "cover"
    ],
    "covering": [
        "cover"
    ],
    "covers": [
        "cover"
    ],
    "sending": [
        "send"
    ],
    "sends": [
        "send"
    ],
    "sensed": [
        "sense"
    ],
    "sensing": [
        "sense"
    ],
    "gods": [
        "god"
    ],
    "hardest": [
        "hard"
    ],
    "fathers": [
        "father"
    ],
    "fathered": [
        "father"
    ],
    "fathering": [
        "father"
    ],
    "reached": [
        "reach"
    ],
    "reaching": [
        "reach"
    ],
    "reaches": [
        "reach"
    ],
    "conditioned": [
        "condition"
    ],
    "conditioning": [
        "condition"
    ],
    "surest": [
        "sure"
    ],
    "surer": [
        "sure"
    ],
    "decided": [
        "decide"
    ],
    "deciding": [
        "decide"
    ],
    "churches": [
        "church"
    ],
    "cuts": [
        "cut"
    ],
    "cutting": [
        "cut"
    ],
    "noted": [
        "note"
    ],
    "noting": [
        "note"
    ],
    "approaches": [
        "approach"
    ],
    "approached": [
        "approach"
    ],
    "approaching": [
        "approach"
    ],
    "streets": [
        "street"
    ],
    "ranging": [
        "range"
    ],
    "ranged": [
        "range"
    ],
    "developed": [
        "develop"
    ],
    "developing": [
        "develop"
    ],
    "develops": [
        "develop"
    ],
    "described": [
        "describe"
    ],
    "describes": [
        "describe"
    ],
    "describing": [
        "describe"
    ],
    "charged": [
        "charge"
    ],
    "charging": [
        "charge"
    ],
    "papers": [
        "paper"
    ],
    "papered": [
        "paper"
    ],
    "papering": [
        "paper"
    ],
    "drawn": [
        "draw"
    ],
    "drew": [
        "draw"
    ],
    "drawing": [
        "draw"
    ],
    "draws": [
        "draw"
    ],
    "theirselves": [
        "themselves"
    ],
    "agreed": [
        "agree"
    ],
    "agreeing": [
        "agree"
    ],
    "likeliest": [
        "likely"
    ],
    "likelier": [
        "likely"
    ],
    "teamed": [
        "team"
    ],
    "teaming": [
        "team"
    ],
    "built": [
        "build"
    ],
    "builds": [
        "build"
    ],
    "englands": [
        "england"
    ],
    "sectioned": [
        "section"
    ],
    "souths": [
        "south"
    ],
    "activities": [
        "activity"
    ],
    "staffed": [
        "staff"
    ],
    "staves": [
        "stave",
        "staff"
    ],
    "staffing": [
        "staff"
    ],
    "understood": [
        "understand"
    ],
    "understanding": [
        "understand"
    ],
    "understands": [
        "understand"
    ],
    "englishes": [
        "english"
    ],
    "rising": [
        "rise"
    ],
    "rises": [
        "rise"
    ],
    "risen": [
        "rise"
    ],
    "sounds": [
        "sound"
    ],
    "sounded": [
        "sound"
    ],
    "sounding": [
        "sound"
    ],
    "sounder": [
        "sound"
    ],
    "soundest": [
        "sound"
    ],
    "trades": [
        "trade"
    ],
    "trading": [
        "trade"
    ],
    "traded": [
        "trade"
    ],
    "reading": [
        "read"
    ],
    "reads": [
        "read"
    ],
    "broke": [
        "break"
    ],
    "broken": [
        "break"
    ],
    "breaking": [
        "break"
    ],
    "involved": [
        "involve"
    ],
    "involving": [
        "involve"
    ],
    "involves": [
        "involve"
    ],
    "tested": [
        "test"
    ],
    "testing": [
        "test"
    ],
    "internationals": [
        "international"
    ],
    "rules": [
        "rule"
    ],
    "ruled": [
        "rule"
    ],
    "ruling": [
        "rule"
    ],
    "tabled": [
        "table"
    ],
    "tabling": [
        "table"
    ],
    "deaths": [
        "death"
    ],
    "nearest": [
        "near"
    ],
    "nearer": [
        "near"
    ],
    "nearing": [
        "near"
    ],
    "neared": [
        "near"
    ],
    "nears": [
        "near"
    ],
    "answered": [
        "answer"
    ],
    "answers": [
        "answer"
    ],
    "answering": [
        "answer"
    ],
    "students": [
        "student"
    ],
    "spent": [
        "spend"
    ],
    "spending": [
        "spend"
    ],
    "spends": [
        "spend"
    ],
    "specials": [
        "special"
    ],
    "dated": [
        "date"
    ],
    "dating": [
        "date"
    ],
    "languages": [
        "language"
    ],
    "passed": [
        "pass"
    ],
    "towns": [
        "town"
    ],
    "managements": [
        "management"
    ],
    "freed": [
        "free"
    ],
    "freeing": [
        "free"
    ],
    "freer": [
        "free"
    ],
    "frees": [
        "free"
    ],
    "freest": [
        "free"
    ],
    "departments": [
        "department"
    ],
    "demands": [
        "demand"
    ],
    "demanded": [
        "demand"
    ],
    "demanding": [
        "demand"
    ],
    "watched": [
        "watch"
    ],
    "watching": [
        "watch"
    ],
    "watches": [
        "watch"
    ],
    "shorter": [
        "short"
    ],
    "shortest": [
        "short"
    ],
    "products": [
        "product"
    ],
    "grounds": [
        "ground"
    ],
    "grounded": [
        "ground"
    ],
    "grounding": [
        "ground"
    ],
    "committees": [
        "committee"
    ],
    "staged": [
        "stage"
    ],
    "staging": [
        "stage"
    ],
    "practices": [
        "practice"
    ],
    "practicing": [
        "practice"
    ],
    "practiced": [
        "practice"
    ],
    "fronted": [
        "front"
    ],
    "fronting": [
        "front"
    ],
    "died": [
        "die"
    ],
    "dying": [
        "die"
    ],
    "dies": [
        "die"
    ],
    "projects": [
        "project"
    ],
    "projected": [
        "project"
    ],
    "projecting": [
        "project"
    ],
    "evidenced": [
        "evidence"
    ],
    "evidencing": [
        "evidence"
    ],
    "created": [
        "create"
    ],
    "creating": [
        "create"
    ],
    "creates": [
        "create"
    ],
    "norths": [
        "north"
    ],
    "lay": [
        "lie"
    ],
    "lying": [
        "lie"
    ],
    "lain": [
        "lie"
    ],
    "humans": [
        "human"
    ],
    "attempts": [
        "attempt"
    ],
    "attempted": [
        "attempt"
    ],
    "attempting": [
        "attempt"
    ],
    "visited": [
        "visit"
    ],
    "visits": [
        "visit"
    ],
    "visiting": [
        "visit"
    ],
    "wests": [
        "west"
    ],
    "sold": [
        "sell"
    ],
    "selling": [
        "sell"
    ],
    "sells": [
        "sell"
    ],
    "letters": [
        "letter"
    ],
    "lettered": [
        "letter"
    ],
    "europeans": [
        "european"
    ],
    "fields": [
        "field"
    ],
    "fielding": [
        "field"
    ],
    "fielded": [
        "field"
    ],
    "mornings": [
        "morning"
    ],
    "foods": [
        "food"
    ],
    "games": [
        "game"
    ],
    "feet": [
        "foot"
    ],
    "footed": [
        "foot"
    ],
    "foots": [
        "foot"
    ],
    "thuss": [
        "thus"
    ],
    "teachers": [
        "teacher"
    ],
    "arms": [
        "arm"
    ],
    "armed": [
        "arm"
    ],
    "arming": [
        "arm"
    ],
    "waiting": [
        "wait"
    ],
    "waited": [
        "wait"
    ],
    "waits": [
        "wait"
    ],
    "clubbed": [
        "club"
    ],
    "clubbing": [
        "club"
    ],
    "materials": [
        "material"
    ],
    "awarded": [
        "award"
    ],
    "awards": [
        "award"
    ],
    "awarding": [
        "award"
    ],
    "sha": [
        "shall"
    ],
    "driving": [
        "drive"
    ],
    "drove": [
        "drive"
    ],
    "driven": [
        "drive"
    ],
    "marked": [
        "mark"
    ],
    "marking": [
        "mark"
    ],
    "firms": [
        "firm"
    ],
    "firmer": [
        "firm"
    ],
    "firmed": [
        "firm"
    ],
    "firmest": [
        "firm"
    ],
    "firming": [
        "firm"
    ],
    "accepted": [
        "accept"
    ],
    "accepting": [
        "accept"
    ],
    "accepts": [
        "accept"
    ],
    "easier": [
        "easy"
    ],
    "easiest": [
        "easy"
    ],
    "taxed": [
        "tax"
    ],
    "taxing": [
        "tax"
    ],
    "amounts": [
        "amount"
    ],
    "amounted": [
        "amount"
    ],
    "amounting": [
        "amount"
    ],
    "stayed": [
        "stay"
    ],
    "staying": [
        "stay"
    ],
    "stays": [
        "stay"
    ],
    "staid": [
        "stay"
    ],
    "benefits": [
        "benefit"
    ],
    "benefited": [
        "benefit"
    ],
    "benefiting": [
        "benefit"
    ],
    "benefitted": [
        "benefit"
    ],
    "benefitting": [
        "benefit"
    ],
    "singled": [
        "single"
    ],
    "singling": [
        "single"
    ],
    "trainings": [
        "training"
    ],
    "stronger": [
        "strong"
    ],
    "strongest": [
        "strong"
    ],
    "signed": [
        "sign"
    ],
    "signs": [
        "sign"
    ],
    "signing": [
        "sign"
    ],
    "wished": [
        "wish"
    ],
    "wishes": [
        "wish"
    ],
    "wishing": [
        "wish"
    ],
    "applied": [
        "apply"
    ],
    "applies": [
        "apply"
    ],
    "applying": [
        "apply"
    ],
    "centrals": [
        "central"
    ],
    "raised": [
        "raise"
    ],
    "raising": [
        "raise"
    ],
    "raises": [
        "raise"
    ],
    "models": [
        "model"
    ],
    "modelled": [
        "model"
    ],
    "modelling": [
        "model"
    ],
    "pounding": [
        "pound"
    ],
    "pounded": [
        "pound"
    ],
    "completed": [
        "complete"
    ],
    "completing": [
        "complete"
    ],
    "universities": [
        "university"
    ],
    "missed": [
        "miss"
    ],
    "missing": [
        "miss"
    ],
    "misses": [
        "miss"
    ],
    "americans": [
        "american"
    ],
    "mrss": [
        "mrs"
    ],
    "learned": [
        "learn"
    ],
    "learning": [
        "learn"
    ],
    "learnt": [
        "learn"
    ],
    "learns": [
        "learn"
    ],
    "steps": [
        "step"
    ],
    "stepped": [
        "step"
    ],
    "stepping": [
        "step"
    ],
    "structured": [
        "structure"
    ],
    "structuring": [
        "structure"
    ],
    "born": [
        "bear"
    ],
    "bearing": [
        "bear"
    ],
    "bears": [
        "bear"
    ],
    "qualities": [
        "quality"
    ],
    "aired": [
        "air"
    ],
    "airing": [
        "air"
    ],
    "explained": [
        "explain"
    ],
    "explains": [
        "explain"
    ],
    "explaining": [
        "explain"
    ],
    "relationships": [
        "relationship"
    ],
    "sirs": [
        "sir"
    ],
    "totalling": [
        "total"
    ],
    "totalled": [
        "total"
    ],
    "totals": [
        "total"
    ],
    "grew": [
        "grow"
    ],
    "grown": [
        "grow"
    ],
    "growing": [
        "grow"
    ],
    "grows": [
        "grow"
    ],
    "windows": [
        "window"
    ],
    "boards": [
        "board"
    ],
    "boarded": [
        "board"
    ],
    "boarding": [
        "board"
    ],
    "detailed": [
        "detail"
    ],
    "detailing": [
        "detail"
    ],
    "wives": [
        "wife"
    ],
    "rested": [
        "rest"
    ],
    "resting": [
        "rest"
    ],
    "rests": [
        "rest"
    ],
    "workers": [
        "worker"
    ],
    "datum": [
        "data"
    ],
    "europes": [
        "europe"
    ],
    "lists": [
        "list"
    ],
    "listed": [
        "list"
    ],
    "units": [
        "unit"
    ],
    "necessaries": [
        "necessary"
    ],
    "truer": [
        "true"
    ],
    "truest": [
        "true"
    ],
    "trues": [
        "true"
    ],
    "truing": [
        "true"
    ],
    "trued": [
        "true"
    ],
    "methods": [
        "method"
    ],
    "stories": [
        "story"
    ],
    "contained": [
        "contain"
    ],
    "contains": [
        "contain"
    ],
    "containing": [
        "contain"
    ],
    "hospitals": [
        "hospital"
    ],
    "officers": [
        "officer"
    ],
    "reduced": [
        "reduce"
    ],
    "reducing": [
        "reduce"
    ],
    "reduces": [
        "reduce"
    ],
    "privates": [
        "private"
    ],
    "according": [
        "accord"
    ],
    "accorded": [
        "accord"
    ],
    "movements": [
        "movement"
    ],
    "measures": [
        "measure"
    ],
    "measured": [
        "measure"
    ],
    "measuring": [
        "measure"
    ],
    "marched": [
        "march"
    ],
    "marching": [
        "march"
    ],
    "contracts": [
        "contract"
    ],
    "contracted": [
        "contract"
    ],
    "contracting": [
        "contract"
    ],
    "established": [
        "establish"
    ],
    "establishing": [
        "establish"
    ],
    "establishes": [
        "establish"
    ],
    "uks": [
        "uk"
    ],
    "fired": [
        "fire"
    ],
    "fires": [
        "fire"
    ],
    "firing": [
        "fire"
    ],
    "easts": [
        "east"
    ],
    "kings": [
        "king"
    ],
    "scheming": [
        "scheme"
    ],
    "schemed": [
        "scheme"
    ],
    "pressed": [
        "press"
    ],
    "planted": [
        "plant"
    ],
    "planting": [
        "plant"
    ],
    "features": [
        "feature"
    ],
    "featured": [
        "feature"
    ],
    "featuring": [
        "feature"
    ],
    "formers": [
        "former"
    ],
    "walls": [
        "wall"
    ],
    "walled": [
        "wall"
    ],
    "walling": [
        "wall"
    ],
    "joined": [
        "join"
    ],
    "joining": [
        "join"
    ],
    "wider": [
        "wide"
    ],
    "widest": [
        "wide"
    ],
    "wides": [
        "wide"
    ],
    "beds": [
        "bed"
    ],
    "bedded": [
        "bed"
    ],
    "bedding": [
        "bed"
    ],
    "finest": [
        "fine"
    ],
    "fined": [
        "fine"
    ],
    "finer": [
        "fine"
    ],
    "fining": [
        "fine"
    ],
    "frenches": [
        "french"
    ],
    "supplied": [
        "supply"
    ],
    "supplying": [
        "supply"
    ],
    "billed": [
        "bill"
    ],
    "billing": [
        "bill"
    ],
    "pictures": [
        "picture"
    ],
    "pictured": [
        "picture"
    ],
    "picturing": [
        "picture"
    ],
    "achieved": [
        "achieve"
    ],
    "achieving": [
        "achieve"
    ],
    "achieves": [
        "achieve"
    ],
    "sought": [
        "seek"
    ],
    "seeking": [
        "seek"
    ],
    "seeks": [
        "seek"
    ],
    "properties": [
        "property"
    ],
    "smiled": [
        "smile"
    ],
    "smiling": [
        "smile"
    ],
    "smiles": [
        "smile"
    ],
    "chapters": [
        "chapter"
    ],
    "shops": [
        "shop"
    ],
    "shopped": [
        "shop"
    ],
    "directors": [
        "director"
    ],
    "colours": [
        "colour"
    ],
    "coloured": [
        "colour"
    ],
    "colouring": [
        "colour"
    ],
    "chosen": [
        "choose"
    ],
    "choosing": [
        "choose"
    ],
    "chooses": [
        "choose"
    ],
    "coss": [
        "cos"
    ],
    "attacks": [
        "attack"
    ],
    "attacked": [
        "attack"
    ],
    "attacking": [
        "attack"
    ],
    "secretaries": [
        "secretary"
    ],
    "poorer": [
        "poor"
    ],
    "poorest": [
        "poor"
    ],
    "agreements": [
        "agreement"
    ],
    "sited": [
        "site"
    ],
    "siting": [
        "site"
    ],
    "opportunities": [
        "opportunity"
    ],
    "failed": [
        "fail"
    ],
    "failing": [
        "fail"
    ],
    "fails": [
        "fail"
    ],
    "directed": [
        "direct"
    ],
    "directing": [
        "direct"
    ],
    "chanced": [
        "chance"
    ],
    "chancing": [
        "chance"
    ],
    "officials": [
        "official"
    ],
    "wrongs": [
        "wrong"
    ],
    "wronging": [
        "wrong"
    ],
    "wronged": [
        "wrong"
    ],
    "served": [
        "serve"
    ],
    "serving": [
        "serve"
    ],
    "simplest": [
        "simple"
    ],
    "simpler": [
        "simple"
    ],
    "securities": [
        "security"
    ],
    "sourced": [
        "source"
    ],
    "sourcing": [
        "source"
    ],
    "occurred": [
        "occur"
    ],
    "occurs": [
        "occur"
    ],
    "occurring": [
        "occur"
    ],
    "represented": [
        "represent"
    ],
    "represents": [
        "represent"
    ],
    "representing": [
        "represent"
    ],
    "losses": [
        "loss"
    ],
    "greener": [
        "green"
    ],
    "greenest": [
        "green"
    ],
    "followings": [
        "following"
    ],
    "animals": [
        "animal"
    ],
    "davids": [
        "david"
    ],
    "influenced": [
        "influence"
    ],
    "influencing": [
        "influence"
    ],
    "aims": [
        "aim"
    ],
    "aimed": [
        "aim"
    ],
    "aiming": [
        "aim"
    ],
    "reds": [
        "red"
    ],
    "redder": [
        "red"
    ],
    "reddest": [
        "red"
    ],
    "forwarded": [
        "forward"
    ],
    "forwards": [
        "forward"
    ],
    "forwarding": [
        "forward"
    ],
    "noticed": [
        "notice"
    ],
    "noticing": [
        "notice"
    ],
    "purposes": [
        "purpose"
    ],
    "purposing": [
        "purpose"
    ],
    "purposed": [
        "purpose"
    ],
    "killed": [
        "kill"
    ],
    "killing": [
        "kill"
    ],
    "kills": [
        "kill"
    ],
    "currents": [
        "current"
    ],
    "caught": [
        "catch"
    ],
    "catching": [
        "catch"
    ],
    "catches": [
        "catch"
    ],
    "royals": [
        "royal"
    ],
    "factors": [
        "factor"
    ],
    "wearing": [
        "wear"
    ],
    "wore": [
        "wear"
    ],
    "worn": [
        "wear"
    ],
    "wears": [
        "wear"
    ],
    "musics": [
        "music"
    ],
    "concerns": [
        "concern"
    ],
    "concerned": [
        "concern"
    ],
    "concerning": [
        "concern"
    ],
    "hearts": [
        "heart"
    ],
    "risks": [
        "risk"
    ],
    "risked": [
        "risk"
    ],
    "risking": [
        "risk"
    ],
    "granted": [
        "grant"
    ],
    "grants": [
        "grant"
    ],
    "granting": [
        "grant"
    ],
    "patterns": [
        "pattern"
    ],
    "patterning": [
        "pattern"
    ],
    "patterned": [
        "pattern"
    ],
    "discussed": [
        "discuss"
    ],
    "discussing": [
        "discuss"
    ],
    "discusses": [
        "discuss"
    ],
    "doubts": [
        "doubt"
    ],
    "doubted": [
        "doubt"
    ],
    "doubting": [
        "doubt"
    ],
    "mr.s": [
        "mr."
    ],
    "picked": [
        "pick"
    ],
    "picking": [
        "pick"
    ],
    "picks": [
        "pick"
    ],
    "aprils": [
        "april"
    ],
    "coupled": [
        "couple"
    ],
    "coupling": [
        "couple"
    ],
    "links": [
        "link"
    ],
    "linked": [
        "link"
    ],
    "linking": [
        "link"
    ],
    "argued": [
        "argue"
    ],
    "argues": [
        "argue"
    ],
    "arguing": [
        "argue"
    ],
    "regarded": [
        "regard"
    ],
    "regarding": [
        "regard"
    ],
    "evenings": [
        "evening"
    ],
    "paging": [
        "page"
    ],
    "paged": [
        "page"
    ],
    "proved": [
        "prove"
    ],
    "proving": [
        "prove"
    ],
    "proves": [
        "prove"
    ],
    "proven": [
        "prove"
    ],
    "keys": [
        "key"
    ],
    "keyed": [
        "key"
    ],
    "keying": [
        "key"
    ],
    "doctors": [
        "doctor"
    ],
    "doctoring": [
        "doctor"
    ],
    "doctored": [
        "doctor"
    ],
    "pressured": [
        "pressure"
    ],
    "pressuring": [
        "pressure"
    ],
    "junes": [
        "june"
    ],
    "responses": [
        "response"
    ],
    "appeals": [
        "appeal"
    ],
    "appealed": [
        "appeal"
    ],
    "appealing": [
        "appeal"
    ],
    "fears": [
        "fear"
    ],
    "feared": [
        "fear"
    ],
    "fearing": [
        "fear"
    ],
    "functions": [
        "function"
    ],
    "functioning": [
        "function"
    ],
    "functioned": [
        "function"
    ],
    "sizes": [
        "size"
    ],
    "sized": [
        "size"
    ],
    "sizing": [
        "size"
    ],
    "piecing": [
        "piece"
    ],
    "pieced": [
        "piece"
    ],
    "knowledges": [
        "knowledge"
    ],
    "knowledge": [
        "knowledge"
    ],
    "pleased": [
        "please"
    ],
    "pleases": [
        "please"
    ],
    "pleasing": [
        "please"
    ],
    "environments": [
        "environment"
    ],
    "gardens": [
        "garden"
    ],
    "gardening": [
        "garden"
    ],
    "despites": [
        "despite"
    ],
    "filming": [
        "film"
    ],
    "filmed": [
        "film"
    ],
    "spaces": [
        "space"
    ],
    "spaced": [
        "space"
    ],
    "spacing": [
        "space"
    ],
    "introduced": [
        "introduce"
    ],
    "introducing": [
        "introduce"
    ],
    "introduces": [
        "introduce"
    ],
    "funds": [
        "fund"
    ],
    "funded": [
        "fund"
    ],
    "funding": [
        "fund"
    ],
    "enjoyed": [
        "enjoy"
    ],
    "enjoying": [
        "enjoy"
    ],
    "enjoys": [
        "enjoy"
    ],
    "successes": [
        "success"
    ],
    "trees": [
        "tree"
    ],
    "hairs": [
        "hair"
    ],
    "stationed": [
        "station"
    ],
    "stationing": [
        "station"
    ],
    "contacted": [
        "contact"
    ],
    "contacting": [
        "contact"
    ],
    "ensuring": [
        "ensure"
    ],
    "ensured": [
        "ensure"
    ],
    "ensures": [
        "ensure"
    ],
    "capitals": [
        "capital"
    ],
    "trained": [
        "train"
    ],
    "matched": [
        "match"
    ],
    "matching": [
        "match"
    ],
    "parks": [
        "park"
    ],
    "parked": [
        "park"
    ],
    "entered": [
        "enter"
    ],
    "entering": [
        "enter"
    ],
    "enters": [
        "enter"
    ],
    "statements": [
        "statement"
    ],
    "eating": [
        "eat"
    ],
    "ate": [
        "eat"
    ],
    "eaten": [
        "eat"
    ],
    "eats": [
        "eat"
    ],
    "principles": [
        "principle"
    ],
    "insides": [
        "inside"
    ],
    "wondered": [
        "wonder"
    ],
    "wondering": [
        "wonder"
    ],
    "wonders": [
        "wonder"
    ],
    "players": [
        "player"
    ],
    "expressed": [
        "express"
    ],
    "expressing": [
        "express"
    ],
    "drinking": [
        "drink"
    ],
    "drank": [
        "drink"
    ],
    "drunk": [
        "drink"
    ],
    "fighting": [
        "fight"
    ],
    "fought": [
        "fight"
    ],
    "fights": [
        "fight"
    ],
    "referred": [
        "refer"
    ],
    "refers": [
        "refer"
    ],
    "referring": [
        "refer"
    ],
    "arrived": [
        "arrive"
    ],
    "arriving": [
        "arrive"
    ],
    "choices": [
        "choice"
    ],
    "choicer": [
        "choice"
    ],
    "choicest": [
        "choice"
    ],
    "pulled": [
        "pull"
    ],
    "pulling": [
        "pull"
    ],
    "darker": [
        "dark"
    ],
    "darkest": [
        "dark"
    ],
    "machined": [
        "machine"
    ],
    "machining": [
        "machine"
    ],
    "incomes": [
        "income"
    ],
    "fitted": [
        "fit"
    ],
    "fits": [
        "fit"
    ],
    "fitting": [
        "fit"
    ],
    "fitter": [
        "fit"
    ],
    "fittest": [
        "fit"
    ],
    "seas": [
        "sea"
    ],
    "thoughts": [
        "thought"
    ],
    "cups": [
        "cup"
    ],
    "cupped": [
        "cup"
    ],
    "cupping": [
        "cup"
    ],
    "affected": [
        "affect"
    ],
    "affecting": [
        "affect"
    ],
    "affects": [
        "affect"
    ],
    "related": [
        "relate"
    ],
    "relating": [
        "relate"
    ],
    "finished": [
        "finish"
    ],
    "finishing": [
        "finish"
    ],
    "finishes": [
        "finish"
    ],
    "professionals": [
        "professional"
    ],
    "germans": [
        "german"
    ],
    "lacking": [
        "lack"
    ],
    "lacked": [
        "lack"
    ],
    "lacks": [
        "lack"
    ],
    "nicer": [
        "nice"
    ],
    "nicest": [
        "nice"
    ],
    "damages": [
        "damage"
    ],
    "damaged": [
        "damage"
    ],
    "damaging": [
        "damage"
    ],
    "resources": [
        "resource"
    ],
    "resourced": [
        "resource"
    ],
    "resourcing": [
        "resource"
    ],
    "identified": [
        "identify"
    ],
    "identifying": [
        "identify"
    ],
    "cells": [
        "cell"
    ],
    "voted": [
        "vote"
    ],
    "voting": [
        "vote"
    ],
    "scotlands": [
        "scotland"
    ],
    "reviewed": [
        "review"
    ],
    "reviews": [
        "review"
    ],
    "reviewing": [
        "review"
    ],
    "treatments": [
        "treatment"
    ],
    "difficulties": [
        "difficulty"
    ],
    "dropped": [
        "drop"
    ],
    "drops": [
        "drop"
    ],
    "dropping": [
        "drop"
    ],
    "released": [
        "release"
    ],
    "releases": [
        "release"
    ],
    "releasing": [
        "release"
    ],
    "moderns": [
        "modern"
    ],
    "counties": [
        "county"
    ],
    "growths": [
        "growth"
    ],
    "degrees": [
        "degree"
    ],
    "provisioning": [
        "provision"
    ],
    "provisioned": [
        "provision"
    ],
    "compared": [
        "compare"
    ],
    "comparing": [
        "compare"
    ],
    "defences": [
        "defence"
    ],
    "limited": [
        "limit"
    ],
    "limits": [
        "limit"
    ],
    "limiting": [
        "limit"
    ],
    "managed": [
        "manage"
    ],
    "managing": [
        "manage"
    ],
    "manages": [
        "manage"
    ],
    "styled": [
        "style"
    ],
    "styling": [
        "style"
    ],
    "behaviours": [
        "behaviour"
    ],
    "exercises": [
        "exercise"
    ],
    "exercised": [
        "exercise"
    ],
    "exercising": [
        "exercise"
    ],
    "obtained": [
        "obtain"
    ],
    "obtaining": [
        "obtain"
    ],
    "obtains": [
        "obtain"
    ],
    "halling": [
        "hall"
    ],
    "tasks": [
        "task"
    ],
    "tasked": [
        "task"
    ],
    "middles": [
        "middle"
    ],
    "commissioned": [
        "commission"
    ],
    "commissioning": [
        "commission"
    ],
    "meanss": [
        "means"
    ],
    "thanked": [
        "thank"
    ],
    "thanking": [
        "thank"
    ],
    "thanks": [
        "thank"
    ],
    "announced": [
        "announce"
    ],
    "announcing": [
        "announce"
    ],
    "announces": [
        "announce"
    ],
    "skills": [
        "skill"
    ],
    "skilled": [
        "skill"
    ],
    "happier": [
        "happy"
    ],
    "happiest": [
        "happy"
    ],
    "users": [
        "user"
    ],
    "travelled": [
        "travel"
    ],
    "travels": [
        "travel"
    ],
    "racing": [
        "race"
    ],
    "raced": [
        "race"
    ],
    "longers": [
        "longer"
    ],
    "investments": [
        "investment"
    ],
    "peters": [
        "peter"
    ],
    "petered": [
        "peter"
    ],
    "petering": [
        "peter"
    ],
    "respected": [
        "respect"
    ],
    "respecting": [
        "respect"
    ],
    "trusted": [
        "trust"
    ],
    "trusting": [
        "trust"
    ],
    "saved": [
        "save"
    ],
    "saving": [
        "save"
    ],
    "saves": [
        "save"
    ],
    "characters": [
        "character"
    ],
    "dogs": [
        "dog"
    ],
    "dogged": [
        "dog"
    ],
    "dogging": [
        "dog"
    ],
    "primed": [
        "prime"
    ],
    "priming": [
        "prime"
    ],
    "horses": [
        "horse"
    ],
    "horsing": [
        "horse"
    ],
    "horsed": [
        "horse"
    ],
    "depending": [
        "depend"
    ],
    "depended": [
        "depend"
    ],
    "gained": [
        "gain"
    ],
    "gaining": [
        "gain"
    ],
    "mentioned": [
        "mention"
    ],
    "mentioning": [
        "mention"
    ],
    "treated": [
        "treat"
    ],
    "treating": [
        "treat"
    ],
    "treats": [
        "treat"
    ],
    "maintained": [
        "maintain"
    ],
    "maintaining": [
        "maintain"
    ],
    "maintains": [
        "maintain"
    ],
    "normals": [
        "normal"
    ],
    "checked": [
        "check"
    ],
    "checking": [
        "check"
    ],
    "checks": [
        "check"
    ],
    "colder": [
        "cold"
    ],
    "colds": [
        "cold"
    ],
    "coldest": [
        "cold"
    ],
    "crossed": [
        "cross"
    ],
    "crossing": [
        "cross"
    ],
    "crossest": [
        "cross"
    ],
    "touched": [
        "touch"
    ],
    "touching": [
        "touch"
    ],
    "armies": [
        "army"
    ],
    "worths": [
        "worth"
    ],
    "seasons": [
        "season"
    ],
    "seasoning": [
        "season"
    ],
    "seasoned": [
        "season"
    ],
    "posts": [
        "post"
    ],
    "posted": [
        "post"
    ],
    "posting": [
        "post"
    ],
    "indicated": [
        "indicate"
    ],
    "indicates": [
        "indicate"
    ],
    "indicating": [
        "indicate"
    ],
    "floors": [
        "floor"
    ],
    "floored": [
        "floor"
    ],
    "flooring": [
        "floor"
    ],
    "published": [
        "publish"
    ],
    "publishing": [
        "publish"
    ],
    "publishes": [
        "publish"
    ],
    "chiefs": [
        "chief"
    ],
    "titles": [
        "title"
    ],
    "titled": [
        "title"
    ],
    "struck": [
        "strike"
    ],
    "strikes": [
        "strike"
    ],
    "striking": [
        "strike"
    ],
    "stricken": [
        "strike"
    ],
    "suffered": [
        "suffer"
    ],
    "suffering": [
        "suffer"
    ],
    "suffers": [
        "suffer"
    ],
    "ringing": [
        "ring"
    ],
    "rung": [
        "ring"
    ],
    "responsibilities": [
        "responsibility"
    ],
    "comments": [
        "comment"
    ],
    "commented": [
        "comment"
    ],
    "commenting": [
        "comment"
    ],
    "brothers": [
        "brother"
    ],
    "brethren": [
        "brother"
    ],
    "chairmen": [
        "chairman"
    ],
    "hitting": [
        "hit"
    ],
    "judges": [
        "judge"
    ],
    "judged": [
        "judge"
    ],
    "judging": [
        "judge"
    ],
    "deeper": [
        "deep"
    ],
    "deepest": [
        "deep"
    ],
    "deeps": [
        "deep"
    ],
    "julies": [
        "july"
    ],
    "profited": [
        "profit"
    ],
    "profiting": [
        "profit"
    ],
    "forgotten": [
        "forget"
    ],
    "forgot": [
        "forget"
    ],
    "forgetting": [
        "forget"
    ],
    "forgets": [
        "forget"
    ],
    "avoided": [
        "avoid"
    ],
    "avoiding": [
        "avoid"
    ],
    "avoids": [
        "avoid"
    ],
    "separated": [
        "separate"
    ],
    "separating": [
        "separate"
    ],
    "separates": [
        "separate"
    ],
    "determined": [
        "determine"
    ],
    "determining": [
        "determine"
    ],
    "addressed": [
        "address"
    ],
    "addresses": [
        "address"
    ],
    "addressing": [
        "address"
    ],
    "campaigns": [
        "campaign"
    ],
    "campaigning": [
        "campaign"
    ],
    "campaigned": [
        "campaign"
    ],
    "husbands": [
        "husband"
    ],
    "husbanding": [
        "husband"
    ],
    "husbanded": [
        "husband"
    ],
    "appropriated": [
        "appropriate"
    ],
    "appropriates": [
        "appropriate"
    ],
    "appropriating": [
        "appropriate"
    ],
    "anyways": [
        "anyway"
    ],
    "duties": [
        "duty"
    ],
    "tended": [
        "tend"
    ],
    "tending": [
        "tend"
    ],
    "supposed": [
        "suppose"
    ],
    "supposing": [
        "suppose"
    ],
    "objects": [
        "object"
    ],
    "objected": [
        "object"
    ],
    "objecting": [
        "object"
    ],
    "transferred": [
        "transfer"
    ],
    "transfers": [
        "transfer"
    ],
    "transferring": [
        "transfer"
    ],
    "seats": [
        "seat"
    ],
    "seated": [
        "seat"
    ],
    "seating": [
        "seat"
    ],
    "originals": [
        "original"
    ],
    "fished": [
        "fish"
    ],
    "fishing": [
        "fish"
    ],
    "fishes": [
        "fish"
    ],
    "basics": [
        "basic"
    ],
    "accessed": [
        "access"
    ],
    "accessing": [
        "access"
    ],
    "accesses": [
        "access"
    ],
    "boxed": [
        "box"
    ],
    "boxing": [
        "box"
    ],
    "customers": [
        "customer"
    ],
    "specifics": [
        "specific"
    ],
    "militaries": [
        "military"
    ],
    "summers": [
        "summer"
    ],
    "removed": [
        "remove"
    ],
    "removing": [
        "remove"
    ],
    "removes": [
        "remove"
    ],
    "thrown": [
        "throw"
    ],
    "threw": [
        "throw"
    ],
    "throwing": [
        "throw"
    ],
    "throws": [
        "throw"
    ],
    "faster": [
        "fast"
    ],
    "fastest": [
        "fast"
    ],
    "fasting": [
        "fast"
    ],
    "fasted": [
        "fast"
    ],
    "fasts": [
        "fast"
    ],
    "bluer": [
        "blue"
    ],
    "bluest": [
        "blue"
    ],
    "blueing": [
        "blue"
    ],
    "blued": [
        "blue"
    ],
    "pauls": [
        "paul"
    ],
    "potentials": [
        "potential"
    ],
    "daughters": [
        "daughter"
    ],
    "suns": [
        "sun"
    ],
    "sunning": [
        "sun"
    ],
    "sunned": [
        "sun"
    ],
    "exists": [
        "exist"
    ],
    "existed": [
        "exist"
    ],
    "existing": [
        "exist"
    ],
    "legging": [
        "leg"
    ],
    "legged": [
        "leg"
    ],
    "encouraged": [
        "encourage"
    ],
    "encouraging": [
        "encourage"
    ],
    "stoned": [
        "stone"
    ],
    "stoning": [
        "stone"
    ],
    "rivers": [
        "river"
    ],
    "reflected": [
        "reflect"
    ],
    "reflects": [
        "reflect"
    ],
    "reflecting": [
        "reflect"
    ],
    "listening": [
        "listen"
    ],
    "listened": [
        "listen"
    ],
    "listens": [
        "listen"
    ],
    "proposals": [
        "proposal"
    ],
    "surveys": [
        "survey"
    ],
    "surveyed": [
        "survey"
    ],
    "surveying": [
        "survey"
    ],
    "oils": [
        "oil"
    ],
    "oiled": [
        "oil"
    ],
    "oiling": [
        "oil"
    ],
    "independents": [
        "independent"
    ],
    "exchanges": [
        "exchange"
    ],
    "exchanged": [
        "exchange"
    ],
    "exchanging": [
        "exchange"
    ],
    "babies": [
        "baby"
    ],
    "sectors": [
        "sector"
    ],
    "starring": [
        "star"
    ],
    "starred": [
        "star"
    ],
    "assumed": [
        "assume"
    ],
    "assuming": [
        "assume"
    ],
    "aids": [
        "aid"
    ],
    "aided": [
        "aid"
    ],
    "aiding": [
        "aid"
    ],
    "improved": [
        "improve"
    ],
    "improving": [
        "improve"
    ],
    "improves": [
        "improve"
    ],
    "imaging": [
        "image"
    ],
    "imaged": [
        "image"
    ],
    "admitted": [
        "admit"
    ],
    "admits": [
        "admit"
    ],
    "admitting": [
        "admit"
    ],
    "displayed": [
        "display"
    ],
    "displays": [
        "display"
    ],
    "displaying": [
        "display"
    ],
    "replaced": [
        "replace"
    ],
    "replacing": [
        "replace"
    ],
    "laying": [
        "lay"
    ],
    "lays": [
        "lay"
    ],
    "northerns": [
        "northern"
    ],
    "circumstances": [
        "circumstance"
    ],
    "prepared": [
        "prepare"
    ],
    "preparing": [
        "prepare"
    ],
    "laughed": [
        "laugh"
    ],
    "laughing": [
        "laugh"
    ],
    "laughs": [
        "laugh"
    ],
    "sorrier": [
        "sorry"
    ],
    "sorriest": [
        "sorry"
    ],
    "averaged": [
        "average"
    ],
    "averages": [
        "average"
    ],
    "averaging": [
        "average"
    ],
    "instanced": [
        "instance"
    ],
    "balanced": [
        "balance"
    ],
    "balancing": [
        "balance"
    ],
    "diseases": [
        "disease"
    ],
    "employments": [
        "employment"
    ],
    "filled": [
        "fill"
    ],
    "filling": [
        "fill"
    ],
    "fills": [
        "fill"
    ],
    "surfaced": [
        "surface"
    ],
    "surfacing": [
        "surface"
    ],
    "barred": [
        "bar"
    ],
    "barring": [
        "bar"
    ],
    "pushed": [
        "push"
    ],
    "pushing": [
        "push"
    ],
    "pushes": [
        "push"
    ],
    "refused": [
        "refuse"
    ],
    "refusing": [
        "refuse"
    ],
    "intended": [
        "intend"
    ],
    "intends": [
        "intend"
    ],
    "intending": [
        "intend"
    ],
    "octobers": [
        "october"
    ],
    "troubled": [
        "trouble"
    ],
    "troubling": [
        "trouble"
    ],
    "searching": [
        "search"
    ],
    "searched": [
        "search"
    ],
    "searches": [
        "search"
    ],
    "holidays": [
        "holiday"
    ],
    "holidaying": [
        "holiday"
    ],
    "holidayed": [
        "holiday"
    ],
    "workings": [
        "working"
    ],
    "documented": [
        "document"
    ],
    "documenting": [
        "document"
    ],
    "pupils": [
        "pupil"
    ],
    "prevented": [
        "prevent"
    ],
    "preventing": [
        "prevent"
    ],
    "prevents": [
        "prevent"
    ],
    "targets": [
        "target"
    ],
    "targeted": [
        "target"
    ],
    "targeting": [
        "target"
    ],
    "targetted": [
        "target"
    ],
    "targetting": [
        "target"
    ],
    "items": [
        "item"
    ],
    "populars": [
        "popular"
    ],
    "affairs": [
        "affair"
    ],
    "winds": [
        "wind"
    ],
    "wound": [
        "wind"
    ],
    "winding": [
        "wind"
    ],
    "winded": [
        "wind"
    ],
    "abilities": [
        "ability"
    ],
    "copied": [
        "copy"
    ],
    "copying": [
        "copy"
    ],
    "referenced": [
        "reference"
    ],
    "referencing": [
        "reference"
    ],
    "saless": [
        "sales"
    ],
    "drugs": [
        "drug"
    ],
    "drugged": [
        "drug"
    ],
    "drugging": [
        "drug"
    ],
    "septembers": [
        "september"
    ],
    "replied": [
        "reply"
    ],
    "replying": [
        "reply"
    ],
    "flew": [
        "fly"
    ],
    "flying": [
        "fly"
    ],
    "flies": [
        "fly"
    ],
    "flown": [
        "fly"
    ],
    "flied": [
        "fly"
    ],
    "discovered": [
        "discover"
    ],
    "discovering": [
        "discover"
    ],
    "discovers": [
        "discover"
    ],
    "heavier": [
        "heavy"
    ],
    "heaviest": [
        "heavy"
    ],
    "heavies": [
        "heavy"
    ],
    "excepted": [
        "except"
    ],
    "excepting": [
        "except"
    ],
    "excepts": [
        "except"
    ],
    "libraries": [
        "library"
    ],
    "cultured": [
        "culture"
    ],
    "culturing": [
        "culture"
    ],
    "rocked": [
        "rock"
    ],
    "rocking": [
        "rock"
    ],
    "taught": [
        "teach"
    ],
    "teaching": [
        "teach"
    ],
    "teaches": [
        "teach"
    ],
    "stocked": [
        "stock"
    ],
    "stocking": [
        "stock"
    ],
    "operating": [
        "operate"
    ],
    "operated": [
        "operate"
    ],
    "operates": [
        "operate"
    ],
    "advantages": [
        "advantage"
    ],
    "advantaged": [
        "advantage"
    ],
    "revealed": [
        "reveal"
    ],
    "reveals": [
        "reveal"
    ],
    "revealing": [
        "reveal"
    ],
    "varieties": [
        "variety"
    ],
    "januaries": [
        "january"
    ],
    "readies": [
        "ready"
    ],
    "readying": [
        "ready"
    ],
    "readied": [
        "ready"
    ],
    "readier": [
        "ready"
    ],
    "flattest": [
        "flat"
    ],
    "challenged": [
        "challenge"
    ],
    "challenging": [
        "challenge"
    ],
    "slept": [
        "sleep"
    ],
    "sleeps": [
        "sleep"
    ],
    "parliaments": [
        "parliament"
    ],
    "chaired": [
        "chair"
    ],
    "chairing": [
        "chair"
    ],
    "shapes": [
        "shape"
    ],
    "shaped": [
        "shape"
    ],
    "shaping": [
        "shape"
    ],
    "majorities": [
        "majority"
    ],
    "enables": [
        "enable"
    ],
    "enabled": [
        "enable"
    ],
    "enabling": [
        "enable"
    ],
    "jamess": [
        "james"
    ],
    "extents": [
        "extent"
    ],
    "complexed": [
        "complex"
    ],
    "memories": [
        "memory"
    ],
    "scottishes": [
        "scottish"
    ],
    "ahs": [
        "ah"
    ],
    "payments": [
        "payment"
    ],
    "filed": [
        "file"
    ],
    "filing": [
        "file"
    ],
    "sundays": [
        "sunday"
    ],
    "bloods": [
        "blood"
    ],
    "blooded": [
        "blood"
    ],
    "blooding": [
        "blood"
    ],
    "females": [
        "female"
    ],
    "sentenced": [
        "sentence"
    ],
    "sentencing": [
        "sentence"
    ],
    "facilities": [
        "facility"
    ],
    "straighter": [
        "straight"
    ],
    "straights": [
        "straight"
    ],
    "straightest": [
        "straight"
    ],
    "yorks": [
        "york"
    ],
    "doubled": [
        "double"
    ],
    "doubling": [
        "double"
    ],
    "contexts": [
        "context"
    ],
    "dressed": [
        "dress"
    ],
    "budgeted": [
        "budget"
    ],
    "budgeting": [
        "budget",
        "budgete"
    ],
    "edges": [
        "edge"
    ],
    "edged": [
        "edge"
    ],
    "edging": [
        "edge"
    ],
    "financed": [
        "finance"
    ],
    "financing": [
        "finance"
    ],
    "irelands": [
        "ireland"
    ],
    "extended": [
        "extend"
    ],
    "extending": [
        "extend"
    ],
    "extends": [
        "extend"
    ],
    "phoned": [
        "phone"
    ],
    "phoning": [
        "phone"
    ],
    "fairs": [
        "fair"
    ],
    "fairer": [
        "fair"
    ],
    "fairest": [
        "fair"
    ],
    "associated": [
        "associate"
    ],
    "associates": [
        "associate"
    ],
    "associating": [
        "associate"
    ],
    "articled": [
        "article"
    ],
    "mouths": [
        "mouth"
    ],
    "mouthed": [
        "mouth"
    ],
    "mouthing": [
        "mouth"
    ],
    "agencies": [
        "agency"
    ],
    "primaries": [
        "primary"
    ],
    "arising": [
        "arise"
    ],
    "arises": [
        "arise"
    ],
    "arose": [
        "arise"
    ],
    "arisen": [
        "arise"
    ],
    "transported": [
        "transport"
    ],
    "transporting": [
        "transport"
    ],
    "birds": [
        "bird"
    ],
    "cards": [
        "card"
    ],
    "carded": [
        "card"
    ],
    "carding": [
        "card"
    ],
    "weights": [
        "weight"
    ],
    "weighted": [
        "weight"
    ],
    "weighting": [
        "weight"
    ],
    "speeds": [
        "speed"
    ],
    "speeding": [
        "speed"
    ],
    "sped": [
        "speed"
    ],
    "speeded": [
        "speed"
    ],
    "texts": [
        "text"
    ],
    "realised": [
        "realise"
    ],
    "realising": [
        "realise"
    ],
    "promised": [
        "promise"
    ],
    "promising": [
        "promise"
    ],
    "possibilities": [
        "possibility"
    ],
    "conservatives": [
        "conservative"
    ],
    "progressed": [
        "progress"
    ],
    "progressing": [
        "progress"
    ],
    "debates": [
        "debate"
    ],
    "debated": [
        "debate"
    ],
    "debating": [
        "debate"
    ],
    "scored": [
        "score"
    ],
    "scoring": [
        "score"
    ],
    "defined": [
        "define"
    ],
    "defining": [
        "define"
    ],
    "defines": [
        "define"
    ],
    "beaten": [
        "beat"
    ],
    "beating": [
        "beat"
    ],
    "lifted": [
        "lift"
    ],
    "careers": [
        "career"
    ],
    "careered": [
        "career"
    ],
    "careering": [
        "career"
    ],
    "focused": [
        "focus"
    ],
    "focusing": [
        "focus"
    ],
    "focuses": [
        "focus"
    ],
    "focussed": [
        "focus"
    ],
    "foci": [
        "focus"
    ],
    "focussing": [
        "focus"
    ],
    "decembers": [
        "december"
    ],
    "novembers": [
        "november"
    ],
    "executives": [
        "executive"
    ],
    "scales": [
        "scale"
    ],
    "scaled": [
        "scale"
    ],
    "scaling": [
        "scale"
    ],
    "organizations": [
        "organization"
    ],
    "earthed": [
        "earth"
    ],
    "earths": [
        "earth"
    ],
    "earthing": [
        "earth"
    ],
    "examined": [
        "examine"
    ],
    "examining": [
        "examine"
    ],
    "hills": [
        "hill"
    ],
    "welcomed": [
        "welcome"
    ],
    "welcomes": [
        "welcome"
    ],
    "welcoming": [
        "welcome"
    ],
    "medicals": [
        "medical"
    ],
    "waless": [
        "wales"
    ],
    "networks": [
        "network"
    ],
    "networking": [
        "network"
    ],
    "networked": [
        "network"
    ],
    "requirements": [
        "requirement"
    ],
    "sporting": [
        "sport"
    ],
    "sported": [
        "sport"
    ],
    "quarters": [
        "quarter"
    ],
    "quartered": [
        "quarter"
    ],
    "quartering": [
        "quarter"
    ],
    "pp": [
        "p"
    ],
    "ps": [
        "p"
    ],
    "occasioned": [
        "occasion"
    ],
    "occasioning": [
        "occasion"
    ],
    "hottest": [
        "hot"
    ],
    "hotting": [
        "hot"
    ],
    "hots": [
        "hot"
    ],
    "hotted": [
        "hot"
    ],
    "bands": [
        "band"
    ],
    "banded": [
        "band"
    ],
    "banding": [
        "band"
    ],
    "recognised": [
        "recognise"
    ],
    "recognising": [
        "recognise"
    ],
    "recognises": [
        "recognise"
    ],
    "telephoned": [
        "telephone"
    ],
    "telephoning": [
        "telephone"
    ],
    "railways": [
        "railway"
    ],
    "forests": [
        "forest"
    ],
    "sisters": [
        "sister"
    ],
    "contented": [
        "content"
    ],
    "contenting": [
        "content"
    ],
    "favoured": [
        "favour"
    ],
    "favours": [
        "favour"
    ],
    "favouring": [
        "favour"
    ],
    "islands": [
        "island"
    ],
    "radioing": [
        "radio"
    ],
    "radioed": [
        "radio"
    ],
    "dearest": [
        "dear"
    ],
    "dearer": [
        "dear"
    ],
    "dears": [
        "dear"
    ],
    "stored": [
        "store"
    ],
    "storing": [
        "store"
    ],
    "essentials": [
        "essential"
    ],
    "attended": [
        "attend"
    ],
    "attending": [
        "attend"
    ],
    "reforms": [
        "reform"
    ],
    "reformed": [
        "reform"
    ],
    "reforming": [
        "reform"
    ],
    "charless": [
        "charles"
    ],
    "partners": [
        "partner"
    ],
    "partnered": [
        "partner"
    ],
    "partnering": [
        "partner"
    ],
    "tomorrows": [
        "tomorrow"
    ],
    "balls": [
        "ball"
    ],
    "balled": [
        "ball"
    ],
    "balling": [
        "ball"
    ],
    "wasted": [
        "waste"
    ],
    "wasting": [
        "waste"
    ],
    "wastes": [
        "waste"
    ],
    "sexing": [
        "sex"
    ],
    "sexed": [
        "sex"
    ],
    "equipments": [
        "equipment"
    ],
    "equipment": [
        "equipment"
    ],
    "farms": [
        "farm"
    ],
    "farmed": [
        "farm"
    ],
    "farming": [
        "farm"
    ],
    "cleaning": [
        "clean"
    ],
    "cleaned": [
        "clean"
    ],
    "cleaner": [
        "clean"
    ],
    "cleans": [
        "clean"
    ],
    "cleanest": [
        "clean"
    ],
    "hung": [
        "hang"
    ],
    "hanging": [
        "hang"
    ],
    "hangs": [
        "hang"
    ],
    "hanged": [
        "hang"
    ],
    "shook": [
        "shake"
    ],
    "shaking": [
        "shake"
    ],
    "shaken": [
        "shake"
    ],
    "shakes": [
        "shake"
    ],
    "interviewed": [
        "interview"
    ],
    "interviewing": [
        "interview"
    ],
    "lengths": [
        "length"
    ],
    "failures": [
        "failure"
    ],
    "branched": [
        "branch"
    ],
    "branching": [
        "branch"
    ],
    "performed": [
        "perform"
    ],
    "performing": [
        "perform"
    ],
    "performs": [
        "perform"
    ],
    "cornered": [
        "corner"
    ],
    "cornering": [
        "corner"
    ],
    "readers": [
        "reader"
    ],
    "speeches": [
        "speech"
    ],
    "owners": [
        "owner"
    ],
    "cashed": [
        "cash"
    ],
    "cashing": [
        "cash"
    ],
    "cashes": [
        "cash"
    ],
    "woods": [
        "wood"
    ],
    "browns": [
        "brown"
    ],
    "browned": [
        "brown"
    ],
    "browner": [
        "brown"
    ],
    "brownest": [
        "brown"
    ],
    "fingers": [
        "finger"
    ],
    "fingered": [
        "finger"
    ],
    "fingering": [
        "finger"
    ],
    "peaces": [
        "peace"
    ],
    "mastered": [
        "master"
    ],
    "mastering": [
        "master"
    ],
    "estimated": [
        "estimate"
    ],
    "estimates": [
        "estimate"
    ],
    "estimating": [
        "estimate"
    ],
    "messaging": [
        "message"
    ],
    "credited": [
        "credit"
    ],
    "crediting": [
        "credit"
    ],
    "adopted": [
        "adopt"
    ],
    "adopting": [
        "adopt"
    ],
    "adopts": [
        "adopt"
    ],
    "launched": [
        "launch"
    ],
    "launching": [
        "launch"
    ],
    "launches": [
        "launch"
    ],
    "dreams": [
        "dream"
    ],
    "dreamed": [
        "dream"
    ],
    "dreaming": [
        "dream"
    ],
    "dreamt": [
        "dream"
    ],
    "saturdays": [
        "saturday"
    ],
    "mums": [
        "mum"
    ],
    "massed": [
        "mass"
    ],
    "massing": [
        "mass"
    ],
    "protected": [
        "protect"
    ],
    "protecting": [
        "protect"
    ],
    "protects": [
        "protect"
    ],
    "confirmed": [
        "confirm"
    ],
    "confirms": [
        "confirm"
    ],
    "confirming": [
        "confirm"
    ],
    "shoulders": [
        "shoulder"
    ],
    "shouldered": [
        "shoulder"
    ],
    "shouldering": [
        "shoulder"
    ],
    "afternoons": [
        "afternoon"
    ],
    "marriages": [
        "marriage"
    ],
    "trials": [
        "trial"
    ],
    "trialled": [
        "trial"
    ],
    "leagues": [
        "league"
    ],
    "tracks": [
        "track"
    ],
    "tracked": [
        "track"
    ],
    "tracking": [
        "track"
    ],
    "stressed": [
        "stress"
    ],
    "stressing": [
        "stress"
    ],
    "truths": [
        "truth"
    ],
    "christians": [
        "christian"
    ],
    "februaries": [
        "february"
    ],
    "adults": [
        "adult"
    ],
    "squared": [
        "square"
    ],
    "squaring": [
        "square"
    ],
    "stuck": [
        "stick"
    ],
    "sticking": [
        "stick"
    ],
    "ships": [
        "ship"
    ],
    "shipped": [
        "ship"
    ],
    "commercials": [
        "commercial"
    ],
    "warmer": [
        "warm"
    ],
    "warmed": [
        "warm"
    ],
    "warming": [
        "warm"
    ],
    "warmest": [
        "warm"
    ],
    "warms": [
        "warm"
    ],
    "newspapers": [
        "newspaper"
    ],
    "teas": [
        "tea"
    ],
    "spirits": [
        "spirit"
    ],
    "spirited": [
        "spirit"
    ],
    "spiriting": [
        "spirit"
    ],
    "paired": [
        "pair"
    ],
    "pairing": [
        "pair"
    ],
    "kitchens": [
        "kitchen"
    ],
    "waves": [
        "wave"
    ],
    "waved": [
        "wave"
    ],
    "waving": [
        "wave"
    ],
    "annuals": [
        "annual"
    ],
    "advanced": [
        "advance"
    ],
    "advances": [
        "advance"
    ],
    "advancing": [
        "advance"
    ],
    "mining": [
        "mine"
    ],
    "mined": [
        "mine"
    ],
    "blocked": [
        "block"
    ],
    "blocking": [
        "block"
    ],
    "gases": [
        "gas"
    ],
    "gassing": [
        "gas"
    ],
    "gasses": [
        "gas"
    ],
    "gassed": [
        "gas"
    ],
    "slower": [
        "slow"
    ],
    "slowed": [
        "slow"
    ],
    "slowing": [
        "slow"
    ],
    "slowest": [
        "slow"
    ],
    "dried": [
        "dry"
    ],
    "drying": [
        "dry"
    ],
    "dries": [
        "dry"
    ],
    "drier": [
        "dry"
    ],
    "driest": [
        "dry"
    ],
    "dryer": [
        "dry"
    ],
    "museums": [
        "museum"
    ],
    "proportioned": [
        "proportion"
    ],
    "touring": [
        "tour"
    ],
    "toured": [
        "tour"
    ],
    "fed": [
        "feed"
    ],
    "feeding": [
        "feed"
    ],
    "feeds": [
        "feed"
    ],
    "bests": [
        "best"
    ],
    "bested": [
        "best"
    ],
    "besting": [
        "best"
    ],
    "pained": [
        "pain"
    ],
    "paining": [
        "pain"
    ],
    "strengths": [
        "strength"
    ],
    "stared": [
        "stare"
    ],
    "staring": [
        "stare"
    ],
    "stares": [
        "stare"
    ],
    "shot": [
        "shoot"
    ],
    "shooting": [
        "shoot"
    ],
    "workss": [
        "works"
    ],
    "conducted": [
        "conduct"
    ],
    "conducting": [
        "conduct"
    ],
    "conducts": [
        "conduct"
    ],
    "imagined": [
        "imagine"
    ],
    "imagining": [
        "imagine"
    ],
    "counts": [
        "count"
    ],
    "counted": [
        "count"
    ],
    "counting": [
        "count"
    ],
    "samples": [
        "sample"
    ],
    "sampled": [
        "sample"
    ],
    "sampling": [
        "sample"
    ],
    "augusts": [
        "august"
    ],
    "smiths": [
        "smith"
    ],
    "overalls": [
        "overall"
    ],
    "queens": [
        "queen"
    ],
    "battles": [
        "battle"
    ],
    "battling": [
        "battle"
    ],
    "battled": [
        "battle"
    ],
    "struggling": [
        "struggle"
    ],
    "struggled": [
        "struggle"
    ],
    "struggles": [
        "struggle"
    ],
    "jointed": [
        "joint"
    ],
    "jointing": [
        "joint"
    ],
    "meanings": [
        "meaning"
    ],
    "contrasts": [
        "contrast"
    ],
    "contrasted": [
        "contrast"
    ],
    "contrasting": [
        "contrast"
    ],
    "safer": [
        "safe"
    ],
    "safest": [
        "safe"
    ],
    "safes": [
        "safe"
    ],
    "employed": [
        "employ"
    ],
    "employing": [
        "employ"
    ],
    "employs": [
        "employ"
    ],
    "cried": [
        "cry"
    ],
    "crying": [
        "cry"
    ],
    "richer": [
        "rich"
    ],
    "richest": [
        "rich"
    ],
    "springs": [
        "spring"
    ],
    "sprang": [
        "spring"
    ],
    "sprung": [
        "spring"
    ],
    "springing": [
        "spring"
    ],
    "murdered": [
        "murder"
    ],
    "murders": [
        "murder"
    ],
    "murdering": [
        "murder"
    ],
    "flows": [
        "flow"
    ],
    "flowing": [
        "flow"
    ],
    "flowed": [
        "flow"
    ],
    "pluses": [
        "plus"
    ],
    "regionals": [
        "regional"
    ],
    "assessments": [
        "assessment"
    ],
    "artists": [
        "artist"
    ],
    "distanced": [
        "distance"
    ],
    "distancing": [
        "distance"
    ],
    "guided": [
        "guide"
    ],
    "guiding": [
        "guide"
    ],
    "suits": [
        "suit"
    ],
    "suited": [
        "suit"
    ],
    "suiting": [
        "suit"
    ],
    "collected": [
        "collect"
    ],
    "collecting": [
        "collect"
    ],
    "collects": [
        "collect"
    ],
    "regulars": [
        "regular"
    ],
    "prettiest": [
        "pretty"
    ],
    "prettier": [
        "pretty"
    ],
    "africas": [
        "africa"
    ],
    "married": [
        "marry"
    ],
    "marrying": [
        "marry"
    ],
    "marries": [
        "marry"
    ],
    "stuffed": [
        "stuff"
    ],
    "stuffing": [
        "stuff"
    ],
    "stuffs": [
        "stuff"
    ],
    "flowers": [
        "flower"
    ],
    "flowering": [
        "flower"
    ],
    "flowered": [
        "flower"
    ],
    "videoing": [
        "video"
    ],
    "videoed": [
        "video"
    ],
    "requested": [
        "request"
    ],
    "requests": [
        "request"
    ],
    "requesting": [
        "request"
    ],
    "impacted": [
        "impact"
    ],
    "impacting": [
        "impact"
    ],
    "worries": [
        "worry"
    ],
    "worried": [
        "worry"
    ],
    "worrying": [
        "worry"
    ],
    "practicals": [
        "practical"
    ],
    "latters": [
        "latter"
    ],
    "understandings": [
        "understanding"
    ],
    "bottoms": [
        "bottom"
    ],
    "bottoming": [
        "bottom"
    ],
    "bottomed": [
        "bottom"
    ],
    "golds": [
        "gold"
    ],
    "golding": [
        "gold"
    ],
    "corrected": [
        "correct"
    ],
    "correcting": [
        "correct"
    ],
    "beginnings": [
        "beginning"
    ],
    "dailies": [
        "daily"
    ],
    "appointed": [
        "appoint"
    ],
    "appointing": [
        "appoint"
    ],
    "appoints": [
        "appoint"
    ],
    "winters": [
        "winter"
    ],
    "wintering": [
        "winter"
    ],
    "wintered": [
        "winter"
    ],
    "emerged": [
        "emerge"
    ],
    "emerging": [
        "emerge"
    ],
    "netted": [
        "net"
    ],
    "netting": [
        "net"
    ],
    "spotted": [
        "spot"
    ],
    "spotting": [
        "spot"
    ],
    "routing": [
        "route",
        "rout"
    ],
    "routed": [
        "route",
        "rout"
    ],
    "skinned": [
        "skin"
    ],
    "skinning": [
        "skin"
    ],
    "denied": [
        "deny"
    ],
    "denying": [
        "deny"
    ],
    "denys": [
        "deny"
    ],
    "packages": [
        "package"
    ],
    "packaged": [
        "package"
    ],
    "raining": [
        "rain"
    ],
    "rains": [
        "rain"
    ],
    "rained": [
        "rain"
    ],
    "spreading": [
        "spread"
    ],
    "spreads": [
        "spread"
    ],
    "equals": [
        "equal"
    ],
    "equalled": [
        "equal"
    ],
    "equalling": [
        "equal"
    ],
    "beliefs": [
        "belief"
    ],
    "conflicts": [
        "conflict"
    ],
    "conflicted": [
        "conflict"
    ],
    "conflicting": [
        "conflict"
    ],
    "sights": [
        "sight"
    ],
    "sighted": [
        "sight"
    ],
    "sighting": [
        "sight"
    ],
    "declined": [
        "decline"
    ],
    "declining": [
        "decline"
    ],
    "purchased": [
        "purchase"
    ],
    "purchases": [
        "purchase"
    ],
    "purchasing": [
        "purchase"
    ],
    "secured": [
        "secure"
    ],
    "securing": [
        "secure"
    ],
    "secures": [
        "secure"
    ],
    "observed": [
        "observe"
    ],
    "observing": [
        "observe"
    ],
    "politicss": [
        "politics"
    ],
    "bridged": [
        "bridge"
    ],
    "bridging": [
        "bridge"
    ],
    "bags": [
        "bag"
    ],
    "bagged": [
        "bag"
    ],
    "bagging": [
        "bag"
    ],
    "estates": [
        "estate"
    ],
    "handled": [
        "handle"
    ],
    "handling": [
        "handle"
    ],
    "handles": [
        "handle"
    ],
    "proposed": [
        "propose"
    ],
    "proposing": [
        "propose"
    ],
    "paths": [
        "path"
    ],
    "farmers": [
        "farmer"
    ],
    "boats": [
        "boat"
    ],
    "boating": [
        "boat"
    ],
    "debts": [
        "debt"
    ],
    "holes": [
        "hole"
    ],
    "holed": [
        "hole"
    ],
    "holing": [
        "hole"
    ],
    "escaped": [
        "escape"
    ],
    "escaping": [
        "escape"
    ],
    "escapes": [
        "escape"
    ],
    "employers": [
        "employer"
    ],
    "vehicles": [
        "vehicle"
    ],
    "realities": [
        "reality"
    ],
    "settled": [
        "settle"
    ],
    "settling": [
        "settle"
    ],
    "settles": [
        "settle"
    ],
    "repeated": [
        "repeat"
    ],
    "repeating": [
        "repeat"
    ],
    "repeats": [
        "repeat"
    ],
    "rows": [
        "row"
    ],
    "rowed": [
        "row"
    ],
    "rowing": [
        "row"
    ],
    "weekends": [
        "weekend"
    ],
    "wines": [
        "wine"
    ],
    "wined": [
        "wine"
    ],
    "wining": [
        "wine"
    ],
    "writers": [
        "writer"
    ],
    "tears": [
        "tear"
    ],
    "torn": [
        "tear"
    ],
    "tearing": [
        "tear"
    ],
    "responded": [
        "respond"
    ],
    "responding": [
        "respond"
    ],
    "responds": [
        "respond"
    ],
    "wages": [
        "wage"
    ],
    "waged": [
        "wage"
    ],
    "waging": [
        "wage"
    ],
    "insurances": [
        "insurance"
    ],
    "tied": [
        "tie"
    ],
    "ties": [
        "tie"
    ],
    "tying": [
        "tie"
    ],
    "ignored": [
        "ignore"
    ],
    "ignoring": [
        "ignore"
    ],
    "blew": [
        "blow"
    ],
    "blown": [
        "blow"
    ],
    "blowing": [
        "blow"
    ],
    "blows": [
        "blow"
    ],
    "blowed": [
        "blow"
    ],
    "survived": [
        "survive"
    ],
    "surviving": [
        "survive"
    ],
    "desired": [
        "desire"
    ],
    "desiring": [
        "desire"
    ],
    "colleagues": [
        "colleague"
    ],
    "concentrated": [
        "concentrate"
    ],
    "concentrating": [
        "concentrate"
    ],
    "concentrates": [
        "concentrate"
    ],
    "somebodies": [
        "somebody"
    ],
    "riding": [
        "ride"
    ],
    "ridden": [
        "ride"
    ],
    "danced": [
        "dance"
    ],
    "dances": [
        "dance"
    ],
    "arranged": [
        "arrange"
    ],
    "arranging": [
        "arrange"
    ],
    "legislations": [
        "legislation"
    ],
    "commitments": [
        "commitment"
    ],
    "paintings": [
        "painting"
    ],
    "clothess": [
        "clothes"
    ],
    "initials": [
        "initial"
    ],
    "initialled": [
        "initial"
    ],
    "initialling": [
        "initial"
    ],
    "shifted": [
        "shift"
    ],
    "shifts": [
        "shift"
    ],
    "shifting": [
        "shift"
    ],
    "sums": [
        "sum"
    ],
    "summed": [
        "sum"
    ],
    "summing": [
        "sum"
    ],
    "selected": [
        "select"
    ],
    "selecting": [
        "select"
    ],
    "threats": [
        "threat"
    ],
    "rolled": [
        "roll"
    ],
    "rolling": [
        "roll"
    ],
    "rolls": [
        "roll"
    ],
    "bloodiest": [
        "bloody"
    ],
    "bloodied": [
        "bloody"
    ],
    "bloodies": [
        "bloody"
    ],
    "bloodying": [
        "bloody"
    ],
    "bloodier": [
        "bloody"
    ],
    "entries": [
        "entry"
    ],
    "domestics": [
        "domestic"
    ],
    "visitors": [
        "visitor"
    ],
    "coded": [
        "code"
    ],
    "coding": [
        "code"
    ],
    "authors": [
        "author"
    ],
    "authoring": [
        "author"
    ],
    "authored": [
        "author"
    ],
    "kingdoms": [
        "kingdom"
    ],
    "songs": [
        "song"
    ],
    "disciplined": [
        "discipline"
    ],
    "disciplining": [
        "discipline"
    ],
    "ordinaries": [
        "ordinary"
    ],
    "backgrounds": [
        "background"
    ],
    "actuals": [
        "actual"
    ],
    "painted": [
        "paint"
    ],
    "paints": [
        "paint"
    ],
    "painting": [
        "paint"
    ],
    "regulations": [
        "regulation"
    ],
    "characteristics": [
        "characteristic"
    ],
    "fresher": [
        "fresh"
    ],
    "freshest": [
        "fresh"
    ],
    "technicals": [
        "technical"
    ],
    "thomass": [
        "thomas"
    ],
    "busses": [
        "bus"
    ],
    "bussing": [
        "bus"
    ],
    "bussed": [
        "bus"
    ],
    "loans": [
        "loan"
    ],
    "loaned": [
        "loan"
    ],
    "loaning": [
        "loan"
    ],
    "med": [
        "m"
    ],
    "ms": [
        "m"
    ],
    "engines": [
        "engine"
    ],
    "engined": [
        "engine"
    ],
    "henries": [
        "henry"
    ],
    "ecs": [
        "ec"
    ],
    "internals": [
        "internal"
    ],
    "acquired": [
        "acquire"
    ],
    "acquiring": [
        "acquire"
    ],
    "acquires": [
        "acquire"
    ],
    "demonstrated": [
        "demonstrate"
    ],
    "demonstrates": [
        "demonstrate"
    ],
    "demonstrating": [
        "demonstrate"
    ],
    "footballs": [
        "football"
    ],
    "victims": [
        "victim"
    ],
    "cheaper": [
        "cheap"
    ],
    "cheapest": [
        "cheap"
    ],
    "screens": [
        "screen"
    ],
    "screened": [
        "screen"
    ],
    "screening": [
        "screen"
    ],
    "dads": [
        "dad"
    ],
    "consumers": [
        "consumer"
    ],
    "stranger": [
        "strange"
    ],
    "strangest": [
        "strange"
    ],
    "broader": [
        "broad"
    ],
    "broadest": [
        "broad"
    ],
    "broads": [
        "broad"
    ],
    "readings": [
        "reading"
    ],
    "printed": [
        "print"
    ],
    "prints": [
        "print"
    ],
    "printing": [
        "print"
    ],
    "preferred": [
        "prefer"
    ],
    "preferring": [
        "prefer"
    ],
    "prefers": [
        "prefer"
    ],
    "chemicals": [
        "chemical"
    ],
    "taped": [
        "tape"
    ],
    "taping": [
        "tape"
    ],
    "committed": [
        "commit"
    ],
    "committing": [
        "commit"
    ],
    "commits": [
        "commit"
    ],
    "russians": [
        "russian"
    ],
    "threatened": [
        "threaten"
    ],
    "threatening": [
        "threaten"
    ],
    "threatens": [
        "threaten"
    ],
    "manners": [
        "manner"
    ],
    "housings": [
        "housing"
    ],
    "tonights": [
        "tonight"
    ],
    "experiments": [
        "experiment"
    ],
    "experimenting": [
        "experiment"
    ],
    "experimented": [
        "experiment"
    ],
    "improvements": [
        "improvement"
    ],
    "quicker": [
        "quick"
    ],
    "quickest": [
        "quick"
    ],
    "heated": [
        "heat"
    ],
    "heats": [
        "heat"
    ],
    "heating": [
        "heat"
    ],
    "channels": [
        "channel"
    ],
    "channelled": [
        "channel"
    ],
    "channelling": [
        "channel"
    ],
    "promoted": [
        "promote"
    ],
    "promoting": [
        "promote"
    ],
    "promotes": [
        "promote"
    ],
    "divided": [
        "divide"
    ],
    "dividing": [
        "divide"
    ],
    "divides": [
        "divide"
    ],
    "insisted": [
        "insist"
    ],
    "insists": [
        "insist"
    ],
    "insisting": [
        "insist"
    ],
    "bound": [
        "bind"
    ],
    "binding": [
        "bind"
    ],
    "binds": [
        "bind"
    ],
    "meals": [
        "meal"
    ],
    "quieter": [
        "quiet"
    ],
    "quietest": [
        "quiet"
    ],
    "quieted": [
        "quiet"
    ],
    "quieting": [
        "quiet"
    ],
    "religiouss": [
        "religious"
    ],
    "liberals": [
        "liberal"
    ],
    "retained": [
        "retain"
    ],
    "retaining": [
        "retain"
    ],
    "retains": [
        "retain"
    ],
    "appearances": [
        "appearance"
    ],
    "outputs": [
        "output"
    ],
    "outputting": [
        "output"
    ],
    "output": [
        "output"
    ],
    "sheets": [
        "sheet"
    ],
    "sheeted": [
        "sheet"
    ],
    "sheeting": [
        "sheet"
    ],
    "unemployments": [
        "unemployment"
    ],
    "rejected": [
        "reject"
    ],
    "rejecting": [
        "reject"
    ],
    "rejects": [
        "reject"
    ],
    "pensioned": [
        "pension"
    ],
    "pensioning": [
        "pension"
    ],
    "coffees": [
        "coffee"
    ],
    "thankss": [
        "thanks"
    ],
    "switched": [
        "switch"
    ],
    "switches": [
        "switch"
    ],
    "switching": [
        "switch"
    ],
    "assets": [
        "asset"
    ],
    "incs": [
        "inc"
    ],
    "assessed": [
        "assess"
    ],
    "assessing": [
        "assess"
    ],
    "assesses": [
        "assess"
    ],
    "limiteds": [
        "limited"
    ],
    "consists": [
        "consist"
    ],
    "consisted": [
        "consist"
    ],
    "consisting": [
        "consist"
    ],
    "softer": [
        "soft"
    ],
    "softest": [
        "soft"
    ],
    "photographs": [
        "photograph"
    ],
    "photographed": [
        "photograph"
    ],
    "photographing": [
        "photograph"
    ],
    "nursed": [
        "nurse"
    ],
    "formals": [
        "formal"
    ],
    "delivered": [
        "deliver"
    ],
    "delivering": [
        "deliver"
    ],
    "delivers": [
        "deliver"
    ],
    "plated": [
        "plate"
    ],
    "plating": [
        "plate"
    ],
    "packed": [
        "pack"
    ],
    "packing": [
        "pack"
    ],
    "mountains": [
        "mountain"
    ],
    "hidden": [
        "hide"
    ],
    "hiding": [
        "hide"
    ],
    "hid": [
        "hide"
    ],
    "hides": [
        "hide"
    ],
    "attracted": [
        "attract"
    ],
    "attracting": [
        "attract"
    ],
    "attracts": [
        "attract"
    ],
    "protests": [
        "protest"
    ],
    "protested": [
        "protest"
    ],
    "protesting": [
        "protest"
    ],
    "freedoms": [
        "freedom"
    ],
    "contributed": [
        "contribute"
    ],
    "contributing": [
        "contribute"
    ],
    "contributes": [
        "contribute"
    ],
    "narrowed": [
        "narrow"
    ],
    "narrower": [
        "narrow"
    ],
    "narrowing": [
        "narrow"
    ],
    "narrows": [
        "narrow"
    ],
    "narrowest": [
        "narrow"
    ],
    "dinners": [
        "dinner"
    ],
    "varied": [
        "vary"
    ],
    "varying": [
        "vary"
    ],
    "writings": [
        "writing"
    ],
    "explanations": [
        "explanation"
    ],
    "mistakes": [
        "mistake"
    ],
    "mistaken": [
        "mistake"
    ],
    "mistaking": [
        "mistake"
    ],
    "mistook": [
        "mistake"
    ],
    "flights": [
        "flight"
    ],
    "tripped": [
        "trip"
    ],
    "tripping": [
        "trip"
    ],
    "arrested": [
        "arrest"
    ],
    "arrests": [
        "arrest"
    ],
    "arresting": [
        "arrest"
    ],
    "institutes": [
        "institute"
    ],
    "instituted": [
        "institute"
    ],
    "instituting": [
        "institute"
    ],
    "imposed": [
        "impose"
    ],
    "imposing": [
        "impose"
    ],
    "maps": [
        "map"
    ],
    "mapped": [
        "map"
    ],
    "mapping": [
        "map"
    ],
    "youths": [
        "youth"
    ],
    "capacities": [
        "capacity"
    ],
    "examinations": [
        "examination"
    ],
    "shouted": [
        "shout"
    ],
    "shouting": [
        "shout"
    ],
    "shouts": [
        "shout"
    ],
    "belonged": [
        "belong"
    ],
    "belonging": [
        "belong"
    ],
    "belongs": [
        "belong"
    ],
    "loveliest": [
        "lovely"
    ],
    "lovelier": [
        "lovely"
    ],
    "lovelies": [
        "lovely"
    ],
    "victories": [
        "victory"
    ],
    "surprised": [
        "surprise"
    ],
    "surprising": [
        "surprise"
    ],
    "aircrafts": [
        "aircraft"
    ],
    "invited": [
        "invite"
    ],
    "inviting": [
        "invite"
    ],
    "briefed": [
        "brief"
    ],
    "briefs": [
        "brief"
    ],
    "briefest": [
        "brief"
    ],
    "recalled": [
        "recall"
    ],
    "recalls": [
        "recall"
    ],
    "recalling": [
        "recall"
    ],
    "glanced": [
        "glance"
    ],
    "glancing": [
        "glance"
    ],
    "glances": [
        "glance"
    ],
    "lips": [
        "lip"
    ],
    "lipped": [
        "lip"
    ],
    "xes": [
        "x"
    ],
    "emptied": [
        "empty"
    ],
    "emptying": [
        "empty"
    ],
    "empties": [
        "empty"
    ],
    "emptier": [
        "empty"
    ],
    "emptiest": [
        "empty"
    ],
    "crowds": [
        "crowd"
    ],
    "crowded": [
        "crowd"
    ],
    "crowding": [
        "crowd"
    ],
    "loads": [
        "load"
    ],
    "loaded": [
        "load"
    ],
    "loading": [
        "load"
    ],
    "laden": [
        "load",
        "laden"
    ],
    "programs": [
        "program"
    ],
    "locked": [
        "lock"
    ],
    "locks": [
        "lock"
    ],
    "locking": [
        "lock"
    ],
    "leadings": [
        "leading"
    ],
    "declared": [
        "declare"
    ],
    "declaring": [
        "declare"
    ],
    "warned": [
        "warn"
    ],
    "warns": [
        "warn"
    ],
    "eggs": [
        "egg"
    ],
    "egged": [
        "egg"
    ],
    "egging": [
        "egg",
        "eg"
    ],
    "registered": [
        "register"
    ],
    "registers": [
        "register"
    ],
    "registering": [
        "register"
    ],
    "kidding": [
        "kid"
    ],
    "kidded": [
        "kid"
    ],
    "factories": [
        "factory"
    ],
    "ontos": [
        "onto"
    ],
    "fourths": [
        "fourth"
    ],
    "signals": [
        "signal"
    ],
    "signalled": [
        "signal"
    ],
    "signalling": [
        "signal"
    ],
    "cooking": [
        "cook"
    ],
    "cooked": [
        "cook"
    ],
    "cooks": [
        "cook"
    ],
    "reserved": [
        "reserve"
    ],
    "reserving": [
        "reserve"
    ],
    "phased": [
        "phase"
    ],
    "phasing": [
        "phase"
    ],
    "brighter": [
        "bright"
    ],
    "brightest": [
        "bright"
    ],
    "stretched": [
        "stretch"
    ],
    "stretches": [
        "stretch"
    ],
    "castles": [
        "castle"
    ],
    "singing": [
        "sing"
    ],
    "sung": [
        "sing"
    ],
    "sings": [
        "sing"
    ],
    "climbed": [
        "climb"
    ],
    "climbing": [
        "climb"
    ],
    "climbs": [
        "climb"
    ],
    "destroyed": [
        "destroy"
    ],
    "destroying": [
        "destroy"
    ],
    "destroys": [
        "destroy"
    ],
    "combined": [
        "combine"
    ],
    "combining": [
        "combine"
    ],
    "opposites": [
        "opposite"
    ],
    "edinburghs": [
        "edinburgh"
    ],
    "nodded": [
        "nod"
    ],
    "nodding": [
        "nod"
    ],
    "nods": [
        "nod"
    ],
    "acids": [
        "acid"
    ],
    "offences": [
        "offence"
    ],
    "pariss": [
        "paris"
    ],
    "slipped": [
        "slip"
    ],
    "slipping": [
        "slip"
    ],
    "jumped": [
        "jump"
    ],
    "jumps": [
        "jump"
    ],
    "growings": [
        "growing"
    ],
    "burned": [
        "burn"
    ],
    "burning": [
        "burn"
    ],
    "burnt": [
        "burn"
    ],
    "burns": [
        "burn"
    ],
    "crowned": [
        "crown"
    ],
    "crowns": [
        "crown"
    ],
    "crowning": [
        "crown"
    ],
    "errors": [
        "error"
    ],
    "appointments": [
        "appointment"
    ],
    "delayed": [
        "delay"
    ],
    "delays": [
        "delay"
    ],
    "delaying": [
        "delay"
    ],
    "undertaken": [
        "undertake"
    ],
    "undertaking": [
        "undertake"
    ],
    "undertook": [
        "undertake"
    ],
    "undertakes": [
        "undertake"
    ],
    "nobodies": [
        "nobody"
    ],
    "criminals": [
        "criminal"
    ],
    "enterprises": [
        "enterprise"
    ],
    "perfected": [
        "perfect"
    ],
    "perfecting": [
        "perfect"
    ],
    "perfects": [
        "perfect"
    ],
    "recommended": [
        "recommend"
    ],
    "recommends": [
        "recommend"
    ],
    "recommending": [
        "recommend"
    ],
    "weapons": [
        "weapon"
    ],
    "irishes": [
        "irish"
    ],
    "weathered": [
        "weather"
    ],
    "weathers": [
        "weather"
    ],
    "weathering": [
        "weather"
    ],
    "births": [
        "birth"
    ],
    "settlements": [
        "settlement"
    ],
    "teachings": [
        "teaching"
    ],
    "assemblies": [
        "assembly"
    ],
    "bottles": [
        "bottle"
    ],
    "bottled": [
        "bottle"
    ],
    "bottling": [
        "bottle"
    ],
    "recognized": [
        "recognize"
    ],
    "recognizing": [
        "recognize"
    ],
    "recognizes": [
        "recognize"
    ],
    "pools": [
        "pool"
    ],
    "pooling": [
        "pool"
    ],
    "pooled": [
        "pool"
    ],
    "criticisms": [
        "criticism"
    ],
    "silenced": [
        "silence"
    ],
    "silencing": [
        "silence"
    ],
    "commands": [
        "command"
    ],
    "commanded": [
        "command"
    ],
    "commanding": [
        "command"
    ],
    "wilder": [
        "wild"
    ],
    "wildest": [
        "wild"
    ],
    "wilds": [
        "wild"
    ],
    "recognitions": [
        "recognition"
    ],
    "bishops": [
        "bishop"
    ],
    "defeated": [
        "defeat"
    ],
    "defeats": [
        "defeat"
    ],
    "defeating": [
        "defeat"
    ],
    "jacked": [
        "jack"
    ],
    "jacking": [
        "jack"
    ],
    "sequenced": [
        "sequence"
    ],
    "sequencing": [
        "sequence"
    ],
    "exported": [
        "export"
    ],
    "exporting": [
        "export"
    ],
    "expenditures": [
        "expenditure"
    ],
    "republics": [
        "republic"
    ],
    "thinner": [
        "thin"
    ],
    "thinning": [
        "thin"
    ],
    "thinned": [
        "thin"
    ],
    "thinnest": [
        "thin"
    ],
    "thins": [
        "thin"
    ],
    "necks": [
        "neck"
    ],
    "necking": [
        "neck"
    ],
    "necked": [
        "neck"
    ],
    "mixed": [
        "mix"
    ],
    "mixing": [
        "mix"
    ],
    "captains": [
        "captain"
    ],
    "captained": [
        "captain"
    ],
    "captaining": [
        "captain"
    ],
    "households": [
        "household"
    ],
    "fridays": [
        "friday"
    ],
    "morals": [
        "moral"
    ],
    "bedrooms": [
        "bedroom"
    ],
    "treaties": [
        "treaty"
    ],
    "guests": [
        "guest"
    ],
    "guesting": [
        "guest"
    ],
    "guested": [
        "guest"
    ],
    "indexes": [
        "index"
    ],
    "indexed": [
        "index"
    ],
    "indexing": [
        "index"
    ],
    "greys": [
        "grey"
    ],
    "greying": [
        "grey"
    ],
    "greyed": [
        "grey"
    ],
    "greyer": [
        "grey"
    ],
    "greyest": [
        "grey"
    ],
    "familiars": [
        "familiar"
    ],
    "journeys": [
        "journey"
    ],
    "journeyed": [
        "journey"
    ],
    "journeying": [
        "journey"
    ],
    "pleasures": [
        "pleasure"
    ],
    "pleasuring": [
        "pleasure"
    ],
    "academics": [
        "academic"
    ],
    "curriculums": [
        "curriculum"
    ],
    "ears": [
        "ear"
    ],
    "circles": [
        "circle"
    ],
    "circled": [
        "circle"
    ],
    "circling": [
        "circle"
    ],
    "unlikeliest": [
        "unlikely"
    ],
    "borders": [
        "border"
    ],
    "bordering": [
        "border"
    ],
    "bordered": [
        "border"
    ],
    "concluded": [
        "conclude"
    ],
    "concludes": [
        "conclude"
    ],
    "concluding": [
        "conclude"
    ],
    "organised": [
        "organise"
    ],
    "organising": [
        "organise"
    ],
    "specialists": [
        "specialist"
    ],
    "metals": [
        "metal"
    ],
    "fashioned": [
        "fashion"
    ],
    "fashions": [
        "fashion"
    ],
    "fashioning": [
        "fashion"
    ],
    "tastes": [
        "taste"
    ],
    "tasted": [
        "taste"
    ],
    "tasting": [
        "taste"
    ],
    "washed": [
        "wash"
    ],
    "washing": [
        "wash"
    ],
    "washes": [
        "wash"
    ],
    "congresses": [
        "congress"
    ],
    "brains": [
        "brain"
    ],
    "braining": [
        "brain"
    ],
    "brained": [
        "brain"
    ],
    "scientists": [
        "scientist"
    ],
    "favourites": [
        "favourite"
    ],
    "assumptions": [
        "assumption"
    ],
    "illustrated": [
        "illustrate"
    ],
    "illustrates": [
        "illustrate"
    ],
    "illustrating": [
        "illustrate"
    ],
    "mondays": [
        "monday"
    ],
    "implies": [
        "imply"
    ],
    "implied": [
        "imply"
    ],
    "implying": [
        "imply"
    ],
    "realized": [
        "realize"
    ],
    "realizing": [
        "realize"
    ],
    "realizes": [
        "realize"
    ],
    "liverpools": [
        "liverpool"
    ],
    "chinas": [
        "china"
    ],
    "jesuss": [
        "jesus"
    ],
    "smoked": [
        "smoke"
    ],
    "smokes": [
        "smoke"
    ],
    "ministries": [
        "ministry"
    ],
    "guaranteed": [
        "guarantee"
    ],
    "guarantees": [
        "guarantee"
    ],
    "guaranteeing": [
        "guarantee"
    ],
    "openings": [
        "opening"
    ],
    "roots": [
        "root"
    ],
    "rooted": [
        "root"
    ],
    "rooting": [
        "root"
    ],
    "tills": [
        "till"
    ],
    "tilled": [
        "till"
    ],
    "tilling": [
        "till"
    ],
    "gunned": [
        "gun"
    ],
    "gunning": [
        "gun"
    ],
    "generated": [
        "generate"
    ],
    "generates": [
        "generate"
    ],
    "generating": [
        "generate"
    ],
    "learnings": [
        "learning"
    ],
    "investigated": [
        "investigate"
    ],
    "investigating": [
        "investigate"
    ],
    "investigates": [
        "investigate"
    ],
    "italians": [
        "italian"
    ],
    "galleries": [
        "gallery"
    ],
    "lanes": [
        "lane"
    ],
    "cats": [
        "cat"
    ],
    "communists": [
        "communist"
    ],
    "skied": [
        "sky",
        "ski"
    ],
    "valleys": [
        "valley"
    ],
    "lunched": [
        "lunch"
    ],
    "lunching": [
        "lunch"
    ],
    "uppers": [
        "upper"
    ],
    "prospects": [
        "prospect"
    ],
    "prospecting": [
        "prospect"
    ],
    "prospected": [
        "prospect"
    ],
    "fuels": [
        "fuel"
    ],
    "fuelled": [
        "fuel"
    ],
    "fuelling": [
        "fuel"
    ],
    "novels": [
        "novel"
    ],
    "remarks": [
        "remark"
    ],
    "remarked": [
        "remark"
    ],
    "remarking": [
        "remark"
    ],
    "priorities": [
        "priority"
    ],
    "combinations": [
        "combination"
    ],
    "contemporaries": [
        "contemporary"
    ],
    "busiest": [
        "busy"
    ],
    "busied": [
        "busy"
    ],
    "busier": [
        "busy"
    ],
    "busying": [
        "busy"
    ],
    "busies": [
        "busy"
    ],
    "troops": [
        "troop"
    ],
    "trooped": [
        "troop"
    ],
    "trooping": [
        "troop"
    ],
    "motioned": [
        "motion"
    ],
    "motioning": [
        "motion"
    ],
    "relied": [
        "rely"
    ],
    "relying": [
        "rely"
    ],
    "tools": [
        "tool"
    ],
    "tooling": [
        "tool"
    ],
    "coals": [
        "coal"
    ],
    "fanned": [
        "fan"
    ],
    "fanning": [
        "fan"
    ],
    "disappeared": [
        "disappear"
    ],
    "disappearing": [
        "disappear"
    ],
    "disappears": [
        "disappear"
    ],
    "memberships": [
        "membership"
    ],
    "toms": [
        "tom"
    ],
    "advised": [
        "advise"
    ],
    "advising": [
        "advise"
    ],
    "advises": [
        "advise"
    ],
    "banned": [
        "ban"
    ],
    "banning": [
        "ban"
    ],
    "noised": [
        "noise"
    ],
    "tiniest": [
        "tiny"
    ],
    "tinier": [
        "tiny"
    ],
    "tinies": [
        "tiny"
    ],
    "gated": [
        "gate"
    ],
    "gating": [
        "gate"
    ],
    "earned": [
        "earn"
    ],
    "earning": [
        "earn"
    ],
    "earns": [
        "earn"
    ],
    "motors": [
        "motor"
    ],
    "motored": [
        "motor"
    ],
    "motoring": [
        "motor"
    ],
    "proceeds": [
        "proceed"
    ],
    "proceeded": [
        "proceed"
    ],
    "proceeding": [
        "proceed"
    ],
    "witnesses": [
        "witness"
    ],
    "witnessed": [
        "witness"
    ],
    "witnessing": [
        "witness"
    ],
    "succeeded": [
        "succeed"
    ],
    "succeeds": [
        "succeed"
    ],
    "succeeding": [
        "succeed"
    ],
    "wings": [
        "wing"
    ],
    "winging": [
        "wing"
    ],
    "winged": [
        "wing"
    ],
    "criteria": [
        "criterion"
    ],
    "faiths": [
        "faith"
    ],
    "deputies": [
        "deputy"
    ],
    "informed": [
        "inform"
    ],
    "informing": [
        "inform"
    ],
    "informs": [
        "inform"
    ],
    "knocked": [
        "knock"
    ],
    "knocking": [
        "knock"
    ],
    "knocks": [
        "knock"
    ],
    "afforded": [
        "afford"
    ],
    "affords": [
        "afford"
    ],
    "affording": [
        "afford"
    ],
    "approved": [
        "approve"
    ],
    "approving": [
        "approve"
    ],
    "approves": [
        "approve"
    ],
    "professors": [
        "professor"
    ],
    "shutting": [
        "shut"
    ],
    "shuts": [
        "shut"
    ],
    "smells": [
        "smell"
    ],
    "smelt": [
        "smell"
    ],
    "smelled": [
        "smell"
    ],
    "smelling": [
        "smell"
    ],
    "reminded": [
        "remind"
    ],
    "reminds": [
        "remind"
    ],
    "reminding": [
        "remind"
    ],
    "elected": [
        "elect"
    ],
    "electing": [
        "elect"
    ],
    "elects": [
        "elect"
    ],
    "suspected": [
        "suspect"
    ],
    "suspecting": [
        "suspect"
    ],
    "soldiers": [
        "soldier"
    ],
    "soldiering": [
        "soldier"
    ],
    "soldiered": [
        "soldier"
    ],
    "leaned": [
        "lean"
    ],
    "leaning": [
        "lean"
    ],
    "leant": [
        "lean"
    ],
    "leans": [
        "lean"
    ],
    "leaner": [
        "lean"
    ],
    "marrieds": [
        "married"
    ],
    "coping": [
        "cope"
    ],
    "coped": [
        "cope"
    ],
    "copes": [
        "cope"
    ],
    "hurts": [
        "hurt"
    ],
    "hurting": [
        "hurt"
    ],
    "winners": [
        "winner"
    ],
    "indians": [
        "indian"
    ],
    "tones": [
        "tone"
    ],
    "toned": [
        "tone"
    ],
    "toning": [
        "ton",
        "tone"
    ],
    "chains": [
        "chain"
    ],
    "chained": [
        "chain"
    ],
    "chaining": [
        "chain"
    ],
    "ironed": [
        "iron"
    ],
    "ironing": [
        "iron"
    ],
    "literatures": [
        "literature"
    ],
    "kicked": [
        "kick"
    ],
    "kicking": [
        "kick"
    ],
    "principals": [
        "principal"
    ],
    "disputed": [
        "dispute"
    ],
    "disputing": [
        "dispute"
    ],
    "teeth": [
        "tooth"
    ],
    "kissed": [
        "kiss"
    ],
    "kissing": [
        "kiss"
    ],
    "kisses": [
        "kiss"
    ],
    "shocked": [
        "shock"
    ],
    "shocks": [
        "shock"
    ],
    "leafing": [
        "leaf"
    ],
    "leafed": [
        "leaf"
    ],
    "leafs": [
        "leaf"
    ],
    "ayes": [
        "aye"
    ],
    "derived": [
        "derive"
    ],
    "deriving": [
        "derive"
    ],
    "guards": [
        "guard"
    ],
    "guarded": [
        "guard"
    ],
    "guarding": [
        "guard"
    ],
    "hells": [
        "hell"
    ],
    "hed": [
        "h"
    ],
    "hs": [
        "h"
    ],
    "italies": [
        "italy"
    ],
    "hated": [
        "hate"
    ],
    "hating": [
        "hate"
    ],
    "lakes": [
        "lake"
    ],
    "foundations": [
        "foundation"
    ],
    "vitals": [
        "vital"
    ],
    "minors": [
        "minor"
    ],
    "tallest": [
        "tall"
    ],
    "frames": [
        "frame"
    ],
    "framed": [
        "frame"
    ],
    "framing": [
        "frame"
    ],
    "bids": [
        "bid"
    ],
    "bidding": [
        "bid"
    ],
    "bade": [
        "bid"
    ],
    "bidden": [
        "bid"
    ],
    "bid": [
        "bid"
    ],
    "fruiting": [
        "fruit"
    ],
    "fruited": [
        "fruit"
    ],
    "ills": [
        "ill"
    ],
    "blamed": [
        "blame"
    ],
    "blaming": [
        "blame"
    ],
    "manchesters": [
        "manchester"
    ],
    "comparisons": [
        "comparison"
    ],
    "quoted": [
        "quote"
    ],
    "quotes": [
        "quote"
    ],
    "quoting": [
        "quote"
    ],
    "casts": [
        "cast"
    ],
    "devices": [
        "device"
    ],
    "persuaded": [
        "persuade"
    ],
    "persuading": [
        "persuade"
    ],
    "guys": [
        "guy"
    ],
    "funs": [
        "fun"
    ],
    "mps": [
        "mp"
    ],
    "fellows": [
        "fellow"
    ],
    "recovered": [
        "recover"
    ],
    "recovering": [
        "recover"
    ],
    "recovers": [
        "recover"
    ],
    "coasts": [
        "coast"
    ],
    "coasting": [
        "coast"
    ],
    "coasted": [
        "coast"
    ],
    "thicker": [
        "thick"
    ],
    "thickest": [
        "thick"
    ],
    "bonded": [
        "bond"
    ],
    "bonding": [
        "bond"
    ],
    "breaths": [
        "breath"
    ],
    "shots": [
        "shot"
    ],
    "woke": [
        "wake"
    ],
    "woken": [
        "wake"
    ],
    "waking": [
        "wake"
    ],
    "wakes": [
        "wake"
    ],
    "waked": [
        "wake"
    ],
    "ancients": [
        "ancient"
    ],
    "usas": [
        "usa"
    ],
    "soils": [
        "soil"
    ],
    "soiled": [
        "soil"
    ],
    "soiling": [
        "soil"
    ],
    "gathered": [
        "gather"
    ],
    "gathering": [
        "gather"
    ],
    "gathers": [
        "gather"
    ],
    "australias": [
        "australia"
    ],
    "championed": [
        "champion"
    ],
    "championing": [
        "champion"
    ],
    "externals": [
        "external"
    ],
    "rarer": [
        "rare"
    ],
    "rarest": [
        "rare"
    ],
    "raring": [
        "rare"
    ],
    "engineerings": [
        "engineering"
    ],
    "negatived": [
        "negative"
    ],
    "grander": [
        "grand"
    ],
    "grandest": [
        "grand"
    ],
    "mechanisms": [
        "mechanism"
    ],
    "silvered": [
        "silver"
    ],
    "silvering": [
        "silver"
    ],
    "silvers": [
        "silver"
    ],
    "opposed": [
        "oppose"
    ],
    "opposing": [
        "oppose"
    ],
    "elderlies": [
        "elderly"
    ],
    "permitted": [
        "permit"
    ],
    "permits": [
        "permit"
    ],
    "permitting": [
        "permit"
    ],
    "milked": [
        "milk"
    ],
    "milking": [
        "milk"
    ],
    "milks": [
        "milk"
    ],
    "rents": [
        "rent"
    ],
    "rented": [
        "rent"
    ],
    "renting": [
        "rent"
    ],
    "porting": [
        "port"
    ],
    "ported": [
        "port"
    ],
    "defendants": [
        "defendant"
    ],
    "panels": [
        "panel"
    ],
    "panelled": [
        "panel"
    ],
    "panelling": [
        "panel"
    ],
    "cooling": [
        "cool"
    ],
    "cooled": [
        "cool"
    ],
    "cooler": [
        "cool"
    ],
    "cools": [
        "cool"
    ],
    "coolest": [
        "cool"
    ],
    "africans": [
        "african"
    ],
    "neighbours": [
        "neighbour"
    ],
    "abused": [
        "abuse"
    ],
    "abusing": [
        "abuse"
    ],
    "liabilities": [
        "liability"
    ],
    "pockets": [
        "pocket"
    ],
    "pocketing": [
        "pocket",
        "pockete"
    ],
    "pocketed": [
        "pocket",
        "pockete"
    ],
    "secondaries": [
        "secondary"
    ],
    "championships": [
        "championship"
    ],
    "attached": [
        "attach"
    ],
    "attaching": [
        "attach"
    ],
    "diets": [
        "diet"
    ],
    "dieting": [
        "diet"
    ],
    "dieted": [
        "diet"
    ],
    "leedss": [
        "leeds"
    ],
    "engineers": [
        "engineer"
    ],
    "engineered": [
        "engineer"
    ],
    "leaderships": [
        "leadership"
    ],
    "fatter": [
        "fat"
    ],
    "fattest": [
        "fat"
    ],
    "negotiations": [
        "negotiation"
    ],
    "welfares": [
        "welfare"
    ],
    "priors": [
        "prior"
    ],
    "plenties": [
        "plenty"
    ],
    "fixed": [
        "fix"
    ],
    "camped": [
        "camp"
    ],
    "sharps": [
        "sharp"
    ],
    "sharper": [
        "sharpe",
        "sharp"
    ],
    "sharpest": [
        "sharpe",
        "sharp"
    ],
    "establishments": [
        "establishment"
    ],
    "explored": [
        "explore"
    ],
    "exploring": [
        "explore"
    ],
    "tips": [
        "tip"
    ],
    "tipped": [
        "tip"
    ],
    "tipping": [
        "tip"
    ],
    "roofs": [
        "roof"
    ],
    "roofed": [
        "roof"
    ],
    "roofing": [
        "roof"
    ],
    "deposits": [
        "deposit"
    ],
    "deposited": [
        "deposit"
    ],
    "depositing": [
        "deposit"
    ],
    "outlined": [
        "outline"
    ],
    "outlines": [
        "outline"
    ],
    "outlining": [
        "outline"
    ],
    "trends": [
        "trend"
    ],
    "trending": [
        "trend"
    ],
    "meanwhiles": [
        "meanwhile"
    ],
    "beaches": [
        "beach"
    ],
    "beached": [
        "beach"
    ],
    "beaching": [
        "beach"
    ],
    "shoes": [
        "shoe"
    ],
    "shod": [
        "shoe"
    ],
    "shoeing": [
        "shoe"
    ],
    "shodden": [
        "shoe"
    ],
    "accused": [
        "accuse"
    ],
    "accusing": [
        "accuse"
    ],
    "rushed": [
        "rush"
    ],
    "rushing": [
        "rush"
    ],
    "origins": [
        "origin"
    ],
    "accompanied": [
        "accompany"
    ],
    "accompanying": [
        "accompany"
    ],
    "accompanies": [
        "accompany"
    ],
    "entires": [
        "entire"
    ],
    "drawings": [
        "drawing"
    ],
    "catholics": [
        "catholic"
    ],
    "coaching": [
        "coach"
    ],
    "coached": [
        "coach"
    ],
    "expenses": [
        "expense"
    ],
    "constructed": [
        "construct"
    ],
    "constructing": [
        "construct"
    ],
    "constructs": [
        "construct"
    ],
    "excluded": [
        "exclude"
    ],
    "excluding": [
        "exclude"
    ],
    "excludes": [
        "exclude"
    ],
    "joness": [
        "jones"
    ],
    "swung": [
        "swing"
    ],
    "swinging": [
        "swing"
    ],
    "paused": [
        "pause"
    ],
    "pausing": [
        "pause"
    ],
    "popped": [
        "pop"
    ],
    "pops": [
        "pop"
    ],
    "popping": [
        "pop"
    ],
    "heights": [
        "height"
    ],
    "splitting": [
        "split"
    ],
    "splits": [
        "split"
    ],
    "fundamentals": [
        "fundamental"
    ],
    "significances": [
        "significance"
    ],
    "mirrors": [
        "mirror"
    ],
    "mirrored": [
        "mirror"
    ],
    "mirroring": [
        "mirror"
    ],
    "urged": [
        "urge"
    ],
    "urging": [
        "urge"
    ],
    "urges": [
        "urge"
    ],
    "honours": [
        "honour"
    ],
    "honoured": [
        "honour"
    ],
    "honouring": [
        "honour"
    ],
    "charities": [
        "charity"
    ],
    "editors": [
        "editor"
    ],
    "railed": [
        "rail"
    ],
    "railing": [
        "rail"
    ],
    "vaster": [
        "vast"
    ],
    "vastest": [
        "vast"
    ],
    "withdrawn": [
        "withdraw"
    ],
    "withdrew": [
        "withdraw"
    ],
    "withdrawing": [
        "withdraw"
    ],
    "withdraws": [
        "withdraw"
    ],
    "outcomes": [
        "outcome"
    ],
    "wheels": [
        "wheel"
    ],
    "wheeled": [
        "wheel"
    ],
    "wheeling": [
        "wheel"
    ],
    "severest": [
        "severe"
    ],
    "severer": [
        "severe"
    ],
    "labelled": [
        "label"
    ],
    "labelling": [
        "label"
    ],
    "labeled": [
        "label"
    ],
    "stolen": [
        "steal"
    ],
    "stole": [
        "steal"
    ],
    "stealing": [
        "steal"
    ],
    "steals": [
        "steal"
    ],
    "citizens": [
        "citizen"
    ],
    "corporates": [
        "corporate"
    ],
    "gifted": [
        "gift"
    ],
    "gifting": [
        "gift"
    ],
    "bones": [
        "bone"
    ],
    "boning": [
        "bone"
    ],
    "boned": [
        "bone"
    ],
    "monitored": [
        "monitor"
    ],
    "monitors": [
        "monitor"
    ],
    "bombs": [
        "bomb"
    ],
    "bombed": [
        "bomb"
    ],
    "bombing": [
        "bomb"
    ],
    "achievements": [
        "achievement"
    ],
    "oohs": [
        "ooh"
    ],
    "pursued": [
        "pursue"
    ],
    "pursuing": [
        "pursue"
    ],
    "pursues": [
        "pursue"
    ],
    "expectations": [
        "expectation"
    ],
    "cycling": [
        "cycle"
    ],
    "cycled": [
        "cycle"
    ],
    "enemies": [
        "enemy"
    ],
    "plainer": [
        "plain"
    ],
    "plainest": [
        "plain"
    ],
    "scheduled": [
        "schedule"
    ],
    "schedules": [
        "schedule"
    ],
    "scheduling": [
        "schedule"
    ],
    "noses": [
        "nose"
    ],
    "nosed": [
        "nose"
    ],
    "nosing": [
        "nose"
    ],
    "parishes": [
        "parish"
    ],
    "manufacturers": [
        "manufacturer"
    ],
    "tenanted": [
        "tenant"
    ],
    "bobbing": [
        "bob"
    ],
    "bobbed": [
        "bob"
    ],
    "guessed": [
        "guess"
    ],
    "guessing": [
        "guess"
    ],
    "guesses": [
        "guess"
    ],
    "funniest": [
        "funny"
    ],
    "funnier": [
        "funny"
    ],
    "funnies": [
        "funny"
    ],
    "radicals": [
        "radical"
    ],
    "prisoners": [
        "prisoner"
    ],
    "collapsed": [
        "collapse"
    ],
    "collapsing": [
        "collapse"
    ],
    "collapses": [
        "collapse"
    ],
    "justified": [
        "justify"
    ],
    "justifying": [
        "justify"
    ],
    "lessons": [
        "lesson"
    ],
    "democracies": [
        "democracy"
    ],
    "lawyers": [
        "lawyer"
    ],
    "inflations": [
        "inflation"
    ],
    "complaints": [
        "complaint"
    ],
    "bushes": [
        "bush"
    ],
    "bushed": [
        "bush"
    ],
    "surrounded": [
        "surround"
    ],
    "surrounding": [
        "surround"
    ],
    "surrounds": [
        "surround"
    ],
    "planing": [
        "plane"
    ],
    "planed": [
        "plane"
    ],
    "councillors": [
        "councillor"
    ],
    "wednesdays": [
        "wednesday"
    ],
    "baths": [
        "bath"
    ],
    "bathing": [
        "bathe",
        "bath",
        "bthe"
    ],
    "bathed": [
        "bathe",
        "bath"
    ],
    "passengers": [
        "passenger"
    ],
    "territories": [
        "territory"
    ],
    "findings": [
        "finding"
    ],
    "spains": [
        "spain"
    ],
    "yellows": [
        "yellow"
    ],
    "yellower": [
        "yellow"
    ],
    "yellowest": [
        "yellow"
    ],
    "yellowing": [
        "yellow"
    ],
    "yellowed": [
        "yellow"
    ],
    "beings": [
        "being"
    ],
    "licenced": [
        "licence"
    ],
    "imported": [
        "import"
    ],
    "importing": [
        "import"
    ],
    "weaker": [
        "weak"
    ],
    "weakest": [
        "weak"
    ],
    "abandoned": [
        "abandon"
    ],
    "abandoning": [
        "abandon"
    ],
    "traced": [
        "trace"
    ],
    "tracing": [
        "trace"
    ],
    "desks": [
        "desk"
    ],
    "independences": [
        "independence"
    ],
    "breakfasted": [
        "breakfast"
    ],
    "breakfasting": [
        "breakfast"
    ],
    "owed": [
        "owe"
    ],
    "owing": [
        "owe"
    ],
    "owes": [
        "owe"
    ],
    "coats": [
        "coat"
    ],
    "coated": [
        "coat"
    ],
    "coating": [
        "coat"
    ],
    "gaps": [
        "gap"
    ],
    "strung": [
        "string"
    ],
    "stringing": [
        "string"
    ],
    "lotss": [
        "lots"
    ],
    "ranks": [
        "rank"
    ],
    "ranked": [
        "rank"
    ],
    "ranking": [
        "rank"
    ],
    "prizes": [
        "prize"
    ],
    "prized": [
        "prize"
    ],
    "prizing": [
        "prize"
    ],
    "accommodations": [
        "accommodation"
    ],
    "boundaries": [
        "boundary"
    ],
    "towers": [
        "tower"
    ],
    "towering": [
        "tower"
    ],
    "towered": [
        "tower"
    ],
    "sweets": [
        "sweet"
    ],
    "sweeter": [
        "sweet"
    ],
    "sweetest": [
        "sweet"
    ],
    "plastics": [
        "plastic"
    ],
    "implemented": [
        "implement"
    ],
    "implementing": [
        "implement"
    ],
    "implements": [
        "implement"
    ],
    "repairs": [
        "repair"
    ],
    "repaired": [
        "repair"
    ],
    "repairing": [
        "repair"
    ],
    "phrased": [
        "phrase"
    ],
    "phrasing": [
        "phrase"
    ],
    "yorkshires": [
        "yorkshire"
    ],
    "mills": [
        "mill"
    ],
    "milling": [
        "mill"
    ],
    "milled": [
        "mill"
    ],
    "occupied": [
        "occupy"
    ],
    "occupying": [
        "occupy"
    ],
    "occupies": [
        "occupy"
    ],
    "buyers": [
        "buyer"
    ],
    "mikes": [
        "mike"
    ],
    "unknowns": [
        "unknown"
    ],
    "connected": [
        "connect"
    ],
    "connecting": [
        "connect"
    ],
    "connects": [
        "connect"
    ],
    "sicker": [
        "sick"
    ],
    "sickest": [
        "sick"
    ],
    "columns": [
        "column"
    ],
    "harried": [
        "harry"
    ],
    "harrying": [
        "harry"
    ],
    "harries": [
        "harry"
    ],
    "knees": [
        "knee"
    ],
    "kneeing": [
        "knee"
    ],
    "kneed": [
        "knee"
    ],
    "crashed": [
        "crash"
    ],
    "crashing": [
        "crash"
    ],
    "appreciated": [
        "appreciate"
    ],
    "appreciating": [
        "appreciate"
    ],
    "appreciates": [
        "appreciate"
    ],
    "topics": [
        "topic"
    ],
    "databases": [
        "database"
    ],
    "resolved": [
        "resolve"
    ],
    "resolving": [
        "resolve"
    ],
    "annes": [
        "anne"
    ],
    "inquiries": [
        "inquiry"
    ],
    "hosts": [
        "host"
    ],
    "hosted": [
        "host"
    ],
    "hosting": [
        "host"
    ],
    "politicians": [
        "politician"
    ],
    "engaged": [
        "engage"
    ],
    "engaging": [
        "engage"
    ],
    "mounted": [
        "mount"
    ],
    "mounting": [
        "mount"
    ],
    "mounts": [
        "mount"
    ],
    "dominated": [
        "dominate"
    ],
    "dominates": [
        "dominate"
    ],
    "dominating": [
        "dominate"
    ],
    "pilots": [
        "pilot"
    ],
    "piloting": [
        "pilote",
        "pilot"
    ],
    "piloted": [
        "pilote",
        "pilot"
    ],
    "beauties": [
        "beauty"
    ],
    "grassed": [
        "grass"
    ],
    "grassing": [
        "grass"
    ],
    "eased": [
        "ease"
    ],
    "easing": [
        "ease"
    ],
    "eases": [
        "ease"
    ],
    "faults": [
        "fault"
    ],
    "faulted": [
        "fault"
    ],
    "faulting": [
        "fault"
    ],
    "russias": [
        "russia"
    ],
    "slid": [
        "slide"
    ],
    "slides": [
        "slide"
    ],
    "sliding": [
        "slide"
    ],
    "identities": [
        "identity"
    ],
    "drafted": [
        "draft"
    ],
    "drafting": [
        "draft"
    ],
    "drafts": [
        "draft"
    ],
    "proceedings": [
        "proceeding"
    ],
    "premises": [
        "premise"
    ],
    "premised": [
        "premise"
    ],
    "extremest": [
        "extreme"
    ],
    "bells": [
        "bell"
    ],
    "belled": [
        "bell"
    ],
    "unixes": [
        "unix"
    ],
    "currencies": [
        "currency"
    ],
    "incorporated": [
        "incorporate"
    ],
    "incorporating": [
        "incorporate"
    ],
    "incorporates": [
        "incorporate"
    ],
    "complained": [
        "complain"
    ],
    "complaining": [
        "complain"
    ],
    "complains": [
        "complain"
    ],
    "quantities": [
        "quantity"
    ],
    "sank": [
        "sink"
    ],
    "sunk": [
        "sink"
    ],
    "sinking": [
        "sink"
    ],
    "sinks": [
        "sink"
    ],
    "sunken": [
        "sink"
    ],
    "minorities": [
        "minority"
    ],
    "spokesmen": [
        "spokesman"
    ],
    "emergencies": [
        "emergency"
    ],
    "inputs": [
        "input"
    ],
    "inputting": [
        "input"
    ],
    "inputted": [
        "input"
    ],
    "interpreted": [
        "interpret"
    ],
    "interpreting": [
        "interpret"
    ],
    "interprets": [
        "interpret"
    ],
    "dismissed": [
        "dismiss"
    ],
    "dismissing": [
        "dismiss"
    ],
    "dismisses": [
        "dismiss"
    ],
    "inches": [
        "inch"
    ],
    "inched": [
        "inch"
    ],
    "inching": [
        "inch"
    ],
    "involvements": [
        "involvement"
    ],
    "glasgows": [
        "glasgow"
    ],
    "rewards": [
        "reward"
    ],
    "rewarded": [
        "reward"
    ],
    "rewarding": [
        "reward"
    ],
    "tensioned": [
        "tension"
    ],
    "polls": [
        "poll"
    ],
    "polled": [
        "poll"
    ],
    "polling": [
        "poll"
    ],
    "wards": [
        "ward"
    ],
    "warding": [
        "ward"
    ],
    "warded": [
        "ward"
    ],
    "jokes": [
        "joke"
    ],
    "joking": [
        "joke"
    ],
    "joked": [
        "joke"
    ],
    "bothered": [
        "bother"
    ],
    "bothering": [
        "bother"
    ],
    "bothers": [
        "bother"
    ],
    "altered": [
        "alter"
    ],
    "altering": [
        "alter"
    ],
    "alters": [
        "alter"
    ],
    "acknowledged": [
        "acknowledge"
    ],
    "acknowledges": [
        "acknowledge"
    ],
    "acknowledging": [
        "acknowledge"
    ],
    "rivals": [
        "rival"
    ],
    "rivalled": [
        "rival"
    ],
    "rivalling": [
        "rival"
    ],
    "gazed": [
        "gaze"
    ],
    "gazing": [
        "gaze"
    ],
    "partnerships": [
        "partnership"
    ],
    "thinkings": [
        "thinking"
    ],
    "expanded": [
        "expand"
    ],
    "expanding": [
        "expand"
    ],
    "expands": [
        "expand"
    ],
    "bent": [
        "bend"
    ],
    "bending": [
        "bend"
    ],
    "bends": [
        "bend"
    ],
    "steeled": [
        "steel"
    ],
    "steels": [
        "steel"
    ],
    "steeling": [
        "steel"
    ],
    "defending": [
        "defend"
    ],
    "defended": [
        "defend"
    ],
    "encountered": [
        "encounter"
    ],
    "encounters": [
        "encounter"
    ],
    "encountering": [
        "encounter"
    ],
    "booted": [
        "boot"
    ],
    "booting": [
        "boot"
    ],
    "analysed": [
        "analyse"
    ],
    "analysing": [
        "analyse"
    ],
    "franked": [
        "frank"
    ],
    "frankest": [
        "frank"
    ],
    "franker": [
        "frank"
    ],
    "franks": [
        "frank"
    ],
    "franking": [
        "frank"
    ],
    "classics": [
        "classic"
    ],
    "holders": [
        "holder"
    ],
    "proteins": [
        "protein"
    ],
    "calculated": [
        "calculate"
    ],
    "calculating": [
        "calculate"
    ],
    "calculates": [
        "calculate"
    ],
    "advertisings": [
        "advertising"
    ],
    "icing": [
        "ice"
    ],
    "ices": [
        "ice"
    ],
    "iced": [
        "ice"
    ],
    "deliveries": [
        "delivery"
    ],
    "wetter": [
        "wet"
    ],
    "wetting": [
        "wet"
    ],
    "wettest": [
        "wet"
    ],
    "wets": [
        "wet"
    ],
    "wetted": [
        "wet"
    ],
    "greeks": [
        "greek"
    ],
    "assisted": [
        "assist"
    ],
    "assisting": [
        "assist"
    ],
    "assists": [
        "assist"
    ],
    "converted": [
        "convert"
    ],
    "converting": [
        "convert"
    ],
    "converts": [
        "convert"
    ],
    "tighter": [
        "tight"
    ],
    "tights": [
        "tight"
    ],
    "tightest": [
        "tight"
    ],
    "consented": [
        "consent"
    ],
    "consents": [
        "consent"
    ],
    "consenting": [
        "consent"
    ],
    "savings": [
        "saving"
    ],
    "crews": [
        "crew"
    ],
    "crewed": [
        "crew"
    ],
    "crewing": [
        "crew"
    ],
    "frameworks": [
        "framework"
    ],
    "friendlier": [
        "friendly"
    ],
    "friendlies": [
        "friendly"
    ],
    "friendliest": [
        "friendly"
    ],
    "possessed": [
        "possess"
    ],
    "possessing": [
        "possess"
    ],
    "possesses": [
        "possess"
    ],
    "strains": [
        "strain"
    ],
    "strained": [
        "strain"
    ],
    "straining": [
        "strain"
    ],
    "angrier": [
        "angry"
    ],
    "angriest": [
        "angry"
    ],
    "angered": [
        "anger"
    ],
    "angers": [
        "anger"
    ],
    "angering": [
        "anger"
    ],
    "bossed": [
        "boss"
    ],
    "bossing": [
        "boss"
    ],
    "breaches": [
        "breach"
    ],
    "breached": [
        "breach"
    ],
    "breaching": [
        "breach"
    ],
    "depths": [
        "depth"
    ],
    "stabled": [
        "stable"
    ],
    "stabling": [
        "stable"
    ],
    "luckier": [
        "lucky"
    ],
    "luckiest": [
        "lucky"
    ],
    "peaks": [
        "peak"
    ],
    "peaked": [
        "peak"
    ],
    "peaking": [
        "peak"
    ],
    "tougher": [
        "tough"
    ],
    "toughest": [
        "tough"
    ],
    "toughs": [
        "tough"
    ],
    "refs": [
        "ref"
    ],
    "socialists": [
        "socialist"
    ],
    "behalves": [
        "behalf"
    ],
    "specified": [
        "specify"
    ],
    "specifying": [
        "specify"
    ],
    "approvals": [
        "approval"
    ],
    "landscapes": [
        "landscape"
    ],
    "landscaped": [
        "landscape"
    ],
    "landscaping": [
        "landscape"
    ],
    "fundings": [
        "funding"
    ],
    "governors": [
        "governor"
    ],
    "settings": [
        "setting"
    ],
    "wilsons": [
        "wilson"
    ],
    "poems": [
        "poem"
    ],
    "coes": [
        "coe",
        "co"
    ],
    "grahams": [
        "graham"
    ],
    "healthier": [
        "healthy"
    ],
    "healthiest": [
        "healthy"
    ],
    "maintenances": [
        "maintenance"
    ],
    "strips": [
        "strip"
    ],
    "stripped": [
        "strip"
    ],
    "stripping": [
        "strip"
    ],
    "conservations": [
        "conservation"
    ],
    "recommendations": [
        "recommendation"
    ],
    "restored": [
        "restore"
    ],
    "restoring": [
        "restore"
    ],
    "restores": [
        "restore"
    ],
    "paces": [
        "pace"
    ],
    "pacing": [
        "pace"
    ],
    "paced": [
        "pace"
    ],
    "preserved": [
        "preserve"
    ],
    "preserving": [
        "preserve"
    ],
    "chipped": [
        "chip"
    ],
    "chipping": [
        "chip"
    ],
    "restricted": [
        "restrict"
    ],
    "restricting": [
        "restrict"
    ],
    "restricts": [
        "restrict"
    ],
    "clouds": [
        "cloud"
    ],
    "clouded": [
        "cloud"
    ],
    "clouding": [
        "cloud"
    ],
    "reckoned": [
        "reckon"
    ],
    "reckons": [
        "reckon"
    ],
    "reckoning": [
        "reckon"
    ],
    "smoothed": [
        "smooth"
    ],
    "smoothing": [
        "smooth"
    ],
    "smoother": [
        "smooth"
    ],
    "smooths": [
        "smooth"
    ],
    "smoothest": [
        "smooth"
    ],
    "countrysides": [
        "countryside"
    ],
    "voluntaries": [
        "voluntary"
    ],
    "plaintiffs": [
        "plaintiff"
    ],
    "solids": [
        "solid"
    ],
    "recessions": [
        "recession"
    ],
    "layers": [
        "layer"
    ],
    "layered": [
        "layer"
    ],
    "layering": [
        "layer"
    ],
    "dependents": [
        "dependent"
    ],
    "distinguished": [
        "distinguish"
    ],
    "distinguishes": [
        "distinguish"
    ],
    "distinguishing": [
        "distinguish"
    ],
    "keener": [
        "keen"
    ],
    "keenest": [
        "keen"
    ],
    "keening": [
        "keen"
    ],
    "keened": [
        "keen"
    ],
    "keens": [
        "keen"
    ],
    "curves": [
        "curve"
    ],
    "curved": [
        "curve"
    ],
    "curving": [
        "curve"
    ],
    "shareholders": [
        "shareholder"
    ],
    "recoveries": [
        "recovery"
    ],
    "parallels": [
        "parallel"
    ],
    "paralleling": [
        "parallel"
    ],
    "paralleled": [
        "parallel",
        "parallele"
    ],
    "agricultures": [
        "agriculture"
    ],
    "sugars": [
        "sugar"
    ],
    "sugaring": [
        "sugar"
    ],
    "sugared": [
        "sugar"
    ],
    "tradings": [
        "trading"
    ],
    "constitutes": [
        "constitute"
    ],
    "constituted": [
        "constitute"
    ],
    "constituting": [
        "constitute"
    ],
    "dramatics": [
        "dramatic"
    ],
    "comforted": [
        "comfort"
    ],
    "comforts": [
        "comfort"
    ],
    "comforting": [
        "comfort"
    ],
    "excused": [
        "excuse"
    ],
    "excusing": [
        "excuse"
    ],
    "angled": [
        "angle"
    ],
    "angling": [
        "angle"
    ],
    "selves": [
        "self"
    ],
    "reversed": [
        "reverse"
    ],
    "reversing": [
        "reverse"
    ],
    "reverses": [
        "reverse"
    ],
    "temporaries": [
        "temporary"
    ],
    "asides": [
        "aside"
    ],
    "willings": [
        "willing"
    ],
    "submitted": [
        "submit"
    ],
    "submitting": [
        "submit"
    ],
    "submits": [
        "submit"
    ],
    "thursdays": [
        "thursday"
    ],
    "judgments": [
        "judgment"
    ],
    "piped": [
        "pipe"
    ],
    "piping": [
        "pipe"
    ],
    "slightest": [
        "slight"
    ],
    "slighter": [
        "slight"
    ],
    "slighted": [
        "slight"
    ],
    "slights": [
        "slight"
    ],
    "slighting": [
        "slight"
    ],
    "spells": [
        "spell"
    ],
    "spelt": [
        "spell"
    ],
    "spelled": [
        "spell"
    ],
    "spelling": [
        "spell"
    ],
    "yields": [
        "yield"
    ],
    "yielded": [
        "yield"
    ],
    "yielding": [
        "yield"
    ],
    "muscled": [
        "muscle"
    ],
    "muscling": [
        "muscle"
    ],
    "gladder": [
        "glad"
    ],
    "gladdest": [
        "glad"
    ],
    "wealths": [
        "wealth"
    ],
    "streams": [
        "stream"
    ],
    "streaming": [
        "stream"
    ],
    "streamed": [
        "stream"
    ],
    "certificates": [
        "certificate"
    ],
    "certificated": [
        "certificate"
    ],
    "certificating": [
        "certificate"
    ],
    "chests": [
        "chest"
    ],
    "chested": [
        "chest"
    ],
    "lewiss": [
        "lewis"
    ],
    "sailing": [
        "sail"
    ],
    "sailed": [
        "sail"
    ],
    "sails": [
        "sail"
    ],
    "pitched": [
        "pitch"
    ],
    "pitches": [
        "pitch"
    ],
    "pitching": [
        "pitch"
    ],
    "efficiencies": [
        "efficiency"
    ],
    "solved": [
        "solve"
    ],
    "solving": [
        "solve"
    ],
    "solves": [
        "solve"
    ],
    "lifespans": [
        "lifespan"
    ],
    "caked": [
        "cake"
    ],
    "caking": [
        "cake"
    ],
    "critics": [
        "critic"
    ],
    "laboratories": [
        "laboratory"
    ],
    "predicted": [
        "predict"
    ],
    "predicting": [
        "predict"
    ],
    "predicts": [
        "predict"
    ],
    "illnesses": [
        "illness"
    ],
    "hellos": [
        "hello"
    ],
    "lees": [
        "lee"
    ],
    "hats": [
        "hat"
    ],
    "hatted": [
        "hat"
    ],
    "arrivals": [
        "arrival"
    ],
    "highlighted": [
        "highlight"
    ],
    "highlights": [
        "highlight"
    ],
    "highlighting": [
        "highlight"
    ],
    "brushed": [
        "brush"
    ],
    "brushes": [
        "brush"
    ],
    "dramas": [
        "drama"
    ],
    "located": [
        "locate"
    ],
    "locating": [
        "locate"
    ],
    "locates": [
        "locate"
    ],
    "meats": [
        "meat"
    ],
    "snowing": [
        "snow"
    ],
    "snows": [
        "snow"
    ],
    "snowed": [
        "snow"
    ],
    "bays": [
        "bay"
    ],
    "baying": [
        "bay"
    ],
    "bayed": [
        "bay"
    ],
    "spendings": [
        "spending"
    ],
    "tackled": [
        "tackle"
    ],
    "tackling": [
        "tackle"
    ],
    "tackles": [
        "tackle"
    ],
    "symptoms": [
        "symptom"
    ],
    "breads": [
        "bread"
    ],
    "rapids": [
        "rapid"
    ],
    "blinds": [
        "blind"
    ],
    "blinded": [
        "blind"
    ],
    "blinding": [
        "blind"
    ],
    "customs": [
        "custom"
    ],
    "commonss": [
        "commons"
    ],
    "taylors": [
        "taylor"
    ],
    "lectured": [
        "lecture"
    ],
    "lecturing": [
        "lecture"
    ],
    "paler": [
        "pale"
    ],
    "paled": [
        "pale"
    ],
    "palest": [
        "pale"
    ],
    "paling": [
        "pale"
    ],
    "producers": [
        "producer"
    ],
    "tapped": [
        "tap"
    ],
    "taps": [
        "tap"
    ],
    "tapping": [
        "tap"
    ],
    "ratios": [
        "ratio"
    ],
    "js": [
        "j"
    ],
    "j'": [
        "je"
    ],
    "beers": [
        "beer"
    ],
    "ventures": [
        "venture"
    ],
    "ventured": [
        "venture"
    ],
    "venturing": [
        "venture"
    ],
    "whispered": [
        "whisper"
    ],
    "whispering": [
        "whisper"
    ],
    "whispers": [
        "whisper"
    ],
    "trapped": [
        "trap"
    ],
    "traps": [
        "trap"
    ],
    "trapping": [
        "trap"
    ],
    "electrics": [
        "electric"
    ],
    "spared": [
        "spare"
    ],
    "spares": [
        "spare"
    ],
    "sparing": [
        "spare"
    ],
    "stair": [
        "stairs"
    ],
    "intellectuals": [
        "intellectual"
    ],
    "belfasts": [
        "belfast"
    ],
    "tuesdays": [
        "tuesday"
    ],
    "cambridges": [
        "cambridge"
    ],
    "hunting": [
        "hunt"
    ],
    "hunted": [
        "hunt"
    ],
    "hunts": [
        "hunt"
    ],
    "invested": [
        "invest"
    ],
    "investing": [
        "invest"
    ],
    "invests": [
        "invest"
    ],
    "actors": [
        "actor"
    ],
    "personalities": [
        "personality"
    ],
    "rougher": [
        "rough"
    ],
    "roughest": [
        "rough"
    ],
    "roughs": [
        "rough"
    ],
    "roughed": [
        "rough"
    ],
    "roughing": [
        "rough"
    ],
    "cores": [
        "core"
    ],
    "cored": [
        "core"
    ],
    "coring": [
        "core"
    ],
    "inspectors": [
        "inspector"
    ],
    "expansions": [
        "expansion"
    ],
    "frequencies": [
        "frequency"
    ],
    "tendencies": [
        "tendency"
    ],
    "chancellors": [
        "chancellor"
    ],
    "uncles": [
        "uncle"
    ],
    "bowls": [
        "bowl"
    ],
    "bowled": [
        "bowl"
    ],
    "elizabeths": [
        "elizabeth"
    ],
    "chambers": [
        "chamber"
    ],
    "swept": [
        "sweep"
    ],
    "sweeping": [
        "sweep"
    ],
    "sweeps": [
        "sweep"
    ],
    "investors": [
        "investor"
    ],
    "awarenesses": [
        "awareness"
    ],
    "recordings": [
        "recording"
    ],
    "attributed": [
        "attribute"
    ],
    "attributes": [
        "attribute"
    ],
    "attributing": [
        "attribute"
    ],
    "moods": [
        "mood"
    ],
    "retired": [
        "retire"
    ],
    "retiring": [
        "retire"
    ],
    "clocks": [
        "clock"
    ],
    "clocked": [
        "clock"
    ],
    "clocking": [
        "clock"
    ],
    "weddings": [
        "wedding"
    ],
    "captured": [
        "capture"
    ],
    "capturing": [
        "capture"
    ],
    "interiors": [
        "interior"
    ],
    "purest": [
        "pure"
    ],
    "purer": [
        "pure"
    ],
    "runnings": [
        "running"
    ],
    "mailed": [
        "mail"
    ],
    "breeds": [
        "breed"
    ],
    "bred": [
        "breed"
    ],
    "breeding": [
        "breed"
    ],
    "spanishes": [
        "spanish"
    ],
    "landlords": [
        "landlord"
    ],
    "guitars": [
        "guitar"
    ],
    "nicked": [
        "nick"
    ],
    "nicking": [
        "nick"
    ],
    "nicks": [
        "nick"
    ],
    "rulings": [
        "ruling"
    ],
    "absolutes": [
        "absolute"
    ],
    "echoed": [
        "echo"
    ],
    "echoes": [
        "echo"
    ],
    "echoing": [
        "echo"
    ],
    "screaming": [
        "scream"
    ],
    "screamed": [
        "scream"
    ],
    "screams": [
        "scream"
    ],
    "mortgages": [
        "mortgage"
    ],
    "mortgaged": [
        "mortgage"
    ],
    "mortgaging": [
        "mortgage"
    ],
    "poured": [
        "pour"
    ],
    "pouring": [
        "pour"
    ],
    "pours": [
        "pour"
    ],
    "saddest": [
        "sad"
    ],
    "sadder": [
        "sad"
    ],
    "phenomena": [
        "phenomenon"
    ],
    "researchers": [
        "researcher"
    ],
    "apples": [
        "apple"
    ],
    "tourists": [
        "tourist"
    ],
    "merest": [
        "mere"
    ],
    "discoveries": [
        "discovery"
    ],
    "dragged": [
        "drag"
    ],
    "dragging": [
        "drag"
    ],
    "visuals": [
        "visual"
    ],
    "hearings": [
        "hearing"
    ],
    "graded": [
        "grade"
    ],
    "grading": [
        "grade"
    ],
    "retirements": [
        "retirement"
    ],
    "sands": [
        "sand"
    ],
    "sanding": [
        "sand"
    ],
    "sanded": [
        "sand"
    ],
    "birminghams": [
        "birmingham"
    ],
    "lukes": [
        "luke"
    ],
    "rugbies": [
        "rugby"
    ],
    "celebrated": [
        "celebrate"
    ],
    "celebrating": [
        "celebrate"
    ],
    "celebrates": [
        "celebrate"
    ],
    "crops": [
        "crop"
    ],
    "cropped": [
        "crop"
    ],
    "cropping": [
        "crop"
    ],
    "brilliants": [
        "brilliant"
    ],
    "calmed": [
        "calm"
    ],
    "calming": [
        "calm"
    ],
    "calms": [
        "calm"
    ],
    "calmest": [
        "calm"
    ],
    "upsetting": [
        "upset"
    ],
    "upsets": [
        "upset"
    ],
    "disks": [
        "disk"
    ],
    "tims": [
        "tim"
    ],
    "comprising": [
        "comprise"
    ],
    "comprised": [
        "comprise"
    ],
    "overcoming": [
        "overcome"
    ],
    "overcame": [
        "overcome"
    ],
    "overcomes": [
        "overcome"
    ],
    "giants": [
        "giant"
    ],
    "gloucesters": [
        "gloucester"
    ],
    "seeds": [
        "seed"
    ],
    "seeded": [
        "seed"
    ],
    "seeding": [
        "seed"
    ],
    "allowances": [
        "allowance"
    ],
    "dnas": [
        "dna"
    ],
    "shirts": [
        "shirt"
    ],
    "ehs": [
        "eh"
    ],
    "creams": [
        "cream"
    ],
    "creamed": [
        "cream"
    ],
    "creaming": [
        "cream"
    ],
    "enquiries": [
        "enquiry"
    ],
    "plotted": [
        "plot"
    ],
    "plotting": [
        "plot"
    ],
    "journals": [
        "journal"
    ],
    "thatchers": [
        "thatcher"
    ],
    "salts": [
        "salt"
    ],
    "salted": [
        "salt"
    ],
    "salting": [
        "salt"
    ],
    "volunteers": [
        "volunteer"
    ],
    "volunteered": [
        "volunteer"
    ],
    "volunteering": [
        "volunteer"
    ],
    "birthdays": [
        "birthday"
    ],
    "resisted": [
        "resist"
    ],
    "resisting": [
        "resist"
    ],
    "resists": [
        "resist"
    ],
    "paragraphs": [
        "paragraph"
    ],
    "paragraphing": [
        "paragraph"
    ],
    "buried": [
        "bury"
    ],
    "burying": [
        "bury"
    ],
    "buries": [
        "bury"
    ],
    "detected": [
        "detect"
    ],
    "detecting": [
        "detect"
    ],
    "detects": [
        "detect"
    ],
    "bursting": [
        "burst"
    ],
    "bursts": [
        "burst"
    ],
    "entrances": [
        "entrance"
    ],
    "entranced": [
        "entrance"
    ],
    "entrancing": [
        "entrance"
    ],
    "medicines": [
        "medicine"
    ],
    "organized": [
        "organize"
    ],
    "organizing": [
        "organize"
    ],
    "organizes": [
        "organize"
    ],
    "romes": [
        "rome"
    ],
    "heroes": [
        "hero"
    ],
    "no.s": [
        "no."
    ],
    "reared": [
        "rear"
    ],
    "rearing": [
        "rear"
    ],
    "rears": [
        "rear"
    ],
    "gulfs": [
        "gulf"
    ],
    "judgements": [
        "judgement"
    ],
    "cracked": [
        "crack"
    ],
    "assaults": [
        "assault"
    ],
    "assaulted": [
        "assault"
    ],
    "assaulting": [
        "assault"
    ],
    "dared": [
        "dare"
    ],
    "daring": [
        "dare"
    ],
    "dares": [
        "dare"
    ],
    "shells": [
        "shell"
    ],
    "shelled": [
        "shell"
    ],
    "shelling": [
        "shell"
    ],
    "tails": [
        "tail"
    ],
    "tailed": [
        "tail"
    ],
    "tailing": [
        "tail"
    ],
    "breathing": [
        "breathe"
    ],
    "breathed": [
        "breathe"
    ],
    "breathes": [
        "breathe"
    ],
    "storms": [
        "storm"
    ],
    "stormed": [
        "storm"
    ],
    "storming": [
        "storm"
    ],
    "carpets": [
        "carpet"
    ],
    "carpeted": [
        "carpet"
    ],
    "carpeting": [
        "carpet"
    ],
    "differs": [
        "differ"
    ],
    "differed": [
        "differ"
    ],
    "differing": [
        "differ"
    ],
    "grinned": [
        "grin"
    ],
    "grinning": [
        "grin"
    ],
    "grins": [
        "grin"
    ],
    "sighed": [
        "sigh"
    ],
    "sighs": [
        "sigh"
    ],
    "sighing": [
        "sigh"
    ],
    "ageds": [
        "aged"
    ],
    "williamss": [
        "williams"
    ],
    "platforms": [
        "platform"
    ],
    "knives": [
        "knife"
    ],
    "knifed": [
        "knife"
    ],
    "knifes": [
        "knife"
    ],
    "knifing": [
        "knife"
    ],
    "rescued": [
        "rescue"
    ],
    "rescuing": [
        "rescue"
    ],
    "rescues": [
        "rescue"
    ],
    "peasants": [
        "peasant"
    ],
    "behaved": [
        "behave"
    ],
    "behaving": [
        "behave"
    ],
    "behaves": [
        "behave"
    ],
    "disasters": [
        "disaster"
    ],
    "circuited": [
        "circuit"
    ],
    "circuiting": [
        "circuit"
    ],
    "sarahs": [
        "sarah"
    ],
    "throats": [
        "throat"
    ],
    "airports": [
        "airport"
    ],
    "pinks": [
        "pink"
    ],
    "pinker": [
        "pink"
    ],
    "pinkest": [
        "pink"
    ],
    "pinking": [
        "pink"
    ],
    "pinked": [
        "pink"
    ],
    "advisers": [
        "adviser"
    ],
    "ls": [
        "l"
    ],
    "catalogued": [
        "catalogue"
    ],
    "cataloguing": [
        "catalogue"
    ],
    "dukes": [
        "duke"
    ],
    "cheeks": [
        "cheek"
    ],
    "cheeked": [
        "cheek"
    ],
    "cheeking": [
        "cheek"
    ],
    "posed": [
        "pose"
    ],
    "posing": [
        "pose"
    ],
    "consumptions": [
        "consumption"
    ],
    "harmed": [
        "harm"
    ],
    "harming": [
        "harm"
    ],
    "harms": [
        "harm"
    ],
    "washingtons": [
        "washington"
    ],
    "excesses": [
        "excess"
    ],
    "formulae": [
        "formula"
    ],
    "formulas": [
        "formula"
    ],
    "nineteenths": [
        "nineteenth"
    ],
    "curtains": [
        "curtain"
    ],
    "curtained": [
        "curtain"
    ],
    "curtaining": [
        "curtain"
    ],
    "israels": [
        "israel"
    ],
    "resigned": [
        "resign"
    ],
    "resigning": [
        "resign"
    ],
    "resigns": [
        "resign"
    ],
    "earningss": [
        "earnings"
    ],
    "stakes": [
        "stake"
    ],
    "staked": [
        "stake"
    ],
    "staking": [
        "stake"
    ],
    "classicals": [
        "classical"
    ],
    "guidances": [
        "guidance"
    ],
    "installed": [
        "install"
    ],
    "installing": [
        "install"
    ],
    "installs": [
        "install"
    ],
    "workshops": [
        "workshop"
    ],
    "extracts": [
        "extract"
    ],
    "extracted": [
        "extract"
    ],
    "extracting": [
        "extract"
    ],
    "statisticss": [
        "statistics"
    ],
    "burdens": [
        "burden"
    ],
    "burdened": [
        "burden"
    ],
    "burdening": [
        "burden"
    ],
    "competing": [
        "compete"
    ],
    "competed": [
        "compete"
    ],
    "relaxed": [
        "relax"
    ],
    "relaxing": [
        "relax"
    ],
    "wounds": [
        "wound"
    ],
    "wounded": [
        "wound"
    ],
    "wounding": [
        "wound"
    ],
    "fishings": [
        "fishing"
    ],
    "kens": [
        "ken"
    ],
    "iraqs": [
        "iraq"
    ],
    "piled": [
        "pile"
    ],
    "piling": [
        "pile"
    ],
    "percentages": [
        "percentage"
    ],
    "survivals": [
        "survival"
    ],
    "wires": [
        "wire"
    ],
    "wired": [
        "wire"
    ],
    "wiring": [
        "wire"
    ],
    "shadowed": [
        "shadow"
    ],
    "shadowing": [
        "shadow"
    ],
    "shadows": [
        "shadow"
    ],
    "steamed": [
        "steam"
    ],
    "steaming": [
        "steam"
    ],
    "steams": [
        "steam"
    ],
    "brands": [
        "brand"
    ],
    "branded": [
        "brand"
    ],
    "branding": [
        "brand"
    ],
    "darknesses": [
        "darkness"
    ],
    "suppliers": [
        "supplier"
    ],
    "countered": [
        "counter"
    ],
    "counters": [
        "counter"
    ],
    "countering": [
        "counter"
    ],
    "priests": [
        "priest"
    ],
    "journalists": [
        "journalist"
    ],
    "givens": [
        "given"
    ],
    "musicals": [
        "musical"
    ],
    "altogethers": [
        "altogether"
    ],
    "ownerships": [
        "ownership"
    ],
    "gripped": [
        "grip"
    ],
    "grips": [
        "grip"
    ],
    "gripping": [
        "grip"
    ],
    "joys": [
        "joy"
    ],
    "proudest": [
        "proud"
    ],
    "prouder": [
        "proud"
    ],
    "magics": [
        "magic"
    ],
    "magicking": [
        "magic"
    ],
    "magicked": [
        "magic"
    ],
    "negotiated": [
        "negotiate"
    ],
    "negotiating": [
        "negotiate"
    ],
    "negotiates": [
        "negotiate"
    ],
    "bets": [
        "bet"
    ],
    "betted": [
        "bet"
    ],
    "exposed": [
        "expose"
    ],
    "exposing": [
        "expose"
    ],
    "founded": [
        "found"
    ],
    "founding": [
        "found"
    ],
    "founds": [
        "found"
    ],
    "resorts": [
        "resort"
    ],
    "resorted": [
        "resort"
    ],
    "resorting": [
        "resort"
    ],
    "hurried": [
        "hurry"
    ],
    "hurrying": [
        "hurry"
    ],
    "hurries": [
        "hurry"
    ],
    "deserted": [
        "desert"
    ],
    "deserting": [
        "desert"
    ],
    "disableds": [
        "disabled"
    ],
    "enhanced": [
        "enhance"
    ],
    "enhancing": [
        "enhance"
    ],
    "enhances": [
        "enhance"
    ],
    "anxieties": [
        "anxiety"
    ],
    "leases": [
        "lease"
    ],
    "leased": [
        "lease"
    ],
    "charts": [
        "chart"
    ],
    "charted": [
        "chart"
    ],
    "charting": [
        "chart"
    ],
    "practitioners": [
        "practitioner"
    ],
    "distributed": [
        "distribute"
    ],
    "distributing": [
        "distribute"
    ],
    "distributes": [
        "distribute"
    ],
    "dishes": [
        "dish"
    ],
    "dished": [
        "dish"
    ],
    "dishing": [
        "dish"
    ],
    "arabs": [
        "arab"
    ],
    "strokes": [
        "stroke"
    ],
    "stroked": [
        "stroke"
    ],
    "stroking": [
        "stroke"
    ],
    "potting": [
        "pot"
    ],
    "potted": [
        "pot"
    ],
    "loosed": [
        "loose"
    ],
    "loosing": [
        "loose"
    ],
    "looses": [
        "loose"
    ],
    "loosest": [
        "loos",
        "loose"
    ],
    "developings": [
        "developing"
    ],
    "sued": [
        "sue"
    ],
    "suing": [
        "sue"
    ],
    "sueing": [
        "sue"
    ],
    "observers": [
        "observer"
    ],
    "measurements": [
        "measurement"
    ],
    "discounts": [
        "discount"
    ],
    "discounted": [
        "discount"
    ],
    "discounting": [
        "discount"
    ],
    "opponents": [
        "opponent"
    ],
    "alcohols": [
        "alcohol"
    ],
    "exceeded": [
        "exceed"
    ],
    "exceeds": [
        "exceed"
    ],
    "exceeding": [
        "exceed"
    ],
    "gestures": [
        "gesture"
    ],
    "gestured": [
        "gesture"
    ],
    "gesturing": [
        "gesture"
    ],
    "stomachs": [
        "stomach"
    ],
    "stomaching": [
        "stomach"
    ],
    "stomached": [
        "stomach"
    ],
    "madder": [
        "mad"
    ],
    "maddest": [
        "mad"
    ],
    "mads": [
        "mad"
    ],
    "prayers": [
        "prayer"
    ],
    "climates": [
        "climate"
    ],
    "lucks": [
        "luck"
    ],
    "symbols": [
        "symbol"
    ],
    "substituted": [
        "substitute"
    ],
    "substitutes": [
        "substitute"
    ],
    "substituting": [
        "substitute"
    ],
    "poverties": [
        "poverty"
    ],
    "ruths": [
        "ruth"
    ],
    "biting": [
        "bite"
    ],
    "bitten": [
        "bite"
    ],
    "evils": [
        "evil"
    ],
    "operators": [
        "operator"
    ],
    "implementations": [
        "implementation"
    ],
    "asias": [
        "asia"
    ],
    "prided": [
        "pride"
    ],
    "prides": [
        "pride"
    ],
    "priding": [
        "pride"
    ],
    "steadied": [
        "steady"
    ],
    "steadying": [
        "steady"
    ],
    "steadier": [
        "steady"
    ],
    "steadies": [
        "steady"
    ],
    "steadiest": [
        "steady"
    ],
    "deserves": [
        "deserve"
    ],
    "deserved": [
        "deserve"
    ],
    "deserving": [
        "deserve"
    ],
    "dusted": [
        "dust"
    ],
    "dusting": [
        "dust"
    ],
    "dusts": [
        "dust"
    ],
    "fuckings": [
        "fucking"
    ],
    "twins": [
        "twin"
    ],
    "twinned": [
        "twin"
    ],
    "twinning": [
        "twin"
    ],
    "moons": [
        "moon"
    ],
    "mooning": [
        "moon"
    ],
    "mooned": [
        "moon"
    ],
    "summaries": [
        "summary"
    ],
    "barriers": [
        "barrier"
    ],
    "intervals": [
        "interval"
    ],
    "borrowed": [
        "borrow"
    ],
    "borrowing": [
        "borrow"
    ],
    "borrows": [
        "borrow"
    ],
    "capped": [
        "cap"
    ],
    "capping": [
        "cap"
    ],
    "emphasised": [
        "emphasise"
    ],
    "emphasises": [
        "emphasise"
    ],
    "emphasising": [
        "emphasise"
    ],
    "holiest": [
        "holy"
    ],
    "holier": [
        "holy"
    ],
    "holies": [
        "holy"
    ],
    "transformed": [
        "transform"
    ],
    "transforming": [
        "transform"
    ],
    "transforms": [
        "transform"
    ],
    "practised": [
        "practise"
    ],
    "practising": [
        "practise"
    ],
    "practises": [
        "practise"
    ],
    "confined": [
        "confine"
    ],
    "confining": [
        "confine"
    ],
    "sheeps": [
        "sheep"
    ],
    "sheep": [
        "sheep"
    ],
    "chasing": [
        "chase"
    ],
    "chased": [
        "chase"
    ],
    "chases": [
        "chase"
    ],
    "qualified": [
        "qualify"
    ],
    "qualifying": [
        "qualify"
    ],
    "aunts": [
        "aunt"
    ],
    "processings": [
        "processing"
    ],
    "uniforms": [
        "uniform"
    ],
    "publishers": [
        "publisher"
    ],
    "louder": [
        "loud"
    ],
    "loudest": [
        "loud"
    ],
    "remoter": [
        "remote"
    ],
    "remotest": [
        "remote"
    ],
    "dimensioned": [
        "dimension"
    ],
    "democrats": [
        "democrat"
    ],
    "swimming": [
        "swim"
    ],
    "swam": [
        "swim"
    ],
    "swims": [
        "swim"
    ],
    "swum": [
        "swim"
    ],
    "enthusiasms": [
        "enthusiasm"
    ],
    "snapped": [
        "snap"
    ],
    "snapping": [
        "snap"
    ],
    "snaps": [
        "snap"
    ],
    "hired": [
        "hire"
    ],
    "hiring": [
        "hire"
    ],
    "hires": [
        "hire"
    ],
    "poets": [
        "poet"
    ],
    "cheeses": [
        "cheese"
    ],
    "cheesed": [
        "cheese"
    ],
    "sealed": [
        "seal"
    ],
    "seals": [
        "seal"
    ],
    "sealing": [
        "seal"
    ],
    "tubed": [
        "tube"
    ],
    "storages": [
        "storage"
    ],
    "peers": [
        "peer"
    ],
    "peered": [
        "peer"
    ],
    "peering": [
        "peer"
    ],
    "turnovers": [
        "turnover"
    ],
    "historians": [
        "historian"
    ],
    "ceased": [
        "cease"
    ],
    "ceases": [
        "cease"
    ],
    "ceasing": [
        "cease"
    ],
    "moscows": [
        "moscow"
    ],
    "heavens": [
        "heaven"
    ],
    "vessels": [
        "vessel"
    ],
    "strengthened": [
        "strengthen"
    ],
    "strengthening": [
        "strengthen"
    ],
    "strengthens": [
        "strengthen"
    ],
    "grabbed": [
        "grab"
    ],
    "grabbing": [
        "grab"
    ],
    "grabs": [
        "grab"
    ],
    "assured": [
        "assure"
    ],
    "assuring": [
        "assure"
    ],
    "proofs": [
        "proof"
    ],
    "proofed": [
        "proof"
    ],
    "proofing": [
        "proof"
    ],
    "dug": [
        "dig"
    ],
    "digging": [
        "dig"
    ],
    "digs": [
        "dig"
    ],
    "digged": [
        "dig"
    ],
    "flashed": [
        "flash"
    ],
    "flashing": [
        "flash"
    ],
    "discharged": [
        "discharge"
    ],
    "discharges": [
        "discharge"
    ],
    "discharging": [
        "discharge"
    ],
    "perceived": [
        "perceive"
    ],
    "perceiving": [
        "perceive"
    ],
    "perceives": [
        "perceive"
    ],
    "replacements": [
        "replacement"
    ],
    "canadas": [
        "canada"
    ],
    "josephs": [
        "joseph"
    ],
    "percents": [
        "percent"
    ],
    "remedies": [
        "remedy"
    ],
    "remedied": [
        "remedy"
    ],
    "remedying": [
        "remedy"
    ],
    "patricks": [
        "patrick"
    ],
    "profiling": [
        "profile"
    ],
    "profiled": [
        "profile"
    ],
    "alarms": [
        "alarm"
    ],
    "alarmed": [
        "alarm"
    ],
    "alarming": [
        "alarm"
    ],
    "mice": [
        "mouse"
    ],
    "mouses": [
        "mouse"
    ],
    "normans": [
        "norman"
    ],
    "participating": [
        "participate"
    ],
    "participated": [
        "participate"
    ],
    "participates": [
        "participate"
    ],
    "economicss": [
        "economics"
    ],
    "extraordinaries": [
        "extraordinary"
    ],
    "walkers": [
        "walker"
    ],
    "australians": [
        "australian"
    ],
    "sustained": [
        "sustain"
    ],
    "sustaining": [
        "sustain"
    ],
    "sustains": [
        "sustain"
    ],
    "lending": [
        "lend"
    ],
    "lends": [
        "lend"
    ],
    "formatting": [
        "format"
    ],
    "formatted": [
        "format"
    ],
    "leisured": [
        "leisure"
    ],
    "coined": [
        "coin"
    ],
    "coining": [
        "coin"
    ],
    "pits": [
        "pit"
    ],
    "pitted": [
        "pit"
    ],
    "pitting": [
        "pit"
    ],
    "raped": [
        "rape"
    ],
    "raping": [
        "rape"
    ],
    "drifted": [
        "drift"
    ],
    "drifting": [
        "drift"
    ],
    "drifts": [
        "drift"
    ],
    "unities": [
        "unity"
    ],
    "allied": [
        "ally"
    ],
    "allying": [
        "ally"
    ],
    "!allies": [
        "ally"
    ],
    "satisfied": [
        "satisfy"
    ],
    "satisfies": [
        "satisfy"
    ],
    "satisfying": [
        "satisfy"
    ],
    "prompted": [
        "prompt"
    ],
    "prompting": [
        "prompt"
    ],
    "prompter": [
        "prompt"
    ],
    "compounds": [
        "compound"
    ],
    "compounded": [
        "compound"
    ],
    "compounding": [
        "compound"
    ],
    "exploited": [
        "exploit"
    ],
    "exploiting": [
        "exploit"
    ],
    "magistrates": [
        "magistrate"
    ],
    "stamps": [
        "stamp"
    ],
    "stamped": [
        "stamp"
    ],
    "stamping": [
        "stamp"
    ],
    "supplemented": [
        "supplement"
    ],
    "supplementing": [
        "supplement"
    ],
    "flooded": [
        "flood"
    ],
    "floods": [
        "flood"
    ],
    "flooding": [
        "flood"
    ],
    "merchants": [
        "merchant"
    ],
    "merchanting": [
        "merchant"
    ],
    "divorced": [
        "divorce"
    ],
    "divorcing": [
        "divorce"
    ],
    "shrugged": [
        "shrug"
    ],
    "shrugs": [
        "shrug"
    ],
    "shrugging": [
        "shrug"
    ],
    "sponsored": [
        "sponsor"
    ],
    "movies": [
        "movie"
    ],
    "fancied": [
        "fancy"
    ],
    "fancies": [
        "fancy"
    ],
    "fancying": [
        "fancy"
    ],
    "fancier": [
        "fancy"
    ],
    "fanciest": [
        "fancy"
    ],
    "fabrics": [
        "fabric"
    ],
    "recruited": [
        "recruit"
    ],
    "recruits": [
        "recruit"
    ],
    "recruiting": [
        "recruit"
    ],
    "tenniss": [
        "tennis"
    ],
    "standings": [
        "standing"
    ],
    "tunnelled": [
        "tunnel"
    ],
    "tunnelling": [
        "tunnel"
    ],
    "audited": [
        "audit"
    ],
    "auditing": [
        "audit"
    ],
    "squads": [
        "squad"
    ],
    "geared": [
        "gear"
    ],
    "gears": [
        "gear"
    ],
    "gearing": [
        "gear"
    ],
    "adapted": [
        "adapt"
    ],
    "adapting": [
        "adapt"
    ],
    "adapts": [
        "adapt"
    ],
    "childhoods": [
        "childhood"
    ],
    "pacifics": [
        "pacific"
    ],
    "breasts": [
        "breast"
    ],
    "breasted": [
        "breast"
    ],
    "breasting": [
        "breast"
    ],
    "hints": [
        "hint"
    ],
    "hinted": [
        "hint"
    ],
    "hinting": [
        "hint"
    ],
    "amendments": [
        "amendment"
    ],
    "bens": [
        "ben"
    ],
    "gentled": [
        "gentle"
    ],
    "gentling": [
        "gentle"
    ],
    "gentler": [
        "gentl",
        "gentle"
    ],
    "gentlest": [
        "gentl",
        "gentle"
    ],
    "chartered": [
        "charter"
    ],
    "chartering": [
        "charter"
    ],
    "lovers": [
        "lover"
    ],
    "boosted": [
        "boost"
    ],
    "boosting": [
        "boost"
    ],
    "boosts": [
        "boost"
    ],
    "surgeries": [
        "surgery"
    ],
    "dirtiest": [
        "dirty"
    ],
    "dirtier": [
        "dirty"
    ],
    "dirtied": [
        "dirty"
    ],
    "dirtying": [
        "dirty"
    ],
    "dirties": [
        "dirty"
    ],
    "manufactured": [
        "manufacture"
    ],
    "manufacturing": [
        "manufacture"
    ],
    "unemployeds": [
        "unemployed"
    ],
    "filters": [
        "filter"
    ],
    "filtered": [
        "filter"
    ],
    "filtering": [
        "filter"
    ],
    "liquids": [
        "liquid"
    ],
    "stems": [
        "stem"
    ],
    "stemmed": [
        "stem"
    ],
    "stemming": [
        "stem"
    ],
    "mating": [
        "mate"
    ],
    "mated": [
        "mate"
    ],
    "bowed": [
        "bow"
    ],
    "bows": [
        "bow"
    ],
    "bowing": [
        "bow"
    ],
    "consulted": [
        "consult"
    ],
    "consulting": [
        "consult"
    ],
    "consults": [
        "consult"
    ],
    "gravest": [
        "grave"
    ],
    "graving": [
        "grave"
    ],
    "graven": [
        "grave"
    ],
    "graved": [
        "grave"
    ],
    "bricked": [
        "brick"
    ],
    "bricking": [
        "brick"
    ],
    "classrooms": [
        "classroom"
    ],
    "pens": [
        "pen"
    ],
    "penned": [
        "pen"
    ],
    "penning": [
        "pen"
    ],
    "pent": [
        "pen"
    ],
    "wans": [
        "wan"
    ],
    "wanning": [
        "wan"
    ],
    "wanned": [
        "wan"
    ],
    "dawned": [
        "dawn"
    ],
    "dawns": [
        "dawn"
    ],
    "dawning": [
        "dawn"
    ],
    "reinforced": [
        "reinforce"
    ],
    "reinforcing": [
        "reinforce"
    ],
    "reinforces": [
        "reinforce"
    ],
    "adjusted": [
        "adjust"
    ],
    "adjusting": [
        "adjust"
    ],
    "adjusts": [
        "adjust"
    ],
    "leapt": [
        "leap"
    ],
    "leaping": [
        "leap"
    ],
    "leaps": [
        "leap"
    ],
    "leaped": [
        "leap"
    ],
    "twisted": [
        "twist"
    ],
    "twisting": [
        "twist"
    ],
    "praised": [
        "praise"
    ],
    "praising": [
        "praise"
    ],
    "praises": [
        "praise"
    ],
    "belts": [
        "belt"
    ],
    "belted": [
        "belt"
    ],
    "belting": [
        "belt"
    ],
    "announcements": [
        "announcement"
    ],
    "refugees": [
        "refugee"
    ],
    "rays": [
        "ray"
    ],
    "discourses": [
        "discourse"
    ],
    "discoursing": [
        "discourse"
    ],
    "discoursed": [
        "discourse"
    ],
    "vegetables": [
        "vegetable"
    ],
    "acceptances": [
        "acceptance"
    ],
    "mysteries": [
        "mystery"
    ],
    "poetries": [
        "poetry"
    ],
    "compromised": [
        "compromise"
    ],
    "compromising": [
        "compromise"
    ],
    "oks": [
        "ok"
    ],
    "foxes": [
        "fox"
    ],
    "foxed": [
        "fox"
    ],
    "foxing": [
        "fox"
    ],
    "patted": [
        "pat"
    ],
    "patting": [
        "pat"
    ],
    "pats": [
        "pat"
    ],
    "manuals": [
        "manual"
    ],
    "pcs": [
        "pc"
    ],
    "pc's": [
        "pc"
    ],
    "architects": [
        "architect"
    ],
    "newcastles": [
        "newcastle"
    ],
    "silliest": [
        "silly"
    ],
    "sillier": [
        "silly"
    ],
    "transitioned": [
        "transition"
    ],
    "guardians": [
        "guardian"
    ],
    "constituencies": [
        "constituency"
    ],
    "graced": [
        "grace"
    ],
    "gracing": [
        "grace"
    ],
    "departures": [
        "departure"
    ],
    "tongues": [
        "tongue"
    ],
    "tonguing": [
        "tongue"
    ],
    "advocated": [
        "advocate"
    ],
    "advocates": [
        "advocate"
    ],
    "advocating": [
        "advocate"
    ],
    "crafts": [
        "craft"
    ],
    "crafted": [
        "craft"
    ],
    "crafting": [
        "craft"
    ],
    "entitled": [
        "entitle"
    ],
    "entitles": [
        "entitle"
    ],
    "entitling": [
        "entitle"
    ],
    "sheds": [
        "shed"
    ],
    "shedding": [
        "shed"
    ],
    "shedded": [
        "shed"
    ],
    "bathrooms": [
        "bathroom"
    ],
    "fools": [
        "fool"
    ],
    "fooled": [
        "fool"
    ],
    "fooling": [
        "fool"
    ],
    "graduates": [
        "graduate"
    ],
    "graduated": [
        "graduate"
    ],
    "graduating": [
        "graduate"
    ],
    "summits": [
        "summit"
    ],
    "universals": [
        "universal"
    ],
    "patched": [
        "patch"
    ],
    "patching": [
        "patch"
    ],
    "treasuries": [
        "treasury"
    ],
    "buttons": [
        "button"
    ],
    "buttoned": [
        "button"
    ],
    "buttoning": [
        "button"
    ],
    "weaknesses": [
        "weakness"
    ],
    "raided": [
        "raid"
    ],
    "raiding": [
        "raid"
    ],
    "deafer": [
        "deaf"
    ],
    "deafest": [
        "deaf"
    ],
    "pretending": [
        "pretend"
    ],
    "pretended": [
        "pretend"
    ],
    "victorians": [
        "victorian"
    ],
    "zealands": [
        "zealand"
    ],
    "concreted": [
        "concrete"
    ],
    "concreting": [
        "concrete"
    ],
    "revolutionaries": [
        "revolutionary"
    ],
    "pleasanter": [
        "pleasant"
    ],
    "pleasantest": [
        "pleasant"
    ],
    "upstairss": [
        "upstairs"
    ],
    "messing": [
        "mess"
    ],
    "messed": [
        "mess"
    ],
    "fords": [
        "ford"
    ],
    "fording": [
        "ford"
    ],
    "forded": [
        "ford"
    ],
    "slopes": [
        "slope"
    ],
    "sloped": [
        "slope"
    ],
    "sloping": [
        "slope"
    ],
    "absorbed": [
        "absorb"
    ],
    "absorbing": [
        "absorb"
    ],
    "absorbs": [
        "absorb"
    ],
    "crystals": [
        "crystal"
    ],
    "poling": [
        "pole"
    ],
    "poled": [
        "pole"
    ],
    "kents": [
        "kent"
    ],
    "frequented": [
        "frequent"
    ],
    "frequenting": [
        "frequent"
    ],
    "margins": [
        "margin"
    ],
    "soled": [
        "sole"
    ],
    "soling": [
        "sole"
    ],
    "cows": [
        "cow"
    ],
    "cowed": [
        "cow"
    ],
    "cowing": [
        "cow"
    ],
    "stirred": [
        "stir"
    ],
    "stirring": [
        "stir"
    ],
    "stirs": [
        "stir"
    ],
    "uncertainties": [
        "uncertainty"
    ],
    "forecasts": [
        "forecast"
    ],
    "forecasting": [
        "forecast"
    ],
    "forecasted": [
        "forecast"
    ],
    "cathedrals": [
        "cathedral"
    ],
    "pinned": [
        "pin"
    ],
    "pinning": [
        "pin"
    ],
    "ridding": [
        "rid"
    ],
    "rids": [
        "rid"
    ],
    "ridded": [
        "rid"
    ],
    "arthurs": [
        "arthur"
    ],
    "drivings": [
        "driving"
    ],
    "premiered": [
        "premier"
    ],
    "concerting": [
        "concert"
    ],
    "universes": [
        "universe"
    ],
    "fulfilled": [
        "fulfil"
    ],
    "fulfilling": [
        "fulfil"
    ],
    "fulfils": [
        "fulfil"
    ],
    "canals": [
        "canal"
    ],
    "capitalists": [
        "capitalist"
    ],
    "delights": [
        "delight"
    ],
    "delighted": [
        "delight"
    ],
    "delighting": [
        "delight"
    ],
    "tuned": [
        "tune"
    ],
    "tuning": [
        "tune"
    ],
    "reacted": [
        "react"
    ],
    "reacting": [
        "react"
    ],
    "reacts": [
        "react"
    ],
    "ceilings": [
        "ceiling"
    ],
    "sergeants": [
        "sergeant"
    ],
    "timbers": [
        "timber"
    ],
    "timbered": [
        "timber"
    ],
    "halted": [
        "halt"
    ],
    "halting": [
        "halt"
    ],
    "halts": [
        "halt"
    ],
    "feminists": [
        "feminist"
    ],
    "wrapped": [
        "wrap"
    ],
    "wrapping": [
        "wrap"
    ],
    "wraps": [
        "wrap"
    ],
    "wrapt": [
        "wrap"
    ],
    "delegates": [
        "delegate"
    ],
    "delegated": [
        "delegate"
    ],
    "delegating": [
        "delegate"
    ],
    "prosecutions": [
        "prosecution"
    ],
    "consciousnesses": [
        "consciousness"
    ],
    "constraints": [
        "constraint"
    ],
    "wiser": [
        "wise"
    ],
    "wisest": [
        "wise"
    ],
    "wised": [
        "wise"
    ],
    "wises": [
        "wise"
    ],
    "wising": [
        "wise"
    ],
    "privileging": [
        "privilege"
    ],
    "privileged": [
        "privilege"
    ],
    "cited": [
        "cite"
    ],
    "citing": [
        "cite"
    ],
    "excitements": [
        "excitement"
    ],
    "tricks": [
        "trick"
    ],
    "tricked": [
        "trick"
    ],
    "tricking": [
        "trick"
    ],
    "guidelines": [
        "guideline"
    ],
    "tinning": [
        "tin"
    ],
    "tinned": [
        "tin"
    ],
    "chickens": [
        "chicken"
    ],
    "chickened": [
        "chicken"
    ],
    "chickening": [
        "chicken"
    ],
    "cattles": [
        "cattle"
    ],
    "terminals": [
        "terminal"
    ],
    "drained": [
        "drain"
    ],
    "draining": [
        "drain"
    ],
    "polished": [
        "polish"
    ],
    "polishing": [
        "polish"
    ],
    "polishes": [
        "polish"
    ],
    "cabled": [
        "cable"
    ],
    "cabling": [
        "cable"
    ],
    "grammars": [
        "grammar"
    ],
    "ws": [
        "w"
    ],
    "shelves": [
        "shelve",
        "shelf"
    ],
    "allocated": [
        "allocate"
    ],
    "allocating": [
        "allocate"
    ],
    "allocates": [
        "allocate"
    ],
    "benches": [
        "bench"
    ],
    "benched": [
        "bench"
    ],
    "completions": [
        "completion"
    ],
    "lowered": [
        "lower"
    ],
    "lowering": [
        "lower"
    ],
    "lowers": [
        "lower"
    ],
    "alexanders": [
        "alexander"
    ],
    "weeklies": [
        "weekly"
    ],
    "rogered": [
        "roger"
    ],
    "rogering": [
        "roger"
    ],
    "clerks": [
        "clerk"
    ],
    "closures": [
        "closure"
    ],
    "governed": [
        "govern"
    ],
    "governing": [
        "govern"
    ],
    "governs": [
        "govern"
    ],
    "communicated": [
        "communicate"
    ],
    "communicating": [
        "communicate"
    ],
    "communicates": [
        "communicate"
    ],
    "shades": [
        "shade"
    ],
    "shaded": [
        "shade"
    ],
    "shading": [
        "shade"
    ],
    "prayed": [
        "pray"
    ],
    "praying": [
        "pray"
    ],
    "prays": [
        "pray"
    ],
    "swallowed": [
        "swallow"
    ],
    "swallowing": [
        "swallow"
    ],
    "swallows": [
        "swallow"
    ],
    "superiors": [
        "superior"
    ],
    "regretted": [
        "regret"
    ],
    "regretting": [
        "regret"
    ],
    "virtues": [
        "virtue"
    ],
    "terries": [
        "terry"
    ],
    "injured": [
        "injure"
    ],
    "injuring": [
        "injure"
    ],
    "interfaced": [
        "interface"
    ],
    "lodged": [
        "lodge"
    ],
    "lodging": [
        "lodge"
    ],
    "lodges": [
        "lodge"
    ],
    "nursings": [
        "nursing"
    ],
    "flyings": [
        "flying"
    ],
    "taxations": [
        "taxation"
    ],
    "lucies": [
        "lucy"
    ],
    "publicities": [
        "publicity"
    ],
    "carbons": [
        "carbon"
    ],
    "contested": [
        "contest"
    ],
    "contests": [
        "contest"
    ],
    "contesting": [
        "contest"
    ],
    "seized": [
        "seize"
    ],
    "seizing": [
        "seize"
    ],
    "seizes": [
        "seize"
    ],
    "folded": [
        "fold"
    ],
    "folds": [
        "fold"
    ],
    "folding": [
        "fold"
    ],
    "bared": [
        "bare"
    ],
    "barest": [
        "bare"
    ],
    "baring": [
        "bare"
    ],
    "bares": [
        "bare"
    ],
    "barer": [
        "bare"
    ],
    "rebels": [
        "rebel"
    ],
    "rebelled": [
        "rebel"
    ],
    "rebelling": [
        "rebel"
    ],
    "trailed": [
        "trail"
    ],
    "trailing": [
        "trail"
    ],
    "trails": [
        "trail"
    ],
    "updated": [
        "update"
    ],
    "updating": [
        "update"
    ],
    "updates": [
        "update"
    ],
    "ducks": [
        "duck"
    ],
    "ducked": [
        "duck"
    ],
    "ducking": [
        "duck"
    ],
    "diaries": [
        "diary"
    ],
    "pigs": [
        "pig"
    ],
    "pigging": [
        "pig"
    ],
    "pigged": [
        "pig"
    ],
    "accountings": [
        "accounting"
    ],
    "pumps": [
        "pump"
    ],
    "pumped": [
        "pump"
    ],
    "pumping": [
        "pump"
    ],
    "nerves": [
        "nerve"
    ],
    "nerved": [
        "nerve"
    ],
    "nerving": [
        "nerve"
    ],
    "printers": [
        "printer"
    ],
    "ultimates": [
        "ultimate"
    ],
    "leathers": [
        "leather"
    ],
    "leathering": [
        "leather"
    ],
    "leathered": [
        "leather"
    ],
    "closers": [
        "closer"
    ],
    "hooked": [
        "hook"
    ],
    "hooks": [
        "hook"
    ],
    "hooking": [
        "hook"
    ],
    "disorders": [
        "disorder"
    ],
    "disordered": [
        "disorder"
    ],
    "dividends": [
        "dividend"
    ],
    "earls": [
        "earl"
    ],
    "potatoes": [
        "potato"
    ],
    "potatos": [
        "potato"
    ],
    "darlings": [
        "darling"
    ],
    "durhams": [
        "durham"
    ],
    "bitterest": [
        "bitter"
    ],
    "shone": [
        "shine"
    ],
    "shining": [
        "shine"
    ],
    "shines": [
        "shine"
    ],
    "shined": [
        "shine"
    ],
    "punishments": [
        "punishment"
    ],
    "rabbits": [
        "rabbit"
    ],
    "rabbiting": [
        "rabbit"
    ],
    "rabbited": [
        "rabbit"
    ],
    "juries": [
        "jury"
    ],
    "vats": [
        "vat"
    ],
    "berlins": [
        "berlin"
    ],
    "applicants": [
        "applicant"
    ],
    "sellers": [
        "seller"
    ],
    "ads": [
        "ad"
    ],
    "desperates": [
        "desperate"
    ],
    "undergoing": [
        "undergo"
    ],
    "undergone": [
        "undergo"
    ],
    "underwent": [
        "undergo"
    ],
    "undergoes": [
        "undergo"
    ],
    "reflections": [
        "reflection"
    ],
    "evaluated": [
        "evaluate"
    ],
    "evaluating": [
        "evaluate"
    ],
    "evaluates": [
        "evaluate"
    ],
    "trouser": [
        "trousers"
    ],
    "losts": [
        "lost"
    ],
    "abstracts": [
        "abstract"
    ],
    "abstracted": [
        "abstract"
    ],
    "abstracting": [
        "abstract"
    ],
    "grossed": [
        "gross"
    ],
    "grosser": [
        "gross"
    ],
    "grossing": [
        "gross"
    ],
    "grossest": [
        "gross"
    ],
    "ulsters": [
        "ulster"
    ],
    "harbours": [
        "harbour"
    ],
    "harbouring": [
        "harbour"
    ],
    "harboured": [
        "harbour"
    ],
    "dosed": [
        "dose"
    ],
    "dosing": [
        "dose"
    ],
    "murmured": [
        "murmur"
    ],
    "murmuring": [
        "murmur"
    ],
    "murmurs": [
        "murmur"
    ],
    "rawest": [
        "raw"
    ],
    "cottons": [
        "cotton"
    ],
    "cottoned": [
        "cotton"
    ],
    "cottoning": [
        "cotton"
    ],
    "exposures": [
        "exposure"
    ],
    "integrations": [
        "integration"
    ],
    "ratted": [
        "rat"
    ],
    "ratting": [
        "rat"
    ],
    "horrors": [
        "horror"
    ],
    "decreased": [
        "decrease"
    ],
    "decreases": [
        "decrease"
    ],
    "decreasing": [
        "decrease"
    ],
    "junctions": [
        "junction"
    ],
    "purchasers": [
        "purchaser"
    ],
    "eliminated": [
        "eliminate"
    ],
    "eliminating": [
        "eliminate"
    ],
    "eliminates": [
        "eliminate"
    ],
    "fleshed": [
        "flesh"
    ],
    "fleshing": [
        "flesh"
    ],
    "fleshes": [
        "flesh"
    ],
    "grasped": [
        "grasp"
    ],
    "grasping": [
        "grasp"
    ],
    "grasps": [
        "grasp"
    ],
    "clashes": [
        "clash"
    ],
    "clashed": [
        "clash"
    ],
    "clashing": [
        "clash"
    ],
    "illegals": [
        "illegal"
    ],
    "imperials": [
        "imperial"
    ],
    "informals": [
        "informal"
    ],
    "outers": [
        "outer"
    ],
    "floating": [
        "float"
    ],
    "floated": [
        "float"
    ],
    "floats": [
        "float"
    ],
    "garies": [
        "gary"
    ],
    "companions": [
        "companion"
    ],
    "fragmented": [
        "fragment"
    ],
    "fragmenting": [
        "fragment"
    ],
    "makers": [
        "maker"
    ],
    "constables": [
        "constable"
    ],
    "stricter": [
        "strict"
    ],
    "strictest": [
        "strict"
    ],
    "boroughs": [
        "borough"
    ],
    "composed": [
        "compose"
    ],
    "composing": [
        "compose"
    ],
    "mummies": [
        "mummy"
    ],
    "singers": [
        "singer"
    ],
    "premiums": [
        "premium"
    ],
    "mayors": [
        "mayor"
    ],
    "planets": [
        "planet"
    ],
    "conveyed": [
        "convey"
    ],
    "conveying": [
        "convey"
    ],
    "conveys": [
        "convey"
    ],
    "fences": [
        "fence"
    ],
    "fenced": [
        "fence"
    ],
    "fencing": [
        "fence"
    ],
    "registrations": [
        "registration"
    ],
    "vendors": [
        "vendor"
    ],
    "wiped": [
        "wipe"
    ],
    "wiping": [
        "wipe"
    ],
    "wipes": [
        "wipe"
    ],
    "exacted": [
        "exact"
    ],
    "exacting": [
        "exact"
    ],
    "cleverer": [
        "clever"
    ],
    "cleverest": [
        "clever"
    ],
    "essays": [
        "essay"
    ],
    "essayed": [
        "essay"
    ],
    "essaying": [
        "essay"
    ],
    "cliffs": [
        "cliff"
    ],
    "discs": [
        "disc"
    ],
    "terraces": [
        "terrace"
    ],
    "commissioners": [
        "commissioner"
    ],
    "fostered": [
        "foster"
    ],
    "fostering": [
        "foster"
    ],
    "fosters": [
        "foster"
    ],
    "wandered": [
        "wander"
    ],
    "wandering": [
        "wander"
    ],
    "wanders": [
        "wander"
    ],
    "emperors": [
        "emperor"
    ],
    "commanders": [
        "commander"
    ],
    "sacked": [
        "sack"
    ],
    "sacks": [
        "sack"
    ],
    "sacking": [
        "sack"
    ],
    "confronted": [
        "confront"
    ],
    "confronting": [
        "confront"
    ],
    "confronts": [
        "confront"
    ],
    "dutches": [
        "dutch"
    ],
    "frozen": [
        "freeze"
    ],
    "froze": [
        "freeze"
    ],
    "freezes": [
        "freeze"
    ],
    "freezing": [
        "freeze"
    ],
    "particles": [
        "particle"
    ],
    "funerals": [
        "funeral"
    ],
    "subsidiaries": [
        "subsidiary"
    ],
    "automatics": [
        "automatic"
    ],
    "chapels": [
        "chapel"
    ],
    "anticipated": [
        "anticipate"
    ],
    "anticipating": [
        "anticipate"
    ],
    "anticipates": [
        "anticipate"
    ],
    "exhibited": [
        "exhibit"
    ],
    "exhibits": [
        "exhibit"
    ],
    "exhibiting": [
        "exhibit"
    ],
    "organs": [
        "organ"
    ],
    "shores": [
        "shore"
    ],
    "shoring": [
        "shore"
    ],
    "shored": [
        "shore"
    ],
    "orals": [
        "oral"
    ],
    "anthonies": [
        "anthony"
    ],
    "grained": [
        "grain"
    ],
    "graining": [
        "grain"
    ],
    "merits": [
        "merit"
    ],
    "merited": [
        "merit"
    ],
    "meriting": [
        "merit"
    ],
    "retailing": [
        "retail"
    ],
    "retails": [
        "retail"
    ],
    "retailed": [
        "retail"
    ],
    "bakers": [
        "baker"
    ],
    "suspended": [
        "suspend"
    ],
    "suspending": [
        "suspend"
    ],
    "friendships": [
        "friendship"
    ],
    "republicans": [
        "republican"
    ],
    "dublins": [
        "dublin"
    ],
    "weighed": [
        "weigh"
    ],
    "weighing": [
        "weigh"
    ],
    "weighs": [
        "weigh"
    ],
    "ethnics": [
        "ethnic"
    ],
    "fleets": [
        "fleet"
    ],
    "fleeting": [
        "fleet"
    ],
    "incentives": [
        "incentive"
    ],
    "toys": [
        "toy"
    ],
    "toyed": [
        "toy"
    ],
    "toying": [
        "toy"
    ],
    "punched": [
        "punch"
    ],
    "punches": [
        "punch"
    ],
    "punching": [
        "punch"
    ],
    "carriages": [
        "carriage"
    ],
    "rallied": [
        "rally"
    ],
    "rallying": [
        "rally"
    ],
    "needles": [
        "needle"
    ],
    "needling": [
        "needle"
    ],
    "needled": [
        "needle"
    ],
    "spirituals": [
        "spiritual"
    ],
    "garaged": [
        "garage"
    ],
    "garaging": [
        "garage"
    ],
    "kitted": [
        "kit"
    ],
    "kitting": [
        "kit"
    ],
    "kiting": [
        "kit"
    ],
    "nicholass": [
        "nicholas"
    ],
    "petrols": [
        "petrol"
    ],
    "rationals": [
        "rational"
    ],
    "logicals": [
        "logical"
    ],
    "disposals": [
        "disposal"
    ],
    "essexes": [
        "essex"
    ],
    "fates": [
        "fate"
    ],
    "fated": [
        "fate"
    ],
    "fatest": [
        "fate"
    ],
    "acutes": [
        "acute"
    ],
    "acutest": [
        "acute"
    ],
    "spun": [
        "spin"
    ],
    "spinning": [
        "spin"
    ],
    "spins": [
        "spin"
    ],
    "flames": [
        "flame"
    ],
    "flamed": [
        "flame"
    ],
    "flaming": [
        "flame"
    ],
    "bikes": [
        "bike"
    ],
    "biking": [
        "bike"
    ],
    "biked": [
        "bike"
    ],
    "dianas": [
        "diana"
    ],
    "correspondents": [
        "correspondent"
    ],
    "prominents": [
        "prominent"
    ],
    "mortalities": [
        "mortality"
    ],
    "electricals": [
        "electrical"
    ],
    "silks": [
        "silk"
    ],
    "olivers": [
        "oliver"
    ],
    "logics": [
        "logic"
    ],
    "condemned": [
        "condemn"
    ],
    "condemning": [
        "condemn"
    ],
    "condemns": [
        "condemn"
    ],
    "nowheres": [
        "nowhere"
    ],
    "cancelled": [
        "cancel"
    ],
    "cancelling": [
        "cancel"
    ],
    "cancels": [
        "cancel"
    ],
    "minerals": [
        "mineral"
    ],
    "nails": [
        "nail"
    ],
    "nailed": [
        "nail"
    ],
    "nailing": [
        "nail"
    ],
    "angels": [
        "angel"
    ],
    "calculations": [
        "calculation"
    ],
    "modified": [
        "modify"
    ],
    "modifying": [
        "modify"
    ],
    "thrusting": [
        "thrust"
    ],
    "thrusts": [
        "thrust"
    ],
    "withdrawals": [
        "withdrawal"
    ],
    "voters": [
        "voter"
    ],
    "matured": [
        "mature"
    ],
    "maturing": [
        "mature"
    ],
    "maturest": [
        "mature"
    ],
    "panned": [
        "pan"
    ],
    "panning": [
        "pan"
    ],
    "corresponding": [
        "correspond"
    ],
    "corresponded": [
        "correspond"
    ],
    "dictionaries": [
        "dictionary"
    ],
    "humours": [
        "humour"
    ],
    "humouring": [
        "humour"
    ],
    "humoured": [
        "humour"
    ],
    "devised": [
        "devise"
    ],
    "devising": [
        "devise"
    ],
    "entertainments": [
        "entertainment"
    ],
    "undergrounding": [
        "underground"
    ],
    "equities": [
        "equity"
    ],
    "rubbished": [
        "rubbish"
    ],
    "rubbishing": [
        "rubbish"
    ],
    "rubbishes": [
        "rubbish"
    ],
    "eras": [
        "era"
    ],
    "coverages": [
        "coverage"
    ],
    "complexities": [
        "complexity"
    ],
    "youngsters": [
        "youngster"
    ],
    "inspired": [
        "inspire"
    ],
    "inspiring": [
        "inspire"
    ],
    "mutuals": [
        "mutual"
    ],
    "squeezed": [
        "squeeze"
    ],
    "squeezing": [
        "squeeze"
    ],
    "squeezes": [
        "squeeze"
    ],
    "competitors": [
        "competitor"
    ],
    "neglected": [
        "neglect"
    ],
    "neglecting": [
        "neglect"
    ],
    "neglects": [
        "neglect"
    ],
    "asians": [
        "asian"
    ],
    "sworn": [
        "swear"
    ],
    "swore": [
        "swear"
    ],
    "swearing": [
        "swear"
    ],
    "swears": [
        "swear"
    ],
    "millers": [
        "miller"
    ],
    "marginals": [
        "marginal"
    ],
    "rumours": [
        "rumour"
    ],
    "rumoured": [
        "rumour"
    ],
    "chatting": [
        "chat"
    ],
    "chatted": [
        "chat"
    ],
    "broadcasts": [
        "broadcast"
    ],
    "broadcasting": [
        "broadcast"
    ],
    "broadcasted": [
        "broadcast"
    ],
    "forths": [
        "forth"
    ],
    "atlantics": [
        "atlantic"
    ],
    "induced": [
        "induce"
    ],
    "induces": [
        "induce"
    ],
    "inducing": [
        "induce"
    ],
    "robbed": [
        "rob"
    ],
    "robbing": [
        "rob"
    ],
    "robs": [
        "rob"
    ],
    "showers": [
        "shower"
    ],
    "showered": [
        "shower"
    ],
    "showering": [
        "shower"
    ],
    "turkeys": [
        "turkey"
    ],
    "flags": [
        "flag"
    ],
    "flagged": [
        "flag"
    ],
    "flagging": [
        "flag"
    ],
    "jews": [
        "jew"
    ],
    "mrs.s": [
        "mrs."
    ],
    "rubbed": [
        "rub"
    ],
    "rubbing": [
        "rub"
    ],
    "rubs": [
        "rub"
    ],
    "rovers": [
        "rover"
    ],
    "triumphs": [
        "triumph"
    ],
    "triumphed": [
        "triumph"
    ],
    "triumphing": [
        "triumph"
    ],
    "farmings": [
        "farming"
    ],
    "isles": [
        "isle"
    ],
    "disabilities": [
        "disability"
    ],
    "integrated": [
        "integrate"
    ],
    "integrating": [
        "integrate"
    ],
    "integrates": [
        "integrate"
    ],
    "faintest": [
        "faint"
    ],
    "fainted": [
        "faint"
    ],
    "fainter": [
        "faint"
    ],
    "fainting": [
        "faint"
    ],
    "faints": [
        "faint"
    ],
    "clinics": [
        "clinic"
    ],
    "strangers": [
        "stranger"
    ],
    "beams": [
        "beam"
    ],
    "beamed": [
        "beam"
    ],
    "beaming": [
        "beam"
    ],
    "cured": [
        "cure"
    ],
    "curing": [
        "cure"
    ],
    "slices": [
        "slice"
    ],
    "sliced": [
        "slice"
    ],
    "slicing": [
        "slice"
    ],
    "convinced": [
        "convince"
    ],
    "convincing": [
        "convince"
    ],
    "convinces": [
        "convince"
    ],
    "californias": [
        "california"
    ],
    "accountants": [
        "accountant"
    ],
    "frowned": [
        "frown"
    ],
    "frowning": [
        "frown"
    ],
    "frowns": [
        "frown"
    ],
    "statutes": [
        "statute"
    ],
    "knitting": [
        "knit"
    ],
    "knitted": [
        "knit"
    ],
    "knits": [
        "knit"
    ],
    "lambs": [
        "lamb"
    ],
    "ropes": [
        "rope"
    ],
    "roped": [
        "rope"
    ],
    "roping": [
        "rope"
    ],
    "processors": [
        "processor"
    ],
    "bulling": [
        "bull"
    ],
    "reigns": [
        "reign"
    ],
    "reigned": [
        "reign"
    ],
    "reigning": [
        "reign"
    ],
    "bulked": [
        "bulk"
    ],
    "bulking": [
        "bulk"
    ],
    "bulks": [
        "bulk"
    ],
    "domains": [
        "domain"
    ],
    "egypts": [
        "egypt"
    ],
    "buttered": [
        "butter"
    ],
    "buttering": [
        "butter"
    ],
    "butters": [
        "butter"
    ],
    "removals": [
        "removal"
    ],
    "banging": [
        "bang"
    ],
    "banged": [
        "bang"
    ],
    "sheffields": [
        "sheffield"
    ],
    "damning": [
        "damn"
    ],
    "damns": [
        "damn"
    ],
    "publishings": [
        "publishing"
    ],
    "skirts": [
        "skirt"
    ],
    "skirted": [
        "skirt"
    ],
    "skirting": [
        "skirt"
    ],
    "organics": [
        "organic"
    ],
    "anniversaries": [
        "anniversary"
    ],
    "civilians": [
        "civilian"
    ],
    "westminsters": [
        "westminster"
    ],
    "translated": [
        "translate"
    ],
    "translating": [
        "translate"
    ],
    "monopolies": [
        "monopoly"
    ],
    "daddies": [
        "daddy"
    ],
    "docked": [
        "dock"
    ],
    "docking": [
        "dock"
    ],
    "dumped": [
        "dump"
    ],
    "dumps": [
        "dump"
    ],
    "stabilities": [
        "stability"
    ],
    "miners": [
        "miner"
    ],
    "drilling": [
        "drill"
    ],
    "drilled": [
        "drill"
    ],
    "drills": [
        "drill"
    ],
    "nests": [
        "nest"
    ],
    "nesting": [
        "nest"
    ],
    "nested": [
        "nest"
    ],
    "gloucestershires": [
        "gloucestershire"
    ],
    "jailed": [
        "jail"
    ],
    "jails": [
        "jail"
    ],
    "jailing": [
        "jail"
    ],
    "shortages": [
        "shortage"
    ],
    "mergers": [
        "merger"
    ],
    "tribunals": [
        "tribunal"
    ],
    "stitches": [
        "stitch"
    ],
    "stitched": [
        "stitch"
    ],
    "stitching": [
        "stitch"
    ],
    "curiouser": [
        "curious"
    ],
    "jurisdictions": [
        "jurisdiction"
    ],
    "adjustments": [
        "adjustment"
    ],
    "alerted": [
        "alert"
    ],
    "alerting": [
        "alert"
    ],
    "alerts": [
        "alert"
    ],
    "christophers": [
        "christopher"
    ],
    "controversies": [
        "controversy"
    ],
    "insects": [
        "insect"
    ],
    "rendered": [
        "render"
    ],
    "renders": [
        "render"
    ],
    "rendering": [
        "render"
    ],
    "sanctioned": [
        "sanction"
    ],
    "sanctioning": [
        "sanction"
    ],
    "alberts": [
        "albert"
    ],
    "kellies": [
        "kelly"
    ],
    "rachels": [
        "rachel"
    ],
    "cms": [
        "cm"
    ],
    "shamed": [
        "shame"
    ],
    "shames": [
        "shame"
    ],
    "shaming": [
        "shame"
    ],
    "donned": [
        "don"
    ],
    "donning": [
        "don"
    ],
    "lawrences": [
        "lawrence"
    ],
    "inserted": [
        "insert"
    ],
    "inserting": [
        "insert"
    ],
    "panicking": [
        "panic"
    ],
    "panics": [
        "panic"
    ],
    "panicked": [
        "panick",
        "panic"
    ],
    "cloths": [
        "cloth"
    ],
    "dotted": [
        "dot"
    ],
    "dotting": [
        "dot"
    ],
    "stuarts": [
        "stuart"
    ],
    "sussexes": [
        "sussex"
    ],
    "ganging": [
        "gang"
    ],
    "ganged": [
        "gang"
    ],
    "tides": [
        "tide"
    ],
    "tiding": [
        "tide"
    ],
    "tided": [
        "tide"
    ],
    "russells": [
        "russell"
    ],
    "greeted": [
        "greet"
    ],
    "greeting": [
        "greet"
    ],
    "greets": [
        "greet"
    ],
    "clothings": [
        "clothing"
    ],
    "initiated": [
        "initiate"
    ],
    "initiating": [
        "initiate"
    ],
    "initiates": [
        "initiate"
    ],
    "devoted": [
        "devote"
    ],
    "devoting": [
        "devote"
    ],
    "bankings": [
        "banking"
    ],
    "stewarts": [
        "stewart"
    ],
    "taxiing": [
        "taxi"
    ],
    "taxied": [
        "taxi"
    ],
    "louiss": [
        "louis"
    ],
    "polands": [
        "poland"
    ],
    "effectivenesses": [
        "effectiveness"
    ],
    "passings": [
        "passing"
    ],
    "laughters": [
        "laughter"
    ],
    "tournaments": [
        "tournament"
    ],
    "accommodated": [
        "accommodate"
    ],
    "accommodating": [
        "accommodate"
    ],
    "accommodates": [
        "accommodate"
    ],
    "romantics": [
        "romantic"
    ],
    "admired": [
        "admire"
    ],
    "admiring": [
        "admire"
    ],
    "receipts": [
        "receipt"
    ],
    "aces": [
        "ace"
    ],
    "accordances": [
        "accordance"
    ],
    "overlooked": [
        "overlook"
    ],
    "overlooking": [
        "overlook"
    ],
    "overlooks": [
        "overlook"
    ],
    "complied": [
        "comply"
    ],
    "complying": [
        "comply"
    ],
    "sheers": [
        "sheer"
    ],
    "sheered": [
        "sheer"
    ],
    "sheering": [
        "sheer"
    ],
    "fled": [
        "flee"
    ],
    "fleeing": [
        "flee"
    ],
    "flees": [
        "flee"
    ],
    "asserted": [
        "assert"
    ],
    "asserting": [
        "assert"
    ],
    "asserts": [
        "assert"
    ],
    "criticised": [
        "criticise"
    ],
    "criticising": [
        "criticise"
    ],
    "criticises": [
        "criticise"
    ],
    "versed": [
        "verse"
    ],
    "tendered": [
        "tender"
    ],
    "tendering": [
        "tender"
    ],
    "tenderest": [
        "tender"
    ],
    "disadvantages": [
        "disadvantage"
    ],
    "disadvantaged": [
        "disadvantage"
    ],
    "disadvantaging": [
        "disadvantage"
    ],
    "probed": [
        "probe"
    ],
    "probing": [
        "probe"
    ],
    "thamess": [
        "thames"
    ],
    "advertisements": [
        "advertisement"
    ],
    "shields": [
        "shield"
    ],
    "shielded": [
        "shield"
    ],
    "shielding": [
        "shield"
    ],
    "graphicss": [
        "graphics"
    ],
    "testings": [
        "testing"
    ],
    "adventures": [
        "adventure"
    ],
    "adventuring": [
        "adventure"
    ],
    "adventured": [
        "adventure"
    ],
    "embraced": [
        "embrace"
    ],
    "embracing": [
        "embrace"
    ],
    "embraces": [
        "embrace"
    ],
    "evolved": [
        "evolve"
    ],
    "evolving": [
        "evolve"
    ],
    "evolves": [
        "evolve"
    ],
    "rhythms": [
        "rhythm"
    ],
    "hardwares": [
        "hardware"
    ],
    "navies": [
        "navy"
    ],
    "stimulated": [
        "stimulate"
    ],
    "stimulates": [
        "stimulate"
    ],
    "stimulating": [
        "stimulate"
    ],
    "toilets": [
        "toilet"
    ],
    "undermined": [
        "undermine"
    ],
    "undermining": [
        "undermine"
    ],
    "undermines": [
        "undermine"
    ],
    "chemistries": [
        "chemistry"
    ],
    "bernards": [
        "bernard"
    ],
    "disturbed": [
        "disturb"
    ],
    "disturbing": [
        "disturb"
    ],
    "disturbs": [
        "disturb"
    ],
    "enforced": [
        "enforce"
    ],
    "enforcing": [
        "enforce"
    ],
    "enforces": [
        "enforce"
    ],
    "shelters": [
        "shelter"
    ],
    "sheltered": [
        "shelter"
    ],
    "sheltering": [
        "shelter"
    ],
    "propositioned": [
        "proposition"
    ],
    "propositioning": [
        "proposition"
    ],
    "abbeys": [
        "abbey"
    ],
    "boomed": [
        "boom"
    ],
    "booming": [
        "boom"
    ],
    "fluids": [
        "fluid"
    ],
    "necessities": [
        "necessity"
    ],
    "thee": [
        "thou"
    ],
    "thy": [
        "thou"
    ],
    "thine": [
        "thou"
    ],
    "myths": [
        "myth"
    ],
    "servers": [
        "server"
    ],
    "widows": [
        "widow"
    ],
    "widowed": [
        "widow"
    ],
    "monthlies": [
        "monthly"
    ],
    "interrupted": [
        "interrupt"
    ],
    "interrupting": [
        "interrupt"
    ],
    "interrupts": [
        "interrupt"
    ],
    "fightings": [
        "fighting"
    ],
    "provoked": [
        "provoke"
    ],
    "provoking": [
        "provoke"
    ],
    "provokes": [
        "provoke"
    ],
    "hesitated": [
        "hesitate"
    ],
    "hesitating": [
        "hesitate"
    ],
    "hesitates": [
        "hesitate"
    ],
    "awaiting": [
        "await"
    ],
    "awaited": [
        "await"
    ],
    "awaits": [
        "await"
    ],
    "eighteenths": [
        "eighteenth"
    ],
    "genders": [
        "gender"
    ],
    "gendered": [
        "gender"
    ],
    "sandwiched": [
        "sandwich"
    ],
    "sandwiching": [
        "sandwich"
    ],
    "handicapped": [
        "handicap"
    ],
    "handicapping": [
        "handicap"
    ],
    "gayer": [
        "gay"
    ],
    "gayest": [
        "gay"
    ],
    "lamps": [
        "lamp"
    ],
    "damped": [
        "damp"
    ],
    "damper": [
        "damp"
    ],
    "damping": [
        "damp"
    ],
    "damps": [
        "damp"
    ],
    "dampest": [
        "damp"
    ],
    "situated": [
        "situate"
    ],
    "situates": [
        "situate"
    ],
    "situating": [
        "situate"
    ],
    "wrights": [
        "wright"
    ],
    "emphasized": [
        "emphasize"
    ],
    "emphasizes": [
        "emphasize"
    ],
    "emphasizing": [
        "emphasize"
    ],
    "restorations": [
        "restoration"
    ],
    "wildlives": [
        "wildlife"
    ],
    "clues": [
        "clue"
    ],
    "clued": [
        "clue"
    ],
    "nobler": [
        "noble"
    ],
    "noblest": [
        "noble"
    ],
    "manors": [
        "manor"
    ],
    "lorries": [
        "lorry"
    ],
    "viruses": [
        "virus"
    ],
    "artificials": [
        "artificial"
    ],
    "muttered": [
        "mutter"
    ],
    "muttering": [
        "mutter"
    ],
    "mutters": [
        "mutter"
    ],
    "heatings": [
        "heating"
    ],
    "airlines": [
        "airline"
    ],
    "jacksons": [
        "jackson"
    ],
    "dcs": [
        "dc"
    ],
    "institutionals": [
        "institutional"
    ],
    "irans": [
        "iran"
    ],
    "pitied": [
        "pity"
    ],
    "pitying": [
        "pity"
    ],
    "mechanicals": [
        "mechanical"
    ],
    "biologicals": [
        "biological"
    ],
    "braved": [
        "brave"
    ],
    "bravest": [
        "brave"
    ],
    "braving": [
        "brave"
    ],
    "creditors": [
        "creditor"
    ],
    "nationalists": [
        "nationalist"
    ],
    "luxuries": [
        "luxury"
    ],
    "flexibilities": [
        "flexibility"
    ],
    "circulars": [
        "circular"
    ],
    "intents": [
        "intent"
    ],
    "leaflets": [
        "leaflet"
    ],
    "leafleting": [
        "leaflet"
    ],
    "leafleted": [
        "leaflet"
    ],
    "forgiven": [
        "forgive"
    ],
    "forgave": [
        "forgive"
    ],
    "forgives": [
        "forgive"
    ],
    "forgiving": [
        "forgive"
    ],
    "sins": [
        "sin"
    ],
    "sinned": [
        "sin"
    ],
    "sinning": [
        "sin"
    ],
    "smarter": [
        "smart"
    ],
    "smarting": [
        "smart"
    ],
    "smartest": [
        "smart"
    ],
    "smarted": [
        "smart"
    ],
    "smarts": [
        "smart"
    ],
    "functionals": [
        "functional"
    ],
    "spectra": [
        "spectrum"
    ],
    "spectrums": [
        "spectrum"
    ],
    "logs": [
        "log"
    ],
    "logged": [
        "log"
    ],
    "logging": [
        "log"
    ],
    "warmths": [
        "warmth"
    ],
    "worshipped": [
        "worship"
    ],
    "worships": [
        "worship"
    ],
    "worshipping": [
        "worship"
    ],
    "pensioners": [
        "pensioner"
    ],
    "thefts": [
        "theft"
    ],
    "computings": [
        "computing"
    ],
    "ghosts": [
        "ghost"
    ],
    "ghosted": [
        "ghost"
    ],
    "ghosting": [
        "ghost"
    ],
    "iraqis": [
        "iraqi"
    ],
    "attendances": [
        "attendance"
    ],
    "coppers": [
        "copper"
    ],
    "indicators": [
        "indicator"
    ],
    "rituals": [
        "ritual"
    ],
    "elaborated": [
        "elaborate"
    ],
    "elaborating": [
        "elaborate"
    ],
    "elaborates": [
        "elaborate"
    ],
    "petting": [
        "pet"
    ],
    "petted": [
        "pet"
    ],
    "kms": [
        "km"
    ],
    "loyalties": [
        "loyalty"
    ],
    "sociologies": [
        "sociology"
    ],
    "spectaculars": [
        "spectacular"
    ],
    "pardoned": [
        "pardon"
    ],
    "pardoning": [
        "pardon"
    ],
    "portfolios": [
        "portfolio"
    ],
    "successors": [
        "successor"
    ],
    "harriss": [
        "harris"
    ],
    "sacrificed": [
        "sacrifice"
    ],
    "sacrificing": [
        "sacrifice"
    ],
    "pursuits": [
        "pursuit"
    ],
    "productivities": [
        "productivity"
    ],
    "figs": [
        "fig"
    ],
    "figging": [
        "fig"
    ],
    "probabilities": [
        "probability"
    ],
    "virgins": [
        "virgin"
    ],
    "dulled": [
        "dull"
    ],
    "duller": [
        "dull"
    ],
    "dullest": [
        "dull"
    ],
    "dulling": [
        "dull"
    ],
    "dulls": [
        "dull"
    ],
    "chaps": [
        "chap"
    ],
    "chapping": [
        "chap"
    ],
    "chapped": [
        "chap"
    ],
    "developers": [
        "developer"
    ],
    "fora": [
        "forum"
    ],
    "availabilities": [
        "availability"
    ],
    "eds": [
        "ed"
    ],
    "eder": [
        "ed"
    ],
    "painters": [
        "painter"
    ],
    "fares": [
        "fare"
    ],
    "fared": [
        "fare"
    ],
    "faring": [
        "fare"
    ],
    "refusals": [
        "refusal"
    ],
    "overnights": [
        "overnight"
    ],
    "seminars": [
        "seminar"
    ],
    "equipped": [
        "equip"
    ],
    "equipping": [
        "equip"
    ],
    "equips": [
        "equip"
    ],
    "rafs": [
        "raf"
    ],
    "breedings": [
        "breeding"
    ],
    "devils": [
        "devil"
    ],
    "devilled": [
        "devil"
    ],
    "devilling": [
        "devil"
    ],
    "flavours": [
        "flavour"
    ],
    "flavoured": [
        "flavour"
    ],
    "flavouring": [
        "flavour"
    ],
    "hammered": [
        "hammer"
    ],
    "hammering": [
        "hammer"
    ],
    "hammers": [
        "hammer"
    ],
    "landings": [
        "landing"
    ],
    "curled": [
        "curl"
    ],
    "curls": [
        "curl"
    ],
    "begged": [
        "beg"
    ],
    "begging": [
        "beg"
    ],
    "begs": [
        "beg"
    ],
    "consumed": [
        "consume"
    ],
    "consuming": [
        "consume"
    ],
    "retreated": [
        "retreat"
    ],
    "retreating": [
        "retreat"
    ],
    "retreats": [
        "retreat"
    ],
    "steeper": [
        "steep"
    ],
    "steeped": [
        "steep"
    ],
    "steepest": [
        "steep"
    ],
    "steeping": [
        "steep"
    ],
    "steeps": [
        "steep"
    ],
    "nasties": [
        "nasty"
    ],
    "nastier": [
        "nasty"
    ],
    "nastiest": [
        "nasty"
    ],
    "unfairest": [
        "unfair"
    ],
    "eliots": [
        "eliot"
    ],
    "builders": [
        "builder"
    ],
    "marxes": [
        "marx"
    ],
    "durations": [
        "duration"
    ],
    "analysts": [
        "analyst"
    ],
    "continentals": [
        "continental"
    ],
    "heels": [
        "heel"
    ],
    "heeled": [
        "heel"
    ],
    "heeling": [
        "heel"
    ],
    "masks": [
        "mask"
    ],
    "masked": [
        "mask"
    ],
    "masking": [
        "mask"
    ],
    "oxygens": [
        "oxygen"
    ],
    "aidss": [
        "aids"
    ],
    "frauds": [
        "fraud"
    ],
    "discretions": [
        "discretion"
    ],
    "lifetimes": [
        "lifetime"
    ],
    "comings": [
        "coming"
    ],
    "receivers": [
        "receiver"
    ],
    "capitalisms": [
        "capitalism"
    ],
    "juices": [
        "juice"
    ],
    "riots": [
        "riot"
    ],
    "rioted": [
        "riot"
    ],
    "rioting": [
        "riot"
    ],
    "oaks": [
        "oak"
    ],
    "prejudiced": [
        "prejudice"
    ],
    "prejudicing": [
        "prejudice"
    ],
    "united": [
        "unite"
    ],
    "uniting": [
        "unite"
    ],
    "appendixes": [
        "appendix"
    ],
    "densities": [
        "density"
    ],
    "sculptured": [
        "sculpture"
    ],
    "sculpturing": [
        "sculpture"
    ],
    "faded": [
        "fade"
    ],
    "shits": [
        "shit"
    ],
    "shitting": [
        "shit"
    ],
    "shitted": [
        "shit"
    ],
    "shat": [
        "shit"
    ],
    "muds": [
        "mud"
    ],
    "mudding": [
        "mud"
    ],
    "mudded": [
        "mud"
    ],
    "polytechnics": [
        "polytechnic"
    ],
    "jetting": [
        "jet"
    ],
    "jetted": [
        "jet"
    ],
    "palestinians": [
        "palestinian"
    ],
    "unionists": [
        "unionist"
    ],
    "executed": [
        "execute"
    ],
    "executing": [
        "execute"
    ],
    "leicesters": [
        "leicester"
    ],
    "liberties": [
        "liberty"
    ],
    "libertys": [
        "liberty"
    ],
    "coloureds": [
        "coloured"
    ],
    "hips": [
        "hip"
    ],
    "hippest": [
        "hip"
    ],
    "hipper": [
        "hip"
    ],
    "unhappier": [
        "unhappy"
    ],
    "unhappiest": [
        "unhappy"
    ],
    "abolished": [
        "abolish"
    ],
    "abolishing": [
        "abolish"
    ],
    "abolishes": [
        "abolish"
    ],
    "hunters": [
        "hunter"
    ],
    "educated": [
        "educate"
    ],
    "educating": [
        "educate"
    ],
    "educates": [
        "educate"
    ],
    "deans": [
        "dean"
    ],
    "rods": [
        "rod"
    ],
    "rodding": [
        "rod"
    ],
    "bureaus": [
        "bureau"
    ],
    "apartments": [
        "apartment"
    ],
    "administered": [
        "administer"
    ],
    "administering": [
        "administer"
    ],
    "administers": [
        "administer"
    ],
    "diagnoses": [
        "diagnosis",
        "diagnose"
    ],
    "palms": [
        "palm"
    ],
    "palmed": [
        "palm"
    ],
    "palming": [
        "palm"
    ],
    "triggered": [
        "trigger"
    ],
    "triggers": [
        "trigger"
    ],
    "triggering": [
        "trigger"
    ],
    "egs": [
        "eg"
    ],
    "moors": [
        "moor"
    ],
    "moored": [
        "moor"
    ],
    "mooring": [
        "moor"
    ],
    "headings": [
        "heading"
    ],
    "norms": [
        "norm"
    ],
    "knights": [
        "knight"
    ],
    "knighted": [
        "knight"
    ],
    "knighting": [
        "knight"
    ],
    "aggregates": [
        "aggregate"
    ],
    "aggregated": [
        "aggregate"
    ],
    "aggregating": [
        "aggregate"
    ],
    "aggregated.": [
        "aggregate"
    ],
    "couped": [
        "coup"
    ],
    "alleged": [
        "allege"
    ],
    "alleging": [
        "allege"
    ],
    "strands": [
        "strand"
    ],
    "stranded": [
        "strand"
    ],
    "stranding": [
        "strand"
    ],
    "inns": [
        "inn"
    ],
    "musicians": [
        "musician"
    ],
    "clusters": [
        "cluster"
    ],
    "clustered": [
        "cluster"
    ],
    "clustering": [
        "cluster"
    ],
    "cupboards": [
        "cupboard"
    ],
    "defenders": [
        "defender"
    ],
    "physicss": [
        "physics"
    ],
    "preliminaries": [
        "preliminary"
    ],
    "blasted": [
        "blast"
    ],
    "blasts": [
        "blast"
    ],
    "blasting": [
        "blast"
    ],
    "subsidies": [
        "subsidy"
    ],
    "tutors": [
        "tutor"
    ],
    "tutoring": [
        "tutor"
    ],
    "tutored": [
        "tutor"
    ],
    "hedges": [
        "hedge"
    ],
    "hedged": [
        "hedge"
    ],
    "hedging": [
        "hedge"
    ],
    "isolated": [
        "isolate"
    ],
    "isolates": [
        "isolate"
    ],
    "isolating": [
        "isolate"
    ],
    "israelis": [
        "israeli"
    ],
    "canadians": [
        "canadian"
    ],
    "verticals": [
        "vertical"
    ],
    "cardiffs": [
        "cardiff"
    ],
    "directories": [
        "directory"
    ],
    "collectors": [
        "collector"
    ],
    "glories": [
        "glory"
    ],
    "gloried": [
        "glory"
    ],
    "glorying": [
        "glory"
    ],
    "casuals": [
        "casual"
    ],
    "envisaged": [
        "envisage"
    ],
    "envisaging": [
        "envisage"
    ],
    "morgans": [
        "morgan"
    ],
    "warranted": [
        "warrant"
    ],
    "warranting": [
        "warrant"
    ],
    "capabilities": [
        "capability"
    ],
    "vietnams": [
        "vietnam"
    ],
    "obscured": [
        "obscure"
    ],
    "obscuring": [
        "obscure"
    ],
    "obscurer": [
        "obscure"
    ],
    "obscurest": [
        "obscure"
    ],
    "beans": [
        "bean"
    ],
    "screwed": [
        "screw"
    ],
    "screws": [
        "screw"
    ],
    "screwing": [
        "screw"
    ],
    "evanss": [
        "evans"
    ],
    "hungrier": [
        "hungry"
    ],
    "hungriest": [
        "hungry"
    ],
    "res": [
        "re"
    ],
    "autonomies": [
        "autonomy"
    ],
    "elders": [
        "elder"
    ],
    "accented": [
        "accent"
    ],
    "accenting": [
        "accent"
    ],
    "caved": [
        "cave"
    ],
    "caving": [
        "cave"
    ],
    "tactics": [
        "tactic"
    ],
    "trainers": [
        "trainer"
    ],
    "diagrams": [
        "diagram"
    ],
    "diagrammed": [
        "diagram"
    ],
    "invented": [
        "invent"
    ],
    "inventing": [
        "invent"
    ],
    "invents": [
        "invent"
    ],
    "olympics": [
        "olympic"
    ],
    "entities": [
        "entity"
    ],
    "minuses": [
        "minus"
    ],
    "minusses": [
        "minus"
    ],
    "fantasies": [
        "fantasy"
    ],
    "assigned": [
        "assign"
    ],
    "assigning": [
        "assign"
    ],
    "assigns": [
        "assign"
    ],
    "consensuss": [
        "consensus"
    ],
    "midnights": [
        "midnight"
    ],
    "tropicals": [
        "tropical"
    ],
    "resembles": [
        "resemble"
    ],
    "resembled": [
        "resemble"
    ],
    "resembling": [
        "resemble"
    ],
    "catering": [
        "cater"
    ],
    "catered": [
        "cater"
    ],
    "caters": [
        "cater"
    ],
    "opted": [
        "opt"
    ],
    "opting": [
        "opt"
    ],
    "opts": [
        "opt"
    ],
    "founders": [
        "founder"
    ],
    "foundered": [
        "founder"
    ],
    "foundering": [
        "founder"
    ],
    "scratched": [
        "scratch"
    ],
    "scratches": [
        "scratch"
    ],
    "compacted": [
        "compact"
    ],
    "compacting": [
        "compact"
    ],
    "compacter": [
        "compact"
    ],
    "blanks": [
        "blank"
    ],
    "blanked": [
        "blank"
    ],
    "blanking": [
        "blank"
    ],
    "blanker": [
        "blank"
    ],
    "blankest": [
        "blank"
    ],
    "drummed": [
        "drum"
    ],
    "drumming": [
        "drum"
    ],
    "allens": [
        "allen"
    ],
    "killers": [
        "killer"
    ],
    "organisms": [
        "organism"
    ],
    "resumed": [
        "resume"
    ],
    "resuming": [
        "resume"
    ],
    "combating": [
        "combat"
    ],
    "combatting": [
        "combat"
    ],
    "combated": [
        "combat"
    ],
    "combatted": [
        "combat"
    ],
    "ferried": [
        "ferry"
    ],
    "ferrying": [
        "ferry"
    ],
    "huntings": [
        "hunting"
    ],
    "disclosed": [
        "disclose"
    ],
    "disclosing": [
        "disclose"
    ],
    "discloses": [
        "disclose"
    ],
    "petitioned": [
        "petition"
    ],
    "petitioning": [
        "petition"
    ],
    "scholars": [
        "scholar"
    ],
    "regulated": [
        "regulate"
    ],
    "regulating": [
        "regulate"
    ],
    "regulates": [
        "regulate"
    ],
    "morriss": [
        "morris"
    ],
    "eagles": [
        "eagle"
    ],
    "eagled": [
        "eagle"
    ],
    "offenders": [
        "offender"
    ],
    "traders": [
        "trader"
    ],
    "qing": [
        "q"
    ],
    "byes": [
        "bye"
    ],
    "batting": [
        "bat"
    ],
    "batted": [
        "bat"
    ],
    "conceded": [
        "concede"
    ],
    "conceding": [
        "concede"
    ],
    "edited": [
        "edit"
    ],
    "editing": [
        "edit"
    ],
    "lungs": [
        "lung"
    ],
    "lunging": [
        "lunge",
        "lung"
    ],
    "bastards": [
        "bastard"
    ],
    "pregnancies": [
        "pregnancy"
    ],
    "strode": [
        "stride"
    ],
    "strides": [
        "stride"
    ],
    "striding": [
        "stride"
    ],
    "stridden": [
        "stride"
    ],
    "strid": [
        "stride"
    ],
    "wools": [
        "wool"
    ],
    "riders": [
        "rider"
    ],
    "pakistans": [
        "pakistan"
    ],
    "constituents": [
        "constituent"
    ],
    "partials": [
        "partial"
    ],
    "bonuses": [
        "bonus"
    ],
    "fittings": [
        "fitting"
    ],
    "shakespeares": [
        "shakespeare"
    ],
    "strikings": [
        "striking"
    ],
    "easters": [
        "easter"
    ],
    "queries": [
        "query"
    ],
    "queried": [
        "query"
    ],
    "querying": [
        "query"
    ],
    "swimmings": [
        "swimming"
    ],
    "persisted": [
        "persist"
    ],
    "persists": [
        "persist"
    ],
    "persisting": [
        "persist"
    ],
    "conceived": [
        "conceive"
    ],
    "conceiving": [
        "conceive"
    ],
    "conceives": [
        "conceive"
    ],
    "auditors": [
        "auditor"
    ],
    "christianities": [
        "christianity"
    ],
    "trucking": [
        "truck"
    ],
    "trucked": [
        "truck"
    ],
    "ashes": [
        "ash"
    ],
    "craziest": [
        "crazy"
    ],
    "crazier": [
        "crazy"
    ],
    "crazies": [
        "crazy"
    ],
    "redundancies": [
        "redundancy"
    ],
    "defects": [
        "defect"
    ],
    "defected": [
        "defect"
    ],
    "defecting": [
        "defect"
    ],
    "fetched": [
        "fetch"
    ],
    "fetching": [
        "fetch"
    ],
    "fetches": [
        "fetch"
    ],
    "decks": [
        "deck"
    ],
    "decked": [
        "deck"
    ],
    "decking": [
        "deck"
    ],
    "clarks": [
        "clark"
    ],
    "correlations": [
        "correlation"
    ],
    "clays": [
        "clay"
    ],
    "inherited": [
        "inherit"
    ],
    "inheriting": [
        "inherit"
    ],
    "inherits": [
        "inherit"
    ],
    "instructed": [
        "instruct"
    ],
    "instructing": [
        "instruct"
    ],
    "instructs": [
        "instruct"
    ],
    "charms": [
        "charm"
    ],
    "charmed": [
        "charm"
    ],
    "charming": [
        "charm"
    ],
    "assignments": [
        "assignment"
    ],
    "exceptionals": [
        "exceptional"
    ],
    "incurred": [
        "incur"
    ],
    "incurring": [
        "incur"
    ],
    "incurs": [
        "incur"
    ],
    "raged": [
        "rage"
    ],
    "raging": [
        "rage"
    ],
    "facilitated": [
        "facilitate"
    ],
    "facilitating": [
        "facilitate"
    ],
    "facilitates": [
        "facilitate"
    ],
    "neater": [
        "neat"
    ],
    "neatest": [
        "neat"
    ],
    "strikers": [
        "striker"
    ],
    "disliked": [
        "dislike"
    ],
    "dislikes": [
        "dislike"
    ],
    "disliking": [
        "dislike"
    ],
    "organisers": [
        "organiser"
    ],
    "pledged": [
        "pledge"
    ],
    "pledges": [
        "pledge"
    ],
    "pledging": [
        "pledge"
    ],
    "sufferings": [
        "suffering"
    ],
    "heys": [
        "hey"
    ],
    "milder": [
        "mild"
    ],
    "mildest": [
        "mild"
    ],
    "milds": [
        "mild"
    ],
    "cheered": [
        "cheer"
    ],
    "cheers": [
        "cheer"
    ],
    "cheering": [
        "cheer"
    ],
    "pleaded": [
        "plead"
    ],
    "pleading": [
        "plead"
    ],
    "pleads": [
        "plead"
    ],
    "pled": [
        "plead"
    ],
    "swords": [
        "sword"
    ],
    "walkings": [
        "walking"
    ],
    "sterlings": [
        "sterling"
    ],
    "interfering": [
        "interfere"
    ],
    "interfered": [
        "interfere"
    ],
    "interferes": [
        "interfere"
    ],
    "casualties": [
        "casualty"
    ],
    "erected": [
        "erect"
    ],
    "erecting": [
        "erect"
    ],
    "erects": [
        "erect"
    ],
    "preyed": [
        "prey"
    ],
    "preying": [
        "prey"
    ],
    "preys": [
        "prey"
    ],
    "lightings": [
        "lighting"
    ],
    "queuing": [
        "queue"
    ],
    "queued": [
        "queue"
    ],
    "queueing": [
        "queue"
    ],
    "bargains": [
        "bargain"
    ],
    "bargaining": [
        "bargain"
    ],
    "bargained": [
        "bargain"
    ],
    "remainders": [
        "remainder"
    ],
    "remaindered": [
        "remainder"
    ],
    "sweating": [
        "sweat"
    ],
    "sweated": [
        "sweat"
    ],
    "sweats": [
        "sweat"
    ],
    "parameters": [
        "parameter"
    ],
    "lapped": [
        "lap"
    ],
    "lapping": [
        "lap"
    ],
    "stalls": [
        "stall"
    ],
    "stalled": [
        "stall"
    ],
    "stalling": [
        "stall"
    ],
    "scandals": [
        "scandal"
    ],
    "arched": [
        "arch"
    ],
    "arching": [
        "arch"
    ],
    "livers": [
        "liver"
    ],
    "sprayed": [
        "spray"
    ],
    "spraying": [
        "spray"
    ],
    "intensities": [
        "intensity"
    ],
    "surrendered": [
        "surrender"
    ],
    "surrendering": [
        "surrender"
    ],
    "surrenders": [
        "surrender"
    ],
    "envelopes": [
        "envelope"
    ],
    "ratings": [
        "rating"
    ],
    "accuracies": [
        "accuracy"
    ],
    "auctions": [
        "auction"
    ],
    "auctioned": [
        "auction"
    ],
    "auctioning": [
        "auction"
    ],
    "monsters": [
        "monster"
    ],
    "nightmares": [
        "nightmare"
    ],
    "clevelands": [
        "cleveland"
    ],
    "horns": [
        "horn"
    ],
    "horned": [
        "horn"
    ],
    "trays": [
        "tray"
    ],
    "crept": [
        "creep"
    ],
    "creeping": [
        "creep"
    ],
    "creeps": [
        "creep"
    ],
    "loneliest": [
        "lonely"
    ],
    "lonelier": [
        "lonely"
    ],
    "moderates": [
        "moderate"
    ],
    "moderated": [
        "moderate"
    ],
    "moderating": [
        "moderate"
    ],
    "packets": [
        "packet"
    ],
    "systematics": [
        "systematic"
    ],
    "smashed": [
        "smash"
    ],
    "smashing": [
        "smash"
    ],
    "smashes": [
        "smash"
    ],
    "awoke": [
        "awake"
    ],
    "awoken": [
        "awake"
    ],
    "awakes": [
        "awake"
    ],
    "awaking": [
        "awake"
    ],
    "criticized": [
        "criticize"
    ],
    "criticizing": [
        "criticize"
    ],
    "criticizes": [
        "criticize"
    ],
    "lancashires": [
        "lancashire"
    ],
    "photographers": [
        "photographer"
    ],
    "slaving": [
        "slave"
    ],
    "slaved": [
        "slave"
    ],
    "counterparts": [
        "counterpart"
    ],
    "doorways": [
        "doorway"
    ],
    "matrixes": [
        "matrix"
    ],
    "ussrs": [
        "ussr"
    ],
    "brazils": [
        "brazil"
    ],
    "lounges": [
        "lounge"
    ],
    "lounging": [
        "lounge"
    ],
    "lounged": [
        "lounge"
    ],
    "pints": [
        "pint"
    ],
    "sensitivities": [
        "sensitivity"
    ],
    "drunks": [
        "drunk"
    ],
    "drunker": [
        "drunk"
    ],
    "fighters": [
        "fighter"
    ],
    "orchestras": [
        "orchestra"
    ],
    "carers": [
        "carer"
    ],
    "relevances": [
        "relevance"
    ],
    "clutching": [
        "clutch"
    ],
    "clutched": [
        "clutch"
    ],
    "clutches": [
        "clutch"
    ],
    "intervened": [
        "intervene"
    ],
    "intervening": [
        "intervene"
    ],
    "intervenes": [
        "intervene"
    ],
    "sketched": [
        "sketch"
    ],
    "sketching": [
        "sketch"
    ],
    "similarities": [
        "similarity"
    ],
    "harsher": [
        "harsh"
    ],
    "harshest": [
        "harsh"
    ],
    "jaws": [
        "jaw"
    ],
    "jawed": [
        "jaw"
    ],
    "jawing": [
        "jaw"
    ],
    "archbishops": [
        "archbishop"
    ],
    "monitorings": [
        "monitoring"
    ],
    "hughess": [
        "hughes"
    ],
    "diamonds": [
        "diamond"
    ],
    "scots": [
        "scot"
    ],
    "descended": [
        "descend"
    ],
    "descending": [
        "descend"
    ],
    "swedens": [
        "sweden"
    ],
    "neighbourhoods": [
        "neighbourhood"
    ],
    "startings": [
        "starting"
    ],
    "fiercest": [
        "fierce"
    ],
    "fiercer": [
        "fierce"
    ],
    "legitimated": [
        "legitimate"
    ],
    "legitimating": [
        "legitimate"
    ],
    "legitimates": [
        "legitimate"
    ],
    "toes": [
        "toe"
    ],
    "toed": [
        "toe"
    ],
    "toeing": [
        "toe"
    ],
    "metropolitans": [
        "metropolitan"
    ],
    "rices": [
        "rice"
    ],
    "ricing": [
        "rice"
    ],
    "riced": [
        "rice"
    ],
    "rice": [
        "rice"
    ],
    "tributes": [
        "tribute"
    ],
    "guilts": [
        "guilt"
    ],
    "hostilities": [
        "hostility"
    ],
    "thieves": [
        "thief"
    ],
    "muslims": [
        "muslim"
    ],
    "plunged": [
        "plunge"
    ],
    "plunging": [
        "plunge"
    ],
    "plunges": [
        "plunge"
    ],
    "plcs": [
        "plc"
    ],
    "faculties": [
        "faculty"
    ],
    "broadcastings": [
        "broadcasting"
    ],
    "greeces": [
        "greece"
    ],
    "bolts": [
        "bolt"
    ],
    "bolted": [
        "bolt"
    ],
    "bolting": [
        "bolt"
    ],
    "bindings": [
        "binding"
    ],
    "cautioned": [
        "caution"
    ],
    "cautioning": [
        "caution"
    ],
    "memorials": [
        "memorial"
    ],
    "midlands": [
        "midland"
    ],
    "assembled": [
        "assemble"
    ],
    "assembling": [
        "assemble"
    ],
    "biased": [
        "bias"
    ],
    "biassed": [
        "bias"
    ],
    "biases": [
        "bias",
        "biase"
    ],
    "biasing": [
        "bias",
        "biase"
    ],
    "socialisms": [
        "socialism"
    ],
    "whipped": [
        "whip"
    ],
    "whips": [
        "whip"
    ],
    "whipping": [
        "whip"
    ],
    "dismissals": [
        "dismissal"
    ],
    "hivs": [
        "hiv"
    ],
    "bronzing": [
        "bronze"
    ],
    "disappointments": [
        "disappointment"
    ],
    "marshalls": [
        "marshall"
    ],
    "scripted": [
        "script"
    ],
    "scripting": [
        "script"
    ],
    "limbs": [
        "limb"
    ],
    "limbed": [
        "limb"
    ],
    "blankets": [
        "blanket"
    ],
    "blanketed": [
        "blanket"
    ],
    "blanketing": [
        "blanket"
    ],
    "hitlers": [
        "hitler"
    ],
    "provincials": [
        "provincial"
    ],
    "arrows": [
        "arrow"
    ],
    "arrowed": [
        "arrow"
    ],
    "arrowing": [
        "arrow"
    ],
    "hazards": [
        "hazard"
    ],
    "hazarded": [
        "hazard"
    ],
    "hazarding": [
        "hazard"
    ],
    "concealed": [
        "conceal"
    ],
    "concealing": [
        "conceal"
    ],
    "conceals": [
        "conceal"
    ],
    "killings": [
        "killing"
    ],
    "scattered": [
        "scatter"
    ],
    "scattering": [
        "scatter"
    ],
    "scatters": [
        "scatter"
    ],
    "kuwaits": [
        "kuwait"
    ],
    "hollywoods": [
        "hollywood"
    ],
    "recipes": [
        "recipe"
    ],
    "surreys": [
        "surrey"
    ],
    "exploded": [
        "explode"
    ],
    "exploding": [
        "explode"
    ],
    "explodes": [
        "explode"
    ],
    "threads": [
        "thread"
    ],
    "threaded": [
        "thread"
    ],
    "threading": [
        "thread"
    ],
    "deemed": [
        "deem"
    ],
    "deems": [
        "deem"
    ],
    "deeming": [
        "deem"
    ],
    "distressed": [
        "distress"
    ],
    "distresses": [
        "distress"
    ],
    "distressing": [
        "distress"
    ],
    "stiffer": [
        "stiff"
    ],
    "stiffs": [
        "stiff"
    ],
    "stiffest": [
        "stiff"
    ],
    "happinesses": [
        "happiness"
    ],
    "happiness": [
        "happiness"
    ],
    "tempered": [
        "temper"
    ],
    "tempers": [
        "temper"
    ],
    "tempering": [
        "temper"
    ],
    "owls": [
        "owl"
    ],
    "spoiled": [
        "spoil"
    ],
    "spoilt": [
        "spoil"
    ],
    "spoils": [
        "spoil"
    ],
    "spoiling": [
        "spoil"
    ],
    "legends": [
        "legend"
    ],
    "tiles": [
        "tile"
    ],
    "tiled": [
        "tile"
    ],
    "tiling": [
        "tile"
    ],
    "canvases": [
        "canvas"
    ],
    "canvassed": [
        "canvas",
        "canvass"
    ],
    "canvassing": [
        "canvas",
        "canvass"
    ],
    "decs": [
        "dec"
    ],
    "mexicoes": [
        "mexico"
    ],
    "moulded": [
        "mould"
    ],
    "moulds": [
        "mould"
    ],
    "moulding": [
        "mould"
    ],
    "reproduced": [
        "reproduce"
    ],
    "reproducing": [
        "reproduce"
    ],
    "reproduces": [
        "reproduce"
    ],
    "rubbers": [
        "rubber"
    ],
    "ridges": [
        "ridge"
    ],
    "ridging": [
        "ridge"
    ],
    "catherines": [
        "catherine"
    ],
    "decorated": [
        "decorate"
    ],
    "decorating": [
        "decorate"
    ],
    "decorates": [
        "decorate"
    ],
    "medals": [
        "medal"
    ],
    "pulses": [
        "pulse"
    ],
    "pulsing": [
        "pulse"
    ],
    "pulsed": [
        "pulse"
    ],
    "elbows": [
        "elbow"
    ],
    "elbowed": [
        "elbow"
    ],
    "elbowing": [
        "elbow"
    ],
    "endorsed": [
        "endorse"
    ],
    "endorsing": [
        "endorse"
    ],
    "endorses": [
        "endorse"
    ],
    "lumps": [
        "lump"
    ],
    "lumped": [
        "lump"
    ],
    "lumping": [
        "lump"
    ],
    "scanned": [
        "scan"
    ],
    "scans": [
        "scan"
    ],
    "cuttings": [
        "cutting"
    ],
    "segmented": [
        "segment"
    ],
    "segmenting": [
        "segment"
    ],
    "gps": [
        "gp"
    ],
    "contemplated": [
        "contemplate"
    ],
    "contemplating": [
        "contemplate"
    ],
    "contemplates": [
        "contemplate"
    ],
    "tumours": [
        "tumour"
    ],
    "coincided": [
        "coincide"
    ],
    "coincides": [
        "coincide"
    ],
    "coinciding": [
        "coincide"
    ],
    "keepers": [
        "keeper"
    ],
    "neutrals": [
        "neutral"
    ],
    "inhabitants": [
        "inhabitant"
    ],
    "respondents": [
        "respondent"
    ],
    "dolphins": [
        "dolphin"
    ],
    "jammed": [
        "jam"
    ],
    "jams": [
        "jam"
    ],
    "jamming": [
        "jam"
    ],
    "unfortunates": [
        "unfortunate"
    ],
    "handsomest": [
        "handsome"
    ],
    "handsomer": [
        "handsome"
    ],
    "jonathans": [
        "jonathan"
    ],
    "sauced": [
        "sauce"
    ],
    "trophies": [
        "trophy"
    ],
    "supermarkets": [
        "supermarket"
    ],
    "derbies": [
        "derby"
    ],
    "contractors": [
        "contractor"
    ],
    "scraps": [
        "scrap"
    ],
    "scrapped": [
        "scrap"
    ],
    "scrapping": [
        "scrap"
    ],
    "overheads": [
        "overhead"
    ],
    "breakdowns": [
        "breakdown"
    ],
    "dipped": [
        "dip"
    ],
    "dipping": [
        "dip"
    ],
    "dips": [
        "dip"
    ],
    "clung": [
        "cling"
    ],
    "clinging": [
        "cling"
    ],
    "clings": [
        "cling"
    ],
    "glimpsed": [
        "glimpse"
    ],
    "glimpses": [
        "glimpse"
    ],
    "glimpsing": [
        "glimpse"
    ],
    "marxists": [
        "marxist"
    ],
    "coffins": [
        "coffin"
    ],
    "economists": [
        "economist"
    ],
    "workforces": [
        "workforce"
    ],
    "predecessors": [
        "predecessor"
    ],
    "shallows": [
        "shallow"
    ],
    "shallower": [
        "shallow"
    ],
    "shallowest": [
        "shallow"
    ],
    "shallowed": [
        "shallow"
    ],
    "shallowing": [
        "shallow"
    ],
    "treasures": [
        "treasure"
    ],
    "treasured": [
        "treasure"
    ],
    "treasuring": [
        "treasure"
    ],
    "bruces": [
        "bruce"
    ],
    "recruitments": [
        "recruitment"
    ],
    "sleeves": [
        "sleeve"
    ],
    "sleeved": [
        "sleeve"
    ],
    "sleeving": [
        "sleeve"
    ],
    "eves": [
        "eve"
    ],
    "tucked": [
        "tuck"
    ],
    "tucking": [
        "tuck"
    ],
    "tucks": [
        "tuck"
    ],
    "fucked": [
        "fuck"
    ],
    "fucking": [
        "fuck"
    ],
    "fucks": [
        "fuck"
    ],
    "cruising": [
        "cruise"
    ],
    "cruises": [
        "cruise"
    ],
    "cruised": [
        "cruise"
    ],
    "absented": [
        "absent"
    ],
    "absenting": [
        "absent"
    ],
    "aliens": [
        "alien"
    ],
    "exhausted": [
        "exhaust"
    ],
    "exhausting": [
        "exhaust"
    ],
    "exhausts": [
        "exhaust"
    ],
    "blades": [
        "blade"
    ],
    "bladed": [
        "blade"
    ],
    "dinings": [
        "dining"
    ],
    "nowadayss": [
        "nowadays"
    ],
    "undertakings": [
        "undertaking"
    ],
    "utilities": [
        "utility"
    ],
    "correspondences": [
        "correspondence"
    ],
    "harvested": [
        "harvest"
    ],
    "harvesting": [
        "harvest"
    ],
    "harvests": [
        "harvest"
    ],
    "poisoned": [
        "poison"
    ],
    "poisoning": [
        "poison"
    ],
    "chins": [
        "chin"
    ],
    "chinned": [
        "chin"
    ],
    "miltons": [
        "milton"
    ],
    "plugs": [
        "plug"
    ],
    "plugged": [
        "plug"
    ],
    "plugging": [
        "plug"
    ],
    "atoms": [
        "atom"
    ],
    "borings": [
        "boring"
    ],
    "collars": [
        "collar"
    ],
    "collaring": [
        "collar"
    ],
    "collared": [
        "collar"
    ],
    "confessed": [
        "confess"
    ],
    "confessing": [
        "confess"
    ],
    "jennies": [
        "jenny"
    ],
    "referees": [
        "referee"
    ],
    "refereed": [
        "referee"
    ],
    "refereeing": [
        "referee"
    ],
    "slammed": [
        "slam"
    ],
    "slamming": [
        "slam"
    ],
    "slams": [
        "slam"
    ],
    "rulers": [
        "ruler"
    ],
    "antibodies": [
        "antibody"
    ],
    "classified": [
        "classify"
    ],
    "classifying": [
        "classify"
    ],
    "classifies": [
        "classify"
    ],
    "fitnesses": [
        "fitness"
    ],
    "freuds": [
        "freud"
    ],
    "spilled": [
        "spill"
    ],
    "spilling": [
        "spill"
    ],
    "spills": [
        "spill"
    ],
    "spilt": [
        "spill"
    ],
    "definites": [
        "definite"
    ],
    "hollands": [
        "holland"
    ],
    "barns": [
        "barn"
    ],
    "weed": [
        "wee"
    ],
    "wees": [
        "wee"
    ],
    "weeing": [
        "wee"
    ],
    "huts": [
        "hut"
    ],
    "patented": [
        "patent"
    ],
    "patenting": [
        "patent"
    ],
    "formulated": [
        "formulate"
    ],
    "formulating": [
        "formulate"
    ],
    "formulates": [
        "formulate"
    ],
    "flushed": [
        "flush"
    ],
    "flushing": [
        "flush"
    ],
    "flushes": [
        "flush"
    ],
    "johnnies": [
        "johnny"
    ],
    "lobbied": [
        "lobby"
    ],
    "terrors": [
        "terror"
    ],
    "conjunctions": [
        "conjunction"
    ],
    "nonsenses": [
        "nonsense"
    ],
    "campbells": [
        "campbell"
    ],
    "wisdoms": [
        "wisdom"
    ],
    "workstations": [
        "workstation"
    ],
    "magnetics": [
        "magnetic"
    ],
    "advertised": [
        "advertise"
    ],
    "advertising": [
        "advertise"
    ],
    "advertises": [
        "advertise"
    ],
    "covenants": [
        "covenant"
    ],
    "covenanted": [
        "covenant"
    ],
    "covenanting": [
        "covenant"
    ],
    "corbetts": [
        "corbett"
    ],
    "referenda": [
        "referendum"
    ],
    "submissions": [
        "submission"
    ],
    "cookings": [
        "cooking"
    ],
    "helicopters": [
        "helicopter"
    ],
    "helicoptered": [
        "helicopter"
    ],
    "helicoptering": [
        "helicopter"
    ],
    "stained": [
        "stain"
    ],
    "stains": [
        "stain"
    ],
    "staining": [
        "stain"
    ],
    "hams": [
        "ham"
    ],
    "hamming": [
        "ham"
    ],
    "hammed": [
        "ham"
    ],
    "wealthier": [
        "wealthy"
    ],
    "wealthiest": [
        "wealthy"
    ],
    "boiling": [
        "boil"
    ],
    "boiled": [
        "boil"
    ],
    "boils": [
        "boil"
    ],
    "livelier": [
        "lively"
    ],
    "liveliest": [
        "lively"
    ],
    "phs": [
        "ph"
    ],
    "headlines": [
        "headline"
    ],
    "headlined": [
        "headline"
    ],
    "headlining": [
        "headline"
    ],
    "glowed": [
        "glow"
    ],
    "glowing": [
        "glow"
    ],
    "glows": [
        "glow"
    ],
    "equalities": [
        "equality"
    ],
    "powders": [
        "powder"
    ],
    "powdered": [
        "powder"
    ],
    "powdering": [
        "powder"
    ],
    "grandfathers": [
        "grandfather"
    ],
    "beefed": [
        "beef"
    ],
    "beefing": [
        "beef"
    ],
    "beefs": [
        "beef"
    ],
    "candles": [
        "candle"
    ],
    "ovens": [
        "oven"
    ],
    "norways": [
        "norway"
    ],
    "sucked": [
        "suck"
    ],
    "sucking": [
        "suck"
    ],
    "sucks": [
        "suck"
    ],
    "impressed": [
        "impress"
    ],
    "impressing": [
        "impress"
    ],
    "impresses": [
        "impress"
    ],
    "handlings": [
        "handling"
    ],
    "switzerlands": [
        "switzerland"
    ],
    "verbals": [
        "verbal"
    ],
    "basins": [
        "basin"
    ],
    "disposed": [
        "dispose"
    ],
    "disposing": [
        "dispose"
    ],
    "blokes": [
        "bloke"
    ],
    "sparked": [
        "spark"
    ],
    "sparks": [
        "spark"
    ],
    "sparking": [
        "spark"
    ],
    "vanished": [
        "vanish"
    ],
    "vanishes": [
        "vanish"
    ],
    "vanishing": [
        "vanish"
    ],
    "commenced": [
        "commence"
    ],
    "commencing": [
        "commence"
    ],
    "convicted": [
        "convict"
    ],
    "convicting": [
        "convict"
    ],
    "tempted": [
        "tempt"
    ],
    "tempting": [
        "tempt"
    ],
    "tempts": [
        "tempt"
    ],
    "veins": [
        "vein"
    ],
    "veined": [
        "vein"
    ],
    "veining": [
        "vein"
    ],
    "roared": [
        "roar"
    ],
    "roaring": [
        "roar"
    ],
    "roars": [
        "roar"
    ],
    "bureaucracies": [
        "bureaucracy"
    ],
    "ladders": [
        "ladder"
    ],
    "laddered": [
        "ladder"
    ],
    "laddering": [
        "ladder"
    ],
    "nuts": [
        "nut"
    ],
    "nutting": [
        "nut"
    ],
    "paraded": [
        "parade"
    ],
    "parading": [
        "parade"
    ],
    "brassed": [
        "brass"
    ],
    "colonials": [
        "colonial"
    ],
    "levied": [
        "levy"
    ],
    "levies": [
        "levy"
    ],
    "levying": [
        "levy"
    ],
    "terrorists": [
        "terrorist"
    ],
    "counselled": [
        "counsel"
    ],
    "counselling": [
        "counsel"
    ],
    "counsels": [
        "counsel"
    ],
    "loops": [
        "loop"
    ],
    "looped": [
        "loop"
    ],
    "portioned": [
        "portion"
    ],
    "portioning": [
        "portion"
    ],
    "tensed": [
        "tense"
    ],
    "tensing": [
        "tense"
    ],
    "tenses": [
        "tense"
    ],
    "tenser": [
        "tense"
    ],
    "tensest": [
        "tense"
    ],
    "desktops": [
        "desktop"
    ],
    "despaired": [
        "despair"
    ],
    "despairs": [
        "despair"
    ],
    "despairing": [
        "despair"
    ],
    "dissolved": [
        "dissolve"
    ],
    "dissolving": [
        "dissolve"
    ],
    "exits": [
        "exit"
    ],
    "exited": [
        "exit"
    ],
    "exiting": [
        "exit"
    ],
    "washings": [
        "washing"
    ],
    "enclosed": [
        "enclose"
    ],
    "enclosing": [
        "enclose"
    ],
    "brightons": [
        "brighton"
    ],
    "pioneered": [
        "pioneer"
    ],
    "pioneers": [
        "pioneer"
    ],
    "pioneering": [
        "pioneer"
    ],
    "embassies": [
        "embassy"
    ],
    "brusselss": [
        "brussels"
    ],
    "commodities": [
        "commodity"
    ],
    "drawers": [
        "drawer"
    ],
    "regimented": [
        "regiment"
    ],
    "leaked": [
        "leak"
    ],
    "leaks": [
        "leak"
    ],
    "leaking": [
        "leak"
    ],
    "marbles": [
        "marble"
    ],
    "marbling": [
        "marble"
    ],
    "ruins": [
        "ruin"
    ],
    "ruining": [
        "ruin",
        "ruine"
    ],
    "ruined": [
        "ruin",
        "ruine"
    ],
    "straws": [
        "straw"
    ],
    "lochs": [
        "loch"
    ],
    "composers": [
        "composer"
    ],
    "empiricals": [
        "empirical"
    ],
    "newtons": [
        "newton"
    ],
    "dicks": [
        "dick"
    ],
    "disturbances": [
        "disturbance"
    ],
    "stacked": [
        "stack"
    ],
    "stacks": [
        "stack"
    ],
    "stacking": [
        "stack"
    ],
    "pencils": [
        "pencil"
    ],
    "pencilled": [
        "pencil"
    ],
    "pencilling": [
        "pencil"
    ],
    "wolves": [
        "wolf"
    ],
    "wolfed": [
        "wolf"
    ],
    "wolfing": [
        "wolf"
    ],
    "wolfs": [
        "wolf"
    ],
    "abortions": [
        "abortion"
    ],
    "tents": [
        "tent"
    ],
    "tented": [
        "tent"
    ],
    "oddss": [
        "odds"
    ],
    "certainties": [
        "certainty"
    ],
    "ies": [
        "ie"
    ],
    "pleas": [
        "plea"
    ],
    "fas": [
        "fa"
    ],
    "fists": [
        "fist"
    ],
    "fisting": [
        "fist"
    ],
    "votings": [
        "voting"
    ],
    "intermediates": [
        "intermediate"
    ],
    "intermediated": [
        "intermediate"
    ],
    "dashed": [
        "dash"
    ],
    "dashing": [
        "dash"
    ],
    "dashes": [
        "dash"
    ],
    "electronicss": [
        "electronics"
    ],
    "hulls": [
        "hull"
    ],
    "hulled": [
        "hull"
    ],
    "hulling": [
        "hull"
    ],
    "patrols": [
        "patrol"
    ],
    "patrolling": [
        "patrol"
    ],
    "patrolled": [
        "patrol"
    ],
    "slots": [
        "slot"
    ],
    "slotted": [
        "slot"
    ],
    "slotting": [
        "slot"
    ],
    "tobaccos": [
        "tobacco"
    ],
    "administrators": [
        "administrator"
    ],
    "glared": [
        "glare"
    ],
    "glaring": [
        "glare"
    ],
    "glares": [
        "glare"
    ],
    "ulcers": [
        "ulcer"
    ],
    "coughing": [
        "cough"
    ],
    "coughed": [
        "cough"
    ],
    "coughs": [
        "cough"
    ],
    "laced": [
        "lace"
    ],
    "lacing": [
        "lace"
    ],
    "mids": [
        "mid"
    ],
    "runners": [
        "runner"
    ],
    "burnings": [
        "burning"
    ],
    "netherlandss": [
        "netherlands"
    ],
    "custodies": [
        "custody"
    ],
    "suppers": [
        "supper"
    ],
    "duncans": [
        "duncan"
    ],
    "integrities": [
        "integrity"
    ],
    "depicted": [
        "depict"
    ],
    "depicting": [
        "depict"
    ],
    "depicts": [
        "depict"
    ],
    "tomatoes": [
        "tomato"
    ],
    "melted": [
        "melt"
    ],
    "melting": [
        "melt"
    ],
    "melts": [
        "melt"
    ],
    "molten": [
        "melt"
    ],
    "restraints": [
        "restraint"
    ],
    "tourisms": [
        "tourism"
    ],
    "minings": [
        "mining"
    ],
    "natoes": [
        "nato"
    ],
    "takeovers": [
        "takeover"
    ],
    "mobilities": [
        "mobility"
    ],
    "quids": [
        "quid"
    ],
    "rejections": [
        "rejection"
    ],
    "soaps": [
        "soap"
    ],
    "soaping": [
        "soap"
    ],
    "soaped": [
        "soap"
    ],
    "dived": [
        "dive"
    ],
    "diving": [
        "dive"
    ],
    "dives": [
        "dive"
    ],
    "dove": [
        "dive"
    ],
    "archiving": [
        "archive"
    ],
    "archived": [
        "archive"
    ],
    "hungaries": [
        "hungary"
    ],
    "gasped": [
        "gasp"
    ],
    "gasping": [
        "gasp"
    ],
    "gasps": [
        "gasp"
    ],
    "goodbyes": [
        "goodbye"
    ],
    "drinkings": [
        "drinking"
    ],
    "bowels": [
        "bowel"
    ],
    "imprisonments": [
        "imprisonment"
    ],
    "shepherds": [
        "shepherd"
    ],
    "shepherded": [
        "shepherd"
    ],
    "shepherding": [
        "shepherd"
    ],
    "andersons": [
        "anderson"
    ],
    "thumbs": [
        "thumb"
    ],
    "thumbed": [
        "thumb"
    ],
    "thumbing": [
        "thumb"
    ],
    "thighs": [
        "thigh"
    ],
    "hauled": [
        "haul"
    ],
    "hauling": [
        "haul"
    ],
    "hauls": [
        "haul"
    ],
    "deliberated": [
        "deliberate"
    ],
    "deliberating": [
        "deliberate"
    ],
    "deliberates": [
        "deliberate"
    ],
    "cruder": [
        "crude"
    ],
    "crudest": [
        "crude"
    ],
    "crudes": [
        "crude"
    ],
    "preceded": [
        "precede"
    ],
    "preceding": [
        "precede"
    ],
    "tidying": [
        "tidy"
    ],
    "tidied": [
        "tidy"
    ],
    "tidier": [
        "tidy"
    ],
    "tidies": [
        "tidy"
    ],
    "tidiest": [
        "tidy"
    ],
    "marshes": [
        "marsh"
    ],
    "maturities": [
        "maturity"
    ],
    "breezes": [
        "breeze"
    ],
    "breezed": [
        "breeze"
    ],
    "breezing": [
        "breeze"
    ],
    "chopped": [
        "chop"
    ],
    "chops": [
        "chop"
    ],
    "chopping": [
        "chop"
    ],
    "originated": [
        "originate"
    ],
    "originating": [
        "originate"
    ],
    "originates": [
        "originate"
    ],
    "handfuls": [
        "handful"
    ],
    "valuations": [
        "valuation"
    ],
    "hamiltons": [
        "hamilton"
    ],
    "honeys": [
        "honey"
    ],
    "goodnesses": [
        "goodness"
    ],
    "robertss": [
        "roberts"
    ],
    "timetables": [
        "timetable"
    ],
    "timetabling": [
        "timetable"
    ],
    "timetabled": [
        "timetable"
    ],
    "bolder": [
        "bold"
    ],
    "boldest": [
        "bold"
    ],
    "slimmer": [
        "slim"
    ],
    "slimming": [
        "slim"
    ],
    "slimmed": [
        "slim"
    ],
    "slims": [
        "slim"
    ],
    "slimmest": [
        "slim"
    ],
    "thompsons": [
        "thompson"
    ],
    "clarified": [
        "clarify"
    ],
    "clarifying": [
        "clarify"
    ],
    "clarifies": [
        "clarify"
    ],
    "divined": [
        "divine"
    ],
    "divining": [
        "divine"
    ],
    "diviner": [
        "divine"
    ],
    "profoundest": [
        "profound"
    ],
    "profounder": [
        "profound"
    ],
    "sallies": [
        "sally"
    ],
    "sallied": [
        "sally"
    ],
    "sallying": [
        "sally"
    ],
    "bunches": [
        "bunch"
    ],
    "bunched": [
        "bunch"
    ],
    "bunching": [
        "bunch"
    ],
    "crushed": [
        "crush"
    ],
    "crushing": [
        "crush"
    ],
    "crushes": [
        "crush"
    ],
    "inequalities": [
        "inequality"
    ],
    "aberdeens": [
        "aberdeen"
    ],
    "bankers": [
        "banker"
    ],
    "blended": [
        "blend"
    ],
    "blends": [
        "blend"
    ],
    "blending": [
        "blend"
    ],
    "blent": [
        "blend"
    ],
    "arsenals": [
        "arsenal"
    ],
    "graphs": [
        "graph"
    ],
    "graphing": [
        "graph"
    ],
    "graphed": [
        "graph"
    ],
    "fortnights": [
        "fortnight"
    ],
    "spines": [
        "spine"
    ],
    "barrels": [
        "barrel"
    ],
    "barrelled": [
        "barrel"
    ],
    "barrelling": [
        "barrel"
    ],
    "heaths": [
        "heath"
    ],
    "taxpayers": [
        "taxpayer"
    ],
    "subordinates": [
        "subordinate"
    ],
    "subordinated": [
        "subordinate"
    ],
    "subordinating": [
        "subordinate"
    ],
    "worthies": [
        "worthy"
    ],
    "worthier": [
        "worthy"
    ],
    "worthiest": [
        "worthy"
    ],
    "inspected": [
        "inspect"
    ],
    "inspecting": [
        "inspect"
    ],
    "inspects": [
        "inspect"
    ],
    "swisses": [
        "swiss"
    ],
    "waitings": [
        "waiting"
    ],
    "salmons": [
        "salmon"
    ],
    "salmon": [
        "salmon"
    ],
    "tightened": [
        "tighten"
    ],
    "tightening": [
        "tighten"
    ],
    "tightens": [
        "tighten"
    ],
    "amended": [
        "amend"
    ],
    "amending": [
        "amend"
    ],
    "amends": [
        "amend"
    ],
    "ankles": [
        "ankle"
    ],
    "grandmothers": [
        "grandmother"
    ],
    "squadrons": [
        "squadron"
    ],
    "compensated": [
        "compensate"
    ],
    "compensating": [
        "compensate"
    ],
    "compensates": [
        "compensate"
    ],
    "fossils": [
        "fossil"
    ],
    "lecturers": [
        "lecturer"
    ],
    "slumped": [
        "slump"
    ],
    "slumps": [
        "slump"
    ],
    "slumping": [
        "slump"
    ],
    "decreed": [
        "decree"
    ],
    "decrees": [
        "decree"
    ],
    "decreeing": [
        "decree"
    ],
    "bookings": [
        "booking"
    ],
    "diversities": [
        "diversity"
    ],
    "soups": [
        "soup"
    ],
    "souped": [
        "soup"
    ],
    "souping": [
        "soup"
    ],
    "circulated": [
        "circulate"
    ],
    "circulating": [
        "circulate"
    ],
    "circulates": [
        "circulate"
    ],
    "remainss": [
        "remains"
    ],
    "relieved": [
        "relieve"
    ],
    "relieving": [
        "relieve"
    ],
    "relieves": [
        "relieve"
    ],
    "bacons": [
        "bacon"
    ],
    "daviss": [
        "davis"
    ],
    "dioxides": [
        "dioxide"
    ],
    "makings": [
        "making"
    ],
    "norfolks": [
        "norfolk"
    ],
    "escorted": [
        "escort"
    ],
    "escorting": [
        "escort"
    ],
    "escorts": [
        "escort"
    ],
    "monks": [
        "monk"
    ],
    "tossed": [
        "toss"
    ],
    "tossing": [
        "toss"
    ],
    "tosses": [
        "toss"
    ],
    "tost": [
        "toss"
    ],
    "soloing": [
        "solo"
    ],
    "yugoslavias": [
        "yugoslavia"
    ],
    "mosaics": [
        "mosaic"
    ],
    "bacteria": [
        "bacterium"
    ],
    "characterised": [
        "characterise"
    ],
    "characterises": [
        "characterise"
    ],
    "characterising": [
        "characterise"
    ],
    "trembling": [
        "tremble"
    ],
    "trembled": [
        "tremble"
    ],
    "faxed": [
        "fax"
    ],
    "faxing": [
        "fax"
    ],
    "widened": [
        "widen"
    ],
    "widening": [
        "widen"
    ],
    "widens": [
        "widen"
    ],
    "dictated": [
        "dictate"
    ],
    "dictates": [
        "dictate"
    ],
    "dictating": [
        "dictate"
    ],
    "wrists": [
        "wrist"
    ],
    "highways": [
        "highway"
    ],
    "risings": [
        "rising"
    ],
    "activated": [
        "activate"
    ],
    "activating": [
        "activate"
    ],
    "activates": [
        "activate"
    ],
    "peculiars": [
        "peculiar"
    ],
    "dancers": [
        "dancer"
    ],
    "knots": [
        "knot"
    ],
    "knotted": [
        "knot"
    ],
    "knotting": [
        "knot"
    ],
    "meantimes": [
        "meantime"
    ],
    "motorways": [
        "motorway"
    ],
    "shivered": [
        "shiver"
    ],
    "shivering": [
        "shiver"
    ],
    "shivers": [
        "shiver"
    ],
    "flung": [
        "fling"
    ],
    "flinging": [
        "fling"
    ],
    "flings": [
        "fling"
    ],
    "protocols": [
        "protocol"
    ],
    "salads": [
        "salad"
    ],
    "sexualities": [
        "sexuality"
    ],
    "overlaps": [
        "overlap"
    ],
    "overlapping": [
        "overlap"
    ],
    "overlapped": [
        "overlap"
    ],
    "sunderlands": [
        "sunderland"
    ],
    "bounced": [
        "bounce"
    ],
    "bouncing": [
        "bounce"
    ],
    "bounces": [
        "bounce"
    ],
    "propped": [
        "prop"
    ],
    "props": [
        "prop"
    ],
    "propping": [
        "prop"
    ],
    "waists": [
        "waist"
    ],
    "waisted": [
        "waist"
    ],
    "skiing": [
        "ski"
    ],
    "ambassadors": [
        "ambassador"
    ],
    "exiled": [
        "exile"
    ],
    "exiling": [
        "exile"
    ],
    "psychologists": [
        "psychologist"
    ],
    "quarries": [
        "quarry"
    ],
    "quarrying": [
        "quarry"
    ],
    "quarried": [
        "quarry"
    ],
    "verbs": [
        "verb"
    ],
    "outlets": [
        "outlet"
    ],
    "diminished": [
        "diminish"
    ],
    "diminishing": [
        "diminish"
    ],
    "diminishes": [
        "diminish"
    ],
    "layouts": [
        "layout"
    ],
    "bounds": [
        "bound"
    ],
    "bounded": [
        "bound"
    ],
    "bounding": [
        "bound"
    ],
    "enquired": [
        "enquire"
    ],
    "enquiring": [
        "enquire"
    ],
    "enquires": [
        "enquire"
    ],
    "ugliest": [
        "ugly"
    ],
    "uglier": [
        "ugly"
    ],
    "uglies": [
        "ugly"
    ],
    "flocks": [
        "flock"
    ],
    "flocked": [
        "flock"
    ],
    "flocking": [
        "flock"
    ],
    "cruellest": [
        "cruel"
    ],
    "crueller": [
        "cruel"
    ],
    "cruelest": [
        "cruel"
    ],
    "safeguards": [
        "safeguard"
    ],
    "safeguarding": [
        "safeguard"
    ],
    "safeguarded": [
        "safeguard"
    ],
    "weakened": [
        "weaken"
    ],
    "weakening": [
        "weaken"
    ],
    "weakens": [
        "weaken"
    ],
    "cds": [
        "cd"
    ],
    "complemented": [
        "complement"
    ],
    "complementing": [
        "complement"
    ],
    "dilemmas": [
        "dilemma"
    ],
    "buckets": [
        "bucket"
    ],
    "bucketing": [
        "bucket"
    ],
    "bucketed": [
        "bucket"
    ],
    "summoned": [
        "summon"
    ],
    "summoning": [
        "summon"
    ],
    "summons": [
        "summon"
    ],
    "blazing": [
        "blaze"
    ],
    "blazed": [
        "blaze"
    ],
    "rugs": [
        "rug"
    ],
    "compiled": [
        "compile"
    ],
    "compiling": [
        "compile"
    ],
    "compiles": [
        "compile"
    ],
    "transmitted": [
        "transmit"
    ],
    "transmitting": [
        "transmit"
    ],
    "transmits": [
        "transmit"
    ],
    "retailers": [
        "retailer"
    ],
    "unconsciouss": [
        "unconscious"
    ],
    "entertained": [
        "entertain"
    ],
    "entertaining": [
        "entertain"
    ],
    "entertains": [
        "entertain"
    ],
    "suppressed": [
        "suppress"
    ],
    "suppressing": [
        "suppress"
    ],
    "suppresses": [
        "suppress"
    ],
    "symbolics": [
        "symbolic"
    ],
    "continuities": [
        "continuity"
    ],
    "dealings": [
        "dealing"
    ],
    "swans": [
        "swan"
    ],
    "swanning": [
        "swan"
    ],
    "swanned": [
        "swan"
    ],
    "koreans": [
        "korean"
    ],
    "stanleys": [
        "stanley"
    ],
    "turkishes": [
        "turkish"
    ],
    "manuscripts": [
        "manuscript"
    ],
    "stewards": [
        "steward"
    ],
    "stewarding": [
        "steward"
    ],
    "stewarded": [
        "steward"
    ],
    "feathers": [
        "feather"
    ],
    "feathered": [
        "feather"
    ],
    "feathering": [
        "feather"
    ],
    "antiqued": [
        "antique"
    ],
    "butlers": [
        "butler"
    ],
    "departed": [
        "depart"
    ],
    "departing": [
        "depart"
    ],
    "lawns": [
        "lawn"
    ],
    "tyres": [
        "tyre"
    ],
    "diameters": [
        "diameter"
    ],
    "eagers": [
        "eager"
    ],
    "caged": [
        "cage"
    ],
    "belgiums": [
        "belgium"
    ],
    "egyptians": [
        "egyptian"
    ],
    "rammed": [
        "ram"
    ],
    "ramming": [
        "ram"
    ],
    "swollen": [
        "swell"
    ],
    "swelled": [
        "swell"
    ],
    "swelling": [
        "swell"
    ],
    "swells": [
        "swell"
    ],
    "validities": [
        "validity"
    ],
    "frontiers": [
        "frontier"
    ],
    "boasts": [
        "boast"
    ],
    "boasted": [
        "boast"
    ],
    "boasting": [
        "boast"
    ],
    "entails": [
        "entail"
    ],
    "entailed": [
        "entail"
    ],
    "entailing": [
        "entail"
    ],
    "porters": [
        "porter"
    ],
    "swifts": [
        "swift"
    ],
    "swifter": [
        "swift"
    ],
    "swiftest": [
        "swift"
    ],
    "upgraded": [
        "upgrade"
    ],
    "upgrading": [
        "upgrade"
    ],
    "upgrades": [
        "upgrade"
    ],
    "viewers": [
        "viewer"
    ],
    "clergies": [
        "clergy"
    ],
    "denmarks": [
        "denmark"
    ],
    "lifestyles": [
        "lifestyle"
    ],
    "enforcements": [
        "enforcement"
    ],
    "librarians": [
        "librarian"
    ],
    "wickets": [
        "wicket"
    ],
    "aroused": [
        "arouse"
    ],
    "arousing": [
        "arouse"
    ],
    "arouses": [
        "arouse"
    ],
    "gospels": [
        "gospel"
    ],
    "spanning": [
        "span"
    ],
    "spans": [
        "span"
    ],
    "spanned": [
        "span"
    ],
    "savages": [
        "savage"
    ],
    "savaged": [
        "savage"
    ],
    "savaging": [
        "savage"
    ],
    "whistling": [
        "whistle"
    ],
    "whistled": [
        "whistle"
    ],
    "whistles": [
        "whistle"
    ],
    "commentators": [
        "commentator"
    ],
    "lemons": [
        "lemon"
    ],
    "nodes": [
        "node"
    ],
    "noded": [
        "node"
    ],
    "privatisations": [
        "privatisation"
    ],
    "dwellings": [
        "dwelling"
    ],
    "fringes": [
        "fringe"
    ],
    "fringed": [
        "fringe"
    ],
    "fringing": [
        "fringe"
    ],
    "fries": [
        "fry"
    ],
    "fried": [
        "fry"
    ],
    "frying": [
        "fry"
    ],
    "girlfriends": [
        "girlfriend"
    ],
    "popularities": [
        "popularity"
    ],
    "predators": [
        "predator"
    ],
    "snakes": [
        "snake"
    ],
    "snaked": [
        "snake"
    ],
    "snaking": [
        "snake"
    ],
    "embarked": [
        "embark"
    ],
    "embarking": [
        "embark"
    ],
    "embarks": [
        "embark"
    ],
    "gloves": [
        "glove"
    ],
    "gloving": [
        "glove"
    ],
    "learners": [
        "learner"
    ],
    "pads": [
        "pad"
    ],
    "padded": [
        "pad"
    ],
    "padding": [
        "pad"
    ],
    "stabbed": [
        "stab"
    ],
    "stabbing": [
        "stab"
    ],
    "stabs": [
        "stab"
    ],
    "warehouses": [
        "warehouse"
    ],
    "warehoused": [
        "warehouse"
    ],
    "heirs": [
        "heir"
    ],
    "counsellings": [
        "counselling"
    ],
    "deprived": [
        "deprive"
    ],
    "depriving": [
        "deprive"
    ],
    "deprives": [
        "deprive"
    ],
    "drowned": [
        "drown"
    ],
    "drowning": [
        "drown"
    ],
    "drowns": [
        "drown"
    ],
    "trimmed": [
        "trim"
    ],
    "trimming": [
        "trim"
    ],
    "trims": [
        "trim"
    ],
    "trimmest": [
        "trim"
    ],
    "tortured": [
        "torture"
    ],
    "torturing": [
        "torture"
    ],
    "prospectives": [
        "prospective"
    ],
    "woodlands": [
        "woodland"
    ],
    "kennedies": [
        "kennedy"
    ],
    "pms": [
        "pm"
    ],
    "fiscals": [
        "fiscal"
    ],
    "flourished": [
        "flourish"
    ],
    "flourishes": [
        "flourish"
    ],
    "flourishing": [
        "flourish"
    ],
    "tribes": [
        "tribe"
    ],
    "sufferers": [
        "sufferer"
    ],
    "revived": [
        "revive"
    ],
    "reviving": [
        "revive"
    ],
    "revives": [
        "revive"
    ],
    "soccers": [
        "soccer"
    ],
    "borrowings": [
        "borrowing"
    ],
    "fts": [
        "ft"
    ],
    "sandier": [
        "sandy"
    ],
    "sandiest": [
        "sandy"
    ],
    "rebuilt": [
        "rebuild"
    ],
    "rebuilding": [
        "rebuild"
    ],
    "rebuilds": [
        "rebuild"
    ],
    "rons": [
        "ron"
    ],
    "maxwells": [
        "maxwell"
    ],
    "offerings": [
        "offering"
    ],
    "intimated": [
        "intimate"
    ],
    "intimates": [
        "intimate"
    ],
    "intimating": [
        "intimate"
    ],
    "pences": [
        "pence"
    ],
    "ripped": [
        "rip"
    ],
    "ripping": [
        "rip"
    ],
    "rips": [
        "rip"
    ],
    "uttered": [
        "utter"
    ],
    "uttering": [
        "utter"
    ],
    "utters": [
        "utter"
    ],
    "bundled": [
        "bundle"
    ],
    "bundles": [
        "bundle"
    ],
    "bundling": [
        "bundle"
    ],
    "manipulated": [
        "manipulate"
    ],
    "manipulating": [
        "manipulate"
    ],
    "manipulates": [
        "manipulate"
    ],
    "alis": [
        "ali"
    ],
    "beasts": [
        "beast"
    ],
    "lordships": [
        "lordship"
    ],
    "whales": [
        "whale"
    ],
    "whaling": [
        "whale"
    ],
    "reactors": [
        "reactor"
    ],
    "viennas": [
        "vienna"
    ],
    "gardeners": [
        "gardener"
    ],
    "brakes": [
        "brake"
    ],
    "braked": [
        "brake"
    ],
    "braking": [
        "brake"
    ],
    "churchills": [
        "churchill"
    ],
    "senates": [
        "senate"
    ],
    "tigers": [
        "tiger"
    ],
    "vitamins": [
        "vitamin"
    ],
    "carts": [
        "cart"
    ],
    "carted": [
        "cart"
    ],
    "carting": [
        "cart"
    ],
    "endeavours": [
        "endeavour"
    ],
    "endeavoured": [
        "endeavour"
    ],
    "endeavouring": [
        "endeavour"
    ],
    "supervised": [
        "supervise"
    ],
    "supervising": [
        "supervise"
    ],
    "compliances": [
        "compliance"
    ],
    "feedbacks": [
        "feedback"
    ],
    "ltd.s": [
        "ltd."
    ],
    "reassured": [
        "reassure"
    ],
    "reassuring": [
        "reassure"
    ],
    "reassures": [
        "reassure"
    ],
    "edwardss": [
        "edwards"
    ],
    "widths": [
        "width"
    ],
    "worms": [
        "worm"
    ],
    "wormed": [
        "worm"
    ],
    "worming": [
        "worm"
    ],
    "forbidden": [
        "forbid"
    ],
    "forbade": [
        "forbid"
    ],
    "forbids": [
        "forbid"
    ],
    "forbidding": [
        "forbid"
    ],
    "obeyed": [
        "obey"
    ],
    "obeying": [
        "obey"
    ],
    "obeys": [
        "obey"
    ],
    "utterances": [
        "utterance"
    ],
    "lids": [
        "lid"
    ],
    "lidded": [
        "lid"
    ],
    "realms": [
        "realm"
    ],
    "somersets": [
        "somerset"
    ],
    "shied": [
        "shy"
    ],
    "shying": [
        "shy"
    ],
    "shies": [
        "shy"
    ],
    "shyer": [
        "shy"
    ],
    "shyest": [
        "shy"
    ],
    "shys": [
        "shy"
    ],
    "shier": [
        "shy"
    ],
    "saudis": [
        "saudi"
    ],
    "arrays": [
        "array"
    ],
    "arrayed": [
        "array"
    ],
    "arraying": [
        "array"
    ],
    "embarrassments": [
        "embarrassment"
    ],
    "caravans": [
        "caravan"
    ],
    "caravanning": [
        "caravan"
    ],
    "cooperations": [
        "cooperation"
    ],
    "grids": [
        "grid"
    ],
    "gridded": [
        "grid"
    ],
    "underlined": [
        "underline"
    ],
    "underlines": [
        "underline"
    ],
    "underlining": [
        "underline"
    ],
    "activists": [
        "activist"
    ],
    "ozones": [
        "ozone"
    ],
    "miseries": [
        "misery"
    ],
    "dedicated": [
        "dedicate"
    ],
    "dedicating": [
        "dedicate"
    ],
    "dedicates": [
        "dedicate"
    ],
    "labs": [
        "lab"
    ],
    "purples": [
        "purple"
    ],
    "scents": [
        "scent"
    ],
    "scented": [
        "scent"
    ],
    "scenting": [
        "scent"
    ],
    "lasered": [
        "laser"
    ],
    "lasering": [
        "laser"
    ],
    "promoters": [
        "promoter"
    ],
    "guinnesses": [
        "guinness"
    ],
    "bins": [
        "bin"
    ],
    "binned": [
        "bin"
    ],
    "binning": [
        "bin"
    ],
    "characterized": [
        "characterize"
    ],
    "characterizes": [
        "characterize"
    ],
    "characterizing": [
        "characterize"
    ],
    "disagreed": [
        "disagree"
    ],
    "disagrees": [
        "disagree"
    ],
    "disagreeing": [
        "disagree"
    ],
    "punished": [
        "punish"
    ],
    "punishing": [
        "punish"
    ],
    "punishes": [
        "punish"
    ],
    "calendars": [
        "calendar"
    ],
    "dignities": [
        "dignity"
    ],
    "cursed": [
        "curse"
    ],
    "cursing": [
        "curse"
    ],
    "curses": [
        "curse"
    ],
    "curst": [
        "curse"
    ],
    "toasted": [
        "toast"
    ],
    "toasting": [
        "toast"
    ],
    "austrias": [
        "austria"
    ],
    "closings": [
        "closing"
    ],
    "printings": [
        "printing"
    ],
    "dependences": [
        "dependence"
    ],
    "cabins": [
        "cabin"
    ],
    "shootings": [
        "shooting"
    ],
    "brer": [
        "br"
    ],
    "brest": [
        "br"
    ],
    "brring": [
        "br"
    ],
    "bubbles": [
        "bubble"
    ],
    "bubbling": [
        "bubble"
    ],
    "bubbled": [
        "bubble"
    ],
    "mpss": [
        "mps"
    ],
    "uprights": [
        "upright"
    ],
    "uprighted": [
        "upright"
    ],
    "vocabularies": [
        "vocabulary"
    ],
    "relaxations": [
        "relaxation"
    ],
    "shafts": [
        "shaft"
    ],
    "shafting": [
        "shaft"
    ],
    "shafted": [
        "shaft"
    ],
    "spies": [
        "spy"
    ],
    "spying": [
        "spy"
    ],
    "spied": [
        "spy"
    ],
    "mediterraneans": [
        "mediterranean"
    ],
    "tablets": [
        "tablet"
    ],
    "aggressions": [
        "aggression"
    ],
    "cornwalls": [
        "cornwall"
    ],
    "debtors": [
        "debtor"
    ],
    "inheritances": [
        "inheritance"
    ],
    "cylinders": [
        "cylinder"
    ],
    "garments": [
        "garment"
    ],
    "sunshines": [
        "sunshine"
    ],
    "boyfriends": [
        "boyfriend"
    ],
    "eyebrows": [
        "eyebrow"
    ],
    "parcels": [
        "parcel"
    ],
    "parcelled": [
        "parcel"
    ],
    "parcelling": [
        "parcel"
    ],
    "thrones": [
        "throne"
    ],
    "spat": [
        "spit"
    ],
    "spitting": [
        "spit"
    ],
    "spits": [
        "spit"
    ],
    "spitted": [
        "spit"
    ],
    "wimbledons": [
        "wimbledon"
    ],
    "actresses": [
        "actress"
    ],
    "mists": [
        "mist"
    ],
    "misted": [
        "mist"
    ],
    "misting": [
        "mist"
    ],
    "gabriels": [
        "gabriel"
    ],
    "eatings": [
        "eating"
    ],
    "peeled": [
        "peel"
    ],
    "peels": [
        "peel"
    ],
    "yelled": [
        "yell"
    ],
    "yelling": [
        "yell"
    ],
    "yells": [
        "yell"
    ],
    "calciums": [
        "calcium"
    ],
    "hollows": [
        "hollow"
    ],
    "hollowed": [
        "hollow"
    ],
    "hollowing": [
        "hollow"
    ],
    "deeds": [
        "deed"
    ],
    "carols": [
        "carol"
    ],
    "carolled": [
        "carol"
    ],
    "carolling": [
        "carol"
    ],
    "conferred": [
        "confer"
    ],
    "confers": [
        "confer"
    ],
    "conferring": [
        "confer"
    ],
    "disguised": [
        "disguise"
    ],
    "disguises": [
        "disguise"
    ],
    "disguising": [
        "disguise"
    ],
    "headmasters": [
        "headmaster"
    ],
    "integrals": [
        "integral"
    ],
    "flicked": [
        "flick"
    ],
    "flicking": [
        "flick"
    ],
    "flicks": [
        "flick"
    ],
    "mainstreaming": [
        "mainstream"
    ],
    "mainstreams": [
        "mainstream"
    ],
    "confused": [
        "confuse"
    ],
    "confusing": [
        "confuse"
    ],
    "regained": [
        "regain"
    ],
    "regaining": [
        "regain"
    ],
    "gravels": [
        "gravel"
    ],
    "gravelling": [
        "gravel"
    ],
    "gravelled": [
        "gravel"
    ],
    "gravel": [
        "gravel"
    ],
    "joyces": [
        "joyce"
    ],
    "prescribed": [
        "prescribe"
    ],
    "prescribing": [
        "prescribe"
    ],
    "prescribes": [
        "prescribe"
    ],
    "cleanings": [
        "cleaning"
    ],
    "skulls": [
        "skull"
    ],
    "surged": [
        "surge"
    ],
    "surging": [
        "surge"
    ],
    "surges": [
        "surge"
    ],
    "peppers": [
        "pepper"
    ],
    "peppered": [
        "pepper"
    ],
    "peppering": [
        "pepper"
    ],
    "coopers": [
        "cooper"
    ],
    "coopering": [
        "cooper"
    ],
    "coopered": [
        "cooper"
    ],
    "guerrillas": [
        "guerrilla"
    ],
    "towels": [
        "towel"
    ],
    "towelled": [
        "towel"
    ],
    "towelling": [
        "towel"
    ],
    "contempts": [
        "contempt"
    ],
    "revivals": [
        "revival"
    ],
    "sponsorships": [
        "sponsorship"
    ],
    "booklets": [
        "booklet"
    ],
    "goulding": [
        "gould"
    ],
    "pining": [
        "pine"
    ],
    "pined": [
        "pine"
    ],
    "barked": [
        "bark"
    ],
    "barking": [
        "bark"
    ],
    "barks": [
        "bark"
    ],
    "merged": [
        "merge"
    ],
    "merging": [
        "merge"
    ],
    "merges": [
        "merge"
    ],
    "referrals": [
        "referral"
    ],
    "tariffs": [
        "tariff"
    ],
    "ancestors": [
        "ancestor"
    ],
    "decays": [
        "decay"
    ],
    "decayed": [
        "decay"
    ],
    "decaying": [
        "decay"
    ],
    "inhibited": [
        "inhibit"
    ],
    "inhibits": [
        "inhibit"
    ],
    "inhibiting": [
        "inhibit"
    ],
    "snatched": [
        "snatch"
    ],
    "snatching": [
        "snatch"
    ],
    "snatches": [
        "snatch"
    ],
    "betrayed": [
        "betray"
    ],
    "betraying": [
        "betray"
    ],
    "betrays": [
        "betray"
    ],
    "jewelleries": [
        "jewellery"
    ],
    "reminders": [
        "reminder"
    ],
    "surroundingss": [
        "surroundings"
    ],
    "attained": [
        "attain"
    ],
    "attaining": [
        "attain"
    ],
    "attains": [
        "attain"
    ],
    "controllers": [
        "controller"
    ],
    "markers": [
        "marker"
    ],
    "temptations": [
        "temptation"
    ],
    "ams": [
        "am"
    ],
    "intakes": [
        "intake"
    ],
    "sellings": [
        "selling"
    ],
    "ticking": [
        "tick"
    ],
    "ticked": [
        "tick"
    ],
    "ticks": [
        "tick"
    ],
    "moralities": [
        "morality"
    ],
    "canterburies": [
        "canterbury"
    ],
    "furs": [
        "fur"
    ],
    "furred": [
        "fur"
    ],
    "furring": [
        "fur"
    ],
    "toxics": [
        "toxic"
    ],
    "scrutinies": [
        "scrutiny"
    ],
    "herbs": [
        "herb"
    ],
    "accountabilities": [
        "accountability"
    ],
    "foreheads": [
        "forehead"
    ],
    "harveys": [
        "harvey"
    ],
    "chemists": [
        "chemist"
    ],
    "horizontals": [
        "horizontal"
    ],
    "murrays": [
        "murray"
    ],
    "backings": [
        "backing"
    ],
    "bargainings": [
        "bargaining"
    ],
    "proclaimed": [
        "proclaim"
    ],
    "proclaiming": [
        "proclaim"
    ],
    "proclaims": [
        "proclaim"
    ],
    "conforms": [
        "conform"
    ],
    "conforming": [
        "conform"
    ],
    "conformed": [
        "conform"
    ],
    "outlooks": [
        "outlook"
    ],
    "mammals": [
        "mammal"
    ],
    "metaphors": [
        "metaphor"
    ],
    "disclosures": [
        "disclosure"
    ],
    "inclusions": [
        "inclusion"
    ],
    "serials": [
        "serial"
    ],
    "serialled": [
        "serial"
    ],
    "renewed": [
        "renew"
    ],
    "renewing": [
        "renew"
    ],
    "renews": [
        "renew"
    ],
    "christies": [
        "christy",
        "christie"
    ],
    "compelled": [
        "compel"
    ],
    "compelling": [
        "compel"
    ],
    "compels": [
        "compel"
    ],
    "virginias": [
        "virginia"
    ],
    "onions": [
        "onion"
    ],
    "embodied": [
        "embody"
    ],
    "embodies": [
        "embody"
    ],
    "embodying": [
        "embody"
    ],
    "sicknesses": [
        "sickness"
    ],
    "corns": [
        "corn"
    ],
    "corning": [
        "corn"
    ],
    "woven": [
        "weave"
    ],
    "weaving": [
        "weave"
    ],
    "weaves": [
        "weave"
    ],
    "wove": [
        "weave"
    ],
    "weaved": [
        "weave"
    ],
    "exerted": [
        "exert"
    ],
    "exerts": [
        "exert"
    ],
    "exerting": [
        "exert"
    ],
    "kindlier": [
        "kindly"
    ],
    "sovereignties": [
        "sovereignty"
    ],
    "legacies": [
        "legacy"
    ],
    "maxes": [
        "max"
    ],
    "clicked": [
        "click"
    ],
    "clicking": [
        "click"
    ],
    "clicks": [
        "click"
    ],
    "fertilities": [
        "fertility"
    ],
    "followers": [
        "follower"
    ],
    "mins": [
        "min"
    ],
    "offsets": [
        "offset"
    ],
    "offsetting": [
        "offset"
    ],
    "steered": [
        "steer"
    ],
    "steering": [
        "steer"
    ],
    "steers": [
        "steer"
    ],
    "flanked": [
        "flank"
    ],
    "flanks": [
        "flank"
    ],
    "flanking": [
        "flank"
    ],
    "foreigners": [
        "foreigner"
    ],
    "recorders": [
        "recorder"
    ],
    "gravities": [
        "gravity"
    ],
    "heaps": [
        "heap"
    ],
    "heaped": [
        "heap"
    ],
    "heaping": [
        "heap"
    ],
    "territorials": [
        "territorial"
    ],
    "splashed": [
        "splash"
    ],
    "splashing": [
        "splash"
    ],
    "splashes": [
        "splash"
    ],
    "statics": [
        "static"
    ],
    "bullets": [
        "bullet"
    ],
    "mozarts": [
        "mozart"
    ],
    "boxings": [
        "boxing"
    ],
    "galls": [
        "gall"
    ],
    "galled": [
        "gall"
    ],
    "galling": [
        "gall"
    ],
    "motivated": [
        "motivate"
    ],
    "motivating": [
        "motivate"
    ],
    "motivates": [
        "motivate"
    ],
    "philosophers": [
        "philosopher"
    ],
    "portrayed": [
        "portray"
    ],
    "portrays": [
        "portray"
    ],
    "portraying": [
        "portray"
    ],
    "multiplied": [
        "multiply"
    ],
    "multiplying": [
        "multiply"
    ],
    "dr.s": [
        "dr."
    ],
    "hydrogens": [
        "hydrogen"
    ],
    "bradfords": [
        "bradford"
    ],
    "crossings": [
        "crossing"
    ],
    "sipped": [
        "sip"
    ],
    "sipping": [
        "sip"
    ],
    "sips": [
        "sip"
    ],
    "censuses": [
        "census"
    ],
    "choirs": [
        "choir"
    ],
    "watsons": [
        "watson"
    ],
    "fouled": [
        "foul"
    ],
    "fouling": [
        "foul"
    ],
    "fouls": [
        "foul"
    ],
    "foulest": [
        "foul"
    ],
    "mistresses": [
        "mistress"
    ],
    "textured": [
        "texture"
    ],
    "texturing": [
        "texture"
    ],
    "hampshires": [
        "hampshire"
    ],
    "defaults": [
        "default"
    ],
    "defaulted": [
        "default"
    ],
    "defaulting": [
        "default"
    ],
    "victors": [
        "victor"
    ],
    "manifested": [
        "manifest"
    ],
    "manifests": [
        "manifest"
    ],
    "manifesting": [
        "manifest"
    ],
    "sovereigns": [
        "sovereign"
    ],
    "likelihoods": [
        "likelihood"
    ],
    "planners": [
        "planner"
    ],
    "turners": [
        "turner"
    ],
    "wept": [
        "weep"
    ],
    "weeping": [
        "weep"
    ],
    "weeps": [
        "weep"
    ],
    "dess": [
        "des"
    ],
    "bailed": [
        "bail"
    ],
    "bailing": [
        "bail"
    ],
    "bails": [
        "bail"
    ],
    "apologies": [
        "apology"
    ],
    "appraisals": [
        "appraisal"
    ],
    "puzzled": [
        "puzzle"
    ],
    "puzzling": [
        "puzzle"
    ],
    "tugged": [
        "tug"
    ],
    "tugging": [
        "tug"
    ],
    "tugs": [
        "tug"
    ],
    "carved": [
        "carve"
    ],
    "carving": [
        "carve"
    ],
    "carves": [
        "carve"
    ],
    "gatherings": [
        "gathering"
    ],
    "groupings": [
        "grouping"
    ],
    "healings": [
        "healing"
    ],
    "willingnesses": [
        "willingness"
    ],
    "diverted": [
        "divert"
    ],
    "diverting": [
        "divert"
    ],
    "diverts": [
        "divert"
    ],
    "outbreaks": [
        "outbreak"
    ],
    "pegs": [
        "peg"
    ],
    "pegged": [
        "peg"
    ],
    "pegging": [
        "peg"
    ],
    "parkers": [
        "parker"
    ],
    "penetrated": [
        "penetrate"
    ],
    "penetrating": [
        "penetrate"
    ],
    "penetrates": [
        "penetrate"
    ],
    "socks": [
        "sock"
    ],
    "socked": [
        "sock"
    ],
    "socking": [
        "sock"
    ],
    "presidencies": [
        "presidency"
    ],
    "telegraphed": [
        "telegraph"
    ],
    "telegraphs": [
        "telegraph"
    ],
    "telegraphing": [
        "telegraph"
    ],
    "prevailed": [
        "prevail"
    ],
    "prevails": [
        "prevail"
    ],
    "prevailing": [
        "prevail"
    ],
    "revised": [
        "revise"
    ],
    "revising": [
        "revise"
    ],
    "editorials": [
        "editorial"
    ],
    "eecs": [
        "eec"
    ],
    "mechanics": [
        "mechanic"
    ],
    "slapped": [
        "slap"
    ],
    "slapping": [
        "slap"
    ],
    "slaps": [
        "slap"
    ],
    "weeds": [
        "weed"
    ],
    "weeding": [
        "weed"
    ],
    "weeded": [
        "weed"
    ],
    "seventeenths": [
        "seventeenth"
    ],
    "crisps": [
        "crisp"
    ],
    "crisping": [
        "crisp"
    ],
    "crisped": [
        "crisp"
    ],
    "crispest": [
        "crisp"
    ],
    "gothics": [
        "gothic"
    ],
    "lengthier": [
        "lengthy"
    ],
    "lengthiest": [
        "lengthy"
    ],
    "frightened": [
        "frighten"
    ],
    "frightens": [
        "frighten"
    ],
    "frightening": [
        "frighten"
    ],
    "herds": [
        "herd"
    ],
    "herded": [
        "herd"
    ],
    "herding": [
        "herd"
    ],
    "summarised": [
        "summarise"
    ],
    "summarises": [
        "summarise"
    ],
    "summarising": [
        "summarise"
    ],
    "valved": [
        "valve"
    ],
    "yarns": [
        "yarn"
    ],
    "goats": [
        "goat"
    ],
    "providers": [
        "provider"
    ],
    "bored": [
        "bore"
    ],
    "boring": [
        "bore"
    ],
    "bores": [
        "bore"
    ],
    "clipped": [
        "clip"
    ],
    "clipping": [
        "clip"
    ],
    "polymers": [
        "polymer"
    ],
    "teds": [
        "ted"
    ],
    "herberts": [
        "herbert"
    ],
    "romanias": [
        "romania"
    ],
    "specialising": [
        "specialise"
    ],
    "specialised": [
        "specialise"
    ],
    "crawled": [
        "crawl"
    ],
    "crawling": [
        "crawl"
    ],
    "crawls": [
        "crawl"
    ],
    "surveyors": [
        "surveyor"
    ],
    "costliest": [
        "costly"
    ],
    "costlier": [
        "costly"
    ],
    "differentiated": [
        "differentiate"
    ],
    "differentiating": [
        "differentiate"
    ],
    "differentiates": [
        "differentiate"
    ],
    "pacts": [
        "pact"
    ],
    "viewpoints": [
        "viewpoint"
    ],
    "accumulated": [
        "accumulate"
    ],
    "accumulating": [
        "accumulate"
    ],
    "accumulates": [
        "accumulate"
    ],
    "bumped": [
        "bump"
    ],
    "bumping": [
        "bump"
    ],
    "bumps": [
        "bump"
    ],
    "keyboards": [
        "keyboard"
    ],
    "keyboarding": [
        "keyboard"
    ],
    "keyboarded": [
        "keyboard"
    ],
    "cleaners": [
        "cleaner"
    ],
    "reeds": [
        "reed"
    ],
    "reeding": [
        "reed"
    ],
    "reportings": [
        "reporting"
    ],
    "sniffed": [
        "sniff"
    ],
    "sniffing": [
        "sniff"
    ],
    "sniffs": [
        "sniff"
    ],
    "disagreements": [
        "disagreement"
    ],
    "abolitions": [
        "abolition"
    ],
    "amnesties": [
        "amnesty"
    ],
    "amnestied": [
        "amnesty"
    ],
    "pills": [
        "pill"
    ],
    "winnings": [
        "winning"
    ],
    "wits": [
        "wit"
    ],
    "wist": [
        "wit"
    ],
    "wot": [
        "wit"
    ],
    "witting": [
        "wit"
    ],
    "lancasters": [
        "lancaster"
    ],
    "presumed": [
        "presume"
    ],
    "presuming": [
        "presume"
    ],
    "spectacled": [
        "spectacle"
    ],
    "tokens": [
        "token"
    ],
    "tolerated": [
        "tolerate"
    ],
    "tolerating": [
        "tolerate"
    ],
    "tolerates": [
        "tolerate"
    ],
    "duals": [
        "dual"
    ],
    "fondest": [
        "fond"
    ],
    "exotics": [
        "exotic"
    ],
    "bicycling": [
        "bicycle"
    ],
    "bicycled": [
        "bicycle"
    ],
    "visitings": [
        "visiting"
    ],
    "subscriptions": [
        "subscription"
    ],
    "alphas": [
        "alpha"
    ],
    "forks": [
        "fork"
    ],
    "forked": [
        "fork"
    ],
    "forking": [
        "fork"
    ],
    "alfreds": [
        "alfred"
    ],
    "gossiping": [
        "gossip"
    ],
    "gossips": [
        "gossip"
    ],
    "gossiped": [
        "gossip"
    ],
    "insults": [
        "insult"
    ],
    "insulted": [
        "insult"
    ],
    "insulting": [
        "insult"
    ],
    "mls": [
        "ml"
    ],
    "scarlets": [
        "scarlet"
    ],
    "spectators": [
        "spectator"
    ],
    "costumed": [
        "costume"
    ],
    "iranians": [
        "iranian"
    ],
    "plastered": [
        "plaster"
    ],
    "plasters": [
        "plaster"
    ],
    "plastering": [
        "plaster"
    ],
    "butterflies": [
        "butterfly"
    ],
    "tags": [
        "tag"
    ],
    "tagged": [
        "tag"
    ],
    "tagging": [
        "tag"
    ],
    "designated": [
        "designate"
    ],
    "designating": [
        "designate"
    ],
    "designates": [
        "designate"
    ],
    "hatched": [
        "hatch"
    ],
    "hatching": [
        "hatch"
    ],
    "hatches": [
        "hatch"
    ],
    "coventries": [
        "coventry"
    ],
    "quitting": [
        "quit"
    ],
    "quits": [
        "quit"
    ],
    "quitted": [
        "quit"
    ],
    "repayments": [
        "repayment"
    ],
    "ribs": [
        "rib"
    ],
    "ribbing": [
        "rib"
    ],
    "ribbed": [
        "rib"
    ],
    "fevers": [
        "fever"
    ],
    "fevered": [
        "fever"
    ],
    "balloting": [
        "ballot"
    ],
    "balloted": [
        "ballot"
    ],
    "littered": [
        "litter"
    ],
    "litters": [
        "litter"
    ],
    "littering": [
        "litter"
    ],
    "curiosities": [
        "curiosity"
    ],
    "landowners": [
        "landowner"
    ],
    "pronounced": [
        "pronounce"
    ],
    "pronouncing": [
        "pronounce"
    ],
    "pronounces": [
        "pronounce"
    ],
    "thresholds": [
        "threshold"
    ],
    "trunks": [
        "trunk"
    ],
    "trunking": [
        "trunk"
    ],
    "variants": [
        "variant"
    ],
    "electorates": [
        "electorate"
    ],
    "mercuries": [
        "mercury"
    ],
    "pylori": [
        "pylorus"
    ],
    "coordinates": [
        "coordinate"
    ],
    "coordinating": [
        "coordinate"
    ],
    "coordinated": [
        "coordinate"
    ],
    "heralded": [
        "herald"
    ],
    "heralds": [
        "herald"
    ],
    "heralding": [
        "herald"
    ],
    "peripherals": [
        "peripheral"
    ],
    "localities": [
        "locality"
    ],
    "mugs": [
        "mug"
    ],
    "mugged": [
        "mug"
    ],
    "mugging": [
        "mug"
    ],
    "propagandas": [
        "propaganda"
    ],
    "terminated": [
        "terminate"
    ],
    "terminating": [
        "terminate"
    ],
    "terminates": [
        "terminate"
    ],
    "racks": [
        "rack"
    ],
    "racked": [
        "rack"
    ],
    "racking": [
        "rack"
    ],
    "sailors": [
        "sailor"
    ],
    "caribbeans": [
        "caribbean"
    ],
    "conspiracies": [
        "conspiracy"
    ],
    "fashionables": [
        "fashionable"
    ],
    "repaid": [
        "repay"
    ],
    "repaying": [
        "repay"
    ],
    "repays": [
        "repay"
    ],
    "straps": [
        "strap"
    ],
    "strapped": [
        "strap"
    ],
    "strapping": [
        "strap"
    ],
    "discouraged": [
        "discourage"
    ],
    "discouraging": [
        "discourage"
    ],
    "discourages": [
        "discourage"
    ],
    "herefords": [
        "hereford"
    ],
    "headaches": [
        "headache"
    ],
    "chapmen": [
        "chapman"
    ],
    "mercies": [
        "mercy"
    ],
    "hostages": [
        "hostage"
    ],
    "impulses": [
        "impulse"
    ],
    "preservations": [
        "preservation"
    ],
    "shelleys": [
        "shelley"
    ],
    "skippers": [
        "skipper"
    ],
    "skippered": [
        "skipper"
    ],
    "skippering": [
        "skipper"
    ],
    "hungers": [
        "hunger"
    ],
    "hungered": [
        "hunger"
    ],
    "hungering": [
        "hunger"
    ],
    "differentials": [
        "differential"
    ],
    "darwins": [
        "darwin"
    ],
    "brows": [
        "brow"
    ],
    "forged": [
        "forge"
    ],
    "forging": [
        "forge"
    ],
    "hungarians": [
        "hungarian"
    ],
    "brokers": [
        "broker"
    ],
    "brokered": [
        "broker"
    ],
    "hays": [
        "hay"
    ],
    "haying": [
        "hay"
    ],
    "hayed": [
        "hay"
    ],
    "insured": [
        "insure"
    ],
    "insuring": [
        "insure"
    ],
    "insures": [
        "insure"
    ],
    "prosperities": [
        "prosperity"
    ],
    "politest": [
        "polite"
    ],
    "politer": [
        "polite"
    ],
    "quotations": [
        "quotation"
    ],
    "romancing": [
        "romance"
    ],
    "romanced": [
        "romance"
    ],
    "suburbs": [
        "suburb"
    ],
    "articulated": [
        "articulate"
    ],
    "articulating": [
        "articulate"
    ],
    "articulates": [
        "articulate"
    ],
    "salvations": [
        "salvation"
    ],
    "zs": [
        "z"
    ],
    "arenas": [
        "arena"
    ],
    "conned": [
        "con"
    ],
    "conning": [
        "con"
    ],
    "coned": [
        "cone",
        "con"
    ],
    "coning": [
        "cone",
        "con"
    ],
    "listeners": [
        "listener"
    ],
    "maids": [
        "maid"
    ],
    "solidarities": [
        "solidarity"
    ],
    "trents": [
        "trent"
    ],
    "dales": [
        "dale"
    ],
    "richardss": [
        "richards"
    ],
    "preaching": [
        "preach"
    ],
    "preached": [
        "preach"
    ],
    "preaches": [
        "preach"
    ],
    "atomics": [
        "atomic"
    ],
    "performers": [
        "performer"
    ],
    "brackets": [
        "bracket"
    ],
    "bracketed": [
        "bracket"
    ],
    "bracketing": [
        "bracket"
    ],
    "deadlines": [
        "deadline"
    ],
    "gauges": [
        "gauge"
    ],
    "gauged": [
        "gauge"
    ],
    "gauging": [
        "gauge"
    ],
    "omitted": [
        "omit"
    ],
    "omitting": [
        "omit"
    ],
    "omits": [
        "omit"
    ],
    "supervisors": [
        "supervisor"
    ],
    "carings": [
        "caring"
    ],
    "cautiouss": [
        "cautious"
    ],
    "czechoslovakias": [
        "czechoslovakia"
    ],
    "follies": [
        "folly"
    ],
    "graying": [
        "gray"
    ],
    "outfits": [
        "outfit"
    ],
    "outfitting": [
        "outfit"
    ],
    "outfitted": [
        "outfit"
    ],
    "dominances": [
        "dominance"
    ],
    "groaned": [
        "groan"
    ],
    "groaning": [
        "groan"
    ],
    "groans": [
        "groan"
    ],
    "scholarships": [
        "scholarship"
    ],
    "warriors": [
        "warrior"
    ],
    "corpses": [
        "corpse"
    ],
    "piers": [
        "pier"
    ],
    "balconies": [
        "balcony"
    ],
    "balconied": [
        "balcony"
    ],
    "jarred": [
        "jar"
    ],
    "jarring": [
        "jar"
    ],
    "lebanons": [
        "lebanon"
    ],
    "bankruptcies": [
        "bankruptcy"
    ],
    "cherries": [
        "cherry"
    ],
    "cherrys": [
        "cherry"
    ],
    "collinss": [
        "collins"
    ],
    "inabilities": [
        "inability"
    ],
    "deliciouss": [
        "delicious"
    ],
    "dolls": [
        "doll"
    ],
    "dolled": [
        "doll"
    ],
    "dolling": [
        "doll"
    ],
    "racisms": [
        "racism"
    ],
    "swapped": [
        "swap"
    ],
    "swapping": [
        "swap"
    ],
    "swaps": [
        "swap"
    ],
    "endings": [
        "ending"
    ],
    "geniuses": [
        "genius"
    ],
    "haunted": [
        "haunt"
    ],
    "haunts": [
        "haunt"
    ],
    "haunting": [
        "haunt"
    ],
    "wrecked": [
        "wreck"
    ],
    "wrecks": [
        "wreck"
    ],
    "wrecking": [
        "wreck"
    ],
    "courtesies": [
        "courtesy"
    ],
    "ploughed": [
        "plough"
    ],
    "ploughing": [
        "plough"
    ],
    "ploughs": [
        "plough"
    ],
    "survivors": [
        "survivor"
    ],
    "rollings": [
        "rolling"
    ],
    "portugals": [
        "portugal"
    ],
    "dyings": [
        "dying"
    ],
    "glued": [
        "glue"
    ],
    "glues": [
        "glue"
    ],
    "gluing": [
        "glue"
    ],
    "glueing": [
        "glue"
    ],
    "hardier": [
        "hardy"
    ],
    "hardiest": [
        "hardy"
    ],
    "stools": [
        "stool"
    ],
    "tokyoes": [
        "tokyo"
    ],
    "prosecuted": [
        "prosecute"
    ],
    "prosecuting": [
        "prosecute"
    ],
    "prosecutes": [
        "prosecute"
    ],
    "apologised": [
        "apologise"
    ],
    "apologising": [
        "apologise"
    ],
    "apologises": [
        "apologise"
    ],
    "hops": [
        "hop"
    ],
    "hopping": [
        "hop"
    ],
    "hopped": [
        "hop"
    ],
    "frosts": [
        "frost"
    ],
    "frosting": [
        "frost"
    ],
    "frosted": [
        "frost"
    ],
    "torched": [
        "torch"
    ],
    "torching": [
        "torch"
    ],
    "imfs": [
        "imf"
    ],
    "masons": [
        "mason"
    ],
    "monkeys": [
        "monkey"
    ],
    "monkeying": [
        "monkey"
    ],
    "monkeyed": [
        "monkey"
    ],
    "stadia": [
        "stadium"
    ],
    "stadiums": [
        "stadium"
    ],
    "bombers": [
        "bomber"
    ],
    "majesties": [
        "majesty"
    ],
    "psychiatrics": [
        "psychiatric"
    ],
    "balloons": [
        "balloon"
    ],
    "ballooning": [
        "balloon"
    ],
    "ballooned": [
        "balloon"
    ],
    "investigators": [
        "investigator"
    ],
    "loomed": [
        "loom"
    ],
    "looms": [
        "loom"
    ],
    "looming": [
        "loom"
    ],
    "biologies": [
        "biology"
    ],
    "renewals": [
        "renewal"
    ],
    "homosexuals": [
        "homosexual"
    ],
    "reagans": [
        "reagan"
    ],
    "insiders": [
        "insider"
    ],
    "mainframes": [
        "mainframe"
    ],
    "wardrobes": [
        "wardrobe"
    ],
    "chicagoes": [
        "chicago"
    ],
    "endured": [
        "endure"
    ],
    "enduring": [
        "endure"
    ],
    "guineas": [
        "guinea"
    ],
    "hps": [
        "hp"
    ],
    "ozs": [
        "oz"
    ],
    "deficiencies": [
        "deficiency"
    ],
    "homelesses": [
        "homeless"
    ],
    "memoranda": [
        "memorandum"
    ],
    "orbits": [
        "orbit"
    ],
    "orbiting": [
        "orbit"
    ],
    "orbited": [
        "orbit"
    ],
    "ponies": [
        "pony"
    ],
    "gilberts": [
        "gilbert"
    ],
    "grinding": [
        "grind"
    ],
    "grinds": [
        "grind"
    ],
    "descents": [
        "descent"
    ],
    "fishermen": [
        "fisherman"
    ],
    "franchising": [
        "franchise"
    ],
    "franchised": [
        "franchise"
    ],
    "mightiest": [
        "mighty"
    ],
    "mightier": [
        "mighty"
    ],
    "supportings": [
        "supporting"
    ],
    "donors": [
        "donor"
    ],
    "hoods": [
        "hood"
    ],
    "hooding": [
        "hood"
    ],
    "lesbians": [
        "lesbian"
    ],
    "accelerated": [
        "accelerate"
    ],
    "accelerating": [
        "accelerate"
    ],
    "accelerates": [
        "accelerate"
    ],
    "bombings": [
        "bombing"
    ],
    "englishmen": [
        "englishman"
    ],
    "flours": [
        "flour"
    ],
    "floured": [
        "flour"
    ],
    "flouring": [
        "flour"
    ],
    "greenhouses": [
        "greenhouse"
    ],
    "accuseds": [
        "accused"
    ],
    "athelstans": [
        "athelstan"
    ],
    "blessed": [
        "bless"
    ],
    "blest": [
        "bless"
    ],
    "calves": [
        "calf"
    ],
    "mucosae": [
        "mucosa"
    ],
    "programmings": [
        "programming"
    ],
    "ambiguities": [
        "ambiguity"
    ],
    "clarities": [
        "clarity"
    ],
    "choruses": [
        "chorus"
    ],
    "chorused": [
        "chorus"
    ],
    "chorusing": [
        "chorus"
    ],
    "spoons": [
        "spoon"
    ],
    "spooned": [
        "spoon"
    ],
    "spooning": [
        "spoon"
    ],
    "resentments": [
        "resentment"
    ],
    "glens": [
        "glen"
    ],
    "jerked": [
        "jerk"
    ],
    "jerking": [
        "jerk"
    ],
    "jerks": [
        "jerk"
    ],
    "keyness": [
        "keynes"
    ],
    "feasts": [
        "feast"
    ],
    "feasting": [
        "feast"
    ],
    "feasted": [
        "feast"
    ],
    "reids": [
        "reid"
    ],
    "jockeying": [
        "jockey"
    ],
    "jockeyed": [
        "jockey"
    ],
    "worryings": [
        "worrying"
    ],
    "blakes": [
        "blake"
    ],
    "copyrights": [
        "copyright"
    ],
    "egos": [
        "ego"
    ],
    "revenged": [
        "revenge"
    ],
    "revenges": [
        "revenge"
    ],
    "revenging": [
        "revenge"
    ],
    "dwarfs": [
        "dwarf"
    ],
    "dwarfed": [
        "dwarf"
    ],
    "dwarves": [
        "dwarf"
    ],
    "dwarfing": [
        "dwarf"
    ],
    "graduals": [
        "gradual"
    ],
    "rifled": [
        "rifle"
    ],
    "rifling": [
        "rifle"
    ],
    "chesters": [
        "chester"
    ],
    "heathers": [
        "heather"
    ],
    "stumbled": [
        "stumble"
    ],
    "stumbling": [
        "stumble"
    ],
    "stumbles": [
        "stumble"
    ],
    "ditches": [
        "ditch"
    ],
    "ditched": [
        "ditch"
    ],
    "ditching": [
        "ditch"
    ],
    "baileys": [
        "bailey"
    ],
    "methodologies": [
        "methodology"
    ],
    "passports": [
        "passport"
    ],
    "pillows": [
        "pillow"
    ],
    "pillowed": [
        "pillow"
    ],
    "pillowing": [
        "pillow"
    ],
    "rainbows": [
        "rainbow"
    ],
    "bladders": [
        "bladder"
    ],
    "bladdered": [
        "bladder"
    ],
    "licensed": [
        "license"
    ],
    "licensing": [
        "license"
    ],
    "licenses": [
        "license"
    ],
    "postponed": [
        "postpone"
    ],
    "postpones": [
        "postpone"
    ],
    "postponing": [
        "postpone"
    ],
    "governings": [
        "governing"
    ],
    "grimmer": [
        "grim"
    ],
    "grimmest": [
        "grim"
    ],
    "furnished": [
        "furnish"
    ],
    "furnishing": [
        "furnish"
    ],
    "furnishes": [
        "furnish"
    ],
    "velocities": [
        "velocity"
    ],
    "apprentices": [
        "apprentice"
    ],
    "apprenticed": [
        "apprentice"
    ],
    "apprenticing": [
        "apprentice"
    ],
    "clearings": [
        "clearing"
    ],
    "reynoldss": [
        "reynolds"
    ],
    "aluminiums": [
        "aluminium"
    ],
    "bosnias": [
        "bosnia"
    ],
    "chosens": [
        "chosen"
    ],
    "treading": [
        "tread"
    ],
    "trod": [
        "tread"
    ],
    "treads": [
        "tread"
    ],
    "trodden": [
        "tread"
    ],
    "treaded": [
        "tread"
    ],
    "exclaimed": [
        "exclaim"
    ],
    "exclaiming": [
        "exclaim"
    ],
    "exclaims": [
        "exclaim"
    ],
    "inflicted": [
        "inflict"
    ],
    "inflicting": [
        "inflict"
    ],
    "inflicts": [
        "inflict"
    ],
    "murderers": [
        "murderer"
    ],
    "burials": [
        "burial"
    ],
    "newcomers": [
        "newcomer"
    ],
    "bowlers": [
        "bowler"
    ],
    "cults": [
        "cult"
    ],
    "shrank": [
        "shrink"
    ],
    "shrunk": [
        "shrink"
    ],
    "shrinking": [
        "shrink"
    ],
    "shrinks": [
        "shrink"
    ],
    "shrunken": [
        "shrink"
    ],
    "listenings": [
        "listening"
    ],
    "darts": [
        "dart"
    ],
    "darted": [
        "dart"
    ],
    "darting": [
        "dart"
    ],
    "licked": [
        "lick"
    ],
    "licking": [
        "lick"
    ],
    "licks": [
        "lick"
    ],
    "mainlands": [
        "mainland"
    ],
    "thundered": [
        "thunder"
    ],
    "thundering": [
        "thunder"
    ],
    "thunders": [
        "thunder"
    ],
    "bitches": [
        "bitch"
    ],
    "bitching": [
        "bitch"
    ],
    "bitched": [
        "bitch"
    ],
    "dressings": [
        "dressing"
    ],
    "hatreds": [
        "hatred"
    ],
    "injunctions": [
        "injunction"
    ],
    "handicappeds": [
        "handicapped"
    ],
    "meadows": [
        "meadow"
    ],
    "privacies": [
        "privacy"
    ],
    "cheating": [
        "cheat"
    ],
    "cheated": [
        "cheat"
    ],
    "cheats": [
        "cheat"
    ],
    "enjoyments": [
        "enjoyment"
    ],
    "flared": [
        "flare"
    ],
    "flares": [
        "flare"
    ],
    "flaring": [
        "flare"
    ],
    "mocked": [
        "mock"
    ],
    "mocking": [
        "mock"
    ],
    "mocks": [
        "mock"
    ],
    "appetites": [
        "appetite"
    ],
    "fussing": [
        "fuss"
    ],
    "fussed": [
        "fuss"
    ],
    "guilds": [
        "guild"
    ],
    "lilies": [
        "lily"
    ],
    "cushions": [
        "cushion"
    ],
    "cushioned": [
        "cushion"
    ],
    "cushioning": [
        "cushion"
    ],
    "noisier": [
        "noisy"
    ],
    "noisiest": [
        "noisy"
    ],
    "asylums": [
        "asylum"
    ],
    "corals": [
        "coral"
    ],
    "enthusiasts": [
        "enthusiast"
    ],
    "residues": [
        "residue"
    ],
    "nationalisms": [
        "nationalism"
    ],
    "pearls": [
        "pearl"
    ],
    "pearled": [
        "pearl"
    ],
    "pearling": [
        "pearl"
    ],
    "wartimes": [
        "wartime"
    ],
    "arcing": [
        "arc"
    ],
    "arced": [
        "arc"
    ],
    "knittings": [
        "knitting"
    ],
    "bearings": [
        "bearing"
    ],
    "donated": [
        "donate"
    ],
    "donating": [
        "donate"
    ],
    "donates": [
        "donate"
    ],
    "dairies": [
        "dairy"
    ],
    "dairying": [
        "dairy"
    ],
    "richardsons": [
        "richardson"
    ],
    "sheriffs": [
        "sheriff"
    ],
    "moaning": [
        "moan"
    ],
    "moaned": [
        "moan"
    ],
    "moans": [
        "moan"
    ],
    "newmen": [
        "newman"
    ],
    "prohibited": [
        "prohibit"
    ],
    "prohibiting": [
        "prohibit"
    ],
    "prohibits": [
        "prohibit"
    ],
    "staircases": [
        "staircase"
    ],
    "beards": [
        "beard"
    ],
    "bearding": [
        "beard"
    ],
    "chords": [
        "chord"
    ],
    "chording": [
        "chord"
    ],
    "mitchells": [
        "mitchell"
    ],
    "chalked": [
        "chalk"
    ],
    "chalks": [
        "chalk"
    ],
    "chalking": [
        "chalk"
    ],
    "hamlets": [
        "hamlet"
    ],
    "northamptons": [
        "northampton"
    ],
    "rockier": [
        "rocky"
    ],
    "rockiest": [
        "rocky"
    ],
    "tumbled": [
        "tumble"
    ],
    "tumbling": [
        "tumble"
    ],
    "tumbles": [
        "tumble"
    ],
    "chilled": [
        "chill"
    ],
    "chills": [
        "chill"
    ],
    "chilling": [
        "chill"
    ],
    "fridges": [
        "fridge"
    ],
    "reluctances": [
        "reluctance"
    ],
    "spiders": [
        "spider"
    ],
    "venices": [
        "venice"
    ],
    "vocals": [
        "vocal"
    ],
    "commentaries": [
        "commentary"
    ],
    "hugged": [
        "hug"
    ],
    "hugging": [
        "hug"
    ],
    "hugs": [
        "hug"
    ],
    "appallings": [
        "appalling"
    ],
    "cargoes": [
        "cargo"
    ],
    "eldests": [
        "eldest"
    ],
    "genevas": [
        "geneva"
    ],
    "manoeuvring": [
        "manoeuvre"
    ],
    "manoeuvred": [
        "manoeuvre",
        "manoeuvr"
    ],
    "nelsons": [
        "nelson"
    ],
    "sittings": [
        "sitting"
    ],
    "stung": [
        "sting"
    ],
    "stings": [
        "sting"
    ],
    "stinging": [
        "sting"
    ],
    "sunnier": [
        "sunny"
    ],
    "sunniest": [
        "sunny"
    ],
    "sunnies": [
        "sunny"
    ],
    "exempted": [
        "exempt"
    ],
    "exempting": [
        "exempt"
    ],
    "nominated": [
        "nominate"
    ],
    "nominating": [
        "nominate"
    ],
    "nominates": [
        "nominate"
    ],
    "bulbs": [
        "bulb"
    ],
    "flapping": [
        "flap"
    ],
    "flaps": [
        "flap"
    ],
    "flapped": [
        "flap"
    ],
    "notebooks": [
        "notebook"
    ],
    "tolls": [
        "toll"
    ],
    "tolled": [
        "toll"
    ],
    "tolling": [
        "toll"
    ],
    "faithfuls": [
        "faithful"
    ],
    "matchings": [
        "matching"
    ],
    "sydneys": [
        "sydney"
    ],
    "civics": [
        "civic"
    ],
    "magnitudes": [
        "magnitude"
    ],
    "skipped": [
        "skip"
    ],
    "skipping": [
        "skip"
    ],
    "skips": [
        "skip"
    ],
    "caping": [
        "cape"
    ],
    "diagnosed": [
        "diagnose"
    ],
    "diagnosing": [
        "diagnose"
    ],
    "gibsons": [
        "gibson"
    ],
    "jasons": [
        "jason"
    ],
    "kenyas": [
        "kenya"
    ],
    "wembleys": [
        "wembley"
    ],
    "biopsied": [
        "biopsy"
    ],
    "texass": [
        "texas"
    ],
    "voltages": [
        "voltage"
    ],
    "striving": [
        "strive"
    ],
    "strove": [
        "strive"
    ],
    "strives": [
        "strive"
    ],
    "striven": [
        "strive"
    ],
    "strived": [
        "strive"
    ],
    "evoked": [
        "evoke"
    ],
    "evokes": [
        "evoke"
    ],
    "evoking": [
        "evoke"
    ],
    "invoked": [
        "invoke"
    ],
    "invoking": [
        "invoke"
    ],
    "invokes": [
        "invoke"
    ],
    "swayed": [
        "sway"
    ],
    "swaying": [
        "sway"
    ],
    "sways": [
        "sway"
    ],
    "adjectives": [
        "adjective"
    ],
    "saddled": [
        "saddle"
    ],
    "saddles": [
        "saddle"
    ],
    "saddling": [
        "saddle"
    ],
    "receptors": [
        "receptor"
    ],
    "breweries": [
        "brewery"
    ],
    "demolished": [
        "demolish"
    ],
    "demolishing": [
        "demolish"
    ],
    "demolishes": [
        "demolish"
    ],
    "spellings": [
        "spelling"
    ],
    "vetted": [
        "vet"
    ],
    "vetting": [
        "vet"
    ],
    "daylights": [
        "daylight"
    ],
    "daylighting": [
        "daylight"
    ],
    "harrisons": [
        "harrison"
    ],
    "leonards": [
        "leonard"
    ],
    "paradises": [
        "paradise"
    ],
    "rattled": [
        "rattle"
    ],
    "rattling": [
        "rattle"
    ],
    "rattles": [
        "rattle"
    ],
    "nationalities": [
        "nationality"
    ],
    "hissed": [
        "hiss"
    ],
    "hissing": [
        "hiss"
    ],
    "scrambled": [
        "scramble"
    ],
    "scrambling": [
        "scramble"
    ],
    "scrambles": [
        "scramble"
    ],
    "sores": [
        "sore"
    ],
    "sorer": [
        "sore"
    ],
    "baldwins": [
        "baldwin"
    ],
    "parred": [
        "par"
    ],
    "parring": [
        "par"
    ],
    "documentaries": [
        "documentary"
    ],
    "freights": [
        "freight"
    ],
    "freighted": [
        "freight"
    ],
    "freighting": [
        "freight"
    ],
    "housewives": [
        "housewife"
    ],
    "housewifes": [
        "housewife"
    ],
    "injected": [
        "inject"
    ],
    "injecting": [
        "inject"
    ],
    "injects": [
        "inject"
    ],
    "prevalences": [
        "prevalence"
    ],
    "ruder": [
        "rude"
    ],
    "rudest": [
        "rude"
    ],
    "wheats": [
        "wheat"
    ],
    "aquaria": [
        "aquarium"
    ],
    "authorised": [
        "authorise"
    ],
    "authorising": [
        "authorise"
    ],
    "authorises": [
        "authorise"
    ],
    "dawsons": [
        "dawson"
    ],
    "gregories": [
        "gregory"
    ],
    "supplementaries": [
        "supplementary"
    ],
    "gutted": [
        "gut"
    ],
    "gutting": [
        "gut"
    ],
    "guts": [
        "gut"
    ],
    "outsets": [
        "outset"
    ],
    "ants": [
        "ant"
    ],
    "anted": [
        "ant"
    ],
    "anting": [
        "ant"
    ],
    "attainments": [
        "attainment"
    ],
    "indulged": [
        "indulge"
    ],
    "indulging": [
        "indulge"
    ],
    "indulges": [
        "indulge"
    ],
    "merediths": [
        "meredith"
    ],
    "batches": [
        "batch"
    ],
    "batching": [
        "batch"
    ],
    "batched": [
        "batch"
    ],
    "credibilities": [
        "credibility"
    ],
    "hollies": [
        "holly"
    ],
    "minimising": [
        "minimise"
    ],
    "minimised": [
        "minimise"
    ],
    "rehearsals": [
        "rehearsal"
    ],
    "blackpools": [
        "blackpool"
    ],
    "corks": [
        "cork"
    ],
    "corked": [
        "cork"
    ],
    "corking": [
        "cork"
    ],
    "monarchs": [
        "monarch"
    ],
    "pinched": [
        "pinch"
    ],
    "pinching": [
        "pinch"
    ],
    "pinches": [
        "pinch"
    ],
    "scars": [
        "scar"
    ],
    "scarred": [
        "scar"
    ],
    "scarring": [
        "scar"
    ],
    "powells": [
        "powell"
    ],
    "plasmas": [
        "plasma"
    ],
    "soaking": [
        "soak"
    ],
    "soaked": [
        "soak"
    ],
    "soaks": [
        "soak"
    ],
    "swedishes": [
        "swedish"
    ],
    "conveniences": [
        "convenience"
    ],
    "convenienced": [
        "convenience"
    ],
    "conveniencing": [
        "convenience"
    ],
    "caterings": [
        "catering"
    ],
    "invaded": [
        "invade"
    ],
    "invading": [
        "invade"
    ],
    "invades": [
        "invade"
    ],
    "jays": [
        "jay"
    ],
    "pastures": [
        "pasture"
    ],
    "pastured": [
        "pasture"
    ],
    "pasturing": [
        "pasture"
    ],
    "chucked": [
        "chuck"
    ],
    "chucking": [
        "chuck"
    ],
    "chucks": [
        "chuck"
    ],
    "arnolds": [
        "arnold"
    ],
    "counsellors": [
        "counsellor"
    ],
    "floras": [
        "flora"
    ],
    "hailed": [
        "hail"
    ],
    "hailing": [
        "hail"
    ],
    "hails": [
        "hail"
    ],
    "potteries": [
        "pottery"
    ],
    "quarrels": [
        "quarrel"
    ],
    "quarrelled": [
        "quarrel"
    ],
    "quarrelling": [
        "quarrel"
    ],
    "treasurers": [
        "treasurer"
    ],
    "blooms": [
        "bloom"
    ],
    "blooming": [
        "bloom"
    ],
    "bloomed": [
        "bloom"
    ],
    "madames": [
        "madame"
    ],
    "reconciled": [
        "reconcile"
    ],
    "reconciling": [
        "reconcile"
    ],
    "reconciles": [
        "reconcile"
    ],
    "adamss": [
        "adams"
    ],
    "chewing": [
        "chew"
    ],
    "chewed": [
        "chew"
    ],
    "chews": [
        "chew"
    ],
    "consistencies": [
        "consistency"
    ],
    "knelt": [
        "kneel"
    ],
    "kneeling": [
        "kneel"
    ],
    "kneels": [
        "kneel"
    ],
    "kneeled": [
        "kneel"
    ],
    "mandatories": [
        "mandatory"
    ],
    "distributors": [
        "distributor"
    ],
    "windsors": [
        "windsor"
    ],
    "accomplished": [
        "accomplish"
    ],
    "accomplishing": [
        "accomplish"
    ],
    "accomplishes": [
        "accomplish"
    ],
    "deleted": [
        "delete"
    ],
    "deleting": [
        "delete"
    ],
    "deletes": [
        "delete"
    ],
    "discoing": [
        "disco"
    ],
    "pillars": [
        "pillar"
    ],
    "blessings": [
        "blessing"
    ],
    "clearances": [
        "clearance"
    ],
    "immunes": [
        "immune"
    ],
    "lenders": [
        "lender"
    ],
    "rocketed": [
        "rocket"
    ],
    "rocketted": [
        "rocket"
    ],
    "rocketing": [
        "rocket"
    ],
    "sailings": [
        "sailing"
    ],
    "underlying": [
        "underlie"
    ],
    "underlay": [
        "underlie"
    ],
    "underlies": [
        "underlie",
        "underly"
    ],
    "underlain": [
        "underlie"
    ],
    "nuclei": [
        "nucleus"
    ],
    "sausages": [
        "sausage"
    ],
    "screenings": [
        "screening"
    ],
    "soared": [
        "soar"
    ],
    "soaring": [
        "soar"
    ],
    "soars": [
        "soar"
    ],
    "argentinas": [
        "argentina"
    ],
    "critiquing": [
        "critique"
    ],
    "critiqued": [
        "critique"
    ],
    "flickered": [
        "flicker"
    ],
    "flickering": [
        "flicker"
    ],
    "flickers": [
        "flicker"
    ],
    "stocktons": [
        "stockton"
    ],
    "wellss": [
        "wells"
    ],
    "gigs": [
        "gig"
    ],
    "gigged": [
        "gig"
    ],
    "gigging": [
        "gig"
    ],
    "melissas": [
        "melissa"
    ],
    "millss": [
        "mills"
    ],
    "arabias": [
        "arabia"
    ],
    "forestries": [
        "forestry"
    ],
    "gowns": [
        "gown"
    ],
    "ribbons": [
        "ribbon"
    ],
    "ribboning": [
        "ribbon"
    ],
    "giggled": [
        "giggle"
    ],
    "giggling": [
        "giggle"
    ],
    "giggles": [
        "giggle"
    ],
    "wallaces": [
        "wallace"
    ],
    "dirts": [
        "dirt"
    ],
    "mathss": [
        "maths"
    ],
    "scraped": [
        "scrape"
    ],
    "scraping": [
        "scrape"
    ],
    "scrapes": [
        "scrape"
    ],
    "constrained": [
        "constrain"
    ],
    "constraining": [
        "constrain"
    ],
    "constrains": [
        "constrain"
    ],
    "substantives": [
        "substantive"
    ],
    "vacuums": [
        "vacuum"
    ],
    "vacuuming": [
        "vacuum"
    ],
    "vacuumed": [
        "vacuum"
    ],
    "workplaces": [
        "workplace"
    ],
    "notified": [
        "notify"
    ],
    "notifying": [
        "notify"
    ],
    "notifies": [
        "notify"
    ],
    "theorists": [
        "theorist"
    ],
    "richmonds": [
        "richmond"
    ],
    "rhetorics": [
        "rhetoric"
    ],
    "rnas": [
        "rna"
    ],
    "vectors": [
        "vector"
    ],
    "bypassed": [
        "bypass"
    ],
    "bypassing": [
        "bypass"
    ],
    "bypasses": [
        "bypass"
    ],
    "murphies": [
        "murphy"
    ],
    "peats": [
        "peat"
    ],
    "peating": [
        "peat"
    ],
    "francoes": [
        "franco"
    ],
    "mosses": [
        "moss"
    ],
    "uncovered": [
        "uncover"
    ],
    "uncovering": [
        "uncover"
    ],
    "uncovers": [
        "uncover"
    ],
    "gardenings": [
        "gardening"
    ],
    "reasonings": [
        "reasoning"
    ],
    "vicars": [
        "vicar"
    ],
    "vowed": [
        "vow"
    ],
    "vows": [
        "vow"
    ],
    "vowing": [
        "vow"
    ],
    "fairies": [
        "fairy"
    ],
    "literacies": [
        "literacy"
    ],
    "packagings": [
        "packaging"
    ],
    "pragues": [
        "prague"
    ],
    "labourers": [
        "labourer"
    ],
    "disruptions": [
        "disruption"
    ],
    "seculars": [
        "secular"
    ],
    "communisms": [
        "communism"
    ],
    "fisheries": [
        "fishery"
    ],
    "pursed": [
        "purse"
    ],
    "purses": [
        "purse"
    ],
    "pursing": [
        "purse"
    ],
    "breathings": [
        "breathing"
    ],
    "deployed": [
        "deploy"
    ],
    "deploying": [
        "deploy"
    ],
    "deploys": [
        "deploy"
    ],
    "gdps": [
        "gdp"
    ],
    "restructurings": [
        "restructuring"
    ],
    "sockets": [
        "socket"
    ],
    "adrians": [
        "adrian"
    ],
    "axed": [
        "axe"
    ],
    "axeing": [
        "axe"
    ],
    "axing": [
        "ax",
        "axe"
    ],
    "straightened": [
        "straighten"
    ],
    "straightening": [
        "straighten"
    ],
    "straightens": [
        "straighten"
    ],
    "altars": [
        "altar"
    ],
    "attachments": [
        "attachment"
    ],
    "blinked": [
        "blink"
    ],
    "blinking": [
        "blink"
    ],
    "blinks": [
        "blink"
    ],
    "solvents": [
        "solvent"
    ],
    "voids": [
        "void"
    ],
    "voided": [
        "void"
    ],
    "voiding": [
        "void"
    ],
    "voider": [
        "void"
    ],
    "linens": [
        "linen"
    ],
    "offsprings": [
        "offspring"
    ],
    "retrieved": [
        "retrieve"
    ],
    "retrieving": [
        "retrieve"
    ],
    "retrieves": [
        "retrieve"
    ],
    "scared": [
        "scare"
    ],
    "scares": [
        "scare"
    ],
    "scaring": [
        "scare"
    ],
    "simplicities": [
        "simplicity"
    ],
    "beneficiaries": [
        "beneficiary"
    ],
    "singapores": [
        "singapore"
    ],
    "frogs": [
        "frog"
    ],
    "frogged": [
        "frog"
    ],
    "craned": [
        "crane"
    ],
    "craning": [
        "crane"
    ],
    "kites": [
        "kite"
    ],
    "jerusalems": [
        "jerusalem"
    ],
    "nuns": [
        "nun"
    ],
    "mushrooms": [
        "mushroom"
    ],
    "mushroomed": [
        "mushroom"
    ],
    "mushrooming": [
        "mushroom"
    ],
    "cords": [
        "cord"
    ],
    "corded": [
        "cord"
    ],
    "embryos": [
        "embryo"
    ],
    "felled": [
        "fell"
    ],
    "fells": [
        "fell"
    ],
    "felling": [
        "fell"
    ],
    "gills": [
        "gill"
    ],
    "gilling": [
        "gill"
    ],
    "levered": [
        "lever"
    ],
    "levering": [
        "lever"
    ],
    "butchered": [
        "butcher"
    ],
    "butchering": [
        "butcher"
    ],
    "butchers": [
        "butcher"
    ],
    "restrained": [
        "restrain"
    ],
    "restraining": [
        "restrain"
    ],
    "restrains": [
        "restrain"
    ],
    "zeroing": [
        "zero"
    ],
    "zeroes": [
        "zero"
    ],
    "zeroed": [
        "zero"
    ],
    "offended": [
        "offend"
    ],
    "offending": [
        "offend"
    ],
    "offends": [
        "offend"
    ],
    "racings": [
        "racing"
    ],
    "wardens": [
        "warden"
    ],
    "wardening": [
        "warden"
    ],
    "cemeteries": [
        "cemetery"
    ],
    "turnings": [
        "turning"
    ],
    "floatings": [
        "floating"
    ],
    "multimedias": [
        "multimedia"
    ],
    "superintendents": [
        "superintendent"
    ],
    "absurds": [
        "absurd"
    ],
    "frightenings": [
        "frightening"
    ],
    "handier": [
        "handy"
    ],
    "handies": [
        "handy"
    ],
    "handiest": [
        "handy"
    ],
    "waiters": [
        "waiter"
    ],
    "opticals": [
        "optical"
    ],
    "seasonals": [
        "seasonal"
    ],
    "glooms": [
        "gloom"
    ],
    "gloomed": [
        "gloom"
    ],
    "glooming": [
        "gloom"
    ],
    "blackburns": [
        "blackburn"
    ],
    "fellowships": [
        "fellowship"
    ],
    "florences": [
        "florence"
    ],
    "heroins": [
        "heroin"
    ],
    "inquests": [
        "inquest"
    ],
    "distortions": [
        "distortion"
    ],
    "nouns": [
        "noun"
    ],
    "villagers": [
        "villager"
    ],
    "dimmed": [
        "dim"
    ],
    "dimmer": [
        "dim"
    ],
    "dimming": [
        "dim"
    ],
    "dimmest": [
        "dim"
    ],
    "dims": [
        "dim"
    ],
    "helmets": [
        "helmet"
    ],
    "odours": [
        "odour"
    ],
    "saddams": [
        "saddam"
    ],
    "crouched": [
        "crouch"
    ],
    "crouching": [
        "crouch"
    ],
    "crouches": [
        "crouch"
    ],
    "limestones": [
        "limestone"
    ],
    "bellies": [
        "belly"
    ],
    "bellied": [
        "belly"
    ],
    "bellying": [
        "belly"
    ],
    "bellys": [
        "belly"
    ],
    "choked": [
        "choke"
    ],
    "choking": [
        "choke"
    ],
    "chokes": [
        "choke"
    ],
    "ageings": [
        "ageing"
    ],
    "provisionals": [
        "provisional"
    ],
    "undergraduates": [
        "undergraduate"
    ],
    "cardinals": [
        "cardinal"
    ],
    "shaws": [
        "shaw"
    ],
    "healed": [
        "heal"
    ],
    "healing": [
        "heal"
    ],
    "heals": [
        "heal"
    ],
    "lbs": [
        "lb"
    ],
    "lincolns": [
        "lincoln"
    ],
    "plagued": [
        "plague"
    ],
    "plagues": [
        "plague"
    ],
    "plaguing": [
        "plague"
    ],
    "exaggerated": [
        "exaggerate"
    ],
    "exaggerating": [
        "exaggerate"
    ],
    "exaggerates": [
        "exaggerate"
    ],
    "lydias": [
        "lydia"
    ],
    "monasteries": [
        "monastery"
    ],
    "proportionals": [
        "proportional"
    ],
    "envied": [
        "envy"
    ],
    "envying": [
        "envy"
    ],
    "revolts": [
        "revolt"
    ],
    "revolted": [
        "revolt"
    ],
    "revolting": [
        "revolt"
    ],
    "teased": [
        "tease"
    ],
    "teasing": [
        "tease"
    ],
    "teases": [
        "tease"
    ],
    "buffers": [
        "buffer"
    ],
    "buffered": [
        "buffer"
    ],
    "buffering": [
        "buffer"
    ],
    "instrumentals": [
        "instrumental"
    ],
    "umbrellas": [
        "umbrella"
    ],
    "chimneys": [
        "chimney"
    ],
    "julians": [
        "julian"
    ],
    "unrests": [
        "unrest"
    ],
    "baked": [
        "bake"
    ],
    "baking": [
        "bake"
    ],
    "bakes": [
        "bake"
    ],
    "cements": [
        "cement"
    ],
    "cemented": [
        "cement"
    ],
    "cementing": [
        "cement"
    ],
    "consultancies": [
        "consultancy"
    ],
    "discarded": [
        "discard"
    ],
    "discarding": [
        "discard"
    ],
    "discards": [
        "discard"
    ],
    "lunchtimes": [
        "lunchtime"
    ],
    "courtyards": [
        "courtyard"
    ],
    "deering": [
        "deer"
    ],
    "deer": [
        "deer"
    ],
    "differentiations": [
        "differentiation"
    ],
    "doings": [
        "doing"
    ],
    "doomed": [
        "doom"
    ],
    "dooms": [
        "doom"
    ],
    "dooming": [
        "doom"
    ],
    "fascists": [
        "fascist"
    ],
    "legislatures": [
        "legislature"
    ],
    "kettles": [
        "kettle"
    ],
    "kettled": [
        "kettle"
    ],
    "consortia": [
        "consortium"
    ],
    "disrupted": [
        "disrupt"
    ],
    "disrupting": [
        "disrupt"
    ],
    "disrupts": [
        "disrupt"
    ],
    "fogs": [
        "fog"
    ],
    "fogged": [
        "fog"
    ],
    "fogging": [
        "fog"
    ],
    "fountains": [
        "fountain"
    ],
    "fountained": [
        "fountain"
    ],
    "fountaining": [
        "fountain"
    ],
    "matts": [
        "matt"
    ],
    "shuddered": [
        "shudder"
    ],
    "shuddering": [
        "shudder"
    ],
    "shudders": [
        "shudder"
    ],
    "sodiums": [
        "sodium"
    ],
    "tilted": [
        "tilt"
    ],
    "tilting": [
        "tilt"
    ],
    "dripping": [
        "drip"
    ],
    "dripped": [
        "drip"
    ],
    "drips": [
        "drip"
    ],
    "dript": [
        "drip"
    ],
    "highlands": [
        "highland"
    ],
    "slates": [
        "slate"
    ],
    "slated": [
        "slate"
    ],
    "slating": [
        "slate"
    ],
    "attackers": [
        "attacker"
    ],
    "therapists": [
        "therapist"
    ],
    "husseins": [
        "hussein"
    ],
    "warrens": [
        "warren"
    ],
    "clericals": [
        "clerical"
    ],
    "resented": [
        "resent"
    ],
    "resenting": [
        "resent"
    ],
    "resents": [
        "resent"
    ],
    "trenches": [
        "trench"
    ],
    "trenching": [
        "trench"
    ],
    "trenched": [
        "trench"
    ],
    "municipals": [
        "municipal"
    ],
    "digested": [
        "digest"
    ],
    "digesting": [
        "digest"
    ],
    "rigs": [
        "rig"
    ],
    "rigged": [
        "rig"
    ],
    "rigging": [
        "rig"
    ],
    "spirals": [
        "spiral"
    ],
    "spiralling": [
        "spiral"
    ],
    "spiralled": [
        "spiral"
    ],
    "congratulated": [
        "congratulate"
    ],
    "congratulating": [
        "congratulate"
    ],
    "congratulates": [
        "congratulate"
    ],
    "diplomas": [
        "diploma"
    ],
    "interacts": [
        "interact"
    ],
    "interacting": [
        "interact"
    ],
    "interacted": [
        "interact"
    ],
    "intercourses": [
        "intercourse"
    ],
    "novelists": [
        "novelist"
    ],
    "signings": [
        "signing"
    ],
    "paddies": [
        "paddy"
    ],
    "robberies": [
        "robbery"
    ],
    "armoured": [
        "armour"
    ],
    "armouring": [
        "armour"
    ],
    "armours": [
        "armour"
    ],
    "lovings": [
        "loving"
    ],
    "platelets": [
        "platelet"
    ],
    "transiting": [
        "transit"
    ],
    "transitted": [
        "transit"
    ],
    "transited": [
        "transit"
    ],
    "transitting": [
        "transit"
    ],
    "correlated": [
        "correlate"
    ],
    "correlates": [
        "correlate"
    ],
    "correlating": [
        "correlate"
    ],
    "saws": [
        "saw"
    ],
    "sawing": [
        "saw"
    ],
    "sawn": [
        "saw"
    ],
    "sawed": [
        "saw"
    ],
    "skeletons": [
        "skeleton"
    ],
    "alcoholics": [
        "alcoholic"
    ],
    "jollies": [
        "jolly"
    ],
    "jollier": [
        "jolly"
    ],
    "jolliest": [
        "jolly"
    ],
    "jollying": [
        "jolly"
    ],
    "jollied": [
        "jolly"
    ],
    "pistols": [
        "pistol"
    ],
    "shattered": [
        "shatter"
    ],
    "shattering": [
        "shatter"
    ],
    "shatters": [
        "shatter"
    ],
    "freezings": [
        "freezing"
    ],
    "groves": [
        "grove"
    ],
    "ivories": [
        "ivory"
    ],
    "maxims": [
        "maxim"
    ],
    "citizenships": [
        "citizenship"
    ],
    "distorted": [
        "distort"
    ],
    "distorting": [
        "distort"
    ],
    "distorts": [
        "distort"
    ],
    "geese": [
        "goose"
    ],
    "goosed": [
        "goose"
    ],
    "goosing": [
        "goose"
    ],
    "gooses": [
        "goose"
    ],
    "perched": [
        "perch"
    ],
    "perching": [
        "perch"
    ],
    "warranties": [
        "warranty"
    ],
    "armchairs": [
        "armchair"
    ],
    "cereals": [
        "cereal"
    ],
    "dependencies": [
        "dependency"
    ],
    "deprivations": [
        "deprivation"
    ],
    "velvets": [
        "velvet"
    ],
    "boycotted": [
        "boycott"
    ],
    "boycotting": [
        "boycott"
    ],
    "boycotts": [
        "boycott"
    ],
    "mobs": [
        "mob"
    ],
    "mobbed": [
        "mob"
    ],
    "mobbing": [
        "mob"
    ],
    "whitehalls": [
        "whitehall"
    ],
    "leos": [
        "leo"
    ],
    "senators": [
        "senator"
    ],
    "syrias": [
        "syria"
    ],
    "detained": [
        "detain"
    ],
    "detaining": [
        "detain"
    ],
    "detains": [
        "detain"
    ],
    "hospitalities": [
        "hospitality"
    ],
    "realisms": [
        "realism"
    ],
    "strayed": [
        "stray"
    ],
    "straying": [
        "stray"
    ],
    "strays": [
        "stray"
    ],
    "ukraines": [
        "ukraine"
    ],
    "amps": [
        "amp"
    ],
    "amping": [
        "amp"
    ],
    "conditionals": [
        "conditional"
    ],
    "markss": [
        "marks"
    ],
    "claws": [
        "claw"
    ],
    "clawed": [
        "claw"
    ],
    "clawing": [
        "claw"
    ],
    "diplomats": [
        "diplomat"
    ],
    "fixtures": [
        "fixture"
    ],
    "fixturing": [
        "fixture"
    ],
    "inks": [
        "ink"
    ],
    "inked": [
        "ink"
    ],
    "inking": [
        "ink"
    ],
    "matted": [
        "mat"
    ],
    "matting": [
        "mat"
    ],
    "nitrogens": [
        "nitrogen"
    ],
    "vouchers": [
        "voucher"
    ],
    "chanting": [
        "chant"
    ],
    "chanted": [
        "chant"
    ],
    "softened": [
        "soften"
    ],
    "softening": [
        "soften"
    ],
    "softens": [
        "soften"
    ],
    "unveiled": [
        "unveil"
    ],
    "unveiling": [
        "unveil"
    ],
    "unveils": [
        "unveil"
    ],
    "boilers": [
        "boiler"
    ],
    "boilered": [
        "boiler"
    ],
    "palestines": [
        "palestine"
    ],
    "pattens": [
        "patten"
    ],
    "physicians": [
        "physician"
    ],
    "sobbing": [
        "sob"
    ],
    "sobbed": [
        "sob"
    ],
    "sobs": [
        "sob"
    ],
    "syntactics": [
        "syntactic"
    ],
    "deterred": [
        "deter"
    ],
    "deterring": [
        "deter"
    ],
    "deters": [
        "deter"
    ],
    "witches": [
        "witch"
    ],
    "witching": [
        "witch"
    ],
    "witched": [
        "witch"
    ],
    "bleaker": [
        "bleak"
    ],
    "bleakest": [
        "bleak"
    ],
    "domed": [
        "dome"
    ],
    "hos": [
        "ho"
    ],
    "hoes": [
        "hoe",
        "ho"
    ],
    "hovering": [
        "hover"
    ],
    "hovered": [
        "hover"
    ],
    "hovers": [
        "hover"
    ],
    "motorists": [
        "motorist"
    ],
    "textbooks": [
        "textbook"
    ],
    "thailands": [
        "thailand"
    ],
    "binaries": [
        "binary"
    ],
    "lashes": [
        "lash"
    ],
    "lashed": [
        "lash"
    ],
    "lashing": [
        "lash"
    ],
    "sown": [
        "sow"
    ],
    "sows": [
        "sow"
    ],
    "sowing": [
        "sow"
    ],
    "sowed": [
        "sow"
    ],
    "subs": [
        "sub"
    ],
    "subbing": [
        "sub"
    ],
    "subbed": [
        "sub"
    ],
    "busts": [
        "bust"
    ],
    "busting": [
        "bust"
    ],
    "busted": [
        "bust"
    ],
    "buster": [
        "bust"
    ],
    "cocked": [
        "cock"
    ],
    "cocks": [
        "cock"
    ],
    "cocking": [
        "cock"
    ],
    "overviews": [
        "overview"
    ],
    "overviewing": [
        "overview"
    ],
    "overviewed": [
        "overview"
    ],
    "privatizations": [
        "privatization"
    ],
    "quests": [
        "quest"
    ],
    "questing": [
        "quest"
    ],
    "quested": [
        "quest"
    ],
    "belgians": [
        "belgian"
    ],
    "tombs": [
        "tomb"
    ],
    "danishes": [
        "danish"
    ],
    "detectors": [
        "detector"
    ],
    "footsteps": [
        "footstep"
    ],
    "wordings": [
        "wording"
    ],
    "kidneys": [
        "kidney"
    ],
    "serbians": [
        "serbian"
    ],
    "czechs": [
        "czech"
    ],
    "czeched": [
        "czech"
    ],
    "inferiors": [
        "inferior"
    ],
    "portsmouths": [
        "portsmouth"
    ],
    "acquaintances": [
        "acquaintance"
    ],
    "mints": [
        "mint"
    ],
    "minted": [
        "mint"
    ],
    "minting": [
        "mint"
    ],
    "simpsons": [
        "simpson"
    ],
    "hazels": [
        "hazel"
    ],
    "pipers": [
        "piper"
    ],
    "postcards": [
        "postcard"
    ],
    "arctics": [
        "arctic"
    ],
    "curbs": [
        "curb"
    ],
    "curbing": [
        "curb"
    ],
    "curbed": [
        "curb"
    ],
    "proprietors": [
        "proprietor"
    ],
    "holmess": [
        "holmes"
    ],
    "mortons": [
        "morton"
    ],
    "cues": [
        "cue"
    ],
    "cued": [
        "cue"
    ],
    "cueing": [
        "cue"
    ],
    "encompasses": [
        "encompass"
    ],
    "encompassing": [
        "encompass"
    ],
    "encompassed": [
        "encompass"
    ],
    "encompass": [
        "encompass"
    ],
    "hostels": [
        "hostel"
    ],
    "hostelling": [
        "hostel"
    ],
    "dreaded": [
        "dread"
    ],
    "dreading": [
        "dread"
    ],
    "dreads": [
        "dread"
    ],
    "bleedings": [
        "bleeding"
    ],
    "madrids": [
        "madrid"
    ],
    "crapping": [
        "crap"
    ],
    "crapped": [
        "crap"
    ],
    "crapper": [
        "crap"
    ],
    "dammed": [
        "dam"
    ],
    "damming": [
        "dam"
    ],
    "damed": [
        "dame"
    ],
    "manpowers": [
        "manpower"
    ],
    "spouses": [
        "spouse"
    ],
    "attendants": [
        "attendant"
    ],
    "cloaks": [
        "cloak"
    ],
    "cloaked": [
        "cloak"
    ],
    "cloaking": [
        "cloak"
    ],
    "overtaken": [
        "overtake"
    ],
    "overtook": [
        "overtake"
    ],
    "overtaking": [
        "overtake"
    ],
    "overtakes": [
        "overtake"
    ],
    "fishers": [
        "fisher"
    ],
    "instructors": [
        "instructor"
    ],
    "reliances": [
        "reliance"
    ],
    "denounced": [
        "denounce"
    ],
    "denouncing": [
        "denounce"
    ],
    "denounces": [
        "denounce"
    ],
    "honourables": [
        "honourable"
    ],
    "tailored": [
        "tailor"
    ],
    "tailors": [
        "tailor"
    ],
    "tailoring": [
        "tailore",
        "tailor"
    ],
    "assays": [
        "assay"
    ],
    "assayed": [
        "assay"
    ],
    "assaying": [
        "assay"
    ],
    "cellars": [
        "cellar"
    ],
    "denials": [
        "denial"
    ],
    "infected": [
        "infect"
    ],
    "infecting": [
        "infect"
    ],
    "missionaries": [
        "missionary"
    ],
    "profitabilities": [
        "profitability"
    ],
    "amsterdams": [
        "amsterdam"
    ],
    "ascertained": [
        "ascertain"
    ],
    "ascertaining": [
        "ascertain"
    ],
    "ascertains": [
        "ascertain"
    ],
    "proses": [
        "prose"
    ],
    "prosing": [
        "prose"
    ],
    "banners": [
        "banner"
    ],
    "bannered": [
        "banner"
    ],
    "indonesias": [
        "indonesia"
    ],
    "nils": [
        "nil"
    ],
    "syllables": [
        "syllable"
    ],
    "syllabled": [
        "syllable"
    ],
    "buds": [
        "bud"
    ],
    "budded": [
        "bud"
    ],
    "budding": [
        "bud"
    ],
    "coronations": [
        "coronation"
    ],
    "pedestrians": [
        "pedestrian"
    ],
    "robertsons": [
        "robertson"
    ],
    "voyaging": [
        "voyage"
    ],
    "voyaged": [
        "voyage"
    ],
    "floridas": [
        "florida"
    ],
    "diabetics": [
        "diabetic"
    ],
    "goalkeepers": [
        "goalkeeper"
    ],
    "carrots": [
        "carrot"
    ],
    "contended": [
        "contend"
    ],
    "contends": [
        "contend"
    ],
    "contending": [
        "contend"
    ],
    "gelling": [
        "gel"
    ],
    "gelled": [
        "gel"
    ],
    "humbled": [
        "humble"
    ],
    "humbling": [
        "humble"
    ],
    "humbler": [
        "humble"
    ],
    "humblest": [
        "humble"
    ],
    "verging": [
        "verge"
    ],
    "verged": [
        "verge"
    ],
    "denotes": [
        "denote"
    ],
    "denoted": [
        "denote"
    ],
    "denoting": [
        "denote"
    ],
    "caer": [
        "ca"
    ],
    "lps": [
        "lp"
    ],
    "urgencies": [
        "urgency"
    ],
    "buggers": [
        "bugger"
    ],
    "buggered": [
        "bugger"
    ],
    "buggering": [
        "bugger"
    ],
    "shrubs": [
        "shrub"
    ],
    "livestocks": [
        "livestock"
    ],
    "ethicss": [
        "ethics"
    ],
    "norwegians": [
        "norwegian"
    ],
    "rehabilitations": [
        "rehabilitation"
    ],
    "continuations": [
        "continuation"
    ],
    "exchequers": [
        "exchequer"
    ],
    "affinities": [
        "affinity"
    ],
    "groomed": [
        "groom"
    ],
    "grooming": [
        "groom"
    ],
    "libelled": [
        "libel"
    ],
    "libels": [
        "libel"
    ],
    "libelling": [
        "libel"
    ],
    "entitlements": [
        "entitlement"
    ],
    "hens": [
        "hen"
    ],
    "nominals": [
        "nominal"
    ],
    "palmers": [
        "palmer"
    ],
    "vested": [
        "vest"
    ],
    "vests": [
        "vest"
    ],
    "vesting": [
        "vest"
    ],
    "airways": [
        "airway"
    ],
    "craftsmen": [
        "craftsman"
    ],
    "fuming": [
        "fume"
    ],
    "fumed": [
        "fume"
    ],
    "hurdles": [
        "hurdle"
    ],
    "hurdling": [
        "hurdle"
    ],
    "hurdled": [
        "hurdle"
    ],
    "wordsworths": [
        "wordsworth"
    ],
    "distracted": [
        "distract"
    ],
    "distracting": [
        "distract"
    ],
    "distracts": [
        "distract"
    ],
    "georgians": [
        "georgian"
    ],
    "expelled": [
        "expel"
    ],
    "expelling": [
        "expel"
    ],
    "expels": [
        "expel"
    ],
    "anglias": [
        "anglia"
    ],
    "complementaries": [
        "complementary"
    ],
    "conductors": [
        "conductor"
    ],
    "harnessed": [
        "harness"
    ],
    "harnesses": [
        "harness"
    ],
    "harnessing": [
        "harness"
    ],
    "consolidated": [
        "consolidate"
    ],
    "consolidating": [
        "consolidate"
    ],
    "consolidates": [
        "consolidate"
    ],
    "midfields": [
        "midfield"
    ],
    "optimisms": [
        "optimism"
    ],
    "braced": [
        "brace"
    ],
    "braces": [
        "brace"
    ],
    "bracing": [
        "brace"
    ],
    "hastingss": [
        "hastings"
    ],
    "rags": [
        "rag"
    ],
    "ragged": [
        "rag"
    ],
    "ragging": [
        "rag"
    ],
    "signified": [
        "signify"
    ],
    "signifies": [
        "signify"
    ],
    "signifying": [
        "signify"
    ],
    "manifestos": [
        "manifesto"
    ],
    "manifestoes": [
        "manifesto"
    ],
    "reverted": [
        "revert"
    ],
    "reverting": [
        "revert"
    ],
    "reverts": [
        "revert"
    ],
    "slabs": [
        "slab"
    ],
    "slabbed": [
        "slab"
    ],
    "spreadsheets": [
        "spreadsheet"
    ],
    "spreadsheeting": [
        "spreadsheet"
    ],
    "ached": [
        "ache"
    ],
    "aching": [
        "ache"
    ],
    "deadliest": [
        "deadly"
    ],
    "deadlier": [
        "deadly"
    ],
    "dentists": [
        "dentist"
    ],
    "hardships": [
        "hardship"
    ],
    "litigations": [
        "litigation"
    ],
    "complimented": [
        "compliment"
    ],
    "complimenting": [
        "compliment"
    ],
    "syllabuses": [
        "syllabus"
    ],
    "syllabi": [
        "syllabus"
    ],
    "demonstrators": [
        "demonstrator"
    ],
    "disregarded": [
        "disregard"
    ],
    "disregarding": [
        "disregard"
    ],
    "disregards": [
        "disregard"
    ],
    "basements": [
        "basement"
    ],
    "corrupted": [
        "corrupt"
    ],
    "corrupting": [
        "corrupt"
    ],
    "corrupts": [
        "corrupt"
    ],
    "corrupter": [
        "corrupt"
    ],
    "pissed": [
        "piss"
    ],
    "pissing": [
        "piss"
    ],
    "solitaries": [
        "solitary"
    ],
    "tripled": [
        "triple"
    ],
    "tripling": [
        "triple"
    ],
    "underestimated": [
        "underestimate"
    ],
    "underestimates": [
        "underestimate"
    ],
    "underestimating": [
        "underestimate"
    ],
    "sulphurs": [
        "sulphur"
    ],
    "scouting": [
        "scout"
    ],
    "scouted": [
        "scout"
    ],
    "slaughtered": [
        "slaughter"
    ],
    "slaughtering": [
        "slaughter"
    ],
    "slaughters": [
        "slaughter"
    ],
    "staggered": [
        "stagger"
    ],
    "staggering": [
        "stagger"
    ],
    "staggers": [
        "stagger"
    ],
    "badged": [
        "badge"
    ],
    "badging": [
        "badge"
    ],
    "colonics": [
        "colonic"
    ],
    "homeworking": [
        "homework"
    ],
    "homeworks": [
        "homework"
    ],
    "homework": [
        "homework"
    ],
    "retentions": [
        "retention"
    ],
    "bryans": [
        "bryan"
    ],
    "tellies": [
        "telly"
    ],
    "tellys": [
        "telly"
    ],
    "waxes": [
        "wax"
    ],
    "waxed": [
        "wax"
    ],
    "waxing": [
        "wax"
    ],
    "authentics": [
        "authentic"
    ],
    "bruises": [
        "bruise"
    ],
    "bruised": [
        "bruise"
    ],
    "bruising": [
        "bruise"
    ],
    "dispersed": [
        "disperse"
    ],
    "dispersing": [
        "disperse"
    ],
    "civilizations": [
        "civilization"
    ],
    "defied": [
        "defy"
    ],
    "defying": [
        "defy"
    ],
    "laziest": [
        "lazy"
    ],
    "lazier": [
        "lazy"
    ],
    "rexes": [
        "rex"
    ],
    "copped": [
        "cop"
    ],
    "copping": [
        "cop"
    ],
    "stickiest": [
        "sticky"
    ],
    "stickier": [
        "sticky"
    ],
    "stickies": [
        "sticky"
    ],
    "stickied": [
        "sticky"
    ],
    "cannons": [
        "cannon"
    ],
    "cannoned": [
        "cannon"
    ],
    "cannoning": [
        "cannon"
    ],
    "invalids": [
        "invalid"
    ],
    "massaged": [
        "massage"
    ],
    "massaging": [
        "massage"
    ],
    "nephews": [
        "nephew"
    ],
    "reformers": [
        "reformer"
    ],
    "pests": [
        "pest"
    ],
    "accountancies": [
        "accountancy"
    ],
    "compartments": [
        "compartment"
    ],
    "compartmented": [
        "compartment"
    ],
    "marshalled": [
        "marshal"
    ],
    "marshalling": [
        "marshal"
    ],
    "prs": [
        "pr"
    ],
    "prest": [
        "pr"
    ],
    "pring": [
        "pr"
    ],
    "vainest": [
        "vain"
    ],
    "vainer": [
        "vain"
    ],
    "creativities": [
        "creativity"
    ],
    "divisionals": [
        "divisional"
    ],
    "hangings": [
        "hanging"
    ],
    "jewels": [
        "jewel"
    ],
    "jewelled": [
        "jewel"
    ],
    "jewelling": [
        "jewel"
    ],
    "wilkinsons": [
        "wilkinson"
    ],
    "residuals": [
        "residual"
    ],
    "bleeding": [
        "bleed"
    ],
    "bleeds": [
        "bleed"
    ],
    "burtons": [
        "burton"
    ],
    "latelier": [
        "lately"
    ],
    "microsystems": [
        "microsystem"
    ],
    "moslems": [
        "moslem"
    ],
    "riscs": [
        "risc"
    ],
    "firemen": [
        "fireman"
    ],
    "firemans": [
        "fireman"
    ],
    "hopefuls": [
        "hopeful"
    ],
    "squashed": [
        "squash"
    ],
    "squashing": [
        "squash"
    ],
    "squashes": [
        "squash"
    ],
    "symmetries": [
        "symmetry"
    ],
    "symmetrys": [
        "symmetry"
    ],
    "bostons": [
        "boston"
    ],
    "croatias": [
        "croatia"
    ],
    "lightnings": [
        "lightning"
    ],
    "postgraduates": [
        "postgraduate"
    ],
    "climbers": [
        "climber"
    ],
    "coils": [
        "coil"
    ],
    "coiled": [
        "coil"
    ],
    "coiling": [
        "coil"
    ],
    "imprisoned": [
        "imprison"
    ],
    "imprisoning": [
        "imprison"
    ],
    "imprisons": [
        "imprison"
    ],
    "mediated": [
        "mediate"
    ],
    "mediating": [
        "mediate"
    ],
    "mediates": [
        "mediate"
    ],
    "sanctuaries": [
        "sanctuary"
    ],
    "joest": [
        "jo"
    ],
    "multinationals": [
        "multinational"
    ],
    "shortss": [
        "shorts"
    ],
    "thomsons": [
        "thomson"
    ],
    "bucks": [
        "buck"
    ],
    "bucked": [
        "buck"
    ],
    "bucking": [
        "buck"
    ],
    "shoved": [
        "shove"
    ],
    "shoving": [
        "shove"
    ],
    "shoves": [
        "shove"
    ],
    "armstrongs": [
        "armstrong"
    ],
    "austrians": [
        "austrian"
    ],
    "enclosures": [
        "enclosure"
    ],
    "insistences": [
        "insistence"
    ],
    "headers": [
        "header"
    ],
    "summonses": [
        "summons"
    ],
    "summonsing": [
        "summons"
    ],
    "summonsed": [
        "summons"
    ],
    "alecs": [
        "alec"
    ],
    "beads": [
        "bead"
    ],
    "beaded": [
        "bead"
    ],
    "beading": [
        "bead"
    ],
    "onsets": [
        "onset"
    ],
    "chamberlains": [
        "chamberlain"
    ],
    "despatched": [
        "despatch"
    ],
    "despatches": [
        "despatch"
    ],
    "despatching": [
        "despatch"
    ],
    "shippings": [
        "shipping"
    ],
    "ampler": [
        "ample"
    ],
    "romanians": [
        "romanian"
    ],
    "vining": [
        "vine"
    ],
    "bennetts": [
        "bennett"
    ],
    "goodwills": [
        "goodwill"
    ],
    "inferences": [
        "inference"
    ],
    "inferencing": [
        "inference"
    ],
    "intensified": [
        "intensify"
    ],
    "intensifying": [
        "intensify"
    ],
    "intensifies": [
        "intensify"
    ],
    "squatted": [
        "squat"
    ],
    "squatting": [
        "squat"
    ],
    "abnormals": [
        "abnormal"
    ],
    "newsletters": [
        "newsletter"
    ],
    "scrubbed": [
        "scrub"
    ],
    "scrubbing": [
        "scrub"
    ],
    "sloganned": [
        "slogan"
    ],
    "barristers": [
        "barrister"
    ],
    "culminating": [
        "culminate"
    ],
    "culminated": [
        "culminate"
    ],
    "culminates": [
        "culminate"
    ],
    "cultivated": [
        "cultivate"
    ],
    "cultivating": [
        "cultivate"
    ],
    "cultivates": [
        "cultivate"
    ],
    "discriminated": [
        "discriminate"
    ],
    "discriminating": [
        "discriminate"
    ],
    "discriminates": [
        "discriminate"
    ],
    "mankinds": [
        "mankind"
    ],
    "taiwans": [
        "taiwan"
    ],
    "destinies": [
        "destiny"
    ],
    "palling": [
        "pall",
        "pal"
    ],
    "palled": [
        "pall",
        "pal"
    ],
    "waynes": [
        "wayne"
    ],
    "advents": [
        "advent"
    ],
    "crohns": [
        "crohn"
    ],
    "grapes": [
        "grape"
    ],
    "salisburies": [
        "salisbury"
    ],
    "technicians": [
        "technician"
    ],
    "utilised": [
        "utilise"
    ],
    "utilising": [
        "utilise"
    ],
    "fused": [
        "fuse"
    ],
    "fuses": [
        "fuse"
    ],
    "fusing": [
        "fuse"
    ],
    "potters": [
        "potter"
    ],
    "pottering": [
        "potter"
    ],
    "pottered": [
        "potter"
    ],
    "steerings": [
        "steering"
    ],
    "stockings": [
        "stocking"
    ],
    "basils": [
        "basil"
    ],
    "kins": [
        "kin"
    ],
    "lesioned": [
        "lesion"
    ],
    "lesioning": [
        "lesion"
    ],
    "qualifyings": [
        "qualifying"
    ],
    "reliabilities": [
        "reliability"
    ],
    "smacked": [
        "smack"
    ],
    "smacking": [
        "smack"
    ],
    "berries": [
        "berry"
    ],
    "berried": [
        "berry"
    ],
    "ploes": [
        "plo"
    ],
    "seamen": [
        "seaman"
    ],
    "seamans": [
        "seaman"
    ],
    "spurred": [
        "spur"
    ],
    "spurring": [
        "spur"
    ],
    "spurs": [
        "spur"
    ],
    "illuminated": [
        "illuminate"
    ],
    "illuminating": [
        "illuminate"
    ],
    "illuminates": [
        "illuminate"
    ],
    "speculated": [
        "speculate"
    ],
    "speculating": [
        "speculate"
    ],
    "speculates": [
        "speculate"
    ],
    "warier": [
        "wary"
    ],
    "wariest": [
        "wary"
    ],
    "veterinaries": [
        "veterinary"
    ],
    "picassoes": [
        "picasso"
    ],
    "revs": [
        "rev"
    ],
    "revved": [
        "rev"
    ],
    "revving": [
        "rev"
    ],
    "vacancies": [
        "vacancy"
    ],
    "vietnameses": [
        "vietnamese"
    ],
    "athenss": [
        "athens"
    ],
    "climbings": [
        "climbing"
    ],
    "excised": [
        "excise"
    ],
    "excising": [
        "excise"
    ],
    "excises": [
        "excise"
    ],
    "northumberlands": [
        "northumberland"
    ],
    "poised": [
        "poise"
    ],
    "poising": [
        "poise"
    ],
    "poises": [
        "poise"
    ],
    "adhered": [
        "adhere"
    ],
    "adhering": [
        "adhere"
    ],
    "adheres": [
        "adhere"
    ],
    "adhereing": [
        "adhere"
    ],
    "borrowers": [
        "borrower"
    ],
    "tanned": [
        "tan"
    ],
    "tanning": [
        "tan"
    ],
    "thicknesses": [
        "thickness"
    ],
    "thicknessing": [
        "thickness"
    ],
    "baits": [
        "bait"
    ],
    "baiting": [
        "bait"
    ],
    "baited": [
        "bait"
    ],
    "blushed": [
        "blush"
    ],
    "blushing": [
        "blush"
    ],
    "blushes": [
        "blush"
    ],
    "bullied": [
        "bully"
    ],
    "bullying": [
        "bully"
    ],
    "bullies": [
        "bully"
    ],
    "garlics": [
        "garlic"
    ],
    "retorted": [
        "retort"
    ],
    "retorts": [
        "retort"
    ],
    "retorting": [
        "retort"
    ],
    "shaved": [
        "shave"
    ],
    "shaving": [
        "shave"
    ],
    "shaves": [
        "shave"
    ],
    "shaven": [
        "shave"
    ],
    "thrived": [
        "thrive"
    ],
    "thriving": [
        "thrive"
    ],
    "thrives": [
        "thrive"
    ],
    "throve": [
        "thrive"
    ],
    "thriven": [
        "thrive"
    ],
    "plantings": [
        "planting"
    ],
    "stripes": [
        "stripe"
    ],
    "striped": [
        "stripe"
    ],
    "striping": [
        "stripe"
    ],
    "algorithms": [
        "algorithm"
    ],
    "audios": [
        "audio"
    ],
    "cruelties": [
        "cruelty"
    ],
    "farewells": [
        "farewell"
    ],
    "plymouths": [
        "plymouth"
    ],
    "slashed": [
        "slash"
    ],
    "slashing": [
        "slash"
    ],
    "slashes": [
        "slash"
    ],
    "deteriorated": [
        "deteriorate"
    ],
    "deteriorates": [
        "deteriorate"
    ],
    "deteriorating": [
        "deteriorate"
    ],
    "insurers": [
        "insurer"
    ],
    "reefs": [
        "reef"
    ],
    "reefing": [
        "reef"
    ],
    "reefed": [
        "reef"
    ],
    "teddies": [
        "teddy"
    ],
    "teddys": [
        "teddy"
    ],
    "cultivations": [
        "cultivation"
    ],
    "linguisticss": [
        "linguistics"
    ],
    "tweeded": [
        "tweed"
    ],
    "enlarged": [
        "enlarge"
    ],
    "enlarging": [
        "enlarge"
    ],
    "enlarges": [
        "enlarge"
    ],
    "pathways": [
        "pathway"
    ],
    "streaked": [
        "streak"
    ],
    "streaks": [
        "streak"
    ],
    "streaking": [
        "streak"
    ],
    "bankrupted": [
        "bankrupt"
    ],
    "bankrupts": [
        "bankrupt"
    ],
    "bankrupting": [
        "bankrupt"
    ],
    "brewers": [
        "brewer"
    ],
    "guitarists": [
        "guitarist"
    ],
    "pettier": [
        "petty"
    ],
    "pettys": [
        "petty"
    ],
    "pettiest": [
        "petty"
    ],
    "racists": [
        "racist"
    ],
    "sterns": [
        "stern"
    ],
    "sterner": [
        "stern",
        "sterne"
    ],
    "sternest": [
        "stern",
        "sterne"
    ],
    "acoustics": [
        "acoustic"
    ],
    "amenities": [
        "amenity"
    ],
    "blurred": [
        "blur"
    ],
    "blurring": [
        "blur"
    ],
    "blurs": [
        "blur"
    ],
    "britons": [
        "briton"
    ],
    "circuses": [
        "circus"
    ],
    "bookshops": [
        "bookshop"
    ],
    "bugged": [
        "bug"
    ],
    "bugging": [
        "bug"
    ],
    "dyes": [
        "dye"
    ],
    "dyed": [
        "dye"
    ],
    "dyeing": [
        "dye"
    ],
    "hybrids": [
        "hybrid"
    ],
    "bilaterals": [
        "bilateral"
    ],
    "synthetics": [
        "synthetic"
    ],
    "wheelchairs": [
        "wheelchair"
    ],
    "convoys": [
        "convoy"
    ],
    "convoying": [
        "convoy"
    ],
    "fireplaces": [
        "fireplace"
    ],
    "madnesses": [
        "madness"
    ],
    "deceaseds": [
        "deceased"
    ],
    "heaters": [
        "heater"
    ],
    "peas": [
        "pea"
    ],
    "airfields": [
        "airfield"
    ],
    "campaigners": [
        "campaigner"
    ],
    "frenchmen": [
        "frenchman"
    ],
    "madams": [
        "madam"
    ],
    "p.c.s": [
        "p.c."
    ],
    "trinities": [
        "trinity"
    ],
    "uxes": [
        "ux"
    ],
    "wedged": [
        "wedge"
    ],
    "wedges": [
        "wedge"
    ],
    "wedging": [
        "wedge"
    ],
    "fakes": [
        "fake"
    ],
    "faked": [
        "fake"
    ],
    "faking": [
        "fake"
    ],
    "lendings": [
        "lending"
    ],
    "ridings": [
        "riding"
    ],
    "scarcer": [
        "scarce"
    ],
    "scarcest": [
        "scarce"
    ],
    "adverts": [
        "advert"
    ],
    "adverted": [
        "advert"
    ],
    "adverting": [
        "advert"
    ],
    "aerospaces": [
        "aerospace"
    ],
    "alleys": [
        "alley"
    ],
    "daisies": [
        "daisy"
    ],
    "gleamed": [
        "gleam"
    ],
    "gleaming": [
        "gleam"
    ],
    "gleams": [
        "gleam"
    ],
    "havens": [
        "haven"
    ],
    "spikes": [
        "spike"
    ],
    "spiked": [
        "spike"
    ],
    "spiking": [
        "spike"
    ],
    "stalks": [
        "stalk"
    ],
    "stalked": [
        "stalk"
    ],
    "stalking": [
        "stalk"
    ],
    "yugoslavs": [
        "yugoslav"
    ],
    "swamped": [
        "swamp"
    ],
    "swamps": [
        "swamp"
    ],
    "swamping": [
        "swamp"
    ],
    "ords": [
        "ord"
    ],
    "sewages": [
        "sewage"
    ],
    "tolerances": [
        "tolerance"
    ],
    "andrewss": [
        "andrews"
    ],
    "ceasefires": [
        "ceasefire"
    ],
    "perus": [
        "peru"
    ],
    "poetics": [
        "poetic"
    ],
    "fredericks": [
        "frederick"
    ],
    "scotched": [
        "scotch"
    ],
    "scotching": [
        "scotch"
    ],
    "testimonies": [
        "testimony"
    ],
    "tramming": [
        "tram"
    ],
    "trammed": [
        "tram"
    ],
    "coleridges": [
        "coleridge"
    ],
    "foreseen": [
        "foresee"
    ],
    "foresaw": [
        "foresee"
    ],
    "foresees": [
        "foresee"
    ],
    "foreseeing": [
        "foresee"
    ],
    "shuffled": [
        "shuffle"
    ],
    "shuffling": [
        "shuffle"
    ],
    "shuffles": [
        "shuffle"
    ],
    "combed": [
        "comb"
    ],
    "combs": [
        "comb"
    ],
    "combing": [
        "comb"
    ],
    "destined": [
        "destine"
    ],
    "destining": [
        "destine"
    ],
    "saids": [
        "said"
    ],
    "tenancies": [
        "tenancy"
    ],
    "greetings": [
        "greeting"
    ],
    "sadnesses": [
        "sadness"
    ],
    "allegiances": [
        "allegiance"
    ],
    "georgias": [
        "georgia"
    ],
    "invoices": [
        "invoice"
    ],
    "invoiced": [
        "invoice"
    ],
    "invoicing": [
        "invoice"
    ],
    "amys": [
        "amy"
    ],
    "warfares": [
        "warfare"
    ],
    "dispensed": [
        "dispense"
    ],
    "dispensing": [
        "dispense"
    ],
    "dissolutions": [
        "dissolution"
    ],
    "heaved": [
        "heave"
    ],
    "heaving": [
        "heave"
    ],
    "heaves": [
        "heave"
    ],
    "hove": [
        "heave"
    ],
    "overthrown": [
        "overthrow"
    ],
    "overthrowing": [
        "overthrow"
    ],
    "overthrows": [
        "overthrow"
    ],
    "overthrew": [
        "overthrow"
    ],
    "relished": [
        "relish"
    ],
    "relishing": [
        "relish"
    ],
    "relishes": [
        "relish"
    ],
    "clamped": [
        "clamp"
    ],
    "clamping": [
        "clamp"
    ],
    "demographics": [
        "demographic"
    ],
    "outings": [
        "outing"
    ],
    "poked": [
        "poke"
    ],
    "poking": [
        "poke"
    ],
    "pokes": [
        "poke"
    ],
    "recyclings": [
        "recycling"
    ],
    "erupted": [
        "erupt"
    ],
    "erupting": [
        "erupt"
    ],
    "erupts": [
        "erupt"
    ],
    "irregulars": [
        "irregular"
    ],
    "fascinated": [
        "fascinate"
    ],
    "fascinates": [
        "fascinate"
    ],
    "fascinating": [
        "fascinate"
    ],
    "beloveds": [
        "beloved"
    ],
    "dialled": [
        "dial"
    ],
    "dials": [
        "dial"
    ],
    "dialed": [
        "dial"
    ],
    "dialing": [
        "dial"
    ],
    "dialling": [
        "dial"
    ],
    "dinosaurs": [
        "dinosaur"
    ],
    "breakthroughs": [
        "breakthrough"
    ],
    "picnics": [
        "picnic"
    ],
    "picnicking": [
        "picnic"
    ],
    "picnicked": [
        "picnic"
    ],
    "barcelonas": [
        "barcelona"
    ],
    "indemnities": [
        "indemnity"
    ],
    "obliged": [
        "oblige"
    ],
    "obliging": [
        "oblige"
    ],
    "prohibitions": [
        "prohibition"
    ],
    "superiorities": [
        "superiority"
    ],
    "aerials": [
        "aerial"
    ],
    "crusts": [
        "crust"
    ],
    "crusted": [
        "crust"
    ],
    "crusting": [
        "crust"
    ],
    "modellings": [
        "modelling"
    ],
    "playgrounds": [
        "playground"
    ],
    "registrars": [
        "registrar"
    ],
    "reined": [
        "rein"
    ],
    "reining": [
        "rein"
    ],
    "farmhouses": [
        "farmhouse"
    ],
    "infinitives": [
        "infinitive"
    ],
    "rollered": [
        "roller"
    ],
    "rollering": [
        "roller"
    ],
    "cyclists": [
        "cyclist"
    ],
    "limped": [
        "limp"
    ],
    "limping": [
        "limp"
    ],
    "limps": [
        "limp"
    ],
    "limpest": [
        "limp"
    ],
    "limper": [
        "limp"
    ],
    "transplanted": [
        "transplant"
    ],
    "transplanting": [
        "transplant"
    ],
    "worcesters": [
        "worcester"
    ],
    "accessories": [
        "accessory"
    ],
    "committeds": [
        "committed"
    ],
    "ales": [
        "ale"
    ],
    "aled": [
        "ale"
    ],
    "chuckled": [
        "chuckle"
    ],
    "chuckling": [
        "chuckle"
    ],
    "chuckles": [
        "chuckle"
    ],
    "playings": [
        "playing"
    ],
    "presided": [
        "preside"
    ],
    "presiding": [
        "preside"
    ],
    "sceneries": [
        "scenery"
    ],
    "stoves": [
        "stove"
    ],
    "stoved": [
        "stove"
    ],
    "defectives": [
        "defective"
    ],
    "grooves": [
        "groove"
    ],
    "grooved": [
        "groove"
    ],
    "grooving": [
        "groove"
    ],
    "icings": [
        "icing"
    ],
    "resemblances": [
        "resemblance"
    ],
    "crawfords": [
        "crawford"
    ],
    "hounds": [
        "hound"
    ],
    "hounded": [
        "hound"
    ],
    "hounding": [
        "hound"
    ],
    "submarines": [
        "submarine"
    ],
    "jealousies": [
        "jealousy"
    ],
    "nigerias": [
        "nigeria"
    ],
    "cubas": [
        "cuba"
    ],
    "robed": [
        "robe"
    ],
    "robing": [
        "robe"
    ],
    "cartooned": [
        "cartoon"
    ],
    "cartooning": [
        "cartoon"
    ],
    "enacted": [
        "enact"
    ],
    "enacting": [
        "enact"
    ],
    "enacts": [
        "enact"
    ],
    "spred": [
        "spr"
    ],
    "thermals": [
        "thermal"
    ],
    "thermalling": [
        "thermal"
    ],
    "mandated": [
        "mandate"
    ],
    "mandating": [
        "mandate"
    ],
    "pastorals": [
        "pastoral"
    ],
    "problematics": [
        "problematic"
    ],
    "resided": [
        "reside"
    ],
    "residing": [
        "reside"
    ],
    "sewn": [
        "sew"
    ],
    "sewing": [
        "sew"
    ],
    "sewed": [
        "sew"
    ],
    "sews": [
        "sew"
    ],
    "soured": [
        "sour"
    ],
    "souring": [
        "sour"
    ],
    "sours": [
        "sour"
    ],
    "sourer": [
        "sour"
    ],
    "sourest": [
        "sour"
    ],
    "warmings": [
        "warming"
    ],
    "watercolours": [
        "watercolour"
    ],
    "rosemaries": [
        "rosemary"
    ],
    "rotted": [
        "rot"
    ],
    "rotting": [
        "rot"
    ],
    "fractured": [
        "fracture"
    ],
    "fracturing": [
        "fracture"
    ],
    "generators": [
        "generator"
    ],
    "inferred": [
        "infer"
    ],
    "inferring": [
        "infer"
    ],
    "infers": [
        "infer"
    ],
    "lapsed": [
        "lapse"
    ],
    "lapses": [
        "lapse"
    ],
    "lapsing": [
        "lapse"
    ],
    "mollies": [
        "molly"
    ],
    "mollied": [
        "molly"
    ],
    "vintages": [
        "vintage"
    ],
    "cholesterols": [
        "cholesterol"
    ],
    "cloning": [
        "clon",
        "clone"
    ],
    "cloned": [
        "clon",
        "clone"
    ],
    "diarrhoeas": [
        "diarrhoea"
    ],
    "gateways": [
        "gateway"
    ],
    "proliferations": [
        "proliferation"
    ],
    "scorings": [
        "scoring"
    ],
    "admirals": [
        "admiral"
    ],
    "arbitrations": [
        "arbitration"
    ],
    "antibiotics": [
        "antibiotic"
    ],
    "dispatched": [
        "dispatch"
    ],
    "dispatches": [
        "dispatch"
    ],
    "goodnights": [
        "goodnight"
    ],
    "idling": [
        "idle"
    ],
    "idled": [
        "idle"
    ],
    "idles": [
        "idle"
    ],
    "rotating": [
        "rotate"
    ],
    "rotated": [
        "rotate"
    ],
    "rotates": [
        "rotate"
    ],
    "conditionings": [
        "conditioning"
    ],
    "doorsteps": [
        "doorstep"
    ],
    "doorstepping": [
        "doorstep"
    ],
    "loyalists": [
        "loyalist"
    ],
    "snacking": [
        "snack"
    ],
    "snacked": [
        "snack"
    ],
    "wesleys": [
        "wesley"
    ],
    "alternating": [
        "alternate"
    ],
    "alternated": [
        "alternate"
    ],
    "alternates": [
        "alternate"
    ],
    "anchors": [
        "anchor"
    ],
    "anchoring": [
        "anchor"
    ],
    "anchored": [
        "anchore",
        "anchor"
    ],
    "expired": [
        "expire"
    ],
    "expiring": [
        "expire"
    ],
    "spices": [
        "spice"
    ],
    "spiced": [
        "spice"
    ],
    "spicing": [
        "spice"
    ],
    "booths": [
        "booth"
    ],
    "conquests": [
        "conquest"
    ],
    "couched": [
        "couch"
    ],
    "couching": [
        "couch"
    ],
    "curtiss": [
        "curtis"
    ],
    "overwhelmed": [
        "overwhelm"
    ],
    "overwhelms": [
        "overwhelm"
    ],
    "overwhelming": [
        "overwhelm"
    ],
    "towed": [
        "tow"
    ],
    "towing": [
        "tow"
    ],
    "tows": [
        "tow"
    ],
    "suitcases": [
        "suitcase"
    ],
    "summarized": [
        "summarize"
    ],
    "summarizes": [
        "summarize"
    ],
    "summarizing": [
        "summarize"
    ],
    "beginners": [
        "beginner"
    ],
    "undone": [
        "undo"
    ],
    "undid": [
        "undo"
    ],
    "undoing": [
        "undo"
    ],
    "undoes": [
        "undo"
    ],
    "zambias": [
        "zambia"
    ],
    "acs": [
        "ac"
    ],
    "burglaries": [
        "burglary"
    ],
    "dumbing": [
        "dumb"
    ],
    "dumbest": [
        "dumb"
    ],
    "dumbed": [
        "dumb"
    ],
    "dumber": [
        "dumb"
    ],
    "inhabited": [
        "inhabit"
    ],
    "inhabiting": [
        "inhabit"
    ],
    "inhabits": [
        "inhabit"
    ],
    "markings": [
        "marking"
    ],
    "microwaves": [
        "microwave"
    ],
    "microwaved": [
        "microwave"
    ],
    "microwaving": [
        "microwave"
    ],
    "accidentals": [
        "accidental"
    ],
    "climaxes": [
        "climax"
    ],
    "climaxed": [
        "climax"
    ],
    "climaxing": [
        "climax"
    ],
    "elves": [
        "elf"
    ],
    "elfed": [
        "elf"
    ],
    "foams": [
        "foam"
    ],
    "foaming": [
        "foam"
    ],
    "foamed": [
        "foam"
    ],
    "lavatories": [
        "lavatory"
    ],
    "misunderstandings": [
        "misunderstanding"
    ],
    "philippiness": [
        "philippines"
    ],
    "tacked": [
        "tack"
    ],
    "tacks": [
        "tack"
    ],
    "tacking": [
        "tack"
    ],
    "transitionals": [
        "transitional"
    ],
    "wholesaling": [
        "wholesale"
    ],
    "wholesales": [
        "wholesale"
    ],
    "wholesaled": [
        "wholesale"
    ],
    "disgusted": [
        "disgust"
    ],
    "disgusts": [
        "disgust"
    ],
    "disgusting": [
        "disgust"
    ],
    "microcomputers": [
        "microcomputer"
    ],
    "procedurals": [
        "procedural"
    ],
    "relayed": [
        "relay"
    ],
    "relays": [
        "relay"
    ],
    "relaying": [
        "relay"
    ],
    "relaid": [
        "relay"
    ],
    "severities": [
        "severity"
    ],
    "attorneys": [
        "attorney"
    ],
    "fiddling": [
        "fiddle"
    ],
    "fiddled": [
        "fiddle"
    ],
    "fiddles": [
        "fiddle"
    ],
    "tenures": [
        "tenure"
    ],
    "tenured": [
        "tenure"
    ],
    "timothies": [
        "timothy"
    ],
    "actings": [
        "acting"
    ],
    "artilleries": [
        "artillery"
    ],
    "construed": [
        "construe"
    ],
    "construing": [
        "construe"
    ],
    "construes": [
        "construe"
    ],
    "dialects": [
        "dialect"
    ],
    "outrights": [
        "outright"
    ],
    "postals": [
        "postal"
    ],
    "reeling": [
        "reel"
    ],
    "reeled": [
        "reel"
    ],
    "sociologists": [
        "sociologist"
    ],
    "abnormalities": [
        "abnormality"
    ],
    "brooked": [
        "brook"
    ],
    "brooking": [
        "brook"
    ],
    "ceramics": [
        "ceramic"
    ],
    "discomforts": [
        "discomfort"
    ],
    "discomforted": [
        "discomfort"
    ],
    "discomforting": [
        "discomfort"
    ],
    "fifteenths": [
        "fifteenth"
    ],
    "marxisms": [
        "marxism"
    ],
    "mexicans": [
        "mexican"
    ],
    "mipss": [
        "mips"
    ],
    "raisings": [
        "raising"
    ],
    "vaults": [
        "vault"
    ],
    "vaulted": [
        "vault"
    ],
    "vaulting": [
        "vault"
    ],
    "imaginaries": [
        "imaginary"
    ],
    "weavers": [
        "weaver"
    ],
    "approximated": [
        "approximate"
    ],
    "approximating": [
        "approximate"
    ],
    "approximates": [
        "approximate"
    ],
    "demised": [
        "demise"
    ],
    "nobilities": [
        "nobility"
    ],
    "brutals": [
        "brutal"
    ],
    "claimants": [
        "claimant"
    ],
    "estuaries": [
        "estuary"
    ],
    "grunted": [
        "grunt"
    ],
    "grunts": [
        "grunt"
    ],
    "grunting": [
        "grunt"
    ],
    "hillsides": [
        "hillside"
    ],
    "identifiers": [
        "identifier"
    ],
    "jumpers": [
        "jumper"
    ],
    "liming": [
        "lime"
    ],
    "limed": [
        "lime"
    ],
    "slendering": [
        "slender"
    ],
    "downings": [
        "downing"
    ],
    "vetoed": [
        "veto"
    ],
    "vetoing": [
        "veto"
    ],
    "vetoes": [
        "veto"
    ],
    "financings": [
        "financing"
    ],
    "prostitutes": [
        "prostitute"
    ],
    "prostituted": [
        "prostitute"
    ],
    "prostituting": [
        "prostitute"
    ],
    "smokers": [
        "smoker"
    ],
    "legitimacies": [
        "legitimacy"
    ],
    "maximising": [
        "maximise"
    ],
    "maximised": [
        "maximise"
    ],
    "maximises": [
        "maximise"
    ],
    "mortars": [
        "mortar"
    ],
    "writs": [
        "writ"
    ],
    "writed": [
        "writ"
    ],
    "crests": [
        "crest"
    ],
    "crested": [
        "crest"
    ],
    "cresting": [
        "crest"
    ],
    "lyrics": [
        "lyric"
    ],
    "nutrients": [
        "nutrient"
    ],
    "chronicles": [
        "chronicle"
    ],
    "chronicled": [
        "chronicle"
    ],
    "chronicling": [
        "chronicle"
    ],
    "geologies": [
        "geology"
    ],
    "purities": [
        "purity"
    ],
    "wycliffes": [
        "wycliffe"
    ],
    "mounds": [
        "mound"
    ],
    "mounded": [
        "mound"
    ],
    "mounding": [
        "mound"
    ],
    "remanded": [
        "remand"
    ],
    "remands": [
        "remand"
    ],
    "remanding": [
        "remand"
    ],
    "rims": [
        "rim"
    ],
    "rimmed": [
        "rim"
    ],
    "rimming": [
        "rim"
    ],
    "coarser": [
        "coarse"
    ],
    "coarsest": [
        "coarse"
    ],
    "coarsing": [
        "coarse"
    ],
    "golfers": [
        "golfer"
    ],
    "outgoings": [
        "outgoing"
    ],
    "singhing": [
        "singh"
    ],
    "trouts": [
        "trout"
    ],
    "workmen": [
        "workman"
    ],
    "libyas": [
        "libya"
    ],
    "bennies": [
        "benny"
    ],
    "disappearances": [
        "disappearance"
    ],
    "meters": [
        "meter"
    ],
    "metered": [
        "meter"
    ],
    "metering": [
        "meter"
    ],
    "energetics": [
        "energetic"
    ],
    "massacring": [
        "massacre",
        "massacr"
    ],
    "massacred": [
        "massacre",
        "massacr"
    ],
    "persians": [
        "persian"
    ],
    "plighted": [
        "plight"
    ],
    "plighting": [
        "plight"
    ],
    "plights": [
        "plight"
    ],
    "tribals": [
        "tribal"
    ],
    "archaeologies": [
        "archaeology"
    ],
    "kylies": [
        "kylie"
    ],
    "morses": [
        "morse"
    ],
    "outraging": [
        "outrage"
    ],
    "outraged": [
        "outrage"
    ],
    "pharmaceuticals": [
        "pharmaceutical"
    ],
    "strolling": [
        "stroll"
    ],
    "strolls": [
        "stroll"
    ],
    "strolled": [
        "stroll",
        "strol"
    ],
    "sutherlands": [
        "sutherland"
    ],
    "tractors": [
        "tractor"
    ],
    "clasped": [
        "clasp"
    ],
    "clasping": [
        "clasp"
    ],
    "clasps": [
        "clasp"
    ],
    "cosier": [
        "cosy"
    ],
    "cosies": [
        "cosy"
    ],
    "cosiest": [
        "cosy"
    ],
    "cosying": [
        "cosy"
    ],
    "cosied": [
        "cosy"
    ],
    "dietaries": [
        "dietary"
    ],
    "equated": [
        "equate"
    ],
    "equates": [
        "equate"
    ],
    "equating": [
        "equate"
    ],
    "exemplified": [
        "exemplify"
    ],
    "exemplifies": [
        "exemplify"
    ],
    "exemplifying": [
        "exemplify"
    ],
    "handkerchiefs": [
        "handkerchief"
    ],
    "pipelined": [
        "pipeline"
    ],
    "pipelining": [
        "pipeline"
    ],
    "ruperts": [
        "rupert"
    ],
    "shinier": [
        "shiny"
    ],
    "shiniest": [
        "shiny"
    ],
    "tobies": [
        "toby"
    ],
    "vales": [
        "vale"
    ],
    "displaced": [
        "displace"
    ],
    "displacing": [
        "displace"
    ],
    "displaces": [
        "displace"
    ],
    "foliages": [
        "foliage"
    ],
    "foliaged": [
        "foliage"
    ],
    "globed": [
        "globe"
    ],
    "stoked": [
        "stoke"
    ],
    "stoking": [
        "stoke"
    ],
    "woundeds": [
        "wounded"
    ],
    "abbots": [
        "abbot"
    ],
    "adjourned": [
        "adjourn"
    ],
    "adjourning": [
        "adjourn"
    ],
    "adjourns": [
        "adjourn"
    ],
    "exteriors": [
        "exterior"
    ],
    "broadened": [
        "broaden"
    ],
    "broadening": [
        "broaden"
    ],
    "broadens": [
        "broaden"
    ],
    "dustier": [
        "dusty"
    ],
    "dustiest": [
        "dusty"
    ],
    "maternities": [
        "maternity"
    ],
    "questionings": [
        "questioning"
    ],
    "anglers": [
        "angler"
    ],
    "riskier": [
        "risky"
    ],
    "riskiest": [
        "risky"
    ],
    "dissenting": [
        "dissent"
    ],
    "dissented": [
        "dissent"
    ],
    "dissents": [
        "dissent"
    ],
    "kindnesses": [
        "kindness"
    ],
    "mgs": [
        "mg"
    ],
    "puppies": [
        "puppy"
    ],
    "puppys": [
        "puppy"
    ],
    "salesmen": [
        "salesman"
    ],
    "anthropologists": [
        "anthropologist"
    ],
    "apts": [
        "apt"
    ],
    "apter": [
        "apt"
    ],
    "aptest": [
        "apt"
    ],
    "inventories": [
        "inventory"
    ],
    "inventoried": [
        "inventory"
    ],
    "specialities": [
        "speciality"
    ],
    "volcanics": [
        "volcanic"
    ],
    "wearied": [
        "weary"
    ],
    "wearying": [
        "weary"
    ],
    "wearier": [
        "weary"
    ],
    "wearies": [
        "weary"
    ],
    "weariest": [
        "weary"
    ],
    "goings": [
        "going"
    ],
    "seams": [
        "seam"
    ],
    "seamed": [
        "seam"
    ],
    "seaming": [
        "seam"
    ],
    "tynes": [
        "tyne"
    ],
    "uplands": [
        "upland"
    ],
    "aucklands": [
        "auckland"
    ],
    "houseworks": [
        "housework"
    ],
    "sexiest": [
        "sexy"
    ],
    "sexier": [
        "sexy"
    ],
    "sobered": [
        "sober"
    ],
    "sobers": [
        "sober"
    ],
    "sobering": [
        "sober"
    ],
    "soberer": [
        "sober"
    ],
    "soberest": [
        "sober"
    ],
    "rogerss": [
        "rogers"
    ],
    "scarves": [
        "scarf"
    ],
    "scarfed": [
        "scarf"
    ],
    "scarfs": [
        "scarf"
    ],
    "viewings": [
        "viewing"
    ],
    "fairnesses": [
        "fairness"
    ],
    "icons": [
        "icon"
    ],
    "webs": [
        "web"
    ],
    "honesties": [
        "honesty"
    ],
    "immunities": [
        "immunity"
    ],
    "lured": [
        "lure"
    ],
    "lures": [
        "lure"
    ],
    "luring": [
        "lure"
    ],
    "necessitated": [
        "necessitate"
    ],
    "necessitates": [
        "necessitate"
    ],
    "necessitating": [
        "necessitate"
    ],
    "psychiatrists": [
        "psychiatrist"
    ],
    "burnss": [
        "burns"
    ],
    "earthquakes": [
        "earthquake"
    ],
    "embedded": [
        "embed"
    ],
    "embedding": [
        "embed"
    ],
    "embeds": [
        "embed"
    ],
    "variances": [
        "variance"
    ],
    "anthropologies": [
        "anthropology"
    ],
    "cardboards": [
        "cardboard"
    ],
    "robuster": [
        "robust"
    ],
    "wildernesses": [
        "wilderness"
    ],
    "moistures": [
        "moisture"
    ],
    "unifications": [
        "unification"
    ],
    "comrades": [
        "comrade"
    ],
    "droughts": [
        "drought"
    ],
    "feminisms": [
        "feminism"
    ],
    "nannies": [
        "nanny"
    ],
    "nannying": [
        "nanny"
    ],
    "nannied": [
        "nanny"
    ],
    "simplified": [
        "simplify"
    ],
    "simplifying": [
        "simplify"
    ],
    "contradictories": [
        "contradictory"
    ],
    "exes": [
        "ex"
    ],
    "noons": [
        "noon"
    ],
    "oaths": [
        "oath"
    ],
    "terminologies": [
        "terminology"
    ],
    "contributors": [
        "contributor"
    ],
    "cubed": [
        "cube"
    ],
    "cubing": [
        "cube"
    ],
    "larvae": [
        "larva"
    ],
    "mused": [
        "muse"
    ],
    "musing": [
        "muse"
    ],
    "orientals": [
        "oriental"
    ],
    "quizzed": [
        "quiz"
    ],
    "quizzing": [
        "quiz"
    ],
    "quizzes": [
        "quiz"
    ],
    "radii": [
        "radius"
    ],
    "rationed": [
        "ration"
    ],
    "rationing": [
        "ration"
    ],
    "reproductives": [
        "reproductive"
    ],
    "trickier": [
        "tricky"
    ],
    "trickiest": [
        "tricky"
    ],
    "violins": [
        "violin"
    ],
    "badgers": [
        "badger"
    ],
    "badgered": [
        "badger"
    ],
    "badgering": [
        "badger"
    ],
    "growled": [
        "growl"
    ],
    "growling": [
        "growl"
    ],
    "growls": [
        "growl"
    ],
    "paisleys": [
        "paisley"
    ],
    "purchasings": [
        "purchasing"
    ],
    "studded": [
        "stud"
    ],
    "studs": [
        "stud"
    ],
    "studding": [
        "stud"
    ],
    "aftermaths": [
        "aftermath"
    ],
    "danas": [
        "dana"
    ],
    "landmarks": [
        "landmark"
    ],
    "landmarking": [
        "landmark"
    ],
    "subscribed": [
        "subscribe"
    ],
    "subscribing": [
        "subscribe"
    ],
    "subscribes": [
        "subscribe"
    ],
    "batsmen": [
        "batsman"
    ],
    "gloomier": [
        "gloomy"
    ],
    "gloomiest": [
        "gloomy"
    ],
    "gloomies": [
        "gloomy"
    ],
    "recycling": [
        "recycle"
    ],
    "recycled": [
        "recycle"
    ],
    "takings": [
        "taking"
    ],
    "terrorisms": [
        "terrorism"
    ],
    "poring": [
        "pore"
    ],
    "pored": [
        "pore"
    ],
    "gypsies": [
        "gypsy"
    ],
    "gypsys": [
        "gypsy"
    ],
    "thumping": [
        "thump"
    ],
    "thumped": [
        "thump"
    ],
    "thumps": [
        "thump"
    ],
    "censorships": [
        "censorship"
    ],
    "hurled": [
        "hurl"
    ],
    "hurling": [
        "hurl"
    ],
    "hurls": [
        "hurl"
    ],
    "madonnas": [
        "madonna"
    ],
    "posturing": [
        "posture"
    ],
    "postured": [
        "posture"
    ],
    "veils": [
        "veil"
    ],
    "veiled": [
        "veil"
    ],
    "veiling": [
        "veil"
    ],
    "lags": [
        "lag"
    ],
    "lagged": [
        "lag"
    ],
    "lagging": [
        "lag"
    ],
    "retrievals": [
        "retrieval"
    ],
    "sweepings": [
        "sweeping"
    ],
    "damneds": [
        "damned"
    ],
    "hymns": [
        "hymn"
    ],
    "hymned": [
        "hymn"
    ],
    "hymning": [
        "hymn"
    ],
    "overflowing": [
        "overflow"
    ],
    "overflowed": [
        "overflow"
    ],
    "overflows": [
        "overflow"
    ],
    "roasted": [
        "roast"
    ],
    "roasting": [
        "roast"
    ],
    "roasts": [
        "roast"
    ],
    "roaster": [
        "roast"
    ],
    "appellants": [
        "appellant"
    ],
    "perfumes": [
        "perfume"
    ],
    "perfumed": [
        "perfume"
    ],
    "perfuming": [
        "perfume"
    ],
    "windings": [
        "winding"
    ],
    "cypruss": [
        "cyprus"
    ],
    "oriented": [
        "orient"
    ],
    "orienting": [
        "orient"
    ],
    "gmts": [
        "gmt"
    ],
    "halifaxes": [
        "halifax"
    ],
    "malaysias": [
        "malaysia"
    ],
    "scooped": [
        "scoop"
    ],
    "scooping": [
        "scoop"
    ],
    "battalions": [
        "battalion"
    ],
    "bitternesses": [
        "bitterness"
    ],
    "bowlings": [
        "bowling"
    ],
    "dismantled": [
        "dismantle"
    ],
    "dismantling": [
        "dismantle"
    ],
    "dismantles": [
        "dismantle"
    ],
    "islams": [
        "islam"
    ],
    "naughtier": [
        "naughty"
    ],
    "naughtiest": [
        "naughty"
    ],
    "naughties": [
        "naughty"
    ],
    "severns": [
        "severn"
    ],
    "gambled": [
        "gamble"
    ],
    "gambling": [
        "gamble"
    ],
    "gambles": [
        "gamble"
    ],
    "nicknamed": [
        "nickname"
    ],
    "nicknames": [
        "nickname"
    ],
    "nicknaming": [
        "nickname"
    ],
    "withheld": [
        "withhold"
    ],
    "withholding": [
        "withhold"
    ],
    "withholds": [
        "withhold"
    ],
    "hacking": [
        "hack"
    ],
    "hacked": [
        "hack"
    ],
    "hacks": [
        "hack"
    ],
    "microscoping": [
        "microscope"
    ],
    "a.m.": [
        "a.m."
    ],
    "scriptures": [
        "scripture"
    ],
    "donkeys": [
        "donkey"
    ],
    "foiled": [
        "foil"
    ],
    "foils": [
        "foil"
    ],
    "foiling": [
        "foil"
    ],
    "rainforests": [
        "rainforest"
    ],
    "roundabouts": [
        "roundabout"
    ],
    "corporals": [
        "corporal"
    ],
    "creators": [
        "creator"
    ],
    "glittered": [
        "glitter"
    ],
    "glittering": [
        "glitter"
    ],
    "glitters": [
        "glitter"
    ],
    "laterals": [
        "lateral"
    ],
    "marred": [
        "mar"
    ],
    "marring": [
        "mar"
    ],
    "paradigms": [
        "paradigm"
    ],
    "pips": [
        "pip"
    ],
    "pipped": [
        "pip"
    ],
    "pipping": [
        "pip"
    ],
    "vowels": [
        "vowel"
    ],
    "webbs": [
        "webb"
    ],
    "crusades": [
        "crusade"
    ],
    "crusading": [
        "crusade"
    ],
    "crusaded": [
        "crusade"
    ],
    "diluted": [
        "dilute"
    ],
    "diluting": [
        "dilute"
    ],
    "dilutes": [
        "dilute"
    ],
    "finlands": [
        "finland"
    ],
    "grazing": [
        "graze"
    ],
    "grazed": [
        "graze"
    ],
    "grazes": [
        "graze"
    ],
    "hampered": [
        "hamper"
    ],
    "hampers": [
        "hamper"
    ],
    "hampering": [
        "hamper"
    ],
    "humming": [
        "hum"
    ],
    "hummed": [
        "hum"
    ],
    "hums": [
        "hum"
    ],
    "ornaments": [
        "ornament"
    ],
    "ornamented": [
        "ornament"
    ],
    "ornamenting": [
        "ornament"
    ],
    "schoolings": [
        "schooling"
    ],
    "sinisters": [
        "sinister"
    ],
    "therapeutics": [
        "therapeutic"
    ],
    "warwicks": [
        "warwick"
    ],
    "bogs": [
        "bog"
    ],
    "bogged": [
        "bog"
    ],
    "bogging": [
        "bog"
    ],
    "dubbed": [
        "dub"
    ],
    "dubbing": [
        "dub"
    ],
    "dubs": [
        "dub"
    ],
    "footpaths": [
        "footpath"
    ],
    "gandhis": [
        "gandhi"
    ],
    "ovals": [
        "oval"
    ],
    "probations": [
        "probation"
    ],
    "rapped": [
        "rap"
    ],
    "raps": [
        "rap"
    ],
    "rapping": [
        "rap"
    ],
    "morrisons": [
        "morrison"
    ],
    "subsections": [
        "subsection"
    ],
    "deceived": [
        "deceive"
    ],
    "deceiving": [
        "deceive"
    ],
    "deceives": [
        "deceive"
    ],
    "dementias": [
        "dementia"
    ],
    "halved": [
        "halve"
    ],
    "halving": [
        "halve"
    ],
    "orchards": [
        "orchard"
    ],
    "berkshires": [
        "berkshire"
    ],
    "rivalries": [
        "rivalry"
    ],
    "starters": [
        "starter"
    ],
    "trotted": [
        "trot"
    ],
    "trotting": [
        "trot"
    ],
    "cambodias": [
        "cambodia"
    ],
    "discontents": [
        "discontent"
    ],
    "gentries": [
        "gentry"
    ],
    "fastened": [
        "fasten"
    ],
    "fastening": [
        "fasten"
    ],
    "fastens": [
        "fasten"
    ],
    "blunted": [
        "blunt"
    ],
    "blunter": [
        "blunt"
    ],
    "blunts": [
        "blunt"
    ],
    "blunting": [
        "blunt"
    ],
    "bluntest": [
        "blunt"
    ],
    "handbags": [
        "handbag"
    ],
    "handbagged": [
        "handbag"
    ],
    "pyramids": [
        "pyramid"
    ],
    "abundances": [
        "abundance"
    ],
    "epidemics": [
        "epidemic"
    ],
    "singings": [
        "singing"
    ],
    "grievances": [
        "grievance"
    ],
    "puffed": [
        "puff"
    ],
    "puffs": [
        "puff"
    ],
    "puffing": [
        "puff"
    ],
    "secrecies": [
        "secrecy"
    ],
    "violated": [
        "violate"
    ],
    "violating": [
        "violate"
    ],
    "violates": [
        "violate"
    ],
    "coxes": [
        "cox"
    ],
    "coxing": [
        "cox"
    ],
    "coxed": [
        "cox"
    ],
    "lamberts": [
        "lambert"
    ],
    "pathetics": [
        "pathetic"
    ],
    "proximities": [
        "proximity"
    ],
    "replays": [
        "replay"
    ],
    "replayed": [
        "replay"
    ],
    "replaying": [
        "replay"
    ],
    "ums": [
        "um"
    ],
    "ummed": [
        "um"
    ],
    "umming": [
        "um"
    ],
    "inmates": [
        "inmate"
    ],
    "smilings": [
        "smiling"
    ],
    "sorrows": [
        "sorrow"
    ],
    "sorrowed": [
        "sorrow"
    ],
    "sorrowing": [
        "sorrow"
    ],
    "storeys": [
        "storey"
    ],
    "storeyed": [
        "storey"
    ],
    "talkings": [
        "talking"
    ],
    "atmospherics": [
        "atmospheric"
    ],
    "celebrities": [
        "celebrity"
    ],
    "hardened": [
        "harden"
    ],
    "hardening": [
        "harden"
    ],
    "hardens": [
        "harden"
    ],
    "appliances": [
        "appliance"
    ],
    "dickenss": [
        "dickens"
    ],
    "endowments": [
        "endowment"
    ],
    "methodists": [
        "methodist"
    ],
    "wallets": [
        "wallet"
    ],
    "danes": [
        "dane"
    ],
    "epics": [
        "epic"
    ],
    "inspectorates": [
        "inspectorate"
    ],
    "sparkling": [
        "sparkle"
    ],
    "sparkled": [
        "sparkle"
    ],
    "sparkles": [
        "sparkle"
    ],
    "zimbabwes": [
        "zimbabwe"
    ],
    "filthiest": [
        "filthy"
    ],
    "filthier": [
        "filthy"
    ],
    "mended": [
        "mend"
    ],
    "mending": [
        "mend"
    ],
    "mends": [
        "mend"
    ],
    "precluded": [
        "preclude"
    ],
    "precludes": [
        "preclude"
    ],
    "precluding": [
        "preclude"
    ],
    "beiruts": [
        "beirut"
    ],
    "chunks": [
        "chunk"
    ],
    "chunking": [
        "chunk"
    ],
    "chunked": [
        "chunk"
    ],
    "lightweights": [
        "lightweight"
    ],
    "prophets": [
        "prophet"
    ],
    "suburbans": [
        "suburban"
    ],
    "addicted": [
        "addict"
    ],
    "addicts": [
        "addict"
    ],
    "brewed": [
        "brew"
    ],
    "brewing": [
        "brew"
    ],
    "brews": [
        "brew"
    ],
    "cocaines": [
        "cocaine"
    ],
    "hares": [
        "hare"
    ],
    "haring": [
        "hare"
    ],
    "hared": [
        "hare"
    ],
    "hareing": [
        "hare"
    ],
    "insulins": [
        "insulin"
    ],
    "messengers": [
        "messenger"
    ],
    "overtimes": [
        "overtime"
    ],
    "sebs": [
        "seb"
    ],
    "deepened": [
        "deepen"
    ],
    "deepening": [
        "deepen"
    ],
    "deepens": [
        "deepen"
    ],
    "realizations": [
        "realization"
    ],
    "trickled": [
        "trickle"
    ],
    "trickling": [
        "trickle"
    ],
    "trickles": [
        "trickle"
    ],
    "contingencies": [
        "contingency"
    ],
    "fascisms": [
        "fascism"
    ],
    "interpreters": [
        "interpreter"
    ],
    "tentacles": [
        "tentacle"
    ],
    "tentacled": [
        "tentacle"
    ],
    "confidentialities": [
        "confidentiality"
    ],
    "couns": [
        "coun"
    ],
    "formalities": [
        "formality"
    ],
    "goddesses": [
        "goddess"
    ],
    "jugs": [
        "jug"
    ],
    "dafter": [
        "daft"
    ],
    "daftest": [
        "daft"
    ],
    "dafts": [
        "daft"
    ],
    "dollies": [
        "dolly"
    ],
    "keepings": [
        "keeping"
    ],
    "overturned": [
        "overturn"
    ],
    "overturning": [
        "overturn"
    ],
    "overturns": [
        "overturn"
    ],
    "draped": [
        "drape"
    ],
    "draping": [
        "drape"
    ],
    "environmentalists": [
        "environmentalist"
    ],
    "intrinsics": [
        "intrinsic"
    ],
    "schoolboys": [
        "schoolboy"
    ],
    "shrines": [
        "shrine"
    ],
    "swanseas": [
        "swansea"
    ],
    "antigens": [
        "antigen"
    ],
    "discrepancies": [
        "discrepancy"
    ],
    "contradicted": [
        "contradict"
    ],
    "contradicts": [
        "contradict"
    ],
    "contradicting": [
        "contradict"
    ],
    "cookers": [
        "cooker"
    ],
    "finishings": [
        "finishing"
    ],
    "pedals": [
        "pedal"
    ],
    "pedalling": [
        "pedal"
    ],
    "pedalled": [
        "pedal"
    ],
    "reshuffled": [
        "reshuffle"
    ],
    "reshuffles": [
        "reshuffle"
    ],
    "reshuffling": [
        "reshuffle"
    ],
    "lethals": [
        "lethal"
    ],
    "wellingtons": [
        "wellington"
    ],
    "acknowledgements": [
        "acknowledgement"
    ],
    "dedications": [
        "dedication"
    ],
    "lofted": [
        "loft"
    ],
    "lofting": [
        "loft"
    ],
    "maidens": [
        "maiden"
    ],
    "balder": [
        "bald"
    ],
    "baldest": [
        "bald"
    ],
    "balding": [
        "bald"
    ],
    "balded": [
        "bald"
    ],
    "cairoes": [
        "cairo"
    ],
    "muddied": [
        "muddy"
    ],
    "muddying": [
        "muddy"
    ],
    "muddies": [
        "muddy"
    ],
    "muddier": [
        "muddy"
    ],
    "muddiest": [
        "muddy"
    ],
    "quarterlies": [
        "quarterly"
    ],
    "quartets": [
        "quartet"
    ],
    "stellas": [
        "stella"
    ],
    "thrills": [
        "thrill"
    ],
    "thrilling": [
        "thrill",
        "thril"
    ],
    "thrilled": [
        "thrill",
        "thril"
    ],
    "trailers": [
        "trailer"
    ],
    "trailered": [
        "trailer"
    ],
    "trailering": [
        "trailer"
    ],
    "warsaws": [
        "warsaw"
    ],
    "bosnians": [
        "bosnian"
    ],
    "emitted": [
        "emit"
    ],
    "emitting": [
        "emit"
    ],
    "emits": [
        "emit"
    ],
    "memoirs": [
        "memoir"
    ],
    "radiators": [
        "radiator"
    ],
    "affirmed": [
        "affirm"
    ],
    "affirming": [
        "affirm"
    ],
    "affirms": [
        "affirm"
    ],
    "footballers": [
        "footballer"
    ],
    "grilled": [
        "grill"
    ],
    "grilling": [
        "grill"
    ],
    "grills": [
        "grill"
    ],
    "helpers": [
        "helper"
    ],
    "hindus": [
        "hindu"
    ],
    "deterrents": [
        "deterrent"
    ],
    "grannies": [
        "granny"
    ],
    "strawberries": [
        "strawberry"
    ],
    "bangors": [
        "bangor"
    ],
    "asthmas": [
        "asthma"
    ],
    "cradled": [
        "cradle"
    ],
    "cradling": [
        "cradle"
    ],
    "cradles": [
        "cradle"
    ],
    "finns": [
        "finn"
    ],
    "glossies": [
        "glossy"
    ],
    "glossier": [
        "glossy"
    ],
    "glossiest": [
        "glossy"
    ],
    "grandsons": [
        "grandson"
    ],
    "tramps": [
        "tramp"
    ],
    "tramped": [
        "tramp"
    ],
    "tramping": [
        "tramp"
    ],
    "undesirables": [
        "undesirable"
    ],
    "doled": [
        "dole"
    ],
    "doles": [
        "dole"
    ],
    "doling": [
        "dole"
    ],
    "parachuting": [
        "parachute"
    ],
    "parachuted": [
        "parachute"
    ],
    "exporters": [
        "exporter"
    ],
    "lingered": [
        "linger"
    ],
    "lingers": [
        "linger"
    ],
    "lingering": [
        "linger"
    ],
    "midsts": [
        "midst"
    ],
    "suffices": [
        "suffice"
    ],
    "sufficed": [
        "suffice"
    ],
    "sufficing": [
        "suffice"
    ],
    "waded": [
        "wade"
    ],
    "wading": [
        "wade"
    ],
    "wades": [
        "wade"
    ],
    "wadeing": [
        "wade"
    ],
    "arrearss": [
        "arrears"
    ],
    "afghanistans": [
        "afghanistan"
    ],
    "brazilians": [
        "brazilian"
    ],
    "icier": [
        "icy"
    ],
    "iciest": [
        "icy"
    ],
    "reiterated": [
        "reiterate"
    ],
    "reiterating": [
        "reiterate"
    ],
    "reiterates": [
        "reiterate"
    ],
    "scepticisms": [
        "scepticism"
    ],
    "cosmetics": [
        "cosmetic"
    ],
    "oxides": [
        "oxide"
    ],
    "pondered": [
        "ponder"
    ],
    "pondering": [
        "ponder"
    ],
    "ponders": [
        "ponder"
    ],
    "eccentrics": [
        "eccentric"
    ],
    "fens": [
        "fen"
    ],
    "greenpeaces": [
        "greenpeace"
    ],
    "migrated": [
        "migrate"
    ],
    "migrating": [
        "migrate"
    ],
    "migrates": [
        "migrate"
    ],
    "pirated": [
        "pirate"
    ],
    "pirating": [
        "pirate"
    ],
    "coking": [
        "coke"
    ],
    "coked": [
        "coke"
    ],
    "addictions": [
        "addiction"
    ],
    "derivatives": [
        "derivative"
    ],
    "gingers": [
        "ginger"
    ],
    "gingering": [
        "ginger"
    ],
    "gingered": [
        "ginger"
    ],
    "gnps": [
        "gnp"
    ],
    "jakes": [
        "jake"
    ],
    "mortals": [
        "mortal"
    ],
    "petroleums": [
        "petroleum"
    ],
    "plucked": [
        "pluck"
    ],
    "plucking": [
        "pluck"
    ],
    "plucks": [
        "pluck"
    ],
    "pss": [
        "ps"
    ],
    "samplings": [
        "sampling"
    ],
    "chicks": [
        "chick"
    ],
    "compassed": [
        "compass"
    ],
    "ecstasies": [
        "ecstasy"
    ],
    "frustrated": [
        "frustrate"
    ],
    "frustrates": [
        "frustrate"
    ],
    "frustrating": [
        "frustrate"
    ],
    "finites": [
        "finite"
    ],
    "cigars": [
        "cigar"
    ],
    "instabilities": [
        "instability"
    ],
    "kidnapped": [
        "kidnap"
    ],
    "kidnaps": [
        "kidnap"
    ],
    "unlocked": [
        "unlock"
    ],
    "unlocking": [
        "unlock"
    ],
    "unlocks": [
        "unlock"
    ],
    "wedded": [
        "wed"
    ],
    "weds": [
        "wed"
    ],
    "wedding": [
        "wed"
    ],
    "wed": [
        "wed"
    ],
    "attics": [
        "attic"
    ],
    "canteens": [
        "canteen"
    ],
    "endorsements": [
        "endorsement"
    ],
    "exacerbated": [
        "exacerbate"
    ],
    "exacerbating": [
        "exacerbate"
    ],
    "exacerbates": [
        "exacerbate"
    ],
    "handbooks": [
        "handbook"
    ],
    "leapors": [
        "leapor"
    ],
    "partitioned": [
        "partition"
    ],
    "partitioning": [
        "partition"
    ],
    "ripest": [
        "ripe"
    ],
    "stereotyping": [
        "stereotype"
    ],
    "stereotyped": [
        "stereotype"
    ],
    "clapped": [
        "clap"
    ],
    "clapping": [
        "clap"
    ],
    "claps": [
        "clap"
    ],
    "hawks": [
        "hawk"
    ],
    "hawking": [
        "hawk"
    ],
    "hawked": [
        "hawk"
    ],
    "luggaged": [
        "luggage"
    ],
    "luggage": [
        "luggage"
    ],
    "carpenters": [
        "carpenter"
    ],
    "carpentering": [
        "carpenter"
    ],
    "carpentered": [
        "carpenter"
    ],
    "fourteenths": [
        "fourteenth"
    ],
    "garrisons": [
        "garrison"
    ],
    "garrisoned": [
        "garrison"
    ],
    "garrisoning": [
        "garrison"
    ],
    "peninsulas": [
        "peninsula"
    ],
    "slung": [
        "sling"
    ],
    "slings": [
        "sling"
    ],
    "slinging": [
        "sling"
    ],
    "assassinations": [
        "assassination"
    ],
    "blander": [
        "bland"
    ],
    "blandest": [
        "bland"
    ],
    "blanding": [
        "bland"
    ],
    "carloss": [
        "carlos"
    ],
    "heroics": [
        "heroic"
    ],
    "maltas": [
        "malta"
    ],
    "telescoped": [
        "telescope"
    ],
    "telescoping": [
        "telescope"
    ],
    "ushered": [
        "usher"
    ],
    "ushering": [
        "usher"
    ],
    "ushers": [
        "usher"
    ],
    "fillings": [
        "filling"
    ],
    "instalments": [
        "instalment"
    ],
    "keywords": [
        "keyword"
    ],
    "keywording": [
        "keyword"
    ],
    "plumped": [
        "plump"
    ],
    "plumping": [
        "plump"
    ],
    "plumper": [
        "plump"
    ],
    "plumps": [
        "plump"
    ],
    "plumpest": [
        "plump"
    ],
    "smeared": [
        "smear"
    ],
    "smears": [
        "smear"
    ],
    "smearing": [
        "smear"
    ],
    "torques": [
        "torque"
    ],
    "barged": [
        "barge"
    ],
    "barging": [
        "barge"
    ],
    "eroded": [
        "erode"
    ],
    "eroding": [
        "erode"
    ],
    "lurking": [
        "lurk"
    ],
    "lurked": [
        "lurk"
    ],
    "lurks": [
        "lurk"
    ],
    "menaced": [
        "menace"
    ],
    "menacing": [
        "menace"
    ],
    "pikes": [
        "pike"
    ],
    "piking": [
        "pike"
    ],
    "piked": [
        "pike"
    ],
    "stevenss": [
        "stevens"
    ],
    "becks": [
        "beck"
    ],
    "burglars": [
        "burglar"
    ],
    "curators": [
        "curator"
    ],
    "regenerations": [
        "regeneration"
    ],
    "theatricals": [
        "theatrical"
    ],
    "thorns": [
        "thorn"
    ],
    "thorning": [
        "thorn"
    ],
    "thorned": [
        "thorn"
    ],
    "compassions": [
        "compassion"
    ],
    "goblins": [
        "goblin"
    ],
    "johnstons": [
        "johnston"
    ],
    "serbias": [
        "serbia"
    ],
    "shipments": [
        "shipment"
    ],
    "yers": [
        "yer"
    ],
    "chesses": [
        "chess"
    ],
    "composts": [
        "compost"
    ],
    "composted": [
        "compost"
    ],
    "composting": [
        "compost"
    ],
    "salvadors": [
        "salvador"
    ],
    "zips": [
        "zip"
    ],
    "zipped": [
        "zip"
    ],
    "zipping": [
        "zip"
    ],
    "muniches": [
        "munich"
    ],
    "dwelt": [
        "dwell"
    ],
    "dwells": [
        "dwell"
    ],
    "dwelling": [
        "dwell"
    ],
    "dwelled": [
        "dwell"
    ],
    "earnests": [
        "earnest"
    ],
    "spokeswomen": [
        "spokeswoman"
    ],
    "stalins": [
        "stalin"
    ],
    "syrians": [
        "syrian"
    ],
    "duchies": [
        "duchy"
    ],
    "fletchers": [
        "fletcher"
    ],
    "generics": [
        "generic"
    ],
    "blossomed": [
        "blossom"
    ],
    "blossoms": [
        "blossom"
    ],
    "blossoming": [
        "blossom"
    ],
    "commended": [
        "commend"
    ],
    "commends": [
        "commend"
    ],
    "commending": [
        "commend"
    ],
    "conserved": [
        "conserve"
    ],
    "conserving": [
        "conserve"
    ],
    "crammed": [
        "cram"
    ],
    "cramming": [
        "cram"
    ],
    "crams": [
        "cram"
    ],
    "precipitated": [
        "precipitate"
    ],
    "precipitating": [
        "precipitate"
    ],
    "precipitates": [
        "precipitate"
    ],
    "finned": [
        "fin"
    ],
    "finning": [
        "fin"
    ],
    "sponges": [
        "sponge"
    ],
    "sponged": [
        "sponge"
    ],
    "sponging": [
        "sponge"
    ],
    "booksellers": [
        "bookseller"
    ],
    "dynamicss": [
        "dynamics"
    ],
    "reversals": [
        "reversal"
    ],
    "detachments": [
        "detachment"
    ],
    "draughts": [
        "draught"
    ],
    "draughting": [
        "draught"
    ],
    "draughted": [
        "draught"
    ],
    "gunmen": [
        "gunman"
    ],
    "shoppers": [
        "shopper"
    ],
    "bidders": [
        "bidder"
    ],
    "dentals": [
        "dental"
    ],
    "extinctions": [
        "extinction"
    ],
    "grandparents": [
        "grandparent"
    ],
    "junks": [
        "junk"
    ],
    "junked": [
        "junk"
    ],
    "junking": [
        "junk"
    ],
    "carbonates": [
        "carbonate"
    ],
    "carbonated": [
        "carbonate"
    ],
    "carbonating": [
        "carbonate"
    ],
    "despised": [
        "despise"
    ],
    "despising": [
        "despise"
    ],
    "despises": [
        "despise"
    ],
    "ecologies": [
        "ecology"
    ],
    "gilts": [
        "gilt"
    ],
    "homosexualities": [
        "homosexuality"
    ],
    "paddling": [
        "paddle"
    ],
    "paddled": [
        "paddle"
    ],
    "paddles": [
        "paddle"
    ],
    "rehearsed": [
        "rehearse"
    ],
    "rehearsing": [
        "rehearse"
    ],
    "rehearses": [
        "rehearse"
    ],
    "mandelas": [
        "mandela"
    ],
    "ordeals": [
        "ordeal"
    ],
    "ratified": [
        "ratify"
    ],
    "ratifying": [
        "ratify"
    ],
    "starved": [
        "starve"
    ],
    "starving": [
        "starve"
    ],
    "starves": [
        "starve"
    ],
    "starveing": [
        "starve"
    ],
    "aminoes": [
        "amino"
    ],
    "butts": [
        "butt"
    ],
    "butting": [
        "butt"
    ],
    "butted": [
        "butt"
    ],
    "expectancies": [
        "expectancy"
    ],
    "gatts": [
        "gatt"
    ],
    "lithuanias": [
        "lithuania"
    ],
    "prominences": [
        "prominence"
    ],
    "siliconed": [
        "silicon"
    ],
    "siliconing": [
        "silicon"
    ],
    "vegetarians": [
        "vegetarian"
    ],
    "bulgarias": [
        "bulgaria"
    ],
    "persuasions": [
        "persuasion"
    ],
    "cancellations": [
        "cancellation"
    ],
    "detached": [
        "detach"
    ],
    "detaching": [
        "detach"
    ],
    "inadequacies": [
        "inadequacy"
    ],
    "ramps": [
        "ramp"
    ],
    "ramping": [
        "ramp"
    ],
    "ramped": [
        "ramp"
    ],
    "rationalities": [
        "rationality"
    ],
    "rebeccas": [
        "rebecca"
    ],
    "sunsets": [
        "sunset"
    ],
    "turfed": [
        "turf"
    ],
    "turfing": [
        "turf"
    ],
    "turves": [
        "turf"
    ],
    "fenders": [
        "fender"
    ],
    "fendered": [
        "fender"
    ],
    "kohls": [
        "kohl"
    ],
    "adventurers": [
        "adventurer"
    ],
    "devastated": [
        "devastate"
    ],
    "devastating": [
        "devastate"
    ],
    "devastates": [
        "devastate"
    ],
    "fortresses": [
        "fortress"
    ],
    "fortressed": [
        "fortress"
    ],
    "lexicons": [
        "lexicon"
    ],
    "pronunciations": [
        "pronunciation"
    ],
    "%s": [
        "%"
    ],
    "enhancements": [
        "enhancement"
    ],
    "necs": [
        "nec"
    ],
    "pavilions": [
        "pavilion"
    ],
    "aisles": [
        "aisle"
    ],
    "believers": [
        "believer"
    ],
    "curries": [
        "curry"
    ],
    "currys": [
        "curry"
    ],
    "currying": [
        "curry"
    ],
    "curried": [
        "curry"
    ],
    "fatties": [
        "fatty"
    ],
    "fattier": [
        "fatty"
    ],
    "fattys": [
        "fatty"
    ],
    "fattiest": [
        "fatty"
    ],
    "gliders": [
        "glider"
    ],
    "mumbled": [
        "mumble"
    ],
    "mumbling": [
        "mumble"
    ],
    "mumbles": [
        "mumble"
    ],
    "peptides": [
        "peptide"
    ],
    "pickups": [
        "pickup"
    ],
    "leighs": [
        "leigh"
    ],
    "lincolnshires": [
        "lincolnshire"
    ],
    "mattresses": [
        "mattress"
    ],
    "spears": [
        "spear"
    ],
    "speared": [
        "spear"
    ],
    "spearing": [
        "spear"
    ],
    "burrows": [
        "burrow"
    ],
    "burrowing": [
        "burrow"
    ],
    "burrowed": [
        "burrow"
    ],
    "gastrins": [
        "gastrin"
    ],
    "generosities": [
        "generosity"
    ],
    "ivies": [
        "ivy"
    ],
    "algae": [
        "alga"
    ],
    "caned": [
        "cane"
    ],
    "caning": [
        "cane"
    ],
    "conquered": [
        "conquer"
    ],
    "conquering": [
        "conquer"
    ],
    "conquers": [
        "conquer"
    ],
    "militias": [
        "militia"
    ],
    "raked": [
        "rake"
    ],
    "raking": [
        "rake"
    ],
    "rakes": [
        "rake"
    ],
    "setbacks": [
        "setback"
    ],
    "disbeliefs": [
        "disbelief"
    ],
    "goldsmiths": [
        "goldsmith"
    ],
    "hockeys": [
        "hockey"
    ],
    "outskirtss": [
        "outskirts"
    ],
    "thirteenths": [
        "thirteenth"
    ],
    "centers": [
        "center"
    ],
    "centered": [
        "center"
    ],
    "centering": [
        "center"
    ],
    "fluttered": [
        "flutter"
    ],
    "fluttering": [
        "flutter"
    ],
    "flutters": [
        "flutter"
    ],
    "imbalances": [
        "imbalance"
    ],
    "imbalanced": [
        "imbalance"
    ],
    "imbalancing": [
        "imbalance"
    ],
    "mantles": [
        "mantle"
    ],
    "mantled": [
        "mantle"
    ],
    "mantling": [
        "mantle"
    ],
    "stouter": [
        "stout"
    ],
    "stoutest": [
        "stout"
    ],
    "stouts": [
        "stout"
    ],
    "harassments": [
        "harassment"
    ],
    "howled": [
        "howl"
    ],
    "howling": [
        "howl"
    ],
    "howls": [
        "howl"
    ],
    "raving": [
        "rave"
    ],
    "raved": [
        "rave"
    ],
    "stans": [
        "stan"
    ],
    "wingers": [
        "winger"
    ],
    "lavas": [
        "lava"
    ],
    "pierced": [
        "pierce"
    ],
    "pierces": [
        "pierce"
    ],
    "reconstructed": [
        "reconstruct"
    ],
    "reconstructing": [
        "reconstruct"
    ],
    "reconstructs": [
        "reconstruct"
    ],
    "ammunitions": [
        "ammunition"
    ],
    "commemorated": [
        "commemorate"
    ],
    "commemorating": [
        "commemorate"
    ],
    "commemorates": [
        "commemorate"
    ],
    "hindered": [
        "hinder"
    ],
    "hindering": [
        "hinder"
    ],
    "hinders": [
        "hinder"
    ],
    "impaired": [
        "impair"
    ],
    "impairing": [
        "impair"
    ],
    "modiglianis": [
        "modigliani"
    ],
    "recollections": [
        "recollection"
    ],
    "refreshments": [
        "refreshment"
    ],
    "woodss": [
        "woods"
    ],
    "buffetted": [
        "buffet"
    ],
    "buffeting": [
        "buffete",
        "buffet"
    ],
    "buffeted": [
        "buffete",
        "buffet"
    ],
    "crows": [
        "crow"
    ],
    "crowed": [
        "crow"
    ],
    "crowing": [
        "crow"
    ],
    "crew": [
        "crow"
    ],
    "hinges": [
        "hinge"
    ],
    "hinged": [
        "hinge"
    ],
    "hingeing": [
        "hinge"
    ],
    "hinging": [
        "hinge"
    ],
    "journalisms": [
        "journalism"
    ],
    "offlined": [
        "offline"
    ],
    "offlining": [
        "offline"
    ],
    "offlines": [
        "offline"
    ],
    "rentals": [
        "rental"
    ],
    "stumps": [
        "stump"
    ],
    "stumped": [
        "stump"
    ],
    "stumping": [
        "stump"
    ],
    "underpinned": [
        "underpin"
    ],
    "underpinning": [
        "underpin"
    ],
    "underpins": [
        "underpin"
    ],
    "flattened": [
        "flatten"
    ],
    "flattening": [
        "flatten"
    ],
    "flattens": [
        "flatten"
    ],
    "insulations": [
        "insulation"
    ],
    "intermediaries": [
        "intermediary"
    ],
    "masts": [
        "mast"
    ],
    "masted": [
        "mast"
    ],
    "barleys": [
        "barley"
    ],
    "costas": [
        "costa"
    ],
    "galloped": [
        "gallop"
    ],
    "galloping": [
        "gallop"
    ],
    "gallops": [
        "gallop"
    ],
    "orderlies": [
        "orderly"
    ],
    "readinesses": [
        "readiness"
    ],
    "regents": [
        "regent"
    ],
    "slits": [
        "slit"
    ],
    "slitting": [
        "slit"
    ],
    "slitted": [
        "slit"
    ],
    "twitched": [
        "twitch"
    ],
    "twitching": [
        "twitch"
    ],
    "twitches": [
        "twitch"
    ],
    "congratulationss": [
        "congratulations"
    ],
    "reappeared": [
        "reappear"
    ],
    "reappears": [
        "reappear"
    ],
    "reappearing": [
        "reappear"
    ],
    "reassurances": [
        "reassurance"
    ],
    "turks": [
        "turk"
    ],
    "waterfalls": [
        "waterfall"
    ],
    "antiquities": [
        "antiquity"
    ],
    "geometrics": [
        "geometric"
    ],
    "misused": [
        "misuse"
    ],
    "misusing": [
        "misuse"
    ],
    "misuses": [
        "misuse"
    ],
    "mosess": [
        "moses"
    ],
    "blotted": [
        "blot"
    ],
    "blotting": [
        "blot"
    ],
    "contenders": [
        "contender"
    ],
    "geneses": [
        "genesis"
    ],
    "reinforcements": [
        "reinforcement"
    ],
    "caressing": [
        "caress"
    ],
    "caressed": [
        "caress"
    ],
    "irritated": [
        "irritate"
    ],
    "irritates": [
        "irritate"
    ],
    "irritating": [
        "irritate"
    ],
    "lifeboats": [
        "lifeboat"
    ],
    "tts": [
        "tt"
    ],
    "bulging": [
        "bulge"
    ],
    "bulged": [
        "bulge"
    ],
    "bulges": [
        "bulge"
    ],
    "duplicated": [
        "duplicate"
    ],
    "duplicating": [
        "duplicate"
    ],
    "duplicates": [
        "duplicate"
    ],
    "liquidities": [
        "liquidity"
    ],
    "marss": [
        "mars"
    ],
    "preachers": [
        "preacher"
    ],
    "anguss": [
        "angus"
    ],
    "delhis": [
        "delhi"
    ],
    "ginned": [
        "gin"
    ],
    "tankered": [
        "tanker"
    ],
    "dismayed": [
        "dismay"
    ],
    "dismaying": [
        "dismay"
    ],
    "dismays": [
        "dismay"
    ],
    "drawbacks": [
        "drawback"
    ],
    "encoded": [
        "encode"
    ],
    "encoding": [
        "encode"
    ],
    "loaves": [
        "loaf"
    ],
    "loafing": [
        "loaf"
    ],
    "loafed": [
        "loaf"
    ],
    "loafs": [
        "loaf"
    ],
    "runways": [
        "runway"
    ],
    "deployments": [
        "deployment"
    ],
    "intimacies": [
        "intimacy"
    ],
    "linings": [
        "lining"
    ],
    "presenters": [
        "presenter"
    ],
    "rationales": [
        "rationale"
    ],
    "scums": [
        "scum"
    ],
    "scummed": [
        "scum"
    ],
    "baghdads": [
        "baghdad"
    ],
    "bloused": [
        "blouse"
    ],
    "blousing": [
        "blouse"
    ],
    "bribed": [
        "bribe"
    ],
    "bribing": [
        "bribe"
    ],
    "callers": [
        "caller"
    ],
    "cockpits": [
        "cockpit"
    ],
    "pasted": [
        "paste"
    ],
    "pastes": [
        "paste"
    ],
    "pasting": [
        "paste"
    ],
    "relics": [
        "relic"
    ],
    "selectors": [
        "selector"
    ],
    "winked": [
        "wink"
    ],
    "winking": [
        "wink"
    ],
    "winks": [
        "wink"
    ],
    "chattering": [
        "chatter"
    ],
    "chattered": [
        "chatter"
    ],
    "chatters": [
        "chatter"
    ],
    "insets": [
        "inset"
    ],
    "insetting": [
        "inset"
    ],
    "insetted": [
        "inset"
    ],
    "judiths": [
        "judith"
    ],
    "canopies": [
        "canopy"
    ],
    "canopied": [
        "canopy"
    ],
    "collaborated": [
        "collaborate"
    ],
    "collaborating": [
        "collaborate"
    ],
    "collaborates": [
        "collaborate"
    ],
    "cryings": [
        "crying"
    ],
    "masterpieces": [
        "masterpiece"
    ],
    "subscribers": [
        "subscriber"
    ],
    "ukrainians": [
        "ukrainian"
    ],
    "accessions": [
        "accession"
    ],
    "accessioned": [
        "accession"
    ],
    "accessioning": [
        "accession"
    ],
    "annoyed": [
        "annoy"
    ],
    "annoys": [
        "annoy"
    ],
    "annoying": [
        "annoy"
    ],
    "lenins": [
        "lenin"
    ],
    "lonelinesses": [
        "loneliness"
    ],
    "mohammeds": [
        "mohammed"
    ],
    "pecking": [
        "peck"
    ],
    "pecked": [
        "peck"
    ],
    "pecks": [
        "peck"
    ],
    "phosphating": [
        "phosphate"
    ],
    "refined": [
        "refine"
    ],
    "refining": [
        "refine"
    ],
    "refines": [
        "refine"
    ],
    "refrained": [
        "refrain"
    ],
    "refraining": [
        "refrain"
    ],
    "sparklings": [
        "sparkling"
    ],
    "stifled": [
        "stifle"
    ],
    "stifling": [
        "stifle"
    ],
    "stifles": [
        "stifle"
    ],
    "vented": [
        "vent"
    ],
    "venting": [
        "vent"
    ],
    "dissatisfactions": [
        "dissatisfaction"
    ],
    "grans": [
        "gran"
    ],
    "pastas": [
        "pasta"
    ],
    "prefaced": [
        "preface"
    ],
    "prefacing": [
        "preface"
    ],
    "proprietaries": [
        "proprietary"
    ],
    "somalias": [
        "somalia"
    ],
    "deducted": [
        "deduct"
    ],
    "deducting": [
        "deduct"
    ],
    "deducts": [
        "deduct"
    ],
    "flus": [
        "flu"
    ],
    "grated": [
        "grate"
    ],
    "grates": [
        "grate"
    ],
    "grating": [
        "grate"
    ],
    "novelties": [
        "novelty"
    ],
    "programmers": [
        "programmer"
    ],
    "toddlers": [
        "toddler"
    ],
    "arses": [
        "arse"
    ],
    "arsed": [
        "arse"
    ],
    "arsing": [
        "arse"
    ],
    "bureaucrats": [
        "bureaucrat"
    ],
    "discipling": [
        "disciple"
    ],
    "discipled": [
        "disciple"
    ],
    "occupiers": [
        "occupier"
    ],
    "unfolded": [
        "unfold"
    ],
    "unfolding": [
        "unfold"
    ],
    "unfolds": [
        "unfold"
    ],
    "vicinities": [
        "vicinity"
    ],
    "lebaneses": [
        "lebanese"
    ],
    "lyonss": [
        "lyons"
    ],
    "pastries": [
        "pastry"
    ],
    "pellets": [
        "pellet"
    ],
    "sherries": [
        "sherry"
    ],
    "tutorials": [
        "tutorial"
    ],
    "bedsides": [
        "bedside"
    ],
    "breadths": [
        "breadth"
    ],
    "dusks": [
        "dusk"
    ],
    "dusking": [
        "dusk"
    ],
    "dusked": [
        "dusk"
    ],
    "jamaicas": [
        "jamaica"
    ],
    "ripples": [
        "ripple"
    ],
    "rippled": [
        "ripple"
    ],
    "rippling": [
        "ripple"
    ],
    "validations": [
        "validation"
    ],
    "deduced": [
        "deduce"
    ],
    "deducing": [
        "deduce"
    ],
    "deduces": [
        "deduce"
    ],
    "elastics": [
        "elastic"
    ],
    "evacuated": [
        "evacuate"
    ],
    "evacuating": [
        "evacuate"
    ],
    "evacuates": [
        "evacuate"
    ],
    "fulfilments": [
        "fulfilment"
    ],
    "trebled": [
        "treble"
    ],
    "trebles": [
        "treble"
    ],
    "trebling": [
        "treble"
    ],
    "vaughans": [
        "vaughan"
    ],
    "flakes": [
        "flake"
    ],
    "flaking": [
        "flake"
    ],
    "flaked": [
        "flake"
    ],
    "furnishings": [
        "furnishing"
    ],
    "penguins": [
        "penguin"
    ],
    "boilings": [
        "boiling"
    ],
    "coatings": [
        "coating"
    ],
    "crumbled": [
        "crumble"
    ],
    "crumbling": [
        "crumble"
    ],
    "crumbles": [
        "crumble"
    ],
    "jellies": [
        "jelly"
    ],
    "jellied": [
        "jelly"
    ],
    "jellys": [
        "jelly"
    ],
    "noughts": [
        "nought"
    ],
    "ores": [
        "ore"
    ],
    "speedier": [
        "speedy"
    ],
    "speediest": [
        "speedy"
    ],
    "austins": [
        "austin"
    ],
    "cloughs": [
        "clough"
    ],
    "gutters": [
        "gutter"
    ],
    "guttered": [
        "gutter"
    ],
    "guttering": [
        "gutter"
    ],
    "luxembourgs": [
        "luxembourg"
    ],
    "midfielders": [
        "midfielder"
    ],
    "porking": [
        "pork"
    ],
    "scotss": [
        "scots"
    ],
    "sods": [
        "sod"
    ],
    "sodding": [
        "sod"
    ],
    "sodded": [
        "sod"
    ],
    "verified": [
        "verify"
    ],
    "verifying": [
        "verify"
    ],
    "coles": [
        "cole"
    ],
    "fatigued": [
        "fatigue"
    ],
    "fatiguing": [
        "fatigue"
    ],
    "frailer": [
        "frail"
    ],
    "frailest": [
        "frail"
    ],
    "frails": [
        "frail"
    ],
    "colourings": [
        "colouring"
    ],
    "saluted": [
        "salute"
    ],
    "salutes": [
        "salute"
    ],
    "saluting": [
        "salute"
    ],
    "teeing": [
        "tee"
    ],
    "teed": [
        "tee"
    ],
    "almonds": [
        "almond"
    ],
    "arteries": [
        "artery"
    ],
    "berkeleys": [
        "berkeley"
    ],
    "foremen": [
        "foreman"
    ],
    "foremans": [
        "foreman"
    ],
    "frankfurts": [
        "frankfurt"
    ],
    "lavished": [
        "lavish"
    ],
    "lavishing": [
        "lavish"
    ],
    "lavishes": [
        "lavish"
    ],
    "prosecutors": [
        "prosecutor"
    ],
    "timess": [
        "times"
    ],
    "cdnas": [
        "cdna"
    ],
    "commonplaces": [
        "commonplace"
    ],
    "crunched": [
        "crunch"
    ],
    "crunching": [
        "crunch"
    ],
    "crunches": [
        "crunch"
    ],
    "handwritings": [
        "handwriting"
    ],
    "parlours": [
        "parlour"
    ],
    "regulators": [
        "regulator"
    ],
    "anselms": [
        "anselm"
    ],
    "confided": [
        "confide"
    ],
    "confiding": [
        "confide"
    ],
    "confides": [
        "confide"
    ],
    "fungi": [
        "fungus"
    ],
    "funguses": [
        "fungus"
    ],
    "lagers": [
        "lager"
    ],
    "lagered": [
        "lager"
    ],
    "riddled": [
        "riddle"
    ],
    "riddles": [
        "riddle"
    ],
    "riddling": [
        "riddle"
    ],
    "vapours": [
        "vapour"
    ],
    "vapouring": [
        "vapour"
    ],
    "wavelengths": [
        "wavelength"
    ],
    "dined": [
        "dine"
    ],
    "dining": [
        "dine"
    ],
    "phoenixes": [
        "phoenix"
    ],
    "typewriters": [
        "typewriter"
    ],
    "wallpapers": [
        "wallpaper"
    ],
    "wallpapering": [
        "wallpaper"
    ],
    "wallpapered": [
        "wallpaper"
    ],
    "boredoms": [
        "boredom"
    ],
    "competitivenesses": [
        "competitiveness"
    ],
    "contouring": [
        "contour"
    ],
    "contoured": [
        "contour"
    ],
    "regs": [
        "reg"
    ],
    "incumbents": [
        "incumbent"
    ],
    "mahoganies": [
        "mahogany"
    ],
    "nancies": [
        "nancy"
    ],
    "operatives": [
        "operative"
    ],
    "paperbacks": [
        "paperback"
    ],
    "paperbacked": [
        "paperback"
    ],
    "collided": [
        "collide"
    ],
    "colliding": [
        "collide"
    ],
    "collides": [
        "collide"
    ],
    "hairdressers": [
        "hairdresser"
    ],
    "loosened": [
        "loosen"
    ],
    "loosening": [
        "loosen"
    ],
    "loosens": [
        "loosen"
    ],
    "registries": [
        "registry"
    ],
    "ricks": [
        "rick"
    ],
    "ricked": [
        "rick"
    ],
    "ricking": [
        "rick"
    ],
    "rouged": [
        "rouge"
    ],
    "rouging": [
        "rouge"
    ],
    "rougeing": [
        "rouge"
    ],
    "slums": [
        "slum"
    ],
    "slumming": [
        "slum"
    ],
    "slummed": [
        "slum"
    ],
    "aligned": [
        "align"
    ],
    "aligning": [
        "align"
    ],
    "aligns": [
        "align"
    ],
    "crescents": [
        "crescent"
    ],
    "harvards": [
        "harvard"
    ],
    "moroccos": [
        "morocco"
    ],
    "sculptors": [
        "sculptor"
    ],
    "convents": [
        "convent"
    ],
    "convented": [
        "convent"
    ],
    "diplomacies": [
        "diplomacy"
    ],
    "facials": [
        "facial"
    ],
    "flints": [
        "flint"
    ],
    "gems": [
        "gem"
    ],
    "montgomeries": [
        "montgomery"
    ],
    "perries": [
        "perry"
    ],
    "perried": [
        "perry"
    ],
    "sayings": [
        "saying"
    ],
    "sprinted": [
        "sprint"
    ],
    "sprinting": [
        "sprint"
    ],
    "vomiting": [
        "vomit"
    ],
    "vomited": [
        "vomit"
    ],
    "vomits": [
        "vomit"
    ],
    "crabbed": [
        "crab"
    ],
    "crabbing": [
        "crab"
    ],
    "elicited": [
        "elicit"
    ],
    "eliciting": [
        "elicit"
    ],
    "elicits": [
        "elicit"
    ],
    "empowered": [
        "empower"
    ],
    "empowers": [
        "empower"
    ],
    "empowering": [
        "empower"
    ],
    "implicated": [
        "implicate"
    ],
    "implicating": [
        "implicate"
    ],
    "implicates": [
        "implicate"
    ],
    "pleasings": [
        "pleasing"
    ],
    "seriousnesses": [
        "seriousness"
    ],
    "glossed": [
        "gloss"
    ],
    "glosses": [
        "gloss"
    ],
    "glossing": [
        "gloss"
    ],
    "infantries": [
        "infantry"
    ],
    "tormented": [
        "torment"
    ],
    "tormenting": [
        "torment"
    ],
    "torments": [
        "torment"
    ],
    "transportations": [
        "transportation"
    ],
    "baptists": [
        "baptist"
    ],
    "baselines": [
        "baseline"
    ],
    "baselining": [
        "baseline"
    ],
    "beetles": [
        "beetle"
    ],
    "beetling": [
        "beetle"
    ],
    "beetled": [
        "beetle"
    ],
    "imitating": [
        "imitate"
    ],
    "imitated": [
        "imitate"
    ],
    "imitates": [
        "imitate"
    ],
    "restructuring": [
        "restructure"
    ],
    "restructured": [
        "restructure"
    ],
    "restructures": [
        "restructure"
    ],
    "shiftings": [
        "shifting"
    ],
    "sprinkled": [
        "sprinkle"
    ],
    "sprinkling": [
        "sprinkle"
    ],
    "sprinkles": [
        "sprinkle"
    ],
    "ascents": [
        "ascent"
    ],
    "flipped": [
        "flip"
    ],
    "flipping": [
        "flip"
    ],
    "rhymes": [
        "rhyme"
    ],
    "rhyming": [
        "rhyme"
    ],
    "rhymed": [
        "rhyme"
    ],
    "seasides": [
        "seaside"
    ],
    "cias": [
        "cia"
    ],
    "clinched": [
        "clinch"
    ],
    "clinching": [
        "clinch"
    ],
    "clinches": [
        "clinch"
    ],
    "crags": [
        "crag"
    ],
    "cragging": [
        "crag"
    ],
    "freemen": [
        "freeman"
    ],
    "greenbelts": [
        "greenbelt"
    ],
    "honeymoons": [
        "honeymoon"
    ],
    "honeymooning": [
        "honeymoon"
    ],
    "honeymooned": [
        "honeymoon"
    ],
    "leicestershires": [
        "leicestershire"
    ],
    "lurched": [
        "lurch"
    ],
    "lurching": [
        "lurch"
    ],
    "lurches": [
        "lurch"
    ],
    "waltons": [
        "walton"
    ],
    "apprenticeships": [
        "apprenticeship"
    ],
    "electors": [
        "elector"
    ],
    "industrialists": [
        "industrialist"
    ],
    "terminations": [
        "termination"
    ],
    "comebacks": [
        "comeback"
    ],
    "coronaries": [
        "coronary"
    ],
    "highlandss": [
        "highlands"
    ],
    "rinsed": [
        "rinse"
    ],
    "rinsing": [
        "rinse"
    ],
    "rinses": [
        "rinse"
    ],
    "withstood": [
        "withstand"
    ],
    "withstanding": [
        "withstand"
    ],
    "withstands": [
        "withstand"
    ],
    "chestnuts": [
        "chestnut"
    ],
    "confederations": [
        "confederation"
    ],
    "pagans": [
        "pagan"
    ],
    "slacks": [
        "slack"
    ],
    "slacking": [
        "slack"
    ],
    "slacker": [
        "slack"
    ],
    "slackest": [
        "slack"
    ],
    "slacked": [
        "slack"
    ],
    "svqs": [
        "svq"
    ],
    "keynesians": [
        "keynesian"
    ],
    "privies": [
        "privy"
    ],
    "puppets": [
        "puppet"
    ],
    "scorers": [
        "scorer"
    ],
    "starvings": [
        "starving"
    ],
    "arithmetics": [
        "arithmetic"
    ],
    "bums": [
        "bum"
    ],
    "bumming": [
        "bum"
    ],
    "bummed": [
        "bum"
    ],
    "examiners": [
        "examiner"
    ],
    "kurdishes": [
        "kurdish"
    ],
    "remitted": [
        "remit"
    ],
    "remits": [
        "remit"
    ],
    "remitting": [
        "remit"
    ],
    "temporals": [
        "temporal"
    ],
    "wailed": [
        "wail"
    ],
    "wailing": [
        "wail"
    ],
    "wails": [
        "wail"
    ],
    "barrows": [
        "barrow"
    ],
    "barrowed": [
        "barrow"
    ],
    "barrowing": [
        "barrow"
    ],
    "edgars": [
        "edgar"
    ],
    "sharks": [
        "shark"
    ],
    "sharking": [
        "shark"
    ],
    "sharked": [
        "shark"
    ],
    "strata": [
        "stratum"
    ],
    "alleviated": [
        "alleviate"
    ],
    "alleviating": [
        "alleviate"
    ],
    "alleviates": [
        "alleviate"
    ],
    "derelicts": [
        "derelict"
    ],
    "jesses": [
        "jess"
    ],
    "libyans": [
        "libyan"
    ],
    "moister": [
        "moist"
    ],
    "moistest": [
        "moist"
    ],
    "cots": [
        "cot"
    ],
    "dummies": [
        "dummy"
    ],
    "dummied": [
        "dummy"
    ],
    "dummying": [
        "dummy"
    ],
    "dummys": [
        "dummy"
    ],
    "settlers": [
        "settler"
    ],
    "williss": [
        "willis"
    ],
    "convergences": [
        "convergence"
    ],
    "creeds": [
        "creed"
    ],
    "gliding": [
        "glide"
    ],
    "glided": [
        "glide"
    ],
    "glides": [
        "glide"
    ],
    "lockes": [
        "locke"
    ],
    "mamas": [
        "mama"
    ],
    "octs": [
        "oct"
    ],
    "planks": [
        "plank"
    ],
    "planked": [
        "plank"
    ],
    "planking": [
        "plank"
    ],
    "thorntons": [
        "thornton"
    ],
    "vulnerabilities": [
        "vulnerability"
    ],
    "aquitaines": [
        "aquitaine"
    ],
    "ascribed": [
        "ascribe"
    ],
    "ascribing": [
        "ascribe"
    ],
    "ascribes": [
        "ascribe"
    ],
    "colombias": [
        "colombia"
    ],
    "kinships": [
        "kinship"
    ],
    "misters": [
        "mister"
    ],
    "physicists": [
        "physicist"
    ],
    "sharpened": [
        "sharpen"
    ],
    "sharpening": [
        "sharpen"
    ],
    "sharpens": [
        "sharpen"
    ],
    "shinings": [
        "shining"
    ],
    "vineyards": [
        "vineyard"
    ],
    "authorized": [
        "authorize"
    ],
    "authorizing": [
        "authorize"
    ],
    "authorizes": [
        "authorize"
    ],
    "averted": [
        "avert"
    ],
    "averting": [
        "avert"
    ],
    "averts": [
        "avert"
    ],
    "disgraced": [
        "disgrace"
    ],
    "disgracing": [
        "disgrace"
    ],
    "housekeepers": [
        "housekeeper"
    ],
    "joned": [
        "jon"
    ],
    "leons": [
        "leon"
    ],
    "monsieurs": [
        "monsieur"
    ],
    "applauded": [
        "applaud"
    ],
    "applauding": [
        "applaud"
    ],
    "applauds": [
        "applaud"
    ],
    "pantss": [
        "pants"
    ],
    "millionaires": [
        "millionaire"
    ],
    "reconsidered": [
        "reconsider"
    ],
    "reconsidering": [
        "reconsider"
    ],
    "reconsiders": [
        "reconsider"
    ],
    "testified": [
        "testify"
    ],
    "testifies": [
        "testify"
    ],
    "testifying": [
        "testify"
    ],
    "whereaboutss": [
        "whereabouts"
    ],
    "beijings": [
        "beijing"
    ],
    "clowning": [
        "clown"
    ],
    "clowned": [
        "clown"
    ],
    "gulls": [
        "gull"
    ],
    "gulled": [
        "gull"
    ],
    "gums": [
        "gum"
    ],
    "gummed": [
        "gum"
    ],
    "gumming": [
        "gum"
    ],
    "insolvencies": [
        "insolvency"
    ],
    "merrier": [
        "merry"
    ],
    "merriest": [
        "merry"
    ],
    "applauses": [
        "applause"
    ],
    "beths": [
        "beth"
    ],
    "chaplains": [
        "chaplain"
    ],
    "startled": [
        "startle"
    ],
    "startling": [
        "startle"
    ],
    "startles": [
        "startle"
    ],
    "coachings": [
        "coaching"
    ],
    "cricketers": [
        "cricketer"
    ],
    "desperations": [
        "desperation"
    ],
    "judiciaries": [
        "judiciary"
    ],
    "neutralities": [
        "neutrality"
    ],
    "normandies": [
        "normandy"
    ],
    "pilgrimages": [
        "pilgrimage"
    ],
    "purports": [
        "purport"
    ],
    "purporting": [
        "purport"
    ],
    "purported": [
        "purport"
    ],
    "reuters": [
        "reuter"
    ],
    "roaming": [
        "roam"
    ],
    "roamed": [
        "roam"
    ],
    "roams": [
        "roam"
    ],
    "shrieked": [
        "shriek"
    ],
    "shrieking": [
        "shriek"
    ],
    "shrieks": [
        "shriek"
    ],
    "snails": [
        "snail"
    ],
    "aprons": [
        "apron"
    ],
    "archaeologists": [
        "archaeologist"
    ],
    "canoeing": [
        "canoe"
    ],
    "canoed": [
        "canoe"
    ],
    "churchyards": [
        "churchyard"
    ],
    "collieries": [
        "colliery"
    ],
    "pebbles": [
        "pebble"
    ],
    "benedicts": [
        "benedict"
    ],
    "conjured": [
        "conjure"
    ],
    "conjuring": [
        "conjure"
    ],
    "facets": [
        "facet"
    ],
    "fivers": [
        "fiver"
    ],
    "laundries": [
        "laundry"
    ],
    "mopped": [
        "mop"
    ],
    "mopping": [
        "mop"
    ],
    "mops": [
        "mop"
    ],
    "novs": [
        "nov"
    ],
    "overseeing": [
        "oversee"
    ],
    "oversees": [
        "oversee"
    ],
    "oversaw": [
        "oversee"
    ],
    "overseen": [
        "oversee"
    ],
    "remnants": [
        "remnant"
    ],
    "snorted": [
        "snort"
    ],
    "snorting": [
        "snort"
    ],
    "snorts": [
        "snort"
    ],
    "spotlights": [
        "spotlight"
    ],
    "spotlighting": [
        "spotlight"
    ],
    "spotlighted": [
        "spotlight"
    ],
    "talbots": [
        "talbot"
    ],
    "daytimes": [
        "daytime"
    ],
    "disneys": [
        "disney"
    ],
    "rankings": [
        "ranking"
    ],
    "carbohydrates": [
        "carbohydrate"
    ],
    "cavities": [
        "cavity"
    ],
    "conglomerates": [
        "conglomerate"
    ],
    "conglomerating": [
        "conglomerate"
    ],
    "floppies": [
        "floppy"
    ],
    "floppier": [
        "floppy"
    ],
    "floppiest": [
        "floppy"
    ],
    "repealed": [
        "repeal"
    ],
    "repealing": [
        "repeal"
    ],
    "repeals": [
        "repeal"
    ],
    "repealling": [
        "repeal"
    ],
    "rifts": [
        "rift"
    ],
    "rifting": [
        "rift"
    ],
    "rifted": [
        "rift"
    ],
    "anguishing": [
        "anguish"
    ],
    "anguishes": [
        "anguish"
    ],
    "anguished": [
        "anguish"
    ],
    "consolidations": [
        "consolidation"
    ],
    "fluxes": [
        "flux"
    ],
    "fluxed": [
        "flux"
    ],
    "fluxing": [
        "flux"
    ],
    "accrued": [
        "accrue"
    ],
    "accruing": [
        "accrue"
    ],
    "athleticss": [
        "athletics"
    ],
    "feats": [
        "feat"
    ],
    "gulped": [
        "gulp"
    ],
    "gulping": [
        "gulp"
    ],
    "gulps": [
        "gulp"
    ],
    "hitched": [
        "hitch"
    ],
    "hitching": [
        "hitch"
    ],
    "hitches": [
        "hitch"
    ],
    "peacocks": [
        "peacock"
    ],
    "peacocking": [
        "peacock"
    ],
    "quays": [
        "quay"
    ],
    "redressed": [
        "redress"
    ],
    "redressing": [
        "redress"
    ],
    "shuttles": [
        "shuttle"
    ],
    "shuttling": [
        "shuttle"
    ],
    "shuttled": [
        "shuttle"
    ],
    "turmoils": [
        "turmoil"
    ],
    "turmoiled": [
        "turmoil"
    ],
    "yawned": [
        "yawn"
    ],
    "yawning": [
        "yawn"
    ],
    "yawns": [
        "yawn"
    ],
    "battered": [
        "batter"
    ],
    "battering": [
        "batter"
    ],
    "batters": [
        "batter"
    ],
    "consoled": [
        "console"
    ],
    "consoling": [
        "console"
    ],
    "dodging": [
        "dodge"
    ],
    "dodged": [
        "dodge"
    ],
    "dodges": [
        "dodge"
    ],
    "nutties": [
        "nutty"
    ],
    "nuttier": [
        "nutty"
    ],
    "nuttiest": [
        "nutty"
    ],
    "presumptions": [
        "presumption"
    ],
    "vigours": [
        "vigour"
    ],
    "alignments": [
        "alignment"
    ],
    "coastlines": [
        "coastline"
    ],
    "condoms": [
        "condom"
    ],
    "decimals": [
        "decimal"
    ],
    "harlows": [
        "harlow"
    ],
    "leukaemias": [
        "leukaemia"
    ],
    "shears": [
        "shear"
    ],
    "shorn": [
        "shear"
    ],
    "shearing": [
        "shear"
    ],
    "sheared": [
        "shear"
    ],
    "crooks": [
        "crook"
    ],
    "crooked": [
        "crook"
    ],
    "crooking": [
        "crook"
    ],
    "discreetest": [
        "discreet"
    ],
    "hopkinss": [
        "hopkins"
    ],
    "moths": [
        "moth"
    ],
    "qcs": [
        "qc"
    ],
    "uraniums": [
        "uranium"
    ],
    "workloads": [
        "workload"
    ],
    "boulders": [
        "boulder"
    ],
    "bouldering": [
        "boulder"
    ],
    "dented": [
        "dent"
    ],
    "denting": [
        "dent"
    ],
    "gritted": [
        "grit"
    ],
    "gritting": [
        "grit"
    ],
    "grits": [
        "grit"
    ],
    "jogged": [
        "jog"
    ],
    "jogs": [
        "jog"
    ],
    "northamptonshires": [
        "northamptonshire"
    ],
    "swooped": [
        "swoop"
    ],
    "swooping": [
        "swoop"
    ],
    "swoops": [
        "swoop"
    ],
    "townships": [
        "township"
    ],
    "abdominals": [
        "abdominal"
    ],
    "excited": [
        "excite"
    ],
    "exciting": [
        "excite"
    ],
    "perths": [
        "perth"
    ],
    "specificities": [
        "specificity"
    ],
    "stinks": [
        "stink"
    ],
    "stinking": [
        "stink"
    ],
    "stank": [
        "stink"
    ],
    "stunk": [
        "stink"
    ],
    "succumbed": [
        "succumb"
    ],
    "succumbing": [
        "succumb"
    ],
    "succumbs": [
        "succumb"
    ],
    "tangled": [
        "tangle"
    ],
    "tangles": [
        "tangle"
    ],
    "tangling": [
        "tangle"
    ],
    "anals": [
        "anal"
    ],
    "awed": [
        "awe"
    ],
    "awes": [
        "awe"
    ],
    "catalysts": [
        "catalyst"
    ],
    "ferreting": [
        "ferret"
    ],
    "ferreted": [
        "ferret"
    ],
    "helpings": [
        "helping"
    ],
    "misled": [
        "mislead"
    ],
    "misleading": [
        "mislead"
    ],
    "misleads": [
        "mislead"
    ],
    "parsonss": [
        "parsons"
    ],
    "plateaus": [
        "plateau"
    ],
    "venuss": [
        "venus"
    ],
    "clenched": [
        "clench"
    ],
    "clenching": [
        "clench"
    ],
    "lucass": [
        "lucas"
    ],
    "prolonged": [
        "prolong"
    ],
    "prolonging": [
        "prolong"
    ],
    "prolongs": [
        "prolong"
    ],
    "reciprocals": [
        "reciprocal"
    ],
    "refinements": [
        "refinement"
    ],
    "transcripts": [
        "transcript"
    ],
    "cubans": [
        "cuban"
    ],
    "flemings": [
        "fleming"
    ],
    "swirling": [
        "swirl"
    ],
    "swirled": [
        "swirl"
    ],
    "swirls": [
        "swirl"
    ],
    "thrashed": [
        "thrash"
    ],
    "thrashing": [
        "thrash"
    ],
    "thrashes": [
        "thrash"
    ],
    "wares": [
        "ware"
    ],
    "waring": [
        "ware"
    ],
    "binocular": [
        "binoculars"
    ],
    "infirmaries": [
        "infirmary"
    ],
    "longings": [
        "longing"
    ],
    "lusts": [
        "lust"
    ],
    "lusted": [
        "lust"
    ],
    "lusting": [
        "lust"
    ],
    "switchings": [
        "switching"
    ],
    "trumpets": [
        "trumpet"
    ],
    "trumpeting": [
        "trumpet"
    ],
    "trumpeted": [
        "trumpet"
    ],
    "advancements": [
        "advancement"
    ],
    "burmas": [
        "burma"
    ],
    "centenaries": [
        "centenary"
    ],
    "evaded": [
        "evade"
    ],
    "evading": [
        "evade"
    ],
    "aristocracies": [
        "aristocracy"
    ],
    "cavalries": [
        "cavalry"
    ],
    "homelands": [
        "homeland"
    ],
    "intercepted": [
        "intercept"
    ],
    "intercepting": [
        "intercept"
    ],
    "intercepts": [
        "intercept"
    ],
    "minimized": [
        "minimize"
    ],
    "minimizing": [
        "minimize"
    ],
    "minimizes": [
        "minimize"
    ],
    "nans": [
        "nan"
    ],
    "nanning": [
        "nan"
    ],
    "pilgrims": [
        "pilgrim"
    ],
    "potencies": [
        "potency"
    ],
    "commuters": [
        "commuter"
    ],
    "entrusted": [
        "entrust"
    ],
    "entrusting": [
        "entrust"
    ],
    "entrusts": [
        "entrust"
    ],
    "flaws": [
        "flaw"
    ],
    "grazings": [
        "grazing"
    ],
    "seizures": [
        "seizure"
    ],
    "tamed": [
        "tame"
    ],
    "taming": [
        "tame"
    ],
    "tamer": [
        "tame"
    ],
    "tames": [
        "tame"
    ],
    "tamest": [
        "tame"
    ],
    "wirelesses": [
        "wireless"
    ],
    "wirelessed": [
        "wireless"
    ],
    "breeders": [
        "breeder"
    ],
    "familiarities": [
        "familiarity"
    ],
    "jargoning": [
        "jargon"
    ],
    "mappings": [
        "mapping"
    ],
    "stipulated": [
        "stipulate"
    ],
    "stipulates": [
        "stipulate"
    ],
    "stipulating": [
        "stipulate"
    ],
    "cohorts": [
        "cohort"
    ],
    "cohorting": [
        "cohort"
    ],
    "deferred": [
        "defer"
    ],
    "deferring": [
        "defer"
    ],
    "defers": [
        "defer"
    ],
    "feedings": [
        "feeding"
    ],
    "indicatives": [
        "indicative"
    ],
    "intricating": [
        "intricate"
    ],
    "warners": [
        "warner"
    ],
    "evangelicals": [
        "evangelical"
    ],
    "forensics": [
        "forensic"
    ],
    "hebrews": [
        "hebrew"
    ],
    "incomings": [
        "incoming"
    ],
    "kgs": [
        "kg"
    ],
    "mortimers": [
        "mortimer"
    ],
    "worcestershires": [
        "worcestershire"
    ],
    "aspired": [
        "aspire"
    ],
    "aspiring": [
        "aspire"
    ],
    "dangling": [
        "dangle"
    ],
    "dangled": [
        "dangle"
    ],
    "dangles": [
        "dangle"
    ],
    "peasantries": [
        "peasantry"
    ],
    "pretences": [
        "pretence"
    ],
    "rectors": [
        "rector"
    ],
    "woollens": [
        "woollen"
    ],
    "efficacies": [
        "efficacy"
    ],
    "flexed": [
        "flex"
    ],
    "flexing": [
        "flex"
    ],
    "flexes": [
        "flex"
    ],
    "treks": [
        "trek"
    ],
    "trekked": [
        "trek"
    ],
    "wrenched": [
        "wrench"
    ],
    "wrenching": [
        "wrench"
    ],
    "wrenches": [
        "wrench"
    ],
    "hugoes": [
        "hugo"
    ],
    "moonlighting": [
        "moonlight"
    ],
    "moonlights": [
        "moonlight"
    ],
    "moonlighted": [
        "moonlight"
    ],
    "ounces": [
        "ounce"
    ],
    "peaches": [
        "peach"
    ],
    "refunded": [
        "refund"
    ],
    "refunds": [
        "refund"
    ],
    "refunding": [
        "refund"
    ],
    "rhodess": [
        "rhodes"
    ],
    "shortened": [
        "shorten"
    ],
    "shortening": [
        "shorten"
    ],
    "shortens": [
        "shorten"
    ],
    "astonishments": [
        "astonishment"
    ],
    "broadcasters": [
        "broadcaster"
    ],
    "mustards": [
        "mustard"
    ],
    "mustarded": [
        "mustard"
    ],
    "mustard": [
        "mustard"
    ],
    "rumbled": [
        "rumble"
    ],
    "rumbling": [
        "rumble"
    ],
    "rumbles": [
        "rumble"
    ],
    "scorned": [
        "scorn"
    ],
    "scorning": [
        "scorn"
    ],
    "scorns": [
        "scorn"
    ],
    "freezers": [
        "freezer"
    ],
    "kirks": [
        "kirk"
    ],
    "literals": [
        "literal"
    ],
    "petersburgs": [
        "petersburg"
    ],
    "plasmids": [
        "plasmid"
    ],
    "umpires": [
        "umpire"
    ],
    "umpiring": [
        "umpire"
    ],
    "umpired": [
        "umpire"
    ],
    "manns": [
        "mann"
    ],
    "unluckiest": [
        "unlucky"
    ],
    "unluckier": [
        "unlucky"
    ],
    "albanians": [
        "albanian"
    ],
    "diffused": [
        "diffuse"
    ],
    "diffusing": [
        "diffuse"
    ],
    "ees": [
        "ee"
    ],
    "etceteras": [
        "etcetera"
    ],
    "fireworks": [
        "firework"
    ],
    "friars": [
        "friar"
    ],
    "grumbled": [
        "grumble"
    ],
    "grumbling": [
        "grumble"
    ],
    "grumbles": [
        "grumble"
    ],
    "intrigued": [
        "intrigue"
    ],
    "intriguing": [
        "intrigue"
    ],
    "parrots": [
        "parrot"
    ],
    "parroting": [
        "parrot"
    ],
    "parroted": [
        "parrot"
    ],
    "thinkers": [
        "thinker"
    ],
    "contaminated": [
        "contaminate"
    ],
    "contaminating": [
        "contaminate"
    ],
    "contaminates": [
        "contaminate"
    ],
    "quantified": [
        "quantify"
    ],
    "quantifying": [
        "quantify"
    ],
    "quantifies": [
        "quantify"
    ],
    "tabs": [
        "tab"
    ],
    "tabbed": [
        "tab"
    ],
    "tabbing": [
        "tab"
    ],
    "usefulnesses": [
        "usefulness"
    ],
    "clumps": [
        "clump"
    ],
    "clumped": [
        "clump"
    ],
    "clumping": [
        "clump"
    ],
    "fertilisers": [
        "fertiliser"
    ],
    "frictioned": [
        "friction"
    ],
    "functionings": [
        "functioning"
    ],
    "linkages": [
        "linkage"
    ],
    "promotionals": [
        "promotional"
    ],
    "willows": [
        "willow"
    ],
    "willowing": [
        "willow"
    ],
    "bandaged": [
        "bandage"
    ],
    "bandaging": [
        "bandage"
    ],
    "dens": [
        "den"
    ],
    "eclipsed": [
        "eclipse"
    ],
    "eclipsing": [
        "eclipse"
    ],
    "enlisted": [
        "enlist"
    ],
    "enlisting": [
        "enlist"
    ],
    "enlists": [
        "enlist"
    ],
    "middays": [
        "midday"
    ],
    "nostrils": [
        "nostril"
    ],
    "nostrilling": [
        "nostril"
    ],
    "rochesters": [
        "rochester"
    ],
    "depreciations": [
        "depreciation"
    ],
    "digits": [
        "digit"
    ],
    "enlightenments": [
        "enlightenment"
    ],
    "martyred": [
        "martyr"
    ],
    "martyring": [
        "martyr"
    ],
    "martyr's": [
        "martyr"
    ],
    "previews": [
        "preview"
    ],
    "previewed": [
        "preview"
    ],
    "previewing": [
        "preview"
    ],
    "shortfalls": [
        "shortfall"
    ],
    "spawned": [
        "spawn"
    ],
    "spawning": [
        "spawn"
    ],
    "spawns": [
        "spawn"
    ],
    "nudes": [
        "nude"
    ],
    "nuder": [
        "nude"
    ],
    "o'briens": [
        "o'brien"
    ],
    "outweighed": [
        "outweigh"
    ],
    "outweighs": [
        "outweigh"
    ],
    "outweighing": [
        "outweigh"
    ],
    "augmented": [
        "augment"
    ],
    "augmenting": [
        "augment"
    ],
    "augments": [
        "augment"
    ],
    "cascading": [
        "cascade"
    ],
    "cascaded": [
        "cascade"
    ],
    "edwardians": [
        "edwardian"
    ],
    "flopped": [
        "flop"
    ],
    "flopping": [
        "flop"
    ],
    "insps": [
        "insp"
    ],
    "bachelors": [
        "bachelor"
    ],
    "betrayals": [
        "betrayal"
    ],
    "charcoals": [
        "charcoal"
    ],
    "charcoaled": [
        "charcoal"
    ],
    "charcoaling": [
        "charcoal"
    ],
    "harpers": [
        "harper"
    ],
    "nutritions": [
        "nutrition"
    ],
    "reclaimed": [
        "reclaim"
    ],
    "reclaiming": [
        "reclaim"
    ],
    "reclaims": [
        "reclaim"
    ],
    "reopened": [
        "reopen"
    ],
    "reopens": [
        "reopen"
    ],
    "reopening": [
        "reopen"
    ],
    "utmosts": [
        "utmost"
    ],
    "adored": [
        "adore"
    ],
    "adoring": [
        "adore"
    ],
    "countesses": [
        "countess"
    ],
    "croatians": [
        "croatian"
    ],
    "lenses": [
        "lense"
    ],
    "lensing": [
        "lense"
    ],
    "lensed": [
        "lense"
    ],
    "rhythmics": [
        "rhythmic"
    ],
    "severed": [
        "sever"
    ],
    "severing": [
        "sever"
    ],
    "severs": [
        "sever"
    ],
    "unloaded": [
        "unload"
    ],
    "unloading": [
        "unload"
    ],
    "unloads": [
        "unload"
    ],
    "algerias": [
        "algeria"
    ],
    "authoritarians": [
        "authoritarian"
    ],
    "banished": [
        "banish"
    ],
    "banishing": [
        "banish"
    ],
    "banishes": [
        "banish"
    ],
    "brisker": [
        "brisk"
    ],
    "briskest": [
        "brisk"
    ],
    "brisking": [
        "brisk"
    ],
    "direst": [
        "dire"
    ],
    "direr": [
        "dire"
    ],
    "disapprovals": [
        "disapproval"
    ],
    "lowlands": [
        "lowland"
    ],
    "martialled": [
        "martial"
    ],
    "martials": [
        "martial"
    ],
    "nurtured": [
        "nurture"
    ],
    "nurturing": [
        "nurture"
    ],
    "nurtures": [
        "nurture"
    ],
    "tubbing": [
        "tub"
    ],
    "tubbed": [
        "tub"
    ],
    "camels": [
        "camel"
    ],
    "foundings": [
        "founding"
    ],
    "inconvenienced": [
        "inconvenience"
    ],
    "inconveniences": [
        "inconvenience"
    ],
    "inconveniencing": [
        "inconvenience"
    ],
    "kgbs": [
        "kgb"
    ],
    "liberalisms": [
        "liberalism"
    ],
    "mazes": [
        "maze"
    ],
    "mazed": [
        "maze"
    ],
    "mazing": [
        "maze"
    ],
    "psychics": [
        "psychic"
    ],
    "scotsmen": [
        "scotsman"
    ],
    "shutters": [
        "shutter"
    ],
    "shuttering": [
        "shutter"
    ],
    "ambers": [
        "amber"
    ],
    "clattered": [
        "clatter"
    ],
    "clattering": [
        "clatter"
    ],
    "clatters": [
        "clatter"
    ],
    "tudors": [
        "tudor"
    ],
    "upholding": [
        "uphold"
    ],
    "upholds": [
        "uphold"
    ],
    "upheld": [
        "uphold"
    ],
    "wowing": [
        "wow"
    ],
    "wowed": [
        "wow"
    ],
    "wows": [
        "wow"
    ],
    "carcinomas": [
        "carcinoma"
    ],
    "fluted": [
        "flute"
    ],
    "fluting": [
        "flute"
    ],
    "manslaughters": [
        "manslaughter"
    ],
    "nipped": [
        "nip"
    ],
    "nipping": [
        "nip"
    ],
    "nips": [
        "nip"
    ],
    "semiconductors": [
        "semiconductor"
    ],
    "villains": [
        "villain"
    ],
    "cuckoos": [
        "cuckoo"
    ],
    "pakistanis": [
        "pakistani"
    ],
    "professionalisms": [
        "professionalism"
    ],
    "salvaged": [
        "salvage"
    ],
    "salvaging": [
        "salvage"
    ],
    "salvages": [
        "salvage"
    ],
    "alighted": [
        "alight"
    ],
    "alighting": [
        "alight"
    ],
    "alights": [
        "alight"
    ],
    "alit": [
        "alight"
    ],
    "antarctics": [
        "antarctic"
    ],
    "cyclings": [
        "cycling"
    ],
    "gcses": [
        "gcse"
    ],
    "jubilees": [
        "jubilee"
    ],
    "misunderstood": [
        "misunderstand"
    ],
    "misunderstanding": [
        "misunderstand"
    ],
    "misunderstands": [
        "misunderstand"
    ],
    "twigs": [
        "twig"
    ],
    "twigged": [
        "twig"
    ],
    "twigging": [
        "twig"
    ],
    "advertisers": [
        "advertiser"
    ],
    "irrationals": [
        "irrational"
    ],
    "mustered": [
        "muster"
    ],
    "mustering": [
        "muster"
    ],
    "musters": [
        "muster"
    ],
    "policyholders": [
        "policyholder"
    ],
    "triumphants": [
        "triumphant"
    ],
    "bridgets": [
        "bridget"
    ],
    "cumbrias": [
        "cumbria"
    ],
    "enriched": [
        "enrich"
    ],
    "enriching": [
        "enrich"
    ],
    "enriches": [
        "enrich"
    ],
    "evaporated": [
        "evaporate"
    ],
    "evaporates": [
        "evaporate"
    ],
    "evaporating": [
        "evaporate"
    ],
    "fretted": [
        "fret"
    ],
    "fretting": [
        "fret"
    ],
    "lavenders": [
        "lavender"
    ],
    "brewings": [
        "brewing"
    ],
    "enrolled": [
        "enrol"
    ],
    "enrolling": [
        "enrol"
    ],
    "enrols": [
        "enrol"
    ],
    "forefronts": [
        "forefront"
    ],
    "metabolisms": [
        "metabolism"
    ],
    "sneaked": [
        "sneak"
    ],
    "sneaking": [
        "sneak"
    ],
    "sneaks": [
        "sneak"
    ],
    "apologized": [
        "apologize"
    ],
    "apologizing": [
        "apologize"
    ],
    "apologizes": [
        "apologize"
    ],
    "beatings": [
        "beating"
    ],
    "chs": [
        "ch"
    ],
    "ches": [
        "ch"
    ],
    "comedians": [
        "comedian"
    ],
    "grandmas": [
        "grandma"
    ],
    "perpetuals": [
        "perpetual"
    ],
    "rashes": [
        "rash"
    ],
    "relinquished": [
        "relinquish"
    ],
    "relinquishing": [
        "relinquish"
    ],
    "relinquishes": [
        "relinquish"
    ],
    "revolves": [
        "revolve"
    ],
    "revolved": [
        "revolve"
    ],
    "revolving": [
        "revolve"
    ],
    "shopkeepers": [
        "shopkeeper"
    ],
    "upsides": [
        "upside"
    ],
    "cfcs": [
        "cfc"
    ],
    "foes": [
        "fo",
        "foe"
    ],
    "humanitarians": [
        "humanitarian"
    ],
    "lessened": [
        "lessen"
    ],
    "lessening": [
        "lessen"
    ],
    "lessens": [
        "lessen"
    ],
    "negotiators": [
        "negotiator"
    ],
    "paperworks": [
        "paperwork"
    ],
    "purged": [
        "purge"
    ],
    "purging": [
        "purge"
    ],
    "refluxed": [
        "reflux"
    ],
    "validated": [
        "validate"
    ],
    "validating": [
        "validate"
    ],
    "validates": [
        "validate"
    ],
    "weavings": [
        "weaving"
    ],
    "beeches": [
        "beech"
    ],
    "carsons": [
        "carson"
    ],
    "cocoas": [
        "cocoa"
    ],
    "floodings": [
        "flooding"
    ],
    "heavyweights": [
        "heavyweight"
    ],
    "recounted": [
        "recount"
    ],
    "recounts": [
        "recount"
    ],
    "recounting": [
        "recount"
    ],
    "slicked": [
        "slick"
    ],
    "slicks": [
        "slick"
    ],
    "slicker": [
        "slick"
    ],
    "slicking": [
        "slick"
    ],
    "slickest": [
        "slick"
    ],
    "tbsps": [
        "tbsp"
    ],
    "emulated": [
        "emulate"
    ],
    "emulating": [
        "emulate"
    ],
    "emulates": [
        "emulate"
    ],
    "madeiras": [
        "madeira"
    ],
    "molars": [
        "molar"
    ],
    "o'neills": [
        "o'neill"
    ],
    "reaping": [
        "reap"
    ],
    "reaped": [
        "reap"
    ],
    "reaps": [
        "reap"
    ],
    "sprouts": [
        "sprout"
    ],
    "sprouted": [
        "sprout"
    ],
    "sprouting": [
        "sprout"
    ],
    "abandonments": [
        "abandonment"
    ],
    "greeds": [
        "greed"
    ],
    "nomes": [
        "nome"
    ],
    "biologists": [
        "biologist"
    ],
    "cowboys": [
        "cowboy"
    ],
    "hypotheticals": [
        "hypothetical"
    ],
    "mucking": [
        "muck"
    ],
    "mucked": [
        "muck"
    ],
    "mucks": [
        "muck"
    ],
    "straits": [
        "strait"
    ],
    "webers": [
        "weber"
    ],
    "arrogances": [
        "arrogance"
    ],
    "emanating": [
        "emanate"
    ],
    "emanated": [
        "emanate"
    ],
    "emanates": [
        "emanate"
    ],
    "petals": [
        "petal"
    ],
    "petalling": [
        "petal"
    ],
    "petalled": [
        "petal"
    ],
    "prudenter": [
        "prudent"
    ],
    "scandinavians": [
        "scandinavian"
    ],
    "skinners": [
        "skinner"
    ],
    "stooped": [
        "stoop"
    ],
    "stooping": [
        "stoop"
    ],
    "stoops": [
        "stoop"
    ],
    "unseens": [
        "unseen"
    ],
    "wagners": [
        "wagner"
    ],
    "bangladeshes": [
        "bangladesh"
    ],
    "redeemed": [
        "redeem"
    ],
    "redeeming": [
        "redeem"
    ],
    "redeems": [
        "redeem"
    ],
    "convened": [
        "convene"
    ],
    "convenes": [
        "convene"
    ],
    "convening": [
        "convene"
    ],
    "ledges": [
        "ledge"
    ],
    "ledged": [
        "ledge"
    ],
    "protesters": [
        "protester"
    ],
    "recourses": [
        "recourse"
    ],
    "snarled": [
        "snarl"
    ],
    "snarling": [
        "snarl"
    ],
    "snarls": [
        "snarl"
    ],
    "whirled": [
        "whirl"
    ],
    "whirling": [
        "whirl"
    ],
    "whirls": [
        "whirl"
    ],
    "blackmailed": [
        "blackmail"
    ],
    "blackmailing": [
        "blackmail"
    ],
    "blackmails": [
        "blackmail"
    ],
    "clarifications": [
        "clarification"
    ],
    "crossroadss": [
        "crossroads"
    ],
    "exhaustions": [
        "exhaustion"
    ],
    "nostalgias": [
        "nostalgia"
    ],
    "racketing": [
        "racket"
    ],
    "racketed": [
        "racket"
    ],
    "shortcomings": [
        "shortcoming"
    ],
    "snookered": [
        "snooker"
    ],
    "snookers": [
        "snooker"
    ],
    "snookering": [
        "snooker"
    ],
    "staples": [
        "staple"
    ],
    "stapled": [
        "staple"
    ],
    "stapling": [
        "staple"
    ],
    "windscreens": [
        "windscreen"
    ],
    "cartridges": [
        "cartridge"
    ],
    "discerned": [
        "discern"
    ],
    "discerns": [
        "discern"
    ],
    "discerning": [
        "discern"
    ],
    "esteemed": [
        "esteem"
    ],
    "esteems": [
        "esteem"
    ],
    "esteeming": [
        "esteem"
    ],
    "flattered": [
        "flatter"
    ],
    "flattering": [
        "flatter"
    ],
    "flatters": [
        "flatter"
    ],
    "glamours": [
        "glamour"
    ],
    "inquired": [
        "inquire"
    ],
    "inquiring": [
        "inquire"
    ],
    "inquires": [
        "inquire"
    ],
    "visibilities": [
        "visibility"
    ],
    "aas": [
        "aa"
    ],
    "arabics": [
        "arabic"
    ],
    "bashing": [
        "bash"
    ],
    "bashed": [
        "bash"
    ],
    "bashes": [
        "bash"
    ],
    "coverings": [
        "covering"
    ],
    "dudleys": [
        "dudley"
    ],
    "gorged": [
        "gorge"
    ],
    "gorging": [
        "gorge"
    ],
    "outbursts": [
        "outburst"
    ],
    "prospered": [
        "prosper"
    ],
    "prospering": [
        "prosper"
    ],
    "prospers": [
        "prosper"
    ],
    "specialized": [
        "specialize"
    ],
    "specializing": [
        "specialize"
    ],
    "specializes": [
        "specialize"
    ],
    "teens": [
        "teen"
    ],
    "ashtons": [
        "ashton"
    ],
    "cams": [
        "cam"
    ],
    "cammed": [
        "cam"
    ],
    "contractings": [
        "contracting"
    ],
    "diced": [
        "dice"
    ],
    "dicing": [
        "dice"
    ],
    "dices": [
        "dice"
    ],
    "relegations": [
        "relegation"
    ],
    "sturdier": [
        "sturdy"
    ],
    "sturdiest": [
        "sturdy"
    ],
    "troughs": [
        "trough"
    ],
    "troughed": [
        "trough"
    ],
    "troughing": [
        "trough"
    ],
    "amused": [
        "amuse"
    ],
    "amusing": [
        "amuse"
    ],
    "cabbages": [
        "cabbage"
    ],
    "carvings": [
        "carving"
    ],
    "goodies": [
        "goody"
    ],
    "meshes": [
        "mesh"
    ],
    "meshed": [
        "mesh"
    ],
    "meshing": [
        "mesh"
    ],
    "slippers": [
        "slipper"
    ],
    "slippered": [
        "slipper"
    ],
    "slippering": [
        "slipper"
    ],
    "wheelers": [
        "wheeler"
    ],
    "amisses": [
        "amiss"
    ],
    "amissing": [
        "amiss"
    ],
    "arcading": [
        "arcade"
    ],
    "arcaded": [
        "arcade"
    ],
    "coordinators": [
        "coordinator"
    ],
    "hastened": [
        "hasten"
    ],
    "hastening": [
        "hasten"
    ],
    "hastens": [
        "hasten"
    ],
    "huddled": [
        "huddle"
    ],
    "huddling": [
        "huddle"
    ],
    "huddles": [
        "huddle"
    ],
    "impairments": [
        "impairment"
    ],
    "liners": [
        "liner"
    ],
    "parried": [
        "parry"
    ],
    "parrying": [
        "parry"
    ],
    "parries": [
        "parry"
    ],
    "raffles": [
        "raffle"
    ],
    "raffled": [
        "raffle"
    ],
    "raffling": [
        "raffle"
    ],
    "unreliables": [
        "unreliable"
    ],
    "buckles": [
        "buckle"
    ],
    "buckled": [
        "buckle"
    ],
    "buckling": [
        "buckle"
    ],
    "pronouns": [
        "pronoun"
    ],
    "rubies": [
        "ruby"
    ],
    "rubys": [
        "ruby"
    ],
    "spreadings": [
        "spreading"
    ],
    "baptisms": [
        "baptism"
    ],
    "gleamings": [
        "gleaming"
    ],
    "glowings": [
        "glowing"
    ],
    "backdrops": [
        "backdrop"
    ],
    "backdropped": [
        "backdrop"
    ],
    "cookeries": [
        "cookery"
    ],
    "renamed": [
        "rename"
    ],
    "renaming": [
        "rename"
    ],
    "renames": [
        "rename"
    ],
    "wielding": [
        "wield"
    ],
    "wielded": [
        "wield"
    ],
    "wields": [
        "wield"
    ],
    "apeing": [
        "ape"
    ],
    "aping": [
        "ape",
        "ap"
    ],
    "aped": [
        "ape",
        "ap"
    ],
    "assented": [
        "assent"
    ],
    "assents": [
        "assent"
    ],
    "assenting": [
        "assent"
    ],
    "avoidances": [
        "avoidance"
    ],
    "compilers": [
        "compiler"
    ],
    "conservatisms": [
        "conservatism"
    ],
    "croats": [
        "croat"
    ],
    "editings": [
        "editing"
    ],
    "ryes": [
        "rye"
    ],
    "shotguns": [
        "shotgun"
    ],
    "abounded": [
        "abound"
    ],
    "abounds": [
        "abound"
    ],
    "abounding": [
        "abound"
    ],
    "admirers": [
        "admirer"
    ],
    "albanias": [
        "albania"
    ],
    "alienated": [
        "alienate"
    ],
    "alienating": [
        "alienate"
    ],
    "alienates": [
        "alienate"
    ],
    "amazements": [
        "amazement"
    ],
    "cunninghams": [
        "cunningham"
    ],
    "intruders": [
        "intruder"
    ],
    "jumbled": [
        "jumble"
    ],
    "jumbles": [
        "jumble"
    ],
    "jumbling": [
        "jumble"
    ],
    "luces": [
        "luce"
    ],
    "nicaraguas": [
        "nicaragua"
    ],
    "presbyterians": [
        "presbyterian"
    ],
    "punters": [
        "punter"
    ],
    "singulars": [
        "singular"
    ],
    "sperms": [
        "sperm"
    ],
    "spermed": [
        "sperm"
    ],
    "eyelids": [
        "eyelid"
    ],
    "gedges": [
        "gedge"
    ],
    "heightened": [
        "heighten"
    ],
    "heightening": [
        "heighten"
    ],
    "heightens": [
        "heighten"
    ],
    "sandstones": [
        "sandstone"
    ],
    "stiffened": [
        "stiffen"
    ],
    "stiffening": [
        "stiffen"
    ],
    "stiffens": [
        "stiffen"
    ],
    "taboos": [
        "taboo"
    ],
    "accompaniments": [
        "accompaniment"
    ],
    "ciders": [
        "cider"
    ],
    "endowed": [
        "endow"
    ],
    "endowing": [
        "endow"
    ],
    "endows": [
        "endow"
    ],
    "ethiopias": [
        "ethiopia"
    ],
    "greedier": [
        "greedy"
    ],
    "greediest": [
        "greedy"
    ],
    "humanitiess": [
        "humanities"
    ],
    "rejoined": [
        "rejoin"
    ],
    "rejoining": [
        "rejoin"
    ],
    "sportsmans": [
        "sportsman"
    ],
    "deletions": [
        "deletion"
    ],
    "megs": [
        "meg"
    ],
    "nudged": [
        "nudge"
    ],
    "nudging": [
        "nudge"
    ],
    "nudges": [
        "nudge"
    ],
    "polluted": [
        "pollute"
    ],
    "polluting": [
        "pollute"
    ],
    "pollutes": [
        "pollute"
    ],
    "skiings": [
        "skiing"
    ],
    "workhouses": [
        "workhouse"
    ],
    "boswells": [
        "boswell"
    ],
    "craters": [
        "crater"
    ],
    "cratered": [
        "crater"
    ],
    "cratering": [
        "crater"
    ],
    "dovered": [
        "dover"
    ],
    "morans": [
        "moran"
    ],
    "o'ed": [
        "o'"
    ],
    "sincerest": [
        "sincere"
    ],
    "sincerer": [
        "sincere"
    ],
    "amplifiers": [
        "amplifier"
    ],
    "blockaded": [
        "blockade"
    ],
    "blockades": [
        "blockade"
    ],
    "blockading": [
        "blockade"
    ],
    "darkened": [
        "darken"
    ],
    "darkening": [
        "darken"
    ],
    "darkens": [
        "darken"
    ],
    "feasibilities": [
        "feasibility"
    ],
    "inflammations": [
        "inflammation"
    ],
    "informants": [
        "informant"
    ],
    "neurons": [
        "neuron"
    ],
    "superseded": [
        "supersede"
    ],
    "supersedes": [
        "supersede"
    ],
    "superseding": [
        "supersede"
    ],
    "fumbled": [
        "fumble"
    ],
    "fumbling": [
        "fumble"
    ],
    "fumbles": [
        "fumble"
    ],
    "magnets": [
        "magnet"
    ],
    "relocations": [
        "relocation"
    ],
    "trespassing": [
        "trespass"
    ],
    "trespasses": [
        "trespass"
    ],
    "trespassed": [
        "trespass"
    ],
    "upheavals": [
        "upheaval"
    ],
    "clumsier": [
        "clumsy"
    ],
    "clumsiest": [
        "clumsy"
    ],
    "cohesions": [
        "cohesion"
    ],
    "coordinations": [
        "coordination"
    ],
    "degenerated": [
        "degenerate"
    ],
    "degenerating": [
        "degenerate"
    ],
    "degenerates": [
        "degenerate"
    ],
    "diagonals": [
        "diagonal"
    ],
    "grams": [
        "gram"
    ],
    "ma'ams": [
        "ma'am"
    ],
    "moorlands": [
        "moorland"
    ],
    "paved": [
        "pave"
    ],
    "paving": [
        "pave"
    ],
    "pricked": [
        "prick"
    ],
    "pricking": [
        "prick"
    ],
    "pricks": [
        "prick"
    ],
    "spades": [
        "spade"
    ],
    "spading": [
        "spade"
    ],
    "beggars": [
        "beggar"
    ],
    "beggaring": [
        "beggar"
    ],
    "beggared": [
        "beggar"
    ],
    "boardings": [
        "boarding"
    ],
    "compatibilities": [
        "compatibility"
    ],
    "fieriest": [
        "fiery"
    ],
    "fierier": [
        "fiery"
    ],
    "herrs": [
        "herr"
    ],
    "icelands": [
        "iceland"
    ],
    "liars": [
        "liar"
    ],
    "opennesses": [
        "openness"
    ],
    "shrewder": [
        "shrewd"
    ],
    "shrewdest": [
        "shrewd"
    ],
    "siemenss": [
        "siemens"
    ],
    "waterproofs": [
        "waterproof"
    ],
    "waterproofed": [
        "waterproof"
    ],
    "waterproofing": [
        "waterproof"
    ],
    "aeas": [
        "aea"
    ],
    "colognes": [
        "cologne"
    ],
    "comprehended": [
        "comprehend"
    ],
    "comprehending": [
        "comprehend"
    ],
    "comprehends": [
        "comprehend"
    ],
    "linguists": [
        "linguist"
    ],
    "polymerases": [
        "polymerase"
    ],
    "viabilities": [
        "viability"
    ],
    "condemnations": [
        "condemnation"
    ],
    "conformities": [
        "conformity"
    ],
    "curtailed": [
        "curtail"
    ],
    "curtailing": [
        "curtail"
    ],
    "curtails": [
        "curtail"
    ],
    "emancipations": [
        "emancipation"
    ],
    "sudans": [
        "sudan"
    ],
    "wriggled": [
        "wriggle"
    ],
    "wriggling": [
        "wriggle"
    ],
    "wriggles": [
        "wriggle"
    ],
    "battier": [
        "batty"
    ],
    "battiest": [
        "batty"
    ],
    "freaked": [
        "freak"
    ],
    "freaking": [
        "freak"
    ],
    "parkinsons": [
        "parkinson"
    ],
    "sarajevoes": [
        "sarajevo"
    ],
    "stevensons": [
        "stevenson"
    ],
    "caesars": [
        "caesar"
    ],
    "dictatorships": [
        "dictatorship"
    ],
    "firearms": [
        "firearm"
    ],
    "misfortunes": [
        "misfortune"
    ],
    "underwears": [
        "underwear"
    ],
    "unwelcoming": [
        "unwelcome"
    ],
    "wizards": [
        "wizard"
    ],
    "barraged": [
        "barrage"
    ],
    "macgregors": [
        "macgregor"
    ],
    "persistences": [
        "persistence"
    ],
    "schemata": [
        "schema"
    ],
    "slaveries": [
        "slavery"
    ],
    "starvations": [
        "starvation"
    ],
    "ters": [
        "ter"
    ],
    "toads": [
        "toad"
    ],
    "tuitioning": [
        "tuition"
    ],
    "franklins": [
        "franklin"
    ],
    "pluralists": [
        "pluralist"
    ],
    "portals": [
        "portal"
    ],
    "promenading": [
        "promenade"
    ],
    "promenaded": [
        "promenade"
    ],
    "putts": [
        "putt"
    ],
    "putted": [
        "putt"
    ],
    "receptionists": [
        "receptionist"
    ],
    "shakier": [
        "shaky"
    ],
    "shakiest": [
        "shaky"
    ],
    "traversed": [
        "traverse"
    ],
    "traversing": [
        "traverse"
    ],
    "assimilated": [
        "assimilate"
    ],
    "assimilating": [
        "assimilate"
    ],
    "assimilates": [
        "assimilate"
    ],
    "baggages": [
        "baggage"
    ],
    "displacements": [
        "displacement"
    ],
    "downhills": [
        "downhill"
    ],
    "edwins": [
        "edwin"
    ],
    "generalizations": [
        "generalization"
    ],
    "subsided": [
        "subside"
    ],
    "subsiding": [
        "subside"
    ],
    "beethovens": [
        "beethoven"
    ],
    "drews": [
        "drew"
    ],
    "eradicated": [
        "eradicate"
    ],
    "eradicating": [
        "eradicate"
    ],
    "eradicates": [
        "eradicate"
    ],
    "genned": [
        "gen"
    ],
    "genning": [
        "gen"
    ],
    "loos": [
        "loo"
    ],
    "looing": [
        "loo"
    ],
    "sagaing": [
        "saga"
    ],
    "terrified": [
        "terrify"
    ],
    "terrifying": [
        "terrify"
    ],
    "carrs": [
        "carr"
    ],
    "converged": [
        "converge"
    ],
    "converging": [
        "converge"
    ],
    "converges": [
        "converge"
    ],
    "eqns": [
        "eqn"
    ],
    "insertions": [
        "insertion"
    ],
    "mods": [
        "mod"
    ],
    "modding": [
        "mod"
    ],
    "modded": [
        "mod"
    ],
    "pickets": [
        "picket"
    ],
    "picketted": [
        "picket"
    ],
    "picketing": [
        "picket",
        "pickete"
    ],
    "picketed": [
        "picket",
        "pickete"
    ],
    "roused": [
        "rouse"
    ],
    "rousing": [
        "rouse"
    ],
    "rouses": [
        "rouse"
    ],
    "annoyances": [
        "annoyance"
    ],
    "assessors": [
        "assessor"
    ],
    "crypts": [
        "crypt"
    ],
    "devolutions": [
        "devolution"
    ],
    "overhauled": [
        "overhaul"
    ],
    "overhauling": [
        "overhaul"
    ],
    "overhauls": [
        "overhaul"
    ],
    "perimeters": [
        "perimeter"
    ],
    "silhouetted": [
        "silhouette"
    ],
    "upbringings": [
        "upbringing"
    ],
    "caretakers": [
        "caretaker"
    ],
    "cunningest": [
        "cunning"
    ],
    "gutss": [
        "guts"
    ],
    "plutoniums": [
        "plutonium"
    ],
    "postulated": [
        "postulate"
    ],
    "postulates": [
        "postulate"
    ],
    "postulating": [
        "postulate"
    ],
    "squiring": [
        "squire"
    ],
    "squired": [
        "squire"
    ],
    "walnuts": [
        "walnut"
    ],
    "weas": [
        "wea"
    ],
    "alpss": [
        "alps"
    ],
    "barbers": [
        "barber"
    ],
    "barbered": [
        "barber"
    ],
    "barbering": [
        "barber"
    ],
    "boars": [
        "boar"
    ],
    "chamberss": [
        "chambers"
    ],
    "endangered": [
        "endanger"
    ],
    "endangering": [
        "endanger"
    ],
    "endangers": [
        "endanger"
    ],
    "greased": [
        "grease"
    ],
    "greasing": [
        "grease"
    ],
    "greases": [
        "grease"
    ],
    "hawkinss": [
        "hawkins"
    ],
    "hemmed": [
        "hem"
    ],
    "hems": [
        "hem"
    ],
    "hemming": [
        "hem"
    ],
    "inconsistencies": [
        "inconsistency"
    ],
    "naves": [
        "nave"
    ],
    "saucers": [
        "saucer"
    ],
    "auxiliaries": [
        "auxiliary"
    ],
    "ensued": [
        "ensue"
    ],
    "ensues": [
        "ensue"
    ],
    "ensuing": [
        "ensue"
    ],
    "recited": [
        "recite"
    ],
    "reciting": [
        "recite"
    ],
    "templates": [
        "template"
    ],
    "templating": [
        "template"
    ],
    "transients": [
        "transient"
    ],
    "advisors": [
        "advisor"
    ],
    "consonants": [
        "consonant"
    ],
    "crates": [
        "crate"
    ],
    "crated": [
        "crate"
    ],
    "crating": [
        "crate"
    ],
    "faunas": [
        "fauna"
    ],
    "folders": [
        "folder"
    ],
    "furnaces": [
        "furnace"
    ],
    "hertfordshires": [
        "hertfordshire"
    ],
    "lineages": [
        "lineage"
    ],
    "microprocessors": [
        "microprocessor"
    ],
    "mixings": [
        "mixing"
    ],
    "rejoicing": [
        "rejoice"
    ],
    "rejoiced": [
        "rejoice"
    ],
    "rejoices": [
        "rejoice"
    ],
    "bonns": [
        "bonn"
    ],
    "buyings": [
        "buying"
    ],
    "carping": [
        "carp"
    ],
    "carps": [
        "carp"
    ],
    "carped": [
        "carp"
    ],
    "datings": [
        "dating"
    ],
    "ferns": [
        "fern"
    ],
    "florals": [
        "floral"
    ],
    "liberated": [
        "liberate"
    ],
    "liberating": [
        "liberate"
    ],
    "liberates": [
        "liberate"
    ],
    "liquors": [
        "liquor"
    ],
    "objectivities": [
        "objectivity"
    ],
    "payers": [
        "payer"
    ],
    "rectified": [
        "rectify"
    ],
    "rectifying": [
        "rectify"
    ],
    "varnished": [
        "varnish"
    ],
    "varnishes": [
        "varnish"
    ],
    "varnishing": [
        "varnish"
    ],
    "whisked": [
        "whisk"
    ],
    "whisking": [
        "whisk"
    ],
    "whisks": [
        "whisk"
    ],
    "churning": [
        "churn"
    ],
    "churned": [
        "churn"
    ],
    "churns": [
        "churn"
    ],
    "cids": [
        "cid"
    ],
    "infringements": [
        "infringement"
    ],
    "mingled": [
        "mingle"
    ],
    "mingling": [
        "mingle"
    ],
    "mingles": [
        "mingle"
    ],
    "razors": [
        "razor"
    ],
    "rusting": [
        "rust"
    ],
    "rusted": [
        "rust"
    ],
    "rusts": [
        "rust"
    ],
    "windies": [
        "windy"
    ],
    "windiest": [
        "windy"
    ],
    "windier": [
        "windy"
    ],
    "apostles": [
        "apostle"
    ],
    "bolsheviks": [
        "bolshevik"
    ],
    "buns": [
        "bun"
    ],
    "bunning": [
        "bun"
    ],
    "bunned": [
        "bun"
    ],
    "desmonds": [
        "desmond"
    ],
    "dinghies": [
        "dinghy"
    ],
    "dinghys": [
        "dinghy"
    ],
    "heterosexuals": [
        "heterosexual"
    ],
    "ids": [
        "id"
    ],
    "iding": [
        "id"
    ],
    "massachusettss": [
        "massachusetts"
    ],
    "receded": [
        "recede"
    ],
    "receding": [
        "recede"
    ],
    "recedes": [
        "recede"
    ],
    "speakings": [
        "speaking"
    ],
    "subsistences": [
        "subsistence"
    ],
    "tarts": [
        "tart"
    ],
    "tarted": [
        "tart"
    ],
    "tarting": [
        "tart"
    ],
    "tarter": [
        "tart"
    ],
    "tartest": [
        "tart"
    ],
    "aquatics": [
        "aquatic"
    ],
    "distrusted": [
        "distrust"
    ],
    "distrusting": [
        "distrust"
    ],
    "distrusts": [
        "distrust"
    ],
    "enlighteneds": [
        "enlightened"
    ],
    "excelled": [
        "excel"
    ],
    "excels": [
        "excel"
    ],
    "excelling": [
        "excel"
    ],
    "glitterings": [
        "glittering"
    ],
    "intellects": [
        "intellect"
    ],
    "monastics": [
        "monastic"
    ],
    "prussians": [
        "prussian"
    ],
    "psychoanalyses": [
        "psychoanalysis"
    ],
    "ruing": [
        "rue"
    ],
    "rued": [
        "rue"
    ],
    "rueing": [
        "rue"
    ],
    "bunkered": [
        "bunker"
    ],
    "bunkering": [
        "bunker"
    ],
    "conservatories": [
        "conservatory"
    ],
    "curvatures": [
        "curvature"
    ],
    "labellings": [
        "labelling"
    ],
    "outlawed": [
        "outlaw"
    ],
    "outlawing": [
        "outlaw"
    ],
    "pears": [
        "pear"
    ],
    "quivering": [
        "quiver"
    ],
    "quivered": [
        "quiver"
    ],
    "quivers": [
        "quiver"
    ],
    "strictures": [
        "stricture"
    ],
    "stricturing": [
        "stricture"
    ],
    "strictured": [
        "stricture"
    ],
    "alloys": [
        "alloy"
    ],
    "alloying": [
        "alloy"
    ],
    "alloyed": [
        "alloy"
    ],
    "beckoned": [
        "beckon"
    ],
    "beckoning": [
        "beckon"
    ],
    "beckons": [
        "beckon"
    ],
    "brittling": [
        "brittle"
    ],
    "brittler": [
        "brittle"
    ],
    "brittlest": [
        "brittle"
    ],
    "cooperating": [
        "cooperate"
    ],
    "cooperated": [
        "cooperate"
    ],
    "cooperates": [
        "cooperate"
    ],
    "disapproved": [
        "disapprove"
    ],
    "disapproves": [
        "disapprove"
    ],
    "disapproving": [
        "disapprove"
    ],
    "drawled": [
        "drawl"
    ],
    "drawling": [
        "drawl"
    ],
    "drawls": [
        "drawl"
    ],
    "homages": [
        "homage"
    ],
    "periodicals": [
        "periodical"
    ],
    "priories": [
        "priory"
    ],
    "shrouded": [
        "shroud"
    ],
    "shrouds": [
        "shroud"
    ],
    "shrouding": [
        "shroud"
    ],
    "worsened": [
        "worsen"
    ],
    "worsens": [
        "worsen"
    ],
    "worsening": [
        "worsen"
    ],
    "bathes": [
        "bathe"
    ],
    "carlos": [
        "carlo"
    ],
    "deities": [
        "deity"
    ],
    "dispelled": [
        "dispel"
    ],
    "dispelling": [
        "dispel"
    ],
    "dispels": [
        "dispel"
    ],
    "drinkers": [
        "drinker"
    ],
    "marvelled": [
        "marvel"
    ],
    "marvels": [
        "marvel"
    ],
    "marvelling": [
        "marvel"
    ],
    "u.s.s": [
        "u.s."
    ],
    "amplitudes": [
        "amplitude"
    ],
    "knuckles": [
        "knuckle"
    ],
    "knuckled": [
        "knuckle"
    ],
    "knuckling": [
        "knuckle"
    ],
    "packings": [
        "packing"
    ],
    "siblings": [
        "sibling"
    ],
    "weirs": [
        "weir"
    ],
    "calculators": [
        "calculator"
    ],
    "envoys": [
        "envoy"
    ],
    "greenes": [
        "greene"
    ],
    "nonconformists": [
        "nonconformist"
    ],
    "paws": [
        "paw"
    ],
    "pawing": [
        "paw"
    ],
    "pawed": [
        "paw"
    ],
    "replicas": [
        "replica"
    ],
    "tessas": [
        "tessa"
    ],
    "blonder": [
        "blond"
    ],
    "blonded": [
        "blond"
    ],
    "columbias": [
        "columbia"
    ],
    "mams": [
        "mam"
    ],
    "placings": [
        "placing"
    ],
    "truces": [
        "truce"
    ],
    "vitalities": [
        "vitality"
    ],
    "beacons": [
        "beacon"
    ],
    "beaconing": [
        "beacon"
    ],
    "garlands": [
        "garland"
    ],
    "garlanded": [
        "garland"
    ],
    "garlanding": [
        "garland"
    ],
    "hammondest": [
        "hammond"
    ],
    "pneumonias": [
        "pneumonia"
    ],
    "todds": [
        "todd"
    ],
    "turtles": [
        "turtle"
    ],
    "blahs": [
        "blah"
    ],
    "doves": [
        "dove"
    ],
    "doving": [
        "dove"
    ],
    "ems": [
        "em"
    ],
    "rostovs": [
        "rostov"
    ],
    "ambushed": [
        "ambush"
    ],
    "ambushes": [
        "ambush"
    ],
    "ambushing": [
        "ambush"
    ],
    "austerities": [
        "austerity"
    ],
    "brooded": [
        "brood"
    ],
    "broods": [
        "brood"
    ],
    "brooding": [
        "brood"
    ],
    "reaffirmed": [
        "reaffirm"
    ],
    "reaffirming": [
        "reaffirm"
    ],
    "reaffirms": [
        "reaffirm"
    ],
    "statesmen": [
        "statesman"
    ],
    "tolkiens": [
        "tolkien"
    ],
    "wigs": [
        "wig"
    ],
    "wigging": [
        "wig"
    ],
    "burgesses": [
        "burgess"
    ],
    "deregulations": [
        "deregulation"
    ],
    "hqs": [
        "hq"
    ],
    "metallics": [
        "metallic"
    ],
    "nightclubs": [
        "nightclub"
    ],
    "nightclubbing": [
        "nightclub"
    ],
    "obituaries": [
        "obituary"
    ],
    "riversides": [
        "riverside"
    ],
    "tits": [
        "tit"
    ],
    "torontoes": [
        "toronto"
    ],
    "bunnies": [
        "bunny"
    ],
    "bunnys": [
        "bunny"
    ],
    "bunnied": [
        "bunny"
    ],
    "flowerings": [
        "flowering"
    ],
    "glinting": [
        "glint"
    ],
    "glinted": [
        "glint"
    ],
    "glints": [
        "glint"
    ],
    "grasslands": [
        "grassland"
    ],
    "heeded": [
        "heed"
    ],
    "heeding": [
        "heed"
    ],
    "heeds": [
        "heed"
    ],
    "sneered": [
        "sneer"
    ],
    "sneering": [
        "sneer"
    ],
    "sneers": [
        "sneer"
    ],
    "herrings": [
        "herring"
    ],
    "jaspers": [
        "jasper"
    ],
    "mouthfuls": [
        "mouthful"
    ],
    "realists": [
        "realist"
    ],
    "toxins": [
        "toxin"
    ],
    "venetians": [
        "venetian"
    ],
    "lusher": [
        "lush"
    ],
    "lushest": [
        "lush"
    ],
    "lushes": [
        "lush"
    ],
    "overriding": [
        "override"
    ],
    "overrides": [
        "override"
    ],
    "overrode": [
        "override"
    ],
    "overridden": [
        "override"
    ],
    "scissor": [
        "scissors"
    ],
    "scissors": [
        "scissors"
    ],
    "barbecued": [
        "barbecue"
    ],
    "barbecuing": [
        "barbecue"
    ],
    "birches": [
        "birch"
    ],
    "birched": [
        "birch"
    ],
    "birching": [
        "birch"
    ],
    "cnuts": [
        "cnut"
    ],
    "dustbins": [
        "dustbin"
    ],
    "hearths": [
        "hearth"
    ],
    "loadings": [
        "loading"
    ],
    "propelled": [
        "propel"
    ],
    "propelling": [
        "propel"
    ],
    "propels": [
        "propel"
    ],
    "reorganizations": [
        "reorganization"
    ],
    "rums": [
        "rum"
    ],
    "rummer": [
        "rum"
    ],
    "stews": [
        "stew"
    ],
    "stewed": [
        "stew"
    ],
    "stewing": [
        "stew"
    ],
    "surnames": [
        "surname"
    ],
    "surnamed": [
        "surname"
    ],
    "sweethearts": [
        "sweetheart"
    ],
    "syndicates": [
        "syndicate"
    ],
    "syndicated": [
        "syndicate"
    ],
    "syndicating": [
        "syndicate"
    ],
    "wittiest": [
        "witty"
    ],
    "wittier": [
        "witty"
    ],
    "wooed": [
        "woo"
    ],
    "wooing": [
        "woo"
    ],
    "woos": [
        "woo"
    ],
    "checklists": [
        "checklist"
    ],
    "cornishes": [
        "cornish"
    ],
    "emigrated": [
        "emigrate"
    ],
    "emigrating": [
        "emigrate"
    ],
    "emigrates": [
        "emigrate"
    ],
    "lettuces": [
        "lettuce"
    ],
    "pos": [
        "po"
    ],
    "supremacies": [
        "supremacy"
    ],
    "surfing": [
        "surf"
    ],
    "surfed": [
        "surf"
    ],
    "surfs": [
        "surf"
    ],
    "yearlies": [
        "yearly"
    ],
    "bleaching": [
        "bleach"
    ],
    "bleached": [
        "bleach"
    ],
    "bleaches": [
        "bleach"
    ],
    "breams": [
        "bream"
    ],
    "breaming": [
        "bream"
    ],
    "breamed": [
        "bream"
    ],
    "bream": [
        "bream"
    ],
    "curlies": [
        "curly"
    ],
    "curlier": [
        "curly"
    ],
    "curliest": [
        "curly"
    ],
    "ducts": [
        "duct"
    ],
    "ducting": [
        "duct"
    ],
    "ducted": [
        "duct"
    ],
    "erotics": [
        "erotic"
    ],
    "infancies": [
        "infancy"
    ],
    "knobs": [
        "knob"
    ],
    "knobbed": [
        "knob"
    ],
    "knobbing": [
        "knob"
    ],
    "perms": [
        "perm"
    ],
    "permed": [
        "perm"
    ],
    "perming": [
        "perm"
    ],
    "presupposes": [
        "presuppose"
    ],
    "presupposed": [
        "presuppose"
    ],
    "presupposing": [
        "presuppose"
    ],
    "aggravated": [
        "aggravate"
    ],
    "aggravating": [
        "aggravate"
    ],
    "aggravates": [
        "aggravate"
    ],
    "banquetting": [
        "banquet"
    ],
    "elevated": [
        "elevate"
    ],
    "elevating": [
        "elevate"
    ],
    "elevates": [
        "elevate"
    ],
    "fundamentalists": [
        "fundamentalist"
    ],
    "jading": [
        "jade"
    ],
    "jaded": [
        "jade"
    ],
    "lening": [
        "len"
    ],
    "norderns": [
        "nordern"
    ],
    "sewers": [
        "sewer"
    ],
    "sewered": [
        "sewer"
    ],
    "sulphates": [
        "sulphate"
    ],
    "sulphated": [
        "sulphate"
    ],
    "waterloos": [
        "waterloo"
    ],
    "acquitted": [
        "acquit"
    ],
    "acquitting": [
        "acquit"
    ],
    "cuddling": [
        "cuddle"
    ],
    "cuddled": [
        "cuddle"
    ],
    "cuddles": [
        "cuddle"
    ],
    "embankments": [
        "embankment"
    ],
    "procured": [
        "procure"
    ],
    "procuring": [
        "procure"
    ],
    "profitbosses": [
        "profitboss"
    ],
    "resultants": [
        "resultant"
    ],
    "saucepans": [
        "saucepan"
    ],
    "winced": [
        "wince"
    ],
    "wincing": [
        "wince"
    ],
    "winces": [
        "wince"
    ],
    "blunders": [
        "blunder"
    ],
    "blundered": [
        "blunder"
    ],
    "blundering": [
        "blunder"
    ],
    "engelss": [
        "engels"
    ],
    "gaelics": [
        "gaelic"
    ],
    "passwords": [
        "password"
    ],
    "pouches": [
        "pouch"
    ],
    "pouched": [
        "pouch"
    ],
    "pouching": [
        "pouch"
    ],
    "prerequisites": [
        "prerequisite"
    ],
    "byrnes": [
        "byrne"
    ],
    "disposables": [
        "disposable"
    ],
    "divings": [
        "diving"
    ],
    "hudsoned": [
        "hudson"
    ],
    "hudsoning": [
        "hudson"
    ],
    "montreals": [
        "montreal"
    ],
    "postmen": [
        "postman"
    ],
    "prawns": [
        "prawn"
    ],
    "psalms": [
        "psalm"
    ],
    "robbers": [
        "robber"
    ],
    "spiring": [
        "spire"
    ],
    "uprisings": [
        "uprising"
    ],
    "adorned": [
        "adorn"
    ],
    "adorning": [
        "adorn"
    ],
    "adorns": [
        "adorn"
    ],
    "caspars": [
        "caspar"
    ],
    "cuffs": [
        "cuff"
    ],
    "cuffed": [
        "cuff"
    ],
    "cuffing": [
        "cuff"
    ],
    "disarmaments": [
        "disarmament"
    ],
    "elviss": [
        "elvis"
    ],
    "freelances": [
        "freelance"
    ],
    "freelancing": [
        "freelance"
    ],
    "freelanced": [
        "freelance"
    ],
    "morleys": [
        "morley"
    ],
    "radials": [
        "radial"
    ],
    "violas": [
        "viola"
    ],
    "clydes": [
        "clyde"
    ],
    "hookers": [
        "hooker"
    ],
    "lamented": [
        "lament"
    ],
    "laments": [
        "lament"
    ],
    "lamenting": [
        "lament"
    ],
    "percies": [
        "percy"
    ],
    "bradies": [
        "brady"
    ],
    "felicities": [
        "felicity"
    ],
    "gunners": [
        "gunner"
    ],
    "parities": [
        "parity"
    ],
    "poppies": [
        "poppy"
    ],
    "poppiest": [
        "poppy"
    ],
    "skated": [
        "skate"
    ],
    "smuggled": [
        "smuggle"
    ],
    "smuggling": [
        "smuggle"
    ],
    "smuggles": [
        "smuggle"
    ],
    "strasbourgs": [
        "strasbourg"
    ],
    "yeasts": [
        "yeast"
    ],
    "bradleys": [
        "bradley"
    ],
    "feebles": [
        "feeble"
    ],
    "feebler": [
        "feeble"
    ],
    "feeblest": [
        "feeble"
    ],
    "foresters": [
        "forester"
    ],
    "malts": [
        "malt"
    ],
    "malting": [
        "malt"
    ],
    "malted": [
        "malt"
    ],
    "orderings": [
        "ordering"
    ],
    "bellowed": [
        "bellow"
    ],
    "bellowing": [
        "bellow"
    ],
    "bellows": [
        "bellow"
    ],
    "filings": [
        "filing"
    ],
    "hindsights": [
        "hindsight"
    ],
    "indonesians": [
        "indonesian"
    ],
    "namibias": [
        "namibia"
    ],
    "privatised": [
        "privatise"
    ],
    "privatising": [
        "privatise"
    ],
    "slaters": [
        "slater"
    ],
    "sleepier": [
        "sleepy"
    ],
    "sleepies": [
        "sleepy"
    ],
    "sleepiest": [
        "sleepy"
    ],
    "cardiacs": [
        "cardiac"
    ],
    "hostesses": [
        "hostess"
    ],
    "hostessing": [
        "hostess"
    ],
    "hostessed": [
        "hostess"
    ],
    "murdoches": [
        "murdoch"
    ],
    "pinpointed": [
        "pinpoint"
    ],
    "pinpoints": [
        "pinpoint"
    ],
    "pinpointing": [
        "pinpoint"
    ],
    "seeping": [
        "seep"
    ],
    "seeped": [
        "seep"
    ],
    "seeps": [
        "seep"
    ],
    "siberias": [
        "siberia"
    ],
    "unequals": [
        "unequal"
    ],
    "unified": [
        "unify"
    ],
    "unifying": [
        "unify"
    ],
    "vinegars": [
        "vinegar"
    ],
    "waterways": [
        "waterway"
    ],
    "bolstered": [
        "bolster"
    ],
    "bolstering": [
        "bolster"
    ],
    "bolsters": [
        "bolster"
    ],
    "captioned": [
        "caption"
    ],
    "captioning": [
        "caption"
    ],
    "conrads": [
        "conrad"
    ],
    "explorers": [
        "explorer"
    ],
    "interchanges": [
        "interchange"
    ],
    "interchanged": [
        "interchange"
    ],
    "interchanging": [
        "interchange"
    ],
    "sapped": [
        "sap"
    ],
    "sapping": [
        "sap"
    ],
    "saps": [
        "sap"
    ],
    "sirens": [
        "siren"
    ],
    "uplifted": [
        "uplift"
    ],
    "uplifts": [
        "uplift"
    ],
    "uplifting": [
        "uplift"
    ],
    "wriest": [
        "wry"
    ],
    "blueprints": [
        "blueprint"
    ],
    "blueprinted": [
        "blueprint"
    ],
    "compulsions": [
        "compulsion"
    ],
    "grimaced": [
        "grimace"
    ],
    "grimacing": [
        "grimace"
    ],
    "hoards": [
        "hoard"
    ],
    "hoarding": [
        "hoard"
    ],
    "hoarded": [
        "hoard"
    ],
    "hushed": [
        "hush"
    ],
    "hushing": [
        "hush"
    ],
    "hushes": [
        "hush"
    ],
    "paiges": [
        "paige"
    ],
    "politburos": [
        "politburo"
    ],
    "posher": [
        "posh"
    ],
    "poshest": [
        "posh"
    ],
    "poshed": [
        "posh"
    ],
    "primers": [
        "primer"
    ],
    "publicised": [
        "publicise"
    ],
    "publicising": [
        "publicise"
    ],
    "publicises": [
        "publicise"
    ],
    "scowled": [
        "scowl"
    ],
    "scowling": [
        "scowl"
    ],
    "scowls": [
        "scowl"
    ],
    "seduced": [
        "seduce"
    ],
    "seducing": [
        "seduce"
    ],
    "seduces": [
        "seduce"
    ],
    "taverns": [
        "tavern"
    ],
    "tummies": [
        "tummy"
    ],
    "venezuelas": [
        "venezuela"
    ],
    "barkers": [
        "barker"
    ],
    "bestowed": [
        "bestow"
    ],
    "bestowing": [
        "bestow"
    ],
    "bestows": [
        "bestow"
    ],
    "fowlers": [
        "fowler"
    ],
    "hassles": [
        "hassle"
    ],
    "hassled": [
        "hassle"
    ],
    "hassling": [
        "hassle"
    ],
    "hastes": [
        "haste"
    ],
    "imperialisms": [
        "imperialism"
    ],
    "maximizing": [
        "maximize"
    ],
    "maximized": [
        "maximize"
    ],
    "maximizes": [
        "maximize"
    ],
    "pps": [
        "pp"
    ],
    "shearers": [
        "shearer"
    ],
    "taunted": [
        "taunt"
    ],
    "taunting": [
        "taunt"
    ],
    "taunts": [
        "taunt"
    ],
    "townsends": [
        "townsend"
    ],
    "auditioned": [
        "audition"
    ],
    "auditioning": [
        "audition"
    ],
    "eternities": [
        "eternity"
    ],
    "faltered": [
        "falter"
    ],
    "faltering": [
        "falter"
    ],
    "falters": [
        "falter"
    ],
    "fingertips": [
        "fingertip"
    ],
    "fingertipped": [
        "fingertip"
    ],
    "footprints": [
        "footprint"
    ],
    "footprinting": [
        "footprint"
    ],
    "influxes": [
        "influx"
    ],
    "newports": [
        "newport"
    ],
    "perpetuated": [
        "perpetuate"
    ],
    "perpetuating": [
        "perpetuate"
    ],
    "perpetuates": [
        "perpetuate"
    ],
    "perversest": [
        "perverse"
    ],
    "protectors": [
        "protector"
    ],
    "ratifications": [
        "ratification"
    ],
    "segregations": [
        "segregation"
    ],
    "bustled": [
        "bustle"
    ],
    "bustling": [
        "bustle"
    ],
    "bustles": [
        "bustle"
    ],
    "discredited": [
        "discredit"
    ],
    "discrediting": [
        "discredit"
    ],
    "discredits": [
        "discredit"
    ],
    "disqualified": [
        "disqualify"
    ],
    "disqualifying": [
        "disqualify"
    ],
    "dorsals": [
        "dorsal"
    ],
    "extremists": [
        "extremist"
    ],
    "fifes": [
        "fife"
    ],
    "graveyards": [
        "graveyard"
    ],
    "hallways": [
        "hallway"
    ],
    "lipsticks": [
        "lipstick"
    ],
    "lipsticking": [
        "lipstick"
    ],
    "lipsticked": [
        "lipstick"
    ],
    "messiahs": [
        "messiah"
    ],
    "retrospects": [
        "retrospect"
    ],
    "retrospecting": [
        "retrospect"
    ],
    "retrospected": [
        "retrospect"
    ],
    "shabbier": [
        "shabby"
    ],
    "shabbiest": [
        "shabby"
    ],
    "xis": [
        "xi"
    ],
    "continuums": [
        "continuum"
    ],
    "embarrassed": [
        "embarrass"
    ],
    "embarrassing": [
        "embarrass"
    ],
    "forgivenesses": [
        "forgiveness"
    ],
    "inhibitors": [
        "inhibitor"
    ],
    "mourning": [
        "mourn"
    ],
    "mourned": [
        "mourn"
    ],
    "mourns": [
        "mourn"
    ],
    "wights": [
        "wight"
    ],
    "inclined": [
        "incline"
    ],
    "inclining": [
        "incline"
    ],
    "incubated": [
        "incubate"
    ],
    "incubating": [
        "incubate"
    ],
    "incubates": [
        "incubate"
    ],
    "insecurities": [
        "insecurity"
    ],
    "pollutants": [
        "pollutant"
    ],
    "roadsides": [
        "roadside"
    ],
    "arousals": [
        "arousal"
    ],
    "crosbies": [
        "crosby"
    ],
    "ethanols": [
        "ethanol"
    ],
    "hoses": [
        "hose"
    ],
    "hosed": [
        "hose"
    ],
    "hosing": [
        "hose"
    ],
    "masais": [
        "masai"
    ],
    "postscripts": [
        "postscript"
    ],
    "regularities": [
        "regularity"
    ],
    "ridiculed": [
        "ridicule"
    ],
    "ridiculing": [
        "ridicule"
    ],
    "spinals": [
        "spinal"
    ],
    "spinners": [
        "spinner"
    ],
    "substrates": [
        "substrate"
    ],
    "acclaimed": [
        "acclaim"
    ],
    "acclaiming": [
        "acclaim"
    ],
    "acclaims": [
        "acclaim"
    ],
    "advocacies": [
        "advocacy"
    ],
    "bangkoks": [
        "bangkok"
    ],
    "brinks": [
        "brink"
    ],
    "broadways": [
        "broadway"
    ],
    "djs": [
        "dj"
    ],
    "djing": [
        "dj"
    ],
    "djed": [
        "dj"
    ],
    "finalised": [
        "finalise"
    ],
    "finalising": [
        "finalise"
    ],
    "finalises": [
        "finalise"
    ],
    "orthodoxies": [
        "orthodoxy"
    ],
    "variabilities": [
        "variability"
    ],
    "vaticans": [
        "vatican"
    ],
    "widenings": [
        "widening"
    ],
    "biochemicals": [
        "biochemical"
    ],
    "cramped": [
        "cramp"
    ],
    "cramps": [
        "cramp"
    ],
    "cramping": [
        "cramp"
    ],
    "exoduss": [
        "exodus"
    ],
    "gamblings": [
        "gambling"
    ],
    "semanticss": [
        "semantics"
    ],
    "singularities": [
        "singularity"
    ],
    "strangled": [
        "strangle"
    ],
    "strangling": [
        "strangle"
    ],
    "strangles": [
        "strangle"
    ],
    "growers": [
        "grower"
    ],
    "hedgerows": [
        "hedgerow"
    ],
    "ilps": [
        "ilp"
    ],
    "imprinted": [
        "imprint"
    ],
    "imprints": [
        "imprint"
    ],
    "imprinting": [
        "imprint"
    ],
    "joshuas": [
        "joshua"
    ],
    "lingerings": [
        "lingering"
    ],
    "obstructing": [
        "obstruct"
    ],
    "obstructed": [
        "obstruct"
    ],
    "obstructs": [
        "obstruct"
    ],
    "plurals": [
        "plural"
    ],
    "shareholdings": [
        "shareholding"
    ],
    "bulgarians": [
        "bulgarian"
    ],
    "chlorides": [
        "chloride"
    ],
    "granadas": [
        "granada"
    ],
    "headteachers": [
        "headteacher"
    ],
    "kittens": [
        "kitten"
    ],
    "kittened": [
        "kitten"
    ],
    "perennials": [
        "perennial"
    ],
    "rainfalls": [
        "rainfall"
    ],
    "annexed": [
        "annex"
    ],
    "annexing": [
        "annex"
    ],
    "apricots": [
        "apricot"
    ],
    "docs": [
        "doc"
    ],
    "falcons": [
        "falcon"
    ],
    "falconing": [
        "falcon"
    ],
    "lighters": [
        "lighter"
    ],
    "matrons": [
        "matron"
    ],
    "nixons": [
        "nixon"
    ],
    "theorems": [
        "theorem"
    ],
    "wrinkles": [
        "wrinkle"
    ],
    "wrinkled": [
        "wrinkle"
    ],
    "wrinkling": [
        "wrinkle"
    ],
    "barrens": [
        "barren"
    ],
    "cacheing": [
        "cache"
    ],
    "castroes": [
        "castro"
    ],
    "creased": [
        "crease"
    ],
    "creases": [
        "crease"
    ],
    "creasing": [
        "crease"
    ],
    "cromwells": [
        "cromwell"
    ],
    "hinds": [
        "hind"
    ],
    "hunched": [
        "hunch"
    ],
    "hunches": [
        "hunch"
    ],
    "hunching": [
        "hunch"
    ],
    "mphs": [
        "mph"
    ],
    "overdrafts": [
        "overdraft"
    ],
    "pantomimed": [
        "pantomime"
    ],
    "repping": [
        "rep"
    ],
    "repped": [
        "rep"
    ],
    "uneases": [
        "unease"
    ],
    "volcanos": [
        "volcano"
    ],
    "volcanoes": [
        "volcanoe",
        "volcano"
    ],
    "zoomed": [
        "zoom"
    ],
    "zooming": [
        "zoom"
    ],
    "frights": [
        "fright"
    ],
    "frighted": [
        "fright"
    ],
    "geologists": [
        "geologist"
    ],
    "hairier": [
        "hairy"
    ],
    "hairies": [
        "hairy"
    ],
    "hairiest": [
        "hairy"
    ],
    "hoppers": [
        "hopper"
    ],
    "isabellas": [
        "isabella"
    ],
    "issuings": [
        "issuing"
    ],
    "lizards": [
        "lizard"
    ],
    "resins": [
        "resin"
    ],
    "complicated": [
        "complicate"
    ],
    "complicates": [
        "complicate"
    ],
    "complicating": [
        "complicate"
    ],
    "eddies": [
        "eddy"
    ],
    "eddied": [
        "eddy"
    ],
    "eddying": [
        "eddy"
    ],
    "hedgehogs": [
        "hedgehog"
    ],
    "limitings": [
        "limiting"
    ],
    "mitched": [
        "mitch"
    ],
    "runing": [
        "rune"
    ],
    "tapestries": [
        "tapestry"
    ],
    "tapestried": [
        "tapestry"
    ],
    "toppled": [
        "topple"
    ],
    "toppling": [
        "topple"
    ],
    "topples": [
        "topple"
    ],
    "bakings": [
        "baking"
    ],
    "earners": [
        "earner"
    ],
    "gyms": [
        "gym"
    ],
    "irregularities": [
        "irregularity"
    ],
    "mosques": [
        "mosque"
    ],
    "narrators": [
        "narrator"
    ],
    "notifications": [
        "notification"
    ],
    "payrolls": [
        "payroll"
    ],
    "plums": [
        "plum"
    ],
    "poisonings": [
        "poisoning"
    ],
    "precursors": [
        "precursor"
    ],
    "talliss": [
        "tallis"
    ],
    "amazons": [
        "amazon"
    ],
    "anthems": [
        "anthem"
    ],
    "budapests": [
        "budapest"
    ],
    "coverts": [
        "covert"
    ],
    "coverting": [
        "covert"
    ],
    "crippled": [
        "cripple"
    ],
    "cripples": [
        "cripple"
    ],
    "crippling": [
        "cripple"
    ],
    "deflected": [
        "deflect"
    ],
    "deflecting": [
        "deflect"
    ],
    "deflects": [
        "deflect"
    ],
    "foregrounding": [
        "foreground"
    ],
    "foregrounds": [
        "foreground"
    ],
    "foregrounded": [
        "foreground"
    ],
    "proxies": [
        "proxy"
    ],
    "proxied": [
        "proxy"
    ],
    "rafts": [
        "raft"
    ],
    "rafted": [
        "raft"
    ],
    "rebates": [
        "rebate"
    ],
    "rebated": [
        "rebate"
    ],
    "rebating": [
        "rebate"
    ],
    "richnesses": [
        "richness"
    ],
    "rustier": [
        "rusty"
    ],
    "rustiest": [
        "rusty"
    ],
    "sagged": [
        "sag"
    ],
    "sagging": [
        "sag"
    ],
    "sags": [
        "sag"
    ],
    "slovaks": [
        "slovak"
    ],
    "affiliated": [
        "affiliate"
    ],
    "affiliates": [
        "affiliate"
    ],
    "affiliating": [
        "affiliate"
    ],
    "brightened": [
        "brighten"
    ],
    "brightening": [
        "brighten"
    ],
    "brightens": [
        "brighten"
    ],
    "carboniferouss": [
        "carboniferous"
    ],
    "chores": [
        "chore"
    ],
    "clambered": [
        "clamber"
    ],
    "clambering": [
        "clamber"
    ],
    "clambers": [
        "clamber"
    ],
    "mischiefs": [
        "mischief"
    ],
    "mischiefing": [
        "mischief"
    ],
    "sensors": [
        "sensor"
    ],
    "transnationals": [
        "transnational"
    ],
    "turnouts": [
        "turnout"
    ],
    "whining": [
        "whine"
    ],
    "whined": [
        "whine"
    ],
    "whines": [
        "whine"
    ],
    "disappointed": [
        "disappoint"
    ],
    "disappointing": [
        "disappoint"
    ],
    "disappoints": [
        "disappoint"
    ],
    "elizabethans": [
        "elizabethan"
    ],
    "lattices": [
        "lattice"
    ],
    "latticed": [
        "lattice"
    ],
    "middletons": [
        "middleton"
    ],
    "motorings": [
        "motoring"
    ],
    "slugs": [
        "slug"
    ],
    "slugged": [
        "slug"
    ],
    "slugging": [
        "slug"
    ],
    "stockbrokers": [
        "stockbroker"
    ],
    "tellings": [
        "telling"
    ],
    "arbitrators": [
        "arbitrator"
    ],
    "beatrices": [
        "beatrice"
    ],
    "brownes": [
        "browne"
    ],
    "firings": [
        "firing"
    ],
    "harmonics": [
        "harmonic"
    ],
    "hoisted": [
        "hoist"
    ],
    "hoisting": [
        "hoist"
    ],
    "hoists": [
        "hoist"
    ],
    "overheard": [
        "overhear"
    ],
    "overhearing": [
        "overhear"
    ],
    "overhears": [
        "overhear"
    ],
    "saviours": [
        "saviour"
    ],
    "staled": [
        "stale"
    ],
    "staler": [
        "stale"
    ],
    "stales": [
        "stale"
    ],
    "staling": [
        "stale"
    ],
    "stalest": [
        "stale"
    ],
    "tallies": [
        "tally"
    ],
    "tallied": [
        "tally"
    ],
    "tallying": [
        "tally"
    ],
    "transmitters": [
        "transmitter"
    ],
    "backbones": [
        "backbone"
    ],
    "couriers": [
        "courier"
    ],
    "couriered": [
        "courier"
    ],
    "ghastliest": [
        "ghastly"
    ],
    "idioms": [
        "idiom"
    ],
    "indictments": [
        "indictment"
    ],
    "metrics": [
        "metric"
    ],
    "mozambiques": [
        "mozambique"
    ],
    "nestling": [
        "nestle"
    ],
    "nestled": [
        "nestle"
    ],
    "nestles": [
        "nestle"
    ],
    "pigmenting": [
        "pigment"
    ],
    "poultries": [
        "poultry"
    ],
    "prophecies": [
        "prophecy"
    ],
    "amplified": [
        "amplify"
    ],
    "amplifying": [
        "amplify"
    ],
    "bluffing": [
        "bluff"
    ],
    "bluffed": [
        "bluff"
    ],
    "brightnesses": [
        "brightness"
    ],
    "ccs": [
        "cc"
    ],
    "einsteins": [
        "einstein"
    ],
    "masteries": [
        "mastery"
    ],
    "orchids": [
        "orchid"
    ],
    "overridings": [
        "overriding"
    ],
    "tracies": [
        "tracy"
    ],
    "transcended": [
        "transcend"
    ],
    "transcends": [
        "transcend"
    ],
    "transcending": [
        "transcend"
    ],
    "brunoes": [
        "bruno"
    ],
    "cleavages": [
        "cleavage"
    ],
    "disparities": [
        "disparity"
    ],
    "fencings": [
        "fencing"
    ],
    "footings": [
        "footing"
    ],
    "manhattans": [
        "manhattan"
    ],
    "reformations": [
        "reformation"
    ],
    "rigours": [
        "rigour"
    ],
    "shrimps": [
        "shrimp"
    ],
    "shrimping": [
        "shrimp"
    ],
    "viscounts": [
        "viscount"
    ],
    "vogued": [
        "vogue"
    ],
    "vogueing": [
        "vogue"
    ],
    "whores": [
        "whore"
    ],
    "whoring": [
        "whore"
    ],
    "whored": [
        "whore"
    ],
    "bearers": [
        "bearer"
    ],
    "compressed": [
        "compress"
    ],
    "compressing": [
        "compress"
    ],
    "importers": [
        "importer"
    ],
    "ledgers": [
        "ledger"
    ],
    "ledgered": [
        "ledger"
    ],
    "ledgering": [
        "ledger"
    ],
    "relapsed": [
        "relapse"
    ],
    "relapsing": [
        "relapse"
    ],
    "scalped": [
        "scalp"
    ],
    "scalping": [
        "scalp"
    ],
    "sicilies": [
        "sicily"
    ],
    "thwarted": [
        "thwart"
    ],
    "thwarting": [
        "thwart"
    ],
    "thwarts": [
        "thwart"
    ],
    "battlefields": [
        "battlefield"
    ],
    "cpus": [
        "cpu"
    ],
    "earrings": [
        "earring"
    ],
    "erratics": [
        "erratic"
    ],
    "ferdinands": [
        "ferdinand"
    ],
    "kuwaitis": [
        "kuwaiti"
    ],
    "puritans": [
        "puritan"
    ],
    "reinstated": [
        "reinstate"
    ],
    "reinstating": [
        "reinstate"
    ],
    "reinstates": [
        "reinstate"
    ],
    "stickers": [
        "sticker"
    ],
    "tastier": [
        "tasty"
    ],
    "tastiest": [
        "tasty"
    ],
    "additives": [
        "additive"
    ],
    "alienations": [
        "alienation"
    ],
    "communing": [
        "commune"
    ],
    "communed": [
        "commune"
    ],
    "computed": [
        "compute"
    ],
    "computing": [
        "compute"
    ],
    "computes": [
        "compute"
    ],
    "contributories": [
        "contributory"
    ],
    "debited": [
        "debit"
    ],
    "debiting": [
        "debit"
    ],
    "embargoes": [
        "embargo"
    ],
    "embargoing": [
        "embargo"
    ],
    "embargoed": [
        "embargo"
    ],
    "melancholies": [
        "melancholy"
    ],
    "paralysed": [
        "paralyse"
    ],
    "paralysing": [
        "paralyse"
    ],
    "perished": [
        "perish"
    ],
    "perishing": [
        "perish"
    ],
    "perishes": [
        "perish"
    ],
    "phoebes": [
        "phoebe"
    ],
    "satans": [
        "satan"
    ],
    "touchings": [
        "touching"
    ],
    "vacationing": [
        "vacation"
    ],
    "vacationed": [
        "vacation"
    ],
    "beddings": [
        "bedding"
    ],
    "chlorines": [
        "chlorine"
    ],
    "diversified": [
        "diversify"
    ],
    "diversifying": [
        "diversify"
    ],
    "ordnances": [
        "ordnance"
    ],
    "reasonablenesses": [
        "reasonableness"
    ],
    "recesses": [
        "recess"
    ],
    "recessed": [
        "recess"
    ],
    "recessing": [
        "recess"
    ],
    "refurbishments": [
        "refurbishment"
    ],
    "sensibilities": [
        "sensibility"
    ],
    "unionisms": [
        "unionism"
    ],
    "annoyings": [
        "annoying"
    ],
    "horsemen": [
        "horseman"
    ],
    "houstons": [
        "houston"
    ],
    "idols": [
        "idol"
    ],
    "nappies": [
        "nappy"
    ],
    "refrigerators": [
        "refrigerator"
    ],
    "beaks": [
        "beak"
    ],
    "beaking": [
        "beak"
    ],
    "beaked": [
        "beak"
    ],
    "bonfires": [
        "bonfire"
    ],
    "expanses": [
        "expanse"
    ],
    "kingstons": [
        "kingston"
    ],
    "o'connors": [
        "o'connor"
    ],
    "pianists": [
        "pianist"
    ],
    "radiating": [
        "radiate"
    ],
    "radiated": [
        "radiate"
    ],
    "radiates": [
        "radiate"
    ],
    "savouring": [
        "savour"
    ],
    "savoured": [
        "savour"
    ],
    "savours": [
        "savour"
    ],
    "vanities": [
        "vanity"
    ],
    "availed": [
        "avail"
    ],
    "availing": [
        "avail"
    ],
    "avails": [
        "avail"
    ],
    "lotteries": [
        "lottery"
    ],
    "lynched": [
        "lynch"
    ],
    "lynching": [
        "lynch"
    ],
    "lynchs": [
        "lynch"
    ],
    "malignants": [
        "malignant"
    ],
    "shampoos": [
        "shampoo"
    ],
    "shampooed": [
        "shampoo"
    ],
    "splendours": [
        "splendour"
    ],
    "accelerators": [
        "accelerator"
    ],
    "anglians": [
        "anglian"
    ],
    "cowards": [
        "coward"
    ],
    "exponents": [
        "exponent"
    ],
    "foucaults": [
        "foucault"
    ],
    "hooves": [
        "hoof"
    ],
    "hoofs": [
        "hoof"
    ],
    "hoofed": [
        "hoof"
    ],
    "hoofing": [
        "hoof"
    ],
    "mansfields": [
        "mansfield"
    ],
    "minoans": [
        "minoan"
    ],
    "panting": [
        "pant"
    ],
    "panted": [
        "pant"
    ],
    "pants": [
        "pant"
    ],
    "predicaments": [
        "predicament"
    ],
    "relocated": [
        "relocate"
    ],
    "relocating": [
        "relocate"
    ],
    "relocates": [
        "relocate"
    ],
    "schizophrenias": [
        "schizophrenia"
    ],
    "settlors": [
        "settlor"
    ],
    "sprawled": [
        "sprawl"
    ],
    "sprawling": [
        "sprawl"
    ],
    "sprawls": [
        "sprawl"
    ],
    "squeaked": [
        "squeak"
    ],
    "squeaks": [
        "squeak"
    ],
    "squeaking": [
        "squeak"
    ],
    "tertiaries": [
        "tertiary"
    ],
    "unfits": [
        "unfit"
    ],
    "unfitting": [
        "unfit"
    ],
    "unfitted": [
        "unfit"
    ],
    "acrylics": [
        "acrylic"
    ],
    "angolas": [
        "angola"
    ],
    "blissing": [
        "bliss"
    ],
    "blissed": [
        "bliss"
    ],
    "blisses": [
        "bliss"
    ],
    "carriageways": [
        "carriageway"
    ],
    "clogged": [
        "clog"
    ],
    "clogs": [
        "clog"
    ],
    "clogging": [
        "clog"
    ],
    "contraceptions": [
        "contraception"
    ],
    "debentures": [
        "debenture"
    ],
    "duns": [
        "dun"
    ],
    "dunned": [
        "dun"
    ],
    "dunning": [
        "dun"
    ],
    "foals": [
        "foal"
    ],
    "foaling": [
        "foal"
    ],
    "foaled": [
        "foal"
    ],
    "hanks": [
        "hank"
    ],
    "hanker": [
        "hank"
    ],
    "hanked": [
        "hank"
    ],
    "paramilitaries": [
        "paramilitary"
    ],
    "parodied": [
        "parody"
    ],
    "parodying": [
        "parody"
    ],
    "squirrels": [
        "squirrel"
    ],
    "squirrelled": [
        "squirrel"
    ],
    "squirrelling": [
        "squirrel"
    ],
    "wedgwoods": [
        "wedgwood"
    ],
    "aromas": [
        "aroma"
    ],
    "awakened": [
        "awaken"
    ],
    "awakening": [
        "awaken"
    ],
    "awakens": [
        "awaken"
    ],
    "chairmanships": [
        "chairmanship"
    ],
    "contrived": [
        "contrive"
    ],
    "contriving": [
        "contrive"
    ],
    "contrives": [
        "contrive"
    ],
    "dabbed": [
        "dab"
    ],
    "dabbing": [
        "dab"
    ],
    "enshrined": [
        "enshrine"
    ],
    "enshrines": [
        "enshrine"
    ],
    "enshrining": [
        "enshrine"
    ],
    "greasiest": [
        "greasy"
    ],
    "greasier": [
        "greasy"
    ],
    "modernists": [
        "modernist"
    ],
    "orphans": [
        "orphan"
    ],
    "orphaned": [
        "orphan"
    ],
    "schoolgirls": [
        "schoolgirl"
    ],
    "shires": [
        "shire"
    ],
    "swivelled": [
        "swivel"
    ],
    "swivelling": [
        "swivel"
    ],
    "swivels": [
        "swivel"
    ],
    "uruguays": [
        "uruguay"
    ],
    "elasticities": [
        "elasticity"
    ],
    "furthering": [
        "further"
    ],
    "furthered": [
        "further"
    ],
    "furthers": [
        "further"
    ],
    "furtherst": [
        "further"
    ],
    "rectories": [
        "rectory"
    ],
    "recurs": [
        "recur"
    ],
    "recurred": [
        "recur"
    ],
    "recurring": [
        "recur"
    ],
    "renounced": [
        "renounce"
    ],
    "renouncing": [
        "renounce"
    ],
    "renounces": [
        "renounce"
    ],
    "brooms": [
        "broom"
    ],
    "chargings": [
        "charging"
    ],
    "enamels": [
        "enamel"
    ],
    "enamelled": [
        "enamel"
    ],
    "enamelling": [
        "enamel"
    ],
    "flinched": [
        "flinch"
    ],
    "flinching": [
        "flinch"
    ],
    "flinches": [
        "flinch"
    ],
    "overweights": [
        "overweight"
    ],
    "overweighted": [
        "overweight"
    ],
    "populated": [
        "populate"
    ],
    "populating": [
        "populate"
    ],
    "populates": [
        "populate"
    ],
    "cosmics": [
        "cosmic"
    ],
    "dizzied": [
        "dizzy"
    ],
    "dizzier": [
        "dizzy"
    ],
    "dizziest": [
        "dizzy"
    ],
    "dizzies": [
        "dizzy"
    ],
    "dizzying": [
        "dizzy"
    ],
    "fragranced": [
        "fragrance"
    ],
    "incidentals": [
        "incidental"
    ],
    "individualities": [
        "individuality"
    ],
    "modernisms": [
        "modernism"
    ],
    "parsleys": [
        "parsley"
    ],
    "pluralisms": [
        "pluralism"
    ],
    "primacies": [
        "primacy"
    ],
    "serbs": [
        "serb"
    ],
    "wharves": [
        "wharf"
    ],
    "wharfs": [
        "wharf"
    ],
    "wharfing": [
        "wharf"
    ],
    "wombs": [
        "womb"
    ],
    "wombed": [
        "womb"
    ],
    "auctioneers": [
        "auctioneer"
    ],
    "auctioneering": [
        "auctioneer"
    ],
    "johannesburgs": [
        "johannesburg"
    ],
    "marketplaces": [
        "marketplace"
    ],
    "ousted": [
        "oust"
    ],
    "ousting": [
        "oust"
    ],
    "ousts": [
        "oust"
    ],
    "revealings": [
        "revealing"
    ],
    "southeasts": [
        "southeast"
    ],
    "almighties": [
        "almighty"
    ],
    "barbarians": [
        "barbarian"
    ],
    "cravens": [
        "craven"
    ],
    "deferreds": [
        "deferred"
    ],
    "greenwiches": [
        "greenwich"
    ],
    "learing": [
        "lear"
    ],
    "maples": [
        "maple"
    ],
    "matings": [
        "mating"
    ],
    "necklaces": [
        "necklace"
    ],
    "necklaced": [
        "necklace"
    ],
    "necklacing": [
        "necklace"
    ],
    "orcs": [
        "orc"
    ],
    "redevelopments": [
        "redevelopment"
    ],
    "respites": [
        "respite"
    ],
    "respiting": [
        "respite"
    ],
    "respited": [
        "respite"
    ],
    "reviewers": [
        "reviewer"
    ],
    "scribbled": [
        "scribble"
    ],
    "scribbling": [
        "scribble"
    ],
    "scribbles": [
        "scribble"
    ],
    "scrums": [
        "scrum"
    ],
    "scrummed": [
        "scrum"
    ],
    "undertakers": [
        "undertaker"
    ],
    "untidier": [
        "untidy"
    ],
    "untidiest": [
        "untidy"
    ],
    "automations": [
        "automation"
    ],
    "ballads": [
        "ballad"
    ],
    "cassies": [
        "cassie"
    ],
    "creamier": [
        "creamy"
    ],
    "creamiest": [
        "creamy"
    ],
    "frescoes": [
        "fresco"
    ],
    "frescos": [
        "fresco"
    ],
    "gagged": [
        "gag"
    ],
    "gagging": [
        "gag"
    ],
    "inventors": [
        "inventor"
    ],
    "lanced": [
        "lance"
    ],
    "lancing": [
        "lance"
    ],
    "ornamentals": [
        "ornamental"
    ],
    "predominated": [
        "predominate"
    ],
    "predominates": [
        "predominate"
    ],
    "predominating": [
        "predominate"
    ],
    "shadowier": [
        "shadowy"
    ],
    "shannons": [
        "shannon"
    ],
    "simulated": [
        "simulate"
    ],
    "simulating": [
        "simulate"
    ],
    "simulates": [
        "simulate"
    ],
    "beatless": [
        "beatles"
    ],
    "crimsons": [
        "crimson"
    ],
    "crimsoned": [
        "crimson"
    ],
    "ernsts": [
        "ernst"
    ],
    "individualisms": [
        "individualism"
    ],
    "latched": [
        "latch"
    ],
    "latches": [
        "latch"
    ],
    "latching": [
        "latch"
    ],
    "lengthened": [
        "lengthen"
    ],
    "lengthening": [
        "lengthen"
    ],
    "lengthens": [
        "lengthen"
    ],
    "muddled": [
        "muddle"
    ],
    "muddling": [
        "muddle"
    ],
    "muddles": [
        "muddle"
    ],
    "relegated": [
        "relegate"
    ],
    "relegating": [
        "relegate"
    ],
    "relegates": [
        "relegate"
    ],
    "renewables": [
        "renewable"
    ],
    "swarmed": [
        "swarm"
    ],
    "swarming": [
        "swarm"
    ],
    "swarms": [
        "swarm"
    ],
    "astronomers": [
        "astronomer"
    ],
    "expatriates": [
        "expatriate"
    ],
    "expatriated": [
        "expatriate"
    ],
    "grafted": [
        "graft"
    ],
    "grafts": [
        "graft"
    ],
    "grafting": [
        "graft"
    ],
    "opecs": [
        "opec"
    ],
    "sects": [
        "sect"
    ],
    "slovenias": [
        "slovenia"
    ],
    "adamants": [
        "adamant"
    ],
    "ayrshires": [
        "ayrshire"
    ],
    "buffs": [
        "buff"
    ],
    "buffing": [
        "buff"
    ],
    "buffed": [
        "buff"
    ],
    "candied": [
        "candy"
    ],
    "candies": [
        "candy"
    ],
    "cods": [
        "cod"
    ],
    "codding": [
        "cod"
    ],
    "codded": [
        "cod"
    ],
    "cod": [
        "cod"
    ],
    "commonest": [
        "commone"
    ],
    "commoner": [
        "commone"
    ],
    "crocodiled": [
        "crocodile"
    ],
    "distastes": [
        "distaste"
    ],
    "endoscopies": [
        "endoscopy"
    ],
    "integers": [
        "integer"
    ],
    "offerors": [
        "offeror"
    ],
    "predicates": [
        "predicate"
    ],
    "predicated": [
        "predicate"
    ],
    "predicating": [
        "predicate"
    ],
    "shoals": [
        "shoal"
    ],
    "shoaling": [
        "shoal"
    ],
    "shoaled": [
        "shoal"
    ],
    "stylings": [
        "styling"
    ],
    "symbolisms": [
        "symbolism"
    ],
    "unavailables": [
        "unavailable"
    ],
    "delicacies": [
        "delicacy"
    ],
    "diversifications": [
        "diversification"
    ],
    "pavings": [
        "paving"
    ],
    "allotments": [
        "allotment"
    ],
    "azerbaijans": [
        "azerbaijan"
    ],
    "excavated": [
        "excavate"
    ],
    "excavating": [
        "excavate"
    ],
    "excavates": [
        "excavate"
    ],
    "motorbikes": [
        "motorbike"
    ],
    "motorbiking": [
        "motorbike"
    ],
    "oligonucleotides": [
        "oligonucleotide"
    ],
    "photocopied": [
        "photocopy"
    ],
    "photocopying": [
        "photocopy"
    ],
    "rewritten": [
        "rewrite"
    ],
    "rewrites": [
        "rewrite"
    ],
    "rewriting": [
        "rewrite"
    ],
    "rewrote": [
        "rewrite"
    ],
    "rottweilers": [
        "rottweiler"
    ],
    "subsidised": [
        "subsidise"
    ],
    "subsidising": [
        "subsidise"
    ],
    "subsidises": [
        "subsidise"
    ],
    "u.k.s": [
        "u.k."
    ],
    "anaesthetics": [
        "anaesthetic"
    ],
    "gabling": [
        "gable"
    ],
    "organizers": [
        "organizer"
    ],
    "statelier": [
        "stately"
    ],
    "stateliest": [
        "stately"
    ],
    "accentuated": [
        "accentuate"
    ],
    "accentuates": [
        "accentuate"
    ],
    "accentuating": [
        "accentuate"
    ],
    "adjustables": [
        "adjustable"
    ],
    "bereavements": [
        "bereavement"
    ],
    "complexions": [
        "complexion"
    ],
    "daggers": [
        "dagger"
    ],
    "daggered": [
        "dagger"
    ],
    "farmlands": [
        "farmland"
    ],
    "glenns": [
        "glenn"
    ],
    "implanted": [
        "implant"
    ],
    "implanting": [
        "implant"
    ],
    "mo's": [
        "mo"
    ],
    "mystics": [
        "mystic"
    ],
    "parables": [
        "parable"
    ],
    "postages": [
        "postage"
    ],
    "rhetoricals": [
        "rhetorical"
    ],
    "theologians": [
        "theologian"
    ],
    "thirsting": [
        "thirst"
    ],
    "thirsts": [
        "thirst"
    ],
    "thirsted": [
        "thirst"
    ],
    "colting": [
        "colt"
    ],
    "engendered": [
        "engender"
    ],
    "engenders": [
        "engender"
    ],
    "engendering": [
        "engender"
    ],
    "hoovering": [
        "hoover"
    ],
    "hoovered": [
        "hoover"
    ],
    "hoovers": [
        "hoover"
    ],
    "sullivans": [
        "sullivan"
    ],
    "taes": [
        "tae"
    ],
    "acquainted": [
        "acquaint"
    ],
    "acquainting": [
        "acquaint"
    ],
    "acquaints": [
        "acquaint"
    ],
    "bunks": [
        "bunk"
    ],
    "bunked": [
        "bunk"
    ],
    "bunking": [
        "bunk"
    ],
    "earmarked": [
        "earmark"
    ],
    "earmarking": [
        "earmark"
    ],
    "earmarks": [
        "earmark"
    ],
    "effluents": [
        "effluent"
    ],
    "gibraltars": [
        "gibraltar"
    ],
    "hamburgs": [
        "hamburg"
    ],
    "harassed": [
        "harass"
    ],
    "harassing": [
        "harass"
    ],
    "illegitimates": [
        "illegitimate"
    ],
    "imparted": [
        "impart"
    ],
    "imparting": [
        "impart"
    ],
    "imparts": [
        "impart"
    ],
    "infringed": [
        "infringe"
    ],
    "infringing": [
        "infringe"
    ],
    "infringes": [
        "infringe"
    ],
    "infringer": [
        "infringe"
    ],
    "maggots": [
        "maggot"
    ],
    "twilights": [
        "twilight"
    ],
    "browsing": [
        "browse"
    ],
    "browsed": [
        "browse"
    ],
    "browses": [
        "browse"
    ],
    "chanceries": [
        "chancery"
    ],
    "cubs": [
        "cub"
    ],
    "cubbing": [
        "cub"
    ],
    "depletions": [
        "depletion"
    ],
    "drummers": [
        "drummer"
    ],
    "mentalities": [
        "mentality"
    ],
    "pekings": [
        "peking"
    ],
    "ransoms": [
        "ransom"
    ],
    "ransoming": [
        "ransom"
    ],
    "ransomed": [
        "ransom"
    ],
    "thickened": [
        "thicken"
    ],
    "thickening": [
        "thicken"
    ],
    "thickens": [
        "thicken"
    ],
    "wetlands": [
        "wetland"
    ],
    "wreckages": [
        "wreckage"
    ],
    "ammonias": [
        "ammonia"
    ],
    "cladding": [
        "clad"
    ],
    "clads": [
        "clad"
    ],
    "commas": [
        "comma"
    ],
    "darings": [
        "daring"
    ],
    "deplored": [
        "deplore"
    ],
    "deploring": [
        "deplore"
    ],
    "formatives": [
        "formative"
    ],
    "groceries": [
        "grocery"
    ],
    "miamis": [
        "miami"
    ],
    "recaptured": [
        "recapture"
    ],
    "recapturing": [
        "recapture"
    ],
    "recaptures": [
        "recapture"
    ],
    "sabotaged": [
        "sabotage"
    ],
    "sabotaging": [
        "sabotage"
    ],
    "stunts": [
        "stunt"
    ],
    "stunted": [
        "stunt"
    ],
    "stunting": [
        "stunt"
    ],
    "tinged": [
        "tinge"
    ],
    "tinges": [
        "tinge"
    ],
    "tingeing": [
        "tinge"
    ],
    "unleashed": [
        "unleash"
    ],
    "unleashing": [
        "unleash"
    ],
    "unleashes": [
        "unleash"
    ],
    "waitresses": [
        "waitress"
    ],
    "waitressing": [
        "waitress"
    ],
    "waitressed": [
        "waitress"
    ],
    "watchdogs": [
        "watchdog"
    ],
    "augustuss": [
        "augustus"
    ],
    "calders": [
        "calder"
    ],
    "caterpillars": [
        "caterpillar"
    ],
    "cortexes": [
        "cortex"
    ],
    "cortices": [
        "cortex"
    ],
    "credentialss": [
        "credentials"
    ],
    "devoured": [
        "devour"
    ],
    "devouring": [
        "devour"
    ],
    "devours": [
        "devour"
    ],
    "froing": [
        "fro"
    ],
    "fros": [
        "fro"
    ],
    "glazed": [
        "glaze"
    ],
    "glazing": [
        "glaze"
    ],
    "glazes": [
        "glaze"
    ],
    "nipples": [
        "nipple"
    ],
    "nippled": [
        "nipple"
    ],
    "nobels": [
        "nobel"
    ],
    "notched": [
        "notch"
    ],
    "notches": [
        "notch"
    ],
    "notching": [
        "notch"
    ],
    "signatories": [
        "signatory"
    ],
    "telegrams": [
        "telegram"
    ],
    "toyotas": [
        "toyota"
    ],
    "tradesmen": [
        "tradesman"
    ],
    "undersides": [
        "underside"
    ],
    "apartheids": [
        "apartheid"
    ],
    "austens": [
        "austen"
    ],
    "bankss": [
        "banks"
    ],
    "boileds": [
        "boiled"
    ],
    "braggs": [
        "bragg"
    ],
    "literates": [
        "literate"
    ],
    "luncheons": [
        "luncheon"
    ],
    "outpatients": [
        "outpatient"
    ],
    "railings": [
        "railing"
    ],
    "sewings": [
        "sewing"
    ],
    "skimming": [
        "skim"
    ],
    "skimmed": [
        "skim"
    ],
    "skims": [
        "skim"
    ],
    "tendernesses": [
        "tenderness"
    ],
    "wirings": [
        "wiring"
    ],
    "anaemias": [
        "anaemia"
    ],
    "bristles": [
        "bristle"
    ],
    "bristling": [
        "bristle"
    ],
    "bristled": [
        "bristle"
    ],
    "clothed": [
        "clothe"
    ],
    "clothes": [
        "clothe"
    ],
    "cloathing": [
        "clothe"
    ],
    "clad": [
        "clothe"
    ],
    "clothing": [
        "clothe"
    ],
    "metaphysicals": [
        "metaphysical"
    ],
    "nepals": [
        "nepal"
    ],
    "precedences": [
        "precedence"
    ],
    "rubbles": [
        "rubble"
    ],
    "throttled": [
        "throttle"
    ],
    "throttles": [
        "throttle"
    ],
    "throttling": [
        "throttle"
    ],
    "abiding": [
        "abide"
    ],
    "abides": [
        "abide"
    ],
    "abided": [
        "abide"
    ],
    "abode": [
        "abide"
    ],
    "chernobyls": [
        "chernobyl"
    ],
    "chillies": [
        "chilly",
        "chilli"
    ],
    "chillier": [
        "chilly"
    ],
    "chilliest": [
        "chilly"
    ],
    "ebbed": [
        "ebb"
    ],
    "ebbs": [
        "ebb"
    ],
    "ebbing": [
        "ebb",
        "eb"
    ],
    "gullies": [
        "gully"
    ],
    "gullying": [
        "gully"
    ],
    "gullied": [
        "gully"
    ],
    "hazes": [
        "haze"
    ],
    "hazed": [
        "haze"
    ],
    "hazing": [
        "haze"
    ],
    "magnates": [
        "magnate"
    ],
    "overshadowed": [
        "overshadow"
    ],
    "overshadowing": [
        "overshadow"
    ],
    "overshadows": [
        "overshadow"
    ],
    "propagated": [
        "propagate"
    ],
    "propagating": [
        "propagate"
    ],
    "propagates": [
        "propagate"
    ],
    "stormiest": [
        "stormy"
    ],
    "stormier": [
        "stormy"
    ],
    "ancillaries": [
        "ancillary"
    ],
    "briefcases": [
        "briefcase"
    ],
    "brilliances": [
        "brilliance"
    ],
    "brookss": [
        "brooks"
    ],
    "chimpanzees": [
        "chimpanzee"
    ],
    "coolings": [
        "cooling"
    ],
    "couplings": [
        "coupling"
    ],
    "haemorrhages": [
        "haemorrhage"
    ],
    "haemorrhaging": [
        "haemorrhage"
    ],
    "haemorrhaged": [
        "haemorrhage"
    ],
    "joeys": [
        "joey"
    ],
    "mccarthies": [
        "mccarthy"
    ],
    "messier": [
        "messy"
    ],
    "messiest": [
        "messy"
    ],
    "morbidities": [
        "morbidity"
    ],
    "subtleties": [
        "subtlety"
    ],
    "artworks": [
        "artwork"
    ],
    "auspicess": [
        "auspices"
    ],
    "coconuts": [
        "coconut"
    ],
    "livelihoods": [
        "livelihood"
    ],
    "outnumbered": [
        "outnumber"
    ],
    "outnumbering": [
        "outnumber"
    ],
    "outnumbers": [
        "outnumber"
    ],
    "replicated": [
        "replicate"
    ],
    "replicating": [
        "replicate"
    ],
    "replicates": [
        "replicate"
    ],
    "sinclairs": [
        "sinclair"
    ],
    "staminas": [
        "stamina"
    ],
    "subjectivities": [
        "subjectivity"
    ],
    "uniformities": [
        "uniformity"
    ],
    "brents": [
        "brent"
    ],
    "elapsed": [
        "elapse"
    ],
    "elapses": [
        "elapse"
    ],
    "elapsing": [
        "elapse"
    ],
    "herculess": [
        "hercules"
    ],
    "nras": [
        "nra"
    ],
    "readerships": [
        "readership"
    ],
    "showrooms": [
        "showroom"
    ],
    "shreds": [
        "shred"
    ],
    "shredded": [
        "shred"
    ],
    "shredding": [
        "shred"
    ],
    "stoddards": [
        "stoddard"
    ],
    "stonier": [
        "stony"
    ],
    "stoniest": [
        "stony"
    ],
    "suitabilities": [
        "suitability"
    ],
    "synonyms": [
        "synonym"
    ],
    "tanzanias": [
        "tanzania"
    ],
    "thronged": [
        "throng"
    ],
    "thronging": [
        "throng"
    ],
    "throngs": [
        "throng"
    ],
    "traitors": [
        "traitor"
    ],
    "unravelling": [
        "unravel"
    ],
    "unravelled": [
        "unravel"
    ],
    "unravels": [
        "unravel"
    ],
    "certifications": [
        "certification"
    ],
    "curated": [
        "curate"
    ],
    "curates": [
        "curate"
    ],
    "curating": [
        "curate"
    ],
    "engulfed": [
        "engulf"
    ],
    "engulfing": [
        "engulf"
    ],
    "engulfs": [
        "engulf"
    ],
    "enrolments": [
        "enrolment"
    ],
    "erased": [
        "erase"
    ],
    "erasing": [
        "erase"
    ],
    "erases": [
        "erase"
    ],
    "esthers": [
        "esther"
    ],
    "motorcycles": [
        "motorcycle"
    ],
    "potassiums": [
        "potassium"
    ],
    "prodded": [
        "prod"
    ],
    "prodding": [
        "prod"
    ],
    "prods": [
        "prod"
    ],
    "volleys": [
        "volley"
    ],
    "volleyed": [
        "volley"
    ],
    "volleying": [
        "volley"
    ],
    "blacknesses": [
        "blackness"
    ],
    "bombays": [
        "bombay"
    ],
    "eyres": [
        "eyre"
    ],
    "flairs": [
        "flair"
    ],
    "flairing": [
        "flair"
    ],
    "hives": [
        "hive"
    ],
    "hived": [
        "hive"
    ],
    "hiving": [
        "hive"
    ],
    "impeded": [
        "impede"
    ],
    "impeding": [
        "impede"
    ],
    "impedes": [
        "impede"
    ],
    "lighthouses": [
        "lighthouse"
    ],
    "naturalists": [
        "naturalist"
    ],
    "negligenter": [
        "negligent"
    ],
    "sager": [
        "sage"
    ],
    "sagest": [
        "sage"
    ],
    "steroids": [
        "steroid"
    ],
    "thematics": [
        "thematic"
    ],
    "volatilities": [
        "volatility"
    ],
    "authenticities": [
        "authenticity"
    ],
    "feeders": [
        "feeder"
    ],
    "householders": [
        "householder"
    ],
    "immersed": [
        "immerse"
    ],
    "immersing": [
        "immerse"
    ],
    "immerses": [
        "immerse"
    ],
    "palazzos": [
        "palazzo"
    ],
    "snags": [
        "snag"
    ],
    "snagged": [
        "snag"
    ],
    "snagging": [
        "snag"
    ],
    "terences": [
        "terence"
    ],
    "thawed": [
        "thaw"
    ],
    "thawing": [
        "thaw"
    ],
    "thaws": [
        "thaw"
    ],
    "undergrowths": [
        "undergrowth"
    ],
    "utilized": [
        "utilize"
    ],
    "utilizing": [
        "utilize"
    ],
    "utilizes": [
        "utilize"
    ],
    "captivities": [
        "captivity"
    ],
    "fragmentations": [
        "fragmentation"
    ],
    "galileos": [
        "galileo"
    ],
    "masculinities": [
        "masculinity"
    ],
    "roaches": [
        "roach"
    ],
    "roosevelts": [
        "roosevelt"
    ],
    "stunned": [
        "stun"
    ],
    "stunning": [
        "stun"
    ],
    "stuns": [
        "stun"
    ],
    "thudding": [
        "thud"
    ],
    "thudded": [
        "thud"
    ],
    "thuds": [
        "thud"
    ],
    "uptakes": [
        "uptake"
    ],
    "bilinguals": [
        "bilingual"
    ],
    "comets": [
        "comet"
    ],
    "conveyances": [
        "conveyance"
    ],
    "fertilizers": [
        "fertilizer"
    ],
    "firths": [
        "firth"
    ],
    "sexists": [
        "sexist"
    ],
    "shovels": [
        "shovel"
    ],
    "shovelling": [
        "shovel"
    ],
    "shovelled": [
        "shovel"
    ],
    "uphills": [
        "uphill"
    ],
    "willies": [
        "willy"
    ],
    "willys": [
        "willy"
    ],
    "ayrs": [
        "ayr"
    ],
    "blacksmiths": [
        "blacksmith"
    ],
    "childbirths": [
        "childbirth"
    ],
    "devalued": [
        "devalue"
    ],
    "devaluing": [
        "devalue"
    ],
    "groining": [
        "groin"
    ],
    "harrowing": [
        "harrow"
    ],
    "harrows": [
        "harrow"
    ],
    "harrowed": [
        "harrow"
    ],
    "mackenzies": [
        "mackenzie"
    ],
    "perks": [
        "perk"
    ],
    "perked": [
        "perk"
    ],
    "perking": [
        "perk"
    ],
    "rowings": [
        "rowing"
    ],
    "sartres": [
        "sartre"
    ],
    "sidelines": [
        "sideline"
    ],
    "sidelined": [
        "sideline"
    ],
    "sidelining": [
        "sideline"
    ],
    "baled": [
        "bale"
    ],
    "baling": [
        "bale"
    ],
    "carnivals": [
        "carnival"
    ],
    "cisterns": [
        "cistern"
    ],
    "countenanced": [
        "countenance"
    ],
    "countenances": [
        "countenance"
    ],
    "countenancing": [
        "countenance"
    ],
    "counteracted": [
        "counteract"
    ],
    "counteracting": [
        "counteract"
    ],
    "counteracts": [
        "counteract"
    ],
    "cursors": [
        "cursor"
    ],
    "gipsies": [
        "gipsy"
    ],
    "kennels": [
        "kennel"
    ],
    "kennelled": [
        "kennel"
    ],
    "lanterns": [
        "lantern"
    ],
    "melbournes": [
        "melbourne"
    ],
    "openers": [
        "opener"
    ],
    "osbornes": [
        "osborne"
    ],
    "pictorials": [
        "pictorial"
    ],
    "signposted": [
        "signpost"
    ],
    "signposts": [
        "signpost"
    ],
    "signposting": [
        "signpost"
    ],
    "tauter": [
        "taut"
    ],
    "tauting": [
        "taut"
    ],
    "tautest": [
        "taut"
    ],
    "tuberculoses": [
        "tuberculosis"
    ],
    "tunas": [
        "tuna"
    ],
    "tuna": [
        "tuna"
    ],
    "abcs": [
        "abc"
    ],
    "berths": [
        "berth"
    ],
    "berthed": [
        "berth"
    ],
    "berthing": [
        "berth"
    ],
    "conversing": [
        "converse"
    ],
    "conversed": [
        "converse"
    ],
    "eels": [
        "eel"
    ],
    "eeling": [
        "eel"
    ],
    "ghanas": [
        "ghana"
    ],
    "moodier": [
        "moody"
    ],
    "moodys": [
        "moody"
    ],
    "moodiest": [
        "moody"
    ],
    "porcelains": [
        "porcelain"
    ],
    "queers": [
        "queer"
    ],
    "queerest": [
        "queer"
    ],
    "queering": [
        "queer"
    ],
    "queerer": [
        "queer"
    ],
    "queered": [
        "queer"
    ],
    "queeres": [
        "queer"
    ],
    "repatriations": [
        "repatriation"
    ],
    "apping": [
        "ap"
    ],
    "aps": [
        "ap"
    ],
    "aspirins": [
        "aspirin"
    ],
    "bettered": [
        "better"
    ],
    "betters": [
        "better"
    ],
    "bettering": [
        "better"
    ],
    "drakes": [
        "drake"
    ],
    "numbed": [
        "numb"
    ],
    "numbing": [
        "numb"
    ],
    "numbs": [
        "numb"
    ],
    "number": [
        "numb"
    ],
    "overdosed": [
        "overdose"
    ],
    "overdosing": [
        "overdose"
    ],
    "peeped": [
        "peep"
    ],
    "peeping": [
        "peep"
    ],
    "peeps": [
        "peep"
    ],
    "scandinavias": [
        "scandinavia"
    ],
    "screeched": [
        "screech"
    ],
    "screeching": [
        "screech"
    ],
    "screeches": [
        "screech"
    ],
    "soothed": [
        "soothe"
    ],
    "soothes": [
        "soothe"
    ],
    "soothing": [
        "soothe"
    ],
    "brimming": [
        "brim"
    ],
    "brimmed": [
        "brim"
    ],
    "brims": [
        "brim"
    ],
    "buchanans": [
        "buchanan"
    ],
    "conservationists": [
        "conservationist"
    ],
    "dells": [
        "dell"
    ],
    "goldfishes": [
        "goldfish"
    ],
    "goldfish": [
        "goldfish"
    ],
    "sidneys": [
        "sidney"
    ],
    "tamils": [
        "tamil"
    ],
    "twinkling": [
        "twinkle"
    ],
    "twinkled": [
        "twinkle"
    ],
    "twinkles": [
        "twinkle"
    ],
    "adversaries": [
        "adversary"
    ],
    "asses": [
        "ass"
    ],
    "assed": [
        "ass"
    ],
    "fanatics": [
        "fanatic"
    ],
    "flirting": [
        "flirt"
    ],
    "flirted": [
        "flirt"
    ],
    "knickerss": [
        "knickers"
    ],
    "knitters": [
        "knitter"
    ],
    "malls": [
        "mall"
    ],
    "malling": [
        "mall"
    ],
    "ridleys": [
        "ridley"
    ],
    "savers": [
        "saver"
    ],
    "spaniards": [
        "spaniard"
    ],
    "squealed": [
        "squeal"
    ],
    "squealing": [
        "squeal"
    ],
    "squeals": [
        "squeal"
    ],
    "stillnesses": [
        "stillness"
    ],
    "bucharests": [
        "bucharest"
    ],
    "certified": [
        "certify"
    ],
    "certifying": [
        "certify"
    ],
    "complacencies": [
        "complacency"
    ],
    "conspiring": [
        "conspire"
    ],
    "conspired": [
        "conspire"
    ],
    "conspires": [
        "conspire"
    ],
    "coses": [
        "cose"
    ],
    "crackled": [
        "crackle"
    ],
    "crackling": [
        "crackle"
    ],
    "crackles": [
        "crackle"
    ],
    "fellas": [
        "fella"
    ],
    "hallmarks": [
        "hallmark"
    ],
    "hallmarked": [
        "hallmark"
    ],
    "hallmarking": [
        "hallmark"
    ],
    "kbs": [
        "kb"
    ],
    "overlappings": [
        "overlapping"
    ],
    "sohoes": [
        "soho"
    ],
    "stephensons": [
        "stephenson"
    ],
    "welded": [
        "weld"
    ],
    "welds": [
        "weld"
    ],
    "welding": [
        "weld"
    ],
    "biotechnologies": [
        "biotechnology"
    ],
    "brownies": [
        "browny"
    ],
    "californians": [
        "californian"
    ],
    "countrymen": [
        "countryman"
    ],
    "depressed": [
        "depress"
    ],
    "depresses": [
        "depress"
    ],
    "depressing": [
        "depress"
    ],
    "dispersals": [
        "dispersal"
    ],
    "exaggerations": [
        "exaggeration"
    ],
    "galways": [
        "galway"
    ],
    "hubs": [
        "hub"
    ],
    "jabbed": [
        "jab"
    ],
    "jabbing": [
        "jab"
    ],
    "jabs": [
        "jab"
    ],
    "jamaicans": [
        "jamaican"
    ],
    "londoners": [
        "londoner"
    ],
    "philadelphias": [
        "philadelphia"
    ],
    "pruned": [
        "prune"
    ],
    "pruning": [
        "prune"
    ],
    "rarities": [
        "rarity"
    ],
    "splinters": [
        "splinter"
    ],
    "splintered": [
        "splinter"
    ],
    "splintering": [
        "splinter"
    ],
    "thrushes": [
        "thrush"
    ],
    "undressed": [
        "undress"
    ],
    "undressing": [
        "undress"
    ],
    "undresses": [
        "undress"
    ],
    "waned": [
        "wane"
    ],
    "waning": [
        "wane"
    ],
    "wanes": [
        "wane"
    ],
    "woolleys": [
        "woolley"
    ],
    "activators": [
        "activator"
    ],
    "astronomies": [
        "astronomy"
    ],
    "buttresses": [
        "buttress"
    ],
    "buttressed": [
        "buttress"
    ],
    "buttressing": [
        "buttress"
    ],
    "camouflaged": [
        "camouflage"
    ],
    "camouflaging": [
        "camouflage"
    ],
    "deacons": [
        "deacon"
    ],
    "dysons": [
        "dyson"
    ],
    "flowings": [
        "flowing"
    ],
    "macbeths": [
        "macbeth"
    ],
    "mileages": [
        "mileage"
    ],
    "ows": [
        "ow"
    ],
    "ower": [
        "ow"
    ],
    "shamen": [
        "shaman"
    ],
    "stationeries": [
        "stationery"
    ],
    "wildes": [
        "wilde"
    ],
    "decencies": [
        "decency"
    ],
    "flanderss": [
        "flanders"
    ],
    "housekeepings": [
        "housekeeping"
    ],
    "imperfects": [
        "imperfect"
    ],
    "larks": [
        "lark"
    ],
    "larking": [
        "lark"
    ],
    "larked": [
        "lark"
    ],
    "ploys": [
        "ploy"
    ],
    "ployed": [
        "ploy"
    ],
    "sheikhs": [
        "sheikh"
    ],
    "sparser": [
        "sparse"
    ],
    "sparsest": [
        "sparse"
    ],
    "treasons": [
        "treason"
    ],
    "waived": [
        "waive"
    ],
    "waiving": [
        "waive"
    ],
    "waives": [
        "waive"
    ],
    "camdens": [
        "camden"
    ],
    "consignments": [
        "consignment"
    ],
    "cookes": [
        "cooke"
    ],
    "imagings": [
        "imaging"
    ],
    "impossibilities": [
        "impossibility"
    ],
    "inaugurals": [
        "inaugural"
    ],
    "lipids": [
        "lipid"
    ],
    "lithuanians": [
        "lithuanian"
    ],
    "otters": [
        "otter"
    ],
    "overloaded": [
        "overload"
    ],
    "overloading": [
        "overload"
    ],
    "overloads": [
        "overload"
    ],
    "pitfalls": [
        "pitfall"
    ],
    "rebuked": [
        "rebuke"
    ],
    "rebuking": [
        "rebuke"
    ],
    "rebukes": [
        "rebuke"
    ],
    "totalities": [
        "totality"
    ],
    "agrarians": [
        "agrarian"
    ],
    "armenians": [
        "armenian"
    ],
    "baffled": [
        "baffle"
    ],
    "baffling": [
        "baffle"
    ],
    "carryings": [
        "carrying"
    ],
    "grenaded": [
        "grenade"
    ],
    "inertias": [
        "inertia"
    ],
    "invertebrates": [
        "invertebrate"
    ],
    "islanders": [
        "islander"
    ],
    "lairds": [
        "laird"
    ],
    "mincing": [
        "mince"
    ],
    "minced": [
        "mince"
    ],
    "prussias": [
        "prussia"
    ],
    "tinkering": [
        "tinker"
    ],
    "tinkers": [
        "tinker"
    ],
    "tinkered": [
        "tinker"
    ],
    "associatives": [
        "associative"
    ],
    "bailiffs": [
        "bailiff"
    ],
    "belongingss": [
        "belongings"
    ],
    "bulkier": [
        "bulky"
    ],
    "bulkiest": [
        "bulky"
    ],
    "callings": [
        "calling"
    ],
    "crumbs": [
        "crumb"
    ],
    "crumbed": [
        "crumb"
    ],
    "degrading": [
        "degrade"
    ],
    "degraded": [
        "degrade"
    ],
    "dictators": [
        "dictator"
    ],
    "emigrations": [
        "emigration"
    ],
    "fags": [
        "fag"
    ],
    "fagged": [
        "fag"
    ],
    "fagging": [
        "fag"
    ],
    "generalities": [
        "generality"
    ],
    "humps": [
        "hump"
    ],
    "humped": [
        "hump"
    ],
    "humping": [
        "hump"
    ],
    "landladies": [
        "landlady"
    ],
    "mottos": [
        "motto"
    ],
    "mottoes": [
        "motto"
    ],
    "obsoleted": [
        "obsolete"
    ],
    "obsoleting": [
        "obsolete"
    ],
    "polyps": [
        "polyp"
    ],
    "wraths": [
        "wrath"
    ],
    "fiats": [
        "fiat"
    ],
    "ingenuities": [
        "ingenuity"
    ],
    "jolted": [
        "jolt"
    ],
    "jolting": [
        "jolt"
    ],
    "jolts": [
        "jolt"
    ],
    "mountings": [
        "mounting"
    ],
    "oysters": [
        "oyster"
    ],
    "prams": [
        "pram"
    ],
    "prammed": [
        "pram"
    ],
    "ravaged": [
        "ravage"
    ],
    "ravaging": [
        "ravage"
    ],
    "rustling": [
        "rustle"
    ],
    "rustled": [
        "rustle"
    ],
    "rustles": [
        "rustle"
    ],
    "sonatas": [
        "sonata"
    ],
    "supernaturals": [
        "supernatural"
    ],
    "wrestled": [
        "wrestle"
    ],
    "wrestling": [
        "wrestle"
    ],
    "wrestles": [
        "wrestle"
    ],
    "antonies": [
        "antony"
    ],
    "bingoes": [
        "bingo"
    ],
    "disbanded": [
        "disband"
    ],
    "disbanding": [
        "disband"
    ],
    "disbands": [
        "disband"
    ],
    "flasks": [
        "flask"
    ],
    "flasked": [
        "flask"
    ],
    "guatemalas": [
        "guatemala"
    ],
    "hals": [
        "hal"
    ],
    "homelessnesses": [
        "homelessness"
    ],
    "hued": [
        "hue"
    ],
    "looted": [
        "loot"
    ],
    "looting": [
        "loot"
    ],
    "loots": [
        "loot"
    ],
    "muhammads": [
        "muhammad"
    ],
    "showings": [
        "showing"
    ],
    "specializations": [
        "specialization"
    ],
    "spotteds": [
        "spotted"
    ],
    "synods": [
        "synod"
    ],
    "afflicted": [
        "afflict"
    ],
    "afflicts": [
        "afflict"
    ],
    "afflicting": [
        "afflict"
    ],
    "buddhists": [
        "buddhist"
    ],
    "culleys": [
        "culley"
    ],
    "defiants": [
        "defiant"
    ],
    "headier": [
        "heady"
    ],
    "headiest": [
        "heady"
    ],
    "heftier": [
        "hefty"
    ],
    "heftiest": [
        "hefty"
    ],
    "humiliated": [
        "humiliate"
    ],
    "humiliating": [
        "humiliate"
    ],
    "humiliates": [
        "humiliate"
    ],
    "lindsays": [
        "lindsay"
    ],
    "mobilized": [
        "mobilize"
    ],
    "mobilizing": [
        "mobilize"
    ],
    "mobilizes": [
        "mobilize"
    ],
    "reformists": [
        "reformist"
    ],
    "whims": [
        "whim"
    ],
    "affidavits": [
        "affidavit"
    ],
    "hegemonies": [
        "hegemony"
    ],
    "intimidated": [
        "intimidate"
    ],
    "intimidating": [
        "intimidate"
    ],
    "intimidates": [
        "intimidate"
    ],
    "mockings": [
        "mocking"
    ],
    "pods": [
        "pod"
    ],
    "podding": [
        "pod"
    ],
    "settees": [
        "settee"
    ],
    "atrocities": [
        "atrocity"
    ],
    "codings": [
        "coding"
    ],
    "culprits": [
        "culprit"
    ],
    "duplications": [
        "duplication"
    ],
    "kosovoes": [
        "kosovo"
    ],
    "oceanics": [
        "oceanic"
    ],
    "ombudsmen": [
        "ombudsman"
    ],
    "ombudsmans": [
        "ombudsman"
    ],
    "overlaid": [
        "overlay"
    ],
    "overlays": [
        "overlay"
    ],
    "overlaying": [
        "overlay"
    ],
    "overlayed": [
        "overlay"
    ],
    "reputed": [
        "repute"
    ],
    "reputing": [
        "repute"
    ],
    "ugandas": [
        "uganda"
    ],
    "biddings": [
        "bidding"
    ],
    "flurries": [
        "flurry"
    ],
    "flurried": [
        "flurry"
    ],
    "flurrying": [
        "flurry"
    ],
    "harps": [
        "harp"
    ],
    "harping": [
        "harp"
    ],
    "harped": [
        "harp"
    ],
    "jeopardies": [
        "jeopardy"
    ],
    "latvias": [
        "latvia"
    ],
    "lunatics": [
        "lunatic"
    ],
    "manures": [
        "manure"
    ],
    "manured": [
        "manure"
    ],
    "manuring": [
        "manure"
    ],
    "midways": [
        "midway"
    ],
    "modernities": [
        "modernity"
    ],
    "mortgagees": [
        "mortgagee"
    ],
    "observables": [
        "observable"
    ],
    "resellers": [
        "reseller"
    ],
    "savoys": [
        "savoy"
    ],
    "alkalines": [
        "alkaline"
    ],
    "berwicks": [
        "berwick"
    ],
    "cheekiest": [
        "cheeky"
    ],
    "cheekier": [
        "cheeky"
    ],
    "cheekies": [
        "cheeky"
    ],
    "columbuss": [
        "columbus"
    ],
    "ecumenicals": [
        "ecumenical"
    ],
    "lisbons": [
        "lisbon"
    ],
    "masonries": [
        "masonry"
    ],
    "mathematicians": [
        "mathematician"
    ],
    "outdoorss": [
        "outdoors"
    ],
    "propensities": [
        "propensity"
    ],
    "scrutinised": [
        "scrutinise"
    ],
    "scrutinising": [
        "scrutinise"
    ],
    "scrutinises": [
        "scrutinise"
    ],
    "tantrums": [
        "tantrum"
    ],
    "vandalisms": [
        "vandalism"
    ],
    "wanging": [
        "wang"
    ],
    "ascots": [
        "ascot"
    ],
    "colorados": [
        "colorado"
    ],
    "crofts": [
        "croft"
    ],
    "crofting": [
        "croft"
    ],
    "crofted": [
        "croft"
    ],
    "gardners": [
        "gardner"
    ],
    "indexings": [
        "indexing"
    ],
    "intruded": [
        "intrude"
    ],
    "intruding": [
        "intrude"
    ],
    "intrudes": [
        "intrude"
    ],
    "irishmen": [
        "irishman"
    ],
    "normalities": [
        "normality"
    ],
    "protagonists": [
        "protagonist"
    ],
    "purified": [
        "purify"
    ],
    "purifying": [
        "purify"
    ],
    "repositories": [
        "repository"
    ],
    "separatists": [
        "separatist"
    ],
    "sleeker": [
        "sleek"
    ],
    "sleekest": [
        "sleek"
    ],
    "sleeking": [
        "sleek"
    ],
    "sleeks": [
        "sleek"
    ],
    "sleeked": [
        "sleek"
    ],
    "standpoints": [
        "standpoint"
    ],
    "surpassed": [
        "surpass"
    ],
    "surpassing": [
        "surpass"
    ],
    "tillers": [
        "tiller"
    ],
    "tillering": [
        "tiller"
    ],
    "allotted": [
        "allot"
    ],
    "allotting": [
        "allot"
    ],
    "allots": [
        "allot"
    ],
    "choreographers": [
        "choreographer"
    ],
    "condensations": [
        "condensation"
    ],
    "havocs": [
        "havoc"
    ],
    "kendalls": [
        "kendall"
    ],
    "macroeconomics": [
        "macroeconomic"
    ],
    "onoes": [
        "ono"
    ],
    "ontarios": [
        "ontario"
    ],
    "partings": [
        "parting"
    ],
    "refurbished": [
        "refurbish"
    ],
    "refurbishing": [
        "refurbish"
    ],
    "refurbishes": [
        "refurbish"
    ],
    "routs": [
        "rout"
    ],
    "tods": [
        "tod"
    ],
    "zuriches": [
        "zurich"
    ],
    "ballrooms": [
        "ballroom"
    ],
    "bolivias": [
        "bolivia"
    ],
    "bumpers": [
        "bumper"
    ],
    "disintegrated": [
        "disintegrate"
    ],
    "disintegrating": [
        "disintegrate"
    ],
    "disintegrates": [
        "disintegrate"
    ],
    "disseminations": [
        "dissemination"
    ],
    "finches": [
        "finch"
    ],
    "laymen": [
        "layman"
    ],
    "laymans": [
        "layman"
    ],
    "newmarkets": [
        "newmarket"
    ],
    "overdues": [
        "overdue"
    ],
    "restarted": [
        "restart"
    ],
    "restarting": [
        "restart"
    ],
    "restarts": [
        "restart"
    ],
    "revelled": [
        "revel"
    ],
    "revelling": [
        "revel"
    ],
    "revels": [
        "revel"
    ],
    "rotaries": [
        "rotary"
    ],
    "sherwoods": [
        "sherwood"
    ],
    "sifted": [
        "sift"
    ],
    "sifting": [
        "sift"
    ],
    "sifts": [
        "sift"
    ],
    "termini": [
        "terminus"
    ],
    "terminuses": [
        "terminus"
    ],
    "attlees": [
        "attlee"
    ],
    "eligibilities": [
        "eligibility"
    ],
    "expended": [
        "expend"
    ],
    "expending": [
        "expend"
    ],
    "expends": [
        "expend"
    ],
    "freeholds": [
        "freehold"
    ],
    "inscribed": [
        "inscribe"
    ],
    "inscribing": [
        "inscribe"
    ],
    "inscribes": [
        "inscribe"
    ],
    "rebuildings": [
        "rebuilding"
    ],
    "retailings": [
        "retailing"
    ],
    "revoked": [
        "revoke"
    ],
    "revoking": [
        "revoke"
    ],
    "revokes": [
        "revoke"
    ],
    "squinted": [
        "squint"
    ],
    "squinting": [
        "squint"
    ],
    "squints": [
        "squint"
    ],
    "stabilised": [
        "stabilise"
    ],
    "stabilising": [
        "stabilise"
    ],
    "stags": [
        "stag"
    ],
    "stagging": [
        "stag"
    ],
    "strongholds": [
        "stronghold"
    ],
    "symbolized": [
        "symbolize"
    ],
    "symbolizes": [
        "symbolize"
    ],
    "symbolizing": [
        "symbolize"
    ],
    "vinyls": [
        "vinyl"
    ],
    "beveridges": [
        "beveridge"
    ],
    "coercions": [
        "coercion"
    ],
    "downfalls": [
        "downfall"
    ],
    "hearers": [
        "hearer"
    ],
    "methanes": [
        "methane"
    ],
    "oozing": [
        "ooze"
    ],
    "oozed": [
        "ooze"
    ],
    "oozes": [
        "ooze"
    ],
    "remedials": [
        "remedial"
    ],
    "salients": [
        "salient"
    ],
    "sharings": [
        "sharing"
    ],
    "surpluses": [
        "surpluse"
    ],
    "arks": [
        "ark"
    ],
    "directorates": [
        "directorate"
    ],
    "dominics": [
        "dominic"
    ],
    "finalists": [
        "finalist"
    ],
    "goodmen": [
        "goodman"
    ],
    "hackneys": [
        "hackney"
    ],
    "hippys": [
        "hippy"
    ],
    "jupiters": [
        "jupiter"
    ],
    "loathed": [
        "loathe"
    ],
    "loathes": [
        "loathe"
    ],
    "loathing": [
        "loathe"
    ],
    "marrows": [
        "marrow"
    ],
    "meltings": [
        "melting"
    ],
    "overcoats": [
        "overcoat"
    ],
    "overcoated": [
        "overcoat"
    ],
    "oxen": [
        "ox"
    ],
    "oxes": [
        "ox"
    ],
    "qualifiers": [
        "qualifier"
    ],
    "stockholms": [
        "stockholm"
    ],
    "trifles": [
        "trifle"
    ],
    "trifled": [
        "trifle"
    ],
    "trifling": [
        "trifle"
    ],
    "bridles": [
        "bridle"
    ],
    "bridled": [
        "bridle"
    ],
    "bridling": [
        "bridle"
    ],
    "brits": [
        "brit"
    ],
    "conveyancings": [
        "conveyancing"
    ],
    "coves": [
        "cove"
    ],
    "coved": [
        "cove"
    ],
    "deadlocked": [
        "deadlock"
    ],
    "deadlocks": [
        "deadlock"
    ],
    "deadlocking": [
        "deadlock"
    ],
    "disseminated": [
        "disseminate"
    ],
    "disseminating": [
        "disseminate"
    ],
    "disseminates": [
        "disseminate"
    ],
    "expiries": [
        "expiry"
    ],
    "hawaiis": [
        "hawaii"
    ],
    "inefficiencies": [
        "inefficiency"
    ],
    "legislators": [
        "legislator"
    ],
    "pennsylvanias": [
        "pennsylvania"
    ],
    "refuted": [
        "refute"
    ],
    "refutes": [
        "refute"
    ],
    "refuting": [
        "refute"
    ],
    "genitals": [
        "genital"
    ],
    "physiotherapists": [
        "physiotherapist"
    ],
    "reprinted": [
        "reprint"
    ],
    "reprints": [
        "reprint"
    ],
    "reprinting": [
        "reprint"
    ],
    "seymours": [
        "seymour"
    ],
    "skinnier": [
        "skinny"
    ],
    "skinnys": [
        "skinny"
    ],
    "skinnies": [
        "skinny"
    ],
    "skinniest": [
        "skinny"
    ],
    "snoring": [
        "snore"
    ],
    "snores": [
        "snore"
    ],
    "snored": [
        "snore"
    ],
    "standbys": [
        "standby"
    ],
    "thorpes": [
        "thorpe"
    ],
    "fallings": [
        "falling"
    ],
    "freshwaters": [
        "freshwater"
    ],
    "istanbuls": [
        "istanbul"
    ],
    "liveries": [
        "livery"
    ],
    "liveried": [
        "livery"
    ],
    "nissans": [
        "nissan"
    ],
    "romeos": [
        "romeo"
    ],
    "subtracting": [
        "subtract"
    ],
    "subtracted": [
        "subtract"
    ],
    "subtracts": [
        "subtract"
    ],
    "visionaries": [
        "visionary"
    ],
    "wyatts": [
        "wyatt"
    ],
    "aarons": [
        "aaron"
    ],
    "analyzed": [
        "analyze"
    ],
    "analyzing": [
        "analyze"
    ],
    "analyzes": [
        "analyze"
    ],
    "ascended": [
        "ascend"
    ],
    "ascends": [
        "ascend"
    ],
    "ascending": [
        "ascend"
    ],
    "catholicisms": [
        "catholicism"
    ],
    "daffodils": [
        "daffodil"
    ],
    "gaols": [
        "gaol"
    ],
    "gaoled": [
        "gaol"
    ],
    "gaoling": [
        "gaol"
    ],
    "gaunter": [
        "gaunt"
    ],
    "mimics": [
        "mimic"
    ],
    "mimicking": [
        "mimic",
        "mimick"
    ],
    "mimicked": [
        "mimic",
        "mimick"
    ],
    "myriads": [
        "myriad"
    ],
    "plumbings": [
        "plumbing"
    ],
    "provisos": [
        "proviso"
    ],
    "reiches": [
        "reich"
    ],
    "scrolls": [
        "scroll"
    ],
    "spates": [
        "spate"
    ],
    "teresas": [
        "teresa"
    ],
    "zeals": [
        "zeal"
    ],
    "anorexias": [
        "anorexia"
    ],
    "apices": [
        "apex"
    ],
    "apexes": [
        "apex"
    ],
    "brutalities": [
        "brutality"
    ],
    "closenesses": [
        "closeness"
    ],
    "creaked": [
        "creak"
    ],
    "creaks": [
        "creak"
    ],
    "creaking": [
        "creak"
    ],
    "fitzgeralds": [
        "fitzgerald"
    ],
    "infinities": [
        "infinity"
    ],
    "infinitys": [
        "infinity"
    ],
    "levis": [
        "levi"
    ],
    "peugeots": [
        "peugeot"
    ],
    "plumaged": [
        "plumage"
    ],
    "pounced": [
        "pounce"
    ],
    "pouncing": [
        "pounce"
    ],
    "pounces": [
        "pounce"
    ],
    "prentices": [
        "prentice"
    ],
    "scoured": [
        "scour"
    ],
    "scouring": [
        "scour"
    ],
    "scours": [
        "scour"
    ],
    "subsets": [
        "subset"
    ],
    "subsetted": [
        "subset"
    ],
    "valentines": [
        "valentine"
    ],
    "boozing": [
        "booze"
    ],
    "boozed": [
        "booze"
    ],
    "boozes": [
        "booze"
    ],
    "coeliacs": [
        "coeliac"
    ],
    "dallass": [
        "dallas"
    ],
    "electromagnetics": [
        "electromagnetic"
    ],
    "failings": [
        "failing"
    ],
    "fidelities": [
        "fidelity"
    ],
    "forfeited": [
        "forfeit"
    ],
    "forfeiting": [
        "forfeit"
    ],
    "forfeits": [
        "forfeit"
    ],
    "longitudinals": [
        "longitudinal"
    ],
    "onslaughts": [
        "onslaught"
    ],
    "pathologies": [
        "pathology"
    ],
    "pineapples": [
        "pineapple"
    ],
    "quashed": [
        "quash"
    ],
    "quashing": [
        "quash"
    ],
    "quashes": [
        "quash"
    ],
    "requisites": [
        "requisite"
    ],
    "retinas": [
        "retina"
    ],
    "retinae": [
        "retina"
    ],
    "richess": [
        "riches"
    ],
    "sacraments": [
        "sacrament"
    ],
    "tecs": [
        "tec"
    ],
    "tingling": [
        "tingle"
    ],
    "tingled": [
        "tingle"
    ],
    "tingles": [
        "tingle"
    ],
    "typings": [
        "typing"
    ],
    "aixes": [
        "aix"
    ],
    "apolloes": [
        "apollo"
    ],
    "belgrades": [
        "belgrade"
    ],
    "constantines": [
        "constantine"
    ],
    "elms": [
        "elm"
    ],
    "estonias": [
        "estonia"
    ],
    "etched": [
        "etch"
    ],
    "etching": [
        "etch"
    ],
    "etches": [
        "etch"
    ],
    "etchs": [
        "etch"
    ],
    "femininities": [
        "femininity"
    ],
    "industrializations": [
        "industrialization"
    ],
    "infiltrated": [
        "infiltrate"
    ],
    "infiltrating": [
        "infiltrate"
    ],
    "infiltrates": [
        "infiltrate"
    ],
    "mailings": [
        "mailing"
    ],
    "nietzsches": [
        "nietzsche"
    ],
    "remmed": [
        "rem"
    ],
    "rems": [
        "rem"
    ],
    "servicemen": [
        "serviceman"
    ],
    "tickled": [
        "tickle"
    ],
    "tickling": [
        "tickle"
    ],
    "tickles": [
        "tickle"
    ],
    "vernaculars": [
        "vernacular"
    ],
    "cumberlands": [
        "cumberland"
    ],
    "headlights": [
        "headlight"
    ],
    "magicians": [
        "magician"
    ],
    "mockeries": [
        "mockery"
    ],
    "seatings": [
        "seating"
    ],
    "secreted": [
        "secrete"
    ],
    "secreting": [
        "secrete"
    ],
    "symbolised": [
        "symbolise"
    ],
    "symbolising": [
        "symbolise"
    ],
    "vancouvers": [
        "vancouver"
    ],
    "abstentions": [
        "abstention"
    ],
    "categorised": [
        "categorise"
    ],
    "categorising": [
        "categorise"
    ],
    "categorises": [
        "categorise"
    ],
    "cherished": [
        "cherish"
    ],
    "cherishes": [
        "cherish"
    ],
    "cherishing": [
        "cherish"
    ],
    "chillings": [
        "chilling"
    ],
    "gazetted": [
        "gazette"
    ],
    "gazetting": [
        "gazette"
    ],
    "hastiest": [
        "hasty"
    ],
    "hastier": [
        "hasty"
    ],
    "lockers": [
        "locker"
    ],
    "lodgingss": [
        "lodgings"
    ],
    "reflectives": [
        "reflective"
    ],
    "respectabilities": [
        "respectability"
    ],
    "skidded": [
        "skid"
    ],
    "skidding": [
        "skid"
    ],
    "skids": [
        "skid"
    ],
    "techs": [
        "tech"
    ],
    "watchers": [
        "watcher"
    ],
    "augustines": [
        "augustine"
    ],
    "bakeries": [
        "bakery"
    ],
    "botanicals": [
        "botanical"
    ],
    "byrons": [
        "byron"
    ],
    "chronologies": [
        "chronology"
    ],
    "doughs": [
        "dough"
    ],
    "encapsulated": [
        "encapsulate"
    ],
    "encapsulates": [
        "encapsulate"
    ],
    "encapsulating": [
        "encapsulate"
    ],
    "galloways": [
        "galloway"
    ],
    "misgivings": [
        "misgiving"
    ],
    "motilities": [
        "motility"
    ],
    "navigators": [
        "navigator"
    ],
    "reactionaries": [
        "reactionary"
    ],
    "saner": [
        "sane"
    ],
    "sanest": [
        "sane"
    ],
    "servings": [
        "serving"
    ],
    "translators": [
        "translator"
    ],
    "adjoining": [
        "adjoin"
    ],
    "adjoined": [
        "adjoin"
    ],
    "breakings": [
        "breaking"
    ],
    "buddies": [
        "buddy"
    ],
    "capitalised": [
        "capitalise"
    ],
    "capitalising": [
        "capitalise"
    ],
    "discontinued": [
        "discontinue"
    ],
    "discontinuing": [
        "discontinue"
    ],
    "kerries": [
        "kerry"
    ],
    "lobsters": [
        "lobster"
    ],
    "maizes": [
        "maize"
    ],
    "margarines": [
        "margarine"
    ],
    "quickened": [
        "quicken"
    ],
    "quickens": [
        "quicken"
    ],
    "quickening": [
        "quicken"
    ],
    "yearning": [
        "yearn"
    ],
    "yearned": [
        "yearn"
    ],
    "yearns": [
        "yearn"
    ],
    "buzzing": [
        "buz"
    ],
    "buzzed": [
        "buz"
    ],
    "domiciled": [
        "domicile"
    ],
    "equivalenced": [
        "equivalence"
    ],
    "extinguished": [
        "extinguish"
    ],
    "extinguishing": [
        "extinguish"
    ],
    "extinguishes": [
        "extinguish"
    ],
    "faeces": [
        "faece"
    ],
    "laurels": [
        "laurel"
    ],
    "milestones": [
        "milestone"
    ],
    "puddles": [
        "puddle"
    ],
    "puddling": [
        "puddle"
    ],
    "puddled": [
        "puddle"
    ],
    "roes": [
        "roe"
    ],
    "websters": [
        "webster"
    ],
    "archdeacons": [
        "archdeacon"
    ],
    "bss": [
        "bs"
    ],
    "charismatics": [
        "charismatic"
    ],
    "dogmas": [
        "dogma"
    ],
    "everests": [
        "everest"
    ],
    "forecastings": [
        "forecasting"
    ],
    "haemoglobins": [
        "haemoglobin"
    ],
    "hayess": [
        "hayes"
    ],
    "hydrocarbons": [
        "hydrocarbon"
    ],
    "incubations": [
        "incubation"
    ],
    "likings": [
        "liking"
    ],
    "punctured": [
        "puncture"
    ],
    "punctures": [
        "puncture"
    ],
    "puncturing": [
        "puncture"
    ],
    "smothered": [
        "smother"
    ],
    "smothering": [
        "smother"
    ],
    "smothers": [
        "smother"
    ],
    "alkalis": [
        "alkali"
    ],
    "coaxed": [
        "coax"
    ],
    "coaxing": [
        "coax"
    ],
    "coaxes": [
        "coax"
    ],
    "complimentaries": [
        "complimentary"
    ],
    "diocesans": [
        "diocesan"
    ],
    "disintegrations": [
        "disintegration"
    ],
    "dumpings": [
        "dumping"
    ],
    "extraditions": [
        "extradition"
    ],
    "fleas": [
        "flea"
    ],
    "fleaing": [
        "flea"
    ],
    "headlands": [
        "headland"
    ],
    "kurds": [
        "kurd"
    ],
    "ordained": [
        "ordain"
    ],
    "ordaining": [
        "ordain"
    ],
    "ordains": [
        "ordain"
    ],
    "patriots": [
        "patriot"
    ],
    "rosiest": [
        "rosy"
    ],
    "accessibilities": [
        "accessibility"
    ],
    "albions": [
        "albion"
    ],
    "antagonisms": [
        "antagonism"
    ],
    "conjectured": [
        "conjecture"
    ],
    "conjecturing": [
        "conjecture"
    ],
    "demos": [
        "demo"
    ],
    "demoing": [
        "demo"
    ],
    "invaders": [
        "invader"
    ],
    "joshing": [
        "josh"
    ],
    "joshed": [
        "josh"
    ],
    "joshes": [
        "josh"
    ],
    "legislated": [
        "legislate"
    ],
    "legislating": [
        "legislate"
    ],
    "legislates": [
        "legislate"
    ],
    "loftier": [
        "lofty"
    ],
    "loftiest": [
        "lofty"
    ],
    "orbitals": [
        "orbital"
    ],
    "orientated": [
        "orientate"
    ],
    "orientating": [
        "orientate"
    ],
    "orientates": [
        "orientate"
    ],
    "pheasants": [
        "pheasant"
    ],
    "pickled": [
        "pickle"
    ],
    "pickling": [
        "pickle"
    ],
    "swimmers": [
        "swimmer"
    ],
    "tired": [
        "tire"
    ],
    "tiring": [
        "tire"
    ],
    "unhappinesses": [
        "unhappiness"
    ],
    "wavered": [
        "waver"
    ],
    "wavering": [
        "waver"
    ],
    "wavers": [
        "waver"
    ],
    "amens": [
        "amen"
    ],
    "aristotles": [
        "aristotle"
    ],
    "arsons": [
        "arson"
    ],
    "camcorders": [
        "camcorder"
    ],
    "chens": [
        "chen"
    ],
    "dodgier": [
        "dodgy"
    ],
    "dodgiest": [
        "dodgy"
    ],
    "dressers": [
        "dresser"
    ],
    "frenzied": [
        "frenzy"
    ],
    "frenzies": [
        "frenzy"
    ],
    "gazas": [
        "gaza"
    ],
    "harriers": [
        "harrier"
    ],
    "inaugurated": [
        "inaugurate"
    ],
    "inaugurating": [
        "inaugurate"
    ],
    "inaugurates": [
        "inaugurate"
    ],
    "jigsaws": [
        "jigsaw"
    ],
    "jigsawn": [
        "jigsaw"
    ],
    "jigsawed": [
        "jigsaw"
    ],
    "jigsawing": [
        "jigsaw"
    ],
    "lizas": [
        "liza"
    ],
    "lulled": [
        "lull"
    ],
    "lulling": [
        "lull"
    ],
    "lulls": [
        "lull"
    ],
    "prescotts": [
        "prescott"
    ],
    "strewn": [
        "strew"
    ],
    "strewing": [
        "strew"
    ],
    "strewed": [
        "strew"
    ],
    "strews": [
        "strew"
    ],
    "superpowers": [
        "superpower"
    ],
    "yoghurts": [
        "yoghurt"
    ],
    "danzigs": [
        "danzig"
    ],
    "doriss": [
        "doris"
    ],
    "emeralds": [
        "emerald"
    ],
    "gearboxes": [
        "gearbox"
    ],
    "mellowed": [
        "mellow"
    ],
    "mellower": [
        "mellow"
    ],
    "mellowing": [
        "mellow"
    ],
    "mellows": [
        "mellow"
    ],
    "mellowest": [
        "mellow"
    ],
    "misconducted": [
        "misconduct"
    ],
    "misconducts": [
        "misconduct"
    ],
    "misconducting": [
        "misconduct"
    ],
    "pepping": [
        "pep"
    ],
    "pepped": [
        "pep"
    ],
    "pronouncements": [
        "pronouncement"
    ],
    "rapists": [
        "rapist"
    ],
    "rudders": [
        "rudder"
    ],
    "ruddering": [
        "rudder"
    ],
    "scurrying": [
        "scurry"
    ],
    "scurried": [
        "scurry"
    ],
    "scurries": [
        "scurry"
    ],
    "sectarians": [
        "sectarian"
    ],
    "tunics": [
        "tunic"
    ],
    "warped": [
        "warp"
    ],
    "warps": [
        "warp"
    ],
    "warping": [
        "warp"
    ],
    "weepings": [
        "weeping"
    ],
    "catchments": [
        "catchment"
    ],
    "confinements": [
        "confinement"
    ],
    "mcs": [
        "mc"
    ],
    "phantoms": [
        "phantom"
    ],
    "riotings": [
        "rioting"
    ],
    "shorthanded": [
        "shorthand"
    ],
    "spruced": [
        "spruce"
    ],
    "sprucing": [
        "spruce"
    ],
    "spruces": [
        "spruce"
    ],
    "weekdays": [
        "weekday"
    ],
    "babes": [
        "babe"
    ],
    "bullocks": [
        "bullock"
    ],
    "bullocking": [
        "bullock"
    ],
    "bullocked": [
        "bullock"
    ],
    "embroideries": [
        "embroidery"
    ],
    "gores": [
        "gore"
    ],
    "gored": [
        "gore"
    ],
    "goring": [
        "gore"
    ],
    "havels": [
        "havel"
    ],
    "langleys": [
        "langley"
    ],
    "nervousnesses": [
        "nervousness"
    ],
    "oases": [
        "oasis"
    ],
    "rucksacks": [
        "rucksack"
    ],
    "rucksacked": [
        "rucksack"
    ],
    "steins": [
        "stein"
    ],
    "thugging": [
        "thug"
    ],
    "aromatics": [
        "aromatic"
    ],
    "bollocks": [
        "bollock"
    ],
    "bollocked": [
        "bollock"
    ],
    "bollocking": [
        "bollock"
    ],
    "buffalos": [
        "buffalo"
    ],
    "buffaloes": [
        "buffalo"
    ],
    "coinages": [
        "coinage"
    ],
    "granddads": [
        "granddad"
    ],
    "grassiest": [
        "grassy"
    ],
    "grassies": [
        "grassy"
    ],
    "grassier": [
        "grassy"
    ],
    "hardnesses": [
        "hardness"
    ],
    "idealisms": [
        "idealism"
    ],
    "materialised": [
        "materialise"
    ],
    "materialising": [
        "materialise"
    ],
    "mediations": [
        "mediation"
    ],
    "pentagons": [
        "pentagon"
    ],
    "permeated": [
        "permeate"
    ],
    "permeates": [
        "permeate"
    ],
    "permeating": [
        "permeate"
    ],
    "refreshed": [
        "refresh"
    ],
    "refreshing": [
        "refresh"
    ],
    "refreshes": [
        "refresh"
    ],
    "saed": [
        "sae"
    ],
    "saes": [
        "sae"
    ],
    "sills": [
        "sill"
    ],
    "spitfires": [
        "spitfire"
    ],
    "thistles": [
        "thistle"
    ],
    "aristocrats": [
        "aristocrat"
    ],
    "armenias": [
        "armenia"
    ],
    "backsides": [
        "backside"
    ],
    "fieldworking": [
        "fieldwork"
    ],
    "galleys": [
        "galley"
    ],
    "mediators": [
        "mediator"
    ],
    "nicandras": [
        "nicandra"
    ],
    "opaqued": [
        "opaque"
    ],
    "quebecs": [
        "quebec"
    ],
    "rumps": [
        "rump"
    ],
    "substantiated": [
        "substantiate"
    ],
    "substantiating": [
        "substantiate"
    ],
    "substantiates": [
        "substantiate"
    ],
    "terrestrials": [
        "terrestrial"
    ],
    "woodworks": [
        "woodwork"
    ],
    "argylls": [
        "argyll"
    ],
    "bamboos": [
        "bamboo"
    ],
    "bukharins": [
        "bukharin"
    ],
    "chauffeured": [
        "chauffeur"
    ],
    "chauffeuring": [
        "chauffeur"
    ],
    "craved": [
        "crave"
    ],
    "craving": [
        "crave"
    ],
    "craves": [
        "crave"
    ],
    "enactments": [
        "enactment"
    ],
    "floorboards": [
        "floorboard"
    ],
    "floorboarding": [
        "floorboard"
    ],
    "forearms": [
        "forearm"
    ],
    "fraus": [
        "frau"
    ],
    "hebridess": [
        "hebrides"
    ],
    "ladings": [
        "lading"
    ],
    "leaching": [
        "leach"
    ],
    "leached": [
        "leach"
    ],
    "leaches": [
        "leach"
    ],
    "macedonias": [
        "macedonia"
    ],
    "moduli": [
        "modulus"
    ],
    "nibbling": [
        "nibble"
    ],
    "nibbled": [
        "nibble"
    ],
    "nibbles": [
        "nibble"
    ],
    "obsessives": [
        "obsessive"
    ],
    "platinums": [
        "platinum"
    ],
    "resumptions": [
        "resumption"
    ],
    "stirrings": [
        "stirring"
    ],
    "testators": [
        "testator"
    ],
    "theresas": [
        "theresa"
    ],
    "waistcoats": [
        "waistcoat"
    ],
    "bombardments": [
        "bombardment"
    ],
    "cutest": [
        "cute"
    ],
    "cuter": [
        "cute"
    ],
    "detracts": [
        "detract"
    ],
    "detracted": [
        "detract"
    ],
    "detracting": [
        "detract"
    ],
    "drabs": [
        "drab"
    ],
    "drabber": [
        "drab"
    ],
    "drabbest": [
        "drab"
    ],
    "enlargements": [
        "enlargement"
    ],
    "flyers": [
        "flyer"
    ],
    "grieved": [
        "grieve"
    ],
    "grieves": [
        "grieve"
    ],
    "grieving": [
        "grieve"
    ],
    "haircuts": [
        "haircut"
    ],
    "haircutting": [
        "haircut"
    ],
    "multilaterals": [
        "multilateral"
    ],
    "oeds": [
        "oed"
    ],
    "oemed": [
        "oem"
    ],
    "oeming": [
        "oem"
    ],
    "pathologists": [
        "pathologist"
    ],
    "simmered": [
        "simmer"
    ],
    "simmers": [
        "simmer"
    ],
    "simmering": [
        "simmer"
    ],
    "swedes": [
        "swede"
    ],
    "systemics": [
        "systemic"
    ],
    "tranquillities": [
        "tranquillity"
    ],
    "adaptors": [
        "adaptor"
    ],
    "ejected": [
        "eject"
    ],
    "ejecting": [
        "eject"
    ],
    "ejects": [
        "eject"
    ],
    "fijis": [
        "fiji"
    ],
    "karates": [
        "karate"
    ],
    "likened": [
        "liken"
    ],
    "likens": [
        "liken"
    ],
    "likening": [
        "liken"
    ],
    "lymphomas": [
        "lymphoma"
    ],
    "maliks": [
        "malik"
    ],
    "misrepresentations": [
        "misrepresentation"
    ],
    "newsagents": [
        "newsagent"
    ],
    "pastimes": [
        "pastime"
    ],
    "schoolmasters": [
        "schoolmaster"
    ],
    "schoolmastering": [
        "schoolmaster"
    ],
    "unpacked": [
        "unpack"
    ],
    "unpacking": [
        "unpack"
    ],
    "unpacks": [
        "unpack"
    ],
    "wattss": [
        "watts"
    ],
    "boos": [
        "boo"
    ],
    "booing": [
        "boo"
    ],
    "booed": [
        "boo"
    ],
    "copenhagens": [
        "copenhagen"
    ],
    "cutleries": [
        "cutlery"
    ],
    "eluded": [
        "elude"
    ],
    "eluding": [
        "elude"
    ],
    "huttons": [
        "hutton"
    ],
    "miming": [
        "mime"
    ],
    "mimed": [
        "mime"
    ],
    "patchier": [
        "patchy"
    ],
    "patchiest": [
        "patchy"
    ],
    "poaching": [
        "poach"
    ],
    "poached": [
        "poach"
    ],
    "poaches": [
        "poach"
    ],
    "portlands": [
        "portland"
    ],
    "poundings": [
        "pounding"
    ],
    "proponents": [
        "proponent"
    ],
    "repelled": [
        "repel"
    ],
    "repelling": [
        "repel"
    ],
    "repels": [
        "repel"
    ],
    "stainlesses": [
        "stainless"
    ],
    "stallions": [
        "stallion"
    ],
    "vanguards": [
        "vanguard"
    ],
    "augs": [
        "aug"
    ],
    "boyles": [
        "boyle"
    ],
    "brickworks": [
        "brickwork"
    ],
    "brickworking": [
        "brickwork"
    ],
    "emptinesses": [
        "emptiness"
    ],
    "feuds": [
        "feud"
    ],
    "feuding": [
        "feud"
    ],
    "feuded": [
        "feud"
    ],
    "germs": [
        "germ"
    ],
    "hangovers": [
        "hangover"
    ],
    "hepatics": [
        "hepatic"
    ],
    "humidities": [
        "humidity"
    ],
    "hypes": [
        "hype"
    ],
    "lightened": [
        "lighten"
    ],
    "lightening": [
        "lighten"
    ],
    "lightens": [
        "lighten"
    ],
    "monographs": [
        "monograph"
    ],
    "piazzas": [
        "piazza"
    ],
    "plundered": [
        "plunder"
    ],
    "plundering": [
        "plunder"
    ],
    "plunders": [
        "plunder"
    ],
    "sandals": [
        "sandal"
    ],
    "tablespoons": [
        "tablespoon"
    ],
    "veras": [
        "vera"
    ],
    "windmills": [
        "windmill"
    ],
    "cichlids": [
        "cichlid"
    ],
    "countings": [
        "counting"
    ],
    "nettles": [
        "nettle"
    ],
    "nettled": [
        "nettle"
    ],
    "pathologicals": [
        "pathological"
    ],
    "slanted": [
        "slant"
    ],
    "slanting": [
        "slant"
    ],
    "slants": [
        "slant"
    ],
    "spars": [
        "spar"
    ],
    "sparring": [
        "spar"
    ],
    "sparred": [
        "spar"
    ],
    "brooches": [
        "brooch"
    ],
    "cleansed": [
        "cleanse"
    ],
    "cleansing": [
        "cleanse"
    ],
    "cleanses": [
        "cleanse"
    ],
    "deferences": [
        "deference"
    ],
    "fbis": [
        "fbi"
    ],
    "hornes": [
        "horne"
    ],
    "intersectioning": [
        "intersection"
    ],
    "leys": [
        "ley"
    ],
    "munroes": [
        "munro"
    ],
    "relativities": [
        "relativity"
    ],
    "suezs": [
        "suez"
    ],
    "absurdities": [
        "absurdity"
    ],
    "aussies": [
        "aussie"
    ],
    "culminations": [
        "culmination"
    ],
    "epitheliums": [
        "epithelium"
    ],
    "groped": [
        "grope"
    ],
    "groping": [
        "grope"
    ],
    "gropes": [
        "grope"
    ],
    "nagging": [
        "nag"
    ],
    "nagged": [
        "nag"
    ],
    "nags": [
        "nag"
    ],
    "phds": [
        "phd"
    ],
    "populists": [
        "populist"
    ],
    "pulped": [
        "pulp"
    ],
    "pulping": [
        "pulp"
    ],
    "pulps": [
        "pulp"
    ],
    "trumen": [
        "truman"
    ],
    "waughs": [
        "waugh"
    ],
    "amazed": [
        "amaze"
    ],
    "amazes": [
        "amaze"
    ],
    "amazing": [
        "amaze"
    ],
    "cloves": [
        "clove"
    ],
    "consigned": [
        "consign"
    ],
    "consigning": [
        "consign"
    ],
    "consigns": [
        "consign"
    ],
    "dilutions": [
        "dilution"
    ],
    "educators": [
        "educator"
    ],
    "enthalpies": [
        "enthalpy"
    ],
    "incests": [
        "incest"
    ],
    "mercenaries": [
        "mercenary"
    ],
    "mertons": [
        "merton"
    ],
    "penalised": [
        "penalise"
    ],
    "penalising": [
        "penalise"
    ],
    "punctuated": [
        "punctuate"
    ],
    "punctuating": [
        "punctuate"
    ],
    "punctuates": [
        "punctuate"
    ],
    "repudiated": [
        "repudiate"
    ],
    "repudiating": [
        "repudiate"
    ],
    "repudiates": [
        "repudiate"
    ],
    "sevilles": [
        "seville"
    ],
    "sinners": [
        "sinner"
    ],
    "tranquils": [
        "tranquil"
    ],
    "amalgamations": [
        "amalgamation"
    ],
    "bettings": [
        "betting"
    ],
    "bonanzas": [
        "bonanza"
    ],
    "bondings": [
        "bonding"
    ],
    "cred": [
        "cr"
    ],
    "crs": [
        "cr"
    ],
    "disarmed": [
        "disarm"
    ],
    "disarming": [
        "disarm"
    ],
    "disarms": [
        "disarm"
    ],
    "endemics": [
        "endemic"
    ],
    "geneticss": [
        "genetics"
    ],
    "loggings": [
        "logging"
    ],
    "nashes": [
        "nash"
    ],
    "outlays": [
        "outlay"
    ],
    "outlaid": [
        "outlay"
    ],
    "outlaying": [
        "outlay"
    ],
    "reprieved": [
        "reprieve"
    ],
    "reprieves": [
        "reprieve"
    ],
    "reprieving": [
        "reprieve"
    ],
    "theos": [
        "theo"
    ],
    "adulthoods": [
        "adulthood"
    ],
    "alleyways": [
        "alleyway"
    ],
    "artemiss": [
        "artemis"
    ],
    "blackbirds": [
        "blackbird"
    ],
    "charlemagnes": [
        "charlemagne"
    ],
    "fingerprints": [
        "fingerprint"
    ],
    "fingerprinting": [
        "fingerprint"
    ],
    "fingerprinted": [
        "fingerprint"
    ],
    "impedances": [
        "impedance"
    ],
    "napkins": [
        "napkin"
    ],
    "originalities": [
        "originality"
    ],
    "paraphrased": [
        "paraphrase"
    ],
    "paraphrasing": [
        "paraphrase"
    ],
    "unisons": [
        "unison"
    ],
    "vindicated": [
        "vindicate"
    ],
    "vindicating": [
        "vindicate"
    ],
    "vindicates": [
        "vindicate"
    ],
    "woodyer": [
        "woody"
    ],
    "woodier": [
        "woody"
    ],
    "woodiest": [
        "woody"
    ],
    "abstained": [
        "abstain"
    ],
    "abstaining": [
        "abstain"
    ],
    "abstains": [
        "abstain"
    ],
    "bordeauxes": [
        "bordeaux"
    ],
    "caricatured": [
        "caricature"
    ],
    "caricaturing": [
        "caricature"
    ],
    "cosmopolitans": [
        "cosmopolitan"
    ],
    "dredging": [
        "dredge"
    ],
    "dredged": [
        "dredge"
    ],
    "dredges": [
        "dredge"
    ],
    "gibbss": [
        "gibbs"
    ],
    "gusts": [
        "gust"
    ],
    "gusting": [
        "gust"
    ],
    "gusted": [
        "gust"
    ],
    "liaising": [
        "liaise"
    ],
    "liaised": [
        "liaise"
    ],
    "liaises": [
        "liaise"
    ],
    "noahs": [
        "noah"
    ],
    "penelopes": [
        "penelope"
    ],
    "positivists": [
        "positivist"
    ],
    "sequels": [
        "sequel"
    ],
    "slain": [
        "slay"
    ],
    "slaying": [
        "slay"
    ],
    "slays": [
        "slay"
    ],
    "slew": [
        "slay"
    ],
    "subunits": [
        "subunit"
    ],
    "tammuzs": [
        "tammuz"
    ],
    "troys": [
        "troy"
    ],
    "vandals": [
        "vandal"
    ],
    "acorns": [
        "acorn"
    ],
    "dozed": [
        "doze"
    ],
    "dozing": [
        "doze"
    ],
    "dozes": [
        "doze"
    ],
    "egalitarians": [
        "egalitarian"
    ],
    "equalisers": [
        "equaliser"
    ],
    "executors": [
        "executor"
    ],
    "groundwaters": [
        "groundwater"
    ],
    "impinged": [
        "impinge"
    ],
    "impinges": [
        "impinge"
    ],
    "impinging": [
        "impinge"
    ],
    "malawis": [
        "malawi"
    ],
    "plumed": [
        "plume"
    ],
    "pluming": [
        "plume"
    ],
    "ramblers": [
        "rambler"
    ],
    "ringings": [
        "ringing"
    ],
    "sexisms": [
        "sexism"
    ],
    "soloists": [
        "soloist"
    ],
    "veronicas": [
        "veronica"
    ],
    "vertebrates": [
        "vertebrate"
    ],
    "boons": [
        "boon"
    ],
    "clamouring": [
        "clamour"
    ],
    "clamoured": [
        "clamour"
    ],
    "clamours": [
        "clamour"
    ],
    "cutbacks": [
        "cutback"
    ],
    "fluctuated": [
        "fluctuate"
    ],
    "fluctuates": [
        "fluctuate"
    ],
    "fluctuating": [
        "fluctuate"
    ],
    "inhaled": [
        "inhale"
    ],
    "inhaling": [
        "inhale"
    ],
    "inhales": [
        "inhale"
    ],
    "khmers": [
        "khmer"
    ],
    "motherhoods": [
        "motherhood"
    ],
    "paddocked": [
        "paddock"
    ],
    "pastors": [
        "pastor"
    ],
    "plumbers": [
        "plumber"
    ],
    "pretensions": [
        "pretension"
    ],
    "spasms": [
        "spasm"
    ],
    "spasmed": [
        "spasm"
    ],
    "spasming": [
        "spasm"
    ],
    "stuttgarts": [
        "stuttgart"
    ],
    "syringes": [
        "syringe"
    ],
    "syringed": [
        "syringe"
    ],
    "syringing": [
        "syringe"
    ],
    "unsettled": [
        "unsettle"
    ],
    "unsettling": [
        "unsettle"
    ],
    "unsettles": [
        "unsettle"
    ],
    "wagging": [
        "wag"
    ],
    "wagged": [
        "wag"
    ],
    "wags": [
        "wag"
    ],
    "warships": [
        "warship"
    ],
    "abdomens": [
        "abdomen"
    ],
    "aggregations": [
        "aggregation"
    ],
    "aprs": [
        "apr"
    ],
    "conifers": [
        "conifer"
    ],
    "endurances": [
        "endurance"
    ],
    "interred": [
        "inter"
    ],
    "interring": [
        "inter"
    ],
    "kilns": [
        "kiln"
    ],
    "nasals": [
        "nasal"
    ],
    "rationalisations": [
        "rationalisation"
    ],
    "rediscovered": [
        "rediscover"
    ],
    "rediscovering": [
        "rediscover"
    ],
    "rediscovers": [
        "rediscover"
    ],
    "rethinking": [
        "rethink"
    ],
    "rethinks": [
        "rethink"
    ],
    "rethought": [
        "rethink"
    ],
    "sabbaths": [
        "sabbath"
    ],
    "shapings": [
        "shaping"
    ],
    "shawls": [
        "shawl"
    ],
    "shawled": [
        "shawl"
    ],
    "swellings": [
        "swelling"
    ],
    "tarred": [
        "tar"
    ],
    "tars": [
        "tar"
    ],
    "tarring": [
        "tar"
    ],
    "trumps": [
        "trump"
    ],
    "trumped": [
        "trump"
    ],
    "trumping": [
        "trump"
    ],
    "tuckers": [
        "tucker"
    ],
    "tuckering": [
        "tucker"
    ],
    "tuckered": [
        "tucker"
    ],
    "blindnesses": [
        "blindness"
    ],
    "conditioners": [
        "conditioner"
    ],
    "corollaries": [
        "corollary"
    ],
    "dazzled": [
        "dazzle"
    ],
    "dazzling": [
        "dazzle"
    ],
    "dazzles": [
        "dazzle"
    ],
    "ethiopians": [
        "ethiopian"
    ],
    "fiduciaries": [
        "fiduciary"
    ],
    "furrows": [
        "furrow"
    ],
    "furrowed": [
        "furrow"
    ],
    "furrowing": [
        "furrow"
    ],
    "glimmered": [
        "glimmer"
    ],
    "glimmering": [
        "glimmer"
    ],
    "glimmers": [
        "glimmer"
    ],
    "monas": [
        "mona"
    ],
    "pipings": [
        "piping"
    ],
    "redefined": [
        "redefine"
    ],
    "redefining": [
        "redefine"
    ],
    "redefines": [
        "redefine"
    ],
    "sincerities": [
        "sincerity"
    ],
    "sweetnesses": [
        "sweetness"
    ],
    "transcribed": [
        "transcribe"
    ],
    "transcribing": [
        "transcribe"
    ],
    "transcribes": [
        "transcribe"
    ],
    "admiralties": [
        "admiralty"
    ],
    "clarinets": [
        "clarinet"
    ],
    "dwellers": [
        "dweller"
    ],
    "dylans": [
        "dylan"
    ],
    "equalised": [
        "equalise"
    ],
    "equalising": [
        "equalise"
    ],
    "equalises": [
        "equalise"
    ],
    "frss": [
        "frs"
    ],
    "gemmas": [
        "gemma"
    ],
    "gladstones": [
        "gladstone"
    ],
    "kingfishers": [
        "kingfisher"
    ],
    "overtures": [
        "overture"
    ],
    "polythenes": [
        "polythene"
    ],
    "pulpits": [
        "pulpit"
    ],
    "regencies": [
        "regency"
    ],
    "reproached": [
        "reproach"
    ],
    "reproaches": [
        "reproach"
    ],
    "reproaching": [
        "reproach"
    ],
    "rushdies": [
        "rushdie"
    ],
    "scuttled": [
        "scuttle"
    ],
    "scuttling": [
        "scuttle"
    ],
    "scuttles": [
        "scuttle"
    ],
    "stupidities": [
        "stupidity"
    ],
    "toiled": [
        "toil"
    ],
    "toils": [
        "toil"
    ],
    "toiling": [
        "toil"
    ],
    "tremors": [
        "tremor"
    ],
    "visualised": [
        "visualise"
    ],
    "visualising": [
        "visualise"
    ],
    "winches": [
        "winch"
    ],
    "winched": [
        "winch"
    ],
    "winching": [
        "winch"
    ],
    "barricaded": [
        "barricade"
    ],
    "barricading": [
        "barricade"
    ],
    "causations": [
        "causation"
    ],
    "chandlers": [
        "chandler"
    ],
    "cleanlinesses": [
        "cleanliness"
    ],
    "comers": [
        "comer"
    ],
    "depts": [
        "dept"
    ],
    "fending": [
        "fend"
    ],
    "fended": [
        "fend"
    ],
    "geographers": [
        "geographer"
    ],
    "itching": [
        "itch"
    ],
    "itched": [
        "itch"
    ],
    "itches": [
        "itch"
    ],
    "jumpings": [
        "jumping"
    ],
    "olympias": [
        "olympia"
    ],
    "professed": [
        "profess"
    ],
    "professes": [
        "profess"
    ],
    "professing": [
        "profess"
    ],
    "trafalgars": [
        "trafalgar"
    ],
    "brotherhoods": [
        "brotherhood"
    ],
    "cads": [
        "cad"
    ],
    "childcares": [
        "childcare"
    ],
    "cobalts": [
        "cobalt"
    ],
    "fms": [
        "fm"
    ],
    "industrialisations": [
        "industrialisation"
    ],
    "mammalians": [
        "mammalian"
    ],
    "moats": [
        "moat"
    ],
    "procurements": [
        "procurement"
    ],
    "rileys": [
        "riley"
    ],
    "ros": [
        "ro"
    ],
    "typified": [
        "typify"
    ],
    "typifies": [
        "typify"
    ],
    "typifying": [
        "typify"
    ],
    "yemens": [
        "yemen"
    ],
    "cambrians": [
        "cambrian"
    ],
    "ethernets": [
        "ethernet"
    ],
    "hoops": [
        "hoop"
    ],
    "hooped": [
        "hoop"
    ],
    "meanders": [
        "meander"
    ],
    "meandering": [
        "meander"
    ],
    "meandered": [
        "meander"
    ],
    "mitigated": [
        "mitigate"
    ],
    "mitigating": [
        "mitigate"
    ],
    "mitigates": [
        "mitigate"
    ],
    "multipliers": [
        "multiplier"
    ],
    "neurotics": [
        "neurotic"
    ],
    "oswalds": [
        "oswald"
    ],
    "outcries": [
        "outcry"
    ],
    "paranoids": [
        "paranoid"
    ],
    "pinnacles": [
        "pinnacle"
    ],
    "pinnacled": [
        "pinnacle"
    ],
    "ruffled": [
        "ruffle"
    ],
    "ruffling": [
        "ruffle"
    ],
    "ruffles": [
        "ruffle"
    ],
    "sharpnesses": [
        "sharpness"
    ],
    "subsidences": [
        "subsidence"
    ],
    "besetting": [
        "beset"
    ],
    "besets": [
        "beset"
    ],
    "capacitors": [
        "capacitor"
    ],
    "chesterfields": [
        "chesterfield"
    ],
    "confounded": [
        "confound"
    ],
    "confounding": [
        "confound"
    ],
    "confounds": [
        "confound"
    ],
    "eisenhowers": [
        "eisenhower"
    ],
    "garnished": [
        "garnish"
    ],
    "garnishing": [
        "garnish"
    ],
    "garnishes": [
        "garnish"
    ],
    "grubbier": [
        "grubby"
    ],
    "grubbied": [
        "grubby"
    ],
    "grubbiest": [
        "grubby"
    ],
    "handouts": [
        "handout"
    ],
    "helms": [
        "helm"
    ],
    "helming": [
        "helm"
    ],
    "helmed": [
        "helm"
    ],
    "holts": [
        "holt"
    ],
    "kazakhstans": [
        "kazakhstan"
    ],
    "monoxided": [
        "monoxide"
    ],
    "mournings": [
        "mourning"
    ],
    "playwrights": [
        "playwright"
    ],
    "playwrighting": [
        "playwright"
    ],
    "portrayals": [
        "portrayal"
    ],
    "preconditions": [
        "precondition"
    ],
    "preconditioned": [
        "precondition"
    ],
    "rasped": [
        "rasp"
    ],
    "rasping": [
        "rasp"
    ],
    "rasps": [
        "rasp"
    ],
    "rearranged": [
        "rearrange"
    ],
    "rearranges": [
        "rearrange"
    ],
    "rearranging": [
        "rearrange"
    ],
    "stabilized": [
        "stabilize"
    ],
    "stabilizing": [
        "stabilize"
    ],
    "stabilizes": [
        "stabilize"
    ],
    "actuaries": [
        "actuary"
    ],
    "authorisations": [
        "authorisation"
    ],
    "brittanies": [
        "brittany"
    ],
    "dews": [
        "dew"
    ],
    "dewed": [
        "dew"
    ],
    "dobsons": [
        "dobson"
    ],
    "fibroses": [
        "fibrosis"
    ],
    "hartleys": [
        "hartley"
    ],
    "ibrahims": [
        "ibrahim"
    ],
    "inceptions": [
        "inception"
    ],
    "lans": [
        "lan"
    ],
    "livingstones": [
        "livingstone"
    ],
    "mooted": [
        "moot"
    ],
    "moots": [
        "moot"
    ],
    "mooting": [
        "moot"
    ],
    "mooter": [
        "moot"
    ],
    "practicalities": [
        "practicality"
    ],
    "punctuations": [
        "punctuation"
    ],
    "renovated": [
        "renovate"
    ],
    "renovating": [
        "renovate"
    ],
    "renovates": [
        "renovate"
    ],
    "shales": [
        "shale"
    ],
    "snubbed": [
        "snub"
    ],
    "snubs": [
        "snub"
    ],
    "snubbing": [
        "snub"
    ],
    "accumulators": [
        "accumulator"
    ],
    "battens": [
        "batten"
    ],
    "battened": [
        "batten"
    ],
    "battening": [
        "batten"
    ],
    "coalfields": [
        "coalfield"
    ],
    "electricians": [
        "electrician"
    ],
    "etas": [
        "eta"
    ],
    "foldings": [
        "folding"
    ],
    "ims": [
        "im"
    ],
    "immed": [
        "im"
    ],
    "kleins": [
        "klein"
    ],
    "lobbed": [
        "lob"
    ],
    "lobbing": [
        "lob"
    ],
    "lobed": [
        "lobe"
    ],
    "mrnas": [
        "mrna"
    ],
    "presuppositions": [
        "presupposition"
    ],
    "runaways": [
        "runaway"
    ],
    "seouls": [
        "seoul"
    ],
    "subconsciouss": [
        "subconscious"
    ],
    "swathed": [
        "swathe"
    ],
    "swathes": [
        "swathe"
    ],
    "swathing": [
        "swathe"
    ],
    "tartans": [
        "tartan"
    ],
    "verduns": [
        "verdun"
    ],
    "yews": [
        "yew"
    ],
    "arafats": [
        "arafat"
    ],
    "ashtrays": [
        "ashtray"
    ],
    "assassinated": [
        "assassinate"
    ],
    "assassinating": [
        "assassinate"
    ],
    "assassinates": [
        "assassinate"
    ],
    "aunties": [
        "aunty"
    ],
    "casseroling": [
        "casserole"
    ],
    "casseroled": [
        "casserole"
    ],
    "chisels": [
        "chisel"
    ],
    "chiselled": [
        "chisel"
    ],
    "chiselling": [
        "chisel"
    ],
    "connollies": [
        "connolly"
    ],
    "dms": [
        "dm"
    ],
    "flotations": [
        "flotation"
    ],
    "gatess": [
        "gates"
    ],
    "grappling": [
        "grapple"
    ],
    "grappled": [
        "grapple"
    ],
    "grapples": [
        "grapple"
    ],
    "greatnesses": [
        "greatness"
    ],
    "insulated": [
        "insulate"
    ],
    "insulates": [
        "insulate"
    ],
    "insulating": [
        "insulate"
    ],
    "kashmirs": [
        "kashmir"
    ],
    "modernizations": [
        "modernization"
    ],
    "napless": [
        "naples"
    ],
    "obliterated": [
        "obliterate"
    ],
    "obliterating": [
        "obliterate"
    ],
    "obliterates": [
        "obliterate"
    ],
    "playgroups": [
        "playgroup"
    ],
    "steading": [
        "stead"
    ],
    "steads": [
        "stead"
    ],
    "superimposed": [
        "superimpose"
    ],
    "superimposing": [
        "superimpose"
    ],
    "superimposes": [
        "superimpose"
    ],
    "trampled": [
        "trample"
    ],
    "trampling": [
        "trample"
    ],
    "tramples": [
        "trample"
    ],
    "vultures": [
        "vulture"
    ],
    "witchcrafts": [
        "witchcraft"
    ],
    "aerosolled": [
        "aerosol"
    ],
    "burghs": [
        "burgh"
    ],
    "costings": [
        "costing"
    ],
    "crackdowns": [
        "crackdown"
    ],
    "fryings": [
        "frying"
    ],
    "grampians": [
        "grampian"
    ],
    "hons": [
        "hon"
    ],
    "honing": [
        "hon",
        "hone"
    ],
    "hon.": [
        "hon"
    ],
    "limas": [
        "lima"
    ],
    "mobilised": [
        "mobilise"
    ],
    "mobilising": [
        "mobilise"
    ],
    "objectors": [
        "objector"
    ],
    "orwells": [
        "orwell"
    ],
    "patsies": [
        "patsy"
    ],
    "platoes": [
        "plato"
    ],
    "retaliations": [
        "retaliation"
    ],
    "sceptics": [
        "sceptic"
    ],
    "skylines": [
        "skyline"
    ],
    "skylined": [
        "skyline"
    ],
    "vibrating": [
        "vibrate"
    ],
    "vibrated": [
        "vibrate"
    ],
    "vibrates": [
        "vibrate"
    ],
    "adulteries": [
        "adultery"
    ],
    "blitzes": [
        "blitz"
    ],
    "blitzing": [
        "blitz"
    ],
    "blitzed": [
        "blitz"
    ],
    "canaries": [
        "canary"
    ],
    "caterers": [
        "caterer"
    ],
    "dwindled": [
        "dwindle"
    ],
    "dwindling": [
        "dwindle"
    ],
    "dwindles": [
        "dwindle"
    ],
    "flimsiest": [
        "flimsy"
    ],
    "flimsies": [
        "flimsy"
    ],
    "flimsier": [
        "flimsy"
    ],
    "foodstuffs": [
        "foodstuff"
    ],
    "humilities": [
        "humility"
    ],
    "jewellers": [
        "jeweller"
    ],
    "muted": [
        "mute"
    ],
    "muting": [
        "mute"
    ],
    "norriss": [
        "norris"
    ],
    "positionings": [
        "positioning"
    ],
    "scribing": [
        "scribe"
    ],
    "scribed": [
        "scribe"
    ],
    "sixpences": [
        "sixpence"
    ],
    "tattoos": [
        "tattoo"
    ],
    "tattooing": [
        "tattoo"
    ],
    "tattooed": [
        "tattoo"
    ],
    "yrs": [
        "yr"
    ],
    "acidities": [
        "acidity"
    ],
    "adepts": [
        "adept"
    ],
    "bequests": [
        "bequest"
    ],
    "bequested": [
        "bequest"
    ],
    "biographers": [
        "biographer"
    ],
    "combos": [
        "combo"
    ],
    "emblems": [
        "emblem"
    ],
    "frocks": [
        "frock"
    ],
    "frocked": [
        "frock"
    ],
    "ghettoes": [
        "ghetto"
    ],
    "polys": [
        "poly"
    ],
    "suedes": [
        "suede"
    ],
    "trajectories": [
        "trajectory"
    ],
    "woes": [
        "woe"
    ],
    "attested": [
        "attest"
    ],
    "attests": [
        "attest"
    ],
    "attesting": [
        "attest"
    ],
    "benchmarks": [
        "benchmark"
    ],
    "benchmarking": [
        "benchmark"
    ],
    "benchmarked": [
        "benchmark"
    ],
    "churchmen": [
        "churchman"
    ],
    "churchmans": [
        "churchman"
    ],
    "czechoslovaks": [
        "czechoslovak"
    ],
    "ecosystems": [
        "ecosystem"
    ],
    "footnotes": [
        "footnote"
    ],
    "footnoted": [
        "footnote"
    ],
    "knoxes": [
        "knox"
    ],
    "ordinations": [
        "ordination"
    ],
    "replications": [
        "replication"
    ],
    "summerchilds": [
        "summerchild"
    ],
    "tots": [
        "tot"
    ],
    "totting": [
        "tot"
    ],
    "totted": [
        "tot"
    ],
    "trackings": [
        "tracking"
    ],
    "treatises": [
        "treatise"
    ],
    "utilitarians": [
        "utilitarian"
    ],
    "veered": [
        "veer"
    ],
    "veers": [
        "veer"
    ],
    "veering": [
        "veer"
    ],
    "westons": [
        "weston"
    ],
    "battings": [
        "batting"
    ],
    "curfews": [
        "curfew"
    ],
    "dissipated": [
        "dissipate"
    ],
    "dissipating": [
        "dissipate"
    ],
    "dissipates": [
        "dissipate"
    ],
    "enveloped": [
        "envelop"
    ],
    "enveloping": [
        "envelop"
    ],
    "envelops": [
        "envelop"
    ],
    "histamines": [
        "histamine"
    ],
    "hutchinsons": [
        "hutchinson"
    ],
    "nasas": [
        "nasa"
    ],
    "postponements": [
        "postponement"
    ],
    "sparrows": [
        "sparrow"
    ],
    "specialisations": [
        "specialisation"
    ],
    "acceptabilities": [
        "acceptability"
    ],
    "collaborators": [
        "collaborator"
    ],
    "connectors": [
        "connector"
    ],
    "detainees": [
        "detainee"
    ],
    "fleeces": [
        "fleece"
    ],
    "fleeced": [
        "fleece"
    ],
    "fleecing": [
        "fleece"
    ],
    "holloways": [
        "holloway"
    ],
    "irrigations": [
        "irrigation"
    ],
    "leavers": [
        "leaver"
    ],
    "mantelpieces": [
        "mantelpiece"
    ],
    "mistier": [
        "misty"
    ],
    "mistiest": [
        "misty"
    ],
    "obscenities": [
        "obscenity"
    ],
    "rabbis": [
        "rabbi"
    ],
    "reunifications": [
        "reunification"
    ],
    "seekers": [
        "seeker"
    ],
    "sennas": [
        "senna"
    ],
    "tiptoed": [
        "tiptoe"
    ],
    "tiptoeing": [
        "tiptoe"
    ],
    "tiptoes": [
        "tiptoe"
    ],
    "tirednesses": [
        "tiredness"
    ],
    "wobbled": [
        "wobble"
    ],
    "wobbling": [
        "wobble"
    ],
    "wobbles": [
        "wobble"
    ],
    "antarcticas": [
        "antarctica"
    ],
    "birthplaces": [
        "birthplace"
    ],
    "bodyguards": [
        "bodyguard"
    ],
    "bodyguarding": [
        "bodyguard"
    ],
    "chimes": [
        "chime"
    ],
    "chimed": [
        "chime"
    ],
    "chiming": [
        "chime"
    ],
    "commuting": [
        "commute"
    ],
    "commuted": [
        "commute"
    ],
    "commutes": [
        "commute"
    ],
    "diggings": [
        "digging"
    ],
    "downturns": [
        "downturn"
    ],
    "downturned": [
        "downturn"
    ],
    "insignias": [
        "insignia"
    ],
    "instilled": [
        "instil"
    ],
    "instilling": [
        "instil"
    ],
    "instils": [
        "instil"
    ],
    "interviewees": [
        "interviewee"
    ],
    "landfills": [
        "landfill"
    ],
    "mussels": [
        "mussel"
    ],
    "postings": [
        "posting"
    ],
    "reintroduced": [
        "reintroduce"
    ],
    "reintroducing": [
        "reintroduce"
    ],
    "reintroduces": [
        "reintroduce"
    ],
    "seasonings": [
        "seasoning"
    ],
    "shipyards": [
        "shipyard"
    ],
    "slags": [
        "slag"
    ],
    "slagging": [
        "slag"
    ],
    "slagged": [
        "slag"
    ],
    "vaginas": [
        "vagina"
    ],
    "alaskas": [
        "alaska"
    ],
    "commissionings": [
        "commissioning"
    ],
    "custards": [
        "custard"
    ],
    "disdained": [
        "disdain"
    ],
    "disdaining": [
        "disdain"
    ],
    "disdains": [
        "disdain"
    ],
    "heartbeats": [
        "heartbeat"
    ],
    "lagoons": [
        "lagoon"
    ],
    "nauseas": [
        "nausea"
    ],
    "parsons": [
        "parson"
    ],
    "plied": [
        "ply"
    ],
    "plying": [
        "ply"
    ],
    "plyed": [
        "ply"
    ],
    "plys": [
        "ply"
    ],
    "senders": [
        "sender"
    ],
    "shins": [
        "shin"
    ],
    "shinning": [
        "shin"
    ],
    "shinned": [
        "shin"
    ],
    "tapering": [
        "taper"
    ],
    "tapered": [
        "taper"
    ],
    "tapers": [
        "taper"
    ],
    "adequacies": [
        "adequacy"
    ],
    "adrenalins": [
        "adrenalin"
    ],
    "burgundies": [
        "burgundy"
    ],
    "contestants": [
        "contestant"
    ],
    "corinthians": [
        "corinthian"
    ],
    "espoused": [
        "espouse"
    ],
    "espousing": [
        "espouse"
    ],
    "espouses": [
        "espouse"
    ],
    "facsimiles": [
        "facsimile"
    ],
    "grandads": [
        "grandad"
    ],
    "muzzles": [
        "muzzle"
    ],
    "muzzled": [
        "muzzle"
    ],
    "muzzling": [
        "muzzle"
    ],
    "punjabs": [
        "punjab"
    ],
    "stigmas": [
        "stigma"
    ],
    "stigmata": [
        "stigma"
    ],
    "throbbed": [
        "throb"
    ],
    "throbbing": [
        "throb"
    ],
    "throbs": [
        "throb"
    ],
    "woollies": [
        "woolly"
    ],
    "woollier": [
        "woolly"
    ],
    "woolliest": [
        "woolly"
    ],
    "dickinsons": [
        "dickinson"
    ],
    "finnishes": [
        "finnish"
    ],
    "goldbergs": [
        "goldberg"
    ],
    "immortals": [
        "immortal"
    ],
    "infarctions": [
        "infarction"
    ],
    "intolerances": [
        "intolerance"
    ],
    "machoes": [
        "macho"
    ],
    "macros": [
        "macro"
    ],
    "mscs": [
        "msc"
    ],
    "mussolinis": [
        "mussolini"
    ],
    "oilies": [
        "oily"
    ],
    "oilier": [
        "oily"
    ],
    "oiliest": [
        "oily"
    ],
    "pacifists": [
        "pacifist"
    ],
    "porridges": [
        "porridge"
    ],
    "premierships": [
        "premiership"
    ],
    "primroses": [
        "primrose"
    ],
    "redesigned": [
        "redesign"
    ],
    "redesigning": [
        "redesign"
    ],
    "redesigns": [
        "redesign"
    ],
    "strifes": [
        "strife"
    ],
    "transformers": [
        "transformer"
    ],
    "visualized": [
        "visualize"
    ],
    "visualizing": [
        "visualize"
    ],
    "visualizes": [
        "visualize"
    ],
    "woolves": [
        "woolf"
    ],
    "agms": [
        "agm"
    ],
    "apathies": [
        "apathy"
    ],
    "boardrooms": [
        "boardroom"
    ],
    "bosoms": [
        "bosom"
    ],
    "cheekbones": [
        "cheekbone"
    ],
    "clarences": [
        "clarence"
    ],
    "delinquents": [
        "delinquent"
    ],
    "escalated": [
        "escalate"
    ],
    "escalating": [
        "escalate"
    ],
    "escalates": [
        "escalate"
    ],
    "fixings": [
        "fixing"
    ],
    "gleaned": [
        "glean"
    ],
    "gleaning": [
        "glean"
    ],
    "gleans": [
        "glean"
    ],
    "multiplicities": [
        "multiplicity"
    ],
    "patriotisms": [
        "patriotism"
    ],
    "raspberries": [
        "raspberry"
    ],
    "raspberrying": [
        "raspberry"
    ],
    "sinkings": [
        "sinking"
    ],
    "spokespersons": [
        "spokesperson"
    ],
    "struts": [
        "strut"
    ],
    "strutted": [
        "strut"
    ],
    "strutting": [
        "strut"
    ],
    "subgroups": [
        "subgroup"
    ],
    "subgrouping": [
        "subgroup"
    ],
    "tendoned": [
        "tendon"
    ],
    "thirstier": [
        "thirsty"
    ],
    "thirstiest": [
        "thirsty"
    ],
    "unwillingnesses": [
        "unwillingness"
    ],
    "batoned": [
        "baton"
    ],
    "batoning": [
        "baton"
    ],
    "buttocks": [
        "buttock"
    ],
    "buttocked": [
        "buttock"
    ],
    "courtships": [
        "courtship"
    ],
    "dictums": [
        "dictum"
    ],
    "fervours": [
        "fervour"
    ],
    "functionalists": [
        "functionalist"
    ],
    "improvised": [
        "improvise"
    ],
    "improvising": [
        "improvise"
    ],
    "legalities": [
        "legality"
    ],
    "modernised": [
        "modernise"
    ],
    "modernising": [
        "modernise"
    ],
    "mosquitos": [
        "mosquito"
    ],
    "mosquitoes": [
        "mosquitoe",
        "mosquito"
    ],
    "nulled": [
        "null"
    ],
    "nulling": [
        "null"
    ],
    "nulls": [
        "null"
    ],
    "prowesses": [
        "prowess"
    ],
    "sarcasms": [
        "sarcasm"
    ],
    "scantest": [
        "scant"
    ],
    "scanted": [
        "scant"
    ],
    "scanter": [
        "scant"
    ],
    "sieves": [
        "sieve"
    ],
    "sieving": [
        "sieve"
    ],
    "sieved": [
        "sieve"
    ],
    "smellies": [
        "smelly"
    ],
    "smelliest": [
        "smelly"
    ],
    "smellier": [
        "smelly"
    ],
    "stainings": [
        "staining"
    ],
    "tehrans": [
        "tehran"
    ],
    "timids": [
        "timid"
    ],
    "yanked": [
        "yank"
    ],
    "yanks": [
        "yank"
    ],
    "yanking": [
        "yank"
    ],
    "composures": [
        "composure"
    ],
    "daphnes": [
        "daphne"
    ],
    "disabled": [
        "disable"
    ],
    "disabling": [
        "disable"
    ],
    "disables": [
        "disable"
    ],
    "draftings": [
        "drafting"
    ],
    "enticed": [
        "entice"
    ],
    "enticing": [
        "entice"
    ],
    "entices": [
        "entice"
    ],
    "headphones": [
        "headphone"
    ],
    "instigated": [
        "instigate"
    ],
    "instigating": [
        "instigate"
    ],
    "instigates": [
        "instigate"
    ],
    "interrogated": [
        "interrogate"
    ],
    "interrogating": [
        "interrogate"
    ],
    "interrogates": [
        "interrogate"
    ],
    "kinases": [
        "kinase"
    ],
    "kinased": [
        "kinase"
    ],
    "kinasing": [
        "kinase"
    ],
    "mds": [
        "md"
    ],
    "miscarriages": [
        "miscarriage"
    ],
    "reorganised": [
        "reorganise"
    ],
    "reorganising": [
        "reorganise"
    ],
    "saturations": [
        "saturation"
    ],
    "sleepers": [
        "sleeper"
    ],
    "sleepered": [
        "sleeper"
    ],
    "spartans": [
        "spartan"
    ],
    "steens": [
        "steen"
    ],
    "submerged": [
        "submerge"
    ],
    "submerging": [
        "submerge"
    ],
    "touted": [
        "tout"
    ],
    "touting": [
        "tout"
    ],
    "clinicians": [
        "clinician"
    ],
    "communicators": [
        "communicator"
    ],
    "corrosions": [
        "corrosion"
    ],
    "dichotomies": [
        "dichotomy"
    ],
    "grubs": [
        "grub"
    ],
    "grubbing": [
        "grub"
    ],
    "grubbed": [
        "grub"
    ],
    "hysterias": [
        "hysteria"
    ],
    "jesuits": [
        "jesuit"
    ],
    "juggling": [
        "juggle"
    ],
    "juggled": [
        "juggle"
    ],
    "juggles": [
        "juggle"
    ],
    "leakages": [
        "leakage"
    ],
    "papacies": [
        "papacy"
    ],
    "planetaries": [
        "planetary"
    ],
    "shadier": [
        "shady"
    ],
    "shadiest": [
        "shady"
    ],
    "tableaus": [
        "tableau"
    ],
    "vilest": [
        "vile"
    ],
    "viler": [
        "vile"
    ],
    "zebras": [
        "zebra"
    ],
    "blockings": [
        "blocking"
    ],
    "cloudier": [
        "cloudy"
    ],
    "disconnected": [
        "disconnect"
    ],
    "disconnects": [
        "disconnect"
    ],
    "disconnecting": [
        "disconnect"
    ],
    "dreariest": [
        "dreary"
    ],
    "drearier": [
        "dreary"
    ],
    "lamed": [
        "lame"
    ],
    "lamest": [
        "lame"
    ],
    "laming": [
        "lame"
    ],
    "luthers": [
        "luther"
    ],
    "performings": [
        "performing"
    ],
    "pivoting": [
        "pivot"
    ],
    "pivoted": [
        "pivot"
    ],
    "polyesters": [
        "polyester"
    ],
    "ravens": [
        "raven"
    ],
    "ravening": [
        "raven"
    ],
    "salzburgs": [
        "salzburg"
    ],
    "switchboards": [
        "switchboard"
    ],
    "trudged": [
        "trudge"
    ],
    "trudging": [
        "trudge"
    ],
    "trudges": [
        "trudge"
    ],
    "atlantas": [
        "atlanta"
    ],
    "binders": [
        "binder"
    ],
    "bloomings": [
        "blooming"
    ],
    "fraying": [
        "fray"
    ],
    "frayed": [
        "fray"
    ],
    "frays": [
        "fray"
    ],
    "fraid": [
        "fray"
    ],
    "haled": [
        "hale"
    ],
    "haling": [
        "hale"
    ],
    "helplines": [
        "helpline"
    ],
    "lodgers": [
        "lodger"
    ],
    "meads": [
        "mead"
    ],
    "minks": [
        "mink"
    ],
    "ops": [
        "op"
    ],
    "opped": [
        "op"
    ],
    "oped": [
        "op"
    ],
    "persias": [
        "persia"
    ],
    "pleats": [
        "pleat"
    ],
    "pleated": [
        "pleat"
    ],
    "pleating": [
        "pleat"
    ],
    "prunings": [
        "pruning"
    ],
    "rodents": [
        "rodent"
    ],
    "stowed": [
        "stow"
    ],
    "stowing": [
        "stow"
    ],
    "stows": [
        "stow"
    ],
    "wiltons": [
        "wilton"
    ],
    "alluded": [
        "allude"
    ],
    "alluding": [
        "allude"
    ],
    "alludes": [
        "allude"
    ],
    "borning": [
        "born"
    ],
    "borns": [
        "born"
    ],
    "catapulted": [
        "catapult"
    ],
    "catapults": [
        "catapult"
    ],
    "catapulting": [
        "catapult"
    ],
    "constabularies": [
        "constabulary"
    ],
    "croaked": [
        "croak"
    ],
    "croaking": [
        "croak"
    ],
    "croaks": [
        "croak"
    ],
    "evicted": [
        "evict"
    ],
    "evicting": [
        "evict"
    ],
    "evicts": [
        "evict"
    ],
    "fieldings": [
        "fielding"
    ],
    "floundering": [
        "flounder"
    ],
    "floundered": [
        "flounder"
    ],
    "flounders": [
        "flounder"
    ],
    "frankensteins": [
        "frankenstein"
    ],
    "highnesses": [
        "highness"
    ],
    "itineraries": [
        "itinerary"
    ],
    "minsters": [
        "minster"
    ],
    "reasserted": [
        "reassert"
    ],
    "reasserting": [
        "reassert"
    ],
    "reasserts": [
        "reassert"
    ],
    "supposings": [
        "supposing"
    ],
    "teapots": [
        "teapot"
    ],
    "trendies": [
        "trendy"
    ],
    "trendiest": [
        "trendy"
    ],
    "trendier": [
        "trendy"
    ],
    "venoms": [
        "venom"
    ],
    "ailments": [
        "ailment"
    ],
    "bedtimes": [
        "bedtime"
    ],
    "caverns": [
        "cavern"
    ],
    "cluttered": [
        "clutter"
    ],
    "cluttering": [
        "clutter"
    ],
    "clutters": [
        "clutter"
    ],
    "disproportionating": [
        "disproportionate"
    ],
    "empathies": [
        "empathy"
    ],
    "moroccans": [
        "moroccan"
    ],
    "morphologies": [
        "morphology"
    ],
    "probings": [
        "probing"
    ],
    "quilts": [
        "quilt"
    ],
    "quilting": [
        "quilt"
    ],
    "quilted": [
        "quilt"
    ],
    "recoiled": [
        "recoil"
    ],
    "recoiling": [
        "recoil"
    ],
    "recoils": [
        "recoil"
    ],
    "referents": [
        "referent"
    ],
    "reprimanded": [
        "reprimand"
    ],
    "reprimands": [
        "reprimand"
    ],
    "reprimanding": [
        "reprimand"
    ],
    "screwdrivers": [
        "screwdriver"
    ],
    "seeings": [
        "seeing"
    ],
    "shunted": [
        "shunt"
    ],
    "shunting": [
        "shunt"
    ],
    "shunts": [
        "shunt"
    ],
    "smuggest": [
        "smug"
    ],
    "smugger": [
        "smug"
    ],
    "timescales": [
        "timescale"
    ],
    "wrestlings": [
        "wrestling"
    ],
    "yogurts": [
        "yogurt"
    ],
    "backlashes": [
        "backlash"
    ],
    "blighted": [
        "blight"
    ],
    "blighting": [
        "blight"
    ],
    "blights": [
        "blight"
    ],
    "crusaders": [
        "crusader"
    ],
    "dampened": [
        "dampen"
    ],
    "dampening": [
        "dampen"
    ],
    "dampens": [
        "dampen"
    ],
    "kernels": [
        "kernel"
    ],
    "movers": [
        "mover"
    ],
    "napiers": [
        "napier"
    ],
    "parchments": [
        "parchment"
    ],
    "parishioners": [
        "parishioner"
    ],
    "pollocks": [
        "pollock"
    ],
    "reunited": [
        "reunite"
    ],
    "reunites": [
        "reunite"
    ],
    "reuniting": [
        "reunite"
    ],
    "sems": [
        "sem"
    ],
    "stints": [
        "stint"
    ],
    "stinted": [
        "stint"
    ],
    "stinting": [
        "stint"
    ],
    "stretchers": [
        "stretcher"
    ],
    "stretchered": [
        "stretcher"
    ],
    "trinidads": [
        "trinidad"
    ],
    "amalgamated": [
        "amalgamate"
    ],
    "amalgamating": [
        "amalgamate"
    ],
    "amalgamates": [
        "amalgamate"
    ],
    "anonymities": [
        "anonymity"
    ],
    "assortments": [
        "assortment"
    ],
    "backups": [
        "backup"
    ],
    "bazaars": [
        "bazaar"
    ],
    "blackboards": [
        "blackboard"
    ],
    "chemotherapies": [
        "chemotherapy"
    ],
    "cleansings": [
        "cleansing"
    ],
    "closets": [
        "closet"
    ],
    "closeted": [
        "closet"
    ],
    "closetting": [
        "closet"
    ],
    "closeting": [
        "closet"
    ],
    "cynicisms": [
        "cynicism"
    ],
    "elevateds": [
        "elevated"
    ],
    "fairways": [
        "fairway"
    ],
    "ldcs": [
        "ldc"
    ],
    "nettings": [
        "netting"
    ],
    "novas": [
        "nova"
    ],
    "novae": [
        "nova"
    ],
    "pleadings": [
        "pleading"
    ],
    "ruptured": [
        "rupture"
    ],
    "rupturing": [
        "rupture"
    ],
    "slavs": [
        "slav"
    ],
    "streamlining": [
        "streamline"
    ],
    "streamlined": [
        "streamline"
    ],
    "streamlines": [
        "streamline"
    ],
    "tensors": [
        "tensor"
    ],
    "troopers": [
        "trooper"
    ],
    "tylers": [
        "tyler"
    ],
    "unkindest": [
        "unkind"
    ],
    "unkinder": [
        "unkind"
    ],
    "upsurges": [
        "upsurge"
    ],
    "backbenchers": [
        "backbencher"
    ],
    "bloomsburies": [
        "bloomsbury"
    ],
    "calcuttas": [
        "calcutta"
    ],
    "changs": [
        "chang"
    ],
    "greenlands": [
        "greenland"
    ],
    "organists": [
        "organist"
    ],
    "pathogeneses": [
        "pathogenesis"
    ],
    "personas": [
        "persona"
    ],
    "personae": [
        "persona"
    ],
    "racecourses": [
        "racecourse"
    ],
    "subdued": [
        "subdue"
    ],
    "subduing": [
        "subdue"
    ],
    "subdues": [
        "subdue"
    ],
    "tibetans": [
        "tibetan"
    ],
    "arbitraging": [
        "arbitrage"
    ],
    "bents": [
        "bent"
    ],
    "bombarded": [
        "bombard"
    ],
    "bombarding": [
        "bombard"
    ],
    "bombards": [
        "bombard"
    ],
    "defused": [
        "defuse"
    ],
    "defusing": [
        "defuse"
    ],
    "defuses": [
        "defuse"
    ],
    "desirabilities": [
        "desirability"
    ],
    "devolved": [
        "devolve"
    ],
    "devolving": [
        "devolve"
    ],
    "devolves": [
        "devolve"
    ],
    "eastons": [
        "easton"
    ],
    "evictions": [
        "eviction"
    ],
    "filenames": [
        "filename"
    ],
    "grindings": [
        "grinding"
    ],
    "inlets": [
        "inlet"
    ],
    "inletting": [
        "inlet"
    ],
    "maines": [
        "maine"
    ],
    "mashed": [
        "mash"
    ],
    "mashing": [
        "mash"
    ],
    "mashes": [
        "mash"
    ],
    "matisses": [
        "matisse"
    ],
    "observatories": [
        "observatory"
    ],
    "riveted": [
        "rivet"
    ],
    "riveting": [
        "rivet"
    ],
    "rivetted": [
        "rivet"
    ],
    "rourkes": [
        "rourke"
    ],
    "staunchest": [
        "staunch"
    ],
    "staunching": [
        "staunch"
    ],
    "staunched": [
        "staunch"
    ],
    "staunches": [
        "staunch"
    ],
    "stauncher": [
        "staunch"
    ],
    "structuralists": [
        "structuralist"
    ],
    "tanners": [
        "tanner"
    ],
    "teasings": [
        "teasing"
    ],
    "transparencies": [
        "transparency"
    ],
    "worsenings": [
        "worsening"
    ],
    "appraised": [
        "appraise"
    ],
    "appraising": [
        "appraise"
    ],
    "appraises": [
        "appraise"
    ],
    "attractivenesses": [
        "attractiveness"
    ],
    "autographs": [
        "autograph"
    ],
    "autographed": [
        "autograph"
    ],
    "autographing": [
        "autograph"
    ],
    "barbadoss": [
        "barbados"
    ],
    "cruisers": [
        "cruiser"
    ],
    "diverged": [
        "diverge"
    ],
    "diverges": [
        "diverge"
    ],
    "diverging": [
        "diverge"
    ],
    "entropies": [
        "entropy"
    ],
    "golfings": [
        "golfing"
    ],
    "griffins": [
        "griffin"
    ],
    "hoopers": [
        "hooper"
    ],
    "incrementals": [
        "incremental"
    ],
    "laities": [
        "laity"
    ],
    "likenesses": [
        "likeness"
    ],
    "newarks": [
        "newark"
    ],
    "refineries": [
        "refinery"
    ],
    "shingled": [
        "shingle"
    ],
    "shingles": [
        "shingle"
    ],
    "tenements": [
        "tenement"
    ],
    "vanessas": [
        "vanessa"
    ],
    "walesas": [
        "walesa"
    ],
    "chubs": [
        "chub"
    ],
    "delusions": [
        "delusion"
    ],
    "dislodged": [
        "dislodge"
    ],
    "dislodging": [
        "dislodge"
    ],
    "dislodges": [
        "dislodge"
    ],
    "ecuadors": [
        "ecuador"
    ],
    "functionalities": [
        "functionality"
    ],
    "incensed": [
        "incense"
    ],
    "incenses": [
        "incense"
    ],
    "incensing": [
        "incense"
    ],
    "khrushchevs": [
        "khrushchev"
    ],
    "napping": [
        "nap"
    ],
    "naps": [
        "nap"
    ],
    "napped": [
        "nap"
    ],
    "prised": [
        "prise"
    ],
    "prising": [
        "prise"
    ],
    "rembrandts": [
        "rembrandt"
    ],
    "reverenced": [
        "reverence"
    ],
    "reverencing": [
        "reverence"
    ],
    "stenches": [
        "stench"
    ],
    "symposia": [
        "symposium"
    ],
    "telexed": [
        "telex"
    ],
    "telexing": [
        "telex"
    ],
    "tubulars": [
        "tubular"
    ],
    "underwoods": [
        "underwood"
    ],
    "unearthed": [
        "unearth"
    ],
    "unearthing": [
        "unearth"
    ],
    "unearths": [
        "unearth"
    ],
    "wholesalers": [
        "wholesaler"
    ],
    "accomplices": [
        "accomplice"
    ],
    "approachings": [
        "approaching"
    ],
    "arterials": [
        "arterial"
    ],
    "athenians": [
        "athenian"
    ],
    "becketts": [
        "beckett"
    ],
    "blisters": [
        "blister"
    ],
    "blistered": [
        "blister"
    ],
    "blistering": [
        "blister"
    ],
    "cobbles": [
        "cobble"
    ],
    "cobbled": [
        "cobble"
    ],
    "cobbling": [
        "cobble"
    ],
    "damascuss": [
        "damascus"
    ],
    "fingernails": [
        "fingernail"
    ],
    "forbiddings": [
        "forbidding"
    ],
    "gallants": [
        "gallant"
    ],
    "hangers": [
        "hanger"
    ],
    "illicits": [
        "illicit"
    ],
    "imperialists": [
        "imperialist"
    ],
    "jeopardised": [
        "jeopardise"
    ],
    "jeopardising": [
        "jeopardise"
    ],
    "jeopardises": [
        "jeopardise"
    ],
    "snapshots": [
        "snapshot"
    ],
    "syphiliss": [
        "syphilis"
    ],
    "wcs": [
        "wc"
    ],
    "wc's": [
        "wc"
    ],
    "archways": [
        "archway"
    ],
    "benefactors": [
        "benefactor"
    ],
    "campaignings": [
        "campaigning"
    ],
    "carrolls": [
        "carroll"
    ],
    "committals": [
        "committal"
    ],
    "greyhounds": [
        "greyhound"
    ],
    "houghtons": [
        "houghton"
    ],
    "hurtling": [
        "hurtle"
    ],
    "hurtled": [
        "hurtle"
    ],
    "hurtles": [
        "hurtle"
    ],
    "ignitions": [
        "ignition"
    ],
    "judaisms": [
        "judaism"
    ],
    "junipers": [
        "juniper"
    ],
    "parochials": [
        "parochial"
    ],
    "pulsars": [
        "pulsar"
    ],
    "redwoods": [
        "redwood"
    ],
    "rhines": [
        "rhine"
    ],
    "segmentations": [
        "segmentation"
    ],
    "slithered": [
        "slither"
    ],
    "slithering": [
        "slither"
    ],
    "slithers": [
        "slither"
    ],
    "transpired": [
        "transpire"
    ],
    "transpiring": [
        "transpire"
    ],
    "anarchies": [
        "anarchy"
    ],
    "armaments": [
        "armament"
    ],
    "billings": [
        "billing"
    ],
    "dorians": [
        "dorian"
    ],
    "droppings": [
        "dropping"
    ],
    "febs": [
        "feb"
    ],
    "filths": [
        "filth"
    ],
    "gardiners": [
        "gardiner"
    ],
    "goldings": [
        "golding"
    ],
    "helsinkis": [
        "helsinki"
    ],
    "ignited": [
        "ignite"
    ],
    "igniting": [
        "ignite"
    ],
    "ignites": [
        "ignite"
    ],
    "inducements": [
        "inducement"
    ],
    "kerbs": [
        "kerb"
    ],
    "kerbing": [
        "kerb"
    ],
    "kerbed": [
        "kerb"
    ],
    "leeches": [
        "leech"
    ],
    "leeching": [
        "leech"
    ],
    "leeched": [
        "leech"
    ],
    "moms": [
        "mom"
    ],
    "nvqs": [
        "nvq"
    ],
    "parisians": [
        "parisian"
    ],
    "pervaded": [
        "pervade"
    ],
    "pervades": [
        "pervade"
    ],
    "pervading": [
        "pervade"
    ],
    "shriller": [
        "shrill"
    ],
    "shrills": [
        "shrill"
    ],
    "shrillest": [
        "shrill"
    ],
    "shrilling": [
        "shrill"
    ],
    "shrilled": [
        "shrill"
    ],
    "teaspoons": [
        "teaspoon"
    ],
    "tortoises": [
        "tortoise"
    ],
    "tortoising": [
        "tortoise"
    ],
    "tortoised": [
        "tortoise"
    ],
    "airmen": [
        "airman"
    ],
    "beholding": [
        "behold"
    ],
    "beholds": [
        "behold"
    ],
    "beheld": [
        "behold"
    ],
    "chaplins": [
        "chaplin"
    ],
    "companionships": [
        "companionship"
    ],
    "derridas": [
        "derrida"
    ],
    "flagships": [
        "flagship"
    ],
    "guidebooks": [
        "guidebook"
    ],
    "haulages": [
        "haulage"
    ],
    "hiking": [
        "hike"
    ],
    "hikes": [
        "hike"
    ],
    "hiked": [
        "hike"
    ],
    "mariners": [
        "mariner"
    ],
    "mistrusted": [
        "mistrust"
    ],
    "mistrusting": [
        "mistrust"
    ],
    "mistrusts": [
        "mistrust"
    ],
    "nethers": [
        "nether"
    ],
    "occupancies": [
        "occupancy"
    ],
    "plasminogens": [
        "plasminogen"
    ],
    "searchings": [
        "searching"
    ],
    "seedlings": [
        "seedling"
    ],
    "shams": [
        "sham"
    ],
    "shamming": [
        "sham"
    ],
    "shammed": [
        "sham"
    ],
    "soarings": [
        "soaring"
    ],
    "airier": [
        "airy"
    ],
    "airiest": [
        "airy"
    ],
    "characterisations": [
        "characterisation"
    ],
    "clerics": [
        "cleric"
    ],
    "complainants": [
        "complainant"
    ],
    "crackings": [
        "cracking"
    ],
    "enrichments": [
        "enrichment"
    ],
    "forays": [
        "foray"
    ],
    "foraying": [
        "foray"
    ],
    "handcuffs": [
        "handcuff"
    ],
    "handcuffed": [
        "handcuff"
    ],
    "handcuffing": [
        "handcuff"
    ],
    "intelligentsias": [
        "intelligentsia"
    ],
    "jocks": [
        "jock"
    ],
    "jocked": [
        "jock"
    ],
    "paraffins": [
        "paraffin"
    ],
    "ramparts": [
        "rampart"
    ],
    "surmounted": [
        "surmount"
    ],
    "surmounting": [
        "surmount"
    ],
    "surmounts": [
        "surmount"
    ],
    "syrups": [
        "syrup"
    ],
    "bundesbanks": [
        "bundesbank"
    ],
    "consorting": [
        "consort"
    ],
    "consorted": [
        "consort"
    ],
    "eradications": [
        "eradication"
    ],
    "errands": [
        "errand"
    ],
    "gradings": [
        "grading"
    ],
    "outflows": [
        "outflow"
    ],
    "outflowing": [
        "outflow"
    ],
    "proctors": [
        "proctor"
    ],
    "sightings": [
        "sighting"
    ],
    "spluttered": [
        "splutter"
    ],
    "spluttering": [
        "splutter"
    ],
    "splutters": [
        "splutter"
    ],
    "sublimest": [
        "sublime"
    ],
    "sublimed": [
        "sublime"
    ],
    "subliming": [
        "sublime"
    ],
    "cambodians": [
        "cambodian"
    ],
    "conquerors": [
        "conqueror"
    ],
    "fillers": [
        "filler"
    ],
    "fitters": [
        "fitter"
    ],
    "grocers": [
        "grocer"
    ],
    "hijacked": [
        "hijack"
    ],
    "hijacking": [
        "hijack"
    ],
    "hijacks": [
        "hijack"
    ],
    "homelier": [
        "homely"
    ],
    "humanists": [
        "humanist"
    ],
    "italics": [
        "italic"
    ],
    "loughs": [
        "lough"
    ],
    "nourished": [
        "nourish"
    ],
    "nourishing": [
        "nourish"
    ],
    "nourishes": [
        "nourish"
    ],
    "overruled": [
        "overrule"
    ],
    "overruling": [
        "overrule"
    ],
    "overrules": [
        "overrule"
    ],
    "servicings": [
        "servicing"
    ],
    "shipbuildings": [
        "shipbuilding"
    ],
    "stagings": [
        "staging"
    ],
    "standstills": [
        "standstill"
    ],
    "tectonics": [
        "tectonic"
    ],
    "worsted": [
        "worst"
    ],
    "worsts": [
        "worst"
    ],
    "worsting": [
        "worst"
    ],
    "ayer": [
        "ay"
    ],
    "ays": [
        "ay"
    ],
    "broodings": [
        "brooding"
    ],
    "chippings": [
        "chipping"
    ],
    "containments": [
        "containment"
    ],
    "contentments": [
        "contentment"
    ],
    "cossacks": [
        "cossack"
    ],
    "depleted": [
        "deplete"
    ],
    "depleting": [
        "deplete"
    ],
    "depletes": [
        "deplete"
    ],
    "divinities": [
        "divinity"
    ],
    "elevators": [
        "elevator"
    ],
    "embers": [
        "ember"
    ],
    "forerunners": [
        "forerunner"
    ],
    "headmistresses": [
        "headmistress"
    ],
    "leeks": [
        "leek"
    ],
    "midweeks": [
        "midweek"
    ],
    "overtones": [
        "overtone"
    ],
    "pews": [
        "pew"
    ],
    "refilled": [
        "refill"
    ],
    "refills": [
        "refill"
    ],
    "refilling": [
        "refill"
    ],
    "skiers": [
        "skier"
    ],
    "sloughed": [
        "slough"
    ],
    "sloughing": [
        "slough"
    ],
    "sloughs": [
        "slough"
    ],
    "spacings": [
        "spacing"
    ],
    "beavers": [
        "beaver"
    ],
    "beavering": [
        "beaver"
    ],
    "beavered": [
        "beaver"
    ],
    "blazings": [
        "blazing"
    ],
    "carvers": [
        "carver"
    ],
    "deviated": [
        "deviate"
    ],
    "deviates": [
        "deviate"
    ],
    "deviating": [
        "deviate"
    ],
    "ethnicities": [
        "ethnicity"
    ],
    "helenas": [
        "helena"
    ],
    "illiterates": [
        "illiterate"
    ],
    "jurassics": [
        "jurassic"
    ],
    "makeshifts": [
        "makeshift"
    ],
    "millenniums": [
        "millennium"
    ],
    "millennia": [
        "millennium"
    ],
    "offsides": [
        "offside"
    ],
    "sandinistas": [
        "sandinista"
    ],
    "selkirks": [
        "selkirk"
    ],
    "seths": [
        "seth"
    ],
    "shelved": [
        "shelve"
    ],
    "shelving": [
        "shelve"
    ],
    "sigmas": [
        "sigma"
    ],
    "stiles": [
        "stile"
    ],
    "stiled": [
        "stile"
    ],
    "stingings": [
        "stinging"
    ],
    "sureties": [
        "surety"
    ],
    "upturned": [
        "upturn"
    ],
    "upturns": [
        "upturn"
    ],
    "upturning": [
        "upturn"
    ],
    "weaning": [
        "wean"
    ],
    "weaned": [
        "wean"
    ],
    "weans": [
        "wean"
    ],
    "whiskers": [
        "whisker"
    ],
    "abrasives": [
        "abrasive"
    ],
    "amassed": [
        "amass"
    ],
    "amassing": [
        "amass"
    ],
    "censured": [
        "censure"
    ],
    "censuring": [
        "censure"
    ],
    "droned": [
        "drone"
    ],
    "droning": [
        "drone"
    ],
    "elementals": [
        "elemental"
    ],
    "engraved": [
        "engrave"
    ],
    "engraving": [
        "engrave"
    ],
    "engraves": [
        "engrave"
    ],
    "evergreens": [
        "evergreen"
    ],
    "healthcares": [
        "healthcare"
    ],
    "jostling": [
        "jostle"
    ],
    "jostled": [
        "jostle"
    ],
    "jostles": [
        "jostle"
    ],
    "kabuls": [
        "kabul"
    ],
    "liquidators": [
        "liquidator"
    ],
    "merchandised": [
        "merchandise"
    ],
    "neediest": [
        "needy"
    ],
    "needier": [
        "needy"
    ],
    "outcrops": [
        "outcrop"
    ],
    "outcropping": [
        "outcrop"
    ],
    "outcropped": [
        "outcrop"
    ],
    "porns": [
        "porn"
    ],
    "precincts": [
        "precinct"
    ],
    "precincted": [
        "precinct"
    ],
    "underclasses": [
        "underclass"
    ],
    "achings": [
        "aching"
    ],
    "backers": [
        "backer"
    ],
    "carcassed": [
        "carcass"
    ],
    "criminologies": [
        "criminology"
    ],
    "decentralizations": [
        "decentralization"
    ],
    "dinned": [
        "din"
    ],
    "dins": [
        "din"
    ],
    "dinning": [
        "din"
    ],
    "durkheims": [
        "durkheim"
    ],
    "entertainers": [
        "entertainer"
    ],
    "farrells": [
        "farrell"
    ],
    "generalized": [
        "generalize"
    ],
    "generalizing": [
        "generalize"
    ],
    "generalizes": [
        "generalize"
    ],
    "lunged": [
        "lunge"
    ],
    "lunges": [
        "lunge"
    ],
    "lungeing": [
        "lunge"
    ],
    "minders": [
        "minder"
    ],
    "nairobis": [
        "nairobi"
    ],
    "partridges": [
        "partridge"
    ],
    "quirks": [
        "quirk"
    ],
    "quirked": [
        "quirk"
    ],
    "quirking": [
        "quirk"
    ],
    "remembrances": [
        "remembrance"
    ],
    "subordinations": [
        "subordination"
    ],
    "swines": [
        "swine"
    ],
    "vaxes": [
        "vax"
    ],
    "vaxs": [
        "vax"
    ],
    "withered": [
        "wither"
    ],
    "withering": [
        "wither"
    ],
    "withers": [
        "wither"
    ],
    "deterrences": [
        "deterrence"
    ],
    "dishwashers": [
        "dishwasher"
    ],
    "foraging": [
        "forage"
    ],
    "foraged": [
        "forage"
    ],
    "queenss": [
        "queens"
    ],
    "randiest": [
        "randy"
    ],
    "randier": [
        "randy"
    ],
    "rebounded": [
        "rebound"
    ],
    "rebounding": [
        "rebound"
    ],
    "rebounds": [
        "rebound"
    ],
    "rummaged": [
        "rummage"
    ],
    "rummaging": [
        "rummage"
    ],
    "rummages": [
        "rummage"
    ],
    "solvings": [
        "solving"
    ],
    "spearheaded": [
        "spearhead"
    ],
    "spearheading": [
        "spearhead"
    ],
    "spearheads": [
        "spearhead"
    ],
    "timers": [
        "timer"
    ],
    "tysons": [
        "tyson"
    ],
    "underwriters": [
        "underwriter"
    ],
    "adobes": [
        "adobe"
    ],
    "aestheticss": [
        "aesthetics"
    ],
    "algerians": [
        "algerian"
    ],
    "antics": [
        "antic"
    ],
    "asymmetries": [
        "asymmetry"
    ],
    "bathshebas": [
        "bathsheba"
    ],
    "bickering": [
        "bicker"
    ],
    "bickers": [
        "bicker"
    ],
    "bickered": [
        "bicker"
    ],
    "branchings": [
        "branching"
    ],
    "clovers": [
        "clover"
    ],
    "deported": [
        "deport"
    ],
    "deporting": [
        "deport"
    ],
    "deports": [
        "deport"
    ],
    "dieters": [
        "dieter"
    ],
    "friedmen": [
        "friedman"
    ],
    "ghostlier": [
        "ghostly"
    ],
    "grudges": [
        "grudge"
    ],
    "grudged": [
        "grudge"
    ],
    "grudging": [
        "grudge"
    ],
    "headways": [
        "headway"
    ],
    "hoots": [
        "hoot"
    ],
    "hooted": [
        "hoot"
    ],
    "hooting": [
        "hoot"
    ],
    "jordanians": [
        "jordanian"
    ],
    "labyrinths": [
        "labyrinth"
    ],
    "malaysians": [
        "malaysian"
    ],
    "materialisms": [
        "materialism"
    ],
    "mouldings": [
        "moulding"
    ],
    "pembrokes": [
        "pembroke"
    ],
    "pups": [
        "pup"
    ],
    "pupped": [
        "pup"
    ],
    "radicalisms": [
        "radicalism"
    ],
    "radioactivities": [
        "radioactivity"
    ],
    "ramblings": [
        "rambling"
    ],
    "ruskins": [
        "ruskin"
    ],
    "sanities": [
        "sanity"
    ],
    "shaikhs": [
        "shaikh"
    ],
    "shermen": [
        "sherman"
    ],
    "subverted": [
        "subvert"
    ],
    "subverting": [
        "subvert"
    ],
    "subverts": [
        "subvert"
    ],
    "tibets": [
        "tibet"
    ],
    "torsos": [
        "torso"
    ],
    "vistas": [
        "vista"
    ],
    "weightings": [
        "weighting"
    ],
    "abductions": [
        "abduction"
    ],
    "encircled": [
        "encircle"
    ],
    "encircling": [
        "encircle"
    ],
    "encircles": [
        "encircle"
    ],
    "enigmas": [
        "enigma"
    ],
    "hearties": [
        "hearty"
    ],
    "heartiest": [
        "hearty"
    ],
    "heartier": [
        "hearty"
    ],
    "increments": [
        "increment"
    ],
    "incremented": [
        "increment"
    ],
    "incrementing": [
        "increment"
    ],
    "kidnappers": [
        "kidnapper"
    ],
    "malones": [
        "malone"
    ],
    "mulling": [
        "mull"
    ],
    "mulled": [
        "mull"
    ],
    "mulls": [
        "mull"
    ],
    "oldfields": [
        "oldfield"
    ],
    "reversions": [
        "reversion"
    ],
    "squabbles": [
        "squabble"
    ],
    "squabbling": [
        "squabble"
    ],
    "squabbled": [
        "squabble"
    ],
    "wrung": [
        "wring"
    ],
    "wringing": [
        "wring"
    ],
    "wrings": [
        "wring"
    ],
    "chunkies": [
        "chunky"
    ],
    "chunkier": [
        "chunky"
    ],
    "chunkiest": [
        "chunky"
    ],
    "constantinoples": [
        "constantinople"
    ],
    "cucumbers": [
        "cucumber"
    ],
    "ecstatics": [
        "ecstatic"
    ],
    "lakesides": [
        "lakeside"
    ],
    "lowliest": [
        "lowly"
    ],
    "lowlier": [
        "lowly"
    ],
    "midsummers": [
        "midsummer"
    ],
    "onlookers": [
        "onlooker"
    ],
    "overdriving": [
        "overdrive"
    ],
    "overdrives": [
        "overdrive"
    ],
    "overdrove": [
        "overdrive"
    ],
    "overdriven": [
        "overdrive"
    ],
    "petitioners": [
        "petitioner"
    ],
    "platoons": [
        "platoon"
    ],
    "quartzs": [
        "quartz"
    ],
    "raincoats": [
        "raincoat"
    ],
    "raincoated": [
        "raincoat"
    ],
    "recreates": [
        "recreate"
    ],
    "recreating": [
        "recreat",
        "recreate"
    ],
    "recreated": [
        "recreat",
        "recreate"
    ],
    "rottings": [
        "rotting"
    ],
    "scolded": [
        "scold"
    ],
    "scolding": [
        "scold"
    ],
    "scolds": [
        "scold"
    ],
    "siberians": [
        "siberian"
    ],
    "speculators": [
        "speculator"
    ],
    "trashed": [
        "trash"
    ],
    "trashing": [
        "trash"
    ],
    "trashes": [
        "trash"
    ],
    "tundras": [
        "tundra"
    ],
    "whimpered": [
        "whimper"
    ],
    "whimpering": [
        "whimper"
    ],
    "whimpers": [
        "whimper"
    ],
    "balancings": [
        "balancing"
    ],
    "beaumonts": [
        "beaumont"
    ],
    "childbearings": [
        "childbearing"
    ],
    "crosswords": [
        "crossword"
    ],
    "detoured": [
        "detour"
    ],
    "detouring": [
        "detour"
    ],
    "dishonesties": [
        "dishonesty"
    ],
    "drapers": [
        "draper"
    ],
    "duelling": [
        "duel"
    ],
    "duelled": [
        "duel"
    ],
    "enthused": [
        "enthuse"
    ],
    "enthuses": [
        "enthuse"
    ],
    "enthusing": [
        "enthuse"
    ],
    "granddaughters": [
        "granddaughter"
    ],
    "rigidities": [
        "rigidity"
    ],
    "sentries": [
        "sentry"
    ],
    "stepfathers": [
        "stepfather"
    ],
    "wallabies": [
        "wallaby"
    ],
    "bryonies": [
        "bryony"
    ],
    "concomitants": [
        "concomitant"
    ],
    "concurred": [
        "concur"
    ],
    "concurs": [
        "concur"
    ],
    "concurring": [
        "concur"
    ],
    "cordoned": [
        "cordon"
    ],
    "cordoning": [
        "cordon"
    ],
    "disgusteds": [
        "disgusted"
    ],
    "fraternities": [
        "fraternity"
    ],
    "goghs": [
        "gogh"
    ],
    "heydays": [
        "heyday"
    ],
    "intrusives": [
        "intrusive"
    ],
    "lyons": [
        "lyon"
    ],
    "mercers": [
        "mercer"
    ],
    "murals": [
        "mural"
    ],
    "obscurities": [
        "obscurity"
    ],
    "pertaining": [
        "pertain"
    ],
    "pertains": [
        "pertain"
    ],
    "pertained": [
        "pertain"
    ],
    "resets": [
        "reset"
    ],
    "resetting": [
        "reset"
    ],
    "schmidts": [
        "schmidt"
    ],
    "scruffier": [
        "scruffy"
    ],
    "scruffiest": [
        "scruffy"
    ],
    "scruffies": [
        "scruffy"
    ],
    "silkiest": [
        "silky"
    ],
    "silkier": [
        "silky"
    ],
    "softnesses": [
        "softness"
    ],
    "sunrises": [
        "sunrise"
    ],
    "swerved": [
        "swerve"
    ],
    "swerving": [
        "swerve"
    ],
    "swerves": [
        "swerve"
    ],
    "templetons": [
        "templeton"
    ],
    "tyrants": [
        "tyrant"
    ],
    "warheads": [
        "warhead"
    ],
    "wessexes": [
        "wessex"
    ],
    "alcoholisms": [
        "alcoholism"
    ],
    "analytics": [
        "analytic"
    ],
    "analytical": [
        "analytic"
    ],
    "argentinians": [
        "argentinian"
    ],
    "bigwigs": [
        "bigwig"
    ],
    "blobs": [
        "blob"
    ],
    "blobbed": [
        "blob"
    ],
    "confiscated": [
        "confiscate"
    ],
    "confiscating": [
        "confiscate"
    ],
    "confiscates": [
        "confiscate"
    ],
    "converters": [
        "converter"
    ],
    "cunts": [
        "cunt"
    ],
    "emersons": [
        "emerson"
    ],
    "kievs": [
        "kiev"
    ],
    "libs": [
        "lib"
    ],
    "libbing": [
        "lib"
    ],
    "pieties": [
        "piety"
    ],
    "pistoned": [
        "piston"
    ],
    "pistoning": [
        "piston"
    ],
    "pts": [
        "pt"
    ],
    "silted": [
        "silt"
    ],
    "silts": [
        "silt"
    ],
    "silting": [
        "silt"
    ],
    "teamworking": [
        "teamwork"
    ],
    "teamworks": [
        "teamwork"
    ],
    "trimmings": [
        "trimming"
    ],
    "walkways": [
        "walkway"
    ],
    "walkwayed": [
        "walkway"
    ],
    "wheelbarrows": [
        "wheelbarrow"
    ],
    "wheelbarrowing": [
        "wheelbarrow"
    ],
    "xeroxes": [
        "xerox"
    ],
    "xeroxed": [
        "xerox"
    ],
    "xeroxing": [
        "xerox"
    ],
    "yeomen": [
        "yeoman"
    ],
    "anglings": [
        "angling"
    ],
    "cessations": [
        "cessation"
    ],
    "euphorias": [
        "euphoria"
    ],
    "greenwoods": [
        "greenwood"
    ],
    "illustrators": [
        "illustrator"
    ],
    "inflated": [
        "inflate"
    ],
    "inflating": [
        "inflate"
    ],
    "inflates": [
        "inflate"
    ],
    "liberias": [
        "liberia"
    ],
    "moderators": [
        "moderator"
    ],
    "mutinies": [
        "mutiny"
    ],
    "mutinied": [
        "mutiny"
    ],
    "mutinying": [
        "mutiny"
    ],
    "scaffoldings": [
        "scaffolding"
    ],
    "snipped": [
        "snip"
    ],
    "snipping": [
        "snip"
    ],
    "snips": [
        "snip"
    ],
    "steamings": [
        "steaming"
    ],
    "vigils": [
        "vigil"
    ],
    "wakings": [
        "waking"
    ],
    "watersheds": [
        "watershed"
    ],
    "whitneys": [
        "whitney"
    ],
    "wittgensteins": [
        "wittgenstein"
    ],
    "conformations": [
        "conformation"
    ],
    "contravened": [
        "contravene"
    ],
    "contravening": [
        "contravene"
    ],
    "contravenes": [
        "contravene"
    ],
    "dellas": [
        "della"
    ],
    "festivities": [
        "festivity"
    ],
    "flannels": [
        "flannel"
    ],
    "flannelling": [
        "flannel"
    ],
    "flannelled": [
        "flannel"
    ],
    "furlongs": [
        "furlong"
    ],
    "geest": [
        "gee"
    ],
    "geeing": [
        "gee"
    ],
    "gees": [
        "gee"
    ],
    "geing": [
        "gee"
    ],
    "geed": [
        "gee"
    ],
    "jekylls": [
        "jekyll"
    ],
    "jetties": [
        "jetty"
    ],
    "jettied": [
        "jetty"
    ],
    "leveraging": [
        "leverage"
    ],
    "leveraged": [
        "leverage"
    ],
    "leverages": [
        "leverage"
    ],
    "magnesiums": [
        "magnesium"
    ],
    "misconceptions": [
        "misconception"
    ],
    "modals": [
        "modal"
    ],
    "northumbrias": [
        "northumbria"
    ],
    "omens": [
        "omen"
    ],
    "originators": [
        "originator"
    ],
    "overdone": [
        "overdo"
    ],
    "overdoing": [
        "overdo"
    ],
    "overdid": [
        "overdo"
    ],
    "overdoes": [
        "overdo"
    ],
    "rustics": [
        "rustic"
    ],
    "shunned": [
        "shun"
    ],
    "shunning": [
        "shun"
    ],
    "shuns": [
        "shun"
    ],
    "spurted": [
        "spurt"
    ],
    "spurting": [
        "spurt"
    ],
    "spurts": [
        "spurt"
    ],
    "trappings": [
        "trapping"
    ],
    "unnerved": [
        "unnerve"
    ],
    "unnerving": [
        "unnerve"
    ],
    "unnerves": [
        "unnerve"
    ],
    "veneers": [
        "veneer"
    ],
    "veneered": [
        "veneer"
    ],
    "veneering": [
        "veneer"
    ],
    "affirmatives": [
        "affirmative"
    ],
    "antis": [
        "anti"
    ],
    "brothels": [
        "brothel"
    ],
    "champing": [
        "champ"
    ],
    "champed": [
        "champ"
    ],
    "enlightened": [
        "enlighten"
    ],
    "enlightening": [
        "enlighten"
    ],
    "enlightens": [
        "enlighten"
    ],
    "glistening": [
        "glisten"
    ],
    "glistened": [
        "glisten"
    ],
    "glistens": [
        "glisten"
    ],
    "hardwoods": [
        "hardwood"
    ],
    "jeered": [
        "jeer"
    ],
    "jeers": [
        "jeer"
    ],
    "jeering": [
        "jeer"
    ],
    "linkings": [
        "linking"
    ],
    "lotioned": [
        "lotion"
    ],
    "nozzles": [
        "nozzle"
    ],
    "ohios": [
        "ohio"
    ],
    "orleanss": [
        "orleans"
    ],
    "overruns": [
        "overrun"
    ],
    "overrunning": [
        "overrun"
    ],
    "overran": [
        "overrun"
    ],
    "overrun": [
        "overrun"
    ],
    "pangs": [
        "pang"
    ],
    "propellers": [
        "propeller"
    ],
    "rhodesias": [
        "rhodesia"
    ],
    "agitated": [
        "agitate"
    ],
    "agitating": [
        "agitate"
    ],
    "agitates": [
        "agitate"
    ],
    "aldermen": [
        "alderman"
    ],
    "biochemistries": [
        "biochemistry"
    ],
    "braids": [
        "braid"
    ],
    "braided": [
        "braid"
    ],
    "braiding": [
        "braid"
    ],
    "clouted": [
        "clout"
    ],
    "clouting": [
        "clout"
    ],
    "clouts": [
        "clout"
    ],
    "compositors": [
        "compositor"
    ],
    "cotswolds": [
        "cotswold"
    ],
    "crumpled": [
        "crumple"
    ],
    "crumpling": [
        "crumple"
    ],
    "crumples": [
        "crumple"
    ],
    "flauberts": [
        "flaubert"
    ],
    "hoggs": [
        "hogg"
    ],
    "inflows": [
        "inflow"
    ],
    "inflowing": [
        "inflow"
    ],
    "monetarists": [
        "monetarist"
    ],
    "nuanced": [
        "nuance"
    ],
    "nuancing": [
        "nuance"
    ],
    "oblivions": [
        "oblivion"
    ],
    "parenthoods": [
        "parenthood"
    ],
    "recouped": [
        "recoup"
    ],
    "recouping": [
        "recoup"
    ],
    "recoups": [
        "recoup"
    ],
    "sheridans": [
        "sheridan"
    ],
    "sympathised": [
        "sympathise"
    ],
    "sympathises": [
        "sympathise"
    ],
    "sympathising": [
        "sympathise"
    ],
    "uvs": [
        "uv"
    ],
    "watermen": [
        "waterman"
    ],
    "annuities": [
        "annuity"
    ],
    "baggies": [
        "baggy"
    ],
    "baggier": [
        "baggy"
    ],
    "baggiest": [
        "baggy"
    ],
    "calaiss": [
        "calais"
    ],
    "censored": [
        "censor"
    ],
    "censors": [
        "censor"
    ],
    "censoring": [
        "censor"
    ],
    "communicatings": [
        "communicating"
    ],
    "culled": [
        "cull"
    ],
    "culling": [
        "cull"
    ],
    "culls": [
        "cull"
    ],
    "danubes": [
        "danube"
    ],
    "delving": [
        "delve"
    ],
    "delved": [
        "delve"
    ],
    "delves": [
        "delve"
    ],
    "kremlins": [
        "kremlin"
    ],
    "leasings": [
        "leasing"
    ],
    "munching": [
        "munch"
    ],
    "munched": [
        "munch"
    ],
    "munches": [
        "munch"
    ],
    "peruvians": [
        "peruvian"
    ],
    "projectors": [
        "projector"
    ],
    "romped": [
        "romp"
    ],
    "romping": [
        "romp"
    ],
    "socializations": [
        "socialization"
    ],
    "subdivided": [
        "subdivide"
    ],
    "subdividing": [
        "subdivide"
    ],
    "subdivides": [
        "subdivide"
    ],
    "susceptibilities": [
        "susceptibility"
    ],
    "tablecloths": [
        "tablecloth"
    ],
    "tacts": [
        "tact"
    ],
    "versatilities": [
        "versatility"
    ],
    "wrens": [
        "wren"
    ],
    "aahs": [
        "aah"
    ],
    "aahing": [
        "aah"
    ],
    "aahed": [
        "aah"
    ],
    "aahhing": [
        "aah"
    ],
    "apprehended": [
        "apprehend"
    ],
    "apprehending": [
        "apprehend"
    ],
    "apprehends": [
        "apprehend"
    ],
    "chileans": [
        "chilean"
    ],
    "dominoes": [
        "domino"
    ],
    "experimenters": [
        "experimenter"
    ],
    "flickerings": [
        "flickering"
    ],
    "horaces": [
        "horace"
    ],
    "islays": [
        "islay"
    ],
    "kinsmen": [
        "kinsman"
    ],
    "manilas": [
        "manila"
    ],
    "onuss": [
        "onus"
    ],
    "rinds": [
        "rind"
    ],
    "rinded": [
        "rind"
    ],
    "stubbed": [
        "stub"
    ],
    "stubs": [
        "stub"
    ],
    "stubbing": [
        "stub"
    ],
    "throbbings": [
        "throbbing"
    ],
    "washers": [
        "washer"
    ],
    "wreaths": [
        "wreath"
    ],
    "animosities": [
        "animosity"
    ],
    "antagonists": [
        "antagonist"
    ],
    "dribbling": [
        "dribble"
    ],
    "dribbled": [
        "dribble"
    ],
    "etchings": [
        "etching"
    ],
    "genomes": [
        "genome"
    ],
    "hegels": [
        "hegel"
    ],
    "herbals": [
        "herbal"
    ],
    "interspersed": [
        "intersperse"
    ],
    "interspersing": [
        "intersperse"
    ],
    "intersperses": [
        "intersperse"
    ],
    "ludens": [
        "luden"
    ],
    "magnified": [
        "magnify"
    ],
    "magnifying": [
        "magnify"
    ],
    "nightingales": [
        "nightingale"
    ],
    "quainter": [
        "quaint"
    ],
    "quaintest": [
        "quaint"
    ],
    "rainiest": [
        "rainy"
    ],
    "rainier": [
        "rainy"
    ],
    "scrabbled": [
        "scrabble"
    ],
    "scrabbling": [
        "scrabble"
    ],
    "scrabbles": [
        "scrabble"
    ],
    "stairways": [
        "stairway"
    ],
    "stalwarts": [
        "stalwart"
    ],
    "strats": [
        "strat"
    ],
    "tycoons": [
        "tycoon"
    ],
    "uniquenesses": [
        "uniqueness"
    ],
    "uproars": [
        "uproar"
    ],
    "utopias": [
        "utopia"
    ],
    "basking": [
        "bask"
    ],
    "basked": [
        "bask"
    ],
    "basks": [
        "bask"
    ],
    "correctives": [
        "corrective"
    ],
    "discontinuities": [
        "discontinuity"
    ],
    "doped": [
        "dope"
    ],
    "dresdens": [
        "dresden"
    ],
    "espionages": [
        "espionage"
    ],
    "exertions": [
        "exertion"
    ],
    "eyesights": [
        "eyesight"
    ],
    "fosterings": [
        "fostering"
    ],
    "infuriated": [
        "infuriate"
    ],
    "infuriates": [
        "infuriate"
    ],
    "infuriating": [
        "infuriate"
    ],
    "lawtons": [
        "lawton"
    ],
    "marmalades": [
        "marmalade"
    ],
    "northwests": [
        "northwest"
    ],
    "paroled": [
        "parole"
    ],
    "peacetimes": [
        "peacetime"
    ],
    "rambles": [
        "ramble"
    ],
    "rambling": [
        "ramble"
    ],
    "rambled": [
        "ramble"
    ],
    "recombinants": [
        "recombinant"
    ],
    "reeves": [
        "reeve"
    ],
    "reeving": [
        "reeve"
    ],
    "reeved": [
        "reeve"
    ],
    "retainers": [
        "retainer"
    ],
    "smashings": [
        "smashing"
    ],
    "snuffed": [
        "snuff"
    ],
    "snuffing": [
        "snuff"
    ],
    "snuffs": [
        "snuff"
    ],
    "tunisias": [
        "tunisia"
    ],
    "vantages": [
        "vantage"
    ],
    "worldlier": [
        "worldly"
    ],
    "apologetics": [
        "apologetic"
    ],
    "arizonas": [
        "arizona"
    ],
    "balfours": [
        "balfour"
    ],
    "blockages": [
        "blockage"
    ],
    "buzzards": [
        "buzzard"
    ],
    "cellos": [
        "cello"
    ],
    "chis": [
        "chi"
    ],
    "depositors": [
        "depositor"
    ],
    "drizzling": [
        "drizzle"
    ],
    "drizzled": [
        "drizzle"
    ],
    "drizzles": [
        "drizzle"
    ],
    "erred": [
        "err"
    ],
    "errs": [
        "err"
    ],
    "erring": [
        "err"
    ],
    "gits": [
        "git"
    ],
    "jutting": [
        "jut"
    ],
    "jutted": [
        "jut"
    ],
    "juts": [
        "jut"
    ],
    "kants": [
        "kant"
    ],
    "mohammads": [
        "mohammad"
    ],
    "pawns": [
        "pawn"
    ],
    "pawned": [
        "pawn"
    ],
    "pawning": [
        "pawn"
    ],
    "renderings": [
        "rendering"
    ],
    "strausses": [
        "strauss"
    ],
    "tadpoles": [
        "tadpole"
    ],
    "abolitionists": [
        "abolitionist"
    ],
    "boreholes": [
        "borehole"
    ],
    "boreholing": [
        "borehole"
    ],
    "crushings": [
        "crushing"
    ],
    "dormitories": [
        "dormitory"
    ],
    "doublings": [
        "doubling"
    ],
    "elucidated": [
        "elucidate"
    ],
    "elucidating": [
        "elucidate"
    ],
    "elucidates": [
        "elucidate"
    ],
    "hawaiians": [
        "hawaiian"
    ],
    "logans": [
        "logan"
    ],
    "medreses": [
        "medrese"
    ],
    "murkiest": [
        "murky"
    ],
    "murkier": [
        "murky"
    ],
    "northeasts": [
        "northeast"
    ],
    "numerics": [
        "numeric"
    ],
    "scapegoats": [
        "scapegoat"
    ],
    "scapegoating": [
        "scapegoat"
    ],
    "scapegoated": [
        "scapegoat"
    ],
    "tenets": [
        "tenet"
    ],
    "vacated": [
        "vacate"
    ],
    "vacating": [
        "vacate"
    ],
    "vacates": [
        "vacate"
    ],
    "zeniths": [
        "zenith"
    ],
    "bereaveds": [
        "bereaved"
    ],
    "christened": [
        "christen"
    ],
    "christening": [
        "christen"
    ],
    "christens": [
        "christen"
    ],
    "custodians": [
        "custodian"
    ],
    "detested": [
        "detest"
    ],
    "detests": [
        "detest"
    ],
    "detesting": [
        "detest"
    ],
    "entireties": [
        "entirety"
    ],
    "felted": [
        "felt"
    ],
    "felts": [
        "felt"
    ],
    "fluffiest": [
        "fluffy"
    ],
    "fluffies": [
        "fluffy"
    ],
    "fluffier": [
        "fluffy"
    ],
    "fullnesses": [
        "fullness"
    ],
    "haziest": [
        "hazy"
    ],
    "hazier": [
        "hazy"
    ],
    "hoarser": [
        "hoarse"
    ],
    "hoarsest": [
        "hoarse"
    ],
    "hobbess": [
        "hobbes"
    ],
    "humbers": [
        "humber"
    ],
    "loudspeakers": [
        "loudspeaker"
    ],
    "loudspeakering": [
        "loudspeaker"
    ],
    "loudspeakered": [
        "loudspeaker"
    ],
    "mayhews": [
        "mayhew"
    ],
    "niggers": [
        "nigger"
    ],
    "politeness": [
        "politenes"
    ],
    "pyreneess": [
        "pyrenees"
    ],
    "salespersons": [
        "salesperson"
    ],
    "salespeople": [
        "salesperson"
    ],
    "secessions": [
        "secession"
    ],
    "straddling": [
        "straddle"
    ],
    "straddled": [
        "straddle"
    ],
    "straddles": [
        "straddle"
    ],
    "swingings": [
        "swinging"
    ],
    "vassals": [
        "vassal"
    ],
    "vicarages": [
        "vicarage"
    ],
    "wafted": [
        "waft"
    ],
    "wafting": [
        "waft"
    ],
    "wafts": [
        "waft"
    ],
    "acceded": [
        "accede"
    ],
    "acceding": [
        "accede"
    ],
    "besieged": [
        "besiege"
    ],
    "besieging": [
        "besiege"
    ],
    "besieges": [
        "besiege"
    ],
    "bewilderments": [
        "bewilderment"
    ],
    "driveways": [
        "driveway"
    ],
    "eigenvalues": [
        "eigenvalue"
    ],
    "eschewed": [
        "eschew"
    ],
    "eschewing": [
        "eschew"
    ],
    "eschews": [
        "eschew"
    ],
    "esquires": [
        "esquire"
    ],
    "flitted": [
        "flit"
    ],
    "flitting": [
        "flit"
    ],
    "flits": [
        "flit"
    ],
    "hoffmen": [
        "hoffman"
    ],
    "hrs": [
        "hr"
    ],
    "liberalizations": [
        "liberalization"
    ],
    "mortuaries": [
        "mortuary"
    ],
    "prostaglandins": [
        "prostaglandin"
    ],
    "salivas": [
        "saliva"
    ],
    "specialties": [
        "specialty"
    ],
    "stiffnesses": [
        "stiffness"
    ],
    "tivolis": [
        "tivoli"
    ],
    "wyes": [
        "wye"
    ],
    "breeches": [
        "breech"
    ],
    "breeched": [
        "breech"
    ],
    "breeching": [
        "breech"
    ],
    "casters": [
        "caster"
    ],
    "catfishes": [
        "catfish"
    ],
    "catfish": [
        "catfish"
    ],
    "defeateds": [
        "defeated"
    ],
    "disillusioned": [
        "disillusion"
    ],
    "disillusioning": [
        "disillusion"
    ],
    "disillusions": [
        "disillusion"
    ],
    "givings": [
        "giving"
    ],
    "graffitiing": [
        "graffiti"
    ],
    "macleods": [
        "macleod"
    ],
    "nationalizations": [
        "nationalization"
    ],
    "patersons": [
        "paterson"
    ],
    "pendulums": [
        "pendulum"
    ],
    "reissued": [
        "reissue"
    ],
    "reissues": [
        "reissue"
    ],
    "reissuing": [
        "reissue"
    ],
    "soliciting": [
        "solicit"
    ],
    "solicited": [
        "solicit"
    ],
    "solicits": [
        "solicit"
    ],
    "subsystems": [
        "subsystem"
    ],
    "tinted": [
        "tint"
    ],
    "tints": [
        "tint"
    ],
    "tinting": [
        "tint"
    ],
    "wovens": [
        "woven"
    ],
    "aborted": [
        "abort"
    ],
    "aborting": [
        "abort"
    ],
    "aborts": [
        "abort"
    ],
    "absentees": [
        "absentee"
    ],
    "aseans": [
        "asean"
    ],
    "botanies": [
        "botany"
    ],
    "brambles": [
        "bramble"
    ],
    "brambling": [
        "bramble"
    ],
    "breakers": [
        "breaker"
    ],
    "configured": [
        "configure"
    ],
    "configuring": [
        "configure"
    ],
    "configures": [
        "configure"
    ],
    "cubicles": [
        "cubicle"
    ],
    "enids": [
        "enid"
    ],
    "foundries": [
        "foundry"
    ],
    "hobbss": [
        "hobbs"
    ],
    "licensees": [
        "licensee"
    ],
    "northumbrians": [
        "northumbrian"
    ],
    "outstripped": [
        "outstrip"
    ],
    "outstripping": [
        "outstrip"
    ],
    "outstrips": [
        "outstrip"
    ],
    "permeabilities": [
        "permeability"
    ],
    "scarcities": [
        "scarcity"
    ],
    "sibs": [
        "sib"
    ],
    "sledges": [
        "sledge"
    ],
    "sledging": [
        "sledge"
    ],
    "sledged": [
        "sledge"
    ],
    "sonics": [
        "sonic"
    ],
    "vying": [
        "vie"
    ],
    "vied": [
        "vie"
    ],
    "briberies": [
        "bribery"
    ],
    "clarets": [
        "claret"
    ],
    "crutches": [
        "crutch"
    ],
    "decreasings": [
        "decreasing"
    ],
    "epochs": [
        "epoch"
    ],
    "exemplars": [
        "exemplar"
    ],
    "footages": [
        "footage"
    ],
    "frontages": [
        "frontage"
    ],
    "jeffersons": [
        "jefferson"
    ],
    "lfas": [
        "lfa"
    ],
    "monoclonals": [
        "monoclonal"
    ],
    "remorses": [
        "remorse"
    ],
    "retraced": [
        "retrace"
    ],
    "retracing": [
        "retrace"
    ],
    "retraces": [
        "retrace"
    ],
    "showdowns": [
        "showdown"
    ],
    "slovakias": [
        "slovakia"
    ],
    "standardised": [
        "standardise"
    ],
    "standardising": [
        "standardise"
    ],
    "superstores": [
        "superstore"
    ],
    "thatcherites": [
        "thatcherite"
    ],
    "abbreviations": [
        "abbreviation"
    ],
    "brackens": [
        "bracken"
    ],
    "brackened": [
        "bracken"
    ],
    "collated": [
        "collate"
    ],
    "collating": [
        "collate"
    ],
    "collates": [
        "collate"
    ],
    "condensed": [
        "condense"
    ],
    "condensing": [
        "condense"
    ],
    "conurbations": [
        "conurbation"
    ],
    "depictions": [
        "depiction"
    ],
    "distillers": [
        "distiller"
    ],
    "duffed": [
        "duff"
    ],
    "duffs": [
        "duff"
    ],
    "duffing": [
        "duff"
    ],
    "fallacies": [
        "fallacy"
    ],
    "geriatrics": [
        "geriatric"
    ],
    "inconclusives": [
        "inconclusive"
    ],
    "interplays": [
        "interplay"
    ],
    "leningrads": [
        "leningrad"
    ],
    "louvres": [
        "louvre"
    ],
    "molluscs": [
        "mollusc"
    ],
    "mourners": [
        "mourner"
    ],
    "newborns": [
        "newborn"
    ],
    "nocturnals": [
        "nocturnal"
    ],
    "priesthoods": [
        "priesthood"
    ],
    "ratepayers": [
        "ratepayer"
    ],
    "retaliated": [
        "retaliate"
    ],
    "retaliating": [
        "retaliate"
    ],
    "retaliates": [
        "retaliate"
    ],
    "saharas": [
        "sahara"
    ],
    "scariest": [
        "scary"
    ],
    "scarier": [
        "scary"
    ],
    "spiritualities": [
        "spirituality"
    ],
    "suffixed": [
        "suffix"
    ],
    "supt.": [
        "supt"
    ],
    "topographies": [
        "topography"
    ],
    "adjournments": [
        "adjournment"
    ],
    "bavarias": [
        "bavaria"
    ],
    "buggies": [
        "buggy"
    ],
    "burners": [
        "burner"
    ],
    "cedars": [
        "cedar"
    ],
    "gaped": [
        "gape"
    ],
    "gapes": [
        "gape"
    ],
    "gaping": [
        "gape"
    ],
    "helplessnesses": [
        "helplessness"
    ],
    "immersions": [
        "immersion"
    ],
    "leavings": [
        "leaving"
    ],
    "lizzies": [
        "lizzy"
    ],
    "metropolises": [
        "metropolis"
    ],
    "navigating": [
        "navigate"
    ],
    "navigated": [
        "navigate"
    ],
    "navigates": [
        "navigate"
    ],
    "orphanages": [
        "orphanage"
    ],
    "policewomen": [
        "policewoman"
    ],
    "queenslands": [
        "queensland"
    ],
    "rationings": [
        "rationing"
    ],
    "seaweeds": [
        "seaweed"
    ],
    "slurred": [
        "slur"
    ],
    "slurs": [
        "slur"
    ],
    "slurring": [
        "slur"
    ],
    "sunglasses": [
        "sunglass"
    ],
    "superegos": [
        "superego"
    ],
    "birdies": [
        "birdy"
    ],
    "birdied": [
        "birdy"
    ],
    "brayed": [
        "bray"
    ],
    "braying": [
        "bray"
    ],
    "brays": [
        "bray"
    ],
    "charismata": [
        "charisma"
    ],
    "chums": [
        "chum"
    ],
    "chummed": [
        "chum"
    ],
    "chumming": [
        "chum"
    ],
    "d.c.s": [
        "d.c."
    ],
    "dottier": [
        "dotty"
    ],
    "dottiest": [
        "dotty"
    ],
    "extremities": [
        "extremity"
    ],
    "fannies": [
        "fanny"
    ],
    "flues": [
        "flue"
    ],
    "flueing": [
        "flue"
    ],
    "footwears": [
        "footwear"
    ],
    "hoves": [
        "hove"
    ],
    "hoving": [
        "hove"
    ],
    "incinerators": [
        "incinerator"
    ],
    "peed": [
        "pee"
    ],
    "peeing": [
        "pee"
    ],
    "pees": [
        "pee"
    ],
    "provenanced": [
        "provenance"
    ],
    "provenancing": [
        "provenance"
    ],
    "robbinss": [
        "robbins"
    ],
    "anatomicals": [
        "anatomical"
    ],
    "ancestries": [
        "ancestry"
    ],
    "anorexics": [
        "anorexic"
    ],
    "beverages": [
        "beverage"
    ],
    "classifieds": [
        "classified"
    ],
    "deceits": [
        "deceit"
    ],
    "drownings": [
        "drowning"
    ],
    "guarantors": [
        "guarantor"
    ],
    "haitis": [
        "haiti"
    ],
    "hardings": [
        "harding"
    ],
    "hustled": [
        "hustle"
    ],
    "hustling": [
        "hustle"
    ],
    "hustles": [
        "hustle"
    ],
    "impressionists": [
        "impressionist"
    ],
    "malas": [
        "mala"
    ],
    "militancies": [
        "militancy"
    ],
    "naomis": [
        "naomi"
    ],
    "noblemen": [
        "nobleman"
    ],
    "orthopaedics": [
        "orthopaedic"
    ],
    "reflectances": [
        "reflectance"
    ],
    "restated": [
        "restate"
    ],
    "restating": [
        "restate"
    ],
    "restates": [
        "restate"
    ],
    "sulking": [
        "sulk"
    ],
    "sulked": [
        "sulk"
    ],
    "sulks": [
        "sulk"
    ],
    "tainted": [
        "taint"
    ],
    "taints": [
        "taint"
    ],
    "tainting": [
        "taint"
    ],
    "tampered": [
        "tamper"
    ],
    "tampering": [
        "tamper"
    ],
    "tampers": [
        "tamper"
    ],
    "thatcherisms": [
        "thatcherism"
    ],
    "trademarks": [
        "trademark"
    ],
    "trademarking": [
        "trademark"
    ],
    "turrets": [
        "turret"
    ],
    "undercutting": [
        "undercut"
    ],
    "undercuts": [
        "undercut"
    ],
    "whooping": [
        "whoop"
    ],
    "whoops": [
        "whoop"
    ],
    "whooped": [
        "whoop"
    ],
    "whooper": [
        "whoop"
    ],
    "worshippers": [
        "worshipper"
    ],
    "yales": [
        "yale"
    ],
    "arabians": [
        "arabian"
    ],
    "armouries": [
        "armoury"
    ],
    "breakages": [
        "breakage"
    ],
    "congoes": [
        "congo"
    ],
    "cypresses": [
        "cypress"
    ],
    "dogmatics": [
        "dogmatic"
    ],
    "drillings": [
        "drilling"
    ],
    "embroidered": [
        "embroider"
    ],
    "embroidering": [
        "embroider"
    ],
    "embroiders": [
        "embroider"
    ],
    "encores": [
        "encore"
    ],
    "encored": [
        "encore"
    ],
    "encoring": [
        "encore"
    ],
    "expounded": [
        "expound"
    ],
    "expounding": [
        "expound"
    ],
    "expounds": [
        "expound"
    ],
    "fellers": [
        "feller"
    ],
    "firs": [
        "fir"
    ],
    "hawthorns": [
        "hawthorn"
    ],
    "iagoes": [
        "iago"
    ],
    "issuers": [
        "issuer"
    ],
    "lifelines": [
        "lifeline"
    ],
    "mammoths": [
        "mammoth"
    ],
    "parsing": [
        "parse"
    ],
    "parses": [
        "parse"
    ],
    "parsed": [
        "parse"
    ],
    "passageways": [
        "passageway"
    ],
    "psychotics": [
        "psychotic"
    ],
    "resiliences": [
        "resilience"
    ],
    "resurrected": [
        "resurrect"
    ],
    "resurrecting": [
        "resurrect"
    ],
    "resurrects": [
        "resurrect"
    ],
    "scorched": [
        "scorch"
    ],
    "scorching": [
        "scorch"
    ],
    "scorches": [
        "scorch"
    ],
    "secondments": [
        "secondment"
    ],
    "transversed": [
        "transverse"
    ],
    "verities": [
        "verity"
    ],
    "angleseys": [
        "anglesey"
    ],
    "cfs": [
        "cf"
    ],
    "eccentricities": [
        "eccentricity"
    ],
    "farts": [
        "fart"
    ],
    "farting": [
        "fart"
    ],
    "farted": [
        "fart"
    ],
    "flankers": [
        "flanker"
    ],
    "funnelled": [
        "funnel"
    ],
    "funnels": [
        "funnel"
    ],
    "funnelling": [
        "funnel"
    ],
    "hernias": [
        "hernia"
    ],
    "huskier": [
        "husky"
    ],
    "huskiest": [
        "husky"
    ],
    "iggs": [
        "igg"
    ],
    "lousier": [
        "lousy"
    ],
    "lousiest": [
        "lousy"
    ],
    "mongolias": [
        "mongolia"
    ],
    "mucuss": [
        "mucus"
    ],
    "protruding": [
        "protrude"
    ],
    "protruded": [
        "protrude"
    ],
    "protrudes": [
        "protrude"
    ],
    "quacks": [
        "quack"
    ],
    "quacking": [
        "quack"
    ],
    "quacked": [
        "quack"
    ],
    "roofings": [
        "roofing"
    ],
    "skirmishes": [
        "skirmish"
    ],
    "skirmishing": [
        "skirmish"
    ],
    "skirmished": [
        "skirmish"
    ],
    "smokies": [
        "smoky"
    ],
    "smokier": [
        "smoky"
    ],
    "smokiest": [
        "smoky"
    ],
    "spouting": [
        "spout"
    ],
    "spouts": [
        "spout"
    ],
    "spouted": [
        "spout"
    ],
    "thrifts": [
        "thrift"
    ],
    "vibes": [
        "vibe"
    ],
    "vibing": [
        "vibe"
    ],
    "vibed": [
        "vibe"
    ],
    "appropriatenesses": [
        "appropriateness"
    ],
    "baptized": [
        "baptize"
    ],
    "baptizing": [
        "baptize"
    ],
    "baptizes": [
        "baptize"
    ],
    "convections": [
        "convection"
    ],
    "duets": [
        "duet"
    ],
    "duetting": [
        "duet"
    ],
    "duetted": [
        "duet"
    ],
    "exhibitors": [
        "exhibitor"
    ],
    "fillets": [
        "fillet"
    ],
    "filleting": [
        "fillet"
    ],
    "filleted": [
        "fillet"
    ],
    "garnered": [
        "garner"
    ],
    "garnering": [
        "garner"
    ],
    "garners": [
        "garner"
    ],
    "infrareds": [
        "infrared"
    ],
    "insolvents": [
        "insolvent"
    ],
    "leaseholds": [
        "leasehold"
    ],
    "leaseholding": [
        "leasehold"
    ],
    "lessees": [
        "lessee"
    ],
    "macarthurs": [
        "macarthur"
    ],
    "menopauses": [
        "menopause"
    ],
    "peculiarities": [
        "peculiarity"
    ],
    "plodding": [
        "plod"
    ],
    "plodded": [
        "plod"
    ],
    "plods": [
        "plod"
    ],
    "pragmatisms": [
        "pragmatism"
    ],
    "stammered": [
        "stammer"
    ],
    "stammering": [
        "stammer"
    ],
    "stammers": [
        "stammer"
    ],
    "stockmarkets": [
        "stockmarket"
    ],
    "uncanniest": [
        "uncanny"
    ],
    "uncannier": [
        "uncanny"
    ],
    "valuers": [
        "valuer"
    ],
    "aerobicss": [
        "aerobics"
    ],
    "affronted": [
        "affront"
    ],
    "affronting": [
        "affront"
    ],
    "brittens": [
        "britten"
    ],
    "easels": [
        "easel"
    ],
    "engravings": [
        "engraving"
    ],
    "inorganics": [
        "inorganic"
    ],
    "keels": [
        "keel"
    ],
    "keeled": [
        "keel"
    ],
    "keeling": [
        "keel"
    ],
    "liberalisations": [
        "liberalisation"
    ],
    "manics": [
        "manic"
    ],
    "o'haras": [
        "o'hara"
    ],
    "piggies": [
        "piggy"
    ],
    "quelled": [
        "quell"
    ],
    "quelling": [
        "quell"
    ],
    "quells": [
        "quell"
    ],
    "reformings": [
        "reforming"
    ],
    "reliving": [
        "relive"
    ],
    "relived": [
        "relive"
    ],
    "relives": [
        "relive"
    ],
    "roarings": [
        "roaring"
    ],
    "sheened": [
        "sheen"
    ],
    "sheens": [
        "sheen"
    ],
    "sheening": [
        "sheen"
    ],
    "sludges": [
        "sludge"
    ],
    "sludging": [
        "sludge"
    ],
    "sludged": [
        "sludge"
    ],
    "stanfords": [
        "stanford"
    ],
    "utopians": [
        "utopian"
    ],
    "woodwards": [
        "woodward"
    ],
    "airliners": [
        "airliner"
    ],
    "albumins": [
        "albumin"
    ],
    "axles": [
        "axle"
    ],
    "axled": [
        "axle"
    ],
    "bohemians": [
        "bohemian"
    ],
    "botswanas": [
        "botswana"
    ],
    "buddings": [
        "budding"
    ],
    "clubhouses": [
        "clubhouse"
    ],
    "dialectics": [
        "dialectic"
    ],
    "dismounted": [
        "dismount"
    ],
    "dismounting": [
        "dismount"
    ],
    "dismounts": [
        "dismount"
    ],
    "disobediences": [
        "disobedience"
    ],
    "dunging": [
        "dung"
    ],
    "dungs": [
        "dung"
    ],
    "dunged": [
        "dung"
    ],
    "fathoms": [
        "fathom"
    ],
    "fathoming": [
        "fathom"
    ],
    "fathomed": [
        "fathom"
    ],
    "flemishes": [
        "flemish"
    ],
    "gesners": [
        "gesner"
    ],
    "heparins": [
        "heparin"
    ],
    "individualists": [
        "individualist"
    ],
    "motherwells": [
        "motherwell"
    ],
    "negated": [
        "negate"
    ],
    "negates": [
        "negate"
    ],
    "negating": [
        "negate"
    ],
    "porosities": [
        "porosity"
    ],
    "prowling": [
        "prowl"
    ],
    "prowled": [
        "prowl"
    ],
    "prowls": [
        "prowl"
    ],
    "sickliest": [
        "sickly"
    ],
    "sicklier": [
        "sickly"
    ],
    "sicklied": [
        "sickly"
    ],
    "welshmen": [
        "welshman"
    ],
    "accomplishments": [
        "accomplishment"
    ],
    "assailants": [
        "assailant"
    ],
    "capillaries": [
        "capillary"
    ],
    "commandments": [
        "commandment"
    ],
    "esoterics": [
        "esoteric"
    ],
    "ganglia": [
        "ganglion"
    ],
    "holidaymakers": [
        "holidaymaker"
    ],
    "jotted": [
        "jot"
    ],
    "jotting": [
        "jot"
    ],
    "jots": [
        "jot"
    ],
    "loopholes": [
        "loophole"
    ],
    "loopholed": [
        "loophole"
    ],
    "muirs": [
        "muir"
    ],
    "orgasms": [
        "orgasm"
    ],
    "orgasmed": [
        "orgasm"
    ],
    "paupers": [
        "pauper"
    ],
    "paupered": [
        "pauper"
    ],
    "permissives": [
        "permissive"
    ],
    "pretexts": [
        "pretext"
    ],
    "pursuers": [
        "pursuer"
    ],
    "synapsing": [
        "synapse"
    ],
    "versailless": [
        "versailles"
    ],
    "allayed": [
        "allay"
    ],
    "allaying": [
        "allay"
    ],
    "allays": [
        "allay"
    ],
    "badmintons": [
        "badminton"
    ],
    "brunts": [
        "brunt"
    ],
    "circumvented": [
        "circumvent"
    ],
    "circumventing": [
        "circumvent"
    ],
    "circumvents": [
        "circumvent"
    ],
    "coastguards": [
        "coastguard"
    ],
    "collaterals": [
        "collateral"
    ],
    "cranks": [
        "crank"
    ],
    "cranked": [
        "crank"
    ],
    "cranking": [
        "crank"
    ],
    "cubists": [
        "cubist"
    ],
    "embodiments": [
        "embodiment"
    ],
    "emptyings": [
        "emptying"
    ],
    "flamings": [
        "flaming"
    ],
    "horrids": [
        "horrid"
    ],
    "interdependences": [
        "interdependence"
    ],
    "poachers": [
        "poacher"
    ],
    "rescheduling": [
        "reschedule"
    ],
    "rescheduled": [
        "reschedule"
    ],
    "reschedules": [
        "reschedule"
    ],
    "royalists": [
        "royalist"
    ],
    "samaritans": [
        "samaritan"
    ],
    "slovenes": [
        "slovene"
    ],
    "squirmed": [
        "squirm"
    ],
    "squirming": [
        "squirm"
    ],
    "squirms": [
        "squirm"
    ],
    "trolling": [
        "troll"
    ],
    "trolled": [
        "troll"
    ],
    "aboriginals": [
        "aboriginal"
    ],
    "andess": [
        "andes"
    ],
    "basalts": [
        "basalt"
    ],
    "drooped": [
        "droop"
    ],
    "drooping": [
        "droop"
    ],
    "droops": [
        "droop"
    ],
    "frosties": [
        "frosty"
    ],
    "frostier": [
        "frosty"
    ],
    "frostiest": [
        "frosty"
    ],
    "goggles": [
        "goggle"
    ],
    "goggled": [
        "goggle"
    ],
    "goggling": [
        "goggle"
    ],
    "hesses": [
        "hess"
    ],
    "knacks": [
        "knack"
    ],
    "knacked": [
        "knack"
    ],
    "monacoes": [
        "monaco"
    ],
    "napes": [
        "nape"
    ],
    "protestors": [
        "protestor"
    ],
    "regenerating": [
        "regenerate"
    ],
    "regenerated": [
        "regenerate"
    ],
    "regenerates": [
        "regenerate"
    ],
    "rescuers": [
        "rescuer"
    ],
    "ribbers": [
        "ribber"
    ],
    "sackings": [
        "sacking"
    ],
    "tbs": [
        "tb"
    ],
    "tropicss": [
        "tropics"
    ],
    "trussed": [
        "truss"
    ],
    "trusses": [
        "truss"
    ],
    "trussing": [
        "truss"
    ],
    "yeatss": [
        "yeats"
    ],
    "adas": [
        "ada"
    ],
    "backlogs": [
        "backlog"
    ],
    "backlogged": [
        "backlog"
    ],
    "blurted": [
        "blurt"
    ],
    "blurting": [
        "blurt"
    ],
    "blurts": [
        "blurt"
    ],
    "cynthias": [
        "cynthia"
    ],
    "eagernesses": [
        "eagerness"
    ],
    "hardbacks": [
        "hardback"
    ],
    "hardbacked": [
        "hardback"
    ],
    "heliums": [
        "helium"
    ],
    "helixes": [
        "helix"
    ],
    "leones": [
        "leone"
    ],
    "lings": [
        "ling"
    ],
    "loused": [
        "louse"
    ],
    "lousing": [
        "louse"
    ],
    "louses": [
        "louse"
    ],
    "mercians": [
        "mercian"
    ],
    "obesities": [
        "obesity"
    ],
    "pes": [
        "pe"
    ],
    "pouting": [
        "pout"
    ],
    "pouted": [
        "pout"
    ],
    "pouts": [
        "pout"
    ],
    "racers": [
        "racer"
    ],
    "scatterings": [
        "scattering"
    ],
    "sharewares": [
        "shareware"
    ],
    "utahs": [
        "utah"
    ],
    "bequeathed": [
        "bequeath"
    ],
    "bequeaths": [
        "bequeath"
    ],
    "bequeathing": [
        "bequeath"
    ],
    "chads": [
        "chad"
    ],
    "chaucers": [
        "chaucer"
    ],
    "chillis": [
        "chilli"
    ],
    "citadels": [
        "citadel"
    ],
    "coldnesses": [
        "coldness"
    ],
    "columnists": [
        "columnist"
    ],
    "deictics": [
        "deictic"
    ],
    "dyers": [
        "dyer"
    ],
    "flogging": [
        "flog"
    ],
    "flogged": [
        "flog"
    ],
    "flogs": [
        "flog"
    ],
    "godfathers": [
        "godfather"
    ],
    "juntas": [
        "junta"
    ],
    "kenyans": [
        "kenyan"
    ],
    "lowells": [
        "lowell"
    ],
    "oddities": [
        "oddity"
    ],
    "pragmaticss": [
        "pragmatics"
    ],
    "psychiatries": [
        "psychiatry"
    ],
    "santiagoes": [
        "santiago"
    ],
    "terracottas": [
        "terracotta"
    ],
    "underworlds": [
        "underworld"
    ],
    "vortices": [
        "vortex"
    ],
    "vortexing": [
        "vortex"
    ],
    "vortexes": [
        "vortex"
    ],
    "vortexed": [
        "vortex"
    ],
    "yogas": [
        "yoga"
    ],
    "abated": [
        "abate"
    ],
    "abating": [
        "abate"
    ],
    "abates": [
        "abate"
    ],
    "adelaides": [
        "adelaide"
    ],
    "antwerps": [
        "antwerp"
    ],
    "bartering": [
        "barter"
    ],
    "bartered": [
        "barter"
    ],
    "barters": [
        "barter"
    ],
    "dostoevskies": [
        "dostoevsky"
    ],
    "foddering": [
        "fodder"
    ],
    "fodders": [
        "fodder"
    ],
    "foddered": [
        "fodder"
    ],
    "frigates": [
        "frigate"
    ],
    "heifers": [
        "heifer"
    ],
    "invalidated": [
        "invalidate"
    ],
    "invalidates": [
        "invalidate"
    ],
    "invalidating": [
        "invalidate"
    ],
    "knitteds": [
        "knitted"
    ],
    "laoss": [
        "laos"
    ],
    "lemonades": [
        "lemonade"
    ],
    "livingstons": [
        "livingston"
    ],
    "morays": [
        "moray"
    ],
    "mountaineerings": [
        "mountaineering"
    ],
    "showcases": [
        "showcase"
    ],
    "showcasing": [
        "showcase"
    ],
    "showcased": [
        "showcase"
    ],
    "sideboards": [
        "sideboard"
    ],
    "spaceships": [
        "spaceship"
    ],
    "tawnies": [
        "tawny"
    ],
    "tawnier": [
        "tawny"
    ],
    "tawniest": [
        "tawny"
    ],
    "terns": [
        "tern"
    ],
    "titfords": [
        "titford"
    ],
    "barbs": [
        "barb"
    ],
    "bookcases": [
        "bookcase"
    ],
    "chroniclers": [
        "chronicler"
    ],
    "collaged": [
        "collage"
    ],
    "cruxes": [
        "crux"
    ],
    "gushing": [
        "gush"
    ],
    "gushed": [
        "gush"
    ],
    "gushes": [
        "gush"
    ],
    "headhunters": [
        "headhunter"
    ],
    "homologies": [
        "homology"
    ],
    "hotlines": [
        "hotline"
    ],
    "hyacinths": [
        "hyacinth"
    ],
    "insanities": [
        "insanity"
    ],
    "mias": [
        "mia"
    ],
    "michigans": [
        "michigan"
    ],
    "orchestrated": [
        "orchestrate"
    ],
    "orchestrating": [
        "orchestrate"
    ],
    "orchestrates": [
        "orchestrate"
    ],
    "pageants": [
        "pageant"
    ],
    "pancaked": [
        "pancake"
    ],
    "patchworks": [
        "patchwork"
    ],
    "pedestals": [
        "pedestal"
    ],
    "recollected": [
        "recollect"
    ],
    "recollects": [
        "recollect"
    ],
    "recollecting": [
        "recollect"
    ],
    "roosting": [
        "roost"
    ],
    "roosts": [
        "roost"
    ],
    "roosted": [
        "roost"
    ],
    "shallots": [
        "shallot"
    ],
    "slanging": [
        "slang"
    ],
    "slangs": [
        "slang"
    ],
    "slanged": [
        "slang"
    ],
    "soundtracks": [
        "soundtrack"
    ],
    "soundtracking": [
        "soundtrack"
    ],
    "spicier": [
        "spicy"
    ],
    "spiciest": [
        "spicy"
    ],
    "trances": [
        "trance"
    ],
    "tranced": [
        "trance"
    ],
    "algierss": [
        "algiers"
    ],
    "analysers": [
        "analyser"
    ],
    "bridesmaids": [
        "bridesmaid"
    ],
    "charred": [
        "char"
    ],
    "charring": [
        "char"
    ],
    "deas": [
        "dea"
    ],
    "drummonds": [
        "drummond"
    ],
    "johnss": [
        "johns"
    ],
    "limelights": [
        "limelight"
    ],
    "moguls": [
        "mogul"
    ],
    "opiums": [
        "opium"
    ],
    "penicillins": [
        "penicillin"
    ],
    "pepsinogens": [
        "pepsinogen"
    ],
    "precepts": [
        "precept"
    ],
    "precepting": [
        "precept"
    ],
    "precepted": [
        "precept"
    ],
    "reassessed": [
        "reassess"
    ],
    "reassessing": [
        "reassess"
    ],
    "reassesses": [
        "reassess"
    ],
    "revulsions": [
        "revulsion"
    ],
    "roadshows": [
        "roadshow"
    ],
    "saddened": [
        "sadden"
    ],
    "saddens": [
        "sadden"
    ],
    "saddening": [
        "sadden"
    ],
    "smugglings": [
        "smuggling"
    ],
    "snowiest": [
        "snowy"
    ],
    "snowys": [
        "snowy"
    ],
    "snowier": [
        "snowy"
    ],
    "subcommittees": [
        "subcommittee"
    ],
    "toothpastes": [
        "toothpaste"
    ],
    "urns": [
        "urn"
    ],
    "wheezing": [
        "wheeze"
    ],
    "wheezed": [
        "wheeze"
    ],
    "wheezes": [
        "wheeze"
    ],
    "alexandrias": [
        "alexandria"
    ],
    "apps": [
        "app"
    ],
    "ascendings": [
        "ascending"
    ],
    "balmorals": [
        "balmoral"
    ],
    "barries": [
        "barrie"
    ],
    "bohemias": [
        "bohemia"
    ],
    "bowies": [
        "bowie"
    ],
    "ferocities": [
        "ferocity"
    ],
    "hermen": [
        "herman"
    ],
    "idas": [
        "ida"
    ],
    "leafier": [
        "leafy"
    ],
    "mobilizations": [
        "mobilization"
    ],
    "ochs": [
        "och"
    ],
    "overcrowding": [
        "overcrowd"
    ],
    "overcrowds": [
        "overcrowd"
    ],
    "overcrowded": [
        "overcrowd"
    ],
    "payouts": [
        "payout"
    ],
    "persecuted": [
        "persecute"
    ],
    "persecuting": [
        "persecute"
    ],
    "revaluations": [
        "revaluation"
    ],
    "saracens": [
        "saracen"
    ],
    "sired": [
        "sire"
    ],
    "siring": [
        "sire"
    ],
    "smirked": [
        "smirk"
    ],
    "smirking": [
        "smirk"
    ],
    "smirks": [
        "smirk"
    ],
    "subsidized": [
        "subsidize"
    ],
    "subsidizing": [
        "subsidize"
    ],
    "subsidizes": [
        "subsidize"
    ],
    "tanneds": [
        "tanned"
    ],
    "wilkinss": [
        "wilkins"
    ],
    "abducted": [
        "abduct"
    ],
    "abducting": [
        "abduct"
    ],
    "abducts": [
        "abduct"
    ],
    "blackberries": [
        "blackberry"
    ],
    "blackberrying": [
        "blackberry"
    ],
    "canberras": [
        "canberra"
    ],
    "dissuaded": [
        "dissuade"
    ],
    "dissuading": [
        "dissuade"
    ],
    "evangelists": [
        "evangelist"
    ],
    "flashings": [
        "flashing"
    ],
    "hamstrings": [
        "hamstring"
    ],
    "hamstringing": [
        "hamstring"
    ],
    "hamstrung": [
        "hamstring"
    ],
    "handels": [
        "handel"
    ],
    "handlers": [
        "handler"
    ],
    "handshakes": [
        "handshake"
    ],
    "hansards": [
        "hansard"
    ],
    "hecks": [
        "heck"
    ],
    "hicks": [
        "hick"
    ],
    "hondurass": [
        "honduras"
    ],
    "inevitabilities": [
        "inevitability"
    ],
    "inroads": [
        "inroad"
    ],
    "knowings": [
        "knowing"
    ],
    "lithospheres": [
        "lithosphere"
    ],
    "nesses": [
        "ness"
    ],
    "o.k.s": [
        "o.k."
    ],
    "parliamentarians": [
        "parliamentarian"
    ],
    "physiotherapies": [
        "physiotherapy"
    ],
    "proliferated": [
        "proliferate"
    ],
    "proliferating": [
        "proliferate"
    ],
    "proliferates": [
        "proliferate"
    ],
    "stoppages": [
        "stoppage"
    ],
    "subsumed": [
        "subsume"
    ],
    "subsumes": [
        "subsume"
    ],
    "subsuming": [
        "subsume"
    ],
    "trailings": [
        "trailing"
    ],
    "wallies": [
        "wally"
    ],
    "wastages": [
        "wastage"
    ],
    "weightier": [
        "weighty"
    ],
    "weightiest": [
        "weighty"
    ],
    "whiffs": [
        "whiff"
    ],
    "whiffed": [
        "whiff"
    ],
    "amphibians": [
        "amphibian"
    ],
    "applicabilities": [
        "applicability"
    ],
    "brawls": [
        "brawl"
    ],
    "brawling": [
        "brawl"
    ],
    "brawled": [
        "brawl"
    ],
    "clints": [
        "clint"
    ],
    "cornerstones": [
        "cornerstone"
    ],
    "disillusionments": [
        "disillusionment"
    ],
    "dissected": [
        "dissect"
    ],
    "dissecting": [
        "dissect"
    ],
    "dissects": [
        "dissect"
    ],
    "eurobonds": [
        "eurobond"
    ],
    "fortified": [
        "fortify"
    ],
    "fortifying": [
        "fortify"
    ],
    "gorillas": [
        "gorilla"
    ],
    "knossoss": [
        "knossos"
    ],
    "milnes": [
        "milne"
    ],
    "moratoriums": [
        "moratorium"
    ],
    "optimised": [
        "optimise"
    ],
    "optimising": [
        "optimise"
    ],
    "optimises": [
        "optimise"
    ],
    "orlandoes": [
        "orlando"
    ],
    "proletarians": [
        "proletarian"
    ],
    "radiotherapies": [
        "radiotherapy"
    ],
    "receiverships": [
        "receivership"
    ],
    "rutherfords": [
        "rutherford"
    ],
    "sonnies": [
        "sonny"
    ],
    "spinnings": [
        "spinning"
    ],
    "stockists": [
        "stockist"
    ],
    "toolkits": [
        "toolkit"
    ],
    "wrappings": [
        "wrapping"
    ],
    "yolks": [
        "yolk"
    ],
    "yolked": [
        "yolk"
    ],
    "alzheimers": [
        "alzheimer"
    ],
    "basketballs": [
        "basketball"
    ],
    "blything": [
        "blyth"
    ],
    "cinderellas": [
        "cinderella"
    ],
    "colombians": [
        "colombian"
    ],
    "condoned": [
        "condone"
    ],
    "condones": [
        "condone"
    ],
    "condoning": [
        "condone"
    ],
    "diggers": [
        "digger"
    ],
    "dryers": [
        "dryer"
    ],
    "enchantments": [
        "enchantment"
    ],
    "epilepsies": [
        "epilepsy"
    ],
    "friendlinesses": [
        "friendliness"
    ],
    "gallups": [
        "gallup"
    ],
    "hancocks": [
        "hancock"
    ],
    "heinrichs": [
        "heinrich"
    ],
    "hendrixes": [
        "hendrix"
    ],
    "incisors": [
        "incisor"
    ],
    "macaulays": [
        "macaulay"
    ],
    "masterminded": [
        "mastermind"
    ],
    "masterminding": [
        "mastermind"
    ],
    "masterminds": [
        "mastermind"
    ],
    "megas": [
        "mega"
    ],
    "milkmen": [
        "milkman"
    ],
    "pathfinders": [
        "pathfinder"
    ],
    "providences": [
        "providence"
    ],
    "spanners": [
        "spanner"
    ],
    "suffocated": [
        "suffocate"
    ],
    "suffocating": [
        "suffocate"
    ],
    "suffocates": [
        "suffocate"
    ],
    "sweatier": [
        "sweaty"
    ],
    "sweatiest": [
        "sweaty"
    ],
    "tewkesburies": [
        "tewkesbury"
    ],
    "wickers": [
        "wicker"
    ],
    "atheists": [
        "atheist"
    ],
    "blackouts": [
        "blackout"
    ],
    "clots": [
        "clot"
    ],
    "clotting": [
        "clot"
    ],
    "clotted": [
        "clot"
    ],
    "conscripts": [
        "conscript"
    ],
    "conscripted": [
        "conscript"
    ],
    "conscripting": [
        "conscript"
    ],
    "encyclopaedias": [
        "encyclopaedia"
    ],
    "entrenched": [
        "entrench"
    ],
    "entrenching": [
        "entrench"
    ],
    "entrenches": [
        "entrench"
    ],
    "fishkeepers": [
        "fishkeeper"
    ],
    "frazers": [
        "frazer"
    ],
    "guildhalls": [
        "guildhall"
    ],
    "heiresses": [
        "heiress"
    ],
    "homoeopathies": [
        "homoeopathy"
    ],
    "masquerading": [
        "masquerade"
    ],
    "masquerades": [
        "masquerade"
    ],
    "masqueraded": [
        "masquerade"
    ],
    "narcotics": [
        "narcotic"
    ],
    "opioids": [
        "opioid"
    ],
    "paranoias": [
        "paranoia"
    ],
    "perpendiculars": [
        "perpendicular"
    ],
    "powyss": [
        "powys"
    ],
    "punts": [
        "punt"
    ],
    "punting": [
        "punt"
    ],
    "punted": [
        "punt"
    ],
    "reckonings": [
        "reckoning"
    ],
    "sloppier": [
        "sloppy"
    ],
    "sloppiest": [
        "sloppy"
    ],
    "sps": [
        "sp"
    ],
    "squirted": [
        "squirt"
    ],
    "squirts": [
        "squirt"
    ],
    "squirting": [
        "squirt"
    ],
    "tristans": [
        "tristan"
    ],
    "warlords": [
        "warlord"
    ],
    "wicks": [
        "wick"
    ],
    "affluences": [
        "affluence"
    ],
    "blazered": [
        "blazer"
    ],
    "crps": [
        "crp"
    ],
    "decentralisations": [
        "decentralisation"
    ],
    "equators": [
        "equator"
    ],
    "lookings": [
        "looking"
    ],
    "normas": [
        "norma"
    ],
    "overpowered": [
        "overpower"
    ],
    "overpowering": [
        "overpower"
    ],
    "overpowers": [
        "overpower"
    ],
    "pascals": [
        "pascal"
    ],
    "patriarchs": [
        "patriarch"
    ],
    "pharmacists": [
        "pharmacist"
    ],
    "playhouses": [
        "playhouse"
    ],
    "polarizations": [
        "polarization"
    ],
    "repressed": [
        "repress"
    ],
    "repressing": [
        "repress"
    ],
    "represses": [
        "repress"
    ],
    "resales": [
        "resale"
    ],
    "rpms": [
        "rpm"
    ],
    "sashes": [
        "sash"
    ],
    "seattles": [
        "seattle"
    ],
    "tellers": [
        "teller"
    ],
    "undecideds": [
        "undecided"
    ],
    "vips": [
        "vip"
    ],
    "accustomed": [
        "accustom"
    ],
    "accustoms": [
        "accustom"
    ],
    "accustoming": [
        "accustom"
    ],
    "ariels": [
        "ariel"
    ],
    "consequentials": [
        "consequential"
    ],
    "crowes": [
        "crowe"
    ],
    "doorbells": [
        "doorbell"
    ],
    "dragoons": [
        "dragoon"
    ],
    "dragooned": [
        "dragoon"
    ],
    "dragooning": [
        "dragoon"
    ],
    "edibles": [
        "edible"
    ],
    "epas": [
        "epa"
    ],
    "fillies": [
        "filly"
    ],
    "floorings": [
        "flooring"
    ],
    "flouted": [
        "flout"
    ],
    "flouting": [
        "flout"
    ],
    "flouts": [
        "flout"
    ],
    "goldmen": [
        "goldman"
    ],
    "ligands": [
        "ligand"
    ],
    "lowerings": [
        "lowering"
    ],
    "penns": [
        "penn"
    ],
    "proprieties": [
        "propriety"
    ],
    "purists": [
        "purist"
    ],
    "realignments": [
        "realignment"
    ],
    "resections": [
        "resection"
    ],
    "resistors": [
        "resistor"
    ],
    "semblances": [
        "semblance"
    ],
    "specs": [
        "spec"
    ],
    "toshibas": [
        "toshiba"
    ],
    "tributaries": [
        "tributary"
    ],
    "viaducts": [
        "viaduct"
    ],
    "animated": [
        "animate"
    ],
    "animates": [
        "animate"
    ],
    "animating": [
        "animate"
    ],
    "apertures": [
        "aperture"
    ],
    "dazed": [
        "daze"
    ],
    "dazing": [
        "daze"
    ],
    "dominicans": [
        "dominican"
    ],
    "encroachments": [
        "encroachment"
    ],
    "escalations": [
        "escalation"
    ],
    "falconers": [
        "falconer"
    ],
    "iterations": [
        "iteration"
    ],
    "leonardoes": [
        "leonardo"
    ],
    "nsfs": [
        "nsf"
    ],
    "plummeted": [
        "plummete"
    ],
    "plummeting": [
        "plummete"
    ],
    "royces": [
        "royce"
    ],
    "shambless": [
        "shambles"
    ],
    "smugglers": [
        "smuggler"
    ],
    "anarchists": [
        "anarchist"
    ],
    "buoyed": [
        "buoy"
    ],
    "buoys": [
        "buoy"
    ],
    "buoying": [
        "buoy"
    ],
    "caddying": [
        "caddy"
    ],
    "caddied": [
        "caddy"
    ],
    "econometrics": [
        "econometric"
    ],
    "freshnesses": [
        "freshness"
    ],
    "frills": [
        "frill"
    ],
    "frilling": [
        "frill"
    ],
    "glovers": [
        "glover"
    ],
    "gnawed": [
        "gnaw"
    ],
    "gnawing": [
        "gnaw"
    ],
    "gnaws": [
        "gnaw"
    ],
    "grousing": [
        "grouse"
    ],
    "groused": [
        "grouse"
    ],
    "idealists": [
        "idealist"
    ],
    "irvings": [
        "irving"
    ],
    "juiciest": [
        "juicy"
    ],
    "juicier": [
        "juicy"
    ],
    "millings": [
        "milling"
    ],
    "plaits": [
        "plait"
    ],
    "plaited": [
        "plait"
    ],
    "plaiting": [
        "plait"
    ],
    "provences": [
        "provence"
    ],
    "reorganized": [
        "reorganize"
    ],
    "reorganizing": [
        "reorganize"
    ],
    "reorganizes": [
        "reorganize"
    ],
    "scannings": [
        "scanning"
    ],
    "sherlocks": [
        "sherlock"
    ],
    "thickets": [
        "thicket"
    ],
    "vagrants": [
        "vagrant"
    ],
    "wipers": [
        "wiper"
    ],
    "workgroups": [
        "workgroup"
    ],
    "workgrouping": [
        "workgroup"
    ],
    "amelias": [
        "amelia"
    ],
    "bounties": [
        "bounty"
    ],
    "bountys": [
        "bounty"
    ],
    "caustics": [
        "caustic"
    ],
    "centrepieces": [
        "centrepiece"
    ],
    "cinnamons": [
        "cinnamon"
    ],
    "connorss": [
        "connors"
    ],
    "disorderlies": [
        "disorderly"
    ],
    "eqs": [
        "eq"
    ],
    "flecks": [
        "fleck"
    ],
    "flecked": [
        "fleck"
    ],
    "flecking": [
        "fleck"
    ],
    "footholds": [
        "foothold"
    ],
    "gentiles": [
        "gentile"
    ],
    "gentlenesses": [
        "gentleness"
    ],
    "heartlands": [
        "heartland"
    ],
    "info.": [
        "info"
    ],
    "ketterings": [
        "kettering"
    ],
    "mackintoshes": [
        "mackintosh"
    ],
    "medallists": [
        "medallist"
    ],
    "promulgated": [
        "promulgate"
    ],
    "promulgating": [
        "promulgate"
    ],
    "promulgates": [
        "promulgate"
    ],
    "puns": [
        "pun"
    ],
    "punning": [
        "pun"
    ],
    "punned": [
        "pun"
    ],
    "sneezing": [
        "sneeze"
    ],
    "sneezed": [
        "sneeze"
    ],
    "sneezes": [
        "sneeze"
    ],
    "stockpiles": [
        "stockpile"
    ],
    "stockpiling": [
        "stockpile"
    ],
    "stockpiled": [
        "stockpile"
    ],
    "swished": [
        "swish"
    ],
    "swishing": [
        "swish"
    ],
    "swishes": [
        "swish"
    ],
    "wolds": [
        "wold"
    ],
    "barrs": [
        "barr"
    ],
    "buddhisms": [
        "buddhism"
    ],
    "casings": [
        "casing"
    ],
    "complicities": [
        "complicity"
    ],
    "courtrooms": [
        "courtroom"
    ],
    "deposed": [
        "depose"
    ],
    "deposing": [
        "depose"
    ],
    "dissociated": [
        "dissociate"
    ],
    "dissociating": [
        "dissociate"
    ],
    "dissociates": [
        "dissociate"
    ],
    "externalities": [
        "externality"
    ],
    "foresights": [
        "foresight"
    ],
    "monologuing": [
        "monologue"
    ],
    "muffled": [
        "muffle"
    ],
    "muffling": [
        "muffle"
    ],
    "muffles": [
        "muffle"
    ],
    "nightdresses": [
        "nightdress"
    ],
    "oppressed": [
        "oppress"
    ],
    "oppressing": [
        "oppress"
    ],
    "oppresses": [
        "oppress"
    ],
    "overestimated": [
        "overestimate"
    ],
    "overestimates": [
        "overestimate"
    ],
    "overestimating": [
        "overestimate"
    ],
    "parklands": [
        "parkland"
    ],
    "phenotypes": [
        "phenotype"
    ],
    "plethoras": [
        "plethora"
    ],
    "polluters": [
        "polluter"
    ],
    "pundits": [
        "pundit"
    ],
    "putters": [
        "putter"
    ],
    "puttered": [
        "putter"
    ],
    "puttering": [
        "putter"
    ],
    "retinues": [
        "retinue"
    ],
    "saturated": [
        "saturate"
    ],
    "saturating": [
        "saturate"
    ],
    "saturates": [
        "saturate"
    ],
    "selfishnesses": [
        "selfishness"
    ],
    "shatterings": [
        "shattering"
    ],
    "shias": [
        "shia"
    ],
    "smudged": [
        "smudge"
    ],
    "smudges": [
        "smudge"
    ],
    "smudging": [
        "smudge"
    ],
    "squandered": [
        "squander"
    ],
    "squandering": [
        "squander"
    ],
    "squanders": [
        "squander"
    ],
    "taiwaneses": [
        "taiwanese"
    ],
    "treacheries": [
        "treachery"
    ],
    "ultrasounds": [
        "ultrasound"
    ],
    "waddingtons": [
        "waddington"
    ],
    "wanderers": [
        "wanderer"
    ],
    "waterss": [
        "waters"
    ],
    "weighings": [
        "weighing"
    ],
    "yangs": [
        "yang"
    ],
    "addressees": [
        "addressee"
    ],
    "anteriors": [
        "anterior"
    ],
    "denominators": [
        "denominator"
    ],
    "governesses": [
        "governess"
    ],
    "governessing": [
        "governess"
    ],
    "guillotined": [
        "guillotine"
    ],
    "guillotining": [
        "guillotine"
    ],
    "haloes": [
        "halo"
    ],
    "haloed": [
        "halo"
    ],
    "haloing": [
        "halo"
    ],
    "hogans": [
        "hogan"
    ],
    "informers": [
        "informer"
    ],
    "interlockings": [
        "interlocking"
    ],
    "magdalens": [
        "magdalen"
    ],
    "merovingians": [
        "merovingian"
    ],
    "mowers": [
        "mower"
    ],
    "mubaraks": [
        "mubarak"
    ],
    "nordics": [
        "nordic"
    ],
    "repossessions": [
        "repossession"
    ],
    "screamings": [
        "screaming"
    ],
    "tennysons": [
        "tennyson"
    ],
    "tightenings": [
        "tightening"
    ],
    "algebras": [
        "algebra"
    ],
    "arbiters": [
        "arbiter"
    ],
    "balkanss": [
        "balkans"
    ],
    "barths": [
        "barth"
    ],
    "benthams": [
        "bentham"
    ],
    "bolognas": [
        "bologna"
    ],
    "categorized": [
        "categorize"
    ],
    "categorizing": [
        "categorize"
    ],
    "categorizes": [
        "categorize"
    ],
    "cretaceouss": [
        "cretaceous"
    ],
    "encased": [
        "encase"
    ],
    "encasing": [
        "encase"
    ],
    "encases": [
        "encase"
    ],
    "eugenes": [
        "eugene"
    ],
    "facings": [
        "facing"
    ],
    "hanovers": [
        "hanover"
    ],
    "infused": [
        "infuse"
    ],
    "infusing": [
        "infuse"
    ],
    "intensifications": [
        "intensification"
    ],
    "jeromes": [
        "jerome"
    ],
    "lexicographers": [
        "lexicographer"
    ],
    "lilacs": [
        "lilac"
    ],
    "logisticss": [
        "logistics"
    ],
    "manhoods": [
        "manhood"
    ],
    "pelvises": [
        "pelvis"
    ],
    "pelves": [
        "pelvis"
    ],
    "plumbed": [
        "plumb"
    ],
    "plumbing": [
        "plumb"
    ],
    "plumbs": [
        "plumb"
    ],
    "preambles": [
        "preamble"
    ],
    "protectionisms": [
        "protectionism"
    ],
    "reimbursed": [
        "reimburse"
    ],
    "reimburses": [
        "reimburse"
    ],
    "reimbursing": [
        "reimburse"
    ],
    "septs": [
        "sept"
    ],
    "slivers": [
        "sliver"
    ],
    "soldered": [
        "solder"
    ],
    "soldering": [
        "solder"
    ],
    "solders": [
        "solder"
    ],
    "sprees": [
        "spree"
    ],
    "springfields": [
        "springfield"
    ],
    "suckers": [
        "sucker"
    ],
    "suckered": [
        "sucker"
    ],
    "suckering": [
        "sucker"
    ],
    "sundries": [
        "sundry"
    ],
    "tats": [
        "tat"
    ],
    "tatting": [
        "tat"
    ],
    "tatted": [
        "tat"
    ],
    "upholsteries": [
        "upholstery"
    ],
    "brezhnevs": [
        "brezhnev"
    ],
    "cls": [
        "cl"
    ],
    "clusterings": [
        "clustering"
    ],
    "distinctivenesses": [
        "distinctiveness"
    ],
    "exuded": [
        "exude"
    ],
    "exuding": [
        "exude"
    ],
    "exudes": [
        "exude"
    ],
    "hooliganisms": [
        "hooliganism"
    ],
    "ingress": [
        "ingres"
    ],
    "positivisms": [
        "positivism"
    ],
    "prying": [
        "pry"
    ],
    "pried": [
        "pry"
    ],
    "prys": [
        "pry"
    ],
    "pryed": [
        "pry"
    ],
    "retardeds": [
        "retarded"
    ],
    "ripening": [
        "ripen"
    ],
    "ripened": [
        "ripen"
    ],
    "ripens": [
        "ripen"
    ],
    "rutlands": [
        "rutland"
    ],
    "schizophrenics": [
        "schizophrenic"
    ],
    "sporing": [
        "spore"
    ],
    "stalinists": [
        "stalinist"
    ],
    "tethered": [
        "tether"
    ],
    "tethers": [
        "tether"
    ],
    "tethering": [
        "tether"
    ],
    "titoes": [
        "tito"
    ],
    "typists": [
        "typist"
    ],
    "udcs": [
        "udc"
    ],
    "widowers": [
        "widower"
    ],
    "zetas": [
        "zeta"
    ],
    "achilless": [
        "achilles"
    ],
    "biffing": [
        "biff"
    ],
    "biffs": [
        "biff"
    ],
    "biffed": [
        "biff"
    ],
    "completenesses": [
        "completeness"
    ],
    "durabilities": [
        "durability"
    ],
    "ecologists": [
        "ecologist"
    ],
    "exportings": [
        "exporting"
    ],
    "fads": [
        "fad"
    ],
    "hinterlands": [
        "hinterland"
    ],
    "hogs": [
        "hog"
    ],
    "hogging": [
        "hog"
    ],
    "hogged": [
        "hog"
    ],
    "horsebacks": [
        "horseback"
    ],
    "indiscriminating": [
        "indiscriminate"
    ],
    "kentishes": [
        "kentish"
    ],
    "letterings": [
        "lettering"
    ],
    "meccas": [
        "mecca"
    ],
    "palls": [
        "pall"
    ],
    "perestroikas": [
        "perestroika"
    ],
    "perpetrators": [
        "perpetrator"
    ],
    "prefixed": [
        "prefix"
    ],
    "prefixing": [
        "prefix"
    ],
    "pwrs": [
        "pwr"
    ],
    "rowntrees": [
        "rowntree"
    ],
    "supplanted": [
        "supplant"
    ],
    "supplanting": [
        "supplant"
    ],
    "supplants": [
        "supplant"
    ],
    "auditoria": [
        "auditorium"
    ],
    "billowing": [
        "billow"
    ],
    "billowed": [
        "billow"
    ],
    "billows": [
        "billow"
    ],
    "brandos": [
        "brando"
    ],
    "brooklyns": [
        "brooklyn"
    ],
    "bruisings": [
        "bruising"
    ],
    "cashiers": [
        "cashier"
    ],
    "cashiered": [
        "cashier"
    ],
    "cashiering": [
        "cashier"
    ],
    "celeries": [
        "celery"
    ],
    "characterizations": [
        "characterization"
    ],
    "deepenings": [
        "deepening"
    ],
    "haydns": [
        "haydn"
    ],
    "jigs": [
        "jig"
    ],
    "jigging": [
        "jig"
    ],
    "jigged": [
        "jig"
    ],
    "jumbos": [
        "jumbo"
    ],
    "lennons": [
        "lennon"
    ],
    "orions": [
        "orion"
    ],
    "plotters": [
        "plotter"
    ],
    "regressed": [
        "regress"
    ],
    "regressing": [
        "regress"
    ],
    "regresses": [
        "regress"
    ],
    "remarried": [
        "remarry"
    ],
    "remarrying": [
        "remarry"
    ],
    "remarries": [
        "remarry"
    ],
    "shorelines": [
        "shoreline"
    ],
    "spinaches": [
        "spinach"
    ],
    "structuralisms": [
        "structuralism"
    ],
    "stubbled": [
        "stubble"
    ],
    "stubbles": [
        "stubble"
    ],
    "tufts": [
        "tuft"
    ],
    "tufting": [
        "tuft"
    ],
    "tulips": [
        "tulip"
    ],
    "ughs": [
        "ugh"
    ],
    "wanderings": [
        "wandering"
    ],
    "windfalls": [
        "windfall"
    ],
    "airlifted": [
        "airlift"
    ],
    "airlifts": [
        "airlift"
    ],
    "airlifting": [
        "airlift"
    ],
    "basilicas": [
        "basilica"
    ],
    "brandishing": [
        "brandish"
    ],
    "brandished": [
        "brandish"
    ],
    "brandishes": [
        "brandish"
    ],
    "cappings": [
        "capping"
    ],
    "cloisters": [
        "cloister"
    ],
    "cloistered": [
        "cloister"
    ],
    "cloistering": [
        "cloister"
    ],
    "disallowed": [
        "disallow"
    ],
    "disallowing": [
        "disallow"
    ],
    "disallows": [
        "disallow"
    ],
    "dockyards": [
        "dockyard"
    ],
    "droplets": [
        "droplet"
    ],
    "eaters": [
        "eater"
    ],
    "gettier": [
        "getty"
    ],
    "headmen": [
        "headman"
    ],
    "larders": [
        "larder"
    ],
    "neutralised": [
        "neutralise"
    ],
    "neutralising": [
        "neutralise"
    ],
    "neutrophils": [
        "neutrophil"
    ],
    "overstated": [
        "overstate"
    ],
    "overstates": [
        "overstate"
    ],
    "overstating": [
        "overstate"
    ],
    "panellings": [
        "panelling"
    ],
    "peerages": [
        "peerage"
    ],
    "potties": [
        "potty"
    ],
    "pottier": [
        "potty"
    ],
    "pottiest": [
        "potty"
    ],
    "quails": [
        "quail"
    ],
    "quailed": [
        "quail"
    ],
    "quailing": [
        "quail"
    ],
    "quantifications": [
        "quantification"
    ],
    "silvias": [
        "silvia"
    ],
    "stalemates": [
        "stalemate"
    ],
    "stalemated": [
        "stalemate"
    ],
    "tutted": [
        "tut"
    ],
    "tutting": [
        "tut"
    ],
    "tuts": [
        "tut"
    ],
    "whitewashed": [
        "whitewash"
    ],
    "whitewashing": [
        "whitewash"
    ],
    "whitewashes": [
        "whitewash"
    ],
    "workmanships": [
        "workmanship"
    ],
    "yardsticks": [
        "yardstick"
    ],
    "abseiling": [
        "abseil"
    ],
    "abseils": [
        "abseil"
    ],
    "abseiled": [
        "abseil"
    ],
    "abseilling": [
        "abseil"
    ],
    "buyouts": [
        "buyout"
    ],
    "devotees": [
        "devotee"
    ],
    "dohs": [
        "doh"
    ],
    "encroached": [
        "encroach"
    ],
    "encroaching": [
        "encroach"
    ],
    "encroaches": [
        "encroach"
    ],
    "fangs": [
        "fang"
    ],
    "lumens": [
        "lumen"
    ],
    "papuas": [
        "papua"
    ],
    "plummers": [
        "plummer"
    ],
    "posited": [
        "posit"
    ],
    "posits": [
        "posit"
    ],
    "positing": [
        "posit"
    ],
    "rescinded": [
        "rescind"
    ],
    "rescinding": [
        "rescind"
    ],
    "rescinds": [
        "rescind"
    ],
    "sapphires": [
        "sapphire"
    ],
    "sauntered": [
        "saunter"
    ],
    "sauntering": [
        "saunter"
    ],
    "saunters": [
        "saunter"
    ],
    "sidings": [
        "siding"
    ],
    "toothbrushes": [
        "toothbrush"
    ],
    "toothbrushing": [
        "toothbrush"
    ],
    "tornados": [
        "tornado"
    ],
    "tornadoes": [
        "tornado"
    ],
    "walkmen": [
        "walkman"
    ],
    "worksheets": [
        "worksheet"
    ],
    "bahamass": [
        "bahamas"
    ],
    "bergs": [
        "berg"
    ],
    "blindings": [
        "blinding"
    ],
    "cameroons": [
        "cameroon"
    ],
    "creakings": [
        "creaking"
    ],
    "dabbling": [
        "dabble"
    ],
    "dabbled": [
        "dabble"
    ],
    "dabbles": [
        "dabble"
    ],
    "elitists": [
        "elitist"
    ],
    "exhorted": [
        "exhort"
    ],
    "exhorting": [
        "exhort"
    ],
    "exhorts": [
        "exhort"
    ],
    "fatalities": [
        "fatality"
    ],
    "fermenting": [
        "ferment"
    ],
    "fermented": [
        "ferment"
    ],
    "firewoods": [
        "firewood"
    ],
    "fussier": [
        "fussy"
    ],
    "fussies": [
        "fussy"
    ],
    "fussiest": [
        "fussy"
    ],
    "greenfields": [
        "greenfield"
    ],
    "leered": [
        "leer"
    ],
    "leering": [
        "leer"
    ],
    "leers": [
        "leer"
    ],
    "mandibles": [
        "mandible"
    ],
    "millets": [
        "millet"
    ],
    "oars": [
        "oar"
    ],
    "operatics": [
        "operatic"
    ],
    "panamanians": [
        "panamanian"
    ],
    "posteriors": [
        "posterior"
    ],
    "reconstituted": [
        "reconstitute"
    ],
    "reconstituting": [
        "reconstitute"
    ],
    "reconstitutes": [
        "reconstitute"
    ],
    "rotas": [
        "rota"
    ],
    "scoffed": [
        "scoff"
    ],
    "scoffing": [
        "scoff"
    ],
    "scoffs": [
        "scoff"
    ],
    "segregated": [
        "segregate"
    ],
    "segregating": [
        "segregate"
    ],
    "segregates": [
        "segregate"
    ],
    "setups": [
        "setup"
    ],
    "snares": [
        "snare"
    ],
    "snared": [
        "snare"
    ],
    "snaring": [
        "snare"
    ],
    "specialisms": [
        "specialism"
    ],
    "spenders": [
        "spender"
    ],
    "staved": [
        "stave"
    ],
    "staving": [
        "stave"
    ],
    "stove": [
        "stave"
    ],
    "technicalities": [
        "technicality"
    ],
    "traffickers": [
        "trafficker"
    ],
    "adjuncts": [
        "adjunct"
    ],
    "ambiences": [
        "ambience"
    ],
    "askings": [
        "asking"
    ],
    "bernsteins": [
        "bernstein"
    ],
    "bitings": [
        "biting"
    ],
    "carews": [
        "carew"
    ],
    "caveats": [
        "caveat"
    ],
    "chromed": [
        "chrome"
    ],
    "chroming": [
        "chrome"
    ],
    "commoners": [
        "commoner"
    ],
    "consternations": [
        "consternation"
    ],
    "courseworks": [
        "coursework"
    ],
    "dungeons": [
        "dungeon"
    ],
    "dwindlings": [
        "dwindling"
    ],
    "filmings": [
        "filming"
    ],
    "impediments": [
        "impediment"
    ],
    "indented": [
        "indent"
    ],
    "indents": [
        "indent"
    ],
    "indenting": [
        "indent"
    ],
    "lawsuits": [
        "lawsuit"
    ],
    "parmas": [
        "parma"
    ],
    "ponting": [
        "pont"
    ],
    "prousts": [
        "proust"
    ],
    "reprisals": [
        "reprisal"
    ],
    "shimmered": [
        "shimmer"
    ],
    "shimmers": [
        "shimmer"
    ],
    "shimmering": [
        "shimmer"
    ],
    "stockier": [
        "stocky"
    ],
    "stockiest": [
        "stocky"
    ],
    "zaires": [
        "zaire"
    ],
    "altruisms": [
        "altruism"
    ],
    "ambled": [
        "amble"
    ],
    "ambling": [
        "amble"
    ],
    "ambles": [
        "amble"
    ],
    "ascendancies": [
        "ascendancy"
    ],
    "burlingtons": [
        "burlington"
    ],
    "circumferences": [
        "circumference"
    ],
    "cobols": [
        "cobol"
    ],
    "colonialisms": [
        "colonialism"
    ],
    "congregated": [
        "congregate"
    ],
    "congregating": [
        "congregate"
    ],
    "congregates": [
        "congregate"
    ],
    "davies": [
        "davy"
    ],
    "eldoradoes": [
        "eldorado"
    ],
    "eyelashes": [
        "eyelash"
    ],
    "eyelashed": [
        "eyelash"
    ],
    "gauls": [
        "gaul"
    ],
    "gearings": [
        "gearing"
    ],
    "heinzs": [
        "heinz"
    ],
    "jrs": [
        "jr"
    ],
    "lankans": [
        "lankan"
    ],
    "lms": [
        "lm"
    ],
    "lumbered": [
        "lumber"
    ],
    "lumbering": [
        "lumber"
    ],
    "lumbers": [
        "lumber"
    ],
    "marylands": [
        "maryland"
    ],
    "mccartneys": [
        "mccartney"
    ],
    "meps": [
        "mep"
    ],
    "neds": [
        "ned"
    ],
    "principalities": [
        "principality"
    ],
    "rainwaters": [
        "rainwater"
    ],
    "requisitioned": [
        "requisition"
    ],
    "requisitioning": [
        "requisition"
    ],
    "reshaping": [
        "reshape"
    ],
    "reshaped": [
        "reshape"
    ],
    "reshapes": [
        "reshape"
    ],
    "roadways": [
        "roadway"
    ],
    "sickles": [
        "sickle"
    ],
    "sickling": [
        "sickle"
    ],
    "stanzas": [
        "stanza"
    ],
    "strengthenings": [
        "strengthening"
    ],
    "thanksgivings": [
        "thanksgiving"
    ],
    "twistings": [
        "twisting"
    ],
    "ventilators": [
        "ventilator"
    ],
    "westerners": [
        "westerner"
    ],
    "whacked": [
        "whack"
    ],
    "whacks": [
        "whack"
    ],
    "whacking": [
        "whack"
    ],
    "wilberforces": [
        "wilberforce"
    ],
    "withholdings": [
        "withholding"
    ],
    "armpits": [
        "armpit"
    ],
    "attired": [
        "attire"
    ],
    "attiring": [
        "attire"
    ],
    "backstages": [
        "backstage"
    ],
    "catwalks": [
        "catwalk"
    ],
    "chromatographies": [
        "chromatography"
    ],
    "cyclicals": [
        "cyclical"
    ],
    "deixes": [
        "deixis"
    ],
    "demarcations": [
        "demarcation"
    ],
    "disinfectants": [
        "disinfectant"
    ],
    "disquieted": [
        "disquiet"
    ],
    "disquiets": [
        "disquiet"
    ],
    "disquieting": [
        "disquiet"
    ],
    "fudged": [
        "fudge"
    ],
    "fudging": [
        "fudge"
    ],
    "fudges": [
        "fudge"
    ],
    "hotspurs": [
        "hotspur"
    ],
    "huxleys": [
        "huxley"
    ],
    "malnutritions": [
        "malnutrition"
    ],
    "maniacs": [
        "maniac"
    ],
    "naggings": [
        "nagging"
    ],
    "pcbs": [
        "pcb"
    ],
    "polypeptides": [
        "polypeptide"
    ],
    "publicans": [
        "publican"
    ],
    "rafters": [
        "rafter"
    ],
    "raftered": [
        "rafter"
    ],
    "romanticisms": [
        "romanticism"
    ],
    "ruddier": [
        "ruddy"
    ],
    "ruddied": [
        "ruddy"
    ],
    "ruddies": [
        "ruddy"
    ],
    "ruddys": [
        "ruddy"
    ],
    "ruddiest": [
        "ruddy"
    ],
    "sabahs": [
        "sabah"
    ],
    "senegals": [
        "senegal"
    ],
    "sheaves": [
        "sheaf"
    ],
    "sheafs": [
        "sheaf"
    ],
    "typefaces": [
        "typeface"
    ],
    "understatements": [
        "understatement"
    ],
    "waddled": [
        "waddle"
    ],
    "waddling": [
        "waddle"
    ],
    "waddles": [
        "waddle"
    ],
    "yachtings": [
        "yachting"
    ],
    "agrippas": [
        "agrippa"
    ],
    "bantering": [
        "banter"
    ],
    "bantered": [
        "banter"
    ],
    "banters": [
        "banter"
    ],
    "befell": [
        "befall"
    ],
    "befallen": [
        "befall"
    ],
    "befalls": [
        "befall"
    ],
    "befalling": [
        "befall"
    ],
    "binges": [
        "binge"
    ],
    "bingeing": [
        "binge"
    ],
    "binged": [
        "binge"
    ],
    "certs": [
        "cert"
    ],
    "choosings": [
        "choosing"
    ],
    "conscriptions": [
        "conscription"
    ],
    "disclaimers": [
        "disclaimer"
    ],
    "disneylands": [
        "disneyland"
    ],
    "genoas": [
        "genoa"
    ],
    "hurleys": [
        "hurley"
    ],
    "immortalities": [
        "immortality"
    ],
    "isdns": [
        "isdn"
    ],
    "landslides": [
        "landslide"
    ],
    "landsliding": [
        "landslide"
    ],
    "lettings": [
        "letting"
    ],
    "mallets": [
        "mallet"
    ],
    "mannheims": [
        "mannheim"
    ],
    "perpetrated": [
        "perpetrate"
    ],
    "perpetrating": [
        "perpetrate"
    ],
    "perpetrates": [
        "perpetrate"
    ],
    "piagets": [
        "piaget"
    ],
    "polygons": [
        "polygon"
    ],
    "portoes": [
        "porto"
    ],
    "provosts": [
        "provost"
    ],
    "quipped": [
        "quip"
    ],
    "quips": [
        "quip"
    ],
    "quipping": [
        "quip"
    ],
    "rearrangements": [
        "rearrangement"
    ],
    "recharged": [
        "recharge"
    ],
    "recharging": [
        "recharge"
    ],
    "redistributed": [
        "redistribute"
    ],
    "redistributing": [
        "redistribute"
    ],
    "redistributes": [
        "redistribute"
    ],
    "ruts": [
        "rut"
    ],
    "rutted": [
        "rut"
    ],
    "rutting": [
        "rut"
    ],
    "salmonellas": [
        "salmonella"
    ],
    "takers": [
        "taker"
    ],
    "tuscanies": [
        "tuscany"
    ],
    "unescoes": [
        "unesco"
    ],
    "blindfolded": [
        "blindfold"
    ],
    "blindfolds": [
        "blindfold"
    ],
    "blindfolding": [
        "blindfold"
    ],
    "borderlines": [
        "borderline"
    ],
    "botanists": [
        "botanist"
    ],
    "distilled": [
        "distil"
    ],
    "distilling": [
        "distil"
    ],
    "distils": [
        "distil"
    ],
    "downtowner": [
        "downtown"
    ],
    "fissuring": [
        "fissure"
    ],
    "glowered": [
        "glower"
    ],
    "glowering": [
        "glower"
    ],
    "glowers": [
        "glower"
    ],
    "gunfires": [
        "gunfire"
    ],
    "kilograms": [
        "kilogram"
    ],
    "lacquered": [
        "lacquer"
    ],
    "lacquers": [
        "lacquer"
    ],
    "lacquering": [
        "lacquer"
    ],
    "latvians": [
        "latvian"
    ],
    "madmen": [
        "madman"
    ],
    "madmans": [
        "madman"
    ],
    "madrigals": [
        "madrigal"
    ],
    "rationalised": [
        "rationalise"
    ],
    "rationalising": [
        "rationalise"
    ],
    "rationalises": [
        "rationalise"
    ],
    "reinstatements": [
        "reinstatement"
    ],
    "restitutions": [
        "restitution"
    ],
    "retrograding": [
        "retrograde"
    ],
    "retrograded": [
        "retrograde"
    ],
    "sculleries": [
        "scullery"
    ],
    "signors": [
        "signor"
    ],
    "surrealists": [
        "surrealist"
    ],
    "synthesised": [
        "synthesise"
    ],
    "synthesising": [
        "synthesise"
    ],
    "synthesises": [
        "synthesise"
    ],
    "truancies": [
        "truancy"
    ],
    "vdus": [
        "vdu"
    ],
    "vials": [
        "vial"
    ],
    "waivers": [
        "waiver"
    ],
    "waivered": [
        "waiver"
    ],
    "warrings": [
        "warring"
    ],
    "babbling": [
        "babble"
    ],
    "babbled": [
        "babble"
    ],
    "babbles": [
        "babble"
    ],
    "brugess": [
        "bruges"
    ],
    "cheerier": [
        "cheery"
    ],
    "cheeriest": [
        "cheery"
    ],
    "connoisseurs": [
        "connoisseur"
    ],
    "craftsmanships": [
        "craftsmanship"
    ],
    "demeanours": [
        "demeanour"
    ],
    "deutschmarks": [
        "deutschmark"
    ],
    "displeasures": [
        "displeasure"
    ],
    "eventualities": [
        "eventuality"
    ],
    "fabricated": [
        "fabricate"
    ],
    "fabricating": [
        "fabricate"
    ],
    "fabricates": [
        "fabricate"
    ],
    "fuzziest": [
        "fuzzy"
    ],
    "fuzzies": [
        "fuzzy"
    ],
    "fuzzier": [
        "fuzzy"
    ],
    "gorengs": [
        "goreng"
    ],
    "ionics": [
        "ionic"
    ],
    "kansass": [
        "kansas"
    ],
    "porpoises": [
        "porpoise"
    ],
    "porpoising": [
        "porpoise"
    ],
    "porpoised": [
        "porpoise"
    ],
    "prologues": [
        "prologue"
    ],
    "refuelling": [
        "refuel"
    ],
    "refuelled": [
        "refuel"
    ],
    "refuels": [
        "refuel"
    ],
    "returnings": [
        "returning"
    ],
    "sooted": [
        "soot"
    ],
    "sooting": [
        "soot"
    ],
    "soots": [
        "soot"
    ],
    "squalors": [
        "squalor"
    ],
    "toxicities": [
        "toxicity"
    ],
    "valences": [
        "valence"
    ],
    "valenced": [
        "valence"
    ],
    "wands": [
        "wand"
    ],
    "collagens": [
        "collagen"
    ],
    "dickies": [
        "dickie"
    ],
    "duresses": [
        "duress"
    ],
    "fabliaus": [
        "fabliau"
    ],
    "fattening": [
        "fatten"
    ],
    "fattened": [
        "fatten"
    ],
    "fattens": [
        "fatten"
    ],
    "freudians": [
        "freudian"
    ],
    "frothing": [
        "froth"
    ],
    "frothed": [
        "froth"
    ],
    "froths": [
        "froth"
    ],
    "kiplings": [
        "kipling"
    ],
    "maces": [
        "mace"
    ],
    "machs": [
        "mach"
    ],
    "montagus": [
        "montagu"
    ],
    "neptunes": [
        "neptune"
    ],
    "perverts": [
        "pervert"
    ],
    "perverted": [
        "pervert"
    ],
    "perverting": [
        "pervert"
    ],
    "phosphoruss": [
        "phosphorus"
    ],
    "presleys": [
        "presley"
    ],
    "rds": [
        "rd"
    ],
    "reposed": [
        "repose"
    ],
    "reposing": [
        "repose"
    ],
    "schematics": [
        "schematic"
    ],
    "schoolteachers": [
        "schoolteacher"
    ],
    "scuffles": [
        "scuffle"
    ],
    "scuffling": [
        "scuffle"
    ],
    "scuffled": [
        "scuffle"
    ],
    "silvas": [
        "silva"
    ],
    "smallholders": [
        "smallholder"
    ],
    "soundings": [
        "sounding"
    ],
    "sprawlings": [
        "sprawling"
    ],
    "stents": [
        "stent"
    ],
    "stented": [
        "stent"
    ],
    "stenting": [
        "stent"
    ],
    "weaponries": [
        "weaponry"
    ],
    "yearnings": [
        "yearning"
    ],
    "yoked": [
        "yoke"
    ],
    "yokes": [
        "yoke"
    ],
    "yoking": [
        "yoke"
    ],
    "brines": [
        "brine"
    ],
    "brining": [
        "brine"
    ],
    "brined": [
        "brine"
    ],
    "coffers": [
        "coffer"
    ],
    "coffering": [
        "coffer"
    ],
    "colonised": [
        "colonise"
    ],
    "colonising": [
        "colonise"
    ],
    "connons": [
        "connon"
    ],
    "conveyancers": [
        "conveyancer"
    ],
    "cypriots": [
        "cypriot"
    ],
    "deforestations": [
        "deforestation"
    ],
    "disproved": [
        "disprove"
    ],
    "disproving": [
        "disprove"
    ],
    "disproves": [
        "disprove"
    ],
    "drenched": [
        "drench"
    ],
    "drenching": [
        "drench"
    ],
    "drenches": [
        "drench"
    ],
    "eas": [
        "ea"
    ],
    "engels": [
        "engel"
    ],
    "glossaries": [
        "glossary"
    ],
    "ingestions": [
        "ingestion"
    ],
    "kestrels": [
        "kestrel"
    ],
    "leashes": [
        "leash"
    ],
    "leashed": [
        "leash"
    ],
    "leashing": [
        "leash"
    ],
    "magpies": [
        "magpie"
    ],
    "manias": [
        "mania"
    ],
    "midwives": [
        "midwive"
    ],
    "mismatches": [
        "mismatch"
    ],
    "mismatched": [
        "mismatch"
    ],
    "mismatching": [
        "mismatch"
    ],
    "moorings": [
        "mooring"
    ],
    "oxidations": [
        "oxidation"
    ],
    "pessimisms": [
        "pessimism"
    ],
    "ranching": [
        "ranch"
    ],
    "ranched": [
        "ranch"
    ],
    "rebuffed": [
        "rebuff"
    ],
    "rebuffs": [
        "rebuff"
    ],
    "rebuffing": [
        "rebuff"
    ],
    "rotterdams": [
        "rotterdam"
    ],
    "sheaths": [
        "sheath"
    ],
    "smogs": [
        "smog"
    ],
    "ssaps": [
        "ssap"
    ],
    "subcontractors": [
        "subcontractor"
    ],
    "thatching": [
        "thatch"
    ],
    "thatches": [
        "thatch"
    ],
    "thatched": [
        "thatch"
    ],
    "angelicas": [
        "angelica"
    ],
    "astronauts": [
        "astronaut"
    ],
    "bandwagons": [
        "bandwagon"
    ],
    "bandwagonning": [
        "bandwagon"
    ],
    "causeways": [
        "causeway"
    ],
    "causewayed": [
        "causeway"
    ],
    "chuted": [
        "chute"
    ],
    "classier": [
        "classy"
    ],
    "classiest": [
        "classy"
    ],
    "decorators": [
        "decorator"
    ],
    "draftsmen": [
        "draftsman"
    ],
    "extroverts": [
        "extrovert"
    ],
    "extroverted": [
        "extrovert"
    ],
    "fullers": [
        "fuller"
    ],
    "hairstyles": [
        "hairstyle"
    ],
    "hairstyling": [
        "hairstyle"
    ],
    "hiccups": [
        "hiccup"
    ],
    "hiccupped": [
        "hiccup"
    ],
    "hiccupping": [
        "hiccup"
    ],
    "husbandries": [
        "husbandry"
    ],
    "jurors": [
        "juror"
    ],
    "kendals": [
        "kendal"
    ],
    "kingships": [
        "kingship"
    ],
    "libertarians": [
        "libertarian"
    ],
    "litigants": [
        "litigant"
    ],
    "lookouts": [
        "lookout"
    ],
    "lymphs": [
        "lymph"
    ],
    "mags": [
        "mag"
    ],
    "marchings": [
        "marching"
    ],
    "padlocked": [
        "padlock"
    ],
    "padlocks": [
        "padlock"
    ],
    "padlocking": [
        "padlock"
    ],
    "plazas": [
        "plaza"
    ],
    "predominances": [
        "predominance"
    ],
    "proverbs": [
        "proverb"
    ],
    "publicized": [
        "publicize"
    ],
    "publicizing": [
        "publicize"
    ],
    "publicizes": [
        "publicize"
    ],
    "rationalized": [
        "rationalize"
    ],
    "rationalizing": [
        "rationalize"
    ],
    "rationalizes": [
        "rationalize"
    ],
    "roths": [
        "roth"
    ],
    "stuffies": [
        "stuffy"
    ],
    "stuffiest": [
        "stuffy"
    ],
    "stuffier": [
        "stuffy"
    ],
    "sudburies": [
        "sudbury"
    ],
    "wastelands": [
        "wasteland"
    ],
    "appointees": [
        "appointee"
    ],
    "belched": [
        "belch"
    ],
    "belching": [
        "belch"
    ],
    "belches": [
        "belch"
    ],
    "boughs": [
        "bough"
    ],
    "boughing": [
        "bough"
    ],
    "bournes": [
        "bourne"
    ],
    "buddhas": [
        "buddha"
    ],
    "captaincies": [
        "captaincy"
    ],
    "consumerisms": [
        "consumerism"
    ],
    "cotswoldss": [
        "cotswolds"
    ],
    "disincentives": [
        "disincentive"
    ],
    "fluencies": [
        "fluency"
    ],
    "freeholders": [
        "freeholder"
    ],
    "gamblers": [
        "gambler"
    ],
    "garters": [
        "garter"
    ],
    "gartering": [
        "garter"
    ],
    "gartered": [
        "garter"
    ],
    "gashes": [
        "gash"
    ],
    "gashed": [
        "gash"
    ],
    "gashing": [
        "gash"
    ],
    "glassiest": [
        "glassy"
    ],
    "glassier": [
        "glassy"
    ],
    "hirs": [
        "hir"
    ],
    "iaeas": [
        "iaea"
    ],
    "longevities": [
        "longevity"
    ],
    "materialists": [
        "materialist"
    ],
    "nicaraguans": [
        "nicaraguan"
    ],
    "nomads": [
        "nomad"
    ],
    "overlies": [
        "overly"
    ],
    "petrochemicals": [
        "petrochemical"
    ],
    "pluralities": [
        "plurality"
    ],
    "shacks": [
        "shack"
    ],
    "shacked": [
        "shack"
    ],
    "shacking": [
        "shack"
    ],
    "shipowners": [
        "shipowner"
    ],
    "sightseeings": [
        "sightseeing"
    ],
    "slurries": [
        "slurry"
    ],
    "slurried": [
        "slurry"
    ],
    "slurrying": [
        "slurry"
    ],
    "stumblings": [
        "stumbling"
    ],
    "urchins": [
        "urchin"
    ],
    "adduced": [
        "adduce"
    ],
    "adduces": [
        "adduce"
    ],
    "adducing": [
        "adduce"
    ],
    "agonisings": [
        "agonising"
    ],
    "ambits": [
        "ambit"
    ],
    "bevins": [
        "bevin"
    ],
    "biomasses": [
        "biomass"
    ],
    "breakaways": [
        "breakaway"
    ],
    "burts": [
        "burt"
    ],
    "cringing": [
        "cringe"
    ],
    "cringed": [
        "cringe"
    ],
    "cringes": [
        "cringe"
    ],
    "cringeing": [
        "cringe"
    ],
    "cts": [
        "ct"
    ],
    "diminutives": [
        "diminutive"
    ],
    "enlivened": [
        "enliven"
    ],
    "enlivening": [
        "enliven"
    ],
    "enlivens": [
        "enliven"
    ],
    "fagins": [
        "fagin"
    ],
    "goddards": [
        "goddard"
    ],
    "hobbled": [
        "hobble"
    ],
    "hobbling": [
        "hobble"
    ],
    "hobbles": [
        "hobble"
    ],
    "ingest": [
        "ing"
    ],
    "ings": [
        "ing"
    ],
    "jeopardized": [
        "jeopardize"
    ],
    "jeopardizing": [
        "jeopardize"
    ],
    "jeopardizes": [
        "jeopardize"
    ],
    "manifolding": [
        "manifold"
    ],
    "manifolded": [
        "manifold"
    ],
    "medics": [
        "medic"
    ],
    "mementoes": [
        "memento"
    ],
    "microscopies": [
        "microscopy"
    ],
    "mogadishus": [
        "mogadishu"
    ],
    "oversights": [
        "oversight"
    ],
    "oversighted": [
        "oversight"
    ],
    "philharmonics": [
        "philharmonic"
    ],
    "potentialities": [
        "potentiality"
    ],
    "samsons": [
        "samson"
    ],
    "standardisations": [
        "standardisation"
    ],
    "unrulier": [
        "unruly"
    ],
    "alders": [
        "alder"
    ],
    "ambroses": [
        "ambrose"
    ],
    "barbarossas": [
        "barbarossa"
    ],
    "casks": [
        "cask"
    ],
    "centralisations": [
        "centralisation"
    ],
    "clefts": [
        "cleft"
    ],
    "epitomes": [
        "epitome"
    ],
    "forefingers": [
        "forefinger"
    ],
    "frontals": [
        "frontal"
    ],
    "gillespies": [
        "gillespie"
    ],
    "goblets": [
        "goblet"
    ],
    "groundings": [
        "grounding"
    ],
    "habsburgs": [
        "habsburg"
    ],
    "hanning": [
        "han"
    ],
    "hans": [
        "han"
    ],
    "hezbollahs": [
        "hezbollah"
    ],
    "hooing": [
        "hoo"
    ],
    "hypnotics": [
        "hypnotic"
    ],
    "incomers": [
        "incomer"
    ],
    "joiners": [
        "joiner"
    ],
    "joinering": [
        "joiner"
    ],
    "loonies": [
        "loony"
    ],
    "looniest": [
        "loony"
    ],
    "loonier": [
        "loony"
    ],
    "lyings": [
        "lying"
    ],
    "muttons": [
        "mutton"
    ],
    "neuroses": [
        "neurosis"
    ],
    "operands": [
        "operand"
    ],
    "osloes": [
        "oslo"
    ],
    "polishings": [
        "polishing"
    ],
    "predisposed": [
        "predispose"
    ],
    "predisposing": [
        "predispose"
    ],
    "pricklier": [
        "prickly"
    ],
    "pushchairs": [
        "pushchair"
    ],
    "pussies": [
        "pussy"
    ],
    "quadrupled": [
        "quadruple"
    ],
    "quadrupling": [
        "quadruple"
    ],
    "retracted": [
        "retract"
    ],
    "retracting": [
        "retract"
    ],
    "retracts": [
        "retract"
    ],
    "sardined": [
        "sardine"
    ],
    "savouries": [
        "savoury"
    ],
    "seafoods": [
        "seafood"
    ],
    "silicones": [
        "silicone"
    ],
    "starlings": [
        "starling"
    ],
    "steeds": [
        "steed"
    ],
    "sweepers": [
        "sweeper"
    ],
    "unanimities": [
        "unanimity"
    ],
    "valencias": [
        "valencia"
    ],
    "welched": [
        "welch"
    ],
    "wonts": [
        "wont"
    ],
    "andersens": [
        "andersen"
    ],
    "augustas": [
        "augusta"
    ],
    "baronets": [
        "baronet"
    ],
    "bridgess": [
        "bridges"
    ],
    "coexisted": [
        "coexist"
    ],
    "coexisting": [
        "coexist"
    ],
    "coexists": [
        "coexist"
    ],
    "darwinians": [
        "darwinian"
    ],
    "earthworms": [
        "earthworm"
    ],
    "eaves": [
        "eave"
    ],
    "eaved": [
        "eave"
    ],
    "enemas": [
        "enema"
    ],
    "furrier": [
        "furry"
    ],
    "furriest": [
        "furry"
    ],
    "generalising": [
        "generalise"
    ],
    "generalised": [
        "generalise"
    ],
    "generalises": [
        "generalise"
    ],
    "grafs": [
        "graf"
    ],
    "hydras": [
        "hydra"
    ],
    "indomethacins": [
        "indomethacin"
    ],
    "keynotes": [
        "keynote"
    ],
    "keynoting": [
        "keynote"
    ],
    "lessors": [
        "lessor"
    ],
    "lightnesses": [
        "lightness"
    ],
    "morbids": [
        "morbid"
    ],
    "omeprazoles": [
        "omeprazole"
    ],
    "panthers": [
        "panther"
    ],
    "patternings": [
        "patterning"
    ],
    "posterities": [
        "posterity"
    ],
    "proffered": [
        "proffer"
    ],
    "proffering": [
        "proffer"
    ],
    "proffers": [
        "proffer"
    ],
    "rectums": [
        "rectum"
    ],
    "relented": [
        "relent"
    ],
    "relenting": [
        "relent"
    ],
    "specks": [
        "speck"
    ],
    "specking": [
        "speck"
    ],
    "specked": [
        "speck"
    ],
    "undervalued": [
        "undervalue"
    ],
    "undervalues": [
        "undervalue"
    ],
    "undervaluing": [
        "undervalue"
    ],
    "wobblies": [
        "wobbly"
    ],
    "acupunctures": [
        "acupuncture"
    ],
    "bismarcks": [
        "bismarck"
    ],
    "carolingians": [
        "carolingian"
    ],
    "cauldrons": [
        "cauldron"
    ],
    "cobwebs": [
        "cobweb"
    ],
    "cobwebbed": [
        "cobweb"
    ],
    "correctnesses": [
        "correctness"
    ],
    "crazes": [
        "craze"
    ],
    "crazing": [
        "craze"
    ],
    "crucifixes": [
        "crucifix"
    ],
    "dandelions": [
        "dandelion"
    ],
    "earthworks": [
        "earthwork"
    ],
    "emilias": [
        "emilia"
    ],
    "evaporations": [
        "evaporation"
    ],
    "glutens": [
        "gluten"
    ],
    "governances": [
        "governance"
    ],
    "gruesomest": [
        "gruesome"
    ],
    "holocausts": [
        "holocaust"
    ],
    "impartialities": [
        "impartiality"
    ],
    "lapels": [
        "lapel"
    ],
    "motherboards": [
        "motherboard"
    ],
    "mouthpieces": [
        "mouthpiece"
    ],
    "nicotined": [
        "nicotine"
    ],
    "peacekeeping": [
        "peacekeep"
    ],
    "regimens": [
        "regimen"
    ],
    "saffrons": [
        "saffron"
    ],
    "sinatras": [
        "sinatra"
    ],
    "starboards": [
        "starboard"
    ],
    "starched": [
        "starch"
    ],
    "starches": [
        "starch"
    ],
    "starching": [
        "starch"
    ],
    "suppling": [
        "supple"
    ],
    "supplest": [
        "supple"
    ],
    "suppler": [
        "supple"
    ],
    "tauruss": [
        "taurus"
    ],
    "traditionalists": [
        "traditionalist"
    ],
    "verandahs": [
        "verandah"
    ],
    "waterfords": [
        "waterford"
    ],
    "anchorages": [
        "anchorage"
    ],
    "brasher": [
        "brash"
    ],
    "brashest": [
        "brash"
    ],
    "brashed": [
        "brash"
    ],
    "celluloses": [
        "cellulose"
    ],
    "fawning": [
        "fawn"
    ],
    "fawns": [
        "fawn"
    ],
    "fawned": [
        "fawn"
    ],
    "frailties": [
        "frailty"
    ],
    "fruitions": [
        "fruition"
    ],
    "hargreavess": [
        "hargreaves"
    ],
    "limbos": [
        "limbo"
    ],
    "nicols": [
        "nicol"
    ],
    "persevered": [
        "persevere"
    ],
    "persevering": [
        "persevere"
    ],
    "photocopiers": [
        "photocopier"
    ],
    "regimentals": [
        "regimental"
    ],
    "remotenesses": [
        "remoteness"
    ],
    "simulators": [
        "simulator"
    ],
    "structurings": [
        "structuring"
    ],
    "surrogates": [
        "surrogate"
    ],
    "tcs": [
        "tc"
    ],
    "temperances": [
        "temperance"
    ],
    "tripolis": [
        "tripoli"
    ],
    "vanillas": [
        "vanilla"
    ],
    "whizzing": [
        "whizz"
    ],
    "whizzed": [
        "whizz"
    ],
    "whizzes": [
        "whizz"
    ],
    "beakers": [
        "beaker"
    ],
    "bloodstreams": [
        "bloodstream"
    ],
    "congressmen": [
        "congressman"
    ],
    "downgraded": [
        "downgrade"
    ],
    "downgrading": [
        "downgrade"
    ],
    "downgrades": [
        "downgrade"
    ],
    "europas": [
        "europa"
    ],
    "fledglings": [
        "fledgling"
    ],
    "grittier": [
        "gritty"
    ],
    "grittiest": [
        "gritty"
    ],
    "imbued": [
        "imbue"
    ],
    "imbuing": [
        "imbue"
    ],
    "ironings": [
        "ironing"
    ],
    "khomeinis": [
        "khomeini"
    ],
    "legering": [
        "leger"
    ],
    "legered": [
        "leger"
    ],
    "magnifications": [
        "magnification"
    ],
    "rationalizations": [
        "rationalization"
    ],
    "resettlements": [
        "resettlement"
    ],
    "revisited": [
        "revisit"
    ],
    "revisiting": [
        "revisit"
    ],
    "revisits": [
        "revisit"
    ],
    "shrinkings": [
        "shrinking"
    ],
    "snugged": [
        "snug"
    ],
    "snugs": [
        "snug"
    ],
    "snugger": [
        "snug"
    ],
    "snuggest": [
        "snug"
    ],
    "socialisations": [
        "socialisation"
    ],
    "tonging": [
        "tong"
    ],
    "warts": [
        "wart"
    ],
    "warted": [
        "wart"
    ],
    "weasels": [
        "weasel"
    ],
    "weaselled": [
        "weasel"
    ],
    "wrappers": [
        "wrapper"
    ],
    "biddies": [
        "biddy"
    ],
    "bishoprics": [
        "bishopric"
    ],
    "bouncers": [
        "bouncer"
    ],
    "brans": [
        "bran"
    ],
    "centralities": [
        "centrality"
    ],
    "delinquencies": [
        "delinquency"
    ],
    "dioxins": [
        "dioxin"
    ],
    "dreamers": [
        "dreamer"
    ],
    "geminis": [
        "gemini"
    ],
    "gratings": [
        "grating"
    ],
    "gymnasiums": [
        "gymnasium"
    ],
    "hsing": [
        "hse"
    ],
    "hses": [
        "hse"
    ],
    "jacquards": [
        "jacquard"
    ],
    "loathings": [
        "loathing"
    ],
    "nahums": [
        "nahum"
    ],
    "newleys": [
        "newley"
    ],
    "pharaohs": [
        "pharaoh"
    ],
    "phoneys": [
        "phoney"
    ],
    "phonier": [
        "phoney"
    ],
    "phoniest": [
        "phoney"
    ],
    "pittsburghs": [
        "pittsburgh"
    ],
    "pols": [
        "pol"
    ],
    "ramen": [
        "raman"
    ],
    "rampaging": [
        "rampage"
    ],
    "rampaged": [
        "rampage"
    ],
    "rampages": [
        "rampage"
    ],
    "remittances": [
        "remittance"
    ],
    "shoutings": [
        "shouting"
    ],
    "shynesses": [
        "shyness"
    ],
    "signifiers": [
        "signifier"
    ],
    "supercomputers": [
        "supercomputer"
    ],
    "swastikas": [
        "swastika"
    ],
    "synthesized": [
        "synthesize"
    ],
    "synthesizing": [
        "synthesize"
    ],
    "synthesizes": [
        "synthesize"
    ],
    "synthesizer": [
        "synthesize"
    ],
    "testimonials": [
        "testimonial"
    ],
    "timors": [
        "timor"
    ],
    "tremblings": [
        "trembling"
    ],
    "trundled": [
        "trundle"
    ],
    "trundling": [
        "trundle"
    ],
    "trundles": [
        "trundle"
    ],
    "uzbekistans": [
        "uzbekistan"
    ],
    "wolffs": [
        "wolff"
    ],
    "abels": [
        "abel"
    ],
    "airframes": [
        "airframe"
    ],
    "alts": [
        "alt"
    ],
    "appeased": [
        "appease"
    ],
    "appeasing": [
        "appease"
    ],
    "appeases": [
        "appease"
    ],
    "boatmen": [
        "boatman"
    ],
    "cloakrooms": [
        "cloakroom"
    ],
    "dems": [
        "dem"
    ],
    "devonshires": [
        "devonshire"
    ],
    "dissenters": [
        "dissenter"
    ],
    "fleshier": [
        "fleshy"
    ],
    "fleshies": [
        "fleshy"
    ],
    "fleshiest": [
        "fleshy"
    ],
    "fowls": [
        "fowl"
    ],
    "fowling": [
        "fowl"
    ],
    "gnomed": [
        "gnome"
    ],
    "gouged": [
        "gouge"
    ],
    "gouging": [
        "gouge"
    ],
    "instrumentations": [
        "instrumentation"
    ],
    "inverts": [
        "invert"
    ],
    "inverting": [
        "invert"
    ],
    "inverted": [
        "invert"
    ],
    "leggings": [
        "legging"
    ],
    "leipzigs": [
        "leipzig"
    ],
    "macrophages": [
        "macrophage"
    ],
    "mayoes": [
        "mayo"
    ],
    "mbas": [
        "mba"
    ],
    "modulated": [
        "modulate"
    ],
    "modulating": [
        "modulate"
    ],
    "modulates": [
        "modulate"
    ],
    "oboes": [
        "oboe"
    ],
    "pelted": [
        "pelt"
    ],
    "pelting": [
        "pelt"
    ],
    "pelts": [
        "pelt"
    ],
    "populaces": [
        "populace"
    ],
    "ppps": [
        "ppp"
    ],
    "regattas": [
        "regatta"
    ],
    "righteousnesses": [
        "righteousness"
    ],
    "salims": [
        "salim"
    ],
    "spectroscopies": [
        "spectroscopy"
    ],
    "spensers": [
        "spenser"
    ],
    "spinsters": [
        "spinster"
    ],
    "spontaneities": [
        "spontaneity"
    ],
    "springboks": [
        "springbok"
    ],
    "stewardships": [
        "stewardship"
    ],
    "stuffings": [
        "stuffing"
    ],
    "tams": [
        "tam"
    ],
    "tithes": [
        "tithe"
    ],
    "toughnesses": [
        "toughness"
    ],
    "transgenics": [
        "transgenic"
    ],
    "wilting": [
        "wilt"
    ],
    "wilted": [
        "wilt"
    ],
    "wilts": [
        "wilt"
    ],
    "wreaked": [
        "wreak"
    ],
    "wreaking": [
        "wreak"
    ],
    "wreaks": [
        "wreak"
    ],
    "androids": [
        "android"
    ],
    "atps": [
        "atp"
    ],
    "befriended": [
        "befriend"
    ],
    "befriending": [
        "befriend"
    ],
    "befriends": [
        "befriend"
    ],
    "bogeys": [
        "bogey"
    ],
    "bogeyed": [
        "bogey"
    ],
    "bogeying": [
        "bogey"
    ],
    "certifieds": [
        "certified"
    ],
    "cubisms": [
        "cubism"
    ],
    "duped": [
        "dupe"
    ],
    "duping": [
        "dupe"
    ],
    "empowerments": [
        "empowerment"
    ],
    "flaks": [
        "flak"
    ],
    "forecourts": [
        "forecourt"
    ],
    "grassroot": [
        "grassroots"
    ],
    "impurities": [
        "impurity"
    ],
    "ivess": [
        "ives"
    ],
    "linning": [
        "lin"
    ],
    "methyls": [
        "methyl"
    ],
    "monochromed": [
        "monochrome"
    ],
    "morrows": [
        "morrow"
    ],
    "mysticisms": [
        "mysticism"
    ],
    "palaeozoics": [
        "palaeozoic"
    ],
    "palates": [
        "palate"
    ],
    "polystyrenes": [
        "polystyrene"
    ],
    "pratts": [
        "pratt"
    ],
    "ranting": [
        "rant"
    ],
    "ranted": [
        "rant"
    ],
    "rants": [
        "rant"
    ],
    "replenished": [
        "replenish"
    ],
    "replenishing": [
        "replenish"
    ],
    "replenishes": [
        "replenish"
    ],
    "scampered": [
        "scamper"
    ],
    "scampering": [
        "scamper"
    ],
    "scampers": [
        "scamper"
    ],
    "shagging": [
        "shag"
    ],
    "shagged": [
        "shag"
    ],
    "shags": [
        "shag"
    ],
    "sitters": [
        "sitter"
    ],
    "slackened": [
        "slacken"
    ],
    "slackening": [
        "slacken"
    ],
    "slackens": [
        "slacken"
    ],
    "surfers": [
        "surfer"
    ],
    "tungs": [
        "tung"
    ],
    "zealanders": [
        "zealander"
    ],
    "bystanders": [
        "bystander"
    ],
    "calibrations": [
        "calibration"
    ],
    "calvins": [
        "calvin"
    ],
    "carelessnesses": [
        "carelessness"
    ],
    "continuances": [
        "continuance"
    ],
    "deliverances": [
        "deliverance"
    ],
    "denunciations": [
        "denunciation"
    ],
    "dgs": [
        "dg"
    ],
    "dispensers": [
        "dispenser"
    ],
    "falsified": [
        "falsify"
    ],
    "falsifying": [
        "falsify"
    ],
    "flotillas": [
        "flotilla"
    ],
    "fluffed": [
        "fluff"
    ],
    "fluffing": [
        "fluff"
    ],
    "fluffs": [
        "fluff"
    ],
    "geomorphologies": [
        "geomorphology"
    ],
    "himalayass": [
        "himalayas"
    ],
    "holinesses": [
        "holiness"
    ],
    "humanisms": [
        "humanism"
    ],
    "impotences": [
        "impotence"
    ],
    "inductances": [
        "inductance"
    ],
    "intricacies": [
        "intricacy"
    ],
    "kangaroos": [
        "kangaroo"
    ],
    "labors": [
        "labor"
    ],
    "negroes": [
        "negro"
    ],
    "ordinances": [
        "ordinance"
    ],
    "perspirations": [
        "perspiration"
    ],
    "plenums": [
        "plenum"
    ],
    "probates": [
        "probate"
    ],
    "proficiencies": [
        "proficiency"
    ],
    "purred": [
        "purr"
    ],
    "purrs": [
        "purr"
    ],
    "purring": [
        "purr"
    ],
    "saltier": [
        "salty"
    ],
    "saltiest": [
        "salty"
    ],
    "seafronts": [
        "seafront"
    ],
    "seagulls": [
        "seagull"
    ],
    "sooties": [
        "sooty"
    ],
    "stylists": [
        "stylist"
    ],
    "susannas": [
        "susanna"
    ],
    "trnas": [
        "trna"
    ],
    "viscosities": [
        "viscosity"
    ],
    "apportioned": [
        "apportion"
    ],
    "apportioning": [
        "apportion"
    ],
    "aquifers": [
        "aquifer"
    ],
    "authorships": [
        "authorship"
    ],
    "barkings": [
        "barking"
    ],
    "barts": [
        "bart"
    ],
    "brahmss": [
        "brahms"
    ],
    "chimps": [
        "chimp"
    ],
    "cobs": [
        "cob"
    ],
    "cobbed": [
        "cob"
    ],
    "corporatists": [
        "corporatist"
    ],
    "decoded": [
        "decode"
    ],
    "decoding": [
        "decode"
    ],
    "feted": [
        "fete"
    ],
    "feting": [
        "fete"
    ],
    "godmothers": [
        "godmother"
    ],
    "gunpowders": [
        "gunpowder"
    ],
    "hindrances": [
        "hindrance"
    ],
    "hoaxes": [
        "hoax"
    ],
    "hoaxed": [
        "hoax"
    ],
    "hoaxing": [
        "hoax"
    ],
    "inaccuracies": [
        "inaccuracy"
    ],
    "indicted": [
        "indict"
    ],
    "indicting": [
        "indict"
    ],
    "indicts": [
        "indict"
    ],
    "interrelationships": [
        "interrelationship"
    ],
    "koches": [
        "koch"
    ],
    "lsds": [
        "lsd"
    ],
    "lumpier": [
        "lumpy"
    ],
    "lumpiest": [
        "lumpy"
    ],
    "outcasts": [
        "outcast"
    ],
    "pantries": [
        "pantry"
    ],
    "peroxides": [
        "peroxide"
    ],
    "peroxided": [
        "peroxide"
    ],
    "peroxiding": [
        "peroxide"
    ],
    "phonologies": [
        "phonology"
    ],
    "pylons": [
        "pylon"
    ],
    "redirected": [
        "redirect"
    ],
    "redirecting": [
        "redirect"
    ],
    "redirects": [
        "redirect"
    ],
    "resolutes": [
        "resolute"
    ],
    "scourges": [
        "scourge"
    ],
    "scourged": [
        "scourge"
    ],
    "scourging": [
        "scourge"
    ],
    "shoemakers": [
        "shoemaker"
    ],
    "sniping": [
        "snipe"
    ],
    "sniped": [
        "snipe"
    ],
    "snipes": [
        "snipe"
    ],
    "sumatras": [
        "sumatra"
    ],
    "vulcans": [
        "vulcan"
    ],
    "waterings": [
        "watering"
    ],
    "wbcs": [
        "wbc"
    ],
    "weakenings": [
        "weakening"
    ],
    "whartons": [
        "wharton"
    ],
    "whiteheads": [
        "whitehead"
    ],
    "whiteheaded": [
        "whitehead"
    ],
    "abodes": [
        "abode"
    ],
    "amendss": [
        "amends"
    ],
    "aus": [
        "au"
    ],
    "bros": [
        "bro"
    ],
    "burlier": [
        "burly"
    ],
    "burlies": [
        "burly"
    ],
    "burliest": [
        "burly"
    ],
    "carnations": [
        "carnation"
    ],
    "deflated": [
        "deflate"
    ],
    "deflating": [
        "deflate"
    ],
    "deflates": [
        "deflate"
    ],
    "devonians": [
        "devonian"
    ],
    "gilbeys": [
        "gilbey"
    ],
    "horrified": [
        "horrify"
    ],
    "horrifying": [
        "horrify"
    ],
    "inferiorities": [
        "inferiority"
    ],
    "lancets": [
        "lancet"
    ],
    "marleys": [
        "marley"
    ],
    "marzipans": [
        "marzipan"
    ],
    "melodramas": [
        "melodrama"
    ],
    "milkings": [
        "milking"
    ],
    "mismanagements": [
        "mismanagement"
    ],
    "mowing": [
        "mow"
    ],
    "mowed": [
        "mow"
    ],
    "mows": [
        "mow"
    ],
    "mown": [
        "mow"
    ],
    "neolithics": [
        "neolithic"
    ],
    "oddest": [
        "od"
    ],
    "odder": [
        "od"
    ],
    "oder": [
        "od"
    ],
    "ods": [
        "od"
    ],
    "opencasting": [
        "opencast"
    ],
    "opportunists": [
        "opportunist"
    ],
    "qualms": [
        "qualm"
    ],
    "rebirthing": [
        "rebirth"
    ],
    "rebirths": [
        "rebirth"
    ],
    "spikier": [
        "spiky"
    ],
    "spikiest": [
        "spiky"
    ],
    "squids": [
        "squid"
    ],
    "stagnations": [
        "stagnation"
    ],
    "sweatings": [
        "sweating"
    ],
    "turnips": [
        "turnip"
    ],
    "acquiescences": [
        "acquiescence"
    ],
    "appended": [
        "append"
    ],
    "appending": [
        "append"
    ],
    "balis": [
        "bali"
    ],
    "baptised": [
        "baptise"
    ],
    "baptising": [
        "baptise"
    ],
    "cantered": [
        "canter"
    ],
    "cantering": [
        "canter"
    ],
    "canters": [
        "canter"
    ],
    "deafnesses": [
        "deafness"
    ],
    "deciphering": [
        "decipher"
    ],
    "deciphered": [
        "decipher"
    ],
    "deciphers": [
        "decipher"
    ],
    "determinisms": [
        "determinism"
    ],
    "emulsions": [
        "emulsion"
    ],
    "emulsioned": [
        "emulsion"
    ],
    "emulsioning": [
        "emulsion"
    ],
    "epistemologies": [
        "epistemology"
    ],
    "evangelisms": [
        "evangelism"
    ],
    "kaufmen": [
        "kaufman"
    ],
    "midges": [
        "midge"
    ],
    "pairings": [
        "pairing"
    ],
    "plinths": [
        "plinth"
    ],
    "plusher": [
        "plush"
    ],
    "plushest": [
        "plush"
    ],
    "prescriptives": [
        "prescriptive"
    ],
    "searchers": [
        "searcher"
    ],
    "stepmothers": [
        "stepmother"
    ],
    "thermometers": [
        "thermometer"
    ],
    "weldings": [
        "welding"
    ],
    "absenteeisms": [
        "absenteeism"
    ],
    "actualities": [
        "actuality"
    ],
    "adversities": [
        "adversity"
    ],
    "afts": [
        "aft"
    ],
    "assertivenesses": [
        "assertiveness"
    ],
    "awakenings": [
        "awakening"
    ],
    "bikers": [
        "biker"
    ],
    "consummated": [
        "consummate"
    ],
    "consummating": [
        "consummate"
    ],
    "consummates": [
        "consummate"
    ],
    "crystallized": [
        "crystallize"
    ],
    "crystallizing": [
        "crystallize"
    ],
    "crystallizes": [
        "crystallize"
    ],
    "defrauding": [
        "defraud"
    ],
    "defrauded": [
        "defraud"
    ],
    "defrauds": [
        "defraud"
    ],
    "everlastings": [
        "everlasting"
    ],
    "flailing": [
        "flail"
    ],
    "flailed": [
        "flail"
    ],
    "flails": [
        "flail"
    ],
    "fos": [
        "fo"
    ],
    "foest": [
        "fo"
    ],
    "formalists": [
        "formalist"
    ],
    "freckles": [
        "freckle"
    ],
    "freckled": [
        "freckle"
    ],
    "freckling": [
        "freckle"
    ],
    "gimmicked": [
        "gimmick"
    ],
    "haymans": [
        "hayman"
    ],
    "healers": [
        "healer"
    ],
    "hopelessnesses": [
        "hopelessness"
    ],
    "hybridisations": [
        "hybridisation"
    ],
    "kentuckies": [
        "kentucky"
    ],
    "khakis": [
        "khaki"
    ],
    "knockouts": [
        "knockout"
    ],
    "mississippis": [
        "mississippi"
    ],
    "munitioning": [
        "munition"
    ],
    "munitioned": [
        "munition"
    ],
    "patronised": [
        "patronise"
    ],
    "patronising": [
        "patronise"
    ],
    "patronises": [
        "patronise"
    ],
    "planters": [
        "planter"
    ],
    "supernatants": [
        "supernatant"
    ],
    "toppings": [
        "topping"
    ],
    "uprooted": [
        "uproot"
    ],
    "uprooting": [
        "uproot"
    ],
    "uproots": [
        "uproot"
    ],
    "vegs": [
        "veg"
    ],
    "vegged": [
        "veg"
    ],
    "walpoles": [
        "walpole"
    ],
    "wavings": [
        "waving"
    ],
    "adverbs": [
        "adverb"
    ],
    "annals": [
        "annal"
    ],
    "asciis": [
        "ascii"
    ],
    "bodices": [
        "bodice"
    ],
    "bodiced": [
        "bodice"
    ],
    "boogieing": [
        "boogie"
    ],
    "boogies": [
        "boogie"
    ],
    "boogied": [
        "boogie"
    ],
    "checkpoints": [
        "checkpoint"
    ],
    "disentangled": [
        "disentangle"
    ],
    "disentangling": [
        "disentangle"
    ],
    "disentangles": [
        "disentangle"
    ],
    "dunkirks": [
        "dunkirk"
    ],
    "eastenders": [
        "eastender"
    ],
    "extrapolating": [
        "extrapolate"
    ],
    "extrapolated": [
        "extrapolate"
    ],
    "extrapolates": [
        "extrapolate"
    ],
    "hillaries": [
        "hillary"
    ],
    "inundated": [
        "inundate"
    ],
    "inundating": [
        "inundate"
    ],
    "inundates": [
        "inundate"
    ],
    "leftists": [
        "leftist"
    ],
    "marquesses": [
        "marquess"
    ],
    "mauled": [
        "maul"
    ],
    "mauls": [
        "maul"
    ],
    "mauling": [
        "maul"
    ],
    "microfilming": [
        "microfilm"
    ],
    "microfilmed": [
        "microfilm"
    ],
    "mimicks": [
        "mimick"
    ],
    "plywoods": [
        "plywood"
    ],
    "predictors": [
        "predictor"
    ],
    "scsis": [
        "scsi"
    ],
    "shortlisted": [
        "shortlist"
    ],
    "shortlists": [
        "shortlist"
    ],
    "shortlisting": [
        "shortlist"
    ],
    "stravinskies": [
        "stravinsky"
    ],
    "toffees": [
        "toffee"
    ],
    "tusks": [
        "tusk"
    ],
    "tusked": [
        "tusk"
    ],
    "wagers": [
        "wager"
    ],
    "wagered": [
        "wager"
    ],
    "wagering": [
        "wager"
    ],
    "agilities": [
        "agility"
    ],
    "apses": [
        "apse"
    ],
    "boms": [
        "bom"
    ],
    "budged": [
        "budge"
    ],
    "budging": [
        "budge"
    ],
    "budges": [
        "budge"
    ],
    "bullyings": [
        "bullying"
    ],
    "chieftains": [
        "chieftain"
    ],
    "daleks": [
        "dalek"
    ],
    "dats": [
        "dat"
    ],
    "educationalists": [
        "educationalist"
    ],
    "gbs": [
        "gb"
    ],
    "gces": [
        "gce"
    ],
    "hairdressings": [
        "hairdressing"
    ],
    "harking": [
        "hark"
    ],
    "harks": [
        "hark"
    ],
    "harked": [
        "hark"
    ],
    "intersected": [
        "intersect"
    ],
    "intersecting": [
        "intersect"
    ],
    "intersects": [
        "intersect"
    ],
    "junctures": [
        "juncture"
    ],
    "launchers": [
        "launcher"
    ],
    "louisianas": [
        "louisiana"
    ],
    "modernizing": [
        "modernize"
    ],
    "modernized": [
        "modernize"
    ],
    "modernizes": [
        "modernize"
    ],
    "newsomes": [
        "newsome"
    ],
    "poplars": [
        "poplar"
    ],
    "raskolnikovs": [
        "raskolnikov"
    ],
    "ricoes": [
        "rico"
    ],
    "slopping": [
        "slop"
    ],
    "slopped": [
        "slop"
    ],
    "slops": [
        "slop"
    ],
    "sofias": [
        "sofia"
    ],
    "southwests": [
        "southwest"
    ],
    "adens": [
        "aden"
    ],
    "aegeans": [
        "aegean"
    ],
    "ardss": [
        "ards"
    ],
    "bawled": [
        "bawl"
    ],
    "bawling": [
        "bawl"
    ],
    "bawls": [
        "bawl"
    ],
    "chasms": [
        "chasm"
    ],
    "chryslers": [
        "chrysler"
    ],
    "crevices": [
        "crevice"
    ],
    "creviced": [
        "crevice"
    ],
    "embalmers": [
        "embalmer"
    ],
    "encyclopedias": [
        "encyclopedia"
    ],
    "enraged": [
        "enrage"
    ],
    "enraging": [
        "enrage"
    ],
    "estonians": [
        "estonian"
    ],
    "eucharists": [
        "eucharist"
    ],
    "farmyards": [
        "farmyard"
    ],
    "firefighters": [
        "firefighter"
    ],
    "hulks": [
        "hulk"
    ],
    "hulked": [
        "hulk"
    ],
    "innovators": [
        "innovator"
    ],
    "intifadas": [
        "intifada"
    ],
    "landforms": [
        "landform"
    ],
    "magnetisms": [
        "magnetism"
    ],
    "makeups": [
        "makeup"
    ],
    "mirths": [
        "mirth"
    ],
    "neutralisations": [
        "neutralisation"
    ],
    "neviss": [
        "nevis"
    ],
    "outposts": [
        "outpost"
    ],
    "outposted": [
        "outpost"
    ],
    "paddings": [
        "padding"
    ],
    "parietals": [
        "parietal"
    ],
    "peddling": [
        "peddle"
    ],
    "peddled": [
        "peddle"
    ],
    "peddles": [
        "peddle"
    ],
    "ponss": [
        "pons"
    ],
    "protestantisms": [
        "protestantism"
    ],
    "raphaels": [
        "raphael"
    ],
    "ritzs": [
        "ritz"
    ],
    "rothschildren": [
        "rothschild"
    ],
    "silicas": [
        "silica"
    ],
    "steeles": [
        "steele"
    ],
    "stratospheres": [
        "stratosphere"
    ],
    "subtitled": [
        "subtitle"
    ],
    "subtitles": [
        "subtitle"
    ],
    "subtitling": [
        "subtitle"
    ],
    "toulice": [
        "toulouse"
    ],
    "tracksuits": [
        "tracksuit"
    ],
    "vagaries": [
        "vagary"
    ],
    "wallers": [
        "waller"
    ],
    "amaranths": [
        "amaranth"
    ],
    "anaesthesias": [
        "anaesthesia"
    ],
    "ced": [
        "ce"
    ],
    "cynics": [
        "cynic"
    ],
    "dispensations": [
        "dispensation"
    ],
    "epidemiologies": [
        "epidemiology"
    ],
    "firelights": [
        "firelight"
    ],
    "formalized": [
        "formalize"
    ],
    "formalizing": [
        "formalize"
    ],
    "formalizes": [
        "formalize"
    ],
    "friezes": [
        "frieze"
    ],
    "hitchcocks": [
        "hitchcock"
    ],
    "hobs": [
        "hob"
    ],
    "kickings": [
        "kicking"
    ],
    "lokking": [
        "lok"
    ],
    "placarded": [
        "placard"
    ],
    "placarding": [
        "placard"
    ],
    "quietened": [
        "quieten"
    ],
    "quietening": [
        "quieten"
    ],
    "quietens": [
        "quieten"
    ],
    "rinks": [
        "rink"
    ],
    "rinking": [
        "rink"
    ],
    "seniorities": [
        "seniority"
    ],
    "sensings": [
        "sensing"
    ],
    "soggiest": [
        "soggy"
    ],
    "soggier": [
        "soggy"
    ],
    "spliced": [
        "splice"
    ],
    "splicing": [
        "splice"
    ],
    "splices": [
        "splice"
    ],
    "stealths": [
        "stealth"
    ],
    "surmised": [
        "surmise"
    ],
    "surmises": [
        "surmise"
    ],
    "surmising": [
        "surmise"
    ],
    "thymes": [
        "thyme"
    ],
    "tolstoys": [
        "tolstoy"
    ],
    "usurped": [
        "usurp"
    ],
    "usurping": [
        "usurp"
    ],
    "usurps": [
        "usurp"
    ],
    "bahrains": [
        "bahrain"
    ],
    "chairpersons": [
        "chairperson"
    ],
    "craftier": [
        "crafty"
    ],
    "craftiest": [
        "crafty"
    ],
    "cvs": [
        "cv"
    ],
    "cv's": [
        "cv"
    ],
    "datasets": [
        "dataset"
    ],
    "dowries": [
        "dowry"
    ],
    "forfeitures": [
        "forfeiture"
    ],
    "greeneries": [
        "greenery"
    ],
    "hypertexts": [
        "hypertext"
    ],
    "iccs": [
        "icc"
    ],
    "inpatients": [
        "inpatient"
    ],
    "jehovahs": [
        "jehovah"
    ],
    "malis": [
        "mali"
    ],
    "malpractices": [
        "malpractice"
    ],
    "mayhems": [
        "mayhem"
    ],
    "mbs": [
        "mb"
    ],
    "mbest": [
        "mb"
    ],
    "minches": [
        "minch"
    ],
    "monsoons": [
        "monsoon"
    ],
    "newfoundlands": [
        "newfoundland"
    ],
    "obviates": [
        "obviate"
    ],
    "obviating": [
        "obviate"
    ],
    "obviated": [
        "obviate"
    ],
    "overseers": [
        "overseer"
    ],
    "placated": [
        "placate"
    ],
    "placating": [
        "placate"
    ],
    "placates": [
        "placate"
    ],
    "railroads": [
        "railroad"
    ],
    "railroaded": [
        "railroad"
    ],
    "railroading": [
        "railroad"
    ],
    "rooftops": [
        "rooftop"
    ],
    "rooftopping": [
        "rooftop"
    ],
    "scrutinized": [
        "scrutinize"
    ],
    "scrutinizing": [
        "scrutinize"
    ],
    "scrutinizes": [
        "scrutinize"
    ],
    "serenities": [
        "serenity"
    ],
    "spurned": [
        "spurn"
    ],
    "spurns": [
        "spurn"
    ],
    "spurning": [
        "spurn"
    ],
    "tristrams": [
        "tristram"
    ],
    "wads": [
        "wad"
    ],
    "wadded": [
        "wad"
    ],
    "waveforms": [
        "waveform"
    ],
    "workmates": [
        "workmate"
    ],
    "adenomas": [
        "adenoma"
    ],
    "affixed": [
        "affix"
    ],
    "affixes": [
        "affix"
    ],
    "affixing": [
        "affix"
    ],
    "backbenches": [
        "backbench"
    ],
    "barometers": [
        "barometer"
    ],
    "crayoning": [
        "crayon"
    ],
    "crayoned": [
        "crayon"
    ],
    "daleys": [
        "daley"
    ],
    "dashboards": [
        "dashboard"
    ],
    "disablements": [
        "disablement"
    ],
    "electrifications": [
        "electrification"
    ],
    "federalisms": [
        "federalism"
    ],
    "flaunting": [
        "flaunt"
    ],
    "flaunted": [
        "flaunt"
    ],
    "flaunts": [
        "flaunt"
    ],
    "funking": [
        "funk"
    ],
    "funked": [
        "funk"
    ],
    "funks": [
        "funk"
    ],
    "futilities": [
        "futility"
    ],
    "gauntlets": [
        "gauntlet"
    ],
    "ged": [
        "ge"
    ],
    "ging": [
        "ge"
    ],
    "glees": [
        "glee"
    ],
    "gonorrhoeas": [
        "gonorrhoea"
    ],
    "grimms": [
        "grimm"
    ],
    "immediacies": [
        "immediacy"
    ],
    "meditating": [
        "meditate"
    ],
    "meditated": [
        "meditate"
    ],
    "meditates": [
        "meditate"
    ],
    "midwinters": [
        "midwinter"
    ],
    "misinterpreted": [
        "misinterpret"
    ],
    "misinterprets": [
        "misinterpret"
    ],
    "misinterpreting": [
        "misinterpret"
    ],
    "preservatives": [
        "preservative"
    ],
    "puberties": [
        "puberty"
    ],
    "pullovers": [
        "pullover"
    ],
    "reneged": [
        "renege"
    ],
    "reneging": [
        "renege"
    ],
    "reneges": [
        "renege"
    ],
    "renegeing": [
        "renege"
    ],
    "routers": [
        "router"
    ],
    "routered": [
        "router"
    ],
    "sociolinguistics": [
        "sociolinguistic"
    ],
    "suitors": [
        "suitor"
    ],
    "sukarnoes": [
        "sukarno"
    ],
    "surcharged": [
        "surcharge"
    ],
    "surcharging": [
        "surcharge"
    ],
    "testers": [
        "tester"
    ],
    "towpaths": [
        "towpath"
    ],
    "twirled": [
        "twirl"
    ],
    "twirling": [
        "twirl"
    ],
    "twirls": [
        "twirl"
    ],
    "zodiacs": [
        "zodiac"
    ],
    "airings": [
        "airing"
    ],
    "atrophied": [
        "atrophy"
    ],
    "atrophying": [
        "atrophy"
    ],
    "bandings": [
        "banding"
    ],
    "blockbusters": [
        "blockbuster"
    ],
    "burgled": [
        "burgle"
    ],
    "burgling": [
        "burgle"
    ],
    "burgles": [
        "burgle"
    ],
    "collocations": [
        "collocation"
    ],
    "cowans": [
        "cowan"
    ],
    "disobeyed": [
        "disobey"
    ],
    "disobeying": [
        "disobey"
    ],
    "disobeys": [
        "disobey"
    ],
    "elisas": [
        "elisa"
    ],
    "engrossed": [
        "engross"
    ],
    "engrossing": [
        "engross"
    ],
    "eyeballs": [
        "eyeball"
    ],
    "filmmakers": [
        "filmmaker"
    ],
    "harlequins": [
        "harlequin"
    ],
    "harmonisations": [
        "harmonisation"
    ],
    "hirings": [
        "hiring"
    ],
    "internments": [
        "internment"
    ],
    "interventionists": [
        "interventionist"
    ],
    "jacobss": [
        "jacobs"
    ],
    "lacunae": [
        "lacuna"
    ],
    "meekest": [
        "meek"
    ],
    "meeker": [
        "meek"
    ],
    "milieus": [
        "milieu"
    ],
    "misdemeanours": [
        "misdemeanour"
    ],
    "mishaps": [
        "mishap"
    ],
    "montenegroes": [
        "montenegro"
    ],
    "parrs": [
        "parr"
    ],
    "penniness": [
        "pennines"
    ],
    "pisas": [
        "pisa"
    ],
    "quarantined": [
        "quarantine"
    ],
    "quarantines": [
        "quarantine"
    ],
    "quarantining": [
        "quarantine"
    ],
    "revitalised": [
        "revitalise"
    ],
    "revitalising": [
        "revitalise"
    ],
    "revitalises": [
        "revitalise"
    ],
    "severances": [
        "severance"
    ],
    "slanders": [
        "slander"
    ],
    "slandered": [
        "slander"
    ],
    "slandering": [
        "slander"
    ],
    "subterraneans": [
        "subterranean"
    ],
    "sunflowers": [
        "sunflower"
    ],
    "sweatshirts": [
        "sweatshirt"
    ],
    "tangs": [
        "tang"
    ],
    "transposed": [
        "transpose"
    ],
    "transposing": [
        "transpose"
    ],
    "u.s.a.s": [
        "u.s.a."
    ],
    "waders": [
        "wader"
    ],
    "wallowing": [
        "wallow"
    ],
    "wallowed": [
        "wallow"
    ],
    "wallows": [
        "wallow"
    ],
    "barbicans": [
        "barbican"
    ],
    "bedrocked": [
        "bedrock"
    ],
    "bedrocks": [
        "bedrock"
    ],
    "beeps": [
        "beep"
    ],
    "beeping": [
        "beep"
    ],
    "beeped": [
        "beep"
    ],
    "blizzarding": [
        "blizzard"
    ],
    "blizzarded": [
        "blizzard"
    ],
    "candidas": [
        "candida"
    ],
    "canted": [
        "cant"
    ],
    "canting": [
        "cant"
    ],
    "cants": [
        "cant"
    ],
    "channing": [
        "chan"
    ],
    "christchurches": [
        "christchurch"
    ],
    "clothiers": [
        "clothier"
    ],
    "creepings": [
        "creeping"
    ],
    "doctorates": [
        "doctorate"
    ],
    "eires": [
        "eire"
    ],
    "furores": [
        "furore"
    ],
    "gists": [
        "gist"
    ],
    "hilts": [
        "hilt"
    ],
    "hinduisms": [
        "hinduism"
    ],
    "hybridizations": [
        "hybridization"
    ],
    "mavericks": [
        "maverick"
    ],
    "medallions": [
        "medallion"
    ],
    "morphines": [
        "morphine"
    ],
    "olympuss": [
        "olympus"
    ],
    "pedagogies": [
        "pedagogy"
    ],
    "photosyntheses": [
        "photosynthesis"
    ],
    "prostates": [
        "prostate"
    ],
    "radons": [
        "radon"
    ],
    "reindeers": [
        "reindeer"
    ],
    "reindeer": [
        "reindeer"
    ],
    "responsivenesses": [
        "responsiveness"
    ],
    "retardations": [
        "retardation"
    ],
    "shakings": [
        "shaking"
    ],
    "slumbers": [
        "slumber"
    ],
    "slumbering": [
        "slumber"
    ],
    "slumbered": [
        "slumber"
    ],
    "spacecrafts": [
        "spacecraft"
    ],
    "subways": [
        "subway"
    ],
    "technoes": [
        "techno"
    ],
    "thermostatted": [
        "thermostat"
    ],
    "trespassers": [
        "trespasser"
    ],
    "tripods": [
        "tripod"
    ],
    "tripodding": [
        "tripod"
    ],
    "unpopularities": [
        "unpopularity"
    ],
    "vestries": [
        "vestry"
    ],
    "bootling": [
        "bootle"
    ],
    "bumbling": [
        "bumble"
    ],
    "bumbled": [
        "bumble"
    ],
    "bumbles": [
        "bumble"
    ],
    "bumpier": [
        "bumpy"
    ],
    "bumpiest": [
        "bumpy"
    ],
    "candlelights": [
        "candlelight"
    ],
    "celts": [
        "celt"
    ],
    "chardonnays": [
        "chardonnay"
    ],
    "cirrhoses": [
        "cirrhosis"
    ],
    "darcies": [
        "darcy"
    ],
    "delineated": [
        "delineate"
    ],
    "delineates": [
        "delineate"
    ],
    "delineating": [
        "delineate"
    ],
    "emissaries": [
        "emissary"
    ],
    "foggiest": [
        "foggy"
    ],
    "foggier": [
        "foggy"
    ],
    "howlings": [
        "howling"
    ],
    "kissings": [
        "kissing"
    ],
    "lttes": [
        "ltte"
    ],
    "lutherans": [
        "lutheran"
    ],
    "marooned": [
        "maroon"
    ],
    "maroons": [
        "maroon"
    ],
    "marooning": [
        "maroon"
    ],
    "monroes": [
        "monroe"
    ],
    "mws": [
        "mw"
    ],
    "packers": [
        "packer"
    ],
    "parallelisms": [
        "parallelism"
    ],
    "pattered": [
        "patter"
    ],
    "pattering": [
        "patter"
    ],
    "patters": [
        "patter"
    ],
    "pegasuss": [
        "pegasus"
    ],
    "prophesied": [
        "prophesy"
    ],
    "prophesying": [
        "prophesy"
    ],
    "prophesies": [
        "prophesy"
    ],
    "rcas": [
        "rca"
    ],
    "sitings": [
        "siting"
    ],
    "socioeconomics": [
        "socioeconomic"
    ],
    "socratess": [
        "socrates"
    ],
    "taloned": [
        "talon"
    ],
    "trotskies": [
        "trotsky"
    ],
    "tumblers": [
        "tumbler"
    ],
    "unsolder": [
        "unsold"
    ],
    "valiants": [
        "valiant"
    ],
    "virginities": [
        "virginity"
    ],
    "warblers": [
        "warbler"
    ],
    "wickednesses": [
        "wickedness"
    ],
    "adjutants": [
        "adjutant"
    ],
    "andeans": [
        "andean"
    ],
    "aws": [
        "aw"
    ],
    "burrs": [
        "burr"
    ],
    "burred": [
        "burr"
    ],
    "burring": [
        "burr"
    ],
    "centralizations": [
        "centralization"
    ],
    "centrifuged": [
        "centrifuge"
    ],
    "centrifuging": [
        "centrifuge"
    ],
    "counterbalanced": [
        "counterbalance"
    ],
    "counterbalancing": [
        "counterbalance"
    ],
    "counterbalances": [
        "counterbalance"
    ],
    "counterfeiting": [
        "counterfeit"
    ],
    "counterfeits": [
        "counterfeit"
    ],
    "counterfeited": [
        "counterfeit"
    ],
    "curds": [
        "curd"
    ],
    "curded": [
        "curd"
    ],
    "enunciated": [
        "enunciate"
    ],
    "enunciating": [
        "enunciate"
    ],
    "enunciates": [
        "enunciate"
    ],
    "fundholders": [
        "fundholder"
    ],
    "gasconies": [
        "gascony"
    ],
    "gaudies": [
        "gaudy"
    ],
    "gaudiest": [
        "gaudy"
    ],
    "gaudier": [
        "gaudy"
    ],
    "germanics": [
        "germanic"
    ],
    "goaded": [
        "goad"
    ],
    "goading": [
        "goad"
    ],
    "goads": [
        "goad"
    ],
    "harmonised": [
        "harmonise"
    ],
    "harmonising": [
        "harmonise"
    ],
    "hermitages": [
        "hermitage"
    ],
    "ips": [
        "ip"
    ],
    "jingling": [
        "jingle"
    ],
    "jingled": [
        "jingle"
    ],
    "joists": [
        "joist"
    ],
    "joisted": [
        "joist"
    ],
    "knockers": [
        "knocker"
    ],
    "mongolians": [
        "mongolian"
    ],
    "oass": [
        "oas"
    ],
    "penultimates": [
        "penultimate"
    ],
    "playbacks": [
        "playback"
    ],
    "polarities": [
        "polarity"
    ],
    "presidiums": [
        "presidium"
    ],
    "proverbials": [
        "proverbial"
    ],
    "reassessments": [
        "reassessment"
    ],
    "sanctities": [
        "sanctity"
    ],
    "sanitations": [
        "sanitation"
    ],
    "solaced": [
        "solace"
    ],
    "solaces": [
        "solace"
    ],
    "solacing": [
        "solace"
    ],
    "wearinesses": [
        "weariness"
    ],
    "aggressors": [
        "aggressor"
    ],
    "alleles": [
        "allele"
    ],
    "apothecaries": [
        "apothecary"
    ],
    "cains": [
        "cain"
    ],
    "ceded": [
        "cede"
    ],
    "ceding": [
        "cede"
    ],
    "cocooned": [
        "cocoon"
    ],
    "cocoons": [
        "cocoon"
    ],
    "cocooning": [
        "cocoon"
    ],
    "coerced": [
        "coerce"
    ],
    "coercing": [
        "coerce"
    ],
    "coerces": [
        "coerce"
    ],
    "consecrated": [
        "consecrate"
    ],
    "consecrating": [
        "consecrate"
    ],
    "consecrates": [
        "consecrate"
    ],
    "cravings": [
        "craving"
    ],
    "davenports": [
        "davenport"
    ],
    "eclectics": [
        "eclectic"
    ],
    "entangled": [
        "entangle"
    ],
    "entangling": [
        "entangle"
    ],
    "entangles": [
        "entangle"
    ],
    "exasperated": [
        "exasperate"
    ],
    "exasperating": [
        "exasperate"
    ],
    "exasperates": [
        "exasperate"
    ],
    "exons": [
        "exon"
    ],
    "feudalisms": [
        "feudalism"
    ],
    "gaits": [
        "gait"
    ],
    "grandstands": [
        "grandstand"
    ],
    "grandstanding": [
        "grandstand"
    ],
    "hanois": [
        "hanoi"
    ],
    "isaiahs": [
        "isaiah"
    ],
    "kneading": [
        "knead"
    ],
    "kneaded": [
        "knead"
    ],
    "kneads": [
        "knead"
    ],
    "lores": [
        "lore"
    ],
    "memorabilias": [
        "memorabilia"
    ],
    "optimists": [
        "optimist"
    ],
    "passivities": [
        "passivity"
    ],
    "petticoats": [
        "petticoat"
    ],
    "platters": [
        "platter"
    ],
    "preamps": [
        "preamp"
    ],
    "preventatives": [
        "preventative"
    ],
    "reciprocated": [
        "reciprocate"
    ],
    "reciprocating": [
        "reciprocate"
    ],
    "reciprocates": [
        "reciprocate"
    ],
    "recklessnesses": [
        "recklessness"
    ],
    "rooks": [
        "rook"
    ],
    "rooked": [
        "rook"
    ],
    "rooking": [
        "rook"
    ],
    "saxonies": [
        "saxony"
    ],
    "socialising": [
        "socialise"
    ],
    "socialised": [
        "socialise"
    ],
    "socialises": [
        "socialise"
    ],
    "spawnings": [
        "spawning"
    ],
    "sulphides": [
        "sulphide"
    ],
    "teherans": [
        "teheran"
    ],
    "universalities": [
        "universality"
    ],
    "upkeeps": [
        "upkeep"
    ],
    "waites": [
        "waite"
    ],
    "werewolves": [
        "werewolf"
    ],
    "westlands": [
        "westland"
    ],
    "whirlwinds": [
        "whirlwind"
    ],
    "aphids": [
        "aphid"
    ],
    "arkansass": [
        "arkansas"
    ],
    "ballistics": [
        "ballistic"
    ],
    "barmaiding": [
        "barmaid"
    ],
    "bathings": [
        "bathing"
    ],
    "blasphemies": [
        "blasphemy"
    ],
    "brats": [
        "brat"
    ],
    "bridals": [
        "bridal"
    ],
    "candidacies": [
        "candidacy"
    ],
    "clarksons": [
        "clarkson"
    ],
    "colomboes": [
        "colombo"
    ],
    "conservancies": [
        "conservancy"
    ],
    "conveners": [
        "convener"
    ],
    "crucified": [
        "crucify"
    ],
    "crucifying": [
        "crucify"
    ],
    "geordies": [
        "geordie"
    ],
    "homers": [
        "homer"
    ],
    "inanimates": [
        "inanimate"
    ],
    "jaggers": [
        "jagger"
    ],
    "lathes": [
        "lathe"
    ],
    "marchers": [
        "marcher"
    ],
    "nymphs": [
        "nymph"
    ],
    "pollarding": [
        "pollard"
    ],
    "pollarded": [
        "pollard"
    ],
    "pollards": [
        "pollard"
    ],
    "preachings": [
        "preaching"
    ],
    "qaing": [
        "qa"
    ],
    "reagents": [
        "reagent"
    ],
    "reciprocities": [
        "reciprocity"
    ],
    "rehabilitated": [
        "rehabilitate"
    ],
    "rehabilitating": [
        "rehabilitate"
    ],
    "rehabilitates": [
        "rehabilitate"
    ],
    "ricardoes": [
        "ricardo"
    ],
    "scrawled": [
        "scrawl"
    ],
    "scrawls": [
        "scrawl"
    ],
    "scrawling": [
        "scrawl"
    ],
    "screenplays": [
        "screenplay"
    ],
    "spindles": [
        "spindle"
    ],
    "spindling": [
        "spindle"
    ],
    "squareds": [
        "squared"
    ],
    "strachs": [
        "strach"
    ],
    "temping": [
        "temp"
    ],
    "temped": [
        "temp"
    ],
    "tsarists": [
        "tsarist"
    ],
    "watchmen": [
        "watchman"
    ],
    "afars": [
        "afar"
    ],
    "bairns": [
        "bairn"
    ],
    "belmonts": [
        "belmont"
    ],
    "bulldozered": [
        "bulldozer"
    ],
    "cuddlier": [
        "cuddly"
    ],
    "cuddliest": [
        "cuddly"
    ],
    "deweys": [
        "dewey"
    ],
    "diaphragms": [
        "diaphragm"
    ],
    "fls": [
        "fl"
    ],
    "fler": [
        "fl"
    ],
    "flukes": [
        "fluke"
    ],
    "fluked": [
        "fluke"
    ],
    "fruitiest": [
        "fruity"
    ],
    "grimier": [
        "grimy"
    ],
    "hoorays": [
        "hooray"
    ],
    "horseshoes": [
        "horseshoe"
    ],
    "incinerations": [
        "incineration"
    ],
    "jps": [
        "jp"
    ],
    "knitwears": [
        "knitwear"
    ],
    "mascaras": [
        "mascara"
    ],
    "mayers": [
        "mayer"
    ],
    "monotonies": [
        "monotony"
    ],
    "oakleys": [
        "oakley"
    ],
    "pestered": [
        "pester"
    ],
    "pestering": [
        "pester"
    ],
    "pesters": [
        "pester"
    ],
    "plovers": [
        "plover"
    ],
    "polyethylenes": [
        "polyethylene"
    ],
    "polynomials": [
        "polynomial"
    ],
    "puzzlements": [
        "puzzlement"
    ],
    "reflectors": [
        "reflector"
    ],
    "reimbursements": [
        "reimbursement"
    ],
    "sauls": [
        "saul"
    ],
    "seconders": [
        "seconder"
    ],
    "slimier": [
        "slimy"
    ],
    "slimiest": [
        "slimy"
    ],
    "sustainabilities": [
        "sustainability"
    ],
    "sutured": [
        "suture"
    ],
    "suturing": [
        "suture"
    ],
    "tennessees": [
        "tennessee"
    ],
    "totalitarians": [
        "totalitarian"
    ],
    "tunings": [
        "tuning"
    ],
    "turins": [
        "turin"
    ],
    "videotapes": [
        "videotape"
    ],
    "videotaped": [
        "videotape"
    ],
    "videotaping": [
        "videotape"
    ],
    "videotapeing": [
        "videotape"
    ],
    "videotapeed": [
        "videotape"
    ],
    "acquiesced": [
        "acquiesce"
    ],
    "acquiescing": [
        "acquiesce"
    ],
    "anathemas": [
        "anathema"
    ],
    "authorizations": [
        "authorization"
    ],
    "axons": [
        "axon"
    ],
    "backfired": [
        "backfire"
    ],
    "backfires": [
        "backfire"
    ],
    "backfiring": [
        "backfire"
    ],
    "befits": [
        "befit"
    ],
    "befitted": [
        "befit"
    ],
    "befitting": [
        "befit"
    ],
    "birks": [
        "birk"
    ],
    "borneos": [
        "borneo"
    ],
    "bowers": [
        "bower"
    ],
    "bowering": [
        "bower"
    ],
    "broached": [
        "broach"
    ],
    "broaching": [
        "broach"
    ],
    "broaches": [
        "broach"
    ],
    "celibacies": [
        "celibacy"
    ],
    "copts": [
        "copt"
    ],
    "deluged": [
        "deluge"
    ],
    "deluging": [
        "deluge"
    ],
    "dixies": [
        "dixie"
    ],
    "druids": [
        "druid"
    ],
    "epitomised": [
        "epitomise"
    ],
    "epitomises": [
        "epitomise"
    ],
    "epitomising": [
        "epitomise"
    ],
    "haulier": [
        "hauly"
    ],
    "inexperienced": [
        "inexperience"
    ],
    "interoperabilities": [
        "interoperability"
    ],
    "kaisers": [
        "kaiser"
    ],
    "maviss": [
        "mavis"
    ],
    "pallets": [
        "pallet"
    ],
    "penances": [
        "penance"
    ],
    "permians": [
        "permian"
    ],
    "phrasings": [
        "phrasing"
    ],
    "quaking": [
        "quake"
    ],
    "quakes": [
        "quake"
    ],
    "quaked": [
        "quake"
    ],
    "raleighs": [
        "raleigh"
    ],
    "relaunched": [
        "relaunch"
    ],
    "relaunching": [
        "relaunch"
    ],
    "relaunches": [
        "relaunch"
    ],
    "revolutionised": [
        "revolutionise"
    ],
    "revolutionising": [
        "revolutionise"
    ],
    "revolutionises": [
        "revolutionise"
    ],
    "slimes": [
        "slime"
    ],
    "slimed": [
        "slime"
    ],
    "sliming": [
        "slime"
    ],
    "stoneworks": [
        "stonework"
    ],
    "tchaikovskies": [
        "tchaikovsky"
    ],
    "thorniest": [
        "thorny"
    ],
    "thornier": [
        "thorny"
    ],
    "transporters": [
        "transporter"
    ],
    "adaptabilities": [
        "adaptability"
    ],
    "anwars": [
        "anwar"
    ],
    "assailed": [
        "assail"
    ],
    "assailing": [
        "assail"
    ],
    "assails": [
        "assail"
    ],
    "auvergnes": [
        "auvergne"
    ],
    "axioms": [
        "axiom"
    ],
    "bards": [
        "bard"
    ],
    "barded": [
        "bard"
    ],
    "barding": [
        "bard"
    ],
    "bels": [
        "bel"
    ],
    "bowmen": [
        "bowman"
    ],
    "bowmans": [
        "bowman"
    ],
    "buoyancies": [
        "buoyancy"
    ],
    "capacitances": [
        "capacitance"
    ],
    "cowering": [
        "cower"
    ],
    "cowered": [
        "cower"
    ],
    "cowers": [
        "cower"
    ],
    "crematoria": [
        "crematorium"
    ],
    "crematoriums": [
        "crematorium"
    ],
    "crusties": [
        "crusty"
    ],
    "crustier": [
        "crusty"
    ],
    "crustiest": [
        "crusty"
    ],
    "dhas": [
        "dha"
    ],
    "embellished": [
        "embellish"
    ],
    "embellishing": [
        "embellish"
    ],
    "embellishes": [
        "embellish"
    ],
    "esps": [
        "esp"
    ],
    "forewords": [
        "foreword"
    ],
    "hadrians": [
        "hadrian"
    ],
    "haggards": [
        "haggard"
    ],
    "heterogeneities": [
        "heterogeneity"
    ],
    "immoralities": [
        "immorality"
    ],
    "interconnected": [
        "interconnect"
    ],
    "interconnects": [
        "interconnect"
    ],
    "interconnecting": [
        "interconnect"
    ],
    "interconnections": [
        "interconnection"
    ],
    "invalidities": [
        "invalidity"
    ],
    "mammas": [
        "mamma"
    ],
    "microorganisms": [
        "microorganism"
    ],
    "monets": [
        "monet"
    ],
    "ostriches": [
        "ostrich"
    ],
    "pathogens": [
        "pathogen"
    ],
    "pings": [
        "ping"
    ],
    "pinging": [
        "ping"
    ],
    "pinged": [
        "ping"
    ],
    "porticos": [
        "portico"
    ],
    "psychedelics": [
        "psychedelic"
    ],
    "renunciations": [
        "renunciation"
    ],
    "ringed": [
        "ringe"
    ],
    "ringes": [
        "ringe"
    ],
    "schedulings": [
        "scheduling"
    ],
    "seines": [
        "seine"
    ],
    "seining": [
        "seine"
    ],
    "seined": [
        "seine"
    ],
    "songwriters": [
        "songwriter"
    ],
    "statisticians": [
        "statistician"
    ],
    "unwinding": [
        "unwind"
    ],
    "unwinds": [
        "unwind"
    ],
    "unwound": [
        "unwind"
    ],
    "acetates": [
        "acetate"
    ],
    "achesons": [
        "acheson"
    ],
    "bairds": [
        "baird"
    ],
    "bridegrooms": [
        "bridegroom"
    ],
    "butches": [
        "butch"
    ],
    "butching": [
        "butch"
    ],
    "christendoms": [
        "christendom"
    ],
    "cloviss": [
        "clovis"
    ],
    "cobblers": [
        "cobbler"
    ],
    "disraelis": [
        "disraeli"
    ],
    "dourest": [
        "dour"
    ],
    "elgars": [
        "elgar"
    ],
    "emergents": [
        "emergent"
    ],
    "fondnesses": [
        "fondness"
    ],
    "foursomes": [
        "foursome"
    ],
    "gobbled": [
        "gobble"
    ],
    "gobbling": [
        "gobble"
    ],
    "gobbles": [
        "gobble"
    ],
    "guernseys": [
        "guernsey"
    ],
    "maidenheads": [
        "maidenhead"
    ],
    "mannerisms": [
        "mannerism"
    ],
    "maskings": [
        "masking"
    ],
    "merlins": [
        "merlin"
    ],
    "mired": [
        "mire"
    ],
    "miring": [
        "mire"
    ],
    "pampered": [
        "pamper"
    ],
    "pampers": [
        "pamper"
    ],
    "pampering": [
        "pamper"
    ],
    "playboys": [
        "playboy"
    ],
    "poohed": [
        "pooh"
    ],
    "poohs": [
        "pooh"
    ],
    "resurfaced": [
        "resurface"
    ],
    "resurfacing": [
        "resurface"
    ],
    "resurfaces": [
        "resurface"
    ],
    "stringers": [
        "stringer"
    ],
    "thingies": [
        "thingy"
    ],
    "thingys": [
        "thingy"
    ],
    "tottered": [
        "totter"
    ],
    "tottering": [
        "totter"
    ],
    "totters": [
        "totter"
    ],
    "typologies": [
        "typology"
    ],
    "understated": [
        "understate"
    ],
    "understates": [
        "understate"
    ],
    "understating": [
        "understate"
    ],
    "upshots": [
        "upshot"
    ],
    "wellies": [
        "welly"
    ],
    "wellied": [
        "welly"
    ],
    "wellying": [
        "welly"
    ],
    "wellyed": [
        "welly"
    ],
    "wildfowls": [
        "wildfowl"
    ],
    "adriatics": [
        "adriatic"
    ],
    "afterthoughts": [
        "afterthought"
    ],
    "bariums": [
        "barium"
    ],
    "bloodsheds": [
        "bloodshed"
    ],
    "broths": [
        "broth"
    ],
    "busters": [
        "buster"
    ],
    "citruss": [
        "citrus"
    ],
    "drafters": [
        "drafter"
    ],
    "elations": [
        "elation"
    ],
    "excerpts": [
        "excerpt"
    ],
    "excerpted": [
        "excerpt"
    ],
    "excerpting": [
        "excerpt"
    ],
    "feigning": [
        "feign"
    ],
    "feigned": [
        "feign"
    ],
    "feigns": [
        "feign"
    ],
    "harpsichords": [
        "harpsichord"
    ],
    "inactivities": [
        "inactivity"
    ],
    "jungs": [
        "jung"
    ],
    "languishing": [
        "languish"
    ],
    "languished": [
        "languish"
    ],
    "languishes": [
        "languish"
    ],
    "microelectronicss": [
        "microelectronics"
    ],
    "minnesotas": [
        "minnesota"
    ],
    "nourishments": [
        "nourishment"
    ],
    "oscillating": [
        "oscillate"
    ],
    "oscillates": [
        "oscillate"
    ],
    "oscillated": [
        "oscillate"
    ],
    "palladiums": [
        "palladium"
    ],
    "pretenders": [
        "pretender"
    ],
    "pretender's": [
        "pretender"
    ],
    "priestleys": [
        "priestley"
    ],
    "privatized": [
        "privatize"
    ],
    "privatizing": [
        "privatize"
    ],
    "privatizes": [
        "privatize"
    ],
    "roadworks": [
        "roadwork"
    ],
    "salvadoreans": [
        "salvadorean"
    ],
    "shackles": [
        "shackle"
    ],
    "shackled": [
        "shackle"
    ],
    "shackling": [
        "shackle"
    ],
    "shanks": [
        "shank"
    ],
    "shanked": [
        "shank"
    ],
    "snowballs": [
        "snowball"
    ],
    "snowballing": [
        "snowball"
    ],
    "snowballed": [
        "snowball"
    ],
    "spokes": [
        "spoke"
    ],
    "spoked": [
        "spoke"
    ],
    "spoking": [
        "spoke"
    ],
    "spoonfuls": [
        "spoonful"
    ],
    "spoonsful": [
        "spoonful"
    ],
    "springboards": [
        "springboard"
    ],
    "steppings": [
        "stepping"
    ],
    "sungs": [
        "sung"
    ],
    "trestles": [
        "trestle"
    ],
    "vanes": [
        "vane"
    ],
    "virtuosi": [
        "virtuoso"
    ],
    "virtuosos": [
        "virtuoso"
    ],
    "antiseptics": [
        "antiseptic"
    ],
    "artiest": [
        "arty"
    ],
    "backyards": [
        "backyard"
    ],
    "bookers": [
        "booker"
    ],
    "bookering": [
        "booker"
    ],
    "bradburies": [
        "bradbury"
    ],
    "cheetahs": [
        "cheetah"
    ],
    "clammed": [
        "clam"
    ],
    "clamming": [
        "clam"
    ],
    "collectings": [
        "collecting"
    ],
    "currans": [
        "curran"
    ],
    "disreputes": [
        "disrepute"
    ],
    "dithering": [
        "dither"
    ],
    "dithered": [
        "dither"
    ],
    "dithers": [
        "dither"
    ],
    "drunkennesses": [
        "drunkenness"
    ],
    "dyslexias": [
        "dyslexia"
    ],
    "embalming": [
        "embalm"
    ],
    "embalmed": [
        "embalm"
    ],
    "embalms": [
        "embalm"
    ],
    "fingerboards": [
        "fingerboard"
    ],
    "fondas": [
        "fonda"
    ],
    "gainsboroughs": [
        "gainsborough"
    ],
    "gatehouses": [
        "gatehouse"
    ],
    "gcs": [
        "gc"
    ],
    "generalists": [
        "generalist"
    ],
    "grinnings": [
        "grinning"
    ],
    "havanas": [
        "havana"
    ],
    "inciting": [
        "incite"
    ],
    "incited": [
        "incite"
    ],
    "incompatibilities": [
        "incompatibility"
    ],
    "jasmines": [
        "jasmine"
    ],
    "knighthoods": [
        "knighthood"
    ],
    "kuhns": [
        "kuhn"
    ],
    "laminas": [
        "lamina"
    ],
    "mackerels": [
        "mackerel"
    ],
    "mackerelled": [
        "mackerel"
    ],
    "maestros": [
        "maestro"
    ],
    "manipulatives": [
        "manipulative"
    ],
    "oedipuss": [
        "oedipus"
    ],
    "pows": [
        "pow"
    ],
    "preconceptions": [
        "preconception"
    ],
    "radiocarbons": [
        "radiocarbon"
    ],
    "reverbs": [
        "reverb"
    ],
    "slownesses": [
        "slowness"
    ],
    "snuggled": [
        "snuggle"
    ],
    "snuggling": [
        "snuggle"
    ],
    "snuggles": [
        "snuggle"
    ],
    "sumners": [
        "sumner"
    ],
    "supplementations": [
        "supplementation"
    ],
    "watersports": [
        "watersport"
    ],
    "watersporting": [
        "watersport"
    ],
    "whitenesses": [
        "whiteness"
    ],
    "whittled": [
        "whittle"
    ],
    "whittling": [
        "whittle"
    ],
    "whittles": [
        "whittle"
    ],
    "adenauers": [
        "adenauer"
    ],
    "aggravations": [
        "aggravation"
    ],
    "anglos": [
        "anglo"
    ],
    "auroras": [
        "aurora"
    ],
    "bayonets": [
        "bayonet"
    ],
    "bayonetted": [
        "bayonet"
    ],
    "bayoneting": [
        "bayonet"
    ],
    "bayoneted": [
        "bayonet"
    ],
    "brutuss": [
        "brutus"
    ],
    "bubblings": [
        "bubbling"
    ],
    "chancels": [
        "chancel"
    ],
    "copses": [
        "copse"
    ],
    "corduroys": [
        "corduroy"
    ],
    "cytokines": [
        "cytokine"
    ],
    "defamations": [
        "defamation"
    ],
    "denvers": [
        "denver"
    ],
    "embroiled": [
        "embroil"
    ],
    "embroiling": [
        "embroil"
    ],
    "embroils": [
        "embroil"
    ],
    "existents": [
        "existent"
    ],
    "extolling": [
        "extol"
    ],
    "extolled": [
        "extol"
    ],
    "extols": [
        "extol"
    ],
    "fabians": [
        "fabian"
    ],
    "firmnesses": [
        "firmness"
    ],
    "florists": [
        "florist"
    ],
    "forebears": [
        "forebear"
    ],
    "gals": [
        "gal"
    ],
    "homogeneities": [
        "homogeneity"
    ],
    "honed": [
        "hone"
    ],
    "hones": [
        "hone"
    ],
    "incapacities": [
        "incapacity"
    ],
    "marseilless": [
        "marseilles"
    ],
    "miras": [
        "mira"
    ],
    "nightfalls": [
        "nightfall"
    ],
    "overlords": [
        "overlord"
    ],
    "patricians": [
        "patrician"
    ],
    "revamped": [
        "revamp"
    ],
    "revamping": [
        "revamp"
    ],
    "revamps": [
        "revamp"
    ],
    "savageries": [
        "savagery"
    ],
    "sfs": [
        "sf"
    ],
    "simmerings": [
        "simmering"
    ],
    "softenings": [
        "softening"
    ],
    "tempests": [
        "tempest"
    ],
    "thirtieths": [
        "thirtieth"
    ],
    "transvaals": [
        "transvaal"
    ],
    "annihilated": [
        "annihilate"
    ],
    "annihilating": [
        "annihilate"
    ],
    "annihilates": [
        "annihilate"
    ],
    "archipelagos": [
        "archipelago"
    ],
    "astrologies": [
        "astrology"
    ],
    "blenheims": [
        "blenheim"
    ],
    "candids": [
        "candid"
    ],
    "counterclaimed": [
        "counterclaim"
    ],
    "counterclaims": [
        "counterclaim"
    ],
    "counterclaiming": [
        "counterclaim"
    ],
    "divulged": [
        "divulge"
    ],
    "divulging": [
        "divulge"
    ],
    "divulges": [
        "divulge"
    ],
    "dysfunctions": [
        "dysfunction"
    ],
    "ebonies": [
        "ebony"
    ],
    "foothills": [
        "foothill"
    ],
    "fundamentalisms": [
        "fundamentalism"
    ],
    "girdles": [
        "girdle"
    ],
    "girdled": [
        "girdle"
    ],
    "girdling": [
        "girdle"
    ],
    "hoeing": [
        "hoe"
    ],
    "hoed": [
        "hoe"
    ],
    "idlenesses": [
        "idleness"
    ],
    "inklings": [
        "inkling"
    ],
    "ludoes": [
        "ludo"
    ],
    "madagascars": [
        "madagascar"
    ],
    "mainstays": [
        "mainstay"
    ],
    "malteser": [
        "maltese"
    ],
    "maltese": [
        "maltese"
    ],
    "mangoes": [
        "mango"
    ],
    "mangos": [
        "mango"
    ],
    "maoris": [
        "maori"
    ],
    "milligans": [
        "milligan"
    ],
    "nectars": [
        "nectar"
    ],
    "noodles": [
        "noodle"
    ],
    "noodling": [
        "noodle"
    ],
    "noodled": [
        "noodle"
    ],
    "peeking": [
        "peek"
    ],
    "peeked": [
        "peek"
    ],
    "peeks": [
        "peek"
    ],
    "postmodernisms": [
        "postmodernism"
    ],
    "sardinias": [
        "sardinia"
    ],
    "searchlights": [
        "searchlight"
    ],
    "semens": [
        "semen"
    ],
    "shrivelled": [
        "shrivel"
    ],
    "shrivelling": [
        "shrivel"
    ],
    "shrivels": [
        "shrivel"
    ],
    "strategists": [
        "strategist"
    ],
    "taxonomies": [
        "taxonomy"
    ],
    "umms": [
        "umm"
    ],
    "wainwrights": [
        "wainwright"
    ],
    "whirlpools": [
        "whirlpool"
    ],
    "whirlpooled": [
        "whirlpool"
    ],
    "abetted": [
        "abet"
    ],
    "abetting": [
        "abet"
    ],
    "abets": [
        "abet"
    ],
    "archivists": [
        "archivist"
    ],
    "bethlehems": [
        "bethlehem"
    ],
    "blackened": [
        "blacken"
    ],
    "blackening": [
        "blacken"
    ],
    "blackens": [
        "blacken"
    ],
    "brisbanes": [
        "brisbane"
    ],
    "bullshitting": [
        "bullshit"
    ],
    "bullshits": [
        "bullshit"
    ],
    "bullshitted": [
        "bullshit"
    ],
    "buntings": [
        "bunting"
    ],
    "cackled": [
        "cackle"
    ],
    "cackling": [
        "cackle"
    ],
    "cackles": [
        "cackle"
    ],
    "caskets": [
        "casket"
    ],
    "catheters": [
        "catheter"
    ],
    "chomskies": [
        "chomsky"
    ],
    "cognitions": [
        "cognition"
    ],
    "connecticuts": [
        "connecticut"
    ],
    "discords": [
        "discord"
    ],
    "dismantlings": [
        "dismantling"
    ],
    "djiboutis": [
        "djibouti"
    ],
    "extravaganzas": [
        "extravaganza"
    ],
    "fadings": [
        "fading"
    ],
    "forebodings": [
        "foreboding"
    ],
    "gaullists": [
        "gaullist"
    ],
    "handers": [
        "hander"
    ],
    "hearsays": [
        "hearsay"
    ],
    "idbs": [
        "idb"
    ],
    "incredulities": [
        "incredulity"
    ],
    "jeremiahs": [
        "jeremiah"
    ],
    "joels": [
        "joel"
    ],
    "marinoes": [
        "marino"
    ],
    "medleys": [
        "medley"
    ],
    "othelloes": [
        "othello"
    ],
    "ottawas": [
        "ottawa"
    ],
    "preponderances": [
        "preponderance"
    ],
    "pursuances": [
        "pursuance"
    ],
    "reeked": [
        "reek"
    ],
    "reeking": [
        "reek"
    ],
    "reeks": [
        "reek"
    ],
    "scalars": [
        "scalar"
    ],
    "sensualities": [
        "sensuality"
    ],
    "sewerages": [
        "sewerage"
    ],
    "sicilians": [
        "sicilian"
    ],
    "subcontracting": [
        "subcontract"
    ],
    "subcontracted": [
        "subcontract"
    ],
    "subcontracts": [
        "subcontract"
    ],
    "subcultures": [
        "subculture"
    ],
    "subcultured": [
        "subculture"
    ],
    "tuniss": [
        "tunis"
    ],
    "undergravels": [
        "undergravel"
    ],
    "unfairnesses": [
        "unfairness"
    ],
    "verns": [
        "vern"
    ],
    "yelped": [
        "yelp"
    ],
    "yelping": [
        "yelp"
    ],
    "yelps": [
        "yelp"
    ],
    "absolved": [
        "absolve"
    ],
    "absolving": [
        "absolve"
    ],
    "arsenics": [
        "arsenic"
    ],
    "artifacts": [
        "artifact"
    ],
    "billiards": [
        "billiard"
    ],
    "brownlows": [
        "brownlow"
    ],
    "bygones": [
        "bygone"
    ],
    "campsites": [
        "campsite"
    ],
    "chattels": [
        "chattel"
    ],
    "conductivities": [
        "conductivity"
    ],
    "currants": [
        "currant"
    ],
    "diodes": [
        "diode"
    ],
    "drummings": [
        "drumming"
    ],
    "echeloned": [
        "echelon"
    ],
    "farmsteads": [
        "farmstead"
    ],
    "fortrans": [
        "fortran"
    ],
    "hulloes": [
        "hullo"
    ],
    "indemnified": [
        "indemnify"
    ],
    "indemnifies": [
        "indemnify"
    ],
    "indemnifying": [
        "indemnify"
    ],
    "kadis": [
        "kadi"
    ],
    "misrepresented": [
        "misrepresent"
    ],
    "misrepresenting": [
        "misrepresent"
    ],
    "misrepresents": [
        "misrepresent"
    ],
    "moults": [
        "moult"
    ],
    "moulting": [
        "moult"
    ],
    "moulted": [
        "moult"
    ],
    "muftiliks": [
        "muftilik"
    ],
    "nestings": [
        "nesting"
    ],
    "neurotransmitters": [
        "neurotransmitter"
    ],
    "offshoots": [
        "offshoot"
    ],
    "pragmatists": [
        "pragmatist"
    ],
    "predations": [
        "predation"
    ],
    "presbyteries": [
        "presbytery"
    ],
    "printouts": [
        "printout"
    ],
    "quaysides": [
        "quayside"
    ],
    "repossessed": [
        "repossess"
    ],
    "repossessing": [
        "repossess"
    ],
    "repossess": [
        "repossess"
    ],
    "sanchezs": [
        "sanchez"
    ],
    "sluices": [
        "sluice"
    ],
    "sluiced": [
        "sluice"
    ],
    "sluicing": [
        "sluice"
    ],
    "sniggered": [
        "snigger"
    ],
    "sniggering": [
        "snigger"
    ],
    "sniggers": [
        "snigger"
    ],
    "spinelets": [
        "spinelet"
    ],
    "styches": [
        "stych"
    ],
    "subsidiarities": [
        "subsidiarity"
    ],
    "tennants": [
        "tennant"
    ],
    "wisps": [
        "wisp"
    ],
    "wisped": [
        "wisp"
    ],
    "wisping": [
        "wisp"
    ],
    "anjous": [
        "anjou"
    ],
    "biros": [
        "biro"
    ],
    "capitalized": [
        "capitalize"
    ],
    "capitalizing": [
        "capitalize"
    ],
    "capitalizes": [
        "capitalize"
    ],
    "centralised": [
        "centralise"
    ],
    "centralising": [
        "centralise"
    ],
    "curias": [
        "curia"
    ],
    "daintier": [
        "dainty"
    ],
    "dainties": [
        "dainty"
    ],
    "daintiest": [
        "dainty"
    ],
    "dignitaries": [
        "dignitary"
    ],
    "droves": [
        "drove"
    ],
    "droving": [
        "drove"
    ],
    "fairgrounds": [
        "fairground"
    ],
    "falsehoods": [
        "falsehood"
    ],
    "fischers": [
        "fischer"
    ],
    "gorses": [
        "gorse"
    ],
    "habituations": [
        "habituation"
    ],
    "handsets": [
        "handset"
    ],
    "handsetting": [
        "handset"
    ],
    "hauntings": [
        "haunting"
    ],
    "indignities": [
        "indignity"
    ],
    "liveseys": [
        "livesey"
    ],
    "lorimers": [
        "lorimer"
    ],
    "malayas": [
        "malaya"
    ],
    "missuss": [
        "missus"
    ],
    "mountaineers": [
        "mountaineer"
    ],
    "nuffields": [
        "nuffield"
    ],
    "protectionists": [
        "protectionist"
    ],
    "quorums": [
        "quorum"
    ],
    "recognisers": [
        "recogniser"
    ],
    "rivas": [
        "riva"
    ],
    "slogging": [
        "slog"
    ],
    "slogged": [
        "slog"
    ],
    "slogs": [
        "slog"
    ],
    "spartas": [
        "sparta"
    ],
    "sprigs": [
        "sprig"
    ],
    "sprigged": [
        "sprig"
    ],
    "sprigging": [
        "sprig"
    ],
    "steelies": [
        "steely"
    ],
    "steelier": [
        "steely"
    ],
    "sunbursts": [
        "sunburst"
    ],
    "upgradings": [
        "upgrading"
    ],
    "wellbeings": [
        "wellbeing"
    ],
    "antelopes": [
        "antelope"
    ],
    "asthmatics": [
        "asthmatic"
    ],
    "bookmen": [
        "bookman"
    ],
    "bookies": [
        "booky"
    ],
    "calvinists": [
        "calvinist"
    ],
    "chatterings": [
        "chattering"
    ],
    "dowding": [
        "dowd"
    ],
    "drowsier": [
        "drowsy"
    ],
    "drowsiest": [
        "drowsy"
    ],
    "fluorescences": [
        "fluorescence"
    ],
    "holsters": [
        "holster"
    ],
    "holstered": [
        "holster"
    ],
    "holstering": [
        "holster"
    ],
    "interwarring": [
        "interwar"
    ],
    "luftwaffes": [
        "luftwaffe"
    ],
    "materialized": [
        "materialize"
    ],
    "materializing": [
        "materialize"
    ],
    "materializes": [
        "materialize"
    ],
    "moldovas": [
        "moldova"
    ],
    "niched": [
        "nich"
    ],
    "phospholipids": [
        "phospholipid"
    ],
    "polarisations": [
        "polarisation"
    ],
    "revered": [
        "rever"
    ],
    "revering": [
        "rever"
    ],
    "rosewoods": [
        "rosewood"
    ],
    "rowans": [
        "rowan"
    ],
    "scratchings": [
        "scratching"
    ],
    "shrews": [
        "shrew"
    ],
    "slowdowns": [
        "slowdown"
    ],
    "somersaults": [
        "somersault"
    ],
    "somersaulted": [
        "somersault"
    ],
    "somersaulting": [
        "somersault"
    ],
    "tombstones": [
        "tombstone"
    ],
    "twinges": [
        "twinge"
    ],
    "twingeing": [
        "twinge"
    ],
    "wheatleys": [
        "wheatley"
    ],
    "accruals": [
        "accrual"
    ],
    "adjudicators": [
        "adjudicator"
    ],
    "bengals": [
        "bengal"
    ],
    "bonniest": [
        "bonny"
    ],
    "bonnier": [
        "bonny"
    ],
    "bunged": [
        "bung"
    ],
    "bunging": [
        "bung"
    ],
    "bungs": [
        "bung"
    ],
    "calcites": [
        "calcite"
    ],
    "cartwrights": [
        "cartwright"
    ],
    "cheddars": [
        "cheddar"
    ],
    "circumcisions": [
        "circumcision"
    ],
    "cleaved": [
        "cleave"
    ],
    "cleaving": [
        "cleave"
    ],
    "cleaves": [
        "cleave"
    ],
    "clove": [
        "cleave"
    ],
    "cleft": [
        "cleave"
    ],
    "cloven": [
        "cleave"
    ],
    "cockroaches": [
        "cockroach"
    ],
    "cominterns": [
        "comintern"
    ],
    "conspirators": [
        "conspirator"
    ],
    "descartess": [
        "descartes"
    ],
    "ephemerals": [
        "ephemeral"
    ],
    "floodlights": [
        "floodlight"
    ],
    "floodlighting": [
        "floodlight"
    ],
    "floodlit": [
        "floodlight"
    ],
    "glistenings": [
        "glistening"
    ],
    "grandpas": [
        "grandpa"
    ],
    "grapevines": [
        "grapevine"
    ],
    "hawkers": [
        "hawker"
    ],
    "indianas": [
        "indiana"
    ],
    "influenzas": [
        "influenza"
    ],
    "jangling": [
        "jangle"
    ],
    "jangled": [
        "jangle"
    ],
    "jangles": [
        "jangle"
    ],
    "launchings": [
        "launching"
    ],
    "maitlands": [
        "maitland"
    ],
    "malignancies": [
        "malignancy"
    ],
    "martens": [
        "marten"
    ],
    "orpheuss": [
        "orpheus"
    ],
    "pewtered": [
        "pewter"
    ],
    "pharisees": [
        "pharisee"
    ],
    "phobias": [
        "phobia"
    ],
    "racehorses": [
        "racehorse"
    ],
    "spillages": [
        "spillage"
    ],
    "subsisting": [
        "subsist"
    ],
    "subsisted": [
        "subsist"
    ],
    "subsists": [
        "subsist"
    ],
    "sympathized": [
        "sympathize"
    ],
    "sympathizes": [
        "sympathize"
    ],
    "sympathizing": [
        "sympathize"
    ],
    "tastings": [
        "tasting"
    ],
    "touchlines": [
        "touchline"
    ],
    "upstaged": [
        "upstage"
    ],
    "upstaging": [
        "upstage"
    ],
    "upstages": [
        "upstage"
    ],
    "utilitarianisms": [
        "utilitarianism"
    ],
    "wakened": [
        "waken"
    ],
    "wakening": [
        "waken"
    ],
    "wakens": [
        "waken"
    ],
    "whistlings": [
        "whistling"
    ],
    "woodpeckers": [
        "woodpecker"
    ],
    "bolivians": [
        "bolivian"
    ],
    "boyhoods": [
        "boyhood"
    ],
    "bremens": [
        "bremen"
    ],
    "canisters": [
        "canister"
    ],
    "celsiuss": [
        "celsius"
    ],
    "chided": [
        "chide"
    ],
    "chiding": [
        "chide"
    ],
    "chides": [
        "chide"
    ],
    "chid": [
        "chide"
    ],
    "chidded": [
        "chide"
    ],
    "competencies": [
        "competency"
    ],
    "counterpoints": [
        "counterpoint"
    ],
    "counterpointed": [
        "counterpoint"
    ],
    "counterpointing": [
        "counterpoint"
    ],
    "draughtsmen": [
        "draughtsman"
    ],
    "dubais": [
        "dubai"
    ],
    "dynamisms": [
        "dynamism"
    ],
    "extricated": [
        "extricate"
    ],
    "extricating": [
        "extricate"
    ],
    "extricates": [
        "extricate"
    ],
    "ezras": [
        "ezra"
    ],
    "forgoing": [
        "forgo"
    ],
    "forgoes": [
        "forgo"
    ],
    "forwent": [
        "forgo"
    ],
    "forgone": [
        "forgo"
    ],
    "hermits": [
        "hermit"
    ],
    "hillier": [
        "hilly"
    ],
    "hilliest": [
        "hilly"
    ],
    "ileums": [
        "ileum"
    ],
    "ineligibles": [
        "ineligible"
    ],
    "juxtaposed": [
        "juxtapose"
    ],
    "juxtaposing": [
        "juxtapose"
    ],
    "kegs": [
        "keg"
    ],
    "kegging": [
        "keg"
    ],
    "lesothoes": [
        "lesotho"
    ],
    "misjudged": [
        "misjudge"
    ],
    "misjudging": [
        "misjudge"
    ],
    "misjudges": [
        "misjudge"
    ],
    "northerlies": [
        "northerly"
    ],
    "obes": [
        "obe"
    ],
    "overhangs": [
        "overhang"
    ],
    "overhanging": [
        "overhang"
    ],
    "overhanged": [
        "overhang"
    ],
    "overhung": [
        "overhang"
    ],
    "polemics": [
        "polemic"
    ],
    "pulleys": [
        "pulley"
    ],
    "pvcs": [
        "pvc"
    ],
    "remixes": [
        "remix"
    ],
    "remixed": [
        "remix"
    ],
    "remixing": [
        "remix"
    ],
    "riffing": [
        "riff"
    ],
    "riffed": [
        "riff"
    ],
    "seemings": [
        "seeming"
    ],
    "stencilled": [
        "stencil"
    ],
    "stencils": [
        "stencil"
    ],
    "stencilling": [
        "stencil"
    ],
    "templars": [
        "templar"
    ],
    "vocalists": [
        "vocalist"
    ],
    "yds": [
        "yd"
    ],
    "annameses": [
        "annamese"
    ],
    "antiquarians": [
        "antiquarian"
    ],
    "baboons": [
        "baboon"
    ],
    "belligerents": [
        "belligerent"
    ],
    "broked": [
        "broke"
    ],
    "caffeines": [
        "caffeine"
    ],
    "calmings": [
        "calming"
    ],
    "concourses": [
        "concourse"
    ],
    "deformities": [
        "deformity"
    ],
    "dreamiest": [
        "dreamy"
    ],
    "dreamier": [
        "dreamy"
    ],
    "facilitators": [
        "facilitator"
    ],
    "illegalities": [
        "illegality"
    ],
    "indebtednesses": [
        "indebtedness"
    ],
    "introns": [
        "intron"
    ],
    "journeymen": [
        "journeyman"
    ],
    "marlowes": [
        "marlowe"
    ],
    "metalworks": [
        "metalwork"
    ],
    "minefields": [
        "minefield"
    ],
    "monoes": [
        "mono"
    ],
    "oregons": [
        "oregon"
    ],
    "pbss": [
        "pbs"
    ],
    "pippins": [
        "pippin"
    ],
    "princeliest": [
        "princely"
    ],
    "remade": [
        "remake"
    ],
    "remaking": [
        "remake"
    ],
    "remakes": [
        "remake"
    ],
    "romanies": [
        "romany"
    ],
    "rumblings": [
        "rumbling"
    ],
    "sats": [
        "sat"
    ],
    "scheds": [
        "sched"
    ],
    "selectivities": [
        "selectivity"
    ],
    "shellings": [
        "shelling"
    ],
    "sines": [
        "sine"
    ],
    "smouldering": [
        "smoulder"
    ],
    "smouldered": [
        "smoulder"
    ],
    "smoulders": [
        "smoulder"
    ],
    "tankards": [
        "tankard"
    ],
    "triassics": [
        "triassic"
    ],
    "underpantss": [
        "underpants"
    ],
    "utensils": [
        "utensil"
    ],
    "veals": [
        "veal"
    ],
    "vertebrae": [
        "vertebra"
    ],
    "whiskeys": [
        "whiskey"
    ],
    "admins": [
        "admin"
    ],
    "amalgams": [
        "amalgam"
    ],
    "annulled": [
        "annul"
    ],
    "annulling": [
        "annul"
    ],
    "annuls": [
        "annul"
    ],
    "battleships": [
        "battleship"
    ],
    "bos": [
        "bo"
    ],
    "boing": [
        "bo"
    ],
    "breadcrumbs": [
        "breadcrumb"
    ],
    "breadcrumbed": [
        "breadcrumb"
    ],
    "cetaceans": [
        "cetacean"
    ],
    "chinks": [
        "chink"
    ],
    "chinking": [
        "chink"
    ],
    "chinked": [
        "chink"
    ],
    "colonists": [
        "colonist"
    ],
    "copernicans": [
        "copernican"
    ],
    "disbelieving": [
        "disbelieve"
    ],
    "disbelieved": [
        "disbelieve"
    ],
    "disbelieves": [
        "disbelieve"
    ],
    "forsaken": [
        "forsake"
    ],
    "forsaking": [
        "forsake"
    ],
    "forsakes": [
        "forsake"
    ],
    "forsook": [
        "forsake"
    ],
    "hallos": [
        "hallo"
    ],
    "hemingways": [
        "hemingway"
    ],
    "heretics": [
        "heretic"
    ],
    "hypoglycaemias": [
        "hypoglycaemia"
    ],
    "impelled": [
        "impel"
    ],
    "impels": [
        "impel"
    ],
    "impelling": [
        "impel"
    ],
    "indecencies": [
        "indecency"
    ],
    "lazios": [
        "lazio"
    ],
    "manliest": [
        "manly"
    ],
    "manlier": [
        "manly"
    ],
    "morsels": [
        "morsel"
    ],
    "muggers": [
        "mugger"
    ],
    "municipalities": [
        "municipality"
    ],
    "paediatrics": [
        "paediatric"
    ],
    "paracetamols": [
        "paracetamol"
    ],
    "purcells": [
        "purcell"
    ],
    "quangos": [
        "quango"
    ],
    "resuscitations": [
        "resuscitation"
    ],
    "retraining": [
        "retrain"
    ],
    "retrained": [
        "retrain"
    ],
    "reworked": [
        "rework"
    ],
    "reworking": [
        "rework"
    ],
    "reworks": [
        "rework"
    ],
    "scythed": [
        "scythe"
    ],
    "scything": [
        "scythe"
    ],
    "smoothnesses": [
        "smoothness"
    ],
    "squawked": [
        "squawk"
    ],
    "squawking": [
        "squawk"
    ],
    "squawks": [
        "squawk"
    ],
    "stuttered": [
        "stutter"
    ],
    "stuttering": [
        "stutter"
    ],
    "stutters": [
        "stutter"
    ],
    "sunnis": [
        "sunni"
    ],
    "sycamores": [
        "sycamore"
    ],
    "tetanuss": [
        "tetanus"
    ],
    "thrustings": [
        "thrusting"
    ],
    "wealds": [
        "weald"
    ],
    "welts": [
        "welt"
    ],
    "welted": [
        "welt"
    ],
    "accredited": [
        "accredit"
    ],
    "accrediting": [
        "accredit"
    ],
    "accredits": [
        "accredit"
    ],
    "acquittals": [
        "acquittal"
    ],
    "adorals": [
        "adoral"
    ],
    "aerobatics": [
        "aerobatic"
    ],
    "alabamas": [
        "alabama"
    ],
    "blemishes": [
        "blemish"
    ],
    "blemished": [
        "blemish"
    ],
    "blemishing": [
        "blemish"
    ],
    "cameos": [
        "cameo"
    ],
    "cantos": [
        "canto"
    ],
    "castigated": [
        "castigate"
    ],
    "castigating": [
        "castigate"
    ],
    "castigates": [
        "castigate"
    ],
    "chasers": [
        "chaser"
    ],
    "clios": [
        "clio"
    ],
    "cowardices": [
        "cowardice"
    ],
    "crossovers": [
        "crossover"
    ],
    "deckers": [
        "decker"
    ],
    "denigrated": [
        "denigrate"
    ],
    "denigrating": [
        "denigrate"
    ],
    "denigrates": [
        "denigrate"
    ],
    "euthanasias": [
        "euthanasia"
    ],
    "farrowing": [
        "farrow"
    ],
    "farrowed": [
        "farrow"
    ],
    "farrows": [
        "farrow"
    ],
    "hepatocytes": [
        "hepatocyte"
    ],
    "huffed": [
        "huff"
    ],
    "huffing": [
        "huff"
    ],
    "huffs": [
        "huff"
    ],
    "inflamed": [
        "inflame"
    ],
    "inflaming": [
        "inflame"
    ],
    "inflames": [
        "inflame"
    ],
    "integrators": [
        "integrator"
    ],
    "invariants": [
        "invariant"
    ],
    "linesmen": [
        "linesman"
    ],
    "linesmans": [
        "linesman"
    ],
    "lolling": [
        "loll"
    ],
    "lolled": [
        "loll"
    ],
    "lolls": [
        "loll"
    ],
    "lovells": [
        "lovell"
    ],
    "newts": [
        "newt"
    ],
    "notorieties": [
        "notoriety"
    ],
    "nurembergs": [
        "nuremberg"
    ],
    "nutmegs": [
        "nutmeg"
    ],
    "nutmegged": [
        "nutmeg"
    ],
    "plausibilities": [
        "plausibility"
    ],
    "pleistocenes": [
        "pleistocene"
    ],
    "psis": [
        "psi"
    ],
    "scallops": [
        "scallop"
    ],
    "stilts": [
        "stilt"
    ],
    "stilted": [
        "stilt"
    ],
    "tenacities": [
        "tenacity"
    ],
    "trojans": [
        "trojan"
    ],
    "wantons": [
        "wanton"
    ],
    "wantoning": [
        "wanton"
    ],
    "wantoned": [
        "wanton"
    ],
    "wavier": [
        "wavy"
    ],
    "waviest": [
        "wavy"
    ],
    "abdicated": [
        "abdicate"
    ],
    "abdicating": [
        "abdicate"
    ],
    "abdicates": [
        "abdicate"
    ],
    "acquirers": [
        "acquirer"
    ],
    "avenged": [
        "avenge"
    ],
    "avenges": [
        "avenge"
    ],
    "avenging": [
        "avenge"
    ],
    "banisters": [
        "banister"
    ],
    "booties": [
        "booty"
    ],
    "capitulated": [
        "capitulate"
    ],
    "capitulating": [
        "capitulate"
    ],
    "capitulates": [
        "capitulate"
    ],
    "cataracts": [
        "cataract"
    ],
    "chivalries": [
        "chivalry"
    ],
    "corinths": [
        "corinth"
    ],
    "demurred": [
        "demur"
    ],
    "demurs": [
        "demur"
    ],
    "demurring": [
        "demur"
    ],
    "descriptors": [
        "descriptor"
    ],
    "detonated": [
        "detonate"
    ],
    "detonating": [
        "detonate"
    ],
    "detonates": [
        "detonate"
    ],
    "dilated": [
        "dilate"
    ],
    "dilating": [
        "dilate"
    ],
    "dingies": [
        "dingy"
    ],
    "dingiest": [
        "dingy"
    ],
    "dingier": [
        "dingy"
    ],
    "disenchantments": [
        "disenchantment"
    ],
    "equatorials": [
        "equatorial"
    ],
    "formalised": [
        "formalise"
    ],
    "formalising": [
        "formalise"
    ],
    "imps": [
        "imp"
    ],
    "inlays": [
        "inlay"
    ],
    "inlaying": [
        "inlay"
    ],
    "inlaid": [
        "inlay"
    ],
    "ironworks": [
        "ironwork"
    ],
    "ironworking": [
        "ironwork"
    ],
    "jurisdictionals": [
        "jurisdictional"
    ],
    "levins": [
        "levin"
    ],
    "lynxes": [
        "lynx"
    ],
    "molded": [
        "mold"
    ],
    "molds": [
        "mold"
    ],
    "niceties": [
        "nicety"
    ],
    "ovaries": [
        "ovary"
    ],
    "personified": [
        "personify"
    ],
    "personifies": [
        "personify"
    ],
    "personifying": [
        "personify"
    ],
    "proportionalities": [
        "proportionality"
    ],
    "riverbanks": [
        "riverbank"
    ],
    "sedated": [
        "sedate"
    ],
    "sedating": [
        "sedate"
    ],
    "sedates": [
        "sedate"
    ],
    "sprinklered": [
        "sprinkler"
    ],
    "stabilizations": [
        "stabilization"
    ],
    "supersparcs": [
        "supersparc"
    ],
    "taid": [
        "tay"
    ],
    "tbilisis": [
        "tbilisi"
    ],
    "thoroughfares": [
        "thoroughfare"
    ],
    "verderers": [
        "verderer"
    ],
    "amoss": [
        "amos"
    ],
    "cajoled": [
        "cajole"
    ],
    "cajoling": [
        "cajole"
    ],
    "cannier": [
        "canny"
    ],
    "canniest": [
        "canny"
    ],
    "chameleons": [
        "chameleon"
    ],
    "checkings": [
        "checking"
    ],
    "conveyors": [
        "conveyor"
    ],
    "demesnes": [
        "demesne"
    ],
    "disappearings": [
        "disappearing"
    ],
    "dreamings": [
        "dreaming"
    ],
    "ducklings": [
        "duckling"
    ],
    "duplexes": [
        "duplex"
    ],
    "duplexing": [
        "duplex"
    ],
    "duplexed": [
        "duplex"
    ],
    "earthier": [
        "earthy"
    ],
    "eyewitnesses": [
        "eyewitness"
    ],
    "friesians": [
        "friesian"
    ],
    "gaer": [
        "ga"
    ],
    "gas": [
        "ga"
    ],
    "heathens": [
        "heathen"
    ],
    "hobsons": [
        "hobson"
    ],
    "indigos": [
        "indigo"
    ],
    "infidelities": [
        "infidelity"
    ],
    "irrelevances": [
        "irrelevance"
    ],
    "lubricants": [
        "lubricant"
    ],
    "lugging": [
        "lug"
    ],
    "lugged": [
        "lug"
    ],
    "lugs": [
        "lug"
    ],
    "majorcas": [
        "majorca"
    ],
    "marksmen": [
        "marksman"
    ],
    "mermaids": [
        "mermaid"
    ],
    "nassers": [
        "nasser"
    ],
    "nsaids": [
        "nsaid"
    ],
    "orbs": [
        "orb"
    ],
    "owenss": [
        "owens"
    ],
    "perseverances": [
        "perseverance"
    ],
    "residencies": [
        "residency"
    ],
    "rootstocks": [
        "rootstock"
    ],
    "rupees": [
        "rupee"
    ],
    "schuberts": [
        "schubert"
    ],
    "shapeliest": [
        "shapely"
    ],
    "shapelier": [
        "shapely"
    ],
    "smoulderings": [
        "smouldering"
    ],
    "subductions": [
        "subduction"
    ],
    "submissives": [
        "submissive"
    ],
    "swaggered": [
        "swagger"
    ],
    "swaggering": [
        "swagger"
    ],
    "swaggers": [
        "swagger"
    ],
    "triads": [
        "triad"
    ],
    "turnarounds": [
        "turnaround"
    ],
    "venisons": [
        "venison"
    ],
    "veronas": [
        "verona"
    ],
    "vesicles": [
        "vesicle"
    ],
    "zagrebs": [
        "zagreb"
    ],
    "abatements": [
        "abatement"
    ],
    "ageisms": [
        "ageism"
    ],
    "bedclothes": [
        "bedclothe"
    ],
    "burgundians": [
        "burgundian"
    ],
    "canness": [
        "cannes"
    ],
    "carnegies": [
        "carnegie"
    ],
    "cbes": [
        "cbe"
    ],
    "circuitries": [
        "circuitry"
    ],
    "clippings": [
        "clipping"
    ],
    "colors": [
        "color"
    ],
    "compatriots": [
        "compatriot"
    ],
    "convenors": [
        "convenor"
    ],
    "corries": [
        "corrie"
    ],
    "crescendos": [
        "crescendo"
    ],
    "crescendi": [
        "crescendo"
    ],
    "cses": [
        "cse"
    ],
    "dutchmen": [
        "dutchman"
    ],
    "epistles": [
        "epistle"
    ],
    "etruscans": [
        "etruscan"
    ],
    "exhilarations": [
        "exhilaration"
    ],
    "geodesics": [
        "geodesic"
    ],
    "gonging": [
        "gong"
    ],
    "gratified": [
        "gratify"
    ],
    "gratifying": [
        "gratify"
    ],
    "gynaecologists": [
        "gynaecologist"
    ],
    "harshnesses": [
        "harshness"
    ],
    "holisms": [
        "holism"
    ],
    "judes": [
        "jude"
    ],
    "malays": [
        "malay"
    ],
    "mausoleums": [
        "mausoleum"
    ],
    "misplaced": [
        "misplace"
    ],
    "misplaces": [
        "misplace"
    ],
    "misplacing": [
        "misplace"
    ],
    "moynihans": [
        "moynihan"
    ],
    "namibians": [
        "namibian"
    ],
    "opticians": [
        "optician"
    ],
    "preheated": [
        "preheat"
    ],
    "preheating": [
        "preheat"
    ],
    "preheats": [
        "preheat"
    ],
    "prepped": [
        "prep"
    ],
    "preps": [
        "prep"
    ],
    "prepping": [
        "prep"
    ],
    "rationalists": [
        "rationalist"
    ],
    "renegotiated": [
        "renegotiate"
    ],
    "renegotiating": [
        "renegotiate"
    ],
    "renegotiates": [
        "renegotiate"
    ],
    "rucks": [
        "ruck"
    ],
    "rucked": [
        "ruck"
    ],
    "rucking": [
        "ruck"
    ],
    "seclusions": [
        "seclusion"
    ],
    "sendings": [
        "sending"
    ],
    "shoddiest": [
        "shoddy"
    ],
    "shoddier": [
        "shoddy"
    ],
    "skirtings": [
        "skirting"
    ],
    "snouts": [
        "snout"
    ],
    "snouting": [
        "snout"
    ],
    "swiped": [
        "swipe"
    ],
    "swipes": [
        "swipe"
    ],
    "swiping": [
        "swipe"
    ],
    "tuxedos": [
        "tuxedo"
    ],
    "tweaked": [
        "tweak"
    ],
    "tweaking": [
        "tweak"
    ],
    "tweaks": [
        "tweak"
    ],
    "warders": [
        "warder"
    ],
    "wardships": [
        "wardship"
    ],
    "wearings": [
        "wearing"
    ],
    "woodworkers": [
        "woodworker"
    ],
    "wuer": [
        "wu"
    ],
    "aerodynamics": [
        "aerodynamic"
    ],
    "appendages": [
        "appendage"
    ],
    "aragons": [
        "aragon"
    ],
    "bluebells": [
        "bluebell"
    ],
    "bogies": [
        "bogy",
        "bogie"
    ],
    "bogying": [
        "bogy"
    ],
    "bushier": [
        "bushy"
    ],
    "bushies": [
        "bushy"
    ],
    "bushiest": [
        "bushy"
    ],
    "classmates": [
        "classmate"
    ],
    "depopulations": [
        "depopulation"
    ],
    "derisions": [
        "derision"
    ],
    "downpours": [
        "downpour"
    ],
    "earthenwares": [
        "earthenware"
    ],
    "finalities": [
        "finality"
    ],
    "footballings": [
        "footballing"
    ],
    "formalisms": [
        "formalism"
    ],
    "functionalisms": [
        "functionalism"
    ],
    "gastons": [
        "gaston"
    ],
    "guyanas": [
        "guyana"
    ],
    "hashing": [
        "hash"
    ],
    "hashed": [
        "hash"
    ],
    "hashes": [
        "hash"
    ],
    "headstocks": [
        "headstock"
    ],
    "herbicides": [
        "herbicide"
    ],
    "humankinds": [
        "humankind"
    ],
    "loners": [
        "loner"
    ],
    "lowries": [
        "lowry"
    ],
    "mansons": [
        "manson"
    ],
    "mbes": [
        "mbe"
    ],
    "moorishes": [
        "moorish"
    ],
    "multiprocessors": [
        "multiprocessor"
    ],
    "philistines": [
        "philistine"
    ],
    "powerlessnesses": [
        "powerlessness"
    ],
    "rationalisms": [
        "rationalism"
    ],
    "repentances": [
        "repentance"
    ],
    "reverberated": [
        "reverberate"
    ],
    "reverberating": [
        "reverberate"
    ],
    "reverberates": [
        "reverberate"
    ],
    "rungs": [
        "rung"
    ],
    "sawyers": [
        "sawyer"
    ],
    "scalded": [
        "scald"
    ],
    "scalding": [
        "scald"
    ],
    "scalds": [
        "scald"
    ],
    "slouched": [
        "slouch"
    ],
    "slouching": [
        "slouch"
    ],
    "slouches": [
        "slouch"
    ],
    "smitten": [
        "smite"
    ],
    "smote": [
        "smite"
    ],
    "smiting": [
        "smite"
    ],
    "smites": [
        "smite"
    ],
    "spattered": [
        "spatter"
    ],
    "spattering": [
        "spatter"
    ],
    "spatters": [
        "spatter"
    ],
    "strangenesses": [
        "strangeness"
    ],
    "tendrils": [
        "tendril"
    ],
    "tendrilled": [
        "tendril"
    ],
    "wearers": [
        "wearer"
    ],
    "workouts": [
        "workout"
    ],
    "yts": [
        "yt"
    ],
    "alps": [
        "alp"
    ],
    "annexations": [
        "annexation"
    ],
    "baltimores": [
        "baltimore"
    ],
    "batmen": [
        "batman"
    ],
    "bavarians": [
        "bavarian"
    ],
    "colonoscopies": [
        "colonoscopy"
    ],
    "concocted": [
        "concoct"
    ],
    "concocting": [
        "concoct"
    ],
    "concocts": [
        "concoct"
    ],
    "counsellees": [
        "counsellee"
    ],
    "degenerations": [
        "degeneration"
    ],
    "demographies": [
        "demography"
    ],
    "divested": [
        "divest"
    ],
    "divesting": [
        "divest"
    ],
    "divests": [
        "divest"
    ],
    "enchanted": [
        "enchant"
    ],
    "enchants": [
        "enchant"
    ],
    "enchanting": [
        "enchant"
    ],
    "festooned": [
        "festoon"
    ],
    "festoons": [
        "festoon"
    ],
    "festooning": [
        "festoon"
    ],
    "flashier": [
        "flashy"
    ],
    "flashies": [
        "flashy"
    ],
    "flashiest": [
        "flashy"
    ],
    "footbridges": [
        "footbridge"
    ],
    "foreshadowed": [
        "foreshadow"
    ],
    "foreshadowing": [
        "foreshadow"
    ],
    "foreshadows": [
        "foreshadow"
    ],
    "gangways": [
        "gangway"
    ],
    "gangwayed": [
        "gangway"
    ],
    "gurgled": [
        "gurgle"
    ],
    "gurgling": [
        "gurgle"
    ],
    "gurgles": [
        "gurgle"
    ],
    "haddocks": [
        "haddock"
    ],
    "judoes": [
        "judo"
    ],
    "leds": [
        "led"
    ],
    "listers": [
        "lister"
    ],
    "logarithms": [
        "logarithm"
    ],
    "measurings": [
        "measuring"
    ],
    "melvilles": [
        "melville"
    ],
    "neutralized": [
        "neutralize"
    ],
    "neutralizing": [
        "neutralize"
    ],
    "neutralizes": [
        "neutralize"
    ],
    "poolsides": [
        "poolside"
    ],
    "predictabilities": [
        "predictability"
    ],
    "prodigies": [
        "prodigy"
    ],
    "reappraisals": [
        "reappraisal"
    ],
    "rearmaments": [
        "rearmament"
    ],
    "removables": [
        "removable"
    ],
    "restlessnesses": [
        "restlessness"
    ],
    "rioters": [
        "rioter"
    ],
    "savannahs": [
        "savannah"
    ],
    "sawdusts": [
        "sawdust"
    ],
    "schisms": [
        "schism"
    ],
    "solidities": [
        "solidity"
    ],
    "thorps": [
        "thorp"
    ],
    "tolerations": [
        "toleration"
    ],
    "trotters": [
        "trotter"
    ],
    "unicefs": [
        "unicef"
    ],
    "accretions": [
        "accretion"
    ],
    "acers": [
        "acer"
    ],
    "appalled": [
        "appal"
    ],
    "appalling": [
        "appal"
    ],
    "appals": [
        "appal"
    ],
    "blisterings": [
        "blistering"
    ],
    "calamities": [
        "calamity"
    ],
    "candlesticks": [
        "candlestick"
    ],
    "collectivities": [
        "collectivity"
    ],
    "coolnesses": [
        "coolness"
    ],
    "crockeries": [
        "crockery"
    ],
    "decomposed": [
        "decompose"
    ],
    "decomposing": [
        "decompose"
    ],
    "deflections": [
        "deflection"
    ],
    "derided": [
        "deride"
    ],
    "deriding": [
        "deride"
    ],
    "derides": [
        "deride"
    ],
    "directorships": [
        "directorship"
    ],
    "dragonflies": [
        "dragonfly"
    ],
    "earshots": [
        "earshot"
    ],
    "edgings": [
        "edging"
    ],
    "ethnographies": [
        "ethnography"
    ],
    "fallows": [
        "fallow"
    ],
    "fallowing": [
        "fallow"
    ],
    "faos": [
        "fao"
    ],
    "grumpier": [
        "grumpy"
    ],
    "grumpies": [
        "grumpy"
    ],
    "grumpiest": [
        "grumpy"
    ],
    "haggling": [
        "haggle"
    ],
    "haggled": [
        "haggle"
    ],
    "haggles": [
        "haggle"
    ],
    "intimations": [
        "intimation"
    ],
    "joyriders": [
        "joyrider"
    ],
    "keenans": [
        "keenan"
    ],
    "loing": [
        "lo"
    ],
    "louts": [
        "lout"
    ],
    "louting": [
        "lout"
    ],
    "marijuanas": [
        "marijuana"
    ],
    "mcintoshes": [
        "mcintosh"
    ],
    "michelins": [
        "michelin"
    ],
    "motleyed": [
        "motley"
    ],
    "nabbed": [
        "nab"
    ],
    "nabs": [
        "nab"
    ],
    "nabbing": [
        "nab"
    ],
    "narrowings": [
        "narrowing"
    ],
    "piracies": [
        "piracy"
    ],
    "punchcards": [
        "punchcard"
    ],
    "ramshackled": [
        "ramshackle"
    ],
    "ransacked": [
        "ransack"
    ],
    "ransacking": [
        "ransack"
    ],
    "ransacks": [
        "ransack"
    ],
    "readabilities": [
        "readability"
    ],
    "rearings": [
        "rearing"
    ],
    "rehoused": [
        "rehouse"
    ],
    "rehousing": [
        "rehouse"
    ],
    "rehouses": [
        "rehouse"
    ],
    "repented": [
        "repent"
    ],
    "repents": [
        "repent"
    ],
    "repenting": [
        "repent"
    ],
    "sheetings": [
        "sheeting"
    ],
    "showmen": [
        "showman"
    ],
    "sickened": [
        "sicken"
    ],
    "sickens": [
        "sicken"
    ],
    "sickening": [
        "sicken"
    ],
    "singletons": [
        "singleton"
    ],
    "sorrels": [
        "sorrel"
    ],
    "spookier": [
        "spooky"
    ],
    "spookiest": [
        "spooky"
    ],
    "supranationals": [
        "supranational"
    ],
    "swopped": [
        "swop"
    ],
    "swopping": [
        "swop"
    ],
    "swops": [
        "swop"
    ],
    "transferors": [
        "transferor"
    ],
    "trawling": [
        "trawl"
    ],
    "trawled": [
        "trawl"
    ],
    "trawls": [
        "trawl"
    ],
    "trusties": [
        "trusty"
    ],
    "trustiest": [
        "trusty"
    ],
    "trustier": [
        "trusty"
    ],
    "watersides": [
        "waterside"
    ],
    "atonements": [
        "atonement"
    ],
    "auschwitzs": [
        "auschwitz"
    ],
    "bartletts": [
        "bartlett"
    ],
    "belied": [
        "bely",
        "belie"
    ],
    "belying": [
        "bely",
        "belie"
    ],
    "cholecystectomies": [
        "cholecystectomy"
    ],
    "claddings": [
        "cladding"
    ],
    "combatants": [
        "combatant"
    ],
    "connectivities": [
        "connectivity"
    ],
    "criminalities": [
        "criminality"
    ],
    "delicatessens": [
        "delicatessen"
    ],
    "dividers": [
        "divider"
    ],
    "edicts": [
        "edict"
    ],
    "ercps": [
        "ercp"
    ],
    "flamingos": [
        "flamingo"
    ],
    "flamingoes": [
        "flamingo"
    ],
    "fluorides": [
        "fluoride"
    ],
    "fragilities": [
        "fragility"
    ],
    "geldings": [
        "gelding"
    ],
    "grapefruits": [
        "grapefruit"
    ],
    "inflections": [
        "inflection"
    ],
    "intertwined": [
        "intertwine"
    ],
    "intertwines": [
        "intertwine"
    ],
    "intertwining": [
        "intertwine"
    ],
    "jackpots": [
        "jackpot"
    ],
    "lauded": [
        "laud"
    ],
    "lauding": [
        "laud"
    ],
    "lauds": [
        "laud"
    ],
    "mallards": [
        "mallard"
    ],
    "meddling": [
        "meddle"
    ],
    "meddled": [
        "meddle"
    ],
    "meddles": [
        "meddle"
    ],
    "nightlives": [
        "nightlife"
    ],
    "outlived": [
        "outlive"
    ],
    "outliving": [
        "outlive"
    ],
    "outlives": [
        "outlive"
    ],
    "perturbed": [
        "perturb"
    ],
    "perturbing": [
        "perturb"
    ],
    "perturbs": [
        "perturb"
    ],
    "pitmen": [
        "pitman"
    ],
    "poppers": [
        "popper"
    ],
    "prednisolones": [
        "prednisolone"
    ],
    "repainted": [
        "repaint"
    ],
    "repainting": [
        "repaint"
    ],
    "repaints": [
        "repaint"
    ],
    "separatisms": [
        "separatism"
    ],
    "speedways": [
        "speedway"
    ],
    "touchdowns": [
        "touchdown"
    ],
    "warburgs": [
        "warburg"
    ],
    "wormwoods": [
        "wormwood"
    ],
    "babylons": [
        "babylon"
    ],
    "bannings": [
        "banning"
    ],
    "caldwells": [
        "caldwell"
    ],
    "chopins": [
        "chopin"
    ],
    "consulates": [
        "consulate"
    ],
    "cornflakes": [
        "cornflake"
    ],
    "danker": [
        "dank"
    ],
    "dankest": [
        "dank"
    ],
    "deflations": [
        "deflation"
    ],
    "destitutes": [
        "destitute"
    ],
    "dualisms": [
        "dualism"
    ],
    "edisons": [
        "edison"
    ],
    "electrophoreses": [
        "electrophoresis"
    ],
    "fahrenheits": [
        "fahrenheit"
    ],
    "funkier": [
        "funky"
    ],
    "funkiest": [
        "funky"
    ],
    "gaieties": [
        "gaiety"
    ],
    "genocided": [
        "genocide"
    ],
    "groundworks": [
        "groundwork"
    ],
    "hexagonals": [
        "hexagonal"
    ],
    "innkeepers": [
        "innkeeper"
    ],
    "laughtons": [
        "laughton"
    ],
    "laundered": [
        "launder"
    ],
    "laundering": [
        "launder"
    ],
    "launders": [
        "launder"
    ],
    "loins": [
        "loin"
    ],
    "loined": [
        "loin"
    ],
    "normalizations": [
        "normalization"
    ],
    "quiverings": [
        "quivering"
    ],
    "refitted": [
        "refit"
    ],
    "refitting": [
        "refit"
    ],
    "refits": [
        "refit"
    ],
    "refrigerations": [
        "refrigeration"
    ],
    "seedier": [
        "seedy"
    ],
    "seediest": [
        "seedy"
    ],
    "sentimentalities": [
        "sentimentality"
    ],
    "snas": [
        "sna"
    ],
    "technologists": [
        "technologist"
    ],
    "throughputs": [
        "throughput"
    ],
    "veing": [
        "ve"
    ],
    "ves": [
        "ve"
    ],
    "violinists": [
        "violinist"
    ],
    "waffles": [
        "waffle"
    ],
    "waffling": [
        "waffle"
    ],
    "waffled": [
        "waffle"
    ],
    "warhols": [
        "warhol"
    ],
    "abusers": [
        "abuser"
    ],
    "alsatians": [
        "alsatian"
    ],
    "aqueducts": [
        "aqueduct"
    ],
    "ballerinas": [
        "ballerina"
    ],
    "blinkings": [
        "blinking"
    ],
    "bosches": [
        "bosch"
    ],
    "broccolis": [
        "broccoli"
    ],
    "burnetts": [
        "burnett"
    ],
    "claustrophobics": [
        "claustrophobic"
    ],
    "cleggs": [
        "clegg"
    ],
    "copyings": [
        "copying"
    ],
    "crumped": [
        "crump"
    ],
    "crumps": [
        "crump"
    ],
    "crumping": [
        "crump"
    ],
    "daemons": [
        "daemon"
    ],
    "daimlers": [
        "daimler"
    ],
    "disaffections": [
        "disaffection"
    ],
    "doused": [
        "douse"
    ],
    "dousing": [
        "douse"
    ],
    "douses": [
        "douse"
    ],
    "fayed": [
        "fay"
    ],
    "fays": [
        "fay"
    ],
    "fiends": [
        "fiend"
    ],
    "g.p.s": [
        "g.p."
    ],
    "geezers": [
        "geezer"
    ],
    "grottos": [
        "grotto"
    ],
    "grottoes": [
        "grotto"
    ],
    "implored": [
        "implore"
    ],
    "imploring": [
        "implore"
    ],
    "implores": [
        "implore"
    ],
    "infertilities": [
        "infertility"
    ],
    "internationalists": [
        "internationalist"
    ],
    "keyholes": [
        "keyhole"
    ],
    "latencies": [
        "latency"
    ],
    "mairs": [
        "mair"
    ],
    "melanomas": [
        "melanoma"
    ],
    "montanas": [
        "montana"
    ],
    "nakednesses": [
        "nakedness"
    ],
    "nonconformities": [
        "nonconformity"
    ],
    "pared": [
        "pare"
    ],
    "paring": [
        "pare"
    ],
    "rekindled": [
        "rekindle"
    ],
    "rekindling": [
        "rekindle"
    ],
    "rekindles": [
        "rekindle"
    ],
    "riggings": [
        "rigging"
    ],
    "rodgerss": [
        "rodgers"
    ],
    "ruffs": [
        "ruff"
    ],
    "ruffed": [
        "ruff"
    ],
    "saigons": [
        "saigon"
    ],
    "setts": [
        "sett"
    ],
    "shippers": [
        "shipper"
    ],
    "southeys": [
        "southey"
    ],
    "spewed": [
        "spew"
    ],
    "spewing": [
        "spew"
    ],
    "spews": [
        "spew"
    ],
    "stardoms": [
        "stardom"
    ],
    "steepled": [
        "steeple"
    ],
    "steepling": [
        "steeple"
    ],
    "stirrups": [
        "stirrup"
    ],
    "swigging": [
        "swig"
    ],
    "swigged": [
        "swig"
    ],
    "swigs": [
        "swig"
    ],
    "tenners": [
        "tenner"
    ],
    "transfixed": [
        "transfix"
    ],
    "transfixing": [
        "transfix"
    ],
    "transfixes": [
        "transfix"
    ],
    "yarrows": [
        "yarrow"
    ],
    "zigzagged": [
        "zigzag"
    ],
    "zigzagging": [
        "zigzag"
    ],
    "alternations": [
        "alternation"
    ],
    "astrologers": [
        "astrologer"
    ],
    "barbels": [
        "barbel"
    ],
    "barbelling": [
        "barbel"
    ],
    "bassoons": [
        "bassoon"
    ],
    "brandts": [
        "brandt"
    ],
    "brevities": [
        "brevity"
    ],
    "bruneis": [
        "brunei"
    ],
    "campuses": [
        "campuse"
    ],
    "capris": [
        "capri"
    ],
    "cuticles": [
        "cuticle"
    ],
    "daubed": [
        "daub"
    ],
    "daubing": [
        "daub"
    ],
    "daubs": [
        "daub"
    ],
    "distensions": [
        "distension"
    ],
    "domesticities": [
        "domesticity"
    ],
    "ebs": [
        "eb"
    ],
    "empiricists": [
        "empiricist"
    ],
    "gaels": [
        "gael"
    ],
    "histologies": [
        "histology"
    ],
    "ircs": [
        "irc"
    ],
    "levellers": [
        "leveller"
    ],
    "marketers": [
        "marketer"
    ],
    "meridians": [
        "meridian"
    ],
    "microkernels": [
        "microkernel"
    ],
    "muslins": [
        "muslin"
    ],
    "nevadas": [
        "nevada"
    ],
    "opticss": [
        "optics"
    ],
    "ortegas": [
        "ortega"
    ],
    "oxbridges": [
        "oxbridge"
    ],
    "paraphernalias": [
        "paraphernalia"
    ],
    "refectories": [
        "refectory"
    ],
    "renegades": [
        "renegade"
    ],
    "santoss": [
        "santos"
    ],
    "siphoned": [
        "siphon"
    ],
    "siphoning": [
        "siphon"
    ],
    "starrs": [
        "starr"
    ],
    "surrealisms": [
        "surrealism"
    ],
    "undercarriages": [
        "undercarriage"
    ],
    "unsolveds": [
        "unsolved"
    ],
    "visitations": [
        "visitation"
    ],
    "wolfes": [
        "wolfe"
    ],
    "admonished": [
        "admonish"
    ],
    "admonishing": [
        "admonish"
    ],
    "admonishes": [
        "admonish"
    ],
    "airbrakes": [
        "airbrake"
    ],
    "airbraked": [
        "airbrake"
    ],
    "argoss": [
        "argos"
    ],
    "aristotelians": [
        "aristotelian"
    ],
    "arkwrights": [
        "arkwright"
    ],
    "asas": [
        "asa"
    ],
    "astonished": [
        "astonish"
    ],
    "astonishes": [
        "astonish"
    ],
    "astonishing": [
        "astonish"
    ],
    "ballasted": [
        "ballast"
    ],
    "ballasting": [
        "ballast"
    ],
    "capers": [
        "caper"
    ],
    "capering": [
        "caper"
    ],
    "capered": [
        "caper"
    ],
    "centrists": [
        "centrist"
    ],
    "chewings": [
        "chewing"
    ],
    "choppering": [
        "chopper"
    ],
    "clipboards": [
        "clipboard"
    ],
    "commendations": [
        "commendation"
    ],
    "confessors": [
        "confessor"
    ],
    "cosmologies": [
        "cosmology"
    ],
    "curlings": [
        "curling"
    ],
    "dahls": [
        "dahl"
    ],
    "damons": [
        "damon"
    ],
    "denser": [
        "dens"
    ],
    "densest": [
        "dens"
    ],
    "dependables": [
        "dependable"
    ],
    "encampments": [
        "encampment"
    ],
    "fronds": [
        "frond"
    ],
    "fronded": [
        "frond"
    ],
    "gamekeepers": [
        "gamekeeper"
    ],
    "gebrecs": [
        "gebrec"
    ],
    "gillies": [
        "gilly"
    ],
    "gillying": [
        "gilly"
    ],
    "gillied": [
        "gilly"
    ],
    "jests": [
        "jest"
    ],
    "jesting": [
        "jest"
    ],
    "jested": [
        "jest"
    ],
    "leanings": [
        "leaning"
    ],
    "maddening": [
        "madden"
    ],
    "maddened": [
        "madden"
    ],
    "maddens": [
        "madden"
    ],
    "militates": [
        "militate"
    ],
    "militated": [
        "militate"
    ],
    "militating": [
        "militate"
    ],
    "moisturisers": [
        "moisturiser"
    ],
    "neuropathies": [
        "neuropathy"
    ],
    "nicosias": [
        "nicosia"
    ],
    "norses": [
        "norse"
    ],
    "penroses": [
        "penrose"
    ],
    "pickings": [
        "picking"
    ],
    "prats": [
        "prat"
    ],
    "pratting": [
        "prat"
    ],
    "pratted": [
        "prat"
    ],
    "quills": [
        "quill"
    ],
    "quilling": [
        "quill"
    ],
    "restoratives": [
        "restorative"
    ],
    "seneschals": [
        "seneschal"
    ],
    "shipwrecked": [
        "shipwreck"
    ],
    "shipwrecks": [
        "shipwreck"
    ],
    "sleeting": [
        "sleet"
    ],
    "sleeted": [
        "sleet"
    ],
    "sleets": [
        "sleet"
    ],
    "spaniels": [
        "spaniel"
    ],
    "stretchings": [
        "stretching"
    ],
    "swearings": [
        "swearing"
    ],
    "thames": [
        "thame"
    ],
    "truncheons": [
        "truncheon"
    ],
    "ufos": [
        "ufo"
    ],
    "vaguenesses": [
        "vagueness"
    ],
    "wankers": [
        "wanker"
    ],
    "weltering": [
        "welter"
    ],
    "weltered": [
        "welter"
    ],
    "whited": [
        "whit"
    ],
    "whits": [
        "whit"
    ],
    "wrangles": [
        "wrangle"
    ],
    "wrangling": [
        "wrangle"
    ],
    "wrangled": [
        "wrangle"
    ],
    "adenocarcinomas": [
        "adenocarcinoma"
    ],
    "amirs": [
        "amir"
    ],
    "balustrading": [
        "balustrade"
    ],
    "balustraded": [
        "balustrade"
    ],
    "beets": [
        "beet"
    ],
    "beeting": [
        "beet"
    ],
    "bonos": [
        "bono"
    ],
    "breadwinners": [
        "breadwinner"
    ],
    "chastities": [
        "chastity"
    ],
    "connectives": [
        "connective"
    ],
    "croppers": [
        "cropper"
    ],
    "detrituss": [
        "detritus"
    ],
    "ericas": [
        "erica"
    ],
    "escarpments": [
        "escarpment"
    ],
    "euphemisms": [
        "euphemism"
    ],
    "exmoors": [
        "exmoor"
    ],
    "glutamates": [
        "glutamate"
    ],
    "horticultures": [
        "horticulture"
    ],
    "infernos": [
        "inferno"
    ],
    "mammies": [
        "mammy"
    ],
    "mergings": [
        "merging"
    ],
    "namesakes": [
        "namesake"
    ],
    "nvs": [
        "nv"
    ],
    "odysseys": [
        "odyssey"
    ],
    "overgrown": [
        "overgrow"
    ],
    "overgrowing": [
        "overgrow"
    ],
    "overgrows": [
        "overgrow"
    ],
    "overgrew": [
        "overgrow"
    ],
    "piglets": [
        "piglet"
    ],
    "pomps": [
        "pomp"
    ],
    "propounded": [
        "propound"
    ],
    "propounding": [
        "propound"
    ],
    "propounds": [
        "propound"
    ],
    "quasars": [
        "quasar"
    ],
    "repatriated": [
        "repatriate"
    ],
    "repatriating": [
        "repatriate"
    ],
    "repatriates": [
        "repatriate"
    ],
    "rowdies": [
        "rowdy"
    ],
    "rowdier": [
        "rowdy"
    ],
    "rowdiest": [
        "rowdy"
    ],
    "snobberies": [
        "snobbery"
    ],
    "stavangers": [
        "stavanger"
    ],
    "torpedoing": [
        "torpedo"
    ],
    "torpedoes": [
        "torpedo"
    ],
    "torpedoed": [
        "torpedo"
    ],
    "tussles": [
        "tussle"
    ],
    "tussling": [
        "tussle"
    ],
    "tussled": [
        "tussle"
    ],
    "umbilicals": [
        "umbilical"
    ],
    "whittakers": [
        "whittaker"
    ],
    "writhed": [
        "writhe"
    ],
    "writhes": [
        "writhe"
    ],
    "writhing": [
        "writhe",
        "wrthe"
    ],
    "acronyms": [
        "acronym"
    ],
    "acronymed": [
        "acronym"
    ],
    "attenuated": [
        "attenuate"
    ],
    "attenuating": [
        "attenuate"
    ],
    "attenuates": [
        "attenuate"
    ],
    "bassists": [
        "bassist"
    ],
    "bennets": [
        "bennet"
    ],
    "bentons": [
        "benton"
    ],
    "brainchilds": [
        "brainchild"
    ],
    "burnhams": [
        "burnham"
    ],
    "cadmiums": [
        "cadmium"
    ],
    "caesareans": [
        "caesarean"
    ],
    "captors": [
        "captor"
    ],
    "catalonias": [
        "catalonia"
    ],
    "chubbier": [
        "chubby"
    ],
    "chubbiest": [
        "chubby"
    ],
    "cooped": [
        "coop"
    ],
    "coops": [
        "coop"
    ],
    "cooping": [
        "coop"
    ],
    "cornices": [
        "cornice"
    ],
    "cornicing": [
        "cornice"
    ],
    "corniced": [
        "cornice"
    ],
    "ctcs": [
        "ctc"
    ],
    "debarred": [
        "debar"
    ],
    "debarring": [
        "debar"
    ],
    "debars": [
        "debar"
    ],
    "disbursements": [
        "disbursement"
    ],
    "durances": [
        "durance"
    ],
    "enormities": [
        "enormity"
    ],
    "esas": [
        "esa"
    ],
    "eunuchs": [
        "eunuch"
    ],
    "fetuss": [
        "fetus"
    ],
    "fieldworkers": [
        "fieldworker"
    ],
    "grists": [
        "grist"
    ],
    "hydros": [
        "hydro"
    ],
    "irreducibles": [
        "irreducible"
    ],
    "kimberleys": [
        "kimberley"
    ],
    "lairs": [
        "lair"
    ],
    "lootings": [
        "looting"
    ],
    "maximisations": [
        "maximisation"
    ],
    "minogues": [
        "minogue"
    ],
    "monopolists": [
        "monopolist"
    ],
    "movables": [
        "movable"
    ],
    "oratories": [
        "oratory"
    ],
    "osiriss": [
        "osiris"
    ],
    "outgrown": [
        "outgrow"
    ],
    "outgrowing": [
        "outgrow"
    ],
    "outgrows": [
        "outgrow"
    ],
    "outgrew": [
        "outgrow"
    ],
    "phosphatases": [
        "phosphatase"
    ],
    "postcodes": [
        "postcode"
    ],
    "postcoded": [
        "postcode"
    ],
    "postcoding": [
        "postcode"
    ],
    "prickled": [
        "prickle"
    ],
    "prickling": [
        "prickle"
    ],
    "prickles": [
        "prickle"
    ],
    "princetons": [
        "princeton"
    ],
    "psychotherapies": [
        "psychotherapy"
    ],
    "rapidities": [
        "rapidity"
    ],
    "showpieces": [
        "showpiece"
    ],
    "testicles": [
        "testicle"
    ],
    "tufteds": [
        "tufted"
    ],
    "undertones": [
        "undertone"
    ],
    "warehousings": [
        "warehousing"
    ],
    "wis": [
        "wi"
    ],
    "abyssinias": [
        "abyssinia"
    ],
    "argyles": [
        "argyle"
    ],
    "ariess": [
        "aries"
    ],
    "astounding": [
        "astound"
    ],
    "astounded": [
        "astound"
    ],
    "astounds": [
        "astound"
    ],
    "avocados": [
        "avocado"
    ],
    "battlements": [
        "battlement"
    ],
    "battlemented": [
        "battlement"
    ],
    "biennials": [
        "biennial"
    ],
    "blackcurrants": [
        "blackcurrant"
    ],
    "bouncings": [
        "bouncing"
    ],
    "bursas": [
        "bursa"
    ],
    "cleopatras": [
        "cleopatra"
    ],
    "colics": [
        "colic"
    ],
    "crashings": [
        "crashing"
    ],
    "defectors": [
        "defector"
    ],
    "definings": [
        "defining"
    ],
    "disfigured": [
        "disfigure"
    ],
    "disfiguring": [
        "disfigure"
    ],
    "disfigures": [
        "disfigure"
    ],
    "finalized": [
        "finalize"
    ],
    "finalizing": [
        "finalize"
    ],
    "finalizes": [
        "finalize"
    ],
    "nullified": [
        "nullify"
    ],
    "nullifying": [
        "nullify"
    ],
    "nullifies": [
        "nullify"
    ],
    "oestrogens": [
        "oestrogen"
    ],
    "outreaches": [
        "outreach"
    ],
    "outreaching": [
        "outreach"
    ],
    "outreached": [
        "outreach"
    ],
    "pompeiis": [
        "pompeii"
    ],
    "portabilities": [
        "portability"
    ],
    "riveras": [
        "rivera"
    ],
    "sandss": [
        "sands"
    ],
    "schs": [
        "sch"
    ],
    "shipmen": [
        "shipman"
    ],
    "skyscrapers": [
        "skyscraper"
    ],
    "spielbergs": [
        "spielberg"
    ],
    "strippers": [
        "stripper"
    ],
    "stvs": [
        "stv"
    ],
    "transfections": [
        "transfection"
    ],
    "transputers": [
        "transputer"
    ],
    "unpredictabilities": [
        "unpredictability"
    ],
    "westerlies": [
        "westerly"
    ],
    "westerlys": [
        "westerly"
    ],
    "aachens": [
        "aachen"
    ],
    "antlers": [
        "antler"
    ],
    "antlered": [
        "antler"
    ],
    "attuned": [
        "attune"
    ],
    "attunes": [
        "attune"
    ],
    "attuning": [
        "attune"
    ],
    "avs": [
        "av"
    ],
    "azerbaijanis": [
        "azerbaijani"
    ],
    "bedsits": [
        "bedsit"
    ],
    "bedsitting": [
        "bedsit"
    ],
    "behaviourists": [
        "behaviourist"
    ],
    "benettons": [
        "benetton"
    ],
    "boarders": [
        "boarder"
    ],
    "circumscribed": [
        "circumscribe"
    ],
    "circumscribes": [
        "circumscribe"
    ],
    "circumscribing": [
        "circumscribe"
    ],
    "clearinghouses": [
        "clearinghouse"
    ],
    "cytoplasms": [
        "cytoplasm"
    ],
    "decimated": [
        "decimate"
    ],
    "decimating": [
        "decimate"
    ],
    "decimates": [
        "decimate"
    ],
    "defter": [
        "deft"
    ],
    "deftest": [
        "deft"
    ],
    "dipoles": [
        "dipole"
    ],
    "dumplings": [
        "dumpling"
    ],
    "epitaphs": [
        "epitaph"
    ],
    "gruffest": [
        "gruff"
    ],
    "gruffs": [
        "gruff"
    ],
    "gruffer": [
        "gruff"
    ],
    "hardliners": [
        "hardliner"
    ],
    "hayeks": [
        "hayek"
    ],
    "husks": [
        "husk"
    ],
    "husked": [
        "husk"
    ],
    "husking": [
        "husk"
    ],
    "hygienics": [
        "hygienic"
    ],
    "infestations": [
        "infestation"
    ],
    "lentils": [
        "lentil"
    ],
    "librettos": [
        "libretto"
    ],
    "libretti": [
        "libretto"
    ],
    "malfunctions": [
        "malfunction"
    ],
    "malfunctioning": [
        "malfunction"
    ],
    "malfunctioned": [
        "malfunction"
    ],
    "marconis": [
        "marconi"
    ],
    "mimicries": [
        "mimicry"
    ],
    "mistletoes": [
        "mistletoe"
    ],
    "nooks": [
        "nook"
    ],
    "overspending": [
        "overspend"
    ],
    "overspends": [
        "overspend"
    ],
    "overspent": [
        "overspend"
    ],
    "poodles": [
        "poodle"
    ],
    "poodled": [
        "poodle"
    ],
    "poodling": [
        "poodle"
    ],
    "possessors": [
        "possessor"
    ],
    "reassembled": [
        "reassemble"
    ],
    "reassembling": [
        "reassemble"
    ],
    "reassembles": [
        "reassemble"
    ],
    "repellents": [
        "repellent"
    ],
    "revisionists": [
        "revisionist"
    ],
    "scudding": [
        "scud"
    ],
    "scuds": [
        "scud"
    ],
    "scudded": [
        "scud"
    ],
    "sweetened": [
        "sweeten"
    ],
    "sweetening": [
        "sweeten"
    ],
    "sweetens": [
        "sweeten"
    ],
    "takeaways": [
        "takeaway"
    ],
    "transvestites": [
        "transvestite"
    ],
    "tuscans": [
        "tuscan"
    ],
    "unscrewed": [
        "unscrew"
    ],
    "unscrewing": [
        "unscrew"
    ],
    "unscrews": [
        "unscrew"
    ],
    "waggons": [
        "waggon"
    ],
    "waggoning": [
        "waggon"
    ],
    "waggoned": [
        "waggon"
    ],
    "wholenesses": [
        "wholeness"
    ],
    "aetiologies": [
        "aetiology"
    ],
    "aircrews": [
        "aircrew"
    ],
    "ammen": [
        "amman"
    ],
    "attributives": [
        "attributive"
    ],
    "banknotes": [
        "banknote"
    ],
    "bubbliest": [
        "bubbly"
    ],
    "bubblier": [
        "bubbly"
    ],
    "capricorns": [
        "capricorn"
    ],
    "chargers": [
        "charger"
    ],
    "cockier": [
        "cocky"
    ],
    "cockiest": [
        "cocky"
    ],
    "daeing": [
        "dae"
    ],
    "deluded": [
        "delude"
    ],
    "deluding": [
        "delude"
    ],
    "deludes": [
        "delude"
    ],
    "directnesses": [
        "directness"
    ],
    "dorcas": [
        "dorca"
    ],
    "enmities": [
        "enmity"
    ],
    "entwined": [
        "entwine"
    ],
    "entwining": [
        "entwine"
    ],
    "entwines": [
        "entwine"
    ],
    "fliers": [
        "flier"
    ],
    "fullbacks": [
        "fullback"
    ],
    "glasnosts": [
        "glasnost"
    ],
    "gravestones": [
        "gravestone"
    ],
    "grimed": [
        "grime"
    ],
    "griming": [
        "grime"
    ],
    "hilltops": [
        "hilltop"
    ],
    "holdalls": [
        "holdall"
    ],
    "inactions": [
        "inaction"
    ],
    "insignificances": [
        "insignificance"
    ],
    "jacobeans": [
        "jacobean"
    ],
    "mcphersons": [
        "mcpherson"
    ],
    "mitreing": [
        "mitre"
    ],
    "mobilisations": [
        "mobilisation"
    ],
    "ms.s": [
        "ms."
    ],
    "mustiest": [
        "musty"
    ],
    "mustier": [
        "musty"
    ],
    "navels": [
        "navel"
    ],
    "padres": [
        "padre"
    ],
    "penthouses": [
        "penthouse"
    ],
    "plenaries": [
        "plenary"
    ],
    "quietnesses": [
        "quietness"
    ],
    "romas": [
        "roma"
    ],
    "rosters": [
        "roster"
    ],
    "rostered": [
        "roster"
    ],
    "rostering": [
        "roster"
    ],
    "serfdoms": [
        "serfdom"
    ],
    "sesames": [
        "sesame"
    ],
    "setons": [
        "seton"
    ],
    "smocked": [
        "smock"
    ],
    "smocking": [
        "smock"
    ],
    "stomping": [
        "stomp"
    ],
    "stomped": [
        "stomp"
    ],
    "stomps": [
        "stomp"
    ],
    "storks": [
        "stork"
    ],
    "superannuations": [
        "superannuation"
    ],
    "thunderstorms": [
        "thunderstorm"
    ],
    "tomographies": [
        "tomography"
    ],
    "truffles": [
        "truffle"
    ],
    "uglinesses": [
        "ugliness"
    ],
    "waistbands": [
        "waistband"
    ],
    "windowsills": [
        "windowsill"
    ],
    "windsurfers": [
        "windsurfer"
    ],
    "wonderlands": [
        "wonderland"
    ],
    "adjudicated": [
        "adjudicate"
    ],
    "adjudicating": [
        "adjudicate"
    ],
    "adjudicates": [
        "adjudicate"
    ],
    "antiracists": [
        "antiracist"
    ],
    "babysitting": [
        "babysit"
    ],
    "babysits": [
        "babysit"
    ],
    "bannisters": [
        "bannister"
    ],
    "benevolences": [
        "benevolence"
    ],
    "canoeists": [
        "canoeist"
    ],
    "capsized": [
        "capsize"
    ],
    "capsizing": [
        "capsize"
    ],
    "capsizes": [
        "capsize"
    ],
    "captivated": [
        "captivate"
    ],
    "captivates": [
        "captivate"
    ],
    "captivating": [
        "captivate"
    ],
    "cartesians": [
        "cartesian"
    ],
    "castiles": [
        "castile"
    ],
    "cauliflowers": [
        "cauliflower"
    ],
    "danbys": [
        "danby"
    ],
    "doughnuts": [
        "doughnut"
    ],
    "doughnutting": [
        "doughnut"
    ],
    "enumerated": [
        "enumerate"
    ],
    "enumerating": [
        "enumerate"
    ],
    "enumerates": [
        "enumerate"
    ],
    "excreted": [
        "excrete"
    ],
    "excreting": [
        "excrete"
    ],
    "excretes": [
        "excrete"
    ],
    "finishers": [
        "finisher"
    ],
    "fondling": [
        "fondle"
    ],
    "fondled": [
        "fondle"
    ],
    "fondles": [
        "fondle"
    ],
    "forestalls": [
        "forestall"
    ],
    "forestalling": [
        "forestall"
    ],
    "forestalled": [
        "forestall"
    ],
    "franciscans": [
        "franciscan"
    ],
    "germinated": [
        "germinate"
    ],
    "germinating": [
        "germinate"
    ],
    "germinates": [
        "germinate"
    ],
    "getaways": [
        "getaway"
    ],
    "glades": [
        "glade"
    ],
    "goffs": [
        "goff"
    ],
    "guppies": [
        "guppy"
    ],
    "gutterings": [
        "guttering"
    ],
    "harares": [
        "harare"
    ],
    "ingested": [
        "ingest"
    ],
    "ingesting": [
        "ingest"
    ],
    "ingests": [
        "ingest"
    ],
    "jettisoned": [
        "jettison"
    ],
    "jettisoning": [
        "jettison"
    ],
    "jettisons": [
        "jettison"
    ],
    "lepers": [
        "leper"
    ],
    "liquidated": [
        "liquidate"
    ],
    "liquidating": [
        "liquidate"
    ],
    "liquidates": [
        "liquidate"
    ],
    "loires": [
        "loire"
    ],
    "mangled": [
        "mangle"
    ],
    "mangles": [
        "mangle"
    ],
    "mangling": [
        "mangle"
    ],
    "mesozoics": [
        "mesozoic"
    ],
    "methanols": [
        "methanol"
    ],
    "mountainsides": [
        "mountainside"
    ],
    "osakas": [
        "osaka"
    ],
    "pavlovs": [
        "pavlov"
    ],
    "pimps": [
        "pimp"
    ],
    "pimping": [
        "pimp"
    ],
    "progenies": [
        "progeny"
    ],
    "rousings": [
        "rousing"
    ],
    "scruples": [
        "scruple"
    ],
    "scrupled": [
        "scruple"
    ],
    "serenaded": [
        "serenade"
    ],
    "serenading": [
        "serenade"
    ],
    "sketchiest": [
        "sketchy"
    ],
    "sketchier": [
        "sketchy"
    ],
    "slimmers": [
        "slimmer"
    ],
    "soyas": [
        "soya"
    ],
    "swimsuits": [
        "swimsuit"
    ],
    "swirlings": [
        "swirling"
    ],
    "thoms": [
        "thom"
    ],
    "twined": [
        "twine"
    ],
    "twining": [
        "twine"
    ],
    "twines": [
        "twine"
    ],
    "ventilated": [
        "ventilate"
    ],
    "ventilating": [
        "ventilate"
    ],
    "ventilates": [
        "ventilate"
    ],
    "visualisations": [
        "visualisation"
    ],
    "waterlilies": [
        "waterlily"
    ],
    "zeuss": [
        "zeus"
    ],
    "affrays": [
        "affray"
    ],
    "affraid": [
        "affray"
    ],
    "ameliorated": [
        "ameliorate"
    ],
    "ameliorating": [
        "ameliorate"
    ],
    "ameliorates": [
        "ameliorate"
    ],
    "backwaters": [
        "backwater"
    ],
    "belfries": [
        "belfry"
    ],
    "bellowss": [
        "bellows"
    ],
    "caucasuss": [
        "caucasus"
    ],
    "causalities": [
        "causality"
    ],
    "clonings": [
        "cloning"
    ],
    "demonstratives": [
        "demonstrative"
    ],
    "derelictions": [
        "dereliction"
    ],
    "disembarked": [
        "disembark"
    ],
    "disembarking": [
        "disembark"
    ],
    "disembarks": [
        "disembark"
    ],
    "disowned": [
        "disown"
    ],
    "disowning": [
        "disown"
    ],
    "disowns": [
        "disown"
    ],
    "drynesses": [
        "dryness"
    ],
    "fertilizations": [
        "fertilization"
    ],
    "freestyles": [
        "freestyle"
    ],
    "heroisms": [
        "heroism"
    ],
    "hummingbirds": [
        "hummingbird"
    ],
    "hydroxides": [
        "hydroxide"
    ],
    "immunoglobulins": [
        "immunoglobulin"
    ],
    "infested": [
        "infest"
    ],
    "infesting": [
        "infest"
    ],
    "infests": [
        "infest"
    ],
    "lakelands": [
        "lakeland"
    ],
    "lutes": [
        "lute"
    ],
    "memorised": [
        "memorise"
    ],
    "memorising": [
        "memorise"
    ],
    "michelangeloes": [
        "michelangelo"
    ],
    "milliseconds": [
        "millisecond"
    ],
    "missouris": [
        "missouri"
    ],
    "narrated": [
        "narrate"
    ],
    "narrating": [
        "narrate"
    ],
    "narrates": [
        "narrate"
    ],
    "obs": [
        "ob"
    ],
    "obed": [
        "ob"
    ],
    "ointments": [
        "ointment"
    ],
    "outbuildings": [
        "outbuilding"
    ],
    "pentlands": [
        "pentland"
    ],
    "pollsters": [
        "pollster"
    ],
    "presets": [
        "preset"
    ],
    "presetting": [
        "preset"
    ],
    "prisms": [
        "prism"
    ],
    "pumpkins": [
        "pumpkin"
    ],
    "quirkiest": [
        "quirky"
    ],
    "quirkier": [
        "quirky"
    ],
    "rangoons": [
        "rangoon"
    ],
    "raptures": [
        "rapture"
    ],
    "raptured": [
        "rapture"
    ],
    "rearguards": [
        "rearguard"
    ],
    "reddened": [
        "redden"
    ],
    "reddening": [
        "redden"
    ],
    "reddens": [
        "redden"
    ],
    "repudiations": [
        "repudiation"
    ],
    "snippets": [
        "snippet"
    ],
    "suhartoes": [
        "suharto"
    ],
    "t'ing": [
        "t'"
    ],
    "tarnished": [
        "tarnish"
    ],
    "tarnishing": [
        "tarnish"
    ],
    "tarnishes": [
        "tarnish"
    ],
    "trowels": [
        "trowel"
    ],
    "trowelling": [
        "trowel"
    ],
    "trowelled": [
        "trowel"
    ],
    "underwrites": [
        "underwrite"
    ],
    "underwriting": [
        "underwrite"
    ],
    "underwrote": [
        "underwrite"
    ],
    "underwritten": [
        "underwrite"
    ],
    "vichies": [
        "vichy"
    ],
    "airspaces": [
        "airspace"
    ],
    "arbuthnots": [
        "arbuthnot"
    ],
    "assams": [
        "assam"
    ],
    "bottlenecks": [
        "bottleneck"
    ],
    "bottlenecking": [
        "bottleneck"
    ],
    "capitols": [
        "capitol"
    ],
    "carmichaels": [
        "carmichael"
    ],
    "cessnas": [
        "cessna"
    ],
    "coalesced": [
        "coalesce"
    ],
    "coalescing": [
        "coalesce"
    ],
    "coalesces": [
        "coalesce"
    ],
    "cogs": [
        "cog"
    ],
    "cornells": [
        "cornell"
    ],
    "cronies": [
        "crony"
    ],
    "dirks": [
        "dirk"
    ],
    "dysplasias": [
        "dysplasia"
    ],
    "edgier": [
        "edgy"
    ],
    "edgiest": [
        "edgy"
    ],
    "eggars": [
        "eggar"
    ],
    "exhaled": [
        "exhale"
    ],
    "exhaling": [
        "exhale"
    ],
    "exhales": [
        "exhale"
    ],
    "facelifts": [
        "facelift"
    ],
    "facelifted": [
        "facelift"
    ],
    "frgs": [
        "frg"
    ],
    "genotyped": [
        "genotype"
    ],
    "giorgios": [
        "giorgio"
    ],
    "immunisations": [
        "immunisation"
    ],
    "interposed": [
        "interpose"
    ],
    "interposing": [
        "interpose"
    ],
    "intoned": [
        "intone"
    ],
    "intones": [
        "intone"
    ],
    "intoning": [
        "intone"
    ],
    "jurists": [
        "jurist"
    ],
    "kaleidoscoped": [
        "kaleidoscope"
    ],
    "kilted": [
        "kilt"
    ],
    "lorenzs": [
        "lorenz"
    ],
    "macks": [
        "mack"
    ],
    "madrass": [
        "madras"
    ],
    "maltings": [
        "malting"
    ],
    "mesmerised": [
        "mesmerise"
    ],
    "mesmerising": [
        "mesmerise"
    ],
    "mulberries": [
        "mulberry"
    ],
    "mulberrys": [
        "mulberry"
    ],
    "nadirs": [
        "nadir"
    ],
    "numberings": [
        "numbering"
    ],
    "ouches": [
        "ouch"
    ],
    "outwitted": [
        "outwit"
    ],
    "outwitting": [
        "outwit"
    ],
    "outwits": [
        "outwit"
    ],
    "pails": [
        "pail"
    ],
    "paucities": [
        "paucity"
    ],
    "payoffs": [
        "payoff"
    ],
    "perplexed": [
        "perplex"
    ],
    "perplexing": [
        "perplex"
    ],
    "pillaged": [
        "pillage"
    ],
    "pillaging": [
        "pillage"
    ],
    "quads": [
        "quad"
    ],
    "repeatings": [
        "repeating"
    ],
    "ruthvens": [
        "ruthven"
    ],
    "shutdowns": [
        "shutdown"
    ],
    "skewers": [
        "skewer"
    ],
    "skewered": [
        "skewer"
    ],
    "skewering": [
        "skewer"
    ],
    "smelting": [
        "smelt"
    ],
    "smelted": [
        "smelt"
    ],
    "smelts": [
        "smelt"
    ],
    "sultriest": [
        "sultry"
    ],
    "sweeteners": [
        "sweetener"
    ],
    "tediums": [
        "tedium"
    ],
    "theists": [
        "theist"
    ],
    "tuners": [
        "tuner"
    ],
    "turntables": [
        "turntable"
    ],
    "waysides": [
        "wayside"
    ],
    "worktops": [
        "worktop"
    ],
    "assuaged": [
        "assuage"
    ],
    "assuaging": [
        "assuage"
    ],
    "assuages": [
        "assuage"
    ],
    "bagpipes": [
        "bagpipe"
    ],
    "blaring": [
        "blare"
    ],
    "blared": [
        "blare"
    ],
    "blares": [
        "blare"
    ],
    "blasters": [
        "blaster"
    ],
    "bodes": [
        "bode"
    ],
    "boded": [
        "bode"
    ],
    "boding": [
        "bode"
    ],
    "bondholders": [
        "bondholder"
    ],
    "bulimias": [
        "bulimia"
    ],
    "cacti": [
        "cactus"
    ],
    "cactuses": [
        "cactus"
    ],
    "calibrated": [
        "calibrate"
    ],
    "calibrating": [
        "calibrate"
    ],
    "calibrates": [
        "calibrate"
    ],
    "chalices": [
        "chalice"
    ],
    "chalkers": [
        "chalker"
    ],
    "concordances": [
        "concordance"
    ],
    "concordancing": [
        "concordance"
    ],
    "corianders": [
        "coriander"
    ],
    "crofters": [
        "crofter"
    ],
    "dandies": [
        "dandy"
    ],
    "dandying": [
        "dandy"
    ],
    "dandiest": [
        "dandy"
    ],
    "dandier": [
        "dandy"
    ],
    "darwinisms": [
        "darwinism"
    ],
    "deconstructions": [
        "deconstruction"
    ],
    "dehydrations": [
        "dehydration"
    ],
    "dumass": [
        "dumas"
    ],
    "eavesdropping": [
        "eavesdrop"
    ],
    "eavesdropped": [
        "eavesdrop"
    ],
    "eavesdrops": [
        "eavesdrop"
    ],
    "empiricisms": [
        "empiricism"
    ],
    "endeared": [
        "endear"
    ],
    "endears": [
        "endear"
    ],
    "endearing": [
        "endear"
    ],
    "fabs": [
        "fab"
    ],
    "hintons": [
        "hinton"
    ],
    "kindled": [
        "kindle"
    ],
    "kindling": [
        "kindle"
    ],
    "kindles": [
        "kindle"
    ],
    "kops": [
        "kop"
    ],
    "lintels": [
        "lintel"
    ],
    "martyrdoms": [
        "martyrdom"
    ],
    "memphiss": [
        "memphis"
    ],
    "odeons": [
        "odeon"
    ],
    "omegas": [
        "omega"
    ],
    "orators": [
        "orator"
    ],
    "painkillers": [
        "painkiller"
    ],
    "peppercorns": [
        "peppercorn"
    ],
    "perspexes": [
        "perspex"
    ],
    "philanthropists": [
        "philanthropist"
    ],
    "polariss": [
        "polaris"
    ],
    "pompeys": [
        "pompey"
    ],
    "postmodernists": [
        "postmodernist"
    ],
    "potholes": [
        "pothole"
    ],
    "potholing": [
        "pothole"
    ],
    "potholed": [
        "pothole"
    ],
    "puffins": [
        "puffin"
    ],
    "quavers": [
        "quaver"
    ],
    "quavered": [
        "quaver"
    ],
    "quavering": [
        "quaver"
    ],
    "quenched": [
        "quench"
    ],
    "quenching": [
        "quench"
    ],
    "quenches": [
        "quench"
    ],
    "rands": [
        "rand"
    ],
    "rappers": [
        "rapper"
    ],
    "repairers": [
        "repairer"
    ],
    "seething": [
        "sethe"
    ],
    "sinais": [
        "sinai"
    ],
    "spekes": [
        "speke"
    ],
    "sprinklings": [
        "sprinkling"
    ],
    "straggling": [
        "straggle"
    ],
    "straggled": [
        "straggle"
    ],
    "straggles": [
        "straggle"
    ],
    "streamers": [
        "streamer"
    ],
    "suctioning": [
        "suction"
    ],
    "suctions": [
        "suction"
    ],
    "suctioned": [
        "suction"
    ],
    "terser": [
        "terse"
    ],
    "tersest": [
        "terse"
    ],
    "throes": [
        "throe"
    ],
    "tightnesses": [
        "tightness"
    ],
    "trilogies": [
        "trilogy"
    ],
    "trivias": [
        "trivia"
    ],
    "wesleyans": [
        "wesleyan"
    ],
    "anachronisms": [
        "anachronism"
    ],
    "asiatics": [
        "asiatic"
    ],
    "bernhards": [
        "bernhard"
    ],
    "berserks": [
        "berserk"
    ],
    "biding": [
        "bide"
    ],
    "bided": [
        "bide"
    ],
    "bode": [
        "bide"
    ],
    "bravados": [
        "bravado"
    ],
    "calculuss": [
        "calculus"
    ],
    "cations": [
        "cation"
    ],
    "christologies": [
        "christology"
    ],
    "cistercians": [
        "cistercian"
    ],
    "clockworks": [
        "clockwork"
    ],
    "collectivisms": [
        "collectivism"
    ],
    "dodgers": [
        "dodger"
    ],
    "evs": [
        "ev"
    ],
    "fryers": [
        "fryer"
    ],
    "globulars": [
        "globular"
    ],
    "horowitzs": [
        "horowitz"
    ],
    "infills": [
        "infill"
    ],
    "investings": [
        "investing"
    ],
    "kayaks": [
        "kayak"
    ],
    "landscapings": [
        "landscaping"
    ],
    "magrittes": [
        "magritte"
    ],
    "morphemes": [
        "morpheme"
    ],
    "newsrooms": [
        "newsroom"
    ],
    "ochres": [
        "ochre"
    ],
    "oncomings": [
        "oncoming"
    ],
    "prelates": [
        "prelate"
    ],
    "prostrated": [
        "prostrate"
    ],
    "prostrating": [
        "prostrate"
    ],
    "prostrates": [
        "prostrate"
    ],
    "protectorates": [
        "protectorate"
    ],
    "rhubarbed": [
        "rhubarb"
    ],
    "santerres": [
        "santerre"
    ],
    "saturns": [
        "saturn"
    ],
    "seminaries": [
        "seminary"
    ],
    "shanties": [
        "shanty"
    ],
    "shards": [
        "shard"
    ],
    "skaters": [
        "skater"
    ],
    "slewed": [
        "slew"
    ],
    "slewing": [
        "slew"
    ],
    "slews": [
        "slew"
    ],
    "sortings": [
        "sorting"
    ],
    "stairwells": [
        "stairwell"
    ],
    "stantons": [
        "stanton"
    ],
    "stitchings": [
        "stitching"
    ],
    "sustenances": [
        "sustenance"
    ],
    "teethings": [
        "teething"
    ],
    "tms": [
        "tm"
    ],
    "transfected": [
        "transfect"
    ],
    "transfecting": [
        "transfect"
    ],
    "trilobites": [
        "trilobite"
    ],
    "unicorns": [
        "unicorn"
    ],
    "wrested": [
        "wrest"
    ],
    "wresting": [
        "wrest"
    ],
    "wrests": [
        "wrest"
    ],
    "acidifications": [
        "acidification"
    ],
    "acreages": [
        "acreage"
    ],
    "anointed": [
        "anoint"
    ],
    "anointing": [
        "anoint"
    ],
    "anoints": [
        "anoint"
    ],
    "asterisks": [
        "asterisk"
    ],
    "asterisked": [
        "asterisk"
    ],
    "asterisking": [
        "asterisk"
    ],
    "autopsied": [
        "autopsy"
    ],
    "awnings": [
        "awning"
    ],
    "bangers": [
        "banger"
    ],
    "barracking": [
        "barrack"
    ],
    "barracked": [
        "barrack"
    ],
    "barracks": [
        "barrack"
    ],
    "beaverbrooks": [
        "beaverbrook"
    ],
    "bemoaning": [
        "bemoan"
    ],
    "bemoaned": [
        "bemoan"
    ],
    "bemoans": [
        "bemoan"
    ],
    "benzenes": [
        "benzene"
    ],
    "bleeps": [
        "bleep"
    ],
    "bleeping": [
        "bleep"
    ],
    "bleeped": [
        "bleep"
    ],
    "broadenings": [
        "broadening"
    ],
    "cheerfulnesses": [
        "cheerfulness"
    ],
    "clinked": [
        "clink"
    ],
    "clinking": [
        "clink"
    ],
    "clinks": [
        "clink"
    ],
    "colluding": [
        "collude"
    ],
    "colluded": [
        "collude"
    ],
    "colludes": [
        "collude"
    ],
    "cormacks": [
        "cormack"
    ],
    "dampnesses": [
        "dampness"
    ],
    "daydreams": [
        "daydream"
    ],
    "daydreaming": [
        "daydream"
    ],
    "daydreamed": [
        "daydream"
    ],
    "dearths": [
        "dearth"
    ],
    "desisted": [
        "desist"
    ],
    "desists": [
        "desist"
    ],
    "desisting": [
        "desist"
    ],
    "disrespected": [
        "disrespect"
    ],
    "disrespects": [
        "disrespect"
    ],
    "disrespecting": [
        "disrespect"
    ],
    "doggies": [
        "doggy"
    ],
    "expediencies": [
        "expediency"
    ],
    "franchisees": [
        "franchisee"
    ],
    "grovess": [
        "groves"
    ],
    "hearses": [
        "hearse"
    ],
    "herods": [
        "herod"
    ],
    "integrins": [
        "integrin"
    ],
    "jakartas": [
        "jakarta"
    ],
    "kiddies": [
        "kiddy"
    ],
    "kurdistans": [
        "kurdistan"
    ],
    "lockings": [
        "locking"
    ],
    "mahlers": [
        "mahler"
    ],
    "manchurias": [
        "manchuria"
    ],
    "minstrels": [
        "minstrel"
    ],
    "moistened": [
        "moisten"
    ],
    "moistening": [
        "moisten"
    ],
    "moistens": [
        "moisten"
    ],
    "namings": [
        "naming"
    ],
    "necklines": [
        "neckline"
    ],
    "nicklauss": [
        "nicklaus"
    ],
    "nmrs": [
        "nmr"
    ],
    "oilfields": [
        "oilfield"
    ],
    "peelings": [
        "peeling"
    ],
    "pls": [
        "pl"
    ],
    "polities": [
        "polity"
    ],
    "reintroductions": [
        "reintroduction"
    ],
    "restorers": [
        "restorer"
    ],
    "roebucks": [
        "roebuck"
    ],
    "seabeds": [
        "seabed"
    ],
    "seabirds": [
        "seabird"
    ],
    "shorthorns": [
        "shorthorn"
    ],
    "shrinkages": [
        "shrinkage"
    ],
    "splattered": [
        "splatter"
    ],
    "splattering": [
        "splatter"
    ],
    "splatters": [
        "splatter"
    ],
    "sprayings": [
        "spraying"
    ],
    "terminators": [
        "terminator"
    ],
    "wirier": [
        "wiry"
    ],
    "wiriest": [
        "wiry"
    ],
    "zealots": [
        "zealot"
    ],
    "battlegrounds": [
        "battleground"
    ],
    "clammying": [
        "clammy"
    ],
    "clammier": [
        "clammy"
    ],
    "clammiest": [
        "clammy"
    ],
    "condolences": [
        "condolence"
    ],
    "coolers": [
        "cooler"
    ],
    "curlews": [
        "curlew"
    ],
    "epithets": [
        "epithet"
    ],
    "equestrians": [
        "equestrian"
    ],
    "executioners": [
        "executioner"
    ],
    "fiddlers": [
        "fiddler"
    ],
    "girders": [
        "girder"
    ],
    "heartbreaks": [
        "heartbreak"
    ],
    "insureds": [
        "insured"
    ],
    "insurgents": [
        "insurgent"
    ],
    "ises": [
        "isis"
    ],
    "jibes": [
        "jibe"
    ],
    "jibed": [
        "jibe"
    ],
    "jibing": [
        "jibe"
    ],
    "menials": [
        "menial"
    ],
    "meteors": [
        "meteor"
    ],
    "middleweights": [
        "middleweight"
    ],
    "nimbled": [
        "nimble"
    ],
    "nimbler": [
        "nimble"
    ],
    "nimblest": [
        "nimble"
    ],
    "normalisations": [
        "normalisation"
    ],
    "ordovicians": [
        "ordovician"
    ],
    "ouses": [
        "ouse"
    ],
    "outhouses": [
        "outhouse"
    ],
    "outhoused": [
        "outhouse"
    ],
    "paediatricians": [
        "paediatrician"
    ],
    "pretorias": [
        "pretoria"
    ],
    "purveyors": [
        "purveyor"
    ],
    "radiances": [
        "radiance"
    ],
    "reginas": [
        "regina"
    ],
    "reused": [
        "reuse"
    ],
    "reusing": [
        "reuse"
    ],
    "reuses": [
        "reuse"
    ],
    "salinities": [
        "salinity"
    ],
    "samoas": [
        "samoa"
    ],
    "sarawaks": [
        "sarawak"
    ],
    "servos": [
        "servo"
    ],
    "seychelless": [
        "seychelles"
    ],
    "sorceries": [
        "sorcery"
    ],
    "squigs": [
        "squig"
    ],
    "stonehenges": [
        "stonehenge"
    ],
    "storylines": [
        "storyline"
    ],
    "tattier": [
        "tatty"
    ],
    "tattiest": [
        "tatty"
    ],
    "teetering": [
        "teeter"
    ],
    "teetered": [
        "teeter"
    ],
    "teeters": [
        "teeter"
    ],
    "thoroughbreds": [
        "thoroughbred"
    ],
    "trawlers": [
        "trawler"
    ],
    "turnpikes": [
        "turnpike"
    ],
    "turnpiked": [
        "turnpike"
    ],
    "turnpiking": [
        "turnpike"
    ],
    "ulyssess": [
        "ulysses"
    ],
    "waybills": [
        "waybill"
    ],
    "womanhoods": [
        "womanhood"
    ],
    "zionists": [
        "zionist"
    ],
    "albanies": [
        "albany"
    ],
    "ankaras": [
        "ankara"
    ],
    "ardens": [
        "arden"
    ],
    "armss": [
        "arms"
    ],
    "brads": [
        "brad"
    ],
    "bulkheads": [
        "bulkhead"
    ],
    "capitalisations": [
        "capitalisation"
    ],
    "ceos": [
        "ceo"
    ],
    "codons": [
        "codon"
    ],
    "counterparties": [
        "counterparty"
    ],
    "cowslips": [
        "cowslip"
    ],
    "crystallised": [
        "crystallise"
    ],
    "crystallising": [
        "crystallise"
    ],
    "crystallises": [
        "crystallise"
    ],
    "dorics": [
        "doric"
    ],
    "drydens": [
        "dryden"
    ],
    "eloquences": [
        "eloquence"
    ],
    "esaus": [
        "esau"
    ],
    "federalists": [
        "federalist"
    ],
    "ffs": [
        "ff"
    ],
    "fiftieths": [
        "fiftieth"
    ],
    "fireflies": [
        "firefly"
    ],
    "flypasts": [
        "flypast"
    ],
    "footworks": [
        "footwork"
    ],
    "glummer": [
        "glum"
    ],
    "glummest": [
        "glum"
    ],
    "glums": [
        "glum"
    ],
    "gondolas": [
        "gondola"
    ],
    "hags": [
        "hag"
    ],
    "hairdryers": [
        "hairdryer"
    ],
    "heredities": [
        "heredity"
    ],
    "interned": [
        "intern"
    ],
    "interning": [
        "intern"
    ],
    "interns": [
        "intern"
    ],
    "layings": [
        "laying"
    ],
    "linkers": [
        "linker"
    ],
    "luminals": [
        "luminal"
    ],
    "palsies": [
        "palsy"
    ],
    "palsied": [
        "palsy"
    ],
    "quintets": [
        "quintet"
    ],
    "rubenss": [
        "rubens"
    ],
    "salomons": [
        "salomon"
    ],
    "smithies": [
        "smithy"
    ],
    "sojourns": [
        "sojourn"
    ],
    "sojourned": [
        "sojourn"
    ],
    "sojourning": [
        "sojourn"
    ],
    "solents": [
        "solent"
    ],
    "swains": [
        "swain"
    ],
    "urbanizations": [
        "urbanization"
    ],
    "valiums": [
        "valium"
    ],
    "westering": [
        "wester"
    ],
    "westered": [
        "wester"
    ],
    "wiggled": [
        "wiggle"
    ],
    "wiggling": [
        "wiggle"
    ],
    "wiggles": [
        "wiggle"
    ],
    "wisconsins": [
        "wisconsin"
    ],
    "workbooks": [
        "workbook"
    ],
    "yorkers": [
        "yorker"
    ],
    "aphasias": [
        "aphasia"
    ],
    "arcanest": [
        "arcane"
    ],
    "beadles": [
        "beadle"
    ],
    "beamishest": [
        "beamish"
    ],
    "beamishes": [
        "beamish"
    ],
    "bses": [
        "bse"
    ],
    "bullions": [
        "bullion"
    ],
    "christenings": [
        "christening"
    ],
    "comparabilities": [
        "comparability"
    ],
    "confidants": [
        "confidant"
    ],
    "conventionalisms": [
        "conventionalism"
    ],
    "crustaceans": [
        "crustacean"
    ],
    "epileptics": [
        "epileptic"
    ],
    "gybes": [
        "gybe"
    ],
    "gybing": [
        "gybe"
    ],
    "gybed": [
        "gybe"
    ],
    "historicisms": [
        "historicism"
    ],
    "inflatables": [
        "inflatable"
    ],
    "joysticks": [
        "joystick"
    ],
    "lovemakings": [
        "lovemaking"
    ],
    "octamers": [
        "octamer"
    ],
    "paraguays": [
        "paraguay"
    ],
    "pennants": [
        "pennant"
    ],
    "purgatories": [
        "purgatory"
    ],
    "ravelled": [
        "ravel"
    ],
    "ravelling": [
        "ravel"
    ],
    "ravels": [
        "ravel"
    ],
    "reappearances": [
        "reappearance"
    ],
    "recitatives": [
        "recitative"
    ],
    "remarriages": [
        "remarriage"
    ],
    "renditions": [
        "rendition"
    ],
    "scabs": [
        "scab"
    ],
    "scabbed": [
        "scab"
    ],
    "shopliftings": [
        "shoplifting"
    ],
    "sidled": [
        "sidle"
    ],
    "sidling": [
        "sidle"
    ],
    "sidles": [
        "sidle"
    ],
    "similes": [
        "simile"
    ],
    "skewed": [
        "skew"
    ],
    "skewing": [
        "skew"
    ],
    "skews": [
        "skew"
    ],
    "smallholdings": [
        "smallholding"
    ],
    "straightaways": [
        "straightaway"
    ],
    "swahilis": [
        "swahili"
    ],
    "swindled": [
        "swindle"
    ],
    "swindling": [
        "swindle"
    ],
    "swindles": [
        "swindle"
    ],
    "thoroughnesses": [
        "thoroughness"
    ],
    "toting": [
        "tote"
    ],
    "totes": [
        "tote"
    ],
    "toted": [
        "tote"
    ],
    "transacted": [
        "transact"
    ],
    "transacting": [
        "transact"
    ],
    "transacts": [
        "transact"
    ],
    "tuppences": [
        "tuppence"
    ],
    "vouched": [
        "vouch"
    ],
    "vouching": [
        "vouch"
    ],
    "vouches": [
        "vouch"
    ],
    "watercourses": [
        "watercourse"
    ],
    "zimbabweans": [
        "zimbabwean"
    ],
    "abhorred": [
        "abhor"
    ],
    "abhors": [
        "abhor"
    ],
    "abhorring": [
        "abhor"
    ],
    "anginas": [
        "angina"
    ],
    "angolans": [
        "angolan"
    ],
    "arrhythmias": [
        "arrhythmia"
    ],
    "brazened": [
        "brazen"
    ],
    "brazening": [
        "brazen"
    ],
    "brazens": [
        "brazen"
    ],
    "canvasses": [
        "canvass"
    ],
    "capels": [
        "capel"
    ],
    "chainsaws": [
        "chainsaw"
    ],
    "chainsawed": [
        "chainsaw"
    ],
    "craggier": [
        "craggy"
    ],
    "cranberries": [
        "cranberry"
    ],
    "dinos": [
        "dino"
    ],
    "dumas": [
        "duma"
    ],
    "egalitarianisms": [
        "egalitarianism"
    ],
    "enthralled": [
        "enthral"
    ],
    "enthralling": [
        "enthral"
    ],
    "enthrals": [
        "enthral"
    ],
    "faulkners": [
        "faulkner"
    ],
    "grails": [
        "grail"
    ],
    "hereafters": [
        "hereafter"
    ],
    "heriots": [
        "heriot"
    ],
    "humbuckers": [
        "humbucker"
    ],
    "insomnias": [
        "insomnia"
    ],
    "instigations": [
        "instigation"
    ],
    "interjected": [
        "interject"
    ],
    "interjects": [
        "interject"
    ],
    "interjecting": [
        "interject"
    ],
    "intransigences": [
        "intransigence"
    ],
    "ironsides": [
        "ironside"
    ],
    "kadiliks": [
        "kadilik"
    ],
    "leadening": [
        "leaden"
    ],
    "metaphysics": [
        "metaphysic"
    ],
    "moldavias": [
        "moldavia"
    ],
    "muldoons": [
        "muldoon"
    ],
    "nativities": [
        "nativity"
    ],
    "neroes": [
        "nero"
    ],
    "numeracies": [
        "numeracy"
    ],
    "prefects": [
        "prefect"
    ],
    "pseudonyms": [
        "pseudonym"
    ],
    "quibbling": [
        "quibble"
    ],
    "quibbles": [
        "quibble"
    ],
    "quibbled": [
        "quibble"
    ],
    "reformulations": [
        "reformulation"
    ],
    "reselling": [
        "resell"
    ],
    "resells": [
        "resell"
    ],
    "resold": [
        "resell"
    ],
    "saussures": [
        "saussure"
    ],
    "skylights": [
        "skylight"
    ],
    "standardizations": [
        "standardization"
    ],
    "standardized": [
        "standardize"
    ],
    "standardizing": [
        "standardize"
    ],
    "standardizes": [
        "standardize"
    ],
    "stanhopes": [
        "stanhope"
    ],
    "storehouses": [
        "storehouse"
    ],
    "superhumans": [
        "superhuman"
    ],
    "virgils": [
        "virgil"
    ],
    "wackiest": [
        "wacky"
    ],
    "wackier": [
        "wacky"
    ],
    "wafers": [
        "wafer"
    ],
    "woodwinds": [
        "woodwind"
    ],
    "zoologies": [
        "zoology"
    ],
    "activisms": [
        "activism"
    ],
    "airshows": [
        "airshow"
    ],
    "automating": [
        "automate"
    ],
    "automated": [
        "automate"
    ],
    "bandas": [
        "banda"
    ],
    "braziers": [
        "brazier"
    ],
    "cashmeres": [
        "cashmere"
    ],
    "catechisms": [
        "catechism"
    ],
    "categorisations": [
        "categorisation"
    ],
    "citrines": [
        "citrine"
    ],
    "cordials": [
        "cordial"
    ],
    "crinkled": [
        "crinkle"
    ],
    "crinkling": [
        "crinkle"
    ],
    "crinkles": [
        "crinkle"
    ],
    "decelerations": [
        "deceleration"
    ],
    "dictations": [
        "dictation"
    ],
    "eegs": [
        "eeg"
    ],
    "electrostatics": [
        "electrostatic"
    ],
    "ells": [
        "ell"
    ],
    "expressionists": [
        "expressionist"
    ],
    "fetters": [
        "fetter"
    ],
    "fettered": [
        "fetter"
    ],
    "fettering": [
        "fetter"
    ],
    "inculcated": [
        "inculcate"
    ],
    "inculcating": [
        "inculcate"
    ],
    "inculcates": [
        "inculcate"
    ],
    "infectives": [
        "infective"
    ],
    "insensitivities": [
        "insensitivity"
    ],
    "jamesons": [
        "jameson"
    ],
    "matchsticks": [
        "matchstick"
    ],
    "mauritanias": [
        "mauritania"
    ],
    "meted": [
        "mete"
    ],
    "metes": [
        "mete"
    ],
    "meting": [
        "mete"
    ],
    "misbehaviours": [
        "misbehaviour"
    ],
    "mnrs": [
        "mnr"
    ],
    "oedemata": [
        "oedema"
    ],
    "paddlers": [
        "paddler"
    ],
    "panaceas": [
        "panacea"
    ],
    "ploughmen": [
        "ploughman"
    ],
    "ploughmans": [
        "ploughman"
    ],
    "rippers": [
        "ripper"
    ],
    "sanskrits": [
        "sanskrit"
    ],
    "schooldays": [
        "schoolday"
    ],
    "splayed": [
        "splay"
    ],
    "splaying": [
        "splay"
    ],
    "splays": [
        "splay"
    ],
    "subtler": [
        "subtl"
    ],
    "subtlest": [
        "subtl"
    ],
    "subtractions": [
        "subtraction"
    ],
    "sunbathing": [
        "sunbthe"
    ],
    "tranquillizers": [
        "tranquillizer"
    ],
    "treadmills": [
        "treadmill"
    ],
    "vestments": [
        "vestment"
    ],
    "voxes": [
        "vox"
    ],
    "airships": [
        "airship"
    ],
    "asparaguss": [
        "asparagus"
    ],
    "audens": [
        "auden"
    ],
    "bestsellers": [
        "bestseller"
    ],
    "bhs": [
        "bh"
    ],
    "ceylons": [
        "ceylon"
    ],
    "contraptions": [
        "contraption"
    ],
    "deputed": [
        "depute"
    ],
    "deputing": [
        "depute"
    ],
    "faradays": [
        "faraday"
    ],
    "filipinos": [
        "filipino"
    ],
    "flirtations": [
        "flirtation"
    ],
    "fobbed": [
        "fob"
    ],
    "fobbing": [
        "fob"
    ],
    "fobs": [
        "fob"
    ],
    "gauzes": [
        "gauze"
    ],
    "gliadins": [
        "gliadin"
    ],
    "grisliest": [
        "grisly"
    ],
    "kampucheas": [
        "kampuchea"
    ],
    "ladened": [
        "laden"
    ],
    "lades": [
        "laden"
    ],
    "lading": [
        "laden"
    ],
    "laded": [
        "laden"
    ],
    "launderettes": [
        "launderette"
    ],
    "leeds": [
        "leed"
    ],
    "leftovers": [
        "leftover"
    ],
    "legalized": [
        "legalize"
    ],
    "legalizing": [
        "legalize"
    ],
    "legalizes": [
        "legalize"
    ],
    "mascots": [
        "mascot"
    ],
    "mauritiuss": [
        "mauritius"
    ],
    "nucleations": [
        "nucleation"
    ],
    "olsens": [
        "olsen"
    ],
    "overburdened": [
        "overburden"
    ],
    "overburdening": [
        "overburden"
    ],
    "overburdens": [
        "overburden"
    ],
    "pandering": [
        "pander"
    ],
    "pandered": [
        "pander"
    ],
    "panders": [
        "pander"
    ],
    "promptings": [
        "prompting"
    ],
    "railwaymen": [
        "railwayman"
    ],
    "redecorated": [
        "redecorate"
    ],
    "redecorating": [
        "redecorate"
    ],
    "redecorates": [
        "redecorate"
    ],
    "relativisms": [
        "relativism"
    ],
    "rhas": [
        "rha"
    ],
    "rundowns": [
        "rundown"
    ],
    "scavengers": [
        "scavenger"
    ],
    "seless": [
        "seles"
    ],
    "serpentining": [
        "serpentine"
    ],
    "socialized": [
        "socialize"
    ],
    "socializing": [
        "socialize"
    ],
    "socializes": [
        "socialize"
    ],
    "solidified": [
        "solidify"
    ],
    "solidifying": [
        "solidify"
    ],
    "sses": [
        "sse"
    ],
    "suffused": [
        "suffuse"
    ],
    "suffusing": [
        "suffuse"
    ],
    "suffuses": [
        "suffuse"
    ],
    "superlatives": [
        "superlative"
    ],
    "teeming": [
        "teem"
    ],
    "teemed": [
        "teem"
    ],
    "teems": [
        "teem"
    ],
    "thucydidess": [
        "thucydides"
    ],
    "toiletries": [
        "toiletry"
    ],
    "trollopes": [
        "trollope"
    ],
    "tubers": [
        "tuber"
    ],
    "unbuttoned": [
        "unbutton"
    ],
    "unbuttoning": [
        "unbutton"
    ],
    "unbuttons": [
        "unbutton"
    ],
    "visors": [
        "visor"
    ],
    "whiplashes": [
        "whiplash"
    ],
    "whiplashed": [
        "whiplash"
    ],
    "wrestlers": [
        "wrestler"
    ],
    "yacs": [
        "yac"
    ],
    "zambians": [
        "zambian"
    ],
    "ascites": [
        "ascite"
    ],
    "audacities": [
        "audacity"
    ],
    "cassidys": [
        "cassidy"
    ],
    "celibates": [
        "celibate"
    ],
    "chantries": [
        "chantry"
    ],
    "chestertons": [
        "chesterton"
    ],
    "comfier": [
        "comfy"
    ],
    "comfiest": [
        "comfy"
    ],
    "conceits": [
        "conceit"
    ],
    "confessionals": [
        "confessional"
    ],
    "customised": [
        "customise"
    ],
    "customising": [
        "customise"
    ],
    "customises": [
        "customise"
    ],
    "depreciated": [
        "depreciate"
    ],
    "depreciating": [
        "depreciate"
    ],
    "depreciates": [
        "depreciate"
    ],
    "disuses": [
        "disuse"
    ],
    "donging": [
        "dong"
    ],
    "donged": [
        "dong"
    ],
    "eccless": [
        "eccles"
    ],
    "environss": [
        "environs"
    ],
    "epitomized": [
        "epitomize"
    ],
    "epitomizes": [
        "epitomize"
    ],
    "epitomizing": [
        "epitomize"
    ],
    "exponentials": [
        "exponential"
    ],
    "familiarising": [
        "familiarise"
    ],
    "familiarised": [
        "familiarise"
    ],
    "franknesses": [
        "frankness"
    ],
    "glorified": [
        "glorify"
    ],
    "glorifying": [
        "glorify"
    ],
    "gustoes": [
        "gusto"
    ],
    "hiroshimas": [
        "hiroshima"
    ],
    "holists": [
        "holist"
    ],
    "huntsmen": [
        "huntsman"
    ],
    "incendiaries": [
        "incendiary"
    ],
    "jihads": [
        "jihad"
    ],
    "kindreds": [
        "kindred"
    ],
    "ladled": [
        "ladle"
    ],
    "ladles": [
        "ladle"
    ],
    "ladling": [
        "ladle"
    ],
    "malabsorptions": [
        "malabsorption"
    ],
    "marshlands": [
        "marshland"
    ],
    "mulches": [
        "mulch"
    ],
    "mulching": [
        "mulch"
    ],
    "mulched": [
        "mulch"
    ],
    "nonas": [
        "nona"
    ],
    "ornithologists": [
        "ornithologist"
    ],
    "passovers": [
        "passover"
    ],
    "peaveys": [
        "peavey"
    ],
    "perishables": [
        "perishable"
    ],
    "reactivities": [
        "reactivity"
    ],
    "rusing": [
        "ruse"
    ],
    "rwandas": [
        "rwanda"
    ],
    "sims": [
        "sim"
    ],
    "snowdrops": [
        "snowdrop"
    ],
    "sorcerers": [
        "sorcerer"
    ],
    "stowes": [
        "stowe"
    ],
    "stubbss": [
        "stubbs"
    ],
    "tarns": [
        "tarn"
    ],
    "throwers": [
        "thrower"
    ],
    "witherings": [
        "withering"
    ],
    "acumens": [
        "acumen"
    ],
    "allahs": [
        "allah"
    ],
    "alsaces": [
        "alsace"
    ],
    "ambulatories": [
        "ambulatory"
    ],
    "antiguas": [
        "antigua"
    ],
    "axminsters": [
        "axminster"
    ],
    "beaus": [
        "beau"
    ],
    "behests": [
        "behest"
    ],
    "bossiest": [
        "bossy"
    ],
    "bossier": [
        "bossy"
    ],
    "chromiums": [
        "chromium"
    ],
    "codified": [
        "codify"
    ],
    "codifying": [
        "codify"
    ],
    "codifies": [
        "codify"
    ],
    "compressors": [
        "compressor"
    ],
    "conceptualized": [
        "conceptualize"
    ],
    "conceptualizing": [
        "conceptualize"
    ],
    "conceptualizes": [
        "conceptualize"
    ],
    "delphis": [
        "delphi"
    ],
    "dexterities": [
        "dexterity"
    ],
    "draculas": [
        "dracula"
    ],
    "dusters": [
        "duster"
    ],
    "extortions": [
        "extortion"
    ],
    "flustered": [
        "fluster"
    ],
    "flustering": [
        "fluster"
    ],
    "flusters": [
        "fluster"
    ],
    "functionaries": [
        "functionary"
    ],
    "gooseberries": [
        "gooseberry"
    ],
    "harlems": [
        "harlem"
    ],
    "hertzs": [
        "hertz"
    ],
    "heuristics": [
        "heuristic"
    ],
    "impaled": [
        "impale"
    ],
    "impaling": [
        "impale"
    ],
    "impales": [
        "impale"
    ],
    "internationalisms": [
        "internationalism"
    ],
    "irrationalities": [
        "irrationality"
    ],
    "lollipops": [
        "lollipop"
    ],
    "longitudes": [
        "longitude"
    ],
    "luxors": [
        "luxor"
    ],
    "memorized": [
        "memorize"
    ],
    "memorizing": [
        "memorize"
    ],
    "memorizes": [
        "memorize"
    ],
    "moralists": [
        "moralist"
    ],
    "nearnesses": [
        "nearness"
    ],
    "nigers": [
        "niger"
    ],
    "normalized": [
        "normalize"
    ],
    "normalizing": [
        "normalize"
    ],
    "normalizes": [
        "normalize"
    ],
    "oligarchies": [
        "oligarchy"
    ],
    "philanthropies": [
        "philanthropy"
    ],
    "plantagenets": [
        "plantagenet"
    ],
    "plonked": [
        "plonk"
    ],
    "plonking": [
        "plonk"
    ],
    "plonks": [
        "plonk"
    ],
    "proms": [
        "prom"
    ],
    "ptas": [
        "pta"
    ],
    "pta's": [
        "pta"
    ],
    "putties": [
        "putty"
    ],
    "puttied": [
        "putty"
    ],
    "puttying": [
        "putty"
    ],
    "qatars": [
        "qatar"
    ],
    "replanted": [
        "replant"
    ],
    "replanting": [
        "replant"
    ],
    "retinals": [
        "retinal"
    ],
    "smolensks": [
        "smolensk"
    ],
    "swilled": [
        "swill"
    ],
    "swilling": [
        "swill"
    ],
    "swills": [
        "swill"
    ],
    "thermodynamicss": [
        "thermodynamics"
    ],
    "truants": [
        "truant"
    ],
    "truanting": [
        "truant"
    ],
    "truanted": [
        "truant"
    ],
    "tubings": [
        "tubing"
    ],
    "whingeing": [
        "whinge"
    ],
    "whinges": [
        "whinge"
    ],
    "whinged": [
        "whinge"
    ],
    "whinging": [
        "whinge"
    ],
    "yawnings": [
        "yawning"
    ],
    "ackroyds": [
        "ackroyd"
    ],
    "amnesias": [
        "amnesia"
    ],
    "barnacles": [
        "barnacle"
    ],
    "barnacled": [
        "barnacle"
    ],
    "bouncier": [
        "bouncy"
    ],
    "bounciest": [
        "bouncy"
    ],
    "bursaries": [
        "bursary"
    ],
    "butlins": [
        "butlin"
    ],
    "confectioneries": [
        "confectionery"
    ],
    "consecrations": [
        "consecration"
    ],
    "crassest": [
        "crass"
    ],
    "crasser": [
        "crass"
    ],
    "cricks": [
        "crick"
    ],
    "cricked": [
        "crick"
    ],
    "cricking": [
        "crick"
    ],
    "crossbows": [
        "crossbow"
    ],
    "cultivators": [
        "cultivator"
    ],
    "decidings": [
        "deciding"
    ],
    "defoes": [
        "defoe"
    ],
    "deuteriums": [
        "deuterium"
    ],
    "diuretics": [
        "diuretic"
    ],
    "dopplers": [
        "doppler"
    ],
    "emblazoned": [
        "emblazon"
    ],
    "emblazoning": [
        "emblazon"
    ],
    "emblazons": [
        "emblazon"
    ],
    "fibreglassing": [
        "fibreglass"
    ],
    "handlebars": [
        "handlebar"
    ],
    "hankies": [
        "hanky"
    ],
    "haughtiest": [
        "haughty"
    ],
    "haughtier": [
        "haughty"
    ],
    "haunches": [
        "haunch"
    ],
    "hermanns": [
        "hermann"
    ],
    "histograms": [
        "histogram"
    ],
    "hyperplasias": [
        "hyperplasia"
    ],
    "issuances": [
        "issuance"
    ],
    "kerseys": [
        "kersey"
    ],
    "knessets": [
        "knesset"
    ],
    "libidos": [
        "libido"
    ],
    "loitering": [
        "loiter"
    ],
    "loitered": [
        "loiter"
    ],
    "loiters": [
        "loiter"
    ],
    "lookalikes": [
        "lookalike"
    ],
    "lucifers": [
        "lucifer"
    ],
    "luvs": [
        "luv"
    ],
    "megabytes": [
        "megabyte"
    ],
    "newtonians": [
        "newtonian"
    ],
    "planktons": [
        "plankton"
    ],
    "propagandists": [
        "propagandist"
    ],
    "questioners": [
        "questioner"
    ],
    "randomised": [
        "randomise"
    ],
    "replicators": [
        "replicator"
    ],
    "retrainings": [
        "retraining"
    ],
    "rococoes": [
        "rococo"
    ],
    "ruthlessnesses": [
        "ruthlessness"
    ],
    "sadats": [
        "sadat"
    ],
    "sizzled": [
        "sizzle"
    ],
    "sizzling": [
        "sizzle"
    ],
    "sizzles": [
        "sizzle"
    ],
    "squalls": [
        "squall"
    ],
    "squalling": [
        "squall"
    ],
    "squalled": [
        "squall"
    ],
    "stoppings": [
        "stopping"
    ],
    "superscalars": [
        "superscalar"
    ],
    "synopses": [
        "synopsis"
    ],
    "teaks": [
        "teak"
    ],
    "terrorised": [
        "terrorise"
    ],
    "terrorising": [
        "terrorise"
    ],
    "transgressed": [
        "transgress"
    ],
    "transgressing": [
        "transgress"
    ],
    "transgresses": [
        "transgress"
    ],
    "trilled": [
        "trill"
    ],
    "trills": [
        "trill"
    ],
    "trilling": [
        "trill"
    ],
    "tuns": [
        "tun"
    ],
    "tungstens": [
        "tungsten"
    ],
    "understudies": [
        "understudy"
    ],
    "understudying": [
        "understudy"
    ],
    "understudied": [
        "understudy"
    ],
    "vanishings": [
        "vanishing"
    ],
    "yorkshiremen": [
        "yorkshireman"
    ],
    "adoes": [
        "ado"
    ],
    "airforces": [
        "airforce"
    ],
    "angsts": [
        "angst"
    ],
    "annihilations": [
        "annihilation"
    ],
    "banquetings": [
        "banqueting"
    ],
    "barros": [
        "barro"
    ],
    "blowers": [
        "blower"
    ],
    "bombshells": [
        "bombshell"
    ],
    "bopped": [
        "bop"
    ],
    "bopping": [
        "bop"
    ],
    "bops": [
        "bop"
    ],
    "breathers": [
        "breather"
    ],
    "broadsides": [
        "broadside"
    ],
    "bulwarks": [
        "bulwark"
    ],
    "byelaws": [
        "byelaw"
    ],
    "checkouts": [
        "checkout"
    ],
    "contorted": [
        "contort"
    ],
    "contorting": [
        "contort"
    ],
    "contorts": [
        "contort"
    ],
    "controllables": [
        "controllable"
    ],
    "corkscrews": [
        "corkscrew"
    ],
    "corkscrewing": [
        "corkscrew"
    ],
    "corkscrewed": [
        "corkscrew"
    ],
    "dewars": [
        "dewar"
    ],
    "disengaged": [
        "disengage"
    ],
    "disengaging": [
        "disengage"
    ],
    "disengages": [
        "disengage"
    ],
    "drams": [
        "dram"
    ],
    "eritreas": [
        "eritrea"
    ],
    "ex.s": [
        "ex."
    ],
    "fastings": [
        "fasting"
    ],
    "fishier": [
        "fishy"
    ],
    "fishiest": [
        "fishy"
    ],
    "fizzier": [
        "fizzy"
    ],
    "fizziest": [
        "fizzy"
    ],
    "garbed": [
        "garb"
    ],
    "garbs": [
        "garb"
    ],
    "garbing": [
        "garb"
    ],
    "glidings": [
        "gliding"
    ],
    "grenadas": [
        "grenada"
    ],
    "haldanes": [
        "haldane"
    ],
    "hardboards": [
        "hardboard"
    ],
    "illiteracies": [
        "illiteracy"
    ],
    "jensens": [
        "jensen"
    ],
    "jnrs": [
        "jnr"
    ],
    "kaplans": [
        "kaplan"
    ],
    "keatss": [
        "keats"
    ],
    "legates": [
        "legate"
    ],
    "legated": [
        "legate"
    ],
    "lutyenss": [
        "lutyens"
    ],
    "macaos": [
        "macao"
    ],
    "mitting": [
        "mit"
    ],
    "mits": [
        "mit"
    ],
    "muskets": [
        "musket"
    ],
    "niggles": [
        "niggle"
    ],
    "niggled": [
        "niggle"
    ],
    "niggling": [
        "niggle"
    ],
    "oys": [
        "oy"
    ],
    "oyer": [
        "oy"
    ],
    "paragons": [
        "paragon"
    ],
    "paternalisms": [
        "paternalism"
    ],
    "perfectionists": [
        "perfectionist"
    ],
    "quines": [
        "quine"
    ],
    "scalpelling": [
        "scalpel"
    ],
    "shavings": [
        "shaving"
    ],
    "stubbier": [
        "stubby"
    ],
    "stubbies": [
        "stubby"
    ],
    "stubbiest": [
        "stubby"
    ],
    "swabs": [
        "swab"
    ],
    "swabbed": [
        "swab"
    ],
    "swabbing": [
        "swab"
    ],
    "tls": [
        "tl"
    ],
    "unspeakables": [
        "unspeakable"
    ],
    "vitaes": [
        "vitae"
    ],
    "waggled": [
        "waggle"
    ],
    "waggling": [
        "waggle"
    ],
    "waggles": [
        "waggle"
    ],
    "watercresses": [
        "watercress"
    ],
    "ammoniums": [
        "ammonium"
    ],
    "athenas": [
        "athena"
    ],
    "attractors": [
        "attractor"
    ],
    "autocracies": [
        "autocracy"
    ],
    "backpacking": [
        "backpack"
    ],
    "backpacks": [
        "backpack"
    ],
    "bimbos": [
        "bimbo"
    ],
    "brunswicks": [
        "brunswick"
    ],
    "cartoonists": [
        "cartoonist"
    ],
    "copings": [
        "coping"
    ],
    "crimeas": [
        "crimea"
    ],
    "crucibles": [
        "crucible"
    ],
    "durans": [
        "duran"
    ],
    "durbans": [
        "durban"
    ],
    "giding": [
        "gide"
    ],
    "givers": [
        "giver"
    ],
    "gloating": [
        "gloat"
    ],
    "gloated": [
        "gloat"
    ],
    "gloats": [
        "gloat"
    ],
    "gunshots": [
        "gunshot"
    ],
    "hdtvs": [
        "hdtv"
    ],
    "hnds": [
        "hnd"
    ],
    "kinks": [
        "kink"
    ],
    "kinking": [
        "kink"
    ],
    "kinked": [
        "kink"
    ],
    "lexingtons": [
        "lexington"
    ],
    "microcosms": [
        "microcosm"
    ],
    "mouldiest": [
        "mouldy"
    ],
    "mouldier": [
        "mouldy"
    ],
    "mutated": [
        "mutate"
    ],
    "mutates": [
        "mutate"
    ],
    "mutating": [
        "mutate"
    ],
    "mystified": [
        "mystify"
    ],
    "mystifying": [
        "mystify"
    ],
    "nazareans": [
        "nazarean"
    ],
    "nellies": [
        "nelly"
    ],
    "outperformed": [
        "outperform"
    ],
    "outperforms": [
        "outperform"
    ],
    "outperforming": [
        "outperform"
    ],
    "peacekeepings": [
        "peacekeeping"
    ],
    "pepsins": [
        "pepsin"
    ],
    "pitchers": [
        "pitcher"
    ],
    "predates": [
        "predate"
    ],
    "predated": [
        "predate"
    ],
    "predating": [
        "predate"
    ],
    "preparednesses": [
        "preparedness"
    ],
    "puckered": [
        "pucker"
    ],
    "puckering": [
        "pucker"
    ],
    "puckers": [
        "pucker"
    ],
    "refereeings": [
        "refereeing"
    ],
    "scantiest": [
        "scanty"
    ],
    "scanties": [
        "scanty"
    ],
    "scantier": [
        "scanty"
    ],
    "stabbings": [
        "stabbing"
    ],
    "sultanas": [
        "sultana"
    ],
    "tarpaulins": [
        "tarpaulin"
    ],
    "toners": [
        "toner"
    ],
    "undercurrents": [
        "undercurrent"
    ],
    "unrealities": [
        "unreality"
    ],
    "watchings": [
        "watching"
    ],
    "weediest": [
        "weedy"
    ],
    "weedier": [
        "weedy"
    ],
    "weedies": [
        "weedy"
    ],
    "whitings": [
        "whiting"
    ],
    "whiting": [
        "whiting"
    ],
    "antrums": [
        "antrum"
    ],
    "ariadnes": [
        "ariadne"
    ],
    "assizes": [
        "assize"
    ],
    "atlantiss": [
        "atlantis"
    ],
    "babylonians": [
        "babylonian"
    ],
    "bainbridges": [
        "bainbridge"
    ],
    "boathouses": [
        "boathouse"
    ],
    "boffins": [
        "boffin"
    ],
    "calibans": [
        "caliban"
    ],
    "choreographies": [
        "choreography"
    ],
    "cimetidines": [
        "cimetidine"
    ],
    "clanging": [
        "clang"
    ],
    "clangs": [
        "clang"
    ],
    "clanged": [
        "clang"
    ],
    "darned": [
        "darn"
    ],
    "darning": [
        "darn"
    ],
    "darns": [
        "darn"
    ],
    "doormen": [
        "doorman"
    ],
    "embellishments": [
        "embellishment"
    ],
    "ensigns": [
        "ensign"
    ],
    "falsifications": [
        "falsification"
    ],
    "flashbacks": [
        "flashback"
    ],
    "fulmars": [
        "fulmar"
    ],
    "gilmours": [
        "gilmour"
    ],
    "grinders": [
        "grinder"
    ],
    "heathlands": [
        "heathland"
    ],
    "hegelians": [
        "hegelian"
    ],
    "infirmities": [
        "infirmity"
    ],
    "irreconcilables": [
        "irreconcilable"
    ],
    "kinseys": [
        "kinsey"
    ],
    "laibons": [
        "laibon"
    ],
    "lazinesses": [
        "laziness"
    ],
    "manganeses": [
        "manganese"
    ],
    "martians": [
        "martian"
    ],
    "mildewed": [
        "mildew"
    ],
    "mildews": [
        "mildew"
    ],
    "mildewing": [
        "mildew"
    ],
    "mitigations": [
        "mitigation"
    ],
    "muons": [
        "muon"
    ],
    "paretoes": [
        "pareto"
    ],
    "pentecosts": [
        "pentecost"
    ],
    "perusing": [
        "peruse"
    ],
    "perused": [
        "peruse"
    ],
    "peruses": [
        "peruse"
    ],
    "physios": [
        "physio"
    ],
    "priestesses": [
        "priestess"
    ],
    "primmest": [
        "prim"
    ],
    "primmer": [
        "prim"
    ],
    "recasting": [
        "recast"
    ],
    "recasts": [
        "recast"
    ],
    "robotics": [
        "robotic"
    ],
    "sanders": [
        "sander"
    ],
    "sealants": [
        "sealant"
    ],
    "sepoys": [
        "sepoy"
    ],
    "sheikhas": [
        "sheikha"
    ],
    "silaging": [
        "silage"
    ],
    "silages": [
        "silage"
    ],
    "soys": [
        "soy"
    ],
    "springtimes": [
        "springtime"
    ],
    "spuds": [
        "spud"
    ],
    "spudded": [
        "spud"
    ],
    "spudding": [
        "spud"
    ],
    "sympathisers": [
        "sympathiser"
    ],
    "tracers": [
        "tracer"
    ],
    "unitarians": [
        "unitarian"
    ],
    "venezuelans": [
        "venezuelan"
    ],
    "windwards": [
        "windward"
    ],
    "aborigines": [
        "aborigine"
    ],
    "ascetics": [
        "ascetic"
    ],
    "beaters": [
        "beater"
    ],
    "billetted": [
        "billet"
    ],
    "billeting": [
        "billet"
    ],
    "billeted": [
        "billet"
    ],
    "blips": [
        "blip"
    ],
    "blipped": [
        "blip"
    ],
    "capitations": [
        "capitation"
    ],
    "carcinogens": [
        "carcinogen"
    ],
    "cavendishes": [
        "cavendish"
    ],
    "chromatics": [
        "chromatic"
    ],
    "concealments": [
        "concealment"
    ],
    "conjugated": [
        "conjugate"
    ],
    "conjugates": [
        "conjugate"
    ],
    "conjugating": [
        "conjugate"
    ],
    "crewmen": [
        "crewman"
    ],
    "crunchies": [
        "crunchy"
    ],
    "crunchier": [
        "crunchy"
    ],
    "crunchiest": [
        "crunchy"
    ],
    "dreadnoughts": [
        "dreadnought"
    ],
    "gricing": [
        "grice"
    ],
    "handicrafts": [
        "handicraft"
    ],
    "hepburns": [
        "hepburn"
    ],
    "homeowners": [
        "homeowner"
    ],
    "icelandics": [
        "icelandic"
    ],
    "improprieties": [
        "impropriety"
    ],
    "incitements": [
        "incitement"
    ],
    "instrumentalists": [
        "instrumentalist"
    ],
    "kenyons": [
        "kenyon"
    ],
    "latexes": [
        "latex"
    ],
    "lendls": [
        "lendl"
    ],
    "marts": [
        "mart"
    ],
    "p.a.s": [
        "p.a."
    ],
    "partaking": [
        "partake"
    ],
    "partakes": [
        "partake"
    ],
    "partook": [
        "partake"
    ],
    "partaken": [
        "partake"
    ],
    "penalized": [
        "penalize"
    ],
    "penalizes": [
        "penalize"
    ],
    "penalizing": [
        "penalize"
    ],
    "prancing": [
        "prance"
    ],
    "pranced": [
        "prance"
    ],
    "prances": [
        "prance"
    ],
    "pranks": [
        "prank"
    ],
    "pranking": [
        "prank"
    ],
    "rebutted": [
        "rebut"
    ],
    "rebutting": [
        "rebut"
    ],
    "recompensed": [
        "recompense"
    ],
    "recompensing": [
        "recompense"
    ],
    "redeveloped": [
        "redevelop"
    ],
    "redevelops": [
        "redevelop"
    ],
    "redeveloping": [
        "redevelop"
    ],
    "redheads": [
        "redhead"
    ],
    "repulsed": [
        "repulse"
    ],
    "repulsing": [
        "repulse"
    ],
    "repulses": [
        "repulse"
    ],
    "rightnesses": [
        "rightness"
    ],
    "scrapings": [
        "scraping"
    ],
    "scubas": [
        "scuba"
    ],
    "spicers": [
        "spicer"
    ],
    "treacles": [
        "treacle"
    ],
    "westphalians": [
        "westphalian"
    ],
    "zulus": [
        "zulu"
    ],
    "acknowledgments": [
        "acknowledgment"
    ],
    "airplanes": [
        "airplane"
    ],
    "amylases": [
        "amylase"
    ],
    "archeries": [
        "archery"
    ],
    "atriumed": [
        "atrium"
    ],
    "batemen": [
        "bateman"
    ],
    "baulked": [
        "baulk"
    ],
    "baulks": [
        "baulk"
    ],
    "baulking": [
        "baulk"
    ],
    "belays": [
        "belay"
    ],
    "belaying": [
        "belay"
    ],
    "belayed": [
        "belay"
    ],
    "belaid": [
        "belay"
    ],
    "belies": [
        "belie"
    ],
    "birthrights": [
        "birthright"
    ],
    "busbys": [
        "busby"
    ],
    "busbies": [
        "busby"
    ],
    "changeovers": [
        "changeover"
    ],
    "childrens": [
        "children"
    ],
    "coachmen": [
        "coachman"
    ],
    "coachmen.": [
        "coachman"
    ],
    "corroborated": [
        "corroborate"
    ],
    "corroborating": [
        "corroborate"
    ],
    "corroborates": [
        "corroborate"
    ],
    "democratizations": [
        "democratization"
    ],
    "echoings": [
        "echoing"
    ],
    "fijians": [
        "fijian"
    ],
    "foamings": [
        "foaming"
    ],
    "foregone": [
        "forego"
    ],
    "foregoing": [
        "forego"
    ],
    "foregoes": [
        "forego"
    ],
    "forewent": [
        "forego"
    ],
    "formaldehydes": [
        "formaldehyde"
    ],
    "giraffes": [
        "giraffe"
    ],
    "glycoproteins": [
        "glycoprotein"
    ],
    "granaries": [
        "granary"
    ],
    "guatemalans": [
        "guatemalan"
    ],
    "harmonized": [
        "harmonize"
    ],
    "harmonizing": [
        "harmonize"
    ],
    "harmonizes": [
        "harmonize"
    ],
    "hemps": [
        "hemp"
    ],
    "hissings": [
        "hissing"
    ],
    "hunks": [
        "hunk"
    ],
    "infatuations": [
        "infatuation"
    ],
    "innovated": [
        "innovate"
    ],
    "innovating": [
        "innovate"
    ],
    "innovates": [
        "innovate"
    ],
    "kinkier": [
        "kinky"
    ],
    "kinkies": [
        "kinky"
    ],
    "kinkiest": [
        "kinky"
    ],
    "launderings": [
        "laundering"
    ],
    "leess": [
        "lees"
    ],
    "legitimized": [
        "legitimize"
    ],
    "legitimizing": [
        "legitimize"
    ],
    "legitimizes": [
        "legitimize"
    ],
    "maligned": [
        "malign"
    ],
    "maligning": [
        "malign"
    ],
    "maligns": [
        "malign"
    ],
    "manoeuvrings": [
        "manoeuvring"
    ],
    "margates": [
        "margate"
    ],
    "misreading": [
        "misread"
    ],
    "misreads": [
        "misread"
    ],
    "monarchists": [
        "monarchist"
    ],
    "officialdoms": [
        "officialdom"
    ],
    "overcasting": [
        "overcast"
    ],
    "pantos": [
        "panto"
    ],
    "parentages": [
        "parentage"
    ],
    "perambulations": [
        "perambulation"
    ],
    "pickers": [
        "picker"
    ],
    "pickering": [
        "picker"
    ],
    "platonics": [
        "platonic"
    ],
    "regaled": [
        "regale"
    ],
    "regaling": [
        "regale"
    ],
    "reminiscing": [
        "reminisce"
    ],
    "reminisced": [
        "reminisce"
    ],
    "reminisces": [
        "reminisce"
    ],
    "reopenings": [
        "reopening"
    ],
    "shakers": [
        "shaker"
    ],
    "sidestepped": [
        "sidestep"
    ],
    "sidestepping": [
        "sidestep"
    ],
    "sidesteps": [
        "sidestep"
    ],
    "signalmen": [
        "signalman"
    ],
    "sowings": [
        "sowing"
    ],
    "subjections": [
        "subjection"
    ],
    "subroutines": [
        "subroutine"
    ],
    "tinkled": [
        "tinkle"
    ],
    "tinkling": [
        "tinkle"
    ],
    "tinkles": [
        "tinkle"
    ],
    "topsoils": [
        "topsoil"
    ],
    "topsoiled": [
        "topsoil"
    ],
    "upliftings": [
        "uplifting"
    ],
    "verves": [
        "verve"
    ],
    "wenches": [
        "wench"
    ],
    "wenched": [
        "wench"
    ],
    "wenching": [
        "wench"
    ],
    "aeros": [
        "aero"
    ],
    "assemblers": [
        "assembler"
    ],
    "bandwidths": [
        "bandwidth"
    ],
    "bernest": [
        "berne"
    ],
    "booleans": [
        "boolean"
    ],
    "catamarans": [
        "catamaran"
    ],
    "cervixes": [
        "cervix"
    ],
    "cervices": [
        "cervix"
    ],
    "compactions": [
        "compaction"
    ],
    "decoys": [
        "decoy"
    ],
    "decoyed": [
        "decoy"
    ],
    "decoying": [
        "decoy"
    ],
    "doldrums": [
        "doldrum"
    ],
    "dras": [
        "dra"
    ],
    "electrified": [
        "electrify"
    ],
    "electrifying": [
        "electrify"
    ],
    "encrusted": [
        "encrust"
    ],
    "encrusting": [
        "encrust"
    ],
    "fatahs": [
        "fatah"
    ],
    "forresters": [
        "forrester"
    ],
    "freighters": [
        "freighter"
    ],
    "fultons": [
        "fulton"
    ],
    "giddier": [
        "giddy"
    ],
    "giddiest": [
        "giddy"
    ],
    "girths": [
        "girth"
    ],
    "girthed": [
        "girth"
    ],
    "greengrocers": [
        "greengrocer"
    ],
    "handguns": [
        "handgun"
    ],
    "havelocks": [
        "havelock"
    ],
    "intercoms": [
        "intercom"
    ],
    "jerichoes": [
        "jericho"
    ],
    "khartoums": [
        "khartoum"
    ],
    "kippered": [
        "kipper"
    ],
    "kippering": [
        "kipper"
    ],
    "loaths": [
        "loath"
    ],
    "localised": [
        "localise"
    ],
    "localising": [
        "localise"
    ],
    "lombardies": [
        "lombardy"
    ],
    "midwiferies": [
        "midwifery"
    ],
    "molested": [
        "molest"
    ],
    "molesting": [
        "molest"
    ],
    "molests": [
        "molest"
    ],
    "motts": [
        "mott"
    ],
    "nazareths": [
        "nazareth"
    ],
    "netballs": [
        "netball"
    ],
    "numerals": [
        "numeral"
    ],
    "overgrowths": [
        "overgrowth"
    ],
    "particularities": [
        "particularity"
    ],
    "pelmets": [
        "pelmet"
    ],
    "pipeworks": [
        "pipework"
    ],
    "polypropylenes": [
        "polypropylene"
    ],
    "repressors": [
        "repressor"
    ],
    "rheumatisms": [
        "rheumatism"
    ],
    "roomier": [
        "roomy"
    ],
    "roomiest": [
        "roomy"
    ],
    "rovings": [
        "roving"
    ],
    "sargents": [
        "sargent"
    ],
    "scams": [
        "scam"
    ],
    "scammed": [
        "scam"
    ],
    "schoolrooms": [
        "schoolroom"
    ],
    "screes": [
        "scree"
    ],
    "siegfrieds": [
        "siegfried"
    ],
    "snappier": [
        "snappy"
    ],
    "snappiest": [
        "snappy"
    ],
    "stationers": [
        "stationer"
    ],
    "swed": [
        "sw"
    ],
    "thrashings": [
        "thrashing"
    ],
    "timeshares": [
        "timeshare"
    ],
    "timesharing": [
        "timeshare"
    ],
    "tiranas": [
        "tirana"
    ],
    "transferences": [
        "transference"
    ],
    "unfoldings": [
        "unfolding"
    ],
    "vargass": [
        "vargas"
    ],
    "whetted": [
        "whet"
    ],
    "whetting": [
        "whet"
    ],
    "whets": [
        "whet"
    ],
    "wimps": [
        "wimp"
    ],
    "wimping": [
        "wimp"
    ],
    "zoologists": [
        "zoologist"
    ],
    "abigails": [
        "abigail"
    ],
    "adjudged": [
        "adjudge"
    ],
    "adjudging": [
        "adjudge"
    ],
    "adjudges": [
        "adjudge"
    ],
    "awkwardnesses": [
        "awkwardness"
    ],
    "belittled": [
        "belittle"
    ],
    "belittling": [
        "belittle"
    ],
    "belittles": [
        "belittle"
    ],
    "bunyans": [
        "bunyan"
    ],
    "buttonholes": [
        "buttonhole"
    ],
    "buttonholed": [
        "buttonhole"
    ],
    "buttonholing": [
        "buttonhole"
    ],
    "chafed": [
        "chafe"
    ],
    "chafing": [
        "chafe"
    ],
    "chafes": [
        "chafe"
    ],
    "charolaiss": [
        "charolais"
    ],
    "cohabiting": [
        "cohabit"
    ],
    "cohabited": [
        "cohabit"
    ],
    "cohabits": [
        "cohabit"
    ],
    "constricted": [
        "constrict"
    ],
    "constricting": [
        "constrict"
    ],
    "constricts": [
        "constrict"
    ],
    "crystallizations": [
        "crystallization"
    ],
    "cusps": [
        "cusp"
    ],
    "cusped": [
        "cusp"
    ],
    "cusping": [
        "cusp"
    ],
    "damsels": [
        "damsel"
    ],
    "decadences": [
        "decadence"
    ],
    "disinfections": [
        "disinfection"
    ],
    "downsizing": [
        "downsize"
    ],
    "downsized": [
        "downsize"
    ],
    "dramatists": [
        "dramatist"
    ],
    "dressmakers": [
        "dressmaker"
    ],
    "escs": [
        "esc"
    ],
    "gatekeepers": [
        "gatekeeper"
    ],
    "himmlers": [
        "himmler"
    ],
    "hoardings": [
        "hoarding"
    ],
    "howellss": [
        "howells"
    ],
    "hoyles": [
        "hoyle"
    ],
    "irritabilities": [
        "irritability"
    ],
    "manageresses": [
        "manageress"
    ],
    "mattings": [
        "matting"
    ],
    "midsoles": [
        "midsole"
    ],
    "narrownesses": [
        "narrowness"
    ],
    "nilssons": [
        "nilsson"
    ],
    "oatess": [
        "oates"
    ],
    "pallors": [
        "pallor"
    ],
    "pandoras": [
        "pandora"
    ],
    "powerhouses": [
        "powerhouse"
    ],
    "praxes": [
        "praxis"
    ],
    "redeployed": [
        "redeploy"
    ],
    "redeploying": [
        "redeploy"
    ],
    "redeploys": [
        "redeploy"
    ],
    "retrials": [
        "retrial"
    ],
    "rosaries": [
        "rosary"
    ],
    "rudds": [
        "rudd"
    ],
    "salomes": [
        "salome"
    ],
    "saplings": [
        "sapling"
    ],
    "starfishes": [
        "starfish"
    ],
    "starfished": [
        "starfish"
    ],
    "starfish": [
        "starfish"
    ],
    "udas": [
        "uda"
    ],
    "academias": [
        "academia"
    ],
    "agnostics": [
        "agnostic"
    ],
    "balaclavas": [
        "balaclava"
    ],
    "balms": [
        "balm"
    ],
    "balmed": [
        "balm"
    ],
    "bantams": [
        "bantam"
    ],
    "beys": [
        "bey"
    ],
    "billboards": [
        "billboard"
    ],
    "bricklayers": [
        "bricklayer"
    ],
    "bulgers": [
        "bulger"
    ],
    "caseworking": [
        "casework"
    ],
    "caucasians": [
        "caucasian"
    ],
    "cooing": [
        "coo"
    ],
    "coos": [
        "coo"
    ],
    "cooed": [
        "coo"
    ],
    "cosmids": [
        "cosmid"
    ],
    "crevecoeurs": [
        "crevecoeur"
    ],
    "degeneracies": [
        "degeneracy"
    ],
    "detractors": [
        "detractor"
    ],
    "dislocated": [
        "dislocate"
    ],
    "dislocating": [
        "dislocate"
    ],
    "dislocates": [
        "dislocate"
    ],
    "dudes": [
        "dude"
    ],
    "duded": [
        "dude"
    ],
    "enslaved": [
        "enslave"
    ],
    "enslaving": [
        "enslave"
    ],
    "enslaves": [
        "enslave"
    ],
    "epsilons": [
        "epsilon"
    ],
    "fairytales": [
        "fairytale"
    ],
    "fayres": [
        "fayre"
    ],
    "fetishes": [
        "fetish"
    ],
    "fidgeted": [
        "fidget"
    ],
    "fidgets": [
        "fidget"
    ],
    "fidgeting": [
        "fidget"
    ],
    "fireballs": [
        "fireball"
    ],
    "gabons": [
        "gabon"
    ],
    "greers": [
        "greer"
    ],
    "hatchbacks": [
        "hatchback"
    ],
    "ibs": [
        "ib"
    ],
    "jefferies": [
        "jeffery"
    ],
    "karpovs": [
        "karpov"
    ],
    "kellers": [
        "keller"
    ],
    "lagoss": [
        "lagos"
    ],
    "laptops": [
        "laptop"
    ],
    "lineouts": [
        "lineout"
    ],
    "mullers": [
        "muller"
    ],
    "normalised": [
        "normalise"
    ],
    "normalising": [
        "normalise"
    ],
    "pallisters": [
        "pallister"
    ],
    "paps": [
        "pap"
    ],
    "pedlars": [
        "pedlar"
    ],
    "permissivenesses": [
        "permissiveness"
    ],
    "picts": [
        "pict"
    ],
    "pontificating": [
        "pontificate"
    ],
    "pontificates": [
        "pontificate"
    ],
    "pontificated": [
        "pontificate"
    ],
    "premissed": [
        "premiss"
    ],
    "premissing": [
        "premiss"
    ],
    "presaged": [
        "presage"
    ],
    "presaging": [
        "presage"
    ],
    "promiscuities": [
        "promiscuity"
    ],
    "readjustments": [
        "readjustment"
    ],
    "rudenesses": [
        "rudeness"
    ],
    "ryas": [
        "rya"
    ],
    "sculpted": [
        "sculpt"
    ],
    "sculpting": [
        "sculpt"
    ],
    "sculpts": [
        "sculpt"
    ],
    "seditions": [
        "sedition"
    ],
    "sligos": [
        "sligo"
    ],
    "stabilisers": [
        "stabiliser"
    ],
    "steelworks": [
        "steelwork"
    ],
    "sugariest": [
        "sugary"
    ],
    "thrombolytics": [
        "thrombolytic"
    ],
    "tribesmen": [
        "tribesman"
    ],
    "vipers": [
        "viper"
    ],
    "admissibilities": [
        "admissibility"
    ],
    "aladdins": [
        "aladdin"
    ],
    "anaphors": [
        "anaphor"
    ],
    "astors": [
        "astor"
    ],
    "ayers": [
        "ayer"
    ],
    "babysitters": [
        "babysitter"
    ],
    "brokerages": [
        "brokerage"
    ],
    "caracass": [
        "caracas"
    ],
    "chaffing": [
        "chaff"
    ],
    "chaffed": [
        "chaff"
    ],
    "chaffs": [
        "chaff"
    ],
    "clevernesses": [
        "cleverness"
    ],
    "conkers": [
        "conker"
    ],
    "conkering": [
        "conker"
    ],
    "coppicing": [
        "coppice"
    ],
    "coppices": [
        "coppice"
    ],
    "deciders": [
        "decider"
    ],
    "diatoms": [
        "diatom"
    ],
    "dilled": [
        "dill"
    ],
    "dregss": [
        "dregs"
    ],
    "effendis": [
        "effendi"
    ],
    "ents": [
        "ent"
    ],
    "exalted": [
        "exalt"
    ],
    "exalting": [
        "exalt"
    ],
    "exalts": [
        "exalt"
    ],
    "favouritisms": [
        "favouritism"
    ],
    "forecasters": [
        "forecaster"
    ],
    "herodotuss": [
        "herodotus"
    ],
    "inspirals": [
        "inspiral"
    ],
    "institutionalized": [
        "institutionalize"
    ],
    "institutionalizing": [
        "institutionalize"
    ],
    "institutionalizes": [
        "institutionalize"
    ],
    "kidds": [
        "kidd"
    ],
    "kindergartens": [
        "kindergarten"
    ],
    "larcenies": [
        "larceny"
    ],
    "lausannes": [
        "lausanne"
    ],
    "lilles": [
        "lille"
    ],
    "middlemen": [
        "middleman"
    ],
    "millstones": [
        "millstone"
    ],
    "minimalists": [
        "minimalist"
    ],
    "naiveties": [
        "naivety"
    ],
    "naturalisms": [
        "naturalism"
    ],
    "nutters": [
        "nutter"
    ],
    "nuzzled": [
        "nuzzle"
    ],
    "nuzzling": [
        "nuzzle"
    ],
    "nuzzles": [
        "nuzzle"
    ],
    "oscillators": [
        "oscillator"
    ],
    "paines": [
        "paine"
    ],
    "perpetuities": [
        "perpetuity"
    ],
    "promontories": [
        "promontory"
    ],
    "quaternaries": [
        "quaternary"
    ],
    "removers": [
        "remover"
    ],
    "revellers": [
        "reveller"
    ],
    "salahs": [
        "salah"
    ],
    "samplers": [
        "sampler"
    ],
    "shostakoviches": [
        "shostakovich"
    ],
    "southerners": [
        "southerner"
    ],
    "teatimes": [
        "teatime"
    ],
    "tranquillisers": [
        "tranquilliser"
    ],
    "travestying": [
        "travesty"
    ],
    "travestied": [
        "travesty"
    ],
    "typographies": [
        "typography"
    ],
    "unfurled": [
        "unfurl"
    ],
    "unfurling": [
        "unfurl"
    ],
    "unfurls": [
        "unfurl"
    ],
    "vermins": [
        "vermin"
    ],
    "vexed": [
        "vex"
    ],
    "vexing": [
        "vex"
    ],
    "viceroys": [
        "viceroy"
    ],
    "vindications": [
        "vindication"
    ],
    "wranglings": [
        "wrangling"
    ],
    "wretches": [
        "wretch"
    ],
    "yeas": [
        "yea"
    ],
    "yearbooks": [
        "yearbook"
    ],
    "australasias": [
        "australasia"
    ],
    "bonifaces": [
        "boniface"
    ],
    "burroughss": [
        "burroughs"
    ],
    "castrated": [
        "castrate"
    ],
    "castrating": [
        "castrate"
    ],
    "castrates": [
        "castrate"
    ],
    "celluloids": [
        "celluloid"
    ],
    "chrysanthemums": [
        "chrysanthemum"
    ],
    "coexistences": [
        "coexistence"
    ],
    "conceptualizations": [
        "conceptualization"
    ],
    "concords": [
        "concord"
    ],
    "daunted": [
        "daunt"
    ],
    "daunts": [
        "daunt"
    ],
    "daunting": [
        "daunt"
    ],
    "dishonoured": [
        "dishonour"
    ],
    "dishonours": [
        "dishonour"
    ],
    "dishonouring": [
        "dishonour"
    ],
    "earphones": [
        "earphone"
    ],
    "fairbairns": [
        "fairbairn"
    ],
    "firesides": [
        "fireside"
    ],
    "galilees": [
        "galilee"
    ],
    "gamings": [
        "gaming"
    ],
    "giveaways": [
        "giveaway"
    ],
    "governorships": [
        "governorship"
    ],
    "hairpins": [
        "hairpin"
    ],
    "hilberts": [
        "hilbert"
    ],
    "hubbling": [
        "hubble"
    ],
    "incapacitated": [
        "incapacitate"
    ],
    "incapacitating": [
        "incapacitate"
    ],
    "incapacitates": [
        "incapacitate"
    ],
    "interlocked": [
        "interlock"
    ],
    "interlocking": [
        "interlock"
    ],
    "interlocks": [
        "interlock"
    ],
    "internalized": [
        "internalize"
    ],
    "internalizing": [
        "internalize"
    ],
    "internalizes": [
        "internalize"
    ],
    "iodines": [
        "iodine"
    ],
    "issed": [
        "iss"
    ],
    "kws": [
        "kw"
    ],
    "landers": [
        "lander"
    ],
    "lipoproteins": [
        "lipoprotein"
    ],
    "maimed": [
        "maim"
    ],
    "maiming": [
        "maim"
    ],
    "maims": [
        "maim"
    ],
    "manses": [
        "manse"
    ],
    "marlins": [
        "marlin"
    ],
    "mediocrities": [
        "mediocrity"
    ],
    "minnows": [
        "minnow"
    ],
    "nationalised": [
        "nationalise"
    ],
    "nationalising": [
        "nationalise"
    ],
    "nitrites": [
        "nitrite"
    ],
    "notepapers": [
        "notepaper"
    ],
    "parviss": [
        "parvis"
    ],
    "patrimonies": [
        "patrimony"
    ],
    "paymasters": [
        "paymaster"
    ],
    "polymorphisms": [
        "polymorphism"
    ],
    "regrouped": [
        "regroup"
    ],
    "regrouping": [
        "regroup"
    ],
    "regroups": [
        "regroup"
    ],
    "rns": [
        "rn"
    ],
    "scholastics": [
        "scholastic"
    ],
    "sclerites": [
        "sclerite"
    ],
    "sheepskins": [
        "sheepskin"
    ],
    "shiftier": [
        "shifty"
    ],
    "shiftiest": [
        "shifty"
    ],
    "sidewalks": [
        "sidewalk"
    ],
    "summations": [
        "summation"
    ],
    "tds": [
        "td"
    ],
    "thromboxanes": [
        "thromboxane"
    ],
    "transducers": [
        "transducer"
    ],
    "transsexuals": [
        "transsexual"
    ],
    "typescripts": [
        "typescript"
    ],
    "volgas": [
        "volga"
    ],
    "wiliest": [
        "wily"
    ],
    "wilier": [
        "wily"
    ],
    "winkles": [
        "winkle"
    ],
    "winkled": [
        "winkle"
    ],
    "winkling": [
        "winkle"
    ]
}